export const Facilities = [
  {
    "dcode": "D",
    "dropkey": "AV19743",
    "droptype": "D",
    "dropname": "SAN JUAN AMF",
    "dropdeladd": "35 AVE JOSE A TONY SANTANA",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009799998",
    "dropphyadd": "35 AVE JOSE A TONY SANTANA",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009799998",
    "dropmaladd": "35 AVE JOSE A TONY SANTANA",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009799998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876414824,
    "dropfax": 7876414855
  },
  {
    "dcode": "D",
    "dropkey": "AW22696",
    "droptype": "D",
    "dropname": "SAN ANTONIO AMF",
    "dropdeladd": "10250 JOHN SAUNDERS RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782463800,
    "dropphyadd": "10250 JOHN SAUNDERS RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782463800,
    "dropmaladd": "10250 JOHN SAUNDERS RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782463800,
    "dropsitphn": 2103688387,
    "dropsitlph": 2108283231,
    "dropsitcph": 2108289045,
    "dropfax": 2108284447
  },
  {
    "dcode": "D",
    "dropkey": "AY28029",
    "droptype": "D",
    "dropname": "NEW ORLEANS AMF",
    "dropdeladd": "100 AIRPORT SERVICE RD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701415000,
    "dropphyadd": "100 AIRPORT SERVICE RD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701415000,
    "dropmaladd": "5720 CITRUS BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701235855,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5044662320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "AY28039",
    "droptype": "D",
    "dropname": "TAMPA AMC",
    "dropdeladd": "3501 BESSIE COLEMAN BLVD FL 1",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336305006,
    "dropphyadd": "3501 BESSIE COLEMAN BLVD FL 1",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336305006,
    "dropmaladd": "PO BOX 39752",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336309752,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8002758777,
    "dropfax": 8138770675
  },
  {
    "dcode": "D",
    "dropkey": "AZ18876",
    "droptype": "D",
    "dropname": "SALT LAKE CITY AMC",
    "dropdeladd": "320 N 3700 W",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841222201,
    "dropphyadd": "320 N 3700 W",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841222201,
    "dropmaladd": "PO BOX 22062",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841220062,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015317659,
    "dropsitcph": 8013590089,
    "dropfax": 8013553542
  },
  {
    "dcode": "D",
    "dropkey": "AZ18886",
    "droptype": "D",
    "dropname": "BILLINGS AIR TRANSFER OFFICE",
    "dropdeladd": "1761 AVIATION PL",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591051987,
    "dropphyadd": "1761 AVIATION PL",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591051987,
    "dropmaladd": "841 S 26TH ST",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591019998,
    "dropsitphn": 4066576713,
    "dropsitlph": 4062457156,
    "dropsitcph": 4062457156,
    "dropfax": 4062556436
  },
  {
    "dcode": "D",
    "dropkey": "AZ24715",
    "droptype": "D",
    "dropname": "SACRAMENTO AMF",
    "dropdeladd": "5853 CITATION WAY",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958371192,
    "dropphyadd": "5853 CITATION WAY",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958371192,
    "dropmaladd": "5853 CITATION WAY",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958371192,
    "dropsitphn": "",
    "dropsitlph": 9169272149,
    "dropsitcph": 9162637199,
    "dropfax": 9169256795
  },
  {
    "dcode": "D",
    "dropkey": "A001163",
    "droptype": "D",
    "dropname": "ORLANDO AMF",
    "dropdeladd": "10401 POST OFFICE BLVD W",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328628401,
    "dropphyadd": "10401 POST OFFICE BLVD W",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328628401,
    "dropmaladd": "PO BOX 620044",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328620044,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4078265625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A001376",
    "droptype": "D",
    "dropname": "JFK ISC",
    "dropdeladd": "250 N BOUNDARY RD STE 1",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114309508,
    "dropphyadd": "250 N BOUNDARY RD STE 1",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114309508,
    "dropmaladd": "250 N BOUNDARY RD STE 1",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114309508,
    "dropsitphn": 7185537200,
    "dropsitlph": 7185537200,
    "dropsitcph": 7185539144,
    "dropfax": 7185539324
  },
  {
    "dcode": "D",
    "dropkey": "A004406",
    "droptype": "D",
    "dropname": "HONOLULU AMF",
    "dropdeladd": "3600 AOLELE ST",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968203668,
    "dropphyadd": "3600 AOLELE ST",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968203668,
    "dropmaladd": "3600 AOLELE ST RM 208C",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968209998,
    "dropsitphn": 8084233893,
    "dropsitlph": "",
    "dropsitcph": 8084233409,
    "dropfax": 8084233839
  },
  {
    "dcode": "D",
    "dropkey": "A006246",
    "droptype": "D",
    "dropname": "ST THOMAS AMF",
    "dropdeladd": "8002 LINDBERG BAY STE 2",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029997",
    "dropphyadd": "8002 LINDBERG BAY STE 2",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029997",
    "dropmaladd": "8002 LINDBERG BAY STE 2",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 3407749093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A006248",
    "droptype": "D",
    "dropname": "KINGSHILL AMF",
    "dropdeladd": "1000 AIRPORT RD",
    "dropdelcty": "KINGSHILL",
    "dropdelst": "VI",
    "dropdelzpp": "008509997",
    "dropphyadd": "1000 AIRPORT RD",
    "dropphycty": "KINGSHILL",
    "dropphyst": "VI",
    "dropphyzpp": "008509997",
    "dropmaladd": "1000 AIRPORT RD",
    "dropmalcty": "KINGSHILL",
    "dropmalst": "VI",
    "dropmalzpp": "008509997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407782681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A020715",
    "droptype": "D",
    "dropname": "KAHULUI AIRPORT ANNEX",
    "dropdeladd": "105 AALELE ST",
    "dropdelcty": "KAHULUI",
    "dropdelst": "HI",
    "dropdelzpp": 967329996,
    "dropphyadd": "105 AALELE ST",
    "dropphycty": "KAHULUI",
    "dropphyst": "HI",
    "dropphyzpp": 967329996,
    "dropmaladd": "105 AALELE ST",
    "dropmalcty": "KAHULUI",
    "dropmalst": "HI",
    "dropmalzpp": 967329996,
    "dropsitphn": 8084233844,
    "dropsitlph": "",
    "dropsitcph": 8088712487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A020835",
    "droptype": "D",
    "dropname": "BUFFALO AMF",
    "dropdeladd": "285 CAYUGA RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142419900,
    "dropphyadd": "285 CAYUGA RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142419900,
    "dropmaladd": "285 CAYUGA RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142419900,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462411,
    "dropsitcph": 7166313531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A020915",
    "droptype": "D",
    "dropname": "DENVER AMF",
    "dropdeladd": "25630 E 75TH AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802496366,
    "dropphyadd": "25630 E 75TH AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802496366,
    "dropmaladd": "25630 E 75TH AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802496366,
    "dropsitphn": 7195705409,
    "dropsitlph": "",
    "dropsitcph": 3033171103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "A020920",
    "droptype": "D",
    "dropname": "CINCINNATI AMF",
    "dropdeladd": "76 CLAY DR",
    "dropdelcty": "HEBRON",
    "dropdelst": "KY",
    "dropdelzpp": 410489900,
    "dropphyadd": "76 CLAY DR",
    "dropphycty": "HEBRON",
    "dropphyst": "KY",
    "dropphyzpp": 410489900,
    "dropmaladd": "76 CLAY DR",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452759900,
    "dropsitphn": 5136845763,
    "dropsitlph": 8593714813,
    "dropsitcph": 8593744813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10003",
    "droptype": "D",
    "dropname": "FPO",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979997",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979997",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979997",
    "dropsitphn": 7033258601,
    "dropsitlph": "",
    "dropsitcph": 7185537138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10058",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "130 BLACK HORSE PIKE STE 400",
    "dropdelcty": "AUDUBON",
    "dropdelst": "NJ",
    "dropdelzpp": "081069998",
    "dropphyadd": "130 BLACK HORSE PIKE STE 400",
    "dropphycty": "AUDUBON",
    "dropphyst": "NJ",
    "dropphyzpp": "081069998",
    "dropmaladd": "130 BLACK HORSE PIKE STE 400",
    "dropmalcty": "AUDUBON",
    "dropmalst": "NJ",
    "dropmalzpp": "081069998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569639026,
    "dropsitcph": 8569636597,
    "dropfax": 8565473020
  },
  {
    "dcode": "D",
    "dropkey": "BV10081",
    "droptype": "D",
    "dropname": "BAY HEAD",
    "dropdeladd": "82 BRIDGE AVE STE 1",
    "dropdelcty": "BAY HEAD",
    "dropdelst": "NJ",
    "dropdelzpp": "087429997",
    "dropphyadd": "82 BRIDGE AVE STE 1",
    "dropphycty": "BAY HEAD",
    "dropphyst": "NJ",
    "dropphyzpp": "087429997",
    "dropmaladd": "82 BRIDGE AVE STE 1",
    "dropmalcty": "BAY HEAD",
    "dropmalst": "NJ",
    "dropmalzpp": "087429997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328921551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10102",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "413 WASHINGTON AVE",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "071099998",
    "dropphyadd": "413 WASHINGTON AVE",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "071099998",
    "dropmaladd": "413 WASHINGTON AVE",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "071099998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737597652,
    "dropsitcph": 9737597652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10140",
    "droptype": "D",
    "dropname": "BOGOTA",
    "dropdeladd": "71 W MAIN ST",
    "dropdelcty": "BOGOTA",
    "dropdelst": "NJ",
    "dropdelzpp": "076039998",
    "dropphyadd": "71 W MAIN ST",
    "dropphycty": "BOGOTA",
    "dropphyst": "NJ",
    "dropphyzpp": "076039998",
    "dropmaladd": "71 W MAIN ST",
    "dropmalcty": "BOGOTA",
    "dropmalst": "NJ",
    "dropmalzpp": "076039998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013754408,
    "dropsitcph": 2013420169,
    "dropfax": 6503576571
  },
  {
    "dcode": "D",
    "dropkey": "BV10215",
    "droptype": "D",
    "dropname": "CARLSTADT",
    "dropdeladd": "331 1ST ST",
    "dropdelcty": "CARLSTADT",
    "dropdelst": "NJ",
    "dropdelzpp": "070729998",
    "dropphyadd": "331 1ST ST",
    "dropphycty": "CARLSTADT",
    "dropphyst": "NJ",
    "dropphyzpp": "070729998",
    "dropmaladd": "331 1ST ST",
    "dropmalcty": "CARLSTADT",
    "dropmalst": "NJ",
    "dropmalzpp": "070729998",
    "dropsitphn": 2015081517,
    "dropsitlph": 2019394793,
    "dropsitcph": 2019394793,
    "dropfax": 6505774253
  },
  {
    "dcode": "D",
    "dropkey": "BV10255",
    "droptype": "D",
    "dropname": "CINNAMINSON",
    "dropdeladd": "2496 ROUTE 130 N",
    "dropdelcty": "CINNAMINSON",
    "dropdelst": "NJ",
    "dropdelzpp": "080779996",
    "dropphyadd": "2496 ROUTE 130 N",
    "dropphycty": "CINNAMINSON",
    "dropphyst": "NJ",
    "dropphyzpp": "080779996",
    "dropmaladd": "2496 ROUTE 130 N",
    "dropmalcty": "CINNAMINSON",
    "dropmalst": "NJ",
    "dropmalzpp": "080779996",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568298383,
    "dropsitcph": 8568298383,
    "dropfax": 8568294720
  },
  {
    "dcode": "D",
    "dropkey": "BV10256",
    "droptype": "D",
    "dropname": "CIRCLE",
    "dropdeladd": "2601 BRUNSWICK AVE",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086389998",
    "dropphyadd": "2601 BRUNSWICK AVE",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086389998",
    "dropmaladd": "2601 BRUNSWICK AVE",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086389998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6097710110,
    "dropfax": 6098836437
  },
  {
    "dcode": "D",
    "dropkey": "BV10257",
    "droptype": "D",
    "dropname": "CLARK",
    "dropdeladd": "1087 RARITAN RD",
    "dropdelcty": "CLARK",
    "dropdelst": "NJ",
    "dropdelzpp": "070669998",
    "dropphyadd": "1087 RARITAN RD",
    "dropphycty": "CLARK",
    "dropphyst": "NJ",
    "dropphyzpp": "070669998",
    "dropmaladd": "1087 RARITAN RD",
    "dropmalcty": "CLARK",
    "dropmalst": "NJ",
    "dropmalzpp": "070669998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7323810261,
    "dropsitcph": 7323810261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10287",
    "droptype": "D",
    "dropname": "COLLINGSWOOD",
    "dropdeladd": "970 HADDON AVE",
    "dropdelcty": "COLLINGSWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "081089998",
    "dropphyadd": "970 HADDON AVE",
    "dropphycty": "COLLINGSWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "081089998",
    "dropmaladd": "970 HADDON AVE",
    "dropmalcty": "COLLINGSWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "081089998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569639046,
    "dropsitcph": 8569636597,
    "dropfax": 8568699276
  },
  {
    "dcode": "D",
    "dropkey": "BV10289",
    "droptype": "D",
    "dropname": "COLONIA",
    "dropdeladd": "574 INMAN AVE",
    "dropdelcty": "COLONIA",
    "dropdelst": "NJ",
    "dropdelzpp": "070679998",
    "dropphyadd": "574 INMAN AVE",
    "dropphycty": "COLONIA",
    "dropphyst": "NJ",
    "dropphyzpp": "070679998",
    "dropmaladd": "574 INMAN AVE",
    "dropmalcty": "COLONIA",
    "dropmalst": "NJ",
    "dropmalzpp": "070679998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7323883760,
    "dropsitcph": 7323883760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10294",
    "droptype": "D",
    "dropname": "CONVENT STATION",
    "dropdeladd": "11 CONVENT RD",
    "dropdelcty": "CONVENT STATION",
    "dropdelst": "NJ",
    "dropdelzpp": "079619800",
    "dropphyadd": "11 CONVENT RD",
    "dropphycty": "CONVENT STATION",
    "dropphyst": "NJ",
    "dropphyzpp": "079619800",
    "dropmaladd": "PO BOX ZZ",
    "dropmalcty": "CONVENT STATION",
    "dropmalst": "NJ",
    "dropmalzpp": "079619998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735380115,
    "dropsitcph": 9735380115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10323",
    "droptype": "D",
    "dropname": "DELANCO",
    "dropdeladd": "801 BURLINGTON AVE STE H",
    "dropdelcty": "DELANCO",
    "dropdelst": "NJ",
    "dropdelzpp": "080759995",
    "dropphyadd": "801 BURLINGTON AVE STE H",
    "dropphycty": "DELANCO",
    "dropphyst": "NJ",
    "dropphyzpp": "080759995",
    "dropmaladd": "801 BURLINGTON AVE STE H",
    "dropmalcty": "DELANCO",
    "dropmalst": "NJ",
    "dropmalzpp": "080759995",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564611752,
    "dropsitcph": 8564611752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10329",
    "droptype": "D",
    "dropname": "DELRAN",
    "dropdeladd": "4000 ROUTE 130 STE 3",
    "dropdelcty": "DELRAN",
    "dropdelst": "NJ",
    "dropdelzpp": "080759996",
    "dropphyadd": "4000 ROUTE 130 STE 3",
    "dropphycty": "DELRAN",
    "dropphyst": "NJ",
    "dropphyzpp": "080759996",
    "dropmaladd": "4000 ROUTE 130 STE 3",
    "dropmalcty": "DELRAN",
    "dropmalst": "NJ",
    "dropmalzpp": "080759996",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564610722,
    "dropsitcph": 8564610722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10335",
    "droptype": "D",
    "dropname": "DEPTFORD",
    "dropdeladd": "1265 HURFFVILLE RD",
    "dropdelcty": "DEPTFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "080969996",
    "dropphyadd": "1265 HURFFVILLE RD",
    "dropphycty": "DEPTFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "080969996",
    "dropmaladd": "1265 HURFFVILLE RD",
    "dropmalcty": "DEPTFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "080969996",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562326785,
    "dropsitcph": 8562326785,
    "dropfax": 8562326954
  },
  {
    "dcode": "D",
    "dropkey": "BV10387",
    "droptype": "D",
    "dropname": "EAST RUTHERFORD",
    "dropdeladd": "193 PARK AVE",
    "dropdelcty": "EAST RUTHERFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "070739998",
    "dropphyadd": "193 PARK AVE",
    "dropphycty": "EAST RUTHERFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "070739998",
    "dropmaladd": "193 PARK AVE",
    "dropmalcty": "EAST RUTHERFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "070739998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935187,
    "dropsitcph": 2014386105,
    "dropfax": 6505774104
  },
  {
    "dcode": "D",
    "dropkey": "BV10427",
    "droptype": "D",
    "dropname": "ENGLEWOOD CLIFFS",
    "dropdeladd": "650 E PALISADE AVE STE A",
    "dropdelcty": "ENGLEWOOD CLIFFS",
    "dropdelst": "NJ",
    "dropdelzpp": "076329998",
    "dropphyadd": "650 E PALISADE AVE STE A",
    "dropphycty": "ENGLEWOOD CLIFFS",
    "dropphyst": "NJ",
    "dropphyzpp": "076329998",
    "dropmaladd": "650 E PALISADE AVE STE A",
    "dropmalcty": "ENGLEWOOD CLIFFS",
    "dropmalst": "NJ",
    "dropmalzpp": "076329998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018945128,
    "dropsitcph": 2018945128,
    "dropfax": 2015410246
  },
  {
    "dcode": "D",
    "dropkey": "BV10449",
    "droptype": "D",
    "dropname": "FAIR HAVEN",
    "dropdeladd": "592 RIVER RD",
    "dropdelcty": "FAIR HAVEN",
    "dropdelst": "NJ",
    "dropdelzpp": "077049998",
    "dropphyadd": "592 RIVER RD",
    "dropphycty": "FAIR HAVEN",
    "dropphyst": "NJ",
    "dropphyzpp": "077049998",
    "dropmaladd": "592 RIVER RD",
    "dropmalcty": "FAIR HAVEN",
    "dropmalst": "NJ",
    "dropmalzpp": "077049998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327415150,
    "dropsitcph": 7327415150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10452",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "400 FAIRFIELD RD STE 5",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070049998",
    "dropphyadd": "400 FAIRFIELD RD STE 5",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070049998",
    "dropmaladd": "400 FAIRFIELD RD STE 5",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070049998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935187,
    "dropsitcph": 9738823815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10490",
    "droptype": "D",
    "dropname": "FORDS",
    "dropdeladd": "450 NEW BRUNSWICK AVE",
    "dropdelcty": "FORDS",
    "dropdelst": "NJ",
    "dropdelzpp": "088639998",
    "dropphyadd": "450 NEW BRUNSWICK AVE",
    "dropphycty": "FORDS",
    "dropphyst": "NJ",
    "dropphyzpp": "088639998",
    "dropmaladd": "450 NEW BRUNSWICK AVE",
    "dropmalcty": "FORDS",
    "dropmalst": "NJ",
    "dropmalzpp": "088639998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327381036,
    "dropfax": 7327389169
  },
  {
    "dcode": "D",
    "dropkey": "BV10492",
    "droptype": "D",
    "dropname": "FORT DIX",
    "dropdeladd": "6038 W 9TH ST STE 1",
    "dropdelcty": "JOINT BASE MDL",
    "dropdelst": "NJ",
    "dropdelzpp": "086409998",
    "dropphyadd": "6038 W 9TH ST STE 1",
    "dropphycty": "JOINT BASE MDL",
    "dropphyst": "NJ",
    "dropphyzpp": "086409998",
    "dropmaladd": "6038 W 9TH ST STE 1",
    "dropmalcty": "JOINT BASE MDL",
    "dropmalst": "NJ",
    "dropmalzpp": "086409998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 6097232089,
    "dropfax": 6097231541
  },
  {
    "dcode": "D",
    "dropkey": "BV10539",
    "droptype": "D",
    "dropname": "GLEN ROCK",
    "dropdeladd": "73 GLEN AVE",
    "dropdelcty": "GLEN ROCK",
    "dropdelst": "NJ",
    "dropdelzpp": "074529998",
    "dropphyadd": "73 GLEN AVE",
    "dropphycty": "GLEN ROCK",
    "dropphyst": "NJ",
    "dropphyzpp": "074529998",
    "dropmaladd": "73 GLEN AVE",
    "dropmalcty": "GLEN ROCK",
    "dropmalst": "NJ",
    "dropmalzpp": "074529998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2014451751,
    "dropsitcph": 2014451751,
    "dropfax": 6505774209
  },
  {
    "dcode": "D",
    "dropkey": "BV10561",
    "droptype": "D",
    "dropname": "GREEN BROOK",
    "dropdeladd": "1003 N WASHINGTON AVE",
    "dropdelcty": "GREEN BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "088129997",
    "dropphyadd": "1003 N WASHINGTON AVE",
    "dropphycty": "GREEN BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "088129997",
    "dropmaladd": "1003 N WASHINGTON AVE",
    "dropmalcty": "GREEN BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "088129997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329682083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10582",
    "droptype": "D",
    "dropname": "GUTTENBERG",
    "dropdeladd": "6900 PARK AVE",
    "dropdelcty": "WEST NEW YORK",
    "dropdelst": "NJ",
    "dropdelzpp": "070939991",
    "dropphyadd": "6900 PARK AVE",
    "dropphycty": "WEST NEW YORK",
    "dropphyst": "NJ",
    "dropphyzpp": "070939991",
    "dropmaladd": "6900 PARK AVE",
    "dropmalcty": "WEST NEW YORK",
    "dropmalst": "NJ",
    "dropmalzpp": "070939991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018698264,
    "dropsitcph": 2018692729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10595",
    "droptype": "D",
    "dropname": "HALEDON",
    "dropdeladd": "400 HALEDON AVE",
    "dropdelcty": "HALEDON",
    "dropdelst": "NJ",
    "dropdelzpp": "075089998",
    "dropphyadd": "400 HALEDON AVE",
    "dropphycty": "HALEDON",
    "dropphyst": "NJ",
    "dropphyzpp": "075089998",
    "dropmaladd": "400 HALEDON AVE",
    "dropmalcty": "HALEDON",
    "dropmalst": "NJ",
    "dropmalzpp": "075089998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9735951759,
    "dropsitcph": 9735951759,
    "dropfax": 6505774345
  },
  {
    "dcode": "D",
    "dropkey": "BV10612",
    "droptype": "D",
    "dropname": "HARVEY CEDARS",
    "dropdeladd": "7600 LONG BEACH BLVD STE 3",
    "dropdelcty": "HARVEY CEDARS",
    "dropdelst": "NJ",
    "dropdelzpp": "080089994",
    "dropphyadd": "7600 LONG BEACH BLVD STE 3",
    "dropphycty": "HARVEY CEDARS",
    "dropphyst": "NJ",
    "dropphyzpp": "080089994",
    "dropmaladd": "7600 LONG BEACH BLVD STE 3",
    "dropmalcty": "HARVEY CEDARS",
    "dropmalst": "NJ",
    "dropmalzpp": "080089994",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094943001,
    "dropsitcph": 6094943001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10616",
    "droptype": "D",
    "dropname": "HASBROUCK HEIGHTS",
    "dropdeladd": "185 BOULEVARD",
    "dropdelcty": "HASBROUCK HEIGHTS",
    "dropdelst": "NJ",
    "dropdelzpp": "076049998",
    "dropphyadd": "185 BOULEVARD",
    "dropphycty": "HASBROUCK HEIGHTS",
    "dropphyst": "NJ",
    "dropphyzpp": "076049998",
    "dropmaladd": "185 BOULEVARD",
    "dropmalcty": "HASBROUCK HEIGHTS",
    "dropmalst": "NJ",
    "dropmalzpp": "076049998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012883905,
    "dropsitcph": 2012883905,
    "dropfax": 6505774323
  },
  {
    "dcode": "D",
    "dropkey": "BV10622",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "226 DIAMOND BRIDGE AVE",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "NJ",
    "dropdelzpp": "075069998",
    "dropphyadd": "226 DIAMOND BRIDGE AVE",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "NJ",
    "dropphyzpp": "075069998",
    "dropmaladd": "226 DIAMOND BRIDGE AVE",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "NJ",
    "dropmalzpp": "075069998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9734232493,
    "dropsitcph": 9734232493,
    "dropfax": 6505774351
  },
  {
    "dcode": "D",
    "dropkey": "BV10637",
    "droptype": "D",
    "dropname": "HIGHLAND PARK",
    "dropdeladd": "406 RARITAN AVE",
    "dropdelcty": "HIGHLAND PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "089049997",
    "dropphyadd": "406 RARITAN AVE",
    "dropphycty": "HIGHLAND PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "089049997",
    "dropmaladd": "406 RARITAN AVE",
    "dropmalcty": "HIGHLAND PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "089049997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325726006,
    "dropfax": 7322470164
  },
  {
    "dcode": "D",
    "dropkey": "BV10649",
    "droptype": "D",
    "dropname": "HILLSIDE",
    "dropdeladd": "1146 LIBERTY AVE",
    "dropdelcty": "HILLSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "072059991",
    "dropphyadd": "1146 LIBERTY AVE",
    "dropphycty": "HILLSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "072059991",
    "dropmaladd": "1146 LIBERTY AVE",
    "dropmalcty": "HILLSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "072059991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9085270648,
    "dropsitcph": 9085270648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10676",
    "droptype": "D",
    "dropname": "INDUSTRIAL HILLSIDE",
    "dropdeladd": "397 HILLSIDE AVE",
    "dropdelcty": "HILLSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "072059992",
    "dropphyadd": "397 HILLSIDE AVE",
    "dropphycty": "HILLSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "072059992",
    "dropmaladd": "397 HILLSIDE AVE",
    "dropmalcty": "HILLSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "072059992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9739292645,
    "dropsitcph": 9739262645,
    "dropfax": 6505774081
  },
  {
    "dcode": "D",
    "dropkey": "BV10682",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "1086 SPRINGFIELD AVE",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "071119998",
    "dropphyadd": "1086 SPRINGFIELD AVE",
    "dropphycty": "IRVINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "071119998",
    "dropmaladd": "1086 SPRINGFIELD AVE",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "071119998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733992936,
    "dropsitcph": 9733992936,
    "dropfax": 6505774135
  },
  {
    "dcode": "D",
    "dropkey": "BV10746",
    "droptype": "D",
    "dropname": "LAKEHURST NAEC",
    "dropdeladd": "38 LANSDOWNE RD STE 1",
    "dropdelcty": "JOINT BASE MDL",
    "dropdelst": "NJ",
    "dropdelzpp": "087339997",
    "dropphyadd": "38 LANSDOWNE RD STE 1",
    "dropphycty": "JOINT BASE MDL",
    "dropphyst": "NJ",
    "dropphyzpp": "087339997",
    "dropmaladd": "38 LANSDOWNE RD STE 1",
    "dropmalcty": "JOINT BASE MDL",
    "dropmalst": "NJ",
    "dropmalzpp": "087339997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323232534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10759",
    "droptype": "D",
    "dropname": "LAURENCE HARBOR",
    "dropdeladd": "902 STATE ROUTE 35",
    "dropdelcty": "SOUTH AMBOY",
    "dropdelst": "NJ",
    "dropdelzpp": "088799997",
    "dropphyadd": "902 STATE ROUTE 35",
    "dropphycty": "SOUTH AMBOY",
    "dropphyst": "NJ",
    "dropphyzpp": "088799997",
    "dropmaladd": "902 STATE ROUTE 35",
    "dropmalcty": "SOUTH AMBOY",
    "dropmalst": "NJ",
    "dropmalzpp": "088799997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325667031,
    "dropfax": 7325668687
  },
  {
    "dcode": "D",
    "dropkey": "BV10763",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE",
    "dropdeladd": "1 CRAVEN LN",
    "dropdelcty": "LAWRENCE TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "086489998",
    "dropphyadd": "1 CRAVEN LN",
    "dropphycty": "LAWRENCE TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "086489998",
    "dropmaladd": "1 CRAVEN LN",
    "dropmalcty": "LAWRENCE TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "086489998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6098960181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10773",
    "droptype": "D",
    "dropname": "LEONIA",
    "dropdeladd": "398 BROAD AVE",
    "dropdelcty": "LEONIA",
    "dropdelst": "NJ",
    "dropdelzpp": "076059998",
    "dropphyadd": "398 BROAD AVE",
    "dropphycty": "LEONIA",
    "dropphyst": "NJ",
    "dropphyzpp": "076059998",
    "dropmaladd": "398 BROAD AVE",
    "dropmalcty": "LEONIA",
    "dropmalst": "NJ",
    "dropmalzpp": "076059998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2019443986,
    "dropsitcph": 2019443986,
    "dropfax": 6505774047
  },
  {
    "dcode": "D",
    "dropkey": "BV10799",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "7401 LONG BEACH BLVD",
    "dropdelcty": "LONG BEACH TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "080089997",
    "dropphyadd": "7401 LONG BEACH BLVD",
    "dropphycty": "LONG BEACH TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "080089997",
    "dropmaladd": "7401 LONG BEACH BLVD",
    "dropmalcty": "LONG BEACH TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "080089997",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093615370,
    "dropsitcph": 6093615370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10805",
    "droptype": "D",
    "dropname": "LONGPORT",
    "dropdeladd": "4 S 27TH AVE STE 2",
    "dropdelcty": "LONGPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "084039998",
    "dropphyadd": "4 S 27TH AVE STE 2",
    "dropphycty": "LONGPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "084039998",
    "dropmaladd": "4 S 27TH AVE STE 2",
    "dropmalcty": "LONGPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "084039998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098231777,
    "dropsitcph": 6098231777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10815",
    "droptype": "D",
    "dropname": "LYNDHURST",
    "dropdeladd": "436 VALLEY BROOK AVE",
    "dropdelcty": "LYNDHURST",
    "dropdelst": "NJ",
    "dropdelzpp": "070719998",
    "dropphyadd": "436 VALLEY BROOK AVE",
    "dropphycty": "LYNDHURST",
    "dropphyst": "NJ",
    "dropphyzpp": "070719998",
    "dropmaladd": "436 VALLEY BROOK AVE",
    "dropmalcty": "LYNDHURST",
    "dropmalst": "NJ",
    "dropmalzpp": "070719998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2014386630,
    "dropsitcph": 2014386630,
    "dropfax": 6505774252
  },
  {
    "dcode": "D",
    "dropkey": "BV10816",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "151 KNOLLCROFT RD",
    "dropdelcty": "LYONS",
    "dropdelst": "NJ",
    "dropdelzpp": "079399997",
    "dropphyadd": "151 KNOLLCROFT RD",
    "dropphycty": "LYONS",
    "dropphyst": "NJ",
    "dropphyzpp": "079399997",
    "dropmaladd": "151 KNOLLCROFT RD",
    "dropmalcty": "LYONS",
    "dropmalst": "NJ",
    "dropmalzpp": "079399997",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086472626,
    "dropsitcph": 9086472626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10843",
    "droptype": "D",
    "dropname": "MARGATE CITY",
    "dropdeladd": "8 S FRANKLIN AVE",
    "dropdelcty": "MARGATE CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "084029998",
    "dropphyadd": "8 S FRANKLIN AVE",
    "dropphycty": "MARGATE CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "084029998",
    "dropmaladd": "8 S FRANKLIN AVE",
    "dropmalcty": "MARGATE CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "084029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098222404,
    "dropsitcph": 6098222404,
    "dropfax": 6098235395
  },
  {
    "dcode": "D",
    "dropkey": "BV10861",
    "droptype": "D",
    "dropname": "MAYWOOD",
    "dropdeladd": "101 W PLEASANT AVE",
    "dropdelcty": "MAYWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "076079998",
    "dropphyadd": "101 W PLEASANT AVE",
    "dropphycty": "MAYWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "076079998",
    "dropmaladd": "101 W PLEASANT AVE",
    "dropmalcty": "MAYWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076079998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018438132,
    "dropsitcph": 2018438132,
    "dropfax": 6505774311
  },
  {
    "dcode": "D",
    "dropkey": "BV10863",
    "droptype": "D",
    "dropname": "MC GUIRE AFB",
    "dropdeladd": "2907 TUSKEGEE AIRMEN AVE",
    "dropdelcty": "JOINT BASE MDL",
    "dropdelst": "NJ",
    "dropdelzpp": "086419998",
    "dropphyadd": "2907 TUSKEGEE AIRMEN AVE",
    "dropphycty": "JOINT BASE MDL",
    "dropphyst": "NJ",
    "dropphyzpp": "086419998",
    "dropmaladd": "2907 TUSKEGEE AIRMEN AVE",
    "dropmalcty": "JOINT BASE MDL",
    "dropmalst": "NJ",
    "dropmalzpp": "086419998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6097232089,
    "dropfax": 6097231541
  },
  {
    "dcode": "D",
    "dropkey": "BV10882",
    "droptype": "D",
    "dropname": "MERCERVILLE",
    "dropdeladd": "339 HIGHWAY 33 STE 2",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086199998",
    "dropphyadd": "339 HIGHWAY 33 STE 2",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086199998",
    "dropmaladd": "339 HIGHWAY 33 STE 2",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086199998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6095873573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10883",
    "droptype": "D",
    "dropname": "MERCHANTVILLE",
    "dropdeladd": "22 W MAPLE AVE",
    "dropdelcty": "MERCHANTVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "081099998",
    "dropphyadd": "22 W MAPLE AVE",
    "dropphycty": "MERCHANTVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "081099998",
    "dropmaladd": "22 W MAPLE AVE",
    "dropmalcty": "MERCHANTVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "081099998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569639084,
    "dropsitcph": 8569636597,
    "dropfax": 8564860325
  },
  {
    "dcode": "D",
    "dropkey": "BV10939",
    "droptype": "D",
    "dropname": "MONTAGUE",
    "dropdeladd": "264 CLOVE RD",
    "dropdelcty": "MONTAGUE",
    "dropdelst": "NJ",
    "dropdelzpp": "078273118",
    "dropphyadd": "264 CLOVE RD",
    "dropphycty": "MONTAGUE",
    "dropphyst": "NJ",
    "dropphyzpp": "078273118",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTAGUE",
    "dropmalst": "NJ",
    "dropmalzpp": "078279998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9732937444,
    "dropsitcph": 9732937444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV10969",
    "droptype": "D",
    "dropname": "MOUNTAINSIDE",
    "dropdeladd": "604 SHERWOOD PKWY",
    "dropdelcty": "MOUNTAINSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "070929992",
    "dropphyadd": "604 SHERWOOD PKWY",
    "dropphycty": "MOUNTAINSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "070929992",
    "dropmaladd": "604 SHERWOOD PKWY",
    "dropmalcty": "MOUNTAINSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "070929992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082330148,
    "dropsitcph": 9082330148,
    "dropfax": 6505774371
  },
  {
    "dcode": "D",
    "dropkey": "BV10986",
    "droptype": "D",
    "dropname": "LITTLE EGG HARBOR",
    "dropdeladd": "200 MATHISTOWN RD UNIT 20",
    "dropdelcty": "LITTLE EGG HARBOR TWP",
    "dropdelst": "NJ",
    "dropdelzpp": "080879996",
    "dropphyadd": "200 MATHISTOWN RD UNIT 20",
    "dropphycty": "LITTLE EGG HARBOR TWP",
    "dropphyst": "NJ",
    "dropphyzpp": "080879996",
    "dropmaladd": "200 MATHISTOWN RD UNIT 20",
    "dropmalcty": "LITTLE EGG HARBOR TWP",
    "dropmalst": "NJ",
    "dropmalzpp": "080879996",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092963344,
    "dropsitcph": 6092963344,
    "dropfax": 6092963794
  },
  {
    "dcode": "D",
    "dropkey": "BV11006",
    "droptype": "D",
    "dropname": "NEPTUNE CITY",
    "dropdeladd": "105 3RD AVE",
    "dropdelcty": "NEPTUNE",
    "dropdelst": "NJ",
    "dropdelzpp": "077539997",
    "dropphyadd": "105 3RD AVE",
    "dropphycty": "NEPTUNE",
    "dropphyst": "NJ",
    "dropphyzpp": "077539997",
    "dropmaladd": "105 3RD AVE",
    "dropmalcty": "NEPTUNE",
    "dropmalst": "NJ",
    "dropmalzpp": "077539997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327765330,
    "dropsitcph": 7327765330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11026",
    "droptype": "D",
    "dropname": "NEW MONMOUTH",
    "dropdeladd": "33 CHERRY TREE FARM RD",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "077489997",
    "dropphyadd": "33 CHERRY TREE FARM RD",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "077489997",
    "dropmaladd": "33 CHERRY TREE FARM RD",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "077489997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7326712350,
    "dropsitcph": 7326712350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11054",
    "droptype": "D",
    "dropname": "NORTH ARLINGTON",
    "dropdeladd": "10 RIDGE PARK DR",
    "dropdelcty": "NORTH ARLINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070319992",
    "dropphyadd": "10 RIDGE PARK DR",
    "dropphycty": "NORTH ARLINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070319992",
    "dropmaladd": "10 RIDGE PARK DR",
    "dropmalcty": "NORTH ARLINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070319992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019914767,
    "dropsitcph": 2019914767,
    "dropfax": 2012468862
  },
  {
    "dcode": "D",
    "dropkey": "BV11058",
    "droptype": "D",
    "dropname": "NORTH BRANCH",
    "dropdeladd": "3274 US HIGHWAY 22",
    "dropdelcty": "BRANCHBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "088769997",
    "dropphyadd": "3274 US HIGHWAY 22",
    "dropphycty": "BRANCHBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "088769997",
    "dropmaladd": "3274 US HIGHWAY 22",
    "dropmalcty": "BRANCHBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "088769997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085268660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11059",
    "droptype": "D",
    "dropname": "NORTH BRUNSWICK",
    "dropdeladd": "1062 LIVINGSTON AVE",
    "dropdelcty": "NORTH BRUNSWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "089029997",
    "dropphyadd": "1062 LIVINGSTON AVE",
    "dropphycty": "NORTH BRUNSWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "089029997",
    "dropmaladd": "1062 LIVINGSTON AVE",
    "dropmalcty": "NORTH BRUNSWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "089029997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322479420,
    "dropfax": 7322470164
  },
  {
    "dcode": "D",
    "dropkey": "BV11062",
    "droptype": "D",
    "dropname": "NORTH CAPE MAY",
    "dropdeladd": "3860 BAYSHORE RD STE 4",
    "dropdelcty": "CAPE MAY",
    "dropdelst": "NJ",
    "dropdelzpp": "082043200",
    "dropphyadd": "3860 BAYSHORE RD STE 4",
    "dropphycty": "CAPE MAY",
    "dropphyst": "NJ",
    "dropphyzpp": "082043200",
    "dropmaladd": "3860 BAYSHORE RD STE 4",
    "dropmalcty": "CAPE MAY",
    "dropmalst": "NJ",
    "dropmalzpp": "082043200",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098898129,
    "dropsitcph": 6098898129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11076",
    "droptype": "D",
    "dropname": "NORTH PLAINFIELD",
    "dropdeladd": "9 JACKSON AVE",
    "dropdelcty": "NORTH PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070609992",
    "dropphyadd": "9 JACKSON AVE",
    "dropphycty": "NORTH PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070609992",
    "dropmaladd": "9 JACKSON AVE",
    "dropmalcty": "NORTH PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070609992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087534072,
    "dropsitcph": 9087534072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11085",
    "droptype": "D",
    "dropname": "NUTLEY",
    "dropdeladd": "372 FRANKLIN AVE",
    "dropdelcty": "NUTLEY",
    "dropdelst": "NJ",
    "dropdelzpp": "071109998",
    "dropphyadd": "372 FRANKLIN AVE",
    "dropphycty": "NUTLEY",
    "dropphyst": "NJ",
    "dropphyzpp": "071109998",
    "dropmaladd": "372 FRANKLIN AVE",
    "dropmalcty": "NUTLEY",
    "dropmalst": "NJ",
    "dropmalzpp": "071109998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732359136,
    "dropsitcph": 9732359136,
    "dropfax": 6505774376
  },
  {
    "dcode": "D",
    "dropkey": "BV11097",
    "droptype": "D",
    "dropname": "OAKLYN",
    "dropdeladd": "5 E BETTLEWOOD AVE",
    "dropdelcty": "OAKLYN",
    "dropdelst": "NJ",
    "dropdelzpp": "081079998",
    "dropphyadd": "5 E BETTLEWOOD AVE",
    "dropphycty": "OAKLYN",
    "dropphyst": "NJ",
    "dropphyzpp": "081079998",
    "dropmaladd": "5 E BETTLEWOOD AVE",
    "dropmalcty": "OAKLYN",
    "dropmalst": "NJ",
    "dropmalzpp": "081079998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569639026,
    "dropsitcph": 8569636597,
    "dropfax": 8568699154
  },
  {
    "dcode": "D",
    "dropkey": "BV11099",
    "droptype": "D",
    "dropname": "OCEAN",
    "dropdeladd": "3305 FAIRMONT AVE",
    "dropdelcty": "OCEAN",
    "dropdelst": "NJ",
    "dropdelzpp": "077129997",
    "dropphyadd": "3305 FAIRMONT AVE",
    "dropphycty": "OCEAN",
    "dropphyst": "NJ",
    "dropphyzpp": "077129997",
    "dropmaladd": "3305 FAIRMONT AVE",
    "dropmalcty": "OCEAN",
    "dropmalst": "NJ",
    "dropmalzpp": "077129997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327768781,
    "dropsitcph": 7327768781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11123",
    "droptype": "D",
    "dropname": "OSBORNVILLE",
    "dropdeladd": "2532 HOOPER AVE",
    "dropdelcty": "BRICK",
    "dropdelst": "NJ",
    "dropdelzpp": "087239996",
    "dropphyadd": "2532 HOOPER AVE",
    "dropphycty": "BRICK",
    "dropphyst": "NJ",
    "dropphyzpp": "087239996",
    "dropmaladd": "2532 HOOPER AVE",
    "dropmalcty": "BRICK",
    "dropmalst": "NJ",
    "dropmalzpp": "087239996",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7324772222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11174",
    "droptype": "D",
    "dropname": "PENNSAUKEN",
    "dropdeladd": "4724 WESTFIELD AVE",
    "dropdelcty": "PENNSAUKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "081109998",
    "dropphyadd": "4724 WESTFIELD AVE",
    "dropphycty": "PENNSAUKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "081109998",
    "dropmaladd": "4724 WESTFIELD AVE",
    "dropmalcty": "PENNSAUKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "081109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569639506,
    "dropsitcph": 8569636597,
    "dropfax": 8564861339
  },
  {
    "dcode": "D",
    "dropkey": "BV11219",
    "droptype": "D",
    "dropname": "POINT PLEASANT BORO",
    "dropdeladd": "2229 BRIDGE AVE",
    "dropdelcty": "POINT PLEASANT BORO",
    "dropdelst": "NJ",
    "dropdelzpp": "087429996",
    "dropphyadd": "2229 BRIDGE AVE",
    "dropphycty": "POINT PLEASANT BORO",
    "dropphyst": "NJ",
    "dropphyzpp": "087429996",
    "dropmaladd": "2229 BRIDGE AVE",
    "dropmalcty": "POINT PLEASANT BORO",
    "dropmalst": "NJ",
    "dropmalzpp": "087429996",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328992571,
    "dropfax": 7328925094
  },
  {
    "dcode": "D",
    "dropkey": "BV11303",
    "droptype": "D",
    "dropname": "RIVER VALE",
    "dropdeladd": "679 WESTWOOD AVE",
    "dropdelcty": "RIVER VALE",
    "dropdelst": "NJ",
    "dropdelzpp": "076759992",
    "dropphyadd": "679 WESTWOOD AVE",
    "dropphycty": "RIVER VALE",
    "dropphyst": "NJ",
    "dropphyzpp": "076759992",
    "dropmaladd": "216 WESTWOOD AVE",
    "dropmalcty": "WESTWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076759998",
    "dropsitphn": 2012631197,
    "dropsitlph": 2012631197,
    "dropsitcph": 2012631197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11319",
    "droptype": "D",
    "dropname": "ROSELLE",
    "dropdeladd": "104 CHESTNUT ST",
    "dropdelcty": "ROSELLE",
    "dropdelst": "NJ",
    "dropdelzpp": "072039998",
    "dropphyadd": "104 CHESTNUT ST",
    "dropphycty": "ROSELLE",
    "dropphyst": "NJ",
    "dropphyzpp": "072039998",
    "dropmaladd": "104 CHESTNUT ST",
    "dropmalcty": "ROSELLE",
    "dropmalst": "NJ",
    "dropmalzpp": "072039998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082453218,
    "dropsitcph": 9082453218,
    "dropfax": 6505774082
  },
  {
    "dcode": "D",
    "dropkey": "BV11320",
    "droptype": "D",
    "dropname": "ROSELLE PARK",
    "dropdeladd": "290 CHESTNUT ST",
    "dropdelcty": "ROSELLE PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "072049998",
    "dropphyadd": "290 CHESTNUT ST",
    "dropphycty": "ROSELLE PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "072049998",
    "dropmaladd": "290 CHESTNUT ST",
    "dropmalcty": "ROSELLE PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "072049998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082418541,
    "dropsitcph": 9082418541,
    "dropfax": 9082455664
  },
  {
    "dcode": "D",
    "dropkey": "BV11345",
    "droptype": "D",
    "dropname": "SADDLE BROOK",
    "dropdeladd": "360 MARKET ST",
    "dropdelcty": "SADDLE BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "076639998",
    "dropphyadd": "360 MARKET ST",
    "dropphycty": "SADDLE BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "076639998",
    "dropmaladd": "360 MARKET ST",
    "dropmalcty": "SADDLE BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "076639998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018434974,
    "dropsitcph": 2018434974,
    "dropfax": 6505774383
  },
  {
    "dcode": "D",
    "dropkey": "BV11389",
    "droptype": "D",
    "dropname": "SHIP BOTTOM",
    "dropdeladd": "1601 LONG BEACH BLVD UNIT 1",
    "dropdelcty": "SHIP BOTTOM",
    "dropdelst": "NJ",
    "dropdelzpp": "080089995",
    "dropphyadd": "1601 LONG BEACH BLVD UNIT 1",
    "dropphycty": "SHIP BOTTOM",
    "dropphyst": "NJ",
    "dropphyzpp": "080089995",
    "dropmaladd": "1601 LONG BEACH BLVD UNIT 1",
    "dropmalcty": "SHIP BOTTOM",
    "dropmalst": "NJ",
    "dropmalzpp": "080089995",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094947235,
    "dropsitcph": 6094947235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11393",
    "droptype": "D",
    "dropname": "SHREWSBURY",
    "dropdeladd": "562 BROAD ST",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "NJ",
    "dropdelzpp": "077029998",
    "dropphyadd": "562 BROAD ST",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "NJ",
    "dropphyzpp": "077029998",
    "dropmaladd": "562 BROAD ST",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "NJ",
    "dropmalzpp": "077029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327415943,
    "dropsitcph": 7327415943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11416",
    "droptype": "D",
    "dropname": "BELLMAWR",
    "dropdeladd": "421 BENIGNO BLVD",
    "dropdelcty": "BELLMAWR",
    "dropdelst": "NJ",
    "dropdelzpp": "080319988",
    "dropphyadd": "421 BENIGNO BLVD",
    "dropphycty": "BELLMAWR",
    "dropphyst": "NJ",
    "dropphyzpp": "080319988",
    "dropmaladd": "501 BENIGNO BLVD",
    "dropmalcty": "BELLMAWR",
    "dropmalst": "NJ",
    "dropmalzpp": "080319989",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569334036,
    "dropsitcph": 8569334036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11441",
    "droptype": "D",
    "dropname": "SOUTH HACKENSACK",
    "dropdeladd": "560 HUYLER ST",
    "dropdelcty": "SOUTH HACKENSACK",
    "dropdelst": "NJ",
    "dropdelzpp": "076061544",
    "dropphyadd": "560 HUYLER ST",
    "dropphycty": "SOUTH HACKENSACK",
    "dropphyst": "NJ",
    "dropphyzpp": "076061544",
    "dropmaladd": "560 HUYLER ST",
    "dropmalcty": "SOUTH HACKENSACK",
    "dropmalst": "NJ",
    "dropmalzpp": "076061544",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013754400,
    "dropsitcph": 2013754400,
    "dropfax": 6505774020
  },
  {
    "dcode": "D",
    "dropkey": "BV11561",
    "droptype": "D",
    "dropname": "TOTOWA",
    "dropdeladd": "20 CREWS ST",
    "dropdelcty": "TOTOWA",
    "dropdelst": "NJ",
    "dropdelzpp": "075129998",
    "dropphyadd": "20 CREWS ST",
    "dropphycty": "TOTOWA",
    "dropphyst": "NJ",
    "dropphyzpp": "075129998",
    "dropmaladd": "20 CREWS ST",
    "dropmalcty": "TOTOWA",
    "dropmalst": "NJ",
    "dropmalzpp": "075129998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9735956074,
    "dropsitcph": 9735956074,
    "dropfax": 6505774358
  },
  {
    "dcode": "D",
    "dropkey": "BV11625",
    "droptype": "D",
    "dropname": "VENTNOR CITY",
    "dropdeladd": "5006 WELLINGTON AVE",
    "dropdelcty": "VENTNOR CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "084069998",
    "dropphyadd": "5006 WELLINGTON AVE",
    "dropphycty": "VENTNOR CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "084069998",
    "dropmaladd": "5006 WELLINGTON AVE",
    "dropmalcty": "VENTNOR CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "084069998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098235521,
    "dropsitcph": 6098235521,
    "dropfax": 6094878934
  },
  {
    "dcode": "D",
    "dropkey": "BV11630",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "682 BLOOMFIELD AVE",
    "dropdelcty": "VERONA",
    "dropdelst": "NJ",
    "dropdelzpp": "070449998",
    "dropphyadd": "682 BLOOMFIELD AVE",
    "dropphycty": "VERONA",
    "dropphyst": "NJ",
    "dropphyzpp": "070449998",
    "dropmaladd": "682 BLOOMFIELD AVE",
    "dropmalcty": "VERONA",
    "dropmalst": "NJ",
    "dropmalzpp": "070449998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732393481,
    "dropsitcph": 9732393481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11657",
    "droptype": "D",
    "dropname": "WALL",
    "dropdeladd": "2510 BELMAR BLVD STE J-4",
    "dropdelcty": "BELMAR",
    "dropdelst": "NJ",
    "dropdelzpp": "077199997",
    "dropphyadd": "2510 BELMAR BLVD STE J-4",
    "dropphycty": "BELMAR",
    "dropphyst": "NJ",
    "dropphyzpp": "077199997",
    "dropmaladd": "2510 BELMAR BLVD STE J-4",
    "dropmalcty": "BELMAR",
    "dropmalst": "NJ",
    "dropmalzpp": "077199997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7326816267,
    "dropsitcph": 7326816267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11663",
    "droptype": "D",
    "dropname": "WALLINGTON",
    "dropdeladd": "218 MAPLE AVE",
    "dropdelcty": "WALLINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070579998",
    "dropphyadd": "218 MAPLE AVE",
    "dropphycty": "WALLINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070579998",
    "dropmaladd": "218 MAPLE AVE",
    "dropmalcty": "WALLINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070579998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737790358,
    "dropsitcph": 9737790358,
    "dropfax": 6505774369
  },
  {
    "dcode": "D",
    "dropkey": "BV11671",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "2 TECHNOLOGY DR",
    "dropdelcty": "WARREN",
    "dropdelst": "NJ",
    "dropdelzpp": "070595148",
    "dropphyadd": "2 TECHNOLOGY DR",
    "dropphycty": "WARREN",
    "dropphyst": "NJ",
    "dropphyzpp": "070595148",
    "dropmaladd": "2 TECHNOLOGY DR",
    "dropmalcty": "WARREN",
    "dropmalst": "NJ",
    "dropmalzpp": "070595148",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082223563,
    "dropsitcph": 9082223563,
    "dropfax": 6505774381
  },
  {
    "dcode": "D",
    "dropkey": "BV11674",
    "droptype": "D",
    "dropname": "TURNERSVILLE",
    "dropdeladd": "425 HURFFVILLE CROSS KEYS RD",
    "dropdelcty": "BLACKWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "080129997",
    "dropphyadd": "425 HURFFVILLE CROSS KEYS RD",
    "dropphycty": "BLACKWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "080129997",
    "dropmaladd": "425 HURFFVILLE CROSS KEYS RD",
    "dropmalcty": "BLACKWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "080129997",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565820685,
    "dropsitcph": 8565820685,
    "dropfax": 8562181075
  },
  {
    "dcode": "D",
    "dropkey": "BV11685",
    "droptype": "D",
    "dropname": "WATCHUNG",
    "dropdeladd": "475 WATCHUNG AVE STE 1",
    "dropdelcty": "WATCHUNG",
    "dropdelst": "NJ",
    "dropdelzpp": "070699994",
    "dropphyadd": "475 WATCHUNG AVE STE 1",
    "dropphycty": "WATCHUNG",
    "dropphyst": "NJ",
    "dropphyzpp": "070699994",
    "dropmaladd": "475 WATCHUNG AVE STE 1",
    "dropmalcty": "WATCHUNG",
    "dropmalst": "NJ",
    "dropmalzpp": "070699994",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087562541,
    "dropsitcph": 9087562541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11692",
    "droptype": "D",
    "dropname": "WEEHAWKEN",
    "dropdeladd": "4100 PARK AVE STE 9",
    "dropdelcty": "WEEHAWKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070869995",
    "dropphyadd": "4100 PARK AVE STE 9",
    "dropphycty": "WEEHAWKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070869995",
    "dropmaladd": "4100 PARK AVE STE 9",
    "dropmalcty": "WEEHAWKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070869995",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018672856,
    "dropsitcph": 2018672856,
    "dropfax": 2018650723
  },
  {
    "dcode": "D",
    "dropkey": "BV11705",
    "droptype": "D",
    "dropname": "WEST CALDWELL",
    "dropdeladd": "155 CLINTON RD",
    "dropdelcty": "CALDWELL",
    "dropdelst": "NJ",
    "dropdelzpp": "070069998",
    "dropphyadd": "155 CLINTON RD",
    "dropphycty": "CALDWELL",
    "dropphyst": "NJ",
    "dropphyzpp": "070069998",
    "dropmaladd": "155 CLINTON RD",
    "dropmalcty": "CALDWELL",
    "dropmalst": "NJ",
    "dropmalzpp": "070069998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732272699,
    "dropsitcph": 9732272699,
    "dropfax": 6505774367
  },
  {
    "dcode": "D",
    "dropkey": "BV11730",
    "droptype": "D",
    "dropname": "WEST ORANGE",
    "dropdeladd": "634 EAGLE ROCK AVE",
    "dropdelcty": "WEST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070529991",
    "dropphyadd": "634 EAGLE ROCK AVE",
    "dropphycty": "WEST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070529991",
    "dropmaladd": "634 EAGLE ROCK AVE",
    "dropmalcty": "WEST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070529991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737313529,
    "dropsitcph": 9737313529,
    "dropfax": 9737312130
  },
  {
    "dcode": "D",
    "dropkey": "BV11731",
    "droptype": "D",
    "dropname": "WEST PATERSON",
    "dropdeladd": "1017 MCBRIDE AVE",
    "dropdelcty": "WOODLAND PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "074249991",
    "dropphyadd": "1017 MCBRIDE AVE",
    "dropphycty": "WOODLAND PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "074249991",
    "dropmaladd": "1017 MCBRIDE AVE",
    "dropmalcty": "WOODLAND PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "074249991",
    "dropsitphn": 2019559706,
    "dropsitlph": 9732564283,
    "dropsitcph": 9732564283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11740",
    "droptype": "D",
    "dropname": "WEST TRENTON",
    "dropdeladd": "555 GRAND AVE",
    "dropdelcty": "EWING",
    "dropdelst": "NJ",
    "dropdelzpp": "086289998",
    "dropphyadd": "555 GRAND AVE",
    "dropphycty": "EWING",
    "dropphyst": "NJ",
    "dropphyzpp": "086289998",
    "dropmaladd": "555 GRAND AVE",
    "dropmalcty": "EWING",
    "dropmalst": "NJ",
    "dropmalzpp": "086289998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 6098824845,
    "dropfax": 6095300521
  },
  {
    "dcode": "D",
    "dropkey": "BV11771",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "108 LACEY RD STE 38",
    "dropdelcty": "WHITING",
    "dropdelst": "NJ",
    "dropdelzpp": "087599998",
    "dropphyadd": "108 LACEY RD STE 38",
    "dropphycty": "WHITING",
    "dropphyst": "NJ",
    "dropphyzpp": "087599998",
    "dropmaladd": "108 LACEY RD STE 38",
    "dropmalcty": "WHITING",
    "dropmalst": "NJ",
    "dropmalzpp": "087599998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323505817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11792",
    "droptype": "D",
    "dropname": "WOOD RIDGE",
    "dropdeladd": "290 HACKENSACK ST",
    "dropdelcty": "WOOD RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070759998",
    "dropphyadd": "290 HACKENSACK ST",
    "dropphycty": "WOOD RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070759998",
    "dropmaladd": "290 HACKENSACK ST",
    "dropmalcty": "WOOD RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070759998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2014381736,
    "dropsitcph": 2014381736,
    "dropfax": 6505774202
  },
  {
    "dcode": "D",
    "dropkey": "BV11802",
    "droptype": "D",
    "dropname": "WOODCLIFF LAKE",
    "dropdeladd": "86 BROADWAY",
    "dropdelcty": "WOODCLIFF LAKE",
    "dropdelst": "NJ",
    "dropdelzpp": "076779991",
    "dropphyadd": "86 BROADWAY",
    "dropphycty": "WOODCLIFF LAKE",
    "dropphyst": "NJ",
    "dropphyzpp": "076779991",
    "dropmaladd": "86 BROADWAY",
    "dropmalcty": "WOODCLIFF LAKE",
    "dropmalst": "NJ",
    "dropmalzpp": "076779991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013912239,
    "dropsitcph": 2013912239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11836",
    "droptype": "D",
    "dropname": "CAYUGA RETAIL",
    "dropdeladd": "285 CAYUGA RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142410001,
    "dropphyadd": "285 CAYUGA RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142410001,
    "dropmaladd": "285 CAYUGA RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142410001,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462411,
    "dropsitcph": 7166313531,
    "dropfax": 7166313779
  },
  {
    "dcode": "D",
    "dropkey": "BV11851",
    "droptype": "D",
    "dropname": "ALDEN MANOR",
    "dropdeladd": "778 ELMONT RD",
    "dropdelcty": "ELMONT",
    "dropdelst": "NY",
    "dropdelzpp": 110039993,
    "dropphyadd": "778 ELMONT RD",
    "dropphycty": "ELMONT",
    "dropphyst": "NY",
    "dropphyzpp": 110039993,
    "dropmaladd": "778 ELMONT RD",
    "dropmalcty": "ELMONT",
    "dropmalst": "NY",
    "dropmalzpp": 110039993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5162854078,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "BV11898",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "5500 N BAILEY AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142269998,
    "dropphyadd": "5500 N BAILEY AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142269998,
    "dropmaladd": "5500 N BAILEY AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168318651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV11951",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "41 RAYMOND AVE",
    "dropdelcty": "POUGHKEEPSIE",
    "dropdelst": "NY",
    "dropdelzpp": 126032397,
    "dropphyadd": "41 RAYMOND AVE",
    "dropphycty": "POUGHKEEPSIE",
    "dropphyst": "NY",
    "dropphyzpp": 126032397,
    "dropmaladd": "41 RAYMOND AVE",
    "dropmalcty": "POUGHKEEPSIE",
    "dropmalst": "NY",
    "dropmalzpp": 126032397,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454717046,
    "dropsitcph": 8454717046,
    "dropfax": 8454714013
  },
  {
    "dcode": "D",
    "dropkey": "BV12044",
    "droptype": "D",
    "dropname": "BARDONIA",
    "dropdeladd": "77 BARDONIA RD",
    "dropdelcty": "NANUET",
    "dropdelst": "NY",
    "dropdelzpp": 109542156,
    "dropphyadd": "77 BARDONIA RD",
    "dropphycty": "NANUET",
    "dropphyst": "NY",
    "dropphyzpp": 109542156,
    "dropmaladd": "10 PROSPECT ST",
    "dropmalcty": "NANUET",
    "dropmalst": "NY",
    "dropmalzpp": 109549998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456236735,
    "dropsitcph": 8456236735,
    "dropfax": 8456244315
  },
  {
    "dcode": "D",
    "dropkey": "BV12081",
    "droptype": "D",
    "dropname": "BAYBERRY",
    "dropdeladd": "7608 OSWEGO RD OFC",
    "dropdelcty": "LIVERPOOL",
    "dropdelst": "NY",
    "dropdelzpp": 130909211,
    "dropphyadd": "7608 OSWEGO RD OFC",
    "dropphycty": "LIVERPOOL",
    "dropphyst": "NY",
    "dropphyzpp": 130909211,
    "dropmaladd": "7608 OSWEGO RD OFC",
    "dropmalcty": "LIVERPOOL",
    "dropmalst": "NY",
    "dropmalzpp": 130909211,
    "dropsitphn": 3156224451,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156224451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV12175",
    "droptype": "D",
    "dropname": "BLASDELL",
    "dropdeladd": "4250 LAKE AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142199998,
    "dropphyadd": "4250 LAKE AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142199998,
    "dropmaladd": "4250 LAKE AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142199998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168278219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV12308",
    "droptype": "D",
    "dropname": "BRONXVILLE",
    "dropdeladd": "119 PONDFIELD RD",
    "dropdelcty": "BRONXVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 107084013,
    "dropphyadd": "119 PONDFIELD RD",
    "dropphycty": "BRONXVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 107084013,
    "dropmaladd": "119 PONDFIELD RD",
    "dropmalcty": "BRONXVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 107084013,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147797092,
    "dropsitcph": 9147797092,
    "dropfax": 9143376922
  },
  {
    "dcode": "D",
    "dropkey": "BV12540",
    "droptype": "D",
    "dropname": "CHEEKTOWAGA",
    "dropdeladd": "125 GALLERIA DR",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142259998,
    "dropphyadd": "125 GALLERIA DR",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142259998,
    "dropmaladd": "125 GALLERIA DR",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166810566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV12845",
    "droptype": "D",
    "dropname": "CRUGERS",
    "dropdeladd": "2042 ALBANY POST RD STE 3",
    "dropdelcty": "CROTON ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 105201128,
    "dropphyadd": "2042 ALBANY POST RD STE 3",
    "dropphycty": "CROTON ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 105201128,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROTON ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 105219998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147390602,
    "dropsitcph": 9147390602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV12885",
    "droptype": "D",
    "dropname": "DE WITT",
    "dropdeladd": "6581 KINNE RD",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132149211,
    "dropphyadd": "6581 KINNE RD",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132149211,
    "dropmaladd": "6581 KINNE RD",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132149211,
    "dropsitphn": 3154451645,
    "dropsitlph": 3154451645,
    "dropsitcph": 3154451645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV13147",
    "droptype": "D",
    "dropname": "EASTCHESTER",
    "dropdeladd": "155 FISHER AVE",
    "dropdelcty": "EASTCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 107092610,
    "dropphyadd": "155 FISHER AVE",
    "dropphycty": "EASTCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 107092610,
    "dropmaladd": "155 FISHER AVE",
    "dropmalcty": "EASTCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 107092610,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147797130,
    "dropsitcph": 9147797130,
    "dropfax": 9143374840
  },
  {
    "dcode": "D",
    "dropkey": "BV13215",
    "droptype": "D",
    "dropname": "ELMIRA HEIGHTS",
    "dropdeladd": "209 E 14TH ST",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149039993,
    "dropphyadd": "209 E 14TH ST",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149039993,
    "dropmaladd": "209 E 14TH ST",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149039993,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077375108,
    "dropsitcph": 6077337502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV13219",
    "droptype": "D",
    "dropname": "ELMONT",
    "dropdeladd": "260 ELMONT RD",
    "dropdelcty": "ELMONT",
    "dropdelst": "NY",
    "dropdelzpp": 110039997,
    "dropphyadd": "260 ELMONT RD",
    "dropphycty": "ELMONT",
    "dropphyst": "NY",
    "dropphyzpp": 110039997,
    "dropmaladd": "260 ELMONT RD",
    "dropmalcty": "ELMONT",
    "dropmalst": "NY",
    "dropmalzpp": 110039997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5163547538,
    "dropfax": 5163547605
  },
  {
    "dcode": "D",
    "dropkey": "BV13392",
    "droptype": "D",
    "dropname": "FORT DRUM",
    "dropdeladd": "10760 ENDURING FREEDOM DR STE 1",
    "dropdelcty": "FORT DRUM",
    "dropdelst": "NY",
    "dropdelzpp": 136029901,
    "dropphyadd": "10760 ENDURING FREEDOM DR STE 1",
    "dropphycty": "FORT DRUM",
    "dropphyst": "NY",
    "dropphyzpp": 136029901,
    "dropmaladd": "10760 ENDURING FREEDOM DR STE 1",
    "dropmalcty": "FORT DRUM",
    "dropmalst": "NY",
    "dropmalzpp": 136029901,
    "dropsitphn": 3157725220,
    "dropsitlph": 5184522299,
    "dropsitcph": 3157725220,
    "dropfax": 3157865975
  },
  {
    "dcode": "D",
    "dropkey": "BV13550",
    "droptype": "D",
    "dropname": "GLEN OAKS",
    "dropdeladd": "25629 UNION TPKE",
    "dropdelcty": "GLEN OAKS",
    "dropdelst": "NY",
    "dropdelzpp": 110049997,
    "dropphyadd": "25629 UNION TPKE",
    "dropphycty": "GLEN OAKS",
    "dropphyst": "NY",
    "dropphyzpp": 110049997,
    "dropmaladd": "25629 UNION TPKE",
    "dropmalcty": "GLEN OAKS",
    "dropmalst": "NY",
    "dropmalzpp": 110049997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183473764,
    "dropfax": 7183476689
  },
  {
    "dcode": "D",
    "dropkey": "BV13564",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "6 GLENRIDGE RD",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123029997,
    "dropphyadd": "6 GLENRIDGE RD",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123029997,
    "dropmaladd": "6 GLENRIDGE RD",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123029997,
    "dropsitphn": 5183840490,
    "dropsitlph": 5183840490,
    "dropsitcph": 5183840490,
    "dropfax": 5183840667
  },
  {
    "dcode": "D",
    "dropkey": "BV13640",
    "droptype": "D",
    "dropname": "GREECE",
    "dropdeladd": "3245 LATTA RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146129998,
    "dropphyadd": "3245 LATTA RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146129998,
    "dropmaladd": "3245 LATTA RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133230,
    "dropsitcph": 5856133230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV13649",
    "droptype": "D",
    "dropname": "GREEN ISLAND",
    "dropdeladd": "137 GEORGE ST",
    "dropdelcty": "TROY",
    "dropdelst": "NY",
    "dropdelzpp": 121839998,
    "dropphyadd": "137 GEORGE ST",
    "dropphycty": "TROY",
    "dropphyst": "NY",
    "dropphyzpp": 121839998,
    "dropmaladd": "137 GEORGE ST",
    "dropmalcty": "TROY",
    "dropmalst": "NY",
    "dropmalzpp": 121839998,
    "dropsitphn": 5182735032,
    "dropsitlph": 5182375032,
    "dropsitcph": 5182735032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV13714",
    "droptype": "D",
    "dropname": "HALESITE",
    "dropdeladd": "16 NEW YORK AVE",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 117439991,
    "dropphyadd": "16 NEW YORK AVE",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 117439991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 117439998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314235880,
    "dropfax": 6314250589
  },
  {
    "dcode": "D",
    "dropkey": "BV13791",
    "droptype": "D",
    "dropname": "HASTINGS ON HUDSON",
    "dropdeladd": "591 WARBURTON AVE",
    "dropdelcty": "HASTINGS ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 107061530,
    "dropphyadd": "591 WARBURTON AVE",
    "dropphycty": "HASTINGS ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 107061530,
    "dropmaladd": "591 WARBURTON AVE",
    "dropmalcty": "HASTINGS ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 107061530,
    "dropsitphn": 9146974123,
    "dropsitlph": 9144783786,
    "dropsitcph": 9144783786,
    "dropfax": 9144780423
  },
  {
    "dcode": "D",
    "dropkey": "BV13793",
    "droptype": "D",
    "dropname": "HAUPPAUGE",
    "dropdeladd": "960 WHEELER RD",
    "dropdelcty": "HAUPPAUGE",
    "dropdelst": "NY",
    "dropdelzpp": 117882847,
    "dropphyadd": "960 WHEELER RD",
    "dropphycty": "HAUPPAUGE",
    "dropphyst": "NY",
    "dropphyzpp": 117882847,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 117879998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313607229,
    "dropfax": 6313664621
  },
  {
    "dcode": "D",
    "dropkey": "BV13795",
    "droptype": "D",
    "dropname": "HAUPPAUGE INDUSTRIAL PARK",
    "dropdeladd": "150 OSER AVE",
    "dropdelcty": "HAUPPAUGE",
    "dropdelst": "NY",
    "dropdelzpp": 117883711,
    "dropphyadd": "150 OSER AVE",
    "dropphycty": "HAUPPAUGE",
    "dropphyst": "NY",
    "dropphyzpp": 117883711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 117879998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312313155,
    "dropfax": 6313484583
  },
  {
    "dcode": "D",
    "dropkey": "BV13810",
    "droptype": "D",
    "dropname": "HEATHCOTE",
    "dropdeladd": "1112 WILMOT RD",
    "dropdelcty": "SCARSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 105836860,
    "dropphyadd": "1112 WILMOT RD",
    "dropphycty": "SCARSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 105836860,
    "dropmaladd": "1112 WILMOT RD",
    "dropmalcty": "SCARSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 105836860,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147258142,
    "dropsitcph": 9147258142,
    "dropfax": 9144721275
  },
  {
    "dcode": "D",
    "dropkey": "BV13872",
    "droptype": "D",
    "dropname": "HILER",
    "dropdeladd": "244 HIGHLAND PKWY",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142239998,
    "dropphyadd": "244 HIGHLAND PKWY",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142239998,
    "dropmaladd": "244 HIGHLAND PKWY",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142239998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168747023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV13883",
    "droptype": "D",
    "dropname": "HILLSIDE MANOR",
    "dropdeladd": "2038 HILLSIDE AVE",
    "dropdelcty": "NEW HYDE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 110409993,
    "dropphyadd": "2038 HILLSIDE AVE",
    "dropphycty": "NEW HYDE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 110409993,
    "dropmaladd": "2038 HILLSIDE AVE",
    "dropmalcty": "NEW HYDE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 110409993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5163545685,
    "dropfax": 5167753809
  },
  {
    "dcode": "D",
    "dropkey": "BV14128",
    "droptype": "D",
    "dropname": "KENMORE",
    "dropdeladd": "3014 DELAWARE AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142179998,
    "dropphyadd": "3014 DELAWARE AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142179998,
    "dropmaladd": "3014 DELAWARE AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142179998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168747017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV14219",
    "droptype": "D",
    "dropname": "LACKAWANNA",
    "dropdeladd": "683 RIDGE RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142189998,
    "dropphyadd": "683 RIDGE RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142189998,
    "dropmaladd": "683 RIDGE RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142189998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168278221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV14258",
    "droptype": "D",
    "dropname": "LAKE RONKONKOMA",
    "dropdeladd": "300 PORTION RD",
    "dropdelcty": "RONKONKOMA",
    "dropdelst": "NY",
    "dropdelzpp": 117792348,
    "dropphyadd": "300 PORTION RD",
    "dropphycty": "RONKONKOMA",
    "dropphyst": "NY",
    "dropphyzpp": 117792348,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RONKONKOMA",
    "dropmalst": "NY",
    "dropmalzpp": 117799998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315881292,
    "dropfax": 6314711290
  },
  {
    "dcode": "D",
    "dropkey": "BV14284",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "1939 E SHORE DR STE 2",
    "dropdelcty": "LANSING",
    "dropdelst": "NY",
    "dropdelzpp": 148828986,
    "dropphyadd": "1939 E SHORE DR STE 2",
    "dropphycty": "LANSING",
    "dropphyst": "NY",
    "dropphyzpp": 148828986,
    "dropmaladd": "1939 E SHORE DR STE 2",
    "dropmalcty": "LANSING",
    "dropmalst": "NY",
    "dropmalzpp": 148828986,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075338698,
    "dropsitcph": 6075338698,
    "dropfax": 6072660566
  },
  {
    "dcode": "D",
    "dropkey": "BV14430",
    "droptype": "D",
    "dropname": "LOUDONVILLE",
    "dropdeladd": "475 ALBANY SHAKER RD STE 9",
    "dropdelcty": "LOUDONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 122119901,
    "dropphyadd": "475 ALBANY SHAKER RD STE 9",
    "dropphycty": "LOUDONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 122119901,
    "dropmaladd": "475 ALBANY SHAKER RD STE 9",
    "dropmalcty": "LOUDONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 122119901,
    "dropsitphn": 5184589548,
    "dropsitlph": 5184589548,
    "dropsitcph": 5184589548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV14587",
    "droptype": "D",
    "dropname": "MATTYDALE",
    "dropdeladd": "1900 BREWERTON RD",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132119211,
    "dropphyadd": "1900 BREWERTON RD",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132119211,
    "dropmaladd": "1900 BREWERTON RD",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132119211,
    "dropsitphn": 3154548332,
    "dropsitlph": 3154548332,
    "dropsitcph": 3154548332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV14601",
    "droptype": "D",
    "dropname": "STUYVESANT PLAZA",
    "dropdeladd": "1475 WESTERN AVE STE 51",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122039998,
    "dropphyadd": "1475 WESTERN AVE STE 51",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122039998,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122039997,
    "dropsitphn": 5184380773,
    "dropsitlph": 5184380773,
    "dropsitcph": 5184380773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV14615",
    "droptype": "D",
    "dropname": "MEACHAM",
    "dropdeladd": "798 MEACHAM AVE",
    "dropdelcty": "ELMONT",
    "dropdelst": "NY",
    "dropdelzpp": 110039994,
    "dropphyadd": "798 MEACHAM AVE",
    "dropphycty": "ELMONT",
    "dropphyst": "NY",
    "dropphyzpp": 110039994,
    "dropmaladd": "798 MEACHAM AVE",
    "dropmalcty": "ELMONT",
    "dropmalst": "NY",
    "dropmalzpp": 110039994,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5168876247,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "BV14633",
    "droptype": "D",
    "dropname": "MELVILLE",
    "dropdeladd": "718 WALT WHITMAN RD",
    "dropdelcty": "MELVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117472230,
    "dropphyadd": "718 WALT WHITMAN RD",
    "dropphycty": "MELVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117472230,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON STATION",
    "dropmalst": "NY",
    "dropmalzpp": 117469998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314210726,
    "dropfax": 6314235626
  },
  {
    "dcode": "D",
    "dropkey": "BV14963",
    "droptype": "D",
    "dropname": "NEW WINDSOR",
    "dropdeladd": "436 BLOOMING GROVE TPKE STE 1100",
    "dropdelcty": "NEW WINDSOR",
    "dropdelst": "NY",
    "dropdelzpp": 125537845,
    "dropphyadd": "436 BLOOMING GROVE TPKE STE 1100",
    "dropphycty": "NEW WINDSOR",
    "dropphyst": "NY",
    "dropphyzpp": 125537845,
    "dropmaladd": "436 BLOOMING GROVE TPKE STE 1100",
    "dropmalcty": "NEW WINDSOR",
    "dropmalst": "NY",
    "dropmalzpp": 125537845,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455620542,
    "dropsitcph": 8455620542,
    "dropfax": 8455691071
  },
  {
    "dcode": "D",
    "dropkey": "BV14988",
    "droptype": "D",
    "dropname": "NEWTONVILLE",
    "dropdeladd": "552 NEW LOUDON RD",
    "dropdelcty": "LATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 121109997,
    "dropphyadd": "552 NEW LOUDON RD",
    "dropphycty": "LATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 121109997,
    "dropmaladd": "552 NEW LOUDON RD",
    "dropmalcty": "LATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 121109997,
    "dropsitphn": 5187850032,
    "dropsitlph": 5187850032,
    "dropsitcph": 5187850032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15008",
    "droptype": "D",
    "dropname": "NISKAYUNA",
    "dropdeladd": "2320 NOTT ST E",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123099211,
    "dropphyadd": "2320 NOTT ST E",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123099211,
    "dropmaladd": "2320 NOTT ST E",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123099211,
    "dropsitphn": 5183820344,
    "dropsitlph": 5183820344,
    "dropsitcph": 5183820344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15028",
    "droptype": "D",
    "dropname": "NORTH BABYLON",
    "dropdeladd": "1196 DEER PARK AVE",
    "dropdelcty": "NORTH BABYLON",
    "dropdelst": "NY",
    "dropdelzpp": 117033111,
    "dropphyadd": "1196 DEER PARK AVE",
    "dropphycty": "NORTH BABYLON",
    "dropphyst": "NY",
    "dropphyzpp": 117033111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABYLON",
    "dropmalst": "NY",
    "dropmalzpp": 117029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316674693,
    "dropfax": 6316674317
  },
  {
    "dcode": "D",
    "dropkey": "BV15035",
    "droptype": "D",
    "dropname": "NORTH BELLMORE",
    "dropdeladd": "2465 JERUSALEM AVE",
    "dropdelcty": "NORTH BELLMORE",
    "dropdelst": "NY",
    "dropdelzpp": 117109991,
    "dropphyadd": "2465 JERUSALEM AVE",
    "dropphycty": "NORTH BELLMORE",
    "dropphyst": "NY",
    "dropphyzpp": 117109991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLMORE",
    "dropmalst": "NY",
    "dropmalzpp": 117109998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167850676,
    "dropfax": 5167817946
  },
  {
    "dcode": "D",
    "dropkey": "BV15083",
    "droptype": "D",
    "dropname": "NORTH MASSAPEQUA",
    "dropdeladd": "1290 HICKSVILLE RD",
    "dropdelcty": "MASSAPEQUA",
    "dropdelst": "NY",
    "dropdelzpp": 117581200,
    "dropphyadd": "1290 HICKSVILLE RD",
    "dropphycty": "MASSAPEQUA",
    "dropphyst": "NY",
    "dropphyzpp": 117581200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASSAPEQUA",
    "dropmalst": "NY",
    "dropmalzpp": 117589998,
    "dropsitphn": 5167552524,
    "dropsitlph": 5167552524,
    "dropsitcph": 5167982450,
    "dropfax": 5167978707
  },
  {
    "dcode": "D",
    "dropkey": "BV15085",
    "droptype": "D",
    "dropname": "NORTH NEW HYDE PARK",
    "dropdeladd": "1568 UNION TPKE",
    "dropdelcty": "NEW HYDE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 110409994,
    "dropphyadd": "1568 UNION TPKE",
    "dropphycty": "NEW HYDE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 110409994,
    "dropmaladd": "1568 UNION TPKE",
    "dropmalcty": "NEW HYDE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 110409994,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5166166893,
    "dropfax": 5167755029
  },
  {
    "dcode": "D",
    "dropkey": "BV15106",
    "droptype": "D",
    "dropname": "NORTH TARRYTOWN",
    "dropdeladd": "45 BEEKMAN AVE",
    "dropdelcty": "SLEEPY HOLLOW",
    "dropdelst": "NY",
    "dropdelzpp": 105912655,
    "dropphyadd": "45 BEEKMAN AVE",
    "dropphycty": "SLEEPY HOLLOW",
    "dropphyst": "NY",
    "dropphyzpp": 105912655,
    "dropmaladd": "45 BEEKMAN AVE",
    "dropmalcty": "SLEEPY HOLLOW",
    "dropmalst": "NY",
    "dropmalzpp": 105912655,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146316480,
    "dropsitcph": 9146316480,
    "dropfax": 9146311646
  },
  {
    "dcode": "D",
    "dropkey": "BV15181",
    "droptype": "D",
    "dropname": "OCEANSIDE",
    "dropdeladd": "80 ATLANTIC AVE",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 115722044,
    "dropphyadd": "80 ATLANTIC AVE",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 115722044,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKVILLE CENTRE",
    "dropmalst": "NY",
    "dropmalzpp": 115719998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167667582,
    "dropfax": 5167667585
  },
  {
    "dcode": "D",
    "dropkey": "BV15190",
    "droptype": "D",
    "dropname": "OLD BETHPAGE",
    "dropdeladd": "696 OLD BETHPAGE RD",
    "dropdelcty": "OLD BETHPAGE",
    "dropdelst": "NY",
    "dropdelzpp": 118041200,
    "dropphyadd": "696 OLD BETHPAGE RD",
    "dropphycty": "OLD BETHPAGE",
    "dropphyst": "NY",
    "dropphyzpp": 118041200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 118029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162492915,
    "dropfax": 5162498934
  },
  {
    "dcode": "D",
    "dropkey": "BV15209",
    "droptype": "D",
    "dropname": "OLD VILLAGE",
    "dropdeladd": "661 MIDDLE NECK RD",
    "dropdelcty": "GREAT NECK",
    "dropdelst": "NY",
    "dropdelzpp": 110239997,
    "dropphyadd": "661 MIDDLE NECK RD",
    "dropphycty": "GREAT NECK",
    "dropphyst": "NY",
    "dropphyzpp": 110239997,
    "dropmaladd": "661 MIDDLE NECK RD",
    "dropmalcty": "GREAT NECK",
    "dropmalst": "NY",
    "dropmalzpp": 110239997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5167342988,
    "dropfax": 5167733541
  },
  {
    "dcode": "D",
    "dropkey": "BV15210",
    "droptype": "D",
    "dropname": "OLD WESTBURY",
    "dropdeladd": "1 STORE HILL RD UNIT B",
    "dropdelcty": "OLD WESTBURY",
    "dropdelst": "NY",
    "dropdelzpp": 115681234,
    "dropphyadd": "1 STORE HILL RD UNIT B",
    "dropphycty": "OLD WESTBURY",
    "dropphyst": "NY",
    "dropphyzpp": 115681234,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTBURY",
    "dropmalst": "NY",
    "dropmalzpp": 115909998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166265247,
    "dropfax": 5166261992
  },
  {
    "dcode": "D",
    "dropkey": "BV15225",
    "droptype": "D",
    "dropname": "ONONDAGA",
    "dropdeladd": "4912 W SENECA TPKE",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132159211,
    "dropphyadd": "4912 W SENECA TPKE",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132159211,
    "dropmaladd": "4912 W SENECA TPKE",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132159211,
    "dropsitphn": 3154921107,
    "dropsitlph": 3154921107,
    "dropsitcph": 3154921107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15300",
    "droptype": "D",
    "dropname": "PANORAMA",
    "dropdeladd": "1614 PENFIELD RD STE 2",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146259998,
    "dropphyadd": "1614 PENFIELD RD STE 2",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146259998,
    "dropmaladd": "1614 PENFIELD RD STE 2",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855869351,
    "dropsitcph": 5855869351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15347",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "26 1ST ST",
    "dropdelcty": "PELHAM",
    "dropdelst": "NY",
    "dropdelzpp": 108031834,
    "dropphyadd": "26 1ST ST",
    "dropphycty": "PELHAM",
    "dropphyst": "NY",
    "dropphyzpp": 108031834,
    "dropmaladd": "26 1ST ST",
    "dropmalcty": "PELHAM",
    "dropmalst": "NY",
    "dropmalzpp": 108031834,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147123790,
    "dropsitcph": 9147123790,
    "dropfax": 9147123792
  },
  {
    "dcode": "D",
    "dropkey": "BV15438",
    "droptype": "D",
    "dropname": "PLAINVIEW",
    "dropdeladd": "1662 OLD COUNTRY RD",
    "dropdelcty": "PLAINVIEW",
    "dropdelst": "NY",
    "dropdelzpp": 118035023,
    "dropphyadd": "1662 OLD COUNTRY RD",
    "dropphycty": "PLAINVIEW",
    "dropphyst": "NY",
    "dropphyzpp": 118035023,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "PLAINVIEW",
    "dropmalst": "NY",
    "dropmalzpp": 118039996,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5168457162,
    "dropfax": 5168457406
  },
  {
    "dcode": "D",
    "dropkey": "BV15442",
    "droptype": "D",
    "dropname": "PLANDOME",
    "dropdeladd": "155 STONYTOWN RD",
    "dropdelcty": "MANHASSET",
    "dropdelst": "NY",
    "dropdelzpp": 110309993,
    "dropphyadd": "155 STONYTOWN RD",
    "dropphycty": "MANHASSET",
    "dropphyst": "NY",
    "dropphyzpp": 110309993,
    "dropmaladd": "155 STONYTOWN RD",
    "dropmalcty": "MANHASSET",
    "dropmalst": "NY",
    "dropmalzpp": 110309993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5166273747,
    "dropfax": 5166275376
  },
  {
    "dcode": "D",
    "dropkey": "BV15501",
    "droptype": "D",
    "dropname": "PORT JEFFERSON",
    "dropdeladd": "407 E MAIN ST STE 17",
    "dropdelcty": "PORT JEFFERSON",
    "dropdelst": "NY",
    "dropdelzpp": 117771887,
    "dropphyadd": "407 E MAIN ST STE 17",
    "dropphycty": "PORT JEFFERSON",
    "dropphyst": "NY",
    "dropphyzpp": 117771887,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT JEFFERSON STATION",
    "dropmalst": "NY",
    "dropmalzpp": 117769998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314731065,
    "dropfax": 6319284632
  },
  {
    "dcode": "D",
    "dropkey": "BV15612",
    "droptype": "D",
    "dropname": "QUEENSBURY",
    "dropdeladd": "820 STATE ROUTE 9 STE 5B",
    "dropdelcty": "QUEENSBURY",
    "dropdelst": "NY",
    "dropdelzpp": 128043598,
    "dropphyadd": "820 STATE ROUTE 9 STE 5B",
    "dropphycty": "QUEENSBURY",
    "dropphyst": "NY",
    "dropphyzpp": 128043598,
    "dropmaladd": "16 HUDSON AVE",
    "dropmalcty": "GLENS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128019998,
    "dropsitphn": 5187454525,
    "dropsitlph": 5187454525,
    "dropsitcph": 5187454525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15698",
    "droptype": "D",
    "dropname": "RIDGEMONT",
    "dropdeladd": "2833 W RIDGE RD STE 28",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146269998,
    "dropphyadd": "2833 W RIDGE RD STE 28",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146269998,
    "dropmaladd": "2833 W RIDGE RD STE 28",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856633321,
    "dropsitcph": 5856633321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15774",
    "droptype": "D",
    "dropname": "ROESSLEVILLE",
    "dropdeladd": "35 FULLER RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122055120,
    "dropphyadd": "35 FULLER RD",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122055120,
    "dropmaladd": "35 FULLER RD",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122055120,
    "dropsitphn": 5184621359,
    "dropsitlph": 5184621359,
    "dropsitcph": 5184621359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV15981",
    "droptype": "D",
    "dropname": "SCOTCHTOWN",
    "dropdeladd": "731 ROUTE 211 E STE 103",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "NY",
    "dropdelzpp": 109411490,
    "dropphyadd": "731 ROUTE 211 E STE 103",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "NY",
    "dropphyzpp": 109411490,
    "dropmaladd": "40 FULTON ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "NY",
    "dropmalzpp": 109409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456922385,
    "dropsitcph": 8456922385,
    "dropfax": 8456920865
  },
  {
    "dcode": "D",
    "dropkey": "BV15982",
    "droptype": "D",
    "dropname": "SCOTIA",
    "dropdeladd": "224 MOHAWK AVE",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123029918,
    "dropphyadd": "224 MOHAWK AVE",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123029918,
    "dropmaladd": "224 MOHAWK AVE",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123029918,
    "dropsitphn": 5183771297,
    "dropsitlph": 5183771297,
    "dropsitcph": 5183771297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV16019",
    "droptype": "D",
    "dropname": "SETAUKET",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "SETAUKET",
    "dropdelst": "NY",
    "dropdelzpp": 117339991,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "SETAUKET",
    "dropphyst": "NY",
    "dropphyzpp": 117339991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SETAUKET",
    "dropmalst": "NY",
    "dropmalzpp": 117339998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319414042,
    "dropfax": 6316892173
  },
  {
    "dcode": "D",
    "dropkey": "BV16147",
    "droptype": "D",
    "dropname": "SOLVAY",
    "dropdeladd": "1801 MILTON AVE",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132099211,
    "dropphyadd": "1801 MILTON AVE",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132099211,
    "dropmaladd": "1801 MILTON AVE",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132099211,
    "dropsitphn": 3154684795,
    "dropsitlph": 3154684795,
    "dropsitcph": 3154684795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV16182",
    "droptype": "D",
    "dropname": "SOUTH FARMINGDALE",
    "dropdeladd": "918 MAIN ST STE 13",
    "dropdelcty": "FARMINGDALE",
    "dropdelst": "NY",
    "dropdelzpp": 117355426,
    "dropphyadd": "918 MAIN ST STE 13",
    "dropphycty": "FARMINGDALE",
    "dropphyst": "NY",
    "dropphyzpp": 117355426,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGDALE",
    "dropmalst": "NY",
    "dropmalzpp": 117359998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162491573,
    "dropfax": 5162494497
  },
  {
    "dcode": "D",
    "dropkey": "BV16219",
    "droptype": "D",
    "dropname": "SOUTH ROAD",
    "dropdeladd": "2572 SOUTH RD",
    "dropdelcty": "POUGHKEEPSIE",
    "dropdelst": "NY",
    "dropdelzpp": 126015341,
    "dropphyadd": "2572 SOUTH RD",
    "dropphycty": "POUGHKEEPSIE",
    "dropphyst": "NY",
    "dropphyzpp": 126015341,
    "dropmaladd": "2572 SOUTH RD",
    "dropmalcty": "POUGHKEEPSIE",
    "dropmalst": "NY",
    "dropmalzpp": 126015341,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454523970,
    "dropsitcph": 8454523970,
    "dropfax": 8454523955
  },
  {
    "dcode": "D",
    "dropkey": "BV16578",
    "droptype": "D",
    "dropname": "TUCKAHOE",
    "dropdeladd": "7 COLUMBUS AVE",
    "dropdelcty": "TUCKAHOE",
    "dropdelst": "NY",
    "dropdelzpp": 107072518,
    "dropphyadd": "7 COLUMBUS AVE",
    "dropphycty": "TUCKAHOE",
    "dropphyst": "NY",
    "dropphyzpp": 107072518,
    "dropmaladd": "7 COLUMBUS AVE",
    "dropmalcty": "TUCKAHOE",
    "dropmalst": "NY",
    "dropmalzpp": 107072518,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147797128,
    "dropsitcph": 9147797128,
    "dropfax": 9143371349
  },
  {
    "dcode": "D",
    "dropkey": "BV16587",
    "droptype": "D",
    "dropname": "LOEHMANNS PLAZA",
    "dropdeladd": "1900 S CLINTON AVE STE 25",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146189998,
    "dropphyadd": "1900 S CLINTON AVE STE 25",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146189998,
    "dropmaladd": "1900 S CLINTON AVE STE 25",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146189998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854736493,
    "dropsitcph": 5854736493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV16697",
    "droptype": "D",
    "dropname": "VETERANS ADMINISTRATION",
    "dropdeladd": "76 VETERANS AVE",
    "dropdelcty": "BATH",
    "dropdelst": "NY",
    "dropdelzpp": 148100840,
    "dropphyadd": "76 VETERANS AVE",
    "dropphycty": "BATH",
    "dropphyst": "NY",
    "dropphyzpp": 148100840,
    "dropmaladd": "76 VETERANS AVE",
    "dropmalcty": "BATH",
    "dropmalst": "NY",
    "dropmalzpp": 148100840,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077762111,
    "dropsitcph": 6077762111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV16941",
    "droptype": "D",
    "dropname": "WEST SENECA",
    "dropdeladd": "4300 SENECA ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142249998,
    "dropphyadd": "4300 SENECA ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142249998,
    "dropmaladd": "4300 SENECA ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166753672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV16975",
    "droptype": "D",
    "dropname": "WESTGATE",
    "dropdeladd": "1485 HOWARD RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146249998,
    "dropphyadd": "1485 HOWARD RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146249998,
    "dropmaladd": "1485 HOWARD RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133215,
    "dropsitcph": 5856133215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV17001",
    "droptype": "D",
    "dropname": "WHEATLEY HEIGHTS",
    "dropdeladd": "6 COLONIAL SPRINGS RD",
    "dropdelcty": "WYANDANCH",
    "dropdelst": "NY",
    "dropdelzpp": 117981075,
    "dropphyadd": "6 COLONIAL SPRINGS RD",
    "dropphycty": "WYANDANCH",
    "dropphyst": "NY",
    "dropphyzpp": 117981075,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYANDANCH",
    "dropmalst": "NY",
    "dropmalzpp": 117989998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316432912,
    "dropfax": 6316430411
  },
  {
    "dcode": "D",
    "dropkey": "BV17041",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE",
    "dropdeladd": "5325 SHERIDAN DR",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142219998,
    "dropphyadd": "5325 SHERIDAN DR",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142219998,
    "dropmaladd": "5325 SHERIDAN DR",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142219998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166320421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV17152",
    "droptype": "D",
    "dropname": "BAYAMON",
    "dropdeladd": "100 AVE RAMON L RODRIGUEZ",
    "dropdelcty": "BAYAMON",
    "dropdelst": "PR",
    "dropdelzpp": "009599998",
    "dropphyadd": "100 AVE RAMON L RODRIGUEZ",
    "dropphycty": "BAYAMON",
    "dropphyst": "PR",
    "dropphyzpp": "009599998",
    "dropmaladd": "100 AVE RAMON L RODRIGUEZ",
    "dropmalcty": "BAYAMON",
    "dropmalst": "PR",
    "dropmalzpp": "009599998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877850415,
    "dropfax": 7877854741
  },
  {
    "dcode": "D",
    "dropkey": "BV17167",
    "droptype": "D",
    "dropname": "CATANO",
    "dropdeladd": "131 AVE BARBOSA",
    "dropdelcty": "CATANO",
    "dropdelst": "PR",
    "dropdelzpp": "009629998",
    "dropphyadd": "131 AVE BARBOSA",
    "dropphycty": "CATANO",
    "dropphyst": "PR",
    "dropphyzpp": "009629998",
    "dropmaladd": "131 AVE BARBOSA",
    "dropmalcty": "CATANO",
    "dropmalst": "PR",
    "dropmalzpp": "009629998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877880279,
    "dropfax": 7877885810
  },
  {
    "dcode": "D",
    "dropkey": "BV17189",
    "droptype": "D",
    "dropname": "FORT BUCHANAN",
    "dropdeladd": "1505 AVE FD ROOSEVELT STE 100",
    "dropdelcty": "GUAYNABO",
    "dropdelst": "PR",
    "dropdelzpp": "009689998",
    "dropphyadd": "1505 AVE FD ROOSEVELT STE 100",
    "dropphycty": "GUAYNABO",
    "dropphyst": "PR",
    "dropphyzpp": "009689998",
    "dropmaladd": "1505 AVE FD ROOSEVELT STE 100",
    "dropmalcty": "GUAYNABO",
    "dropmalst": "PR",
    "dropmalzpp": "009689998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7676221659,
    "dropsitcph": 7877073390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV17240",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "23 CALLE PRINCIPAL",
    "dropdelcty": "PALMER",
    "dropdelst": "PR",
    "dropdelzpp": "007219997",
    "dropphyadd": "23 CALLE PRINCIPAL",
    "dropphycty": "PALMER",
    "dropphyst": "PR",
    "dropphyzpp": "007219997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMER",
    "dropmalst": "PR",
    "dropmalzpp": "007219998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878872112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV17287",
    "droptype": "D",
    "dropname": "TRUJILLO ALTO",
    "dropdeladd": "100 CALLE BORINQUEN",
    "dropdelcty": "TRUJILLO ALTO",
    "dropdelst": "PR",
    "dropdelzpp": "009769998",
    "dropphyadd": "100 CALLE BORINQUEN",
    "dropphycty": "TRUJILLO ALTO",
    "dropphyst": "PR",
    "dropphyzpp": "009769998",
    "dropmaladd": "100 CALLE BORINQUEN",
    "dropmalcty": "TRUJILLO ALTO",
    "dropmalst": "PR",
    "dropmalzpp": "009769998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877611825,
    "dropfax": 7872833565
  },
  {
    "dcode": "D",
    "dropkey": "BV18865",
    "droptype": "D",
    "dropname": "BAYAMON GDNS",
    "dropdeladd": "100 VICTORY SHOPP CTR STE 1",
    "dropdelcty": "BAYAMON",
    "dropdelst": "PR",
    "dropdelzpp": "009579998",
    "dropphyadd": "100 VICTORY SHOPP CTR STE 1",
    "dropphycty": "BAYAMON",
    "dropphyst": "PR",
    "dropphyzpp": "009579998",
    "dropmaladd": "100 VICTORY SHOPP CTR STE 1",
    "dropmalcty": "BAYAMON",
    "dropmalst": "PR",
    "dropmalzpp": "009579998",
    "dropsitphn": 7877872235,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877872235,
    "dropfax": 7877808894
  },
  {
    "dcode": "D",
    "dropkey": "BV18874",
    "droptype": "D",
    "dropname": "COLONIE CENTER",
    "dropdeladd": "1425 CENTRAL AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122052702,
    "dropphyadd": "1425 CENTRAL AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122052702,
    "dropmaladd": "PO BOX 50001",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122059997,
    "dropsitphn": 5184587217,
    "dropsitlph": 5184587217,
    "dropsitcph": 5184587217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV19081",
    "droptype": "D",
    "dropname": "ROTTERDAM SQUARE",
    "dropdeladd": "93 W CAMPBELL RD",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123066890,
    "dropphyadd": "93 W CAMPBELL RD",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123066890,
    "dropmaladd": "1976 SCHUYLER ST",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123039998,
    "dropsitphn": 5183701726,
    "dropsitlph": 5183701726,
    "dropsitcph": 5183701726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV19215",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "1560 STATE ROUTE 332",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 144259998,
    "dropphyadd": "1560 STATE ROUTE 332",
    "dropphycty": "FARMINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 144259998,
    "dropmaladd": "1560 STATE ROUTE 332",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 144259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853983830,
    "dropsitcph": 5853983830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV19610",
    "droptype": "D",
    "dropname": "ROOSEVELT ROADS",
    "dropdeladd": "1759 FORRESTAL DR",
    "dropdelcty": "ROOSEVELT ROADS",
    "dropdelst": "PR",
    "dropdelzpp": "007429800",
    "dropphyadd": "1759 FORRESTAL DR",
    "dropphycty": "ROOSEVELT ROADS",
    "dropphyst": "PR",
    "dropphyzpp": "007429800",
    "dropmaladd": "1759 FORRESTAL DR",
    "dropmalcty": "ROOSEVELT ROADS",
    "dropmalst": "PR",
    "dropmalzpp": "007429800",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878652197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV19934",
    "droptype": "D",
    "dropname": "COAST GUARD BASE",
    "dropdeladd": "1 MUNRO AVE",
    "dropdelcty": "CAPE MAY",
    "dropdelst": "NJ",
    "dropdelzpp": "082049997",
    "dropphyadd": "1 MUNRO AVE",
    "dropphycty": "CAPE MAY",
    "dropphyst": "NJ",
    "dropphyzpp": "082049997",
    "dropmaladd": "1 MUNRO AVE",
    "dropmalcty": "CAPE MAY",
    "dropmalst": "NJ",
    "dropmalzpp": "082049997",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098843578,
    "dropsitcph": 6098843578,
    "dropfax": 6098862313
  },
  {
    "dcode": "D",
    "dropkey": "BV20008",
    "droptype": "D",
    "dropname": "ALLINGTOWN",
    "dropdeladd": "75 FARWELL ST",
    "dropdelcty": "WEST HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065169998",
    "dropphyadd": "75 FARWELL ST",
    "dropphycty": "WEST HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065169998",
    "dropmaladd": "75 FARWELL ST",
    "dropmalcty": "WEST HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065169998",
    "dropsitphn": 2039377718,
    "dropsitlph": 2039377718,
    "dropsitcph": 2039377718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20033",
    "droptype": "D",
    "dropname": "BAYBROOK STATION",
    "dropdeladd": "14 OCEAN AVE",
    "dropdelcty": "WEST HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065169991",
    "dropphyadd": "14 OCEAN AVE",
    "dropphycty": "WEST HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065169991",
    "dropmaladd": "14 OCEAN AVE",
    "dropmalcty": "WEST HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065169991",
    "dropsitphn": 2039310899,
    "dropsitlph": 2039310899,
    "dropsitcph": 2039310899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20041",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "780 WORTHINGTON RDG",
    "dropdelcty": "BERLIN",
    "dropdelst": "CT",
    "dropdelzpp": "060379991",
    "dropphyadd": "780 WORTHINGTON RDG",
    "dropphycty": "BERLIN",
    "dropphyst": "CT",
    "dropphyzpp": "060379991",
    "dropmaladd": "62 KENSINGTON RD",
    "dropmalcty": "BERLIN",
    "dropmalst": "CT",
    "dropmalzpp": "060379992",
    "dropsitphn": 8608284768,
    "dropsitlph": 8608284768,
    "dropsitcph": 8608294277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20047",
    "droptype": "D",
    "dropname": "BISHOPS CORNER",
    "dropdeladd": "12 CROSSROADS PLZ",
    "dropdelcty": "WEST HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061179998",
    "dropphyadd": "12 CROSSROADS PLZ",
    "dropphycty": "WEST HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061179998",
    "dropmaladd": "12 CROSSROADS PLZ",
    "dropmalcty": "WEST HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061179998",
    "dropsitphn": 8602312871,
    "dropsitlph": 8602312871,
    "dropsitcph": 8602312872,
    "dropfax": 8602312895
  },
  {
    "dcode": "D",
    "dropkey": "BV20057",
    "droptype": "D",
    "dropname": "BOLTON",
    "dropdeladd": "681 BOSTON TPKE",
    "dropdelcty": "BOLTON",
    "dropdelst": "CT",
    "dropdelzpp": "060439993",
    "dropphyadd": "681 BOSTON TPKE",
    "dropphycty": "BOLTON",
    "dropphyst": "CT",
    "dropphyzpp": "060439993",
    "dropmaladd": "681 BOSTON TPKE",
    "dropmalcty": "BOLTON",
    "dropmalst": "CT",
    "dropmalzpp": "060439993",
    "dropsitphn": 8606434872,
    "dropsitlph": 8606434872,
    "dropsitcph": 8606434872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20091",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "715 GEORGE WASHINGTON TPKE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "060139998",
    "dropphyadd": "715 GEORGE WASHINGTON TPKE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "060139998",
    "dropmaladd": "715 GEORGE WASHINGTON TPKE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "060139998",
    "dropsitphn": 8606756339,
    "dropsitlph": 8606756339,
    "dropsitcph": 8606756339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20191",
    "droptype": "D",
    "dropname": "EAST HARTFORD",
    "dropdeladd": "850 MAIN ST",
    "dropdelcty": "EAST HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061089998",
    "dropphyadd": "850 MAIN ST",
    "dropphycty": "EAST HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061089998",
    "dropmaladd": "850 MAIN ST",
    "dropmalcty": "EAST HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061089998",
    "dropsitphn": 8605286529,
    "dropsitlph": 8605286529,
    "dropsitcph": 8605286529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20207",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "295 CENTER RD",
    "dropdelcty": "EASTON",
    "dropdelst": "CT",
    "dropdelzpp": "066129998",
    "dropphyadd": "295 CENTER RD",
    "dropphycty": "EASTON",
    "dropphyst": "CT",
    "dropphyzpp": "066129998",
    "dropmaladd": "295 CENTER RD",
    "dropmalcty": "EASTON",
    "dropmalst": "CT",
    "dropmalzpp": "066129998",
    "dropsitphn": 2032618386,
    "dropsitlph": 2032618386,
    "dropsitcph": 2032618386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20281",
    "droptype": "D",
    "dropname": "HAMDEN",
    "dropdeladd": "1744 DIXWELL AVE",
    "dropdelcty": "HAMDEN",
    "dropdelst": "CT",
    "dropdelzpp": "065149998",
    "dropphyadd": "1744 DIXWELL AVE",
    "dropphycty": "HAMDEN",
    "dropphyst": "CT",
    "dropphyzpp": "065149998",
    "dropmaladd": "1744 DIXWELL AVE",
    "dropmalcty": "HAMDEN",
    "dropmalst": "CT",
    "dropmalzpp": "065149998",
    "dropsitphn": 2032814573,
    "dropsitlph": 2032814573,
    "dropsitcph": 2032814573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20292",
    "droptype": "D",
    "dropname": "HARWINTON",
    "dropdeladd": "122 LITCHFIELD RD STE 2",
    "dropdelcty": "HARWINTON",
    "dropdelst": "CT",
    "dropdelzpp": "067919991",
    "dropphyadd": "122 LITCHFIELD RD STE 2",
    "dropphycty": "HARWINTON",
    "dropphyst": "CT",
    "dropphyzpp": "067919991",
    "dropmaladd": "122 LITCHFIELD RD STE 2",
    "dropmalcty": "HARWINTON",
    "dropmalst": "CT",
    "dropmalzpp": "067919991",
    "dropsitphn": 8604851935,
    "dropsitlph": 8604851935,
    "dropsitcph": 8604851935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20340",
    "droptype": "D",
    "dropname": "LEDYARD",
    "dropdeladd": "764 COLONEL LEDYARD HWY",
    "dropdelcty": "LEDYARD",
    "dropdelst": "CT",
    "dropdelzpp": "063399998",
    "dropphyadd": "764 COLONEL LEDYARD HWY",
    "dropphycty": "LEDYARD",
    "dropphyst": "CT",
    "dropphyzpp": "063399998",
    "dropmaladd": "764 COLONEL LEDYARD HWY",
    "dropmalcty": "LEDYARD",
    "dropmalst": "CT",
    "dropmalzpp": "063399998",
    "dropsitphn": 8604643147,
    "dropsitlph": 8604643147,
    "dropsitcph": 8604643147,
    "dropfax": 8604643149
  },
  {
    "dcode": "D",
    "dropkey": "BV20370",
    "droptype": "D",
    "dropname": "MARLBOROUGH",
    "dropdeladd": "16 E HAMPTON RD",
    "dropdelcty": "MARLBOROUGH",
    "dropdelst": "CT",
    "dropdelzpp": "064479992",
    "dropphyadd": "16 E HAMPTON RD",
    "dropphycty": "MARLBOROUGH",
    "dropphyst": "CT",
    "dropphyzpp": "064479992",
    "dropmaladd": "16 E HAMPTON RD",
    "dropmalcty": "MARLBOROUGH",
    "dropmalst": "CT",
    "dropmalzpp": "064479992",
    "dropsitphn": 8602672094,
    "dropsitlph": 8602672094,
    "dropsitcph": 8602950057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20419",
    "droptype": "D",
    "dropname": "NEW FAIRFIELD",
    "dropdeladd": "7 BRUSH HILL RD",
    "dropdelcty": "NEW FAIRFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068129998",
    "dropphyadd": "7 BRUSH HILL RD",
    "dropphycty": "NEW FAIRFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068129998",
    "dropmaladd": "7 BRUSH HILL RD",
    "dropmalcty": "NEW FAIRFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068129998",
    "dropsitphn": 2037467911,
    "dropsitlph": 2037467911,
    "dropsitcph": 2037467911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20435",
    "droptype": "D",
    "dropname": "NEWINGTON",
    "dropdeladd": "75 LOWREY PL",
    "dropdelcty": "NEWINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "061119998",
    "dropphyadd": "75 LOWREY PL",
    "dropphycty": "NEWINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "061119998",
    "dropmaladd": "75 LOWREY PL",
    "dropmalcty": "NEWINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "061119998",
    "dropsitphn": 8606668436,
    "dropsitlph": 8606668436,
    "dropsitcph": 8606668436,
    "dropfax": 8606657280
  },
  {
    "dcode": "D",
    "dropkey": "BV20505",
    "droptype": "D",
    "dropname": "PAWCATUCK",
    "dropdeladd": "66 S BROAD ST",
    "dropdelcty": "PAWCATUCK",
    "dropdelst": "CT",
    "dropdelzpp": "063799998",
    "dropphyadd": "66 S BROAD ST",
    "dropphycty": "PAWCATUCK",
    "dropphyst": "CT",
    "dropphyzpp": "063799998",
    "dropmaladd": "66 S BROAD ST",
    "dropmalcty": "PAWCATUCK",
    "dropmalst": "CT",
    "dropmalzpp": "063799998",
    "dropsitphn": 8605996980,
    "dropsitlph": 8605996980,
    "dropsitcph": 8605996980,
    "dropfax": 8605996983
  },
  {
    "dcode": "D",
    "dropkey": "BV20544",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "70 WATERBURY RD",
    "dropdelcty": "PROSPECT",
    "dropdelst": "CT",
    "dropdelzpp": "067129998",
    "dropphyadd": "70 WATERBURY RD",
    "dropphycty": "PROSPECT",
    "dropphyst": "CT",
    "dropphyzpp": "067129998",
    "dropmaladd": "70 WATERBURY RD",
    "dropmalcty": "PROSPECT",
    "dropmalst": "CT",
    "dropmalzpp": "067129998",
    "dropsitphn": 2037584771,
    "dropsitlph": 2037584771,
    "dropsitcph": 2037584771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20601",
    "droptype": "D",
    "dropname": "SHIELD STREET",
    "dropdeladd": "121 SHIELD ST",
    "dropdelcty": "WEST HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061109998",
    "dropphyadd": "121 SHIELD ST",
    "dropphycty": "WEST HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061109998",
    "dropmaladd": "121 SHIELD ST",
    "dropmalcty": "WEST HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061109998",
    "dropsitphn": 8609534920,
    "dropsitlph": 8609534920,
    "dropsitcph": 8609534920,
    "dropfax": 8609530121
  },
  {
    "dcode": "D",
    "dropkey": "BV20603",
    "droptype": "D",
    "dropname": "SILVER LANE",
    "dropdeladd": "888 SILVER LN",
    "dropdelcty": "EAST HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061189998",
    "dropphyadd": "888 SILVER LN",
    "dropphycty": "EAST HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061189998",
    "dropmaladd": "888 SILVER LN",
    "dropmalcty": "EAST HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061189998",
    "dropsitphn": 8605698633,
    "dropsitlph": 8605698633,
    "dropsitcph": 8605698633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20685",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "3100 MAIN ST",
    "dropdelcty": "STRATFORD",
    "dropdelst": "CT",
    "dropdelzpp": "066149998",
    "dropphyadd": "3100 MAIN ST",
    "dropphycty": "STRATFORD",
    "dropphyst": "CT",
    "dropphyzpp": "066149998",
    "dropmaladd": "3100 MAIN ST",
    "dropmalcty": "STRATFORD",
    "dropmalst": "CT",
    "dropmalzpp": "066149998",
    "dropsitphn": 2033801880,
    "dropsitlph": 2033801880,
    "dropsitcph": 2033801880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20719",
    "droptype": "D",
    "dropname": "TROLLEY SQUARE",
    "dropdeladd": "175 MAIN ST STE 2",
    "dropdelcty": "EAST HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065123099",
    "dropphyadd": "175 MAIN ST STE 2",
    "dropphycty": "EAST HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065123099",
    "dropmaladd": "175 MAIN ST STE 2",
    "dropmalcty": "EAST HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065123099",
    "dropsitphn": 2034699071,
    "dropsitlph": 2034699071,
    "dropsitcph": 2034699071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20720",
    "droptype": "D",
    "dropname": "TRUMBULL",
    "dropdeladd": "50 QUALITY ST",
    "dropdelcty": "TRUMBULL",
    "dropdelst": "CT",
    "dropdelzpp": "066119998",
    "dropphyadd": "50 QUALITY ST",
    "dropphycty": "TRUMBULL",
    "dropphyst": "CT",
    "dropphyzpp": "066119998",
    "dropmaladd": "50 QUALITY ST",
    "dropmalcty": "TRUMBULL",
    "dropmalst": "CT",
    "dropmalzpp": "066119998",
    "dropsitphn": 2032682978,
    "dropsitlph": 2032682978,
    "dropsitcph": 2032682978,
    "dropfax": 2032685937
  },
  {
    "dcode": "D",
    "dropkey": "BV20752",
    "droptype": "D",
    "dropname": "WEST HARTFORD",
    "dropdeladd": "102 LASALLE RD",
    "dropdelcty": "WEST HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061079992",
    "dropphyadd": "102 LASALLE RD",
    "dropphycty": "WEST HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061079992",
    "dropmaladd": "102 LASALLE RD",
    "dropmalcty": "WEST HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061079992",
    "dropsitphn": 8602312865,
    "dropsitlph": 8602312865,
    "dropsitcph": 8602312865,
    "dropfax": 8602312868
  },
  {
    "dcode": "D",
    "dropkey": "BV20801",
    "droptype": "D",
    "dropname": "WEST HAVEN",
    "dropdeladd": "589 CAMPBELL AVE",
    "dropdelcty": "WEST HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065169992",
    "dropphyadd": "589 CAMPBELL AVE",
    "dropphycty": "WEST HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065169992",
    "dropmaladd": "589 CAMPBELL AVE",
    "dropmalcty": "WEST HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065169992",
    "dropsitphn": 2039319812,
    "dropsitlph": 2039319812,
    "dropsitcph": 2039319812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20803",
    "droptype": "D",
    "dropname": "WEST MYSTIC",
    "dropdeladd": "55 W MYSTIC AVE",
    "dropdelcty": "WEST MYSTIC",
    "dropdelst": "CT",
    "dropdelzpp": "063889992",
    "dropphyadd": "55 W MYSTIC AVE",
    "dropphycty": "WEST MYSTIC",
    "dropphyst": "CT",
    "dropphyzpp": "063889992",
    "dropmaladd": "55 W MYSTIC AVE",
    "dropmalcty": "WEST MYSTIC",
    "dropmalst": "CT",
    "dropmalzpp": "063889992",
    "dropsitphn": 8605360530,
    "dropsitlph": 8605360530,
    "dropsitcph": 8605360530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20814",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "190 WESTON RD STE 1",
    "dropdelcty": "WESTON",
    "dropdelst": "CT",
    "dropdelzpp": "068839991",
    "dropphyadd": "190 WESTON RD STE 1",
    "dropphycty": "WESTON",
    "dropphyst": "CT",
    "dropphyzpp": "068839991",
    "dropmaladd": "190 WESTON RD STE 1",
    "dropmalcty": "WESTON",
    "dropmalst": "CT",
    "dropmalzpp": "068839991",
    "dropsitphn": 2032271605,
    "dropsitlph": 8602271605,
    "dropsitcph": 2032271605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20819",
    "droptype": "D",
    "dropname": "WETHERSFIELD",
    "dropdeladd": "67 BEAVER RD",
    "dropdelcty": "WETHERSFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "061099998",
    "dropphyadd": "67 BEAVER RD",
    "dropphycty": "WETHERSFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "061099998",
    "dropmaladd": "67 BEAVER RD",
    "dropmalcty": "WETHERSFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "061099998",
    "dropsitphn": 8607210821,
    "dropsitlph": 8607210821,
    "dropsitcph": 8605631941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20822",
    "droptype": "D",
    "dropname": "WHITNEYVILLE",
    "dropdeladd": "40 PUTNAM AVE",
    "dropdelcty": "HAMDEN",
    "dropdelst": "CT",
    "dropdelzpp": "065179998",
    "dropphyadd": "40 PUTNAM AVE",
    "dropphycty": "HAMDEN",
    "dropphyst": "CT",
    "dropphyzpp": "065179998",
    "dropmaladd": "40 PUTNAM AVE",
    "dropmalcty": "HAMDEN",
    "dropmalst": "CT",
    "dropmalzpp": "065179998",
    "dropsitphn": 2032304712,
    "dropsitlph": 2032304712,
    "dropsitcph": 2032304712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20842",
    "droptype": "D",
    "dropname": "WOLCOTT",
    "dropdeladd": "803 WOLCOTT RD",
    "dropdelcty": "WOLCOTT",
    "dropdelst": "CT",
    "dropdelzpp": "067169998",
    "dropphyadd": "803 WOLCOTT RD",
    "dropphycty": "WOLCOTT",
    "dropphyst": "CT",
    "dropphyzpp": "067169998",
    "dropmaladd": "803 WOLCOTT RD",
    "dropmalcty": "WOLCOTT",
    "dropmalst": "CT",
    "dropmalzpp": "067169998",
    "dropsitphn": 2038791557,
    "dropsitlph": 2038791557,
    "dropsitcph": 2038791557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV20956",
    "droptype": "D",
    "dropname": "DULLES",
    "dropdeladd": "45005 AVIATION DR STE 120",
    "dropdelcty": "STERLING",
    "dropdelst": "VA",
    "dropdelzpp": 201667533,
    "dropphyadd": "45005 AVIATION DR STE 120",
    "dropphycty": "STERLING",
    "dropphyst": "VA",
    "dropphyzpp": 201667533,
    "dropmaladd": "PO BOX 17000",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200417000,
    "dropsitphn": 3014997331,
    "dropsitlph": 7034711777,
    "dropsitcph": 7034711777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21084",
    "droptype": "D",
    "dropname": "NAVY ANNEX",
    "dropdeladd": "2 NAVY ANX",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 203700002,
    "dropphyadd": "2 NAVY ANX",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 203700002,
    "dropmaladd": "2 NAVY ANX",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 203700002,
    "dropsitphn": 3014997331,
    "dropsitlph": 7032716285,
    "dropsitcph": 7036142049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21101",
    "droptype": "D",
    "dropname": "PENTAGON",
    "dropdeladd": "9998 THE PENTAGON",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 203019998,
    "dropphyadd": "9998 THE PENTAGON",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 203019998,
    "dropmaladd": "9998 THE PENTAGON",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 203019998,
    "dropsitphn": 3014997331,
    "dropsitlph": 7036956835,
    "dropsitcph": 7036956835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21250",
    "droptype": "D",
    "dropname": "DOVER AFB",
    "dropdeladd": "442 13TH ST",
    "dropdelcty": "DOVER AFB",
    "dropdelst": "DE",
    "dropdelzpp": 199029998,
    "dropphyadd": "442 13TH ST",
    "dropphycty": "DOVER AFB",
    "dropphyst": "DE",
    "dropphyzpp": 199029998,
    "dropmaladd": "442 13TH ST",
    "dropmalcty": "DOVER AFB",
    "dropmalst": "DE",
    "dropmalzpp": 199029998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3026776196,
    "dropsitcph": 3026776196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21254",
    "droptype": "D",
    "dropname": "EDGEMOOR",
    "dropdeladd": "4901 GOVERNOR PRINTZ BLVD",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198099998,
    "dropphyadd": "4901 GOVERNOR PRINTZ BLVD",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198099998,
    "dropmaladd": "4901 GOVERNOR PRINTZ BLVD",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198099998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027621833,
    "dropfax": 3027621240
  },
  {
    "dcode": "D",
    "dropkey": "BV21281",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "3801 KENNETT PIKE STE A101",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198079998,
    "dropphyadd": "3801 KENNETT PIKE STE A101",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198079998,
    "dropmaladd": "3801 KENNETT PIKE STE A101",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198079998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026525449,
    "dropfax": 3027771679
  },
  {
    "dcode": "D",
    "dropkey": "BV21312",
    "droptype": "D",
    "dropname": "MANOR",
    "dropdeladd": "100 MCMULLEN AVE",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "DE",
    "dropdelzpp": 197209996,
    "dropphyadd": "100 MCMULLEN AVE",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "DE",
    "dropphyzpp": 197209996,
    "dropmaladd": "100 MCMULLEN AVE",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "DE",
    "dropmalzpp": 197209996,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023285893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21314",
    "droptype": "D",
    "dropname": "MARSHALLTON",
    "dropdeladd": "3434 OLD CAPITOL TRL",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198089998,
    "dropphyadd": "3434 OLD CAPITOL TRL",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198089998,
    "dropmaladd": "3434 OLD CAPITOL TRL",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198089998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3029981168,
    "dropfax": 3029988054
  },
  {
    "dcode": "D",
    "dropkey": "BV21392",
    "droptype": "D",
    "dropname": "ACCORD",
    "dropdeladd": "28 WHITING ST",
    "dropdelcty": "HINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020439991",
    "dropphyadd": "28 WHITING ST",
    "dropphycty": "HINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020439991",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ACCORD",
    "dropmalst": "MA",
    "dropmalzpp": "020189998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817494763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21395",
    "droptype": "D",
    "dropname": "ACUSHNET",
    "dropdeladd": "178 S MAIN ST",
    "dropdelcty": "ACUSHNET",
    "dropdelst": "MA",
    "dropdelzpp": "027439998",
    "dropphyadd": "178 S MAIN ST",
    "dropphycty": "ACUSHNET",
    "dropphyst": "MA",
    "dropphyzpp": "027439998",
    "dropmaladd": "178 S MAIN ST",
    "dropmalcty": "ACUSHNET",
    "dropmalst": "MA",
    "dropmalzpp": "027439998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089951694,
    "dropfax": 5089952786
  },
  {
    "dcode": "D",
    "dropkey": "BV21417",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "10 COURT ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "024769998",
    "dropphyadd": "10 COURT ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "024769998",
    "dropmaladd": "10 COURT ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "024769998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7816485376,
    "dropfax": 7816485176
  },
  {
    "dcode": "D",
    "dropkey": "BV21442",
    "droptype": "D",
    "dropname": "AUBURNDALE",
    "dropdeladd": "2122 COMMONWEALTH AVE",
    "dropdelcty": "AUBURNDALE",
    "dropdelst": "MA",
    "dropdelzpp": "024669998",
    "dropphyadd": "2122 COMMONWEALTH AVE",
    "dropphycty": "AUBURNDALE",
    "dropphyst": "MA",
    "dropphyzpp": "024669998",
    "dropmaladd": "2122 COMMONWEALTH AVE",
    "dropmalcty": "AUBURNDALE",
    "dropmalst": "MA",
    "dropmalzpp": "024669998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175271970,
    "dropfax": 6175273567
  },
  {
    "dcode": "D",
    "dropkey": "BV21445",
    "droptype": "D",
    "dropname": "BABSON PARK",
    "dropdeladd": "231 FOREST ST",
    "dropdelcty": "WELLESLEY HILLS",
    "dropdelst": "MA",
    "dropdelzpp": "024816834",
    "dropphyadd": "231 FOREST ST",
    "dropphycty": "WELLESLEY HILLS",
    "dropphyst": "MA",
    "dropphyzpp": "024816834",
    "dropmaladd": "PO BOX 579998",
    "dropmalcty": "BABSON PARK",
    "dropmalst": "MA",
    "dropmalzpp": "024579998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812354376,
    "dropfax": 7812358526
  },
  {
    "dcode": "D",
    "dropkey": "BV21466",
    "droptype": "D",
    "dropname": "BEACH",
    "dropdeladd": "151 VFW PKWY STE 3",
    "dropdelcty": "REVERE",
    "dropdelst": "MA",
    "dropdelzpp": "021519991",
    "dropphyadd": "151 VFW PKWY STE 3",
    "dropphycty": "REVERE",
    "dropphyst": "MA",
    "dropphyzpp": "021519991",
    "dropmaladd": "151 VFW PKWY STE 3",
    "dropmalcty": "REVERE",
    "dropmalst": "MA",
    "dropmalzpp": "021519991",
    "dropsitphn": 6178844048,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812842056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21476",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "405 CONCORD AVE",
    "dropdelcty": "BELMONT",
    "dropdelst": "MA",
    "dropdelzpp": "024789998",
    "dropphyadd": "405 CONCORD AVE",
    "dropphycty": "BELMONT",
    "dropphyst": "MA",
    "dropphyzpp": "024789998",
    "dropmaladd": "405 CONCORD AVE",
    "dropmalcty": "BELMONT",
    "dropmalst": "MA",
    "dropmalzpp": "024789998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174844201,
    "dropfax": 6174899488
  },
  {
    "dcode": "D",
    "dropkey": "BV21511",
    "droptype": "D",
    "dropname": "BOSTON COLLEGE",
    "dropdeladd": "136 COMMONWEALTH AVE",
    "dropdelcty": "CHESTNUT HILL",
    "dropdelst": "MA",
    "dropdelzpp": "024679991",
    "dropphyadd": "136 COMMONWEALTH AVE",
    "dropphycty": "CHESTNUT HILL",
    "dropphyst": "MA",
    "dropphyzpp": "024679991",
    "dropmaladd": "136 COMMONWEALTH AVE",
    "dropmalcty": "CHESTNUT HILL",
    "dropmalst": "MA",
    "dropmalzpp": "024679991",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175523522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21538",
    "droptype": "D",
    "dropname": "BRAINTREE",
    "dropdeladd": "125 PEARL ST",
    "dropdelcty": "BRAINTREE",
    "dropdelst": "MA",
    "dropdelzpp": "021846525",
    "dropphyadd": "125 PEARL ST",
    "dropphycty": "BRAINTREE",
    "dropphyst": "MA",
    "dropphyzpp": "021846525",
    "dropmaladd": "PO BOX 859998",
    "dropmalcty": "BRAINTREE",
    "dropmalst": "MA",
    "dropmalzpp": "021859998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813564569,
    "dropfax": 7818439297
  },
  {
    "dcode": "D",
    "dropkey": "BV21558",
    "droptype": "D",
    "dropname": "BROOKLINE",
    "dropdeladd": "1295 BEACON ST",
    "dropdelcty": "BROOKLINE",
    "dropdelst": "MA",
    "dropdelzpp": "024469998",
    "dropphyadd": "1295 BEACON ST",
    "dropphycty": "BROOKLINE",
    "dropphyst": "MA",
    "dropphyzpp": "024469998",
    "dropmaladd": "1295 BEACON ST",
    "dropmalcty": "BROOKLINE",
    "dropmalst": "MA",
    "dropmalzpp": "024469998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177381649,
    "dropfax": 6177388494
  },
  {
    "dcode": "D",
    "dropkey": "BV21560",
    "droptype": "D",
    "dropname": "BROOKLINE VILLAGE",
    "dropdeladd": "207 WASHINGTON ST",
    "dropdelcty": "BROOKLINE",
    "dropdelst": "MA",
    "dropdelzpp": "024459998",
    "dropphyadd": "207 WASHINGTON ST",
    "dropphycty": "BROOKLINE",
    "dropphyst": "MA",
    "dropphyzpp": "024459998",
    "dropmaladd": "PO BOX 479998",
    "dropmalcty": "BROOKLINE VILLAGE",
    "dropmalst": "MA",
    "dropmalzpp": "024479998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175661557,
    "dropfax": 6177319668
  },
  {
    "dcode": "D",
    "dropkey": "BV21607",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "320 BROADWAY STE 1",
    "dropdelcty": "CHELSEA",
    "dropdelst": "MA",
    "dropdelzpp": "021509991",
    "dropphyadd": "320 BROADWAY STE 1",
    "dropphycty": "CHELSEA",
    "dropphyst": "MA",
    "dropphyzpp": "021509991",
    "dropmaladd": "320 BROADWAY STE 1",
    "dropmalcty": "CHELSEA",
    "dropmalst": "MA",
    "dropmalzpp": "021509991",
    "dropsitphn": 6176545113,
    "dropsitlph": 6178845855,
    "dropsitcph": 6178843578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21615",
    "droptype": "D",
    "dropname": "CHESTNUT HILL",
    "dropdeladd": "12 MIDDLESEX RD",
    "dropdelcty": "CHESTNUT HILL",
    "dropdelst": "MA",
    "dropdelzpp": "024679998",
    "dropphyadd": "12 MIDDLESEX RD",
    "dropphycty": "CHESTNUT HILL",
    "dropphyst": "MA",
    "dropphyzpp": "024679998",
    "dropmaladd": "12 MIDDLESEX RD",
    "dropmalcty": "CHESTNUT HILL",
    "dropmalst": "MA",
    "dropmalzpp": "024679998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175660941,
    "dropfax": 6175660857
  },
  {
    "dcode": "D",
    "dropkey": "BV21677",
    "droptype": "D",
    "dropname": "DUDLEY",
    "dropdeladd": "124 W MAIN ST",
    "dropdelcty": "DUDLEY",
    "dropdelst": "MA",
    "dropdelzpp": "015719100",
    "dropphyadd": "124 W MAIN ST",
    "dropphycty": "DUDLEY",
    "dropphyst": "MA",
    "dropphyzpp": "015719100",
    "dropmaladd": "124 W MAIN ST",
    "dropmalcty": "DUDLEY",
    "dropmalst": "MA",
    "dropmalzpp": "015719100",
    "dropsitphn": 9786647013,
    "dropsitlph": 5089438090,
    "dropsitcph": 5089437682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21703",
    "droptype": "D",
    "dropname": "EAST ARLINGTON",
    "dropdeladd": "240 MASSACHUSETTS AVE",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "024749998",
    "dropphyadd": "240 MASSACHUSETTS AVE",
    "dropphycty": "ARLINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "024749998",
    "dropmaladd": "240 MASSACHUSETTS AVE",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "024749998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7816434482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21741",
    "droptype": "D",
    "dropname": "EAST TAUNTON",
    "dropdeladd": "493 MIDDLEBORO AVE",
    "dropdelcty": "EAST TAUNTON",
    "dropdelst": "MA",
    "dropdelzpp": "027189998",
    "dropphyadd": "493 MIDDLEBORO AVE",
    "dropphycty": "EAST TAUNTON",
    "dropphyst": "MA",
    "dropphyzpp": "027189998",
    "dropmaladd": "493 MIDDLEBORO AVE",
    "dropmalcty": "EAST TAUNTON",
    "dropmalst": "MA",
    "dropmalzpp": "027189998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088243712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21746",
    "droptype": "D",
    "dropname": "EAST WATERTOWN",
    "dropdeladd": "589 MOUNT AUBURN ST",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "024729991",
    "dropphyadd": "589 MOUNT AUBURN ST",
    "dropphycty": "WATERTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "024729991",
    "dropmaladd": "589 MOUNT AUBURN ST",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "024729991",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6179241407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21747",
    "droptype": "D",
    "dropname": "EAST WEYMOUTH",
    "dropdeladd": "1377 COMMERCIAL ST",
    "dropdelcty": "EAST WEYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "021899998",
    "dropphyadd": "1377 COMMERCIAL ST",
    "dropphycty": "EAST WEYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "021899998",
    "dropmaladd": "1377 COMMERCIAL ST",
    "dropmalcty": "EAST WEYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "021899998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813353801,
    "dropfax": 7813370117
  },
  {
    "dcode": "D",
    "dropkey": "BV21763",
    "droptype": "D",
    "dropname": "EVERETT",
    "dropdeladd": "11 NORWOOD ST",
    "dropdelcty": "EVERETT",
    "dropdelst": "MA",
    "dropdelzpp": "021499998",
    "dropphyadd": "11 NORWOOD ST",
    "dropphycty": "EVERETT",
    "dropphyst": "MA",
    "dropphyzpp": "021499998",
    "dropmaladd": "11 NORWOOD ST",
    "dropmalcty": "EVERETT",
    "dropmalst": "MA",
    "dropmalzpp": "021499998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173811016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21812",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "64 CENTRAL ST STE 9",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "MA",
    "dropdelzpp": "018339998",
    "dropphyadd": "64 CENTRAL ST STE 9",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "MA",
    "dropphyzpp": "018339998",
    "dropmaladd": "64 CENTRAL ST STE 9",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "MA",
    "dropmalzpp": "018339998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783523196,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "BV21854",
    "droptype": "D",
    "dropname": "GROVELAND",
    "dropdeladd": "299 MAIN ST",
    "dropdelcty": "GROVELAND",
    "dropdelst": "MA",
    "dropdelzpp": "018349998",
    "dropphyadd": "299 MAIN ST",
    "dropphycty": "GROVELAND",
    "dropphyst": "MA",
    "dropphyzpp": "018349998",
    "dropmaladd": "299 MAIN ST",
    "dropmalcty": "GROVELAND",
    "dropmalst": "MA",
    "dropmalzpp": "018349998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783727311,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "BV21863",
    "droptype": "D",
    "dropname": "HANSCOM AFB",
    "dropdeladd": "50 GRIFFISS ST",
    "dropdelcty": "HANSCOM AFB",
    "dropdelst": "MA",
    "dropdelzpp": "017311645",
    "dropphyadd": "50 GRIFFISS ST",
    "dropphycty": "HANSCOM AFB",
    "dropphyst": "MA",
    "dropphyzpp": "017311645",
    "dropmaladd": "158 GREAT RD UNIT J",
    "dropmalcty": "BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "017309998",
    "dropsitphn": 9786447013,
    "dropsitlph": 9786447013,
    "dropsitcph": 7812757431,
    "dropfax": 7812710025
  },
  {
    "dcode": "D",
    "dropkey": "BV21926",
    "droptype": "D",
    "dropname": "INDIAN ORCHARD",
    "dropdeladd": "19 OAK ST",
    "dropdelcty": "INDIAN ORCHARD",
    "dropdelst": "MA",
    "dropdelzpp": "011519998",
    "dropphyadd": "19 OAK ST",
    "dropphycty": "INDIAN ORCHARD",
    "dropphyst": "MA",
    "dropphyzpp": "011519998",
    "dropmaladd": "1883 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011019998",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135432585,
    "dropfax": 4135433663
  },
  {
    "dcode": "D",
    "dropkey": "BV21950",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "74 SUMMER ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "MA",
    "dropdelzpp": "023649998",
    "dropphyadd": "74 SUMMER ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "MA",
    "dropphyzpp": "023649998",
    "dropmaladd": "74 SUMMER ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "MA",
    "dropmalzpp": "023649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815822504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21957",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "330 BEDFORD ST STE 1",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "023472100",
    "dropphyadd": "330 BEDFORD ST STE 1",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "023472100",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "023479998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089464519,
    "dropfax": 5089230742
  },
  {
    "dcode": "D",
    "dropkey": "BV21978",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "1661 MASSACHUSETTS AVE",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "024209998",
    "dropphyadd": "1661 MASSACHUSETTS AVE",
    "dropphycty": "LEXINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "024209998",
    "dropmaladd": "1661 MASSACHUSETTS AVE",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "024209998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7818624006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV21992",
    "droptype": "D",
    "dropname": "LONGMEADOW",
    "dropdeladd": "817 WILLIAMS ST",
    "dropdelcty": "LONGMEADOW",
    "dropdelst": "MA",
    "dropdelzpp": "011069998",
    "dropphyadd": "817 WILLIAMS ST",
    "dropphycty": "LONGMEADOW",
    "dropphyst": "MA",
    "dropphyzpp": "011069998",
    "dropmaladd": "119 INDUSTRIAL DR",
    "dropmalcty": "EAST LONGMEADOW",
    "dropmalst": "MA",
    "dropmalzpp": "010289998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135652208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22008",
    "droptype": "D",
    "dropname": "MALDEN",
    "dropdeladd": "109 MOUNTAIN AVE",
    "dropdelcty": "MALDEN",
    "dropdelst": "MA",
    "dropdelzpp": "021489998",
    "dropphyadd": "109 MOUNTAIN AVE",
    "dropphycty": "MALDEN",
    "dropphyst": "MA",
    "dropphyzpp": "021489998",
    "dropmaladd": "109 MOUNTAIN AVE",
    "dropmalcty": "MALDEN",
    "dropmalst": "MA",
    "dropmalzpp": "021489998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813224685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22044",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "20 FOREST ST",
    "dropdelcty": "MEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "021559998",
    "dropphyadd": "20 FOREST ST",
    "dropphycty": "MEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "021559998",
    "dropmaladd": "20 FOREST ST",
    "dropmalcty": "MEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "021559998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813962444,
    "dropfax": 7813061458
  },
  {
    "dcode": "D",
    "dropkey": "BV22047",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "23 ESSEX ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "MA",
    "dropdelzpp": "021769998",
    "dropphyadd": "23 ESSEX ST",
    "dropphycty": "MELROSE",
    "dropphyst": "MA",
    "dropphyzpp": "021769998",
    "dropmaladd": "23 ESSEX ST",
    "dropmalcty": "MELROSE",
    "dropmalst": "MA",
    "dropmalzpp": "021769998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7816658571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22055",
    "droptype": "D",
    "dropname": "METHUEN",
    "dropdeladd": "272 BROADWAY",
    "dropdelcty": "METHUEN",
    "dropdelst": "MA",
    "dropdelzpp": "018449998",
    "dropphyadd": "272 BROADWAY",
    "dropphycty": "METHUEN",
    "dropphyst": "MA",
    "dropphyzpp": "018449998",
    "dropmaladd": "272 BROADWAY",
    "dropmalcty": "METHUEN",
    "dropmalst": "MA",
    "dropmalzpp": "018449998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786834019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22074",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "499 ADAMS ST",
    "dropdelcty": "MILTON",
    "dropdelst": "MA",
    "dropdelzpp": "021869998",
    "dropphyadd": "499 ADAMS ST",
    "dropphycty": "MILTON",
    "dropphyst": "MA",
    "dropphyzpp": "021869998",
    "dropmaladd": "499 ADAMS ST",
    "dropmalcty": "MILTON",
    "dropmalst": "MA",
    "dropmalzpp": "021869998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176988139,
    "dropfax": 6176967696
  },
  {
    "dcode": "D",
    "dropkey": "BV22076",
    "droptype": "D",
    "dropname": "MILTON VILLAGE",
    "dropdeladd": "50 ADAMS ST",
    "dropdelcty": "MILTON",
    "dropdelst": "MA",
    "dropdelzpp": "021863412",
    "dropphyadd": "50 ADAMS ST",
    "dropphycty": "MILTON",
    "dropphyst": "MA",
    "dropphyzpp": "021863412",
    "dropmaladd": "PO BOX 879998",
    "dropmalcty": "MILTON VILLAGE",
    "dropmalst": "MA",
    "dropmalzpp": "021879998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176988109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22137",
    "droptype": "D",
    "dropname": "NAHANT",
    "dropdeladd": "332 NAHANT RD STE 2",
    "dropdelcty": "NAHANT",
    "dropdelst": "MA",
    "dropdelzpp": "019089998",
    "dropphyadd": "332 NAHANT RD STE 2",
    "dropphycty": "NAHANT",
    "dropphyst": "MA",
    "dropphyzpp": "019089998",
    "dropmaladd": "332 NAHANT RD STE 2",
    "dropmalcty": "NAHANT",
    "dropmalst": "MA",
    "dropmalzpp": "019089998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7815811983,
    "dropfax": 7815869068
  },
  {
    "dcode": "D",
    "dropkey": "BV22142",
    "droptype": "D",
    "dropname": "NEEDHAM",
    "dropdeladd": "1150 GREAT PLAIN AVE",
    "dropdelcty": "NEEDHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024929998",
    "dropphyadd": "1150 GREAT PLAIN AVE",
    "dropphycty": "NEEDHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024929998",
    "dropmaladd": "1150 GREAT PLAIN AVE",
    "dropmalcty": "NEEDHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024929998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7814490707,
    "dropfax": 7814497524
  },
  {
    "dcode": "D",
    "dropkey": "BV22143",
    "droptype": "D",
    "dropname": "NEEDHAM HEIGHTS",
    "dropdeladd": "844 HIGHLAND AVE",
    "dropdelcty": "NEEDHAM HEIGHTS",
    "dropdelst": "MA",
    "dropdelzpp": "024949998",
    "dropphyadd": "844 HIGHLAND AVE",
    "dropphycty": "NEEDHAM HEIGHTS",
    "dropphyst": "MA",
    "dropphyzpp": "024949998",
    "dropmaladd": "844 HIGHLAND AVE",
    "dropmalcty": "NEEDHAM HEIGHTS",
    "dropmalst": "MA",
    "dropmalzpp": "024949998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7814440355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22165",
    "droptype": "D",
    "dropname": "NEW TOWN",
    "dropdeladd": "123 GALEN ST",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "024724507",
    "dropphyadd": "123 GALEN ST",
    "dropphycty": "WATERTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "024724507",
    "dropmaladd": "PO BOX 569998",
    "dropmalcty": "NEW TOWN",
    "dropmalst": "MA",
    "dropmalzpp": "024569998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6179262606,
    "dropfax": 6179263897
  },
  {
    "dcode": "D",
    "dropkey": "BV22175",
    "droptype": "D",
    "dropname": "NEWTON HIGHLANDS",
    "dropdeladd": "63 LINCOLN ST",
    "dropdelcty": "NEWTON HIGHLANDS",
    "dropdelst": "MA",
    "dropdelzpp": "024619998",
    "dropphyadd": "63 LINCOLN ST",
    "dropphycty": "NEWTON HIGHLANDS",
    "dropphyst": "MA",
    "dropphyzpp": "024619998",
    "dropmaladd": "63 LINCOLN ST",
    "dropmalcty": "NEWTON HIGHLANDS",
    "dropmalst": "MA",
    "dropmalzpp": "024619998",
    "dropsitphn": 6176545111,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175273033,
    "dropfax": 6179658545
  },
  {
    "dcode": "D",
    "dropkey": "BV22177",
    "droptype": "D",
    "dropname": "NEWTON LOWER FALLS",
    "dropdeladd": "2344 WASHINGTON ST STE 1",
    "dropdelcty": "NEWTON LOWER FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "024629998",
    "dropphyadd": "2344 WASHINGTON ST STE 1",
    "dropphycty": "NEWTON LOWER FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "024629998",
    "dropmaladd": "2344 WASHINGTON ST STE 1",
    "dropmalcty": "NEWTON LOWER FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "024629998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175274391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22178",
    "droptype": "D",
    "dropname": "NEWTON UPPER FALLS",
    "dropdeladd": "81 OAK ST",
    "dropdelcty": "NEWTON UPPER FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "024649998",
    "dropphyadd": "81 OAK ST",
    "dropphycty": "NEWTON UPPER FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "024649998",
    "dropmaladd": "81 OAK ST",
    "dropmalcty": "NEWTON UPPER FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "024649998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175277774,
    "dropfax": 6179642456
  },
  {
    "dcode": "D",
    "dropkey": "BV22179",
    "droptype": "D",
    "dropname": "NEWTONVILLE",
    "dropdeladd": "897 WASHINGTON ST",
    "dropdelcty": "NEWTONVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "024609998",
    "dropphyadd": "897 WASHINGTON ST",
    "dropphycty": "NEWTONVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "024609998",
    "dropmaladd": "897 WASHINGTON ST",
    "dropmalcty": "NEWTONVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "024609998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172442355,
    "dropfax": 6179286045
  },
  {
    "dcode": "D",
    "dropkey": "BV22197",
    "droptype": "D",
    "dropname": "NONANTUM",
    "dropdeladd": "326 WATERTOWN ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "MA",
    "dropdelzpp": "024589998",
    "dropphyadd": "326 WATERTOWN ST",
    "dropphycty": "NEWTON",
    "dropphyst": "MA",
    "dropphyzpp": "024589998",
    "dropmaladd": "PO BOX 959998",
    "dropmalcty": "NONANTUM",
    "dropmalst": "MA",
    "dropmalzpp": "024959998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172442379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22209",
    "droptype": "D",
    "dropname": "NORTH ANDOVER",
    "dropdeladd": "131 MAIN ST",
    "dropdelcty": "NORTH ANDOVER",
    "dropdelst": "MA",
    "dropdelzpp": "018459998",
    "dropphyadd": "131 MAIN ST",
    "dropphycty": "NORTH ANDOVER",
    "dropphyst": "MA",
    "dropphyzpp": "018459998",
    "dropmaladd": "131 MAIN ST",
    "dropmalcty": "NORTH ANDOVER",
    "dropmalst": "MA",
    "dropmalzpp": "018459998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786871740,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "BV22220",
    "droptype": "D",
    "dropname": "NORTH DARTMOUTH",
    "dropdeladd": "77 FAUNCE CORNER MALL RD",
    "dropdelcty": "NORTH DARTMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "027479998",
    "dropphyadd": "77 FAUNCE CORNER MALL RD",
    "dropphycty": "NORTH DARTMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "027479998",
    "dropmaladd": "77 FAUNCE CORNER MALL RD",
    "dropmalcty": "NORTH DARTMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "027479998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089973976,
    "dropfax": 5089961413
  },
  {
    "dcode": "D",
    "dropkey": "BV22245",
    "droptype": "D",
    "dropname": "NORTH QUINCY",
    "dropdeladd": "454 HANCOCK ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MA",
    "dropdelzpp": "021719998",
    "dropphyadd": "454 HANCOCK ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MA",
    "dropphyzpp": "021719998",
    "dropmaladd": "454 HANCOCK ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "MA",
    "dropmalzpp": "021719998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173281716,
    "dropfax": 6174727875
  },
  {
    "dcode": "D",
    "dropkey": "BV22253",
    "droptype": "D",
    "dropname": "NORTH WALTHAM",
    "dropdeladd": "854 LEXINGTON ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024529998",
    "dropphyadd": "854 LEXINGTON ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024529998",
    "dropmaladd": "854 LEXINGTON ST",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024529998",
    "dropsitphn": 7818935961,
    "dropsitlph": 7818935961,
    "dropsitcph": 7818939520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22254",
    "droptype": "D",
    "dropname": "NORTH WEYMOUTH",
    "dropdeladd": "53 SEA ST",
    "dropdelcty": "NORTH WEYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "021919998",
    "dropphyadd": "53 SEA ST",
    "dropphycty": "NORTH WEYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "021919998",
    "dropmaladd": "53 SEA ST",
    "dropmalcty": "NORTH WEYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "021919998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813351687,
    "dropfax": 7813358231
  },
  {
    "dcode": "D",
    "dropkey": "BV22317",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "127 SOUTH ST",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "027629998",
    "dropphyadd": "127 SOUTH ST",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "027629998",
    "dropmaladd": "127 SOUTH ST",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "027629998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086954933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22334",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "47 WASHINGTON ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MA",
    "dropdelzpp": "021695301",
    "dropphyadd": "47 WASHINGTON ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MA",
    "dropphyzpp": "021695301",
    "dropmaladd": "PO BOX 699998",
    "dropmalcty": "QUINCY",
    "dropmalst": "MA",
    "dropmalzpp": "022699998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177736641,
    "dropfax": 6177869173
  },
  {
    "dcode": "D",
    "dropkey": "BV22345",
    "droptype": "D",
    "dropname": "REVERE",
    "dropdeladd": "300 BROADWAY LBBY",
    "dropdelcty": "REVERE",
    "dropdelst": "MA",
    "dropdelzpp": "021519998",
    "dropphyadd": "300 BROADWAY LBBY",
    "dropphycty": "REVERE",
    "dropphyst": "MA",
    "dropphyzpp": "021519998",
    "dropmaladd": "300 BROADWAY LBBY",
    "dropmalcty": "REVERE",
    "dropmalst": "MA",
    "dropmalzpp": "021519998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812892105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22410",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "6 ELM ST UNIT C",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MA",
    "dropdelzpp": "019529998",
    "dropphyadd": "6 ELM ST UNIT C",
    "dropphycty": "SALISBURY",
    "dropphyst": "MA",
    "dropphyzpp": "019529998",
    "dropmaladd": "6 ELM ST UNIT C",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MA",
    "dropmalzpp": "019529998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784651410,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "BV22417",
    "droptype": "D",
    "dropname": "SAUGUS",
    "dropdeladd": "437 LINCOLN AVE",
    "dropdelcty": "SAUGUS",
    "dropdelst": "MA",
    "dropdelzpp": "019069998",
    "dropphyadd": "437 LINCOLN AVE",
    "dropphycty": "SAUGUS",
    "dropphyst": "MA",
    "dropphyzpp": "019069998",
    "dropmaladd": "437 LINCOLN AVE",
    "dropmalcty": "SAUGUS",
    "dropmalst": "MA",
    "dropmalzpp": "019069998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812338354,
    "dropfax": 7812311824
  },
  {
    "dcode": "D",
    "dropkey": "BV22450",
    "droptype": "D",
    "dropname": "SIASCONSET",
    "dropdeladd": "6 MAIN ST",
    "dropdelcty": "SIASCONSET",
    "dropdelst": "MA",
    "dropdelzpp": "025649800",
    "dropphyadd": "6 MAIN ST",
    "dropphycty": "SIASCONSET",
    "dropphyst": "MA",
    "dropphyzpp": "025649800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIASCONSET",
    "dropmalst": "MA",
    "dropmalzpp": "025649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082284477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22481",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "1089 COUNTY ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "MA",
    "dropdelzpp": "027269998",
    "dropphyadd": "1089 COUNTY ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "MA",
    "dropphyzpp": "027269998",
    "dropmaladd": "1089 COUNTY ST",
    "dropmalcty": "SOMERSET",
    "dropmalst": "MA",
    "dropmalzpp": "027269998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086734178,
    "dropfax": 5086462622
  },
  {
    "dcode": "D",
    "dropkey": "BV22500",
    "droptype": "D",
    "dropname": "SOUTH DARTMOUTH",
    "dropdeladd": "668 DARTMOUTH ST",
    "dropdelcty": "SOUTH DARTMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "027483099",
    "dropphyadd": "668 DARTMOUTH ST",
    "dropphycty": "SOUTH DARTMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "027483099",
    "dropmaladd": "668 DARTMOUTH ST",
    "dropmalcty": "SOUTH DARTMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "027483099",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089965487,
    "dropfax": 5089971572
  },
  {
    "dcode": "D",
    "dropkey": "BV22530",
    "droptype": "D",
    "dropname": "SOUTH WALTHAM",
    "dropdeladd": "38 SPRUCE ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024539998",
    "dropphyadd": "38 SPRUCE ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024539998",
    "dropmaladd": "38 SPRUCE ST",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024539998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7818939841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22532",
    "droptype": "D",
    "dropname": "SOUTH WEYMOUTH",
    "dropdeladd": "84 PLEASANT ST",
    "dropdelcty": "SOUTH WEYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "021902413",
    "dropphyadd": "84 PLEASANT ST",
    "dropphycty": "SOUTH WEYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "021902413",
    "dropmaladd": "84 PLEASANT ST",
    "dropmalcty": "SOUTH WEYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "021902413",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813353221,
    "dropfax": 7813372766
  },
  {
    "dcode": "D",
    "dropkey": "BV22620",
    "droptype": "D",
    "dropname": "STONEHAM",
    "dropdeladd": "345 MAIN ST",
    "dropdelcty": "STONEHAM",
    "dropdelst": "MA",
    "dropdelzpp": "021809998",
    "dropphyadd": "345 MAIN ST",
    "dropphycty": "STONEHAM",
    "dropphyst": "MA",
    "dropphyzpp": "021809998",
    "dropmaladd": "345 MAIN ST",
    "dropmalcty": "STONEHAM",
    "dropmalst": "MA",
    "dropmalzpp": "021809998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7814383124,
    "dropfax": 7814384238
  },
  {
    "dcode": "D",
    "dropkey": "BV22633",
    "droptype": "D",
    "dropname": "SWAMPSCOTT",
    "dropdeladd": "49 ELMWOOD RD",
    "dropdelcty": "SWAMPSCOTT",
    "dropdelst": "MA",
    "dropdelzpp": "019079998",
    "dropphyadd": "49 ELMWOOD RD",
    "dropphycty": "SWAMPSCOTT",
    "dropphyst": "MA",
    "dropphyzpp": "019079998",
    "dropmaladd": "49 ELMWOOD RD",
    "dropmalcty": "SWAMPSCOTT",
    "dropmalst": "MA",
    "dropmalzpp": "019079998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7815933157,
    "dropfax": 7815986550
  },
  {
    "dcode": "D",
    "dropkey": "BV22639",
    "droptype": "D",
    "dropname": "TEATICKET",
    "dropdeladd": "160 TEATICKET HWY",
    "dropdelcty": "TEATICKET",
    "dropdelst": "MA",
    "dropdelzpp": "025369992",
    "dropphyadd": "160 TEATICKET HWY",
    "dropphycty": "TEATICKET",
    "dropphyst": "MA",
    "dropphyzpp": "025369992",
    "dropmaladd": "160 TEATICKET HWY",
    "dropmalcty": "TEATICKET",
    "dropmalst": "MA",
    "dropmalzpp": "025369992",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085484324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22657",
    "droptype": "D",
    "dropname": "TUFTS UNIVERSITY",
    "dropdeladd": "470 BOSTON AVE",
    "dropdelcty": "MEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "021555802",
    "dropphyadd": "470 BOSTON AVE",
    "dropphycty": "MEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "021555802",
    "dropmaladd": "PO BOX 539998",
    "dropmalcty": "MEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "021539998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176255755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22708",
    "droptype": "D",
    "dropname": "WABAN",
    "dropdeladd": "83 WYMAN ST",
    "dropdelcty": "WABAN",
    "dropdelst": "MA",
    "dropdelzpp": "024689998",
    "dropphyadd": "83 WYMAN ST",
    "dropphycty": "WABAN",
    "dropphyst": "MA",
    "dropphyzpp": "024689998",
    "dropmaladd": "83 WYMAN ST",
    "dropmalcty": "WABAN",
    "dropmalst": "MA",
    "dropmalzpp": "024689998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175273673,
    "dropfax": 6175274105
  },
  {
    "dcode": "D",
    "dropkey": "BV22715",
    "droptype": "D",
    "dropname": "WALTHAM",
    "dropdeladd": "776 MAIN ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024519998",
    "dropphyadd": "776 MAIN ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024519998",
    "dropmaladd": "PO BOX 549998",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024549998",
    "dropsitphn": 7818931100,
    "dropsitlph": 6176545111,
    "dropsitcph": 7818939752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22727",
    "droptype": "D",
    "dropname": "WAVERLEY",
    "dropdeladd": "492 TRAPELO RD",
    "dropdelcty": "BELMONT",
    "dropdelst": "MA",
    "dropdelzpp": "024781422",
    "dropphyadd": "492 TRAPELO RD",
    "dropphycty": "BELMONT",
    "dropphyst": "MA",
    "dropphyzpp": "024781422",
    "dropmaladd": "PO BOX 799998",
    "dropmalcty": "WAVERLEY",
    "dropmalst": "MA",
    "dropmalzpp": "024799998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174844724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22736",
    "droptype": "D",
    "dropname": "WELLESLEY",
    "dropdeladd": "1 GROVE ST",
    "dropdelcty": "WELLESLEY",
    "dropdelst": "MA",
    "dropdelzpp": "024829998",
    "dropphyadd": "1 GROVE ST",
    "dropphycty": "WELLESLEY",
    "dropphyst": "MA",
    "dropphyzpp": "024829998",
    "dropmaladd": "1 GROVE ST",
    "dropmalcty": "WELLESLEY",
    "dropmalst": "MA",
    "dropmalzpp": "024829998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812353666,
    "dropfax": 7812372923
  },
  {
    "dcode": "D",
    "dropkey": "BV22739",
    "droptype": "D",
    "dropname": "WELLESLEY HILLS",
    "dropdeladd": "337 WASHINGTON ST",
    "dropdelcty": "WELLESLEY HILLS",
    "dropdelst": "MA",
    "dropdelzpp": "024819998",
    "dropphyadd": "337 WASHINGTON ST",
    "dropphycty": "WELLESLEY HILLS",
    "dropphyst": "MA",
    "dropphyzpp": "024819998",
    "dropmaladd": "337 WASHINGTON ST",
    "dropmalcty": "WELLESLEY HILLS",
    "dropmalst": "MA",
    "dropmalzpp": "024819998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812354374,
    "dropfax": 7812351053
  },
  {
    "dcode": "D",
    "dropkey": "BV22779",
    "droptype": "D",
    "dropname": "WEST MEDFORD",
    "dropdeladd": "485 HIGH ST",
    "dropdelcty": "MEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "021556735",
    "dropphyadd": "485 HIGH ST",
    "dropphycty": "MEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "021556735",
    "dropmaladd": "PO BOX 569998",
    "dropmalcty": "WEST MEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "021569998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7814833090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22784",
    "droptype": "D",
    "dropname": "WEST NEWTON",
    "dropdeladd": "525 WALTHAM ST",
    "dropdelcty": "WEST NEWTON",
    "dropdelst": "MA",
    "dropdelzpp": "024659998",
    "dropphyadd": "525 WALTHAM ST",
    "dropphycty": "WEST NEWTON",
    "dropphyst": "MA",
    "dropphyzpp": "024659998",
    "dropmaladd": "525 WALTHAM ST",
    "dropmalcty": "WEST NEWTON",
    "dropmalst": "MA",
    "dropmalzpp": "024659998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172442502,
    "dropfax": 6179642595
  },
  {
    "dcode": "D",
    "dropkey": "BV22794",
    "droptype": "D",
    "dropname": "WEST SOMERVILLE",
    "dropdeladd": "58 DAY ST STE 100",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "021449998",
    "dropphyadd": "58 DAY ST STE 100",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "021449998",
    "dropmaladd": "58 DAY ST STE 100",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021449998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176662255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22805",
    "droptype": "D",
    "dropname": "WEST WARREN",
    "dropdeladd": "2282 MAIN ST",
    "dropdelcty": "WEST WARREN",
    "dropdelst": "MA",
    "dropdelzpp": "010929998",
    "dropphyadd": "2282 MAIN ST",
    "dropphycty": "WEST WARREN",
    "dropphyst": "MA",
    "dropphyzpp": "010929998",
    "dropmaladd": "16 MILTON O FOUNTAIN WAY",
    "dropmalcty": "WARREN",
    "dropmalst": "MA",
    "dropmalzpp": "010839998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134367662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22807",
    "droptype": "D",
    "dropname": "WEST YARMOUTH",
    "dropdeladd": "602 ROUTE 28",
    "dropdelcty": "WEST YARMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "026735074",
    "dropphyadd": "602 ROUTE 28",
    "dropphycty": "WEST YARMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "026735074",
    "dropmaladd": "602 ROUTE 28",
    "dropmalcty": "WEST YARMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "026735074",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087752620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22814",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "25 COLPITTS RD",
    "dropdelcty": "WESTON",
    "dropdelst": "MA",
    "dropdelzpp": "024939998",
    "dropphyadd": "25 COLPITTS RD",
    "dropphycty": "WESTON",
    "dropphyst": "MA",
    "dropphyzpp": "024939998",
    "dropmaladd": "25 COLPITTS RD",
    "dropmalcty": "WESTON",
    "dropmalst": "MA",
    "dropmalzpp": "024939998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7818937667,
    "dropfax": 7818937684
  },
  {
    "dcode": "D",
    "dropkey": "BV22822",
    "droptype": "D",
    "dropname": "WEYMOUTH",
    "dropdeladd": "103 WASHINGTON ST",
    "dropdelcty": "WEYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "021889998",
    "dropphyadd": "103 WASHINGTON ST",
    "dropphycty": "WEYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "021889998",
    "dropmaladd": "103 WASHINGTON ST",
    "dropmalcty": "WEYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "021889998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813370098,
    "dropfax": 7813406031
  },
  {
    "dcode": "D",
    "dropkey": "BV22851",
    "droptype": "D",
    "dropname": "WINTER HILL",
    "dropdeladd": "320 BROADWAY",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "021459998",
    "dropphyadd": "320 BROADWAY",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "021459998",
    "dropmaladd": "320 BROADWAY",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021459998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176665225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22853",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "5 MICHAELS MALL",
    "dropdelcty": "WINTHROP",
    "dropdelst": "MA",
    "dropdelzpp": "021529998",
    "dropphyadd": "5 MICHAELS MALL",
    "dropphycty": "WINTHROP",
    "dropphyst": "MA",
    "dropphyzpp": "021529998",
    "dropmaladd": "5 MICHAELS MALL",
    "dropmalcty": "WINTHROP",
    "dropmalst": "MA",
    "dropmalzpp": "021529998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178460995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV22857",
    "droptype": "D",
    "dropname": "WOLLASTON",
    "dropdeladd": "5 BEACH ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MA",
    "dropdelzpp": "021709998",
    "dropphyadd": "5 BEACH ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MA",
    "dropphyzpp": "021709998",
    "dropmaladd": "5 BEACH ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "MA",
    "dropmalzpp": "021709998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174721263,
    "dropfax": 6174793549
  },
  {
    "dcode": "D",
    "dropkey": "BV22858",
    "droptype": "D",
    "dropname": "WOODS HOLE",
    "dropdeladd": "16 WATER ST",
    "dropdelcty": "WOODS HOLE",
    "dropdelst": "MA",
    "dropdelzpp": "025439998",
    "dropphyadd": "16 WATER ST",
    "dropphycty": "WOODS HOLE",
    "dropphyst": "MA",
    "dropphyzpp": "025439998",
    "dropmaladd": "16 WATER ST",
    "dropmalcty": "WOODS HOLE",
    "dropmalst": "MA",
    "dropmalzpp": "025439998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085483298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV23044",
    "droptype": "D",
    "dropname": "BROOKLYN CURTIS BAY",
    "dropdeladd": "10 16TH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "MD",
    "dropdelzpp": 212259998,
    "dropphyadd": "10 16TH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "MD",
    "dropphyzpp": 212259998,
    "dropmaladd": "10 16TH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "MD",
    "dropmalzpp": 212259998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4107893021,
    "dropsitcph": 4107893021,
    "dropfax": 4107890855
  },
  {
    "dcode": "D",
    "dropkey": "BV23119",
    "droptype": "D",
    "dropname": "CATONSVILLE",
    "dropdeladd": "1001 FREDERICK RD",
    "dropdelcty": "CATONSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 212289998,
    "dropphyadd": "1001 FREDERICK RD",
    "dropphycty": "CATONSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 212289998,
    "dropmaladd": "1001 FREDERICK RD",
    "dropmalcty": "CATONSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 212289998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108697204,
    "dropsitcph": 4108697204,
    "dropfax": 4107191614
  },
  {
    "dcode": "D",
    "dropkey": "BV23168",
    "droptype": "D",
    "dropname": "CHEVY CHASE",
    "dropdeladd": "5910 CONNECTICUT AVE",
    "dropdelcty": "CHEVY CHASE",
    "dropdelst": "MD",
    "dropdelzpp": 208159998,
    "dropphyadd": "5910 CONNECTICUT AVE",
    "dropphycty": "CHEVY CHASE",
    "dropphyst": "MD",
    "dropphyzpp": 208159998,
    "dropmaladd": "5910 CONNECTICUT AVE",
    "dropmalcty": "CHEVY CHASE",
    "dropmalst": "MD",
    "dropmalzpp": 208159998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019412793,
    "dropsitcph": 3019412793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV23216",
    "droptype": "D",
    "dropname": "COLESVILLE",
    "dropdeladd": "13217 NEW HAMPSHIRE AVE",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209049997,
    "dropphyadd": "13217 NEW HAMPSHIRE AVE",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209049997,
    "dropmaladd": "13217 NEW HAMPSHIRE AVE",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209049997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018792334,
    "dropsitcph": 3018792331,
    "dropfax": 3013845338
  },
  {
    "dcode": "D",
    "dropkey": "BV23292",
    "droptype": "D",
    "dropname": "CRESAPTOWN",
    "dropdeladd": "12836 DARROWS AVE",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215059998,
    "dropphyadd": "12836 DARROWS AVE",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215059998,
    "dropmaladd": "12836 DARROWS AVE",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215059998,
    "dropsitphn": 3017228190,
    "dropsitlph": 4107293360,
    "dropsitcph": 3017293360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV23341",
    "droptype": "D",
    "dropname": "DERWOOD",
    "dropdeladd": "17533 REDLAND RD",
    "dropdelcty": "DERWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 208559998,
    "dropphyadd": "17533 REDLAND RD",
    "dropphycty": "DERWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 208559998,
    "dropmaladd": "17533 REDLAND RD",
    "dropmalcty": "DERWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 208559998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015271103,
    "dropsitcph": 3015271103,
    "dropfax": 3015271105
  },
  {
    "dcode": "D",
    "dropkey": "BV23351",
    "droptype": "D",
    "dropname": "DISTRICT HEIGHTS",
    "dropdeladd": "6514 MARLBORO PIKE",
    "dropdelcty": "DISTRICT HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207479997,
    "dropphyadd": "6514 MARLBORO PIKE",
    "dropphycty": "DISTRICT HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207479997,
    "dropmaladd": "6514 MARLBORO PIKE",
    "dropmalcty": "DISTRICT HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207479997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017352720,
    "dropsitcph": 3015168536,
    "dropfax": 3017350196
  },
  {
    "dcode": "D",
    "dropkey": "BV23375",
    "droptype": "D",
    "dropname": "DUNDALK SPARROWS POINT",
    "dropdeladd": "44 SHIPPING PL",
    "dropdelcty": "DUNDALK",
    "dropdelst": "MD",
    "dropdelzpp": 212229998,
    "dropphyadd": "44 SHIPPING PL",
    "dropphycty": "DUNDALK",
    "dropphyst": "MD",
    "dropphyzpp": 212229998,
    "dropmaladd": "44 SHIPPING PL",
    "dropmalcty": "DUNDALK",
    "dropmalst": "MD",
    "dropmalzpp": 212229998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102842063,
    "dropsitcph": 4102842063,
    "dropfax": 4102841503
  },
  {
    "dcode": "D",
    "dropkey": "BV23425",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "444 MARYLAND AVE",
    "dropdelcty": "ESSEX",
    "dropdelst": "MD",
    "dropdelzpp": 212219998,
    "dropphyadd": "444 MARYLAND AVE",
    "dropphycty": "ESSEX",
    "dropphyst": "MD",
    "dropphyzpp": 212219998,
    "dropmaladd": "444 MARYLAND AVE",
    "dropmalcty": "ESSEX",
    "dropmalst": "MD",
    "dropmalzpp": 212219998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106876366,
    "dropsitcph": 4106876366,
    "dropfax": 4106870694
  },
  {
    "dcode": "D",
    "dropkey": "BV23619",
    "droptype": "D",
    "dropname": "GUNPOWDER",
    "dropdeladd": "4405 AUSTIN RD",
    "dropdelcty": "GUNPOWDER",
    "dropdelst": "MD",
    "dropdelzpp": 210109998,
    "dropphyadd": "4405 AUSTIN RD",
    "dropphycty": "GUNPOWDER",
    "dropphyst": "MD",
    "dropphyzpp": 210109998,
    "dropmaladd": "4405 AUSTIN RD",
    "dropmalcty": "GUNPOWDER",
    "dropmalst": "MD",
    "dropmalzpp": 210109998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106761905,
    "dropsitcph": 4106761905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV23620",
    "droptype": "D",
    "dropname": "GWYNN OAK",
    "dropdeladd": "6101 LIBERTY RD",
    "dropdelcty": "GWYNN OAK",
    "dropdelst": "MD",
    "dropdelzpp": 212079998,
    "dropphyadd": "6101 LIBERTY RD",
    "dropphycty": "GWYNN OAK",
    "dropphyst": "MD",
    "dropphyzpp": 212079998,
    "dropmaladd": "6101 LIBERTY RD",
    "dropmalcty": "GWYNN OAK",
    "dropmalst": "MD",
    "dropmalzpp": 212079998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4109442435,
    "dropsitcph": 4109442435,
    "dropfax": 4109448879
  },
  {
    "dcode": "D",
    "dropkey": "BV23624",
    "droptype": "D",
    "dropname": "HALETHORPE",
    "dropdeladd": "6 WAELCHLI AVE",
    "dropdelcty": "HALETHORPE",
    "dropdelst": "MD",
    "dropdelzpp": 212279998,
    "dropphyadd": "6 WAELCHLI AVE",
    "dropphycty": "HALETHORPE",
    "dropphyst": "MD",
    "dropphyzpp": 212279998,
    "dropmaladd": "6 WAELCHLI AVE",
    "dropmalcty": "HALETHORPE",
    "dropmalst": "MD",
    "dropmalzpp": 212279998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102421483,
    "dropsitcph": 4102421483,
    "dropfax": 4105369409
  },
  {
    "dcode": "D",
    "dropkey": "BV23816",
    "droptype": "D",
    "dropname": "LANDOVER",
    "dropdeladd": "3312 DODGE PARK RD",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207859997,
    "dropphyadd": "3312 DODGE PARK RD",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207859997,
    "dropmaladd": "3312 DODGE PARK RD",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207859997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013225056,
    "dropsitcph": 3013225056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV23818",
    "droptype": "D",
    "dropname": "LANDOVER HILLS",
    "dropdeladd": "7400 BUCHANAN ST",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207842324,
    "dropphyadd": "7400 BUCHANAN ST",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207842324,
    "dropmaladd": "7400 BUCHANAN ST",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207842324,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017313423,
    "dropsitcph": 3017313423,
    "dropfax": 3015777020
  },
  {
    "dcode": "D",
    "dropkey": "BV23821",
    "droptype": "D",
    "dropname": "LANGLEY PARK",
    "dropdeladd": "1325 HOLTON LN",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207839997,
    "dropphyadd": "1325 HOLTON LN",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207839997,
    "dropmaladd": "1325 HOLTON LN",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207839997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014223984,
    "dropsitcph": 3014223984,
    "dropfax": 3014223982
  },
  {
    "dcode": "D",
    "dropkey": "BV23843",
    "droptype": "D",
    "dropname": "LAVALE",
    "dropdeladd": "401 NATIONAL HWY",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215049998,
    "dropphyadd": "401 NATIONAL HWY",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215049998,
    "dropmaladd": "401 NATIONAL HWY",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215049998,
    "dropsitphn": 3017228190,
    "dropsitlph": 4107247145,
    "dropsitcph": 3017247145,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "BV23898",
    "droptype": "D",
    "dropname": "LUKE",
    "dropdeladd": "119 PRATT ST",
    "dropdelcty": "LUKE",
    "dropdelst": "MD",
    "dropdelzpp": 215401013,
    "dropphyadd": "119 PRATT ST",
    "dropphycty": "LUKE",
    "dropphyst": "MD",
    "dropphyzpp": 215401013,
    "dropmaladd": "119 PRATT ST",
    "dropmalcty": "LUKE",
    "dropmalst": "MD",
    "dropmalzpp": 215401013,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013599261,
    "dropsitcph": 3013599261,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "BV23968",
    "droptype": "D",
    "dropname": "MIDDLE RIVER",
    "dropdeladd": "200 WILSON POINT RD",
    "dropdelcty": "MIDDLE RIVER",
    "dropdelst": "MD",
    "dropdelzpp": 212209998,
    "dropphyadd": "200 WILSON POINT RD",
    "dropphycty": "MIDDLE RIVER",
    "dropphyst": "MD",
    "dropphyzpp": 212209998,
    "dropmaladd": "200 WILSON POINT RD",
    "dropmalcty": "MIDDLE RIVER",
    "dropmalst": "MD",
    "dropmalzpp": 212209998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106875568,
    "dropsitcph": 4106875568,
    "dropfax": 4106870725
  },
  {
    "dcode": "D",
    "dropkey": "BV23985",
    "droptype": "D",
    "dropname": "MITCHELLVILLE",
    "dropdeladd": "1500 POINTER RIDGE PL",
    "dropdelcty": "BOWIE",
    "dropdelst": "MD",
    "dropdelzpp": 207169998,
    "dropphyadd": "1500 POINTER RIDGE PL",
    "dropphycty": "BOWIE",
    "dropphyst": "MD",
    "dropphyzpp": 207169998,
    "dropmaladd": "1500 POINTER RIDGE PL",
    "dropmalcty": "BOWIE",
    "dropmalst": "MD",
    "dropmalzpp": 207169998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012492512,
    "dropsitcph": 3012492512,
    "dropfax": 3013909074
  },
  {
    "dcode": "D",
    "dropkey": "BV24000",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "12625 LAUREL BOWIE RD",
    "dropdelcty": "LAUREL",
    "dropdelst": "MD",
    "dropdelzpp": 207089998,
    "dropphyadd": "12625 LAUREL BOWIE RD",
    "dropphycty": "LAUREL",
    "dropphyst": "MD",
    "dropphyzpp": 207089998,
    "dropmaladd": "12625 LAUREL BOWIE RD",
    "dropmalcty": "LAUREL",
    "dropmalst": "MD",
    "dropmalzpp": 207089998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014901818,
    "dropsitcph": 3014901818,
    "dropfax": 3016179761
  },
  {
    "dcode": "D",
    "dropkey": "BV24023",
    "droptype": "D",
    "dropname": "MOUNTAIN LAKE PARK",
    "dropdeladd": "1325 MARYLAND HWY",
    "dropdelcty": "OAKLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215509997,
    "dropphyadd": "1325 MARYLAND HWY",
    "dropphycty": "OAKLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215509997,
    "dropmaladd": "1325 MARYLAND HWY",
    "dropmalcty": "OAKLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215509997,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013343151,
    "dropsitcph": 3013343151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV24046",
    "droptype": "D",
    "dropname": "NAVAL ACADEMY",
    "dropdeladd": "1 WILSON RD",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MD",
    "dropdelzpp": 214021205,
    "dropphyadd": "1 WILSON RD",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MD",
    "dropphyzpp": 214021205,
    "dropmaladd": "1 WILSON RD",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MD",
    "dropmalzpp": 214021205,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105736537,
    "dropsitcph": 4105736537,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "BV24093",
    "droptype": "D",
    "dropname": "NOTTINGHAM",
    "dropdeladd": "4990 MERCANTILE RD",
    "dropdelcty": "NOTTINGHAM",
    "dropdelst": "MD",
    "dropdelzpp": 212369998,
    "dropphyadd": "4990 MERCANTILE RD",
    "dropphycty": "NOTTINGHAM",
    "dropphyst": "MD",
    "dropphyzpp": 212369998,
    "dropmaladd": "4990 MERCANTILE RD",
    "dropmalcty": "NOTTINGHAM",
    "dropmalst": "MD",
    "dropmalzpp": 212369998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4109314305,
    "dropsitcph": 4109314305,
    "dropfax": 4109314302
  },
  {
    "dcode": "D",
    "dropkey": "BV24129",
    "droptype": "D",
    "dropname": "OXON HILL",
    "dropdeladd": "6316 OXON HILL RD",
    "dropdelcty": "OXON HILL",
    "dropdelst": "MD",
    "dropdelzpp": 207459997,
    "dropphyadd": "6316 OXON HILL RD",
    "dropphycty": "OXON HILL",
    "dropphyst": "MD",
    "dropphyzpp": 207459997,
    "dropmaladd": "6316 OXON HILL RD",
    "dropmalcty": "OXON HILL",
    "dropmalst": "MD",
    "dropmalzpp": 207459997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018395617,
    "dropsitcph": 3018395617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV24139",
    "droptype": "D",
    "dropname": "PARKVILLE",
    "dropdeladd": "8201 HARFORD RD",
    "dropdelcty": "PARKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 212349998,
    "dropphyadd": "8201 HARFORD RD",
    "dropphycty": "PARKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 212349998,
    "dropmaladd": "8201 HARFORD RD",
    "dropmalcty": "PARKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 212349998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108820390,
    "dropsitcph": 4108820390,
    "dropfax": 4106657819
  },
  {
    "dcode": "D",
    "dropkey": "BV24207",
    "droptype": "D",
    "dropname": "POTOMAC",
    "dropdeladd": "10221 RIVER RD",
    "dropdelcty": "POTOMAC",
    "dropdelst": "MD",
    "dropdelzpp": 208549998,
    "dropphyadd": "10221 RIVER RD",
    "dropphycty": "POTOMAC",
    "dropphyst": "MD",
    "dropphyzpp": 208549998,
    "dropmaladd": "10221 RIVER RD",
    "dropmalcty": "POTOMAC",
    "dropmalst": "MD",
    "dropmalzpp": 208549998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019834671,
    "dropsitcph": 3019834671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV24275",
    "droptype": "D",
    "dropname": "RIVIERA BEACH",
    "dropdeladd": "8489 RUGBY RD",
    "dropdelcty": "PASADENA",
    "dropdelst": "MD",
    "dropdelzpp": 211229997,
    "dropphyadd": "8489 RUGBY RD",
    "dropphycty": "PASADENA",
    "dropphyst": "MD",
    "dropphyzpp": 211229997,
    "dropmaladd": "8489 RUGBY RD",
    "dropmalcty": "PASADENA",
    "dropmalst": "MD",
    "dropmalzpp": 211229997,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104398495,
    "dropsitcph": 4104398495,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "BV24308",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "7000 GOLDEN RING RD",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "MD",
    "dropdelzpp": 212379998,
    "dropphyadd": "7000 GOLDEN RING RD",
    "dropphycty": "ROSEDALE",
    "dropphyst": "MD",
    "dropphyzpp": 212379998,
    "dropmaladd": "7000 GOLDEN RING RD",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "MD",
    "dropmalzpp": 212379998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103918074,
    "dropsitcph": 4103918074,
    "dropfax": 4103919364
  },
  {
    "dcode": "D",
    "dropkey": "BV24454",
    "droptype": "D",
    "dropname": "SUITLAND",
    "dropdeladd": "4520 SUITLAND RD",
    "dropdelcty": "SUITLAND",
    "dropdelst": "MD",
    "dropdelzpp": 207469997,
    "dropphyadd": "4520 SUITLAND RD",
    "dropphycty": "SUITLAND",
    "dropphyst": "MD",
    "dropphyzpp": 207469997,
    "dropmaladd": "4520 SUITLAND RD",
    "dropmalcty": "SUITLAND",
    "dropmalst": "MD",
    "dropmalzpp": 207469997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017351939,
    "dropsitcph": 3017351939,
    "dropfax": 3017355274
  },
  {
    "dcode": "D",
    "dropkey": "BV24469",
    "droptype": "D",
    "dropname": "TAKOMA PARK",
    "dropdeladd": "6909 LAUREL AVE",
    "dropdelcty": "TAKOMA PARK",
    "dropdelst": "MD",
    "dropdelzpp": 209129997,
    "dropphyadd": "6909 LAUREL AVE",
    "dropphycty": "TAKOMA PARK",
    "dropphyst": "MD",
    "dropphyzpp": 209129997,
    "dropmaladd": "6909 LAUREL AVE",
    "dropmalcty": "TAKOMA PARK",
    "dropmalst": "MD",
    "dropmalzpp": 209129997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012704393,
    "dropsitcph": 3012704392,
    "dropfax": 3012700201
  },
  {
    "dcode": "D",
    "dropkey": "BV24608",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "10421 MOTOR CITY DR",
    "dropdelcty": "BETHESDA",
    "dropdelst": "MD",
    "dropdelzpp": 208179996,
    "dropphyadd": "10421 MOTOR CITY DR",
    "dropphycty": "BETHESDA",
    "dropphyst": "MD",
    "dropphyzpp": 208179996,
    "dropmaladd": "10421 MOTOR CITY DR",
    "dropmalcty": "BETHESDA",
    "dropmalst": "MD",
    "dropmalzpp": 208179996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017671742,
    "dropsitcph": 3017671742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV24618",
    "droptype": "D",
    "dropname": "WEST HYATTSVILLE",
    "dropdeladd": "3116 HAMILTON ST",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207829997,
    "dropphyadd": "3116 HAMILTON ST",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207829997,
    "dropmaladd": "3116 HAMILTON ST",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207829997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012704394,
    "dropsitcph": 3012704394,
    "dropfax": 3012704395
  },
  {
    "dcode": "D",
    "dropkey": "BV24639",
    "droptype": "D",
    "dropname": "WHEATON",
    "dropdeladd": "11431 AMHERST AVE",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209029997,
    "dropphyadd": "11431 AMHERST AVE",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209029997,
    "dropmaladd": "11431 AMHERST AVE",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209029997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019297831,
    "dropsitcph": 3019297835,
    "dropfax": 3019336233
  },
  {
    "dcode": "D",
    "dropkey": "BV25206",
    "droptype": "D",
    "dropname": "SOUTH PORTLAND",
    "dropdeladd": "15 COTTAGE RD",
    "dropdelcty": "SOUTH PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041063615",
    "dropphyadd": "15 COTTAGE RD",
    "dropphycty": "SOUTH PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041063615",
    "dropmaladd": "15 COTTAGE RD",
    "dropmalcty": "SOUTH PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041063615",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078718455,
    "dropsitcph": 2075102775,
    "dropfax": 2078718455
  },
  {
    "dcode": "D",
    "dropkey": "BV25210",
    "droptype": "D",
    "dropname": "SOUTH WINDHAM",
    "dropdeladd": "57 MAIN ST",
    "dropdelcty": "SOUTH WINDHAM",
    "dropdelst": "ME",
    "dropdelzpp": "040829998",
    "dropphyadd": "57 MAIN ST",
    "dropphycty": "SOUTH WINDHAM",
    "dropphyst": "ME",
    "dropphyzpp": "040829998",
    "dropmaladd": "57 MAIN ST",
    "dropmalcty": "SOUTH WINDHAM",
    "dropmalst": "ME",
    "dropmalzpp": "040829998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078926011,
    "dropsitcph": 2078926011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25349",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "25 S RIVER RD STE 110",
    "dropdelcty": "BEDFORD",
    "dropdelst": "NH",
    "dropdelzpp": "031109717",
    "dropphyadd": "25 S RIVER RD STE 110",
    "dropphycty": "BEDFORD",
    "dropphyst": "NH",
    "dropphyzpp": "031109717",
    "dropmaladd": "25 S RIVER RD STE 110",
    "dropmalcty": "BEDFORD",
    "dropmalst": "NH",
    "dropmalzpp": "031109717",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036270517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25525",
    "droptype": "D",
    "dropname": "HOOKSETT",
    "dropdeladd": "1328 HOOKSETT RD STE 45",
    "dropdelcty": "HOOKSETT",
    "dropdelst": "NH",
    "dropdelzpp": "031069716",
    "dropphyadd": "1328 HOOKSETT RD STE 45",
    "dropphycty": "HOOKSETT",
    "dropphyst": "NH",
    "dropphyzpp": "031069716",
    "dropmaladd": "1328 HOOKSETT RD STE 45",
    "dropmalcty": "HOOKSETT",
    "dropmalst": "NH",
    "dropmalzpp": "031069716",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036230373,
    "dropfax": 6036471399
  },
  {
    "dcode": "D",
    "dropkey": "BV25851",
    "droptype": "D",
    "dropname": "CENTRAL FALLS",
    "dropdeladd": "575 DEXTER ST",
    "dropdelcty": "CENTRAL FALLS",
    "dropdelst": "RI",
    "dropdelzpp": "028632603",
    "dropphyadd": "575 DEXTER ST",
    "dropphycty": "CENTRAL FALLS",
    "dropphyst": "RI",
    "dropphyzpp": "028632603",
    "dropmaladd": "575 DEXTER ST",
    "dropmalcty": "CENTRAL FALLS",
    "dropmalst": "RI",
    "dropmalzpp": "028632603",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017251138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25852",
    "droptype": "D",
    "dropname": "CENTREDALE",
    "dropdeladd": "2050 SMITH ST",
    "dropdelcty": "NORTH PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029119998",
    "dropphyadd": "2050 SMITH ST",
    "dropphycty": "NORTH PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029119998",
    "dropmaladd": "2050 SMITH ST",
    "dropmalcty": "NORTH PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029119998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012327634,
    "dropfax": 4013537180
  },
  {
    "dcode": "D",
    "dropkey": "BV25860",
    "droptype": "D",
    "dropname": "CRANSTON",
    "dropdeladd": "57 ROLFE SQ",
    "dropdelcty": "CRANSTON",
    "dropdelst": "RI",
    "dropdelzpp": "029103499",
    "dropphyadd": "57 ROLFE SQ",
    "dropphycty": "CRANSTON",
    "dropphyst": "RI",
    "dropphyzpp": "029103499",
    "dropmaladd": "57 ROLFE SQ",
    "dropmalcty": "CRANSTON",
    "dropmalst": "RI",
    "dropmalzpp": "029103499",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017818647,
    "dropfax": 4017814915
  },
  {
    "dcode": "D",
    "dropkey": "BV25862",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "2055 DIAMOND HILL RD",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "RI",
    "dropdelzpp": "028649998",
    "dropphyadd": "2055 DIAMOND HILL RD",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "RI",
    "dropphyzpp": "028649998",
    "dropmaladd": "2055 DIAMOND HILL RD",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "RI",
    "dropmalzpp": "028649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013343265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25884",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "200 MIDWAY RD STE 200",
    "dropdelcty": "CRANSTON",
    "dropdelst": "RI",
    "dropdelzpp": "029209998",
    "dropphyadd": "200 MIDWAY RD STE 200",
    "dropphycty": "CRANSTON",
    "dropphyst": "RI",
    "dropphyzpp": "029209998",
    "dropmaladd": "200 MIDWAY RD STE 200",
    "dropmalcty": "CRANSTON",
    "dropmalst": "RI",
    "dropmalzpp": "029209998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4019429855,
    "dropfax": 4019466840
  },
  {
    "dcode": "D",
    "dropkey": "BV25901",
    "droptype": "D",
    "dropname": "JOHNSTON",
    "dropdeladd": "1530 ATWOOD AVE",
    "dropdelcty": "JOHNSTON",
    "dropdelst": "RI",
    "dropdelzpp": "029199998",
    "dropphyadd": "1530 ATWOOD AVE",
    "dropphycty": "JOHNSTON",
    "dropphyst": "RI",
    "dropphyzpp": "029199998",
    "dropmaladd": "1530 ATWOOD AVE",
    "dropmalcty": "JOHNSTON",
    "dropmalst": "RI",
    "dropmalzpp": "029199998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013319367,
    "dropfax": 4012724127
  },
  {
    "dcode": "D",
    "dropkey": "BV25903",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "101 BRIAR LN",
    "dropdelcty": "KINGSTON",
    "dropdelst": "RI",
    "dropdelzpp": "028819998",
    "dropphyadd": "101 BRIAR LN",
    "dropphycty": "KINGSTON",
    "dropphyst": "RI",
    "dropphyzpp": "028819998",
    "dropmaladd": "101 BRIAR LN",
    "dropmalcty": "KINGSTON",
    "dropmalst": "RI",
    "dropmalzpp": "028819998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017837264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25905",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "203 FRONT ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "RI",
    "dropdelzpp": "028659998",
    "dropphyadd": "203 FRONT ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "RI",
    "dropphyzpp": "028659998",
    "dropmaladd": "203 FRONT ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "RI",
    "dropmalzpp": "028659998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017271430,
    "dropfax": 4017221769
  },
  {
    "dcode": "D",
    "dropkey": "BV25911",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "7 COMMERCIAL BLVD",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "RI",
    "dropdelzpp": "028426290",
    "dropphyadd": "7 COMMERCIAL BLVD",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "RI",
    "dropphyzpp": "028426290",
    "dropmaladd": "7 COMMERCIAL BLVD",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "RI",
    "dropmalzpp": "028426290",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018460663,
    "dropfax": 4018461841
  },
  {
    "dcode": "D",
    "dropkey": "BV25916",
    "droptype": "D",
    "dropname": "NARRAGANSETT",
    "dropdeladd": "15 MEMORIAL SQ",
    "dropdelcty": "NARRAGANSETT",
    "dropdelst": "RI",
    "dropdelzpp": "028823391",
    "dropphyadd": "15 MEMORIAL SQ",
    "dropphycty": "NARRAGANSETT",
    "dropphyst": "RI",
    "dropphyzpp": "028823391",
    "dropmaladd": "15 MEMORIAL SQ",
    "dropmalcty": "NARRAGANSETT",
    "dropmalst": "RI",
    "dropmalzpp": "028823391",
    "dropsitphn": 4017525649,
    "dropsitlph": "",
    "dropsitcph": 4017832691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV25930",
    "droptype": "D",
    "dropname": "PEACE DALE",
    "dropdeladd": "551 KINGSTOWN RD",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "RI",
    "dropdelzpp": "028799993",
    "dropphyadd": "551 KINGSTOWN RD",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "RI",
    "dropphyzpp": "028799993",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEACE DALE",
    "dropmalst": "RI",
    "dropmalzpp": "028839997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017832691,
    "dropfax": 4017835059
  },
  {
    "dcode": "D",
    "dropkey": "BV25946",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "378 WILLETT AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "RI",
    "dropdelzpp": "029159991",
    "dropphyadd": "378 WILLETT AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "RI",
    "dropphyzpp": "029159991",
    "dropmaladd": "378 WILLETT AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "RI",
    "dropmalzpp": "029159991",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014332619,
    "dropfax": 4014340239
  },
  {
    "dcode": "D",
    "dropkey": "BV25948",
    "droptype": "D",
    "dropname": "RUMFORD",
    "dropdeladd": "10 NEWMAN AVE",
    "dropdelcty": "RUMFORD",
    "dropdelst": "RI",
    "dropdelzpp": "029169998",
    "dropphyadd": "10 NEWMAN AVE",
    "dropphycty": "RUMFORD",
    "dropphyst": "RI",
    "dropphyzpp": "029169998",
    "dropmaladd": "10 NEWMAN AVE",
    "dropmalcty": "RUMFORD",
    "dropmalst": "RI",
    "dropmalzpp": "029169998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014389548,
    "dropfax": 4014388256
  },
  {
    "dcode": "D",
    "dropkey": "BV25955",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "290 OLD COUNTY RD",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "RI",
    "dropdelzpp": "029179998",
    "dropphyadd": "290 OLD COUNTY RD",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "RI",
    "dropphyzpp": "029179998",
    "dropmaladd": "290 OLD COUNTY RD",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "RI",
    "dropmalzpp": "029179998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012321008,
    "dropfax": 4012311201
  },
  {
    "dcode": "D",
    "dropkey": "BV27022",
    "droptype": "D",
    "dropname": "SOUTH BURLINGTON",
    "dropdeladd": "60 WHITE ST",
    "dropdelcty": "SOUTH BURLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054039998",
    "dropphyadd": "60 WHITE ST",
    "dropphycty": "SOUTH BURLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054039998",
    "dropmaladd": "60 WHITE ST",
    "dropmalcty": "SOUTH BURLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054039998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026580923,
    "dropsitcph": 8028626668,
    "dropfax": 8028607336
  },
  {
    "dcode": "D",
    "dropkey": "BV27291",
    "droptype": "D",
    "dropname": "WINOOSKI",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "WINOOSKI",
    "dropdelst": "VT",
    "dropdelzpp": "054049998",
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "WINOOSKI",
    "dropphyst": "VT",
    "dropphyzpp": "054049998",
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "WINOOSKI",
    "dropmalst": "VT",
    "dropmalzpp": "054049998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026580923,
    "dropsitcph": 8026551323,
    "dropfax": 8026552338
  },
  {
    "dcode": "D",
    "dropkey": "BV27312",
    "droptype": "D",
    "dropname": "PIKESVILLE",
    "dropdeladd": "1325 BEDFORD AVE",
    "dropdelcty": "PIKESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 212829998,
    "dropphyadd": "1325 BEDFORD AVE",
    "dropphycty": "PIKESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 212829998,
    "dropmaladd": "1325 BEDFORD AVE",
    "dropmalcty": "PIKESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 212829998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103582454,
    "dropsitcph": 4103582454,
    "dropfax": 4106021199
  },
  {
    "dcode": "D",
    "dropkey": "BV27337",
    "droptype": "D",
    "dropname": "FAYVILLE",
    "dropdeladd": "67 TURNPIKE RD",
    "dropdelcty": "FAYVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "017452101",
    "dropphyadd": "67 TURNPIKE RD",
    "dropphycty": "FAYVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "017452101",
    "dropmaladd": "67 TURNPIKE RD",
    "dropmalcty": "FAYVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "017452101",
    "dropsitphn": 5086647031,
    "dropsitlph": 5084852669,
    "dropsitcph": 5084855262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV27384",
    "droptype": "D",
    "dropname": "WATERTOWN FINANCIAL",
    "dropdeladd": "126 MAIN ST",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "024724416",
    "dropphyadd": "126 MAIN ST",
    "dropphycty": "WATERTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "024724416",
    "dropmaladd": "PO BOX 719998",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "024719998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6179241215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV27419",
    "droptype": "D",
    "dropname": "WILMINGTON BOX",
    "dropdeladd": "147 QUIGLEY BLVD",
    "dropdelcty": "HISTORIC NEW CASTLE",
    "dropdelst": "DE",
    "dropdelzpp": 197209696,
    "dropphyadd": "147 QUIGLEY BLVD",
    "dropphycty": "HISTORIC NEW CASTLE",
    "dropphyst": "DE",
    "dropphyzpp": 197209696,
    "dropmaladd": "PO BOX 10000",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198509996,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023232260,
    "dropfax": 3023233702
  },
  {
    "dcode": "D",
    "dropkey": "BV27426",
    "droptype": "D",
    "dropname": "WAQUOIT",
    "dropdeladd": "36 CARRIAGE SHOP RD",
    "dropdelcty": "EAST FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025369991",
    "dropphyadd": "36 CARRIAGE SHOP RD",
    "dropphycty": "EAST FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025369991",
    "dropmaladd": "36 CARRIAGE SHOP RD",
    "dropmalcty": "EAST FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025369991",
    "dropsitphn": 5085485578,
    "dropsitlph": 5085485578,
    "dropsitcph": 5085486606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV27459",
    "droptype": "D",
    "dropname": "EAST PROVIDENCE FINANCE UNIT",
    "dropdeladd": "17 GROVE AVE",
    "dropdelcty": "EAST PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029144506",
    "dropphyadd": "17 GROVE AVE",
    "dropphycty": "EAST PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029144506",
    "dropmaladd": "17 GROVE AVE",
    "dropmalcty": "EAST PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029144506",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014347845,
    "dropfax": 4014341292
  },
  {
    "dcode": "D",
    "dropkey": "BV27524",
    "droptype": "D",
    "dropname": "ANDREWS AFB",
    "dropdeladd": "1668 D ST",
    "dropdelcty": "JB ANDREWS",
    "dropdelst": "MD",
    "dropdelzpp": 207629998,
    "dropphyadd": "1668 D ST",
    "dropphycty": "JB ANDREWS",
    "dropphyst": "MD",
    "dropphyzpp": 207629998,
    "dropmaladd": "1668 D ST",
    "dropmalcty": "JB ANDREWS",
    "dropmalst": "MD",
    "dropmalzpp": 207629998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015682218,
    "dropsitcph": 3015682218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV27525",
    "droptype": "D",
    "dropname": "GREENBUSH",
    "dropdeladd": "25 FORD RD",
    "dropdelcty": "SCITUATE",
    "dropdelst": "MA",
    "dropdelzpp": "020669991",
    "dropphyadd": "25 FORD RD",
    "dropphycty": "SCITUATE",
    "dropphyst": "MA",
    "dropphyzpp": "020669991",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENBUSH",
    "dropmalst": "MA",
    "dropmalzpp": "020409998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815454829,
    "dropfax": 7815451583
  },
  {
    "dcode": "D",
    "dropkey": "BV27526",
    "droptype": "D",
    "dropname": "MINOT",
    "dropdeladd": "76 GLADES RD UNIT 1",
    "dropdelcty": "SCITUATE",
    "dropdelst": "MA",
    "dropdelzpp": "020661242",
    "dropphyadd": "76 GLADES RD UNIT 1",
    "dropphycty": "SCITUATE",
    "dropphyst": "MA",
    "dropphyzpp": "020661242",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINOT",
    "dropmalst": "MA",
    "dropmalzpp": "020559998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815451378,
    "dropfax": 7815451583
  },
  {
    "dcode": "D",
    "dropkey": "BV27527",
    "droptype": "D",
    "dropname": "NORTH SCITUATE",
    "dropdeladd": "357 GANNETT RD",
    "dropdelcty": "SCITUATE",
    "dropdelst": "MA",
    "dropdelzpp": "020669992",
    "dropphyadd": "357 GANNETT RD",
    "dropphycty": "SCITUATE",
    "dropphyst": "MA",
    "dropphyzpp": "020669992",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH SCITUATE",
    "dropmalst": "MA",
    "dropmalzpp": "020609998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815450934,
    "dropfax": 7815451583
  },
  {
    "dcode": "D",
    "dropkey": "BV27586",
    "droptype": "D",
    "dropname": "TALLEYVILLE",
    "dropdeladd": "3911 CONCORD PIKE",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198039995,
    "dropphyadd": "3911 CONCORD PIKE",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198039995,
    "dropmaladd": "3911 CONCORD PIKE",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198039995,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024785753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BV27590",
    "droptype": "D",
    "dropname": "LOCH RAVEN",
    "dropdeladd": "808 GLENEAGLES CT STE 1",
    "dropdelcty": "TOWSON",
    "dropdelst": "MD",
    "dropdelzpp": 212862205,
    "dropphyadd": "808 GLENEAGLES CT STE 1",
    "dropphycty": "TOWSON",
    "dropphyst": "MD",
    "dropphyzpp": 212862205,
    "dropmaladd": "808 GLENEAGLES CT STE 1",
    "dropmalcty": "TOWSON",
    "dropmalst": "MD",
    "dropmalzpp": 212862205,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102963056,
    "dropsitcph": 4102963056,
    "dropfax": 4105830608
  },
  {
    "dcode": "D",
    "dropkey": "BV27634",
    "droptype": "D",
    "dropname": "TOWSON",
    "dropdeladd": "101 W CHESAPEAKE AVE",
    "dropdelcty": "TOWSON",
    "dropdelst": "MD",
    "dropdelzpp": 212859998,
    "dropphyadd": "101 W CHESAPEAKE AVE",
    "dropphycty": "TOWSON",
    "dropphyst": "MD",
    "dropphyzpp": 212859998,
    "dropmaladd": "101 W CHESAPEAKE AVE",
    "dropmalcty": "TOWSON",
    "dropmalst": "MD",
    "dropmalzpp": 212859998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108286324,
    "dropsitcph": 4108286324,
    "dropfax": 4103397823
  },
  {
    "dcode": "D",
    "dropkey": "BV27652",
    "droptype": "D",
    "dropname": "ELKRIDGE",
    "dropdeladd": "6655 SANTA BARBARA RD",
    "dropdelcty": "ELKRIDGE",
    "dropdelst": "MD",
    "dropdelzpp": 210759998,
    "dropphyadd": "6655 SANTA BARBARA RD",
    "dropphycty": "ELKRIDGE",
    "dropphyst": "MD",
    "dropphyzpp": 210759998,
    "dropmaladd": "6655 SANTA BARBARA RD",
    "dropmalcty": "ELKRIDGE",
    "dropmalst": "MD",
    "dropmalzpp": 210759998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103791535,
    "dropsitcph": 4103791535,
    "dropfax": 4107967816
  },
  {
    "dcode": "D",
    "dropkey": "BV28206",
    "droptype": "D",
    "dropname": "WINDSOR MILL",
    "dropdeladd": "2513 N ROLLING RD",
    "dropdelcty": "WINDSOR MILL",
    "dropdelst": "MD",
    "dropdelzpp": 212449998,
    "dropphyadd": "2513 N ROLLING RD",
    "dropphycty": "WINDSOR MILL",
    "dropphyst": "MD",
    "dropphyzpp": 212449998,
    "dropmaladd": "2513 N ROLLING RD",
    "dropmalcty": "WINDSOR MILL",
    "dropmalst": "MD",
    "dropmalzpp": 212449998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4105949284,
    "dropsitcph": 4105949284,
    "dropfax": 4105949318
  },
  {
    "dcode": "D",
    "dropkey": "BW1A015",
    "droptype": "D",
    "dropname": "MILLARD HIGHLANDS",
    "dropdeladd": "4433 S 133RD ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681379998,
    "dropphyadd": "4433 S 133RD ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681379998,
    "dropmaladd": "4433 S 133RD ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027582724,
    "dropsitcph": 4027582722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1A074",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "6012 N 102ND ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681349998,
    "dropphyadd": "6012 N 102ND ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681349998,
    "dropmaladd": "6012 N 102ND ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024936420,
    "dropsitcph": 4029654026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1A087",
    "droptype": "D",
    "dropname": "OFFUTT AFB",
    "dropdeladd": "906 GARLAND ST",
    "dropdelcty": "OFFUTT AFB",
    "dropdelst": "NE",
    "dropdelzpp": 681133126,
    "dropphyadd": "906 GARLAND ST",
    "dropphycty": "OFFUTT AFB",
    "dropphyst": "NE",
    "dropphyzpp": 681133126,
    "dropmaladd": "906 GARLAND ST",
    "dropmalcty": "OFFUTT AFB",
    "dropmalst": "NE",
    "dropmalzpp": 681133126,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022919788,
    "dropsitcph": 4022928304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1A113",
    "droptype": "D",
    "dropname": "PAPILLION",
    "dropdeladd": "909 N ADAMS ST",
    "dropdelcty": "PAPILLION",
    "dropdelst": "NE",
    "dropdelzpp": 680469998,
    "dropphyadd": "909 N ADAMS ST",
    "dropphycty": "PAPILLION",
    "dropphyst": "NE",
    "dropphyzpp": 680469998,
    "dropmaladd": "909 N ADAMS ST",
    "dropmalcty": "PAPILLION",
    "dropmalst": "NE",
    "dropmalzpp": 680469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023314989,
    "dropsitcph": 4023314978,
    "dropfax": 4023396930
  },
  {
    "dcode": "D",
    "dropkey": "BW1A160",
    "droptype": "D",
    "dropname": "RALSTON",
    "dropdeladd": "7300 MAIN ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681279998,
    "dropphyadd": "7300 MAIN ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681279998,
    "dropmaladd": "7300 MAIN ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023315749,
    "dropsitcph": 4023315739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1B371",
    "droptype": "D",
    "dropname": "FE WARREN AFB",
    "dropdeladd": "6109 RANDALL AVE",
    "dropdelcty": "FE WARREN AFB",
    "dropdelst": "WY",
    "dropdelzpp": 820019983,
    "dropphyadd": "6109 RANDALL AVE",
    "dropphycty": "FE WARREN AFB",
    "dropphyst": "WY",
    "dropphyzpp": 820019983,
    "dropmaladd": "6109 RANDALL AVE",
    "dropmalcty": "FE WARREN AFB",
    "dropmalst": "WY",
    "dropmalzpp": 820019983,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077727083,
    "dropsitcph": 3077733409,
    "dropfax": 3077726583
  },
  {
    "dcode": "D",
    "dropkey": "BW1B778",
    "droptype": "D",
    "dropname": "NORTH RIVERSIDE NDC",
    "dropdeladd": "7300 W 25TH ST",
    "dropdelcty": "NORTH RIVERSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 605469800,
    "dropphyadd": "7300 W 25TH ST",
    "dropphycty": "NORTH RIVERSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 605469800,
    "dropmaladd": "7300 W 25TH ST",
    "dropmalcty": "NORTH RIVERSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 605469800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7084470514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1C145",
    "droptype": "D",
    "dropname": "ORLAND PARK RETAIL",
    "dropdeladd": "15128 S LA GRANGE RD",
    "dropdelcty": "ORLAND PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604629800,
    "dropphyadd": "15128 S LA GRANGE RD",
    "dropphycty": "ORLAND PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604629800,
    "dropmaladd": "15128 S LA GRANGE RD",
    "dropmalcty": "ORLAND PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604629800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7082260249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW1C561",
    "droptype": "D",
    "dropname": "KIRKWOOD POSTAL STORE",
    "dropdeladd": "343 S KIRKWOOD RD STE 105",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631226099,
    "dropphyadd": "343 S KIRKWOOD RD STE 105",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631226099,
    "dropmaladd": "343 S KIRKWOOD RD STE 105",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631226099,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149099887,
    "dropsitcph": 3149660638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW10441",
    "droptype": "D",
    "dropname": "DURANGO",
    "dropdeladd": "100 DURANGO RD",
    "dropdelcty": "DURANGO",
    "dropdelst": "IA",
    "dropdelzpp": 520399738,
    "dropphyadd": "100 DURANGO RD",
    "dropphycty": "DURANGO",
    "dropphyst": "IA",
    "dropphyzpp": 520399738,
    "dropmaladd": "100 DURANGO RD",
    "dropmalcty": "DURANGO",
    "dropmalst": "IA",
    "dropmalzpp": 520399738,
    "dropsitphn": 5152837530,
    "dropsitlph": 3195522102,
    "dropsitcph": 3195522102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW10479",
    "droptype": "D",
    "dropname": "ELKPORT",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "ELKPORT",
    "dropdelst": "IA",
    "dropdelzpp": 520448300,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "ELKPORT",
    "dropphyst": "IA",
    "dropphyzpp": 520448300,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "ELKPORT",
    "dropmalst": "IA",
    "dropmalzpp": 520448300,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199286212,
    "dropsitcph": 3199286212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW11242",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "1300 NE 56TH ST",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503177073,
    "dropphyadd": "1300 NE 56TH ST",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503177073,
    "dropmaladd": "1300 NE 56TH ST",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503177073,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152640361,
    "dropsitcph": 5152999275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW11722",
    "droptype": "D",
    "dropname": "WEST DES MOINES",
    "dropdeladd": "430 5TH ST",
    "dropdelcty": "WEST DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 502654638,
    "dropphyadd": "430 5TH ST",
    "dropphycty": "WEST DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 502654638,
    "dropmaladd": "430 5TH ST",
    "dropmalcty": "WEST DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 502654638,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152556080,
    "dropsitcph": 5152556471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW11834",
    "droptype": "D",
    "dropname": "ALORTON",
    "dropdeladd": "4825 BOND AVE",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622079998,
    "dropphyadd": "4825 BOND AVE",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622079998,
    "dropmaladd": "4825 BOND AVE",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622079998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188743736,
    "dropsitcph": 6188743736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW11985",
    "droptype": "D",
    "dropname": "BARTONVILLE",
    "dropdeladd": "5814 S ADAMS ST",
    "dropdelcty": "BARTONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 616071906,
    "dropphyadd": "5814 S ADAMS ST",
    "dropphycty": "BARTONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 616071906,
    "dropmaladd": "5814 S ADAMS ST",
    "dropmalcty": "BARTONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 616071906,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085437318,
    "dropsitcph": 3096331142,
    "dropfax": 3096331159
  },
  {
    "dcode": "D",
    "dropkey": "BW12115",
    "droptype": "D",
    "dropname": "LEMONT",
    "dropdeladd": "42 STEPHEN ST",
    "dropdelcty": "LEMONT",
    "dropdelst": "IL",
    "dropdelzpp": 604399998,
    "dropphyadd": "42 STEPHEN ST",
    "dropphycty": "LEMONT",
    "dropphyst": "IL",
    "dropphyzpp": 604399998,
    "dropmaladd": "42 STEPHEN ST",
    "dropmalcty": "LEMONT",
    "dropmalst": "IL",
    "dropmalzpp": 604399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 6302576204,
    "dropfax": 6302576438
  },
  {
    "dcode": "D",
    "dropkey": "BW12166",
    "droptype": "D",
    "dropname": "BRIDGEVIEW",
    "dropdeladd": "7401 W 100TH PL",
    "dropdelcty": "BRIDGEVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 604559998,
    "dropphyadd": "7401 W 100TH PL",
    "dropphycty": "BRIDGEVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 604559998,
    "dropmaladd": "7401 W 100TH PL",
    "dropmalcty": "BRIDGEVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 604559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7082335562,
    "dropfax": 7082337374
  },
  {
    "dcode": "D",
    "dropkey": "BW12174",
    "droptype": "D",
    "dropname": "BROADVIEW",
    "dropdeladd": "2131 S 17TH AVE",
    "dropdelcty": "BROADVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 601553081,
    "dropphyadd": "2131 S 17TH AVE",
    "dropphycty": "BROADVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 601553081,
    "dropmaladd": "2131 S 17TH AVE",
    "dropmalcty": "BROADVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 601553081,
    "dropsitphn": 6302605499,
    "dropsitlph": 7083453882,
    "dropsitcph": 7083453882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW12254",
    "droptype": "D",
    "dropname": "CAHOKIA",
    "dropdeladd": "801 RANGE LN",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622069998,
    "dropphyadd": "801 RANGE LN",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622069998,
    "dropmaladd": "801 RANGE LN",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622069998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183323571,
    "dropsitcph": 6183323571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW12419",
    "droptype": "D",
    "dropname": "CICERO",
    "dropdeladd": "2440 S LARAMIE AVE",
    "dropdelcty": "CICERO",
    "dropdelst": "IL",
    "dropdelzpp": 608049998,
    "dropphyadd": "2440 S LARAMIE AVE",
    "dropphycty": "CICERO",
    "dropphyst": "IL",
    "dropphyzpp": 608049998,
    "dropmaladd": "2440 S LARAMIE AVE",
    "dropmalcty": "CICERO",
    "dropmalst": "IL",
    "dropmalzpp": 608049998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7086526880,
    "dropfax": 7086521138
  },
  {
    "dcode": "D",
    "dropkey": "BW12521",
    "droptype": "D",
    "dropname": "COUNTRY CLUB HILLS",
    "dropdeladd": "4053 183RD ST",
    "dropdelcty": "COUNTRY CLUB HILLS",
    "dropdelst": "IL",
    "dropdelzpp": 604789800,
    "dropphyadd": "4053 183RD ST",
    "dropphycty": "COUNTRY CLUB HILLS",
    "dropphyst": "IL",
    "dropphyzpp": 604789800,
    "dropmaladd": "4053 183RD ST",
    "dropmalcty": "COUNTRY CLUB HILLS",
    "dropmalst": "IL",
    "dropmalzpp": 604789800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087997633,
    "dropfax": 7085329969
  },
  {
    "dcode": "D",
    "dropkey": "BW12771",
    "droptype": "D",
    "dropname": "EAST PEORIA",
    "dropdeladd": "415 E WASHINGTON ST",
    "dropdelcty": "EAST PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616112639,
    "dropphyadd": "415 E WASHINGTON ST",
    "dropphycty": "EAST PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616112639,
    "dropmaladd": "415 E WASHINGTON ST",
    "dropmalcty": "EAST PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616112639,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096941167,
    "dropfax": 3096941162
  },
  {
    "dcode": "D",
    "dropkey": "BW12839",
    "droptype": "D",
    "dropname": "ELK GROVE VILLAGE",
    "dropdeladd": "611 LANDMEIER RD",
    "dropdelcty": "ELK GROVE VILLAGE",
    "dropdelst": "IL",
    "dropdelzpp": 600074765,
    "dropphyadd": "611 LANDMEIER RD",
    "dropphycty": "ELK GROVE VILLAGE",
    "dropphyst": "IL",
    "dropphyzpp": 600074765,
    "dropmaladd": "611 LANDMEIER RD",
    "dropmalcty": "ELK GROVE VILLAGE",
    "dropmalst": "IL",
    "dropmalzpp": 600074765,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474395573,
    "dropsitcph": 8474395573,
    "dropfax": 8474399672
  },
  {
    "dcode": "D",
    "dropkey": "BW12866",
    "droptype": "D",
    "dropname": "ELMWOOD PARK",
    "dropdeladd": "7300 W FULLERTON AVE",
    "dropdelcty": "ELMWOOD PARK",
    "dropdelst": "IL",
    "dropdelzpp": 607079998,
    "dropphyadd": "7300 W FULLERTON AVE",
    "dropphycty": "ELMWOOD PARK",
    "dropphyst": "IL",
    "dropphyzpp": 607079998,
    "dropmaladd": "7300 W FULLERTON AVE",
    "dropmalcty": "ELMWOOD PARK",
    "dropmalst": "IL",
    "dropmalzpp": 607079998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7084534390,
    "dropfax": 7084530651
  },
  {
    "dcode": "D",
    "dropkey": "BW12907",
    "droptype": "D",
    "dropname": "EVERGREEN PARK",
    "dropdeladd": "9359 S KEDZIE AVE",
    "dropdelcty": "EVERGREEN PARK",
    "dropdelst": "IL",
    "dropdelzpp": 608059998,
    "dropphyadd": "9359 S KEDZIE AVE",
    "dropphycty": "EVERGREEN PARK",
    "dropphyst": "IL",
    "dropphyzpp": 608059998,
    "dropmaladd": "9359 S KEDZIE AVE",
    "dropmalcty": "EVERGREEN PARK",
    "dropmalst": "IL",
    "dropmalzpp": 608059998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7084220740,
    "dropfax": 7734238763
  },
  {
    "dcode": "D",
    "dropkey": "BW13121",
    "droptype": "D",
    "dropname": "GLENDALE HEIGHTS",
    "dropdeladd": "147 E NORTH AVE",
    "dropdelcty": "GLENDALE HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 601392088,
    "dropphyadd": "147 E NORTH AVE",
    "dropphycty": "GLENDALE HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 601392088,
    "dropmaladd": "147 E NORTH AVE",
    "dropmalcty": "GLENDALE HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 601392088,
    "dropsitphn": 6302605499,
    "dropsitlph": 6303077104,
    "dropsitcph": 6303077104,
    "dropfax": 6303079931
  },
  {
    "dcode": "D",
    "dropkey": "BW13181",
    "droptype": "D",
    "dropname": "GREAT LAKES",
    "dropdeladd": "525 BRONSON AVE",
    "dropdelcty": "GREAT LAKES",
    "dropdelst": "IL",
    "dropdelzpp": 600882948,
    "dropphyadd": "525 BRONSON AVE",
    "dropphycty": "GREAT LAKES",
    "dropphyst": "IL",
    "dropphyzpp": 600882948,
    "dropmaladd": "525 BRONSON AVE",
    "dropmalcty": "GREAT LAKES",
    "dropmalst": "IL",
    "dropmalzpp": 600882948,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474739195,
    "dropsitcph": 8474739195,
    "dropfax": 8474739197
  },
  {
    "dcode": "D",
    "dropkey": "BW13263",
    "droptype": "D",
    "dropname": "HARWOOD HEIGHTS",
    "dropdeladd": "7101 W GUNNISON ST",
    "dropdelcty": "HARWOOD HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 607069998,
    "dropphyadd": "7101 W GUNNISON ST",
    "dropphycty": "HARWOOD HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 607069998,
    "dropmaladd": "7101 W GUNNISON ST",
    "dropmalcty": "HARWOOD HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 607069998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7088674713,
    "dropfax": 7088670072
  },
  {
    "dcode": "D",
    "dropkey": "BW13327",
    "droptype": "D",
    "dropname": "HILLSIDE",
    "dropdeladd": "505 N WOLF RD",
    "dropdelcty": "HILLSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 601621270,
    "dropphyadd": "505 N WOLF RD",
    "dropphycty": "HILLSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 601621270,
    "dropmaladd": "505 N WOLF RD",
    "dropmalcty": "HILLSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 601621270,
    "dropsitphn": 6302605499,
    "dropsitlph": 7085443347,
    "dropsitcph": 7085443347,
    "dropfax": 7085441056
  },
  {
    "dcode": "D",
    "dropkey": "BW13342",
    "droptype": "D",
    "dropname": "HODGKINS",
    "dropdeladd": "8990 LYONS ST",
    "dropdelcty": "HODGKINS",
    "dropdelst": "IL",
    "dropdelzpp": 605257628,
    "dropphyadd": "8990 LYONS ST",
    "dropphycty": "HODGKINS",
    "dropphyst": "IL",
    "dropphyzpp": 605257628,
    "dropmaladd": "8990 LYONS ST",
    "dropmalcty": "HODGKINS",
    "dropmalst": "IL",
    "dropmalzpp": 605257628,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083523611,
    "dropfax": 7083523669
  },
  {
    "dcode": "D",
    "dropkey": "BW13347",
    "droptype": "D",
    "dropname": "HOFFMAN ESTATES",
    "dropdeladd": "1255 GANNON DR",
    "dropdelcty": "HOFFMAN ESTATES",
    "dropdelst": "IL",
    "dropdelzpp": 601697057,
    "dropphyadd": "1255 GANNON DR",
    "dropphycty": "HOFFMAN ESTATES",
    "dropphyst": "IL",
    "dropphyzpp": 601697057,
    "dropmaladd": "1255 GANNON DR",
    "dropmalcty": "HOFFMAN ESTATES",
    "dropmalst": "IL",
    "dropmalzpp": 601697057,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478856514,
    "dropsitcph": 8478856514,
    "dropfax": 8478851454
  },
  {
    "dcode": "D",
    "dropkey": "BW13582",
    "droptype": "D",
    "dropname": "LA GRANGE PARK",
    "dropdeladd": "701 E 31ST ST",
    "dropdelcty": "LA GRANGE PARK",
    "dropdelst": "IL",
    "dropdelzpp": 605269800,
    "dropphyadd": "701 E 31ST ST",
    "dropphycty": "LA GRANGE PARK",
    "dropphyst": "IL",
    "dropphyzpp": 605269800,
    "dropmaladd": "701 E 31ST ST",
    "dropmalcty": "LA GRANGE PARK",
    "dropmalst": "IL",
    "dropmalzpp": 605269800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083544606,
    "dropfax": 7083523669
  },
  {
    "dcode": "D",
    "dropkey": "BW13765",
    "droptype": "D",
    "dropname": "LOVES PARK",
    "dropdeladd": "1702 WINDSOR RD",
    "dropdelcty": "LOVES PARK",
    "dropdelst": "IL",
    "dropdelzpp": 611119711,
    "dropphyadd": "1702 WINDSOR RD",
    "dropphycty": "LOVES PARK",
    "dropphyst": "IL",
    "dropphyzpp": 611119711,
    "dropmaladd": "1702 WINDSOR RD",
    "dropmalcty": "LOVES PARK",
    "dropmalst": "IL",
    "dropmalzpp": 611119711,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156542161,
    "dropsitcph": 8156542161,
    "dropfax": 8158777085
  },
  {
    "dcode": "D",
    "dropkey": "BW13832",
    "droptype": "D",
    "dropname": "MARKHAM",
    "dropdeladd": "16011 KEDZIE AVE",
    "dropdelcty": "MARKHAM",
    "dropdelst": "IL",
    "dropdelzpp": 604289998,
    "dropphyadd": "16011 KEDZIE AVE",
    "dropphycty": "MARKHAM",
    "dropphyst": "IL",
    "dropphyzpp": 604289998,
    "dropmaladd": "15441 CENTER AVE",
    "dropmalcty": "HARVEY",
    "dropmalst": "IL",
    "dropmalzpp": 604263656,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083391211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW13869",
    "droptype": "D",
    "dropname": "MC COOK",
    "dropdeladd": "5000 GLENCOE AVE STE 1A",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "IL",
    "dropdelzpp": 605257804,
    "dropphyadd": "5000 GLENCOE AVE STE 1A",
    "dropphycty": "LA GRANGE",
    "dropphyst": "IL",
    "dropphyzpp": 605257804,
    "dropmaladd": "5000 GLENCOE AVE STE 1A",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "IL",
    "dropmalzpp": 605257804,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7084472171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW13980",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "506 E CHAIN OF ROCKS RD",
    "dropdelcty": "GRANITE CITY",
    "dropdelst": "IL",
    "dropdelzpp": 620409996,
    "dropphyadd": "506 E CHAIN OF ROCKS RD",
    "dropphycty": "GRANITE CITY",
    "dropphyst": "IL",
    "dropphyzpp": 620409996,
    "dropmaladd": "506 E CHAIN OF ROCKS RD",
    "dropmalcty": "GRANITE CITY",
    "dropmalst": "IL",
    "dropmalzpp": 620409996,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188770700,
    "dropsitcph": 6188770700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW14008",
    "droptype": "D",
    "dropname": "MOOSEHEART",
    "dropdeladd": "25 S INTERNATIONAL DR",
    "dropdelcty": "MOOSEHEART",
    "dropdelst": "IL",
    "dropdelzpp": 605399800,
    "dropphyadd": "25 S INTERNATIONAL DR",
    "dropphycty": "MOOSEHEART",
    "dropphyst": "IL",
    "dropphyzpp": 605399800,
    "dropmaladd": "25 S INTERNATIONAL DR",
    "dropmalcty": "MOOSEHEART",
    "dropmalst": "IL",
    "dropmalzpp": 605399800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6307232084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW14160",
    "droptype": "D",
    "dropname": "NILES",
    "dropdeladd": "6977 W OAKTON ST",
    "dropdelcty": "NILES",
    "dropdelst": "IL",
    "dropdelzpp": 607149998,
    "dropphyadd": "6977 W OAKTON ST",
    "dropphycty": "NILES",
    "dropphyst": "IL",
    "dropphyzpp": 607149998,
    "dropmaladd": "6977 W OAKTON ST",
    "dropmalcty": "NILES",
    "dropmalst": "IL",
    "dropmalzpp": 607149998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 8479671989,
    "dropfax": 8479678852
  },
  {
    "dcode": "D",
    "dropkey": "BW14193",
    "droptype": "D",
    "dropname": "NORTH RIVERSIDE",
    "dropdeladd": "7300 W 25TH ST",
    "dropdelcty": "NORTH RIVERSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 605469998,
    "dropphyadd": "7300 W 25TH ST",
    "dropphycty": "NORTH RIVERSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 605469998,
    "dropmaladd": "7300 W 25TH ST",
    "dropmalcty": "NORTH RIVERSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 605469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 7084428207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW14206",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "1787 ORCHARD LN",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 600933400,
    "dropphyadd": "1787 ORCHARD LN",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 600933400,
    "dropmaladd": "1787 ORCHARD LN",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 600933400,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474463777,
    "dropsitcph": 8474463777,
    "dropfax": 8474466701
  },
  {
    "dcode": "D",
    "dropkey": "BW14208",
    "droptype": "D",
    "dropname": "NORTHLAKE",
    "dropdeladd": "47 W NORTH AVE",
    "dropdelcty": "NORTHLAKE",
    "dropdelst": "IL",
    "dropdelzpp": 601642583,
    "dropphyadd": "47 W NORTH AVE",
    "dropphycty": "NORTHLAKE",
    "dropphyst": "IL",
    "dropphyzpp": 601642583,
    "dropmaladd": "47 W NORTH AVE",
    "dropmalcty": "NORTHLAKE",
    "dropmalst": "IL",
    "dropmalzpp": 601642583,
    "dropsitphn": 6302605499,
    "dropsitlph": 7084920533,
    "dropsitcph": 7084920533,
    "dropfax": 7084920663
  },
  {
    "dcode": "D",
    "dropkey": "BW14230",
    "droptype": "D",
    "dropname": "HINSDALE",
    "dropdeladd": "109 SYMONDS DR",
    "dropdelcty": "HINSDALE",
    "dropdelst": "IL",
    "dropdelzpp": 605213763,
    "dropphyadd": "109 SYMONDS DR",
    "dropphycty": "HINSDALE",
    "dropphyst": "IL",
    "dropphyzpp": 605213763,
    "dropmaladd": "1314 KENSINGTON RD",
    "dropmalcty": "OAK BROOK",
    "dropmalst": "IL",
    "dropmalzpp": 605239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6303231490,
    "dropfax": 6309904234
  },
  {
    "dcode": "D",
    "dropkey": "BW14232",
    "droptype": "D",
    "dropname": "OAK BROOK MALL",
    "dropdeladd": "100 OAKBROOK CTR",
    "dropdelcty": "OAK BROOK",
    "dropdelst": "IL",
    "dropdelzpp": 605231838,
    "dropphyadd": "100 OAKBROOK CTR",
    "dropphycty": "OAK BROOK",
    "dropphyst": "IL",
    "dropphyzpp": 605231838,
    "dropmaladd": "1314 KENSINGTON RD",
    "dropmalcty": "OAK BROOK",
    "dropmalst": "IL",
    "dropmalzpp": 605239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085730213,
    "dropsitcph": 6309904224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW14621",
    "droptype": "D",
    "dropname": "RIVER FOREST",
    "dropdeladd": "401 WILLIAM ST",
    "dropdelcty": "RIVER FOREST",
    "dropdelst": "IL",
    "dropdelzpp": 603051900,
    "dropphyadd": "401 WILLIAM ST",
    "dropphycty": "RIVER FOREST",
    "dropphyst": "IL",
    "dropphyzpp": 603051900,
    "dropmaladd": "401 WILLIAM ST",
    "dropmalcty": "RIVER FOREST",
    "dropmalst": "IL",
    "dropmalzpp": 603051900,
    "dropsitphn": 6302605499,
    "dropsitlph": 7083660977,
    "dropsitcph": 7083660977,
    "dropfax": 7083661484
  },
  {
    "dcode": "D",
    "dropkey": "BW14624",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "661 W 138TH ST",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "IL",
    "dropdelzpp": 608279998,
    "dropphyadd": "661 W 138TH ST",
    "dropphycty": "RIVERDALE",
    "dropphyst": "IL",
    "dropphyzpp": 608279998,
    "dropmaladd": "661 W 138TH ST",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "IL",
    "dropmalzpp": 608279998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7088490453,
    "dropfax": 7082010316
  },
  {
    "dcode": "D",
    "dropkey": "BW14682",
    "droptype": "D",
    "dropname": "LOCKPORT",
    "dropdeladd": "423 N STATE ST",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 604419807,
    "dropphyadd": "423 N STATE ST",
    "dropphycty": "LOCKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 604419807,
    "dropmaladd": "423 N STATE ST",
    "dropmalcty": "LOCKPORT",
    "dropmalst": "IL",
    "dropmalzpp": 604419807,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158869040,
    "dropfax": 8153729862
  },
  {
    "dcode": "D",
    "dropkey": "BW14697",
    "droptype": "D",
    "dropname": "ROSELLE",
    "dropdeladd": "256 CENTRAL AVE",
    "dropdelcty": "ROSELLE",
    "dropdelst": "IL",
    "dropdelzpp": 601721979,
    "dropphyadd": "256 CENTRAL AVE",
    "dropphycty": "ROSELLE",
    "dropphyst": "IL",
    "dropphyzpp": 601721979,
    "dropmaladd": "256 CENTRAL AVE",
    "dropmalcty": "ROSELLE",
    "dropmalst": "IL",
    "dropmalzpp": 601721979,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308937247,
    "dropsitcph": 6308937247,
    "dropfax": 6308930714
  },
  {
    "dcode": "D",
    "dropkey": "BW14699",
    "droptype": "D",
    "dropname": "ROSEMONT",
    "dropdeladd": "9507 W HIGGINS RD",
    "dropdelcty": "ROSEMONT",
    "dropdelst": "IL",
    "dropdelzpp": 600185000,
    "dropphyadd": "9507 W HIGGINS RD",
    "dropphycty": "ROSEMONT",
    "dropphyst": "IL",
    "dropphyzpp": 600185000,
    "dropmaladd": "9507 W HIGGINS RD",
    "dropmalcty": "ROSEMONT",
    "dropmalst": "IL",
    "dropmalzpp": 600185000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476983089,
    "dropsitcph": 8478275591,
    "dropfax": 8478273924
  },
  {
    "dcode": "D",
    "dropkey": "BW14791",
    "droptype": "D",
    "dropname": "SAUK VILLAGE",
    "dropdeladd": "5 SURREY BROOK PLZ",
    "dropdelcty": "SAUK VILLAGE",
    "dropdelst": "IL",
    "dropdelzpp": 604117300,
    "dropphyadd": "5 SURREY BROOK PLZ",
    "dropphycty": "SAUK VILLAGE",
    "dropphyst": "IL",
    "dropphyzpp": 604117300,
    "dropmaladd": "1333 W END AVE",
    "dropmalcty": "CHICAGO HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 604119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7087573876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW14808",
    "droptype": "D",
    "dropname": "SCHILLER PARK",
    "dropdeladd": "9460 IRVING PARK RD",
    "dropdelcty": "SCHILLER PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601761956,
    "dropphyadd": "9460 IRVING PARK RD",
    "dropphycty": "SCHILLER PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601761956,
    "dropmaladd": "9460 IRVING PARK RD",
    "dropmalcty": "SCHILLER PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601761956,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476781308,
    "dropsitcph": 8476781308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15191",
    "droptype": "D",
    "dropname": "STREAMWOOD",
    "dropdeladd": "115 E IRVING PARK RD",
    "dropdelcty": "STREAMWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 601072971,
    "dropphyadd": "115 E IRVING PARK RD",
    "dropphycty": "STREAMWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 601072971,
    "dropmaladd": "115 E IRVING PARK RD",
    "dropmalcty": "STREAMWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 601072971,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308373500,
    "dropsitcph": 6308373500,
    "dropfax": 6308375871
  },
  {
    "dcode": "D",
    "dropkey": "BW15222",
    "droptype": "D",
    "dropname": "SUNNYLAND",
    "dropdeladd": "14 SUNNYLAND PLZ",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 615711996,
    "dropphyadd": "14 SUNNYLAND PLZ",
    "dropphycty": "WASHINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 615711996,
    "dropmaladd": "106 S HIGH ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 615719998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3094444044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15369",
    "droptype": "D",
    "dropname": "VERNON HILLS",
    "dropdeladd": "675 LAKEVIEW PKWY",
    "dropdelcty": "VERNON HILLS",
    "dropdelst": "IL",
    "dropdelzpp": 600611466,
    "dropphyadd": "675 LAKEVIEW PKWY",
    "dropphycty": "VERNON HILLS",
    "dropphyst": "IL",
    "dropphyzpp": 600611466,
    "dropmaladd": "675 LAKEVIEW PKWY",
    "dropmalcty": "VERNON HILLS",
    "dropmalst": "IL",
    "dropmalzpp": 600611466,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475663901,
    "dropsitcph": 8475663901,
    "dropfax": 8473670951
  },
  {
    "dcode": "D",
    "dropkey": "BW15446",
    "droptype": "D",
    "dropname": "WASHINGTON PARK",
    "dropdeladd": "6110 FOREST BLVD",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622049998,
    "dropphyadd": "6110 FOREST BLVD",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622049998,
    "dropmaladd": "950 MISSOURI AVE",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188743826,
    "dropsitcph": 6188743826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15498",
    "droptype": "D",
    "dropname": "WESTCHESTER",
    "dropdeladd": "10240 W ROOSEVELT RD STE A",
    "dropdelcty": "WESTCHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 601542577,
    "dropphyadd": "10240 W ROOSEVELT RD STE A",
    "dropphycty": "WESTCHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 601542577,
    "dropmaladd": "10240 W ROOSEVELT RD STE A",
    "dropmalcty": "WESTCHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 601542577,
    "dropsitphn": 6302605499,
    "dropsitlph": 7084500170,
    "dropsitcph": 7084500170,
    "dropfax": 7083440238
  },
  {
    "dcode": "D",
    "dropkey": "BW15603",
    "droptype": "D",
    "dropname": "WOODRIDGE",
    "dropdeladd": "2 PLAZA DR",
    "dropdelcty": "WOODRIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 605179998,
    "dropphyadd": "2 PLAZA DR",
    "dropphycty": "WOODRIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 605179998,
    "dropmaladd": "2 PLAZA DR",
    "dropmalcty": "WOODRIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 605179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6305159070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15654",
    "droptype": "D",
    "dropname": "AFFTON",
    "dropdeladd": "55 GRASSO PLZ",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631239998,
    "dropphyadd": "55 GRASSO PLZ",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631239998,
    "dropmaladd": "55 GRASSO PLZ",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145447929,
    "dropsitcph": 3145447929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15833",
    "droptype": "D",
    "dropname": "BERKELEY",
    "dropdeladd": "8655 AIRPORT RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631349998,
    "dropphyadd": "8655 AIRPORT RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631349998,
    "dropmaladd": "8655 AIRPORT RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145213986,
    "dropsitcph": 3145216551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15948",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "8764 ROSALIE AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631449998,
    "dropphyadd": "8764 ROSALIE AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631449998,
    "dropmaladd": "8764 ROSALIE AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143512319,
    "dropsitcph": 3149686318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW15955",
    "droptype": "D",
    "dropname": "BRIDGETON",
    "dropdeladd": "12255 NATURAL BRIDGE RD",
    "dropdelcty": "BRIDGETON",
    "dropdelst": "MO",
    "dropdelzpp": 630449998,
    "dropphyadd": "12255 NATURAL BRIDGE RD",
    "dropphycty": "BRIDGETON",
    "dropphyst": "MO",
    "dropphyzpp": 630449998,
    "dropmaladd": "12255 NATURAL BRIDGE RD",
    "dropmalcty": "BRIDGETON",
    "dropmalst": "MO",
    "dropmalzpp": 630449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3147398678,
    "dropsitcph": 3142091693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16195",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "7750 MARYLAND AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631059998,
    "dropphyadd": "7750 MARYLAND AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631059998,
    "dropmaladd": "7750 MARYLAND AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631059998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148621822,
    "dropsitcph": 3148621822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16273",
    "droptype": "D",
    "dropname": "CREVE COEUR",
    "dropdeladd": "331 N NEW BALLAS RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631419998,
    "dropphyadd": "331 N NEW BALLAS RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631419998,
    "dropmaladd": "331 N NEW BALLAS RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144328211,
    "dropsitcph": 3144323664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16336",
    "droptype": "D",
    "dropname": "DES PERES",
    "dropdeladd": "1015 GRUPP RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631319998,
    "dropphyadd": "1015 GRUPP RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631319998,
    "dropmaladd": "1015 GRUPP RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149666397,
    "dropsitcph": 3149663437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16339",
    "droptype": "D",
    "dropname": "DESLOGE",
    "dropdeladd": "301 N DESLOGE DR",
    "dropdelcty": "DESLOGE",
    "dropdelst": "MO",
    "dropdelzpp": 636013532,
    "dropphyadd": "301 N DESLOGE DR",
    "dropphycty": "DESLOGE",
    "dropphyst": "MO",
    "dropphyzpp": 636013532,
    "dropmaladd": "302 T J STEWART DR",
    "dropmalcty": "PARK HILLS",
    "dropmalst": "MO",
    "dropmalzpp": 636019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734314906,
    "dropsitcph": 5734312257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16482",
    "droptype": "D",
    "dropname": "FERGUSON",
    "dropdeladd": "225 SAINT LOUIS AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631359998,
    "dropphyadd": "225 SAINT LOUIS AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631359998,
    "dropmaladd": "225 SAINT LOUIS AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145212550,
    "dropsitcph": 3145216099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16581",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "7170 N BROADWAY ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641189998,
    "dropphyadd": "7170 N BROADWAY ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641189998,
    "dropmaladd": "7170 N BROADWAY ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641189998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8164366587,
    "dropsitcph": 8164363038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW16868",
    "droptype": "D",
    "dropname": "JENNINGS",
    "dropdeladd": "9810 HALLS FERRY RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631369998,
    "dropphyadd": "9810 HALLS FERRY RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631369998,
    "dropmaladd": "9810 HALLS FERRY RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148670418,
    "dropsitcph": 3148670768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17021",
    "droptype": "D",
    "dropname": "CHARLES J COYLE",
    "dropdeladd": "1203 LEMAY FERRY RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631259998,
    "dropphyadd": "1203 LEMAY FERRY RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631259998,
    "dropmaladd": "1203 LEMAY FERRY RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145445169,
    "dropsitcph": 3145449832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17131",
    "droptype": "D",
    "dropname": "MACKENZIE POINTE",
    "dropdeladd": "7217 WATSON RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631199998,
    "dropphyadd": "7217 WATSON RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631199998,
    "dropmaladd": "7217 WATSON RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143515638,
    "dropsitcph": 3143515638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17154",
    "droptype": "D",
    "dropname": "MAPLEWOOD",
    "dropdeladd": "2800 MARSHALL AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631439998,
    "dropphyadd": "2800 MARSHALL AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631439998,
    "dropmaladd": "2800 MARSHALL AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3146450872,
    "dropsitcph": 3146453179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17187",
    "droptype": "D",
    "dropname": "MARYLAND HEIGHTS",
    "dropdeladd": "177 WELDON PKWY",
    "dropdelcty": "MARYLAND HEIGHTS",
    "dropdelst": "MO",
    "dropdelzpp": 630439998,
    "dropphyadd": "177 WELDON PKWY",
    "dropphycty": "MARYLAND HEIGHTS",
    "dropphyst": "MO",
    "dropphyzpp": 630439998,
    "dropmaladd": "177 WELDON PKWY",
    "dropmalcty": "MARYLAND HEIGHTS",
    "dropmalst": "MO",
    "dropmalzpp": 630439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145677767,
    "dropsitcph": 3145677767,
    "dropfax": 3145673569
  },
  {
    "dcode": "D",
    "dropkey": "BW17393",
    "droptype": "D",
    "dropname": "NORMANDY",
    "dropdeladd": "7450 NATURAL BRIDGE RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631219998,
    "dropphyadd": "7450 NATURAL BRIDGE RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631219998,
    "dropmaladd": "7450 NATURAL BRIDGE RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143857599,
    "dropsitcph": 3143852694,
    "dropfax": 3143816890
  },
  {
    "dcode": "D",
    "dropkey": "BW17394",
    "droptype": "D",
    "dropname": "NORTH COUNTY",
    "dropdeladd": "11001 DUNKLIN DR",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631389998,
    "dropphyadd": "11001 DUNKLIN DR",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631389998,
    "dropmaladd": "11001 DUNKLIN DR",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148690566,
    "dropsitcph": 3148690566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17396",
    "droptype": "D",
    "dropname": "NORTH KANSAS CITY",
    "dropdeladd": "820 ARMOUR RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641169998,
    "dropphyadd": "820 ARMOUR RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641169998,
    "dropmaladd": "820 ARMOUR RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641169998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162216716,
    "dropsitcph": 8162216716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17446",
    "droptype": "D",
    "dropname": "OLIVETTE",
    "dropdeladd": "9621 OLIVE BLVD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631329998,
    "dropphyadd": "9621 OLIVE BLVD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631329998,
    "dropmaladd": "9621 OLIVE BLVD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149947051,
    "dropsitcph": 3149940058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17466",
    "droptype": "D",
    "dropname": "TIMOTHY M GAFFNEY",
    "dropdeladd": "2318 WOODSON RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631149998,
    "dropphyadd": "2318 WOODSON RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631149998,
    "dropmaladd": "2318 WOODSON RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144271095,
    "dropsitcph": 3144278945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17492",
    "droptype": "D",
    "dropname": "PARKVILLE",
    "dropdeladd": "105 EAST ST",
    "dropdelcty": "PARKVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 641529998,
    "dropphyadd": "105 EAST ST",
    "dropphycty": "PARKVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 641529998,
    "dropmaladd": "105 EAST ST",
    "dropmalcty": "PARKVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 641529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167411762,
    "dropsitcph": 8167415973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17639",
    "droptype": "D",
    "dropname": "RAYTOWN",
    "dropdeladd": "10501 E 63RD ST",
    "dropdelcty": "RAYTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 641339998,
    "dropphyadd": "10501 E 63RD ST",
    "dropphycty": "RAYTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 641339998,
    "dropmaladd": "10501 E 63RD ST",
    "dropmalcty": "RAYTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 641339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163560686,
    "dropsitcph": 8163136872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17682",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "4900 NW GATEWAY AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "MO",
    "dropdelzpp": 641509998,
    "dropphyadd": "4900 NW GATEWAY AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "MO",
    "dropphyzpp": 641509998,
    "dropmaladd": "4900 NW GATEWAY AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "MO",
    "dropmalzpp": 641509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165841986,
    "dropsitcph": 8165849912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17803",
    "droptype": "D",
    "dropname": "SAINT LOUIS AIR MAIL CENTER",
    "dropdeladd": "9855 AIR CARGO RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631454500,
    "dropphyadd": "9855 AIR CARGO RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631454500,
    "dropmaladd": "PO BOX 45900",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631455900,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144366819,
    "dropsitcph": 3144366819,
    "dropfax": 3144275883
  },
  {
    "dcode": "D",
    "dropkey": "BW17874",
    "droptype": "D",
    "dropname": "SAPPINGTON",
    "dropdeladd": "11662 GRAVOIS RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631269998,
    "dropphyadd": "11662 GRAVOIS RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631269998,
    "dropmaladd": "11662 GRAVOIS RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148432560,
    "dropsitcph": 3148436316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17956",
    "droptype": "D",
    "dropname": "SOUTH COUNTY",
    "dropdeladd": "5636 TELEGRAPH RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631299998,
    "dropphyadd": "5636 TELEGRAPH RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631299998,
    "dropmaladd": "5636 TELEGRAPH RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631299998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148464152,
    "dropsitcph": 3148464152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW17957",
    "droptype": "D",
    "dropname": "SOUTH COUNTY POSTAL STORE",
    "dropdeladd": "375A S COUNTY CENTER WAY",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631299997,
    "dropphyadd": "375A S COUNTY CENTER WAY",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631299997,
    "dropmaladd": "375A S COUNTY CENTER WAY",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631299997,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148923598,
    "dropsitcph": 3148462380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW18459",
    "droptype": "D",
    "dropname": "TOWN AND COUNTRY",
    "dropdeladd": "1100 TOWN AND COUNTRY COMMONS DR",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 630179997,
    "dropphyadd": "1100 TOWN AND COUNTRY COMMONS DR",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 630179997,
    "dropmaladd": "1100 TOWN AND COUNTRY COMMONS DR",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 630179997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363912374,
    "dropsitcph": 6363914970,
    "dropfax": 6363913025
  },
  {
    "dcode": "D",
    "dropkey": "BW18503",
    "droptype": "D",
    "dropname": "UNIVERSITY CITY",
    "dropdeladd": "561 KINGSLAND AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631309998,
    "dropphyadd": "561 KINGSLAND AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631309998,
    "dropmaladd": "561 KINGSLAND AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3147214286,
    "dropsitcph": 3147261067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW18626",
    "droptype": "D",
    "dropname": "WEST COUNTY",
    "dropdeladd": "2002 CONGRESSIONAL DR",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631469998,
    "dropphyadd": "2002 CONGRESSIONAL DR",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631469998,
    "dropmaladd": "2002 CONGRESSIONAL DR",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149935172,
    "dropsitcph": 3149931402,
    "dropfax": 3149937068
  },
  {
    "dcode": "D",
    "dropkey": "BW18968",
    "droptype": "D",
    "dropname": "GRAND FORKS AFB",
    "dropdeladd": "590 HOLZAPPLE ST",
    "dropdelcty": "GRAND FORKS AFB",
    "dropdelst": "ND",
    "dropdelzpp": 582041000,
    "dropphyadd": "590 HOLZAPPLE ST",
    "dropphycty": "GRAND FORKS AFB",
    "dropphyst": "ND",
    "dropphyzpp": 582041000,
    "dropmaladd": "590 HOLZAPPLE ST",
    "dropmalcty": "GRAND FORKS AFB",
    "dropmalst": "ND",
    "dropmalzpp": 582041000,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017473339,
    "dropsitcph": 7017473339,
    "dropfax": 7017475231
  },
  {
    "dcode": "D",
    "dropkey": "BW19150",
    "droptype": "D",
    "dropname": "MINOT AFB",
    "dropdeladd": "220 PEACEKEEPER PL",
    "dropdelcty": "MINOT AFB",
    "dropdelst": "ND",
    "dropdelzpp": 587049998,
    "dropphyadd": "220 PEACEKEEPER PL",
    "dropphycty": "MINOT AFB",
    "dropphyst": "ND",
    "dropphyzpp": 587049998,
    "dropmaladd": "220 PEACEKEEPER PL",
    "dropmalcty": "MINOT AFB",
    "dropmalst": "ND",
    "dropmalzpp": 587049998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017276488,
    "dropsitcph": 7017276488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW20186",
    "droptype": "D",
    "dropname": "BLUE VALLEY",
    "dropdeladd": "12433 ANTIOCH RD",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662139998,
    "dropphyadd": "12433 ANTIOCH RD",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662139998,
    "dropmaladd": "12433 ANTIOCH RD",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662139998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138974233,
    "dropsitcph": 9138974936,
    "dropfax": 9136850516
  },
  {
    "dcode": "D",
    "dropkey": "BW20221",
    "droptype": "D",
    "dropname": "BROOKRIDGE",
    "dropdeladd": "9727 ANTIOCH RD",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662129998,
    "dropphyadd": "9727 ANTIOCH RD",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662129998,
    "dropmaladd": "9727 ANTIOCH RD",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136496590,
    "dropsitcph": 9136497504,
    "dropfax": 9136482541
  },
  {
    "dcode": "D",
    "dropkey": "BW20476",
    "droptype": "D",
    "dropname": "EDWARDSVILLE",
    "dropdeladd": "104 S 4TH ST",
    "dropdelcty": "EDWARDSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 661119998,
    "dropphyadd": "104 S 4TH ST",
    "dropphycty": "EDWARDSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 661119998,
    "dropmaladd": "1310 N 78TH TER",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9134410416,
    "dropsitcph": 9134228573,
    "dropfax": 9133349576
  },
  {
    "dcode": "D",
    "dropkey": "BW20548",
    "droptype": "D",
    "dropname": "FORT LEAVENWORTH",
    "dropdeladd": "311 KEARNY AVE",
    "dropdelcty": "FORT LEAVENWORTH",
    "dropdelst": "KS",
    "dropdelzpp": 660279997,
    "dropphyadd": "311 KEARNY AVE",
    "dropphycty": "FORT LEAVENWORTH",
    "dropphyst": "KS",
    "dropphyzpp": 660279997,
    "dropmaladd": "311 KEARNY AVE",
    "dropmalcty": "FORT LEAVENWORTH",
    "dropmalst": "KS",
    "dropmalzpp": 660279997,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136801648,
    "dropsitcph": 9136801648,
    "dropfax": 6505784535
  },
  {
    "dcode": "D",
    "dropkey": "BW20549",
    "droptype": "D",
    "dropname": "FORT RILEY",
    "dropdeladd": "5302 MORELOCK ST",
    "dropdelcty": "FORT RILEY",
    "dropdelst": "KS",
    "dropdelzpp": 664429998,
    "dropphyadd": "5302 MORELOCK ST",
    "dropphycty": "FORT RILEY",
    "dropphyst": "KS",
    "dropphyzpp": 664429998,
    "dropmaladd": "5302 MORELOCK ST",
    "dropmalcty": "FORT RILEY",
    "dropmalst": "KS",
    "dropmalzpp": 664429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857842865,
    "dropsitcph": 7857842865,
    "dropfax": 7857844700
  },
  {
    "dcode": "D",
    "dropkey": "BW20568",
    "droptype": "D",
    "dropname": "FRONTENAC",
    "dropdeladd": "204 E MCKAY ST",
    "dropdelcty": "FRONTENAC",
    "dropdelst": "KS",
    "dropdelzpp": 667639998,
    "dropphyadd": "204 E MCKAY ST",
    "dropphycty": "FRONTENAC",
    "dropphyst": "KS",
    "dropphyzpp": 667639998,
    "dropmaladd": "204 E MCKAY ST",
    "dropmalcty": "FRONTENAC",
    "dropmalst": "KS",
    "dropmalzpp": 667639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202319660,
    "dropsitcph": 6202319660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW20746",
    "droptype": "D",
    "dropname": "INDIAN CREEK",
    "dropdeladd": "4225 W 107TH ST",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662079998,
    "dropphyadd": "4225 W 107TH ST",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662079998,
    "dropmaladd": "4225 W 107TH ST",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662079998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9133815246,
    "dropsitcph": 9133814695,
    "dropfax": 9136492371
  },
  {
    "dcode": "D",
    "dropkey": "BW20846",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "617 HOLIDAY PLZ",
    "dropdelcty": "LANSING",
    "dropdelst": "KS",
    "dropdelzpp": 660439998,
    "dropphyadd": "617 HOLIDAY PLZ",
    "dropphycty": "LANSING",
    "dropphyst": "KS",
    "dropphyzpp": 660439998,
    "dropmaladd": "617 HOLIDAY PLZ",
    "dropmalcty": "LANSING",
    "dropmalst": "KS",
    "dropmalzpp": 660439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136801648,
    "dropsitcph": 9136801648,
    "dropfax": 6505784535
  },
  {
    "dcode": "D",
    "dropkey": "BW20866",
    "droptype": "D",
    "dropname": "LENEXA",
    "dropdeladd": "8820 MONROVIA ST",
    "dropdelcty": "LENEXA",
    "dropdelst": "KS",
    "dropdelzpp": 662159998,
    "dropphyadd": "8820 MONROVIA ST",
    "dropphycty": "LENEXA",
    "dropphyst": "KS",
    "dropphyzpp": 662159998,
    "dropmaladd": "8820 MONROVIA ST",
    "dropmalcty": "LENEXA",
    "dropmalst": "KS",
    "dropmalzpp": 662159998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138886396,
    "dropsitcph": 9138880448,
    "dropfax": 9138881483
  },
  {
    "dcode": "D",
    "dropkey": "BW21018",
    "droptype": "D",
    "dropname": "MISSION",
    "dropdeladd": "5419 JOHNSON DR",
    "dropdelcty": "MISSION",
    "dropdelst": "KS",
    "dropdelzpp": 662059998,
    "dropphyadd": "5419 JOHNSON DR",
    "dropphycty": "MISSION",
    "dropphyst": "KS",
    "dropphyzpp": 662059998,
    "dropmaladd": "5419 JOHNSON DR",
    "dropmalcty": "MISSION",
    "dropmalst": "KS",
    "dropmalzpp": 662059998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136776727,
    "dropsitcph": 9138315375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW21171",
    "droptype": "D",
    "dropname": "OVERLAND PARK",
    "dropdeladd": "8010 CONSER ST",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662049998,
    "dropphyadd": "8010 CONSER ST",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662049998,
    "dropmaladd": "8010 CONSER ST",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136487833,
    "dropsitcph": 9136486206,
    "dropfax": 9136482297
  },
  {
    "dcode": "D",
    "dropkey": "BW21388",
    "droptype": "D",
    "dropname": "SHAWNEE",
    "dropdeladd": "6201 NIEMAN RD",
    "dropdelcty": "SHAWNEE",
    "dropdelst": "KS",
    "dropdelzpp": 662039998,
    "dropphyadd": "6201 NIEMAN RD",
    "dropphycty": "SHAWNEE",
    "dropphyst": "KS",
    "dropphyzpp": 662039998,
    "dropmaladd": "6201 NIEMAN RD",
    "dropmalcty": "SHAWNEE",
    "dropmalst": "KS",
    "dropmalzpp": 662039998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136310760,
    "dropsitcph": 9136316209,
    "dropfax": 9136318799
  },
  {
    "dcode": "D",
    "dropkey": "BW21555",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "7500 W 151ST ST",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662239998,
    "dropphyadd": "7500 W 151ST ST",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662239998,
    "dropmaladd": "7500 W 151ST ST",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136818462,
    "dropsitcph": 9138976357,
    "dropfax": 9138978360
  },
  {
    "dcode": "D",
    "dropkey": "BW21831",
    "droptype": "D",
    "dropname": "ALTUS AFB",
    "dropdeladd": "204 S 3RD ST",
    "dropdelcty": "ALTUS AFB",
    "dropdelst": "OK",
    "dropdelzpp": 735239998,
    "dropphyadd": "204 S 3RD ST",
    "dropphycty": "ALTUS AFB",
    "dropphyst": "OK",
    "dropphyzpp": 735239998,
    "dropmaladd": "217 W CYPRESS ST",
    "dropmalcty": "ALTUS",
    "dropmalst": "OK",
    "dropmalzpp": 735219998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054822065,
    "dropsitcph": 5804822065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW22073",
    "droptype": "D",
    "dropname": "FORT SILL",
    "dropdeladd": "930 FORT SILL BLVD STE 100",
    "dropdelcty": "FORT SILL",
    "dropdelst": "OK",
    "dropdelzpp": 735039998,
    "dropphyadd": "930 FORT SILL BLVD STE 100",
    "dropphycty": "FORT SILL",
    "dropphyst": "OK",
    "dropphyzpp": 735039998,
    "dropmaladd": "930 FORT SILL BLVD STE 100",
    "dropmalcty": "FORT SILL",
    "dropmalst": "OK",
    "dropmalzpp": 735039998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803557738,
    "dropsitcph": 5803557738,
    "dropfax": 5803534082
  },
  {
    "dcode": "D",
    "dropkey": "BW22278",
    "droptype": "D",
    "dropname": "MIDWEST CITY",
    "dropdeladd": "8275 E RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731109998,
    "dropphyadd": "8275 E RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731109998,
    "dropmaladd": "8275 E RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731109998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057327401,
    "dropsitcph": 4057328601,
    "dropfax": 4057325375
  },
  {
    "dcode": "D",
    "dropkey": "BW22289",
    "droptype": "D",
    "dropname": "MOORE",
    "dropdeladd": "601 S SERVICE RD",
    "dropdelcty": "MOORE",
    "dropdelst": "OK",
    "dropdelzpp": 731609998,
    "dropphyadd": "601 S SERVICE RD",
    "dropphycty": "MOORE",
    "dropphyst": "OK",
    "dropphyzpp": 731609998,
    "dropmaladd": "601 S SERVICE RD",
    "dropmalcty": "MOORE",
    "dropmalst": "OK",
    "dropmalzpp": 731609998,
    "dropsitphn": 4057941690,
    "dropsitlph": 4057941690,
    "dropsitcph": 4057941690,
    "dropfax": 4057946948
  },
  {
    "dcode": "D",
    "dropkey": "BW22556",
    "droptype": "D",
    "dropname": "TINKER AFB",
    "dropdeladd": "3681 H AVE BLDG 478",
    "dropdelcty": "TINKER AFB",
    "dropdelst": "OK",
    "dropdelzpp": 731459998,
    "dropphyadd": "3681 H AVE BLDG 478",
    "dropphycty": "TINKER AFB",
    "dropphyst": "OK",
    "dropphyzpp": 731459998,
    "dropmaladd": "3681 H AVE BLDG 478",
    "dropmalcty": "TINKER AFB",
    "dropmalst": "OK",
    "dropmalzpp": 731459998,
    "dropsitphn": 4057327401,
    "dropsitlph": 4057328601,
    "dropsitcph": 4057346048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW22594",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "2304 W HEFNER RD",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731209998,
    "dropphyadd": "2304 W HEFNER RD",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731209998,
    "dropmaladd": "2304 W HEFNER RD",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731209998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057517384,
    "dropsitcph": 4057517096,
    "dropfax": 4057516058
  },
  {
    "dcode": "D",
    "dropkey": "BW22699",
    "droptype": "D",
    "dropname": "ALAMO HEIGHTS",
    "dropdeladd": "4801 BROADWAY",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782095703,
    "dropphyadd": "4801 BROADWAY",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782095703,
    "dropmaladd": "4801 BROADWAY",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782095703,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109305780,
    "dropsitcph": 2108260230,
    "dropfax": 2108295893
  },
  {
    "dcode": "D",
    "dropkey": "BW22833",
    "droptype": "D",
    "dropname": "BALCH SPRINGS",
    "dropdeladd": "3400 HICKORY TREE RD",
    "dropdelcty": "BALCH SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 751809998,
    "dropphyadd": "3400 HICKORY TREE RD",
    "dropphycty": "BALCH SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 751809998,
    "dropmaladd": "120 E GRUBB DR",
    "dropmalcty": "MESQUITE",
    "dropmalst": "TX",
    "dropmalzpp": 751499998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722865481,
    "dropsitcph": 9722865481,
    "dropfax": 9725570755
  },
  {
    "dcode": "D",
    "dropkey": "BW22903",
    "droptype": "D",
    "dropname": "BELLMEAD",
    "dropdeladd": "901 BANK DR",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767059998,
    "dropphyadd": "901 BANK DR",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767059998,
    "dropmaladd": "901 BANK DR",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547991546,
    "dropsitcph": 2547991546,
    "dropfax": 2548670834
  },
  {
    "dcode": "D",
    "dropkey": "BW22917",
    "droptype": "D",
    "dropname": "BENBROOK",
    "dropdeladd": "9415 HIGHWAY 377 S",
    "dropdelcty": "BENBROOK",
    "dropdelst": "TX",
    "dropdelzpp": 761269998,
    "dropphyadd": "9415 HIGHWAY 377 S",
    "dropphycty": "BENBROOK",
    "dropphyst": "TX",
    "dropphyzpp": 761269998,
    "dropmaladd": "9415 HIGHWAY 377 S",
    "dropmalcty": "BENBROOK",
    "dropmalst": "TX",
    "dropmalzpp": 761269998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172493845,
    "dropsitcph": 8172497579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23135",
    "droptype": "D",
    "dropname": "CANYON LAKE",
    "dropdeladd": "1300 FM 2673",
    "dropdelcty": "CANYON LAKE",
    "dropdelst": "TX",
    "dropdelzpp": 781339998,
    "dropphyadd": "1300 FM 2673",
    "dropphycty": "CANYON LAKE",
    "dropphyst": "TX",
    "dropphyzpp": 781339998,
    "dropmaladd": "1300 FM 2673",
    "dropmalcty": "CANYON LAKE",
    "dropmalst": "TX",
    "dropmalzpp": 781339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306257736,
    "dropsitcph": 8309644100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23160",
    "droptype": "D",
    "dropname": "NAVAL AIR STATION JRB",
    "dropdeladd": "1501 ARNOLD AVE",
    "dropdelcty": "NAVAL AIR STATION JRB",
    "dropdelst": "TX",
    "dropdelzpp": 761279998,
    "dropphyadd": "1501 ARNOLD AVE",
    "dropphycty": "NAVAL AIR STATION JRB",
    "dropphyst": "TX",
    "dropphyzpp": 761279998,
    "dropmaladd": "1501 ARNOLD AVE",
    "dropmalcty": "NAVAL AIR STATION JRB",
    "dropmalst": "TX",
    "dropmalzpp": 761279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8177351086,
    "dropsitcph": 8177322635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23395",
    "droptype": "D",
    "dropname": "CRYSTAL BEACH",
    "dropdeladd": "2200 HIGHWAY 87",
    "dropdelcty": "PORT BOLIVAR",
    "dropdelst": "TX",
    "dropdelzpp": 776500717,
    "dropphyadd": "2200 HIGHWAY 87",
    "dropphycty": "PORT BOLIVAR",
    "dropphyst": "TX",
    "dropphyzpp": 776500717,
    "dropmaladd": "PO BOX 3099",
    "dropmalcty": "PORT BOLIVAR",
    "dropmalst": "TX",
    "dropmalzpp": 776503099,
    "dropsitphn": 7132263055,
    "dropsitlph": 4096841773,
    "dropsitcph": 4096845281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23568",
    "droptype": "D",
    "dropname": "DYESS AFB",
    "dropdeladd": "2201 AVENUE B",
    "dropdelcty": "DYESS AFB",
    "dropdelst": "TX",
    "dropdelzpp": 796071724,
    "dropphyadd": "2201 AVENUE B",
    "dropphycty": "DYESS AFB",
    "dropphyst": "TX",
    "dropphyzpp": 796071724,
    "dropmaladd": "2201 AVENUE B",
    "dropmalcty": "DYESS AFB",
    "dropmalst": "TX",
    "dropmalzpp": 796071724,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256957965,
    "dropsitcph": 3256957965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23573",
    "droptype": "D",
    "dropname": "EARLY",
    "dropdeladd": "101 CRESCENT DR",
    "dropdelcty": "EARLY",
    "dropdelst": "TX",
    "dropdelzpp": 768029998,
    "dropphyadd": "101 CRESCENT DR",
    "dropphycty": "EARLY",
    "dropphyst": "TX",
    "dropphyzpp": 768029998,
    "dropmaladd": "101 CRESCENT DR",
    "dropmalcty": "EARLY",
    "dropmalst": "TX",
    "dropmalzpp": 768029998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256463530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23713",
    "droptype": "D",
    "dropname": "FARMERS BRANCH",
    "dropdeladd": "13904 JOSEY LN",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752349998,
    "dropphyadd": "13904 JOSEY LN",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752349998,
    "dropmaladd": "13904 JOSEY LN",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752349998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726209132,
    "dropsitcph": 9726209132,
    "dropfax": 9724883127
  },
  {
    "dcode": "D",
    "dropkey": "BW23758",
    "droptype": "D",
    "dropname": "FLOWER MOUND",
    "dropdeladd": "2300 OLYMPIA DR",
    "dropdelcty": "FLOWER MOUND",
    "dropdelst": "TX",
    "dropdelzpp": 750289998,
    "dropphyadd": "2300 OLYMPIA DR",
    "dropphycty": "FLOWER MOUND",
    "dropphyst": "TX",
    "dropphyzpp": 750289998,
    "dropmaladd": "2300 OLYMPIA DR",
    "dropmalcty": "FLOWER MOUND",
    "dropmalst": "TX",
    "dropmalzpp": 750289998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723555963,
    "dropsitcph": 9723555963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW23780",
    "droptype": "D",
    "dropname": "FORT BLISS",
    "dropdeladd": "1733 PLEASONTON RD",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799069998,
    "dropphyadd": "1733 PLEASONTON RD",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799069998,
    "dropmaladd": "1733 PLEASONTON RD",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799069998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155628124,
    "dropsitcph": 9155627298,
    "dropfax": 9155661562
  },
  {
    "dcode": "D",
    "dropkey": "BW23785",
    "droptype": "D",
    "dropname": "FORT CAVAZOS",
    "dropdeladd": "332 761ST TANK BATTALION AVE",
    "dropdelcty": "FORT CAVAZOS",
    "dropdelst": "TX",
    "dropdelzpp": 765449800,
    "dropphyadd": "332 761ST TANK BATTALION AVE",
    "dropphycty": "FORT CAVAZOS",
    "dropphyst": "TX",
    "dropphyzpp": 765449800,
    "dropmaladd": "332 761ST TANK BATTALION AVE",
    "dropmalcty": "FORT CAVAZOS",
    "dropmalst": "TX",
    "dropmalzpp": 765449800,
    "dropsitphn": 2103688387,
    "dropsitlph": 2542871858,
    "dropsitcph": 2542872728,
    "dropfax": 2545324265
  },
  {
    "dcode": "D",
    "dropkey": "BW23793",
    "droptype": "D",
    "dropname": "FORT SAM HOUSTON",
    "dropdeladd": "2492 STANLEY RD",
    "dropdelcty": "JBSA FT SAM HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 782349998,
    "dropphyadd": "2492 STANLEY RD",
    "dropphycty": "JBSA FT SAM HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 782349998,
    "dropmaladd": "2492 STANLEY RD",
    "dropmalcty": "JBSA FT SAM HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 782349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2102260252,
    "dropsitcph": 2102260252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24011",
    "droptype": "D",
    "dropname": "HALTOM CITY",
    "dropdeladd": "5709 BROADWAY AVE",
    "dropdelcty": "HALTOM CITY",
    "dropdelst": "TX",
    "dropdelzpp": 761173325,
    "dropphyadd": "5709 BROADWAY AVE",
    "dropphycty": "HALTOM CITY",
    "dropphyst": "TX",
    "dropphyzpp": 761173325,
    "dropmaladd": "5709 BROADWAY AVE",
    "dropmalcty": "HALTOM CITY",
    "dropmalst": "TX",
    "dropmalzpp": 761173325,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178380068,
    "dropsitcph": 8178388023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24028",
    "droptype": "D",
    "dropname": "HARKER HEIGHTS",
    "dropdeladd": "415 E FM 2410 RD",
    "dropdelcty": "HARKER HEIGHTS",
    "dropdelst": "TX",
    "dropdelzpp": 765489998,
    "dropphyadd": "415 E FM 2410 RD",
    "dropphycty": "HARKER HEIGHTS",
    "dropphyst": "TX",
    "dropphyzpp": 765489998,
    "dropmaladd": "415 E FM 2410 RD",
    "dropmalcty": "HARKER HEIGHTS",
    "dropmalst": "TX",
    "dropmalzpp": 765489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546340281,
    "dropsitcph": 2546992111,
    "dropfax": 2546990123
  },
  {
    "dcode": "D",
    "dropkey": "BW24127",
    "droptype": "D",
    "dropname": "HORSESHOE BAY",
    "dropdeladd": "9740 W FM 2147",
    "dropdelcty": "HORSESHOE BAY",
    "dropdelst": "TX",
    "dropdelzpp": 786579998,
    "dropphyadd": "9740 W FM 2147",
    "dropphycty": "HORSESHOE BAY",
    "dropphyst": "TX",
    "dropphyzpp": 786579998,
    "dropmaladd": "9740 W FM 2147",
    "dropmalcty": "HORSESHOE BAY",
    "dropmalst": "TX",
    "dropmalzpp": 786579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306933531,
    "dropsitcph": 8305988773,
    "dropfax": 8305989387
  },
  {
    "dcode": "D",
    "dropkey": "BW24285",
    "droptype": "D",
    "dropname": "SECURITY SERVICES",
    "dropdeladd": "103 HALL ST STE 4",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782439998,
    "dropphyadd": "103 HALL ST STE 4",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782439998,
    "dropmaladd": "103 HALL ST STE 4",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109258255,
    "dropsitcph": 2109258255,
    "dropfax": 2106756382
  },
  {
    "dcode": "D",
    "dropkey": "BW24319",
    "droptype": "D",
    "dropname": "KINGWOOD",
    "dropdeladd": "4025 FEATHER LAKES WAY",
    "dropdelcty": "KINGWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 773399998,
    "dropphyadd": "4025 FEATHER LAKES WAY",
    "dropphycty": "KINGWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 773399998,
    "dropmaladd": "4025 FEATHER LAKES WAY",
    "dropmalcty": "KINGWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 773399998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2819132111,
    "dropsitcph": 2819131999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24332",
    "droptype": "D",
    "dropname": "KLEIN",
    "dropdeladd": "7717 LOUETTA RD",
    "dropdelcty": "SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 773799998,
    "dropphyadd": "7717 LOUETTA RD",
    "dropphycty": "SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 773799998,
    "dropmaladd": "7717 LOUETTA RD",
    "dropmalcty": "SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 773799998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2812573801,
    "dropsitcph": 2812573806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24368",
    "droptype": "D",
    "dropname": "LACKLAND AFB",
    "dropdeladd": "2261 HUGHES AVE",
    "dropdelcty": "JBSA LACKLAND",
    "dropdelst": "TX",
    "dropdelzpp": 782369998,
    "dropphyadd": "2261 HUGHES AVE",
    "dropphycty": "JBSA LACKLAND",
    "dropphyst": "TX",
    "dropphyzpp": 782369998,
    "dropmaladd": "2261 HUGHES AVE",
    "dropmalcty": "JBSA LACKLAND",
    "dropmalst": "TX",
    "dropmalzpp": 782369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106711058,
    "dropsitcph": 2106745977,
    "dropfax": 2106756382
  },
  {
    "dcode": "D",
    "dropkey": "BW24392",
    "droptype": "D",
    "dropname": "LAKE WORTH",
    "dropdeladd": "3930 TELEPHONE RD",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761359998,
    "dropphyadd": "3930 TELEPHONE RD",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761359998,
    "dropmaladd": "3930 TELEPHONE RD",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761359998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172377413,
    "dropsitcph": 8172375128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24469",
    "droptype": "D",
    "dropname": "LEON VALLEY",
    "dropdeladd": "6825 HUEBNER RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782389998,
    "dropphyadd": "6825 HUEBNER RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782389998,
    "dropmaladd": "6825 HUEBNER RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105205830,
    "dropsitcph": 2105205962,
    "dropfax": 2106809807
  },
  {
    "dcode": "D",
    "dropkey": "BW24566",
    "droptype": "D",
    "dropname": "LUMBERTON",
    "dropdeladd": "650 S MAIN ST",
    "dropdelcty": "LUMBERTON",
    "dropdelst": "TX",
    "dropdelzpp": 776579998,
    "dropphyadd": "650 S MAIN ST",
    "dropphycty": "LUMBERTON",
    "dropphyst": "TX",
    "dropphyzpp": 776579998,
    "dropmaladd": "650 S MAIN ST",
    "dropmalcty": "LUMBERTON",
    "dropmalst": "TX",
    "dropmalzpp": 776579998,
    "dropsitphn": 4097516317,
    "dropsitlph": 4097516317,
    "dropsitcph": 4097516656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW24945",
    "droptype": "D",
    "dropname": "NORTH RICHLAND HILLS",
    "dropdeladd": "6051 DAVIS BLVD",
    "dropdelcty": "NORTH RICHLAND HILLS",
    "dropdelst": "TX",
    "dropdelzpp": 761806385,
    "dropphyadd": "6051 DAVIS BLVD",
    "dropphycty": "NORTH RICHLAND HILLS",
    "dropphyst": "TX",
    "dropphyzpp": 761806385,
    "dropmaladd": "6051 DAVIS BLVD",
    "dropmalcty": "NORTH RICHLAND HILLS",
    "dropmalst": "TX",
    "dropmalzpp": 761806385,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172816876,
    "dropsitcph": 8172815846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW25018",
    "droptype": "D",
    "dropname": "OLD TOWN FINANCE",
    "dropdeladd": "320 S CHARLES ST",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 750579998,
    "dropphyadd": "320 S CHARLES ST",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 750579998,
    "dropmaladd": "194 CIVIC CIR",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 750679998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724369941,
    "dropsitcph": 9723530056,
    "dropfax": 9724367230
  },
  {
    "dcode": "D",
    "dropkey": "BW25246",
    "droptype": "D",
    "dropname": "PRESTONWOOD",
    "dropdeladd": "5995 SUMMERSIDE DR",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752489998,
    "dropphyadd": "5995 SUMMERSIDE DR",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752489998,
    "dropmaladd": "5995 SUMMERSIDE DR",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752489998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9724594622,
    "dropsitcph": 9723805716,
    "dropfax": 9723801426
  },
  {
    "dcode": "D",
    "dropkey": "BW25300",
    "droptype": "D",
    "dropname": "RANDOLPH AFB",
    "dropdeladd": "355 B ST W STE 3",
    "dropdelcty": "JBSA RANDOLPH",
    "dropdelst": "TX",
    "dropdelzpp": 781509998,
    "dropphyadd": "355 B ST W STE 3",
    "dropphycty": "JBSA RANDOLPH",
    "dropphyst": "TX",
    "dropphyzpp": 781509998,
    "dropmaladd": "355 B ST W STE 3",
    "dropmalcty": "JBSA RANDOLPH",
    "dropmalst": "TX",
    "dropmalzpp": 781509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106522606,
    "dropsitcph": 2106522606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW25385",
    "droptype": "D",
    "dropname": "OAKS",
    "dropdeladd": "1008 ROBERTS CUT OFF RD",
    "dropdelcty": "RIVER OAKS",
    "dropdelst": "TX",
    "dropdelzpp": 761149998,
    "dropphyadd": "1008 ROBERTS CUT OFF RD",
    "dropphycty": "RIVER OAKS",
    "dropphyst": "TX",
    "dropphyzpp": 761149998,
    "dropmaladd": "1008 ROBERTS CUT OFF RD",
    "dropmalcty": "RIVER OAKS",
    "dropmalst": "TX",
    "dropmalzpp": 761149998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8177322635,
    "dropsitcph": 8177322635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW25484",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "101 BELMONT ST",
    "dropdelcty": "SAGINAW",
    "dropdelst": "TX",
    "dropdelzpp": 761791601,
    "dropphyadd": "101 BELMONT ST",
    "dropphycty": "SAGINAW",
    "dropphyst": "TX",
    "dropphyzpp": 761791601,
    "dropmaladd": "101 BELMONT ST",
    "dropmalcty": "SAGINAW",
    "dropmalst": "TX",
    "dropmalzpp": 761791601,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172321261,
    "dropsitcph": 8176255864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW25624",
    "droptype": "D",
    "dropname": "SHEPPARD AFB",
    "dropdeladd": "527 I AVE",
    "dropdelcty": "SHEPPARD AFB",
    "dropdelst": "TX",
    "dropdelzpp": 763112502,
    "dropphyadd": "527 I AVE",
    "dropphycty": "SHEPPARD AFB",
    "dropphyst": "TX",
    "dropphyzpp": 763112502,
    "dropmaladd": "PO BOX 91198",
    "dropmalcty": "SHEPPARD AFB",
    "dropmalst": "TX",
    "dropmalzpp": 763119998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408553319,
    "dropsitcph": 9408553319,
    "dropfax": 9408556715
  },
  {
    "dcode": "D",
    "dropkey": "BW25694",
    "droptype": "D",
    "dropname": "SOUTH PADRE ISLAND",
    "dropdeladd": "4701 PADRE BLVD",
    "dropdelcty": "SOUTH PADRE ISLAND",
    "dropdelst": "TX",
    "dropdelzpp": 785979998,
    "dropphyadd": "4701 PADRE BLVD",
    "dropphycty": "SOUTH PADRE ISLAND",
    "dropphyst": "TX",
    "dropphyzpp": 785979998,
    "dropmaladd": "4701 PADRE BLVD",
    "dropmalcty": "SOUTH PADRE ISLAND",
    "dropmalst": "TX",
    "dropmalzpp": 785979998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567614252,
    "dropsitcph": 9567614252,
    "dropfax": 9567611376
  },
  {
    "dcode": "D",
    "dropkey": "BW25710",
    "droptype": "D",
    "dropname": "SOUTHLAKE",
    "dropdeladd": "300 STATE ST",
    "dropdelcty": "SOUTHLAKE",
    "dropdelst": "TX",
    "dropdelzpp": 760929998,
    "dropphyadd": "300 STATE ST",
    "dropphycty": "SOUTHLAKE",
    "dropphyst": "TX",
    "dropphyzpp": 760929998,
    "dropmaladd": "300 STATE ST",
    "dropmalcty": "SOUTHLAKE",
    "dropmalst": "TX",
    "dropmalzpp": 760929998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174166129,
    "dropsitcph": 8174166129,
    "dropfax": 8174166370
  },
  {
    "dcode": "D",
    "dropkey": "BW26009",
    "droptype": "D",
    "dropname": "THE COLONY",
    "dropdeladd": "5200 S COLONY BLVD",
    "dropdelcty": "THE COLONY",
    "dropdelst": "TX",
    "dropdelzpp": 750569998,
    "dropphyadd": "5200 S COLONY BLVD",
    "dropphycty": "THE COLONY",
    "dropphyst": "TX",
    "dropphyzpp": 750569998,
    "dropmaladd": "5200 S COLONY BLVD",
    "dropmalcty": "THE COLONY",
    "dropmalst": "TX",
    "dropmalzpp": 750569998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723709721,
    "dropsitcph": 9723709721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW26013",
    "droptype": "D",
    "dropname": "THE WOODLANDS",
    "dropdeladd": "9450 PINECROFT DR",
    "dropdelcty": "SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 773809998,
    "dropphyadd": "9450 PINECROFT DR",
    "dropphycty": "SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 773809998,
    "dropmaladd": "9450 PINECROFT DR",
    "dropmalcty": "SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 773809998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3468316218,
    "dropsitcph": 2814197948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW26230",
    "droptype": "D",
    "dropname": "WATAUGA",
    "dropdeladd": "6651 WATAUGA RD STE 103",
    "dropdelcty": "WATAUGA",
    "dropdelst": "TX",
    "dropdelzpp": 761489998,
    "dropphyadd": "6651 WATAUGA RD STE 103",
    "dropphycty": "WATAUGA",
    "dropphyst": "TX",
    "dropphyzpp": 761489998,
    "dropmaladd": "6651 WATAUGA RD STE 103",
    "dropmalcty": "WATAUGA",
    "dropmalst": "TX",
    "dropmalzpp": 761489998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172814088,
    "dropsitcph": 8172815619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW26312",
    "droptype": "D",
    "dropname": "WHITE SETTLEMENT",
    "dropdeladd": "301 N LAS VEGAS TRL",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761081500,
    "dropphyadd": "301 N LAS VEGAS TRL",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761081500,
    "dropmaladd": "301 N LAS VEGAS TRL",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761081500,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172468629,
    "dropsitcph": 8172469465,
    "dropfax": 8172464597
  },
  {
    "dcode": "D",
    "dropkey": "BW26635",
    "droptype": "D",
    "dropname": "PANTHER CREEK",
    "dropdeladd": "10800 GOSLING RD",
    "dropdelcty": "SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 773819998,
    "dropphyadd": "10800 GOSLING RD",
    "dropphycty": "SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 773819998,
    "dropmaladd": "10800 GOSLING RD",
    "dropmalcty": "SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 773819998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814665863,
    "dropsitcph": 2814198231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW26641",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "22015 W 66TH ST",
    "dropdelcty": "SHAWNEE",
    "dropdelst": "KS",
    "dropdelzpp": 662269998,
    "dropphyadd": "22015 W 66TH ST",
    "dropphycty": "SHAWNEE",
    "dropphyst": "KS",
    "dropphyzpp": 662269998,
    "dropmaladd": "22015 W 66TH ST",
    "dropmalcty": "SHAWNEE",
    "dropmalst": "KS",
    "dropmalzpp": 662269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9134221984,
    "dropsitcph": 9134223927,
    "dropfax": 9134221508
  },
  {
    "dcode": "D",
    "dropkey": "BW26817",
    "droptype": "D",
    "dropname": "ACTON",
    "dropdeladd": "5561 N GATE RD",
    "dropdelcty": "GRANBURY",
    "dropdelst": "TX",
    "dropdelzpp": 760499998,
    "dropphyadd": "5561 N GATE RD",
    "dropphycty": "GRANBURY",
    "dropphyst": "TX",
    "dropphyzpp": 760499998,
    "dropmaladd": "5561 N GATE RD",
    "dropmalcty": "GRANBURY",
    "dropmalst": "TX",
    "dropmalzpp": 760499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175735515,
    "dropsitcph": 8173264088,
    "dropfax": 8173262782
  },
  {
    "dcode": "D",
    "dropkey": "BW26821",
    "droptype": "D",
    "dropname": "SOUTHEAST",
    "dropdeladd": "500 S FOREST HILL DR",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761404830,
    "dropphyadd": "500 S FOREST HILL DR",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761404830,
    "dropmaladd": "500 S FOREST HILL DR",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761404830,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172938193,
    "dropsitcph": 8172930946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BW26943",
    "droptype": "D",
    "dropname": "RICHLAND HILLS",
    "dropdeladd": "3201 DIANA DR STE A",
    "dropdelcty": "RICHLAND HILLS",
    "dropdelst": "TX",
    "dropdelzpp": 761184214,
    "dropphyadd": "3201 DIANA DR STE A",
    "dropphycty": "RICHLAND HILLS",
    "dropphyst": "TX",
    "dropphyzpp": 761184214,
    "dropmaladd": "6051 DAVIS BLVD",
    "dropmalcty": "NORTH RICHLAND HILLS",
    "dropmalst": "TX",
    "dropmalzpp": 761806385,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172849611,
    "dropsitcph": 8172815846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A033",
    "droptype": "D",
    "dropname": "MUNHALL",
    "dropdeladd": "3406 MAIN ST",
    "dropdelcty": "HOMESTEAD",
    "dropdelst": "PA",
    "dropdelzpp": 151203369,
    "dropphyadd": "3406 MAIN ST",
    "dropphycty": "HOMESTEAD",
    "dropphyst": "PA",
    "dropphyzpp": 151203369,
    "dropmaladd": "3406 MAIN ST",
    "dropmalcty": "HOMESTEAD",
    "dropmalst": "PA",
    "dropmalzpp": 151203369,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124615730,
    "dropsitcph": 4124610452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A071",
    "droptype": "D",
    "dropname": "NATRONA",
    "dropdeladd": "45 CHESTNUT ST",
    "dropdelcty": "NATRONA HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 150652600,
    "dropphyadd": "45 CHESTNUT ST",
    "dropphycty": "NATRONA HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 150652600,
    "dropmaladd": "45 CHESTNUT ST",
    "dropmalcty": "NATRONA HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 150652600,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122248336,
    "dropsitcph": 4122248336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A084",
    "droptype": "D",
    "dropname": "NEFFSVILLE",
    "dropdeladd": "16 MEADOW LN",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176019997,
    "dropphyadd": "16 MEADOW LN",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176019997,
    "dropmaladd": "16 MEADOW LN",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176019997,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175690703,
    "dropsitcph": 7175690703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A091",
    "droptype": "D",
    "dropname": "NESHANNOCK",
    "dropdeladd": "4 E MAITLAND LN",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161051200,
    "dropphyadd": "4 E MAITLAND LN",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161051200,
    "dropmaladd": "4 E MAITLAND LN",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161051200,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246542241,
    "dropsitcph": 7246542241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A109",
    "droptype": "D",
    "dropname": "NEW BRITAIN",
    "dropdeladd": "85 W BUTLER AVE",
    "dropdelcty": "DOYLESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189019995,
    "dropphyadd": "85 W BUTLER AVE",
    "dropphycty": "DOYLESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189019995,
    "dropmaladd": "85 W BUTLER AVE",
    "dropmalcty": "DOYLESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189019995,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153487082,
    "dropsitcph": 2153487082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A302",
    "droptype": "D",
    "dropname": "OGONTZ CAMPUS",
    "dropdeladd": "1600 WOODLAND RD",
    "dropdelcty": "ABINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 190019996,
    "dropphyadd": "1600 WOODLAND RD",
    "dropphycty": "ABINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 190019996,
    "dropmaladd": "1600 WOODLAND RD",
    "dropmalcty": "ABINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 190019996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158872395,
    "dropsitcph": 2158872395,
    "dropfax": 2158870717
  },
  {
    "dcode": "D",
    "dropkey": "BX1A371",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "650 S GREENWOOD AVE",
    "dropdelcty": "EASTON",
    "dropdelst": "PA",
    "dropdelzpp": 180459800,
    "dropphyadd": "650 S GREENWOOD AVE",
    "dropphycty": "EASTON",
    "dropphyst": "PA",
    "dropphyzpp": 180459800,
    "dropmaladd": "650 S GREENWOOD AVE",
    "dropmalcty": "EASTON",
    "dropmalst": "PA",
    "dropmalzpp": 180459800,
    "dropsitphn": 6102529964,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102529964,
    "dropfax": 6102520545
  },
  {
    "dcode": "D",
    "dropkey": "BX1A400",
    "droptype": "D",
    "dropname": "PARKWAY CENTER",
    "dropdeladd": "4 PARKWAY CTR W STE 150",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152203514,
    "dropphyadd": "4 PARKWAY CTR W STE 150",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152203514,
    "dropmaladd": "4 PARKWAY CTR W STE 150",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152203514,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122796955,
    "dropsitcph": 4129226952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A447",
    "droptype": "D",
    "dropname": "PENN HILLS",
    "dropdeladd": "11650 PENN HILLS DR",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152359998,
    "dropphyadd": "11650 PENN HILLS DR",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152359998,
    "dropmaladd": "11650 PENN HILLS DR",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127315987,
    "dropsitcph": 4127315987,
    "dropfax": 4127314074
  },
  {
    "dcode": "D",
    "dropkey": "BX1A457",
    "droptype": "D",
    "dropname": "PENNDEL",
    "dropdeladd": "27 BELLEVUE AVE",
    "dropdelcty": "PENNDEL",
    "dropdelst": "PA",
    "dropdelzpp": 190479996,
    "dropphyadd": "27 BELLEVUE AVE",
    "dropphycty": "PENNDEL",
    "dropphyst": "PA",
    "dropphyzpp": 190479996,
    "dropmaladd": "27 BELLEVUE AVE",
    "dropmalcty": "PENNDEL",
    "dropmalst": "PA",
    "dropmalzpp": 190479996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2157416935,
    "dropsitcph": 2157416935,
    "dropfax": 2157578327
  },
  {
    "dcode": "D",
    "dropkey": "BX1A490",
    "droptype": "D",
    "dropname": "PITTSBURGH INTL AIRPORT",
    "dropdeladd": "0 CONCOURSE D",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152313001,
    "dropphyadd": "0 CONCOURSE D",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152313001,
    "dropmaladd": "PO BOX 12499",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152310499,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124721068,
    "dropsitcph": 4124721068,
    "dropfax": 4124728779
  },
  {
    "dcode": "D",
    "dropkey": "BX1A510",
    "droptype": "D",
    "dropname": "PILGRIM GARDENS",
    "dropdeladd": "1051 PONTIAC RD",
    "dropdelcty": "DREXEL HILL",
    "dropdelst": "PA",
    "dropdelzpp": 190269997,
    "dropphyadd": "1051 PONTIAC RD",
    "dropphycty": "DREXEL HILL",
    "dropphyst": "PA",
    "dropphyzpp": 190269997,
    "dropmaladd": "1051 PONTIAC RD",
    "dropmalcty": "DREXEL HILL",
    "dropmalst": "PA",
    "dropmalzpp": 190269997,
    "dropsitphn": 2154465149,
    "dropsitlph": 6104465149,
    "dropsitcph": 6104465149,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "BX1A534",
    "droptype": "D",
    "dropname": "PITCAIRN",
    "dropdeladd": "540 BROADWAY",
    "dropdelcty": "PITCAIRN",
    "dropdelst": "PA",
    "dropdelzpp": 151409998,
    "dropphyadd": "540 BROADWAY",
    "dropphycty": "PITCAIRN",
    "dropphyst": "PA",
    "dropphyzpp": 151409998,
    "dropmaladd": "540 BROADWAY",
    "dropmalcty": "PITCAIRN",
    "dropmalst": "PA",
    "dropmalzpp": 151409998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123722608,
    "dropsitcph": 4123730691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A557",
    "droptype": "D",
    "dropname": "PLEASANT GAP",
    "dropdeladd": "157 W COLLEGE AVE",
    "dropdelcty": "PLEASANT GAP",
    "dropdelst": "PA",
    "dropdelzpp": 168233299,
    "dropphyadd": "157 W COLLEGE AVE",
    "dropphycty": "PLEASANT GAP",
    "dropphyst": "PA",
    "dropphyzpp": 168233299,
    "dropmaladd": "157 W COLLEGE AVE",
    "dropmalcty": "PLEASANT GAP",
    "dropmalst": "PA",
    "dropmalzpp": 168233299,
    "dropsitphn": 8148367307,
    "dropsitlph": "",
    "dropsitcph": 8143592927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A577",
    "droptype": "D",
    "dropname": "PLUM",
    "dropdeladd": "3100 LEECHBURG RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152399998,
    "dropphyadd": "3100 LEECHBURG RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152399998,
    "dropmaladd": "3100 LEECHBURG RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152399998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127952179,
    "dropsitcph": 4127952179,
    "dropfax": 4127952012
  },
  {
    "dcode": "D",
    "dropkey": "BX1A637",
    "droptype": "D",
    "dropname": "PRESQUE ISLE",
    "dropdeladd": "2711 LEGION RD",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165063100,
    "dropphyadd": "2711 LEGION RD",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165063100,
    "dropmaladd": "2711 LEGION RD",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165063100,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148331018,
    "dropsitcph": 8148331018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A646",
    "droptype": "D",
    "dropname": "PRIMOS SECANE",
    "dropdeladd": "925 PROVIDENCE RD STE 12",
    "dropdelcty": "SECANE",
    "dropdelst": "PA",
    "dropdelzpp": 190189997,
    "dropphyadd": "925 PROVIDENCE RD STE 12",
    "dropphycty": "SECANE",
    "dropphyst": "PA",
    "dropphyzpp": 190189997,
    "dropmaladd": "925 PROVIDENCE RD STE 12",
    "dropmalcty": "SECANE",
    "dropmalst": "PA",
    "dropmalzpp": 190189997,
    "dropsitphn": 2158958561,
    "dropsitlph": 6106230107,
    "dropsitcph": 6106230107,
    "dropfax": 6106230471
  },
  {
    "dcode": "D",
    "dropkey": "BX1A682",
    "droptype": "D",
    "dropname": "RADNOR",
    "dropdeladd": "560 E LANCASTER AVE STE 100",
    "dropdelcty": "WAYNE",
    "dropdelst": "PA",
    "dropdelzpp": 190879996,
    "dropphyadd": "560 E LANCASTER AVE STE 100",
    "dropphycty": "WAYNE",
    "dropphyst": "PA",
    "dropphyzpp": 190879996,
    "dropmaladd": "560 E LANCASTER AVE STE 100",
    "dropmalcty": "WAYNE",
    "dropmalst": "PA",
    "dropmalzpp": 190879996,
    "dropsitphn": 2158958561,
    "dropsitlph": 6109641248,
    "dropsitcph": 6109641248,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "BX1A748",
    "droptype": "D",
    "dropname": "RICHBORO",
    "dropdeladd": "851 BUSTLETON PIKE",
    "dropdelcty": "RICHBORO",
    "dropdelst": "PA",
    "dropdelzpp": 189549998,
    "dropphyadd": "851 BUSTLETON PIKE",
    "dropphycty": "RICHBORO",
    "dropphyst": "PA",
    "dropphyzpp": 189549998,
    "dropmaladd": "851 BUSTLETON PIKE",
    "dropmalcty": "RICHBORO",
    "dropmalst": "PA",
    "dropmalzpp": 189549998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153645680,
    "dropsitcph": 2153645680,
    "dropfax": 2153967107
  },
  {
    "dcode": "D",
    "dropkey": "BX1A815",
    "droptype": "D",
    "dropname": "ROHRERSTOWN",
    "dropdeladd": "153 ROHRERSTOWN RD",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176032263,
    "dropphyadd": "153 ROHRERSTOWN RD",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176032263,
    "dropmaladd": "153 ROHRERSTOWN RD",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176032263,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173940982,
    "dropsitcph": 7173940982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A833",
    "droptype": "D",
    "dropname": "ROSETO",
    "dropdeladd": "123 GARIBALDI AVE",
    "dropdelcty": "ROSETO",
    "dropdelst": "PA",
    "dropdelzpp": 180131300,
    "dropphyadd": "123 GARIBALDI AVE",
    "dropphycty": "ROSETO",
    "dropphyst": "PA",
    "dropphyzpp": 180131300,
    "dropmaladd": "123 GARIBALDI AVE",
    "dropmalcty": "ROSETO",
    "dropmalst": "PA",
    "dropmalzpp": 180131300,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6105883495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A836",
    "droptype": "D",
    "dropname": "ROSLYN",
    "dropdeladd": "1302 EASTON RD",
    "dropdelcty": "ABINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 190019997,
    "dropphyadd": "1302 EASTON RD",
    "dropphycty": "ABINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 190019997,
    "dropmaladd": "1302 EASTON RD",
    "dropmalcty": "ABINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 190019997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158874521,
    "dropsitcph": 2158874521,
    "dropfax": 2158870717
  },
  {
    "dcode": "D",
    "dropkey": "BX1A843",
    "droptype": "D",
    "dropname": "NORTH BELLE VERNON",
    "dropdeladd": "306 GRANT ST",
    "dropdelcty": "BELLE VERNON",
    "dropdelst": "PA",
    "dropdelzpp": 150121400,
    "dropphyadd": "306 GRANT ST",
    "dropphycty": "BELLE VERNON",
    "dropphyst": "PA",
    "dropphyzpp": 150121400,
    "dropmaladd": "306 GRANT ST",
    "dropmalcty": "BELLE VERNON",
    "dropmalst": "PA",
    "dropmalzpp": 150121400,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249293712,
    "dropsitcph": 7249293712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A874",
    "droptype": "D",
    "dropname": "RYDAL",
    "dropdeladd": "1470 SUSQUEHANNA RD",
    "dropdelcty": "JENKINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190469997,
    "dropphyadd": "1470 SUSQUEHANNA RD",
    "dropphycty": "JENKINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190469997,
    "dropmaladd": "1470 SUSQUEHANNA RD",
    "dropmalcty": "JENKINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190469997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158867984,
    "dropsitcph": 2158867984,
    "dropfax": 2158870753
  },
  {
    "dcode": "D",
    "dropkey": "BX1A899",
    "droptype": "D",
    "dropname": "SAINT DAVIDS",
    "dropdeladd": "322 E LANCASTER AVE",
    "dropdelcty": "WAYNE",
    "dropdelst": "PA",
    "dropdelzpp": 190879995,
    "dropphyadd": "322 E LANCASTER AVE",
    "dropphycty": "WAYNE",
    "dropphyst": "PA",
    "dropphyzpp": 190879995,
    "dropmaladd": "322 E LANCASTER AVE",
    "dropmalcty": "WAYNE",
    "dropmalst": "PA",
    "dropmalzpp": 190879995,
    "dropsitphn": 6106881511,
    "dropsitlph": 6106881511,
    "dropsitcph": 6109641248,
    "dropfax": 6106873277
  },
  {
    "dcode": "D",
    "dropkey": "BX1A921",
    "droptype": "D",
    "dropname": "SANATOGA",
    "dropdeladd": "2227 E HIGH ST",
    "dropdelcty": "POTTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194649996,
    "dropphyadd": "2227 E HIGH ST",
    "dropphycty": "POTTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194649996,
    "dropmaladd": "2227 E HIGH ST",
    "dropmalcty": "POTTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194649996,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107189104,
    "dropsitcph": 6107189104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A951",
    "droptype": "D",
    "dropname": "SCHWENKSVILLE",
    "dropdeladd": "153 CENTENNIAL ST",
    "dropdelcty": "SCHWENKSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194739998,
    "dropphyadd": "153 CENTENNIAL ST",
    "dropphycty": "SCHWENKSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194739998,
    "dropmaladd": "153 CENTENNIAL ST",
    "dropmalcty": "SCHWENKSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194739998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102873551,
    "dropsitcph": 6102873551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1A995",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "1200 MAIN ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152159998,
    "dropphyadd": "1200 MAIN ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152159998,
    "dropmaladd": "1200 MAIN ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152159998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127810536,
    "dropsitcph": 4127810536,
    "dropfax": 4127811034
  },
  {
    "dcode": "D",
    "dropkey": "BX1B001",
    "droptype": "D",
    "dropname": "SHAVERTOWN",
    "dropdeladd": "1915 MEMORIAL HWY",
    "dropdelcty": "SHAVERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 187089997,
    "dropphyadd": "1915 MEMORIAL HWY",
    "dropphycty": "SHAVERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 187089997,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019990,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706751221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B023",
    "droptype": "D",
    "dropname": "SHILLINGTON",
    "dropdeladd": "550 KENHORST PLZ",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196073653,
    "dropphyadd": "550 KENHORST PLZ",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196073653,
    "dropmaladd": "550 KENHORST PLZ",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196073653,
    "dropsitphn": 6107777143,
    "dropsitlph": 6107777143,
    "dropsitcph": 6107777143,
    "dropfax": 6107778304
  },
  {
    "dcode": "D",
    "dropkey": "BX1B034",
    "droptype": "D",
    "dropname": "SHIREMANSTOWN",
    "dropdeladd": "10 W MAIN ST",
    "dropdelcty": "CAMP HILL",
    "dropdelst": "PA",
    "dropdelzpp": 170119997,
    "dropphyadd": "10 W MAIN ST",
    "dropphycty": "CAMP HILL",
    "dropphyst": "PA",
    "dropphyzpp": 170119997,
    "dropmaladd": "10 W MAIN ST",
    "dropmalcty": "CAMP HILL",
    "dropmalst": "PA",
    "dropmalzpp": 170119997,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177370395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B067",
    "droptype": "D",
    "dropname": "SINKING SPRING",
    "dropdeladd": "4100 PENN AVE",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196089998,
    "dropphyadd": "4100 PENN AVE",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196089998,
    "dropmaladd": "4100 PENN AVE",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196089998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106781351,
    "dropsitcph": 6106788136,
    "dropfax": 6106786764
  },
  {
    "dcode": "D",
    "dropkey": "BX1B141",
    "droptype": "D",
    "dropname": "SOUTH HILLS",
    "dropdeladd": "3038 W LIBERTY AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152169998,
    "dropphyadd": "3038 W LIBERTY AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152169998,
    "dropmaladd": "3038 W LIBERTY AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4125315498,
    "dropsitcph": 4125315498,
    "dropfax": 4125318518
  },
  {
    "dcode": "D",
    "dropkey": "BX1B153",
    "droptype": "D",
    "dropname": "SOUTH WILLIAMSPORT",
    "dropdeladd": "1223 W SOUTHERN AVE",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177029995,
    "dropphyadd": "1223 W SOUTHERN AVE",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177029995,
    "dropmaladd": "1223 W SOUTHERN AVE",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177029995,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703237678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B191",
    "droptype": "D",
    "dropname": "SPRING HOUSE",
    "dropdeladd": "905 BETHLEHEM PIKE",
    "dropdelcty": "SPRING HOUSE",
    "dropdelst": "PA",
    "dropdelzpp": 194779998,
    "dropphyadd": "905 BETHLEHEM PIKE",
    "dropphycty": "SPRING HOUSE",
    "dropphyst": "PA",
    "dropphyzpp": 194779998,
    "dropmaladd": "905 BETHLEHEM PIKE",
    "dropmalcty": "SPRING HOUSE",
    "dropmalst": "PA",
    "dropmalzpp": 194779998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155910462,
    "dropsitcph": 2155910462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B201",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "1138 BALTIMORE PIKE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 190649998,
    "dropphyadd": "1138 BALTIMORE PIKE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 190649998,
    "dropmaladd": "1138 BALTIMORE PIKE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 190649998,
    "dropsitphn": 2158958561,
    "dropsitlph": 6103281813,
    "dropsitcph": 6103281813,
    "dropfax": 6108920958
  },
  {
    "dcode": "D",
    "dropkey": "BX1B204",
    "droptype": "D",
    "dropname": "SPRINGFIELD MALL",
    "dropdeladd": "1250 BALTIMORE PIKE LOWR L13B2",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 190649996,
    "dropphyadd": "1250 BALTIMORE PIKE LOWR L13B2",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 190649996,
    "dropmaladd": "1250 BALTIMORE PIKE LOWR L13B2",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 190649996,
    "dropsitphn": 2158958561,
    "dropsitlph": 6103289244,
    "dropsitcph": 6105446840,
    "dropfax": 6108920958
  },
  {
    "dcode": "D",
    "dropkey": "BX1B350",
    "droptype": "D",
    "dropname": "STEELTON",
    "dropdeladd": "29 LOCUST ST",
    "dropdelcty": "STEELTON",
    "dropdelst": "PA",
    "dropdelzpp": 171139998,
    "dropphyadd": "29 LOCUST ST",
    "dropphycty": "STEELTON",
    "dropphyst": "PA",
    "dropphyzpp": 171139998,
    "dropmaladd": "29 LOCUST ST",
    "dropmalcty": "STEELTON",
    "dropmalst": "PA",
    "dropmalzpp": 171139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179392741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B382",
    "droptype": "D",
    "dropname": "STOWE",
    "dropdeladd": "60 LEMON ST",
    "dropdelcty": "POTTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194649997,
    "dropphyadd": "60 LEMON ST",
    "dropphycty": "POTTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194649997,
    "dropmaladd": "60 LEMON ST",
    "dropmalcty": "POTTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194649997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109700495,
    "dropsitcph": 6109700495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B442",
    "droptype": "D",
    "dropname": "SWATARA",
    "dropdeladd": "5120 DERRY ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171119998,
    "dropphyadd": "5120 DERRY ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171119998,
    "dropmaladd": "5120 DERRY ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175646322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B455",
    "droptype": "D",
    "dropname": "SWISSVALE",
    "dropdeladd": "1911 MONONGAHELA AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152189998,
    "dropphyadd": "1911 MONONGAHELA AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152189998,
    "dropmaladd": "1911 MONONGAHELA AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152189998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122714161,
    "dropsitcph": 4122714161,
    "dropfax": 4122715702
  },
  {
    "dcode": "D",
    "dropkey": "BX1B488",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "910 S MAIN ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "PA",
    "dropdelzpp": 185179998,
    "dropphyadd": "910 S MAIN ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "PA",
    "dropphyzpp": 185179998,
    "dropmaladd": "910 S MAIN ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "PA",
    "dropmalzpp": 185179998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705622000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B506",
    "droptype": "D",
    "dropname": "THORNDALE",
    "dropdeladd": "20 N BAILEY RD",
    "dropdelcty": "THORNDALE",
    "dropdelst": "PA",
    "dropdelzpp": 193729998,
    "dropphyadd": "20 N BAILEY RD",
    "dropphycty": "THORNDALE",
    "dropphyst": "PA",
    "dropphyzpp": 193729998,
    "dropmaladd": "20 N BAILEY RD",
    "dropmalcty": "THORNDALE",
    "dropmalst": "PA",
    "dropmalzpp": 193729998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103840780,
    "dropsitcph": 6103840780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B654",
    "droptype": "D",
    "dropname": "UPPER SAINT CLAIR",
    "dropdeladd": "2211 LESNETT RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152419998,
    "dropphyadd": "2211 LESNETT RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152419998,
    "dropmaladd": "2211 LESNETT RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152419998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122212708,
    "dropsitcph": 4122212708,
    "dropfax": 4122218339
  },
  {
    "dcode": "D",
    "dropkey": "BX1B708",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "1900 WASHINGTON RD STE 455",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152411415,
    "dropphyadd": "1900 WASHINGTON RD STE 455",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152411415,
    "dropmaladd": "1900 WASHINGTON RD STE 455",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152411415,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128333014,
    "dropsitcph": 4128333014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B773",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "19 N PROVIDENCE RD",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "PA",
    "dropdelzpp": 190869998,
    "dropphyadd": "19 N PROVIDENCE RD",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "PA",
    "dropphyzpp": 190869998,
    "dropmaladd": "101 E BALTIMORE AVE",
    "dropmalcty": "MEDIA",
    "dropmalst": "PA",
    "dropmalzpp": 190639998,
    "dropsitphn": 6105662237,
    "dropsitlph": 6105662237,
    "dropsitcph": 6105662237,
    "dropfax": 6108920958
  },
  {
    "dcode": "D",
    "dropkey": "BX1B874",
    "droptype": "D",
    "dropname": "WESCOSVILLE",
    "dropdeladd": "1115 BROOKSIDE RD",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 181069539,
    "dropphyadd": "1115 BROOKSIDE RD",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 181069539,
    "dropmaladd": "1000 POSTAL RD SIDE",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 181098900,
    "dropsitphn": 6102665282,
    "dropsitlph": 6102665282,
    "dropsitcph": 6103955161,
    "dropfax": 6103952356
  },
  {
    "dcode": "D",
    "dropkey": "BX1B900",
    "droptype": "D",
    "dropname": "WEST CONSHOHOCKEN",
    "dropdeladd": "426 FORD ST",
    "dropdelcty": "CONSHOHOCKEN",
    "dropdelst": "PA",
    "dropdelzpp": 194289996,
    "dropphyadd": "426 FORD ST",
    "dropphycty": "CONSHOHOCKEN",
    "dropphyst": "PA",
    "dropphyzpp": 194289996,
    "dropmaladd": "426 FORD ST",
    "dropmalcty": "CONSHOHOCKEN",
    "dropmalst": "PA",
    "dropmalzpp": 194289996,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108281611,
    "dropsitcph": 6108286161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B928",
    "droptype": "D",
    "dropname": "WEST MIFFLIN",
    "dropdeladd": "5001 HOMEVILLE RD",
    "dropdelcty": "WEST MIFFLIN",
    "dropdelst": "PA",
    "dropdelzpp": 151229998,
    "dropphyadd": "5001 HOMEVILLE RD",
    "dropphycty": "WEST MIFFLIN",
    "dropphyst": "PA",
    "dropphyzpp": 151229998,
    "dropmaladd": "5001 HOMEVILLE RD",
    "dropmalcty": "WEST MIFFLIN",
    "dropmalst": "PA",
    "dropmalzpp": 151229998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126554912,
    "dropsitcph": 4126553836,
    "dropfax": 4124661493
  },
  {
    "dcode": "D",
    "dropkey": "BX1B943",
    "droptype": "D",
    "dropname": "WEST PITTSTON",
    "dropdeladd": "801 WYOMING AVE STE 250",
    "dropdelcty": "WEST PITTSTON",
    "dropdelst": "PA",
    "dropdelzpp": 186432784,
    "dropphyadd": "801 WYOMING AVE STE 250",
    "dropphycty": "WEST PITTSTON",
    "dropphyst": "PA",
    "dropphyzpp": 186432784,
    "dropmaladd": "11 DOCK ST",
    "dropmalcty": "PITTSTON",
    "dropmalst": "PA",
    "dropmalzpp": 186409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706552657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1B953",
    "droptype": "D",
    "dropname": "WEST VIEW",
    "dropdeladd": "1007 W VIEW PARK DR",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152292717,
    "dropphyadd": "1007 W VIEW PARK DR",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152292717,
    "dropmaladd": "1007 W VIEW PARK DR",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152292717,
    "dropsitphn": 4123597568,
    "dropsitlph": 4129314643,
    "dropsitcph": 4129314643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C030",
    "droptype": "D",
    "dropname": "WILKINSBURG FINANCE",
    "dropdeladd": "1025 HAY ST STE A",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152212151,
    "dropphyadd": "1025 HAY ST STE A",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152212151,
    "dropmaladd": "1025 HAY ST STE A",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152212151,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122410916,
    "dropsitcph": 4122410794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C047",
    "droptype": "D",
    "dropname": "WILLOW GROVE NAS",
    "dropdeladd": "1301 EASTON RD",
    "dropdelcty": "WILLOW GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 190909997,
    "dropphyadd": "1301 EASTON RD",
    "dropphycty": "WILLOW GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 190909997,
    "dropmaladd": "1301 EASTON RD",
    "dropmalcty": "WILLOW GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 190909997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156590756,
    "dropsitcph": 2156590756,
    "dropfax": 2156590870
  },
  {
    "dcode": "D",
    "dropkey": "BX1C116",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "200 WYOMING AVE",
    "dropdelcty": "WYOMING",
    "dropdelst": "PA",
    "dropdelzpp": 186449998,
    "dropphyadd": "200 WYOMING AVE",
    "dropphycty": "WYOMING",
    "dropphyst": "PA",
    "dropphyzpp": 186449998,
    "dropmaladd": "11 DOCK ST",
    "dropmalcty": "PITTSTON",
    "dropmalst": "PA",
    "dropmalzpp": 186409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706930350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C117",
    "droptype": "D",
    "dropname": "WYOMISSING",
    "dropdeladd": "1021 PENN AVE",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196102000,
    "dropphyadd": "1021 PENN AVE",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196102000,
    "dropmaladd": "1021 PENN AVE",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196102000,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103781247,
    "dropsitcph": 6103781247,
    "dropfax": 6103781235
  },
  {
    "dcode": "D",
    "dropkey": "BX1C120",
    "droptype": "D",
    "dropname": "YARDLEY",
    "dropdeladd": "56 S MAIN ST STE 2",
    "dropdelcty": "YARDLEY",
    "dropdelst": "PA",
    "dropdelzpp": 190679997,
    "dropphyadd": "56 S MAIN ST STE 2",
    "dropphycty": "YARDLEY",
    "dropphyst": "PA",
    "dropphyzpp": 190679997,
    "dropmaladd": "56 S MAIN ST STE 2",
    "dropmalcty": "YARDLEY",
    "dropmalst": "PA",
    "dropmalzpp": 190679997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2152953763,
    "dropsitcph": 2153699738,
    "dropfax": 2152952547
  },
  {
    "dcode": "D",
    "dropkey": "BX1C124",
    "droptype": "D",
    "dropname": "YEADON",
    "dropdeladd": "709 CHURCH LN",
    "dropdelcty": "LANSDOWNE",
    "dropdelst": "PA",
    "dropdelzpp": 190509997,
    "dropphyadd": "709 CHURCH LN",
    "dropphycty": "LANSDOWNE",
    "dropphyst": "PA",
    "dropphyzpp": 190509997,
    "dropmaladd": "709 CHURCH LN",
    "dropmalcty": "LANSDOWNE",
    "dropmalst": "PA",
    "dropmalzpp": 190509997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156231384,
    "dropsitcph": 2156231384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C164",
    "droptype": "D",
    "dropname": "CRANBERRY TOWNSHIP",
    "dropdeladd": "240 EXECUTIVE DR",
    "dropdelcty": "CRANBERRY TOWNSHIP",
    "dropdelst": "PA",
    "dropdelzpp": 160666400,
    "dropphyadd": "240 EXECUTIVE DR",
    "dropphycty": "CRANBERRY TOWNSHIP",
    "dropphyst": "PA",
    "dropphyzpp": 160666400,
    "dropmaladd": "240 EXECUTIVE DR",
    "dropmalcty": "CRANBERRY TOWNSHIP",
    "dropmalst": "PA",
    "dropmalzpp": 160666400,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247791101,
    "dropsitcph": 7247791101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C184",
    "droptype": "D",
    "dropname": "PLEASANT HILLS",
    "dropdeladd": "500 REGIS AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152369998,
    "dropphyadd": "500 REGIS AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152369998,
    "dropmaladd": "500 REGIS AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126553836,
    "dropsitcph": 4126553836,
    "dropfax": 4126506057
  },
  {
    "dcode": "D",
    "dropkey": "BX1C285",
    "droptype": "D",
    "dropname": "WEST SOMERSET",
    "dropdeladd": "299 WASHINGTON DR",
    "dropdelcty": "SOMERSET",
    "dropdelst": "KY",
    "dropdelzpp": 425012962,
    "dropphyadd": "299 WASHINGTON DR",
    "dropphycty": "SOMERSET",
    "dropphyst": "KY",
    "dropphyzpp": 425012962,
    "dropmaladd": "299 WASHINGTON DR",
    "dropmalcty": "SOMERSET",
    "dropmalst": "KY",
    "dropmalzpp": 425012962,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066793802,
    "dropfax": 6066795430
  },
  {
    "dcode": "D",
    "dropkey": "BX1C330",
    "droptype": "D",
    "dropname": "ALLENTOWN AIRPORT",
    "dropdeladd": "1000 POSTAL RD SIDE",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 181099998,
    "dropphyadd": "1000 POSTAL RD SIDE",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 181099998,
    "dropmaladd": "1000 POSTAL RD SIDE",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 181099998,
    "dropsitphn": 6102665314,
    "dropsitlph": 6102665308,
    "dropsitcph": 6102665280,
    "dropfax": 6102665410
  },
  {
    "dcode": "D",
    "dropkey": "BX1C340",
    "droptype": "D",
    "dropname": "PLAINS",
    "dropdeladd": "29 N RIVER ST",
    "dropdelcty": "PLAINS",
    "dropdelst": "PA",
    "dropdelzpp": 187051332,
    "dropphyadd": "29 N RIVER ST",
    "dropphycty": "PLAINS",
    "dropphyst": "PA",
    "dropphyzpp": 187051332,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019990,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708222597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C369",
    "droptype": "D",
    "dropname": "GROVE CITY POSTAL RETAIL STR",
    "dropdeladd": "1911 LEESBURG GROVE CITY RD UNIT 645",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "PA",
    "dropdelzpp": 161279800,
    "dropphyadd": "1911 LEESBURG GROVE CITY RD UNIT 645",
    "dropphycty": "GROVE CITY",
    "dropphyst": "PA",
    "dropphyzpp": 161279800,
    "dropmaladd": "117 E PINE ST",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "PA",
    "dropmalzpp": 161272000,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244586140,
    "dropsitcph": 7247485052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C516",
    "droptype": "D",
    "dropname": "30TH STREET",
    "dropdeladd": "2955 MARKET ST LBBY A",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049775,
    "dropphyadd": "2955 MARKET ST LBBY A",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049775,
    "dropmaladd": "2955 MARKET ST LBBY A",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049775,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158958970,
    "dropsitcph": 2158958970,
    "dropfax": 2158958964
  },
  {
    "dcode": "D",
    "dropkey": "BX1C566",
    "droptype": "D",
    "dropname": "CHESTNUT MOUNTAIN",
    "dropdeladd": "4103 WINDER HWY",
    "dropdelcty": "CHESTNUT MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 305029800,
    "dropphyadd": "4103 WINDER HWY",
    "dropphycty": "CHESTNUT MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 305029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTNUT MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 305029998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705344135,
    "dropsitcph": 7709678050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C675",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "5944 HIGHWAY 92 STE 100",
    "dropdelcty": "ACWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 301029998,
    "dropphyadd": "5944 HIGHWAY 92 STE 100",
    "dropphycty": "ACWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 301029998,
    "dropmaladd": "5944 HIGHWAY 92 STE 100",
    "dropmalcty": "ACWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 301029998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705922800,
    "dropsitcph": 7705922800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX1C676",
    "droptype": "D",
    "dropname": "BROOKSTONE",
    "dropdeladd": "5330 BROOKSTONE DR NW STE 250",
    "dropdelcty": "ACWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 301017183,
    "dropphyadd": "5330 BROOKSTONE DR NW STE 250",
    "dropphycty": "ACWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 301017183,
    "dropmaladd": "5330 BROOKSTONE DR NW STE 250",
    "dropmalcty": "ACWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 301017183,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707958924,
    "dropsitcph": 7707958924,
    "dropfax": 7705907313
  },
  {
    "dcode": "D",
    "dropkey": "BX1C745",
    "droptype": "D",
    "dropname": "SANDY SPRINGS",
    "dropdeladd": "230 HAMMOND DR STE G",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303289997,
    "dropphyadd": "230 HAMMOND DR STE G",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303289997,
    "dropmaladd": "230 HAMMOND DR STE G",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303289997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042557624,
    "dropsitcph": 4042557624,
    "dropfax": 4042562984
  },
  {
    "dcode": "D",
    "dropkey": "BX1D284",
    "droptype": "D",
    "dropname": "ZEBULON BRANCH",
    "dropdeladd": "7040 PEAKE RD N",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312109998,
    "dropphyadd": "7040 PEAKE RD N",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312109998,
    "dropmaladd": "7040 PEAKE RD N",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784718182,
    "dropsitcph": 4784718182,
    "dropfax": 4784759714
  },
  {
    "dcode": "D",
    "dropkey": "BX10226",
    "droptype": "D",
    "dropname": "CHAMBLEE",
    "dropdeladd": "3545 BROAD ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303412259,
    "dropphyadd": "3545 BROAD ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303412259,
    "dropmaladd": "3545 BROAD ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303412259,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702161958,
    "dropsitcph": 7702161968,
    "dropfax": 7704554039
  },
  {
    "dcode": "D",
    "dropkey": "BX10268",
    "droptype": "D",
    "dropname": "COLLEGE PARK",
    "dropdeladd": "3799 MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303379998,
    "dropphyadd": "3799 MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303379998,
    "dropmaladd": "3799 MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303379998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4046699781,
    "dropsitcph": 4046699781,
    "dropfax": 4047628875
  },
  {
    "dcode": "D",
    "dropkey": "BX10355",
    "droptype": "D",
    "dropname": "DORAVILLE",
    "dropdeladd": "4700 LONGMIRE EXT",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303409998,
    "dropphyadd": "4700 LONGMIRE EXT",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303409998,
    "dropmaladd": "4700 LONGMIRE EXT",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303409998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702168480,
    "dropsitcph": 7702168475,
    "dropfax": 7704554409
  },
  {
    "dcode": "D",
    "dropkey": "BX10379",
    "droptype": "D",
    "dropname": "DUNWOODY",
    "dropdeladd": "1551 DUNWOODY VILLAGE PKWY",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303389998,
    "dropphyadd": "1551 DUNWOODY VILLAGE PKWY",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303389998,
    "dropmaladd": "1551 DUNWOODY VILLAGE PKWY",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303389998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702177923,
    "dropsitcph": 7703529070,
    "dropfax": 7703949217
  },
  {
    "dcode": "D",
    "dropkey": "BX10390",
    "droptype": "D",
    "dropname": "EAST POINT",
    "dropdeladd": "2905 E POINT ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303444202,
    "dropphyadd": "2905 E POINT ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303444202,
    "dropmaladd": "2905 E POINT ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303444202,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047955902,
    "dropsitcph": 4047667643,
    "dropfax": 4047612063
  },
  {
    "dcode": "D",
    "dropkey": "BX10468",
    "droptype": "D",
    "dropname": "FOREST HILLS",
    "dropdeladd": "3301 WRIGHTSBORO RD",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309099998,
    "dropphyadd": "3301 WRIGHTSBORO RD",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309099998,
    "dropmaladd": "3301 WRIGHTSBORO RD",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309099998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7067375156,
    "dropsitcph": 7067375156,
    "dropfax": 7067378344
  },
  {
    "dcode": "D",
    "dropkey": "BX10472",
    "droptype": "D",
    "dropname": "FORT MOORE",
    "dropdeladd": "110 VIBBERT AVE",
    "dropdelcty": "FORT MOORE",
    "dropdelst": "GA",
    "dropdelzpp": 319059998,
    "dropphyadd": "110 VIBBERT AVE",
    "dropphycty": "FORT MOORE",
    "dropphyst": "GA",
    "dropphyzpp": 319059998,
    "dropmaladd": "110 VIBBERT AVE",
    "dropmalcty": "FORT MOORE",
    "dropmalst": "GA",
    "dropmalzpp": 319059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066891696,
    "dropsitcph": 7066891696,
    "dropfax": 7066827255
  },
  {
    "dcode": "D",
    "dropkey": "BX10477",
    "droptype": "D",
    "dropname": "FORT EISENHOWER",
    "dropdeladd": "411 36TH ST",
    "dropdelcty": "FORT EISENHOWER",
    "dropdelst": "GA",
    "dropdelzpp": 309059998,
    "dropphyadd": "411 36TH ST",
    "dropphycty": "FORT EISENHOWER",
    "dropphyst": "GA",
    "dropphyzpp": 309059998,
    "dropmaladd": "411 36TH ST",
    "dropmalcty": "FORT EISENHOWER",
    "dropmalst": "GA",
    "dropmalzpp": 309059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7067903651,
    "dropsitcph": 7067903651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX10481",
    "droptype": "D",
    "dropname": "FORT OGLETHORPE",
    "dropdeladd": "155 FORREST RD",
    "dropdelcty": "FORT OGLETHORPE",
    "dropdelst": "GA",
    "dropdelzpp": 307429998,
    "dropphyadd": "155 FORREST RD",
    "dropphycty": "FORT OGLETHORPE",
    "dropphyst": "GA",
    "dropphyzpp": 307429998,
    "dropmaladd": "155 FORREST RD",
    "dropmalcty": "FORT OGLETHORPE",
    "dropmalst": "GA",
    "dropmalzpp": 307429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068669374,
    "dropsitcph": 7068669350,
    "dropfax": 7068617527
  },
  {
    "dcode": "D",
    "dropkey": "BX10483",
    "droptype": "D",
    "dropname": "FORT STEWART",
    "dropdeladd": "843 HASE RD",
    "dropdelcty": "FORT STEWART",
    "dropdelst": "GA",
    "dropdelzpp": 313149998,
    "dropphyadd": "843 HASE RD",
    "dropphycty": "FORT STEWART",
    "dropphyst": "GA",
    "dropphyzpp": 313149998,
    "dropmaladd": "843 HASE RD",
    "dropmalcty": "FORT STEWART",
    "dropmalst": "GA",
    "dropmalzpp": 313149998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128766730,
    "dropsitcph": 9128766730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX10506",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "4431 AUGUSTA RD",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314089998,
    "dropphyadd": "4431 AUGUSTA RD",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314089998,
    "dropmaladd": "4431 AUGUSTA RD",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314089998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9129644033,
    "dropsitcph": 9129644033,
    "dropfax": 9129651720
  },
  {
    "dcode": "D",
    "dropkey": "BX10586",
    "droptype": "D",
    "dropname": "HAPEVILLE",
    "dropdeladd": "650 S CENTRAL AVE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303549998,
    "dropphyadd": "650 S CENTRAL AVE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303549998,
    "dropmaladd": "650 S CENTRAL AVE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303549998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047687073,
    "dropsitcph": 4047634096,
    "dropfax": 4047616186
  },
  {
    "dcode": "D",
    "dropkey": "BX10643",
    "droptype": "D",
    "dropname": "HUNTER AAF",
    "dropdeladd": "37 N SCHMIDT ST STE 102",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314099998,
    "dropphyadd": "37 N SCHMIDT ST STE 102",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314099998,
    "dropmaladd": "37 N SCHMIDT ST STE 102",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314099998,
    "dropsitphn": 4787528444,
    "dropsitlph": 9123553217,
    "dropsitcph": 9123510480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX10789",
    "droptype": "D",
    "dropname": "MARTINEZ",
    "dropdeladd": "125 COMMERCIAL BLVD",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309079998,
    "dropphyadd": "125 COMMERCIAL BLVD",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309079998,
    "dropmaladd": "125 COMMERCIAL BLVD",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309079998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068634700,
    "dropsitcph": 7068634700,
    "dropfax": 7066500245
  },
  {
    "dcode": "D",
    "dropkey": "BX10968",
    "droptype": "D",
    "dropname": "PEACH ORCHARD",
    "dropdeladd": "3108 PEACH ORCHARD RD STE 8",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309069998,
    "dropphyadd": "3108 PEACH ORCHARD RD STE 8",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309069998,
    "dropmaladd": "3108 PEACH ORCHARD RD STE 8",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066193622,
    "dropsitcph": 7067981305,
    "dropfax": 7067966106
  },
  {
    "dcode": "D",
    "dropkey": "BX10970",
    "droptype": "D",
    "dropname": "PEACHTREE CITY",
    "dropdeladd": "151 HIGHWAY 74 S",
    "dropdelcty": "PEACHTREE CITY",
    "dropdelst": "GA",
    "dropdelzpp": 302699998,
    "dropphyadd": "151 HIGHWAY 74 S",
    "dropphycty": "PEACHTREE CITY",
    "dropphyst": "GA",
    "dropphyzpp": 302699998,
    "dropmaladd": "151 HIGHWAY 74 S",
    "dropmalcty": "PEACHTREE CITY",
    "dropmalst": "GA",
    "dropmalzpp": 302699998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704860273,
    "dropsitcph": 7704866802,
    "dropfax": 7704868413
  },
  {
    "dcode": "D",
    "dropkey": "BX11096",
    "droptype": "D",
    "dropname": "SAINT SIMONS ISLAND",
    "dropdeladd": "260 EDWARDS PLZ",
    "dropdelcty": "SAINT SIMONS ISLAND",
    "dropdelst": "GA",
    "dropdelzpp": 315229998,
    "dropphyadd": "260 EDWARDS PLZ",
    "dropphycty": "SAINT SIMONS ISLAND",
    "dropphyst": "GA",
    "dropphyzpp": 315229998,
    "dropmaladd": "260 EDWARDS PLZ",
    "dropmalcty": "SAINT SIMONS ISLAND",
    "dropmalst": "GA",
    "dropmalzpp": 315229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126383623,
    "dropsitcph": 9126383623,
    "dropfax": 9126340054
  },
  {
    "dcode": "D",
    "dropkey": "BX11797",
    "droptype": "D",
    "dropname": "CASTLETON",
    "dropdeladd": "8710 BASH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462569998,
    "dropphyadd": "8710 BASH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462569998,
    "dropmaladd": "8710 BASH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462569998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11838",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "7 N WASHINGTON ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "IN",
    "dropdelzpp": 460179998,
    "dropphyadd": "7 N WASHINGTON ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "IN",
    "dropphyzpp": 460179998,
    "dropmaladd": "7 N WASHINGTON ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "IN",
    "dropmalzpp": 460179998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653787346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11862",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "757 E LEWIS AND CLARK PKWY STE 814",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471299998,
    "dropphyadd": "757 E LEWIS AND CLARK PKWY STE 814",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471299998,
    "dropmaladd": "757 E LEWIS AND CLARK PKWY STE 814",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122831396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11877",
    "droptype": "D",
    "dropname": "CLERMONT",
    "dropdeladd": "3239 TANSEL RD",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462349998,
    "dropphyadd": "3239 TANSEL RD",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462349998,
    "dropmaladd": "3239 TANSEL RD",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11906",
    "droptype": "D",
    "dropname": "COLLEGEVILLE",
    "dropdeladd": "1515 KENKEL DR",
    "dropdelcty": "RENSSELAER",
    "dropdelst": "IN",
    "dropdelzpp": 479783126,
    "dropphyadd": "1515 KENKEL DR",
    "dropphycty": "RENSSELAER",
    "dropphyst": "IN",
    "dropphyzpp": 479783126,
    "dropmaladd": "225 S VAN RENSSELAER ST",
    "dropmalcty": "RENSSELAER",
    "dropmalst": "IN",
    "dropmalzpp": 479789998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2198665322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11960",
    "droptype": "D",
    "dropname": "CRANE NAVAL DEPOT",
    "dropdeladd": "300 HIGHWAY 361",
    "dropdelcty": "CRANE",
    "dropdelst": "IN",
    "dropdelzpp": 475224000,
    "dropphyadd": "300 HIGHWAY 361",
    "dropphycty": "CRANE",
    "dropphyst": "IN",
    "dropphyzpp": 475224000,
    "dropmaladd": "300 HIGHWAY 361",
    "dropmalcty": "CRANE",
    "dropmalst": "IN",
    "dropmalzpp": 475224000,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128543400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX11989",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "11600 E WASHINGTON ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462299998,
    "dropphyadd": "11600 E WASHINGTON ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462299998,
    "dropmaladd": "11600 E WASHINGTON ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX12089",
    "droptype": "D",
    "dropname": "EAGLE CREEK",
    "dropdeladd": "6401 GATEWAY DR",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462549998,
    "dropphyadd": "6401 GATEWAY DR",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462549998,
    "dropmaladd": "6401 GATEWAY DR",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646814,
    "dropfax": 3174646105
  },
  {
    "dcode": "D",
    "dropkey": "BX12466",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "8500 KENNEDY AVE",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "IN",
    "dropdelzpp": 463221619,
    "dropphyadd": "8500 KENNEDY AVE",
    "dropphycty": "HIGHLAND",
    "dropphyst": "IN",
    "dropphyzpp": 463221619,
    "dropmaladd": "8500 KENNEDY AVE",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "IN",
    "dropmalzpp": 463221619,
    "dropsitphn": 2198381248,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198381248,
    "dropfax": 2199379470
  },
  {
    "dcode": "D",
    "dropkey": "BX12700",
    "droptype": "D",
    "dropname": "LAKE STATION",
    "dropdeladd": "2901 CENTRAL AVE",
    "dropdelcty": "LAKE STATION",
    "dropdelst": "IN",
    "dropdelzpp": 464059998,
    "dropphyadd": "2901 CENTRAL AVE",
    "dropphycty": "LAKE STATION",
    "dropphyst": "IN",
    "dropphyzpp": 464059998,
    "dropmaladd": "2901 CENTRAL AVE",
    "dropmalcty": "LAKE STATION",
    "dropmalst": "IN",
    "dropmalzpp": 464059998,
    "dropsitphn": 2199621880,
    "dropsitlph": 2198868051,
    "dropsitcph": 2199621880,
    "dropfax": 2199625079
  },
  {
    "dcode": "D",
    "dropkey": "BX12729",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "4430 MCCOY ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462269998,
    "dropphyadd": "4430 MCCOY ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462269998,
    "dropmaladd": "4430 MCCOY ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX12914",
    "droptype": "D",
    "dropname": "MERRILLVILLE",
    "dropdeladd": "303 W 80TH PL",
    "dropdelcty": "MERRILLVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 464109998,
    "dropphyadd": "303 W 80TH PL",
    "dropphycty": "MERRILLVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 464109998,
    "dropmaladd": "303 W 80TH PL",
    "dropmalcty": "MERRILLVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 464109998,
    "dropsitphn": 2197692155,
    "dropsitlph": 2198868051,
    "dropsitcph": 2197692155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX13030",
    "droptype": "D",
    "dropname": "MUNSTER",
    "dropdeladd": "915 RIDGE RD BLDG 2",
    "dropdelcty": "MUNSTER",
    "dropdelst": "IN",
    "dropdelzpp": 463219998,
    "dropphyadd": "915 RIDGE RD BLDG 2",
    "dropphycty": "MUNSTER",
    "dropphyst": "IN",
    "dropphyzpp": 463219998,
    "dropmaladd": "915 RIDGE RD BLDG 2",
    "dropmalcty": "MUNSTER",
    "dropmalst": "IN",
    "dropmalzpp": 463219998,
    "dropsitphn": 2198398005,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198368225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX13057",
    "droptype": "D",
    "dropname": "NEW AUGUSTA",
    "dropdeladd": "8401 MOLLER RD",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462689998,
    "dropphyadd": "8401 MOLLER RD",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462689998,
    "dropmaladd": "8401 MOLLER RD",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646868,
    "dropfax": 3174646796
  },
  {
    "dcode": "D",
    "dropkey": "BX13124",
    "droptype": "D",
    "dropname": "NORA",
    "dropdeladd": "1300 E 86TH ST STE 36A",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462409998,
    "dropphyadd": "1300 E 86TH ST STE 36A",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462409998,
    "dropmaladd": "1300 E 86TH ST STE 36A",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646840,
    "dropfax": 3174646762
  },
  {
    "dcode": "D",
    "dropkey": "BX13136",
    "droptype": "D",
    "dropname": "NORTH TERRE HAUTE",
    "dropdeladd": "4900 N LAFAYETTE ST",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478059998,
    "dropphyadd": "4900 N LAFAYETTE ST",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478059998,
    "dropmaladd": "4900 N LAFAYETTE ST",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478059998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124601913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX13180",
    "droptype": "D",
    "dropname": "OAKLANDON",
    "dropdeladd": "12125 E 65TH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462369998,
    "dropphyadd": "12125 E 65TH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462369998,
    "dropmaladd": "12125 E 65TH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646836,
    "dropfax": 3174646554
  },
  {
    "dcode": "D",
    "dropkey": "BX13241",
    "droptype": "D",
    "dropname": "PARK FLETCHER",
    "dropdeladd": "2760 FORTUNE CIR E",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462419998,
    "dropphyadd": "2760 FORTUNE CIR E",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462419998,
    "dropmaladd": "2760 FORTUNE CIR E",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646841,
    "dropfax": 3174646359
  },
  {
    "dcode": "D",
    "dropkey": "BX13631",
    "droptype": "D",
    "dropname": "SOUTHPORT",
    "dropdeladd": "1701 E EDGEWOOD AVE",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462279998,
    "dropphyadd": "1701 E EDGEWOOD AVE",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462279998,
    "dropmaladd": "1701 E EDGEWOOD AVE",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646827,
    "dropfax": 3174646438
  },
  {
    "dcode": "D",
    "dropkey": "BX13641",
    "droptype": "D",
    "dropname": "SPEEDWAY",
    "dropdeladd": "6110 W 25TH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462249998,
    "dropphyadd": "6110 W 25TH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462249998,
    "dropmaladd": "6110 W 25TH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646824,
    "dropfax": 3174646522
  },
  {
    "dcode": "D",
    "dropkey": "BX13966",
    "droptype": "D",
    "dropname": "WANAMAKER",
    "dropdeladd": "7950 SOUTHEASTERN AVE",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462399998,
    "dropphyadd": "7950 SOUTHEASTERN AVE",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462399998,
    "dropmaladd": "7950 SOUTHEASTERN AVE",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462399998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX14019",
    "droptype": "D",
    "dropname": "WEST LAFAYETTE",
    "dropdeladd": "610 W NAVAJO ST",
    "dropdelcty": "WEST LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479061902,
    "dropphyadd": "610 W NAVAJO ST",
    "dropphycty": "WEST LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479061902,
    "dropmaladd": "610 W NAVAJO ST",
    "dropmalcty": "WEST LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479061902,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489288,
    "dropfax": 7654979880
  },
  {
    "dcode": "D",
    "dropkey": "BX14108",
    "droptype": "D",
    "dropname": "WOODBRIDGE",
    "dropdeladd": "3210 E 10TH ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474089990,
    "dropphyadd": "3210 E 10TH ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474089990,
    "dropmaladd": "3210 E 10TH ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474089990,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123314553,
    "dropfax": 8123352266
  },
  {
    "dcode": "D",
    "dropkey": "BX14192",
    "droptype": "D",
    "dropname": "ANCHORAGE",
    "dropdeladd": "11501 PARK RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402239997,
    "dropphyadd": "11501 PARK RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402239997,
    "dropmaladd": "11501 PARK RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402239997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022451008,
    "dropfax": 5022457963
  },
  {
    "dcode": "D",
    "dropkey": "BX14303",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "361 TAYLOR AVE",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "KY",
    "dropdelzpp": 410739998,
    "dropphyadd": "361 TAYLOR AVE",
    "dropphycty": "BELLEVUE",
    "dropphyst": "KY",
    "dropphyzpp": 410739998,
    "dropmaladd": "420 COLUMBIA ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "KY",
    "dropmalzpp": 410719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8592612358,
    "dropfax": 8592914934
  },
  {
    "dcode": "D",
    "dropkey": "BX14635",
    "droptype": "D",
    "dropname": "COLD SPRGS HIGHLAND HTS",
    "dropdeladd": "2701 ALEXANDRIA WAY",
    "dropdelcty": "HIGHLAND HEIGHTS",
    "dropdelst": "KY",
    "dropdelzpp": 410769998,
    "dropphyadd": "2701 ALEXANDRIA WAY",
    "dropphycty": "HIGHLAND HEIGHTS",
    "dropphyst": "KY",
    "dropphyzpp": 410769998,
    "dropmaladd": "2701 ALEXANDRIA WAY",
    "dropmalcty": "HIGHLAND HEIGHTS",
    "dropmalst": "KY",
    "dropmalzpp": 410769998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8594412037,
    "dropfax": 5136845194
  },
  {
    "dcode": "D",
    "dropkey": "BX14812",
    "droptype": "D",
    "dropname": "DIXIE",
    "dropdeladd": "123 BUTTERMILK PIKE",
    "dropdelcty": "LAKESIDE PARK",
    "dropdelst": "KY",
    "dropdelzpp": 410179998,
    "dropphyadd": "123 BUTTERMILK PIKE",
    "dropphycty": "LAKESIDE PARK",
    "dropphyst": "KY",
    "dropphyzpp": 410179998,
    "dropmaladd": "123 BUTTERMILK PIKE",
    "dropmalcty": "LAKESIDE PARK",
    "dropmalst": "KY",
    "dropmalzpp": 410179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8593312175,
    "dropfax": 8593314204
  },
  {
    "dcode": "D",
    "dropkey": "BX14939",
    "droptype": "D",
    "dropname": "ERLANGER",
    "dropdeladd": "3135 DIXIE HWY",
    "dropdelcty": "ERLANGER",
    "dropdelst": "KY",
    "dropdelzpp": 410189998,
    "dropphyadd": "3135 DIXIE HWY",
    "dropphycty": "ERLANGER",
    "dropphyst": "KY",
    "dropphyzpp": 410189998,
    "dropmaladd": "3135 DIXIE HWY",
    "dropmalcty": "ERLANGER",
    "dropmalst": "KY",
    "dropmalzpp": 410189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8594267071,
    "dropfax": 8594260994
  },
  {
    "dcode": "D",
    "dropkey": "BX14985",
    "droptype": "D",
    "dropname": "FERN CREEK",
    "dropdeladd": "9100 FERN CREEK RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402919998,
    "dropphyadd": "9100 FERN CREEK RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402919998,
    "dropmaladd": "9100 FERN CREEK RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402919998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022392720,
    "dropfax": 5022315648
  },
  {
    "dcode": "D",
    "dropkey": "BX15037",
    "droptype": "D",
    "dropname": "FORT THOMAS",
    "dropdeladd": "24 S FORT THOMAS AVE",
    "dropdelcty": "FORT THOMAS",
    "dropdelst": "KY",
    "dropdelzpp": 410759998,
    "dropphyadd": "24 S FORT THOMAS AVE",
    "dropphycty": "FORT THOMAS",
    "dropphyst": "KY",
    "dropphyzpp": 410759998,
    "dropmaladd": "24 S FORT THOMAS AVE",
    "dropmalcty": "FORT THOMAS",
    "dropmalst": "KY",
    "dropmalzpp": 410759998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8594416359,
    "dropfax": 8594416359
  },
  {
    "dcode": "D",
    "dropkey": "BX15421",
    "droptype": "D",
    "dropname": "JEFFERSONTOWN",
    "dropdeladd": "3801 BILLTOWN RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402999998,
    "dropphyadd": "3801 BILLTOWN RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402999998,
    "dropmaladd": "3801 BILLTOWN RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402999998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022665844,
    "dropfax": 5022666799
  },
  {
    "dcode": "D",
    "dropkey": "BX15526",
    "droptype": "D",
    "dropname": "LATONIA",
    "dropdeladd": "111 E SOUTHERN AVE",
    "dropdelcty": "COVINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 410159998,
    "dropphyadd": "111 E SOUTHERN AVE",
    "dropphycty": "COVINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 410159998,
    "dropmaladd": "3135 DIXIE HWY",
    "dropmalcty": "ERLANGER",
    "dropmalst": "KY",
    "dropmalzpp": 410189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8594314201,
    "dropfax": 8592913807
  },
  {
    "dcode": "D",
    "dropkey": "BX15653",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "640 ELM ST",
    "dropdelcty": "LUDLOW",
    "dropdelst": "KY",
    "dropdelzpp": 410169998,
    "dropphyadd": "640 ELM ST",
    "dropphycty": "LUDLOW",
    "dropphyst": "KY",
    "dropphyzpp": 410169998,
    "dropmaladd": "640 ELM ST",
    "dropmalcty": "LUDLOW",
    "dropmalst": "KY",
    "dropmalzpp": 410169998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8592610815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX15655",
    "droptype": "D",
    "dropname": "LYNDON",
    "dropdeladd": "8127 LA GRANGE RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402229998,
    "dropphyadd": "8127 LA GRANGE RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402229998,
    "dropmaladd": "8127 LA GRANGE RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024254547,
    "dropfax": 5024268522
  },
  {
    "dcode": "D",
    "dropkey": "BX15774",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "119 EVERGREEN RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402439998,
    "dropphyadd": "119 EVERGREEN RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402439998,
    "dropmaladd": "119 EVERGREEN RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022455791,
    "dropfax": 5022458035
  },
  {
    "dcode": "D",
    "dropkey": "BX15955",
    "droptype": "D",
    "dropname": "OKOLONA",
    "dropdeladd": "7400 JEFFERSON BLVD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402199998,
    "dropphyadd": "7400 JEFFERSON BLVD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402199998,
    "dropmaladd": "7400 JEFFERSON BLVD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029668049,
    "dropfax": 5029645178
  },
  {
    "dcode": "D",
    "dropkey": "BX16075",
    "droptype": "D",
    "dropname": "PLEASURE RIDGE PARK",
    "dropdeladd": "6121 GREENWOOD RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402589998,
    "dropphyadd": "6121 GREENWOOD RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402589998,
    "dropmaladd": "6121 GREENWOOD RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029334841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX16276",
    "droptype": "D",
    "dropname": "SAINT MATTHEWS",
    "dropdeladd": "4600 SHELBYVILLE RD STE 126",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402079998,
    "dropphyadd": "4600 SHELBYVILLE RD STE 126",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402079998,
    "dropmaladd": "4600 SHELBYVILLE RD STE 126",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028940378,
    "dropfax": 5028955376
  },
  {
    "dcode": "D",
    "dropkey": "BX16355",
    "droptype": "D",
    "dropname": "SHIVELY",
    "dropdeladd": "3131 CRUMS LN",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402169998,
    "dropphyadd": "3131 CRUMS LN",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402169998,
    "dropmaladd": "3131 CRUMS LN",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024492657,
    "dropfax": 5024474618
  },
  {
    "dcode": "D",
    "dropkey": "BX17001",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "1740 5TH AVE",
    "dropdelcty": "NEW KENSINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 150684418,
    "dropphyadd": "1740 5TH AVE",
    "dropphycty": "NEW KENSINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 150684418,
    "dropmaladd": "1740 5TH AVE",
    "dropmalcty": "NEW KENSINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 150684418,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243357120,
    "dropsitcph": 7243357120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17018",
    "droptype": "D",
    "dropname": "ASPINWALL",
    "dropdeladd": "12 BRILLIANT AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152153136,
    "dropphyadd": "12 BRILLIANT AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152153136,
    "dropmaladd": "12 BRILLIANT AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152153136,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127810548,
    "dropsitcph": 4127810548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17019",
    "droptype": "D",
    "dropname": "ASTON",
    "dropdeladd": "4708 PENNELL RD",
    "dropdelcty": "ASTON",
    "dropdelst": "PA",
    "dropdelzpp": 190149997,
    "dropphyadd": "4708 PENNELL RD",
    "dropphycty": "ASTON",
    "dropphyst": "PA",
    "dropphyzpp": 190149997,
    "dropmaladd": "4708 PENNELL RD",
    "dropmalcty": "ASTON",
    "dropmalst": "PA",
    "dropmalzpp": 190149997,
    "dropsitphn": 2158958561,
    "dropsitlph": 6108769823,
    "dropsitcph": 6108761265,
    "dropfax": 6108764070
  },
  {
    "dcode": "D",
    "dropkey": "BX17032",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "2838 AUDUBON VILLAGE DR OFC",
    "dropdelcty": "AUDUBON",
    "dropdelst": "PA",
    "dropdelzpp": 194079998,
    "dropphyadd": "2838 AUDUBON VILLAGE DR OFC",
    "dropphycty": "AUDUBON",
    "dropphyst": "PA",
    "dropphyzpp": 194079998,
    "dropmaladd": "2838 AUDUBON VILLAGE DR OFC",
    "dropmalcty": "AUDUBON",
    "dropmalst": "PA",
    "dropmalzpp": 194079998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106665211,
    "dropsitcph": 6106665211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17043",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "PA",
    "dropdelzpp": 186411622,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "AVOCA",
    "dropphyst": "PA",
    "dropphyzpp": 186411622,
    "dropmaladd": "701 MAIN ST",
    "dropmalcty": "AVOCA",
    "dropmalst": "PA",
    "dropmalzpp": 186411622,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704573321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17160",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "15 N SPRAGUE AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152029998,
    "dropphyadd": "15 N SPRAGUE AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152029998,
    "dropmaladd": "15 N SPRAGUE AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152029998,
    "dropsitphn": 4123597864,
    "dropsitlph": 4127610527,
    "dropsitcph": 4127610527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17249",
    "droptype": "D",
    "dropname": "BLAWNOX",
    "dropdeladd": "1310 OLD FREEPORT RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152389998,
    "dropphyadd": "1310 OLD FREEPORT RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152389998,
    "dropmaladd": "1310 OLD FREEPORT RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4129631330,
    "dropsitcph": 4129631330,
    "dropfax": 4129631821
  },
  {
    "dcode": "D",
    "dropkey": "BX17285",
    "droptype": "D",
    "dropname": "BOOTHWYN",
    "dropdeladd": "3390 CHICHESTER AVE",
    "dropdelcty": "UPPER CHICHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 190619996,
    "dropphyadd": "3390 CHICHESTER AVE",
    "dropphycty": "UPPER CHICHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 190619996,
    "dropmaladd": "3390 CHICHESTER AVE",
    "dropmalcty": "UPPER CHICHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 190619996,
    "dropsitphn": 2158958561,
    "dropsitlph": 6104854749,
    "dropsitcph": 6104854749,
    "dropfax": 6104859445
  },
  {
    "dcode": "D",
    "dropkey": "BX17287",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "5727 SMITHFIELD ST",
    "dropdelcty": "MCKEESPORT",
    "dropdelst": "PA",
    "dropdelzpp": 151359998,
    "dropphyadd": "5727 SMITHFIELD ST",
    "dropphycty": "MCKEESPORT",
    "dropphyst": "PA",
    "dropphyzpp": 151359998,
    "dropmaladd": "5727 SMITHFIELD ST",
    "dropmalcty": "MCKEESPORT",
    "dropmalst": "PA",
    "dropmalzpp": 151359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127517220,
    "dropsitcph": 4127517220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17347",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "350 TOWNE SQUARE WAY",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152279998,
    "dropphyadd": "350 TOWNE SQUARE WAY",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152279998,
    "dropmaladd": "350 TOWNE SQUARE WAY",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126554912,
    "dropsitcph": 4128811666,
    "dropfax": 4128811899
  },
  {
    "dcode": "D",
    "dropkey": "BX17356",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "312 MILL ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "PA",
    "dropdelzpp": 194059998,
    "dropphyadd": "312 MILL ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "PA",
    "dropphyzpp": 194059998,
    "dropmaladd": "312 MILL ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "PA",
    "dropmalzpp": 194059998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102397419,
    "dropsitcph": 6102397419,
    "dropfax": 6102758124
  },
  {
    "dcode": "D",
    "dropkey": "BX17381",
    "droptype": "D",
    "dropname": "BROOKHAVEN",
    "dropdeladd": "3522 EDGMONT AVE",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 190159998,
    "dropphyadd": "3522 EDGMONT AVE",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 190159998,
    "dropmaladd": "3522 EDGMONT AVE",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 190159998,
    "dropsitphn": 2158958561,
    "dropsitlph": 6108764006,
    "dropsitcph": 6108764006,
    "dropfax": 6108764070
  },
  {
    "dcode": "D",
    "dropkey": "BX17437",
    "droptype": "D",
    "dropname": "NETWORK DISTRIBUTION CT",
    "dropdeladd": "300 BRUSH CREEK RD",
    "dropdelcty": "WARRENDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150951002,
    "dropphyadd": "300 BRUSH CREEK RD",
    "dropphycty": "WARRENDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150959995,
    "dropmaladd": "PO BOX 1000",
    "dropmalcty": "WARRENDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150951000,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247766217,
    "dropsitcph": 7247766217,
    "dropfax": 7247766325
  },
  {
    "dcode": "D",
    "dropkey": "BX17461",
    "droptype": "D",
    "dropname": "BUTZTOWN",
    "dropdeladd": "3232 EASTON AVE",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180204200,
    "dropphyadd": "3232 EASTON AVE",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180204200,
    "dropmaladd": "535 WOOD ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "PA",
    "dropmalzpp": 180169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108671971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17503",
    "droptype": "D",
    "dropname": "CARLISLE BARRACKS",
    "dropdeladd": "1 CARLISLE BARRACKS",
    "dropdelcty": "CARLISLE",
    "dropdelst": "PA",
    "dropdelzpp": 170139997,
    "dropphyadd": "1 CARLISLE BARRACKS",
    "dropphycty": "CARLISLE",
    "dropphyst": "PA",
    "dropphyzpp": 170139997,
    "dropmaladd": "1 CARLISLE BARRACKS",
    "dropmalcty": "CARLISLE",
    "dropmalst": "PA",
    "dropmalzpp": 170139997,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172416463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17531",
    "droptype": "D",
    "dropname": "CASTLE SHANNON",
    "dropdeladd": "370 CASTLE SHANNON BLVD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152349998,
    "dropphyadd": "370 CASTLE SHANNON BLVD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152349998,
    "dropmaladd": "370 CASTLE SHANNON BLVD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152349998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4125611173,
    "dropsitcph": 4125611173,
    "dropfax": 4123412863
  },
  {
    "dcode": "D",
    "dropkey": "BX17550",
    "droptype": "D",
    "dropname": "CEDARHURST",
    "dropdeladd": "1099 BOWER HILL RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152439998,
    "dropphyadd": "1099 BOWER HILL RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152439998,
    "dropmaladd": "1099 BOWER HILL RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152439998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122781407,
    "dropsitcph": 4122781407,
    "dropfax": 4129231001
  },
  {
    "dcode": "D",
    "dropkey": "BX17675",
    "droptype": "D",
    "dropname": "CLEONA",
    "dropdeladd": "25 N LINCOLN ST",
    "dropdelcty": "CLEONA",
    "dropdelst": "PA",
    "dropdelzpp": 170429997,
    "dropphyadd": "25 N LINCOLN ST",
    "dropphycty": "CLEONA",
    "dropphyst": "PA",
    "dropphyzpp": 170429997,
    "dropmaladd": "25 N LINCOLN ST",
    "dropmalcty": "CLEONA",
    "dropmalst": "PA",
    "dropmalzpp": 170429997,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172732465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17730",
    "droptype": "D",
    "dropname": "COLLINGDALE",
    "dropdeladd": "705 MACDADE BLVD",
    "dropdelcty": "DARBY",
    "dropdelst": "PA",
    "dropdelzpp": 190239997,
    "dropphyadd": "705 MACDADE BLVD",
    "dropphycty": "DARBY",
    "dropphyst": "PA",
    "dropphyzpp": 190239997,
    "dropmaladd": "705 MACDADE BLVD",
    "dropmalcty": "DARBY",
    "dropmalst": "PA",
    "dropmalzpp": 190239997,
    "dropsitphn": 2158958561,
    "dropsitlph": 6105864281,
    "dropsitcph": 6105864281,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "BX17820",
    "droptype": "D",
    "dropname": "CRAFTON",
    "dropdeladd": "90 W STEUBEN ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152059998,
    "dropphyadd": "90 W STEUBEN ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152059998,
    "dropmaladd": "90 W STEUBEN ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152059998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122796955,
    "dropsitcph": 4129217983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX17852",
    "droptype": "D",
    "dropname": "CROYDON",
    "dropdeladd": "300 BRISTOL PIKE",
    "dropdelcty": "CROYDON",
    "dropdelst": "PA",
    "dropdelzpp": 190219997,
    "dropphyadd": "300 BRISTOL PIKE",
    "dropphycty": "CROYDON",
    "dropphyst": "PA",
    "dropphyzpp": 190219997,
    "dropmaladd": "300 BRISTOL PIKE",
    "dropmalcty": "CROYDON",
    "dropmalst": "PA",
    "dropmalzpp": 190219997,
    "dropsitphn": 2156339436,
    "dropsitlph": 2156395051,
    "dropsitcph": 2156395051,
    "dropfax": 2156394990
  },
  {
    "dcode": "D",
    "dropkey": "BX17854",
    "droptype": "D",
    "dropname": "CRUM LYNNE",
    "dropdeladd": "1416 CHESTER PIKE",
    "dropdelcty": "CRUM LYNNE",
    "dropdelst": "PA",
    "dropdelzpp": 190229998,
    "dropphyadd": "1416 CHESTER PIKE",
    "dropphycty": "CRUM LYNNE",
    "dropphyst": "PA",
    "dropphyzpp": 190229998,
    "dropmaladd": "1416 CHESTER PIKE",
    "dropmalcty": "CRUM LYNNE",
    "dropmalst": "PA",
    "dropmalzpp": 190229998,
    "dropsitphn": 2158958561,
    "dropsitlph": 6108331476,
    "dropsitcph": 6108331476,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "BX17987",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "24 N MAIN ST",
    "dropdelcty": "DOVER",
    "dropdelst": "PA",
    "dropdelzpp": 173159998,
    "dropphyadd": "24 N MAIN ST",
    "dropphycty": "DOVER",
    "dropphyst": "PA",
    "dropphyzpp": 173159998,
    "dropmaladd": "24 N MAIN ST",
    "dropmalcty": "DOVER",
    "dropmalst": "PA",
    "dropmalzpp": 173159998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172927318,
    "dropsitcph": 7172927318,
    "dropfax": 7172921475
  },
  {
    "dcode": "D",
    "dropkey": "BX18039",
    "droptype": "D",
    "dropname": "DUNMORE",
    "dropdeladd": "114 N BLAKELY ST",
    "dropdelcty": "DUNMORE",
    "dropdelst": "PA",
    "dropdelzpp": 185129998,
    "dropphyadd": "114 N BLAKELY ST",
    "dropphycty": "DUNMORE",
    "dropphyst": "PA",
    "dropphyzpp": 185129998,
    "dropmaladd": "114 N BLAKELY ST",
    "dropmalcty": "DUNMORE",
    "dropmalst": "PA",
    "dropmalzpp": 185129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703438914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18049",
    "droptype": "D",
    "dropname": "DURYEA",
    "dropdeladd": "450 STEPHENSON ST",
    "dropdelcty": "DURYEA",
    "dropdelst": "PA",
    "dropdelzpp": 186421500,
    "dropphyadd": "450 STEPHENSON ST",
    "dropphycty": "DURYEA",
    "dropphyst": "PA",
    "dropphyzpp": 186421500,
    "dropmaladd": "11 DOCK ST",
    "dropmalcty": "PITTSTON",
    "dropmalst": "PA",
    "dropmalzpp": 186409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704573701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18088",
    "droptype": "D",
    "dropname": "EAGLEVILLE",
    "dropdeladd": "3200 RIDGE PIKE STE 300",
    "dropdelcty": "NORRISTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194039998,
    "dropphyadd": "3200 RIDGE PIKE STE 300",
    "dropphycty": "NORRISTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194039998,
    "dropmaladd": "3200 RIDGE PIKE STE 300",
    "dropmalcty": "NORRISTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194039998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106309718,
    "dropsitcph": 6106661592,
    "dropfax": 6105391367
  },
  {
    "dcode": "D",
    "dropkey": "BX18118",
    "droptype": "D",
    "dropname": "EAST LANCASTER",
    "dropdeladd": "1813 OLDE HOMESTEAD LN",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176015868,
    "dropphyadd": "1813 OLDE HOMESTEAD LN",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176015868,
    "dropmaladd": "1813 OLDE HOMESTEAD LN",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176015868,
    "dropsitphn": 7172912905,
    "dropsitlph": 7173968782,
    "dropsitcph": 7172912905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18234",
    "droptype": "D",
    "dropname": "ELWYN",
    "dropdeladd": "5 GLEN RIDDLE RD",
    "dropdelcty": "MEDIA",
    "dropdelst": "PA",
    "dropdelzpp": 190639995,
    "dropphyadd": "5 GLEN RIDDLE RD",
    "dropphycty": "MEDIA",
    "dropphyst": "PA",
    "dropphyzpp": 190639995,
    "dropmaladd": "5 GLEN RIDDLE RD",
    "dropmalcty": "MEDIA",
    "dropmalst": "PA",
    "dropmalzpp": 190639995,
    "dropsitphn": 2158958561,
    "dropsitlph": 6105662183,
    "dropsitcph": 6105662183,
    "dropfax": 6105657040
  },
  {
    "dcode": "D",
    "dropkey": "BX18276",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "335 BUTLER ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152239998,
    "dropphyadd": "335 BUTLER ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152239998,
    "dropmaladd": "335 BUTLER ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152239998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127810612,
    "dropsitcph": 4127810612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18336",
    "droptype": "D",
    "dropname": "FAIRVIEW VILLAGE",
    "dropdeladd": "1025 VALLEY FORGE RD",
    "dropdelcty": "FAIRVIEW VILLAGE",
    "dropdelst": "PA",
    "dropdelzpp": 194099998,
    "dropphyadd": "1025 VALLEY FORGE RD",
    "dropphycty": "FAIRVIEW VILLAGE",
    "dropphyst": "PA",
    "dropphyzpp": 194099998,
    "dropmaladd": "1025 VALLEY FORGE RD",
    "dropmalcty": "FAIRVIEW VILLAGE",
    "dropmalst": "PA",
    "dropmalzpp": 194099998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106301736,
    "dropsitcph": 6106301736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18369",
    "droptype": "D",
    "dropname": "FEASTERVILLE TREVOSE",
    "dropdeladd": "275 E STREET RD STE A",
    "dropdelcty": "FEASTERVILLE TREVOSE",
    "dropdelst": "PA",
    "dropdelzpp": 190539997,
    "dropphyadd": "275 E STREET RD STE A",
    "dropphycty": "FEASTERVILLE TREVOSE",
    "dropphyst": "PA",
    "dropphyzpp": 190539997,
    "dropmaladd": "275 E STREET RD STE A",
    "dropmalcty": "FEASTERVILLE TREVOSE",
    "dropmalst": "PA",
    "dropmalzpp": 190539997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2159530690,
    "dropsitcph": 2159530690,
    "dropfax": 2157578327
  },
  {
    "dcode": "D",
    "dropkey": "BX18482",
    "droptype": "D",
    "dropname": "FOXCROFT SQUARE",
    "dropdeladd": "261 OLD YORK RD",
    "dropdelcty": "JENKINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190469995,
    "dropphyadd": "261 OLD YORK RD",
    "dropphycty": "JENKINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190469995,
    "dropmaladd": "261 OLD YORK RD",
    "dropmalcty": "JENKINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190469995,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158866831,
    "dropsitcph": 2158866831,
    "dropfax": 2158870753
  },
  {
    "dcode": "D",
    "dropkey": "BX18501",
    "droptype": "D",
    "dropname": "FRAZER",
    "dropdeladd": "490 LANCASTER AVE STE 15",
    "dropdelcty": "MALVERN",
    "dropdelst": "PA",
    "dropdelzpp": 193559997,
    "dropphyadd": "490 LANCASTER AVE STE 15",
    "dropphycty": "MALVERN",
    "dropphyst": "PA",
    "dropphyzpp": 193559997,
    "dropmaladd": "490 LANCASTER AVE STE 15",
    "dropmalcty": "MALVERN",
    "dropmalst": "PA",
    "dropmalzpp": 193559997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102964592,
    "dropsitcph": 6102964592,
    "dropfax": 6106447726
  },
  {
    "dcode": "D",
    "dropkey": "BX18576",
    "droptype": "D",
    "dropname": "GEORGE SCHOOL",
    "dropdeladd": "1690 NEWTOWN LANGHORNE RD",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189409997,
    "dropphyadd": "1690 NEWTOWN LANGHORNE RD",
    "dropphycty": "NEWTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189409997,
    "dropmaladd": "1690 NEWTOWN LANGHORNE RD",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189409997,
    "dropsitphn": 6109646414,
    "dropsitlph": 2159683041,
    "dropsitcph": 2159683041,
    "dropfax": 2155796604
  },
  {
    "dcode": "D",
    "dropkey": "BX18624",
    "droptype": "D",
    "dropname": "GLEN RIDDLE LIMA",
    "dropdeladd": "18 S PENNELL RD",
    "dropdelcty": "MEDIA",
    "dropdelst": "PA",
    "dropdelzpp": 190639994,
    "dropphyadd": "18 S PENNELL RD",
    "dropphycty": "MEDIA",
    "dropphyst": "PA",
    "dropphyzpp": 190639994,
    "dropmaladd": "18 S PENNELL RD",
    "dropmalcty": "MEDIA",
    "dropmalst": "PA",
    "dropmalzpp": 190639994,
    "dropsitphn": 2158958561,
    "dropsitlph": 6105665268,
    "dropsitcph": 6105665268,
    "dropfax": 6105657040
  },
  {
    "dcode": "D",
    "dropkey": "BX18697",
    "droptype": "D",
    "dropname": "GREEN HILLS",
    "dropdeladd": "1198 CHESTER PIKE STE 2",
    "dropdelcty": "SHARON HILL",
    "dropdelst": "PA",
    "dropdelzpp": 190799997,
    "dropphyadd": "1198 CHESTER PIKE STE 2",
    "dropphycty": "SHARON HILL",
    "dropphyst": "PA",
    "dropphyzpp": 190799997,
    "dropmaladd": "1198 CHESTER PIKE STE 2",
    "dropmalcty": "SHARON HILL",
    "dropmalst": "PA",
    "dropmalzpp": 190799997,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6105867397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18723",
    "droptype": "D",
    "dropname": "GREENTREE",
    "dropdeladd": "770 TRUMBULL DR",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152054363,
    "dropphyadd": "770 TRUMBULL DR",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152054363,
    "dropmaladd": "PO BOX 16500",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152429998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122761698,
    "dropsitcph": 4122796955,
    "dropfax": 4122760790
  },
  {
    "dcode": "D",
    "dropkey": "BX18795",
    "droptype": "D",
    "dropname": "HARMONVILLE",
    "dropdeladd": "421 W RIDGE PIKE",
    "dropdelcty": "CONSHOHOCKEN",
    "dropdelst": "PA",
    "dropdelzpp": 194289997,
    "dropphyadd": "421 W RIDGE PIKE",
    "dropphycty": "CONSHOHOCKEN",
    "dropphyst": "PA",
    "dropphyzpp": 194289997,
    "dropmaladd": "421 W RIDGE PIKE",
    "dropmalcty": "CONSHOHOCKEN",
    "dropmalst": "PA",
    "dropmalzpp": 194289997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108281611,
    "dropsitcph": 6108257297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX18824",
    "droptype": "D",
    "dropname": "HAVERTOWN",
    "dropdeladd": "444 E TOWNSHIP LINE RD",
    "dropdelcty": "HAVERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190839998,
    "dropphyadd": "444 E TOWNSHIP LINE RD",
    "dropphycty": "HAVERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190839998,
    "dropmaladd": "444 E TOWNSHIP LINE RD",
    "dropmalcty": "HAVERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190839998,
    "dropsitphn": 6104467153,
    "dropsitlph": 6107897282,
    "dropsitcph": 6104467153,
    "dropfax": 6107891929
  },
  {
    "dcode": "D",
    "dropkey": "BX18877",
    "droptype": "D",
    "dropname": "HERMITAGE",
    "dropdeladd": "3386 E STATE ST",
    "dropdelcty": "HERMITAGE",
    "dropdelst": "PA",
    "dropdelzpp": 161483300,
    "dropphyadd": "3386 E STATE ST",
    "dropphycty": "HERMITAGE",
    "dropphyst": "PA",
    "dropphyzpp": 161483300,
    "dropmaladd": "3386 E STATE ST",
    "dropmalcty": "HERMITAGE",
    "dropmalst": "PA",
    "dropmalzpp": 161483300,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243471100,
    "dropsitcph": 7243471100,
    "dropfax": 7243472267
  },
  {
    "dcode": "D",
    "dropkey": "BX19057",
    "droptype": "D",
    "dropname": "JACOBUS",
    "dropdeladd": "2 SMITH ST",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174079800,
    "dropphyadd": "2 SMITH ST",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174079800,
    "dropmaladd": "2 SMITH ST",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174079800,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174281105,
    "dropsitcph": 7174281105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19170",
    "droptype": "D",
    "dropname": "KING OF PRUSSIA",
    "dropdeladd": "620 ALLENDALE RD STE 125",
    "dropdelcty": "KING OF PRUSSIA",
    "dropdelst": "PA",
    "dropdelzpp": 194069990,
    "dropphyadd": "620 ALLENDALE RD STE 125",
    "dropphycty": "KING OF PRUSSIA",
    "dropphyst": "PA",
    "dropphyzpp": 194069990,
    "dropmaladd": "620 ALLENDALE RD STE 125",
    "dropmalcty": "KING OF PRUSSIA",
    "dropmalst": "PA",
    "dropmalzpp": 194069990,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103379823,
    "dropsitcph": 6103379823,
    "dropfax": 6102652228
  },
  {
    "dcode": "D",
    "dropkey": "BX19176",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "435 WYOMING AVE",
    "dropdelcty": "KINGSTON",
    "dropdelst": "PA",
    "dropdelzpp": 187049998,
    "dropphyadd": "435 WYOMING AVE",
    "dropphycty": "KINGSTON",
    "dropphyst": "PA",
    "dropphyzpp": 187049998,
    "dropmaladd": "435 WYOMING AVE",
    "dropmalcty": "KINGSTON",
    "dropmalst": "PA",
    "dropmalzpp": 187049998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5702879673,
    "dropfax": 5708313403
  },
  {
    "dcode": "D",
    "dropkey": "BX19292",
    "droptype": "D",
    "dropname": "LARGE",
    "dropdeladd": "1613 ROUTE 51",
    "dropdelcty": "CLAIRTON",
    "dropdelst": "PA",
    "dropdelzpp": 150253600,
    "dropphyadd": "1613 ROUTE 51",
    "dropphycty": "CLAIRTON",
    "dropphyst": "PA",
    "dropphyzpp": 150253600,
    "dropmaladd": "1613 ROUTE 51",
    "dropmalcty": "CLAIRTON",
    "dropmalst": "PA",
    "dropmalzpp": 150253600,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123842387,
    "dropsitcph": 4123842387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19421",
    "droptype": "D",
    "dropname": "LIMERICK",
    "dropdeladd": "327 W RIDGE PIKE STE A",
    "dropdelcty": "ROYERSFORD",
    "dropdelst": "PA",
    "dropdelzpp": 194689996,
    "dropphyadd": "327 W RIDGE PIKE STE A",
    "dropphycty": "ROYERSFORD",
    "dropphyst": "PA",
    "dropphyzpp": 194689996,
    "dropmaladd": "327 W RIDGE PIKE STE A",
    "dropmalcty": "ROYERSFORD",
    "dropmalst": "PA",
    "dropmalzpp": 194689996,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108315604,
    "dropsitcph": 6108315604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19443",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "1401 HUDDELL AVE STE 1",
    "dropdelcty": "MARCUS HOOK",
    "dropdelst": "PA",
    "dropdelzpp": 190619998,
    "dropphyadd": "1401 HUDDELL AVE STE 1",
    "dropphycty": "MARCUS HOOK",
    "dropphyst": "PA",
    "dropphyzpp": 190619998,
    "dropmaladd": "1401 HUDDELL AVE STE 1",
    "dropmalcty": "MARCUS HOOK",
    "dropmalst": "PA",
    "dropmalzpp": 190619998,
    "dropsitphn": 2158958561,
    "dropsitlph": 6104857576,
    "dropsitcph": 6104857576,
    "dropfax": 6104859445
  },
  {
    "dcode": "D",
    "dropkey": "BX19510",
    "droptype": "D",
    "dropname": "LOWER BURRELL",
    "dropdeladd": "2893 LEECHBURG RD",
    "dropdelcty": "NEW KENSINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 150682542,
    "dropphyadd": "2893 LEECHBURG RD",
    "dropphycty": "NEW KENSINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 150682542,
    "dropmaladd": "2893 LEECHBURG RD",
    "dropmalcty": "NEW KENSINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 150682542,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243357724,
    "dropsitcph": 7243357724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19516",
    "droptype": "D",
    "dropname": "LOWER PAXTON",
    "dropdeladd": "5901 JONESTOWN RD",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171129998,
    "dropphyadd": "5901 JONESTOWN RD",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171129998,
    "dropmaladd": "5901 JONESTOWN RD",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175458680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19541",
    "droptype": "D",
    "dropname": "LUZERNE",
    "dropdeladd": "122 MAIN ST",
    "dropdelcty": "LUZERNE",
    "dropdelst": "PA",
    "dropdelzpp": 187091260,
    "dropphyadd": "122 MAIN ST",
    "dropphycty": "LUZERNE",
    "dropphyst": "PA",
    "dropphyzpp": 187091260,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019990,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5702875941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19604",
    "droptype": "D",
    "dropname": "MAPLE GLEN",
    "dropdeladd": "520 LIMEKILN PIKE",
    "dropdelcty": "AMBLER",
    "dropdelst": "PA",
    "dropdelzpp": 190029997,
    "dropphyadd": "520 LIMEKILN PIKE",
    "dropphycty": "AMBLER",
    "dropphyst": "PA",
    "dropphyzpp": 190029997,
    "dropmaladd": "520 LIMEKILN PIKE",
    "dropmalcty": "AMBLER",
    "dropmalst": "PA",
    "dropmalzpp": 190029997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156465982,
    "dropsitcph": 2156465982,
    "dropfax": 2156464577
  },
  {
    "dcode": "D",
    "dropkey": "BX19692",
    "droptype": "D",
    "dropname": "MC KNIGHT",
    "dropdeladd": "4981 MCKNIGHT RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152379998,
    "dropphyadd": "4981 MCKNIGHT RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152379998,
    "dropmaladd": "4981 MCKNIGHT RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123647903,
    "dropsitcph": 4123647903,
    "dropfax": 4123640247
  },
  {
    "dcode": "D",
    "dropkey": "BX19694",
    "droptype": "D",
    "dropname": "MC MURRAY",
    "dropdeladd": "3935 WASHINGTON RD",
    "dropdelcty": "CANONSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 153172552,
    "dropphyadd": "3935 WASHINGTON RD",
    "dropphycty": "CANONSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 153172552,
    "dropmaladd": "3935 WASHINGTON RD",
    "dropmalcty": "CANONSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 153172552,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247455770,
    "dropsitcph": 7249423421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19735",
    "droptype": "D",
    "dropname": "MEADOWBROOK",
    "dropdeladd": "1525 VALLEY RD",
    "dropdelcty": "JENKINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190469996,
    "dropphyadd": "1525 VALLEY RD",
    "dropphycty": "JENKINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190469996,
    "dropmaladd": "1525 VALLEY RD",
    "dropmalcty": "JENKINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190469996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158870750,
    "dropsitcph": 2158870750,
    "dropfax": 2158870753
  },
  {
    "dcode": "D",
    "dropkey": "BX19851",
    "droptype": "D",
    "dropname": "MILLVALE",
    "dropdeladd": "205 LINCOLN AVE",
    "dropdelcty": "MILLVALE",
    "dropdelst": "PA",
    "dropdelzpp": 152099998,
    "dropphyadd": "205 LINCOLN AVE",
    "dropphycty": "MILLVALE",
    "dropphyst": "PA",
    "dropphyzpp": 152099998,
    "dropmaladd": "205 LINCOLN AVE",
    "dropmalcty": "MILLVALE",
    "dropmalst": "PA",
    "dropmalzpp": 152099998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128217859,
    "dropsitcph": 4128217859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19896",
    "droptype": "D",
    "dropname": "MONROEVILLE",
    "dropdeladd": "2630 MONROEVILLE BLVD",
    "dropdelcty": "MONROEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 151469998,
    "dropphyadd": "2630 MONROEVILLE BLVD",
    "dropphycty": "MONROEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 151469998,
    "dropmaladd": "2630 MONROEVILLE BLVD",
    "dropmalcty": "MONROEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 151469998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123732513,
    "dropsitcph": 4123732513,
    "dropfax": 4123727513
  },
  {
    "dcode": "D",
    "dropkey": "BX19899",
    "droptype": "D",
    "dropname": "MONT CLARE",
    "dropdeladd": "200 BRIDGE ST APT 2",
    "dropdelcty": "MONT CLARE",
    "dropdelst": "PA",
    "dropdelzpp": 194535008,
    "dropphyadd": "200 BRIDGE ST APT 2",
    "dropphycty": "MONT CLARE",
    "dropphyst": "PA",
    "dropphyzpp": 194535008,
    "dropmaladd": "200 BRIDGE ST APT 2",
    "dropmalcty": "MONT CLARE",
    "dropmalst": "PA",
    "dropmalzpp": 194535008,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109337628,
    "dropsitcph": 6109337628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19908",
    "droptype": "D",
    "dropname": "MONTOUR",
    "dropdeladd": "1936 PARK MANOR BLVD",
    "dropdelcty": "MONTOUR",
    "dropdelst": "PA",
    "dropdelzpp": 152441001,
    "dropphyadd": "1936 PARK MANOR BLVD",
    "dropphycty": "MONTOUR",
    "dropphyst": "PA",
    "dropphyzpp": 152441001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127879672,
    "dropsitcph": 4127879672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19961",
    "droptype": "D",
    "dropname": "MOUNT OLIVER",
    "dropdeladd": "140 BROWNSVILLE RD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152109998,
    "dropphyadd": "140 BROWNSVILLE RD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152109998,
    "dropmaladd": "140 BROWNSVILLE RD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152109998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123814915,
    "dropsitcph": 4123814915,
    "dropfax": 4123819884
  },
  {
    "dcode": "D",
    "dropkey": "BX19963",
    "droptype": "D",
    "dropname": "READING STATION",
    "dropdeladd": "3115 SAINT LAWRENCE AVE",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196069998,
    "dropphyadd": "3115 SAINT LAWRENCE AVE",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196069998,
    "dropmaladd": "3115 SAINT LAWRENCE AVE",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196069998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217055,
    "dropsitcph": 6107790318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19989",
    "droptype": "D",
    "dropname": "MOUNTAIN TOP",
    "dropdeladd": "42 S MOUNTAIN BLVD",
    "dropdelcty": "MOUNTAIN TOP",
    "dropdelst": "PA",
    "dropdelzpp": 187079998,
    "dropphyadd": "42 S MOUNTAIN BLVD",
    "dropphycty": "MOUNTAIN TOP",
    "dropphyst": "PA",
    "dropphyzpp": 187079998,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019990,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704746014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX19999",
    "droptype": "D",
    "dropname": "MOYLAN",
    "dropdeladd": "4 MANCHESTER RD",
    "dropdelcty": "MEDIA",
    "dropdelst": "PA",
    "dropdelzpp": 190639993,
    "dropphyadd": "4 MANCHESTER RD",
    "dropphycty": "MEDIA",
    "dropphyst": "PA",
    "dropphyzpp": 190639993,
    "dropmaladd": "4 MANCHESTER RD",
    "dropmalcty": "MEDIA",
    "dropmalst": "PA",
    "dropmalzpp": 190639993,
    "dropsitphn": 2158958561,
    "dropsitlph": 6105657559,
    "dropsitcph": 6105657559,
    "dropfax": 6105657040
  },
  {
    "dcode": "D",
    "dropkey": "BX2A464",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "3750 E BROAD ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432139997,
    "dropphyadd": "3750 E BROAD ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432139997,
    "dropmaladd": "3750 E BROAD ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432139997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142371410,
    "dropsitcph": 6142371410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX2A597",
    "droptype": "D",
    "dropname": "SULLY STATION",
    "dropdeladd": "5003 WESTFIELDS BLVD",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201209997,
    "dropphyadd": "5003 WESTFIELDS BLVD",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201209997,
    "dropmaladd": "5003 WESTFIELDS BLVD",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201209997,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033785502,
    "dropsitcph": 7033785502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX2A663",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "520 W BLACKSTOCK RD",
    "dropdelcty": "SPARTANBURG",
    "dropdelst": "SC",
    "dropdelzpp": 293019996,
    "dropphyadd": "520 W BLACKSTOCK RD",
    "dropphycty": "SPARTANBURG",
    "dropphyst": "SC",
    "dropphyzpp": 293019996,
    "dropmaladd": "520 W BLACKSTOCK RD",
    "dropmalcty": "SPARTANBURG",
    "dropmalst": "SC",
    "dropmalzpp": 293019996,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645951217,
    "dropfax": 8645956052
  },
  {
    "dcode": "D",
    "dropkey": "BX2A664",
    "droptype": "D",
    "dropname": "BOILING SPRINGS",
    "dropdeladd": "1943 BOILING SPRINGS RD",
    "dropdelcty": "BOILING SPRINGS",
    "dropdelst": "SC",
    "dropdelzpp": 293169995,
    "dropphyadd": "1943 BOILING SPRINGS RD",
    "dropphycty": "BOILING SPRINGS",
    "dropphyst": "SC",
    "dropphyzpp": 293169995,
    "dropmaladd": "1943 BOILING SPRINGS RD",
    "dropmalcty": "BOILING SPRINGS",
    "dropmalst": "SC",
    "dropmalzpp": 293169995,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645784256,
    "dropfax": 8645787306
  },
  {
    "dcode": "D",
    "dropkey": "BX2A665",
    "droptype": "D",
    "dropname": "CAROLINA FOREST",
    "dropdeladd": "4025 POSTAL WAY",
    "dropdelcty": "MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295799998,
    "dropphyadd": "4025 POSTAL WAY",
    "dropphycty": "MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295799998,
    "dropmaladd": "4025 POSTAL WAY",
    "dropmalcty": "MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295799998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432360657,
    "dropsitcph": 8432360657,
    "dropfax": 8432360613
  },
  {
    "dcode": "D",
    "dropkey": "BX2A674",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "13520 MCLEAREN RD",
    "dropdelcty": "HERNDON",
    "dropdelst": "VA",
    "dropdelzpp": 201719998,
    "dropphyadd": "13520 MCLEAREN RD",
    "dropphycty": "HERNDON",
    "dropphyst": "VA",
    "dropphyzpp": 201719998,
    "dropmaladd": "13520 MCLEAREN RD",
    "dropmalcty": "HERNDON",
    "dropmalst": "VA",
    "dropmalzpp": 201719998,
    "dropsitphn": 7034376525,
    "dropsitlph": 7034648360,
    "dropsitcph": 7034648360,
    "dropfax": 7034378085
  },
  {
    "dcode": "D",
    "dropkey": "BX2A675",
    "droptype": "D",
    "dropname": "KINGSTOWNE",
    "dropdeladd": "5900 BARCLAY DR",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223159998,
    "dropphyadd": "5900 BARCLAY DR",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223159998,
    "dropmaladd": "5900 BARCLAY DR",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223159998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039713093,
    "dropsitcph": 7039713093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX2A708",
    "droptype": "D",
    "dropname": "PRINCE WILLIAM",
    "dropdeladd": "3360 POST OFFICE RD",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 221939996,
    "dropphyadd": "3360 POST OFFICE RD",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 221939996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 221959998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038782715,
    "dropsitcph": 7038782715,
    "dropfax": 7037308748
  },
  {
    "dcode": "D",
    "dropkey": "BX2A710",
    "droptype": "D",
    "dropname": "POTOMAC FALLS",
    "dropdeladd": "46164 WESTLAKE DR",
    "dropdelcty": "STERLING",
    "dropdelst": "VA",
    "dropdelzpp": 201659998,
    "dropphyadd": "46164 WESTLAKE DR",
    "dropphycty": "STERLING",
    "dropphyst": "VA",
    "dropphyzpp": 201659998,
    "dropmaladd": "46164 WESTLAKE DR",
    "dropmalcty": "STERLING",
    "dropmalst": "VA",
    "dropmalzpp": 201659998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034332725,
    "dropsitcph": 7034332725,
    "dropfax": 7034331794
  },
  {
    "dcode": "D",
    "dropkey": "BX20030",
    "droptype": "D",
    "dropname": "CINCINNATI AIRPORT RETAIL",
    "dropdeladd": "76 CLAY DR",
    "dropdelcty": "HEBRON",
    "dropdelst": "KY",
    "dropdelzpp": 410489900,
    "dropphyadd": "76 CLAY DR",
    "dropphycty": "HEBRON",
    "dropphyst": "KY",
    "dropphyzpp": 410489900,
    "dropmaladd": "76 CLAY DR",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452759900,
    "dropsitphn": 5136845763,
    "dropsitlph": 8593714813,
    "dropsitcph": 8593714813,
    "dropfax": 8595252241
  },
  {
    "dcode": "D",
    "dropkey": "BX20077",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "1320 NAGEL RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452559998,
    "dropphyadd": "1320 NAGEL RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452559998,
    "dropmaladd": "1320 NAGEL RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5134743262,
    "dropsitcph": 5134743262,
    "dropfax": 5134740848
  },
  {
    "dcode": "D",
    "dropkey": "BX20126",
    "droptype": "D",
    "dropname": "AUSTINTOWN",
    "dropdeladd": "6000 MAHONING AVE STE 120",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445159998,
    "dropphyadd": "6000 MAHONING AVE STE 120",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445159998,
    "dropmaladd": "6000 MAHONING AVE STE 120",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307995061,
    "dropsitcph": 3307995061,
    "dropfax": 2347190235
  },
  {
    "dcode": "D",
    "dropkey": "BX20166",
    "droptype": "D",
    "dropname": "BAY VILLAGE",
    "dropdeladd": "27106 E OVIATT RD",
    "dropdelcty": "BAY VILLAGE",
    "dropdelst": "OH",
    "dropdelzpp": 441409998,
    "dropphyadd": "27106 E OVIATT RD",
    "dropphycty": "BAY VILLAGE",
    "dropphyst": "OH",
    "dropphyzpp": 441409998,
    "dropmaladd": "27106 E OVIATT RD",
    "dropmalcty": "BAY VILLAGE",
    "dropmalst": "OH",
    "dropmalzpp": 441409998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402509545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20172",
    "droptype": "D",
    "dropname": "BEACHWOOD",
    "dropdeladd": "3695 GREEN RD",
    "dropdelcty": "BEACHWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 441229998,
    "dropphyadd": "3695 GREEN RD",
    "dropphycty": "BEACHWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 441229998,
    "dropmaladd": "3695 GREEN RD",
    "dropmalcty": "BEACHWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 441229998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2163600257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20179",
    "droptype": "D",
    "dropname": "BEAVERCREEK",
    "dropdeladd": "3541 DAYTON XENIA RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454329998,
    "dropphyadd": "3541 DAYTON XENIA RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454329998,
    "dropmaladd": "3541 DAYTON XENIA RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373205142,
    "dropsitcph": 9373205142,
    "dropfax": 9374267790
  },
  {
    "dcode": "D",
    "dropkey": "BX20184",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "89 WILLIS ST",
    "dropdelcty": "BEDFORD",
    "dropdelst": "OH",
    "dropdelzpp": 441469998,
    "dropphyadd": "89 WILLIS ST",
    "dropphycty": "BEDFORD",
    "dropphyst": "OH",
    "dropphyzpp": 441469998,
    "dropmaladd": "89 WILLIS ST",
    "dropmalcty": "BEDFORD",
    "dropmalst": "OH",
    "dropmalzpp": 441469998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407359712,
    "dropfax": 4407860913
  },
  {
    "dcode": "D",
    "dropkey": "BX20243",
    "droptype": "D",
    "dropname": "BEXLEY",
    "dropdeladd": "2935 E MAIN ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432099998,
    "dropphyadd": "2935 E MAIN ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432099998,
    "dropmaladd": "2935 E MAIN ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432099998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720674,
    "dropsitcph": 6142372830,
    "dropfax": 6142389035
  },
  {
    "dcode": "D",
    "dropkey": "BX20282",
    "droptype": "D",
    "dropname": "BOARDMAN",
    "dropdeladd": "407 BOARDMAN CANFIELD RD",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445129998,
    "dropphyadd": "407 BOARDMAN CANFIELD RD",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445129998,
    "dropmaladd": "407 BOARDMAN CANFIELD RD",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307581213,
    "dropsitcph": 3307581213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20325",
    "droptype": "D",
    "dropname": "BRIGGS",
    "dropdeladd": "5611 STATE RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441342262,
    "dropphyadd": "5611 STATE RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441342262,
    "dropmaladd": "5611 STATE RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441342262,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408439055,
    "dropfax": 4408426171
  },
  {
    "dcode": "D",
    "dropkey": "BX20334",
    "droptype": "D",
    "dropname": "BROADVIEW HEIGHTS",
    "dropdeladd": "2525 E ROYALTON RD STE 8",
    "dropdelcty": "BROADVIEW HEIGHTS",
    "dropdelst": "OH",
    "dropdelzpp": 441472841,
    "dropphyadd": "2525 E ROYALTON RD STE 8",
    "dropphycty": "BROADVIEW HEIGHTS",
    "dropphyst": "OH",
    "dropphyzpp": 441472841,
    "dropmaladd": "2525 E ROYALTON RD STE 8",
    "dropmalcty": "BROADVIEW HEIGHTS",
    "dropmalst": "OH",
    "dropmalzpp": 441472841,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408380429,
    "dropfax": 4407925183
  },
  {
    "dcode": "D",
    "dropkey": "BX20342",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "6200 BIDDULPH RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441449998,
    "dropphyadd": "6200 BIDDULPH RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441449998,
    "dropmaladd": "6200 BIDDULPH RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441449998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2163982866,
    "dropfax": 2163512932
  },
  {
    "dcode": "D",
    "dropkey": "BX20421",
    "droptype": "D",
    "dropname": "CALCUTTA",
    "dropdeladd": "15713 STATE ROUTE 170",
    "dropdelcty": "EAST LIVERPOOL",
    "dropdelst": "OH",
    "dropdelzpp": 439209633,
    "dropphyadd": "15713 STATE ROUTE 170",
    "dropphycty": "EAST LIVERPOOL",
    "dropphyst": "OH",
    "dropphyzpp": 439209633,
    "dropmaladd": "15713 STATE ROUTE 170",
    "dropmalcty": "EAST LIVERPOOL",
    "dropmalst": "OH",
    "dropmalzpp": 439209633,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303853100,
    "dropsitcph": 3303858600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20488",
    "droptype": "D",
    "dropname": "WASHINGTON TOWNSHIP",
    "dropdeladd": "7525 PARAGON RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454599998,
    "dropphyadd": "7525 PARAGON RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454599998,
    "dropmaladd": "7525 PARAGON RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454599998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372911624,
    "dropsitcph": 9372911624,
    "dropfax": 9372914501
  },
  {
    "dcode": "D",
    "dropkey": "BX20579",
    "droptype": "D",
    "dropname": "AMC FINANCE UNIT",
    "dropdeladd": "5801 POSTAL RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441819600,
    "dropphyadd": "5801 POSTAL RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441819600,
    "dropmaladd": "5801 POSTAL RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441819600,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164334023,
    "dropfax": 2164334020
  },
  {
    "dcode": "D",
    "dropkey": "BX20582",
    "droptype": "D",
    "dropname": "CLEVELAND HEIGHTS",
    "dropdeladd": "3 SEVERANCE CIR",
    "dropdelcty": "CLEVELAND HEIGHTS",
    "dropdelst": "OH",
    "dropdelzpp": 441189998,
    "dropphyadd": "3 SEVERANCE CIR",
    "dropphycty": "CLEVELAND HEIGHTS",
    "dropphyst": "OH",
    "dropphyzpp": 441189998,
    "dropmaladd": "3 SEVERANCE CIR",
    "dropmalcty": "CLEVELAND HEIGHTS",
    "dropmalst": "OH",
    "dropmalzpp": 441189998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162910207,
    "dropfax": 4407306352
  },
  {
    "dcode": "D",
    "dropkey": "BX20625",
    "droptype": "D",
    "dropname": "COLLEGE HL",
    "dropdeladd": "1531 CEDAR AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452249998,
    "dropphyadd": "1531 CEDAR AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452249998,
    "dropmaladd": "1531 CEDAR AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452249998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135411593,
    "dropsitcph": 5135411593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20692",
    "droptype": "D",
    "dropname": "COPLEY",
    "dropdeladd": "3840 RIDGEWOOD RD",
    "dropdelcty": "COPLEY",
    "dropdelst": "OH",
    "dropdelzpp": 443219998,
    "dropphyadd": "3840 RIDGEWOOD RD",
    "dropphycty": "COPLEY",
    "dropphyst": "OH",
    "dropphyzpp": 443219998,
    "dropmaladd": "3840 RIDGEWOOD RD",
    "dropmalcty": "COPLEY",
    "dropmalst": "OH",
    "dropmalzpp": 443219998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306668540,
    "dropfax": 3306663710
  },
  {
    "dcode": "D",
    "dropkey": "BX20729",
    "droptype": "D",
    "dropname": "CRIDERSVILLE",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "CRIDERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 458069998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "CRIDERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 458069998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "CRIDERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 458069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196456224,
    "dropsitcph": 4196456224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20871",
    "droptype": "D",
    "dropname": "EAST CANTON",
    "dropdeladd": "117 NASSAU ST W",
    "dropdelcty": "EAST CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447309998,
    "dropphyadd": "117 NASSAU ST W",
    "dropphycty": "EAST CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447309998,
    "dropmaladd": "117 NASSAU ST W",
    "dropmalcty": "EAST CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304882100,
    "dropfax": 3304882100
  },
  {
    "dcode": "D",
    "dropkey": "BX20874",
    "droptype": "D",
    "dropname": "EAST CLEVELAND",
    "dropdeladd": "1700 SHAW AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441129998,
    "dropphyadd": "1700 SHAW AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441129998,
    "dropmaladd": "1700 SHAW AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441129998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164512026,
    "dropfax": 2165416500
  },
  {
    "dcode": "D",
    "dropkey": "BX20926",
    "droptype": "D",
    "dropname": "ELIDA",
    "dropdeladd": "304 E MAIN ST",
    "dropdelcty": "ELIDA",
    "dropdelst": "OH",
    "dropdelzpp": 458079998,
    "dropphyadd": "304 E MAIN ST",
    "dropphycty": "ELIDA",
    "dropphyst": "OH",
    "dropphyzpp": 458079998,
    "dropmaladd": "304 E MAIN ST",
    "dropmalcty": "ELIDA",
    "dropmalst": "OH",
    "dropmalzpp": 458079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193391330,
    "dropsitcph": 4193391330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX20954",
    "droptype": "D",
    "dropname": "EUCLID",
    "dropdeladd": "21551 EUCLID AVE",
    "dropdelcty": "EUCLID",
    "dropdelst": "OH",
    "dropdelzpp": 441179998,
    "dropphyadd": "21551 EUCLID AVE",
    "dropphycty": "EUCLID",
    "dropphyst": "OH",
    "dropphyzpp": 441179998,
    "dropmaladd": "21551 EUCLID AVE",
    "dropmalcty": "EUCLID",
    "dropmalst": "OH",
    "dropmalzpp": 441179998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164813790,
    "dropfax": 4407306471
  },
  {
    "dcode": "D",
    "dropkey": "BX20970",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "700 WESSEL DR",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 450149998,
    "dropphyadd": "700 WESSEL DR",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 450149998,
    "dropmaladd": "700 WESSEL DR",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 450149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5138581693,
    "dropfax": 5138583653
  },
  {
    "dcode": "D",
    "dropkey": "BX20974",
    "droptype": "D",
    "dropname": "FAIRLAWN",
    "dropdeladd": "2711 W MARKET ST",
    "dropdelcty": "FAIRLAWN",
    "dropdelst": "OH",
    "dropdelzpp": 443339998,
    "dropphyadd": "2711 W MARKET ST",
    "dropphycty": "FAIRLAWN",
    "dropphyst": "OH",
    "dropphyzpp": 443339998,
    "dropmaladd": "2711 W MARKET ST",
    "dropmalcty": "FAIRLAWN",
    "dropmalst": "OH",
    "dropmalzpp": 443339998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308646409,
    "dropfax": 2345422167
  },
  {
    "dcode": "D",
    "dropkey": "BX20979",
    "droptype": "D",
    "dropname": "FAIRPORT HARBOR",
    "dropdeladd": "705 HIGH ST",
    "dropdelcty": "FAIRPORT HARBOR",
    "dropdelst": "OH",
    "dropdelzpp": 440775514,
    "dropphyadd": "705 HIGH ST",
    "dropphycty": "FAIRPORT HARBOR",
    "dropphyst": "OH",
    "dropphyzpp": 440775514,
    "dropmaladd": "705 HIGH ST",
    "dropmalcty": "FAIRPORT HARBOR",
    "dropmalst": "OH",
    "dropmalzpp": 440775514,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403576101,
    "dropfax": 4403571426
  },
  {
    "dcode": "D",
    "dropkey": "BX20994",
    "droptype": "D",
    "dropname": "FARMERSVILLE",
    "dropdeladd": "12 W CENTER ST",
    "dropdelcty": "FARMERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453251006,
    "dropphyadd": "12 W CENTER ST",
    "dropphycty": "FARMERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453251006,
    "dropmaladd": "12 W CENTER ST",
    "dropmalcty": "FARMERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453251006,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378552888,
    "dropsitcph": 9378552888,
    "dropfax": 9378556498
  },
  {
    "dcode": "D",
    "dropkey": "BX21094",
    "droptype": "D",
    "dropname": "GAHANNA1",
    "dropdeladd": "106 MILL ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432309913,
    "dropphyadd": "106 MILL ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432309913,
    "dropmaladd": "106 MILL ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432309913,
    "dropsitphn": 6144720696,
    "dropsitlph": 6144720696,
    "dropsitcph": 6144720796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21105",
    "droptype": "D",
    "dropname": "GARFIELD HEIGHTS",
    "dropdeladd": "12401 ROCKSIDE RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441259998,
    "dropphyadd": "12401 ROCKSIDE RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441259998,
    "dropmaladd": "12401 ROCKSIDE RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441259998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2166631447,
    "dropfax": 2165189308
  },
  {
    "dcode": "D",
    "dropkey": "BX21213",
    "droptype": "D",
    "dropname": "GROESBECK",
    "dropdeladd": "8721 COLERAIN AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452519998,
    "dropphyadd": "8721 COLERAIN AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452519998,
    "dropmaladd": "8721 COLERAIN AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452519998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137418396,
    "dropsitcph": 5137418396,
    "dropfax": 5137410152
  },
  {
    "dcode": "D",
    "dropkey": "BX21288",
    "droptype": "D",
    "dropname": "HEATH",
    "dropdeladd": "789 HEBRON RD REAR",
    "dropdelcty": "HEATH",
    "dropdelst": "OH",
    "dropdelzpp": 430569997,
    "dropphyadd": "789 HEBRON RD REAR",
    "dropphycty": "HEATH",
    "dropphyst": "OH",
    "dropphyzpp": 430569997,
    "dropmaladd": "789 HEBRON RD REAR",
    "dropmalcty": "HEATH",
    "dropmalst": "OH",
    "dropmalzpp": 430569997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405224595,
    "dropsitcph": 7405224595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21360",
    "droptype": "D",
    "dropname": "HUBER HEIGHTS",
    "dropdeladd": "5425 FISHBURG RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454249998,
    "dropphyadd": "5425 FISHBURG RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454249998,
    "dropmaladd": "5425 FISHBURG RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454249998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372359664,
    "dropsitcph": 9372359664,
    "dropfax": 9372363060
  },
  {
    "dcode": "D",
    "dropkey": "BX21382",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "6509 BRECKSVILLE RD",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "OH",
    "dropdelzpp": 441314854,
    "dropphyadd": "6509 BRECKSVILLE RD",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "OH",
    "dropphyzpp": 441314854,
    "dropmaladd": "6509 BRECKSVILLE RD",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "OH",
    "dropmalzpp": 441314854,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2165249614,
    "dropfax": 2164460772
  },
  {
    "dcode": "D",
    "dropkey": "BX21412",
    "droptype": "D",
    "dropname": "JACKSON BELDEN",
    "dropdeladd": "4420 DRESSLER RD NW",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447189998,
    "dropphyadd": "4420 DRESSLER RD NW",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447189998,
    "dropmaladd": "4420 DRESSLER RD NW",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447189998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304921588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21484",
    "droptype": "D",
    "dropname": "KETTERING",
    "dropdeladd": "1740 E STROOP RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454299998,
    "dropphyadd": "1740 E STROOP RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454299998,
    "dropmaladd": "1740 E STROOP RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454299998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372993270,
    "dropsitcph": 9372993270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21555",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "1475 WARREN RD",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 441079998,
    "dropphyadd": "1475 WARREN RD",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 441079998,
    "dropmaladd": "1475 WARREN RD",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 441079998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162261415,
    "dropfax": 2162260710
  },
  {
    "dcode": "D",
    "dropkey": "BX21604",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "24 SHORT ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 449049998,
    "dropphyadd": "24 SHORT ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 449049998,
    "dropmaladd": "24 SHORT ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 449049998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198841320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21627",
    "droptype": "D",
    "dropname": "LINCOLN VILLAGE",
    "dropdeladd": "4150 SHOPPERS LN",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432289993,
    "dropphyadd": "4150 SHOPPERS LN",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432289993,
    "dropmaladd": "4150 SHOPPERS LN",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432289993,
    "dropsitphn": 6144720674,
    "dropsitlph": 6143511770,
    "dropsitcph": 6143511770,
    "dropfax": 6142798910
  },
  {
    "dcode": "D",
    "dropkey": "BX21656",
    "droptype": "D",
    "dropname": "LOCKLAND",
    "dropdeladd": "117 ANNA ST",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452159998,
    "dropphyadd": "117 ANNA ST",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452159998,
    "dropmaladd": "117 ANNA ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452159998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138215378,
    "dropsitcph": 5138215378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX21700",
    "droptype": "D",
    "dropname": "LYNDHURST MAYFIELD",
    "dropdeladd": "5815 LANDERBROOK DR",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441249998,
    "dropphyadd": "5815 LANDERBROOK DR",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441249998,
    "dropmaladd": "5815 LANDERBROOK DR",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441249998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404613815,
    "dropfax": 4404423065
  },
  {
    "dcode": "D",
    "dropkey": "BX21711",
    "droptype": "D",
    "dropname": "MADEIRA",
    "dropdeladd": "7737 LAUREL AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452439998,
    "dropphyadd": "7737 LAUREL AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452439998,
    "dropmaladd": "7737 LAUREL AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452439998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5135614172,
    "dropfax": 5615619545
  },
  {
    "dcode": "D",
    "dropkey": "BX21887",
    "droptype": "D",
    "dropname": "MIDPARK",
    "dropdeladd": "13301 SMITH RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441309998,
    "dropphyadd": "13301 SMITH RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441309998,
    "dropmaladd": "13301 SMITH RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441309998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408438816,
    "dropfax": 4402533101
  },
  {
    "dcode": "D",
    "dropkey": "BX21983",
    "droptype": "D",
    "dropname": "MOUNT HEALTHY",
    "dropdeladd": "7504 PERRY ST",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452319998,
    "dropphyadd": "7504 PERRY ST",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452319998,
    "dropmaladd": "7504 PERRY ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135216061,
    "dropsitcph": 5135216061,
    "dropfax": 5135212200
  },
  {
    "dcode": "D",
    "dropkey": "BX22058",
    "droptype": "D",
    "dropname": "NE WATERWORKS",
    "dropdeladd": "1930 SPANGLER RD NE",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447059998,
    "dropphyadd": "1930 SPANGLER RD NE",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447059998,
    "dropmaladd": "1930 SPANGLER RD NE",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447059998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304386461,
    "dropfax": 3304531449
  },
  {
    "dcode": "D",
    "dropkey": "BX22171",
    "droptype": "D",
    "dropname": "NOBLE",
    "dropdeladd": "25101 N LAKELAND BLVD",
    "dropdelcty": "EUCLID",
    "dropdelst": "OH",
    "dropdelzpp": 441329998,
    "dropphyadd": "25101 N LAKELAND BLVD",
    "dropphycty": "EUCLID",
    "dropphyst": "OH",
    "dropphyzpp": 441329998,
    "dropmaladd": "25101 N LAKELAND BLVD",
    "dropmalcty": "EUCLID",
    "dropmalst": "OH",
    "dropmalzpp": 441329998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162892213,
    "dropfax": 2162890870
  },
  {
    "dcode": "D",
    "dropkey": "BX22191",
    "droptype": "D",
    "dropname": "NORTH INDUSTRY",
    "dropdeladd": "4724 CLEVELAND AVE S",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447079998,
    "dropphyadd": "4724 CLEVELAND AVE S",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447079998,
    "dropmaladd": "4724 CLEVELAND AVE S",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447079998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304845200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX22204",
    "droptype": "D",
    "dropname": "NORTH RIDGEVILLE",
    "dropdeladd": "34760 CENTER RIDGE RD",
    "dropdelcty": "NORTH RIDGEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440393184,
    "dropphyadd": "34760 CENTER RIDGE RD",
    "dropphycty": "NORTH RIDGEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440393184,
    "dropmaladd": "34760 CENTER RIDGE RD",
    "dropmalcty": "NORTH RIDGEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440393184,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403278806,
    "dropfax": 4404065362
  },
  {
    "dcode": "D",
    "dropkey": "BX22206",
    "droptype": "D",
    "dropname": "NORTH ROYALTON",
    "dropdeladd": "13901 STATE RD",
    "dropdelcty": "NORTH ROYALTON",
    "dropdelst": "OH",
    "dropdelzpp": 441339998,
    "dropphyadd": "13901 STATE RD",
    "dropphycty": "NORTH ROYALTON",
    "dropphyst": "OH",
    "dropphyzpp": 441339998,
    "dropmaladd": "13901 STATE RD",
    "dropmalcty": "NORTH ROYALTON",
    "dropmalst": "OH",
    "dropmalzpp": 441339998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405828418,
    "dropfax": 4406283080
  },
  {
    "dcode": "D",
    "dropkey": "BX22227",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "3200 GREENWICH RD RM 75",
    "dropdelcty": "NORTON",
    "dropdelst": "OH",
    "dropdelzpp": 442039903,
    "dropphyadd": "3200 GREENWICH RD RM 75",
    "dropphycty": "NORTON",
    "dropphyst": "OH",
    "dropphyzpp": 442039903,
    "dropmaladd": "3200 GREENWICH RD RM 75",
    "dropmalcty": "NORTON",
    "dropmalst": "OH",
    "dropmalzpp": 442039903,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308258768,
    "dropfax": 3308250302
  },
  {
    "dcode": "D",
    "dropkey": "BX22231",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "4515 ALLISON ST",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452129998,
    "dropphyadd": "4515 ALLISON ST",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452129998,
    "dropmaladd": "4515 ALLISON ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137315613,
    "dropsitcph": 5137315613,
    "dropfax": 5137310522
  },
  {
    "dcode": "D",
    "dropkey": "BX22297",
    "droptype": "D",
    "dropname": "OLMSTED FALLS",
    "dropdeladd": "8000 BROOKSIDE DR",
    "dropdelcty": "OLMSTED FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 441389998,
    "dropphyadd": "8000 BROOKSIDE DR",
    "dropphycty": "OLMSTED FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 441389998,
    "dropmaladd": "8000 BROOKSIDE DR",
    "dropmalcty": "OLMSTED FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 441389998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402351838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX22313",
    "droptype": "D",
    "dropname": "OREGON",
    "dropdeladd": "3054 DUSTIN RD",
    "dropdelcty": "OREGON",
    "dropdelst": "OH",
    "dropdelzpp": 436169998,
    "dropphyadd": "3054 DUSTIN RD",
    "dropphycty": "OREGON",
    "dropphyst": "OH",
    "dropphyzpp": 436169998,
    "dropmaladd": "3054 DUSTIN RD",
    "dropmalcty": "OREGON",
    "dropmalst": "OH",
    "dropmalzpp": 436169998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196935033,
    "dropsitcph": 4196935033,
    "dropfax": 5672907956
  },
  {
    "dcode": "D",
    "dropkey": "BX22364",
    "droptype": "D",
    "dropname": "PARKDALE",
    "dropdeladd": "670 NORTHLAND BLVD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452409998,
    "dropphyadd": "670 NORTHLAND BLVD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452409998,
    "dropmaladd": "670 NORTHLAND BLVD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138256475,
    "dropsitcph": 5138256475,
    "dropfax": 5138258719
  },
  {
    "dcode": "D",
    "dropkey": "BX22367",
    "droptype": "D",
    "dropname": "PARMA",
    "dropdeladd": "7801 DAY DR",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441299998,
    "dropphyadd": "7801 DAY DR",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441299998,
    "dropmaladd": "7801 DAY DR",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441299998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408438839,
    "dropfax": 4403453749
  },
  {
    "dcode": "D",
    "dropkey": "BX22484",
    "droptype": "D",
    "dropname": "POLAND",
    "dropdeladd": "125 W MCKINLEY WAY",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445149998,
    "dropphyadd": "125 W MCKINLEY WAY",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445149998,
    "dropmaladd": "125 W MCKINLEY WAY",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445149998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307578616,
    "dropsitcph": 3307578616,
    "dropfax": 3307570528
  },
  {
    "dcode": "D",
    "dropkey": "BX22603",
    "droptype": "D",
    "dropname": "RICHMOND HEIGHTS",
    "dropdeladd": "454 RICHMOND RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441439998,
    "dropphyadd": "454 RICHMOND RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441439998,
    "dropmaladd": "454 RICHMOND RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441439998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164814461,
    "dropfax": 2164818640
  },
  {
    "dcode": "D",
    "dropkey": "BX22655",
    "droptype": "D",
    "dropname": "ROCKY RIVER",
    "dropdeladd": "19525 HILLIARD BLVD",
    "dropdelcty": "ROCKY RIVER",
    "dropdelst": "OH",
    "dropdelzpp": 441169998,
    "dropphyadd": "19525 HILLIARD BLVD",
    "dropphycty": "ROCKY RIVER",
    "dropphyst": "OH",
    "dropphyzpp": 441169998,
    "dropmaladd": "19525 HILLIARD BLVD",
    "dropmalcty": "ROCKY RIVER",
    "dropmalst": "OH",
    "dropmalzpp": 441169998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403562465,
    "dropfax": 4403561138
  },
  {
    "dcode": "D",
    "dropkey": "BX22669",
    "droptype": "D",
    "dropname": "ROSELAWN",
    "dropdeladd": "1730 SECTION RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452229998,
    "dropphyadd": "1730 SECTION RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452229998,
    "dropmaladd": "1730 SECTION RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5136316363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX22674",
    "droptype": "D",
    "dropname": "ROSSFORD",
    "dropdeladd": "313 GLENWOOD RD",
    "dropdelcty": "ROSSFORD",
    "dropdelst": "OH",
    "dropdelzpp": 434609998,
    "dropphyadd": "313 GLENWOOD RD",
    "dropphycty": "ROSSFORD",
    "dropphyst": "OH",
    "dropphyzpp": 434609998,
    "dropmaladd": "313 GLENWOOD RD",
    "dropmalcty": "ROSSFORD",
    "dropmalst": "OH",
    "dropmalzpp": 434609998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196663124,
    "dropsitcph": 4196663124,
    "dropfax": 4197265093
  },
  {
    "dcode": "D",
    "dropkey": "BX22676",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "865 FRANKLIN ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "OH",
    "dropdelzpp": 450139998,
    "dropphyadd": "865 FRANKLIN ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "OH",
    "dropphyzpp": 450139998,
    "dropmaladd": "865 FRANKLIN ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "OH",
    "dropmalzpp": 450139998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5137371430,
    "dropfax": 5138945728
  },
  {
    "dcode": "D",
    "dropkey": "BX22711",
    "droptype": "D",
    "dropname": "SAINT BERNARD",
    "dropdeladd": "5115 VINE ST",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452179998,
    "dropphyadd": "5115 VINE ST",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452179998,
    "dropmaladd": "5115 VINE ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132424269,
    "dropsitcph": 5132424269,
    "dropfax": 5132421254
  },
  {
    "dcode": "D",
    "dropkey": "BX22746",
    "droptype": "D",
    "dropname": "SAYLER PARK",
    "dropdeladd": "6605 GRACELY DR FRNT",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452331185,
    "dropphyadd": "6605 GRACELY DR FRNT",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452331185,
    "dropmaladd": "6605 GRACELY DR FRNT",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452331185,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5139412137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX22787",
    "droptype": "D",
    "dropname": "SHARONVILLE",
    "dropdeladd": "11069 READING RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452419998,
    "dropphyadd": "11069 READING RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452419998,
    "dropmaladd": "11069 READING RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452419998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135630760,
    "dropsitcph": 5135630760,
    "dropfax": 5137695662
  },
  {
    "dcode": "D",
    "dropkey": "BX22847",
    "droptype": "D",
    "dropname": "SOUTH EUCLID",
    "dropdeladd": "1568 S GREEN RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441214048,
    "dropphyadd": "1568 S GREEN RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441214048,
    "dropmaladd": "1568 S GREEN RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441214048,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2163813792,
    "dropfax": 2163813876
  },
  {
    "dcode": "D",
    "dropkey": "BX23004",
    "droptype": "D",
    "dropname": "STOW",
    "dropdeladd": "3900 DARROW RD",
    "dropdelcty": "STOW",
    "dropdelst": "OH",
    "dropdelzpp": 442249998,
    "dropphyadd": "3900 DARROW RD",
    "dropphycty": "STOW",
    "dropphyst": "OH",
    "dropphyzpp": 442249998,
    "dropmaladd": "3900 DARROW RD",
    "dropmalcty": "STOW",
    "dropmalst": "OH",
    "dropmalzpp": 442249998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306889288,
    "dropfax": 2346784486
  },
  {
    "dcode": "D",
    "dropkey": "BX23011",
    "droptype": "D",
    "dropname": "STREETSBORO",
    "dropdeladd": "1639 STREETSBORO PLZ",
    "dropdelcty": "STREETSBORO",
    "dropdelst": "OH",
    "dropdelzpp": 442419998,
    "dropphyadd": "1639 STREETSBORO PLZ",
    "dropphycty": "STREETSBORO",
    "dropphyst": "OH",
    "dropphyzpp": 442419998,
    "dropmaladd": "1639 STREETSBORO PLZ",
    "dropmalcty": "STREETSBORO",
    "dropmalst": "OH",
    "dropmalzpp": 442419998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306264317,
    "dropfax": 3306261069
  },
  {
    "dcode": "D",
    "dropkey": "BX23015",
    "droptype": "D",
    "dropname": "STRONGSVILLE",
    "dropdeladd": "15500 PEARL RD",
    "dropdelcty": "STRONGSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 441369998,
    "dropphyadd": "15500 PEARL RD",
    "dropphycty": "STRONGSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 441369998,
    "dropmaladd": "15500 PEARL RD",
    "dropmalcty": "STRONGSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 441369998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405721637,
    "dropfax": 4405722837
  },
  {
    "dcode": "D",
    "dropkey": "BX23050",
    "droptype": "D",
    "dropname": "TAFT",
    "dropdeladd": "7350 MONTGOMERY RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452369998,
    "dropphyadd": "7350 MONTGOMERY RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452369998,
    "dropmaladd": "7350 MONTGOMERY RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138916347,
    "dropsitcph": 5138916347,
    "dropfax": 5139850269
  },
  {
    "dcode": "D",
    "dropkey": "BX23108",
    "droptype": "D",
    "dropname": "TROTWOOD",
    "dropdeladd": "34 BEARDSLEY RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454269998,
    "dropphyadd": "34 BEARDSLEY RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454269998,
    "dropmaladd": "34 BEARDSLEY RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454269998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378370647,
    "dropsitcph": 9378370647,
    "dropfax": 9378374682
  },
  {
    "dcode": "D",
    "dropkey": "BX23156",
    "droptype": "D",
    "dropname": "UPPER ARLINGTON",
    "dropdeladd": "3700 RIVERSIDE DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432219998,
    "dropphyadd": "3700 RIVERSIDE DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432219998,
    "dropmaladd": "3700 RIVERSIDE DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432219998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144512302,
    "dropsitcph": 6144512302,
    "dropfax": 6144516192
  },
  {
    "dcode": "D",
    "dropkey": "BX23307",
    "droptype": "D",
    "dropname": "WEST CARROLLTON",
    "dropdeladd": "901 E CENTRAL AVE",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454499998,
    "dropphyadd": "901 E CENTRAL AVE",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454499998,
    "dropmaladd": "901 E CENTRAL AVE",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378595163,
    "dropsitcph": 9378595163,
    "dropfax": 9378593926
  },
  {
    "dcode": "D",
    "dropkey": "BX23351",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "27300 CENTER RIDGE RD",
    "dropdelcty": "WESTLAKE",
    "dropdelst": "OH",
    "dropdelzpp": 441459998,
    "dropphyadd": "27300 CENTER RIDGE RD",
    "dropphycty": "WESTLAKE",
    "dropphyst": "OH",
    "dropphyzpp": 441459998,
    "dropmaladd": "27300 CENTER RIDGE RD",
    "dropmalcty": "WESTLAKE",
    "dropmalst": "OH",
    "dropmalzpp": 441459998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402509529,
    "dropfax": 4408359314
  },
  {
    "dcode": "D",
    "dropkey": "BX23358",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "3336 HARRISON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452119998,
    "dropphyadd": "3336 HARRISON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452119998,
    "dropmaladd": "3336 HARRISON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136617652,
    "dropsitcph": 5136617652,
    "dropfax": 5136617142
  },
  {
    "dcode": "D",
    "dropkey": "BX23397",
    "droptype": "D",
    "dropname": "WILLOWICK",
    "dropdeladd": "260 E 312TH ST",
    "dropdelcty": "WILLOWICK",
    "dropdelst": "OH",
    "dropdelzpp": 440959998,
    "dropphyadd": "260 E 312TH ST",
    "dropphycty": "WILLOWICK",
    "dropphyst": "OH",
    "dropphyzpp": 440959998,
    "dropmaladd": "260 E 312TH ST",
    "dropmalcty": "WILLOWICK",
    "dropmalst": "OH",
    "dropmalzpp": 440959998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409431260,
    "dropfax": 4405497425
  },
  {
    "dcode": "D",
    "dropkey": "BX23417",
    "droptype": "D",
    "dropname": "WINTERSVILLE",
    "dropdeladd": "210 LURAY DR",
    "dropdelcty": "STEUBENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439533977,
    "dropphyadd": "210 LURAY DR",
    "dropphycty": "STEUBENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439533977,
    "dropmaladd": "210 LURAY DR",
    "dropmalcty": "STEUBENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439533977,
    "dropsitphn": 3309969797,
    "dropsitlph": 7402643611,
    "dropsitcph": 7402643611,
    "dropfax": 7402643611
  },
  {
    "dcode": "D",
    "dropkey": "BX23429",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "597 HIGH ST",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 430859998,
    "dropphyadd": "597 HIGH ST",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 430859998,
    "dropmaladd": "597 HIGH ST",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 430859998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148467413,
    "dropsitcph": 6148467413,
    "dropfax": 6148462825
  },
  {
    "dcode": "D",
    "dropkey": "BX23612",
    "droptype": "D",
    "dropname": "BURTON",
    "dropdeladd": "11 ROBERT SMALLS PKWY STE C",
    "dropdelcty": "BEAUFORT",
    "dropdelst": "SC",
    "dropdelzpp": 299069998,
    "dropphyadd": "11 ROBERT SMALLS PKWY STE C",
    "dropphycty": "BEAUFORT",
    "dropphyst": "SC",
    "dropphyzpp": 299069998,
    "dropmaladd": "11 ROBERT SMALLS PKWY STE C",
    "dropmalcty": "BEAUFORT",
    "dropmalst": "SC",
    "dropmalzpp": 299069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8435256645,
    "dropsitcph": 8435256645,
    "dropfax": 8435242044
  },
  {
    "dcode": "D",
    "dropkey": "BX23764",
    "droptype": "D",
    "dropname": "CROSS COUNTY",
    "dropdeladd": "7075 CROSS COUNTY RD",
    "dropdelcty": "NORTH CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294189997,
    "dropphyadd": "7075 CROSS COUNTY RD",
    "dropphycty": "NORTH CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294189997,
    "dropmaladd": "7075 CROSS COUNTY RD",
    "dropmalcty": "NORTH CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294189997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437605435,
    "dropsitcph": 8437605420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX24211",
    "droptype": "D",
    "dropname": "MARINE CORPS AIR STATION",
    "dropdeladd": "1283 GEIGER BLVD",
    "dropdelcty": "BEAUFORT",
    "dropdelst": "SC",
    "dropdelzpp": 299049998,
    "dropphyadd": "1283 GEIGER BLVD",
    "dropphycty": "BEAUFORT",
    "dropphyst": "SC",
    "dropphyzpp": 299049998,
    "dropmaladd": "1283 GEIGER BLVD",
    "dropmalcty": "BEAUFORT",
    "dropmalst": "SC",
    "dropmalzpp": 299049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8432287003,
    "dropsitcph": 8432287003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX24345",
    "droptype": "D",
    "dropname": "NORTH CHARLESTON",
    "dropdeladd": "6401 RIVERS AVE",
    "dropdelcty": "NORTH CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294064883,
    "dropphyadd": "6401 RIVERS AVE",
    "dropphycty": "NORTH CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294069996,
    "dropmaladd": "PO BOX 29419",
    "dropmalcty": "NORTH CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294199998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435692610,
    "dropsitcph": 8435692610,
    "dropfax": 8435530847
  },
  {
    "dcode": "D",
    "dropkey": "BX24413",
    "droptype": "D",
    "dropname": "PARRIS ISLAND",
    "dropdeladd": "292 BOULEVARD DE FRANCE",
    "dropdelcty": "PARRIS ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 299059998,
    "dropphyadd": "292 BOULEVARD DE FRANCE",
    "dropphycty": "PARRIS ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 299059998,
    "dropmaladd": "292 BOULEVARD DE FRANCE",
    "dropmalcty": "PARRIS ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 299059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8432282812,
    "dropsitcph": 8432282812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX24469",
    "droptype": "D",
    "dropname": "QUINBY",
    "dropdeladd": "625 E ASHBY RD",
    "dropdelcty": "FLORENCE",
    "dropdelst": "SC",
    "dropdelzpp": 295069998,
    "dropphyadd": "625 E ASHBY RD",
    "dropphycty": "FLORENCE",
    "dropphyst": "SC",
    "dropphyzpp": 295069998,
    "dropmaladd": "625 E ASHBY RD",
    "dropmalcty": "FLORENCE",
    "dropmalst": "SC",
    "dropmalzpp": 295069998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436655288,
    "dropsitcph": 8436655288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX24588",
    "droptype": "D",
    "dropname": "SHAW AFB",
    "dropdeladd": "510 NELSON AVE",
    "dropdelcty": "SHAW AFB",
    "dropdelst": "SC",
    "dropdelzpp": 291529998,
    "dropphyadd": "510 NELSON AVE",
    "dropphycty": "SHAW AFB",
    "dropphyst": "SC",
    "dropphyzpp": 291529998,
    "dropmaladd": "510 NELSON AVE",
    "dropmalcty": "SHAW AFB",
    "dropmalst": "SC",
    "dropmalzpp": 291529998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036662153,
    "dropfax": 8036662236
  },
  {
    "dcode": "D",
    "dropkey": "BX24696",
    "droptype": "D",
    "dropname": "SURFSIDE BEACH",
    "dropdeladd": "420 HIGHWAY 17 N",
    "dropdelcty": "SURFSIDE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295759998,
    "dropphyadd": "420 HIGHWAY 17 N",
    "dropphycty": "SURFSIDE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295759998,
    "dropmaladd": "420 HIGHWAY 17 N",
    "dropmalcty": "SURFSIDE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295759998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432382523,
    "dropsitcph": 8432382523,
    "dropfax": 8432388965
  },
  {
    "dcode": "D",
    "dropkey": "BX24858",
    "droptype": "D",
    "dropname": "ALGOOD",
    "dropdeladd": "122 W MAIN ST",
    "dropdelcty": "COOKEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385069998,
    "dropphyadd": "122 W MAIN ST",
    "dropphycty": "COOKEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385069998,
    "dropmaladd": "122 W MAIN ST",
    "dropmalcty": "COOKEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385069998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155376122,
    "dropsitcph": 9315376122,
    "dropfax": 9315379954
  },
  {
    "dcode": "D",
    "dropkey": "BX24899",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "2966 ELMORE PARK RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381349998,
    "dropphyadd": "2966 ELMORE PARK RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381349998,
    "dropmaladd": "2966 ELMORE PARK RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013881713,
    "dropsitcph": 9013885524,
    "dropfax": 9013884232
  },
  {
    "dcode": "D",
    "dropkey": "BX24916",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "7619 HIGHWAY 70 S",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372219998,
    "dropphyadd": "7619 HIGHWAY 70 S",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372219998,
    "dropmaladd": "7619 HIGHWAY 70 S",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156732385,
    "dropsitcph": 6156731892,
    "dropfax": 6156464929
  },
  {
    "dcode": "D",
    "dropkey": "BX25041",
    "droptype": "D",
    "dropname": "COLONIAL HEIGHTS",
    "dropdeladd": "4313 FORT HENRY DR",
    "dropdelcty": "KINGSPORT",
    "dropdelst": "TN",
    "dropdelzpp": 376639998,
    "dropphyadd": "4313 FORT HENRY DR",
    "dropphycty": "KINGSPORT",
    "dropphyst": "TN",
    "dropphyzpp": 376639998,
    "dropmaladd": "4313 FORT HENRY DR",
    "dropmalcty": "KINGSPORT",
    "dropmalst": "TN",
    "dropmalzpp": 376639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232390900,
    "dropsitcph": 4232390900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX25150",
    "droptype": "D",
    "dropname": "EAST RIDGE",
    "dropdeladd": "1510 MAXWELL RD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374129998,
    "dropphyadd": "1510 MAXWELL RD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374129998,
    "dropmaladd": "1510 MAXWELL RD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374129998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238940624,
    "dropsitcph": 4232961476,
    "dropfax": 4238929714
  },
  {
    "dcode": "D",
    "dropkey": "BX25188",
    "droptype": "D",
    "dropname": "FARRAGUT",
    "dropdeladd": "11409 MUNICIPAL CENTER DR",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379229997,
    "dropphyadd": "11409 MUNICIPAL CENTER DR",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379229997,
    "dropmaladd": "11409 MUNICIPAL CENTER DR",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379229997,
    "dropsitphn": 6158859336,
    "dropsitlph": 8656713245,
    "dropsitcph": 8656713475,
    "dropfax": 8656750114
  },
  {
    "dcode": "D",
    "dropkey": "BX25263",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "220 OLD GRAY STATION RD",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376159998,
    "dropphyadd": "220 OLD GRAY STATION RD",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376159998,
    "dropmaladd": "220 OLD GRAY STATION RD",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234772015,
    "dropsitcph": 4234772015,
    "dropfax": 4234775870
  },
  {
    "dcode": "D",
    "dropkey": "BX25493",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "798 BERRY RD",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372049998,
    "dropphyadd": "798 BERRY RD",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372049998,
    "dropmaladd": "798 BERRY RD",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372049998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154630548,
    "dropsitcph": 6153855390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX25573",
    "droptype": "D",
    "dropname": "NAVAL AIR STATION MEMPHIS",
    "dropdeladd": "5722 INTEGRITY DR",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 380545028,
    "dropphyadd": "5722 INTEGRITY DR",
    "dropphycty": "MILLINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 380545028,
    "dropmaladd": "4847 NAVY RD",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 380539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018722231,
    "dropsitcph": 9018724591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX25646",
    "droptype": "D",
    "dropname": "PIGEON FORGE",
    "dropdeladd": "3235 RENA ST",
    "dropdelcty": "PIGEON FORGE",
    "dropdelst": "TN",
    "dropdelzpp": 378639998,
    "dropphyadd": "3235 RENA ST",
    "dropphycty": "PIGEON FORGE",
    "dropphyst": "TN",
    "dropphyzpp": 378639998,
    "dropmaladd": "3235 RENA ST",
    "dropmalcty": "PIGEON FORGE",
    "dropmalst": "TN",
    "dropmalzpp": 378639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654291658,
    "dropsitcph": 8654291859,
    "dropfax": 8654537754
  },
  {
    "dcode": "D",
    "dropkey": "BX25687",
    "droptype": "D",
    "dropname": "RED BANK",
    "dropdeladd": "3317 DAYTON BLVD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374159998,
    "dropphyadd": "3317 DAYTON BLVD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374159998,
    "dropmaladd": "3317 DAYTON BLVD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238773061,
    "dropsitcph": 4238758282,
    "dropfax": 4238758695
  },
  {
    "dcode": "D",
    "dropkey": "BX26028",
    "droptype": "D",
    "dropname": "AMPTHILL",
    "dropdeladd": "3930 MEADOWDALE BLVD",
    "dropdelcty": "NORTH CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 232349998,
    "dropphyadd": "3930 MEADOWDALE BLVD",
    "dropphycty": "NORTH CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 232349998,
    "dropmaladd": "3930 MEADOWDALE BLVD",
    "dropmalcty": "NORTH CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 232349998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042750464,
    "dropsitcph": 8042750464,
    "dropfax": 8047438735
  },
  {
    "dcode": "D",
    "dropkey": "BX26075",
    "droptype": "D",
    "dropname": "BAILEYS CROSSROADS",
    "dropdeladd": "6021 LEESBURG PIKE",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220419998,
    "dropphyadd": "6021 LEESBURG PIKE",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220419998,
    "dropmaladd": "6021 LEESBURG PIKE",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220419998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": 7036716694
  },
  {
    "dcode": "D",
    "dropkey": "BX26117",
    "droptype": "D",
    "dropname": "BELLEVIEW",
    "dropdeladd": "1626 BELLE VIEW BLVD",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223079998,
    "dropphyadd": "1626 BELLE VIEW BLVD",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223079998,
    "dropmaladd": "1626 BELLE VIEW BLVD",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223079998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037683675,
    "dropsitcph": 7037683675,
    "dropfax": 7036609697
  },
  {
    "dcode": "D",
    "dropkey": "BX26119",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "5327 CHAMBERLAYNE RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232279998,
    "dropphyadd": "5327 CHAMBERLAYNE RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232279998,
    "dropmaladd": "5327 CHAMBERLAYNE RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042664863,
    "dropsitcph": 8042664863,
    "dropfax": 8042666251
  },
  {
    "dcode": "D",
    "dropkey": "BX26161",
    "droptype": "D",
    "dropname": "BON AIR",
    "dropdeladd": "101 N PINETTA DR",
    "dropdelcty": "NORTH CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 232359998,
    "dropphyadd": "101 N PINETTA DR",
    "dropphycty": "NORTH CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 232359998,
    "dropmaladd": "101 N PINETTA DR",
    "dropmalcty": "NORTH CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 232359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042723845,
    "dropsitcph": 8046754064,
    "dropfax": 8042723728
  },
  {
    "dcode": "D",
    "dropkey": "BX26224",
    "droptype": "D",
    "dropname": "BURKE",
    "dropdeladd": "9501 BURKE RD",
    "dropdelcty": "BURKE",
    "dropdelst": "VA",
    "dropdelzpp": 220159998,
    "dropphyadd": "9501 BURKE RD",
    "dropphycty": "BURKE",
    "dropphyst": "VA",
    "dropphyzpp": 220159998,
    "dropmaladd": "9501 BURKE RD",
    "dropmalcty": "BURKE",
    "dropmalst": "VA",
    "dropmalzpp": 220159998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039781436,
    "dropsitcph": 7039781436,
    "dropfax": 7034259546
  },
  {
    "dcode": "D",
    "dropkey": "BX26291",
    "droptype": "D",
    "dropname": "CAVE SPRING",
    "dropdeladd": "4069 POSTAL DR",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240189998,
    "dropphyadd": "4069 POSTAL DR",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240189998,
    "dropmaladd": "4069 POSTAL DR",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240189998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407728094,
    "dropfax": 5409858722
  },
  {
    "dcode": "D",
    "dropkey": "BX26305",
    "droptype": "D",
    "dropname": "CHANTILLY",
    "dropdeladd": "4410 BROOKFIELD CORPORATE DR",
    "dropdelcty": "CHANTILLY",
    "dropdelst": "VA",
    "dropdelzpp": 201519998,
    "dropphyadd": "4410 BROOKFIELD CORPORATE DR",
    "dropphycty": "CHANTILLY",
    "dropphyst": "VA",
    "dropphyzpp": 201519998,
    "dropmaladd": "4410 BROOKFIELD CORPORATE DR",
    "dropmalcty": "CHANTILLY",
    "dropmalst": "VA",
    "dropmalzpp": 201519998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039687361,
    "dropsitcph": 7039619419,
    "dropfax": 7032228071
  },
  {
    "dcode": "D",
    "dropkey": "BX26529",
    "droptype": "D",
    "dropname": "DUNN LORING",
    "dropdeladd": "2302 GALLOWS RD",
    "dropdelcty": "DUNN LORING",
    "dropdelst": "VA",
    "dropdelzpp": 220279998,
    "dropphyadd": "2302 GALLOWS RD",
    "dropphycty": "DUNN LORING",
    "dropphyst": "VA",
    "dropphyzpp": 220279998,
    "dropmaladd": "2302 GALLOWS RD",
    "dropmalcty": "DUNN LORING",
    "dropmalst": "VA",
    "dropmalzpp": 220279998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7035736593,
    "dropsitcph": 7035736593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX26569",
    "droptype": "D",
    "dropname": "ENGLESIDE",
    "dropdeladd": "8588 RICHMOND HWY",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223099998,
    "dropphyadd": "8588 RICHMOND HWY",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223099998,
    "dropmaladd": "8588 RICHMOND HWY",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223099998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037045680,
    "dropsitcph": 7037045680,
    "dropfax": 7037802695
  },
  {
    "dcode": "D",
    "dropkey": "BX26585",
    "droptype": "D",
    "dropname": "FAIRFAX STATION",
    "dropdeladd": "5616I OX RD",
    "dropdelcty": "FAIRFAX STATION",
    "dropdelst": "VA",
    "dropdelzpp": 220399998,
    "dropphyadd": "5616I OX RD",
    "dropphycty": "FAIRFAX STATION",
    "dropphyst": "VA",
    "dropphyzpp": 220399998,
    "dropmaladd": "5616I OX RD",
    "dropmalcty": "FAIRFAX STATION",
    "dropmalst": "VA",
    "dropmalzpp": 220399998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035910458,
    "dropsitcph": 7035910458,
    "dropfax": 7032506724
  },
  {
    "dcode": "D",
    "dropkey": "BX26596",
    "droptype": "D",
    "dropname": "FALMOUTH",
    "dropdeladd": "16 LICHFIELD BLVD",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 224069998,
    "dropphyadd": "16 LICHFIELD BLVD",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 224069998,
    "dropmaladd": "16 LICHFIELD BLVD",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 224069998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403737841,
    "dropsitcph": 5403737841,
    "dropfax": 5403704862
  },
  {
    "dcode": "D",
    "dropkey": "BX26621",
    "droptype": "D",
    "dropname": "FLEET",
    "dropdeladd": "9221 3RD AVE",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235119998,
    "dropphyadd": "9221 3RD AVE",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235119998,
    "dropmaladd": "9221 3RD AVE",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235119998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574443161,
    "dropsitcph": 7574443161,
    "dropfax": 7574446659
  },
  {
    "dcode": "D",
    "dropkey": "BX26645",
    "droptype": "D",
    "dropname": "FORT GREGG ADAMS",
    "dropdeladd": "1400 SUSTAINMENT AVE",
    "dropdelcty": "FORT GREGG ADAMS",
    "dropdelst": "VA",
    "dropdelzpp": 238011616,
    "dropphyadd": "1400 SUSTAINMENT AVE",
    "dropphycty": "FORT GREGG ADAMS",
    "dropphyst": "VA",
    "dropphyzpp": 238011616,
    "dropmaladd": "1400 SUSTAINMENT AVE",
    "dropmalcty": "FORT GREGG ADAMS",
    "dropmalst": "VA",
    "dropmalzpp": 238011616,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048610539,
    "dropsitcph": 8048610539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX26658",
    "droptype": "D",
    "dropname": "FRANCONIA",
    "dropdeladd": "5221 FRANCONIA RD",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223109998,
    "dropphyadd": "5221 FRANCONIA RD",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223109998,
    "dropmaladd": "5221 FRANCONIA RD",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223109998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039710435,
    "dropsitcph": 7039710435,
    "dropfax": 7039718935
  },
  {
    "dcode": "D",
    "dropkey": "BX26735",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "5702 GEORGE WASHINGTON MEM HWY",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 236922878,
    "dropphyadd": "5702 GEORGE WASHINGTON MEM HWY",
    "dropphycty": "YORKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 236922878,
    "dropmaladd": "5702 GEORGE WASHINGTON MEM HWY",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 236922878,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578988633,
    "dropsitcph": 7578985435,
    "dropfax": 7578985497
  },
  {
    "dcode": "D",
    "dropkey": "BX26837",
    "droptype": "D",
    "dropname": "HIGHLAND SPRINGS",
    "dropdeladd": "405 E NINE MILE RD",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 230759998,
    "dropphyadd": "405 E NINE MILE RD",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 230759998,
    "dropmaladd": "405 E NINE MILE RD",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 230759998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047379530,
    "dropsitcph": 8047379530,
    "dropfax": 8047376311
  },
  {
    "dcode": "D",
    "dropkey": "BX26852",
    "droptype": "D",
    "dropname": "HOLLINS",
    "dropdeladd": "6621 WILLIAMSON RD",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240199998,
    "dropphyadd": "6621 WILLIAMSON RD",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240199998,
    "dropmaladd": "6621 WILLIAMSON RD",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240199998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403668632,
    "dropfax": 5402657934
  },
  {
    "dcode": "D",
    "dropkey": "BX26905",
    "droptype": "D",
    "dropname": "JEFFERSON MANOR",
    "dropdeladd": "5834C N KINGS HWY",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223039998,
    "dropphyadd": "5834C N KINGS HWY",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223039998,
    "dropmaladd": "5834C N KINGS HWY",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223039998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033179286,
    "dropsitcph": 7033179286,
    "dropfax": 7033179379
  },
  {
    "dcode": "D",
    "dropkey": "BX26967",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "2100 E PARHAM RD",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 232289998,
    "dropphyadd": "2100 E PARHAM RD",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 232289998,
    "dropmaladd": "2100 E PARHAM RD",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 232289998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042620641,
    "dropsitcph": 8042620641,
    "dropfax": 8042629311
  },
  {
    "dcode": "D",
    "dropkey": "BX27068",
    "droptype": "D",
    "dropname": "MANASSAS PARK",
    "dropdeladd": "2049 OLD CENTREVILLE RD",
    "dropdelcty": "MANASSAS PARK",
    "dropdelst": "VA",
    "dropdelzpp": 201119998,
    "dropphyadd": "2049 OLD CENTREVILLE RD",
    "dropphycty": "MANASSAS PARK",
    "dropphyst": "VA",
    "dropphyzpp": 201119998,
    "dropmaladd": "2049 OLD CENTREVILLE RD",
    "dropmalcty": "MANASSAS PARK",
    "dropmalst": "VA",
    "dropmalzpp": 201119998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033923955,
    "dropsitcph": 7033923955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27209",
    "droptype": "D",
    "dropname": "MOSBY",
    "dropdeladd": "3030 ANNANDALE RD",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220429998,
    "dropphyadd": "3030 ANNANDALE RD",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220429998,
    "dropmaladd": "3030 ANNANDALE RD",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220429998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27252",
    "droptype": "D",
    "dropname": "NAVAL BASE",
    "dropdeladd": "1731 GILBERT ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235119997,
    "dropphyadd": "1731 GILBERT ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235119997,
    "dropmaladd": "1731 GILBERT ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235119997,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7574442043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27260",
    "droptype": "D",
    "dropname": "NAVAL WEAPONS STATION",
    "dropdeladd": "1 US NAVY",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 236919998,
    "dropphyadd": "1 US NAVY",
    "dropphycty": "YORKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 236919998,
    "dropmaladd": "1 US NAVY",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 236919998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578986241,
    "dropsitcph": 7578986241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27432",
    "droptype": "D",
    "dropname": "POQUOSON",
    "dropdeladd": "529 WYTHE CREEK RD",
    "dropdelcty": "POQUOSON",
    "dropdelst": "VA",
    "dropdelzpp": 236629998,
    "dropphyadd": "529 WYTHE CREEK RD",
    "dropphycty": "POQUOSON",
    "dropphyst": "VA",
    "dropphyzpp": 236629998,
    "dropmaladd": "529 WYTHE CREEK RD",
    "dropmalcty": "POQUOSON",
    "dropmalst": "VA",
    "dropmalzpp": 236629998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578382776,
    "dropsitcph": 7578683428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27504",
    "droptype": "D",
    "dropname": "REGENCY",
    "dropdeladd": "2000 STARLING DR",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 232299998,
    "dropphyadd": "2000 STARLING DR",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 232299998,
    "dropmaladd": "2000 STARLING DR",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 232299998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047471844,
    "dropsitcph": 8047471844,
    "dropfax": 8049353822
  },
  {
    "dcode": "D",
    "dropkey": "BX27512",
    "droptype": "D",
    "dropname": "RESTON",
    "dropdeladd": "11110 SUNSET HILLS RD",
    "dropdelcty": "RESTON",
    "dropdelst": "VA",
    "dropdelzpp": 201909998,
    "dropphyadd": "11110 SUNSET HILLS RD",
    "dropphycty": "RESTON",
    "dropphyst": "VA",
    "dropphyzpp": 201909998,
    "dropmaladd": "11110 SUNSET HILLS RD",
    "dropmalcty": "RESTON",
    "dropmalst": "VA",
    "dropmalzpp": 201909998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036899874,
    "dropsitcph": 7036899874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27531",
    "droptype": "D",
    "dropname": "RIDGE",
    "dropdeladd": "10509 PATTERSON AVE",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 232389998,
    "dropphyadd": "10509 PATTERSON AVE",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 232389998,
    "dropmaladd": "10509 PATTERSON AVE",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 232389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047407092,
    "dropsitcph": 8047407092,
    "dropfax": 8047408179
  },
  {
    "dcode": "D",
    "dropkey": "BX27620",
    "droptype": "D",
    "dropname": "SEVEN CORNERS",
    "dropdeladd": "6375 SEVEN CORNERS CTR",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220449998,
    "dropphyadd": "6375 SEVEN CORNERS CTR",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220449998,
    "dropmaladd": "6375 SEVEN CORNERS CTR",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220449998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27892",
    "droptype": "D",
    "dropname": "VINT HILL FARMS",
    "dropdeladd": "4257 AIKEN DR",
    "dropdelcty": "WARRENTON",
    "dropdelst": "VA",
    "dropdelzpp": 201873934,
    "dropphyadd": "4257 AIKEN DR",
    "dropphycty": "WARRENTON",
    "dropphyst": "VA",
    "dropphyzpp": 201873934,
    "dropmaladd": "4257 AIKEN DR",
    "dropmalcty": "WARRENTON",
    "dropmalst": "VA",
    "dropmalzpp": 201873934,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403476551,
    "dropsitcph": 5403498759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27912",
    "droptype": "D",
    "dropname": "WALLOPS ISLAND",
    "dropdeladd": "7 OREILEY ST BLDG E",
    "dropdelcty": "WALLOPS ISLAND",
    "dropdelst": "VA",
    "dropdelzpp": 233379998,
    "dropphyadd": "7 OREILEY ST BLDG E",
    "dropphycty": "WALLOPS ISLAND",
    "dropphyst": "VA",
    "dropphyzpp": 233379998,
    "dropmaladd": "7 OREILEY ST BLDG E",
    "dropmalcty": "WALLOPS ISLAND",
    "dropmalst": "VA",
    "dropmalzpp": 233379998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573362934,
    "dropsitcph": 7578241243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX27962",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "2220 DABNEY RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232309998,
    "dropphyadd": "2220 DABNEY RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232309998,
    "dropmaladd": "2220 DABNEY RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232309998,
    "dropsitphn": 8047373653,
    "dropsitlph": 8043534361,
    "dropsitcph": 8043534361,
    "dropfax": 8043531311
  },
  {
    "dcode": "D",
    "dropkey": "BX27964",
    "droptype": "D",
    "dropname": "WEST MCLEAN",
    "dropdeladd": "1544 SPRING HILL RD",
    "dropdelcty": "MC LEAN",
    "dropdelst": "VA",
    "dropdelzpp": 221029998,
    "dropphyadd": "1544 SPRING HILL RD",
    "dropphycty": "MC LEAN",
    "dropphyst": "VA",
    "dropphyzpp": 221029998,
    "dropmaladd": "1544 SPRING HILL RD",
    "dropmalcty": "MC LEAN",
    "dropmalst": "VA",
    "dropmalzpp": 221029998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037346243,
    "dropsitcph": 7037346243,
    "dropfax": 7033567984
  },
  {
    "dcode": "D",
    "dropkey": "BX27967",
    "droptype": "D",
    "dropname": "WEST SPRINGFIELD",
    "dropdeladd": "6200 ROLLING RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 221529998,
    "dropphyadd": "6200 ROLLING RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 221529998,
    "dropmaladd": "6200 ROLLING RD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 221529998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035690378,
    "dropsitcph": 7035690378,
    "dropfax": 7035692762
  },
  {
    "dcode": "D",
    "dropkey": "BX28367",
    "droptype": "D",
    "dropname": "CROSS LANES",
    "dropdeladd": "5306 BIG TYLER RD",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253139998,
    "dropphyadd": "5306 BIG TYLER RD",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253139998,
    "dropmaladd": "5306 BIG TYLER RD",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047763201,
    "dropfax": 3047761861
  },
  {
    "dcode": "D",
    "dropkey": "BX28503",
    "droptype": "D",
    "dropname": "FORT NEAL",
    "dropdeladd": "806 NEAL ST",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261019997,
    "dropphyadd": "806 NEAL ST",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261019997,
    "dropmaladd": "806 NEAL ST",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261019997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044280992,
    "dropfax": 3044850724
  },
  {
    "dcode": "D",
    "dropkey": "BX28835",
    "droptype": "D",
    "dropname": "MARMET",
    "dropdeladd": "9303 MACCORKLE AVE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253159998,
    "dropphyadd": "9303 MACCORKLE AVE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253159998,
    "dropmaladd": "9303 MACCORKLE AVE",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049496328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX28964",
    "droptype": "D",
    "dropname": "NORTH PARKERSBURG",
    "dropdeladd": "3505 CENTRAL AVE",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261049998,
    "dropphyadd": "3505 CENTRAL AVE",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261049998,
    "dropmaladd": "3505 CENTRAL AVE",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044224312,
    "dropfax": 3044850724
  },
  {
    "dcode": "D",
    "dropkey": "BX29193",
    "droptype": "D",
    "dropname": "SISSONVILLE",
    "dropdeladd": "6088 SISSONVILLE DR",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253129997,
    "dropphyadd": "6088 SISSONVILLE DR",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253129997,
    "dropmaladd": "6088 SISSONVILLE DR",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253129997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049849352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX29211",
    "droptype": "D",
    "dropname": "SOUTH CHARLESTON",
    "dropdeladd": "400 D ST",
    "dropdelcty": "SOUTH CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253039998,
    "dropphyadd": "400 D ST",
    "dropphycty": "SOUTH CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253039998,
    "dropmaladd": "400 D ST",
    "dropmalcty": "SOUTH CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047447357,
    "dropfax": 3047447826
  },
  {
    "dcode": "D",
    "dropkey": "BX29227",
    "droptype": "D",
    "dropname": "STAR CITY",
    "dropdeladd": "3400 UNIVERSITY AVE",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265059994,
    "dropphyadd": "3400 UNIVERSITY AVE",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265059994,
    "dropmaladd": "3400 UNIVERSITY AVE",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265059994,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045995769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX29323",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "600 27TH ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "WV",
    "dropdelzpp": 261059998,
    "dropphyadd": "600 27TH ST",
    "dropphycty": "VIENNA",
    "dropphyst": "WV",
    "dropphyzpp": 261059998,
    "dropmaladd": "600 27TH ST",
    "dropmalcty": "VIENNA",
    "dropmalst": "WV",
    "dropmalzpp": 261059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042954341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX29490",
    "droptype": "D",
    "dropname": "EASTPOINTE",
    "dropdeladd": "200 CAVA DR",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263019991,
    "dropphyadd": "200 CAVA DR",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263019991,
    "dropmaladd": "200 CAVA DR",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263019991,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046237732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX29798",
    "droptype": "D",
    "dropname": "GEORGE MASON",
    "dropdeladd": "126 S WASHINGTON ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223209998,
    "dropphyadd": "126 S WASHINGTON ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223209998,
    "dropmaladd": "126 S WASHINGTON ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223209998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036843619,
    "dropsitcph": 7036843619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BX29803",
    "droptype": "D",
    "dropname": "OAKTON",
    "dropdeladd": "10449 WHITE GRANITE DR",
    "dropdelcty": "OAKTON",
    "dropdelst": "VA",
    "dropdelzpp": 221249998,
    "dropphyadd": "10449 WHITE GRANITE DR",
    "dropphycty": "OAKTON",
    "dropphyst": "VA",
    "dropphyzpp": 221249998,
    "dropmaladd": "10449 WHITE GRANITE DR",
    "dropmalcty": "OAKTON",
    "dropmalst": "VA",
    "dropmalzpp": 221249998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7032180731,
    "dropsitcph": 7032180731,
    "dropfax": 7035917354
  },
  {
    "dcode": "D",
    "dropkey": "BX29863",
    "droptype": "D",
    "dropname": "GAHANNA",
    "dropdeladd": "246 LINCOLN CIR STE H",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432309997,
    "dropphyadd": "246 LINCOLN CIR STE H",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432309997,
    "dropmaladd": "246 LINCOLN CIR STE H",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432309997,
    "dropsitphn": 6144720696,
    "dropsitlph": 6144720696,
    "dropsitcph": 6144719174,
    "dropfax": 6144752745
  },
  {
    "dcode": "D",
    "dropkey": "BY10126",
    "droptype": "D",
    "dropname": "BLUE MOUNTAIN",
    "dropdeladd": "3202 MCCLELLAN BLVD",
    "dropdelcty": "ANNISTON",
    "dropdelst": "AL",
    "dropdelzpp": 362042000,
    "dropphyadd": "3202 MCCLELLAN BLVD",
    "dropphycty": "ANNISTON",
    "dropphyst": "AL",
    "dropphyzpp": 362042000,
    "dropmaladd": "3202 MCCLELLAN BLVD",
    "dropmalcty": "ANNISTON",
    "dropmalst": "AL",
    "dropmalzpp": 362049998,
    "dropsitphn": 2562379711,
    "dropsitlph": 2562379711,
    "dropsitcph": 2562379711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10130",
    "droptype": "D",
    "dropname": "BLUFF PARK",
    "dropdeladd": "762 SHADES MOUNTAIN PLZ",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352602000,
    "dropphyadd": "762 SHADES MOUNTAIN PLZ",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352609998,
    "dropmaladd": "762 SHADES MOUNTAIN PLZ",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352609998,
    "dropsitphn": 2059794149,
    "dropsitlph": 2059794149,
    "dropsitcph": 2059794149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10178",
    "droptype": "D",
    "dropname": "CAHABA HEIGHTS",
    "dropdeladd": "3105 SUNVIEW DR",
    "dropdelcty": "VESTAVIA",
    "dropdelst": "AL",
    "dropdelzpp": 352435434,
    "dropphyadd": "3105 SUNVIEW DR",
    "dropphycty": "VESTAVIA",
    "dropphyst": "AL",
    "dropphyzpp": 352435434,
    "dropmaladd": "3105 SUNVIEW DR",
    "dropmalcty": "VESTAVIA",
    "dropmalst": "AL",
    "dropmalzpp": 352439998,
    "dropsitphn": 2059701696,
    "dropsitlph": 2059701696,
    "dropsitcph": 2059701696,
    "dropfax": 2059691465
  },
  {
    "dcode": "D",
    "dropkey": "BY10206",
    "droptype": "D",
    "dropname": "CENTER POINT",
    "dropdeladd": "2365 1ST ST NE",
    "dropdelcty": "CENTER POINT",
    "dropdelst": "AL",
    "dropdelzpp": 352153619,
    "dropphyadd": "2365 1ST ST NE",
    "dropphycty": "CENTER POINT",
    "dropphyst": "AL",
    "dropphyzpp": 352153619,
    "dropmaladd": "2365 1ST ST NE",
    "dropmalcty": "CENTER POINT",
    "dropmalst": "AL",
    "dropmalzpp": 352159998,
    "dropsitphn": 2058546603,
    "dropsitlph": 2058544399,
    "dropsitcph": 2058546603,
    "dropfax": 2055200874
  },
  {
    "dcode": "D",
    "dropkey": "BY10221",
    "droptype": "D",
    "dropname": "CHICKASAW",
    "dropdeladd": "411 PARKER LN",
    "dropdelcty": "CHICKASAW",
    "dropdelst": "AL",
    "dropdelzpp": 366111599,
    "dropphyadd": "411 PARKER LN",
    "dropphycty": "CHICKASAW",
    "dropphyst": "AL",
    "dropphyzpp": 366111599,
    "dropmaladd": "411 PARKER LN",
    "dropmalcty": "CHICKASAW",
    "dropmalst": "AL",
    "dropmalzpp": 366111599,
    "dropsitphn": 2514572018,
    "dropsitlph": 2514572018,
    "dropsitcph": 2514572018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10262",
    "droptype": "D",
    "dropname": "COOSA PINES",
    "dropdeladd": "125 9TH AVE SW",
    "dropdelcty": "CHILDERSBURG",
    "dropdelst": "AL",
    "dropdelzpp": 350449998,
    "dropphyadd": "125 9TH AVE SW",
    "dropphycty": "CHILDERSBURG",
    "dropphyst": "AL",
    "dropphyzpp": 350449998,
    "dropmaladd": "125 9TH AVE SW",
    "dropmalcty": "CHILDERSBURG",
    "dropmalst": "AL",
    "dropmalzpp": 350449998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2057594660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10282",
    "droptype": "D",
    "dropname": "CRESTLINE HEIGHTS",
    "dropdeladd": "3900 MONTCLAIR RD FL 1",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352139998,
    "dropphyadd": "3900 MONTCLAIR RD FL 1",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352139998,
    "dropmaladd": "3900 MONTCLAIR RD FL 1",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352139998,
    "dropsitphn": 2058709656,
    "dropsitlph": 2058709656,
    "dropsitcph": 2058709656,
    "dropfax": 2058799071
  },
  {
    "dcode": "D",
    "dropkey": "BY10355",
    "droptype": "D",
    "dropname": "EAST BREWTON",
    "dropdeladd": "505 FORREST AVE",
    "dropdelcty": "BREWTON",
    "dropdelst": "AL",
    "dropdelzpp": 364262698,
    "dropphyadd": "505 FORREST AVE",
    "dropphycty": "BREWTON",
    "dropphyst": "AL",
    "dropphyzpp": 364262698,
    "dropmaladd": "505 FORREST AVE",
    "dropmalcty": "BREWTON",
    "dropmalst": "AL",
    "dropmalzpp": 364262698,
    "dropsitphn": 3348674233,
    "dropsitlph": 3348674233,
    "dropsitcph": 3348674233,
    "dropfax": 3348672676
  },
  {
    "dcode": "D",
    "dropkey": "BY10361",
    "droptype": "D",
    "dropname": "EAST TALLASSEE",
    "dropdeladd": "114 CENTRAL BLVD",
    "dropdelcty": "TALLASSEE",
    "dropdelst": "AL",
    "dropdelzpp": 360782008,
    "dropphyadd": "114 CENTRAL BLVD",
    "dropphycty": "TALLASSEE",
    "dropphyst": "AL",
    "dropphyzpp": 360782008,
    "dropmaladd": "114 CENTRAL BLVD",
    "dropmalcty": "TALLASSEE",
    "dropmalst": "AL",
    "dropmalzpp": 360782008,
    "dropsitphn": 3342832262,
    "dropsitlph": 3342832262,
    "dropsitcph": 3342832262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10455",
    "droptype": "D",
    "dropname": "FORT MC CLELLAN",
    "dropdeladd": "267 TOWN CENTER DR",
    "dropdelcty": "ANNISTON",
    "dropdelst": "AL",
    "dropdelzpp": 362059998,
    "dropphyadd": "267 TOWN CENTER DR",
    "dropphycty": "ANNISTON",
    "dropphyst": "AL",
    "dropphyzpp": 362059998,
    "dropmaladd": "267 TOWN CENTER DR",
    "dropmalcty": "ANNISTON",
    "dropmalst": "AL",
    "dropmalzpp": 362059998,
    "dropsitphn": 2568206595,
    "dropsitlph": 2568206595,
    "dropsitcph": 2568206595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10460",
    "droptype": "D",
    "dropname": "FORT NOVOSEL",
    "dropdeladd": "9000 RUF AVE",
    "dropdelcty": "FORT NOVOSEL",
    "dropdelst": "AL",
    "dropdelzpp": 363625003,
    "dropphyadd": "9000 RUF AVE",
    "dropphycty": "FORT NOVOSEL",
    "dropphyst": "AL",
    "dropphyzpp": 363625003,
    "dropmaladd": "9000 RUF AVE",
    "dropmalcty": "FORT NOVOSEL",
    "dropmalst": "AL",
    "dropmalzpp": 363625003,
    "dropsitphn": 3345986446,
    "dropsitlph": 3345986446,
    "dropsitcph": 3345986446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10510",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "107 MAIN ST E",
    "dropdelcty": "GADSDEN",
    "dropdelst": "AL",
    "dropdelzpp": 359051755,
    "dropphyadd": "107 MAIN ST E",
    "dropphycty": "GADSDEN",
    "dropphyst": "AL",
    "dropphyzpp": 359051755,
    "dropmaladd": "107 MAIN ST E",
    "dropmalcty": "GADSDEN",
    "dropmalst": "AL",
    "dropmalzpp": 359059998,
    "dropsitphn": 2564922210,
    "dropsitlph": 2564922210,
    "dropsitcph": 2564922210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10616",
    "droptype": "D",
    "dropname": "HOMEWOOD",
    "dropdeladd": "2710 18TH ST S",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352091904,
    "dropphyadd": "2710 18TH ST S",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352091904,
    "dropmaladd": "2710 18TH ST S",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352099998,
    "dropsitphn": 2058710641,
    "dropsitlph": 2058710641,
    "dropsitcph": 2058710641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10621",
    "droptype": "D",
    "dropname": "HOOVER",
    "dropdeladd": "1809 RIVERCHASE DR",
    "dropdelcty": "HOOVER",
    "dropdelst": "AL",
    "dropdelzpp": 352449998,
    "dropphyadd": "1809 RIVERCHASE DR",
    "dropphycty": "HOOVER",
    "dropphyst": "AL",
    "dropphyzpp": 352449998,
    "dropmaladd": "1809 RIVERCHASE DR",
    "dropmalcty": "HOOVER",
    "dropmalst": "AL",
    "dropmalzpp": 352449998,
    "dropsitphn": 2059824861,
    "dropsitlph": 2059824861,
    "dropsitcph": 2059821734,
    "dropfax": 2059883056
  },
  {
    "dcode": "D",
    "dropkey": "BY10627",
    "droptype": "D",
    "dropname": "HUEYTOWN",
    "dropdeladd": "615 BROOKLANE DR",
    "dropdelcty": "HUEYTOWN",
    "dropdelst": "AL",
    "dropdelzpp": 350232508,
    "dropphyadd": "615 BROOKLANE DR",
    "dropphycty": "HUEYTOWN",
    "dropphyst": "AL",
    "dropphyzpp": 350232508,
    "dropmaladd": "615 BROOKLANE DR",
    "dropmalcty": "HUEYTOWN",
    "dropmalst": "AL",
    "dropmalzpp": 350239998,
    "dropsitphn": 2054970586,
    "dropsitlph": 2054970586,
    "dropsitcph": 2054970586,
    "dropfax": 2054910573
  },
  {
    "dcode": "D",
    "dropkey": "BY10648",
    "droptype": "D",
    "dropname": "IRONDALE",
    "dropdeladd": "2730 CRESTWOOD BLVD",
    "dropdelcty": "IRONDALE",
    "dropdelst": "AL",
    "dropdelzpp": 352101227,
    "dropphyadd": "2730 CRESTWOOD BLVD",
    "dropphycty": "IRONDALE",
    "dropphyst": "AL",
    "dropphyzpp": 352101227,
    "dropmaladd": "2730 CRESTWOOD BLVD",
    "dropmalcty": "IRONDALE",
    "dropmalst": "AL",
    "dropmalzpp": 352109998,
    "dropsitphn": 2059567377,
    "dropsitlph": 2059567377,
    "dropsitcph": 2059567377,
    "dropfax": 2059566172
  },
  {
    "dcode": "D",
    "dropkey": "BY10760",
    "droptype": "D",
    "dropname": "MAXWELL AFB",
    "dropdeladd": "550 E MAXWELL BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361126103,
    "dropphyadd": "550 E MAXWELL BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361126103,
    "dropmaladd": "550 E MAXWELL BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361126103,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342634974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10789",
    "droptype": "D",
    "dropname": "MIDFIELD",
    "dropdeladd": "880 WILKES RD",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352283785,
    "dropphyadd": "880 WILKES RD",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352283785,
    "dropmaladd": "880 WILKES RD",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352289998,
    "dropsitphn": 2054244139,
    "dropsitlph": 2054244139,
    "dropsitcph": 2054268054,
    "dropfax": 2054244590
  },
  {
    "dcode": "D",
    "dropkey": "BY10905",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "90 PLAZA LN",
    "dropdelcty": "OXFORD",
    "dropdelst": "AL",
    "dropdelzpp": 362032440,
    "dropphyadd": "90 PLAZA LN",
    "dropphycty": "OXFORD",
    "dropphyst": "AL",
    "dropphyzpp": 362032440,
    "dropmaladd": "90 PLAZA LN",
    "dropmalcty": "OXFORD",
    "dropmalst": "AL",
    "dropmalzpp": 362039998,
    "dropsitphn": 2568313515,
    "dropsitlph": 2568313515,
    "dropsitcph": 2568313515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY10979",
    "droptype": "D",
    "dropname": "PRICHARD",
    "dropdeladd": "130 E PRICHARD AVE",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366109998,
    "dropphyadd": "130 E PRICHARD AVE",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366109998,
    "dropmaladd": "130 E PRICHARD AVE",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366109998,
    "dropsitphn": 2514574512,
    "dropsitlph": 2514574512,
    "dropsitcph": 2514574512,
    "dropfax": 2514569610
  },
  {
    "dcode": "D",
    "dropkey": "BY11000",
    "droptype": "D",
    "dropname": "REDSTONE ARSENAL",
    "dropdeladd": "3710 AEROBEE RD",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358089008,
    "dropphyadd": "3710 AEROBEE RD",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358089008,
    "dropmaladd": "3605 GOVERNORS DR SW",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358059998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2568850879,
    "dropsitcph": 2566501153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY11093",
    "droptype": "D",
    "dropname": "SILURIA",
    "dropdeladd": "637 11TH AVE SW",
    "dropdelcty": "SILURIA",
    "dropdelst": "AL",
    "dropdelzpp": 35144,
    "dropphyadd": "637 11TH AVE SW",
    "dropphycty": "SILURIA",
    "dropphyst": "AL",
    "dropphyzpp": 35144,
    "dropmaladd": "50 KENT STONE WAY",
    "dropmalcty": "ALABASTER",
    "dropmalst": "AL",
    "dropmalzpp": 350079998,
    "dropsitphn": 2056633971,
    "dropsitlph": 2056633971,
    "dropsitcph": 2056633971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY11169",
    "droptype": "D",
    "dropname": "TARRANT",
    "dropdeladd": "1101 ELIZABETH AVE",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352172427,
    "dropphyadd": "1101 ELIZABETH AVE",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352172427,
    "dropmaladd": "1101 ELIZABETH AVE",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352179998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2058498245,
    "dropsitcph": 2058498245,
    "dropfax": 2058497677
  },
  {
    "dcode": "D",
    "dropkey": "BY11235",
    "droptype": "D",
    "dropname": "VESTAVIA HILLS",
    "dropdeladd": "745 MONTGOMERY HWY",
    "dropdelcty": "VESTAVIA HILLS",
    "dropdelst": "AL",
    "dropdelzpp": 352169998,
    "dropphyadd": "745 MONTGOMERY HWY",
    "dropphycty": "VESTAVIA HILLS",
    "dropphyst": "AL",
    "dropphyzpp": 352169998,
    "dropmaladd": "745 MONTGOMERY HWY",
    "dropmalcty": "VESTAVIA HILLS",
    "dropmalst": "AL",
    "dropmalzpp": 352169998,
    "dropsitphn": 2059794123,
    "dropsitlph": 2059794123,
    "dropsitcph": 2059792195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY11377",
    "droptype": "D",
    "dropname": "AUBURN HILLS",
    "dropdeladd": "2960 AUBURN RD",
    "dropdelcty": "AUBURN HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483269998,
    "dropphyadd": "2960 AUBURN RD",
    "dropphycty": "AUBURN HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483269998,
    "dropmaladd": "2960 AUBURN RD",
    "dropmalcty": "AUBURN HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483269998,
    "dropsitphn": 2488524135,
    "dropsitlph": 2487585622,
    "dropsitcph": 2488522048,
    "dropfax": 2488524988
  },
  {
    "dcode": "D",
    "dropkey": "BY11434",
    "droptype": "D",
    "dropname": "BERKLEY",
    "dropdeladd": "2886 12 MILE RD",
    "dropdelcty": "BERKLEY",
    "dropdelst": "MI",
    "dropdelzpp": 480729998,
    "dropphyadd": "2886 12 MILE RD",
    "dropphycty": "BERKLEY",
    "dropphyst": "MI",
    "dropphyzpp": 480729998,
    "dropmaladd": "200 W 2ND ST",
    "dropmalcty": "ROYAL OAK",
    "dropmalst": "MI",
    "dropmalzpp": 480689998,
    "dropsitphn": 2487403324,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485467149,
    "dropfax": 2483991371
  },
  {
    "dcode": "D",
    "dropkey": "BY11465",
    "droptype": "D",
    "dropname": "BLOOMFIELD TOWNSHIP",
    "dropdeladd": "2211 S TELEGRAPH RD",
    "dropdelcty": "BLOOMFIELD HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483029998,
    "dropphyadd": "2211 S TELEGRAPH RD",
    "dropphycty": "BLOOMFIELD HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483029998,
    "dropmaladd": "2211 S TELEGRAPH RD",
    "dropmalcty": "BLOOMFIELD HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483029998,
    "dropsitphn": 2483329381,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483326870,
    "dropfax": 2483357024
  },
  {
    "dcode": "D",
    "dropkey": "BY11574",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "480 N CANTON CENTER RD",
    "dropdelcty": "CANTON",
    "dropdelst": "MI",
    "dropdelzpp": 481879998,
    "dropphyadd": "480 N CANTON CENTER RD",
    "dropphycty": "CANTON",
    "dropphyst": "MI",
    "dropphyzpp": 481879998,
    "dropmaladd": "480 N CANTON CENTER RD",
    "dropmalcty": "CANTON",
    "dropmalst": "MI",
    "dropmalzpp": 481879998,
    "dropsitphn": 7348440590,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348440590,
    "dropfax": 7348443793
  },
  {
    "dcode": "D",
    "dropkey": "BY11653",
    "droptype": "D",
    "dropname": "CLINTON TOWNSHIP",
    "dropdeladd": "42383 GARFIELD RD",
    "dropdelcty": "CLINTON TOWNSHIP",
    "dropdelst": "MI",
    "dropdelzpp": 480389997,
    "dropphyadd": "42383 GARFIELD RD",
    "dropphycty": "CLINTON TOWNSHIP",
    "dropphyst": "MI",
    "dropphyzpp": 480389997,
    "dropmaladd": "42383 GARFIELD RD",
    "dropmalcty": "CLINTON TOWNSHIP",
    "dropmalst": "MI",
    "dropmalzpp": 480389997,
    "dropsitphn": 5867832879,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867832879,
    "dropfax": 5864693387
  },
  {
    "dcode": "D",
    "dropkey": "BY11837",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "9780 S DIXIE HWY",
    "dropdelcty": "ERIE",
    "dropdelst": "MI",
    "dropdelzpp": 481339998,
    "dropphyadd": "9780 S DIXIE HWY",
    "dropphycty": "ERIE",
    "dropphyst": "MI",
    "dropphyzpp": 481339998,
    "dropmaladd": "9780 S DIXIE HWY",
    "dropmalcty": "ERIE",
    "dropmalst": "MI",
    "dropmalzpp": 481339998,
    "dropsitphn": 7348485101,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348485101,
    "dropfax": 7348482892
  },
  {
    "dcode": "D",
    "dropkey": "BY11854",
    "droptype": "D",
    "dropname": "FARMINGTON HILLS",
    "dropdeladd": "32455 W 12 MILE RD",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 483339998,
    "dropphyadd": "32455 W 12 MILE RD",
    "dropphycty": "FARMINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 483339998,
    "dropmaladd": "32455 W 12 MILE RD",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 483339998,
    "dropsitphn": 2483243485,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483243485,
    "dropfax": 2485537840
  },
  {
    "dcode": "D",
    "dropkey": "BY11870",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "22681 WOODWARD AVE",
    "dropdelcty": "FERNDALE",
    "dropdelst": "MI",
    "dropdelzpp": 482209998,
    "dropphyadd": "22681 WOODWARD AVE",
    "dropphycty": "FERNDALE",
    "dropphyst": "MI",
    "dropphyzpp": 482209998,
    "dropmaladd": "22681 WOODWARD AVE",
    "dropmalcty": "FERNDALE",
    "dropmalst": "MI",
    "dropmalzpp": 482209998,
    "dropsitphn": 3132268558,
    "dropsitlph": 2485410625,
    "dropsitcph": 2485421226,
    "dropfax": 3138638890
  },
  {
    "dcode": "D",
    "dropkey": "BY11911",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "32406 FRANKLIN RD",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MI",
    "dropdelzpp": 480259998,
    "dropphyadd": "32406 FRANKLIN RD",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MI",
    "dropphyzpp": 480259998,
    "dropmaladd": "32406 FRANKLIN RD",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MI",
    "dropmalzpp": 480259998,
    "dropsitphn": 2483682977,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483682977,
    "dropfax": 2483682955
  },
  {
    "dcode": "D",
    "dropkey": "BY12011",
    "droptype": "D",
    "dropname": "GROSSE POINTE",
    "dropdeladd": "18640 MACK AVE",
    "dropdelcty": "GROSSE POINTE FARMS",
    "dropdelst": "MI",
    "dropdelzpp": 482369998,
    "dropphyadd": "18640 MACK AVE",
    "dropphycty": "GROSSE POINTE FARMS",
    "dropphyst": "MI",
    "dropphyzpp": 482369998,
    "dropmaladd": "18640 MACK AVE",
    "dropmalcty": "GROSSE POINTE FARMS",
    "dropmalst": "MI",
    "dropmalzpp": 482369998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3138844255,
    "dropsitcph": 3138848146,
    "dropfax": 3138842522
  },
  {
    "dcode": "D",
    "dropkey": "BY12028",
    "droptype": "D",
    "dropname": "HAMTRAMCK",
    "dropdeladd": "2933 CANIFF ST",
    "dropdelcty": "HAMTRAMCK",
    "dropdelst": "MI",
    "dropdelzpp": 482129998,
    "dropphyadd": "2933 CANIFF ST",
    "dropphycty": "HAMTRAMCK",
    "dropphyst": "MI",
    "dropphyzpp": 482129998,
    "dropmaladd": "2933 CANIFF ST",
    "dropmalcty": "HAMTRAMCK",
    "dropmalst": "MI",
    "dropmalzpp": 482129998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3138919819,
    "dropsitcph": 3138919819,
    "dropfax": 3138913154
  },
  {
    "dcode": "D",
    "dropkey": "BY12073",
    "droptype": "D",
    "dropname": "HIGHLAND PARK",
    "dropdeladd": "13215 WOODWARD AVE",
    "dropdelcty": "HIGHLAND PARK",
    "dropdelst": "MI",
    "dropdelzpp": 482039998,
    "dropphyadd": "13215 WOODWARD AVE",
    "dropphycty": "HIGHLAND PARK",
    "dropphyst": "MI",
    "dropphyzpp": 482039998,
    "dropmaladd": "13215 WOODWARD AVE",
    "dropmalcty": "HIGHLAND PARK",
    "dropmalst": "MI",
    "dropmalzpp": 482039998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138832479,
    "dropfax": 3138839619
  },
  {
    "dcode": "D",
    "dropkey": "BY12173",
    "droptype": "D",
    "dropname": "KENTWOOD",
    "dropdeladd": "1680 44TH ST SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495089998,
    "dropphyadd": "1680 44TH ST SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495089998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6164553301,
    "dropsitcph": 6164553301,
    "dropfax": 6164553120
  },
  {
    "dcode": "D",
    "dropkey": "BY12180",
    "droptype": "D",
    "dropname": "KINCHELOE",
    "dropdeladd": "4800 W M 80",
    "dropdelcty": "KINCHELOE",
    "dropdelst": "MI",
    "dropdelzpp": 497881645,
    "dropphyadd": "4800 W M 80",
    "dropphycty": "KINCHELOE",
    "dropphyst": "MI",
    "dropphyzpp": 497881645,
    "dropmaladd": "4800 W M 80",
    "dropmalcty": "KINCHELOE",
    "dropmalst": "MI",
    "dropmalzpp": 497889998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064955347,
    "dropsitcph": 9064955347,
    "dropfax": 9064955922
  },
  {
    "dcode": "D",
    "dropkey": "BY12189",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "3985 S OTTER CREEK RD",
    "dropdelcty": "LA SALLE",
    "dropdelst": "MI",
    "dropdelzpp": 481459998,
    "dropphyadd": "3985 S OTTER CREEK RD",
    "dropphycty": "LA SALLE",
    "dropphyst": "MI",
    "dropphyzpp": 481459998,
    "dropmaladd": "3985 S OTTER CREEK RD",
    "dropmalcty": "LA SALLE",
    "dropmalst": "MI",
    "dropmalzpp": 481459998,
    "dropsitphn": 7342430473,
    "dropsitlph": 3132268554,
    "dropsitcph": 7342430473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY12223",
    "droptype": "D",
    "dropname": "LATHRUP VILLAGE",
    "dropdeladd": "28211 SOUTHFIELD RD",
    "dropdelcty": "LATHRUP VILLAGE",
    "dropdelst": "MI",
    "dropdelzpp": 480769998,
    "dropphyadd": "28211 SOUTHFIELD RD",
    "dropphycty": "LATHRUP VILLAGE",
    "dropphyst": "MI",
    "dropphyzpp": 480769998,
    "dropmaladd": "28211 SOUTHFIELD RD",
    "dropmalcty": "LATHRUP VILLAGE",
    "dropmalst": "MI",
    "dropmalzpp": 480769998,
    "dropsitphn": 2483682977,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483682977,
    "dropfax": 2483682955
  },
  {
    "dcode": "D",
    "dropkey": "BY12224",
    "droptype": "D",
    "dropname": "LAURIUM",
    "dropdeladd": "75 3RD ST",
    "dropdelcty": "LAURIUM",
    "dropdelst": "MI",
    "dropdelzpp": 499132120,
    "dropphyadd": "75 3RD ST",
    "dropphycty": "LAURIUM",
    "dropphyst": "MI",
    "dropphyzpp": 499132120,
    "dropmaladd": "201 6TH ST",
    "dropmalcty": "CALUMET",
    "dropmalst": "MI",
    "dropmalzpp": 499139998,
    "dropsitphn": 4142912520,
    "dropsitlph": 9063373210,
    "dropsitcph": 9063373210,
    "dropfax": 9063370104
  },
  {
    "dcode": "D",
    "dropkey": "BY12276",
    "droptype": "D",
    "dropname": "LUNA PIER",
    "dropdeladd": "4352 LUNA PIER RD",
    "dropdelcty": "LUNA PIER",
    "dropdelst": "MI",
    "dropdelzpp": 481579998,
    "dropphyadd": "4352 LUNA PIER RD",
    "dropphycty": "LUNA PIER",
    "dropphyst": "MI",
    "dropphyzpp": 481579998,
    "dropmaladd": "4352 LUNA PIER RD",
    "dropmalcty": "LUNA PIER",
    "dropmalst": "MI",
    "dropmalzpp": 481579998,
    "dropsitphn": 7348489994,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348489994,
    "dropfax": 7348483397
  },
  {
    "dcode": "D",
    "dropkey": "BY12296",
    "droptype": "D",
    "dropname": "MADISON HEIGHTS",
    "dropdeladd": "29441 JOHN R RD",
    "dropdelcty": "MADISON HEIGHTS",
    "dropdelst": "MI",
    "dropdelzpp": 480719991,
    "dropphyadd": "29441 JOHN R RD",
    "dropphycty": "MADISON HEIGHTS",
    "dropphyst": "MI",
    "dropphyzpp": 480719991,
    "dropmaladd": "200 W 2ND ST",
    "dropmalcty": "ROYAL OAK",
    "dropmalst": "MI",
    "dropmalzpp": 480689998,
    "dropsitphn": 2485895143,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485472975,
    "dropfax": 2485481257
  },
  {
    "dcode": "D",
    "dropkey": "BY12326",
    "droptype": "D",
    "dropname": "MAYBEE",
    "dropdeladd": "7580 MILL ST",
    "dropdelcty": "MAYBEE",
    "dropdelst": "MI",
    "dropdelzpp": 481599998,
    "dropphyadd": "7580 MILL ST",
    "dropphycty": "MAYBEE",
    "dropphyst": "MI",
    "dropphyzpp": 481599998,
    "dropmaladd": "7580 MILL ST",
    "dropmalcty": "MAYBEE",
    "dropmalst": "MI",
    "dropmalzpp": 481599998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7345872595,
    "dropsitcph": 7345872595,
    "dropfax": 7342436919
  },
  {
    "dcode": "D",
    "dropkey": "BY12352",
    "droptype": "D",
    "dropname": "MELVINDALE",
    "dropdeladd": "17081 ALLEN RD",
    "dropdelcty": "MELVINDALE",
    "dropdelst": "MI",
    "dropdelzpp": 481229998,
    "dropphyadd": "17081 ALLEN RD",
    "dropphycty": "MELVINDALE",
    "dropphyst": "MI",
    "dropphyzpp": 481229998,
    "dropmaladd": "17081 ALLEN RD",
    "dropmalcty": "MELVINDALE",
    "dropmalst": "MI",
    "dropmalzpp": 481229998,
    "dropsitphn": 3133822304,
    "dropsitlph": 3132268554,
    "dropsitcph": 3132947000,
    "dropfax": 3133374770
  },
  {
    "dcode": "D",
    "dropkey": "BY12427",
    "droptype": "D",
    "dropname": "MUSKEGON HEIGHTS",
    "dropdeladd": "2517 PECK ST",
    "dropdelcty": "MUSKEGON",
    "dropdelst": "MI",
    "dropdelzpp": 494449998,
    "dropphyadd": "2517 PECK ST",
    "dropphycty": "MUSKEGON",
    "dropphyst": "MI",
    "dropphyzpp": 494449998,
    "dropmaladd": "2517 PECK ST",
    "dropmalcty": "MUSKEGON",
    "dropmalst": "MI",
    "dropmalzpp": 494449998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317227292,
    "dropsitcph": 2317332434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY12460",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "8463 SWAN CREEK RD",
    "dropdelcty": "NEWPORT",
    "dropdelst": "MI",
    "dropdelzpp": 481669998,
    "dropphyadd": "8463 SWAN CREEK RD",
    "dropphycty": "NEWPORT",
    "dropphyst": "MI",
    "dropphyzpp": 481669998,
    "dropmaladd": "8463 SWAN CREEK RD",
    "dropmalcty": "NEWPORT",
    "dropmalst": "MI",
    "dropmalzpp": 481669998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7345863003,
    "dropsitcph": 7345863003,
    "dropfax": 7345863951
  },
  {
    "dcode": "D",
    "dropkey": "BY12471",
    "droptype": "D",
    "dropname": "NORTH MUSKEGON",
    "dropdeladd": "404 CENTER ST",
    "dropdelcty": "MUSKEGON",
    "dropdelst": "MI",
    "dropdelzpp": 494452488,
    "dropphyadd": "404 CENTER ST",
    "dropphycty": "MUSKEGON",
    "dropphyst": "MI",
    "dropphyzpp": 494452488,
    "dropmaladd": "404 CENTER ST",
    "dropmalcty": "MUSKEGON",
    "dropmalst": "MI",
    "dropmalzpp": 494452488,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317441489,
    "dropsitcph": 2317441489,
    "dropfax": 2317447082
  },
  {
    "dcode": "D",
    "dropkey": "BY12475",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "4465 DAVISON RD",
    "dropdelcty": "BURTON",
    "dropdelst": "MI",
    "dropdelzpp": 485099998,
    "dropphyadd": "4465 DAVISON RD",
    "dropphycty": "BURTON",
    "dropphyst": "MI",
    "dropphyzpp": 485099998,
    "dropmaladd": "4465 DAVISON RD",
    "dropmalcty": "BURTON",
    "dropmalst": "MI",
    "dropmalzpp": 485099998,
    "dropsitphn": 8107421580,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107421580,
    "dropfax": 8107426918
  },
  {
    "dcode": "D",
    "dropkey": "BY12484",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "3274 W PASADENA AVE",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485049998,
    "dropphyadd": "3274 W PASADENA AVE",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485049998,
    "dropmaladd": "3274 W PASADENA AVE",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485049998,
    "dropsitphn": 8107336681,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107336681,
    "dropfax": 8107332009
  },
  {
    "dcode": "D",
    "dropkey": "BY12496",
    "droptype": "D",
    "dropname": "OAK PARK",
    "dropdeladd": "14200 W 8 MILE RD",
    "dropdelcty": "OAK PARK",
    "dropdelst": "MI",
    "dropdelzpp": 482379998,
    "dropphyadd": "14200 W 8 MILE RD",
    "dropphycty": "OAK PARK",
    "dropphyst": "MI",
    "dropphyzpp": 482379998,
    "dropmaladd": "14200 W 8 MILE RD",
    "dropmalcty": "OAK PARK",
    "dropmalst": "MI",
    "dropmalzpp": 482379998,
    "dropsitphn": 2489683044,
    "dropsitlph": 3132268554,
    "dropsitcph": 2489683085,
    "dropfax": 2489689788
  },
  {
    "dcode": "D",
    "dropkey": "BY12519",
    "droptype": "D",
    "dropname": "ORCHARD LAKE",
    "dropdeladd": "3735 COMMERCE RD",
    "dropdelcty": "ORCHARD LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 483249998,
    "dropphyadd": "3735 COMMERCE RD",
    "dropphycty": "ORCHARD LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 483249998,
    "dropmaladd": "3735 COMMERCE RD",
    "dropmalcty": "ORCHARD LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 483249998,
    "dropsitphn": 2484574034,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483384511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY12547",
    "droptype": "D",
    "dropname": "PARCHMENT",
    "dropdeladd": "839 COMMERCE LN",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490049998,
    "dropphyadd": "839 COMMERCE LN",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490049998,
    "dropmaladd": "839 COMMERCE LN",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490049998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693887296,
    "dropsitcph": 2693887297,
    "dropfax": 2693887201
  },
  {
    "dcode": "D",
    "dropkey": "BY12555",
    "droptype": "D",
    "dropname": "PEARL BEACH",
    "dropdeladd": "9664 PEARL BEACH BLVD",
    "dropdelcty": "ALGONAC",
    "dropdelst": "MI",
    "dropdelzpp": 480014253,
    "dropphyadd": "9664 PEARL BEACH BLVD",
    "dropphycty": "ALGONAC",
    "dropphyst": "MI",
    "dropphyzpp": 480014253,
    "dropmaladd": "9664 PEARL BEACH BLVD",
    "dropmalcty": "ALGONAC",
    "dropmalst": "MI",
    "dropmalzpp": 480014253,
    "dropsitphn": 2484574034,
    "dropsitlph": 2487585622,
    "dropsitcph": 8107943213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY12641",
    "droptype": "D",
    "dropname": "REDFORD",
    "dropdeladd": "12245 BEECH DALY RD",
    "dropdelcty": "REDFORD",
    "dropdelst": "MI",
    "dropdelzpp": 482399998,
    "dropphyadd": "12245 BEECH DALY RD",
    "dropphycty": "REDFORD",
    "dropphyst": "MI",
    "dropphyzpp": 482399998,
    "dropmaladd": "12245 BEECH DALY RD",
    "dropmalcty": "REDFORD",
    "dropmalst": "MI",
    "dropmalzpp": 482399998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3139371242,
    "dropfax": 3139372707
  },
  {
    "dcode": "D",
    "dropkey": "BY12666",
    "droptype": "D",
    "dropname": "RIVER ROUGE",
    "dropdeladd": "10455 W JEFFERSON AVE",
    "dropdelcty": "RIVER ROUGE",
    "dropdelst": "MI",
    "dropdelzpp": 482189998,
    "dropphyadd": "10455 W JEFFERSON AVE",
    "dropphycty": "RIVER ROUGE",
    "dropphyst": "MI",
    "dropphyzpp": 482189998,
    "dropmaladd": "10455 W JEFFERSON AVE",
    "dropmalcty": "RIVER ROUGE",
    "dropmalst": "MI",
    "dropmalzpp": 482189998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138431795,
    "dropfax": 3138417290
  },
  {
    "dcode": "D",
    "dropkey": "BY12669",
    "droptype": "D",
    "dropname": "RIVERVIEW",
    "dropdeladd": "18231 CIVIC PARK DR",
    "dropdelcty": "RIVERVIEW",
    "dropdelst": "MI",
    "dropdelzpp": 481939998,
    "dropphyadd": "18231 CIVIC PARK DR",
    "dropphycty": "RIVERVIEW",
    "dropphyst": "MI",
    "dropphyzpp": 481939998,
    "dropmaladd": "18231 CIVIC PARK DR",
    "dropmalcty": "RIVERVIEW",
    "dropmalst": "MI",
    "dropmalzpp": 481939998,
    "dropsitphn": 7342817773,
    "dropsitlph": 2262268554,
    "dropsitcph": 7342817773,
    "dropfax": 7342851863
  },
  {
    "dcode": "D",
    "dropkey": "BY12672",
    "droptype": "D",
    "dropname": "ROCHESTER HILLS",
    "dropdeladd": "2632 S ROCHESTER RD",
    "dropdelcty": "ROCHESTER HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483079998,
    "dropphyadd": "2632 S ROCHESTER RD",
    "dropphycty": "ROCHESTER HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483079998,
    "dropmaladd": "1936 ROCHESTER INDUSTRIAL LN",
    "dropmalcty": "ROCHESTER HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483099998,
    "dropsitphn": 2486011011,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486011011,
    "dropfax": 2486517420
  },
  {
    "dcode": "D",
    "dropkey": "BY12758",
    "droptype": "D",
    "dropname": "SELFRIDGE ANGB",
    "dropdeladd": "44580 N JEFFERSON AVE",
    "dropdelcty": "SELFRIDGE ANGB",
    "dropdelst": "MI",
    "dropdelzpp": 480459998,
    "dropphyadd": "44580 N JEFFERSON AVE",
    "dropphycty": "SELFRIDGE ANGB",
    "dropphyst": "MI",
    "dropphyzpp": 480459998,
    "dropmaladd": "155 S MAIN ST",
    "dropmalcty": "MOUNT CLEMENS",
    "dropmalst": "MI",
    "dropmalzpp": 480469998,
    "dropsitphn": 2484574034,
    "dropsitlph": 2487585622,
    "dropsitcph": 5864681760,
    "dropfax": 5864684960
  },
  {
    "dcode": "D",
    "dropkey": "BY12769",
    "droptype": "D",
    "dropname": "SHELBY TOWNSHIP",
    "dropdeladd": "7755 22 MILE RD",
    "dropdelcty": "SHELBY TOWNSHIP",
    "dropdelst": "MI",
    "dropdelzpp": 483179992,
    "dropphyadd": "7755 22 MILE RD",
    "dropphycty": "SHELBY TOWNSHIP",
    "dropphyst": "MI",
    "dropphyzpp": 483179992,
    "dropmaladd": "7755 22 MILE RD",
    "dropmalcty": "SHELBY TOWNSHIP",
    "dropmalst": "MI",
    "dropmalzpp": 483179992,
    "dropsitphn": 5869832359,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867319613,
    "dropfax": 5867318703
  },
  {
    "dcode": "D",
    "dropkey": "BY12812",
    "droptype": "D",
    "dropname": "SOUTHEAST",
    "dropdeladd": "4065 MANOR DR",
    "dropdelcty": "BURTON",
    "dropdelst": "MI",
    "dropdelzpp": 485199998,
    "dropphyadd": "4065 MANOR DR",
    "dropphycty": "BURTON",
    "dropphyst": "MI",
    "dropphyzpp": 485199998,
    "dropmaladd": "4065 MANOR DR",
    "dropmalcty": "BURTON",
    "dropmalst": "MI",
    "dropmalzpp": 485199998,
    "dropsitphn": 8107432200,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107432200,
    "dropfax": 8107437455
  },
  {
    "dcode": "D",
    "dropkey": "BY12815",
    "droptype": "D",
    "dropname": "SOUTHGATE",
    "dropdeladd": "14000 DIX TOLEDO RD",
    "dropdelcty": "SOUTHGATE",
    "dropdelst": "MI",
    "dropdelzpp": 481959998,
    "dropphyadd": "14000 DIX TOLEDO RD",
    "dropphycty": "SOUTHGATE",
    "dropphyst": "MI",
    "dropphyzpp": 481959998,
    "dropmaladd": "14000 DIX TOLEDO RD",
    "dropmalcty": "SOUTHGATE",
    "dropmalst": "MI",
    "dropmalzpp": 481959998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7342838115,
    "dropsitcph": 7342838115,
    "dropfax": 7342827457
  },
  {
    "dcode": "D",
    "dropkey": "BY12936",
    "droptype": "D",
    "dropname": "STERLING HEIGHTS",
    "dropdeladd": "7007 METROPOLITAN PKWY",
    "dropdelcty": "STERLING HEIGHTS",
    "dropdelst": "MI",
    "dropdelzpp": 483119998,
    "dropphyadd": "7007 METROPOLITAN PKWY",
    "dropphycty": "STERLING HEIGHTS",
    "dropphyst": "MI",
    "dropphyzpp": 483119998,
    "dropmaladd": "7007 METROPOLITAN PKWY",
    "dropmalcty": "STERLING HEIGHTS",
    "dropmalst": "MI",
    "dropmalzpp": 483119998,
    "dropsitphn": 5869832359,
    "dropsitlph": 2487585622,
    "dropsitcph": 5869832359,
    "dropfax": 5862682055
  },
  {
    "dcode": "D",
    "dropkey": "BY13085",
    "droptype": "D",
    "dropname": "WEQUETONSING",
    "dropdeladd": "15 2ND AVE",
    "dropdelcty": "HARBOR SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 497409807,
    "dropphyadd": "15 2ND AVE",
    "dropphycty": "HARBOR SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 497409807,
    "dropmaladd": "250 STATE ST",
    "dropmalcty": "HARBOR SPRINGS",
    "dropmalst": "MI",
    "dropmalzpp": 497409998,
    "dropsitphn": 6167761516,
    "dropsitlph": "",
    "dropsitcph": 6165262521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY13086",
    "droptype": "D",
    "dropname": "WEST BLOOMFIELD",
    "dropdeladd": "6725 DALY RD",
    "dropdelcty": "WEST BLOOMFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 483223421,
    "dropphyadd": "6725 DALY RD",
    "dropphycty": "WEST BLOOMFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 483223421,
    "dropmaladd": "6725 DALY RD",
    "dropmalcty": "WEST BLOOMFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 483223421,
    "dropsitphn": 2486269875,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486269875,
    "dropfax": 2486268340
  },
  {
    "dcode": "D",
    "dropkey": "BY13091",
    "droptype": "D",
    "dropname": "WESTLAND",
    "dropdeladd": "6300 N WAYNE RD",
    "dropdelcty": "WESTLAND",
    "dropdelst": "MI",
    "dropdelzpp": 481859998,
    "dropphyadd": "6300 N WAYNE RD",
    "dropphycty": "WESTLAND",
    "dropphyst": "MI",
    "dropphyzpp": 481859998,
    "dropmaladd": "6300 N WAYNE RD",
    "dropmalcty": "WESTLAND",
    "dropmalst": "MI",
    "dropmalzpp": 481859998,
    "dropsitphn": 7343260372,
    "dropsitlph": 3132268554,
    "dropsitcph": 7343260372,
    "dropfax": 7343263071
  },
  {
    "dcode": "D",
    "dropkey": "BY13094",
    "droptype": "D",
    "dropname": "BOARDWALK",
    "dropdeladd": "3193 BOARDWALK DR",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486032363,
    "dropphyadd": "3193 BOARDWALK DR",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486032363,
    "dropmaladd": "3193 BOARDWALK DR",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486032363,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715798,
    "dropsitcph": 9897715798,
    "dropfax": 9897991466
  },
  {
    "dcode": "D",
    "dropkey": "BY13096",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "167 N DRAKE RD",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490099998,
    "dropphyadd": "167 N DRAKE RD",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490099998,
    "dropmaladd": "167 N DRAKE RD",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693437425,
    "dropsitcph": 2693437425,
    "dropfax": 2693437672
  },
  {
    "dcode": "D",
    "dropkey": "BY13131",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "2929 MICHAEL AVE SW",
    "dropdelcty": "WYOMING",
    "dropdelst": "MI",
    "dropdelzpp": 495099998,
    "dropphyadd": "2929 MICHAEL AVE SW",
    "dropphycty": "WYOMING",
    "dropphyst": "MI",
    "dropphyzpp": 495099998,
    "dropmaladd": "2929 MICHAEL AVE SW",
    "dropmalcty": "WYOMING",
    "dropmalst": "MI",
    "dropmalzpp": 495099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6165322218,
    "dropsitcph": 6165322218,
    "dropfax": 6165319235
  },
  {
    "dcode": "D",
    "dropkey": "BY13339",
    "droptype": "D",
    "dropname": "BYRAM",
    "dropdeladd": "5654 TERRY RD",
    "dropdelcty": "BYRAM",
    "dropdelst": "MS",
    "dropdelzpp": 392729998,
    "dropphyadd": "5654 TERRY RD",
    "dropphycty": "BYRAM",
    "dropphyst": "MS",
    "dropphyzpp": 392729998,
    "dropmaladd": "5654 TERRY RD",
    "dropmalcty": "BYRAM",
    "dropmalst": "MS",
    "dropmalzpp": 392729998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015022311,
    "dropsitcph": 6015022311,
    "dropfax": 6015022310
  },
  {
    "dcode": "D",
    "dropkey": "BY13844",
    "droptype": "D",
    "dropname": "KREOLE",
    "dropdeladd": "4913 KREOLE AVE",
    "dropdelcty": "MOSS POINT",
    "dropdelst": "MS",
    "dropdelzpp": 395633534,
    "dropphyadd": "4913 KREOLE AVE",
    "dropphycty": "MOSS POINT",
    "dropphyst": "MS",
    "dropphyzpp": 395633534,
    "dropmaladd": "4913 KREOLE AVE",
    "dropmalcty": "MOSS POINT",
    "dropmalst": "MS",
    "dropmalzpp": 395633534,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2284758528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY14053",
    "droptype": "D",
    "dropname": "MOSS POINT",
    "dropdeladd": "4537 BOWEN ST",
    "dropdelcty": "MOSS POINT",
    "dropdelst": "MS",
    "dropdelzpp": 395639998,
    "dropphyadd": "4537 BOWEN ST",
    "dropphycty": "MOSS POINT",
    "dropphyst": "MS",
    "dropphyzpp": 395639998,
    "dropmaladd": "4537 BOWEN ST",
    "dropmalcty": "MOSS POINT",
    "dropmalst": "MS",
    "dropmalzpp": 395639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2282716002,
    "dropsitcph": 2284755621,
    "dropfax": 2284749939
  },
  {
    "dcode": "D",
    "dropkey": "BY14120",
    "droptype": "D",
    "dropname": "NORTH BAY DIBERVILLE",
    "dropdeladd": "356 GINGER DR",
    "dropdelcty": "DIBERVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 395409998,
    "dropphyadd": "356 GINGER DR",
    "dropphycty": "DIBERVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 395409998,
    "dropmaladd": "356 GINGER DR",
    "dropmalcty": "DIBERVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 395409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2283923245,
    "dropsitcph": 2283927210,
    "dropfax": 2283922762
  },
  {
    "dcode": "D",
    "dropkey": "BY14184",
    "droptype": "D",
    "dropname": "PEARL",
    "dropdeladd": "2300 HIGHWAY 80 E",
    "dropdelcty": "PEARL",
    "dropdelst": "MS",
    "dropdelzpp": 392089998,
    "dropphyadd": "2300 HIGHWAY 80 E",
    "dropphycty": "PEARL",
    "dropphyst": "MS",
    "dropphyzpp": 392089998,
    "dropmaladd": "2300 HIGHWAY 80 E",
    "dropmalcty": "PEARL",
    "dropmalst": "MS",
    "dropmalzpp": 392089998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6016640369,
    "dropsitcph": 6016640117,
    "dropfax": 6019397406
  },
  {
    "dcode": "D",
    "dropkey": "BY14298",
    "droptype": "D",
    "dropname": "RESERVOIR",
    "dropdeladd": "610 GRANTS FERRY RD",
    "dropdelcty": "BRANDON",
    "dropdelst": "MS",
    "dropdelzpp": 390479998,
    "dropphyadd": "610 GRANTS FERRY RD",
    "dropphycty": "BRANDON",
    "dropphyst": "MS",
    "dropphyzpp": 390479998,
    "dropmaladd": "610 GRANTS FERRY RD",
    "dropmalcty": "BRANDON",
    "dropmalst": "MS",
    "dropmalzpp": 390479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019923950,
    "dropsitcph": 6019926874,
    "dropfax": 6019926502
  },
  {
    "dcode": "D",
    "dropkey": "BY14304",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "366 SCARBROUGH ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "MS",
    "dropdelzpp": 392189998,
    "dropphyadd": "366 SCARBROUGH ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "MS",
    "dropphyzpp": 392189998,
    "dropmaladd": "366 SCARBROUGH ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "MS",
    "dropmalzpp": 392189998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016641656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY14564",
    "droptype": "D",
    "dropname": "VANCLEAVE",
    "dropdeladd": "12401 HIGHWAY 57",
    "dropdelcty": "VANCLEAVE",
    "dropdelst": "MS",
    "dropdelzpp": 395659998,
    "dropphyadd": "12401 HIGHWAY 57",
    "dropphycty": "VANCLEAVE",
    "dropphyst": "MS",
    "dropphyzpp": 395659998,
    "dropmaladd": "12401 HIGHWAY 57",
    "dropmalcty": "VANCLEAVE",
    "dropmalst": "MS",
    "dropmalzpp": 395659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2288264865,
    "dropfax": 2288265496
  },
  {
    "dcode": "D",
    "dropkey": "BY14701",
    "droptype": "D",
    "dropname": "AMF GREENSBORO",
    "dropdeladd": "6321 BRYAN BLVD STE G",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274099437,
    "dropphyadd": "6321 BRYAN BLVD STE G",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274099437,
    "dropmaladd": "PO BOX 27425",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362929345,
    "dropfax": 3366659681
  },
  {
    "dcode": "D",
    "dropkey": "BY14718",
    "droptype": "D",
    "dropname": "ARCHDALE",
    "dropdeladd": "10193 N MAIN ST",
    "dropdelcty": "ARCHDALE",
    "dropdelst": "NC",
    "dropdelzpp": 272633410,
    "dropphyadd": "10193 N MAIN ST",
    "dropphycty": "ARCHDALE",
    "dropphyst": "NC",
    "dropphyzpp": 272633410,
    "dropmaladd": "10193 N MAIN ST",
    "dropmalcty": "ARCHDALE",
    "dropmalst": "NC",
    "dropmalzpp": 272633410,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364310513,
    "dropfax": 3364312203
  },
  {
    "dcode": "D",
    "dropkey": "BY14939",
    "droptype": "D",
    "dropname": "CAMP LEJEUNE",
    "dropdeladd": "1770 MCHUGH BLVD",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285475000,
    "dropphyadd": "1770 MCHUGH BLVD",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285475000,
    "dropmaladd": "PO BOX 28547",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285479998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105775570,
    "dropsitcph": 9105775570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY15343",
    "droptype": "D",
    "dropname": "FORT BRAGG",
    "dropdeladd": "1605 ROCK MERRITT AVE",
    "dropdelcty": "FORT BRAGG",
    "dropdelst": "NC",
    "dropdelzpp": 283075001,
    "dropphyadd": "1605 ROCK MERRITT AVE",
    "dropphycty": "FORT BRAGG",
    "dropphyst": "NC",
    "dropphyzpp": 283075001,
    "dropmaladd": "1605 ROCK MERRITT AVE",
    "dropmalcty": "FORT BRAGG",
    "dropmalst": "NC",
    "dropmalzpp": 283075001,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104361100,
    "dropsitcph": 9104232309,
    "dropfax": 9104360114
  },
  {
    "dcode": "D",
    "dropkey": "BY15411",
    "droptype": "D",
    "dropname": "GLEN RAVEN",
    "dropdeladd": "1910 W WEBB AVE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 272171074,
    "dropphyadd": "1910 W WEBB AVE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 272171074,
    "dropmaladd": "1910 W WEBB AVE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 272171074,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362274293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY15879",
    "droptype": "D",
    "dropname": "MCCUTCHEON FIELD",
    "dropdeladd": "234 CURTIS RD",
    "dropdelcty": "MCAS NEW RIVER",
    "dropdelst": "NC",
    "dropdelzpp": 285455002,
    "dropphyadd": "234 CURTIS RD",
    "dropphycty": "MCAS NEW RIVER",
    "dropphyst": "NC",
    "dropphyzpp": 285455002,
    "dropmaladd": "PO BOX 28540",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285409998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104496397,
    "dropsitcph": 9104496397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY16019",
    "droptype": "D",
    "dropname": "NEUSE",
    "dropdeladd": "6320 CAPITAL BLVD STE 120",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276163017,
    "dropphyadd": "6320 CAPITAL BLVD STE 120",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276163017,
    "dropmaladd": "6320 CAPITAL BLVD STE 120",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276163017,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198788525,
    "dropfax": 9198788089
  },
  {
    "dcode": "D",
    "dropkey": "BY16020",
    "droptype": "D",
    "dropname": "NEUSE FOREST",
    "dropdeladd": "1620 OLD CHERRY POINT RD",
    "dropdelcty": "NEW BERN",
    "dropdelst": "NC",
    "dropdelzpp": 285609702,
    "dropphyadd": "1620 OLD CHERRY POINT RD",
    "dropphycty": "NEW BERN",
    "dropphyst": "NC",
    "dropphyzpp": 285609702,
    "dropmaladd": "1620 OLD CHERRY POINT RD",
    "dropmalcty": "NEW BERN",
    "dropmalst": "NC",
    "dropmalzpp": 285609702,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 2526386418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY16269",
    "droptype": "D",
    "dropname": "RDU INTERNATIONAL AMF",
    "dropdeladd": "2600 W TERMINAL BLVD",
    "dropdelcty": "CARY",
    "dropdelst": "NC",
    "dropdelzpp": 275199996,
    "dropphyadd": "2600 W TERMINAL BLVD",
    "dropphycty": "CARY",
    "dropphyst": "NC",
    "dropphyzpp": 275199996,
    "dropmaladd": "2600 W TERMINAL BLVD",
    "dropmalcty": "CARY",
    "dropmalst": "NC",
    "dropmalzpp": 275199996,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198400824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY16288",
    "droptype": "D",
    "dropname": "RESEARCH TRIANGLE PARK",
    "dropdeladd": "65 TW ALEXANDER DR",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277090962,
    "dropphyadd": "65 TW ALEXANDER DR",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277090962,
    "dropmaladd": "65 TW ALEXANDER DR",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277099998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195499637,
    "dropfax": 9198062108
  },
  {
    "dcode": "D",
    "dropkey": "BY16466",
    "droptype": "D",
    "dropname": "SOUTH BRUNSWICK",
    "dropdeladd": "1587 SEASIDE RD SW",
    "dropdelcty": "OCEAN ISLE BEACH",
    "dropdelst": "NC",
    "dropdelzpp": 284691029,
    "dropphyadd": "1587 SEASIDE RD SW",
    "dropphycty": "OCEAN ISLE BEACH",
    "dropphyst": "NC",
    "dropphyzpp": 284691029,
    "dropmaladd": "PO BOX 28469",
    "dropmalcty": "OCEAN ISLE BEACH",
    "dropmalst": "NC",
    "dropmalzpp": 284699998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105795202,
    "dropsitcph": 9105795202,
    "dropfax": 9105795201
  },
  {
    "dcode": "D",
    "dropkey": "BY16597",
    "droptype": "D",
    "dropname": "TARAWA TERRACE",
    "dropdeladd": "2463 IWO JIMA BLVD",
    "dropdelcty": "TARAWA TERRACE",
    "dropdelst": "NC",
    "dropdelzpp": 285431200,
    "dropphyadd": "2463 IWO JIMA BLVD",
    "dropphycty": "TARAWA TERRACE",
    "dropphyst": "NC",
    "dropphyzpp": 285431200,
    "dropmaladd": "PO BOX 28543",
    "dropmalcty": "TARAWA TERRACE",
    "dropmalst": "NC",
    "dropmalzpp": 285439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103531874,
    "dropsitcph": 9103531874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY16925",
    "droptype": "D",
    "dropname": "HANSEN ROAD",
    "dropdeladd": "790 HANSEN RD STE E",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "WI",
    "dropdelzpp": 543045124,
    "dropphyadd": "790 HANSEN RD STE E",
    "dropphycty": "GREEN BAY",
    "dropphyst": "WI",
    "dropphyzpp": 543045124,
    "dropmaladd": "PO BOX 28000",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "WI",
    "dropmalzpp": 543249998,
    "dropsitphn": 4142912520,
    "dropsitlph": 9204983892,
    "dropsitcph": 9204050665,
    "dropfax": 9204058203
  },
  {
    "dcode": "D",
    "dropkey": "BY17381",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "7353 W FOREST HOME AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532203491,
    "dropphyadd": "7353 W FOREST HOME AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532203491,
    "dropmaladd": "7353 W FOREST HOME AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4145458749,
    "dropsitcph": 4145458744,
    "dropfax": 4145457644
  },
  {
    "dcode": "D",
    "dropkey": "BY17669",
    "droptype": "D",
    "dropname": "MIDDLETON",
    "dropdeladd": "7613 ELMWOOD AVE",
    "dropdelcty": "MIDDLETON",
    "dropdelst": "WI",
    "dropdelzpp": 535623191,
    "dropphyadd": "7613 ELMWOOD AVE",
    "dropphycty": "MIDDLETON",
    "dropphyst": "WI",
    "dropphyzpp": 535623191,
    "dropmaladd": "7613 ELMWOOD AVE",
    "dropmalcty": "MIDDLETON",
    "dropmalst": "WI",
    "dropmalzpp": 535623191,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088312953,
    "dropsitcph": 6088315501,
    "dropfax": 6082461323
  },
  {
    "dcode": "D",
    "dropkey": "BY17692",
    "droptype": "D",
    "dropname": "MONONA",
    "dropdeladd": "112 OWEN RD",
    "dropdelcty": "MONONA",
    "dropdelst": "WI",
    "dropdelzpp": 537163553,
    "dropphyadd": "112 OWEN RD",
    "dropphycty": "MONONA",
    "dropphyst": "WI",
    "dropphyzpp": 537163553,
    "dropmaladd": "112 OWEN RD",
    "dropmalcty": "MONONA",
    "dropmalst": "WI",
    "dropmalzpp": 537163553,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082227776,
    "dropsitcph": 6082228184,
    "dropfax": 6082461323
  },
  {
    "dcode": "D",
    "dropkey": "BY17734",
    "droptype": "D",
    "dropname": "NEW BERLIN",
    "dropdeladd": "15300 W HOWARD AVE",
    "dropdelcty": "NEW BERLIN",
    "dropdelst": "WI",
    "dropdelzpp": 531519998,
    "dropphyadd": "15300 W HOWARD AVE",
    "dropphycty": "NEW BERLIN",
    "dropphyst": "WI",
    "dropphyzpp": 531519998,
    "dropmaladd": "15300 W HOWARD AVE",
    "dropmalcty": "NEW BERLIN",
    "dropmalst": "WI",
    "dropmalzpp": 531519998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2627972487,
    "dropsitcph": 2627972487,
    "dropfax": 2627978437
  },
  {
    "dcode": "D",
    "dropkey": "BY17760",
    "droptype": "D",
    "dropname": "NORTH SHORE",
    "dropdeladd": "5651 N LYDELL AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532174504,
    "dropphyadd": "5651 N LYDELL AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532174504,
    "dropmaladd": "5651 N LYDELL AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532174504,
    "dropsitphn": 4142702120,
    "dropsitlph": 4149629831,
    "dropsitcph": 4149623064,
    "dropfax": 4149625195
  },
  {
    "dcode": "D",
    "dropkey": "BY17921",
    "droptype": "D",
    "dropname": "ROOT RIVER",
    "dropdeladd": "11015 W OKLAHOMA AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532279998,
    "dropphyadd": "11015 W OKLAHOMA AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532279998,
    "dropmaladd": "11015 W OKLAHOMA AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4145458790,
    "dropsitcph": 4145458782,
    "dropfax": 4145451235
  },
  {
    "dcode": "D",
    "dropkey": "BY17981",
    "droptype": "D",
    "dropname": "SHOREWOOD",
    "dropdeladd": "1620 E CAPITOL DR",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532111960,
    "dropphyadd": "1620 E CAPITOL DR",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532111960,
    "dropmaladd": "1620 E CAPITOL DR",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532111960,
    "dropsitphn": 4142702120,
    "dropsitlph": 4143322241,
    "dropsitcph": 4143322241,
    "dropfax": 4143327794
  },
  {
    "dcode": "D",
    "dropkey": "BY18219",
    "droptype": "D",
    "dropname": "TUCKAWAY",
    "dropdeladd": "5114 S 27TH ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532219998,
    "dropphyadd": "5114 S 27TH ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532219998,
    "dropmaladd": "5114 S 27TH ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142821295,
    "dropsitcph": 4142821288,
    "dropfax": 4142823209
  },
  {
    "dcode": "D",
    "dropkey": "BY18240",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "100 ENTERPRISE DR",
    "dropdelcty": "VERONA",
    "dropdelst": "WI",
    "dropdelzpp": 535930900,
    "dropphyadd": "100 ENTERPRISE DR",
    "dropphycty": "VERONA",
    "dropphyst": "WI",
    "dropphyzpp": 535930900,
    "dropmaladd": "100 ENTERPRISE DR",
    "dropmalcty": "VERONA",
    "dropmalst": "WI",
    "dropmalzpp": 535930900,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088486879,
    "dropsitcph": 6088486885,
    "dropfax": 6088453056
  },
  {
    "dcode": "D",
    "dropkey": "BY18278",
    "droptype": "D",
    "dropname": "WAUWATOSA",
    "dropdeladd": "1655 N MAYFAIR RD",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532263018,
    "dropphyadd": "1655 N MAYFAIR RD",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532263018,
    "dropmaladd": "1655 N MAYFAIR RD",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142589217,
    "dropsitcph": 4142589210,
    "dropfax": 4142584927
  },
  {
    "dcode": "D",
    "dropkey": "BY18285",
    "droptype": "D",
    "dropname": "WEST ALLIS",
    "dropdeladd": "7440 W GREENFIELD AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532149998,
    "dropphyadd": "7440 W GREENFIELD AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532149998,
    "dropmaladd": "7440 W GREENFIELD AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532149998,
    "dropsitphn": 4142857964,
    "dropsitlph": 4142587964,
    "dropsitcph": 4142587387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY18291",
    "droptype": "D",
    "dropname": "WEST MILWAUKEE",
    "dropdeladd": "4300 W LINCOLN AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532195012,
    "dropphyadd": "4300 W LINCOLN AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532195012,
    "dropmaladd": "4300 W LINCOLN AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4146430338,
    "dropsitcph": 4146430443,
    "dropfax": 4146434449
  },
  {
    "dcode": "D",
    "dropkey": "BY18387",
    "droptype": "D",
    "dropname": "WESTGATE",
    "dropdeladd": "1 FLORETTA PL RM 208",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276769902,
    "dropphyadd": "1 FLORETTA PL RM 208",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276769902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276769998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205230,
    "dropfax": 9194205396
  },
  {
    "dcode": "D",
    "dropkey": "BY18493",
    "droptype": "D",
    "dropname": "BIRCHWOOD MALL",
    "dropdeladd": "4350 24TH AVE STE 324",
    "dropdelcty": "FORT GRATIOT",
    "dropdelst": "MI",
    "dropdelzpp": 480599998,
    "dropphyadd": "4350 24TH AVE STE 324",
    "dropphycty": "FORT GRATIOT",
    "dropphyst": "MI",
    "dropphyzpp": 480599998,
    "dropmaladd": "852 32ND ST",
    "dropmalcty": "PORT HURON",
    "dropmalst": "MI",
    "dropmalzpp": 480619998,
    "dropsitphn": 8109897900,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103857918,
    "dropfax": 8103857642
  },
  {
    "dcode": "D",
    "dropkey": "BY18633",
    "droptype": "D",
    "dropname": "BARLOW",
    "dropdeladd": "1756 BARLOW ST",
    "dropdelcty": "TRAVERSE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496865907,
    "dropphyadd": "1756 BARLOW ST",
    "dropphycty": "TRAVERSE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496865907,
    "dropmaladd": "1756 BARLOW ST",
    "dropmalcty": "TRAVERSE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496865907,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319465319,
    "dropsitcph": 2319465319,
    "dropfax": 2319466944
  },
  {
    "dcode": "D",
    "dropkey": "BY19184",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "9575 BRENWOOD PARK DR",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "WI",
    "dropdelzpp": 531329998,
    "dropphyadd": "9575 BRENWOOD PARK DR",
    "dropphycty": "FRANKLIN",
    "dropphyst": "WI",
    "dropphyzpp": 531329998,
    "dropmaladd": "9575 BRENWOOD PARK DR",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "WI",
    "dropmalzpp": 531329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144271416,
    "dropsitcph": 4144271414,
    "dropfax": 4144277094
  },
  {
    "dcode": "D",
    "dropkey": "BY20004",
    "droptype": "D",
    "dropname": "FPO",
    "dropdeladd": "11698 NW 25TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331129997,
    "dropphyadd": "11698 NW 25TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331129997,
    "dropmaladd": "11698 NW 25TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331129997,
    "dropsitphn": 3058713327,
    "dropsitlph": "",
    "dropsitcph": 3057187501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY20067",
    "droptype": "D",
    "dropname": "BARLING",
    "dropdeladd": "609 FORT ST",
    "dropdelcty": "BARLING",
    "dropdelst": "AR",
    "dropdelzpp": 729239998,
    "dropphyadd": "609 FORT ST",
    "dropphycty": "BARLING",
    "dropphyst": "AR",
    "dropphyzpp": 729239998,
    "dropmaladd": "609 FORT ST",
    "dropmalcty": "BARLING",
    "dropmalst": "AR",
    "dropmalzpp": 729239998,
    "dropsitphn": 4794846496,
    "dropsitlph": 4794527350,
    "dropsitcph": 4794527350,
    "dropfax": 4794849085
  },
  {
    "dcode": "D",
    "dropkey": "BY20093",
    "droptype": "D",
    "dropname": "BELLA VISTA",
    "dropdeladd": "555 MEMORIAL DR",
    "dropdelcty": "BELLA VISTA",
    "dropdelst": "AR",
    "dropdelzpp": 727149998,
    "dropphyadd": "555 MEMORIAL DR",
    "dropphycty": "BELLA VISTA",
    "dropphyst": "AR",
    "dropphyzpp": 727149998,
    "dropmaladd": "555 MEMORIAL DR",
    "dropmalcty": "BELLA VISTA",
    "dropmalst": "AR",
    "dropmalzpp": 727149998,
    "dropsitphn": 4798554823,
    "dropsitlph": 4798556121,
    "dropsitcph": 4798556121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY20347",
    "droptype": "D",
    "dropname": "EAST CAMDEN",
    "dropdeladd": "510 HIGHWAY 274",
    "dropdelcty": "CAMDEN",
    "dropdelst": "AR",
    "dropdelzpp": 717017385,
    "dropphyadd": "510 HIGHWAY 274",
    "dropphycty": "CAMDEN",
    "dropphyst": "AR",
    "dropphyzpp": 717017385,
    "dropmaladd": "510 HIGHWAY 274",
    "dropmalcty": "CAMDEN",
    "dropmalst": "AR",
    "dropmalzpp": 717017385,
    "dropsitphn": 8705741719,
    "dropsitlph": 8705741719,
    "dropsitcph": 8705741719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY20485",
    "droptype": "D",
    "dropname": "GRAVEL RIDGE",
    "dropdeladd": "7907 JACKSONVILLE CATO RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720762219,
    "dropphyadd": "7907 JACKSONVILLE CATO RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720762219,
    "dropmaladd": "7907 JACKSONVILLE CATO RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720762219,
    "dropsitphn": 5019821444,
    "dropsitlph": 5018349028,
    "dropsitcph": 5018349023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY20672",
    "droptype": "D",
    "dropname": "LAKE HAMILTON",
    "dropdeladd": "335 SECTION LINE RD",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139998,
    "dropphyadd": "335 SECTION LINE RD",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139943,
    "dropmaladd": "335 SECTION LINE RD",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5015250558,
    "dropsitcph": 5015250558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY20761",
    "droptype": "D",
    "dropname": "MAUMELLE",
    "dropdeladd": "501 COMMERCE DR",
    "dropdelcty": "MAUMELLE",
    "dropdelst": "AR",
    "dropdelzpp": 721139998,
    "dropphyadd": "501 COMMERCE DR",
    "dropphycty": "MAUMELLE",
    "dropphyst": "AR",
    "dropphyzpp": 721139998,
    "dropmaladd": "501 COMMERCE DR",
    "dropmalcty": "MAUMELLE",
    "dropmalst": "AR",
    "dropmalzpp": 721139998,
    "dropsitphn": 5018514929,
    "dropsitlph": 5018511608,
    "dropsitcph": 5018511608,
    "dropfax": 5018510152
  },
  {
    "dcode": "D",
    "dropkey": "BY21113",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "2300 WILDWOOD AVE",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "AR",
    "dropdelzpp": 721209998,
    "dropphyadd": "2300 WILDWOOD AVE",
    "dropphycty": "SHERWOOD",
    "dropphyst": "AR",
    "dropphyzpp": 721209998,
    "dropmaladd": "2300 WILDWOOD AVE",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "AR",
    "dropmalzpp": 721209998,
    "dropsitphn": 5018350609,
    "dropsitlph": 5018350609,
    "dropsitcph": 5018351451,
    "dropfax": 5018330037
  },
  {
    "dcode": "D",
    "dropkey": "BY21225",
    "droptype": "D",
    "dropname": "UNIV OF ARK AT MONTICELLO",
    "dropdeladd": "580 UNIVERSITY DR",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "AR",
    "dropdelzpp": 716558884,
    "dropphyadd": "580 UNIVERSITY DR",
    "dropphycty": "MONTICELLO",
    "dropphyst": "AR",
    "dropphyzpp": 716558884,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "AR",
    "dropmalzpp": 716569998,
    "dropsitphn": 8704601699,
    "dropsitlph": 8704601699,
    "dropsitcph": 8704601699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY21348",
    "droptype": "D",
    "dropname": "ALLANDALE",
    "dropdeladd": "201 COMMONWEALTH BLVD STE F",
    "dropdelcty": "PORT ORANGE",
    "dropdelst": "FL",
    "dropdelzpp": 321275575,
    "dropphyadd": "201 COMMONWEALTH BLVD STE F",
    "dropphycty": "PORT ORANGE",
    "dropphyst": "FL",
    "dropphyzpp": 321275575,
    "dropmaladd": "201 COMMONWEALTH BLVD STE F",
    "dropmalcty": "PORT ORANGE",
    "dropmalst": "FL",
    "dropmalzpp": 321275575,
    "dropsitphn": 9043592957,
    "dropsitlph": 3867615992,
    "dropsitcph": 3867615992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY21351",
    "droptype": "D",
    "dropname": "ALOMA",
    "dropdeladd": "221 DRIGGS DR",
    "dropdelcty": "WINTER PARK",
    "dropdelst": "FL",
    "dropdelzpp": 327929997,
    "dropphyadd": "221 DRIGGS DR",
    "dropphycty": "WINTER PARK",
    "dropphyst": "FL",
    "dropphyzpp": 327929997,
    "dropmaladd": "221 DRIGGS DR",
    "dropmalcty": "WINTER PARK",
    "dropmalst": "FL",
    "dropmalzpp": 327929997,
    "dropsitphn": 4076782188,
    "dropsitlph": 4076782188,
    "dropsitcph": 4076781230,
    "dropfax": 4076789255
  },
  {
    "dcode": "D",
    "dropkey": "BY21385",
    "droptype": "D",
    "dropname": "ATLANTIC BEACH",
    "dropdeladd": "1001 MAYPORT RD",
    "dropdelcty": "ATLANTIC BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 322339998,
    "dropphyadd": "1001 MAYPORT RD",
    "dropphycty": "ATLANTIC BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 322339998,
    "dropmaladd": "1001 MAYPORT RD",
    "dropmalcty": "ATLANTIC BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 322339998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042411967,
    "dropsitcph": 9042412026,
    "dropfax": 9042478502
  },
  {
    "dcode": "D",
    "dropkey": "BY21392",
    "droptype": "D",
    "dropname": "AVIATION",
    "dropdeladd": "16150 AVIATION LOOP DR",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 346046992,
    "dropphyadd": "16150 AVIATION LOOP DR",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 346046992,
    "dropmaladd": "16150 AVIATION LOOP DR",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 346046992,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3527963664,
    "dropfax": 3527548564
  },
  {
    "dcode": "D",
    "dropkey": "BY21396",
    "droptype": "D",
    "dropname": "AZALEA PARK",
    "dropdeladd": "501 N SEMORAN BLVD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328079998,
    "dropphyadd": "501 N SEMORAN BLVD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328079998,
    "dropmaladd": "501 N SEMORAN BLVD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328079998,
    "dropsitphn": 4073819161,
    "dropsitlph": 4073819161,
    "dropsitcph": 4073817425,
    "dropfax": 4073828093
  },
  {
    "dcode": "D",
    "dropkey": "BY21407",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "199 CENTER ST S",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322349998,
    "dropphyadd": "199 CENTER ST S",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322349998,
    "dropmaladd": "199 CENTER ST S",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322349998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042669402,
    "dropsitcph": 9042664910,
    "dropfax": 9042661141
  },
  {
    "dcode": "D",
    "dropkey": "BY21459",
    "droptype": "D",
    "dropname": "BEVERLY HILLS",
    "dropdeladd": "3971 N LECANTO HWY",
    "dropdelcty": "BEVERLY HILLS",
    "dropdelst": "FL",
    "dropdelzpp": 344659998,
    "dropphyadd": "3971 N LECANTO HWY",
    "dropphycty": "BEVERLY HILLS",
    "dropphyst": "FL",
    "dropphyzpp": 344659998,
    "dropmaladd": "320 S LECANTO HWY",
    "dropmalcty": "LECANTO",
    "dropmalst": "FL",
    "dropmalzpp": 344619998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527462424,
    "dropsitcph": 3527462424,
    "dropfax": 3527464080
  },
  {
    "dcode": "D",
    "dropkey": "BY21464",
    "droptype": "D",
    "dropname": "BIG PINE KEY",
    "dropdeladd": "29959 OVERSEAS HWY",
    "dropdelcty": "BIG PINE KEY",
    "dropdelst": "FL",
    "dropdelzpp": 330439998,
    "dropphyadd": "29959 OVERSEAS HWY",
    "dropphycty": "BIG PINE KEY",
    "dropphyst": "FL",
    "dropphyzpp": 330439998,
    "dropmaladd": "29959 OVERSEAS HWY",
    "dropmalcty": "BIG PINE KEY",
    "dropmalst": "FL",
    "dropmalzpp": 330439998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058721223,
    "dropsitcph": 3058722531,
    "dropfax": 3058721269
  },
  {
    "dcode": "D",
    "dropkey": "BY21478",
    "droptype": "D",
    "dropname": "WEST BOCA POSTAL STORE",
    "dropdeladd": "11419 W PALMETTO PARK RD STE A",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334289998,
    "dropphyadd": "11419 W PALMETTO PARK RD STE A",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334289998,
    "dropmaladd": "11419 W PALMETTO PARK RD STE A",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334289998,
    "dropsitphn": 5618524180,
    "dropsitlph": 5614777262,
    "dropsitcph": 5612181665,
    "dropfax": 5618830287
  },
  {
    "dcode": "D",
    "dropkey": "BY21496",
    "droptype": "D",
    "dropname": "BRADEN RIVER",
    "dropdeladd": "4112 53RD AVE E",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342039998,
    "dropphyadd": "4112 53RD AVE E",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342039998,
    "dropmaladd": "4112 53RD AVE E",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342039998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417274817,
    "dropfax": 9417581540
  },
  {
    "dcode": "D",
    "dropkey": "BY21520",
    "droptype": "D",
    "dropname": "BUENA VENTURA LAKES",
    "dropdeladd": "503 FLORIDA PKWY",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347439991,
    "dropphyadd": "503 FLORIDA PKWY",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347439991,
    "dropmaladd": "503 FLORIDA PKWY",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347439991,
    "dropsitphn": 4073483636,
    "dropsitlph": 4079332044,
    "dropsitcph": 4073483636,
    "dropfax": 4078463022
  },
  {
    "dcode": "D",
    "dropkey": "BY21537",
    "droptype": "D",
    "dropname": "CAPE CORAL CENTRAL",
    "dropdeladd": "1030 SE 9TH AVE",
    "dropdelcty": "CAPE CORAL",
    "dropdelst": "FL",
    "dropdelzpp": 339909998,
    "dropphyadd": "1030 SE 9TH AVE",
    "dropphycty": "CAPE CORAL",
    "dropphyst": "FL",
    "dropphyzpp": 339909998,
    "dropmaladd": "1030 SE 9TH AVE",
    "dropmalcty": "CAPE CORAL",
    "dropmalst": "FL",
    "dropmalzpp": 339909998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2397727501,
    "dropfax": 2397727312
  },
  {
    "dcode": "D",
    "dropkey": "BY21539",
    "droptype": "D",
    "dropname": "CAPE CORAL SOUTH",
    "dropdeladd": "4722 SE 17TH AVE",
    "dropdelcty": "CAPE CORAL",
    "dropdelst": "FL",
    "dropdelzpp": 339049998,
    "dropphyadd": "4722 SE 17TH AVE",
    "dropphycty": "CAPE CORAL",
    "dropphyst": "FL",
    "dropphyzpp": 339049998,
    "dropmaladd": "4722 SE 17TH AVE",
    "dropmalcty": "CAPE CORAL",
    "dropmalst": "FL",
    "dropmalzpp": 339049998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2397727501,
    "dropfax": 2395410242
  },
  {
    "dcode": "D",
    "dropkey": "BY21544",
    "droptype": "D",
    "dropname": "CARL FISHER",
    "dropdeladd": "1661 WEST AVE",
    "dropdelcty": "MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331399997,
    "dropphyadd": "1661 WEST AVE",
    "dropphycty": "MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331399997,
    "dropmaladd": "1661 WEST AVE",
    "dropmalcty": "MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331399997,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056725002,
    "dropsitcph": 3056725002,
    "dropfax": 3055312109
  },
  {
    "dcode": "D",
    "dropkey": "BY21546",
    "droptype": "D",
    "dropname": "CAROL CITY",
    "dropdeladd": "18690 NW 37TH AVE",
    "dropdelcty": "MIAMI GARDENS",
    "dropdelst": "FL",
    "dropdelzpp": 330569998,
    "dropphyadd": "18690 NW 37TH AVE",
    "dropphycty": "MIAMI GARDENS",
    "dropphyst": "FL",
    "dropphyzpp": 330569998,
    "dropmaladd": "18690 NW 37TH AVE",
    "dropmalcty": "MIAMI GARDENS",
    "dropmalst": "FL",
    "dropmalzpp": 330569998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056209670,
    "dropsitcph": 3056202519,
    "dropfax": 3056205393
  },
  {
    "dcode": "D",
    "dropkey": "BY21549",
    "droptype": "D",
    "dropname": "CARROLLWOOD",
    "dropdeladd": "12651 N DALE MABRY HWY",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336189998,
    "dropphyadd": "12651 N DALE MABRY HWY",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336189998,
    "dropmaladd": "12651 N DALE MABRY HWY",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336189998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8139612963,
    "dropsitcph": 8132806397,
    "dropfax": 8139632415
  },
  {
    "dcode": "D",
    "dropkey": "BY21628",
    "droptype": "D",
    "dropname": "CORAL GABLES",
    "dropdeladd": "251 VALENCIA AVE",
    "dropdelcty": "CORAL GABLES",
    "dropdelst": "FL",
    "dropdelzpp": 331349998,
    "dropphyadd": "251 VALENCIA AVE",
    "dropphycty": "CORAL GABLES",
    "dropphyst": "FL",
    "dropphyzpp": 331349998,
    "dropmaladd": "251 VALENCIA AVE",
    "dropmalcty": "CORAL GABLES",
    "dropmalst": "FL",
    "dropmalzpp": 331349998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054437837,
    "dropsitcph": 3054432532,
    "dropfax": 3054410381
  },
  {
    "dcode": "D",
    "dropkey": "BY21633",
    "droptype": "D",
    "dropname": "CORAL SPRINGS",
    "dropdeladd": "3255 NW 94TH AVE",
    "dropdelcty": "CORAL SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 330659998,
    "dropphyadd": "3255 NW 94TH AVE",
    "dropphycty": "CORAL SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 330659998,
    "dropmaladd": "3255 NW 94TH AVE",
    "dropmalcty": "CORAL SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 330659998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547969086,
    "dropsitcph": 9547551670,
    "dropfax": 7542406103
  },
  {
    "dcode": "D",
    "dropkey": "BY21682",
    "droptype": "D",
    "dropname": "DAVIE",
    "dropdeladd": "3850 S UNIVERSITY DR",
    "dropdelcty": "DAVIE",
    "dropdelst": "FL",
    "dropdelzpp": 333289998,
    "dropphyadd": "3850 S UNIVERSITY DR",
    "dropphycty": "DAVIE",
    "dropphyst": "FL",
    "dropphyzpp": 333289998,
    "dropmaladd": "3850 S UNIVERSITY DR",
    "dropmalcty": "DAVIE",
    "dropmalst": "FL",
    "dropmalzpp": 333289998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549168834,
    "dropsitcph": 9549168834,
    "dropfax": 9544238832
  },
  {
    "dcode": "D",
    "dropkey": "BY21690",
    "droptype": "D",
    "dropname": "DAYTONA BEACH SHORES",
    "dropdeladd": "2136 S ATLANTIC AVE STE A",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321185016,
    "dropphyadd": "2136 S ATLANTIC AVE STE A",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321185016,
    "dropmaladd": "2136 S ATLANTIC AVE STE A",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321185016,
    "dropsitphn": 3862746327,
    "dropsitlph": 3862558398,
    "dropsitcph": 3862558398,
    "dropfax": 3862744360
  },
  {
    "dcode": "D",
    "dropkey": "BY21825",
    "droptype": "D",
    "dropname": "FERN PARK",
    "dropdeladd": "130 FERNWOOD BLVD",
    "dropdelcty": "FERN PARK",
    "dropdelst": "FL",
    "dropdelzpp": 327309998,
    "dropphyadd": "130 FERNWOOD BLVD",
    "dropphycty": "FERN PARK",
    "dropphyst": "FL",
    "dropphyzpp": 327309998,
    "dropmaladd": "130 FERNWOOD BLVD",
    "dropmalcty": "FERN PARK",
    "dropmalst": "FL",
    "dropmalzpp": 327309998,
    "dropsitphn": 4073391886,
    "dropsitlph": 4073391886,
    "dropsitcph": 4073397288,
    "dropfax": 4073397659
  },
  {
    "dcode": "D",
    "dropkey": "BY21832",
    "droptype": "D",
    "dropname": "FIFTY SEVENTH AVENUE",
    "dropdeladd": "2005 57TH AVE W",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342079998,
    "dropphyadd": "2005 57TH AVE W",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342079998,
    "dropmaladd": "2005 57TH AVE W",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342079998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417270595,
    "dropfax": 9417528956
  },
  {
    "dcode": "D",
    "dropkey": "BY21863",
    "droptype": "D",
    "dropname": "FLORIDA CITY",
    "dropdeladd": "1000 W PALM DR",
    "dropdelcty": "HOMESTEAD",
    "dropdelst": "FL",
    "dropdelzpp": 330349998,
    "dropphyadd": "1000 W PALM DR",
    "dropphycty": "HOMESTEAD",
    "dropphyst": "FL",
    "dropphyzpp": 330349998,
    "dropmaladd": "1000 W PALM DR",
    "dropmalcty": "HOMESTEAD",
    "dropmalst": "FL",
    "dropmalzpp": 330349998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052489266,
    "dropsitcph": 3052489550,
    "dropfax": 3052451598
  },
  {
    "dcode": "D",
    "dropkey": "BY21944",
    "droptype": "D",
    "dropname": "GOLDEN GATE",
    "dropdeladd": "11665 COLLIER BLVD",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341169998,
    "dropphyadd": "11665 COLLIER BLVD",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341169998,
    "dropmaladd": "11665 COLLIER BLVD",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341169998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393523010,
    "dropfax": 2393524431
  },
  {
    "dcode": "D",
    "dropkey": "BY21958",
    "droptype": "D",
    "dropname": "GOULDS",
    "dropdeladd": "22350 OLD DIXIE HWY",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331709998,
    "dropphyadd": "22350 OLD DIXIE HWY",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331709998,
    "dropmaladd": "22350 OLD DIXIE HWY",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331709998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052583425,
    "dropsitcph": 3052583122,
    "dropfax": 3052588310
  },
  {
    "dcode": "D",
    "dropkey": "BY21967",
    "droptype": "D",
    "dropname": "GRATIGNY",
    "dropdeladd": "995 NW 119TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331689998,
    "dropphyadd": "995 NW 119TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331689998,
    "dropmaladd": "995 NW 119TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331689998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056880401,
    "dropsitcph": 3056872484,
    "dropfax": 3056882669
  },
  {
    "dcode": "D",
    "dropkey": "BY21986",
    "droptype": "D",
    "dropname": "GULF GATE",
    "dropdeladd": "2875 ASHTON RD",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342319998,
    "dropphyadd": "2875 ASHTON RD",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342319998,
    "dropmaladd": "2875 ASHTON RD",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342319998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9419222339,
    "dropfax": 9419252460
  },
  {
    "dcode": "D",
    "dropkey": "BY22000",
    "droptype": "D",
    "dropname": "HAINES CREEK",
    "dropdeladd": "32327 COUNTY ROAD 473",
    "dropdelcty": "LEESBURG",
    "dropdelst": "FL",
    "dropdelzpp": 347889998,
    "dropphyadd": "32327 COUNTY ROAD 473",
    "dropphycty": "LEESBURG",
    "dropphyst": "FL",
    "dropphyzpp": 347889998,
    "dropmaladd": "32327 COUNTY ROAD 473",
    "dropmalcty": "LEESBURG",
    "dropmalst": "FL",
    "dropmalzpp": 347889998,
    "dropsitphn": 3523430410,
    "dropsitlph": 3523430410,
    "dropsitcph": 3523430410,
    "dropfax": 3523431772
  },
  {
    "dcode": "D",
    "dropkey": "BY22032",
    "droptype": "D",
    "dropname": "HIAWASSEE",
    "dropdeladd": "3200 N HIAWASSEE RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328189998,
    "dropphyadd": "3200 N HIAWASSEE RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328189998,
    "dropmaladd": "3200 N HIAWASSEE RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328189998,
    "dropsitphn": 4072939220,
    "dropsitlph": 4072939220,
    "dropsitcph": 4074450685,
    "dropfax": 4072937550
  },
  {
    "dcode": "D",
    "dropkey": "BY22052",
    "droptype": "D",
    "dropname": "HOLIDAY",
    "dropdeladd": "4737 MILE STRETCH DR",
    "dropdelcty": "HOLIDAY",
    "dropdelst": "FL",
    "dropdelzpp": 346909998,
    "dropphyadd": "4737 MILE STRETCH DR",
    "dropphycty": "HOLIDAY",
    "dropphyst": "FL",
    "dropphyzpp": 346909998,
    "dropmaladd": "4737 MILE STRETCH DR",
    "dropmalcty": "HOLIDAY",
    "dropmalst": "FL",
    "dropmalzpp": 346909998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7279376521,
    "dropsitcph": 7279372207,
    "dropfax": 7279391781
  },
  {
    "dcode": "D",
    "dropkey": "BY22055",
    "droptype": "D",
    "dropname": "HOLLY HILL",
    "dropdeladd": "231 7TH ST",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321179998,
    "dropphyadd": "231 7TH ST",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321179998,
    "dropmaladd": "231 7TH ST",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321179998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3862746332,
    "dropsitcph": 3862385584,
    "dropfax": 3862387204
  },
  {
    "dcode": "D",
    "dropkey": "BY22074",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "13610 BIG BEND DR",
    "dropdelcty": "HUDSON",
    "dropdelst": "FL",
    "dropdelzpp": 346679998,
    "dropphyadd": "13610 BIG BEND DR",
    "dropphycty": "HUDSON",
    "dropphyst": "FL",
    "dropphyzpp": 346679998,
    "dropmaladd": "13610 BIG BEND DR",
    "dropmalcty": "HUDSON",
    "dropmalst": "FL",
    "dropmalzpp": 346679998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278190073,
    "dropfax": 7278681369
  },
  {
    "dcode": "D",
    "dropkey": "BY22086",
    "droptype": "D",
    "dropname": "INDIALANTIC",
    "dropdeladd": "200 N PALM AVE",
    "dropdelcty": "INDIALANTIC",
    "dropdelst": "FL",
    "dropdelzpp": 329039998,
    "dropphyadd": "200 N PALM AVE",
    "dropphycty": "INDIALANTIC",
    "dropphyst": "FL",
    "dropphyzpp": 329039998,
    "dropmaladd": "200 N PALM AVE",
    "dropmalcty": "INDIALANTIC",
    "dropmalst": "FL",
    "dropmalzpp": 329039998,
    "dropsitphn": 3216762921,
    "dropsitlph": 3216762921,
    "dropsitcph": 3217236164,
    "dropfax": 3217290081
  },
  {
    "dcode": "D",
    "dropkey": "BY22106",
    "droptype": "D",
    "dropname": "INTERCHANGE SQUARE",
    "dropdeladd": "1155 MALABAR RD NE STE 18",
    "dropdelcty": "PALM BAY",
    "dropdelst": "FL",
    "dropdelzpp": 329079994,
    "dropphyadd": "1155 MALABAR RD NE STE 18",
    "dropphycty": "PALM BAY",
    "dropphyst": "FL",
    "dropphyzpp": 329079994,
    "dropmaladd": "1155 MALABAR RD NE STE 18",
    "dropmalcty": "PALM BAY",
    "dropmalst": "FL",
    "dropmalzpp": 329079994,
    "dropsitphn": 3217260552,
    "dropsitlph": 3217260552,
    "dropsitcph": 3219849658,
    "dropfax": 3217261560
  },
  {
    "dcode": "D",
    "dropkey": "BY22128",
    "droptype": "D",
    "dropname": "JACKSONVILLE BEACH",
    "dropdeladd": "1348 BEACH BLVD",
    "dropdelcty": "JACKSONVILLE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 322509998,
    "dropphyadd": "1348 BEACH BLVD",
    "dropphycty": "JACKSONVILLE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 322509998,
    "dropmaladd": "1348 BEACH BLVD",
    "dropmalcty": "JACKSONVILLE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 322509998,
    "dropsitphn": "",
    "dropsitlph": 9042493006,
    "dropsitcph": 9042495426,
    "dropfax": 9042463339
  },
  {
    "dcode": "D",
    "dropkey": "BY22129",
    "droptype": "D",
    "dropname": "JACKSONVILLE NAS",
    "dropdeladd": "569 CHILDS ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322121198,
    "dropphyadd": "569 CHILDS ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322121198,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322129998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9049085255,
    "dropsitcph": 9047716826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY22163",
    "droptype": "D",
    "dropname": "KEY BISCAYNE",
    "dropdeladd": "951 CRANDON BLVD",
    "dropdelcty": "KEY BISCAYNE",
    "dropdelst": "FL",
    "dropdelzpp": 331499998,
    "dropphyadd": "951 CRANDON BLVD",
    "dropphycty": "KEY BISCAYNE",
    "dropphyst": "FL",
    "dropphyzpp": 331499998,
    "dropmaladd": "951 CRANDON BLVD",
    "dropmalcty": "KEY BISCAYNE",
    "dropmalst": "FL",
    "dropmalzpp": 331499998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053619149,
    "dropsitcph": 3053617884,
    "dropfax": 3053619961
  },
  {
    "dcode": "D",
    "dropkey": "BY22165",
    "droptype": "D",
    "dropname": "KEY COLONY BEACH",
    "dropdeladd": "600 W OCEAN DR",
    "dropdelcty": "KEY COLONY BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330519800,
    "dropphyadd": "600 W OCEAN DR",
    "dropphycty": "KEY COLONY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330519800,
    "dropmaladd": "600 W OCEAN DR",
    "dropmalcty": "KEY COLONY BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330519800,
    "dropsitphn": 3055132368,
    "dropsitlph": 3057433570,
    "dropsitcph": 3057435238,
    "dropfax": 7869713267
  },
  {
    "dcode": "D",
    "dropkey": "BY22213",
    "droptype": "D",
    "dropname": "LAKE PARK",
    "dropdeladd": "904 PARK AVE",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334039991,
    "dropphyadd": "904 PARK AVE",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334039991,
    "dropmaladd": "904 PARK AVE",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334039991,
    "dropsitphn": 5618411920,
    "dropsitlph": 5618411920,
    "dropsitcph": 5618411920,
    "dropfax": 5618484798
  },
  {
    "dcode": "D",
    "dropkey": "BY22236",
    "droptype": "D",
    "dropname": "LANTANA",
    "dropdeladd": "201 W OCEAN AVE",
    "dropdelcty": "LANTANA",
    "dropdelst": "FL",
    "dropdelzpp": 334629998,
    "dropphyadd": "201 W OCEAN AVE",
    "dropphycty": "LANTANA",
    "dropphyst": "FL",
    "dropphyzpp": 334629998,
    "dropmaladd": "201 W OCEAN AVE",
    "dropmalcty": "LANTANA",
    "dropmalst": "FL",
    "dropmalzpp": 334629998,
    "dropsitphn": 5615827525,
    "dropsitlph": 5615827525,
    "dropsitcph": 5613577864,
    "dropfax": 5615821358
  },
  {
    "dcode": "D",
    "dropkey": "BY22261",
    "droptype": "D",
    "dropname": "LIGHTHOUSE POINT",
    "dropdeladd": "2091 NE 36TH ST",
    "dropdelcty": "LIGHTHOUSE POINT",
    "dropdelst": "FL",
    "dropdelzpp": 330649997,
    "dropphyadd": "2091 NE 36TH ST",
    "dropphycty": "LIGHTHOUSE POINT",
    "dropphyst": "FL",
    "dropphyzpp": 330649997,
    "dropmaladd": "2091 NE 36TH ST",
    "dropmalcty": "LIGHTHOUSE POINT",
    "dropmalst": "FL",
    "dropmalzpp": 330649997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547855765,
    "dropsitcph": 9547834390,
    "dropfax": 9547849874
  },
  {
    "dcode": "D",
    "dropkey": "BY22284",
    "droptype": "D",
    "dropname": "LOCKHART",
    "dropdeladd": "5087 EDGEWATER DR",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328109998,
    "dropphyadd": "5087 EDGEWATER DR",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328109998,
    "dropmaladd": "5087 EDGEWATER DR",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328109998,
    "dropsitphn": 4072935360,
    "dropsitlph": 4072935360,
    "dropsitcph": 4072925835,
    "dropfax": 4072930517
  },
  {
    "dcode": "D",
    "dropkey": "BY22297",
    "droptype": "D",
    "dropname": "LUDLAM",
    "dropdeladd": "6900 BIRD RD",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331559998,
    "dropphyadd": "6900 BIRD RD",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331559998,
    "dropmaladd": "6900 BIRD RD",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331559998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055991782,
    "dropsitcph": 3056693806,
    "dropfax": 3056612669
  },
  {
    "dcode": "D",
    "dropkey": "BY22306",
    "droptype": "D",
    "dropname": "MACDILL AFB",
    "dropdeladd": "8106 CONDOR ST",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336215408,
    "dropphyadd": "8106 CONDOR ST",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336215408,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336089998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138284680,
    "dropfax": 8138409191
  },
  {
    "dcode": "D",
    "dropkey": "BY22310",
    "droptype": "D",
    "dropname": "MADEIRA BEACH",
    "dropdeladd": "15019 MADEIRA WAY",
    "dropdelcty": "MADEIRA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 337089998,
    "dropphyadd": "15019 MADEIRA WAY",
    "dropphycty": "MADEIRA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 337089998,
    "dropmaladd": "15019 MADEIRA WAY",
    "dropmalcty": "MADEIRA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 337089998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273190353,
    "dropfax": 7273942736
  },
  {
    "dcode": "D",
    "dropkey": "BY22333",
    "droptype": "D",
    "dropname": "MARATHON SHORES",
    "dropdeladd": "11400 OVERSEAS HWY STE 120",
    "dropdelcty": "MARATHON",
    "dropdelst": "FL",
    "dropdelzpp": 330509997,
    "dropphyadd": "11400 OVERSEAS HWY STE 120",
    "dropphycty": "MARATHON",
    "dropphyst": "FL",
    "dropphyzpp": 330509997,
    "dropmaladd": "11400 OVERSEAS HWY STE 120",
    "dropmalcty": "MARATHON",
    "dropmalst": "FL",
    "dropmalzpp": 330509997,
    "dropsitphn": 3055132368,
    "dropsitlph": 3057433570,
    "dropsitcph": 3057435238,
    "dropfax": 3057439431
  },
  {
    "dcode": "D",
    "dropkey": "BY22338",
    "droptype": "D",
    "dropname": "MARGATE",
    "dropdeladd": "5094 COCONUT CREEK PKWY",
    "dropdelcty": "MARGATE",
    "dropdelst": "FL",
    "dropdelzpp": 330639998,
    "dropphyadd": "5094 COCONUT CREEK PKWY",
    "dropphycty": "MARGATE",
    "dropphyst": "FL",
    "dropphyzpp": 330639998,
    "dropmaladd": "5094 COCONUT CREEK PKWY",
    "dropmalcty": "MARGATE",
    "dropmalst": "FL",
    "dropmalzpp": 330639998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549568983,
    "dropsitcph": 9549719569,
    "dropfax": 9549756793
  },
  {
    "dcode": "D",
    "dropkey": "BY22357",
    "droptype": "D",
    "dropname": "MAYPORT NAVAL STATION",
    "dropdeladd": "460 MASSEY AVE",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322289998,
    "dropphyadd": "460 MASSEY AVE",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322289998,
    "dropmaladd": "460 MASSEY AVE",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322289998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042499523,
    "dropsitcph": 9042499523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY22372",
    "droptype": "D",
    "dropname": "MELBOURNE BEACH",
    "dropdeladd": "504 OCEAN AVE",
    "dropdelcty": "MELBOURNE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329519998,
    "dropphyadd": "504 OCEAN AVE",
    "dropphycty": "MELBOURNE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329519998,
    "dropmaladd": "504 OCEAN AVE",
    "dropmalcty": "MELBOURNE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329519998,
    "dropsitphn": 3217234854,
    "dropsitlph": 3217234854,
    "dropsitcph": 3217236738,
    "dropfax": 3217222497
  },
  {
    "dcode": "D",
    "dropkey": "BY22393",
    "droptype": "D",
    "dropname": "MIAMI GARDENS",
    "dropdeladd": "6193 NW 183RD ST",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330159998,
    "dropphyadd": "6193 NW 183RD ST",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330159998,
    "dropmaladd": "6193 NW 183RD ST",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330159998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056233852,
    "dropsitcph": 3056214721,
    "dropfax": 3056282189
  },
  {
    "dcode": "D",
    "dropkey": "BY22395",
    "droptype": "D",
    "dropname": "MIAMI SHORES",
    "dropdeladd": "9825 NE 2ND AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331539998,
    "dropphyadd": "9825 NE 2ND AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331539998,
    "dropmaladd": "9825 NE 2ND AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331539998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3057540886,
    "dropsitcph": 3057540886,
    "dropfax": 3057596841
  },
  {
    "dcode": "D",
    "dropkey": "BY22399",
    "droptype": "D",
    "dropname": "MIAMI SPRINGS",
    "dropdeladd": "107 WESTWARD DR",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 332669998,
    "dropphyadd": "107 WESTWARD DR",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 332669998,
    "dropmaladd": "107 WESTWARD DR",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 332669998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058821352,
    "dropsitcph": 3058821042,
    "dropfax": 3058055525
  },
  {
    "dcode": "D",
    "dropkey": "BY22421",
    "droptype": "D",
    "dropname": "MIRAMAR",
    "dropdeladd": "14900 SW 30TH ST",
    "dropdelcty": "MIRAMAR",
    "dropdelst": "FL",
    "dropdelzpp": 330279997,
    "dropphyadd": "14900 SW 30TH ST",
    "dropphycty": "MIRAMAR",
    "dropphyst": "FL",
    "dropphyzpp": 330279997,
    "dropmaladd": "14900 SW 30TH ST",
    "dropmalcty": "MIRAMAR",
    "dropmalst": "FL",
    "dropmalzpp": 330279997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547048993,
    "dropsitcph": 9547048993,
    "dropfax": 7542603436
  },
  {
    "dcode": "D",
    "dropkey": "BY22440",
    "droptype": "D",
    "dropname": "MURDOCK",
    "dropdeladd": "19190 COCHRAN BLVD FRNT",
    "dropdelcty": "PORT CHARLOTTE",
    "dropdelst": "FL",
    "dropdelzpp": 339489998,
    "dropphyadd": "19190 COCHRAN BLVD FRNT",
    "dropphycty": "PORT CHARLOTTE",
    "dropphyst": "FL",
    "dropphyzpp": 339489998,
    "dropmaladd": "19190 COCHRAN BLVD FRNT",
    "dropmalcty": "PORT CHARLOTTE",
    "dropmalst": "FL",
    "dropmalzpp": 339489998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9416252397,
    "dropfax": 9416296025
  },
  {
    "dcode": "D",
    "dropkey": "BY22446",
    "droptype": "D",
    "dropname": "MYRTLE GROVE",
    "dropdeladd": "5200 LILLIAN HWY",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325069998,
    "dropphyadd": "5200 LILLIAN HWY",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325069998,
    "dropmaladd": "5200 LILLIAN HWY",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325069998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8503162345,
    "dropsitcph": 8504539364,
    "dropfax": 8504550715
  },
  {
    "dcode": "D",
    "dropkey": "BY22475",
    "droptype": "D",
    "dropname": "NAVAL AIR STATION",
    "dropdeladd": "210 WEST AVE STE B",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325085135,
    "dropphyadd": "210 WEST AVE STE B",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325085135,
    "dropmaladd": "210 WEST AVE STE B",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325085135,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504565845,
    "dropsitcph": 8504565845,
    "dropfax": 8504562218
  },
  {
    "dcode": "D",
    "dropkey": "BY22476",
    "droptype": "D",
    "dropname": "NAVAL AIR STATION UNIT 2",
    "dropdeladd": "4069 LANGLEY AVE BLDG A",
    "dropdelcty": "KEY WEST",
    "dropdelst": "FL",
    "dropdelzpp": 330406324,
    "dropphyadd": "4069 LANGLEY AVE BLDG A",
    "dropphycty": "KEY WEST",
    "dropphyst": "FL",
    "dropphyzpp": 330406324,
    "dropmaladd": "400 WHITEHEAD ST",
    "dropmalcty": "KEY WEST",
    "dropmalst": "FL",
    "dropmalzpp": 330409998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052949366,
    "dropsitcph": 3052932406,
    "dropfax": 3052946575
  },
  {
    "dcode": "D",
    "dropkey": "BY22480",
    "droptype": "D",
    "dropname": "NAVARRE",
    "dropdeladd": "1910 NAVARRE SCHOOL RD",
    "dropdelcty": "NAVARRE",
    "dropdelst": "FL",
    "dropdelzpp": 325665517,
    "dropphyadd": "1910 NAVARRE SCHOOL RD",
    "dropphycty": "NAVARRE",
    "dropphyst": "FL",
    "dropphyzpp": 325665517,
    "dropmaladd": "1910 NAVARRE SCHOOL RD",
    "dropmalcty": "NAVARRE",
    "dropmalst": "FL",
    "dropmalzpp": 325665517,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509394762,
    "dropsitcph": 8509390381,
    "dropfax": 8509395511
  },
  {
    "dcode": "D",
    "dropkey": "BY22517",
    "droptype": "D",
    "dropname": "NORLAND",
    "dropdeladd": "18640 NW 2ND AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331699998,
    "dropphyadd": "18640 NW 2ND AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331699998,
    "dropmaladd": "18640 NW 2ND AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331699998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056518594,
    "dropsitcph": 3056522818,
    "dropfax": 3056531892
  },
  {
    "dcode": "D",
    "dropkey": "BY22526",
    "droptype": "D",
    "dropname": "NORTH FORT MYERS",
    "dropdeladd": "1882 N TAMIAMI TRL",
    "dropdelcty": "NORTH FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339039998,
    "dropphyadd": "1882 N TAMIAMI TRL",
    "dropphycty": "NORTH FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339039998,
    "dropmaladd": "1882 N TAMIAMI TRL",
    "dropmalcty": "NORTH FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339039998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2399970059,
    "dropfax": 2396564540
  },
  {
    "dcode": "D",
    "dropkey": "BY22533",
    "droptype": "D",
    "dropname": "NORTH MIAMI",
    "dropdeladd": "14311 BISCAYNE BLVD",
    "dropdelcty": "NORTH MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331819998,
    "dropphyadd": "14311 BISCAYNE BLVD",
    "dropphycty": "NORTH MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331819998,
    "dropmaladd": "14311 BISCAYNE BLVD",
    "dropmalcty": "NORTH MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331819998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3053548047,
    "dropsitcph": 3053544612,
    "dropfax": 7866545805
  },
  {
    "dcode": "D",
    "dropkey": "BY22536",
    "droptype": "D",
    "dropname": "NORTH MIAMI BEACH",
    "dropdeladd": "16400 W DIXIE HWY",
    "dropdelcty": "NORTH MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331609998,
    "dropphyadd": "16400 W DIXIE HWY",
    "dropphycty": "NORTH MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331609998,
    "dropmaladd": "16400 W DIXIE HWY",
    "dropmalcty": "NORTH MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331609998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3059476280,
    "dropsitcph": 3059476454,
    "dropfax": 3059498973
  },
  {
    "dcode": "D",
    "dropkey": "BY22539",
    "droptype": "D",
    "dropname": "NORTH PALM BEACH",
    "dropdeladd": "643 US HIGHWAY 1",
    "dropdelcty": "NORTH PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334089998,
    "dropphyadd": "643 US HIGHWAY 1",
    "dropphycty": "NORTH PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334089998,
    "dropmaladd": "643 US HIGHWAY 1",
    "dropmalcty": "NORTH PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334089998,
    "dropsitphn": 5618425637,
    "dropsitlph": 5618425637,
    "dropsitcph": 5618411425,
    "dropfax": 5618486851
  },
  {
    "dcode": "D",
    "dropkey": "BY22566",
    "droptype": "D",
    "dropname": "OAKLAND PARK",
    "dropdeladd": "3350 NE 12TH AVE",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333349997,
    "dropphyadd": "3350 NE 12TH AVE",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333349997,
    "dropmaladd": "3350 NE 12TH AVE",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333349997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545630867,
    "dropsitcph": 9545630867,
    "dropfax": 9545645128
  },
  {
    "dcode": "D",
    "dropkey": "BY22579",
    "droptype": "D",
    "dropname": "OJUS",
    "dropdeladd": "18901 W DIXIE HWY",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331802635,
    "dropphyadd": "18901 W DIXIE HWY",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331802635,
    "dropmaladd": "18901 W DIXIE HWY",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331802635,
    "dropsitphn": 3054700746,
    "dropsitlph": 3059315972,
    "dropsitcph": 3059476454,
    "dropfax": 3059315972
  },
  {
    "dcode": "D",
    "dropkey": "BY22589",
    "droptype": "D",
    "dropname": "OLYMPIA HEIGHTS",
    "dropdeladd": "3801 SW 117TH AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331759998,
    "dropphyadd": "3801 SW 117TH AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331759998,
    "dropmaladd": "3801 SW 117TH AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331759998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052261578,
    "dropsitcph": 3052256749,
    "dropfax": 3055519364
  },
  {
    "dcode": "D",
    "dropkey": "BY22612",
    "droptype": "D",
    "dropname": "ORLO VISTA",
    "dropdeladd": "501 S KIRKMAN RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328119998,
    "dropphyadd": "501 S KIRKMAN RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328119998,
    "dropmaladd": "501 S KIRKMAN RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328119998,
    "dropsitphn": 4072930512,
    "dropsitlph": 4072930512,
    "dropsitcph": 4072944925,
    "dropfax": 4072930361
  },
  {
    "dcode": "D",
    "dropkey": "BY22630",
    "droptype": "D",
    "dropname": "PADDOCK",
    "dropdeladd": "4545 SW 60TH AVE",
    "dropdelcty": "OCALA",
    "dropdelst": "FL",
    "dropdelzpp": 344744301,
    "dropphyadd": "4545 SW 60TH AVE",
    "dropphycty": "OCALA",
    "dropphyst": "FL",
    "dropphyzpp": 344744301,
    "dropmaladd": "PO BOX 779998",
    "dropmalcty": "OCALA",
    "dropmalst": "FL",
    "dropmalzpp": 344779998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3528618188,
    "dropsitcph": 3528618188,
    "dropfax": 3522371459
  },
  {
    "dcode": "D",
    "dropkey": "BY22635",
    "droptype": "D",
    "dropname": "PALM BAY",
    "dropdeladd": "4660 LIPSCOMB ST NE",
    "dropdelcty": "PALM BAY",
    "dropdelst": "FL",
    "dropdelzpp": 329059998,
    "dropphyadd": "4660 LIPSCOMB ST NE",
    "dropphycty": "PALM BAY",
    "dropphyst": "FL",
    "dropphyzpp": 329059998,
    "dropmaladd": "4660 LIPSCOMB ST NE",
    "dropmalcty": "PALM BAY",
    "dropmalst": "FL",
    "dropmalzpp": 329059998,
    "dropsitphn": 3217233790,
    "dropsitlph": 3217233790,
    "dropsitcph": 3217236962,
    "dropfax": 3217233757
  },
  {
    "dcode": "D",
    "dropkey": "BY22639",
    "droptype": "D",
    "dropname": "PALM BEACH GARDENS",
    "dropdeladd": "3330 FAIRCHILD GARDENS AVE",
    "dropdelcty": "PALM BEACH GARDENS",
    "dropdelst": "FL",
    "dropdelzpp": 334109998,
    "dropphyadd": "3330 FAIRCHILD GARDENS AVE",
    "dropphycty": "PALM BEACH GARDENS",
    "dropphyst": "FL",
    "dropphyzpp": 334109998,
    "dropmaladd": "3330 FAIRCHILD GARDENS AVE",
    "dropmalcty": "PALM BEACH GARDENS",
    "dropmalst": "FL",
    "dropmalzpp": 334109998,
    "dropsitphn": 5617995892,
    "dropsitlph": 5617995892,
    "dropsitcph": 5617994068,
    "dropfax": 5616251360
  },
  {
    "dcode": "D",
    "dropkey": "BY22644",
    "droptype": "D",
    "dropname": "PALM COAST",
    "dropdeladd": "2 PINE CONE DR",
    "dropdelcty": "PALM COAST",
    "dropdelst": "FL",
    "dropdelzpp": 321379998,
    "dropphyadd": "2 PINE CONE DR",
    "dropphycty": "PALM COAST",
    "dropphyst": "FL",
    "dropphyzpp": 321379998,
    "dropmaladd": "2 PINE CONE DR",
    "dropmalcty": "PALM COAST",
    "dropmalst": "FL",
    "dropmalzpp": 321379998,
    "dropsitphn": 3864464355,
    "dropsitlph": 3864479880,
    "dropsitcph": 3864479880,
    "dropfax": 3864451356
  },
  {
    "dcode": "D",
    "dropkey": "BY22654",
    "droptype": "D",
    "dropname": "PALMA SOLA",
    "dropdeladd": "115 75TH ST W",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342099998,
    "dropphyadd": "115 75TH ST W",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342099998,
    "dropmaladd": "115 75TH ST W",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342099998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417921893,
    "dropfax": 9417983846
  },
  {
    "dcode": "D",
    "dropkey": "BY22660",
    "droptype": "D",
    "dropname": "PANAMA CITY BEACH",
    "dropdeladd": "420 CHURCHWELL DR",
    "dropdelcty": "PANAMA CITY BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 324079998,
    "dropphyadd": "420 CHURCHWELL DR",
    "dropphycty": "PANAMA CITY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 324079998,
    "dropmaladd": "420 CHURCHWELL DR",
    "dropmalcty": "PANAMA CITY BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 324079998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502360589,
    "dropsitcph": 8502360589,
    "dropfax": 8502349006
  },
  {
    "dcode": "D",
    "dropkey": "BY22669",
    "droptype": "D",
    "dropname": "PATRICK AFB",
    "dropdeladd": "424 FALCON AVE",
    "dropdelcty": "PATRICK AIR FORCE BASE",
    "dropdelst": "FL",
    "dropdelzpp": 329259998,
    "dropphyadd": "424 FALCON AVE",
    "dropphycty": "PATRICK AIR FORCE BASE",
    "dropphyst": "FL",
    "dropphyzpp": 329259998,
    "dropmaladd": "424 FALCON AVE",
    "dropmalcty": "PATRICK AIR FORCE BASE",
    "dropmalst": "FL",
    "dropmalzpp": 329259998,
    "dropsitphn": 3214946297,
    "dropsitlph": 3214946297,
    "dropsitcph": 3217840394,
    "dropfax": 3217846561
  },
  {
    "dcode": "D",
    "dropkey": "BY22677",
    "droptype": "D",
    "dropname": "PEMBROKE PINES",
    "dropdeladd": "2350 N UNIVERSITY DR",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330249998,
    "dropphyadd": "2350 N UNIVERSITY DR",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330249998,
    "dropmaladd": "2350 N UNIVERSITY DR",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330249998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544417728,
    "dropsitcph": 9544417334,
    "dropfax": 7542603436
  },
  {
    "dcode": "D",
    "dropkey": "BY22691",
    "droptype": "D",
    "dropname": "PERRINE",
    "dropdeladd": "9833 E HIBISCUS ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 332575400,
    "dropphyadd": "9833 E HIBISCUS ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 332575400,
    "dropmaladd": "9833 E HIBISCUS ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 332575400,
    "dropsitphn": 3054700746,
    "dropsitlph": 3059714349,
    "dropsitcph": 3059714349,
    "dropfax": 3052350855
  },
  {
    "dcode": "D",
    "dropkey": "BY22695",
    "droptype": "D",
    "dropname": "PINE CASTLE",
    "dropdeladd": "7707 S ORANGE AVE",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328099998,
    "dropphyadd": "7707 S ORANGE AVE",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328099998,
    "dropmaladd": "7707 S ORANGE AVE",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328099998,
    "dropsitphn": 4078556164,
    "dropsitlph": 4078556164,
    "dropsitcph": 4078554932,
    "dropfax": 4078550273
  },
  {
    "dcode": "D",
    "dropkey": "BY22696",
    "droptype": "D",
    "dropname": "PINE HILLS",
    "dropdeladd": "811 DEAUVILLE DR",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328089998,
    "dropphyadd": "811 DEAUVILLE DR",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328089998,
    "dropmaladd": "811 DEAUVILLE DR",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328089998,
    "dropsitphn": 4072964127,
    "dropsitlph": 4072964127,
    "dropsitcph": 4074450685,
    "dropfax": 4072955557
  },
  {
    "dcode": "D",
    "dropkey": "BY22709",
    "droptype": "D",
    "dropname": "PLANTATION",
    "dropdeladd": "7580 NW 5TH ST",
    "dropdelcty": "PLANTATION",
    "dropdelst": "FL",
    "dropdelzpp": 333179998,
    "dropphyadd": "7580 NW 5TH ST",
    "dropphycty": "PLANTATION",
    "dropphyst": "FL",
    "dropphyzpp": 333179998,
    "dropmaladd": "7580 NW 5TH ST",
    "dropmalcty": "PLANTATION",
    "dropmalst": "FL",
    "dropmalzpp": 333179998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545874921,
    "dropsitcph": 9545874921,
    "dropfax": 9547925014
  },
  {
    "dcode": "D",
    "dropkey": "BY22713",
    "droptype": "D",
    "dropname": "PLAZA",
    "dropdeladd": "7341 SPRING HILL DR",
    "dropdelcty": "SPRING HILL",
    "dropdelst": "FL",
    "dropdelzpp": 346064300,
    "dropphyadd": "7341 SPRING HILL DR",
    "dropphycty": "SPRING HILL",
    "dropphyst": "FL",
    "dropphyzpp": 346064300,
    "dropmaladd": "7341 SPRING HILL DR",
    "dropmalcty": "SPRING HILL",
    "dropmalst": "FL",
    "dropmalzpp": 346064300,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3526661320,
    "dropfax": 3526846539
  },
  {
    "dcode": "D",
    "dropkey": "BY22737",
    "droptype": "D",
    "dropname": "PORT CHARLOTTE",
    "dropdeladd": "3740 TAMIAMI TRL",
    "dropdelcty": "PORT CHARLOTTE",
    "dropdelst": "FL",
    "dropdelzpp": 339529998,
    "dropphyadd": "3740 TAMIAMI TRL",
    "dropphycty": "PORT CHARLOTTE",
    "dropphyst": "FL",
    "dropphyzpp": 339529998,
    "dropmaladd": "3740 TAMIAMI TRL",
    "dropmalcty": "PORT CHARLOTTE",
    "dropmalst": "FL",
    "dropmalzpp": 339529998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9416252397,
    "dropfax": 9416257111
  },
  {
    "dcode": "D",
    "dropkey": "BY22757",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "13500 SW 250TH ST",
    "dropdelcty": "HOMESTEAD",
    "dropdelst": "FL",
    "dropdelzpp": 330329998,
    "dropphyadd": "13500 SW 250TH ST",
    "dropphycty": "HOMESTEAD",
    "dropphyst": "FL",
    "dropphyzpp": 330329998,
    "dropmaladd": "13500 SW 250TH ST",
    "dropmalcty": "HOMESTEAD",
    "dropmalst": "FL",
    "dropmalzpp": 330329998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052582390,
    "dropsitcph": 3052589462,
    "dropfax": 3052572206
  },
  {
    "dcode": "D",
    "dropkey": "BY22771",
    "droptype": "D",
    "dropname": "QUAIL HEIGHTS",
    "dropdeladd": "10360 SW 186TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331979998,
    "dropphyadd": "10360 SW 186TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331979998,
    "dropmaladd": "10360 SW 186TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331979998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052534910,
    "dropsitcph": 3053786759,
    "dropfax": 3059644012
  },
  {
    "dcode": "D",
    "dropkey": "BY22803",
    "droptype": "D",
    "dropname": "RIVIERA BEACH",
    "dropdeladd": "1905 W BLUE HERON BLVD",
    "dropdelcty": "RIVIERA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334049998,
    "dropphyadd": "1905 W BLUE HERON BLVD",
    "dropphycty": "RIVIERA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334049998,
    "dropmaladd": "1905 W BLUE HERON BLVD",
    "dropmalcty": "RIVIERA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334049998,
    "dropsitphn": 5618443751,
    "dropsitlph": 5618443751,
    "dropsitcph": 5618411920,
    "dropfax": 5618429113
  },
  {
    "dcode": "D",
    "dropkey": "BY22811",
    "droptype": "D",
    "dropname": "ROYAL PALM BEACH",
    "dropdeladd": "1050 ROYAL PALM BEACH BLVD STE 123",
    "dropdelcty": "ROYAL PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334119991,
    "dropphyadd": "1050 ROYAL PALM BEACH BLVD STE 123",
    "dropphycty": "ROYAL PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334119991,
    "dropmaladd": "1050 ROYAL PALM BEACH BLVD STE 123",
    "dropmalcty": "ROYAL PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334119991,
    "dropsitphn": 5617530446,
    "dropsitlph": 5617530446,
    "dropsitcph": 5617530446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY22840",
    "droptype": "D",
    "dropname": "SAINT PETE BEACH",
    "dropdeladd": "250 COREY AVE",
    "dropdelcty": "ST PETE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 337069998,
    "dropphyadd": "250 COREY AVE",
    "dropphycty": "ST PETE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 337069998,
    "dropmaladd": "250 COREY AVE",
    "dropmalcty": "ST PETE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 337069998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273677781,
    "dropfax": 7273677781
  },
  {
    "dcode": "D",
    "dropkey": "BY22848",
    "droptype": "D",
    "dropname": "SAND LAKE",
    "dropdeladd": "10450 TURKEY LAKE RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328199998,
    "dropphyadd": "10450 TURKEY LAKE RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328199998,
    "dropmaladd": "10450 TURKEY LAKE RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328199998,
    "dropsitphn": 4073524744,
    "dropsitlph": 4073524744,
    "dropsitcph": 4073512492,
    "dropfax": 4072481153
  },
  {
    "dcode": "D",
    "dropkey": "BY22861",
    "droptype": "D",
    "dropname": "SATELLITE BEACH",
    "dropdeladd": "1071 S PATRICK DR STE 101",
    "dropdelcty": "SATELLITE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329373972,
    "dropphyadd": "1071 S PATRICK DR STE 101",
    "dropphycty": "SATELLITE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329373972,
    "dropmaladd": "1071 S PATRICK DR STE 101",
    "dropmalcty": "SATELLITE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329373972,
    "dropsitphn": 3217778132,
    "dropsitlph": 3217778132,
    "dropsitcph": 3217739638,
    "dropfax": 3217794760
  },
  {
    "dcode": "D",
    "dropkey": "BY22875",
    "droptype": "D",
    "dropname": "SEMINOLE",
    "dropdeladd": "9355 113TH ST",
    "dropdelcty": "SEMINOLE",
    "dropdelst": "FL",
    "dropdelzpp": 337729998,
    "dropphyadd": "9355 113TH ST",
    "dropphycty": "SEMINOLE",
    "dropphyst": "FL",
    "dropphyzpp": 337729998,
    "dropmaladd": "9355 113TH ST",
    "dropmalcty": "SEMINOLE",
    "dropmalst": "FL",
    "dropmalzpp": 337729998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273940847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY22898",
    "droptype": "D",
    "dropname": "SNAPPER CREEK",
    "dropdeladd": "11000 SW 104TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331169998,
    "dropphyadd": "11000 SW 104TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331169998,
    "dropmaladd": "11000 SW 104TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331169998,
    "dropsitphn": 3052700335,
    "dropsitlph": 3052700335,
    "dropsitcph": 3052700335,
    "dropfax": 3055989248
  },
  {
    "dcode": "D",
    "dropkey": "BY22911",
    "droptype": "D",
    "dropname": "SOUTH DAYTONA",
    "dropdeladd": "2400 S RIDGEWOOD AVE STE 28",
    "dropdelcty": "SOUTH DAYTONA",
    "dropdelst": "FL",
    "dropdelzpp": 321199998,
    "dropphyadd": "2400 S RIDGEWOOD AVE STE 28",
    "dropphycty": "SOUTH DAYTONA",
    "dropphyst": "FL",
    "dropphyzpp": 321199998,
    "dropmaladd": "2400 S RIDGEWOOD AVE STE 28",
    "dropmalcty": "SOUTH DAYTONA",
    "dropmalst": "FL",
    "dropmalzpp": 321199998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3867639155,
    "dropsitcph": 3867639155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY22922",
    "droptype": "D",
    "dropname": "SOUTH MIAMI",
    "dropdeladd": "5927 SW 70TH ST",
    "dropdelcty": "SOUTH MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331439998,
    "dropphyadd": "5927 SW 70TH ST",
    "dropphycty": "SOUTH MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331439998,
    "dropmaladd": "5927 SW 70TH ST",
    "dropmalcty": "SOUTH MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331439998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056615435,
    "dropsitcph": 3056610664,
    "dropfax": 3056616988
  },
  {
    "dcode": "D",
    "dropkey": "BY22944",
    "droptype": "D",
    "dropname": "SOUTHSIDE POSTAL STORE",
    "dropdeladd": "6000 S FLORIDA AVE",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338139996,
    "dropphyadd": "6000 S FLORIDA AVE",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338139996,
    "dropmaladd": "6000 S FLORIDA AVE",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338139996,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8637010757,
    "dropfax": 8636462585
  },
  {
    "dcode": "D",
    "dropkey": "BY22951",
    "droptype": "D",
    "dropname": "SPRING HILL",
    "dropdeladd": "8501 PHILATELIC DR",
    "dropdelcty": "SPRING HILL",
    "dropdelst": "FL",
    "dropdelzpp": 346069998,
    "dropphyadd": "8501 PHILATELIC DR",
    "dropphycty": "SPRING HILL",
    "dropphyst": "FL",
    "dropphyzpp": 346069998,
    "dropmaladd": "8501 PHILATELIC DR",
    "dropmalcty": "SPRING HILL",
    "dropmalst": "FL",
    "dropmalzpp": 346069998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3526833780,
    "dropfax": 3526839714
  },
  {
    "dcode": "D",
    "dropkey": "BY23041",
    "droptype": "D",
    "dropname": "SUN CITY CENTER",
    "dropdeladd": "1645 SUN CITY CENTER PLZ",
    "dropdelcty": "SUN CITY CENTER",
    "dropdelst": "FL",
    "dropdelzpp": 335739998,
    "dropphyadd": "1645 SUN CITY CENTER PLZ",
    "dropphycty": "SUN CITY CENTER",
    "dropphyst": "FL",
    "dropphyzpp": 335739998,
    "dropmaladd": "1645 SUN CITY CENTER PLZ",
    "dropmalcty": "SUN CITY CENTER",
    "dropmalst": "FL",
    "dropmalzpp": 335739998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136341403,
    "dropfax": 8136428081
  },
  {
    "dcode": "D",
    "dropkey": "BY23056",
    "droptype": "D",
    "dropname": "SUNRISE",
    "dropdeladd": "3225 N HIATUS RD",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333459998,
    "dropphyadd": "3225 N HIATUS RD",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333459998,
    "dropmaladd": "3225 N HIATUS RD",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333459998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547479945,
    "dropsitcph": 9547464910,
    "dropfax": 9547418508
  },
  {
    "dcode": "D",
    "dropkey": "BY23061",
    "droptype": "D",
    "dropname": "SUNSET POINT",
    "dropdeladd": "1851 N HERCULES AVE",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "FL",
    "dropdelzpp": 337651149,
    "dropphyadd": "1851 N HERCULES AVE",
    "dropphycty": "CLEARWATER",
    "dropphyst": "FL",
    "dropphyzpp": 337651149,
    "dropmaladd": "1851 N HERCULES AVE",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "FL",
    "dropmalzpp": 337651149,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7274477166,
    "dropfax": 7274617776
  },
  {
    "dcode": "D",
    "dropkey": "BY23063",
    "droptype": "D",
    "dropname": "SUNTREE",
    "dropdeladd": "6105 N WICKHAM RD",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "FL",
    "dropdelzpp": 329409998,
    "dropphyadd": "6105 N WICKHAM RD",
    "dropphycty": "MELBOURNE",
    "dropphyst": "FL",
    "dropphyzpp": 329409998,
    "dropmaladd": "6105 N WICKHAM RD",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "FL",
    "dropmalzpp": 329409998,
    "dropsitphn": 3212547263,
    "dropsitlph": 3212547263,
    "dropsitcph": 3212420426,
    "dropfax": 3212558342
  },
  {
    "dcode": "D",
    "dropkey": "BY23064",
    "droptype": "D",
    "dropname": "SURFSIDE",
    "dropdeladd": "250 95TH ST",
    "dropdelcty": "SURFSIDE",
    "dropdelst": "FL",
    "dropdelzpp": 331549998,
    "dropphyadd": "250 95TH ST",
    "dropphycty": "SURFSIDE",
    "dropphyst": "FL",
    "dropphyzpp": 331549998,
    "dropmaladd": "250 95TH ST",
    "dropmalcty": "SURFSIDE",
    "dropmalst": "FL",
    "dropmalzpp": 331549998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058655475,
    "dropsitcph": 3058679637,
    "dropfax": 3058657390
  },
  {
    "dcode": "D",
    "dropkey": "BY23075",
    "droptype": "D",
    "dropname": "TAMARAC",
    "dropdeladd": "7875 NW 57TH ST",
    "dropdelcty": "TAMARAC",
    "dropdelst": "FL",
    "dropdelzpp": 333519998,
    "dropphyadd": "7875 NW 57TH ST",
    "dropphycty": "TAMARAC",
    "dropphyst": "FL",
    "dropphyzpp": 333519998,
    "dropmaladd": "7875 NW 57TH ST",
    "dropmalcty": "TAMARAC",
    "dropmalst": "FL",
    "dropmalzpp": 333519998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547224476,
    "dropsitcph": 9547224476,
    "dropfax": 9547204752
  },
  {
    "dcode": "D",
    "dropkey": "BY23095",
    "droptype": "D",
    "dropname": "TEQUESTA",
    "dropdeladd": "401 OLD DIXIE HWY",
    "dropdelcty": "JUPITER",
    "dropdelst": "FL",
    "dropdelzpp": 334699998,
    "dropphyadd": "401 OLD DIXIE HWY",
    "dropphycty": "JUPITER",
    "dropphyst": "FL",
    "dropphyzpp": 334699998,
    "dropmaladd": "401 OLD DIXIE HWY",
    "dropmalcty": "JUPITER",
    "dropmalst": "FL",
    "dropmalzpp": 334699998,
    "dropsitphn": 5617434982,
    "dropsitlph": 5617434982,
    "dropsitcph": 5617488368,
    "dropfax": 5617459848
  },
  {
    "dcode": "D",
    "dropkey": "BY23099",
    "droptype": "D",
    "dropname": "TICE",
    "dropdeladd": "4585 PALM BEACH BLVD",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339053510,
    "dropphyadd": "4585 PALM BEACH BLVD",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339053510,
    "dropmaladd": "4585 PALM BEACH BLVD",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339053510,
    "dropsitphn": 8138770729,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396940643,
    "dropfax": 2396940611
  },
  {
    "dcode": "D",
    "dropkey": "BY23107",
    "droptype": "D",
    "dropname": "TOWN N COUNTRY",
    "dropdeladd": "7521 PAULA DR",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336159998,
    "dropphyadd": "7521 PAULA DR",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336159998,
    "dropmaladd": "7521 PAULA DR",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336159998,
    "dropsitphn": 8138770729,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138886839,
    "dropfax": 8132492574
  },
  {
    "dcode": "D",
    "dropkey": "BY23113",
    "droptype": "D",
    "dropname": "FATHER FELIX VARELA",
    "dropdeladd": "14310 SW 8TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331849998,
    "dropphyadd": "14310 SW 8TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331849998,
    "dropmaladd": "14310 SW 8TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331849998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052218869,
    "dropsitcph": 3052211819,
    "dropfax": 3052217863
  },
  {
    "dcode": "D",
    "dropkey": "BY23122",
    "droptype": "D",
    "dropname": "TROPIC",
    "dropdeladd": "600 6TH AVE STE 1",
    "dropdelcty": "VERO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329629998,
    "dropphyadd": "600 6TH AVE STE 1",
    "dropphycty": "VERO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329629998,
    "dropmaladd": "600 6TH AVE STE 1",
    "dropmalcty": "VERO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329629998,
    "dropsitphn": 7727783059,
    "dropsitlph": 7727783059,
    "dropsitcph": 7725692924,
    "dropfax": 7727701792
  },
  {
    "dcode": "D",
    "dropkey": "BY23132",
    "droptype": "D",
    "dropname": "ULETA",
    "dropdeladd": "16750 NE 4TH PL",
    "dropdelcty": "NORTH MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331629998,
    "dropphyadd": "16750 NE 4TH PL",
    "dropphycty": "NORTH MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331629998,
    "dropmaladd": "16750 NE 4TH PL",
    "dropmalcty": "NORTH MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331629998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056511332,
    "dropsitcph": 3056511332,
    "dropfax": 3056535936
  },
  {
    "dcode": "D",
    "dropkey": "BY23134",
    "droptype": "D",
    "dropname": "UNION PARK",
    "dropdeladd": "1801 N ECONLOCKHATCHEE TRL",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328179998,
    "dropphyadd": "1801 N ECONLOCKHATCHEE TRL",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328179998,
    "dropmaladd": "1801 N ECONLOCKHATCHEE TRL",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328179998,
    "dropsitphn": 4072823678,
    "dropsitlph": 4072823678,
    "dropsitcph": 4074828271,
    "dropfax": 4072824079
  },
  {
    "dcode": "D",
    "dropkey": "BY23165",
    "droptype": "D",
    "dropname": "VENTURA",
    "dropdeladd": "7360 CURRY FORD RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328227967,
    "dropphyadd": "7360 CURRY FORD RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328227967,
    "dropmaladd": "PO BOX 729998",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328729998,
    "dropsitphn": 4072750871,
    "dropsitlph": 4072750871,
    "dropsitcph": 4072773501,
    "dropfax": 4072492892
  },
  {
    "dcode": "D",
    "dropkey": "BY23199",
    "droptype": "D",
    "dropname": "WARRINGTON",
    "dropdeladd": "901 S OLD CORRY FIELD RD",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325079998,
    "dropphyadd": "901 S OLD CORRY FIELD RD",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325079998,
    "dropmaladd": "901 S OLD CORRY FIELD RD",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325079998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504573851,
    "dropsitcph": 8504581602,
    "dropfax": 8504551414
  },
  {
    "dcode": "D",
    "dropkey": "BY23208",
    "droptype": "D",
    "dropname": "WEKIVA SPRINGS",
    "dropdeladd": "920 WEKIVA SPRINGS RD",
    "dropdelcty": "LONGWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 327799998,
    "dropphyadd": "920 WEKIVA SPRINGS RD",
    "dropphycty": "LONGWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 327799998,
    "dropmaladd": "920 WEKIVA SPRINGS RD",
    "dropmalcty": "LONGWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 327799998,
    "dropsitphn": 4076826216,
    "dropsitlph": 4076826216,
    "dropsitcph": 4076826216,
    "dropfax": 4076827161
  },
  {
    "dcode": "D",
    "dropkey": "BY23216",
    "droptype": "D",
    "dropname": "ATLANTIC",
    "dropdeladd": "8801 W ATLANTIC BLVD",
    "dropdelcty": "CORAL SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 330719998,
    "dropphyadd": "8801 W ATLANTIC BLVD",
    "dropphycty": "CORAL SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 330719998,
    "dropmaladd": "8801 W ATLANTIC BLVD",
    "dropmalcty": "CORAL SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 330719998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545759081,
    "dropsitcph": 9543452864,
    "dropfax": 9543469706
  },
  {
    "dcode": "D",
    "dropkey": "BY23221",
    "droptype": "D",
    "dropname": "WEST DADE",
    "dropdeladd": "14790 N KENDALL DR",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331969998,
    "dropphyadd": "14790 N KENDALL DR",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331969998,
    "dropmaladd": "14790 N KENDALL DR",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331969998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053853329,
    "dropsitcph": 3053851029,
    "dropfax": 3055519364
  },
  {
    "dcode": "D",
    "dropkey": "BY23273",
    "droptype": "D",
    "dropname": "WINTER SPRINGS",
    "dropdeladd": "1065 E STATE ROAD 434",
    "dropdelcty": "WINTER SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 327089998,
    "dropphyadd": "1065 E STATE ROAD 434",
    "dropphycty": "WINTER SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 327089998,
    "dropmaladd": "1065 E STATE ROAD 434",
    "dropmalcty": "WINTER SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 327089998,
    "dropsitphn": 4073274606,
    "dropsitlph": 4073274606,
    "dropsitcph": 4073274569,
    "dropfax": 4073278171
  },
  {
    "dcode": "D",
    "dropkey": "BY23361",
    "droptype": "D",
    "dropname": "BARKSDALE AFB",
    "dropdeladd": "450 CURTISS RD",
    "dropdelcty": "BARKSDALE AFB",
    "dropdelst": "LA",
    "dropdelzpp": 711102420,
    "dropphyadd": "450 CURTISS RD",
    "dropphycty": "BARKSDALE AFB",
    "dropphyst": "LA",
    "dropphyzpp": 711102420,
    "dropmaladd": "450 CURTISS RD",
    "dropmalcty": "BARKSDALE AFB",
    "dropmalst": "LA",
    "dropmalzpp": 711102420,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187467926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY23442",
    "droptype": "D",
    "dropname": "BRIDGE CITY",
    "dropdeladd": "1507 BRIDGE CITY AVE",
    "dropdelcty": "WESTWEGO",
    "dropdelst": "LA",
    "dropdelzpp": 700943200,
    "dropphyadd": "1507 BRIDGE CITY AVE",
    "dropphycty": "WESTWEGO",
    "dropphyst": "LA",
    "dropphyzpp": 700943200,
    "dropmaladd": "1507 BRIDGE CITY AVE",
    "dropmalcty": "WESTWEGO",
    "dropmalst": "LA",
    "dropmalzpp": 700943200,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044369543,
    "dropfax": 5044362265
  },
  {
    "dcode": "D",
    "dropkey": "BY23515",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "13515 HOOPER RD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708182912,
    "dropphyadd": "13515 HOOPER RD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708182912,
    "dropmaladd": "PO BOX 78000",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708379998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2252617133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY23671",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "5720 CITRUS BLVD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701235855,
    "dropphyadd": "5720 CITRUS BLVD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701235855,
    "dropmaladd": "5720 CITRUS BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701235855,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048180579,
    "dropfax": 5048180892
  },
  {
    "dcode": "D",
    "dropkey": "BY23736",
    "droptype": "D",
    "dropname": "FORT JOHNSON",
    "dropdeladd": "6180 UNIVERSITY PKWY",
    "dropdelcty": "FORT JOHNSON",
    "dropdelst": "LA",
    "dropdelzpp": 714599998,
    "dropphyadd": "6180 UNIVERSITY PKWY",
    "dropphycty": "FORT JOHNSON",
    "dropphyst": "LA",
    "dropphyzpp": 714599998,
    "dropmaladd": "6180 UNIVERSITY PKWY",
    "dropmalcty": "FORT JOHNSON",
    "dropmalst": "LA",
    "dropmalzpp": 714599998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3375375569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY23839",
    "droptype": "D",
    "dropname": "HARAHAN",
    "dropdeladd": "5720 CITRUS BLVD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701235855,
    "dropphyadd": "5720 CITRUS BLVD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701239997,
    "dropmaladd": "5720 CITRUS BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701235855,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048180892,
    "dropfax": 5045891010
  },
  {
    "dcode": "D",
    "dropkey": "BY23923",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "5720 CITRUS BLVD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701235854,
    "dropphyadd": "5720 CITRUS BLVD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701235854,
    "dropmaladd": "5720 CITRUS BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701235854,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891268,
    "dropsitcph": 5048180892,
    "dropfax": 5045891010
  },
  {
    "dcode": "D",
    "dropkey": "BY24740",
    "droptype": "D",
    "dropname": "APPLE VALLEY",
    "dropdeladd": "7287 153RD ST W",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551247019,
    "dropphyadd": "7287 153RD ST W",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551247019,
    "dropmaladd": "7287 153RD ST W",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529973032,
    "dropsitcph": 9529973031,
    "dropfax": 9528918361
  },
  {
    "dcode": "D",
    "dropkey": "BY24862",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "9641 GARFIELD AVE S",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554209998,
    "dropphyadd": "9641 GARFIELD AVE S",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554209998,
    "dropmaladd": "9641 GARFIELD AVE S",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528845325,
    "dropsitcph": 9528845325,
    "dropfax": 9528815356
  },
  {
    "dcode": "D",
    "dropkey": "BY24904",
    "droptype": "D",
    "dropname": "BROOKLYN CENTER",
    "dropdeladd": "6848 LEE AVE N",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554299998,
    "dropphyadd": "6848 LEE AVE N",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554299998,
    "dropmaladd": "6848 LEE AVE N",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635668701,
    "dropsitcph": 7635613995,
    "dropfax": 7635660961
  },
  {
    "dcode": "D",
    "dropkey": "BY24907",
    "droptype": "D",
    "dropname": "BROOKLYN PARK",
    "dropdeladd": "5001 EDINBROOK TER",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554434200,
    "dropphyadd": "5001 EDINBROOK TER",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554434200,
    "dropmaladd": "5001 EDINBROOK TER",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7633910753,
    "dropsitcph": 7633910753,
    "dropfax": 7633153017
  },
  {
    "dcode": "D",
    "dropkey": "BY24936",
    "droptype": "D",
    "dropname": "BURNSVILLE",
    "dropdeladd": "13800 NICOLLET BLVD",
    "dropdelcty": "BURNSVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 553379929,
    "dropphyadd": "13800 NICOLLET BLVD",
    "dropphycty": "BURNSVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 553379929,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNSVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 553379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528902274,
    "dropsitcph": 9528902274,
    "dropfax": 9528903967
  },
  {
    "dcode": "D",
    "dropkey": "BY25050",
    "droptype": "D",
    "dropname": "COLUMBIA HEIGHTS",
    "dropdeladd": "940 44TH AVE NE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554213047,
    "dropphyadd": "940 44TH AVE NE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554213047,
    "dropmaladd": "940 44TH AVE NE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7637813166,
    "dropsitcph": 7637813166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25063",
    "droptype": "D",
    "dropname": "COON RAPIDS",
    "dropdeladd": "10250 FOLEY BLVD NW",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554489998,
    "dropphyadd": "10250 FOLEY BLVD NW",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554489998,
    "dropmaladd": "10250 FOLEY BLVD NW",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554489998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7638629638,
    "dropsitcph": 7638629638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25093",
    "droptype": "D",
    "dropname": "CRYSTAL",
    "dropdeladd": "5550 W BROADWAY AVE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554283551,
    "dropphyadd": "5550 W BROADWAY AVE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554283551,
    "dropmaladd": "5550 W BROADWAY AVE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554283551,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635378462,
    "dropsitcph": 7635360493,
    "dropfax": 7635378462
  },
  {
    "dcode": "D",
    "dropkey": "BY25172",
    "droptype": "D",
    "dropname": "EAGAN",
    "dropdeladd": "3145 LEXINGTON AVE S",
    "dropdelcty": "EAGAN",
    "dropdelst": "MN",
    "dropdelzpp": 551214201,
    "dropphyadd": "3145 LEXINGTON AVE S",
    "dropphycty": "EAGAN",
    "dropphyst": "MN",
    "dropphyzpp": 551214201,
    "dropmaladd": "3145 LEXINGTON AVE S",
    "dropmalcty": "EAGAN",
    "dropmalst": "MN",
    "dropmalzpp": 551214201,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514053142,
    "dropsitcph": 6514053068,
    "dropfax": 6514549478
  },
  {
    "dcode": "D",
    "dropkey": "BY25182",
    "droptype": "D",
    "dropname": "EASTERN HEIGHTS",
    "dropdeladd": "1175 GERSHWIN AVE N",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551286127,
    "dropphyadd": "1175 GERSHWIN AVE N",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551286127,
    "dropmaladd": "1175 GERSHWIN AVE N",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6515786969,
    "dropsitcph": 6515014658,
    "dropfax": 6124351503
  },
  {
    "dcode": "D",
    "dropkey": "BY25191",
    "droptype": "D",
    "dropname": "EDEN PRAIRIE",
    "dropdeladd": "8725 COLUMBINE RD",
    "dropdelcty": "EDEN PRAIRIE",
    "dropdelst": "MN",
    "dropdelzpp": 553449712,
    "dropphyadd": "8725 COLUMBINE RD",
    "dropphycty": "EDEN PRAIRIE",
    "dropphyst": "MN",
    "dropphyzpp": 553449712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDEN PRAIRIE",
    "dropmalst": "MN",
    "dropmalzpp": 553449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529479071,
    "dropsitcph": 9529447186,
    "dropfax": 9529429011
  },
  {
    "dcode": "D",
    "dropkey": "BY25198",
    "droptype": "D",
    "dropname": "EDINA",
    "dropdeladd": "3948 MARKET ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554249998,
    "dropphyadd": "3948 MARKET ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554249998,
    "dropmaladd": "3948 MARKET ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529266569,
    "dropsitcph": 9529266569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25318",
    "droptype": "D",
    "dropname": "FRIDLEY",
    "dropdeladd": "7440 UNIVERSITY AVE NE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554329998,
    "dropphyadd": "7440 UNIVERSITY AVE NE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554329998,
    "dropmaladd": "7440 UNIVERSITY AVE NE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635711508,
    "dropsitcph": 7635712016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25356",
    "droptype": "D",
    "dropname": "GOLDEN VALLEY",
    "dropdeladd": "7701 GOLDEN VALLEY RD",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554279998,
    "dropphyadd": "7701 GOLDEN VALLEY RD",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554279998,
    "dropmaladd": "7701 GOLDEN VALLEY RD",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635444126,
    "dropsitcph": 7635444126,
    "dropfax": 7635444380
  },
  {
    "dcode": "D",
    "dropkey": "BY25723",
    "droptype": "D",
    "dropname": "LOST LAKE",
    "dropdeladd": "9705 45TH AVE N",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554422566,
    "dropphyadd": "9705 45TH AVE N",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554422566,
    "dropmaladd": "9705 45TH AVE N",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554429998,
    "dropsitphn": 6123499163,
    "dropsitlph": 7635771068,
    "dropsitcph": 7635771068,
    "dropfax": 7635510826
  },
  {
    "dcode": "D",
    "dropkey": "BY25765",
    "droptype": "D",
    "dropname": "MAPLE GROVE",
    "dropdeladd": "13500 GROVE DR",
    "dropdelcty": "MAPLE GROVE",
    "dropdelst": "MN",
    "dropdelzpp": 553119902,
    "dropphyadd": "13500 GROVE DR",
    "dropphycty": "MAPLE GROVE",
    "dropphyst": "MN",
    "dropphyzpp": 553119902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE GROVE",
    "dropmalst": "MN",
    "dropmalzpp": 553119998,
    "dropsitphn": 6123499163,
    "dropsitlph": 7634944738,
    "dropsitcph": 7634940123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25817",
    "droptype": "D",
    "dropname": "MENDOTA",
    "dropdeladd": "1310 SIBLEY MEMORIAL HWY",
    "dropdelcty": "MENDOTA",
    "dropdelst": "MN",
    "dropdelzpp": 551501430,
    "dropphyadd": "1310 SIBLEY MEMORIAL HWY",
    "dropphycty": "MENDOTA",
    "dropphyst": "MN",
    "dropphyzpp": 551501430,
    "dropmaladd": "1310 SIBLEY MEMORIAL HWY",
    "dropmalcty": "MENDOTA",
    "dropmalst": "MN",
    "dropmalzpp": 551501430,
    "dropsitphn": 6123496399,
    "dropsitlph": 6519944509,
    "dropsitcph": 6519944501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25856",
    "droptype": "D",
    "dropname": "MINNETONKA",
    "dropdeladd": "14702 EXCELSIOR BLVD",
    "dropdelcty": "MINNETONKA",
    "dropdelst": "MN",
    "dropdelzpp": 553459909,
    "dropphyadd": "14702 EXCELSIOR BLVD",
    "dropphycty": "MINNETONKA",
    "dropphyst": "MN",
    "dropphyzpp": 553459909,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNETONKA",
    "dropmalst": "MN",
    "dropmalzpp": 553459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529354909,
    "dropsitcph": 9529354909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25972",
    "droptype": "D",
    "dropname": "NORMANDALE",
    "dropdeladd": "5108 W 74TH ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554392300,
    "dropphyadd": "5108 W 74TH ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554392300,
    "dropmaladd": "5108 W 74TH ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528351150,
    "dropsitcph": 9528351150,
    "dropfax": 9528359588
  },
  {
    "dcode": "D",
    "dropkey": "BY25977",
    "droptype": "D",
    "dropname": "NORTH MANKATO",
    "dropdeladd": "245 BELGRADE AVE",
    "dropdelcty": "NORTH MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560033803,
    "dropphyadd": "245 BELGRADE AVE",
    "dropphycty": "NORTH MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560033803,
    "dropmaladd": "245 BELGRADE AVE",
    "dropmalcty": "NORTH MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560033803,
    "dropsitphn": 6123496399,
    "dropsitlph": 5076256587,
    "dropsitcph": 5073455834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY25981",
    "droptype": "D",
    "dropname": "NORTH SAINT PAUL",
    "dropdeladd": "2523 7TH AVE E",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551099969,
    "dropphyadd": "2523 7TH AVE E",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551099969,
    "dropmaladd": "2523 7TH AVE E",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551099969,
    "dropsitphn": 6123496399,
    "dropsitlph": 6517702919,
    "dropsitcph": 6517702919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26112",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "3300 PLYMOUTH BLVD",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554471446,
    "dropphyadd": "3300 PLYMOUTH BLVD",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554471446,
    "dropmaladd": "3300 PLYMOUTH BLVD",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554479998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635771509,
    "dropsitcph": 7635571509,
    "dropfax": 7635500514
  },
  {
    "dcode": "D",
    "dropkey": "BY26132",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "217 2ND ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558101650,
    "dropphyadd": "217 2ND ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558101650,
    "dropmaladd": "217 2ND ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558101610,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186242530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26170",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "825 W 65TH ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554239998,
    "dropphyadd": "825 W 65TH ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554239998,
    "dropmaladd": "825 W 65TH ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6128693479,
    "dropsitcph": 6128693479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26182",
    "droptype": "D",
    "dropname": "ROBBINSDALE",
    "dropdeladd": "4048 LAKELAND AVE N",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554229998,
    "dropphyadd": "4048 LAKELAND AVE N",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554229998,
    "dropmaladd": "4048 LAKELAND AVE N",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635359951,
    "dropsitcph": 7635359936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26204",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "2000 COUNTY ROAD B2 W",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551139998,
    "dropphyadd": "2000 COUNTY ROAD B2 W",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551139998,
    "dropmaladd": "2000 COUNTY ROAD B2 W",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516310742,
    "dropsitcph": 6516310628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26248",
    "droptype": "D",
    "dropname": "SAINT LOUIS PARK",
    "dropdeladd": "2700 LOUISIANA AVE S",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554263109,
    "dropphyadd": "2700 LOUISIANA AVE S",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554263109,
    "dropmaladd": "2700 LOUISIANA AVE S",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9522855372,
    "dropsitcph": 9522855372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26275",
    "droptype": "D",
    "dropname": "SAUK RAPIDS",
    "dropdeladd": "1239 2ND ST N",
    "dropdelcty": "SAUK RAPIDS",
    "dropdelst": "MN",
    "dropdelzpp": 563792675,
    "dropphyadd": "1239 2ND ST N",
    "dropphycty": "SAUK RAPIDS",
    "dropphyst": "MN",
    "dropphyzpp": 563792675,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAUK RAPIDS",
    "dropmalst": "MN",
    "dropmalzpp": 563799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202514865,
    "dropfax": 3202513369
  },
  {
    "dcode": "D",
    "dropkey": "BY26556",
    "droptype": "D",
    "dropname": "TWIN CITIES",
    "dropdeladd": "5001 NORTHWEST DR",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551113032,
    "dropphyadd": "5001 NORTHWEST DR",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551113032,
    "dropmaladd": "5001 NORTHWEST DR",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551113032,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933779,
    "dropsitcph": 6129707643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26611",
    "droptype": "D",
    "dropname": "WAITE PARK",
    "dropdeladd": "254 2ND AVE S",
    "dropdelcty": "WAITE PARK",
    "dropdelst": "MN",
    "dropdelzpp": 563872312,
    "dropphyadd": "254 2ND AVE S",
    "dropphycty": "WAITE PARK",
    "dropphyst": "MN",
    "dropphyzpp": 563872312,
    "dropmaladd": "254 2ND AVE S",
    "dropmalcty": "WAITE PARK",
    "dropmalst": "MN",
    "dropmalzpp": 563872312,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202518415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26652",
    "droptype": "D",
    "dropname": "BURNETT",
    "dropdeladd": "6101 W OLD SHAKOPEE RD",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554389998,
    "dropphyadd": "6101 W OLD SHAKOPEE RD",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554389998,
    "dropmaladd": "6101 W OLD SHAKOPEE RD",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528843698,
    "dropsitcph": 9528843698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY26656",
    "droptype": "D",
    "dropname": "WEST EDINA",
    "dropdeladd": "7360 BUSH LAKE RD",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554392062,
    "dropphyadd": "7360 BUSH LAKE RD",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554392062,
    "dropmaladd": "7360 BUSH LAKE RD",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554392062,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528931357,
    "dropsitcph": 9529219850,
    "dropfax": 9528931630
  },
  {
    "dcode": "D",
    "dropkey": "BY26659",
    "droptype": "D",
    "dropname": "WEST SAINT PAUL",
    "dropdeladd": "1970 CHRISTENSEN AVE",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551184600,
    "dropphyadd": "1970 CHRISTENSEN AVE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551184600,
    "dropmaladd": "1970 CHRISTENSEN AVE",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551184600,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514573996,
    "dropsitcph": 6514559551,
    "dropfax": 6414573514
  },
  {
    "dcode": "D",
    "dropkey": "BY26672",
    "droptype": "D",
    "dropname": "WHITE BEAR LAKE",
    "dropdeladd": "2223 5TH ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551103024,
    "dropphyadd": "2223 5TH ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551103024,
    "dropmaladd": "2223 5TH ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514296284,
    "dropsitcph": 6517621437,
    "dropfax": 6517620435
  },
  {
    "dcode": "D",
    "dropkey": "BY26712",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "7595 CURRELL BLVD",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551252505,
    "dropphyadd": "7595 CURRELL BLVD",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551252505,
    "dropmaladd": "7595 CURRELL BLVD",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6515017903,
    "dropsitcph": 6515010008,
    "dropfax": 6124351513
  },
  {
    "dcode": "D",
    "dropkey": "BY26737",
    "droptype": "D",
    "dropname": "PALMS WEST",
    "dropdeladd": "10299 SOUTHERN BLVD",
    "dropdelcty": "ROYAL PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334119998,
    "dropphyadd": "10299 SOUTHERN BLVD",
    "dropphycty": "ROYAL PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334119998,
    "dropmaladd": "10299 SOUTHERN BLVD",
    "dropmalcty": "ROYAL PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334119998,
    "dropsitphn": 5612463479,
    "dropsitlph": 5612463479,
    "dropsitcph": 5612463479,
    "dropfax": 5613522607
  },
  {
    "dcode": "D",
    "dropkey": "BY26892",
    "droptype": "D",
    "dropname": "SOUTH CREEK",
    "dropdeladd": "1701 W WETHERBEE RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328379998,
    "dropphyadd": "1701 W WETHERBEE RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328379998,
    "dropmaladd": "1701 W WETHERBEE RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328379998,
    "dropsitphn": 4078556658,
    "dropsitlph": 4078556658,
    "dropsitcph": 4078556568,
    "dropfax": 4078556066
  },
  {
    "dcode": "D",
    "dropkey": "BY26910",
    "droptype": "D",
    "dropname": "GREENACRES",
    "dropdeladd": "4300 S JOG RD",
    "dropdelcty": "GREENACRES",
    "dropdelst": "FL",
    "dropdelzpp": 334679998,
    "dropphyadd": "4300 S JOG RD",
    "dropphycty": "GREENACRES",
    "dropphyst": "FL",
    "dropphyzpp": 334679998,
    "dropmaladd": "4300 S JOG RD",
    "dropmalcty": "GREENACRES",
    "dropmalst": "FL",
    "dropmalzpp": 334679998,
    "dropsitphn": 5616491574,
    "dropsitlph": 5616491574,
    "dropsitcph": 5616492039,
    "dropfax": 5619671164
  },
  {
    "dcode": "D",
    "dropkey": "BY26911",
    "droptype": "D",
    "dropname": "HAVERHILL BR",
    "dropdeladd": "3900 N HAVERHILL RD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334179998,
    "dropphyadd": "3900 N HAVERHILL RD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334179998,
    "dropmaladd": "3900 N HAVERHILL RD",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334179998,
    "dropsitphn": 5616158307,
    "dropsitlph": 5616158307,
    "dropsitcph": 5616869402,
    "dropfax": 5616830683
  },
  {
    "dcode": "D",
    "dropkey": "BY26942",
    "droptype": "D",
    "dropname": "PALM BEACH GARDENS MALL",
    "dropdeladd": "3101 PGA BLVD STE E160",
    "dropdelcty": "PALM BEACH GARDENS",
    "dropdelst": "FL",
    "dropdelzpp": 334109991,
    "dropphyadd": "3101 PGA BLVD STE E160",
    "dropphycty": "PALM BEACH GARDENS",
    "dropphyst": "FL",
    "dropphyzpp": 334109991,
    "dropmaladd": "3101 PGA BLVD STE E160",
    "dropmalcty": "PALM BEACH GARDENS",
    "dropmalst": "FL",
    "dropmalzpp": 334109991,
    "dropsitphn": 5617993941,
    "dropsitlph": 5617993941,
    "dropsitcph": 5617994068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY27116",
    "droptype": "D",
    "dropname": "JOG ROAD",
    "dropdeladd": "6400 BOYNTON BEACH BLVD",
    "dropdelcty": "BOYNTON BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334379998,
    "dropphyadd": "6400 BOYNTON BEACH BLVD",
    "dropphycty": "BOYNTON BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334379998,
    "dropmaladd": "6400 BOYNTON BEACH BLVD",
    "dropmalcty": "BOYNTON BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334379998,
    "dropsitphn": 5617337444,
    "dropsitlph": 5617407320,
    "dropsitcph": 5617407320,
    "dropfax": 5617337414
  },
  {
    "dcode": "D",
    "dropkey": "BY27124",
    "droptype": "D",
    "dropname": "CELEBRATION",
    "dropdeladd": "601 MARKET ST",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347479992,
    "dropphyadd": "601 MARKET ST",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347479992,
    "dropmaladd": "601 MARKET ST",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347479992,
    "dropsitphn": 4075661110,
    "dropsitlph": 4075661110,
    "dropsitcph": 4073967001,
    "dropfax": 4075662008
  },
  {
    "dcode": "D",
    "dropkey": "BY27133",
    "droptype": "D",
    "dropname": "INVERRARY",
    "dropdeladd": "6240 W OAKLAND PARK BLVD",
    "dropdelcty": "LAUDERHILL",
    "dropdelst": "FL",
    "dropdelzpp": 333199998,
    "dropphyadd": "6240 W OAKLAND PARK BLVD",
    "dropphycty": "LAUDERHILL",
    "dropphyst": "FL",
    "dropphyzpp": 333199998,
    "dropmaladd": "6240 W OAKLAND PARK BLVD",
    "dropmalcty": "LAUDERHILL",
    "dropmalst": "FL",
    "dropmalzpp": 333199998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545724276,
    "dropsitcph": 9547426522,
    "dropfax": 9545726450
  },
  {
    "dcode": "D",
    "dropkey": "BY27173",
    "droptype": "D",
    "dropname": "FLAMINGO",
    "dropdeladd": "12590 PINES BLVD",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330279998,
    "dropphyadd": "12590 PINES BLVD",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330279998,
    "dropmaladd": "12590 PINES BLVD",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330279998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544417355,
    "dropsitcph": 9544418427,
    "dropfax": 7542634479
  },
  {
    "dcode": "D",
    "dropkey": "BY27186",
    "droptype": "D",
    "dropname": "HOLIDAY ISLAND",
    "dropdeladd": "7 PARKCLIFF DR",
    "dropdelcty": "HOLIDAY ISLAND",
    "dropdelst": "AR",
    "dropdelzpp": 726319998,
    "dropphyadd": "7 PARKCLIFF DR",
    "dropphycty": "HOLIDAY ISLAND",
    "dropphyst": "AR",
    "dropphyzpp": 726319998,
    "dropmaladd": "7 PARKCLIFF DR",
    "dropmalcty": "HOLIDAY ISLAND",
    "dropmalst": "AR",
    "dropmalzpp": 726319998,
    "dropsitphn": 4792535701,
    "dropsitlph": 4792535701,
    "dropsitcph": 4792535701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY27258",
    "droptype": "D",
    "dropname": "HUTCHINSON BEACH",
    "dropdeladd": "11007 S OCEAN DR",
    "dropdelcty": "JENSEN BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 349579991,
    "dropphyadd": "11007 S OCEAN DR",
    "dropphycty": "JENSEN BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 349579991,
    "dropmaladd": "11007 S OCEAN DR",
    "dropmalcty": "JENSEN BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 349579991,
    "dropsitphn": 5612291178,
    "dropsitlph": 5612291178,
    "dropsitcph": 7722320869,
    "dropfax": 5612291347
  },
  {
    "dcode": "D",
    "dropkey": "BY27334",
    "droptype": "D",
    "dropname": "THE HIGHLANDS",
    "dropdeladd": "1750 FOREST HILLS BLVD",
    "dropdelcty": "BELLA VISTA",
    "dropdelst": "AR",
    "dropdelzpp": 727159998,
    "dropphyadd": "1750 FOREST HILLS BLVD",
    "dropphycty": "BELLA VISTA",
    "dropphyst": "AR",
    "dropphyzpp": 727159998,
    "dropmaladd": "1750 FOREST HILLS BLVD",
    "dropmalcty": "BELLA VISTA",
    "dropmalst": "AR",
    "dropmalzpp": 727159998,
    "dropsitphn": 4798550307,
    "dropsitlph": 4798559891,
    "dropsitcph": 4798559891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY27351",
    "droptype": "D",
    "dropname": "SABAL PALM",
    "dropdeladd": "5451 N STATE ROAD 7",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333192951,
    "dropphyadd": "5451 N STATE ROAD 7",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333192951,
    "dropmaladd": "5451 N STATE ROAD 7",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333192951,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547426522,
    "dropsitcph": 9547426522,
    "dropfax": 9544861782
  },
  {
    "dcode": "D",
    "dropkey": "BY27354",
    "droptype": "D",
    "dropname": "TOWN & COUNTRY POSTAL STORE",
    "dropdeladd": "8266 MILLS DR",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 332839998,
    "dropphyadd": "8266 MILLS DR",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 332839998,
    "dropmaladd": "8266 MILLS DR",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 332839998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052790679,
    "dropsitcph": 3055965485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY27374",
    "droptype": "D",
    "dropname": "CORAL REEF",
    "dropdeladd": "6295 W SAMPLE RD",
    "dropdelcty": "CORAL SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 330679998,
    "dropphyadd": "6295 W SAMPLE RD",
    "dropphycty": "CORAL SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 330679998,
    "dropmaladd": "6295 W SAMPLE RD",
    "dropmalcty": "CORAL SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 330679998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9543440386,
    "dropsitcph": 9543440538,
    "dropfax": 9547578465
  },
  {
    "dcode": "D",
    "dropkey": "BY27382",
    "droptype": "D",
    "dropname": "PALM BAY WEST",
    "dropdeladd": "950 MALABAR RD SW",
    "dropdelcty": "PALM BAY",
    "dropdelst": "FL",
    "dropdelzpp": 329079998,
    "dropphyadd": "950 MALABAR RD SW",
    "dropphycty": "PALM BAY",
    "dropphyst": "FL",
    "dropphyzpp": 329079998,
    "dropmaladd": "950 MALABAR RD SW",
    "dropmalcty": "PALM BAY",
    "dropmalst": "FL",
    "dropmalzpp": 329079998,
    "dropsitphn": 3219569844,
    "dropsitlph": 3219569844,
    "dropsitcph": 3219849658,
    "dropfax": 3219561729
  },
  {
    "dcode": "D",
    "dropkey": "BY27389",
    "droptype": "D",
    "dropname": "CITRUS RIDGE",
    "dropdeladd": "8500 20TH ST",
    "dropdelcty": "VERO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329669998,
    "dropphyadd": "8500 20TH ST",
    "dropphycty": "VERO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329669998,
    "dropmaladd": "8500 20TH ST",
    "dropmalcty": "VERO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329669998,
    "dropsitphn": 7725624302,
    "dropsitlph": 7725624302,
    "dropsitcph": 7725622580,
    "dropfax": 7725627068
  },
  {
    "dcode": "D",
    "dropkey": "BY27390",
    "droptype": "D",
    "dropname": "WEST MELBOURNE",
    "dropdeladd": "2305 MINTON RD",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "FL",
    "dropdelzpp": 329049998,
    "dropphyadd": "2305 MINTON RD",
    "dropphycty": "MELBOURNE",
    "dropphyst": "FL",
    "dropphyzpp": 329049998,
    "dropmaladd": "2305 MINTON RD",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "FL",
    "dropmalzpp": 329049998,
    "dropsitphn": 3217330658,
    "dropsitlph": 3217330658,
    "dropsitcph": 3217330427,
    "dropfax": 3217331037
  },
  {
    "dcode": "D",
    "dropkey": "BY27398",
    "droptype": "D",
    "dropname": "MARICAMP",
    "dropdeladd": "6530 SE MARICAMP RD",
    "dropdelcty": "OCALA",
    "dropdelst": "FL",
    "dropdelzpp": 344722808,
    "dropphyadd": "6530 SE MARICAMP RD",
    "dropphycty": "OCALA",
    "dropphyst": "FL",
    "dropphyzpp": 344722808,
    "dropmaladd": "PO BOX 839998",
    "dropmalcty": "OCALA",
    "dropmalst": "FL",
    "dropmalzpp": 344839998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526870463,
    "dropsitcph": 3526870463,
    "dropfax": 3526870024
  },
  {
    "dcode": "D",
    "dropkey": "BY27402",
    "droptype": "D",
    "dropname": "BOCA RIO BR",
    "dropdeladd": "8185 VIA ANCHO RD",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334339998,
    "dropphyadd": "8185 VIA ANCHO RD",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334339998,
    "dropmaladd": "8185 VIA ANCHO RD",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334339998,
    "dropsitphn": 5614793089,
    "dropsitlph": 5614793089,
    "dropsitcph": 5612874558,
    "dropfax": 5618838655
  },
  {
    "dcode": "D",
    "dropkey": "BY27404",
    "droptype": "D",
    "dropname": "AVENUE OF THE AMERICAS",
    "dropdeladd": "1455 NW 107TH AVE STE 106",
    "dropdelcty": "DORAL",
    "dropdelst": "FL",
    "dropdelzpp": 331729997,
    "dropphyadd": "1455 NW 107TH AVE STE 106",
    "dropphycty": "DORAL",
    "dropphyst": "FL",
    "dropphyzpp": 331729997,
    "dropmaladd": "1455 NW 107TH AVE STE 106",
    "dropmalcty": "DORAL",
    "dropmalst": "FL",
    "dropmalzpp": 331729997,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054062314,
    "dropsitcph": 3053922567,
    "dropfax": 3054061389
  },
  {
    "dcode": "D",
    "dropkey": "BY27473",
    "droptype": "D",
    "dropname": "RIVERLAND",
    "dropdeladd": "3945 W BROWARD BLVD",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333129997,
    "dropphyadd": "3945 W BROWARD BLVD",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333129997,
    "dropmaladd": "3945 W BROWARD BLVD",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333129997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9543168052,
    "dropsitcph": 9543168052,
    "dropfax": 9543169342
  },
  {
    "dcode": "D",
    "dropkey": "BY27487",
    "droptype": "D",
    "dropname": "HILLCREST",
    "dropdeladd": "4429 HOLLYWOOD BLVD",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 330219997,
    "dropphyadd": "4429 HOLLYWOOD BLVD",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 330219997,
    "dropmaladd": "4429 HOLLYWOOD BLVD",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 330219997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9548937872,
    "dropsitcph": 9549268669,
    "dropfax": 9549624541
  },
  {
    "dcode": "D",
    "dropkey": "BY27815",
    "droptype": "D",
    "dropname": "WEST HOLLYWOOD",
    "dropdeladd": "1901 S STATE ROAD 7",
    "dropdelcty": "WEST PARK",
    "dropdelst": "FL",
    "dropdelzpp": 330236733,
    "dropphyadd": "1901 S STATE ROAD 7",
    "dropphycty": "WEST PARK",
    "dropphyst": "FL",
    "dropphyzpp": 330236733,
    "dropmaladd": "1901 S STATE ROAD 7",
    "dropmalcty": "WEST PARK",
    "dropmalst": "FL",
    "dropmalzpp": 330239997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549840559,
    "dropsitcph": 9548946599,
    "dropfax": 9549624549
  },
  {
    "dcode": "D",
    "dropkey": "BY27816",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "7972 PINES BLVD",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330246921,
    "dropphyadd": "7972 PINES BLVD",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330246921,
    "dropmaladd": "7972 PINES BLVD",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330246921,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549664792,
    "dropsitcph": 9544417427,
    "dropfax": 9549646911
  },
  {
    "dcode": "D",
    "dropkey": "BY27936",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "516 NORTHWOOD RD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334079998,
    "dropphyadd": "516 NORTHWOOD RD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334079998,
    "dropmaladd": "516 NORTHWOOD RD",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334079998,
    "dropsitphn": 5618411920,
    "dropsitlph": 5618411920,
    "dropsitcph": 5618411920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY27937",
    "droptype": "D",
    "dropname": "PINECREST",
    "dropdeladd": "11301 S DIXIE HWY",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 332569998,
    "dropphyadd": "11301 S DIXIE HWY",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 332569998,
    "dropmaladd": "11301 S DIXIE HWY",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 332569998,
    "dropsitphn": 3052746702,
    "dropsitlph": 3052596828,
    "dropsitcph": 3052596828,
    "dropfax": 3055060016
  },
  {
    "dcode": "D",
    "dropkey": "BY27984",
    "droptype": "D",
    "dropname": "WEST DELRAY BEACH",
    "dropdeladd": "10290 ATLANTIC AVE",
    "dropdelcty": "DELRAY BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334469998,
    "dropphyadd": "10290 ATLANTIC AVE",
    "dropphycty": "DELRAY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334469998,
    "dropmaladd": "10290 ATLANTIC AVE",
    "dropmalcty": "DELRAY BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334469998,
    "dropsitphn": 5616374524,
    "dropsitlph": 5616374524,
    "dropsitcph": 5616377750,
    "dropfax": 5616373882
  },
  {
    "dcode": "D",
    "dropkey": "BY28006",
    "droptype": "D",
    "dropname": "WHITE HALL",
    "dropdeladd": "7402 DOLLARWAY RD",
    "dropdelcty": "WHITE HALL",
    "dropdelst": "AR",
    "dropdelzpp": 716029998,
    "dropphyadd": "7402 DOLLARWAY RD",
    "dropphycty": "WHITE HALL",
    "dropphyst": "AR",
    "dropphyzpp": 716029998,
    "dropmaladd": "7402 DOLLARWAY RD",
    "dropmalcty": "WHITE HALL",
    "dropmalst": "AR",
    "dropmalzpp": 716029998,
    "dropsitphn": 8705353559,
    "dropsitlph": 8702478223,
    "dropsitcph": 8702478223,
    "dropfax": 8705359512
  },
  {
    "dcode": "D",
    "dropkey": "BY28045",
    "droptype": "D",
    "dropname": "MILAM DAIRY",
    "dropdeladd": "5600 NW 72ND AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331669998,
    "dropphyadd": "5600 NW 72ND AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331669998,
    "dropmaladd": "5600 NW 72ND AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331669998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058636330,
    "dropsitcph": 3058856758,
    "dropfax": 3058636332
  },
  {
    "dcode": "D",
    "dropkey": "BY28047",
    "droptype": "D",
    "dropname": "DORAL",
    "dropdeladd": "1700 NW 97TH AVE",
    "dropdelcty": "DORAL",
    "dropdelst": "FL",
    "dropdelzpp": 331729998,
    "dropphyadd": "1700 NW 97TH AVE",
    "dropphycty": "DORAL",
    "dropphyst": "FL",
    "dropphyzpp": 331729998,
    "dropmaladd": "1700 NW 97TH AVE",
    "dropmalcty": "DORAL",
    "dropmalst": "FL",
    "dropmalzpp": 331729998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054182116,
    "dropsitcph": 3054182053,
    "dropfax": 3054182119
  },
  {
    "dcode": "D",
    "dropkey": "BY28048",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "1870 N CORPORATE LAKES BLVD",
    "dropdelcty": "WESTON",
    "dropdelst": "FL",
    "dropdelzpp": 333269998,
    "dropphyadd": "1870 N CORPORATE LAKES BLVD",
    "dropphycty": "WESTON",
    "dropphyst": "FL",
    "dropphyzpp": 333269998,
    "dropmaladd": "1870 N CORPORATE LAKES BLVD",
    "dropmalcty": "WESTON",
    "dropmalst": "FL",
    "dropmalzpp": 333269998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9542178528,
    "dropsitcph": 9542178528,
    "dropfax": 9542331355
  },
  {
    "dcode": "D",
    "dropkey": "BY28139",
    "droptype": "D",
    "dropname": "FALKENBURG",
    "dropdeladd": "10121 E ADAMO DR",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336192656,
    "dropphyadd": "10121 E ADAMO DR",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336192656,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336899998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136260654,
    "dropfax": 8136235612
  },
  {
    "dcode": "D",
    "dropkey": "BY28145",
    "droptype": "D",
    "dropname": "LITTLE ROCK AIR FORCE BASE",
    "dropdeladd": "988 CANNON DR",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720765089,
    "dropphyadd": "988 CANNON DR",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720765089,
    "dropmaladd": "988 CANNON DR",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720765089,
    "dropsitphn": 5018645017,
    "dropsitlph": 8705722748,
    "dropsitcph": 8705722748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BY28197",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "4111 NW 16TH BLVD",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326059998,
    "dropphyadd": "4111 NW 16TH BLVD",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326059998,
    "dropmaladd": "PO BOX 357000",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326359998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523777620,
    "dropsitcph": 3523777620,
    "dropfax": 3523341807
  },
  {
    "dcode": "D",
    "dropkey": "BY28208",
    "droptype": "D",
    "dropname": "SOUTH CLERMONT",
    "dropdeladd": "1100 US HIGHWAY 27 STE F",
    "dropdelcty": "CLERMONT",
    "dropdelst": "FL",
    "dropdelzpp": 347149998,
    "dropphyadd": "1100 US HIGHWAY 27 STE F",
    "dropphycty": "CLERMONT",
    "dropphyst": "FL",
    "dropphyzpp": 347149998,
    "dropmaladd": "1100 US HIGHWAY 27 STE F",
    "dropmalcty": "CLERMONT",
    "dropmalst": "FL",
    "dropmalzpp": 347149998,
    "dropsitphn": 3522432941,
    "dropsitlph": 3522432941,
    "dropsitcph": 3522432940,
    "dropfax": 3522432947
  },
  {
    "dcode": "D",
    "dropkey": "BY28224",
    "droptype": "D",
    "dropname": "COCO RIVER",
    "dropdeladd": "1130 CREEKSIDE PKWY",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341081929,
    "dropphyadd": "1130 CREEKSIDE PKWY",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341081929,
    "dropmaladd": "1130 CREEKSIDE PKWY",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341081929,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2395139161,
    "dropfax": 2395964508
  },
  {
    "dcode": "D",
    "dropkey": "BY28227",
    "droptype": "D",
    "dropname": "CHAPEL LAKES",
    "dropdeladd": "21001 PINES BLVD",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330299998,
    "dropphyadd": "21001 PINES BLVD",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330299998,
    "dropmaladd": "21001 PINES BLVD",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330299998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544331269,
    "dropsitcph": 9544331644,
    "dropfax": 7542603545
  },
  {
    "dcode": "D",
    "dropkey": "BY28230",
    "droptype": "D",
    "dropname": "EMBASSY CROSSING",
    "dropdeladd": "9602 US HIGHWAY 19",
    "dropdelcty": "PORT RICHEY",
    "dropdelst": "FL",
    "dropdelzpp": 346684642,
    "dropphyadd": "9602 US HIGHWAY 19",
    "dropphycty": "PORT RICHEY",
    "dropphyst": "FL",
    "dropphyzpp": 346684642,
    "dropmaladd": "8101 WASHINGTON ST",
    "dropmalcty": "PORT RICHEY",
    "dropmalst": "FL",
    "dropmalzpp": 346689998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278151308,
    "dropfax": 7278467928
  },
  {
    "dcode": "D",
    "dropkey": "BZ10015",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "260 W 1ST ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "AK",
    "dropdelzpp": 997449800,
    "dropphyadd": "260 W 1ST ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "AK",
    "dropphyzpp": 997449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDERSON",
    "dropmalst": "AK",
    "dropmalzpp": 997449998,
    "dropsitphn": 9078325545,
    "dropsitlph": 9078325545,
    "dropsitcph": 9075822992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10025",
    "droptype": "D",
    "dropname": "AUKE BAY",
    "dropdeladd": "11899 GLACIER HWY",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998018628,
    "dropphyadd": "11899 GLACIER HWY",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998018628,
    "dropmaladd": "PO BOX 219998",
    "dropmalcty": "AUKE BAY",
    "dropmalst": "AK",
    "dropmalzpp": 998219998,
    "dropsitphn": 9077890680,
    "dropsitlph": 9077890680,
    "dropsitcph": 9077890680,
    "dropfax": 9077893484
  },
  {
    "dcode": "D",
    "dropkey": "BZ10060",
    "droptype": "D",
    "dropname": "CLEAR",
    "dropdeladd": "202 A ST STOP 1047",
    "dropdelcty": "CLEAR",
    "dropdelst": "AK",
    "dropdelzpp": 997045360,
    "dropphyadd": "202 A ST STOP 1047",
    "dropphycty": "CLEAR",
    "dropphyst": "AK",
    "dropphyzpp": 997045360,
    "dropmaladd": "PO BOX 49998",
    "dropmalcty": "CLEAR",
    "dropmalst": "AK",
    "dropmalzpp": 997049998,
    "dropsitphn": 9078325545,
    "dropsitlph": 9078325545,
    "dropsitcph": 9075822650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10064",
    "droptype": "D",
    "dropname": "COLLEGE",
    "dropdeladd": "755 FAIRBANKS ST",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "AK",
    "dropdelzpp": 997099997,
    "dropphyadd": "755 FAIRBANKS ST",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "AK",
    "dropphyzpp": 997099997,
    "dropmaladd": "PO BOX 89998",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "AK",
    "dropmalzpp": 997089998,
    "dropsitphn": 9074794026,
    "dropsitlph": 9074794026,
    "dropsitcph": 9074796021,
    "dropfax": 9074798613
  },
  {
    "dcode": "D",
    "dropkey": "BZ10081",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "804 3RD ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "AK",
    "dropdelzpp": 998245412,
    "dropphyadd": "804 3RD ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "AK",
    "dropphyzpp": 998245412,
    "dropmaladd": "PO BOX 249998",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "AK",
    "dropmalzpp": 998249998,
    "dropsitphn": 9073642445,
    "dropsitlph": 9073642445,
    "dropsitcph": 9073642445,
    "dropfax": 9075867155
  },
  {
    "dcode": "D",
    "dropkey": "BZ10085",
    "droptype": "D",
    "dropname": "DUTCH HARBOR",
    "dropdeladd": "1745 AIRPORT BEACH RD",
    "dropdelcty": "DUTCH HARBOR",
    "dropdelst": "AK",
    "dropdelzpp": 996929800,
    "dropphyadd": "1745 AIRPORT BEACH RD",
    "dropphycty": "DUTCH HARBOR",
    "dropphyst": "AK",
    "dropphyzpp": 996929800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUTCH HARBOR",
    "dropmalst": "AK",
    "dropmalzpp": 996929998,
    "dropsitphn": 9075811657,
    "dropsitlph": 9075811657,
    "dropsitcph": 9075811657,
    "dropfax": 9075814141
  },
  {
    "dcode": "D",
    "dropkey": "BZ10097",
    "droptype": "D",
    "dropname": "EIELSON AFB",
    "dropdeladd": "365 KODIAK ST",
    "dropdelcty": "EIELSON AFB",
    "dropdelst": "AK",
    "dropdelzpp": 997025300,
    "dropphyadd": "365 KODIAK ST",
    "dropphycty": "EIELSON AFB",
    "dropphyst": "AK",
    "dropphyzpp": 997025300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EIELSON AFB",
    "dropmalst": "AK",
    "dropmalzpp": 997029998,
    "dropsitphn": 9073721209,
    "dropsitlph": 9073721209,
    "dropsitcph": 9073726300,
    "dropfax": 9073721209
  },
  {
    "dcode": "D",
    "dropkey": "BZ10102",
    "droptype": "D",
    "dropname": "ELMENDORF AFB",
    "dropdeladd": "10437 KUTER AVE",
    "dropdelcty": "JBER",
    "dropdelst": "AK",
    "dropdelzpp": 995069998,
    "dropphyadd": "10437 KUTER AVE",
    "dropphycty": "JBER",
    "dropphyst": "AK",
    "dropphyzpp": 995069998,
    "dropmaladd": "10437 KUTER AVE",
    "dropmalcty": "JBER",
    "dropmalst": "AK",
    "dropmalzpp": 995069998,
    "dropsitphn": 9077539005,
    "dropsitlph": 9077539005,
    "dropsitcph": 9077539089,
    "dropfax": 9077530658
  },
  {
    "dcode": "D",
    "dropkey": "BZ10113",
    "droptype": "D",
    "dropname": "FORT RICHARDSON",
    "dropdeladd": "724 QUARTERMASTER RD",
    "dropdelcty": "JBER",
    "dropdelst": "AK",
    "dropdelzpp": 995059998,
    "dropphyadd": "724 QUARTERMASTER RD",
    "dropphycty": "JBER",
    "dropphyst": "AK",
    "dropphyzpp": 995059998,
    "dropmaladd": "724 QUARTERMASTER RD",
    "dropmalcty": "JBER",
    "dropmalst": "AK",
    "dropmalzpp": 995059998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9074283869,
    "dropsitcph": 9074283869,
    "dropfax": 9074280275
  },
  {
    "dcode": "D",
    "dropkey": "BZ10114",
    "droptype": "D",
    "dropname": "FORT WAINWRIGHT",
    "dropdeladd": "3726 NEELY RD",
    "dropdelcty": "FORT WAINWRIGHT",
    "dropdelst": "AK",
    "dropdelzpp": 997038424,
    "dropphyadd": "3726 NEELY RD",
    "dropphycty": "FORT WAINWRIGHT",
    "dropphyst": "AK",
    "dropphyzpp": 997038424,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "FORT WAINWRIGHT",
    "dropmalst": "AK",
    "dropmalzpp": 997039998,
    "dropsitphn": 9073567603,
    "dropsitlph": 9073567603,
    "dropsitcph": 9073567602,
    "dropfax": 9073563510
  },
  {
    "dcode": "D",
    "dropkey": "BZ10228",
    "droptype": "D",
    "dropname": "NORTH POLE",
    "dropdeladd": "325 S SANTA CLAUS LN",
    "dropdelcty": "NORTH POLE",
    "dropdelst": "AK",
    "dropdelzpp": 997059998,
    "dropphyadd": "325 S SANTA CLAUS LN",
    "dropphycty": "NORTH POLE",
    "dropphyst": "AK",
    "dropphyzpp": 997059998,
    "dropmaladd": "325 S SANTA CLAUS LN",
    "dropmalcty": "NORTH POLE",
    "dropmalst": "AK",
    "dropmalzpp": 997059998,
    "dropsitphn": 9074881376,
    "dropsitlph": 9074882896,
    "dropsitcph": 9074881376,
    "dropfax": 9074883189
  },
  {
    "dcode": "D",
    "dropkey": "BZ10424",
    "droptype": "D",
    "dropname": "CASAS ADOBES",
    "dropdeladd": "6281 N ORACLE RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857049998,
    "dropphyadd": "6281 N ORACLE RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857049998,
    "dropmaladd": "6281 N ORACLE RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857049998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205310693,
    "dropsitcph": 5205310695,
    "dropfax": 5205759049
  },
  {
    "dcode": "D",
    "dropkey": "BZ10529",
    "droptype": "D",
    "dropname": "FORT HUACHUCA",
    "dropdeladd": "47 ARIZONA ST",
    "dropdelcty": "FORT HUACHUCA",
    "dropdelst": "AZ",
    "dropdelzpp": 856139998,
    "dropphyadd": "47 ARIZONA ST",
    "dropphycty": "FORT HUACHUCA",
    "dropphyst": "AZ",
    "dropphyzpp": 856139998,
    "dropmaladd": "2300 E FRY BLVD",
    "dropmalcty": "SIERRA VISTA",
    "dropmalst": "AZ",
    "dropmalzpp": 856359998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204594614,
    "dropsitcph": 5204584411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10533",
    "droptype": "D",
    "dropname": "FORT MOHAVE",
    "dropdeladd": "4821 S HIGHWAY 95 STE 7",
    "dropdelcty": "FORT MOHAVE",
    "dropdelst": "AZ",
    "dropdelzpp": 864268399,
    "dropphyadd": "4821 S HIGHWAY 95 STE 7",
    "dropphycty": "FORT MOHAVE",
    "dropphyst": "AZ",
    "dropphyzpp": 864268399,
    "dropmaladd": "4821 S HIGHWAY 95 STE 7",
    "dropmalcty": "FORT MOHAVE",
    "dropmalst": "AZ",
    "dropmalzpp": 864268399,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287049440,
    "dropsitcph": 9287585711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10653",
    "droptype": "D",
    "dropname": "LUKE AIR FORCE BASE",
    "dropdeladd": "14032 W MUSTANG",
    "dropdelcty": "LUKE AIR FORCE BASE",
    "dropdelst": "AZ",
    "dropdelzpp": 853095000,
    "dropphyadd": "14032 W MUSTANG",
    "dropphycty": "LUKE AIR FORCE BASE",
    "dropphyst": "AZ",
    "dropphyzpp": 853095000,
    "dropmaladd": "14032 W MUSTANG",
    "dropmalcty": "LUKE AIR FORCE BASE",
    "dropmalst": "AZ",
    "dropmalzpp": 853095000,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239351343,
    "dropsitcph": 6239351343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10688",
    "droptype": "D",
    "dropname": "MOHAVE VALLEY",
    "dropdeladd": "8045 S HIGHWAY 95",
    "dropdelcty": "MOHAVE VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 864408588,
    "dropphyadd": "8045 S HIGHWAY 95",
    "dropphycty": "MOHAVE VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 864408588,
    "dropmaladd": "8045 S HIGHWAY 95",
    "dropmalcty": "MOHAVE VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 864408588,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287687586,
    "dropsitcph": 9287585711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10769",
    "droptype": "D",
    "dropname": "PRESCOTT VALLEY",
    "dropdeladd": "8307 E STATE ROUTE 69 STE 1",
    "dropdelcty": "PRESCOTT VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 863149452,
    "dropphyadd": "8307 E STATE ROUTE 69 STE 1",
    "dropphycty": "PRESCOTT VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 863149452,
    "dropmaladd": "8307 E STATE ROUTE 69 STE 1",
    "dropmalcty": "PRESCOTT VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 863149452,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287592316,
    "dropsitcph": 9287724406,
    "dropfax": 9287781738
  },
  {
    "dcode": "D",
    "dropkey": "BZ10787",
    "droptype": "D",
    "dropname": "RIO RICO",
    "dropdeladd": "1163 W FRONTAGE RD",
    "dropdelcty": "RIO RICO",
    "dropdelst": "AZ",
    "dropdelzpp": 856486214,
    "dropphyadd": "1163 W FRONTAGE RD",
    "dropphycty": "RIO RICO",
    "dropphyst": "AZ",
    "dropphyzpp": 856486214,
    "dropmaladd": "1163 W FRONTAGE RD",
    "dropmalcty": "RIO RICO",
    "dropmalst": "AZ",
    "dropmalzpp": 856486214,
    "dropsitphn": 5206205019,
    "dropsitlph": 5202817223,
    "dropsitcph": 5202817223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ10850",
    "droptype": "D",
    "dropname": "SOUTH TUCSON",
    "dropdeladd": "2420 S 6TH AVE",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857133405,
    "dropphyadd": "2420 S 6TH AVE",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857133405,
    "dropmaladd": "2420 S 6TH AVE",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857133405,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206222263,
    "dropsitcph": 5209039827,
    "dropfax": 5206243652
  },
  {
    "dcode": "D",
    "dropkey": "BZ10914",
    "droptype": "D",
    "dropname": "SURPRISE",
    "dropdeladd": "14955 W BELL RD",
    "dropdelcty": "SURPRISE",
    "dropdelst": "AZ",
    "dropdelzpp": 853749998,
    "dropphyadd": "14955 W BELL RD",
    "dropphycty": "SURPRISE",
    "dropphyst": "AZ",
    "dropphyzpp": 853749998,
    "dropmaladd": "14955 W BELL RD",
    "dropmalcty": "SURPRISE",
    "dropmalst": "AZ",
    "dropmalzpp": 853749998,
    "dropsitphn": 6235444818,
    "dropsitlph": 6235444818,
    "dropsitcph": 6235444672,
    "dropfax": 6235444677
  },
  {
    "dcode": "D",
    "dropkey": "BZ10970",
    "droptype": "D",
    "dropname": "WEST SEDONA",
    "dropdeladd": "2081 W STATE ROUTE 89A STE 12",
    "dropdelcty": "SEDONA",
    "dropdelst": "AZ",
    "dropdelzpp": 863369997,
    "dropphyadd": "2081 W STATE ROUTE 89A STE 12",
    "dropphycty": "SEDONA",
    "dropphyst": "AZ",
    "dropphyzpp": 863369997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEDONA",
    "dropmalst": "AZ",
    "dropmalzpp": 863409998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282823482,
    "dropsitcph": 9282823511,
    "dropfax": 9282049666
  },
  {
    "dcode": "D",
    "dropkey": "BZ11004",
    "droptype": "D",
    "dropname": "ADAMS CITY",
    "dropdeladd": "6655 BRIGHTON BLVD",
    "dropdelcty": "COMMERCE CITY",
    "dropdelst": "CO",
    "dropdelzpp": 800222300,
    "dropphyadd": "6655 BRIGHTON BLVD",
    "dropphycty": "COMMERCE CITY",
    "dropphyst": "CO",
    "dropphyzpp": 800222300,
    "dropmaladd": "6655 BRIGHTON BLVD",
    "dropmalcty": "COMMERCE CITY",
    "dropmalst": "CO",
    "dropmalzpp": 800222300,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032277383,
    "dropsitcph": 3032277381,
    "dropfax": 3032871862
  },
  {
    "dcode": "D",
    "dropkey": "BZ11034",
    "droptype": "D",
    "dropname": "GREENWOOD VILLAGE",
    "dropdeladd": "6855 S DAYTON ST",
    "dropdelcty": "GREENWOOD VILLAGE",
    "dropdelst": "CO",
    "dropdelzpp": 801129998,
    "dropphyadd": "6855 S DAYTON ST",
    "dropphycty": "GREENWOOD VILLAGE",
    "dropphyst": "CO",
    "dropphyzpp": 801129998,
    "dropmaladd": "6855 S DAYTON ST",
    "dropmalcty": "GREENWOOD VILLAGE",
    "dropmalst": "CO",
    "dropmalzpp": 801129998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037080564,
    "dropsitcph": 3037920098,
    "dropfax": 3037998339
  },
  {
    "dcode": "D",
    "dropkey": "BZ11344",
    "droptype": "D",
    "dropname": "EDGEWATER",
    "dropdeladd": "1990 DEPEW ST",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 802149998,
    "dropphyadd": "1990 DEPEW ST",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 802149998,
    "dropmaladd": "1990 DEPEW ST",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 802149998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032759829,
    "dropsitcph": 3032759829,
    "dropfax": 3032396706
  },
  {
    "dcode": "D",
    "dropkey": "BZ11419",
    "droptype": "D",
    "dropname": "FRUITVALE",
    "dropdeladd": "2923 NORTH AVE STE 4",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "CO",
    "dropdelzpp": 815049998,
    "dropphyadd": "2923 NORTH AVE STE 4",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "CO",
    "dropphyzpp": 815049998,
    "dropmaladd": "2923 NORTH AVE STE 4",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "CO",
    "dropmalzpp": 815049998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702410826,
    "dropsitcph": 9702410826,
    "dropfax": 9702569293
  },
  {
    "dcode": "D",
    "dropkey": "BZ11497",
    "droptype": "D",
    "dropname": "HIGHLANDS RANCH",
    "dropdeladd": "9609 S UNIVERSITY BLVD",
    "dropdelcty": "HIGHLANDS RANCH",
    "dropdelst": "CO",
    "dropdelzpp": 801309998,
    "dropphyadd": "9609 S UNIVERSITY BLVD",
    "dropphycty": "HIGHLANDS RANCH",
    "dropphyst": "CO",
    "dropphyzpp": 801309998,
    "dropmaladd": "9609 S UNIVERSITY BLVD",
    "dropmalcty": "HIGHLANDS RANCH",
    "dropmalst": "CO",
    "dropmalzpp": 801309998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032275520,
    "dropsitcph": 3032275500,
    "dropfax": 3032275581
  },
  {
    "dcode": "D",
    "dropkey": "BZ11569",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "10799 W ALAMEDA AVE",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 802269998,
    "dropphyadd": "10799 W ALAMEDA AVE",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 802269998,
    "dropmaladd": "10799 W ALAMEDA AVE",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 802269998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3039693201,
    "dropsitcph": 3039693201,
    "dropfax": 3039693232
  },
  {
    "dcode": "D",
    "dropkey": "BZ11694",
    "droptype": "D",
    "dropname": "NORTHGLENN",
    "dropdeladd": "11887 WASHINGTON ST",
    "dropdelcty": "NORTHGLENN",
    "dropdelst": "CO",
    "dropdelzpp": 802339998,
    "dropphyadd": "11887 WASHINGTON ST",
    "dropphycty": "NORTHGLENN",
    "dropphyst": "CO",
    "dropphyzpp": 802339998,
    "dropmaladd": "11887 WASHINGTON ST",
    "dropmalcty": "NORTHGLENN",
    "dropmalst": "CO",
    "dropmalzpp": 802339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034522316,
    "dropsitcph": 3034522316,
    "dropfax": 3032548013
  },
  {
    "dcode": "D",
    "dropkey": "BZ11860",
    "droptype": "D",
    "dropname": "SILVERTHORNE",
    "dropdeladd": "518 BRIAN AVE",
    "dropdelcty": "SILVERTHORNE",
    "dropdelst": "CO",
    "dropdelzpp": 804979990,
    "dropphyadd": "518 BRIAN AVE",
    "dropphycty": "SILVERTHORNE",
    "dropphyst": "CO",
    "dropphyzpp": 804979990,
    "dropmaladd": "518 BRIAN AVE",
    "dropmalcty": "SILVERTHORNE",
    "dropmalst": "CO",
    "dropmalzpp": 804979990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704682050,
    "dropsitcph": 9704682050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ11872",
    "droptype": "D",
    "dropname": "SNOWMASS VILLAGE",
    "dropdeladd": "0016 KEARNS RD",
    "dropdelcty": "SNOWMASS VILLAGE",
    "dropdelst": "CO",
    "dropdelzpp": 816159702,
    "dropphyadd": "0016 KEARNS RD",
    "dropphycty": "SNOWMASS VILLAGE",
    "dropphyst": "CO",
    "dropphyzpp": 816159702,
    "dropmaladd": "PO BOX 6000",
    "dropmalcty": "SNOWMASS VILLAGE",
    "dropmalst": "CO",
    "dropmalzpp": 816156000,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709232497,
    "dropsitcph": 9709232497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ11881",
    "droptype": "D",
    "dropname": "CENTENNIAL",
    "dropdeladd": "2221 E ARAPAHOE RD",
    "dropdelcty": "CENTENNIAL",
    "dropdelst": "CO",
    "dropdelzpp": 801229998,
    "dropphyadd": "2221 E ARAPAHOE RD",
    "dropphycty": "CENTENNIAL",
    "dropphyst": "CO",
    "dropphyzpp": 801229998,
    "dropmaladd": "2221 E ARAPAHOE RD",
    "dropmalcty": "CENTENNIAL",
    "dropmalst": "CO",
    "dropmalzpp": 801229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037941285,
    "dropsitcph": 3037941285,
    "dropfax": 3033472091
  },
  {
    "dcode": "D",
    "dropkey": "BZ11941",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "8804 WASHINGTON ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "CO",
    "dropdelzpp": 802299998,
    "dropphyadd": "8804 WASHINGTON ST",
    "dropphycty": "THORNTON",
    "dropphyst": "CO",
    "dropphyzpp": 802299998,
    "dropmaladd": "8804 WASHINGTON ST",
    "dropmalcty": "THORNTON",
    "dropmalst": "CO",
    "dropmalzpp": 802299998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032277386,
    "dropsitcph": 3032277386,
    "dropfax": 3032878679
  },
  {
    "dcode": "D",
    "dropkey": "BZ12077",
    "droptype": "D",
    "dropname": "BARRIGADA",
    "dropdeladd": "489 ARMY DR",
    "dropdelcty": "BARRIGADA",
    "dropdelst": "GU",
    "dropdelzpp": 969139998,
    "dropphyadd": "489 ARMY DR",
    "dropphycty": "BARRIGADA",
    "dropphyst": "GU",
    "dropphyzpp": 969139998,
    "dropmaladd": "489 ARMY DR",
    "dropmalcty": "BARRIGADA",
    "dropmalst": "GU",
    "dropmalzpp": 969139998,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6717343921,
    "dropfax": 6717343925
  },
  {
    "dcode": "D",
    "dropkey": "BZ12100",
    "droptype": "D",
    "dropname": "TAMUNING",
    "dropdeladd": "143 EDWARD T CALVO MEMORIAL PKWY",
    "dropdelcty": "TAMUNING",
    "dropdelst": "GU",
    "dropdelzpp": 969133598,
    "dropphyadd": "143 EDWARD T CALVO MEMORIAL PKWY",
    "dropphycty": "TAMUNING",
    "dropphyst": "GU",
    "dropphyzpp": 969133598,
    "dropmaladd": "143 EDWARD T CALVO MEMORIAL PKWY",
    "dropmalcty": "TAMUNING",
    "dropmalst": "GU",
    "dropmalzpp": 969133598,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6716465539,
    "dropfax": 6716476034
  },
  {
    "dcode": "D",
    "dropkey": "BZ12118",
    "droptype": "D",
    "dropname": "BARBERS POINT",
    "dropdeladd": "91-1049 LEXINGTON ST",
    "dropdelcty": "KAPOLEI",
    "dropdelst": "HI",
    "dropdelzpp": 967079996,
    "dropphyadd": "91-1049 LEXINGTON ST",
    "dropphycty": "KAPOLEI",
    "dropphyst": "HI",
    "dropphyzpp": 967079996,
    "dropmaladd": "PO BOX 759998",
    "dropmalcty": "KAPOLEI",
    "dropmalst": "HI",
    "dropmalzpp": 967079998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086820738,
    "dropsitcph": 8086710369,
    "dropfax": 8086820738
  },
  {
    "dcode": "D",
    "dropkey": "BZ12246",
    "droptype": "D",
    "dropname": "KUKUIHAELE",
    "dropdeladd": "48-5300 KUKUIHAELE RD",
    "dropdelcty": "HONOKAA",
    "dropdelst": "HI",
    "dropdelzpp": 967277211,
    "dropphyadd": "48-5300 KUKUIHAELE RD",
    "dropphycty": "HONOKAA",
    "dropphyst": "HI",
    "dropphyzpp": 967277211,
    "dropmaladd": "48-5300 KUKUIHAELE RD",
    "dropmalcty": "HONOKAA",
    "dropmalst": "HI",
    "dropmalzpp": 967277211,
    "dropsitphn": 8084233844,
    "dropsitlph": 8087750081,
    "dropsitcph": 8087750081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ12277",
    "droptype": "D",
    "dropname": "MILILANI",
    "dropdeladd": "95-1030 MEHEULA PKWY",
    "dropdelcty": "MILILANI",
    "dropdelst": "HI",
    "dropdelzpp": 967899998,
    "dropphyadd": "95-1030 MEHEULA PKWY",
    "dropphycty": "MILILANI",
    "dropphyst": "HI",
    "dropphyzpp": 967899998,
    "dropmaladd": "95-1030 MEHEULA PKWY",
    "dropmalcty": "MILILANI",
    "dropmalst": "HI",
    "dropmalzpp": 967899998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086233994,
    "dropsitcph": 8086250320,
    "dropfax": 8084262227
  },
  {
    "dcode": "D",
    "dropkey": "BZ12324",
    "droptype": "D",
    "dropname": "PRINCEVILLE",
    "dropdeladd": "5-4280 KUHIO HWY",
    "dropdelcty": "PRINCEVILLE",
    "dropdelst": "HI",
    "dropdelzpp": 967225438,
    "dropphyadd": "5-4280 KUHIO HWY",
    "dropphycty": "PRINCEVILLE",
    "dropphyst": "HI",
    "dropphyzpp": 967225438,
    "dropmaladd": "PO BOX 229998",
    "dropmalcty": "PRINCEVILLE",
    "dropmalst": "HI",
    "dropmalzpp": 967229998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088281721,
    "dropsitcph": 8088281721,
    "dropfax": 8088280217
  },
  {
    "dcode": "D",
    "dropkey": "BZ12328",
    "droptype": "D",
    "dropname": "PUKALANI",
    "dropdeladd": "55 PUKALANI ST STE 12",
    "dropdelcty": "MAKAWAO",
    "dropdelst": "HI",
    "dropdelzpp": 967688544,
    "dropphyadd": "55 PUKALANI ST STE 12",
    "dropphycty": "MAKAWAO",
    "dropphyst": "HI",
    "dropphyzpp": 967688544,
    "dropmaladd": "55 PUKALANI ST STE 12",
    "dropmalcty": "MAKAWAO",
    "dropmalst": "HI",
    "dropmalzpp": 967688544,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085720019,
    "dropsitcph": 8085720019,
    "dropfax": 8085727053
  },
  {
    "dcode": "D",
    "dropkey": "BZ12360",
    "droptype": "D",
    "dropname": "WAIKOLOA",
    "dropdeladd": "68-1875 PUA MELIA ST",
    "dropdelcty": "WAIKOLOA",
    "dropdelst": "HI",
    "dropdelzpp": 967389998,
    "dropphyadd": "68-1875 PUA MELIA ST",
    "dropphycty": "WAIKOLOA",
    "dropphyst": "HI",
    "dropphyzpp": 967389998,
    "dropmaladd": "68-1875 PUA MELIA ST",
    "dropmalcty": "WAIKOLOA",
    "dropmalst": "HI",
    "dropmalzpp": 967389998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088831497,
    "dropsitcph": 8088856239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ12749",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME AFB",
    "dropdeladd": "480 5TH ST",
    "dropdelcty": "MOUNTAIN HOME AFB",
    "dropdelst": "ID",
    "dropdelzpp": 836485098,
    "dropphyadd": "480 5TH ST",
    "dropphycty": "MOUNTAIN HOME AFB",
    "dropphyst": "ID",
    "dropphyzpp": 836489998,
    "dropmaladd": "480 5TH ST",
    "dropmalcty": "MOUNTAIN HOME AFB",
    "dropmalst": "ID",
    "dropmalzpp": 836489998,
    "dropsitphn": 2085871413,
    "dropsitlph": 2085871413,
    "dropsitcph": 2088327008,
    "dropfax": 2088324820
  },
  {
    "dcode": "D",
    "dropkey": "BZ13049",
    "droptype": "D",
    "dropname": "BLACK EAGLE",
    "dropdeladd": "1321 SMELTER AVE NE",
    "dropdelcty": "BLACK EAGLE",
    "dropdelst": "MT",
    "dropdelzpp": 594149998,
    "dropphyadd": "1321 SMELTER AVE NE",
    "dropphycty": "BLACK EAGLE",
    "dropphyst": "MT",
    "dropphyzpp": 594149998,
    "dropmaladd": "1321 SMELTER AVE NE",
    "dropmalcty": "BLACK EAGLE",
    "dropmalst": "MT",
    "dropmalzpp": 594149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064535591,
    "dropsitcph": 4064535591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ13496",
    "droptype": "D",
    "dropname": "ALAMEDA",
    "dropdeladd": "9132 4TH ST NW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871149998,
    "dropphyadd": "9132 4TH ST NW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871149998,
    "dropmaladd": "9132 4TH ST NW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057928749,
    "dropsitcph": 5057928749,
    "dropfax": 5058907407
  },
  {
    "dcode": "D",
    "dropkey": "BZ13826",
    "droptype": "D",
    "dropname": "KIRTLAND AFB",
    "dropdeladd": "1400 1ST ST SE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871169998,
    "dropphyadd": "1400 1ST ST SE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871169998,
    "dropmaladd": "1400 1ST ST SE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871169998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460561,
    "dropsitcph": 5053460561,
    "dropfax": 5053460559
  },
  {
    "dcode": "D",
    "dropkey": "BZ13934",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "105 AIRPORT RD",
    "dropdelcty": "MILAN",
    "dropdelst": "NM",
    "dropdelzpp": 870219998,
    "dropphyadd": "105 AIRPORT RD",
    "dropphycty": "MILAN",
    "dropphyst": "NM",
    "dropphyzpp": 870219998,
    "dropmaladd": "105 AIRPORT RD",
    "dropmalcty": "MILAN",
    "dropmalst": "NM",
    "dropmalzpp": 870219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052874685,
    "dropsitcph": 5052874685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ14075",
    "droptype": "D",
    "dropname": "RIO RANCHO",
    "dropdeladd": "900 PINETREE RD SE",
    "dropdelcty": "RIO RANCHO",
    "dropdelst": "NM",
    "dropdelzpp": 871249998,
    "dropphyadd": "900 PINETREE RD SE",
    "dropphycty": "RIO RANCHO",
    "dropphyst": "NM",
    "dropphyzpp": 871249998,
    "dropmaladd": "900 PINETREE RD SE",
    "dropmalcty": "RIO RANCHO",
    "dropmalst": "NM",
    "dropmalzpp": 871249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052083382,
    "dropsitcph": 5059943756,
    "dropfax": 5059942742
  },
  {
    "dcode": "D",
    "dropkey": "BZ14290",
    "droptype": "D",
    "dropname": "WHITE SANDS MISSILE RANGE",
    "dropdeladd": "153 JOLLET",
    "dropdelcty": "WHITE SANDS MISSILE RANGE",
    "dropdelst": "NM",
    "dropdelzpp": 880029800,
    "dropphyadd": "153 JOLLET",
    "dropphycty": "WHITE SANDS MISSILE RANGE",
    "dropphyst": "NM",
    "dropphyzpp": 880029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE SANDS MISSILE RANGE",
    "dropmalst": "NM",
    "dropmalzpp": 880029998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756742257,
    "dropsitcph": 5756742257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ14450",
    "droptype": "D",
    "dropname": "INCLINE VILLAGE",
    "dropdeladd": "770 MAYS BLVD",
    "dropdelcty": "INCLINE VILLAGE",
    "dropdelst": "NV",
    "dropdelzpp": 894519997,
    "dropphyadd": "770 MAYS BLVD",
    "dropphycty": "INCLINE VILLAGE",
    "dropphyst": "NV",
    "dropphyzpp": 894519997,
    "dropmaladd": "770 MAYS BLVD",
    "dropmalcty": "INCLINE VILLAGE",
    "dropmalst": "NV",
    "dropmalzpp": 894519997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758316072,
    "dropsitcph": 7758318994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ14518",
    "droptype": "D",
    "dropname": "NELLIS AFB",
    "dropdeladd": "4250 GRIFFISS AVE",
    "dropdelcty": "NELLIS AFB",
    "dropdelst": "NV",
    "dropdelzpp": 891917018,
    "dropphyadd": "4250 GRIFFISS AVE",
    "dropphycty": "NELLIS AFB",
    "dropphyst": "NV",
    "dropphyzpp": 891917018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELLIS AFB",
    "dropmalst": "NV",
    "dropmalzpp": 891919998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7026524679,
    "dropsitcph": 7024320482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ14635",
    "droptype": "D",
    "dropname": "STATELINE",
    "dropdeladd": "223 KINGSBURY GRADE",
    "dropdelcty": "STATELINE",
    "dropdelst": "NV",
    "dropdelzpp": 894499997,
    "dropphyadd": "223 KINGSBURY GRADE",
    "dropphycty": "STATELINE",
    "dropphyst": "NV",
    "dropphyzpp": 894499997,
    "dropmaladd": "223 KINGSBURY GRADE",
    "dropmalcty": "STATELINE",
    "dropmalst": "NV",
    "dropmalzpp": 894499997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755882623,
    "dropsitcph": 7755882623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ14648",
    "droptype": "D",
    "dropname": "SUN VALLEY",
    "dropdeladd": "125 W 6TH AVE",
    "dropdelcty": "SUN VALLEY",
    "dropdelst": "NV",
    "dropdelzpp": 894337303,
    "dropphyadd": "125 W 6TH AVE",
    "dropphycty": "SUN VALLEY",
    "dropphyst": "NV",
    "dropphyzpp": 894337303,
    "dropmaladd": "125 W 6TH AVE",
    "dropmalcty": "SUN VALLEY",
    "dropmalst": "NV",
    "dropmalzpp": 894339998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7756735717,
    "dropsitcph": 7756733259,
    "dropfax": 7756739438
  },
  {
    "dcode": "D",
    "dropkey": "BZ14721",
    "droptype": "D",
    "dropname": "ALOHA",
    "dropdeladd": "3800 SW 185TH AVE",
    "dropdelcty": "BEAVERTON",
    "dropdelst": "OR",
    "dropdelzpp": 970781570,
    "dropphyadd": "3800 SW 185TH AVE",
    "dropphycty": "BEAVERTON",
    "dropphyst": "OR",
    "dropphyzpp": 970781570,
    "dropmaladd": "3800 SW 185TH AVE",
    "dropmalcty": "BEAVERTON",
    "dropmalst": "OR",
    "dropmalzpp": 970789998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035919822,
    "dropsitcph": 5038483919,
    "dropfax": 5035911338
  },
  {
    "dcode": "D",
    "dropkey": "BZ14799",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "5000 BROOKLAKE RD NE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973059600,
    "dropphyadd": "5000 BROOKLAKE RD NE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973059600,
    "dropmaladd": "5000 BROOKLAKE RD NE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973059998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033040723,
    "dropsitcph": 5033040720,
    "dropfax": 5033909188
  },
  {
    "dcode": "D",
    "dropkey": "BZ14847",
    "droptype": "D",
    "dropname": "CENTRAL POINT",
    "dropdeladd": "625 E PINE ST",
    "dropdelcty": "CENTRAL POINT",
    "dropdelst": "OR",
    "dropdelzpp": 975022446,
    "dropphyadd": "625 E PINE ST",
    "dropphycty": "CENTRAL POINT",
    "dropphyst": "OR",
    "dropphyzpp": 975022446,
    "dropmaladd": "625 E PINE ST",
    "dropmalcty": "CENTRAL POINT",
    "dropmalst": "OR",
    "dropmalzpp": 975029998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416646812,
    "dropsitcph": 5416646812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ15153",
    "droptype": "D",
    "dropname": "KEIZER",
    "dropdeladd": "5454 RIVER RD N",
    "dropdelcty": "KEIZER",
    "dropdelst": "OR",
    "dropdelzpp": 973032000,
    "dropphyadd": "5454 RIVER RD N",
    "dropphycty": "KEIZER",
    "dropphyst": "OR",
    "dropphyzpp": 973032000,
    "dropmaladd": "5454 RIVER RD N",
    "dropmalcty": "KEIZER",
    "dropmalst": "OR",
    "dropmalzpp": 973032000,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033930861,
    "dropsitcph": 5033040655,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": "BZ15271",
    "droptype": "D",
    "dropname": "MILWAUKIE",
    "dropdeladd": "11222 SE MAIN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972227748,
    "dropphyadd": "11222 SE MAIN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972227748,
    "dropmaladd": "11222 SE MAIN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972229998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036532858,
    "dropsitcph": 5036541643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ15348",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "3860 SE NAEF RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972675623,
    "dropphyadd": "3860 SE NAEF RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972675623,
    "dropmaladd": "3860 SE NAEF RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972679998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036541598,
    "dropsitcph": 5036541643,
    "dropfax": 5036529581
  },
  {
    "dcode": "D",
    "dropkey": "BZ15620",
    "droptype": "D",
    "dropname": "SUNRIVER",
    "dropdeladd": "56857 ENTERPRISE DR",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977072120,
    "dropphyadd": "56857 ENTERPRISE DR",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977072120,
    "dropmaladd": "56857 ENTERPRISE DR",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977079998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415987674,
    "dropsitcph": 5415987674,
    "dropfax": 5415935802
  },
  {
    "dcode": "D",
    "dropkey": "BZ15643",
    "droptype": "D",
    "dropname": "TIGARD",
    "dropdeladd": "12210 SW MAIN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972236222,
    "dropphyadd": "12210 SW MAIN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972236222,
    "dropmaladd": "12210 SW MAIN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5039680753,
    "dropsitcph": 5039686763,
    "dropfax": 5036390203
  },
  {
    "dcode": "D",
    "dropkey": "BZ15739",
    "droptype": "D",
    "dropname": "WHITE CITY",
    "dropdeladd": "7561 CRATER LAKE HWY STE A",
    "dropdelcty": "WHITE CITY",
    "dropdelst": "OR",
    "dropdelzpp": 975031668,
    "dropphyadd": "7561 CRATER LAKE HWY STE A",
    "dropphycty": "WHITE CITY",
    "dropphyst": "OR",
    "dropphyzpp": 975031668,
    "dropmaladd": "7561 CRATER LAKE HWY STE A",
    "dropmalcty": "WHITE CITY",
    "dropmalst": "OR",
    "dropmalzpp": 975039998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418266405,
    "dropsitcph": 5418264903,
    "dropfax": 5418300361
  },
  {
    "dcode": "D",
    "dropkey": "BZ15897",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "6890 S 2300 E",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841219998,
    "dropphyadd": "6890 S 2300 E",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841219998,
    "dropmaladd": "6890 S 2300 E",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841219998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014531991,
    "dropsitcph": 8014531991,
    "dropfax": 8019427224
  },
  {
    "dcode": "D",
    "dropkey": "BZ16050",
    "droptype": "D",
    "dropname": "HILL AIR FORCE BASE",
    "dropdeladd": "7338 LONCKI ST",
    "dropdelcty": "HILL AIR FORCE BASE",
    "dropdelst": "UT",
    "dropdelzpp": 840565001,
    "dropphyadd": "7338 LONCKI ST",
    "dropphycty": "HILL AIR FORCE BASE",
    "dropphyst": "UT",
    "dropphyzpp": 840565001,
    "dropmaladd": "PO BOX 569998",
    "dropmalcty": "HILL AIR FORCE BASE",
    "dropmalst": "UT",
    "dropmalzpp": 840569998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017799298,
    "dropsitcph": 8017799110,
    "dropfax": 8018259804
  },
  {
    "dcode": "D",
    "dropkey": "BZ16055",
    "droptype": "D",
    "dropname": "HOLLADAY",
    "dropdeladd": "2350 E ARBOR LN",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841179998,
    "dropphyadd": "2350 E ARBOR LN",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841179998,
    "dropmaladd": "2350 E ARBOR LN",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841179998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8012879942,
    "dropsitcph": 8012789942,
    "dropfax": 8012786832
  },
  {
    "dcode": "D",
    "dropkey": "BZ16080",
    "droptype": "D",
    "dropname": "KEARNS",
    "dropdeladd": "5495 S 4015 W",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 841299998,
    "dropphyadd": "5495 S 4015 W",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 841299998,
    "dropmaladd": "5495 S 4015 W",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 841299998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019644752,
    "dropsitcph": 8019644752,
    "dropfax": 8019638121
  },
  {
    "dcode": "D",
    "dropkey": "BZ16143",
    "droptype": "D",
    "dropname": "MILLCREEK",
    "dropdeladd": "3350 S 2940 E",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841099998,
    "dropphyadd": "3350 S 2940 E",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841099998,
    "dropmaladd": "3350 S 2940 E",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841099998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014857547,
    "dropsitcph": 8014857547,
    "dropfax": 8014672723
  },
  {
    "dcode": "D",
    "dropkey": "BZ16168",
    "droptype": "D",
    "dropname": "MURRAY",
    "dropdeladd": "4989 S STATE ST",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841079998,
    "dropphyadd": "4989 S STATE ST",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841079998,
    "dropmaladd": "4989 S STATE ST",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841079998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8012814472,
    "dropsitcph": 8012930436,
    "dropfax": 8016858233
  },
  {
    "dcode": "D",
    "dropkey": "BZ16186",
    "droptype": "D",
    "dropname": "NORTH SALT LAKE",
    "dropdeladd": "345 N HIGHWAY 89",
    "dropdelcty": "NORTH SALT LAKE",
    "dropdelst": "UT",
    "dropdelzpp": 840549998,
    "dropphyadd": "345 N HIGHWAY 89",
    "dropphycty": "NORTH SALT LAKE",
    "dropphyst": "UT",
    "dropphyzpp": 840549998,
    "dropmaladd": "345 N HIGHWAY 89",
    "dropmalcty": "NORTH SALT LAKE",
    "dropmalst": "UT",
    "dropmalzpp": 840549998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8012925754,
    "dropsitcph": 8012926712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ16279",
    "droptype": "D",
    "dropname": "SOUTH SALT LAKE",
    "dropdeladd": "3161 S WEST TEMPLE",
    "dropdelcty": "SOUTH SALT LAKE",
    "dropdelst": "UT",
    "dropdelzpp": 841159998,
    "dropphyadd": "3161 S WEST TEMPLE",
    "dropphycty": "SOUTH SALT LAKE",
    "dropphyst": "UT",
    "dropphyzpp": 841159998,
    "dropmaladd": "3161 S WEST TEMPLE",
    "dropmalcty": "SOUTH SALT LAKE",
    "dropmalst": "UT",
    "dropmalzpp": 841159998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014832604,
    "dropsitcph": 8014832604,
    "dropfax": 8014675152
  },
  {
    "dcode": "D",
    "dropkey": "BZ16384",
    "droptype": "D",
    "dropname": "WEST VALLEY",
    "dropdeladd": "3490 S 4400 W",
    "dropdelcty": "WEST VALLEY CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841209998,
    "dropphyadd": "3490 S 4400 W",
    "dropphycty": "WEST VALLEY CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841209998,
    "dropmaladd": "3490 S 4400 W",
    "dropmalcty": "WEST VALLEY CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841209998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019688099,
    "dropsitcph": 8019558584,
    "dropfax": 8019642116
  },
  {
    "dcode": "D",
    "dropkey": "BZ16518",
    "droptype": "D",
    "dropname": "BONNEY LAKE",
    "dropdeladd": "18429 VETERANS MEMORIAL DR E",
    "dropdelcty": "BONNEY LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 983919997,
    "dropphyadd": "18429 VETERANS MEMORIAL DR E",
    "dropphycty": "BONNEY LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 983919997,
    "dropmaladd": "18429 VETERANS MEMORIAL DR E",
    "dropmalcty": "BONNEY LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 983919997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538633187,
    "dropsitcph": 2538260902,
    "dropfax": 6513066300
  },
  {
    "dcode": "D",
    "dropkey": "BZ16551",
    "droptype": "D",
    "dropname": "BURTON",
    "dropdeladd": "23830 VASHON HWY SW",
    "dropdelcty": "VASHON",
    "dropdelst": "WA",
    "dropdelzpp": 980707056,
    "dropphyadd": "23830 VASHON HWY SW",
    "dropphycty": "VASHON",
    "dropphyst": "WA",
    "dropphyzpp": 980707056,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURTON",
    "dropmalst": "WA",
    "dropmalzpp": 980139998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2064632091,
    "dropsitcph": 2064632091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ16695",
    "droptype": "D",
    "dropname": "DISHMAN",
    "dropdeladd": "111 N VISTA RD STE 1A",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 992122982,
    "dropphyadd": "111 N VISTA RD STE 1A",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 992122982,
    "dropmaladd": "111 N VISTA RD STE 1A",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 992122982,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522359,
    "dropsitcph": 5098919088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ16809",
    "droptype": "D",
    "dropname": "FORT LEWIS",
    "dropdeladd": "4170 KAUFMAN AVE",
    "dropdelcty": "JOINT BASE LEWIS MCCHORD",
    "dropdelst": "WA",
    "dropdelzpp": 984332008,
    "dropphyadd": "4170 KAUFMAN AVE",
    "dropphycty": "JOINT BASE LEWIS MCCHORD",
    "dropphyst": "WA",
    "dropphyzpp": 984332008,
    "dropmaladd": "4170 KAUFMAN AVE",
    "dropmalcty": "JOINT BASE LEWIS MCCHORD",
    "dropmalst": "WA",
    "dropmalzpp": 984332008,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539646330,
    "dropsitcph": 2539648302,
    "dropfax": 6514566177
  },
  {
    "dcode": "D",
    "dropkey": "BZ16998",
    "droptype": "D",
    "dropname": "LACEY",
    "dropdeladd": "5815 LACEY BLVD SE",
    "dropdelcty": "LACEY",
    "dropdelst": "WA",
    "dropdelzpp": 985039998,
    "dropphyadd": "5815 LACEY BLVD SE",
    "dropphycty": "LACEY",
    "dropphyst": "WA",
    "dropphyzpp": 985039998,
    "dropmaladd": "5815 LACEY BLVD SE",
    "dropmalcty": "LACEY",
    "dropmalst": "WA",
    "dropmalzpp": 985039998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604598988,
    "dropsitcph": 3604551120,
    "dropfax": 6514566196
  },
  {
    "dcode": "D",
    "dropkey": "BZ17018",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "5409 100TH ST SW",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 984999998,
    "dropphyadd": "5409 100TH ST SW",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 984999998,
    "dropmaladd": "5409 100TH ST SW",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 984999998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535885104,
    "dropsitcph": 2539838266,
    "dropfax": 6514566198
  },
  {
    "dcode": "D",
    "dropkey": "BZ17065",
    "droptype": "D",
    "dropname": "MADIGAN HOSPITAL",
    "dropdeladd": "9040 REID ST",
    "dropdelcty": "JOINT BASE LEWIS MCCHORD",
    "dropdelst": "WA",
    "dropdelzpp": 984311100,
    "dropphyadd": "9040 REID ST",
    "dropphycty": "JOINT BASE LEWIS MCCHORD",
    "dropphyst": "WA",
    "dropphyzpp": 984311100,
    "dropmaladd": "9040 REID ST",
    "dropmalcty": "JOINT BASE LEWIS MCCHORD",
    "dropmalst": "WA",
    "dropmalzpp": 984311100,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539682052,
    "dropsitcph": 2539682052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ17115",
    "droptype": "D",
    "dropname": "MCCHORD AFB",
    "dropdeladd": "735 5TH ST",
    "dropdelcty": "JOINT BASE LEWIS MCCHORD",
    "dropdelst": "WA",
    "dropdelzpp": 984389998,
    "dropphyadd": "735 5TH ST",
    "dropphycty": "JOINT BASE LEWIS MCCHORD",
    "dropphyst": "WA",
    "dropphyzpp": 984389998,
    "dropmaladd": "735 5TH ST",
    "dropmalcty": "JOINT BASE LEWIS MCCHORD",
    "dropmalst": "WA",
    "dropmalzpp": 984389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539822093,
    "dropsitcph": 2539829208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ17269",
    "droptype": "D",
    "dropname": "PARKLAND",
    "dropdeladd": "320 GARFIELD ST S",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984449998,
    "dropphyadd": "320 GARFIELD ST S",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984449998,
    "dropmaladd": "320 GARFIELD ST S",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984449998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535389070,
    "dropsitcph": 2535389432,
    "dropfax": 6514566231
  },
  {
    "dcode": "D",
    "dropkey": "BZ17393",
    "droptype": "D",
    "dropname": "ROSEWOOD",
    "dropdeladd": "6325 N MONROE ST",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992089998,
    "dropphyadd": "6325 N MONROE ST",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992089998,
    "dropmaladd": "6325 N MONROE ST",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992089998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522363,
    "dropsitcph": 5093286792,
    "dropfax": 6514566250
  },
  {
    "dcode": "D",
    "dropkey": "BZ17481",
    "droptype": "D",
    "dropname": "SOUTH HILL",
    "dropdeladd": "13516 MERIDIAN E",
    "dropdelcty": "PUYALLUP",
    "dropdelst": "WA",
    "dropdelzpp": 983739997,
    "dropphyadd": "13516 MERIDIAN E",
    "dropphycty": "PUYALLUP",
    "dropphyst": "WA",
    "dropphyzpp": 983739997,
    "dropmaladd": "13516 MERIDIAN E",
    "dropmalcty": "PUYALLUP",
    "dropmalst": "WA",
    "dropmalzpp": 983739997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2534351214,
    "dropsitcph": 2534351148,
    "dropfax": 6514566266
  },
  {
    "dcode": "D",
    "dropkey": "BZ17493",
    "droptype": "D",
    "dropname": "SUNSET HILL",
    "dropdeladd": "6801 W FLIGHTLINE BLVD",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992245718,
    "dropphyadd": "6801 W FLIGHTLINE BLVD",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992245718,
    "dropmaladd": "6801 W FLIGHTLINE BLVD",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992245718,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093636221,
    "dropsitcph": 5092525100,
    "dropfax": 6514566273
  },
  {
    "dcode": "D",
    "dropkey": "BZ17576",
    "droptype": "D",
    "dropname": "STEILACOOM",
    "dropdeladd": "1610 LAFAYETTE ST",
    "dropdelcty": "STEILACOOM",
    "dropdelst": "WA",
    "dropdelzpp": 983889998,
    "dropphyadd": "1610 LAFAYETTE ST",
    "dropphycty": "STEILACOOM",
    "dropphyst": "WA",
    "dropphyzpp": 983889998,
    "dropmaladd": "1610 LAFAYETTE ST",
    "dropmalcty": "STEILACOOM",
    "dropmalst": "WA",
    "dropmalzpp": 983889998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535893943,
    "dropsitcph": 2535883493,
    "dropfax": 6514566270
  },
  {
    "dcode": "D",
    "dropkey": "BZ17634",
    "droptype": "D",
    "dropname": "TRENTWOOD",
    "dropdeladd": "14409 E TRENT AVE",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 992161392,
    "dropphyadd": "14409 E TRENT AVE",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 992161392,
    "dropmaladd": "14409 E TRENT AVE",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 992161392,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098930185,
    "dropsitcph": 5098930098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ17650",
    "droptype": "D",
    "dropname": "UNION GAP",
    "dropdeladd": "3514 MAIN ST",
    "dropdelcty": "UNION GAP",
    "dropdelst": "WA",
    "dropdelzpp": 989039997,
    "dropphyadd": "3514 MAIN ST",
    "dropphycty": "UNION GAP",
    "dropphyst": "WA",
    "dropphyzpp": 989039997,
    "dropmaladd": "3514 MAIN ST",
    "dropmalcty": "UNION GAP",
    "dropmalst": "WA",
    "dropmalzpp": 989039997,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094542478,
    "dropsitcph": 5092251389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ17658",
    "droptype": "D",
    "dropname": "UNIVERSITY PLACE",
    "dropdeladd": "6817 27TH ST W",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984669998,
    "dropphyadd": "6817 27TH ST W",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984669998,
    "dropmaladd": "6817 27TH ST W",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984669998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535667133,
    "dropsitcph": 2535667133,
    "dropfax": 6514566279
  },
  {
    "dcode": "D",
    "dropkey": "BZ17729",
    "droptype": "D",
    "dropname": "WHIDBEY ISLAND NAVAL AIR",
    "dropdeladd": "1080 W LEXINGTON ST",
    "dropdelcty": "OAK HARBOR",
    "dropdelst": "WA",
    "dropdelzpp": 982789998,
    "dropphyadd": "1080 W LEXINGTON ST",
    "dropphycty": "OAK HARBOR",
    "dropphyst": "WA",
    "dropphyzpp": 982789998,
    "dropmaladd": "1080 W LEXINGTON ST",
    "dropmalcty": "OAK HARBOR",
    "dropmalst": "WA",
    "dropmalzpp": 982789998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606756621,
    "dropsitcph": 3602572424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ17822",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "15833 MILL CREEK BLVD",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "WA",
    "dropdelzpp": 980129998,
    "dropphyadd": "15833 MILL CREEK BLVD",
    "dropphycty": "MILL CREEK",
    "dropphyst": "WA",
    "dropphyzpp": 980129998,
    "dropmaladd": "15833 MILL CREEK BLVD",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "WA",
    "dropmalzpp": 980129998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253168472,
    "dropsitcph": 4253798698,
    "dropfax": 6514566213
  },
  {
    "dcode": "D",
    "dropkey": "BZ17852",
    "droptype": "D",
    "dropname": "WEST HILLS",
    "dropdeladd": "200 S NATIONAL AVE",
    "dropdelcty": "BREMERTON",
    "dropdelst": "WA",
    "dropdelzpp": 983129998,
    "dropphyadd": "200 S NATIONAL AVE",
    "dropphycty": "BREMERTON",
    "dropphyst": "WA",
    "dropphyzpp": 983129998,
    "dropmaladd": "200 S NATIONAL AVE",
    "dropmalcty": "BREMERTON",
    "dropmalst": "WA",
    "dropmalzpp": 983129998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603772722,
    "dropsitcph": 3603772722,
    "dropfax": 6514566287
  },
  {
    "dcode": "D",
    "dropkey": "BZ17857",
    "droptype": "D",
    "dropname": "REGAL",
    "dropdeladd": "5428 S REGAL ST",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992239998,
    "dropphyadd": "5428 S REGAL ST",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992239998,
    "dropmaladd": "5428 S REGAL ST",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992239998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092523714,
    "dropsitcph": 5094439440,
    "dropfax": 6514566245
  },
  {
    "dcode": "D",
    "dropkey": "BZ17858",
    "droptype": "D",
    "dropname": "MCBH KANEOHE BAY",
    "dropdeladd": "6644 MOKAPU BLVD BLDG 6644",
    "dropdelcty": "MCBH KANEOHE BAY",
    "dropdelst": "HI",
    "dropdelzpp": 968635097,
    "dropphyadd": "6644 MOKAPU BLVD BLDG 6644",
    "dropphycty": "MCBH KANEOHE BAY",
    "dropphyst": "HI",
    "dropphyzpp": 968635097,
    "dropmaladd": "335 HAHANI ST",
    "dropmalcty": "KAILUA",
    "dropmalst": "HI",
    "dropmalzpp": 967349998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082579933,
    "dropsitcph": 8082663996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ18011",
    "droptype": "D",
    "dropname": "CIMARRON HILLS",
    "dropdeladd": "5925 GALLEY RD",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809153761,
    "dropphyadd": "5925 GALLEY RD",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809153761,
    "dropmaladd": "5925 GALLEY RD",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809153761,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196381781,
    "dropsitcph": 7196381781,
    "dropfax": 7195966750
  },
  {
    "dcode": "D",
    "dropkey": "BZ18079",
    "droptype": "D",
    "dropname": "NORTH LOGAN",
    "dropdeladd": "1721 N 400 E",
    "dropdelcty": "LOGAN",
    "dropdelst": "UT",
    "dropdelzpp": 843419998,
    "dropphyadd": "1721 N 400 E",
    "dropphycty": "LOGAN",
    "dropphyst": "UT",
    "dropphyzpp": 843419998,
    "dropmaladd": "1721 N 400 E",
    "dropmalcty": "LOGAN",
    "dropmalst": "UT",
    "dropmalzpp": 843419998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357520059,
    "dropsitcph": 4357520301,
    "dropfax": 8017523493
  },
  {
    "dcode": "D",
    "dropkey": "BZ18083",
    "droptype": "D",
    "dropname": "SNYDERVILLE",
    "dropdeladd": "1764 UINTA WAY STE H1",
    "dropdelcty": "PARK CITY",
    "dropdelst": "UT",
    "dropdelzpp": 840987698,
    "dropphyadd": "1764 UINTA WAY STE H1",
    "dropphycty": "PARK CITY",
    "dropphyst": "UT",
    "dropphyzpp": 840987698,
    "dropmaladd": "1764 UINTA WAY STE H1",
    "dropmalcty": "PARK CITY",
    "dropmalst": "UT",
    "dropmalzpp": 840987698,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356558037,
    "dropsitcph": 4356558037,
    "dropfax": 4356494163
  },
  {
    "dcode": "D",
    "dropkey": "BZ18221",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "21905 MOUNTAIN HWY E",
    "dropdelcty": "SPANAWAY",
    "dropdelst": "WA",
    "dropdelzpp": 983877518,
    "dropphyadd": "21905 MOUNTAIN HWY E",
    "dropphycty": "SPANAWAY",
    "dropphyst": "WA",
    "dropphyzpp": 983877518,
    "dropmaladd": "21905 MOUNTAIN HWY E",
    "dropmalcty": "SPANAWAY",
    "dropmalst": "WA",
    "dropmalzpp": 983877518,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538751125,
    "dropsitcph": 2538751125,
    "dropfax": 6514566586
  },
  {
    "dcode": "D",
    "dropkey": "BZ18233",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "945 S BIRCH ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802469998,
    "dropphyadd": "945 S BIRCH ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802469998,
    "dropmaladd": "945 S BIRCH ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802469998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035049050,
    "dropsitcph": 3035049050,
    "dropfax": 3035049269
  },
  {
    "dcode": "D",
    "dropkey": "BZ18331",
    "droptype": "D",
    "dropname": "SOUTH JORDAN",
    "dropdeladd": "10102 S REDWOOD RD",
    "dropdelcty": "SOUTH JORDAN",
    "dropdelst": "UT",
    "dropdelzpp": 840959998,
    "dropphyadd": "10102 S REDWOOD RD",
    "dropphycty": "SOUTH JORDAN",
    "dropphyst": "UT",
    "dropphyzpp": 840959998,
    "dropmaladd": "10102 S REDWOOD RD",
    "dropmalcty": "SOUTH JORDAN",
    "dropmalst": "UT",
    "dropmalzpp": 840959998,
    "dropsitphn": 3853376215,
    "dropsitlph": 8014466407,
    "dropsitcph": 8014466406,
    "dropfax": 8014469196
  },
  {
    "dcode": "D",
    "dropkey": "BZ18409",
    "droptype": "D",
    "dropname": "ORO VALLEY",
    "dropdeladd": "11900 N LA CANADA DR",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857379998,
    "dropphyadd": "11900 N LA CANADA DR",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857379998,
    "dropmaladd": "11900 N LA CANADA DR",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857379998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5202290340,
    "dropsitcph": 5202290320,
    "dropfax": 5202290338
  },
  {
    "dcode": "D",
    "dropkey": "BZ18825",
    "droptype": "D",
    "dropname": "SPRING CREEK",
    "dropdeladd": "576 SPRING VALLEY CT",
    "dropdelcty": "SPRING CREEK",
    "dropdelst": "NV",
    "dropdelzpp": 898159996,
    "dropphyadd": "576 SPRING VALLEY CT",
    "dropphycty": "SPRING CREEK",
    "dropphyst": "NV",
    "dropphyzpp": 898159996,
    "dropmaladd": "576 SPRING VALLEY CT",
    "dropmalcty": "SPRING CREEK",
    "dropmalst": "NV",
    "dropmalzpp": 898159996,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757779816,
    "dropsitcph": 7757779816,
    "dropfax": 7757537923
  },
  {
    "dcode": "D",
    "dropkey": "BZ18874",
    "droptype": "D",
    "dropname": "SUN CITY WEST",
    "dropdeladd": "19437 N NEW TRADITION RD",
    "dropdelcty": "SUN CITY WEST",
    "dropdelst": "AZ",
    "dropdelzpp": 853759998,
    "dropphyadd": "19437 N NEW TRADITION RD",
    "dropphycty": "SUN CITY WEST",
    "dropphyst": "AZ",
    "dropphyzpp": 853759998,
    "dropmaladd": "19437 N NEW TRADITION RD",
    "dropmalcty": "SUN CITY WEST",
    "dropmalst": "AZ",
    "dropmalzpp": 853759998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6232146915,
    "dropsitcph": 6235463990,
    "dropfax": 6232146906
  },
  {
    "dcode": "D",
    "dropkey": "BZ18897",
    "droptype": "D",
    "dropname": "KENMORE",
    "dropdeladd": "6700 NE 181ST ST",
    "dropdelcty": "KENMORE",
    "dropdelst": "WA",
    "dropdelzpp": 980289998,
    "dropphyadd": "6700 NE 181ST ST",
    "dropphycty": "KENMORE",
    "dropphyst": "WA",
    "dropphyzpp": 980289998,
    "dropmaladd": "6700 NE 181ST ST",
    "dropmalcty": "KENMORE",
    "dropmalst": "WA",
    "dropmalzpp": 980289998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254869759,
    "dropsitcph": 4254829755,
    "dropfax": 4254862216
  },
  {
    "dcode": "D",
    "dropkey": "BZ18993",
    "droptype": "D",
    "dropname": "TUMWATER",
    "dropdeladd": "200 ISRAEL RD SE",
    "dropdelcty": "TUMWATER",
    "dropdelst": "WA",
    "dropdelzpp": 985016458,
    "dropphyadd": "200 ISRAEL RD SE",
    "dropphycty": "TUMWATER",
    "dropphyst": "WA",
    "dropphyzpp": 985016458,
    "dropmaladd": "200 ISRAEL RD SE",
    "dropmalcty": "TUMWATER",
    "dropmalst": "WA",
    "dropmalzpp": 985016458,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603526200,
    "dropsitcph": 3603526386,
    "dropfax": 3603526387
  },
  {
    "dcode": "D",
    "dropkey": "BZ20002",
    "droptype": "D",
    "dropname": "FPO",
    "dropdeladd": "2501 RYDIN RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948509751,
    "dropphyadd": "2501 RYDIN RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948509751,
    "dropmaladd": "2501 RYDIN RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948509751,
    "dropsitphn": 6508081314,
    "dropsitlph": 6508081356,
    "dropsitcph": 6508081356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20046",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "1191 SOLANO AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "CA",
    "dropdelzpp": 947061682,
    "dropphyadd": "1191 SOLANO AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "CA",
    "dropphyzpp": 947061682,
    "dropmaladd": "2000 ALLSTON WAY",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947049998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493136,
    "dropsitcph": 5106496718,
    "dropfax": 5106493124
  },
  {
    "dcode": "D",
    "dropkey": "BZ20076",
    "droptype": "D",
    "dropname": "ALTAVILLE",
    "dropdeladd": "380 S MAIN ST",
    "dropdelcty": "ALTAVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 952219998,
    "dropphyadd": "380 S MAIN ST",
    "dropphycty": "ALTAVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 952219998,
    "dropmaladd": "380 S MAIN ST",
    "dropmalcty": "ALTAVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 952219998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097364095,
    "dropsitcph": 2097364095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20088",
    "droptype": "D",
    "dropname": "AMERICAN CANYON",
    "dropdeladd": "310 CRAWFORD WAY",
    "dropdelcty": "AMERICAN CANYON",
    "dropdelst": "CA",
    "dropdelzpp": 945039991,
    "dropphyadd": "310 CRAWFORD WAY",
    "dropphycty": "AMERICAN CANYON",
    "dropphyst": "CA",
    "dropphyzpp": 945039991,
    "dropmaladd": "310 CRAWFORD WAY",
    "dropmalcty": "AMERICAN CANYON",
    "dropmalst": "CA",
    "dropmalzpp": 945039991,
    "dropsitphn": 7076424441,
    "dropsitlph": 7076423355,
    "dropsitcph": 7076423071,
    "dropfax": 7076422957
  },
  {
    "dcode": "D",
    "dropkey": "BZ20125",
    "droptype": "D",
    "dropname": "ARLETA",
    "dropdeladd": "9454 ARLETA AVE",
    "dropdelcty": "ARLETA",
    "dropdelst": "CA",
    "dropdelzpp": 913314749,
    "dropphyadd": "9454 ARLETA AVE",
    "dropphycty": "ARLETA",
    "dropphyst": "CA",
    "dropphyzpp": 913314749,
    "dropmaladd": "13507 VAN NUYS BLVD",
    "dropmalcty": "PACOIMA",
    "dropmalst": "CA",
    "dropmalzpp": 913319998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188996791,
    "dropsitcph": 8188994660,
    "dropfax": 8188344251
  },
  {
    "dcode": "D",
    "dropkey": "BZ20203",
    "droptype": "D",
    "dropname": "BASSETT",
    "dropdeladd": "512 WORKMAN MILL RD",
    "dropdelcty": "LA PUENTE",
    "dropdelst": "CA",
    "dropdelzpp": 917469998,
    "dropphyadd": "512 WORKMAN MILL RD",
    "dropphycty": "LA PUENTE",
    "dropphyst": "CA",
    "dropphyzpp": 917469998,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479998,
    "dropsitphn": 6263695301,
    "dropsitlph": 6263333432,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": "BZ20218",
    "droptype": "D",
    "dropname": "BEALE AFB",
    "dropdeladd": "17852 16TH ST",
    "dropdelcty": "BEALE AFB",
    "dropdelst": "CA",
    "dropdelzpp": 959039998,
    "dropphyadd": "17852 16TH ST",
    "dropphycty": "BEALE AFB",
    "dropphyst": "CA",
    "dropphyzpp": 959039998,
    "dropmaladd": "17852 16TH ST",
    "dropmalcty": "BEALE AFB",
    "dropmalst": "CA",
    "dropmalzpp": 959039998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307422336,
    "dropsitcph": 5307882401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20331",
    "droptype": "D",
    "dropname": "BOWMAN",
    "dropdeladd": "13116 LINCOLN WAY",
    "dropdelcty": "AUBURN",
    "dropdelst": "CA",
    "dropdelzpp": 956039996,
    "dropphyadd": "13116 LINCOLN WAY",
    "dropphycty": "AUBURN",
    "dropphyst": "CA",
    "dropphyzpp": 956039996,
    "dropmaladd": "13116 LINCOLN WAY",
    "dropmalcty": "AUBURN",
    "dropmalst": "CA",
    "dropmalzpp": 956039996,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308857793,
    "dropsitcph": 5308857793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20436",
    "droptype": "D",
    "dropname": "CALABASAS",
    "dropdeladd": "4774 PARK GRANADA STE 10",
    "dropdelcty": "CALABASAS",
    "dropdelst": "CA",
    "dropdelzpp": 913029998,
    "dropphyadd": "4774 PARK GRANADA STE 10",
    "dropphycty": "CALABASAS",
    "dropphyst": "CA",
    "dropphyzpp": 913029998,
    "dropmaladd": "4774 PARK GRANADA STE 10",
    "dropmalcty": "CALABASAS",
    "dropmalst": "CA",
    "dropmalzpp": 913029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185911790,
    "dropsitcph": 8185911790,
    "dropfax": 8185771260
  },
  {
    "dcode": "D",
    "dropkey": "BZ20446",
    "droptype": "D",
    "dropname": "CALIFORNIA CITY",
    "dropdeladd": "21100 HACIENDA BLVD",
    "dropdelcty": "CALIFORNIA CITY",
    "dropdelst": "CA",
    "dropdelzpp": 935059998,
    "dropphyadd": "21100 HACIENDA BLVD",
    "dropphycty": "CALIFORNIA CITY",
    "dropphyst": "CA",
    "dropphyzpp": 935059998,
    "dropmaladd": "21100 HACIENDA BLVD",
    "dropmalcty": "CALIFORNIA CITY",
    "dropmalst": "CA",
    "dropmalzpp": 935059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603738113,
    "dropsitcph": 7603738113,
    "dropfax": 7603739209
  },
  {
    "dcode": "D",
    "dropkey": "BZ20459",
    "droptype": "D",
    "dropname": "CALPELLA",
    "dropdeladd": "6260 N STATE ST",
    "dropdelcty": "CALPELLA",
    "dropdelst": "CA",
    "dropdelzpp": 954187000,
    "dropphyadd": "6260 N STATE ST",
    "dropphycty": "CALPELLA",
    "dropphyst": "CA",
    "dropphyzpp": 954187000,
    "dropmaladd": "6260 N STATE ST",
    "dropmalcty": "CALPELLA",
    "dropmalst": "CA",
    "dropmalzpp": 954187000,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074858692,
    "dropfax": 7074623767
  },
  {
    "dcode": "D",
    "dropkey": "BZ20491",
    "droptype": "D",
    "dropname": "CANYON COUNTRY",
    "dropdeladd": "18336 SOLEDAD CANYON RD",
    "dropdelcty": "CANYON COUNTRY",
    "dropdelst": "CA",
    "dropdelzpp": 913879998,
    "dropphyadd": "18336 SOLEDAD CANYON RD",
    "dropphycty": "CANYON COUNTRY",
    "dropphyst": "CA",
    "dropphyzpp": 913879998,
    "dropmaladd": "18336 SOLEDAD CANYON RD",
    "dropmalcty": "CANYON COUNTRY",
    "dropmalst": "CA",
    "dropmalzpp": 913879998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612524313,
    "dropsitcph": 6612515768,
    "dropfax": 6612547318
  },
  {
    "dcode": "D",
    "dropkey": "BZ20499",
    "droptype": "D",
    "dropname": "CAPISTRANO BEACH",
    "dropdeladd": "34281 DOHENY PARK RD",
    "dropdelcty": "CAPISTRANO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926242200,
    "dropphyadd": "34281 DOHENY PARK RD",
    "dropphycty": "CAPISTRANO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926242200,
    "dropmaladd": "34281 DOHENY PARK RD",
    "dropmalcty": "CAPISTRANO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926242200,
    "dropsitphn": 9494962787,
    "dropsitlph": 9494961219,
    "dropsitcph": 9494962787,
    "dropfax": 9494932193
  },
  {
    "dcode": "D",
    "dropkey": "BZ20522",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "21350 AVALON BLVD",
    "dropdelcty": "CARSON",
    "dropdelst": "CA",
    "dropdelzpp": 907459998,
    "dropphyadd": "21350 AVALON BLVD",
    "dropphycty": "CARSON",
    "dropphyst": "CA",
    "dropphyzpp": 907459998,
    "dropmaladd": "21350 AVALON BLVD",
    "dropmalcty": "CARSON",
    "dropmalst": "CA",
    "dropmalzpp": 907459998,
    "dropsitphn": 3105490851,
    "dropsitlph": 3105490851,
    "dropsitcph": 3105492801,
    "dropfax": 3105491336
  },
  {
    "dcode": "D",
    "dropkey": "BZ20540",
    "droptype": "D",
    "dropname": "CASTRO VALLEY",
    "dropdeladd": "20283 SANTA MARIA AVE",
    "dropdelcty": "CASTRO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 945469998,
    "dropphyadd": "20283 SANTA MARIA AVE",
    "dropphycty": "CASTRO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 945469998,
    "dropmaladd": "20283 SANTA MARIA AVE",
    "dropmalcty": "CASTRO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 945469998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5105817322,
    "dropsitcph": 5105810159,
    "dropfax": 5105814074
  },
  {
    "dcode": "D",
    "dropkey": "BZ20558",
    "droptype": "D",
    "dropname": "CEDARPINES PARK",
    "dropdeladd": "201 NARDY LN",
    "dropdelcty": "CEDARPINES PARK",
    "dropdelst": "CA",
    "dropdelzpp": 923220001,
    "dropphyadd": "201 NARDY LN",
    "dropphycty": "CEDARPINES PARK",
    "dropphyst": "CA",
    "dropphyzpp": 923220001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESTLINE",
    "dropmalst": "CA",
    "dropmalzpp": 923259998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093389513,
    "dropsitcph": 9093385489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20570",
    "droptype": "D",
    "dropname": "CERRITOS",
    "dropdeladd": "18122 CARMENITA RD",
    "dropdelcty": "CERRITOS",
    "dropdelst": "CA",
    "dropdelzpp": 907039998,
    "dropphyadd": "18122 CARMENITA RD",
    "dropphycty": "CERRITOS",
    "dropphyst": "CA",
    "dropphyzpp": 907039998,
    "dropmaladd": "11721 183RD ST",
    "dropmalcty": "ARTESIA",
    "dropmalst": "CA",
    "dropmalzpp": 907019998,
    "dropsitphn": 5628600394,
    "dropsitlph": 5628602821,
    "dropsitcph": 5624041585,
    "dropfax": 5629218237
  },
  {
    "dcode": "D",
    "dropkey": "BZ20617",
    "droptype": "D",
    "dropname": "CITY OF INDUSTRY",
    "dropdeladd": "15421 E GALE AVE",
    "dropdelcty": "CITY OF INDUSTRY",
    "dropdelst": "CA",
    "dropdelzpp": 917159608,
    "dropphyadd": "15421 E GALE AVE",
    "dropphycty": "CITY OF INDUSTRY",
    "dropphyst": "CA",
    "dropphyzpp": 917159608,
    "dropmaladd": "15421 E GALE AVE",
    "dropmalcty": "CITY OF INDUSTRY",
    "dropmalst": "CA",
    "dropmalzpp": 917159608,
    "dropsitphn": 6268556440,
    "dropsitlph": 6263366269,
    "dropsitcph": 6268556440,
    "dropfax": 6268556696
  },
  {
    "dcode": "D",
    "dropkey": "BZ20761",
    "droptype": "D",
    "dropname": "CORONADO",
    "dropdeladd": "1320 YNEZ PL",
    "dropdelcty": "CORONADO",
    "dropdelst": "CA",
    "dropdelzpp": 921189998,
    "dropphyadd": "1320 YNEZ PL",
    "dropphycty": "CORONADO",
    "dropphyst": "CA",
    "dropphyzpp": 921189998,
    "dropmaladd": "1320 YNEZ PL",
    "dropmalcty": "CORONADO",
    "dropmalst": "CA",
    "dropmalzpp": 921189998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194356520,
    "dropsitcph": 6194351142,
    "dropfax": 6194355192
  },
  {
    "dcode": "D",
    "dropkey": "BZ20776",
    "droptype": "D",
    "dropname": "COYOTE",
    "dropdeladd": "8220 MONTEREY RD",
    "dropdelcty": "COYOTE",
    "dropdelst": "CA",
    "dropdelzpp": 950139800,
    "dropphyadd": "8220 MONTEREY RD",
    "dropphycty": "COYOTE",
    "dropphyst": "CA",
    "dropphyzpp": 950139800,
    "dropmaladd": "PO BOX 13000",
    "dropmalcty": "COYOTE",
    "dropmalst": "CA",
    "dropmalzpp": 950139998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084631418,
    "dropsitcph": 4082268391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20808",
    "droptype": "D",
    "dropname": "CUDAHY",
    "dropdeladd": "4619 ELIZABETH ST",
    "dropdelcty": "CUDAHY",
    "dropdelst": "CA",
    "dropdelzpp": 902019992,
    "dropphyadd": "4619 ELIZABETH ST",
    "dropphycty": "CUDAHY",
    "dropphyst": "CA",
    "dropphyzpp": 902019992,
    "dropmaladd": "4619 ELIZABETH ST",
    "dropmalcty": "CUDAHY",
    "dropmalst": "CA",
    "dropmalzpp": 902019992,
    "dropsitphn": 5624942406,
    "dropsitlph": 2135621787,
    "dropsitcph": 3235623062,
    "dropfax": 5628069206
  },
  {
    "dcode": "D",
    "dropkey": "BZ20816",
    "droptype": "D",
    "dropname": "CUTTEN",
    "dropdeladd": "3901 WALNUT DR",
    "dropdelcty": "EUREKA",
    "dropdelst": "CA",
    "dropdelzpp": 955039993,
    "dropphyadd": "3901 WALNUT DR",
    "dropphycty": "EUREKA",
    "dropphyst": "CA",
    "dropphyzpp": 955039993,
    "dropmaladd": "337 W CLARK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "CA",
    "dropmalzpp": 955019903,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074421768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ20884",
    "droptype": "D",
    "dropname": "DIAMOND BAR",
    "dropdeladd": "1317 S DIAMOND BAR BLVD",
    "dropdelcty": "DIAMOND BAR",
    "dropdelst": "CA",
    "dropdelzpp": 917659998,
    "dropphyadd": "1317 S DIAMOND BAR BLVD",
    "dropphycty": "DIAMOND BAR",
    "dropphyst": "CA",
    "dropphyzpp": 917659998,
    "dropmaladd": "580 W MONTEREY AVE",
    "dropmalcty": "POMONA",
    "dropmalst": "CA",
    "dropmalzpp": 917699998,
    "dropsitphn": 9098602469,
    "dropsitlph": 9098617623,
    "dropsitcph": 9098602469,
    "dropfax": 9098608253
  },
  {
    "dcode": "D",
    "dropkey": "BZ20939",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "6937 VILLAGE PKWY",
    "dropdelcty": "DUBLIN",
    "dropdelst": "CA",
    "dropdelzpp": 945682405,
    "dropphyadd": "6937 VILLAGE PKWY",
    "dropphycty": "DUBLIN",
    "dropphyst": "CA",
    "dropphyzpp": 945682405,
    "dropmaladd": "4300 BLACK AVE",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "CA",
    "dropmalzpp": 945669998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9258287894,
    "dropsitcph": 9258282689,
    "dropfax": 9258281914
  },
  {
    "dcode": "D",
    "dropkey": "BZ20976",
    "droptype": "D",
    "dropname": "EAST LOS ANGELES",
    "dropdeladd": "975 S ATLANTIC BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900229998,
    "dropphyadd": "975 S ATLANTIC BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900229998,
    "dropmaladd": "975 S ATLANTIC BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900229998,
    "dropsitphn": 2135861867,
    "dropsitlph": 3232682643,
    "dropsitcph": 3232683148,
    "dropfax": 3232681759
  },
  {
    "dcode": "D",
    "dropkey": "BZ21017",
    "droptype": "D",
    "dropname": "EL DORADO HILLS",
    "dropdeladd": "4641 POST ST",
    "dropdelcty": "EL DORADO HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 957629998,
    "dropphyadd": "4641 POST ST",
    "dropphycty": "EL DORADO HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 957629998,
    "dropmaladd": "4641 POST ST",
    "dropmalcty": "EL DORADO HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 957629998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163587801,
    "dropsitcph": 9169390168,
    "dropfax": 9169390367
  },
  {
    "dcode": "D",
    "dropkey": "BZ21030",
    "droptype": "D",
    "dropname": "EL SOBRANTE",
    "dropdeladd": "535 APPIAN WAY",
    "dropdelcty": "EL SOBRANTE",
    "dropdelst": "CA",
    "dropdelzpp": 948039991,
    "dropphyadd": "535 APPIAN WAY",
    "dropphycty": "EL SOBRANTE",
    "dropphyst": "CA",
    "dropphyzpp": 948039991,
    "dropmaladd": "535 APPIAN WAY",
    "dropmalcty": "EL SOBRANTE",
    "dropmalst": "CA",
    "dropmalzpp": 948039991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106691674,
    "dropsitcph": 5102626910,
    "dropfax": 5102323718
  },
  {
    "dcode": "D",
    "dropkey": "BZ21052",
    "droptype": "D",
    "dropname": "EMERYVILLE",
    "dropdeladd": "1585 62ND ST",
    "dropdelcty": "EMERYVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 946082039,
    "dropphyadd": "1585 62ND ST",
    "dropphycty": "EMERYVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 946082039,
    "dropmaladd": "1585 62ND ST",
    "dropmalcty": "EMERYVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 946089991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513387,
    "dropsitcph": 5102513386,
    "dropfax": 5104201653
  },
  {
    "dcode": "D",
    "dropkey": "BZ21061",
    "droptype": "D",
    "dropname": "ENCINO",
    "dropdeladd": "5805 WHITE OAK AVE",
    "dropdelcty": "ENCINO",
    "dropdelst": "CA",
    "dropdelzpp": 913169998,
    "dropphyadd": "5805 WHITE OAK AVE",
    "dropphycty": "ENCINO",
    "dropphyst": "CA",
    "dropphyzpp": 913169998,
    "dropmaladd": "5805 WHITE OAK AVE",
    "dropmalcty": "ENCINO",
    "dropmalst": "CA",
    "dropmalzpp": 913169998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183433674,
    "dropsitcph": 8183433674,
    "dropfax": 8183431167
  },
  {
    "dcode": "D",
    "dropkey": "BZ21069",
    "droptype": "D",
    "dropname": "ETIWANDA",
    "dropdeladd": "7615 ETIWANDA AVE",
    "dropdelcty": "RANCHO CUCAMONGA",
    "dropdelst": "CA",
    "dropdelzpp": 917399998,
    "dropphyadd": "7615 ETIWANDA AVE",
    "dropphycty": "RANCHO CUCAMONGA",
    "dropphyst": "CA",
    "dropphyzpp": 917399998,
    "dropmaladd": "10950 ARROW RTE",
    "dropmalcty": "RANCHO CUCAMONGA",
    "dropmalst": "CA",
    "dropmalzpp": 917299998,
    "dropsitphn": 9098998644,
    "dropsitlph": 9098990793,
    "dropsitcph": 9098998644,
    "dropfax": 9099873653
  },
  {
    "dcode": "D",
    "dropkey": "BZ21176",
    "droptype": "D",
    "dropname": "FORT IRWIN",
    "dropdeladd": "306 LANGFORD LAKE RD BLDG 306",
    "dropdelcty": "FORT IRWIN",
    "dropdelst": "CA",
    "dropdelzpp": 923109800,
    "dropphyadd": "306 LANGFORD LAKE RD BLDG 306",
    "dropphycty": "FORT IRWIN",
    "dropphyst": "CA",
    "dropphyzpp": 923109800,
    "dropmaladd": "306 LANGFORD LAKE RD BLDG 306",
    "dropmalcty": "FORT IRWIN",
    "dropmalst": "CA",
    "dropmalzpp": 923109800,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603862259,
    "dropsitcph": 7603803451,
    "dropfax": 7603862259
  },
  {
    "dcode": "D",
    "dropkey": "BZ21187",
    "droptype": "D",
    "dropname": "FOUNTAIN VALLEY",
    "dropdeladd": "17227 NEWHOPE ST",
    "dropdelcty": "FOUNTAIN VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 927289005,
    "dropphyadd": "17227 NEWHOPE ST",
    "dropphycty": "FOUNTAIN VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 927289005,
    "dropmaladd": "17227 NEWHOPE ST",
    "dropmalcty": "FOUNTAIN VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 927289005,
    "dropsitphn": 7149660595,
    "dropsitlph": 7149665292,
    "dropsitcph": 7149660595,
    "dropfax": 7149669273
  },
  {
    "dcode": "D",
    "dropkey": "BZ21298",
    "droptype": "D",
    "dropname": "GOLETA",
    "dropdeladd": "130 S PATTERSON AVE",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931119998,
    "dropphyadd": "130 S PATTERSON AVE",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931119998,
    "dropmaladd": "130 S PATTERSON AVE",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931119998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056925631,
    "dropsitcph": 8056925642,
    "dropfax": 8056925650
  },
  {
    "dcode": "D",
    "dropkey": "BZ21306",
    "droptype": "D",
    "dropname": "GRANADA HILLS",
    "dropdeladd": "18039 CHATSWORTH ST",
    "dropdelcty": "GRANADA HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 913449998,
    "dropphyadd": "18039 CHATSWORTH ST",
    "dropphycty": "GRANADA HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 913449998,
    "dropmaladd": "18039 CHATSWORTH ST",
    "dropmalcty": "GRANADA HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 913449998,
    "dropsitphn": 6617757608,
    "dropsitlph": 8183609174,
    "dropsitcph": 8188380693,
    "dropfax": 8183613733
  },
  {
    "dcode": "D",
    "dropkey": "BZ21325",
    "droptype": "D",
    "dropname": "GREEN VALLEY LAKE",
    "dropdeladd": "33271 GREEN VALLEY LAKE RD",
    "dropdelcty": "GREEN VALLEY LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 923410400,
    "dropphyadd": "33271 GREEN VALLEY LAKE RD",
    "dropphycty": "GREEN VALLEY LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 923410400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN VALLEY LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 923419998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098673247,
    "dropsitcph": 9098673247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21361",
    "droptype": "D",
    "dropname": "HACIENDA HEIGHTS",
    "dropdeladd": "2054 S HACIENDA BLVD",
    "dropdelcty": "HACIENDA HEIGHTS",
    "dropdelst": "CA",
    "dropdelzpp": 917459998,
    "dropphyadd": "2054 S HACIENDA BLVD",
    "dropphycty": "HACIENDA HEIGHTS",
    "dropphyst": "CA",
    "dropphyzpp": 917459998,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479998,
    "dropsitphn": 6263695301,
    "dropsitlph": 6263694859,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": "BZ21398",
    "droptype": "D",
    "dropname": "HAZARD",
    "dropdeladd": "3729 E 1ST ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900639998,
    "dropphyadd": "3729 E 1ST ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900639998,
    "dropmaladd": "3729 E 1ST ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900639998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232627117,
    "dropsitcph": 3232620361,
    "dropfax": 3232622133
  },
  {
    "dcode": "D",
    "dropkey": "BZ21411",
    "droptype": "D",
    "dropname": "HERCULES",
    "dropdeladd": "1611 SYCAMORE AVE",
    "dropdelcty": "HERCULES",
    "dropdelst": "CA",
    "dropdelzpp": 945471707,
    "dropphyadd": "1611 SYCAMORE AVE",
    "dropphycty": "HERCULES",
    "dropphyst": "CA",
    "dropphyzpp": 945471707,
    "dropmaladd": "499 PARKER AVE",
    "dropmalcty": "RODEO",
    "dropmalst": "CA",
    "dropmalzpp": 945721457,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107994233,
    "dropsitcph": 5107993607,
    "dropfax": 5107994584
  },
  {
    "dcode": "D",
    "dropkey": "BZ21415",
    "droptype": "D",
    "dropname": "HERMOSA BEACH",
    "dropdeladd": "565 PIER AVE",
    "dropdelcty": "HERMOSA BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902549998,
    "dropphyadd": "565 PIER AVE",
    "dropphycty": "HERMOSA BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902549998,
    "dropmaladd": "565 PIER AVE",
    "dropmalcty": "HERMOSA BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902549998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103793572,
    "dropsitcph": 3103763252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21532",
    "droptype": "D",
    "dropname": "IRWINDALE",
    "dropdeladd": "16025 CALLE DEL NORTE",
    "dropdelcty": "BALDWIN PARK",
    "dropdelst": "CA",
    "dropdelzpp": 917069997,
    "dropphyadd": "16025 CALLE DEL NORTE",
    "dropphycty": "BALDWIN PARK",
    "dropphyst": "CA",
    "dropphyzpp": 917069997,
    "dropmaladd": "4230 MAINE AVE",
    "dropmalcty": "BALDWIN PARK",
    "dropmalst": "CA",
    "dropmalzpp": 917069998,
    "dropsitphn": 6269620268,
    "dropsitlph": 6263372207,
    "dropsitcph": 6269620268,
    "dropfax": 6269603057
  },
  {
    "dcode": "D",
    "dropkey": "BZ21581",
    "droptype": "D",
    "dropname": "KENTFIELD",
    "dropdeladd": "822 COLLEGE AVE",
    "dropdelcty": "KENTFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 949049991,
    "dropphyadd": "822 COLLEGE AVE",
    "dropphycty": "KENTFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 949049991,
    "dropmaladd": "822 COLLEGE AVE",
    "dropmalcty": "KENTFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 949049991,
    "dropsitphn": 7074547825,
    "dropsitlph": 7074547825,
    "dropsitcph": 4154547756,
    "dropfax": 4154565136
  },
  {
    "dcode": "D",
    "dropkey": "BZ21594",
    "droptype": "D",
    "dropname": "KINGS CANYON NATIONAL PK",
    "dropdeladd": "86724 HIGHWAY 180",
    "dropdelcty": "KINGS CANYON NATIONAL PK",
    "dropdelst": "CA",
    "dropdelzpp": 936339800,
    "dropphyadd": "86724 HIGHWAY 180",
    "dropphycty": "KINGS CANYON NATIONAL PK",
    "dropphyst": "CA",
    "dropphyzpp": 936339800,
    "dropmaladd": "86724 HIGHWAY 180",
    "dropmalcty": "KINGS CANYON NATIONAL PK",
    "dropmalst": "CA",
    "dropmalzpp": 936339800,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 5593352499,
    "dropfax": 5593351199
  },
  {
    "dcode": "D",
    "dropkey": "BZ21616",
    "droptype": "D",
    "dropname": "LA CRESCENTA",
    "dropdeladd": "3300 FOOTHILL BLVD",
    "dropdelcty": "LA CRESCENTA",
    "dropdelst": "CA",
    "dropdelzpp": 912149998,
    "dropphyadd": "3300 FOOTHILL BLVD",
    "dropphycty": "LA CRESCENTA",
    "dropphyst": "CA",
    "dropphyzpp": 912149998,
    "dropmaladd": "3300 FOOTHILL BLVD",
    "dropmalcty": "LA CRESCENTA",
    "dropmalst": "CA",
    "dropmalzpp": 912149998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8182482802,
    "dropsitcph": 8182483117,
    "dropfax": 8182489657
  },
  {
    "dcode": "D",
    "dropkey": "BZ21644",
    "droptype": "D",
    "dropname": "LAGUNA HILLS",
    "dropdeladd": "24001 CALLE DE LA MAGDALENA",
    "dropdelcty": "LAGUNA HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 926549998,
    "dropphyadd": "24001 CALLE DE LA MAGDALENA",
    "dropphycty": "LAGUNA HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 926549998,
    "dropmaladd": "24001 CALLE DE LA MAGDALENA",
    "dropmalcty": "LAGUNA HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 926549998,
    "dropsitphn": 9498371848,
    "dropsitlph": 9498371611,
    "dropsitcph": 9498371848,
    "dropfax": 9498373946
  },
  {
    "dcode": "D",
    "dropkey": "BZ21674",
    "droptype": "D",
    "dropname": "LAKESHORE",
    "dropdeladd": "62804 HUNTINGTON LAKE RD",
    "dropdelcty": "LAKESHORE",
    "dropdelst": "CA",
    "dropdelzpp": 936349997,
    "dropphyadd": "62804 HUNTINGTON LAKE RD",
    "dropphycty": "LAKESHORE",
    "dropphyst": "CA",
    "dropphyzpp": 936349997,
    "dropmaladd": "62804 HUNTINGTON LAKE RD",
    "dropmalcty": "LAKESHORE",
    "dropmalst": "CA",
    "dropmalzpp": 936349997,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598933421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21686",
    "droptype": "D",
    "dropname": "LANDERS",
    "dropdeladd": "890 LANDERS LN",
    "dropdelcty": "LANDERS",
    "dropdelst": "CA",
    "dropdelzpp": 922859998,
    "dropphyadd": "890 LANDERS LN",
    "dropphycty": "LANDERS",
    "dropphyst": "CA",
    "dropphyzpp": 922859998,
    "dropmaladd": "890 LANDERS LN",
    "dropmalcty": "LANDERS",
    "dropmalst": "CA",
    "dropmalzpp": 922859998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603642323,
    "dropsitcph": 7603642323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21723",
    "droptype": "D",
    "dropname": "LEMOORE NAVAL AIR STATION",
    "dropdeladd": "826 HANCOCK CIR",
    "dropdelcty": "LEMOORE",
    "dropdelst": "CA",
    "dropdelzpp": 932462010,
    "dropphyadd": "826 HANCOCK CIR",
    "dropphycty": "LEMOORE",
    "dropphyst": "CA",
    "dropphyzpp": 932462010,
    "dropmaladd": "206 C ST",
    "dropmalcty": "LEMOORE",
    "dropmalst": "CA",
    "dropmalzpp": 932459998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5599243017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21812",
    "droptype": "D",
    "dropname": "LOS NIETOS",
    "dropdeladd": "8232 NORWALK BLVD",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906069998,
    "dropphyadd": "8232 NORWALK BLVD",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906069998,
    "dropmaladd": "8232 NORWALK BLVD",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906069998,
    "dropsitphn": 5626928206,
    "dropsitlph": 5626956666,
    "dropsitcph": 5626928206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21814",
    "droptype": "D",
    "dropname": "LOS OSOS",
    "dropdeladd": "1189 LOS OSOS VALLEY RD",
    "dropdelcty": "LOS OSOS",
    "dropdelst": "CA",
    "dropdelzpp": 934029998,
    "dropphyadd": "1189 LOS OSOS VALLEY RD",
    "dropphycty": "LOS OSOS",
    "dropphyst": "CA",
    "dropphyzpp": 934029998,
    "dropmaladd": "1189 LOS OSOS VALLEY RD",
    "dropmalcty": "LOS OSOS",
    "dropmalst": "CA",
    "dropmalzpp": 934029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055287239,
    "dropsitcph": 8055286927,
    "dropfax": 8055450812
  },
  {
    "dcode": "D",
    "dropkey": "BZ21880",
    "droptype": "D",
    "dropname": "MARCH AIR RESERVE BASE",
    "dropdeladd": "1486 GRAEBER ST BLDG 2406",
    "dropdelcty": "MARCH AIR RESERVE BASE",
    "dropdelst": "CA",
    "dropdelzpp": 925189995,
    "dropphyadd": "1486 GRAEBER ST BLDG 2406",
    "dropphycty": "MARCH AIR RESERVE BASE",
    "dropphyst": "CA",
    "dropphyzpp": 925189995,
    "dropmaladd": "1486 GRAEBER ST BLDG 2406",
    "dropmalcty": "MARCH AIR RESERVE BASE",
    "dropmalst": "CA",
    "dropmalzpp": 925189995,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516553010,
    "dropsitcph": 9516553010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21916",
    "droptype": "D",
    "dropname": "MC KINLEYVILLE",
    "dropdeladd": "1561 CITY CENTER RD",
    "dropdelcty": "MCKINLEYVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 955199991,
    "dropphyadd": "1561 CITY CENTER RD",
    "dropphycty": "MCKINLEYVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 955199991,
    "dropmaladd": "1561 CITY CENTER RD",
    "dropmalcty": "MCKINLEYVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 955199991,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7078223370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ21922",
    "droptype": "D",
    "dropname": "MCCLELLAN AFB",
    "dropdeladd": "3327 LAUREL ST STE 1",
    "dropdelcty": "MCCLELLAN",
    "dropdelst": "CA",
    "dropdelzpp": 956521076,
    "dropphyadd": "3327 LAUREL ST STE 1",
    "dropphycty": "MCCLELLAN",
    "dropphyst": "CA",
    "dropphyzpp": 956521076,
    "dropmaladd": "6483 WATT AVE",
    "dropmalcty": "NORTH HIGHLANDS",
    "dropmalst": "CA",
    "dropmalzpp": 956603626,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9166432722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ22006",
    "droptype": "D",
    "dropname": "MISSION HILLS",
    "dropdeladd": "10919 SEPULVEDA BLVD",
    "dropdelcty": "SAN FERNANDO",
    "dropdelst": "CA",
    "dropdelzpp": 913451435,
    "dropphyadd": "10919 SEPULVEDA BLVD",
    "dropphycty": "SAN FERNANDO",
    "dropphyst": "CA",
    "dropphyzpp": 913451435,
    "dropmaladd": "10919 SEPULVEDA BLVD",
    "dropmalcty": "SAN FERNANDO",
    "dropmalst": "CA",
    "dropmalzpp": 913451435,
    "dropsitphn": 6617757608,
    "dropsitlph": 8188379304,
    "dropsitcph": 8188380693,
    "dropfax": 8183613733
  },
  {
    "dcode": "D",
    "dropkey": "BZ22019",
    "droptype": "D",
    "dropname": "MOFFETT FIELD",
    "dropdeladd": "67 N AKRON DR",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "CA",
    "dropdelzpp": 940359991,
    "dropphyadd": "67 N AKRON DR",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "CA",
    "dropphyzpp": 940359991,
    "dropmaladd": "67 N AKRON DR",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "CA",
    "dropmalzpp": 940359991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509674144,
    "dropsitcph": 6509606851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ22034",
    "droptype": "D",
    "dropname": "MONTALVO",
    "dropdeladd": "2481 GRAND AVE",
    "dropdelcty": "VENTURA",
    "dropdelst": "CA",
    "dropdelzpp": 930036600,
    "dropphyadd": "2481 GRAND AVE",
    "dropphycty": "VENTURA",
    "dropphyst": "CA",
    "dropphyzpp": 930036600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENTURA",
    "dropmalst": "CA",
    "dropmalzpp": 930059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056428887,
    "dropsitcph": 8056433057,
    "dropfax": 8056432831
  },
  {
    "dcode": "D",
    "dropkey": "BZ22044",
    "droptype": "D",
    "dropname": "MONTECITO",
    "dropdeladd": "1470 E VALLEY RD STE H",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931081297,
    "dropphyadd": "1470 E VALLEY RD STE H",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931081297,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931509998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059694939,
    "dropsitcph": 8058991792,
    "dropfax": 8055642255
  },
  {
    "dcode": "D",
    "dropkey": "BZ22077",
    "droptype": "D",
    "dropname": "MOUNT EDEN",
    "dropdeladd": "2163 ALDENGATE WAY",
    "dropdelcty": "HAYWARD",
    "dropdelst": "CA",
    "dropdelzpp": 945459998,
    "dropphyadd": "2163 ALDENGATE WAY",
    "dropphycty": "HAYWARD",
    "dropphyst": "CA",
    "dropphyzpp": 945459998,
    "dropmaladd": "2163 ALDENGATE WAY",
    "dropmalcty": "HAYWARD",
    "dropmalst": "CA",
    "dropmalzpp": 945459998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107825570,
    "dropsitcph": 5107825636,
    "dropfax": 5107830460
  },
  {
    "dcode": "D",
    "dropkey": "BZ22157",
    "droptype": "D",
    "dropname": "NEWHALL",
    "dropdeladd": "24201 THE OLD RD",
    "dropdelcty": "NEWHALL",
    "dropdelst": "CA",
    "dropdelzpp": 913219998,
    "dropphyadd": "24201 THE OLD RD",
    "dropphycty": "NEWHALL",
    "dropphyst": "CA",
    "dropphyzpp": 913219998,
    "dropmaladd": "24201 THE OLD RD",
    "dropmalcty": "NEWHALL",
    "dropmalst": "CA",
    "dropmalzpp": 913219998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612530771,
    "dropsitcph": 6612530771,
    "dropfax": 6612539487
  },
  {
    "dcode": "D",
    "dropkey": "BZ22330",
    "droptype": "D",
    "dropname": "OLYMPIC VALLEY",
    "dropdeladd": "1600 OLYMPIC VALLEY RD",
    "dropdelcty": "OLYMPIC VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 961469995,
    "dropphyadd": "1600 OLYMPIC VALLEY RD",
    "dropphycty": "OLYMPIC VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 961469995,
    "dropmaladd": "1600 OLYMPIC VALLEY RD",
    "dropmalcty": "OLYMPIC VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 961469995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5305835126,
    "dropfax": 5305836826
  },
  {
    "dcode": "D",
    "dropkey": "BZ22345",
    "droptype": "D",
    "dropname": "ORCUTT",
    "dropdeladd": "155 S 1ST ST",
    "dropdelcty": "SANTA MARIA",
    "dropdelst": "CA",
    "dropdelzpp": 934555298,
    "dropphyadd": "155 S 1ST ST",
    "dropphycty": "SANTA MARIA",
    "dropphyst": "CA",
    "dropphyzpp": 934555298,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA MARIA",
    "dropmalst": "CA",
    "dropmalzpp": 934579998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059372084,
    "dropsitcph": 8059372084,
    "dropfax": 8059282451
  },
  {
    "dcode": "D",
    "dropkey": "BZ22364",
    "droptype": "D",
    "dropname": "PACHECO",
    "dropdeladd": "4980 PACHECO BLVD",
    "dropdelcty": "MARTINEZ",
    "dropdelst": "CA",
    "dropdelzpp": 945539992,
    "dropphyadd": "4980 PACHECO BLVD",
    "dropphycty": "MARTINEZ",
    "dropphyst": "CA",
    "dropphyzpp": 945539992,
    "dropmaladd": "4980 PACHECO BLVD",
    "dropmalcty": "MARTINEZ",
    "dropmalst": "CA",
    "dropmalzpp": 945539992,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252289875,
    "dropsitcph": 9252282722,
    "dropfax": 9258748544
  },
  {
    "dcode": "D",
    "dropkey": "BZ22402",
    "droptype": "D",
    "dropname": "PALOS VERDES ESTATES",
    "dropdeladd": "2516 VIA TEJON STE 102",
    "dropdelcty": "PALOS VERDES ESTATES",
    "dropdelst": "CA",
    "dropdelzpp": 902749993,
    "dropphyadd": "2516 VIA TEJON STE 102",
    "dropphycty": "PALOS VERDES ESTATES",
    "dropphyst": "CA",
    "dropphyzpp": 902749993,
    "dropmaladd": "2516 VIA TEJON STE 102",
    "dropmalcty": "PALOS VERDES ESTATES",
    "dropmalst": "CA",
    "dropmalzpp": 902749993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103780416,
    "dropsitcph": 3105410624,
    "dropfax": 3103772805
  },
  {
    "dcode": "D",
    "dropkey": "BZ22408",
    "droptype": "D",
    "dropname": "PANORAMA CITY",
    "dropdeladd": "14416 CHASE ST",
    "dropdelcty": "PANORAMA CITY",
    "dropdelst": "CA",
    "dropdelzpp": 914029998,
    "dropphyadd": "14416 CHASE ST",
    "dropphycty": "PANORAMA CITY",
    "dropphyst": "CA",
    "dropphyzpp": 914029998,
    "dropmaladd": "14416 CHASE ST",
    "dropmalcty": "PANORAMA CITY",
    "dropmalst": "CA",
    "dropmalzpp": 914029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188915065,
    "dropsitcph": 8188915065,
    "dropfax": 8188953835
  },
  {
    "dcode": "D",
    "dropkey": "BZ22447",
    "droptype": "D",
    "dropname": "PENN VALLEY",
    "dropdeladd": "17612 PENN VALLEY DR",
    "dropdelcty": "PENN VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959469900,
    "dropphyadd": "17612 PENN VALLEY DR",
    "dropphycty": "PENN VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959469900,
    "dropmaladd": "17612 PENN VALLEY DR",
    "dropmalcty": "PENN VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959469900,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304327422,
    "dropsitcph": 5304327420,
    "dropfax": 5304327423
  },
  {
    "dcode": "D",
    "dropkey": "BZ22470",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "195 41ST ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946119991,
    "dropphyadd": "195 41ST ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946119991,
    "dropmaladd": "195 41ST ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946119991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513393,
    "dropsitcph": 5102513392,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "BZ22488",
    "droptype": "D",
    "dropname": "PINEDALE",
    "dropdeladd": "34 W MINARETS AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 936509998,
    "dropphyadd": "34 W MINARETS AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 936509998,
    "dropmaladd": "34 W MINARETS AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 936509998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594390944,
    "dropsitcph": 5594390944,
    "dropfax": 5594391415
  },
  {
    "dcode": "D",
    "dropkey": "BZ22512",
    "droptype": "D",
    "dropname": "PLAYA DEL REY",
    "dropdeladd": "215 CULVER BLVD",
    "dropdelcty": "PLAYA DEL REY",
    "dropdelst": "CA",
    "dropdelzpp": 902939998,
    "dropphyadd": "215 CULVER BLVD",
    "dropphycty": "PLAYA DEL REY",
    "dropphyst": "CA",
    "dropphyzpp": 902939998,
    "dropmaladd": "215 CULVER BLVD",
    "dropmalcty": "PLAYA DEL REY",
    "dropmalst": "CA",
    "dropmalzpp": 902939998,
    "dropsitphn": 3103144024,
    "dropsitlph": 3108230357,
    "dropsitcph": 3108231206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ22520",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "1945 CONTRA COSTA BLVD",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "CA",
    "dropdelzpp": 945239991,
    "dropphyadd": "1945 CONTRA COSTA BLVD",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "CA",
    "dropphyzpp": 945239991,
    "dropmaladd": "1945 CONTRA COSTA BLVD",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "CA",
    "dropmalzpp": 945239991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256098063,
    "dropsitcph": 9256870533,
    "dropfax": 9258748544
  },
  {
    "dcode": "D",
    "dropkey": "BZ22575",
    "droptype": "D",
    "dropname": "PROJECT CITY",
    "dropdeladd": "1985 CASCADE BLVD",
    "dropdelcty": "SHASTA LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 960199007,
    "dropphyadd": "1985 CASCADE BLVD",
    "dropphycty": "SHASTA LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 960199007,
    "dropmaladd": "1985 CASCADE BLVD",
    "dropmalcty": "SHASTA LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 960199007,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302759317,
    "dropsitcph": 5302759317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ22621",
    "droptype": "D",
    "dropname": "RANCHO SANTA MARGARITA",
    "dropdeladd": "29862 AVENIDA DE LAS BANDERA",
    "dropdelcty": "RANCHO SANTA MARGARITA",
    "dropdelst": "CA",
    "dropdelzpp": 926889998,
    "dropphyadd": "29862 AVENIDA DE LAS BANDERA",
    "dropphycty": "RANCHO SANTA MARGARITA",
    "dropphyst": "CA",
    "dropphyzpp": 926889998,
    "dropmaladd": "29862 AVENIDA DE LAS BANDERA",
    "dropmalcty": "RANCHO SANTA MARGARITA",
    "dropmalst": "CA",
    "dropmalzpp": 926889998,
    "dropsitphn": 9498881533,
    "dropsitlph": 9498889504,
    "dropsitcph": 9498881533,
    "dropfax": 9498888479
  },
  {
    "dcode": "D",
    "dropkey": "BZ22704",
    "droptype": "D",
    "dropname": "ROHNERT PARK",
    "dropdeladd": "150 RALEYS TOWNE CTR",
    "dropdelcty": "ROHNERT PARK",
    "dropdelst": "CA",
    "dropdelzpp": 949282477,
    "dropphyadd": "150 RALEYS TOWNE CTR",
    "dropphycty": "ROHNERT PARK",
    "dropphyst": "CA",
    "dropphyzpp": 949282477,
    "dropmaladd": "150 RALEYS TOWNE CTR",
    "dropmalcty": "ROHNERT PARK",
    "dropmalst": "CA",
    "dropmalzpp": 949282477,
    "dropsitphn": 7077785312,
    "dropsitlph": 7075865414,
    "dropsitcph": 7075865412,
    "dropfax": 7075859168
  },
  {
    "dcode": "D",
    "dropkey": "BZ22712",
    "droptype": "D",
    "dropname": "ROMOLAND",
    "dropdeladd": "28480 US HIGHWAY 74 STE C",
    "dropdelcty": "MENIFEE",
    "dropdelst": "CA",
    "dropdelzpp": 925859998,
    "dropphyadd": "28480 US HIGHWAY 74 STE C",
    "dropphycty": "MENIFEE",
    "dropphyst": "CA",
    "dropphyzpp": 925859998,
    "dropmaladd": "28480 US HIGHWAY 74 STE C",
    "dropmalcty": "MENIFEE",
    "dropmalst": "CA",
    "dropmalzpp": 925859998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9099283716,
    "dropsitcph": 9099283716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ22729",
    "droptype": "D",
    "dropname": "ROWLAND HEIGHTS",
    "dropdeladd": "1521 NOGALES ST",
    "dropdelcty": "ROWLAND HEIGHTS",
    "dropdelst": "CA",
    "dropdelzpp": 917489998,
    "dropphyadd": "1521 NOGALES ST",
    "dropphycty": "ROWLAND HEIGHTS",
    "dropphyst": "CA",
    "dropphyzpp": 917489998,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479998,
    "dropsitphn": 6263695301,
    "dropsitlph": 6269649439,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": "BZ22748",
    "droptype": "D",
    "dropname": "AIRPORT MAIL CENTER",
    "dropdeladd": "660 W FIELD RD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941283163,
    "dropphyadd": "660 W FIELD RD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941283163,
    "dropmaladd": "660 W FIELD RD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941283163,
    "dropsitphn": 4155505045,
    "dropsitlph": 6508227157,
    "dropsitcph": 4158227157,
    "dropfax": 6508081466
  },
  {
    "dcode": "D",
    "dropkey": "BZ22832",
    "droptype": "D",
    "dropname": "SAN MARINO",
    "dropdeladd": "2960 HUNTINGTON DR",
    "dropdelcty": "SAN MARINO",
    "dropdelst": "CA",
    "dropdelzpp": 911089998,
    "dropphyadd": "2960 HUNTINGTON DR",
    "dropphycty": "SAN MARINO",
    "dropphyst": "CA",
    "dropphyzpp": 911089998,
    "dropmaladd": "2960 HUNTINGTON DR",
    "dropmalcty": "SAN MARINO",
    "dropmalst": "CA",
    "dropmalzpp": 911089998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6262856815,
    "dropsitcph": 6262859532,
    "dropfax": 6264324407
  },
  {
    "dcode": "D",
    "dropkey": "BZ22836",
    "droptype": "D",
    "dropname": "SAN PABLO",
    "dropdeladd": "2080 23RD ST",
    "dropdelcty": "SAN PABLO",
    "dropdelst": "CA",
    "dropdelzpp": 948069991,
    "dropphyadd": "2080 23RD ST",
    "dropphycty": "SAN PABLO",
    "dropphyst": "CA",
    "dropphyzpp": 948063667,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948029998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102325274,
    "dropsitcph": 5102234654,
    "dropfax": 5102377905
  },
  {
    "dcode": "D",
    "dropkey": "BZ22844",
    "droptype": "D",
    "dropname": "SAN YSIDRO",
    "dropdeladd": "440 W SAN YSIDRO BLVD",
    "dropdelcty": "SAN YSIDRO",
    "dropdelst": "CA",
    "dropdelzpp": 921739998,
    "dropphyadd": "440 W SAN YSIDRO BLVD",
    "dropphycty": "SAN YSIDRO",
    "dropphyst": "CA",
    "dropphyzpp": 921739998,
    "dropmaladd": "440 W SAN YSIDRO BLVD",
    "dropmalcty": "SAN YSIDRO",
    "dropmalst": "CA",
    "dropmalzpp": 921739998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194282075,
    "dropsitcph": 6194282387,
    "dropfax": 6194286854
  },
  {
    "dcode": "D",
    "dropkey": "BZ22899",
    "droptype": "D",
    "dropname": "SCOTTS VALLEY",
    "dropdeladd": "241 KINGS VILLAGE RD",
    "dropdelcty": "SCOTTS VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 950669998,
    "dropphyadd": "241 KINGS VILLAGE RD",
    "dropphycty": "SCOTTS VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 950669998,
    "dropmaladd": "241 KINGS VILLAGE RD",
    "dropmalcty": "SCOTTS VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 950669998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314385801,
    "dropsitcph": 8314385801,
    "dropfax": 8314384936
  },
  {
    "dcode": "D",
    "dropkey": "BZ22948",
    "droptype": "D",
    "dropname": "SHERMAN OAKS",
    "dropdeladd": "14900 MAGNOLIA BLVD",
    "dropdelcty": "SHERMAN OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 914039998,
    "dropphyadd": "14900 MAGNOLIA BLVD",
    "dropphycty": "SHERMAN OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 914039998,
    "dropmaladd": "14900 MAGNOLIA BLVD",
    "dropmalcty": "SHERMAN OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 914039998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187848576,
    "dropsitcph": 8187848576,
    "dropfax": 8187848097
  },
  {
    "dcode": "D",
    "dropkey": "BZ22955",
    "droptype": "D",
    "dropname": "BAY POINT",
    "dropdeladd": "646 PORT CHICAGO HWY",
    "dropdelcty": "BAY POINT",
    "dropdelst": "CA",
    "dropdelzpp": 945659991,
    "dropphyadd": "646 PORT CHICAGO HWY",
    "dropphycty": "BAY POINT",
    "dropphyst": "CA",
    "dropphyzpp": 945659991,
    "dropmaladd": "646 PORT CHICAGO HWY",
    "dropmalcty": "BAY POINT",
    "dropmalst": "CA",
    "dropmalzpp": 945659991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254324079,
    "dropsitcph": 9254322741,
    "dropfax": 9254329643
  },
  {
    "dcode": "D",
    "dropkey": "BZ23053",
    "droptype": "D",
    "dropname": "SOUTH EL MONTE",
    "dropdeladd": "10452 RUSH ST",
    "dropdelcty": "SOUTH EL MONTE",
    "dropdelst": "CA",
    "dropdelzpp": 917339998,
    "dropphyadd": "10452 RUSH ST",
    "dropphycty": "SOUTH EL MONTE",
    "dropphyst": "CA",
    "dropphyzpp": 917339998,
    "dropmaladd": "11151 VALLEY BLVD",
    "dropmalcty": "EL MONTE",
    "dropmalst": "CA",
    "dropmalzpp": 917349998,
    "dropsitphn": 6264430704,
    "dropsitlph": 6264441966,
    "dropsitcph": 6264430704,
    "dropfax": 6264438157
  },
  {
    "dcode": "D",
    "dropkey": "BZ23057",
    "droptype": "D",
    "dropname": "SOUTH LAGUNA",
    "dropdeladd": "31677 VIRGINIA WAY",
    "dropdelcty": "LAGUNA BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926529998,
    "dropphyadd": "31677 VIRGINIA WAY",
    "dropphycty": "LAGUNA BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926529998,
    "dropmaladd": "29911 NIGUEL RD",
    "dropmalcty": "LAGUNA NIGUEL",
    "dropmalst": "CA",
    "dropmalzpp": 926079998,
    "dropsitphn": 9493628306,
    "dropsitlph": 9494991643,
    "dropsitcph": 9493628306,
    "dropfax": 9494993587
  },
  {
    "dcode": "D",
    "dropkey": "BZ23081",
    "droptype": "D",
    "dropname": "SPRECKELS",
    "dropdeladd": "40 SPRECKELS BLVD",
    "dropdelcty": "SALINAS",
    "dropdelst": "CA",
    "dropdelzpp": 939089800,
    "dropphyadd": "40 SPRECKELS BLVD",
    "dropphycty": "SALINAS",
    "dropphyst": "CA",
    "dropphyzpp": 939089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRECKELS",
    "dropmalst": "CA",
    "dropmalzpp": 939629998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314559613,
    "dropsitcph": 8314559613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23086",
    "droptype": "D",
    "dropname": "SPRING VALLEY LAKE",
    "dropdeladd": "13295 SPRING VALLEY PKWY",
    "dropdelcty": "VICTORVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 923959997,
    "dropphyadd": "13295 SPRING VALLEY PKWY",
    "dropphycty": "VICTORVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 923959997,
    "dropmaladd": "16333 GREEN TREE BLVD",
    "dropmalcty": "VICTORVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 923956500,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602414433,
    "dropsitcph": 7602414433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23379",
    "droptype": "D",
    "dropname": "STANDARD",
    "dropdeladd": "14665 MONO WAY",
    "dropdelcty": "STANDARD",
    "dropdelst": "CA",
    "dropdelzpp": 953739998,
    "dropphyadd": "14665 MONO WAY",
    "dropphycty": "STANDARD",
    "dropphyst": "CA",
    "dropphyzpp": 953739998,
    "dropmaladd": "14665 MONO WAY",
    "dropmalcty": "STANDARD",
    "dropmalst": "CA",
    "dropmalzpp": 953739998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095334219,
    "dropsitcph": 2095338354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23382",
    "droptype": "D",
    "dropname": "STANFORD",
    "dropdeladd": "531 LASUEN MALL",
    "dropdelcty": "STANFORD",
    "dropdelst": "CA",
    "dropdelzpp": 943059991,
    "dropphyadd": "531 LASUEN MALL",
    "dropphycty": "STANFORD",
    "dropphyst": "CA",
    "dropphyzpp": 943059991,
    "dropmaladd": "531 LASUEN MALL",
    "dropmalcty": "STANFORD",
    "dropmalst": "CA",
    "dropmalzpp": 943059991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503213193,
    "dropsitcph": 6503211423,
    "dropfax": 6503220476
  },
  {
    "dcode": "D",
    "dropkey": "BZ23471",
    "droptype": "D",
    "dropname": "STUDIO CITY",
    "dropdeladd": "3950 LAUREL CANYON BLVD",
    "dropdelcty": "STUDIO CITY",
    "dropdelst": "CA",
    "dropdelzpp": 916049998,
    "dropphyadd": "3950 LAUREL CANYON BLVD",
    "dropphycty": "STUDIO CITY",
    "dropphyst": "CA",
    "dropphyzpp": 916049998,
    "dropmaladd": "3950 LAUREL CANYON BLVD",
    "dropmalcty": "STUDIO CITY",
    "dropmalst": "CA",
    "dropmalzpp": 916049998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187614906,
    "dropsitcph": 8187611286,
    "dropfax": 7472055503
  },
  {
    "dcode": "D",
    "dropkey": "BZ23515",
    "droptype": "D",
    "dropname": "SYLMAR",
    "dropdeladd": "13700 FOOTHILL BLVD",
    "dropdelcty": "SYLMAR",
    "dropdelst": "CA",
    "dropdelzpp": 913429998,
    "dropphyadd": "13700 FOOTHILL BLVD",
    "dropphycty": "SYLMAR",
    "dropphyst": "CA",
    "dropphyzpp": 913429998,
    "dropmaladd": "13700 FOOTHILL BLVD",
    "dropmalcty": "SYLMAR",
    "dropmalst": "CA",
    "dropmalzpp": 913429998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183640286,
    "dropsitcph": 8183640286,
    "dropfax": 8183642304
  },
  {
    "dcode": "D",
    "dropkey": "BZ23527",
    "droptype": "D",
    "dropname": "TAHOMA",
    "dropdeladd": "7000 WESTLAKE BLVD",
    "dropdelcty": "TAHOMA",
    "dropdelst": "CA",
    "dropdelzpp": 961429800,
    "dropphyadd": "7000 WESTLAKE BLVD",
    "dropphycty": "TAHOMA",
    "dropphyst": "CA",
    "dropphyzpp": 961429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAHOMA",
    "dropmalst": "CA",
    "dropmalzpp": 961429998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7027880663,
    "dropsitcph": 5305256695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23586",
    "droptype": "D",
    "dropname": "TOLUCA LAKE",
    "dropdeladd": "10063 RIVERSIDE DR",
    "dropdelcty": "TOLUCA LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 916029998,
    "dropphyadd": "10063 RIVERSIDE DR",
    "dropphycty": "TOLUCA LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 916029998,
    "dropmaladd": "10063 RIVERSIDE DR",
    "dropmalcty": "TOLUCA LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 916029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187612551,
    "dropsitcph": 8185063651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23611",
    "droptype": "D",
    "dropname": "TRAVIS AFB",
    "dropdeladd": "465 SKYMASTER CIR",
    "dropdelcty": "TRAVIS AFB",
    "dropdelst": "CA",
    "dropdelzpp": 945359991,
    "dropphyadd": "465 SKYMASTER CIR",
    "dropphycty": "TRAVIS AFB",
    "dropphyst": "CA",
    "dropphyzpp": 945359991,
    "dropmaladd": "465 SKYMASTER CIR",
    "dropmalcty": "TRAVIS AFB",
    "dropmalst": "CA",
    "dropmalzpp": 945359991,
    "dropsitphn": 7074257325,
    "dropsitlph": 7074257325,
    "dropsitcph": 7074372889,
    "dropfax": 7074258459
  },
  {
    "dcode": "D",
    "dropkey": "BZ23639",
    "droptype": "D",
    "dropname": "TWENTYNINE PALMS MCB",
    "dropdeladd": "1435 STURGIS ST BLDG 1435",
    "dropdelcty": "TWENTYNINE PALMS",
    "dropdelst": "CA",
    "dropdelzpp": 922789800,
    "dropphyadd": "1435 STURGIS ST BLDG 1435",
    "dropphycty": "TWENTYNINE PALMS",
    "dropphyst": "CA",
    "dropphyzpp": 922789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWENTYNINE PALMS",
    "dropmalst": "CA",
    "dropmalzpp": 922789998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603683231,
    "dropsitcph": 7608306640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23690",
    "droptype": "D",
    "dropname": "VALENCIA",
    "dropdeladd": "25842 1/2 TOURNAMENT RD",
    "dropdelcty": "VALENCIA",
    "dropdelst": "CA",
    "dropdelzpp": 913552323,
    "dropphyadd": "25842 1/2 TOURNAMENT RD",
    "dropphycty": "VALENCIA",
    "dropphyst": "CA",
    "dropphyzpp": 913552323,
    "dropmaladd": "25842 1/2 TOURNAMENT RD",
    "dropmalcty": "VALENCIA",
    "dropmalst": "CA",
    "dropmalzpp": 913552323,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612551891,
    "dropsitcph": 6612543270,
    "dropfax": 6612547318
  },
  {
    "dcode": "D",
    "dropkey": "BZ23704",
    "droptype": "D",
    "dropname": "VALLEY VILLAGE",
    "dropdeladd": "12450 MAGNOLIA BLVD",
    "dropdelcty": "VALLEY VILLAGE",
    "dropdelst": "CA",
    "dropdelzpp": 916079998,
    "dropphyadd": "12450 MAGNOLIA BLVD",
    "dropphycty": "VALLEY VILLAGE",
    "dropphyst": "CA",
    "dropphyzpp": 916079998,
    "dropmaladd": "12450 MAGNOLIA BLVD",
    "dropmalcty": "VALLEY VILLAGE",
    "dropmalst": "CA",
    "dropmalzpp": 916079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187623958,
    "dropsitcph": 8185030979,
    "dropfax": 7472055527
  },
  {
    "dcode": "D",
    "dropkey": "BZ23721",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "5121 HAMPTON ST",
    "dropdelcty": "VERNON",
    "dropdelst": "CA",
    "dropdelzpp": 900589998,
    "dropphyadd": "5121 HAMPTON ST",
    "dropphycty": "VERNON",
    "dropphyst": "CA",
    "dropphyzpp": 900589998,
    "dropmaladd": "5121 HAMPTON ST",
    "dropmalcty": "VERNON",
    "dropmalst": "CA",
    "dropmalzpp": 900589998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3235837509,
    "dropsitcph": 3235835093,
    "dropfax": 3235890666
  },
  {
    "dcode": "D",
    "dropkey": "BZ23822",
    "droptype": "D",
    "dropname": "WEST HILLS",
    "dropdeladd": "23055 SHERMAN WAY",
    "dropdelcty": "WEST HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 913079998,
    "dropphyadd": "23055 SHERMAN WAY",
    "dropphycty": "WEST HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 913079998,
    "dropmaladd": "23055 SHERMAN WAY",
    "dropmalcty": "WEST HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 913079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187041472,
    "dropsitcph": 8187041472,
    "dropfax": 8187045647
  },
  {
    "dcode": "D",
    "dropkey": "BZ23828",
    "droptype": "D",
    "dropname": "WEST MENLO PARK",
    "dropdeladd": "2120 AVY AVE",
    "dropdelcty": "MENLO PARK",
    "dropdelst": "CA",
    "dropdelzpp": 940259992,
    "dropphyadd": "2120 AVY AVE",
    "dropphycty": "MENLO PARK",
    "dropphyst": "CA",
    "dropphyzpp": 940259992,
    "dropmaladd": "2120 AVY AVE",
    "dropmalcty": "MENLO PARK",
    "dropmalst": "CA",
    "dropmalzpp": 940259992,
    "dropsitphn": 4155505045,
    "dropsitlph": 6508548682,
    "dropsitcph": 6502725199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ23903",
    "droptype": "D",
    "dropname": "WINNETKA",
    "dropdeladd": "7655 WINNETKA AVE",
    "dropdelcty": "WINNETKA",
    "dropdelst": "CA",
    "dropdelzpp": 913069998,
    "dropphyadd": "7655 WINNETKA AVE",
    "dropphycty": "WINNETKA",
    "dropphyst": "CA",
    "dropphyzpp": 913069998,
    "dropmaladd": "7655 WINNETKA AVE",
    "dropmalcty": "WINNETKA",
    "dropmalst": "CA",
    "dropmalzpp": 913069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187730132,
    "dropsitcph": 8187730028,
    "dropfax": 7472355033
  },
  {
    "dcode": "D",
    "dropkey": "BZ23922",
    "droptype": "D",
    "dropname": "WOODSIDE",
    "dropdeladd": "2995 WOODSIDE RD STE 200",
    "dropdelcty": "WOODSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 940629991,
    "dropphyadd": "2995 WOODSIDE RD STE 200",
    "dropphycty": "WOODSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 940629991,
    "dropmaladd": "2995 WOODSIDE RD STE 200",
    "dropmalcty": "WOODSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 940629991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6508519452,
    "dropsitcph": 6503684163,
    "dropfax": 6508519579
  },
  {
    "dcode": "D",
    "dropkey": "BZ24100",
    "droptype": "D",
    "dropname": "MIDWAY CITY",
    "dropdeladd": "15041 JACKSON ST",
    "dropdelcty": "MIDWAY CITY",
    "dropdelst": "CA",
    "dropdelzpp": 926553400,
    "dropphyadd": "15041 JACKSON ST",
    "dropphycty": "MIDWAY CITY",
    "dropphyst": "CA",
    "dropphyzpp": 926553400,
    "dropmaladd": "15030 GOLDENWEST CIR",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CA",
    "dropmalzpp": 926859998,
    "dropsitphn": 7148923232,
    "dropsitlph": 7149038659,
    "dropsitcph": 7148923232,
    "dropfax": 7143734329
  },
  {
    "dcode": "D",
    "dropkey": "BZ24217",
    "droptype": "D",
    "dropname": "SUMMIT CITY",
    "dropdeladd": "13701 HILL BLVD",
    "dropdelcty": "SHASTA LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 960899998,
    "dropphyadd": "13701 HILL BLVD",
    "dropphycty": "SHASTA LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 960899998,
    "dropmaladd": "13701 HILL BLVD",
    "dropmalcty": "SHASTA LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 960899998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302759574,
    "dropsitcph": 5302759574,
    "dropfax": 5302751843
  },
  {
    "dcode": "D",
    "dropkey": "BZ24333",
    "droptype": "D",
    "dropname": "SAN LUIS REY",
    "dropdeladd": "3774 MISSION AVE",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 920589996,
    "dropphyadd": "3774 MISSION AVE",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 920589996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN LUIS REY",
    "dropmalst": "CA",
    "dropmalzpp": 920689998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7609669134,
    "dropsitcph": 7608063866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ24375",
    "droptype": "D",
    "dropname": "PALA",
    "dropdeladd": "3000 E PALA MSN",
    "dropdelcty": "PALA",
    "dropdelst": "CA",
    "dropdelzpp": 920593200,
    "dropphyadd": "3000 E PALA MSN",
    "dropphycty": "PALA",
    "dropphyst": "CA",
    "dropphyzpp": 920593200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALA",
    "dropmalst": "CA",
    "dropmalzpp": 920599998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607421358,
    "dropsitcph": 7607421358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "BZ24670",
    "droptype": "D",
    "dropname": "BRODERICK",
    "dropdeladd": "900 SACRAMENTO AVE",
    "dropdelcty": "WEST SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 956059998,
    "dropphyadd": "900 SACRAMENTO AVE",
    "dropphycty": "WEST SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 956059998,
    "dropmaladd": "1601 MERKLEY AVE",
    "dropmalcty": "WEST SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 956919998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165563412,
    "dropsitcph": 9165563406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000024",
    "droptype": "D",
    "dropname": "MELROSE VISTA",
    "dropdeladd": "3901 W BROWARD BLVD",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333129998,
    "dropphyadd": "3901 W BROWARD BLVD",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333129998,
    "dropmaladd": "3901 W BROWARD BLVD",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333129998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9543168052,
    "dropsitcph": 9543168052,
    "dropfax": 9543169342
  },
  {
    "dcode": "D",
    "dropkey": "B000092",
    "droptype": "D",
    "dropname": "COUNTRY LAKES",
    "dropdeladd": "13520 SW 152ND ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331779998,
    "dropphyadd": "13520 SW 152ND ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331779998,
    "dropmaladd": "13520 SW 152ND ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331779998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3059696110,
    "dropsitcph": 3059712427,
    "dropfax": 3059696193
  },
  {
    "dcode": "D",
    "dropkey": "B000188",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE POSTAL STORE",
    "dropdeladd": "5423 SHERIDAN DR",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142213609,
    "dropphyadd": "5423 SHERIDAN DR",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142213609,
    "dropmaladd": "5423 SHERIDAN DR",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142213609,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166320421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000210",
    "droptype": "D",
    "dropname": "AVENTURA",
    "dropdeladd": "3585 NE 207TH ST STE C9",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331809997,
    "dropphyadd": "3585 NE 207TH ST STE C9",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331809997,
    "dropmaladd": "3585 NE 207TH ST STE C9",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331809997,
    "dropsitphn": 3054700642,
    "dropsitlph": 3059317564,
    "dropsitcph": 3059317682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000227",
    "droptype": "D",
    "dropname": "NORTH LAKE TRAVIS",
    "dropdeladd": "8027 BRONCO LN",
    "dropdelcty": "LAGO VISTA",
    "dropdelst": "TX",
    "dropdelzpp": 786459998,
    "dropphyadd": "8027 BRONCO LN",
    "dropphycty": "LAGO VISTA",
    "dropphyst": "TX",
    "dropphyzpp": 786459998,
    "dropmaladd": "8027 BRONCO LN",
    "dropmalcty": "LAGO VISTA",
    "dropmalst": "TX",
    "dropmalzpp": 786459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122671848,
    "dropsitcph": 5122671637,
    "dropfax": 5122672114
  },
  {
    "dcode": "D",
    "dropkey": "B000257",
    "droptype": "D",
    "dropname": "NW SAINT JOHNS",
    "dropdeladd": "112 BARTRAM OAKS WALK STE 104",
    "dropdelcty": "SAINT JOHNS",
    "dropdelst": "FL",
    "dropdelzpp": 322593268,
    "dropphyadd": "112 BARTRAM OAKS WALK STE 104",
    "dropphycty": "SAINT JOHNS",
    "dropphyst": "FL",
    "dropphyzpp": 322593268,
    "dropmaladd": "112 BARTRAM OAKS WALK STE 104",
    "dropmalcty": "SAINT JOHNS",
    "dropmalst": "FL",
    "dropmalzpp": 322593268,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042303473,
    "dropsitcph": 9042303473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000269",
    "droptype": "D",
    "dropname": "BETHLEHEM AIRPORT",
    "dropdeladd": "1000 POSTAL RD REAR",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 181098901,
    "dropphyadd": "1000 POSTAL RD REAR",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 181098901,
    "dropmaladd": "1000 POSTAL RD REAR",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 181098901,
    "dropsitphn": 6102663162,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102663162,
    "dropfax": 6102663166
  },
  {
    "dcode": "D",
    "dropkey": "B000293",
    "droptype": "D",
    "dropname": "JAMESBURG",
    "dropdeladd": "13 E RAILROAD AVE",
    "dropdelcty": "JAMESBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "088319997",
    "dropphyadd": "13 E RAILROAD AVE",
    "dropphycty": "JAMESBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "088319997",
    "dropmaladd": "13 E RAILROAD AVE",
    "dropmalcty": "JAMESBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "088319997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325210403,
    "dropfax": 7325211653
  },
  {
    "dcode": "D",
    "dropkey": "B000296",
    "droptype": "D",
    "dropname": "MIRAMAR BEACH",
    "dropdeladd": "322 MIRAMAR BEACH DR",
    "dropdelcty": "MIRAMAR BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 325508033,
    "dropphyadd": "322 MIRAMAR BEACH DR",
    "dropphycty": "MIRAMAR BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 325508033,
    "dropmaladd": "322 MIRAMAR BEACH DR",
    "dropmalcty": "MIRAMAR BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 325508033,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502691187,
    "dropsitcph": 8502691186,
    "dropfax": 8508371850
  },
  {
    "dcode": "D",
    "dropkey": "B000304",
    "droptype": "D",
    "dropname": "GOLDEN ISLES",
    "dropdeladd": "1800 E HALLANDALE BEACH BLVD",
    "dropdelcty": "HALLANDALE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330094737,
    "dropphyadd": "1800 E HALLANDALE BEACH BLVD",
    "dropphycty": "HALLANDALE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330094737,
    "dropmaladd": "1800 E HALLANDALE BEACH BLVD",
    "dropmalcty": "HALLANDALE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330094737,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544553365,
    "dropsitcph": 9544550493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000308",
    "droptype": "D",
    "dropname": "NEWTON CENTER",
    "dropdeladd": "716 BEACON ST",
    "dropdelcty": "NEWTON CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "024599997",
    "dropphyadd": "716 BEACON ST",
    "dropphycty": "NEWTON CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "024599997",
    "dropmaladd": "716 BEACON ST",
    "dropmalcty": "NEWTON CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "024599997",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175581399,
    "dropfax": 6179643685
  },
  {
    "dcode": "D",
    "dropkey": "B000313",
    "droptype": "D",
    "dropname": "COCONUT CREEK",
    "dropdeladd": "4233 W HILLSBORO BLVD",
    "dropdelcty": "COCONUT CREEK",
    "dropdelst": "FL",
    "dropdelzpp": 330739998,
    "dropphyadd": "4233 W HILLSBORO BLVD",
    "dropphycty": "COCONUT CREEK",
    "dropphyst": "FL",
    "dropphyzpp": 330739998,
    "dropmaladd": "4233 W HILLSBORO BLVD",
    "dropmalcty": "COCONUT CREEK",
    "dropmalst": "FL",
    "dropmalzpp": 330739998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544289860,
    "dropsitcph": 9544280139,
    "dropfax": 9544284772
  },
  {
    "dcode": "D",
    "dropkey": "B000348",
    "droptype": "D",
    "dropname": "INVER GROVE HEIGHTS",
    "dropdeladd": "6566 CAHILL AVE",
    "dropdelcty": "INVER GROVE HEIGHTS",
    "dropdelst": "MN",
    "dropdelzpp": 550762021,
    "dropphyadd": "6566 CAHILL AVE",
    "dropphycty": "INVER GROVE HEIGHTS",
    "dropphyst": "MN",
    "dropphyzpp": 550762021,
    "dropmaladd": "6566 CAHILL AVE",
    "dropmalcty": "INVER GROVE HEIGHTS",
    "dropmalst": "MN",
    "dropmalzpp": 550762021,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6514507548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B000394",
    "droptype": "D",
    "dropname": "TOWER",
    "dropdeladd": "18555 E SMOKY HILL RD",
    "dropdelcty": "CENTENNIAL",
    "dropdelst": "CO",
    "dropdelzpp": 800159998,
    "dropphyadd": "18555 E SMOKY HILL RD",
    "dropphycty": "CENTENNIAL",
    "dropphyst": "CO",
    "dropphyzpp": 800159998,
    "dropmaladd": "18555 E SMOKY HILL RD",
    "dropmalcty": "CENTENNIAL",
    "dropmalst": "CO",
    "dropmalzpp": 800159998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036998943,
    "dropsitcph": 3036998907,
    "dropfax": 3036995495
  },
  {
    "dcode": "D",
    "dropkey": "B000396",
    "droptype": "D",
    "dropname": "LAKE JACKSON BRANCH",
    "dropdeladd": "829 MALL RING RD",
    "dropdelcty": "SEBRING",
    "dropdelst": "FL",
    "dropdelzpp": 338708514,
    "dropphyadd": "829 MALL RING RD",
    "dropphycty": "SEBRING",
    "dropphyst": "FL",
    "dropphyzpp": 338708514,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "SEBRING",
    "dropmalst": "FL",
    "dropmalzpp": 338729997,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8633826138,
    "dropfax": 8633824181
  },
  {
    "dcode": "D",
    "dropkey": "B000414",
    "droptype": "D",
    "dropname": "SYMMES",
    "dropdeladd": "9370 FIELDS ERTEL RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452499998,
    "dropphyadd": "9370 FIELDS ERTEL RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452499998,
    "dropmaladd": "9370 FIELDS ERTEL RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138332572,
    "dropsitcph": 5138332572,
    "dropfax": 5136976548
  },
  {
    "dcode": "D",
    "dropkey": "B000736",
    "droptype": "D",
    "dropname": "CENTERVILLE BRANCH",
    "dropdeladd": "3375 CENTERVILLE HWY",
    "dropdelcty": "SNELLVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300399997,
    "dropphyadd": "3375 CENTERVILLE HWY",
    "dropphycty": "SNELLVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300399997,
    "dropmaladd": "3375 CENTERVILLE HWY",
    "dropmalcty": "SNELLVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300399997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702252271,
    "dropsitcph": 6783446248,
    "dropfax": 6783446925
  },
  {
    "dcode": "D",
    "dropkey": "B000842",
    "droptype": "D",
    "dropname": "KEN CARYL RANCH",
    "dropdeladd": "8200 SHAFFER PKWY",
    "dropdelcty": "LITTLETON",
    "dropdelst": "CO",
    "dropdelzpp": 801279997,
    "dropphyadd": "8200 SHAFFER PKWY",
    "dropphycty": "LITTLETON",
    "dropphyst": "CO",
    "dropphyzpp": 801279997,
    "dropmaladd": "8200 SHAFFER PKWY",
    "dropmalcty": "LITTLETON",
    "dropmalst": "CO",
    "dropmalzpp": 801279997,
    "dropsitphn": 3038536511,
    "dropsitlph": 7209220125,
    "dropsitcph": 7209220122,
    "dropfax": 7209220130
  },
  {
    "dcode": "D",
    "dropkey": "B000986",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE NORTH",
    "dropdeladd": "1557 BUFORD DR",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300439998,
    "dropphyadd": "1557 BUFORD DR",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300439998,
    "dropmaladd": "1557 BUFORD DR",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300439998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709955387,
    "dropsitcph": 6789853771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B001249",
    "droptype": "D",
    "dropname": "SOCASTEE",
    "dropdeladd": "7140 HIGHWAY 707",
    "dropdelcty": "MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295889998,
    "dropphyadd": "7140 HIGHWAY 707",
    "dropphycty": "MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295889998,
    "dropmaladd": "7140 HIGHWAY 707",
    "dropmalcty": "MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295889998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436509059,
    "dropsitcph": 8436509059,
    "dropfax": 8436509465
  },
  {
    "dcode": "D",
    "dropkey": "B001409",
    "droptype": "D",
    "dropname": "EVERGLADES BR",
    "dropdeladd": "6759 SW 196TH AVE",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333329998,
    "dropphyadd": "6759 SW 196TH AVE",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333329998,
    "dropmaladd": "6759 SW 196TH AVE",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333329998,
    "dropsitphn": 3055132368,
    "dropsitlph": "",
    "dropsitcph": 9544348517,
    "dropfax": 9542330624
  },
  {
    "dcode": "D",
    "dropkey": "B001430",
    "droptype": "D",
    "dropname": "LAKE JACKSON",
    "dropdeladd": "3607 N MONROE ST",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323032747,
    "dropphyadd": "3607 N MONROE ST",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323032747,
    "dropmaladd": "3607 N MONROE ST",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323032747,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502542536,
    "dropsitcph": 8505621039,
    "dropfax": 8505620567
  },
  {
    "dcode": "D",
    "dropkey": "B001436",
    "droptype": "D",
    "dropname": "GREAT LAKES CROSSING",
    "dropdeladd": "3906 BALDWIN RD",
    "dropdelcty": "AUBURN HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483261287,
    "dropphyadd": "3906 BALDWIN RD",
    "dropphycty": "AUBURN HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483261287,
    "dropmaladd": "2960 AUBURN RD",
    "dropmalcty": "AUBURN HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483269998,
    "dropsitphn": 2484574034,
    "dropsitlph": 2487585622,
    "dropsitcph": 2484542402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B001448",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "2500 S LINDEN RD",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485329998,
    "dropphyadd": "2500 S LINDEN RD",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485329998,
    "dropmaladd": "2500 S LINDEN RD",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485329998,
    "dropsitphn": 8107322415,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107322415,
    "dropfax": 8107322436
  },
  {
    "dcode": "D",
    "dropkey": "B001542",
    "droptype": "D",
    "dropname": "POCOSHOCK CREEK",
    "dropdeladd": "7501 LADY BLAIR LN",
    "dropdelcty": "NORTH CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 232369998,
    "dropphyadd": "7501 LADY BLAIR LN",
    "dropphycty": "NORTH CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 232369998,
    "dropmaladd": "7501 LADY BLAIR LN",
    "dropmalcty": "NORTH CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 232369998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046759268,
    "dropsitcph": 8046754064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B001592",
    "droptype": "D",
    "dropname": "COVINGTON BRANCH",
    "dropdeladd": "17300 SE 270TH PL",
    "dropdelcty": "COVINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 980429998,
    "dropphyadd": "17300 SE 270TH PL",
    "dropphycty": "COVINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 980429998,
    "dropmaladd": "17300 SE 270TH PL",
    "dropmalcty": "COVINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 980429998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2536396954,
    "dropsitcph": 2536396833,
    "dropfax": 6514566161
  },
  {
    "dcode": "D",
    "dropkey": "B001671",
    "droptype": "D",
    "dropname": "EHRLICH",
    "dropdeladd": "14910 N DALE MABRY HWY",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336181814,
    "dropphyadd": "14910 N DALE MABRY HWY",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336181814,
    "dropmaladd": "PO BOX 349998",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336949998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139083478,
    "dropfax": 8139626109
  },
  {
    "dcode": "D",
    "dropkey": "B001754",
    "droptype": "D",
    "dropname": "FLOWOOD",
    "dropdeladd": "105 HOGG CREEK DR",
    "dropdelcty": "FLOWOOD",
    "dropdelst": "MS",
    "dropdelzpp": 392329998,
    "dropphyadd": "105 HOGG CREEK DR",
    "dropphycty": "FLOWOOD",
    "dropphyst": "MS",
    "dropphyzpp": 392329998,
    "dropmaladd": "105 HOGG CREEK DR",
    "dropmalcty": "FLOWOOD",
    "dropmalst": "MS",
    "dropmalzpp": 392329998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019392955,
    "dropsitcph": 6019392330,
    "dropfax": 6019394084
  },
  {
    "dcode": "D",
    "dropkey": "B001765",
    "droptype": "D",
    "dropname": "OCEAN PINES",
    "dropdeladd": "11115 LAKE VIEW LN",
    "dropdelcty": "BERLIN",
    "dropdelst": "MD",
    "dropdelzpp": 218113184,
    "dropphyadd": "11115 LAKE VIEW LN",
    "dropphycty": "BERLIN",
    "dropphyst": "MD",
    "dropphyzpp": 218113184,
    "dropmaladd": "11115 LAKE VIEW LN",
    "dropmalcty": "BERLIN",
    "dropmalst": "MD",
    "dropmalzpp": 218113184,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102083959,
    "dropsitcph": 4102083959,
    "dropfax": 4102084891
  },
  {
    "dcode": "D",
    "dropkey": "B001837",
    "droptype": "D",
    "dropname": "TOWNSHIP OF WASHINGTON",
    "dropdeladd": "261R PASCACK RD",
    "dropdelcty": "TOWNSHIP OF WASHINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "076769998",
    "dropphyadd": "261R PASCACK RD",
    "dropphycty": "TOWNSHIP OF WASHINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "076769998",
    "dropmaladd": "261R PASCACK RD",
    "dropmalcty": "TOWNSHIP OF WASHINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "076769998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016647314,
    "dropsitcph": 2016647314,
    "dropfax": 6505774197
  },
  {
    "dcode": "D",
    "dropkey": "B001843",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "867 W BLOOMINGDALE AVE",
    "dropdelcty": "BRANDON",
    "dropdelst": "FL",
    "dropdelzpp": 335117701,
    "dropphyadd": "867 W BLOOMINGDALE AVE",
    "dropphycty": "BRANDON",
    "dropphyst": "FL",
    "dropphyzpp": 335117701,
    "dropmaladd": "PO BOX 6000",
    "dropmalcty": "BRANDON",
    "dropmalst": "FL",
    "dropmalzpp": 335089998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136611503,
    "dropfax": 8136514364
  },
  {
    "dcode": "D",
    "dropkey": "B001870",
    "droptype": "D",
    "dropname": "YUMA FOOTHILLS",
    "dropdeladd": "11692 S FORTUNA RD",
    "dropdelcty": "YUMA",
    "dropdelst": "AZ",
    "dropdelzpp": 853679998,
    "dropphyadd": "11692 S FORTUNA RD",
    "dropphycty": "YUMA",
    "dropphyst": "AZ",
    "dropphyzpp": 853679998,
    "dropmaladd": "11692 S FORTUNA RD",
    "dropmalcty": "YUMA",
    "dropmalst": "AZ",
    "dropmalzpp": 853679998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283050193,
    "dropsitcph": 9283050187,
    "dropfax": 9283055154
  },
  {
    "dcode": "D",
    "dropkey": "B001875",
    "droptype": "D",
    "dropname": "EAST PARIS",
    "dropdeladd": "3970 S GREENBROOKE DR SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495125455,
    "dropphyadd": "3970 S GREENBROOKE DR SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495125455,
    "dropmaladd": "3970 S GREENBROOKE DR SE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495125455,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166565795,
    "dropsitcph": 6166565795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B001911",
    "droptype": "D",
    "dropname": "SURPRISE DYSART RETAIL",
    "dropdeladd": "16554 N DYSART RD",
    "dropdelcty": "SURPRISE",
    "dropdelst": "AZ",
    "dropdelzpp": 853783747,
    "dropphyadd": "16554 N DYSART RD",
    "dropphycty": "SURPRISE",
    "dropphyst": "AZ",
    "dropphyzpp": 853783747,
    "dropmaladd": "16554 N DYSART RD",
    "dropmalcty": "SURPRISE",
    "dropmalst": "AZ",
    "dropmalzpp": 853783747,
    "dropsitphn": 6235463653,
    "dropsitlph": 6235463652,
    "dropsitcph": 6235444672,
    "dropfax": 6235463617
  },
  {
    "dcode": "D",
    "dropkey": "B001958",
    "droptype": "D",
    "dropname": "HALFMOON",
    "dropdeladd": "2 PROGRESS DR",
    "dropdelcty": "HALFMOON",
    "dropdelst": "NY",
    "dropdelzpp": 120657829,
    "dropphyadd": "2 PROGRESS DR",
    "dropphycty": "HALFMOON",
    "dropphyst": "NY",
    "dropphyzpp": 120659211,
    "dropmaladd": "2 PROGRESS DR",
    "dropmalcty": "HALFMOON",
    "dropmalst": "NY",
    "dropmalzpp": 120659211,
    "dropsitphn": 5183715460,
    "dropsitlph": 5183715460,
    "dropsitcph": 5183715460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B002120",
    "droptype": "D",
    "dropname": "TOWSON TOWN CENTER",
    "dropdeladd": "825 DULANEY VALLEY RD OFC",
    "dropdelcty": "TOWSON",
    "dropdelst": "MD",
    "dropdelzpp": 212041019,
    "dropphyadd": "825 DULANEY VALLEY RD OFC",
    "dropphycty": "TOWSON",
    "dropphyst": "MD",
    "dropphyzpp": 212041019,
    "dropmaladd": "825 DULANEY VALLEY RD OFC",
    "dropmalcty": "TOWSON",
    "dropmalst": "MD",
    "dropmalzpp": 212041019,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108281430,
    "dropsitcph": 4108281430,
    "dropfax": 4103377416
  },
  {
    "dcode": "D",
    "dropkey": "B002143",
    "droptype": "D",
    "dropname": "EAST POINT MALL",
    "dropdeladd": "7761C EASTPOINT MALL",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212242118,
    "dropphyadd": "7761C EASTPOINT MALL",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212242118,
    "dropmaladd": "7761C EASTPOINT MALL",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212242118,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106333730,
    "dropsitcph": 4106333730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B002144",
    "droptype": "D",
    "dropname": "MONDAWMIN MALL",
    "dropdeladd": "2401 LIBERTY HEIGHTS AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212158019,
    "dropphyadd": "2401 LIBERTY HEIGHTS AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212158019,
    "dropmaladd": "2401 LIBERTY HEIGHTS AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212158019,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106642701,
    "dropsitcph": 4106642701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B002145",
    "droptype": "D",
    "dropname": "SECURITY SQ",
    "dropdeladd": "6901 SECURITY BLVD",
    "dropdelcty": "WINDSOR MILL",
    "dropdelst": "MD",
    "dropdelzpp": 212442412,
    "dropphyadd": "6901 SECURITY BLVD",
    "dropphycty": "WINDSOR MILL",
    "dropphyst": "MD",
    "dropphyzpp": 212442412,
    "dropmaladd": "6901 SECURITY BLVD",
    "dropmalcty": "WINDSOR MILL",
    "dropmalst": "MD",
    "dropmalzpp": 212442412,
    "dropsitphn": 4103474587,
    "dropsitlph": 4105949284,
    "dropsitcph": 4105949284,
    "dropfax": 4105949318
  },
  {
    "dcode": "D",
    "dropkey": "B002147",
    "droptype": "D",
    "dropname": "ENCHANTED FOREST",
    "dropdeladd": "10020 BALTIMORE NATIONAL PIKE",
    "dropdelcty": "ELLICOTT CITY",
    "dropdelst": "MD",
    "dropdelzpp": 210423760,
    "dropphyadd": "10020 BALTIMORE NATIONAL PIKE",
    "dropphycty": "ELLICOTT CITY",
    "dropphyst": "MD",
    "dropphyzpp": 210423760,
    "dropmaladd": "10020 BALTIMORE NATIONAL PIKE",
    "dropmalcty": "ELLICOTT CITY",
    "dropmalst": "MD",
    "dropmalzpp": 210423760,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107501340,
    "dropsitcph": 4107501340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B002239",
    "droptype": "D",
    "dropname": "SULLIVAN GARDENS",
    "dropdeladd": "320 W CENTER ST",
    "dropdelcty": "KINGSPORT",
    "dropdelst": "TN",
    "dropdelzpp": 376603848,
    "dropphyadd": "320 W CENTER ST",
    "dropphycty": "KINGSPORT",
    "dropphyst": "TN",
    "dropphyzpp": 376603848,
    "dropmaladd": "320 W CENTER ST",
    "dropmalcty": "KINGSPORT",
    "dropmalst": "TN",
    "dropmalzpp": 376603848,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232455111,
    "dropsitcph": 4232455111,
    "dropfax": 4232451566
  },
  {
    "dcode": "D",
    "dropkey": "B002434",
    "droptype": "D",
    "dropname": "FLEMING ISLAND",
    "dropdeladd": "1880 EASTWEST PKWY",
    "dropdelcty": "FLEMING ISLAND",
    "dropdelst": "FL",
    "dropdelzpp": 320039998,
    "dropphyadd": "1880 EASTWEST PKWY",
    "dropphycty": "FLEMING ISLAND",
    "dropphyst": "FL",
    "dropphyzpp": 320039998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLEMING ISLAND",
    "dropmalst": "FL",
    "dropmalzpp": 320069998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042648913,
    "dropsitcph": 9042648913,
    "dropfax": 9042648772
  },
  {
    "dcode": "D",
    "dropkey": "B002513",
    "droptype": "D",
    "dropname": "KENTWOOD BRCH",
    "dropdeladd": "1680 44TH ST SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495085269,
    "dropphyadd": "1680 44TH ST SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495085269,
    "dropmaladd": "1680 44TH ST SE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495085269,
    "dropsitphn": 6169771064,
    "dropsitlph": 6164553301,
    "dropsitcph": 6164553301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B002716",
    "droptype": "D",
    "dropname": "WEST BABYLON",
    "dropdeladd": "385 ROUTE 109",
    "dropdelcty": "WEST BABYLON",
    "dropdelst": "NY",
    "dropdelzpp": 117046227,
    "dropphyadd": "385 ROUTE 109",
    "dropphycty": "WEST BABYLON",
    "dropphyst": "NY",
    "dropphyzpp": 117046227,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABYLON",
    "dropmalst": "NY",
    "dropmalzpp": 117029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6318930560,
    "dropfax": 6318935238
  },
  {
    "dcode": "D",
    "dropkey": "B002918",
    "droptype": "D",
    "dropname": "GREENWOOD FIN",
    "dropdeladd": "345 W MAIN ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 461423111,
    "dropphyadd": "345 W MAIN ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 461423111,
    "dropmaladd": "345 W MAIN ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 461423111,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B003133",
    "droptype": "D",
    "dropname": "BROAD ST STA",
    "dropdeladd": "9 E BROAD ST",
    "dropdelcty": "COOKEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385039998,
    "dropphyadd": "9 E BROAD ST",
    "dropphycty": "COOKEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385039998,
    "dropmaladd": "9 E BROAD ST",
    "dropmalcty": "COOKEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385039998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315262107,
    "dropsitcph": 9315263435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B003138",
    "droptype": "D",
    "dropname": "DOWNTOWN STA",
    "dropdeladd": "155 BROAD ST NW",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "TN",
    "dropdelzpp": 373115178,
    "dropphyadd": "155 BROAD ST NW",
    "dropphycty": "CLEVELAND",
    "dropphyst": "TN",
    "dropphyzpp": 373115178,
    "dropmaladd": "1981 KEITH ST NW",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "TN",
    "dropmalzpp": 373114386,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234794347,
    "dropsitcph": 4234794347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B003263",
    "droptype": "D",
    "dropname": "PHILA MAIN OFC POSTAL STORE",
    "dropdeladd": "3000 CHESTNUT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049998,
    "dropphyadd": "3000 CHESTNUT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049996,
    "dropmaladd": "3000 CHESTNUT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049996,
    "dropsitphn": 2158958989,
    "dropsitlph": 2158958989,
    "dropsitcph": 2158958989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B003329",
    "droptype": "D",
    "dropname": "KILLEARN",
    "dropdeladd": "6800 THOMASVILLE RD STE 101",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323124879,
    "dropphyadd": "6800 THOMASVILLE RD STE 101",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323124879,
    "dropmaladd": "6800 THOMASVILLE RD STE 101",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323124879,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508943233,
    "dropsitcph": 8508943233,
    "dropfax": 8508942897
  },
  {
    "dcode": "D",
    "dropkey": "B003459",
    "droptype": "D",
    "dropname": "RIVERSIDE FINANCE",
    "dropdeladd": "45 E BURLINGTON ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 605462124,
    "dropphyadd": "45 E BURLINGTON ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 605462124,
    "dropmaladd": "7300 W 25TH ST",
    "dropmalcty": "NORTH RIVERSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 605469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7084428207,
    "dropsitcph": 7084428207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B003965",
    "droptype": "D",
    "dropname": "INWOOD",
    "dropdeladd": "143 DOUGHTY BLVD",
    "dropdelcty": "INWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 110969907,
    "dropphyadd": "143 DOUGHTY BLVD",
    "dropphycty": "INWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 110969907,
    "dropmaladd": "143 DOUGHTY BLVD",
    "dropmalcty": "INWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 110969907,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5162394452,
    "dropfax": 7183278633
  },
  {
    "dcode": "D",
    "dropkey": "B003992",
    "droptype": "D",
    "dropname": "FEDERAL STA",
    "dropdeladd": "100 S CLINTON ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132619211,
    "dropphyadd": "100 S CLINTON ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132619211,
    "dropmaladd": "100 S CLINTON ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132619211,
    "dropsitphn": "",
    "dropsitlph": 3154234306,
    "dropsitcph": 3154234306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004024",
    "droptype": "D",
    "dropname": "SUNNY ISLES",
    "dropdeladd": "18070 COLLINS AVE",
    "dropdelcty": "SUNNY ISLES BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331602723,
    "dropphyadd": "18070 COLLINS AVE",
    "dropphycty": "SUNNY ISLES BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331602723,
    "dropmaladd": "18070 COLLINS AVE",
    "dropmalcty": "SUNNY ISLES BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331602723,
    "dropsitphn": 3054700746,
    "dropsitlph": 3059318412,
    "dropsitcph": 3059318412,
    "dropfax": 3059318479
  },
  {
    "dcode": "D",
    "dropkey": "B004189",
    "droptype": "D",
    "dropname": "ANGEL FIRE",
    "dropdeladd": "3469 HIGHWAY 434 STE B8",
    "dropdelcty": "ANGEL FIRE",
    "dropdelst": "NM",
    "dropdelzpp": 877109998,
    "dropphyadd": "3469 HIGHWAY 434 STE B8",
    "dropphycty": "ANGEL FIRE",
    "dropphyst": "NM",
    "dropphyzpp": 877109998,
    "dropmaladd": "3469 HIGHWAY 434 STE B8",
    "dropmalcty": "ANGEL FIRE",
    "dropmalst": "NM",
    "dropmalzpp": 877109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753777216,
    "dropsitcph": 5753777216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004190",
    "droptype": "D",
    "dropname": "KINGSFORD",
    "dropdeladd": "700 W BREITUNG AVE",
    "dropdelcty": "KINGSFORD",
    "dropdelst": "MI",
    "dropdelzpp": 498029997,
    "dropphyadd": "700 W BREITUNG AVE",
    "dropphycty": "KINGSFORD",
    "dropphyst": "MI",
    "dropphyzpp": 498029997,
    "dropmaladd": "700 W BREITUNG AVE",
    "dropmalcty": "KINGSFORD",
    "dropmalst": "MI",
    "dropmalzpp": 498029997,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067762001,
    "dropsitcph": 9067762050,
    "dropfax": 9067762032
  },
  {
    "dcode": "D",
    "dropkey": "B004362",
    "droptype": "D",
    "dropname": "ANASTASIA ISLAND",
    "dropdeladd": "138 SEA GROVE MAIN ST",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "FL",
    "dropdelzpp": 320807708,
    "dropphyadd": "138 SEA GROVE MAIN ST",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "FL",
    "dropphyzpp": 320807708,
    "dropmaladd": "138 SEA GROVE MAIN ST",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "FL",
    "dropmalzpp": 320807708,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048254638,
    "dropsitcph": 9048250628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004440",
    "droptype": "D",
    "dropname": "BLUE LAGOON",
    "dropdeladd": "6200 NW 7TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331269998,
    "dropphyadd": "6200 NW 7TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331269998,
    "dropmaladd": "6200 NW 7TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331269998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3052627836,
    "dropsitcph": 3052627836,
    "dropfax": 3052629345
  },
  {
    "dcode": "D",
    "dropkey": "B004485",
    "droptype": "D",
    "dropname": "ARLINGTON TEMP FINANCE UNIT",
    "dropdeladd": "1039 N HIGHLAND ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222012150,
    "dropphyadd": "1039 N HIGHLAND ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222012150,
    "dropmaladd": "1039 N HIGHLAND ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222012150,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038412118,
    "dropsitcph": 7038412118,
    "dropfax": 6932434061
  },
  {
    "dcode": "D",
    "dropkey": "B004500",
    "droptype": "D",
    "dropname": "COAST GUARD FINANCE UNIT",
    "dropdeladd": "1 U S COAST GUARD TRN CTR",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 236905001,
    "dropphyadd": "1 U S COAST GUARD TRN CTR",
    "dropphycty": "YORKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 236905001,
    "dropmaladd": "1 U S COAST GUARD TRN CTR",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 236905001,
    "dropsitphn": 7578985435,
    "dropsitlph": 7574218259,
    "dropsitcph": 7578562169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004642",
    "droptype": "D",
    "dropname": "CORAOPOLIS FINANCE",
    "dropdeladd": "914 5TH AVE",
    "dropdelcty": "CORAOPOLIS",
    "dropdelst": "PA",
    "dropdelzpp": 151081802,
    "dropphyadd": "914 5TH AVE",
    "dropphycty": "CORAOPOLIS",
    "dropphyst": "PA",
    "dropphyzpp": 151081802,
    "dropmaladd": "914 5TH AVE",
    "dropmalcty": "CORAOPOLIS",
    "dropmalst": "PA",
    "dropmalzpp": 151081802,
    "dropsitphn": 4122624024,
    "dropsitlph": 4122624024,
    "dropsitcph": 4122624024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004655",
    "droptype": "D",
    "dropname": "BRADLEY AIRPORT",
    "dropdeladd": "10 SCHOEPHOESTER RD",
    "dropdelcty": "WINDSOR LOCKS",
    "dropdelst": "CT",
    "dropdelzpp": "060961023",
    "dropphyadd": "10 SCHOEPHOESTER RD",
    "dropphycty": "WINDSOR LOCKS",
    "dropphyst": "CT",
    "dropphyzpp": "060961023",
    "dropmaladd": "10 SCHOEPHOESTER RD",
    "dropmalcty": "WINDSOR LOCKS",
    "dropmalst": "CT",
    "dropmalzpp": "060961023",
    "dropsitphn": 8602923308,
    "dropsitlph": "",
    "dropsitcph": 8602923308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B004780",
    "droptype": "D",
    "dropname": "SAN JUAN AIRPORT RETAIL",
    "dropdeladd": "35 AVE JOSE A TONY SANTANA",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009799998",
    "dropphyadd": "35 AVE JOSE A TONY SANTANA",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009799998",
    "dropmaladd": "35 AVE JOSE A TONY SANTANA",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009799998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876414824,
    "dropfax": 7876414855
  },
  {
    "dcode": "D",
    "dropkey": "B006066",
    "droptype": "D",
    "dropname": "BOGGS ROAD",
    "dropdeladd": "1605 BOGGS RD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300965519,
    "dropphyadd": "1605 BOGGS RD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300965519,
    "dropmaladd": "1605 BOGGS RD",
    "dropmalcty": "DULUTH",
    "dropmalst": "GA",
    "dropmalzpp": 300965519,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707173718,
    "dropsitcph": 7707173701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B006818",
    "droptype": "D",
    "dropname": "WEST YORK",
    "dropdeladd": "2150 WHITE ST STE 8",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174049998,
    "dropphyadd": "2150 WHITE ST STE 8",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174049998,
    "dropmaladd": "2150 WHITE ST STE 8",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174049998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7178547568,
    "dropsitcph": 7178461505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B006848",
    "droptype": "D",
    "dropname": "CHIPPEWA MALL",
    "dropdeladd": "2580 CONSTITUTION BLVD STE 9",
    "dropdelcty": "BEAVER FALLS",
    "dropdelst": "PA",
    "dropdelzpp": 150101273,
    "dropphyadd": "2580 CONSTITUTION BLVD STE 9",
    "dropphycty": "BEAVER FALLS",
    "dropphyst": "PA",
    "dropphyzpp": 150101273,
    "dropmaladd": "2580 CONSTITUTION BLVD STE 9",
    "dropmalcty": "BEAVER FALLS",
    "dropmalst": "PA",
    "dropmalzpp": 150101273,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248433280,
    "dropsitcph": 7248433280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B007609",
    "droptype": "D",
    "dropname": "ORCHARDS MALL",
    "dropdeladd": "1800 PIPESTONE RD",
    "dropdelcty": "BENTON HARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 490222304,
    "dropphyadd": "1800 PIPESTONE RD",
    "dropphycty": "BENTON HARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 490222304,
    "dropmaladd": "1800 PIPESTONE RD",
    "dropmalcty": "BENTON HARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 490222304,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2699253458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B007631",
    "droptype": "D",
    "dropname": "ROUTE 13",
    "dropdeladd": "2505 N SALISBURY BLVD UNIT 1",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MD",
    "dropdelzpp": 218019996,
    "dropphyadd": "2505 N SALISBURY BLVD UNIT 1",
    "dropphycty": "SALISBURY",
    "dropphyst": "MD",
    "dropphyzpp": 218019996,
    "dropmaladd": "2505 N SALISBURY BLVD UNIT 1",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MD",
    "dropmalzpp": 218019996,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107429261,
    "dropsitcph": 4107429261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008194",
    "droptype": "D",
    "dropname": "DET AMC FINAN",
    "dropdeladd": "515 DETROIT METRO AIRPORT",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482421000,
    "dropphyadd": "515 DETROIT METRO AIRPORT",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482421000,
    "dropmaladd": "515 DETROIT METRO AIRPORT",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482421000,
    "dropsitphn": "",
    "dropsitlph": 3132268854,
    "dropsitcph": 3132348926,
    "dropfax": 7349552250
  },
  {
    "dcode": "D",
    "dropkey": "B008338",
    "droptype": "D",
    "dropname": "MAYWOOD",
    "dropdeladd": "4357 SLAUSON AVE",
    "dropdelcty": "MAYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 902709998,
    "dropphyadd": "4357 SLAUSON AVE",
    "dropphycty": "MAYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 902709998,
    "dropmaladd": "4357 SLAUSON AVE",
    "dropmalcty": "MAYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 902709998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3237710269,
    "dropsitcph": 3237714597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008451",
    "droptype": "D",
    "dropname": "GOODFELLOW AFB",
    "dropdeladd": "161 NUCHOLS ST UNIT 102",
    "dropdelcty": "GOODFELLOW AFB",
    "dropdelst": "TX",
    "dropdelzpp": 769083352,
    "dropphyadd": "161 NUCHOLS ST UNIT 102",
    "dropphycty": "GOODFELLOW AFB",
    "dropphyst": "TX",
    "dropphyzpp": 769083352,
    "dropmaladd": "161 NUCHOLS ST UNIT 102",
    "dropmalcty": "GOODFELLOW AFB",
    "dropmalst": "TX",
    "dropmalzpp": 769083352,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 9156597700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008651",
    "droptype": "D",
    "dropname": "GRIFFIS AFB",
    "dropdeladd": "306 MARKET ST STE 4",
    "dropdelcty": "ROME",
    "dropdelst": "NY",
    "dropdelzpp": 134419901,
    "dropphyadd": "306 MARKET ST STE 4",
    "dropphycty": "ROME",
    "dropphyst": "NY",
    "dropphyzpp": 134419901,
    "dropmaladd": "306 MARKET ST STE 4",
    "dropmalcty": "ROME",
    "dropmalst": "NY",
    "dropmalzpp": 134419901,
    "dropsitphn": 3153361500,
    "dropsitlph": 3153373469,
    "dropsitcph": 3153373469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008652",
    "droptype": "D",
    "dropname": "COLLEGE SQUARE",
    "dropdeladd": "119 W COLLEGE AVE STE 204",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MD",
    "dropdelzpp": 218049996,
    "dropphyadd": "119 W COLLEGE AVE STE 204",
    "dropphycty": "SALISBURY",
    "dropphyst": "MD",
    "dropphyzpp": 218049996,
    "dropmaladd": "119 W COLLEGE AVE STE 204",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MD",
    "dropmalzpp": 218049996,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107429261,
    "dropsitcph": 4107429261,
    "dropfax": 4107429495
  },
  {
    "dcode": "D",
    "dropkey": "B008817",
    "droptype": "D",
    "dropname": "SCOTT AIR FORCE BASE",
    "dropdeladd": "404 W MARTIN ST",
    "dropdelcty": "SCOTT AIR FORCE BASE",
    "dropdelst": "IL",
    "dropdelzpp": 622259998,
    "dropphyadd": "404 W MARTIN ST",
    "dropphycty": "SCOTT AIR FORCE BASE",
    "dropphyst": "IL",
    "dropphyzpp": 622259998,
    "dropmaladd": "404 W MARTIN ST",
    "dropmalcty": "SCOTT AIR FORCE BASE",
    "dropmalst": "IL",
    "dropmalzpp": 622259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182565942,
    "dropsitcph": 6182565942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008891",
    "droptype": "D",
    "dropname": "PHILA AMC RETAIL STORE",
    "dropdeladd": "2904 S 70TH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191429997,
    "dropphyadd": "2904 S 70TH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191429997,
    "dropmaladd": "2904 S 70TH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191429997,
    "dropsitphn": 2159375610,
    "dropsitlph": 2159375640,
    "dropsitcph": 2159375640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B008957",
    "droptype": "D",
    "dropname": "SUGARLOAF",
    "dropdeladd": "501 MAPLE LN",
    "dropdelcty": "SUGARLOAF",
    "dropdelst": "CA",
    "dropdelzpp": 923869998,
    "dropphyadd": "501 MAPLE LN",
    "dropphycty": "SUGARLOAF",
    "dropphyst": "CA",
    "dropphyzpp": 923869998,
    "dropmaladd": "501 MAPLE LN",
    "dropmalcty": "SUGARLOAF",
    "dropmalst": "CA",
    "dropmalzpp": 923869998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9095856364,
    "dropsitcph": 9095856364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B009013",
    "droptype": "D",
    "dropname": "WPAFB UNIT 2",
    "dropdeladd": "4881 SUGAR MAPLE DR BLDG 830",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454339911,
    "dropphyadd": "4881 SUGAR MAPLE DR BLDG 830",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454339911,
    "dropmaladd": "4881 SUGAR MAPLE DR BLDG 830",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454339911,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372574219,
    "dropsitcph": 9372574219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B009014",
    "droptype": "D",
    "dropname": "WPAFB UNIT 3",
    "dropdeladd": "5435 HEMLOCK ST BLDG 1226",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454339912,
    "dropphyadd": "5435 HEMLOCK ST BLDG 1226",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454339912,
    "dropmaladd": "5435 HEMLOCK ST BLDG 1226",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454339912,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372574458,
    "dropsitcph": 9372574458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B009818",
    "droptype": "D",
    "dropname": "KILMER",
    "dropdeladd": "21 KILMER RD",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088999512",
    "dropphyadd": "21 KILMER RD",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088999512",
    "dropmaladd": "21 KILMER RD",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088999512",
    "dropsitphn": 7328194333,
    "dropsitlph": 7328194333,
    "dropsitcph": 7328194333,
    "dropfax": 7328194387
  },
  {
    "dcode": "D",
    "dropkey": "B010373",
    "droptype": "D",
    "dropname": "LEHIGH VALLEY POSTAL STORE",
    "dropdeladd": "17 S COMMERCE WAY",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180179026,
    "dropphyadd": "17 S COMMERCE WAY",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180179026,
    "dropmaladd": "17 S COMMERCE WAY",
    "dropmalcty": "LEHIGH VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 180029610,
    "dropsitphn": 6108823244,
    "dropsitlph": 6108823247,
    "dropsitcph": 6108823247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B010428",
    "droptype": "D",
    "dropname": "ALAFAYA",
    "dropdeladd": "650 N ALAFAYA TRL STE 101",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328289997,
    "dropphyadd": "650 N ALAFAYA TRL STE 101",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328289997,
    "dropmaladd": "PO BOX 789998",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328789998,
    "dropsitphn": 4072736876,
    "dropsitlph": 4072736876,
    "dropsitcph": 4072736788,
    "dropfax": 4072736504
  },
  {
    "dcode": "D",
    "dropkey": "B010470",
    "droptype": "D",
    "dropname": "RIO RANCHO POE",
    "dropdeladd": "7800 ENCHANTED HILLS BLVD NE STE A",
    "dropdelcty": "RIO RANCHO",
    "dropdelst": "NM",
    "dropdelzpp": 871449997,
    "dropphyadd": "7800 ENCHANTED HILLS BLVD NE STE A",
    "dropphycty": "RIO RANCHO",
    "dropphyst": "NM",
    "dropphyzpp": 871449997,
    "dropmaladd": "7800 ENCHANTED HILLS BLVD NE STE A",
    "dropmalcty": "RIO RANCHO",
    "dropmalst": "NM",
    "dropmalzpp": 871449997,
    "dropsitphn": 5053468251,
    "dropsitlph": "",
    "dropsitcph": 5059943756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B010485",
    "droptype": "D",
    "dropname": "DIAMONDHEAD",
    "dropdeladd": "4402 E ALOHA DR STE 5",
    "dropdelcty": "DIAMONDHEAD",
    "dropdelst": "MS",
    "dropdelzpp": 395259998,
    "dropphyadd": "4402 E ALOHA DR STE 5",
    "dropphycty": "DIAMONDHEAD",
    "dropphyst": "MS",
    "dropphyzpp": 395259998,
    "dropmaladd": "4402 E ALOHA DR STE 5",
    "dropmalcty": "DIAMONDHEAD",
    "dropmalst": "MS",
    "dropmalzpp": 395259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2282556724,
    "dropsitcph": 2282556701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B010797",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "1704 W NEWPORT PIKE",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198049998,
    "dropphyadd": "1704 W NEWPORT PIKE",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198049998,
    "dropmaladd": "1704 W NEWPORT PIKE",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198049998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3029945029,
    "dropfax": 3029987197
  },
  {
    "dcode": "D",
    "dropkey": "B010941",
    "droptype": "D",
    "dropname": "SURF CITY",
    "dropdeladd": "13567 NC HIGHWAY 50 STE D",
    "dropdelcty": "HOLLY RIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 284456572,
    "dropphyadd": "13567 NC HIGHWAY 50 STE D",
    "dropphycty": "HOLLY RIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 284456572,
    "dropmaladd": "13567 NC HIGHWAY 50 STE D",
    "dropmalcty": "HOLLY RIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 284456572,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103291463,
    "dropsitcph": 9103291463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B010943",
    "droptype": "D",
    "dropname": "CITY CENTER",
    "dropdeladd": "4975 CITY HALL BLVD",
    "dropdelcty": "NORTH PORT",
    "dropdelst": "FL",
    "dropdelzpp": 342864103,
    "dropphyadd": "4975 CITY HALL BLVD",
    "dropphycty": "NORTH PORT",
    "dropphyst": "FL",
    "dropphyzpp": 342864103,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "NORTH PORT",
    "dropmalst": "FL",
    "dropmalzpp": 342909997,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9414292082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B011262",
    "droptype": "D",
    "dropname": "FOXBROOK",
    "dropdeladd": "7231 FM 1960 RD W STE A",
    "dropdelcty": "HUMBLE",
    "dropdelst": "TX",
    "dropdelzpp": 773383468,
    "dropphyadd": "7231 FM 1960 RD W STE A",
    "dropphycty": "HUMBLE",
    "dropphyst": "TX",
    "dropphyzpp": 773383468,
    "dropmaladd": "PO BOX 60998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772059998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813195520,
    "dropsitcph": 2813195519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B011317",
    "droptype": "D",
    "dropname": "VAIL RETAIL",
    "dropdeladd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropdelcty": "VAIL",
    "dropdelst": "AZ",
    "dropdelzpp": 856418808,
    "dropphyadd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropphycty": "VAIL",
    "dropphyst": "AZ",
    "dropphyzpp": 856418808,
    "dropmaladd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropmalcty": "VAIL",
    "dropmalst": "AZ",
    "dropmalzpp": 856418808,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208625052,
    "dropsitcph": 5207625052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B011752",
    "droptype": "D",
    "dropname": "ANASTASIA",
    "dropdeladd": "2250 A1A S",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "FL",
    "dropdelzpp": 320807958,
    "dropphyadd": "2250 A1A S",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "FL",
    "dropphyzpp": 320807958,
    "dropmaladd": "2250 A1A S",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "FL",
    "dropmalzpp": 320807958,
    "dropsitphn": 9043592957,
    "dropsitlph": 9044611773,
    "dropsitcph": 9044717088,
    "dropfax": 9044717099
  },
  {
    "dcode": "D",
    "dropkey": "B011815",
    "droptype": "D",
    "dropname": "LAKEWOOD RANCH",
    "dropdeladd": "5910 POST BLVD",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342119998,
    "dropphyadd": "5910 POST BLVD",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342119998,
    "dropmaladd": "5910 POST BLVD",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342119998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417583537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B012185",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "10611 BALTIMORE ST NE STE 100",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554499930,
    "dropphyadd": "10611 BALTIMORE ST NE STE 100",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554499930,
    "dropmaladd": "10611 BALTIMORE ST NE STE 100",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554495057,
    "dropsitphn": 6123496399,
    "dropsitlph": 7637833094,
    "dropsitcph": 7637841208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B012202",
    "droptype": "D",
    "dropname": "POINCIANA",
    "dropdeladd": "4774 SAN REMO RD",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347589998,
    "dropphyadd": "4774 SAN REMO RD",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347589998,
    "dropmaladd": "4774 SAN REMO RD",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347589998,
    "dropsitphn": 4079440939,
    "dropsitlph": 4079332044,
    "dropsitcph": 4073437874,
    "dropfax": 4078463022
  },
  {
    "dcode": "D",
    "dropkey": "B012221",
    "droptype": "D",
    "dropname": "NEW BRIGHTON",
    "dropdeladd": "525 MAIN ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551129998,
    "dropphyadd": "525 MAIN ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551129998,
    "dropmaladd": "525 MAIN ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551123243,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516310524,
    "dropsitcph": 6516399306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B012359",
    "droptype": "D",
    "dropname": "CASTAIC",
    "dropdeladd": "28201 FRANKLIN PKWY",
    "dropdelcty": "SANTA CLARITA",
    "dropdelst": "CA",
    "dropdelzpp": 913839998,
    "dropphyadd": "28201 FRANKLIN PKWY",
    "dropphycty": "SANTA CLARITA",
    "dropphyst": "CA",
    "dropphyzpp": 913839998,
    "dropmaladd": "28201 FRANKLIN PKWY",
    "dropmalcty": "SANTA CLARITA",
    "dropmalst": "CA",
    "dropmalzpp": 913839998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617757167,
    "dropsitcph": 6617757166,
    "dropfax": 6617757199
  },
  {
    "dcode": "D",
    "dropkey": "B012360",
    "droptype": "D",
    "dropname": "NORTH HILLS",
    "dropdeladd": "9134 SEPULVEDA BLVD",
    "dropdelcty": "NORTH HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 913439998,
    "dropphyadd": "9134 SEPULVEDA BLVD",
    "dropphycty": "NORTH HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 913439998,
    "dropmaladd": "9134 SEPULVEDA BLVD",
    "dropmalcty": "NORTH HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 913439998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188305404,
    "dropsitcph": 8188305257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B012396",
    "droptype": "D",
    "dropname": "ELLWOOD",
    "dropdeladd": "400 STORKE RD",
    "dropdelcty": "GOLETA",
    "dropdelst": "CA",
    "dropdelzpp": 931999998,
    "dropphyadd": "400 STORKE RD",
    "dropphycty": "GOLETA",
    "dropphyst": "CA",
    "dropphyzpp": 931999998,
    "dropmaladd": "400 STORKE RD",
    "dropmalcty": "GOLETA",
    "dropmalst": "CA",
    "dropmalzpp": 931999998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059610782,
    "dropsitcph": 8059610782,
    "dropfax": 8059610849
  },
  {
    "dcode": "D",
    "dropkey": "B012521",
    "droptype": "D",
    "dropname": "HOCKINGPORT",
    "dropdeladd": "699 STATE ROUTE 124",
    "dropdelcty": "HOCKINGPORT",
    "dropdelst": "OH",
    "dropdelzpp": 457399996,
    "dropphyadd": "699 STATE ROUTE 124",
    "dropphycty": "HOCKINGPORT",
    "dropphyst": "OH",
    "dropphyzpp": 457399996,
    "dropmaladd": "699 STATE ROUTE 124",
    "dropmalcty": "HOCKINGPORT",
    "dropmalst": "OH",
    "dropmalzpp": 457399996,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406670538,
    "dropsitcph": 7406670538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B013110",
    "droptype": "D",
    "dropname": "HOT SPRINGS VILLAGE",
    "dropdeladd": "4656 N HIGHWAY 7 STE P",
    "dropdelcty": "HOT SPRINGS VILLAGE",
    "dropdelst": "AR",
    "dropdelzpp": 719099998,
    "dropphyadd": "4656 N HIGHWAY 7 STE P",
    "dropphycty": "HOT SPRINGS VILLAGE",
    "dropphyst": "AR",
    "dropphyzpp": 719099998,
    "dropmaladd": "4656 N HIGHWAY 7 STE P",
    "dropmalcty": "HOT SPRINGS VILLAGE",
    "dropmalst": "AR",
    "dropmalzpp": 719099998,
    "dropsitphn": 5019846392,
    "dropsitlph": 5019846392,
    "dropsitcph": 5019846392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B013336",
    "droptype": "D",
    "dropname": "CAMP PENDLETON",
    "dropdeladd": "16840 USPS BLDG 16840",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550013,
    "dropphyadd": "16840 USPS BLDG 16840",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920559998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607254691,
    "dropsitcph": 7607255029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B013365",
    "droptype": "D",
    "dropname": "FAIRVIEW PARK",
    "dropdeladd": "22350 BROOKPARK RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441269998,
    "dropphyadd": "22350 BROOKPARK RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441269998,
    "dropmaladd": "22350 BROOKPARK RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441269998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407342166,
    "dropfax": 4403480142
  },
  {
    "dcode": "D",
    "dropkey": "B013966",
    "droptype": "D",
    "dropname": "TEMPLE TERRACE",
    "dropdeladd": "8761 N 56TH ST",
    "dropdelcty": "TEMPLE TERRACE",
    "dropdelst": "FL",
    "dropdelzpp": 336176208,
    "dropphyadd": "8761 N 56TH ST",
    "dropphycty": "TEMPLE TERRACE",
    "dropphyst": "FL",
    "dropphyzpp": 336176208,
    "dropmaladd": "8761 N 56TH ST",
    "dropmalcty": "TEMPLE TERRACE",
    "dropmalst": "FL",
    "dropmalzpp": 336176208,
    "dropsitphn": 8139897866,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139897866,
    "dropfax": 8139887873
  },
  {
    "dcode": "D",
    "dropkey": "B014188",
    "droptype": "D",
    "dropname": "GLENDALE HEIGHTS FINANCE",
    "dropdeladd": "147 E NORTH AVE",
    "dropdelcty": "GLENDALE HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 601393785,
    "dropphyadd": "147 E NORTH AVE",
    "dropphycty": "GLENDALE HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 601393785,
    "dropmaladd": "147 E NORTH AVE",
    "dropmalcty": "GLENDALE HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 601393785,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306821310,
    "dropsitcph": 6306821310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B014246",
    "droptype": "D",
    "dropname": "NORTH SPRINGFIELD",
    "dropdeladd": "5242 PORT ROYAL RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 221512124,
    "dropphyadd": "5242 PORT ROYAL RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 221512124,
    "dropmaladd": "5242 PORT ROYAL RD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 221512124,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039781436,
    "dropsitcph": 7039781436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B014609",
    "droptype": "D",
    "dropname": "ASHBURN II RETAIL",
    "dropdeladd": "43150 BROADLANDS CENTER PLZ STE 124",
    "dropdelcty": "BROADLANDS",
    "dropdelst": "VA",
    "dropdelzpp": 201483808,
    "dropphyadd": "43150 BROADLANDS CENTER PLZ STE 124",
    "dropphycty": "BROADLANDS",
    "dropphyst": "VA",
    "dropphyzpp": 201483808,
    "dropmaladd": "43150 BROADLANDS CENTER PLZ STE 124",
    "dropmalcty": "BROADLANDS",
    "dropmalst": "VA",
    "dropmalzpp": 201483808,
    "dropsitphn": 7036986367,
    "dropsitlph": 7034066291,
    "dropsitcph": 7034066291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B014641",
    "droptype": "D",
    "dropname": "ESSEXVILLE",
    "dropdeladd": "1205 WOODSIDE AVE",
    "dropdelcty": "ESSEXVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487321267,
    "dropphyadd": "1205 WOODSIDE AVE",
    "dropphycty": "ESSEXVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487321267,
    "dropmaladd": "1205 WOODSIDE AVE",
    "dropmalcty": "ESSEXVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487321267,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9898942561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B014973",
    "droptype": "D",
    "dropname": "EL SEGUNDO",
    "dropdeladd": "2130 E MARIPOSA AVE",
    "dropdelcty": "EL SEGUNDO",
    "dropdelst": "CA",
    "dropdelzpp": 902459998,
    "dropphyadd": "2130 E MARIPOSA AVE",
    "dropphycty": "EL SEGUNDO",
    "dropphyst": "CA",
    "dropphyzpp": 902459998,
    "dropmaladd": "2130 E MARIPOSA AVE",
    "dropmalcty": "EL SEGUNDO",
    "dropmalst": "CA",
    "dropmalzpp": 902459998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3104140352,
    "dropsitcph": 3104140350,
    "dropfax": 3106402584
  },
  {
    "dcode": "D",
    "dropkey": "B015085",
    "droptype": "D",
    "dropname": "MOSBY FINANCE UNIT",
    "dropdeladd": "6533 ARLINGTON BLVD STE A",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220423023,
    "dropphyadd": "6533 ARLINGTON BLVD STE A",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220423023,
    "dropmaladd": "6533 ARLINGTON BLVD STE A",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220423023,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": 7032373672
  },
  {
    "dcode": "D",
    "dropkey": "B015318",
    "droptype": "D",
    "dropname": "GRANITE BAY",
    "dropdeladd": "8757 AUBURN FOLSOM RD",
    "dropdelcty": "GRANITE BAY",
    "dropdelst": "CA",
    "dropdelzpp": 957469998,
    "dropphyadd": "8757 AUBURN FOLSOM RD",
    "dropphycty": "GRANITE BAY",
    "dropphyst": "CA",
    "dropphyzpp": 957469998,
    "dropmaladd": "8757 AUBURN FOLSOM RD",
    "dropmalcty": "GRANITE BAY",
    "dropmalst": "CA",
    "dropmalzpp": 957469998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167910873,
    "dropsitcph": 9167972732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B015363",
    "droptype": "D",
    "dropname": "ROSEMONT BRANCH",
    "dropdeladd": "9507 W HIGGINS RD",
    "dropdelcty": "ROSEMONT",
    "dropdelst": "IL",
    "dropdelzpp": 600184934,
    "dropphyadd": "9507 W HIGGINS RD",
    "dropphycty": "ROSEMONT",
    "dropphyst": "IL",
    "dropphyzpp": 600184934,
    "dropmaladd": "9507 W HIGGINS RD",
    "dropmalcty": "ROSEMONT",
    "dropmalst": "IL",
    "dropmalzpp": 600184934,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476983089,
    "dropsitcph": 8476851280,
    "dropfax": 8478273924
  },
  {
    "dcode": "D",
    "dropkey": "B016165",
    "droptype": "D",
    "dropname": "CHARLOTTE PASSPORT OFFICE",
    "dropdeladd": "1820 W POINTE DR STE A",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282140050,
    "dropphyadd": "1820 W POINTE DR STE A",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282140050,
    "dropmaladd": "1820 W POINTE DR STE A",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282140050,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043590761,
    "dropsitcph": 7043590761,
    "dropfax": 7043934492
  },
  {
    "dcode": "D",
    "dropkey": "B016381",
    "droptype": "D",
    "dropname": "HOXIE",
    "dropdeladd": "202 SW TEXAS ST",
    "dropdelcty": "HOXIE",
    "dropdelst": "AR",
    "dropdelzpp": 724339998,
    "dropphyadd": "202 SW TEXAS ST",
    "dropphycty": "HOXIE",
    "dropphyst": "AR",
    "dropphyzpp": 724339998,
    "dropmaladd": "202 SW TEXAS ST",
    "dropmalcty": "HOXIE",
    "dropmalst": "AR",
    "dropmalzpp": 724339998,
    "dropsitphn": 8708862581,
    "dropsitlph": 8708666256,
    "dropsitcph": 8708866256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B016397",
    "droptype": "D",
    "dropname": "UNION SQUARE",
    "dropdeladd": "18 BOW ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "021432956",
    "dropphyadd": "18 BOW ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "021432956",
    "dropmaladd": "18 BOW ST",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021432956",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177760175,
    "dropfax": 6176256622
  },
  {
    "dcode": "D",
    "dropkey": "B016761",
    "droptype": "D",
    "dropname": "TYNDALL AFB",
    "dropdeladd": "590 SUWANNEE RD STE 105",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324039998,
    "dropphyadd": "590 SUWANNEE RD STE 105",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324039998,
    "dropmaladd": "590 SUWANNEE RD STE 105",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324039998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502865019,
    "dropsitcph": 8502833420,
    "dropfax": 8502865019
  },
  {
    "dcode": "D",
    "dropkey": "B016844",
    "droptype": "D",
    "dropname": "KENDALL",
    "dropdeladd": "8821 SW 136TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331769997,
    "dropphyadd": "8821 SW 136TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331769997,
    "dropmaladd": "8821 SW 136TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331769997,
    "dropsitphn": 3052746702,
    "dropsitlph": 3052351973,
    "dropsitcph": 3052351546,
    "dropfax": 3052357172
  },
  {
    "dcode": "D",
    "dropkey": "B016851",
    "droptype": "D",
    "dropname": "PRAIRIE VILLAGE",
    "dropdeladd": "6917 TOMAHAWK RD",
    "dropdelcty": "PRAIRIE VILLAGE",
    "dropdelst": "KS",
    "dropdelzpp": 662082618,
    "dropphyadd": "6917 TOMAHAWK RD",
    "dropphycty": "PRAIRIE VILLAGE",
    "dropphyst": "KS",
    "dropphyzpp": 662082618,
    "dropmaladd": "6917 TOMAHAWK RD",
    "dropmalcty": "PRAIRIE VILLAGE",
    "dropmalst": "KS",
    "dropmalzpp": 662082618,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 9138315374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B016882",
    "droptype": "D",
    "dropname": "NEWBURY PARK",
    "dropdeladd": "3401 GRANDE VISTA DR",
    "dropdelcty": "NEWBURY PARK",
    "dropdelst": "CA",
    "dropdelzpp": 913209998,
    "dropphyadd": "3401 GRANDE VISTA DR",
    "dropphycty": "NEWBURY PARK",
    "dropphyst": "CA",
    "dropphyzpp": 913209998,
    "dropmaladd": "3401 GRANDE VISTA DR",
    "dropmalcty": "NEWBURY PARK",
    "dropmalst": "CA",
    "dropmalzpp": 913209998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8053760836,
    "dropsitcph": 8053760836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B016917",
    "droptype": "D",
    "dropname": "WEST HOLLYWOOD",
    "dropdeladd": "458 N DOHENY DR",
    "dropdelcty": "WEST HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 900489997,
    "dropphyadd": "458 N DOHENY DR",
    "dropphycty": "WEST HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 900489997,
    "dropmaladd": "458 N DOHENY DR",
    "dropmalcty": "WEST HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 900489997,
    "dropsitphn": 3239331865,
    "dropsitlph": 3235861867,
    "dropsitcph": 3102055508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B016941",
    "droptype": "D",
    "dropname": "CORALVILLE",
    "dropdeladd": "2150 JAMES ST",
    "dropdelcty": "CORALVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 522419998,
    "dropphyadd": "2150 JAMES ST",
    "dropphycty": "CORALVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 522419998,
    "dropmaladd": "2150 JAMES ST",
    "dropmalcty": "CORALVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 522419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193378881,
    "dropsitcph": 3193378881,
    "dropfax": 3193375178
  },
  {
    "dcode": "D",
    "dropkey": "B016987",
    "droptype": "D",
    "dropname": "SEA ISLAND",
    "dropdeladd": "351 SEA ISLAND RD STE 104",
    "dropdelcty": "SAINT SIMONS ISLAND",
    "dropdelst": "GA",
    "dropdelzpp": 315221477,
    "dropphyadd": "351 SEA ISLAND RD STE 104",
    "dropphycty": "SAINT SIMONS ISLAND",
    "dropphyst": "GA",
    "dropphyzpp": 315221477,
    "dropmaladd": "351 SEA ISLAND RD STE 104",
    "dropmalcty": "SAINT SIMONS ISLAND",
    "dropmalst": "GA",
    "dropmalzpp": 315221477,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126386486,
    "dropsitcph": 9126386486,
    "dropfax": 9126384786
  },
  {
    "dcode": "D",
    "dropkey": "B017011",
    "droptype": "D",
    "dropname": "ASPEN HILL",
    "dropdeladd": "14030 CONNECTICUT AVE",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209069998,
    "dropphyadd": "14030 CONNECTICUT AVE",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209069998,
    "dropmaladd": "14030 CONNECTICUT AVE",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209069998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018714442,
    "dropsitcph": 3018714444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B017157",
    "droptype": "D",
    "dropname": "STEVENSON RANCH",
    "dropdeladd": "25548 THE OLD RD",
    "dropdelcty": "STEVENSON RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 913819984,
    "dropphyadd": "25548 THE OLD RD",
    "dropphycty": "STEVENSON RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 913819984,
    "dropmaladd": "25548 THE OLD RD",
    "dropmalcty": "STEVENSON RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 913819984,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612873564,
    "dropsitcph": 6612530771,
    "dropfax": 6612547318
  },
  {
    "dcode": "D",
    "dropkey": "B017260",
    "droptype": "D",
    "dropname": "MARINA DEL REY",
    "dropdeladd": "4325 GLENCOE AVE STE C9",
    "dropdelcty": "MARINA DEL REY",
    "dropdelst": "CA",
    "dropdelzpp": 902929991,
    "dropphyadd": "4325 GLENCOE AVE STE C9",
    "dropphycty": "MARINA DEL REY",
    "dropphyst": "CA",
    "dropphyzpp": 902929991,
    "dropmaladd": "4325 GLENCOE AVE STE C9",
    "dropmalcty": "MARINA DEL REY",
    "dropmalst": "CA",
    "dropmalzpp": 902929991,
    "dropsitphn": 3103144024,
    "dropsitlph": 3103060774,
    "dropsitcph": 3103064533,
    "dropfax": 3103066933
  },
  {
    "dcode": "D",
    "dropkey": "B017435",
    "droptype": "D",
    "dropname": "JARBIDGE",
    "dropdeladd": "533 MAIN ST",
    "dropdelcty": "JARBIDGE",
    "dropdelst": "NV",
    "dropdelzpp": 898269998,
    "dropphyadd": "533 MAIN ST",
    "dropphycty": "JARBIDGE",
    "dropphyst": "NV",
    "dropphyzpp": 898269998,
    "dropmaladd": "533 MAIN ST",
    "dropmalcty": "JARBIDGE",
    "dropmalst": "NV",
    "dropmalzpp": 898269998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7754882394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B017944",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "11528 W STATE ROAD 84",
    "dropdelcty": "DAVIE",
    "dropdelst": "FL",
    "dropdelzpp": 333259998,
    "dropphyadd": "11528 W STATE ROAD 84",
    "dropphycty": "DAVIE",
    "dropphyst": "FL",
    "dropphyzpp": 333259998,
    "dropmaladd": "11528 W STATE ROAD 84",
    "dropmalcty": "DAVIE",
    "dropmalst": "FL",
    "dropmalzpp": 333259998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544736130,
    "dropsitcph": 9544736130,
    "dropfax": 9549169399
  },
  {
    "dcode": "D",
    "dropkey": "B018056",
    "droptype": "D",
    "dropname": "RUBIDOUX",
    "dropdeladd": "8082 LIMONITE AVE STE 1",
    "dropdelcty": "JURUPA VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 925096127,
    "dropphyadd": "8082 LIMONITE AVE STE 1",
    "dropphycty": "JURUPA VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 925096127,
    "dropmaladd": "8082 LIMONITE AVE STE 1",
    "dropmalcty": "JURUPA VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 925096127,
    "dropsitphn": 9517278346,
    "dropsitlph": 9516861731,
    "dropsitcph": 9517278346,
    "dropfax": 9517278347
  },
  {
    "dcode": "D",
    "dropkey": "B018096",
    "droptype": "D",
    "dropname": "RICHMOND HEIGHTS",
    "dropdeladd": "1209 S BIG BEND BLVD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631179998,
    "dropphyadd": "1209 S BIG BEND BLVD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631179998,
    "dropmaladd": "1209 S BIG BEND BLVD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3146451595,
    "dropsitcph": 3146453365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018237",
    "droptype": "D",
    "dropname": "JEKYLL ISLAND",
    "dropdeladd": "17 PIER RD UNIT B",
    "dropdelcty": "JEKYLL ISLAND",
    "dropdelst": "GA",
    "dropdelzpp": 315279998,
    "dropphyadd": "17 PIER RD UNIT B",
    "dropphycty": "JEKYLL ISLAND",
    "dropphyst": "GA",
    "dropphyzpp": 315279998,
    "dropmaladd": "17 PIER RD UNIT B",
    "dropmalcty": "JEKYLL ISLAND",
    "dropmalst": "GA",
    "dropmalzpp": 315279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126352625,
    "dropsitcph": 9126352625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018239",
    "droptype": "D",
    "dropname": "SOUTH INTL",
    "dropdeladd": "15 18TH ST E",
    "dropdelcty": "SOUTH INTERNATIONAL FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 566795001,
    "dropphyadd": "15 18TH ST E",
    "dropphycty": "SOUTH INTERNATIONAL FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 566795001,
    "dropmaladd": "15 18TH ST E",
    "dropmalcty": "SOUTH INTERNATIONAL FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 566795001,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 2182838470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018355",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "613 BIG BEND RD",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "MO",
    "dropdelzpp": 630219998,
    "dropphyadd": "613 BIG BEND RD",
    "dropphycty": "MANCHESTER",
    "dropphyst": "MO",
    "dropphyzpp": 630219998,
    "dropmaladd": "613 BIG BEND RD",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "MO",
    "dropmalzpp": 630219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362071013,
    "dropsitcph": 6362071013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018370",
    "droptype": "D",
    "dropname": "SINGER ISLAND",
    "dropdeladd": "2505 OCEAN AVE",
    "dropdelcty": "RIVIERA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334049991,
    "dropphyadd": "2505 OCEAN AVE",
    "dropphycty": "RIVIERA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334049991,
    "dropmaladd": "2505 OCEAN AVE",
    "dropmalcty": "RIVIERA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334049991,
    "dropsitphn": 5618411920,
    "dropsitlph": 5618411920,
    "dropsitcph": 5618411920,
    "dropfax": 5618639531
  },
  {
    "dcode": "D",
    "dropkey": "B018375",
    "droptype": "D",
    "dropname": "CAREFREE",
    "dropdeladd": "100 EASY ST",
    "dropdelcty": "CAREFREE",
    "dropdelst": "AZ",
    "dropdelzpp": 853779998,
    "dropphyadd": "100 EASY ST",
    "dropphycty": "CAREFREE",
    "dropphyst": "AZ",
    "dropphyzpp": 853779998,
    "dropmaladd": "100 EASY ST",
    "dropmalcty": "CAREFREE",
    "dropmalst": "AZ",
    "dropmalzpp": 853779998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4805959598,
    "dropsitcph": 4804883781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018637",
    "droptype": "D",
    "dropname": "OCEAN VIEW",
    "dropdeladd": "92-8678 LOTUS BLOSSOM LN STE 4",
    "dropdelcty": "OCEAN VIEW",
    "dropdelst": "HI",
    "dropdelzpp": 967379996,
    "dropphyadd": "92-8678 LOTUS BLOSSOM LN STE 4",
    "dropphycty": "OCEAN VIEW",
    "dropphyst": "HI",
    "dropphyzpp": 967379996,
    "dropmaladd": "PO BOX 379998",
    "dropmalcty": "OCEAN VIEW",
    "dropmalst": "HI",
    "dropmalzpp": 967379998,
    "dropsitphn": "",
    "dropsitlph": 8084233844,
    "dropsitcph": 8089297141,
    "dropfax": 8089299609
  },
  {
    "dcode": "D",
    "dropkey": "B018643",
    "droptype": "D",
    "dropname": "LAUREL SPRINGS",
    "dropdeladd": "1468 BLACKWOOD CLEMENTON RD STE 650",
    "dropdelcty": "CLEMENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080219995",
    "dropphyadd": "1468 BLACKWOOD CLEMENTON RD STE 650",
    "dropphycty": "CLEMENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080219995",
    "dropmaladd": "1468 BLACKWOOD CLEMENTON RD STE 650",
    "dropmalcty": "CLEMENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080219995",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567831263,
    "dropsitcph": 8567831289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018837",
    "droptype": "D",
    "dropname": "FOSTER CITY",
    "dropdeladd": "750 ALMA LN STE 100",
    "dropdelcty": "FOSTER CITY",
    "dropdelst": "CA",
    "dropdelzpp": 944042598,
    "dropphyadd": "750 ALMA LN STE 100",
    "dropphycty": "FOSTER CITY",
    "dropphyst": "CA",
    "dropphyzpp": 944042598,
    "dropmaladd": "750 ALMA LN STE 100",
    "dropmalcty": "FOSTER CITY",
    "dropmalst": "CA",
    "dropmalzpp": 944042598,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503588482,
    "dropsitcph": 6503588490,
    "dropfax": 6503499726
  },
  {
    "dcode": "D",
    "dropkey": "B018881",
    "droptype": "D",
    "dropname": "BRICKELL",
    "dropdeladd": "1100 BRICKELL BAY DR STE 113",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331319996,
    "dropphyadd": "1100 BRICKELL BAY DR STE 113",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331319996,
    "dropmaladd": "1100 BRICKELL BAY DR STE 113",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331319996,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053717099,
    "dropsitcph": 3053737562,
    "dropfax": 3053799294
  },
  {
    "dcode": "D",
    "dropkey": "B018933",
    "droptype": "D",
    "dropname": "NORTH CANTON",
    "dropdeladd": "2201 E MAPLE ST",
    "dropdelcty": "NORTH CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447209997,
    "dropphyadd": "2201 E MAPLE ST",
    "dropphycty": "NORTH CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447209997,
    "dropmaladd": "2201 E MAPLE ST",
    "dropmalcty": "NORTH CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447209997,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304940444,
    "dropfax": 3302661617
  },
  {
    "dcode": "D",
    "dropkey": "B018937",
    "droptype": "D",
    "dropname": "WHITEMAN AIR FORCE BASE",
    "dropdeladd": "750 ARNOLD AVE RM 184",
    "dropdelcty": "WHITEMAN AIR FORCE BASE",
    "dropdelst": "MO",
    "dropdelzpp": 653055305,
    "dropphyadd": "750 ARNOLD AVE RM 184",
    "dropphycty": "WHITEMAN AIR FORCE BASE",
    "dropphyst": "MO",
    "dropphyzpp": 653055305,
    "dropmaladd": "750 ARNOLD AVE RM 184",
    "dropmalcty": "WHITEMAN AIR FORCE BASE",
    "dropmalst": "MO",
    "dropmalzpp": 653055305,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606875100,
    "dropsitcph": 6606875100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018938",
    "droptype": "D",
    "dropname": "LOUISIANA RETAIL",
    "dropdeladd": "7200 MONTGOMERY BLVD NE STE B11",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871091555,
    "dropphyadd": "7200 MONTGOMERY BLVD NE STE B11",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871091555,
    "dropmaladd": "7200 MONTGOMERY BLVD NE STE B11",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871091555,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461233,
    "dropsitcph": 5058810459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018976",
    "droptype": "D",
    "dropname": "EAST PALO ALTO",
    "dropdeladd": "1765 E BAYSHORE RD STE E",
    "dropdelcty": "EAST PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943035502,
    "dropphyadd": "1765 E BAYSHORE RD STE E",
    "dropphycty": "EAST PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943035502,
    "dropmaladd": "1765 E BAYSHORE RD STE E",
    "dropmalcty": "EAST PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943035502,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503280727,
    "dropsitcph": 6503211423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B018987",
    "droptype": "D",
    "dropname": "PISECO",
    "dropdeladd": "402 OLD PISECO RD",
    "dropdelcty": "PISECO",
    "dropdelst": "NY",
    "dropdelzpp": 121399998,
    "dropphyadd": "402 OLD PISECO RD",
    "dropphycty": "PISECO",
    "dropphyst": "NY",
    "dropphyzpp": 121399998,
    "dropmaladd": "402 OLD PISECO RD",
    "dropmalcty": "PISECO",
    "dropmalst": "NY",
    "dropmalzpp": 121399998,
    "dropsitphn": 5185485793,
    "dropsitlph": "",
    "dropsitcph": 5185485668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B019093",
    "droptype": "D",
    "dropname": "CARDIFF BY THE SEA",
    "dropdeladd": "135 LIVERPOOL DR STE A",
    "dropdelcty": "CARDIFF BY THE SEA",
    "dropdelst": "CA",
    "dropdelzpp": 920071843,
    "dropphyadd": "135 LIVERPOOL DR STE A",
    "dropphycty": "CARDIFF BY THE SEA",
    "dropphyst": "CA",
    "dropphyzpp": 920071843,
    "dropmaladd": "135 LIVERPOOL DR STE A",
    "dropmalcty": "CARDIFF BY THE SEA",
    "dropmalst": "CA",
    "dropmalzpp": 920071843,
    "dropsitphn": 8586740173,
    "dropsitlph": 7606349820,
    "dropsitcph": 7607531415,
    "dropfax": 7606349824
  },
  {
    "dcode": "D",
    "dropkey": "B019188",
    "droptype": "D",
    "dropname": "ALAMO HEIGHTS FINANCE UNIT",
    "dropdeladd": "1107 AUSTIN HWY",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782099800,
    "dropphyadd": "1107 AUSTIN HWY",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782099800,
    "dropmaladd": "1107 AUSTIN HWY",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782099800,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109305780,
    "dropsitcph": 2108264731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B019307",
    "droptype": "D",
    "dropname": "MOUNTAIN BROOK",
    "dropdeladd": "201 RELE ST",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352232592,
    "dropphyadd": "201 RELE ST",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352232592,
    "dropmaladd": "201 RELE ST",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352232592,
    "dropsitphn": 2055210367,
    "dropsitlph": 2058689204,
    "dropsitcph": 2058035041,
    "dropfax": 2058713501
  },
  {
    "dcode": "D",
    "dropkey": "B019740",
    "droptype": "D",
    "dropname": "PAPILLION LAVISTA RETAIL",
    "dropdeladd": "10717 VIRGINIA PLZ STE 119",
    "dropdelcty": "LA VISTA",
    "dropdelst": "NE",
    "dropdelzpp": 681284203,
    "dropphyadd": "10717 VIRGINIA PLZ STE 119",
    "dropphycty": "LA VISTA",
    "dropphyst": "NE",
    "dropphyzpp": 681284203,
    "dropmaladd": "10717 VIRGINIA PLZ STE 119",
    "dropmalcty": "LA VISTA",
    "dropmalst": "NE",
    "dropmalzpp": 681284203,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023314989,
    "dropsitcph": 4023314978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B020024",
    "droptype": "D",
    "dropname": "CAPE CORAL NORTH",
    "dropdeladd": "1441 SW 4TH ST",
    "dropdelcty": "CAPE CORAL",
    "dropdelst": "FL",
    "dropdelzpp": 339919990,
    "dropphyadd": "1441 SW 4TH ST",
    "dropphycty": "CAPE CORAL",
    "dropphyst": "FL",
    "dropphyzpp": 339919990,
    "dropmaladd": "1441 SW 4TH ST",
    "dropmalcty": "CAPE CORAL",
    "dropmalst": "FL",
    "dropmalzpp": 339919990,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2395993338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B020199",
    "droptype": "D",
    "dropname": "FORT DRUM NEW",
    "dropdeladd": "10720 MOUNT BELVEDERE BLVD",
    "dropdelcty": "FORT DRUM",
    "dropdelst": "NY",
    "dropdelzpp": 136029998,
    "dropphyadd": "10720 MOUNT BELVEDERE BLVD",
    "dropphycty": "FORT DRUM",
    "dropphyst": "NY",
    "dropphyzpp": 136029998,
    "dropmaladd": "10720 MOUNT BELVEDERE BLVD",
    "dropmalcty": "FORT DRUM",
    "dropmalst": "NY",
    "dropmalzpp": 136029998,
    "dropsitphn": 3157725220,
    "dropsitlph": "",
    "dropsitcph": 3157725220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B020213",
    "droptype": "D",
    "dropname": "CAPARRA HEIGHTS",
    "dropdeladd": "1498 AVE FD ROOSEVELT STE 5B",
    "dropdelcty": "GUAYNABO",
    "dropdelst": "PR",
    "dropdelzpp": "009689997",
    "dropphyadd": "1498 AVE FD ROOSEVELT STE 5B",
    "dropphycty": "GUAYNABO",
    "dropphyst": "PR",
    "dropphyzpp": "009689997",
    "dropmaladd": "1498 AVE FD ROOSEVELT STE 5B",
    "dropmalcty": "GUAYNABO",
    "dropmalst": "PR",
    "dropmalzpp": "009689997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7877936187,
    "dropsitcph": 7877936187,
    "dropfax": 7872770887
  },
  {
    "dcode": "D",
    "dropkey": "B020883",
    "droptype": "D",
    "dropname": "COMMUNITY NEW",
    "dropdeladd": "2923 E LEE AVE",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223061721,
    "dropphyadd": "2923 E LEE AVE",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223061721,
    "dropmaladd": "2923 E LEE AVE",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223061721,
    "dropsitphn": 7036986367,
    "dropsitlph": "",
    "dropsitcph": 7037651350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B020911",
    "droptype": "D",
    "dropname": "GOLDEN ISLES NEW",
    "dropdeladd": "800 E HALLANDALE BEACH BLVD STE 23",
    "dropdelcty": "HALLANDALE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330099997,
    "dropphyadd": "800 E HALLANDALE BEACH BLVD STE 23",
    "dropphycty": "HALLANDALE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330099997,
    "dropmaladd": "800 E HALLANDALE BEACH BLVD STE 23",
    "dropmalcty": "HALLANDALE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330099997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544553365,
    "dropsitcph": 9544550493,
    "dropfax": 3055132368
  },
  {
    "dcode": "D",
    "dropkey": "B020942",
    "droptype": "D",
    "dropname": "MELROSE VISTA NEW",
    "dropdeladd": "3945 W BROWARD BLVD",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333129996,
    "dropphyadd": "3945 W BROWARD BLVD",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333129996,
    "dropmaladd": "3945 W BROWARD BLVD",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333129996,
    "dropsitphn": 3055132368,
    "dropsitlph": 9543168052,
    "dropsitcph": 9543168052,
    "dropfax": 9543169342
  },
  {
    "dcode": "D",
    "dropkey": "B021017",
    "droptype": "D",
    "dropname": "MONONA  NEW",
    "dropdeladd": "105 RIVER PL",
    "dropdelcty": "MONONA",
    "dropdelst": "WI",
    "dropdelzpp": 537169900,
    "dropphyadd": "105 RIVER PL",
    "dropphycty": "MONONA",
    "dropphyst": "WI",
    "dropphyzpp": 537169900,
    "dropmaladd": "105 RIVER PL",
    "dropmalcty": "MONONA",
    "dropmalst": "WI",
    "dropmalzpp": 537169900,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082227776,
    "dropsitcph": 6082228184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "B021260",
    "droptype": "D",
    "dropname": "PEAKS ISLAND",
    "dropdeladd": "70 ISLAND AVE",
    "dropdelcty": "PEAKS ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041089997",
    "dropphyadd": "70 ISLAND AVE",
    "dropphycty": "PEAKS ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041089997",
    "dropmaladd": "70 ISLAND AVE",
    "dropmalcty": "PEAKS ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041089997",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077662912,
    "dropsitcph": 2077662912,
    "dropfax": 2077662912
  },
  {
    "dcode": "D",
    "dropkey": "CV11916",
    "droptype": "D",
    "dropname": "ANNANDALE ON HUDSON",
    "dropdeladd": "30 CAMPUS RD",
    "dropdelcty": "ANNANDALE ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 125049800,
    "dropphyadd": "30 CAMPUS RD",
    "dropphycty": "ANNANDALE ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 125049800,
    "dropmaladd": "7525 N BROADWAY",
    "dropmalcty": "RED HOOK",
    "dropmalst": "NY",
    "dropmalzpp": 125719998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8457585361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV12253",
    "droptype": "D",
    "dropname": "BRANTINGHAM",
    "dropdeladd": "5508 PARTRIDGEVILLE RD",
    "dropdelcty": "BRANTINGHAM",
    "dropdelst": "NY",
    "dropdelzpp": 133129997,
    "dropphyadd": "5508 PARTRIDGEVILLE RD",
    "dropphycty": "BRANTINGHAM",
    "dropphyst": "NY",
    "dropphyzpp": 133129997,
    "dropmaladd": "6036 MAIN ST",
    "dropmalcty": "GLENFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 133439998,
    "dropsitphn": "",
    "dropsitlph": 3153484090,
    "dropsitcph": 3153484090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV12560",
    "droptype": "D",
    "dropname": "CHERRY GROVE",
    "dropdeladd": "1000 BAY WALK",
    "dropdelcty": "CHERRY GROVE",
    "dropdelst": "NY",
    "dropdelzpp": 117829007,
    "dropphyadd": "1000 BAY WALK",
    "dropphycty": "CHERRY GROVE",
    "dropphyst": "NY",
    "dropphyzpp": 117829007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117829998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315891177,
    "dropfax": 6315894571
  },
  {
    "dcode": "D",
    "dropkey": "CV12875",
    "droptype": "D",
    "dropname": "DAVIS PARK",
    "dropdeladd": "1 MAIN WALK",
    "dropdelcty": "DAVIS PARK",
    "dropdelst": "NY",
    "dropdelzpp": 117729995,
    "dropphyadd": "1 MAIN WALK",
    "dropphycty": "DAVIS PARK",
    "dropphyst": "NY",
    "dropphyzpp": 117729995,
    "dropmaladd": "1 MAIN WALK",
    "dropmalcty": "DAVIS PARK",
    "dropmalst": "NY",
    "dropmalzpp": 117729995,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314750587,
    "dropfax": 6317552599
  },
  {
    "dcode": "D",
    "dropkey": "CV13323",
    "droptype": "D",
    "dropname": "FIRE ISLAND PINES",
    "dropdeladd": "1 FIRE ISLAND BLVD",
    "dropdelcty": "FIRE ISLAND PINES",
    "dropdelst": "NY",
    "dropdelzpp": 117829006,
    "dropphyadd": "1 FIRE ISLAND BLVD",
    "dropphycty": "FIRE ISLAND PINES",
    "dropphyst": "NY",
    "dropphyzpp": 117829006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117829998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315891177,
    "dropfax": 6315894571
  },
  {
    "dcode": "D",
    "dropkey": "CV13462",
    "droptype": "D",
    "dropname": "FRONTENAC",
    "dropdeladd": "15749 ROUND IS",
    "dropdelcty": "FRONTENAC",
    "dropdelst": "NY",
    "dropdelzpp": 136242017,
    "dropphyadd": "15749 ROUND IS",
    "dropphycty": "FRONTENAC",
    "dropphyst": "NY",
    "dropphyzpp": 136242017,
    "dropmaladd": "236 JOHN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 136249998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3156863311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV13674",
    "droptype": "D",
    "dropname": "GRENELL",
    "dropdeladd": "16498 GRENELL IS",
    "dropdelcty": "GRENELL",
    "dropdelst": "NY",
    "dropdelzpp": 136242007,
    "dropphyadd": "16498 GRENELL IS",
    "dropphycty": "GRENELL",
    "dropphyst": "NY",
    "dropphyzpp": 136242007,
    "dropmaladd": "236 JOHN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 136249998,
    "dropsitphn": 3156863311,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156863311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV14821",
    "droptype": "D",
    "dropname": "MURRAY ISLE",
    "dropdeladd": "42650 MURRAY IS",
    "dropdelcty": "MURRAY ISLE",
    "dropdelst": "NY",
    "dropdelzpp": 136242027,
    "dropphyadd": "42650 MURRAY IS",
    "dropphycty": "MURRAY ISLE",
    "dropphyst": "NY",
    "dropphyzpp": 136242027,
    "dropmaladd": "236 JOHN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 136249998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3156863311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV15919",
    "droptype": "D",
    "dropname": "SALTAIRE",
    "dropdeladd": "1 POMANDER WALK",
    "dropdelcty": "SALTAIRE",
    "dropdelst": "NY",
    "dropdelzpp": 117068960,
    "dropphyadd": "1 POMANDER WALK",
    "dropphycty": "SALTAIRE",
    "dropphyst": "NY",
    "dropphyzpp": 117068960,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY SHORE",
    "dropmalst": "NY",
    "dropmalzpp": 117069998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316652535,
    "dropfax": 6317552599
  },
  {
    "dcode": "D",
    "dropkey": "CV16960",
    "droptype": "D",
    "dropname": "WESTBROOKVILLE",
    "dropdeladd": "1755 STATE ROUTE 209",
    "dropdelcty": "WESTBROOKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127859800,
    "dropphyadd": "1755 STATE ROUTE 209",
    "dropphycty": "WESTBROOKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127859800,
    "dropmaladd": "20 SUSSEX ST",
    "dropmalcty": "PORT JERVIS",
    "dropmalst": "NY",
    "dropmalzpp": 127719998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457547116,
    "dropsitcph": 8457547116,
    "dropfax": 8457547116
  },
  {
    "dcode": "D",
    "dropkey": "CV17061",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "654 SARATOGA RD STE 2",
    "dropdelcty": "GANSEVOORT",
    "dropdelst": "NY",
    "dropdelzpp": 128312808,
    "dropphyadd": "654 SARATOGA RD STE 2",
    "dropphycty": "GANSEVOORT",
    "dropphyst": "NY",
    "dropphyzpp": 128312808,
    "dropmaladd": "50 LEONARD ST",
    "dropmalcty": "GANSEVOORT",
    "dropmalst": "NY",
    "dropmalzpp": 128319998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5187928777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV18890",
    "droptype": "D",
    "dropname": "DEER RIVER",
    "dropdeladd": "10734 STATE ROUTE 126",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "NY",
    "dropdelzpp": 136199800,
    "dropphyadd": "10734 STATE ROUTE 26",
    "dropphycty": "CARTHAGE",
    "dropphyst": "NY",
    "dropphyzpp": 136193214,
    "dropmaladd": "9886 STATE ROUTE 12",
    "dropmalcty": "COPENHAGEN",
    "dropmalst": "NY",
    "dropmalzpp": 136269998,
    "dropsitphn": "",
    "dropsitlph": 3156882920,
    "dropsitcph": 3156882920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV19472",
    "droptype": "D",
    "dropname": "BOVINA CENTER",
    "dropdeladd": "1866 COUNTY HIGHWAY 6",
    "dropdelcty": "BOVINA CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 137409997,
    "dropphyadd": "1866 COUNTY HIGHWAY 6",
    "dropphycty": "BOVINA CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 137409997,
    "dropmaladd": "204 LOWER MAIN ST",
    "dropmalcty": "ANDES",
    "dropmalst": "NY",
    "dropmalzpp": 137319998,
    "dropsitphn": 8456763211,
    "dropsitlph": 6078324453,
    "dropsitcph": 6078324453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV19828",
    "droptype": "D",
    "dropname": "STELLA NIAGARA",
    "dropdeladd": "4421 LOWER RIVER RD",
    "dropdelcty": "STELLA NIAGARA",
    "dropdelst": "NY",
    "dropdelzpp": 141449998,
    "dropphyadd": "4421 LOWER RIVER RD",
    "dropphycty": "STELLA NIAGARA",
    "dropphyst": "NY",
    "dropphyzpp": 141449998,
    "dropmaladd": "4421 LOWER RIVER RD",
    "dropmalcty": "STELLA NIAGARA",
    "dropmalst": "NY",
    "dropmalzpp": 141449998,
    "dropsitphn": "",
    "dropsitlph": 7168462415,
    "dropsitcph": 7167544311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV19974",
    "droptype": "D",
    "dropname": "MOTTVILLE",
    "dropdeladd": "873 CROW HILL RD",
    "dropdelcty": "MOTTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 131199998,
    "dropphyadd": "873 CROW HILL RD",
    "dropphycty": "MOTTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 131199998,
    "dropmaladd": "873 CROW HILL RD",
    "dropmalcty": "MOTTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 131199998,
    "dropsitphn": "",
    "dropsitlph": 3156856934,
    "dropsitcph": 3156856934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV21860",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "37 COREY RD",
    "dropdelcty": "HANCOCK",
    "dropdelst": "MA",
    "dropdelzpp": "012379525",
    "dropphyadd": "37 COREY RD",
    "dropphycty": "HANCOCK",
    "dropphyst": "MA",
    "dropphyzpp": "012379525",
    "dropmaladd": "37 COREY RD",
    "dropmalcty": "HANCOCK",
    "dropmalst": "MA",
    "dropmalzpp": "012379525",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137385066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV21887",
    "droptype": "D",
    "dropname": "HEATH",
    "dropdeladd": "1 E MAIN ST",
    "dropdelcty": "HEATH",
    "dropdelst": "MA",
    "dropdelzpp": "013469998",
    "dropphyadd": "1 E MAIN ST",
    "dropphycty": "HEATH",
    "dropphyst": "MA",
    "dropphyzpp": "013469998",
    "dropmaladd": "1 E MAIN ST",
    "dropmalcty": "HEATH",
    "dropmalst": "MA",
    "dropmalzpp": "013469998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133374934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV22161",
    "droptype": "D",
    "dropname": "NEW SALEM",
    "dropdeladd": "410 DANIEL SHAYS HWY",
    "dropdelcty": "NEW SALEM",
    "dropdelst": "MA",
    "dropdelzpp": "013559531",
    "dropphyadd": "410 DANIEL SHAYS HWY",
    "dropphycty": "NEW SALEM",
    "dropphyst": "MA",
    "dropphyzpp": "013559531",
    "dropmaladd": "410 DANIEL SHAYS HWY",
    "dropmalcty": "NEW SALEM",
    "dropmalst": "MA",
    "dropmalzpp": "013559507",
    "dropsitphn": 4137856420,
    "dropsitlph": 9785446595,
    "dropsitcph": 9785446595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV22372",
    "droptype": "D",
    "dropname": "ROYALSTON",
    "dropdeladd": "1 ATHOL RD",
    "dropdelcty": "ROYALSTON",
    "dropdelst": "MA",
    "dropdelzpp": "013689998",
    "dropphyadd": "1 ATHOL RD",
    "dropphycty": "ROYALSTON",
    "dropphyst": "MA",
    "dropphyzpp": "013689998",
    "dropmaladd": "1 ATHOL RD",
    "dropmalcty": "ROYALSTON",
    "dropmalst": "MA",
    "dropmalzpp": "013689998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 5082497577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV22665",
    "droptype": "D",
    "dropname": "TYRINGHAM",
    "dropdeladd": "118 MAIN RD",
    "dropdelcty": "TYRINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "012649998",
    "dropphyadd": "118 MAIN RD",
    "dropphycty": "TYRINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "012649998",
    "dropmaladd": "118 MAIN RD",
    "dropmalcty": "TYRINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "012649998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132431225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV24365",
    "droptype": "D",
    "dropname": "SHERWOOD FOREST",
    "dropdeladd": "132 SHERWOOD FOREST RD",
    "dropdelcty": "SHERWOOD FOREST",
    "dropdelst": "MD",
    "dropdelzpp": 214052028,
    "dropphyadd": "132 SHERWOOD FOREST RD",
    "dropphycty": "SHERWOOD FOREST",
    "dropphyst": "MD",
    "dropphyzpp": 214052028,
    "dropmaladd": "132 SHERWOOD FOREST RD",
    "dropmalcty": "SHERWOOD FOREST",
    "dropmalst": "MD",
    "dropmalzpp": 214052028,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108410071,
    "dropsitcph": 4108410071,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "CV25048",
    "droptype": "D",
    "dropname": "NEW LIMERICK",
    "dropdeladd": "1132 COUNTY RD",
    "dropdelcty": "NEW LIMERICK",
    "dropdelst": "ME",
    "dropdelzpp": "047616016",
    "dropphyadd": "1132 COUNTY RD",
    "dropphycty": "NEW LIMERICK",
    "dropphyst": "ME",
    "dropphyzpp": "047616016",
    "dropmaladd": "1132 COUNTY RD",
    "dropmalcty": "NEW LIMERICK",
    "dropmalst": "ME",
    "dropmalzpp": "047616016",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075322872,
    "dropsitcph": 2075322083,
    "dropfax": 2075327489
  },
  {
    "dcode": "D",
    "dropkey": "CV25087",
    "droptype": "D",
    "dropname": "OCEAN PARK",
    "dropdeladd": "15 COLBY AVE",
    "dropdelcty": "OCEAN PARK",
    "dropdelst": "ME",
    "dropdelzpp": "040639998",
    "dropphyadd": "15 COLBY AVE",
    "dropphycty": "OCEAN PARK",
    "dropphyst": "ME",
    "dropphyzpp": "040639998",
    "dropmaladd": "15 COLBY AVE",
    "dropmalcty": "OCEAN PARK",
    "dropmalst": "ME",
    "dropmalzpp": "040639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079344401,
    "dropsitcph": 2079341627,
    "dropfax": 2079342823
  },
  {
    "dcode": "D",
    "dropkey": "CV25363",
    "droptype": "D",
    "dropname": "BRETTON WOODS",
    "dropdeladd": "310 MOUNT WASHINGTON HOTEL RD UNIT 1",
    "dropdelcty": "BRETTON WOODS",
    "dropdelst": "NH",
    "dropdelzpp": "035753099",
    "dropphyadd": "310 MOUNT WASHINGTON HOTEL RD UNIT 1",
    "dropphycty": "BRETTON WOODS",
    "dropphyst": "NH",
    "dropphyzpp": "035753099",
    "dropmaladd": "310 MOUNT WASHINGTON HOTEL RD UNIT 1",
    "dropmalcty": "BRETTON WOODS",
    "dropmalst": "NH",
    "dropmalzpp": "035753099",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038465570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV25385",
    "droptype": "D",
    "dropname": "CENTER TUFTONBORO",
    "dropdeladd": "150 MIDDLE RD",
    "dropdelcty": "CENTER TUFTONBORO",
    "dropdelst": "NH",
    "dropdelzpp": "038169997",
    "dropphyadd": "150 MIDDLE RD",
    "dropphycty": "CENTER TUFTONBORO",
    "dropphyst": "NH",
    "dropphyzpp": "038169997",
    "dropmaladd": "150 MIDDLE RD",
    "dropmalcty": "CENTER TUFTONBORO",
    "dropmalst": "NH",
    "dropmalzpp": "038169997",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035692375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV25462",
    "droptype": "D",
    "dropname": "EATON CENTER",
    "dropdeladd": "2316 EATON RD UNIT 1",
    "dropdelcty": "EATON CENTER",
    "dropdelst": "NH",
    "dropdelzpp": "038329997",
    "dropphyadd": "2316 EATON RD UNIT 1",
    "dropphycty": "EATON CENTER",
    "dropphyst": "NH",
    "dropphyzpp": "038329997",
    "dropmaladd": "1904 VILLAGE RD",
    "dropmalcty": "MADISON",
    "dropmalst": "NH",
    "dropmalzpp": "038499998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034472403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV25595",
    "droptype": "D",
    "dropname": "MOUNT WASHINGTON",
    "dropdeladd": "3168 BASE STATION RD UNIT 1",
    "dropdelcty": "MOUNT WASHINGTON",
    "dropdelst": "NH",
    "dropdelzpp": "035894099",
    "dropphyadd": "3168 BASE STATION RD UNIT 1",
    "dropphycty": "MOUNT WASHINGTON",
    "dropphyst": "NH",
    "dropphyzpp": "035894099",
    "dropmaladd": "3168 BASE STATION RD UNIT 1",
    "dropmalcty": "MOUNT WASHINGTON",
    "dropmalst": "NH",
    "dropmalzpp": "035894099",
    "dropsitphn": 6036444128,
    "dropsitlph": 6038465570,
    "dropsitcph": 6038465570,
    "dropfax": 6036444174
  },
  {
    "dcode": "D",
    "dropkey": "CV25888",
    "droptype": "D",
    "dropname": "GREENE",
    "dropdeladd": "25 OLD SUMMIT RD",
    "dropdelcty": "GREENE",
    "dropdelst": "RI",
    "dropdelzpp": "028271716",
    "dropphyadd": "25 OLD SUMMIT RD",
    "dropphycty": "GREENE",
    "dropphyst": "RI",
    "dropphyzpp": "028271716",
    "dropmaladd": "25 OLD SUMMIT RD",
    "dropmalcty": "GREENE",
    "dropmalst": "RI",
    "dropmalzpp": "028271716",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013973366,
    "dropfax": 4018268110
  },
  {
    "dcode": "D",
    "dropkey": "CV25938",
    "droptype": "D",
    "dropname": "PRUDENCE ISLAND",
    "dropdeladd": "837 NARRAGANSETT AVE",
    "dropdelcty": "PRUDENCE ISLAND",
    "dropdelst": "RI",
    "dropdelzpp": "028729900",
    "dropphyadd": "837 NARRAGANSETT AVE",
    "dropphycty": "PRUDENCE ISLAND",
    "dropphyst": "RI",
    "dropphyzpp": "028729900",
    "dropmaladd": "837 NARRAGANSETT AVE",
    "dropmalcty": "PRUDENCE ISLAND",
    "dropmalst": "RI",
    "dropmalzpp": "028729900",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016835785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV26540",
    "droptype": "D",
    "dropname": "JERICHO CENTER",
    "dropdeladd": "25 JERICHO CENTER CIR",
    "dropdelcty": "JERICHO",
    "dropdelst": "VT",
    "dropdelzpp": "054652602",
    "dropphyadd": "25 JERICHO CENTER CIR",
    "dropphycty": "JERICHO",
    "dropphyst": "VT",
    "dropphyzpp": "054652602",
    "dropmaladd": "25 JERICHO CENTER CIR",
    "dropmalcty": "JERICHO",
    "dropmalst": "VT",
    "dropmalzpp": "054652602",
    "dropsitphn": "",
    "dropsitlph": 8028993202,
    "dropsitcph": 8028993313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV26568",
    "droptype": "D",
    "dropname": "LAKE ELMORE",
    "dropdeladd": "1208 VT ROUTE 12",
    "dropdelcty": "LAKE ELMORE",
    "dropdelst": "VT",
    "dropdelzpp": "056579998",
    "dropphyadd": "1208 VT ROUTE 12",
    "dropphycty": "LAKE ELMORE",
    "dropphyst": "VT",
    "dropphyzpp": "056579998",
    "dropmaladd": "1208 VT ROUTE 12",
    "dropmalcty": "LAKE ELMORE",
    "dropmalst": "VT",
    "dropmalzpp": "056579998",
    "dropsitphn": "",
    "dropsitlph": 8028883557,
    "dropsitcph": 8028882296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV27250",
    "droptype": "D",
    "dropname": "WEST TOWNSHEND",
    "dropdeladd": "6573 VT ROUTE 30",
    "dropdelcty": "WEST TOWNSHEND",
    "dropdelst": "VT",
    "dropdelzpp": "053599998",
    "dropphyadd": "6573 VT ROUTE 30",
    "dropphycty": "WEST TOWNSHEND",
    "dropphyst": "VT",
    "dropphyzpp": "053599998",
    "dropmaladd": "6573 VT ROUTE 30",
    "dropmalcty": "WEST TOWNSHEND",
    "dropmalst": "VT",
    "dropmalzpp": "053599998",
    "dropsitphn": "",
    "dropsitlph": 8023657765,
    "dropsitcph": 8028747092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CV28254",
    "droptype": "D",
    "dropname": "STODDARD",
    "dropdeladd": "984 ROUTE 123 N",
    "dropdelcty": "STODDARD",
    "dropdelst": "NH",
    "dropdelzpp": "034644164",
    "dropphyadd": "984 ROUTE 123 N",
    "dropphycty": "STODDARD",
    "dropphyst": "NH",
    "dropphyzpp": "034644164",
    "dropmaladd": "984 ROUTE 123 N",
    "dropmalcty": "STODDARD",
    "dropmalst": "NH",
    "dropmalzpp": "034644164",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034462282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A258",
    "droptype": "D",
    "dropname": "SPARKS",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "SPARKS",
    "dropdelst": "NE",
    "dropdelzpp": 692209720,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "SPARKS",
    "dropphyst": "NE",
    "dropphyzpp": 692209720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPARKS",
    "dropmalst": "NE",
    "dropmalzpp": 692209998,
    "dropsitphn": 4023482871,
    "dropsitlph": 4023482606,
    "dropsitcph": 4023761540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A442",
    "droptype": "D",
    "dropname": "WINNETOON",
    "dropdeladd": "312 MAIN AVE",
    "dropdelcty": "WINNETOON",
    "dropdelst": "NE",
    "dropdelzpp": 687897013,
    "dropphyadd": "312 MAIN AVE",
    "dropphycty": "WINNETOON",
    "dropphyst": "NE",
    "dropphyzpp": 687897013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNETOON",
    "dropmalst": "NE",
    "dropmalzpp": 687899998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4028473368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A465",
    "droptype": "D",
    "dropname": "AGENCY VILLAGE",
    "dropdeladd": "12554 BIA HIGHWAY 711 STE 272",
    "dropdelcty": "AGENCY VILLAGE",
    "dropdelst": "SD",
    "dropdelzpp": 572627409,
    "dropphyadd": "12554 BIA HIGHWAY 711 STE 272",
    "dropphycty": "AGENCY VILLAGE",
    "dropphyst": "SD",
    "dropphyzpp": 572627409,
    "dropmaladd": "12554 BIA HIGHWAY 711 STE 272",
    "dropmalcty": "AGENCY VILLAGE",
    "dropmalst": "SD",
    "dropmalzpp": 572627409,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6056983413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A621",
    "droptype": "D",
    "dropname": "CRAZY HORSE",
    "dropdeladd": "12151 AVENUE OF THE CHIEFS",
    "dropdelcty": "CRAZY HORSE",
    "dropdelst": "SD",
    "dropdelzpp": 577308900,
    "dropphyadd": "12151 AVENUE OF THE CHIEFS",
    "dropphycty": "CRAZY HORSE",
    "dropphyst": "SD",
    "dropphyzpp": 577308900,
    "dropmaladd": "12151 AVENUE OF THE CHIEFS",
    "dropmalcty": "CRAZY HORSE",
    "dropmalst": "SD",
    "dropmalzpp": 577308900,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056734681,
    "dropsitcph": 6056734681,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "CW1A692",
    "droptype": "D",
    "dropname": "FERNEY",
    "dropdeladd": "109 CENTER ST",
    "dropdelcty": "FERNEY",
    "dropdelst": "SD",
    "dropdelzpp": 574399998,
    "dropphyadd": "109 CENTER ST",
    "dropphycty": "FERNEY",
    "dropphyst": "SD",
    "dropphyzpp": 574399998,
    "dropmaladd": "109 CENTER ST",
    "dropmalcty": "FERNEY",
    "dropmalst": "SD",
    "dropmalzpp": 574399998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6053972707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A847",
    "droptype": "D",
    "dropname": "LABOLT",
    "dropdeladd": "109 MAIN ST",
    "dropdelcty": "LABOLT",
    "dropdelst": "SD",
    "dropdelzpp": 572469998,
    "dropphyadd": "109 MAIN ST",
    "dropphycty": "LABOLT",
    "dropphyst": "SD",
    "dropphyzpp": 572469998,
    "dropmaladd": "109 MAIN ST",
    "dropmalcty": "LABOLT",
    "dropmalst": "SD",
    "dropmalzpp": 572469998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6054326531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A864",
    "droptype": "D",
    "dropname": "LANE",
    "dropdeladd": "219 OAK AVE",
    "dropdelcty": "LANE",
    "dropdelst": "SD",
    "dropdelzpp": 573589998,
    "dropphyadd": "219 OAK AVE",
    "dropphycty": "LANE",
    "dropphyst": "SD",
    "dropphyzpp": 573589998,
    "dropmaladd": "219 OAK AVE",
    "dropmalcty": "LANE",
    "dropmalst": "SD",
    "dropmalzpp": 573589998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6057964495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1A997",
    "droptype": "D",
    "dropname": "ORTLEY",
    "dropdeladd": "114 NEW MAIN ST",
    "dropdelcty": "ORTLEY",
    "dropdelst": "SD",
    "dropdelzpp": 572569998,
    "dropphyadd": "100 NEW MAIN ST",
    "dropphycty": "ORTLEY",
    "dropphyst": "SD",
    "dropphyzpp": 572562119,
    "dropmaladd": "100 NEW MAIN ST",
    "dropmalcty": "ORTLEY",
    "dropmalst": "SD",
    "dropmalzpp": 572562119,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059474262,
    "dropsitcph": 6059474262,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "CW1B171",
    "droptype": "D",
    "dropname": "STRANDBURG",
    "dropdeladd": "123 S MAIN",
    "dropdelcty": "STRANDBURG",
    "dropdelst": "SD",
    "dropdelzpp": 572659998,
    "dropphyadd": "123 S MAIN",
    "dropphycty": "STRANDBURG",
    "dropphyst": "SD",
    "dropphyzpp": 572659998,
    "dropmaladd": "123 S MAIN",
    "dropmalcty": "STRANDBURG",
    "dropmalst": "SD",
    "dropmalzpp": 572659998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6056762394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B295",
    "droptype": "D",
    "dropname": "ALADDIN",
    "dropdeladd": "3983 STATE HIGHWAY 24",
    "dropdelcty": "ALADDIN",
    "dropdelst": "WY",
    "dropdelzpp": 827109765,
    "dropphyadd": "3983 STATE HIGHWAY 24",
    "dropphycty": "ALADDIN",
    "dropphyst": "WY",
    "dropphyzpp": 827109765,
    "dropmaladd": "3983 STATE HIGHWAY 24",
    "dropmalcty": "ALADDIN",
    "dropmalst": "WY",
    "dropmalzpp": 827109765,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077726524,
    "dropsitcph": 3078962226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B299",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "102 US HIGHWAY 89",
    "dropdelcty": "ALPINE",
    "dropdelst": "WY",
    "dropdelzpp": 831289900,
    "dropphyadd": "102 US HIGHWAY 89",
    "dropphycty": "ALPINE",
    "dropphyst": "WY",
    "dropphyzpp": 831289900,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "ALPINE",
    "dropmalst": "WY",
    "dropmalzpp": 831289997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076547591,
    "dropsitcph": 3076547591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B313",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "4436 MAIN ST",
    "dropdelcty": "BEDFORD",
    "dropdelst": "WY",
    "dropdelzpp": 831129901,
    "dropphyadd": "4436 MAIN ST",
    "dropphycty": "BEDFORD",
    "dropphyst": "WY",
    "dropphyzpp": 831129901,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "BEDFORD",
    "dropmalst": "WY",
    "dropmalzpp": 831129997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078863625,
    "dropsitcph": 3078833706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B366",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "107857 N US HIGHWAY 89",
    "dropdelcty": "ETNA",
    "dropdelst": "WY",
    "dropdelzpp": 831189700,
    "dropphyadd": "107857 N US HIGHWAY 89",
    "dropphycty": "ETNA",
    "dropphyst": "WY",
    "dropphyzpp": 831189700,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "ETNA",
    "dropmalst": "WY",
    "dropmalzpp": 831189997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078832220,
    "dropsitcph": 3078832220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B494",
    "droptype": "D",
    "dropname": "POINT OF ROCKS",
    "dropdeladd": "7 HALTER AND FLICK ST",
    "dropdelcty": "POINT OF ROCKS",
    "dropdelst": "WY",
    "dropdelzpp": 829429900,
    "dropphyadd": "7 HALTER AND FLICK ST",
    "dropphycty": "POINT OF ROCKS",
    "dropphyst": "WY",
    "dropphyzpp": 829429900,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "POINT OF ROCKS",
    "dropmalst": "WY",
    "dropmalzpp": 829429997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073622094,
    "dropsitcph": 3073622094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B547",
    "droptype": "D",
    "dropname": "TETON VILLAGE",
    "dropdeladd": "3230 MCCOLLISTER DR",
    "dropdelcty": "TETON VILLAGE",
    "dropdelst": "WY",
    "dropdelzpp": 830259905,
    "dropphyadd": "3230 MCCOLLISTER DR",
    "dropphycty": "TETON VILLAGE",
    "dropphyst": "WY",
    "dropphyzpp": 830259905,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "TETON VILLAGE",
    "dropmalst": "WY",
    "dropmalzpp": 830259997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077333575,
    "dropsitcph": 3077333575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B578",
    "droptype": "D",
    "dropname": "WRIGHT",
    "dropdeladd": "105 WRIGHT BLVD STE A-108",
    "dropdelcty": "WRIGHT",
    "dropdelst": "WY",
    "dropdelzpp": 827329900,
    "dropphyadd": "105 WRIGHT BLVD STE A-108",
    "dropphycty": "WRIGHT",
    "dropphyst": "WY",
    "dropphyzpp": 827329900,
    "dropmaladd": "105 WRIGHT BLVD STE A-108",
    "dropmalcty": "WRIGHT",
    "dropmalst": "WY",
    "dropmalzpp": 827329900,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076892597,
    "dropsitcph": 3074641527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B636",
    "droptype": "D",
    "dropname": "WHITECLAY",
    "dropdeladd": "7883 STATE HIGHWAY 87",
    "dropdelcty": "WHITECLAY",
    "dropdelst": "NE",
    "dropdelzpp": 693654900,
    "dropphyadd": "7883 STATE HIGHWAY 87",
    "dropphycty": "WHITECLAY",
    "dropphyst": "NE",
    "dropphyzpp": 693654900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITECLAY",
    "dropmalst": "NE",
    "dropmalzpp": 693659998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3088624215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B639",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "215 2ND ST",
    "dropdelcty": "LINWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 680363122,
    "dropphyadd": "215 2ND ST",
    "dropphycty": "LINWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 680363122,
    "dropmaladd": "215 2ND ST",
    "dropmalcty": "LINWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 680363122,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4025432224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B650",
    "droptype": "D",
    "dropname": "HUBBELL",
    "dropdeladd": "208 JOHNSON ST",
    "dropdelcty": "HUBBELL",
    "dropdelst": "NE",
    "dropdelzpp": 683757025,
    "dropphyadd": "208 JOHNSON ST",
    "dropphycty": "HUBBELL",
    "dropphyst": "NE",
    "dropphyzpp": 683757025,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBELL",
    "dropmalst": "NE",
    "dropmalzpp": 683759998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023248755,
    "dropsitcph": 4023248755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B682",
    "droptype": "D",
    "dropname": "SMITHWICK",
    "dropdeladd": "206 SMITHWICK RD",
    "dropdelcty": "SMITHWICK",
    "dropdelst": "SD",
    "dropdelzpp": 577829998,
    "dropphyadd": "206 SMITHWICK RD",
    "dropphycty": "SMITHWICK",
    "dropphyst": "SD",
    "dropphyzpp": 577829998,
    "dropmaladd": "206 SMITHWICK RD",
    "dropmalcty": "SMITHWICK",
    "dropmalst": "SD",
    "dropmalzpp": 577829998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6057454117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B702",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "111 2ND ST",
    "dropdelcty": "ROGERS",
    "dropdelst": "ND",
    "dropdelzpp": 584799998,
    "dropphyadd": "111 2ND ST",
    "dropphycty": "ROGERS",
    "dropphyst": "ND",
    "dropphyzpp": 584799998,
    "dropmaladd": "111 2ND ST",
    "dropmalcty": "ROGERS",
    "dropmalst": "ND",
    "dropmalzpp": 584799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016466244,
    "dropsitcph": 7016466244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B790",
    "droptype": "D",
    "dropname": "REYNOLDS",
    "dropdeladd": "128 COMMERCIAL ST",
    "dropdelcty": "REYNOLDS",
    "dropdelst": "NE",
    "dropdelzpp": 684293519,
    "dropphyadd": "128 COMMERCIAL ST",
    "dropphycty": "REYNOLDS",
    "dropphyst": "NE",
    "dropphyzpp": 684293519,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REYNOLDS",
    "dropmalst": "NE",
    "dropmalzpp": 684299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023243232,
    "dropsitcph": 4023243232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B858",
    "droptype": "D",
    "dropname": "FEDORA",
    "dropdeladd": "23304 421ST AVE",
    "dropdelcty": "FEDORA",
    "dropdelst": "SD",
    "dropdelzpp": 573379998,
    "dropphyadd": "23304 421ST AVE",
    "dropphycty": "FEDORA",
    "dropphyst": "SD",
    "dropphyzpp": 573379998,
    "dropmaladd": "23304 421ST AVE",
    "dropmalcty": "FEDORA",
    "dropmalst": "SD",
    "dropmalzpp": 573379998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6055272478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B890",
    "droptype": "D",
    "dropname": "STEELE CITY",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "STEELE CITY",
    "dropdelst": "NE",
    "dropdelzpp": 684409800,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "STEELE CITY",
    "dropphyst": "NE",
    "dropphyzpp": 684409800,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "STEELE CITY",
    "dropmalst": "NE",
    "dropmalzpp": 684409800,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024422246,
    "dropsitcph": 4024422246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B947",
    "droptype": "D",
    "dropname": "MCGREW",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MCGREW",
    "dropdelst": "NE",
    "dropdelzpp": 693539700,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MCGREW",
    "dropphyst": "NE",
    "dropphyzpp": 693539700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCGREW",
    "dropmalst": "NE",
    "dropmalzpp": 693539998,
    "dropsitphn": 3085861314,
    "dropsitlph": 3085861314,
    "dropsitcph": 3085861314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1B995",
    "droptype": "D",
    "dropname": "BURR",
    "dropdeladd": "435 MAIN ST",
    "dropdelcty": "BURR",
    "dropdelst": "NE",
    "dropdelzpp": 683245000,
    "dropphyadd": "435 MAIN ST",
    "dropphycty": "BURR",
    "dropphyst": "NE",
    "dropphyzpp": 683245000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURR",
    "dropmalst": "NE",
    "dropmalzpp": 683249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028666161,
    "dropsitcph": 4028482310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1C029",
    "droptype": "D",
    "dropname": "CARNARVON",
    "dropdeladd": "201 370TH ST",
    "dropdelcty": "CARNARVON",
    "dropdelst": "IA",
    "dropdelzpp": 514507606,
    "dropphyadd": "201 370TH ST",
    "dropphycty": "CARNARVON",
    "dropphyst": "IA",
    "dropphyzpp": 514507606,
    "dropmaladd": "201 370TH ST",
    "dropmalcty": "CARNARVON",
    "dropmalst": "IA",
    "dropmalzpp": 514507606,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126578531,
    "dropsitcph": 7126642075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1C070",
    "droptype": "D",
    "dropname": "MARTY",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "MARTY",
    "dropdelst": "SD",
    "dropdelzpp": 573619998,
    "dropphyadd": "9105 COLLEGE LOOP",
    "dropphycty": "MARTY",
    "dropphyst": "SD",
    "dropphyzpp": 573619998,
    "dropmaladd": "9105 COLLEGE LOOP",
    "dropmalcty": "MARTY",
    "dropmalst": "SD",
    "dropmalzpp": 573619998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6053845508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1C175",
    "droptype": "D",
    "dropname": "WESTPHALIA",
    "dropdeladd": "205 4TH ST",
    "dropdelcty": "WESTPHALIA",
    "dropdelst": "IA",
    "dropdelzpp": 515789700,
    "dropphyadd": "205 4TH ST",
    "dropphycty": "WESTPHALIA",
    "dropphyst": "IA",
    "dropphyzpp": 515789700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTPHALIA",
    "dropmalst": "IA",
    "dropmalzpp": 515789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127555812,
    "dropsitcph": 7126274136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW1C496",
    "droptype": "D",
    "dropname": "EDDYVILLE",
    "dropdeladd": "505 CENTRAL AVE",
    "dropdelcty": "EDDYVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 688346234,
    "dropphyadd": "505 CENTRAL AVE",
    "dropphycty": "EDDYVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 688346234,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDDYVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 688349998,
    "dropsitphn": 3089872560,
    "dropsitlph": 3089872560,
    "dropsitcph": 3088584950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW10064",
    "droptype": "D",
    "dropname": "ASPINWALL",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "ASPINWALL",
    "dropdelst": "IA",
    "dropdelzpp": 514327700,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "ASPINWALL",
    "dropphyst": "IA",
    "dropphyzpp": 514327700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASPINWALL",
    "dropmalst": "IA",
    "dropmalzpp": 514329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126533441,
    "dropsitcph": 7126533441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW10695",
    "droptype": "D",
    "dropname": "HIGHLANDVILLE",
    "dropdeladd": "3497 HIGHLANDVILLE RD",
    "dropdelcty": "HIGHLANDVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 521493400,
    "dropphyadd": "3497 HIGHLANDVILLE RD",
    "dropphycty": "HIGHLANDVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 521493400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGHLANDVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 521499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193822903,
    "dropsitcph": 3195467722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW13695",
    "droptype": "D",
    "dropname": "LINDENHURST",
    "dropdeladd": "2301 E SAND LAKE RD",
    "dropdelcty": "LINDENHURST",
    "dropdelst": "IL",
    "dropdelzpp": 600468935,
    "dropphyadd": "2301 E SAND LAKE RD",
    "dropphycty": "LINDENHURST",
    "dropphyst": "IL",
    "dropphyzpp": 600468935,
    "dropmaladd": "2301 E SAND LAKE RD",
    "dropmalcty": "LINDENHURST",
    "dropmalst": "IL",
    "dropmalzpp": 600468935,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473565995,
    "dropsitcph": 8473568252,
    "dropfax": 8473566349
  },
  {
    "dcode": "D",
    "dropkey": "CW15937",
    "droptype": "D",
    "dropname": "BRANSON WEST",
    "dropdeladd": "18128 BUSINESS 13",
    "dropdelcty": "REEDS SPRING",
    "dropdelst": "MO",
    "dropdelzpp": 657378637,
    "dropphyadd": "18128 BUSINESS 13",
    "dropphycty": "REEDS SPRING",
    "dropphyst": "MO",
    "dropphyzpp": 657378637,
    "dropmaladd": "18128 BUSINESS 13",
    "dropmalcty": "REEDS SPRING",
    "dropmalst": "MO",
    "dropmalzpp": 657378637,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172723243,
    "dropsitcph": 4172728248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW16755",
    "droptype": "D",
    "dropname": "HIGH POINT",
    "dropdeladd": "61241 HIGHWAY C",
    "dropdelcty": "HIGH POINT",
    "dropdelst": "MO",
    "dropdelzpp": 650429800,
    "dropphyadd": "61241 HIGHWAY C",
    "dropphycty": "HIGH POINT",
    "dropphyst": "MO",
    "dropphyzpp": 650429998,
    "dropmaladd": "61241 HIGHWAY C",
    "dropmalcty": "HIGH POINT",
    "dropmalst": "MO",
    "dropmalzpp": 650429998,
    "dropsitphn": 3144363601,
    "dropsitlph": 5737964401,
    "dropsitcph": 6604892200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW16909",
    "droptype": "D",
    "dropname": "KIMMSWICK",
    "dropdeladd": "6057 FRONT ST",
    "dropdelcty": "KIMMSWICK",
    "dropdelst": "MO",
    "dropdelzpp": 630539998,
    "dropphyadd": "6057 FRONT ST",
    "dropphycty": "KIMMSWICK",
    "dropphyst": "MO",
    "dropphyzpp": 630539998,
    "dropmaladd": "6057 FRONT ST",
    "dropmalcty": "KIMMSWICK",
    "dropmalst": "MO",
    "dropmalzpp": 630539998,
    "dropsitphn": 3144363601,
    "dropsitlph": 6364612273,
    "dropsitcph": 6364612273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW17206",
    "droptype": "D",
    "dropname": "MC BRIDE",
    "dropdeladd": "233 MAIN ST",
    "dropdelcty": "MC BRIDE",
    "dropdelst": "MO",
    "dropdelzpp": 637769998,
    "dropphyadd": "233 MAIN ST",
    "dropphycty": "MC BRIDE",
    "dropphyst": "MO",
    "dropphyzpp": 637769998,
    "dropmaladd": "233 MAIN ST",
    "dropmalcty": "MC BRIDE",
    "dropmalst": "MO",
    "dropmalzpp": 637769998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 5735474343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW17328",
    "droptype": "D",
    "dropname": "MOUNT STERLING",
    "dropdeladd": "2718 HIGHWAY A",
    "dropdelcty": "BLAND",
    "dropdelst": "MO",
    "dropdelzpp": 650142017,
    "dropphyadd": "2718 HIGHWAY A",
    "dropphycty": "BLAND",
    "dropphyst": "MO",
    "dropphyzpp": 650142017,
    "dropmaladd": "201 W LINCOLN AVE",
    "dropmalcty": "OWENSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 650669998,
    "dropsitphn": 3144363601,
    "dropsitlph": 5739436321,
    "dropsitcph": 5739436321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW17711",
    "droptype": "D",
    "dropname": "ROCKY MOUNT",
    "dropdeladd": "19554 WONDERLAND RD",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "MO",
    "dropdelzpp": 650729096,
    "dropphyadd": "19554 WONDERLAND RD",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "MO",
    "dropphyzpp": 650729096,
    "dropmaladd": "PO BOX 919",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "MO",
    "dropmalzpp": 650720919,
    "dropsitphn": 3144363601,
    "dropsitlph": 5733926402,
    "dropsitcph": 5733926402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW18800",
    "droptype": "D",
    "dropname": "CANNON BALL",
    "dropdeladd": "440 HORSESHOE RD",
    "dropdelcty": "CANNON BALL",
    "dropdelst": "ND",
    "dropdelzpp": 585289998,
    "dropphyadd": "440 HORSESHOE RD",
    "dropphycty": "CANNON BALL",
    "dropphyst": "ND",
    "dropphyzpp": 585289998,
    "dropmaladd": "440 HORSESHOE RD",
    "dropmalcty": "CANNON BALL",
    "dropmalst": "ND",
    "dropmalzpp": 585289998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7018547412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW19115",
    "droptype": "D",
    "dropname": "MARMARTH",
    "dropdeladd": "75 1ST ST W",
    "dropdelcty": "MARMARTH",
    "dropdelst": "ND",
    "dropdelzpp": 586439998,
    "dropphyadd": "75 1ST ST W",
    "dropphycty": "MARMARTH",
    "dropphyst": "ND",
    "dropphyzpp": 586439998,
    "dropmaladd": "75 1ST ST W",
    "dropmalcty": "MARMARTH",
    "dropmalst": "ND",
    "dropmalzpp": 586439998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7012796644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW19450",
    "droptype": "D",
    "dropname": "AMES",
    "dropdeladd": "210 N MAIN ST",
    "dropdelcty": "AMES",
    "dropdelst": "NE",
    "dropdelzpp": 686212186,
    "dropphyadd": "210 N MAIN ST",
    "dropphycty": "AMES",
    "dropphyst": "NE",
    "dropphyzpp": 686212186,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMES",
    "dropmalst": "NE",
    "dropmalzpp": 686219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026523413,
    "dropsitcph": 4026523413,
    "dropfax": 4027218588
  },
  {
    "dcode": "D",
    "dropkey": "CW19674",
    "droptype": "D",
    "dropname": "DICKENS",
    "dropdeladd": "33994 ADRIAN AVE",
    "dropdelcty": "DICKENS",
    "dropdelst": "NE",
    "dropdelzpp": 691323242,
    "dropphyadd": "33994 ADRIAN AVE",
    "dropphycty": "DICKENS",
    "dropphyst": "NE",
    "dropphyzpp": 691323242,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DICKENS",
    "dropmalst": "NE",
    "dropmalzpp": 691329998,
    "dropsitphn": 3085323149,
    "dropsitlph": 3089634502,
    "dropsitcph": 3089634502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW19773",
    "droptype": "D",
    "dropname": "GILEAD",
    "dropdeladd": "225 S MAIN ST",
    "dropdelcty": "GILEAD",
    "dropdelst": "NE",
    "dropdelzpp": 683629700,
    "dropphyadd": "225 S MAIN ST",
    "dropphycty": "GILEAD",
    "dropphyst": "NE",
    "dropphyzpp": 683629700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILEAD",
    "dropmalst": "NE",
    "dropmalzpp": 683629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027686127,
    "dropsitcph": 4027686127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW19804",
    "droptype": "D",
    "dropname": "HADAR",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "HADAR",
    "dropdelst": "NE",
    "dropdelzpp": 687389700,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "HADAR",
    "dropphyst": "NE",
    "dropphyzpp": 687389700,
    "dropmaladd": "PO BOX 151",
    "dropmalcty": "HADAR",
    "dropmalst": "NE",
    "dropmalzpp": 687380151,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026444134,
    "dropsitcph": 4026444134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW19841",
    "droptype": "D",
    "dropname": "HENDLEY",
    "dropdeladd": "223 GRANT ST",
    "dropdelcty": "HENDLEY",
    "dropdelst": "NE",
    "dropdelzpp": 689464621,
    "dropphyadd": "223 GRANT ST",
    "dropphycty": "HENDLEY",
    "dropphyst": "NE",
    "dropphyzpp": 689464621,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENDLEY",
    "dropmalst": "NE",
    "dropmalzpp": 689469998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3082683783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW20834",
    "droptype": "D",
    "dropname": "LAKE OF THE FOREST",
    "dropdeladd": "1 LAKE OF THE FRST",
    "dropdelcty": "BONNER SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 660129538,
    "dropphyadd": "1 LAKE OF THE FRST",
    "dropphycty": "BONNER SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 660129538,
    "dropmaladd": "135 CEDAR AVE",
    "dropmalcty": "BONNER SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 660129998,
    "dropsitphn": "",
    "dropsitlph": 9134416389,
    "dropsitcph": 9134412199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW20841",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "3496 DD20 RD",
    "dropdelcty": "LAMONT",
    "dropdelst": "KS",
    "dropdelzpp": 668555000,
    "dropphyadd": "3496 DD20 RD",
    "dropphycty": "LAMONT",
    "dropphyst": "KS",
    "dropphyzpp": 668555000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAMONT",
    "dropmalst": "KS",
    "dropmalzpp": 668559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3164274431,
    "dropsitcph": 3164274431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW20972",
    "droptype": "D",
    "dropname": "MC FARLAND",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "MC FARLAND",
    "dropdelst": "KS",
    "dropdelzpp": 665018801,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "MC FARLAND",
    "dropphyst": "KS",
    "dropphyzpp": 665018801,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "MC FARLAND",
    "dropmalst": "KS",
    "dropmalzpp": 665018801,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857653370,
    "dropsitcph": 7857653370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW22925",
    "droptype": "D",
    "dropname": "BERGHEIM",
    "dropdeladd": "843 STATE HIGHWAY 46 E",
    "dropdelcty": "BERGHEIM",
    "dropdelst": "TX",
    "dropdelzpp": 780049997,
    "dropphyadd": "843 STATE HIGHWAY 46 E",
    "dropphycty": "BERGHEIM",
    "dropphyst": "TX",
    "dropphyzpp": 780049997,
    "dropmaladd": "843 STATE HIGHWAY 46 E",
    "dropmalcty": "BERGHEIM",
    "dropmalst": "TX",
    "dropmalzpp": 780049997,
    "dropsitphn": 2103688387,
    "dropsitlph": 2102492414,
    "dropsitcph": 2102492414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW23019",
    "droptype": "D",
    "dropname": "BOYS RANCH",
    "dropdeladd": "8 JULIAN BIVINS BLVD",
    "dropdelcty": "BOYS RANCH",
    "dropdelst": "TX",
    "dropdelzpp": 790109801,
    "dropphyadd": "8 JULIAN BIVINS BLVD",
    "dropphycty": "BOYS RANCH",
    "dropphyst": "TX",
    "dropphyzpp": 790109801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYS RANCH",
    "dropmalst": "TX",
    "dropmalzpp": 790109998,
    "dropsitphn": 8063792110,
    "dropsitlph": 8176253658,
    "dropsitcph": 8063792110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW23085",
    "droptype": "D",
    "dropname": "BULVERDE",
    "dropdeladd": "30131 BULVERDE LN UNIT 1",
    "dropdelcty": "BULVERDE",
    "dropdelst": "TX",
    "dropdelzpp": 781639997,
    "dropphyadd": "30131 BULVERDE LN UNIT 1",
    "dropphycty": "BULVERDE",
    "dropphyst": "TX",
    "dropphyzpp": 781639997,
    "dropmaladd": "30131 BULVERDE LN UNIT 1",
    "dropmalcty": "BULVERDE",
    "dropmalst": "TX",
    "dropmalzpp": 781639997,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308854508,
    "dropsitcph": 8304383003,
    "dropfax": 8308853146
  },
  {
    "dcode": "D",
    "dropkey": "CW23408",
    "droptype": "D",
    "dropname": "CUT AND SHOOT",
    "dropdeladd": "13985 HIGHWAY 105 E",
    "dropdelcty": "CUT AND SHOOT",
    "dropdelst": "TX",
    "dropdelzpp": 773065353,
    "dropphyadd": "13985 HIGHWAY 105 E",
    "dropphycty": "CUT AND SHOOT",
    "dropphyst": "TX",
    "dropphyzpp": 773065353,
    "dropmaladd": "13985 HIGHWAY 105 E",
    "dropmalcty": "CUT AND SHOOT",
    "dropmalst": "TX",
    "dropmalzpp": 773065353,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7133506055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW24102",
    "droptype": "D",
    "dropname": "HILLTOP LAKES",
    "dropdeladd": "1 HOLSTER HWY",
    "dropdelcty": "HILLTOP LAKES",
    "dropdelst": "TX",
    "dropdelzpp": 778719803,
    "dropphyadd": "1 HOLSTER HWY",
    "dropphycty": "HILLTOP LAKES",
    "dropphyst": "TX",
    "dropphyzpp": 778719803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORMANGEE",
    "dropmalst": "TX",
    "dropmalzpp": 778719998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9368552711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW24328",
    "droptype": "D",
    "dropname": "KIRVIN",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "KIRVIN",
    "dropdelst": "TX",
    "dropdelzpp": 758489998,
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "KIRVIN",
    "dropphyst": "TX",
    "dropphyzpp": 758489998,
    "dropmaladd": "230 MAIN ST",
    "dropmalcty": "KIRVIN",
    "dropmalst": "TX",
    "dropmalzpp": 758489998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035992933,
    "dropsitcph": 9035992933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW24745",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "11371 COUNTY ROAD 317 S",
    "dropdelcty": "MINDEN",
    "dropdelst": "TX",
    "dropdelzpp": 756809997,
    "dropphyadd": "11371 COUNTY ROAD 317 S",
    "dropphycty": "MINDEN",
    "dropphyst": "TX",
    "dropphyzpp": 756809997,
    "dropmaladd": "PO BOX 98",
    "dropmalcty": "MINDEN",
    "dropmalst": "TX",
    "dropmalzpp": 756809998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9036571481,
    "dropfax": 9036556900
  },
  {
    "dcode": "D",
    "dropkey": "CW24747",
    "droptype": "D",
    "dropname": "MINERAL",
    "dropdeladd": "8692 FM 673",
    "dropdelcty": "MINERAL",
    "dropdelst": "TX",
    "dropdelzpp": 781252500,
    "dropphyadd": "8692 FM 673",
    "dropphycty": "MINERAL",
    "dropphyst": "TX",
    "dropphyzpp": 781252500,
    "dropmaladd": "223 S 2ND ST",
    "dropmalcty": "KENEDY",
    "dropmalst": "TX",
    "dropmalzpp": 781199998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305832119,
    "dropsitcph": 8305832119,
    "dropfax": 8305839757
  },
  {
    "dcode": "D",
    "dropkey": "CW26239",
    "droptype": "D",
    "dropname": "WAYSIDE",
    "dropdeladd": "8471 FM 285",
    "dropdelcty": "WAYSIDE",
    "dropdelst": "TX",
    "dropdelzpp": 790949802,
    "dropphyadd": "8471 FM 285",
    "dropphycty": "WAYSIDE",
    "dropphyst": "TX",
    "dropphyzpp": 790949802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAPPY",
    "dropmalst": "TX",
    "dropmalzpp": 790429998,
    "dropsitphn": 8065584051,
    "dropsitlph": 8176253658,
    "dropsitcph": 8067643450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW26512",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "1290 FM 193",
    "dropdelcty": "AFTON",
    "dropdelst": "TX",
    "dropdelzpp": 792204913,
    "dropphyadd": "1290 E FM 193",
    "dropphycty": "AFTON",
    "dropphyst": "TX",
    "dropphyzpp": 792204943,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROARING SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 792569998,
    "dropsitphn": 8063487951,
    "dropsitlph": 8063487951,
    "dropsitcph": 8063487951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW26637",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "6501 MAIN ST",
    "dropdelcty": "CORNING",
    "dropdelst": "KS",
    "dropdelzpp": 664178407,
    "dropphyadd": "6501 MAIN ST",
    "dropphycty": "CORNING",
    "dropphyst": "KS",
    "dropphyzpp": 664178407,
    "dropmaladd": "6501 MAIN ST",
    "dropmalcty": "CORNING",
    "dropmalst": "KS",
    "dropmalzpp": 664178407,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859392580,
    "dropsitcph": 7858682410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CW26699",
    "droptype": "D",
    "dropname": "FLOMOT",
    "dropdeladd": "206 LEONARD ST",
    "dropdelcty": "FLOMOT",
    "dropdelst": "TX",
    "dropdelzpp": 792343000,
    "dropphyadd": "206 LEONARD ST",
    "dropphycty": "FLOMOT",
    "dropphyst": "TX",
    "dropphyzpp": 792343000,
    "dropmaladd": "401 LONE STAR ST",
    "dropmalcty": "SILVERTON",
    "dropmalst": "TX",
    "dropmalzpp": 792579804,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064695370,
    "dropsitcph": 8064695370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A385",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "80 STEUBENVILLE PIKE STE A",
    "dropdelcty": "BURGETTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 150218529,
    "dropphyadd": "80 STEUBENVILLE PIKE STE A",
    "dropphycty": "BURGETTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 150218529,
    "dropmaladd": "1602 MAIN ST",
    "dropmalcty": "BURGETTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 150211174,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247297422,
    "dropsitcph": 7247297422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A425",
    "droptype": "D",
    "dropname": "PEACH GLEN",
    "dropdeladd": "800 PEACH GLEN IDAVILLE RD",
    "dropdelcty": "PEACH GLEN",
    "dropdelst": "PA",
    "dropdelzpp": 173750001,
    "dropphyadd": "800 PEACH GLEN IDAVILLE RD",
    "dropphycty": "PEACH GLEN",
    "dropphyst": "PA",
    "dropphyzpp": 173750001,
    "dropmaladd": "800 PEACH GLEN IDAVILLE RD",
    "dropmalcty": "PEACH GLEN",
    "dropmalst": "PA",
    "dropmalzpp": 173750001,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176778181,
    "dropsitcph": 7176778181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A587",
    "droptype": "D",
    "dropname": "POCONO LAKE PRESERVE",
    "dropdeladd": "1 ROUTE 940",
    "dropdelcty": "POCONO LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 183479900,
    "dropphyadd": "1 ROUTE 940",
    "dropphycty": "POCONO LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 183479998,
    "dropmaladd": "1 ROUTE 940",
    "dropmalcty": "POCONO LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 183479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706462081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A677",
    "droptype": "D",
    "dropname": "QUENTIN",
    "dropdeladd": "2625 QUENTIN RD",
    "dropdelcty": "QUENTIN",
    "dropdelst": "PA",
    "dropdelzpp": 170839800,
    "dropphyadd": "2625 QUENTIN RD",
    "dropphycty": "QUENTIN",
    "dropphyst": "PA",
    "dropphyzpp": 170839998,
    "dropmaladd": "2625 QUENTIN RD",
    "dropmalcty": "QUENTIN",
    "dropmalst": "PA",
    "dropmalzpp": 170839998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172729911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A681",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "102 3RD AVE",
    "dropdelcty": "BEAVER FALLS",
    "dropdelst": "PA",
    "dropdelzpp": 150105001,
    "dropphyadd": "102 3RD AVE",
    "dropphycty": "BEAVER FALLS",
    "dropphyst": "PA",
    "dropphyzpp": 150105001,
    "dropmaladd": "102 3RD AVE",
    "dropmalcty": "BEAVER FALLS",
    "dropmalst": "PA",
    "dropmalzpp": 150105001,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128462410,
    "dropsitcph": 7248460970,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A924",
    "droptype": "D",
    "dropname": "SANDY RIDGE",
    "dropdeladd": "391 STATE ST",
    "dropdelcty": "SANDY RIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 166779998,
    "dropphyadd": "391 STATE ST",
    "dropphycty": "SANDY RIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 166779998,
    "dropmaladd": "391 STATE ST",
    "dropmalcty": "SANDY RIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 166779998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143396701,
    "dropsitcph": 8143424469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1A968",
    "droptype": "D",
    "dropname": "SELTZER",
    "dropdeladd": "541 SELTZER RD",
    "dropdelcty": "POTTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 179019801,
    "dropphyadd": "541 SELTZER RD",
    "dropphycty": "POTTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 179019801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELTZER",
    "dropmalst": "PA",
    "dropmalzpp": 179749998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175444704,
    "dropsitcph": 7175444704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1B964",
    "droptype": "D",
    "dropname": "WESTFORD",
    "dropdeladd": "2218 WESTFORD RD",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 161349997,
    "dropphyadd": "2218 WESTFORD RD",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 161349997,
    "dropmaladd": "2218 WESTFORD RD",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 161349997,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249325245,
    "dropsitcph": 7249272221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX1C289",
    "droptype": "D",
    "dropname": "WURTLAND",
    "dropdeladd": "500 WURTLAND AVE",
    "dropdelcty": "GREENUP",
    "dropdelst": "KY",
    "dropdelzpp": 411449996,
    "dropphyadd": "500 WURTLAND AVE",
    "dropphycty": "GREENUP",
    "dropphyst": "KY",
    "dropphyzpp": 411449996,
    "dropmaladd": "500 WURTLAND AVE",
    "dropmalcty": "GREENUP",
    "dropmalst": "KY",
    "dropmalzpp": 411449996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064737251,
    "dropfax": 6064736657
  },
  {
    "dcode": "D",
    "dropkey": "CX1C464",
    "droptype": "D",
    "dropname": "FULDA",
    "dropdeladd": "16534 N STATE ROAD 545",
    "dropdelcty": "FULDA",
    "dropdelst": "IN",
    "dropdelzpp": 475369998,
    "dropphyadd": "16534 N STATE ROAD 545",
    "dropphycty": "FULDA",
    "dropphyst": "IN",
    "dropphyzpp": 475369998,
    "dropmaladd": "16534 N STATE ROAD 545",
    "dropmalcty": "FULDA",
    "dropmalst": "IN",
    "dropmalzpp": 475369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123575023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX10220",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "628 N HOUSTON LAKE BLVD",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310289998,
    "dropphyadd": "628 N HOUSTON LAKE BLVD",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310289998,
    "dropmaladd": "628 N HOUSTON LAKE BLVD",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789534444,
    "dropsitcph": 4789534444,
    "dropfax": 4783283777
  },
  {
    "dcode": "D",
    "dropkey": "CX12160",
    "droptype": "D",
    "dropname": "EVANSTON",
    "dropdeladd": "10598 N MCDONALD AVE",
    "dropdelcty": "EVANSTON",
    "dropdelst": "IN",
    "dropdelzpp": 475318000,
    "dropphyadd": "10598 N MCDONALD AVE",
    "dropphycty": "EVANSTON",
    "dropphyst": "IN",
    "dropphyzpp": 475318000,
    "dropmaladd": "10598 N MCDONALD AVE",
    "dropmalcty": "EVANSTON",
    "dropmalst": "IN",
    "dropmalzpp": 475318000,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125298440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX12674",
    "droptype": "D",
    "dropname": "KURTZ",
    "dropdeladd": "5787 N HENDRICKS ST",
    "dropdelcty": "NORMAN",
    "dropdelst": "IN",
    "dropdelzpp": 472645700,
    "dropphyadd": "5787 N HENDRICKS ST",
    "dropphycty": "NORMAN",
    "dropphyst": "IN",
    "dropphyzpp": 472645700,
    "dropmaladd": "5787 N HENDRICKS ST",
    "dropmalcty": "NORMAN",
    "dropmalst": "IN",
    "dropmalzpp": 472645700,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124973800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX15116",
    "droptype": "D",
    "dropname": "GHENT",
    "dropdeladd": "305 MAIN CROSS ST",
    "dropdelcty": "GHENT",
    "dropdelst": "KY",
    "dropdelzpp": 410459998,
    "dropphyadd": "305 MAIN CROSS ST",
    "dropphycty": "GHENT",
    "dropphyst": "KY",
    "dropphyzpp": 410459998,
    "dropmaladd": "305 MAIN CROSS ST",
    "dropmalcty": "GHENT",
    "dropmalst": "KY",
    "dropmalzpp": 410459998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5023475974,
    "dropsitcph": 5023475974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX16149",
    "droptype": "D",
    "dropname": "RAVENNA",
    "dropdeladd": "710 MAIN ST STE 1",
    "dropdelcty": "RAVENNA",
    "dropdelst": "KY",
    "dropdelzpp": 404721359,
    "dropphyadd": "710 MAIN ST STE 1",
    "dropphycty": "RAVENNA",
    "dropphyst": "KY",
    "dropphyzpp": 404721359,
    "dropmaladd": "710 MAIN ST STE 1",
    "dropmalcty": "RAVENNA",
    "dropmalst": "KY",
    "dropmalzpp": 404721359,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067233013,
    "dropfax": 6067234246
  },
  {
    "dcode": "D",
    "dropkey": "CX16296",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "41165 US HIGHWAY 62",
    "dropdelcty": "MAYSLICK",
    "dropdelst": "KY",
    "dropdelzpp": 410558825,
    "dropphyadd": "41165 US HIGHWAY 62",
    "dropphycty": "MAYSLICK",
    "dropphyst": "KY",
    "dropphyzpp": 410558825,
    "dropmaladd": "131 E 3RD ST",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 6065643461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX16372",
    "droptype": "D",
    "dropname": "SIZEROCK",
    "dropdeladd": "5951 BULLSKIN RD",
    "dropdelcty": "SIZEROCK",
    "dropdelst": "KY",
    "dropdelzpp": 417629998,
    "dropphyadd": "5951 BULLSKIN RD",
    "dropphycty": "SIZEROCK",
    "dropphyst": "KY",
    "dropphyzpp": 417629998,
    "dropmaladd": "5951 BULLSKIN RD",
    "dropmalcty": "SIZEROCK",
    "dropmalst": "KY",
    "dropmalzpp": 417629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066722509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX18268",
    "droptype": "D",
    "dropname": "ERNEST",
    "dropdeladd": "400 1ST ST",
    "dropdelcty": "ERNEST",
    "dropdelst": "PA",
    "dropdelzpp": 157399998,
    "dropphyadd": "400 1ST ST",
    "dropphycty": "ERNEST",
    "dropphyst": "PA",
    "dropphyzpp": 157399998,
    "dropmaladd": "400 1ST ST",
    "dropmalcty": "ERNEST",
    "dropmalst": "PA",
    "dropmalzpp": 157399998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244630103,
    "dropsitcph": 7244630103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX18547",
    "droptype": "D",
    "dropname": "GANS",
    "dropdeladd": "405 GANS RD",
    "dropdelcty": "GANS",
    "dropdelst": "PA",
    "dropdelzpp": 154391000,
    "dropphyadd": "405 GANS RD",
    "dropphycty": "GANS",
    "dropphyst": "PA",
    "dropphyzpp": 154391000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GANS",
    "dropmalst": "PA",
    "dropmalzpp": 154399998,
    "dropsitphn": 7247253280,
    "dropsitlph": 4123597568,
    "dropsitcph": 7247253280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX18808",
    "droptype": "D",
    "dropname": "HARRISONVILLE",
    "dropdeladd": "8764 LINCOLN HWY",
    "dropdelcty": "HARRISONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 172289998,
    "dropphyadd": "8764 LINCOLN HWY",
    "dropphycty": "HARRISONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 172289998,
    "dropmaladd": "8764 LINCOLN HWY",
    "dropmalcty": "HARRISONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 172289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174853571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX19646",
    "droptype": "D",
    "dropname": "MARTINDALE",
    "dropdeladd": "1009 MARTINDALE RD",
    "dropdelcty": "EPHRATA",
    "dropdelst": "PA",
    "dropdelzpp": 175228974,
    "dropphyadd": "1009 MARTINDALE RD",
    "dropphycty": "EPHRATA",
    "dropphyst": "PA",
    "dropphyzpp": 175228974,
    "dropmaladd": "1009 MARTINDALE RD",
    "dropmalcty": "EPHRATA",
    "dropmalst": "PA",
    "dropmalzpp": 175228974,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174454212,
    "dropsitcph": 7174454212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX20535",
    "droptype": "D",
    "dropname": "CHICKASAW",
    "dropdeladd": "49 W FRANKLIN ST",
    "dropdelcty": "CHICKASAW",
    "dropdelst": "OH",
    "dropdelzpp": 458269998,
    "dropphyadd": "49 W FRANKLIN ST",
    "dropphycty": "CHICKASAW",
    "dropphyst": "OH",
    "dropphyzpp": 458269998,
    "dropmaladd": "49 W FRANKLIN ST",
    "dropmalcty": "CHICKASAW",
    "dropmalst": "OH",
    "dropmalzpp": 458269998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 4195862442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX20956",
    "droptype": "D",
    "dropname": "EVANSPORT",
    "dropdeladd": "1110 S MAIN ST",
    "dropdelcty": "EVANSPORT",
    "dropdelst": "OH",
    "dropdelzpp": 435199900,
    "dropphyadd": "1110 S MAIN ST",
    "dropphycty": "EVANSPORT",
    "dropphyst": "OH",
    "dropphyzpp": 435199900,
    "dropmaladd": "1110 S MAIN ST",
    "dropmalcty": "EVANSPORT",
    "dropmalst": "OH",
    "dropmalzpp": 435199900,
    "dropsitphn": 3309969797,
    "dropsitlph": 4192456870,
    "dropsitcph": 4194285103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX21207",
    "droptype": "D",
    "dropname": "GRELTON",
    "dropdeladd": "6944 COUNTY ROAD M",
    "dropdelcty": "GRELTON",
    "dropdelst": "OH",
    "dropdelzpp": 435231000,
    "dropphyadd": "6944 COUNTY ROAD M",
    "dropphycty": "GRELTON",
    "dropphyst": "OH",
    "dropphyzpp": 435231000,
    "dropmaladd": "6944 COUNTY ROAD M",
    "dropmalcty": "GRELTON",
    "dropmalst": "OH",
    "dropmalzpp": 435231000,
    "dropsitphn": 3309969797,
    "dropsitlph": 4192566381,
    "dropsitcph": 4192566381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX21380",
    "droptype": "D",
    "dropname": "IDAHO",
    "dropdeladd": "14460 STATE ROUTE 124",
    "dropdelcty": "PIKETON",
    "dropdelst": "OH",
    "dropdelzpp": 456619694,
    "dropphyadd": "14460 STATE ROUTE 124",
    "dropphycty": "PIKETON",
    "dropphyst": "OH",
    "dropphyzpp": 456619694,
    "dropmaladd": "14460 STATE ROUTE 124",
    "dropmalcty": "PIKETON",
    "dropmalst": "OH",
    "dropmalzpp": 456619694,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404933882,
    "dropsitcph": 7404933882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX22788",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "19661 STATE ROUTE 550",
    "dropdelcty": "AMESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457119416,
    "dropphyadd": "19661 STATE ROUTE 550",
    "dropphycty": "AMESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457119416,
    "dropmaladd": "19661 STATE ROUTE 550",
    "dropmalcty": "AMESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457119416,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404488251,
    "dropsitcph": 7404488251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX23052",
    "droptype": "D",
    "dropname": "TARLTON",
    "dropdeladd": "25 HARRISON ST",
    "dropdelcty": "TARLTON",
    "dropdelst": "OH",
    "dropdelzpp": 431569900,
    "dropphyadd": "25 HARRISON ST",
    "dropphycty": "TARLTON",
    "dropphyst": "OH",
    "dropphyzpp": 431569900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TARLTON",
    "dropmalst": "OH",
    "dropmalzpp": 431569998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144742072,
    "dropsitcph": 6144742072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX23275",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "1 TOWNSHIP ROAD 109A",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 457879701,
    "dropphyadd": "1 TOWNSHIP ROAD 109A",
    "dropphycty": "WATERTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 457879701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 457879998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409842404,
    "dropsitcph": 7409842404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX24033",
    "droptype": "D",
    "dropname": "HILDA",
    "dropdeladd": "75 RAILROAD AVE",
    "dropdelcty": "BARNWELL",
    "dropdelst": "SC",
    "dropdelzpp": 298124503,
    "dropphyadd": "75 RAILROAD AVE",
    "dropphycty": "BARNWELL",
    "dropphyst": "SC",
    "dropphyzpp": 298124503,
    "dropmaladd": "75 RAILROAD AVE",
    "dropmalcty": "BARNWELL",
    "dropmalst": "SC",
    "dropmalzpp": 298124503,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 8037931116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX25109",
    "droptype": "D",
    "dropname": "DICKEL",
    "dropdeladd": "1950 CASCADE HOLLOW RD",
    "dropdelcty": "NORMANDY",
    "dropdelst": "TN",
    "dropdelzpp": 373603049,
    "dropphyadd": "1950 CASCADE HOLLOW RD",
    "dropphycty": "NORMANDY",
    "dropphyst": "TN",
    "dropphyzpp": 373603049,
    "dropmaladd": "1950 CASCADE HOLLOW RD",
    "dropmalcty": "NORMANDY",
    "dropmalst": "TN",
    "dropmalzpp": 373603049,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318573124,
    "dropsitcph": 9318573124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX25542",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "100 MAIN ST E",
    "dropdelcty": "MOUNT CARMEL",
    "dropdelst": "TN",
    "dropdelzpp": 376453668,
    "dropphyadd": "100 MAIN ST E",
    "dropphycty": "MOUNT CARMEL",
    "dropphyst": "TN",
    "dropphyzpp": 376453668,
    "dropmaladd": "PO BOX 1421",
    "dropmalcty": "MOUNT CARMEL",
    "dropmalst": "TN",
    "dropmalzpp": 376451421,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233573311,
    "dropsitcph": 4233573311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX25719",
    "droptype": "D",
    "dropname": "RUGBY",
    "dropdeladd": "5569 RUGBY HWY",
    "dropdelcty": "RUGBY",
    "dropdelst": "TN",
    "dropdelzpp": 377335000,
    "dropphyadd": "5569 RUGBY HWY",
    "dropphycty": "RUGBY",
    "dropphyst": "TN",
    "dropphyzpp": 377335000,
    "dropmaladd": "5569 RUGBY HWY",
    "dropmalcty": "RUGBY",
    "dropmalst": "TN",
    "dropmalzpp": 377335000,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236272390,
    "dropsitcph": 4236272390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX26580",
    "droptype": "D",
    "dropname": "FBI ACAD",
    "dropdeladd": "1 RANGE RD",
    "dropdelcty": "QUANTICO",
    "dropdelst": "VA",
    "dropdelzpp": 221350001,
    "dropphyadd": "1 RANGE RD",
    "dropphycty": "QUANTICO",
    "dropphyst": "VA",
    "dropphyzpp": 221350001,
    "dropmaladd": "1 RANGE RD",
    "dropmalcty": "QUANTICO",
    "dropmalst": "VA",
    "dropmalzpp": 221350001,
    "dropsitphn": 7036986867,
    "dropsitlph": 7036407577,
    "dropsitcph": 7036302951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX26757",
    "droptype": "D",
    "dropname": "GREENWAY",
    "dropdeladd": "8328 GEORGETOWN PIKE",
    "dropdelcty": "MC LEAN",
    "dropdelst": "VA",
    "dropdelzpp": 220670999,
    "dropphyadd": "8328 GEORGETOWN PIKE",
    "dropphycty": "MC LEAN",
    "dropphyst": "VA",
    "dropphyzpp": 220670999,
    "dropmaladd": "8328 GEORGETOWN PIKE",
    "dropmalcty": "MC LEAN",
    "dropmalst": "VA",
    "dropmalzpp": 220670999,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037909100,
    "dropsitcph": 7037909100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX26786",
    "droptype": "D",
    "dropname": "HAMPDEN SYDNEY",
    "dropdeladd": "80 GRAHAM CIRCLE DR",
    "dropdelcty": "HAMPDEN SYDNEY",
    "dropdelst": "VA",
    "dropdelzpp": 239435000,
    "dropphyadd": "80 GRAHAM CIRCLE DR",
    "dropphycty": "HAMPDEN SYDNEY",
    "dropphyst": "VA",
    "dropphyzpp": 239435000,
    "dropmaladd": "80 GRAHAM CIRCLE DR",
    "dropmalcty": "HAMPDEN SYDNEY",
    "dropmalst": "VA",
    "dropmalzpp": 239435000,
    "dropsitphn": "",
    "dropsitlph": 8047756127,
    "dropsitcph": 8043924349,
    "dropfax": 8042236169
  },
  {
    "dcode": "D",
    "dropkey": "CX27955",
    "droptype": "D",
    "dropname": "WEBER CITY",
    "dropdeladd": "102 LEGION ST",
    "dropdelcty": "WEBER CITY",
    "dropdelst": "VA",
    "dropdelzpp": 242909997,
    "dropphyadd": "102 LEGION ST",
    "dropphycty": "WEBER CITY",
    "dropphyst": "VA",
    "dropphyzpp": 242909997,
    "dropmaladd": "102 LEGION ST",
    "dropmalcty": "WEBER CITY",
    "dropmalst": "VA",
    "dropmalzpp": 242909997,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2763867911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28030",
    "droptype": "D",
    "dropname": "WOODBERRY FOREST",
    "dropdeladd": "898 WOODBERRY FOREST RD",
    "dropdelcty": "WOODBERRY FOREST",
    "dropdelst": "VA",
    "dropdelzpp": 229899998,
    "dropphyadd": "898 WOODBERRY FOREST RD",
    "dropphycty": "WOODBERRY FOREST",
    "dropphyst": "VA",
    "dropphyzpp": 229899998,
    "dropmaladd": "898 WOODBERRY FOREST RD",
    "dropmalcty": "WOODBERRY FOREST",
    "dropmalst": "VA",
    "dropmalzpp": 229899998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5406726046,
    "dropsitcph": 5406726046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28145",
    "droptype": "D",
    "dropname": "BAXTER",
    "dropdeladd": "2741 PAW PAW CREEK RD",
    "dropdelcty": "BAXTER",
    "dropdelst": "WV",
    "dropdelzpp": 265609997,
    "dropphyadd": "2741 PAW PAW CREEK RD",
    "dropphycty": "BAXTER",
    "dropphyst": "WV",
    "dropphyzpp": 265609997,
    "dropmaladd": "2741 PAW PAW CREEK RD",
    "dropmalcty": "BAXTER",
    "dropmalst": "WV",
    "dropmalzpp": 265609997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042785758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28178",
    "droptype": "D",
    "dropname": "BIG CHIMNEY",
    "dropdeladd": "4506 PENNSYLVANIA AVE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253029997,
    "dropphyadd": "4506 PENNSYLVANIA AVE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253029997,
    "dropmaladd": "4506 PENNSYLVANIA AVE",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253029997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049653852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28338",
    "droptype": "D",
    "dropname": "COPEN",
    "dropdeladd": "22 WALKER FORK RD",
    "dropdelcty": "COPEN",
    "dropdelst": "WV",
    "dropdelzpp": 266159997,
    "dropphyadd": "22 WALKER FORK RD",
    "dropphycty": "COPEN",
    "dropphyst": "WV",
    "dropphyzpp": 266159997,
    "dropmaladd": "22 WALKER FORK RD",
    "dropmalcty": "COPEN",
    "dropmalst": "WV",
    "dropmalzpp": 266159997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042393941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28587",
    "droptype": "D",
    "dropname": "GREEN SULPHUR SPRINGS",
    "dropdeladd": "12957 N SR 20",
    "dropdelcty": "GREEN SULPHUR SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 259669998,
    "dropphyadd": "12957 N SR 20",
    "dropphycty": "GREEN SULPHUR SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 259669998,
    "dropmaladd": "12957 N SR 20",
    "dropmalcty": "GREEN SULPHUR SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 259669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044660875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28748",
    "droptype": "D",
    "dropname": "LANHAM",
    "dropdeladd": "3618 POCA RIVER RD N",
    "dropdelcty": "POCA",
    "dropdelst": "WV",
    "dropdelzpp": 251596742,
    "dropphyadd": "3618 POCA RIVER RD N",
    "dropphycty": "POCA",
    "dropphyst": "WV",
    "dropphyzpp": 251596742,
    "dropmaladd": "3618 POCA RIVER RD N",
    "dropmalcty": "POCA",
    "dropmalst": "WV",
    "dropmalzpp": 251596742,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047552832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX28824",
    "droptype": "D",
    "dropname": "MALDEN",
    "dropdeladd": "4202 MALDEN DR",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253066442,
    "dropphyadd": "4202 MALDEN DR",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253066442,
    "dropmaladd": "4202 MALDEN DR",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253066442,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049250324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29165",
    "droptype": "D",
    "dropname": "SCHERR",
    "dropdeladd": "299 OLEN KIMBLE STORE RD",
    "dropdelcty": "KEYSER",
    "dropdelst": "WV",
    "dropdelzpp": 267264200,
    "dropphyadd": "299 OLEN KIMBLE STORE RD",
    "dropphycty": "KEYSER",
    "dropphyst": "WV",
    "dropphyzpp": 267264200,
    "dropmaladd": "299 OLEN KIMBLE STORE RD",
    "dropmalcty": "KEYSER",
    "dropmalst": "WV",
    "dropmalzpp": 267264201,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047497252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29359",
    "droptype": "D",
    "dropname": "WEST LOGAN",
    "dropdeladd": "102 6TH ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "WV",
    "dropdelzpp": 256019997,
    "dropphyadd": "102 6TH ST",
    "dropphycty": "LOGAN",
    "dropphyst": "WV",
    "dropphyzpp": 256019997,
    "dropmaladd": "102 6TH ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "WV",
    "dropmalzpp": 256019997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047526332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29505",
    "droptype": "D",
    "dropname": "STOCKDALE",
    "dropdeladd": "56 STATE ROUTE 335",
    "dropdelcty": "BEAVER",
    "dropdelst": "OH",
    "dropdelzpp": 456138800,
    "dropphyadd": "56 STATE ROUTE 335",
    "dropphycty": "BEAVER",
    "dropphyst": "OH",
    "dropphyzpp": 456138800,
    "dropmaladd": "PO BOX 1058",
    "dropmalcty": "STOCKDALE",
    "dropmalst": "OH",
    "dropmalzpp": 456830058,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402265151,
    "dropsitcph": 7408202616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29612",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "18992 STATE ROUTE 347",
    "dropdelcty": "BROADWAY",
    "dropdelst": "OH",
    "dropdelzpp": 430079997,
    "dropphyadd": "18992 STATE ROUTE 347",
    "dropphycty": "BROADWAY",
    "dropphyst": "OH",
    "dropphyzpp": 430079997,
    "dropmaladd": "18992 STATE ROUTE 347",
    "dropmalcty": "BROADWAY",
    "dropmalst": "OH",
    "dropmalzpp": 430079997,
    "dropsitphn": 6144720674,
    "dropsitlph": 9372463361,
    "dropsitcph": 9372463361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29709",
    "droptype": "D",
    "dropname": "SHADE",
    "dropdeladd": "2280 OLD US HIGHWAY 33",
    "dropdelcty": "SHADE",
    "dropdelst": "OH",
    "dropdelzpp": 457769639,
    "dropphyadd": "2280 OLD US ROUTE 33",
    "dropphycty": "SHADE",
    "dropphyst": "OH",
    "dropphyzpp": 457769639,
    "dropmaladd": "2280 OLD US ROUTE 33",
    "dropmalcty": "SHADE",
    "dropmalst": "OH",
    "dropmalzpp": 457769639,
    "dropsitphn": 6144720674,
    "dropsitlph": 6146983241,
    "dropsitcph": 6146983241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29752",
    "droptype": "D",
    "dropname": "MOUNT SAINT JOSEPH",
    "dropdeladd": "5900 DELHI RD",
    "dropdelcty": "MOUNT SAINT JOSEPH",
    "dropdelst": "OH",
    "dropdelzpp": 450511501,
    "dropphyadd": "5900 DELHI RD",
    "dropphycty": "MOUNT SAINT JOSEPH",
    "dropphyst": "OH",
    "dropphyzpp": 450511501,
    "dropmaladd": "5900 DELHI RD",
    "dropmalcty": "MOUNT SAINT JOSEPH",
    "dropmalst": "OH",
    "dropmalzpp": 450511501,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133475350,
    "dropsitcph": 5133475350,
    "dropfax": 5136845194
  },
  {
    "dcode": "D",
    "dropkey": "CX29763",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "39051 STATE ROUTE 26",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457349996,
    "dropphyadd": "39051 STATE ROUTE 26",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457349996,
    "dropmaladd": "PO BOX 34243",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457340243,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409342526,
    "dropsitcph": 7409342526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CX29772",
    "droptype": "D",
    "dropname": "KIRBY",
    "dropdeladd": "138 N MAIN ST",
    "dropdelcty": "KIRBY",
    "dropdelst": "OH",
    "dropdelzpp": 433309700,
    "dropphyadd": "138 N MAIN ST",
    "dropphycty": "KIRBY",
    "dropphyst": "OH",
    "dropphyzpp": 433309700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRBY",
    "dropmalst": "OH",
    "dropmalzpp": 433309998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4192732988,
    "dropsitcph": 4192732988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY11349",
    "droptype": "D",
    "dropname": "ANDREWS",
    "dropdeladd": "100 US HIGHWAY 31",
    "dropdelcty": "BERRIEN SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 491040002,
    "dropphyadd": "100 US HIGHWAY 31",
    "dropphycty": "BERRIEN SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 491040002,
    "dropmaladd": "100 US HIGHWAY 31",
    "dropmalcty": "BERRIEN SPRINGS",
    "dropmalst": "MI",
    "dropmalzpp": 491040002,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2694713238,
    "dropfax": 2694716208
  },
  {
    "dcode": "D",
    "dropkey": "CY11362",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "42904 COUNTY ROAD 426",
    "dropdelcty": "ARNOLD",
    "dropdelst": "MI",
    "dropdelzpp": 498199800,
    "dropphyadd": "42904 COUNTY ROAD 426",
    "dropphycty": "ARNOLD",
    "dropphyst": "MI",
    "dropphyzpp": 498199800,
    "dropmaladd": "42904 COUNTY ROAD 426",
    "dropmalcty": "ARNOLD",
    "dropmalst": "MI",
    "dropmalzpp": 498199800,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9067864821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY11695",
    "droptype": "D",
    "dropname": "COPPER HARBOR",
    "dropdeladd": "230 GRATIOT ST",
    "dropdelcty": "COPPER HARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 499189802,
    "dropphyadd": "230 GRATIOT ST",
    "dropphycty": "COPPER HARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 499189802,
    "dropmaladd": "230 GRATIOT ST",
    "dropmalcty": "COPPER HARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 499189802,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062894528,
    "dropsitcph": 9062894528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY11961",
    "droptype": "D",
    "dropname": "GOOD HART",
    "dropdeladd": "1075 N LAKE SHORE DR",
    "dropdelcty": "HARBOR SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 497409119,
    "dropphyadd": "1075 N LAKE SHORE DR",
    "dropphycty": "HARBOR SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 497409119,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOOD HART",
    "dropmalst": "MI",
    "dropmalzpp": 497379998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 5175266001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY12729",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "7912 DICKERSON RD",
    "dropdelcty": "SALEM",
    "dropdelst": "MI",
    "dropdelzpp": 481759998,
    "dropphyadd": "9706 6 MILE RD",
    "dropphycty": "NORTHVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 481689492,
    "dropmaladd": "200 S WING ST",
    "dropmalcty": "NORTHVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 481671544,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 2483807017,
    "dropfax": 2483498134
  },
  {
    "dcode": "D",
    "dropkey": "CY13003",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "15479 US HIGHWAY 12 APT A",
    "dropdelcty": "UNION",
    "dropdelst": "MI",
    "dropdelzpp": 491308732,
    "dropphyadd": "15479 US HIGHWAY 12 APT A",
    "dropphycty": "UNION",
    "dropphyst": "MI",
    "dropphyzpp": 491308732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION",
    "dropmalst": "MI",
    "dropmalzpp": 491309998,
    "dropsitphn": "",
    "dropsitlph": 2696415180,
    "dropsitcph": 2696415180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY13045",
    "droptype": "D",
    "dropname": "SYLVAN BEACH",
    "dropdeladd": "5959 MURRAY RD",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "MI",
    "dropdelzpp": 494619456,
    "dropphyadd": "5959 MURRAY RD",
    "dropphycty": "WHITEHALL",
    "dropphyst": "MI",
    "dropphyzpp": 494619456,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYLVAN BEACH",
    "dropmalst": "MI",
    "dropmalzpp": 494639998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318944553,
    "dropsitcph": 2318944553,
    "dropfax": 2318930023
  },
  {
    "dcode": "D",
    "dropkey": "CY14062",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "7490 HIGHWAY 311",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 386357806,
    "dropphyadd": "7490 HIGHWAY 311",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 386357806,
    "dropmaladd": "7490 HIGHWAY 311",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 386357806,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628517820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY14501",
    "droptype": "D",
    "dropname": "TIE PLANT",
    "dropdeladd": "70 KOPPERS DR",
    "dropdelcty": "TIE PLANT",
    "dropdelst": "MS",
    "dropdelzpp": 389607815,
    "dropphyadd": "70 KOPPERS DR",
    "dropphycty": "TIE PLANT",
    "dropphyst": "MS",
    "dropphyzpp": 389607815,
    "dropmaladd": "70 KOPPERS DR",
    "dropmalcty": "TIE PLANT",
    "dropmalst": "MS",
    "dropmalzpp": 389607815,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622264278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY15280",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "NC",
    "dropdelzpp": 278308870,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "FREMONT",
    "dropphyst": "NC",
    "dropphyzpp": 278308870,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "NC",
    "dropmalzpp": 278308870,
    "dropsitphn": 9194205175,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192425064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY16675",
    "droptype": "D",
    "dropname": "VALLE CRUCIS",
    "dropdeladd": "3565 NC HIGHWAY 194 S",
    "dropdelcty": "BANNER ELK",
    "dropdelst": "NC",
    "dropdelzpp": 286047877,
    "dropphyadd": "3565 NC HIGHWAY 194 S",
    "dropphycty": "BANNER ELK",
    "dropphyst": "NC",
    "dropphyzpp": 286047877,
    "dropmaladd": "3565 NC HIGHWAY 194 S",
    "dropmalcty": "BANNER ELK",
    "dropmalst": "NC",
    "dropmalzpp": 286047877,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8289636511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY16763",
    "droptype": "D",
    "dropname": "WESLEYAN COLLEGE",
    "dropdeladd": "3400 N WESLEYAN BLVD",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278048699,
    "dropphyadd": "3400 N WESLEYAN BLVD",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278048699,
    "dropmaladd": "3400 N WESLEYAN BLVD",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278048699,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 2529855174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY17421",
    "droptype": "D",
    "dropname": "HEAFFORD JUNCTION",
    "dropdeladd": "N11790 COUNTY ROAD L",
    "dropdelcty": "HEAFFORD JUNCTION",
    "dropdelst": "WI",
    "dropdelzpp": 545329800,
    "dropphyadd": "N11790 COUNTY ROAD L",
    "dropphycty": "HEAFFORD JUNCTION",
    "dropphyst": "WI",
    "dropphyzpp": 545329800,
    "dropmaladd": "N11790 COUNTY ROAD L",
    "dropmalcty": "HEAFFORD JUNCTION",
    "dropmalst": "WI",
    "dropmalzpp": 545329800,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154532831,
    "dropsitcph": 7154535888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY17820",
    "droptype": "D",
    "dropname": "PHLOX",
    "dropdeladd": "W7308 STATE HIGHWAY 47",
    "dropdelcty": "PHLOX",
    "dropdelst": "WI",
    "dropdelzpp": 544649800,
    "dropphyadd": "W7308 STATE HIGHWAY 47",
    "dropphycty": "PHLOX",
    "dropphyst": "WI",
    "dropphyzpp": 544649800,
    "dropmaladd": "W7308 STATE HIGHWAY 47",
    "dropmalcty": "PHLOX",
    "dropmalst": "WI",
    "dropmalzpp": 544649800,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154893632,
    "dropsitcph": 7154893632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18417",
    "droptype": "D",
    "dropname": "WHITFIELD",
    "dropdeladd": "3550 HIGHWAY 468 W",
    "dropdelcty": "WHITFIELD",
    "dropdelst": "MS",
    "dropdelzpp": 391935529,
    "dropphyadd": "3550 HIGHWAY 468 W",
    "dropphycty": "WHITFIELD",
    "dropphyst": "MS",
    "dropphyzpp": 391935529,
    "dropmaladd": "3550 HIGHWAY 468 W",
    "dropmalcty": "WHITFIELD",
    "dropmalst": "MS",
    "dropmalzpp": 391935529,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013518000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18420",
    "droptype": "D",
    "dropname": "CATARACT",
    "dropdeladd": "5897 STATE HIGHWAY 27",
    "dropdelcty": "CATARACT",
    "dropdelst": "WI",
    "dropdelzpp": 546205000,
    "dropphyadd": "5897 STATE HIGHWAY 27",
    "dropphycty": "SPARTA",
    "dropphyst": "WI",
    "dropphyzpp": 546566592,
    "dropmaladd": "PO BOX 228",
    "dropmalcty": "SPARTA",
    "dropmalst": "WI",
    "dropmalzpp": 546560228,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6082723155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18421",
    "droptype": "D",
    "dropname": "WASCOTT",
    "dropdeladd": "16389 CRYSTAL LAKE RD",
    "dropdelcty": "WASCOTT",
    "dropdelst": "WI",
    "dropdelzpp": 548909700,
    "dropphyadd": "16389 CRYSTAL LAKE RD",
    "dropphycty": "WASCOTT",
    "dropphyst": "WI",
    "dropphyzpp": 548909700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASCOTT",
    "dropmalst": "WI",
    "dropmalzpp": 548909998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154664220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18639",
    "droptype": "D",
    "dropname": "PARMELE",
    "dropdeladd": "1063 JAMES RD",
    "dropdelcty": "ROBERSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278718913,
    "dropphyadd": "1063 JAMES RD",
    "dropphycty": "ROBERSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278718913,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARMELE",
    "dropmalst": "NC",
    "dropmalzpp": 278619998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527954678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18650",
    "droptype": "D",
    "dropname": "STAR LAKE",
    "dropdeladd": "7697 COUNTY ROAD K",
    "dropdelcty": "STAR LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 545619720,
    "dropphyadd": "7697 COUNTY ROAD K",
    "dropphycty": "STAR LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 545619720,
    "dropmaladd": "7697 COUNTY ROAD K",
    "dropmalcty": "STAR LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 545619720,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155423360,
    "dropsitcph": 7155423464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY18777",
    "droptype": "D",
    "dropname": "JACHIN",
    "dropdeladd": "40806 HIGHWAY 17",
    "dropdelcty": "JACHIN",
    "dropdelst": "AL",
    "dropdelzpp": 369103234,
    "dropphyadd": "40806 HIGHWAY 17",
    "dropphycty": "JACHIN",
    "dropphyst": "AL",
    "dropphyzpp": 369103234,
    "dropmaladd": "40806 HIGHWAY 17",
    "dropmalcty": "JACHIN",
    "dropmalst": "AL",
    "dropmalzpp": 369103234,
    "dropsitphn": 6013517144,
    "dropsitlph": "",
    "dropsitcph": 2054592822,
    "dropfax": 6013517510
  },
  {
    "dcode": "D",
    "dropkey": "CY20028",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "11748 HIGHWAY 8 W",
    "dropdelcty": "AMITY",
    "dropdelst": "AR",
    "dropdelzpp": 719219134,
    "dropphyadd": "11748 HIGHWAY 8 W",
    "dropphycty": "AMITY",
    "dropphyst": "AR",
    "dropphyzpp": 719219134,
    "dropmaladd": "11748 HIGHWAY 8 W",
    "dropmalcty": "AMITY",
    "dropmalst": "AR",
    "dropmalzpp": 719219134,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013425671,
    "dropsitcph": 5013425671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY20108",
    "droptype": "D",
    "dropname": "BIG FLAT",
    "dropdeladd": "100 COMMUNITY DR",
    "dropdelcty": "BIG FLAT",
    "dropdelst": "AR",
    "dropdelzpp": 726178720,
    "dropphyadd": "100 COMMUNITY DR",
    "dropphycty": "BIG FLAT",
    "dropphyst": "AR",
    "dropphyzpp": 726178720,
    "dropmaladd": "100 COMMUNITY DR",
    "dropmalcty": "BIG FLAT",
    "dropmalst": "AR",
    "dropmalzpp": 726178720,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704483297,
    "dropsitcph": 8704483297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY21056",
    "droptype": "D",
    "dropname": "ROHWER",
    "dropdeladd": "136 COOKS RAMP RD",
    "dropdelcty": "TILLAR",
    "dropdelst": "AR",
    "dropdelzpp": 716709396,
    "dropphyadd": "136 COOKS RAMP RD",
    "dropphycty": "TILLAR",
    "dropphyst": "AR",
    "dropphyzpp": 716709396,
    "dropmaladd": "136 COOKS RAMP RD",
    "dropmalcty": "TILLAR",
    "dropmalst": "AR",
    "dropmalzpp": 716709396,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706443613,
    "dropsitcph": 8706443613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY21720",
    "droptype": "D",
    "dropname": "DOWLING PARK",
    "dropdeladd": "11057 COUNTY ROAD 136",
    "dropdelcty": "LIVE OAK",
    "dropdelst": "FL",
    "dropdelzpp": 320605890,
    "dropphyadd": "11057 COUNTY ROAD 136",
    "dropphycty": "LIVE OAK",
    "dropphyst": "FL",
    "dropphyzpp": 320605890,
    "dropmaladd": "11057 COUNTY ROAD 136",
    "dropmalcty": "LIVE OAK",
    "dropmalst": "FL",
    "dropmalzpp": 320605890,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866583333,
    "dropsitcph": 3866585270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY21780",
    "droptype": "D",
    "dropname": "EATONVILLE",
    "dropdeladd": "332 E KENNEDY BLVD",
    "dropdelcty": "EATONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 327519991,
    "dropphyadd": "332 E KENNEDY BLVD",
    "dropphycty": "EATONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 327519991,
    "dropmaladd": "332 E KENNEDY BLVD",
    "dropmalcty": "EATONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 327519991,
    "dropsitphn": 4076225745,
    "dropsitlph": 4076225745,
    "dropsitcph": 4076231235,
    "dropfax": 4076472561
  },
  {
    "dcode": "D",
    "dropkey": "CY21791",
    "droptype": "D",
    "dropname": "EL JOBEAN",
    "dropdeladd": "14410 PAMBAR AVE",
    "dropdelcty": "PORT CHARLOTTE",
    "dropdelst": "FL",
    "dropdelzpp": 339536046,
    "dropphyadd": "14410 PAMBAR AVE",
    "dropphycty": "PORT CHARLOTTE",
    "dropphyst": "FL",
    "dropphyzpp": 339536046,
    "dropmaladd": "14410 PAMBAR AVE",
    "dropmalcty": "PORT CHARLOTTE",
    "dropmalst": "FL",
    "dropmalzpp": 339536046,
    "dropsitphn": 8138770788,
    "dropsitlph": 9416255548,
    "dropsitcph": 9416255548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY21803",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "710 JACOB BROCK AVE",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "FL",
    "dropdelzpp": 327258123,
    "dropphyadd": "710 JACOB BROCK AVE",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "FL",
    "dropphyzpp": 327258123,
    "dropmaladd": "PO BOX 4131",
    "dropmalcty": "DELTONA",
    "dropmalst": "FL",
    "dropmalzpp": 327250131,
    "dropsitphn": 3866682329,
    "dropsitlph": 3866682329,
    "dropsitcph": 3866682329,
    "dropfax": 3866682329
  },
  {
    "dcode": "D",
    "dropkey": "CY21821",
    "droptype": "D",
    "dropname": "LAKESHORE",
    "dropdeladd": "500 CLUB CIR",
    "dropdelcty": "LAKESHORE",
    "dropdelst": "FL",
    "dropdelzpp": 338549801,
    "dropphyadd": "500 CLUB CIR",
    "dropphycty": "LAKESHORE",
    "dropphyst": "FL",
    "dropphyzpp": 338549801,
    "dropmaladd": "PO BOX 8631",
    "dropmalcty": "LAKESHORE",
    "dropmalst": "FL",
    "dropmalzpp": 338548631,
    "dropsitphn": 8138770788,
    "dropsitlph": 8636961917,
    "dropsitcph": 8636961917,
    "dropfax": 8633474289
  },
  {
    "dcode": "D",
    "dropkey": "CY21829",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "18728 COUNTY ROAD 455",
    "dropdelcty": "FERNDALE",
    "dropdelst": "FL",
    "dropdelzpp": 347293098,
    "dropphyadd": "18728 COUNTY ROAD 455",
    "dropphycty": "FERNDALE",
    "dropphyst": "FL",
    "dropphyzpp": 347293098,
    "dropmaladd": "PO BOX 299998",
    "dropmalcty": "FERNDALE",
    "dropmalst": "FL",
    "dropmalzpp": 347299998,
    "dropsitphn": 4074692113,
    "dropsitlph": 4074692113,
    "dropsitcph": 4074692632,
    "dropfax": 4074692849
  },
  {
    "dcode": "D",
    "dropkey": "CY21981",
    "droptype": "D",
    "dropname": "GROVE CITY",
    "dropdeladd": "3031 PLACIDA RD STE 3",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "FL",
    "dropdelzpp": 342248547,
    "dropphyadd": "3031 PLACIDA RD STE 3",
    "dropphycty": "GROVE CITY",
    "dropphyst": "FL",
    "dropphyzpp": 342248547,
    "dropmaladd": "3031 PLACIDA RD STE 3",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "FL",
    "dropmalzpp": 342248547,
    "dropsitphn": 8138770788,
    "dropsitlph": 9416976444,
    "dropsitcph": 9416976444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22036",
    "droptype": "D",
    "dropname": "HIGHLAND BEACH",
    "dropdeladd": "3612 S OCEAN BLVD",
    "dropdelcty": "HIGHLAND BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334879991,
    "dropphyadd": "3612 S OCEAN BLVD",
    "dropphycty": "HIGHLAND BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334879991,
    "dropmaladd": "3612 S OCEAN BLVD",
    "dropmalcty": "HIGHLAND BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334879991,
    "dropsitphn": 5612781448,
    "dropsitlph": 5612781448,
    "dropsitcph": 5612781448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22090",
    "droptype": "D",
    "dropname": "INDIAN LAKE ESTATES",
    "dropdeladd": "1720 PARK AVE",
    "dropdelcty": "INDIAN LAKE ESTATES",
    "dropdelst": "FL",
    "dropdelzpp": 338559801,
    "dropphyadd": "1720 PARK AVE",
    "dropphycty": "INDIAN LAKE ESTATES",
    "dropphyst": "FL",
    "dropphyzpp": 338559801,
    "dropmaladd": "PO BOX 7096",
    "dropmalcty": "INDIAN LAKE ESTATES",
    "dropmalst": "FL",
    "dropmalzpp": 338557096,
    "dropsitphn": 8138770788,
    "dropsitlph": 8636920233,
    "dropsitcph": 8636921008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22350",
    "droptype": "D",
    "dropname": "MATLACHA",
    "dropdeladd": "4547 PINE ISLAND RD NW UNIT A",
    "dropdelcty": "MATLACHA",
    "dropdelst": "FL",
    "dropdelzpp": 339939767,
    "dropphyadd": "4547 PINE ISLAND RD NW UNIT A",
    "dropphycty": "MATLACHA",
    "dropphyst": "FL",
    "dropphyzpp": 339939767,
    "dropmaladd": "PO BOX 145",
    "dropmalcty": "MATLACHA",
    "dropmalst": "FL",
    "dropmalzpp": 339930145,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2392830924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22378",
    "droptype": "D",
    "dropname": "MEXICO BEACH",
    "dropdeladd": "625C 15TH ST",
    "dropdelcty": "MEXICO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 324562189,
    "dropphyadd": "625C 15TH ST",
    "dropphycty": "MEXICO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 324562189,
    "dropmaladd": "625C 15TH ST",
    "dropmalcty": "MEXICO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 324562189,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506482208,
    "dropsitcph": 8506482208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22465",
    "droptype": "D",
    "dropname": "NALCREST",
    "dropdeladd": "10275 LEISURE LN W",
    "dropdelcty": "NALCREST",
    "dropdelst": "FL",
    "dropdelzpp": 338569800,
    "dropphyadd": "67105 NALCREST RD",
    "dropphycty": "NALCREST",
    "dropphyst": "FL",
    "dropphyzpp": 338561066,
    "dropmaladd": "PO BOX 6351",
    "dropmalcty": "NALCREST",
    "dropmalst": "FL",
    "dropmalzpp": 338566351,
    "dropsitphn": 8138770788,
    "dropsitlph": 8636968000,
    "dropsitcph": 8636968000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY22843",
    "droptype": "D",
    "dropname": "SALT SPRINGS",
    "dropdeladd": "14100 N HIGHWAY 19 STE G",
    "dropdelcty": "SALT SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 321348632,
    "dropphyadd": "14100 N HIGHWAY 19 STE G",
    "dropphycty": "SALT SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 321348632,
    "dropmaladd": "14100 N HIGHWAY 19 STE G",
    "dropmalcty": "SALT SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 321348622,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526852325,
    "dropsitcph": 3526852325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY23055",
    "droptype": "D",
    "dropname": "ROSEMARY BEACH",
    "dropdeladd": "28 MAIN ST",
    "dropdelcty": "INLET BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 324616929,
    "dropphyadd": "28 MAIN ST",
    "dropphycty": "ROSEMARY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 324616929,
    "dropmaladd": "PO BOX 611000",
    "dropmalcty": "INLET BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 324611012,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502782078,
    "dropsitcph": 8502782078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY23765",
    "droptype": "D",
    "dropname": "GARDNER",
    "dropdeladd": "40 HOLT STORE RD",
    "dropdelcty": "BOYCE",
    "dropdelst": "LA",
    "dropdelzpp": 714099770,
    "dropphyadd": "40 HOLT STORE RD",
    "dropphycty": "BOYCE",
    "dropphyst": "LA",
    "dropphyzpp": 714099770,
    "dropmaladd": "PO BOX 900",
    "dropmalcty": "GARDNER",
    "dropmalst": "LA",
    "dropmalzpp": 714310900,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3187938355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY23858",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "1489 HENDERSON HWY",
    "dropdelcty": "BREAUX BRIDGE",
    "dropdelst": "LA",
    "dropdelzpp": 705177812,
    "dropphyadd": "1489 HENDERSON HWY",
    "dropphycty": "BREAUX BRIDGE",
    "dropphyst": "LA",
    "dropphyzpp": 705177812,
    "dropmaladd": "1489 HENDERSON HWY",
    "dropmalcty": "BREAUX BRIDGE",
    "dropmalst": "LA",
    "dropmalzpp": 705177812,
    "dropsitphn": 5045891027,
    "dropsitlph": 5047633632,
    "dropsitcph": 3183321811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY24528",
    "droptype": "D",
    "dropname": "SUGARTOWN",
    "dropdeladd": "8243 HIGHWAY 113",
    "dropdelcty": "DRY CREEK",
    "dropdelst": "LA",
    "dropdelzpp": 706373600,
    "dropphyadd": "8243 HIGHWAY 113",
    "dropphycty": "DRY CREEK",
    "dropphyst": "LA",
    "dropphyzpp": 706373600,
    "dropmaladd": "PO BOX 6200",
    "dropmalcty": "SUGARTOWN",
    "dropmalst": "LA",
    "dropmalzpp": 706629998,
    "dropsitphn": 5045891027,
    "dropsitlph": 2257633632,
    "dropsitcph": 3373287145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY24587",
    "droptype": "D",
    "dropname": "UNCLE SAM",
    "dropdeladd": "7250 LA 44",
    "dropdelcty": "UNCLE SAM",
    "dropdelst": "LA",
    "dropdelzpp": 707920002,
    "dropphyadd": "7250 LA 44",
    "dropphycty": "UNCLE SAM",
    "dropphyst": "LA",
    "dropphyzpp": 707920002,
    "dropmaladd": "PO BOX 9200",
    "dropmalcty": "UNCLE SAM",
    "dropmalst": "LA",
    "dropmalzpp": 707929998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2255623501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY24605",
    "droptype": "D",
    "dropname": "VARNADO",
    "dropdeladd": "29891 HIGHWAY 21",
    "dropdelcty": "ANGIE",
    "dropdelst": "LA",
    "dropdelzpp": 704269998,
    "dropphyadd": "29891 HIGHWAY 21",
    "dropphycty": "ANGIE",
    "dropphyst": "LA",
    "dropphyzpp": 704269998,
    "dropmaladd": "29891 HIGHWAY 21",
    "dropmalcty": "ANGIE",
    "dropmalst": "LA",
    "dropmalzpp": 704269998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9859862697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY25643",
    "droptype": "D",
    "dropname": "LASTRUP",
    "dropdeladd": "19291 285TH AVE",
    "dropdelcty": "PIERZ",
    "dropdelst": "MN",
    "dropdelzpp": 563643011,
    "dropphyadd": "19291 285TH AVE",
    "dropphycty": "PIERZ",
    "dropphyst": "MN",
    "dropphyzpp": 563643011,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LASTRUP",
    "dropmalst": "MN",
    "dropmalzpp": 563449998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2184682543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY25859",
    "droptype": "D",
    "dropname": "MINNETONKA BEACH",
    "dropdeladd": "2945 WESTWOOD RD",
    "dropdelcty": "MINNETONKA BEACH",
    "dropdelst": "MN",
    "dropdelzpp": 553616102,
    "dropphyadd": "2945 WESTWOOD RD",
    "dropphycty": "MINNETONKA BEACH",
    "dropphyst": "MN",
    "dropphyzpp": 553616102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNETONKA BEACH",
    "dropmalst": "MN",
    "dropmalzpp": 553619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 6123496348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY25929",
    "droptype": "D",
    "dropname": "NETT LAKE",
    "dropdeladd": "13072 NETT LAKE RD",
    "dropdelcty": "ORR",
    "dropdelst": "MN",
    "dropdelzpp": 557717700,
    "dropphyadd": "13072 NETT LAKE RD",
    "dropphycty": "ORR",
    "dropphyst": "MN",
    "dropphyzpp": 557717700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORR",
    "dropmalst": "MN",
    "dropmalzpp": 557719998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2187573920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26000",
    "droptype": "D",
    "dropname": "OAK PARK",
    "dropdeladd": "16623 IRONWOOD RD NE",
    "dropdelcty": "OAK PARK",
    "dropdelst": "MN",
    "dropdelzpp": 563578986,
    "dropphyadd": "16623 IRONWOOD RD NE",
    "dropphycty": "OAK PARK",
    "dropphyst": "MN",
    "dropphyzpp": 563578986,
    "dropmaladd": "16623 IRONWOOD RD NE",
    "dropmalcty": "OAK PARK",
    "dropmalst": "MN",
    "dropmalzpp": 563578986,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3209687216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26076",
    "droptype": "D",
    "dropname": "PENNINGTON",
    "dropdeladd": "3070 SCENIC HWY NE",
    "dropdelcty": "PENNINGTON",
    "dropdelst": "MN",
    "dropdelzpp": 566633700,
    "dropphyadd": "3070 SCENIC HWY NE",
    "dropphycty": "PENNINGTON",
    "dropphyst": "MN",
    "dropphyzpp": 566633700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENNINGTON",
    "dropmalst": "MN",
    "dropmalzpp": 566639998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2183352721,
    "dropfax": 2183352721
  },
  {
    "dcode": "D",
    "dropkey": "CY26187",
    "droptype": "D",
    "dropname": "ROCK CREEK",
    "dropdeladd": "7160 560TH ST",
    "dropdelcty": "RUSH CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550692583,
    "dropphyadd": "7160 560TH ST",
    "dropphycty": "RUSH CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550692583,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK CREEK",
    "dropmalst": "MN",
    "dropmalzpp": 550679998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3202820190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26516",
    "droptype": "D",
    "dropname": "TALMOON",
    "dropdeladd": "49926 STATE HIGHWAY 6",
    "dropdelcty": "TALMOON",
    "dropdelst": "MN",
    "dropdelzpp": 566372016,
    "dropphyadd": "49926 STATE HIGHWAY 6",
    "dropphycty": "TALMOON",
    "dropphyst": "MN",
    "dropphyzpp": 566372016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALMOON",
    "dropmalst": "MN",
    "dropmalzpp": 566379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188323516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26708",
    "droptype": "D",
    "dropname": "WOLF LAKE",
    "dropdeladd": "132 W JOHNSON ST",
    "dropdelcty": "WOLF LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 565939998,
    "dropphyadd": "132 W JOHNSON ST",
    "dropphycty": "WOLF LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 565939998,
    "dropmaladd": "132 W JOHNSON ST",
    "dropmalcty": "WOLF LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 565939998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2183345041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26783",
    "droptype": "D",
    "dropname": "HILLMAN",
    "dropdeladd": "36929 HIGHWAY 27",
    "dropdelcty": "HILLMAN",
    "dropdelst": "MN",
    "dropdelzpp": 563382259,
    "dropphyadd": "36929 HIGHWAY 27",
    "dropphycty": "HILLMAN",
    "dropphyst": "MN",
    "dropphyzpp": 563382259,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLMAN",
    "dropmalst": "MN",
    "dropmalzpp": 563389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 6122773575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26816",
    "droptype": "D",
    "dropname": "LEONARD",
    "dropdeladd": "24624 LEONARD RD",
    "dropdelcty": "LEONARD",
    "dropdelst": "MN",
    "dropdelzpp": 566524166,
    "dropphyadd": "24624 LEONARD RD",
    "dropphycty": "LEONARD",
    "dropphyst": "MN",
    "dropphyzpp": 566524166,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEONARD",
    "dropmalst": "MN",
    "dropmalzpp": 566529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189682347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY26991",
    "droptype": "D",
    "dropname": "PINE RIDGE",
    "dropdeladd": "4562 W HIGHWAY 88",
    "dropdelcty": "ODEN",
    "dropdelst": "AR",
    "dropdelzpp": 719619997,
    "dropphyadd": "4562 W HIGHWAY 88",
    "dropphycty": "ODEN",
    "dropphyst": "AR",
    "dropphyzpp": 719619997,
    "dropmaladd": "4562 W HIGHWAY 88",
    "dropmalcty": "ODEN",
    "dropmalst": "AR",
    "dropmalzpp": 719619997,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703264341,
    "dropsitcph": 8703264341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY27130",
    "droptype": "D",
    "dropname": "OAK ISLAND",
    "dropdeladd": "820 OAK IS",
    "dropdelcty": "OAK ISLAND",
    "dropdelst": "MN",
    "dropdelzpp": 567419998,
    "dropphyadd": "820 OAK IS",
    "dropphycty": "OAK ISLAND",
    "dropphyst": "MN",
    "dropphyzpp": 567419998,
    "dropmaladd": "820 OAK IS",
    "dropmalcty": "OAK ISLAND",
    "dropmalst": "MN",
    "dropmalzpp": 567419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184428001,
    "dropsitcph": 2184428001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY27132",
    "droptype": "D",
    "dropname": "HUNTLEY",
    "dropdeladd": "16978 315TH AVE",
    "dropdelcty": "HUNTLEY",
    "dropdelst": "MN",
    "dropdelzpp": 560473000,
    "dropphyadd": "16978 315TH AVE",
    "dropphycty": "HUNTLEY",
    "dropphyst": "MN",
    "dropphyzpp": 560473000,
    "dropmaladd": "16978 315TH AVE",
    "dropmalcty": "HUNTLEY",
    "dropmalst": "MN",
    "dropmalzpp": 560473000,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078664440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY27504",
    "droptype": "D",
    "dropname": "EFFIE",
    "dropdeladd": "98 NE STATE HIGHWAY 1",
    "dropdelcty": "EFFIE",
    "dropdelst": "MN",
    "dropdelzpp": 566396035,
    "dropphyadd": "98 NE STATE HIGHWAY 1",
    "dropphycty": "EFFIE",
    "dropphyst": "MN",
    "dropphyzpp": 566396035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIGFORK",
    "dropmalst": "MN",
    "dropmalzpp": 566289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187433561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY27871",
    "droptype": "D",
    "dropname": "GULFPORT",
    "dropdeladd": "3115 BEACH BLVD S",
    "dropdelcty": "GULFPORT",
    "dropdelst": "FL",
    "dropdelzpp": 337076027,
    "dropphyadd": "3115 BEACH BLVD S",
    "dropphycty": "GULFPORT",
    "dropphyst": "FL",
    "dropphyzpp": 337076027,
    "dropmaladd": "3115 BEACH BLVD S",
    "dropmalcty": "GULFPORT",
    "dropmalst": "FL",
    "dropmalzpp": 337076027,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273818548,
    "dropsitcph": 7273818548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY27872",
    "droptype": "D",
    "dropname": "KENNETH CITY",
    "dropdeladd": "5480 58TH ST N",
    "dropdelcty": "KENNETH CITY",
    "dropdelst": "FL",
    "dropdelzpp": 337092036,
    "dropphyadd": "5480 58TH ST N",
    "dropphycty": "KENNETH CITY",
    "dropphyst": "FL",
    "dropphyzpp": 337092036,
    "dropmaladd": "5480 58TH ST N",
    "dropmalcty": "KENNETH CITY",
    "dropmalst": "FL",
    "dropmalzpp": 337092036,
    "dropsitphn": 8138770788,
    "dropsitlph": 7275417788,
    "dropsitcph": 7275417788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CY28067",
    "droptype": "D",
    "dropname": "FARWELL",
    "dropdeladd": "10 STANLEY AVE N",
    "dropdelcty": "FARWELL",
    "dropdelst": "MN",
    "dropdelzpp": 563278227,
    "dropphyadd": "10 STANLEY AVE N",
    "dropphycty": "FARWELL",
    "dropphyst": "MN",
    "dropphyzpp": 563278227,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARWELL",
    "dropmalst": "MN",
    "dropmalzpp": 563279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 6122835665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10001",
    "droptype": "D",
    "dropname": "AKHIOK",
    "dropdeladd": "165 D ST",
    "dropdelcty": "AKHIOK",
    "dropdelst": "AK",
    "dropdelzpp": 996159800,
    "dropphyadd": "165 D ST",
    "dropphycty": "AKHIOK",
    "dropphyst": "AK",
    "dropphyzpp": 996159800,
    "dropmaladd": "PO BOX 5099",
    "dropmalcty": "KODIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996155099,
    "dropsitphn": 9074864721,
    "dropsitlph": 9074864721,
    "dropsitcph": 9078362229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10021",
    "droptype": "D",
    "dropname": "ATKA",
    "dropdeladd": "1 ATXAX WAY",
    "dropdelcty": "ATKA",
    "dropdelst": "AK",
    "dropdelzpp": 995479800,
    "dropphyadd": "1 ATXAX WAY",
    "dropphycty": "ATKA",
    "dropphyst": "AK",
    "dropphyzpp": 995479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATKA",
    "dropmalst": "AK",
    "dropmalzpp": 995479998,
    "dropsitphn": 9075811231,
    "dropsitlph": 9075811232,
    "dropsitcph": 9078392214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10022",
    "droptype": "D",
    "dropname": "ATMAUTLUAK",
    "dropdeladd": "6500 ATMAUTLUAK RD",
    "dropdelcty": "ATMAUTLUAK",
    "dropdelst": "AK",
    "dropdelzpp": 995599801,
    "dropphyadd": "6500 ATMAUTLUAK RD",
    "dropphycty": "ATMAUTLUAK",
    "dropphyst": "AK",
    "dropphyzpp": 995599801,
    "dropmaladd": "PO BOX 6500",
    "dropmalcty": "ATMAUTLUAK",
    "dropmalst": "AK",
    "dropmalzpp": 995596500,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9075535901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10023",
    "droptype": "D",
    "dropname": "ATQASUK",
    "dropdeladd": "4010 SHUGLUK ST",
    "dropdelcty": "ATQASUK",
    "dropdelst": "AK",
    "dropdelzpp": 997919800,
    "dropphyadd": "4010 SHUGLUK ST",
    "dropphycty": "ATQASUK",
    "dropphyst": "AK",
    "dropphyzpp": 997919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATQASUK",
    "dropmalst": "AK",
    "dropmalzpp": 997919998,
    "dropsitphn": 9076336212,
    "dropsitlph": 9076336212,
    "dropsitcph": 9076336212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10042",
    "droptype": "D",
    "dropname": "CHALKYITSIK",
    "dropdeladd": "9788 CHALKYITSIK RD",
    "dropdelcty": "CHALKYITSIK",
    "dropdelst": "AK",
    "dropdelzpp": 997889800,
    "dropphyadd": "9788 CHALKYITSIK RD",
    "dropphycty": "CHALKYITSIK",
    "dropphyst": "AK",
    "dropphyzpp": 997889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHALKYITSIK",
    "dropmalst": "AK",
    "dropmalzpp": 997889998,
    "dropsitphn": 9076622335,
    "dropsitlph": 9076622335,
    "dropsitcph": 9078488128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10045",
    "droptype": "D",
    "dropname": "CHENEGA BAY",
    "dropdeladd": "8098 CHENEGA BAY RD",
    "dropdelcty": "CHENEGA BAY",
    "dropdelst": "AK",
    "dropdelzpp": 995749801,
    "dropphyadd": "8098 CHENEGA BAY RD",
    "dropphycty": "CHENEGA BAY",
    "dropphyst": "AK",
    "dropphyzpp": 995749801,
    "dropmaladd": "PO BOX 8098",
    "dropmalcty": "CORDOVA",
    "dropmalst": "AK",
    "dropmalzpp": 995748098,
    "dropsitphn": 9074243564,
    "dropsitlph": 9074343564,
    "dropsitcph": 9075735177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10047",
    "droptype": "D",
    "dropname": "CHICKALOON",
    "dropdeladd": "33968 N GLENN HWY",
    "dropdelcty": "SUTTON",
    "dropdelst": "AK",
    "dropdelzpp": 996749801,
    "dropphyadd": "33968 N GLENN HWY",
    "dropphycty": "SUTTON",
    "dropphyst": "AK",
    "dropphyzpp": 996749801,
    "dropmaladd": "PO BOX 1251",
    "dropmalcty": "CHICKALOON",
    "dropmalst": "AK",
    "dropmalzpp": 996741251,
    "dropsitphn": 9077453433,
    "dropsitlph": 9077453433,
    "dropsitcph": 9077460280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10051",
    "droptype": "D",
    "dropname": "CHIGNIK LAKE",
    "dropdeladd": "100 POSTAL WAY",
    "dropdelcty": "CHIGNIK LAKE",
    "dropdelst": "AK",
    "dropdelzpp": 995489800,
    "dropphyadd": "100 POSTAL WAY",
    "dropphycty": "CHIGNIK LAKE",
    "dropphyst": "AK",
    "dropphyzpp": 995489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIGNIK LAKE",
    "dropmalst": "AK",
    "dropmalzpp": 995489998,
    "dropsitphn": 9077492212,
    "dropsitlph": 9077492212,
    "dropsitcph": 9077492220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10052",
    "droptype": "D",
    "dropname": "CHINIAK",
    "dropdeladd": "36158 CHINIAK HWY",
    "dropdelcty": "CHINIAK",
    "dropdelst": "AK",
    "dropdelzpp": 996159801,
    "dropphyadd": "36158 CHINIAK HWY",
    "dropphycty": "CHINIAK",
    "dropphyst": "AK",
    "dropphyzpp": 996159801,
    "dropmaladd": "PO BOX 5500",
    "dropmalcty": "KODIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996155500,
    "dropsitphn": 9074864721,
    "dropsitlph": 9074864721,
    "dropsitcph": 9074860838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10054",
    "droptype": "D",
    "dropname": "CHUATHBALUK",
    "dropdeladd": "8999 CHUATHBALUK RD",
    "dropdelcty": "CHUATHBALUK",
    "dropdelst": "AK",
    "dropdelzpp": 995579801,
    "dropphyadd": "8999 CHUATHBALUK RD",
    "dropphycty": "CHUATHBALUK",
    "dropphyst": "AK",
    "dropphyzpp": 995579801,
    "dropmaladd": "PO BOX CHU",
    "dropmalcty": "ANIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995578999,
    "dropsitphn": 9076754314,
    "dropsitlph": 9076754314,
    "dropsitcph": 9074674030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10076",
    "droptype": "D",
    "dropname": "DENALI NATIONAL PARK",
    "dropdeladd": "55998 DENALI PARK RD",
    "dropdelcty": "DENALI NATIONAL PARK",
    "dropdelst": "AK",
    "dropdelzpp": 997559800,
    "dropphyadd": "55998 DENALI PARK RD",
    "dropphycty": "DENALI NATIONAL PARK",
    "dropphyst": "AK",
    "dropphyzpp": 997559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENALI NATIONAL PARK",
    "dropmalst": "AK",
    "dropmalzpp": 997559998,
    "dropsitphn": 9076832263,
    "dropsitlph": 9076832263,
    "dropsitcph": 9076832291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10127",
    "droptype": "D",
    "dropname": "GOLOVIN",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "GOLOVIN",
    "dropdelst": "AK",
    "dropdelzpp": 997629802,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "GOLOVIN",
    "dropphyst": "AK",
    "dropphyzpp": 997629802,
    "dropmaladd": "PO BOX 62998",
    "dropmalcty": "NOME",
    "dropmalst": "AK",
    "dropmalzpp": 997626998,
    "dropsitphn": 9074432401,
    "dropsitlph": 9074432401,
    "dropsitcph": 9074432401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10133",
    "droptype": "D",
    "dropname": "HALIBUT COVE",
    "dropdeladd": "6400 BOAT DOCK LNDG",
    "dropdelcty": "HOMER",
    "dropdelst": "AK",
    "dropdelzpp": 996039802,
    "dropphyadd": "6400 BOAT DOCK LNDG",
    "dropphycty": "HOMER",
    "dropphyst": "AK",
    "dropphyzpp": 996039802,
    "dropmaladd": "PO BOX 6400",
    "dropmalcty": "HOMER",
    "dropmalst": "AK",
    "dropmalzpp": 996036400,
    "dropsitphn": 9072356120,
    "dropsitlph": 9072356120,
    "dropsitcph": 9072356120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10140",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "17152 W PARKS HWY",
    "dropdelcty": "HOUSTON",
    "dropdelst": "AK",
    "dropdelzpp": 996949800,
    "dropphyadd": "17152 W PARKS HWY",
    "dropphycty": "HOUSTON",
    "dropphyst": "AK",
    "dropphyzpp": 996949800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "AK",
    "dropmalzpp": 996949998,
    "dropsitphn": 9073765327,
    "dropsitlph": 9073765327,
    "dropsitcph": 9078926129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10146",
    "droptype": "D",
    "dropname": "IGIUGIG",
    "dropdeladd": "4198 MAIN ST",
    "dropdelcty": "IGIUGIG",
    "dropdelst": "AK",
    "dropdelzpp": 996139801,
    "dropphyadd": "4198 MAIN ST",
    "dropphycty": "IGIUGIG",
    "dropphyst": "AK",
    "dropphyzpp": 996139801,
    "dropmaladd": "PO BOX 4198",
    "dropmalcty": "IGIUGIG",
    "dropmalst": "AK",
    "dropmalzpp": 996134198,
    "dropsitphn": 9072463396,
    "dropsitlph": 9072463396,
    "dropsitcph": 9075338001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10172",
    "droptype": "D",
    "dropname": "KOKHANOK",
    "dropdeladd": "998 KOKHANOK RD",
    "dropdelcty": "KOKHANOK",
    "dropdelst": "AK",
    "dropdelzpp": 996069801,
    "dropphyadd": "998 KOKHANOK RD",
    "dropphycty": "KOKHANOK",
    "dropphyst": "AK",
    "dropphyzpp": 996069801,
    "dropmaladd": "PO BOX 998",
    "dropmalcty": "ILIAMNA",
    "dropmalst": "AK",
    "dropmalzpp": 996060998,
    "dropsitphn": 9075711224,
    "dropsitlph": 9075711224,
    "dropsitcph": 9072822202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10174",
    "droptype": "D",
    "dropname": "KOLIGANEK",
    "dropdeladd": "5098 KOLIGANEK RD",
    "dropdelcty": "KOLIGANEK",
    "dropdelst": "AK",
    "dropdelzpp": 995769802,
    "dropphyadd": "5098 KOLIGANEK RD",
    "dropphycty": "KOLIGANEK",
    "dropphyst": "AK",
    "dropphyzpp": 995769802,
    "dropmaladd": "PO BOX 5098",
    "dropmalcty": "DILLINGHAM",
    "dropmalst": "AK",
    "dropmalzpp": 995765098,
    "dropsitphn": 9078425633,
    "dropsitlph": 9078425633,
    "dropsitcph": 9075963434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10175",
    "droptype": "D",
    "dropname": "KONGIGANAK",
    "dropdeladd": "5198 KONGIGANAK RD",
    "dropdelcty": "KONGIGANAK",
    "dropdelst": "AK",
    "dropdelzpp": 995459802,
    "dropphyadd": "5198 KONGIGANAK RD",
    "dropphycty": "KONGIGANAK",
    "dropphyst": "AK",
    "dropphyzpp": 995459802,
    "dropmaladd": "PO BOX 5198",
    "dropmalcty": "KONGIGANAK",
    "dropmalst": "AK",
    "dropmalzpp": 995455198,
    "dropsitphn": 9075888226,
    "dropsitlph": 9075888226,
    "dropsitcph": 9075575413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10186",
    "droptype": "D",
    "dropname": "LITTLE DIOMEDE",
    "dropdeladd": "12 STEPPING STONE WAY",
    "dropdelcty": "LITTLE DIOMEDE",
    "dropdelst": "AK",
    "dropdelzpp": 997629803,
    "dropphyadd": "12 STEPPING STONE WAY",
    "dropphycty": "LITTLE DIOMEDE",
    "dropphyst": "AK",
    "dropphyzpp": 997629803,
    "dropmaladd": "PO BOX 7098",
    "dropmalcty": "NOME",
    "dropmalst": "AK",
    "dropmalzpp": 997627098,
    "dropsitphn": 9074432129,
    "dropsitlph": 9074432401,
    "dropsitcph": 9074432401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10199",
    "droptype": "D",
    "dropname": "MENTASTA LAKE",
    "dropdeladd": "6 MENTASTA VILLAGE RD",
    "dropdelcty": "MENTASTA LAKE",
    "dropdelst": "AK",
    "dropdelzpp": 997809803,
    "dropphyadd": "6 MENTASTA VILLAGE RD",
    "dropphycty": "MENTASTA LAKE",
    "dropphyst": "AK",
    "dropphyzpp": 997809803,
    "dropmaladd": "PO BOX 6999",
    "dropmalcty": "TOK",
    "dropmalst": "AK",
    "dropmalzpp": 997806999,
    "dropsitphn": 9078835880,
    "dropsitlph": 9078835880,
    "dropsitcph": 9078835880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10201",
    "droptype": "D",
    "dropname": "MEYERS CHUCK",
    "dropdeladd": "9998 MEYERS RD",
    "dropdelcty": "MEYERS CHUCK",
    "dropdelst": "AK",
    "dropdelzpp": 999039800,
    "dropphyadd": "9998 MEYERS RD",
    "dropphycty": "MEYERS CHUCK",
    "dropphyst": "AK",
    "dropphyzpp": 999039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEYERS CHUCK",
    "dropmalst": "AK",
    "dropmalzpp": 999039998,
    "dropsitphn": 9072259601,
    "dropsitlph": 9072259601,
    "dropsitcph": 9079469800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10210",
    "droptype": "D",
    "dropname": "NANWALEK",
    "dropdeladd": "8028 NANWALEK WAY",
    "dropdelcty": "HOMER",
    "dropdelst": "AK",
    "dropdelzpp": 996039801,
    "dropphyadd": "8028 NANWALEK WAY",
    "dropphycty": "HOMER",
    "dropphyst": "AK",
    "dropphyzpp": 996039801,
    "dropmaladd": "PO BOX 8028",
    "dropmalcty": "NANWALEK",
    "dropmalst": "AK",
    "dropmalzpp": 996036628,
    "dropsitphn": 9072356120,
    "dropsitlph": 9072356120,
    "dropsitcph": 9072356120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10212",
    "droptype": "D",
    "dropname": "NAPASKIAK",
    "dropdeladd": "6198 NAPASKIAK RD",
    "dropdelcty": "NAPASKIAK",
    "dropdelst": "AK",
    "dropdelzpp": 995599803,
    "dropphyadd": "6198 NAPASKIAK RD",
    "dropphycty": "NAPASKIAK",
    "dropphyst": "AK",
    "dropphyzpp": 995599803,
    "dropmaladd": "PO BOX 6198",
    "dropmalcty": "NAPASKIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995596198,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9077377539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10216",
    "droptype": "D",
    "dropname": "NEWTOK",
    "dropdeladd": "5598 NEWTOK RD",
    "dropdelcty": "NEWTOK",
    "dropdelst": "AK",
    "dropdelzpp": 995599804,
    "dropphyadd": "5598 NEWTOK RD",
    "dropphycty": "NEWTOK",
    "dropphyst": "AK",
    "dropphyzpp": 995599804,
    "dropmaladd": "PO BOX 5598",
    "dropmalcty": "NEWTOK",
    "dropmalst": "AK",
    "dropmalzpp": 995595598,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9072372625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10217",
    "droptype": "D",
    "dropname": "NIGHTMUTE",
    "dropdeladd": "9690 NIGHTMUTE RD",
    "dropdelcty": "NIGHTMUTE",
    "dropdelst": "AK",
    "dropdelzpp": 996909800,
    "dropphyadd": "9690 NIGHTMUTE RD",
    "dropphycty": "NIGHTMUTE",
    "dropphyst": "AK",
    "dropphyzpp": 996909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIGHTMUTE",
    "dropmalst": "AK",
    "dropmalzpp": 996909998,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9076476325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10219",
    "droptype": "D",
    "dropname": "NIKISKI",
    "dropdeladd": "51708 KENAI SPUR HWY STE B",
    "dropdelcty": "NIKISKI",
    "dropdelst": "AK",
    "dropdelzpp": 996359800,
    "dropphyadd": "51708 KENAI SPUR HWY STE B",
    "dropphycty": "NIKISKI",
    "dropphyst": "AK",
    "dropphyzpp": 996359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIKISKI",
    "dropmalst": "AK",
    "dropmalzpp": 996359998,
    "dropsitphn": 9072837771,
    "dropsitlph": 9072837771,
    "dropsitcph": 9077765258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10221",
    "droptype": "D",
    "dropname": "NIKOLAI",
    "dropdeladd": "9691 NIKOLAI RD",
    "dropdelcty": "NIKOLAI",
    "dropdelst": "AK",
    "dropdelzpp": 996919800,
    "dropphyadd": "9691 NIKOLAI RD",
    "dropphycty": "NIKOLAI",
    "dropphyst": "AK",
    "dropphyzpp": 996919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIKOLAI",
    "dropmalst": "AK",
    "dropmalzpp": 996919998,
    "dropsitphn": 9075243333,
    "dropsitlph": 9075243333,
    "dropsitcph": 9072932127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10231",
    "droptype": "D",
    "dropname": "NUIQSUT",
    "dropdeladd": "301 PAUSANNA ST",
    "dropdelcty": "NUIQSUT",
    "dropdelst": "AK",
    "dropdelzpp": 997899800,
    "dropphyadd": "301 PAUSANNA ST",
    "dropphycty": "NUIQSUT",
    "dropphyst": "AK",
    "dropphyzpp": 997899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUIQSUT",
    "dropmalst": "AK",
    "dropmalzpp": 997899998,
    "dropsitphn": 9078526800,
    "dropsitlph": 9078526800,
    "dropsitcph": 9074806529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10238",
    "droptype": "D",
    "dropname": "PEDRO BAY",
    "dropdeladd": "9998 PEDRO BAY RD",
    "dropdelcty": "PEDRO BAY",
    "dropdelst": "AK",
    "dropdelzpp": 996479800,
    "dropphyadd": "9998 PEDRO BAY RD",
    "dropphycty": "PEDRO BAY",
    "dropphyst": "AK",
    "dropphyzpp": 996479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEDRO BAY",
    "dropmalst": "AK",
    "dropmalzpp": 996479998,
    "dropsitphn": 9075711224,
    "dropsitlph": 9075711224,
    "dropsitcph": 9078502330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10251",
    "droptype": "D",
    "dropname": "POINT LAY",
    "dropdeladd": "218 QIGALIK ST",
    "dropdelcty": "POINT LAY",
    "dropdelst": "AK",
    "dropdelzpp": 997599800,
    "dropphyadd": "218 QIGALIK ST",
    "dropphycty": "POINT LAY",
    "dropphyst": "AK",
    "dropphyzpp": 997599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT LAY",
    "dropmalst": "AK",
    "dropmalzpp": 997599998,
    "dropsitphn": 9078526800,
    "dropsitlph": 9078526800,
    "dropsitcph": 9078332812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10252",
    "droptype": "D",
    "dropname": "PORT ALEXANDER",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "PORT ALEXANDER",
    "dropdelst": "AK",
    "dropdelzpp": 998369800,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "PORT ALEXANDER",
    "dropphyst": "AK",
    "dropphyzpp": 998369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT ALEXANDER",
    "dropmalst": "AK",
    "dropmalzpp": 998369998,
    "dropsitphn": 9077473381,
    "dropsitlph": 9077473381,
    "dropsitcph": 9075682311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10254",
    "droptype": "D",
    "dropname": "PORT GRAHAM",
    "dropdeladd": "5548 GRAHAM RD",
    "dropdelcty": "HOMER",
    "dropdelst": "AK",
    "dropdelzpp": 996039803,
    "dropphyadd": "5548 GRAHAM RD",
    "dropphycty": "HOMER",
    "dropphyst": "AK",
    "dropphyzpp": 996039803,
    "dropmaladd": "PO BOX 5548",
    "dropmalcty": "PORT GRAHAM",
    "dropmalst": "AK",
    "dropmalzpp": 996035548,
    "dropsitphn": 9072316120,
    "dropsitlph": 9072356120,
    "dropsitcph": 9072842220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10255",
    "droptype": "D",
    "dropname": "PORT HEIDEN",
    "dropdeladd": "2 JACKS CUL DE SAC RD",
    "dropdelcty": "PORT HEIDEN",
    "dropdelst": "AK",
    "dropdelzpp": 995499800,
    "dropphyadd": "2 JACKS CUL DE SAC RD",
    "dropphycty": "PORT HEIDEN",
    "dropphyst": "AK",
    "dropphyzpp": 995499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT HEIDEN",
    "dropmalst": "AK",
    "dropmalzpp": 995499998,
    "dropsitphn": 9072463396,
    "dropsitlph": 9072463396,
    "dropsitcph": 9078872234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10261",
    "droptype": "D",
    "dropname": "RAMPART",
    "dropdeladd": "9767 FRONT ST",
    "dropdelcty": "RAMPART",
    "dropdelst": "AK",
    "dropdelzpp": 997679800,
    "dropphyadd": "9767 FRONT ST",
    "dropphycty": "RAMPART",
    "dropphyst": "AK",
    "dropphyzpp": 997679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAMPART",
    "dropmalst": "AK",
    "dropmalzpp": 997679998,
    "dropsitphn": 9074555452,
    "dropsitlph": 9074555412,
    "dropsitcph": 9073583114,
    "dropfax": 9073583114
  },
  {
    "dcode": "D",
    "dropkey": "CZ10268",
    "droptype": "D",
    "dropname": "SAINT GEORGE ISLAND",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SAINT GEORGE ISLAND",
    "dropdelst": "AK",
    "dropdelzpp": 995919800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SAINT GEORGE ISLAND",
    "dropphyst": "AK",
    "dropphyzpp": 995919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT GEORGE ISLAND",
    "dropmalst": "AK",
    "dropmalzpp": 995919998,
    "dropsitphn": 9075462270,
    "dropsitlph": 9075462270,
    "dropsitcph": 9078592222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10273",
    "droptype": "D",
    "dropname": "SALCHA",
    "dropdeladd": "9162 RICHARDSON HWY",
    "dropdelcty": "SALCHA",
    "dropdelst": "AK",
    "dropdelzpp": 997149676,
    "dropphyadd": "9162 RICHARDSON HWY",
    "dropphycty": "SALCHA",
    "dropphyst": "AK",
    "dropphyzpp": 997149676,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALCHA",
    "dropmalst": "AK",
    "dropmalzpp": 997149998,
    "dropsitphn": 9074555452,
    "dropsitlph": 9074555452,
    "dropsitcph": 9074882233,
    "dropfax": 9074882233
  },
  {
    "dcode": "D",
    "dropkey": "CZ10284",
    "droptype": "D",
    "dropname": "NUNAM IQUA",
    "dropdeladd": "9666 NUNAM IQUA RD",
    "dropdelcty": "NUNAM IQUA",
    "dropdelst": "AK",
    "dropdelzpp": 996669800,
    "dropphyadd": "9666 NUNAM IQUA RD",
    "dropphycty": "NUNAM IQUA",
    "dropphyst": "AK",
    "dropphyzpp": 996669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUNAM IQUA",
    "dropmalst": "AK",
    "dropmalzpp": 996669998,
    "dropsitphn": 9079491929,
    "dropsitlph": 9079491929,
    "dropsitcph": 9074984314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10291",
    "droptype": "D",
    "dropname": "SLANA",
    "dropdeladd": "2 NABESNA RD",
    "dropdelcty": "SLANA",
    "dropdelst": "AK",
    "dropdelzpp": 995869802,
    "dropphyadd": "2 NABESNA RD",
    "dropphycty": "SLANA",
    "dropphyst": "AK",
    "dropphyzpp": 995869802,
    "dropmaladd": "PO BOX 770",
    "dropmalcty": "GAKONA",
    "dropmalst": "AK",
    "dropmalzpp": 995860770,
    "dropsitphn": 9078223542,
    "dropsitlph": 9078223542,
    "dropsitcph": 9078223973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10314",
    "droptype": "D",
    "dropname": "STONY RIVER",
    "dropdeladd": "8998 STONY RIVER RD",
    "dropdelcty": "STONY RIVER",
    "dropdelst": "AK",
    "dropdelzpp": 995579802,
    "dropphyadd": "8998 STONY RIVER RD",
    "dropphycty": "STONY RIVER",
    "dropphyst": "AK",
    "dropphyzpp": 995579802,
    "dropmaladd": "PO BOX SRV",
    "dropmalcty": "ANIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995578998,
    "dropsitphn": 9076754314,
    "dropsitlph": 9076754314,
    "dropsitcph": 9076754314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10316",
    "droptype": "D",
    "dropname": "TAKOTNA",
    "dropdeladd": "9675 AIRPORT RD",
    "dropdelcty": "TAKOTNA",
    "dropdelst": "AK",
    "dropdelzpp": 996759800,
    "dropphyadd": "9675 AIRPORT RD",
    "dropphycty": "TAKOTNA",
    "dropphyst": "AK",
    "dropphyzpp": 996759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAKOTNA",
    "dropmalst": "AK",
    "dropmalzpp": 996759998,
    "dropsitphn": 9074432129,
    "dropsitlph": 9074432401,
    "dropsitcph": 9072982000,
    "dropfax": 9074434167
  },
  {
    "dcode": "D",
    "dropkey": "CZ10318",
    "droptype": "D",
    "dropname": "TANACROSS",
    "dropdeladd": "1000 1ST AVE",
    "dropdelcty": "TANACROSS",
    "dropdelst": "AK",
    "dropdelzpp": 997769800,
    "dropphyadd": "1000 1ST AVE",
    "dropphycty": "TANACROSS",
    "dropphyst": "AK",
    "dropphyzpp": 997769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TANACROSS",
    "dropmalst": "AK",
    "dropmalzpp": 997769998,
    "dropsitphn": 9078835880,
    "dropsitlph": 9078835880,
    "dropsitcph": 9078834496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10320",
    "droptype": "D",
    "dropname": "TATITLEK",
    "dropdeladd": "9998 TATITLEK RD",
    "dropdelcty": "TATITLEK",
    "dropdelst": "AK",
    "dropdelzpp": 996779800,
    "dropphyadd": "9998 TATITLEK RD",
    "dropphycty": "TATITLEK",
    "dropphyst": "AK",
    "dropphyzpp": 996779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TATITLEK",
    "dropmalst": "AK",
    "dropmalzpp": 996779998,
    "dropsitphn": 9074243564,
    "dropsitlph": 9074243564,
    "dropsitcph": 9073252357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10325",
    "droptype": "D",
    "dropname": "THORNE BAY",
    "dropdeladd": "9998 THORNE BAY",
    "dropdelcty": "THORNE BAY",
    "dropdelst": "AK",
    "dropdelzpp": 999199800,
    "dropphyadd": "9998 THORNE BAY",
    "dropphycty": "THORNE BAY",
    "dropphyst": "AK",
    "dropphyzpp": 999199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THORNE BAY",
    "dropmalst": "AK",
    "dropmalzpp": 999199998,
    "dropsitphn": 9072259601,
    "dropsitlph": 9072259601,
    "dropsitcph": 9078283490,
    "dropfax": 9078288287
  },
  {
    "dcode": "D",
    "dropkey": "CZ10328",
    "droptype": "D",
    "dropname": "TOKSOOK BAY",
    "dropdeladd": "9637 TOKSOOK BAY RD",
    "dropdelcty": "TOKSOOK BAY",
    "dropdelst": "AK",
    "dropdelzpp": 996379800,
    "dropphyadd": "9637 TOKSOOK BAY RD",
    "dropphycty": "TOKSOOK BAY",
    "dropphyst": "AK",
    "dropphyzpp": 996379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOKSOOK BAY",
    "dropmalst": "AK",
    "dropmalzpp": 996379998,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9074277474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10329",
    "droptype": "D",
    "dropname": "TRAPPER CREEK",
    "dropdeladd": "23161 S WATSON CIR",
    "dropdelcty": "TRAPPER CREEK",
    "dropdelst": "AK",
    "dropdelzpp": 996839800,
    "dropphyadd": "23161 S WATSON CIR",
    "dropphycty": "TRAPPER CREEK",
    "dropphyst": "AK",
    "dropphyzpp": 996839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRAPPER CREEK",
    "dropmalst": "AK",
    "dropmalzpp": 996839998,
    "dropsitphn": 9074956266,
    "dropsitlph": 9074956266,
    "dropsitcph": 9077334440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10330",
    "droptype": "D",
    "dropname": "TULUKSAK",
    "dropdeladd": "9679 TULUKSAK RD",
    "dropdelcty": "TULUKSAK",
    "dropdelst": "AK",
    "dropdelzpp": 996799800,
    "dropphyadd": "9679 TULUKSAK RD",
    "dropphycty": "TULUKSAK",
    "dropphyst": "AK",
    "dropphyzpp": 996799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TULUKSAK",
    "dropmalst": "AK",
    "dropmalzpp": 996799998,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9076956767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10331",
    "droptype": "D",
    "dropname": "TUNTUTULIAK",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "TUNTUTULIAK",
    "dropdelst": "AK",
    "dropdelzpp": 996809800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "TUNTUTULIAK",
    "dropphyst": "AK",
    "dropphyzpp": 996809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUNTUTULIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996809998,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9072562654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10333",
    "droptype": "D",
    "dropname": "TWIN HILLS",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "TWIN HILLS",
    "dropdelst": "AK",
    "dropdelzpp": 995769801,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "TWIN HILLS",
    "dropphyst": "AK",
    "dropphyzpp": 995769801,
    "dropmaladd": "PO BOX TWA",
    "dropmalcty": "DILLINGHAM",
    "dropmalst": "AK",
    "dropmalzpp": 995768996,
    "dropsitphn": 9078425633,
    "dropsitlph": 9078425633,
    "dropsitcph": 9075254127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10368",
    "droptype": "D",
    "dropname": "AMADO",
    "dropdeladd": "28661 S NOGALES HWY",
    "dropdelcty": "AMADO",
    "dropdelst": "AZ",
    "dropdelzpp": 856459900,
    "dropphyadd": "28661 S NOGALES HWY",
    "dropphycty": "AMADO",
    "dropphyst": "AZ",
    "dropphyzpp": 856459900,
    "dropmaladd": "PO BOX 1098",
    "dropmalcty": "AMADO",
    "dropmalst": "AZ",
    "dropmalzpp": 856451098,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885019,
    "dropsitcph": 5203982580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10427",
    "droptype": "D",
    "dropname": "CATALINA",
    "dropdeladd": "16141 N ORACLE RD",
    "dropdelcty": "CATALINA",
    "dropdelst": "AZ",
    "dropdelzpp": 857399129,
    "dropphyadd": "16141 N ORACLE RD",
    "dropphycty": "CATALINA",
    "dropphyst": "AZ",
    "dropphyzpp": 857399129,
    "dropmaladd": "16141 N ORACLE RD",
    "dropmalcty": "CATALINA",
    "dropmalst": "AZ",
    "dropmalzpp": 857399129,
    "dropsitphn": 5203885019,
    "dropsitlph": 5202290340,
    "dropsitcph": 5208257440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10434",
    "droptype": "D",
    "dropname": "CHANDLER HEIGHTS",
    "dropdeladd": "18337 E SAN TAN BLVD STE 102",
    "dropdelcty": "CHANDLER HEIGHTS",
    "dropdelst": "AZ",
    "dropdelzpp": 851428200,
    "dropphyadd": "18914 E SAN TAN BLVD STE 116",
    "dropphycty": "QUEEN CREEK",
    "dropphyst": "AZ",
    "dropphyzpp": 851426487,
    "dropmaladd": "1662 W HUNT HWY",
    "dropmalcty": "SAN TAN VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 851437598,
    "dropsitphn": 6022253491,
    "dropsitlph": 4809875020,
    "dropsitcph": 4809881415,
    "dropfax": 4809983408
  },
  {
    "dcode": "D",
    "dropkey": "CZ10445",
    "droptype": "D",
    "dropname": "CIBECUE",
    "dropdeladd": "221 S COOLEY RD",
    "dropdelcty": "CIBECUE",
    "dropdelst": "AZ",
    "dropdelzpp": 859115800,
    "dropphyadd": "221 S COOLEY RD",
    "dropphycty": "CIBECUE",
    "dropphyst": "AZ",
    "dropphyzpp": 859115800,
    "dropmaladd": "221 S COOLEY RD",
    "dropmalcty": "CIBECUE",
    "dropmalst": "AZ",
    "dropmalzpp": 859115800,
    "dropsitphn": 6022253491,
    "dropsitlph": 6023322500,
    "dropsitcph": 9283322500,
    "dropfax": 9285378458
  },
  {
    "dcode": "D",
    "dropkey": "CZ10608",
    "droptype": "D",
    "dropname": "INDIAN WELLS",
    "dropdeladd": "17 HIGHWAY 77",
    "dropdelcty": "INDIAN WELLS",
    "dropdelst": "AZ",
    "dropdelzpp": 860319997,
    "dropphyadd": "17 HIGHWAY 77",
    "dropphycty": "INDIAN WELLS",
    "dropphyst": "AZ",
    "dropphyzpp": 860319997,
    "dropmaladd": "PO BOX 3000",
    "dropmalcty": "INDIAN WELLS",
    "dropmalst": "AZ",
    "dropmalzpp": 860319998,
    "dropsitphn": 6022253491,
    "dropsitlph": 9286543390,
    "dropsitcph": 9286543390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10640",
    "droptype": "D",
    "dropname": "LAKE MONTEZUMA",
    "dropdeladd": "4220 ZUNI",
    "dropdelcty": "LAKE MONTEZUMA",
    "dropdelst": "AZ",
    "dropdelzpp": 863425800,
    "dropphyadd": "4220 ZUNI",
    "dropphycty": "LAKE MONTEZUMA",
    "dropphyst": "AZ",
    "dropphyzpp": 863425800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE MONTEZUMA",
    "dropmalst": "AZ",
    "dropmalzpp": 863429998,
    "dropsitphn": 6022253491,
    "dropsitlph": 9285674721,
    "dropsitcph": 9285674721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10651",
    "droptype": "D",
    "dropname": "LUKACHUKAI",
    "dropdeladd": "700 HIGHWAY 191",
    "dropdelcty": "LUKACHUKAI",
    "dropdelst": "AZ",
    "dropdelzpp": 865071715,
    "dropphyadd": "700 HIGHWAY 191",
    "dropphycty": "LUKACHUKAI",
    "dropphyst": "AZ",
    "dropphyzpp": 865071715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUKACHUKAI",
    "dropmalst": "AZ",
    "dropmalzpp": 865079998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9287872281,
    "dropsitcph": 9287872281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10656",
    "droptype": "D",
    "dropname": "LUPTON",
    "dropdeladd": "357 ROUTE 12",
    "dropdelcty": "LUPTON",
    "dropdelst": "AZ",
    "dropdelzpp": 865081001,
    "dropphyadd": "357 ROUTE 12",
    "dropphycty": "LUPTON",
    "dropphyst": "AZ",
    "dropphyzpp": 865081001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUCK",
    "dropmalst": "AZ",
    "dropmalzpp": 865069998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9286882681,
    "dropsitcph": 9286882690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10658",
    "droptype": "D",
    "dropname": "MANY FARMS",
    "dropdeladd": "100 HIGHWAY 191",
    "dropdelcty": "MANY FARMS",
    "dropdelst": "AZ",
    "dropdelzpp": 865381701,
    "dropphyadd": "100 HIGHWAY 191",
    "dropphycty": "MANY FARMS",
    "dropphyst": "AZ",
    "dropphyzpp": 865381701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANY FARMS",
    "dropmalst": "AZ",
    "dropmalzpp": 865389998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9287813617,
    "dropsitcph": 9287813617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10661",
    "droptype": "D",
    "dropname": "MARBLE CANYON",
    "dropdeladd": "540 HIGHWAY 89A",
    "dropdelcty": "MARBLE CANYON",
    "dropdelst": "AZ",
    "dropdelzpp": 860369997,
    "dropphyadd": "540 US HIGHWAY 89A",
    "dropphycty": "MARBLE CANYON",
    "dropphyst": "AZ",
    "dropphyzpp": 860369997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARBLE CANYON",
    "dropmalst": "AZ",
    "dropmalzpp": 860369998,
    "dropsitphn": 6022253491,
    "dropsitlph": 9283552235,
    "dropsitcph": 9283552235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10704",
    "droptype": "D",
    "dropname": "NAZLINI",
    "dropdeladd": "19 STATE HIGHWAY 27",
    "dropdelcty": "NAZLINI",
    "dropdelst": "AZ",
    "dropdelzpp": 865401000,
    "dropphyadd": "19 STATE HIGHWAY 27",
    "dropphycty": "NAZLINI",
    "dropphyst": "AZ",
    "dropphyzpp": 865401000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAZLINI",
    "dropmalst": "AZ",
    "dropmalzpp": 865409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9287553504,
    "dropsitcph": 9287555900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10764",
    "droptype": "D",
    "dropname": "PORTAL",
    "dropdeladd": "2391 S ROCK HOUSE RD",
    "dropdelcty": "SAN SIMON",
    "dropdelst": "AZ",
    "dropdelzpp": 856329950,
    "dropphyadd": "2391 S ROCK HOUSE RD",
    "dropphycty": "SAN SIMON",
    "dropphyst": "AZ",
    "dropphyzpp": 856329950,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN SIMON",
    "dropmalst": "AZ",
    "dropmalzpp": 856329998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885019,
    "dropsitcph": 5208452212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10905",
    "droptype": "D",
    "dropname": "SUN VALLEY",
    "dropdeladd": "8611 5TH ST",
    "dropdelcty": "SUN VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 860299997,
    "dropphyadd": "8611 5TH ST",
    "dropphycty": "SUN VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 860299997,
    "dropmaladd": "PO BOX 4000",
    "dropmalcty": "SUN VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 860299998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285243311,
    "dropsitcph": 9285243311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10943",
    "droptype": "D",
    "dropname": "TUBAC",
    "dropdeladd": "2255B E FRONTAGE RD",
    "dropdelcty": "TUBAC",
    "dropdelst": "AZ",
    "dropdelzpp": 856469997,
    "dropphyadd": "2255 E FRONTAGE RD",
    "dropphycty": "TUBAC",
    "dropphyst": "AZ",
    "dropphyzpp": 856469997,
    "dropmaladd": "PO BOX 4398",
    "dropmalcty": "TUBAC",
    "dropmalst": "AZ",
    "dropmalzpp": 856464398,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885019,
    "dropsitcph": 5203983379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ10994",
    "droptype": "D",
    "dropname": "WOODRUFF",
    "dropdeladd": "6435 W 1ST ST",
    "dropdelcty": "WOODRUFF",
    "dropdelst": "AZ",
    "dropdelzpp": 859429997,
    "dropphyadd": "6435 W 1ST ST",
    "dropphycty": "WOODRUFF",
    "dropphyst": "AZ",
    "dropphyzpp": 859429997,
    "dropmaladd": "6435 W 1ST ST",
    "dropmalcty": "WOODRUFF",
    "dropmalst": "AZ",
    "dropmalzpp": 859429997,
    "dropsitphn": 6022253491,
    "dropsitlph": 9285363911,
    "dropsitcph": 9285363610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ11127",
    "droptype": "D",
    "dropname": "BUFFALO CREEK",
    "dropdeladd": "17706 COUNTY ROAD 96",
    "dropdelcty": "BUFFALO CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 804259997,
    "dropphyadd": "17706 COUNTY ROAD 96",
    "dropphycty": "BUFFALO CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 804259997,
    "dropmaladd": "17706 COUNTY ROAD 96",
    "dropmalcty": "BUFFALO CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 804259997,
    "dropsitphn": 3038385715,
    "dropsitlph": 3038386511,
    "dropsitcph": 3038385715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ11202",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "614 BROADWAY ST",
    "dropdelcty": "COMO",
    "dropdelst": "CO",
    "dropdelzpp": 804329990,
    "dropphyadd": "614 BROADWAY ST",
    "dropphycty": "COMO",
    "dropphyst": "CO",
    "dropphyzpp": 804329990,
    "dropmaladd": "614 BROADWAY ST",
    "dropmalcty": "COMO",
    "dropmalst": "CO",
    "dropmalzpp": 804329990,
    "dropsitphn": 3038536511,
    "dropsitlph": 7198362423,
    "dropsitcph": 7198362423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ11499",
    "droptype": "D",
    "dropname": "HILLSIDE",
    "dropdeladd": "24 STATE HIGHWAY 69",
    "dropdelcty": "HILLSIDE",
    "dropdelst": "CO",
    "dropdelzpp": 812329990,
    "dropphyadd": "24 STATE HIGHWAY 69",
    "dropphycty": "HILLSIDE",
    "dropphyst": "CO",
    "dropphyzpp": 812329990,
    "dropmaladd": "24 STATE HIGHWAY 69",
    "dropmalcty": "HILLSIDE",
    "dropmalst": "CO",
    "dropmalzpp": 812329990,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705409,
    "dropsitcph": 7197830800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12083",
    "droptype": "D",
    "dropname": "INARAJAN",
    "dropdeladd": "663 PALE DUENAS ST",
    "dropdelcty": "SANTA RITA",
    "dropdelst": "GU",
    "dropdelzpp": 969153297,
    "dropphyadd": "663 PALE DUENAS ST",
    "dropphycty": "SANTA RITA",
    "dropphyst": "GU",
    "dropphyzpp": 969153297,
    "dropmaladd": "PO BOX 179998",
    "dropmalcty": "INARAJAN",
    "dropmalst": "GU",
    "dropmalzpp": 969179998,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6718282700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12087",
    "droptype": "D",
    "dropname": "MERIZO",
    "dropdeladd": "76 ROSARIO ST",
    "dropdelcty": "MERIZO",
    "dropdelst": "GU",
    "dropdelzpp": 969151299,
    "dropphyadd": "76 ROSARIO ST",
    "dropphycty": "MERIZO",
    "dropphyst": "GU",
    "dropphyzpp": 969151299,
    "dropmaladd": "76 ROSARIO ST",
    "dropmalcty": "MERIZO",
    "dropmalst": "GU",
    "dropmalzpp": 969151299,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6717343921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12229",
    "droptype": "D",
    "dropname": "KEALIA",
    "dropdeladd": "2340 KEALIA RD",
    "dropdelcty": "KEALIA",
    "dropdelst": "HI",
    "dropdelzpp": 967519997,
    "dropphyadd": "2340 KEALIA RD",
    "dropphycty": "KEALIA",
    "dropphyst": "HI",
    "dropphyzpp": 967519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEALIA",
    "dropmalst": "HI",
    "dropmalzpp": 967519998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088224710,
    "dropsitcph": 8088210478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12297",
    "droptype": "D",
    "dropname": "NINOLE",
    "dropdeladd": "32-942 MAMALAHOA HWY",
    "dropdelcty": "NINOLE",
    "dropdelst": "HI",
    "dropdelzpp": 967739997,
    "dropphyadd": "32-942 MAMALAHOA HWY",
    "dropphycty": "NINOLE",
    "dropphyst": "HI",
    "dropphyzpp": 967739997,
    "dropmaladd": "PO BOX 739998",
    "dropmalcty": "NINOLE",
    "dropmalst": "HI",
    "dropmalzpp": 967739998,
    "dropsitphn": 8084233844,
    "dropsitlph": "",
    "dropsitcph": 8087761282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12302",
    "droptype": "D",
    "dropname": "OOKALA",
    "dropdeladd": "39-3325 MAMALAHOA HWY",
    "dropdelcty": "OOKALA",
    "dropdelst": "HI",
    "dropdelzpp": 967749997,
    "dropphyadd": "39-3320 MAMALAHOA HWY",
    "dropphycty": "OOKALA",
    "dropphyst": "HI",
    "dropphyzpp": 967749996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OOKALA",
    "dropmalst": "HI",
    "dropmalzpp": 967749998,
    "dropsitphn": 8084233844,
    "dropsitlph": "",
    "dropsitcph": 8089626238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12672",
    "droptype": "D",
    "dropname": "KOOTENAI",
    "dropdeladd": "109 1ST ST",
    "dropdelcty": "KOOTENAI",
    "dropdelst": "ID",
    "dropdelzpp": 838409998,
    "dropphyadd": "109 1ST ST",
    "dropphycty": "KOOTENAI",
    "dropphyst": "ID",
    "dropphyzpp": 838409998,
    "dropmaladd": "109 1ST ST",
    "dropmalcty": "KOOTENAI",
    "dropmalst": "ID",
    "dropmalzpp": 838409998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082633364,
    "dropsitcph": 2082633364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12735",
    "droptype": "D",
    "dropname": "MINIDOKA",
    "dropdeladd": "402 CHERRY ST",
    "dropdelcty": "MINIDOKA",
    "dropdelst": "ID",
    "dropdelzpp": 833439998,
    "dropphyadd": "402 CHERRY ST",
    "dropphycty": "MINIDOKA",
    "dropphyst": "ID",
    "dropphyzpp": 833439998,
    "dropmaladd": "402 CHERRY ST",
    "dropmalcty": "MINIDOKA",
    "dropmalst": "ID",
    "dropmalzpp": 833439998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084363446,
    "dropsitcph": 2085314101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12807",
    "droptype": "D",
    "dropname": "PICABO",
    "dropdeladd": "18918 HIGHWAY 20",
    "dropdelcty": "PICABO",
    "dropdelst": "ID",
    "dropdelzpp": 833489998,
    "dropphyadd": "18918 HIGHWAY 20",
    "dropphycty": "PICABO",
    "dropphyst": "ID",
    "dropphyzpp": 833489998,
    "dropmaladd": "18918 HIGHWAY 20",
    "dropmalcty": "PICABO",
    "dropmalst": "ID",
    "dropmalzpp": 833489998,
    "dropsitphn": 2087344510,
    "dropsitlph": 2087344510,
    "dropsitcph": 2087883536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ12925",
    "droptype": "D",
    "dropname": "SWEET",
    "dropdeladd": "7555 SWEET OLA HWY",
    "dropdelcty": "SWEET",
    "dropdelst": "ID",
    "dropdelzpp": 836709998,
    "dropphyadd": "7555 SWEET OLA HWY",
    "dropphycty": "SWEET",
    "dropphyst": "ID",
    "dropphyzpp": 836709998,
    "dropmaladd": "7555 SWEET OLA HWY",
    "dropmalcty": "SWEET",
    "dropmalst": "ID",
    "dropmalzpp": 836709998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087818967,
    "dropsitcph": 2087818967,
    "dropfax": 2087932915
  },
  {
    "dcode": "D",
    "dropkey": "CZ12970",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "100 WARREN WAGON RD",
    "dropdelcty": "WARREN",
    "dropdelst": "ID",
    "dropdelzpp": 836719700,
    "dropphyadd": "100 WARREN WAGON RD",
    "dropphycty": "WARREN",
    "dropphyst": "ID",
    "dropphyzpp": 836719700,
    "dropmaladd": "100 WARREN WAGON RD",
    "dropmalcty": "WARREN",
    "dropmalst": "ID",
    "dropmalzpp": 836719700,
    "dropsitphn": 2086343164,
    "dropsitlph": 2084334080,
    "dropsitcph": 2086363360,
    "dropfax": 2086343276
  },
  {
    "dcode": "D",
    "dropkey": "CZ13003",
    "droptype": "D",
    "dropname": "TINIAN",
    "dropdeladd": "1 SAN JOSE VLG",
    "dropdelcty": "TINIAN",
    "dropdelst": "MP",
    "dropdelzpp": 969529997,
    "dropphyadd": "1 SAN JOSE VLG",
    "dropphycty": "TINIAN",
    "dropphyst": "MP",
    "dropphyzpp": 969529997,
    "dropmaladd": "PO BOX 529998",
    "dropmalcty": "TINIAN",
    "dropmalst": "MP",
    "dropmalzpp": 969529998,
    "dropsitphn": 8084233841,
    "dropsitlph": 6702346270,
    "dropsitcph": 6702346270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13056",
    "droptype": "D",
    "dropname": "BOYD",
    "dropdeladd": "1 MONTANA ST",
    "dropdelcty": "BOYD",
    "dropdelst": "MT",
    "dropdelzpp": 590139998,
    "dropphyadd": "1 MONTANA ST",
    "dropphycty": "BOYD",
    "dropphyst": "MT",
    "dropphyzpp": 590139998,
    "dropmaladd": "1 MONTANA ST",
    "dropmalcty": "BOYD",
    "dropmalst": "MT",
    "dropmalzpp": 590139998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4069623288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13074",
    "droptype": "D",
    "dropname": "CANYON CREEK",
    "dropdeladd": "8703 LINCOLN RD W",
    "dropdelcty": "CANYON CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 596339027,
    "dropphyadd": "8703 LINCOLN RD W",
    "dropphycty": "CANYON CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 596339027,
    "dropmaladd": "PO BOX 506",
    "dropmalcty": "CANYON CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 596330506,
    "dropsitphn": 4063682300,
    "dropsitlph": 4066575713,
    "dropsitcph": 4063682300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13103",
    "droptype": "D",
    "dropname": "CORAM",
    "dropdeladd": "10055 US HIGHWAY 2 E",
    "dropdelcty": "CORAM",
    "dropdelst": "MT",
    "dropdelzpp": 599139998,
    "dropphyadd": "10055 US HIGHWAY 2 E",
    "dropphycty": "CORAM",
    "dropphyst": "MT",
    "dropphyzpp": 599139998,
    "dropmaladd": "10055 US HIGHWAY 2 E",
    "dropmalcty": "CORAM",
    "dropmalst": "MT",
    "dropmalzpp": 599139998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4063875002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13117",
    "droptype": "D",
    "dropname": "DE BORGIA",
    "dropdeladd": "132 DEBORGIA HAUGAN FRONTAGE RD",
    "dropdelcty": "DE BORGIA",
    "dropdelst": "MT",
    "dropdelzpp": 598309998,
    "dropphyadd": "132 DEBORGIA HAUGAN FRONTAGE RD",
    "dropphycty": "DE BORGIA",
    "dropphyst": "MT",
    "dropphyzpp": 598309998,
    "dropmaladd": "132 DEBORGIA HAUGAN FRONTAGE RD",
    "dropmalcty": "DE BORGIA",
    "dropmalst": "MT",
    "dropmalzpp": 598309998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4066784268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13121",
    "droptype": "D",
    "dropname": "DELL",
    "dropdeladd": "24 MAIN ST",
    "dropdelcty": "DELL",
    "dropdelst": "MT",
    "dropdelzpp": 597249998,
    "dropphyadd": "24 MAIN ST",
    "dropphycty": "DELL",
    "dropphyst": "MT",
    "dropphyzpp": 597249998,
    "dropmaladd": "24 MAIN ST",
    "dropmalcty": "DELL",
    "dropmalst": "MT",
    "dropmalzpp": 597249998,
    "dropsitphn": 4062763332,
    "dropsitlph": 4066575713,
    "dropsitcph": 4062763332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13182",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "140 GARRISON JUNCTION RD W",
    "dropdelcty": "GARRISON",
    "dropdelst": "MT",
    "dropdelzpp": 597318501,
    "dropphyadd": "140 GARRISON JUNCTION RD W",
    "dropphycty": "GARRISON",
    "dropphyst": "MT",
    "dropphyzpp": 597318501,
    "dropmaladd": "140 GARRISON JUNCTION RD W",
    "dropmalcty": "GARRISON",
    "dropmalst": "MT",
    "dropmalzpp": 597318501,
    "dropsitphn": 4068469961,
    "dropsitlph": 4066575713,
    "dropsitcph": 4068469961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13192",
    "droptype": "D",
    "dropname": "GOLD CREEK",
    "dropdeladd": "512 GOLD CREEK RD",
    "dropdelcty": "GOLD CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 597339998,
    "dropphyadd": "512 GOLD CREEK RD",
    "dropphycty": "GOLD CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 597339998,
    "dropmaladd": "512 GOLD CREEK RD",
    "dropmalcty": "GOLD CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 597339998,
    "dropsitphn": 4062883311,
    "dropsitlph": 4066575713,
    "dropsitcph": 4062883311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13195",
    "droptype": "D",
    "dropname": "GRANTSDALE",
    "dropdeladd": "199 GRANTSDALE CUTOFF RD",
    "dropdelcty": "GRANTSDALE",
    "dropdelst": "MT",
    "dropdelzpp": 598359998,
    "dropphyadd": "199 GRANTSDALE CUTOFF RD",
    "dropphycty": "GRANTSDALE",
    "dropphyst": "MT",
    "dropphyzpp": 598359998,
    "dropmaladd": "199 GRANTSDALE CUTOFF RD",
    "dropmalcty": "GRANTSDALE",
    "dropmalst": "MT",
    "dropmalzpp": 598359998,
    "dropsitphn": 4063630670,
    "dropsitlph": 4066575713,
    "dropsitcph": 4063630670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13230",
    "droptype": "D",
    "dropname": "HUNGRY HORSE",
    "dropdeladd": "8900 US HIGHWAY 2 E",
    "dropdelcty": "HUNGRY HORSE",
    "dropdelst": "MT",
    "dropdelzpp": 599199998,
    "dropphyadd": "8900 US HIGHWAY 2 E",
    "dropphycty": "HUNGRY HORSE",
    "dropphyst": "MT",
    "dropphyzpp": 599199998,
    "dropmaladd": "8900 US HIGHWAY 2 E",
    "dropmalcty": "HUNGRY HORSE",
    "dropmalst": "MT",
    "dropmalzpp": 599199998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4063875821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13253",
    "droptype": "D",
    "dropname": "LAKE MC DONALD",
    "dropdeladd": "350 LAKE MCDONALD LODGE RD",
    "dropdelcty": "LAKE MC DONALD",
    "dropdelst": "MT",
    "dropdelzpp": 599219998,
    "dropphyadd": "110 GOING TO THE SUN RD",
    "dropphycty": "WEST GLACIER",
    "dropphyst": "MT",
    "dropphyzpp": 599369998,
    "dropmaladd": "110 GOING TO THE SUN RD",
    "dropmalcty": "WEST GLACIER",
    "dropmalst": "MT",
    "dropmalzpp": 599369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4068885591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13313",
    "droptype": "D",
    "dropname": "MOSBY",
    "dropdeladd": "1783 MELSTONE RD",
    "dropdelcty": "MOSBY",
    "dropdelst": "MT",
    "dropdelzpp": 590589998,
    "dropphyadd": "265 MELSTONE RD",
    "dropphycty": "MOSBY",
    "dropphyst": "MT",
    "dropphyzpp": 590588507,
    "dropmaladd": "265 MELSTONE RD",
    "dropmalcty": "MOSBY",
    "dropmalst": "MT",
    "dropmalzpp": 590588507,
    "dropsitphn": 4064295621,
    "dropsitlph": 4066575713,
    "dropsitcph": 4064295621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13337",
    "droptype": "D",
    "dropname": "PINESDALE",
    "dropdeladd": "25 E 16TH ST",
    "dropdelcty": "PINESDALE",
    "dropdelst": "MT",
    "dropdelzpp": 598419998,
    "dropphyadd": "25 E 16TH ST",
    "dropphycty": "PINESDALE",
    "dropphyst": "MT",
    "dropphyzpp": 598419998,
    "dropmaladd": "25 E 16TH ST",
    "dropmalcty": "PINESDALE",
    "dropmalst": "MT",
    "dropmalzpp": 598419998,
    "dropsitphn": "",
    "dropsitlph": 4063631448,
    "dropsitcph": 4069615681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13342",
    "droptype": "D",
    "dropname": "POLARIS",
    "dropdeladd": "96 BILLINGS CREEK RD",
    "dropdelcty": "POLARIS",
    "dropdelst": "MT",
    "dropdelzpp": 597469998,
    "dropphyadd": "96 BILLINGS CREEK RD",
    "dropphycty": "POLARIS",
    "dropphyst": "MT",
    "dropphyzpp": 597469998,
    "dropmaladd": "96 BILLINGS CREEK RD",
    "dropmalcty": "POLARIS",
    "dropmalst": "MT",
    "dropmalzpp": 597469998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4068343505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13373",
    "droptype": "D",
    "dropname": "ROLLINS",
    "dropdeladd": "87867 US HIGHWAY 93 S",
    "dropdelcty": "ROLLINS",
    "dropdelst": "MT",
    "dropdelzpp": 599319998,
    "dropphyadd": "87867 US HIGHWAY 93 S",
    "dropphycty": "ROLLINS",
    "dropphyst": "MT",
    "dropphyzpp": 599319998,
    "dropmaladd": "87867 US HIGHWAY 93 S",
    "dropmalcty": "ROLLINS",
    "dropmalst": "MT",
    "dropmalzpp": 599319998,
    "dropsitphn": 4068443942,
    "dropsitlph": 4066575713,
    "dropsitcph": 4068443942,
    "dropfax": 4068443943
  },
  {
    "dcode": "D",
    "dropkey": "CZ13475",
    "droptype": "D",
    "dropname": "WINSTON",
    "dropdeladd": "6480 US HIGHWAY 287",
    "dropdelcty": "WINSTON",
    "dropdelst": "MT",
    "dropdelzpp": 596479705,
    "dropphyadd": "6480 US HIGHWAY 287",
    "dropphycty": "WINSTON",
    "dropphyst": "MT",
    "dropphyzpp": 596479705,
    "dropmaladd": "6480 US HIGHWAY 287",
    "dropmalcty": "WINSTON",
    "dropmalst": "MT",
    "dropmalzpp": 596479705,
    "dropsitphn": 4066576713,
    "dropsitlph": 4066576713,
    "dropsitcph": 4062277080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13563",
    "droptype": "D",
    "dropname": "BRIMHALL",
    "dropdeladd": "101 ROUTE 9",
    "dropdelcty": "BRIMHALL",
    "dropdelst": "NM",
    "dropdelzpp": 873101001,
    "dropphyadd": "101 ROUTE 9",
    "dropphycty": "BRIMHALL",
    "dropphyst": "NM",
    "dropphyzpp": 873101001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIMHALL",
    "dropmalst": "NM",
    "dropmalzpp": 873109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057352032,
    "dropsitcph": 5057352032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13627",
    "droptype": "D",
    "dropname": "CLINES CORNERS",
    "dropdeladd": "1 YACHT CLUB DR",
    "dropdelcty": "CLINES CORNERS",
    "dropdelst": "NM",
    "dropdelzpp": 870709998,
    "dropphyadd": "1 YACHT CLUB DR",
    "dropphycty": "CLINES CORNERS",
    "dropphyst": "NM",
    "dropphyzpp": 870709998,
    "dropmaladd": "514 ROUTE 66",
    "dropmalcty": "MORIARTY",
    "dropmalst": "NM",
    "dropmalzpp": 870359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754725488,
    "dropsitcph": 5754725488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13637",
    "droptype": "D",
    "dropname": "CONCHAS DAM",
    "dropdeladd": "101 NICKLE LN",
    "dropdelcty": "CONCHAS DAM",
    "dropdelst": "NM",
    "dropdelzpp": 884169998,
    "dropphyadd": "101 NICKLE LN",
    "dropphycty": "CONCHAS DAM",
    "dropphyst": "NM",
    "dropphyzpp": 884169998,
    "dropmaladd": "220 S 1ST ST",
    "dropmalcty": "TUCUMCARI",
    "dropmalst": "NM",
    "dropmalzpp": 884019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758689610,
    "dropsitcph": 5758689610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13651",
    "droptype": "D",
    "dropname": "COUNSELOR",
    "dropdeladd": "9766 HIGHWAY 550",
    "dropdelcty": "COUNSELOR",
    "dropdelst": "NM",
    "dropdelzpp": 870189998,
    "dropphyadd": "9766 HIGHWAY 550",
    "dropphycty": "COUNSELOR",
    "dropphyst": "NM",
    "dropphyzpp": 870189998,
    "dropmaladd": "9766 HIGHWAY 550",
    "dropmalcty": "COUNSELOR",
    "dropmalst": "NM",
    "dropmalzpp": 870189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056753135,
    "dropsitcph": 5056753135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13756",
    "droptype": "D",
    "dropname": "GAMERCO",
    "dropdeladd": "909 CHINO LOOP",
    "dropdelcty": "GAMERCO",
    "dropdelst": "NM",
    "dropdelzpp": 873179998,
    "dropphyadd": "909 CHINO LOOP",
    "dropphycty": "GAMERCO",
    "dropphyst": "NM",
    "dropphyzpp": 873179998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAMERCO",
    "dropmalst": "NM",
    "dropmalzpp": 873179997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058636897,
    "dropsitcph": 5058636897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13962",
    "droptype": "D",
    "dropname": "NEWCOMB",
    "dropdeladd": "7266 HIGHWAY 491 S",
    "dropdelcty": "NEWCOMB",
    "dropdelst": "NM",
    "dropdelzpp": 874559998,
    "dropphyadd": "7266 HIGHWAY 491 S",
    "dropphycty": "NEWCOMB",
    "dropphyst": "NM",
    "dropphyzpp": 874559998,
    "dropmaladd": "7266 HIGHWAY 491 S",
    "dropmalcty": "NEWCOMB",
    "dropmalst": "NM",
    "dropmalzpp": 874559998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056963333,
    "dropsitcph": 5056963333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ13979",
    "droptype": "D",
    "dropname": "OJO FELIZ",
    "dropdeladd": "138 SAN ISIDRO RD",
    "dropdelcty": "OJO FELIZ",
    "dropdelst": "NM",
    "dropdelzpp": 877351000,
    "dropphyadd": "138 SAN ISIDRO RD",
    "dropphycty": "OJO FELIZ",
    "dropphyst": "NM",
    "dropphyzpp": 877351000,
    "dropmaladd": "610 5TH ST",
    "dropmalcty": "SPRINGER",
    "dropmalst": "NM",
    "dropmalzpp": 877479998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753876471,
    "dropsitcph": 5753876471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14128",
    "droptype": "D",
    "dropname": "SANOSTEE",
    "dropdeladd": "9 STATE HIGHWAY 491 S",
    "dropdelcty": "SANOSTEE",
    "dropdelst": "NM",
    "dropdelzpp": 874619998,
    "dropphyadd": "9 STATE HIGHWAY 491 S",
    "dropphycty": "SANOSTEE",
    "dropphyst": "NM",
    "dropphyzpp": 874619998,
    "dropmaladd": "9 STATE HIGHWAY 491 S",
    "dropmalcty": "SANOSTEE",
    "dropmalst": "NM",
    "dropmalzpp": 874619998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057232478,
    "dropsitcph": 5057232478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14136",
    "droptype": "D",
    "dropname": "SANTA TERESA",
    "dropdeladd": "5290 MCNUTT RD STE 201",
    "dropdelcty": "SANTA TERESA",
    "dropdelst": "NM",
    "dropdelzpp": 880089694,
    "dropphyadd": "5290 MCNUTT RD STE 211",
    "dropphycty": "SANTA TERESA",
    "dropphyst": "NM",
    "dropphyzpp": 880089694,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA TERESA",
    "dropmalst": "NM",
    "dropmalzpp": 880089998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755891508,
    "dropsitcph": 5755891508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14140",
    "droptype": "D",
    "dropname": "SAPELLO",
    "dropdeladd": "1007 STATE HIGHWAY 518",
    "dropdelcty": "SAPELLO",
    "dropdelst": "NM",
    "dropdelzpp": 877451000,
    "dropphyadd": "1007 NM HIGHWAY 518",
    "dropphycty": "SAPELLO",
    "dropphyst": "NM",
    "dropphyzpp": 877451000,
    "dropmaladd": "1001 DOUGLAS AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NM",
    "dropmalzpp": 877019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054259748,
    "dropsitcph": 5054259748,
    "dropfax": 5052459806
  },
  {
    "dcode": "D",
    "dropkey": "CZ14154",
    "droptype": "D",
    "dropname": "SHEEP SPRINGS",
    "dropdeladd": "491 RED MESA RD",
    "dropdelcty": "SHEEP SPRINGS",
    "dropdelst": "NM",
    "dropdelzpp": 873649998,
    "dropphyadd": "491 RED MESA RD",
    "dropphycty": "SHEEP SPRINGS",
    "dropphyst": "NM",
    "dropphyzpp": 873649998,
    "dropmaladd": "491 RED MESA RD",
    "dropmalcty": "SHEEP SPRINGS",
    "dropmalst": "NM",
    "dropmalzpp": 873649998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057324211,
    "dropsitcph": 5057324211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14241",
    "droptype": "D",
    "dropname": "TRUCHAS",
    "dropdeladd": "10 COUNTY ROAD 75",
    "dropdelcty": "TRUCHAS",
    "dropdelst": "NM",
    "dropdelzpp": 875789998,
    "dropphyadd": "10 COUNTY ROAD 75",
    "dropphycty": "TRUCHAS",
    "dropphyst": "NM",
    "dropphyzpp": 875789998,
    "dropmaladd": "10 COUNTY ROAD 75",
    "dropmalcty": "TRUCHAS",
    "dropmalst": "NM",
    "dropmalzpp": 875789998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056891044,
    "dropsitcph": 5053514611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14333",
    "droptype": "D",
    "dropname": "CAL NEV ARI",
    "dropdeladd": "1 PIUTE VALLEY DR",
    "dropdelcty": "CAL NEV ARI",
    "dropdelst": "NV",
    "dropdelzpp": 890399800,
    "dropphyadd": "1 PIUTE VALLEY DR",
    "dropphycty": "CAL NEV ARI",
    "dropphyst": "NV",
    "dropphyzpp": 890399800,
    "dropmaladd": "PO BOX 430",
    "dropmalcty": "CAL NEV ARI",
    "dropmalst": "NV",
    "dropmalzpp": 890390430,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022971219,
    "dropsitcph": 7022971118,
    "dropfax": 7022971043
  },
  {
    "dcode": "D",
    "dropkey": "CZ14387",
    "droptype": "D",
    "dropname": "DUCKWATER",
    "dropdeladd": "511 DUCKWATER FALLS RD",
    "dropdelcty": "DUCKWATER",
    "dropdelst": "NV",
    "dropdelzpp": 893149800,
    "dropphyadd": "511 DUCKWATER FALLS RD",
    "dropphycty": "DUCKWATER",
    "dropphyst": "NV",
    "dropphyzpp": 893149800,
    "dropmaladd": "PO BOX 149998",
    "dropmalcty": "DUCKWATER",
    "dropmalst": "NV",
    "dropmalzpp": 893149998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752894537,
    "dropfax": 7752899284
  },
  {
    "dcode": "D",
    "dropkey": "CZ14474",
    "droptype": "D",
    "dropname": "LAMOILLE",
    "dropdeladd": "787 LAMOILLE HWY",
    "dropdelcty": "LAMOILLE",
    "dropdelst": "NV",
    "dropdelzpp": 898289995,
    "dropphyadd": "787 LAMOILLE HWY",
    "dropphycty": "LAMOILLE",
    "dropphyst": "NV",
    "dropphyzpp": 898289995,
    "dropmaladd": "PO BOX 289998",
    "dropmalcty": "LAMOILLE",
    "dropmalst": "NV",
    "dropmalzpp": 898289998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757779828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14587",
    "droptype": "D",
    "dropname": "RUBY VALLEY",
    "dropdeladd": "HC 60 BOX 515",
    "dropdelcty": "RUBY VALLEY",
    "dropdelst": "NV",
    "dropdelzpp": 898339802,
    "dropphyadd": "HC 60 BOX 515",
    "dropphycty": "RUBY VALLEY",
    "dropphyst": "NV",
    "dropphyzpp": 898339802,
    "dropmaladd": "HC 60 BOX 515",
    "dropmalcty": "RUBY VALLEY",
    "dropmalst": "NV",
    "dropmalzpp": 898339802,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757792268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14754",
    "droptype": "D",
    "dropname": "BAY CITY",
    "dropdeladd": "9220 5TH ST",
    "dropdelcty": "BAY CITY",
    "dropdelst": "OR",
    "dropdelzpp": 971079701,
    "dropphyadd": "9220 5TH ST",
    "dropphycty": "BAY CITY",
    "dropphyst": "OR",
    "dropphyzpp": 971079701,
    "dropmaladd": "PO BOX 3264",
    "dropmalcty": "BAY CITY",
    "dropmalst": "OR",
    "dropmalzpp": 971073264,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033772595,
    "dropsitcph": 5033772004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14774",
    "droptype": "D",
    "dropname": "BLACHLY",
    "dropdeladd": "20448 HIGHWAY 36",
    "dropdelcty": "BLACHLY",
    "dropdelst": "OR",
    "dropdelzpp": 974129713,
    "dropphyadd": "20448 HIGHWAY 36",
    "dropphycty": "BLACHLY",
    "dropphyst": "OR",
    "dropphyzpp": 974129713,
    "dropmaladd": "PO BOX 20",
    "dropmalcty": "BLACHLY",
    "dropmalst": "OR",
    "dropmalzpp": 974120020,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419253344,
    "dropsitcph": 5419253344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14852",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "90378 ALBACORE ST",
    "dropdelcty": "COOS BAY",
    "dropdelst": "OR",
    "dropdelzpp": 974209601,
    "dropphyadd": "90378 ALBACORE ST",
    "dropphycty": "COOS BAY",
    "dropphyst": "OR",
    "dropphyzpp": 974209601,
    "dropmaladd": "PO BOX 5998",
    "dropmalcty": "COOS BAY",
    "dropmalst": "OR",
    "dropmalzpp": 974201516,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412675122,
    "dropsitcph": 5418883887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14859",
    "droptype": "D",
    "dropname": "CHRISTMAS VALLEY",
    "dropdeladd": "86957 CHRISTMAS VALLEY HWY",
    "dropdelcty": "CHRISTMAS VALLEY",
    "dropdelst": "OR",
    "dropdelzpp": 976419700,
    "dropphyadd": "86957 CHRISTMAS VALLEY HWY",
    "dropphycty": "CHRISTMAS VALLEY",
    "dropphyst": "OR",
    "dropphyzpp": 976419700,
    "dropmaladd": "86957 CHRISTMAS VALLEY HWY",
    "dropmalcty": "CHRISTMAS VALLEY",
    "dropmalst": "OR",
    "dropmalzpp": 976419700,
    "dropsitphn": 5417761348,
    "dropsitlph": 5415762147,
    "dropsitcph": 5415762657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14870",
    "droptype": "D",
    "dropname": "COBURG",
    "dropdeladd": "91145 N WILLAMETTE ST",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974089700,
    "dropphyadd": "91145 N WILLAMETTE ST",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974089700,
    "dropmaladd": "PO BOX 8068",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974081301,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413458669,
    "dropsitcph": 5413458669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14889",
    "droptype": "D",
    "dropname": "CRATER LAKE",
    "dropdeladd": "1 SAGER BLDG",
    "dropdelcty": "CRATER LAKE",
    "dropdelst": "OR",
    "dropdelzpp": 976049000,
    "dropphyadd": "1 SAGER BLDG",
    "dropphycty": "CRATER LAKE",
    "dropphyst": "OR",
    "dropphyzpp": 976049000,
    "dropmaladd": "317 S 7TH ST",
    "dropmalcty": "KLAMATH FALLS",
    "dropmalst": "OR",
    "dropmalzpp": 976016119,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417832745,
    "dropsitcph": 5415943115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14912",
    "droptype": "D",
    "dropname": "DALE",
    "dropdeladd": "48388 HWY 395 N",
    "dropdelcty": "UKIAH",
    "dropdelst": "OR",
    "dropdelzpp": 978805001,
    "dropphyadd": "48388 HWY 395 N",
    "dropphycty": "UKIAH",
    "dropphyst": "OR",
    "dropphyzpp": 978805001,
    "dropmaladd": "PO BOX 2051",
    "dropmalcty": "DALE",
    "dropmalst": "OR",
    "dropmalzpp": 978800951,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414273332,
    "dropsitcph": 5414273332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14938",
    "droptype": "D",
    "dropname": "DIAMOND LAKE",
    "dropdeladd": "350 RESORT DR",
    "dropdelcty": "DIAMOND LAKE",
    "dropdelst": "OR",
    "dropdelzpp": 977319710,
    "dropphyadd": "350 RESORT DR",
    "dropphycty": "DIAMOND LAKE",
    "dropphyst": "OR",
    "dropphyzpp": 977319710,
    "dropmaladd": "125 G C PALMER ST",
    "dropmalcty": "CHEMULT",
    "dropmalst": "OR",
    "dropmalzpp": 977319733,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413654411,
    "dropsitcph": 5413654411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ14990",
    "droptype": "D",
    "dropname": "FALL CREEK",
    "dropdeladd": "39074 JASPER LOWELL RD",
    "dropdelcty": "FALL CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 974389724,
    "dropphyadd": "39074 JASPER LOWELL RD",
    "dropphycty": "FALL CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 974389724,
    "dropmaladd": "39074 JASPER LOWELL RD",
    "dropmalcty": "FALL CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 974389724,
    "dropsitphn": "",
    "dropsitlph": 5419373178,
    "dropsitcph": 5417463068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15034",
    "droptype": "D",
    "dropname": "GEARHART",
    "dropdeladd": "546 PACIFIC WAY",
    "dropdelcty": "SEASIDE",
    "dropdelst": "OR",
    "dropdelzpp": 971384100,
    "dropphyadd": "546 PACIFIC WAY",
    "dropphycty": "SEASIDE",
    "dropphyst": "OR",
    "dropphyzpp": 971384100,
    "dropmaladd": "546 PACIFIC WAY",
    "dropmalcty": "SEASIDE",
    "dropmalst": "OR",
    "dropmalzpp": 971384100,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037385283,
    "dropsitcph": 5037387220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15045",
    "droptype": "D",
    "dropname": "GLENEDEN BEACH",
    "dropdeladd": "6645 GLENEDEN BEACH LOOP",
    "dropdelcty": "GLENEDEN BEACH",
    "dropdelst": "OR",
    "dropdelzpp": 973889700,
    "dropphyadd": "6645 GLENEDEN BEACH LOOP",
    "dropphycty": "GLENEDEN BEACH",
    "dropphyst": "OR",
    "dropphyzpp": 973889700,
    "dropmaladd": "6645 GLENEDEN BEACH LOOP",
    "dropmalcty": "GLENEDEN BEACH",
    "dropmalst": "OR",
    "dropmalzpp": 973889700,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419947910,
    "dropsitcph": 5417643203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15133",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "36763 JASPER LOWELL RD",
    "dropdelcty": "JASPER",
    "dropdelst": "OR",
    "dropdelzpp": 974389705,
    "dropphyadd": "36763 JASPER LOWELL RD",
    "dropphycty": "JASPER",
    "dropphyst": "OR",
    "dropphyzpp": 974389705,
    "dropmaladd": "PO BOX 2078",
    "dropmalcty": "JASPER",
    "dropmalst": "OR",
    "dropmalzpp": 974380299,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417462032,
    "dropsitcph": 5417462032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15198",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "320 E MAIN ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "OR",
    "dropdelzpp": 978393000,
    "dropphyadd": "320 E MAIN ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "OR",
    "dropphyzpp": 978393000,
    "dropmaladd": "167 N MAIN ST",
    "dropmalcty": "HEPPNER",
    "dropmalst": "OR",
    "dropmalzpp": 978369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 9716769630,
    "dropsitcph": 9716769630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15207",
    "droptype": "D",
    "dropname": "LOGSDEN",
    "dropdeladd": "7550 LOGSDEN RD",
    "dropdelcty": "LOGSDEN",
    "dropdelst": "OR",
    "dropdelzpp": 973579701,
    "dropphyadd": "7550 LOGSDEN RD",
    "dropphycty": "LOGSDEN",
    "dropphyst": "OR",
    "dropphyzpp": 973579701,
    "dropmaladd": "295 SE GAITHER ST",
    "dropmalcty": "SILETZ",
    "dropmalst": "OR",
    "dropmalzpp": 973809998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414442088,
    "dropsitcph": 5414442088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15246",
    "droptype": "D",
    "dropname": "MEACHAM",
    "dropdeladd": "64348 OLD OREGON TRAIL RD",
    "dropdelcty": "MEACHAM",
    "dropdelst": "OR",
    "dropdelzpp": 978591199,
    "dropphyadd": "64348 OLD OREGON TRAIL RD",
    "dropphycty": "MEACHAM",
    "dropphyst": "OR",
    "dropphyzpp": 978591199,
    "dropmaladd": "64348 OLD OREGON TRAIL RD",
    "dropmalcty": "MEACHAM",
    "dropmalst": "OR",
    "dropmalzpp": 978591199,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419832476,
    "dropsitcph": 5419832520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15320",
    "droptype": "D",
    "dropname": "NESKOWIN",
    "dropdeladd": "48990 HIGHWAY 101 S",
    "dropdelcty": "NESKOWIN",
    "dropdelst": "OR",
    "dropdelzpp": 971499731,
    "dropphyadd": "48990 HIGHWAY 101 S UNIT B",
    "dropphycty": "NESKOWIN",
    "dropphyst": "OR",
    "dropphyzpp": 971499731,
    "dropmaladd": "48990 HIGHWAY 101 S UNIT B",
    "dropmalcty": "NESKOWIN",
    "dropmalst": "OR",
    "dropmalzpp": 971499731,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033923393,
    "dropsitcph": 5033924466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15321",
    "droptype": "D",
    "dropname": "NETARTS",
    "dropdeladd": "1355 PHELPS AVE W STE 1",
    "dropdelcty": "NETARTS",
    "dropdelst": "OR",
    "dropdelzpp": 971439512,
    "dropphyadd": "4945 NETARTS HWY W",
    "dropphycty": "TILLAMOOK",
    "dropphyst": "OR",
    "dropphyzpp": 971419467,
    "dropmaladd": "PO BOX 84",
    "dropmalcty": "NETARTS",
    "dropmalst": "OR",
    "dropmalzpp": 971430084,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038426973,
    "dropsitcph": 5038153700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15403",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "84899 TILLICUM AVE STE 3",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "OR",
    "dropdelzpp": 974559699,
    "dropphyadd": "84899 TILLICUM AVE STE 3",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "OR",
    "dropphyzpp": 974559699,
    "dropmaladd": "84899 TILLICUM AVE STE 3",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "OR",
    "dropmalzpp": 974559699,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417441975,
    "dropsitcph": 5417441975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15419",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "52451 HIGHWAY 78",
    "dropdelcty": "PRINCETON",
    "dropdelst": "OR",
    "dropdelzpp": 977219537,
    "dropphyadd": "52451 HIGHWAY 78",
    "dropphycty": "PRINCETON",
    "dropphyst": "OR",
    "dropphyzpp": 977219537,
    "dropmaladd": "52451 HIGHWAY 78",
    "dropmalcty": "PRINCETON",
    "dropmalst": "OR",
    "dropmalzpp": 977219537,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414932721,
    "dropsitcph": 5414932721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15521",
    "droptype": "D",
    "dropname": "SOUTH BEACH",
    "dropdeladd": "4909 S COAST HWY STE 10",
    "dropdelcty": "SOUTH BEACH",
    "dropdelst": "OR",
    "dropdelzpp": 973669655,
    "dropphyadd": "4909 S COAST HWY STE 10",
    "dropphycty": "SOUTH BEACH",
    "dropphyst": "OR",
    "dropphyzpp": 973669655,
    "dropmaladd": "310 SW 2ND ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "OR",
    "dropmalzpp": 973659998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412652664,
    "dropsitcph": 5418673986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15532",
    "droptype": "D",
    "dropname": "SPRAGUE RIVER",
    "dropdeladd": "23402 SPRAGUE RIVER RD",
    "dropdelcty": "SPRAGUE RIVER",
    "dropdelst": "OR",
    "dropdelzpp": 976398618,
    "dropphyadd": "23402 SPRAGUE RIVER RD",
    "dropphycty": "SPRAGUE RIVER",
    "dropphyst": "OR",
    "dropphyzpp": 976398618,
    "dropmaladd": "23402 SPRAGUE RIVER RD",
    "dropmalcty": "SPRAGUE RIVER",
    "dropmalst": "OR",
    "dropmalzpp": 976399998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415332251,
    "dropsitcph": 5415332251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15615",
    "droptype": "D",
    "dropname": "SUMMERVILLE",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "SUMMERVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 978768174,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "SUMMERVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 978768174,
    "dropmaladd": "510 RUCKMAN AVE",
    "dropmalcty": "IMBLER",
    "dropmalst": "OR",
    "dropmalzpp": 978419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415344111,
    "dropsitcph": 5415346701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15651",
    "droptype": "D",
    "dropname": "TOLOVANA PARK",
    "dropdeladd": "3140 S HEMLOCK ST",
    "dropdelcty": "TOLOVANA PARK",
    "dropdelst": "OR",
    "dropdelzpp": 971459997,
    "dropphyadd": "3140 S HEMLOCK ST",
    "dropphycty": "TOLOVANA PARK",
    "dropphyst": "OR",
    "dropphyzpp": 971459997,
    "dropmaladd": "163 N HEMLOCK",
    "dropmalcty": "CANNON BEACH",
    "dropmalst": "OR",
    "dropmalzpp": 971109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5034362822,
    "dropsitcph": 5034362822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15744",
    "droptype": "D",
    "dropname": "WILDERVILLE",
    "dropdeladd": "7845 REDWOOD HWY",
    "dropdelcty": "WILDERVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 975439721,
    "dropphyadd": "7845 OLD REDWOOD HWY",
    "dropphycty": "WILDERVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 975439721,
    "dropmaladd": "7845 OLD REDWOOD HWY",
    "dropmalcty": "WILDERVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 975439721,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414797526,
    "dropsitcph": 5414763924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15756",
    "droptype": "D",
    "dropname": "WINCHESTER BAY",
    "dropdeladd": "245 8TH ST",
    "dropdelcty": "REEDSPORT",
    "dropdelst": "OR",
    "dropdelzpp": 974679737,
    "dropphyadd": "225 8TH ST",
    "dropphycty": "REEDSPORT",
    "dropphyst": "OR",
    "dropphyzpp": 974678792,
    "dropmaladd": "225 8TH ST",
    "dropmalcty": "REEDSPORT",
    "dropmalst": "OR",
    "dropmalzpp": 974679805,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412712632,
    "dropsitcph": 5412712632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15782",
    "droptype": "D",
    "dropname": "ALTA",
    "dropdeladd": "10351 E STATE HIGHWAY 210",
    "dropdelcty": "ALTA",
    "dropdelst": "UT",
    "dropdelzpp": 840929501,
    "dropphyadd": "10351 E STATE HIGHWAY 210",
    "dropphycty": "ALTA",
    "dropphyst": "UT",
    "dropphyzpp": 840929501,
    "dropmaladd": "PO BOX 8000",
    "dropmalcty": "SANDY",
    "dropmalst": "UT",
    "dropmalzpp": 840928000,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 8017422142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15784",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "11 N MAIN ST",
    "dropdelcty": "ALTON",
    "dropdelst": "UT",
    "dropdelzpp": 847108001,
    "dropphyadd": "11 S 100 W",
    "dropphycty": "ALTON",
    "dropphyst": "UT",
    "dropphyzpp": 847108000,
    "dropmaladd": "11 S 100 W",
    "dropmalcty": "ALTON",
    "dropmalst": "UT",
    "dropmalzpp": 847108000,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356482384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15791",
    "droptype": "D",
    "dropname": "ANETH",
    "dropdeladd": "10 STATE HWY 262",
    "dropdelcty": "ANETH",
    "dropdelst": "UT",
    "dropdelzpp": 845108001,
    "dropphyadd": "10 STATE HWY 262",
    "dropphycty": "ANETH",
    "dropphyst": "UT",
    "dropphyzpp": 845108001,
    "dropmaladd": "PO BOX 109998",
    "dropmalcty": "ANETH",
    "dropmalst": "UT",
    "dropmalzpp": 845109998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356513244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15794",
    "droptype": "D",
    "dropname": "ANTIMONY",
    "dropdeladd": "130 N HIGHWAY 22",
    "dropdelcty": "ANTIMONY",
    "dropdelst": "UT",
    "dropdelzpp": 847128001,
    "dropphyadd": "130 N HIGHWAY 22",
    "dropphycty": "ANTIMONY",
    "dropphyst": "UT",
    "dropphyzpp": 847128001,
    "dropmaladd": "PO BOX 129998",
    "dropmalcty": "ANTIMONY",
    "dropmalst": "UT",
    "dropmalzpp": 847129998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356243318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15818",
    "droptype": "D",
    "dropname": "BIG WATER",
    "dropdeladd": "175 AARON BURR",
    "dropdelcty": "BIG WATER",
    "dropdelst": "UT",
    "dropdelzpp": 847418001,
    "dropphyadd": "175 AARON BURR",
    "dropphycty": "BIG WATER",
    "dropphyst": "UT",
    "dropphyzpp": 847418001,
    "dropmaladd": "PO BOX 419997",
    "dropmalcty": "KANAB",
    "dropmalst": "UT",
    "dropmalzpp": 847419997,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356753982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15835",
    "droptype": "D",
    "dropname": "BOULDER",
    "dropdeladd": "325 N 100 E",
    "dropdelcty": "BOULDER",
    "dropdelst": "UT",
    "dropdelzpp": 847168001,
    "dropphyadd": "325 N 100 E",
    "dropphycty": "BOULDER",
    "dropphyst": "UT",
    "dropphyzpp": 847168001,
    "dropmaladd": "PO BOX 169998",
    "dropmalcty": "BOULDER",
    "dropmalst": "UT",
    "dropmalzpp": 847169998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4353357932,
    "dropfax": 4358264437
  },
  {
    "dcode": "D",
    "dropkey": "CZ15839",
    "droptype": "D",
    "dropname": "BRIAN HEAD",
    "dropdeladd": "90 CIRCLE DR",
    "dropdelcty": "BRIAN HEAD",
    "dropdelst": "UT",
    "dropdelzpp": 847198002,
    "dropphyadd": "90 CIRCLE DR",
    "dropphycty": "BRIAN HEAD",
    "dropphyst": "UT",
    "dropphyzpp": 847198002,
    "dropmaladd": "PO BOX 199998",
    "dropmalcty": "BRIAN HEAD",
    "dropmalst": "UT",
    "dropmalzpp": 847199998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356772040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15849",
    "droptype": "D",
    "dropname": "BULLFROG",
    "dropdeladd": "89 N HIGHWAY 276",
    "dropdelcty": "LAKE POWELL",
    "dropdelst": "UT",
    "dropdelzpp": 845338002,
    "dropphyadd": "89 N HIGHWAY 276",
    "dropphycty": "LAKE POWELL",
    "dropphyst": "UT",
    "dropphyzpp": 845338002,
    "dropmaladd": "PO BOX 409998",
    "dropmalcty": "LAKE POWELL",
    "dropmalst": "UT",
    "dropmalzpp": 845339997,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356842219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ15860",
    "droptype": "D",
    "dropname": "CANNONVILLE",
    "dropdeladd": "25 S REDROCK DR",
    "dropdelcty": "CANNONVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847188001,
    "dropphyadd": "25 S REDROCK DR",
    "dropphycty": "CANNONVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847188001,
    "dropmaladd": "PO BOX 189998",
    "dropmalcty": "CANNONVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847189998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356798413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16014",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "130 E CENTER ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "UT",
    "dropdelzpp": 847308001,
    "dropphyadd": "130 E CENTER ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "UT",
    "dropphyzpp": 847308001,
    "dropmaladd": "PO BOX 309998",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "UT",
    "dropmalzpp": 847309998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358962078,
    "dropsitcph": 4358969156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16070",
    "droptype": "D",
    "dropname": "IVINS",
    "dropdeladd": "575 S 200 E STE 3",
    "dropdelcty": "IVINS",
    "dropdelst": "UT",
    "dropdelzpp": 847388001,
    "dropphyadd": "575 S 200 E STE 3",
    "dropphycty": "IVINS",
    "dropphyst": "UT",
    "dropphyzpp": 847388001,
    "dropmaladd": "PO BOX 389998",
    "dropmalcty": "IVINS",
    "dropmalst": "UT",
    "dropmalzpp": 847389998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356282112,
    "dropfax": 4356281381
  },
  {
    "dcode": "D",
    "dropkey": "CZ16087",
    "droptype": "D",
    "dropname": "KOOSHAREM",
    "dropdeladd": "5 N MAIN ST",
    "dropdelcty": "KOOSHAREM",
    "dropdelst": "UT",
    "dropdelzpp": 847448001,
    "dropphyadd": "5 N MAIN ST",
    "dropphycty": "KOOSHAREM",
    "dropphyst": "UT",
    "dropphyzpp": 847448001,
    "dropmaladd": "PO BOX 449998",
    "dropmalcty": "KOOSHAREM",
    "dropmalst": "UT",
    "dropmalzpp": 847449998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356387304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16105",
    "droptype": "D",
    "dropname": "LEAMINGTON",
    "dropdeladd": "291 W MAIN ST",
    "dropdelcty": "LEAMINGTON",
    "dropdelst": "UT",
    "dropdelzpp": 846388001,
    "dropphyadd": "291 W MAIN ST",
    "dropphycty": "LEAMINGTON",
    "dropphyst": "UT",
    "dropphyzpp": 846388001,
    "dropmaladd": "PO BOX 389998",
    "dropmalcty": "LEAMINGTON",
    "dropmalst": "UT",
    "dropmalzpp": 846389998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358579132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16106",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "545 N MAIN ST",
    "dropdelcty": "LEEDS",
    "dropdelst": "UT",
    "dropdelzpp": 847468001,
    "dropphyadd": "545 N MAIN ST",
    "dropphycty": "LEEDS",
    "dropphyst": "UT",
    "dropphyzpp": 847468001,
    "dropmaladd": "PO BOX 469998",
    "dropmalcty": "LEEDS",
    "dropmalst": "UT",
    "dropmalzpp": 847469998,
    "dropsitphn": "",
    "dropsitlph": 4356354781,
    "dropsitcph": 4358798195,
    "dropfax": 4358796998
  },
  {
    "dcode": "D",
    "dropkey": "CZ16137",
    "droptype": "D",
    "dropname": "MEXICAN HAT",
    "dropdeladd": "2296 US HIGHWAY 163",
    "dropdelcty": "MEXICAN HAT",
    "dropdelst": "UT",
    "dropdelzpp": 845318001,
    "dropphyadd": "2956 S US HIGHWAY 163",
    "dropphycty": "MEXICAN HAT",
    "dropphyst": "UT",
    "dropphyzpp": 845317707,
    "dropmaladd": "PO BOX 319998",
    "dropmalcty": "MEXICAN HAT",
    "dropmalst": "UT",
    "dropmalzpp": 845319998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356832214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16203",
    "droptype": "D",
    "dropname": "PARAGONAH",
    "dropdeladd": "50 N 100 W",
    "dropdelcty": "PARAGONAH",
    "dropdelst": "UT",
    "dropdelzpp": 847608001,
    "dropphyadd": "50 N 100 W",
    "dropphycty": "PARAGONAH",
    "dropphyst": "UT",
    "dropphyzpp": 847608001,
    "dropmaladd": "PO BOX 609998",
    "dropmalcty": "PARAGONAH",
    "dropmalst": "UT",
    "dropmalzpp": 847609998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354773043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16243",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "43 E MAIN ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847638001,
    "dropphyadd": "43 E MAIN ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847638001,
    "dropmaladd": "PO BOX 639998",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847639998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357720118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16266",
    "droptype": "D",
    "dropname": "SCIPIO",
    "dropdeladd": "65 W 200 S",
    "dropdelcty": "SCIPIO",
    "dropdelst": "UT",
    "dropdelzpp": 846568001,
    "dropphyadd": "130 N STATE ST",
    "dropphycty": "SCIPIO",
    "dropphyst": "UT",
    "dropphyzpp": 846569989,
    "dropmaladd": "PO BOX 560019",
    "dropmalcty": "SCIPIO",
    "dropmalst": "UT",
    "dropmalzpp": 846560019,
    "dropsitphn": 4355313730,
    "dropsitlph": 4355313730,
    "dropsitcph": 4355313730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16274",
    "droptype": "D",
    "dropname": "SNOWBIRD",
    "dropdeladd": "9320 E STATE HIGHWAY 210",
    "dropdelcty": "SNOWBIRD",
    "dropdelst": "UT",
    "dropdelzpp": 840929500,
    "dropphyadd": "9320 E STATE HIGHWAY 210",
    "dropphycty": "SNOWBIRD",
    "dropphyst": "UT",
    "dropphyzpp": 840929500,
    "dropmaladd": "PO BOX 929998",
    "dropmalcty": "SANDY",
    "dropmalst": "UT",
    "dropmalzpp": 840929998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 8013591720,
    "dropfax": 8017422376
  },
  {
    "dcode": "D",
    "dropkey": "CZ16299",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "111 N MAIN ST",
    "dropdelcty": "STERLING",
    "dropdelst": "UT",
    "dropdelzpp": 846658001,
    "dropphyadd": "111 N MAIN ST",
    "dropphycty": "STERLING",
    "dropphyst": "UT",
    "dropphyzpp": 846658001,
    "dropmaladd": "PO BOX 659998",
    "dropmalcty": "STERLING",
    "dropmalst": "UT",
    "dropmalzpp": 846659998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358354867,
    "dropfax": 4358354866
  },
  {
    "dcode": "D",
    "dropkey": "CZ16304",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "127 E MAIN ST",
    "dropdelcty": "SUMMIT",
    "dropdelst": "UT",
    "dropdelzpp": 847728001,
    "dropphyadd": "127 E MAIN ST",
    "dropphycty": "SUMMIT",
    "dropphyst": "UT",
    "dropphyzpp": 847728001,
    "dropmaladd": "PO BOX 729998",
    "dropmalcty": "SUMMIT",
    "dropmalst": "UT",
    "dropmalzpp": 847729998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358650803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16330",
    "droptype": "D",
    "dropname": "TRIDELL",
    "dropdeladd": "10333 N 8000 E",
    "dropdelcty": "TRIDELL",
    "dropdelst": "UT",
    "dropdelzpp": 840768001,
    "dropphyadd": "10333 N 8000 E",
    "dropphycty": "TRIDELL",
    "dropphyst": "UT",
    "dropphyzpp": 840768001,
    "dropmaladd": "PO BOX 769998",
    "dropmalcty": "TRIDELL",
    "dropmalst": "UT",
    "dropmalzpp": 840769998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352472480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16448",
    "droptype": "D",
    "dropname": "ANDERSON ISLAND",
    "dropdeladd": "10202 ECKENSTAM JOHNSON RD STE B",
    "dropdelcty": "ANDERSON ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 983038708,
    "dropphyadd": "10202 ECKENSTAM JOHNSON RD STE B",
    "dropphycty": "ANDERSON ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 983038708,
    "dropmaladd": "10202 ECKENSTAM JOHNSON RD STE B",
    "dropmalcty": "ANDERSON ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 983038708,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539641705,
    "dropsitcph": 2538844001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16510",
    "droptype": "D",
    "dropname": "BLAKELY ISLAND",
    "dropdeladd": "1 BLAKELY IS",
    "dropdelcty": "BLAKELY ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 982225000,
    "dropphyadd": "1 BLAKELY IS",
    "dropphycty": "BLAKELY ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 982225000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAKELY ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 982229998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603756662,
    "dropsitcph": 3603756662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ16833",
    "droptype": "D",
    "dropname": "GEORGE",
    "dropdeladd": "207 W MONTMORENCY BLVD",
    "dropdelcty": "GEORGE",
    "dropdelst": "WA",
    "dropdelzpp": 988249801,
    "dropphyadd": "207 W MONTMORENCY BLVD",
    "dropphycty": "GEORGE",
    "dropphyst": "WA",
    "dropphyzpp": 988249801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GEORGE",
    "dropmalst": "WA",
    "dropmalzpp": 988249998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097872613,
    "dropsitcph": 5097872613,
    "dropfax": 5097872396
  },
  {
    "dcode": "D",
    "dropkey": "CZ17302",
    "droptype": "D",
    "dropname": "PORT LUDLOW",
    "dropdeladd": "46 VILLAGE WAY UNIT A",
    "dropdelcty": "PORT LUDLOW",
    "dropdelst": "WA",
    "dropdelzpp": 983659556,
    "dropphyadd": "46 VILLAGE WAY UNIT A",
    "dropphycty": "PORT LUDLOW",
    "dropphyst": "WA",
    "dropphyzpp": 983659556,
    "dropmaladd": "46 VILLAGE WAY UNIT A",
    "dropmalcty": "PORT LUDLOW",
    "dropmalst": "WA",
    "dropmalzpp": 983659556,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604372939,
    "dropsitcph": 3604372939,
    "dropfax": 3604372849
  },
  {
    "dcode": "D",
    "dropkey": "CZ17670",
    "droptype": "D",
    "dropname": "VANTAGE",
    "dropdeladd": "551 MAIN ST",
    "dropdelcty": "VANTAGE",
    "dropdelst": "WA",
    "dropdelzpp": 989509800,
    "dropphyadd": "551 MAIN ST",
    "dropphycty": "VANTAGE",
    "dropphyst": "WA",
    "dropphyzpp": 989509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANTAGE",
    "dropmalst": "WA",
    "dropmalzpp": 989509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098562800,
    "dropsitcph": 5098562800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ17894",
    "droptype": "D",
    "dropname": "SILVER STAR",
    "dropdeladd": "5342 MT HIGHWAY 41 N",
    "dropdelcty": "SILVER STAR",
    "dropdelst": "MT",
    "dropdelzpp": 597519998,
    "dropphyadd": "5342 MT HIGHWAY 41 N",
    "dropphycty": "SILVER STAR",
    "dropphyst": "MT",
    "dropphyzpp": 597519998,
    "dropmaladd": "5342 MT HIGHWAY 41 N",
    "dropmalcty": "SILVER STAR",
    "dropmalst": "MT",
    "dropmalzpp": 597519998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4062873605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ17935",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "712 N DUNLAVY AVE",
    "dropdelcty": "WILLARD",
    "dropdelst": "NM",
    "dropdelzpp": 870639998,
    "dropphyadd": "712 DUNLAVY AVE",
    "dropphycty": "WILLARD",
    "dropphyst": "NM",
    "dropphyzpp": 870639998,
    "dropmaladd": "712 DUNLAVY AVE",
    "dropmalcty": "WILLARD",
    "dropmalst": "NM",
    "dropmalzpp": 870639998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053842721,
    "dropsitcph": 5053842721,
    "dropfax": 5053843217
  },
  {
    "dcode": "D",
    "dropkey": "CZ17936",
    "droptype": "D",
    "dropname": "PONDEROSA",
    "dropdeladd": "6335 HIGHWAY 290",
    "dropdelcty": "PONDEROSA",
    "dropdelst": "NM",
    "dropdelzpp": 870449998,
    "dropphyadd": "6335 HIGHWAY 290",
    "dropphycty": "PONDEROSA",
    "dropphyst": "NM",
    "dropphyzpp": 870449998,
    "dropmaladd": "6335 HIGHWAY 290",
    "dropmalcty": "PONDEROSA",
    "dropmalst": "NM",
    "dropmalzpp": 870449998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758347099,
    "dropsitcph": 5758347339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ17938",
    "droptype": "D",
    "dropname": "LYNNDYL",
    "dropdeladd": "106 E CENTER ST",
    "dropdelcty": "LYNNDYL",
    "dropdelst": "UT",
    "dropdelzpp": 846408001,
    "dropphyadd": "106 E CENTER ST",
    "dropphycty": "LYNNDYL",
    "dropphyst": "UT",
    "dropphyzpp": 846408001,
    "dropmaladd": "PO BOX 409998",
    "dropmalcty": "LYNNDYL",
    "dropmalst": "UT",
    "dropmalzpp": 846409998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358579110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ17939",
    "droptype": "D",
    "dropname": "GROUSE CREEK",
    "dropdeladd": "11695 N GROUSE CREEK RD",
    "dropdelcty": "GROUSE CREEK",
    "dropdelst": "UT",
    "dropdelzpp": 843138001,
    "dropphyadd": "11695 N GROUSE CREEK RD",
    "dropphycty": "GROUSE CREEK",
    "dropphyst": "UT",
    "dropphyzpp": 843138001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GROUSE CREEK",
    "dropmalst": "UT",
    "dropmalzpp": 843139998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357477515,
    "dropfax": 4357477515
  },
  {
    "dcode": "D",
    "dropkey": "CZ18004",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "2321 MT HIGHWAY 7",
    "dropdelcty": "WILLARD",
    "dropdelst": "MT",
    "dropdelzpp": 593549700,
    "dropphyadd": "2321 MT HIGHWAY 7",
    "dropphycty": "WILLARD",
    "dropphyst": "MT",
    "dropphyzpp": 593549700,
    "dropmaladd": "2321 MT HIGHWAY 7",
    "dropmalcty": "WILLARD",
    "dropmalst": "MT",
    "dropmalzpp": 593549700,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4067783525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ18102",
    "droptype": "D",
    "dropname": "CLARKIA",
    "dropdeladd": "179 CEDAR ST",
    "dropdelcty": "CLARKIA",
    "dropdelst": "ID",
    "dropdelzpp": 838129998,
    "dropphyadd": "179 CEDAR ST",
    "dropphycty": "CLARKIA",
    "dropphyst": "ID",
    "dropphyzpp": 838129998,
    "dropmaladd": "179 CEDAR ST",
    "dropmalcty": "CLARKIA",
    "dropmalst": "ID",
    "dropmalzpp": 838129998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082453382,
    "dropsitcph": 2082455287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ18785",
    "droptype": "D",
    "dropname": "VEYO",
    "dropdeladd": "21 S MAIN ST",
    "dropdelcty": "VEYO",
    "dropdelst": "UT",
    "dropdelzpp": 847824079,
    "dropphyadd": "21 S MAIN ST",
    "dropphycty": "VEYO",
    "dropphyst": "UT",
    "dropphyzpp": 847824079,
    "dropmaladd": "PO BOX 829998",
    "dropmalcty": "VEYO",
    "dropmalst": "UT",
    "dropmalzpp": 847829998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355742749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20273",
    "droptype": "D",
    "dropname": "BIG RIVER",
    "dropdeladd": "150400 TURQUOISE RD",
    "dropdelcty": "EARP",
    "dropdelst": "CA",
    "dropdelzpp": 922429800,
    "dropphyadd": "150400 TURQUOISE RD",
    "dropphycty": "EARP",
    "dropphyst": "CA",
    "dropphyzpp": 922429800,
    "dropmaladd": "PO BOX 1996",
    "dropmalcty": "BIG RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 922421996,
    "dropsitphn": 9093354457,
    "dropsitlph": 9093354531,
    "dropsitcph": 7606652160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20349",
    "droptype": "D",
    "dropname": "BRANSCOMB",
    "dropdeladd": "14322 BRANSCOMB RD",
    "dropdelcty": "BRANSCOMB",
    "dropdelst": "CA",
    "dropdelzpp": 954179642,
    "dropphyadd": "14322 BRANSCOMB RD",
    "dropphycty": "BRANSCOMB",
    "dropphyst": "CA",
    "dropphyzpp": 954179642,
    "dropmaladd": "14322 BRANSCOMB RD",
    "dropmalcty": "BRANSCOMB",
    "dropmalst": "CA",
    "dropmalzpp": 954179642,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079846722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20403",
    "droptype": "D",
    "dropname": "BURREL",
    "dropdeladd": "10655A W ELKHORN AVE",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "CA",
    "dropdelzpp": 936569770,
    "dropphyadd": "10655A W ELKHORN AVE",
    "dropphycty": "RIVERDALE",
    "dropphyst": "CA",
    "dropphyzpp": 936569770,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "BURREL",
    "dropmalst": "CA",
    "dropmalzpp": 936079997,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598673174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20473",
    "droptype": "D",
    "dropname": "CAMP NELSON",
    "dropdeladd": "801 HIGHWAY 190",
    "dropdelcty": "CAMP NELSON",
    "dropdelst": "CA",
    "dropdelzpp": 932089998,
    "dropphyadd": "35701 HIGHWAY 190",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932659998,
    "dropmaladd": "35701 HIGHWAY 190",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932659998,
    "dropsitphn": "",
    "dropsitlph": 4084376726,
    "dropsitcph": 5595422423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20482",
    "droptype": "D",
    "dropname": "CAMPO SECO",
    "dropdeladd": "3958 CAMPO SECO RD",
    "dropdelcty": "CAMPO SECO",
    "dropdelst": "CA",
    "dropdelzpp": 952269998,
    "dropphyadd": "3958 CAMPO SECO RD",
    "dropphycty": "CAMPO SECO",
    "dropphyst": "CA",
    "dropphyzpp": 952269998,
    "dropmaladd": "3958 CAMPO SECO RD",
    "dropmalcty": "CAMPO SECO",
    "dropmalst": "CA",
    "dropmalzpp": 952269998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2097722388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20488",
    "droptype": "D",
    "dropname": "CANTIL",
    "dropdeladd": "28111 JAWBONE CANYON RD",
    "dropdelcty": "MOJAVE",
    "dropdelst": "CA",
    "dropdelzpp": 935019990,
    "dropphyadd": "28111 JAWBONE CANYON RD",
    "dropphycty": "MOJAVE",
    "dropphyst": "CA",
    "dropphyzpp": 935019990,
    "dropmaladd": "2053 BELSHAW ST",
    "dropmalcty": "MOJAVE",
    "dropmalst": "CA",
    "dropmalzpp": 935019998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7603731146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20600",
    "droptype": "D",
    "dropname": "CHIRIACO SUMMIT",
    "dropdeladd": "62450 CHIRIACO RD",
    "dropdelcty": "INDIO",
    "dropdelst": "CA",
    "dropdelzpp": 922018202,
    "dropphyadd": "62450 CHIRIACO RD",
    "dropphycty": "INDIO",
    "dropphyst": "CA",
    "dropphyzpp": 922018202,
    "dropmaladd": "62450 CHIRIACO RD",
    "dropmalcty": "INDIO",
    "dropmalst": "CA",
    "dropmalzpp": 922018202,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093354531,
    "dropsitcph": 7602273227,
    "dropfax": 7602273227
  },
  {
    "dcode": "D",
    "dropkey": "CZ20796",
    "droptype": "D",
    "dropname": "CROMBERG",
    "dropdeladd": "59704 STATE HIGHWAY 70",
    "dropdelcty": "CROMBERG",
    "dropdelst": "CA",
    "dropdelzpp": 961039995,
    "dropphyadd": "59704 STATE HIGHWAY 70",
    "dropphycty": "CROMBERG",
    "dropphyst": "CA",
    "dropphyzpp": 961039995,
    "dropmaladd": "59704 STATE HIGHWAY 70",
    "dropmalcty": "CROMBERG",
    "dropmalst": "CA",
    "dropmalzpp": 961039995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308362426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ20994",
    "droptype": "D",
    "dropname": "ECHO LAKE",
    "dropdeladd": "9900 ECHO LAKES RD",
    "dropdelcty": "ECHO LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 957219400,
    "dropphyadd": "9900 ECHO LAKES RD",
    "dropphycty": "ECHO LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 957219400,
    "dropmaladd": "17481 HIGHWAY 50",
    "dropmalcty": "TWIN BRIDGES",
    "dropmalst": "CA",
    "dropmalzpp": 957359998,
    "dropsitphn": "",
    "dropsitlph": 5306597670,
    "dropsitcph": 5306597207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21088",
    "droptype": "D",
    "dropname": "FALLEN LEAF",
    "dropdeladd": "400 FALLEN LEAF RD",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961506132,
    "dropphyadd": "400 FALLEN LEAF RD",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961506132,
    "dropmaladd": "1046 AL TAHOE BLVD",
    "dropmalcty": "SOUTH LAKE TAHOE",
    "dropmalst": "CA",
    "dropmalzpp": 961504603,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305414671,
    "dropsitcph": 5305414671,
    "dropfax": 5305448133
  },
  {
    "dcode": "D",
    "dropkey": "CZ21202",
    "droptype": "D",
    "dropname": "FREESTONE",
    "dropdeladd": "500 BOHEMIAN HWY",
    "dropdelcty": "SEBASTOPOL",
    "dropdelst": "CA",
    "dropdelzpp": 954729993,
    "dropphyadd": "500 BOHEMIAN HWY",
    "dropphycty": "SEBASTOPOL",
    "dropphyst": "CA",
    "dropphyzpp": 954729993,
    "dropmaladd": "290 S MAIN ST",
    "dropmalcty": "SEBASTOPOL",
    "dropmalst": "CA",
    "dropmalzpp": 954729917,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7078741417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21302",
    "droptype": "D",
    "dropname": "GORMAN",
    "dropdeladd": "49744 GORMAN POST RD STE 3",
    "dropdelcty": "LEBEC",
    "dropdelst": "CA",
    "dropdelzpp": 932439702,
    "dropphyadd": "49744 GORMAN POST RD STE 3",
    "dropphycty": "LEBEC",
    "dropphyst": "CA",
    "dropphyzpp": 932439702,
    "dropmaladd": "2132 LEBEC RD",
    "dropmalcty": "LEBEC",
    "dropmalst": "CA",
    "dropmalzpp": 932439998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6612488501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21391",
    "droptype": "D",
    "dropname": "HAVASU LAKE",
    "dropdeladd": "148629 HAVASU LAKE RD",
    "dropdelcty": "NEEDLES",
    "dropdelst": "CA",
    "dropdelzpp": 923639802,
    "dropphyadd": "148629 SHOWBOAT RD",
    "dropphycty": "NEEDLES",
    "dropphyst": "CA",
    "dropphyzpp": 923639802,
    "dropmaladd": "PO BOX 1946",
    "dropmalcty": "NEEDLES",
    "dropmalst": "CA",
    "dropmalzpp": 923631946,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093354531,
    "dropsitcph": 7608584887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21479",
    "droptype": "D",
    "dropname": "HUME",
    "dropdeladd": "64144 HUME LAKE RD",
    "dropdelcty": "HUME",
    "dropdelst": "CA",
    "dropdelzpp": 936289601,
    "dropphyadd": "64144 HUME LAKE RD",
    "dropphycty": "HUME",
    "dropphyst": "CA",
    "dropphyzpp": 936289601,
    "dropmaladd": "GENERAL DELIVERY",
    "dropmalcty": "HUME",
    "dropmalst": "CA",
    "dropmalzpp": 936289999,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5593362542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21525",
    "droptype": "D",
    "dropname": "IOWA HILL",
    "dropdeladd": "3181 IOWA HILL RD",
    "dropdelcty": "COLFAX",
    "dropdelst": "CA",
    "dropdelzpp": 957139302,
    "dropphyadd": "3181 IOWA HILL RD",
    "dropphycty": "COLFAX",
    "dropphyst": "CA",
    "dropphyzpp": 957139302,
    "dropmaladd": "40 W CHURCH ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "CA",
    "dropmalzpp": 957139136,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5303460025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21603",
    "droptype": "D",
    "dropname": "KNIGHTS FERRY",
    "dropdeladd": "17631 SONORA RD",
    "dropdelcty": "OAKDALE",
    "dropdelst": "CA",
    "dropdelzpp": 953619800,
    "dropphyadd": "17631 SONORA RD",
    "dropphycty": "OAKDALE",
    "dropphyst": "CA",
    "dropphyzpp": 953619800,
    "dropmaladd": "170 CALIFORNIA AVE",
    "dropmalcty": "OAKDALE",
    "dropmalst": "CA",
    "dropmalzpp": 953619907,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098477269,
    "dropsitcph": 2098813535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21906",
    "droptype": "D",
    "dropname": "MARTELL",
    "dropdeladd": "11020 N STATE HIGHWAY 49",
    "dropdelcty": "MARTELL",
    "dropdelst": "CA",
    "dropdelzpp": 956549998,
    "dropphyadd": "11020 N STATE HIGHWAY 49",
    "dropphycty": "MARTELL",
    "dropphyst": "CA",
    "dropphyzpp": 956549998,
    "dropmaladd": "424 SUTTER ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "CA",
    "dropmalzpp": 956422049,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2092237720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21955",
    "droptype": "D",
    "dropname": "METTLER",
    "dropdeladd": "1047 METTLER FRONTAGE RD W",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933139674,
    "dropphyadd": "1047 METTLER FRONTAGE RD W",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933139674,
    "dropmaladd": "3200 LARSON LN",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933045351,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 6618582979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ21974",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "40271 STATE HIGHWAY 172",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 960619711,
    "dropphyadd": "40271 STATE HIGHWAY 172",
    "dropphycty": "MILL CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 960619711,
    "dropmaladd": "40271 STATE HIGHWAY 172",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 960619711,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5305953372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22028",
    "droptype": "D",
    "dropname": "MONO HOT SPRINGS",
    "dropdeladd": "72000 HIGHWAY 168",
    "dropdelcty": "MONO HOT SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 936429800,
    "dropphyadd": "72000 HIGHWAY 168",
    "dropphycty": "MONO HOT SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 936429800,
    "dropmaladd": "GENERAL DELIVERY",
    "dropmalcty": "MONO HOT SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 936429999,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598413678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22039",
    "droptype": "D",
    "dropname": "MONTE SERENO",
    "dropdeladd": "18041 SARATOGA LOS GATOS RD",
    "dropdelcty": "MONTE SERENO",
    "dropdelst": "CA",
    "dropdelzpp": 950304299,
    "dropphyadd": "18041 SARATOGA LOS GATOS RD",
    "dropphycty": "MONTE SERENO",
    "dropphyst": "CA",
    "dropphyzpp": 950304299,
    "dropmaladd": "18041 SARATOGA LOS GATOS RD",
    "dropmalcty": "MONTE SERENO",
    "dropmalst": "CA",
    "dropmalzpp": 950304299,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4083545466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22078",
    "droptype": "D",
    "dropname": "MOUNT HAMILTON",
    "dropdeladd": "7281 MOUNT HAMILTON RD",
    "dropdelcty": "MOUNT HAMILTON",
    "dropdelst": "CA",
    "dropdelzpp": 951409998,
    "dropphyadd": "7281 MOUNT HAMILTON RD",
    "dropphycty": "MOUNT HAMILTON",
    "dropphyst": "CA",
    "dropphyzpp": 951409998,
    "dropmaladd": "7281 MOUNT HAMILTON RD",
    "dropmalcty": "MOUNT HAMILTON",
    "dropmalst": "CA",
    "dropmalzpp": 951409998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082749266,
    "dropsitcph": 4082749266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22143",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "6805 MIDWAY RD",
    "dropdelcty": "NELSON",
    "dropdelst": "CA",
    "dropdelzpp": 959589998,
    "dropphyadd": "6805 MIDWAY RD",
    "dropphycty": "NELSON",
    "dropphyst": "CA",
    "dropphyzpp": 959589998,
    "dropmaladd": "2396 DURHAM DAYTON HWY",
    "dropmalcty": "DURHAM",
    "dropmalst": "CA",
    "dropmalzpp": 959389902,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5303430995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22434",
    "droptype": "D",
    "dropname": "PAYNES CREEK",
    "dropdeladd": "29791 PAYNES CREEK LOOP",
    "dropdelcty": "PAYNES CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 960759737,
    "dropphyadd": "29791 PAYNES CREEK LOOP",
    "dropphycty": "PAYNES CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 960759737,
    "dropmaladd": "447 WALNUT ST",
    "dropmalcty": "RED BLUFF",
    "dropmalst": "CA",
    "dropmalzpp": 960809936,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5305271455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22540",
    "droptype": "D",
    "dropname": "POPLAR",
    "dropdeladd": "14653 ROAD 192",
    "dropdelcty": "PORTERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932578965,
    "dropphyadd": "14524 ROAD 192",
    "dropphycty": "PORTERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932579169,
    "dropmaladd": "65 W MILL AVE",
    "dropmalcty": "PORTERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932579998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5597846415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22583",
    "droptype": "D",
    "dropname": "PUMPKIN CENTER",
    "dropdeladd": "3107 TAFT HWY",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933139621,
    "dropphyadd": "3107 TAFT HWY",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933139621,
    "dropmaladd": "10001 CAMINO MEDIA",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933111309,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6618373807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22624",
    "droptype": "D",
    "dropname": "RANDSBURG",
    "dropdeladd": "26741 BUTTE AVE",
    "dropdelcty": "RANDSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 935549900,
    "dropphyadd": "26741 BUTTE AVE",
    "dropphycty": "RANDSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 935549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHANNESBURG",
    "dropmalst": "CA",
    "dropmalzpp": 935289998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7603742337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22673",
    "droptype": "D",
    "dropname": "RIO NIDO",
    "dropdeladd": "14770 RIO NIDO RD",
    "dropdelcty": "RIO NIDO",
    "dropdelst": "CA",
    "dropdelzpp": 954718900,
    "dropphyadd": "14470 RIO NIDO RD",
    "dropphycty": "RIO NIDO",
    "dropphyst": "CA",
    "dropphyzpp": 954718900,
    "dropmaladd": "14060 MILL ST",
    "dropmalcty": "GUERNEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954469815,
    "dropsitphn": 7078693353,
    "dropsitlph": 7078693353,
    "dropsitcph": 7078693353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22734",
    "droptype": "D",
    "dropname": "RUMSEY",
    "dropdeladd": "3405 OLEARY LN",
    "dropdelcty": "RUMSEY",
    "dropdelst": "CA",
    "dropdelzpp": 956799998,
    "dropphyadd": "3405 OLEARY LN",
    "dropphycty": "RUMSEY",
    "dropphyst": "CA",
    "dropphyzpp": 956799998,
    "dropmaladd": "7575 STATE HIGHWAY 16",
    "dropmalcty": "GUINDA",
    "dropmalst": "CA",
    "dropmalzpp": 956379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307964152,
    "dropsitcph": 5307964152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ22775",
    "droptype": "D",
    "dropname": "SALTON CITY",
    "dropdeladd": "2113 S MARINA DR",
    "dropdelcty": "THERMAL",
    "dropdelst": "CA",
    "dropdelzpp": 922748432,
    "dropphyadd": "2113 S MARINA DR",
    "dropphycty": "THERMAL",
    "dropphyst": "CA",
    "dropphyzpp": 922748432,
    "dropmaladd": "2113 S MARINA DR",
    "dropmalcty": "THERMAL",
    "dropmalst": "CA",
    "dropmalzpp": 922748432,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603944403,
    "dropsitcph": 7603944403,
    "dropfax": 7603944403
  },
  {
    "dcode": "D",
    "dropkey": "CZ23077",
    "droptype": "D",
    "dropname": "SPANISH FLAT",
    "dropdeladd": "SPANISH FLAT",
    "dropdelcty": "NAPA",
    "dropdelst": "CA",
    "dropdelzpp": 94558,
    "dropphyadd": "SPANISH FLAT",
    "dropphycty": "NAPA",
    "dropphyst": "CA",
    "dropphyzpp": 94558,
    "dropmaladd": "1625 TRANCAS ST",
    "dropmalcty": "NAPA",
    "dropmalst": "CA",
    "dropmalzpp": 945589998,
    "dropsitphn": 5108323950,
    "dropsitlph": 5108323950,
    "dropsitcph": 7072552339,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "CZ23093",
    "droptype": "D",
    "dropname": "SQUAW VALLEY",
    "dropdeladd": "30754 E KINGS CANYON RD",
    "dropdelcty": "SQUAW VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 936759304,
    "dropphyadd": "30754 E KINGS CANYON RD",
    "dropphycty": "SQUAW VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 936759304,
    "dropmaladd": "30754 E KINGS CANYON RD",
    "dropmalcty": "SQUAW VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 936759304,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596261418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ23467",
    "droptype": "D",
    "dropname": "STRAWBERRY",
    "dropdeladd": "28635 HERRING CREEK LN",
    "dropdelcty": "STRAWBERRY",
    "dropdelst": "CA",
    "dropdelzpp": 953759998,
    "dropphyadd": "28635 HERRING CREEK LN",
    "dropphycty": "STRAWBERRY",
    "dropphyst": "CA",
    "dropphyzpp": 953759998,
    "dropmaladd": "411 PINECREST LAKE RD",
    "dropmalcty": "PINECREST",
    "dropmalst": "CA",
    "dropmalzpp": 953649705,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2099653278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ23563",
    "droptype": "D",
    "dropname": "THE SEA RANCH",
    "dropdeladd": "60 SEAWALK DR",
    "dropdelcty": "THE SEA RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 954978800,
    "dropphyadd": "60 SEAWALK DR",
    "dropphycty": "THE SEA RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 954978800,
    "dropmaladd": "PO BOX 44",
    "dropmalcty": "THE SEA RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 954970044,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077854809,
    "dropfax": 7078849556
  },
  {
    "dcode": "D",
    "dropkey": "CZ23705",
    "droptype": "D",
    "dropname": "VALYERMO",
    "dropdeladd": "29831 VALYERMO RD",
    "dropdelcty": "VALYERMO",
    "dropdelst": "CA",
    "dropdelzpp": 935639998,
    "dropphyadd": "29831 VALYERMO RD",
    "dropphycty": "VALYERMO",
    "dropphyst": "CA",
    "dropphyzpp": 935639998,
    "dropmaladd": "12302 PEARBLOSSOM HWY",
    "dropmalcty": "PEARBLOSSOM",
    "dropmalst": "CA",
    "dropmalzpp": 935539998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8059441721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ23843",
    "droptype": "D",
    "dropname": "WESTHAVEN",
    "dropdeladd": "460 6TH AVE",
    "dropdelcty": "TRINIDAD",
    "dropdelst": "CA",
    "dropdelzpp": 955709725,
    "dropphyadd": "460 6TH AVE",
    "dropphycty": "TRINIDAD",
    "dropphyst": "CA",
    "dropphyzpp": 955709725,
    "dropmaladd": "357 MAIN ST",
    "dropmalcty": "TRINIDAD",
    "dropmalst": "CA",
    "dropmalzpp": 955709998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076773117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ23852",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "37001 N HIGHWAY 1",
    "dropdelcty": "WESTPORT",
    "dropdelst": "CA",
    "dropdelzpp": 954888719,
    "dropphyadd": "37001 N HIGHWAY 1",
    "dropphycty": "WESTPORT",
    "dropphyst": "CA",
    "dropphyzpp": 954888719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTPORT",
    "dropmalst": "CA",
    "dropmalzpp": 954889998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079642302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ23923",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "16883 AVENUE 168",
    "dropdelcty": "PORTERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932579264,
    "dropphyadd": "16883 AVENUE 168",
    "dropphycty": "PORTERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932579264,
    "dropmaladd": "65 W MILL AVE",
    "dropmalcty": "PORTERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932579998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5596860770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ24665",
    "droptype": "D",
    "dropname": "SUNSHINE MARKET",
    "dropdeladd": "13015 CLAYMINE RD",
    "dropdelcty": "EDWARDS",
    "dropdelst": "CA",
    "dropdelzpp": 935233243,
    "dropphyadd": "13015 CLAYMINE RD",
    "dropphycty": "EDWARDS",
    "dropphyst": "CA",
    "dropphyzpp": 935233243,
    "dropmaladd": "1000 KINCHELOE AVE",
    "dropmalcty": "EDWARDS",
    "dropmalst": "CA",
    "dropmalzpp": 935239998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6612774315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "CZ24752",
    "droptype": "D",
    "dropname": "KOPY KING",
    "dropdeladd": "2155 TAPO ST",
    "dropdelcty": "SIMI VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 930635499,
    "dropphyadd": "2155 TAPO ST",
    "dropphycty": "SIMI VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 930635499,
    "dropmaladd": "2155 TAPO ST",
    "dropmalcty": "SIMI VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 930635499,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8055270060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C000424",
    "droptype": "D",
    "dropname": "LONG VALLEY",
    "dropdeladd": "27199 SD HIGHWAY 73",
    "dropdelcty": "LONG VALLEY",
    "dropdelst": "SD",
    "dropdelzpp": 575479998,
    "dropphyadd": "27199 SD HIGHWAY 73",
    "dropphycty": "LONG VALLEY",
    "dropphyst": "SD",
    "dropphyzpp": 575479998,
    "dropmaladd": "27199 SD HIGHWAY 73",
    "dropmalcty": "LONG VALLEY",
    "dropmalst": "SD",
    "dropmalzpp": 575479998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6054626142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C002757",
    "droptype": "D",
    "dropname": "BAKERSVILLE",
    "dropdeladd": "59505 COUNTY ROAD 2",
    "dropdelcty": "BAKERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 438039000,
    "dropphyadd": "59505 COUNTY ROAD 2",
    "dropphycty": "BAKERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 438039000,
    "dropmaladd": "107 W JEFFERSON ST",
    "dropmalcty": "STONE CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 438409997,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3308977561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C002759",
    "droptype": "D",
    "dropname": "LISTIE",
    "dropdeladd": "126 RAILROAD ST",
    "dropdelcty": "LISTIE",
    "dropdelst": "PA",
    "dropdelzpp": 155499998,
    "dropphyadd": "126 RAILROAD ST",
    "dropphycty": "LISTIE",
    "dropphyst": "PA",
    "dropphyzpp": 155499998,
    "dropmaladd": "126 RAILROAD ST",
    "dropmalcty": "LISTIE",
    "dropmalst": "PA",
    "dropmalzpp": 155499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144458574,
    "dropsitcph": 8144458574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C002762",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "42385 MILL ST",
    "dropdelcty": "STAFFORD",
    "dropdelst": "OH",
    "dropdelzpp": 437869900,
    "dropphyadd": "42385 MILL ST",
    "dropphycty": "STAFFORD",
    "dropphyst": "OH",
    "dropphyzpp": 437869900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAFFORD",
    "dropmalst": "OH",
    "dropmalzpp": 437869998,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 7405673192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C002807",
    "droptype": "D",
    "dropname": "TWIG",
    "dropdeladd": "5302 TWIG BLVD",
    "dropdelcty": "TWIG",
    "dropdelst": "MN",
    "dropdelzpp": 557914400,
    "dropphyadd": "5302 TWIG BLVD",
    "dropphycty": "TWIG",
    "dropphyst": "MN",
    "dropphyzpp": 557914400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWIG",
    "dropmalst": "MN",
    "dropmalzpp": 557919998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2187298852,
    "dropfax": 2187290416
  },
  {
    "dcode": "D",
    "dropkey": "C003081",
    "droptype": "D",
    "dropname": "PAGE",
    "dropdeladd": "WV ROUTE 61",
    "dropdelcty": "PAGE",
    "dropdelst": "WV",
    "dropdelzpp": 25152,
    "dropphyadd": "WV ROUTE 61",
    "dropphycty": "PAGE",
    "dropphyst": "WV",
    "dropphyzpp": 25152,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "PAGE",
    "dropmalst": "WV",
    "dropmalzpp": 251529997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044658791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C003110",
    "droptype": "D",
    "dropname": "EDMUND",
    "dropdeladd": "3156 N MAIN ST",
    "dropdelcty": "EDMUND",
    "dropdelst": "WI",
    "dropdelzpp": 535359700,
    "dropphyadd": "3156 N MAIN ST",
    "dropphycty": "EDMUND",
    "dropphyst": "WI",
    "dropphyzpp": 535359700,
    "dropmaladd": "269 HIGH ST",
    "dropmalcty": "MINERAL POINT",
    "dropmalst": "WI",
    "dropmalzpp": 535659998,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 6086232434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C003162",
    "droptype": "D",
    "dropname": "FANROCK",
    "dropdeladd": "2022 BRIER CREEK RD",
    "dropdelcty": "FANROCK",
    "dropdelst": "WV",
    "dropdelzpp": 248349998,
    "dropphyadd": "2022 BRIER CREEK RD",
    "dropphycty": "FANROCK",
    "dropphyst": "WV",
    "dropphyzpp": 248349998,
    "dropmaladd": "2022 BRIER CREEK RD",
    "dropmalcty": "FANROCK",
    "dropmalst": "WV",
    "dropmalzpp": 248349998,
    "dropsitphn": 3047465002,
    "dropsitlph": "",
    "dropsitcph": 3047327410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C003581",
    "droptype": "D",
    "dropname": "FOUR CORNERS MKT",
    "dropdeladd": "611 REAMER AVE",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156015459,
    "dropphyadd": "611 REAMER AVE",
    "dropphycty": "GREENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156015459,
    "dropmaladd": "611 REAMER AVE",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156015459,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248347055,
    "dropsitcph": 7248347055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C003743",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "519 FRONT ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "SD",
    "dropdelzpp": 574219998,
    "dropphyadd": "519 FRONT ST",
    "dropphycty": "AMHERST",
    "dropphyst": "SD",
    "dropphyzpp": 574219998,
    "dropmaladd": "309 MAIN ST",
    "dropmalcty": "LANGFORD",
    "dropmalst": "SD",
    "dropmalzpp": 574549998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6052945316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004165",
    "droptype": "D",
    "dropname": "ARCHER",
    "dropdeladd": "2121 ARCHER RD STOP 2",
    "dropdelcty": "ARCHER",
    "dropdelst": "NE",
    "dropdelzpp": 688162600,
    "dropphyadd": "2121 ARCHER RD STOP 2",
    "dropphycty": "ARCHER",
    "dropphyst": "NE",
    "dropphyzpp": 688162600,
    "dropmaladd": "2121 ARCHER RD STOP 2",
    "dropmalcty": "ARCHER",
    "dropmalst": "NE",
    "dropmalzpp": 688162600,
    "dropsitphn": 3088943804,
    "dropsitlph": 3087952278,
    "dropsitcph": 3087952204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004283",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 438369000,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 438369000,
    "dropmaladd": "PO BOX 385",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 438360385,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408292630,
    "dropsitcph": 7405456111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004330",
    "droptype": "D",
    "dropname": "STINESVILLE",
    "dropdeladd": "8201 W MAIN ST",
    "dropdelcty": "STINESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474649900,
    "dropphyadd": "8201 W MAIN ST",
    "dropphycty": "STINESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474649900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STINESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128766203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004491",
    "droptype": "D",
    "dropname": "ECHO",
    "dropdeladd": "3455 ECHO RD",
    "dropdelcty": "ECHO",
    "dropdelst": "UT",
    "dropdelzpp": 840248001,
    "dropphyadd": "3455 ECHO RD",
    "dropphycty": "ECHO",
    "dropphyst": "UT",
    "dropphyzpp": 840248001,
    "dropmaladd": "3455 ECHO RD",
    "dropmalcty": "ECHO",
    "dropmalst": "UT",
    "dropmalzpp": 840248001,
    "dropsitphn": 8019742558,
    "dropsitlph": "",
    "dropsitcph": 4353362588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004677",
    "droptype": "D",
    "dropname": "ADAMANT",
    "dropdeladd": "1313 HAGGETT RD",
    "dropdelcty": "ADAMANT",
    "dropdelst": "VT",
    "dropdelzpp": "056409800",
    "dropphyadd": "1313 HAGGETT RD",
    "dropphycty": "ADAMANT",
    "dropphyst": "VT",
    "dropphyzpp": "056409800",
    "dropmaladd": "1313 HAGGETT RD",
    "dropmalcty": "ADAMANT",
    "dropmalst": "VT",
    "dropmalzpp": "056409800",
    "dropsitphn": "",
    "dropsitlph": 8024568857,
    "dropsitcph": 8022235760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004865",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "31 N HILL RD UNIT 2",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "058747602",
    "dropphyadd": "31 N HILL RD UNIT 2",
    "dropphycty": "WESTFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "058747602",
    "dropmaladd": "31 N HILL RD UNIT 2",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "058747602",
    "dropsitphn": "",
    "dropsitlph": 8027442708,
    "dropsitcph": 8027446887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C004889",
    "droptype": "D",
    "dropname": "COKER CREEK",
    "dropdeladd": "12199 NEW HIGHWAY 68",
    "dropdelcty": "TELLICO PLAINS",
    "dropdelst": "TN",
    "dropdelzpp": 373856928,
    "dropphyadd": "12199 NEW HIGHWAY 68",
    "dropphycty": "TELLICO PLAINS",
    "dropphyst": "TN",
    "dropphyzpp": 373856928,
    "dropmaladd": "PO BOX 82",
    "dropmalcty": "COKER CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 373140082,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232612286,
    "dropsitcph": 4232612286,
    "dropfax": 4232612069
  },
  {
    "dcode": "D",
    "dropkey": "C006223",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "56 N MAIN ST",
    "dropdelcty": "HOLDEN",
    "dropdelst": "UT",
    "dropdelzpp": 846368001,
    "dropphyadd": "56 N MAIN ST",
    "dropphycty": "HOLDEN",
    "dropphyst": "UT",
    "dropphyzpp": 846368001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLDEN",
    "dropmalst": "UT",
    "dropmalzpp": 846369998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357952213,
    "dropsitcph": 4357952213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C006262",
    "droptype": "D",
    "dropname": "ELDERON",
    "dropdeladd": "467 HIGHLAND AVE",
    "dropdelcty": "ELDERON",
    "dropdelst": "WI",
    "dropdelzpp": 544299800,
    "dropphyadd": "467 HIGHLAND AVE",
    "dropphycty": "ELDERON",
    "dropphyst": "WI",
    "dropphyzpp": 544299800,
    "dropmaladd": "467 HIGHLAND AVE",
    "dropmalcty": "ELDERON",
    "dropmalst": "WI",
    "dropmalzpp": 544299800,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154546565,
    "dropsitcph": 7154546565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C007056",
    "droptype": "D",
    "dropname": "MAPLE MOUNT",
    "dropdeladd": "8001 CUMMINGS RD",
    "dropdelcty": "MAPLE MOUNT",
    "dropdelst": "KY",
    "dropdelzpp": 423569998,
    "dropphyadd": "8001 CUMMINGS RD",
    "dropphycty": "MAPLE MOUNT",
    "dropphyst": "KY",
    "dropphyzpp": 423569998,
    "dropmaladd": "8001 CUMMINGS RD",
    "dropmalcty": "MAPLE MOUNT",
    "dropmalst": "KY",
    "dropmalzpp": 423569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702294103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C008140",
    "droptype": "D",
    "dropname": "HARFORD",
    "dropdeladd": "405 STATE ROUTE 38",
    "dropdelcty": "HARFORD",
    "dropdelst": "NY",
    "dropdelzpp": 137849998,
    "dropphyadd": "405 STATE ROUTE 38",
    "dropphycty": "HARFORD",
    "dropphyst": "NY",
    "dropphyzpp": 137849998,
    "dropmaladd": "405 STATE ROUTE 38",
    "dropmalcty": "HARFORD",
    "dropmalst": "NY",
    "dropmalzpp": 137849998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6078443475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C008842",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "8994 AUSTIN RD",
    "dropdelcty": "SALINE",
    "dropdelst": "MI",
    "dropdelzpp": 481769650,
    "dropphyadd": "8994 AUSTIN RD",
    "dropphycty": "SALINE",
    "dropphyst": "MI",
    "dropphyzpp": 481769650,
    "dropmaladd": "8994 AUSTIN RD",
    "dropmalcty": "SALINE",
    "dropmalst": "MI",
    "dropmalzpp": 481769650,
    "dropsitphn": 3132268558,
    "dropsitlph": "",
    "dropsitcph": 7344294020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C008858",
    "droptype": "D",
    "dropname": "CALIFORNIA VALLEY",
    "dropdeladd": "13080 SODA LAKE RD",
    "dropdelcty": "SANTA MARGARITA",
    "dropdelst": "CA",
    "dropdelzpp": 934539746,
    "dropphyadd": "13080 SODA LAKE RD",
    "dropphycty": "SANTA MARGARITA",
    "dropphyst": "CA",
    "dropphyzpp": 934539746,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA MARGARITA",
    "dropmalst": "CA",
    "dropmalzpp": 934539998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8054383950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C011719",
    "droptype": "D",
    "dropname": "HOWELL",
    "dropdeladd": "16020 N 17400 W STE B",
    "dropdelcty": "HOWELL",
    "dropdelst": "UT",
    "dropdelzpp": 843168002,
    "dropphyadd": "16020 N 17400 W STE B",
    "dropphycty": "HOWELL",
    "dropphyst": "UT",
    "dropphyzpp": 843168002,
    "dropmaladd": "16020 N 17400 W STE B",
    "dropmalcty": "HOWELL",
    "dropmalst": "UT",
    "dropmalzpp": 843168002,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354717331,
    "dropsitcph": 4354717331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C011720",
    "droptype": "D",
    "dropname": "FRENCHBORO",
    "dropdeladd": "1 EXECUTIVE DR",
    "dropdelcty": "FRENCHBORO",
    "dropdelst": "ME",
    "dropdelzpp": "046353001",
    "dropphyadd": "1 EXECUTIVE DR",
    "dropphycty": "FRENCHBORO",
    "dropphyst": "ME",
    "dropphyzpp": "046353001",
    "dropmaladd": "1 EXECUTIVE DR",
    "dropmalcty": "FRENCHBORO",
    "dropmalst": "ME",
    "dropmalzpp": "046353001",
    "dropsitphn": "",
    "dropsitlph": 2073342938,
    "dropsitcph": 2073342938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C012031",
    "droptype": "D",
    "dropname": "CAMAS VALLEY",
    "dropdeladd": "18493 HWY 42 RD",
    "dropdelcty": "CAMAS VALLEY",
    "dropdelst": "OR",
    "dropdelzpp": 974169778,
    "dropphyadd": "18493 HWY 42 RD",
    "dropphycty": "CAMAS VALLEY",
    "dropphyst": "OR",
    "dropphyzpp": 974169778,
    "dropmaladd": "18493 HWY 42 RD",
    "dropmalcty": "CAMAS VALLEY",
    "dropmalst": "OR",
    "dropmalzpp": 974169778,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416797654,
    "dropsitcph": 5414452177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C012534",
    "droptype": "D",
    "dropname": "BROOKSIDE CPO",
    "dropdeladd": "4185 MUNICIPAL DR STE 101",
    "dropdelcty": "BROOKSIDE",
    "dropdelst": "AL",
    "dropdelzpp": 350362103,
    "dropphyadd": "4399 MUNICIPAL DR",
    "dropphycty": "BROOKSIDE",
    "dropphyst": "AL",
    "dropphyzpp": 350362104,
    "dropmaladd": "4399 MUNICIPAL DR",
    "dropmalcty": "BROOKSIDE",
    "dropmalst": "AL",
    "dropmalzpp": 350362104,
    "dropsitphn": 2056748221,
    "dropsitlph": 2056748221,
    "dropsitcph": 2056748221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C012634",
    "droptype": "D",
    "dropname": "STRAWBERRY VALLEY",
    "dropdeladd": "13393 LA PORTE RD",
    "dropdelcty": "STRAWBERRY VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959819703,
    "dropphyadd": "13393 LA PORTE RD",
    "dropphycty": "STRAWBERRY VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959819703,
    "dropmaladd": "13393 LA PORTE RD",
    "dropmalcty": "STRAWBERRY VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959819703,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306752111,
    "dropsitcph": 5306752111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C014545",
    "droptype": "D",
    "dropname": "LAYTONSVILLE",
    "dropdeladd": "6830 OLNEY LAYTONSVILLE RD",
    "dropdelcty": "LAYTONSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208829996,
    "dropphyadd": "6830 OLNEY LAYTONSVILLE RD",
    "dropphycty": "LAYTONSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208829996,
    "dropmaladd": "6830 OLNEY LAYTONSVILLE RD",
    "dropmalcty": "LAYTONSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208829996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083736,
    "dropsitcph": 3013301339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018165",
    "droptype": "D",
    "dropname": "PENINSULA",
    "dropdeladd": "2711 GEORGE WASHINGTON MEM HWY",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 236939997,
    "dropphyadd": "2711 GEORGE WASHINGTON MEM HWY",
    "dropphycty": "YORKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 236939997,
    "dropmaladd": "2711 GEORGE WASHINGTON MEM HWY",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 236939997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578678835,
    "dropsitcph": 7578678835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018195",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "601 WEBSTER ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "NE",
    "dropdelzpp": 683816025,
    "dropphyadd": "601 WEBSTER ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "NE",
    "dropphyzpp": 683816025,
    "dropmaladd": "601 WEBSTER ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "NE",
    "dropmalzpp": 683816025,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028654315,
    "dropsitcph": 4028654315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018394",
    "droptype": "D",
    "dropname": "MIDDLE BASS",
    "dropdeladd": "891 FOX RD",
    "dropdelcty": "MIDDLE BASS",
    "dropdelst": "OH",
    "dropdelzpp": 434468001,
    "dropphyadd": "891 FOX RD",
    "dropphycty": "MIDDLE BASS",
    "dropphyst": "OH",
    "dropphyzpp": 434468001,
    "dropmaladd": "891 FOX RD",
    "dropmalcty": "MIDDLE BASS",
    "dropmalst": "OH",
    "dropmalzpp": 434468001,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192853200,
    "dropsitcph": 4192853200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018690",
    "droptype": "D",
    "dropname": "RUTH",
    "dropdeladd": "18001 MAD RIVER RD",
    "dropdelcty": "MAD RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 955529385,
    "dropphyadd": "18001 MAD RIVER RD",
    "dropphycty": "MAD RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 955529385,
    "dropmaladd": "PO BOX 1097",
    "dropmalcty": "RUTH",
    "dropmalst": "CA",
    "dropmalzpp": 955261097,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7075746511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018782",
    "droptype": "D",
    "dropname": "FOUR CORNER 2",
    "dropdeladd": "24695 US HIGHWAY 85",
    "dropdelcty": "FOUR CORNERS",
    "dropdelst": "WY",
    "dropdelzpp": 827159901,
    "dropphyadd": "24695 US HIGHWAY 85",
    "dropphycty": "FOUR CORNERS",
    "dropphyst": "WY",
    "dropphyzpp": 827159901,
    "dropmaladd": "24695 US HIGHWAY 85",
    "dropmalcty": "FOUR CORNERS",
    "dropmalst": "WY",
    "dropmalzpp": 827159901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077462309,
    "dropsitcph": 3077462309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C018928",
    "droptype": "D",
    "dropname": "KINDRED",
    "dropdeladd": "145 S FRANKLIN ST",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998011321,
    "dropphyadd": "145 S FRANKLIN ST",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998011321,
    "dropmaladd": "145 S FRANKLIN ST",
    "dropmalcty": "JUNEAU",
    "dropmalst": "AK",
    "dropmalzpp": 998011321,
    "dropsitphn": 9075235053,
    "dropsitlph": 9075235053,
    "dropsitcph": 9075235053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C019127",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "38588 US HIGHWAY 285",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "CO",
    "dropdelzpp": 804569997,
    "dropphyadd": "38588 US HIGHWAY 285",
    "dropphycty": "JEFFERSON",
    "dropphyst": "CO",
    "dropphyzpp": 804569997,
    "dropmaladd": "38588 US HIGHWAY 285",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "CO",
    "dropmalzpp": 804569997,
    "dropsitphn": "",
    "dropsitlph": 7198364683,
    "dropsitcph": 7198364683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C019128",
    "droptype": "D",
    "dropname": "NYE",
    "dropdeladd": "1997 NYE RD",
    "dropdelcty": "NYE",
    "dropdelst": "MT",
    "dropdelzpp": 590619998,
    "dropphyadd": "1997 NYE RD",
    "dropphycty": "FISHTAIL",
    "dropphyst": "MT",
    "dropphyzpp": 590289900,
    "dropmaladd": "1997 NYE RD",
    "dropmalcty": "FISHTAIL",
    "dropmalst": "MT",
    "dropmalzpp": 590289900,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575713,
    "dropsitcph": 4063286262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C019308",
    "droptype": "D",
    "dropname": "SNEAD",
    "dropdeladd": "42794 STATE HIGHWAY 75",
    "dropdelcty": "ALTOONA",
    "dropdelst": "AL",
    "dropdelzpp": 359526529,
    "dropphyadd": "42794 STATE HIGHWAY 75",
    "dropphycty": "ALTOONA",
    "dropphyst": "AL",
    "dropphyzpp": 359526529,
    "dropmaladd": "2920 COLLEGE ST",
    "dropmalcty": "ALTOONA",
    "dropmalst": "AL",
    "dropmalzpp": 359529998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3342435580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C020089",
    "droptype": "D",
    "dropname": "MONUMENT VALLEY",
    "dropdeladd": "1 WELCOME CENTER DR",
    "dropdelcty": "MONUMENT VALLEY",
    "dropdelst": "UT",
    "dropdelzpp": 845367726,
    "dropphyadd": "1 WELCOME CENTER DR",
    "dropphycty": "MONUMENT VALLEY",
    "dropphyst": "UT",
    "dropphyzpp": 845367726,
    "dropmaladd": "PO BOX 369998",
    "dropmalcty": "MONUMENT VALLEY",
    "dropmalst": "UT",
    "dropmalzpp": 845369998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357273264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C020492",
    "droptype": "D",
    "dropname": "INTERIOR NEW",
    "dropdeladd": "601 SD HIGHWAY 44",
    "dropdelcty": "INTERIOR",
    "dropdelst": "SD",
    "dropdelzpp": 577509997,
    "dropphyadd": "601 SD HIGHWAY 44",
    "dropphycty": "INTERIOR",
    "dropphyst": "SD",
    "dropphyzpp": 577509997,
    "dropmaladd": "529 MAIN ST",
    "dropmalcty": "WALL",
    "dropmalst": "SD",
    "dropmalzpp": 577909998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052792466,
    "dropsitcph": 6052792466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C020834",
    "droptype": "D",
    "dropname": "FOREST LAKES",
    "dropdeladd": "1537 MERZVILLE RD",
    "dropdelcty": "FOREST LAKES",
    "dropdelst": "AZ",
    "dropdelzpp": 859310251,
    "dropphyadd": "1537 MERZVILLE RD",
    "dropphycty": "FOREST LAKES",
    "dropphyst": "AZ",
    "dropphyzpp": 859310251,
    "dropmaladd": "1537 MERZVILLE RD",
    "dropmalcty": "FOREST LAKES",
    "dropmalst": "AZ",
    "dropmalzpp": 859310251,
    "dropsitphn": 6022253491,
    "dropsitlph": 9285354640,
    "dropsitcph": 9285354640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C021174",
    "droptype": "D",
    "dropname": "TIMBERLINE LODGE",
    "dropdeladd": "27500 E TIMBERLINE RD",
    "dropdelcty": "GOVERNMENT CAMP",
    "dropdelst": "OR",
    "dropdelzpp": 970289912,
    "dropphyadd": "27500 E TIMBERLINE RD",
    "dropphycty": "GOVERNMENT CAMP",
    "dropphyst": "OR",
    "dropphyzpp": 970289912,
    "dropmaladd": "PO BOX 159",
    "dropmalcty": "GOVERNMENT CAMP",
    "dropmalst": "OR",
    "dropmalzpp": 970280159,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5032723238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "C021266",
    "droptype": "D",
    "dropname": "BIG RIVER NEW",
    "dropdeladd": "150435 RIO VISTA DR",
    "dropdelcty": "BIG RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 922429514,
    "dropphyadd": "150435 RIO VISTA DR",
    "dropphycty": "BIG RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 922429514,
    "dropmaladd": "PO BOX 2391",
    "dropmalcty": "BIG RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 922422391,
    "dropsitphn": 9093354457,
    "dropsitlph": 9093354531,
    "dropsitcph": 7606652160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV12169",
    "droptype": "D",
    "dropname": "BINGHAMTON",
    "dropdeladd": "115 HENRY ST",
    "dropdelcty": "BINGHAMTON",
    "dropdelst": "NY",
    "dropdelzpp": 139029998,
    "dropphyadd": "115 HENRY ST",
    "dropphycty": "BINGHAMTON",
    "dropphyst": "NY",
    "dropphyzpp": 139029991,
    "dropmaladd": "115 HENRY ST",
    "dropmalcty": "BINGHAMTON",
    "dropmalst": "NY",
    "dropmalzpp": 139029998,
    "dropsitphn": 6077732174,
    "dropsitlph": 6077732333,
    "dropsitcph": 6077732126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV18876",
    "droptype": "D",
    "dropname": "KILMER",
    "dropdeladd": "21 KILMER RD",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088999900",
    "dropphyadd": "21 KILMER RD",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088999900",
    "dropmaladd": "21 KILMER RD",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088999900",
    "dropsitphn": 7328193638,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328194308,
    "dropfax": 7328194387
  },
  {
    "dcode": "D",
    "dropkey": "EV20423",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "50 BREWERY ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065119998",
    "dropphyadd": "50 BREWERY ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065119998",
    "dropmaladd": "50 BREWERY ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065119998",
    "dropsitphn": 2037827007,
    "dropsitlph": 2037827007,
    "dropsitcph": 2037827007,
    "dropfax": 2037827084
  },
  {
    "dcode": "D",
    "dropkey": "EV20782",
    "droptype": "D",
    "dropname": "WATERBURY",
    "dropdeladd": "135 GRAND ST",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067019997",
    "dropphyadd": "135 GRAND ST",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067019997",
    "dropmaladd": "135 GRAND ST",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067019997",
    "dropsitphn": 2035746521,
    "dropsitlph": 2035746521,
    "dropsitcph": 2035746521,
    "dropfax": 2035746588
  },
  {
    "dcode": "D",
    "dropkey": "EV23310",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "215 PARK ST",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215029949,
    "dropphyadd": "215 PARK ST",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215029949,
    "dropmaladd": "215 PARK ST",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215029949,
    "dropsitphn": 3017228194,
    "dropsitlph": 3017228190,
    "dropsitcph": 3017228190,
    "dropfax": 3017773416
  },
  {
    "dcode": "D",
    "dropkey": "EV28231",
    "droptype": "D",
    "dropname": "NORTHWEST BOSTON",
    "dropdeladd": "200 SMITH ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024510099",
    "dropphyadd": "200 SMITH ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024510099",
    "dropmaladd": "200 SMITH ST STE 101",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024510002",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089455560,
    "dropfax": 5089454184
  },
  {
    "dcode": "D",
    "dropkey": "EW1A460",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "1202 S 5TH ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "SD",
    "dropdelzpp": 574019997,
    "dropphyadd": "1202 S 5TH ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "SD",
    "dropphyzpp": 574019997,
    "dropmaladd": "1202 S 5TH ST",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "SD",
    "dropmalzpp": 574019997,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052262673,
    "dropsitcph": 6052262673,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "EW1B018",
    "droptype": "D",
    "dropname": "PIERRE",
    "dropdeladd": "225 S PIERRE ST STE 101",
    "dropdelcty": "PIERRE",
    "dropdelst": "SD",
    "dropdelzpp": 575019997,
    "dropphyadd": "225 S PIERRE ST STE 101",
    "dropphycty": "PIERRE",
    "dropphyst": "SD",
    "dropphyzpp": 575019997,
    "dropmaladd": "225 S PIERRE ST STE 101",
    "dropmalcty": "PIERRE",
    "dropmalst": "SD",
    "dropmalzpp": 575019997,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052241204,
    "dropsitcph": 6052241204,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "EW1B501",
    "droptype": "D",
    "dropname": "RAWLINS",
    "dropdeladd": "106 5TH ST",
    "dropdelcty": "RAWLINS",
    "dropdelst": "WY",
    "dropdelzpp": 823019997,
    "dropphyadd": "106 5TH ST",
    "dropphycty": "RAWLINS",
    "dropphyst": "WY",
    "dropphyzpp": 823019997,
    "dropmaladd": "106 5TH ST",
    "dropmalcty": "RAWLINS",
    "dropmalst": "WY",
    "dropmalzpp": 823019997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073243521,
    "dropsitcph": 3073243521,
    "dropfax": 3073246134
  },
  {
    "dcode": "D",
    "dropkey": "EW1B513",
    "droptype": "D",
    "dropname": "ROCK SPRINGS",
    "dropdeladd": "2829 COMMERCIAL WAY",
    "dropdelcty": "ROCK SPRINGS",
    "dropdelst": "WY",
    "dropdelzpp": 829019997,
    "dropphyadd": "2829 COMMERCIAL WAY",
    "dropphycty": "ROCK SPRINGS",
    "dropphyst": "WY",
    "dropphyzpp": 829019997,
    "dropmaladd": "2829 COMMERCIAL WAY",
    "dropmalcty": "ROCK SPRINGS",
    "dropmalst": "WY",
    "dropmalzpp": 829019997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073629792,
    "dropsitcph": 3073629792,
    "dropfax": 3073829735
  },
  {
    "dcode": "D",
    "dropkey": "EW10224",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "614 N CLARK ST",
    "dropdelcty": "CARROLL",
    "dropdelst": "IA",
    "dropdelzpp": 514012578,
    "dropphyadd": "614 N CLARK ST",
    "dropphycty": "CARROLL",
    "dropphyst": "IA",
    "dropphyzpp": 514012578,
    "dropmaladd": "614 N CLARK ST",
    "dropmalcty": "CARROLL",
    "dropmalst": "IA",
    "dropmalzpp": 514012578,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127922341,
    "dropsitcph": 7127922341,
    "dropfax": 7127925581
  },
  {
    "dcode": "D",
    "dropkey": "EW10349",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "300 S ELM ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "IA",
    "dropdelzpp": 508013600,
    "dropphyadd": "300 S ELM ST",
    "dropphycty": "CRESTON",
    "dropphyst": "IA",
    "dropphyzpp": 508013600,
    "dropmaladd": "300 S ELM ST",
    "dropmalcty": "CRESTON",
    "dropmalst": "IA",
    "dropmalzpp": 508013600,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417822184,
    "dropsitcph": 6417822184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW12094",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "1511 E EMPIRE ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617019988,
    "dropphyadd": "1511 E EMPIRE ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617019988,
    "dropmaladd": "1511 E EMPIRE ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617019988,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096644600,
    "dropfax": 3096620076
  },
  {
    "dcode": "D",
    "dropkey": "EW12287",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "1301 E MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "IL",
    "dropdelzpp": 629011026,
    "dropphyadd": "1301 E MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "IL",
    "dropphyzpp": 629011026,
    "dropmaladd": "1301 E MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "IL",
    "dropmalzpp": 629011026,
    "dropsitphn": 3144363601,
    "dropsitlph": 6183515651,
    "dropsitcph": 6183515651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW12345",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "314 S POPLAR ST",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "IL",
    "dropdelzpp": 628019997,
    "dropphyadd": "314 S POPLAR ST",
    "dropphycty": "CENTRALIA",
    "dropphyst": "IL",
    "dropphyzpp": 628019997,
    "dropmaladd": "314 S POPLAR ST",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "IL",
    "dropmalzpp": 628019997,
    "dropsitphn": 3144363601,
    "dropsitlph": 6185326717,
    "dropsitcph": 6185326717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW14657",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "5225 HARRISON AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611259997,
    "dropphyadd": "5225 HARRISON AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611259997,
    "dropmaladd": "5225 HARRISON AVE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611259997,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152294806,
    "dropsitcph": 8152294806,
    "dropfax": 8152294857
  },
  {
    "dcode": "D",
    "dropkey": "EW19147",
    "droptype": "D",
    "dropname": "MINOT",
    "dropdeladd": "117 5TH AVE SW",
    "dropdelcty": "MINOT",
    "dropdelst": "ND",
    "dropdelzpp": 587019997,
    "dropphyadd": "117 5TH AVE SW",
    "dropphycty": "MINOT",
    "dropphyst": "ND",
    "dropphyzpp": 587019997,
    "dropmaladd": "117 5TH AVE SW",
    "dropmalcty": "MINOT",
    "dropmalst": "ND",
    "dropmalzpp": 587019997,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018576155,
    "dropsitcph": 7018576155,
    "dropfax": 7018576117
  },
  {
    "dcode": "D",
    "dropkey": "EW20353",
    "droptype": "D",
    "dropname": "COLBY",
    "dropdeladd": "535 N COURT AVE",
    "dropdelcty": "COLBY",
    "dropdelst": "KS",
    "dropdelzpp": 677019902,
    "dropphyadd": "535 N COURT AVE",
    "dropphycty": "COLBY",
    "dropphyst": "KS",
    "dropphyzpp": 677019902,
    "dropmaladd": "535 N COURT AVE",
    "dropmalcty": "COLBY",
    "dropmalst": "KS",
    "dropmalzpp": 677019902,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854627904,
    "dropsitcph": 7854627904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW20438",
    "droptype": "D",
    "dropname": "DODGE CITY",
    "dropdeladd": "700 CENTRAL AVE",
    "dropdelcty": "DODGE CITY",
    "dropdelst": "KS",
    "dropdelzpp": 678019906,
    "dropphyadd": "700 CENTRAL AVE",
    "dropphycty": "DODGE CITY",
    "dropphyst": "KS",
    "dropphyzpp": 678019906,
    "dropmaladd": "700 CENTRAL AVE",
    "dropmalcty": "DODGE CITY",
    "dropmalst": "KS",
    "dropmalzpp": 678019906,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202278619,
    "dropsitcph": 6202278618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW20678",
    "droptype": "D",
    "dropname": "HAYS",
    "dropdeladd": "706 FORT ST",
    "dropdelcty": "HAYS",
    "dropdelst": "KS",
    "dropdelzpp": 676019997,
    "dropphyadd": "706 FORT ST",
    "dropphycty": "HAYS",
    "dropphyst": "KS",
    "dropphyzpp": 676019997,
    "dropmaladd": "706 FORT ST",
    "dropmalcty": "HAYS",
    "dropmalst": "KS",
    "dropmalzpp": 676019997,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856253112,
    "dropsitcph": 7856252012,
    "dropfax": 7856254728
  },
  {
    "dcode": "D",
    "dropkey": "EW21349",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "211 E ASH ST",
    "dropdelcty": "SALINA",
    "dropdelst": "KS",
    "dropdelzpp": 674019942,
    "dropphyadd": "211 E ASH ST",
    "dropphycty": "SALINA",
    "dropphyst": "KS",
    "dropphyzpp": 674019942,
    "dropmaladd": "211 E ASH ST",
    "dropmalcty": "SALINA",
    "dropmalst": "KS",
    "dropmalzpp": 674019942,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858273695,
    "dropsitcph": 7858273695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW21614",
    "droptype": "D",
    "dropname": "TOPEKA",
    "dropdeladd": "1410 NW GAGE BLVD",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666182835,
    "dropphyadd": "1410 NW GAGE BLVD",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666182835,
    "dropmaladd": "1410 NW GAGE BLVD",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666182835,
    "dropsitphn": 7852313512,
    "dropsitlph": 7852313535,
    "dropsitcph": 7852313535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW23069",
    "droptype": "D",
    "dropname": "BRYAN",
    "dropdeladd": "2121 E WM J BRYAN PKWY",
    "dropdelcty": "BRYAN",
    "dropdelst": "TX",
    "dropdelzpp": 778019997,
    "dropphyadd": "2121 E WM J BRYAN PKWY",
    "dropphycty": "BRYAN",
    "dropphyst": "TX",
    "dropphyzpp": 778019997,
    "dropmaladd": "2121 E WM J BRYAN PKWY",
    "dropmalcty": "BRYAN",
    "dropmalst": "TX",
    "dropmalzpp": 778019997,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797742314,
    "dropsitcph": 9797747068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW24562",
    "droptype": "D",
    "dropname": "LUFKIN",
    "dropdeladd": "800 S JOHN REDDITT DR",
    "dropdelcty": "LUFKIN",
    "dropdelst": "TX",
    "dropdelzpp": 759049997,
    "dropphyadd": "800 S JOHN REDDITT DR",
    "dropphycty": "LUFKIN",
    "dropphyst": "TX",
    "dropphyzpp": 759049997,
    "dropmaladd": "800 S JOHN REDDITT DR",
    "dropmalcty": "LUFKIN",
    "dropmalst": "TX",
    "dropmalzpp": 759049997,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366347749,
    "dropsitcph": 9366347749,
    "dropfax": 9366392766
  },
  {
    "dcode": "D",
    "dropkey": "EW26090",
    "droptype": "D",
    "dropname": "EAST TEXAS",
    "dropdeladd": "12621 FM 3311",
    "dropdelcty": "TYLER",
    "dropdelst": "TX",
    "dropdelzpp": 757089901,
    "dropphyadd": "12621 FM 3311",
    "dropphycty": "TYLER",
    "dropphyst": "TX",
    "dropphyzpp": 757089901,
    "dropmaladd": "12621 FM 3311",
    "dropmalcty": "TYLER",
    "dropmalst": "TX",
    "dropmalzpp": 757089901,
    "dropsitphn": 2149482879,
    "dropsitlph": 9035958680,
    "dropsitcph": 9035958680,
    "dropfax": 9035958619
  },
  {
    "dcode": "D",
    "dropkey": "EW26196",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "430 W STATE HIGHWAY 6",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767020009,
    "dropphyadd": "430 W STATE HIGHWAY 6",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767020009,
    "dropmaladd": "430 W STATE HIGHWAY 6",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767020009,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543992201,
    "dropsitcph": 2543992201,
    "dropfax": 2543992287
  },
  {
    "dcode": "D",
    "dropkey": "EX1A703",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "2100 N 13TH ST",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196129991,
    "dropphyadd": "2100 N 13TH ST",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196129991,
    "dropmaladd": "2100 N 13TH ST",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196129991,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217055,
    "dropsitcph": 6109217000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX1B156",
    "droptype": "D",
    "dropname": "SOUTHEASTERN",
    "dropdeladd": "1000 W VALLEY RD",
    "dropdelcty": "SOUTHEASTERN",
    "dropdelst": "PA",
    "dropdelzpp": 193999992,
    "dropphyadd": "1000 W VALLEY RD",
    "dropphycty": "SOUTHEASTERN",
    "dropphyst": "PA",
    "dropphyzpp": 193999992,
    "dropmaladd": "1000 W VALLEY RD",
    "dropmalcty": "SOUTHEASTERN",
    "dropmalst": "PA",
    "dropmalzpp": 193999992,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109646401,
    "dropsitcph": 6109646401,
    "dropfax": 6109646458
  },
  {
    "dcode": "D",
    "dropkey": "EX1C041",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "2901 REACH RD",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177019997,
    "dropphyadd": "2901 REACH RD",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177019997,
    "dropmaladd": "2901 REACH RD",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177019997,
    "dropsitphn": 7172574875,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703204100,
    "dropfax": 5703204126
  },
  {
    "dcode": "D",
    "dropkey": "EX1C317",
    "droptype": "D",
    "dropname": "KOKOMO",
    "dropdeladd": "2719 S WEBSTER ST",
    "dropdelcty": "KOKOMO",
    "dropdelst": "IN",
    "dropdelzpp": 469029997,
    "dropphyadd": "2719 S WEBSTER ST",
    "dropphycty": "KOKOMO",
    "dropphyst": "IN",
    "dropphyzpp": 469029997,
    "dropmaladd": "2719 S WEBSTER ST",
    "dropmalcty": "KOKOMO",
    "dropmalst": "IN",
    "dropmalzpp": 469029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 7654558322,
    "dropsitcph": 7654558338,
    "dropfax": 7654558350
  },
  {
    "dcode": "D",
    "dropkey": "EX10018",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "1501 S SLAPPEY BLVD",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317019997,
    "dropphyadd": "1501 S SLAPPEY BLVD",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317019997,
    "dropmaladd": "1501 S SLAPPEY BLVD",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317019997,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298892629,
    "dropsitcph": 2298892629,
    "dropfax": 2298892640
  },
  {
    "dcode": "D",
    "dropkey": "EX10273",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3916 MILGEN RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079992,
    "dropphyadd": "3916 MILGEN RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319079992,
    "dropmaladd": "3916 MILGEN RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319079992,
    "dropsitphn": 4787528444,
    "dropsitlph": 7065621782,
    "dropsitcph": 7065621782,
    "dropfax": 7065621784
  },
  {
    "dcode": "D",
    "dropkey": "EX11113",
    "droptype": "D",
    "dropname": "SAVANNAH",
    "dropdeladd": "210 BOURNE BLVD",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314089997,
    "dropphyadd": "210 BOURNE BLVD",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314089997,
    "dropmaladd": "210 BOURNE BLVD",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314089997,
    "dropsitphn": 4787528444,
    "dropsitlph": 9127487558,
    "dropsitcph": 9127487558,
    "dropfax": 9127487514
  },
  {
    "dcode": "D",
    "dropkey": "EX11243",
    "droptype": "D",
    "dropname": "SWAINSBORO",
    "dropdeladd": "211 W MORING ST",
    "dropdelcty": "SWAINSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 304019997,
    "dropphyadd": "211 W MORING ST",
    "dropphycty": "SWAINSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 304019997,
    "dropmaladd": "211 W MORING ST",
    "dropmalcty": "SWAINSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 304019997,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782379689,
    "dropsitcph": 4782379689,
    "dropfax": 4782379070
  },
  {
    "dcode": "D",
    "dropkey": "EX12682",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "3450 SOUTH ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479059997,
    "dropphyadd": "3450 SOUTH ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479059997,
    "dropmaladd": "3450 SOUTH ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479059997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489200,
    "dropfax": 7654489292
  },
  {
    "dcode": "D",
    "dropkey": "EX13833",
    "droptype": "D",
    "dropname": "TERRE HAUTE",
    "dropdeladd": "150 W MARGARET DR",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478029997,
    "dropphyadd": "150 W MARGARET DR",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478029997,
    "dropmaladd": "150 W MARGARET DR",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122314020,
    "dropfax": 8122314140
  },
  {
    "dcode": "D",
    "dropkey": "EX14398",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "5300 SCOTTSVILLE RD",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 421049997,
    "dropphyadd": "5300 SCOTTSVILLE RD",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 421049997,
    "dropmaladd": "5300 SCOTTSVILLE RD",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 421049997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708435760,
    "dropfax": 2708435773
  },
  {
    "dcode": "D",
    "dropkey": "EX14505",
    "droptype": "D",
    "dropname": "CAMPTON",
    "dropdeladd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropdelcty": "CAMPTON",
    "dropdelst": "KY",
    "dropdelzpp": 413019997,
    "dropphyadd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropphycty": "CAMPTON",
    "dropphyst": "KY",
    "dropphyzpp": 413019997,
    "dropmaladd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropmalcty": "CAMPTON",
    "dropmalst": "KY",
    "dropmalzpp": 413019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066686395,
    "dropfax": 6066686398
  },
  {
    "dcode": "D",
    "dropkey": "EX14904",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "2934 DOLPHIN DR",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 427019996,
    "dropphyadd": "2934 DOLPHIN DR",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 427019996,
    "dropmaladd": "2934 DOLPHIN DR",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 427019996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707657230,
    "dropfax": 2707372595
  },
  {
    "dcode": "D",
    "dropkey": "EX15274",
    "droptype": "D",
    "dropname": "HAZARD",
    "dropdeladd": "201 BLACK GOLD BLVD",
    "dropdelcty": "HAZARD",
    "dropdelst": "KY",
    "dropdelzpp": 417019997,
    "dropphyadd": "201 BLACK GOLD BLVD",
    "dropphycty": "HAZARD",
    "dropphyst": "KY",
    "dropphyzpp": 417019997,
    "dropmaladd": "201 BLACK GOLD BLVD",
    "dropmalcty": "HAZARD",
    "dropmalst": "KY",
    "dropmalzpp": 417019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064363180,
    "dropfax": 6064393499
  },
  {
    "dcode": "D",
    "dropkey": "EX15623",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "1760 HIGHWAY 192 W",
    "dropdelcty": "LONDON",
    "dropdelst": "KY",
    "dropdelzpp": 407419997,
    "dropphyadd": "1760 HIGHWAY 192 W",
    "dropphycty": "LONDON",
    "dropphyst": "KY",
    "dropphyzpp": 407419997,
    "dropmaladd": "1760 HIGHWAY 192 W",
    "dropmalcty": "LONDON",
    "dropmalst": "KY",
    "dropmalzpp": 407419997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068641701,
    "dropfax": 6068642289
  },
  {
    "dcode": "D",
    "dropkey": "EX15981",
    "droptype": "D",
    "dropname": "OWENSBORO",
    "dropdeladd": "54 BON HARBOR HLS",
    "dropdelcty": "OWENSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423019997,
    "dropphyadd": "54 BON HARBOR HLS",
    "dropphycty": "OWENSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423019997,
    "dropmaladd": "54 BON HARBOR HLS",
    "dropmalcty": "OWENSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706891838,
    "dropfax": 2706868895
  },
  {
    "dcode": "D",
    "dropkey": "EX16407",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "119 N MAPLE ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "KY",
    "dropdelzpp": 425019997,
    "dropphyadd": "119 N MAPLE ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "KY",
    "dropphyzpp": 425019997,
    "dropmaladd": "119 N MAPLE ST",
    "dropmalcty": "SOMERSET",
    "dropmalst": "KY",
    "dropmalzpp": 425019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066793549,
    "dropfax": 6066795430
  },
  {
    "dcode": "D",
    "dropkey": "EX18264",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "2108 E 38TH ST",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165159987,
    "dropphyadd": "2108 E 38TH ST",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165159987,
    "dropmaladd": "2108 E 38TH ST",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165159987,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148987340,
    "dropsitcph": 8148987364,
    "dropfax": 8148987303
  },
  {
    "dcode": "D",
    "dropkey": "EX25352",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383019997,
    "dropphyadd": "200 DR MARTIN LUTHER KING JR DR",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383019997,
    "dropmaladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383019997,
    "dropsitphn": 6158859336,
    "dropsitlph": 7314232596,
    "dropsitcph": 7314232596,
    "dropfax": 7314230234
  },
  {
    "dcode": "D",
    "dropkey": "EX26451",
    "droptype": "D",
    "dropname": "CULPEPER",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "CULPEPER",
    "dropdelst": "VA",
    "dropdelzpp": 227019996,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "CULPEPER",
    "dropphyst": "VA",
    "dropphyzpp": 227019996,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "CULPEPER",
    "dropmalst": "VA",
    "dropmalzpp": 227019996,
    "dropsitphn": 7036986367,
    "dropsitlph": 5408298435,
    "dropsitcph": 5408298435,
    "dropfax": 5408253983
  },
  {
    "dcode": "D",
    "dropkey": "EX26599",
    "droptype": "D",
    "dropname": "FARMVILLE",
    "dropdeladd": "301 E 3RD ST",
    "dropdelcty": "FARMVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239019998,
    "dropphyadd": "301 E 3RD ST",
    "dropphycty": "FARMVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239019997,
    "dropmaladd": "301 E 3RD ST",
    "dropmalcty": "FARMVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343923354,
    "dropsitcph": 4343923354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX28238",
    "droptype": "D",
    "dropname": "BUCKHANNON",
    "dropdeladd": "11 S SPRING ST",
    "dropdelcty": "BUCKHANNON",
    "dropdelst": "WV",
    "dropdelzpp": 262019913,
    "dropphyadd": "11 S SPRING ST",
    "dropphycty": "BUCKHANNON",
    "dropphyst": "WV",
    "dropphyzpp": 262019913,
    "dropmaladd": "11 S SPRING ST",
    "dropmalcty": "BUCKHANNON",
    "dropmalst": "WV",
    "dropmalzpp": 262019913,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044722020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX28309",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "200 CAVA DR",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263019997,
    "dropphyadd": "200 CAVA DR",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263019997,
    "dropmaladd": "200 CAVA DR",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263019997,
    "dropsitphn": 3046237731,
    "dropsitlph": 3046237731,
    "dropsitcph": 3046234796,
    "dropfax": 3046248897
  },
  {
    "dcode": "D",
    "dropkey": "EX28838",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "1355 OLD COURTHOUSE SQ",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 254049905,
    "dropphyadd": "1355 OLD COURTHOUSE SQ",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 254049905,
    "dropmaladd": "1355 OLD COURTHOUSE SQ",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 254049905,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042677787,
    "dropfax": 3042679360
  },
  {
    "dcode": "D",
    "dropkey": "EX29366",
    "droptype": "D",
    "dropname": "WHEELING",
    "dropdeladd": "2501 CHAPLINE ST",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260039787,
    "dropphyadd": "2501 CHAPLINE ST",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260039787,
    "dropmaladd": "2501 CHAPLINE ST",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260039787,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042333912,
    "dropsitcph": 3042431875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX29487",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "40 S WALNUT ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "OH",
    "dropdelzpp": 456013257,
    "dropphyadd": "40 S WALNUT ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "OH",
    "dropphyzpp": 456013257,
    "dropmaladd": "40 S WALNUT ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "OH",
    "dropmalzpp": 456013257,
    "dropsitphn": 7407741181,
    "dropsitlph": 7407741181,
    "dropsitcph": 7407741181,
    "dropfax": 7407742354
  },
  {
    "dcode": "D",
    "dropkey": "EX29542",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "5 W STIMSON AVE",
    "dropdelcty": "ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 457012668,
    "dropphyadd": "5 W STIMSON AVE",
    "dropphycty": "ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 457012668,
    "dropmaladd": "5 W STIMSON AVE",
    "dropmalcty": "ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 457012668,
    "dropsitphn": 7405935578,
    "dropsitlph": 6144720674,
    "dropsitcph": 7405935578,
    "dropfax": 7405944601
  },
  {
    "dcode": "D",
    "dropkey": "EY10338",
    "droptype": "D",
    "dropname": "DOTHAN",
    "dropdeladd": "379 N OATES ST",
    "dropdelcty": "DOTHAN",
    "dropdelst": "AL",
    "dropdelzpp": 363024500,
    "dropphyadd": "379 N OATES ST",
    "dropphycty": "DOTHAN",
    "dropphyst": "AL",
    "dropphyzpp": 363024500,
    "dropmaladd": "379 N OATES ST",
    "dropmalcty": "DOTHAN",
    "dropmalst": "AL",
    "dropmalzpp": 363029998,
    "dropsitphn": 3347948567,
    "dropsitlph": 3347948567,
    "dropsitcph": 3347948567,
    "dropfax": 3347941032
  },
  {
    "dcode": "D",
    "dropkey": "EY11932",
    "droptype": "D",
    "dropname": "GAYLORD",
    "dropdeladd": "289 W COMMERCE BLVD",
    "dropdelcty": "GAYLORD",
    "dropdelst": "MI",
    "dropdelzpp": 497357343,
    "dropphyadd": "289 W COMMERCE BLVD",
    "dropphycty": "GAYLORD",
    "dropphyst": "MI",
    "dropphyzpp": 497357343,
    "dropmaladd": "289 W COMMERCE BLVD",
    "dropmalcty": "GAYLORD",
    "dropmalst": "MI",
    "dropmalzpp": 497357343,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897326800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY12136",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "1500 N ELM AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "MI",
    "dropdelzpp": 492029956,
    "dropphyadd": "1500 N ELM AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "MI",
    "dropphyzpp": 492029956,
    "dropmaladd": "1500 N ELM AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "MI",
    "dropmalzpp": 492029956,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5177680721,
    "dropfax": 5177680618
  },
  {
    "dcode": "D",
    "dropkey": "EY12153",
    "droptype": "D",
    "dropname": "KALAMAZOO",
    "dropdeladd": "3885 S 9TH ST",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490099554,
    "dropphyadd": "3885 S 9TH ST",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490099554,
    "dropmaladd": "3885 S 9TH ST",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490099554,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693535000,
    "dropsitcph": 2693535000,
    "dropfax": 2693535004
  },
  {
    "dcode": "D",
    "dropkey": "EY12713",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "1233 S WASHINGTON AVE",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486012503,
    "dropphyadd": "1233 S WASHINGTON AVE",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486012503,
    "dropmaladd": "1233 S WASHINGTON AVE",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486012503,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715727,
    "dropsitcph": 9897715725,
    "dropfax": 9897715704
  },
  {
    "dcode": "D",
    "dropkey": "EY13432",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3202 BLUECUTT RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MS",
    "dropdelzpp": 397059997,
    "dropphyadd": "3202 BLUECUTT RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MS",
    "dropphyzpp": 397059997,
    "dropmaladd": "3202 BLUECUTT RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MS",
    "dropmalzpp": 397059997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623282313,
    "dropsitcph": 6623291092,
    "dropfax": 6623281502
  },
  {
    "dcode": "D",
    "dropkey": "EY13691",
    "droptype": "D",
    "dropname": "GRENADA",
    "dropdeladd": "2500 GATEWAY ST",
    "dropdelcty": "GRENADA",
    "dropdelst": "MS",
    "dropdelzpp": 389019998,
    "dropphyadd": "2500 GATEWAY ST",
    "dropphycty": "GRENADA",
    "dropphyst": "MS",
    "dropphyzpp": 389019997,
    "dropmaladd": "2500 GATEWAY ST",
    "dropmalcty": "GRENADA",
    "dropmalst": "MS",
    "dropmalzpp": 389019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622265521,
    "dropsitcph": 6622265515,
    "dropfax": 6622264342
  },
  {
    "dcode": "D",
    "dropkey": "EY13720",
    "droptype": "D",
    "dropname": "HATTIESBURG",
    "dropdeladd": "220 S 40TH AVE",
    "dropdelcty": "HATTIESBURG",
    "dropdelst": "MS",
    "dropdelzpp": 394029997,
    "dropphyadd": "220 S 40TH AVE",
    "dropphycty": "HATTIESBURG",
    "dropphyst": "MS",
    "dropphyzpp": 394029997,
    "dropmaladd": "220 S 40TH AVE",
    "dropmalcty": "HATTIESBURG",
    "dropmalst": "MS",
    "dropmalzpp": 394029997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6012717080,
    "dropsitcph": 6012717000,
    "dropfax": 6012717060
  },
  {
    "dcode": "D",
    "dropkey": "EY14531",
    "droptype": "D",
    "dropname": "TUPELO",
    "dropdeladd": "362 S THOMAS ST",
    "dropdelcty": "TUPELO",
    "dropdelst": "MS",
    "dropdelzpp": 388019998,
    "dropphyadd": "362 S THOMAS ST",
    "dropphycty": "TUPELO",
    "dropphyst": "MS",
    "dropphyzpp": 388019997,
    "dropmaladd": "362 S THOMAS ST",
    "dropmalcty": "TUPELO",
    "dropmalst": "MS",
    "dropmalzpp": 388019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627918430,
    "dropsitcph": 6627918401,
    "dropfax": 6628440888
  },
  {
    "dcode": "D",
    "dropkey": "EY17528",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "425 STATE ST",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "WI",
    "dropdelzpp": 546013346,
    "dropphyadd": "425 STATE ST",
    "dropphycty": "LA CROSSE",
    "dropphyst": "WI",
    "dropphyzpp": 546013346,
    "dropmaladd": "425 STATE ST STE 100",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "WI",
    "dropmalzpp": 546019998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6087918100,
    "dropfax": 6087826227
  },
  {
    "dcode": "D",
    "dropkey": "EY20425",
    "droptype": "D",
    "dropname": "FORT SMITH",
    "dropdeladd": "3318 S 74TH ST",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729039996,
    "dropphyadd": "3318 S 74TH ST",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729039996,
    "dropmaladd": "3318 S 74TH ST",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729039996,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794846401,
    "dropsitcph": 4794846401,
    "dropfax": 4794846397
  },
  {
    "dcode": "D",
    "dropkey": "EY20531",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "215 W INDUSTRIAL PARK RD",
    "dropdelcty": "HARRISON",
    "dropdelst": "AR",
    "dropdelzpp": 726019998,
    "dropphyadd": "215 W INDUSTRIAL PARK RD",
    "dropphycty": "HARRISON",
    "dropphyst": "AR",
    "dropphyzpp": 726019902,
    "dropmaladd": "215 W INDUSTRIAL PARK RD",
    "dropmalcty": "HARRISON",
    "dropmalst": "AR",
    "dropmalzpp": 726019998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707413473,
    "dropsitcph": 8707413473,
    "dropfax": 5017417162
  },
  {
    "dcode": "D",
    "dropkey": "EY20591",
    "droptype": "D",
    "dropname": "HOT SPRINGS NATIONAL PARK",
    "dropdeladd": "335 SECTION LINE RD",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139998,
    "dropphyadd": "335 SECTION LINE RD",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139942,
    "dropmaladd": "335 SECTION LINE RD",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5015250558,
    "dropsitcph": 5015250558,
    "dropfax": 5015253164
  },
  {
    "dcode": "D",
    "dropkey": "EY20640",
    "droptype": "D",
    "dropname": "NORTHEAST ARKANSAS",
    "dropdeladd": "3405 MOORE RD",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019996,
    "dropphyadd": "3405 MOORE RD",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019996,
    "dropmaladd": "3405 MOORE RD",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019996,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709315763,
    "dropsitcph": 8709315763,
    "dropfax": 8709316932
  },
  {
    "dcode": "D",
    "dropkey": "EY21080",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "203 S BOSTON AVE",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728019998,
    "dropphyadd": "203 S BOSTON AVE",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728019907,
    "dropmaladd": "203 S BOSTON AVE",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728019998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799684112,
    "dropsitcph": 4799684112,
    "dropfax": 4799683628
  },
  {
    "dcode": "D",
    "dropkey": "EY22226",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "2800 LAKELAND HILLS BLVD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338058800,
    "dropphyadd": "2800 LAKELAND HILLS BLVD",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338058800,
    "dropmaladd": "2800 LAKELAND HILLS BLVD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338058800,
    "dropsitphn": 8138770729,
    "dropsitlph": 8638022053,
    "dropsitcph": 8638022066,
    "dropfax": 8638022080
  },
  {
    "dcode": "D",
    "dropkey": "EY22836",
    "droptype": "D",
    "dropname": "SAINT PETERSBURG",
    "dropdeladd": "3135 1ST AVE N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337309997,
    "dropphyadd": "3135 1ST AVE N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337309997,
    "dropmaladd": "3135 1ST AVE N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337309997,
    "dropsitphn": 8138770729,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273236501,
    "dropfax": 7273286605
  },
  {
    "dcode": "D",
    "dropkey": "EY22915",
    "droptype": "D",
    "dropname": "SOUTH FLORIDA",
    "dropdeladd": "16000 PINES BLVD",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330829698,
    "dropphyadd": "16000 PINES BLVD",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330829698,
    "dropmaladd": "PO BOX 829997",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330829997,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055132368,
    "dropsitcph": 9544364356,
    "dropfax": 9544364316
  },
  {
    "dcode": "D",
    "dropkey": "EY24815",
    "droptype": "D",
    "dropname": "BEMIDJI",
    "dropdeladd": "401 IRVINE AVE NW",
    "dropdelcty": "BEMIDJI",
    "dropdelst": "MN",
    "dropdelzpp": 566012602,
    "dropphyadd": "401 IRVINE AVE NW",
    "dropphycty": "BEMIDJI",
    "dropphyst": "MN",
    "dropphyzpp": 566012602,
    "dropmaladd": "401 IRVINE AVE NW",
    "dropmalcty": "BEMIDJI",
    "dropmalst": "MN",
    "dropmalzpp": 566012602,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187511059,
    "dropfax": 2187591917
  },
  {
    "dcode": "D",
    "dropkey": "EY26185",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "3939 VALLEYHIGH RD NW",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559012203,
    "dropphyadd": "3939 VALLEYHIGH RD NW",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559012203,
    "dropmaladd": "3939 VALLEYHIGH RD NW",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559012208,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072871268,
    "dropfax": 5072871274
  },
  {
    "dcode": "D",
    "dropkey": "EY26695",
    "droptype": "D",
    "dropname": "WINDOM",
    "dropdeladd": "445 9TH ST",
    "dropdelcty": "WINDOM",
    "dropdelst": "MN",
    "dropdelzpp": 561011640,
    "dropphyadd": "445 9TH ST",
    "dropphycty": "WINDOM",
    "dropphyst": "MN",
    "dropphyzpp": 561011626,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDOM",
    "dropmalst": "MN",
    "dropmalzpp": 561019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5078312595,
    "dropsitcph": 5078312595,
    "dropfax": 5078312206
  },
  {
    "dcode": "D",
    "dropkey": "EZ10106",
    "droptype": "D",
    "dropname": "FAIRBANKS",
    "dropdeladd": "5400 MAIL TRAIL RD",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "AK",
    "dropdelzpp": 997091000,
    "dropphyadd": "5400 MAIL TRAIL RD",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "AK",
    "dropphyzpp": 997091000,
    "dropmaladd": "5400 MAIL TRAIL RD",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "AK",
    "dropmalzpp": 997091000,
    "dropsitphn": 9074555452,
    "dropsitlph": 9074555452,
    "dropsitcph": 9074555406,
    "dropfax": 9074555480
  },
  {
    "dcode": "D",
    "dropkey": "EZ10149",
    "droptype": "S",
    "dropname": "JUNEAU",
    "dropdeladd": "9491 VINTAGE BLVD",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998017107,
    "dropphyadd": "9491 VINTAGE BLVD",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998017107,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "JUNEAU",
    "dropmalst": "AK",
    "dropmalzpp": 998039998,
    "dropsitphn": 9077893295,
    "dropsitlph": 9077893295,
    "dropsitcph": 9077890934,
    "dropfax": 9077895291
  },
  {
    "dcode": "D",
    "dropkey": "EZ10160",
    "droptype": "S",
    "dropname": "KETCHIKAN",
    "dropdeladd": "3609 TONGASS AVE",
    "dropdelcty": "KETCHIKAN",
    "dropdelst": "AK",
    "dropdelzpp": 999019994,
    "dropphyadd": "3609 TONGASS AVE",
    "dropphycty": "KETCHIKAN",
    "dropphyst": "AK",
    "dropphyzpp": 999019994,
    "dropmaladd": "3609 TONGASS AVE",
    "dropmalcty": "KETCHIKAN",
    "dropmalst": "AK",
    "dropmalzpp": 999019994,
    "dropsitphn": 9072259602,
    "dropsitlph": 9072259602,
    "dropsitcph": 9072259602,
    "dropfax": 9072471272
  },
  {
    "dcode": "D",
    "dropkey": "EZ11013",
    "droptype": "D",
    "dropname": "ALAMOSA",
    "dropdeladd": "505 3RD ST",
    "dropdelcty": "ALAMOSA",
    "dropdelst": "CO",
    "dropdelzpp": 811019997,
    "dropphyadd": "505 3RD ST",
    "dropphycty": "ALAMOSA",
    "dropphyst": "CO",
    "dropphyzpp": 811019997,
    "dropmaladd": "505 3RD ST",
    "dropmalcty": "ALAMOSA",
    "dropmalst": "CO",
    "dropmalzpp": 811019997,
    "dropsitphn": 7195894909,
    "dropsitlph": 7195894909,
    "dropsitcph": 7195894909,
    "dropfax": 7195896190
  },
  {
    "dcode": "D",
    "dropkey": "EZ11329",
    "droptype": "D",
    "dropname": "DURANGO",
    "dropdeladd": "222 W 8TH ST",
    "dropdelcty": "DURANGO",
    "dropdelst": "CO",
    "dropdelzpp": 813019997,
    "dropphyadd": "222 W 8TH ST",
    "dropphycty": "DURANGO",
    "dropphyst": "CO",
    "dropphyzpp": 813019997,
    "dropmaladd": "222 W 8TH ST",
    "dropmalcty": "DURANGO",
    "dropmalst": "CO",
    "dropmalzpp": 813019997,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702473968,
    "dropsitcph": 9702473434,
    "dropfax": 9702473154
  },
  {
    "dcode": "D",
    "dropkey": "EZ11824",
    "droptype": "D",
    "dropname": "SALIDA",
    "dropdeladd": "310 D ST",
    "dropdelcty": "SALIDA",
    "dropdelst": "CO",
    "dropdelzpp": 812019997,
    "dropphyadd": "310 D ST",
    "dropphycty": "SALIDA",
    "dropphyst": "CO",
    "dropphyzpp": 812019997,
    "dropmaladd": "310 D ST",
    "dropmalcty": "SALIDA",
    "dropmalst": "CO",
    "dropmalzpp": 812019997,
    "dropsitphn": 7195392548,
    "dropsitlph": 7195392548,
    "dropsitcph": 7195393655,
    "dropfax": 7195300763
  },
  {
    "dcode": "D",
    "dropkey": "EZ13070",
    "droptype": "D",
    "dropname": "BUTTE",
    "dropdeladd": "701 DEWEY BLVD",
    "dropdelcty": "BUTTE",
    "dropdelst": "MT",
    "dropdelzpp": 597019997,
    "dropphyadd": "701 DEWEY BLVD",
    "dropphycty": "BUTTE",
    "dropphyst": "MT",
    "dropphyzpp": 597019997,
    "dropmaladd": "701 DEWEY BLVD",
    "dropmalcty": "BUTTE",
    "dropmalst": "MT",
    "dropmalzpp": 597019997,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064942107,
    "dropsitcph": 4064942107,
    "dropfax": 4064942718
  },
  {
    "dcode": "D",
    "dropkey": "EZ13215",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "2300 N HARRIS ST",
    "dropdelcty": "HELENA",
    "dropdelst": "MT",
    "dropdelzpp": 596019997,
    "dropphyadd": "2300 N HARRIS ST",
    "dropphycty": "HELENA",
    "dropphyst": "MT",
    "dropphyzpp": 596019997,
    "dropmaladd": "2300 N HARRIS ST",
    "dropmalcty": "HELENA",
    "dropmalst": "MT",
    "dropmalzpp": 596019997,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064433304,
    "dropsitcph": 4064433304,
    "dropfax": 4064427946
  },
  {
    "dcode": "D",
    "dropkey": "EZ13245",
    "droptype": "D",
    "dropname": "KALISPELL",
    "dropdeladd": "350 N MERIDIAN RD",
    "dropdelcty": "KALISPELL",
    "dropdelst": "MT",
    "dropdelzpp": 599019997,
    "dropphyadd": "350 N MERIDIAN RD",
    "dropphycty": "KALISPELL",
    "dropphyst": "MT",
    "dropphyzpp": 599019997,
    "dropmaladd": "350 N MERIDIAN RD",
    "dropmalcty": "KALISPELL",
    "dropmalst": "MT",
    "dropmalzpp": 599019997,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067556450,
    "dropsitcph": 4067556450,
    "dropfax": 4067560045
  },
  {
    "dcode": "D",
    "dropkey": "EZ13479",
    "droptype": "D",
    "dropname": "WOLF POINT",
    "dropdeladd": "131 FRONT ST",
    "dropdelcty": "WOLF POINT",
    "dropdelst": "MT",
    "dropdelzpp": 592019997,
    "dropphyadd": "131 FRONT ST",
    "dropphycty": "WOLF POINT",
    "dropphyst": "MT",
    "dropphyzpp": 592019997,
    "dropmaladd": "131 FRONT ST",
    "dropmalcty": "WOLF POINT",
    "dropmalst": "MT",
    "dropmalzpp": 592019997,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066532802,
    "dropsitcph": 4066532802,
    "dropfax": 4066533650
  },
  {
    "dcode": "D",
    "dropkey": "EZ13630",
    "droptype": "D",
    "dropname": "NORTHWEST STATION",
    "dropdeladd": "1224 W 21ST ST",
    "dropdelcty": "CLOVIS",
    "dropdelst": "NM",
    "dropdelzpp": 881014126,
    "dropphyadd": "1224 W 21ST ST",
    "dropphycty": "CLOVIS",
    "dropphyst": "NM",
    "dropphyzpp": 881014126,
    "dropmaladd": "1224 W 21ST ST",
    "dropmalcty": "CLOVIS",
    "dropmalst": "NM",
    "dropmalzpp": 881014126,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757635556,
    "dropsitcph": 5757635556,
    "dropfax": 5757638964
  },
  {
    "dcode": "D",
    "dropkey": "EZ14089",
    "droptype": "D",
    "dropname": "ROSWELL",
    "dropdeladd": "497 W BRASHER RD",
    "dropdelcty": "ROSWELL",
    "dropdelst": "NM",
    "dropdelzpp": 882035353,
    "dropphyadd": "497 W BRASHER RD",
    "dropphycty": "ROSWELL",
    "dropphyst": "NM",
    "dropphyzpp": 882035353,
    "dropmaladd": "497 W BRASHER RD",
    "dropmalcty": "ROSWELL",
    "dropmalst": "NM",
    "dropmalzpp": 882035353,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756238699,
    "dropsitcph": 5756238699,
    "dropfax": 5756278256
  },
  {
    "dcode": "D",
    "dropkey": "EZ14244",
    "droptype": "D",
    "dropname": "TRUTH OR CONSEQUENCES",
    "dropdeladd": "1507 N DATE ST",
    "dropdelcty": "TRUTH OR CONSEQUENCES",
    "dropdelst": "NM",
    "dropdelzpp": 879013717,
    "dropphyadd": "1507 N DATE ST",
    "dropphycty": "TRUTH OR CONSEQUENCES",
    "dropphyst": "NM",
    "dropphyzpp": 879013717,
    "dropmaladd": "1507 N DATE ST",
    "dropmalcty": "TRUTH OR CONSEQUENCES",
    "dropmalst": "NM",
    "dropmalzpp": 879013717,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758943137,
    "dropsitcph": 5758943137,
    "dropfax": 5758949402
  },
  {
    "dcode": "D",
    "dropkey": "EZ14246",
    "droptype": "D",
    "dropname": "TUCUMCARI",
    "dropdeladd": "220 S 1ST ST",
    "dropdelcty": "TUCUMCARI",
    "dropdelst": "NM",
    "dropdelzpp": 884012702,
    "dropphyadd": "220 S 1ST ST",
    "dropphycty": "TUCUMCARI",
    "dropphyst": "NM",
    "dropphyzpp": 884012702,
    "dropmaladd": "220 S 1ST ST",
    "dropmalcty": "TUCUMCARI",
    "dropmalst": "NM",
    "dropmalzpp": 884012702,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058483903,
    "dropsitcph": 5754610370,
    "dropfax": 5754613942
  },
  {
    "dcode": "D",
    "dropkey": "EZ14400",
    "droptype": "D",
    "dropname": "ELKO",
    "dropdeladd": "500 ASPEN WAY",
    "dropdelcty": "ELKO",
    "dropdelst": "NV",
    "dropdelzpp": 898019997,
    "dropphyadd": "500 ASPEN WAY",
    "dropphycty": "ELKO",
    "dropphyst": "NV",
    "dropphyzpp": 898019997,
    "dropmaladd": "500 ASPEN WAY",
    "dropmalcty": "ELKO",
    "dropmalst": "NV",
    "dropmalzpp": 898019997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757779803,
    "dropsitcph": 7757779803,
    "dropfax": 7757385980
  },
  {
    "dcode": "D",
    "dropkey": "EZ14764",
    "droptype": "D",
    "dropname": "BEND",
    "dropdeladd": "2300 NE 4TH ST",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977013630,
    "dropphyadd": "2300 NE 4TH ST",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977013630,
    "dropmaladd": "2300 NE 4TH ST",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977013615,
    "dropsitphn": 5032942242,
    "dropsitlph": 5413882427,
    "dropsitcph": 5413185068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ16762",
    "droptype": "D",
    "dropname": "EVERETT",
    "dropdeladd": "8120 HARDESON RD",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982036289,
    "dropphyadd": "8120 HARDESON RD",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982036289,
    "dropmaladd": "8120 HARDESON RD",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982036289,
    "dropsitphn": 2063816600,
    "dropsitlph": 4253558366,
    "dropsitcph": 4252906300,
    "dropfax": 4252906306
  },
  {
    "dcode": "D",
    "dropkey": "EZ17233",
    "droptype": "D",
    "dropname": "OLYMPIA",
    "dropdeladd": "717 76TH AVE SW",
    "dropdelcty": "TUMWATER",
    "dropdelst": "WA",
    "dropdelzpp": 985019991,
    "dropphyadd": "717 76TH AVE SW",
    "dropphycty": "TUMWATER",
    "dropphyst": "WA",
    "dropphyzpp": 985019991,
    "dropmaladd": "717 76TH AVE SW",
    "dropmalcty": "TUMWATER",
    "dropmalst": "WA",
    "dropmalzpp": 985019991,
    "dropsitphn": 2063816600,
    "dropsitlph": 3607044815,
    "dropsitcph": 3607044815,
    "dropfax": 3607044892
  },
  {
    "dcode": "D",
    "dropkey": "EZ17272",
    "droptype": "D",
    "dropname": "PASCO",
    "dropdeladd": "3500 W COURT ST",
    "dropdelcty": "PASCO",
    "dropdelst": "WA",
    "dropdelzpp": 993013886,
    "dropphyadd": "3500 W COURT ST",
    "dropphycty": "PASCO",
    "dropphyst": "WA",
    "dropphyzpp": 993013886,
    "dropmaladd": "3500 W COURT ST",
    "dropmalcty": "PASCO",
    "dropmalst": "WA",
    "dropmalzpp": 993013886,
    "dropsitphn": 5095432189,
    "dropsitlph": 5095432113,
    "dropsitcph": 5095432189,
    "dropfax": 5095432116
  },
  {
    "dcode": "D",
    "dropkey": "EZ17891",
    "droptype": "D",
    "dropname": "BARRIGADA",
    "dropdeladd": "489 ARMY DR",
    "dropdelcty": "BARRIGADA",
    "dropdelst": "GU",
    "dropdelzpp": 969139997,
    "dropphyadd": "489 ARMY DR",
    "dropphycty": "BARRIGADA",
    "dropphyst": "GU",
    "dropphyzpp": 969139997,
    "dropmaladd": "489 ARMY DR",
    "dropmalcty": "BARRIGADA",
    "dropmalst": "GU",
    "dropmalzpp": 969139997,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6717343921,
    "dropfax": 6717343925
  },
  {
    "dcode": "D",
    "dropkey": "EZ17891",
    "droptype": "S",
    "dropname": "BARRIGADA",
    "dropdeladd": "489 ARMY DR",
    "dropdelcty": "BARRIGADA",
    "dropdelst": "GU",
    "dropdelzpp": 969139997,
    "dropphyadd": "489 ARMY DR",
    "dropphycty": "BARRIGADA",
    "dropphyst": "GU",
    "dropphyzpp": 969139997,
    "dropmaladd": "489 ARMY DR",
    "dropmalcty": "BARRIGADA",
    "dropmalst": "GU",
    "dropmalzpp": 969139997,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6717343921,
    "dropfax": 6717343925
  },
  {
    "dcode": "D",
    "dropkey": "EZ21071",
    "droptype": "S",
    "dropname": "EUREKA",
    "dropdeladd": "337 W CLARK ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "CA",
    "dropdelzpp": 955019994,
    "dropphyadd": "337 W CLARK ST",
    "dropphycty": "EUREKA",
    "dropphyst": "CA",
    "dropphyzpp": 955019994,
    "dropmaladd": "337 W CLARK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "CA",
    "dropmalzpp": 955019994,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074421768,
    "dropfax": 7074459076
  },
  {
    "dcode": "D",
    "dropkey": "EZ21789",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "2300 REDONDO AVE",
    "dropdelcty": "SIGNAL HILL",
    "dropdelst": "CA",
    "dropdelzpp": 907559876,
    "dropphyadd": "2300 REDONDO AVE",
    "dropphycty": "SIGNAL HILL",
    "dropphyst": "CA",
    "dropphyzpp": 907559876,
    "dropmaladd": "2300 REDONDO AVE",
    "dropmalcty": "SIGNAL HILL",
    "dropmalst": "CA",
    "dropmalzpp": 907559876,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624942300,
    "dropsitcph": 5624942300,
    "dropfax": 5624941245
  },
  {
    "dcode": "D",
    "dropkey": "E001203",
    "droptype": "D",
    "dropname": "NOME MP ANNEX",
    "dropdeladd": "516 PORT RD",
    "dropdelcty": "NOME",
    "dropdelst": "AK",
    "dropdelzpp": 997629801,
    "dropphyadd": "516 PORT RD",
    "dropphycty": "NOME",
    "dropphyst": "AK",
    "dropphyzpp": 997629801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOME",
    "dropmalst": "AK",
    "dropmalzpp": 997629998,
    "dropsitphn": 9074432129,
    "dropsitlph": 9074432129,
    "dropsitcph": 9074432129,
    "dropfax": 9074434167
  },
  {
    "dcode": "D",
    "dropkey": "E001535",
    "droptype": "D",
    "dropname": "MCCOMB ANNEX",
    "dropdeladd": "503 APACHE DR",
    "dropdelcty": "MCCOMB",
    "dropdelst": "MS",
    "dropdelzpp": 396489997,
    "dropphyadd": "503 APACHE DR",
    "dropphycty": "MCCOMB",
    "dropphyst": "MS",
    "dropphyzpp": 396489997,
    "dropmaladd": "503 APACHE DR",
    "dropmalcty": "MCCOMB",
    "dropmalst": "MS",
    "dropmalzpp": 396489997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016842909,
    "dropfax": 6016842949
  },
  {
    "dcode": "D",
    "dropkey": "E001567",
    "droptype": "D",
    "dropname": "IRVING PARK ROAD",
    "dropdeladd": "11560 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 607019998,
    "dropphyadd": "11560 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 607019998,
    "dropmaladd": "11560 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 607019997,
    "dropsitphn": 7738941102,
    "dropsitlph": 7738941102,
    "dropsitcph": 7738941102,
    "dropfax": 7738941105
  },
  {
    "dcode": "D",
    "dropkey": "E002539",
    "droptype": "D",
    "dropname": "ALBUQUERQUE ANNEX",
    "dropdeladd": "7601 BLUEWATER RD NW STE A",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871210004,
    "dropphyadd": "7601 BLUEWATER RD NW STE A",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871210004,
    "dropmaladd": "7601 BLUEWATER RD NW STE A",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871210004,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468252,
    "dropsitcph": 5058339554,
    "dropfax": 5053520222
  },
  {
    "dcode": "D",
    "dropkey": "E003203",
    "droptype": "D",
    "dropname": "JACKSONVILLE BMEU",
    "dropdeladd": "3650 SOUTHSIDE BLVD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322164657,
    "dropphyadd": "3650 SOUTHSIDE BLVD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322164657,
    "dropmaladd": "3650 SOUTHSIDE BLVD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322164657,
    "dropsitphn": 9043592957,
    "dropsitlph": "",
    "dropsitcph": 9046455695,
    "dropfax": 9045641294
  },
  {
    "dcode": "D",
    "dropkey": "E003442",
    "droptype": "D",
    "dropname": "NORFOLK TRANT ANNEX",
    "dropdeladd": "3440 TRANT AVE STE A",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235023164,
    "dropphyadd": "3440 TRANT AVE STE A",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235023164,
    "dropmaladd": "3440 TRANT AVE STE A",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235023164,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7574610143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E003571",
    "droptype": "D",
    "dropname": "WACO ANNEX",
    "dropdeladd": "7300 IMPERIAL DR",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767126603,
    "dropphyadd": "7300 IMPERIAL DR",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767126603,
    "dropmaladd": "7300 IMPERIAL DR",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767126603,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547416946,
    "dropsitcph": 2547410884,
    "dropfax": 2543996703
  },
  {
    "dcode": "D",
    "dropkey": "E004252",
    "droptype": "D",
    "dropname": "DENVER MAIL PROCESSING ANNEX",
    "dropdeladd": "20101 E 36TH DR",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800118153,
    "dropphyadd": "20101 E 36TH DR",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800118153,
    "dropmaladd": "20101 E 36TH DR",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800118153,
    "dropsitphn": 3032976511,
    "dropsitlph": 3032976510,
    "dropsitcph": 3038536930,
    "dropfax": 3032275261
  },
  {
    "dcode": "D",
    "dropkey": "E004254",
    "droptype": "D",
    "dropname": "HARRISBURG STC",
    "dropdeladd": "1425 CROOKED HILL RD",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171079971,
    "dropphyadd": "1425 CROOKED HILL RD",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171079971,
    "dropmaladd": "1425 CROOKED HILL RD",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171079971,
    "dropsitphn": 7172574870,
    "dropsitlph": "",
    "dropsitcph": 4124942636,
    "dropfax": 4124942542
  },
  {
    "dcode": "D",
    "dropkey": "E004528",
    "droptype": "D",
    "dropname": "NASHVILLE P&DC ANNEX",
    "dropdeladd": "230 ELLERY CT",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372293677,
    "dropphyadd": "230 ELLERY CT",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372293677,
    "dropmaladd": "230 ELLERY CT",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372293677,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158859251,
    "dropsitcph": 6158859251,
    "dropfax": 6159029142
  },
  {
    "dcode": "D",
    "dropkey": "E008308",
    "droptype": "D",
    "dropname": "SUBURBAN MARYLAND ANNEX",
    "dropdeladd": "15813 GAITHER DR",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208779997,
    "dropphyadd": "15813 GAITHER DR",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208779997,
    "dropmaladd": "15813 GAITHER DR",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208779997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012082115,
    "dropsitcph": 3012082115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E008443",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "2535 MIDWAY DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921109995,
    "dropphyadd": "2535 MIDWAY DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921109995,
    "dropmaladd": "2535 MIDWAY DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921109995,
    "dropsitphn": 8586740173,
    "dropsitlph": 8586740100,
    "dropsitcph": 6192269482,
    "dropfax": 6197587127
  },
  {
    "dcode": "D",
    "dropkey": "E008714",
    "droptype": "D",
    "dropname": "PITTSBURGH P&DC BUILDING 2",
    "dropdeladd": "900 PENNSYLVANIA AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152331409,
    "dropphyadd": "900 PENNSYLVANIA AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152331409,
    "dropmaladd": "900 PENNSYLVANIA AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152331409,
    "dropsitphn": "",
    "dropsitlph": 4123597859,
    "dropsitcph": 4123597859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E009495",
    "droptype": "D",
    "dropname": "SOUTHERN AREA STC",
    "dropdeladd": "2450 W AIRFIELD DR",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752614099,
    "dropphyadd": "2450 W AIRFIELD DR",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752614099,
    "dropmaladd": "PO BOX 610606",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752610606,
    "dropsitphn": 2149482879,
    "dropsitlph": "",
    "dropsitcph": 8173297676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E009538",
    "droptype": "D",
    "dropname": "WHEELER STREET ANNEX",
    "dropdeladd": "1201 S WHEELER ST",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486021249,
    "dropphyadd": "1201 S WHEELER ST",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486021249,
    "dropmaladd": "1201 S WHEELER ST",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486021249,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715769,
    "dropsitcph": 9897715769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E011114",
    "droptype": "D",
    "dropname": "ISC CHRISTMAS ANNEX",
    "dropdeladd": "513 EXPRESS CENTER DR",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606889900,
    "dropphyadd": "513 EXPRESS CENTER DR",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606889900,
    "dropmaladd": "513 EXPRESS CENTER DR",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606889900,
    "dropsitphn": 7738949200,
    "dropsitlph": 7738949200,
    "dropsitcph": 7738949200,
    "dropfax": 7738949015
  },
  {
    "dcode": "D",
    "dropkey": "E011546",
    "droptype": "D",
    "dropname": "NJ INTERNATIONAL OPERATIONS",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979998",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979996",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979998",
    "dropsitphn": 2017146214,
    "dropsitlph": 2017146214,
    "dropsitcph": 2017146214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E012382",
    "droptype": "D",
    "dropname": "JT WEEKER ISC ANNEX",
    "dropdeladd": "513 EXPRESS CENTER DR",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606889996,
    "dropphyadd": "513 EXPRESS CENTER DR",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606889996,
    "dropmaladd": "513 EXPRESS CENTER DR",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606889996,
    "dropsitphn": 7738949200,
    "dropsitlph": "",
    "dropsitcph": 7730000000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E012491",
    "droptype": "D",
    "dropname": "OMAHA MAIL CONSOL CTR",
    "dropdeladd": "13593 GILES RD",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681383488,
    "dropphyadd": "13593 GILES RD",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681383488,
    "dropmaladd": "13593 GILES RD",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681383488,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 4028964080,
    "dropfax": 4028964283
  },
  {
    "dcode": "D",
    "dropkey": "E012733",
    "droptype": "D",
    "dropname": "SAN ANTONIO EM ANNEX",
    "dropdeladd": "10250 JOHN SAUNDERS RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782469998,
    "dropphyadd": "10250 JOHN SAUNDERS RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782469997,
    "dropmaladd": "10250 JOHN SAUNDERS RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782469998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2108289045,
    "dropsitcph": 2108289045,
    "dropfax": 2108284447
  },
  {
    "dcode": "D",
    "dropkey": "E014143",
    "droptype": "D",
    "dropname": "LOS ANGELES CA FSS ANNEX",
    "dropdeladd": "902 E GAGE AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900019600,
    "dropphyadd": "902 E GAGE AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900019600,
    "dropmaladd": "902 E GAGE AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900019600,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3235652730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E014645",
    "droptype": "D",
    "dropname": "NORTHERN CA STC",
    "dropdeladd": "2501 RYDIN RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948505850,
    "dropphyadd": "2501 RYDIN RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948505850,
    "dropmaladd": "2501 RYDIN RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948505850,
    "dropsitphn": 5105289780,
    "dropsitlph": 5105289780,
    "dropsitcph": 5105289632,
    "dropfax": 5105289770
  },
  {
    "dcode": "D",
    "dropkey": "E014729",
    "droptype": "D",
    "dropname": "SPRINGFIELD LDC ANNEX",
    "dropdeladd": "100 BROOKDALE DR STE DK1",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011043273",
    "dropphyadd": "100 BROOKDALE DR STE DK1",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011043273",
    "dropmaladd": "100 BROOKDALE DR STE DK1",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011043273",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4134522170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E014959",
    "droptype": "D",
    "dropname": "DUBUQUE BMEU",
    "dropdeladd": "750 WHITE ST STE 1",
    "dropdelcty": "DUBUQUE",
    "dropdelst": "IA",
    "dropdelzpp": 520019997,
    "dropphyadd": "750 WHITE ST STE 1",
    "dropphycty": "DUBUQUE",
    "dropphyst": "IA",
    "dropphyzpp": 520019997,
    "dropmaladd": "750 WHITE ST STE 1",
    "dropmalcty": "DUBUQUE",
    "dropmalst": "IA",
    "dropmalzpp": 520019997,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635824365,
    "dropsitcph": 5635823674,
    "dropfax": 5635822528
  },
  {
    "dcode": "D",
    "dropkey": "E015074",
    "droptype": "D",
    "dropname": "MID FLORIDA BMEU",
    "dropdeladd": "800 RINEHART RD",
    "dropdelcty": "MID FLORIDA",
    "dropdelst": "FL",
    "dropdelzpp": 327998804,
    "dropphyadd": "800 RINEHART RD",
    "dropphycty": "MID FLORIDA",
    "dropphyst": "FL",
    "dropphyzpp": 327998804,
    "dropmaladd": "800 RINEHART RD",
    "dropmalcty": "MID FLORIDA",
    "dropmalst": "FL",
    "dropmalzpp": 327998804,
    "dropsitphn": 4073338496,
    "dropsitlph": 4073338496,
    "dropsitcph": 4073338400,
    "dropfax": 4073338475
  },
  {
    "dcode": "D",
    "dropkey": "E015163",
    "droptype": "D",
    "dropname": "TAMPA BMEU",
    "dropdeladd": "5433 W SLIGH AVE STE B",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336349653,
    "dropphyadd": "5433 W SLIGH AVE STE B",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336349653,
    "dropmaladd": "5433 W SLIGH AVE STE B",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336349653,
    "dropsitphn": 8138770729,
    "dropsitlph": 8138770637,
    "dropsitcph": 8132435960,
    "dropfax": 8132437452
  },
  {
    "dcode": "D",
    "dropkey": "E015334",
    "droptype": "D",
    "dropname": "MONMOUTH BMEU",
    "dropdeladd": "307 INDUSTRIAL WAY W",
    "dropdelcty": "EATONTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "077999998",
    "dropphyadd": "307 INDUSTRIAL WAY W",
    "dropphycty": "EATONTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "077999998",
    "dropmaladd": "307 INDUSTRIAL WAY W",
    "dropmalcty": "EATONTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "077999998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323897000,
    "dropfax": 7323898047
  },
  {
    "dcode": "D",
    "dropkey": "E015625",
    "droptype": "D",
    "dropname": "ROCHESTER BMEU",
    "dropdeladd": "3939 VALLEYHIGH RD NW",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559015687,
    "dropphyadd": "3939 VALLEYHIGH RD NW",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559015687,
    "dropmaladd": "3939 VALLEYHIGH RD NW",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559015687,
    "dropsitphn": 6123496399,
    "dropsitlph": 5072823068,
    "dropsitcph": 5072823068,
    "dropfax": 5072823068
  },
  {
    "dcode": "D",
    "dropkey": "E015736",
    "droptype": "D",
    "dropname": "CAPE GIRARDEAU BMEU",
    "dropdeladd": "475 KELL FARM DR",
    "dropdelcty": "CAPE GIRARDEAU",
    "dropdelst": "MO",
    "dropdelzpp": 637019806,
    "dropphyadd": "475 KELL FARM DR",
    "dropphycty": "CAPE GIRARDEAU",
    "dropphyst": "MO",
    "dropphyzpp": 637019806,
    "dropmaladd": "475 KELL FARM DR",
    "dropmalcty": "CAPE GIRARDEAU",
    "dropmalst": "MO",
    "dropmalzpp": 637019806,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 5733310800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E015878",
    "droptype": "D",
    "dropname": "JONESBORO BMEU",
    "dropdeladd": "3405 MOORE RD",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019741,
    "dropphyadd": "3405 MOORE RD",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019741,
    "dropmaladd": "3405 MOORE RD",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019741,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709315763,
    "dropsitcph": 8709315763,
    "dropfax": 8709316932
  },
  {
    "dcode": "D",
    "dropkey": "E015890",
    "droptype": "D",
    "dropname": "LAKELAND BMEU",
    "dropdeladd": "2800 LAKELAND HILLS BLVD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338059300,
    "dropphyadd": "2800 LAKELAND HILLS BLVD",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338059300,
    "dropmaladd": "2800 LAKELAND HILLS BLVD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338059300,
    "dropsitphn": 8138770729,
    "dropsitlph": 8638022005,
    "dropsitcph": 8638022005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E016669",
    "droptype": "D",
    "dropname": "MEMPHIS STC",
    "dropdeladd": "363 BURMA RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381068757,
    "dropphyadd": "363 BURMA RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381068757,
    "dropmaladd": "363 BURMA RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381068757,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013706168,
    "dropsitcph": 9013706169,
    "dropfax": 9013706860
  },
  {
    "dcode": "D",
    "dropkey": "E017167",
    "droptype": "D",
    "dropname": "CHRISTMAS ANNEX",
    "dropdeladd": "1413 OSAGE AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661051607,
    "dropphyadd": "1413 OSAGE AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661051607,
    "dropmaladd": "1413 OSAGE AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661051607,
    "dropsitphn": 8165043362,
    "dropsitlph": 9135732604,
    "dropsitcph": 9135732604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E017342",
    "droptype": "D",
    "dropname": "FARGO ANNEX",
    "dropdeladd": "1500 23RD ST S",
    "dropdelcty": "MOORHEAD",
    "dropdelst": "MN",
    "dropdelzpp": 565603844,
    "dropphyadd": "1500 23RD ST S",
    "dropphycty": "MOORHEAD",
    "dropphyst": "MN",
    "dropphyzpp": 565603844,
    "dropmaladd": "1500 23RD ST S",
    "dropmalcty": "MOORHEAD",
    "dropmalst": "MN",
    "dropmalzpp": 565603844,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7016596115,
    "dropfax": 7012216211
  },
  {
    "dcode": "D",
    "dropkey": "E017828",
    "droptype": "D",
    "dropname": "INDIANAPOLIS MP ANNEX 2",
    "dropdeladd": "7452 TEMPELHOF DR STE B",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462417526,
    "dropphyadd": "7452 TEMPELHOF DR STE B",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462417526,
    "dropmaladd": "7452 TEMPELHOF DR STE B",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462417526,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178742233,
    "dropfax": 3174646993
  },
  {
    "dcode": "D",
    "dropkey": "E017837",
    "droptype": "D",
    "dropname": "TRI COUNTY BMEU",
    "dropdeladd": "1000 W VALLEY RD",
    "dropdelcty": "SOUTHEASTERN",
    "dropdelst": "PA",
    "dropdelzpp": 193999004,
    "dropphyadd": "1000 W VALLEY RD",
    "dropphycty": "SOUTHEASTERN",
    "dropphyst": "PA",
    "dropphyzpp": 193999004,
    "dropmaladd": "1000 W VALLEY RD",
    "dropmalcty": "SOUTHEASTERN",
    "dropmalst": "PA",
    "dropmalzpp": 193999004,
    "dropsitphn": 6109646414,
    "dropsitlph": "",
    "dropsitcph": 6109646476,
    "dropfax": 6109645467
  },
  {
    "dcode": "D",
    "dropkey": "E017901",
    "droptype": "D",
    "dropname": "NEW ENGLAND CROSS DOCK ANNEX",
    "dropdeladd": "111 ADAMS ST STE 3",
    "dropdelcty": "CLINTON",
    "dropdelst": "MA",
    "dropdelzpp": "015101550",
    "dropphyadd": "111 ADAMS ST STE 3",
    "dropphycty": "CLINTON",
    "dropphyst": "MA",
    "dropphyzpp": "015101550",
    "dropmaladd": "111 ADAMS ST STE 3",
    "dropmalcty": "CLINTON",
    "dropmalst": "MA",
    "dropmalzpp": "015101550",
    "dropsitphn": 9786647013,
    "dropsitlph": 9876647013,
    "dropsitcph": 9783653241,
    "dropfax": 9783653259
  },
  {
    "dcode": "D",
    "dropkey": "E017994",
    "droptype": "D",
    "dropname": "MCALESTER ANNEX",
    "dropdeladd": "123 EXPRESS LN",
    "dropdelcty": "MCALESTER",
    "dropdelst": "OK",
    "dropdelzpp": 745019997,
    "dropphyadd": "123 EXPRESS LN",
    "dropphycty": "MCALESTER",
    "dropphyst": "OK",
    "dropphyzpp": 745019997,
    "dropmaladd": "123 EXPRESS LN",
    "dropmalcty": "MCALESTER",
    "dropmalst": "OK",
    "dropmalzpp": 745019997,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184234048,
    "dropsitcph": 9184265492,
    "dropfax": 9184238640
  },
  {
    "dcode": "D",
    "dropkey": "E018271",
    "droptype": "D",
    "dropname": "CAPITAL METRO STC",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207999800,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207999800,
    "dropmaladd": "9201 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207999800,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014997331,
    "dropsitcph": 3014997663,
    "dropfax": 3014997651
  },
  {
    "dcode": "D",
    "dropkey": "E018278",
    "droptype": "D",
    "dropname": "NORFOLK CHRISTMAS ANNEX",
    "dropdeladd": "3760 E VIRGINIA BEACH BLVD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235023218,
    "dropphyadd": "3760 E VIRGINIA BEACH BLVD",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235023218,
    "dropmaladd": "3760 E VIRGINIA BEACH BLVD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235023218,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7578531240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E018631",
    "droptype": "D",
    "dropname": "VALDOSTA",
    "dropdeladd": "3698 INNER PERIMETER RD",
    "dropdelcty": "VALDOSTA",
    "dropdelst": "GA",
    "dropdelzpp": 316029997,
    "dropphyadd": "3698 INNER PERIMETER RD",
    "dropphycty": "VALDOSTA",
    "dropphyst": "GA",
    "dropphyzpp": 316029997,
    "dropmaladd": "3698 INNER PERIMETER RD",
    "dropmalcty": "VALDOSTA",
    "dropmalst": "GA",
    "dropmalzpp": 316029997,
    "dropsitphn": 4787528466,
    "dropsitlph": "",
    "dropsitcph": 2292417209,
    "dropfax": 2292418702
  },
  {
    "dcode": "D",
    "dropkey": "E018926",
    "droptype": "D",
    "dropname": "SOUTHERN AREA STC NEW",
    "dropdeladd": "4931 CONFLANS RD",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750590001,
    "dropphyadd": "4931 CONFLANS RD",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750590001,
    "dropmaladd": "4931 CONFLANS RD",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750590001,
    "dropsitphn": 2144675879,
    "dropsitlph": "",
    "dropsitcph": 4692849352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E018927",
    "droptype": "D",
    "dropname": "INDIANAPOLIS STC",
    "dropdeladd": "701 COLUMBIA RD STE 151",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 461689791,
    "dropphyadd": "701 COLUMBIA RD STE 151",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 461689791,
    "dropmaladd": "701 COLUMBIA RD STE 151",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 461689791,
    "dropsitphn": 3174646350,
    "dropsitlph": "",
    "dropsitcph": 3174874003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019046",
    "droptype": "D",
    "dropname": "HOUSTON PEAK ANNEX",
    "dropdeladd": "14700 NORTH FWY",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770906504,
    "dropphyadd": "14700 NORTH FWY",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770906504,
    "dropmaladd": "14700 NORTH FWY",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770906504,
    "dropsitphn": 7132263055,
    "dropsitlph": "",
    "dropsitcph": 2814430856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019049",
    "droptype": "D",
    "dropname": "MADISON PEAK ANNEX",
    "dropdeladd": "213 INDUSTRIAL DR N",
    "dropdelcty": "GLUCKSTADT",
    "dropdelst": "MS",
    "dropdelzpp": 391109909,
    "dropphyadd": "213 INDUSTRIAL DR N",
    "dropphycty": "GLUCKSTADT",
    "dropphyst": "MS",
    "dropphyzpp": 391109909,
    "dropmaladd": "213 INDUSTRIAL DR N",
    "dropmalcty": "GLUCKSTADT",
    "dropmalst": "MS",
    "dropmalzpp": 391109909,
    "dropsitphn": 6013517144,
    "dropsitlph": "",
    "dropsitcph": 6017906384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019063",
    "droptype": "D",
    "dropname": "SAN ANTONIO PEAK ANNEX",
    "dropdeladd": "5701 BUSINESS PARK",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782185530,
    "dropphyadd": "5701 BUSINESS PARK",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782185530,
    "dropmaladd": "5701 BUSINESS PARK",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782185530,
    "dropsitphn": 2103688387,
    "dropsitlph": "",
    "dropsitcph": 2103688498,
    "dropfax": 2103681698
  },
  {
    "dcode": "D",
    "dropkey": "E019065",
    "droptype": "D",
    "dropname": "LA ISC CHRISTMAS ANNEX",
    "dropdeladd": "24760 MAIN ST",
    "dropdelcty": "CARSON",
    "dropdelst": "CA",
    "dropdelzpp": 907456329,
    "dropphyadd": "24760 MAIN ST",
    "dropphycty": "CARSON",
    "dropphyst": "CA",
    "dropphyzpp": 907456329,
    "dropmaladd": "24760 MAIN ST",
    "dropmalcty": "CARSON",
    "dropmalst": "CA",
    "dropmalzpp": 907456329,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3103378720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019068",
    "droptype": "D",
    "dropname": "NEW JERSEY CROSSDOCK",
    "dropdeladd": "145 TALMADGE RD STE 1",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088179800",
    "dropphyadd": "145 TALMADGE RD STE 1",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088179800",
    "dropmaladd": "145 TALMADGE RD STE 1",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088179800",
    "dropsitphn": 7328193630,
    "dropsitlph": "",
    "dropsitcph": 7328193833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019177",
    "droptype": "D",
    "dropname": "SOUTHERN CA STC OLD",
    "dropdeladd": "24760 MAIN ST STE 100",
    "dropdelcty": "CARSON",
    "dropdelst": "CA",
    "dropdelzpp": 907456331,
    "dropphyadd": "24760 MAIN ST STE 100",
    "dropphycty": "CARSON",
    "dropphyst": "CA",
    "dropphyzpp": 907456331,
    "dropmaladd": "24760 MAIN ST STE 100",
    "dropmalcty": "CARSON",
    "dropmalst": "CA",
    "dropmalzpp": 907456331,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3102931864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019194",
    "droptype": "D",
    "dropname": "SAN JUAN PR MPA",
    "dropdeladd": "225 AVE JOSE A TONY SANTANA STE 130A",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009799996",
    "dropphyadd": "225 AVE JOSE A TONY SANTANA STE 130A",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009799996",
    "dropmaladd": "225 AVE JOSE A TONY SANTANA STE 130A",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009799996",
    "dropsitphn": 7876221795,
    "dropsitlph": "",
    "dropsitcph": 7876221920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019274",
    "droptype": "D",
    "dropname": "CENTRAL FLORIDA STC",
    "dropdeladd": "11010 FLORIDA CROWN DR",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328247028,
    "dropphyadd": "11010 FLORIDA CROWN DR",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328247028,
    "dropmaladd": "11010 FLORIDA CROWN DR",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328247028,
    "dropsitphn": 4078265608,
    "dropsitlph": "",
    "dropsitcph": 4078121135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019292",
    "droptype": "D",
    "dropname": "NEW ENGLAND CROSSDOCK ANNEX",
    "dropdeladd": "40 WISCONSIN AVE",
    "dropdelcty": "NORWICH",
    "dropdelst": "CT",
    "dropdelzpp": "063609995",
    "dropphyadd": "40 WISCONSIN AVE",
    "dropphycty": "NORWICH",
    "dropphyst": "CT",
    "dropphyzpp": "063609995",
    "dropmaladd": "40 WISCONSIN AVE",
    "dropmalcty": "NORWICH",
    "dropmalst": "CT",
    "dropmalzpp": "063609995",
    "dropsitphn": 8608873559,
    "dropsitlph": 8603033249,
    "dropsitcph": 8603033241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019677",
    "droptype": "D",
    "dropname": "ATLANTA STC",
    "dropdeladd": "1800 JAMES JACKSON PKWY NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303691103,
    "dropphyadd": "1800 JAMES JACKSON PKWY NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303691103,
    "dropmaladd": "1800 JAMES JACKSON PKWY NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303691103,
    "dropsitphn": 4047923125,
    "dropsitlph": 4047923008,
    "dropsitcph": 4047923270,
    "dropfax": 4047923293
  },
  {
    "dcode": "D",
    "dropkey": "E019678",
    "droptype": "D",
    "dropname": "SPRINGFIELD STC",
    "dropdeladd": "190 FIBERLOID ST STE 1",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011529711",
    "dropphyadd": "190 FIBERLOID ST STE 1",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011529711",
    "dropmaladd": "190 FIBERLOID ST STE 1",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011529711",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4137856246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019748",
    "droptype": "D",
    "dropname": "CENTRAL MA PSA",
    "dropdeladd": "111 CONSTITUTION BLVD",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MA",
    "dropdelzpp": "020389997",
    "dropphyadd": "111 CONSTITUTION BLVD",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MA",
    "dropphyzpp": "020389997",
    "dropmaladd": "111 CONSTITUTION BLVD",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MA",
    "dropmalzpp": "020389997",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087935915,
    "dropsitcph": 5087935104,
    "dropfax": 5087935995
  },
  {
    "dcode": "D",
    "dropkey": "E019758",
    "droptype": "D",
    "dropname": "BUSSE IL PSA",
    "dropdeladd": "2600 LIVELY BLVD",
    "dropdelcty": "ELK GROVE VILLAGE",
    "dropdelst": "IL",
    "dropdelzpp": 600076703,
    "dropphyadd": "2600 LIVELY BLVD",
    "dropphycty": "ELK GROVE VILLAGE",
    "dropphyst": "IL",
    "dropphyzpp": 600076703,
    "dropmaladd": "2600 LIVELY BLVD",
    "dropmalcty": "ELK GROVE VILLAGE",
    "dropmalst": "IL",
    "dropmalzpp": 600076703,
    "dropsitphn": 7085834294,
    "dropsitlph": 7084883220,
    "dropsitcph": 7085834521,
    "dropfax": 7085834550
  },
  {
    "dcode": "D",
    "dropkey": "E019779",
    "droptype": "D",
    "dropname": "NORTH HOUSTON TX PSA",
    "dropdeladd": "15600 MORALES RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770322102,
    "dropphyadd": "15600 MORALES RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770322102,
    "dropmaladd": "15600 MORALES RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770322102,
    "dropsitphn": 7132263913,
    "dropsitlph": 7132263475,
    "dropsitcph": 7132264202,
    "dropfax": 7132263095
  },
  {
    "dcode": "D",
    "dropkey": "E020037",
    "droptype": "D",
    "dropname": "RALEIGH NC MPA",
    "dropdeladd": "5511 W TEN RD",
    "dropdelcty": "MEBANE",
    "dropdelst": "NC",
    "dropdelzpp": 273028769,
    "dropphyadd": "5511 W TEN RD",
    "dropphycty": "MEBANE",
    "dropphyst": "NC",
    "dropphyzpp": 273028769,
    "dropmaladd": "5511 W TEN RD",
    "dropmalcty": "MEBANE",
    "dropmalst": "NC",
    "dropmalzpp": 273028769,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205106,
    "dropfax": 9194205357
  },
  {
    "dcode": "D",
    "dropkey": "E020061",
    "droptype": "D",
    "dropname": "SOUTHERN CA STC",
    "dropdeladd": "2400 E ARTESIA BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908059801,
    "dropphyadd": "2400 E ARTESIA BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908059801,
    "dropmaladd": "2400 E ARTESIA BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908059801,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3102931864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020837",
    "droptype": "D",
    "dropname": "POMPANO BEACH FL LPC",
    "dropdeladd": "3250 NW 33RD ST",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330699810,
    "dropphyadd": "3250 NW 33RD ST",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330699810,
    "dropmaladd": "3250 NW 33RD ST",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330699810,
    "dropsitphn": 3055132368,
    "dropsitlph": "",
    "dropsitcph": 9549355122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E021214",
    "droptype": "D",
    "dropname": "LUBBOCK TX MPA",
    "dropdeladd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794039905,
    "dropphyadd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794039905,
    "dropmaladd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794039905,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067627841,
    "dropsitcph": 8066277841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E021270",
    "droptype": "D",
    "dropname": "JOHNSON CITY TN LPC",
    "dropdeladd": "128 ROWELAND DR",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376013822,
    "dropphyadd": "128 ROWELAND DR",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376013822,
    "dropmaladd": "128 ROWELAND DR",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376013822,
    "dropsitphn": 6158859336,
    "dropsitlph": "",
    "dropsitcph": 4232325840,
    "dropfax": 4232325860
  },
  {
    "dcode": "D",
    "dropkey": "FV21485",
    "droptype": "D",
    "dropname": "BEVERLY DDC",
    "dropdeladd": "16 TOZER RD",
    "dropdelcty": "BEVERLY",
    "dropdelst": "MA",
    "dropdelzpp": "019159997",
    "dropphyadd": "16 TOZER RD",
    "dropphycty": "BEVERLY",
    "dropphyst": "MA",
    "dropphyzpp": "019159997",
    "dropmaladd": "16 TOZER RD",
    "dropmalcty": "BEVERLY",
    "dropmalst": "MA",
    "dropmalzpp": "019159997",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789224533,
    "dropfax": 9789227389
  },
  {
    "dcode": "D",
    "dropkey": "FV27323",
    "droptype": "D",
    "dropname": "BILLERICA DDC",
    "dropdeladd": "5 BRICK KILN RD",
    "dropdelcty": "BILLERICA",
    "dropdelst": "MA",
    "dropdelzpp": "018219991",
    "dropphyadd": "5 BRICK KILN RD",
    "dropphycty": "BILLERICA",
    "dropphyst": "MA",
    "dropphyzpp": "018219991",
    "dropmaladd": "5 BRICK KILN RD",
    "dropmalcty": "BILLERICA",
    "dropmalst": "MA",
    "dropmalzpp": "018219991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786635455,
    "dropfax": 9786638548
  },
  {
    "dcode": "D",
    "dropkey": "F006134",
    "droptype": "D",
    "dropname": "HOUSTON N ANNEX",
    "dropdeladd": "4665 KENDRICK PLAZA DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770322416,
    "dropphyadd": "4665 KENDRICK PLAZA DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770322416,
    "dropmaladd": "4600 ALDINE BENDER RD",
    "dropmalcty": "NORTH HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 773159900,
    "dropsitphn": 7132263555,
    "dropsitlph": 7132263355,
    "dropsitcph": 7132263355,
    "dropfax": 2812273273
  },
  {
    "dcode": "D",
    "dropkey": "F014496",
    "droptype": "D",
    "dropname": "EAST RUTHERFORD DDC",
    "dropdeladd": "263 HACKENSACK ST",
    "dropdelcty": "EAST RUTHERFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "070739997",
    "dropphyadd": "263 HACKENSACK ST",
    "dropphycty": "EAST RUTHERFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "070739997",
    "dropmaladd": "263 HACKENSACK ST",
    "dropmalcty": "EAST RUTHERFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "070739997",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019350033,
    "dropsitcph": 2019350033,
    "dropfax": 6505774212
  },
  {
    "dcode": "D",
    "dropkey": "F015372",
    "droptype": "D",
    "dropname": "NORTH BAY DDC",
    "dropdeladd": "1150 N MCDOWELL BLVD",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949999712,
    "dropphyadd": "1150 N MCDOWELL BLVD",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949999712,
    "dropmaladd": "1150 N MCDOWELL BLVD",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949999712,
    "dropsitphn": 7077785461,
    "dropsitlph": "",
    "dropsitcph": 7077890778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "F020857",
    "droptype": "D",
    "dropname": "MCALESTER DDC",
    "dropdeladd": "123 EXPRESS LN",
    "dropdelcty": "MCALESTER",
    "dropdelst": "OK",
    "dropdelzpp": 745019996,
    "dropphyadd": "123 EXPRESS LN",
    "dropphycty": "MCALESTER",
    "dropphyst": "OK",
    "dropphyzpp": 745019996,
    "dropmaladd": "123 EXPRESS LN",
    "dropmalcty": "MCALESTER",
    "dropmalst": "OK",
    "dropmalzpp": 745019996,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184234048,
    "dropsitcph": 9184265492,
    "dropfax": 9184238640
  },
  {
    "dcode": "D",
    "dropkey": "G016933",
    "droptype": "D",
    "dropname": "TRI COUNTY",
    "dropdeladd": "1000 W VALLEY RD",
    "dropdelcty": "SOUTHEASTERN",
    "dropdelst": "PA",
    "dropdelzpp": 193999992,
    "dropphyadd": "1000 W VALLEY RD",
    "dropphycty": "SOUTHEASTERN",
    "dropphyst": "PA",
    "dropphyzpp": 193999992,
    "dropmaladd": "1000 W VALLEY RD",
    "dropmalcty": "SOUTHEASTERN",
    "dropmalst": "PA",
    "dropmalzpp": 193999992,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109646401,
    "dropsitcph": 6109646401,
    "dropfax": 6109646458
  },
  {
    "dcode": "D",
    "dropkey": "G016934",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "5225 HARRISON AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611259997,
    "dropphyadd": "5225 HARRISON AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611259997,
    "dropmaladd": "5225 HARRISON AVE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611259997,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152294806,
    "dropsitcph": 8152294806,
    "dropfax": 8152294857
  },
  {
    "dcode": "D",
    "dropkey": "G017189",
    "droptype": "D",
    "dropname": "WATERBURY",
    "dropdeladd": "135 GRAND ST",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067019901",
    "dropphyadd": "135 GRAND ST",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067019901",
    "dropmaladd": "135 GRAND ST",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067019901",
    "dropsitphn": 2035746521,
    "dropsitlph": 2035746521,
    "dropsitcph": 2035746521,
    "dropfax": 2035746588
  },
  {
    "dcode": "D",
    "dropkey": "G017192",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "4600 SW 34TH ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326089990,
    "dropphyadd": "4600 SW 34TH ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326089990,
    "dropmaladd": "4600 SW 34TH ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326089990,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341870,
    "dropsitcph": 3523341899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017351",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "3408 WALL TRIANA HWY",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358131001,
    "dropphyadd": "3408 WALL TRIANA HWY",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358131001,
    "dropmaladd": "3408 WALL TRIANA HWY",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358131001,
    "dropsitphn": 2567724691,
    "dropsitlph": "",
    "dropsitcph": 2567724691,
    "dropfax": 2564617885
  },
  {
    "dcode": "D",
    "dropkey": "G017354",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "2800 LAKELAND HILLS BLVD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338058800,
    "dropphyadd": "2800 LAKELAND HILLS BLVD",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338058800,
    "dropmaladd": "2800 LAKELAND HILLS BLVD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338058800,
    "dropsitphn": 8138770729,
    "dropsitlph": 8638022053,
    "dropsitcph": 8638022066,
    "dropfax": 8638022080
  },
  {
    "dcode": "D",
    "dropkey": "G017355",
    "droptype": "D",
    "dropname": "TERRE HAUTE",
    "dropdeladd": "150 W MARGARET DR",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478029997,
    "dropphyadd": "150 W MARGARET DR",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478029997,
    "dropmaladd": "150 W MARGARET DR",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122314020,
    "dropfax": 8122314140
  },
  {
    "dcode": "D",
    "dropkey": "G017358",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "211 E ASH ST",
    "dropdelcty": "SALINA",
    "dropdelst": "KS",
    "dropdelzpp": 674019942,
    "dropphyadd": "211 E ASH ST",
    "dropphycty": "SALINA",
    "dropphyst": "KS",
    "dropphyzpp": 674019942,
    "dropmaladd": "211 E ASH ST",
    "dropmalcty": "SALINA",
    "dropmalst": "KS",
    "dropmalzpp": 674019942,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 7858273695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017359",
    "droptype": "D",
    "dropname": "TOPEKA",
    "dropdeladd": "1410 NW GAGE BLVD RM 111",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666182835,
    "dropphyadd": "1410 NW GAGE BLVD RM 111",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666182835,
    "dropmaladd": "1410 NW GAGE BLVD RM 111",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666182835,
    "dropsitphn": 7852313512,
    "dropsitlph": "",
    "dropsitcph": 7852313535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017361",
    "droptype": "D",
    "dropname": "KALAMAZOO",
    "dropdeladd": "3885 S 9TH ST",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490099554,
    "dropphyadd": "3885 S 9TH ST",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490099554,
    "dropmaladd": "3885 S 9TH ST",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490099554,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2693535000,
    "dropfax": 2693535004
  },
  {
    "dcode": "D",
    "dropkey": "G017362",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "1233 S WASHINGTON AVE",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486012503,
    "dropphyadd": "1233 S WASHINGTON AVE",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486012503,
    "dropmaladd": "1233 S WASHINGTON AVE",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486012503,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715727,
    "dropsitcph": 9897715725,
    "dropfax": 9897715704
  },
  {
    "dcode": "D",
    "dropkey": "G017363",
    "droptype": "D",
    "dropname": "DULUTH",
    "dropdeladd": "2800 W MICHIGAN ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558069998,
    "dropphyadd": "2800 W MICHIGAN ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558069998,
    "dropmaladd": "2800 W MICHIGAN ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558069998,
    "dropsitphn": 2187232565,
    "dropsitlph": 2187232575,
    "dropsitcph": 2187232565,
    "dropfax": 2187232557
  },
  {
    "dcode": "D",
    "dropkey": "G017365",
    "droptype": "D",
    "dropname": "SAINT CLOUD",
    "dropdeladd": "517 10TH AVE S",
    "dropdelcty": "WAITE PARK",
    "dropdelst": "MN",
    "dropdelzpp": 563871519,
    "dropphyadd": "517 10TH AVE S",
    "dropphycty": "WAITE PARK",
    "dropphyst": "MN",
    "dropphyzpp": 563871519,
    "dropmaladd": "517 10TH AVE S",
    "dropmalcty": "WAITE PARK",
    "dropmalst": "MN",
    "dropmalzpp": 563871519,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202513876,
    "dropfax": 3202513984
  },
  {
    "dcode": "D",
    "dropkey": "G017366",
    "droptype": "D",
    "dropname": "GRENADA",
    "dropdeladd": "2500 GATEWAY ST",
    "dropdelcty": "GRENADA",
    "dropdelst": "MS",
    "dropdelzpp": 389019998,
    "dropphyadd": "2500 GATEWAY ST",
    "dropphycty": "GRENADA",
    "dropphyst": "MS",
    "dropphyzpp": 389019998,
    "dropmaladd": "2500 GATEWAY ST",
    "dropmalcty": "GRENADA",
    "dropmalst": "MS",
    "dropmalzpp": 389019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622265521,
    "dropsitcph": 6622265515,
    "dropfax": 6622264342
  },
  {
    "dcode": "D",
    "dropkey": "G017367",
    "droptype": "D",
    "dropname": "BUTTE",
    "dropdeladd": "701 DEWEY BLVD",
    "dropdelcty": "BUTTE",
    "dropdelst": "MT",
    "dropdelzpp": 597019997,
    "dropphyadd": "701 DEWEY BLVD",
    "dropphycty": "BUTTE",
    "dropphyst": "MT",
    "dropphyzpp": 597019997,
    "dropmaladd": "701 DEWEY BLVD",
    "dropmalcty": "BUTTE",
    "dropmalst": "MT",
    "dropmalzpp": 597019997,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4064942107,
    "dropfax": 4064942718
  },
  {
    "dcode": "D",
    "dropkey": "G017369",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "2300 N HARRIS ST",
    "dropdelcty": "HELENA",
    "dropdelst": "MT",
    "dropdelzpp": 596019997,
    "dropphyadd": "2300 N HARRIS ST",
    "dropphycty": "HELENA",
    "dropphyst": "MT",
    "dropphyzpp": 596019997,
    "dropmaladd": "2300 N HARRIS ST",
    "dropmalcty": "HELENA",
    "dropmalst": "MT",
    "dropmalzpp": 596019997,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4064433304,
    "dropfax": 4064427946
  },
  {
    "dcode": "D",
    "dropkey": "G017370",
    "droptype": "D",
    "dropname": "KALISPELL",
    "dropdeladd": "350 N MERIDIAN RD",
    "dropdelcty": "KALISPELL",
    "dropdelst": "MT",
    "dropdelzpp": 599019997,
    "dropphyadd": "350 N MERIDIAN RD",
    "dropphycty": "KALISPELL",
    "dropphyst": "MT",
    "dropphyzpp": 599019997,
    "dropmaladd": "350 N MERIDIAN RD",
    "dropmalcty": "KALISPELL",
    "dropmalst": "MT",
    "dropmalzpp": 599019997,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4067556450,
    "dropfax": 4067560045
  },
  {
    "dcode": "D",
    "dropkey": "G017372",
    "droptype": "D",
    "dropname": "WOLF POINT",
    "dropdeladd": "131 FRONT ST",
    "dropdelcty": "WOLF POINT",
    "dropdelst": "MT",
    "dropdelzpp": 592019997,
    "dropphyadd": "131 FRONT ST",
    "dropphycty": "WOLF POINT",
    "dropphyst": "MT",
    "dropphyzpp": 592019997,
    "dropmaladd": "131 FRONT ST",
    "dropmalcty": "WOLF POINT",
    "dropmalst": "MT",
    "dropmalzpp": 592019997,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4066532802,
    "dropfax": 4066533650
  },
  {
    "dcode": "D",
    "dropkey": "G017373",
    "droptype": "D",
    "dropname": "ASHEVILLE",
    "dropdeladd": "591 BREVARD RD",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288109880,
    "dropphyadd": "591 BREVARD RD",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288109880,
    "dropmaladd": "591 BREVARD RD",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288109880,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 8282574126,
    "dropfax": 8282574178
  },
  {
    "dcode": "D",
    "dropkey": "G017374",
    "droptype": "D",
    "dropname": "MINOT",
    "dropdeladd": "117 5TH AVE SW",
    "dropdelcty": "MINOT",
    "dropdelst": "ND",
    "dropdelzpp": 587019997,
    "dropphyadd": "117 5TH AVE SW",
    "dropphycty": "MINOT",
    "dropphyst": "ND",
    "dropphyzpp": 587019997,
    "dropmaladd": "117 5TH AVE SW",
    "dropmalcty": "MINOT",
    "dropmalst": "ND",
    "dropmalzpp": 587019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7018576155,
    "dropfax": 7018576117
  },
  {
    "dcode": "D",
    "dropkey": "G017375",
    "droptype": "D",
    "dropname": "GRAND ISLAND",
    "dropdeladd": "3835 W OLD POTASH HWY",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "NE",
    "dropdelzpp": 688039977,
    "dropphyadd": "3835 W OLD POTASH HWY",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "NE",
    "dropphyzpp": 688039977,
    "dropmaladd": "3835 W OLD POTASH HWY",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "NE",
    "dropmalzpp": 688039977,
    "dropsitphn": 3083856526,
    "dropsitlph": "",
    "dropsitcph": 3083856526,
    "dropfax": 3083856020
  },
  {
    "dcode": "D",
    "dropkey": "G017376",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "700 R ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685019821,
    "dropphyadd": "700 R ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685019821,
    "dropmaladd": "700 R ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685019821,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 4024731602,
    "dropfax": 4024731738
  },
  {
    "dcode": "D",
    "dropkey": "G017377",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "2650 CLEVELAND AVE NW",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447119997,
    "dropphyadd": "2650 CLEVELAND AVE NW",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447119997,
    "dropmaladd": "2650 CLEVELAND AVE NW",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447119997,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304386451,
    "dropfax": 3304386407
  },
  {
    "dcode": "D",
    "dropkey": "G017378",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "435 S SAINT CLAIR ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436019997,
    "dropphyadd": "435 S SAINT CLAIR ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436019997,
    "dropmaladd": "435 S SAINT CLAIR ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436019997,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 4192456917,
    "dropfax": 4192456846
  },
  {
    "dcode": "D",
    "dropkey": "G017379",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "99 S WALNUT ST RM 289",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445019993,
    "dropphyadd": "99 S WALNUT ST RM 289",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445019993,
    "dropmaladd": "99 S WALNUT ST RM 289",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445019993,
    "dropsitphn": 3309969797,
    "dropsitlph": "",
    "dropsitcph": 3307408808,
    "dropfax": 3307408804
  },
  {
    "dcode": "D",
    "dropkey": "G017380",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "1050 25TH ST SE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973012512,
    "dropphyadd": "1050 25TH ST SE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973012512,
    "dropmaladd": "1050 25TH ST SE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973012512,
    "dropsitphn": 5032942242,
    "dropsitlph": 5033704710,
    "dropsitcph": 5033704781,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": "G017381",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "141 PATCHWAY RD",
    "dropdelcty": "DUNCANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166359997,
    "dropphyadd": "141 PATCHWAY RD",
    "dropphycty": "DUNCANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166359997,
    "dropmaladd": "141 PATCHWAY RD",
    "dropmalcty": "DUNCANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166359997,
    "dropsitphn": 8148987318,
    "dropsitlph": "",
    "dropsitcph": 8146934742,
    "dropfax": 8146934715
  },
  {
    "dcode": "D",
    "dropkey": "G017382",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "1400 HARRISBURG PIKE",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176049970,
    "dropphyadd": "1400 HARRISBURG PIKE",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176049970,
    "dropmaladd": "1400 HARRISBURG PIKE",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176049970,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173966932,
    "dropsitcph": 7173966925,
    "dropfax": 7173966918
  },
  {
    "dcode": "D",
    "dropkey": "G017383",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "2100 N 13TH ST",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196129991,
    "dropphyadd": "2100 N 13TH ST",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196129991,
    "dropmaladd": "2100 N 13TH ST",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196129991,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217055,
    "dropsitcph": 6109217000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017384",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "2800 STAFFORD AVE",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185059997,
    "dropphyadd": "2800 STAFFORD AVE",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185059997,
    "dropmaladd": "2800 STAFFORD AVE",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185059997,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709695101,
    "dropfax": 5709695151
  },
  {
    "dcode": "D",
    "dropkey": "G017385",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "2901 REACH RD",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177019997,
    "dropphyadd": "2901 REACH RD",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177019997,
    "dropmaladd": "2901 REACH RD",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177019997,
    "dropsitphn": 7172574875,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703204100,
    "dropfax": 5703204126
  },
  {
    "dcode": "D",
    "dropkey": "G017386",
    "droptype": "D",
    "dropname": "JOHNSON CITY",
    "dropdeladd": "530 E MAIN ST",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376015629,
    "dropphyadd": "530 E MAIN ST",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376015629,
    "dropmaladd": "530 E MAIN ST",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376015629,
    "dropsitphn": 6158859336,
    "dropsitlph": "",
    "dropsitcph": 4232325840,
    "dropfax": 4232325860
  },
  {
    "dcode": "D",
    "dropkey": "G017387",
    "droptype": "D",
    "dropname": "EVERETT",
    "dropdeladd": "8120 HARDESON RD",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982036289,
    "dropphyadd": "8120 HARDESON RD",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982036289,
    "dropmaladd": "8120 HARDESON RD",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982036289,
    "dropsitphn": 2063816600,
    "dropsitlph": 4253558366,
    "dropsitcph": 4252906300,
    "dropfax": 4252906306
  },
  {
    "dcode": "D",
    "dropkey": "G017388",
    "droptype": "D",
    "dropname": "OLYMPIA",
    "dropdeladd": "717 76TH AVE SW",
    "dropdelcty": "TUMWATER",
    "dropdelst": "WA",
    "dropdelzpp": 985019991,
    "dropphyadd": "717 76TH AVE SW",
    "dropphycty": "TUMWATER",
    "dropphyst": "WA",
    "dropphyzpp": 985019991,
    "dropmaladd": "717 76TH AVE SW",
    "dropmalcty": "TUMWATER",
    "dropmalst": "WA",
    "dropmalzpp": 985019991,
    "dropsitphn": 2063816600,
    "dropsitlph": "",
    "dropsitcph": 3607044815,
    "dropfax": 3607044892
  },
  {
    "dcode": "D",
    "dropkey": "G017389",
    "droptype": "D",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "3510 HOGARTH ST",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "WI",
    "dropdelzpp": 547039997,
    "dropphyadd": "3510 HOGARTH ST",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "WI",
    "dropphyzpp": 547039997,
    "dropmaladd": "3510 HOGARTH ST",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "WI",
    "dropmalzpp": 547039997,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 7158336785,
    "dropfax": 7158305752
  },
  {
    "dcode": "D",
    "dropkey": "G017390",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "425 STATE ST",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "WI",
    "dropdelzpp": 546013346,
    "dropphyadd": "425 STATE ST",
    "dropphycty": "LA CROSSE",
    "dropphyst": "WI",
    "dropphyzpp": 546013346,
    "dropmaladd": "425 STATE ST",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "WI",
    "dropmalzpp": 546013346,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6087918100,
    "dropfax": 6087826227
  },
  {
    "dcode": "D",
    "dropkey": "G017391",
    "droptype": "D",
    "dropname": "WAUSAU",
    "dropdeladd": "400 CRESKE AVE",
    "dropdelcty": "ROTHSCHILD",
    "dropdelst": "WI",
    "dropdelzpp": 544747955,
    "dropphyadd": "400 CRESKE AVE",
    "dropphycty": "ROTHSCHILD",
    "dropphyst": "WI",
    "dropphyzpp": 544747955,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "WAUSAU",
    "dropmalst": "WI",
    "dropmalzpp": 544029996,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 7152413800,
    "dropfax": 7152413825
  },
  {
    "dcode": "D",
    "dropkey": "G017393",
    "droptype": "D",
    "dropname": "HAVRE",
    "dropdeladd": "115 3RD ST",
    "dropdelcty": "HAVRE",
    "dropdelst": "MT",
    "dropdelzpp": 595019996,
    "dropphyadd": "115 3RD ST",
    "dropphycty": "HAVRE",
    "dropphyst": "MT",
    "dropphyzpp": 595019996,
    "dropmaladd": "115 3RD ST",
    "dropmalcty": "HAVRE",
    "dropmalst": "MT",
    "dropmalzpp": 595019996,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4062655581,
    "dropfax": 4062656886
  },
  {
    "dcode": "D",
    "dropkey": "G017394",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "450 JACKSON ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "IN",
    "dropdelzpp": 472019997,
    "dropphyadd": "450 JACKSON ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "IN",
    "dropphyzpp": 472019997,
    "dropmaladd": "450 JACKSON ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "IN",
    "dropmalzpp": 472019997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123783521,
    "dropfax": 8123760278
  },
  {
    "dcode": "D",
    "dropkey": "G017395",
    "droptype": "D",
    "dropname": "MILES CITY",
    "dropdeladd": "106 N 7TH ST",
    "dropdelcty": "MILES CITY",
    "dropdelst": "MT",
    "dropdelzpp": 593013147,
    "dropphyadd": "106 N 7TH ST",
    "dropphycty": "MILES CITY",
    "dropphyst": "MT",
    "dropphyzpp": 593013147,
    "dropmaladd": "106 N 7TH ST",
    "dropmalcty": "MILES CITY",
    "dropmalst": "MT",
    "dropmalzpp": 593013147,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4062322586,
    "dropfax": 4062321429
  },
  {
    "dcode": "D",
    "dropkey": "G017396",
    "droptype": "D",
    "dropname": "PLATTSBURGH",
    "dropdeladd": "46 VETERANS LN",
    "dropdelcty": "PLATTSBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 129011270,
    "dropphyadd": "46 VETERANS LN",
    "dropphycty": "PLATTSBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 129011270,
    "dropmaladd": "46 VETERANS LN",
    "dropmalcty": "PLATTSBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 129011270,
    "dropsitphn": 5185618776,
    "dropsitlph": "",
    "dropsitcph": 5185618776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017397",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "100 PITCHER ST",
    "dropdelcty": "UTICA",
    "dropdelst": "NY",
    "dropdelzpp": 135049990,
    "dropphyadd": "100 PITCHER ST",
    "dropphycty": "UTICA",
    "dropphyst": "NY",
    "dropphyzpp": 135049990,
    "dropmaladd": "100 PITCHER ST",
    "dropmalcty": "UTICA",
    "dropmalst": "NY",
    "dropmalzpp": 135049990,
    "dropsitphn": 3157385313,
    "dropsitlph": "",
    "dropsitcph": 3157385313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017398",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "435 S CASCADE ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161089989,
    "dropphyadd": "435 S CASCADE ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161089989,
    "dropmaladd": "435 S CASCADE ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161089989,
    "dropsitphn": 8148987318,
    "dropsitlph": "",
    "dropsitcph": 7246567221,
    "dropfax": 7246567205
  },
  {
    "dcode": "D",
    "dropkey": "G017513",
    "droptype": "D",
    "dropname": "BINGHAMTON",
    "dropdeladd": "115 HENRY ST",
    "dropdelcty": "BINGHAMTON",
    "dropdelst": "NY",
    "dropdelzpp": 139029991,
    "dropphyadd": "115 HENRY ST",
    "dropphycty": "BINGHAMTON",
    "dropphyst": "NY",
    "dropphyzpp": 139029991,
    "dropmaladd": "115 HENRY ST",
    "dropmalcty": "BINGHAMTON",
    "dropmalst": "NY",
    "dropmalzpp": 139029991,
    "dropsitphn": 6077732174,
    "dropsitlph": 6077732333,
    "dropsitcph": 6077732126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017515",
    "droptype": "D",
    "dropname": "POCATELLO",
    "dropdeladd": "1750 FLANDRO DR",
    "dropdelcty": "POCATELLO",
    "dropdelst": "ID",
    "dropdelzpp": 832021970,
    "dropphyadd": "1750 FLANDRO DR",
    "dropphycty": "POCATELLO",
    "dropphyst": "ID",
    "dropphyzpp": 832021970,
    "dropmaladd": "1750 FLANDRO DR",
    "dropmalcty": "POCATELLO",
    "dropmalst": "ID",
    "dropmalzpp": 832021970,
    "dropsitphn": 2082355501,
    "dropsitlph": 2084334080,
    "dropsitcph": 2082352190,
    "dropfax": 2082355550
  },
  {
    "dcode": "D",
    "dropkey": "G017516",
    "droptype": "D",
    "dropname": "ROCK SPRINGS",
    "dropdeladd": "2829 COMMERCIAL WAY",
    "dropdelcty": "ROCK SPRINGS",
    "dropdelst": "WY",
    "dropdelzpp": 829019997,
    "dropphyadd": "2829 COMMERCIAL WAY",
    "dropphycty": "ROCK SPRINGS",
    "dropphyst": "WY",
    "dropphyzpp": 829019997,
    "dropmaladd": "2829 COMMERCIAL WAY",
    "dropmalcty": "ROCK SPRINGS",
    "dropmalst": "WY",
    "dropmalzpp": 829019997,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3073629792,
    "dropfax": 3073829735
  },
  {
    "dcode": "D",
    "dropkey": "G017517",
    "droptype": "D",
    "dropname": "SALIDA",
    "dropdeladd": "310 D ST",
    "dropdelcty": "SALIDA",
    "dropdelst": "CO",
    "dropdelzpp": 812019997,
    "dropphyadd": "310 D ST",
    "dropphycty": "SALIDA",
    "dropphyst": "CO",
    "dropphyzpp": 812019997,
    "dropmaladd": "310 D ST",
    "dropmalcty": "SALIDA",
    "dropmalst": "CO",
    "dropmalzpp": 812019997,
    "dropsitphn": 7195392548,
    "dropsitlph": 7195392548,
    "dropsitcph": 7195393655,
    "dropfax": 7195300763
  },
  {
    "dcode": "D",
    "dropkey": "G017522",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "4738 W VERNAL PIKE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474049900,
    "dropphyadd": "4738 W VERNAL PIKE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474049900,
    "dropmaladd": "4738 W VERNAL PIKE",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474049900,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123314544,
    "dropfax": 8123490394
  },
  {
    "dcode": "D",
    "dropkey": "G017532",
    "droptype": "D",
    "dropname": "FORT SMITH",
    "dropdeladd": "3318 S 74TH ST",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729039996,
    "dropphyadd": "3318 S 74TH ST",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729039996,
    "dropmaladd": "3318 S 74TH ST",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729039996,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 4794846401,
    "dropfax": 4794846397
  },
  {
    "dcode": "D",
    "dropkey": "G017533",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "215 W INDUSTRIAL PARK RD",
    "dropdelcty": "HARRISON",
    "dropdelst": "AR",
    "dropdelzpp": 726019902,
    "dropphyadd": "215 W INDUSTRIAL PARK RD",
    "dropphycty": "HARRISON",
    "dropphyst": "AR",
    "dropphyzpp": 726019902,
    "dropmaladd": "215 W INDUSTRIAL PARK RD",
    "dropmalcty": "HARRISON",
    "dropmalst": "AR",
    "dropmalzpp": 726019902,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 8707413473,
    "dropfax": 5017417162
  },
  {
    "dcode": "D",
    "dropkey": "G017534",
    "droptype": "D",
    "dropname": "HOT SPRINGS NATIONAL PARK",
    "dropdeladd": "335 SECTION LINE RD",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139942,
    "dropphyadd": "335 SECTION LINE RD",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139942,
    "dropmaladd": "335 SECTION LINE RD",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139942,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 5015250558,
    "dropfax": 5015253164
  },
  {
    "dcode": "D",
    "dropkey": "G017535",
    "droptype": "D",
    "dropname": "NORTHEAST ARKANSAS",
    "dropdeladd": "3405 MOORE RD",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019996,
    "dropphyadd": "3405 MOORE RD",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019996,
    "dropmaladd": "3405 MOORE RD",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019996,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 8709315763,
    "dropfax": 8709316932
  },
  {
    "dcode": "D",
    "dropkey": "G017536",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "203 S BOSTON AVE",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728019907,
    "dropphyadd": "203 S BOSTON AVE",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728019907,
    "dropmaladd": "203 S BOSTON AVE",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728019907,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 4799684112,
    "dropfax": 4799683628
  },
  {
    "dcode": "D",
    "dropkey": "G017537",
    "droptype": "D",
    "dropname": "LUFKIN",
    "dropdeladd": "800 S JOHN REDDITT DR",
    "dropdelcty": "LUFKIN",
    "dropdelst": "TX",
    "dropdelzpp": 759049997,
    "dropphyadd": "800 S JOHN REDDITT DR",
    "dropphycty": "LUFKIN",
    "dropphyst": "TX",
    "dropphyzpp": 759049997,
    "dropmaladd": "800 S JOHN REDDITT DR",
    "dropmalcty": "LUFKIN",
    "dropmalst": "TX",
    "dropmalzpp": 759049997,
    "dropsitphn": 2144675879,
    "dropsitlph": "",
    "dropsitcph": 9366347749,
    "dropfax": 9366392766
  },
  {
    "dcode": "D",
    "dropkey": "G017539",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "1501 S SLAPPEY BLVD",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317019997,
    "dropphyadd": "1501 S SLAPPEY BLVD",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317019997,
    "dropmaladd": "1501 S SLAPPEY BLVD",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317019997,
    "dropsitphn": 4787528444,
    "dropsitlph": "",
    "dropsitcph": 2298892629,
    "dropfax": 2298892640
  },
  {
    "dcode": "D",
    "dropkey": "G017540",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3916 MILGEN RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079992,
    "dropphyadd": "3916 MILGEN RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319079992,
    "dropmaladd": "3916 MILGEN RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319079992,
    "dropsitphn": 4787528444,
    "dropsitlph": "",
    "dropsitcph": 7065621782,
    "dropfax": 7065621784
  },
  {
    "dcode": "D",
    "dropkey": "G017541",
    "droptype": "D",
    "dropname": "SWAINSBORO",
    "dropdeladd": "211 W MORING ST",
    "dropdelcty": "SWAINSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 304019997,
    "dropphyadd": "211 W MORING ST",
    "dropphycty": "SWAINSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 304019997,
    "dropmaladd": "211 W MORING ST",
    "dropmalcty": "SWAINSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 304019997,
    "dropsitphn": 4787528466,
    "dropsitlph": "",
    "dropsitcph": 4782379689,
    "dropfax": 4782379070
  },
  {
    "dcode": "D",
    "dropkey": "G017545",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3202 BLUECUTT RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MS",
    "dropdelzpp": 397059997,
    "dropphyadd": "3202 BLUECUTT RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MS",
    "dropphyzpp": 397059997,
    "dropmaladd": "3202 BLUECUTT RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MS",
    "dropmalzpp": 397059997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623282313,
    "dropsitcph": 6623291092,
    "dropfax": 6623281502
  },
  {
    "dcode": "D",
    "dropkey": "G017546",
    "droptype": "D",
    "dropname": "TUPELO",
    "dropdeladd": "362 S THOMAS ST",
    "dropdelcty": "TUPELO",
    "dropdelst": "MS",
    "dropdelzpp": 388019997,
    "dropphyadd": "362 S THOMAS ST",
    "dropphycty": "TUPELO",
    "dropphyst": "MS",
    "dropphyzpp": 388019997,
    "dropmaladd": "362 S THOMAS ST",
    "dropmalcty": "TUPELO",
    "dropmalst": "MS",
    "dropmalzpp": 388019997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627918430,
    "dropsitcph": 6627918401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017548",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "5815 WALDEN RD",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777079995,
    "dropphyadd": "5815 WALDEN RD",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777079995,
    "dropmaladd": "5815 WALDEN RD",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777079995,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099818730,
    "dropsitcph": 4099818601,
    "dropfax": 4099818607
  },
  {
    "dcode": "D",
    "dropkey": "G017549",
    "droptype": "D",
    "dropname": "ANNISTON",
    "dropdeladd": "1101 QUINTARD AVE",
    "dropdelcty": "ANNISTON",
    "dropdelst": "AL",
    "dropdelzpp": 362014632,
    "dropphyadd": "1101 QUINTARD AVE",
    "dropphycty": "ANNISTON",
    "dropphyst": "AL",
    "dropphyzpp": 362014632,
    "dropmaladd": "1101 QUINTARD AVE",
    "dropmalcty": "ANNISTON",
    "dropmalst": "AL",
    "dropmalzpp": 362014632,
    "dropsitphn": 2562359940,
    "dropsitlph": "",
    "dropsitcph": 2562359940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017550",
    "droptype": "D",
    "dropname": "TUSCALOOSA",
    "dropdeladd": "3201 SKYLAND BLVD E",
    "dropdelcty": "TUSCALOOSA",
    "dropdelst": "AL",
    "dropdelzpp": 354059995,
    "dropphyadd": "3201 SKYLAND BLVD E",
    "dropphycty": "TUSCALOOSA",
    "dropphyst": "AL",
    "dropphyzpp": 354059995,
    "dropmaladd": "3201 SKYLAND BLVD E",
    "dropmalcty": "TUSCALOOSA",
    "dropmalst": "AL",
    "dropmalzpp": 354059995,
    "dropsitphn": 2053446080,
    "dropsitlph": "",
    "dropsitcph": 2053446080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017551",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "490 E COLLEGE ST STE 139",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 725019912,
    "dropphyadd": "490 E COLLEGE ST STE 139",
    "dropphycty": "BATESVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 725019912,
    "dropmaladd": "490 E COLLEGE ST STE 139",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 725019912,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 8707936828,
    "dropfax": 8706980314
  },
  {
    "dcode": "D",
    "dropkey": "G017552",
    "droptype": "D",
    "dropname": "PINE BLUFF",
    "dropdeladd": "100 E 8TH AVE STE 105",
    "dropdelcty": "PINE BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 716019990,
    "dropphyadd": "100 E 8TH AVE STE 105",
    "dropphycty": "PINE BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 716019990,
    "dropmaladd": "100 E 8TH AVE STE 105",
    "dropmalcty": "PINE BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 716019990,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 8705363535,
    "dropfax": 8705359512
  },
  {
    "dcode": "D",
    "dropkey": "G017553",
    "droptype": "D",
    "dropname": "PANAMA CITY",
    "dropdeladd": "1336 SHERMAN AVE",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324019500,
    "dropphyadd": "1336 SHERMAN AVE",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324019500,
    "dropmaladd": "PO BOX 35000",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324129998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507473901,
    "dropsitcph": 8507474890,
    "dropfax": 8507474814
  },
  {
    "dcode": "D",
    "dropkey": "G017554",
    "droptype": "D",
    "dropname": "WAYCROSS",
    "dropdeladd": "601 TEBEAU ST FL 1",
    "dropdelcty": "WAYCROSS",
    "dropdelst": "GA",
    "dropdelzpp": 315019905,
    "dropphyadd": "601 TEBEAU ST FL 1",
    "dropphycty": "WAYCROSS",
    "dropphyst": "GA",
    "dropphyzpp": 315019905,
    "dropmaladd": "601 TEBEAU ST FL 1",
    "dropmalcty": "WAYCROSS",
    "dropmalst": "GA",
    "dropmalzpp": 315019905,
    "dropsitphn": 4787528466,
    "dropsitlph": "",
    "dropsitcph": 9122878110,
    "dropfax": 9122831810
  },
  {
    "dcode": "D",
    "dropkey": "G017555",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "1715 ODOM ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "LA",
    "dropdelzpp": 713019997,
    "dropphyadd": "1715 ODOM ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "LA",
    "dropphyzpp": 713019997,
    "dropmaladd": "1715 ODOM ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "LA",
    "dropmalzpp": 713019997,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3184844602,
    "dropfax": 3184844659
  },
  {
    "dcode": "D",
    "dropkey": "G017556",
    "droptype": "D",
    "dropname": "HOUMA",
    "dropdeladd": "425 LAFAYETTE ST OFC",
    "dropdelcty": "HOUMA",
    "dropdelst": "LA",
    "dropdelzpp": 703609997,
    "dropphyadd": "425 LAFAYETTE ST OFC",
    "dropphycty": "HOUMA",
    "dropphyst": "LA",
    "dropphyzpp": 703609997,
    "dropmaladd": "425 LAFAYETTE ST OFC",
    "dropmalcty": "HOUMA",
    "dropmalst": "LA",
    "dropmalzpp": 703609997,
    "dropsitphn": 9858681629,
    "dropsitlph": "",
    "dropsitcph": 9852231722,
    "dropfax": 9858687348
  },
  {
    "dcode": "D",
    "dropkey": "G017557",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "501 STERLINGTON RD",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712039997,
    "dropphyadd": "501 STERLINGTON RD",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712039997,
    "dropmaladd": "501 STERLINGTON RD",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712039997,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3183876162,
    "dropfax": 3183241329
  },
  {
    "dcode": "D",
    "dropkey": "G017559",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "305 MAIN ST STE 154",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387019997,
    "dropphyadd": "305 MAIN ST STE 154",
    "dropphycty": "GREENVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387019997,
    "dropmaladd": "305 MAIN ST STE 154",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387019997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623354524,
    "dropsitcph": 6623354523,
    "dropfax": 6623328921
  },
  {
    "dcode": "D",
    "dropkey": "G017560",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "2100 9TH ST",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "MS",
    "dropdelzpp": 393019997,
    "dropphyadd": "2100 9TH ST",
    "dropphycty": "MERIDIAN",
    "dropphyst": "MS",
    "dropphyzpp": 393019997,
    "dropmaladd": "2100 9TH ST",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "MS",
    "dropmalzpp": 393019997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015538000,
    "dropsitcph": 6016932581,
    "dropfax": 6015538024
  },
  {
    "dcode": "D",
    "dropkey": "G017561",
    "droptype": "D",
    "dropname": "ARDMORE",
    "dropdeladd": "208 1ST AVE SW",
    "dropdelcty": "ARDMORE",
    "dropdelst": "OK",
    "dropdelzpp": 734016348,
    "dropphyadd": "208 1ST AVE SW",
    "dropphycty": "ARDMORE",
    "dropphyst": "OK",
    "dropphyzpp": 734016348,
    "dropmaladd": "208 1ST AVE SW",
    "dropmalcty": "ARDMORE",
    "dropmalst": "OK",
    "dropmalzpp": 734016348,
    "dropsitphn": 4058152724,
    "dropsitlph": "",
    "dropsitcph": 5802231583,
    "dropfax": 5802262830
  },
  {
    "dcode": "D",
    "dropkey": "G017562",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "212 S 11TH ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "OK",
    "dropdelzpp": 736013936,
    "dropphyadd": "212 S 11TH ST",
    "dropphycty": "CLINTON",
    "dropphyst": "OK",
    "dropphyzpp": 736013936,
    "dropmaladd": "212 S 11TH ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "OK",
    "dropmalzpp": 736013936,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055536782,
    "dropsitcph": 5803230712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017564",
    "droptype": "D",
    "dropname": "ENID",
    "dropdeladd": "115 W BROADWAY AVE FL 1",
    "dropdelcty": "ENID",
    "dropdelst": "OK",
    "dropdelzpp": 737015613,
    "dropphyadd": "115 W BROADWAY AVE FL 1",
    "dropphycty": "ENID",
    "dropphyst": "OK",
    "dropphyzpp": 737015613,
    "dropmaladd": "115 W BROADWAY AVE FL 1",
    "dropmalcty": "ENID",
    "dropmalst": "OK",
    "dropmalzpp": 737015613,
    "dropsitphn": 4058152724,
    "dropsitlph": "",
    "dropsitcph": 5802374331,
    "dropfax": 5802376419
  },
  {
    "dcode": "D",
    "dropkey": "G017565",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "501 SW 5TH ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "OK",
    "dropdelzpp": 735014621,
    "dropphyadd": "501 SW 5TH ST",
    "dropphycty": "LAWTON",
    "dropphyst": "OK",
    "dropphyzpp": 735014621,
    "dropmaladd": "501 SW 5TH ST",
    "dropmalcty": "LAWTON",
    "dropmalst": "OK",
    "dropmalzpp": 735014621,
    "dropsitphn": 4058152724,
    "dropsitlph": "",
    "dropsitcph": 5803531500,
    "dropfax": 5803534082
  },
  {
    "dcode": "D",
    "dropkey": "G017569",
    "droptype": "D",
    "dropname": "WOODWARD",
    "dropdeladd": "2020 WILLIAMS AVE",
    "dropdelcty": "WOODWARD",
    "dropdelst": "OK",
    "dropdelzpp": 738019903,
    "dropphyadd": "2020 WILLIAMS AVE",
    "dropphycty": "WOODWARD",
    "dropphyst": "OK",
    "dropphyzpp": 738019903,
    "dropmaladd": "2020 WILLIAMS AVE",
    "dropmalcty": "WOODWARD",
    "dropmalst": "OK",
    "dropmalzpp": 738019903,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055536782,
    "dropsitcph": 5802567138,
    "dropfax": 5802564404
  },
  {
    "dcode": "D",
    "dropkey": "G017570",
    "droptype": "D",
    "dropname": "CHILDRESS",
    "dropdeladd": "507 AVENUE F NW",
    "dropdelcty": "CHILDRESS",
    "dropdelst": "TX",
    "dropdelzpp": 792019997,
    "dropphyadd": "507 AVENUE F NW",
    "dropphycty": "CHILDRESS",
    "dropphyst": "TX",
    "dropphyzpp": 792019997,
    "dropmaladd": "507 AVENUE F NW",
    "dropmalcty": "CHILDRESS",
    "dropmalst": "TX",
    "dropmalzpp": 792019997,
    "dropsitphn": 8173173658,
    "dropsitlph": "",
    "dropsitcph": 9409373741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017571",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "1213 N LINK ST",
    "dropdelcty": "PALESTINE",
    "dropdelst": "TX",
    "dropdelzpp": 758039997,
    "dropphyadd": "1213 N LINK ST",
    "dropphycty": "PALESTINE",
    "dropphyst": "TX",
    "dropphyzpp": 758039997,
    "dropmaladd": "1213 N LINK ST",
    "dropmalcty": "PALESTINE",
    "dropmalst": "TX",
    "dropmalzpp": 758039997,
    "dropsitphn": 2144675879,
    "dropsitlph": "",
    "dropsitcph": 9037231084,
    "dropfax": 9037291999
  },
  {
    "dcode": "D",
    "dropkey": "G017572",
    "droptype": "D",
    "dropname": "TEXARKANA",
    "dropdeladd": "2211 N ROBISON RD",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "TX",
    "dropdelzpp": 755019997,
    "dropphyadd": "2211 N ROBISON RD",
    "dropphycty": "TEXARKANA",
    "dropphyst": "TX",
    "dropphyzpp": 755019997,
    "dropmaladd": "2211 N ROBISON RD",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "TX",
    "dropmalzpp": 755019997,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032233823,
    "dropsitcph": 9032233800,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "G017573",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "2804 SAM HOUSTON DR",
    "dropdelcty": "VICTORIA",
    "dropdelst": "TX",
    "dropdelzpp": 779049991,
    "dropphyadd": "2804 SAM HOUSTON DR",
    "dropphycty": "VICTORIA",
    "dropphyst": "TX",
    "dropphyzpp": 779049991,
    "dropmaladd": "2804 SAM HOUSTON DR",
    "dropmalcty": "VICTORIA",
    "dropmalst": "TX",
    "dropmalzpp": 779049991,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615752363,
    "dropsitcph": 3615755611,
    "dropfax": 3615751010
  },
  {
    "dcode": "D",
    "dropkey": "G017574",
    "droptype": "D",
    "dropname": "BRYAN",
    "dropdeladd": "2121 E WM J BRYAN PKWY",
    "dropdelcty": "BRYAN",
    "dropdelst": "TX",
    "dropdelzpp": 778019997,
    "dropphyadd": "2121 E WM J BRYAN PKWY",
    "dropphycty": "BRYAN",
    "dropphyst": "TX",
    "dropphyzpp": 778019997,
    "dropmaladd": "2121 E WM J BRYAN PKWY",
    "dropmalcty": "BRYAN",
    "dropmalst": "TX",
    "dropmalzpp": 778019997,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797742314,
    "dropsitcph": 9797742300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017600",
    "droptype": "D",
    "dropname": "ALAMOSA",
    "dropdeladd": "505 3RD ST",
    "dropdelcty": "ALAMOSA",
    "dropdelst": "CO",
    "dropdelzpp": 811019997,
    "dropphyadd": "505 3RD ST",
    "dropphycty": "ALAMOSA",
    "dropphyst": "CO",
    "dropphyzpp": 811019997,
    "dropmaladd": "505 3RD ST",
    "dropmalcty": "ALAMOSA",
    "dropmalst": "CO",
    "dropmalzpp": 811019997,
    "dropsitphn": 7195894909,
    "dropsitlph": "",
    "dropsitcph": 7195894909,
    "dropfax": 7195896190
  },
  {
    "dcode": "D",
    "dropkey": "G017602",
    "droptype": "D",
    "dropname": "DURANGO",
    "dropdeladd": "222 W 8TH ST",
    "dropdelcty": "DURANGO",
    "dropdelst": "CO",
    "dropdelzpp": 813019997,
    "dropphyadd": "222 W 8TH ST",
    "dropphycty": "DURANGO",
    "dropphyst": "CO",
    "dropphyzpp": 813019997,
    "dropmaladd": "222 W 8TH ST",
    "dropmalcty": "DURANGO",
    "dropmalst": "CO",
    "dropmalzpp": 813019997,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702473968,
    "dropsitcph": 9702473434,
    "dropfax": 9702473154
  },
  {
    "dcode": "D",
    "dropkey": "G017603",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "427 WEST AVE RM 334",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069109997",
    "dropphyadd": "427 WEST AVE RM 334",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069109997",
    "dropmaladd": "427 WEST AVE RM 334",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069109997",
    "dropsitphn": 2033262038,
    "dropsitlph": "",
    "dropsitcph": 2033262038,
    "dropfax": 2033262153
  },
  {
    "dcode": "D",
    "dropkey": "G017604",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "614 N CLARK ST",
    "dropdelcty": "CARROLL",
    "dropdelst": "IA",
    "dropdelzpp": 514014500,
    "dropphyadd": "614 N CLARK ST",
    "dropphycty": "CARROLL",
    "dropphyst": "IA",
    "dropphyzpp": 514014500,
    "dropmaladd": "614 N CLARK ST",
    "dropmalcty": "CARROLL",
    "dropmalst": "IA",
    "dropmalzpp": 514014500,
    "dropsitphn": 5152837530,
    "dropsitlph": "",
    "dropsitcph": 7127922341,
    "dropfax": 7127925581
  },
  {
    "dcode": "D",
    "dropkey": "G017605",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "300 S ELM ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "IA",
    "dropdelzpp": 508014300,
    "dropphyadd": "300 S ELM ST",
    "dropphycty": "CRESTON",
    "dropphyst": "IA",
    "dropphyzpp": 508014300,
    "dropmaladd": "300 S ELM ST",
    "dropmalcty": "CRESTON",
    "dropmalst": "IA",
    "dropmalzpp": 508014300,
    "dropsitphn": 5152837530,
    "dropsitlph": "",
    "dropsitcph": 6417822184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017606",
    "droptype": "D",
    "dropname": "DUBUQUE",
    "dropdeladd": "4555 FUTURO CT",
    "dropdelcty": "DUBUQUE",
    "dropdelst": "IA",
    "dropdelzpp": 520023000,
    "dropphyadd": "4555 FUTURO CT",
    "dropphycty": "DUBUQUE",
    "dropphyst": "IA",
    "dropphyzpp": 520023000,
    "dropmaladd": "4555 FUTURO CT",
    "dropmalcty": "DUBUQUE",
    "dropmalst": "IA",
    "dropmalzpp": 520023000,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635824365,
    "dropsitcph": 5635822997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017607",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "1301 E MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "IL",
    "dropdelzpp": 629019996,
    "dropphyadd": "1301 E MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "IL",
    "dropphyzpp": 629019996,
    "dropmaladd": "1301 E MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "IL",
    "dropmalzpp": 629019996,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 6183515651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017613",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "314 S POPLAR ST",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "IL",
    "dropdelzpp": 628019996,
    "dropphyadd": "314 S POPLAR ST",
    "dropphycty": "CENTRALIA",
    "dropphyst": "IL",
    "dropphyzpp": 628019996,
    "dropmaladd": "314 S POPLAR ST",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "IL",
    "dropmalzpp": 628019996,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 6185326717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017616",
    "droptype": "D",
    "dropname": "KOKOMO",
    "dropdeladd": "2719 S WEBSTER ST",
    "dropdelcty": "KOKOMO",
    "dropdelst": "IN",
    "dropdelzpp": 469029997,
    "dropphyadd": "2719 S WEBSTER ST",
    "dropphycty": "KOKOMO",
    "dropphyst": "IN",
    "dropphyzpp": 469029997,
    "dropmaladd": "2719 S WEBSTER ST",
    "dropmalcty": "KOKOMO",
    "dropmalst": "IN",
    "dropmalzpp": 469029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 7654558322,
    "dropsitcph": 7654558338,
    "dropfax": 7654558350
  },
  {
    "dcode": "D",
    "dropkey": "G017618",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "3450 SOUTH ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479059997,
    "dropphyadd": "3450 SOUTH ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479059997,
    "dropmaladd": "3450 SOUTH ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479059997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489200,
    "dropfax": 7654489292
  },
  {
    "dcode": "D",
    "dropkey": "G017620",
    "droptype": "D",
    "dropname": "COLBY",
    "dropdeladd": "535 N COURT AVE",
    "dropdelcty": "COLBY",
    "dropdelst": "KS",
    "dropdelzpp": 677019902,
    "dropphyadd": "535 N COURT AVE",
    "dropphycty": "COLBY",
    "dropphyst": "KS",
    "dropphyzpp": 677019902,
    "dropmaladd": "535 N COURT AVE",
    "dropmalcty": "COLBY",
    "dropmalst": "KS",
    "dropmalzpp": 677019902,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 7854627904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017621",
    "droptype": "D",
    "dropname": "DODGE CITY",
    "dropdeladd": "700 CENTRAL AVE",
    "dropdelcty": "DODGE CITY",
    "dropdelst": "KS",
    "dropdelzpp": 678019906,
    "dropphyadd": "700 CENTRAL AVE",
    "dropphycty": "DODGE CITY",
    "dropphyst": "KS",
    "dropphyzpp": 678019906,
    "dropmaladd": "700 CENTRAL AVE",
    "dropmalcty": "DODGE CITY",
    "dropmalst": "KS",
    "dropmalzpp": 678019906,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202278619,
    "dropsitcph": 6202278618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017622",
    "droptype": "D",
    "dropname": "HAYS",
    "dropdeladd": "706 FORT ST",
    "dropdelcty": "HAYS",
    "dropdelst": "KS",
    "dropdelzpp": 676019997,
    "dropphyadd": "706 FORT ST",
    "dropphycty": "HAYS",
    "dropphyst": "KS",
    "dropphyzpp": 676019997,
    "dropmaladd": "706 FORT ST",
    "dropmalcty": "HAYS",
    "dropmalst": "KS",
    "dropmalzpp": 676019997,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856253112,
    "dropsitcph": 7856252012,
    "dropfax": 7856254728
  },
  {
    "dcode": "D",
    "dropkey": "G017623",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "5300 SCOTTSVILLE RD",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 421049997,
    "dropphyadd": "5300 SCOTTSVILLE RD",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 421049997,
    "dropmaladd": "5300 SCOTTSVILLE RD",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 421049997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708435760,
    "dropfax": 2708435773
  },
  {
    "dcode": "D",
    "dropkey": "G017624",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "2934 DOLPHIN DR",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 427019996,
    "dropphyadd": "2934 DOLPHIN DR",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 427019996,
    "dropmaladd": "2934 DOLPHIN DR",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 427019996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707657230,
    "dropfax": 2707372595
  },
  {
    "dcode": "D",
    "dropkey": "G017625",
    "droptype": "D",
    "dropname": "HAZARD",
    "dropdeladd": "201 BLACK GOLD BLVD",
    "dropdelcty": "HAZARD",
    "dropdelst": "KY",
    "dropdelzpp": 417019997,
    "dropphyadd": "201 BLACK GOLD BLVD",
    "dropphycty": "HAZARD",
    "dropphyst": "KY",
    "dropphyzpp": 417019997,
    "dropmaladd": "201 BLACK GOLD BLVD",
    "dropmalcty": "HAZARD",
    "dropmalst": "KY",
    "dropmalzpp": 417019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064363180,
    "dropfax": 6064393499
  },
  {
    "dcode": "D",
    "dropkey": "G017626",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "1760 HIGHWAY 192 W",
    "dropdelcty": "LONDON",
    "dropdelst": "KY",
    "dropdelzpp": 407419997,
    "dropphyadd": "1760 HIGHWAY 192 W",
    "dropphycty": "LONDON",
    "dropphyst": "KY",
    "dropphyzpp": 407419997,
    "dropmaladd": "1760 HIGHWAY 192 W",
    "dropmalcty": "LONDON",
    "dropmalst": "KY",
    "dropmalzpp": 407419997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068641701,
    "dropfax": 6068642289
  },
  {
    "dcode": "D",
    "dropkey": "G017627",
    "droptype": "D",
    "dropname": "OWENSBORO",
    "dropdeladd": "54 BON HARBOR HLS",
    "dropdelcty": "OWENSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423019997,
    "dropphyadd": "54 BON HARBOR HLS",
    "dropphycty": "OWENSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423019997,
    "dropmaladd": "54 BON HARBOR HLS",
    "dropmalcty": "OWENSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706891838,
    "dropfax": 2706868895
  },
  {
    "dcode": "D",
    "dropkey": "G017628",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "119 N MAPLE ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "KY",
    "dropdelzpp": 425019997,
    "dropphyadd": "119 N MAPLE ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "KY",
    "dropphyzpp": 425019997,
    "dropmaladd": "119 N MAPLE ST",
    "dropmalcty": "SOMERSET",
    "dropmalst": "KY",
    "dropmalzpp": 425019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066793549,
    "dropfax": 6066795430
  },
  {
    "dcode": "D",
    "dropkey": "G017629",
    "droptype": "D",
    "dropname": "GAYLORD",
    "dropdeladd": "289 W COMMERCE BLVD",
    "dropdelcty": "GAYLORD",
    "dropdelst": "MI",
    "dropdelzpp": 497357343,
    "dropphyadd": "289 W COMMERCE BLVD",
    "dropphycty": "GAYLORD",
    "dropphyst": "MI",
    "dropphyzpp": 497357343,
    "dropmaladd": "289 W COMMERCE BLVD",
    "dropmalcty": "GAYLORD",
    "dropmalst": "MI",
    "dropmalzpp": 497357343,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897326800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017631",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "1500 N ELM AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "MI",
    "dropdelzpp": 492029956,
    "dropphyadd": "1500 N ELM AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "MI",
    "dropphyzpp": 492029956,
    "dropmaladd": "1500 N ELM AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "MI",
    "dropmalzpp": 492029956,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5177680721,
    "dropfax": 5177680618
  },
  {
    "dcode": "D",
    "dropkey": "G017635",
    "droptype": "D",
    "dropname": "CAPE GIRARDEAU",
    "dropdeladd": "475 KELL FARM DR",
    "dropdelcty": "CAPE GIRARDEAU",
    "dropdelst": "MO",
    "dropdelzpp": 637019806,
    "dropphyadd": "475 KELL FARM DR",
    "dropphycty": "CAPE GIRARDEAU",
    "dropphyst": "MO",
    "dropphyzpp": 637019806,
    "dropmaladd": "475 KELL FARM DR",
    "dropmalcty": "CAPE GIRARDEAU",
    "dropmalst": "MO",
    "dropmalzpp": 637019806,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165043331,
    "dropsitcph": 5733310800,
    "dropfax": 5733310863
  },
  {
    "dcode": "D",
    "dropkey": "G017637",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "1100 S PINE INDUSTRIAL RD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "NE",
    "dropdelzpp": 687019997,
    "dropphyadd": "1100 S PINE INDUSTRIAL RD",
    "dropphycty": "NORFOLK",
    "dropphyst": "NE",
    "dropphyzpp": 687019997,
    "dropmaladd": "1100 S PINE INDUSTRIAL RD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "NE",
    "dropmalzpp": 687019997,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 4023710734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017638",
    "droptype": "D",
    "dropname": "TRUTH OR CONSEQUENCES",
    "dropdeladd": "1507 N DATE ST",
    "dropdelcty": "TRUTH OR CONSEQUENCES",
    "dropdelst": "NM",
    "dropdelzpp": 879013717,
    "dropphyadd": "1507 N DATE ST",
    "dropphycty": "TRUTH OR CONSEQUENCES",
    "dropphyst": "NM",
    "dropphyzpp": 879013717,
    "dropmaladd": "1507 N DATE ST",
    "dropmalcty": "TRUTH OR CONSEQUENCES",
    "dropmalst": "NM",
    "dropmalzpp": 879013717,
    "dropsitphn": 5053468251,
    "dropsitlph": "",
    "dropsitcph": 5758943137,
    "dropfax": 5758949402
  },
  {
    "dcode": "D",
    "dropkey": "G017640",
    "droptype": "D",
    "dropname": "ELKO",
    "dropdeladd": "500 ASPEN WAY",
    "dropdelcty": "ELKO",
    "dropdelst": "NV",
    "dropdelzpp": 898019997,
    "dropphyadd": "500 ASPEN WAY",
    "dropphycty": "ELKO",
    "dropphyst": "NV",
    "dropphyzpp": 898019997,
    "dropmaladd": "500 ASPEN WAY",
    "dropmalcty": "ELKO",
    "dropmalst": "NV",
    "dropmalzpp": 898019997,
    "dropsitphn": 7023619453,
    "dropsitlph": "",
    "dropsitcph": 7757779803,
    "dropfax": 7757385980
  },
  {
    "dcode": "D",
    "dropkey": "G017642",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "5 W STIMSON AVE",
    "dropdelcty": "ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 457018510,
    "dropphyadd": "5 W STIMSON AVE",
    "dropphycty": "ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 457018510,
    "dropmaladd": "5 W STIMSON AVE",
    "dropmalcty": "ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 457018510,
    "dropsitphn": 7405935578,
    "dropsitlph": 6144720674,
    "dropsitcph": 7405935578,
    "dropfax": 7405944601
  },
  {
    "dcode": "D",
    "dropkey": "G017643",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "40 S WALNUT ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "OH",
    "dropdelzpp": 456019998,
    "dropphyadd": "40 S WALNUT ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "OH",
    "dropphyzpp": 456019998,
    "dropmaladd": "40 S WALNUT ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "OH",
    "dropmalzpp": 456019998,
    "dropsitphn": 7407741181,
    "dropsitlph": "",
    "dropsitcph": 7407741181,
    "dropfax": 7407742354
  },
  {
    "dcode": "D",
    "dropkey": "G017644",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "1202 S 5TH ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "SD",
    "dropdelzpp": 574019997,
    "dropphyadd": "1202 S 5TH ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "SD",
    "dropphyzpp": 574019997,
    "dropmaladd": "1202 S 5TH ST",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "SD",
    "dropmalzpp": 574019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 6052262673,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "G017646",
    "droptype": "D",
    "dropname": "PIERRE",
    "dropdeladd": "225 S PIERRE ST STE 101",
    "dropdelcty": "PIERRE",
    "dropdelst": "SD",
    "dropdelzpp": 575019997,
    "dropphyadd": "225 S PIERRE ST STE 101",
    "dropphycty": "PIERRE",
    "dropphyst": "SD",
    "dropphyzpp": 575019997,
    "dropmaladd": "225 S PIERRE ST STE 101",
    "dropmalcty": "PIERRE",
    "dropmalst": "SD",
    "dropmalzpp": 575019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 6052241204,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "G017647",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383019997,
    "dropphyadd": "200 DR MARTIN LUTHER KING JR DR",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383019997,
    "dropmaladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383019997,
    "dropsitphn": 6158859336,
    "dropsitlph": "",
    "dropsitcph": 7314232596,
    "dropfax": 7314230234
  },
  {
    "dcode": "D",
    "dropkey": "G017648",
    "droptype": "D",
    "dropname": "PASCO",
    "dropdeladd": "3500 W COURT ST",
    "dropdelcty": "PASCO",
    "dropdelst": "WA",
    "dropdelzpp": 993013886,
    "dropphyadd": "3500 W COURT ST",
    "dropphycty": "PASCO",
    "dropphyst": "WA",
    "dropphyzpp": 993013886,
    "dropmaladd": "3500 W COURT ST",
    "dropmalcty": "PASCO",
    "dropmalst": "WA",
    "dropmalzpp": 993013886,
    "dropsitphn": 5095432189,
    "dropsitlph": 5095432113,
    "dropsitcph": 5095432189,
    "dropfax": 5095432116
  },
  {
    "dcode": "D",
    "dropkey": "G017651",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "200 CAVA DR",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263019997,
    "dropphyadd": "200 CAVA DR",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263019997,
    "dropmaladd": "200 CAVA DR",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263019997,
    "dropsitphn": 3046237707,
    "dropsitlph": 3046237707,
    "dropsitcph": 3046237707,
    "dropfax": 3046248897
  },
  {
    "dcode": "D",
    "dropkey": "G017652",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "1355 OLD COURTHOUSE SQ",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 254049905,
    "dropphyadd": "1355 OLD COURTHOUSE SQ",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 254049905,
    "dropmaladd": "1355 OLD COURTHOUSE SQ",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 254049905,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042677787,
    "dropfax": 3042679360
  },
  {
    "dcode": "D",
    "dropkey": "G017653",
    "droptype": "D",
    "dropname": "WHEELING",
    "dropdeladd": "2501 CHAPLINE ST",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260039787,
    "dropphyadd": "2501 CHAPLINE ST",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260039787,
    "dropmaladd": "2501 CHAPLINE ST",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260039787,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042333912,
    "dropsitcph": 3042431875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017654",
    "droptype": "D",
    "dropname": "RAWLINS",
    "dropdeladd": "106 5TH ST",
    "dropdelcty": "RAWLINS",
    "dropdelst": "WY",
    "dropdelzpp": 823019997,
    "dropphyadd": "106 5TH ST",
    "dropphycty": "RAWLINS",
    "dropphyst": "WY",
    "dropphyzpp": 823019997,
    "dropmaladd": "106 5TH ST",
    "dropmalcty": "RAWLINS",
    "dropmalst": "WY",
    "dropmalzpp": 823019997,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3073243521,
    "dropfax": 3073246134
  },
  {
    "dcode": "D",
    "dropkey": "G017655",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "351 W WASHINGTON ST STE 100",
    "dropdelcty": "CAMDEN",
    "dropdelst": "AR",
    "dropdelzpp": 717019754,
    "dropphyadd": "351 W WASHINGTON ST STE 100",
    "dropphycty": "CAMDEN",
    "dropphyst": "AR",
    "dropphyzpp": 717019754,
    "dropmaladd": "351 W WASHINGTON ST STE 100",
    "dropmalcty": "CAMDEN",
    "dropmalst": "AR",
    "dropmalzpp": 717019754,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 8708368146,
    "dropfax": 8708367549
  },
  {
    "dcode": "D",
    "dropkey": "G017656",
    "droptype": "D",
    "dropname": "FLAGSTAFF",
    "dropdeladd": "2400 N POSTAL BLVD",
    "dropdelcty": "FLAGSTAFF",
    "dropdelst": "AZ",
    "dropdelzpp": 860049996,
    "dropphyadd": "2400 N POSTAL BLVD",
    "dropphycty": "FLAGSTAFF",
    "dropphyst": "AZ",
    "dropphyzpp": 860049996,
    "dropmaladd": "2400 N POSTAL BLVD",
    "dropmalcty": "FLAGSTAFF",
    "dropmalst": "AZ",
    "dropmalzpp": 860049996,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287140524,
    "dropsitcph": 9287149302,
    "dropfax": 9287149882
  },
  {
    "dcode": "D",
    "dropkey": "G017657",
    "droptype": "D",
    "dropname": "KINGMAN",
    "dropdeladd": "1901 JOHNSON AVE",
    "dropdelcty": "KINGMAN",
    "dropdelst": "AZ",
    "dropdelzpp": 864019996,
    "dropphyadd": "1901 JOHNSON AVE",
    "dropphycty": "KINGMAN",
    "dropphyst": "AZ",
    "dropphyzpp": 864019996,
    "dropmaladd": "1901 JOHNSON AVE",
    "dropmalcty": "KINGMAN",
    "dropmalst": "AZ",
    "dropmalzpp": 864019996,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287538944,
    "dropsitcph": 9287532480,
    "dropfax": 9287533031
  },
  {
    "dcode": "D",
    "dropkey": "G017658",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "442 MILLER VALLEY RD",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "AZ",
    "dropdelzpp": 863019997,
    "dropphyadd": "442 MILLER VALLEY RD",
    "dropphycty": "PRESCOTT",
    "dropphyst": "AZ",
    "dropphyzpp": 863019997,
    "dropmaladd": "442 MILLER VALLEY RD",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "AZ",
    "dropmalzpp": 863019997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284458814,
    "dropsitcph": 9287781890,
    "dropfax": 9287781738
  },
  {
    "dcode": "D",
    "dropkey": "G017659",
    "droptype": "D",
    "dropname": "SHOW LOW",
    "dropdeladd": "191 W DEUCE OF CLUBS",
    "dropdelcty": "SHOW LOW",
    "dropdelst": "AZ",
    "dropdelzpp": 859019996,
    "dropphyadd": "191 W DEUCE OF CLUBS",
    "dropphycty": "SHOW LOW",
    "dropphyst": "AZ",
    "dropphyzpp": 859019996,
    "dropmaladd": "191 W DEUCE OF CLUBS",
    "dropmalcty": "SHOW LOW",
    "dropmalst": "AZ",
    "dropmalzpp": 859019996,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285371131,
    "dropsitcph": 9285374588,
    "dropfax": 9285378458
  },
  {
    "dcode": "D",
    "dropkey": "G017660",
    "droptype": "D",
    "dropname": "GLOBE",
    "dropdeladd": "1770 HIGHWAY 60-77",
    "dropdelcty": "GLOBE",
    "dropdelst": "AZ",
    "dropdelzpp": 855011432,
    "dropphyadd": "1770 HIGHWAY 60-77",
    "dropphycty": "GLOBE",
    "dropphyst": "AZ",
    "dropphyzpp": 855011432,
    "dropmaladd": "1770 HIGHWAY 60-77",
    "dropmalcty": "GLOBE",
    "dropmalst": "AZ",
    "dropmalzpp": 855011432,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284256950,
    "dropsitcph": 9284252381,
    "dropfax": 9284256953
  },
  {
    "dcode": "D",
    "dropkey": "G017661",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "300 N MAIN ST STE 100",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 526017800,
    "dropphyadd": "300 N MAIN ST STE 100",
    "dropphycty": "BURLINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 526017800,
    "dropmaladd": "300 N MAIN ST STE 100",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 526017800,
    "dropsitphn": 5152837530,
    "dropsitlph": "",
    "dropsitcph": 3197547581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017662",
    "droptype": "D",
    "dropname": "DECORAH",
    "dropdeladd": "401 HEIVLY ST",
    "dropdelcty": "DECORAH",
    "dropdelst": "IA",
    "dropdelzpp": 521013000,
    "dropphyadd": "401 HEIVLY ST",
    "dropphycty": "DECORAH",
    "dropphyst": "IA",
    "dropphyzpp": 521013000,
    "dropmaladd": "401 HEIVLY ST",
    "dropmalcty": "DECORAH",
    "dropmalst": "IA",
    "dropmalzpp": 521013000,
    "dropsitphn": 5152837530,
    "dropsitlph": "",
    "dropsitcph": 5633822903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017663",
    "droptype": "D",
    "dropname": "FORT DODGE",
    "dropdeladd": "3440 MAPLE DR",
    "dropdelcty": "FORT DODGE",
    "dropdelst": "IA",
    "dropdelzpp": 505019300,
    "dropphyadd": "3440 MAPLE DR",
    "dropphycty": "FORT DODGE",
    "dropphyst": "IA",
    "dropphyzpp": 505019300,
    "dropmaladd": "3440 MAPLE DR",
    "dropmalcty": "FORT DODGE",
    "dropmalst": "IA",
    "dropmalzpp": 505019300,
    "dropsitphn": 5152837530,
    "dropsitlph": "",
    "dropsitcph": 5155734130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017664",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "1613 IDAHO ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "ID",
    "dropdelzpp": 835019898,
    "dropphyadd": "1613 IDAHO ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "ID",
    "dropphyzpp": 835019898,
    "dropmaladd": "1613 IDAHO ST",
    "dropmalcty": "LEWISTON",
    "dropmalst": "ID",
    "dropmalzpp": 835019898,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087433476,
    "dropsitcph": 2087984929,
    "dropfax": 6514566199
  },
  {
    "dcode": "D",
    "dropkey": "G017665",
    "droptype": "D",
    "dropname": "TWIN FALLS",
    "dropdeladd": "1376 FILLMORE ST",
    "dropdelcty": "TWIN FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 833019997,
    "dropphyadd": "1376 FILLMORE ST",
    "dropphycty": "TWIN FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 833019997,
    "dropmaladd": "1376 FILLMORE ST",
    "dropmalcty": "TWIN FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 833019997,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087344903,
    "dropsitcph": 2087341452,
    "dropfax": 2087345587
  },
  {
    "dcode": "D",
    "dropkey": "G017666",
    "droptype": "D",
    "dropname": "GALESBURG",
    "dropdeladd": "476 E MAIN ST STE A",
    "dropdelcty": "GALESBURG",
    "dropdelst": "IL",
    "dropdelzpp": 614019997,
    "dropphyadd": "476 E MAIN ST STE A",
    "dropphycty": "GALESBURG",
    "dropphyst": "IL",
    "dropphyzpp": 614019997,
    "dropmaladd": "476 E MAIN ST STE A",
    "dropmalcty": "GALESBURG",
    "dropmalst": "IL",
    "dropmalzpp": 614019997,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3093426166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017667",
    "droptype": "D",
    "dropname": "KANKAKEE",
    "dropdeladd": "475 E COURT ST",
    "dropdelcty": "KANKAKEE",
    "dropdelst": "IL",
    "dropdelzpp": 609019980,
    "dropphyadd": "475 E COURT ST",
    "dropphycty": "KANKAKEE",
    "dropphyst": "IL",
    "dropphyzpp": 609019980,
    "dropmaladd": "475 E COURT ST",
    "dropmalcty": "KANKAKEE",
    "dropmalst": "IL",
    "dropmalzpp": 609019980,
    "dropsitphn": 8159357440,
    "dropsitlph": 8159357440,
    "dropsitcph": 8159357437,
    "dropfax": 8159326375
  },
  {
    "dcode": "D",
    "dropkey": "G017668",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "2950 CHARTRES ST",
    "dropdelcty": "LA SALLE",
    "dropdelst": "IL",
    "dropdelzpp": 613019997,
    "dropphyadd": "2950 CHARTRES ST",
    "dropphycty": "LA SALLE",
    "dropphyst": "IL",
    "dropphyzpp": 613019997,
    "dropmaladd": "2950 CHARTRES ST",
    "dropmalcty": "LA SALLE",
    "dropmalst": "IL",
    "dropmalzpp": 613019997,
    "dropsitphn": 8152232635,
    "dropsitlph": 7085637318,
    "dropsitcph": 8152232635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017669",
    "droptype": "D",
    "dropname": "FORT SCOTT",
    "dropdeladd": "120 S NATIONAL AVE",
    "dropdelcty": "FORT SCOTT",
    "dropdelst": "KS",
    "dropdelzpp": 667019997,
    "dropphyadd": "120 S NATIONAL AVE",
    "dropphycty": "FORT SCOTT",
    "dropphyst": "KS",
    "dropphyzpp": 667019997,
    "dropmaladd": "120 S NATIONAL AVE",
    "dropmalcty": "FORT SCOTT",
    "dropmalst": "KS",
    "dropmalzpp": 667019997,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 6202231410,
    "dropfax": 6505784613
  },
  {
    "dcode": "D",
    "dropkey": "G017670",
    "droptype": "D",
    "dropname": "HUTCHINSON",
    "dropdeladd": "128 E 1ST AVE",
    "dropdelcty": "HUTCHINSON",
    "dropdelst": "KS",
    "dropdelzpp": 675019900,
    "dropphyadd": "128 E 1ST AVE",
    "dropphycty": "HUTCHINSON",
    "dropphyst": "KS",
    "dropphyzpp": 675019900,
    "dropmaladd": "128 E 1ST AVE",
    "dropmalcty": "HUTCHINSON",
    "dropmalst": "KS",
    "dropmalzpp": 675019900,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 6206621295,
    "dropfax": 6206626156
  },
  {
    "dcode": "D",
    "dropkey": "G017671",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "116 E LAUREL ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "KS",
    "dropdelzpp": 673019900,
    "dropphyadd": "116 E LAUREL ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "KS",
    "dropphyzpp": 673019900,
    "dropmaladd": "116 E LAUREL ST",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "KS",
    "dropmalzpp": 673019900,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 6203310320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017672",
    "droptype": "D",
    "dropname": "LIBERAL",
    "dropdeladd": "25 E 5TH ST",
    "dropdelcty": "LIBERAL",
    "dropdelst": "KS",
    "dropdelzpp": 679019900,
    "dropphyadd": "25 E 5TH ST",
    "dropphycty": "LIBERAL",
    "dropphyst": "KS",
    "dropphyzpp": 679019900,
    "dropmaladd": "25 E 5TH ST",
    "dropmalcty": "LIBERAL",
    "dropmalst": "KS",
    "dropmalzpp": 679019900,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 6206244031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017673",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "1140 CARTER AVE",
    "dropdelcty": "ASHLAND",
    "dropdelst": "KY",
    "dropdelzpp": 411019995,
    "dropphyadd": "1140 CARTER AVE",
    "dropphycty": "ASHLAND",
    "dropphyst": "KY",
    "dropphyzpp": 411019995,
    "dropmaladd": "1140 CARTER AVE",
    "dropmalcty": "ASHLAND",
    "dropmalst": "KY",
    "dropmalzpp": 411019995,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063272139,
    "dropfax": 6063272137
  },
  {
    "dcode": "D",
    "dropkey": "G017674",
    "droptype": "D",
    "dropname": "WAREHAM ANNEX",
    "dropdeladd": "25 TOBEY RD",
    "dropdelcty": "WAREHAM",
    "dropdelst": "MA",
    "dropdelzpp": "025719701",
    "dropphyadd": "25 TOBEY RD",
    "dropphycty": "WAREHAM",
    "dropphyst": "MA",
    "dropphyzpp": "025719701",
    "dropmaladd": "25 TOBEY RD",
    "dropmalcty": "WAREHAM",
    "dropmalst": "MA",
    "dropmalzpp": "025719701",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082918700,
    "dropfax": 5082918700
  },
  {
    "dcode": "D",
    "dropkey": "G017675",
    "droptype": "D",
    "dropname": "FLINT",
    "dropdeladd": "250 E BOULEVARD DR",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485029997,
    "dropphyadd": "250 E BOULEVARD DR",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485029997,
    "dropmaladd": "250 E BOULEVARD DR",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485029997,
    "dropsitphn": 8102571567,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102571506,
    "dropfax": 8102571518
  },
  {
    "dcode": "D",
    "dropkey": "G017676",
    "droptype": "D",
    "dropname": "BRAINERD",
    "dropdeladd": "422 LAUREL ST",
    "dropdelcty": "BRAINERD",
    "dropdelst": "MN",
    "dropdelzpp": 564013104,
    "dropphyadd": "422 LAUREL ST",
    "dropphycty": "BRAINERD",
    "dropphyst": "MN",
    "dropphyzpp": 564013104,
    "dropmaladd": "422 LAUREL ST",
    "dropmalcty": "BRAINERD",
    "dropmalst": "MN",
    "dropmalzpp": 564013104,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188293101,
    "dropfax": 2188298690
  },
  {
    "dcode": "D",
    "dropkey": "G017677",
    "droptype": "D",
    "dropname": "DETROIT LAKES",
    "dropdeladd": "250 STATE ST W",
    "dropdelcty": "DETROIT LAKES",
    "dropdelst": "MN",
    "dropdelzpp": 565019997,
    "dropphyadd": "250 STATE ST W",
    "dropphycty": "DETROIT LAKES",
    "dropphyst": "MN",
    "dropphyzpp": 565019997,
    "dropmaladd": "250 STATE ST W",
    "dropmalcty": "DETROIT LAKES",
    "dropmalst": "MN",
    "dropmalzpp": 565019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 2188460285,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "G017678",
    "droptype": "D",
    "dropname": "WILLMAR",
    "dropdeladd": "401 TROTT AVE SW",
    "dropdelcty": "WILLMAR",
    "dropdelst": "MN",
    "dropdelzpp": 562019800,
    "dropphyadd": "401 TROTT AVE SW",
    "dropphycty": "WILLMAR",
    "dropphyst": "MN",
    "dropphyzpp": 562019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLMAR",
    "dropmalst": "MN",
    "dropmalzpp": 562019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202352472,
    "dropfax": 3202357942
  },
  {
    "dcode": "D",
    "dropkey": "G017679",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "401 S WASHINGTON ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "MO",
    "dropdelzpp": 646019911,
    "dropphyadd": "401 S WASHINGTON ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "MO",
    "dropphyzpp": 646019911,
    "dropmaladd": "401 S WASHINGTON ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "MO",
    "dropmalzpp": 646019911,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 6606461133,
    "dropfax": 6606464063
  },
  {
    "dcode": "D",
    "dropkey": "G017681",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "201 S 8TH ST",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MO",
    "dropdelzpp": 645019805,
    "dropphyadd": "201 S 8TH ST",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MO",
    "dropphyzpp": 645019805,
    "dropmaladd": "201 S 8TH ST",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MO",
    "dropmalzpp": 645019805,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 8163643231,
    "dropfax": 8163641926
  },
  {
    "dcode": "D",
    "dropkey": "G017682",
    "droptype": "D",
    "dropname": "DEVILS LAKE",
    "dropdeladd": "502 3RD ST NE",
    "dropdelcty": "DEVILS LAKE",
    "dropdelst": "ND",
    "dropdelzpp": 583019998,
    "dropphyadd": "502 3RD ST NE",
    "dropphycty": "DEVILS LAKE",
    "dropphyst": "ND",
    "dropphyzpp": 583019998,
    "dropmaladd": "502 3RD ST NE",
    "dropmalcty": "DEVILS LAKE",
    "dropmalst": "ND",
    "dropmalzpp": 583019998,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7016627132,
    "dropfax": 7016621126
  },
  {
    "dcode": "D",
    "dropkey": "G017683",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "212 2ND ST SW",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "ND",
    "dropdelzpp": 584019997,
    "dropphyadd": "212 2ND ST SW",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "ND",
    "dropphyzpp": 584019997,
    "dropmaladd": "212 2ND ST SW",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "ND",
    "dropmalzpp": 584019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7012523855,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "G017684",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "120 E BROADWAY",
    "dropdelcty": "WILLISTON",
    "dropdelst": "ND",
    "dropdelzpp": 588019998,
    "dropphyadd": "120 E BROADWAY",
    "dropphycty": "WILLISTON",
    "dropphyst": "ND",
    "dropphyzpp": 588019998,
    "dropmaladd": "120 E BROADWAY",
    "dropmalcty": "WILLISTON",
    "dropmalst": "ND",
    "dropmalzpp": 588019998,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7015722408,
    "dropfax": 7015729502
  },
  {
    "dcode": "D",
    "dropkey": "G017685",
    "droptype": "D",
    "dropname": "ALLIANCE",
    "dropdeladd": "401 BOX BUTTE AVE",
    "dropdelcty": "ALLIANCE",
    "dropdelst": "NE",
    "dropdelzpp": 693013309,
    "dropphyadd": "401 BOX BUTTE AVE",
    "dropphycty": "ALLIANCE",
    "dropphyst": "NE",
    "dropphyzpp": 693013309,
    "dropmaladd": "401 BOX BUTTE AVE",
    "dropmalcty": "ALLIANCE",
    "dropmalst": "NE",
    "dropmalzpp": 693013309,
    "dropsitphn": 3087623212,
    "dropsitlph": "",
    "dropsitcph": 3087623212,
    "dropfax": 3087625343
  },
  {
    "dcode": "D",
    "dropkey": "G017686",
    "droptype": "D",
    "dropname": "MC COOK",
    "dropdeladd": "411 W 3RD ST",
    "dropdelcty": "MC COOK",
    "dropdelst": "NE",
    "dropdelzpp": 690013610,
    "dropphyadd": "411 W 3RD ST",
    "dropphycty": "MC COOK",
    "dropphyst": "NE",
    "dropphyzpp": 690013610,
    "dropmaladd": "411 W 3RD ST",
    "dropmalcty": "MC COOK",
    "dropmalst": "NE",
    "dropmalzpp": 690013610,
    "dropsitphn": 3083456590,
    "dropsitlph": "",
    "dropsitcph": 3083456590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017687",
    "droptype": "D",
    "dropname": "VALENTINE",
    "dropdeladd": "239 N HALL ST",
    "dropdelcty": "VALENTINE",
    "dropdelst": "NE",
    "dropdelzpp": 692011819,
    "dropphyadd": "239 N HALL ST",
    "dropphycty": "VALENTINE",
    "dropphyst": "NE",
    "dropphyzpp": 692011819,
    "dropmaladd": "239 N HALL ST",
    "dropmalcty": "VALENTINE",
    "dropmalst": "NE",
    "dropmalzpp": 692011819,
    "dropsitphn": 4023761540,
    "dropsitlph": "",
    "dropsitcph": 4023761540,
    "dropfax": 4023761415
  },
  {
    "dcode": "D",
    "dropkey": "G017688",
    "droptype": "D",
    "dropname": "GALLUP",
    "dropdeladd": "500 S SECOND ST",
    "dropdelcty": "GALLUP",
    "dropdelst": "NM",
    "dropdelzpp": 873016248,
    "dropphyadd": "500 S SECOND ST",
    "dropphycty": "GALLUP",
    "dropphyst": "NM",
    "dropphyzpp": 873016248,
    "dropmaladd": "500 S SECOND ST",
    "dropmalcty": "GALLUP",
    "dropmalst": "NM",
    "dropmalzpp": 873016248,
    "dropsitphn": 5053468251,
    "dropsitlph": "",
    "dropsitcph": 5057225265,
    "dropfax": 5058639635
  },
  {
    "dcode": "D",
    "dropkey": "G017689",
    "droptype": "D",
    "dropname": "SOCORRO",
    "dropdeladd": "124 PLAZA ST",
    "dropdelcty": "SOCORRO",
    "dropdelst": "NM",
    "dropdelzpp": 878014577,
    "dropphyadd": "124 PLAZA ST",
    "dropphycty": "SOCORRO",
    "dropphyst": "NM",
    "dropphyzpp": 878014577,
    "dropmaladd": "124 PLAZA ST",
    "dropmalcty": "SOCORRO",
    "dropmalst": "NM",
    "dropmalzpp": 878014577,
    "dropsitphn": 5053468251,
    "dropsitlph": "",
    "dropsitcph": 5758350542,
    "dropfax": 5758358921
  },
  {
    "dcode": "D",
    "dropkey": "G017690",
    "droptype": "D",
    "dropname": "ELY",
    "dropdeladd": "2600 BRISTLECONE AVE",
    "dropdelcty": "ELY",
    "dropdelst": "NV",
    "dropdelzpp": 893019997,
    "dropphyadd": "2600 BRISTLECONE AVE",
    "dropphycty": "ELY",
    "dropphyst": "NV",
    "dropphyzpp": 893019997,
    "dropmaladd": "2600 BRISTLECONE AVE",
    "dropmalcty": "ELY",
    "dropmalst": "NV",
    "dropmalzpp": 893019997,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752899276,
    "dropfax": 7022892614
  },
  {
    "dcode": "D",
    "dropkey": "G017691",
    "droptype": "D",
    "dropname": "ELMIRA",
    "dropdeladd": "1580 SULLIVAN ST",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149019996,
    "dropphyadd": "1580 SULLIVAN ST",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149019996,
    "dropmaladd": "1580 SULLIVAN ST",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149019996,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077375116,
    "dropsitcph": 6077375108,
    "dropfax": 6077326207
  },
  {
    "dcode": "D",
    "dropkey": "G017692",
    "droptype": "D",
    "dropname": "GLENS FALLS",
    "dropdeladd": "16 HUDSON AVE",
    "dropdelcty": "GLENS FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 128019900,
    "dropphyadd": "16 HUDSON AVE",
    "dropphycty": "GLENS FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 128019900,
    "dropmaladd": "16 HUDSON AVE",
    "dropmalcty": "GLENS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128019900,
    "dropsitphn": 5187454525,
    "dropsitlph": "",
    "dropsitcph": 5187454525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017693",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "300 E 3RD ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 147019955,
    "dropphyadd": "300 E 3RD ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 147019955,
    "dropmaladd": "300 E 3RD ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 147019955,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166642133,
    "dropfax": 7164832576
  },
  {
    "dcode": "D",
    "dropkey": "G017694",
    "droptype": "D",
    "dropname": "STATEN ISLAND",
    "dropdeladd": "550 MANOR RD STE 8",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103149601,
    "dropphyadd": "550 MANOR RD STE 8",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103149601,
    "dropmaladd": "550 MANOR RD STE 8",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103149601,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7188162710,
    "dropfax": 7188162783
  },
  {
    "dcode": "D",
    "dropkey": "G017695",
    "droptype": "D",
    "dropname": "PIKEVILLE",
    "dropdeladd": "281 THOMPSON RD",
    "dropdelcty": "PIKEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 415019997,
    "dropphyadd": "281 THOMPSON RD",
    "dropphycty": "PIKEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 415019997,
    "dropmaladd": "281 THOMPSON RD",
    "dropmalcty": "PIKEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 415019997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064322146,
    "dropfax": 6064323372
  },
  {
    "dcode": "D",
    "dropkey": "G017696",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "232 COMMERCE PARK DR",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 136019900,
    "dropphyadd": "232 COMMERCE PARK DR",
    "dropphycty": "WATERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 136019900,
    "dropmaladd": "232 COMMERCE PARK DR",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 136019900,
    "dropsitphn": 3157865900,
    "dropsitlph": "",
    "dropsitcph": 3157865900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017697",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "200 N DIAMOND ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 449019997,
    "dropphyadd": "200 N DIAMOND ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 449019997,
    "dropmaladd": "200 N DIAMOND ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 449019997,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197554621,
    "dropfax": 4197554610
  },
  {
    "dcode": "D",
    "dropkey": "G017698",
    "droptype": "D",
    "dropname": "STEUBENVILLE",
    "dropdeladd": "150 N 3RD ST",
    "dropdelcty": "STEUBENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439529997,
    "dropphyadd": "150 N 3RD ST",
    "dropphycty": "STEUBENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439529997,
    "dropmaladd": "150 N 3RD ST",
    "dropmalcty": "STEUBENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439529997,
    "dropsitphn": 3309969797,
    "dropsitlph": "",
    "dropsitcph": 7402826221,
    "dropfax": 7402826681
  },
  {
    "dcode": "D",
    "dropkey": "G017699",
    "droptype": "D",
    "dropname": "ZANESVILLE",
    "dropdeladd": "900 MCINTIRE AVE",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437019997,
    "dropphyadd": "900 MCINTIRE AVE",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437019997,
    "dropmaladd": "900 MCINTIRE AVE",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437019997,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 7404552802,
    "dropfax": 7404552851
  },
  {
    "dcode": "D",
    "dropkey": "G017700",
    "droptype": "D",
    "dropname": "DU BOIS",
    "dropdeladd": "229 BEAVER DR",
    "dropdelcty": "DU BOIS",
    "dropdelst": "PA",
    "dropdelzpp": 158019700,
    "dropphyadd": "229 BEAVER DR",
    "dropphycty": "DU BOIS",
    "dropphyst": "PA",
    "dropphyzpp": 158019700,
    "dropmaladd": "229 BEAVER DR",
    "dropmalcty": "DU BOIS",
    "dropmalst": "PA",
    "dropmalzpp": 158019700,
    "dropsitphn": 8148367307,
    "dropsitlph": "",
    "dropsitcph": 8143715530,
    "dropfax": 8143719209
  },
  {
    "dcode": "D",
    "dropkey": "G017701",
    "droptype": "D",
    "dropname": "OIL CITY",
    "dropdeladd": "302 E 2ND ST",
    "dropdelcty": "OIL CITY",
    "dropdelst": "PA",
    "dropdelzpp": 163019700,
    "dropphyadd": "302 E 2ND ST",
    "dropphycty": "OIL CITY",
    "dropphyst": "PA",
    "dropphyzpp": 163019700,
    "dropmaladd": "302 E 2ND ST",
    "dropmalcty": "OIL CITY",
    "dropmalst": "PA",
    "dropmalzpp": 163019700,
    "dropsitphn": 8148367307,
    "dropsitlph": "",
    "dropsitcph": 8146771266,
    "dropfax": 8146763279
  },
  {
    "dcode": "D",
    "dropkey": "G017702",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "417 W 7TH ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "TN",
    "dropdelzpp": 384019929,
    "dropphyadd": "417 W 7TH ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "TN",
    "dropphyzpp": 384019929,
    "dropmaladd": "417 W 7TH ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "TN",
    "dropmalzpp": 384019929,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313817150,
    "dropsitcph": 9313886161,
    "dropfax": 9313812997
  },
  {
    "dcode": "D",
    "dropkey": "G017703",
    "droptype": "D",
    "dropname": "COOKEVILLE",
    "dropdeladd": "900 S WILLOW AVE",
    "dropdelcty": "COOKEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385019923,
    "dropphyadd": "900 S WILLOW AVE",
    "dropphycty": "COOKEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385019923,
    "dropmaladd": "900 S WILLOW AVE",
    "dropmalcty": "COOKEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385019923,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315262107,
    "dropsitcph": 9315267141,
    "dropfax": 9315262316
  },
  {
    "dcode": "D",
    "dropkey": "G017704",
    "droptype": "D",
    "dropname": "MC KENZIE",
    "dropdeladd": "15075 HIGHLAND DR",
    "dropdelcty": "MC KENZIE",
    "dropdelst": "TN",
    "dropdelzpp": 382019909,
    "dropphyadd": "15075 HIGHLAND DR",
    "dropphycty": "MC KENZIE",
    "dropphyst": "TN",
    "dropphyzpp": 382019909,
    "dropmaladd": "15075 HIGHLAND DR",
    "dropmalcty": "MC KENZIE",
    "dropmalst": "TN",
    "dropmalzpp": 382019909,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7313527977,
    "dropfax": 7313520709
  },
  {
    "dcode": "D",
    "dropkey": "G017706",
    "droptype": "D",
    "dropname": "LYNCHBURG",
    "dropdeladd": "3300 ODD FELLOWS RD",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245069997,
    "dropphyadd": "3300 ODD FELLOWS RD",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245069997,
    "dropmaladd": "3300 ODD FELLOWS RD",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245069997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345288995,
    "dropfax": 4345288910
  },
  {
    "dcode": "D",
    "dropkey": "G017707",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "215 W CONANT ST",
    "dropdelcty": "PORTAGE",
    "dropdelst": "WI",
    "dropdelzpp": 539019997,
    "dropphyadd": "215 W CONANT ST",
    "dropphycty": "PORTAGE",
    "dropphyst": "WI",
    "dropphyzpp": 539019997,
    "dropmaladd": "215 W CONANT ST",
    "dropmalcty": "PORTAGE",
    "dropmalst": "WI",
    "dropmalzpp": 539019997,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 6087425012,
    "dropfax": 6087428669
  },
  {
    "dcode": "D",
    "dropkey": "G017709",
    "droptype": "D",
    "dropname": "RHINELANDER",
    "dropdeladd": "156 S COURTNEY ST",
    "dropdelcty": "RHINELANDER",
    "dropdelst": "WI",
    "dropdelzpp": 545019997,
    "dropphyadd": "156 S COURTNEY ST",
    "dropphycty": "RHINELANDER",
    "dropphyst": "WI",
    "dropphyzpp": 545019997,
    "dropmaladd": "156 S COURTNEY ST",
    "dropmalcty": "RHINELANDER",
    "dropmalst": "WI",
    "dropmalzpp": 545019997,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 7153696813,
    "dropfax": 7153697319
  },
  {
    "dcode": "D",
    "dropkey": "G017710",
    "droptype": "D",
    "dropname": "BECKLEY",
    "dropdeladd": "134 INDUSTRIAL DR",
    "dropdelcty": "BECKLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258019988,
    "dropphyadd": "134 INDUSTRIAL DR",
    "dropphycty": "BECKLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258019988,
    "dropmaladd": "134 INDUSTRIAL DR",
    "dropmalcty": "BECKLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258019988,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042525336,
    "dropfax": 3042529438
  },
  {
    "dcode": "D",
    "dropkey": "G017711",
    "droptype": "D",
    "dropname": "BLUEFIELD",
    "dropdeladd": "3010 E CUMBERLAND RD",
    "dropdelcty": "BLUEFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 247019997,
    "dropphyadd": "3010 E CUMBERLAND RD",
    "dropphycty": "BLUEFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 247019997,
    "dropmaladd": "3010 E CUMBERLAND RD",
    "dropmalcty": "BLUEFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 247019997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043259196,
    "dropfax": 3043256165
  },
  {
    "dcode": "D",
    "dropkey": "G017712",
    "droptype": "D",
    "dropname": "GLENWOOD SPRINGS",
    "dropdeladd": "113 9TH ST",
    "dropdelcty": "GLENWOOD SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 816019997,
    "dropphyadd": "113 9TH ST",
    "dropphycty": "GLENWOOD SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 816019997,
    "dropmaladd": "113 9TH ST",
    "dropmalcty": "GLENWOOD SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 816019997,
    "dropsitphn": 3038536511,
    "dropsitlph": "",
    "dropsitcph": 9709452701,
    "dropfax": 9709280945
  },
  {
    "dcode": "D",
    "dropkey": "G017713",
    "droptype": "D",
    "dropname": "GASSAWAY",
    "dropdeladd": "400 ELK ST",
    "dropdelcty": "GASSAWAY",
    "dropdelst": "WV",
    "dropdelzpp": 266249997,
    "dropphyadd": "400 ELK ST",
    "dropphycty": "GASSAWAY",
    "dropphyst": "WV",
    "dropphyzpp": 266249997,
    "dropmaladd": "400 ELK ST",
    "dropmalcty": "GASSAWAY",
    "dropmalst": "WV",
    "dropmalzpp": 266249997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043642291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017714",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "1000 VIRGINIA AVE W",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257049997,
    "dropphyadd": "1000 VIRGINIA AVE W",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257049997,
    "dropmaladd": "1000 VIRGINIA AVE W",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257049997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045269600,
    "dropfax": 3045269612
  },
  {
    "dcode": "D",
    "dropkey": "G017716",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "1 POSTAL SQ",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 268479997,
    "dropphyadd": "1 POSTAL SQ",
    "dropphycty": "PETERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 268479997,
    "dropmaladd": "1 POSTAL SQ",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 268479997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042574344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017717",
    "droptype": "D",
    "dropname": "GILLETTE",
    "dropdeladd": "311 S KENDRICK AVE",
    "dropdelcty": "GILLETTE",
    "dropdelst": "WY",
    "dropdelzpp": 827169997,
    "dropphyadd": "311 S KENDRICK AVE",
    "dropphycty": "GILLETTE",
    "dropphyst": "WY",
    "dropphyzpp": 827169997,
    "dropmaladd": "311 S KENDRICK AVE",
    "dropmalcty": "GILLETTE",
    "dropmalst": "WY",
    "dropmalzpp": 827169997,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3076823727,
    "dropfax": 3076872818
  },
  {
    "dcode": "D",
    "dropkey": "G017718",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "501 E MAIN ST",
    "dropdelcty": "RIVERTON",
    "dropdelst": "WY",
    "dropdelzpp": 825019996,
    "dropphyadd": "501 E MAIN ST",
    "dropphycty": "RIVERTON",
    "dropphyst": "WY",
    "dropphyzpp": 825019996,
    "dropmaladd": "501 E MAIN ST",
    "dropmalcty": "RIVERTON",
    "dropmalst": "WY",
    "dropmalzpp": 825019996,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3078563725,
    "dropfax": 3078569033
  },
  {
    "dcode": "D",
    "dropkey": "G017719",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "101 E LOUCKS ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "WY",
    "dropdelzpp": 828019997,
    "dropphyadd": "101 E LOUCKS ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "WY",
    "dropphyzpp": 828019997,
    "dropmaladd": "101 E LOUCKS ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "WY",
    "dropmalzpp": 828019997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076723430,
    "dropsitcph": 3076720714,
    "dropfax": 3076723292
  },
  {
    "dcode": "D",
    "dropkey": "G017720",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "852 WALNUT ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "WY",
    "dropdelzpp": 822019997,
    "dropphyadd": "852 WALNUT ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "WY",
    "dropphyzpp": 822019997,
    "dropmaladd": "852 WALNUT ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "WY",
    "dropmalzpp": 822019997,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3073223287,
    "dropfax": 3073225930
  },
  {
    "dcode": "D",
    "dropkey": "G017721",
    "droptype": "D",
    "dropname": "WORLAND",
    "dropdeladd": "119 N 7TH ST",
    "dropdelcty": "WORLAND",
    "dropdelst": "WY",
    "dropdelzpp": 824019997,
    "dropphyadd": "119 N 7TH ST",
    "dropphycty": "WORLAND",
    "dropphyst": "WY",
    "dropphyzpp": 824019997,
    "dropmaladd": "119 N 7TH ST",
    "dropmalcty": "WORLAND",
    "dropmalst": "WY",
    "dropmalzpp": 824019997,
    "dropsitphn": 3077726524,
    "dropsitlph": "",
    "dropsitcph": 3073473321,
    "dropfax": 3073472142
  },
  {
    "dcode": "D",
    "dropkey": "G017722",
    "droptype": "D",
    "dropname": "SPOONER",
    "dropdeladd": "422 N FRONT ST",
    "dropdelcty": "SPOONER",
    "dropdelst": "WI",
    "dropdelzpp": 548019910,
    "dropphyadd": "422 N FRONT ST",
    "dropphycty": "SPOONER",
    "dropphyst": "WI",
    "dropphyzpp": 548019910,
    "dropmaladd": "422 N FRONT ST",
    "dropmalcty": "SPOONER",
    "dropmalst": "WI",
    "dropmalzpp": 548019910,
    "dropsitphn": 6123499163,
    "dropsitlph": 7156357919,
    "dropsitcph": 7156356919,
    "dropfax": 7156356813
  },
  {
    "dcode": "D",
    "dropkey": "G017724",
    "droptype": "D",
    "dropname": "SOUTH BEND",
    "dropdeladd": "424 S MICHIGAN ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466019997,
    "dropphyadd": "424 S MICHIGAN ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466019997,
    "dropmaladd": "424 S MICHIGAN ST",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466019997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828413,
    "dropfax": 5742828411
  },
  {
    "dcode": "D",
    "dropkey": "G017725",
    "droptype": "D",
    "dropname": "SOUTHERN CT",
    "dropdeladd": "24 RESEARCH PKWY",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929051",
    "dropphyadd": "24 RESEARCH PKWY",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929051",
    "dropmaladd": "24 RESEARCH PKWY",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929051",
    "dropsitphn": 2039493040,
    "dropsitlph": 2039493157,
    "dropsitcph": 2039493105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G017727",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "238 S PENNSYLVANIA AVE",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156019924,
    "dropphyadd": "238 S PENNSYLVANIA AVE",
    "dropphycty": "GREENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156019924,
    "dropmaladd": "238 S PENNSYLVANIA AVE",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156019924,
    "dropsitphn": 4123597568,
    "dropsitlph": "",
    "dropsitcph": 7248374187,
    "dropfax": 7248376139
  },
  {
    "dcode": "D",
    "dropkey": "G017752",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "2108 E 38TH ST",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165159987,
    "dropphyadd": "2108 E 38TH ST",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165159987,
    "dropmaladd": "2108 E 38TH ST",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165159987,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148987340,
    "dropsitcph": 8148987364,
    "dropfax": 8148987303
  },
  {
    "dcode": "D",
    "dropkey": "G017834",
    "droptype": "D",
    "dropname": "PARKERSBURG",
    "dropdeladd": "400 RAYON DR",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261019908,
    "dropphyadd": "400 RAYON DR",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261019908,
    "dropmaladd": "400 RAYON DR",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261019908,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044857771,
    "dropfax": 3044850724
  },
  {
    "dcode": "D",
    "dropkey": "G018242",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "1445 VALLEYHIGH DR NW",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559010765,
    "dropphyadd": "1445 VALLEYHIGH DR NW",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559010765,
    "dropmaladd": "1445 VALLEYHIGH DR NW",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559010765,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516812544,
    "dropsitcph": 5072871268,
    "dropfax": 5072871274
  },
  {
    "dcode": "D",
    "dropkey": "G018630",
    "droptype": "D",
    "dropname": "VALDOSTA",
    "dropdeladd": "3698 INNER PERIMETER RD",
    "dropdelcty": "VALDOSTA",
    "dropdelst": "GA",
    "dropdelzpp": 316029996,
    "dropphyadd": "3698 INNER PERIMETER RD",
    "dropphycty": "VALDOSTA",
    "dropphyst": "GA",
    "dropphyzpp": 316029996,
    "dropmaladd": "3698 INNER PERIMETER RD",
    "dropmalcty": "VALDOSTA",
    "dropmalst": "GA",
    "dropmalzpp": 316029996,
    "dropsitphn": 4787528466,
    "dropsitlph": "",
    "dropsitcph": 2292417209,
    "dropfax": 2292418702
  },
  {
    "dcode": "D",
    "dropkey": "G019675",
    "droptype": "D",
    "dropname": "THIBODAUX",
    "dropdeladd": "910 CANAL BLVD",
    "dropdelcty": "THIBODAUX",
    "dropdelst": "LA",
    "dropdelzpp": 703019996,
    "dropphyadd": "910 CANAL BLVD",
    "dropphycty": "THIBODAUX",
    "dropphyst": "LA",
    "dropphyzpp": 703019996,
    "dropmaladd": "910 CANAL BLVD",
    "dropmalcty": "THIBODAUX",
    "dropmalst": "LA",
    "dropmalzpp": 703019996,
    "dropsitphn": 5045891255,
    "dropsitlph": "",
    "dropsitcph": 9854466932,
    "dropfax": 9854473739
  },
  {
    "dcode": "D",
    "dropkey": "G020714",
    "droptype": "D",
    "dropname": "KAHULUI",
    "dropdeladd": "105 AALELE ST",
    "dropdelcty": "KAHULUI",
    "dropdelst": "HI",
    "dropdelzpp": 967329997,
    "dropphyadd": "105 AALELE ST",
    "dropphycty": "KAHULUI",
    "dropphyst": "HI",
    "dropphyzpp": 967329997,
    "dropmaladd": "105 AALELE ST",
    "dropmalcty": "KAHULUI",
    "dropmalst": "HI",
    "dropmalzpp": 967329997,
    "dropsitphn": 8082141627,
    "dropsitlph": "",
    "dropsitcph": 8088779479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G020892",
    "droptype": "D",
    "dropname": "OTTUMWA",
    "dropdeladd": "616 W 2ND ST",
    "dropdelcty": "OTTUMWA",
    "dropdelst": "IA",
    "dropdelzpp": 525019936,
    "dropphyadd": "616 W 2ND ST",
    "dropphycty": "OTTUMWA",
    "dropphyst": "IA",
    "dropphyzpp": 525019936,
    "dropmaladd": "616 W 2ND ST",
    "dropmalcty": "OTTUMWA",
    "dropmalst": "IA",
    "dropmalzpp": 525019936,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416844591,
    "dropsitcph": 6416845439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "G021276",
    "droptype": "D",
    "dropname": "MANKATO",
    "dropdeladd": "851 SUMMIT AVE",
    "dropdelcty": "MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560019820,
    "dropphyadd": "851 SUMMIT AVE",
    "dropphycty": "MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560019820,
    "dropmaladd": "851 SUMMIT AVE",
    "dropmalcty": "MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560019820,
    "dropsitphn": 6123499163,
    "dropsitlph": 5076257527,
    "dropsitcph": 5076252320,
    "dropfax": 5073886851
  },
  {
    "dcode": "D",
    "dropkey": "G021277",
    "droptype": "D",
    "dropname": "WINDOM",
    "dropdeladd": "445 9TH ST",
    "dropdelcty": "WINDOM",
    "dropdelst": "MN",
    "dropdelzpp": 561011782,
    "dropphyadd": "445 9TH ST",
    "dropphycty": "WINDOM",
    "dropphyst": "MN",
    "dropphyzpp": 561011782,
    "dropmaladd": "445 9TH ST",
    "dropmalcty": "WINDOM",
    "dropmalst": "MN",
    "dropmalzpp": 561011782,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 5078312595,
    "dropfax": 5078312206
  },
  {
    "dcode": "D",
    "dropkey": "KV12343",
    "droptype": "B",
    "dropname": "BUFFALO ASF",
    "dropdeladd": "1200 WILLIAM ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142409701,
    "dropphyadd": "1200 WILLIAM ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142409701,
    "dropmaladd": "1200 WILLIAM ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142409701,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168462333,
    "dropfax": 7168462396
  },
  {
    "dcode": "D",
    "dropkey": "KW1B108",
    "droptype": "B",
    "dropname": "SIOUX FALLS ASF",
    "dropdeladd": "4801 N 4TH AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571049302,
    "dropphyadd": "4801 N 4TH AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571049302,
    "dropmaladd": "4801 N 4TH AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571049302,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053574932,
    "dropsitcph": 6053574954,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "KZ10746",
    "droptype": "B",
    "dropname": "PHOENIX ASF",
    "dropdeladd": "4949 E VAN BUREN ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850269672,
    "dropphyadd": "4949 E VAN BUREN ST RM 49",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850269816,
    "dropmaladd": "4949 E VAN BUREN ST RM 49",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850269816,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022253214,
    "dropsitcph": 6022253491,
    "dropfax": 6022253944
  },
  {
    "dcode": "D",
    "dropkey": "KZ13045",
    "droptype": "B",
    "dropname": "BILLINGS ASF",
    "dropdeladd": "841 S 26TH ST",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591014566,
    "dropphyadd": "841 S 26TH ST",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591014566,
    "dropmaladd": "841 S 26TH ST",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591014566,
    "dropsitphn": 4066575601,
    "dropsitlph": 4066575780,
    "dropsitcph": 4066575780,
    "dropfax": 4066575788
  },
  {
    "dcode": "D",
    "dropkey": "K004524",
    "droptype": "D",
    "dropname": "ATLANTA NDC ANNEX",
    "dropdeladd": "125 VILLANOVA DR SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303782507,
    "dropphyadd": "125 VILLANOVA DR SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303782507,
    "dropmaladd": "125 VILLANOVA DR SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303782507,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4043445661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K010814",
    "droptype": "D",
    "dropname": "CHICAGO IL MPA",
    "dropdeladd": "7506 ROOSEVELT RD",
    "dropdelcty": "FOREST PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601302486,
    "dropphyadd": "7506 ROOSEVELT RD",
    "dropphycty": "FOREST PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601302486,
    "dropmaladd": "7506 ROOSEVELT RD",
    "dropmalcty": "FOREST PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601302486,
    "dropsitphn": 7085834294,
    "dropsitlph": "",
    "dropsitcph": 7085834200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K011881",
    "droptype": "B",
    "dropname": "OKLAHOMA CITY ASF",
    "dropdeladd": "4025 W RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731259404,
    "dropphyadd": "4025 W RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731259404,
    "dropmaladd": "4025 W RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731259404,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055535832,
    "dropsitcph": 4058152711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K019283",
    "droptype": "D",
    "dropname": "CINCINNATI NDC PEAK ANNEX",
    "dropdeladd": "3571 CONCORDE DR BLDG 2",
    "dropdelcty": "VANDALIA",
    "dropdelst": "OH",
    "dropdelzpp": 453773325,
    "dropphyadd": "3571 CONCORDE DR BLDG 2",
    "dropphycty": "VANDALIA",
    "dropphyst": "OH",
    "dropphyzpp": 453773325,
    "dropmaladd": "3571 CONCORDE DR BLDG 2",
    "dropmalcty": "VANDALIA",
    "dropmalst": "OH",
    "dropmalzpp": 453773325,
    "dropsitphn": 5137337008,
    "dropsitlph": "",
    "dropsitcph": 5137337261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX25496",
    "droptype": "S",
    "dropname": "MEMPHIS",
    "dropdeladd": "555 S B B KING BLVD LBBY",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381017500,
    "dropphyadd": "555 S B B KING BLVD LBBY",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381017500,
    "dropmaladd": "555 S B B KING BLVD LBBY",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381017500,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212182,
    "dropsitcph": 9015212245,
    "dropfax": 9015212177
  },
  {
    "dcode": "D",
    "dropkey": "EW1B336",
    "droptype": "S",
    "dropname": "CHEYENNE",
    "dropdeladd": "4800 CONVERSE AVE",
    "dropdelcty": "CHEYENNE",
    "dropdelst": "WY",
    "dropdelzpp": 820099997,
    "dropphyadd": "4800 CONVERSE AVE",
    "dropphycty": "CHEYENNE",
    "dropphyst": "WY",
    "dropphyzpp": 820099997,
    "dropmaladd": "4800 CONVERSE AVE",
    "dropmalcty": "CHEYENNE",
    "dropmalst": "WY",
    "dropmalzpp": 820099997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077726504,
    "dropsitcph": 3077726511,
    "dropfax": 3077726532
  },
  {
    "dcode": "D",
    "dropkey": "KX25497",
    "droptype": "B",
    "dropname": "MEMPHIS NDC",
    "dropdeladd": "1921 ELVIS PRESLEY BLVD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381369997,
    "dropphyadd": "1921 ELVIS PRESLEY BLVD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381369997,
    "dropmaladd": "1921 ELVIS PRESLEY BLVD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381369997,
    "dropsitphn": 9019477675,
    "dropsitlph": "",
    "dropsitcph": 9019477675,
    "dropfax": 9019477678
  },
  {
    "dcode": "D",
    "dropkey": "EW1B333",
    "droptype": "S",
    "dropname": "CASPER",
    "dropdeladd": "411 N FOREST DR",
    "dropdelcty": "CASPER",
    "dropdelst": "WY",
    "dropdelzpp": 826099997,
    "dropphyadd": "411 N FOREST DR",
    "dropphycty": "CASPER",
    "dropphyst": "WY",
    "dropphyzpp": 826099997,
    "dropmaladd": "411 N FOREST DR",
    "dropmalcty": "CASPER",
    "dropmalst": "WY",
    "dropmalzpp": 826099997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072664034,
    "dropsitcph": 3072378556,
    "dropfax": 3072660133
  },
  {
    "dcode": "D",
    "dropkey": "EZ10013",
    "droptype": "S",
    "dropname": "ANCHORAGE",
    "dropdeladd": "4141 POSTMARK DR",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995301002,
    "dropphyadd": "4141 POSTMARK DR",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995301002,
    "dropmaladd": "4141 POSTMARK DR",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995301002,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072663261,
    "dropsitcph": 9072663261,
    "dropfax": 9072663161
  },
  {
    "dcode": "D",
    "dropkey": "EX28291",
    "droptype": "S",
    "dropname": "CHARLESTON",
    "dropdeladd": "1000 CENTRE WAY",
    "dropdelcty": "SOUTH CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253099426,
    "dropphyadd": "1000 CENTRE WAY",
    "dropphycty": "SOUTH CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253099426,
    "dropmaladd": "PO BOX 59701",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253509701,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047465001,
    "dropfax": 3047465149
  },
  {
    "dcode": "D",
    "dropkey": "EY18274",
    "droptype": "D",
    "dropname": "WAUSAU",
    "dropdeladd": "400 CRESKE AVE",
    "dropdelcty": "ROTHSCHILD",
    "dropdelst": "WI",
    "dropdelzpp": 544747955,
    "dropphyadd": "400 CRESKE AVE",
    "dropphycty": "ROTHSCHILD",
    "dropphyst": "WI",
    "dropphyzpp": 544747955,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "WAUSAU",
    "dropmalst": "WI",
    "dropmalzpp": 544029996,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152413800,
    "dropsitcph": 7182413800,
    "dropfax": 7152413825
  },
  {
    "dcode": "D",
    "dropkey": "EY17792",
    "droptype": "D",
    "dropname": "OSHKOSH",
    "dropdeladd": "1025 W 20TH AVE",
    "dropdelcty": "OSHKOSH",
    "dropdelst": "WI",
    "dropdelzpp": 549039997,
    "dropphyadd": "1025 W 20TH AVE",
    "dropphycty": "OSHKOSH",
    "dropphyst": "WI",
    "dropphyzpp": 549039997,
    "dropmaladd": "1025 W 20TH AVE",
    "dropmalcty": "OSHKOSH",
    "dropmalst": "WI",
    "dropmalzpp": 549039997,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202360201,
    "dropsitcph": 9202360625,
    "dropfax": 9202360211
  },
  {
    "dcode": "D",
    "dropkey": "EY17679",
    "droptype": "S",
    "dropname": "MILWAUKEE",
    "dropdeladd": "345 W SAINT PAUL AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532033017,
    "dropphyadd": "345 W SAINT PAUL AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532033017,
    "dropmaladd": "PO BOX 5066",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532015066,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702066,
    "dropsitcph": 4142702350,
    "dropfax": 4142702022
  },
  {
    "dcode": "D",
    "dropkey": "EY18537",
    "droptype": "D",
    "dropname": "MILWAUKEE PRIORITY ANNEX",
    "dropdeladd": "7620 S 10TH ST",
    "dropdelcty": "OAK CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 531541912,
    "dropphyadd": "7620 S 10TH ST",
    "dropphycty": "OAK CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 531541912,
    "dropmaladd": "7620 S 10TH ST",
    "dropmalcty": "OAK CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 531541912,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702313,
    "dropsitcph": 4145707710,
    "dropfax": 4145707724
  },
  {
    "dcode": "D",
    "dropkey": "EY17610",
    "droptype": "S",
    "dropname": "MADISON",
    "dropdeladd": "3902 MILWAUKEE ST",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537149998,
    "dropphyadd": "3902 MILWAUKEE ST",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537143000,
    "dropmaladd": "PO BOX 7990",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537077990,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082461284,
    "dropsitcph": 6082461222,
    "dropfax": 6082461313
  },
  {
    "dcode": "D",
    "dropkey": "EY10113",
    "droptype": "S",
    "dropname": "BIRMINGHAM",
    "dropdeladd": "351 24TH ST N RM 210",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352039811,
    "dropphyadd": "351 24TH ST N RM 210",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352039811,
    "dropmaladd": "351 24TH ST N RM 210",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352039811,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2055210260,
    "dropfax": 2055212650
  },
  {
    "dcode": "D",
    "dropkey": "EY17374",
    "droptype": "S",
    "dropname": "GREEN BAY",
    "dropdeladd": "300 PACKERLAND DR",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "WI",
    "dropdelzpp": 543039996,
    "dropphyadd": "300 PACKERLAND DR",
    "dropphycty": "GREEN BAY",
    "dropphyst": "WI",
    "dropphyzpp": 543039996,
    "dropmaladd": "PO BOX 7003",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "WI",
    "dropmalzpp": 543077003,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204983885,
    "dropsitcph": 9204983833,
    "dropfax": 9204983834
  },
  {
    "dcode": "D",
    "dropkey": "EY17229",
    "droptype": "S",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "3510 HOGARTH ST",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "WI",
    "dropdelzpp": 547039997,
    "dropphyadd": "3510 HOGARTH ST",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "WI",
    "dropphyzpp": 547039997,
    "dropmaladd": "3510 HOGARTH ST",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "WI",
    "dropmalzpp": 547039997,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 7158336785,
    "dropfax": 7158305752
  },
  {
    "dcode": "D",
    "dropkey": "E003325",
    "droptype": "D",
    "dropname": "BIRMINGHAM ANNEX",
    "dropdeladd": "4500 1ST AVE S",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352222111,
    "dropphyadd": "4500 1ST AVE S",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352222111,
    "dropmaladd": "4500 1ST AVE S",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352222111,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2055928852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ17763",
    "droptype": "S",
    "dropname": "YAKIMA",
    "dropdeladd": "205 W WASHINGTON AVE",
    "dropdelcty": "YAKIMA",
    "dropdelst": "WA",
    "dropdelzpp": 989039995,
    "dropphyadd": "205 W WASHINGTON AVE",
    "dropphycty": "YAKIMA",
    "dropphyst": "WA",
    "dropphyzpp": 989039995,
    "dropmaladd": "205 W WASHINGTON AVE",
    "dropmalcty": "YAKIMA",
    "dropmalst": "WA",
    "dropmalzpp": 989039995,
    "dropsitphn": 2063816600,
    "dropsitlph": 2065210449,
    "dropsitcph": 5094542455,
    "dropfax": 5094542474
  },
  {
    "dcode": "D",
    "dropkey": "EY10631",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "3408 WALL TRIANA HWY",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358131001,
    "dropphyadd": "3408 WALL TRIANA HWY",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358131001,
    "dropmaladd": "3408 WALL TRIANA HWY",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358131001,
    "dropsitphn": 2567724691,
    "dropsitlph": 2567724691,
    "dropsitcph": 2567724691,
    "dropfax": 2564617885
  },
  {
    "dcode": "D",
    "dropkey": "EZ17710",
    "droptype": "S",
    "dropname": "WENATCHEE",
    "dropdeladd": "3075 OHME RD",
    "dropdelcty": "WENATCHEE",
    "dropdelst": "WA",
    "dropdelzpp": 988019997,
    "dropphyadd": "3075 OHME RD",
    "dropphycty": "WENATCHEE",
    "dropphyst": "WA",
    "dropphyzpp": 988019997,
    "dropmaladd": "3075 OHME RD",
    "dropmalcty": "WENATCHEE",
    "dropmalst": "WA",
    "dropmalzpp": 988019997,
    "dropsitphn": 2063816600,
    "dropsitlph": 5096674634,
    "dropsitcph": 5096674665,
    "dropfax": 5096674668
  },
  {
    "dcode": "D",
    "dropkey": "EZ17596",
    "droptype": "S",
    "dropname": "TACOMA",
    "dropdeladd": "4001 S PINE ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984139997,
    "dropphyadd": "4001 S PINE ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984139997,
    "dropmaladd": "4001 S PINE ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984139997,
    "dropsitphn": 2534715952,
    "dropsitlph": 2534715852,
    "dropsitcph": 2534716035,
    "dropfax": 2534716007
  },
  {
    "dcode": "D",
    "dropkey": "EZ17490",
    "droptype": "S",
    "dropname": "SPOKANE",
    "dropdeladd": "2928 S SPOTTED RD",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992249997,
    "dropphyadd": "2928 S SPOTTED RD",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992249997,
    "dropmaladd": "2928 S SPOTTED RD",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992249997,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094590205,
    "dropsitcph": 5093636210,
    "dropfax": 5093636006
  },
  {
    "dcode": "D",
    "dropkey": "EY10806",
    "droptype": "S",
    "dropname": "MOBILE",
    "dropdeladd": "4538 SHIPYARD RD",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366759998,
    "dropphyadd": "4538 SHIPYARD RD",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366759998,
    "dropmaladd": "4538 SHIPYARD RD",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366759998,
    "dropsitphn": 2516021708,
    "dropsitlph": 2516021708,
    "dropsitcph": 2516021708,
    "dropfax": 2516021700
  },
  {
    "dcode": "D",
    "dropkey": "J008251",
    "droptype": "D",
    "dropname": "SEATTLE PRIORITY MAIL ANNEX",
    "dropdeladd": "22430 RUSSELL RD",
    "dropdelcty": "KENT",
    "dropdelst": "WA",
    "dropdelzpp": 980324894,
    "dropphyadd": "22430 RUSSELL RD",
    "dropphycty": "KENT",
    "dropphyst": "WA",
    "dropphyzpp": 980324894,
    "dropmaladd": "22430 RUSSELL RD",
    "dropmalcty": "KENT",
    "dropmalst": "WA",
    "dropmalzpp": 980324894,
    "dropsitphn": 2067684422,
    "dropsitlph": "",
    "dropsitcph": 2534372198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "KZ17428",
    "droptype": "B",
    "dropname": "SEATTLE NDC",
    "dropdeladd": "34301 9TH AVE S",
    "dropdelcty": "FEDERAL WAY",
    "dropdelst": "WA",
    "dropdelzpp": 980036721,
    "dropphyadd": "34301 9TH AVE S",
    "dropphycty": "FEDERAL WAY",
    "dropphyst": "WA",
    "dropphyzpp": 980036721,
    "dropmaladd": "34301 9TH AVE S",
    "dropmalcty": "FEDERAL WAY",
    "dropmalst": "WA",
    "dropmalzpp": 980036721,
    "dropsitphn": 2063816600,
    "dropsitlph": 2538747393,
    "dropsitcph": 2538747200,
    "dropfax": 2538747356
  },
  {
    "dcode": "D",
    "dropkey": "EZ17427",
    "droptype": "S",
    "dropname": "SEATTLE",
    "dropdeladd": "10700 27TH AVE S",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981681831,
    "dropphyadd": "10700 27TH AVE S",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981681831,
    "dropmaladd": "10700 27TH AVE S",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981681831,
    "dropsitphn": 2063816600,
    "dropsitlph": 2067684488,
    "dropsitcph": 2067684422,
    "dropfax": 2067680514
  },
  {
    "dcode": "D",
    "dropkey": "J009166",
    "droptype": "D",
    "dropname": "MOBILE ANNEX",
    "dropdeladd": "251 N ROYAL ST",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366029700,
    "dropphyadd": "251 N ROYAL ST",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366029700,
    "dropmaladd": "250 SAINT JOSEPH ST",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366012001,
    "dropsitphn": 2516945939,
    "dropsitlph": 2516945939,
    "dropsitcph": 2516945939,
    "dropfax": 2516021768
  },
  {
    "dcode": "D",
    "dropkey": "EV27270",
    "droptype": "S",
    "dropname": "WHITE RIVER JUNCTION",
    "dropdeladd": "195 SYKES MOUNTAIN AVE",
    "dropdelcty": "WHITE RIVER JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "050019997",
    "dropphyadd": "195 SYKES MOUNTAIN AVE",
    "dropphycty": "WHITE RIVER JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "050019997",
    "dropmaladd": "195 SYKES MOUNTAIN AVE",
    "dropmalcty": "WHITE RIVER JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "050019997",
    "dropsitphn": 8022963237,
    "dropsitlph": 8022963237,
    "dropsitcph": 8022963246,
    "dropfax": 8022963311
  },
  {
    "dcode": "D",
    "dropkey": "EV28205",
    "droptype": "S",
    "dropname": "BURLINGTON",
    "dropdeladd": "8 NEW ENGLAND DR STE 997",
    "dropdelcty": "ESSEX JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "054529997",
    "dropphyadd": "8 NEW ENGLAND DR STE 997",
    "dropphycty": "ESSEX JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "054529997",
    "dropmaladd": "8 NEW ENGLAND DR STE 997",
    "dropmalcty": "ESSEX JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "054529997",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028722222,
    "dropsitcph": 8028722221,
    "dropfax": 8028780537
  },
  {
    "dcode": "D",
    "dropkey": "EX27548",
    "droptype": "S",
    "dropname": "ROANOKE",
    "dropdeladd": "419 RUTHERFORD AVE NE",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240229998,
    "dropphyadd": "419 RUTHERFORD AVE NE",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240229997,
    "dropmaladd": "419 RUTHERFORD AVE NE",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240229998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409858751,
    "dropfax": 5409858722
  },
  {
    "dcode": "D",
    "dropkey": "K012546",
    "droptype": "S",
    "dropname": "RICHMOND VA RPDC",
    "dropdeladd": "5801 TECHNOLOGY BLVD",
    "dropdelcty": "SANDSTON",
    "dropdelst": "VA",
    "dropdelzpp": 231505016,
    "dropphyadd": "5801 TECHNOLOGY BLVD",
    "dropphycty": "SANDSTON",
    "dropphyst": "VA",
    "dropphyzpp": 231505016,
    "dropmaladd": "5801 TECHNOLOGY BLVD",
    "dropmalcty": "SANDSTON",
    "dropmalst": "VA",
    "dropmalzpp": 231505016,
    "dropsitphn": 8047373653,
    "dropsitlph": "",
    "dropsitcph": 8047373561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX29484",
    "droptype": "S",
    "dropname": "NORTHERN VA",
    "dropdeladd": "8409 ROUTE 29",
    "dropdelcty": "MERRIFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 220819700,
    "dropphyadd": "8409 ROUTE 29",
    "dropphycty": "MERRIFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 220819700,
    "dropmaladd": "8409 ROUTE 29",
    "dropmalcty": "MERRIFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 220819700,
    "dropsitphn": 7036986367,
    "dropsitlph": "",
    "dropsitcph": 7036986333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX27303",
    "droptype": "S",
    "dropname": "NORFOLK VA LPC",
    "dropdeladd": "600 CHURCH ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235019908,
    "dropphyadd": "600 CHURCH ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235019908,
    "dropmaladd": "600 CHURCH ST RM 203",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235019997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7576292117,
    "dropfax": 7576292106
  },
  {
    "dcode": "D",
    "dropkey": "EX29745",
    "droptype": "S",
    "dropname": "DULLES",
    "dropdeladd": "44715 PRENTICE DR",
    "dropdelcty": "STERLING",
    "dropdelst": "VA",
    "dropdelzpp": 201669113,
    "dropphyadd": "44715 PRENTICE DR",
    "dropphycty": "DULLES",
    "dropphyst": "VA",
    "dropphyzpp": 201019998,
    "dropmaladd": "44715 PRENTICE DR",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201019998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034066314,
    "dropsitcph": 7034066602,
    "dropfax": 7034066604
  },
  {
    "dcode": "D",
    "dropkey": "EY10814",
    "droptype": "S",
    "dropname": "MONTGOMERY",
    "dropdeladd": "6701 WINTON BLOUNT BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361199998,
    "dropphyadd": "6701 WINTON BLOUNT BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361199998,
    "dropmaladd": "6701 WINTON BLOUNT BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361199998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342447624,
    "dropfax": 3342447600
  },
  {
    "dcode": "D",
    "dropkey": "K016686",
    "droptype": "B",
    "dropname": "SALT LAKE CITY ASF",
    "dropdeladd": "1960 S INDUSTRIAL RD",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841999780,
    "dropphyadd": "1960 S INDUSTRIAL RD",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841999780,
    "dropmaladd": "1960 S INDUSTRIAL RD",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841999780,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019085743,
    "dropsitcph": 8019085706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ16257",
    "droptype": "S",
    "dropname": "SALT LAKE CITY",
    "dropdeladd": "1760 W 2100 S",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841999997,
    "dropphyadd": "1760 W 2100 S",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841999997,
    "dropmaladd": "1760 W 2100 S",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841999997,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 8019742948,
    "dropfax": 8019742324
  },
  {
    "dcode": "D",
    "dropkey": "EY20708",
    "droptype": "S",
    "dropname": "LITTLE ROCK",
    "dropdeladd": "4700 E MCCAIN BLVD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722319998,
    "dropphyadd": "4700 E MCCAIN BLVD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722319998,
    "dropmaladd": "4700 E MCCAIN BLVD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722319998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013755155,
    "dropsitcph": 5013755155,
    "dropfax": 5019456615
  },
  {
    "dcode": "D",
    "dropkey": "EZ17855",
    "droptype": "S",
    "dropname": "PROVO",
    "dropdeladd": "936 S 250 E",
    "dropdelcty": "PROVO",
    "dropdelst": "UT",
    "dropdelzpp": 846069998,
    "dropphyadd": "936 S 250 E",
    "dropphycty": "PROVO",
    "dropphyst": "UT",
    "dropphyzpp": 846069997,
    "dropmaladd": "936 S 250 E",
    "dropmalcty": "PROVO",
    "dropmalst": "UT",
    "dropmalzpp": 846069998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013742052,
    "dropsitcph": 8013562212,
    "dropfax": 8013756944
  },
  {
    "dcode": "D",
    "dropkey": "EW22666",
    "droptype": "S",
    "dropname": "ABILENE",
    "dropdeladd": "1020 E OVERLAND TRL",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796019997,
    "dropphyadd": "1020 E OVERLAND TRL",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796019997,
    "dropmaladd": "1020 E OVERLAND TRL",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796019997,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256721020,
    "dropsitcph": 3256721020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW22730",
    "droptype": "S",
    "dropname": "AMARILLO",
    "dropdeladd": "2301 ROSS ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791209732,
    "dropphyadd": "2301 ROSS ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791209732,
    "dropmaladd": "2301 ROSS ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791209732,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064682101,
    "dropsitcph": 8064682101,
    "dropfax": 8064682106
  },
  {
    "dcode": "D",
    "dropkey": "EW22814",
    "droptype": "S",
    "dropname": "AUSTIN",
    "dropdeladd": "8225 CROSS PARK DR",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787109998,
    "dropphyadd": "8225 CROSS PARK DR",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787109997,
    "dropmaladd": "8225 CROSS PARK DR",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123421225,
    "dropsitcph": 5123421135,
    "dropfax": 5123421298
  },
  {
    "dcode": "D",
    "dropkey": "E003573",
    "droptype": "D",
    "dropname": "AUSTIN ANNEX",
    "dropdeladd": "9001 TUSCANY WAY",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787100002,
    "dropphyadd": "9001 TUSCANY WAY",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787100002,
    "dropmaladd": "9001 TUSCANY WAY",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787100002,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123421225,
    "dropsitcph": 5129278124,
    "dropfax": 5129278348
  },
  {
    "dcode": "D",
    "dropkey": "EW22885",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "5815 WALDEN RD",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777079995,
    "dropphyadd": "5815 WALDEN RD",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777079995,
    "dropmaladd": "5815 WALDEN RD",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777079995,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099818730,
    "dropsitcph": 4099818601,
    "dropfax": 4099816807
  },
  {
    "dcode": "D",
    "dropkey": "E003198",
    "droptype": "D",
    "dropname": "LITTLE ROCK LINDSEY RD ANNEX",
    "dropdeladd": "6910 LINDSEY RD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722063826,
    "dropphyadd": "6910 LINDSEY RD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722063826,
    "dropmaladd": "6910 LINDSEY RD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722063826,
    "dropsitphn": 5019456732,
    "dropsitlph": 5014902411,
    "dropsitcph": 5014902411,
    "dropfax": 5014901884
  },
  {
    "dcode": "D",
    "dropkey": "EW23343",
    "droptype": "S",
    "dropname": "CORPUS CHRISTI",
    "dropdeladd": "809 NUECES BAY BLVD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784699998,
    "dropphyadd": "809 NUECES BAY BLVD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784699997,
    "dropmaladd": "809 NUECES BAY BLVD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618862242,
    "dropsitcph": 3618862245,
    "dropfax": 3618862215
  },
  {
    "dcode": "D",
    "dropkey": "EW23426",
    "droptype": "S",
    "dropname": "DALLAS",
    "dropdeladd": "401 TOM LANDRY HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752609998,
    "dropphyadd": "401 TOM LANDRY HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752609997,
    "dropmaladd": "401 TOM LANDRY HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752609998,
    "dropsitphn": 2147604661,
    "dropsitlph": 2147604941,
    "dropsitcph": 2147604359,
    "dropfax": 2147604595
  },
  {
    "dcode": "D",
    "dropkey": "KW23427",
    "droptype": "B",
    "dropname": "DALLAS NDC",
    "dropdeladd": "2400 DALLAS FT WORTH TPKE",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 753989100,
    "dropphyadd": "2400 DALLAS FT WORTH TPKE",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 753989100,
    "dropmaladd": "2400 DALLAS FT WORTH TPKE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 753989100,
    "dropsitphn": 2144675879,
    "dropsitlph": 2144675879,
    "dropsitcph": 2144675828,
    "dropfax": 2144675853
  },
  {
    "dcode": "D",
    "dropkey": "EZ10745",
    "droptype": "S",
    "dropname": "PHOENIX",
    "dropdeladd": "4949 E VAN BUREN ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850269800,
    "dropphyadd": "4949 E VAN BUREN ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850269672,
    "dropmaladd": "4949 E VAN BUREN ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850269672,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022253214,
    "dropsitcph": 6022253491,
    "dropfax": 6022253108
  },
  {
    "dcode": "D",
    "dropkey": "EW23623",
    "droptype": "S",
    "dropname": "EL PASO",
    "dropdeladd": "8401 BOEING DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799109998,
    "dropphyadd": "8401 BOEING DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799109997,
    "dropmaladd": "8401 BOEING DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807690,
    "dropsitcph": 9157807502,
    "dropfax": 9157807510
  },
  {
    "dcode": "D",
    "dropkey": "EW26475",
    "droptype": "S",
    "dropname": "FORT WORTH",
    "dropdeladd": "4600 MARK IV PKWY",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761619711,
    "dropphyadd": "4600 MARK IV PKWY",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761619711,
    "dropmaladd": "4600 MARK IV PKWY",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761619711,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173850,
    "dropsitcph": 8173173850,
    "dropfax": 8173173826
  },
  {
    "dcode": "D",
    "dropkey": "EW24557",
    "droptype": "S",
    "dropname": "LUBBOCK",
    "dropdeladd": "1515 CRICKETS AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794029998,
    "dropphyadd": "1515 CRICKETS AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794029998,
    "dropmaladd": "1515 CRICKETS AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794029998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067627841,
    "dropsitcph": 8067627841,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "E015431",
    "droptype": "D",
    "dropname": "LUBBOCK ANNEX",
    "dropdeladd": "1601 CRICKETS AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794029996,
    "dropphyadd": "1601 CRICKETS AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794029996,
    "dropmaladd": "1601 CRICKETS AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794029996,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067627841,
    "dropsitcph": 8067627841,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "EW24660",
    "droptype": "S",
    "dropname": "MCALLEN",
    "dropdeladd": "620 E PECAN BLVD",
    "dropdelcty": "MCALLEN",
    "dropdelst": "TX",
    "dropdelzpp": 785019998,
    "dropphyadd": "620 E PECAN BLVD",
    "dropphycty": "MCALLEN",
    "dropphyst": "TX",
    "dropphyzpp": 785019997,
    "dropmaladd": "620 E PECAN BLVD",
    "dropmalcty": "MCALLEN",
    "dropmalst": "TX",
    "dropmalzpp": 785019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569711741,
    "dropsitcph": 9569711741,
    "dropfax": 9569711787
  },
  {
    "dcode": "D",
    "dropkey": "EW24719",
    "droptype": "S",
    "dropname": "MIDLAND",
    "dropdeladd": "10000 LOOP 40",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797119998,
    "dropphyadd": "10000 LOOP 40",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797119997,
    "dropmaladd": "10000 LOOP 40",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4325605063,
    "dropsitcph": 4325605105,
    "dropfax": 9155605096
  },
  {
    "dcode": "D",
    "dropkey": "EW24934",
    "droptype": "S",
    "dropname": "NORTH HOUSTON",
    "dropdeladd": "4600 ALDINE BENDER RD RM 224",
    "dropdelcty": "NORTH HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 773159997,
    "dropphyadd": "4600 ALDINE BENDER RD RM 224",
    "dropphycty": "NORTH HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 773159997,
    "dropmaladd": "4600 ALDINE BENDER RD RM 224",
    "dropmalcty": "NORTH HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 773159997,
    "dropsitphn": 7132263913,
    "dropsitlph": 7132263475,
    "dropsitcph": 7132264202,
    "dropfax": 7132263095
  },
  {
    "dcode": "D",
    "dropkey": "EW23331",
    "droptype": "S",
    "dropname": "NORTH TEXAS",
    "dropdeladd": "951 W BETHEL RD",
    "dropdelcty": "COPPELL",
    "dropdelst": "TX",
    "dropdelzpp": 750998888,
    "dropphyadd": "951 W BETHEL RD",
    "dropphycty": "COPPELL",
    "dropphyst": "TX",
    "dropphyzpp": 750998888,
    "dropmaladd": "951 W BETHEL RD",
    "dropmalcty": "COPPELL",
    "dropmalst": "TX",
    "dropmalzpp": 750998888,
    "dropsitphn": 9723936199,
    "dropsitlph": 9723936325,
    "dropsitcph": 9723936780,
    "dropfax": 9723936369
  },
  {
    "dcode": "D",
    "dropkey": "EW26439",
    "droptype": "S",
    "dropname": "SAN ANTONIO",
    "dropdeladd": "10410 PERRIN BEITEL RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782849991,
    "dropphyadd": "10410 PERRIN BEITEL RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782849991,
    "dropmaladd": "10410 PERRIN BEITEL RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782849991,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688687,
    "dropsitcph": 2103688498,
    "dropfax": 2103681698
  },
  {
    "dcode": "D",
    "dropkey": "E003572",
    "droptype": "D",
    "dropname": "SAN ANTONIO ANNEX",
    "dropdeladd": "10410 PERRIN BEITEL RD BLDG 2",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782849907,
    "dropphyadd": "10410 PERRIN BEITEL RD BLDG 2",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782849907,
    "dropmaladd": "10410 PERRIN BEITEL RD BLDG 2",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782849907,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103683837,
    "dropsitcph": 2104030511,
    "dropfax": 2104039261
  },
  {
    "dcode": "D",
    "dropkey": "EX25002",
    "droptype": "S",
    "dropname": "CHATTANOOGA",
    "dropdeladd": "6050 SHALLOWFORD RD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374219997,
    "dropphyadd": "6050 SHALLOWFORD RD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374219997,
    "dropmaladd": "6050 SHALLOWFORD RD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374219997,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234998231,
    "dropsitcph": 4234998295,
    "dropfax": 4234998208
  },
  {
    "dcode": "D",
    "dropkey": "EX25366",
    "droptype": "D",
    "dropname": "JOHNSON CITY",
    "dropdeladd": "530 E MAIN ST",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376015629,
    "dropphyadd": "530 E MAIN ST",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376015629,
    "dropmaladd": "530 E MAIN ST",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376015629,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232325840,
    "dropsitcph": 4232325840,
    "dropfax": 4232325860
  },
  {
    "dcode": "D",
    "dropkey": "EX25384",
    "droptype": "S",
    "dropname": "KNOXVILLE",
    "dropdeladd": "1237 E WEISGARBER RD",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379508505,
    "dropphyadd": "1237 E WEISGARBER RD",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379508505,
    "dropmaladd": "1237 E WEISGARBER RD",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379508505,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655584629,
    "dropsitcph": 8655584664,
    "dropfax": 8655584521
  },
  {
    "dcode": "D",
    "dropkey": "E018840",
    "droptype": "D",
    "dropname": "MUSIC CITY ANNEX",
    "dropdeladd": "570 KNIGHT VALLEY DR",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372279800,
    "dropphyadd": "570 KNIGHT VALLEY DR",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372279800,
    "dropmaladd": "570 KNIGHT VALLEY DR",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372279800,
    "dropsitphn": 6158859129,
    "dropsitlph": "",
    "dropsitcph": 6158725642,
    "dropfax": 6158725765
  },
  {
    "dcode": "D",
    "dropkey": "EX25565",
    "droptype": "S",
    "dropname": "NASHVILLE",
    "dropdeladd": "525 ROYAL PKWY",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372299997,
    "dropphyadd": "525 ROYAL PKWY",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372299997,
    "dropmaladd": "525 ROYAL PKWY",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372299997,
    "dropsitphn": 6158859129,
    "dropsitlph": 6158859129,
    "dropsitcph": 6158859129,
    "dropfax": 6158859181
  },
  {
    "dcode": "D",
    "dropkey": "EW1C074",
    "droptype": "S",
    "dropname": "DAKOTA CENTRAL",
    "dropdeladd": "355 15TH ST NW",
    "dropdelcty": "HURON",
    "dropdelst": "SD",
    "dropdelzpp": 573999998,
    "dropphyadd": "355 15TH ST NW",
    "dropphycty": "HURON",
    "dropphyst": "SD",
    "dropphyzpp": 573999998,
    "dropmaladd": "355 15TH ST NW",
    "dropmalcty": "HURON",
    "dropmalst": "SD",
    "dropmalzpp": 573999998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053529835,
    "dropsitcph": 6053529835,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "EW1B046",
    "droptype": "S",
    "dropname": "RAPID CITY",
    "dropdeladd": "500 EAST BLVD",
    "dropdelcty": "RAPID CITY",
    "dropdelst": "SD",
    "dropdelzpp": 577019909,
    "dropphyadd": "500 EAST BLVD",
    "dropphycty": "RAPID CITY",
    "dropphyst": "SD",
    "dropphyzpp": 577019909,
    "dropmaladd": "500 EAST BLVD",
    "dropmalcty": "RAPID CITY",
    "dropmalst": "SD",
    "dropmalzpp": 577019909,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053552819,
    "dropsitcph": 6053552819,
    "dropfax": 6053948616
  },
  {
    "dcode": "D",
    "dropkey": "EW1B107",
    "droptype": "S",
    "dropname": "SIOUX FALLS",
    "dropdeladd": "4801 N 4TH AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571049300,
    "dropphyadd": "4801 N 4TH AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571049300,
    "dropmaladd": "4801 N 4TH AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571049300,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053574901,
    "dropsitcph": 6055754954,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "EZ10944",
    "droptype": "S",
    "dropname": "TUCSON",
    "dropdeladd": "1501 S CHERRYBELL STRA",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857269901,
    "dropphyadd": "1501 S CHERRYBELL STRA",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857269901,
    "dropmaladd": "1501 S CHERRYBELL STRA",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857269901,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885004,
    "dropsitcph": 5203885043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX29536",
    "droptype": "S",
    "dropname": "CHARLESTON",
    "dropdeladd": "7075 CROSS COUNTY RD",
    "dropdelcty": "NORTH CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294189996,
    "dropphyadd": "7075 CROSS COUNTY RD",
    "dropphycty": "NORTH CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294189996,
    "dropmaladd": "7075 CROSS COUNTY RD",
    "dropmalcty": "NORTH CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294189997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437605435,
    "dropsitcph": 8437605430,
    "dropfax": 8039266014
  },
  {
    "dcode": "D",
    "dropkey": "EX23726",
    "droptype": "S",
    "dropname": "COLUMBIA",
    "dropdeladd": "2001 DIXIANA RD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292929990,
    "dropphyadd": "2001 DIXIANA RD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292929990,
    "dropmaladd": "PO BOX 929997",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292929997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334600,
    "dropfax": 8037717717
  },
  {
    "dcode": "D",
    "dropkey": "E004291",
    "droptype": "S",
    "dropname": "GREENVILLE",
    "dropdeladd": "4605 DAIRY DR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296073731,
    "dropphyadd": "204 FAIRFOREST WAY",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296074609,
    "dropmaladd": "PO BOX 709510",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296079510,
    "dropsitphn": 8039266014,
    "dropsitlph": 8642865017,
    "dropsitcph": 8642865017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E004551",
    "droptype": "D",
    "dropname": "WEST VALLEY",
    "dropdeladd": "620 N 47TH AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850432814,
    "dropphyadd": "620 N 47TH AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850432814,
    "dropmaladd": "620 N 47TH AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850432814,
    "dropsitphn": 6022253214,
    "dropsitlph": 6024426076,
    "dropsitcph": 6024426000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV25935",
    "droptype": "S",
    "dropname": "PROVIDENCE",
    "dropdeladd": "24 CORLISS ST REAR DOCK",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029049799",
    "dropphyadd": "24 CORLISS ST REAR DOCK",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029049799",
    "dropmaladd": "24 CORLISS ST RM 200",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029049997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4012766858,
    "dropsitcph": 4012766812,
    "dropfax": 4012766867
  },
  {
    "dcode": "D",
    "dropkey": "EV17273",
    "droptype": "S",
    "dropname": "SAN JUAN",
    "dropdeladd": "585 AVE FD ROOSEVELT STE 370",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009369312",
    "dropphyadd": "585 AVE FD ROOSEVELT STE 370",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009369312",
    "dropmaladd": "585 AVE FD ROOSEVELT STE 370",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009369312",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876221750,
    "dropfax": 7876221923
  },
  {
    "dcode": "D",
    "dropkey": "EZ24277",
    "droptype": "S",
    "dropname": "ANAHEIM",
    "dropdeladd": "5335 E LA PALMA AVE",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928999998,
    "dropphyadd": "5335 E LA PALMA AVE",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928999998,
    "dropmaladd": "5335 E LA PALMA AVE",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928999998,
    "dropsitphn": 7147012663,
    "dropsitlph": 7147012663,
    "dropsitcph": 7147012663,
    "dropfax": 7147792034
  },
  {
    "dcode": "D",
    "dropkey": "EZ20171",
    "droptype": "S",
    "dropname": "BAKERSFIELD",
    "dropdeladd": "3400 PEGASUS DR",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933809000,
    "dropphyadd": "3400 PEGASUS DR",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933809000,
    "dropmaladd": "3400 PEGASUS DR",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933809000,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613926102,
    "dropsitcph": 6613926102,
    "dropfax": 6613926149
  },
  {
    "dcode": "D",
    "dropkey": "EZ21209",
    "droptype": "S",
    "dropname": "FRESNO",
    "dropdeladd": "1900 E ST",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937068000,
    "dropphyadd": "1900 E ST",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937068000,
    "dropmaladd": "1900 E ST",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937068000,
    "dropsitphn": 5594977609,
    "dropsitlph": 5594977609,
    "dropsitcph": 5594977629,
    "dropfax": 5594977511
  },
  {
    "dcode": "D",
    "dropkey": "EZ24135",
    "droptype": "S",
    "dropname": "INDUSTRY",
    "dropdeladd": "15421 E GALE AVE",
    "dropdelcty": "CITY OF INDUSTRY",
    "dropdelst": "CA",
    "dropdelzpp": 917159998,
    "dropphyadd": "15421 E GALE AVE",
    "dropphycty": "CITY OF INDUSTRY",
    "dropphyst": "CA",
    "dropphyzpp": 917159998,
    "dropmaladd": "15421 E GALE AVE",
    "dropmalcty": "CITY OF INDUSTRY",
    "dropmalst": "CA",
    "dropmalzpp": 917159998,
    "dropsitphn": 6268556440,
    "dropsitlph": 6268556522,
    "dropsitcph": 6268556440,
    "dropfax": 6268556696
  },
  {
    "dcode": "D",
    "dropkey": "EX12161",
    "droptype": "S",
    "dropname": "EVANSVILLE",
    "dropdeladd": "7100 PETERSBURG RD",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477111737,
    "dropphyadd": "7100 PETERSBURG RD",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477111737,
    "dropmaladd": "7100 PETERSBURG RD",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477111737,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 8124293411,
    "dropfax": 8124293486
  },
  {
    "dcode": "D",
    "dropkey": "E015728",
    "droptype": "D",
    "dropname": "EVANSVILLE ANNEX",
    "dropdeladd": "800 SYCAMORE ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477089900,
    "dropphyadd": "800 SYCAMORE ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477089900,
    "dropmaladd": "800 SYCAMORE ST",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477089900,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 8124293411,
    "dropfax": 8124293486
  },
  {
    "dcode": "D",
    "dropkey": "EZ24121",
    "droptype": "S",
    "dropname": "LOS ANGELES",
    "dropdeladd": "7001 S CENTRAL AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900529998,
    "dropphyadd": "7001 S CENTRAL AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900529998,
    "dropmaladd": "7001 S CENTRAL AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900529998,
    "dropsitphn": 3235861867,
    "dropsitlph": 2135862719,
    "dropsitcph": 3235861840,
    "dropfax": 3235861498
  },
  {
    "dcode": "D",
    "dropkey": "EX12224",
    "droptype": "S",
    "dropname": "FORT WAYNE",
    "dropdeladd": "1501 S CLINTON ST",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468029997,
    "dropphyadd": "1501 S CLINTON ST",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468029997,
    "dropmaladd": "1501 S CLINTON ST",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277310,
    "dropfax": 2604277346
  },
  {
    "dcode": "D",
    "dropkey": "EX12284",
    "droptype": "S",
    "dropname": "GARY",
    "dropdeladd": "1499 MARTIN LUTHER KING DR",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464019997,
    "dropphyadd": "1499 MARTIN LUTHER KING DR",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464019997,
    "dropmaladd": "1499 MARTIN LUTHER KING DR",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464019997,
    "dropsitphn": 2198868051,
    "dropsitlph": "",
    "dropsitcph": 2198848079,
    "dropfax": 2198868201
  },
  {
    "dcode": "D",
    "dropkey": "KZ21804",
    "droptype": "B",
    "dropname": "LOS ANGELES NDC",
    "dropdeladd": "5555 BANDINI BLVD",
    "dropdelcty": "BELL GARDENS",
    "dropdelst": "CA",
    "dropdelzpp": 902019997,
    "dropphyadd": "5555 BANDINI BLVD",
    "dropphycty": "BELL GARDENS",
    "dropphyst": "CA",
    "dropphyzpp": 902019997,
    "dropmaladd": "5555 BANDINI BLVD",
    "dropmalcty": "BELL GARDENS",
    "dropmalst": "CA",
    "dropmalzpp": 902019997,
    "dropsitphn": 3237294185,
    "dropsitlph": 3237294141,
    "dropsitcph": 3237294050,
    "dropfax": 3237294125
  },
  {
    "dcode": "D",
    "dropkey": "EX12557",
    "droptype": "S",
    "dropname": "INDIANAPOLIS",
    "dropdeladd": "125 W SOUTH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462069997,
    "dropphyadd": "125 W SOUTH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462069997,
    "dropmaladd": "125 W SOUTH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462069997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646852,
    "dropfax": 3174646011
  },
  {
    "dcode": "D",
    "dropkey": "EX16953",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "141 PATCHWAY RD",
    "dropdelcty": "DUNCANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166359997,
    "dropphyadd": "141 PATCHWAY RD",
    "dropphycty": "DUNCANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166359997,
    "dropmaladd": "141 PATCHWAY RD",
    "dropmalcty": "DUNCANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166359997,
    "dropsitphn": 8148987318,
    "dropsitlph": 8146934742,
    "dropsitcph": 8146934748,
    "dropfax": 8146934715
  },
  {
    "dcode": "D",
    "dropkey": 4020644,
    "droptype": "D",
    "dropname": "ERIE PA S&DC",
    "dropdeladd": "2108 E 38TH ST",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165159987,
    "dropphyadd": "2108 E 38TH ST",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165159987,
    "dropmaladd": "2108 E 38TH ST",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165159987,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148987340,
    "dropsitcph": 8148987364,
    "dropfax": 8148987303
  },
  {
    "dcode": "D",
    "dropkey": "EX18801",
    "droptype": "S",
    "dropname": "HARRISBURG",
    "dropdeladd": "1425 CROOKED HILL RD",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171079970,
    "dropphyadd": "1425 CROOKED HILL RD",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171079970,
    "dropmaladd": "1425 CROOKED HILL RD",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171079970,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172572361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX19092",
    "droptype": "S",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "235 JARI DR",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 159046940,
    "dropphyadd": "235 JARI DR RM 109",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 159049989,
    "dropmaladd": "235 JARI DR RM 109",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 159049989,
    "dropsitphn": 8145334970,
    "dropsitlph": 8145334937,
    "dropsitcph": 8145334941,
    "dropfax": 8145336166
  },
  {
    "dcode": "D",
    "dropkey": "EX19267",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "1400 HARRISBURG PIKE",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176049970,
    "dropphyadd": "1400 HARRISBURG PIKE",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176049970,
    "dropmaladd": "1400 HARRISBURG PIKE",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176049970,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173966932,
    "dropsitcph": 7173966925,
    "dropfax": 7173966918
  },
  {
    "dcode": "D",
    "dropkey": "EX19355",
    "droptype": "S",
    "dropname": "LEHIGH VALLEY",
    "dropdeladd": "17 S COMMERCE WAY",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180179005,
    "dropphyadd": "17 S COMMERCE WAY",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180179005,
    "dropmaladd": "17 S COMMERCE WAY",
    "dropmalcty": "LEHIGH VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 180029997,
    "dropsitphn": 6108823244,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108223209,
    "dropfax": 6108823297
  },
  {
    "dcode": "D",
    "dropkey": "J004220",
    "droptype": "D",
    "dropname": "PENNWOOD PLACE",
    "dropdeladd": "51 PENNWOOD PL STE 100",
    "dropdelcty": "WARRENDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150867531,
    "dropphyadd": "51 PENNWOOD PL STE 100",
    "dropphycty": "WARRENDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150867531,
    "dropmaladd": "51 PENNWOOD PL STE 100",
    "dropmalcty": "WARRENDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150867531,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247793140,
    "dropsitcph": 7247793100,
    "dropfax": 7247793113
  },
  {
    "dcode": "D",
    "dropkey": "E015761",
    "droptype": "D",
    "dropname": "MORENO VALLEY",
    "dropdeladd": "23800 CACTUS AVE",
    "dropdelcty": "MORENO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 925539995,
    "dropphyadd": "23800 CACTUS AVE",
    "dropphycty": "MORENO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 925539995,
    "dropmaladd": "23800 CACTUS AVE",
    "dropmalcty": "MORENO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 925539995,
    "dropsitphn": 9093354694,
    "dropsitlph": 9096564302,
    "dropsitcph": 9093354408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E005918",
    "droptype": "S",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "7500 LINDBERGH BLVD",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191769997,
    "dropphyadd": "7500 LINDBERGH BLVD",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191769997,
    "dropmaladd": "7500 LINDBERGH BLVD",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191769997,
    "dropsitphn": 2157494278,
    "dropsitlph": 2157494278,
    "dropsitcph": 2157494278,
    "dropfax": 2158633631
  },
  {
    "dcode": "D",
    "dropkey": "KX1A495",
    "droptype": "B",
    "dropname": "PHILADELPHIA NDC",
    "dropdeladd": "1900 BYBERRY RD STE 1",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191169751,
    "dropphyadd": "1900 BYBERRY RD STE 1",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191169751,
    "dropmaladd": "1900 BYBERRY RD STE 1",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191169751,
    "dropsitphn": 2156717625,
    "dropsitlph": 2156717666,
    "dropsitcph": 2156717609,
    "dropfax": 2156717622
  },
  {
    "dcode": "D",
    "dropkey": "EZ22186",
    "droptype": "D",
    "dropname": "NORTH BAY",
    "dropdeladd": "1150 N MCDOWELL BLVD",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949999993,
    "dropphyadd": "1150 N MCDOWELL BLVD",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949999993,
    "dropmaladd": "1150 N MCDOWELL BLVD",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949999993,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785230,
    "dropsitcph": 7077785230,
    "dropfax": 7077785393
  },
  {
    "dcode": "D",
    "dropkey": "E019110",
    "droptype": "D",
    "dropname": "NORTH PENINSULA DDC",
    "dropdeladd": "1625 ROLLINS RD",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "CA",
    "dropdelzpp": 940109994,
    "dropphyadd": "1625 ROLLINS RD",
    "dropphycty": "BURLINGAME",
    "dropphyst": "CA",
    "dropphyzpp": 940109994,
    "dropmaladd": "1625 ROLLINS RD",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "CA",
    "dropmalzpp": 940109994,
    "dropsitphn": 4155505045,
    "dropsitlph": "",
    "dropsitcph": 6505521003,
    "dropfax": 6505521091
  },
  {
    "dcode": "D",
    "dropkey": "EZ22295",
    "droptype": "S",
    "dropname": "OAKLAND",
    "dropdeladd": "1675 7TH ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946150001,
    "dropphyadd": "1675 7TH ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946150001,
    "dropmaladd": "1675 7TH ST RM 236",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946159997,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108748252,
    "dropsitcph": 5102513375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E018303",
    "droptype": "D",
    "dropname": "PASADENA",
    "dropdeladd": "600 LINCOLN AVE",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911099925,
    "dropphyadd": "600 LINCOLN AVE",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911099925,
    "dropmaladd": "600 LINCOLN AVE",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911099925,
    "dropsitphn": 6617757808,
    "dropsitlph": 6263047112,
    "dropsitcph": 6263047164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX1A541",
    "droptype": "S",
    "dropname": "PITTSBURGH",
    "dropdeladd": "1001 CALIFORNIA AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152901001,
    "dropphyadd": "1001 CALIFORNIA AVE RM 2057A",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152909670,
    "dropmaladd": "1001 CALIFORNIA AVE RM 2057A",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152909670,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123597845,
    "dropsitcph": 4123597845,
    "dropfax": 4123211953
  },
  {
    "dcode": "D",
    "dropkey": "EZ22632",
    "droptype": "D",
    "dropname": "REDDING",
    "dropdeladd": "2323 CHURN CREEK RD",
    "dropdelcty": "REDDING",
    "dropdelst": "CA",
    "dropdelzpp": 960029997,
    "dropphyadd": "2323 CHURN CREEK RD",
    "dropphycty": "REDDING",
    "dropphyst": "CA",
    "dropphyzpp": 960029997,
    "dropmaladd": "2323 CHURN CREEK RD",
    "dropmalcty": "REDDING",
    "dropmalst": "CA",
    "dropmalzpp": 960029997,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302237500,
    "dropsitcph": 5302237523,
    "dropfax": 5302237511
  },
  {
    "dcode": "D",
    "dropkey": "KX1A542",
    "droptype": "B",
    "dropname": "PITTSBURGH NDC",
    "dropdeladd": "300 BRUSH CREEK RD",
    "dropdelcty": "WARRENDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150951002,
    "dropphyadd": "300 BRUSH CREEK RD",
    "dropphycty": "WARRENDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150951002,
    "dropmaladd": "300 BRUSH CREEK RD",
    "dropmalcty": "WARRENDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150951002,
    "dropsitphn": 7247766244,
    "dropsitlph": 7247766378,
    "dropsitcph": 7247766226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ22760",
    "droptype": "S",
    "dropname": "SACRAMENTO",
    "dropdeladd": "3775 INDUSTRIAL BLVD RM 4040",
    "dropdelcty": "WEST SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 957990199,
    "dropphyadd": "3775 INDUSTRIAL BLVD RM 4040",
    "dropphycty": "WEST SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 957990199,
    "dropmaladd": "3775 INDUSTRIAL BLVD RM 4040",
    "dropmalcty": "WEST SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 957990199,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163738128,
    "dropsitcph": 9163738157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX1A956",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "2800 STAFFORD AVE",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185059997,
    "dropphyadd": "2800 STAFFORD AVE",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185059997,
    "dropmaladd": "2800 STAFFORD AVE",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185059997,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709695101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ22788",
    "droptype": "S",
    "dropname": "SAN BERNARDINO",
    "dropdeladd": "1900 W REDLANDS BLVD",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924039996,
    "dropphyadd": "1900 W REDLANDS BLVD",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924039996,
    "dropmaladd": "PO BOX 19001",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924239001,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093354531,
    "dropsitcph": 9093354300,
    "dropfax": 9093354415
  },
  {
    "dcode": "D",
    "dropkey": "EZ14985",
    "droptype": "S",
    "dropname": "EUGENE OR LPC",
    "dropdeladd": "3148 GATEWAY ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 974751100,
    "dropphyadd": "3148 GATEWAY ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 974759990,
    "dropmaladd": "PO BOX 7000",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 974750100,
    "dropsitphn": 5032942242,
    "dropsitlph": 5419885100,
    "dropsitcph": 5419885105,
    "dropfax": 5419885217
  },
  {
    "dcode": "D",
    "dropkey": "EZ15248",
    "droptype": "S",
    "dropname": "MEDFORD OR LPC",
    "dropdeladd": "2195 SAGE RD",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OR",
    "dropdelzpp": 975011357,
    "dropphyadd": "2195 SAGE RD",
    "dropphycty": "MEDFORD",
    "dropphyst": "OR",
    "dropphyzpp": 975011357,
    "dropmaladd": "2195 SAGE RD",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OR",
    "dropmalzpp": 975011357,
    "dropsitphn": 5032942242,
    "dropsitlph": 5417761344,
    "dropsitcph": 5417761348,
    "dropfax": 5417748513
  },
  {
    "dcode": "D",
    "dropkey": "EZ22793",
    "droptype": "S",
    "dropname": "SAN DIEGO",
    "dropdeladd": "11251 RANCHO CARMEL DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921999992,
    "dropphyadd": "11251 RANCHO CARMEL DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921999992,
    "dropmaladd": "11251 RANCHO CARMEL DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921999709,
    "dropsitphn": 8586740173,
    "dropsitlph": 8586740109,
    "dropsitcph": 8586742670,
    "dropfax": 8586740373
  },
  {
    "dcode": "D",
    "dropkey": "K018733",
    "droptype": "S",
    "dropname": "PORTLAND OR RPDC",
    "dropdeladd": "7007 NE CORNFOOT RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972189997,
    "dropphyadd": "7007 NE CORNFOOT RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972189997,
    "dropmaladd": "7007 NE CORNFOOT RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972189997,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5032942421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ22801",
    "droptype": "S",
    "dropname": "SAN FRANCISCO",
    "dropdeladd": "1300 EVANS AVE STE 300P",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941888025,
    "dropphyadd": "1300 EVANS AVE STE 300P",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941888025,
    "dropmaladd": "PO BOX 881328",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941881328,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155505638,
    "dropsitcph": 4155505000,
    "dropfax": 4155505283
  },
  {
    "dcode": "D",
    "dropkey": "E011036",
    "droptype": "S",
    "dropname": "OKLAHOMA CITY",
    "dropdeladd": "4025 W RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731259403,
    "dropphyadd": "4025 W RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731259403,
    "dropmaladd": "4025 W RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731259403,
    "dropsitphn": 4058152724,
    "dropsitlph": "",
    "dropsitcph": 4058152711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW22564",
    "droptype": "S",
    "dropname": "TULSA",
    "dropdeladd": "2132 S 91ST EAST AVE",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741419997,
    "dropphyadd": "2132 S 91ST EAST AVE",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741419997,
    "dropmaladd": "2132 S 91ST EAST AVE",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741419997,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182707431,
    "dropsitcph": 9182707411,
    "dropfax": 9182707711
  },
  {
    "dcode": "D",
    "dropkey": "EX20034",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "675 WOLF LEDGES PKWY RM 114",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443099997,
    "dropphyadd": "675 WOLF LEDGES PKWY RM 114",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443099997,
    "dropmaladd": "675 WOLF LEDGES PKWY RM 114",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443099997,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309969750,
    "dropfax": 3309969939
  },
  {
    "dcode": "D",
    "dropkey": "KZ24019",
    "droptype": "B",
    "dropname": "SAN FRANCISCO NDC",
    "dropdeladd": "2501 RYDIN RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948509751,
    "dropphyadd": "2501 RYDIN RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948509751,
    "dropmaladd": "2501 RYDIN RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948509751,
    "dropsitphn": 5105289780,
    "dropsitlph": 5105289780,
    "dropsitcph": 5105289632,
    "dropfax": 5105289770
  },
  {
    "dcode": "D",
    "dropkey": "EX20547",
    "droptype": "S",
    "dropname": "CINCINNATI",
    "dropdeladd": "1591 DALTON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452349997,
    "dropphyadd": "1591 DALTON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452349997,
    "dropmaladd": "1591 DALTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452349997,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5136845671,
    "dropfax": 5136845194
  },
  {
    "dcode": "D",
    "dropkey": "EX11429",
    "droptype": "D",
    "dropname": "INDIANAPOLIS HS ROAD ANNEX",
    "dropdeladd": "2690 S HIGH SCHOOL RD",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462414922,
    "dropphyadd": "2690 S HIGH SCHOOL RD",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462414922,
    "dropmaladd": "2690 S HIGH SCHOOL RD",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462414922,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646851,
    "dropfax": 3174646249
  },
  {
    "dcode": "D",
    "dropkey": "KX20548",
    "droptype": "B",
    "dropname": "CINCINNATI NDC",
    "dropdeladd": "3055 CRESCENTVILLE RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452359998,
    "dropphyadd": "3055 CRESCENTVILLE RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452359998,
    "dropmaladd": "3055 CRESCENTVILLE RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452359998,
    "dropsitphn": 5137337008,
    "dropsitlph": 5137337008,
    "dropsitcph": 5137337008,
    "dropfax": 5137337122
  },
  {
    "dcode": "D",
    "dropkey": "E001209",
    "droptype": "D",
    "dropname": "INDIANAPOLIS MP ANNEX",
    "dropdeladd": "7451 TEMPELHOF DR STE A",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462419531,
    "dropphyadd": "7451 TEMPELHOF DR STE A",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462419531,
    "dropmaladd": "7451 TEMPELHOF DR STE A",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462419531,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178742233,
    "dropfax": 3174646993
  },
  {
    "dcode": "D",
    "dropkey": "EZ22813",
    "droptype": "S",
    "dropname": "SAN JOSE",
    "dropdeladd": "1750 LUNDY AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951019998,
    "dropphyadd": "1750 LUNDY AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951019998,
    "dropmaladd": "1750 LUNDY AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951019998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376700,
    "dropsitcph": 4084376700,
    "dropfax": 4084376699
  },
  {
    "dcode": "D",
    "dropkey": "EZ22855",
    "droptype": "S",
    "dropname": "SANTA ANA",
    "dropdeladd": "3101 W SUNFLOWER AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927990101,
    "dropphyadd": "3101 W SUNFLOWER AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927990101,
    "dropmaladd": "3101 W SUNFLOWER AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927999998,
    "dropsitphn": 7146626415,
    "dropsitlph": 7146626474,
    "dropsitcph": 7146626465,
    "dropfax": 7148352406
  },
  {
    "dcode": "D",
    "dropkey": "EX20577",
    "droptype": "S",
    "dropname": "CLEVELAND",
    "dropdeladd": "2400 ORANGE AVE RM 165",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441019309,
    "dropphyadd": "2400 ORANGE AVE RM 30",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441019701,
    "dropmaladd": "2400 ORANGE AVE RM 30",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441019701,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164434089,
    "dropfax": 2164434343
  },
  {
    "dcode": "D",
    "dropkey": "E013407",
    "droptype": "D",
    "dropname": "CLEVELAND FSS ANNEX",
    "dropdeladd": "5801 POSTAL RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441819998,
    "dropphyadd": "5801 POSTAL RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441819998,
    "dropmaladd": "5801 POSTAL RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441819998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164334039,
    "dropfax": 2164334020
  },
  {
    "dcode": "D",
    "dropkey": "EX20642",
    "droptype": "S",
    "dropname": "COLUMBUS",
    "dropdeladd": "3175 AGLER RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432189002,
    "dropphyadd": "2323 CITYGATE DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432189997,
    "dropmaladd": "2323 CITYGATE DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432189997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720237,
    "dropsitcph": 6144720237,
    "dropfax": 6144720303
  },
  {
    "dcode": "D",
    "dropkey": "E015865",
    "droptype": "D",
    "dropname": "COLUMBUS FSS ANNEX",
    "dropdeladd": "850 TWIN RIVERS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432169305,
    "dropphyadd": "850 TWIN RIVERS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432169305,
    "dropmaladd": "850 TWIN RIVERS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432169305,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 6144694516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX20775",
    "droptype": "S",
    "dropname": "DAYTON",
    "dropdeladd": "1111 E 5TH ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454019997,
    "dropphyadd": "1111 E 5TH ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454019997,
    "dropmaladd": "1111 E 5TH ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454019997,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376845763,
    "dropsitcph": 9372271245,
    "dropfax": 9372273940
  },
  {
    "dcode": "D",
    "dropkey": "EX13027",
    "droptype": "S",
    "dropname": "MUNCIE",
    "dropdeladd": "4300 S COWAN RD",
    "dropdelcty": "MUNCIE",
    "dropdelst": "IN",
    "dropdelzpp": 473029997,
    "dropphyadd": "4300 S COWAN RD",
    "dropphycty": "MUNCIE",
    "dropphyst": "IN",
    "dropphyzpp": 473029997,
    "dropmaladd": "4300 S COWAN RD",
    "dropmalcty": "MUNCIE",
    "dropmalst": "IN",
    "dropmalzpp": 473029997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652869600,
    "dropfax": 7652869613
  },
  {
    "dcode": "D",
    "dropkey": "E018829",
    "droptype": "D",
    "dropname": "SPRINGDALE ANNEX",
    "dropdeladd": "12000 NORTHWEST BLVD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452469998,
    "dropphyadd": "12000 NORTHWEST BLVD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452469998,
    "dropmaladd": "12000 NORTHWEST BLVD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452469998,
    "dropsitphn": 5136845763,
    "dropsitlph": "",
    "dropsitcph": 5136845671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX13618",
    "droptype": "S",
    "dropname": "SOUTH BEND",
    "dropdeladd": "424 S MICHIGAN ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466019997,
    "dropphyadd": "424 S MICHIGAN ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466019997,
    "dropmaladd": "424 S MICHIGAN ST",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466019997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828413,
    "dropfax": 5742828411
  },
  {
    "dcode": "D",
    "dropkey": "EX23087",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "435 S SAINT CLAIR ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436019997,
    "dropphyadd": "435 S SAINT CLAIR ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436019997,
    "dropmaladd": "435 S SAINT CLAIR ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436019997,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 4192456917,
    "dropfax": 4192456846
  },
  {
    "dcode": "D",
    "dropkey": "KW20787",
    "droptype": "B",
    "dropname": "KANSAS CITY NDC",
    "dropdeladd": "4900 SPEAKER RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661061093,
    "dropphyadd": "4900 SPEAKER RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661061093,
    "dropmaladd": "4900 SPEAKER RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661061093,
    "dropsitphn": 9135732520,
    "dropsitlph": 9135732542,
    "dropsitcph": 9135732641,
    "dropfax": 9135732698
  },
  {
    "dcode": "D",
    "dropkey": "EX29488",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "99 S WALNUT ST RM 289",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445019993,
    "dropphyadd": "99 S WALNUT ST RM 289",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445019993,
    "dropmaladd": "99 S WALNUT ST RM 289",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445019993,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307408808,
    "dropsitcph": 3307408808,
    "dropfax": 3307408804
  },
  {
    "dcode": "D",
    "dropkey": "EW21758",
    "droptype": "S",
    "dropname": "WICHITA",
    "dropdeladd": "7117 W HARRY ST",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672769949,
    "dropphyadd": "7117 W HARRY ST",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672769949,
    "dropmaladd": "7117 W HARRY ST",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672769949,
    "dropsitphn": 3169464628,
    "dropsitlph": 3169464649,
    "dropsitcph": 3169464636,
    "dropfax": 3169459762
  },
  {
    "dcode": "D",
    "dropkey": "EV11841",
    "droptype": "S",
    "dropname": "ALBANY",
    "dropdeladd": "30 KARNER RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122889990,
    "dropphyadd": "30 KARNER RD",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122889990,
    "dropmaladd": "30 KARNER RD",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122889990,
    "dropsitphn": 5184522298,
    "dropsitlph": 5184522298,
    "dropsitcph": 5184522300,
    "dropfax": 5184522325
  },
  {
    "dcode": "D",
    "dropkey": "J002618",
    "droptype": "D",
    "dropname": "BETHPAGE",
    "dropdeladd": "288 GRUMMAN RD W",
    "dropdelcty": "BETHPAGE",
    "dropdelst": "NY",
    "dropdelzpp": 117143566,
    "dropphyadd": "288 GRUMMAN RD W",
    "dropphycty": "BETHPAGE",
    "dropphyst": "NY",
    "dropphyzpp": 117143566,
    "dropmaladd": "288 GRUMMAN RD W",
    "dropmalcty": "BETHPAGE",
    "dropmalst": "NY",
    "dropmalzpp": 117143566,
    "dropsitphn": 6317552524,
    "dropsitlph": "",
    "dropsitcph": 5163495000,
    "dropfax": 5163495007
  },
  {
    "dcode": "D",
    "dropkey": "EX15573",
    "droptype": "S",
    "dropname": "LEXINGTON",
    "dropdeladd": "1088 NANDINO BLVD",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405119995,
    "dropphyadd": "1088 NANDINO BLVD",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405119995,
    "dropmaladd": "1088 NANDINO BLVD",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405119995,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 8592316700,
    "dropfax": 8592316703
  },
  {
    "dcode": "D",
    "dropkey": "EX15638",
    "droptype": "S",
    "dropname": "LOUISVILLE",
    "dropdeladd": "1420 GARDINER LN",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402319990,
    "dropphyadd": "1420 GARDINER LN",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402319990,
    "dropmaladd": "PO BOX 31997",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402319997,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 5024541781,
    "dropfax": 5024541987
  },
  {
    "dcode": "D",
    "dropkey": "AX1C359",
    "droptype": "D",
    "dropname": "LOUISVILLE AMF",
    "dropdeladd": "4440 CRITTENDEN DR",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402219990,
    "dropphyadd": "4440 CRITTENDEN DR",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402219990,
    "dropmaladd": "4440 CRITTENDEN DR",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402219990,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 5023755895,
    "dropfax": 5023755868
  },
  {
    "dcode": "D",
    "dropkey": "EZ23973",
    "droptype": "S",
    "dropname": "SANTA BARBARA",
    "dropdeladd": "400 STORKE RD",
    "dropdelcty": "GOLETA",
    "dropdelst": "CA",
    "dropdelzpp": 931999997,
    "dropphyadd": "400 STORKE RD",
    "dropphycty": "GOLETA",
    "dropphyst": "CA",
    "dropphyzpp": 931999997,
    "dropmaladd": "400 STORKE RD",
    "dropmalcty": "GOLETA",
    "dropmalst": "CA",
    "dropmalzpp": 931999997,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059610710,
    "dropsitcph": 8059610710,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "EV12316",
    "droptype": "S",
    "dropname": "BROOKLYN",
    "dropdeladd": "1050 FORBELL ST RM 2005",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112569604,
    "dropphyadd": "1050 FORBELL ST RM 2005",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112569604,
    "dropmaladd": "1050 FORBELL ST RM 2005",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112569604,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183483100,
    "dropfax": 7183483659
  },
  {
    "dcode": "D",
    "dropkey": "EV12342",
    "droptype": "S",
    "dropname": "BUFFALO",
    "dropdeladd": "1200 WILLIAM ST RM 201",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142409997,
    "dropphyadd": "1200 WILLIAM ST RM 201",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142409997,
    "dropmaladd": "1200 WILLIAM ST RM 201",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142409997,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168462400,
    "dropfax": 7168462407
  },
  {
    "dcode": "D",
    "dropkey": "E009134",
    "droptype": "D",
    "dropname": "JFK ISC",
    "dropdeladd": "250 N BOUNDARY RD RM 2F1",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114301818,
    "dropphyadd": "250 N BOUNDARY RD RM 2F1",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114301818,
    "dropmaladd": "250 N BOUNDARY RD RM 2F1",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114301818,
    "dropsitphn": 7185537200,
    "dropsitlph": 7185537200,
    "dropsitcph": 7185539132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ23707",
    "droptype": "S",
    "dropname": "SANTA CLARITA",
    "dropdeladd": "28201 FRANKLIN PKWY",
    "dropdelcty": "SANTA CLARITA",
    "dropdelst": "CA",
    "dropdelzpp": 913839997,
    "dropphyadd": "28201 FRANKLIN PKWY",
    "dropphycty": "SANTA CLARITA",
    "dropphyst": "CA",
    "dropphyzpp": 913839997,
    "dropmaladd": "28201 FRANKLIN PKWY",
    "dropmalcty": "SANTA CLARITA",
    "dropmalst": "CA",
    "dropmalzpp": 913839997,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617757807,
    "dropsitcph": 6617756681,
    "dropfax": 6617757109
  },
  {
    "dcode": "D",
    "dropkey": "EV14657",
    "droptype": "S",
    "dropname": "MID HUDSON",
    "dropdeladd": "99 ENTERPRISE DR",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 125558301,
    "dropphyadd": "99 ENTERPRISE DR",
    "dropphycty": "NEWBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 125558302,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 125559997,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8455672301,
    "dropfax": 8455672309
  },
  {
    "dcode": "D",
    "dropkey": "EV18928",
    "droptype": "S",
    "dropname": "MID ISLAND",
    "dropdeladd": "160 DURYEA RD",
    "dropdelcty": "MELVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117473832,
    "dropphyadd": "160 DURYEA RD",
    "dropphycty": "MELVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117473832,
    "dropmaladd": "160 DURYEA RD",
    "dropmalcty": "MELVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117473832,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317552502,
    "dropfax": 6317552626
  },
  {
    "dcode": "D",
    "dropkey": "EV19160",
    "droptype": "S",
    "dropname": "NEW YORK",
    "dropdeladd": "341 9TH AVE RM A420",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 101999701,
    "dropphyadd": "341 9TH AVE RM A420",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 101999701,
    "dropmaladd": "341 9TH AVE RM A420",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 101999701,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123302772,
    "dropsitcph": 2123302770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "J001621",
    "droptype": "D",
    "dropname": "NORTHWEST ROCHESTER",
    "dropdeladd": "1700 LYELL AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146062393,
    "dropphyadd": "1700 LYELL AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146062393,
    "dropmaladd": "1700 LYELL AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146062393,
    "dropsitphn": 7168462415,
    "dropsitlph": "",
    "dropsitcph": 5854522100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV13364",
    "droptype": "S",
    "dropname": "QUEENS",
    "dropdeladd": "14202 20TH AVE RM 3166",
    "dropdelcty": "FLUSHING",
    "dropdelst": "NY",
    "dropdelzpp": 113519604,
    "dropphyadd": "14202 20TH AVE RM 3166",
    "dropphycty": "FLUSHING",
    "dropphyst": "NY",
    "dropphyzpp": 113519604,
    "dropmaladd": "14202 20TH AVE RM 3166",
    "dropmalcty": "FLUSHING",
    "dropmalst": "NY",
    "dropmalzpp": 113519604,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183215252,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "EV15731",
    "droptype": "S",
    "dropname": "ROCHESTER",
    "dropdeladd": "1335 JEFFERSON RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146929901,
    "dropphyadd": "1335 JEFFERSON RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146929901,
    "dropmaladd": "1335 JEFFERSON RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146929901,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852725616,
    "dropsitcph": 5852725901,
    "dropfax": 5852725864
  },
  {
    "dcode": "D",
    "dropkey": "EV16465",
    "droptype": "S",
    "dropname": "SYRACUSE",
    "dropdeladd": "5640 E TAFT RD",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132209997,
    "dropphyadd": "5640 E TAFT RD",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132209997,
    "dropmaladd": "5640 E TAFT RD",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132209997,
    "dropsitphn": 3154523422,
    "dropsitlph": 3154523455,
    "dropsitcph": 3154523422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV19219",
    "droptype": "S",
    "dropname": "WESTCHESTER",
    "dropdeladd": "1000 WESTCHESTER AVE",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 106101000,
    "dropphyadd": "1000 WESTCHESTER AVE",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 106101000,
    "dropmaladd": "PO BOX 9800",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 106109800,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 9146977000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV16969",
    "droptype": "S",
    "dropname": "WESTERN NASSAU",
    "dropdeladd": "830 STEWART AVE",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "NY",
    "dropdelzpp": 115999900,
    "dropphyadd": "830 STEWART AVE",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "NY",
    "dropphyzpp": 115999900,
    "dropmaladd": "830 STEWART AVE",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "NY",
    "dropmalzpp": 115999900,
    "dropsitphn": 5162287614,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162287502,
    "dropfax": 5162287555
  },
  {
    "dcode": "D",
    "dropkey": "EZ14476",
    "droptype": "S",
    "dropname": "LAS VEGAS",
    "dropdeladd": "1001 E SUNSET RD RM 1030",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891999998,
    "dropphyadd": "1001 E SUNSET RD RM 1054",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891999607,
    "dropmaladd": "1001 E SUNSET RD RM 1054",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891999607,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619453,
    "dropsitcph": 7023619453,
    "dropfax": 7028968427
  },
  {
    "dcode": "D",
    "dropkey": "E014235",
    "droptype": "D",
    "dropname": "LAS VEGAS MPA",
    "dropdeladd": "3755 E POST RD STE 110",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891207247,
    "dropphyadd": "3755 E POST RD STE 110",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891207247,
    "dropmaladd": "3755 E POST RD STE 110",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891209900,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028555903,
    "dropsitcph": 7028555912,
    "dropfax": 7028555908
  },
  {
    "dcode": "D",
    "dropkey": "EZ14577",
    "droptype": "S",
    "dropname": "RENO",
    "dropdeladd": "2000 VASSAR ST",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895109991,
    "dropphyadd": "2000 VASSAR ST",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895109991,
    "dropmaladd": "2000 VASSAR ST",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880676,
    "dropsitcph": 7757880676,
    "dropfax": 7757880692
  },
  {
    "dcode": "D",
    "dropkey": "E014226",
    "droptype": "D",
    "dropname": "VAN NUYS FSS",
    "dropdeladd": "15701 SHERMAN WAY",
    "dropdelcty": "VAN NUYS",
    "dropdelst": "CA",
    "dropdelzpp": 914064008,
    "dropphyadd": "15701 SHERMAN WAY",
    "dropphycty": "VAN NUYS",
    "dropphyst": "CA",
    "dropphyzpp": 914064008,
    "dropmaladd": "15701 SHERMAN WAY",
    "dropmalcty": "VAN NUYS",
    "dropmalst": "CA",
    "dropmalzpp": 914064008,
    "dropsitphn": 6617757800,
    "dropsitlph": "",
    "dropsitcph": 6617757800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX15987",
    "droptype": "D",
    "dropname": "PADUCAH",
    "dropdeladd": "300 S 4TH ST",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420039997,
    "dropphyadd": "300 S 4TH ST",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420039997,
    "dropmaladd": "PO BOX 1840",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420021840,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 2704449447,
    "dropfax": 2704445332
  },
  {
    "dcode": "D",
    "dropkey": "EY23369",
    "droptype": "S",
    "dropname": "BATON ROUGE",
    "dropdeladd": "8101 BLUEBONNET BLVD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708109998,
    "dropphyadd": "8101 BLUEBONNET BLVD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708109998,
    "dropmaladd": "8101 BLUEBONNET BLVD",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708109998,
    "dropsitphn": 5045891027,
    "dropsitlph": "",
    "dropsitcph": 2257633843,
    "dropfax": 2257633612
  },
  {
    "dcode": "D",
    "dropkey": "EY23983",
    "droptype": "S",
    "dropname": "LAFAYETTE",
    "dropdeladd": "1105 MOSS ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705013601,
    "dropphyadd": "1105 MOSS ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705013601,
    "dropmaladd": "1105 MOSS ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705019998,
    "dropsitphn": 5045891027,
    "dropsitlph": "",
    "dropsitcph": 3372697110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY24218",
    "droptype": "S",
    "dropname": "NEW ORLEANS",
    "dropdeladd": "701 LOYOLA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701139997,
    "dropphyadd": "701 LOYOLA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701139997,
    "dropmaladd": "701 LOYOLA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701139998,
    "dropsitphn": 5045891027,
    "dropsitlph": "",
    "dropsitcph": 5045891046,
    "dropfax": 5045891025
  },
  {
    "dcode": "D",
    "dropkey": "EZ17854",
    "droptype": "S",
    "dropname": "COLORADO SPRINGS",
    "dropdeladd": "3655 E FOUNTAIN BLVD",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809103733,
    "dropphyadd": "3655 E FOUNTAIN BLVD",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809103733,
    "dropmaladd": "3655 E FOUNTAIN BLVD STE 100",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809103799,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705336,
    "dropsitcph": 7195705336,
    "dropfax": 7195705478
  },
  {
    "dcode": "D",
    "dropkey": "EY24453",
    "droptype": "S",
    "dropname": "SHREVEPORT",
    "dropdeladd": "2400 TEXAS AVE",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711029991,
    "dropphyadd": "2400 TEXAS AVE",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711029991,
    "dropmaladd": "2400 TEXAS AVE",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711029991,
    "dropsitphn": 5045891027,
    "dropsitlph": 3186772333,
    "dropsitcph": 3186772295,
    "dropfax": 3186772275
  },
  {
    "dcode": "D",
    "dropkey": "EZ17853",
    "droptype": "S",
    "dropname": "DENVER",
    "dropdeladd": "7540 E 53RD PL",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802660001,
    "dropphyadd": "7540 E 53RD PL",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802660001,
    "dropmaladd": "7540 E 53RD PL",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802660001,
    "dropsitphn": 3032976511,
    "dropsitlph": 3032976510,
    "dropsitcph": 3038536480,
    "dropfax": 3038536291
  },
  {
    "dcode": "D",
    "dropkey": "EV21507",
    "droptype": "S",
    "dropname": "BOSTON",
    "dropdeladd": "25 DORCHESTER AVE RM 4025B",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "022050016",
    "dropphyadd": "25 DORCHESTER AVE RM 4025B",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "022050016",
    "dropmaladd": "25 DORCHESTER AVE RM 4025B",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "022050016",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6176545225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV21554",
    "droptype": "S",
    "dropname": "BROCKTON",
    "dropdeladd": "225 LIBERTY ST RM 234",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MA",
    "dropdelzpp": "023019701",
    "dropphyadd": "225 LIBERTY ST RM 234",
    "dropphycty": "BROCKTON",
    "dropphyst": "MA",
    "dropphyzpp": "023019701",
    "dropmaladd": "225 LIBERTY ST RM 234",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MA",
    "dropmalzpp": "023019701",
    "dropsitphn": 4017525649,
    "dropsitlph": 5084270159,
    "dropsitcph": 5084270214,
    "dropfax": 5085596763
  },
  {
    "dcode": "D",
    "dropkey": "EV27659",
    "droptype": "S",
    "dropname": "CENTRAL",
    "dropdeladd": "192 MAIN ST",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "MA",
    "dropdelzpp": "015460001",
    "dropphyadd": "192 MAIN ST",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "MA",
    "dropphyzpp": "015460001",
    "dropmaladd": "192 MAIN ST",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "MA",
    "dropmalzpp": "015460001",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087935915,
    "dropsitcph": 5087935104,
    "dropfax": 5087935995
  },
  {
    "dcode": "D",
    "dropkey": "EV22061",
    "droptype": "S",
    "dropname": "MIDDLESEX ESSEX",
    "dropdeladd": "76 MAIN ST",
    "dropdelcty": "NORTH READING",
    "dropdelst": "MA",
    "dropdelzpp": "018897001",
    "dropphyadd": "76 MAIN ST",
    "dropphycty": "NORTH READING",
    "dropphyst": "MA",
    "dropphyzpp": "018897001",
    "dropmaladd": "76 MAIN ST",
    "dropmalcty": "NORTH READING",
    "dropmalst": "MA",
    "dropmalzpp": "018897001",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647077,
    "dropsitcph": 9766647006,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "J013196",
    "droptype": "D",
    "dropname": "SPRINGFIELD LDC",
    "dropdeladd": "1800L PAGE BLVD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011529311",
    "dropphyadd": "1800L PAGE BLVD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011529311",
    "dropmaladd": "1800L PAGE BLVD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011529311",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4134522170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "KZ11305",
    "droptype": "B",
    "dropname": "DENVER NDC",
    "dropdeladd": "7755 E 56TH AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802665400,
    "dropphyadd": "7755 E 56TH AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802665400,
    "dropmaladd": "PO BOX 172000",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802172000,
    "dropsitphn": 3038532547,
    "dropsitlph": 3038532584,
    "dropsitcph": 3038532570,
    "dropfax": 3038532609
  },
  {
    "dcode": "D",
    "dropkey": "KV22551",
    "droptype": "B",
    "dropname": "SPRINGFIELD NDC",
    "dropdeladd": "1800 PAGE BLVD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011529903",
    "dropphyadd": "1800 PAGE BLVD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011529903",
    "dropmaladd": "190 FIBERLOID ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011529706",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4137856246,
    "dropfax": 4137856465
  },
  {
    "dcode": "D",
    "dropkey": "EV22931",
    "droptype": "S",
    "dropname": "BALTIMORE",
    "dropdeladd": "900 E FAYETTE ST RM 505",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212339998,
    "dropphyadd": "900 E FAYETTE ST RM 505",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212339998,
    "dropmaladd": "900 E FAYETTE ST RM 505",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212339998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474536,
    "dropsitcph": 4103474260,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "EZ11455",
    "droptype": "S",
    "dropname": "GRAND JUNCTION",
    "dropdeladd": "602 BURKEY ST",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "CO",
    "dropdelzpp": 815051148,
    "dropphyadd": "602 BURKEY ST",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "CO",
    "dropphyzpp": 815051148,
    "dropmaladd": "602 BURKEY ST",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "CO",
    "dropmalzpp": 815051148,
    "dropsitphn": 9702443436,
    "dropsitlph": 9702443440,
    "dropsitcph": 9702443439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E015406",
    "droptype": "D",
    "dropname": "CAPITAL BELTWAY FACILITY",
    "dropdeladd": "9151 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207909993,
    "dropphyadd": "9151 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207909993,
    "dropmaladd": "9151 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207909993,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3014997304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV27605",
    "droptype": "S",
    "dropname": "EASTERN SHORE",
    "dropdeladd": "29060 AIRPARK DR",
    "dropdelcty": "EASTON",
    "dropdelst": "MD",
    "dropdelzpp": 216019997,
    "dropphyadd": "29060 AIRPARK DR",
    "dropphycty": "EASTON",
    "dropphyst": "MD",
    "dropphyzpp": 216019997,
    "dropmaladd": "29060 AIRPARK DR",
    "dropmalcty": "EASTON",
    "dropmalst": "MD",
    "dropmalzpp": 216019997,
    "dropsitphn": 4107637740,
    "dropsitlph": "",
    "dropsitcph": 4107637700,
    "dropfax": 4107637799
  },
  {
    "dcode": "D",
    "dropkey": "E013304",
    "droptype": "D",
    "dropname": "BRADLEY ANNEX",
    "dropdeladd": "10 SCHOEPHOESTER RD",
    "dropdelcty": "WINDSOR LOCKS",
    "dropdelst": "CT",
    "dropdelzpp": "060969993",
    "dropphyadd": "10 SCHOEPHOESTER RD",
    "dropphycty": "WINDSOR LOCKS",
    "dropphyst": "CT",
    "dropphyzpp": "060969993",
    "dropmaladd": "10 SCHOEPHOESTER RD",
    "dropmalcty": "WINDSOR LOCKS",
    "dropmalst": "CT",
    "dropmalzpp": "060969993",
    "dropsitphn": 8602923308,
    "dropsitlph": "",
    "dropsitcph": 8602923308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV24400",
    "droptype": "S",
    "dropname": "SOUTHERN MARYLAND",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207909995,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207909995,
    "dropmaladd": "9201 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207909995,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3014997600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV27378",
    "droptype": "S",
    "dropname": "SUBURBAN MARYLAND",
    "dropdeladd": "16501 SHADY GROVE RD",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208989993,
    "dropphyadd": "16501 SHADY GROVE RD",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208989993,
    "dropmaladd": "16501 SHADY GROVE RD",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208989993,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016706008,
    "dropsitcph": 3016706049,
    "dropfax": 3016706515
  },
  {
    "dcode": "D",
    "dropkey": "EV20284",
    "droptype": "S",
    "dropname": "HARTFORD",
    "dropdeladd": "141 WESTON ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061019706",
    "dropphyadd": "141 WESTON ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061019706",
    "dropmaladd": "141 WESTON ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061019706",
    "dropsitphn": 8605246297,
    "dropsitlph": 8605246241,
    "dropsitcph": 8605246253,
    "dropfax": 8605246006
  },
  {
    "dcode": "D",
    "dropkey": "KV24594",
    "droptype": "B",
    "dropname": "WASHINGTON NDC",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207999997,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207999997,
    "dropmaladd": "9201 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207999997,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3014997331,
    "dropfax": 3014997651
  },
  {
    "dcode": "D",
    "dropkey": "EV27348",
    "droptype": "S",
    "dropname": "EASTERN MAINE",
    "dropdeladd": "16 PENOBSCOT MEADOW DR",
    "dropdelcty": "HAMPDEN",
    "dropdelst": "ME",
    "dropdelzpp": "044447099",
    "dropphyadd": "16 PENOBSCOT MEADOW DR",
    "dropphycty": "HAMPDEN",
    "dropphyst": "ME",
    "dropphyzpp": "044447099",
    "dropmaladd": "16 PENOBSCOT MEADOW DR",
    "dropmalcty": "HAMPDEN",
    "dropmalst": "ME",
    "dropmalzpp": "044447099",
    "dropsitphn": 2075102795,
    "dropsitlph": "",
    "dropsitcph": 2079412012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV27604",
    "droptype": "D",
    "dropname": "SOUTHERN CT",
    "dropdeladd": "24 RESEARCH PKWY",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929051",
    "dropphyadd": "24 RESEARCH PKWY",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929051",
    "dropmaladd": "24 RESEARCH PKWY",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929051",
    "dropsitphn": 2039493040,
    "dropsitlph": 2039493157,
    "dropsitcph": 2039493105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E007387",
    "droptype": "S",
    "dropname": "SOUTHERN MAINE",
    "dropdeladd": "79 POSTAL SERVICE WAY",
    "dropdelcty": "SCARBOROUGH",
    "dropdelst": "ME",
    "dropdelzpp": "040747001",
    "dropphyadd": "79 POSTAL SERVICE WAY",
    "dropphycty": "SCARBOROUGH",
    "dropphyst": "ME",
    "dropphyzpp": "040747001",
    "dropmaladd": "79 POSTAL SERVICE WAY",
    "dropmalcty": "SCARBOROUGH",
    "dropmalst": "ME",
    "dropmalzpp": "040747001",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075102793,
    "dropsitcph": 2075102800,
    "dropfax": 2075102786
  },
  {
    "dcode": "D",
    "dropkey": "EV20670",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "427 WEST AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069101002",
    "dropphyadd": "427 WEST AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069101002",
    "dropmaladd": "427 WEST AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069101002",
    "dropsitphn": 2033262038,
    "dropsitlph": 2033262038,
    "dropsitcph": 2033262038,
    "dropfax": 2033262153
  },
  {
    "dcode": "D",
    "dropkey": "EY11740",
    "droptype": "S",
    "dropname": "DETROIT",
    "dropdeladd": "1401 W FORT ST RM 1022",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482339997,
    "dropphyadd": "1401 W FORT ST RM 1022",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482339997,
    "dropmaladd": "1401 W FORT ST RM 1022",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482339997,
    "dropsitphn": 3132268558,
    "dropsitlph": 3133372132,
    "dropsitcph": 3132268315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "KY11741",
    "droptype": "B",
    "dropname": "DETROIT NDC",
    "dropdeladd": "17500 OAKWOOD BLVD",
    "dropdelcty": "ALLEN PARK",
    "dropdelst": "MI",
    "dropdelzpp": 481012775,
    "dropphyadd": "17500 OAKWOOD BLVD",
    "dropphycty": "ALLEN PARK",
    "dropphyst": "MI",
    "dropphyzpp": 481012775,
    "dropmaladd": "17500 OAKWOOD BLVD",
    "dropmalcty": "ALLEN PARK",
    "dropmalst": "MI",
    "dropmalzpp": 481012775,
    "dropsitphn": 3133372172,
    "dropsitlph": 3133372132,
    "dropsitcph": 3133372100,
    "dropfax": 3133372108
  },
  {
    "dcode": "D",
    "dropkey": "EY11978",
    "droptype": "S",
    "dropname": "GRAND RAPIDS",
    "dropdeladd": "225 MICHIGAN ST NW",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495019900,
    "dropphyadd": "225 MICHIGAN ST NW",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495019900,
    "dropmaladd": "225 MICHIGAN ST NW",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495019900,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6167761416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY18410",
    "droptype": "S",
    "dropname": "IRON MOUNTAIN",
    "dropdeladd": "700 W BREITUNG AVE",
    "dropdelcty": "KINGSFORD",
    "dropdelst": "MI",
    "dropdelzpp": 498029996,
    "dropphyadd": "700 W BREITUNG AVE",
    "dropphycty": "KINGSFORD",
    "dropphyst": "MI",
    "dropphyzpp": 498029996,
    "dropmaladd": "700 W BREITUNG AVE",
    "dropmalcty": "KINGSFORD",
    "dropmalst": "MI",
    "dropmalzpp": 498029996,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 9067762002,
    "dropfax": 9067762032
  },
  {
    "dcode": "D",
    "dropkey": "EY12219",
    "droptype": "S",
    "dropname": "LANSING",
    "dropdeladd": "4800 COLLINS RD",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489249700,
    "dropphyadd": "4800 COLLINS RD",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489249700,
    "dropmaladd": "4800 COLLINS RD",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489249700,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173378775,
    "dropsitcph": 5173378872,
    "dropfax": 5173374843
  },
  {
    "dcode": "D",
    "dropkey": "E010600",
    "droptype": "S",
    "dropname": "MICHIGAN METROPLEX",
    "dropdeladd": "711 N GLENWOOD AVE",
    "dropdelcty": "PONTIAC",
    "dropdelst": "MI",
    "dropdelzpp": 483409991,
    "dropphyadd": "711 N GLENWOOD AVE",
    "dropphycty": "PONTIAC",
    "dropphyst": "MI",
    "dropphyzpp": 483409991,
    "dropmaladd": "711 N GLENWOOD AVE",
    "dropmalcty": "PONTIAC",
    "dropmalst": "MI",
    "dropmalzpp": 483409991,
    "dropsitphn": 2487585622,
    "dropsitlph": 2487585622,
    "dropsitcph": 2487585596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY12982",
    "droptype": "S",
    "dropname": "TRAVERSE CITY",
    "dropdeladd": "1801 GARFIELD RD N",
    "dropdelcty": "TRAVERSE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496969997,
    "dropphyadd": "1801 GARFIELD RD N",
    "dropphycty": "TRAVERSE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496969997,
    "dropmaladd": "1801 GARFIELD RD N",
    "dropmalcty": "TRAVERSE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496969997,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319331040,
    "dropsitcph": 2319465217,
    "dropfax": 2319331055
  },
  {
    "dcode": "D",
    "dropkey": "EY25161",
    "droptype": "D",
    "dropname": "DULUTH",
    "dropdeladd": "2800 W MICHIGAN ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558069998,
    "dropphyadd": "2800 W MICHIGAN ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558069998,
    "dropmaladd": "2800 W MICHIGAN ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558069998,
    "dropsitphn": 2187232565,
    "dropsitlph": 2187232575,
    "dropsitcph": 2187232565,
    "dropfax": 2187232557
  },
  {
    "dcode": "D",
    "dropkey": "EV21176",
    "droptype": "S",
    "dropname": "WASHINGTON",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189992,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189992,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189992,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361972,
    "dropsitcph": 2026361972,
    "dropfax": 2025231212
  },
  {
    "dcode": "D",
    "dropkey": "EV21380",
    "droptype": "S",
    "dropname": "WILMINGTON",
    "dropdeladd": "147 QUIGLEY BLVD",
    "dropdelcty": "HISTORIC NEW CASTLE",
    "dropdelst": "DE",
    "dropdelzpp": 197204183,
    "dropphyadd": "147 QUIGLEY BLVD",
    "dropphycty": "HISTORIC NEW CASTLE",
    "dropphyst": "DE",
    "dropphyzpp": 197204183,
    "dropmaladd": "PO BOX 10000",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198509996,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023232260,
    "dropfax": 3023232163
  },
  {
    "dcode": "D",
    "dropkey": "EY21885",
    "droptype": "S",
    "dropname": "FORT MYERS",
    "dropdeladd": "14080 JETPORT LOOP RM B-111",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339139997,
    "dropphyadd": "14080 JETPORT LOOP RM B-111",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339139997,
    "dropmaladd": "14080 JETPORT LOOP RM B-111",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339139997,
    "dropsitphn": 8138770729,
    "dropsitlph": 2397688083,
    "dropsitcph": 2397688045,
    "dropfax": 2397688006
  },
  {
    "dcode": "D",
    "dropkey": "EY21914",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "4600 SW 34TH ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326089997,
    "dropphyadd": "4600 SW 34TH ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326089997,
    "dropmaladd": "4600 SW 34TH ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326089997,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341870,
    "dropsitcph": 3523341899,
    "dropfax": 3523341844
  },
  {
    "dcode": "D",
    "dropkey": "EY22124",
    "droptype": "S",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "1100 KINGS RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322039996,
    "dropphyadd": "1100 KINGS RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322039996,
    "dropmaladd": "1100 KINGS RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322039996,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043592819,
    "dropsitcph": 9043664892,
    "dropfax": 9043664866
  },
  {
    "dcode": "D",
    "dropkey": "KY22125",
    "droptype": "B",
    "dropname": "JACKSONVILLE NDC",
    "dropdeladd": "7415 COMMONWEALTH AVE",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 320990002,
    "dropphyadd": "7415 COMMONWEALTH AVE",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 320990002,
    "dropmaladd": "PO BOX 2000",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322032000,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047837115,
    "dropsitcph": 9047837176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY25758",
    "droptype": "S",
    "dropname": "MANKATO",
    "dropdeladd": "851 SUMMIT AVE",
    "dropdelcty": "MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560019997,
    "dropphyadd": "851 SUMMIT AVE",
    "dropphycty": "MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560019997,
    "dropmaladd": "851 SUMMIT AVE",
    "dropmalcty": "MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560019997,
    "dropsitphn": 6123499163,
    "dropsitlph": 5076257527,
    "dropsitcph": 5076252320,
    "dropfax": 5073886851
  },
  {
    "dcode": "D",
    "dropkey": "EY25844",
    "droptype": "S",
    "dropname": "MINNEAPOLIS",
    "dropdeladd": "100 S 1ST ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554011041,
    "dropphyadd": "100 S 1ST ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554011041,
    "dropmaladd": "100 S 1ST ST RM 127",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496346,
    "dropsitcph": 6123494957,
    "dropfax": 6123496377
  },
  {
    "dcode": "D",
    "dropkey": "EY22324",
    "droptype": "S",
    "dropname": "MANASOTA",
    "dropdeladd": "850 TALLEVAST RD",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342605000,
    "dropphyadd": "850 TALLEVAST RD",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342605000,
    "dropmaladd": "850 TALLEVAST RD STE 9998",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342609998,
    "dropsitphn": 9413595154,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413595109,
    "dropfax": 9413595177
  },
  {
    "dcode": "D",
    "dropkey": "KY26253",
    "droptype": "B",
    "dropname": "MINNEAPOLIS SAINT PAUL NDC",
    "dropdeladd": "3165 LEXINGTON AVE S BLDG 1",
    "dropdelcty": "EAGAN",
    "dropdelst": "MN",
    "dropdelzpp": 551212547,
    "dropphyadd": "3165 LEXINGTON AVE S",
    "dropphycty": "EAGAN",
    "dropphyst": "MN",
    "dropphyzpp": 551212539,
    "dropmaladd": "3165 LEXINGTON AVE S",
    "dropmalcty": "EAGAN",
    "dropmalst": "MN",
    "dropmalzpp": 551212288,
    "dropsitphn": 6126812226,
    "dropsitlph": 6126812141,
    "dropsitcph": 6516812131,
    "dropfax": 6516812102
  },
  {
    "dcode": "D",
    "dropkey": "EY22387",
    "droptype": "S",
    "dropname": "MIAMI",
    "dropdeladd": "2200 NW 72ND AVE STE 200",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331529997,
    "dropphyadd": "2200 NW 72ND AVE STE 200",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331529997,
    "dropmaladd": "2200 NW 72ND AVE STE 200",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331529997,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055910479,
    "dropsitcph": 3054700479,
    "dropfax": 3054700364
  },
  {
    "dcode": "D",
    "dropkey": "E003997",
    "droptype": "D",
    "dropname": "MIAMI ISC",
    "dropdeladd": "11698 NW 25TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331129997,
    "dropphyadd": "11698 NW 25TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331129997,
    "dropmaladd": "11698 NW 25TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331129997,
    "dropsitphn": 3054700746,
    "dropsitlph": "",
    "dropsitcph": 3057187475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY22406",
    "droptype": "D",
    "dropname": "MID FLORIDA",
    "dropdeladd": "800 RINEHART RD",
    "dropdelcty": "MID FLORIDA",
    "dropdelst": "FL",
    "dropdelzpp": 327998805,
    "dropphyadd": "800 RINEHART RD",
    "dropphycty": "MID FLORIDA",
    "dropphyst": "FL",
    "dropphyzpp": 327998805,
    "dropmaladd": "PO BOX 999997",
    "dropmalcty": "MID FLORIDA",
    "dropmalst": "FL",
    "dropmalzpp": 327999997,
    "dropsitphn": 4073338496,
    "dropsitlph": 4073338496,
    "dropsitcph": 4073338400,
    "dropfax": 4073338475
  },
  {
    "dcode": "D",
    "dropkey": "E013150",
    "droptype": "S",
    "dropname": "SAINT PAUL",
    "dropdeladd": "3165 LEXINGTON AVE S BLDG 2",
    "dropdelcty": "EAGAN",
    "dropdelst": "MN",
    "dropdelzpp": 551212548,
    "dropphyadd": "3232 DENMARK AVE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551211366,
    "dropmaladd": "PO BOX 645002",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551645002,
    "dropsitphn": 6123494928,
    "dropsitlph": 6516812625,
    "dropsitcph": 6516812526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY22610",
    "droptype": "S",
    "dropname": "ORLANDO",
    "dropdeladd": "10401 POST OFFICE BLVD W FL 1",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328628400,
    "dropphyadd": "10401 POST OFFICE BLVD W FL 1",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328628400,
    "dropmaladd": "PO BOX 620044",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328620044,
    "dropsitphn": 4078265608,
    "dropsitlph": 4078506334,
    "dropsitcph": 4078506203,
    "dropfax": 4078506328
  },
  {
    "dcode": "D",
    "dropkey": "EY22687",
    "droptype": "S",
    "dropname": "PENSACOLA",
    "dropdeladd": "1400 W JORDAN ST",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325019998,
    "dropphyadd": "1400 W JORDAN ST",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325019996,
    "dropmaladd": "PO BOX 17000",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504349124,
    "dropsitcph": 8504349182,
    "dropfax": 8504388575
  },
  {
    "dcode": "D",
    "dropkey": "EY26241",
    "droptype": "S",
    "dropname": "WAITE PARK",
    "dropdeladd": "517 10TH AVE S",
    "dropdelcty": "WAITE PARK",
    "dropdelst": "MN",
    "dropdelzpp": 563871519,
    "dropphyadd": "517 10TH AVE S",
    "dropphycty": "WAITE PARK",
    "dropphyst": "MN",
    "dropphyzpp": 563871519,
    "dropmaladd": "517 10TH AVE S",
    "dropmalcty": "WAITE PARK",
    "dropmalst": "MN",
    "dropmalzpp": 563871519,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202513876,
    "dropfax": 3202513984
  },
  {
    "dcode": "D",
    "dropkey": "EW16080",
    "droptype": "D",
    "dropname": "CAPE GIRARDEAU",
    "dropdeladd": "475 KELL FARM DR",
    "dropdelcty": "CAPE GIRARDEAU",
    "dropdelst": "MO",
    "dropdelzpp": 637019706,
    "dropphyadd": "475 KELL FARM DR",
    "dropphycty": "CAPE GIRARDEAU",
    "dropphyst": "MO",
    "dropphyzpp": 637019706,
    "dropmaladd": "475 KELL FARM DR",
    "dropmalcty": "CAPE GIRARDEAU",
    "dropmalst": "MO",
    "dropmalzpp": 637019706,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165043331,
    "dropsitcph": 5733310800,
    "dropfax": 5733310863
  },
  {
    "dcode": "D",
    "dropkey": "EW1B651",
    "droptype": "S",
    "dropname": "KANSAS CITY",
    "dropdeladd": "1700 CLEVELAND AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641219997,
    "dropphyadd": "1700 CLEVELAND AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641219997,
    "dropmaladd": "1700 CLEVELAND AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641219997,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165043200,
    "dropsitcph": 8163749121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW17241",
    "droptype": "S",
    "dropname": "MID MISSOURI",
    "dropdeladd": "11450 S AIRPORT DR",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652999997,
    "dropphyadd": "11450 S AIRPORT DR",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652999997,
    "dropmaladd": "11450 S AIRPORT DR",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652999997,
    "dropsitphn": 3144363601,
    "dropsitlph": "",
    "dropsitcph": 5738746558,
    "dropfax": 5738746501
  },
  {
    "dcode": "D",
    "dropkey": "EW17797",
    "droptype": "S",
    "dropname": "SAINT LOUIS",
    "dropdeladd": "1720 MARKET ST RM 3025",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631559997,
    "dropphyadd": "1720 MARKET ST RM 3025",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631559997,
    "dropmaladd": "1720 MARKET ST RM 3025",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631559997,
    "dropsitphn": 3144363601,
    "dropsitlph": 3144364160,
    "dropsitcph": 3144364117,
    "dropfax": 3144364565
  },
  {
    "dcode": "D",
    "dropkey": "E001692",
    "droptype": "D",
    "dropname": "SAINT LOUIS METRO ANNEX",
    "dropdeladd": "5463 PHANTOM DR",
    "dropdelcty": "HAZELWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630422468,
    "dropphyadd": "5463 PHANTOM DR",
    "dropphycty": "HAZELWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630422468,
    "dropmaladd": "5463 PHANTOM DR",
    "dropmalcty": "HAZELWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630422468,
    "dropsitphn": 3144363601,
    "dropsitlph": "",
    "dropsitcph": 3145067203,
    "dropfax": 3148954225
  },
  {
    "dcode": "D",
    "dropkey": "J011833",
    "droptype": "D",
    "dropname": "ROYAL PALM",
    "dropdeladd": "5500 NW 142ND ST",
    "dropdelcty": "OPA LOCKA",
    "dropdelst": "FL",
    "dropdelzpp": 330549997,
    "dropphyadd": "5500 NW 142ND ST",
    "dropphycty": "OPA LOCKA",
    "dropphyst": "FL",
    "dropphyzpp": 330549997,
    "dropmaladd": "5500 NW 142ND ST",
    "dropmalcty": "OPA LOCKA",
    "dropmalst": "FL",
    "dropmalzpp": 330549997,
    "dropsitphn": 3055132368,
    "dropsitlph": 3059535604,
    "dropsitcph": 3059535694,
    "dropfax": 3059535608
  },
  {
    "dcode": "D",
    "dropkey": "KW17798",
    "droptype": "B",
    "dropname": "SAINT LOUIS NDC",
    "dropdeladd": "5800 PHANTOM DR",
    "dropdelcty": "HAZELWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630422487,
    "dropphyadd": "5800 PHANTOM DR",
    "dropphycty": "HAZELWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630422487,
    "dropmaladd": "5800 PHANTOM DR",
    "dropmalcty": "HAZELWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630422487,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 3148959270,
    "dropfax": 3148959346
  },
  {
    "dcode": "D",
    "dropkey": "EW17988",
    "droptype": "S",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "500 W CHESTNUT EXPY",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658019997,
    "dropphyadd": "500 W CHESTNUT EXPY",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658019997,
    "dropmaladd": "500 W CHESTNUT EXPY",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658019997,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165043331,
    "dropsitcph": 4178640199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY13699",
    "droptype": "S",
    "dropname": "GULFPORT",
    "dropdeladd": "10285 CORPORATE DR",
    "dropdelcty": "GULFPORT",
    "dropdelst": "MS",
    "dropdelzpp": 395039997,
    "dropphyadd": "10285 CORPORATE DR",
    "dropphycty": "GULFPORT",
    "dropphyst": "MS",
    "dropphyzpp": 395039997,
    "dropmaladd": "10285 CORPORATE DR",
    "dropmalcty": "GULFPORT",
    "dropmalst": "MS",
    "dropmalzpp": 395039997,
    "dropsitphn": 6013517144,
    "dropsitlph": 2288977580,
    "dropsitcph": 2288977500,
    "dropfax": 2288977575
  },
  {
    "dcode": "D",
    "dropkey": "EY13800",
    "droptype": "S",
    "dropname": "JACKSON",
    "dropdeladd": "401 E SOUTH ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392019997,
    "dropphyadd": "401 E SOUTH ST",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392019997,
    "dropmaladd": "PO BOX 99997",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392059997,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517097,
    "dropsitcph": 6013517079,
    "dropfax": 6013517511
  },
  {
    "dcode": "D",
    "dropkey": "EZ13044",
    "droptype": "S",
    "dropname": "BILLINGS",
    "dropdeladd": "841 S 26TH ST",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591019998,
    "dropphyadd": "841 S 26TH ST",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591019998,
    "dropmaladd": "841 S 26TH ST RM 8",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591019186,
    "dropsitphn": 4066575601,
    "dropsitlph": "",
    "dropsitcph": 4066575745,
    "dropfax": 4066575788
  },
  {
    "dcode": "D",
    "dropkey": "J003322",
    "droptype": "D",
    "dropname": "SEMINOLE",
    "dropdeladd": "2036 E LANDSTREET RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328247952,
    "dropphyadd": "2036 E LANDSTREET RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328247952,
    "dropmaladd": "2036 E LANDSTREET RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328247952,
    "dropsitphn": 4078121110,
    "dropsitlph": 4078121110,
    "dropsitcph": 4078121135,
    "dropfax": 4078121101
  },
  {
    "dcode": "D",
    "dropkey": "EZ13197",
    "droptype": "S",
    "dropname": "GREAT FALLS",
    "dropdeladd": "1409 14TH ST SW",
    "dropdelcty": "GREAT FALLS",
    "dropdelst": "MT",
    "dropdelzpp": 594049991,
    "dropphyadd": "1409 14TH ST SW",
    "dropphycty": "GREAT FALLS",
    "dropphyst": "MT",
    "dropphyzpp": 594049991,
    "dropmaladd": "1409 14TH ST SW",
    "dropmalcty": "GREAT FALLS",
    "dropmalst": "MT",
    "dropmalzpp": 594049991,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4067912597,
    "dropfax": 4067612570
  },
  {
    "dcode": "D",
    "dropkey": "EY23072",
    "droptype": "S",
    "dropname": "TALLAHASSEE",
    "dropdeladd": "2800 S ADAMS ST",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323019996,
    "dropphyadd": "2800 S ADAMS ST",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323019996,
    "dropmaladd": "2800 S ADAMS ST",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323019996,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502164282,
    "dropsitcph": 8502164364,
    "dropfax": 8502164301
  },
  {
    "dcode": "D",
    "dropkey": "EY23078",
    "droptype": "S",
    "dropname": "TAMPA",
    "dropdeladd": "3501 BESSIE COLEMAN BLVD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336305009,
    "dropphyadd": "3501 BESSIE COLEMAN BLVD FL 2",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336305012,
    "dropmaladd": "PO BOX 39997",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336309997,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138770612,
    "dropfax": 8138770360
  },
  {
    "dcode": "D",
    "dropkey": "EZ13303",
    "droptype": "S",
    "dropname": "MISSOULA",
    "dropdeladd": "1100 W KENT AVE",
    "dropdelcty": "MISSOULA",
    "dropdelst": "MT",
    "dropdelzpp": 598019952,
    "dropphyadd": "1100 W KENT AVE",
    "dropphycty": "MISSOULA",
    "dropphyst": "MT",
    "dropphyzpp": 598019952,
    "dropmaladd": "1100 W KENT AVE",
    "dropmalcty": "MISSOULA",
    "dropmalst": "MT",
    "dropmalzpp": 598019952,
    "dropsitphn": 4066575713,
    "dropsitlph": "",
    "dropsitcph": 4063292248,
    "dropfax": 4063292280
  },
  {
    "dcode": "D",
    "dropkey": "EY14992",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "2901 SCOTT FUTRELL DR",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282289880,
    "dropphyadd": "2901 SCOTT FUTRELL DR",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282289880,
    "dropmaladd": "2901 SCOTT FUTRELL DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282289880,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7043934444,
    "dropfax": 7043934476
  },
  {
    "dcode": "D",
    "dropkey": "EY23233",
    "droptype": "S",
    "dropname": "WEST PALM BEACH",
    "dropdeladd": "3200 SUMMIT BLVD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334163524,
    "dropphyadd": "3200 SUMMIT BLVD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334163524,
    "dropmaladd": "PO BOX 169997",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334169997,
    "dropsitphn": 5616972122,
    "dropsitlph": 5616972122,
    "dropsitcph": 5616972165,
    "dropfax": 5616971970
  },
  {
    "dcode": "D",
    "dropkey": "J007646",
    "droptype": "D",
    "dropname": "YBOR CITY",
    "dropdeladd": "1801 GRANT ST",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336056001,
    "dropphyadd": "1801 GRANT ST",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336056001,
    "dropmaladd": "1801 GRANT ST",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336056001,
    "dropsitphn": 8132487505,
    "dropsitlph": 8132487505,
    "dropsitcph": 8132487500,
    "dropfax": 8132487527
  },
  {
    "dcode": "D",
    "dropkey": "EX10054",
    "droptype": "S",
    "dropname": "ATLANTA GA LPC",
    "dropdeladd": "3900 CROWN RD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303049997,
    "dropphyadd": "3900 CROWN RD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303049997,
    "dropmaladd": "3900 CROWN RD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303049997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047657578,
    "dropsitcph": 4047657300,
    "dropfax": 4047657299
  },
  {
    "dcode": "D",
    "dropkey": "KX10055",
    "droptype": "B",
    "dropname": "ATLANTA NDC",
    "dropdeladd": "1800 JAMES JACKSON PKWY NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303699998,
    "dropphyadd": "1800 JAMES JACKSON PKWY NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303699998,
    "dropmaladd": "1800 JAMES JACKSON PKWY NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303699998,
    "dropsitphn": 4047923125,
    "dropsitlph": 4047923008,
    "dropsitcph": 4047923270,
    "dropfax": 4047923293
  },
  {
    "dcode": "D",
    "dropkey": "EX10064",
    "droptype": "S",
    "dropname": "AUGUSTA GA LPC",
    "dropdeladd": "525 8TH ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309019997,
    "dropphyadd": "525 8TH ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309019997,
    "dropmaladd": "525 8TH ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309019997,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068233116,
    "dropsitcph": 7068233116,
    "dropfax": 7068231622
  },
  {
    "dcode": "D",
    "dropkey": "EX1C700",
    "droptype": "D",
    "dropname": "HOLT AVE GA ANNEX",
    "dropdeladd": "595 HOLT AVE",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312049996,
    "dropphyadd": "595 HOLT AVE",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312049996,
    "dropmaladd": "451 COLLEGE ST",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312139997,
    "dropsitphn": 4787528444,
    "dropsitlph": 4787528452,
    "dropsitcph": 4787439152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EX10767",
    "droptype": "S",
    "dropname": "MACON GA LPC",
    "dropdeladd": "451 COLLEGE ST",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312139997,
    "dropphyadd": "451 COLLEGE ST",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312139997,
    "dropmaladd": "451 COLLEGE ST",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312139997,
    "dropsitphn": 4787528444,
    "dropsitlph": 4787528444,
    "dropsitcph": 4787528435,
    "dropfax": 4787528401
  },
  {
    "dcode": "D",
    "dropkey": "EX10915",
    "droptype": "S",
    "dropname": "DULUTH GA LPC",
    "dropdeladd": "1605 BOGGS RD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300961876,
    "dropphyadd": "1605 BOGGS RD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300961876,
    "dropmaladd": "PO BOX 599000",
    "dropmalcty": "NORTH METRO",
    "dropmalst": "GA",
    "dropmalzpp": 300269000,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707173700,
    "dropsitcph": 7707173700,
    "dropfax": 7707173452
  },
  {
    "dcode": "D",
    "dropkey": "EY15308",
    "droptype": "S",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "301 GREEN ST STE 200",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283015099,
    "dropphyadd": "301 GREEN ST STE 200",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283015099,
    "dropmaladd": "PO BOX 28302",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283029998,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 9104862311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E001910",
    "droptype": "D",
    "dropname": "FAYETTEVILLE NC ANNEX",
    "dropdeladd": "2507 DOWNING RD",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283128225,
    "dropphyadd": "2507 DOWNING RD",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283128225,
    "dropmaladd": "2507 DOWNING RD",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283128225,
    "dropsitphn": 7043934444,
    "dropsitlph": 9102233616,
    "dropsitcph": 9102233600,
    "dropfax": 9102233656
  },
  {
    "dcode": "D",
    "dropkey": "E018851",
    "droptype": "D",
    "dropname": "SOUTH MACON ANNEX",
    "dropdeladd": "1740 ROCKY CREEK RD REAR",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312069996,
    "dropphyadd": "1740 ROCKY CREEK RD REAR",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312069996,
    "dropmaladd": "1740 ROCKY CREEK RD REAR",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312069996,
    "dropsitphn": 4787528466,
    "dropsitlph": "",
    "dropsitcph": 4787843911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EZ12185",
    "droptype": "S",
    "dropname": "HONOLULU",
    "dropdeladd": "3600 AOLELE ST RM 208E",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968209500,
    "dropphyadd": "3600 AOLELE ST RM 208E",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968209500,
    "dropmaladd": "3600 AOLELE ST RM 208E",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968209500,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084233840,
    "dropsitcph": 8084233700,
    "dropfax": 8084233902
  },
  {
    "dcode": "D",
    "dropkey": "EW10239",
    "droptype": "S",
    "dropname": "CEDAR RAPIDS",
    "dropdeladd": "615 6TH AVE SE",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 524019997,
    "dropphyadd": "615 6TH AVE SE",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 524019997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 524069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193992946,
    "dropsitcph": 3193995560,
    "dropfax": 3193992983
  },
  {
    "dcode": "D",
    "dropkey": "EW10400",
    "droptype": "S",
    "dropname": "DES MOINES",
    "dropdeladd": "1165 2ND AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503189997,
    "dropphyadd": "1165 2ND AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503189997,
    "dropmaladd": "1165 2ND AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503189997,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152837530,
    "dropsitcph": 5152837582,
    "dropfax": 5152837665
  },
  {
    "dcode": "D",
    "dropkey": "KW10401",
    "droptype": "B",
    "dropname": "DES MOINES NDC",
    "dropdeladd": "4000 109TH ST",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503950001,
    "dropphyadd": "4000 109TH ST",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503950001,
    "dropmaladd": "4000 109TH ST",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503950001,
    "dropsitphn": 5152787617,
    "dropsitlph": 5152787621,
    "dropsitcph": 5152512330,
    "dropfax": 5152787635
  },
  {
    "dcode": "D",
    "dropkey": "EW11692",
    "droptype": "S",
    "dropname": "WATERLOO",
    "dropdeladd": "300 SYCAMORE ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "IA",
    "dropdelzpp": 507014649,
    "dropphyadd": "300 SYCAMORE ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "IA",
    "dropphyzpp": 507014649,
    "dropmaladd": "300 SYCAMORE ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "IA",
    "dropmalzpp": 507014649,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192742221,
    "dropsitcph": 3192742200,
    "dropfax": 3192742275
  },
  {
    "dcode": "D",
    "dropkey": "KZ12429",
    "droptype": "S",
    "dropname": "BOISE ID RPDC",
    "dropdeladd": "2201 S COLE RD",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837089997,
    "dropphyadd": "2201 S COLE RD",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837089997,
    "dropmaladd": "2201 S COLE RD",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837089997,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084334000,
    "dropsitcph": 2084334000,
    "dropfax": 2084333996
  },
  {
    "dcode": "D",
    "dropkey": "EZ12818",
    "droptype": "D",
    "dropname": "POCATELLO ID LPC",
    "dropdeladd": "1750 FLANDRO DR",
    "dropdelcty": "POCATELLO",
    "dropdelst": "ID",
    "dropdelzpp": 832021970,
    "dropphyadd": "1750 FLANDRO DR",
    "dropphycty": "POCATELLO",
    "dropphyst": "ID",
    "dropphyzpp": 832021970,
    "dropmaladd": "1750 FLANDRO DR",
    "dropmalcty": "POCATELLO",
    "dropmalst": "ID",
    "dropmalzpp": 832021970,
    "dropsitphn": 2082355501,
    "dropsitlph": 2084334080,
    "dropsitcph": 2082352190,
    "dropfax": 2082355550
  },
  {
    "dcode": "D",
    "dropkey": "EY15457",
    "droptype": "S",
    "dropname": "GREENSBORO",
    "dropdeladd": "1120 PLEASANT RIDGE RD",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274989795,
    "dropphyadd": "1120 PLEASANT RIDGE RD",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274989795,
    "dropmaladd": "PO BOX 27490",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274989700,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369319400,
    "dropfax": 3369319406
  },
  {
    "dcode": "D",
    "dropkey": "EW12295",
    "droptype": "S",
    "dropname": "CAROL STREAM",
    "dropdeladd": "500 FULLERTON AVE",
    "dropdelcty": "CAROL STREAM",
    "dropdelst": "IL",
    "dropdelzpp": 601999997,
    "dropphyadd": "500 FULLERTON AVE",
    "dropphycty": "CAROL STREAM",
    "dropphyst": "IL",
    "dropphyzpp": 601999997,
    "dropmaladd": "500 FULLERTON AVE",
    "dropmalcty": "CAROL STREAM",
    "dropmalst": "IL",
    "dropmalzpp": 601999997,
    "dropsitphn": 6302605499,
    "dropsitlph": 6302605412,
    "dropsitcph": 6302605251,
    "dropfax": 6302605179
  },
  {
    "dcode": "D",
    "dropkey": "EW12356",
    "droptype": "S",
    "dropname": "CHAMPAIGN",
    "dropdeladd": "2001 N MATTIS AVE",
    "dropdelcty": "CHAMPAIGN",
    "dropdelst": "IL",
    "dropdelzpp": 618219997,
    "dropphyadd": "2001 N MATTIS AVE",
    "dropphycty": "CHAMPAIGN",
    "dropphyst": "IL",
    "dropphyzpp": 618219997,
    "dropmaladd": "2001 N MATTIS AVE",
    "dropmalcty": "CHAMPAIGN",
    "dropmalst": "IL",
    "dropmalzpp": 618219997,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173136018,
    "dropfax": 2173736004
  },
  {
    "dcode": "D",
    "dropkey": "KY15460",
    "droptype": "B",
    "dropname": "GREENSBORO NDC",
    "dropdeladd": "3701 W WENDOVER AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274950001,
    "dropphyadd": "3701 W WENDOVER AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274950001,
    "dropmaladd": "3701 W WENDOVER AVE",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274950001,
    "dropsitphn": 3368554318,
    "dropsitlph": 3368554324,
    "dropsitcph": 3368554290,
    "dropfax": 3368554323
  },
  {
    "dcode": "D",
    "dropkey": "EW12399",
    "droptype": "S",
    "dropname": "CHICAGO",
    "dropdeladd": "433 W HARRISON ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606993916,
    "dropphyadd": "433 W HARRISON ST STE 3012A",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999997,
    "dropmaladd": "433 W HARRISON ST STE 3012A",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999997,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3129837550,
    "dropfax": 3129837590
  },
  {
    "dcode": "D",
    "dropkey": "E008903",
    "droptype": "S",
    "dropname": "CHARLOTTE NC LPC",
    "dropdeladd": "1820 W POINTE DR STE A",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282149106,
    "dropphyadd": "1820 W POINTE DR STE A",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282149106,
    "dropmaladd": "2901 SCOTT FUTRELL DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282289830,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7043985553,
    "dropfax": 7043934463
  },
  {
    "dcode": "D",
    "dropkey": "EY16259",
    "droptype": "S",
    "dropname": "RALEIGH",
    "dropdeladd": "1 FLORETTA PL",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276769900,
    "dropphyadd": "1 FLORETTA PL",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276769900,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276769997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205106,
    "dropfax": 9194205357
  },
  {
    "dcode": "D",
    "dropkey": "KW12400",
    "droptype": "B",
    "dropname": "CHICAGO NDC",
    "dropdeladd": "7500 ROOSEVELT RD",
    "dropdelcty": "FOREST PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601302296,
    "dropphyadd": "7500 ROOSEVELT RD",
    "dropphycty": "FOREST PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601302296,
    "dropmaladd": "7500 ROOSEVELT RD",
    "dropmalcty": "FOREST PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601302296,
    "dropsitphn": 7085834294,
    "dropsitlph": 7084883220,
    "dropsitcph": 7085834521,
    "dropfax": 7085834550
  },
  {
    "dcode": "D",
    "dropkey": "EY16330",
    "droptype": "S",
    "dropname": "ROCKY MOUNT",
    "dropdeladd": "327 E RALEIGH BLVD",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278019908,
    "dropphyadd": "327 E RALEIGH BLVD",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278019908,
    "dropmaladd": "327 E RALEIGH BLVD",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278019908,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524071037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW13018",
    "droptype": "S",
    "dropname": "FOX VALLEY",
    "dropdeladd": "3900 GABRIELLE LN",
    "dropdelcty": "FOX VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 605999701,
    "dropphyadd": "3900 GABRIELLE LN",
    "dropphycty": "FOX VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 605999701,
    "dropmaladd": "3900 GABRIELLE LN",
    "dropmalcty": "FOX VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 605999701,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6309784432,
    "dropfax": 6309784336
  },
  {
    "dcode": "D",
    "dropkey": "EW18762",
    "droptype": "S",
    "dropname": "BISMARCK",
    "dropdeladd": "2220 E BISMARCK EXPY RM 212",
    "dropdelcty": "BISMARCK",
    "dropdelst": "ND",
    "dropdelzpp": 585049990,
    "dropphyadd": "2220 E BISMARCK EXPY RM 212",
    "dropphycty": "BISMARCK",
    "dropphyst": "ND",
    "dropphyzpp": 585049990,
    "dropmaladd": "2220 E BISMARCK EXPY RM 212",
    "dropmalcty": "BISMARCK",
    "dropmalst": "ND",
    "dropmalzpp": 585049990,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012216553,
    "dropsitcph": 7012216528,
    "dropfax": 7012216542
  },
  {
    "dcode": "D",
    "dropkey": "EW18901",
    "droptype": "S",
    "dropname": "FARGO",
    "dropdeladd": "657 2ND AVE N RM 104",
    "dropdelcty": "FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 581024768,
    "dropphyadd": "657 2ND AVE N RM 104",
    "dropphycty": "FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 581024768,
    "dropmaladd": "657 2ND AVE N RM 104",
    "dropmalcty": "FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 581024768,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7012416115,
    "dropfax": 7012716211
  },
  {
    "dcode": "D",
    "dropkey": "E013397",
    "droptype": "S",
    "dropname": "JT WEEKER ISC",
    "dropdeladd": "11600 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606889998,
    "dropphyadd": "11600 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606889998,
    "dropmaladd": "11600 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606889998,
    "dropsitphn": 7738949200,
    "dropsitlph": 7738949200,
    "dropsitcph": 7738949100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K017964",
    "droptype": "B",
    "dropname": "FARGO ASF",
    "dropdeladd": "1907 4TH AVE NW UNIT 200",
    "dropdelcty": "WEST FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 580781399,
    "dropphyadd": "1907 4TH AVE NW UNIT 200",
    "dropphycty": "WEST FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 580781399,
    "dropmaladd": "1907 4TH AVE NW UNIT 200",
    "dropmalcty": "WEST FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 580781399,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7012416115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW18966",
    "droptype": "S",
    "dropname": "GRAND FORKS",
    "dropdeladd": "2501 28TH AVE S",
    "dropdelcty": "GRAND FORKS",
    "dropdelst": "ND",
    "dropdelzpp": 582019997,
    "dropphyadd": "2501 28TH AVE S",
    "dropphycty": "GRAND FORKS",
    "dropphyst": "ND",
    "dropphyzpp": 582019997,
    "dropmaladd": "2501 28TH AVE S",
    "dropmalcty": "GRAND FORKS",
    "dropmalst": "ND",
    "dropmalzpp": 582019997,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7013352001,
    "dropfax": 7013352014
  },
  {
    "dcode": "D",
    "dropkey": "EW14362",
    "droptype": "S",
    "dropname": "PALATINE",
    "dropdeladd": "1300 E NORTHWEST HWY",
    "dropdelcty": "PALATINE",
    "dropdelst": "IL",
    "dropdelzpp": 600959997,
    "dropphyadd": "1300 E NORTHWEST HWY",
    "dropphycty": "PALATINE",
    "dropphyst": "IL",
    "dropphyzpp": 600959987,
    "dropmaladd": "1300 E NORTHWEST HWY",
    "dropmalcty": "PALATINE",
    "dropmalst": "IL",
    "dropmalzpp": 600959997,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475906666,
    "dropsitcph": 8475906600,
    "dropfax": 8475906699
  },
  {
    "dcode": "D",
    "dropkey": "EW1C546",
    "droptype": "D",
    "dropname": "GRAND ISLAND",
    "dropdeladd": "3835 W OLD POTASH HWY",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "NE",
    "dropdelzpp": 688039977,
    "dropphyadd": "3835 W OLD POTASH HWY",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "NE",
    "dropphyzpp": 688039977,
    "dropmaladd": "3835 W OLD POTASH HWY",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "NE",
    "dropmalzpp": 688039977,
    "dropsitphn": 3083856526,
    "dropsitlph": "",
    "dropsitcph": 3083856526,
    "dropfax": 3083856020
  },
  {
    "dcode": "D",
    "dropkey": "EW14651",
    "droptype": "S",
    "dropname": "QUAD CITIES",
    "dropdeladd": "7700 68TH ST",
    "dropdelcty": "MILAN",
    "dropdelst": "IL",
    "dropdelzpp": 612649997,
    "dropphyadd": "7700 68TH ST",
    "dropphycty": "MILAN",
    "dropphyst": "IL",
    "dropphyzpp": 612649997,
    "dropmaladd": "7700 68TH ST",
    "dropmalcty": "MILAN",
    "dropmalst": "IL",
    "dropmalzpp": 612649997,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097994081,
    "dropsitcph": 3097994081,
    "dropfax": 3097994022
  },
  {
    "dcode": "D",
    "dropkey": "EW19932",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "700 R ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685019821,
    "dropphyadd": "700 R ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685019821,
    "dropmaladd": "700 R ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685019821,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 4024731602,
    "dropfax": 4024731738
  },
  {
    "dcode": "D",
    "dropkey": "EW1A064",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "1100 S PINE INDUSTRIAL RD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "NE",
    "dropdelzpp": 687019997,
    "dropphyadd": "1100 S PINE INDUSTRIAL RD",
    "dropphycty": "NORFOLK",
    "dropphyst": "NE",
    "dropphyzpp": 687019997,
    "dropmaladd": "1100 S PINE INDUSTRIAL RD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "NE",
    "dropmalzpp": 687019997,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026444107,
    "dropsitcph": 4026444134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW1A071",
    "droptype": "S",
    "dropname": "NORTH PLATTE",
    "dropdeladd": "1302 INDUSTRIAL AVE",
    "dropdelcty": "NORTH PLATTE",
    "dropdelst": "NE",
    "dropdelzpp": 691019921,
    "dropphyadd": "1302 INDUSTRIAL AVE",
    "dropphycty": "NORTH PLATTE",
    "dropphyst": "NE",
    "dropphyzpp": 691019921,
    "dropmaladd": "1302 INDUSTRIAL AVE",
    "dropmalcty": "NORTH PLATTE",
    "dropmalst": "NE",
    "dropmalzpp": 691019921,
    "dropsitphn": 3085323144,
    "dropsitlph": "",
    "dropsitcph": 3085323144,
    "dropfax": 3085328243
  },
  {
    "dcode": "D",
    "dropkey": "EW12009",
    "droptype": "S",
    "dropname": "SOUTH SUBURBAN",
    "dropdeladd": "6801 W 73RD ST",
    "dropdelcty": "BEDFORD PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604999997,
    "dropphyadd": "6801 W 73RD ST",
    "dropphycty": "BEDFORD PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604999997,
    "dropmaladd": "6801 W 73RD ST",
    "dropmalcty": "BEDFORD PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604999997,
    "dropsitphn": 7085637313,
    "dropsitlph": 7085637310,
    "dropsitcph": 7085637800,
    "dropfax": 7085637495
  },
  {
    "dcode": "D",
    "dropkey": "EW1A092",
    "droptype": "S",
    "dropname": "OMAHA",
    "dropdeladd": "1124 PACIFIC ST RM 212",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681089997,
    "dropphyadd": "1124 PACIFIC ST RM 212",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681089997,
    "dropmaladd": "1124 PACIFIC ST RM 212",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681089997,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023482602,
    "dropsitcph": 4023482600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EW14964",
    "droptype": "S",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "2105 E COOK ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627039997,
    "dropphyadd": "2105 E COOK ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627039997,
    "dropmaladd": "2105 E COOK ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627039997,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177887257,
    "dropfax": 2177887495
  },
  {
    "dcode": "D",
    "dropkey": "E019098",
    "droptype": "D",
    "dropname": "OMAHA NE MCA",
    "dropdeladd": "11850 PORTAL RD",
    "dropdelcty": "LA VISTA",
    "dropdelst": "NE",
    "dropdelzpp": 681285554,
    "dropphyadd": "11850 PORTAL RD",
    "dropphycty": "LA VISTA",
    "dropphyst": "NE",
    "dropphyzpp": 681285554,
    "dropmaladd": "11850 PORTAL RD",
    "dropmalcty": "LA VISTA",
    "dropmalst": "NE",
    "dropmalzpp": 681285554,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 4028964080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "JX1D196",
    "droptype": "D",
    "dropname": "PEACHTREE",
    "dropdeladd": "2310 MAYNARD H JACKSON JR BLVD",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303206000,
    "dropphyadd": "2310 MAYNARD H JACKSON JR BLVD",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303206000,
    "dropmaladd": "PO BOX 46999",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303209741,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047655510,
    "dropsitcph": 4047655400,
    "dropfax": 4047655502
  },
  {
    "dcode": "D",
    "dropkey": "EZ13503",
    "droptype": "S",
    "dropname": "ALBUQUERQUE",
    "dropdeladd": "1135 BROADWAY BLVD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871010002,
    "dropphyadd": "1135 BROADWAY BLVD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871010002,
    "dropmaladd": "1135 BROADWAY BLVD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871010002,
    "dropsitphn": 5053468410,
    "dropsitlph": 5053468252,
    "dropsitcph": 5053468410,
    "dropfax": 5053468138
  },
  {
    "dcode": "D",
    "dropkey": "EV25570",
    "droptype": "S",
    "dropname": "MANCHESTER",
    "dropdeladd": "955 GOFFS FALLS RD STE 997",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "031039997",
    "dropphyadd": "955 GOFFS FALLS RD STE 997",
    "dropphycty": "MANCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "031039997",
    "dropmaladd": "955 GOFFS FALLS RD STE 997",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "031039997",
    "dropsitphn": 6036444128,
    "dropsitlph": "",
    "dropsitcph": 6036444084,
    "dropfax": 6036444174
  },
  {
    "dcode": "D",
    "dropkey": "J001160",
    "droptype": "D",
    "dropname": "NASHUA",
    "dropdeladd": "10 CELINA AVE",
    "dropdelcty": "NASHUA",
    "dropdelst": "NH",
    "dropdelzpp": "030639997",
    "dropphyadd": "10 CELINA AVE",
    "dropphycty": "NASHUA",
    "dropphyst": "NH",
    "dropphyzpp": "030639997",
    "dropmaladd": "10 CELINA AVE",
    "dropmalcty": "NASHUA",
    "dropmalst": "NH",
    "dropmalzpp": "030639997",
    "dropsitphn": 6036444128,
    "dropsitlph": 6035792140,
    "dropsitcph": 6035792170,
    "dropfax": 6035792111
  },
  {
    "dcode": "D",
    "dropkey": "EV19356",
    "droptype": "S",
    "dropname": "DOMINICK V DANIELS",
    "dropdeladd": "850 NEWARK TPKE",
    "dropdelcty": "KEARNY",
    "dropdelst": "NJ",
    "dropdelzpp": "070999400",
    "dropphyadd": "850 NEWARK TPKE",
    "dropphycty": "KEARNY",
    "dropphyst": "NJ",
    "dropphyzpp": "070999400",
    "dropmaladd": "850 NEWARK TPKE",
    "dropmalcty": "KEARNY",
    "dropmalst": "NJ",
    "dropmalzpp": "070999998",
    "dropsitphn": 2019559705,
    "dropsitlph": "",
    "dropsitcph": 2019559600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "KZ13504",
    "droptype": "B",
    "dropname": "ALBUQUERQUE ASF",
    "dropdeladd": "7601 BLUEWATER RD NW STE A",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871210001,
    "dropphyadd": "7601 BLUEWATER RD NW STE A",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871210001,
    "dropmaladd": "7601 BLUEWATER RD NW STE A",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871210001,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468250,
    "dropsitcph": 5053468052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "KV10697",
    "droptype": "B",
    "dropname": "NEW JERSEY NDC",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979997",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979997",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979997",
    "dropsitphn": 2017146809,
    "dropsitlph": 2017146311,
    "dropsitcph": 2017146000,
    "dropfax": 2017146345
  },
  {
    "dcode": "D",
    "dropkey": "E003313",
    "droptype": "S",
    "dropname": "NORTHERN NJ METRO",
    "dropdeladd": "200 INDUSTRIAL AVE",
    "dropdelcty": "TETERBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "076999998",
    "dropphyadd": "200 INDUSTRIAL AVE",
    "dropphycty": "TETERBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "076999998",
    "dropmaladd": "200 INDUSTRIAL AVE",
    "dropmalcty": "TETERBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "076999998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2013754180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV10103",
    "droptype": "S",
    "dropname": "SOUTH JERSEY",
    "dropdeladd": "421 BENIGNO BLVD",
    "dropdelcty": "BELLMAWR",
    "dropdelst": "NJ",
    "dropdelzpp": "080319997",
    "dropphyadd": "421 BENIGNO BLVD",
    "dropphycty": "BELLMAWR",
    "dropphyst": "NJ",
    "dropphyzpp": "080319997",
    "dropmaladd": "421 BENIGNO BLVD",
    "dropmalcty": "BELLMAWR",
    "dropmalst": "NJ",
    "dropmalzpp": "080319997",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569334047,
    "dropsitcph": 8569334036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EV11574",
    "droptype": "S",
    "dropname": "TRENTON",
    "dropdeladd": "680 US HIGHWAY 130",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086509997",
    "dropphyadd": "680 US HIGHWAY 130",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086509997",
    "dropmaladd": "680 US HIGHWAY 130",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086509997",
    "dropsitphn": 6095813139,
    "dropsitlph": "",
    "dropsitcph": 6095813047,
    "dropfax": 6095813062
  },
  {
    "dcode": "D",
    "dropkey": "EW14426",
    "droptype": "S",
    "dropname": "PEORIA",
    "dropdeladd": "95 STATE ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616019900,
    "dropphyadd": "95 STATE ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616019900,
    "dropmaladd": "95 STATE ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616019900,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096718822,
    "dropfax": 3096748983
  },
  {
    "dcode": "D",
    "dropkey": "EV27663",
    "droptype": "S",
    "dropname": "LINTHICUM",
    "dropdeladd": "961 CORPORATE BLVD",
    "dropdelcty": "LINTHICUM HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 210902225,
    "dropphyadd": "961 CORPORATE BLVD",
    "dropphycty": "LINTHICUM HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 210902225,
    "dropmaladd": "961 CORPORATE BLVD",
    "dropmalcty": "LINTHICUM HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 210902225,
    "dropsitphn": 4103474518,
    "dropsitlph": "",
    "dropsitcph": 4106914200,
    "dropfax": 4106914240
  },
  {
    "dcode": "D",
    "dropkey": "J009713",
    "droptype": "D",
    "dropname": "CHICAGO METRO PRIORITY HUB",
    "dropdeladd": "2591 BUSSE RD",
    "dropdelcty": "ELK GROVE VILLAGE",
    "dropdelst": "IL",
    "dropdelzpp": 600076101,
    "dropphyadd": "2591 BUSSE RD",
    "dropphycty": "ELK GROVE VILLAGE",
    "dropphyst": "IL",
    "dropphyzpp": 600076101,
    "dropmaladd": "2591 BUSSE RD",
    "dropmalcty": "ELK GROVE VILLAGE",
    "dropmalst": "IL",
    "dropmalzpp": 600076101,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 8475957340,
    "dropfax": 8475957355
  },
  {
    "dcode": "D",
    "dropkey": "E020708",
    "droptype": "D",
    "dropname": "CEDAR RAPIDS PARCEL ANNEX",
    "dropdeladd": "4515 20TH AVE SW STE F",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 524041224,
    "dropphyadd": "4515 20TH AVE SW STE F",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 524041224,
    "dropmaladd": "4515 20TH AVE SW STE F",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 524041224,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193992946,
    "dropsitcph": 3193995560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E006130",
    "droptype": "D",
    "dropname": "DMDU ANNEX",
    "dropdeladd": "100 AVE CONQUISTADORES",
    "dropdelcty": "CATANO",
    "dropdelst": "PR",
    "dropdelzpp": "009629996",
    "dropphyadd": "100 AVE CONQUISTADORES",
    "dropphycty": "CATANO",
    "dropphyst": "PR",
    "dropphyzpp": "009629996",
    "dropmaladd": "100 AVE CONQUISTADORES",
    "dropmalcty": "CATANO",
    "dropmalst": "PR",
    "dropmalzpp": "009629996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877880760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "EY20402",
    "droptype": "S",
    "dropname": "NORTHWEST ARKANSAS",
    "dropdeladd": "2300 S CITY LAKE RD",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727019997,
    "dropphyadd": "2300 S CITY LAKE RD",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727019997,
    "dropmaladd": "2300 S CITY LAKE RD",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727019997,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 4795711006,
    "dropfax": 4794427131
  },
  {
    "dcode": "D",
    "dropkey": "E002101",
    "droptype": "D",
    "dropname": "GRAND RAPIDS ANNEX P1",
    "dropdeladd": "3500 PATTERSON AVE SE STE A",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495125699,
    "dropphyadd": "3500 PATTERSON AVE SE STE A",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495125699,
    "dropmaladd": "PO BOX 995701",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495995701,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6169771048,
    "dropfax": 6169771044
  },
  {
    "dcode": "D",
    "dropkey": "E010253",
    "droptype": "D",
    "dropname": "GRAND RAPIDS P3",
    "dropdeladd": "3550 PATTERSON AVE SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495125655,
    "dropphyadd": "3550 PATTERSON AVE SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495125655,
    "dropmaladd": "PO BOX 995800",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495995800,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6167761041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "J004342",
    "droptype": "D",
    "dropname": "GREATER NEWARK",
    "dropdeladd": "1200 HARRISON AVE",
    "dropdelcty": "KEARNY",
    "dropdelst": "NJ",
    "dropdelzpp": "070325931",
    "dropphyadd": "1200 HARRISON AVE",
    "dropphycty": "KEARNY",
    "dropphyst": "NJ",
    "dropphyzpp": "070325931",
    "dropmaladd": "1200 HARRISON AVE",
    "dropmalcty": "KEARNY",
    "dropmalst": "NJ",
    "dropmalzpp": "070325931",
    "dropsitphn": 8569334047,
    "dropsitlph": "",
    "dropsitcph": 2012462012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "F018400",
    "droptype": "D",
    "dropname": "NORTH GRAND DDC",
    "dropdeladd": "2201 N GRAND AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927119997,
    "dropphyadd": "2201 N GRAND AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927119997,
    "dropmaladd": "2201 N GRAND AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927119997,
    "dropsitphn": 7146676771,
    "dropsitlph": 7146676768,
    "dropsitcph": 7146676771,
    "dropfax": 7149736816
  },
  {
    "dcode": "D",
    "dropkey": "F003918",
    "droptype": "D",
    "dropname": "EAST DDC",
    "dropdeladd": "7241 185TH AVE NE",
    "dropdelcty": "REDMOND",
    "dropdelst": "WA",
    "dropdelzpp": 980526715,
    "dropphyadd": "7241 185TH AVE NE",
    "dropphycty": "REDMOND",
    "dropphyst": "WA",
    "dropphyzpp": 980526715,
    "dropmaladd": "7241 185TH AVE NE",
    "dropmalcty": "REDMOND",
    "dropmalst": "WA",
    "dropmalzpp": 980526715,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4258813535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "FZ18114",
    "droptype": "D",
    "dropname": "SOUTH DDC",
    "dropdeladd": "24800 64TH AVE S",
    "dropdelcty": "KENT",
    "dropdelst": "WA",
    "dropdelzpp": 980329704,
    "dropphyadd": "24800 64TH AVE S",
    "dropphycty": "KENT",
    "dropphyst": "WA",
    "dropphyzpp": 980329704,
    "dropmaladd": "24800 64TH AVE S",
    "dropmalcty": "KENT",
    "dropmalst": "WA",
    "dropmalzpp": 980329704,
    "dropsitphn": 2067684422,
    "dropsitlph": "",
    "dropsitcph": 2538594399,
    "dropfax": 2538594375
  },
  {
    "dcode": "D",
    "dropkey": "A010812",
    "droptype": "D",
    "dropname": "TWIN CITIES AMF",
    "dropdeladd": "5001 NORTHWEST DR",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551113032,
    "dropphyadd": "5001 NORTHWEST DR",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551113032,
    "dropmaladd": "5001 NORTHWEST DR",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551113032,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 6129707601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K019659",
    "droptype": "D",
    "dropname": "LOG DULLES AIR TRANSFER OFC",
    "dropdeladd": "23941 CARGO DR UNIT 22",
    "dropdelcty": "STERLING",
    "dropdelst": "VA",
    "dropdelzpp": 201667621,
    "dropphyadd": "23941 CARGO DR UNIT 22",
    "dropphycty": "STERLING",
    "dropphyst": "VA",
    "dropphyzpp": 201667621,
    "dropmaladd": "44715 PRENTICE DR",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201029997,
    "dropsitphn": 7036986867,
    "dropsitlph": "",
    "dropsitcph": 7039668701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019662",
    "droptype": "D",
    "dropname": "SAINT ROSE",
    "dropdeladd": "130 RIVERBEND DR",
    "dropdelcty": "SAINT ROSE",
    "dropdelst": "LA",
    "dropdelzpp": 700873363,
    "dropphyadd": "130 RIVERBEND DR",
    "dropphycty": "SAINT ROSE",
    "dropphyst": "LA",
    "dropphyzpp": 700873363,
    "dropmaladd": "130 RIVERBEND DR",
    "dropmalcty": "SAINT ROSE",
    "dropmalst": "LA",
    "dropmalzpp": 700873363,
    "dropsitphn": 5045891255,
    "dropsitlph": "",
    "dropsitcph": 5047126913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K019787",
    "droptype": "D",
    "dropname": "LOG BUSSE IL PSA",
    "dropdeladd": "2600 LIVELY BLVD",
    "dropdelcty": "ELK GROVE VILLAGE",
    "dropdelst": "IL",
    "dropdelzpp": 600076703,
    "dropphyadd": "2600 LIVELY BLVD",
    "dropphycty": "ELK GROVE VILLAGE",
    "dropphyst": "IL",
    "dropphyzpp": 600076703,
    "dropmaladd": "2600 LIVELY BLVD",
    "dropmalcty": "ELK GROVE VILLAGE",
    "dropmalst": "IL",
    "dropmalzpp": 600076703,
    "dropsitphn": 7085834294,
    "dropsitlph": 7084883220,
    "dropsitcph": 7085834521,
    "dropfax": 7085834550
  },
  {
    "dcode": "D",
    "dropkey": "E019784",
    "droptype": "D",
    "dropname": "DENVER CO PSA",
    "dropdeladd": "4690 FLORENCE ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802385020,
    "dropphyadd": "4690 FLORENCE ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802385020,
    "dropmaladd": "4690 FLORENCE ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802385020,
    "dropsitphn": 3038532547,
    "dropsitlph": 3038532584,
    "dropsitcph": 3038532570,
    "dropfax": 3038532609
  },
  {
    "dcode": "D",
    "dropkey": "E019746",
    "droptype": "D",
    "dropname": "LEHIGH VALLEY PA PSA",
    "dropdeladd": "250 RADAR DR",
    "dropdelcty": "NORTHAMPTON",
    "dropdelst": "PA",
    "dropdelzpp": 180679997,
    "dropphyadd": "250 RADAR DR",
    "dropphycty": "NORTHAMPTON",
    "dropphyst": "PA",
    "dropphyzpp": 180679997,
    "dropmaladd": "250 RADAR DR",
    "dropmalcty": "NORTHAMPTON",
    "dropmalst": "PA",
    "dropmalzpp": 180679997,
    "dropsitphn": 6108823244,
    "dropsitlph": "",
    "dropsitcph": 6108223209,
    "dropfax": 6108823297
  },
  {
    "dcode": "D",
    "dropkey": "E019773",
    "droptype": "D",
    "dropname": "ATLANTA GA PSA",
    "dropdeladd": "220 THE BLFS",
    "dropdelcty": "AUSTELL",
    "dropdelst": "GA",
    "dropdelzpp": 301687847,
    "dropphyadd": "220 THE BLFS",
    "dropphycty": "AUSTELL",
    "dropphyst": "GA",
    "dropphyzpp": 301687847,
    "dropmaladd": "220 THE BLFS",
    "dropmalcty": "AUSTELL",
    "dropmalst": "GA",
    "dropmalzpp": 301687847,
    "dropsitphn": 4047923125,
    "dropsitlph": 4047923008,
    "dropsitcph": 4047923270,
    "dropfax": 4047923293
  },
  {
    "dcode": "D",
    "dropkey": "E019781",
    "droptype": "D",
    "dropname": "AUSTIN TX PSA",
    "dropdeladd": "9101 WALL ST STE 1300",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787544594,
    "dropphyadd": "9101 WALL ST STE 1300",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787544594,
    "dropmaladd": "9101 WALL ST STE 1300",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787544594,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123421225,
    "dropsitcph": 5123421135,
    "dropfax": 5123421298
  },
  {
    "dcode": "D",
    "dropkey": "E019768",
    "droptype": "D",
    "dropname": "BIRMINGHAM AL PSA",
    "dropdeladd": "3501 1ST AVE N",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352221200,
    "dropphyadd": "3501 1ST AVE N",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352221200,
    "dropmaladd": "3501 1ST AVE N",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352221200,
    "dropsitphn": 2055210367,
    "dropsitlph": "",
    "dropsitcph": 2055210260,
    "dropfax": 2052212650
  },
  {
    "dcode": "D",
    "dropkey": "E019749",
    "droptype": "D",
    "dropname": "BOSTON MA PSA",
    "dropdeladd": "275 BODWELL ST STE B",
    "dropdelcty": "AVON",
    "dropdelst": "MA",
    "dropdelzpp": "023229914",
    "dropphyadd": "275 BODWELL ST STE B",
    "dropphycty": "AVON",
    "dropphyst": "MA",
    "dropphyzpp": "023229914",
    "dropmaladd": "275 BODWELL ST STE B",
    "dropmalcty": "AVON",
    "dropmalst": "MA",
    "dropmalzpp": "023229914",
    "dropsitphn": 6176545113,
    "dropsitlph": "",
    "dropsitcph": 6176545225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K019797",
    "droptype": "D",
    "dropname": "LOG CENTRAL MA PSA",
    "dropdeladd": "111 CONSTITUTION BLVD",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MA",
    "dropdelzpp": "020389997",
    "dropphyadd": "111 CONSTITUTION BLVD",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MA",
    "dropphyzpp": "020389997",
    "dropmaladd": "111 CONSTITUTION BLVD",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MA",
    "dropmalzpp": "020389997",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087935915,
    "dropsitcph": 5087935104,
    "dropfax": 5087935995
  },
  {
    "dcode": "D",
    "dropkey": "E019753",
    "droptype": "D",
    "dropname": "MID CAROLINA NC PSA",
    "dropdeladd": "1900 CONTINENTAL BLVD STE I",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282739628,
    "dropphyadd": "1900 CONTINENTAL BLVD STE I",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282739628,
    "dropmaladd": "1900 CONTINENTAL BLVD STE I",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282739628,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7043935553,
    "dropfax": 7043934463
  },
  {
    "dcode": "D",
    "dropkey": "E019767",
    "droptype": "D",
    "dropname": "CINCINNATI OH PSA",
    "dropdeladd": "8615 JACQUEMIN DR STE 200",
    "dropdelcty": "WEST CHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 450699908,
    "dropphyadd": "8615 JACQUEMIN DR STE 200",
    "dropphycty": "WEST CHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 450699908,
    "dropmaladd": "8615 JACQUEMIN DR STE 200",
    "dropmalcty": "WEST CHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 450699908,
    "dropsitphn": 5137337008,
    "dropsitlph": "",
    "dropsitcph": 5137337009,
    "dropfax": 5137337122
  },
  {
    "dcode": "D",
    "dropkey": "E019766",
    "droptype": "D",
    "dropname": "CLEVELAND OH PSA",
    "dropdeladd": "5520 CHEVROLET BLVD STE 100",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441309904,
    "dropphyadd": "5520 CHEVROLET BLVD STE 100",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441309904,
    "dropmaladd": "5520 CHEVROLET BLVD STE 100",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441309904,
    "dropsitphn": 2164434255,
    "dropsitlph": "",
    "dropsitcph": 2164434089,
    "dropfax": 2164434343
  },
  {
    "dcode": "D",
    "dropkey": "E019777",
    "droptype": "D",
    "dropname": "DALLAS TX PSA",
    "dropdeladd": "602 FOUNTAIN PKWY STE A",
    "dropdelcty": "GRAND PRAIRIE",
    "dropdelst": "TX",
    "dropdelzpp": 750501414,
    "dropphyadd": "602 FOUNTAIN PKWY STE A",
    "dropphycty": "GRAND PRAIRIE",
    "dropphyst": "TX",
    "dropphyzpp": 750501414,
    "dropmaladd": "602 FOUNTAIN PKWY STE A",
    "dropmalcty": "GRAND PRAIRIE",
    "dropmalst": "TX",
    "dropmalzpp": 750501414,
    "dropsitphn": 2144675879,
    "dropsitlph": "",
    "dropsitcph": 2144675828,
    "dropfax": 2144675853
  },
  {
    "dcode": "D",
    "dropkey": "E019763",
    "droptype": "D",
    "dropname": "DETROIT MI PSA",
    "dropdeladd": "18765 SEAWAY DR",
    "dropdelcty": "MELVINDALE",
    "dropdelst": "MI",
    "dropdelzpp": 481221900,
    "dropphyadd": "18765 SEAWAY DR",
    "dropphycty": "MELVINDALE",
    "dropphyst": "MI",
    "dropphyzpp": 481221900,
    "dropmaladd": "18765 SEAWAY DR",
    "dropmalcty": "MELVINDALE",
    "dropmalst": "MI",
    "dropmalzpp": 481221900,
    "dropsitphn": 3133372172,
    "dropsitlph": 3133372132,
    "dropsitcph": 3133372100,
    "dropfax": 3133372108
  },
  {
    "dcode": "D",
    "dropkey": "E019769",
    "droptype": "D",
    "dropname": "JACKSONVILLE FL PSA",
    "dropdeladd": "10089 N MAIN ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322185785,
    "dropphyadd": "10089 N MAIN ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322185785,
    "dropmaladd": "10089 N MAIN ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322185785,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047837115,
    "dropsitcph": 9047837176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019772",
    "droptype": "D",
    "dropname": "ROYAL PALM FL PSA",
    "dropdeladd": "21201 NW 43RD AVE UNIT 100",
    "dropdelcty": "MIAMI GARDENS",
    "dropdelst": "FL",
    "dropdelzpp": 330559997,
    "dropphyadd": "21201 NW 43RD AVE UNIT 100",
    "dropphycty": "MIAMI GARDENS",
    "dropphyst": "FL",
    "dropphyzpp": 330559997,
    "dropmaladd": "21201 NW 43RD AVE UNIT 100",
    "dropmalcty": "MIAMI GARDENS",
    "dropmalst": "FL",
    "dropmalzpp": 330559997,
    "dropsitphn": 3055132368,
    "dropsitlph": 3059535604,
    "dropsitcph": 3059535694,
    "dropfax": 3059535608
  },
  {
    "dcode": "D",
    "dropkey": "E019770",
    "droptype": "D",
    "dropname": "SEMINOLE FL PSA",
    "dropdeladd": "10425 S ORANGE AVE",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328249914,
    "dropphyadd": "10425 S ORANGE AVE",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328249914,
    "dropmaladd": "10425 S ORANGE AVE",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328249914,
    "dropsitphn": 4078121110,
    "dropsitlph": "",
    "dropsitcph": 4078121135,
    "dropfax": 4078211101
  },
  {
    "dcode": "D",
    "dropkey": "E019771",
    "droptype": "D",
    "dropname": "YBOR CITY FL PSA",
    "dropdeladd": "4720 OAK FAIR BLVD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336109928,
    "dropphyadd": "4720 OAK FAIR BLVD",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336109928,
    "dropmaladd": "4720 OAK FAIR BLVD",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336109928,
    "dropsitphn": 8132487505,
    "dropsitlph": "",
    "dropsitcph": 8132487500,
    "dropfax": 8132487527
  },
  {
    "dcode": "D",
    "dropkey": "E019759",
    "droptype": "D",
    "dropname": "INDIANAPOLIS IN PSA",
    "dropdeladd": "800 COMMERCE PARKWAY WEST DR STE A",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 461439929,
    "dropphyadd": "800 COMMERCE PARKWAY WEST DR STE A",
    "dropphycty": "GREENWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 461439929,
    "dropmaladd": "800 COMMERCE PARKWAY WEST DR STE A",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 461439929,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646852,
    "dropfax": 3174646011
  },
  {
    "dcode": "D",
    "dropkey": "E019762",
    "droptype": "D",
    "dropname": "WICHITA KS PSA",
    "dropdeladd": "7601 W UNIVERSITY ST",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672092021,
    "dropphyadd": "7601 W UNIVERSITY ST",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672092021,
    "dropmaladd": "7601 W UNIVERSITY ST",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672092021,
    "dropsitphn": 3169464628,
    "dropsitlph": 3169464649,
    "dropsitcph": 3169464636,
    "dropfax": 3169459762
  },
  {
    "dcode": "D",
    "dropkey": "E019774",
    "droptype": "D",
    "dropname": "SHREVEPORT LA PSA",
    "dropdeladd": "7600 ANTOINE BLVD",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711299997,
    "dropphyadd": "7600 ANTOINE BLVD",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711299997,
    "dropmaladd": "7600 ANTOINE BLVD",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711299997,
    "dropsitphn": 5045891027,
    "dropsitlph": 3186772333,
    "dropsitcph": 3186772295,
    "dropfax": 3186772275
  },
  {
    "dcode": "D",
    "dropkey": "E019764",
    "droptype": "D",
    "dropname": "GRAND RAPIDS MI PSA",
    "dropdeladd": "4300 36TH ST SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495122916,
    "dropphyadd": "4300 36TH ST SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495122916,
    "dropmaladd": "4300 36TH ST SE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495122916,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6167761416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019761",
    "droptype": "D",
    "dropname": "KANSAS CITY MO PSA",
    "dropdeladd": "4151 NW 41ST ST STE 100",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "MO",
    "dropdelzpp": 641507848,
    "dropphyadd": "4151 NW 41ST ST STE 100",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "MO",
    "dropphyzpp": 641507848,
    "dropmaladd": "4151 NW 41ST ST STE 100",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "MO",
    "dropmalzpp": 641507848,
    "dropsitphn": 9135732520,
    "dropsitlph": 9135732542,
    "dropsitcph": 9135732641,
    "dropfax": 9135732698
  },
  {
    "dcode": "D",
    "dropkey": "E019760",
    "droptype": "D",
    "dropname": "SAINT LOUIS MO PSA",
    "dropdeladd": "4702 PARK 370 BLVD",
    "dropdelcty": "HAZELWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630424458,
    "dropphyadd": "4702 PARK 370 BLVD",
    "dropphycty": "HAZELWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630424458,
    "dropmaladd": "4702 PARK 370 BLVD",
    "dropmalcty": "HAZELWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630424458,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 3148959270,
    "dropfax": 3148959346
  },
  {
    "dcode": "D",
    "dropkey": "E019757",
    "droptype": "D",
    "dropname": "OMAHA NE PSA",
    "dropdeladd": "14620 GOLD COAST RD STE 400",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681384456,
    "dropphyadd": "14620 GOLD COAST RD STE 400",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681384456,
    "dropmaladd": "14620 GOLD COAST RD STE 400",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681384456,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023482602,
    "dropsitcph": 4023482600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019751",
    "droptype": "D",
    "dropname": "NEW JERSEY NJ PSA",
    "dropdeladd": "1201 VALLEY BROOK AVE",
    "dropdelcty": "LYNDHURST",
    "dropdelst": "NJ",
    "dropdelzpp": "070719905",
    "dropphyadd": "1201 VALLEY BROOK AVE",
    "dropphycty": "LYNDHURST",
    "dropphyst": "NJ",
    "dropphyzpp": "070719905",
    "dropmaladd": "1201 VALLEY BROOK AVE",
    "dropmalcty": "LYNDHURST",
    "dropmalst": "NJ",
    "dropmalzpp": "070719905",
    "dropsitphn": 2017146809,
    "dropsitlph": 2017146311,
    "dropsitcph": 2017146000,
    "dropfax": 2017146345
  },
  {
    "dcode": "D",
    "dropkey": "E019754",
    "droptype": "D",
    "dropname": "HARRISBURG PA PSA",
    "dropdeladd": "6455 ALLENTOWN BLVD",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171123311,
    "dropphyadd": "6455 ALLENTOWN BLVD",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171123311,
    "dropmaladd": "6455 ALLENTOWN BLVD",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171123311,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172572361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019747",
    "droptype": "D",
    "dropname": "PHILADELPHIA PA PSA",
    "dropdeladd": "2021 WOODHAVEN RD",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191169997,
    "dropphyadd": "2021 WOODHAVEN RD",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191169997,
    "dropmaladd": "2021 WOODHAVEN RD",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191169997,
    "dropsitphn": 2156717625,
    "dropsitlph": 2156717666,
    "dropsitcph": 2156717609,
    "dropfax": 2156717622
  },
  {
    "dcode": "D",
    "dropkey": "E019778",
    "droptype": "D",
    "dropname": "FORT WORTH TX PSA",
    "dropdeladd": "400 INTERMODAL PKWY STE 100",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761773999,
    "dropphyadd": "400 INTERMODAL PKWY STE 100",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761773999,
    "dropmaladd": "400 INTERMODAL PKWY STE 100",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761773999,
    "dropsitphn": 8173173658,
    "dropsitlph": "",
    "dropsitcph": 8173173850,
    "dropfax": 8173173826
  },
  {
    "dcode": "D",
    "dropkey": "K019825",
    "droptype": "D",
    "dropname": "LOG NORTH HOUSTON TX PSA",
    "dropdeladd": "15600 MORALES RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770322102,
    "dropphyadd": "15600 MORALES RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770322102,
    "dropmaladd": "15600 MORALES RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770322102,
    "dropsitphn": 7132263913,
    "dropsitlph": 7132263475,
    "dropsitcph": 7132264202,
    "dropfax": 7132263095
  },
  {
    "dcode": "D",
    "dropkey": "E019755",
    "droptype": "D",
    "dropname": "NORFOLK VA PSA",
    "dropdeladd": "3512 BUSINESS CENTER DR",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233232655,
    "dropphyadd": "3512 BUSINESS CENTER DR",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233232655,
    "dropmaladd": "3512 BUSINESS CENTER DR",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233232655,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7576292117,
    "dropfax": 7576292106
  },
  {
    "dcode": "D",
    "dropkey": "E019785",
    "droptype": "D",
    "dropname": "SEATTLE WA PSA",
    "dropdeladd": "18340 SEGALE PARK DRIVE B",
    "dropdelcty": "TUKWILA",
    "dropdelst": "WA",
    "dropdelzpp": 981889918,
    "dropphyadd": "18340 SEGALE PARK DRIVE B",
    "dropphycty": "TUKWILA",
    "dropphyst": "WA",
    "dropphyzpp": 981889918,
    "dropmaladd": "18340 SEGALE PARK DRIVE B",
    "dropmalcty": "TUKWILA",
    "dropmalst": "WA",
    "dropmalzpp": 981889918,
    "dropsitphn": 2063816600,
    "dropsitlph": 2538747393,
    "dropsitcph": 2538747200,
    "dropfax": 2538747356
  },
  {
    "dcode": "D",
    "dropkey": "E019829",
    "droptype": "D",
    "dropname": "FAYETTEVILLE NC PSA",
    "dropdeladd": "5300 CORPORATION DR",
    "dropdelcty": "HOPE MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 283489606,
    "dropphyadd": "5300 CORPORATION DR",
    "dropphycty": "HOPE MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 283489606,
    "dropmaladd": "5300 CORPORATION DR",
    "dropmalcty": "HOPE MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 283489606,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 9104862311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019831",
    "droptype": "D",
    "dropname": "SPRINGFIELD MA PSA",
    "dropdeladd": "100 BROOKDALE DR STE DK13",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011049997",
    "dropphyadd": "100 BROOKDALE DR STE DK13",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011049997",
    "dropmaladd": "100 BROOKDALE DR STE DK13",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011049997",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4137856246,
    "dropfax": 4137856465
  },
  {
    "dcode": "D",
    "dropkey": "E019833",
    "droptype": "D",
    "dropname": "LITTLE ROCK AR PSA",
    "dropdeladd": "700 BURKHALTER COMMERCIAL DR STE 3",
    "dropdelcty": "MAUMELLE",
    "dropdelst": "AR",
    "dropdelzpp": 721137535,
    "dropphyadd": "700 BURKHALTER COMMERCIAL DR STE 3",
    "dropphycty": "MAUMELLE",
    "dropphyst": "AR",
    "dropphyzpp": 721137535,
    "dropmaladd": "700 BURKHALTER COMMERCIAL DR STE 3",
    "dropmalcty": "MAUMELLE",
    "dropmalst": "AR",
    "dropmalzpp": 721137535,
    "dropsitphn": 5019456732,
    "dropsitlph": "",
    "dropsitcph": 5013755155,
    "dropfax": 5019456615
  },
  {
    "dcode": "D",
    "dropkey": "E019838",
    "droptype": "D",
    "dropname": "LAS VEGAS NV PSA",
    "dropdeladd": "1720 CHAPARRAL RD",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890449900,
    "dropphyadd": "1720 CHAPARRAL RD",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890449900,
    "dropmaladd": "1720 CHAPARRAL RD",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890449900,
    "dropsitphn": 7023619453,
    "dropsitlph": "",
    "dropsitcph": 7023619453,
    "dropfax": 7028968427
  },
  {
    "dcode": "D",
    "dropkey": "E019880",
    "droptype": "D",
    "dropname": "SACRAMENTO CA MPA",
    "dropdeladd": "2000 ROYAL OAKS DR",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958139992,
    "dropphyadd": "2000 ROYAL OAKS DR",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958139992,
    "dropmaladd": "2000 ROYAL OAKS DR",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958139992,
    "dropsitphn": 9163738025,
    "dropsitlph": "",
    "dropsitcph": 9162637127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019905",
    "droptype": "D",
    "dropname": "SAN JUAN PR MPA2",
    "dropdeladd": "50 CALLE GILDITA STE 501",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009839996",
    "dropphyadd": "50 CALLE GILDITA STE 501",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009839996",
    "dropmaladd": "50 CALLE GILDITA STE 501",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009839996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876221750,
    "dropfax": 7876221923
  },
  {
    "dcode": "D",
    "dropkey": "E019915",
    "droptype": "D",
    "dropname": "DES MOINES IA PSA",
    "dropdeladd": "4301 121ST ST",
    "dropdelcty": "URBANDALE",
    "dropdelst": "IA",
    "dropdelzpp": 503232808,
    "dropphyadd": "4301 121ST ST",
    "dropphycty": "URBANDALE",
    "dropphyst": "IA",
    "dropphyzpp": 503232808,
    "dropmaladd": "4301 121ST ST",
    "dropmalcty": "URBANDALE",
    "dropmalst": "IA",
    "dropmalzpp": 503232808,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152787621,
    "dropsitcph": 5152512330,
    "dropfax": 5152287635
  },
  {
    "dcode": "D",
    "dropkey": "E019922",
    "droptype": "D",
    "dropname": "GREENSBORO NC PSA",
    "dropdeladd": "1671 GREENBOURNE DR STE 101",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274099990,
    "dropphyadd": "1671 GREENBOURNE DR STE 101",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274099990,
    "dropmaladd": "1671 GREENBOURNE DR STE 101",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274099990,
    "dropsitphn": 3368554318,
    "dropsitlph": 3368554324,
    "dropsitcph": 3368554290,
    "dropfax": 3368554323
  },
  {
    "dcode": "D",
    "dropkey": "E019165",
    "droptype": "D",
    "dropname": "OAK CREEK",
    "dropdeladd": "2201 E COLLEGE AVE",
    "dropdelcty": "OAK CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 531542201,
    "dropphyadd": "2201 E COLLEGE AVE",
    "dropphycty": "OAK CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 531542201,
    "dropmaladd": "2201 E COLLEGE AVE",
    "dropmalcty": "OAK CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 531542201,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702313,
    "dropsitcph": 4143468401,
    "dropfax": 4145707724
  },
  {
    "dcode": "D",
    "dropkey": "E019928",
    "droptype": "D",
    "dropname": "SAN ANTONIO TX PSA",
    "dropdeladd": "6719 INTERSTATE 10 E",
    "dropdelcty": "CONVERSE",
    "dropdelst": "TX",
    "dropdelzpp": 781095176,
    "dropphyadd": "6719 INTERSTATE 10 E",
    "dropphycty": "CONVERSE",
    "dropphyst": "TX",
    "dropphyzpp": 781095176,
    "dropmaladd": "6719 INTERSTATE 10 E",
    "dropmalcty": "CONVERSE",
    "dropmalst": "TX",
    "dropmalzpp": 781095176,
    "dropsitphn": 2103688387,
    "dropsitlph": "",
    "dropsitcph": 2103688498,
    "dropfax": 2103681698
  },
  {
    "dcode": "D",
    "dropkey": "E019935",
    "droptype": "S",
    "dropname": "SAN JOSE CA MPA",
    "dropdeladd": "1750 MERIDIAN AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951259900,
    "dropphyadd": "1750 MERIDIAN AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951259900,
    "dropmaladd": "1750 MERIDIAN AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951259900,
    "dropsitphn": 4084376726,
    "dropsitlph": "",
    "dropsitcph": 4084376700,
    "dropfax": 4084376699
  },
  {
    "dcode": "D",
    "dropkey": "E019938",
    "droptype": "S",
    "dropname": "SAN JUAN PR MPA3",
    "dropdeladd": "60 CALLE GILDITA STE 635",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009839900",
    "dropphyadd": "60 CALLE GILDITA STE 635",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009839900",
    "dropmaladd": "60 CALLE GILDITA STE 635",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009839900",
    "dropsitphn": 7876221795,
    "dropsitlph": "",
    "dropsitcph": 7876221920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019956",
    "droptype": "D",
    "dropname": "WEST VALLEY AZ PSA",
    "dropdeladd": "500 S 104TH AVE",
    "dropdelcty": "TOLLESON",
    "dropdelst": "AZ",
    "dropdelzpp": 853539216,
    "dropphyadd": "500 S 104TH AVE",
    "dropphycty": "TOLLESON",
    "dropphyst": "AZ",
    "dropphyzpp": 853539216,
    "dropmaladd": "500 S 104TH AVE",
    "dropmalcty": "TOLLESON",
    "dropmalst": "AZ",
    "dropmalzpp": 853539216,
    "dropsitphn": 6022253214,
    "dropsitlph": 6024426076,
    "dropsitcph": 6024426000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019961",
    "droptype": "D",
    "dropname": "PHILADELPHIA PA PSA 2",
    "dropdeladd": "10 CREEK PKWY",
    "dropdelcty": "UPPER CHICHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 190619994,
    "dropphyadd": "10 CREEK PKWY",
    "dropphycty": "UPPER CHICHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 190619994,
    "dropmaladd": "10 CREEK PKWY",
    "dropmalcty": "UPPER CHICHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 190619994,
    "dropsitphn": 2156717625,
    "dropsitlph": 2156717666,
    "dropsitcph": 2156717609,
    "dropfax": 2156717622
  },
  {
    "dcode": "D",
    "dropkey": "K019975",
    "droptype": "D",
    "dropname": "RENO PEAK ANNEX",
    "dropdeladd": "385 CABELA DR UNIT 100",
    "dropdelcty": "VERDI",
    "dropdelst": "NV",
    "dropdelzpp": 894398192,
    "dropphyadd": "385 CABELA DR UNIT 100",
    "dropphycty": "VERDI",
    "dropphyst": "NV",
    "dropphyzpp": 894398192,
    "dropmaladd": "385 CABELA DR UNIT 100",
    "dropmalcty": "VERDI",
    "dropmalst": "NV",
    "dropmalzpp": 894398192,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880676,
    "dropsitcph": 7757880676,
    "dropfax": 7757880692
  },
  {
    "dcode": "D",
    "dropkey": "E019977",
    "droptype": "S",
    "dropname": "RICHMOND VA MPA",
    "dropdeladd": "13721 ROUTE 1",
    "dropdelcty": "CHESTER",
    "dropdelst": "VA",
    "dropdelzpp": 238315349,
    "dropphyadd": "13721 ROUTE 1",
    "dropphycty": "CHESTER",
    "dropphyst": "VA",
    "dropphyzpp": 238315349,
    "dropmaladd": "13721 ROUTE 1",
    "dropmalcty": "CHESTER",
    "dropmalst": "VA",
    "dropmalzpp": 238315349,
    "dropsitphn": 8047373653,
    "dropsitlph": "",
    "dropsitcph": 8047373561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E019979",
    "droptype": "S",
    "dropname": "GREENVILLE SC MPA",
    "dropdeladd": "3309 LAURENS RD",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296075396,
    "dropphyadd": "3309 LAURENS RD",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296075396,
    "dropmaladd": "3309 LAURENS RD",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296075396,
    "dropsitphn": 8039266014,
    "dropsitlph": "",
    "dropsitcph": 8642865019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K019981",
    "droptype": "S",
    "dropname": "LOG PORTSMOUTH NH SDC",
    "dropdeladd": "345 HERITAGE AVE UNIT 100",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "NH",
    "dropdelzpp": "038019908",
    "dropphyadd": "345 HERITAGE AVE UNIT 100",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "NH",
    "dropphyzpp": "038019908",
    "dropmaladd": "345 HERITAGE AVE UNIT 100",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "NH",
    "dropmalzpp": "038019908",
    "dropsitphn": 6036444128,
    "dropsitlph": "",
    "dropsitcph": 6034312871,
    "dropfax": 6034308931
  },
  {
    "dcode": "D",
    "dropkey": "EZ23458",
    "droptype": "S",
    "dropname": "SACRAMENTO CA MPA2",
    "dropdeladd": "3131 ARCH AIRPORT RD",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952139996,
    "dropphyadd": "3131 ARCH AIRPORT RD",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952139996,
    "dropmaladd": "3131 ARCH AIRPORT RD",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952139996,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099836351,
    "dropsitcph": 2099836397,
    "dropfax": 2099836215
  },
  {
    "dcode": "D",
    "dropkey": "E020029",
    "droptype": "S",
    "dropname": "LA CA ISC IRF MPA",
    "dropdeladd": "10080 INTERNATIONAL RD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900459996,
    "dropphyadd": "10080 INTERNATIONAL RD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900459996,
    "dropmaladd": "10080 INTERNATIONAL RD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900459996,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3103378700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020031",
    "droptype": "S",
    "dropname": "INDUSTRY CA MPA",
    "dropdeladd": "321 VINELAND AVE",
    "dropdelcty": "CITY OF INDUSTRY",
    "dropdelst": "CA",
    "dropdelzpp": 917462341,
    "dropphyadd": "321 VINELAND AVE",
    "dropphycty": "CITY OF INDUSTRY",
    "dropphyst": "CA",
    "dropphyzpp": 917462341,
    "dropmaladd": "321 VINELAND AVE",
    "dropmalcty": "CITY OF INDUSTRY",
    "dropmalst": "CA",
    "dropmalzpp": 917462341,
    "dropsitphn": 6268556440,
    "dropsitlph": 6268556522,
    "dropsitcph": 6268556440,
    "dropfax": 6268556696
  },
  {
    "dcode": "D",
    "dropkey": "E020033",
    "droptype": "S",
    "dropname": "SAN DIEGO CA MPA",
    "dropdeladd": "2611 BUSINESS PARK DR",
    "dropdelcty": "VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 920817817,
    "dropphyadd": "2611 BUSINESS PARK DR",
    "dropphycty": "VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 920817817,
    "dropmaladd": "2611 BUSINESS PARK DR",
    "dropmalcty": "VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 920817817,
    "dropsitphn": 8586740173,
    "dropsitlph": 8586740109,
    "dropsitcph": 8586742670,
    "dropfax": 8586740373
  },
  {
    "dcode": "D",
    "dropkey": "E020035",
    "droptype": "S",
    "dropname": "SAN BERNARDINO CA MPA",
    "dropdeladd": "27400 5TH ST",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "CA",
    "dropdelzpp": 923464204,
    "dropphyadd": "27400 5TH ST",
    "dropphycty": "HIGHLAND",
    "dropphyst": "CA",
    "dropphyzpp": 923464204,
    "dropmaladd": "27400 5TH ST",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "CA",
    "dropmalzpp": 923464204,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093354531,
    "dropsitcph": 9093354300,
    "dropfax": 9093354415
  },
  {
    "dcode": "D",
    "dropkey": "K020038",
    "droptype": "S",
    "dropname": "LOG RALEIGH NC MPA",
    "dropdeladd": "5511 W TEN RD",
    "dropdelcty": "MEBANE",
    "dropdelst": "NC",
    "dropdelzpp": 273028769,
    "dropphyadd": "5511 W TEN RD",
    "dropphycty": "MEBANE",
    "dropphyst": "NC",
    "dropphyzpp": 273028769,
    "dropmaladd": "5511 W TEN RD",
    "dropmalcty": "MEBANE",
    "dropmalst": "NC",
    "dropmalzpp": 273028769,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205106,
    "dropfax": 9194205357
  },
  {
    "dcode": "D",
    "dropkey": "E019064",
    "droptype": "S",
    "dropname": "LOS ANGELES CA ISC",
    "dropdeladd": "1 YEAGER WAY",
    "dropdelcty": "BELL GARDENS",
    "dropdelst": "CA",
    "dropdelzpp": 902059998,
    "dropphyadd": "1 YEAGER WAY",
    "dropphycty": "BELL GARDENS",
    "dropphyst": "CA",
    "dropphyzpp": 902059998,
    "dropmaladd": "1 YEAGER WAY",
    "dropmalcty": "BELL GARDENS",
    "dropmalst": "CA",
    "dropmalzpp": 902059998,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3237291976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020200",
    "droptype": "S",
    "dropname": "MEMPHIS TN MPA",
    "dropdeladd": "4550 SWINNEA RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381189700,
    "dropphyadd": "4550 SWINNEA RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381189700,
    "dropmaladd": "4550 SWINNEA RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381189700,
    "dropsitphn": 6158859336,
    "dropsitlph": "",
    "dropsitcph": 9017959882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020301",
    "droptype": "S",
    "dropname": "INDIANAPOLIS IN RPDC",
    "dropdeladd": "5505 BROOKVILLE RD",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462197153,
    "dropphyadd": "5505 BROOKVILLE RD",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462197153,
    "dropmaladd": "5505 BROOKVILLE RD",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462197153,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020303",
    "droptype": "S",
    "dropname": "ATLANTA GA RPDC",
    "dropdeladd": "600 PALMETTO LOGISTICS PKWY",
    "dropdelcty": "PALMETTO",
    "dropdelst": "GA",
    "dropdelzpp": 302689991,
    "dropphyadd": "600 PALMETTO LOGISTICS PKWY",
    "dropphycty": "PALMETTO",
    "dropphyst": "GA",
    "dropphyzpp": 302689991,
    "dropmaladd": "600 PALMETTO LOGISTICS PKWY",
    "dropmalcty": "PALMETTO",
    "dropmalst": "GA",
    "dropmalzpp": 302689991,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047657578,
    "dropsitcph": 7704306253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020305",
    "droptype": "D",
    "dropname": "RENO PEAK ANNEX NEW",
    "dropdeladd": "9499 N VIRGINIA ST UNIT 105",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895067755,
    "dropphyadd": "9499 N VIRGINIA ST UNIT 105",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895067755,
    "dropmaladd": "9499 N VIRGINIA ST UNIT 105",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895067755,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880676,
    "dropsitcph": 7757880676,
    "dropfax": 7757880692
  },
  {
    "dcode": "D",
    "dropkey": "K020307",
    "droptype": "S",
    "dropname": "CHARLOTTE NC RPDC",
    "dropdeladd": "524 SCALYBARK RD",
    "dropdelcty": "GASTONIA",
    "dropdelst": "NC",
    "dropdelzpp": 280549994,
    "dropphyadd": "524 SCALYBARK RD",
    "dropphycty": "GASTONIA",
    "dropphyst": "NC",
    "dropphyzpp": 280549994,
    "dropmaladd": "524 SCALYBARK RD",
    "dropmalcty": "GASTONIA",
    "dropmalst": "NC",
    "dropmalzpp": 280549994,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7043934444,
    "dropfax": 7043934476
  },
  {
    "dcode": "D",
    "dropkey": "K020388",
    "droptype": "S",
    "dropname": "LOG NEW ENGLAND X DOCK NEW",
    "dropdeladd": "24 RESEARCH PKWY",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929000",
    "dropphyadd": "24 RESEARCH PKWY",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929000",
    "dropmaladd": "24 RESEARCH PKWY",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929000",
    "dropsitphn": 2032698712,
    "dropsitlph": 2039493157,
    "dropsitcph": 2039493105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020440",
    "droptype": "S",
    "dropname": "SALT LAKE CITY UT MPA",
    "dropdeladd": "1795 W 2100 S",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841999781,
    "dropphyadd": "1795 W 2100 S",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841999781,
    "dropmaladd": "1795 W 2100 S",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841999781,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742298,
    "dropsitcph": 8019783093,
    "dropfax": 8019783034
  },
  {
    "dcode": "D",
    "dropkey": "E020709",
    "droptype": "S",
    "dropname": "SOUTH HOUSTON TX LPC",
    "dropdeladd": "611 HIGHWAY 90 A",
    "dropdelcty": "MISSOURI CITY",
    "dropdelst": "TX",
    "dropdelzpp": 774899904,
    "dropphyadd": "611 HIGHWAY 90 A",
    "dropphycty": "MISSOURI CITY",
    "dropphyst": "TX",
    "dropphyzpp": 774899904,
    "dropmaladd": "611 HIGHWAY 90 A",
    "dropmalcty": "MISSOURI CITY",
    "dropmalst": "TX",
    "dropmalzpp": 774899904,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263475,
    "dropsitcph": 7132264202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020838",
    "droptype": "S",
    "dropname": "LOG POMPANO BEACH FL LPC",
    "dropdeladd": "3250 NW 33RD ST",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330699810,
    "dropphyadd": "3250 NW 33RD ST",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330699810,
    "dropmaladd": "3250 NW 33RD ST",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330699810,
    "dropsitphn": 3055132368,
    "dropsitlph": "",
    "dropsitcph": 9549355122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020847",
    "droptype": "D",
    "dropname": "SALT LAKE PEAK ANNEX",
    "dropdeladd": "1194 N 6880 W STE 400",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841165260,
    "dropphyadd": "1194 N 6880 W STE 400",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841165260,
    "dropmaladd": "1194 N 6880 W STE 400",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841165260,
    "dropsitphn": 8019742558,
    "dropsitlph": "",
    "dropsitcph": 8019742332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020956",
    "droptype": "S",
    "dropname": "PORTLAND OR LPC",
    "dropdeladd": "7007 NE CORNFOOT RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972189994,
    "dropphyadd": "7007 NE CORNFOOT RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972189994,
    "dropmaladd": "7007 NE CORNFOOT RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972189994,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5032942421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020959",
    "droptype": "S",
    "dropname": "RICHMOND VA LPC",
    "dropdeladd": "5801 TECHNOLOGY BLVD",
    "dropdelcty": "SANDSTON",
    "dropdelst": "VA",
    "dropdelzpp": 231505047,
    "dropphyadd": "5801 TECHNOLOGY BLVD",
    "dropphycty": "SANDSTON",
    "dropphyst": "VA",
    "dropphyzpp": 231505047,
    "dropmaladd": "5801 TECHNOLOGY BLVD",
    "dropmalcty": "SANDSTON",
    "dropmalst": "VA",
    "dropmalzpp": 231505047,
    "dropsitphn": 8047373653,
    "dropsitlph": "",
    "dropsitcph": 8047373561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K020975",
    "droptype": "S",
    "dropname": "PHOENIX AZ RPDC RTH",
    "dropdeladd": "12250 W CORPORATE DR",
    "dropdelcty": "AVONDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 853231378,
    "dropphyadd": "12250 W CORPORATE DR",
    "dropphycty": "AVONDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 853231378,
    "dropmaladd": "12250 W CORPORATE DR",
    "dropmalcty": "AVONDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 853231378,
    "dropsitphn": 6022253030,
    "dropsitlph": 6022253214,
    "dropsitcph": 6022534913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "E020988",
    "droptype": "S",
    "dropname": "BOISE ID LPC",
    "dropdeladd": "2201 S COLE RD",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837089993,
    "dropphyadd": "2201 S COLE RD",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837089993,
    "dropmaladd": "2201 S COLE RD",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837089993,
    "dropsitphn": 2084334080,
    "dropsitlph": "",
    "dropsitcph": 2084334000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021002",
    "droptype": "S",
    "dropname": "LOG ATHENS",
    "dropdeladd": "5 W STIMSON AVE",
    "dropdelcty": "ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 457012668,
    "dropphyadd": "5 W STIMSON AVE",
    "dropphycty": "ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 457012668,
    "dropmaladd": "5 W STIMSON AVE",
    "dropmalcty": "ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 457012668,
    "dropsitphn": 7405935578,
    "dropsitlph": "",
    "dropsitcph": 6144720673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021003",
    "droptype": "S",
    "dropname": "LOG LIMA",
    "dropdeladd": "350 W HIGH ST",
    "dropdelcty": "LIMA",
    "dropdelst": "OH",
    "dropdelzpp": 458019998,
    "dropphyadd": "350 W HIGH ST",
    "dropphycty": "LIMA",
    "dropphyst": "OH",
    "dropphyzpp": 458019998,
    "dropmaladd": "350 W HIGH ST",
    "dropmalcty": "LIMA",
    "dropmalst": "OH",
    "dropmalzpp": 458019998,
    "dropsitphn": 5136845763,
    "dropsitlph": "",
    "dropsitcph": 4192277777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021004",
    "droptype": "S",
    "dropname": "LOG ZANESVILLE",
    "dropdeladd": "900 MCINTIRE AVE",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437019998,
    "dropphyadd": "900 MCINTIRE AVE",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437019998,
    "dropmaladd": "900 MCINTIRE AVE",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437019998,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 7404552802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020222,
    "droptype": "S",
    "dropname": "ATHENS GA S&DC",
    "dropdeladd": "575 OLYMPIC DR",
    "dropdelcty": "ATHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306019902,
    "dropphyadd": "575 OLYMPIC DR",
    "dropphycty": "ATHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306019902,
    "dropmaladd": "575 OLYMPIC DR",
    "dropmalcty": "ATHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306019902,
    "dropsitphn": 4047657578,
    "dropsitlph": "",
    "dropsitcph": 7063693216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020683,
    "droptype": "S",
    "dropname": "COLUMBUS GA S&DC",
    "dropdeladd": "3916 MILGEN RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079901,
    "dropphyadd": "3916 MILGEN RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319079901,
    "dropmaladd": "3916 MILGEN RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319079901,
    "dropsitphn": 4787528444,
    "dropsitlph": "",
    "dropsitcph": 7065621782,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020719,
    "droptype": "S",
    "dropname": "CHARLOTTESVILLE VA S&DC",
    "dropdeladd": "1155 SEMINOLE TRL",
    "dropdelcty": "CHARLOTTESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229069700,
    "dropphyadd": "1155 SEMINOLE TRL",
    "dropphycty": "CHARLOTTESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229069700,
    "dropmaladd": "1155 SEMINOLE TRL",
    "dropmalcty": "CHARLOTTESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229069700,
    "dropsitphn": 8047756336,
    "dropsitlph": "",
    "dropsitcph": 4349787621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020717,
    "droptype": "S",
    "dropname": "HAMPTON VA S&DC",
    "dropdeladd": "809 ABERDEEN RD",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236709702,
    "dropphyadd": "809 ABERDEEN RD",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236709702,
    "dropmaladd": "809 ABERDEEN RD",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236709702,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7572624850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020650,
    "droptype": "S",
    "dropname": "RICHMOND VA S&DC",
    "dropdeladd": "1801 BROOK RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232329903,
    "dropphyadd": "1801 BROOK RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232329903,
    "dropmaladd": "1801 BROOK RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232329903,
    "dropsitphn": 8047756336,
    "dropsitlph": "",
    "dropsitcph": 8047756094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021011",
    "droptype": "S",
    "dropname": "LOG CHILLICOTHE",
    "dropdeladd": "40 S WALNUT ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "OH",
    "dropdelzpp": 456013257,
    "dropphyadd": "40 S WALNUT ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "OH",
    "dropphyzpp": 456013257,
    "dropmaladd": "40 S WALNUT ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "OH",
    "dropmalzpp": 456013257,
    "dropsitphn": 7407741181,
    "dropsitlph": "",
    "dropsitcph": 7407741181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021041",
    "droptype": "S",
    "dropname": "LOG BATESVILLE",
    "dropdeladd": "490 E COLLEGE ST STE 139",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 725019998,
    "dropphyadd": "490 E COLLEGE ST STE 139",
    "dropphycty": "BATESVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 725019998,
    "dropmaladd": "490 E COLLEGE ST STE 139",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 725019998,
    "dropsitphn": 8707936829,
    "dropsitlph": "",
    "dropsitcph": 8707936828,
    "dropfax": 8706980314
  },
  {
    "dcode": "D",
    "dropkey": "K021042",
    "droptype": "S",
    "dropname": "LOG CAMDEN",
    "dropdeladd": "351 W WASHINGTON ST STE 100",
    "dropdelcty": "CAMDEN",
    "dropdelst": "AR",
    "dropdelzpp": 717019998,
    "dropphyadd": "351 W WASHINGTON ST STE 100",
    "dropphycty": "CAMDEN",
    "dropphyst": "AR",
    "dropphyzpp": 717019998,
    "dropmaladd": "351 W WASHINGTON ST STE 100",
    "dropmalcty": "CAMDEN",
    "dropmalst": "AR",
    "dropmalzpp": 717019998,
    "dropsitphn": 8708368146,
    "dropsitlph": "",
    "dropsitcph": 8708368146,
    "dropfax": 8708367549
  },
  {
    "dcode": "D",
    "dropkey": "K021043",
    "droptype": "S",
    "dropname": "LOG HOT SPRINGS NATIONAL PK",
    "dropdeladd": "335 SECTION LINE RD",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139998,
    "dropphyadd": "335 SECTION LINE RD",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139998,
    "dropmaladd": "335 SECTION LINE RD",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139998,
    "dropsitphn": 5015252473,
    "dropsitlph": "",
    "dropsitcph": 5015250558,
    "dropfax": 5015253164
  },
  {
    "dcode": "D",
    "dropkey": "K021044",
    "droptype": "S",
    "dropname": "LOG PINE BLUFF",
    "dropdeladd": "100 E 8TH AVE STE 105",
    "dropdelcty": "PINE BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 716019998,
    "dropphyadd": "100 E 8TH AVE STE 105",
    "dropphycty": "PINE BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 716019998,
    "dropmaladd": "100 E 8TH AVE STE 105",
    "dropmalcty": "PINE BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 716019998,
    "dropsitphn": 8705363535,
    "dropsitlph": "",
    "dropsitcph": 8705363535,
    "dropfax": 8705359512
  },
  {
    "dcode": "D",
    "dropkey": "K021045",
    "droptype": "S",
    "dropname": "LOG RUSSELLVILLE",
    "dropdeladd": "203 S BOSTON AVE",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728019998,
    "dropphyadd": "203 S BOSTON AVE",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728019998,
    "dropmaladd": "203 S BOSTON AVE",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728019998,
    "dropsitphn": 4799684112,
    "dropsitlph": "",
    "dropsitcph": 4799684112,
    "dropfax": 4799683628
  },
  {
    "dcode": "D",
    "dropkey": "K021086",
    "droptype": "S",
    "dropname": "DALLAS TX RPDC RTH",
    "dropdeladd": "1421 N COCKRELL HILL RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752111465,
    "dropphyadd": "1421 N COCKRELL HILL RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752111465,
    "dropmaladd": "1421 N COCKRELL HILL RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752111465,
    "dropsitphn": 2149482879,
    "dropsitlph": "",
    "dropsitcph": 2144675828,
    "dropfax": 2144675853
  },
  {
    "dcode": "D",
    "dropkey": 4020564,
    "droptype": "S",
    "dropname": "JACKSON MI S&DC",
    "dropdeladd": "1500 N ELM AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "MI",
    "dropdelzpp": 492029910,
    "dropphyadd": "1500 N ELM AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "MI",
    "dropphyzpp": 492029910,
    "dropmaladd": "1500 N ELM AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "MI",
    "dropmalzpp": 492029910,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177860726,
    "dropsitcph": 5177680721,
    "dropfax": 5177680618
  },
  {
    "dcode": "D",
    "dropkey": "K021097",
    "droptype": "S",
    "dropname": "LOG SAGINAW",
    "dropdeladd": "1233 S WASHINGTON AVE",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486012517,
    "dropphyadd": "1233 S WASHINGTON AVE",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486012517,
    "dropmaladd": "PO BOX 59998",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486059998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897715718,
    "dropfax": 9897715715
  },
  {
    "dcode": "D",
    "dropkey": 4020651,
    "droptype": "S",
    "dropname": "FLINT MI S&DC",
    "dropdeladd": "250 E BOULEVARD DR",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485029916,
    "dropphyadd": "250 E BOULEVARD DR",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485029916,
    "dropmaladd": "250 E BOULEVARD DR",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485029916,
    "dropsitphn": 8102571567,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102571506,
    "dropfax": 8102571518
  },
  {
    "dcode": "D",
    "dropkey": 4020680,
    "droptype": "S",
    "dropname": "KALAMAZOO MI S&DC",
    "dropdeladd": "3885 S 9TH ST",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490099908,
    "dropphyadd": "3885 S 9TH ST",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490099908,
    "dropmaladd": "3885 S 9TH ST",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490099908,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2693535005,
    "dropfax": 2693535054
  },
  {
    "dcode": "D",
    "dropkey": "K021100",
    "droptype": "S",
    "dropname": "LOG GAYLORD",
    "dropdeladd": "289 W COMMERCE BLVD",
    "dropdelcty": "GAYLORD",
    "dropdelst": "MI",
    "dropdelzpp": 497359998,
    "dropphyadd": "289 W COMMERCE BLVD",
    "dropphycty": "GAYLORD",
    "dropphyst": "MI",
    "dropphyzpp": 497359998,
    "dropmaladd": "289 W COMMERCE BLVD",
    "dropmalcty": "GAYLORD",
    "dropmalst": "MI",
    "dropmalzpp": 497359998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897326800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14866",
    "droptype": "S",
    "dropname": "BOONE",
    "dropdeladd": "1544 BLOWING ROCK RD",
    "dropdelcty": "BOONE",
    "dropdelst": "NC",
    "dropdelzpp": 286071000,
    "dropphyadd": "1544 BLOWING ROCK RD",
    "dropphycty": "BOONE",
    "dropphyst": "NC",
    "dropphyzpp": 286071000,
    "dropmaladd": "1544 BLOWING ROCK RD",
    "dropmalcty": "BOONE",
    "dropmalst": "NC",
    "dropmalzpp": 286071000,
    "dropsitphn": 9969319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282643813,
    "dropfax": 8282639652
  },
  {
    "dcode": "D",
    "dropkey": "PY15949",
    "droptype": "S",
    "dropname": "MORGANTON",
    "dropdeladd": "320 SANFORD DR",
    "dropdelcty": "MORGANTON",
    "dropdelst": "NC",
    "dropdelzpp": 286552574,
    "dropphyadd": "320 SANFORD DR",
    "dropphycty": "MORGANTON",
    "dropphyst": "NC",
    "dropphyzpp": 286552574,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORGANTON",
    "dropmalst": "NC",
    "dropmalzpp": 286559998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284373484,
    "dropfax": 8284376944
  },
  {
    "dcode": "D",
    "dropkey": "PY16039",
    "droptype": "S",
    "dropname": "NEWTON",
    "dropdeladd": "218 S MAIN AVE",
    "dropdelcty": "NEWTON",
    "dropdelst": "NC",
    "dropdelzpp": 286583357,
    "dropphyadd": "218 S MAIN AVE",
    "dropphycty": "NEWTON",
    "dropphyst": "NC",
    "dropphyzpp": 286583357,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWTON",
    "dropmalst": "NC",
    "dropmalzpp": 286589998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284644031,
    "dropfax": 8284649123
  },
  {
    "dcode": "D",
    "dropkey": "PY16064",
    "droptype": "S",
    "dropname": "NORTH WILKESBORO",
    "dropdeladd": "300 8TH ST",
    "dropdelcty": "NORTH WILKESBORO",
    "dropdelst": "NC",
    "dropdelzpp": 286594163,
    "dropphyadd": "300 8TH ST",
    "dropphycty": "NORTH WILKESBORO",
    "dropphyst": "NC",
    "dropphyzpp": 286594163,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH WILKESBORO",
    "dropmalst": "NC",
    "dropmalzpp": 286599998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366677127,
    "dropfax": 3366671054
  },
  {
    "dcode": "D",
    "dropkey": "PY16524",
    "droptype": "S",
    "dropname": "STATESVILLE",
    "dropdeladd": "301 S OAKLAND AVE",
    "dropdelcty": "STATESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286779998,
    "dropphyadd": "301 S OAKLAND AVE",
    "dropphycty": "STATESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286779998,
    "dropmaladd": "301 S OAKLAND AVE",
    "dropmalcty": "STATESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286779998,
    "dropsitphn": 3363781463,
    "dropsitlph": 3362715587,
    "dropsitcph": 7048725213,
    "dropfax": 7048721907
  },
  {
    "dcode": "D",
    "dropkey": 4011728,
    "droptype": "S",
    "dropname": "ATLANTIC CITY CARRIER ANNEX",
    "dropdeladd": "800 ABSECON BLVD",
    "dropdelcty": "ATLANTIC CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "084019995",
    "dropphyadd": "800 ABSECON BLVD",
    "dropphycty": "ATLANTIC CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "084019995",
    "dropmaladd": "800 ABSECON BLVD",
    "dropmalcty": "ATLANTIC CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "084019995",
    "dropsitphn": 8569334046,
    "dropsitlph": "",
    "dropsitcph": 6093482940,
    "dropfax": 6093445587
  },
  {
    "dcode": "D",
    "dropkey": "PX20447",
    "droptype": "S",
    "dropname": "CANTON",
    "dropdeladd": "2650 CLEVELAND AVE NW",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447119998,
    "dropphyadd": "2650 CLEVELAND AVE NW",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447119998,
    "dropmaladd": "2650 CLEVELAND AVE NW",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447119998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304386477,
    "dropfax": 3304386407
  },
  {
    "dcode": "D",
    "dropkey": "PW12831",
    "droptype": "S",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "151 N MAIN ST",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 629319998,
    "dropphyadd": "151 N MAIN ST",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 629319998,
    "dropmaladd": "151 N MAIN ST",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 629319998,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 6182872622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10480",
    "droptype": "S",
    "dropname": "GADSDEN",
    "dropdeladd": "700 CHESTNUT ST",
    "dropdelcty": "GADSDEN",
    "dropdelst": "AL",
    "dropdelzpp": 359019998,
    "dropphyadd": "700 CHESTNUT ST",
    "dropphycty": "GADSDEN",
    "dropphyst": "AL",
    "dropphyzpp": 359019998,
    "dropmaladd": "700 CHESTNUT ST",
    "dropmalcty": "GADSDEN",
    "dropmalst": "AL",
    "dropmalzpp": 359019998,
    "dropsitphn": 2565476391,
    "dropsitlph": "",
    "dropsitcph": 2565476391,
    "dropfax": 2565439410
  },
  {
    "dcode": "D",
    "dropkey": "PX21744",
    "droptype": "S",
    "dropname": "MANSFIELD",
    "dropdeladd": "200 N DIAMOND ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 449011006,
    "dropphyadd": "200 N DIAMOND ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 449011006,
    "dropmaladd": "200 N DIAMOND ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 449011006,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197554649,
    "dropfax": 4197554660
  },
  {
    "dcode": "D",
    "dropkey": "PZ17234",
    "droptype": "S",
    "dropname": "OLYMPIA",
    "dropdeladd": "900 JEFFERSON ST SE",
    "dropdelcty": "OLYMPIA",
    "dropdelst": "WA",
    "dropdelzpp": 985019998,
    "dropphyadd": "900 JEFFERSON ST SE",
    "dropphycty": "OLYMPIA",
    "dropphyst": "WA",
    "dropphyzpp": 985019998,
    "dropmaladd": "900 JEFFERSON ST SE",
    "dropmalcty": "OLYMPIA",
    "dropmalst": "WA",
    "dropmalzpp": 985019998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605706330,
    "dropsitcph": 3605706300,
    "dropfax": 3605706340
  },
  {
    "dcode": "D",
    "dropkey": "PZ17301",
    "droptype": "S",
    "dropname": "PORT HADLOCK",
    "dropdeladd": "93 MATHESON ST",
    "dropdelcty": "PORT HADLOCK",
    "dropdelst": "WA",
    "dropdelzpp": 983399800,
    "dropphyadd": "93 MATHESON ST",
    "dropphycty": "PORT HADLOCK",
    "dropphyst": "WA",
    "dropphyzpp": 983399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT HADLOCK",
    "dropmalst": "WA",
    "dropmalzpp": 983399998,
    "dropsitphn": 2067684422,
    "dropsitlph": "",
    "dropsitcph": 3603850605,
    "dropfax": 6516751582
  },
  {
    "dcode": "D",
    "dropkey": "PX1A704",
    "droptype": "S",
    "dropname": "READING",
    "dropdeladd": "2100 N 13TH ST",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196129992,
    "dropphyadd": "2100 N 13TH ST",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196129992,
    "dropmaladd": "2100 N 13TH ST",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196129992,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217055,
    "dropsitcph": 6109217000,
    "dropfax": 6109217025
  },
  {
    "dcode": "D",
    "dropkey": "PW14658",
    "droptype": "S",
    "dropname": "ROCKFORD",
    "dropdeladd": "5225 HARRISON AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611259300,
    "dropphyadd": "5225 HARRISON AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611259300,
    "dropmaladd": "5225 HARRISON AVE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611259300,
    "dropsitphn": 6302605499,
    "dropsitlph": "",
    "dropsitcph": 8152294804,
    "dropfax": 8152294857
  },
  {
    "dcode": "D",
    "dropkey": "PX11114",
    "droptype": "S",
    "dropname": "SAVANNAH",
    "dropdeladd": "2 N FAHM ST RM 1A",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314019998,
    "dropphyadd": "2 N FAHM ST RM 1A",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314019998,
    "dropmaladd": "2 N FAHM ST RM 1A",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314019998,
    "dropsitphn": 4787528444,
    "dropsitlph": "",
    "dropsitcph": 9122354666,
    "dropfax": 9122354678
  },
  {
    "dcode": "D",
    "dropkey": 4020655,
    "droptype": "S",
    "dropname": "SOUTHEASTERN PA S&DC",
    "dropdeladd": "1000 W VALLEY RD",
    "dropdelcty": "SOUTHEASTERN",
    "dropdelst": "PA",
    "dropdelzpp": 193999944,
    "dropphyadd": "1000 W VALLEY RD",
    "dropphycty": "SOUTHEASTERN",
    "dropphyst": "PA",
    "dropphyzpp": 193999944,
    "dropmaladd": "1000 W VALLEY RD",
    "dropmalcty": "SOUTHEASTERN",
    "dropmalst": "PA",
    "dropmalzpp": 193999944,
    "dropsitphn": 6109646414,
    "dropsitlph": "",
    "dropsitcph": 6109646448,
    "dropfax": 6109645467
  },
  {
    "dcode": "D",
    "dropkey": "PV16367",
    "droptype": "S",
    "dropname": "STATEN ISLAND",
    "dropdeladd": "550 MANOR RD STE 1",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103149996,
    "dropphyadd": "550 MANOR RD STE 1",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103149996,
    "dropmaladd": "550 MANOR RD STE 1",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103149996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7188162710,
    "dropfax": 7188162783
  },
  {
    "dcode": "D",
    "dropkey": 4020476,
    "droptype": "S",
    "dropname": "UTICA NY S&DC",
    "dropdeladd": "100 PITCHER ST",
    "dropdelcty": "UTICA",
    "dropdelst": "NY",
    "dropdelzpp": 135049937,
    "dropphyadd": "100 PITCHER ST",
    "dropphycty": "UTICA",
    "dropphyst": "NY",
    "dropphyzpp": 135049937,
    "dropmaladd": "100 PITCHER ST",
    "dropmalcty": "UTICA",
    "dropmalst": "NY",
    "dropmalzpp": 135049937,
    "dropsitphn": 3157385313,
    "dropsitlph": "",
    "dropsitcph": 3157385313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20783",
    "droptype": "S",
    "dropname": "WATERBURY",
    "dropdeladd": "135 GRAND ST",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067019998",
    "dropphyadd": "135 GRAND ST",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067019998",
    "dropmaladd": "135 GRAND ST",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067019998",
    "dropsitphn": 2035746521,
    "dropsitlph": "",
    "dropsitcph": 2035746521,
    "dropfax": 2035746588
  },
  {
    "dcode": "D",
    "dropkey": 4020940,
    "droptype": "S",
    "dropname": "YORK EAST PA S&DC",
    "dropdeladd": "3435 CONCORD RD OFC",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174029900,
    "dropphyadd": "3435 CONCORD RD OFC",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174029900,
    "dropmaladd": "3435 CONCORD RD OFC",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174029900,
    "dropsitphn": 7172574870,
    "dropsitlph": 7178482381,
    "dropsitcph": 7177514612,
    "dropfax": 7177514679
  },
  {
    "dcode": "D",
    "dropkey": "K021215",
    "droptype": "S",
    "dropname": "LOG LUBBOCK TX MPA",
    "dropdeladd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794039905,
    "dropphyadd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794039905,
    "dropmaladd": "508 LUBBOCK BUSINESS PARK BLVD",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794039905,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067627841,
    "dropsitcph": 8067627841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020508,
    "droptype": "S",
    "dropname": "WILLIAMSPORT PA S&DC",
    "dropdeladd": "2901 REACH RD",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177019922,
    "dropphyadd": "2901 REACH RD",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177019922,
    "dropmaladd": "2901 REACH RD",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177019922,
    "dropsitphn": 7172574870,
    "dropsitlph": "",
    "dropsitcph": 8148323214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "K021271",
    "droptype": "S",
    "dropname": "LOG JOHNSON CITY TN LPC",
    "dropdeladd": "128 ROWELAND DR",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376013822,
    "dropphyadd": "128 ROWELAND DR",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376013822,
    "dropmaladd": "128 ROWELAND DR",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376013822,
    "dropsitphn": 6158859336,
    "dropsitlph": "",
    "dropsitcph": 4232325840,
    "dropfax": 4232325860
  },
  {
    "dcode": "D",
    "dropkey": "K021272",
    "droptype": "D",
    "dropname": "KANSAS CITY KS RPDC",
    "dropdeladd": "17150 MERCURY ST",
    "dropdelcty": "OLATHE",
    "dropdelst": "KS",
    "dropdelzpp": 660618815,
    "dropphyadd": "17150 MERCURY ST",
    "dropphycty": "OLATHE",
    "dropphyst": "KS",
    "dropphyzpp": 660618815,
    "dropmaladd": "17150 MERCURY ST",
    "dropmalcty": "OLATHE",
    "dropmalst": "KS",
    "dropmalzpp": 660618815,
    "dropsitphn": 9135732520,
    "dropsitlph": 9135732542,
    "dropsitcph": 9135732641,
    "dropfax": 9135732698
  },
  {
    "dcode": "D",
    "dropkey": "K021273",
    "droptype": "S",
    "dropname": "LOG KANSAS CITY KS RPDC",
    "dropdeladd": "17150 MERCURY ST",
    "dropdelcty": "OLATHE",
    "dropdelst": "KS",
    "dropdelzpp": 660618815,
    "dropphyadd": "17150 MERCURY ST",
    "dropphycty": "OLATHE",
    "dropphyst": "KS",
    "dropphyzpp": 660618815,
    "dropmaladd": "17150 MERCURY ST",
    "dropmalcty": "OLATHE",
    "dropmalst": "KS",
    "dropmalzpp": 660618815,
    "dropsitphn": 9135732520,
    "dropsitlph": 9135732542,
    "dropsitcph": 9135732641,
    "dropfax": 9135732698
  },
  {
    "dcode": "D",
    "dropkey": "PV10001",
    "droptype": "D",
    "dropname": "APO",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979997",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979997",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979997",
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215323,
    "dropsitcph": 7185537138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10009",
    "droptype": "D",
    "dropname": "ABSECON",
    "dropdeladd": "1001 NEW JERSEY AVE",
    "dropdelcty": "ABSECON",
    "dropdelst": "NJ",
    "dropdelzpp": "082019998",
    "dropphyadd": "1001 NEW JERSEY AVE",
    "dropphycty": "ABSECON",
    "dropphyst": "NJ",
    "dropphyzpp": "082019998",
    "dropmaladd": "1001 NEW JERSEY AVE",
    "dropmalcty": "ABSECON",
    "dropmalst": "NJ",
    "dropmalzpp": "082019998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096418066,
    "dropsitcph": 6096418066,
    "dropfax": 6096462618
  },
  {
    "dcode": "D",
    "dropkey": "PV10013",
    "droptype": "D",
    "dropname": "ADELPHIA",
    "dropdeladd": "16 WYCKOFF MILLS RD",
    "dropdelcty": "ADELPHIA",
    "dropdelst": "NJ",
    "dropdelzpp": "077109998",
    "dropphyadd": "16 WYCKOFF MILLS RD",
    "dropphycty": "ADELPHIA",
    "dropphyst": "NJ",
    "dropphyzpp": "077109998",
    "dropmaladd": "16 WYCKOFF MILLS RD",
    "dropmalcty": "ADELPHIA",
    "dropmalst": "NJ",
    "dropmalzpp": "077109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324625578,
    "dropsitcph": 7324625578,
    "dropfax": 7328631899
  },
  {
    "dcode": "D",
    "dropkey": "PV10017",
    "droptype": "D",
    "dropname": "ALLAMUCHY",
    "dropdeladd": "16 RUTHERFORD RD",
    "dropdelcty": "ALLAMUCHY",
    "dropdelst": "NJ",
    "dropdelzpp": "078209998",
    "dropphyadd": "16 RUTHERFORD RD",
    "dropphycty": "ALLAMUCHY",
    "dropphyst": "NJ",
    "dropphyzpp": "078209998",
    "dropmaladd": "16 RUTHERFORD RD",
    "dropmalcty": "ALLAMUCHY",
    "dropmalst": "NJ",
    "dropmalzpp": "078209998",
    "dropsitphn": 9735157867,
    "dropsitlph": 9088521093,
    "dropsitcph": 9088521093,
    "dropfax": 6505774024
  },
  {
    "dcode": "D",
    "dropkey": "PV10019",
    "droptype": "D",
    "dropname": "ALLENDALE",
    "dropdeladd": "2 MYRTLE AVE",
    "dropdelcty": "ALLENDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "074019992",
    "dropphyadd": "2 MYRTLE AVE",
    "dropphycty": "ALLENDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "074019992",
    "dropmaladd": "2 MYRTLE AVE",
    "dropmalcty": "ALLENDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "074019992",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012369473,
    "dropsitcph": 2012369473,
    "dropfax": 2019340041
  },
  {
    "dcode": "D",
    "dropkey": "PV10020",
    "droptype": "D",
    "dropname": "ALLENHURST",
    "dropdeladd": "4 MAIN ST",
    "dropdelcty": "ALLENHURST",
    "dropdelst": "NJ",
    "dropdelzpp": "077119998",
    "dropphyadd": "4 MAIN ST",
    "dropphycty": "ALLENHURST",
    "dropphyst": "NJ",
    "dropphyzpp": "077119998",
    "dropmaladd": "4 MAIN ST",
    "dropmalcty": "ALLENHURST",
    "dropmalst": "NJ",
    "dropmalzpp": "077119998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325313114,
    "dropsitcph": 7325313114,
    "dropfax": 7325170636
  },
  {
    "dcode": "D",
    "dropkey": "PV10021",
    "droptype": "D",
    "dropname": "ALLENTOWN",
    "dropdeladd": "12 S MAIN ST",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "085019998",
    "dropphyadd": "12 S MAIN ST",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "085019998",
    "dropmaladd": "12 S MAIN ST",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "085019998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092592541,
    "dropsitcph": 6092592541,
    "dropfax": 6092080553
  },
  {
    "dcode": "D",
    "dropkey": "PV10022",
    "droptype": "D",
    "dropname": "ALLENWOOD",
    "dropdeladd": "3212 ALLENWOOD LAKEWOOD RD",
    "dropdelcty": "ALLENWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "087209998",
    "dropphyadd": "3212 ALLENWOOD LAKEWOOD RD",
    "dropphycty": "ALLENWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "087209998",
    "dropmaladd": "3212 ALLENWOOD LAKEWOOD RD",
    "dropmalcty": "ALLENWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "087209998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322236111,
    "dropfax": 7322239144
  },
  {
    "dcode": "D",
    "dropkey": "PV10024",
    "droptype": "D",
    "dropname": "ALLOWAY",
    "dropdeladd": "18 SCHOOL LN",
    "dropdelcty": "ALLOWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "080019998",
    "dropphyadd": "18 SCHOOL LN",
    "dropphycty": "ALLOWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "080019998",
    "dropmaladd": "18 SCHOOL LN",
    "dropmalcty": "ALLOWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "080019998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569355338,
    "dropsitcph": 8569355338,
    "dropfax": 8569355338
  },
  {
    "dcode": "D",
    "dropkey": "PV10029",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "100 CHURCH ST",
    "dropdelcty": "ALPINE",
    "dropdelst": "NJ",
    "dropdelzpp": "076201000",
    "dropphyadd": "100 CHURCH ST",
    "dropphycty": "ALPINE",
    "dropphyst": "NJ",
    "dropphyzpp": "076201000",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPINE",
    "dropmalst": "NJ",
    "dropmalzpp": "076209998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017686585,
    "dropsitcph": 2017841494,
    "dropfax": 6505774262
  },
  {
    "dcode": "D",
    "dropkey": "PV10033",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "5 LENAPE RD",
    "dropdelcty": "ANDOVER",
    "dropdelst": "NJ",
    "dropdelzpp": "078219998",
    "dropphyadd": "5 LENAPE RD",
    "dropphycty": "ANDOVER",
    "dropphyst": "NJ",
    "dropphyzpp": "078219998",
    "dropmaladd": "5 LENAPE RD",
    "dropmalcty": "ANDOVER",
    "dropmalst": "NJ",
    "dropmalzpp": "078219998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9737865651,
    "dropsitcph": 9737865651,
    "dropfax": 6505774033
  },
  {
    "dcode": "D",
    "dropkey": "PV10035",
    "droptype": "D",
    "dropname": "ANNANDALE",
    "dropdeladd": "10 LOWER WEST ST",
    "dropdelcty": "ANNANDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "088019998",
    "dropphyadd": "10 LOWER WEST ST",
    "dropphycty": "ANNANDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "088019998",
    "dropmaladd": "10 LOWER WEST ST",
    "dropmalcty": "ANNANDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "088019998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087357713,
    "dropfax": 6505775426
  },
  {
    "dcode": "D",
    "dropkey": "PV10040",
    "droptype": "D",
    "dropname": "ASBURY",
    "dropdeladd": "285 ASBURY ANDERSON RD",
    "dropdelcty": "ASBURY",
    "dropdelst": "NJ",
    "dropdelzpp": "088029998",
    "dropphyadd": "285 ASBURY ANDERSON RD",
    "dropphycty": "ASBURY",
    "dropphyst": "NJ",
    "dropphyzpp": "088029998",
    "dropmaladd": "285 ASBURY ANDERSON RD",
    "dropmalcty": "ASBURY",
    "dropmalst": "NJ",
    "dropmalzpp": "088029998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085372327,
    "dropfax": 6505775427
  },
  {
    "dcode": "D",
    "dropkey": "PV10042",
    "droptype": "D",
    "dropname": "ASBURY PARK",
    "dropdeladd": "801 BANGS AVE",
    "dropdelcty": "ASBURY PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "077129998",
    "dropphyadd": "801 BANGS AVE",
    "dropphycty": "ASBURY PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "077129998",
    "dropmaladd": "801 BANGS AVE",
    "dropmalcty": "ASBURY PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "077129998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327750696,
    "dropsitcph": 7327750696,
    "dropfax": 7327766038
  },
  {
    "dcode": "D",
    "dropkey": "PV10046",
    "droptype": "D",
    "dropname": "ATCO",
    "dropdeladd": "408 FRONT ST",
    "dropdelcty": "ATCO",
    "dropdelst": "NJ",
    "dropdelzpp": "080049998",
    "dropphyadd": "408 FRONT ST",
    "dropphycty": "ATCO",
    "dropphyst": "NJ",
    "dropphyzpp": "080049998",
    "dropmaladd": "408 FRONT ST",
    "dropmalcty": "ATCO",
    "dropmalst": "NJ",
    "dropmalzpp": "080049998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567673029,
    "dropsitcph": 8567673029,
    "dropfax": 8567534784
  },
  {
    "dcode": "D",
    "dropkey": "PV10050",
    "droptype": "D",
    "dropname": "ATLANTIC CITY",
    "dropdeladd": "1801 ATLANTIC AVE STE 101",
    "dropdelcty": "ATLANTIC CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "084019998",
    "dropphyadd": "1801 ATLANTIC AVE STE 101",
    "dropphycty": "ATLANTIC CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "084019998",
    "dropmaladd": "1801 ATLANTIC AVE STE 101",
    "dropmalcty": "ATLANTIC CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "084019998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093482940,
    "dropsitcph": 6093482940,
    "dropfax": 6093450223
  },
  {
    "dcode": "D",
    "dropkey": "PV10053",
    "droptype": "D",
    "dropname": "ATLANTIC HIGHLANDS",
    "dropdeladd": "25 RAILROAD AVE",
    "dropdelcty": "ATLANTIC HIGHLANDS",
    "dropdelst": "NJ",
    "dropdelzpp": "077169998",
    "dropphyadd": "25 RAILROAD AVE",
    "dropphycty": "ATLANTIC HIGHLANDS",
    "dropphyst": "NJ",
    "dropphyzpp": "077169998",
    "dropmaladd": "25 RAILROAD AVE",
    "dropmalcty": "ATLANTIC HIGHLANDS",
    "dropmalst": "NJ",
    "dropmalzpp": "077169998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322910740,
    "dropsitcph": 7322910740,
    "dropfax": 7322913757
  },
  {
    "dcode": "D",
    "dropkey": "PV10060",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "33 US HIGHWAY 206 STE 101",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "NJ",
    "dropdelzpp": "078229998",
    "dropphyadd": "33 US HIGHWAY 206 STE 101",
    "dropphycty": "AUGUSTA",
    "dropphyst": "NJ",
    "dropphyzpp": "078229998",
    "dropmaladd": "33 US HIGHWAY 206 STE 101",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "NJ",
    "dropmalzpp": "078229998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735791081,
    "dropsitcph": 9735791081,
    "dropfax": 6503576551
  },
  {
    "dcode": "D",
    "dropkey": "PV10062",
    "droptype": "D",
    "dropname": "AVALON",
    "dropdeladd": "3219 DUNE DR",
    "dropdelcty": "AVALON",
    "dropdelst": "NJ",
    "dropdelzpp": "082029998",
    "dropphyadd": "3219 DUNE DR",
    "dropphycty": "AVALON",
    "dropphyst": "NJ",
    "dropphyzpp": "082029998",
    "dropmaladd": "3219 DUNE DR",
    "dropmalcty": "AVALON",
    "dropmalst": "NJ",
    "dropmalzpp": "082029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099673240,
    "dropsitcph": 6099673240,
    "dropfax": 8563686742
  },
  {
    "dcode": "D",
    "dropkey": "PV10063",
    "droptype": "D",
    "dropname": "AVENEL",
    "dropdeladd": "1065 RAHWAY AVE",
    "dropdelcty": "AVENEL",
    "dropdelst": "NJ",
    "dropdelzpp": "070019998",
    "dropphyadd": "1065 RAHWAY AVE",
    "dropphycty": "AVENEL",
    "dropphyst": "NJ",
    "dropphyzpp": "070019998",
    "dropmaladd": "1065 RAHWAY AVE",
    "dropmalcty": "AVENEL",
    "dropmalst": "NJ",
    "dropmalzpp": "070019998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7326344703,
    "dropsitcph": 7326344703,
    "dropfax": 6519943269
  },
  {
    "dcode": "D",
    "dropkey": "PV10066",
    "droptype": "D",
    "dropname": "AVON BY THE SEA",
    "dropdeladd": "321 MAIN ST",
    "dropdelcty": "AVON BY THE SEA",
    "dropdelst": "NJ",
    "dropdelzpp": "077179998",
    "dropphyadd": "321 MAIN ST",
    "dropphycty": "AVON BY THE SEA",
    "dropphyst": "NJ",
    "dropphyzpp": "077179998",
    "dropmaladd": "321 MAIN ST",
    "dropmalcty": "AVON BY THE SEA",
    "dropmalst": "NJ",
    "dropmalzpp": "077179998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327752709,
    "dropsitcph": 7327752709,
    "dropfax": 7325020354
  },
  {
    "dcode": "D",
    "dropkey": "PV10069",
    "droptype": "D",
    "dropname": "BAPTISTOWN",
    "dropdeladd": "1031 COUNTY ROAD 519",
    "dropdelcty": "BAPTISTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088039800",
    "dropphyadd": "1031 COUNTY ROAD 519",
    "dropphycty": "BAPTISTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088039800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAPTISTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088039998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9089963152,
    "dropfax": 6505775428
  },
  {
    "dcode": "D",
    "dropkey": "PV10071",
    "droptype": "D",
    "dropname": "BARNEGAT",
    "dropdeladd": "830 W BAY AVE UNIT 1",
    "dropdelcty": "BARNEGAT",
    "dropdelst": "NJ",
    "dropdelzpp": "080059998",
    "dropphyadd": "830 W BAY AVE UNIT 1",
    "dropphycty": "BARNEGAT",
    "dropphyst": "NJ",
    "dropphyzpp": "080059998",
    "dropmaladd": "830 W BAY AVE UNIT 1",
    "dropmalcty": "BARNEGAT",
    "dropmalst": "NJ",
    "dropmalzpp": "080059998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096980158,
    "dropsitcph": 6096605734,
    "dropfax": 6096988921
  },
  {
    "dcode": "D",
    "dropkey": "PV10073",
    "droptype": "D",
    "dropname": "BARNEGAT LIGHT",
    "dropdeladd": "10 W 10TH ST",
    "dropdelcty": "BARNEGAT LIGHT",
    "dropdelst": "NJ",
    "dropdelzpp": "080069998",
    "dropphyadd": "10 W 10TH ST",
    "dropphycty": "BARNEGAT LIGHT",
    "dropphyst": "NJ",
    "dropphyzpp": "080069998",
    "dropmaladd": "10 W 10TH ST",
    "dropmalcty": "BARNEGAT LIGHT",
    "dropmalst": "NJ",
    "dropmalzpp": "080069998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094946493,
    "dropsitcph": 6094946493,
    "dropfax": 6093612836
  },
  {
    "dcode": "D",
    "dropkey": "PV10076",
    "droptype": "D",
    "dropname": "BARRINGTON",
    "dropdeladd": "191 HAINES AVE",
    "dropdelcty": "BARRINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080079998",
    "dropphyadd": "191 HAINES AVE",
    "dropphycty": "BARRINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080079998",
    "dropmaladd": "191 HAINES AVE",
    "dropmalcty": "BARRINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080079998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565465491,
    "dropsitcph": 8565465491,
    "dropfax": 8565477331
  },
  {
    "dcode": "D",
    "dropkey": "PV10079",
    "droptype": "D",
    "dropname": "BASKING RIDGE",
    "dropdeladd": "21 BROWNLEE PL",
    "dropdelcty": "BASKING RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "079209998",
    "dropphyadd": "21 BROWNLEE PL",
    "dropphycty": "BASKING RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "079209998",
    "dropmaladd": "21 BROWNLEE PL",
    "dropmalcty": "BASKING RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "079209998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9087660611,
    "dropsitcph": 9087660611,
    "dropfax": 6519943238
  },
  {
    "dcode": "D",
    "dropkey": "PV10082",
    "droptype": "D",
    "dropname": "BAYONNE",
    "dropdeladd": "570 BROADWAY",
    "dropdelcty": "BAYONNE",
    "dropdelst": "NJ",
    "dropdelzpp": "070029998",
    "dropphyadd": "570 BROADWAY",
    "dropphycty": "BAYONNE",
    "dropphyst": "NJ",
    "dropphyzpp": "070029998",
    "dropmaladd": "570 BROADWAY",
    "dropmalcty": "BAYONNE",
    "dropmalst": "NJ",
    "dropmalzpp": "070029998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013392029,
    "dropsitcph": 2013392029,
    "dropfax": 6505774007
  },
  {
    "dcode": "D",
    "dropkey": "PV10083",
    "droptype": "D",
    "dropname": "BAYVILLE",
    "dropdeladd": "801 ATLANTIC CITY BLVD",
    "dropdelcty": "BAYVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "087219998",
    "dropphyadd": "801 ATLANTIC CITY BLVD",
    "dropphycty": "BAYVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "087219998",
    "dropmaladd": "801 ATLANTIC CITY BLVD",
    "dropmalcty": "BAYVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "087219998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322691030,
    "dropfax": 7322696978
  },
  {
    "dcode": "D",
    "dropkey": "PV10086",
    "droptype": "D",
    "dropname": "BEACH HAVEN",
    "dropdeladd": "510 N BAY AVE UNIT 101",
    "dropdelcty": "BEACH HAVEN",
    "dropdelst": "NJ",
    "dropdelzpp": "080089993",
    "dropphyadd": "510 N BAY AVE UNIT 101",
    "dropphycty": "BEACH HAVEN",
    "dropphyst": "NJ",
    "dropphyzpp": "080089993",
    "dropmaladd": "510 N BAY AVE UNIT 101",
    "dropmalcty": "BEACH HAVEN",
    "dropmalst": "NJ",
    "dropmalzpp": "080089993",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093615370,
    "dropsitcph": 6093615370,
    "dropfax": 8563612782
  },
  {
    "dcode": "D",
    "dropkey": "PV10092",
    "droptype": "D",
    "dropname": "BEACHWOOD",
    "dropdeladd": "74 LOCKER ST",
    "dropdelcty": "BEACHWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "087229998",
    "dropphyadd": "74 LOCKER ST",
    "dropphycty": "BEACHWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "087229998",
    "dropmaladd": "74 LOCKER ST",
    "dropmalcty": "BEACHWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "087229998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323495507,
    "dropfax": 7323492359
  },
  {
    "dcode": "D",
    "dropkey": "PV10094",
    "droptype": "D",
    "dropname": "BEDMINSTER",
    "dropdeladd": "251 SOMERVILLE RD",
    "dropdelcty": "BEDMINSTER",
    "dropdelst": "NJ",
    "dropdelzpp": "079219998",
    "dropphyadd": "251 SOMERVILLE RD",
    "dropphycty": "BEDMINSTER",
    "dropphyst": "NJ",
    "dropphyzpp": "079219998",
    "dropmaladd": "251 SOMERVILLE RD",
    "dropmalcty": "BEDMINSTER",
    "dropmalst": "NJ",
    "dropmalzpp": "079219998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9082340070,
    "dropsitcph": 9082340070,
    "dropfax": 6505774364
  },
  {
    "dcode": "D",
    "dropkey": "PV10097",
    "droptype": "D",
    "dropname": "BELFORD",
    "dropdeladd": "669 STATE ROUTE 36",
    "dropdelcty": "BELFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "077189998",
    "dropphyadd": "669 STATE ROUTE 36",
    "dropphycty": "BELFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "077189998",
    "dropmaladd": "669 STATE ROUTE 36",
    "dropmalcty": "BELFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "077189998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327874490,
    "dropsitcph": 7327874490,
    "dropfax": 7327874499
  },
  {
    "dcode": "D",
    "dropkey": "PV10100",
    "droptype": "D",
    "dropname": "BELLE MEAD",
    "dropdeladd": "2468 US HIGHWAY 206",
    "dropdelcty": "BELLE MEAD",
    "dropdelst": "NJ",
    "dropdelzpp": "085029998",
    "dropphyadd": "2468 US HIGHWAY 206",
    "dropphycty": "BELLE MEAD",
    "dropphyst": "NJ",
    "dropphyzpp": "085029998",
    "dropmaladd": "2468 US HIGHWAY 206",
    "dropmalcty": "BELLE MEAD",
    "dropmalst": "NJ",
    "dropmalzpp": "085029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 9083595311,
    "dropsitcph": 9083595311,
    "dropfax": 9083590037
  },
  {
    "dcode": "D",
    "dropkey": "PV10105",
    "droptype": "D",
    "dropname": "BELMAR",
    "dropdeladd": "1300 MAIN ST",
    "dropdelcty": "BELMAR",
    "dropdelst": "NJ",
    "dropdelzpp": "077199998",
    "dropphyadd": "1300 MAIN ST",
    "dropphycty": "BELMAR",
    "dropphyst": "NJ",
    "dropphyzpp": "077199998",
    "dropmaladd": "1300 MAIN ST",
    "dropmalcty": "BELMAR",
    "dropmalst": "NJ",
    "dropmalzpp": "077199998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7326810961,
    "dropsitcph": 7326810961,
    "dropfax": 7326811053
  },
  {
    "dcode": "D",
    "dropkey": "PV10106",
    "droptype": "D",
    "dropname": "BELVIDERE",
    "dropdeladd": "111 MANSFIELD ST",
    "dropdelcty": "BELVIDERE",
    "dropdelst": "NJ",
    "dropdelzpp": "078239998",
    "dropphyadd": "111 MANSFIELD ST",
    "dropphycty": "BELVIDERE",
    "dropphyst": "NJ",
    "dropphyzpp": "078239998",
    "dropmaladd": "111 MANSFIELD ST",
    "dropmalcty": "BELVIDERE",
    "dropmalst": "NJ",
    "dropmalzpp": "078239998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735157868,
    "dropsitcph": 9084752957,
    "dropfax": 6505774083
  },
  {
    "dcode": "D",
    "dropkey": "PV10111",
    "droptype": "D",
    "dropname": "BERGENFIELD",
    "dropdeladd": "25 VETERANS PLZ",
    "dropdelcty": "BERGENFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "076219998",
    "dropphyadd": "25 VETERANS PLZ",
    "dropphycty": "BERGENFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "076219998",
    "dropmaladd": "25 VETERANS PLZ",
    "dropmalcty": "BERGENFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "076219998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013841831,
    "dropsitcph": 2013841831,
    "dropfax": 6505774190
  },
  {
    "dcode": "D",
    "dropkey": "PV10117",
    "droptype": "D",
    "dropname": "BERKELEY HEIGHTS",
    "dropdeladd": "364 SPRINGFIELD AVE",
    "dropdelcty": "BERKELEY HEIGHTS",
    "dropdelst": "NJ",
    "dropdelzpp": "079229998",
    "dropphyadd": "364 SPRINGFIELD AVE",
    "dropphycty": "BERKELEY HEIGHTS",
    "dropphyst": "NJ",
    "dropphyzpp": "079229998",
    "dropmaladd": "364 SPRINGFIELD AVE",
    "dropmalcty": "BERKELEY HEIGHTS",
    "dropmalst": "NJ",
    "dropmalzpp": "079229998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084641115,
    "dropsitcph": 9084641115,
    "dropfax": 6505774188
  },
  {
    "dcode": "D",
    "dropkey": "PV10122",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "10 HARKER AVE",
    "dropdelcty": "BERLIN",
    "dropdelst": "NJ",
    "dropdelzpp": "080099998",
    "dropphyadd": "10 HARKER AVE",
    "dropphycty": "BERLIN",
    "dropphyst": "NJ",
    "dropphyzpp": "080099998",
    "dropmaladd": "10 HARKER AVE",
    "dropmalcty": "BERLIN",
    "dropmalst": "NJ",
    "dropmalzpp": "080099998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567671287,
    "dropsitcph": 8567671287,
    "dropfax": 8567670074
  },
  {
    "dcode": "D",
    "dropkey": "PV10123",
    "droptype": "D",
    "dropname": "BERNARDSVILLE",
    "dropdeladd": "23 QUIMBY LN",
    "dropdelcty": "BERNARDSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "079249998",
    "dropphyadd": "23 QUIMBY LN",
    "dropphycty": "BERNARDSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "079249998",
    "dropmaladd": "23 QUIMBY LN",
    "dropmalcty": "BERNARDSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "079249998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9087661481,
    "dropsitcph": 9087661481,
    "dropfax": 6516751693
  },
  {
    "dcode": "D",
    "dropkey": "PV10126",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "417 WARREN ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "NJ",
    "dropdelzpp": "080109998",
    "dropphyadd": "417 WARREN ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "NJ",
    "dropphyzpp": "080109998",
    "dropmaladd": "417 WARREN ST",
    "dropmalcty": "BEVERLY",
    "dropmalst": "NJ",
    "dropmalzpp": "080109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093870332,
    "dropsitcph": 6093870332,
    "dropfax": 6093871796
  },
  {
    "dcode": "D",
    "dropkey": "PV10128",
    "droptype": "D",
    "dropname": "BIRMINGHAM",
    "dropdeladd": "221 BIRMINGHAM RD",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "NJ",
    "dropdelzpp": "080119998",
    "dropphyadd": "221 BIRMINGHAM RD",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "NJ",
    "dropphyzpp": "080119998",
    "dropmaladd": "221 BIRMINGHAM RD",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "NJ",
    "dropmalzpp": "080119998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098944691,
    "dropsitcph": 6098944691,
    "dropfax": 6098944691
  },
  {
    "dcode": "D",
    "dropkey": "PV10131",
    "droptype": "D",
    "dropname": "BLACKWOOD",
    "dropdeladd": "200 DAVISTOWN RD",
    "dropdelcty": "BLACKWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "080129998",
    "dropphyadd": "200 DAVISTOWN RD",
    "dropphycty": "BLACKWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "080129998",
    "dropmaladd": "200 DAVISTOWN RD",
    "dropmalcty": "BLACKWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "080129998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562270010,
    "dropsitcph": 8562270010,
    "dropfax": 8562271809
  },
  {
    "dcode": "D",
    "dropkey": "PV10134",
    "droptype": "D",
    "dropname": "BLAIRSTOWN",
    "dropdeladd": "39 MAIN ST",
    "dropdelcty": "BLAIRSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "078259998",
    "dropphyadd": "39 MAIN ST",
    "dropphycty": "BLAIRSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "078259998",
    "dropmaladd": "39 MAIN ST",
    "dropmalcty": "BLAIRSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "078259998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9083626249,
    "dropsitcph": 9083626249,
    "dropfax": 6516751586
  },
  {
    "dcode": "D",
    "dropkey": "PV10135",
    "droptype": "D",
    "dropname": "BLAWENBURG",
    "dropdeladd": "1693 GREAT RD",
    "dropdelcty": "BLAWENBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "085049998",
    "dropphyadd": "1693 GREAT RD",
    "dropphycty": "BLAWENBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "085049998",
    "dropmaladd": "1693 GREAT RD",
    "dropmalcty": "BLAWENBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "085049998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094661782,
    "dropsitcph": 6094661782,
    "dropfax": 6094668387
  },
  {
    "dcode": "D",
    "dropkey": "PV10137",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "13 MUNICIPAL PLZ",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070039998",
    "dropphyadd": "13 MUNICIPAL PLZ",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070039998",
    "dropmaladd": "13 MUNICIPAL PLZ",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070039998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9738739062,
    "dropsitcph": 9738739062,
    "dropfax": 6505774372
  },
  {
    "dcode": "D",
    "dropkey": "PV10138",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "126 MAIN ST",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "074039998",
    "dropphyadd": "126 MAIN ST",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "074039998",
    "dropmaladd": "126 MAIN ST",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "074039998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738382904,
    "dropsitcph": 9738382904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10139",
    "droptype": "D",
    "dropname": "BLOOMSBURY",
    "dropdeladd": "53 CENTER ST",
    "dropdelcty": "BLOOMSBURY",
    "dropdelst": "NJ",
    "dropdelzpp": "088049998",
    "dropphyadd": "53 CENTER ST",
    "dropphycty": "BLOOMSBURY",
    "dropphyst": "NJ",
    "dropphyzpp": "088049998",
    "dropmaladd": "53 CENTER ST",
    "dropmalcty": "BLOOMSBURY",
    "dropmalst": "NJ",
    "dropmalzpp": "088049998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9084794538,
    "dropfax": 6505775429
  },
  {
    "dcode": "D",
    "dropkey": "PV10141",
    "droptype": "D",
    "dropname": "BOONTON",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "BOONTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070059998",
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "BOONTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070059998",
    "dropmaladd": "501 MAIN ST",
    "dropmalcty": "BOONTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070059998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733342745,
    "dropsitcph": 9733342745,
    "dropfax": 6505774094
  },
  {
    "dcode": "D",
    "dropkey": "PV10143",
    "droptype": "D",
    "dropname": "BORDENTOWN",
    "dropdeladd": "14 WALNUT ST",
    "dropdelcty": "BORDENTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "085059998",
    "dropphyadd": "14 WALNUT ST",
    "dropphycty": "BORDENTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "085059998",
    "dropmaladd": "14 WALNUT ST",
    "dropmalcty": "BORDENTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "085059998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092980262,
    "dropsitcph": 6092980262,
    "dropfax": 6092988550
  },
  {
    "dcode": "D",
    "dropkey": "PV10145",
    "droptype": "D",
    "dropname": "BOUND BROOK",
    "dropdeladd": "24 MOUNTAIN AVE",
    "dropdelcty": "BOUND BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "088059998",
    "dropphyadd": "24 MOUNTAIN AVE",
    "dropphycty": "BOUND BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "088059998",
    "dropmaladd": "24 MOUNTAIN AVE",
    "dropmalcty": "BOUND BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "088059998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323565500,
    "dropfax": 6505775430
  },
  {
    "dcode": "D",
    "dropkey": "PV10156",
    "droptype": "D",
    "dropname": "BRADLEY BEACH",
    "dropdeladd": "515 MAIN ST",
    "dropdelcty": "BRADLEY BEACH",
    "dropdelst": "NJ",
    "dropdelzpp": "077209998",
    "dropphyadd": "515 MAIN ST",
    "dropphycty": "BRADLEY BEACH",
    "dropphyst": "NJ",
    "dropphyzpp": "077209998",
    "dropmaladd": "515 MAIN ST",
    "dropmalcty": "BRADLEY BEACH",
    "dropmalst": "NJ",
    "dropmalzpp": "077209998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327757013,
    "dropsitcph": 7327757013,
    "dropfax": 7327758448
  },
  {
    "dcode": "D",
    "dropkey": "PV10163",
    "droptype": "D",
    "dropname": "BRANCHVILLE",
    "dropdeladd": "1 BROAD ST",
    "dropdelcty": "BRANCHVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "078269998",
    "dropphyadd": "1 BROAD ST",
    "dropphycty": "BRANCHVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "078269998",
    "dropmaladd": "1 BROAD ST",
    "dropmalcty": "BRANCHVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "078269998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9739483580,
    "dropsitcph": 9739483580,
    "dropfax": 6516751525
  },
  {
    "dcode": "D",
    "dropkey": "PV10167",
    "droptype": "D",
    "dropname": "BRICK",
    "dropdeladd": "160 CHAMBERS BRIDGE RD",
    "dropdelcty": "BRICK",
    "dropdelst": "NJ",
    "dropdelzpp": "087239998",
    "dropphyadd": "160 CHAMBERS BRIDGE RD",
    "dropphycty": "BRICK",
    "dropphyst": "NJ",
    "dropphyzpp": "087239998",
    "dropmaladd": "160 CHAMBERS BRIDGE RD",
    "dropmalcty": "BRICK",
    "dropmalst": "NJ",
    "dropmalzpp": "087239998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7324770100,
    "dropfax": 7324774118
  },
  {
    "dcode": "D",
    "dropkey": "PV10172",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "134 MAIN ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "080149998",
    "dropphyadd": "134 MAIN ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "080149998",
    "dropmaladd": "134 MAIN ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "080149998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564670533,
    "dropsitcph": 8564670533,
    "dropfax": 8562411464
  },
  {
    "dcode": "D",
    "dropkey": "PV10174",
    "droptype": "D",
    "dropname": "BRIDGETON",
    "dropdeladd": "102 W BROAD ST",
    "dropdelcty": "BRIDGETON",
    "dropdelst": "NJ",
    "dropdelzpp": "083029998",
    "dropphyadd": "102 W BROAD ST",
    "dropphycty": "BRIDGETON",
    "dropphyst": "NJ",
    "dropphyzpp": "083029998",
    "dropmaladd": "102 W BROAD ST",
    "dropmalcty": "BRIDGETON",
    "dropmalst": "NJ",
    "dropmalzpp": "083029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564516100,
    "dropsitcph": 8564516100,
    "dropfax": 8564550329
  },
  {
    "dcode": "D",
    "dropkey": "PV10177",
    "droptype": "D",
    "dropname": "BRIELLE",
    "dropdeladd": "412 HIGGINS AVE",
    "dropdelcty": "BRIELLE",
    "dropdelst": "NJ",
    "dropdelzpp": "087309998",
    "dropphyadd": "412 HIGGINS AVE",
    "dropphycty": "BRIELLE",
    "dropphyst": "NJ",
    "dropphyzpp": "087309998",
    "dropmaladd": "412 HIGGINS AVE",
    "dropmalcty": "BRIELLE",
    "dropmalst": "NJ",
    "dropmalzpp": "087309998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325286112,
    "dropfax": 7325286150
  },
  {
    "dcode": "D",
    "dropkey": "PV10178",
    "droptype": "D",
    "dropname": "BRIGANTINE",
    "dropdeladd": "4326 HARBOR BEACH BLVD",
    "dropdelcty": "BRIGANTINE",
    "dropdelst": "NJ",
    "dropdelzpp": "082039998",
    "dropphyadd": "4326 HARBOR BEACH BLVD",
    "dropphycty": "BRIGANTINE",
    "dropphyst": "NJ",
    "dropphyzpp": "082039998",
    "dropmaladd": "4326 HARBOR BEACH BLVD",
    "dropmalcty": "BRIGANTINE",
    "dropmalst": "NJ",
    "dropmalzpp": "082039998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092663562,
    "dropsitcph": 6092663562,
    "dropfax": 6092662013
  },
  {
    "dcode": "D",
    "dropkey": "PV10180",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "12 ASBURY RD",
    "dropdelcty": "BROADWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "088089800",
    "dropphyadd": "12 ASBURY RD",
    "dropphycty": "BROADWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "088089800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROADWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "088089998",
    "dropsitphn": 7328193630,
    "dropsitlph": 6505775431,
    "dropsitcph": 9086897775,
    "dropfax": 6505775431
  },
  {
    "dcode": "D",
    "dropkey": "PV10184",
    "droptype": "D",
    "dropname": "BROOKSIDE",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "BROOKSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "079269800",
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "BROOKSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "079269800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "079269998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735437878,
    "dropsitcph": 9735437878,
    "dropfax": 6505774204
  },
  {
    "dcode": "D",
    "dropkey": "PV10186",
    "droptype": "D",
    "dropname": "BROWNS MILLS",
    "dropdeladd": "27 DEARBORN AVE",
    "dropdelcty": "BROWNS MILLS",
    "dropdelst": "NJ",
    "dropdelzpp": "080159998",
    "dropphyadd": "27 DEARBORN AVE",
    "dropphycty": "BROWNS MILLS",
    "dropphyst": "NJ",
    "dropphyzpp": "080159998",
    "dropmaladd": "27 DEARBORN AVE",
    "dropmalcty": "BROWNS MILLS",
    "dropmalst": "NJ",
    "dropmalzpp": "080159998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098932497,
    "dropsitcph": 6098932497,
    "dropfax": 6097350980
  },
  {
    "dcode": "D",
    "dropkey": "PV10189",
    "droptype": "D",
    "dropname": "BUDD LAKE",
    "dropdeladd": "1 MOUNT OLIVE RD STE 102",
    "dropdelcty": "BUDD LAKE",
    "dropdelst": "NJ",
    "dropdelzpp": "078289998",
    "dropphyadd": "1 MOUNT OLIVE RD STE 102",
    "dropphycty": "BUDD LAKE",
    "dropphyst": "NJ",
    "dropphyzpp": "078289998",
    "dropmaladd": "1 MOUNT OLIVE RD STE 102",
    "dropmalcty": "BUDD LAKE",
    "dropmalst": "NJ",
    "dropmalzpp": "078289998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736918011,
    "dropsitcph": 9736918011,
    "dropfax": 6505774029
  },
  {
    "dcode": "D",
    "dropkey": "PV10191",
    "droptype": "D",
    "dropname": "BUENA",
    "dropdeladd": "896 HARDING HWY",
    "dropdelcty": "BUENA",
    "dropdelst": "NJ",
    "dropdelzpp": "083109998",
    "dropphyadd": "896 HARDING HWY",
    "dropphycty": "BUENA",
    "dropphyst": "NJ",
    "dropphyzpp": "083109998",
    "dropmaladd": "896 HARDING HWY",
    "dropmalcty": "BUENA",
    "dropmalst": "NJ",
    "dropmalzpp": "083109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566972828,
    "dropsitcph": 8566972828,
    "dropfax": 8566972828
  },
  {
    "dcode": "D",
    "dropkey": "PV10196",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "427 HIGH ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080169998",
    "dropphyadd": "427 HIGH ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080169998",
    "dropmaladd": "427 HIGH ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080169998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093860357,
    "dropsitcph": 6093860357,
    "dropfax": 6093875284
  },
  {
    "dcode": "D",
    "dropkey": "PV10198",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "180 MAIN ST STE A",
    "dropdelcty": "BUTLER",
    "dropdelst": "NJ",
    "dropdelzpp": "074059998",
    "dropphyadd": "180 MAIN ST STE A",
    "dropphycty": "BUTLER",
    "dropphyst": "NJ",
    "dropphyzpp": "074059998",
    "dropmaladd": "180 MAIN ST STE A",
    "dropmalcty": "BUTLER",
    "dropmalst": "NJ",
    "dropmalzpp": "074059998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738398323,
    "dropsitcph": 9738398323,
    "dropfax": 6505774071
  },
  {
    "dcode": "D",
    "dropkey": "PV10203",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "10 PARK AVE",
    "dropdelcty": "CALDWELL",
    "dropdelst": "NJ",
    "dropdelzpp": "070069991",
    "dropphyadd": "10 PARK AVE",
    "dropphycty": "CALDWELL",
    "dropphyst": "NJ",
    "dropphyzpp": "070069991",
    "dropmaladd": "10 PARK AVE",
    "dropmalcty": "CALDWELL",
    "dropmalst": "NJ",
    "dropmalzpp": "070069991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732272699,
    "dropsitcph": 9732272699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10204",
    "droptype": "D",
    "dropname": "CALIFON",
    "dropdeladd": "53 MAIN ST",
    "dropdelcty": "CALIFON",
    "dropdelst": "NJ",
    "dropdelzpp": "078309998",
    "dropphyadd": "53 MAIN ST",
    "dropphycty": "CALIFON",
    "dropphyst": "NJ",
    "dropphyzpp": "078309998",
    "dropmaladd": "53 MAIN ST",
    "dropmalcty": "CALIFON",
    "dropmalst": "NJ",
    "dropmalzpp": "078309998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9088322138,
    "dropsitcph": 9088322138,
    "dropfax": 6503576744
  },
  {
    "dcode": "D",
    "dropkey": "PV10205",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "401 MARKET ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "081029998",
    "dropphyadd": "401 MARKET ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "081029998",
    "dropmaladd": "401 MARKET ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "081029998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569638492,
    "dropsitcph": 8569636597,
    "dropfax": 8567570156
  },
  {
    "dcode": "D",
    "dropkey": "PV10208",
    "droptype": "D",
    "dropname": "CAPE MAY",
    "dropdeladd": "700 WASHINGTON ST",
    "dropdelcty": "CAPE MAY",
    "dropdelst": "NJ",
    "dropdelzpp": "082049998",
    "dropphyadd": "700 WASHINGTON ST",
    "dropphycty": "CAPE MAY",
    "dropphyst": "NJ",
    "dropphyzpp": "082049998",
    "dropmaladd": "700 WASHINGTON ST",
    "dropmalcty": "CAPE MAY",
    "dropmalst": "NJ",
    "dropmalzpp": "082049998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098843578,
    "dropsitcph": 6098843578,
    "dropfax": 6098842313
  },
  {
    "dcode": "D",
    "dropkey": "PV10211",
    "droptype": "D",
    "dropname": "CAPE MAY COURT HOUSE",
    "dropdeladd": "615 ROUTE 9 S",
    "dropdelcty": "CAPE MAY COURT HOUSE",
    "dropdelst": "NJ",
    "dropdelzpp": "082109998",
    "dropphyadd": "615 ROUTE 9 S",
    "dropphycty": "CAPE MAY COURT HOUSE",
    "dropphyst": "NJ",
    "dropphyzpp": "082109998",
    "dropmaladd": "615 ROUTE 9 S",
    "dropmalcty": "CAPE MAY COURT HOUSE",
    "dropmalst": "NJ",
    "dropmalzpp": "082109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094655404,
    "dropsitcph": 6094655404,
    "dropfax": 6094655620
  },
  {
    "dcode": "D",
    "dropkey": "PV10212",
    "droptype": "D",
    "dropname": "CAPE MAY POINT",
    "dropdeladd": "408 YALE AVE",
    "dropdelcty": "CAPE MAY POINT",
    "dropdelst": "NJ",
    "dropdelzpp": "082129998",
    "dropphyadd": "408 YALE AVE",
    "dropphycty": "CAPE MAY POINT",
    "dropphyst": "NJ",
    "dropphyzpp": "082129998",
    "dropmaladd": "408 YALE AVE",
    "dropmalcty": "CAPE MAY POINT",
    "dropmalst": "NJ",
    "dropmalzpp": "082129998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098842754,
    "dropsitcph": 6098842754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10219",
    "droptype": "D",
    "dropname": "CARTERET",
    "dropdeladd": "212 PERSHING AVE",
    "dropdelcty": "CARTERET",
    "dropdelst": "NJ",
    "dropdelzpp": "070089998",
    "dropphyadd": "212 PERSHING AVE",
    "dropphycty": "CARTERET",
    "dropphyst": "NJ",
    "dropphyzpp": "070089998",
    "dropmaladd": "212 PERSHING AVE",
    "dropmalcty": "CARTERET",
    "dropmalst": "NJ",
    "dropmalzpp": "070089998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7325415624,
    "dropsitcph": 7325418397,
    "dropfax": 6505774425
  },
  {
    "dcode": "D",
    "dropkey": "PV10228",
    "droptype": "D",
    "dropname": "CEDAR BROOK",
    "dropdeladd": "24 N ROUTE 73",
    "dropdelcty": "CEDAR BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "080189998",
    "dropphyadd": "24 N ROUTE 73",
    "dropphycty": "CEDAR BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "080189998",
    "dropmaladd": "24 N ROUTE 73",
    "dropmalcty": "CEDAR BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "080189998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095612419,
    "dropsitcph": 6095612419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10229",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "519 POMPTON AVE",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "NJ",
    "dropdelzpp": "070099998",
    "dropphyadd": "519 POMPTON AVE",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "NJ",
    "dropphyzpp": "070099998",
    "dropmaladd": "519 POMPTON AVE",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "NJ",
    "dropmalzpp": "070099998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732397439,
    "dropsitcph": 9732397439,
    "dropfax": 6505774217
  },
  {
    "dcode": "D",
    "dropkey": "PV10230",
    "droptype": "D",
    "dropname": "CEDAR KNOLLS",
    "dropdeladd": "2 MOUNTAIN AVE",
    "dropdelcty": "CEDAR KNOLLS",
    "dropdelst": "NJ",
    "dropdelzpp": "079279998",
    "dropphyadd": "2 MOUNTAIN AVE",
    "dropphycty": "CEDAR KNOLLS",
    "dropphyst": "NJ",
    "dropphyzpp": "079279998",
    "dropmaladd": "2 MOUNTAIN AVE",
    "dropmalcty": "CEDAR KNOLLS",
    "dropmalst": "NJ",
    "dropmalzpp": "079279998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735392312,
    "dropsitcph": 9735392312,
    "dropfax": 6505776045
  },
  {
    "dcode": "D",
    "dropkey": "PV10232",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "343 MAIN ST",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083119998",
    "dropphyadd": "343 MAIN ST",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083119998",
    "dropmaladd": "343 MAIN ST",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083119998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564474379,
    "dropsitcph": 8564474379,
    "dropfax": 8564470486
  },
  {
    "dcode": "D",
    "dropkey": "PV10239",
    "droptype": "D",
    "dropname": "CHANGEWATER",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "CHANGEWATER",
    "dropdelst": "NJ",
    "dropdelzpp": "078319800",
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "CHANGEWATER",
    "dropphyst": "NJ",
    "dropphyzpp": "078319800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANGEWATER",
    "dropmalst": "NJ",
    "dropmalzpp": "078319998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086892520,
    "dropsitcph": 9086892520,
    "dropfax": 6505774041
  },
  {
    "dcode": "D",
    "dropkey": "PV10242",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "19 S PASSAIC AVE",
    "dropdelcty": "CHATHAM",
    "dropdelst": "NJ",
    "dropdelzpp": "079289998",
    "dropphyadd": "19 S PASSAIC AVE",
    "dropphycty": "CHATHAM",
    "dropphyst": "NJ",
    "dropphyzpp": "079289998",
    "dropmaladd": "19 S PASSAIC AVE",
    "dropmalcty": "CHATHAM",
    "dropmalst": "NJ",
    "dropmalzpp": "079289998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736358400,
    "dropsitcph": 9736358400,
    "dropfax": 6513066175
  },
  {
    "dcode": "D",
    "dropkey": "PV10243",
    "droptype": "D",
    "dropname": "CHATSWORTH",
    "dropdeladd": "9 2ND AVE",
    "dropdelcty": "CHATSWORTH",
    "dropdelst": "NJ",
    "dropdelzpp": "080199998",
    "dropphyadd": "9 2ND AVE",
    "dropphycty": "CHATSWORTH",
    "dropphyst": "NJ",
    "dropphyzpp": "080199998",
    "dropmaladd": "9 2ND AVE",
    "dropmalcty": "CHATSWORTH",
    "dropmalst": "NJ",
    "dropmalzpp": "080199998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097261414,
    "dropsitcph": 6097261414,
    "dropfax": 6098942957
  },
  {
    "dcode": "D",
    "dropkey": "PV10247",
    "droptype": "D",
    "dropname": "CHERRY HILL",
    "dropdeladd": "1175 MARLKRESS RD",
    "dropdelcty": "CHERRY HILL",
    "dropdelst": "NJ",
    "dropdelzpp": "080349998",
    "dropphyadd": "1175 MARLKRESS RD",
    "dropphycty": "CHERRY HILL",
    "dropphyst": "NJ",
    "dropphyzpp": "080349998",
    "dropmaladd": "1175 MARLKRESS RD",
    "dropmalcty": "CHERRY HILL",
    "dropmalst": "NJ",
    "dropmalzpp": "080349998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564240093,
    "dropsitcph": 8564240093,
    "dropfax": 8562984852
  },
  {
    "dcode": "D",
    "dropkey": "PV10250",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "1 SENTRY LN",
    "dropdelcty": "CHESTER",
    "dropdelst": "NJ",
    "dropdelzpp": "079309998",
    "dropphyadd": "1 SENTRY LN",
    "dropphycty": "CHESTER",
    "dropphyst": "NJ",
    "dropphyzpp": "079309998",
    "dropmaladd": "1 SENTRY LN",
    "dropmalcty": "CHESTER",
    "dropmalst": "NJ",
    "dropmalzpp": "079309998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9088795095,
    "dropsitcph": 9088795095,
    "dropfax": 6505774398
  },
  {
    "dcode": "D",
    "dropkey": "PV10258",
    "droptype": "D",
    "dropname": "CLARKSBORO",
    "dropdeladd": "175 W COHAWKIN RD STE B",
    "dropdelcty": "CLARKSBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080209998",
    "dropphyadd": "175 W COHAWKIN RD STE B",
    "dropphycty": "CLARKSBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080209998",
    "dropmaladd": "175 W COHAWKIN RD STE B",
    "dropmalcty": "CLARKSBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080209998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564225015,
    "dropsitcph": 8564225015,
    "dropfax": 8562240277
  },
  {
    "dcode": "D",
    "dropkey": "PV10260",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "424 STAGECOACH RD",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "085109998",
    "dropphyadd": "424 STAGECOACH RD",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "085109998",
    "dropmaladd": "424 STAGECOACH RD",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "085109998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092596384,
    "dropsitcph": 6092596384,
    "dropfax": 6092591846
  },
  {
    "dcode": "D",
    "dropkey": "PV10261",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "732 N DELSEA DR",
    "dropdelcty": "CLAYTON",
    "dropdelst": "NJ",
    "dropdelzpp": "083129998",
    "dropphyadd": "732 N DELSEA DR",
    "dropphycty": "CLAYTON",
    "dropphyst": "NJ",
    "dropphyzpp": "083129998",
    "dropmaladd": "732 N DELSEA DR",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NJ",
    "dropmalzpp": "083129998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568813150,
    "dropsitcph": 8568813150,
    "dropfax": 8568810951
  },
  {
    "dcode": "D",
    "dropkey": "PV10262",
    "droptype": "D",
    "dropname": "CLEMENTON",
    "dropdeladd": "22 BERLIN RD",
    "dropdelcty": "CLEMENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080219998",
    "dropphyadd": "22 BERLIN RD",
    "dropphycty": "CLEMENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080219998",
    "dropmaladd": "22 BERLIN RD",
    "dropmalcty": "CLEMENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080219998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567834868,
    "dropsitcph": 8564353728,
    "dropfax": 8564356094
  },
  {
    "dcode": "D",
    "dropkey": "PV10266",
    "droptype": "D",
    "dropname": "CLIFFSIDE PARK",
    "dropdeladd": "289 GORGE RD",
    "dropdelcty": "CLIFFSIDE PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "070109998",
    "dropphyadd": "289 GORGE RD",
    "dropphycty": "CLIFFSIDE PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "070109998",
    "dropmaladd": "289 GORGE RD",
    "dropmalcty": "CLIFFSIDE PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "070109998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019435271,
    "dropsitcph": 2019435271,
    "dropfax": 6505774378
  },
  {
    "dcode": "D",
    "dropkey": "PV10268",
    "droptype": "D",
    "dropname": "CLIFFWOOD",
    "dropdeladd": "349 STATE ROUTE 35",
    "dropdelcty": "CLIFFWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "077219998",
    "dropphyadd": "349 STATE ROUTE 35",
    "dropphycty": "CLIFFWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "077219998",
    "dropmaladd": "349 STATE ROUTE 35",
    "dropmalcty": "CLIFFWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "077219998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325663166,
    "dropsitcph": 7325663166,
    "dropfax": 7325667195
  },
  {
    "dcode": "D",
    "dropkey": "PV10273",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "811 PAULISON AVE",
    "dropdelcty": "CLIFTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070119998",
    "dropphyadd": "811 PAULISON AVE",
    "dropphycty": "CLIFTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070119998",
    "dropmaladd": "811 PAULISON AVE",
    "dropmalcty": "CLIFTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070119998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734720426,
    "dropsitcph": 9734720426,
    "dropfax": 6505774218
  },
  {
    "dcode": "D",
    "dropkey": "PV10274",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "24 E MAIN ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088099998",
    "dropphyadd": "24 E MAIN ST",
    "dropphycty": "CLINTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088099998",
    "dropmaladd": "24 E MAIN ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088099998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087357216,
    "dropfax": 6505775432
  },
  {
    "dcode": "D",
    "dropkey": "PV10279",
    "droptype": "D",
    "dropname": "CLOSTER",
    "dropdeladd": "185 HOMANS AVE",
    "dropdelcty": "CLOSTER",
    "dropdelst": "NJ",
    "dropdelzpp": "076249998",
    "dropphyadd": "185 HOMANS AVE",
    "dropphycty": "CLOSTER",
    "dropphyst": "NJ",
    "dropphyzpp": "076249998",
    "dropmaladd": "185 HOMANS AVE",
    "dropmalcty": "CLOSTER",
    "dropmalst": "NJ",
    "dropmalzpp": "076249998",
    "dropsitphn": 2017502700,
    "dropsitlph": 2017680461,
    "dropsitcph": 2017680461,
    "dropfax": 6505774427
  },
  {
    "dcode": "D",
    "dropkey": "PV10288",
    "droptype": "D",
    "dropname": "COLOGNE",
    "dropdeladd": "807 W WHITE HORSE PIKE",
    "dropdelcty": "COLOGNE",
    "dropdelst": "NJ",
    "dropdelzpp": "082139998",
    "dropphyadd": "807 W WHITE HORSE PIKE",
    "dropphycty": "COLOGNE",
    "dropphyst": "NJ",
    "dropphyzpp": "082139998",
    "dropmaladd": "807 W WHITE HORSE PIKE",
    "dropmalcty": "COLOGNE",
    "dropmalst": "NJ",
    "dropmalzpp": "082139998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099654640,
    "dropsitcph": 6099654640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10291",
    "droptype": "D",
    "dropname": "COLTS NECK",
    "dropdeladd": "420 STATE ROUTE 34 STE 307",
    "dropdelcty": "COLTS NECK",
    "dropdelst": "NJ",
    "dropdelzpp": "077229998",
    "dropphyadd": "420 STATE ROUTE 34 STE 307",
    "dropphycty": "COLTS NECK",
    "dropphyst": "NJ",
    "dropphyzpp": "077229998",
    "dropmaladd": "420 STATE ROUTE 34 STE 307",
    "dropmalcty": "COLTS NECK",
    "dropmalst": "NJ",
    "dropmalzpp": "077229998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324623935,
    "dropsitcph": 7324623935,
    "dropfax": 7324621181
  },
  {
    "dcode": "D",
    "dropkey": "PV10292",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "27 DECATUR ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "NJ",
    "dropdelzpp": "078329998",
    "dropphyadd": "27 DECATUR ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "NJ",
    "dropphyzpp": "078329998",
    "dropmaladd": "27 DECATUR ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "NJ",
    "dropmalzpp": "078329998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084907002,
    "dropsitcph": 9084907002,
    "dropfax": 6505774084
  },
  {
    "dcode": "D",
    "dropkey": "PV10293",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "231 ATLANTIC AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "NJ",
    "dropdelzpp": "080229998",
    "dropphyadd": "231 ATLANTIC AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "NJ",
    "dropphyzpp": "080229998",
    "dropmaladd": "231 ATLANTIC AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "NJ",
    "dropmalzpp": "080229998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092981141,
    "dropsitcph": 6092981141,
    "dropfax": 6093241461
  },
  {
    "dcode": "D",
    "dropkey": "PV10295",
    "droptype": "D",
    "dropname": "COOKSTOWN",
    "dropdeladd": "7 WRIGHTSTOWN COOKSTOWN RD",
    "dropdelcty": "COOKSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "085119998",
    "dropphyadd": "7 WRIGHTSTOWN COOKSTOWN RD",
    "dropphycty": "COOKSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "085119998",
    "dropmaladd": "7 WRIGHTSTOWN COOKSTOWN RD",
    "dropmalcty": "COOKSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "085119998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097235713,
    "dropsitcph": 6097235713,
    "dropfax": 6097233236
  },
  {
    "dcode": "D",
    "dropkey": "PV10301",
    "droptype": "D",
    "dropname": "CRANBURY",
    "dropdeladd": "65 N MAIN ST",
    "dropdelcty": "CRANBURY",
    "dropdelst": "NJ",
    "dropdelzpp": "085129998",
    "dropphyadd": "65 N MAIN ST",
    "dropphycty": "CRANBURY",
    "dropphyst": "NJ",
    "dropphyzpp": "085129998",
    "dropmaladd": "65 N MAIN ST",
    "dropmalcty": "CRANBURY",
    "dropmalst": "NJ",
    "dropmalzpp": "085129998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093950748,
    "dropsitcph": 6093950748,
    "dropfax": 6093951772
  },
  {
    "dcode": "D",
    "dropkey": "PV10302",
    "droptype": "D",
    "dropname": "CRANFORD",
    "dropdeladd": "3 MILN ST",
    "dropdelcty": "CRANFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "070169998",
    "dropphyadd": "3 MILN ST",
    "dropphycty": "CRANFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "070169998",
    "dropmaladd": "3 MILN ST",
    "dropmalcty": "CRANFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "070169998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082763506,
    "dropsitcph": 9082763506,
    "dropfax": 6505774100
  },
  {
    "dcode": "D",
    "dropkey": "PV10303",
    "droptype": "D",
    "dropname": "CREAM RIDGE",
    "dropdeladd": "163 BURLINGTON PATH RD STE D",
    "dropdelcty": "CREAM RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "085149998",
    "dropphyadd": "163 BURLINGTON PATH RD STE D",
    "dropphycty": "CREAM RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "085149998",
    "dropmaladd": "163 BURLINGTON PATH RD STE D",
    "dropmalcty": "CREAM RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "085149998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097571685,
    "dropsitcph": 6097571685,
    "dropfax": 6097581793
  },
  {
    "dcode": "D",
    "dropkey": "PV10304",
    "droptype": "D",
    "dropname": "CRESSKILL",
    "dropdeladd": "20 WASHINGTON ST STE 2",
    "dropdelcty": "CRESSKILL",
    "dropdelst": "NJ",
    "dropdelzpp": "076269998",
    "dropphyadd": "20 WASHINGTON ST STE 2",
    "dropphycty": "CRESSKILL",
    "dropphyst": "NJ",
    "dropphyzpp": "076269998",
    "dropmaladd": "20 WASHINGTON ST STE 2",
    "dropmalcty": "CRESSKILL",
    "dropmalst": "NJ",
    "dropmalzpp": "076269998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015693843,
    "dropsitcph": 2015693843,
    "dropfax": 6505774123
  },
  {
    "dcode": "D",
    "dropkey": "PV10306",
    "droptype": "D",
    "dropname": "CROSSWICKS",
    "dropdeladd": "3 NEW ST",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "085159998",
    "dropphyadd": "3 NEW ST",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "085159998",
    "dropmaladd": "3 NEW ST",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "085159998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092986407,
    "dropsitcph": 6092986407,
    "dropfax": 6094969133
  },
  {
    "dcode": "D",
    "dropkey": "PV10314",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "347 GEORGES RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088109998",
    "dropphyadd": "347 GEORGES RD",
    "dropphycty": "DAYTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088109998",
    "dropmaladd": "347 GEORGES RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088109998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323296296,
    "dropfax": 6505775433
  },
  {
    "dcode": "D",
    "dropkey": "PV10315",
    "droptype": "D",
    "dropname": "DEAL",
    "dropdeladd": "92 NORWOOD AVE",
    "dropdelcty": "DEAL",
    "dropdelst": "NJ",
    "dropdelzpp": "077239998",
    "dropphyadd": "92 NORWOOD AVE",
    "dropphycty": "DEAL",
    "dropphyst": "NJ",
    "dropphyzpp": "077239998",
    "dropmaladd": "92 NORWOOD AVE",
    "dropmalcty": "DEAL",
    "dropmalst": "NJ",
    "dropmalzpp": "077239998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325310610,
    "dropsitcph": 7325310610,
    "dropfax": 7325312101
  },
  {
    "dcode": "D",
    "dropkey": "PV10318",
    "droptype": "D",
    "dropname": "DEEPWATER",
    "dropdeladd": "582 N BROADWAY",
    "dropdelcty": "DEEPWATER",
    "dropdelst": "NJ",
    "dropdelzpp": "080239998",
    "dropphyadd": "582 N BROADWAY",
    "dropphycty": "DEEPWATER",
    "dropphyst": "NJ",
    "dropphyzpp": "080239998",
    "dropmaladd": "582 N BROADWAY",
    "dropmalcty": "DEEPWATER",
    "dropmalst": "NJ",
    "dropmalzpp": "080239998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562994252,
    "dropsitcph": 8562994252,
    "dropfax": 8562990158
  },
  {
    "dcode": "D",
    "dropkey": "PV10320",
    "droptype": "D",
    "dropname": "DEERFIELD STREET",
    "dropdeladd": "1542 ROUTE 77",
    "dropdelcty": "DEERFIELD STREET",
    "dropdelst": "NJ",
    "dropdelzpp": "083139998",
    "dropphyadd": "1542 ROUTE 77",
    "dropphycty": "DEERFIELD STREET",
    "dropphyst": "NJ",
    "dropphyzpp": "083139998",
    "dropmaladd": "1542 ROUTE 77",
    "dropmalcty": "DEERFIELD STREET",
    "dropmalst": "NJ",
    "dropmalzpp": "083139998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564553106,
    "dropsitcph": 8564553106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10326",
    "droptype": "D",
    "dropname": "DELAWARE",
    "dropdeladd": "9 CLINTON ST",
    "dropdelcty": "DELAWARE",
    "dropdelst": "NJ",
    "dropdelzpp": "078339800",
    "dropphyadd": "9 CLINTON ST",
    "dropphycty": "DELAWARE",
    "dropphyst": "NJ",
    "dropphyzpp": "078339800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELAWARE",
    "dropmalst": "NJ",
    "dropmalzpp": "078339998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084752490,
    "dropsitcph": 9084752490,
    "dropfax": 6505774085
  },
  {
    "dcode": "D",
    "dropkey": "PV10328",
    "droptype": "D",
    "dropname": "DELMONT",
    "dropdeladd": "4507 ROUTE 47",
    "dropdelcty": "DELMONT",
    "dropdelst": "NJ",
    "dropdelzpp": "083149998",
    "dropphyadd": "4507 ROUTE 47",
    "dropphycty": "DELMONT",
    "dropphyst": "NJ",
    "dropphyzpp": "083149998",
    "dropmaladd": "4507 ROUTE 47",
    "dropmalcty": "DELMONT",
    "dropmalst": "NJ",
    "dropmalzpp": "083149998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567852055,
    "dropsitcph": 8567852055,
    "dropfax": 8567852055
  },
  {
    "dcode": "D",
    "dropkey": "PV10331",
    "droptype": "D",
    "dropname": "DEMAREST",
    "dropdeladd": "126 HARDENBURGH AVE",
    "dropdelcty": "DEMAREST",
    "dropdelst": "NJ",
    "dropdelzpp": "076279998",
    "dropphyadd": "126 HARDENBURGH AVE",
    "dropphycty": "DEMAREST",
    "dropphyst": "NJ",
    "dropphyzpp": "076279998",
    "dropmaladd": "126 HARDENBURGH AVE",
    "dropmalcty": "DEMAREST",
    "dropmalst": "NJ",
    "dropmalzpp": "076279998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017688227,
    "dropsitcph": 2017688227,
    "dropfax": 6505774133
  },
  {
    "dcode": "D",
    "dropkey": "PV10332",
    "droptype": "D",
    "dropname": "DENNISVILLE",
    "dropdeladd": "24 HALL AVE",
    "dropdelcty": "DENNISVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "082149998",
    "dropphyadd": "24 HALL AVE",
    "dropphycty": "DENNISVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "082149998",
    "dropmaladd": "24 HALL AVE",
    "dropmalcty": "DENNISVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "082149998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098611114,
    "dropsitcph": 6098611114,
    "dropfax": 6098612321
  },
  {
    "dcode": "D",
    "dropkey": "PV10334",
    "droptype": "D",
    "dropname": "DENVILLE",
    "dropdeladd": "18 CHURCH ST",
    "dropdelcty": "DENVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "078349998",
    "dropphyadd": "18 CHURCH ST",
    "dropphycty": "DENVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "078349998",
    "dropmaladd": "18 CHURCH ST",
    "dropmalcty": "DENVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "078349998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736251700,
    "dropsitcph": 9736251700,
    "dropfax": 6505774317
  },
  {
    "dcode": "D",
    "dropkey": "PV10338",
    "droptype": "D",
    "dropname": "DIVIDING CREEK",
    "dropdeladd": "918 UNION ST",
    "dropdelcty": "DIVIDING CREEK",
    "dropdelst": "NJ",
    "dropdelzpp": "083159998",
    "dropphyadd": "918 UNION ST",
    "dropphycty": "DIVIDING CREEK",
    "dropphyst": "NJ",
    "dropphyzpp": "083159998",
    "dropmaladd": "918 UNION ST",
    "dropmalcty": "DIVIDING CREEK",
    "dropmalst": "NJ",
    "dropmalzpp": "083159998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567852215,
    "dropsitcph": 8567852215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10344",
    "droptype": "D",
    "dropname": "DOMINICK V DANIELS",
    "dropdeladd": "850 NEWARK TPKE",
    "dropdelcty": "KEARNY",
    "dropdelst": "NJ",
    "dropdelzpp": "070999400",
    "dropphyadd": "850 NEWARK TPKE",
    "dropphycty": "KEARNY",
    "dropphyst": "NJ",
    "dropphyzpp": "070999998",
    "dropmaladd": "850 NEWARK TPKE",
    "dropmalcty": "KEARNY",
    "dropmalst": "NJ",
    "dropmalzpp": "070999400",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019959660,
    "dropsitcph": 2019959630,
    "dropfax": 2019911344
  },
  {
    "dcode": "D",
    "dropkey": "PV10345",
    "droptype": "D",
    "dropname": "DORCHESTER",
    "dropdeladd": "239 CARLISLE PLACE RD",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "NJ",
    "dropdelzpp": "083169998",
    "dropphyadd": "239 CARLISLE PLACE RD",
    "dropphycty": "DORCHESTER",
    "dropphyst": "NJ",
    "dropphyzpp": "083169998",
    "dropmaladd": "239 CARLISLE PLACE RD",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "NJ",
    "dropmalzpp": "083169998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567852080,
    "dropsitcph": 8567852080,
    "dropfax": 8567852080
  },
  {
    "dcode": "D",
    "dropkey": "PV10346",
    "droptype": "D",
    "dropname": "DOROTHY",
    "dropdeladd": "42 TUCKAHOE RD UNIT 1",
    "dropdelcty": "DOROTHY",
    "dropdelst": "NJ",
    "dropdelzpp": "083179998",
    "dropphyadd": "42 TUCKAHOE RD UNIT 1",
    "dropphycty": "DOROTHY",
    "dropphyst": "NJ",
    "dropphyzpp": "083179998",
    "dropmaladd": "42 TUCKAHOE RD UNIT 1",
    "dropmalcty": "DOROTHY",
    "dropmalst": "NJ",
    "dropmalzpp": "083179998",
    "dropsitphn": 6099334047,
    "dropsitlph": 6094762200,
    "dropsitcph": 6094762200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10347",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "22 N SUSSEX ST",
    "dropdelcty": "DOVER",
    "dropdelst": "NJ",
    "dropdelzpp": "078019998",
    "dropphyadd": "22 N SUSSEX ST",
    "dropphycty": "DOVER",
    "dropphyst": "NJ",
    "dropphyzpp": "078019998",
    "dropmaladd": "22 N SUSSEX ST",
    "dropmalcty": "DOVER",
    "dropmalst": "NJ",
    "dropmalzpp": "078019998",
    "dropsitphn": 9735157868,
    "dropsitlph": 8623975992,
    "dropsitcph": 8623975992,
    "dropfax": 9733668261
  },
  {
    "dcode": "D",
    "dropkey": "PV10354",
    "droptype": "D",
    "dropname": "DUMONT",
    "dropdeladd": "138 VETERANS PLZ",
    "dropdelcty": "DUMONT",
    "dropdelst": "NJ",
    "dropdelzpp": "076289998",
    "dropphyadd": "138 VETERANS PLZ",
    "dropphycty": "DUMONT",
    "dropphyst": "NJ",
    "dropphyzpp": "076289998",
    "dropmaladd": "138 VETERANS PLZ",
    "dropmalcty": "DUMONT",
    "dropmalst": "NJ",
    "dropmalzpp": "076289998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013846738,
    "dropsitcph": 2013846738,
    "dropfax": 6505774217
  },
  {
    "dcode": "D",
    "dropkey": "PV10357",
    "droptype": "D",
    "dropname": "DUNELLEN",
    "dropdeladd": "311 NORTH AVE",
    "dropdelcty": "DUNELLEN",
    "dropdelst": "NJ",
    "dropdelzpp": "088129998",
    "dropphyadd": "311 NORTH AVE",
    "dropphycty": "DUNELLEN",
    "dropphyst": "NJ",
    "dropphyzpp": "088129998",
    "dropmaladd": "311 NORTH AVE",
    "dropmalcty": "DUNELLEN",
    "dropmalst": "NJ",
    "dropmalzpp": "088129998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329682070,
    "dropfax": 6505775434
  },
  {
    "dcode": "D",
    "dropkey": "PV10374",
    "droptype": "D",
    "dropname": "EAST BRUNSWICK",
    "dropdeladd": "614 CRANBURY RD",
    "dropdelcty": "EAST BRUNSWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "088169998",
    "dropphyadd": "614 CRANBURY RD",
    "dropphycty": "EAST BRUNSWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "088169998",
    "dropmaladd": "614 CRANBURY RD",
    "dropmalcty": "EAST BRUNSWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "088169998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322576270,
    "dropfax": 6503576324
  },
  {
    "dcode": "D",
    "dropkey": "PV10379",
    "droptype": "D",
    "dropname": "EAST HANOVER",
    "dropdeladd": "315 RIDGEDALE AVE",
    "dropdelcty": "EAST HANOVER",
    "dropdelst": "NJ",
    "dropdelzpp": "079369998",
    "dropphyadd": "315 RIDGEDALE AVE",
    "dropphycty": "EAST HANOVER",
    "dropphyst": "NJ",
    "dropphyzpp": "079369998",
    "dropmaladd": "315 RIDGEDALE AVE",
    "dropmalcty": "EAST HANOVER",
    "dropmalst": "NJ",
    "dropmalzpp": "079369998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9738870065,
    "dropsitcph": 9738870065,
    "dropfax": 6516751523
  },
  {
    "dcode": "D",
    "dropkey": "PV10385",
    "droptype": "D",
    "dropname": "EAST ORANGE",
    "dropdeladd": "26 CITY HALL PLZ",
    "dropdelcty": "EAST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070189997",
    "dropphyadd": "26 CITY HALL PLZ",
    "dropphycty": "EAST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070189997",
    "dropmaladd": "26 CITY HALL PLZ",
    "dropmalcty": "EAST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070189997",
    "dropsitphn": 9739559705,
    "dropsitlph": 9736935556,
    "dropsitcph": 9736735556,
    "dropfax": 2024064658
  },
  {
    "dcode": "D",
    "dropkey": "PV10394",
    "droptype": "D",
    "dropname": "EATONTOWN",
    "dropdeladd": "409 SOUTH ST",
    "dropdelcty": "EATONTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "077249998",
    "dropphyadd": "409 SOUTH ST",
    "dropphycty": "EATONTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "077249998",
    "dropmaladd": "409 SOUTH ST",
    "dropmalcty": "EATONTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "077249998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7323897121,
    "dropsitcph": 7325420108,
    "dropfax": 7323892391
  },
  {
    "dcode": "D",
    "dropkey": "PV10398",
    "droptype": "D",
    "dropname": "EDGEWATER",
    "dropdeladd": "770 RIVER RD",
    "dropdelcty": "EDGEWATER",
    "dropdelst": "NJ",
    "dropdelzpp": "070209998",
    "dropphyadd": "770 RIVER RD",
    "dropphycty": "EDGEWATER",
    "dropphyst": "NJ",
    "dropphyzpp": "070209998",
    "dropmaladd": "770 RIVER RD",
    "dropmalcty": "EDGEWATER",
    "dropmalst": "NJ",
    "dropmalzpp": "070209998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2079454297,
    "dropsitcph": 2019454297,
    "dropfax": 6505774432
  },
  {
    "dcode": "D",
    "dropkey": "PV10401",
    "droptype": "D",
    "dropname": "EDISON",
    "dropdeladd": "2101 STATE ROUTE 27",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088179998",
    "dropphyadd": "2101 STATE ROUTE 27",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088179998",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088189998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322874311,
    "dropfax": 6503576404
  },
  {
    "dcode": "D",
    "dropkey": "PV10405",
    "droptype": "D",
    "dropname": "EGG HARBOR CITY",
    "dropdeladd": "237 PHILADELPHIA AVE",
    "dropdelcty": "EGG HARBOR CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "082159998",
    "dropphyadd": "237 PHILADELPHIA AVE",
    "dropphycty": "EGG HARBOR CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "082159998",
    "dropmaladd": "237 PHILADELPHIA AVE",
    "dropmalcty": "EGG HARBOR CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "082159998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099650240,
    "dropsitcph": 6099650240,
    "dropfax": 6099656587
  },
  {
    "dcode": "D",
    "dropkey": "PV10411",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "310 N BROAD ST",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "072089998",
    "dropphyadd": "310 N BROAD ST",
    "dropphycty": "ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "072089998",
    "dropmaladd": "310 N BROAD ST",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "072089998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935187,
    "dropsitcph": 9088208490,
    "dropfax": 6516751695
  },
  {
    "dcode": "D",
    "dropkey": "PV10417",
    "droptype": "D",
    "dropname": "ELMER",
    "dropdeladd": "625 N MAIN ST",
    "dropdelcty": "ELMER",
    "dropdelst": "NJ",
    "dropdelzpp": "083189998",
    "dropphyadd": "625 N MAIN ST",
    "dropphycty": "ELMER",
    "dropphyst": "NJ",
    "dropphyzpp": "083189998",
    "dropmaladd": "625 N MAIN ST",
    "dropmalcty": "ELMER",
    "dropmalst": "NJ",
    "dropmalzpp": "083189998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8563583922,
    "dropsitcph": 8563583922,
    "dropfax": 8563588953
  },
  {
    "dcode": "D",
    "dropkey": "PV10420",
    "droptype": "D",
    "dropname": "ELMWOOD PARK",
    "dropdeladd": "335 MOLA BLVD",
    "dropdelcty": "ELMWOOD PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "074079998",
    "dropphyadd": "335 MOLA BLVD",
    "dropphycty": "ELMWOOD PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "074079998",
    "dropmaladd": "335 MOLA BLVD",
    "dropmalcty": "ELMWOOD PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "074079998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017967057,
    "dropsitcph": 2017967057,
    "dropfax": 6505774347
  },
  {
    "dcode": "D",
    "dropkey": "PV10422",
    "droptype": "D",
    "dropname": "ELWOOD",
    "dropdeladd": "4401 WHITE HORSE PIKE",
    "dropdelcty": "ELWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "082179998",
    "dropphyadd": "4401 WHITE HORSE PIKE",
    "dropphycty": "ELWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "082179998",
    "dropmaladd": "4401 WHITE HORSE PIKE",
    "dropmalcty": "ELWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "082179998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095619287,
    "dropsitcph": 6095619287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10423",
    "droptype": "D",
    "dropname": "EMERSON",
    "dropdeladd": "381 KINDERKAMACK RD STE A",
    "dropdelcty": "EMERSON",
    "dropdelst": "NJ",
    "dropdelzpp": "076301119",
    "dropphyadd": "381 KINDERKAMACK RD STE A",
    "dropphycty": "EMERSON",
    "dropphyst": "NJ",
    "dropphyzpp": "076301119",
    "dropmaladd": "381 KINDERKAMACK RD STE A",
    "dropmalcty": "EMERSON",
    "dropmalst": "NJ",
    "dropmalzpp": "076301119",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012620732,
    "dropsitcph": 2012620732,
    "dropfax": 6505774203
  },
  {
    "dcode": "D",
    "dropkey": "PV10424",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "77 ENGLE ST",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "076319998",
    "dropphyadd": "77 ENGLE ST",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "076319998",
    "dropmaladd": "77 ENGLE ST",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076319998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015680086,
    "dropsitcph": 2015680086,
    "dropfax": 2015686366
  },
  {
    "dcode": "D",
    "dropkey": "PV10429",
    "droptype": "D",
    "dropname": "ENGLISHTOWN",
    "dropdeladd": "9 TAYLORS MILLS RD",
    "dropdelcty": "MANALAPAN",
    "dropdelst": "NJ",
    "dropdelzpp": "077269998",
    "dropphyadd": "9 TAYLORS MILLS RD",
    "dropphycty": "MANALAPAN",
    "dropphyst": "NJ",
    "dropphyzpp": "077269998",
    "dropmaladd": "9 TAYLORS MILLS RD",
    "dropmalcty": "MANALAPAN",
    "dropmalst": "NJ",
    "dropmalzpp": "077269998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324467621,
    "dropsitcph": 7324467621,
    "dropfax": 7324464582
  },
  {
    "dcode": "D",
    "dropkey": "PV10440",
    "droptype": "D",
    "dropname": "ESSEX FELLS",
    "dropdeladd": "297 RUNNYMEDE RD",
    "dropdelcty": "ESSEX FELLS",
    "dropdelst": "NJ",
    "dropdelzpp": "070219998",
    "dropphyadd": "297 RUNNYMEDE RD",
    "dropphycty": "ESSEX FELLS",
    "dropphyst": "NJ",
    "dropphyzpp": "070219998",
    "dropmaladd": "297 RUNNYMEDE RD",
    "dropmalcty": "ESSEX FELLS",
    "dropmalst": "NJ",
    "dropmalzpp": "070219998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732267204,
    "dropsitcph": 9732267204,
    "dropfax": 6505774380
  },
  {
    "dcode": "D",
    "dropkey": "PV10441",
    "droptype": "D",
    "dropname": "ESTELL MANOR",
    "dropdeladd": "156 TUCKAHOE RD",
    "dropdelcty": "ESTELL MANOR",
    "dropdelst": "NJ",
    "dropdelzpp": "083199998",
    "dropphyadd": "156 TUCKAHOE RD",
    "dropphycty": "ESTELL MANOR",
    "dropphyst": "NJ",
    "dropphyzpp": "083199998",
    "dropmaladd": "156 TUCKAHOE RD",
    "dropmalcty": "ESTELL MANOR",
    "dropmalst": "NJ",
    "dropmalzpp": "083199998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094762765,
    "dropsitcph": 6094762765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10445",
    "droptype": "D",
    "dropname": "EWAN",
    "dropdeladd": "310 EWAN RD",
    "dropdelcty": "EWAN",
    "dropdelst": "NJ",
    "dropdelzpp": "080259998",
    "dropphyadd": "310 EWAN RD",
    "dropphycty": "EWAN",
    "dropphyst": "NJ",
    "dropphyzpp": "080259998",
    "dropmaladd": "310 EWAN RD",
    "dropmalcty": "EWAN",
    "dropmalst": "NJ",
    "dropmalzpp": "080259998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564782226,
    "dropsitcph": 8564782226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10451",
    "droptype": "D",
    "dropname": "FAIR LAWN",
    "dropdeladd": "14-24 ABBOTT RD",
    "dropdelcty": "FAIR LAWN",
    "dropdelst": "NJ",
    "dropdelzpp": "074109998",
    "dropphyadd": "14-24 ABBOTT RD",
    "dropphycty": "FAIR LAWN",
    "dropphyst": "NJ",
    "dropphyzpp": "074109998",
    "dropmaladd": "14-24 ABBOTT RD",
    "dropmalcty": "FAIR LAWN",
    "dropmalst": "NJ",
    "dropmalzpp": "074109998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017960873,
    "dropsitcph": 2017960873,
    "dropfax": 6505774192
  },
  {
    "dcode": "D",
    "dropkey": "PV10457",
    "droptype": "D",
    "dropname": "FAIRTON",
    "dropdeladd": "56 BRIDGETON FAIRTON RD",
    "dropdelcty": "FAIRTON",
    "dropdelst": "NJ",
    "dropdelzpp": "083209998",
    "dropphyadd": "56 BRIDGETON FAIRTON RD",
    "dropphycty": "FAIRTON",
    "dropphyst": "NJ",
    "dropphyzpp": "083209998",
    "dropmaladd": "56 BRIDGETON FAIRTON RD",
    "dropmalcty": "FAIRTON",
    "dropmalst": "NJ",
    "dropmalzpp": "083209998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564515229,
    "dropsitcph": 8564515229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10459",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "6 ANDERSON AVE",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "NJ",
    "dropdelzpp": "070229998",
    "dropphyadd": "6 ANDERSON AVE",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "NJ",
    "dropphyzpp": "070229998",
    "dropmaladd": "6 ANDERSON AVE",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "NJ",
    "dropmalzpp": "070229998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019435738,
    "dropsitcph": 2019435738,
    "dropfax": 6505774421
  },
  {
    "dcode": "D",
    "dropkey": "PV10461",
    "droptype": "D",
    "dropname": "FANWOOD",
    "dropdeladd": "275 SOUTH AVE",
    "dropdelcty": "FANWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "070239998",
    "dropphyadd": "275 SOUTH AVE",
    "dropphycty": "FANWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "070239998",
    "dropmaladd": "275 SOUTH AVE",
    "dropmalcty": "FANWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "070239998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9083227978,
    "dropsitcph": 9083227978,
    "dropfax": 6505776217
  },
  {
    "dcode": "D",
    "dropkey": "PV10462",
    "droptype": "D",
    "dropname": "FAR HILLS",
    "dropdeladd": "35 US HIGHWAY 202",
    "dropdelcty": "FAR HILLS",
    "dropdelst": "NJ",
    "dropdelzpp": "079312444",
    "dropphyadd": "35 US HIGHWAY 202",
    "dropphycty": "FAR HILLS",
    "dropphyst": "NJ",
    "dropphyzpp": "079312444",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAR HILLS",
    "dropmalst": "NJ",
    "dropmalzpp": "079319998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9082340744,
    "dropsitcph": 9082340744,
    "dropfax": 6505774206
  },
  {
    "dcode": "D",
    "dropkey": "PV10463",
    "droptype": "D",
    "dropname": "FARMINGDALE",
    "dropdeladd": "66 MAIN ST",
    "dropdelcty": "FARMINGDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "077279998",
    "dropphyadd": "66 MAIN ST",
    "dropphycty": "FARMINGDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "077279998",
    "dropmaladd": "66 MAIN ST",
    "dropmalcty": "FARMINGDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "077279998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7329386311,
    "dropsitcph": 7329386311,
    "dropfax": 7329197569
  },
  {
    "dcode": "D",
    "dropkey": "PV10482",
    "droptype": "D",
    "dropname": "FLAGTOWN",
    "dropdeladd": "223 S BRANCH RD",
    "dropdelcty": "FLAGTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088219800",
    "dropphyadd": "223 S BRANCH RD",
    "dropphycty": "FLAGTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088219800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLAGTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088219998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9083693262,
    "dropfax": 6505775435
  },
  {
    "dcode": "D",
    "dropkey": "PV10483",
    "droptype": "D",
    "dropname": "FLANDERS",
    "dropdeladd": "240 US HIGHWAY 206 UNIT 20",
    "dropdelcty": "FLANDERS",
    "dropdelst": "NJ",
    "dropdelzpp": "078369998",
    "dropphyadd": "240 US HIGHWAY 206 UNIT 20",
    "dropphycty": "FLANDERS",
    "dropphyst": "NJ",
    "dropphyzpp": "078369998",
    "dropmaladd": "240 US HIGHWAY 206 UNIT 20",
    "dropmalcty": "FLANDERS",
    "dropmalst": "NJ",
    "dropmalzpp": "078369998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735843660,
    "dropsitcph": 9735843660,
    "dropfax": 6516751655
  },
  {
    "dcode": "D",
    "dropkey": "PV10485",
    "droptype": "D",
    "dropname": "FLEMINGTON",
    "dropdeladd": "4 KINGS CT",
    "dropdelcty": "FLEMINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088229998",
    "dropphyadd": "4 KINGS CT",
    "dropphycty": "FLEMINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088229998",
    "dropmaladd": "4 KINGS CT",
    "dropmalcty": "FLEMINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088229998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9082371518,
    "dropfax": 6503576358
  },
  {
    "dcode": "D",
    "dropkey": "PV10487",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "400 BROAD ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "NJ",
    "dropdelzpp": "085189998",
    "dropphyadd": "400 BROAD ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "NJ",
    "dropphyzpp": "085189998",
    "dropmaladd": "400 BROAD ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "NJ",
    "dropmalzpp": "085189998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094990166,
    "dropsitcph": 6094990166,
    "dropfax": 6094993531
  },
  {
    "dcode": "D",
    "dropkey": "PV10488",
    "droptype": "D",
    "dropname": "FLORHAM PARK",
    "dropdeladd": "187 COLUMBIA TPKE STE 15",
    "dropdelcty": "FLORHAM PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "079329998",
    "dropphyadd": "187 COLUMBIA TPKE STE 15",
    "dropphycty": "FLORHAM PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "079329998",
    "dropmaladd": "187 COLUMBIA TPKE STE 15",
    "dropmalcty": "FLORHAM PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "079329998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733775652,
    "dropsitcph": 9733775652,
    "dropfax": 6505774093
  },
  {
    "dcode": "D",
    "dropkey": "PV10491",
    "droptype": "D",
    "dropname": "FORKED RIVER",
    "dropdeladd": "610 LACEY RD",
    "dropdelcty": "FORKED RIVER",
    "dropdelst": "NJ",
    "dropdelzpp": "087319998",
    "dropphyadd": "610 LACEY RD",
    "dropphycty": "FORKED RIVER",
    "dropphyst": "NJ",
    "dropphyzpp": "087319998",
    "dropmaladd": "610 LACEY RD",
    "dropmalcty": "FORKED RIVER",
    "dropmalst": "NJ",
    "dropmalzpp": "087319998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 6096932334,
    "dropfax": 6096933478
  },
  {
    "dcode": "D",
    "dropkey": "PV10494",
    "droptype": "D",
    "dropname": "FORT LEE",
    "dropdeladd": "231 MAIN ST FL 1",
    "dropdelcty": "FORT LEE",
    "dropdelst": "NJ",
    "dropdelzpp": "070249995",
    "dropphyadd": "231 MAIN ST FL 1",
    "dropphycty": "FORT LEE",
    "dropphyst": "NJ",
    "dropphyzpp": "070249995",
    "dropmaladd": "231 MAIN ST FL 1",
    "dropmalcty": "FORT LEE",
    "dropmalst": "NJ",
    "dropmalzpp": "070249995",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019441865,
    "dropsitcph": 2019441865,
    "dropfax": 6505774368
  },
  {
    "dcode": "D",
    "dropkey": "PV10496",
    "droptype": "D",
    "dropname": "FORTESCUE",
    "dropdeladd": "880 DOWNE AVE",
    "dropdelcty": "FORTESCUE",
    "dropdelst": "NJ",
    "dropdelzpp": "083219998",
    "dropphyadd": "880 DOWNE AVE",
    "dropphycty": "FORTESCUE",
    "dropphyst": "NJ",
    "dropphyzpp": "083219998",
    "dropmaladd": "880 DOWNE AVE",
    "dropmalcty": "FORTESCUE",
    "dropmalst": "NJ",
    "dropmalzpp": "083219998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564473118,
    "dropsitcph": 8564473118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10501",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "270K STATE RT 23",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NJ",
    "dropdelzpp": "074169998",
    "dropphyadd": "270K STATE RT 23",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NJ",
    "dropphyzpp": "074169998",
    "dropmaladd": "270K STATE RT 23",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NJ",
    "dropmalzpp": "074169998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738270570,
    "dropsitcph": 9738270570,
    "dropfax": 6505774337
  },
  {
    "dcode": "D",
    "dropkey": "PV10504",
    "droptype": "D",
    "dropname": "FRANKLIN LAKES",
    "dropdeladd": "785 FRANKLIN AVE",
    "dropdelcty": "FRANKLIN LAKES",
    "dropdelst": "NJ",
    "dropdelzpp": "074179998",
    "dropphyadd": "785 FRANKLIN AVE",
    "dropphycty": "FRANKLIN LAKES",
    "dropphyst": "NJ",
    "dropphyzpp": "074179998",
    "dropmaladd": "785 FRANKLIN AVE",
    "dropmalcty": "FRANKLIN LAKES",
    "dropmalst": "NJ",
    "dropmalzpp": "074179998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018470697,
    "dropsitcph": 2018470697,
    "dropfax": 6503576640
  },
  {
    "dcode": "D",
    "dropkey": "PV10506",
    "droptype": "D",
    "dropname": "FRANKLIN PARK",
    "dropdeladd": "3124 STATE ROUTE 27",
    "dropdelcty": "KENDALL PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "088249996",
    "dropphyadd": "3124 STATE ROUTE 27",
    "dropphycty": "KENDALL PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "088249996",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLIN PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "088239998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322973170,
    "dropfax": 6505775436
  },
  {
    "dcode": "D",
    "dropkey": "PV10508",
    "droptype": "D",
    "dropname": "FRANKLINVILLE",
    "dropdeladd": "2387 DELSEA DR",
    "dropdelcty": "FRANKLINVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083229998",
    "dropphyadd": "2387 DELSEA DR",
    "dropphycty": "FRANKLINVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083229998",
    "dropmaladd": "2387 DELSEA DR",
    "dropmalcty": "FRANKLINVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083229998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566941616,
    "dropsitcph": 8566941616,
    "dropfax": 8566942067
  },
  {
    "dcode": "D",
    "dropkey": "PV10511",
    "droptype": "D",
    "dropname": "FREEHOLD",
    "dropdeladd": "200 VILLAGE CENTER DR",
    "dropdelcty": "FREEHOLD",
    "dropdelst": "NJ",
    "dropdelzpp": "077289998",
    "dropphyadd": "200 VILLAGE CENTER DR",
    "dropphycty": "FREEHOLD",
    "dropphyst": "NJ",
    "dropphyzpp": "077289998",
    "dropmaladd": "200 VILLAGE CENTER DR",
    "dropmalcty": "FREEHOLD",
    "dropmalst": "NJ",
    "dropmalzpp": "077289998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324314525,
    "dropsitcph": 7324314525,
    "dropfax": 7324310148
  },
  {
    "dcode": "D",
    "dropkey": "PV10512",
    "droptype": "D",
    "dropname": "FRENCHTOWN",
    "dropdeladd": "16 TRENTON AVE",
    "dropdelcty": "FRENCHTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088259998",
    "dropphyadd": "16 TRENTON AVE",
    "dropphycty": "FRENCHTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088259998",
    "dropmaladd": "16 TRENTON AVE",
    "dropmalcty": "FRENCHTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088259998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9089962323,
    "dropfax": 6505775437
  },
  {
    "dcode": "D",
    "dropkey": "PV10518",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "254 PALISADE AVE",
    "dropdelcty": "GARFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070269998",
    "dropphyadd": "254 PALISADE AVE",
    "dropphycty": "GARFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070269998",
    "dropmaladd": "254 PALISADE AVE",
    "dropmalcty": "GARFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070269998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734787244,
    "dropsitcph": 9734780897,
    "dropfax": 6505774407
  },
  {
    "dcode": "D",
    "dropkey": "PV10519",
    "droptype": "D",
    "dropname": "GARWOOD",
    "dropdeladd": "202 CENTER ST",
    "dropdelcty": "GARWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "070279998",
    "dropphyadd": "202 CENTER ST",
    "dropphycty": "GARWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "070279998",
    "dropmaladd": "202 CENTER ST",
    "dropmalcty": "GARWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "070279998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087890315,
    "dropsitcph": 9087890315,
    "dropfax": 6505774391
  },
  {
    "dcode": "D",
    "dropkey": "PV10526",
    "droptype": "D",
    "dropname": "GIBBSBORO",
    "dropdeladd": "65 KIRKWOOD RD",
    "dropdelcty": "GIBBSBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080269998",
    "dropphyadd": "65 KIRKWOOD RD",
    "dropphycty": "GIBBSBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080269998",
    "dropmaladd": "65 KIRKWOOD RD",
    "dropmalcty": "GIBBSBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080269998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566277250,
    "dropsitcph": 8566277250,
    "dropfax": 8566243756
  },
  {
    "dcode": "D",
    "dropkey": "PV10530",
    "droptype": "D",
    "dropname": "GIBBSTOWN",
    "dropdeladd": "414 W BROAD ST",
    "dropdelcty": "GIBBSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080279998",
    "dropphyadd": "414 W BROAD ST",
    "dropphycty": "GIBBSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080279998",
    "dropmaladd": "414 W BROAD ST",
    "dropmalcty": "GIBBSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080279998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564233011,
    "dropsitcph": 8564233011,
    "dropfax": 8564234198
  },
  {
    "dcode": "D",
    "dropkey": "PV10531",
    "droptype": "D",
    "dropname": "GILLETTE",
    "dropdeladd": "594 VALLEY RD",
    "dropdelcty": "GILLETTE",
    "dropdelst": "NJ",
    "dropdelzpp": "079339998",
    "dropphyadd": "594 VALLEY RD",
    "dropphycty": "GILLETTE",
    "dropphyst": "NJ",
    "dropphyzpp": "079339998",
    "dropmaladd": "594 VALLEY RD",
    "dropmalcty": "GILLETTE",
    "dropmalst": "NJ",
    "dropmalzpp": "079339998",
    "dropsitphn": "",
    "dropsitlph": 9086473135,
    "dropsitcph": 9086473135,
    "dropfax": 6505775095
  },
  {
    "dcode": "D",
    "dropkey": "PV10532",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "266 MAIN ST STE A",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "NJ",
    "dropdelzpp": "079349803",
    "dropphyadd": "266 MAIN ST STE A",
    "dropphycty": "GLADSTONE",
    "dropphyst": "NJ",
    "dropphyzpp": "079349803",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "NJ",
    "dropmalzpp": "079349998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9082340303,
    "dropsitcph": 9082340303,
    "dropfax": 6505774344
  },
  {
    "dcode": "D",
    "dropkey": "PV10533",
    "droptype": "D",
    "dropname": "GLASSBORO",
    "dropdeladd": "124 E HIGH ST",
    "dropdelcty": "GLASSBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080289998",
    "dropphyadd": "124 E HIGH ST",
    "dropphycty": "GLASSBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080289998",
    "dropmaladd": "124 E HIGH ST",
    "dropmalcty": "GLASSBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080289998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568816266,
    "dropsitcph": 8568816266,
    "dropfax": 8568811528
  },
  {
    "dcode": "D",
    "dropkey": "PV10535",
    "droptype": "D",
    "dropname": "GLASSER",
    "dropdeladd": "3 HOPATCONG ST",
    "dropdelcty": "GLASSER",
    "dropdelst": "NJ",
    "dropdelzpp": "078379800",
    "dropphyadd": "3 HOPATCONG ST",
    "dropphycty": "GLASSER",
    "dropphyst": "NJ",
    "dropphyzpp": "078379800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLASSER",
    "dropmalst": "NJ",
    "dropmalzpp": "078379998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736633840,
    "dropsitcph": 9736633840,
    "dropfax": 6505774036
  },
  {
    "dcode": "D",
    "dropkey": "PV10536",
    "droptype": "D",
    "dropname": "GLEN GARDNER",
    "dropdeladd": "64 MAIN ST",
    "dropdelcty": "GLEN GARDNER",
    "dropdelst": "NJ",
    "dropdelzpp": "088269998",
    "dropphyadd": "64 MAIN ST",
    "dropphycty": "GLEN GARDNER",
    "dropphyst": "NJ",
    "dropphyzpp": "088269998",
    "dropmaladd": "64 MAIN ST",
    "dropmalcty": "GLEN GARDNER",
    "dropmalst": "NJ",
    "dropmalzpp": "088269998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085372813,
    "dropfax": 6505775438
  },
  {
    "dcode": "D",
    "dropkey": "PV10537",
    "droptype": "D",
    "dropname": "GLEN RIDGE",
    "dropdeladd": "225 RIDGEWOOD AVE",
    "dropdelcty": "GLEN RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070289998",
    "dropphyadd": "225 RIDGEWOOD AVE",
    "dropphycty": "GLEN RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070289998",
    "dropmaladd": "225 RIDGEWOOD AVE",
    "dropmalcty": "GLEN RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070289998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737433685,
    "dropsitcph": 9737433685,
    "dropfax": 6505774321
  },
  {
    "dcode": "D",
    "dropkey": "PV10541",
    "droptype": "D",
    "dropname": "GLENDORA",
    "dropdeladd": "38 6TH AVE",
    "dropdelcty": "GLENDORA",
    "dropdelst": "NJ",
    "dropdelzpp": "080299998",
    "dropphyadd": "38 6TH AVE",
    "dropphycty": "GLENDORA",
    "dropphyst": "NJ",
    "dropphyzpp": "080299998",
    "dropmaladd": "38 6TH AVE",
    "dropmalcty": "GLENDORA",
    "dropmalst": "NJ",
    "dropmalzpp": "080299998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569390440,
    "dropsitcph": 8569390440,
    "dropfax": 8569392380
  },
  {
    "dcode": "D",
    "dropkey": "PV10543",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "958 COUNTY RT 517",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "074189998",
    "dropphyadd": "958 COUNTY RT 517",
    "dropphycty": "GLENWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "074189998",
    "dropmaladd": "958 COUNTY RT 517",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "074189998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737642616,
    "dropsitcph": 9737642616,
    "dropfax": 6505774032
  },
  {
    "dcode": "D",
    "dropkey": "PV10546",
    "droptype": "D",
    "dropname": "GLOUCESTER CITY",
    "dropdeladd": "113 S BROADWAY",
    "dropdelcty": "GLOUCESTER CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "080309998",
    "dropphyadd": "113 S BROADWAY",
    "dropphycty": "GLOUCESTER CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "080309998",
    "dropmaladd": "113 S BROADWAY",
    "dropmalcty": "GLOUCESTER CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "080309998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564560477,
    "dropsitcph": 8564560477,
    "dropfax": 8564563197
  },
  {
    "dcode": "D",
    "dropkey": "PV10557",
    "droptype": "D",
    "dropname": "GREAT MEADOWS",
    "dropdeladd": "4 REGINA LN",
    "dropdelcty": "GREAT MEADOWS",
    "dropdelst": "NJ",
    "dropdelzpp": "078382099",
    "dropphyadd": "4 REGINA LN",
    "dropphycty": "GREAT MEADOWS",
    "dropphyst": "NJ",
    "dropphyzpp": "078382099",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREAT MEADOWS",
    "dropmalst": "NJ",
    "dropmalzpp": "078389998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086374792,
    "dropsitcph": 9086374792,
    "dropfax": 6505774023
  },
  {
    "dcode": "D",
    "dropkey": "PV10562",
    "droptype": "D",
    "dropname": "GREEN CREEK",
    "dropdeladd": "501 ROUTE 47 S",
    "dropdelcty": "GREEN CREEK",
    "dropdelst": "NJ",
    "dropdelzpp": "082199998",
    "dropphyadd": "501 ROUTE 47 S",
    "dropphycty": "GREEN CREEK",
    "dropphyst": "NJ",
    "dropphyzpp": "082199998",
    "dropmaladd": "501 ROUTE 47 S",
    "dropmalcty": "GREEN CREEK",
    "dropmalst": "NJ",
    "dropmalzpp": "082199998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098867579,
    "dropsitcph": 6098867579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10565",
    "droptype": "D",
    "dropname": "GREEN VILLAGE",
    "dropdeladd": "372 GREEN VILLAGE RD",
    "dropdelcty": "GREEN VILLAGE",
    "dropdelst": "NJ",
    "dropdelzpp": "079359998",
    "dropphyadd": "372 GREEN VILLAGE RD",
    "dropphycty": "GREEN VILLAGE",
    "dropphyst": "NJ",
    "dropphyzpp": "079359998",
    "dropmaladd": "372 GREEN VILLAGE RD",
    "dropmalcty": "GREEN VILLAGE",
    "dropmalst": "NJ",
    "dropmalzpp": "079359998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086473135,
    "dropsitcph": 9733770737,
    "dropfax": 6516751619
  },
  {
    "dcode": "D",
    "dropkey": "PV10568",
    "droptype": "D",
    "dropname": "GREENDELL",
    "dropdeladd": "243 KENNEDY RD",
    "dropdelcty": "GREENDELL",
    "dropdelst": "NJ",
    "dropdelzpp": "078399800",
    "dropphyadd": "243 KENNEDY RD",
    "dropphycty": "GREENDELL",
    "dropphyst": "NJ",
    "dropphyzpp": "078399800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENDELL",
    "dropmalst": "NJ",
    "dropmalzpp": "078399998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735157868,
    "dropsitcph": 9733836499,
    "dropfax": 6505774038
  },
  {
    "dcode": "D",
    "dropkey": "PV10572",
    "droptype": "D",
    "dropname": "GREENWICH",
    "dropdeladd": "1016 YE GREATE ST",
    "dropdelcty": "GREENWICH",
    "dropdelst": "NJ",
    "dropdelzpp": "083239998",
    "dropphyadd": "1016 YE GREATE ST",
    "dropphycty": "GREENWICH",
    "dropphyst": "NJ",
    "dropphyzpp": "083239998",
    "dropmaladd": "1016 YE GREATE ST",
    "dropmalcty": "GREENWICH",
    "dropmalst": "NJ",
    "dropmalzpp": "083239998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564552555,
    "dropsitcph": 8564552555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10575",
    "droptype": "D",
    "dropname": "GRENLOCH",
    "dropdeladd": "113 CENTRAL AVE",
    "dropdelcty": "GRENLOCH",
    "dropdelst": "NJ",
    "dropdelzpp": "080329998",
    "dropphyadd": "113 CENTRAL AVE",
    "dropphycty": "GRENLOCH",
    "dropphyst": "NJ",
    "dropphyzpp": "080329998",
    "dropmaladd": "113 CENTRAL AVE",
    "dropmalcty": "GRENLOCH",
    "dropmalst": "NJ",
    "dropmalzpp": "080329998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562281750,
    "dropsitcph": 8562281750,
    "dropfax": 8562322489
  },
  {
    "dcode": "D",
    "dropkey": "PV10586",
    "droptype": "D",
    "dropname": "HACKENSACK",
    "dropdeladd": "226 STATE ST",
    "dropdelcty": "HACKENSACK",
    "dropdelst": "NJ",
    "dropdelzpp": "076015502",
    "dropphyadd": "226 STATE ST",
    "dropphycty": "HACKENSACK",
    "dropphyst": "NJ",
    "dropphyzpp": "076015502",
    "dropmaladd": "226 STATE ST",
    "dropmalcty": "HACKENSACK",
    "dropmalst": "NJ",
    "dropmalzpp": "076015502",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016469736,
    "dropsitcph": 2016469736,
    "dropfax": 6505774250
  },
  {
    "dcode": "D",
    "dropkey": "PV10587",
    "droptype": "D",
    "dropname": "HACKETTSTOWN",
    "dropdeladd": "120 GRAND AVE",
    "dropdelcty": "HACKETTSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "078409998",
    "dropphyadd": "120 GRAND AVE",
    "dropphycty": "HACKETTSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "078409998",
    "dropmaladd": "120 GRAND AVE",
    "dropmalcty": "HACKETTSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "078409998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9088523535,
    "dropsitcph": 9088523535,
    "dropfax": 6505774018
  },
  {
    "dcode": "D",
    "dropkey": "PV10589",
    "droptype": "D",
    "dropname": "HADDON HEIGHTS",
    "dropdeladd": "701 STATION AVE",
    "dropdelcty": "HADDON HEIGHTS",
    "dropdelst": "NJ",
    "dropdelzpp": "080359998",
    "dropphyadd": "701 STATION AVE",
    "dropphycty": "HADDON HEIGHTS",
    "dropphyst": "NJ",
    "dropphyzpp": "080359998",
    "dropmaladd": "701 STATION AVE",
    "dropmalcty": "HADDON HEIGHTS",
    "dropmalst": "NJ",
    "dropmalzpp": "080359998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565471091,
    "dropsitcph": 8565471091,
    "dropfax": 8565476086
  },
  {
    "dcode": "D",
    "dropkey": "PV10592",
    "droptype": "D",
    "dropname": "HADDONFIELD",
    "dropdeladd": "25 S HADDON AVE",
    "dropdelcty": "HADDONFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "080339998",
    "dropphyadd": "25 S HADDON AVE",
    "dropphycty": "HADDONFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "080339998",
    "dropmaladd": "25 S HADDON AVE",
    "dropmalcty": "HADDONFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "080339998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564290246,
    "dropsitcph": 8564290246,
    "dropfax": 8564293241
  },
  {
    "dcode": "D",
    "dropkey": "PV10594",
    "droptype": "D",
    "dropname": "HAINESPORT",
    "dropdeladd": "107 BROAD ST",
    "dropdelcty": "HAINESPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "080369998",
    "dropphyadd": "107 BROAD ST",
    "dropphycty": "HAINESPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "080369998",
    "dropmaladd": "107 BROAD ST",
    "dropmalcty": "HAINESPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "080369998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092670633,
    "dropsitcph": 6092670633,
    "dropfax": 6095182483
  },
  {
    "dcode": "D",
    "dropkey": "PV10596",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "28 MAIN ST",
    "dropdelcty": "HAMBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "074199998",
    "dropphyadd": "28 MAIN ST",
    "dropphycty": "HAMBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "074199998",
    "dropmaladd": "28 MAIN ST",
    "dropmalcty": "HAMBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "074199998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738270571,
    "dropsitcph": 9738270571,
    "dropfax": 6505774014
  },
  {
    "dcode": "D",
    "dropkey": "PV10602",
    "droptype": "D",
    "dropname": "HAMMONTON",
    "dropdeladd": "114 S 3RD ST",
    "dropdelcty": "HAMMONTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080379998",
    "dropphyadd": "114 S 3RD ST",
    "dropphycty": "HAMMONTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080379998",
    "dropmaladd": "114 S 3RD ST",
    "dropmalcty": "HAMMONTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080379998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095610474,
    "dropsitcph": 6095610474,
    "dropfax": 6095674796
  },
  {
    "dcode": "D",
    "dropkey": "PV10603",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "77 FOSS AVE",
    "dropdelcty": "HAMPTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088279998",
    "dropphyadd": "77 FOSS AVE",
    "dropphycty": "HAMPTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088279998",
    "dropmaladd": "77 FOSS AVE",
    "dropmalcty": "HAMPTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088279998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085372012,
    "dropfax": 6505775439
  },
  {
    "dcode": "D",
    "dropkey": "PV10605",
    "droptype": "D",
    "dropname": "HANCOCKS BRIDGE",
    "dropdeladd": "500 LOCUST ISLAND RD",
    "dropdelcty": "HANCOCKS BRIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "080389998",
    "dropphyadd": "500 LOCUST ISLAND RD",
    "dropphycty": "HANCOCKS BRIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "080389998",
    "dropmaladd": "500 LOCUST ISLAND RD",
    "dropmalcty": "HANCOCKS BRIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "080389998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569352114,
    "dropsitcph": 8569352114,
    "dropfax": 8568780619
  },
  {
    "dcode": "D",
    "dropkey": "PV10607",
    "droptype": "D",
    "dropname": "HARRINGTON PARK",
    "dropdeladd": "7 LYNN ST",
    "dropdelcty": "HARRINGTON PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "076409998",
    "dropphyadd": "7 LYNN ST",
    "dropphycty": "HARRINGTON PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "076409998",
    "dropmaladd": "7 LYNN ST",
    "dropmalcty": "HARRINGTON PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "076409998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017846754,
    "dropsitcph": 2017846754,
    "dropfax": 6505774677
  },
  {
    "dcode": "D",
    "dropkey": "PV10609",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "427 HARRISON AVE",
    "dropdelcty": "HARRISON",
    "dropdelst": "NJ",
    "dropdelzpp": "070299998",
    "dropphyadd": "427 HARRISON AVE",
    "dropphycty": "HARRISON",
    "dropphyst": "NJ",
    "dropphyzpp": "070299998",
    "dropmaladd": "427 HARRISON AVE",
    "dropmalcty": "HARRISON",
    "dropmalst": "NJ",
    "dropmalzpp": "070299998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734815256,
    "dropsitcph": 9734815256,
    "dropfax": 6503576628
  },
  {
    "dcode": "D",
    "dropkey": "PV10610",
    "droptype": "D",
    "dropname": "HARRISONVILLE",
    "dropdeladd": "830 MULLICA HILL RD",
    "dropdelcty": "HARRISONVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "080399997",
    "dropphyadd": "830 MULLICA HILL RD",
    "dropphycty": "HARRISONVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "080399997",
    "dropmaladd": "830 MULLICA HILL RD",
    "dropmalcty": "HARRISONVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "080399997",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567691884,
    "dropsitcph": 8567691884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10619",
    "droptype": "D",
    "dropname": "HASKELL",
    "dropdeladd": "1108 RINGWOOD AVE",
    "dropdelcty": "HASKELL",
    "dropdelst": "NJ",
    "dropdelzpp": "074209998",
    "dropphyadd": "1108 RINGWOOD AVE",
    "dropphycty": "HASKELL",
    "dropphyst": "NJ",
    "dropphyzpp": "074209998",
    "dropmaladd": "1108 RINGWOOD AVE",
    "dropmalcty": "HASKELL",
    "dropmalst": "NJ",
    "dropmalzpp": "074209998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738353762,
    "dropsitcph": 9738353762,
    "dropfax": 6505774074
  },
  {
    "dcode": "D",
    "dropkey": "PV10621",
    "droptype": "D",
    "dropname": "HAWORTH",
    "dropdeladd": "300 SAINT NICHOLAS AVE",
    "dropdelcty": "HAWORTH",
    "dropdelst": "NJ",
    "dropdelzpp": "076419998",
    "dropphyadd": "300 SAINT NICHOLAS AVE",
    "dropphycty": "HAWORTH",
    "dropphyst": "NJ",
    "dropphyzpp": "076419998",
    "dropmaladd": "300 SAINT NICHOLAS AVE",
    "dropmalcty": "HAWORTH",
    "dropmalst": "NJ",
    "dropmalzpp": "076419998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013852609,
    "dropsitcph": 2013852609,
    "dropfax": 6505774399
  },
  {
    "dcode": "D",
    "dropkey": "PV10623",
    "droptype": "D",
    "dropname": "HAZLET",
    "dropdeladd": "65 HAZLET AVE",
    "dropdelcty": "HAZLET",
    "dropdelst": "NJ",
    "dropdelzpp": "077309998",
    "dropphyadd": "65 HAZLET AVE",
    "dropphycty": "HAZLET",
    "dropphyst": "NJ",
    "dropphyzpp": "077309998",
    "dropmaladd": "65 HAZLET AVE",
    "dropmalcty": "HAZLET",
    "dropmalst": "NJ",
    "dropmalzpp": "077309998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322647068,
    "dropsitcph": 7322647068,
    "dropfax": 7322643649
  },
  {
    "dcode": "D",
    "dropkey": "PV10624",
    "droptype": "D",
    "dropname": "HEISLERVILLE",
    "dropdeladd": "222 MAIN ST",
    "dropdelcty": "HEISLERVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083249998",
    "dropphyadd": "222 MAIN ST",
    "dropphycty": "HEISLERVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083249998",
    "dropmaladd": "222 MAIN ST",
    "dropmalcty": "HEISLERVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083249998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567850171,
    "dropsitcph": 8567850171,
    "dropfax": 8567850171
  },
  {
    "dcode": "D",
    "dropkey": "PV10626",
    "droptype": "D",
    "dropname": "HELMETTA",
    "dropdeladd": "68 MAIN ST",
    "dropdelcty": "HELMETTA",
    "dropdelst": "NJ",
    "dropdelzpp": "088289998",
    "dropphyadd": "68 MAIN ST",
    "dropphycty": "HELMETTA",
    "dropphyst": "NJ",
    "dropphyzpp": "088289998",
    "dropmaladd": "68 MAIN ST",
    "dropmalcty": "HELMETTA",
    "dropmalst": "NJ",
    "dropmalzpp": "088289998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325210326,
    "dropfax": 6505775440
  },
  {
    "dcode": "D",
    "dropkey": "PV10627",
    "droptype": "D",
    "dropname": "HEWITT",
    "dropdeladd": "1926 UNION VALLEY RD STE E",
    "dropdelcty": "HEWITT",
    "dropdelst": "NJ",
    "dropdelzpp": "074219998",
    "dropphyadd": "1926 UNION VALLEY RD STE E",
    "dropphycty": "HEWITT",
    "dropphyst": "NJ",
    "dropphyzpp": "074219998",
    "dropmaladd": "1926 UNION VALLEY RD STE E",
    "dropmalcty": "HEWITT",
    "dropmalst": "NJ",
    "dropmalzpp": "074219998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737285981,
    "dropsitcph": 9737285981,
    "dropfax": 6505774012
  },
  {
    "dcode": "D",
    "dropkey": "PV10629",
    "droptype": "D",
    "dropname": "HIBERNIA",
    "dropdeladd": "328 GREEN POND RD",
    "dropdelcty": "HIBERNIA",
    "dropdelst": "NJ",
    "dropdelzpp": "078429800",
    "dropphyadd": "328 GREEN POND RD",
    "dropphycty": "HIBERNIA",
    "dropphyst": "NJ",
    "dropphyzpp": "078429800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIBERNIA",
    "dropmalst": "NJ",
    "dropmalzpp": "078429998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736252257,
    "dropsitcph": 9736252219,
    "dropfax": 6505774076
  },
  {
    "dcode": "D",
    "dropkey": "PV10631",
    "droptype": "D",
    "dropname": "HIGH BRIDGE",
    "dropdeladd": "10 MCDONALD ST",
    "dropdelcty": "HIGH BRIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "088299998",
    "dropphyadd": "10 MCDONALD ST",
    "dropphycty": "HIGH BRIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "088299998",
    "dropmaladd": "10 MCDONALD ST",
    "dropmalcty": "HIGH BRIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "088299998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9086386281,
    "dropfax": 6505775441
  },
  {
    "dcode": "D",
    "dropkey": "PV10635",
    "droptype": "D",
    "dropname": "HIGHLAND LAKES",
    "dropdeladd": "177 BREAKNECK RD",
    "dropdelcty": "HIGHLAND LAKES",
    "dropdelst": "NJ",
    "dropdelzpp": "074229998",
    "dropphyadd": "177 BREAKNECK RD",
    "dropphycty": "HIGHLAND LAKES",
    "dropphyst": "NJ",
    "dropphyzpp": "074229998",
    "dropmaladd": "177 BREAKNECK RD",
    "dropmalcty": "HIGHLAND LAKES",
    "dropmalst": "NJ",
    "dropmalzpp": "074229998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737649086,
    "dropsitcph": 9737649086,
    "dropfax": 6505774035
  },
  {
    "dcode": "D",
    "dropkey": "PV10639",
    "droptype": "D",
    "dropname": "HIGHLANDS",
    "dropdeladd": "170 BAY AVE",
    "dropdelcty": "HIGHLANDS",
    "dropdelst": "NJ",
    "dropdelzpp": "077329998",
    "dropphyadd": "170 BAY AVE",
    "dropphycty": "HIGHLANDS",
    "dropphyst": "NJ",
    "dropphyzpp": "077329998",
    "dropmaladd": "170 BAY AVE",
    "dropmalcty": "HIGHLANDS",
    "dropmalst": "NJ",
    "dropmalzpp": "077329998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7328720622,
    "dropsitcph": 7328720622,
    "dropfax": 7328722257
  },
  {
    "dcode": "D",
    "dropkey": "PV10643",
    "droptype": "D",
    "dropname": "HIGHTSTOWN",
    "dropdeladd": "150 MERCER ST",
    "dropdelcty": "HIGHTSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "085209998",
    "dropphyadd": "150 MERCER ST",
    "dropphycty": "HIGHTSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "085209998",
    "dropmaladd": "150 MERCER ST",
    "dropmalcty": "HIGHTSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "085209998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094480255,
    "dropsitcph": 6094480255,
    "dropfax": 6093710819
  },
  {
    "dcode": "D",
    "dropkey": "PV10648",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "445 HILLSDALE AVE",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "076429998",
    "dropphyadd": "445 HILLSDALE AVE",
    "dropphycty": "HILLSDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "076429998",
    "dropmaladd": "445 HILLSDALE AVE",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "076429998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016647581,
    "dropsitcph": 2016647581,
    "dropfax": 6505774205
  },
  {
    "dcode": "D",
    "dropkey": "PV10651",
    "droptype": "D",
    "dropname": "HO HO KUS",
    "dropdeladd": "30 N FRANKLIN TPKE",
    "dropdelcty": "HO HO KUS",
    "dropdelst": "NJ",
    "dropdelzpp": "074239998",
    "dropphyadd": "30 N FRANKLIN TPKE",
    "dropphycty": "HO HO KUS",
    "dropphyst": "NJ",
    "dropphyzpp": "074239998",
    "dropmaladd": "30 N FRANKLIN TPKE",
    "dropmalcty": "HO HO KUS",
    "dropmalst": "NJ",
    "dropmalzpp": "074239998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2014475937,
    "dropsitcph": 2014475937,
    "dropfax": 6505774284
  },
  {
    "dcode": "D",
    "dropkey": "PV10652",
    "droptype": "D",
    "dropname": "HOBOKEN",
    "dropdeladd": "89 RIVER ST",
    "dropdelcty": "HOBOKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070309998",
    "dropphyadd": "89 RIVER ST",
    "dropphycty": "HOBOKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070309998",
    "dropmaladd": "89 RIVER ST",
    "dropmalcty": "HOBOKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070309998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2016593017,
    "dropsitcph": 2016593017,
    "dropfax": 6505774008
  },
  {
    "dcode": "D",
    "dropkey": "PV10655",
    "droptype": "D",
    "dropname": "HOLMDEL",
    "dropdeladd": "10 CRAWFORDS CORNER RD",
    "dropdelcty": "HOLMDEL",
    "dropdelst": "NJ",
    "dropdelzpp": "077339998",
    "dropphyadd": "10 CRAWFORDS CORNER RD",
    "dropphycty": "HOLMDEL",
    "dropphyst": "NJ",
    "dropphyzpp": "077339998",
    "dropmaladd": "10 CRAWFORDS CORNER RD",
    "dropmalcty": "HOLMDEL",
    "dropmalst": "NJ",
    "dropmalzpp": "077339998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7329464710,
    "dropsitcph": 7329464710,
    "dropfax": 7329468596
  },
  {
    "dcode": "D",
    "dropkey": "PV10658",
    "droptype": "D",
    "dropname": "HOPATCONG",
    "dropdeladd": "32 DURBAN AVE",
    "dropdelcty": "HOPATCONG",
    "dropdelst": "NJ",
    "dropdelzpp": "078439998",
    "dropphyadd": "32 DURBAN AVE",
    "dropphycty": "HOPATCONG",
    "dropphyst": "NJ",
    "dropphyzpp": "078439998",
    "dropmaladd": "32 DURBAN AVE",
    "dropmalcty": "HOPATCONG",
    "dropmalst": "NJ",
    "dropmalzpp": "078439998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733981046,
    "dropsitcph": 9733981046,
    "dropfax": 6505774339
  },
  {
    "dcode": "D",
    "dropkey": "PV10659",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "10 BLAIRSTOWN RD",
    "dropdelcty": "HOPE",
    "dropdelst": "NJ",
    "dropdelzpp": "078449800",
    "dropphyadd": "10 BLAIRSTOWN RD",
    "dropphycty": "HOPE",
    "dropphyst": "NJ",
    "dropphyzpp": "078449800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPE",
    "dropmalst": "NJ",
    "dropmalzpp": "078449998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084594088,
    "dropsitcph": 9084594088,
    "dropfax": 6505774030
  },
  {
    "dcode": "D",
    "dropkey": "PV10661",
    "droptype": "D",
    "dropname": "HOPEWELL",
    "dropdeladd": "9 S GREENWOOD AVE",
    "dropdelcty": "HOPEWELL",
    "dropdelst": "NJ",
    "dropdelzpp": "085259998",
    "dropphyadd": "9 S GREENWOOD AVE",
    "dropphycty": "HOPEWELL",
    "dropphyst": "NJ",
    "dropphyzpp": "085259998",
    "dropmaladd": "9 S GREENWOOD AVE",
    "dropmalcty": "HOPEWELL",
    "dropmalst": "NJ",
    "dropmalzpp": "085259998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094660462,
    "dropsitcph": 6094660462,
    "dropfax": 6094660646
  },
  {
    "dcode": "D",
    "dropkey": "PV10664",
    "droptype": "D",
    "dropname": "HOWELL",
    "dropdeladd": "4170 US HIGHWAY 9",
    "dropdelcty": "HOWELL",
    "dropdelst": "NJ",
    "dropdelzpp": "077319998",
    "dropphyadd": "4170 US HIGHWAY 9",
    "dropphycty": "HOWELL",
    "dropphyst": "NJ",
    "dropphyzpp": "077319998",
    "dropmaladd": "4170 US HIGHWAY 9",
    "dropmalcty": "HOWELL",
    "dropmalst": "NJ",
    "dropmalzpp": "077319998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7323645288,
    "dropsitcph": 7323645288,
    "dropfax": 7323642072
  },
  {
    "dcode": "D",
    "dropkey": "PV10680",
    "droptype": "D",
    "dropname": "IRONIA",
    "dropdeladd": "389 DOVER CHESTER RD",
    "dropdelcty": "IRONIA",
    "dropdelst": "NJ",
    "dropdelzpp": "078459800",
    "dropphyadd": "389 DOVER CHESTER RD",
    "dropphycty": "IRONIA",
    "dropphyst": "NJ",
    "dropphyzpp": "078459800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRONIA",
    "dropmalst": "NJ",
    "dropmalzpp": "078459998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735845659,
    "dropsitcph": 9735845659,
    "dropfax": 6505774056
  },
  {
    "dcode": "D",
    "dropkey": "PV10683",
    "droptype": "D",
    "dropname": "ISELIN",
    "dropdeladd": "250 MIDDLESEX TPKE",
    "dropdelcty": "ISELIN",
    "dropdelst": "NJ",
    "dropdelzpp": "088309998",
    "dropphyadd": "250 MIDDLESEX TPKE",
    "dropphycty": "ISELIN",
    "dropphyst": "NJ",
    "dropphyzpp": "088309998",
    "dropmaladd": "250 MIDDLESEX TPKE",
    "dropmalcty": "ISELIN",
    "dropmalst": "NJ",
    "dropmalzpp": "088309998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322830053,
    "dropfax": 6503576535
  },
  {
    "dcode": "D",
    "dropkey": "PV10684",
    "droptype": "D",
    "dropname": "ISLAND HEIGHTS",
    "dropdeladd": "5 WANAMAKER MUNICIPAL COMPLEX",
    "dropdelcty": "ISLAND HEIGHTS",
    "dropdelst": "NJ",
    "dropdelzpp": "087329998",
    "dropphyadd": "5 WANAMAKER MUNICIPAL COMPLEX",
    "dropphycty": "ISLAND HEIGHTS",
    "dropphyst": "NJ",
    "dropphyzpp": "087329998",
    "dropmaladd": "5 WANAMAKER MUNICIPAL COMPLEX",
    "dropmalcty": "ISLAND HEIGHTS",
    "dropmalst": "NJ",
    "dropmalzpp": "087329998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329290220,
    "dropfax": 7329291431
  },
  {
    "dcode": "D",
    "dropkey": "PV10685",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "915 BENNETTS MILLS RD",
    "dropdelcty": "JACKSON",
    "dropdelst": "NJ",
    "dropdelzpp": "085279998",
    "dropphyadd": "915 BENNETTS MILLS RD",
    "dropphycty": "JACKSON",
    "dropphyst": "NJ",
    "dropphyzpp": "085279998",
    "dropmaladd": "915 BENNETTS MILLS RD",
    "dropmalcty": "JACKSON",
    "dropmalst": "NJ",
    "dropmalzpp": "085279998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7329424675,
    "dropsitcph": 7329424675,
    "dropfax": 7323638652
  },
  {
    "dcode": "D",
    "dropkey": "PV10690",
    "droptype": "D",
    "dropname": "MONROE TOWNSHIP",
    "dropdeladd": "1601 PERRINEVILLE RD",
    "dropdelcty": "MONROE TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "088319998",
    "dropphyadd": "1601 PERRINEVILLE RD",
    "dropphycty": "MONROE TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "088319998",
    "dropmaladd": "1601 PERRINEVILLE RD",
    "dropmalcty": "MONROE TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "088319998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 6094098170,
    "dropfax": 6505774062
  },
  {
    "dcode": "D",
    "dropkey": "PV10698",
    "droptype": "D",
    "dropname": "JERSEY CITY",
    "dropdeladd": "69 MONTGOMERY ST",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073029998",
    "dropphyadd": "69 MONTGOMERY ST",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073029998",
    "dropmaladd": "69 MONTGOMERY ST",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073029998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019157041,
    "dropsitcph": 2019157041,
    "dropfax": 6505774216
  },
  {
    "dcode": "D",
    "dropkey": "PV10702",
    "droptype": "D",
    "dropname": "JOBSTOWN",
    "dropdeladd": "2206 SAYLORS POND RD",
    "dropdelcty": "JOBSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080419998",
    "dropphyadd": "2206 SAYLORS POND RD",
    "dropphycty": "JOBSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080419998",
    "dropmaladd": "2206 SAYLORS POND RD",
    "dropmalcty": "JOBSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080419998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097232586,
    "dropsitcph": 6097232586,
    "dropfax": 6097236639
  },
  {
    "dcode": "D",
    "dropkey": "PV10708",
    "droptype": "D",
    "dropname": "JULIUSTOWN",
    "dropdeladd": "393 MAIN ST",
    "dropdelcty": "JULIUSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080429998",
    "dropphyadd": "393 MAIN ST",
    "dropphycty": "JULIUSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080429998",
    "dropmaladd": "393 MAIN ST",
    "dropmalcty": "JULIUSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080429998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098944648,
    "dropsitcph": 6098944648,
    "dropfax": 6098944648
  },
  {
    "dcode": "D",
    "dropkey": "PV10712",
    "droptype": "D",
    "dropname": "KEANSBURG",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "KEANSBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "077349998",
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "KEANSBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "077349998",
    "dropmaladd": "230 MAIN ST",
    "dropmalcty": "KEANSBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "077349998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327872940,
    "dropsitcph": 7327872940,
    "dropfax": 7327871310
  },
  {
    "dcode": "D",
    "dropkey": "PV10714",
    "droptype": "D",
    "dropname": "KEARNY",
    "dropdeladd": "64 MIDLAND AVE",
    "dropdelcty": "KEARNY",
    "dropdelst": "NJ",
    "dropdelzpp": "070329998",
    "dropphyadd": "64 MIDLAND AVE",
    "dropphycty": "KEARNY",
    "dropphyst": "NJ",
    "dropphyzpp": "070329998",
    "dropmaladd": "64 MIDLAND AVE",
    "dropmalcty": "KEARNY",
    "dropmalst": "NJ",
    "dropmalzpp": "070329998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019915629,
    "dropsitcph": 2019915629,
    "dropfax": 6505774005
  },
  {
    "dcode": "D",
    "dropkey": "PV10715",
    "droptype": "D",
    "dropname": "KEASBEY",
    "dropdeladd": "140 SMITH ST STE 1",
    "dropdelcty": "KEASBEY",
    "dropdelst": "NJ",
    "dropdelzpp": "088329998",
    "dropphyadd": "140 SMITH ST STE 1",
    "dropphycty": "KEASBEY",
    "dropphyst": "NJ",
    "dropphyzpp": "088329998",
    "dropmaladd": "140 SMITH ST STE 1",
    "dropmalcty": "KEASBEY",
    "dropmalst": "NJ",
    "dropmalzpp": "088329998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327384444,
    "dropfax": 6505775442
  },
  {
    "dcode": "D",
    "dropkey": "PV10717",
    "droptype": "D",
    "dropname": "KENDALL PARK",
    "dropdeladd": "3124 STATE ROUTE 27",
    "dropdelcty": "KENDALL PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "088249998",
    "dropphyadd": "3124 STATE ROUTE 27",
    "dropphycty": "KENDALL PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "088249998",
    "dropmaladd": "3124 STATE ROUTE 27",
    "dropmalcty": "KENDALL PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "088249998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322979181,
    "dropfax": 6505774047
  },
  {
    "dcode": "D",
    "dropkey": "PV10719",
    "droptype": "D",
    "dropname": "KENILWORTH",
    "dropdeladd": "641 BOULEVARD",
    "dropdelcty": "KENILWORTH",
    "dropdelst": "NJ",
    "dropdelzpp": "070339998",
    "dropphyadd": "641 BOULEVARD",
    "dropphycty": "KENILWORTH",
    "dropphyst": "NJ",
    "dropphyzpp": "070339998",
    "dropmaladd": "641 BOULEVARD",
    "dropmalcty": "KENILWORTH",
    "dropmalst": "NJ",
    "dropmalzpp": "070339998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082419823,
    "dropsitcph": 9082419823,
    "dropfax": 6505774395
  },
  {
    "dcode": "D",
    "dropkey": "PV10720",
    "droptype": "D",
    "dropname": "KENVIL",
    "dropdeladd": "708 US HIGHWAY 46",
    "dropdelcty": "KENVIL",
    "dropdelst": "NJ",
    "dropdelzpp": "078479998",
    "dropphyadd": "708 US HIGHWAY 46",
    "dropphycty": "KENVIL",
    "dropphyst": "NJ",
    "dropphyzpp": "078479998",
    "dropmaladd": "708 US HIGHWAY 46",
    "dropmalcty": "KENVIL",
    "dropmalst": "NJ",
    "dropmalzpp": "078479998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735157868,
    "dropsitcph": 9735844463,
    "dropfax": 6505774057
  },
  {
    "dcode": "D",
    "dropkey": "PV10721",
    "droptype": "D",
    "dropname": "KEYPORT",
    "dropdeladd": "95 W FRONT ST",
    "dropdelcty": "KEYPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "077359998",
    "dropphyadd": "95 W FRONT ST",
    "dropphycty": "KEYPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "077359998",
    "dropmaladd": "95 W FRONT ST",
    "dropmalcty": "KEYPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "077359998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322640388,
    "dropsitcph": 7322640388,
    "dropfax": 7322645853
  },
  {
    "dcode": "D",
    "dropkey": "PV10724",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "4599 ROUTE 27",
    "dropdelcty": "KINGSTON",
    "dropdelst": "NJ",
    "dropdelzpp": "085289998",
    "dropphyadd": "4599 ROUTE 27",
    "dropphycty": "KINGSTON",
    "dropphyst": "NJ",
    "dropphyzpp": "085289998",
    "dropmaladd": "4599 ROUTE 27",
    "dropmalcty": "KINGSTON",
    "dropmalst": "NJ",
    "dropmalzpp": "085289998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099244544,
    "dropsitcph": 6099244544,
    "dropfax": 6096837873
  },
  {
    "dcode": "D",
    "dropkey": "PV10727",
    "droptype": "D",
    "dropname": "VOORHEES",
    "dropdeladd": "504 CENTENNIAL BLVD",
    "dropdelcty": "VOORHEES",
    "dropdelst": "NJ",
    "dropdelzpp": "080439998",
    "dropphyadd": "504 CENTENNIAL BLVD",
    "dropphycty": "VOORHEES",
    "dropphyst": "NJ",
    "dropphyzpp": "080439998",
    "dropmaladd": "504 CENTENNIAL BLVD",
    "dropmalcty": "VOORHEES",
    "dropmalst": "NJ",
    "dropmalzpp": "080439998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564898052,
    "dropsitcph": 8564898052,
    "dropfax": 8564894090
  },
  {
    "dcode": "D",
    "dropkey": "PV10735",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "96 STATE ROUTE 15",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "NJ",
    "dropdelzpp": "078489998",
    "dropphyadd": "96 STATE ROUTE 15",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "NJ",
    "dropphyzpp": "078489998",
    "dropmaladd": "96 STATE ROUTE 15",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "NJ",
    "dropmalzpp": "078489998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733835757,
    "dropsitcph": 9733835757,
    "dropfax": 6505774059
  },
  {
    "dcode": "D",
    "dropkey": "PV10738",
    "droptype": "D",
    "dropname": "LAKE HIAWATHA",
    "dropdeladd": "494 N BEVERWYCK RD",
    "dropdelcty": "LAKE HIAWATHA",
    "dropdelst": "NJ",
    "dropdelzpp": "070349998",
    "dropphyadd": "494 N BEVERWYCK RD",
    "dropphycty": "LAKE HIAWATHA",
    "dropphyst": "NJ",
    "dropphyzpp": "070349998",
    "dropmaladd": "494 N BEVERWYCK RD",
    "dropmalcty": "LAKE HIAWATHA",
    "dropmalst": "NJ",
    "dropmalzpp": "070349998",
    "dropsitphn": 9733347062,
    "dropsitlph": 9733347062,
    "dropsitcph": 9733347062,
    "dropfax": 6505774396
  },
  {
    "dcode": "D",
    "dropkey": "PV10739",
    "droptype": "D",
    "dropname": "LAKE HOPATCONG",
    "dropdeladd": "700 STATE ROUTE 15 S",
    "dropdelcty": "LAKE HOPATCONG",
    "dropdelst": "NJ",
    "dropdelzpp": "078499998",
    "dropphyadd": "700 STATE ROUTE 15 S",
    "dropphycty": "LAKE HOPATCONG",
    "dropphyst": "NJ",
    "dropphyzpp": "078499998",
    "dropmaladd": "700 STATE ROUTE 15 S",
    "dropmalcty": "LAKE HOPATCONG",
    "dropmalst": "NJ",
    "dropmalzpp": "078499998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736633886,
    "dropsitcph": 9736633886,
    "dropfax": 6503576393
  },
  {
    "dcode": "D",
    "dropkey": "PV10745",
    "droptype": "D",
    "dropname": "LAKEHURST",
    "dropdeladd": "1 BROWN AVE",
    "dropdelcty": "LAKEHURST",
    "dropdelst": "NJ",
    "dropdelzpp": "087339998",
    "dropphyadd": "1 BROWN AVE",
    "dropphycty": "LAKEHURST",
    "dropphyst": "NJ",
    "dropphyzpp": "087339998",
    "dropmaladd": "1 BROWN AVE",
    "dropmalcty": "LAKEHURST",
    "dropmalst": "NJ",
    "dropmalzpp": "087339998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7326578562,
    "dropfax": 7326578827
  },
  {
    "dcode": "D",
    "dropkey": "PV10748",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "1820 SWARTHMORE AVE",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "087019998",
    "dropphyadd": "1820 SWARTHMORE AVE",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "087019998",
    "dropmaladd": "1820 SWARTHMORE AVE",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "087019998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323639444,
    "dropfax": 7329010703
  },
  {
    "dcode": "D",
    "dropkey": "PV10750",
    "droptype": "D",
    "dropname": "LAMBERTVILLE",
    "dropdeladd": "10 YORK ST",
    "dropdelcty": "LAMBERTVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "085309998",
    "dropphyadd": "10 YORK ST",
    "dropphycty": "LAMBERTVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "085309998",
    "dropmaladd": "10 YORK ST",
    "dropmalcty": "LAMBERTVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "085309998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093970061,
    "dropsitcph": 6093970061,
    "dropfax": 6093974547
  },
  {
    "dcode": "D",
    "dropkey": "PV10751",
    "droptype": "D",
    "dropname": "LANDING",
    "dropdeladd": "130 LAKESIDE BLVD",
    "dropdelcty": "LANDING",
    "dropdelst": "NJ",
    "dropdelzpp": "078509998",
    "dropphyadd": "130 LAKESIDE BLVD",
    "dropphycty": "LANDING",
    "dropphyst": "NJ",
    "dropphyzpp": "078509998",
    "dropmaladd": "130 LAKESIDE BLVD",
    "dropmalcty": "LANDING",
    "dropmalst": "NJ",
    "dropmalzpp": "078509998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733981177,
    "dropsitcph": 9733981177,
    "dropfax": 6505774079
  },
  {
    "dcode": "D",
    "dropkey": "PV10752",
    "droptype": "D",
    "dropname": "LANDISVILLE",
    "dropdeladd": "101 S HARDING HWY",
    "dropdelcty": "LANDISVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083269998",
    "dropphyadd": "101 S HARDING HWY",
    "dropphycty": "LANDISVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083269998",
    "dropmaladd": "101 S HARDING HWY",
    "dropmalcty": "LANDISVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083269998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566971939,
    "dropsitcph": 8566971939,
    "dropfax": 8566973473
  },
  {
    "dcode": "D",
    "dropkey": "PV10754",
    "droptype": "D",
    "dropname": "LANOKA HARBOR",
    "dropdeladd": "402 US HIGHWAY 9",
    "dropdelcty": "LANOKA HARBOR",
    "dropdelst": "NJ",
    "dropdelzpp": "087349998",
    "dropphyadd": "402 US HIGHWAY 9",
    "dropphycty": "LANOKA HARBOR",
    "dropphyst": "NJ",
    "dropphyzpp": "087349998",
    "dropmaladd": "402 US HIGHWAY 9",
    "dropmalcty": "LANOKA HARBOR",
    "dropmalst": "NJ",
    "dropmalzpp": "087349998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096932373,
    "dropsitcph": 6096932373,
    "dropfax": 6092420763
  },
  {
    "dcode": "D",
    "dropkey": "PV10761",
    "droptype": "D",
    "dropname": "LAVALLETTE",
    "dropdeladd": "1302 GRAND CENTRAL AVE",
    "dropdelcty": "LAVALLETTE",
    "dropdelst": "NJ",
    "dropdelzpp": "087352336",
    "dropphyadd": "1302 GRAND CENTRAL AVE",
    "dropphycty": "LAVALLETTE",
    "dropphyst": "NJ",
    "dropphyzpp": "087352336",
    "dropmaladd": "1302 GRAND CENTRAL AVE",
    "dropmalcty": "LAVALLETTE",
    "dropmalst": "NJ",
    "dropmalzpp": "087352336",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 8482663294,
    "dropfax": 7328301428
  },
  {
    "dcode": "D",
    "dropkey": "PV10762",
    "droptype": "D",
    "dropname": "LAWNSIDE",
    "dropdeladd": "175 WARWICK RD N",
    "dropdelcty": "LAWNSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "080459998",
    "dropphyadd": "175 WARWICK RD N",
    "dropphycty": "LAWNSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "080459998",
    "dropmaladd": "175 WARWICK RD N",
    "dropmalcty": "LAWNSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "080459998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565469419,
    "dropsitcph": 8565469419,
    "dropfax": 8563101233
  },
  {
    "dcode": "D",
    "dropkey": "PV10764",
    "droptype": "D",
    "dropname": "LAYTON",
    "dropdeladd": "122 COUNTY ROAD 560",
    "dropdelcty": "LAYTON",
    "dropdelst": "NJ",
    "dropdelzpp": "078519998",
    "dropphyadd": "122 COUNTY ROAD 560",
    "dropphycty": "LAYTON",
    "dropphyst": "NJ",
    "dropphyzpp": "078519998",
    "dropmaladd": "122 COUNTY ROAD 560",
    "dropmalcty": "LAYTON",
    "dropmalst": "NJ",
    "dropmalzpp": "078512025",
    "dropsitphn": 9735157868,
    "dropsitlph": 9739484359,
    "dropsitcph": 9739484359,
    "dropfax": 6505774073
  },
  {
    "dcode": "D",
    "dropkey": "PV10766",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "1271 US HIGHWAY 22 STE A",
    "dropdelcty": "LEBANON",
    "dropdelst": "NJ",
    "dropdelzpp": "088339998",
    "dropphyadd": "1271 US HIGHWAY 22 STE A",
    "dropphycty": "LEBANON",
    "dropphyst": "NJ",
    "dropphyzpp": "088339998",
    "dropmaladd": "1271 US HIGHWAY 22 STE A",
    "dropmalcty": "LEBANON",
    "dropmalst": "NJ",
    "dropmalzpp": "088339998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9082362101,
    "dropfax": 6505774309
  },
  {
    "dcode": "D",
    "dropkey": "PV10767",
    "droptype": "D",
    "dropname": "LEDGEWOOD",
    "dropdeladd": "1070 US HIGHWAY 46 STE 11",
    "dropdelcty": "LEDGEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "078529998",
    "dropphyadd": "1070 US HIGHWAY 46 STE 11",
    "dropphycty": "LEDGEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "078529998",
    "dropmaladd": "1070 US HIGHWAY 46 STE 11",
    "dropmalcty": "LEDGEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "078529998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735849198,
    "dropsitcph": 9735849198,
    "dropfax": 6505774193
  },
  {
    "dcode": "D",
    "dropkey": "PV10768",
    "droptype": "D",
    "dropname": "LEEDS POINT",
    "dropdeladd": "15 S LEEDS POINT RD",
    "dropdelcty": "LEEDS POINT",
    "dropdelst": "NJ",
    "dropdelzpp": "082209998",
    "dropphyadd": "15 S LEEDS POINT RD",
    "dropphycty": "LEEDS POINT",
    "dropphyst": "NJ",
    "dropphyzpp": "082209998",
    "dropmaladd": "15 S LEEDS POINT RD",
    "dropmalcty": "LEEDS POINT",
    "dropmalst": "NJ",
    "dropmalzpp": "082209998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096520762,
    "dropsitcph": 6096520762,
    "dropfax": 6097483415
  },
  {
    "dcode": "D",
    "dropkey": "PV10770",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "174 HIGH ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "083279998",
    "dropphyadd": "174 HIGH ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "083279998",
    "dropmaladd": "174 HIGH ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "083279998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567850300,
    "dropsitcph": 8567850300,
    "dropfax": 8567850300
  },
  {
    "dcode": "D",
    "dropkey": "PV10772",
    "droptype": "D",
    "dropname": "LEONARDO",
    "dropdeladd": "60 THOMPSON AVE",
    "dropdelcty": "LEONARDO",
    "dropdelst": "NJ",
    "dropdelzpp": "077379998",
    "dropphyadd": "60 THOMPSON AVE",
    "dropphycty": "LEONARDO",
    "dropphyst": "NJ",
    "dropphyzpp": "077379998",
    "dropmaladd": "60 THOMPSON AVE",
    "dropmalcty": "LEONARDO",
    "dropmalst": "NJ",
    "dropmalzpp": "077379998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322912556,
    "dropsitcph": 7322912556,
    "dropfax": 7322912882
  },
  {
    "dcode": "D",
    "dropkey": "PV10774",
    "droptype": "D",
    "dropname": "LIBERTY CORNER",
    "dropdeladd": "8 CHURCH ST",
    "dropdelcty": "LIBERTY CORNER",
    "dropdelst": "NJ",
    "dropdelzpp": "079389800",
    "dropphyadd": "8 CHURCH ST",
    "dropphycty": "LIBERTY CORNER",
    "dropphyst": "NJ",
    "dropphyzpp": "079389800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTY CORNER",
    "dropmalst": "NJ",
    "dropmalzpp": "079389998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086470841,
    "dropsitcph": 9086470841,
    "dropfax": 6505774366
  },
  {
    "dcode": "D",
    "dropkey": "PV10775",
    "droptype": "D",
    "dropname": "LINCOLN PARK",
    "dropdeladd": "9 ZELIFF PL",
    "dropdelcty": "LINCOLN PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "070359998",
    "dropphyadd": "9 ZELIFF PL",
    "dropphycty": "LINCOLN PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "070359998",
    "dropmaladd": "9 ZELIFF PL",
    "dropmalcty": "LINCOLN PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "070359998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736941627,
    "dropsitcph": 9736941627,
    "dropfax": 6505774405
  },
  {
    "dcode": "D",
    "dropkey": "PV10776",
    "droptype": "D",
    "dropname": "LINCROFT",
    "dropdeladd": "774 NEWMAN SPRINGS RD",
    "dropdelcty": "LINCROFT",
    "dropdelst": "NJ",
    "dropdelzpp": "077389998",
    "dropphyadd": "774 NEWMAN SPRINGS RD",
    "dropphycty": "LINCROFT",
    "dropphyst": "NJ",
    "dropphyzpp": "077389998",
    "dropmaladd": "774 NEWMAN SPRINGS RD",
    "dropmalcty": "LINCROFT",
    "dropmalst": "NJ",
    "dropmalzpp": "077389998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327475115,
    "dropsitcph": 7327475115,
    "dropfax": 7322195824
  },
  {
    "dcode": "D",
    "dropkey": "PV10777",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "400 N WOOD AVE STE A",
    "dropdelcty": "LINDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070369998",
    "dropphyadd": "400 N WOOD AVE STE A",
    "dropphycty": "LINDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070369998",
    "dropmaladd": "400 N WOOD AVE STE A",
    "dropmalcty": "LINDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070369998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9089258836,
    "dropsitcph": 9089258836,
    "dropfax": 6505774403
  },
  {
    "dcode": "D",
    "dropkey": "PV10780",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "1103 SHORE RD",
    "dropdelcty": "LINWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "082219998",
    "dropphyadd": "1103 SHORE RD",
    "dropphycty": "LINWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "082219998",
    "dropmaladd": "1103 SHORE RD",
    "dropmalcty": "LINWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "082219998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099274881,
    "dropsitcph": 6099274881,
    "dropfax": 6099271254
  },
  {
    "dcode": "D",
    "dropkey": "PV10783",
    "droptype": "D",
    "dropname": "LITTLE FALLS",
    "dropdeladd": "229 MAIN ST",
    "dropdelcty": "LITTLE FALLS",
    "dropdelst": "NJ",
    "dropdelzpp": "074249998",
    "dropphyadd": "229 MAIN ST",
    "dropphycty": "LITTLE FALLS",
    "dropphyst": "NJ",
    "dropphyzpp": "074249998",
    "dropmaladd": "229 MAIN ST",
    "dropmalcty": "LITTLE FALLS",
    "dropmalst": "NJ",
    "dropmalzpp": "074249998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738261101,
    "dropsitcph": 9738261101,
    "dropfax": 6505774132
  },
  {
    "dcode": "D",
    "dropkey": "PV10784",
    "droptype": "D",
    "dropname": "LITTLE FERRY",
    "dropdeladd": "20 MAIN ST",
    "dropdelcty": "LITTLE FERRY",
    "dropdelst": "NJ",
    "dropdelzpp": "076439998",
    "dropphyadd": "20 MAIN ST",
    "dropphycty": "LITTLE FERRY",
    "dropphyst": "NJ",
    "dropphyzpp": "076439998",
    "dropmaladd": "20 MAIN ST",
    "dropmalcty": "LITTLE FERRY",
    "dropmalst": "NJ",
    "dropmalzpp": "076439998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016417843,
    "dropsitcph": 2016417843,
    "dropfax": 6505774397
  },
  {
    "dcode": "D",
    "dropkey": "PV10787",
    "droptype": "D",
    "dropname": "LITTLE SILVER",
    "dropdeladd": "20 CHURCH ST",
    "dropdelcty": "LITTLE SILVER",
    "dropdelst": "NJ",
    "dropdelzpp": "077399998",
    "dropphyadd": "20 CHURCH ST",
    "dropphycty": "LITTLE SILVER",
    "dropphyst": "NJ",
    "dropphyzpp": "077399998",
    "dropmaladd": "20 CHURCH ST",
    "dropmalcty": "LITTLE SILVER",
    "dropmalst": "NJ",
    "dropmalzpp": "077399998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327417947,
    "dropsitcph": 7327417947,
    "dropfax": 7329339667
  },
  {
    "dcode": "D",
    "dropkey": "PV10791",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "49 W MOUNT PLEASANT AVE",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070399998",
    "dropphyadd": "49 W MOUNT PLEASANT AVE",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070399998",
    "dropmaladd": "49 W MOUNT PLEASANT AVE",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070399998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9739928401,
    "dropsitcph": 9739928401,
    "dropfax": 6505774370
  },
  {
    "dcode": "D",
    "dropkey": "PV10798",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "25 WASHINGTON ST STE 1",
    "dropdelcty": "LODI",
    "dropdelst": "NJ",
    "dropdelzpp": "076449998",
    "dropphyadd": "25 WASHINGTON ST STE 1",
    "dropphycty": "LODI",
    "dropphyst": "NJ",
    "dropphyzpp": "076449998",
    "dropmaladd": "25 WASHINGTON ST STE 1",
    "dropmalcty": "LODI",
    "dropmalst": "NJ",
    "dropmalzpp": "076449998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737799423,
    "dropsitcph": 9737799423,
    "dropfax": 6505774343
  },
  {
    "dcode": "D",
    "dropkey": "PV10802",
    "droptype": "D",
    "dropname": "LONG BRANCH",
    "dropdeladd": "60 3RD AVE",
    "dropdelcty": "LONG BRANCH",
    "dropdelst": "NJ",
    "dropdelzpp": "077409998",
    "dropphyadd": "60 3RD AVE",
    "dropphycty": "LONG BRANCH",
    "dropphyst": "NJ",
    "dropphyzpp": "077409998",
    "dropmaladd": "60 3RD AVE",
    "dropmalcty": "LONG BRANCH",
    "dropmalst": "NJ",
    "dropmalzpp": "077409998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322227711,
    "dropsitcph": 7322227711,
    "dropfax": 7322226908
  },
  {
    "dcode": "D",
    "dropkey": "PV10803",
    "droptype": "D",
    "dropname": "LONG VALLEY",
    "dropdeladd": "3 OLD FARMERS RD",
    "dropdelcty": "LONG VALLEY",
    "dropdelst": "NJ",
    "dropdelzpp": "078539998",
    "dropphyadd": "3 OLD FARMERS RD",
    "dropphycty": "LONG VALLEY",
    "dropphyst": "NJ",
    "dropphyzpp": "078539998",
    "dropmaladd": "3 OLD FARMERS RD",
    "dropmalcty": "LONG VALLEY",
    "dropmalst": "NJ",
    "dropmalzpp": "078539998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9738763161,
    "dropsitcph": 9088763161,
    "dropfax": 6516751565
  },
  {
    "dcode": "D",
    "dropkey": "PV10813",
    "droptype": "D",
    "dropname": "LUMBERTON",
    "dropdeladd": "702 MAIN ST",
    "dropdelcty": "LUMBERTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080489998",
    "dropphyadd": "702 MAIN ST",
    "dropphycty": "LUMBERTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080489998",
    "dropmaladd": "702 MAIN ST",
    "dropmalcty": "LUMBERTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080489998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092674021,
    "dropsitcph": 6092674021,
    "dropfax": 6095189210
  },
  {
    "dcode": "D",
    "dropkey": "PV10818",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "10 LINCOLN PL",
    "dropdelcty": "MADISON",
    "dropdelst": "NJ",
    "dropdelzpp": "079409998",
    "dropphyadd": "10 LINCOLN PL",
    "dropphycty": "MADISON",
    "dropphyst": "NJ",
    "dropphyzpp": "079409998",
    "dropmaladd": "10 LINCOLN PL",
    "dropmalcty": "MADISON",
    "dropmalst": "NJ",
    "dropmalzpp": "079409998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736609636,
    "dropsitcph": 9736609636,
    "dropfax": 6516751591
  },
  {
    "dcode": "D",
    "dropkey": "PV10819",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "307 E MONROE AVE",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "NJ",
    "dropdelzpp": "080499998",
    "dropphyadd": "307 E MONROE AVE",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "NJ",
    "dropphyzpp": "080499998",
    "dropmaladd": "307 E MONROE AVE",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "NJ",
    "dropmalzpp": "080499998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567836455,
    "dropsitcph": 8567836455,
    "dropfax": 8564358487
  },
  {
    "dcode": "D",
    "dropkey": "PV10820",
    "droptype": "D",
    "dropname": "MAHWAH",
    "dropdeladd": "1037 MACARTHUR BLVD",
    "dropdelcty": "MAHWAH",
    "dropdelst": "NJ",
    "dropdelzpp": "074303620",
    "dropphyadd": "1037 MACARTHUR BLVD",
    "dropphycty": "MAHWAH",
    "dropphyst": "NJ",
    "dropphyzpp": "074303620",
    "dropmaladd": "1037 MACARTHUR BLVD",
    "dropmalcty": "MAHWAH",
    "dropmalst": "NJ",
    "dropmalzpp": "074303620",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015129928,
    "dropsitcph": 2015129928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10824",
    "droptype": "D",
    "dropname": "MALAGA",
    "dropdeladd": "603 DELSEA DR",
    "dropdelcty": "MALAGA",
    "dropdelst": "NJ",
    "dropdelzpp": "083289998",
    "dropphyadd": "603 DELSEA DR",
    "dropphycty": "MALAGA",
    "dropphyst": "NJ",
    "dropphyzpp": "083289998",
    "dropmaladd": "603 DELSEA DR",
    "dropmalcty": "MALAGA",
    "dropmalst": "NJ",
    "dropmalzpp": "083289998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566942800,
    "dropsitcph": 8566942800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10825",
    "droptype": "D",
    "dropname": "MANAHAWKIN",
    "dropdeladd": "525 E BAY AVE",
    "dropdelcty": "MANAHAWKIN",
    "dropdelst": "NJ",
    "dropdelzpp": "080509998",
    "dropphyadd": "525 E BAY AVE",
    "dropphycty": "MANAHAWKIN",
    "dropphyst": "NJ",
    "dropphyzpp": "080509998",
    "dropmaladd": "525 E BAY AVE",
    "dropmalcty": "MANAHAWKIN",
    "dropmalst": "NJ",
    "dropmalzpp": "080509998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099782192,
    "dropsitcph": 6099782192,
    "dropfax": 6095970637
  },
  {
    "dcode": "D",
    "dropkey": "PV10828",
    "droptype": "D",
    "dropname": "MANASQUAN",
    "dropdeladd": "43 ABE VOORHEES DR",
    "dropdelcty": "MANASQUAN",
    "dropdelst": "NJ",
    "dropdelzpp": "087369998",
    "dropphyadd": "43 ABE VOORHEES DR",
    "dropphycty": "MANASQUAN",
    "dropphyst": "NJ",
    "dropphyzpp": "087369998",
    "dropmaladd": "43 ABE VOORHEES DR",
    "dropmalcty": "MANASQUAN",
    "dropmalst": "NJ",
    "dropmalzpp": "087369998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322231259,
    "dropfax": 7322230893
  },
  {
    "dcode": "D",
    "dropkey": "PV10833",
    "droptype": "D",
    "dropname": "MANTOLOKING",
    "dropdeladd": "207 DOWNER AVE",
    "dropdelcty": "MANTOLOKING",
    "dropdelst": "NJ",
    "dropdelzpp": "087389998",
    "dropphyadd": "207 DOWNER AVE",
    "dropphycty": "MANTOLOKING",
    "dropphyst": "NJ",
    "dropphyzpp": "087389998",
    "dropmaladd": "207 DOWNER AVE",
    "dropmalcty": "MANTOLOKING",
    "dropmalst": "NJ",
    "dropmalzpp": "087389998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7323897121,
    "dropsitcph": 7328990800,
    "dropfax": 7328998722
  },
  {
    "dcode": "D",
    "dropkey": "PV10834",
    "droptype": "D",
    "dropname": "MANTUA",
    "dropdeladd": "20 MANTUA BLVD",
    "dropdelcty": "MANTUA",
    "dropdelst": "NJ",
    "dropdelzpp": "080519998",
    "dropphyadd": "20 MANTUA BLVD",
    "dropphycty": "MANTUA",
    "dropphyst": "NJ",
    "dropphyzpp": "080519998",
    "dropmaladd": "20 MANTUA BLVD",
    "dropmalcty": "MANTUA",
    "dropmalst": "NJ",
    "dropmalzpp": "080519998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564681600,
    "dropsitcph": 8564681600,
    "dropfax": 8564682140
  },
  {
    "dcode": "D",
    "dropkey": "PV10836",
    "droptype": "D",
    "dropname": "MANVILLE",
    "dropdeladd": "101 BROOKS BLVD",
    "dropdelcty": "MANVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "088359998",
    "dropphyadd": "101 BROOKS BLVD",
    "dropphycty": "MANVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "088359998",
    "dropmaladd": "101 BROOKS BLVD",
    "dropmalcty": "MANVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "088359998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087252184,
    "dropfax": 6503576470
  },
  {
    "dcode": "D",
    "dropkey": "PV10838",
    "droptype": "D",
    "dropname": "MAPLE SHADE",
    "dropdeladd": "1 E MAIN ST",
    "dropdelcty": "MAPLE SHADE",
    "dropdelst": "NJ",
    "dropdelzpp": "080529998",
    "dropphyadd": "1 E MAIN ST",
    "dropphycty": "MAPLE SHADE",
    "dropphyst": "NJ",
    "dropphyzpp": "080529998",
    "dropmaladd": "1 E MAIN ST",
    "dropmalcty": "MAPLE SHADE",
    "dropmalst": "NJ",
    "dropmalzpp": "080529998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567797176,
    "dropsitcph": 8567797176,
    "dropfax": 8567790473
  },
  {
    "dcode": "D",
    "dropkey": "PV10841",
    "droptype": "D",
    "dropname": "MAPLEWOOD",
    "dropdeladd": "195 MAPLEWOOD AVE STE 1",
    "dropdelcty": "MAPLEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "070409998",
    "dropphyadd": "195 MAPLEWOOD AVE STE 1",
    "dropphycty": "MAPLEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "070409998",
    "dropmaladd": "195 MAPLEWOOD AVE STE 1",
    "dropmalcty": "MAPLEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "070409998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737635841,
    "dropsitcph": 9737635841,
    "dropfax": 6505774248
  },
  {
    "dcode": "D",
    "dropkey": "PV10845",
    "droptype": "D",
    "dropname": "MARLBORO",
    "dropdeladd": "8 S MAIN ST STE 1",
    "dropdelcty": "MARLBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "077469998",
    "dropphyadd": "8 S MAIN ST STE 1",
    "dropphycty": "MARLBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "077469998",
    "dropmaladd": "8 S MAIN ST STE 1",
    "dropmalcty": "MARLBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "077469998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324622980,
    "dropsitcph": 7324622980,
    "dropfax": 7322940453
  },
  {
    "dcode": "D",
    "dropkey": "PV10847",
    "droptype": "D",
    "dropname": "MARLTON",
    "dropdeladd": "123 E MAIN ST",
    "dropdelcty": "MARLTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080539998",
    "dropphyadd": "123 E MAIN ST",
    "dropphycty": "MARLTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080539998",
    "dropmaladd": "123 E MAIN ST",
    "dropmalcty": "MARLTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080539998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569830352,
    "dropsitcph": 8569830352,
    "dropfax": 8569856265
  },
  {
    "dcode": "D",
    "dropkey": "PV10849",
    "droptype": "D",
    "dropname": "MARMORA",
    "dropdeladd": "120 TUCKAHOE RD",
    "dropdelcty": "MARMORA",
    "dropdelst": "NJ",
    "dropdelzpp": "082239998",
    "dropphyadd": "120 TUCKAHOE RD",
    "dropphycty": "MARMORA",
    "dropphyst": "NJ",
    "dropphyzpp": "082239998",
    "dropmaladd": "120 TUCKAHOE RD",
    "dropmalcty": "MARMORA",
    "dropmalst": "NJ",
    "dropmalzpp": "082239998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093901368,
    "dropsitcph": 6093901368,
    "dropfax": 6093907819
  },
  {
    "dcode": "D",
    "dropkey": "PV10850",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "1990 WASHINGTON VALLEY RD",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "088369998",
    "dropphyadd": "1990 WASHINGTON VALLEY RD",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "088369998",
    "dropmaladd": "1990 WASHINGTON VALLEY RD",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "088369998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7324692080,
    "dropfax": 6505775456
  },
  {
    "dcode": "D",
    "dropkey": "PV10853",
    "droptype": "D",
    "dropname": "MATAWAN",
    "dropdeladd": "155 MAIN ST",
    "dropdelcty": "MATAWAN",
    "dropdelst": "NJ",
    "dropdelzpp": "077479998",
    "dropphyadd": "155 MAIN ST",
    "dropphycty": "MATAWAN",
    "dropphyst": "NJ",
    "dropphyzpp": "077479998",
    "dropmaladd": "155 MAIN ST",
    "dropmalcty": "MATAWAN",
    "dropmalst": "NJ",
    "dropmalzpp": "077479998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325660854,
    "dropsitcph": 7325660854,
    "dropfax": 7325667313
  },
  {
    "dcode": "D",
    "dropkey": "PV10855",
    "droptype": "D",
    "dropname": "MAURICETOWN",
    "dropdeladd": "9572 HIGHLAND ST",
    "dropdelcty": "MAURICETOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "083299998",
    "dropphyadd": "9572 HIGHLAND ST",
    "dropphycty": "MAURICETOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "083299998",
    "dropmaladd": "9572 HIGHLAND ST",
    "dropmalcty": "MAURICETOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "083299998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567850050,
    "dropsitcph": 8567850050,
    "dropfax": 8567851823
  },
  {
    "dcode": "D",
    "dropkey": "PV10858",
    "droptype": "D",
    "dropname": "MAYS LANDING",
    "dropdeladd": "5306 ATLANTIC AVE",
    "dropdelcty": "MAYS LANDING",
    "dropdelst": "NJ",
    "dropdelzpp": "083309998",
    "dropphyadd": "5306 ATLANTIC AVE",
    "dropphycty": "MAYS LANDING",
    "dropphyst": "NJ",
    "dropphyzpp": "083309998",
    "dropmaladd": "5306 ATLANTIC AVE",
    "dropmalcty": "MAYS LANDING",
    "dropmalst": "NJ",
    "dropmalzpp": "083309998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096255680,
    "dropsitcph": 6096255680,
    "dropfax": 6096257985
  },
  {
    "dcode": "D",
    "dropkey": "PV10862",
    "droptype": "D",
    "dropname": "MC AFEE",
    "dropdeladd": "40 STATE RT 94",
    "dropdelcty": "MC AFEE",
    "dropdelst": "NJ",
    "dropdelzpp": "074289800",
    "dropphyadd": "40 STATE RT 94",
    "dropphycty": "MC AFEE",
    "dropphyst": "NJ",
    "dropphyzpp": "074289800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC AFEE",
    "dropmalst": "NJ",
    "dropmalzpp": "074289998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738278071,
    "dropsitcph": 9738278071,
    "dropfax": 6505774910
  },
  {
    "dcode": "D",
    "dropkey": "PV10872",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "326 STOKES RD",
    "dropdelcty": "MEDFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "080559998",
    "dropphyadd": "326 STOKES RD",
    "dropphycty": "MEDFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "080559998",
    "dropmaladd": "326 STOKES RD",
    "dropmalcty": "MEDFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "080559998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096541362,
    "dropsitcph": 6096541362,
    "dropfax": 6096548647
  },
  {
    "dcode": "D",
    "dropkey": "PV10876",
    "droptype": "D",
    "dropname": "MENDHAM",
    "dropdeladd": "2 TEMPE WICK RD",
    "dropdelcty": "MENDHAM",
    "dropdelst": "NJ",
    "dropdelzpp": "079459998",
    "dropphyadd": "2 TEMPE WICK RD",
    "dropphycty": "MENDHAM",
    "dropphyst": "NJ",
    "dropphyzpp": "079459998",
    "dropmaladd": "2 TEMPE WICK RD",
    "dropmalcty": "MENDHAM",
    "dropmalst": "NJ",
    "dropmalzpp": "079459998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735434777,
    "dropsitcph": 9735434777,
    "dropfax": 6505774213
  },
  {
    "dcode": "D",
    "dropkey": "PV10889",
    "droptype": "D",
    "dropname": "METUCHEN",
    "dropdeladd": "360 MAIN ST",
    "dropdelcty": "METUCHEN",
    "dropdelst": "NJ",
    "dropdelzpp": "088409998",
    "dropphyadd": "360 MAIN ST",
    "dropphycty": "METUCHEN",
    "dropphyst": "NJ",
    "dropphyzpp": "088409998",
    "dropmaladd": "360 MAIN ST",
    "dropmalcty": "METUCHEN",
    "dropmalst": "NJ",
    "dropmalzpp": "088409998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325495511,
    "dropfax": 6505775457
  },
  {
    "dcode": "D",
    "dropkey": "PV10891",
    "droptype": "D",
    "dropname": "MICKLETON",
    "dropdeladd": "159 DEMOCRAT RD STE A",
    "dropdelcty": "MICKLETON",
    "dropdelst": "NJ",
    "dropdelzpp": "080569998",
    "dropphyadd": "159 DEMOCRAT RD STE A",
    "dropphycty": "MICKLETON",
    "dropphyst": "NJ",
    "dropphyzpp": "080569998",
    "dropmaladd": "159 DEMOCRAT RD STE A",
    "dropmalcty": "MICKLETON",
    "dropmalst": "NJ",
    "dropmalzpp": "080569998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564232373,
    "dropsitcph": 8564232373,
    "dropfax": 8564230679
  },
  {
    "dcode": "D",
    "dropkey": "PV10894",
    "droptype": "D",
    "dropname": "MIDDLESEX",
    "dropdeladd": "95 MARLBOROUGH AVE",
    "dropdelcty": "MIDDLESEX",
    "dropdelst": "NJ",
    "dropdelzpp": "088469998",
    "dropphyadd": "95 MARLBOROUGH AVE",
    "dropphycty": "MIDDLESEX",
    "dropphyst": "NJ",
    "dropphyzpp": "088469998",
    "dropmaladd": "95 MARLBOROUGH AVE",
    "dropmalcty": "MIDDLESEX",
    "dropmalst": "NJ",
    "dropmalzpp": "088469998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323562100,
    "dropfax": 6505775458
  },
  {
    "dcode": "D",
    "dropkey": "PV10895",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "1601 STATE ROUTE 35",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "077489998",
    "dropphyadd": "1601 STATE ROUTE 35",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "077489998",
    "dropmaladd": "1601 STATE ROUTE 35",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "077489998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7326711365,
    "dropsitcph": 7326711365,
    "dropfax": 7326711146
  },
  {
    "dcode": "D",
    "dropkey": "PV10897",
    "droptype": "D",
    "dropname": "MIDDLEVILLE",
    "dropdeladd": "904 COUNTY ROAD 521",
    "dropdelcty": "MIDDLEVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "078559800",
    "dropphyadd": "904 COUNTY ROAD 521",
    "dropphycty": "MIDDLEVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "078559800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "078559998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733838544,
    "dropsitcph": 9733838544,
    "dropfax": 6505774058
  },
  {
    "dcode": "D",
    "dropkey": "PV10899",
    "droptype": "D",
    "dropname": "MIDLAND PARK",
    "dropdeladd": "215 GODWIN AVE",
    "dropdelcty": "MIDLAND PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "074329998",
    "dropphyadd": "215 GODWIN AVE",
    "dropphycty": "MIDLAND PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "074329998",
    "dropmaladd": "215 GODWIN AVE",
    "dropmalcty": "MIDLAND PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "074329998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2014478927,
    "dropsitcph": 2014478927,
    "dropfax": 6505774207
  },
  {
    "dcode": "D",
    "dropkey": "PV10906",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "73 BRIDGE ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "088489998",
    "dropphyadd": "73 BRIDGE ST",
    "dropphycty": "MILFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "088489998",
    "dropmaladd": "73 BRIDGE ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "088489998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9089954211,
    "dropfax": 6505775459
  },
  {
    "dcode": "D",
    "dropkey": "PV10909",
    "droptype": "D",
    "dropname": "MILLBURN",
    "dropdeladd": "300 MILLBURN AVE",
    "dropdelcty": "MILLBURN",
    "dropdelst": "NJ",
    "dropdelzpp": "070419998",
    "dropphyadd": "300 MILLBURN AVE",
    "dropphycty": "MILLBURN",
    "dropphyst": "NJ",
    "dropphyzpp": "070419998",
    "dropmaladd": "300 MILLBURN AVE",
    "dropmalcty": "MILLBURN",
    "dropmalst": "NJ",
    "dropmalzpp": "070419998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733762966,
    "dropsitcph": 9733762966,
    "dropfax": 6505774365
  },
  {
    "dcode": "D",
    "dropkey": "PV10911",
    "droptype": "D",
    "dropname": "MILLINGTON",
    "dropdeladd": "1936 LONG HILL RD",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "079469998",
    "dropphyadd": "1936 LONG HILL RD",
    "dropphycty": "MILLINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "079469998",
    "dropmaladd": "1936 LONG HILL RD",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "079469998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086471279,
    "dropsitcph": 9086471279,
    "dropfax": 6505774349
  },
  {
    "dcode": "D",
    "dropkey": "PV10914",
    "droptype": "D",
    "dropname": "MILLTOWN",
    "dropdeladd": "27 WASHINGTON AVE",
    "dropdelcty": "MILLTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088509998",
    "dropphyadd": "27 WASHINGTON AVE",
    "dropphycty": "MILLTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088509998",
    "dropmaladd": "27 WASHINGTON AVE",
    "dropmalcty": "MILLTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088509998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328281171,
    "dropfax": 6505775460
  },
  {
    "dcode": "D",
    "dropkey": "PV10916",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "302 HIGH ST N",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083329998",
    "dropphyadd": "302 HIGH ST N",
    "dropphycty": "MILLVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083329998",
    "dropmaladd": "302 HIGH ST N",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083329998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568257091,
    "dropsitcph": 8568257091,
    "dropfax": 8568252279
  },
  {
    "dcode": "D",
    "dropkey": "PV10917",
    "droptype": "D",
    "dropname": "MILMAY",
    "dropdeladd": "225 BROAD ST",
    "dropdelcty": "MILMAY",
    "dropdelst": "NJ",
    "dropdelzpp": "083409998",
    "dropphyadd": "225 BROAD ST",
    "dropphycty": "MILMAY",
    "dropphyst": "NJ",
    "dropphyzpp": "083409998",
    "dropmaladd": "225 BROAD ST",
    "dropmalcty": "MILMAY",
    "dropmalst": "NJ",
    "dropmalzpp": "083409998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094763215,
    "dropsitcph": 6094763215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10921",
    "droptype": "D",
    "dropname": "MINOTOLA",
    "dropdeladd": "807 CENTRAL AVE",
    "dropdelcty": "MINOTOLA",
    "dropdelst": "NJ",
    "dropdelzpp": "083419998",
    "dropphyadd": "807 CENTRAL AVE",
    "dropphycty": "MINOTOLA",
    "dropphyst": "NJ",
    "dropphyzpp": "083419998",
    "dropmaladd": "807 CENTRAL AVE",
    "dropmalcty": "MINOTOLA",
    "dropmalst": "NJ",
    "dropmalzpp": "083419998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566972232,
    "dropsitcph": 8566972232,
    "dropfax": 8566975058
  },
  {
    "dcode": "D",
    "dropkey": "PV10922",
    "droptype": "D",
    "dropname": "MIZPAH",
    "dropdeladd": "6442 DEHIRSCH AVE",
    "dropdelcty": "MIZPAH",
    "dropdelst": "NJ",
    "dropdelzpp": "083429998",
    "dropphyadd": "6442 DEHIRSCH AVE",
    "dropphycty": "MIZPAH",
    "dropphyst": "NJ",
    "dropphyzpp": "083429998",
    "dropmaladd": "6442 DEHIRSCH AVE",
    "dropmalcty": "MIZPAH",
    "dropmalst": "NJ",
    "dropmalzpp": "083429998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094762261,
    "dropsitcph": 6094762261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV10928",
    "droptype": "D",
    "dropname": "MONMOUTH BEACH",
    "dropdeladd": "36 BEACH RD STE 8",
    "dropdelcty": "MONMOUTH BEACH",
    "dropdelst": "NJ",
    "dropdelzpp": "077509998",
    "dropphyadd": "36 BEACH RD STE 8",
    "dropphycty": "MONMOUTH BEACH",
    "dropphyst": "NJ",
    "dropphyzpp": "077509998",
    "dropmaladd": "36 BEACH RD STE 8",
    "dropmalcty": "MONMOUTH BEACH",
    "dropmalst": "NJ",
    "dropmalzpp": "077509998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322224521,
    "dropsitcph": 7322224521,
    "dropfax": 7327281673
  },
  {
    "dcode": "D",
    "dropkey": "PV10931",
    "droptype": "D",
    "dropname": "MONMOUTH JUNCTION",
    "dropdeladd": "651 RIDGE RD",
    "dropdelcty": "MONMOUTH JUNCTION",
    "dropdelst": "NJ",
    "dropdelzpp": "088529998",
    "dropphyadd": "651 RIDGE RD",
    "dropphycty": "MONMOUTH JUNCTION",
    "dropphyst": "NJ",
    "dropphyzpp": "088529998",
    "dropmaladd": "651 RIDGE RD",
    "dropmalcty": "MONMOUTH JUNCTION",
    "dropmalst": "NJ",
    "dropmalzpp": "088529998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323296701,
    "dropfax": 6505775461
  },
  {
    "dcode": "D",
    "dropkey": "PV10937",
    "droptype": "D",
    "dropname": "MONROEVILLE",
    "dropdeladd": "403 MONROEVILLE RD",
    "dropdelcty": "MONROEVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083439998",
    "dropphyadd": "403 MONROEVILLE RD",
    "dropphycty": "MONROEVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083439998",
    "dropmaladd": "403 MONROEVILLE RD",
    "dropmalcty": "MONROEVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083439998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8563582005,
    "dropsitcph": 8563582005,
    "dropfax": 8563586142
  },
  {
    "dcode": "D",
    "dropkey": "PV10940",
    "droptype": "D",
    "dropname": "MONTCLAIR",
    "dropdeladd": "125 GLENRIDGE AVE",
    "dropdelcty": "MONTCLAIR",
    "dropdelst": "NJ",
    "dropdelzpp": "070429998",
    "dropphyadd": "125 GLENRIDGE AVE",
    "dropphycty": "MONTCLAIR",
    "dropphyst": "NJ",
    "dropphyzpp": "070429998",
    "dropmaladd": "125 GLENRIDGE AVE",
    "dropmalcty": "MONTCLAIR",
    "dropmalst": "NJ",
    "dropmalzpp": "070429998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9738739017,
    "dropsitcph": 9738739017,
    "dropfax": 6505774377
  },
  {
    "dcode": "D",
    "dropkey": "PV10942",
    "droptype": "D",
    "dropname": "MONTVALE",
    "dropdeladd": "22 W GRAND AVE",
    "dropdelcty": "MONTVALE",
    "dropdelst": "NJ",
    "dropdelzpp": "076459998",
    "dropphyadd": "22 W GRAND AVE",
    "dropphycty": "MONTVALE",
    "dropphyst": "NJ",
    "dropphyzpp": "076459998",
    "dropmaladd": "22 W GRAND AVE",
    "dropmalcty": "MONTVALE",
    "dropmalst": "NJ",
    "dropmalzpp": "076459998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013911967,
    "dropsitcph": 2013911967,
    "dropfax": 6505774360
  },
  {
    "dcode": "D",
    "dropkey": "PV10943",
    "droptype": "D",
    "dropname": "MONTVILLE",
    "dropdeladd": "16 SKYLINE DR",
    "dropdelcty": "MONTVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "070459998",
    "dropphyadd": "16 SKYLINE DR",
    "dropphycty": "MONTVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "070459998",
    "dropmaladd": "16 SKYLINE DR",
    "dropmalcty": "MONTVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "070459998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733351748,
    "dropsitcph": 9733351748,
    "dropfax": 6505774215
  },
  {
    "dcode": "D",
    "dropkey": "PV10946",
    "droptype": "D",
    "dropname": "MOORESTOWN",
    "dropdeladd": "200 CHESTER AVE STE 1",
    "dropdelcty": "MOORESTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080579998",
    "dropphyadd": "200 CHESTER AVE STE 1",
    "dropphycty": "MOORESTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080579998",
    "dropmaladd": "200 CHESTER AVE STE 1",
    "dropmalcty": "MOORESTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080579998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568029665,
    "dropsitcph": 8568029665,
    "dropfax": 8567787292
  },
  {
    "dcode": "D",
    "dropkey": "PV10950",
    "droptype": "D",
    "dropname": "MORGANVILLE",
    "dropdeladd": "113 TENNENT RD",
    "dropdelcty": "MORGANVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "077519998",
    "dropphyadd": "113 TENNENT RD",
    "dropphycty": "MORGANVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "077519998",
    "dropmaladd": "113 TENNENT RD",
    "dropmalcty": "MORGANVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "077519998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325912440,
    "dropsitcph": 7325912440,
    "dropfax": 7325918927
  },
  {
    "dcode": "D",
    "dropkey": "PV10953",
    "droptype": "D",
    "dropname": "MORRIS PLAINS",
    "dropdeladd": "485 SPEEDWELL AVE",
    "dropdelcty": "MORRIS PLAINS",
    "dropdelst": "NJ",
    "dropdelzpp": "079509998",
    "dropphyadd": "485 SPEEDWELL AVE",
    "dropphycty": "MORRIS PLAINS",
    "dropphyst": "NJ",
    "dropphyzpp": "079509998",
    "dropmaladd": "485 SPEEDWELL AVE",
    "dropmalcty": "MORRIS PLAINS",
    "dropmalst": "NJ",
    "dropmalzpp": "079509998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735383666,
    "dropsitcph": 9735383666,
    "dropfax": 6516751587
  },
  {
    "dcode": "D",
    "dropkey": "PV10956",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "166 RIDGEDALE AVE STE 9",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "079604085",
    "dropphyadd": "166 RIDGEDALE AVE STE 9",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "079604085",
    "dropmaladd": "166 RIDGEDALE AVE STE 9",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "079604085",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735395890,
    "dropsitcph": 9735395890,
    "dropfax": 6516751571
  },
  {
    "dcode": "D",
    "dropkey": "PV10958",
    "droptype": "D",
    "dropname": "MOUNT ARLINGTON",
    "dropdeladd": "385 HOWARD BLVD",
    "dropdelcty": "MOUNT ARLINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "078561112",
    "dropphyadd": "385 HOWARD BLVD",
    "dropphycty": "MOUNT ARLINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "078561112",
    "dropmaladd": "385 HOWARD BLVD",
    "dropmalcty": "MOUNT ARLINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "078561112",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733988022,
    "dropsitcph": 9733988022,
    "dropfax": 6516751565
  },
  {
    "dcode": "D",
    "dropkey": "PV10959",
    "droptype": "D",
    "dropname": "MOUNT EPHRAIM",
    "dropdeladd": "313 W KINGS HWY",
    "dropdelcty": "MOUNT EPHRAIM",
    "dropdelst": "NJ",
    "dropdelzpp": "080599998",
    "dropphyadd": "313 W KINGS HWY",
    "dropphycty": "MOUNT EPHRAIM",
    "dropphyst": "NJ",
    "dropphyzpp": "080599998",
    "dropmaladd": "313 W KINGS HWY",
    "dropmalcty": "MOUNT EPHRAIM",
    "dropmalst": "NJ",
    "dropmalzpp": "080599998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569311762,
    "dropsitcph": 8569311762,
    "dropfax": 8569311434
  },
  {
    "dcode": "D",
    "dropkey": "PV10960",
    "droptype": "D",
    "dropname": "MOUNT FREEDOM",
    "dropdeladd": "1250 SUSSEX TPKE",
    "dropdelcty": "MOUNT FREEDOM",
    "dropdelst": "NJ",
    "dropdelzpp": "079709000",
    "dropphyadd": "1250 SUSSEX TPKE",
    "dropphycty": "MOUNT FREEDOM",
    "dropphyst": "NJ",
    "dropphyzpp": "079709000",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT FREEDOM",
    "dropmalst": "NJ",
    "dropmalzpp": "079709998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9738952383,
    "dropsitcph": 9738952383,
    "dropfax": 6505774195
  },
  {
    "dcode": "D",
    "dropkey": "PV10961",
    "droptype": "D",
    "dropname": "MOUNT HOLLY",
    "dropdeladd": "28 WASHINGTON ST",
    "dropdelcty": "MOUNT HOLLY",
    "dropdelst": "NJ",
    "dropdelzpp": "080609998",
    "dropphyadd": "28 WASHINGTON ST",
    "dropphycty": "MOUNT HOLLY",
    "dropphyst": "NJ",
    "dropphyzpp": "080609998",
    "dropmaladd": "28 WASHINGTON ST",
    "dropmalcty": "MOUNT HOLLY",
    "dropmalst": "NJ",
    "dropmalzpp": "080609998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092671430,
    "dropsitcph": 6092671430,
    "dropfax": 6092650667
  },
  {
    "dcode": "D",
    "dropkey": "PV10962",
    "droptype": "D",
    "dropname": "MOUNT LAUREL",
    "dropdeladd": "200 WALT WHITMAN AVE",
    "dropdelcty": "MOUNT LAUREL",
    "dropdelst": "NJ",
    "dropdelzpp": "080549998",
    "dropphyadd": "200 WALT WHITMAN AVE",
    "dropphycty": "MOUNT LAUREL",
    "dropphyst": "NJ",
    "dropphyzpp": "080549998",
    "dropmaladd": "200 WALT WHITMAN AVE",
    "dropmalcty": "MOUNT LAUREL",
    "dropmalst": "NJ",
    "dropmalzpp": "080549998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566080938,
    "dropsitcph": 8566080938,
    "dropfax": 8562352395
  },
  {
    "dcode": "D",
    "dropkey": "PV10965",
    "droptype": "D",
    "dropname": "MOUNT ROYAL",
    "dropdeladd": "138 KINGS HWY",
    "dropdelcty": "MOUNT ROYAL",
    "dropdelst": "NJ",
    "dropdelzpp": "080619998",
    "dropphyadd": "138 KINGS HWY",
    "dropphycty": "MOUNT ROYAL",
    "dropphyst": "NJ",
    "dropphyzpp": "080619998",
    "dropmaladd": "138 KINGS HWY",
    "dropmalcty": "MOUNT ROYAL",
    "dropmalst": "NJ",
    "dropmalzpp": "080619998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564230404,
    "dropsitcph": 8564230404,
    "dropfax": 8564230404
  },
  {
    "dcode": "D",
    "dropkey": "PV10966",
    "droptype": "D",
    "dropname": "MOUNT TABOR",
    "dropdeladd": "26 SIMPSON AVE",
    "dropdelcty": "MOUNT TABOR",
    "dropdelst": "NJ",
    "dropdelzpp": "078789212",
    "dropphyadd": "26 SIMPSON AVE",
    "dropphycty": "MOUNT TABOR",
    "dropphyst": "NJ",
    "dropphyzpp": "078789212",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT TABOR",
    "dropmalst": "NJ",
    "dropmalzpp": "078789998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736279523,
    "dropsitcph": 9736279523,
    "dropfax": 6505774201
  },
  {
    "dcode": "D",
    "dropkey": "PV10967",
    "droptype": "D",
    "dropname": "MOUNTAIN LAKES",
    "dropdeladd": "13 ELM RD",
    "dropdelcty": "MOUNTAIN LAKES",
    "dropdelst": "NJ",
    "dropdelzpp": "070469998",
    "dropphyadd": "13 ELM RD",
    "dropphycty": "MOUNTAIN LAKES",
    "dropphyst": "NJ",
    "dropphyzpp": "070469998",
    "dropmaladd": "13 ELM RD",
    "dropmalcty": "MOUNTAIN LAKES",
    "dropmalst": "NJ",
    "dropmalzpp": "070469998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733347303,
    "dropsitcph": 9733347303,
    "dropfax": 6505774091
  },
  {
    "dcode": "D",
    "dropkey": "PV10982",
    "droptype": "D",
    "dropname": "MULLICA HILL",
    "dropdeladd": "123 BRIDGETON PIKE",
    "dropdelcty": "MULLICA HILL",
    "dropdelst": "NJ",
    "dropdelzpp": "080629998",
    "dropphyadd": "123 BRIDGETON PIKE",
    "dropphycty": "MULLICA HILL",
    "dropphyst": "NJ",
    "dropphyzpp": "080629998",
    "dropmaladd": "123 BRIDGETON PIKE",
    "dropmalcty": "MULLICA HILL",
    "dropmalst": "NJ",
    "dropmalzpp": "080629998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564784411,
    "dropsitcph": 8564784411,
    "dropfax": 6094780538
  },
  {
    "dcode": "D",
    "dropkey": "PV11001",
    "droptype": "D",
    "dropname": "NATIONAL PARK",
    "dropdeladd": "512 HESSIAN AVE",
    "dropdelcty": "NATIONAL PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "080639998",
    "dropphyadd": "512 HESSIAN AVE",
    "dropphycty": "NATIONAL PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "080639998",
    "dropmaladd": "512 HESSIAN AVE",
    "dropmalcty": "NATIONAL PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "080639998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568457485,
    "dropsitcph": 8568457485,
    "dropfax": 8568459305
  },
  {
    "dcode": "D",
    "dropkey": "PV11004",
    "droptype": "D",
    "dropname": "NAVESINK",
    "dropdeladd": "2375 STATE ROUTE 36",
    "dropdelcty": "NAVESINK",
    "dropdelst": "NJ",
    "dropdelzpp": "077529998",
    "dropphyadd": "2375 STATE ROUTE 36",
    "dropphycty": "NAVESINK",
    "dropphyst": "NJ",
    "dropphyzpp": "077529998",
    "dropmaladd": "2375 STATE ROUTE 36",
    "dropmalcty": "NAVESINK",
    "dropmalst": "NJ",
    "dropmalzpp": "077529998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322912323,
    "dropsitcph": 7322912323,
    "dropfax": 7322915156
  },
  {
    "dcode": "D",
    "dropkey": "PV11005",
    "droptype": "D",
    "dropname": "NEPTUNE",
    "dropdeladd": "50 NEPTUNE BLVD",
    "dropdelcty": "NEPTUNE",
    "dropdelst": "NJ",
    "dropdelzpp": "077539998",
    "dropphyadd": "50 NEPTUNE BLVD",
    "dropphycty": "NEPTUNE",
    "dropphyst": "NJ",
    "dropphyzpp": "077539998",
    "dropmaladd": "50 NEPTUNE BLVD",
    "dropmalcty": "NEPTUNE",
    "dropmalst": "NJ",
    "dropmalzpp": "077539998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327768811,
    "dropsitcph": 7327768811,
    "dropfax": 7327765231
  },
  {
    "dcode": "D",
    "dropkey": "PV11011",
    "droptype": "D",
    "dropname": "NESHANIC STATION",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "NESHANIC STATION",
    "dropdelst": "NJ",
    "dropdelzpp": "088539998",
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "NESHANIC STATION",
    "dropphyst": "NJ",
    "dropphyzpp": "088539998",
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "NESHANIC STATION",
    "dropmalst": "NJ",
    "dropmalzpp": "088539998",
    "dropsitphn": 7328193630,
    "dropsitlph": 6505775462,
    "dropsitcph": 9083693111,
    "dropfax": 9083694073
  },
  {
    "dcode": "D",
    "dropkey": "PV11012",
    "droptype": "D",
    "dropname": "NETCONG",
    "dropdeladd": "18 MAPLE AVE",
    "dropdelcty": "NETCONG",
    "dropdelst": "NJ",
    "dropdelzpp": "078579998",
    "dropphyadd": "18 MAPLE AVE",
    "dropphycty": "NETCONG",
    "dropphyst": "NJ",
    "dropphyzpp": "078579998",
    "dropmaladd": "18 MAPLE AVE",
    "dropmalcty": "NETCONG",
    "dropmalst": "NJ",
    "dropmalzpp": "078579998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733471177,
    "dropsitcph": 9733471177,
    "dropfax": 6505774037
  },
  {
    "dcode": "D",
    "dropkey": "PV11017",
    "droptype": "D",
    "dropname": "NEW BRUNSWICK",
    "dropdeladd": "86 BAYARD ST",
    "dropdelcty": "NEW BRUNSWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "089012169",
    "dropphyadd": "86 BAYARD ST",
    "dropphycty": "NEW BRUNSWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "089012169",
    "dropmaladd": "86 BAYARD ST",
    "dropmalcty": "NEW BRUNSWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "089012169",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325456819,
    "dropfax": 6505775463
  },
  {
    "dcode": "D",
    "dropkey": "PV11019",
    "droptype": "D",
    "dropname": "NEW EGYPT",
    "dropdeladd": "22 N MAIN ST",
    "dropdelcty": "NEW EGYPT",
    "dropdelst": "NJ",
    "dropdelzpp": "085339998",
    "dropphyadd": "22 N MAIN ST",
    "dropphycty": "NEW EGYPT",
    "dropphyst": "NJ",
    "dropphyzpp": "085339998",
    "dropmaladd": "22 N MAIN ST",
    "dropmalcty": "NEW EGYPT",
    "dropmalst": "NJ",
    "dropmalzpp": "085339998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097582247,
    "dropsitcph": 6097582247,
    "dropfax": 6097584654
  },
  {
    "dcode": "D",
    "dropkey": "PV11020",
    "droptype": "D",
    "dropname": "NEW GRETNA",
    "dropdeladd": "5624 ROUTE 9",
    "dropdelcty": "NEW GRETNA",
    "dropdelst": "NJ",
    "dropdelzpp": "082249998",
    "dropphyadd": "5624 ROUTE 9",
    "dropphycty": "NEW GRETNA",
    "dropphyst": "NJ",
    "dropphyzpp": "082249998",
    "dropmaladd": "5624 ROUTE 9",
    "dropmalcty": "NEW GRETNA",
    "dropmalst": "NJ",
    "dropmalzpp": "082249998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092965005,
    "dropsitcph": 6092965005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11022",
    "droptype": "D",
    "dropname": "NEW LISBON",
    "dropdeladd": "79 FOUR MILE RD",
    "dropdelcty": "NEW LISBON",
    "dropdelst": "NJ",
    "dropdelzpp": "080649998",
    "dropphyadd": "79 FOUR MILE RD",
    "dropphycty": "NEW LISBON",
    "dropphyst": "NJ",
    "dropphyzpp": "080649998",
    "dropmaladd": "79 FOUR MILE RD",
    "dropmalcty": "NEW LISBON",
    "dropmalst": "NJ",
    "dropmalzpp": "080649998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098949272,
    "dropsitcph": 6098949272,
    "dropfax": 6098940467
  },
  {
    "dcode": "D",
    "dropkey": "PV11025",
    "droptype": "D",
    "dropname": "NEW MILFORD",
    "dropdeladd": "1055 RIVER RD",
    "dropdelcty": "NEW MILFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "076469998",
    "dropphyadd": "1055 RIVER RD",
    "dropphycty": "NEW MILFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "076469998",
    "dropmaladd": "1055 RIVER RD",
    "dropmalcty": "NEW MILFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "076469998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016923951,
    "dropsitcph": 2016923951,
    "dropfax": 6505774401
  },
  {
    "dcode": "D",
    "dropkey": "PV11027",
    "droptype": "D",
    "dropname": "NEW PROVIDENCE",
    "dropdeladd": "598 CENTRAL AVE STE 7",
    "dropdelcty": "NEW PROVIDENCE",
    "dropdelst": "NJ",
    "dropdelzpp": "079749998",
    "dropphyadd": "598 CENTRAL AVE STE 7",
    "dropphycty": "NEW PROVIDENCE",
    "dropphyst": "NJ",
    "dropphyzpp": "079749998",
    "dropmaladd": "598 CENTRAL AVE STE 7",
    "dropmalcty": "NEW PROVIDENCE",
    "dropmalst": "NJ",
    "dropmalzpp": "079749998",
    "dropsitphn": 9082771737,
    "dropsitlph": 9082771737,
    "dropsitcph": 9086652075,
    "dropfax": 6505774194
  },
  {
    "dcode": "D",
    "dropkey": "PV11028",
    "droptype": "D",
    "dropname": "NEW VERNON",
    "dropdeladd": "12 VILLAGE RD",
    "dropdelcty": "NEW VERNON",
    "dropdelst": "NJ",
    "dropdelzpp": "079769721",
    "dropphyadd": "12 VILLAGE RD",
    "dropphycty": "NEW VERNON",
    "dropphyst": "NJ",
    "dropphyzpp": "079769721",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW VERNON",
    "dropmalst": "NJ",
    "dropmalzpp": "079769998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735387210,
    "dropsitcph": 9735387210,
    "dropfax": 6503576560
  },
  {
    "dcode": "D",
    "dropkey": "PV11029",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "2 FEDERAL SQ",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071029998",
    "dropphyadd": "2 FEDERAL SQ",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071029998",
    "dropmaladd": "2 FEDERAL SQ",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071029400",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935230,
    "dropsitcph": 9736935231,
    "dropfax": 9736935286
  },
  {
    "dcode": "D",
    "dropkey": "PV11031",
    "droptype": "D",
    "dropname": "NEWFIELD",
    "dropdeladd": "10 N WEST BLVD",
    "dropdelcty": "NEWFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "083449998",
    "dropphyadd": "10 N WEST BLVD",
    "dropphycty": "NEWFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "083449998",
    "dropmaladd": "10 N WEST BLVD",
    "dropmalcty": "NEWFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "083449998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566971551,
    "dropsitcph": 8566971551,
    "dropfax": 8566974060
  },
  {
    "dcode": "D",
    "dropkey": "PV11032",
    "droptype": "D",
    "dropname": "NEWFOUNDLAND",
    "dropdeladd": "2727 STATE RT 23 STE 1",
    "dropdelcty": "NEWFOUNDLAND",
    "dropdelst": "NJ",
    "dropdelzpp": "074351472",
    "dropphyadd": "2727 STATE RT 23 STE 1",
    "dropphycty": "NEWFOUNDLAND",
    "dropphyst": "NJ",
    "dropphyzpp": "074351472",
    "dropmaladd": "2727 STATE RT 23 STE 1",
    "dropmalcty": "NEWFOUNDLAND",
    "dropmalst": "NJ",
    "dropmalzpp": "074351472",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736975392,
    "dropsitcph": 9736975392,
    "dropfax": 6505774067
  },
  {
    "dcode": "D",
    "dropkey": "PV11033",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "304 BAPTIST RD",
    "dropdelcty": "NEWPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "083459998",
    "dropphyadd": "304 BAPTIST RD",
    "dropphycty": "NEWPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "083459998",
    "dropmaladd": "304 BAPTIST RD",
    "dropmalcty": "NEWPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "083459998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564474926,
    "dropsitcph": 8564474926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11034",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "39 MAIN ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "NJ",
    "dropdelzpp": "078609998",
    "dropphyadd": "39 MAIN ST",
    "dropphycty": "NEWTON",
    "dropphyst": "NJ",
    "dropphyzpp": "078609998",
    "dropmaladd": "39 MAIN ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "NJ",
    "dropmalzpp": "078609998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733831970,
    "dropsitcph": 9733831970,
    "dropfax": 6505774336
  },
  {
    "dcode": "D",
    "dropkey": "PV11035",
    "droptype": "D",
    "dropname": "NEWTONVILLE",
    "dropdeladd": "711 JACKSON RD",
    "dropdelcty": "NEWTONVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "083469998",
    "dropphyadd": "711 JACKSON RD",
    "dropphycty": "NEWTONVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "083469998",
    "dropmaladd": "711 JACKSON RD",
    "dropmalcty": "NEWTONVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "083469998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095672389,
    "dropsitcph": 6095672389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11042",
    "droptype": "D",
    "dropname": "NJ INTL NDC",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979801",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979801",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979801",
    "dropsitphn": 9736935181,
    "dropsitlph": 2017147604,
    "dropsitcph": 2017147604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11050",
    "droptype": "D",
    "dropname": "NORMA",
    "dropdeladd": "809 GERSHAL AVE",
    "dropdelcty": "NORMA",
    "dropdelst": "NJ",
    "dropdelzpp": "083479998",
    "dropphyadd": "809 GERSHAL AVE",
    "dropphycty": "NORMA",
    "dropphyst": "NJ",
    "dropphyzpp": "083479998",
    "dropmaladd": "809 GERSHAL AVE",
    "dropmalcty": "NORMA",
    "dropmalst": "NJ",
    "dropmalzpp": "083479998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566923496,
    "dropsitcph": 8566923496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11051",
    "droptype": "D",
    "dropname": "NORMANDY BEACH",
    "dropdeladd": "551 STATE ROUTE 35 N",
    "dropdelcty": "NORMANDY BEACH",
    "dropdelst": "NJ",
    "dropdelzpp": "087399998",
    "dropphyadd": "551 STATE ROUTE 35 N",
    "dropphycty": "NORMANDY BEACH",
    "dropphyst": "NJ",
    "dropphyzpp": "087399998",
    "dropmaladd": "551 STATE ROUTE 35 N",
    "dropmalcty": "NORMANDY BEACH",
    "dropmalst": "NJ",
    "dropmalzpp": "087399998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327936927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11057",
    "droptype": "D",
    "dropname": "NORTH BERGEN",
    "dropdeladd": "4608 TONNELLE AVE",
    "dropdelcty": "NORTH BERGEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070479998",
    "dropphyadd": "4608 TONNELLE AVE",
    "dropphycty": "NORTH BERGEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070479998",
    "dropmaladd": "4608 TONNELLE AVE",
    "dropmalcty": "NORTH BERGEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070479998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018671346,
    "dropsitcph": 2018671346,
    "dropfax": 6505774387
  },
  {
    "dcode": "D",
    "dropkey": "PV11080",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "800 NEW RD",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "082259998",
    "dropphyadd": "800 NEW RD",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "082259998",
    "dropmaladd": "800 NEW RD",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "082259998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096416583,
    "dropsitcph": 6096416583,
    "dropfax": 6098332281
  },
  {
    "dcode": "D",
    "dropkey": "PV11082",
    "droptype": "D",
    "dropname": "NORTHVALE",
    "dropdeladd": "124 PARIS AVE",
    "dropdelcty": "NORTHVALE",
    "dropdelst": "NJ",
    "dropdelzpp": "076479998",
    "dropphyadd": "124 PARIS AVE",
    "dropphycty": "NORTHVALE",
    "dropphyst": "NJ",
    "dropphyzpp": "076479998",
    "dropmaladd": "124 PARIS AVE",
    "dropmalcty": "NORTHVALE",
    "dropmalst": "NJ",
    "dropmalzpp": "076479998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017840598,
    "dropsitcph": 2017840598,
    "dropfax": 6505774363
  },
  {
    "dcode": "D",
    "dropkey": "PV11084",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "239 RAILROAD AVE",
    "dropdelcty": "NORWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "076489998",
    "dropphyadd": "239 RAILROAD AVE",
    "dropphycty": "NORWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "076489998",
    "dropmaladd": "239 RAILROAD AVE",
    "dropmalcty": "NORWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076489998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017840597,
    "dropsitcph": 2017840597,
    "dropfax": 6505774352
  },
  {
    "dcode": "D",
    "dropkey": "PV11092",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "247 OAK RIDGE RD",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "074389998",
    "dropphyadd": "247 OAK RIDGE RD",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "074389998",
    "dropmaladd": "247 OAK RIDGE RD",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "074389998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736979073,
    "dropsitcph": 9736979073,
    "dropfax": 6505774430
  },
  {
    "dcode": "D",
    "dropkey": "PV11095",
    "droptype": "D",
    "dropname": "OAKHURST",
    "dropdeladd": "715 W PARK AVE",
    "dropdelcty": "OAKHURST",
    "dropdelst": "NJ",
    "dropdelzpp": "077559998",
    "dropphyadd": "715 W PARK AVE",
    "dropphycty": "OAKHURST",
    "dropphyst": "NJ",
    "dropphyzpp": "077559998",
    "dropmaladd": "715 W PARK AVE",
    "dropmalcty": "OAKHURST",
    "dropmalst": "NJ",
    "dropmalzpp": "077559998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325316566,
    "dropsitcph": 7325316566,
    "dropfax": 7325314982
  },
  {
    "dcode": "D",
    "dropkey": "PV11096",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "332 RAMAPO VALLEY RD",
    "dropdelcty": "OAKLAND",
    "dropdelst": "NJ",
    "dropdelzpp": "074369998",
    "dropphyadd": "332 RAMAPO VALLEY RD",
    "dropphycty": "OAKLAND",
    "dropphyst": "NJ",
    "dropphyzpp": "074369998",
    "dropmaladd": "332 RAMAPO VALLEY RD",
    "dropmalcty": "OAKLAND",
    "dropmalst": "NJ",
    "dropmalzpp": "074369998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013375736,
    "dropsitcph": 2013377536,
    "dropfax": 6505774198
  },
  {
    "dcode": "D",
    "dropkey": "PV11102",
    "droptype": "D",
    "dropname": "OCEAN CITY",
    "dropdeladd": "859 OCEAN AVE",
    "dropdelcty": "OCEAN CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "082269998",
    "dropphyadd": "859 OCEAN AVE",
    "dropphycty": "OCEAN CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "082269998",
    "dropmaladd": "859 OCEAN AVE",
    "dropmalcty": "OCEAN CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "082269998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093990475,
    "dropsitcph": 6093990475,
    "dropfax": 6093910973
  },
  {
    "dcode": "D",
    "dropkey": "PV11104",
    "droptype": "D",
    "dropname": "OCEAN GATE",
    "dropdeladd": "450 OCEAN GATE AVE",
    "dropdelcty": "OCEAN GATE",
    "dropdelst": "NJ",
    "dropdelzpp": "087409998",
    "dropphyadd": "450 OCEAN GATE AVE",
    "dropphycty": "OCEAN GATE",
    "dropphyst": "NJ",
    "dropphyzpp": "087409998",
    "dropmaladd": "450 OCEAN GATE AVE",
    "dropmalcty": "OCEAN GATE",
    "dropmalst": "NJ",
    "dropmalzpp": "087409998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322693112,
    "dropfax": 7322694329
  },
  {
    "dcode": "D",
    "dropkey": "PV11105",
    "droptype": "D",
    "dropname": "OCEAN GROVE",
    "dropdeladd": "59 MAIN AVE",
    "dropdelcty": "OCEAN GROVE",
    "dropdelst": "NJ",
    "dropdelzpp": "077569998",
    "dropphyadd": "59 MAIN AVE",
    "dropphycty": "OCEAN GROVE",
    "dropphyst": "NJ",
    "dropphyzpp": "077569998",
    "dropmaladd": "59 MAIN AVE",
    "dropmalcty": "OCEAN GROVE",
    "dropmalst": "NJ",
    "dropmalzpp": "077569998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327750375,
    "dropsitcph": 7327750375,
    "dropfax": 7327756725
  },
  {
    "dcode": "D",
    "dropkey": "PV11110",
    "droptype": "D",
    "dropname": "OCEAN VIEW",
    "dropdeladd": "556 SEA ISLE BLVD UNIT H",
    "dropdelcty": "OCEAN VIEW",
    "dropdelst": "NJ",
    "dropdelzpp": "082309998",
    "dropphyadd": "556 SEA ISLE BLVD UNIT H",
    "dropphycty": "OCEAN VIEW",
    "dropphyst": "NJ",
    "dropphyzpp": "082309998",
    "dropmaladd": "556 SEA ISLE BLVD UNIT H",
    "dropmalcty": "OCEAN VIEW",
    "dropmalst": "NJ",
    "dropmalzpp": "082309998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096240887,
    "dropsitcph": 6096240887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11112",
    "droptype": "D",
    "dropname": "OCEANPORT",
    "dropdeladd": "285 E MAIN ST",
    "dropdelcty": "OCEANPORT",
    "dropdelst": "NJ",
    "dropdelzpp": "077579998",
    "dropphyadd": "285 E MAIN ST",
    "dropphycty": "OCEANPORT",
    "dropphyst": "NJ",
    "dropphyzpp": "077579998",
    "dropmaladd": "285 E MAIN ST",
    "dropmalcty": "OCEANPORT",
    "dropmalst": "NJ",
    "dropmalzpp": "077579998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7325422284,
    "dropsitcph": 7325422284,
    "dropfax": 7325422522
  },
  {
    "dcode": "D",
    "dropkey": "PV11113",
    "droptype": "D",
    "dropname": "OCEANVILLE",
    "dropdeladd": "174 S NEW YORK AVE",
    "dropdelcty": "OCEANVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "082319998",
    "dropphyadd": "174 S NEW YORK AVE",
    "dropphycty": "OCEANVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "082319998",
    "dropmaladd": "174 S NEW YORK AVE",
    "dropmalcty": "OCEANVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "082319998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096521168,
    "dropsitcph": 6096521168,
    "dropfax": 6097486781
  },
  {
    "dcode": "D",
    "dropkey": "PV11115",
    "droptype": "D",
    "dropname": "OGDENSBURG",
    "dropdeladd": "328 MAIN ST",
    "dropdelcty": "OGDENSBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "074399998",
    "dropphyadd": "328 MAIN ST",
    "dropphycty": "OGDENSBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "074399998",
    "dropmaladd": "328 MAIN ST",
    "dropmalcty": "OGDENSBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "074399998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738278328,
    "dropsitcph": 9738278328,
    "dropfax": 6505774006
  },
  {
    "dcode": "D",
    "dropkey": "PV11116",
    "droptype": "D",
    "dropname": "OLD BRIDGE",
    "dropdeladd": "151 HIGHWAY 516",
    "dropdelcty": "OLD BRIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "088579998",
    "dropphyadd": "151 HIGHWAY 516",
    "dropphycty": "OLD BRIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "088579998",
    "dropmaladd": "151 HIGHWAY 516",
    "dropmalcty": "OLD BRIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "088579998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322574192,
    "dropfax": 6505775464
  },
  {
    "dcode": "D",
    "dropkey": "PV11118",
    "droptype": "D",
    "dropname": "OLDWICK",
    "dropdeladd": "174 LAMINGTON RD",
    "dropdelcty": "OLDWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "088589800",
    "dropphyadd": "174 LAMINGTON RD",
    "dropphycty": "OLDWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "088589800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLDWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "088589998",
    "dropsitphn": 9084392920,
    "dropsitlph": 9084392920,
    "dropsitcph": 9084392920,
    "dropfax": 9084399176
  },
  {
    "dcode": "D",
    "dropkey": "PV11120",
    "droptype": "D",
    "dropname": "ORADELL",
    "dropdeladd": "618 VELDRAN AVE",
    "dropdelcty": "ORADELL",
    "dropdelst": "NJ",
    "dropdelzpp": "076499998",
    "dropphyadd": "618 VELDRAN AVE",
    "dropphycty": "ORADELL",
    "dropphyst": "NJ",
    "dropphyzpp": "076499998",
    "dropmaladd": "618 VELDRAN AVE",
    "dropmalcty": "ORADELL",
    "dropmalst": "NJ",
    "dropmalzpp": "076499998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012622255,
    "dropsitcph": 2016340598,
    "dropfax": 6505774394
  },
  {
    "dcode": "D",
    "dropkey": "PV11121",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "384 MAIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070509998",
    "dropphyadd": "384 MAIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070509998",
    "dropmaladd": "384 MAIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070509998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736727304,
    "dropsitcph": 9736727304,
    "dropfax": 6505774210
  },
  {
    "dcode": "D",
    "dropkey": "PV11130",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "170 STATE ROUTE 31 N",
    "dropdelcty": "OXFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "078639998",
    "dropphyadd": "170 STATE ROUTE 31 N",
    "dropphycty": "OXFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "078639998",
    "dropmaladd": "170 STATE ROUTE 31 N",
    "dropmalcty": "OXFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "078639998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084532441,
    "dropsitcph": 9084532441,
    "dropfax": 6505774086
  },
  {
    "dcode": "D",
    "dropkey": "PV11139",
    "droptype": "D",
    "dropname": "PALISADES PARK",
    "dropdeladd": "117 W CENTRAL BLVD STE 1",
    "dropdelcty": "PALISADES PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "076509998",
    "dropphyadd": "117 W CENTRAL BLVD STE 1",
    "dropphycty": "PALISADES PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "076509998",
    "dropmaladd": "117 W CENTRAL BLVD STE 1",
    "dropmalcty": "PALISADES PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "076509998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2019446266,
    "dropsitcph": 2019431690,
    "dropfax": 6505774410
  },
  {
    "dcode": "D",
    "dropkey": "PV11143",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "36 W BROAD ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "NJ",
    "dropdelzpp": "080659998",
    "dropphyadd": "36 W BROAD ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "NJ",
    "dropphyzpp": "080659998",
    "dropmaladd": "36 W BROAD ST",
    "dropmalcty": "PALMYRA",
    "dropmalst": "NJ",
    "dropmalzpp": "080659998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568291171,
    "dropsitcph": 8568291171,
    "dropfax": 8568292553
  },
  {
    "dcode": "D",
    "dropkey": "PV11147",
    "droptype": "D",
    "dropname": "PARAMUS",
    "dropdeladd": "33 E MIDLAND AVE",
    "dropdelcty": "PARAMUS",
    "dropdelst": "NJ",
    "dropdelzpp": "076529998",
    "dropphyadd": "33 E MIDLAND AVE",
    "dropphycty": "PARAMUS",
    "dropphyst": "NJ",
    "dropphyzpp": "076529998",
    "dropmaladd": "33 E MIDLAND AVE",
    "dropmalcty": "PARAMUS",
    "dropmalst": "NJ",
    "dropmalzpp": "076529998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012627635,
    "dropsitcph": 2012627635,
    "dropfax": 6505774196
  },
  {
    "dcode": "D",
    "dropkey": "PV11151",
    "droptype": "D",
    "dropname": "PARK RIDGE",
    "dropdeladd": "24 PARK AVE",
    "dropdelcty": "PARK RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "076561240",
    "dropphyadd": "24 PARK AVE",
    "dropphycty": "PARK RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "076561240",
    "dropmaladd": "24 PARK AVE",
    "dropmalcty": "PARK RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "076561240",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013914424,
    "dropsitcph": 2013911659,
    "dropfax": 6505774428
  },
  {
    "dcode": "D",
    "dropkey": "PV11154",
    "droptype": "D",
    "dropname": "PARLIN",
    "dropdeladd": "778 WASHINGTON RD",
    "dropdelcty": "PARLIN",
    "dropdelst": "NJ",
    "dropdelzpp": "088599998",
    "dropphyadd": "778 WASHINGTON RD",
    "dropphycty": "PARLIN",
    "dropphyst": "NJ",
    "dropphyzpp": "088599998",
    "dropmaladd": "778 WASHINGTON RD",
    "dropmalcty": "PARLIN",
    "dropmalst": "NJ",
    "dropmalzpp": "088599998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322570045,
    "dropfax": 6505775466
  },
  {
    "dcode": "D",
    "dropkey": "PV11155",
    "droptype": "D",
    "dropname": "PARSIPPANY",
    "dropdeladd": "3299 US HIGHWAY 46",
    "dropdelcty": "PARSIPPANY",
    "dropdelst": "NJ",
    "dropdelzpp": "070549998",
    "dropphyadd": "3299 US HIGHWAY 46",
    "dropphycty": "PARSIPPANY",
    "dropphyst": "NJ",
    "dropphyzpp": "070549998",
    "dropmaladd": "3299 US HIGHWAY 46",
    "dropmalcty": "PARSIPPANY",
    "dropmalst": "NJ",
    "dropmalzpp": "070549998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733352587,
    "dropsitcph": 9733352587,
    "dropfax": 6505774121
  },
  {
    "dcode": "D",
    "dropkey": "PV11157",
    "droptype": "D",
    "dropname": "PASSAIC",
    "dropdeladd": "46 GROVE ST",
    "dropdelcty": "PASSAIC",
    "dropdelst": "NJ",
    "dropdelzpp": "070559998",
    "dropphyadd": "46 GROVE ST",
    "dropphycty": "PASSAIC",
    "dropphyst": "NJ",
    "dropphyzpp": "070559998",
    "dropmaladd": "46 GROVE ST",
    "dropmalcty": "PASSAIC",
    "dropmalst": "NJ",
    "dropmalzpp": "070559998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737796758,
    "dropsitcph": 9737796758,
    "dropfax": 6505774418
  },
  {
    "dcode": "D",
    "dropkey": "PV11161",
    "droptype": "D",
    "dropname": "PATERSON",
    "dropdeladd": "194 WARD ST",
    "dropdelcty": "PATERSON",
    "dropdelst": "NJ",
    "dropdelzpp": "075109000",
    "dropphyadd": "194 WARD ST",
    "dropphycty": "PATERSON",
    "dropphyst": "NJ",
    "dropphyzpp": "075109998",
    "dropmaladd": "194 WARD ST",
    "dropmalcty": "PATERSON",
    "dropmalst": "NJ",
    "dropmalzpp": "075109998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9739774729,
    "dropsitcph": 9739774611,
    "dropfax": 9739774622
  },
  {
    "dcode": "D",
    "dropkey": "PV11163",
    "droptype": "D",
    "dropname": "PAULSBORO",
    "dropdeladd": "1015 N DELAWARE ST",
    "dropdelcty": "PAULSBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080669998",
    "dropphyadd": "1015 N DELAWARE ST",
    "dropphycty": "PAULSBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080669998",
    "dropmaladd": "1015 N DELAWARE ST",
    "dropmalcty": "PAULSBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080669998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564230327,
    "dropsitcph": 8564230327,
    "dropfax": 8564236827
  },
  {
    "dcode": "D",
    "dropkey": "PV11167",
    "droptype": "D",
    "dropname": "PEAPACK",
    "dropdeladd": "155 MAIN ST",
    "dropdelcty": "PEAPACK",
    "dropdelst": "NJ",
    "dropdelzpp": "079779800",
    "dropphyadd": "155 MAIN ST",
    "dropphycty": "PEAPACK",
    "dropphyst": "NJ",
    "dropphyzpp": "079779800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEAPACK",
    "dropmalst": "NJ",
    "dropmalzpp": "079779998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9082340546,
    "dropsitcph": 9082340546,
    "dropfax": 6505774404
  },
  {
    "dcode": "D",
    "dropkey": "PV11168",
    "droptype": "D",
    "dropname": "PEDRICKTOWN",
    "dropdeladd": "13 W MILL ST",
    "dropdelcty": "PEDRICKTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080679998",
    "dropphyadd": "13 W MILL ST",
    "dropphycty": "PEDRICKTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080679998",
    "dropmaladd": "13 W MILL ST",
    "dropmalcty": "PEDRICKTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080679998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562993999,
    "dropsitcph": 8562993999,
    "dropfax": 8562993921
  },
  {
    "dcode": "D",
    "dropkey": "PV11170",
    "droptype": "D",
    "dropname": "PEMBERTON",
    "dropdeladd": "73 ELIZABETH ST",
    "dropdelcty": "PEMBERTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080689998",
    "dropphyadd": "73 ELIZABETH ST",
    "dropphycty": "PEMBERTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080689998",
    "dropmaladd": "73 ELIZABETH ST",
    "dropmalcty": "PEMBERTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080689998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098942686,
    "dropsitcph": 6098942686,
    "dropfax": 6098941168
  },
  {
    "dcode": "D",
    "dropkey": "PV11171",
    "droptype": "D",
    "dropname": "PENNINGTON",
    "dropdeladd": "125 BROEMEL PL",
    "dropdelcty": "PENNINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "085349998",
    "dropphyadd": "125 BROEMEL PL",
    "dropphycty": "PENNINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "085349998",
    "dropmaladd": "125 BROEMEL PL",
    "dropmalcty": "PENNINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "085349998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097371115,
    "dropsitcph": 6097371115,
    "dropfax": 6097309097
  },
  {
    "dcode": "D",
    "dropkey": "PV11172",
    "droptype": "D",
    "dropname": "PENNS GROVE",
    "dropdeladd": "56 W MAIN ST",
    "dropdelcty": "PENNS GROVE",
    "dropdelst": "NJ",
    "dropdelzpp": "080699998",
    "dropphyadd": "56 W MAIN ST",
    "dropphycty": "PENNS GROVE",
    "dropphyst": "NJ",
    "dropphyzpp": "080699998",
    "dropmaladd": "56 W MAIN ST",
    "dropmalcty": "PENNS GROVE",
    "dropmalst": "NJ",
    "dropmalzpp": "080699998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562995200,
    "dropsitcph": 8562995200,
    "dropfax": 8562992851
  },
  {
    "dcode": "D",
    "dropkey": "PV11176",
    "droptype": "D",
    "dropname": "PENNSVILLE",
    "dropdeladd": "220 S BROADWAY",
    "dropdelcty": "PENNSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "080709998",
    "dropphyadd": "220 S BROADWAY",
    "dropphycty": "PENNSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "080709998",
    "dropmaladd": "220 S BROADWAY",
    "dropmalcty": "PENNSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "080709998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566785999,
    "dropsitcph": 8566785999,
    "dropfax": 8566783736
  },
  {
    "dcode": "D",
    "dropkey": "PV11179",
    "droptype": "D",
    "dropname": "PEQUANNOCK",
    "dropdeladd": "190 NEWARK POMPTON TPKE",
    "dropdelcty": "PEQUANNOCK",
    "dropdelst": "NJ",
    "dropdelzpp": "074409998",
    "dropphyadd": "190 NEWARK POMPTON TPKE",
    "dropphycty": "PEQUANNOCK",
    "dropphyst": "NJ",
    "dropphyzpp": "074409998",
    "dropmaladd": "190 NEWARK POMPTON TPKE",
    "dropmalcty": "PEQUANNOCK",
    "dropmalst": "NJ",
    "dropmalzpp": "074409998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736945178,
    "dropsitcph": 9736945178,
    "dropfax": 6505774078
  },
  {
    "dcode": "D",
    "dropkey": "PV11182",
    "droptype": "D",
    "dropname": "PERRINEVILLE",
    "dropdeladd": "221 MILLSTONE RD",
    "dropdelcty": "MILLSTONE TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "085359998",
    "dropphyadd": "221 MILLSTONE RD",
    "dropphycty": "MILLSTONE TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "085359998",
    "dropmaladd": "221 MILLSTONE RD",
    "dropmalcty": "MILLSTONE TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "085359998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7324467102,
    "dropfax": 7327860627
  },
  {
    "dcode": "D",
    "dropkey": "PV11185",
    "droptype": "D",
    "dropname": "PERTH AMBOY",
    "dropdeladd": "205 JEFFERSON ST",
    "dropdelcty": "PERTH AMBOY",
    "dropdelst": "NJ",
    "dropdelzpp": "088619998",
    "dropphyadd": "205 JEFFERSON ST",
    "dropphycty": "PERTH AMBOY",
    "dropphyst": "NJ",
    "dropphyzpp": "088619998",
    "dropmaladd": "205 JEFFERSON ST",
    "dropmalcty": "PERTH AMBOY",
    "dropmalst": "NJ",
    "dropmalzpp": "088619998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328262090,
    "dropfax": 6503576424
  },
  {
    "dcode": "D",
    "dropkey": "PV11190",
    "droptype": "D",
    "dropname": "PHILLIPSBURG",
    "dropdeladd": "361 MEMORIAL PKWY",
    "dropdelcty": "PHILLIPSBURG",
    "dropdelst": "NJ",
    "dropdelzpp": "088659998",
    "dropphyadd": "361 MEMORIAL PKWY",
    "dropphycty": "PHILLIPSBURG",
    "dropphyst": "NJ",
    "dropphyzpp": "088659998",
    "dropmaladd": "361 MEMORIAL PKWY",
    "dropmalcty": "PHILLIPSBURG",
    "dropmalst": "NJ",
    "dropmalzpp": "088659998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9088593666,
    "dropfax": 6505775467
  },
  {
    "dcode": "D",
    "dropkey": "PV11193",
    "droptype": "D",
    "dropname": "PINE BEACH",
    "dropdeladd": "601 PENNSYLVANIA AVE",
    "dropdelcty": "PINE BEACH",
    "dropdelst": "NJ",
    "dropdelzpp": "087419998",
    "dropphyadd": "601 PENNSYLVANIA AVE",
    "dropphycty": "PINE BEACH",
    "dropphyst": "NJ",
    "dropphyzpp": "087419998",
    "dropmaladd": "601 PENNSYLVANIA AVE",
    "dropmalcty": "PINE BEACH",
    "dropmalst": "NJ",
    "dropmalzpp": "087419998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323411911,
    "dropfax": 7327360074
  },
  {
    "dcode": "D",
    "dropkey": "PV11194",
    "droptype": "D",
    "dropname": "PINE BROOK",
    "dropdeladd": "50 US HIGHWAY 46",
    "dropdelcty": "PINE BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "070589998",
    "dropphyadd": "50 US HIGHWAY 46",
    "dropphycty": "PINE BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "070589998",
    "dropmaladd": "50 US HIGHWAY 46",
    "dropmalcty": "PINE BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "070589998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732270143,
    "dropsitcph": 9732270143,
    "dropfax": 6505774359
  },
  {
    "dcode": "D",
    "dropkey": "PV11203",
    "droptype": "D",
    "dropname": "PISCATAWAY",
    "dropdeladd": "3 SKILES AVE",
    "dropdelcty": "PISCATAWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "088549998",
    "dropphyadd": "3 SKILES AVE",
    "dropphycty": "PISCATAWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "088549998",
    "dropmaladd": "3 SKILES AVE",
    "dropmalcty": "PISCATAWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "088549998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329810740,
    "dropfax": 6505774151
  },
  {
    "dcode": "D",
    "dropkey": "PV11204",
    "droptype": "D",
    "dropname": "PITMAN",
    "dropdeladd": "55 N BROADWAY",
    "dropdelcty": "PITMAN",
    "dropdelst": "NJ",
    "dropdelzpp": "080719998",
    "dropphyadd": "55 N BROADWAY",
    "dropphycty": "PITMAN",
    "dropphyst": "NJ",
    "dropphyzpp": "080719998",
    "dropmaladd": "55 N BROADWAY",
    "dropmalcty": "PITMAN",
    "dropmalst": "NJ",
    "dropmalzpp": "080719998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565892234,
    "dropsitcph": 8565892234,
    "dropfax": 8562561149
  },
  {
    "dcode": "D",
    "dropkey": "PV11206",
    "droptype": "D",
    "dropname": "PITTSTOWN",
    "dropdeladd": "313 PITTSTOWN RD",
    "dropdelcty": "PITTSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088679998",
    "dropphyadd": "313 PITTSTOWN RD",
    "dropphycty": "PITTSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088679998",
    "dropmaladd": "313 PITTSTOWN RD",
    "dropmalcty": "PITTSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088679998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087357291,
    "dropfax": 6505775468
  },
  {
    "dcode": "D",
    "dropkey": "PV11208",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "201 WATCHUNG AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070609998",
    "dropphyadd": "201 WATCHUNG AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070609998",
    "dropmaladd": "201 WATCHUNG AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070609998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082265244,
    "dropsitcph": 9082265244,
    "dropfax": 6505774408
  },
  {
    "dcode": "D",
    "dropkey": "PV11209",
    "droptype": "D",
    "dropname": "PLAINSBORO",
    "dropdeladd": "12 SCHALKS CROSSING RD",
    "dropdelcty": "PLAINSBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "085369998",
    "dropphyadd": "12 SCHALKS CROSSING RD",
    "dropphycty": "PLAINSBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "085369998",
    "dropmaladd": "12 SCHALKS CROSSING RD",
    "dropmalcty": "PLAINSBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "085369998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097990239,
    "dropsitcph": 6097990239,
    "dropfax": 6099368935
  },
  {
    "dcode": "D",
    "dropkey": "PV11213",
    "droptype": "D",
    "dropname": "PLEASANTVILLE",
    "dropdeladd": "752 BLACK HORSE PIKE",
    "dropdelcty": "PLEASANTVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "082329998",
    "dropphyadd": "752 BLACK HORSE PIKE",
    "dropphycty": "PLEASANTVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "082329998",
    "dropmaladd": "752 BLACK HORSE PIKE",
    "dropmalcty": "PLEASANTVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "082329998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096411858,
    "dropsitcph": 6096411858,
    "dropfax": 6096467465
  },
  {
    "dcode": "D",
    "dropkey": "PV11215",
    "droptype": "D",
    "dropname": "PLUCKEMIN",
    "dropdeladd": "318 US HIGHWAY 206",
    "dropdelcty": "PLUCKEMIN",
    "dropdelst": "NJ",
    "dropdelzpp": "079789800",
    "dropphyadd": "318 US HIGHWAY 206",
    "dropphycty": "PLUCKEMIN",
    "dropphyst": "NJ",
    "dropphyzpp": "079789800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLUCKEMIN",
    "dropmalst": "NJ",
    "dropmalzpp": "079789998",
    "dropsitphn": 9765157868,
    "dropsitlph": 9086583698,
    "dropsitcph": 9086583698,
    "dropfax": 6505774379
  },
  {
    "dcode": "D",
    "dropkey": "PV11220",
    "droptype": "D",
    "dropname": "POINT PLEASANT BEACH",
    "dropdeladd": "410 ARNOLD AVE",
    "dropdelcty": "POINT PLEASANT BEACH",
    "dropdelst": "NJ",
    "dropdelzpp": "087429998",
    "dropphyadd": "410 ARNOLD AVE",
    "dropphycty": "POINT PLEASANT BEACH",
    "dropphyst": "NJ",
    "dropphyzpp": "087429998",
    "dropmaladd": "410 ARNOLD AVE",
    "dropmalcty": "POINT PLEASANT BEACH",
    "dropmalst": "NJ",
    "dropmalzpp": "087429998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328994250,
    "dropfax": 7328990970
  },
  {
    "dcode": "D",
    "dropkey": "PV11221",
    "droptype": "D",
    "dropname": "POMONA",
    "dropdeladd": "269 W WHITE HORSE PIKE",
    "dropdelcty": "POMONA",
    "dropdelst": "NJ",
    "dropdelzpp": "082409998",
    "dropphyadd": "269 W WHITE HORSE PIKE",
    "dropphycty": "POMONA",
    "dropphyst": "NJ",
    "dropphyzpp": "082409998",
    "dropmaladd": "269 W WHITE HORSE PIKE",
    "dropmalcty": "POMONA",
    "dropmalst": "NJ",
    "dropmalzpp": "082409998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099651891,
    "dropsitcph": 6099651891,
    "dropfax": 6098040714
  },
  {
    "dcode": "D",
    "dropkey": "PV11224",
    "droptype": "D",
    "dropname": "POMPTON LAKES",
    "dropdeladd": "47 LAKESIDE AVE",
    "dropdelcty": "POMPTON LAKES",
    "dropdelst": "NJ",
    "dropdelzpp": "074429998",
    "dropphyadd": "47 LAKESIDE AVE",
    "dropphycty": "POMPTON LAKES",
    "dropphyst": "NJ",
    "dropphyzpp": "074429998",
    "dropmaladd": "47 LAKESIDE AVE",
    "dropmalcty": "POMPTON LAKES",
    "dropmalst": "NJ",
    "dropmalzpp": "074429998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738359364,
    "dropsitcph": 9738359364,
    "dropfax": 6505774069
  },
  {
    "dcode": "D",
    "dropkey": "PV11226",
    "droptype": "D",
    "dropname": "POMPTON PLAINS",
    "dropdeladd": "538 NEWARK POMPTON TPKE STE 1",
    "dropdelcty": "POMPTON PLAINS",
    "dropdelst": "NJ",
    "dropdelzpp": "074449998",
    "dropphyadd": "538 NEWARK POMPTON TPKE STE 1",
    "dropphycty": "POMPTON PLAINS",
    "dropphyst": "NJ",
    "dropphyzpp": "074449998",
    "dropmaladd": "538 NEWARK POMPTON TPKE STE 1",
    "dropmalcty": "POMPTON PLAINS",
    "dropmalst": "NJ",
    "dropmalzpp": "074449998",
    "dropsitphn": 9739559706,
    "dropsitlph": 9738354243,
    "dropsitcph": 9738354243,
    "dropfax": 6505774070
  },
  {
    "dcode": "D",
    "dropkey": "PV11230",
    "droptype": "D",
    "dropname": "PORT ELIZABETH",
    "dropdeladd": "3575 ROUTE 47",
    "dropdelcty": "PORT ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "083489998",
    "dropphyadd": "3575 ROUTE 47",
    "dropphycty": "PORT ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "083489998",
    "dropmaladd": "3575 ROUTE 47",
    "dropmalcty": "PORT ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "083489998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8563272609,
    "dropsitcph": 8563272609,
    "dropfax": 8568250390
  },
  {
    "dcode": "D",
    "dropkey": "PV11231",
    "droptype": "D",
    "dropname": "PORT MONMOUTH",
    "dropdeladd": "3 PULSCH ST",
    "dropdelcty": "PORT MONMOUTH",
    "dropdelst": "NJ",
    "dropdelzpp": "077589998",
    "dropphyadd": "3 PULSCH ST",
    "dropphycty": "PORT MONMOUTH",
    "dropphyst": "NJ",
    "dropphyzpp": "077589998",
    "dropmaladd": "3 PULSCH ST",
    "dropmalcty": "PORT MONMOUTH",
    "dropmalst": "NJ",
    "dropmalzpp": "077589998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327874310,
    "dropsitcph": 7327874310,
    "dropfax": 7324711979
  },
  {
    "dcode": "D",
    "dropkey": "PV11233",
    "droptype": "D",
    "dropname": "PORT MURRAY",
    "dropdeladd": "218 MAIN ST",
    "dropdelcty": "PORT MURRAY",
    "dropdelst": "NJ",
    "dropdelzpp": "078659998",
    "dropphyadd": "218 MAIN ST",
    "dropphycty": "PORT MURRAY",
    "dropphyst": "NJ",
    "dropphyzpp": "078659998",
    "dropmaladd": "218 MAIN ST",
    "dropmalcty": "PORT MURRAY",
    "dropmalst": "NJ",
    "dropmalzpp": "078659998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086892430,
    "dropsitcph": 9086892430,
    "dropfax": 6519943270
  },
  {
    "dcode": "D",
    "dropkey": "PV11235",
    "droptype": "D",
    "dropname": "PORT NORRIS",
    "dropdeladd": "1770 MAIN ST",
    "dropdelcty": "PORT NORRIS",
    "dropdelst": "NJ",
    "dropdelzpp": "083499998",
    "dropphyadd": "1770 MAIN ST",
    "dropphycty": "PORT NORRIS",
    "dropphyst": "NJ",
    "dropphyzpp": "083499998",
    "dropmaladd": "1770 MAIN ST",
    "dropmalcty": "PORT NORRIS",
    "dropmalst": "NJ",
    "dropmalzpp": "083499998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567850152,
    "dropsitcph": 8567850152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11236",
    "droptype": "D",
    "dropname": "PORT READING",
    "dropdeladd": "605 PORT READING AVE",
    "dropdelcty": "PORT READING",
    "dropdelst": "NJ",
    "dropdelzpp": "070649998",
    "dropphyadd": "605 PORT READING AVE",
    "dropphycty": "PORT READING",
    "dropphyst": "NJ",
    "dropphyzpp": "070649998",
    "dropmaladd": "605 PORT READING AVE",
    "dropmalcty": "PORT READING",
    "dropmalst": "NJ",
    "dropmalzpp": "070649998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7326346535,
    "dropsitcph": 7326346535,
    "dropfax": 6505774374
  },
  {
    "dcode": "D",
    "dropkey": "PV11237",
    "droptype": "D",
    "dropname": "PORT REPUBLIC",
    "dropdeladd": "207 CLARKS LANDING RD",
    "dropdelcty": "PORT REPUBLIC",
    "dropdelst": "NJ",
    "dropdelzpp": "082419998",
    "dropphyadd": "207 CLARKS LANDING RD",
    "dropphycty": "PORT REPUBLIC",
    "dropphyst": "NJ",
    "dropphyzpp": "082419998",
    "dropmaladd": "207 CLARKS LANDING RD",
    "dropmalcty": "PORT REPUBLIC",
    "dropmalst": "NJ",
    "dropmalzpp": "082419998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096527999,
    "dropsitcph": 6096527999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11241",
    "droptype": "D",
    "dropname": "POTTERSVILLE",
    "dropdeladd": "5 FAIRMOUNT RD E",
    "dropdelcty": "POTTERSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "079799800",
    "dropphyadd": "5 FAIRMOUNT RD E",
    "dropphycty": "POTTERSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "079799800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTTERSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "079799998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084392730,
    "dropsitcph": 9084392730,
    "dropfax": 6519943289
  },
  {
    "dcode": "D",
    "dropkey": "PV11245",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "213 CARNEGIE CTR",
    "dropdelcty": "PRINCETON",
    "dropdelst": "NJ",
    "dropdelzpp": "085409998",
    "dropphyadd": "213 CARNEGIE CTR",
    "dropphycty": "PRINCETON",
    "dropphyst": "NJ",
    "dropphyzpp": "085409998",
    "dropmaladd": "213 CARNEGIE CTR",
    "dropmalcty": "PRINCETON",
    "dropmalst": "NJ",
    "dropmalzpp": "085409998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094529044,
    "dropsitcph": 6094529044,
    "dropfax": 6094521853
  },
  {
    "dcode": "D",
    "dropkey": "PV11247",
    "droptype": "D",
    "dropname": "PRINCETON JUNCTION",
    "dropdeladd": "331 N POST RD",
    "dropdelcty": "PRINCETON JUNCTION",
    "dropdelst": "NJ",
    "dropdelzpp": "085509998",
    "dropphyadd": "331 N POST RD",
    "dropphycty": "PRINCETON JUNCTION",
    "dropphyst": "NJ",
    "dropphyzpp": "085509998",
    "dropmaladd": "331 N POST RD",
    "dropmalcty": "PRINCETON JUNCTION",
    "dropmalst": "NJ",
    "dropmalzpp": "085509998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097991054,
    "dropsitcph": 6097991054,
    "dropfax": 6097993221
  },
  {
    "dcode": "D",
    "dropkey": "PV11266",
    "droptype": "D",
    "dropname": "QUAKERTOWN",
    "dropdeladd": "289 WHITEBRIDGE RD",
    "dropdelcty": "QUAKERTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "088689800",
    "dropphyadd": "289 WHITEBRIDGE RD",
    "dropphycty": "QUAKERTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "088689800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUAKERTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "088689998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087354433,
    "dropfax": 6505775469
  },
  {
    "dcode": "D",
    "dropkey": "PV11268",
    "droptype": "D",
    "dropname": "QUINTON",
    "dropdeladd": "16 MAIN ST",
    "dropdelcty": "QUINTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080729998",
    "dropphyadd": "16 MAIN ST",
    "dropphycty": "QUINTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080729998",
    "dropmaladd": "16 MAIN ST",
    "dropmalcty": "QUINTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080729998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569357310,
    "dropsitcph": 8569357310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11271",
    "droptype": "D",
    "dropname": "RAHWAY",
    "dropdeladd": "123 E MILTON AVE",
    "dropdelcty": "RAHWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "070659998",
    "dropphyadd": "123 E MILTON AVE",
    "dropphycty": "RAHWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "070659998",
    "dropmaladd": "123 E MILTON AVE",
    "dropmalcty": "RAHWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "070659998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7323883264,
    "dropsitcph": 7323883264,
    "dropfax": 6505774211
  },
  {
    "dcode": "D",
    "dropkey": "PV11272",
    "droptype": "D",
    "dropname": "RAMSEY",
    "dropdeladd": "175 E MAIN ST",
    "dropdelcty": "RAMSEY",
    "dropdelst": "NJ",
    "dropdelzpp": "074469998",
    "dropphyadd": "175 E MAIN ST",
    "dropphycty": "RAMSEY",
    "dropphyst": "NJ",
    "dropphyzpp": "074469998",
    "dropmaladd": "175 E MAIN ST",
    "dropmalcty": "RAMSEY",
    "dropmalst": "NJ",
    "dropmalzpp": "074469998",
    "dropsitphn": 2017600892,
    "dropsitlph": 2017600892,
    "dropsitcph": 2019347503,
    "dropfax": 6505774117
  },
  {
    "dcode": "D",
    "dropkey": "PV11273",
    "droptype": "D",
    "dropname": "RANCOCAS",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "RANCOCAS",
    "dropdelst": "NJ",
    "dropdelzpp": "080739998",
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "RANCOCAS",
    "dropphyst": "NJ",
    "dropphyzpp": "080739998",
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "RANCOCAS",
    "dropmalst": "NJ",
    "dropmalzpp": "080739998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092612669,
    "dropsitcph": 6092612669,
    "dropfax": 6095182485
  },
  {
    "dcode": "D",
    "dropkey": "PV11277",
    "droptype": "D",
    "dropname": "RARITAN",
    "dropdeladd": "30 E SOMERSET ST",
    "dropdelcty": "RARITAN",
    "dropdelst": "NJ",
    "dropdelzpp": "088699998",
    "dropphyadd": "30 E SOMERSET ST",
    "dropphycty": "RARITAN",
    "dropphyst": "NJ",
    "dropphyzpp": "088699998",
    "dropmaladd": "30 E SOMERSET ST",
    "dropmalcty": "RARITAN",
    "dropmalst": "NJ",
    "dropmalzpp": "088699998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087253120,
    "dropfax": 6505775470
  },
  {
    "dcode": "D",
    "dropkey": "PV11278",
    "droptype": "D",
    "dropname": "READINGTON",
    "dropdeladd": "114 READINGTON RD BLDG 2",
    "dropdelcty": "READINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088709800",
    "dropphyadd": "114 READINGTON RD BLDG 2",
    "dropphycty": "READINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088709800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "READINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088709998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085346421,
    "dropfax": 6505775471
  },
  {
    "dcode": "D",
    "dropkey": "PV11284",
    "droptype": "D",
    "dropname": "RED BANK",
    "dropdeladd": "171 BROAD ST UNIT 1",
    "dropdelcty": "RED BANK",
    "dropdelst": "NJ",
    "dropdelzpp": "077019998",
    "dropphyadd": "171 BROAD ST UNIT 1",
    "dropphycty": "RED BANK",
    "dropphyst": "NJ",
    "dropphyzpp": "077019998",
    "dropmaladd": "171 BROAD ST UNIT 1",
    "dropmalcty": "RED BANK",
    "dropmalst": "NJ",
    "dropmalzpp": "077019998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327419200,
    "dropsitcph": 7327419200,
    "dropfax": 7327418335
  },
  {
    "dcode": "D",
    "dropkey": "PV11287",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "1276 HARDING HWY",
    "dropdelcty": "RICHLAND",
    "dropdelst": "NJ",
    "dropdelzpp": "083509998",
    "dropphyadd": "1276 HARDING HWY",
    "dropphycty": "RICHLAND",
    "dropphyst": "NJ",
    "dropphyzpp": "083509998",
    "dropmaladd": "1276 HARDING HWY",
    "dropmalcty": "RICHLAND",
    "dropmalst": "NJ",
    "dropmalzpp": "083509998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566972846,
    "dropsitcph": 8566972846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11288",
    "droptype": "D",
    "dropname": "RICHWOOD",
    "dropdeladd": "647 MULLICA HILL RD",
    "dropdelcty": "RICHWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "080749998",
    "dropphyadd": "647 MULLICA HILL RD",
    "dropphycty": "RICHWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "080749998",
    "dropmaladd": "647 MULLICA HILL RD",
    "dropmalcty": "RICHWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "080749998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565897788,
    "dropsitcph": 8565897788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11289",
    "droptype": "D",
    "dropname": "RIDGEFIELD",
    "dropdeladd": "757 BROAD AVE",
    "dropdelcty": "RIDGEFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "076579998",
    "dropphyadd": "757 BROAD AVE",
    "dropphycty": "RIDGEFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "076579998",
    "dropmaladd": "757 BROAD AVE",
    "dropmalcty": "RIDGEFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "076579998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2019438729,
    "dropsitcph": 2019438729,
    "dropfax": 2019438429
  },
  {
    "dcode": "D",
    "dropkey": "PV11290",
    "droptype": "D",
    "dropname": "RIDGEFIELD PARK",
    "dropdeladd": "155 MAIN ST",
    "dropdelcty": "RIDGEFIELD PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "076609998",
    "dropphyadd": "155 MAIN ST",
    "dropphycty": "RIDGEFIELD PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "076609998",
    "dropmaladd": "155 MAIN ST",
    "dropmalcty": "RIDGEFIELD PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "076609998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2016419038,
    "dropsitcph": 2016419038,
    "dropfax": 6505774105
  },
  {
    "dcode": "D",
    "dropkey": "PV11293",
    "droptype": "D",
    "dropname": "RIDGEWOOD",
    "dropdeladd": "143 E RIDGEWOOD AVE",
    "dropdelcty": "RIDGEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "074509998",
    "dropphyadd": "143 E RIDGEWOOD AVE",
    "dropphycty": "RIDGEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "074509998",
    "dropmaladd": "143 E RIDGEWOOD AVE",
    "dropmalcty": "RIDGEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "074509998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2014472135,
    "dropsitcph": 2014472135,
    "dropfax": 6505774199
  },
  {
    "dcode": "D",
    "dropkey": "PV11295",
    "droptype": "D",
    "dropname": "RINGOES",
    "dropdeladd": "1108 OLD YORK RD",
    "dropdelcty": "RINGOES",
    "dropdelst": "NJ",
    "dropdelzpp": "085519998",
    "dropphyadd": "1108 OLD YORK RD",
    "dropphycty": "RINGOES",
    "dropphyst": "NJ",
    "dropphyzpp": "085519998",
    "dropmaladd": "1108 OLD YORK RD",
    "dropmalcty": "RINGOES",
    "dropmalst": "NJ",
    "dropmalzpp": "085519998",
    "dropsitphn": 8569334046,
    "dropsitlph": 9087820166,
    "dropsitcph": 9087820166,
    "dropfax": 9088064723
  },
  {
    "dcode": "D",
    "dropkey": "PV11296",
    "droptype": "D",
    "dropname": "RINGWOOD",
    "dropdeladd": "130 SKYLINE DR STE 5",
    "dropdelcty": "RINGWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "074569998",
    "dropphyadd": "130 SKYLINE DR STE 5",
    "dropphycty": "RINGWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "074569998",
    "dropmaladd": "130 SKYLINE DR STE 5",
    "dropmalcty": "RINGWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "074569998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9739624956,
    "dropsitcph": 9739624956,
    "dropfax": 6503576333
  },
  {
    "dcode": "D",
    "dropkey": "PV11297",
    "droptype": "D",
    "dropname": "RIO GRANDE",
    "dropdeladd": "1087 ROUTE 47 S",
    "dropdelcty": "RIO GRANDE",
    "dropdelst": "NJ",
    "dropdelzpp": "082429998",
    "dropphyadd": "1087 ROUTE 47 S",
    "dropphycty": "RIO GRANDE",
    "dropphyst": "NJ",
    "dropphyzpp": "082429998",
    "dropmaladd": "1087 ROUTE 47 S",
    "dropmalcty": "RIO GRANDE",
    "dropmalst": "NJ",
    "dropmalzpp": "082429998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098861600,
    "dropsitcph": 6098861600,
    "dropfax": 6098864169
  },
  {
    "dcode": "D",
    "dropkey": "PV11300",
    "droptype": "D",
    "dropname": "RIVER EDGE",
    "dropdeladd": "650 KINDERKAMACK RD",
    "dropdelcty": "RIVER EDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "076619998",
    "dropphyadd": "650 KINDERKAMACK RD",
    "dropphycty": "RIVER EDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "076619998",
    "dropmaladd": "650 KINDERKAMACK RD",
    "dropmalcty": "RIVER EDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "076619998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012628585,
    "dropsitcph": 2012628585,
    "dropfax": 6505774393
  },
  {
    "dcode": "D",
    "dropkey": "PV11304",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "56 HAMBURG TPKE",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "074579998",
    "dropphyadd": "56 HAMBURG TPKE",
    "dropphycty": "RIVERDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "074579998",
    "dropmaladd": "56 HAMBURG TPKE",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "074579998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738354583,
    "dropsitcph": 9738354583,
    "dropfax": 6505774624
  },
  {
    "dcode": "D",
    "dropkey": "PV11306",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "4 W SCOTT ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "NJ",
    "dropdelzpp": "080759998",
    "dropphyadd": "4 W SCOTT ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "NJ",
    "dropphyzpp": "080759998",
    "dropmaladd": "4 W SCOTT ST",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "NJ",
    "dropmalzpp": "080759998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564610004,
    "dropsitcph": 8564610004,
    "dropfax": 8564615845
  },
  {
    "dcode": "D",
    "dropkey": "PV11307",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "605 MAIN ST STE 100",
    "dropdelcty": "RIVERTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080779998",
    "dropphyadd": "605 MAIN ST STE 100",
    "dropphycty": "RIVERTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080779998",
    "dropmaladd": "605 MAIN ST STE 100",
    "dropmalcty": "RIVERTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080779998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568298383,
    "dropsitcph": 8568298383,
    "dropfax": 8568294720
  },
  {
    "dcode": "D",
    "dropkey": "PV11310",
    "droptype": "D",
    "dropname": "ROCHELLE PARK",
    "dropdeladd": "231 ROCHELLE AVE",
    "dropdelcty": "ROCHELLE PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "076629998",
    "dropphyadd": "231 ROCHELLE AVE",
    "dropphycty": "ROCHELLE PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "076629998",
    "dropmaladd": "231 ROCHELLE AVE",
    "dropmalcty": "ROCHELLE PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "076629998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018434974,
    "dropsitcph": 2018437497,
    "dropfax": 6505774383
  },
  {
    "dcode": "D",
    "dropkey": "PV11312",
    "droptype": "D",
    "dropname": "ROCKAWAY",
    "dropdeladd": "1 BANK ST STE 9",
    "dropdelcty": "ROCKAWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "078669998",
    "dropphyadd": "1 BANK ST STE 9",
    "dropphycty": "ROCKAWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "078669998",
    "dropmaladd": "1 BANK ST STE 9",
    "dropmalcty": "ROCKAWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "078669998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328192372,
    "dropsitcph": 9736277039,
    "dropfax": 6505774010
  },
  {
    "dcode": "D",
    "dropkey": "PV11315",
    "droptype": "D",
    "dropname": "ROCKY HILL",
    "dropdeladd": "130 WASHINGTON ST",
    "dropdelcty": "ROCKY HILL",
    "dropdelst": "NJ",
    "dropdelzpp": "085539998",
    "dropphyadd": "130 WASHINGTON ST",
    "dropphycty": "ROCKY HILL",
    "dropphyst": "NJ",
    "dropphyzpp": "085539998",
    "dropmaladd": "130 WASHINGTON ST",
    "dropmalcty": "ROCKY HILL",
    "dropmalst": "NJ",
    "dropmalzpp": "085539998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099219096,
    "dropsitcph": 6099219096,
    "dropfax": 6099219096
  },
  {
    "dcode": "D",
    "dropkey": "PV11316",
    "droptype": "D",
    "dropname": "ROEBLING",
    "dropdeladd": "51 MAIN ST",
    "dropdelcty": "ROEBLING",
    "dropdelst": "NJ",
    "dropdelzpp": "085549998",
    "dropphyadd": "51 MAIN ST",
    "dropphycty": "ROEBLING",
    "dropphyst": "NJ",
    "dropphyzpp": "085549998",
    "dropmaladd": "51 MAIN ST",
    "dropmalcty": "ROEBLING",
    "dropmalst": "NJ",
    "dropmalzpp": "085549998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094990383,
    "dropsitcph": 6094990383,
    "dropfax": 6094990634
  },
  {
    "dcode": "D",
    "dropkey": "PV11317",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "1 FARM LN",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "NJ",
    "dropdelzpp": "085559998",
    "dropphyadd": "1 FARM LN",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "NJ",
    "dropphyzpp": "085559998",
    "dropmaladd": "1 FARM LN",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "NJ",
    "dropmalzpp": "085559998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094485105,
    "dropsitcph": 6094485105,
    "dropfax": 6094435604
  },
  {
    "dcode": "D",
    "dropkey": "PV11318",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "160 EAGLE ROCK AVE",
    "dropdelcty": "ROSELAND",
    "dropdelst": "NJ",
    "dropdelzpp": "070689998",
    "dropphyadd": "160 EAGLE ROCK AVE",
    "dropphycty": "ROSELAND",
    "dropphyst": "NJ",
    "dropphyzpp": "070689998",
    "dropmaladd": "160 EAGLE ROCK AVE",
    "dropmalcty": "ROSELAND",
    "dropmalst": "NJ",
    "dropmalzpp": "070689998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732262154,
    "dropsitcph": 9732262154,
    "dropfax": 6505774423
  },
  {
    "dcode": "D",
    "dropkey": "PV11322",
    "droptype": "D",
    "dropname": "ROSEMONT",
    "dropdeladd": "99 KINGWOOD STOCKTON RD",
    "dropdelcty": "ROSEMONT",
    "dropdelst": "NJ",
    "dropdelzpp": "085569998",
    "dropphyadd": "99 KINGWOOD STOCKTON RD",
    "dropphycty": "ROSEMONT",
    "dropphyst": "NJ",
    "dropphyzpp": "085569998",
    "dropmaladd": "99 KINGWOOD STOCKTON RD",
    "dropmalcty": "ROSEMONT",
    "dropmalst": "NJ",
    "dropmalzpp": "085569998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093972761,
    "dropsitcph": 6093972761,
    "dropfax": 6093972761
  },
  {
    "dcode": "D",
    "dropkey": "PV11323",
    "droptype": "D",
    "dropname": "ROSENHAYN",
    "dropdeladd": "522 MORTON AVE",
    "dropdelcty": "ROSENHAYN",
    "dropdelst": "NJ",
    "dropdelzpp": "083529998",
    "dropphyadd": "522 MORTON AVE",
    "dropphycty": "ROSENHAYN",
    "dropphyst": "NJ",
    "dropphyzpp": "083529998",
    "dropmaladd": "522 MORTON AVE",
    "dropmalcty": "ROSENHAYN",
    "dropmalst": "NJ",
    "dropmalzpp": "083529998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564553350,
    "dropsitcph": 8564553350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11326",
    "droptype": "D",
    "dropname": "RUMSON",
    "dropdeladd": "6 HUNT ST",
    "dropdelcty": "RUMSON",
    "dropdelst": "NJ",
    "dropdelzpp": "077609998",
    "dropphyadd": "6 HUNT ST",
    "dropphycty": "RUMSON",
    "dropphyst": "NJ",
    "dropphyzpp": "077609998",
    "dropmaladd": "6 HUNT ST",
    "dropmalcty": "RUMSON",
    "dropmalst": "NJ",
    "dropmalzpp": "077609998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7328420332,
    "dropsitcph": 7328420332,
    "dropfax": 7328420836
  },
  {
    "dcode": "D",
    "dropkey": "PV11327",
    "droptype": "D",
    "dropname": "RUNNEMEDE",
    "dropdeladd": "209 N BLACK HORSE PIKE",
    "dropdelcty": "RUNNEMEDE",
    "dropdelst": "NJ",
    "dropdelzpp": "080789998",
    "dropphyadd": "209 N BLACK HORSE PIKE",
    "dropphycty": "RUNNEMEDE",
    "dropphyst": "NJ",
    "dropphyzpp": "080789998",
    "dropmaladd": "209 N BLACK HORSE PIKE",
    "dropmalcty": "RUNNEMEDE",
    "dropmalst": "NJ",
    "dropmalzpp": "080789998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8563120385,
    "dropsitcph": 8563120385,
    "dropfax": 8563120385
  },
  {
    "dcode": "D",
    "dropkey": "PV11328",
    "droptype": "D",
    "dropname": "RUTHERFORD",
    "dropdeladd": "156 PARK AVE",
    "dropdelcty": "RUTHERFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "070709998",
    "dropphyadd": "156 PARK AVE",
    "dropphycty": "RUTHERFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "070709998",
    "dropmaladd": "156 PARK AVE",
    "dropmalcty": "RUTHERFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "070709998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019331214,
    "dropsitcph": 2019331214,
    "dropfax": 6505774252
  },
  {
    "dcode": "D",
    "dropkey": "PV11348",
    "droptype": "D",
    "dropname": "SADDLE RIVER",
    "dropdeladd": "177 E SADDLE RIVER RD STE 2",
    "dropdelcty": "SADDLE RIVER",
    "dropdelst": "NJ",
    "dropdelzpp": "074589998",
    "dropphyadd": "177 E SADDLE RIVER RD STE 2",
    "dropphycty": "SADDLE RIVER",
    "dropphyst": "NJ",
    "dropphyzpp": "074589998",
    "dropmaladd": "177 E SADDLE RIVER RD STE 2",
    "dropmalcty": "SADDLE RIVER",
    "dropmalst": "NJ",
    "dropmalzpp": "074589998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017609365,
    "dropsitcph": 2012362493,
    "dropfax": 6503576363
  },
  {
    "dcode": "D",
    "dropkey": "PV11350",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "120 W BROADWAY",
    "dropdelcty": "SALEM",
    "dropdelst": "NJ",
    "dropdelzpp": "080799998",
    "dropphyadd": "120 W BROADWAY",
    "dropphycty": "SALEM",
    "dropphyst": "NJ",
    "dropphyzpp": "080799998",
    "dropmaladd": "120 W BROADWAY",
    "dropmalcty": "SALEM",
    "dropmalst": "NJ",
    "dropmalzpp": "080799998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569355516,
    "dropsitcph": 8569355516,
    "dropfax": 8569358645
  },
  {
    "dcode": "D",
    "dropkey": "PV11354",
    "droptype": "D",
    "dropname": "SAYREVILLE",
    "dropdeladd": "90 MAIN ST",
    "dropdelcty": "SAYREVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "088729998",
    "dropphyadd": "90 MAIN ST",
    "dropphycty": "SAYREVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "088729998",
    "dropmaladd": "90 MAIN ST",
    "dropmalcty": "SAYREVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "088729998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322540027,
    "dropfax": 6505775472
  },
  {
    "dcode": "D",
    "dropkey": "PV11358",
    "droptype": "D",
    "dropname": "SCHOOLEYS MOUNTAIN",
    "dropdeladd": "250 SCHOOLEYS MOUNTAIN RD",
    "dropdelcty": "SCHOOLEYS MOUNTAIN",
    "dropdelst": "NJ",
    "dropdelzpp": "078709800",
    "dropphyadd": "250 SCHOOLEYS MOUNTAIN RD",
    "dropphycty": "SCHOOLEYS MOUNTAIN",
    "dropphyst": "NJ",
    "dropphyzpp": "078709800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHOOLEYS MOUNTAIN",
    "dropmalst": "NJ",
    "dropmalzpp": "078709998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9088524446,
    "dropsitcph": 9088524446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11364",
    "droptype": "D",
    "dropname": "SCOTCH PLAINS",
    "dropdeladd": "536 PARK AVE",
    "dropdelcty": "SCOTCH PLAINS",
    "dropdelst": "NJ",
    "dropdelzpp": "070769998",
    "dropphyadd": "536 PARK AVE",
    "dropphycty": "SCOTCH PLAINS",
    "dropphyst": "NJ",
    "dropphyzpp": "070769998",
    "dropmaladd": "536 PARK AVE",
    "dropmalcty": "SCOTCH PLAINS",
    "dropmalst": "NJ",
    "dropmalzpp": "070769998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9083220674,
    "dropsitcph": 9083220674,
    "dropfax": 6505774406
  },
  {
    "dcode": "D",
    "dropkey": "PV11368",
    "droptype": "D",
    "dropname": "SEA GIRT",
    "dropdeladd": "800 THE PLZ STE 10",
    "dropdelcty": "SEA GIRT",
    "dropdelst": "NJ",
    "dropdelzpp": "087509998",
    "dropphyadd": "800 THE PLZ STE 10",
    "dropphycty": "SEA GIRT",
    "dropphyst": "NJ",
    "dropphyzpp": "087509998",
    "dropmaladd": "800 THE PLZ STE 10",
    "dropmalcty": "SEA GIRT",
    "dropmalst": "NJ",
    "dropmalzpp": "087509998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7324499440,
    "dropfax": 7324496438
  },
  {
    "dcode": "D",
    "dropkey": "PV11369",
    "droptype": "D",
    "dropname": "SEA ISLE CITY",
    "dropdeladd": "145 JOHN F KENNEDY BLVD",
    "dropdelcty": "SEA ISLE CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "082439998",
    "dropphyadd": "145 JOHN F KENNEDY BLVD",
    "dropphycty": "SEA ISLE CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "082439998",
    "dropmaladd": "145 JOHN F KENNEDY BLVD",
    "dropmalcty": "SEA ISLE CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "082439998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092638878,
    "dropsitcph": 6092638878,
    "dropfax": 6092639382
  },
  {
    "dcode": "D",
    "dropkey": "PV11371",
    "droptype": "D",
    "dropname": "SEASIDE HEIGHTS",
    "dropdeladd": "55 SUMNER AVE",
    "dropdelcty": "SEASIDE HEIGHTS",
    "dropdelst": "NJ",
    "dropdelzpp": "087519998",
    "dropphyadd": "55 SUMNER AVE",
    "dropphycty": "SEASIDE HEIGHTS",
    "dropphyst": "NJ",
    "dropphyzpp": "087519998",
    "dropmaladd": "55 SUMNER AVE",
    "dropmalcty": "SEASIDE HEIGHTS",
    "dropmalst": "NJ",
    "dropmalzpp": "087519998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327938640,
    "dropfax": 7328304974
  },
  {
    "dcode": "D",
    "dropkey": "PV11372",
    "droptype": "D",
    "dropname": "SEASIDE PARK",
    "dropdeladd": "900 SE CENTRAL AVE",
    "dropdelcty": "SEASIDE PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "087529998",
    "dropphyadd": "900 SE CENTRAL AVE",
    "dropphycty": "SEASIDE PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "087529998",
    "dropmaladd": "900 SE CENTRAL AVE",
    "dropmalcty": "SEASIDE PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "087529998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327930377,
    "dropfax": 7327930367
  },
  {
    "dcode": "D",
    "dropkey": "PV11374",
    "droptype": "D",
    "dropname": "SECAUCUS",
    "dropdeladd": "300 COUNTY AVE",
    "dropdelcty": "SECAUCUS",
    "dropdelst": "NJ",
    "dropdelzpp": "070949998",
    "dropphyadd": "300 COUNTY AVE",
    "dropphycty": "SECAUCUS",
    "dropphyst": "NJ",
    "dropphyzpp": "070949998",
    "dropmaladd": "300 COUNTY AVE",
    "dropmalcty": "SECAUCUS",
    "dropmalst": "NJ",
    "dropmalzpp": "070949998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018671557,
    "dropsitcph": 2018671557,
    "dropfax": 6505774416
  },
  {
    "dcode": "D",
    "dropkey": "PV11376",
    "droptype": "D",
    "dropname": "SERGEANTSVILLE",
    "dropdeladd": "557 ROSEMONT RINGOES RD",
    "dropdelcty": "SERGEANTSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "085579998",
    "dropphyadd": "557 ROSEMONT RINGOES RD",
    "dropphycty": "SERGEANTSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "085579998",
    "dropmaladd": "557 ROSEMONT RINGOES RD",
    "dropmalcty": "SERGEANTSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "085579998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093970080,
    "dropsitcph": 6093970080,
    "dropfax": 6093972893
  },
  {
    "dcode": "D",
    "dropkey": "PV11377",
    "droptype": "D",
    "dropname": "SEWAREN",
    "dropdeladd": "85 WOODBRIDGE AVE",
    "dropdelcty": "SEWAREN",
    "dropdelst": "NJ",
    "dropdelzpp": "070779998",
    "dropphyadd": "85 WOODBRIDGE AVE",
    "dropphycty": "SEWAREN",
    "dropphyst": "NJ",
    "dropphyzpp": "070779998",
    "dropmaladd": "85 WOODBRIDGE AVE",
    "dropmalcty": "SEWAREN",
    "dropmalst": "NJ",
    "dropmalzpp": "070779998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7326344936,
    "dropsitcph": 7326344936,
    "dropfax": 6505774678
  },
  {
    "dcode": "D",
    "dropkey": "PV11378",
    "droptype": "D",
    "dropname": "SEWELL",
    "dropdeladd": "141 CENTER ST",
    "dropdelcty": "SEWELL",
    "dropdelst": "NJ",
    "dropdelzpp": "080809998",
    "dropphyadd": "141 CENTER ST",
    "dropphycty": "SEWELL",
    "dropphyst": "NJ",
    "dropphyzpp": "080809998",
    "dropmaladd": "141 CENTER ST",
    "dropmalcty": "SEWELL",
    "dropmalst": "NJ",
    "dropmalzpp": "080809998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564680811,
    "dropsitcph": 8564681010,
    "dropfax": 8564681647
  },
  {
    "dcode": "D",
    "dropkey": "PV11388",
    "droptype": "D",
    "dropname": "SHILOH",
    "dropdeladd": "966 MAIN ST",
    "dropdelcty": "SHILOH",
    "dropdelst": "NJ",
    "dropdelzpp": "083539998",
    "dropphyadd": "966 MAIN ST",
    "dropphycty": "SHILOH",
    "dropphyst": "NJ",
    "dropphyzpp": "083539998",
    "dropmaladd": "966 MAIN ST",
    "dropmalcty": "SHILOH",
    "dropmalst": "NJ",
    "dropmalzpp": "083539998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564511252,
    "dropsitcph": 8564511252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11391",
    "droptype": "D",
    "dropname": "SHORT HILLS",
    "dropdeladd": "30 CHATHAM RD",
    "dropdelcty": "SHORT HILLS",
    "dropdelst": "NJ",
    "dropdelzpp": "070789998",
    "dropphyadd": "30 CHATHAM RD",
    "dropphycty": "SHORT HILLS",
    "dropphyst": "NJ",
    "dropphyzpp": "070789998",
    "dropmaladd": "30 CHATHAM RD",
    "dropmalcty": "SHORT HILLS",
    "dropmalst": "NJ",
    "dropmalzpp": "070789998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733795214,
    "dropsitcph": 9733795214,
    "dropfax": 6505774429
  },
  {
    "dcode": "D",
    "dropkey": "PV11396",
    "droptype": "D",
    "dropname": "SICKLERVILLE",
    "dropdeladd": "415 SICKLERVILLE RD",
    "dropdelcty": "SICKLERVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "080819998",
    "dropphyadd": "415 SICKLERVILLE RD",
    "dropphycty": "SICKLERVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "080819998",
    "dropmaladd": "415 SICKLERVILLE RD",
    "dropmalcty": "SICKLERVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "080819998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566297068,
    "dropsitcph": 8566297068,
    "dropfax": 8566294269
  },
  {
    "dcode": "D",
    "dropkey": "PV11402",
    "droptype": "D",
    "dropname": "SKILLMAN",
    "dropdeladd": "950 ROUTE 601",
    "dropdelcty": "SKILLMAN",
    "dropdelst": "NJ",
    "dropdelzpp": "085589998",
    "dropphyadd": "950 ROUTE 601",
    "dropphycty": "SKILLMAN",
    "dropphyst": "NJ",
    "dropphyzpp": "085589998",
    "dropmaladd": "950 ROUTE 601",
    "dropmalcty": "SKILLMAN",
    "dropmalst": "NJ",
    "dropmalzpp": "085589998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094661420,
    "dropsitcph": 6094661420,
    "dropfax": 6094665316
  },
  {
    "dcode": "D",
    "dropkey": "PV11421",
    "droptype": "D",
    "dropname": "SOMERDALE",
    "dropdeladd": "26 S WHITE HORSE PIKE",
    "dropdelcty": "SOMERDALE",
    "dropdelst": "NJ",
    "dropdelzpp": "080839998",
    "dropphyadd": "26 S WHITE HORSE PIKE",
    "dropphycty": "SOMERDALE",
    "dropphyst": "NJ",
    "dropphyzpp": "080839998",
    "dropmaladd": "26 S WHITE HORSE PIKE",
    "dropmalcty": "SOMERDALE",
    "dropmalst": "NJ",
    "dropmalzpp": "080839998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567820742,
    "dropsitcph": 8567820742,
    "dropfax": 8564353991
  },
  {
    "dcode": "D",
    "dropkey": "PV11422",
    "droptype": "D",
    "dropname": "SOMERS POINT",
    "dropdeladd": "325 W GROVELAND AVE",
    "dropdelcty": "SOMERS POINT",
    "dropdelst": "NJ",
    "dropdelzpp": "082449998",
    "dropphyadd": "325 W GROVELAND AVE",
    "dropphycty": "SOMERS POINT",
    "dropphyst": "NJ",
    "dropphyzpp": "082449998",
    "dropmaladd": "325 W GROVELAND AVE",
    "dropmalcty": "SOMERS POINT",
    "dropmalst": "NJ",
    "dropmalzpp": "082449998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099275757,
    "dropsitcph": 6099275757,
    "dropfax": 6099275928
  },
  {
    "dcode": "D",
    "dropkey": "PV11424",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "500 DEMOTT LN",
    "dropdelcty": "SOMERSET",
    "dropdelst": "NJ",
    "dropdelzpp": "088739998",
    "dropphyadd": "500 DEMOTT LN",
    "dropphycty": "SOMERSET",
    "dropphyst": "NJ",
    "dropphyzpp": "088739998",
    "dropmaladd": "500 DEMOTT LN",
    "dropmalcty": "SOMERSET",
    "dropmalst": "NJ",
    "dropmalzpp": "088739998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328738600,
    "dropfax": 6505774175
  },
  {
    "dcode": "D",
    "dropkey": "PV11425",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "39 DIVISION ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "088769998",
    "dropphyadd": "39 DIVISION ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "088769998",
    "dropmaladd": "39 DIVISION ST",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "088769998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087250570,
    "dropfax": 6505775473
  },
  {
    "dcode": "D",
    "dropkey": "PV11430",
    "droptype": "D",
    "dropname": "SOUTH AMBOY",
    "dropdeladd": "209 S BROADWAY",
    "dropdelcty": "SOUTH AMBOY",
    "dropdelst": "NJ",
    "dropdelzpp": "088799998",
    "dropphyadd": "209 S BROADWAY",
    "dropphycty": "SOUTH AMBOY",
    "dropphyst": "NJ",
    "dropphyzpp": "088799998",
    "dropmaladd": "209 S BROADWAY",
    "dropmalcty": "SOUTH AMBOY",
    "dropmalst": "NJ",
    "dropmalzpp": "088799998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327210937,
    "dropfax": 6505775474
  },
  {
    "dcode": "D",
    "dropkey": "PV11432",
    "droptype": "D",
    "dropname": "SOUTH BOUND BROOK",
    "dropdeladd": "11 MADISON ST",
    "dropdelcty": "SOUTH BOUND BROOK",
    "dropdelst": "NJ",
    "dropdelzpp": "088809998",
    "dropphyadd": "11 MADISON ST",
    "dropphycty": "SOUTH BOUND BROOK",
    "dropphyst": "NJ",
    "dropphyzpp": "088809998",
    "dropmaladd": "11 MADISON ST",
    "dropmalcty": "SOUTH BOUND BROOK",
    "dropmalst": "NJ",
    "dropmalzpp": "088809998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323561255,
    "dropfax": 6505775475
  },
  {
    "dcode": "D",
    "dropkey": "PV11439",
    "droptype": "D",
    "dropname": "SOUTH DENNIS",
    "dropdeladd": "231 COUNTY RD",
    "dropdelcty": "SOUTH DENNIS",
    "dropdelst": "NJ",
    "dropdelzpp": "082459998",
    "dropphyadd": "231 COUNTY RD",
    "dropphycty": "SOUTH DENNIS",
    "dropphyst": "NJ",
    "dropphyzpp": "082459998",
    "dropmaladd": "231 COUNTY RD",
    "dropmalcty": "SOUTH DENNIS",
    "dropmalst": "NJ",
    "dropmalzpp": "082459998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098612436,
    "dropsitcph": 6098612436,
    "dropfax": 6098612436
  },
  {
    "dcode": "D",
    "dropkey": "PV11445",
    "droptype": "D",
    "dropname": "SOUTH ORANGE",
    "dropdeladd": "31 VOSE AVE",
    "dropdelcty": "SOUTH ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070799998",
    "dropphyadd": "31 VOSE AVE",
    "dropphycty": "SOUTH ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070799998",
    "dropmaladd": "31 VOSE AVE",
    "dropmalcty": "SOUTH ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070799998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737622872,
    "dropsitcph": 9737622872,
    "dropfax": 6505774092
  },
  {
    "dcode": "D",
    "dropkey": "PV11448",
    "droptype": "D",
    "dropname": "SOUTH PLAINFIELD",
    "dropdeladd": "114 OAK TREE AVE",
    "dropdelcty": "SOUTH PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070809998",
    "dropphyadd": "114 OAK TREE AVE",
    "dropphycty": "SOUTH PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070809998",
    "dropmaladd": "114 OAK TREE AVE",
    "dropmalcty": "SOUTH PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070809998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087562432,
    "dropsitcph": 9087562432,
    "dropfax": 9087560446
  },
  {
    "dcode": "D",
    "dropkey": "PV11449",
    "droptype": "D",
    "dropname": "SOUTH RIVER",
    "dropdeladd": "44 OBERT ST",
    "dropdelcty": "SOUTH RIVER",
    "dropdelst": "NJ",
    "dropdelzpp": "088829998",
    "dropphyadd": "44 OBERT ST",
    "dropphycty": "SOUTH RIVER",
    "dropphyst": "NJ",
    "dropphyzpp": "088829998",
    "dropmaladd": "44 OBERT ST",
    "dropmalcty": "SOUTH RIVER",
    "dropmalst": "NJ",
    "dropmalzpp": "088829998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322541475,
    "dropfax": 6505775476
  },
  {
    "dcode": "D",
    "dropkey": "PV11451",
    "droptype": "D",
    "dropname": "SOUTH SEAVILLE",
    "dropdeladd": "493 KINGS HWY",
    "dropdelcty": "SOUTH SEAVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "082469998",
    "dropphyadd": "493 KINGS HWY",
    "dropphycty": "SOUTH SEAVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "082469998",
    "dropmaladd": "493 KINGS HWY",
    "dropmalcty": "SOUTH SEAVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "082469998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096241387,
    "dropsitcph": 6096241387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11457",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "2 MAIN ST STE 1",
    "dropdelcty": "SPARTA",
    "dropdelst": "NJ",
    "dropdelzpp": "078719998",
    "dropphyadd": "2 MAIN ST STE 1",
    "dropphycty": "SPARTA",
    "dropphyst": "NJ",
    "dropphyzpp": "078719998",
    "dropmaladd": "2 MAIN ST STE 1",
    "dropmalcty": "SPARTA",
    "dropmalst": "NJ",
    "dropmalzpp": "078719998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9737297444,
    "dropsitcph": 9737297444,
    "dropfax": 6505774737
  },
  {
    "dcode": "D",
    "dropkey": "PV11460",
    "droptype": "D",
    "dropname": "SPOTSWOOD",
    "dropdeladd": "436 MAIN ST",
    "dropdelcty": "SPOTSWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "088849998",
    "dropphyadd": "436 MAIN ST",
    "dropphycty": "SPOTSWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "088849998",
    "dropmaladd": "436 MAIN ST",
    "dropmalcty": "SPOTSWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "088849998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322513668,
    "dropfax": 6505775477
  },
  {
    "dcode": "D",
    "dropkey": "PV11463",
    "droptype": "D",
    "dropname": "SPRING LAKE",
    "dropdeladd": "2407 STATE ROUTE 71 STE 1",
    "dropdelcty": "SPRING LAKE",
    "dropdelst": "NJ",
    "dropdelzpp": "077629998",
    "dropphyadd": "2407 STATE ROUTE 71 STE 1",
    "dropphycty": "SPRING LAKE",
    "dropphyst": "NJ",
    "dropphyzpp": "077629998",
    "dropmaladd": "2407 STATE ROUTE 71 STE 1",
    "dropmalcty": "SPRING LAKE",
    "dropmalst": "NJ",
    "dropmalzpp": "077629998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324495120,
    "dropsitcph": 7324495120,
    "dropfax": 7324492167
  },
  {
    "dcode": "D",
    "dropkey": "PV11466",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "210 MOUNTAIN AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070819998",
    "dropphyadd": "210 MOUNTAIN AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070819998",
    "dropmaladd": "210 MOUNTAIN AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070819998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9739242013,
    "dropsitcph": 9739242013,
    "dropfax": 6505774375
  },
  {
    "dcode": "D",
    "dropkey": "PV11499",
    "droptype": "D",
    "dropname": "STANHOPE",
    "dropdeladd": "4 KELLY PL",
    "dropdelcty": "STANHOPE",
    "dropdelst": "NJ",
    "dropdelzpp": "078749998",
    "dropphyadd": "4 KELLY PL",
    "dropphycty": "STANHOPE",
    "dropphyst": "NJ",
    "dropphyzpp": "078749998",
    "dropmaladd": "4 KELLY PL",
    "dropmalcty": "STANHOPE",
    "dropmalst": "NJ",
    "dropmalzpp": "078749998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733472338,
    "dropsitcph": 9733472338,
    "dropfax": 6505774039
  },
  {
    "dcode": "D",
    "dropkey": "PV11500",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "2 STANTON MOUNTAIN RD",
    "dropdelcty": "STANTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088859800",
    "dropphyadd": "2 STANTON MOUNTAIN RD",
    "dropphycty": "STANTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088859800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088859998",
    "dropsitphn": 7328193630,
    "dropsitlph": 6505775478,
    "dropsitcph": 9082366104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11509",
    "droptype": "D",
    "dropname": "STEWARTSVILLE",
    "dropdeladd": "731 STATE ROUTE 57",
    "dropdelcty": "STEWARTSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "088869998",
    "dropphyadd": "731 STATE ROUTE 57",
    "dropphycty": "STEWARTSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "088869998",
    "dropmaladd": "731 STATE ROUTE 57",
    "dropmalcty": "STEWARTSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "088869998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9088591428,
    "dropfax": 6505774249
  },
  {
    "dcode": "D",
    "dropkey": "PV11512",
    "droptype": "D",
    "dropname": "STILLWATER",
    "dropdeladd": "912 MAIN ST",
    "dropdelcty": "STILLWATER",
    "dropdelst": "NJ",
    "dropdelzpp": "078759800",
    "dropphyadd": "912 MAIN ST",
    "dropphycty": "STILLWATER",
    "dropphyst": "NJ",
    "dropphyzpp": "078759800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STILLWATER",
    "dropmalst": "NJ",
    "dropmalzpp": "078759998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733837747,
    "dropsitcph": 9733837747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11513",
    "droptype": "D",
    "dropname": "STIRLING",
    "dropdeladd": "1153 VALLEY RD STE 8",
    "dropdelcty": "STIRLING",
    "dropdelst": "NJ",
    "dropdelzpp": "079809998",
    "dropphyadd": "1153 VALLEY RD STE 8",
    "dropphycty": "STIRLING",
    "dropphyst": "NJ",
    "dropphyzpp": "079809998",
    "dropmaladd": "1153 VALLEY RD STE 8",
    "dropmalcty": "STIRLING",
    "dropmalst": "NJ",
    "dropmalzpp": "079809998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086470206,
    "dropsitcph": 9086470206,
    "dropfax": 6516751462
  },
  {
    "dcode": "D",
    "dropkey": "PV11514",
    "droptype": "D",
    "dropname": "STOCKHOLM",
    "dropdeladd": "2741 STATE RT 23 STE 4",
    "dropdelcty": "STOCKHOLM",
    "dropdelst": "NJ",
    "dropdelzpp": "074601306",
    "dropphyadd": "2741 STATE RT 23 STE 4",
    "dropphycty": "STOCKHOLM",
    "dropphyst": "NJ",
    "dropphyzpp": "074601306",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKHOLM",
    "dropmalst": "NJ",
    "dropmalzpp": "074609998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736978732,
    "dropsitcph": 9736978732,
    "dropfax": 6505774034
  },
  {
    "dcode": "D",
    "dropkey": "PV11515",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "2 BRIDGE ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "NJ",
    "dropdelzpp": "085599998",
    "dropphyadd": "2 BRIDGE ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "NJ",
    "dropphyzpp": "085599998",
    "dropmaladd": "2 BRIDGE ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "NJ",
    "dropmalzpp": "085599998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093970940,
    "dropsitcph": 6093970940,
    "dropfax": 6093970658
  },
  {
    "dcode": "D",
    "dropkey": "PV11516",
    "droptype": "D",
    "dropname": "STONE HARBOR",
    "dropdeladd": "9601 2ND AVE",
    "dropdelcty": "STONE HARBOR",
    "dropdelst": "NJ",
    "dropdelzpp": "082479998",
    "dropphyadd": "9601 2ND AVE",
    "dropphycty": "STONE HARBOR",
    "dropphyst": "NJ",
    "dropphyzpp": "082479998",
    "dropmaladd": "9601 2ND AVE",
    "dropmalcty": "STONE HARBOR",
    "dropmalst": "NJ",
    "dropmalzpp": "082479998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6093682565,
    "dropsitcph": 6093682565,
    "dropfax": 6093686779
  },
  {
    "dcode": "D",
    "dropkey": "PV11518",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "190 WARWICK RD",
    "dropdelcty": "STRATFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "080849998",
    "dropphyadd": "190 WARWICK RD",
    "dropphycty": "STRATFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "080849998",
    "dropmaladd": "190 WARWICK RD",
    "dropmalcty": "STRATFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "080849998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567835252,
    "dropsitcph": 8567835252,
    "dropfax": 8567839761
  },
  {
    "dcode": "D",
    "dropkey": "PV11520",
    "droptype": "D",
    "dropname": "STRATHMERE",
    "dropdeladd": "9 COMMONWEALTH AVE",
    "dropdelcty": "STRATHMERE",
    "dropdelst": "NJ",
    "dropdelzpp": "082489998",
    "dropphyadd": "9 COMMONWEALTH AVE",
    "dropphycty": "STRATHMERE",
    "dropphyst": "NJ",
    "dropphyzpp": "082489998",
    "dropmaladd": "9 COMMONWEALTH AVE",
    "dropmalcty": "STRATHMERE",
    "dropmalst": "NJ",
    "dropmalzpp": "082489998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092637434,
    "dropsitcph": 6092637434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11523",
    "droptype": "D",
    "dropname": "SUCCASUNNA",
    "dropdeladd": "1 ROXBURY MALL",
    "dropdelcty": "SUCCASUNNA",
    "dropdelst": "NJ",
    "dropdelzpp": "078769998",
    "dropphyadd": "1 ROXBURY MALL",
    "dropphycty": "SUCCASUNNA",
    "dropphyst": "NJ",
    "dropphyzpp": "078769998",
    "dropmaladd": "1 ROXBURY MALL",
    "dropmalcty": "SUCCASUNNA",
    "dropmalst": "NJ",
    "dropmalzpp": "078769998",
    "dropsitphn": 9735842022,
    "dropsitlph": 9735842022,
    "dropsitcph": 9735842022,
    "dropfax": 6505772546
  },
  {
    "dcode": "D",
    "dropkey": "PV11525",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "61 MAPLE ST",
    "dropdelcty": "SUMMIT",
    "dropdelst": "NJ",
    "dropdelzpp": "079019998",
    "dropphyadd": "61 MAPLE ST",
    "dropphycty": "SUMMIT",
    "dropphyst": "NJ",
    "dropphyzpp": "079019998",
    "dropmaladd": "61 MAPLE ST",
    "dropmalcty": "SUMMIT",
    "dropmalst": "NJ",
    "dropmalzpp": "079019998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9082771737,
    "dropsitcph": 9082771737,
    "dropfax": 6519943287
  },
  {
    "dcode": "D",
    "dropkey": "PV11531",
    "droptype": "D",
    "dropname": "SUSSEX",
    "dropdeladd": "455 STATE RT 23 STE 5",
    "dropdelcty": "SUSSEX",
    "dropdelst": "NJ",
    "dropdelzpp": "074619998",
    "dropphyadd": "455 STATE RT 23 STE 5",
    "dropphycty": "SUSSEX",
    "dropphyst": "NJ",
    "dropphyzpp": "074619998",
    "dropmaladd": "455 STATE RT 23 STE 5",
    "dropmalcty": "SUSSEX",
    "dropmalst": "NJ",
    "dropmalzpp": "074619998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738757410,
    "dropsitcph": 9738757410,
    "dropfax": 6505774316
  },
  {
    "dcode": "D",
    "dropkey": "PV11533",
    "droptype": "D",
    "dropname": "SWARTSWOOD",
    "dropdeladd": "1064 COUNTY ROAD 521",
    "dropdelcty": "SWARTSWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "078779800",
    "dropphyadd": "1064 COUNTY ROAD 521",
    "dropphycty": "SWARTSWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "078779800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWARTSWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "078779998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733839995,
    "dropsitcph": 9733839995,
    "dropfax": 6505774065
  },
  {
    "dcode": "D",
    "dropkey": "PV11534",
    "droptype": "D",
    "dropname": "SWEDESBORO",
    "dropdeladd": "1950 KINGS HWY",
    "dropdelcty": "SWEDESBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080859998",
    "dropphyadd": "1950 KINGS HWY",
    "dropphycty": "SWEDESBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080859998",
    "dropmaladd": "1950 KINGS HWY",
    "dropmalcty": "SWEDESBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080859998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564670270,
    "dropsitcph": 8564670270,
    "dropfax": 6503576543
  },
  {
    "dcode": "D",
    "dropkey": "PV11546",
    "droptype": "D",
    "dropname": "TEANECK",
    "dropdeladd": "751 PALISADE AVE",
    "dropdelcty": "TEANECK",
    "dropdelst": "NJ",
    "dropdelzpp": "076669998",
    "dropphyadd": "751 PALISADE AVE",
    "dropphycty": "TEANECK",
    "dropphyst": "NJ",
    "dropphyzpp": "076669998",
    "dropmaladd": "751 PALISADE AVE",
    "dropmalcty": "TEANECK",
    "dropmalst": "NJ",
    "dropmalzpp": "076669998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018367214,
    "dropsitcph": 2018367214,
    "dropfax": 6505774402
  },
  {
    "dcode": "D",
    "dropkey": "PV11547",
    "droptype": "D",
    "dropname": "TENAFLY",
    "dropdeladd": "400 TENAFLY RD",
    "dropdelcty": "TENAFLY",
    "dropdelst": "NJ",
    "dropdelzpp": "076709998",
    "dropphyadd": "400 TENAFLY RD",
    "dropphycty": "TENAFLY",
    "dropphyst": "NJ",
    "dropphyzpp": "076709998",
    "dropmaladd": "400 TENAFLY RD",
    "dropmalcty": "TENAFLY",
    "dropmalst": "NJ",
    "dropmalzpp": "076709998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015681467,
    "dropsitcph": 2015683518,
    "dropfax": 6505774422
  },
  {
    "dcode": "D",
    "dropkey": "PV11548",
    "droptype": "D",
    "dropname": "TENNENT",
    "dropdeladd": "420 MAIN ST",
    "dropdelcty": "TENNENT",
    "dropdelst": "NJ",
    "dropdelzpp": "077639998",
    "dropphyadd": "420 MAIN ST",
    "dropphycty": "TENNENT",
    "dropphyst": "NJ",
    "dropphyzpp": "077639998",
    "dropmaladd": "420 MAIN ST",
    "dropmalcty": "TENNENT",
    "dropmalst": "NJ",
    "dropmalzpp": "077639998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324466822,
    "dropsitcph": 7324466822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11554",
    "droptype": "D",
    "dropname": "THOROFARE",
    "dropdeladd": "300 CROWN POINT RD UNIT A",
    "dropdelcty": "WEST DEPTFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "080869998",
    "dropphyadd": "300 CROWN POINT RD UNIT A",
    "dropphycty": "WEST DEPTFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "080869998",
    "dropmaladd": "300 CROWN POINT RD UNIT A",
    "dropmalcty": "WEST DEPTFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "080869998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8568480320,
    "dropsitcph": 8568480320,
    "dropfax": 8568455615
  },
  {
    "dcode": "D",
    "dropkey": "PV11556",
    "droptype": "D",
    "dropname": "THREE BRIDGES",
    "dropdeladd": "39 BROAD ST",
    "dropdelcty": "THREE BRIDGES",
    "dropdelst": "NJ",
    "dropdelzpp": "088879800",
    "dropphyadd": "39 BROAD ST",
    "dropphycty": "THREE BRIDGES",
    "dropphyst": "NJ",
    "dropphyzpp": "088879800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THREE BRIDGES",
    "dropmalst": "NJ",
    "dropmalzpp": "088879998",
    "dropsitphn": 7328193630,
    "dropsitlph": 6505775479,
    "dropsitcph": 9087823898,
    "dropfax": 9087823898
  },
  {
    "dcode": "D",
    "dropkey": "PV11559",
    "droptype": "D",
    "dropname": "TITUSVILLE",
    "dropdeladd": "1380 RIVER RD",
    "dropdelcty": "TITUSVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "085609998",
    "dropphyadd": "1380 RIVER RD",
    "dropphycty": "TITUSVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "085609998",
    "dropmaladd": "1380 RIVER RD",
    "dropmalcty": "TITUSVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "085609998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097372337,
    "dropsitcph": 6097372337,
    "dropfax": 6097372337
  },
  {
    "dcode": "D",
    "dropkey": "PV11560",
    "droptype": "D",
    "dropname": "TOMS RIVER",
    "dropdeladd": "130 W WATER ST",
    "dropdelcty": "TOMS RIVER",
    "dropdelst": "NJ",
    "dropdelzpp": "087539998",
    "dropphyadd": "130 W WATER ST",
    "dropphycty": "TOMS RIVER",
    "dropphyst": "NJ",
    "dropphyzpp": "087539998",
    "dropmaladd": "130 W WATER ST",
    "dropmalcty": "TOMS RIVER",
    "dropmalst": "NJ",
    "dropmalzpp": "087539998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323490710,
    "dropfax": 7322863025
  },
  {
    "dcode": "D",
    "dropkey": "PV11563",
    "droptype": "D",
    "dropname": "TOWACO",
    "dropdeladd": "666 MAIN RD",
    "dropdelcty": "TOWACO",
    "dropdelst": "NJ",
    "dropdelzpp": "070829998",
    "dropphyadd": "666 MAIN RD",
    "dropphycty": "TOWACO",
    "dropphyst": "NJ",
    "dropphyzpp": "070829998",
    "dropmaladd": "666 MAIN RD",
    "dropmalcty": "TOWACO",
    "dropmalst": "NJ",
    "dropmalzpp": "070829998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733340743,
    "dropsitcph": 9733340743,
    "dropfax": 6503576537
  },
  {
    "dcode": "D",
    "dropkey": "PV11571",
    "droptype": "D",
    "dropname": "TRANQUILITY",
    "dropdeladd": "28 KENNEDY RD",
    "dropdelcty": "TRANQUILITY",
    "dropdelst": "NJ",
    "dropdelzpp": "078799800",
    "dropphyadd": "28 KENNEDY RD",
    "dropphycty": "TRANQUILITY",
    "dropphyst": "NJ",
    "dropphyzpp": "078799800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRANQUILITY",
    "dropmalst": "NJ",
    "dropmalzpp": "078799998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9088520648,
    "dropsitcph": 9088520648,
    "dropfax": 6516751537
  },
  {
    "dcode": "D",
    "dropkey": "PV11575",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "680 US HIGHWAY 130",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086509998",
    "dropphyadd": "680 US HIGHWAY 130",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086509998",
    "dropmaladd": "680 US HIGHWAY 130",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086509998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 6095813001,
    "dropfax": 6095819514
  },
  {
    "dcode": "D",
    "dropkey": "PV11579",
    "droptype": "D",
    "dropname": "TUCKAHOE",
    "dropdeladd": "2250 ROUTE 50",
    "dropdelcty": "TUCKAHOE",
    "dropdelst": "NJ",
    "dropdelzpp": "082509998",
    "dropphyadd": "2250 ROUTE 50",
    "dropphycty": "TUCKAHOE",
    "dropphyst": "NJ",
    "dropphyzpp": "082509998",
    "dropmaladd": "2250 ROUTE 50",
    "dropmalcty": "TUCKAHOE",
    "dropmalst": "NJ",
    "dropmalzpp": "082509998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096282152,
    "dropsitcph": 6096282152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11580",
    "droptype": "D",
    "dropname": "TUCKERTON",
    "dropdeladd": "139 E MAIN ST",
    "dropdelcty": "TUCKERTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080879998",
    "dropphyadd": "139 E MAIN ST",
    "dropphycty": "TUCKERTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080879998",
    "dropmaladd": "139 E MAIN ST",
    "dropmalcty": "TUCKERTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080879998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092941858,
    "dropsitcph": 6092941858,
    "dropfax": 6092963826
  },
  {
    "dcode": "D",
    "dropkey": "PV11586",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "1130 W CHESTNUT ST",
    "dropdelcty": "UNION",
    "dropdelst": "NJ",
    "dropdelzpp": "070839998",
    "dropphyadd": "1130 W CHESTNUT ST",
    "dropphycty": "UNION",
    "dropphyst": "NJ",
    "dropphyzpp": "070839998",
    "dropmaladd": "1130 W CHESTNUT ST",
    "dropmalcty": "UNION",
    "dropmalst": "NJ",
    "dropmalzpp": "070839998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9086880600,
    "dropsitcph": 9083786129,
    "dropfax": 6505774362
  },
  {
    "dcode": "D",
    "dropkey": "PV11592",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "301 30TH ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070879998",
    "dropphyadd": "301 30TH ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070879998",
    "dropmaladd": "301 30TH ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070879998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2918670081,
    "dropsitcph": 2018672576,
    "dropfax": 6505774431
  },
  {
    "dcode": "D",
    "dropkey": "PV11623",
    "droptype": "D",
    "dropname": "VAUXHALL",
    "dropdeladd": "2215 SPRINGFIELD AVE",
    "dropdelcty": "VAUXHALL",
    "dropdelst": "NJ",
    "dropdelzpp": "070889998",
    "dropphyadd": "2215 SPRINGFIELD AVE",
    "dropphycty": "VAUXHALL",
    "dropphyst": "NJ",
    "dropphyzpp": "070889998",
    "dropmaladd": "2215 SPRINGFIELD AVE",
    "dropmalcty": "VAUXHALL",
    "dropmalst": "NJ",
    "dropmalzpp": "070889998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9086862341,
    "dropsitcph": 9086862341,
    "dropfax": 6505774361
  },
  {
    "dcode": "D",
    "dropkey": "PV11629",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "530 COUNTY ROUTE 515 UNIT 13",
    "dropdelcty": "VERNON",
    "dropdelst": "NJ",
    "dropdelzpp": "074629997",
    "dropphyadd": "530 COUNTY ROUTE 515 UNIT 13",
    "dropphycty": "VERNON",
    "dropphyst": "NJ",
    "dropphyzpp": "074629997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERNON",
    "dropmalst": "NJ",
    "dropmalzpp": "074629998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737649056,
    "dropsitcph": 9737649056,
    "dropfax": 6505774031
  },
  {
    "dcode": "D",
    "dropkey": "PV11631",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "7 WATER ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "NJ",
    "dropdelzpp": "078809800",
    "dropphyadd": "7 WATER ST",
    "dropphycty": "VIENNA",
    "dropphyst": "NJ",
    "dropphyzpp": "078809800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIENNA",
    "dropmalst": "NJ",
    "dropmalzpp": "078809998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086374691,
    "dropsitcph": 9086374691,
    "dropfax": 6505774042
  },
  {
    "dcode": "D",
    "dropkey": "PV11633",
    "droptype": "D",
    "dropname": "VILLAS",
    "dropdeladd": "1814 BAYSHORE RD STE 1",
    "dropdelcty": "VILLAS",
    "dropdelst": "NJ",
    "dropdelzpp": "082519998",
    "dropphyadd": "1814 BAYSHORE RD STE 1",
    "dropphycty": "VILLAS",
    "dropphyst": "NJ",
    "dropphyzpp": "082519998",
    "dropmaladd": "1814 BAYSHORE RD STE 1",
    "dropmalcty": "VILLAS",
    "dropmalst": "NJ",
    "dropmalzpp": "082519998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098863197,
    "dropsitcph": 6098863197,
    "dropfax": 6098864854
  },
  {
    "dcode": "D",
    "dropkey": "PV11634",
    "droptype": "D",
    "dropname": "VINCENTOWN",
    "dropdeladd": "1813 ROUTE 206",
    "dropdelcty": "SOUTHAMPTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080889998",
    "dropphyadd": "1813 ROUTE 206",
    "dropphycty": "SOUTHAMPTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080889998",
    "dropmaladd": "1813 ROUTE 206",
    "dropmalcty": "SOUTHAMPTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080889998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098592485,
    "dropsitcph": 6098592485,
    "dropfax": 6098590261
  },
  {
    "dcode": "D",
    "dropkey": "PV11636",
    "droptype": "D",
    "dropname": "VINELAND",
    "dropdeladd": "722 E LANDIS AVE",
    "dropdelcty": "VINELAND",
    "dropdelst": "NJ",
    "dropdelzpp": "083609998",
    "dropphyadd": "722 E LANDIS AVE",
    "dropphycty": "VINELAND",
    "dropphyst": "NJ",
    "dropphyzpp": "083609998",
    "dropmaladd": "722 E LANDIS AVE",
    "dropmalcty": "VINELAND",
    "dropmalst": "NJ",
    "dropmalzpp": "083609998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566911206,
    "dropsitcph": 8566911206,
    "dropfax": 8566911701
  },
  {
    "dcode": "D",
    "dropkey": "PV11656",
    "droptype": "D",
    "dropname": "WALDWICK",
    "dropdeladd": "1 WALTER HAMMOND PL",
    "dropdelcty": "WALDWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "074639998",
    "dropphyadd": "1 WALTER HAMMOND PL",
    "dropphycty": "WALDWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "074639998",
    "dropmaladd": "1 WALTER HAMMOND PL",
    "dropmalcty": "WALDWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "074639998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2014473058,
    "dropsitcph": 2014473058,
    "dropfax": 6505774095
  },
  {
    "dcode": "D",
    "dropkey": "PV11667",
    "droptype": "D",
    "dropname": "WANAQUE",
    "dropdeladd": "500 RINGWOOD AVE",
    "dropdelcty": "WANAQUE",
    "dropdelst": "NJ",
    "dropdelzpp": "074659998",
    "dropphyadd": "500 RINGWOOD AVE",
    "dropphycty": "WANAQUE",
    "dropphyst": "NJ",
    "dropphyzpp": "074659998",
    "dropmaladd": "500 RINGWOOD AVE",
    "dropmalcty": "WANAQUE",
    "dropmalst": "NJ",
    "dropmalzpp": "074659998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9738355674,
    "dropsitcph": 9738355674,
    "dropfax": 6505774064
  },
  {
    "dcode": "D",
    "dropkey": "PV11670",
    "droptype": "D",
    "dropname": "WARETOWN",
    "dropdeladd": "529 ROUTE 9 STE 17",
    "dropdelcty": "WARETOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "087589998",
    "dropphyadd": "529 ROUTE 9 STE 17",
    "dropphycty": "WARETOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "087589998",
    "dropmaladd": "529 ROUTE 9 STE 17",
    "dropmalcty": "WARETOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "087589998",
    "dropsitphn": 6096933683,
    "dropsitlph": 6096933683,
    "dropsitcph": 6096933683,
    "dropfax": 6092421683
  },
  {
    "dcode": "D",
    "dropkey": "PV11675",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "36 BELVIDERE AVE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "078829998",
    "dropphyadd": "36 BELVIDERE AVE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "078829998",
    "dropmaladd": "36 BELVIDERE AVE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "078829998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9086890443,
    "dropsitcph": 9086890443,
    "dropfax": 6505774075
  },
  {
    "dcode": "D",
    "dropkey": "PV11687",
    "droptype": "D",
    "dropname": "WATERFORD WORKS",
    "dropdeladd": "5 N WHITE HORSE PIKE",
    "dropdelcty": "WATERFORD WORKS",
    "dropdelst": "NJ",
    "dropdelzpp": "080899998",
    "dropphyadd": "5 N WHITE HORSE PIKE",
    "dropphycty": "WATERFORD WORKS",
    "dropphyst": "NJ",
    "dropphyzpp": "080899998",
    "dropmaladd": "5 N WHITE HORSE PIKE",
    "dropmalcty": "WATERFORD WORKS",
    "dropmalst": "NJ",
    "dropmalzpp": "080899998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567672322,
    "dropsitcph": 8567672322,
    "dropfax": 8567671761
  },
  {
    "dcode": "D",
    "dropkey": "PV11690",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "150 POMPTON PLAINS XRD",
    "dropdelcty": "WAYNE",
    "dropdelst": "NJ",
    "dropdelzpp": "074709994",
    "dropphyadd": "150 POMPTON PLAINS XRD",
    "dropphycty": "WAYNE",
    "dropphyst": "NJ",
    "dropphyzpp": "074709994",
    "dropmaladd": "150 POMPTON PLAINS XRD",
    "dropmalcty": "WAYNE",
    "dropmalst": "NJ",
    "dropmalzpp": "074709994",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736940308,
    "dropsitcph": 9736940308,
    "dropfax": 6505774134
  },
  {
    "dcode": "D",
    "dropkey": "PV11695",
    "droptype": "D",
    "dropname": "WENONAH",
    "dropdeladd": "4 S WEST AVE",
    "dropdelcty": "WENONAH",
    "dropdelst": "NJ",
    "dropdelzpp": "080909998",
    "dropphyadd": "4 S WEST AVE",
    "dropphycty": "WENONAH",
    "dropphyst": "NJ",
    "dropphyzpp": "080909998",
    "dropmaladd": "4 S WEST AVE",
    "dropmalcty": "WENONAH",
    "dropmalst": "NJ",
    "dropmalzpp": "080909998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564686156,
    "dropsitcph": 8564686156,
    "dropfax": 8564641604
  },
  {
    "dcode": "D",
    "dropkey": "PV11704",
    "droptype": "D",
    "dropname": "WEST BERLIN",
    "dropdeladd": "118 WALKER AVE",
    "dropdelcty": "WEST BERLIN",
    "dropdelst": "NJ",
    "dropdelzpp": "080919998",
    "dropphyadd": "118 WALKER AVE",
    "dropphycty": "WEST BERLIN",
    "dropphyst": "NJ",
    "dropphyzpp": "080919998",
    "dropmaladd": "118 WALKER AVE",
    "dropmalcty": "WEST BERLIN",
    "dropmalst": "NJ",
    "dropmalzpp": "080919998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567672003,
    "dropsitcph": 8567672003,
    "dropfax": 8567531587
  },
  {
    "dcode": "D",
    "dropkey": "PV11710",
    "droptype": "D",
    "dropname": "WEST CREEK",
    "dropdeladd": "194 ROUTE 9",
    "dropdelcty": "WEST CREEK",
    "dropdelst": "NJ",
    "dropdelzpp": "080929998",
    "dropphyadd": "194 ROUTE 9",
    "dropphycty": "WEST CREEK",
    "dropphyst": "NJ",
    "dropphyzpp": "080929998",
    "dropmaladd": "194 ROUTE 9",
    "dropmalcty": "WEST CREEK",
    "dropmalst": "NJ",
    "dropmalzpp": "080929998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6092975195,
    "dropsitcph": 6092975195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11723",
    "droptype": "D",
    "dropname": "WEST LONG BRANCH",
    "dropdeladd": "183 LOCUST AVE",
    "dropdelcty": "WEST LONG BRANCH",
    "dropdelst": "NJ",
    "dropdelzpp": "077649998",
    "dropphyadd": "183 LOCUST AVE",
    "dropphycty": "WEST LONG BRANCH",
    "dropphyst": "NJ",
    "dropphyzpp": "077649998",
    "dropmaladd": "183 LOCUST AVE",
    "dropmalcty": "WEST LONG BRANCH",
    "dropmalst": "NJ",
    "dropmalzpp": "077649998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322227588,
    "dropsitcph": 7322227588,
    "dropfax": 7322630875
  },
  {
    "dcode": "D",
    "dropkey": "PV11724",
    "droptype": "D",
    "dropname": "WEST MILFORD",
    "dropdeladd": "1560 UNION VALLEY RD",
    "dropdelcty": "WEST MILFORD",
    "dropdelst": "NJ",
    "dropdelzpp": "074809998",
    "dropphyadd": "1560 UNION VALLEY RD",
    "dropphycty": "WEST MILFORD",
    "dropphyst": "NJ",
    "dropphyzpp": "074809998",
    "dropmaladd": "1560 UNION VALLEY RD",
    "dropmalcty": "WEST MILFORD",
    "dropmalst": "NJ",
    "dropmalzpp": "074809998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737287847,
    "dropsitcph": 9737287847,
    "dropfax": 6505774068
  },
  {
    "dcode": "D",
    "dropkey": "PV11728",
    "droptype": "D",
    "dropname": "WEST NEW YORK",
    "dropdeladd": "5415 BERGENLINE AVE",
    "dropdelcty": "WEST NEW YORK",
    "dropdelst": "NJ",
    "dropdelzpp": "070939998",
    "dropphyadd": "5415 BERGENLINE AVE",
    "dropphycty": "WEST NEW YORK",
    "dropphyst": "NJ",
    "dropphyzpp": "070939998",
    "dropmaladd": "5415 BERGENLINE AVE",
    "dropmalcty": "WEST NEW YORK",
    "dropmalst": "NJ",
    "dropmalzpp": "070939998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018655796,
    "dropsitcph": 2018655796,
    "dropfax": 6505774027
  },
  {
    "dcode": "D",
    "dropkey": "PV11753",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "153 CENTRAL AVE",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070909998",
    "dropphyadd": "153 CENTRAL AVE",
    "dropphycty": "WESTFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070909998",
    "dropmaladd": "153 CENTRAL AVE",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070909998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9082334053,
    "dropsitcph": 9082334053,
    "dropfax": 6505774424
  },
  {
    "dcode": "D",
    "dropkey": "PV11756",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "329 BROADWAY",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "080939998",
    "dropphyadd": "329 BROADWAY",
    "dropphycty": "WESTVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "080939998",
    "dropmaladd": "329 BROADWAY",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "080939998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564560699,
    "dropsitcph": 8564560699,
    "dropfax": 8564563541
  },
  {
    "dcode": "D",
    "dropkey": "PV11759",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "216 WESTWOOD AVE",
    "dropdelcty": "WESTWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "076759998",
    "dropphyadd": "216 WESTWOOD AVE",
    "dropphycty": "WESTWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "076759998",
    "dropmaladd": "216 WESTWOOD AVE",
    "dropmalcty": "WESTWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076759998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2012631066,
    "dropsitcph": 2012631066,
    "dropfax": 6505774118
  },
  {
    "dcode": "D",
    "dropkey": "PV11762",
    "droptype": "D",
    "dropname": "WHARTON",
    "dropdeladd": "350 N MAIN ST STE 7",
    "dropdelcty": "WHARTON",
    "dropdelst": "NJ",
    "dropdelzpp": "078859998",
    "dropphyadd": "350 N MAIN ST STE 7",
    "dropphycty": "WHARTON",
    "dropphyst": "NJ",
    "dropphyzpp": "078859998",
    "dropmaladd": "350 N MAIN ST STE 7",
    "dropmalcty": "WHARTON",
    "dropmalst": "NJ",
    "dropmalzpp": "078859998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9733664779,
    "dropsitcph": 9733664779,
    "dropfax": 6505774318
  },
  {
    "dcode": "D",
    "dropkey": "PV11766",
    "droptype": "D",
    "dropname": "WHITEHOUSE",
    "dropdeladd": "366 US HIGHWAY 22",
    "dropdelcty": "WHITEHOUSE",
    "dropdelst": "NJ",
    "dropdelzpp": "088889801",
    "dropphyadd": "366 US HIGHWAY 22",
    "dropphycty": "WHITEHOUSE",
    "dropphyst": "NJ",
    "dropphyzpp": "088889801",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITEHOUSE",
    "dropmalst": "NJ",
    "dropmalzpp": "088889998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085342271,
    "dropfax": 6505775480
  },
  {
    "dcode": "D",
    "dropkey": "PV11767",
    "droptype": "D",
    "dropname": "WHITEHOUSE STATION",
    "dropdeladd": "273 MAIN ST",
    "dropdelcty": "WHITEHOUSE STATION",
    "dropdelst": "NJ",
    "dropdelzpp": "088899998",
    "dropphyadd": "273 MAIN ST",
    "dropphycty": "WHITEHOUSE STATION",
    "dropphyst": "NJ",
    "dropphyzpp": "088899998",
    "dropmaladd": "273 MAIN ST",
    "dropmalcty": "WHITEHOUSE STATION",
    "dropmalst": "NJ",
    "dropmalzpp": "088899998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085342737,
    "dropfax": 6505775481
  },
  {
    "dcode": "D",
    "dropkey": "PV11768",
    "droptype": "D",
    "dropname": "WHITESBORO",
    "dropdeladd": "6 E MAIN ST",
    "dropdelcty": "WHITESBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "082529904",
    "dropphyadd": "6 E MAIN ST",
    "dropphycty": "WHITESBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "082529904",
    "dropmaladd": "6 E MAIN ST",
    "dropmalcty": "WHITESBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "082529904",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094638289,
    "dropsitcph": 6094638289,
    "dropfax": 6094638289
  },
  {
    "dcode": "D",
    "dropkey": "PV11773",
    "droptype": "D",
    "dropname": "WICKATUNK",
    "dropdeladd": "248 STATE ROUTE 79",
    "dropdelcty": "WICKATUNK",
    "dropdelst": "NJ",
    "dropdelzpp": "077659998",
    "dropphyadd": "248 STATE ROUTE 79",
    "dropphycty": "WICKATUNK",
    "dropphyst": "NJ",
    "dropphyzpp": "077659998",
    "dropmaladd": "248 STATE ROUTE 79",
    "dropmalcty": "WICKATUNK",
    "dropmalst": "NJ",
    "dropmalzpp": "077659998",
    "dropsitphn": 8569334046,
    "dropsitlph": 7329469798,
    "dropsitcph": 7329469798,
    "dropfax": 7329463642
  },
  {
    "dcode": "D",
    "dropkey": "PV11775",
    "droptype": "D",
    "dropname": "WILDWOOD",
    "dropdeladd": "3311 ATLANTIC AVE",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "082609998",
    "dropphyadd": "3311 ATLANTIC AVE",
    "dropphycty": "WILDWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "082609998",
    "dropmaladd": "3311 ATLANTIC AVE",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "082609998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095221088,
    "dropsitcph": 6095221088,
    "dropfax": 6095223885
  },
  {
    "dcode": "D",
    "dropkey": "PV11778",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "135 S BLACK HORSE PIKE",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080949998",
    "dropphyadd": "135 S BLACK HORSE PIKE",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080949998",
    "dropmaladd": "135 S BLACK HORSE PIKE",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080949998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567287492,
    "dropsitcph": 8567287492,
    "dropfax": 8566297325
  },
  {
    "dcode": "D",
    "dropkey": "PV11781",
    "droptype": "D",
    "dropname": "WILLINGBORO",
    "dropdeladd": "16 REV DR MARTIN LUTHER KING JR DR",
    "dropdelcty": "WILLINGBORO",
    "dropdelst": "NJ",
    "dropdelzpp": "080469998",
    "dropphyadd": "16 REV DR MARTIN LUTHER KING JR DR",
    "dropphycty": "WILLINGBORO",
    "dropphyst": "NJ",
    "dropphyzpp": "080469998",
    "dropmaladd": "16 REV DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "WILLINGBORO",
    "dropmalst": "NJ",
    "dropmalzpp": "080469998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098772148,
    "dropsitcph": 6098772148,
    "dropfax": 6098776449
  },
  {
    "dcode": "D",
    "dropkey": "PV11784",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "39 S MAIN ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "NJ",
    "dropdelzpp": "085619998",
    "dropphyadd": "39 S MAIN ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "NJ",
    "dropphyzpp": "085619998",
    "dropmaladd": "39 S MAIN ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "NJ",
    "dropmalzpp": "085619998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6094486655,
    "dropsitcph": 6094486655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11789",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "48 HALL ST",
    "dropdelcty": "WINSLOW",
    "dropdelst": "NJ",
    "dropdelzpp": "080959998",
    "dropphyadd": "48 HALL ST",
    "dropphycty": "WINSLOW",
    "dropphyst": "NJ",
    "dropphyzpp": "080959998",
    "dropmaladd": "48 HALL ST",
    "dropmalcty": "WINSLOW",
    "dropmalst": "NJ",
    "dropmalzpp": "080959998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6095615658,
    "dropsitcph": 6095615658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11794",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "642 WASHINGTON AVE",
    "dropdelcty": "WOODBINE",
    "dropdelst": "NJ",
    "dropdelzpp": "082709998",
    "dropphyadd": "642 WASHINGTON AVE",
    "dropphycty": "WOODBINE",
    "dropphyst": "NJ",
    "dropphyzpp": "082709998",
    "dropmaladd": "642 WASHINGTON AVE",
    "dropmalcty": "WOODBINE",
    "dropmalst": "NJ",
    "dropmalzpp": "082709998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6098614291,
    "dropsitcph": 6098614291,
    "dropfax": 6098610028
  },
  {
    "dcode": "D",
    "dropkey": "PV11795",
    "droptype": "D",
    "dropname": "WOODBRIDGE",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070959998",
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070959998",
    "dropmaladd": "60 MAIN ST",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070959998",
    "dropsitphn": 2019559705,
    "dropsitlph": 7326344985,
    "dropsitcph": 7326344985,
    "dropfax": 6505774417
  },
  {
    "dcode": "D",
    "dropkey": "PV11796",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "35 N BROAD ST",
    "dropdelcty": "WOODBURY",
    "dropdelst": "NJ",
    "dropdelzpp": "080969998",
    "dropphyadd": "35 N BROAD ST",
    "dropphycty": "WOODBURY",
    "dropphyst": "NJ",
    "dropphyzpp": "080969998",
    "dropmaladd": "35 N BROAD ST",
    "dropmalcty": "WOODBURY",
    "dropmalst": "NJ",
    "dropmalzpp": "080969998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8562326785,
    "dropsitcph": 8562326785,
    "dropfax": 8568455802
  },
  {
    "dcode": "D",
    "dropkey": "PV11809",
    "droptype": "D",
    "dropname": "WOODSTOWN",
    "dropdeladd": "35 EAST AVE OFC 1",
    "dropdelcty": "WOODSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "080989998",
    "dropphyadd": "35 EAST AVE OFC 1",
    "dropphycty": "WOODSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "080989998",
    "dropmaladd": "35 EAST AVE OFC 1",
    "dropmalcty": "WOODSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "080989998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567690377,
    "dropsitcph": 8567690377,
    "dropfax": 8567693880
  },
  {
    "dcode": "D",
    "dropkey": "PV11811",
    "droptype": "D",
    "dropname": "WRIGHTSTOWN",
    "dropdeladd": "10 E MAIN ST",
    "dropdelcty": "WRIGHTSTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "085629998",
    "dropphyadd": "10 E MAIN ST",
    "dropphycty": "WRIGHTSTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "085629998",
    "dropmaladd": "10 E MAIN ST",
    "dropmalcty": "WRIGHTSTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "085629998",
    "dropsitphn": 8569334046,
    "dropsitlph": 6097235324,
    "dropsitcph": 6097235324,
    "dropfax": 6097235514
  },
  {
    "dcode": "D",
    "dropkey": "PV11812",
    "droptype": "D",
    "dropname": "WYCKOFF",
    "dropdeladd": "411 GREENWOOD AVE",
    "dropdelcty": "WYCKOFF",
    "dropdelst": "NJ",
    "dropdelzpp": "074819998",
    "dropphyadd": "411 GREENWOOD AVE",
    "dropphycty": "WYCKOFF",
    "dropphyst": "NJ",
    "dropphyzpp": "074819998",
    "dropmaladd": "411 GREENWOOD AVE",
    "dropmalcty": "WYCKOFF",
    "dropmalst": "NJ",
    "dropmalzpp": "074819998",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015609982,
    "dropsitcph": 2015609982,
    "dropfax": 6516751592
  },
  {
    "dcode": "D",
    "dropkey": "PV11822",
    "droptype": "D",
    "dropname": "ACCORD",
    "dropdeladd": "30 MAIN ST",
    "dropdelcty": "ACCORD",
    "dropdelst": "NY",
    "dropdelzpp": 124049998,
    "dropphyadd": "30 MAIN ST",
    "dropphycty": "ACCORD",
    "dropphyst": "NY",
    "dropphyzpp": 124049998,
    "dropmaladd": "30 MAIN ST",
    "dropmalcty": "ACCORD",
    "dropmalst": "NY",
    "dropmalzpp": 124049998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456265881,
    "dropsitcph": 8456265881,
    "dropfax": 8456264303
  },
  {
    "dcode": "D",
    "dropkey": "PV11823",
    "droptype": "D",
    "dropname": "ACRA",
    "dropdeladd": "522 OLD ROUTE 23",
    "dropdelcty": "ACRA",
    "dropdelst": "NY",
    "dropdelzpp": 124059998,
    "dropphyadd": "522 OLD ROUTE 23",
    "dropphycty": "ACRA",
    "dropphyst": "NY",
    "dropphyzpp": 124059998,
    "dropmaladd": "522 OLD ROUTE 23",
    "dropmalcty": "ACRA",
    "dropmalst": "NY",
    "dropmalzpp": 124059998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186229202,
    "dropsitcph": 5186229202,
    "dropfax": 5186220647
  },
  {
    "dcode": "D",
    "dropkey": "PV11824",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "27 E CHURCH ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "NY",
    "dropdelzpp": 136059998,
    "dropphyadd": "27 E CHURCH ST",
    "dropphycty": "ADAMS",
    "dropphyst": "NY",
    "dropphyzpp": 136059998,
    "dropmaladd": "27 E CHURCH ST",
    "dropmalcty": "ADAMS",
    "dropmalst": "NY",
    "dropmalzpp": 136059998,
    "dropsitphn": 3152322312,
    "dropsitlph": 3152322312,
    "dropsitcph": 3152322312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11825",
    "droptype": "D",
    "dropname": "ADAMS BASIN",
    "dropdeladd": "4303 CANAL RD",
    "dropdelcty": "ADAMS BASIN",
    "dropdelst": "NY",
    "dropdelzpp": 144109998,
    "dropphyadd": "4303 CANAL RD",
    "dropphycty": "ADAMS BASIN",
    "dropphyst": "NY",
    "dropphyzpp": 144109998,
    "dropmaladd": "4303 CANAL RD",
    "dropmalcty": "ADAMS BASIN",
    "dropmalst": "NY",
    "dropmalzpp": 144109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853491221,
    "dropsitcph": 5853491221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11826",
    "droptype": "D",
    "dropname": "ADAMS CENTER",
    "dropdeladd": "13346 NORTH ST",
    "dropdelcty": "ADAMS CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 136069998,
    "dropphyadd": "13346 NORTH ST",
    "dropphycty": "ADAMS CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 136069998,
    "dropmaladd": "13346 NORTH ST",
    "dropmalcty": "ADAMS CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 136069998,
    "dropsitphn": 3155835811,
    "dropsitlph": 3155835811,
    "dropsitcph": 3155835811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11830",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "150 FRONT ST",
    "dropdelcty": "ADDISON",
    "dropdelst": "NY",
    "dropdelzpp": 148019998,
    "dropphyadd": "150 FRONT ST",
    "dropphycty": "ADDISON",
    "dropphyst": "NY",
    "dropphyzpp": 148019998,
    "dropmaladd": "150 FRONT ST",
    "dropmalcty": "ADDISON",
    "dropmalst": "NY",
    "dropmalzpp": 148019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073592136,
    "dropsitcph": 6073592136,
    "dropfax": 7163592155
  },
  {
    "dcode": "D",
    "dropkey": "PV11832",
    "droptype": "D",
    "dropname": "ADIRONDACK",
    "dropdeladd": "5 RED WING RD",
    "dropdelcty": "ADIRONDACK",
    "dropdelst": "NY",
    "dropdelzpp": 128089998,
    "dropphyadd": "5 RED WING RD",
    "dropphycty": "ADIRONDACK",
    "dropphyst": "NY",
    "dropphyzpp": 128089998,
    "dropmaladd": "5 RED WING RD",
    "dropmalcty": "ADIRONDACK",
    "dropmalst": "NY",
    "dropmalzpp": 128089998,
    "dropsitphn": 5187595411,
    "dropsitlph": 5187595411,
    "dropsitcph": 5187595411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11834",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "89 MAIN ST",
    "dropdelcty": "AFTON",
    "dropdelst": "NY",
    "dropdelzpp": 137309998,
    "dropphyadd": "89 MAIN ST",
    "dropphycty": "AFTON",
    "dropphyst": "NY",
    "dropphyzpp": 137309998,
    "dropmaladd": "89 MAIN ST",
    "dropmalcty": "AFTON",
    "dropmalst": "NY",
    "dropmalzpp": 137309998,
    "dropsitphn": 6076392831,
    "dropsitlph": 6076392831,
    "dropsitcph": 6076392831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11839",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "AKRON",
    "dropdelst": "NY",
    "dropdelzpp": 140019998,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "AKRON",
    "dropphyst": "NY",
    "dropphyzpp": 140019998,
    "dropmaladd": "118 MAIN ST",
    "dropmalcty": "AKRON",
    "dropmalst": "NY",
    "dropmalzpp": 140019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165429756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11842",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "30 KARNER RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122889998,
    "dropphyadd": "30 KARNER RD",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122889998,
    "dropmaladd": "30 KARNER RD",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122889998,
    "dropsitphn": 5184522367,
    "dropsitlph": 5184522314,
    "dropsitcph": 5184522286,
    "dropfax": 5184522203
  },
  {
    "dcode": "D",
    "dropkey": "PV11845",
    "droptype": "D",
    "dropname": "ALBERTSON",
    "dropdeladd": "860 WILLIS AVE",
    "dropdelcty": "ALBERTSON",
    "dropdelst": "NY",
    "dropdelzpp": 115071952,
    "dropphyadd": "860 WILLIS AVE",
    "dropphycty": "ALBERTSON",
    "dropphyst": "NY",
    "dropphyzpp": 115071952,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBERTSON",
    "dropmalst": "NY",
    "dropmalzpp": 115079998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167463512,
    "dropfax": 5162481042
  },
  {
    "dcode": "D",
    "dropkey": "PV11847",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "8 S MAIN ST",
    "dropdelcty": "ALBION",
    "dropdelst": "NY",
    "dropdelzpp": 144119998,
    "dropphyadd": "8 S MAIN ST",
    "dropphycty": "ALBION",
    "dropphyst": "NY",
    "dropphyzpp": 144119998,
    "dropmaladd": "8 S MAIN ST",
    "dropmalcty": "ALBION",
    "dropmalst": "NY",
    "dropmalzpp": 144119998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855895928,
    "dropsitcph": 5855895928,
    "dropfax": 5855894782
  },
  {
    "dcode": "D",
    "dropkey": "PV11849",
    "droptype": "D",
    "dropname": "ALCOVE",
    "dropdeladd": "83 COUNTY ROUTE 111",
    "dropdelcty": "ALCOVE",
    "dropdelst": "NY",
    "dropdelzpp": 120079998,
    "dropphyadd": "83 COUNTY ROUTE 111",
    "dropphycty": "ALCOVE",
    "dropphyst": "NY",
    "dropphyzpp": 120079998,
    "dropmaladd": "83 COUNTY ROUTE 111",
    "dropmalcty": "ALCOVE",
    "dropmalst": "NY",
    "dropmalzpp": 120079998,
    "dropsitphn": 5187592006,
    "dropsitlph": 5187592006,
    "dropsitcph": 5187592006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11850",
    "droptype": "D",
    "dropname": "ALDEN",
    "dropdeladd": "13127 BROADWAY ST",
    "dropdelcty": "ALDEN",
    "dropdelst": "NY",
    "dropdelzpp": 140049998,
    "dropphyadd": "13127 BROADWAY ST",
    "dropphycty": "ALDEN",
    "dropphyst": "NY",
    "dropphyzpp": 140049998,
    "dropmaladd": "13127 BROADWAY ST",
    "dropmalcty": "ALDEN",
    "dropmalst": "NY",
    "dropmalzpp": 140049998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169376020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11855",
    "droptype": "D",
    "dropname": "ALDER CREEK",
    "dropdeladd": "11440 STATE ROUTE 12",
    "dropdelcty": "ALDER CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 133019998,
    "dropphyadd": "11440 STATE ROUTE 12",
    "dropphycty": "ALDER CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 133019998,
    "dropmaladd": "11440 STATE ROUTE 12",
    "dropmalcty": "ALDER CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 133019998,
    "dropsitphn": 3158315986,
    "dropsitlph": 3158315986,
    "dropsitcph": 3158315986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11857",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "10506 MAIN ST",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "NY",
    "dropdelzpp": 140059998,
    "dropphyadd": "10506 MAIN ST",
    "dropphycty": "ALEXANDER",
    "dropphyst": "NY",
    "dropphyzpp": 140059998,
    "dropmaladd": "10506 MAIN ST",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "NY",
    "dropmalzpp": 140059998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855912258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11860",
    "droptype": "D",
    "dropname": "ALEXANDRIA BAY",
    "dropdeladd": "15 BETHUNE ST",
    "dropdelcty": "ALEXANDRIA BAY",
    "dropdelst": "NY",
    "dropdelzpp": 136079998,
    "dropphyadd": "15 BETHUNE ST",
    "dropphycty": "ALEXANDRIA BAY",
    "dropphyst": "NY",
    "dropphyzpp": 136079998,
    "dropmaladd": "15 BETHUNE ST",
    "dropmalcty": "ALEXANDRIA BAY",
    "dropmalst": "NY",
    "dropmalzpp": 136079998,
    "dropsitphn": 3154829521,
    "dropsitlph": 3154829521,
    "dropsitcph": 3154829521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11861",
    "droptype": "D",
    "dropname": "ALFRED",
    "dropdeladd": "63 N MAIN ST",
    "dropdelcty": "ALFRED",
    "dropdelst": "NY",
    "dropdelzpp": 148029998,
    "dropphyadd": "63 N MAIN ST",
    "dropphycty": "ALFRED",
    "dropphyst": "NY",
    "dropphyzpp": 148029998,
    "dropmaladd": "63 N MAIN ST",
    "dropmalcty": "ALFRED",
    "dropmalst": "NY",
    "dropmalzpp": 148029998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075878449,
    "dropsitcph": 6075878449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11863",
    "droptype": "D",
    "dropname": "ALFRED STATION",
    "dropdeladd": "623 STATE ROUTE 244",
    "dropdelcty": "ALFRED STATION",
    "dropdelst": "NY",
    "dropdelzpp": 148039998,
    "dropphyadd": "623 STATE ROUTE 244",
    "dropphycty": "ALFRED STATION",
    "dropphyst": "NY",
    "dropphyzpp": 148039998,
    "dropmaladd": "623 STATE ROUTE 244",
    "dropmalcty": "ALFRED STATION",
    "dropmalst": "NY",
    "dropmalzpp": 148039998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075878828,
    "dropsitcph": 6075878828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11866",
    "droptype": "D",
    "dropname": "ALLEGANY",
    "dropdeladd": "21 N 5TH ST",
    "dropdelcty": "ALLEGANY",
    "dropdelst": "NY",
    "dropdelzpp": 147069998,
    "dropphyadd": "21 N 5TH ST",
    "dropphycty": "ALLEGANY",
    "dropphyst": "NY",
    "dropphyzpp": 147069998,
    "dropmaladd": "21 N 5TH ST",
    "dropmalcty": "ALLEGANY",
    "dropmalst": "NY",
    "dropmalzpp": 147069998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163732995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11868",
    "droptype": "D",
    "dropname": "ALLENTOWN",
    "dropdeladd": "5840 MAIN ST",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 147079800,
    "dropphyadd": "5840 MAIN ST",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 147079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 147079998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855932024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11874",
    "droptype": "D",
    "dropname": "ALMOND",
    "dropdeladd": "49 MAIN ST",
    "dropdelcty": "ALMOND",
    "dropdelst": "NY",
    "dropdelzpp": 148049998,
    "dropphyadd": "49 MAIN ST",
    "dropphycty": "ALMOND",
    "dropphyst": "NY",
    "dropphyzpp": 148049998,
    "dropmaladd": "49 MAIN ST",
    "dropmalcty": "ALMOND",
    "dropmalst": "NY",
    "dropmalzpp": 148049998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072766444,
    "dropsitcph": 6072766444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11875",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "5908 COUNTY ROAD 11",
    "dropdelcty": "ALPINE",
    "dropdelst": "NY",
    "dropdelzpp": 148059998,
    "dropphyadd": "5908 COUNTY ROAD 11",
    "dropphycty": "ALPINE",
    "dropphyst": "NY",
    "dropphyzpp": 148059998,
    "dropmaladd": "5908 COUNTY ROAD 11",
    "dropmalcty": "ALPINE",
    "dropmalst": "NY",
    "dropmalzpp": 148059998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075942030,
    "dropsitcph": 6075942030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11880",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "108 PARK ST",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "NY",
    "dropdelzpp": 120099998,
    "dropphyadd": "108 PARK ST",
    "dropphycty": "ALTAMONT",
    "dropphyst": "NY",
    "dropphyzpp": 120099998,
    "dropmaladd": "108 PARK ST",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "NY",
    "dropmalzpp": 120099998,
    "dropsitphn": 5188616953,
    "dropsitlph": 5188616953,
    "dropsitcph": 5188616953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11881",
    "droptype": "D",
    "dropname": "ALTMAR",
    "dropdeladd": "1964 MEXICO ST",
    "dropdelcty": "ALTMAR",
    "dropdelst": "NY",
    "dropdelzpp": 133029998,
    "dropphyadd": "1964 MEXICO ST",
    "dropphycty": "ALTMAR",
    "dropphyst": "NY",
    "dropphyzpp": 133029998,
    "dropmaladd": "1964 MEXICO ST",
    "dropmalcty": "ALTMAR",
    "dropmalst": "NY",
    "dropmalzpp": 133029998,
    "dropsitphn": 3152984388,
    "dropsitlph": 3152984388,
    "dropsitcph": 3152984388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11882",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "8483 RIDGE RD",
    "dropdelcty": "ALTON",
    "dropdelst": "NY",
    "dropdelzpp": 144139800,
    "dropphyadd": "8483 RIDGE RD",
    "dropphycty": "ALTON",
    "dropphyst": "NY",
    "dropphyzpp": 144139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTON",
    "dropmalst": "NY",
    "dropmalzpp": 144139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3154834763,
    "dropsitcph": 3154834763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11883",
    "droptype": "D",
    "dropname": "ALTONA",
    "dropdeladd": "499 DEVILS DEN RD",
    "dropdelcty": "ALTONA",
    "dropdelst": "NY",
    "dropdelzpp": 129102036,
    "dropphyadd": "499 DEVILS DEN RD",
    "dropphycty": "ALTONA",
    "dropphyst": "NY",
    "dropphyzpp": 129102036,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTONA",
    "dropmalst": "NY",
    "dropmalzpp": 129109998,
    "dropsitphn": 5182367463,
    "dropsitlph": 5182367463,
    "dropsitcph": 5182367463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11885",
    "droptype": "D",
    "dropname": "AMAGANSETT",
    "dropdeladd": "501 MONTAUK HWY",
    "dropdelcty": "AMAGANSETT",
    "dropdelst": "NY",
    "dropdelzpp": 119303400,
    "dropphyadd": "501 MONTAUK HWY",
    "dropphycty": "AMAGANSETT",
    "dropphyst": "NY",
    "dropphyzpp": 119303400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMAGANSETT",
    "dropmalst": "NY",
    "dropmalzpp": 119309998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312672804,
    "dropfax": 6312676567
  },
  {
    "dcode": "D",
    "dropkey": "PV11886",
    "droptype": "D",
    "dropname": "AMAWALK",
    "dropdeladd": "3 MAHOPAC AVE",
    "dropdelcty": "AMAWALK",
    "dropdelst": "NY",
    "dropdelzpp": 105019998,
    "dropphyadd": "3 MAHOPAC AVE",
    "dropphycty": "AMAWALK",
    "dropphyst": "NY",
    "dropphyzpp": 105019998,
    "dropmaladd": "3 MAHOPAC AVE",
    "dropmalcty": "AMAWALK",
    "dropmalst": "NY",
    "dropmalzpp": 105019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142450915,
    "dropsitcph": 9142450915,
    "dropfax": 9142450915
  },
  {
    "dcode": "D",
    "dropkey": "PV11892",
    "droptype": "D",
    "dropname": "AMENIA",
    "dropdeladd": "3296 ROUTE 343",
    "dropdelcty": "AMENIA",
    "dropdelst": "NY",
    "dropdelzpp": 125019998,
    "dropphyadd": "3296 ROUTE 343",
    "dropphycty": "AMENIA",
    "dropphyst": "NY",
    "dropphyzpp": 125019998,
    "dropmaladd": "3296 ROUTE 343",
    "dropmalcty": "AMENIA",
    "dropmalst": "NY",
    "dropmalzpp": 125019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453739306,
    "dropsitcph": 8453739306,
    "dropfax": 8453737467
  },
  {
    "dcode": "D",
    "dropkey": "PV11903",
    "droptype": "D",
    "dropname": "AMITYVILLE",
    "dropdeladd": "77 IRELAND PL",
    "dropdelcty": "AMITYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117012987,
    "dropphyadd": "77 IRELAND PL",
    "dropphycty": "AMITYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117012987,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMITYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117019998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312643532,
    "dropfax": 6312645712
  },
  {
    "dcode": "D",
    "dropkey": "PV11906",
    "droptype": "D",
    "dropname": "AMSTERDAM",
    "dropdeladd": "10 CHURCH ST",
    "dropdelcty": "AMSTERDAM",
    "dropdelst": "NY",
    "dropdelzpp": 120109998,
    "dropphyadd": "10 CHURCH ST",
    "dropphycty": "AMSTERDAM",
    "dropphyst": "NY",
    "dropphyzpp": 120109998,
    "dropmaladd": "10 CHURCH ST",
    "dropmalcty": "AMSTERDAM",
    "dropmalst": "NY",
    "dropmalzpp": 120109998,
    "dropsitphn": 5188426940,
    "dropsitlph": 5188426940,
    "dropsitcph": 5188426940,
    "dropfax": 5188435448
  },
  {
    "dcode": "D",
    "dropkey": "PV11907",
    "droptype": "D",
    "dropname": "ANCRAM",
    "dropdeladd": "1295 COUNTY ROUTE 7",
    "dropdelcty": "ANCRAM",
    "dropdelst": "NY",
    "dropdelzpp": 125029998,
    "dropphyadd": "1295 COUNTY ROUTE 7",
    "dropphycty": "ANCRAM",
    "dropphyst": "NY",
    "dropphyzpp": 125029998,
    "dropmaladd": "1295 COUNTY ROUTE 7",
    "dropmalcty": "ANCRAM",
    "dropmalst": "NY",
    "dropmalzpp": 125029998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5183294360,
    "dropsitcph": 5183294360,
    "dropfax": 5183290766
  },
  {
    "dcode": "D",
    "dropkey": "PV11908",
    "droptype": "D",
    "dropname": "ANCRAMDALE",
    "dropdeladd": "11 COUNTY ROUTE 8",
    "dropdelcty": "ANCRAMDALE",
    "dropdelst": "NY",
    "dropdelzpp": 125039998,
    "dropphyadd": "11 COUNTY ROUTE 8",
    "dropphycty": "ANCRAMDALE",
    "dropphyst": "NY",
    "dropphyzpp": 125039998,
    "dropmaladd": "11 COUNTY ROUTE 8",
    "dropmalcty": "ANCRAMDALE",
    "dropmalst": "NY",
    "dropmalzpp": 125039998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 5183296199,
    "dropfax": 5183296199
  },
  {
    "dcode": "D",
    "dropkey": "PV11909",
    "droptype": "D",
    "dropname": "ANDES",
    "dropdeladd": "204 LOWER MAIN ST",
    "dropdelcty": "ANDES",
    "dropdelst": "NY",
    "dropdelzpp": 137319998,
    "dropphyadd": "204 LOWER MAIN ST",
    "dropphycty": "ANDES",
    "dropphyst": "NY",
    "dropphyzpp": 137319998,
    "dropmaladd": "204 LOWER MAIN ST",
    "dropmalcty": "ANDES",
    "dropmalst": "NY",
    "dropmalzpp": 137319998,
    "dropsitphn": 8456763211,
    "dropsitlph": 8456763211,
    "dropsitcph": 8456763211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11910",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "16 MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "NY",
    "dropdelzpp": 148069998,
    "dropphyadd": "16 MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "NY",
    "dropphyzpp": 148069998,
    "dropmaladd": "16 MAIN ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "NY",
    "dropmalzpp": 148069998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6074788167,
    "dropsitcph": 6074788167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11912",
    "droptype": "D",
    "dropname": "ANGELICA",
    "dropdeladd": "1 W MAIN ST",
    "dropdelcty": "ANGELICA",
    "dropdelst": "NY",
    "dropdelzpp": 147099998,
    "dropphyadd": "1 W MAIN ST",
    "dropphycty": "ANGELICA",
    "dropphyst": "NY",
    "dropphyzpp": 147099998,
    "dropmaladd": "1 W MAIN ST",
    "dropmalcty": "ANGELICA",
    "dropmalst": "NY",
    "dropmalzpp": 147099998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854667689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11913",
    "droptype": "D",
    "dropname": "ANGOLA",
    "dropdeladd": "80 N MAIN ST",
    "dropdelcty": "ANGOLA",
    "dropdelst": "NY",
    "dropdelzpp": 140069998,
    "dropphyadd": "80 N MAIN ST",
    "dropphycty": "ANGOLA",
    "dropphyst": "NY",
    "dropphyzpp": 140069998,
    "dropmaladd": "80 N MAIN ST",
    "dropmalcty": "ANGOLA",
    "dropmalst": "NY",
    "dropmalzpp": 140069998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165491991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11924",
    "droptype": "D",
    "dropname": "ANTWERP",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "ANTWERP",
    "dropdelst": "NY",
    "dropdelzpp": 136089998,
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "ANTWERP",
    "dropphyst": "NY",
    "dropphyzpp": 136089998,
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "ANTWERP",
    "dropmalst": "NY",
    "dropmalzpp": 136089998,
    "dropsitphn": 3156598651,
    "dropsitlph": 3156598651,
    "dropsitcph": 3156598651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11925",
    "droptype": "D",
    "dropname": "APALACHIN",
    "dropdeladd": "6100 STATE ROUTE 434",
    "dropdelcty": "APALACHIN",
    "dropdelst": "NY",
    "dropdelzpp": 137329998,
    "dropphyadd": "6100 STATE ROUTE 434",
    "dropphycty": "APALACHIN",
    "dropphyst": "NY",
    "dropphyzpp": 137329998,
    "dropmaladd": "6100 STATE ROUTE 434",
    "dropmalcty": "APALACHIN",
    "dropmalst": "NY",
    "dropmalzpp": 137329998,
    "dropsitphn": 6076252414,
    "dropsitlph": 6076252414,
    "dropsitcph": 6076252414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11927",
    "droptype": "D",
    "dropname": "APPLETON",
    "dropdeladd": "1924 HESS RD",
    "dropdelcty": "APPLETON",
    "dropdelst": "NY",
    "dropdelzpp": 140089998,
    "dropphyadd": "1924 HESS RD",
    "dropphycty": "APPLETON",
    "dropphyst": "NY",
    "dropphyzpp": 140089998,
    "dropmaladd": "1924 HESS RD",
    "dropmalcty": "APPLETON",
    "dropmalst": "NY",
    "dropmalzpp": 140089998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167787787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11929",
    "droptype": "D",
    "dropname": "APULIA STATION",
    "dropdeladd": "979 APULIA RD",
    "dropdelcty": "APULIA STATION",
    "dropdelst": "NY",
    "dropdelzpp": 130209998,
    "dropphyadd": "979 APULIA RD",
    "dropphycty": "APULIA STATION",
    "dropphyst": "NY",
    "dropphyzpp": 130209998,
    "dropmaladd": "979 APULIA RD",
    "dropmalcty": "APULIA STATION",
    "dropmalst": "NY",
    "dropmalzpp": 130209998,
    "dropsitphn": 5186965278,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156965278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11930",
    "droptype": "D",
    "dropname": "AQUEBOGUE",
    "dropdeladd": "212 LINDA AVE",
    "dropdelcty": "AQUEBOGUE",
    "dropdelst": "NY",
    "dropdelzpp": 119319800,
    "dropphyadd": "212 LINDA AVE",
    "dropphycty": "AQUEBOGUE",
    "dropphyst": "NY",
    "dropphyzpp": 119319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AQUEBOGUE",
    "dropmalst": "NY",
    "dropmalzpp": 119319998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317224368,
    "dropfax": 6317225636
  },
  {
    "dcode": "D",
    "dropkey": "PV11932",
    "droptype": "D",
    "dropname": "ARCADE",
    "dropdeladd": "23 EDWARD ST",
    "dropdelcty": "ARCADE",
    "dropdelst": "NY",
    "dropdelzpp": 140099998,
    "dropphyadd": "23 EDWARD ST",
    "dropphycty": "ARCADE",
    "dropphyst": "NY",
    "dropphyzpp": 140099998,
    "dropmaladd": "23 EDWARD ST",
    "dropmalcty": "ARCADE",
    "dropmalst": "NY",
    "dropmalzpp": 140099998,
    "dropsitphn": 7167076049,
    "dropsitlph": 7167076049,
    "dropsitcph": 7167076049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11937",
    "droptype": "D",
    "dropname": "ARDSLEY",
    "dropdeladd": "875 SAW MILL RIVER RD STE 4",
    "dropdelcty": "ARDSLEY",
    "dropdelst": "NY",
    "dropdelzpp": 105029998,
    "dropphyadd": "875 SAW MILL RIVER RD STE 4",
    "dropphycty": "ARDSLEY",
    "dropphyst": "NY",
    "dropphyzpp": 105029998,
    "dropmaladd": "875 SAW MILL RIVER RD STE 4",
    "dropmalcty": "ARDSLEY",
    "dropmalst": "NY",
    "dropmalzpp": 105029998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146930476,
    "dropsitcph": 9146930476,
    "dropfax": 9146936955
  },
  {
    "dcode": "D",
    "dropkey": "PV11938",
    "droptype": "D",
    "dropname": "ARDSLEY ON HUDSON",
    "dropdeladd": "110 ARDSLEY AVE W",
    "dropdelcty": "ARDSLEY ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 105039800,
    "dropphyadd": "110 ARDSLEY AVE W",
    "dropphycty": "ARDSLEY ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 105039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARDSLEY ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 105039998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 9145917299,
    "dropfax": 9145912249
  },
  {
    "dcode": "D",
    "dropkey": "PV11942",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "38 MAIN ST",
    "dropdelcty": "ARGYLE",
    "dropdelst": "NY",
    "dropdelzpp": 128099998,
    "dropphyadd": "38 MAIN ST",
    "dropphycty": "ARGYLE",
    "dropphyst": "NY",
    "dropphyzpp": 128099998,
    "dropmaladd": "38 MAIN ST",
    "dropmalcty": "ARGYLE",
    "dropmalst": "NY",
    "dropmalzpp": 128099998,
    "dropsitphn": 5186388821,
    "dropsitlph": 5186388821,
    "dropsitcph": 5186388821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11945",
    "droptype": "D",
    "dropname": "ARKPORT",
    "dropdeladd": "27 MAIN ST",
    "dropdelcty": "ARKPORT",
    "dropdelst": "NY",
    "dropdelzpp": 148079998,
    "dropphyadd": "27 MAIN ST",
    "dropphycty": "ARKPORT",
    "dropphyst": "NY",
    "dropphyzpp": 148079998,
    "dropmaladd": "27 MAIN ST",
    "dropmalcty": "ARKPORT",
    "dropmalst": "NY",
    "dropmalzpp": 148079998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072957939,
    "dropsitcph": 6072957939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11946",
    "droptype": "D",
    "dropname": "ARKVILLE",
    "dropdeladd": "43400 STATE ROUTE 28",
    "dropdelcty": "ARKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124069998,
    "dropphyadd": "43400 STATE ROUTE 28",
    "dropphycty": "ARKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124069998,
    "dropmaladd": "43400 STATE ROUTE 28",
    "dropmalcty": "ARKVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124069998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455864182,
    "dropsitcph": 8455864182,
    "dropfax": 8455864182
  },
  {
    "dcode": "D",
    "dropkey": "PV11954",
    "droptype": "D",
    "dropname": "ARMONK",
    "dropdeladd": "403 MAIN ST",
    "dropdelcty": "ARMONK",
    "dropdelst": "NY",
    "dropdelzpp": 105049998,
    "dropphyadd": "403 MAIN ST",
    "dropphycty": "ARMONK",
    "dropphyst": "NY",
    "dropphyzpp": 105049998,
    "dropmaladd": "403 MAIN ST",
    "dropmalcty": "ARMONK",
    "dropmalst": "NY",
    "dropmalzpp": 105049998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142736731,
    "dropsitcph": 9142736731,
    "dropfax": 9142732794
  },
  {
    "dcode": "D",
    "dropkey": "PV11964",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "12101 STATE HIGHWAY 23",
    "dropdelcty": "ASHLAND",
    "dropdelst": "NY",
    "dropdelzpp": 124079998,
    "dropphyadd": "12101 STATE HIGHWAY 23",
    "dropphycty": "ASHLAND",
    "dropphyst": "NY",
    "dropphyzpp": 124079998,
    "dropmaladd": "12101 STATE HIGHWAY 23",
    "dropmalcty": "ASHLAND",
    "dropmalst": "NY",
    "dropmalzpp": 124079998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187344269,
    "dropsitcph": 5187344269,
    "dropfax": 5187344269
  },
  {
    "dcode": "D",
    "dropkey": "PV11967",
    "droptype": "D",
    "dropname": "ASHVILLE",
    "dropdeladd": "2181 N MAPLE AVE",
    "dropdelcty": "ASHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147109998,
    "dropphyadd": "2181 N MAPLE AVE",
    "dropphycty": "ASHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147109998,
    "dropmaladd": "2181 N MAPLE AVE",
    "dropmalcty": "ASHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167632035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11971",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "64 N WASHINGTON ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "NY",
    "dropdelzpp": 120159998,
    "dropphyadd": "64 N WASHINGTON ST",
    "dropphycty": "ATHENS",
    "dropphyst": "NY",
    "dropphyzpp": 120159998,
    "dropmaladd": "64 N WASHINGTON ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "NY",
    "dropmalzpp": 120159998,
    "dropsitphn": 5189451255,
    "dropsitlph": 5189451255,
    "dropsitcph": 5189451255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11972",
    "droptype": "D",
    "dropname": "ATHOL",
    "dropdeladd": "274 ATHOL RD",
    "dropdelcty": "ATHOL",
    "dropdelst": "NY",
    "dropdelzpp": 128109998,
    "dropphyadd": "274 ATHOL RD",
    "dropphycty": "ATHOL",
    "dropphyst": "NY",
    "dropphyzpp": 128109998,
    "dropmaladd": "274 ATHOL RD",
    "dropmalcty": "ATHOL",
    "dropmalst": "NY",
    "dropmalzpp": 128109998,
    "dropsitphn": 5186232018,
    "dropsitlph": 5186232018,
    "dropsitcph": 5186232018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11973",
    "droptype": "D",
    "dropname": "ATHOL SPRINGS",
    "dropdeladd": "4480 OLD CAMP RD",
    "dropdelcty": "ATHOL SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 140109800,
    "dropphyadd": "4480 OLD CAMP RD",
    "dropphycty": "ATHOL SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 140109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATHOL SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 140109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166497182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11974",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "28 MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "NY",
    "dropdelzpp": 148089998,
    "dropphyadd": "28 MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "NY",
    "dropphyzpp": 148089998,
    "dropmaladd": "28 MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "NY",
    "dropmalzpp": 148089998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855345450,
    "dropsitcph": 5855345450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11977",
    "droptype": "D",
    "dropname": "ATLANTIC BEACH",
    "dropdeladd": "2009 PARK ST",
    "dropdelcty": "ATLANTIC BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 115091245,
    "dropphyadd": "2009 PARK ST",
    "dropphycty": "ATLANTIC BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 115091245,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATLANTIC BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 115099998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162391178,
    "dropfax": 5163716821
  },
  {
    "dcode": "D",
    "dropkey": "PV11979",
    "droptype": "D",
    "dropname": "ATTICA",
    "dropdeladd": "76 MAIN ST",
    "dropdelcty": "ATTICA",
    "dropdelst": "NY",
    "dropdelzpp": 140119998,
    "dropphyadd": "76 MAIN ST",
    "dropphycty": "ATTICA",
    "dropphyst": "NY",
    "dropphyzpp": 140119998,
    "dropmaladd": "76 MAIN ST",
    "dropmalcty": "ATTICA",
    "dropmalst": "NY",
    "dropmalzpp": 140119998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855910900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11984",
    "droptype": "D",
    "dropname": "AU SABLE FORKS",
    "dropdeladd": "35 FORGE ST",
    "dropdelcty": "AU SABLE FORKS",
    "dropdelst": "NY",
    "dropdelzpp": 129129998,
    "dropphyadd": "35 FORGE ST",
    "dropphycty": "AU SABLE FORKS",
    "dropphyst": "NY",
    "dropphyzpp": 129129998,
    "dropmaladd": "35 FORGE ST",
    "dropmalcty": "AU SABLE FORKS",
    "dropmalst": "NY",
    "dropmalzpp": 129129998,
    "dropsitphn": 5186475591,
    "dropsitlph": 5186475591,
    "dropsitcph": 5186475591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11986",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "1 JAMES ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "NY",
    "dropdelzpp": 130219998,
    "dropphyadd": "1 JAMES ST",
    "dropphycty": "AUBURN",
    "dropphyst": "NY",
    "dropphyzpp": 130219998,
    "dropmaladd": "1 JAMES ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "NY",
    "dropmalzpp": 130219998,
    "dropsitphn": 5182529554,
    "dropsitlph": 5182529554,
    "dropsitcph": 3152529554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11994",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "373 MAIN ST",
    "dropdelcty": "AURORA",
    "dropdelst": "NY",
    "dropdelzpp": 130269998,
    "dropphyadd": "373 MAIN ST",
    "dropphycty": "AURORA",
    "dropphyst": "NY",
    "dropphyzpp": 130269998,
    "dropmaladd": "373 MAIN ST",
    "dropmalcty": "AURORA",
    "dropmalst": "NY",
    "dropmalzpp": 130269998,
    "dropsitphn": 3153648751,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153648751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11996",
    "droptype": "D",
    "dropname": "AUSTERLITZ",
    "dropdeladd": "6 E HILL RD",
    "dropdelcty": "AUSTERLITZ",
    "dropdelst": "NY",
    "dropdelzpp": 120179998,
    "dropphyadd": "6 E HILL RD",
    "dropphycty": "AUSTERLITZ",
    "dropphyst": "NY",
    "dropphyzpp": 120179998,
    "dropmaladd": "6 E HILL RD",
    "dropmalcty": "AUSTERLITZ",
    "dropmalst": "NY",
    "dropmalzpp": 120179998,
    "dropsitphn": 5183923155,
    "dropsitlph": 5183923155,
    "dropsitcph": 5183923155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11997",
    "droptype": "D",
    "dropname": "AVA",
    "dropdeladd": "11510 STATE ROUTE 26",
    "dropdelcty": "AVA",
    "dropdelst": "NY",
    "dropdelzpp": 133039998,
    "dropphyadd": "11510 STATE ROUTE 26",
    "dropphycty": "AVA",
    "dropphyst": "NY",
    "dropphyzpp": 133039998,
    "dropmaladd": "11510 STATE ROUTE 26",
    "dropmalcty": "AVA",
    "dropmalst": "NY",
    "dropmalzpp": 133039998,
    "dropsitphn": 3159425683,
    "dropsitlph": 3159425683,
    "dropsitcph": 3159425683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11998",
    "droptype": "D",
    "dropname": "AVERILL PARK",
    "dropdeladd": "2951 NY HIGHWAY 43",
    "dropdelcty": "AVERILL PARK",
    "dropdelst": "NY",
    "dropdelzpp": 120189998,
    "dropphyadd": "2951 NY HIGHWAY 43",
    "dropphycty": "AVERILL PARK",
    "dropphyst": "NY",
    "dropphyzpp": 120189998,
    "dropmaladd": "2951 NY HIGHWAY 43",
    "dropmalcty": "AVERILL PARK",
    "dropmalst": "NY",
    "dropmalzpp": 120189998,
    "dropsitphn": 5186743423,
    "dropsitlph": 5186743423,
    "dropsitcph": 5186743423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV11999",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "44 S MAIN ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "NY",
    "dropdelzpp": 148099998,
    "dropphyadd": "44 S MAIN ST",
    "dropphycty": "AVOCA",
    "dropphyst": "NY",
    "dropphyzpp": 148099998,
    "dropmaladd": "44 S MAIN ST",
    "dropmalcty": "AVOCA",
    "dropmalst": "NY",
    "dropmalzpp": 148099998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075668566,
    "dropsitcph": 6075668566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12000",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "80 PROSPECT ST",
    "dropdelcty": "AVON",
    "dropdelst": "NY",
    "dropdelzpp": 144149998,
    "dropphyadd": "80 PROSPECT ST",
    "dropphycty": "AVON",
    "dropphyst": "NY",
    "dropphyzpp": 144149998,
    "dropmaladd": "80 PROSPECT ST",
    "dropmalcty": "AVON",
    "dropmalst": "NY",
    "dropmalzpp": 144149998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852263550,
    "dropsitcph": 5852263550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12006",
    "droptype": "D",
    "dropname": "BABYLON",
    "dropdeladd": "110 COOPER ST",
    "dropdelcty": "BABYLON",
    "dropdelst": "NY",
    "dropdelzpp": 117022320,
    "dropphyadd": "110 COOPER ST",
    "dropphycty": "BABYLON",
    "dropphyst": "NY",
    "dropphyzpp": 117022320,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABYLON",
    "dropmalst": "NY",
    "dropmalzpp": 117029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316694474,
    "dropfax": 6316694631
  },
  {
    "dcode": "D",
    "dropkey": "PV12012",
    "droptype": "D",
    "dropname": "BAINBRIDGE",
    "dropdeladd": "17 E MAIN ST",
    "dropdelcty": "BAINBRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 137339998,
    "dropphyadd": "17 E MAIN ST",
    "dropphycty": "BAINBRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 137339998,
    "dropmaladd": "17 E MAIN ST",
    "dropmalcty": "BAINBRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 137339998,
    "dropsitphn": 6079673333,
    "dropsitlph": 6079673333,
    "dropsitcph": 6079673333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12014",
    "droptype": "D",
    "dropname": "BAKERS MILLS",
    "dropdeladd": "3 POST OFFICE LOOP",
    "dropdelcty": "BAKERS MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 128119998,
    "dropphyadd": "3 POST OFFICE LOOP",
    "dropphycty": "BAKERS MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 128119998,
    "dropmaladd": "3 POST OFFICE LOOP",
    "dropmalcty": "BAKERS MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 128119998,
    "dropsitphn": 5182513246,
    "dropsitlph": 5182513246,
    "dropsitcph": 5182513246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12017",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "2260 GRAND AVE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "NY",
    "dropdelzpp": 115103162,
    "dropphyadd": "2260 GRAND AVE",
    "dropphycty": "BALDWIN",
    "dropphyst": "NY",
    "dropphyzpp": 115103162,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN",
    "dropmalst": "NY",
    "dropmalzpp": 115109998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162235024,
    "dropfax": 5162237420
  },
  {
    "dcode": "D",
    "dropkey": "PV12019",
    "droptype": "D",
    "dropname": "BALDWIN PLACE",
    "dropdeladd": "167 ROUTE 6",
    "dropdelcty": "MAHOPAC",
    "dropdelst": "NY",
    "dropdelzpp": 105412204,
    "dropphyadd": "167 ROUTE 6",
    "dropphycty": "MAHOPAC",
    "dropphyst": "NY",
    "dropphyzpp": 105412204,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN PLACE",
    "dropmalst": "NY",
    "dropmalzpp": 105059998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456288029,
    "dropsitcph": 8456288029,
    "dropfax": 8456212459
  },
  {
    "dcode": "D",
    "dropkey": "PV12020",
    "droptype": "D",
    "dropname": "BALDWINSVILLE",
    "dropdeladd": "26 E GENESEE ST",
    "dropdelcty": "BALDWINSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130279998,
    "dropphyadd": "26 E GENESEE ST",
    "dropphycty": "BALDWINSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130279998,
    "dropmaladd": "26 E GENESEE ST",
    "dropmalcty": "BALDWINSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130279998,
    "dropsitphn": 3156355241,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156355241,
    "dropfax": 3156353195
  },
  {
    "dcode": "D",
    "dropkey": "PV12026",
    "droptype": "D",
    "dropname": "BALLSTON SPA",
    "dropdeladd": "1 FRONT ST",
    "dropdelcty": "BALLSTON SPA",
    "dropdelst": "NY",
    "dropdelzpp": 120209998,
    "dropphyadd": "1 FRONT ST",
    "dropphycty": "BALLSTON SPA",
    "dropphyst": "NY",
    "dropphyzpp": 120209998,
    "dropmaladd": "1 FRONT ST",
    "dropmalcty": "BALLSTON SPA",
    "dropmalst": "NY",
    "dropmalzpp": 120209998,
    "dropsitphn": 5188859191,
    "dropsitlph": 5188859191,
    "dropsitcph": 5188859191,
    "dropfax": 5188854158
  },
  {
    "dcode": "D",
    "dropkey": "PV12029",
    "droptype": "D",
    "dropname": "BANGALL",
    "dropdeladd": "105 HUNNS LAKE RD",
    "dropdelcty": "BANGALL",
    "dropdelst": "NY",
    "dropdelzpp": 125069800,
    "dropphyadd": "105 HUNNS LAKE RD",
    "dropphycty": "BANGALL",
    "dropphyst": "NY",
    "dropphyzpp": 125069800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANGALL",
    "dropmalst": "NY",
    "dropmalzpp": 125069998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458681964,
    "dropsitcph": 8458681964,
    "dropfax": 8458681296
  },
  {
    "dcode": "D",
    "dropkey": "PV12045",
    "droptype": "D",
    "dropname": "BARKER",
    "dropdeladd": "8720 MAIN ST",
    "dropdelcty": "BARKER",
    "dropdelst": "NY",
    "dropdelzpp": 140129998,
    "dropphyadd": "8720 MAIN ST",
    "dropphycty": "BARKER",
    "dropphyst": "NY",
    "dropphyzpp": 140129998,
    "dropmaladd": "8720 MAIN ST",
    "dropmalcty": "BARKER",
    "dropmalst": "NY",
    "dropmalzpp": 140129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167953684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12052",
    "droptype": "D",
    "dropname": "BARNEVELD",
    "dropdeladd": "117 REMSEN RD",
    "dropdelcty": "BARNEVELD",
    "dropdelst": "NY",
    "dropdelzpp": 133049998,
    "dropphyadd": "117 REMSEN RD",
    "dropphycty": "BARNEVELD",
    "dropphyst": "NY",
    "dropphyzpp": 133049998,
    "dropmaladd": "117 REMSEN RD",
    "dropmalcty": "BARNEVELD",
    "dropmalst": "NY",
    "dropmalzpp": 133049998,
    "dropsitphn": 3158962704,
    "dropsitlph": 3158962704,
    "dropsitcph": 3158962704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12055",
    "droptype": "D",
    "dropname": "BARRYVILLE",
    "dropdeladd": "6 COUNTY ROAD 21",
    "dropdelcty": "BARRYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127199998,
    "dropphyadd": "6 COUNTY ROAD 21",
    "dropphycty": "BARRYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127199998,
    "dropmaladd": "6 COUNTY ROAD 21",
    "dropmalcty": "BARRYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127199998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455578412,
    "dropsitcph": 8455578412,
    "dropfax": 8455578412
  },
  {
    "dcode": "D",
    "dropkey": "PV12059",
    "droptype": "D",
    "dropname": "BASOM",
    "dropdeladd": "7156 ALLEGHANY RD",
    "dropdelcty": "BASOM",
    "dropdelst": "NY",
    "dropdelzpp": 140139998,
    "dropphyadd": "7156 ALLEGHANY RD",
    "dropphycty": "BASOM",
    "dropphyst": "NY",
    "dropphyzpp": 140139998,
    "dropmaladd": "7156 ALLEGHANY RD",
    "dropmalcty": "BASOM",
    "dropmalst": "NY",
    "dropmalzpp": 140139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859485874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12060",
    "droptype": "D",
    "dropname": "BATAVIA",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "BATAVIA",
    "dropdelst": "NY",
    "dropdelzpp": 140209998,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "BATAVIA",
    "dropphyst": "NY",
    "dropphyzpp": 140209998,
    "dropmaladd": "2 W MAIN ST",
    "dropmalcty": "BATAVIA",
    "dropmalst": "NY",
    "dropmalzpp": 140209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5853430491,
    "dropfax": 5853444046
  },
  {
    "dcode": "D",
    "dropkey": "PV12063",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "101 LIBERTY ST",
    "dropdelcty": "BATH",
    "dropdelst": "NY",
    "dropdelzpp": 148109998,
    "dropphyadd": "101 LIBERTY ST",
    "dropphycty": "BATH",
    "dropphyst": "NY",
    "dropphyzpp": 148109998,
    "dropmaladd": "101 LIBERTY ST",
    "dropmalcty": "BATH",
    "dropmalst": "NY",
    "dropmalzpp": 148109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077767151,
    "dropsitcph": 6077767151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12078",
    "droptype": "D",
    "dropname": "BAY SHORE",
    "dropdeladd": "1314 5TH AVE",
    "dropdelcty": "BAY SHORE",
    "dropdelst": "NY",
    "dropdelzpp": 117064141,
    "dropphyadd": "1314 5TH AVE",
    "dropphycty": "BAY SHORE",
    "dropphyst": "NY",
    "dropphyzpp": 117064141,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY SHORE",
    "dropmalst": "NY",
    "dropmalzpp": 117069998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319693504,
    "dropfax": 6319680770
  },
  {
    "dcode": "D",
    "dropkey": "PV12087",
    "droptype": "D",
    "dropname": "BAYPORT",
    "dropdeladd": "850 MONTAUK HWY",
    "dropdelcty": "BAYPORT",
    "dropdelst": "NY",
    "dropdelzpp": 117051636,
    "dropphyadd": "850 MONTAUK HWY",
    "dropphycty": "BAYPORT",
    "dropphyst": "NY",
    "dropphyzpp": 117051636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYPORT",
    "dropmalst": "NY",
    "dropmalzpp": 117059998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314727396,
    "dropfax": 6314721845
  },
  {
    "dcode": "D",
    "dropkey": "PV12093",
    "droptype": "D",
    "dropname": "BAYVILLE",
    "dropdeladd": "251 BAYVILLE AVE",
    "dropdelcty": "BAYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117091670,
    "dropphyadd": "251 BAYVILLE AVE",
    "dropphycty": "BAYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117091670,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117099998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166289235,
    "dropfax": 5166288953
  },
  {
    "dcode": "D",
    "dropkey": "PV12095",
    "droptype": "D",
    "dropname": "BEACON",
    "dropdeladd": "369 MAIN ST",
    "dropdelcty": "BEACON",
    "dropdelst": "NY",
    "dropdelzpp": 125089998,
    "dropphyadd": "369 MAIN ST",
    "dropphycty": "BEACON",
    "dropphyst": "NY",
    "dropphyzpp": 125089998,
    "dropmaladd": "369 MAIN ST",
    "dropmalcty": "BEACON",
    "dropmalst": "NY",
    "dropmalzpp": 125089998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458314372,
    "dropsitcph": 8458314372,
    "dropfax": 8458313162
  },
  {
    "dcode": "D",
    "dropkey": "PV12097",
    "droptype": "D",
    "dropname": "BEAR MOUNTAIN",
    "dropdeladd": "30 SERVICE RD",
    "dropdelcty": "BEAR MOUNTAIN",
    "dropdelst": "NY",
    "dropdelzpp": 109119998,
    "dropphyadd": "30 SERVICE RD",
    "dropphycty": "BEAR MOUNTAIN",
    "dropphyst": "NY",
    "dropphyzpp": 109119998,
    "dropmaladd": "30 SERVICE RD",
    "dropmalcty": "BEAR MOUNTAIN",
    "dropmalst": "NY",
    "dropmalzpp": 109119998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8457863747,
    "dropfax": 8457862153
  },
  {
    "dcode": "D",
    "dropkey": "PV12099",
    "droptype": "D",
    "dropname": "BEARSVILLE",
    "dropdeladd": "3203 ROUTE 212 STE 1",
    "dropdelcty": "BEARSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124099998,
    "dropphyadd": "3203 ROUTE 212 STE 1",
    "dropphycty": "BEARSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124099998,
    "dropmaladd": "3203 ROUTE 212 STE 1",
    "dropmalcty": "BEARSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124099998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456793077,
    "dropsitcph": 8456793077,
    "dropfax": 8456793077
  },
  {
    "dcode": "D",
    "dropkey": "PV12102",
    "droptype": "D",
    "dropname": "BEAVER DAMS",
    "dropdeladd": "2347 COUNTY ROAD 20",
    "dropdelcty": "BEAVER DAMS",
    "dropdelst": "NY",
    "dropdelzpp": 148129998,
    "dropphyadd": "2347 COUNTY ROAD 20",
    "dropphycty": "BEAVER DAMS",
    "dropphyst": "NY",
    "dropphyzpp": 148129998,
    "dropmaladd": "2347 COUNTY ROAD 20",
    "dropmalcty": "BEAVER DAMS",
    "dropmalst": "NY",
    "dropmalzpp": 148129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6079364748,
    "dropsitcph": 6079364748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12103",
    "droptype": "D",
    "dropname": "BEAVER FALLS",
    "dropdeladd": "9572 MAIN ST",
    "dropdelcty": "BEAVER FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 133059998,
    "dropphyadd": "9572 MAIN ST",
    "dropphycty": "BEAVER FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 133059998,
    "dropmaladd": "9572 MAIN ST",
    "dropmalcty": "BEAVER FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 133059998,
    "dropsitphn": 3153466412,
    "dropsitlph": 3153466412,
    "dropsitcph": 3153466412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12109",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "40 VILLAGE GRN",
    "dropdelcty": "BEDFORD",
    "dropdelst": "NY",
    "dropdelzpp": 105069998,
    "dropphyadd": "40 VILLAGE GRN",
    "dropphycty": "BEDFORD",
    "dropphyst": "NY",
    "dropphyzpp": 105069998,
    "dropmaladd": "40 VILLAGE GRN",
    "dropmalcty": "BEDFORD",
    "dropmalst": "NY",
    "dropmalzpp": 105069998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142343275,
    "dropsitcph": 9142343275,
    "dropfax": 9142343120
  },
  {
    "dcode": "D",
    "dropkey": "PV12110",
    "droptype": "D",
    "dropname": "BEDFORD HILLS",
    "dropdeladd": "60 ADAMS ST",
    "dropdelcty": "BEDFORD HILLS",
    "dropdelst": "NY",
    "dropdelzpp": 105079998,
    "dropphyadd": "60 ADAMS ST",
    "dropphycty": "BEDFORD HILLS",
    "dropphyst": "NY",
    "dropphyzpp": 105079998,
    "dropmaladd": "60 ADAMS ST",
    "dropmalcty": "BEDFORD HILLS",
    "dropmalst": "NY",
    "dropmalzpp": 105079998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146665268,
    "dropsitcph": 9146665268,
    "dropfax": 9142440931
  },
  {
    "dcode": "D",
    "dropkey": "PV12117",
    "droptype": "D",
    "dropname": "BELFAST",
    "dropdeladd": "53 S MAIN ST",
    "dropdelcty": "BELFAST",
    "dropdelst": "NY",
    "dropdelzpp": 147119800,
    "dropphyadd": "53 S MAIN ST",
    "dropphycty": "BELFAST",
    "dropphyst": "NY",
    "dropphyzpp": 147119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELFAST",
    "dropmalst": "NY",
    "dropmalzpp": 147119998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5853652678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12127",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "8279 STATE ROUTE 289",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136119998,
    "dropphyadd": "8279 STATE ROUTE 289",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136119998,
    "dropmaladd": "8279 STATE ROUTE 289",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136119998,
    "dropsitphn": 3158465000,
    "dropsitlph": 5184522299,
    "dropsitcph": 3158465000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12131",
    "droptype": "D",
    "dropname": "BELLMORE",
    "dropdeladd": "2611 MERRICK RD",
    "dropdelcty": "BELLMORE",
    "dropdelst": "NY",
    "dropdelzpp": 117105752,
    "dropphyadd": "2611 MERRICK RD",
    "dropphycty": "BELLMORE",
    "dropphyst": "NY",
    "dropphyzpp": 117105752,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLMORE",
    "dropmalst": "NY",
    "dropmalzpp": 117109998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167810579,
    "dropfax": 5166795174
  },
  {
    "dcode": "D",
    "dropkey": "PV12132",
    "droptype": "D",
    "dropname": "BELLONA",
    "dropdeladd": "134 PRE EMPTION RD",
    "dropdelcty": "BELLONA",
    "dropdelst": "NY",
    "dropdelzpp": 144159998,
    "dropphyadd": "134 PRE EMPTION RD",
    "dropphycty": "BELLONA",
    "dropphyst": "NY",
    "dropphyzpp": 144159998,
    "dropmaladd": "134 PRE EMPTION RD",
    "dropmalcty": "BELLONA",
    "dropmalst": "NY",
    "dropmalzpp": 144159998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855265500,
    "dropsitcph": 5855265500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12133",
    "droptype": "D",
    "dropname": "BELLPORT",
    "dropdeladd": "26 STATION RD",
    "dropdelcty": "BELLPORT",
    "dropdelst": "NY",
    "dropdelzpp": 117132464,
    "dropphyadd": "26 STATION RD",
    "dropphycty": "BELLPORT",
    "dropphyst": "NY",
    "dropphyzpp": 117132464,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLPORT",
    "dropmalst": "NY",
    "dropmalzpp": 117139998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312868561,
    "dropfax": 6312860737
  },
  {
    "dcode": "D",
    "dropkey": "PV12136",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "3 SCHUYLER ST",
    "dropdelcty": "BELMONT",
    "dropdelst": "NY",
    "dropdelzpp": 148139998,
    "dropphyadd": "3 SCHUYLER ST",
    "dropphycty": "BELMONT",
    "dropphyst": "NY",
    "dropphyzpp": 148139998,
    "dropmaladd": "3 SCHUYLER ST",
    "dropmalcty": "BELMONT",
    "dropmalst": "NY",
    "dropmalzpp": 148139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852687344,
    "dropsitcph": 5852687344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12138",
    "droptype": "D",
    "dropname": "BEMUS POINT",
    "dropdeladd": "29 MAIN ST",
    "dropdelcty": "BEMUS POINT",
    "dropdelst": "NY",
    "dropdelzpp": 147129998,
    "dropphyadd": "29 MAIN ST",
    "dropphycty": "BEMUS POINT",
    "dropphyst": "NY",
    "dropphyzpp": 147129998,
    "dropmaladd": "29 MAIN ST",
    "dropmalcty": "BEMUS POINT",
    "dropmalst": "NY",
    "dropmalzpp": 147129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163865475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12142",
    "droptype": "D",
    "dropname": "BERGEN",
    "dropdeladd": "15 ROCHESTER ST",
    "dropdelcty": "BERGEN",
    "dropdelst": "NY",
    "dropdelzpp": 144169998,
    "dropphyadd": "15 ROCHESTER ST",
    "dropphycty": "BERGEN",
    "dropphyst": "NY",
    "dropphyzpp": 144169998,
    "dropmaladd": "15 ROCHESTER ST",
    "dropmalcty": "BERGEN",
    "dropmalst": "NY",
    "dropmalzpp": 144169998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854941200,
    "dropsitcph": 5854941200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12144",
    "droptype": "D",
    "dropname": "BERKSHIRE",
    "dropdeladd": "12324 STATE ROUTE 38",
    "dropdelcty": "BERKSHIRE",
    "dropdelst": "NY",
    "dropdelzpp": 137369998,
    "dropphyadd": "12324 STATE ROUTE 38",
    "dropphycty": "BERKSHIRE",
    "dropphyst": "NY",
    "dropphyzpp": 137369998,
    "dropmaladd": "12324 STATE ROUTE 38",
    "dropmalcty": "BERKSHIRE",
    "dropmalst": "NY",
    "dropmalzpp": 137369998,
    "dropsitphn": 6076572755,
    "dropsitlph": 6076572755,
    "dropsitcph": 6076572755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12146",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "18246 STATE ROUTE 22",
    "dropdelcty": "BERLIN",
    "dropdelst": "NY",
    "dropdelzpp": 120229998,
    "dropphyadd": "18246 STATE ROUTE 22",
    "dropphycty": "BERLIN",
    "dropphyst": "NY",
    "dropphyzpp": 120229998,
    "dropmaladd": "18246 STATE ROUTE 22",
    "dropmalcty": "BERLIN",
    "dropmalst": "NY",
    "dropmalzpp": 120229998,
    "dropsitphn": 5186083647,
    "dropsitlph": 5186083647,
    "dropsitcph": 8779072115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12147",
    "droptype": "D",
    "dropname": "BERNE",
    "dropdeladd": "1654 HELDERBERG TRL",
    "dropdelcty": "BERNE",
    "dropdelst": "NY",
    "dropdelzpp": 120239998,
    "dropphyadd": "1654 HELDERBERG TRL",
    "dropphycty": "BERNE",
    "dropphyst": "NY",
    "dropphyzpp": 120239998,
    "dropmaladd": "1654 HELDERBERG TRL",
    "dropmalcty": "BERNE",
    "dropmalst": "NY",
    "dropmalzpp": 120239998,
    "dropsitphn": 5188720424,
    "dropsitlph": 5188720424,
    "dropsitcph": 5188720424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12148",
    "droptype": "D",
    "dropname": "BERNHARDS BAY",
    "dropdeladd": "694 STATE ROUTE 49",
    "dropdelcty": "BERNHARDS BAY",
    "dropdelst": "NY",
    "dropdelzpp": 130289998,
    "dropphyadd": "694 STATE ROUTE 49",
    "dropphycty": "BERNHARDS BAY",
    "dropphyst": "NY",
    "dropphyzpp": 130289998,
    "dropmaladd": "694 STATE ROUTE 49",
    "dropmalcty": "BERNHARDS BAY",
    "dropmalst": "NY",
    "dropmalzpp": 130289998,
    "dropsitphn": 3156753100,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156753100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12152",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "2166 STATE ROUTE 17B",
    "dropdelcty": "BETHEL",
    "dropdelst": "NY",
    "dropdelzpp": 127209998,
    "dropphyadd": "2166 STATE ROUTE 17B",
    "dropphycty": "BETHEL",
    "dropphyst": "NY",
    "dropphyzpp": 127209998,
    "dropmaladd": "2166 STATE ROUTE 17B",
    "dropmalcty": "BETHEL",
    "dropmalst": "NY",
    "dropmalzpp": 127209998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455835005,
    "dropsitcph": 8455835005,
    "dropfax": 8455831156
  },
  {
    "dcode": "D",
    "dropkey": "PV12155",
    "droptype": "D",
    "dropname": "BETHPAGE",
    "dropdeladd": "339 HICKSVILLE RD",
    "dropdelcty": "BETHPAGE",
    "dropdelst": "NY",
    "dropdelzpp": 117143401,
    "dropphyadd": "339 HICKSVILLE RD",
    "dropphycty": "BETHPAGE",
    "dropphyst": "NY",
    "dropphyzpp": 117143401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHPAGE",
    "dropmalst": "NY",
    "dropmalzpp": 117149998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169383901,
    "dropfax": 5166814269
  },
  {
    "dcode": "D",
    "dropkey": "PV12159",
    "droptype": "D",
    "dropname": "BIBLE SCHOOL PARK",
    "dropdeladd": "400 RIVERSIDE DR",
    "dropdelcty": "BIBLE SCHOOL PARK",
    "dropdelst": "NY",
    "dropdelzpp": 137379800,
    "dropphyadd": "400 RIVERSIDE DR",
    "dropphycty": "BIBLE SCHOOL PARK",
    "dropphyst": "NY",
    "dropphyzpp": 137379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIBLE SCHOOL PARK",
    "dropmalst": "NY",
    "dropmalzpp": 137379998,
    "dropsitphn": 6077974048,
    "dropsitlph": 6077974048,
    "dropsitcph": 6077974048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12162",
    "droptype": "D",
    "dropname": "BIG FLATS",
    "dropdeladd": "471 MAPLE ST",
    "dropdelcty": "BIG FLATS",
    "dropdelst": "NY",
    "dropdelzpp": 148149998,
    "dropphyadd": "471 MAPLE ST",
    "dropphycty": "BIG FLATS",
    "dropphyst": "NY",
    "dropphyzpp": 148149998,
    "dropmaladd": "471 MAPLE ST",
    "dropmalcty": "BIG FLATS",
    "dropmalst": "NY",
    "dropmalzpp": 148149998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075623159,
    "dropsitcph": 6075623159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12163",
    "droptype": "D",
    "dropname": "BIG INDIAN",
    "dropdeladd": "8279 STATE ROUTE 28",
    "dropdelcty": "BIG INDIAN",
    "dropdelst": "NY",
    "dropdelzpp": 124109998,
    "dropphyadd": "8279 STATE ROUTE 28",
    "dropphycty": "BIG INDIAN",
    "dropphyst": "NY",
    "dropphyzpp": 124109998,
    "dropmaladd": "8279 STATE ROUTE 28",
    "dropmalcty": "BIG INDIAN",
    "dropmalst": "NY",
    "dropmalzpp": 124109998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452544036,
    "dropsitcph": 8452544036,
    "dropfax": 8452544036
  },
  {
    "dcode": "D",
    "dropkey": "PV12165",
    "droptype": "D",
    "dropname": "BILLINGS",
    "dropdeladd": "2411 ROUTE 82",
    "dropdelcty": "BILLINGS",
    "dropdelst": "NY",
    "dropdelzpp": 125109800,
    "dropphyadd": "2411 ROUTE 82",
    "dropphycty": "BILLINGS",
    "dropphyst": "NY",
    "dropphyzpp": 125109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BILLINGS",
    "dropmalst": "NY",
    "dropmalzpp": 125109998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452235453,
    "dropsitcph": 8452235162,
    "dropfax": 8452235162
  },
  {
    "dcode": "D",
    "dropkey": "PV12170",
    "droptype": "D",
    "dropname": "BINGHAMTON",
    "dropdeladd": "115 HENRY ST",
    "dropdelcty": "BINGHAMTON",
    "dropdelst": "NY",
    "dropdelzpp": 139029998,
    "dropphyadd": "115 HENRY ST",
    "dropphycty": "BINGHAMTON",
    "dropphyst": "NY",
    "dropphyzpp": 139029998,
    "dropmaladd": "115 HENRY ST",
    "dropmalcty": "BINGHAMTON",
    "dropmalst": "NY",
    "dropmalzpp": 139029998,
    "dropsitphn": 6077732174,
    "dropsitlph": 6077732333,
    "dropsitcph": 6077732126,
    "dropfax": 6077732106
  },
  {
    "dcode": "D",
    "dropkey": "PV12172",
    "droptype": "D",
    "dropname": "BLACK CREEK",
    "dropdeladd": "6391 ROUTE 305",
    "dropdelcty": "BLACK CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 147149998,
    "dropphyadd": "6391 ROUTE 305",
    "dropphycty": "BLACK CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 147149998,
    "dropmaladd": "6391 ROUTE 305",
    "dropmalcty": "BLACK CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 147149998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859681509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12174",
    "droptype": "D",
    "dropname": "BLACK RIVER",
    "dropdeladd": "28553 STATE ROUTE 3",
    "dropdelcty": "BLACK RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 136129998,
    "dropphyadd": "28553 STATE ROUTE 3",
    "dropphycty": "BLACK RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 136129998,
    "dropmaladd": "28553 STATE ROUTE 3",
    "dropmalcty": "BLACK RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 136129998,
    "dropsitphn": 3157735000,
    "dropsitlph": 5184522299,
    "dropsitcph": 3157735000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12176",
    "droptype": "D",
    "dropname": "BLAUVELT",
    "dropdeladd": "545 WESTERN HWY",
    "dropdelcty": "BLAUVELT",
    "dropdelst": "NY",
    "dropdelzpp": 109139998,
    "dropphyadd": "545 WESTERN HWY",
    "dropphycty": "BLAUVELT",
    "dropphyst": "NY",
    "dropphyzpp": 109139998,
    "dropmaladd": "545 WESTERN HWY",
    "dropmalcty": "BLAUVELT",
    "dropmalst": "NY",
    "dropmalzpp": 109139998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453593477,
    "dropsitcph": 8453593477,
    "dropfax": 8453595233
  },
  {
    "dcode": "D",
    "dropkey": "PV12179",
    "droptype": "D",
    "dropname": "BLISS",
    "dropdeladd": "6664 ROUTE 362",
    "dropdelcty": "BLISS",
    "dropdelst": "NY",
    "dropdelzpp": 140249998,
    "dropphyadd": "6664 ROUTE 362",
    "dropphycty": "BLISS",
    "dropphyst": "NY",
    "dropphyzpp": 140249998,
    "dropmaladd": "6664 ROUTE 362",
    "dropmalcty": "BLISS",
    "dropmalst": "NY",
    "dropmalzpp": 140249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5853227740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12181",
    "droptype": "D",
    "dropname": "BLODGETT MILLS",
    "dropdeladd": "2320 BLODGETT MILLS RD",
    "dropdelcty": "BLODGETT MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 137389998,
    "dropphyadd": "2320 BLODGETT MILLS RD",
    "dropphycty": "BLODGETT MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 137389998,
    "dropmaladd": "2320 BLODGETT MILLS RD",
    "dropmalcty": "BLODGETT MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 137389998,
    "dropsitphn": 6077531467,
    "dropsitlph": 6077531467,
    "dropsitcph": 6077531467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12184",
    "droptype": "D",
    "dropname": "BLOOMING GROVE",
    "dropdeladd": "2876 ROUTE 94",
    "dropdelcty": "BLOOMING GROVE",
    "dropdelst": "NY",
    "dropdelzpp": 109149800,
    "dropphyadd": "2876 ROUTE 94",
    "dropphycty": "BLOOMING GROVE",
    "dropphyst": "NY",
    "dropphyzpp": 109149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMING GROVE",
    "dropmalst": "NY",
    "dropmalzpp": 109149998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454967501,
    "dropsitcph": 8454967501,
    "dropfax": 8454967501
  },
  {
    "dcode": "D",
    "dropkey": "PV12185",
    "droptype": "D",
    "dropname": "BLOOMINGBURG",
    "dropdeladd": "21 WINTERTON RD",
    "dropdelcty": "BLOOMINGBURG",
    "dropdelst": "NY",
    "dropdelzpp": 127219998,
    "dropphyadd": "21 WINTERTON RD",
    "dropphycty": "BLOOMINGBURG",
    "dropphyst": "NY",
    "dropphyzpp": 127219998,
    "dropmaladd": "21 WINTERTON RD",
    "dropmalcty": "BLOOMINGBURG",
    "dropmalst": "NY",
    "dropmalzpp": 127219998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457336735,
    "dropsitcph": 8457336735,
    "dropfax": 8457334800
  },
  {
    "dcode": "D",
    "dropkey": "PV12186",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "1711 STATE ROUTE 3 STE 1",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "NY",
    "dropdelzpp": 129139998,
    "dropphyadd": "1711 STATE ROUTE 3 STE 1",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "NY",
    "dropphyzpp": 129139998,
    "dropmaladd": "1711 STATE ROUTE 3 STE 1",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "NY",
    "dropmalzpp": 129139998,
    "dropsitphn": 5188912868,
    "dropsitlph": 5188912868,
    "dropsitcph": 5188912868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12188",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "58 MAIN ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 124119998,
    "dropphyadd": "58 MAIN ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 124119998,
    "dropmaladd": "58 MAIN ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 124119998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453381314,
    "dropsitcph": 8453381314,
    "dropfax": 8453381314
  },
  {
    "dcode": "D",
    "dropkey": "PV12189",
    "droptype": "D",
    "dropname": "BLOOMVILLE",
    "dropdeladd": "51948 STATE HIGHWAY 10",
    "dropdelcty": "BLOOMVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137399998,
    "dropphyadd": "51948 STATE HIGHWAY 10",
    "dropphycty": "BLOOMVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137399998,
    "dropmaladd": "51948 STATE HIGHWAY 10",
    "dropmalcty": "BLOOMVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137399998,
    "dropsitphn": 6075389011,
    "dropsitlph": 6075389011,
    "dropsitcph": 6075389011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12192",
    "droptype": "D",
    "dropname": "BLOSSVALE",
    "dropdeladd": "8461 MILL POND WAY",
    "dropdelcty": "BLOSSVALE",
    "dropdelst": "NY",
    "dropdelzpp": 133089998,
    "dropphyadd": "8461 MILL POND WAY",
    "dropphycty": "BLOSSVALE",
    "dropphyst": "NY",
    "dropphyzpp": 133089998,
    "dropmaladd": "8461 MILL POND WAY",
    "dropmalcty": "BLOSSVALE",
    "dropmalst": "NY",
    "dropmalzpp": 133089998,
    "dropsitphn": 3152452828,
    "dropsitlph": 3152452828,
    "dropsitcph": 3152452828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12194",
    "droptype": "D",
    "dropname": "BLUE MOUNTAIN LAKE",
    "dropdeladd": "3444 STATE ROUTE 28",
    "dropdelcty": "BLUE MOUNTAIN LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 128129998,
    "dropphyadd": "3444 STATE ROUTE 28",
    "dropphycty": "BLUE MOUNTAIN LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 128129998,
    "dropmaladd": "3444 STATE ROUTE 28",
    "dropmalcty": "BLUE MOUNTAIN LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 128129998,
    "dropsitphn": 5183527654,
    "dropsitlph": 5183527654,
    "dropsitcph": 5183527654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12196",
    "droptype": "D",
    "dropname": "BLUE POINT",
    "dropdeladd": "141 MONTAUK HWY",
    "dropdelcty": "BLUE POINT",
    "dropdelst": "NY",
    "dropdelzpp": 117151132,
    "dropphyadd": "141 MONTAUK HWY",
    "dropphycty": "BLUE POINT",
    "dropphyst": "NY",
    "dropphyzpp": 117151132,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE POINT",
    "dropmalst": "NY",
    "dropmalzpp": 117159998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313636272,
    "dropfax": 6313630841
  },
  {
    "dcode": "D",
    "dropkey": "PV12203",
    "droptype": "D",
    "dropname": "BOHEMIA",
    "dropdeladd": "200 ORVILLE DR",
    "dropdelcty": "BOHEMIA",
    "dropdelst": "NY",
    "dropdelzpp": 117162531,
    "dropphyadd": "200 ORVILLE DR",
    "dropphycty": "BOHEMIA",
    "dropphyst": "NY",
    "dropphyzpp": 117162531,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOHEMIA",
    "dropmalst": "NY",
    "dropmalzpp": 117169998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315892487,
    "dropfax": 6315634624
  },
  {
    "dcode": "D",
    "dropkey": "PV12204",
    "droptype": "D",
    "dropname": "BOICEVILLE",
    "dropdeladd": "4117 STATE ROUTE 28",
    "dropdelcty": "BOICEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124129998,
    "dropphyadd": "4117 STATE ROUTE 28",
    "dropphycty": "BOICEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124129998,
    "dropmaladd": "4117 STATE ROUTE 28",
    "dropmalcty": "BOICEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124129998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456572226,
    "dropsitcph": 8456572226,
    "dropfax": 8456572226
  },
  {
    "dcode": "D",
    "dropkey": "PV12207",
    "droptype": "D",
    "dropname": "BOLIVAR",
    "dropdeladd": "279 MAIN ST",
    "dropdelcty": "BOLIVAR",
    "dropdelst": "NY",
    "dropdelzpp": 147159998,
    "dropphyadd": "279 MAIN ST",
    "dropphycty": "BOLIVAR",
    "dropphyst": "NY",
    "dropphyzpp": 147159998,
    "dropmaladd": "279 MAIN ST",
    "dropmalcty": "BOLIVAR",
    "dropmalst": "NY",
    "dropmalzpp": 147159998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859282040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12208",
    "droptype": "D",
    "dropname": "BOLTON LANDING",
    "dropdeladd": "5000 LAKE SHORE DR",
    "dropdelcty": "BOLTON LANDING",
    "dropdelst": "NY",
    "dropdelzpp": 128149998,
    "dropphyadd": "5000 LAKE SHORE DR",
    "dropphycty": "BOLTON LANDING",
    "dropphyst": "NY",
    "dropphyzpp": 128149998,
    "dropmaladd": "5000 LAKE SHORE DR",
    "dropmalcty": "BOLTON LANDING",
    "dropmalst": "NY",
    "dropmalzpp": 128149998,
    "dropsitphn": 5186449666,
    "dropsitlph": 5186449666,
    "dropsitcph": 5186449666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12210",
    "droptype": "D",
    "dropname": "BOMBAY",
    "dropdeladd": "1794 STATE ROUTE 95",
    "dropdelcty": "BOMBAY",
    "dropdelst": "NY",
    "dropdelzpp": 129142423,
    "dropphyadd": "1794 STATE ROUTE 95",
    "dropphycty": "BOMBAY",
    "dropphyst": "NY",
    "dropphyzpp": 129142423,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOMBAY",
    "dropmalst": "NY",
    "dropmalzpp": 129149998,
    "dropsitphn": 5183589965,
    "dropsitlph": 5183589965,
    "dropsitcph": 5183589965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12212",
    "droptype": "D",
    "dropname": "BOONVILLE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "BOONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133099998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "BOONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133099998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "BOONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133099998,
    "dropsitphn": 3159424816,
    "dropsitlph": 3159424816,
    "dropsitcph": 3159424816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12216",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "9025 BOSTON STATE RD",
    "dropdelcty": "BOSTON",
    "dropdelst": "NY",
    "dropdelzpp": 140259998,
    "dropphyadd": "9025 BOSTON STATE RD",
    "dropphycty": "BOSTON",
    "dropphyst": "NY",
    "dropphyzpp": 140259998,
    "dropmaladd": "9025 BOSTON STATE RD",
    "dropmalcty": "BOSTON",
    "dropmalst": "NY",
    "dropmalzpp": 140259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169415420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12232",
    "droptype": "D",
    "dropname": "BOWMANSVILLE",
    "dropdeladd": "515 HARRIS HILL RD",
    "dropdelcty": "BOWMANSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140269998,
    "dropphyadd": "515 HARRIS HILL RD",
    "dropphycty": "BOWMANSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140269998,
    "dropmaladd": "515 HARRIS HILL RD",
    "dropmalcty": "BOWMANSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166851390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12244",
    "droptype": "D",
    "dropname": "BRAINARDSVILLE",
    "dropdeladd": "2399 COUNTY ROUTE 24",
    "dropdelcty": "BRAINARDSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129159998,
    "dropphyadd": "2399 COUNTY ROUTE 24",
    "dropphycty": "BRAINARDSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129159998,
    "dropmaladd": "2399 COUNTY ROUTE 24",
    "dropmalcty": "BRAINARDSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129159998,
    "dropsitphn": 5184253441,
    "dropsitlph": 5184253441,
    "dropsitcph": 5184253441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12251",
    "droptype": "D",
    "dropname": "BRANT",
    "dropdeladd": "10778 BRANT ANGOLA RD",
    "dropdelcty": "BRANT",
    "dropdelst": "NY",
    "dropdelzpp": 140279800,
    "dropphyadd": "10778 BRANT ANGOLA RD",
    "dropphycty": "BRANT",
    "dropphyst": "NY",
    "dropphyzpp": 140279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANT",
    "dropmalst": "NY",
    "dropmalzpp": 140279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165490777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12252",
    "droptype": "D",
    "dropname": "BRANT LAKE",
    "dropdeladd": "6580 STATE ROUTE 8",
    "dropdelcty": "BRANT LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 128151924,
    "dropphyadd": "6580 STATE ROUTE 8",
    "dropphycty": "BRANT LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 128151924,
    "dropmaladd": "6580 STATE ROUTE 8",
    "dropmalcty": "BRANT LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 128159998,
    "dropsitphn": 5184943021,
    "dropsitlph": 5184943021,
    "dropsitcph": 5184943021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12254",
    "droptype": "D",
    "dropname": "BRASHER FALLS",
    "dropdeladd": "905 STATE HIGHWAY 11C",
    "dropdelcty": "BRASHER FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 136139998,
    "dropphyadd": "905 STATE HIGHWAY 11C",
    "dropphycty": "BRASHER FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 136139998,
    "dropmaladd": "905 STATE HIGHWAY 11C",
    "dropmalcty": "BRASHER FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 136139998,
    "dropsitphn": 3153895090,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153895090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12259",
    "droptype": "D",
    "dropname": "BREESPORT",
    "dropdeladd": "657 MAIN ST",
    "dropdelcty": "BREESPORT",
    "dropdelst": "NY",
    "dropdelzpp": 148169998,
    "dropphyadd": "657 MAIN ST",
    "dropphycty": "BREESPORT",
    "dropphyst": "NY",
    "dropphyzpp": 148169998,
    "dropmaladd": "657 MAIN ST",
    "dropmalcty": "BREESPORT",
    "dropmalst": "NY",
    "dropmalzpp": 148169998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077392230,
    "dropsitcph": 6077392230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12261",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "25 2ND AVE",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 117174627,
    "dropphyadd": "25 2ND AVE",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 117174627,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 117179998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312730947,
    "dropfax": 6312736353
  },
  {
    "dcode": "D",
    "dropkey": "PV12264",
    "droptype": "D",
    "dropname": "BREWERTON",
    "dropdeladd": "5560 BARTEL RD",
    "dropdelcty": "BREWERTON",
    "dropdelst": "NY",
    "dropdelzpp": 130299998,
    "dropphyadd": "5560 BARTEL RD",
    "dropphycty": "BREWERTON",
    "dropphyst": "NY",
    "dropphyzpp": 130299998,
    "dropmaladd": "5560 BARTEL RD",
    "dropmalcty": "BREWERTON",
    "dropmalst": "NY",
    "dropmalzpp": 130299998,
    "dropsitphn": 3156767790,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156767790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12265",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "3 MOUNT EBO RD N",
    "dropdelcty": "BREWSTER",
    "dropdelst": "NY",
    "dropdelzpp": 105099998,
    "dropphyadd": "3 MOUNT EBO RD N",
    "dropphycty": "BREWSTER",
    "dropphyst": "NY",
    "dropphyzpp": 105099998,
    "dropmaladd": "3 MOUNT EBO RD N",
    "dropmalcty": "BREWSTER",
    "dropmalst": "NY",
    "dropmalzpp": 105099998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452790138,
    "dropsitcph": 8452790138,
    "dropfax": 8452791506
  },
  {
    "dcode": "D",
    "dropkey": "PV12271",
    "droptype": "D",
    "dropname": "BRIARCLIFF MANOR",
    "dropdeladd": "1077 PLEASANTVILLE RD",
    "dropdelcty": "BRIARCLIFF MANOR",
    "dropdelst": "NY",
    "dropdelzpp": 105109998,
    "dropphyadd": "1077 PLEASANTVILLE RD",
    "dropphycty": "BRIARCLIFF MANOR",
    "dropphyst": "NY",
    "dropphyzpp": 105109998,
    "dropmaladd": "1077 PLEASANTVILLE RD",
    "dropmalcty": "BRIARCLIFF MANOR",
    "dropmalst": "NY",
    "dropmalzpp": 105109998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149234677,
    "dropsitcph": 9149234677,
    "dropfax": 9149449289
  },
  {
    "dcode": "D",
    "dropkey": "PV12276",
    "droptype": "D",
    "dropname": "BRIDGEHAMPTON",
    "dropdeladd": "2322 MONTAUK HWY",
    "dropdelcty": "BRIDGEHAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 119329700,
    "dropphyadd": "2322 MONTAUK HWY",
    "dropphycty": "BRIDGEHAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 119329700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEHAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 119329998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315379322,
    "dropfax": 6315375122
  },
  {
    "dcode": "D",
    "dropkey": "PV12277",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "7901 BRIDGEPORT MINOA RD",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "NY",
    "dropdelzpp": 130309998,
    "dropphyadd": "7901 BRIDGEPORT MINOA RD",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "NY",
    "dropphyzpp": 130309998,
    "dropmaladd": "7901 BRIDGEPORT MINOA RD",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "NY",
    "dropmalzpp": 130309998,
    "dropsitphn": 3156339641,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156339641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12279",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "320 STATE ROUTE 8",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "NY",
    "dropdelzpp": 133139998,
    "dropphyadd": "320 STATE ROUTE 8",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "NY",
    "dropphyzpp": 133139998,
    "dropmaladd": "320 STATE ROUTE 8",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "NY",
    "dropmalzpp": 133139998,
    "dropsitphn": 3158226471,
    "dropsitlph": 3158226471,
    "dropsitcph": 3158226471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12280",
    "droptype": "D",
    "dropname": "BRIER HILL",
    "dropdeladd": "39 COUNTY ROUTE 2",
    "dropdelcty": "BRIER HILL",
    "dropdelst": "NY",
    "dropdelzpp": 136149998,
    "dropphyadd": "39 COUNTY ROUTE 2",
    "dropphycty": "BRIER HILL",
    "dropphyst": "NY",
    "dropphyzpp": 136149998,
    "dropmaladd": "39 COUNTY ROUTE 2",
    "dropmalcty": "BRIER HILL",
    "dropmalst": "NY",
    "dropmalzpp": 136149998,
    "dropsitphn": 3153756767,
    "dropsitlph": 3153756767,
    "dropsitcph": 3153756767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12287",
    "droptype": "D",
    "dropname": "BRIGHTWATERS",
    "dropdeladd": "145 ORINOCO DR",
    "dropdelcty": "BRIGHTWATERS",
    "dropdelst": "NY",
    "dropdelzpp": 117181304,
    "dropphyadd": "145 ORINOCO DR",
    "dropphycty": "BRIGHTWATERS",
    "dropphyst": "NY",
    "dropphyzpp": 117181304,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIGHTWATERS",
    "dropmalst": "NY",
    "dropmalzpp": 117189998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312064855,
    "dropfax": 6316668021
  },
  {
    "dcode": "D",
    "dropkey": "PV12300",
    "droptype": "D",
    "dropname": "BROADALBIN",
    "dropdeladd": "10 CENTER ST",
    "dropdelcty": "BROADALBIN",
    "dropdelst": "NY",
    "dropdelzpp": 120259998,
    "dropphyadd": "10 CENTER ST",
    "dropphycty": "BROADALBIN",
    "dropphyst": "NY",
    "dropphyzpp": 120259998,
    "dropmaladd": "10 CENTER ST",
    "dropmalcty": "BROADALBIN",
    "dropmalst": "NY",
    "dropmalzpp": 120259998,
    "dropsitphn": 5188835523,
    "dropsitlph": 5188835523,
    "dropsitcph": 5188835523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12303",
    "droptype": "D",
    "dropname": "BROCKPORT",
    "dropdeladd": "14 MAIN ST",
    "dropdelcty": "BROCKPORT",
    "dropdelst": "NY",
    "dropdelzpp": 144209998,
    "dropphyadd": "14 MAIN ST",
    "dropphycty": "BROCKPORT",
    "dropphyst": "NY",
    "dropphyzpp": 144209998,
    "dropmaladd": "14 MAIN ST",
    "dropmalcty": "BROCKPORT",
    "dropmalst": "NY",
    "dropmalzpp": 144209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856374400,
    "dropsitcph": 5856374400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12304",
    "droptype": "D",
    "dropname": "BROCTON",
    "dropdeladd": "42 E MAIN ST",
    "dropdelcty": "BROCTON",
    "dropdelst": "NY",
    "dropdelzpp": 147169998,
    "dropphyadd": "42 E MAIN ST",
    "dropphycty": "BROCTON",
    "dropphyst": "NY",
    "dropphyzpp": 147169998,
    "dropmaladd": "42 E MAIN ST",
    "dropmalcty": "BROCTON",
    "dropmalst": "NY",
    "dropmalzpp": 147169998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167924241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12306",
    "droptype": "D",
    "dropname": "BRONX",
    "dropdeladd": "558 GRAND CONCOURSE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104519998,
    "dropphyadd": "558 GRAND CONCOURSE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104519998,
    "dropmaladd": "558 GRAND CONCOURSE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104519998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7184024674,
    "dropsitcph": 7184023430,
    "dropfax": 7184022660
  },
  {
    "dcode": "D",
    "dropkey": "PV12313",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "10511 MAIN ST",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 133149998,
    "dropphyadd": "10511 MAIN ST",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 133149998,
    "dropmaladd": "10511 MAIN ST",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 133149998,
    "dropsitphn": 3158995820,
    "dropsitlph": 3158995820,
    "dropsitcph": 3158995820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12315",
    "droptype": "D",
    "dropname": "BROOKHAVEN",
    "dropdeladd": "2512 MONTAUK HWY",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "NY",
    "dropdelzpp": 117194000,
    "dropphyadd": "2512 MONTAUK HWY",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "NY",
    "dropphyzpp": 117194000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "NY",
    "dropmalzpp": 117199998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312861591,
    "dropfax": 6312865281
  },
  {
    "dcode": "D",
    "dropkey": "PV12317",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "1050 FORBELL ST RM 2005",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112569700,
    "dropphyadd": "1050 FORBELL ST RM 2005",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112569700,
    "dropmaladd": "1050 FORBELL ST RM 2005",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112569700,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188343048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12321",
    "droptype": "D",
    "dropname": "BROOKTONDALE",
    "dropdeladd": "456 BROOKTONDALE RD",
    "dropdelcty": "BROOKTONDALE",
    "dropdelst": "NY",
    "dropdelzpp": 148179998,
    "dropphyadd": "456 BROOKTONDALE RD",
    "dropphycty": "BROOKTONDALE",
    "dropphyst": "NY",
    "dropphyzpp": 148179998,
    "dropmaladd": "456 BROOKTONDALE RD",
    "dropmalcty": "BROOKTONDALE",
    "dropmalst": "NY",
    "dropmalzpp": 148179998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075397112,
    "dropsitcph": 6075397112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12327",
    "droptype": "D",
    "dropname": "BROWNVILLE",
    "dropdeladd": "118 BROWN BLVD",
    "dropdelcty": "BROWNVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136159998,
    "dropphyadd": "118 BROWN BLVD",
    "dropphycty": "BROWNVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136159998,
    "dropmaladd": "118 BROWN BLVD",
    "dropmalcty": "BROWNVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136159998,
    "dropsitphn": 3157883390,
    "dropsitlph": 5184522299,
    "dropsitcph": 3157883390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12332",
    "droptype": "D",
    "dropname": "BRUSHTON",
    "dropdeladd": "1249 WASHINGTON ST",
    "dropdelcty": "BRUSHTON",
    "dropdelst": "NY",
    "dropdelzpp": 129169998,
    "dropphyadd": "1249 WASHINGTON ST",
    "dropphycty": "BRUSHTON",
    "dropphyst": "NY",
    "dropphyzpp": 129169998,
    "dropmaladd": "1249 WASHINGTON ST",
    "dropmalcty": "BRUSHTON",
    "dropmalst": "NY",
    "dropmalzpp": 129169998,
    "dropsitphn": 5185297306,
    "dropsitlph": 5185297306,
    "dropsitcph": 5185297306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12336",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "252 TATE AVE",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "NY",
    "dropdelzpp": 105119998,
    "dropphyadd": "252 TATE AVE",
    "dropphycty": "BUCHANAN",
    "dropphyst": "NY",
    "dropphyzpp": 105119998,
    "dropmaladd": "252 TATE AVE",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "NY",
    "dropmalzpp": 105119998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147379241,
    "dropsitcph": 9147379241,
    "dropfax": 9147375309
  },
  {
    "dcode": "D",
    "dropkey": "PV12344",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "1200 WILLIAM ST RM 200",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142409998,
    "dropphyadd": "1200 WILLIAM ST RM 200",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142409998,
    "dropmaladd": "1200 WILLIAM ST RM 200",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142409998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168462401,
    "dropfax": 7168462407
  },
  {
    "dcode": "D",
    "dropkey": "PV12348",
    "droptype": "D",
    "dropname": "BULLVILLE",
    "dropdeladd": "652 LYBOLT RD",
    "dropdelcty": "BULLVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109159800,
    "dropphyadd": "652 LYBOLT RD",
    "dropphycty": "BULLVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BULLVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109159998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453615411,
    "dropsitcph": 8453615411,
    "dropfax": 8453615411
  },
  {
    "dcode": "D",
    "dropkey": "PV12351",
    "droptype": "D",
    "dropname": "BURDETT",
    "dropdeladd": "3986 LAKE AVE",
    "dropdelcty": "BURDETT",
    "dropdelst": "NY",
    "dropdelzpp": 148189998,
    "dropphyadd": "3986 LAKE AVE",
    "dropphycty": "BURDETT",
    "dropphyst": "NY",
    "dropphyzpp": 148189998,
    "dropmaladd": "3986 LAKE AVE",
    "dropmalcty": "BURDETT",
    "dropmalst": "NY",
    "dropmalzpp": 148189998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075467691,
    "dropsitcph": 6075467691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12353",
    "droptype": "D",
    "dropname": "BURKE",
    "dropdeladd": "822 DEPOT ST",
    "dropdelcty": "BURKE",
    "dropdelst": "NY",
    "dropdelzpp": 129179998,
    "dropphyadd": "822 DEPOT ST",
    "dropphycty": "BURKE",
    "dropphyst": "NY",
    "dropphyzpp": 129179998,
    "dropmaladd": "822 DEPOT ST",
    "dropmalcty": "BURKE",
    "dropmalst": "NY",
    "dropmalzpp": 129179998,
    "dropsitphn": 5184834287,
    "dropsitlph": 5184834287,
    "dropsitcph": 5184834287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12354",
    "droptype": "D",
    "dropname": "BURLINGHAM",
    "dropdeladd": "709 BURLINGHAM RD",
    "dropdelcty": "BURLINGHAM",
    "dropdelst": "NY",
    "dropdelzpp": 127229800,
    "dropphyadd": "709 BURLINGHAM RD",
    "dropphycty": "BURLINGHAM",
    "dropphyst": "NY",
    "dropphyzpp": 127229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURLINGHAM",
    "dropmalst": "NY",
    "dropmalzpp": 127229998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457331811,
    "dropsitcph": 8457331811,
    "dropfax": 8457331811
  },
  {
    "dcode": "D",
    "dropkey": "PV12356",
    "droptype": "D",
    "dropname": "BURLINGTON FLATS",
    "dropdeladd": "6047 STATE HIGHWAY 51",
    "dropdelcty": "BURLINGTON FLATS",
    "dropdelst": "NY",
    "dropdelzpp": 133159998,
    "dropphyadd": "6047 STATE HIGHWAY 51",
    "dropphycty": "BURLINGTON FLATS",
    "dropphyst": "NY",
    "dropphyzpp": 133159998,
    "dropmaladd": "6047 STATE HIGHWAY 51",
    "dropmalcty": "BURLINGTON FLATS",
    "dropmalst": "NY",
    "dropmalzpp": 133159998,
    "dropsitphn": 6079658873,
    "dropsitlph": 6079658873,
    "dropsitcph": 6079658873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12359",
    "droptype": "D",
    "dropname": "BURNT HILLS",
    "dropdeladd": "845 STATE ROUTE 50",
    "dropdelcty": "BURNT HILLS",
    "dropdelst": "NY",
    "dropdelzpp": 120279998,
    "dropphyadd": "845 STATE ROUTE 50",
    "dropphycty": "BURNT HILLS",
    "dropphyst": "NY",
    "dropphyzpp": 120279998,
    "dropmaladd": "845 STATE ROUTE 50",
    "dropmalcty": "BURNT HILLS",
    "dropmalst": "NY",
    "dropmalzpp": 120279590,
    "dropsitphn": 5183998111,
    "dropsitlph": 5183998111,
    "dropsitcph": 5183998111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12375",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "6332 ROUTE 262",
    "dropdelcty": "BYRON",
    "dropdelst": "NY",
    "dropdelzpp": 144229998,
    "dropphyadd": "6332 ROUTE 262",
    "dropphycty": "BYRON",
    "dropphyst": "NY",
    "dropphyzpp": 144229998,
    "dropmaladd": "6332 ROUTE 262",
    "dropmalcty": "BYRON",
    "dropmalst": "NY",
    "dropmalzpp": 144229998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855482645,
    "dropsitcph": 5855482645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12382",
    "droptype": "D",
    "dropname": "CADYVILLE",
    "dropdeladd": "2106 STATE ROUTE 3",
    "dropdelcty": "CADYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129189998,
    "dropphyadd": "2106 STATE ROUTE 3",
    "dropphycty": "CADYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129189998,
    "dropmaladd": "2106 STATE ROUTE 3",
    "dropmalcty": "CADYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129189998,
    "dropsitphn": 5182937510,
    "dropsitlph": 5182937510,
    "dropsitcph": 5182937510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12383",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "540 MAIN ST",
    "dropdelcty": "CAIRO",
    "dropdelst": "NY",
    "dropdelzpp": 124139998,
    "dropphyadd": "540 MAIN ST",
    "dropphycty": "CAIRO",
    "dropphyst": "NY",
    "dropphyzpp": 124139998,
    "dropmaladd": "540 MAIN ST",
    "dropmalcty": "CAIRO",
    "dropmalst": "NY",
    "dropmalzpp": 124139998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186229766,
    "dropsitcph": 5186229766,
    "dropfax": 5186223167
  },
  {
    "dcode": "D",
    "dropkey": "PV12384",
    "droptype": "D",
    "dropname": "CALCIUM",
    "dropdeladd": "24841 SANFORD CORNERS RD",
    "dropdelcty": "CALCIUM",
    "dropdelst": "NY",
    "dropdelzpp": 136169998,
    "dropphyadd": "24841 SANFORD CORNERS RD",
    "dropphycty": "CALCIUM",
    "dropphyst": "NY",
    "dropphyzpp": 136169998,
    "dropmaladd": "24841 SANFORD CORNERS RD",
    "dropmalcty": "CALCIUM",
    "dropmalst": "NY",
    "dropmalzpp": 136169998,
    "dropsitphn": 3157881881,
    "dropsitlph": 3157881881,
    "dropsitcph": 3157881881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12387",
    "droptype": "D",
    "dropname": "CALLICOON",
    "dropdeladd": "13 RIVER RD",
    "dropdelcty": "CALLICOON",
    "dropdelst": "NY",
    "dropdelzpp": 127239998,
    "dropphyadd": "13 RIVER RD",
    "dropphycty": "CALLICOON",
    "dropphyst": "NY",
    "dropphyzpp": 127239998,
    "dropmaladd": "13 RIVER RD",
    "dropmalcty": "CALLICOON",
    "dropmalst": "NY",
    "dropmalzpp": 127239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458876810,
    "dropsitcph": 8458876810,
    "dropfax": 8458876548
  },
  {
    "dcode": "D",
    "dropkey": "PV12388",
    "droptype": "D",
    "dropname": "CALLICOON CENTER",
    "dropdeladd": "1675 GULF RD",
    "dropdelcty": "CALLICOON CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 127249800,
    "dropphyadd": "1675 GULF RD",
    "dropphycty": "CALLICOON CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 127249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALLICOON CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 127249998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454824287,
    "dropsitcph": 8454824287,
    "dropfax": 8454824287
  },
  {
    "dcode": "D",
    "dropkey": "PV12390",
    "droptype": "D",
    "dropname": "CALVERTON",
    "dropdeladd": "3690 MIDDLE COUNTRY RD",
    "dropdelcty": "CALVERTON",
    "dropdelst": "NY",
    "dropdelzpp": 119331804,
    "dropphyadd": "3690 MIDDLE COUNTRY RD",
    "dropphycty": "CALVERTON",
    "dropphyst": "NY",
    "dropphyzpp": 119331804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALVERTON",
    "dropmalst": "NY",
    "dropmalzpp": 119339998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317270067,
    "dropfax": 6317278731
  },
  {
    "dcode": "D",
    "dropkey": "PV12394",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "51 E MAIN ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 128169998,
    "dropphyadd": "51 E MAIN ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 128169998,
    "dropmaladd": "51 E MAIN ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 128169998,
    "dropsitphn": 5186773585,
    "dropsitlph": 5186773585,
    "dropsitcph": 5186773585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12395",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "NY",
    "dropdelzpp": 133169998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "NY",
    "dropphyzpp": 133169998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "NY",
    "dropmalzpp": 133169998,
    "dropsitphn": 3152450430,
    "dropsitlph": 3152450430,
    "dropsitcph": 3152450430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12397",
    "droptype": "D",
    "dropname": "CAMERON MILLS",
    "dropdeladd": "6785 COUNTY ROUTE 119",
    "dropdelcty": "CAMERON MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 148209998,
    "dropphyadd": "6785 COUNTY ROUTE 119",
    "dropphycty": "CAMERON MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 148209998,
    "dropmaladd": "6785 COUNTY ROUTE 119",
    "dropmalcty": "CAMERON MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 148209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6076959700,
    "dropsitcph": 6076959700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12398",
    "droptype": "D",
    "dropname": "CAMILLUS",
    "dropdeladd": "120 KASSON RD",
    "dropdelcty": "CAMILLUS",
    "dropdelst": "NY",
    "dropdelzpp": 130319998,
    "dropphyadd": "120 KASSON RD",
    "dropphycty": "CAMILLUS",
    "dropphyst": "NY",
    "dropphyzpp": 130319998,
    "dropmaladd": "120 KASSON RD",
    "dropmalcty": "CAMILLUS",
    "dropmalst": "NY",
    "dropmalzpp": 130319998,
    "dropsitphn": 3154879097,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154879097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12401",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "8753 MAIN ST",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "NY",
    "dropdelzpp": 148219998,
    "dropphyadd": "8753 MAIN ST",
    "dropphycty": "CAMPBELL",
    "dropphyst": "NY",
    "dropphyzpp": 148219998,
    "dropmaladd": "8753 MAIN ST",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "NY",
    "dropmalzpp": 148219998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075278791,
    "dropsitcph": 6075278791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12402",
    "droptype": "D",
    "dropname": "CAMPBELL HALL",
    "dropdeladd": "10 MAYBROOK RD",
    "dropdelcty": "CAMPBELL HALL",
    "dropdelst": "NY",
    "dropdelzpp": 109169998,
    "dropphyadd": "10 MAYBROOK RD",
    "dropphycty": "CAMPBELL HALL",
    "dropphyst": "NY",
    "dropphyzpp": 109169998,
    "dropmaladd": "10 MAYBROOK RD",
    "dropmalcty": "CAMPBELL HALL",
    "dropmalst": "NY",
    "dropmalzpp": 109169998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454277013,
    "dropsitcph": 8454277013,
    "dropfax": 8454275254
  },
  {
    "dcode": "D",
    "dropkey": "PV12405",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "1961 STATE ROUTE 295",
    "dropdelcty": "CANAAN",
    "dropdelst": "NY",
    "dropdelzpp": 120293817,
    "dropphyadd": "1961 STATE ROUTE 295",
    "dropphycty": "CANAAN",
    "dropphyst": "NY",
    "dropphyzpp": 120293817,
    "dropmaladd": "1961 STATE ROUTE 295",
    "dropmalcty": "CANAAN",
    "dropmalst": "NY",
    "dropmalzpp": 120299998,
    "dropsitphn": 5187814727,
    "dropsitlph": 5187814727,
    "dropsitcph": 5187814727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12409",
    "droptype": "D",
    "dropname": "CANAJOHARIE",
    "dropdeladd": "50 W MAIN ST",
    "dropdelcty": "CANAJOHARIE",
    "dropdelst": "NY",
    "dropdelzpp": 133179998,
    "dropphyadd": "50 W MAIN ST",
    "dropphycty": "CANAJOHARIE",
    "dropphyst": "NY",
    "dropphyzpp": 133179998,
    "dropmaladd": "50 W MAIN ST",
    "dropmalcty": "CANAJOHARIE",
    "dropmalst": "NY",
    "dropmalzpp": 133179998,
    "dropsitphn": 5186735811,
    "dropsitlph": 5186735811,
    "dropsitcph": 5186735811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12412",
    "droptype": "D",
    "dropname": "CANANDAIGUA",
    "dropdeladd": "405 EASTERN BLVD",
    "dropdelcty": "CANANDAIGUA",
    "dropdelst": "NY",
    "dropdelzpp": 144249998,
    "dropphyadd": "405 EASTERN BLVD",
    "dropphycty": "CANANDAIGUA",
    "dropphyst": "NY",
    "dropphyzpp": 144249998,
    "dropmaladd": "405 EASTERN BLVD",
    "dropmalcty": "CANANDAIGUA",
    "dropmalst": "NY",
    "dropmalzpp": 144249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853941500,
    "dropsitcph": 5853941500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12414",
    "droptype": "D",
    "dropname": "CANASERAGA",
    "dropdeladd": "59 MAIN ST",
    "dropdelcty": "CANASERAGA",
    "dropdelst": "NY",
    "dropdelzpp": 148229998,
    "dropphyadd": "59 MAIN ST",
    "dropphycty": "CANASERAGA",
    "dropphyst": "NY",
    "dropphyzpp": 148229998,
    "dropmaladd": "59 MAIN ST",
    "dropmalcty": "CANASERAGA",
    "dropmalst": "NY",
    "dropmalzpp": 148229998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075458850,
    "dropsitcph": 6075458850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12415",
    "droptype": "D",
    "dropname": "CANASTOTA",
    "dropdeladd": "118 S PETERBORO ST",
    "dropdelcty": "CANASTOTA",
    "dropdelst": "NY",
    "dropdelzpp": 130329998,
    "dropphyadd": "118 S PETERBORO ST",
    "dropphycty": "CANASTOTA",
    "dropphyst": "NY",
    "dropphyzpp": 130329998,
    "dropmaladd": "118 S PETERBORO ST",
    "dropmalcty": "CANASTOTA",
    "dropmalst": "NY",
    "dropmalzpp": 130329998,
    "dropsitphn": 3156977717,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156977717,
    "dropfax": 3156978491
  },
  {
    "dcode": "D",
    "dropkey": "PV12416",
    "droptype": "D",
    "dropname": "CANDOR",
    "dropdeladd": "62 MAIN ST",
    "dropdelcty": "CANDOR",
    "dropdelst": "NY",
    "dropdelzpp": 137439998,
    "dropphyadd": "62 MAIN ST",
    "dropphycty": "CANDOR",
    "dropphyst": "NY",
    "dropphyzpp": 137439998,
    "dropmaladd": "62 MAIN ST",
    "dropmalcty": "CANDOR",
    "dropmalst": "NY",
    "dropmalzpp": 137439998,
    "dropsitphn": 6076593085,
    "dropsitlph": 6076593085,
    "dropsitcph": 6076593085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12417",
    "droptype": "D",
    "dropname": "CANEADEA",
    "dropdeladd": "8915 STATE ROUTE 19",
    "dropdelcty": "CANEADEA",
    "dropdelst": "NY",
    "dropdelzpp": 147179998,
    "dropphyadd": "8915 STATE ROUTE 19",
    "dropphycty": "CANEADEA",
    "dropphyst": "NY",
    "dropphyzpp": 147179998,
    "dropmaladd": "8915 STATE ROUTE 19",
    "dropmalcty": "CANEADEA",
    "dropmalst": "NY",
    "dropmalzpp": 147179998,
    "dropsitphn": 5853652376,
    "dropsitlph": 5853652376,
    "dropsitcph": 5853652376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12418",
    "droptype": "D",
    "dropname": "CANISTEO",
    "dropdeladd": "6 DEPOT ST",
    "dropdelcty": "CANISTEO",
    "dropdelst": "NY",
    "dropdelzpp": 148239998,
    "dropphyadd": "6 DEPOT ST",
    "dropphycty": "CANISTEO",
    "dropphyst": "NY",
    "dropphyzpp": 148239998,
    "dropmaladd": "6 DEPOT ST",
    "dropmalcty": "CANISTEO",
    "dropmalst": "NY",
    "dropmalzpp": 148239998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6076984081,
    "dropsitcph": 6076984081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12421",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "CANTON",
    "dropdelst": "NY",
    "dropdelzpp": 136179998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "CANTON",
    "dropphyst": "NY",
    "dropphyzpp": 136179998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "CANTON",
    "dropmalst": "NY",
    "dropmalzpp": 136179998,
    "dropsitphn": 3153864502,
    "dropsitlph": 3153864502,
    "dropsitcph": 3153864502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12422",
    "droptype": "D",
    "dropname": "CAPE VINCENT",
    "dropdeladd": "362 E BROADWAY ST",
    "dropdelcty": "CAPE VINCENT",
    "dropdelst": "NY",
    "dropdelzpp": 136189998,
    "dropphyadd": "362 E BROADWAY ST",
    "dropphycty": "CAPE VINCENT",
    "dropphyst": "NY",
    "dropphyzpp": 136189998,
    "dropmaladd": "362 E BROADWAY ST",
    "dropmalcty": "CAPE VINCENT",
    "dropmalst": "NY",
    "dropmalzpp": 136189998,
    "dropsitphn": 3156542424,
    "dropsitlph": 3156542424,
    "dropsitcph": 3156542424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12428",
    "droptype": "D",
    "dropname": "CARLE PLACE",
    "dropdeladd": "309 WESTBURY AVE",
    "dropdelcty": "CARLE PLACE",
    "dropdelst": "NY",
    "dropdelzpp": 115141656,
    "dropphyadd": "309 WESTBURY AVE",
    "dropphycty": "CARLE PLACE",
    "dropphyst": "NY",
    "dropphyzpp": 115141656,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLE PLACE",
    "dropmalst": "NY",
    "dropmalzpp": 115149998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163333147,
    "dropfax": 5163345263
  },
  {
    "dcode": "D",
    "dropkey": "PV12429",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "2429 HIGHWAY ROUTE 20",
    "dropdelcty": "CARLISLE",
    "dropdelst": "NY",
    "dropdelzpp": 120319998,
    "dropphyadd": "2429 HIGHWAY ROUTE 20",
    "dropphycty": "CARLISLE",
    "dropphyst": "NY",
    "dropphyzpp": 120319998,
    "dropmaladd": "2429 HIGHWAY ROUTE 20",
    "dropmalcty": "CARLISLE",
    "dropmalst": "NY",
    "dropmalzpp": 120319998,
    "dropsitphn": 5182342021,
    "dropsitlph": 5182342021,
    "dropsitcph": 5182342021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12431",
    "droptype": "D",
    "dropname": "CARMEL",
    "dropdeladd": "29 FAIR ST",
    "dropdelcty": "CARMEL",
    "dropdelst": "NY",
    "dropdelzpp": 105129998,
    "dropphyadd": "29 FAIR ST",
    "dropphycty": "CARMEL",
    "dropphyst": "NY",
    "dropphyzpp": 105129998,
    "dropmaladd": "29 FAIR ST",
    "dropmalcty": "CARMEL",
    "dropmalst": "NY",
    "dropmalzpp": 105129998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452254372,
    "dropsitcph": 8452254372,
    "dropfax": 8452252347
  },
  {
    "dcode": "D",
    "dropkey": "PV12435",
    "droptype": "D",
    "dropname": "CAROGA LAKE",
    "dropdeladd": "2089 STATE HIGHWAY 10",
    "dropdelcty": "CAROGA LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 120329998,
    "dropphyadd": "2089 STATE HIGHWAY 10",
    "dropphycty": "CAROGA LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 120329998,
    "dropmaladd": "2089 STATE HIGHWAY 10",
    "dropmalcty": "CAROGA LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 120329998,
    "dropsitphn": 5188354326,
    "dropsitlph": 5188354326,
    "dropsitcph": 5188354326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12441",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "521 STATE ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "NY",
    "dropdelzpp": 136199998,
    "dropphyadd": "521 STATE ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "NY",
    "dropphyzpp": 136199998,
    "dropmaladd": "521 STATE ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "NY",
    "dropmalzpp": 136199998,
    "dropsitphn": 3154933600,
    "dropsitlph": 3154933600,
    "dropsitcph": 3154933600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12443",
    "droptype": "D",
    "dropname": "CASSADAGA",
    "dropdeladd": "15 MAPLE AVE",
    "dropdelcty": "CASSADAGA",
    "dropdelst": "NY",
    "dropdelzpp": 147189800,
    "dropphyadd": "15 MAPLE AVE",
    "dropphycty": "CASSADAGA",
    "dropphyst": "NY",
    "dropphyzpp": 147189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASSADAGA",
    "dropmalst": "NY",
    "dropmalzpp": 147189998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854572880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12444",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "1685 MAIN ST",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133189998,
    "dropphyadd": "1685 MAIN ST",
    "dropphycty": "CASSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133189998,
    "dropmaladd": "1685 MAIN ST",
    "dropmalcty": "CASSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133189998,
    "dropsitphn": 5188395060,
    "dropsitlph": 5188395060,
    "dropsitcph": 3158395060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12445",
    "droptype": "D",
    "dropname": "CASTILE",
    "dropdeladd": "30 N MAIN ST",
    "dropdelcty": "CASTILE",
    "dropdelst": "NY",
    "dropdelzpp": 144279998,
    "dropphyadd": "30 N MAIN ST",
    "dropphycty": "CASTILE",
    "dropphyst": "NY",
    "dropphyzpp": 144279998,
    "dropmaladd": "30 N MAIN ST",
    "dropmalcty": "CASTILE",
    "dropmalst": "NY",
    "dropmalzpp": 144279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854932560,
    "dropsitcph": 5854932560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12447",
    "droptype": "D",
    "dropname": "CASTLE CREEK",
    "dropdeladd": "1094 CASTLE CREEK RD",
    "dropdelcty": "CASTLE CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 137449998,
    "dropphyadd": "1094 CASTLE CREEK RD",
    "dropphycty": "CASTLE CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 137449998,
    "dropmaladd": "1094 CASTLE CREEK RD",
    "dropmalcty": "CASTLE CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 137449998,
    "dropsitphn": 6076486954,
    "dropsitlph": 6076486954,
    "dropsitcph": 6076486954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12451",
    "droptype": "D",
    "dropname": "CASTLE POINT",
    "dropdeladd": "15 NURSING HOME RD RM 24",
    "dropdelcty": "CASTLE POINT",
    "dropdelst": "NY",
    "dropdelzpp": 125119800,
    "dropphyadd": "15 NURSING HOME RD RM 24",
    "dropphycty": "CASTLE POINT",
    "dropphyst": "NY",
    "dropphyzpp": 125119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTLE POINT",
    "dropmalst": "NY",
    "dropmalzpp": 125119998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458312000,
    "dropsitcph": 8458312000,
    "dropfax": 8458385180
  },
  {
    "dcode": "D",
    "dropkey": "PV12455",
    "droptype": "D",
    "dropname": "CASTLETON ON HUDSON",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "CASTLETON ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 120339998,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "CASTLETON ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 120339998,
    "dropmaladd": "108 S MAIN ST",
    "dropmalcty": "CASTLETON ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 120339998,
    "dropsitphn": 5187322132,
    "dropsitlph": 5187322132,
    "dropsitcph": 5187322132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12456",
    "droptype": "D",
    "dropname": "CASTORLAND",
    "dropdeladd": "5158 STATE ROUTE 410",
    "dropdelcty": "CASTORLAND",
    "dropdelst": "NY",
    "dropdelzpp": 136209998,
    "dropphyadd": "5158 STATE ROUTE 410",
    "dropphycty": "CASTORLAND",
    "dropphyst": "NY",
    "dropphyzpp": 136209998,
    "dropmaladd": "5158 STATE ROUTE 410",
    "dropmalcty": "CASTORLAND",
    "dropmalst": "NY",
    "dropmalzpp": 136209998,
    "dropsitphn": 3153760371,
    "dropsitlph": 3153760371,
    "dropsitcph": 3153760371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12462",
    "droptype": "D",
    "dropname": "CATO",
    "dropdeladd": "2544 E MAIN ST",
    "dropdelcty": "CATO",
    "dropdelst": "NY",
    "dropdelzpp": 130339998,
    "dropphyadd": "2544 E MAIN ST",
    "dropphycty": "CATO",
    "dropphyst": "NY",
    "dropphyzpp": 130339998,
    "dropmaladd": "2544 E MAIN ST",
    "dropmalcty": "CATO",
    "dropmalst": "NY",
    "dropmalzpp": 130339998,
    "dropsitphn": 3156262311,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156262311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12463",
    "droptype": "D",
    "dropname": "CATSKILL",
    "dropdeladd": "270 MAIN ST",
    "dropdelcty": "CATSKILL",
    "dropdelst": "NY",
    "dropdelzpp": 124149998,
    "dropphyadd": "270 MAIN ST",
    "dropphycty": "CATSKILL",
    "dropphyst": "NY",
    "dropphyzpp": 124149998,
    "dropmaladd": "270 MAIN ST",
    "dropmalcty": "CATSKILL",
    "dropmalst": "NY",
    "dropmalzpp": 124149998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5189437417,
    "dropsitcph": 5189437417,
    "dropfax": 5189433227
  },
  {
    "dcode": "D",
    "dropkey": "PV12464",
    "droptype": "D",
    "dropname": "CATTARAUGUS",
    "dropdeladd": "8 MEMORIAL DR",
    "dropdelcty": "CATTARAUGUS",
    "dropdelst": "NY",
    "dropdelzpp": 147199998,
    "dropphyadd": "8 MEMORIAL DR",
    "dropphycty": "CATTARAUGUS",
    "dropphyst": "NY",
    "dropphyzpp": 147199998,
    "dropmaladd": "8 MEMORIAL DR",
    "dropmalcty": "CATTARAUGUS",
    "dropmalst": "NY",
    "dropmalzpp": 147199998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162573911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12467",
    "droptype": "D",
    "dropname": "CAYUGA",
    "dropdeladd": "6198 CENTER ST",
    "dropdelcty": "CAYUGA",
    "dropdelst": "NY",
    "dropdelzpp": 130349998,
    "dropphyadd": "6198 CENTER ST",
    "dropphycty": "CAYUGA",
    "dropphyst": "NY",
    "dropphyzpp": 130349998,
    "dropmaladd": "6198 CENTER ST",
    "dropmalcty": "CAYUGA",
    "dropmalst": "NY",
    "dropmalzpp": 130349998,
    "dropsitphn": 3152536957,
    "dropsitlph": 5184522299,
    "dropsitcph": 3152536957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12468",
    "droptype": "D",
    "dropname": "CAYUTA",
    "dropdeladd": "6338 STATE ROUTE 224",
    "dropdelcty": "CAYUTA",
    "dropdelst": "NY",
    "dropdelzpp": 148249998,
    "dropphyadd": "6338 STATE ROUTE 224",
    "dropphycty": "CAYUTA",
    "dropphyst": "NY",
    "dropphyzpp": 148249998,
    "dropmaladd": "6338 STATE ROUTE 224",
    "dropmalcty": "CAYUTA",
    "dropmalst": "NY",
    "dropmalzpp": 148249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075942178,
    "dropsitcph": 6075942178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12470",
    "droptype": "D",
    "dropname": "CAZENOVIA",
    "dropdeladd": "24 LINCKLAEN ST",
    "dropdelcty": "CAZENOVIA",
    "dropdelst": "NY",
    "dropdelzpp": 130359998,
    "dropphyadd": "24 LINCKLAEN ST",
    "dropphycty": "CAZENOVIA",
    "dropphyst": "NY",
    "dropphyzpp": 130359998,
    "dropmaladd": "24 LINCKLAEN ST",
    "dropmalcty": "CAZENOVIA",
    "dropmalst": "NY",
    "dropmalzpp": 130359998,
    "dropsitphn": 3156553133,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156553133,
    "dropfax": 3156554584
  },
  {
    "dcode": "D",
    "dropkey": "PV12472",
    "droptype": "D",
    "dropname": "CEDARHURST",
    "dropdeladd": "124 GROVE AVE",
    "dropdelcty": "CEDARHURST",
    "dropdelst": "NY",
    "dropdelzpp": 115162328,
    "dropphyadd": "124 GROVE AVE",
    "dropphycty": "CEDARHURST",
    "dropphyst": "NY",
    "dropphyzpp": 115162328,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDARHURST",
    "dropmalst": "NY",
    "dropmalzpp": 115169998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162951452,
    "dropfax": 5163742095
  },
  {
    "dcode": "D",
    "dropkey": "PV12475",
    "droptype": "D",
    "dropname": "CELORON",
    "dropdeladd": "17 BOULEVARD AVE",
    "dropdelcty": "CELORON",
    "dropdelst": "NY",
    "dropdelzpp": 147209800,
    "dropphyadd": "17 BOULEVARD AVE",
    "dropphycty": "CELORON",
    "dropphyst": "NY",
    "dropphyzpp": 147209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CELORON",
    "dropmalst": "NY",
    "dropmalzpp": 147209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164889035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12480",
    "droptype": "D",
    "dropname": "CENTER MORICHES",
    "dropdeladd": "35 RAILROAD AVE",
    "dropdelcty": "CENTER MORICHES",
    "dropdelst": "NY",
    "dropdelzpp": 119342417,
    "dropphyadd": "35 RAILROAD AVE",
    "dropphycty": "CENTER MORICHES",
    "dropphyst": "NY",
    "dropphyzpp": 119342417,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER MORICHES",
    "dropmalst": "NY",
    "dropmalzpp": 119349998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6318780953,
    "dropfax": 6318786913
  },
  {
    "dcode": "D",
    "dropkey": "PV12482",
    "droptype": "D",
    "dropname": "CENTEREACH",
    "dropdeladd": "245 CENTEREACH MALL",
    "dropdelcty": "CENTEREACH",
    "dropdelst": "NY",
    "dropdelzpp": 117202716,
    "dropphyadd": "245 CENTEREACH MALL",
    "dropphycty": "CENTEREACH",
    "dropphyst": "NY",
    "dropphyzpp": 117202716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTEREACH",
    "dropmalst": "NY",
    "dropmalzpp": 117209998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315887069,
    "dropfax": 6319813784
  },
  {
    "dcode": "D",
    "dropkey": "PV12484",
    "droptype": "D",
    "dropname": "CENTERPORT",
    "dropdeladd": "434 E MAIN ST",
    "dropdelcty": "CENTERPORT",
    "dropdelst": "NY",
    "dropdelzpp": 117211517,
    "dropphyadd": "434 E MAIN ST",
    "dropphycty": "CENTERPORT",
    "dropphyst": "NY",
    "dropphyzpp": 117211517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERPORT",
    "dropmalst": "NY",
    "dropmalzpp": 117219998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312616918,
    "dropfax": 6317576784
  },
  {
    "dcode": "D",
    "dropkey": "PV12485",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "10985B RUSHFORD RD",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140299800,
    "dropphyadd": "10985B RUSHFORD RD",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140299998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855672566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12491",
    "droptype": "D",
    "dropname": "CENTRAL BRIDGE",
    "dropdeladd": "126 S MAIN ST STE 1",
    "dropdelcty": "CENTRAL BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 120359900,
    "dropphyadd": "126 S MAIN ST STE 1",
    "dropphycty": "CENTRAL BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 120359900,
    "dropmaladd": "126 S MAIN ST STE 1",
    "dropmalcty": "CENTRAL BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 120359900,
    "dropsitphn": 5188684531,
    "dropsitlph": 5188684531,
    "dropsitcph": 5188684531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12492",
    "droptype": "D",
    "dropname": "CENTRAL ISLIP",
    "dropdeladd": "110 E SUFFOLK AVE",
    "dropdelcty": "CENTRAL ISLIP",
    "dropdelst": "NY",
    "dropdelzpp": 117222430,
    "dropphyadd": "110 E SUFFOLK AVE",
    "dropphycty": "CENTRAL ISLIP",
    "dropphyst": "NY",
    "dropphyzpp": 117222430,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL ISLIP",
    "dropmalst": "NY",
    "dropmalzpp": 117229998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312340547,
    "dropfax": 6312347429
  },
  {
    "dcode": "D",
    "dropkey": "PV12499",
    "droptype": "D",
    "dropname": "CENTRAL SQUARE",
    "dropdeladd": "555 S MAIN ST",
    "dropdelcty": "CENTRAL SQUARE",
    "dropdelst": "NY",
    "dropdelzpp": 130369998,
    "dropphyadd": "555 S MAIN ST",
    "dropphycty": "CENTRAL SQUARE",
    "dropphyst": "NY",
    "dropphyzpp": 130369998,
    "dropmaladd": "555 S MAIN ST",
    "dropmalcty": "CENTRAL SQUARE",
    "dropmalst": "NY",
    "dropmalzpp": 130369998,
    "dropsitphn": 3156686711,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156686711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12500",
    "droptype": "D",
    "dropname": "CENTRAL VALLEY",
    "dropdeladd": "28 SMITH CLOVE RD",
    "dropdelcty": "CENTRAL VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 109179998,
    "dropphyadd": "28 SMITH CLOVE RD",
    "dropphycty": "CENTRAL VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 109179998,
    "dropmaladd": "28 SMITH CLOVE RD",
    "dropmalcty": "CENTRAL VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 109179998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459286016,
    "dropsitcph": 8459286016,
    "dropfax": 8459287405
  },
  {
    "dcode": "D",
    "dropkey": "PV12505",
    "droptype": "D",
    "dropname": "CERES",
    "dropdeladd": "227 MAIN ST",
    "dropdelcty": "CERES",
    "dropdelst": "NY",
    "dropdelzpp": 147219800,
    "dropphyadd": "227 MAIN ST",
    "dropphycty": "CERES",
    "dropphyst": "NY",
    "dropphyzpp": 147219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CERES",
    "dropmalst": "NY",
    "dropmalzpp": 147219998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859338093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12506",
    "droptype": "D",
    "dropname": "CHADWICKS",
    "dropdeladd": "3367 ONEIDA ST",
    "dropdelcty": "CHADWICKS",
    "dropdelst": "NY",
    "dropdelzpp": 133199998,
    "dropphyadd": "3367 ONEIDA ST",
    "dropphycty": "CHADWICKS",
    "dropphyst": "NY",
    "dropphyzpp": 133199998,
    "dropmaladd": "3367 ONEIDA ST",
    "dropmalcty": "CHADWICKS",
    "dropmalst": "NY",
    "dropmalzpp": 133199998,
    "dropsitphn": 3157378369,
    "dropsitlph": 3157378369,
    "dropsitcph": 3157378369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12507",
    "droptype": "D",
    "dropname": "CHAFFEE",
    "dropdeladd": "11439 OLEAN RD",
    "dropdelcty": "CHAFFEE",
    "dropdelst": "NY",
    "dropdelzpp": 140309998,
    "dropphyadd": "11439 OLEAN RD",
    "dropphycty": "CHAFFEE",
    "dropphyst": "NY",
    "dropphyzpp": 140309998,
    "dropmaladd": "11439 OLEAN RD",
    "dropmalcty": "CHAFFEE",
    "dropmalst": "NY",
    "dropmalzpp": 140309998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164967322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12510",
    "droptype": "D",
    "dropname": "CHAMPLAIN",
    "dropdeladd": "880 STATE ROUTE 11",
    "dropdelcty": "CHAMPLAIN",
    "dropdelst": "NY",
    "dropdelzpp": 129199998,
    "dropphyadd": "880 STATE ROUTE 11",
    "dropphycty": "CHAMPLAIN",
    "dropphyst": "NY",
    "dropphyzpp": 129199998,
    "dropmaladd": "880 STATE ROUTE 11",
    "dropmalcty": "CHAMPLAIN",
    "dropmalst": "NY",
    "dropmalzpp": 129199998,
    "dropsitphn": 5182983341,
    "dropsitlph": 5182983341,
    "dropsitcph": 5182983341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12512",
    "droptype": "D",
    "dropname": "CHAPPAQUA",
    "dropdeladd": "107 N GREELEY AVE",
    "dropdelcty": "CHAPPAQUA",
    "dropdelst": "NY",
    "dropdelzpp": 105149998,
    "dropphyadd": "107 N GREELEY AVE",
    "dropphycty": "CHAPPAQUA",
    "dropphyst": "NY",
    "dropphyzpp": 105149998,
    "dropmaladd": "107 N GREELEY AVE",
    "dropmalcty": "CHAPPAQUA",
    "dropmalst": "NY",
    "dropmalzpp": 105149998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142387592,
    "dropsitcph": 9142387592,
    "dropfax": 9142385637
  },
  {
    "dcode": "D",
    "dropkey": "PV12516",
    "droptype": "D",
    "dropname": "CHARLOTTEVILLE",
    "dropdeladd": "632 CHARLOTTE VALLEY RD",
    "dropdelcty": "CHARLOTTEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120369998,
    "dropphyadd": "632 CHARLOTTE VALLEY RD",
    "dropphycty": "CHARLOTTEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120369998,
    "dropmaladd": "632 CHARLOTTE VALLEY RD",
    "dropmalcty": "CHARLOTTEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120369998,
    "dropsitphn": 6073978177,
    "dropsitlph": 6073978177,
    "dropsitcph": 6073978177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12525",
    "droptype": "D",
    "dropname": "CHASE MILLS",
    "dropdeladd": "5275 COUNTY ROUTE 14",
    "dropdelcty": "CHASE MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 136219998,
    "dropphyadd": "5275 COUNTY ROUTE 14",
    "dropphycty": "CHASE MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 136219998,
    "dropmaladd": "5275 COUNTY ROUTE 14",
    "dropmalcty": "CHASE MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 136219998,
    "dropsitphn": 3153225573,
    "dropsitlph": 3153225573,
    "dropsitcph": 3153225573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12530",
    "droptype": "D",
    "dropname": "CHATEAUGAY",
    "dropdeladd": "19 RIVER ST",
    "dropdelcty": "CHATEAUGAY",
    "dropdelst": "NY",
    "dropdelzpp": 129209998,
    "dropphyadd": "19 RIVER ST",
    "dropphycty": "CHATEAUGAY",
    "dropphyst": "NY",
    "dropphyzpp": 129209998,
    "dropmaladd": "19 RIVER ST",
    "dropmalcty": "CHATEAUGAY",
    "dropmalst": "NY",
    "dropmalzpp": 129209998,
    "dropsitphn": 5184976012,
    "dropsitlph": 5184976012,
    "dropsitcph": 5184976012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12531",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "35 RAILROAD AVE",
    "dropdelcty": "CHATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 120379998,
    "dropphyadd": "35 RAILROAD AVE",
    "dropphycty": "CHATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 120379998,
    "dropmaladd": "35 RAILROAD AVE",
    "dropmalcty": "CHATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 120379998,
    "dropsitphn": 5183923961,
    "dropsitlph": 5183923961,
    "dropsitcph": 5183923961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12534",
    "droptype": "D",
    "dropname": "CHAUMONT",
    "dropdeladd": "12061 STATE ROUTE 12E",
    "dropdelcty": "CHAUMONT",
    "dropdelst": "NY",
    "dropdelzpp": 136229998,
    "dropphyadd": "12061 STATE ROUTE 12E",
    "dropphycty": "CHAUMONT",
    "dropphyst": "NY",
    "dropphyzpp": 136229998,
    "dropmaladd": "12061 STATE ROUTE 12E",
    "dropmalcty": "CHAUMONT",
    "dropmalst": "NY",
    "dropmalzpp": 136229998,
    "dropsitphn": 3156495225,
    "dropsitlph": 3156495225,
    "dropsitcph": 3156495225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12536",
    "droptype": "D",
    "dropname": "CHAUTAUQUA",
    "dropdeladd": "10-12 ROBERTS ST",
    "dropdelcty": "CHAUTAUQUA",
    "dropdelst": "NY",
    "dropdelzpp": 147229800,
    "dropphyadd": "10-12 ROBERTS ST",
    "dropphycty": "CHAUTAUQUA",
    "dropphyst": "NY",
    "dropphyzpp": 147229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAUTAUQUA",
    "dropmalst": "NY",
    "dropmalzpp": 147229998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163573275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12537",
    "droptype": "D",
    "dropname": "CHAZY",
    "dropdeladd": "9578 STATE ROUTE 9",
    "dropdelcty": "CHAZY",
    "dropdelst": "NY",
    "dropdelzpp": 129219998,
    "dropphyadd": "9578 STATE ROUTE 9",
    "dropphycty": "CHAZY",
    "dropphyst": "NY",
    "dropphyzpp": 129219998,
    "dropmaladd": "9578 STATE ROUTE 9",
    "dropmalcty": "CHAZY",
    "dropmalst": "NY",
    "dropmalzpp": 129219998,
    "dropsitphn": 5189573408,
    "dropsitlph": 5189573408,
    "dropsitcph": 5189573408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12543",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "17 LIBERTY ST",
    "dropdelcty": "CHELSEA",
    "dropdelst": "NY",
    "dropdelzpp": 125129800,
    "dropphyadd": "17 LIBERTY ST",
    "dropphycty": "CHELSEA",
    "dropphyst": "NY",
    "dropphyzpp": 125129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHELSEA",
    "dropmalst": "NY",
    "dropmalzpp": 125129998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458317580,
    "dropsitcph": 8458317580,
    "dropfax": 8458317580
  },
  {
    "dcode": "D",
    "dropkey": "PV12548",
    "droptype": "D",
    "dropname": "CHEMUNG",
    "dropdeladd": "733 MAIN ST",
    "dropdelcty": "CHEMUNG",
    "dropdelst": "NY",
    "dropdelzpp": 148259998,
    "dropphyadd": "733 MAIN ST",
    "dropphycty": "CHEMUNG",
    "dropphyst": "NY",
    "dropphyzpp": 148259998,
    "dropmaladd": "733 MAIN ST",
    "dropmalcty": "CHEMUNG",
    "dropmalst": "NY",
    "dropmalzpp": 148259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075293526,
    "dropsitcph": 6075293526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12552",
    "droptype": "D",
    "dropname": "CHENANGO BRIDGE",
    "dropdeladd": "511 MAIN ST",
    "dropdelcty": "CHENANGO BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 137459998,
    "dropphyadd": "511 MAIN ST",
    "dropphycty": "CHENANGO BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 137459998,
    "dropmaladd": "511 MAIN ST",
    "dropmalcty": "CHENANGO BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 137459998,
    "dropsitphn": 6076488300,
    "dropsitlph": 6076488300,
    "dropsitcph": 6076488300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12554",
    "droptype": "D",
    "dropname": "CHENANGO FORKS",
    "dropdeladd": "6554 STATE ROUTE 79",
    "dropdelcty": "CHENANGO FORKS",
    "dropdelst": "NY",
    "dropdelzpp": 137469998,
    "dropphyadd": "6554 STATE ROUTE 79",
    "dropphycty": "CHENANGO FORKS",
    "dropphyst": "NY",
    "dropphyzpp": 137469998,
    "dropmaladd": "6554 STATE ROUTE 79",
    "dropmalcty": "CHENANGO FORKS",
    "dropmalst": "NY",
    "dropmalzpp": 137469998,
    "dropsitphn": 6076489500,
    "dropsitlph": 6076489500,
    "dropsitcph": 6076489500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12559",
    "droptype": "D",
    "dropname": "CHERRY CREEK",
    "dropdeladd": "6746 MAIN ST",
    "dropdelcty": "CHERRY CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 147239899,
    "dropphyadd": "6746 MAIN ST",
    "dropphycty": "CHERRY CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 147239899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHERRY CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 147239998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162965204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12562",
    "droptype": "D",
    "dropname": "CHERRY PLAIN",
    "dropdeladd": "65 CHERRY PLAIN SQ",
    "dropdelcty": "CHERRY PLAIN",
    "dropdelst": "NY",
    "dropdelzpp": 120409998,
    "dropphyadd": "65 CHERRY PLAIN SQ",
    "dropphycty": "CHERRY PLAIN",
    "dropphyst": "NY",
    "dropphyzpp": 120409998,
    "dropmaladd": "65 CHERRY PLAIN SQ",
    "dropmalcty": "CHERRY PLAIN",
    "dropmalst": "NY",
    "dropmalzpp": 120409998,
    "dropsitphn": 5186582503,
    "dropsitlph": 5186582503,
    "dropsitcph": 5186582503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12563",
    "droptype": "D",
    "dropname": "CHERRY VALLEY",
    "dropdeladd": "2 GENESEE ST",
    "dropdelcty": "CHERRY VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 133209998,
    "dropphyadd": "2 GENESEE ST",
    "dropphycty": "CHERRY VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 133209998,
    "dropmaladd": "2 GENESEE ST",
    "dropmalcty": "CHERRY VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 133209998,
    "dropsitphn": 6072643031,
    "dropsitlph": 6072643031,
    "dropsitcph": 6072643031,
    "dropfax": 6076385140
  },
  {
    "dcode": "D",
    "dropkey": "PV12566",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "76 BROOKSIDE AVE",
    "dropdelcty": "CHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 109189998,
    "dropphyadd": "76 BROOKSIDE AVE",
    "dropphycty": "CHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 109189998,
    "dropmaladd": "76 BROOKSIDE AVE",
    "dropmalcty": "CHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 109189998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454692106,
    "dropsitcph": 8454692106,
    "dropfax": 8454695248
  },
  {
    "dcode": "D",
    "dropkey": "PV12567",
    "droptype": "D",
    "dropname": "CHESTERTOWN",
    "dropdeladd": "6323 STATE ROUTE 9",
    "dropdelcty": "CHESTERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 128179998,
    "dropphyadd": "6323 STATE ROUTE 9",
    "dropphycty": "CHESTERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 128179998,
    "dropmaladd": "6323 STATE ROUTE 9",
    "dropmalcty": "CHESTERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 128179998,
    "dropsitphn": 5182190129,
    "dropsitlph": 5182190129,
    "dropsitcph": 5182190129,
    "dropfax": 5182190129
  },
  {
    "dcode": "D",
    "dropkey": "PV12571",
    "droptype": "D",
    "dropname": "CHICHESTER",
    "dropdeladd": "536 STATE ROUTE 214",
    "dropdelcty": "CHICHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 124169998,
    "dropphyadd": "536 STATE ROUTE 214",
    "dropphycty": "CHICHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 124169998,
    "dropmaladd": "536 STATE ROUTE 214",
    "dropmalcty": "CHICHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 124169998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456887300,
    "dropsitcph": 8456887300,
    "dropfax": 8456887300
  },
  {
    "dcode": "D",
    "dropkey": "PV12579",
    "droptype": "D",
    "dropname": "CHIPPEWA BAY",
    "dropdeladd": "1176 COUNTY ROUTE 6",
    "dropdelcty": "CHIPPEWA BAY",
    "dropdelst": "NY",
    "dropdelzpp": 136239998,
    "dropphyadd": "1176 COUNTY ROUTE 6",
    "dropphycty": "CHIPPEWA BAY",
    "dropphyst": "NY",
    "dropphyzpp": 136239998,
    "dropmaladd": "1176 COUNTY ROUTE 6",
    "dropmalcty": "CHIPPEWA BAY",
    "dropmalst": "NY",
    "dropmalzpp": 136239998,
    "dropsitphn": 3153245550,
    "dropsitlph": 3153245550,
    "dropsitcph": 3153245550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12581",
    "droptype": "D",
    "dropname": "CHITTENANGO",
    "dropdeladd": "1001 E GENESEE ST STE 1",
    "dropdelcty": "CHITTENANGO",
    "dropdelst": "NY",
    "dropdelzpp": 130379998,
    "dropphyadd": "1001 E GENESEE ST STE 1",
    "dropphycty": "CHITTENANGO",
    "dropphyst": "NY",
    "dropphyzpp": 130379998,
    "dropmaladd": "1001 E GENESEE ST STE 1",
    "dropmalcty": "CHITTENANGO",
    "dropmalst": "NY",
    "dropmalzpp": 130379998,
    "dropsitphn": 3156879412,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156879412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12589",
    "droptype": "D",
    "dropname": "CHURCHVILLE",
    "dropdeladd": "42G S MAIN ST",
    "dropdelcty": "CHURCHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 144289998,
    "dropphyadd": "42G S MAIN ST",
    "dropphycty": "CHURCHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 144289998,
    "dropmaladd": "42G S MAIN ST",
    "dropmalcty": "CHURCHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 144289998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852933600,
    "dropsitcph": 5852933600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12591",
    "droptype": "D",
    "dropname": "CHURUBUSCO",
    "dropdeladd": "1306 CLINTON MILLS RD",
    "dropdelcty": "CHURUBUSCO",
    "dropdelst": "NY",
    "dropdelzpp": 129239998,
    "dropphyadd": "1306 CLINTON MILLS RD",
    "dropphycty": "CHURUBUSCO",
    "dropphyst": "NY",
    "dropphyzpp": 129239998,
    "dropmaladd": "1306 CLINTON MILLS RD",
    "dropmalcty": "CHURUBUSCO",
    "dropmalst": "NY",
    "dropmalzpp": 129239998,
    "dropsitphn": 5184976717,
    "dropsitlph": 5184976717,
    "dropsitcph": 5184976717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12593",
    "droptype": "D",
    "dropname": "CINCINNATUS",
    "dropdeladd": "2763 LOWER CINCINNATUS RD",
    "dropdelcty": "CINCINNATUS",
    "dropdelst": "NY",
    "dropdelzpp": 130409998,
    "dropphyadd": "2763 LOWER CINCINNATUS RD",
    "dropphycty": "CINCINNATUS",
    "dropphyst": "NY",
    "dropphyzpp": 130409998,
    "dropmaladd": "2763 LOWER CINCINNATUS RD",
    "dropmalcty": "CINCINNATUS",
    "dropmalst": "NY",
    "dropmalzpp": 130409998,
    "dropsitphn": 6072891004,
    "dropsitlph": 5184522299,
    "dropsitcph": 6072891004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12594",
    "droptype": "D",
    "dropname": "CIRCLEVILLE",
    "dropdeladd": "2079 ROUTE 302",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109199998,
    "dropphyadd": "2079 ROUTE 302",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109199998,
    "dropmaladd": "2079 ROUTE 302",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109199998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8453613966,
    "dropfax": 8453615836
  },
  {
    "dcode": "D",
    "dropkey": "PV12604",
    "droptype": "D",
    "dropname": "CLARENCE",
    "dropdeladd": "9845 MAIN ST",
    "dropdelcty": "CLARENCE",
    "dropdelst": "NY",
    "dropdelzpp": 140319998,
    "dropphyadd": "9845 MAIN ST",
    "dropphycty": "CLARENCE",
    "dropphyst": "NY",
    "dropphyzpp": 140319998,
    "dropmaladd": "9845 MAIN ST",
    "dropmalcty": "CLARENCE",
    "dropmalst": "NY",
    "dropmalzpp": 140319998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167591243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12605",
    "droptype": "D",
    "dropname": "CLARENCE CENTER",
    "dropdeladd": "6045 RAILROAD ST",
    "dropdelcty": "CLARENCE CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 140329998,
    "dropphyadd": "6045 RAILROAD ST",
    "dropphycty": "CLARENCE CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 140329998,
    "dropmaladd": "6045 RAILROAD ST",
    "dropmalcty": "CLARENCE CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 140329998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167412870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12607",
    "droptype": "D",
    "dropname": "CLARENDON",
    "dropdeladd": "4540 HOLLEY BYRON RD",
    "dropdelcty": "CLARENDON",
    "dropdelst": "NY",
    "dropdelzpp": 144299800,
    "dropphyadd": "4540 HOLLEY BYRON RD",
    "dropphycty": "CLARENDON",
    "dropphyst": "NY",
    "dropphyzpp": 144299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARENDON",
    "dropmalst": "NY",
    "dropmalzpp": 144299998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856386420,
    "dropsitcph": 5856386420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12608",
    "droptype": "D",
    "dropname": "CLARK MILLS",
    "dropdeladd": "4814 CLINTON ST",
    "dropdelcty": "CLARK MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 133219998,
    "dropphyadd": "4814 CLINTON ST",
    "dropphycty": "CLARK MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 133219998,
    "dropmaladd": "4814 CLINTON ST",
    "dropmalcty": "CLARK MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 133219998,
    "dropsitphn": 3158538945,
    "dropsitlph": 3158538945,
    "dropsitcph": 3158538945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12610",
    "droptype": "D",
    "dropname": "CLARKSON",
    "dropdeladd": "3720 LAKE RD",
    "dropdelcty": "CLARKSON",
    "dropdelst": "NY",
    "dropdelzpp": 144309800,
    "dropphyadd": "3720 LAKE RD",
    "dropphycty": "CLARKSON",
    "dropphyst": "NY",
    "dropphyzpp": 144309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSON",
    "dropmalst": "NY",
    "dropmalzpp": 144309998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856376726,
    "dropsitcph": 5856376726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12613",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "1967 DELAWARE TPKE",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120411223,
    "dropphyadd": "1967 DELAWARE TPKE",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120411223,
    "dropmaladd": "1967 DELAWARE TPKE",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120419998,
    "dropsitphn": 5187682991,
    "dropsitlph": 5187682991,
    "dropsitcph": 5187682991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12615",
    "droptype": "D",
    "dropname": "CLARYVILLE",
    "dropdeladd": "1471 DENNING RD",
    "dropdelcty": "CLARYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127259998,
    "dropphyadd": "1471 DENNING RD",
    "dropphycty": "CLARYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127259998,
    "dropmaladd": "1471 DENNING RD",
    "dropmalcty": "CLARYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127259998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459852409,
    "dropsitcph": 8459852409,
    "dropfax": 8459850334
  },
  {
    "dcode": "D",
    "dropkey": "PV12618",
    "droptype": "D",
    "dropname": "CLAVERACK",
    "dropdeladd": "4 PARK PLACE ST",
    "dropdelcty": "CLAVERACK",
    "dropdelst": "NY",
    "dropdelzpp": 125139998,
    "dropphyadd": "4 PARK PLACE ST",
    "dropphycty": "CLAVERACK",
    "dropphyst": "NY",
    "dropphyzpp": 125139998,
    "dropmaladd": "4 PARK PLACE ST",
    "dropmalcty": "CLAVERACK",
    "dropmalst": "NY",
    "dropmalzpp": 125139998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5188519537,
    "dropsitcph": 5188519537,
    "dropfax": 5188512538
  },
  {
    "dcode": "D",
    "dropkey": "PV12619",
    "droptype": "D",
    "dropname": "CLAY",
    "dropdeladd": "5601 STATE ROUTE 31",
    "dropdelcty": "CLAY",
    "dropdelst": "NY",
    "dropdelzpp": 130419998,
    "dropphyadd": "5601 STATE ROUTE 31",
    "dropphycty": "CLAY",
    "dropphyst": "NY",
    "dropphyzpp": 130419998,
    "dropmaladd": "5601 STATE ROUTE 31",
    "dropmalcty": "CLAY",
    "dropmalst": "NY",
    "dropmalzpp": 130419998,
    "dropsitphn": 3156995721,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156995721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12620",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "236 JOHN ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "NY",
    "dropdelzpp": 136249998,
    "dropphyadd": "236 JOHN ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "NY",
    "dropphyzpp": 136249998,
    "dropmaladd": "236 JOHN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 136249998,
    "dropsitphn": 3156863311,
    "dropsitlph": 3156863311,
    "dropsitcph": 3156863311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12621",
    "droptype": "D",
    "dropname": "CLAYVILLE",
    "dropdeladd": "2370 MAIN ST",
    "dropdelcty": "CLAYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133229998,
    "dropphyadd": "2370 MAIN ST",
    "dropphycty": "CLAYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133229998,
    "dropmaladd": "2370 MAIN ST",
    "dropmalcty": "CLAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133229998,
    "dropsitphn": 3158395822,
    "dropsitlph": 3158395822,
    "dropsitcph": 3158395822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12625",
    "droptype": "D",
    "dropname": "CLEMONS",
    "dropdeladd": "14007 STATE ROUTE 22",
    "dropdelcty": "CLEMONS",
    "dropdelst": "NY",
    "dropdelzpp": 128192301,
    "dropphyadd": "14007 STATE ROUTE 22",
    "dropphycty": "CLEMONS",
    "dropphyst": "NY",
    "dropphyzpp": 128192301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEMONS",
    "dropmalst": "NY",
    "dropmalzpp": 128199998,
    "dropsitphn": 5184990040,
    "dropsitlph": 5184990040,
    "dropsitcph": 5184990040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12628",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "100 STATE ROUTE 49",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "NY",
    "dropdelzpp": 130429998,
    "dropphyadd": "100 STATE ROUTE 49",
    "dropphycty": "CLEVELAND",
    "dropphyst": "NY",
    "dropphyzpp": 130429998,
    "dropmaladd": "100 STATE ROUTE 49",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "NY",
    "dropmalzpp": 130429998,
    "dropsitphn": 3156758364,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156758364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12631",
    "droptype": "D",
    "dropname": "CLEVERDALE",
    "dropdeladd": "2663 STATE ROUTE 9L",
    "dropdelcty": "CLEVERDALE",
    "dropdelst": "NY",
    "dropdelzpp": 128209900,
    "dropphyadd": "2663 STATE ROUTE 9L",
    "dropphycty": "CLEVERDALE",
    "dropphyst": "NY",
    "dropphyzpp": 128209900,
    "dropmaladd": "2663 STATE ROUTE 9L",
    "dropmalcty": "CLEVERDALE",
    "dropmalst": "NY",
    "dropmalzpp": 128209900,
    "dropsitphn": 5186569059,
    "dropsitlph": 5186569059,
    "dropsitcph": 5186569059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12634",
    "droptype": "D",
    "dropname": "CLIFTON PARK",
    "dropdeladd": "1764 ROUTE 9",
    "dropdelcty": "HALFMOON",
    "dropdelst": "NY",
    "dropdelzpp": 120659998,
    "dropphyadd": "1764 ROUTE 9",
    "dropphycty": "HALFMOON",
    "dropphyst": "NY",
    "dropphyzpp": 120659998,
    "dropmaladd": "1764 ROUTE 9",
    "dropmalcty": "HALFMOON",
    "dropmalst": "NY",
    "dropmalzpp": 120659998,
    "dropsitphn": 5183715460,
    "dropsitlph": 5183715600,
    "dropsitcph": 5183715600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12637",
    "droptype": "D",
    "dropname": "CLIFTON SPRINGS",
    "dropdeladd": "3 SPRING ST",
    "dropdelcty": "CLIFTON SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 144329998,
    "dropphyadd": "3 SPRING ST",
    "dropphycty": "CLIFTON SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 144329998,
    "dropmaladd": "3 SPRING ST",
    "dropmalcty": "CLIFTON SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 144329998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3154627513,
    "dropsitcph": 3154627513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12638",
    "droptype": "D",
    "dropname": "CLIMAX",
    "dropdeladd": "58 COUNTY ROUTE 26",
    "dropdelcty": "CLIMAX",
    "dropdelst": "NY",
    "dropdelzpp": 120422100,
    "dropphyadd": "58 COUNTY ROUTE 26",
    "dropphycty": "CLIMAX",
    "dropphyst": "NY",
    "dropphyzpp": 120422100,
    "dropmaladd": "58 COUNTY ROUTE 26",
    "dropmalcty": "CLIMAX",
    "dropmalst": "NY",
    "dropmalzpp": 120429998,
    "dropsitphn": 5187318881,
    "dropsitlph": 5187318881,
    "dropsitcph": 5187318881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12639",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "40 COLLEGE ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "NY",
    "dropdelzpp": 133239998,
    "dropphyadd": "40 COLLEGE ST",
    "dropphycty": "CLINTON",
    "dropphyst": "NY",
    "dropphyzpp": 133239998,
    "dropmaladd": "40 COLLEGE ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "NY",
    "dropmalzpp": 133239998,
    "dropsitphn": 3158532033,
    "dropsitlph": 3158532033,
    "dropsitcph": 3158532033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12640",
    "droptype": "D",
    "dropname": "CLINTON CORNERS",
    "dropdeladd": "2486 SALT POINT TPKE",
    "dropdelcty": "CLINTON CORNERS",
    "dropdelst": "NY",
    "dropdelzpp": 125149998,
    "dropphyadd": "2486 SALT POINT TPKE",
    "dropphycty": "CLINTON CORNERS",
    "dropphyst": "NY",
    "dropphyzpp": 125149998,
    "dropmaladd": "2486 SALT POINT TPKE",
    "dropmalcty": "CLINTON CORNERS",
    "dropmalst": "NY",
    "dropmalzpp": 125149998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452665694,
    "dropsitcph": 8452665694,
    "dropfax": 8452664064
  },
  {
    "dcode": "D",
    "dropkey": "PV12643",
    "droptype": "D",
    "dropname": "CLINTONDALE",
    "dropdeladd": "1059 ROUTE 44 55",
    "dropdelcty": "CLINTONDALE",
    "dropdelst": "NY",
    "dropdelzpp": 125159998,
    "dropphyadd": "1059 ROUTE 44 55",
    "dropphycty": "CLINTONDALE",
    "dropphyst": "NY",
    "dropphyzpp": 125159998,
    "dropmaladd": "1059 ROUTE 44 55",
    "dropmalcty": "CLINTONDALE",
    "dropmalst": "NY",
    "dropmalzpp": 125159998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458835320,
    "dropsitcph": 8458835320,
    "dropfax": 8458837973
  },
  {
    "dcode": "D",
    "dropkey": "PV12646",
    "droptype": "D",
    "dropname": "CLOCKVILLE",
    "dropdeladd": "7247 OXBOW RD",
    "dropdelcty": "CLOCKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130439998,
    "dropphyadd": "7247 OXBOW RD",
    "dropphycty": "CLOCKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130439998,
    "dropmaladd": "7247 OXBOW RD",
    "dropmalcty": "CLOCKVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130439998,
    "dropsitphn": 3156978113,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156978113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12650",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "20 S PARK ST",
    "dropdelcty": "CLYDE",
    "dropdelst": "NY",
    "dropdelzpp": 144339998,
    "dropphyadd": "20 S PARK ST",
    "dropphycty": "CLYDE",
    "dropphyst": "NY",
    "dropphyzpp": 144339998,
    "dropmaladd": "20 S PARK ST",
    "dropmalcty": "CLYDE",
    "dropmalst": "NY",
    "dropmalzpp": 144339998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3159234571,
    "dropsitcph": 3159234571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12651",
    "droptype": "D",
    "dropname": "CLYMER",
    "dropdeladd": "8727 E MAIN ST",
    "dropdelcty": "CLYMER",
    "dropdelst": "NY",
    "dropdelzpp": 147249998,
    "dropphyadd": "8727 E MAIN ST",
    "dropphycty": "CLYMER",
    "dropphyst": "NY",
    "dropphyzpp": 147249998,
    "dropmaladd": "8727 E MAIN ST",
    "dropmalcty": "CLYMER",
    "dropmalst": "NY",
    "dropmalzpp": 147249998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163554443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12656",
    "droptype": "D",
    "dropname": "COBLESKILL",
    "dropdeladd": "111 UNION ST",
    "dropdelcty": "COBLESKILL",
    "dropdelst": "NY",
    "dropdelzpp": 120439998,
    "dropphyadd": "111 UNION ST",
    "dropphycty": "COBLESKILL",
    "dropphyst": "NY",
    "dropphyzpp": 120439998,
    "dropmaladd": "111 UNION ST",
    "dropmalcty": "COBLESKILL",
    "dropmalst": "NY",
    "dropmalzpp": 120439998,
    "dropsitphn": 5182344011,
    "dropsitlph": 5182344011,
    "dropsitcph": 5182344011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12657",
    "droptype": "D",
    "dropname": "COCHECTON",
    "dropdeladd": "45 COUNTY ROAD 114",
    "dropdelcty": "COCHECTON",
    "dropdelst": "NY",
    "dropdelzpp": 127269998,
    "dropphyadd": "45 COUNTY ROAD 114",
    "dropphycty": "COCHECTON",
    "dropphyst": "NY",
    "dropphyzpp": 127269998,
    "dropmaladd": "45 COUNTY ROAD 114",
    "dropmalcty": "COCHECTON",
    "dropmalst": "NY",
    "dropmalzpp": 127269998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459328319,
    "dropsitcph": 8459328319,
    "dropfax": 8459328319
  },
  {
    "dcode": "D",
    "dropkey": "PV12658",
    "droptype": "D",
    "dropname": "COCHECTON CENTER",
    "dropdeladd": "45 COUNTY ROAD 114",
    "dropdelcty": "COCHECTON",
    "dropdelst": "NY",
    "dropdelzpp": 127265299,
    "dropphyadd": "45 COUNTY ROAD 114",
    "dropphycty": "COCHECTON",
    "dropphyst": "NY",
    "dropphyzpp": 127265299,
    "dropmaladd": "45 COUNTY ROAD 114",
    "dropmalcty": "COCHECTON",
    "dropmalst": "NY",
    "dropmalzpp": 127265299,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452523010,
    "dropsitcph": 8452523010,
    "dropfax": 8452523010
  },
  {
    "dcode": "D",
    "dropkey": "PV12660",
    "droptype": "D",
    "dropname": "COEYMANS",
    "dropdeladd": "96 MAIN ST",
    "dropdelcty": "COEYMANS",
    "dropdelst": "NY",
    "dropdelzpp": 120459998,
    "dropphyadd": "96 MAIN ST",
    "dropphycty": "COEYMANS",
    "dropphyst": "NY",
    "dropphyzpp": 120459998,
    "dropmaladd": "96 MAIN ST",
    "dropmalcty": "COEYMANS",
    "dropmalst": "NY",
    "dropmalzpp": 120459998,
    "dropsitphn": 5852018915,
    "dropsitlph": 5852018915,
    "dropsitcph": 5852018915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12661",
    "droptype": "D",
    "dropname": "COEYMANS HOLLOW",
    "dropdeladd": "1273 STATE ROUTE 143",
    "dropdelcty": "COEYMANS HOLLOW",
    "dropdelst": "NY",
    "dropdelzpp": 120462147,
    "dropphyadd": "1273 STATE ROUTE 143",
    "dropphycty": "COEYMANS HOLLOW",
    "dropphyst": "NY",
    "dropphyzpp": 120462147,
    "dropmaladd": "1273 STATE ROUTE 143",
    "dropmalcty": "COEYMANS HOLLOW",
    "dropmalst": "NY",
    "dropmalzpp": 120469998,
    "dropsitphn": 5187562025,
    "dropsitlph": 5187562025,
    "dropsitcph": 5187562025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12663",
    "droptype": "D",
    "dropname": "COHOCTON",
    "dropdeladd": "28 MAPLE AVE",
    "dropdelcty": "COHOCTON",
    "dropdelst": "NY",
    "dropdelzpp": 148269998,
    "dropphyadd": "28 MAPLE AVE",
    "dropphycty": "COHOCTON",
    "dropphyst": "NY",
    "dropphyzpp": 148269998,
    "dropmaladd": "28 MAPLE AVE",
    "dropmalcty": "COHOCTON",
    "dropmalst": "NY",
    "dropmalzpp": 148269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853845440,
    "dropsitcph": 5853845440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12664",
    "droptype": "D",
    "dropname": "COHOES",
    "dropdeladd": "101 MOHAWK ST",
    "dropdelcty": "COHOES",
    "dropdelst": "NY",
    "dropdelzpp": 120479996,
    "dropphyadd": "101 MOHAWK ST",
    "dropphycty": "COHOES",
    "dropphyst": "NY",
    "dropphyzpp": 120479996,
    "dropmaladd": "101 MOHAWK ST",
    "dropmalcty": "COHOES",
    "dropmalst": "NY",
    "dropmalzpp": 120479996,
    "dropsitphn": 5182375006,
    "dropsitlph": 5182375006,
    "dropsitcph": 5182375006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12668",
    "droptype": "D",
    "dropname": "COLD BROOK",
    "dropdeladd": "475 MAIN ST",
    "dropdelcty": "COLD BROOK",
    "dropdelst": "NY",
    "dropdelzpp": 133249998,
    "dropphyadd": "475 MAIN ST",
    "dropphycty": "COLD BROOK",
    "dropphyst": "NY",
    "dropphyzpp": 133249998,
    "dropmaladd": "475 MAIN ST",
    "dropmalcty": "COLD BROOK",
    "dropmalst": "NY",
    "dropmalzpp": 133249998,
    "dropsitphn": 3152280674,
    "dropsitlph": 3152280674,
    "dropsitcph": 3152280674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12671",
    "droptype": "D",
    "dropname": "COLD SPRING",
    "dropdeladd": "20 JULIA LN",
    "dropdelcty": "COLD SPRING",
    "dropdelst": "NY",
    "dropdelzpp": 105162507,
    "dropphyadd": "20 JULIA LN",
    "dropphycty": "COLD SPRING",
    "dropphyst": "NY",
    "dropphyzpp": 105162507,
    "dropmaladd": "20 JULIA LN",
    "dropmalcty": "COLD SPRING",
    "dropmalst": "NY",
    "dropmalzpp": 105162507,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452652193,
    "dropsitcph": 8452652193,
    "dropfax": 8452653148
  },
  {
    "dcode": "D",
    "dropkey": "PV12672",
    "droptype": "D",
    "dropname": "COLD SPRING HARBOR",
    "dropdeladd": "126 MAIN ST",
    "dropdelcty": "COLD SPRING HARBOR",
    "dropdelst": "NY",
    "dropdelzpp": 117241440,
    "dropphyadd": "126 MAIN ST",
    "dropphycty": "COLD SPRING HARBOR",
    "dropphyst": "NY",
    "dropphyzpp": 117241440,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLD SPRING HARBOR",
    "dropmalst": "NY",
    "dropmalzpp": 117249998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316925307,
    "dropfax": 6316925430
  },
  {
    "dcode": "D",
    "dropkey": "PV12679",
    "droptype": "D",
    "dropname": "COLDEN",
    "dropdeladd": "8665 STATE RD",
    "dropdelcty": "COLDEN",
    "dropdelst": "NY",
    "dropdelzpp": 140339998,
    "dropphyadd": "8665 STATE RD",
    "dropphycty": "COLDEN",
    "dropphyst": "NY",
    "dropphyzpp": 140339998,
    "dropmaladd": "8665 STATE RD",
    "dropmalcty": "COLDEN",
    "dropmalst": "NY",
    "dropmalzpp": 140339998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169415254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12688",
    "droptype": "D",
    "dropname": "COLLIERSVILLE",
    "dropdeladd": "6173 STATE HIGHWAY 7",
    "dropdelcty": "COLLIERSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137479998,
    "dropphyadd": "6173 STATE HIGHWAY 7",
    "dropphycty": "COLLIERSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137479998,
    "dropmaladd": "6173 STATE HIGHWAY 7",
    "dropmalcty": "COLLIERSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137479998,
    "dropsitphn": 6074320282,
    "dropsitlph": 6074320282,
    "dropsitcph": 6074320282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12691",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "2275 MAIN ST",
    "dropdelcty": "COLLINS",
    "dropdelst": "NY",
    "dropdelzpp": 140349998,
    "dropphyadd": "2275 MAIN ST",
    "dropphycty": "COLLINS",
    "dropphyst": "NY",
    "dropphyzpp": 140349998,
    "dropmaladd": "2275 MAIN ST",
    "dropmalcty": "COLLINS",
    "dropmalst": "NY",
    "dropmalzpp": 140349998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165323976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12692",
    "droptype": "D",
    "dropname": "COLLINS CENTER",
    "dropdeladd": "3592 MAIN ST",
    "dropdelcty": "COLLINS CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 140359800,
    "dropphyadd": "3592 MAIN ST",
    "dropphycty": "COLLINS CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 140359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLINS CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 140359998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165324032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12703",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "4841 STATE HIGHWAY 56",
    "dropdelcty": "COLTON",
    "dropdelst": "NY",
    "dropdelzpp": 136259998,
    "dropphyadd": "4841 STATE HIGHWAY 56",
    "dropphycty": "COLTON",
    "dropphyst": "NY",
    "dropphyzpp": 136259998,
    "dropmaladd": "4841 STATE HIGHWAY 56",
    "dropmalcty": "COLTON",
    "dropmalst": "NY",
    "dropmalzpp": 136259998,
    "dropsitphn": 3152622559,
    "dropsitlph": 3152622559,
    "dropsitcph": 3152622559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12708",
    "droptype": "D",
    "dropname": "COLUMBIAVILLE",
    "dropdeladd": "1227 ROUTE 9",
    "dropdelcty": "COLUMBIAVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120509998,
    "dropphyadd": "1227 ROUTE 9",
    "dropphycty": "COLUMBIAVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120509998,
    "dropmaladd": "1227 ROUTE 9",
    "dropmalcty": "COLUMBIAVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120509998,
    "dropsitphn": 5188282194,
    "dropsitlph": 5188282194,
    "dropsitcph": 5188282194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12715",
    "droptype": "D",
    "dropname": "COMMACK",
    "dropdeladd": "150 VETERANS MEMORIAL HWY",
    "dropdelcty": "COMMACK",
    "dropdelst": "NY",
    "dropdelzpp": 117253636,
    "dropphyadd": "150 VETERANS MEMORIAL HWY",
    "dropphycty": "COMMACK",
    "dropphyst": "NY",
    "dropphyzpp": 117253636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMMACK",
    "dropmalst": "NY",
    "dropmalzpp": 117259998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315433647,
    "dropfax": 6315437487
  },
  {
    "dcode": "D",
    "dropkey": "PV12716",
    "droptype": "D",
    "dropname": "COMSTOCK",
    "dropdeladd": "11762 STATE ROUTE 22",
    "dropdelcty": "COMSTOCK",
    "dropdelst": "NY",
    "dropdelzpp": 128212103,
    "dropphyadd": "11762 STATE ROUTE 22",
    "dropphycty": "COMSTOCK",
    "dropphyst": "NY",
    "dropphyzpp": 128212103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMSTOCK",
    "dropmalst": "NY",
    "dropmalzpp": 128219998,
    "dropsitphn": 5186395288,
    "dropsitlph": 5186395288,
    "dropsitcph": 5186395288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12720",
    "droptype": "D",
    "dropname": "CONESUS",
    "dropdeladd": "6154 S LIVONIA RD",
    "dropdelcty": "CONESUS",
    "dropdelst": "NY",
    "dropdelzpp": 144359998,
    "dropphyadd": "6154 S LIVONIA RD",
    "dropphycty": "CONESUS",
    "dropphyst": "NY",
    "dropphyzpp": 144359998,
    "dropmaladd": "6154 S LIVONIA RD",
    "dropmalcty": "CONESUS",
    "dropmalst": "NY",
    "dropmalzpp": 144359998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853463990,
    "dropsitcph": 5853463990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12721",
    "droptype": "D",
    "dropname": "CONEWANGO VALLEY",
    "dropdeladd": "5496 ROUTE 62",
    "dropdelcty": "CONEWANGO VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 147269998,
    "dropphyadd": "5496 ROUTE 62",
    "dropphycty": "CONEWANGO VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 147269998,
    "dropmaladd": "5496 ROUTE 62",
    "dropmalcty": "CONEWANGO VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 147269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162872950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12725",
    "droptype": "D",
    "dropname": "CONGERS",
    "dropdeladd": "14 OLD HAVERSTRAW RD",
    "dropdelcty": "CONGERS",
    "dropdelst": "NY",
    "dropdelzpp": 109209998,
    "dropphyadd": "14 OLD HAVERSTRAW RD",
    "dropphycty": "CONGERS",
    "dropphyst": "NY",
    "dropphyzpp": 109209998,
    "dropmaladd": "14 OLD HAVERSTRAW RD",
    "dropmalcty": "CONGERS",
    "dropmalst": "NY",
    "dropmalzpp": 109209998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452688742,
    "dropsitcph": 8452688742,
    "dropfax": 8452684744
  },
  {
    "dcode": "D",
    "dropkey": "PV12727",
    "droptype": "D",
    "dropname": "CONKLIN",
    "dropdeladd": "1101 CONKLIN RD",
    "dropdelcty": "CONKLIN",
    "dropdelst": "NY",
    "dropdelzpp": 137489998,
    "dropphyadd": "1101 CONKLIN RD",
    "dropphycty": "CONKLIN",
    "dropphyst": "NY",
    "dropphyzpp": 137489998,
    "dropmaladd": "1101 CONKLIN RD",
    "dropmalcty": "CONKLIN",
    "dropmalst": "NY",
    "dropmalzpp": 137489998,
    "dropsitphn": 6077753616,
    "dropsitlph": 6077753616,
    "dropsitcph": 6077753616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12731",
    "droptype": "D",
    "dropname": "CONNELLY",
    "dropdeladd": "130 3RD ST",
    "dropdelcty": "CONNELLY",
    "dropdelst": "NY",
    "dropdelzpp": 124179800,
    "dropphyadd": "130 3RD ST",
    "dropphycty": "CONNELLY",
    "dropphyst": "NY",
    "dropphyzpp": 124179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONNELLY",
    "dropmalst": "NY",
    "dropmalzpp": 124179998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453318741,
    "dropsitcph": 8453318741,
    "dropfax": 8453318741
  },
  {
    "dcode": "D",
    "dropkey": "PV12735",
    "droptype": "D",
    "dropname": "CONSTABLE",
    "dropdeladd": "1138 STATE ROUTE 122",
    "dropdelcty": "CONSTABLE",
    "dropdelst": "NY",
    "dropdelzpp": 129269998,
    "dropphyadd": "1138 STATE ROUTE 122",
    "dropphycty": "CONSTABLE",
    "dropphyst": "NY",
    "dropphyzpp": 129269998,
    "dropmaladd": "1138 STATE ROUTE 122",
    "dropmalcty": "CONSTABLE",
    "dropmalst": "NY",
    "dropmalzpp": 129269998,
    "dropsitphn": 5184837717,
    "dropsitlph": 5184837717,
    "dropsitcph": 5184837717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12736",
    "droptype": "D",
    "dropname": "CONSTABLEVILLE",
    "dropdeladd": "3109 MAIN ST",
    "dropdelcty": "CONSTABLEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133259998,
    "dropphyadd": "3109 MAIN ST",
    "dropphycty": "CONSTABLEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133259998,
    "dropmaladd": "3109 MAIN ST",
    "dropmalcty": "CONSTABLEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133259998,
    "dropsitphn": 3153972375,
    "dropsitlph": 3153972375,
    "dropsitcph": 3153972375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12738",
    "droptype": "D",
    "dropname": "CONSTANTIA",
    "dropdeladd": "45 REDFIELD ST",
    "dropdelcty": "CONSTANTIA",
    "dropdelst": "NY",
    "dropdelzpp": 130442634,
    "dropphyadd": "45 REDFIELD ST",
    "dropphycty": "CONSTANTIA",
    "dropphyst": "NY",
    "dropphyzpp": 130442634,
    "dropmaladd": "45 REDFIELD ST",
    "dropmalcty": "CONSTANTIA",
    "dropmalst": "NY",
    "dropmalzpp": 130442634,
    "dropsitphn": 3156230976,
    "dropsitlph": 3156230976,
    "dropsitcph": 3156230976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12746",
    "droptype": "D",
    "dropname": "COOPERS PLAINS",
    "dropdeladd": "158 MAIN ST",
    "dropdelcty": "COOPERS PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 148279800,
    "dropphyadd": "158 MAIN ST",
    "dropphycty": "COOPERS PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 148279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOPERS PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 148279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6079369441,
    "dropsitcph": 6079369441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12747",
    "droptype": "D",
    "dropname": "COOPERSTOWN",
    "dropdeladd": "40 MAIN ST",
    "dropdelcty": "COOPERSTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 133269998,
    "dropphyadd": "40 MAIN ST",
    "dropphycty": "COOPERSTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 133269998,
    "dropmaladd": "40 MAIN ST",
    "dropmalcty": "COOPERSTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 133269998,
    "dropsitphn": 6075472311,
    "dropsitlph": 6075472311,
    "dropsitcph": 6075472311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12751",
    "droptype": "D",
    "dropname": "COPAKE",
    "dropdeladd": "1656 COUNTY ROUTE 7A",
    "dropdelcty": "COPAKE",
    "dropdelst": "NY",
    "dropdelzpp": 125169998,
    "dropphyadd": "1656 COUNTY ROUTE 7A",
    "dropphycty": "COPAKE",
    "dropphyst": "NY",
    "dropphyzpp": 125169998,
    "dropmaladd": "1656 COUNTY ROUTE 7A",
    "dropmalcty": "COPAKE",
    "dropmalst": "NY",
    "dropmalzpp": 125169998,
    "dropsitphn": 5186608048,
    "dropsitlph": 5186608048,
    "dropsitcph": 8773641309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12752",
    "droptype": "D",
    "dropname": "COPAKE FALLS",
    "dropdeladd": "109 STATE ROUTE 344",
    "dropdelcty": "COPAKE FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 125175324,
    "dropphyadd": "109 STATE ROUTE 344",
    "dropphycty": "COPAKE FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 125175324,
    "dropmaladd": "109 STATE ROUTE 344",
    "dropmalcty": "COPAKE FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 125179998,
    "dropsitphn": 5186608715,
    "dropsitlph": 5186608715,
    "dropsitcph": 8778541837,
    "dropfax": 5183291399
  },
  {
    "dcode": "D",
    "dropkey": "PV12755",
    "droptype": "D",
    "dropname": "COPENHAGEN",
    "dropdeladd": "9886 STATE ROUTE 12",
    "dropdelcty": "COPENHAGEN",
    "dropdelst": "NY",
    "dropdelzpp": 136269998,
    "dropphyadd": "9886 STATE ROUTE 12",
    "dropphycty": "COPENHAGEN",
    "dropphyst": "NY",
    "dropphyzpp": 136269998,
    "dropmaladd": "9886 STATE ROUTE 12",
    "dropmalcty": "COPENHAGEN",
    "dropmalst": "NY",
    "dropmalzpp": 136269998,
    "dropsitphn": 3156882920,
    "dropsitlph": 3156882920,
    "dropsitcph": 3156882920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12756",
    "droptype": "D",
    "dropname": "COPIAGUE",
    "dropdeladd": "695 MARCONI BLVD",
    "dropdelcty": "COPIAGUE",
    "dropdelst": "NY",
    "dropdelzpp": 117262819,
    "dropphyadd": "695 MARCONI BLVD",
    "dropphycty": "COPIAGUE",
    "dropphyst": "NY",
    "dropphyzpp": 117262819,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPIAGUE",
    "dropmalst": "NY",
    "dropmalzpp": 117269998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6318429084,
    "dropfax": 6318425896
  },
  {
    "dcode": "D",
    "dropkey": "PV12757",
    "droptype": "D",
    "dropname": "CORAM",
    "dropdeladd": "117 PAULS PATH",
    "dropdelcty": "CORAM",
    "dropdelst": "NY",
    "dropdelzpp": 117273364,
    "dropphyadd": "117 PAULS PATH",
    "dropphycty": "CORAM",
    "dropphyst": "NY",
    "dropphyzpp": 117273364,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORAM",
    "dropmalst": "NY",
    "dropmalzpp": 117279998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317328691,
    "dropfax": 6317321435
  },
  {
    "dcode": "D",
    "dropkey": "PV12759",
    "droptype": "D",
    "dropname": "CORBETTSVILLE",
    "dropdeladd": "10 CORBETTSVILLE RD",
    "dropdelcty": "CORBETTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137499998,
    "dropphyadd": "10 CORBETTSVILLE RD",
    "dropphycty": "CORBETTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137499998,
    "dropmaladd": "10 CORBETTSVILLE RD",
    "dropmalcty": "CORBETTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137499998,
    "dropsitphn": 6077753499,
    "dropsitlph": 6077753499,
    "dropsitcph": 6077753499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12762",
    "droptype": "D",
    "dropname": "CORFU",
    "dropdeladd": "7 W MAIN ST",
    "dropdelcty": "CORFU",
    "dropdelst": "NY",
    "dropdelzpp": 140369998,
    "dropphyadd": "7 W MAIN ST",
    "dropphycty": "CORFU",
    "dropphyst": "NY",
    "dropphyzpp": 140369998,
    "dropmaladd": "7 W MAIN ST",
    "dropmalcty": "CORFU",
    "dropmalst": "NY",
    "dropmalzpp": 140369998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855984607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12763",
    "droptype": "D",
    "dropname": "CORINTH",
    "dropdeladd": "97 MAIN ST",
    "dropdelcty": "CORINTH",
    "dropdelst": "NY",
    "dropdelzpp": 128229998,
    "dropphyadd": "97 MAIN ST",
    "dropphycty": "CORINTH",
    "dropphyst": "NY",
    "dropphyzpp": 128229998,
    "dropmaladd": "97 MAIN ST",
    "dropmalcty": "CORINTH",
    "dropmalst": "NY",
    "dropmalzpp": 128229998,
    "dropsitphn": 5186542121,
    "dropsitlph": 5186542121,
    "dropsitcph": 5186542121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12769",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "198 BAKER ST",
    "dropdelcty": "CORNING",
    "dropdelst": "NY",
    "dropdelzpp": 148309998,
    "dropphyadd": "198 BAKER ST",
    "dropphycty": "CORNING",
    "dropphyst": "NY",
    "dropphyzpp": 148309998,
    "dropmaladd": "198 BAKER ST",
    "dropmalcty": "CORNING",
    "dropmalst": "NY",
    "dropmalzpp": 148309998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6079366132,
    "dropsitcph": 6079366132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12771",
    "droptype": "D",
    "dropname": "CORNWALL",
    "dropdeladd": "33 QUAKER AVE",
    "dropdelcty": "CORNWALL",
    "dropdelst": "NY",
    "dropdelzpp": 125189998,
    "dropphyadd": "33 QUAKER AVE",
    "dropphycty": "CORNWALL",
    "dropphyst": "NY",
    "dropphyzpp": 125189998,
    "dropmaladd": "33 QUAKER AVE",
    "dropmalcty": "CORNWALL",
    "dropmalst": "NY",
    "dropmalzpp": 125189998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455349801,
    "dropsitcph": 8455349801,
    "dropfax": 8455344986
  },
  {
    "dcode": "D",
    "dropkey": "PV12775",
    "droptype": "D",
    "dropname": "CORNWALL ON HUDSON",
    "dropdeladd": "237 HUDSON ST STE 1",
    "dropdelcty": "CORNWALL ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 125209998,
    "dropphyadd": "237 HUDSON ST STE 1",
    "dropphycty": "CORNWALL ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 125209998,
    "dropmaladd": "237 HUDSON ST STE 1",
    "dropmalcty": "CORNWALL ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 125209998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455349783,
    "dropsitcph": 8455349783,
    "dropfax": 8455343849
  },
  {
    "dcode": "D",
    "dropkey": "PV12777",
    "droptype": "D",
    "dropname": "CORNWALLVILLE",
    "dropdeladd": "2893 ROUTE 20",
    "dropdelcty": "CORNWALLVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124189998,
    "dropphyadd": "2893 ROUTE 20",
    "dropphycty": "CORNWALLVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124189998,
    "dropmaladd": "2893 ROUTE 20",
    "dropmalcty": "CORNWALLVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124189998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5182396177,
    "dropsitcph": 5182396177,
    "dropfax": 5182396177
  },
  {
    "dcode": "D",
    "dropkey": "PV12784",
    "droptype": "D",
    "dropname": "CORTLAND",
    "dropdeladd": "88 MAIN ST",
    "dropdelcty": "CORTLAND",
    "dropdelst": "NY",
    "dropdelzpp": 130459998,
    "dropphyadd": "88 MAIN ST",
    "dropphycty": "CORTLAND",
    "dropphyst": "NY",
    "dropphyzpp": 130459998,
    "dropmaladd": "88 MAIN ST",
    "dropmalcty": "CORTLAND",
    "dropmalst": "NY",
    "dropmalzpp": 130459998,
    "dropsitphn": 6077530266,
    "dropsitlph": 6077530266,
    "dropsitcph": 6077530266,
    "dropfax": 6077567155
  },
  {
    "dcode": "D",
    "dropkey": "PV12790",
    "droptype": "D",
    "dropname": "COSSAYUNA",
    "dropdeladd": "703 COUNTY ROUTE 49",
    "dropdelcty": "COSSAYUNA",
    "dropdelst": "NY",
    "dropdelzpp": 128239998,
    "dropphyadd": "703 COUNTY ROUTE 49",
    "dropphycty": "COSSAYUNA",
    "dropphyst": "NY",
    "dropphyzpp": 128239998,
    "dropmaladd": "703 COUNTY ROUTE 49",
    "dropmalcty": "COSSAYUNA",
    "dropmalst": "NY",
    "dropmalzpp": 128239998,
    "dropsitphn": 5186927820,
    "dropsitlph": 5186927820,
    "dropsitcph": 5186927820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12792",
    "droptype": "D",
    "dropname": "COTTEKILL",
    "dropdeladd": "1820 LUCAS AVENUE EXT",
    "dropdelcty": "COTTEKILL",
    "dropdelst": "NY",
    "dropdelzpp": 124199998,
    "dropphyadd": "1820 LUCAS AVENUE EXT",
    "dropphycty": "COTTEKILL",
    "dropphyst": "NY",
    "dropphyzpp": 124199998,
    "dropmaladd": "1820 LUCAS AVENUE EXT",
    "dropmalcty": "COTTEKILL",
    "dropmalst": "NY",
    "dropmalzpp": 124199998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456877182,
    "dropsitcph": 8456877182,
    "dropfax": 8456877182
  },
  {
    "dcode": "D",
    "dropkey": "PV12803",
    "droptype": "D",
    "dropname": "COXSACKIE",
    "dropdeladd": "27 REED ST",
    "dropdelcty": "COXSACKIE",
    "dropdelst": "NY",
    "dropdelzpp": 120519998,
    "dropphyadd": "27 REED ST",
    "dropphycty": "COXSACKIE",
    "dropphyst": "NY",
    "dropphyzpp": 120519998,
    "dropmaladd": "27 REED ST",
    "dropmalcty": "COXSACKIE",
    "dropmalst": "NY",
    "dropmalzpp": 120519998,
    "dropsitphn": 5187316112,
    "dropsitlph": 5187316112,
    "dropsitcph": 5187316112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12807",
    "droptype": "D",
    "dropname": "CRAGSMOOR",
    "dropdeladd": "8 HENRY RD",
    "dropdelcty": "CRAGSMOOR",
    "dropdelst": "NY",
    "dropdelzpp": 124209998,
    "dropphyadd": "8 HENRY RD",
    "dropphycty": "CRAGSMOOR",
    "dropphyst": "NY",
    "dropphyzpp": 124209998,
    "dropmaladd": "8 HENRY RD",
    "dropmalcty": "CRAGSMOOR",
    "dropmalst": "NY",
    "dropmalzpp": 124209998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456478282,
    "dropsitcph": 8456478282,
    "dropfax": 8456473861
  },
  {
    "dcode": "D",
    "dropkey": "PV12808",
    "droptype": "D",
    "dropname": "CRANBERRY LAKE",
    "dropdeladd": "7171 STATE HIGHWAY 3",
    "dropdelcty": "CRANBERRY LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 129277761,
    "dropphyadd": "7171 STATE HIGHWAY 3",
    "dropphycty": "CRANBERRY LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 129277761,
    "dropmaladd": "7171 STATE HIGHWAY 3",
    "dropmalcty": "CRANBERRY LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 129277761,
    "dropsitphn": 5188483574,
    "dropsitlph": 5188483574,
    "dropsitcph": 3158483574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12813",
    "droptype": "D",
    "dropname": "CRARYVILLE",
    "dropdeladd": "1751 STATE ROUTE 23",
    "dropdelcty": "CRARYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125215160,
    "dropphyadd": "1751 STATE ROUTE 23",
    "dropphycty": "CRARYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125215160,
    "dropmaladd": "1751 STATE ROUTE 23",
    "dropmalcty": "CRARYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125219998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5183259420,
    "dropsitcph": 5183259420,
    "dropfax": 5183255752
  },
  {
    "dcode": "D",
    "dropkey": "PV12827",
    "droptype": "D",
    "dropname": "CROGHAN",
    "dropdeladd": "6915 BANK ST",
    "dropdelcty": "CROGHAN",
    "dropdelst": "NY",
    "dropdelzpp": 133279998,
    "dropphyadd": "6915 BANK ST",
    "dropphycty": "CROGHAN",
    "dropphyst": "NY",
    "dropphyzpp": 133279998,
    "dropmaladd": "6915 BANK ST",
    "dropmalcty": "CROGHAN",
    "dropmalst": "NY",
    "dropmalzpp": 133279998,
    "dropsitphn": 3153441062,
    "dropsitlph": 3153441062,
    "dropsitcph": 3153441062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12828",
    "droptype": "D",
    "dropname": "CROMPOND",
    "dropdeladd": "60 BARON DE HIRSCH RD",
    "dropdelcty": "CROMPOND",
    "dropdelst": "NY",
    "dropdelzpp": 105179800,
    "dropphyadd": "60 BARON DE HIRSCH RD",
    "dropphycty": "CROMPOND",
    "dropphyst": "NY",
    "dropphyzpp": 105179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROMPOND",
    "dropmalst": "NY",
    "dropmalzpp": 105179998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145285824,
    "dropsitcph": 9145285824,
    "dropfax": 9145280936
  },
  {
    "dcode": "D",
    "dropkey": "PV12829",
    "droptype": "D",
    "dropname": "CROPSEYVILLE",
    "dropdeladd": "3991 STATE RTE 2",
    "dropdelcty": "CROPSEYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120529998,
    "dropphyadd": "3991 STATE RTE 2",
    "dropphycty": "CROPSEYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120529998,
    "dropmaladd": "3991 STATE RTE 2",
    "dropmalcty": "CROPSEYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120529998,
    "dropsitphn": 5182791220,
    "dropsitlph": 5182791220,
    "dropsitcph": 5182791220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12831",
    "droptype": "D",
    "dropname": "CROSS RIVER",
    "dropdeladd": "20 CROSS RIVER SHOPPING CTR STE H",
    "dropdelcty": "CROSS RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 105189998,
    "dropphyadd": "20 CROSS RIVER SHOPPING CTR STE H",
    "dropphycty": "CROSS RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 105189998,
    "dropmaladd": "20 CROSS RIVER SHOPPING CTR STE H",
    "dropmalcty": "CROSS RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 105189998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147633798,
    "dropsitcph": 9147633798,
    "dropfax": 9147630524
  },
  {
    "dcode": "D",
    "dropkey": "PV12834",
    "droptype": "D",
    "dropname": "CROTON FALLS",
    "dropdeladd": "8 FRONT ST",
    "dropdelcty": "CROTON FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 105199800,
    "dropphyadd": "8 FRONT ST",
    "dropphycty": "CROTON FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 105199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROTON FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 105199998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142771427,
    "dropsitcph": 9142771427,
    "dropfax": 9142777853
  },
  {
    "dcode": "D",
    "dropkey": "PV12838",
    "droptype": "D",
    "dropname": "CROTON ON HUDSON",
    "dropdeladd": "50 MAPLE ST",
    "dropdelcty": "CROTON ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 105209998,
    "dropphyadd": "50 MAPLE ST",
    "dropphycty": "CROTON ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 105209998,
    "dropmaladd": "50 MAPLE ST",
    "dropmalcty": "CROTON ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 105209998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142717589,
    "dropsitcph": 9142717589,
    "dropfax": 9142718404
  },
  {
    "dcode": "D",
    "dropkey": "PV12843",
    "droptype": "D",
    "dropname": "CROWN POINT",
    "dropdeladd": "2752 MAIN ST",
    "dropdelcty": "CROWN POINT",
    "dropdelst": "NY",
    "dropdelzpp": 129289998,
    "dropphyadd": "2752 MAIN ST",
    "dropphycty": "CROWN POINT",
    "dropphyst": "NY",
    "dropphyzpp": 129289998,
    "dropmaladd": "2752 MAIN ST",
    "dropmalcty": "CROWN POINT",
    "dropmalst": "NY",
    "dropmalzpp": 129289998,
    "dropsitphn": 5185973922,
    "dropsitlph": 5185973922,
    "dropsitcph": 5185973922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12851",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "40 WATER ST",
    "dropdelcty": "CUBA",
    "dropdelst": "NY",
    "dropdelzpp": 147279998,
    "dropphyadd": "40 WATER ST",
    "dropphycty": "CUBA",
    "dropphyst": "NY",
    "dropphyzpp": 147279998,
    "dropmaladd": "40 WATER ST",
    "dropmalcty": "CUBA",
    "dropmalst": "NY",
    "dropmalzpp": 147279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859681380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12852",
    "droptype": "D",
    "dropname": "CUDDEBACKVILLE",
    "dropdeladd": "19 STATE ROUTE 211",
    "dropdelcty": "CUDDEBACKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127299998,
    "dropphyadd": "19 STATE ROUTE 211",
    "dropphycty": "CUDDEBACKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127299998,
    "dropmaladd": "19 STATE ROUTE 211",
    "dropmalcty": "CUDDEBACKVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127299998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457540780,
    "dropsitcph": 8457540780,
    "dropfax": 8457548548
  },
  {
    "dcode": "D",
    "dropkey": "PV12855",
    "droptype": "D",
    "dropname": "CUTCHOGUE",
    "dropdeladd": "240 GRIFFING ST",
    "dropdelcty": "CUTCHOGUE",
    "dropdelst": "NY",
    "dropdelzpp": 119351200,
    "dropphyadd": "240 GRIFFING ST",
    "dropphycty": "CUTCHOGUE",
    "dropphyst": "NY",
    "dropphyzpp": 119351200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUTCHOGUE",
    "dropmalst": "NY",
    "dropmalzpp": 119359998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317346032,
    "dropfax": 6317344142
  },
  {
    "dcode": "D",
    "dropkey": "PV12862",
    "droptype": "D",
    "dropname": "DALE",
    "dropdeladd": "1302 DALE RD",
    "dropdelcty": "DALE",
    "dropdelst": "NY",
    "dropdelzpp": 140399998,
    "dropphyadd": "1302 DALE RD",
    "dropphycty": "DALE",
    "dropphyst": "NY",
    "dropphyzpp": 140399998,
    "dropmaladd": "1302 DALE RD",
    "dropmalcty": "DALE",
    "dropmalst": "NY",
    "dropmalzpp": 140399998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5857863446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12863",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "9959 STATE ST",
    "dropdelcty": "DALTON",
    "dropdelst": "NY",
    "dropdelzpp": 148369998,
    "dropphyadd": "9959 STATE ST",
    "dropphycty": "DALTON",
    "dropphyst": "NY",
    "dropphyzpp": 148369998,
    "dropmaladd": "9959 STATE ST",
    "dropmalcty": "DALTON",
    "dropmalst": "NY",
    "dropmalzpp": 148369998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854762293,
    "dropsitcph": 5854762293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12867",
    "droptype": "D",
    "dropname": "DANNEMORA",
    "dropdeladd": "1079 COOK ST",
    "dropdelcty": "DANNEMORA",
    "dropdelst": "NY",
    "dropdelzpp": 129299998,
    "dropphyadd": "1079 COOK ST",
    "dropphycty": "DANNEMORA",
    "dropphyst": "NY",
    "dropphyzpp": 129299998,
    "dropmaladd": "1079 COOK ST",
    "dropmalcty": "DANNEMORA",
    "dropmalst": "NY",
    "dropmalzpp": 129299998,
    "dropsitphn": 5184927115,
    "dropsitlph": 5184927115,
    "dropsitcph": 5184927115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12868",
    "droptype": "D",
    "dropname": "DANSVILLE",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "DANSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 144379998,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "DANSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 144379998,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "DANSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 144379998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853352720,
    "dropsitcph": 5853352720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12870",
    "droptype": "D",
    "dropname": "DARIEN CENTER",
    "dropdeladd": "1402 BROADWAY",
    "dropdelcty": "DARIEN CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 140409998,
    "dropphyadd": "1402 BROADWAY",
    "dropphycty": "DARIEN CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 140409998,
    "dropmaladd": "1402 BROADWAY",
    "dropmalcty": "DARIEN CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 140409998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855472217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12872",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "15682 STATE HIGHWAY 23",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "NY",
    "dropdelzpp": 137509998,
    "dropphyadd": "15682 STATE HIGHWAY 23",
    "dropphycty": "DAVENPORT",
    "dropphyst": "NY",
    "dropphyzpp": 137509998,
    "dropmaladd": "15682 STATE HIGHWAY 23",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "NY",
    "dropmalzpp": 137509998,
    "dropsitphn": 6072785622,
    "dropsitlph": 6072785622,
    "dropsitcph": 6072785622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12873",
    "droptype": "D",
    "dropname": "DAVENPORT CENTER",
    "dropdeladd": "11892 STATE HIGHWAY 23",
    "dropdelcty": "DAVENPORT CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 137519998,
    "dropphyadd": "11892 STATE HIGHWAY 23",
    "dropphycty": "DAVENPORT CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 137519998,
    "dropmaladd": "11892 STATE HIGHWAY 23",
    "dropmalcty": "DAVENPORT CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 137519998,
    "dropsitphn": 6072785067,
    "dropsitlph": 6072785067,
    "dropsitcph": 6072785067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12877",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "9593 ROUTE 62",
    "dropdelcty": "DAYTON",
    "dropdelst": "NY",
    "dropdelzpp": 140419706,
    "dropphyadd": "9593 ROUTE 62",
    "dropphycty": "DAYTON",
    "dropphyst": "NY",
    "dropphyzpp": 140419706,
    "dropmaladd": "9593 ROUTE 62",
    "dropmalcty": "DAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 140419706,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165324244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12881",
    "droptype": "D",
    "dropname": "DE KALB JUNCTION",
    "dropdeladd": "4329 US HIGHWAY 11",
    "dropdelcty": "DE KALB JUNCTION",
    "dropdelst": "NY",
    "dropdelzpp": 136309998,
    "dropphyadd": "4329 US HIGHWAY 11",
    "dropphycty": "DE KALB JUNCTION",
    "dropphyst": "NY",
    "dropphyzpp": 136309998,
    "dropmaladd": "4329 US HIGHWAY 11",
    "dropmalcty": "DE KALB JUNCTION",
    "dropmalst": "NY",
    "dropmalzpp": 136309998,
    "dropsitphn": 3153473397,
    "dropsitlph": 3153473397,
    "dropsitcph": 3153473397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12884",
    "droptype": "D",
    "dropname": "DE RUYTER",
    "dropdeladd": "1639 CORTLAND ST",
    "dropdelcty": "DE RUYTER",
    "dropdelst": "NY",
    "dropdelzpp": 130529998,
    "dropphyadd": "1639 CORTLAND ST",
    "dropphycty": "DE RUYTER",
    "dropphyst": "NY",
    "dropphyzpp": 130529998,
    "dropmaladd": "1639 CORTLAND ST",
    "dropmalcty": "DE RUYTER",
    "dropmalst": "NY",
    "dropmalzpp": 130529998,
    "dropsitphn": 3158529515,
    "dropsitlph": 5184522299,
    "dropsitcph": 3158529515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12886",
    "droptype": "D",
    "dropname": "DEANSBORO",
    "dropdeladd": "2715 STATE ROUTE 12B",
    "dropdelcty": "DEANSBORO",
    "dropdelst": "NY",
    "dropdelzpp": 133289998,
    "dropphyadd": "2715 STATE ROUTE 12B",
    "dropphycty": "DEANSBORO",
    "dropphyst": "NY",
    "dropphyzpp": 133289998,
    "dropmaladd": "2715 STATE ROUTE 12B",
    "dropmalcty": "DEANSBORO",
    "dropmalst": "NY",
    "dropmalzpp": 133289998,
    "dropsitphn": 3158414757,
    "dropsitlph": 3158414757,
    "dropsitcph": 3158414757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12889",
    "droptype": "D",
    "dropname": "DEER PARK",
    "dropdeladd": "375 CARLLS PATH",
    "dropdelcty": "DEER PARK",
    "dropdelst": "NY",
    "dropdelzpp": 117294414,
    "dropphyadd": "375 CARLLS PATH",
    "dropphycty": "DEER PARK",
    "dropphyst": "NY",
    "dropphyzpp": 117294414,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER PARK",
    "dropmalst": "NY",
    "dropmalzpp": 117299998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316679744,
    "dropfax": 6315866346
  },
  {
    "dcode": "D",
    "dropkey": "PV12902",
    "droptype": "D",
    "dropname": "DELANSON",
    "dropdeladd": "126 RAILROAD AVE",
    "dropdelcty": "DELANSON",
    "dropdelst": "NY",
    "dropdelzpp": 120539998,
    "dropphyadd": "126 RAILROAD AVE",
    "dropphycty": "DELANSON",
    "dropphyst": "NY",
    "dropphyzpp": 120539998,
    "dropmaladd": "126 RAILROAD AVE",
    "dropmalcty": "DELANSON",
    "dropmalst": "NY",
    "dropmalzpp": 120539998,
    "dropsitphn": 5188958810,
    "dropsitlph": 5188958810,
    "dropsitcph": 5188958810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12904",
    "droptype": "D",
    "dropname": "DELEVAN",
    "dropdeladd": "40 N MAIN ST",
    "dropdelcty": "DELEVAN",
    "dropdelst": "NY",
    "dropdelzpp": 140429998,
    "dropphyadd": "40 N MAIN ST",
    "dropphycty": "DELEVAN",
    "dropphyst": "NY",
    "dropphyzpp": 140429998,
    "dropmaladd": "40 N MAIN ST",
    "dropmalcty": "DELEVAN",
    "dropmalst": "NY",
    "dropmalzpp": 140429998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164922670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12905",
    "droptype": "D",
    "dropname": "DELHI",
    "dropdeladd": "8 COURT ST",
    "dropdelcty": "DELHI",
    "dropdelst": "NY",
    "dropdelzpp": 137539998,
    "dropphyadd": "8 COURT ST",
    "dropphycty": "DELHI",
    "dropphyst": "NY",
    "dropphyzpp": 137539998,
    "dropmaladd": "8 COURT ST",
    "dropmalcty": "DELHI",
    "dropmalst": "NY",
    "dropmalzpp": 137539998,
    "dropsitphn": 6077462256,
    "dropsitlph": 6077462256,
    "dropsitcph": 6077462256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12906",
    "droptype": "D",
    "dropname": "DELMAR",
    "dropdeladd": "357 DELAWARE AVE",
    "dropdelcty": "DELMAR",
    "dropdelst": "NY",
    "dropdelzpp": 120549998,
    "dropphyadd": "357 DELAWARE AVE",
    "dropphycty": "DELMAR",
    "dropphyst": "NY",
    "dropphyzpp": 120549998,
    "dropmaladd": "357 DELAWARE AVE",
    "dropmalcty": "DELMAR",
    "dropmalst": "NY",
    "dropmalzpp": 120549998,
    "dropsitphn": 5184391933,
    "dropsitlph": 5184391933,
    "dropsitcph": 5184391933,
    "dropfax": 5184780249
  },
  {
    "dcode": "D",
    "dropkey": "PV12907",
    "droptype": "D",
    "dropname": "DELPHI FALLS",
    "dropdeladd": "2185 ORAN DELPHI RD",
    "dropdelcty": "DELPHI FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 130519998,
    "dropphyadd": "2185 ORAN DELPHI RD",
    "dropphycty": "DELPHI FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 130519998,
    "dropmaladd": "2185 ORAN DELPHI RD",
    "dropmalcty": "DELPHI FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 130519998,
    "dropsitphn": 3156627428,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156627428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12915",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "1375 DIMMICK MOUNTAIN RD",
    "dropdelcty": "DENVER",
    "dropdelst": "NY",
    "dropdelzpp": 124219998,
    "dropphyadd": "1375 DIMMICK MOUNTAIN RD",
    "dropphycty": "DENVER",
    "dropphyst": "NY",
    "dropphyzpp": 124219998,
    "dropmaladd": "1375 DIMMICK MOUNTAIN RD",
    "dropmalcty": "DENVER",
    "dropmalst": "NY",
    "dropmalzpp": 124219998,
    "dropsitphn": 9146974123,
    "dropsitlph": 6073264959,
    "dropsitcph": 6073264959,
    "dropfax": 6073264959
  },
  {
    "dcode": "D",
    "dropkey": "PV12916",
    "droptype": "D",
    "dropname": "DEPAUVILLE",
    "dropdeladd": "32523 STATE ROUTE 12",
    "dropdelcty": "DEPAUVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136329998,
    "dropphyadd": "32523 STATE ROUTE 12",
    "dropphycty": "DEPAUVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136329998,
    "dropmaladd": "32523 STATE ROUTE 12",
    "dropmalcty": "DEPAUVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136329998,
    "dropsitphn": 3156863040,
    "dropsitlph": 3156863040,
    "dropsitcph": 3156863040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12919",
    "droptype": "D",
    "dropname": "DEPEW",
    "dropdeladd": "165 WARSAW ST",
    "dropdelcty": "DEPEW",
    "dropdelst": "NY",
    "dropdelzpp": 140439998,
    "dropphyadd": "165 WARSAW ST",
    "dropphycty": "DEPEW",
    "dropphyst": "NY",
    "dropphyzpp": 140439998,
    "dropmaladd": "165 WARSAW ST",
    "dropmalcty": "DEPEW",
    "dropmalst": "NY",
    "dropmalzpp": 140439998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166832656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12921",
    "droptype": "D",
    "dropname": "DEPOSIT",
    "dropdeladd": "8 DEAN ST",
    "dropdelcty": "DEPOSIT",
    "dropdelst": "NY",
    "dropdelzpp": 137549998,
    "dropphyadd": "8 DEAN ST",
    "dropphycty": "DEPOSIT",
    "dropphyst": "NY",
    "dropphyzpp": 137549998,
    "dropmaladd": "8 DEAN ST",
    "dropmalcty": "DEPOSIT",
    "dropmalst": "NY",
    "dropmalzpp": 137549998,
    "dropsitphn": 6074672606,
    "dropsitlph": 6074672606,
    "dropsitcph": 6074672606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12923",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "7350 ERIE RD",
    "dropdelcty": "DERBY",
    "dropdelst": "NY",
    "dropdelzpp": 140479998,
    "dropphyadd": "7350 ERIE RD",
    "dropphycty": "DERBY",
    "dropphyst": "NY",
    "dropphyzpp": 140479998,
    "dropmaladd": "7350 ERIE RD",
    "dropmalcty": "DERBY",
    "dropmalst": "NY",
    "dropmalzpp": 140479998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169475550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12929",
    "droptype": "D",
    "dropname": "DEWITTVILLE",
    "dropdeladd": "5452 E LAKE RD",
    "dropdelcty": "DEWITTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147289998,
    "dropphyadd": "5452 E LAKE RD",
    "dropphycty": "DEWITTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147289998,
    "dropmaladd": "5452 E LAKE RD",
    "dropmalcty": "DEWITTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147289998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167537570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12932",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "612 BROWN ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "NY",
    "dropdelzpp": 136349998,
    "dropphyadd": "612 BROWN ST",
    "dropphycty": "DEXTER",
    "dropphyst": "NY",
    "dropphyzpp": 136349998,
    "dropmaladd": "612 BROWN ST",
    "dropmalcty": "DEXTER",
    "dropmalst": "NY",
    "dropmalzpp": 136349998,
    "dropsitphn": 3156396946,
    "dropsitlph": 3156396946,
    "dropsitcph": 3156396946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12935",
    "droptype": "D",
    "dropname": "DIAMOND POINT",
    "dropdeladd": "801 DIAMOND POINT RD",
    "dropdelcty": "DIAMOND POINT",
    "dropdelst": "NY",
    "dropdelzpp": 128242907,
    "dropphyadd": "801 DIAMOND POINT RD",
    "dropphycty": "DIAMOND POINT",
    "dropphyst": "NY",
    "dropphyzpp": 128242907,
    "dropmaladd": "801 DIAMOND POINT RD",
    "dropmalcty": "DIAMOND POINT",
    "dropmalst": "NY",
    "dropmalzpp": 128242907,
    "dropsitphn": 5186685521,
    "dropsitlph": 5186685521,
    "dropsitcph": 5186685521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12938",
    "droptype": "D",
    "dropname": "DICKINSON CENTER",
    "dropdeladd": "7 CHURCH ST",
    "dropdelcty": "DICKINSON CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 129309998,
    "dropphyadd": "7 CHURCH ST",
    "dropphycty": "DICKINSON CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 129309998,
    "dropmaladd": "7 CHURCH ST",
    "dropmalcty": "DICKINSON CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 129309998,
    "dropsitphn": 5188569681,
    "dropsitlph": 5188569681,
    "dropsitcph": 5188569681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12942",
    "droptype": "D",
    "dropname": "DOBBS FERRY",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "DOBBS FERRY",
    "dropdelst": "NY",
    "dropdelzpp": 105229998,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "DOBBS FERRY",
    "dropphyst": "NY",
    "dropphyzpp": 105229998,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "DOBBS FERRY",
    "dropmalst": "NY",
    "dropmalzpp": 105229998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146930451,
    "dropsitcph": 9146930451,
    "dropfax": 9146749681
  },
  {
    "dcode": "D",
    "dropkey": "PV12943",
    "droptype": "D",
    "dropname": "DOLGEVILLE",
    "dropdeladd": "41 S MAIN ST",
    "dropdelcty": "DOLGEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133299998,
    "dropphyadd": "41 S MAIN ST",
    "dropphycty": "DOLGEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133299998,
    "dropmaladd": "41 S MAIN ST",
    "dropmalcty": "DOLGEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133299998,
    "dropsitphn": 3154298221,
    "dropsitlph": 3154298221,
    "dropsitcph": 3154298221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12953",
    "droptype": "D",
    "dropname": "DOVER PLAINS",
    "dropdeladd": "3042 ROUTE 22",
    "dropdelcty": "DOVER PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 125229998,
    "dropphyadd": "3042 ROUTE 22",
    "dropphycty": "DOVER PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 125229998,
    "dropmaladd": "3042 ROUTE 22",
    "dropmalcty": "DOVER PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 125229998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458776953,
    "dropsitcph": 8458776953,
    "dropfax": 8458779071
  },
  {
    "dcode": "D",
    "dropkey": "PV12955",
    "droptype": "D",
    "dropname": "DOWNSVILLE",
    "dropdeladd": "15126 STATE HIGHWAY 30",
    "dropdelcty": "DOWNSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137559998,
    "dropphyadd": "15126 STATE HIGHWAY 30",
    "dropphycty": "DOWNSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137559998,
    "dropmaladd": "15126 STATE HIGHWAY 30",
    "dropmalcty": "DOWNSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137559998,
    "dropsitphn": 6073632266,
    "dropsitlph": 6073632266,
    "dropsitcph": 6073632266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12964",
    "droptype": "D",
    "dropname": "DRESDEN",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "DRESDEN",
    "dropdelst": "NY",
    "dropdelzpp": 144419998,
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "DRESDEN",
    "dropphyst": "NY",
    "dropphyzpp": 144419998,
    "dropmaladd": "60 MAIN ST",
    "dropmalcty": "DRESDEN",
    "dropmalst": "NY",
    "dropmalzpp": 144419998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155369435,
    "dropsitcph": 3155369435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12967",
    "droptype": "D",
    "dropname": "DRYDEN",
    "dropdeladd": "27 W MAIN ST",
    "dropdelcty": "DRYDEN",
    "dropdelst": "NY",
    "dropdelzpp": 130539998,
    "dropphyadd": "27 W MAIN ST",
    "dropphycty": "DRYDEN",
    "dropphyst": "NY",
    "dropphyzpp": 130539998,
    "dropmaladd": "27 W MAIN ST",
    "dropmalcty": "DRYDEN",
    "dropmalst": "NY",
    "dropmalzpp": 130539998,
    "dropsitphn": 6078449276,
    "dropsitlph": 5184522299,
    "dropsitcph": 6078449276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12969",
    "droptype": "D",
    "dropname": "DUANESBURG",
    "dropdeladd": "7000 DUANESBURG RD",
    "dropdelcty": "DUANESBURG",
    "dropdelst": "NY",
    "dropdelzpp": 120569998,
    "dropphyadd": "7000 DUANESBURG RD",
    "dropphycty": "DUANESBURG",
    "dropphyst": "NY",
    "dropphyzpp": 120569998,
    "dropmaladd": "7000 DUANESBURG RD",
    "dropmalcty": "DUANESBURG",
    "dropmalst": "NY",
    "dropmalzpp": 120569998,
    "dropsitphn": 5188958872,
    "dropsitlph": 5188958872,
    "dropsitcph": 5188958872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12974",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "26 MAIN ST",
    "dropdelcty": "DUNDEE",
    "dropdelst": "NY",
    "dropdelzpp": 148379998,
    "dropphyadd": "26 MAIN ST",
    "dropphycty": "DUNDEE",
    "dropphyst": "NY",
    "dropphyzpp": 148379998,
    "dropmaladd": "26 MAIN ST",
    "dropmalcty": "DUNDEE",
    "dropmalst": "NY",
    "dropmalzpp": 148379998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072438515,
    "dropsitcph": 6072438515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12977",
    "droptype": "D",
    "dropname": "DUNKIRK",
    "dropdeladd": "410 CENTRAL AVE",
    "dropdelcty": "DUNKIRK",
    "dropdelst": "NY",
    "dropdelzpp": 140489998,
    "dropphyadd": "410 CENTRAL AVE",
    "dropphycty": "DUNKIRK",
    "dropphyst": "NY",
    "dropphyzpp": 140489998,
    "dropmaladd": "410 CENTRAL AVE",
    "dropmalcty": "DUNKIRK",
    "dropmalst": "NY",
    "dropmalzpp": 140489998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163661780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV12981",
    "droptype": "D",
    "dropname": "DURHAMVILLE",
    "dropdeladd": "5346 CANAL ST",
    "dropdelcty": "DURHAMVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130549998,
    "dropphyadd": "5346 CANAL ST",
    "dropphycty": "DURHAMVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130549998,
    "dropmaladd": "5346 CANAL ST",
    "dropmalcty": "DURHAMVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130549998,
    "dropsitphn": 3153638870,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153638870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13040",
    "droptype": "D",
    "dropname": "EAGLE BAY",
    "dropdeladd": "102 EAST AVE",
    "dropdelcty": "EAGLE BAY",
    "dropdelst": "NY",
    "dropdelzpp": 133319998,
    "dropphyadd": "102 EAST AVE",
    "dropphycty": "EAGLE BAY",
    "dropphyst": "NY",
    "dropphyzpp": 133319998,
    "dropmaladd": "102 EAST AVE",
    "dropmalcty": "EAGLE BAY",
    "dropmalst": "NY",
    "dropmalzpp": 133319998,
    "dropsitphn": 3153573401,
    "dropsitlph": 3153573401,
    "dropsitcph": 3153573401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13041",
    "droptype": "D",
    "dropname": "EAGLE BRIDGE",
    "dropdeladd": "3902 STATE ROUTE 67",
    "dropdelcty": "EAGLE BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 120579998,
    "dropphyadd": "3902 STATE ROUTE 67",
    "dropphycty": "EAGLE BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 120579998,
    "dropmaladd": "3902 STATE ROUTE 67",
    "dropmalcty": "EAGLE BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 120579998,
    "dropsitphn": 5186867221,
    "dropsitlph": 5186867221,
    "dropsitcph": 5186867221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13046",
    "droptype": "D",
    "dropname": "EARLTON",
    "dropdeladd": "1504 ROUTE 81",
    "dropdelcty": "EARLTON",
    "dropdelst": "NY",
    "dropdelzpp": 120589998,
    "dropphyadd": "1504 ROUTE 81",
    "dropphycty": "EARLTON",
    "dropphyst": "NY",
    "dropphyzpp": 120589998,
    "dropmaladd": "1504 ROUTE 81",
    "dropmalcty": "EARLTON",
    "dropmalst": "NY",
    "dropmalzpp": 120589998,
    "dropsitphn": 5187318314,
    "dropsitlph": 5187318314,
    "dropsitcph": 5187318314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13047",
    "droptype": "D",
    "dropname": "EARLVILLE",
    "dropdeladd": "11 S MAIN ST",
    "dropdelcty": "EARLVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133329998,
    "dropphyadd": "11 S MAIN ST",
    "dropphycty": "EARLVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133329998,
    "dropmaladd": "11 S MAIN ST",
    "dropmalcty": "EARLVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133329998,
    "dropsitphn": 3156914141,
    "dropsitlph": 3156914141,
    "dropsitcph": 3156914141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13050",
    "droptype": "D",
    "dropname": "EAST AMHERST",
    "dropdeladd": "9830 TRANSIT RD",
    "dropdelcty": "EAST AMHERST",
    "dropdelst": "NY",
    "dropdelzpp": 140519998,
    "dropphyadd": "9830 TRANSIT RD",
    "dropphycty": "EAST AMHERST",
    "dropphyst": "NY",
    "dropphyzpp": 140519998,
    "dropmaladd": "9830 TRANSIT RD",
    "dropmalcty": "EAST AMHERST",
    "dropmalst": "NY",
    "dropmalzpp": 140519998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166889595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13052",
    "droptype": "D",
    "dropname": "EAST AURORA",
    "dropdeladd": "408 QUAKER RD",
    "dropdelcty": "EAST AURORA",
    "dropdelst": "NY",
    "dropdelzpp": 140529998,
    "dropphyadd": "408 QUAKER RD",
    "dropphycty": "EAST AURORA",
    "dropphyst": "NY",
    "dropphyzpp": 140529998,
    "dropmaladd": "408 QUAKER RD",
    "dropmalcty": "EAST AURORA",
    "dropmalst": "NY",
    "dropmalzpp": 140529998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166520172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13055",
    "droptype": "D",
    "dropname": "EAST BERNE",
    "dropdeladd": "873 HELDERBERG TRL",
    "dropdelcty": "EAST BERNE",
    "dropdelst": "NY",
    "dropdelzpp": 120599998,
    "dropphyadd": "873 HELDERBERG TRL",
    "dropphycty": "EAST BERNE",
    "dropphyst": "NY",
    "dropphyzpp": 120599998,
    "dropmaladd": "873 HELDERBERG TRL",
    "dropmalcty": "EAST BERNE",
    "dropmalst": "NY",
    "dropmalzpp": 120599998,
    "dropsitphn": 5188721244,
    "dropsitlph": 5188721244,
    "dropsitcph": 5188721244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13058",
    "droptype": "D",
    "dropname": "EAST BRANCH",
    "dropdeladd": "3979 O AND W RD",
    "dropdelcty": "EAST BRANCH",
    "dropdelst": "NY",
    "dropdelzpp": 137569998,
    "dropphyadd": "3979 O AND W RD",
    "dropphycty": "EAST BRANCH",
    "dropphyst": "NY",
    "dropphyzpp": 137569998,
    "dropmaladd": "3979 O AND W RD",
    "dropmalcty": "EAST BRANCH",
    "dropmalst": "NY",
    "dropmalzpp": 137569998,
    "dropsitphn": 6073632521,
    "dropsitlph": 6073632521,
    "dropsitcph": 6073632521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13060",
    "droptype": "D",
    "dropname": "EAST CHATHAM",
    "dropdeladd": "1111 STATE ROUTE 295",
    "dropdelcty": "EAST CHATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 120609998,
    "dropphyadd": "1111 STATE ROUTE 295",
    "dropphycty": "EAST CHATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 120609998,
    "dropmaladd": "1111 STATE ROUTE 295",
    "dropmalcty": "EAST CHATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 120609998,
    "dropsitphn": 5183925722,
    "dropsitlph": 5183925722,
    "dropsitcph": 5183925722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13061",
    "droptype": "D",
    "dropname": "EAST CONCORD",
    "dropdeladd": "12085 VAUGHN ST",
    "dropdelcty": "EAST CONCORD",
    "dropdelst": "NY",
    "dropdelzpp": 140559998,
    "dropphyadd": "12085 VAUGHN ST",
    "dropphycty": "EAST CONCORD",
    "dropphyst": "NY",
    "dropphyzpp": 140559998,
    "dropmaladd": "12085 VAUGHN ST",
    "dropmalcty": "EAST CONCORD",
    "dropmalst": "NY",
    "dropmalzpp": 140559998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165927598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13065",
    "droptype": "D",
    "dropname": "EAST DURHAM",
    "dropdeladd": "2355 ROUTE 145",
    "dropdelcty": "EAST DURHAM",
    "dropdelst": "NY",
    "dropdelzpp": 124239998,
    "dropphyadd": "2355 ROUTE 145",
    "dropphycty": "EAST DURHAM",
    "dropphyst": "NY",
    "dropphyzpp": 124239998,
    "dropmaladd": "2355 ROUTE 145",
    "dropmalcty": "EAST DURHAM",
    "dropmalst": "NY",
    "dropmalzpp": 124239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186342033,
    "dropsitcph": 5186342033,
    "dropfax": 5186342033
  },
  {
    "dcode": "D",
    "dropkey": "PV13075",
    "droptype": "D",
    "dropname": "EAST GREENBUSH",
    "dropdeladd": "10 GREENWOOD DR",
    "dropdelcty": "EAST GREENBUSH",
    "dropdelst": "NY",
    "dropdelzpp": 120619998,
    "dropphyadd": "10 GREENWOOD DR",
    "dropphycty": "EAST GREENBUSH",
    "dropphyst": "NY",
    "dropphyzpp": 120619998,
    "dropmaladd": "10 GREENWOOD DR",
    "dropmalcty": "EAST GREENBUSH",
    "dropmalst": "NY",
    "dropmalzpp": 120619998,
    "dropsitphn": 5184775212,
    "dropsitlph": 5184775212,
    "dropsitcph": 5184775212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13078",
    "droptype": "D",
    "dropname": "EAST HAMPTON",
    "dropdeladd": "12 GAY RD",
    "dropdelcty": "EAST HAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 119372747,
    "dropphyadd": "12 GAY RD",
    "dropphycty": "EAST HAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 119372747,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST HAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 119379998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313246320,
    "dropfax": 6313245385
  },
  {
    "dcode": "D",
    "dropkey": "PV13088",
    "droptype": "D",
    "dropname": "EAST ISLIP",
    "dropdeladd": "11 GREENWOOD AVE",
    "dropdelcty": "EAST ISLIP",
    "dropdelst": "NY",
    "dropdelzpp": 117302145,
    "dropphyadd": "11 GREENWOOD AVE",
    "dropphycty": "EAST ISLIP",
    "dropphyst": "NY",
    "dropphyzpp": 117302145,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST ISLIP",
    "dropmalst": "NY",
    "dropmalzpp": 117309998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315817807,
    "dropfax": 6312249064
  },
  {
    "dcode": "D",
    "dropkey": "PV13095",
    "droptype": "D",
    "dropname": "EAST MARION",
    "dropdeladd": "9165 MAIN RD",
    "dropdelcty": "EAST MARION",
    "dropdelst": "NY",
    "dropdelzpp": 119391538,
    "dropphyadd": "9165 MAIN RD",
    "dropphycty": "EAST MARION",
    "dropphyst": "NY",
    "dropphyzpp": 119391538,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST MARION",
    "dropmalst": "NY",
    "dropmalzpp": 119399998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314771668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13100",
    "droptype": "D",
    "dropname": "EAST MEREDITH",
    "dropdeladd": "51 COUNTY HIGHWAY 12",
    "dropdelcty": "EAST MEREDITH",
    "dropdelst": "NY",
    "dropdelzpp": 137579998,
    "dropphyadd": "51 COUNTY HIGHWAY 12",
    "dropphycty": "EAST MEREDITH",
    "dropphyst": "NY",
    "dropphyzpp": 137579998,
    "dropmaladd": "51 COUNTY HIGHWAY 12",
    "dropmalcty": "EAST MEREDITH",
    "dropmalst": "NY",
    "dropmalzpp": 137579998,
    "dropsitphn": 6072789938,
    "dropsitlph": 6072789938,
    "dropsitcph": 6072789938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13101",
    "droptype": "D",
    "dropname": "EAST MORICHES",
    "dropdeladd": "3 ATLANTIC AVE",
    "dropdelcty": "EAST MORICHES",
    "dropdelst": "NY",
    "dropdelzpp": 119401327,
    "dropphyadd": "3 ATLANTIC AVE",
    "dropphycty": "EAST MORICHES",
    "dropphyst": "NY",
    "dropphyzpp": 119401327,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST MORICHES",
    "dropmalst": "NY",
    "dropmalzpp": 119409998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6318780243,
    "dropfax": 6318744664
  },
  {
    "dcode": "D",
    "dropkey": "PV13102",
    "droptype": "D",
    "dropname": "EAST NASSAU",
    "dropdeladd": "6466 STATE ROUTE 66",
    "dropdelcty": "EAST NASSAU",
    "dropdelst": "NY",
    "dropdelzpp": 120629998,
    "dropphyadd": "6466 STATE ROUTE 66",
    "dropphycty": "EAST NASSAU",
    "dropphyst": "NY",
    "dropphyzpp": 120629998,
    "dropmaladd": "6466 STATE ROUTE 66",
    "dropmalcty": "EAST NASSAU",
    "dropmalst": "NY",
    "dropmalzpp": 120629998,
    "dropsitphn": 5187949741,
    "dropsitlph": 5187949741,
    "dropsitcph": 5187949741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13106",
    "droptype": "D",
    "dropname": "EAST NORTHPORT",
    "dropdeladd": "297 LARKFIELD RD",
    "dropdelcty": "EAST NORTHPORT",
    "dropdelst": "NY",
    "dropdelzpp": 117312449,
    "dropphyadd": "297 LARKFIELD RD",
    "dropphycty": "EAST NORTHPORT",
    "dropphyst": "NY",
    "dropphyzpp": 117312449,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST NORTHPORT",
    "dropmalst": "NY",
    "dropmalzpp": 117319998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313685632,
    "dropfax": 6313680027
  },
  {
    "dcode": "D",
    "dropkey": "PV13107",
    "droptype": "D",
    "dropname": "EAST NORWICH",
    "dropdeladd": "1001 OYSTER BAY RD",
    "dropdelcty": "EAST NORWICH",
    "dropdelst": "NY",
    "dropdelzpp": 117321003,
    "dropphyadd": "1001 OYSTER BAY RD",
    "dropphycty": "EAST NORWICH",
    "dropphyst": "NY",
    "dropphyzpp": 117321003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST NORWICH",
    "dropmalst": "NY",
    "dropmalzpp": 117329998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169228283,
    "dropfax": 5169224329
  },
  {
    "dcode": "D",
    "dropkey": "PV13109",
    "droptype": "D",
    "dropname": "EAST OTTO",
    "dropdeladd": "8991 REED HILL RD",
    "dropdelcty": "EAST OTTO",
    "dropdelst": "NY",
    "dropdelzpp": 147299998,
    "dropphyadd": "8991 REED HILL RD",
    "dropphycty": "EAST OTTO",
    "dropphyst": "NY",
    "dropphyzpp": 147299998,
    "dropmaladd": "8991 REED HILL RD",
    "dropmalcty": "EAST OTTO",
    "dropmalst": "NY",
    "dropmalzpp": 147299998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162573156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13114",
    "droptype": "D",
    "dropname": "EAST PEMBROKE",
    "dropdeladd": "8643 READ RD",
    "dropdelcty": "EAST PEMBROKE",
    "dropdelst": "NY",
    "dropdelzpp": 140569800,
    "dropphyadd": "8643 READ RD",
    "dropphycty": "EAST PEMBROKE",
    "dropphyst": "NY",
    "dropphyzpp": 140569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST PEMBROKE",
    "dropmalst": "NY",
    "dropmalzpp": 140569998,
    "dropsitphn": 5857571001,
    "dropsitlph": 5857571001,
    "dropsitcph": 5857571001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13118",
    "droptype": "D",
    "dropname": "EAST QUOGUE",
    "dropdeladd": "6 BAY AVE",
    "dropdelcty": "EAST QUOGUE",
    "dropdelst": "NY",
    "dropdelzpp": 119424351,
    "dropphyadd": "6 BAY AVE",
    "dropphycty": "EAST QUOGUE",
    "dropphyst": "NY",
    "dropphyzpp": 119424351,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST QUOGUE",
    "dropmalst": "NY",
    "dropmalzpp": 119429998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316535247,
    "dropfax": 6316536031
  },
  {
    "dcode": "D",
    "dropkey": "PV13120",
    "droptype": "D",
    "dropname": "EAST ROCHESTER",
    "dropdeladd": "206 W COMMERCIAL ST",
    "dropdelcty": "EAST ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 144459998,
    "dropphyadd": "206 W COMMERCIAL ST",
    "dropphycty": "EAST ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 144459998,
    "dropmaladd": "206 W COMMERCIAL ST",
    "dropmalcty": "EAST ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 144459998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855862978,
    "dropsitcph": 5855862978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13121",
    "droptype": "D",
    "dropname": "EAST ROCKAWAY",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "EAST ROCKAWAY",
    "dropdelst": "NY",
    "dropdelzpp": 115182065,
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "EAST ROCKAWAY",
    "dropphyst": "NY",
    "dropphyzpp": 115182065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST ROCKAWAY",
    "dropmalst": "NY",
    "dropmalzpp": 115189998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5165992157,
    "dropfax": 5165931530
  },
  {
    "dcode": "D",
    "dropkey": "PV13123",
    "droptype": "D",
    "dropname": "EAST SCHODACK",
    "dropdeladd": "1649 COLUMBIA TPKE",
    "dropdelcty": "EAST SCHODACK",
    "dropdelst": "NY",
    "dropdelzpp": 120639998,
    "dropphyadd": "1649 COLUMBIA TPKE",
    "dropphycty": "EAST SCHODACK",
    "dropphyst": "NY",
    "dropphyzpp": 120639998,
    "dropmaladd": "1649 COLUMBIA TPKE",
    "dropmalcty": "EAST SCHODACK",
    "dropmalst": "NY",
    "dropmalzpp": 120639998,
    "dropsitphn": 5184778462,
    "dropsitlph": 5184778462,
    "dropsitcph": 5184778462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13124",
    "droptype": "D",
    "dropname": "EAST SETAUKET",
    "dropdeladd": "450 ROUTE 25A",
    "dropdelcty": "EAST SETAUKET",
    "dropdelst": "NY",
    "dropdelzpp": 117332878,
    "dropphyadd": "450 ROUTE 25A",
    "dropphycty": "EAST SETAUKET",
    "dropphyst": "NY",
    "dropphyzpp": 117332878,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SETAUKET",
    "dropmalst": "NY",
    "dropmalzpp": 117339998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319414005,
    "dropfax": 6316892173
  },
  {
    "dcode": "D",
    "dropkey": "PV13134",
    "droptype": "D",
    "dropname": "EAST SYRACUSE",
    "dropdeladd": "404 W MANLIUS ST",
    "dropdelcty": "EAST SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 130579998,
    "dropphyadd": "404 W MANLIUS ST",
    "dropphycty": "EAST SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 130579998,
    "dropmaladd": "404 W MANLIUS ST",
    "dropmalcty": "EAST SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 130579998,
    "dropsitphn": 3154372113,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154372113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13141",
    "droptype": "D",
    "dropname": "EAST WILLIAMSON",
    "dropdeladd": "4995 RIDGE RD",
    "dropdelcty": "EAST WILLIAMSON",
    "dropdelst": "NY",
    "dropdelzpp": 144499800,
    "dropphyadd": "4995 RIDGE RD",
    "dropphycty": "EAST WILLIAMSON",
    "dropphyst": "NY",
    "dropphyzpp": 144499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST WILLIAMSON",
    "dropmalst": "NY",
    "dropmalzpp": 144499998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155898430,
    "dropsitcph": 3155898430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13146",
    "droptype": "D",
    "dropname": "EAST WORCESTER",
    "dropdeladd": "70 MAIN ST STE 1",
    "dropdelcty": "EAST WORCESTER",
    "dropdelst": "NY",
    "dropdelzpp": 120642029,
    "dropphyadd": "70 MAIN ST STE 1",
    "dropphycty": "EAST WORCESTER",
    "dropphyst": "NY",
    "dropphyzpp": 120642029,
    "dropmaladd": "70 MAIN ST STE 1",
    "dropmalcty": "EAST WORCESTER",
    "dropmalst": "NY",
    "dropmalzpp": 120649998,
    "dropsitphn": 6073978882,
    "dropsitlph": 6073978882,
    "dropsitcph": 6073978882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13152",
    "droptype": "D",
    "dropname": "EASTPORT",
    "dropdeladd": "24 EASTPORT MANOR RD",
    "dropdelcty": "EASTPORT",
    "dropdelst": "NY",
    "dropdelzpp": 119411412,
    "dropphyadd": "24 EASTPORT MANOR RD",
    "dropphycty": "EASTPORT",
    "dropphyst": "NY",
    "dropphyzpp": 119411412,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTPORT",
    "dropmalst": "NY",
    "dropmalzpp": 119419998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313251798,
    "dropfax": 6313252178
  },
  {
    "dcode": "D",
    "dropkey": "PV13157",
    "droptype": "D",
    "dropname": "EATON",
    "dropdeladd": "4084 STATE ROUTE 26",
    "dropdelcty": "EATON",
    "dropdelst": "NY",
    "dropdelzpp": 133349998,
    "dropphyadd": "4084 STATE ROUTE 26",
    "dropphycty": "EATON",
    "dropphyst": "NY",
    "dropphyzpp": 133349998,
    "dropmaladd": "4084 STATE ROUTE 26",
    "dropmalcty": "EATON",
    "dropmalst": "NY",
    "dropmalzpp": 133349998,
    "dropsitphn": 3156849500,
    "dropsitlph": 3156849500,
    "dropsitcph": 3156849500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13163",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "8230 N MAIN ST",
    "dropdelcty": "EDEN",
    "dropdelst": "NY",
    "dropdelzpp": 140579998,
    "dropphyadd": "8230 N MAIN ST",
    "dropphycty": "EDEN",
    "dropphyst": "NY",
    "dropphyzpp": 140579998,
    "dropmaladd": "8230 N MAIN ST",
    "dropmalcty": "EDEN",
    "dropmalst": "NY",
    "dropmalzpp": 140579998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169923875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13170",
    "droptype": "D",
    "dropname": "EDMESTON",
    "dropdeladd": "3 WEST ST",
    "dropdelcty": "EDMESTON",
    "dropdelst": "NY",
    "dropdelzpp": 133359998,
    "dropphyadd": "3 WEST ST",
    "dropphycty": "EDMESTON",
    "dropphyst": "NY",
    "dropphyzpp": 133359998,
    "dropmaladd": "3 WEST ST",
    "dropmalcty": "EDMESTON",
    "dropmalst": "NY",
    "dropmalzpp": 133359998,
    "dropsitphn": 6079658445,
    "dropsitlph": 6079658445,
    "dropsitcph": 6079658445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13172",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "196 MAIN ST",
    "dropdelcty": "EDWARDS",
    "dropdelst": "NY",
    "dropdelzpp": 136359998,
    "dropphyadd": "196 MAIN ST",
    "dropphycty": "EDWARDS",
    "dropphyst": "NY",
    "dropphyzpp": 136359998,
    "dropmaladd": "196 MAIN ST",
    "dropmalcty": "EDWARDS",
    "dropmalst": "NY",
    "dropmalzpp": 136359998,
    "dropsitphn": 3155623200,
    "dropsitlph": 3155623200,
    "dropsitcph": 3155623200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13177",
    "droptype": "D",
    "dropname": "ELBA",
    "dropdeladd": "7 N MAIN ST",
    "dropdelcty": "ELBA",
    "dropdelst": "NY",
    "dropdelzpp": 140589998,
    "dropphyadd": "7 N MAIN ST",
    "dropphycty": "ELBA",
    "dropphyst": "NY",
    "dropphyzpp": 140589998,
    "dropmaladd": "7 N MAIN ST",
    "dropmalcty": "ELBA",
    "dropmalst": "NY",
    "dropmalzpp": 140589998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5857579391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13178",
    "droptype": "D",
    "dropname": "ELBRIDGE",
    "dropdeladd": "106 SOUTH ST",
    "dropdelcty": "ELBRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 130609998,
    "dropphyadd": "106 SOUTH ST",
    "dropphycty": "ELBRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 130609998,
    "dropmaladd": "106 SOUTH ST",
    "dropmalcty": "ELBRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 130609998,
    "dropsitphn": 3156606004,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156606004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13179",
    "droptype": "D",
    "dropname": "ELDRED",
    "dropdeladd": "12 PROCTOR RD STE 1",
    "dropdelcty": "ELDRED",
    "dropdelst": "NY",
    "dropdelzpp": 127329998,
    "dropphyadd": "12 PROCTOR RD STE 1",
    "dropphycty": "ELDRED",
    "dropphyst": "NY",
    "dropphyzpp": 127329998,
    "dropmaladd": "12 PROCTOR RD STE 1",
    "dropmalcty": "ELDRED",
    "dropmalst": "NY",
    "dropmalzpp": 127329998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455578421,
    "dropsitcph": 8455578421,
    "dropfax": 8455570347
  },
  {
    "dcode": "D",
    "dropkey": "PV13180",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "190 WATER ST",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 129329998,
    "dropphyadd": "190 WATER ST",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 129329998,
    "dropmaladd": "190 WATER ST",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 129329998,
    "dropsitphn": 5188736461,
    "dropsitlph": 5188736461,
    "dropsitcph": 5188736461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13181",
    "droptype": "D",
    "dropname": "ELIZAVILLE",
    "dropdeladd": "673 COUNTY ROUTE 2",
    "dropdelcty": "ELIZAVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125239998,
    "dropphyadd": "673 COUNTY ROUTE 2",
    "dropphycty": "ELIZAVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125239998,
    "dropmaladd": "673 COUNTY ROUTE 2",
    "dropmalcty": "ELIZAVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457565026,
    "dropsitcph": 8457565026,
    "dropfax": 8457562014
  },
  {
    "dcode": "D",
    "dropkey": "PV13185",
    "droptype": "D",
    "dropname": "ELKA PARK",
    "dropdeladd": "183 ELKA PARK RD",
    "dropdelcty": "ELKA PARK",
    "dropdelst": "NY",
    "dropdelzpp": 124279998,
    "dropphyadd": "183 ELKA PARK RD",
    "dropphycty": "ELKA PARK",
    "dropphyst": "NY",
    "dropphyzpp": 124279998,
    "dropmaladd": "183 ELKA PARK RD",
    "dropmalcty": "ELKA PARK",
    "dropmalst": "NY",
    "dropmalzpp": 124279998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5185896298,
    "dropsitcph": 5185896298,
    "dropfax": 5185896298
  },
  {
    "dcode": "D",
    "dropkey": "PV13188",
    "droptype": "D",
    "dropname": "ELLENBURG",
    "dropdeladd": "16 ST EDMUNDS WAY",
    "dropdelcty": "ELLENBURG",
    "dropdelst": "NY",
    "dropdelzpp": 129339998,
    "dropphyadd": "16 ST EDMUNDS WAY",
    "dropphycty": "ELLENBURG",
    "dropphyst": "NY",
    "dropphyzpp": 129339998,
    "dropmaladd": "16 ST EDMUNDS WAY",
    "dropmalcty": "ELLENBURG",
    "dropmalst": "NY",
    "dropmalzpp": 129339998,
    "dropsitphn": 5185947128,
    "dropsitlph": 5185947128,
    "dropsitcph": 5185947128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13189",
    "droptype": "D",
    "dropname": "ELLENBURG CENTER",
    "dropdeladd": "40 BRANDY BROOK RD",
    "dropdelcty": "ELLENBURG CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 129341901,
    "dropphyadd": "40 BRANDY BROOK RD",
    "dropphycty": "ELLENBURG CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 129341901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLENBURG CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 129349998,
    "dropsitphn": 5185947011,
    "dropsitlph": 5185947011,
    "dropsitcph": 5185947011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13191",
    "droptype": "D",
    "dropname": "ELLENBURG DEPOT",
    "dropdeladd": "4959 STATE ROUTE 11",
    "dropdelcty": "ELLENBURG DEPOT",
    "dropdelst": "NY",
    "dropdelzpp": 129359998,
    "dropphyadd": "4959 STATE ROUTE 11",
    "dropphycty": "ELLENBURG DEPOT",
    "dropphyst": "NY",
    "dropphyzpp": 129359998,
    "dropmaladd": "4959 STATE ROUTE 11",
    "dropmalcty": "ELLENBURG DEPOT",
    "dropmalst": "NY",
    "dropmalzpp": 129359998,
    "dropsitphn": 5185943940,
    "dropsitlph": 5185943940,
    "dropsitcph": 5185943940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13192",
    "droptype": "D",
    "dropname": "ELLENVILLE",
    "dropdeladd": "1 LIBERTY SQ",
    "dropdelcty": "ELLENVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124289998,
    "dropphyadd": "1 LIBERTY SQ",
    "dropphycty": "ELLENVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124289998,
    "dropmaladd": "1 LIBERTY SQ",
    "dropmalcty": "ELLENVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124289998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456479584,
    "dropsitcph": 8456479584,
    "dropfax": 8456471787
  },
  {
    "dcode": "D",
    "dropkey": "PV13197",
    "droptype": "D",
    "dropname": "ELLICOTTVILLE",
    "dropdeladd": "4 WASHINGTON ST",
    "dropdelcty": "ELLICOTTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147319998,
    "dropphyadd": "4 WASHINGTON ST",
    "dropphycty": "ELLICOTTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147319998,
    "dropmaladd": "4 WASHINGTON ST",
    "dropmalcty": "ELLICOTTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147319998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166992598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13200",
    "droptype": "D",
    "dropname": "ELLINGTON",
    "dropdeladd": "5006 MILL ST",
    "dropdelcty": "ELLINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 147329800,
    "dropphyadd": "5006 MILL ST",
    "dropphycty": "ELLINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 147329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 147329998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162872042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13202",
    "droptype": "D",
    "dropname": "ELLISBURG",
    "dropdeladd": "12109 STATE ROUTE 193",
    "dropdelcty": "ELLISBURG",
    "dropdelst": "NY",
    "dropdelzpp": 136369998,
    "dropphyadd": "12109 STATE ROUTE 193",
    "dropphycty": "ELLISBURG",
    "dropphyst": "NY",
    "dropphyzpp": 136369998,
    "dropmaladd": "12109 STATE ROUTE 193",
    "dropmalcty": "ELLISBURG",
    "dropmalst": "NY",
    "dropmalzpp": 136369998,
    "dropsitphn": 3158465511,
    "dropsitlph": 3158465511,
    "dropsitcph": 3158465511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13205",
    "droptype": "D",
    "dropname": "ELMA",
    "dropdeladd": "2300 BOWEN RD",
    "dropdelcty": "ELMA",
    "dropdelst": "NY",
    "dropdelzpp": 140599998,
    "dropphyadd": "2300 BOWEN RD",
    "dropphycty": "ELMA",
    "dropphyst": "NY",
    "dropphyzpp": 140599998,
    "dropmaladd": "2300 BOWEN RD",
    "dropmalcty": "ELMA",
    "dropmalst": "NY",
    "dropmalzpp": 140599998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166523937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13213",
    "droptype": "D",
    "dropname": "ELMIRA",
    "dropdeladd": "1580 SULLIVAN ST",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149019998,
    "dropphyadd": "1580 SULLIVAN ST",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149019998,
    "dropmaladd": "1580 SULLIVAN ST",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077375116,
    "dropsitcph": 6077375108,
    "dropfax": 6077326207
  },
  {
    "dcode": "D",
    "dropkey": "PV13220",
    "droptype": "D",
    "dropname": "ELMSFORD",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "ELMSFORD",
    "dropdelst": "NY",
    "dropdelzpp": 105232600,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "ELMSFORD",
    "dropphyst": "NY",
    "dropphyzpp": 105232600,
    "dropmaladd": "150 CLEARBROOK RD STE 124",
    "dropmalcty": "ELMSFORD",
    "dropmalst": "NY",
    "dropmalzpp": 105239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145920968,
    "dropsitcph": 9145920968,
    "dropfax": 9145921629
  },
  {
    "dcode": "D",
    "dropkey": "PV13239",
    "droptype": "D",
    "dropname": "ENDICOTT",
    "dropdeladd": "200 WASHINGTON AVE",
    "dropdelcty": "ENDICOTT",
    "dropdelst": "NY",
    "dropdelzpp": 137609998,
    "dropphyadd": "200 WASHINGTON AVE",
    "dropphycty": "ENDICOTT",
    "dropphyst": "NY",
    "dropphyzpp": 137609998,
    "dropmaladd": "200 WASHINGTON AVE",
    "dropmalcty": "ENDICOTT",
    "dropmalst": "NY",
    "dropmalzpp": 137609998,
    "dropsitphn": 6077488207,
    "dropsitlph": 6077488207,
    "dropsitcph": 6077488207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13242",
    "droptype": "D",
    "dropname": "ERIEVILLE",
    "dropdeladd": "3643 EATONBROOK RD",
    "dropdelcty": "ERIEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130619998,
    "dropphyadd": "3643 EATONBROOK RD",
    "dropphycty": "ERIEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130619998,
    "dropmaladd": "3643 EATONBROOK RD",
    "dropmalcty": "ERIEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130619998,
    "dropsitphn": 3156627410,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156627410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13245",
    "droptype": "D",
    "dropname": "ERIN",
    "dropdeladd": "336 WHEATON RD",
    "dropdelcty": "ERIN",
    "dropdelst": "NY",
    "dropdelzpp": 148389998,
    "dropphyadd": "336 WHEATON RD",
    "dropphycty": "ERIN",
    "dropphyst": "NY",
    "dropphyzpp": 148389998,
    "dropmaladd": "336 WHEATON RD",
    "dropmalcty": "ERIN",
    "dropmalst": "NY",
    "dropmalzpp": 148389998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077398020,
    "dropsitcph": 6077398020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13246",
    "droptype": "D",
    "dropname": "ESOPUS",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "ESOPUS",
    "dropdelst": "NY",
    "dropdelzpp": 124299800,
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "ESOPUS",
    "dropphyst": "NY",
    "dropphyzpp": 124299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESOPUS",
    "dropmalst": "NY",
    "dropmalzpp": 124299998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453846808,
    "dropsitcph": 8453846808,
    "dropfax": 8453846808
  },
  {
    "dcode": "D",
    "dropkey": "PV13247",
    "droptype": "D",
    "dropname": "ESPERANCE",
    "dropdeladd": "170 MAIN ST",
    "dropdelcty": "ESPERANCE",
    "dropdelst": "NY",
    "dropdelzpp": 120669998,
    "dropphyadd": "170 MAIN ST",
    "dropphycty": "ESPERANCE",
    "dropphyst": "NY",
    "dropphyzpp": 120669998,
    "dropmaladd": "170 MAIN ST",
    "dropmalcty": "ESPERANCE",
    "dropmalst": "NY",
    "dropmalzpp": 120669998,
    "dropsitphn": 5188756731,
    "dropsitlph": 5188756731,
    "dropsitcph": 5188756731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13250",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "2303 MAIN ST",
    "dropdelcty": "ESSEX",
    "dropdelst": "NY",
    "dropdelzpp": 129369998,
    "dropphyadd": "2303 MAIN ST",
    "dropphycty": "ESSEX",
    "dropphyst": "NY",
    "dropphyzpp": 129369998,
    "dropmaladd": "2303 MAIN ST",
    "dropmalcty": "ESSEX",
    "dropmalst": "NY",
    "dropmalzpp": 129369998,
    "dropsitphn": 5189637285,
    "dropsitlph": 5189637285,
    "dropsitcph": 5189637285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13251",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "2 LOWER CREEK RD",
    "dropdelcty": "ETNA",
    "dropdelst": "NY",
    "dropdelzpp": 130629998,
    "dropphyadd": "2 LOWER CREEK RD",
    "dropphycty": "ETNA",
    "dropphyst": "NY",
    "dropphyzpp": 130629998,
    "dropmaladd": "2 LOWER CREEK RD",
    "dropmalcty": "ETNA",
    "dropmalst": "NY",
    "dropmalzpp": 130629998,
    "dropsitphn": 6073474763,
    "dropsitlph": 5184522299,
    "dropsitcph": 6073474763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13256",
    "droptype": "D",
    "dropname": "EVANS MILLS",
    "dropdeladd": "8496 LERAY ST",
    "dropdelcty": "EVANS MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 136379998,
    "dropphyadd": "8496 LERAY ST",
    "dropphycty": "EVANS MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 136379998,
    "dropmaladd": "8496 LERAY ST",
    "dropmalcty": "EVANS MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 136379998,
    "dropsitphn": 3156294820,
    "dropsitlph": 3156294820,
    "dropsitcph": 3156294820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13261",
    "droptype": "D",
    "dropname": "FABIUS",
    "dropdeladd": "1306 KEENEY RD",
    "dropdelcty": "FABIUS",
    "dropdelst": "NY",
    "dropdelzpp": 130639998,
    "dropphyadd": "1306 KEENEY RD",
    "dropphycty": "FABIUS",
    "dropphyst": "NY",
    "dropphyzpp": 130639998,
    "dropmaladd": "1306 KEENEY RD",
    "dropmalcty": "FABIUS",
    "dropmalst": "NY",
    "dropmalzpp": 130639998,
    "dropsitphn": 3156835257,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156835257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13265",
    "droptype": "D",
    "dropname": "FAIR HAVEN",
    "dropdeladd": "14452 FANCHER AVE",
    "dropdelcty": "FAIR HAVEN",
    "dropdelst": "NY",
    "dropdelzpp": 130649998,
    "dropphyadd": "14452 FANCHER AVE",
    "dropphycty": "FAIR HAVEN",
    "dropphyst": "NY",
    "dropphyzpp": 130649998,
    "dropmaladd": "14452 FANCHER AVE",
    "dropmalcty": "FAIR HAVEN",
    "dropmalst": "NY",
    "dropmalzpp": 130649998,
    "dropsitphn": 3159475747,
    "dropsitlph": 5184522299,
    "dropsitcph": 3159475747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13271",
    "droptype": "D",
    "dropname": "FAIRPORT",
    "dropdeladd": "770 AYRAULT RD",
    "dropdelcty": "FAIRPORT",
    "dropdelst": "NY",
    "dropdelzpp": 144509998,
    "dropphyadd": "770 AYRAULT RD",
    "dropphycty": "FAIRPORT",
    "dropphyst": "NY",
    "dropphyzpp": 144509998,
    "dropmaladd": "770 AYRAULT RD",
    "dropmalcty": "FAIRPORT",
    "dropmalst": "NY",
    "dropmalzpp": 144509998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852239650,
    "dropsitcph": 5852239650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13272",
    "droptype": "D",
    "dropname": "FALCONER",
    "dropdeladd": "5 W EVERETT ST",
    "dropdelcty": "FALCONER",
    "dropdelst": "NY",
    "dropdelzpp": 147339998,
    "dropphyadd": "5 W EVERETT ST",
    "dropphycty": "FALCONER",
    "dropphyst": "NY",
    "dropphyzpp": 147339998,
    "dropmaladd": "5 W EVERETT ST",
    "dropmalcty": "FALCONER",
    "dropmalst": "NY",
    "dropmalzpp": 147339998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166652403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13274",
    "droptype": "D",
    "dropname": "FALLSBURG",
    "dropdeladd": "5672 STATE ROUTE 42",
    "dropdelcty": "FALLSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 127339998,
    "dropphyadd": "5672 STATE ROUTE 42",
    "dropphycty": "FALLSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 127339998,
    "dropmaladd": "5672 STATE ROUTE 42",
    "dropmalcty": "FALLSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 127339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454346318,
    "dropsitcph": 8454346318,
    "dropfax": 8454345075
  },
  {
    "dcode": "D",
    "dropkey": "PV13275",
    "droptype": "D",
    "dropname": "FANCHER",
    "dropdeladd": "15865 MILLION DOLLAR HWY",
    "dropdelcty": "FANCHER",
    "dropdelst": "NY",
    "dropdelzpp": 144529800,
    "dropphyadd": "15865 MILLION DOLLAR HWY",
    "dropphycty": "FANCHER",
    "dropphyst": "NY",
    "dropphyzpp": 144529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FANCHER",
    "dropmalst": "NY",
    "dropmalzpp": 144529998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856385055,
    "dropsitcph": 5856385055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13276",
    "droptype": "D",
    "dropname": "FAR ROCKAWAY",
    "dropdeladd": "1836 MOTT AVE",
    "dropdelcty": "FAR ROCKAWAY",
    "dropdelst": "NY",
    "dropdelzpp": 116919998,
    "dropphyadd": "1836 MOTT AVE",
    "dropphycty": "FAR ROCKAWAY",
    "dropphyst": "NY",
    "dropphyzpp": 116919998,
    "dropmaladd": "1836 MOTT AVE",
    "dropmalcty": "FAR ROCKAWAY",
    "dropmalst": "NY",
    "dropmalzpp": 116919998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3474872020,
    "dropfax": 3473274398
  },
  {
    "dcode": "D",
    "dropkey": "PV13281",
    "droptype": "D",
    "dropname": "FARMERSVILLE STATION",
    "dropdeladd": "994 ELTON RD",
    "dropdelcty": "FARMERSVILLE STATION",
    "dropdelst": "NY",
    "dropdelzpp": 140609998,
    "dropphyadd": "994 ELTON RD",
    "dropphycty": "FARMERSVILLE STATION",
    "dropphyst": "NY",
    "dropphyzpp": 140609998,
    "dropmaladd": "994 ELTON RD",
    "dropmalcty": "FARMERSVILLE STATION",
    "dropmalst": "NY",
    "dropmalzpp": 140609998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5856763011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13282",
    "droptype": "D",
    "dropname": "FARMINGDALE",
    "dropdeladd": "380 MAIN ST",
    "dropdelcty": "FARMINGDALE",
    "dropdelst": "NY",
    "dropdelzpp": 117353590,
    "dropphyadd": "380 MAIN ST",
    "dropphycty": "FARMINGDALE",
    "dropphyst": "NY",
    "dropphyzpp": 117353590,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGDALE",
    "dropmalst": "NY",
    "dropmalzpp": 117359998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162491552,
    "dropfax": 5162491089
  },
  {
    "dcode": "D",
    "dropkey": "PV13286",
    "droptype": "D",
    "dropname": "FARMINGVILLE",
    "dropdeladd": "500 HORSEBLOCK RD",
    "dropdelcty": "FARMINGVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117381239,
    "dropphyadd": "500 HORSEBLOCK RD",
    "dropphycty": "FARMINGVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117381239,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117389998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317328625,
    "dropfax": 6316969158
  },
  {
    "dcode": "D",
    "dropkey": "PV13289",
    "droptype": "D",
    "dropname": "FARNHAM",
    "dropdeladd": "461 COMMERCIAL ST",
    "dropdelcty": "FARNHAM",
    "dropdelst": "NY",
    "dropdelzpp": 140619800,
    "dropphyadd": "461 COMMERCIAL ST",
    "dropphycty": "FARNHAM",
    "dropphyst": "NY",
    "dropphyzpp": 140619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARNHAM",
    "dropmalst": "NY",
    "dropmalzpp": 140619998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165495170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13291",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "4346 STATE ROUTE 414",
    "dropdelcty": "FAYETTE",
    "dropdelst": "NY",
    "dropdelzpp": 130659998,
    "dropphyadd": "4346 STATE ROUTE 414",
    "dropphycty": "FAYETTE",
    "dropphyst": "NY",
    "dropphyzpp": 130659998,
    "dropmaladd": "4346 STATE ROUTE 414",
    "dropmalcty": "FAYETTE",
    "dropmalst": "NY",
    "dropmalzpp": 130659998,
    "dropsitphn": 3155498854,
    "dropsitlph": 5184522299,
    "dropsitcph": 3155498854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13292",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "599 E GENESEE ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130669998,
    "dropphyadd": "599 E GENESEE ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130669998,
    "dropmaladd": "599 E GENESEE ST",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130669998,
    "dropsitphn": 3156376761,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156376761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13304",
    "droptype": "D",
    "dropname": "FELTS MILLS",
    "dropdeladd": "24456 MAIN ST",
    "dropdelcty": "FELTS MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 136389998,
    "dropphyadd": "24456 MAIN ST",
    "dropphycty": "FELTS MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 136389998,
    "dropmaladd": "24456 MAIN ST",
    "dropmalcty": "FELTS MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 136389998,
    "dropsitphn": 3157734435,
    "dropsitlph": 3157734435,
    "dropsitcph": 3157734435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13309",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "108 SULLIVAN AVE",
    "dropdelcty": "FERNDALE",
    "dropdelst": "NY",
    "dropdelzpp": 127344398,
    "dropphyadd": "108 SULLIVAN AVE",
    "dropphycty": "FERNDALE",
    "dropphyst": "NY",
    "dropphyzpp": 127344398,
    "dropmaladd": "108 SULLIVAN AVE",
    "dropmalcty": "FERNDALE",
    "dropmalst": "NY",
    "dropmalzpp": 127344398,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452925281,
    "dropsitcph": 8452925281,
    "dropfax": 8452955281
  },
  {
    "dcode": "D",
    "dropkey": "PV13312",
    "droptype": "D",
    "dropname": "FEURA BUSH",
    "dropdeladd": "1380 INDIAN FIELDS RD",
    "dropdelcty": "FEURA BUSH",
    "dropdelst": "NY",
    "dropdelzpp": 120679998,
    "dropphyadd": "1380 INDIAN FIELDS RD",
    "dropphycty": "FEURA BUSH",
    "dropphyst": "NY",
    "dropphyzpp": 120679998,
    "dropmaladd": "1380 INDIAN FIELDS RD",
    "dropmalcty": "FEURA BUSH",
    "dropmalst": "NY",
    "dropmalzpp": 120679998,
    "dropsitphn": 5184392497,
    "dropsitlph": 5184392497,
    "dropsitcph": 5184392497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13316",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "54 W MAIN ST",
    "dropdelcty": "FILLMORE",
    "dropdelst": "NY",
    "dropdelzpp": 147359800,
    "dropphyadd": "54 W MAIN ST",
    "dropphycty": "FILLMORE",
    "dropphyst": "NY",
    "dropphyzpp": 147359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FILLMORE",
    "dropmalst": "NY",
    "dropmalzpp": 147359998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855678588,
    "dropfax": 5855674452
  },
  {
    "dcode": "D",
    "dropkey": "PV13317",
    "droptype": "D",
    "dropname": "FINDLEY LAKE",
    "dropdeladd": "10404 MAIN ST",
    "dropdelcty": "FINDLEY LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 147369998,
    "dropphyadd": "10404 MAIN ST",
    "dropphycty": "FINDLEY LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 147369998,
    "dropmaladd": "10404 MAIN ST",
    "dropmalcty": "FINDLEY LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 147369998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167697317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13319",
    "droptype": "D",
    "dropname": "FINE",
    "dropdeladd": "8 SPRING ST",
    "dropdelcty": "FINE",
    "dropdelst": "NY",
    "dropdelzpp": 136399998,
    "dropphyadd": "8 SPRING ST",
    "dropphycty": "FINE",
    "dropphyst": "NY",
    "dropphyzpp": 136399998,
    "dropmaladd": "8 SPRING ST",
    "dropmalcty": "FINE",
    "dropmalst": "NY",
    "dropmalzpp": 136399998,
    "dropsitphn": 3158483442,
    "dropsitlph": 3158483442,
    "dropsitcph": 3158483442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13320",
    "droptype": "D",
    "dropname": "FINEVIEW",
    "dropdeladd": "44392 COUNTY ROUTE 191",
    "dropdelcty": "WELLESLEY ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 136409998,
    "dropphyadd": "44392 COUNTY ROUTE 191",
    "dropphycty": "WELLESLEY ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 136409998,
    "dropmaladd": "44392 COUNTY ROUTE 191",
    "dropmalcty": "WELLESLEY ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 136409998,
    "dropsitphn": 3154823700,
    "dropsitlph": 3154823700,
    "dropsitcph": 3154823700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13332",
    "droptype": "D",
    "dropname": "FISHERS",
    "dropdeladd": "7839 MAIN ST",
    "dropdelcty": "FISHERS",
    "dropdelst": "NY",
    "dropdelzpp": 144539800,
    "dropphyadd": "7839 MAIN ST",
    "dropphycty": "FISHERS",
    "dropphyst": "NY",
    "dropphyzpp": 144539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FISHERS",
    "dropmalst": "NY",
    "dropmalzpp": 144539998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5859247270,
    "dropsitcph": 5859247270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13333",
    "droptype": "D",
    "dropname": "FISHERS LANDING",
    "dropdeladd": "18064 REEDS POINT RD",
    "dropdelcty": "FISHERS LANDING",
    "dropdelst": "NY",
    "dropdelzpp": 136419998,
    "dropphyadd": "18064 REEDS POINT RD",
    "dropphycty": "FISHERS LANDING",
    "dropphyst": "NY",
    "dropphyzpp": 136419998,
    "dropmaladd": "18064 REEDS POINT RD",
    "dropmalcty": "FISHERS LANDING",
    "dropmalst": "NY",
    "dropmalzpp": 136419998,
    "dropsitphn": 3156865008,
    "dropsitlph": 3156865008,
    "dropsitcph": 3156865008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13335",
    "droptype": "D",
    "dropname": "FISHKILL",
    "dropdeladd": "1018 MAIN ST",
    "dropdelcty": "FISHKILL",
    "dropdelst": "NY",
    "dropdelzpp": 125249998,
    "dropphyadd": "1018 MAIN ST",
    "dropphycty": "FISHKILL",
    "dropphyst": "NY",
    "dropphyzpp": 125249998,
    "dropmaladd": "1018 MAIN ST",
    "dropmalcty": "FISHKILL",
    "dropmalst": "NY",
    "dropmalzpp": 125249998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458967863,
    "dropsitcph": 8458967863,
    "dropfax": 8458969329
  },
  {
    "dcode": "D",
    "dropkey": "PV13337",
    "droptype": "D",
    "dropname": "FISHS EDDY",
    "dropdeladd": "252 POST OFFICE ST",
    "dropdelcty": "FISHS EDDY",
    "dropdelst": "NY",
    "dropdelzpp": 137749998,
    "dropphyadd": "252 POST OFFICE ST",
    "dropphycty": "FISHS EDDY",
    "dropphyst": "NY",
    "dropphyzpp": 137749998,
    "dropmaladd": "252 POST OFFICE ST",
    "dropmalcty": "FISHS EDDY",
    "dropmalst": "NY",
    "dropmalzpp": 137749998,
    "dropsitphn": 6076375205,
    "dropsitlph": 6076375205,
    "dropsitcph": 6076375205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13349",
    "droptype": "D",
    "dropname": "FLEISCHMANNS",
    "dropdeladd": "1050 MAIN ST",
    "dropdelcty": "FLEISCHMANNS",
    "dropdelst": "NY",
    "dropdelzpp": 124309998,
    "dropphyadd": "1050 MAIN ST",
    "dropphycty": "FLEISCHMANNS",
    "dropphyst": "NY",
    "dropphyzpp": 124309998,
    "dropmaladd": "1050 MAIN ST",
    "dropmalcty": "FLEISCHMANNS",
    "dropmalst": "NY",
    "dropmalzpp": 124309998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452546947,
    "dropsitcph": 8452546947,
    "dropfax": 8452546947
  },
  {
    "dcode": "D",
    "dropkey": "PV13352",
    "droptype": "D",
    "dropname": "FLORAL PARK",
    "dropdeladd": "35 TULIP AVE",
    "dropdelcty": "FLORAL PARK",
    "dropdelst": "NY",
    "dropdelzpp": 110019998,
    "dropphyadd": "35 TULIP AVE",
    "dropphycty": "FLORAL PARK",
    "dropphyst": "NY",
    "dropphyzpp": 110019998,
    "dropmaladd": "35 TULIP AVE",
    "dropmalcty": "FLORAL PARK",
    "dropmalst": "NY",
    "dropmalzpp": 110019998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5164376621,
    "dropfax": 5163543747
  },
  {
    "dcode": "D",
    "dropkey": "PV13355",
    "droptype": "D",
    "dropname": "FLORIDA",
    "dropdeladd": "15 EDWARD J LEMPKA DR",
    "dropdelcty": "FLORIDA",
    "dropdelst": "NY",
    "dropdelzpp": 109219998,
    "dropphyadd": "15 EDWARD J LEMPKA DR",
    "dropphycty": "FLORIDA",
    "dropphyst": "NY",
    "dropphyzpp": 109219998,
    "dropmaladd": "15 EDWARD J LEMPKA DR",
    "dropmalcty": "FLORIDA",
    "dropmalst": "NY",
    "dropmalzpp": 109219998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456510044,
    "dropsitcph": 8456510044,
    "dropfax": 8456517853
  },
  {
    "dcode": "D",
    "dropkey": "PV13365",
    "droptype": "D",
    "dropname": "FLUSHING",
    "dropdeladd": "4165 MAIN ST STE 1",
    "dropdelcty": "FLUSHING",
    "dropdelst": "NY",
    "dropdelzpp": 113559998,
    "dropphyadd": "4165 MAIN ST STE 1",
    "dropphycty": "FLUSHING",
    "dropphyst": "NY",
    "dropphyzpp": 113559998,
    "dropmaladd": "4165 MAIN ST STE 1",
    "dropmalcty": "FLUSHING",
    "dropmalst": "NY",
    "dropmalzpp": 113559998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183216803,
    "dropfax": 7183216842
  },
  {
    "dcode": "D",
    "dropkey": "PV13368",
    "droptype": "D",
    "dropname": "FLY CREEK",
    "dropdeladd": "845 COUNTY HIGHWAY 26",
    "dropdelcty": "FLY CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 133379998,
    "dropphyadd": "845 COUNTY HIGHWAY 26",
    "dropphycty": "FLY CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 133379998,
    "dropmaladd": "845 COUNTY HIGHWAY 26",
    "dropmalcty": "FLY CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 133379998,
    "dropsitphn": 6075475111,
    "dropsitlph": 6075475111,
    "dropsitcph": 6075475111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13370",
    "droptype": "D",
    "dropname": "FONDA",
    "dropdeladd": "1 W MAIN ST",
    "dropdelcty": "FONDA",
    "dropdelst": "NY",
    "dropdelzpp": 120689998,
    "dropphyadd": "1 W MAIN ST",
    "dropphycty": "FONDA",
    "dropphyst": "NY",
    "dropphyzpp": 120689998,
    "dropmaladd": "1 W MAIN ST",
    "dropmalcty": "FONDA",
    "dropmalst": "NY",
    "dropmalzpp": 120689998,
    "dropsitphn": 5188533112,
    "dropsitlph": 5188533112,
    "dropsitcph": 5188533112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13381",
    "droptype": "D",
    "dropname": "FORESTPORT",
    "dropdeladd": "12180 WOODHULL RD",
    "dropdelcty": "FORESTPORT",
    "dropdelst": "NY",
    "dropdelzpp": 133389998,
    "dropphyadd": "12180 WOODHULL RD",
    "dropphycty": "FORESTPORT",
    "dropphyst": "NY",
    "dropphyzpp": 133389998,
    "dropmaladd": "12180 WOODHULL RD",
    "dropmalcty": "FORESTPORT",
    "dropmalst": "NY",
    "dropmalzpp": 133389998,
    "dropsitphn": 3153987725,
    "dropsitlph": 3153987725,
    "dropsitcph": 3153987725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13383",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "FORESTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140629998,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "FORESTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140629998,
    "dropmaladd": "17 MAIN ST",
    "dropmalcty": "FORESTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140629998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169654884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13390",
    "droptype": "D",
    "dropname": "FORT ANN",
    "dropdeladd": "86 GEORGE ST",
    "dropdelcty": "FORT ANN",
    "dropdelst": "NY",
    "dropdelzpp": 128279998,
    "dropphyadd": "86 GEORGE ST",
    "dropphycty": "FORT ANN",
    "dropphyst": "NY",
    "dropphyzpp": 128279998,
    "dropmaladd": "86 GEORGE ST",
    "dropmalcty": "FORT ANN",
    "dropmalst": "NY",
    "dropmalzpp": 128279998,
    "dropsitphn": 5186398682,
    "dropsitlph": 5186398682,
    "dropsitcph": 5186398682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13391",
    "droptype": "D",
    "dropname": "FORT COVINGTON",
    "dropdeladd": "15 S WATER ST",
    "dropdelcty": "FORT COVINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 129379998,
    "dropphyadd": "15 S WATER ST",
    "dropphycty": "FORT COVINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 129379998,
    "dropmaladd": "15 S WATER ST",
    "dropmalcty": "FORT COVINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 129379998,
    "dropsitphn": 5183582100,
    "dropsitlph": 5183582100,
    "dropsitcph": 5183582100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13394",
    "droptype": "D",
    "dropname": "FORT EDWARD",
    "dropdeladd": "126 BROADWAY",
    "dropdelcty": "FORT EDWARD",
    "dropdelst": "NY",
    "dropdelzpp": 128289998,
    "dropphyadd": "126 BROADWAY",
    "dropphycty": "FORT EDWARD",
    "dropphyst": "NY",
    "dropphyzpp": 128289998,
    "dropmaladd": "126 BROADWAY",
    "dropmalcty": "FORT EDWARD",
    "dropmalst": "NY",
    "dropmalzpp": 128289998,
    "dropsitphn": 5187476311,
    "dropsitlph": 5187476311,
    "dropsitcph": 5187476311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13403",
    "droptype": "D",
    "dropname": "FORT JOHNSON",
    "dropdeladd": "5 E MAIN ST",
    "dropdelcty": "FORT JOHNSON",
    "dropdelst": "NY",
    "dropdelzpp": 120709998,
    "dropphyadd": "5 E MAIN ST",
    "dropphycty": "FORT JOHNSON",
    "dropphyst": "NY",
    "dropphyzpp": 120709998,
    "dropmaladd": "5 E MAIN ST",
    "dropmalcty": "FORT JOHNSON",
    "dropmalst": "NY",
    "dropmalzpp": 120709998,
    "dropsitphn": 5188425582,
    "dropsitlph": 5188425582,
    "dropsitcph": 5188425582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13405",
    "droptype": "D",
    "dropname": "FORT MONTGOMERY",
    "dropdeladd": "130 FIREFIGHTERS MEMORIAL DR",
    "dropdelcty": "FORT MONTGOMERY",
    "dropdelst": "NY",
    "dropdelzpp": 109229800,
    "dropphyadd": "130 FIREFIGHTERS MEMORIAL DR",
    "dropphycty": "FORT MONTGOMERY",
    "dropphyst": "NY",
    "dropphyzpp": 109229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT MONTGOMERY",
    "dropmalst": "NY",
    "dropmalzpp": 109229998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454468459,
    "dropsitcph": 8454468459,
    "dropfax": 8454462173
  },
  {
    "dcode": "D",
    "dropkey": "PV13407",
    "droptype": "D",
    "dropname": "FORT PLAIN",
    "dropdeladd": "41 RIVER ST",
    "dropdelcty": "FORT PLAIN",
    "dropdelst": "NY",
    "dropdelzpp": 133399998,
    "dropphyadd": "41 RIVER ST",
    "dropphycty": "FORT PLAIN",
    "dropphyst": "NY",
    "dropphyzpp": 133399998,
    "dropmaladd": "41 RIVER ST",
    "dropmalcty": "FORT PLAIN",
    "dropmalst": "NY",
    "dropmalzpp": 133399998,
    "dropsitphn": 5189933801,
    "dropsitlph": 5189933801,
    "dropsitcph": 5189933801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13425",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "130 E MAIN ST",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "NY",
    "dropdelzpp": 133409998,
    "dropphyadd": "130 E MAIN ST",
    "dropphycty": "FRANKFORT",
    "dropphyst": "NY",
    "dropphyzpp": 133409998,
    "dropmaladd": "130 E MAIN ST",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "NY",
    "dropmalzpp": 133409998,
    "dropsitphn": 3158944410,
    "dropsitlph": 3158944410,
    "dropsitcph": 3158944410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13427",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "450 MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NY",
    "dropdelzpp": 137759998,
    "dropphyadd": "450 MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NY",
    "dropphyzpp": 137759998,
    "dropmaladd": "450 MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NY",
    "dropmalzpp": 137759998,
    "dropsitphn": 6078293161,
    "dropsitlph": 6078293161,
    "dropsitcph": 6078293161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13434",
    "droptype": "D",
    "dropname": "FRANKLIN SQUARE",
    "dropdeladd": "867 HEMPSTEAD TPKE",
    "dropdelcty": "FRANKLIN SQUARE",
    "dropdelst": "NY",
    "dropdelzpp": 110109998,
    "dropphyadd": "867 HEMPSTEAD TPKE",
    "dropphycty": "FRANKLIN SQUARE",
    "dropphyst": "NY",
    "dropphyzpp": 110109998,
    "dropmaladd": "867 HEMPSTEAD TPKE",
    "dropmalcty": "FRANKLIN SQUARE",
    "dropmalst": "NY",
    "dropmalzpp": 110109998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5163526411,
    "dropfax": 5163522256
  },
  {
    "dcode": "D",
    "dropkey": "PV13435",
    "droptype": "D",
    "dropname": "FRANKLINVILLE",
    "dropdeladd": "14 S MAIN ST",
    "dropdelcty": "FRANKLINVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147379998,
    "dropphyadd": "14 S MAIN ST",
    "dropphycty": "FRANKLINVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147379998,
    "dropmaladd": "14 S MAIN ST",
    "dropmalcty": "FRANKLINVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147379998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166763042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13440",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "21 DAY ST",
    "dropdelcty": "FREDONIA",
    "dropdelst": "NY",
    "dropdelzpp": 140639998,
    "dropphyadd": "21 DAY ST",
    "dropphycty": "FREDONIA",
    "dropphyst": "NY",
    "dropphyzpp": 140639998,
    "dropmaladd": "21 DAY ST",
    "dropmalcty": "FREDONIA",
    "dropmalst": "NY",
    "dropmalzpp": 140639998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166726756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13441",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "11481 ROUTE 98",
    "dropdelcty": "FREEDOM",
    "dropdelst": "NY",
    "dropdelzpp": 140659998,
    "dropphyadd": "11481 ROUTE 98",
    "dropphycty": "FREEDOM",
    "dropphyst": "NY",
    "dropphyzpp": 140659998,
    "dropmaladd": "11481 ROUTE 98",
    "dropmalcty": "FREEDOM",
    "dropmalst": "NY",
    "dropmalzpp": 140659998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164921241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13442",
    "droptype": "D",
    "dropname": "FREEHOLD",
    "dropdeladd": "9467 ROUTE 32",
    "dropdelcty": "FREEHOLD",
    "dropdelst": "NY",
    "dropdelzpp": 124319998,
    "dropphyadd": "9467 ROUTE 32",
    "dropphycty": "FREEHOLD",
    "dropphyst": "NY",
    "dropphyzpp": 124319998,
    "dropmaladd": "9467 ROUTE 32",
    "dropmalcty": "FREEHOLD",
    "dropmalst": "NY",
    "dropmalzpp": 124319998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186342878,
    "dropsitcph": 5186342878,
    "dropfax": 5186342878
  },
  {
    "dcode": "D",
    "dropkey": "PV13443",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "132 W MERRICK RD",
    "dropdelcty": "FREEPORT",
    "dropdelst": "NY",
    "dropdelzpp": 115203757,
    "dropphyadd": "132 W MERRICK RD",
    "dropphycty": "FREEPORT",
    "dropphyst": "NY",
    "dropphyzpp": 115203757,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEPORT",
    "dropmalst": "NY",
    "dropmalzpp": 115209998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163786512,
    "dropfax": 5162233843
  },
  {
    "dcode": "D",
    "dropkey": "PV13447",
    "droptype": "D",
    "dropname": "FREEVILLE",
    "dropdeladd": "46 MAIN ST",
    "dropdelcty": "FREEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130689998,
    "dropphyadd": "46 MAIN ST",
    "dropphycty": "FREEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130689998,
    "dropmaladd": "46 MAIN ST",
    "dropmalcty": "FREEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130689998,
    "dropsitphn": 6078448410,
    "dropsitlph": 5184522299,
    "dropsitcph": 6078448410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13451",
    "droptype": "D",
    "dropname": "FREMONT CENTER",
    "dropdeladd": "37 COUNTY ROAD 93",
    "dropdelcty": "FREMONT CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 127369998,
    "dropphyadd": "37 COUNTY ROAD 93",
    "dropphycty": "FREMONT CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 127369998,
    "dropmaladd": "37 COUNTY ROAD 93",
    "dropmalcty": "FREMONT CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 127369998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458875808,
    "dropsitcph": 8458875808,
    "dropfax": 8458876372
  },
  {
    "dcode": "D",
    "dropkey": "PV13460",
    "droptype": "D",
    "dropname": "FREWSBURG",
    "dropdeladd": "21 E MAIN ST",
    "dropdelcty": "FREWSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 147389900,
    "dropphyadd": "21 E MAIN ST",
    "dropphycty": "FREWSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 147389900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREWSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 147389998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165696545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13461",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "4 W WATER ST",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "NY",
    "dropdelzpp": 147399998,
    "dropphyadd": "4 W WATER ST",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "NY",
    "dropphyzpp": 147399998,
    "dropmaladd": "4 W WATER ST",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "NY",
    "dropmalzpp": 147399998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859732301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13474",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "214 S 1ST ST",
    "dropdelcty": "FULTON",
    "dropdelst": "NY",
    "dropdelzpp": 130699998,
    "dropphyadd": "214 S 1ST ST",
    "dropphycty": "FULTON",
    "dropphyst": "NY",
    "dropphyzpp": 130699998,
    "dropmaladd": "214 S 1ST ST",
    "dropmalcty": "FULTON",
    "dropmalst": "NY",
    "dropmalzpp": 130699998,
    "dropsitphn": 3155927158,
    "dropsitlph": 5184522299,
    "dropsitcph": 3155927158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13475",
    "droptype": "D",
    "dropname": "FULTONHAM",
    "dropdeladd": "3431 STATE ROUTE 30",
    "dropdelcty": "FULTONHAM",
    "dropdelst": "NY",
    "dropdelzpp": 120719998,
    "dropphyadd": "3431 STATE ROUTE 30",
    "dropphycty": "FULTONHAM",
    "dropphyst": "NY",
    "dropphyzpp": 120719998,
    "dropmaladd": "3431 STATE ROUTE 30",
    "dropmalcty": "FULTONHAM",
    "dropmalst": "NY",
    "dropmalzpp": 120719998,
    "dropsitphn": 5188275355,
    "dropsitlph": 5188275355,
    "dropsitcph": 5188275355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13476",
    "droptype": "D",
    "dropname": "FULTONVILLE",
    "dropdeladd": "26 MAIN ST STE 5",
    "dropdelcty": "FULTONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120729998,
    "dropphyadd": "26 MAIN ST STE 5",
    "dropphycty": "FULTONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120729998,
    "dropmaladd": "26 MAIN ST STE 5",
    "dropmalcty": "FULTONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120729998,
    "dropsitphn": 5188533631,
    "dropsitlph": 5188533631,
    "dropsitcph": 5188533631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13483",
    "droptype": "D",
    "dropname": "GABRIELS",
    "dropdeladd": "846 STATE ROUTE 86",
    "dropdelcty": "GABRIELS",
    "dropdelst": "NY",
    "dropdelzpp": 129399998,
    "dropphyadd": "846 STATE ROUTE 86",
    "dropphycty": "GABRIELS",
    "dropphyst": "NY",
    "dropphyzpp": 129399998,
    "dropmaladd": "846 STATE ROUTE 86",
    "dropmalcty": "GABRIELS",
    "dropmalst": "NY",
    "dropmalzpp": 129399998,
    "dropsitphn": 5183273609,
    "dropsitlph": 5183273609,
    "dropsitcph": 5183273609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13484",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "2 S MAIN ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140669998,
    "dropphyadd": "2 S MAIN ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140669998,
    "dropmaladd": "2 S MAIN ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140669998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854932860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13488",
    "droptype": "D",
    "dropname": "GALLUPVILLE",
    "dropdeladd": "859 STATE ROUTE 443 STE 2",
    "dropdelcty": "GALLUPVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120739998,
    "dropphyadd": "859 STATE ROUTE 443 STE 2",
    "dropphycty": "GALLUPVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120739998,
    "dropmaladd": "859 STATE ROUTE 443 STE 2",
    "dropmalcty": "GALLUPVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120739998,
    "dropsitphn": 5188721057,
    "dropsitlph": 5188721057,
    "dropsitcph": 5188721057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13489",
    "droptype": "D",
    "dropname": "GALWAY",
    "dropdeladd": "5101 SACANDAGA RD",
    "dropdelcty": "GALWAY",
    "dropdelst": "NY",
    "dropdelzpp": 120749998,
    "dropphyadd": "5101 SACANDAGA RD",
    "dropphycty": "GALWAY",
    "dropphyst": "NY",
    "dropphyzpp": 120749998,
    "dropmaladd": "5101 SACANDAGA RD",
    "dropmalcty": "GALWAY",
    "dropmalst": "NY",
    "dropmalzpp": 120749998,
    "dropsitphn": 5188821044,
    "dropsitlph": 5188821044,
    "dropsitcph": 5188821044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13491",
    "droptype": "D",
    "dropname": "GANSEVOORT",
    "dropdeladd": "50 LEONARD ST",
    "dropdelcty": "GANSEVOORT",
    "dropdelst": "NY",
    "dropdelzpp": 128319998,
    "dropphyadd": "50 LEONARD ST",
    "dropphycty": "GANSEVOORT",
    "dropphyst": "NY",
    "dropphyzpp": 128319998,
    "dropmaladd": "50 LEONARD ST",
    "dropmalcty": "GANSEVOORT",
    "dropmalst": "NY",
    "dropmalzpp": 128319998,
    "dropsitphn": 5187928777,
    "dropsitlph": 5187928777,
    "dropsitcph": 5187928777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13492",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "600 FRANKLIN AVE",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "NY",
    "dropdelzpp": 115305756,
    "dropphyadd": "600 FRANKLIN AVE",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "NY",
    "dropphyzpp": 115305756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "NY",
    "dropmalzpp": 115309998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167472201,
    "dropfax": 5167470332
  },
  {
    "dcode": "D",
    "dropkey": "PV13500",
    "droptype": "D",
    "dropname": "GARDINER",
    "dropdeladd": "124 MAIN ST",
    "dropdelcty": "GARDINER",
    "dropdelst": "NY",
    "dropdelzpp": 125259998,
    "dropphyadd": "124 MAIN ST",
    "dropphycty": "GARDINER",
    "dropphyst": "NY",
    "dropphyzpp": 125259998,
    "dropmaladd": "124 MAIN ST",
    "dropmalcty": "GARDINER",
    "dropmalst": "NY",
    "dropmalzpp": 125259998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452557267,
    "dropsitcph": 8452557267,
    "dropfax": 8452551525
  },
  {
    "dcode": "D",
    "dropkey": "PV13502",
    "droptype": "D",
    "dropname": "GARNERVILLE",
    "dropdeladd": "55 RAMAPO RD",
    "dropdelcty": "GARNERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109239998,
    "dropphyadd": "55 RAMAPO RD",
    "dropphycty": "GARNERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109239998,
    "dropmaladd": "55 RAMAPO RD",
    "dropmalcty": "GARNERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459473454,
    "dropsitcph": 8459473454,
    "dropfax": 8459474738
  },
  {
    "dcode": "D",
    "dropkey": "PV13506",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "1145 ROUTE 9D",
    "dropdelcty": "GARRISON",
    "dropdelst": "NY",
    "dropdelzpp": 105249998,
    "dropphyadd": "1145 ROUTE 9D",
    "dropphycty": "GARRISON",
    "dropphyst": "NY",
    "dropphyzpp": 105249998,
    "dropmaladd": "1145 ROUTE 9D",
    "dropmalcty": "GARRISON",
    "dropmalst": "NY",
    "dropmalzpp": 105249998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454244839,
    "dropsitcph": 8454244839,
    "dropfax": 8454244781
  },
  {
    "dcode": "D",
    "dropkey": "PV13509",
    "droptype": "D",
    "dropname": "GASPORT",
    "dropdeladd": "8391 ROCHESTER RD",
    "dropdelcty": "GASPORT",
    "dropdelst": "NY",
    "dropdelzpp": 140679998,
    "dropphyadd": "8391 ROCHESTER RD",
    "dropphycty": "GASPORT",
    "dropphyst": "NY",
    "dropphyzpp": 140679998,
    "dropmaladd": "8391 ROCHESTER RD",
    "dropmalcty": "GASPORT",
    "dropmalst": "NY",
    "dropmalzpp": 140679998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167727535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13522",
    "droptype": "D",
    "dropname": "GENESEO",
    "dropdeladd": "13 SOUTH ST",
    "dropdelcty": "GENESEO",
    "dropdelst": "NY",
    "dropdelzpp": 144549998,
    "dropphyadd": "13 SOUTH ST",
    "dropphycty": "GENESEO",
    "dropphyst": "NY",
    "dropphyzpp": 144549998,
    "dropmaladd": "13 SOUTH ST",
    "dropmalcty": "GENESEO",
    "dropmalst": "NY",
    "dropmalzpp": 144549998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852432000,
    "dropsitcph": 5852432000,
    "dropfax": 5852435080
  },
  {
    "dcode": "D",
    "dropkey": "PV13523",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "67 CASTLE ST",
    "dropdelcty": "GENEVA",
    "dropdelst": "NY",
    "dropdelzpp": 144569998,
    "dropphyadd": "67 CASTLE ST",
    "dropphycty": "GENEVA",
    "dropphyst": "NY",
    "dropphyzpp": 144569998,
    "dropmaladd": "67 CASTLE ST",
    "dropmalcty": "GENEVA",
    "dropmalst": "NY",
    "dropmalzpp": 144569998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3157890922,
    "dropsitcph": 3157890922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13524",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "1034 NORTH ST",
    "dropdelcty": "GENOA",
    "dropdelst": "NY",
    "dropdelzpp": 130719998,
    "dropphyadd": "1034 NORTH ST",
    "dropphycty": "GENOA",
    "dropphyst": "NY",
    "dropphyzpp": 130719998,
    "dropmaladd": "1034 NORTH ST",
    "dropmalcty": "GENOA",
    "dropmalst": "NY",
    "dropmalzpp": 130719998,
    "dropsitphn": 3154970456,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154970456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13525",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1008 STATE ROUTE 26",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "NY",
    "dropdelzpp": 130729998,
    "dropphyadd": "1008 STATE ROUTE 26",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "NY",
    "dropphyzpp": 130729998,
    "dropmaladd": "1008 STATE ROUTE 26",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "NY",
    "dropmalzpp": 130729998,
    "dropsitphn": 3158374470,
    "dropsitlph": 5184522299,
    "dropsitcph": 3158374470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13530",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 125265336,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 125265336,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 125269998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8779079836,
    "dropsitcph": 8779079836,
    "dropfax": 5185376273
  },
  {
    "dcode": "D",
    "dropkey": "PV13532",
    "droptype": "D",
    "dropname": "GERRY",
    "dropdeladd": "4465 ROUTE 60",
    "dropdelcty": "GERRY",
    "dropdelst": "NY",
    "dropdelzpp": 147409998,
    "dropphyadd": "4465 ROUTE 60",
    "dropphycty": "GERRY",
    "dropphyst": "NY",
    "dropphyzpp": 147409998,
    "dropmaladd": "4465 ROUTE 60",
    "dropmalcty": "GERRY",
    "dropmalst": "NY",
    "dropmalzpp": 147409998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169854513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13533",
    "droptype": "D",
    "dropname": "GETZVILLE",
    "dropdeladd": "2655 MILLERSPORT HWY",
    "dropdelcty": "GETZVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140689998,
    "dropphyadd": "2655 MILLERSPORT HWY",
    "dropphycty": "GETZVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140689998,
    "dropmaladd": "2655 MILLERSPORT HWY",
    "dropmalcty": "GETZVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140689998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166898874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13534",
    "droptype": "D",
    "dropname": "GHENT",
    "dropdeladd": "2354 STATE ROUTE 66",
    "dropdelcty": "GHENT",
    "dropdelst": "NY",
    "dropdelzpp": 120759998,
    "dropphyadd": "2354 STATE ROUTE 66",
    "dropphycty": "GHENT",
    "dropphyst": "NY",
    "dropphyzpp": 120759998,
    "dropmaladd": "2354 STATE ROUTE 66",
    "dropmalcty": "GHENT",
    "dropmalst": "NY",
    "dropmalzpp": 120759998,
    "dropsitphn": 5183925969,
    "dropsitlph": 5183925969,
    "dropsitcph": 5183925969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13537",
    "droptype": "D",
    "dropname": "GILBERTSVILLE",
    "dropdeladd": "3 COMMERCIAL ST",
    "dropdelcty": "GILBERTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137769998,
    "dropphyadd": "3 COMMERCIAL ST",
    "dropphycty": "GILBERTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137769998,
    "dropmaladd": "3 COMMERCIAL ST",
    "dropmalcty": "GILBERTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137769998,
    "dropsitphn": 6077832735,
    "dropsitlph": 5184522299,
    "dropsitcph": 6077832735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13540",
    "droptype": "D",
    "dropname": "GILBOA",
    "dropdeladd": "373 STATE ROUTE 990V STE 2",
    "dropdelcty": "GILBOA",
    "dropdelst": "NY",
    "dropdelzpp": 120769998,
    "dropphyadd": "373 STATE ROUTE 990V STE 2",
    "dropphycty": "GILBOA",
    "dropphyst": "NY",
    "dropphyzpp": 120769998,
    "dropmaladd": "373 STATE ROUTE 990V STE 2",
    "dropmalcty": "GILBOA",
    "dropmalst": "NY",
    "dropmalzpp": 120769998,
    "dropsitphn": 5185886667,
    "dropsitlph": 5185886667,
    "dropsitcph": 6075886667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13543",
    "droptype": "D",
    "dropname": "GLASCO",
    "dropdeladd": "90 GLASCO TPKE",
    "dropdelcty": "GLASCO",
    "dropdelst": "NY",
    "dropdelzpp": 124329800,
    "dropphyadd": "90 GLASCO TPKE",
    "dropphycty": "GLASCO",
    "dropphyst": "NY",
    "dropphyzpp": 124329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLASCO",
    "dropmalst": "NY",
    "dropmalzpp": 124329998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452467303,
    "dropsitcph": 8452467303,
    "dropfax": 8452467303
  },
  {
    "dcode": "D",
    "dropkey": "PV13545",
    "droptype": "D",
    "dropname": "GLEN AUBREY",
    "dropdeladd": "10 OCTAGON ST",
    "dropdelcty": "GLEN AUBREY",
    "dropdelst": "NY",
    "dropdelzpp": 137779998,
    "dropphyadd": "10 OCTAGON ST",
    "dropphycty": "GLEN AUBREY",
    "dropphyst": "NY",
    "dropphyzpp": 137779998,
    "dropmaladd": "10 OCTAGON ST",
    "dropmalcty": "GLEN AUBREY",
    "dropmalst": "NY",
    "dropmalzpp": 137779998,
    "dropsitphn": 6078629512,
    "dropsitlph": 6078629512,
    "dropsitcph": 6078629512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13547",
    "droptype": "D",
    "dropname": "GLEN COVE",
    "dropdeladd": "2 GLEN COVE AVE",
    "dropdelcty": "GLEN COVE",
    "dropdelst": "NY",
    "dropdelzpp": 115422596,
    "dropphyadd": "2 GLEN COVE AVE",
    "dropphycty": "GLEN COVE",
    "dropphyst": "NY",
    "dropphyzpp": 115422596,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN COVE",
    "dropmalst": "NY",
    "dropmalzpp": 115429998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166717847,
    "dropfax": 5166740174
  },
  {
    "dcode": "D",
    "dropkey": "PV13549",
    "droptype": "D",
    "dropname": "GLEN HEAD",
    "dropdeladd": "240 GLEN HEAD RD STE 1",
    "dropdelcty": "GLEN HEAD",
    "dropdelst": "NY",
    "dropdelzpp": 115451980,
    "dropphyadd": "240 GLEN HEAD RD STE 1",
    "dropphycty": "GLEN HEAD",
    "dropphyst": "NY",
    "dropphyzpp": 115451980,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN HEAD",
    "dropmalst": "NY",
    "dropmalzpp": 115459998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166768465,
    "dropfax": 5167596716
  },
  {
    "dcode": "D",
    "dropkey": "PV13552",
    "droptype": "D",
    "dropname": "GLEN SPEY",
    "dropdeladd": "1677 FORESTBURGH RD",
    "dropdelcty": "GLEN SPEY",
    "dropdelst": "NY",
    "dropdelzpp": 127379998,
    "dropphyadd": "1677 FORESTBURGH RD",
    "dropphycty": "GLEN SPEY",
    "dropphyst": "NY",
    "dropphyzpp": 127379998,
    "dropmaladd": "1677 FORESTBURGH RD",
    "dropmalcty": "GLEN SPEY",
    "dropmalst": "NY",
    "dropmalzpp": 127379998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458583615,
    "dropsitcph": 8458583615,
    "dropfax": 8458588286
  },
  {
    "dcode": "D",
    "dropkey": "PV13553",
    "droptype": "D",
    "dropname": "GLEN WILD",
    "dropdeladd": "424 GLEN WILD RD",
    "dropdelcty": "GLEN WILD",
    "dropdelst": "NY",
    "dropdelzpp": 127389998,
    "dropphyadd": "424 GLEN WILD RD",
    "dropphycty": "GLEN WILD",
    "dropphyst": "NY",
    "dropphyzpp": 127389998,
    "dropmaladd": "424 GLEN WILD RD",
    "dropmalcty": "GLEN WILD",
    "dropmalst": "NY",
    "dropmalzpp": 127389998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454366839,
    "dropsitcph": 8454366839,
    "dropfax": 8454366839
  },
  {
    "dcode": "D",
    "dropkey": "PV13558",
    "droptype": "D",
    "dropname": "GLENFIELD",
    "dropdeladd": "6036 MAIN ST",
    "dropdelcty": "GLENFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 133439998,
    "dropphyadd": "6036 MAIN ST",
    "dropphycty": "GLENFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 133439998,
    "dropmaladd": "6036 MAIN ST",
    "dropmalcty": "GLENFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 133439998,
    "dropsitphn": 3153718076,
    "dropsitlph": 3153718076,
    "dropsitcph": 3153718076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13559",
    "droptype": "D",
    "dropname": "GLENFORD",
    "dropdeladd": "216 OLD STATE ROUTE 28",
    "dropdelcty": "GLENFORD",
    "dropdelst": "NY",
    "dropdelzpp": 124339998,
    "dropphyadd": "216 OLD STATE ROUTE 28",
    "dropphycty": "GLENFORD",
    "dropphyst": "NY",
    "dropphyzpp": 124339998,
    "dropmaladd": "216 OLD STATE ROUTE 28",
    "dropmalcty": "GLENFORD",
    "dropmalst": "NY",
    "dropmalzpp": 124339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456572949,
    "dropsitcph": 8456572949,
    "dropfax": 8456572949
  },
  {
    "dcode": "D",
    "dropkey": "PV13560",
    "droptype": "D",
    "dropname": "GLENHAM",
    "dropdeladd": "77 OLD GLENHAM RD",
    "dropdelcty": "GLENHAM",
    "dropdelst": "NY",
    "dropdelzpp": 125279800,
    "dropphyadd": "77 OLD GLENHAM RD",
    "dropphycty": "GLENHAM",
    "dropphyst": "NY",
    "dropphyzpp": 125279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENHAM",
    "dropmalst": "NY",
    "dropmalzpp": 125279998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458318070,
    "dropsitcph": 8458318070,
    "dropfax": 8458318070
  },
  {
    "dcode": "D",
    "dropkey": "PV13561",
    "droptype": "D",
    "dropname": "GLENMONT",
    "dropdeladd": "392 FEURA BUSH RD STE 700",
    "dropdelcty": "GLENMONT",
    "dropdelst": "NY",
    "dropdelzpp": 120773096,
    "dropphyadd": "392 FEURA BUSH RD STE 700",
    "dropphycty": "GLENMONT",
    "dropphyst": "NY",
    "dropphyzpp": 120773096,
    "dropmaladd": "392 FEURA BUSH RD STE 700",
    "dropmalcty": "GLENMONT",
    "dropmalst": "NY",
    "dropmalzpp": 120773096,
    "dropsitphn": 5184348358,
    "dropsitlph": 5184348358,
    "dropsitcph": 5184348358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13563",
    "droptype": "D",
    "dropname": "GLENS FALLS",
    "dropdeladd": "16 HUDSON AVE",
    "dropdelcty": "GLENS FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 128019998,
    "dropphyadd": "16 HUDSON AVE",
    "dropphycty": "GLENS FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 128019998,
    "dropmaladd": "16 HUDSON AVE",
    "dropmalcty": "GLENS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128019998,
    "dropsitphn": 5187454525,
    "dropsitlph": 5187454525,
    "dropsitcph": 5187454525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13567",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "9645 STATE RD",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 140699998,
    "dropphyadd": "9645 STATE RD",
    "dropphycty": "GLENWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 140699998,
    "dropmaladd": "9645 STATE RD",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 140699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169416421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13568",
    "droptype": "D",
    "dropname": "GLENWOOD LANDING",
    "dropdeladd": "123 GLENWOOD RD",
    "dropdelcty": "GLENWOOD LANDING",
    "dropdelst": "NY",
    "dropdelzpp": 115479701,
    "dropphyadd": "123 GLENWOOD RD",
    "dropphycty": "GLENWOOD LANDING",
    "dropphyst": "NY",
    "dropphyzpp": 115479701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENWOOD LANDING",
    "dropmalst": "NY",
    "dropmalzpp": 115479998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166768452,
    "dropfax": 5166748143
  },
  {
    "dcode": "D",
    "dropkey": "PV13572",
    "droptype": "D",
    "dropname": "GLOVERSVILLE",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "GLOVERSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120789998,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "GLOVERSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120789998,
    "dropmaladd": "115 N MAIN ST",
    "dropmalcty": "GLOVERSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120789998,
    "dropsitphn": 5187251214,
    "dropsitlph": 5187251214,
    "dropsitcph": 5187251214,
    "dropfax": 5187730243
  },
  {
    "dcode": "D",
    "dropkey": "PV13576",
    "droptype": "D",
    "dropname": "GOLDENS BRIDGE",
    "dropdeladd": "104 N COUNTY SHOPPING CTR",
    "dropdelcty": "GOLDENS BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 105269998,
    "dropphyadd": "104 N COUNTY SHOPPING CTR",
    "dropphycty": "GOLDENS BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 105269998,
    "dropmaladd": "104 N COUNTY SHOPPING CTR",
    "dropmalcty": "GOLDENS BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 105269998,
    "dropsitphn": 9142328036,
    "dropsitlph": 9142328036,
    "dropsitcph": 9142328036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13579",
    "droptype": "D",
    "dropname": "GORHAM",
    "dropdeladd": "2621 MAIN ST",
    "dropdelcty": "GORHAM",
    "dropdelst": "NY",
    "dropdelzpp": 144619800,
    "dropphyadd": "2621 MAIN ST",
    "dropphycty": "GORHAM",
    "dropphyst": "NY",
    "dropphyzpp": 144619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GORHAM",
    "dropmalst": "NY",
    "dropmalzpp": 144619998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855266839,
    "dropsitcph": 5855266839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13580",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "20 GRAND ST",
    "dropdelcty": "GOSHEN",
    "dropdelst": "NY",
    "dropdelzpp": 109249998,
    "dropphyadd": "20 GRAND ST",
    "dropphycty": "GOSHEN",
    "dropphyst": "NY",
    "dropphyzpp": 109249998,
    "dropmaladd": "20 GRAND ST",
    "dropmalcty": "GOSHEN",
    "dropmalst": "NY",
    "dropmalzpp": 109249998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452944288,
    "dropsitcph": 8452944288,
    "dropfax": 8452940594
  },
  {
    "dcode": "D",
    "dropkey": "PV13583",
    "droptype": "D",
    "dropname": "GOUVERNEUR",
    "dropdeladd": "35 GROVE ST",
    "dropdelcty": "GOUVERNEUR",
    "dropdelst": "NY",
    "dropdelzpp": 136429998,
    "dropphyadd": "35 GROVE ST",
    "dropphycty": "GOUVERNEUR",
    "dropphyst": "NY",
    "dropphyzpp": 136429998,
    "dropmaladd": "35 GROVE ST",
    "dropmalcty": "GOUVERNEUR",
    "dropmalst": "NY",
    "dropmalzpp": 136429998,
    "dropsitphn": 3152870520,
    "dropsitlph": 3152870520,
    "dropsitcph": 3152870520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13586",
    "droptype": "D",
    "dropname": "GOWANDA",
    "dropdeladd": "63 W MAIN ST",
    "dropdelcty": "GOWANDA",
    "dropdelst": "NY",
    "dropdelzpp": 140709998,
    "dropphyadd": "63 W MAIN ST",
    "dropphycty": "GOWANDA",
    "dropphyst": "NY",
    "dropphyzpp": 140709998,
    "dropmaladd": "63 W MAIN ST",
    "dropmalcty": "GOWANDA",
    "dropmalst": "NY",
    "dropmalzpp": 140709998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165325163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13595",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "6 ROXBOROUGH RD",
    "dropdelcty": "GRAFTON",
    "dropdelst": "NY",
    "dropdelzpp": 120829998,
    "dropphyadd": "6 ROXBOROUGH RD",
    "dropphycty": "GRAFTON",
    "dropphyst": "NY",
    "dropphyzpp": 120829998,
    "dropmaladd": "6 ROXBOROUGH RD",
    "dropmalcty": "GRAFTON",
    "dropmalst": "NY",
    "dropmalzpp": 120829998,
    "dropsitphn": 5182799627,
    "dropsitlph": 5182799627,
    "dropsitcph": 5182799627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13596",
    "droptype": "D",
    "dropname": "GRAHAMSVILLE",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "GRAHAMSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127409998,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "GRAHAMSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127409998,
    "dropmaladd": "215 MAIN ST",
    "dropmalcty": "GRAHAMSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459857735,
    "dropsitcph": 8459857735,
    "dropfax": 8459850334
  },
  {
    "dcode": "D",
    "dropkey": "PV13601",
    "droptype": "D",
    "dropname": "GRAND GORGE",
    "dropdeladd": "37163 STATE HIGHWAY 23",
    "dropdelcty": "GRAND GORGE",
    "dropdelst": "NY",
    "dropdelzpp": 124349998,
    "dropphyadd": "37163 STATE HIGHWAY 23",
    "dropphycty": "GRAND GORGE",
    "dropphyst": "NY",
    "dropphyzpp": 124349998,
    "dropmaladd": "37163 STATE HIGHWAY 23",
    "dropmalcty": "GRAND GORGE",
    "dropmalst": "NY",
    "dropmalzpp": 124349998,
    "dropsitphn": 9146974123,
    "dropsitlph": 6075886274,
    "dropsitcph": 6075886274,
    "dropfax": 6075886274
  },
  {
    "dcode": "D",
    "dropkey": "PV13603",
    "droptype": "D",
    "dropname": "GRAND ISLAND",
    "dropdeladd": "2391 BASELINE RD",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 140729998,
    "dropphyadd": "2391 BASELINE RD",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 140729998,
    "dropmaladd": "2391 BASELINE RD",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 140729998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167735355,
    "dropfax": 7167748120
  },
  {
    "dcode": "D",
    "dropkey": "PV13611",
    "droptype": "D",
    "dropname": "GRANITE SPRINGS",
    "dropdeladd": "137 MAHOPAC AVE",
    "dropdelcty": "GRANITE SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 105279998,
    "dropphyadd": "137 MAHOPAC AVE",
    "dropphycty": "GRANITE SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 105279998,
    "dropmaladd": "137 MAHOPAC AVE",
    "dropmalcty": "GRANITE SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 105279998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142485369,
    "dropsitcph": 9142485369,
    "dropfax": 9142485369
  },
  {
    "dcode": "D",
    "dropkey": "PV13616",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "41 MAIN ST",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128329998,
    "dropphyadd": "41 MAIN ST",
    "dropphycty": "GRANVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128329998,
    "dropmaladd": "41 MAIN ST",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128329998,
    "dropsitphn": 5186421190,
    "dropsitlph": 5186421190,
    "dropsitcph": 5186421190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13624",
    "droptype": "D",
    "dropname": "GREAT BEND",
    "dropdeladd": "32675 STATE ROUTE 26",
    "dropdelcty": "GREAT BEND",
    "dropdelst": "NY",
    "dropdelzpp": 136439998,
    "dropphyadd": "32675 STATE ROUTE 26",
    "dropphycty": "GREAT BEND",
    "dropphyst": "NY",
    "dropphyzpp": 136439998,
    "dropmaladd": "32675 STATE ROUTE 26",
    "dropmalcty": "GREAT BEND",
    "dropmalst": "NY",
    "dropmalzpp": 136439998,
    "dropsitphn": 3154931517,
    "dropsitlph": 3154931517,
    "dropsitcph": 3154931517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13628",
    "droptype": "D",
    "dropname": "GREAT NECK",
    "dropdeladd": "1 WELWYN RD",
    "dropdelcty": "GREAT NECK",
    "dropdelst": "NY",
    "dropdelzpp": 110219998,
    "dropphyadd": "1 WELWYN RD",
    "dropphycty": "GREAT NECK",
    "dropphyst": "NY",
    "dropphyzpp": 110219998,
    "dropmaladd": "1 WELWYN RD",
    "dropmalcty": "GREAT NECK",
    "dropmalst": "NY",
    "dropmalzpp": 110219998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5164825013,
    "dropfax": 5164872508
  },
  {
    "dcode": "D",
    "dropkey": "PV13633",
    "droptype": "D",
    "dropname": "GREAT RIVER",
    "dropdeladd": "62 RIVER RD",
    "dropdelcty": "GREAT RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 117399700,
    "dropphyadd": "62 RIVER RD",
    "dropphycty": "GREAT RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 117399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREAT RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 117399998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315817680,
    "dropfax": 6312241375
  },
  {
    "dcode": "D",
    "dropkey": "PV13638",
    "droptype": "D",
    "dropname": "GREAT VALLEY",
    "dropdeladd": "6027 DEPOT ST",
    "dropdelcty": "GREAT VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 147419998,
    "dropphyadd": "6027 DEPOT ST",
    "dropphycty": "GREAT VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 147419998,
    "dropmaladd": "6027 DEPOT ST",
    "dropmalcty": "GREAT VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 147419998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169455586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13652",
    "droptype": "D",
    "dropname": "GREENE",
    "dropdeladd": "11 S CANAL ST",
    "dropdelcty": "GREENE",
    "dropdelst": "NY",
    "dropdelzpp": 137789998,
    "dropphyadd": "11 S CANAL ST",
    "dropphycty": "GREENE",
    "dropphyst": "NY",
    "dropphyzpp": 137789998,
    "dropmaladd": "11 S CANAL ST",
    "dropmalcty": "GREENE",
    "dropmalst": "NY",
    "dropmalzpp": 137789998,
    "dropsitphn": 6076564233,
    "dropsitlph": 6076564233,
    "dropsitcph": 6076564233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13654",
    "droptype": "D",
    "dropname": "GREENFIELD CENTER",
    "dropdeladd": "20 WILTON RD",
    "dropdelcty": "GREENFIELD CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 128339998,
    "dropphyadd": "20 WILTON RD",
    "dropphycty": "GREENFIELD CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 128339998,
    "dropmaladd": "20 WILTON RD",
    "dropmalcty": "GREENFIELD CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 128339998,
    "dropsitphn": 5188937171,
    "dropsitlph": 5188937171,
    "dropsitcph": 5188937171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13655",
    "droptype": "D",
    "dropname": "GREENFIELD PARK",
    "dropdeladd": "7021 STATE ROUTE 52",
    "dropdelcty": "GREENFIELD PARK",
    "dropdelst": "NY",
    "dropdelzpp": 124359998,
    "dropphyadd": "7021 STATE ROUTE 52",
    "dropphycty": "GREENFIELD PARK",
    "dropphyst": "NY",
    "dropphyzpp": 124359998,
    "dropmaladd": "7021 STATE ROUTE 52",
    "dropmalcty": "GREENFIELD PARK",
    "dropmalst": "NY",
    "dropmalzpp": 124359998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456478415,
    "dropsitcph": 8456478415,
    "dropfax": 8456478415
  },
  {
    "dcode": "D",
    "dropkey": "PV13659",
    "droptype": "D",
    "dropname": "GREENHURST",
    "dropdeladd": "2871 GREENHURST AVE",
    "dropdelcty": "GREENHURST",
    "dropdelst": "NY",
    "dropdelzpp": 147429800,
    "dropphyadd": "2871 GREENHURST AVE",
    "dropphycty": "GREENHURST",
    "dropphyst": "NY",
    "dropphyzpp": 147429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENHURST",
    "dropmalst": "NY",
    "dropmalzpp": 147429998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164840358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13660",
    "droptype": "D",
    "dropname": "GREENLAWN",
    "dropdeladd": "55 BROADWAY",
    "dropdelcty": "GREENLAWN",
    "dropdelst": "NY",
    "dropdelzpp": 117401337,
    "dropphyadd": "55 BROADWAY",
    "dropphycty": "GREENLAWN",
    "dropphyst": "NY",
    "dropphyzpp": 117401337,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENLAWN",
    "dropmalst": "NY",
    "dropmalzpp": 117409998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312616437,
    "dropfax": 6312621860
  },
  {
    "dcode": "D",
    "dropkey": "PV13662",
    "droptype": "D",
    "dropname": "GREENPORT",
    "dropdeladd": "131 FRONT ST",
    "dropdelcty": "GREENPORT",
    "dropdelst": "NY",
    "dropdelzpp": 119441644,
    "dropphyadd": "131 FRONT ST",
    "dropphycty": "GREENPORT",
    "dropphyst": "NY",
    "dropphyzpp": 119441644,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENPORT",
    "dropmalst": "NY",
    "dropmalzpp": 119449998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314771493,
    "dropfax": 6314772936
  },
  {
    "dcode": "D",
    "dropkey": "PV13664",
    "droptype": "D",
    "dropname": "GREENVALE",
    "dropdeladd": "37 NORTHERN BLVD",
    "dropdelcty": "GREENVALE",
    "dropdelst": "NY",
    "dropdelzpp": 115481348,
    "dropphyadd": "37 NORTHERN BLVD",
    "dropphycty": "GREENVALE",
    "dropphyst": "NY",
    "dropphyzpp": 115481348,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENVALE",
    "dropmalst": "NY",
    "dropmalzpp": 115489998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166217163,
    "dropfax": 5166255521
  },
  {
    "dcode": "D",
    "dropkey": "PV13665",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "4912 STATE ROUTE 81",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120839998,
    "dropphyadd": "4912 STATE ROUTE 81",
    "dropphycty": "GREENVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120839998,
    "dropmaladd": "4912 STATE ROUTE 81",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120839998,
    "dropsitphn": 5189665379,
    "dropsitlph": 5189665379,
    "dropsitcph": 5189665379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13667",
    "droptype": "D",
    "dropname": "GREENWICH",
    "dropdeladd": "39 MAIN ST",
    "dropdelcty": "GREENWICH",
    "dropdelst": "NY",
    "dropdelzpp": 128349998,
    "dropphyadd": "39 MAIN ST",
    "dropphycty": "GREENWICH",
    "dropphyst": "NY",
    "dropphyzpp": 128349998,
    "dropmaladd": "39 MAIN ST",
    "dropmalcty": "GREENWICH",
    "dropmalst": "NY",
    "dropmalzpp": 128349998,
    "dropsitphn": 5186922055,
    "dropsitlph": 5186922055,
    "dropsitcph": 5186922055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13668",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "2698 MAIN ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 148399998,
    "dropphyadd": "2698 MAIN ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 148399998,
    "dropmaladd": "2698 MAIN ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 148399998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072254915,
    "dropsitcph": 6072254915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13669",
    "droptype": "D",
    "dropname": "GREENWOOD LAKE",
    "dropdeladd": "123 WINDERMERE AVE",
    "dropdelcty": "GREENWOOD LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 109259998,
    "dropphyadd": "123 WINDERMERE AVE",
    "dropphycty": "GREENWOOD LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 109259998,
    "dropmaladd": "123 WINDERMERE AVE",
    "dropmalcty": "GREENWOOD LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 109259998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454777328,
    "dropsitcph": 8454777328,
    "dropfax": 8454772276
  },
  {
    "dcode": "D",
    "dropkey": "PV13682",
    "droptype": "D",
    "dropname": "GROTON",
    "dropdeladd": "101 E CORTLAND ST",
    "dropdelcty": "GROTON",
    "dropdelst": "NY",
    "dropdelzpp": 130739998,
    "dropphyadd": "101 E CORTLAND ST",
    "dropphycty": "GROTON",
    "dropphyst": "NY",
    "dropphyzpp": 130739998,
    "dropmaladd": "101 E CORTLAND ST",
    "dropmalcty": "GROTON",
    "dropmalst": "NY",
    "dropmalzpp": 130739998,
    "dropsitphn": 6078985116,
    "dropsitlph": 6078985116,
    "dropsitcph": 6078985116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13684",
    "droptype": "D",
    "dropname": "GROVELAND",
    "dropdeladd": "7426 GROVELAND STATION RD",
    "dropdelcty": "GROVELAND",
    "dropdelst": "NY",
    "dropdelzpp": 144629998,
    "dropphyadd": "7426 GROVELAND STATION RD",
    "dropphycty": "GROVELAND",
    "dropphyst": "NY",
    "dropphyzpp": 144629998,
    "dropmaladd": "7426 GROVELAND STATION RD",
    "dropmalcty": "GROVELAND",
    "dropmalst": "NY",
    "dropmalzpp": 144629998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852433033,
    "dropsitcph": 5852433033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13692",
    "droptype": "D",
    "dropname": "GUILDERLAND",
    "dropdeladd": "11 NEW KARNER RD",
    "dropdelcty": "GUILDERLAND",
    "dropdelst": "NY",
    "dropdelzpp": 120849998,
    "dropphyadd": "11 NEW KARNER RD",
    "dropphycty": "GUILDERLAND",
    "dropphyst": "NY",
    "dropphyzpp": 120849998,
    "dropmaladd": "11 NEW KARNER RD",
    "dropmalcty": "GUILDERLAND",
    "dropmalst": "NY",
    "dropmalzpp": 120849998,
    "dropsitphn": 5184561400,
    "dropsitlph": 5184561400,
    "dropsitcph": 5184561400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13693",
    "droptype": "D",
    "dropname": "GUILDERLAND CENTER",
    "dropdeladd": "457 STATE ROUTE 146 UNIT 2",
    "dropdelcty": "GUILDERLAND CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 120857707,
    "dropphyadd": "457 STATE ROUTE 146 UNIT 2",
    "dropphycty": "GUILDERLAND CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 120857707,
    "dropmaladd": "457 STATE ROUTE 146 UNIT 2",
    "dropmalcty": "GUILDERLAND CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 120857707,
    "dropsitphn": 5188617198,
    "dropsitlph": 5188617198,
    "dropsitcph": 5188617198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13695",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "1261 COUNTY ROAD 35",
    "dropdelcty": "GUILFORD",
    "dropdelst": "NY",
    "dropdelzpp": 137809998,
    "dropphyadd": "1261 COUNTY ROAD 35",
    "dropphycty": "GUILFORD",
    "dropphyst": "NY",
    "dropphyzpp": 137809998,
    "dropmaladd": "1261 COUNTY ROAD 35",
    "dropmalcty": "GUILFORD",
    "dropmalst": "NY",
    "dropmalzpp": 137809998,
    "dropsitphn": 6078956552,
    "dropsitlph": 6078956552,
    "dropsitcph": 6078956552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13699",
    "droptype": "D",
    "dropname": "HADLEY",
    "dropdeladd": "311 OLD CORINTH RD",
    "dropdelcty": "HADLEY",
    "dropdelst": "NY",
    "dropdelzpp": 128359998,
    "dropphyadd": "311 OLD CORINTH RD",
    "dropphycty": "HADLEY",
    "dropphyst": "NY",
    "dropphyzpp": 128359998,
    "dropmaladd": "311 OLD CORINTH RD",
    "dropmalcty": "HADLEY",
    "dropmalst": "NY",
    "dropmalzpp": 128359998,
    "dropsitphn": 5186924009,
    "dropsitlph": 5186963515,
    "dropsitcph": 5186924009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13700",
    "droptype": "D",
    "dropname": "HAGAMAN",
    "dropdeladd": "127 S PAWLING ST",
    "dropdelcty": "HAGAMAN",
    "dropdelst": "NY",
    "dropdelzpp": 120869998,
    "dropphyadd": "127 S PAWLING ST",
    "dropphycty": "HAGAMAN",
    "dropphyst": "NY",
    "dropphyzpp": 120869998,
    "dropmaladd": "127 S PAWLING ST",
    "dropmalcty": "HAGAMAN",
    "dropmalst": "NY",
    "dropmalzpp": 120869998,
    "dropsitphn": 5188423280,
    "dropsitlph": 5188423280,
    "dropsitcph": 5188423280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13704",
    "droptype": "D",
    "dropname": "HAGUE",
    "dropdeladd": "9840 GRAPHITE MOUNTAIN RD",
    "dropdelcty": "HAGUE",
    "dropdelst": "NY",
    "dropdelzpp": 128369998,
    "dropphyadd": "9840 GRAPHITE MOUNTAIN RD",
    "dropphycty": "HAGUE",
    "dropphyst": "NY",
    "dropphyzpp": 128369998,
    "dropmaladd": "9840 GRAPHITE MOUNTAIN RD",
    "dropmalcty": "HAGUE",
    "dropmalst": "NY",
    "dropmalzpp": 128369998,
    "dropsitphn": 5185436333,
    "dropsitlph": 5185436333,
    "dropsitcph": 5185436333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13705",
    "droptype": "D",
    "dropname": "HAILESBORO",
    "dropdeladd": "97 MAIN ST",
    "dropdelcty": "HAILESBORO",
    "dropdelst": "NY",
    "dropdelzpp": 136459998,
    "dropphyadd": "97 MAIN ST",
    "dropphycty": "HAILESBORO",
    "dropphyst": "NY",
    "dropphyzpp": 136459998,
    "dropmaladd": "97 MAIN ST",
    "dropmalcty": "HAILESBORO",
    "dropmalst": "NY",
    "dropmalzpp": 136459998,
    "dropsitphn": 3152870099,
    "dropsitlph": 3152870099,
    "dropsitcph": 3152870099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13707",
    "droptype": "D",
    "dropname": "HAINES FALLS",
    "dropdeladd": "5197 ROUTE 23A",
    "dropdelcty": "HAINES FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 124369800,
    "dropphyadd": "5197 ROUTE 23A",
    "dropphycty": "HAINES FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 124369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAINES FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 124369998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5185896313,
    "dropsitcph": 5185896313,
    "dropfax": 5185896313
  },
  {
    "dcode": "D",
    "dropkey": "PV13710",
    "droptype": "D",
    "dropname": "HALCOTTSVILLE",
    "dropdeladd": "387 HALCOTTSVILLE RD",
    "dropdelcty": "HALCOTTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124389800,
    "dropphyadd": "387 HALCOTTSVILLE RD",
    "dropphycty": "HALCOTTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALCOTTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124389998,
    "dropsitphn": 9146974123,
    "dropsitlph": 6073264952,
    "dropsitcph": 6073264952,
    "dropfax": 6073264952
  },
  {
    "dcode": "D",
    "dropkey": "PV13719",
    "droptype": "D",
    "dropname": "HALL",
    "dropdeladd": "4858 STATE ROUTE 14A",
    "dropdelcty": "HALL",
    "dropdelst": "NY",
    "dropdelzpp": 144639800,
    "dropphyadd": "4858 STATE ROUTE 14A",
    "dropphycty": "HALL",
    "dropphyst": "NY",
    "dropphyzpp": 144639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALL",
    "dropmalst": "NY",
    "dropmalzpp": 144639998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855265081,
    "dropsitcph": 5855265081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13725",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "5501 CAMP RD",
    "dropdelcty": "HAMBURG",
    "dropdelst": "NY",
    "dropdelzpp": 140759998,
    "dropphyadd": "5501 CAMP RD",
    "dropphycty": "HAMBURG",
    "dropphyst": "NY",
    "dropphyzpp": 140759998,
    "dropmaladd": "5501 CAMP RD",
    "dropmalcty": "HAMBURG",
    "dropmalst": "NY",
    "dropmalzpp": 140759998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166491631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13726",
    "droptype": "D",
    "dropname": "HAMDEN",
    "dropdeladd": "35866 STATE HIGHWAY 10",
    "dropdelcty": "HAMDEN",
    "dropdelst": "NY",
    "dropdelzpp": 137829998,
    "dropphyadd": "35866 STATE HIGHWAY 10",
    "dropphycty": "HAMDEN",
    "dropphyst": "NY",
    "dropphyzpp": 137829998,
    "dropmaladd": "35866 STATE HIGHWAY 10",
    "dropmalcty": "HAMDEN",
    "dropmalst": "NY",
    "dropmalzpp": 137829998,
    "dropsitphn": 6077466909,
    "dropsitlph": 6077466909,
    "dropsitcph": 6077466909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13727",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "32 BROAD ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "NY",
    "dropdelzpp": 133469998,
    "dropphyadd": "32 BROAD ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "NY",
    "dropphyzpp": 133469998,
    "dropmaladd": "32 BROAD ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "NY",
    "dropmalzpp": 133469998,
    "dropsitphn": 3158242350,
    "dropsitlph": 3158242350,
    "dropsitcph": 3158242350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13731",
    "droptype": "D",
    "dropname": "HAMLIN",
    "dropdeladd": "133 RAILROAD AVE",
    "dropdelcty": "HAMLIN",
    "dropdelst": "NY",
    "dropdelzpp": 144649998,
    "dropphyadd": "133 RAILROAD AVE",
    "dropphycty": "HAMLIN",
    "dropphyst": "NY",
    "dropphyzpp": 144649998,
    "dropmaladd": "133 RAILROAD AVE",
    "dropmalcty": "HAMLIN",
    "dropmalst": "NY",
    "dropmalzpp": 144649998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5859642425,
    "dropsitcph": 5859642425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13732",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "50 S MAIN ST",
    "dropdelcty": "HAMMOND",
    "dropdelst": "NY",
    "dropdelzpp": 136469998,
    "dropphyadd": "50 S MAIN ST",
    "dropphycty": "HAMMOND",
    "dropphyst": "NY",
    "dropphyzpp": 136469998,
    "dropmaladd": "50 S MAIN ST",
    "dropmalcty": "HAMMOND",
    "dropmalst": "NY",
    "dropmalzpp": 136469998,
    "dropsitphn": 3153245841,
    "dropsitlph": 3153245841,
    "dropsitcph": 3153245841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13733",
    "droptype": "D",
    "dropname": "HAMMONDSPORT",
    "dropdeladd": "76 PULTENEY ST",
    "dropdelcty": "HAMMONDSPORT",
    "dropdelst": "NY",
    "dropdelzpp": 148409998,
    "dropphyadd": "76 PULTENEY ST",
    "dropphycty": "HAMMONDSPORT",
    "dropphyst": "NY",
    "dropphyzpp": 148409998,
    "dropmaladd": "76 PULTENEY ST",
    "dropmalcty": "HAMMONDSPORT",
    "dropmalst": "NY",
    "dropmalzpp": 148409998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075692144,
    "dropsitcph": 6075692144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13735",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "2522 COUNTY ROUTE 18",
    "dropdelcty": "HAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 128379998,
    "dropphyadd": "2522 COUNTY ROUTE 18",
    "dropphycty": "HAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 128379998,
    "dropmaladd": "2522 COUNTY ROUTE 18",
    "dropmalcty": "HAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 128379998,
    "dropsitphn": 5182829611,
    "dropsitlph": 5182829611,
    "dropsitcph": 5182829611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13736",
    "droptype": "D",
    "dropname": "HAMPTON BAYS",
    "dropdeladd": "16 PONQUOGUE AVE",
    "dropdelcty": "HAMPTON BAYS",
    "dropdelst": "NY",
    "dropdelzpp": 119461877,
    "dropphyadd": "16 PONQUOGUE AVE",
    "dropphycty": "HAMPTON BAYS",
    "dropphyst": "NY",
    "dropphyzpp": 119461877,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMPTON BAYS",
    "dropmalst": "NY",
    "dropmalzpp": 119469998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317286994,
    "dropfax": 6317233939
  },
  {
    "dcode": "D",
    "dropkey": "PV13738",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "204 WHEELER ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "NY",
    "dropdelzpp": 137839998,
    "dropphyadd": "204 WHEELER ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "NY",
    "dropphyzpp": 137839998,
    "dropmaladd": "204 WHEELER ST",
    "dropmalcty": "HANCOCK",
    "dropmalst": "NY",
    "dropmalzpp": 137839998,
    "dropsitphn": 6072024005,
    "dropsitlph": 6072024005,
    "dropsitcph": 6072024005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13740",
    "droptype": "D",
    "dropname": "HANKINS",
    "dropdeladd": "10816 STATE ROUTE 97",
    "dropdelcty": "HANKINS",
    "dropdelst": "NY",
    "dropdelzpp": 127415098,
    "dropphyadd": "10816 STATE ROUTE 97",
    "dropphycty": "HANKINS",
    "dropphyst": "NY",
    "dropphyzpp": 127415098,
    "dropmaladd": "10816 STATE ROUTE 97",
    "dropmalcty": "HANKINS",
    "dropmalst": "NY",
    "dropmalzpp": 127415098,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458874411,
    "dropsitcph": 8458874411,
    "dropfax": 8458874411
  },
  {
    "dcode": "D",
    "dropkey": "PV13741",
    "droptype": "D",
    "dropname": "HANNACROIX",
    "dropdeladd": "13591 US ROUTE 9W",
    "dropdelcty": "HANNACROIX",
    "dropdelst": "NY",
    "dropdelzpp": 120879998,
    "dropphyadd": "13591 US ROUTE 9W",
    "dropphycty": "HANNACROIX",
    "dropphyst": "NY",
    "dropphyzpp": 120879998,
    "dropmaladd": "13591 US ROUTE 9W",
    "dropmalcty": "HANNACROIX",
    "dropmalst": "NY",
    "dropmalzpp": 120879998,
    "dropsitphn": 8383838932,
    "dropsitlph": 8383838932,
    "dropsitcph": 8383838932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13742",
    "droptype": "D",
    "dropname": "HANNAWA FALLS",
    "dropdeladd": "5890 STATE HIGHWAY 56",
    "dropdelcty": "HANNAWA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 136479998,
    "dropphyadd": "5890 STATE HIGHWAY 56",
    "dropphycty": "HANNAWA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 136479998,
    "dropmaladd": "5890 STATE HIGHWAY 56",
    "dropmalcty": "HANNAWA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 136479998,
    "dropsitphn": 3152658842,
    "dropsitlph": 3152658842,
    "dropsitcph": 3152658842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13744",
    "droptype": "D",
    "dropname": "HANNIBAL",
    "dropdeladd": "1 VILLAGE SQ",
    "dropdelcty": "HANNIBAL",
    "dropdelst": "NY",
    "dropdelzpp": 130749998,
    "dropphyadd": "1 VILLAGE SQ",
    "dropphycty": "HANNIBAL",
    "dropphyst": "NY",
    "dropphyzpp": 130749998,
    "dropmaladd": "1 VILLAGE SQ",
    "dropmalcty": "HANNIBAL",
    "dropmalst": "NY",
    "dropmalzpp": 130749998,
    "dropsitphn": 3155646327,
    "dropsitlph": 5184522299,
    "dropsitcph": 3155646327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13766",
    "droptype": "D",
    "dropname": "HARPERSFIELD",
    "dropdeladd": "798 COLONEL HARPER DR",
    "dropdelcty": "HARPERSFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 137869998,
    "dropphyadd": "798 COLONEL HARPER DR",
    "dropphycty": "HARPERSFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 137869998,
    "dropmaladd": "798 COLONEL HARPER DR",
    "dropmalcty": "HARPERSFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 137869998,
    "dropsitphn": 6076522181,
    "dropsitlph": 6076522181,
    "dropsitcph": 6076522181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13768",
    "droptype": "D",
    "dropname": "HARPURSVILLE",
    "dropdeladd": "3619 STATE ROUTE 79",
    "dropdelcty": "HARPURSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 137879998,
    "dropphyadd": "3619 STATE ROUTE 79",
    "dropphycty": "HARPURSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 137879998,
    "dropmaladd": "3619 STATE ROUTE 79",
    "dropmalcty": "HARPURSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 137879998,
    "dropsitphn": 6076932420,
    "dropsitlph": 6076932420,
    "dropsitcph": 6076932420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13772",
    "droptype": "D",
    "dropname": "HARRIMAN",
    "dropdeladd": "88 STATE ROUTE 17M",
    "dropdelcty": "HARRIMAN",
    "dropdelst": "NY",
    "dropdelzpp": 109269998,
    "dropphyadd": "88 STATE ROUTE 17M",
    "dropphycty": "HARRIMAN",
    "dropphyst": "NY",
    "dropphyzpp": 109269998,
    "dropmaladd": "88 STATE ROUTE 17M",
    "dropmalcty": "HARRIMAN",
    "dropmalst": "NY",
    "dropmalzpp": 109269998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457830346,
    "dropsitcph": 8457830346,
    "dropfax": 8457832981
  },
  {
    "dcode": "D",
    "dropkey": "PV13773",
    "droptype": "D",
    "dropname": "HARRIS",
    "dropdeladd": "798 OLD ROUTE 17",
    "dropdelcty": "HARRIS",
    "dropdelst": "NY",
    "dropdelzpp": 127429998,
    "dropphyadd": "798 OLD ROUTE 17",
    "dropphycty": "HARRIS",
    "dropphyst": "NY",
    "dropphyzpp": 127429998,
    "dropmaladd": "798 OLD ROUTE 17",
    "dropmalcty": "HARRIS",
    "dropmalst": "NY",
    "dropmalzpp": 127429998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457942524,
    "dropsitcph": 8457942524,
    "dropfax": 8457942524
  },
  {
    "dcode": "D",
    "dropkey": "PV13777",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "258 HALSTEAD AVE",
    "dropdelcty": "HARRISON",
    "dropdelst": "NY",
    "dropdelzpp": 105289998,
    "dropphyadd": "258 HALSTEAD AVE",
    "dropphycty": "HARRISON",
    "dropphyst": "NY",
    "dropphyzpp": 105289998,
    "dropmaladd": "258 HALSTEAD AVE",
    "dropmalcty": "HARRISON",
    "dropmalst": "NY",
    "dropmalzpp": 105289998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9148354937,
    "dropsitcph": 9148354937,
    "dropfax": 9148358380
  },
  {
    "dcode": "D",
    "dropkey": "PV13778",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "14220 STATE ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136489998,
    "dropphyadd": "14220 STATE ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136489998,
    "dropmaladd": "14220 STATE ST",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136489998,
    "dropsitphn": 3155432220,
    "dropsitlph": 3155432220,
    "dropsitcph": 3155432220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13782",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "46 HARTFORD MAIN ST STE 1",
    "dropdelcty": "HARTFORD",
    "dropdelst": "NY",
    "dropdelzpp": 128382210,
    "dropphyadd": "46 HARTFORD MAIN ST STE 1",
    "dropphycty": "HARTFORD",
    "dropphyst": "NY",
    "dropphyzpp": 128382210,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTFORD",
    "dropmalst": "NY",
    "dropmalzpp": 128389998,
    "dropsitphn": 5186325913,
    "dropsitlph": 5186325913,
    "dropsitcph": 5186325913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13784",
    "droptype": "D",
    "dropname": "HARTSDALE",
    "dropdeladd": "441 CENTRAL PARK AVE",
    "dropdelcty": "SCARSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 105839997,
    "dropphyadd": "441 CENTRAL PARK AVE",
    "dropphycty": "SCARSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 105839997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 105309998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9144727164,
    "dropsitcph": 9144727164,
    "dropfax": 9147253445
  },
  {
    "dcode": "D",
    "dropkey": "PV13786",
    "droptype": "D",
    "dropname": "HARTWICK",
    "dropdeladd": "3095 COUNTY HIGHWAY 11",
    "dropdelcty": "HARTWICK",
    "dropdelst": "NY",
    "dropdelzpp": 133489998,
    "dropphyadd": "3095 COUNTY HIGHWAY 11",
    "dropphycty": "HARTWICK",
    "dropphyst": "NY",
    "dropphyzpp": 133489998,
    "dropmaladd": "3095 COUNTY HIGHWAY 11",
    "dropmalcty": "HARTWICK",
    "dropmalst": "NY",
    "dropmalzpp": 133489998,
    "dropsitphn": 6072937355,
    "dropsitlph": 6072937355,
    "dropsitcph": 6072937355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13789",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "6 COUNTY ROUTE 45",
    "dropdelcty": "HASTINGS",
    "dropdelst": "NY",
    "dropdelzpp": 130769998,
    "dropphyadd": "6 COUNTY ROUTE 45",
    "dropphycty": "HASTINGS",
    "dropphyst": "NY",
    "dropphyzpp": 130769998,
    "dropmaladd": "6 COUNTY ROUTE 45",
    "dropmalcty": "HASTINGS",
    "dropmalst": "NY",
    "dropmalzpp": 130769998,
    "dropsitphn": 3156682056,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156682056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13796",
    "droptype": "D",
    "dropname": "HAVERSTRAW",
    "dropdeladd": "86 MAIN ST",
    "dropdelcty": "HAVERSTRAW",
    "dropdelst": "NY",
    "dropdelzpp": 109279998,
    "dropphyadd": "86 MAIN ST",
    "dropphycty": "HAVERSTRAW",
    "dropphyst": "NY",
    "dropphyzpp": 109279998,
    "dropmaladd": "86 MAIN ST",
    "dropmalcty": "HAVERSTRAW",
    "dropmalst": "NY",
    "dropmalzpp": 109279998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454299066,
    "dropsitcph": 8454299066,
    "dropfax": 8454290890
  },
  {
    "dcode": "D",
    "dropkey": "PV13801",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "9 CROSS ST W",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "NY",
    "dropdelzpp": 105329998,
    "dropphyadd": "9 CROSS ST W",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "NY",
    "dropphyzpp": 105329998,
    "dropmaladd": "9 CROSS ST W",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "NY",
    "dropmalzpp": 105329998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147697308,
    "dropsitcph": 9147697308,
    "dropfax": 9147730426
  },
  {
    "dcode": "D",
    "dropkey": "PV13814",
    "droptype": "D",
    "dropname": "HECTOR",
    "dropdeladd": "5640 STATE ROUTE 414",
    "dropdelcty": "HECTOR",
    "dropdelst": "NY",
    "dropdelzpp": 148419998,
    "dropphyadd": "5640 STATE ROUTE 414",
    "dropphycty": "HECTOR",
    "dropphyst": "NY",
    "dropphyzpp": 148419998,
    "dropmaladd": "5640 STATE ROUTE 414",
    "dropmalcty": "HECTOR",
    "dropmalst": "NY",
    "dropmalzpp": 148419998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075469881,
    "dropsitcph": 6075469881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13817",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "589 1/2 QUINELL RD",
    "dropdelcty": "HELENA",
    "dropdelst": "NY",
    "dropdelzpp": 136499998,
    "dropphyadd": "589 1/2 QUINELL RD",
    "dropphycty": "HELENA",
    "dropphyst": "NY",
    "dropphyzpp": 136499998,
    "dropmaladd": "589 1/2 QUINELL RD",
    "dropmalcty": "HELENA",
    "dropmalst": "NY",
    "dropmalzpp": 136499998,
    "dropsitphn": 3157699426,
    "dropsitlph": 3157699426,
    "dropsitcph": 3157699426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13821",
    "droptype": "D",
    "dropname": "HEMLOCK",
    "dropdeladd": "4625 MAIN ST",
    "dropdelcty": "HEMLOCK",
    "dropdelst": "NY",
    "dropdelzpp": 144669998,
    "dropphyadd": "4625 MAIN ST",
    "dropphycty": "HEMLOCK",
    "dropphyst": "NY",
    "dropphyzpp": 144669998,
    "dropmaladd": "4625 MAIN ST",
    "dropmalcty": "HEMLOCK",
    "dropmalst": "NY",
    "dropmalzpp": 144669998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853672751,
    "dropsitcph": 5853672751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13822",
    "droptype": "D",
    "dropname": "HEMPSTEAD",
    "dropdeladd": "200 FULTON AVE",
    "dropdelcty": "HEMPSTEAD",
    "dropdelst": "NY",
    "dropdelzpp": 115503728,
    "dropphyadd": "200 FULTON AVE",
    "dropphycty": "HEMPSTEAD",
    "dropphyst": "NY",
    "dropphyzpp": 115503728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEMPSTEAD",
    "dropmalst": "NY",
    "dropmalzpp": 115519998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5165601120,
    "dropfax": 5165645341
  },
  {
    "dcode": "D",
    "dropkey": "PV13825",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "8872 STATE ROUTE 178",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NY",
    "dropdelzpp": 136509998,
    "dropphyadd": "8872 STATE ROUTE 178",
    "dropphycty": "HENDERSON",
    "dropphyst": "NY",
    "dropphyzpp": 136509998,
    "dropmaladd": "8872 STATE ROUTE 178",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NY",
    "dropmalzpp": 136509998,
    "dropsitphn": 3159385321,
    "dropsitlph": 3159385321,
    "dropsitcph": 3159385321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13826",
    "droptype": "D",
    "dropname": "HENDERSON HARBOR",
    "dropdeladd": "13190 COUNTY ROUTE 123",
    "dropdelcty": "HENDERSON HARBOR",
    "dropdelst": "NY",
    "dropdelzpp": 136519998,
    "dropphyadd": "13190 COUNTY ROUTE 123",
    "dropphycty": "HENDERSON HARBOR",
    "dropphyst": "NY",
    "dropphyzpp": 136519998,
    "dropmaladd": "13190 COUNTY ROUTE 123",
    "dropmalcty": "HENDERSON HARBOR",
    "dropmalst": "NY",
    "dropmalzpp": 136519998,
    "dropsitphn": 3159385023,
    "dropsitlph": 3159385023,
    "dropsitcph": 3159385023,
    "dropfax": 3159385023
  },
  {
    "dcode": "D",
    "dropkey": "PV13828",
    "droptype": "D",
    "dropname": "HENRIETTA",
    "dropdeladd": "25 GOODBURLET RD",
    "dropdelcty": "HENRIETTA",
    "dropdelst": "NY",
    "dropdelzpp": 144679998,
    "dropphyadd": "25 GOODBURLET RD",
    "dropphycty": "HENRIETTA",
    "dropphyst": "NY",
    "dropphyzpp": 144679998,
    "dropmaladd": "25 GOODBURLET RD",
    "dropmalcty": "HENRIETTA",
    "dropmalst": "NY",
    "dropmalzpp": 144679998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853343700,
    "dropsitcph": 5853343700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13830",
    "droptype": "D",
    "dropname": "HENSONVILLE",
    "dropdeladd": "395 STATE ROUTE 296",
    "dropdelcty": "HENSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124399998,
    "dropphyadd": "395 STATE ROUTE 296",
    "dropphycty": "HENSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124399998,
    "dropmaladd": "395 STATE ROUTE 296",
    "dropmalcty": "HENSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124399998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187343271,
    "dropsitcph": 5187343271,
    "dropfax": 5187343271
  },
  {
    "dcode": "D",
    "dropkey": "PV13834",
    "droptype": "D",
    "dropname": "HERKIMER",
    "dropdeladd": "135 PARK AVE",
    "dropdelcty": "HERKIMER",
    "dropdelst": "NY",
    "dropdelzpp": 133509998,
    "dropphyadd": "135 PARK AVE",
    "dropphycty": "HERKIMER",
    "dropphyst": "NY",
    "dropphyzpp": 133509998,
    "dropmaladd": "135 PARK AVE",
    "dropmalcty": "HERKIMER",
    "dropmalst": "NY",
    "dropmalzpp": 133509998,
    "dropsitphn": 3158661460,
    "dropsitlph": 3158661460,
    "dropsitcph": 3158661460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13835",
    "droptype": "D",
    "dropname": "HERMON",
    "dropdeladd": "88 MAIN ST",
    "dropdelcty": "HERMON",
    "dropdelst": "NY",
    "dropdelzpp": 136529998,
    "dropphyadd": "88 MAIN ST",
    "dropphycty": "HERMON",
    "dropphyst": "NY",
    "dropphyzpp": 136529998,
    "dropmaladd": "88 MAIN ST",
    "dropmalcty": "HERMON",
    "dropmalst": "NY",
    "dropmalzpp": 136529998,
    "dropsitphn": 3153473262,
    "dropsitlph": 3153473262,
    "dropsitcph": 3153473262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13841",
    "droptype": "D",
    "dropname": "HEUVELTON",
    "dropdeladd": "107B STATE ST",
    "dropdelcty": "HEUVELTON",
    "dropdelst": "NY",
    "dropdelzpp": 136549998,
    "dropphyadd": "107B STATE ST",
    "dropphycty": "HEUVELTON",
    "dropphyst": "NY",
    "dropphyzpp": 136549998,
    "dropmaladd": "107B STATE ST",
    "dropmalcty": "HEUVELTON",
    "dropmalst": "NY",
    "dropmalzpp": 136549998,
    "dropsitphn": 3153448801,
    "dropsitlph": 3153448801,
    "dropsitcph": 3153448801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13845",
    "droptype": "D",
    "dropname": "HEWLETT",
    "dropdeladd": "1245 HEWLETT PLZ",
    "dropdelcty": "HEWLETT",
    "dropdelst": "NY",
    "dropdelzpp": 115572037,
    "dropphyadd": "1245 HEWLETT PLZ",
    "dropphycty": "HEWLETT",
    "dropphyst": "NY",
    "dropphyzpp": 115572037,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEWLETT",
    "dropmalst": "NY",
    "dropmalzpp": 115579998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163740973,
    "dropfax": 5165690446
  },
  {
    "dcode": "D",
    "dropkey": "PV13851",
    "droptype": "D",
    "dropname": "HICKSVILLE",
    "dropdeladd": "185 W JOHN ST",
    "dropdelcty": "HICKSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 118018702,
    "dropphyadd": "185 W JOHN ST",
    "dropphycty": "HICKSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 118018702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 118029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169332321,
    "dropfax": 5169332309
  },
  {
    "dcode": "D",
    "dropkey": "PV13858",
    "droptype": "D",
    "dropname": "HIGH FALLS",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "HIGH FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 124409998,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "HIGH FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 124409998,
    "dropmaladd": "107 MAIN ST",
    "dropmalcty": "HIGH FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 124409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456874271,
    "dropsitcph": 8456874271,
    "dropfax": 8456874271
  },
  {
    "dcode": "D",
    "dropkey": "PV13863",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "197 NORTH RD",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "NY",
    "dropdelzpp": 125289998,
    "dropphyadd": "197 NORTH RD",
    "dropphycty": "HIGHLAND",
    "dropphyst": "NY",
    "dropphyzpp": 125289998,
    "dropmaladd": "197 NORTH RD",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "NY",
    "dropmalzpp": 125289998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456919086,
    "dropsitcph": 8456919086,
    "dropfax": 8456913704
  },
  {
    "dcode": "D",
    "dropkey": "PV13864",
    "droptype": "D",
    "dropname": "HIGHLAND FALLS",
    "dropdeladd": "259 MAIN ST",
    "dropdelcty": "HIGHLAND FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 109289998,
    "dropphyadd": "259 MAIN ST",
    "dropphycty": "HIGHLAND FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 109289998,
    "dropmaladd": "259 MAIN ST",
    "dropmalcty": "HIGHLAND FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 109289998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454468733,
    "dropsitcph": 8454468733,
    "dropfax": 8454463625
  },
  {
    "dcode": "D",
    "dropkey": "PV13865",
    "droptype": "D",
    "dropname": "HIGHLAND LAKE",
    "dropdeladd": "112 HIGHLAND LAKE RD",
    "dropdelcty": "HIGHLAND LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127439998,
    "dropphyadd": "112 HIGHLAND LAKE RD",
    "dropphycty": "HIGHLAND LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127439998,
    "dropmaladd": "112 HIGHLAND LAKE RD",
    "dropmalcty": "HIGHLAND LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127439998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455576059,
    "dropsitcph": 8455576059,
    "dropfax": 8455576059
  },
  {
    "dcode": "D",
    "dropkey": "PV13867",
    "droptype": "D",
    "dropname": "HIGHLAND MILLS",
    "dropdeladd": "547 STATE ROUTE 32",
    "dropdelcty": "HIGHLAND MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 109309998,
    "dropphyadd": "547 STATE ROUTE 32",
    "dropphycty": "HIGHLAND MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 109309998,
    "dropmaladd": "547 STATE ROUTE 32",
    "dropmalcty": "HIGHLAND MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 109309998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459286625,
    "dropsitcph": 8459286625,
    "dropfax": 8459283735
  },
  {
    "dcode": "D",
    "dropkey": "PV13871",
    "droptype": "D",
    "dropname": "HIGHMOUNT",
    "dropdeladd": "8 GALLI CURCI RD",
    "dropdelcty": "HIGHMOUNT",
    "dropdelst": "NY",
    "dropdelzpp": 124419800,
    "dropphyadd": "8 GALLI CURCI RD",
    "dropphycty": "HIGHMOUNT",
    "dropphyst": "NY",
    "dropphyzpp": 124419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGHMOUNT",
    "dropmalst": "NY",
    "dropmalzpp": 124419998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452544754,
    "dropsitcph": 8452544754,
    "dropfax": 8452544754
  },
  {
    "dcode": "D",
    "dropkey": "PV13874",
    "droptype": "D",
    "dropname": "HILLBURN",
    "dropdeladd": "27 ROCKLAND AVE",
    "dropdelcty": "HILLBURN",
    "dropdelst": "NY",
    "dropdelzpp": 109319998,
    "dropphyadd": "27 ROCKLAND AVE",
    "dropphycty": "HILLBURN",
    "dropphyst": "NY",
    "dropphyzpp": 109319998,
    "dropmaladd": "27 ROCKLAND AVE",
    "dropmalcty": "HILLBURN",
    "dropmalst": "NY",
    "dropmalzpp": 109319998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8453570266,
    "dropfax": 8453570266
  },
  {
    "dcode": "D",
    "dropkey": "PV13879",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "9245 STATE ROUTE 22",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 125299998,
    "dropphyadd": "9245 STATE ROUTE 22",
    "dropphycty": "HILLSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 125299998,
    "dropmaladd": "9245 STATE ROUTE 22",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 125299998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5183259419,
    "dropsitcph": 5183259419,
    "dropfax": 5183255929
  },
  {
    "dcode": "D",
    "dropkey": "PV13884",
    "droptype": "D",
    "dropname": "HILTON",
    "dropdeladd": "25 SOUTH AVE",
    "dropdelcty": "HILTON",
    "dropdelst": "NY",
    "dropdelzpp": 144689998,
    "dropphyadd": "25 SOUTH AVE",
    "dropphycty": "HILTON",
    "dropphyst": "NY",
    "dropphyzpp": 144689998,
    "dropmaladd": "25 SOUTH AVE",
    "dropmalcty": "HILTON",
    "dropmalst": "NY",
    "dropmalzpp": 144689998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853922910,
    "dropsitcph": 5853922910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13885",
    "droptype": "D",
    "dropname": "HIMROD",
    "dropdeladd": "3619 HIMROD RD",
    "dropdelcty": "HIMROD",
    "dropdelst": "NY",
    "dropdelzpp": 148429998,
    "dropphyadd": "3619 HIMROD RD",
    "dropphycty": "HIMROD",
    "dropphyst": "NY",
    "dropphyzpp": 148429998,
    "dropmaladd": "3619 HIMROD RD",
    "dropmalcty": "HIMROD",
    "dropmalst": "NY",
    "dropmalzpp": 148429998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072438236,
    "dropsitcph": 6072438236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13886",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "7201 MAIN ST",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "NY",
    "dropdelzpp": 133529998,
    "dropphyadd": "7201 MAIN ST",
    "dropphycty": "HINCKLEY",
    "dropphyst": "NY",
    "dropphyzpp": 133529998,
    "dropmaladd": "7201 MAIN ST",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "NY",
    "dropmalzpp": 133529998,
    "dropsitphn": 3158962847,
    "dropsitlph": 3158962847,
    "dropsitcph": 3158962847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13889",
    "droptype": "D",
    "dropname": "HINSDALE",
    "dropdeladd": "3722 MAIN ST",
    "dropdelcty": "HINSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 147439998,
    "dropphyadd": "3722 MAIN ST",
    "dropphycty": "HINSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 147439998,
    "dropmaladd": "3722 MAIN ST",
    "dropmalcty": "HINSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 147439998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165572485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13894",
    "droptype": "D",
    "dropname": "HOBART",
    "dropdeladd": "698 MAIN ST STE 1",
    "dropdelcty": "HOBART",
    "dropdelst": "NY",
    "dropdelzpp": 137889998,
    "dropphyadd": "698 MAIN ST STE 1",
    "dropphycty": "HOBART",
    "dropphyst": "NY",
    "dropphyzpp": 137889998,
    "dropmaladd": "698 MAIN ST STE 1",
    "dropmalcty": "HOBART",
    "dropmalst": "NY",
    "dropmalzpp": 137889998,
    "dropsitphn": 6075389371,
    "dropsitlph": 6075389371,
    "dropsitcph": 6075389371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13897",
    "droptype": "D",
    "dropname": "HOFFMEISTER",
    "dropdeladd": "0 STATE ROUTE 8",
    "dropdelcty": "HOFFMEISTER",
    "dropdelst": "NY",
    "dropdelzpp": 133539998,
    "dropphyadd": "0 STATE ROUTE 8",
    "dropphycty": "HOFFMEISTER",
    "dropphyst": "NY",
    "dropphyzpp": 133539998,
    "dropmaladd": "0 STATE ROUTE 8",
    "dropmalcty": "HOFFMEISTER",
    "dropmalst": "NY",
    "dropmalzpp": 133539998,
    "dropsitphn": 3158265017,
    "dropsitlph": 3158265017,
    "dropsitcph": 3158265017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13900",
    "droptype": "D",
    "dropname": "HOGANSBURG",
    "dropdeladd": "11 SAINT REGIS ST",
    "dropdelcty": "HOGANSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 136559998,
    "dropphyadd": "11 SAINT REGIS ST",
    "dropphycty": "HOGANSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 136559998,
    "dropmaladd": "11 SAINT REGIS ST",
    "dropmalcty": "HOGANSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 136559998,
    "dropsitphn": 5183582277,
    "dropsitlph": 5183582277,
    "dropsitcph": 5183582277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13901",
    "droptype": "D",
    "dropname": "HOLBROOK",
    "dropdeladd": "445 FURROWS RD",
    "dropdelcty": "HOLBROOK",
    "dropdelst": "NY",
    "dropdelzpp": 117412726,
    "dropphyadd": "445 FURROWS RD",
    "dropphycty": "HOLBROOK",
    "dropphyst": "NY",
    "dropphyzpp": 117412726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLBROOK",
    "dropmalst": "NY",
    "dropmalzpp": 117419998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315880226,
    "dropfax": 6317370518
  },
  {
    "dcode": "D",
    "dropkey": "PV13902",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "2 ELM ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 144699998,
    "dropphyadd": "2 ELM ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 144699998,
    "dropmaladd": "2 ELM ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 144699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856577225,
    "dropsitcph": 5856577225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13904",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "11765 PARTRIDGE RD",
    "dropdelcty": "HOLLAND",
    "dropdelst": "NY",
    "dropdelzpp": 140809998,
    "dropphyadd": "11765 PARTRIDGE RD",
    "dropphycty": "HOLLAND",
    "dropphyst": "NY",
    "dropphyzpp": 140809998,
    "dropmaladd": "11765 PARTRIDGE RD",
    "dropmalcty": "HOLLAND",
    "dropmalst": "NY",
    "dropmalzpp": 140809998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165379400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13905",
    "droptype": "D",
    "dropname": "HOLLAND PATENT",
    "dropdeladd": "9565 MAIN ST",
    "dropdelcty": "HOLLAND PATENT",
    "dropdelst": "NY",
    "dropdelzpp": 133549998,
    "dropphyadd": "9565 MAIN ST",
    "dropphycty": "HOLLAND PATENT",
    "dropphyst": "NY",
    "dropphyzpp": 133549998,
    "dropmaladd": "9565 MAIN ST",
    "dropmalcty": "HOLLAND PATENT",
    "dropmalst": "NY",
    "dropmalzpp": 133549998,
    "dropsitphn": 3158654791,
    "dropsitlph": 3158654791,
    "dropsitcph": 3158654791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13907",
    "droptype": "D",
    "dropname": "HOLLEY",
    "dropdeladd": "5 WRIGHT ST",
    "dropdelcty": "HOLLEY",
    "dropdelst": "NY",
    "dropdelzpp": 144709998,
    "dropphyadd": "5 WRIGHT ST",
    "dropphycty": "HOLLEY",
    "dropphyst": "NY",
    "dropphyzpp": 144709998,
    "dropmaladd": "5 WRIGHT ST",
    "dropmalcty": "HOLLEY",
    "dropmalst": "NY",
    "dropmalzpp": 144709998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856386652,
    "dropsitcph": 5856386652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13911",
    "droptype": "D",
    "dropname": "HOLLOWVILLE",
    "dropdeladd": "255 COUNTY ROUTE 16",
    "dropdelcty": "HOLLOWVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125309800,
    "dropphyadd": "255 COUNTY ROUTE 16",
    "dropphycty": "HOLLOWVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLOWVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125309998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5188512005,
    "dropsitcph": 5188512005,
    "dropfax": 5188512005
  },
  {
    "dcode": "D",
    "dropkey": "PV13914",
    "droptype": "D",
    "dropname": "HOLMES",
    "dropdeladd": "298 ROUTE 292",
    "dropdelcty": "HOLMES",
    "dropdelst": "NY",
    "dropdelzpp": 125319998,
    "dropphyadd": "298 ROUTE 292",
    "dropphycty": "HOLMES",
    "dropphyst": "NY",
    "dropphyzpp": 125319998,
    "dropmaladd": "298 ROUTE 292",
    "dropmalcty": "HOLMES",
    "dropmalst": "NY",
    "dropmalzpp": 125319998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458783471,
    "dropsitcph": 8458783471,
    "dropfax": 8458787259
  },
  {
    "dcode": "D",
    "dropkey": "PV13916",
    "droptype": "D",
    "dropname": "HOLTSVILLE",
    "dropdeladd": "162 LONG ISLAND AVE",
    "dropdelcty": "HOLTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117421828,
    "dropphyadd": "162 LONG ISLAND AVE",
    "dropphycty": "HOLTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117421828,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117429998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314751761,
    "dropfax": 6314756840
  },
  {
    "dcode": "D",
    "dropkey": "PV13921",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "2 S MAIN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "NY",
    "dropdelzpp": 130779998,
    "dropphyadd": "2 S MAIN ST",
    "dropphycty": "HOMER",
    "dropphyst": "NY",
    "dropphyzpp": 130779998,
    "dropmaladd": "2 S MAIN ST",
    "dropmalcty": "HOMER",
    "dropmalst": "NY",
    "dropmalzpp": 130779998,
    "dropsitphn": 6077493071,
    "dropsitlph": 5184522299,
    "dropsitcph": 6077493071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13923",
    "droptype": "D",
    "dropname": "HONEOYE",
    "dropdeladd": "8627 MAIN ST",
    "dropdelcty": "HONEOYE",
    "dropdelst": "NY",
    "dropdelzpp": 144719998,
    "dropphyadd": "8627 MAIN ST",
    "dropphycty": "HONEOYE",
    "dropphyst": "NY",
    "dropphyzpp": 144719998,
    "dropmaladd": "8627 MAIN ST",
    "dropmalcty": "HONEOYE",
    "dropmalst": "NY",
    "dropmalzpp": 144719998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852295476,
    "dropsitcph": 5852295476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13924",
    "droptype": "D",
    "dropname": "HONEOYE FALLS",
    "dropdeladd": "39 W MAIN ST",
    "dropdelcty": "HONEOYE FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 144729998,
    "dropphyadd": "39 W MAIN ST",
    "dropphycty": "HONEOYE FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 144729998,
    "dropmaladd": "39 W MAIN ST",
    "dropmalcty": "HONEOYE FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 144729998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856243200,
    "dropsitcph": 5856243200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13929",
    "droptype": "D",
    "dropname": "HOOSICK FALLS",
    "dropdeladd": "35 MAIN ST",
    "dropdelcty": "HOOSICK FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 120909998,
    "dropphyadd": "35 MAIN ST",
    "dropphycty": "HOOSICK FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 120909998,
    "dropmaladd": "35 MAIN ST",
    "dropmalcty": "HOOSICK FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 120909998,
    "dropsitphn": 5186867011,
    "dropsitlph": 5186867011,
    "dropsitcph": 5186867011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13934",
    "droptype": "D",
    "dropname": "HOPEWELL JUNCTION",
    "dropdeladd": "815 ROUTE 82",
    "dropdelcty": "HOPEWELL JUNCTION",
    "dropdelst": "NY",
    "dropdelzpp": 125339998,
    "dropphyadd": "815 ROUTE 82",
    "dropphycty": "HOPEWELL JUNCTION",
    "dropphyst": "NY",
    "dropphyzpp": 125339998,
    "dropmaladd": "815 ROUTE 82",
    "dropmalcty": "HOPEWELL JUNCTION",
    "dropmalst": "NY",
    "dropmalzpp": 125339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452233048,
    "dropsitcph": 8452233048,
    "dropfax": 8452218688
  },
  {
    "dcode": "D",
    "dropkey": "PV13938",
    "droptype": "D",
    "dropname": "HORNELL",
    "dropdeladd": "23 GENESEE ST",
    "dropdelcty": "HORNELL",
    "dropdelst": "NY",
    "dropdelzpp": 148439998,
    "dropphyadd": "23 GENESEE ST",
    "dropphycty": "HORNELL",
    "dropphyst": "NY",
    "dropphyzpp": 148439998,
    "dropmaladd": "23 GENESEE ST",
    "dropmalcty": "HORNELL",
    "dropmalst": "NY",
    "dropmalzpp": 148439998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073242622,
    "dropsitcph": 6073242622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13939",
    "droptype": "D",
    "dropname": "HORSEHEADS",
    "dropdeladd": "624 TUTTLE AVE",
    "dropdelcty": "HORSEHEADS",
    "dropdelst": "NY",
    "dropdelzpp": 148459998,
    "dropphyadd": "624 TUTTLE AVE",
    "dropphycty": "HORSEHEADS",
    "dropphyst": "NY",
    "dropphyzpp": 148459998,
    "dropmaladd": "624 TUTTLE AVE",
    "dropmalcty": "HORSEHEADS",
    "dropmalst": "NY",
    "dropmalzpp": 148459998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077390371,
    "dropsitcph": 6077390371,
    "dropfax": 6077965562
  },
  {
    "dcode": "D",
    "dropkey": "PV13942",
    "droptype": "D",
    "dropname": "HORTONVILLE",
    "dropdeladd": "82 MAIN ST",
    "dropdelcty": "HORTONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127459998,
    "dropphyadd": "82 MAIN ST",
    "dropphycty": "HORTONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127459998,
    "dropmaladd": "82 MAIN ST",
    "dropmalcty": "HORTONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127459998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458875329,
    "dropsitcph": 8458875329,
    "dropfax": 8458875329
  },
  {
    "dcode": "D",
    "dropkey": "PV13945",
    "droptype": "D",
    "dropname": "HOUGHTON",
    "dropdeladd": "9672 ROUTE 19",
    "dropdelcty": "HOUGHTON",
    "dropdelst": "NY",
    "dropdelzpp": 147449998,
    "dropphyadd": "9672 ROUTE 19",
    "dropphycty": "HOUGHTON",
    "dropphyst": "NY",
    "dropphyzpp": 147449998,
    "dropmaladd": "9672 ROUTE 19",
    "dropmalcty": "HOUGHTON",
    "dropmalst": "NY",
    "dropmalzpp": 147449998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855678783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13952",
    "droptype": "D",
    "dropname": "HOWELLS",
    "dropdeladd": "126 NEW VERNON RD STE 1",
    "dropdelcty": "HOWELLS",
    "dropdelst": "NY",
    "dropdelzpp": 109329800,
    "dropphyadd": "126 NEW VERNON RD STE 1",
    "dropphycty": "HOWELLS",
    "dropphyst": "NY",
    "dropphyzpp": 109329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOWELLS",
    "dropmalst": "NY",
    "dropmalzpp": 109329998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453864222,
    "dropsitcph": 8453864222,
    "dropfax": 8453864222
  },
  {
    "dcode": "D",
    "dropkey": "PV13953",
    "droptype": "D",
    "dropname": "HOWES CAVE",
    "dropdeladd": "2929 STATE ROUTE 7",
    "dropdelcty": "HOWES CAVE",
    "dropdelst": "NY",
    "dropdelzpp": 120929998,
    "dropphyadd": "2929 STATE ROUTE 7",
    "dropphycty": "HOWES CAVE",
    "dropphyst": "NY",
    "dropphyzpp": 120929998,
    "dropmaladd": "2929 STATE ROUTE 7",
    "dropmalcty": "HOWES CAVE",
    "dropmalst": "NY",
    "dropmalzpp": 120929998,
    "dropsitphn": 5182968393,
    "dropsitlph": 5182968393,
    "dropsitcph": 5182968393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13957",
    "droptype": "D",
    "dropname": "HUBBARDSVILLE",
    "dropdeladd": "2434 POOLVILLE RD",
    "dropdelcty": "HUBBARDSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133559998,
    "dropphyadd": "2434 POOLVILLE RD",
    "dropphycty": "HUBBARDSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133559998,
    "dropmaladd": "2434 POOLVILLE RD",
    "dropmalcty": "HUBBARDSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133559998,
    "dropsitphn": 3156912300,
    "dropsitlph": 3156912300,
    "dropsitcph": 3156912300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13961",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "402 UNION ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 125349998,
    "dropphyadd": "402 UNION ST",
    "dropphycty": "HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 125349998,
    "dropmaladd": "402 UNION ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 125349998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5188283672,
    "dropsitcph": 5188283672,
    "dropfax": 5188220632
  },
  {
    "dcode": "D",
    "dropkey": "PV13962",
    "droptype": "D",
    "dropname": "HUDSON FALLS",
    "dropdeladd": "114 MAIN ST",
    "dropdelcty": "HUDSON FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 128399998,
    "dropphyadd": "114 MAIN ST",
    "dropphycty": "HUDSON FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 128399998,
    "dropmaladd": "114 MAIN ST",
    "dropmalcty": "HUDSON FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128399998,
    "dropsitphn": 5187472144,
    "dropsitlph": 5187472144,
    "dropsitcph": 5187472144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13965",
    "droptype": "D",
    "dropname": "HUGHSONVILLE",
    "dropdeladd": "2337 ROUTE 9D",
    "dropdelcty": "HUGHSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125379800,
    "dropphyadd": "2337 ROUTE 9D",
    "dropphycty": "HUGHSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUGHSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125379998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452970941,
    "dropsitcph": 8452970941,
    "dropfax": 8452970941
  },
  {
    "dcode": "D",
    "dropkey": "PV13968",
    "droptype": "D",
    "dropname": "HUGUENOT",
    "dropdeladd": "435 ROUTE 209",
    "dropdelcty": "HUGUENOT",
    "dropdelst": "NY",
    "dropdelzpp": 127469998,
    "dropphyadd": "435 ROUTE 209",
    "dropphycty": "HUGUENOT",
    "dropphyst": "NY",
    "dropphyzpp": 127469998,
    "dropmaladd": "435 ROUTE 209",
    "dropmalcty": "HUGUENOT",
    "dropmalst": "NY",
    "dropmalzpp": 127469998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458563076,
    "dropsitcph": 8458563076,
    "dropfax": 8458563076
  },
  {
    "dcode": "D",
    "dropkey": "PV13970",
    "droptype": "D",
    "dropname": "HULETTS LANDING",
    "dropdeladd": "962 COUNTY ROUTE 6",
    "dropdelcty": "HULETTS LANDING",
    "dropdelst": "NY",
    "dropdelzpp": 128419998,
    "dropphyadd": "962 COUNTY ROUTE 6",
    "dropphycty": "HULETTS LANDING",
    "dropphyst": "NY",
    "dropphyzpp": 128419998,
    "dropmaladd": "962 COUNTY ROUTE 6",
    "dropmalcty": "HULETTS LANDING",
    "dropmalst": "NY",
    "dropmalzpp": 128419998,
    "dropsitphn": 5184992406,
    "dropsitlph": 5184992406,
    "dropsitcph": 5184992406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13973",
    "droptype": "D",
    "dropname": "HUME",
    "dropdeladd": "10912 COUNTY ROAD 23",
    "dropdelcty": "HUME",
    "dropdelst": "NY",
    "dropdelzpp": 147459800,
    "dropphyadd": "10912 COUNTY ROAD 23",
    "dropphycty": "HUME",
    "dropphyst": "NY",
    "dropphyzpp": 147459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUME",
    "dropmalst": "NY",
    "dropmalzpp": 147459998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855678831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13975",
    "droptype": "D",
    "dropname": "HUNT",
    "dropdeladd": "9926 SMITH HILL RD",
    "dropdelcty": "HUNT",
    "dropdelst": "NY",
    "dropdelzpp": 148469998,
    "dropphyadd": "9926 SMITH HILL RD",
    "dropphycty": "HUNT",
    "dropphyst": "NY",
    "dropphyzpp": 148469998,
    "dropmaladd": "9926 SMITH HILL RD",
    "dropmalcty": "HUNT",
    "dropmalst": "NY",
    "dropmalzpp": 148469998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854762362,
    "dropsitcph": 5854762362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV13979",
    "droptype": "D",
    "dropname": "HUNTER",
    "dropdeladd": "7975 MAIN ST",
    "dropdelcty": "HUNTER",
    "dropdelst": "NY",
    "dropdelzpp": 124429998,
    "dropphyadd": "7975 MAIN ST",
    "dropphycty": "HUNTER",
    "dropphyst": "NY",
    "dropphyzpp": 124429998,
    "dropmaladd": "7975 MAIN ST",
    "dropmalcty": "HUNTER",
    "dropmalst": "NY",
    "dropmalzpp": 124429998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5182634771,
    "dropsitcph": 5182634771,
    "dropfax": 5182634771
  },
  {
    "dcode": "D",
    "dropkey": "PV13982",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "55 GERARD ST",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 117433256,
    "dropphyadd": "55 GERARD ST",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 117433256,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 117439998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314273825,
    "dropfax": 6314270307
  },
  {
    "dcode": "D",
    "dropkey": "PV13988",
    "droptype": "D",
    "dropname": "HUNTINGTON STATION",
    "dropdeladd": "888 E JERICHO TPKE",
    "dropdelcty": "HUNTINGTON STATION",
    "dropdelst": "NY",
    "dropdelzpp": 117467530,
    "dropphyadd": "888 E JERICHO TPKE",
    "dropphycty": "HUNTINGTON STATION",
    "dropphyst": "NY",
    "dropphyzpp": 117467530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON STATION",
    "dropmalst": "NY",
    "dropmalzpp": 117469998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314270594,
    "dropfax": 6312714437
  },
  {
    "dcode": "D",
    "dropkey": "PV13990",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "4 MAIN ST",
    "dropdelcty": "HURLEY",
    "dropdelst": "NY",
    "dropdelzpp": 124439998,
    "dropphyadd": "4 MAIN ST",
    "dropphycty": "HURLEY",
    "dropphyst": "NY",
    "dropphyzpp": 124439998,
    "dropmaladd": "4 MAIN ST",
    "dropmalcty": "HURLEY",
    "dropmalst": "NY",
    "dropmalzpp": 124439998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453386018,
    "dropsitcph": 8453386018,
    "dropfax": 8453409307
  },
  {
    "dcode": "D",
    "dropkey": "PV13991",
    "droptype": "D",
    "dropname": "HURLEYVILLE",
    "dropdeladd": "6 MONGAUP RD",
    "dropdelcty": "HURLEYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127479998,
    "dropphyadd": "6 MONGAUP RD",
    "dropphycty": "HURLEYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127479998,
    "dropmaladd": "6 MONGAUP RD",
    "dropmalcty": "HURLEYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127479998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454345120,
    "dropsitcph": 8454345120,
    "dropfax": 8454368621
  },
  {
    "dcode": "D",
    "dropkey": "PV13992",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "1 E MARKET ST",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 125389998,
    "dropphyadd": "1 E MARKET ST",
    "dropphycty": "HYDE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 125389998,
    "dropmaladd": "1 E MARKET ST",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 125389998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452296806,
    "dropsitcph": 8452290112,
    "dropfax": 8452295614
  },
  {
    "dcode": "D",
    "dropkey": "PV13999",
    "droptype": "D",
    "dropname": "ILION",
    "dropdeladd": "48 1ST ST",
    "dropdelcty": "ILION",
    "dropdelst": "NY",
    "dropdelzpp": 133579998,
    "dropphyadd": "48 1ST ST",
    "dropphycty": "ILION",
    "dropphyst": "NY",
    "dropphyzpp": 133579998,
    "dropmaladd": "48 1ST ST",
    "dropmalcty": "ILION",
    "dropmalst": "NY",
    "dropmalzpp": 133579998,
    "dropsitphn": 3158945007,
    "dropsitlph": 3158945007,
    "dropsitcph": 3158945007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14005",
    "droptype": "D",
    "dropname": "INDIAN LAKE",
    "dropdeladd": "6316 NYS ROUTE 30",
    "dropdelcty": "INDIAN LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 128429998,
    "dropphyadd": "6316 NYS ROUTE 30",
    "dropphycty": "INDIAN LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 128429998,
    "dropmaladd": "6316 NYS ROUTE 30",
    "dropmalcty": "INDIAN LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 128429998,
    "dropsitphn": 5186485252,
    "dropsitlph": 5186485252,
    "dropsitcph": 5186485252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14010",
    "droptype": "D",
    "dropname": "INLET",
    "dropdeladd": "166 N ROUTE 28",
    "dropdelcty": "INLET",
    "dropdelst": "NY",
    "dropdelzpp": 133609998,
    "dropphyadd": "166 N ROUTE 28",
    "dropphycty": "INLET",
    "dropphyst": "NY",
    "dropphyzpp": 133609998,
    "dropmaladd": "166 N ROUTE 28",
    "dropmalcty": "INLET",
    "dropmalst": "NY",
    "dropmalzpp": 133609998,
    "dropsitphn": 3153572012,
    "dropsitlph": 3153572012,
    "dropsitcph": 3153572012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14011",
    "droptype": "D",
    "dropname": "INTERLAKEN",
    "dropdeladd": "8409 MAIN ST",
    "dropdelcty": "INTERLAKEN",
    "dropdelst": "NY",
    "dropdelzpp": 148479998,
    "dropphyadd": "8409 MAIN ST",
    "dropphycty": "INTERLAKEN",
    "dropphyst": "NY",
    "dropphyzpp": 148479998,
    "dropmaladd": "8409 MAIN ST",
    "dropmalcty": "INTERLAKEN",
    "dropmalst": "NY",
    "dropmalzpp": 148479998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075328316,
    "dropsitcph": 6075328316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14015",
    "droptype": "D",
    "dropname": "IONIA",
    "dropdeladd": "8289 COUNTY ROAD 14",
    "dropdelcty": "IONIA",
    "dropdelst": "NY",
    "dropdelzpp": 144759998,
    "dropphyadd": "8289 COUNTY ROAD 14",
    "dropphycty": "IONIA",
    "dropphyst": "NY",
    "dropphyzpp": 144759998,
    "dropmaladd": "8289 COUNTY ROAD 14",
    "dropmalcty": "IONIA",
    "dropmalst": "NY",
    "dropmalzpp": 144759998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856576444,
    "dropsitcph": 5856576444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14022",
    "droptype": "D",
    "dropname": "IRVING",
    "dropdeladd": "12746 ERIE ST",
    "dropdelcty": "IRVING",
    "dropdelst": "NY",
    "dropdelzpp": 140819998,
    "dropphyadd": "12746 ERIE ST",
    "dropphycty": "IRVING",
    "dropphyst": "NY",
    "dropphyzpp": 140819998,
    "dropmaladd": "12746 ERIE ST",
    "dropmalcty": "IRVING",
    "dropmalst": "NY",
    "dropmalzpp": 140819998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169342077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14025",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "25 N BUCKHOUT ST",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 105339998,
    "dropphyadd": "25 N BUCKHOUT ST",
    "dropphycty": "IRVINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 105339998,
    "dropmaladd": "25 N BUCKHOUT ST",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 105339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145916487,
    "dropsitcph": 9145916487,
    "dropfax": 9145914296
  },
  {
    "dcode": "D",
    "dropkey": "PV14032",
    "droptype": "D",
    "dropname": "ISLAND PARK",
    "dropdeladd": "367 LONG BEACH RD",
    "dropdelcty": "ISLAND PARK",
    "dropdelst": "NY",
    "dropdelzpp": 115581551,
    "dropphyadd": "367 LONG BEACH RD",
    "dropphycty": "ISLAND PARK",
    "dropphyst": "NY",
    "dropphyzpp": 115581551,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISLAND PARK",
    "dropmalst": "NY",
    "dropmalzpp": 115589998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5164329537,
    "dropfax": 5168970504
  },
  {
    "dcode": "D",
    "dropkey": "PV14040",
    "droptype": "D",
    "dropname": "ISLIP",
    "dropdeladd": "309 MAIN ST UNIT 3",
    "dropdelcty": "ISLIP",
    "dropdelst": "NY",
    "dropdelzpp": 117513453,
    "dropphyadd": "309 MAIN ST UNIT 3",
    "dropphycty": "ISLIP",
    "dropphyst": "NY",
    "dropphyzpp": 117513453,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISLIP",
    "dropmalst": "NY",
    "dropmalzpp": 117519998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315817931,
    "dropfax": 6312241376
  },
  {
    "dcode": "D",
    "dropkey": "PV14043",
    "droptype": "D",
    "dropname": "ISLIP TERRACE",
    "dropdeladd": "136 CARLETON AVE",
    "dropdelcty": "ISLIP TERRACE",
    "dropdelst": "NY",
    "dropdelzpp": 117522641,
    "dropphyadd": "136 CARLETON AVE",
    "dropphycty": "ISLIP TERRACE",
    "dropphyst": "NY",
    "dropphyzpp": 117522641,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISLIP TERRACE",
    "dropmalst": "NY",
    "dropmalzpp": 117529998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315817894,
    "dropfax": 6312249083
  },
  {
    "dcode": "D",
    "dropkey": "PV14045",
    "droptype": "D",
    "dropname": "ITHACA",
    "dropdeladd": "757 WARREN RD",
    "dropdelcty": "ITHACA",
    "dropdelst": "NY",
    "dropdelzpp": 148509998,
    "dropphyadd": "757 WARREN RD",
    "dropphycty": "ITHACA",
    "dropphyst": "NY",
    "dropphyzpp": 148509998,
    "dropmaladd": "757 WARREN RD",
    "dropmalcty": "ITHACA",
    "dropmalst": "NY",
    "dropmalzpp": 148509998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072660566,
    "dropsitcph": 6072660566,
    "dropfax": 6072660571
  },
  {
    "dcode": "D",
    "dropkey": "PV14054",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "1852 TRUMANSBURG RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 148549800,
    "dropphyadd": "1852 TRUMANSBURG RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 148549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 148549998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073875606,
    "dropsitcph": 6073875606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14056",
    "droptype": "D",
    "dropname": "JAMAICA",
    "dropdeladd": "8840 164TH ST",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114329998,
    "dropphyadd": "8840 164TH ST",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114329998,
    "dropmaladd": "8840 164TH ST",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114329998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7189901090,
    "dropfax": 7182171135
  },
  {
    "dcode": "D",
    "dropkey": "PV14062",
    "droptype": "D",
    "dropname": "JAMESPORT",
    "dropdeladd": "1451 ROUTE 25",
    "dropdelcty": "JAMESPORT",
    "dropdelst": "NY",
    "dropdelzpp": 119479700,
    "dropphyadd": "1451 ROUTE 25",
    "dropphycty": "JAMESPORT",
    "dropphyst": "NY",
    "dropphyzpp": 119479700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAMESPORT",
    "dropmalst": "NY",
    "dropmalzpp": 119479998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317225946,
    "dropfax": 6317225637
  },
  {
    "dcode": "D",
    "dropkey": "PV14065",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "300 E 3RD ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 147019998,
    "dropphyadd": "300 E 3RD ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 147019998,
    "dropmaladd": "300 E 3RD ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 147019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166642133,
    "dropfax": 7164832576
  },
  {
    "dcode": "D",
    "dropkey": "PV14067",
    "droptype": "D",
    "dropname": "JAMESVILLE",
    "dropdeladd": "6499 E SENECA TPKE",
    "dropdelcty": "JAMESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130789998,
    "dropphyadd": "6499 E SENECA TPKE",
    "dropphycty": "JAMESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130789998,
    "dropmaladd": "6499 E SENECA TPKE",
    "dropmalcty": "JAMESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130789998,
    "dropsitphn": 3154693046,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154693046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14071",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "3807 LIBRARY ST",
    "dropdelcty": "JASPER",
    "dropdelst": "NY",
    "dropdelzpp": 148559998,
    "dropphyadd": "3807 LIBRARY ST",
    "dropphycty": "JASPER",
    "dropphyst": "NY",
    "dropphyzpp": 148559998,
    "dropmaladd": "3807 LIBRARY ST",
    "dropmalcty": "JASPER",
    "dropmalst": "NY",
    "dropmalzpp": 148559998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077923771,
    "dropsitcph": 6077923771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14072",
    "droptype": "D",
    "dropname": "JAVA CENTER",
    "dropdeladd": "1423 ROUTE 78",
    "dropdelcty": "JAVA CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 140829998,
    "dropphyadd": "1423 ROUTE 78",
    "dropphycty": "JAVA CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 140829998,
    "dropmaladd": "1423 ROUTE 78",
    "dropmalcty": "JAVA CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 140829998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854579631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14073",
    "droptype": "D",
    "dropname": "JAVA VILLAGE",
    "dropdeladd": "4530 ROUTE 78",
    "dropdelcty": "JAVA VILLAGE",
    "dropdelst": "NY",
    "dropdelzpp": 140839800,
    "dropphyadd": "4530 ROUTE 78",
    "dropphycty": "JAVA VILLAGE",
    "dropphyst": "NY",
    "dropphyzpp": 140839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAVA VILLAGE",
    "dropmalst": "NY",
    "dropmalzpp": 140839998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854573853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14075",
    "droptype": "D",
    "dropname": "JAY",
    "dropdeladd": "12941 NYS RT 9N",
    "dropdelcty": "JAY",
    "dropdelst": "NY",
    "dropdelzpp": 129419998,
    "dropphyadd": "12941 NYS RT 9N",
    "dropphycty": "JAY",
    "dropphyst": "NY",
    "dropphyzpp": 129419998,
    "dropmaladd": "12941 NYS RT 9N",
    "dropmalcty": "JAY",
    "dropmalst": "NY",
    "dropmalzpp": 129419998,
    "dropsitphn": 5189467200,
    "dropsitlph": 5189467200,
    "dropsitcph": 5189467200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14077",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "102 PARK AVE",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "NY",
    "dropdelzpp": 120939998,
    "dropphyadd": "102 PARK AVE",
    "dropphycty": "JEFFERSON",
    "dropphyst": "NY",
    "dropphyzpp": 120939998,
    "dropmaladd": "102 PARK AVE",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "NY",
    "dropmalzpp": 120939998,
    "dropsitphn": 6076527707,
    "dropsitlph": 6076527707,
    "dropsitcph": 6076527707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14079",
    "droptype": "D",
    "dropname": "JEFFERSON VALLEY",
    "dropdeladd": "3652 LEE RD",
    "dropdelcty": "JEFFERSON VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 105359998,
    "dropphyadd": "3652 LEE RD",
    "dropphycty": "JEFFERSON VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 105359998,
    "dropmaladd": "3652 LEE RD",
    "dropmalcty": "JEFFERSON VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 105359998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142455705,
    "dropsitcph": 9142455705,
    "dropfax": 9142434908
  },
  {
    "dcode": "D",
    "dropkey": "PV14080",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "4915 STATE ROUTE 52",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127489998,
    "dropphyadd": "4915 STATE ROUTE 52",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127489998,
    "dropmaladd": "4915 STATE ROUTE 52",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127489998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454824265,
    "dropsitcph": 8454824265,
    "dropfax": 8454825287
  },
  {
    "dcode": "D",
    "dropkey": "PV14083",
    "droptype": "D",
    "dropname": "JERICHO",
    "dropdeladd": "425 N BROADWAY",
    "dropdelcty": "JERICHO",
    "dropdelst": "NY",
    "dropdelzpp": 117532140,
    "dropphyadd": "425 N BROADWAY",
    "dropphycty": "JERICHO",
    "dropphyst": "NY",
    "dropphyzpp": 117532140,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JERICHO",
    "dropmalst": "NY",
    "dropmalzpp": 117539998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166816248,
    "dropfax": 5166819131
  },
  {
    "dcode": "D",
    "dropkey": "PV14090",
    "droptype": "D",
    "dropname": "JEWETT",
    "dropdeladd": "4800 ROUTE 23C",
    "dropdelcty": "JEWETT",
    "dropdelst": "NY",
    "dropdelzpp": 124449998,
    "dropphyadd": "4800 ROUTE 23C",
    "dropphycty": "JEWETT",
    "dropphyst": "NY",
    "dropphyzpp": 124449998,
    "dropmaladd": "4800 ROUTE 23C",
    "dropmalcty": "JEWETT",
    "dropmalst": "NY",
    "dropmalzpp": 124449998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187343692,
    "dropsitcph": 5187343692,
    "dropfax": 5187343692
  },
  {
    "dcode": "D",
    "dropkey": "PV14096",
    "droptype": "D",
    "dropname": "JOHNSBURG",
    "dropdeladd": "3462 STATE ROUTE 8",
    "dropdelcty": "JOHNSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 128439998,
    "dropphyadd": "3462 STATE ROUTE 8",
    "dropphycty": "JOHNSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 128439998,
    "dropmaladd": "3462 STATE ROUTE 8",
    "dropmalcty": "JOHNSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 128439998,
    "dropsitphn": 5182512238,
    "dropsitlph": 5182512238,
    "dropsitcph": 5182512238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14097",
    "droptype": "D",
    "dropname": "JOHNSON",
    "dropdeladd": "83 COUNTY HIGHWAY 22",
    "dropdelcty": "JOHNSON",
    "dropdelst": "NY",
    "dropdelzpp": 109339800,
    "dropphyadd": "83 COUNTY HIGHWAY 22",
    "dropphycty": "JOHNSON",
    "dropphyst": "NY",
    "dropphyzpp": 109339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHNSON",
    "dropmalst": "NY",
    "dropmalzpp": 109339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453553112,
    "dropsitcph": 8453553112,
    "dropfax": 8453553112
  },
  {
    "dcode": "D",
    "dropkey": "PV14098",
    "droptype": "D",
    "dropname": "JOHNSON CITY",
    "dropdeladd": "307 MAIN ST",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "NY",
    "dropdelzpp": 137909998,
    "dropphyadd": "307 MAIN ST",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "NY",
    "dropphyzpp": 137909998,
    "dropmaladd": "307 MAIN ST",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "NY",
    "dropmalzpp": 137909998,
    "dropsitphn": 6077294066,
    "dropsitlph": 6077294066,
    "dropsitcph": 6077294066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14101",
    "droptype": "D",
    "dropname": "JOHNSONVILLE",
    "dropdeladd": "2442 STATE ROUTE 67",
    "dropdelcty": "JOHNSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 120943836,
    "dropphyadd": "2442 STATE ROUTE 67",
    "dropphycty": "JOHNSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 120943836,
    "dropmaladd": "2442 STATE ROUTE 67",
    "dropmalcty": "JOHNSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 120949998,
    "dropsitphn": 5187534938,
    "dropsitlph": 5187534938,
    "dropsitcph": 5187534938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14102",
    "droptype": "D",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "14 N WILLIAM ST",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 120959998,
    "dropphyadd": "14 N WILLIAM ST",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 120959998,
    "dropmaladd": "14 N WILLIAM ST",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 120959998,
    "dropsitphn": 5187623314,
    "dropsitlph": 5187623314,
    "dropsitcph": 5187623314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14107",
    "droptype": "D",
    "dropname": "JORDAN",
    "dropdeladd": "9 MECHANIC ST",
    "dropdelcty": "JORDAN",
    "dropdelst": "NY",
    "dropdelzpp": 130809998,
    "dropphyadd": "9 MECHANIC ST",
    "dropphycty": "JORDAN",
    "dropphyst": "NY",
    "dropphyzpp": 130809998,
    "dropmaladd": "9 MECHANIC ST",
    "dropmalcty": "JORDAN",
    "dropmalst": "NY",
    "dropmalzpp": 130809998,
    "dropsitphn": 3156893048,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156893048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14108",
    "droptype": "D",
    "dropname": "JORDANVILLE",
    "dropdeladd": "137 MAIN ST",
    "dropdelcty": "JORDANVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133619998,
    "dropphyadd": "137 MAIN ST",
    "dropphycty": "JORDANVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133619998,
    "dropmaladd": "137 MAIN ST",
    "dropmalcty": "JORDANVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133619998,
    "dropsitphn": 3158582884,
    "dropsitlph": 3158582884,
    "dropsitcph": 3158582884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14112",
    "droptype": "D",
    "dropname": "KANONA",
    "dropdeladd": "7662 N MAIN ST",
    "dropdelcty": "KANONA",
    "dropdelst": "NY",
    "dropdelzpp": 148569800,
    "dropphyadd": "7662 N MAIN ST",
    "dropphycty": "KANONA",
    "dropphyst": "NY",
    "dropphyzpp": 148569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KANONA",
    "dropmalst": "NY",
    "dropmalzpp": 148569998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077763622,
    "dropsitcph": 6077763622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14114",
    "droptype": "D",
    "dropname": "KATONAH",
    "dropdeladd": "292 KATONAH AVE",
    "dropdelcty": "KATONAH",
    "dropdelst": "NY",
    "dropdelzpp": 105362144,
    "dropphyadd": "292 KATONAH AVE",
    "dropphycty": "KATONAH",
    "dropphyst": "NY",
    "dropphyzpp": 105362144,
    "dropmaladd": "292 KATONAH AVE",
    "dropmalcty": "KATONAH",
    "dropmalst": "NY",
    "dropmalzpp": 105369998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142326158,
    "dropsitcph": 9142326158,
    "dropfax": 9142322954
  },
  {
    "dcode": "D",
    "dropkey": "PV14116",
    "droptype": "D",
    "dropname": "KATTSKILL BAY",
    "dropdeladd": "1488 PILOT KNOB RD",
    "dropdelcty": "KATTSKILL BAY",
    "dropdelst": "NY",
    "dropdelzpp": 128441804,
    "dropphyadd": "1488 PILOT KNOB RD",
    "dropphycty": "KATTSKILL BAY",
    "dropphyst": "NY",
    "dropphyzpp": 128441804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KATTSKILL BAY",
    "dropmalst": "NY",
    "dropmalzpp": 128449998,
    "dropsitphn": 5186569069,
    "dropsitlph": 5186569069,
    "dropsitcph": 5186569069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14118",
    "droptype": "D",
    "dropname": "KAUNEONGA LAKE",
    "dropdeladd": "3584 STATE ROUTE 55",
    "dropdelcty": "KAUNEONGA LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127499800,
    "dropphyadd": "3584 STATE ROUTE 55",
    "dropphycty": "KAUNEONGA LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAUNEONGA LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127499998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455838159,
    "dropsitcph": 8455838159,
    "dropfax": 8455838117
  },
  {
    "dcode": "D",
    "dropkey": "PV14121",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "2841 NYS ROUTE 73 STE 2",
    "dropdelcty": "KEENE",
    "dropdelst": "NY",
    "dropdelzpp": 129428500,
    "dropphyadd": "2841 NYS ROUTE 73 STE 2",
    "dropphycty": "KEENE",
    "dropphyst": "NY",
    "dropphyzpp": 129428500,
    "dropmaladd": "2841 NYS ROUTE 73 STE 2",
    "dropmalcty": "KEENE",
    "dropmalst": "NY",
    "dropmalzpp": 129428500,
    "dropsitphn": 5185769966,
    "dropsitlph": 5185769966,
    "dropsitcph": 5185769966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14123",
    "droptype": "D",
    "dropname": "KEESEVILLE",
    "dropdeladd": "100 KENT ST",
    "dropdelcty": "KEESEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129449998,
    "dropphyadd": "100 KENT ST",
    "dropphycty": "KEESEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129449998,
    "dropmaladd": "100 KENT ST",
    "dropmalcty": "KEESEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129449998,
    "dropsitphn": 5188349061,
    "dropsitlph": 5188349061,
    "dropsitcph": 5188349061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14126",
    "droptype": "D",
    "dropname": "KENDALL",
    "dropdeladd": "1870 KENDALL RD",
    "dropdelcty": "KENDALL",
    "dropdelst": "NY",
    "dropdelzpp": 144769998,
    "dropphyadd": "1870 KENDALL RD",
    "dropphycty": "KENDALL",
    "dropphyst": "NY",
    "dropphyzpp": 144769998,
    "dropmaladd": "1870 KENDALL RD",
    "dropmalcty": "KENDALL",
    "dropmalst": "NY",
    "dropmalzpp": 144769998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856592210,
    "dropsitcph": 5856592210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14130",
    "droptype": "D",
    "dropname": "KENNEDY",
    "dropdeladd": "3600 CHURCH ST",
    "dropdelcty": "KENNEDY",
    "dropdelst": "NY",
    "dropdelzpp": 147479800,
    "dropphyadd": "3600 CHURCH ST",
    "dropphycty": "KENNEDY",
    "dropphyst": "NY",
    "dropphyzpp": 147479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNEDY",
    "dropmalst": "NY",
    "dropmalzpp": 147479998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162673855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14131",
    "droptype": "D",
    "dropname": "KENOZA LAKE",
    "dropdeladd": "5691 STATE ROUTE 52",
    "dropdelcty": "KENOZA LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127509998,
    "dropphyadd": "5691 STATE ROUTE 52",
    "dropphycty": "KENOZA LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127509998,
    "dropmaladd": "5691 STATE ROUTE 52",
    "dropmalcty": "KENOZA LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127509998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454825234,
    "dropsitcph": 8454825234,
    "dropfax": 8454829316
  },
  {
    "dcode": "D",
    "dropkey": "PV14136",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "1788 KENT RD",
    "dropdelcty": "KENT",
    "dropdelst": "NY",
    "dropdelzpp": 144779998,
    "dropphyadd": "1788 KENT RD",
    "dropphycty": "KENT",
    "dropphyst": "NY",
    "dropphyzpp": 144779998,
    "dropmaladd": "1788 KENT RD",
    "dropmalcty": "KENT",
    "dropmalst": "NY",
    "dropmalzpp": 144779998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856823172,
    "dropsitcph": 5856823172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14141",
    "droptype": "D",
    "dropname": "KERHONKSON",
    "dropdeladd": "17 WEST ST",
    "dropdelcty": "KERHONKSON",
    "dropdelst": "NY",
    "dropdelzpp": 124469998,
    "dropphyadd": "17 WEST ST",
    "dropphycty": "KERHONKSON",
    "dropphyst": "NY",
    "dropphyzpp": 124469998,
    "dropmaladd": "17 WEST ST",
    "dropmalcty": "KERHONKSON",
    "dropmalst": "NY",
    "dropmalzpp": 124469998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456265470,
    "dropsitcph": 8456265470,
    "dropfax": 8456267663
  },
  {
    "dcode": "D",
    "dropkey": "PV14144",
    "droptype": "D",
    "dropname": "KEUKA PARK",
    "dropdeladd": "508 ASSEMBLY AVE",
    "dropdelcty": "KEUKA PARK",
    "dropdelst": "NY",
    "dropdelzpp": 144789998,
    "dropphyadd": "508 ASSEMBLY AVE",
    "dropphycty": "KEUKA PARK",
    "dropphyst": "NY",
    "dropphyzpp": 144789998,
    "dropmaladd": "508 ASSEMBLY AVE",
    "dropmalcty": "KEUKA PARK",
    "dropmalst": "NY",
    "dropmalzpp": 144789998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155363667,
    "dropsitcph": 3155363667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14148",
    "droptype": "D",
    "dropname": "KIAMESHA LAKE",
    "dropdeladd": "4668 STATE ROUTE 42",
    "dropdelcty": "KIAMESHA LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127519998,
    "dropphyadd": "4668 STATE ROUTE 42",
    "dropphycty": "KIAMESHA LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127519998,
    "dropmaladd": "4668 STATE ROUTE 42",
    "dropmalcty": "KIAMESHA LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127519998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457942336,
    "dropsitcph": 8457942336,
    "dropfax": 8457945416
  },
  {
    "dcode": "D",
    "dropkey": "PV14151",
    "droptype": "D",
    "dropname": "KILL BUCK",
    "dropdeladd": "3753 OAKWOOD ST",
    "dropdelcty": "KILL BUCK",
    "dropdelst": "NY",
    "dropdelzpp": 147489998,
    "dropphyadd": "3753 OAKWOOD ST",
    "dropphycty": "KILL BUCK",
    "dropphyst": "NY",
    "dropphyzpp": 147489998,
    "dropmaladd": "3753 OAKWOOD ST",
    "dropmalcty": "KILL BUCK",
    "dropmalst": "NY",
    "dropmalzpp": 147489998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169457556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14152",
    "droptype": "D",
    "dropname": "KILLAWOG",
    "dropdeladd": "614 JENNINGS CREEK RD",
    "dropdelcty": "KILLAWOG",
    "dropdelst": "NY",
    "dropdelzpp": 137949998,
    "dropphyadd": "614 JENNINGS CREEK RD",
    "dropphycty": "KILLAWOG",
    "dropphyst": "NY",
    "dropphyzpp": 137949998,
    "dropmaladd": "614 JENNINGS CREEK RD",
    "dropmalcty": "KILLAWOG",
    "dropmalst": "NY",
    "dropmalzpp": 137949998,
    "dropsitphn": 6078493969,
    "dropsitlph": 6078493969,
    "dropsitcph": 6078493969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14153",
    "droptype": "D",
    "dropname": "KINDERHOOK",
    "dropdeladd": "3 HUDSON ST",
    "dropdelcty": "KINDERHOOK",
    "dropdelst": "NY",
    "dropdelzpp": 121069998,
    "dropphyadd": "3 HUDSON ST",
    "dropphycty": "KINDERHOOK",
    "dropphyst": "NY",
    "dropphyzpp": 121069998,
    "dropmaladd": "3 HUDSON ST",
    "dropmalcty": "KINDERHOOK",
    "dropmalst": "NY",
    "dropmalzpp": 121069998,
    "dropsitphn": 5187587782,
    "dropsitlph": 5187587782,
    "dropsitcph": 5187587782,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14154",
    "droptype": "D",
    "dropname": "KING FERRY",
    "dropdeladd": "8761 STATE ROUTE 90 N",
    "dropdelcty": "KING FERRY",
    "dropdelst": "NY",
    "dropdelzpp": 130819998,
    "dropphyadd": "8761 STATE ROUTE 90 N",
    "dropphycty": "KING FERRY",
    "dropphyst": "NY",
    "dropphyzpp": 130819998,
    "dropmaladd": "8761 STATE ROUTE 90 N",
    "dropmalcty": "KING FERRY",
    "dropmalst": "NY",
    "dropmalzpp": 130819998,
    "dropsitphn": 3153648662,
    "dropsitlph": 5184582299,
    "dropsitcph": 3153648662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14157",
    "droptype": "D",
    "dropname": "KINGS PARK",
    "dropdeladd": "125 E MAIN ST",
    "dropdelcty": "KINGS PARK",
    "dropdelst": "NY",
    "dropdelzpp": 117543819,
    "dropphyadd": "125 E MAIN ST",
    "dropphycty": "KINGS PARK",
    "dropphyst": "NY",
    "dropphyzpp": 117543819,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGS PARK",
    "dropmalst": "NY",
    "dropmalzpp": 117549998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312696481,
    "dropfax": 6312697875
  },
  {
    "dcode": "D",
    "dropkey": "PV14168",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "90 CORNELL ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "NY",
    "dropdelzpp": 124019998,
    "dropphyadd": "90 CORNELL ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "NY",
    "dropphyzpp": 124019998,
    "dropmaladd": "90 CORNELL ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "NY",
    "dropmalzpp": 124019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453312286,
    "dropsitcph": 8453312286,
    "dropfax": 8453393282
  },
  {
    "dcode": "D",
    "dropkey": "PV14172",
    "droptype": "D",
    "dropname": "KIRKVILLE",
    "dropdeladd": "6365 N KIRKVILLE RD",
    "dropdelcty": "KIRKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 130829998,
    "dropphyadd": "6365 N KIRKVILLE RD",
    "dropphycty": "KIRKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 130829998,
    "dropmaladd": "6365 N KIRKVILLE RD",
    "dropmalcty": "KIRKVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 130829998,
    "dropsitphn": 3156563519,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156563519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14175",
    "droptype": "D",
    "dropname": "KIRKWOOD",
    "dropdeladd": "78 CRESCENT DR",
    "dropdelcty": "KIRKWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 137959998,
    "dropphyadd": "78 CRESCENT DR",
    "dropphycty": "KIRKWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 137959998,
    "dropmaladd": "78 CRESCENT DR",
    "dropmalcty": "KIRKWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 137959998,
    "dropsitphn": 6077732174,
    "dropsitlph": 6077753114,
    "dropsitcph": 6077753114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14209",
    "droptype": "D",
    "dropname": "LA FARGEVILLE",
    "dropdeladd": "36327 STATE ROUTE 180",
    "dropdelcty": "LA FARGEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136569998,
    "dropphyadd": "36327 STATE ROUTE 180",
    "dropphycty": "LA FARGEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136569998,
    "dropmaladd": "36327 STATE ROUTE 180",
    "dropmalcty": "LA FARGEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136569998,
    "dropsitphn": 3156589911,
    "dropsitlph": 3156589911,
    "dropsitcph": 3156589911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14212",
    "droptype": "D",
    "dropname": "LA FAYETTE",
    "dropdeladd": "2507 US ROUTE 11",
    "dropdelcty": "LA FAYETTE",
    "dropdelst": "NY",
    "dropdelzpp": 130849998,
    "dropphyadd": "2507 US ROUTE 11",
    "dropphycty": "LA FAYETTE",
    "dropphyst": "NY",
    "dropphyzpp": 130849998,
    "dropmaladd": "2507 US ROUTE 11",
    "dropmalcty": "LA FAYETTE",
    "dropmalst": "NY",
    "dropmalzpp": 130849998,
    "dropsitphn": 3156773642,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156773642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14221",
    "droptype": "D",
    "dropname": "LACONA",
    "dropdeladd": "15 PARK AVE",
    "dropdelcty": "LACONA",
    "dropdelst": "NY",
    "dropdelzpp": 130839998,
    "dropphyadd": "15 PARK AVE",
    "dropphycty": "LACONA",
    "dropphyst": "NY",
    "dropphyzpp": 130839998,
    "dropmaladd": "15 PARK AVE",
    "dropmalcty": "LACONA",
    "dropmalst": "NY",
    "dropmalzpp": 130839998,
    "dropsitphn": 3153873813,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153873813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14224",
    "droptype": "D",
    "dropname": "LAGRANGEVILLE",
    "dropdeladd": "1085 ROUTE 55",
    "dropdelcty": "LAGRANGEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125409998,
    "dropphyadd": "1085 ROUTE 55",
    "dropphycty": "LAGRANGEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125409998,
    "dropmaladd": "1085 ROUTE 55",
    "dropmalcty": "LAGRANGEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454525270,
    "dropsitcph": 8454525270,
    "dropfax": 8454520627
  },
  {
    "dcode": "D",
    "dropkey": "PV14230",
    "droptype": "D",
    "dropname": "LAKE CLEAR",
    "dropdeladd": "6379 STATE ROUTE 30",
    "dropdelcty": "LAKE CLEAR",
    "dropdelst": "NY",
    "dropdelzpp": 129459998,
    "dropphyadd": "6379 STATE ROUTE 30",
    "dropphycty": "LAKE CLEAR",
    "dropphyst": "NY",
    "dropphyzpp": 129459998,
    "dropmaladd": "6379 STATE ROUTE 30",
    "dropmalcty": "LAKE CLEAR",
    "dropmalst": "NY",
    "dropmalzpp": 129459998,
    "dropsitphn": 5188913608,
    "dropsitlph": 5188913608,
    "dropsitcph": 5188913608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14237",
    "droptype": "D",
    "dropname": "LAKE GEORGE",
    "dropdeladd": "180 CANADA ST",
    "dropdelcty": "LAKE GEORGE",
    "dropdelst": "NY",
    "dropdelzpp": 128459998,
    "dropphyadd": "180 CANADA ST",
    "dropphycty": "LAKE GEORGE",
    "dropphyst": "NY",
    "dropphyzpp": 128459998,
    "dropmaladd": "180 CANADA ST",
    "dropmalcty": "LAKE GEORGE",
    "dropmalst": "NY",
    "dropmalzpp": 128459998,
    "dropsitphn": 5186683386,
    "dropsitlph": 5186683386,
    "dropsitcph": 5186683386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14238",
    "droptype": "D",
    "dropname": "LAKE GROVE",
    "dropdeladd": "1001 HAWKINS AVE",
    "dropdelcty": "LAKE GROVE",
    "dropdelst": "NY",
    "dropdelzpp": 117551647,
    "dropphyadd": "1001 HAWKINS AVE",
    "dropphycty": "LAKE GROVE",
    "dropphyst": "NY",
    "dropphyzpp": 117551647,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE GROVE",
    "dropmalst": "NY",
    "dropmalzpp": 117559998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315887019,
    "dropfax": 6314712849
  },
  {
    "dcode": "D",
    "dropkey": "PV14240",
    "droptype": "D",
    "dropname": "LAKE HILL",
    "dropdeladd": "3929 STATE ROUTE 212",
    "dropdelcty": "LAKE HILL",
    "dropdelst": "NY",
    "dropdelzpp": 124489998,
    "dropphyadd": "3929 STATE ROUTE 212",
    "dropphycty": "LAKE HILL",
    "dropphyst": "NY",
    "dropphyzpp": 124489998,
    "dropmaladd": "3929 STATE ROUTE 212",
    "dropmalcty": "LAKE HILL",
    "dropmalst": "NY",
    "dropmalzpp": 124489998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456795717,
    "dropsitcph": 8456795717,
    "dropfax": 8456795717
  },
  {
    "dcode": "D",
    "dropkey": "PV14243",
    "droptype": "D",
    "dropname": "LAKE HUNTINGTON",
    "dropdeladd": "6736 STATE ROUTE 52",
    "dropdelcty": "LAKE HUNTINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 127529998,
    "dropphyadd": "6736 STATE ROUTE 52",
    "dropphycty": "LAKE HUNTINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 127529998,
    "dropmaladd": "6736 STATE ROUTE 52",
    "dropmalcty": "LAKE HUNTINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 127529998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459328318,
    "dropsitcph": 8459328318,
    "dropfax": 8459328318
  },
  {
    "dcode": "D",
    "dropkey": "PV14245",
    "droptype": "D",
    "dropname": "LAKE KATRINE",
    "dropdeladd": "1840 ULSTER AVE",
    "dropdelcty": "LAKE KATRINE",
    "dropdelst": "NY",
    "dropdelzpp": 124499998,
    "dropphyadd": "1840 ULSTER AVE",
    "dropphycty": "LAKE KATRINE",
    "dropphyst": "NY",
    "dropphyzpp": 124499998,
    "dropmaladd": "1840 ULSTER AVE",
    "dropmalcty": "LAKE KATRINE",
    "dropmalst": "NY",
    "dropmalzpp": 124499998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453822086,
    "dropsitcph": 8453822086,
    "dropfax": 8453821233
  },
  {
    "dcode": "D",
    "dropkey": "PV14248",
    "droptype": "D",
    "dropname": "LAKE LUZERNE",
    "dropdeladd": "8 SCHOOL ST",
    "dropdelcty": "LAKE LUZERNE",
    "dropdelst": "NY",
    "dropdelzpp": 128469998,
    "dropphyadd": "8 SCHOOL ST",
    "dropphycty": "LAKE LUZERNE",
    "dropphyst": "NY",
    "dropphyzpp": 128469998,
    "dropmaladd": "8 SCHOOL ST",
    "dropmalcty": "LAKE LUZERNE",
    "dropmalst": "NY",
    "dropmalzpp": 128469998,
    "dropsitphn": 5186924019,
    "dropsitlph": 5186924019,
    "dropsitcph": 5186924019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14254",
    "droptype": "D",
    "dropname": "LAKE PEEKSKILL",
    "dropdeladd": "132 LAKE DR",
    "dropdelcty": "LAKE PEEKSKILL",
    "dropdelst": "NY",
    "dropdelzpp": 105379998,
    "dropphyadd": "132 LAKE DR",
    "dropphycty": "LAKE PEEKSKILL",
    "dropphyst": "NY",
    "dropphyzpp": 105379998,
    "dropmaladd": "132 LAKE DR",
    "dropmalcty": "LAKE PEEKSKILL",
    "dropmalst": "NY",
    "dropmalzpp": 105379998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455282762,
    "dropsitcph": 8455282762,
    "dropfax": 8455280480
  },
  {
    "dcode": "D",
    "dropkey": "PV14255",
    "droptype": "D",
    "dropname": "LAKE PLACID",
    "dropdeladd": "2591 MAIN ST",
    "dropdelcty": "LAKE PLACID",
    "dropdelst": "NY",
    "dropdelzpp": 129469998,
    "dropphyadd": "2591 MAIN ST",
    "dropphycty": "LAKE PLACID",
    "dropphyst": "NY",
    "dropphyzpp": 129469998,
    "dropmaladd": "2591 MAIN ST",
    "dropmalcty": "LAKE PLACID",
    "dropmalst": "NY",
    "dropmalzpp": 129469998,
    "dropsitphn": 5185233071,
    "dropsitlph": 5185233071,
    "dropsitcph": 5185233071,
    "dropfax": 5185230143
  },
  {
    "dcode": "D",
    "dropkey": "PV14256",
    "droptype": "D",
    "dropname": "LAKE PLEASANT",
    "dropdeladd": "2557 STATE ROUTE 8",
    "dropdelcty": "LAKE PLEASANT",
    "dropdelst": "NY",
    "dropdelzpp": 121089998,
    "dropphyadd": "2557 STATE ROUTE 8",
    "dropphycty": "LAKE PLEASANT",
    "dropphyst": "NY",
    "dropphyzpp": 121089998,
    "dropmaladd": "2557 STATE ROUTE 8",
    "dropmalcty": "LAKE PLEASANT",
    "dropmalst": "NY",
    "dropmalzpp": 121089998,
    "dropsitphn": 5855803771,
    "dropsitlph": 5855803771,
    "dropsitcph": 5855803771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14263",
    "droptype": "D",
    "dropname": "LAKE VIEW",
    "dropdeladd": "6472 SOUTHWESTERN BLVD STE 3",
    "dropdelcty": "LAKE VIEW",
    "dropdelst": "NY",
    "dropdelzpp": 140859997,
    "dropphyadd": "6472 SOUTHWESTERN BLVD STE 3",
    "dropphycty": "LAKE VIEW",
    "dropphyst": "NY",
    "dropphyzpp": 140859997,
    "dropmaladd": "6472 SOUTHWESTERN BLVD STE 3",
    "dropmalcty": "LAKE VIEW",
    "dropmalst": "NY",
    "dropmalzpp": 140859997,
    "dropsitphn": 7166277118,
    "dropsitlph": 7166277118,
    "dropsitcph": 7166277118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14267",
    "droptype": "D",
    "dropname": "LAKEMONT",
    "dropdeladd": "5160 LAKEMONT HIMROD RD",
    "dropdelcty": "LAKEMONT",
    "dropdelst": "NY",
    "dropdelzpp": 148579800,
    "dropphyadd": "5160 LAKEMONT HIMROD RD",
    "dropphycty": "LAKEMONT",
    "dropphyst": "NY",
    "dropphyzpp": 148579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEMONT",
    "dropmalst": "NY",
    "dropmalzpp": 148579998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072438222,
    "dropsitcph": 6072438222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14272",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "5832 BIG TREE RD",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 144809998,
    "dropphyadd": "5832 BIG TREE RD",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 144809998,
    "dropmaladd": "5832 BIG TREE RD",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 144809998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853462752,
    "dropsitcph": 5853462752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14275",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "2 W FAIRMOUNT AVE",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 147509998,
    "dropphyadd": "2 W FAIRMOUNT AVE",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 147509998,
    "dropmaladd": "2 W FAIRMOUNT AVE",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 147509998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167638101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14277",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "5406 BROADWAY ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "NY",
    "dropdelzpp": 140869998,
    "dropphyadd": "5406 BROADWAY ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "NY",
    "dropphyzpp": 140869998,
    "dropmaladd": "5406 BROADWAY ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "NY",
    "dropmalzpp": 140869998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166831110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14279",
    "droptype": "D",
    "dropname": "LANESVILLE",
    "dropdeladd": "1546 ROUTE 214",
    "dropdelcty": "LANESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124509998,
    "dropphyadd": "1546 ROUTE 214",
    "dropphycty": "LANESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124509998,
    "dropmaladd": "1546 ROUTE 214",
    "dropmalcty": "LANESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124509998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456885244,
    "dropsitcph": 8456885244,
    "dropfax": 8456885244
  },
  {
    "dcode": "D",
    "dropkey": "PV14290",
    "droptype": "D",
    "dropname": "LARCHMONT",
    "dropdeladd": "1 CHATSWORTH AVE",
    "dropdelcty": "LARCHMONT",
    "dropdelst": "NY",
    "dropdelzpp": 105382945,
    "dropphyadd": "1 CHATSWORTH AVE",
    "dropphycty": "LARCHMONT",
    "dropphyst": "NY",
    "dropphyzpp": 105382945,
    "dropmaladd": "1 CHATSWORTH AVE",
    "dropmalcty": "LARCHMONT",
    "dropmalst": "NY",
    "dropmalzpp": 105382945,
    "dropsitphn": 9146974123,
    "dropsitlph": 9148344963,
    "dropsitcph": 9148344963,
    "dropfax": 9148345704
  },
  {
    "dcode": "D",
    "dropkey": "PV14295",
    "droptype": "D",
    "dropname": "LATHAM",
    "dropdeladd": "685 WATERVLIET SHAKER RD",
    "dropdelcty": "LATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 121109998,
    "dropphyadd": "685 WATERVLIET SHAKER RD",
    "dropphycty": "LATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 121109998,
    "dropmaladd": "685 WATERVLIET SHAKER RD",
    "dropmalcty": "LATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 121109998,
    "dropsitphn": 5187856341,
    "dropsitlph": 5187856341,
    "dropsitcph": 5187856341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14300",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "2168 MAIN RD",
    "dropdelcty": "LAUREL",
    "dropdelst": "NY",
    "dropdelzpp": 119481302,
    "dropphyadd": "2168 MAIN RD",
    "dropphycty": "LAUREL",
    "dropphyst": "NY",
    "dropphyzpp": 119481302,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUREL",
    "dropmalst": "NY",
    "dropmalzpp": 119489998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312981672,
    "dropfax": 6312981048
  },
  {
    "dcode": "D",
    "dropkey": "PV14305",
    "droptype": "D",
    "dropname": "LAURENS",
    "dropdeladd": "55 BROOK ST",
    "dropdelcty": "LAURENS",
    "dropdelst": "NY",
    "dropdelzpp": 137969998,
    "dropphyadd": "55 BROOK ST",
    "dropphycty": "LAURENS",
    "dropphyst": "NY",
    "dropphyzpp": 137969998,
    "dropmaladd": "55 BROOK ST",
    "dropmalcty": "LAURENS",
    "dropmalst": "NY",
    "dropmalzpp": 137969998,
    "dropsitphn": 6074328593,
    "dropsitlph": 6074328593,
    "dropsitcph": 6074328593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14306",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "12 BAYVIEW AVE",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "NY",
    "dropdelzpp": 115591045,
    "dropphyadd": "12 BAYVIEW AVE",
    "dropphycty": "LAWRENCE",
    "dropphyst": "NY",
    "dropphyzpp": 115591045,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "NY",
    "dropmalzpp": 115599998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162392834,
    "dropfax": 5162395284
  },
  {
    "dcode": "D",
    "dropkey": "PV14310",
    "droptype": "D",
    "dropname": "LAWTONS",
    "dropdeladd": "12525 GOWANDA STATE RD",
    "dropdelcty": "LAWTONS",
    "dropdelst": "NY",
    "dropdelzpp": 140919998,
    "dropphyadd": "12525 GOWANDA STATE RD",
    "dropphycty": "LAWTONS",
    "dropphyst": "NY",
    "dropphyzpp": 140919998,
    "dropmaladd": "12525 GOWANDA STATE RD",
    "dropmalcty": "LAWTONS",
    "dropmalst": "NY",
    "dropmalzpp": 140919998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163370110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14315",
    "droptype": "D",
    "dropname": "LE ROY",
    "dropdeladd": "2 MAIN ST",
    "dropdelcty": "LE ROY",
    "dropdelst": "NY",
    "dropdelzpp": 144829998,
    "dropphyadd": "2 MAIN ST",
    "dropphycty": "LE ROY",
    "dropphyst": "NY",
    "dropphyzpp": 144829998,
    "dropmaladd": "2 MAIN ST",
    "dropmalcty": "LE ROY",
    "dropmalst": "NY",
    "dropmalzpp": 144829998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5857686500,
    "dropsitcph": 5857686500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14324",
    "droptype": "D",
    "dropname": "LEE CENTER",
    "dropdeladd": "5555 SCHOOL ST",
    "dropdelcty": "LEE CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 133639998,
    "dropphyadd": "5555 SCHOOL ST",
    "dropphycty": "LEE CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 133639998,
    "dropmaladd": "5555 SCHOOL ST",
    "dropmalcty": "LEE CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 133639998,
    "dropsitphn": 3153360430,
    "dropsitlph": 3153360430,
    "dropsitcph": 3153360430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14325",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "1155 MAIN ST",
    "dropdelcty": "LEEDS",
    "dropdelst": "NY",
    "dropdelzpp": 124519998,
    "dropphyadd": "1155 MAIN ST",
    "dropphycty": "LEEDS",
    "dropphyst": "NY",
    "dropphyzpp": 124519998,
    "dropmaladd": "1155 MAIN ST",
    "dropmalcty": "LEEDS",
    "dropmalst": "NY",
    "dropmalzpp": 124519998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5189437718,
    "dropsitcph": 5189437718,
    "dropfax": 5189437035
  },
  {
    "dcode": "D",
    "dropkey": "PV14329",
    "droptype": "D",
    "dropname": "LEICESTER",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "LEICESTER",
    "dropdelst": "NY",
    "dropdelzpp": 144819998,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "LEICESTER",
    "dropphyst": "NY",
    "dropphyzpp": 144819998,
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "LEICESTER",
    "dropmalst": "NY",
    "dropmalzpp": 144819998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853823309,
    "dropsitcph": 5853823309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14335",
    "droptype": "D",
    "dropname": "LEONARDSVILLE",
    "dropdeladd": "2008 STATE ROUTE 8",
    "dropdelcty": "LEONARDSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133649998,
    "dropphyadd": "2008 STATE ROUTE 8",
    "dropphycty": "LEONARDSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133649998,
    "dropmaladd": "2008 STATE ROUTE 8",
    "dropmalcty": "LEONARDSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133649998,
    "dropsitphn": 3158554300,
    "dropsitlph": 3158554300,
    "dropsitcph": 3158554300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14338",
    "droptype": "D",
    "dropname": "LEVITTOWN",
    "dropdeladd": "180 GARDINERS AVE",
    "dropdelcty": "LEVITTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 117563762,
    "dropphyadd": "180 GARDINERS AVE",
    "dropphycty": "LEVITTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 117563762,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEVITTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 117569998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167357343,
    "dropfax": 5167355319
  },
  {
    "dcode": "D",
    "dropkey": "PV14341",
    "droptype": "D",
    "dropname": "LEWIS",
    "dropdeladd": "8550 US ROUTE 9",
    "dropdelcty": "LEWIS",
    "dropdelst": "NY",
    "dropdelzpp": 129509998,
    "dropphyadd": "8550 US ROUTE 9",
    "dropphycty": "LEWIS",
    "dropphyst": "NY",
    "dropphyzpp": 129509998,
    "dropmaladd": "8550 US ROUTE 9",
    "dropmalcty": "LEWIS",
    "dropmalst": "NY",
    "dropmalzpp": 129509998,
    "dropsitphn": 5188736704,
    "dropsitlph": 5188736704,
    "dropsitcph": 5188736704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14344",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "150 S 8TH ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "NY",
    "dropdelzpp": 140929998,
    "dropphyadd": "150 S 8TH ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "NY",
    "dropphyzpp": 140929998,
    "dropmaladd": "150 S 8TH ST",
    "dropmalcty": "LEWISTON",
    "dropmalst": "NY",
    "dropmalzpp": 140929998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167548000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14345",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "4021 ROUTE 42 STE 1",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 124529800,
    "dropphyadd": "4021 ROUTE 42 STE 1",
    "dropphycty": "LEXINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 124529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 124529998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5189896435,
    "dropsitcph": 5189896435,
    "dropfax": 5189896435
  },
  {
    "dcode": "D",
    "dropkey": "PV14347",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "14 CHESTNUT ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "NY",
    "dropdelzpp": 127549998,
    "dropphyadd": "14 CHESTNUT ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "NY",
    "dropphyzpp": 127549998,
    "dropmaladd": "14 CHESTNUT ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "NY",
    "dropmalzpp": 127549998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452925108,
    "dropsitcph": 8452925108,
    "dropfax": 8452928240
  },
  {
    "dcode": "D",
    "dropkey": "PV14350",
    "droptype": "D",
    "dropname": "LILY DALE",
    "dropdeladd": "30 SOUTH ST",
    "dropdelcty": "LILY DALE",
    "dropdelst": "NY",
    "dropdelzpp": 147529800,
    "dropphyadd": "30 SOUTH ST",
    "dropphycty": "LILY DALE",
    "dropphyst": "NY",
    "dropphyzpp": 147529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LILY DALE",
    "dropmalst": "NY",
    "dropmalzpp": 147529998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165953298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14351",
    "droptype": "D",
    "dropname": "LIMA",
    "dropdeladd": "7275 W MAIN ST",
    "dropdelcty": "LIMA",
    "dropdelst": "NY",
    "dropdelzpp": 144859998,
    "dropphyadd": "7275 W MAIN ST",
    "dropphycty": "LIMA",
    "dropphyst": "NY",
    "dropphyzpp": 144859998,
    "dropmaladd": "7275 W MAIN ST",
    "dropmalcty": "LIMA",
    "dropmalst": "NY",
    "dropmalzpp": 144859998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855821400,
    "dropsitcph": 5855821400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14354",
    "droptype": "D",
    "dropname": "LIMESTONE",
    "dropdeladd": "610 MAIN ST",
    "dropdelcty": "LIMESTONE",
    "dropdelst": "NY",
    "dropdelzpp": 147539998,
    "dropphyadd": "610 MAIN ST",
    "dropphycty": "LIMESTONE",
    "dropphyst": "NY",
    "dropphyzpp": 147539998,
    "dropmaladd": "610 MAIN ST",
    "dropmalcty": "LIMESTONE",
    "dropmalst": "NY",
    "dropmalzpp": 147539998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169258227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14359",
    "droptype": "D",
    "dropname": "LINCOLNDALE",
    "dropdeladd": "152 ROUTE 202",
    "dropdelcty": "LINCOLNDALE",
    "dropdelst": "NY",
    "dropdelzpp": 105409800,
    "dropphyadd": "152 ROUTE 202",
    "dropphycty": "LINCOLNDALE",
    "dropphyst": "NY",
    "dropphyzpp": 105409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLNDALE",
    "dropmalst": "NY",
    "dropmalzpp": 105409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142487193,
    "dropsitcph": 9142487193,
    "dropfax": 9142480168
  },
  {
    "dcode": "D",
    "dropkey": "PV14364",
    "droptype": "D",
    "dropname": "LINDENHURST",
    "dropdeladd": "65 E HOFFMAN AVE",
    "dropdelcty": "LINDENHURST",
    "dropdelst": "NY",
    "dropdelzpp": 117575071,
    "dropphyadd": "65 E HOFFMAN AVE",
    "dropphycty": "LINDENHURST",
    "dropphyst": "NY",
    "dropphyzpp": 117575071,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINDENHURST",
    "dropmalst": "NY",
    "dropmalzpp": 117579998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312266914,
    "dropfax": 6312265599
  },
  {
    "dcode": "D",
    "dropkey": "PV14365",
    "droptype": "D",
    "dropname": "LINDLEY",
    "dropdeladd": "635 COUNTY ROUTE 115",
    "dropdelcty": "LINDLEY",
    "dropdelst": "NY",
    "dropdelzpp": 148589998,
    "dropphyadd": "635 COUNTY ROUTE 115",
    "dropphycty": "LINDLEY",
    "dropphyst": "NY",
    "dropphyzpp": 148589998,
    "dropmaladd": "635 COUNTY ROUTE 115",
    "dropmalcty": "LINDLEY",
    "dropmalst": "NY",
    "dropmalzpp": 148589998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075238054,
    "dropsitcph": 6075238054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14368",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "7007 COUNTY ROUTE 10",
    "dropdelcty": "LISBON",
    "dropdelst": "NY",
    "dropdelzpp": 136589998,
    "dropphyadd": "7007 COUNTY ROUTE 10",
    "dropphycty": "LISBON",
    "dropphyst": "NY",
    "dropphyzpp": 136589998,
    "dropmaladd": "7007 COUNTY ROUTE 10",
    "dropmalcty": "LISBON",
    "dropmalst": "NY",
    "dropmalzpp": 136589998,
    "dropsitphn": 3153930312,
    "dropsitlph": 3153930312,
    "dropsitcph": 3153930312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14369",
    "droptype": "D",
    "dropname": "LISLE",
    "dropdeladd": "8988 MAIN ST",
    "dropdelcty": "LISLE",
    "dropdelst": "NY",
    "dropdelzpp": 137979998,
    "dropphyadd": "8988 MAIN ST",
    "dropphycty": "LISLE",
    "dropphyst": "NY",
    "dropphyzpp": 137979998,
    "dropmaladd": "8988 MAIN ST",
    "dropmalcty": "LISLE",
    "dropmalst": "NY",
    "dropmalzpp": 137979998,
    "dropsitphn": 6076924030,
    "dropsitlph": 6076924030,
    "dropsitcph": 6076924030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14371",
    "droptype": "D",
    "dropname": "LITTLE FALLS",
    "dropdeladd": "25 W MAIN ST",
    "dropdelcty": "LITTLE FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 133659998,
    "dropphyadd": "25 W MAIN ST",
    "dropphycty": "LITTLE FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 133659998,
    "dropmaladd": "25 W MAIN ST",
    "dropmalcty": "LITTLE FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 133659998,
    "dropsitphn": 3158232440,
    "dropsitlph": 3158232440,
    "dropsitcph": 3158232440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14372",
    "droptype": "D",
    "dropname": "LITTLE GENESEE",
    "dropdeladd": "8258 STATE ROUTE 417",
    "dropdelcty": "LITTLE GENESEE",
    "dropdelst": "NY",
    "dropdelzpp": 147549998,
    "dropphyadd": "8258 STATE ROUTE 417",
    "dropphycty": "LITTLE GENESEE",
    "dropphyst": "NY",
    "dropphyzpp": 147549998,
    "dropmaladd": "8258 STATE ROUTE 417",
    "dropmalcty": "LITTLE GENESEE",
    "dropmalst": "NY",
    "dropmalzpp": 147549998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859281242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14378",
    "droptype": "D",
    "dropname": "LITTLE VALLEY",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "LITTLE VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 147559998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "LITTLE VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 147559998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "LITTLE VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 147559998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169389153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14381",
    "droptype": "D",
    "dropname": "LITTLE YORK",
    "dropdeladd": "6002 STATE ROUTE 281",
    "dropdelcty": "LITTLE YORK",
    "dropdelst": "NY",
    "dropdelzpp": 130879998,
    "dropphyadd": "6002 STATE ROUTE 281",
    "dropphycty": "LITTLE YORK",
    "dropphyst": "NY",
    "dropphyzpp": 130879998,
    "dropmaladd": "6002 STATE ROUTE 281",
    "dropmalcty": "LITTLE YORK",
    "dropmalst": "NY",
    "dropmalzpp": 130879998,
    "dropsitphn": 6077494868,
    "dropsitlph": 5184522299,
    "dropsitcph": 6077494868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14382",
    "droptype": "D",
    "dropname": "LIVERPOOL",
    "dropdeladd": "300 CYPRESS ST",
    "dropdelcty": "LIVERPOOL",
    "dropdelst": "NY",
    "dropdelzpp": 130889998,
    "dropphyadd": "300 CYPRESS ST",
    "dropphycty": "LIVERPOOL",
    "dropphyst": "NY",
    "dropphyzpp": 130889998,
    "dropmaladd": "300 CYPRESS ST",
    "dropmalcty": "LIVERPOOL",
    "dropmalst": "NY",
    "dropmalzpp": 130889998,
    "dropsitphn": 3154513060,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154513060,
    "dropfax": 3154512620
  },
  {
    "dcode": "D",
    "dropkey": "PV14384",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "122 COUNTY ROUTE 19",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "NY",
    "dropdelzpp": 125419800,
    "dropphyadd": "122 COUNTY ROUTE 19",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "NY",
    "dropphyzpp": 125419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "NY",
    "dropmalzpp": 125419998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5188518683,
    "dropsitcph": 5188518683,
    "dropfax": 5188518683
  },
  {
    "dcode": "D",
    "dropkey": "PV14385",
    "droptype": "D",
    "dropname": "LIVINGSTON MANOR",
    "dropdeladd": "23 MAIN ST",
    "dropdelcty": "LIVINGSTON MANOR",
    "dropdelst": "NY",
    "dropdelzpp": 127589998,
    "dropphyadd": "23 MAIN ST",
    "dropphycty": "LIVINGSTON MANOR",
    "dropphyst": "NY",
    "dropphyzpp": 127589998,
    "dropmaladd": "23 MAIN ST",
    "dropmalcty": "LIVINGSTON MANOR",
    "dropmalst": "NY",
    "dropmalzpp": 127589998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454398196,
    "dropsitcph": 8454398196,
    "dropfax": 8454395719
  },
  {
    "dcode": "D",
    "dropkey": "PV14387",
    "droptype": "D",
    "dropname": "LIVONIA",
    "dropdeladd": "34 MAIN ST",
    "dropdelcty": "LIVONIA",
    "dropdelst": "NY",
    "dropdelzpp": 144879998,
    "dropphyadd": "34 MAIN ST",
    "dropphycty": "LIVONIA",
    "dropphyst": "NY",
    "dropphyzpp": 144879998,
    "dropmaladd": "34 MAIN ST",
    "dropmalcty": "LIVONIA",
    "dropmalst": "NY",
    "dropmalzpp": 144879998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853465858,
    "dropsitcph": 5852151008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14403",
    "droptype": "D",
    "dropname": "LOCH SHELDRAKE",
    "dropdeladd": "739 LOCH SHELDRAKE HURLEYVILLE RD",
    "dropdelcty": "LOCH SHELDRAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127599998,
    "dropphyadd": "739 LOCH SHELDRAKE HURLEYVILLE RD",
    "dropphycty": "LOCH SHELDRAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127599998,
    "dropmaladd": "739 LOCH SHELDRAKE HURLEYVILLE RD",
    "dropmalcty": "LOCH SHELDRAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127599998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454345897,
    "dropsitcph": 8454345897,
    "dropfax": 8454346254
  },
  {
    "dcode": "D",
    "dropkey": "PV14404",
    "droptype": "D",
    "dropname": "LOCKE",
    "dropdeladd": "12199 WATER ST",
    "dropdelcty": "LOCKE",
    "dropdelst": "NY",
    "dropdelzpp": 130929998,
    "dropphyadd": "12199 WATER ST",
    "dropphycty": "LOCKE",
    "dropphyst": "NY",
    "dropphyzpp": 130929998,
    "dropmaladd": "12199 WATER ST",
    "dropmalcty": "LOCKE",
    "dropmalst": "NY",
    "dropmalzpp": 130929998,
    "dropsitphn": 3154970460,
    "dropsitlph": 5184522299,
    "dropsitcph": 3154970460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14405",
    "droptype": "D",
    "dropname": "LOCKPORT",
    "dropdeladd": "138 EAST AVE",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "NY",
    "dropdelzpp": 140949998,
    "dropphyadd": "138 EAST AVE",
    "dropphycty": "LOCKPORT",
    "dropphyst": "NY",
    "dropphyzpp": 140949998,
    "dropmaladd": "138 EAST AVE",
    "dropmalcty": "LOCKPORT",
    "dropmalst": "NY",
    "dropmalzpp": 140949998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165145000,
    "dropfax": 7164341365
  },
  {
    "dcode": "D",
    "dropkey": "PV14406",
    "droptype": "D",
    "dropname": "LOCKWOOD",
    "dropdeladd": "1557 STATE ROUTE 34",
    "dropdelcty": "LOCKWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 148599998,
    "dropphyadd": "1557 STATE ROUTE 34",
    "dropphycty": "LOCKWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 148599998,
    "dropmaladd": "1557 STATE ROUTE 34",
    "dropmalcty": "LOCKWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 148599998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075982526,
    "dropsitcph": 6075982526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14409",
    "droptype": "D",
    "dropname": "LOCUST VALLEY",
    "dropdeladd": "115 FOREST AVE",
    "dropdelcty": "LOCUST VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 115601733,
    "dropphyadd": "115 FOREST AVE",
    "dropphycty": "LOCUST VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 115601733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCUST VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 115609998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166711559,
    "dropfax": 5167596758
  },
  {
    "dcode": "D",
    "dropkey": "PV14412",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "8455 N MAIN ST",
    "dropdelcty": "LODI",
    "dropdelst": "NY",
    "dropdelzpp": 148609998,
    "dropphyadd": "8455 N MAIN ST",
    "dropphycty": "LODI",
    "dropphyst": "NY",
    "dropphyzpp": 148609998,
    "dropmaladd": "8455 N MAIN ST",
    "dropmalcty": "LODI",
    "dropmalst": "NY",
    "dropmalzpp": 148609998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075826266,
    "dropsitcph": 6075826266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14417",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "101 E PARK AVE",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 115613561,
    "dropphyadd": "101 E PARK AVE",
    "dropphycty": "LONG BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 115613561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 115619998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5164325484,
    "dropfax": 5164311160
  },
  {
    "dcode": "D",
    "dropkey": "PV14419",
    "droptype": "D",
    "dropname": "LONG EDDY",
    "dropdeladd": "13 CHESTNUT ST",
    "dropdelcty": "LONG EDDY",
    "dropdelst": "NY",
    "dropdelzpp": 127609998,
    "dropphyadd": "13 CHESTNUT ST",
    "dropphycty": "LONG EDDY",
    "dropphyst": "NY",
    "dropphyzpp": 127609998,
    "dropmaladd": "13 CHESTNUT ST",
    "dropmalcty": "LONG EDDY",
    "dropmalst": "NY",
    "dropmalzpp": 127609998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458875260,
    "dropsitcph": 8458875260,
    "dropfax": 8458875260
  },
  {
    "dcode": "D",
    "dropkey": "PV14422",
    "droptype": "D",
    "dropname": "LONG ISLAND CITY",
    "dropdeladd": "4602 21ST ST",
    "dropdelcty": "LONG ISLAND CITY",
    "dropdelst": "NY",
    "dropdelzpp": 111019998,
    "dropphyadd": "4602 21ST ST",
    "dropphycty": "LONG ISLAND CITY",
    "dropphyst": "NY",
    "dropphyzpp": 111019998,
    "dropmaladd": "4602 21ST ST",
    "dropmalcty": "LONG ISLAND CITY",
    "dropmalst": "NY",
    "dropmalzpp": 111019998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183494634,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "PV14425",
    "droptype": "D",
    "dropname": "LONG LAKE",
    "dropdeladd": "1095 DEERLAND RD",
    "dropdelcty": "LONG LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 128479998,
    "dropphyadd": "1095 DEERLAND RD",
    "dropphycty": "LONG LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 128479998,
    "dropmaladd": "1095 DEERLAND RD",
    "dropmalcty": "LONG LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 128479998,
    "dropsitphn": 5186244567,
    "dropsitlph": 5186244567,
    "dropsitcph": 5186244567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14429",
    "droptype": "D",
    "dropname": "LORRAINE",
    "dropdeladd": "20693 COUNTY ROUTE 93",
    "dropdelcty": "LORRAINE",
    "dropdelst": "NY",
    "dropdelzpp": 136599998,
    "dropphyadd": "20693 COUNTY ROUTE 93",
    "dropphycty": "LORRAINE",
    "dropphyst": "NY",
    "dropphyzpp": 136599998,
    "dropmaladd": "20693 COUNTY ROUTE 93",
    "dropmalcty": "LORRAINE",
    "dropmalst": "NY",
    "dropmalzpp": 136599998,
    "dropsitphn": 3152324938,
    "dropsitlph": 3152324938,
    "dropsitcph": 3152324938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14436",
    "droptype": "D",
    "dropname": "LOWMAN",
    "dropdeladd": "1931 COUNTY ROUTE 60",
    "dropdelcty": "LOWMAN",
    "dropdelst": "NY",
    "dropdelzpp": 148619998,
    "dropphyadd": "1931 COUNTY ROUTE 60",
    "dropphycty": "LOWMAN",
    "dropphyst": "NY",
    "dropphyzpp": 148619998,
    "dropmaladd": "1931 COUNTY ROUTE 60",
    "dropmalcty": "LOWMAN",
    "dropmalst": "NY",
    "dropmalzpp": 148619998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077347758,
    "dropsitcph": 6077347758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14437",
    "droptype": "D",
    "dropname": "LOWVILLE",
    "dropdeladd": "7651 N STATE ST",
    "dropdelcty": "LOWVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 133679998,
    "dropphyadd": "7651 N STATE ST",
    "dropphycty": "LOWVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 133679998,
    "dropmaladd": "7651 N STATE ST",
    "dropmalcty": "LOWVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 133679998,
    "dropsitphn": 3153763111,
    "dropsitlph": 3153763111,
    "dropsitcph": 3153763111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14444",
    "droptype": "D",
    "dropname": "LYCOMING",
    "dropdeladd": "1059 COUNTY ROUTE 29N",
    "dropdelcty": "LYCOMING",
    "dropdelst": "NY",
    "dropdelzpp": 130939998,
    "dropphyadd": "1059 COUNTY ROUTE 29N",
    "dropphycty": "LYCOMING",
    "dropphyst": "NY",
    "dropphyzpp": 130939998,
    "dropmaladd": "1059 COUNTY ROUTE 29N",
    "dropmalcty": "LYCOMING",
    "dropmalst": "NY",
    "dropmalzpp": 130939998,
    "dropsitphn": 3153432765,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153432765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14448",
    "droptype": "D",
    "dropname": "LYNBROOK",
    "dropdeladd": "100 BROADWAY",
    "dropdelcty": "LYNBROOK",
    "dropdelst": "NY",
    "dropdelzpp": 115633279,
    "dropphyadd": "100 BROADWAY",
    "dropphycty": "LYNBROOK",
    "dropphyst": "NY",
    "dropphyzpp": 115633279,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNBROOK",
    "dropmalst": "NY",
    "dropmalzpp": 115639998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5165997587,
    "dropfax": 5168877571
  },
  {
    "dcode": "D",
    "dropkey": "PV14450",
    "droptype": "D",
    "dropname": "LYNDONVILLE",
    "dropdeladd": "18 S MAIN ST",
    "dropdelcty": "LYNDONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 140989998,
    "dropphyadd": "18 S MAIN ST",
    "dropphycty": "LYNDONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 140989998,
    "dropmaladd": "18 S MAIN ST",
    "dropmalcty": "LYNDONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 140989998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5857659721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14451",
    "droptype": "D",
    "dropname": "LYON MOUNTAIN",
    "dropdeladd": "8 LANGEY ST",
    "dropdelcty": "LYON MOUNTAIN",
    "dropdelst": "NY",
    "dropdelzpp": 129529998,
    "dropphyadd": "8 LANGEY ST",
    "dropphycty": "LYON MOUNTAIN",
    "dropphyst": "NY",
    "dropphyzpp": 129529998,
    "dropmaladd": "8 LANGEY ST",
    "dropmalcty": "LYON MOUNTAIN",
    "dropmalst": "NY",
    "dropmalzpp": 129529998,
    "dropsitphn": 5187354747,
    "dropsitlph": 5187354747,
    "dropsitcph": 5187354747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14452",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "1 PEARL ST",
    "dropdelcty": "LYONS",
    "dropdelst": "NY",
    "dropdelzpp": 144899998,
    "dropphyadd": "1 PEARL ST",
    "dropphycty": "LYONS",
    "dropphyst": "NY",
    "dropphyzpp": 144899998,
    "dropmaladd": "1 PEARL ST",
    "dropmalcty": "LYONS",
    "dropmalst": "NY",
    "dropmalzpp": 144899998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3159464661,
    "dropsitcph": 3159464661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14453",
    "droptype": "D",
    "dropname": "LYONS FALLS",
    "dropdeladd": "3864 FULTON ST",
    "dropdelcty": "LYONS FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 133689998,
    "dropphyadd": "3864 FULTON ST",
    "dropphycty": "LYONS FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 133689998,
    "dropmaladd": "3864 FULTON ST",
    "dropmalcty": "LYONS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 133689998,
    "dropsitphn": 3153488623,
    "dropsitlph": 3153488623,
    "dropsitcph": 3153488623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14461",
    "droptype": "D",
    "dropname": "MACEDON",
    "dropdeladd": "1475 CANANDAIGUA RD",
    "dropdelcty": "MACEDON",
    "dropdelst": "NY",
    "dropdelzpp": 145029998,
    "dropphyadd": "1475 CANANDAIGUA RD",
    "dropphycty": "MACEDON",
    "dropphyst": "NY",
    "dropphyzpp": 145029998,
    "dropmaladd": "1475 CANANDAIGUA RD",
    "dropmalcty": "MACEDON",
    "dropmalst": "NY",
    "dropmalzpp": 145029998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3159864904,
    "dropsitcph": 3159864904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14462",
    "droptype": "D",
    "dropname": "MACHIAS",
    "dropdeladd": "9742 MAIN ST",
    "dropdelcty": "MACHIAS",
    "dropdelst": "NY",
    "dropdelzpp": 141019998,
    "dropphyadd": "9742 MAIN ST",
    "dropphycty": "MACHIAS",
    "dropphyst": "NY",
    "dropphyzpp": 141019998,
    "dropmaladd": "9742 MAIN ST",
    "dropmalcty": "MACHIAS",
    "dropmalst": "NY",
    "dropmalzpp": 141019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163538561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14466",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "7326 STATE ROUTE 20",
    "dropdelcty": "MADISON",
    "dropdelst": "NY",
    "dropdelzpp": 134029998,
    "dropphyadd": "7326 STATE ROUTE 20",
    "dropphycty": "MADISON",
    "dropphyst": "NY",
    "dropphyzpp": 134029998,
    "dropmaladd": "7326 STATE ROUTE 20",
    "dropmalcty": "MADISON",
    "dropmalst": "NY",
    "dropmalzpp": 134029998,
    "dropsitphn": 3158931831,
    "dropsitlph": 3158931831,
    "dropsitcph": 3158931831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14471",
    "droptype": "D",
    "dropname": "MADRID",
    "dropdeladd": "3 CHURCH ST",
    "dropdelcty": "MADRID",
    "dropdelst": "NY",
    "dropdelzpp": 136609998,
    "dropphyadd": "3 CHURCH ST",
    "dropphycty": "MADRID",
    "dropphyst": "NY",
    "dropphyzpp": 136609998,
    "dropmaladd": "3 CHURCH ST",
    "dropmalcty": "MADRID",
    "dropmalst": "NY",
    "dropmalzpp": 136609998,
    "dropsitphn": 3153224200,
    "dropsitlph": 3153224200,
    "dropsitcph": 3153224200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14474",
    "droptype": "D",
    "dropname": "MAHOPAC",
    "dropdeladd": "346 ROUTE 6",
    "dropdelcty": "MAHOPAC",
    "dropdelst": "NY",
    "dropdelzpp": 105419998,
    "dropphyadd": "346 ROUTE 6",
    "dropphycty": "MAHOPAC",
    "dropphyst": "NY",
    "dropphyzpp": 105419998,
    "dropmaladd": "346 ROUTE 6",
    "dropmalcty": "MAHOPAC",
    "dropmalst": "NY",
    "dropmalzpp": 105419998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456281061,
    "dropsitcph": 8456281061,
    "dropfax": 8456286872
  },
  {
    "dcode": "D",
    "dropkey": "PV14475",
    "droptype": "D",
    "dropname": "MAHOPAC FALLS",
    "dropdeladd": "173 MYRTLE AVE",
    "dropdelcty": "MAHOPAC FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 105429800,
    "dropphyadd": "173 MYRTLE AVE",
    "dropphycty": "MAHOPAC FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 105429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAHOPAC FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 105429998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456289582,
    "dropsitcph": 8456289582,
    "dropfax": 8456289582
  },
  {
    "dcode": "D",
    "dropkey": "PV14486",
    "droptype": "D",
    "dropname": "MAINE",
    "dropdeladd": "2597 MAIN ST",
    "dropdelcty": "MAINE",
    "dropdelst": "NY",
    "dropdelzpp": 138029998,
    "dropphyadd": "2597 MAIN ST",
    "dropphycty": "MAINE",
    "dropphyst": "NY",
    "dropphyzpp": 138029998,
    "dropmaladd": "2597 MAIN ST",
    "dropmalcty": "MAINE",
    "dropmalst": "NY",
    "dropmalzpp": 138029998,
    "dropsitphn": 6078624051,
    "dropsitlph": 6078624051,
    "dropsitcph": 6078624051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14489",
    "droptype": "D",
    "dropname": "MALDEN BRIDGE",
    "dropdeladd": "4691 STATE ROUTE 66",
    "dropdelcty": "MALDEN BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 121159998,
    "dropphyadd": "4691 STATE ROUTE 66",
    "dropphycty": "MALDEN BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 121159998,
    "dropmaladd": "4691 STATE ROUTE 66",
    "dropmalcty": "MALDEN BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 121159998,
    "dropsitphn": 5187663800,
    "dropsitlph": 5187663800,
    "dropsitcph": 5187663800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14492",
    "droptype": "D",
    "dropname": "MALDEN ON HUDSON",
    "dropdeladd": "1116 MAIN ST",
    "dropdelcty": "MALDEN ON HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 124539800,
    "dropphyadd": "1116 MAIN ST",
    "dropphycty": "MALDEN ON HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 124539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALDEN ON HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 124539998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452467655,
    "dropsitcph": 8452467655,
    "dropfax": 8452467655
  },
  {
    "dcode": "D",
    "dropkey": "PV14494",
    "droptype": "D",
    "dropname": "MALLORY",
    "dropdeladd": "77 COUNTY ROUTE 32",
    "dropdelcty": "MALLORY",
    "dropdelst": "NY",
    "dropdelzpp": 131039998,
    "dropphyadd": "77 COUNTY ROUTE 32",
    "dropphycty": "MALLORY",
    "dropphyst": "NY",
    "dropphyzpp": 131039998,
    "dropmaladd": "77 COUNTY ROUTE 32",
    "dropmalcty": "MALLORY",
    "dropmalst": "NY",
    "dropmalzpp": 131039998,
    "dropsitphn": 3156683043,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156683043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14495",
    "droptype": "D",
    "dropname": "MALONE",
    "dropdeladd": "482 E MAIN ST",
    "dropdelcty": "MALONE",
    "dropdelst": "NY",
    "dropdelzpp": 129539998,
    "dropphyadd": "482 E MAIN ST",
    "dropphycty": "MALONE",
    "dropphyst": "NY",
    "dropphyzpp": 129539998,
    "dropmaladd": "482 E MAIN ST",
    "dropmalcty": "MALONE",
    "dropmalst": "NY",
    "dropmalzpp": 129539998,
    "dropsitphn": 5184834220,
    "dropsitlph": 5184834220,
    "dropsitcph": 5184834220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14499",
    "droptype": "D",
    "dropname": "MALVERNE",
    "dropdeladd": "339 HEMPSTEAD AVE",
    "dropdelcty": "MALVERNE",
    "dropdelst": "NY",
    "dropdelzpp": 115651223,
    "dropphyadd": "339 HEMPSTEAD AVE",
    "dropphycty": "MALVERNE",
    "dropphyst": "NY",
    "dropphyzpp": 115651223,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALVERNE",
    "dropmalst": "NY",
    "dropmalzpp": 115659998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5165997583,
    "dropfax": 5165992760
  },
  {
    "dcode": "D",
    "dropkey": "PV14500",
    "droptype": "D",
    "dropname": "MAMARONECK",
    "dropdeladd": "309 MOUNT PLEASANT AVE",
    "dropdelcty": "MAMARONECK",
    "dropdelst": "NY",
    "dropdelzpp": 105439998,
    "dropphyadd": "309 MOUNT PLEASANT AVE",
    "dropphycty": "MAMARONECK",
    "dropphyst": "NY",
    "dropphyzpp": 105439998,
    "dropmaladd": "309 MOUNT PLEASANT AVE",
    "dropmalcty": "MAMARONECK",
    "dropmalst": "NY",
    "dropmalzpp": 105439998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146983229,
    "dropsitcph": 9146983229,
    "dropfax": 9147770603
  },
  {
    "dcode": "D",
    "dropkey": "PV14502",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 145049998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 145049998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 145049998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852896204,
    "dropsitcph": 5852896204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14505",
    "droptype": "D",
    "dropname": "MANHASSET",
    "dropdeladd": "28 MAPLE PL",
    "dropdelcty": "MANHASSET",
    "dropdelst": "NY",
    "dropdelzpp": 110309998,
    "dropphyadd": "28 MAPLE PL",
    "dropphycty": "MANHASSET",
    "dropphyst": "NY",
    "dropphyzpp": 110309998,
    "dropmaladd": "28 MAPLE PL",
    "dropmalcty": "MANHASSET",
    "dropmalst": "NY",
    "dropmalzpp": 110309998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5166270536,
    "dropfax": 5166275376
  },
  {
    "dcode": "D",
    "dropkey": "PV14513",
    "droptype": "D",
    "dropname": "MANLIUS",
    "dropdeladd": "110 WESLEY ST",
    "dropdelcty": "MANLIUS",
    "dropdelst": "NY",
    "dropdelzpp": 131049998,
    "dropphyadd": "110 WESLEY ST",
    "dropphycty": "MANLIUS",
    "dropphyst": "NY",
    "dropphyzpp": 131049998,
    "dropmaladd": "110 WESLEY ST",
    "dropmalcty": "MANLIUS",
    "dropmalst": "NY",
    "dropmalzpp": 131049998,
    "dropsitphn": 3156826770,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156826770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14515",
    "droptype": "D",
    "dropname": "MANNSVILLE",
    "dropdeladd": "306 S MAIN ST",
    "dropdelcty": "MANNSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136619998,
    "dropphyadd": "306 S MAIN ST",
    "dropphycty": "MANNSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136619998,
    "dropmaladd": "306 S MAIN ST",
    "dropmalcty": "MANNSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136619998,
    "dropsitphn": 3154654065,
    "dropsitlph": 3154654065,
    "dropsitcph": 3154654065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14520",
    "droptype": "D",
    "dropname": "MANORVILLE",
    "dropdeladd": "525 EASTPORT MANOR RD",
    "dropdelcty": "MANORVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 119493343,
    "dropphyadd": "525 EASTPORT MANOR RD",
    "dropphycty": "MANORVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 119493343,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANORVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 119499998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317270064,
    "dropfax": 6317278631
  },
  {
    "dcode": "D",
    "dropkey": "PV14532",
    "droptype": "D",
    "dropname": "MAPLECREST",
    "dropdeladd": "27 ROUTE 56",
    "dropdelcty": "MAPLECREST",
    "dropdelst": "NY",
    "dropdelzpp": 124549998,
    "dropphyadd": "27 ROUTE 56",
    "dropphycty": "MAPLECREST",
    "dropphyst": "NY",
    "dropphyzpp": 124549998,
    "dropmaladd": "27 ROUTE 56",
    "dropmalcty": "MAPLECREST",
    "dropmalst": "NY",
    "dropmalzpp": 124549998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187346243,
    "dropsitcph": 5187346243,
    "dropfax": 5187346243
  },
  {
    "dcode": "D",
    "dropkey": "PV14536",
    "droptype": "D",
    "dropname": "MARATHON",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "MARATHON",
    "dropdelst": "NY",
    "dropdelzpp": 138039998,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "MARATHON",
    "dropphyst": "NY",
    "dropphyzpp": 138039998,
    "dropmaladd": "12 MAIN ST",
    "dropmalcty": "MARATHON",
    "dropmalst": "NY",
    "dropmalzpp": 138039998,
    "dropsitphn": 6078493817,
    "dropsitlph": 6078493817,
    "dropsitcph": 6078493817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14537",
    "droptype": "D",
    "dropname": "MARCELLUS",
    "dropdeladd": "9 E MAIN ST",
    "dropdelcty": "MARCELLUS",
    "dropdelst": "NY",
    "dropdelzpp": 131089998,
    "dropphyadd": "9 E MAIN ST",
    "dropphycty": "MARCELLUS",
    "dropphyst": "NY",
    "dropphyzpp": 131089998,
    "dropmaladd": "9 E MAIN ST",
    "dropmalcty": "MARCELLUS",
    "dropmalst": "NY",
    "dropmalzpp": 131089998,
    "dropsitphn": 3156733259,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156733259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14540",
    "droptype": "D",
    "dropname": "MARCY",
    "dropdeladd": "5735 CAVANAUGH RD",
    "dropdelcty": "MARCY",
    "dropdelst": "NY",
    "dropdelzpp": 134039998,
    "dropphyadd": "5735 CAVANAUGH RD",
    "dropphycty": "MARCY",
    "dropphyst": "NY",
    "dropphyzpp": 134039998,
    "dropmaladd": "5735 CAVANAUGH RD",
    "dropmalcty": "MARCY",
    "dropmalst": "NY",
    "dropmalzpp": 134039998,
    "dropsitphn": 3157367072,
    "dropsitlph": 3157367072,
    "dropsitcph": 3157367072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14542",
    "droptype": "D",
    "dropname": "MARGARETVILLE",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "MARGARETVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124559998,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "MARGARETVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124559998,
    "dropmaladd": "315 MAIN ST",
    "dropmalcty": "MARGARETVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124559998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455862967,
    "dropsitcph": 8455862967,
    "dropfax": 8455864116
  },
  {
    "dcode": "D",
    "dropkey": "PV14546",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "2796 STATE ROUTE 174",
    "dropdelcty": "MARIETTA",
    "dropdelst": "NY",
    "dropdelzpp": 131109998,
    "dropphyadd": "2796 STATE ROUTE 174",
    "dropphycty": "MARIETTA",
    "dropphyst": "NY",
    "dropphyzpp": 131109998,
    "dropmaladd": "2796 STATE ROUTE 174",
    "dropmalcty": "MARIETTA",
    "dropmalst": "NY",
    "dropmalzpp": 131109998,
    "dropsitphn": 3156368423,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156368423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14547",
    "droptype": "D",
    "dropname": "MARILLA",
    "dropdeladd": "1800 TWO ROD RD",
    "dropdelcty": "MARILLA",
    "dropdelst": "NY",
    "dropdelzpp": 141029998,
    "dropphyadd": "1800 TWO ROD RD",
    "dropphycty": "MARILLA",
    "dropphyst": "NY",
    "dropphyzpp": 141029998,
    "dropmaladd": "1800 TWO ROD RD",
    "dropmalcty": "MARILLA",
    "dropmalst": "NY",
    "dropmalzpp": 141029998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166528190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14552",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "3785 S MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "NY",
    "dropdelzpp": 145059998,
    "dropphyadd": "3785 S MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "NY",
    "dropphyzpp": 145059998,
    "dropmaladd": "3785 S MAIN ST",
    "dropmalcty": "MARION",
    "dropmalst": "NY",
    "dropmalzpp": 145059998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3159264355,
    "dropsitcph": 3159264355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14553",
    "droptype": "D",
    "dropname": "MARLBORO",
    "dropdeladd": "43 WESTERN AVE",
    "dropdelcty": "MARLBORO",
    "dropdelst": "NY",
    "dropdelzpp": 125429998,
    "dropphyadd": "43 WESTERN AVE",
    "dropphycty": "MARLBORO",
    "dropphyst": "NY",
    "dropphyzpp": 125429998,
    "dropmaladd": "43 WESTERN AVE",
    "dropmalcty": "MARLBORO",
    "dropmalst": "NY",
    "dropmalzpp": 125429998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452362914,
    "dropsitcph": 8452362914,
    "dropfax": 8452363253
  },
  {
    "dcode": "D",
    "dropkey": "PV14556",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "5604 WHITAKER RD",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 134049998,
    "dropphyadd": "5604 WHITAKER RD",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 134049998,
    "dropmaladd": "5604 WHITAKER RD",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 134049998,
    "dropsitphn": 3153718050,
    "dropsitlph": 3153718050,
    "dropsitcph": 3153718050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14558",
    "droptype": "D",
    "dropname": "MARTVILLE",
    "dropdeladd": "15422 STATE ROUTE 104",
    "dropdelcty": "MARTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 131119998,
    "dropphyadd": "15422 STATE ROUTE 104",
    "dropphycty": "MARTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 131119998,
    "dropmaladd": "15422 STATE ROUTE 104",
    "dropmalcty": "MARTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 131119998,
    "dropsitphn": 3155645550,
    "dropsitlph": 5184522299,
    "dropsitcph": 3155645550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14562",
    "droptype": "D",
    "dropname": "MARYKNOLL",
    "dropdeladd": "85 RYDER RD",
    "dropdelcty": "MARYKNOLL",
    "dropdelst": "NY",
    "dropdelzpp": 105459800,
    "dropphyadd": "85 RYDER RD",
    "dropphycty": "MARYKNOLL",
    "dropphyst": "NY",
    "dropphyzpp": 105459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARYKNOLL",
    "dropmalst": "NY",
    "dropmalzpp": 105459998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149231578,
    "dropsitcph": 9149231578,
    "dropfax": 9147624941
  },
  {
    "dcode": "D",
    "dropkey": "PV14563",
    "droptype": "D",
    "dropname": "MARYLAND",
    "dropdeladd": "7501 STATE HIGHWAY 7",
    "dropdelcty": "MARYLAND",
    "dropdelst": "NY",
    "dropdelzpp": 121169998,
    "dropphyadd": "7501 STATE HIGHWAY 7",
    "dropphycty": "MARYLAND",
    "dropphyst": "NY",
    "dropphyzpp": 121169998,
    "dropmaladd": "7501 STATE HIGHWAY 7",
    "dropmalcty": "MARYLAND",
    "dropmalst": "NY",
    "dropmalzpp": 121169998,
    "dropsitphn": 6076389311,
    "dropsitlph": 6076389311,
    "dropsitcph": 6076389311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14565",
    "droptype": "D",
    "dropname": "MASONVILLE",
    "dropdeladd": "15505 STATE HIGHWAY 8",
    "dropdelcty": "MASONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 138049998,
    "dropphyadd": "15505 STATE HIGHWAY 8",
    "dropphycty": "MASONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 138049998,
    "dropmaladd": "15505 STATE HIGHWAY 8",
    "dropmalcty": "MASONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 138049998,
    "dropsitphn": 6072653505,
    "dropsitlph": 6072653505,
    "dropsitcph": 6072653505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14573",
    "droptype": "D",
    "dropname": "MASSAPEQUA",
    "dropdeladd": "80 KILLIANS RD",
    "dropdelcty": "MASSAPEQUA",
    "dropdelst": "NY",
    "dropdelzpp": 117585135,
    "dropphyadd": "80 KILLIANS RD",
    "dropphycty": "MASSAPEQUA",
    "dropphyst": "NY",
    "dropphyzpp": 117585135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASSAPEQUA",
    "dropmalst": "NY",
    "dropmalzpp": 117589998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167982576,
    "dropfax": 5167999218
  },
  {
    "dcode": "D",
    "dropkey": "PV14574",
    "droptype": "D",
    "dropname": "MASSAPEQUA PARK",
    "dropdeladd": "4910 MERRICK RD",
    "dropdelcty": "MASSAPEQUA PARK",
    "dropdelst": "NY",
    "dropdelzpp": 117623827,
    "dropphyadd": "4910 MERRICK RD",
    "dropphycty": "MASSAPEQUA PARK",
    "dropphyst": "NY",
    "dropphyzpp": 117623827,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASSAPEQUA PARK",
    "dropmalst": "NY",
    "dropmalzpp": 117629998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167981268,
    "dropfax": 5167985630
  },
  {
    "dcode": "D",
    "dropkey": "PV14579",
    "droptype": "D",
    "dropname": "MASSENA",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MASSENA",
    "dropdelst": "NY",
    "dropdelzpp": 136629998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MASSENA",
    "dropphyst": "NY",
    "dropphyzpp": 136629998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "MASSENA",
    "dropmalst": "NY",
    "dropmalzpp": 136629998,
    "dropsitphn": 3157695935,
    "dropsitlph": 3157695935,
    "dropsitcph": 3157695935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14582",
    "droptype": "D",
    "dropname": "MASTIC",
    "dropdeladd": "1450 MONTAUK HWY",
    "dropdelcty": "MASTIC",
    "dropdelst": "NY",
    "dropdelzpp": 119502936,
    "dropphyadd": "1450 MONTAUK HWY",
    "dropphycty": "MASTIC",
    "dropphyst": "NY",
    "dropphyzpp": 119502936,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASTIC",
    "dropmalst": "NY",
    "dropmalzpp": 119509998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312810275,
    "dropfax": 6312811082
  },
  {
    "dcode": "D",
    "dropkey": "PV14584",
    "droptype": "D",
    "dropname": "MASTIC BEACH",
    "dropdeladd": "110 MASTIC RD",
    "dropdelcty": "MASTIC BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 119512406,
    "dropphyadd": "110 MASTIC RD",
    "dropphycty": "MASTIC BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 119512406,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASTIC BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 119519998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312810359,
    "dropfax": 6313956728
  },
  {
    "dcode": "D",
    "dropkey": "PV14586",
    "droptype": "D",
    "dropname": "MATTITUCK",
    "dropdeladd": "140 LOVE LN",
    "dropdelcty": "MATTITUCK",
    "dropdelst": "NY",
    "dropdelzpp": 119523296,
    "dropphyadd": "140 LOVE LN",
    "dropphycty": "MATTITUCK",
    "dropphyst": "NY",
    "dropphyzpp": 119523296,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATTITUCK",
    "dropmalst": "NY",
    "dropmalzpp": 119529998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312981364,
    "dropfax": 6312981174
  },
  {
    "dcode": "D",
    "dropkey": "PV14588",
    "droptype": "D",
    "dropname": "MAYBROOK",
    "dropdeladd": "207 HOMESTEAD AVE",
    "dropdelcty": "MAYBROOK",
    "dropdelst": "NY",
    "dropdelzpp": 125439998,
    "dropphyadd": "207 HOMESTEAD AVE",
    "dropphycty": "MAYBROOK",
    "dropphyst": "NY",
    "dropphyzpp": 125439998,
    "dropmaladd": "207 HOMESTEAD AVE",
    "dropmalcty": "MAYBROOK",
    "dropmalst": "NY",
    "dropmalzpp": 125439998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454272891,
    "dropsitcph": 8454272891,
    "dropfax": 8454272061
  },
  {
    "dcode": "D",
    "dropkey": "PV14591",
    "droptype": "D",
    "dropname": "MAYFIELD",
    "dropdeladd": "13 N SCHOOL ST",
    "dropdelcty": "MAYFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 121173998,
    "dropphyadd": "13 N SCHOOL ST",
    "dropphycty": "MAYFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 121173998,
    "dropmaladd": "13 N SCHOOL ST",
    "dropmalcty": "MAYFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 121173998,
    "dropsitphn": 5186615821,
    "dropsitlph": 5186615821,
    "dropsitcph": 5186615821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14592",
    "droptype": "D",
    "dropname": "MAYVILLE",
    "dropdeladd": "19 E CHAUTAUQUA ST",
    "dropdelcty": "MAYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147579998,
    "dropphyadd": "19 E CHAUTAUQUA ST",
    "dropphycty": "MAYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147579998,
    "dropmaladd": "19 E CHAUTAUQUA ST",
    "dropmalcty": "MAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147579998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167532921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14599",
    "droptype": "D",
    "dropname": "MC DONOUGH",
    "dropdeladd": "1600 STATE HIGHWAY 220",
    "dropdelcty": "MC DONOUGH",
    "dropdelst": "NY",
    "dropdelzpp": 138019998,
    "dropphyadd": "1600 STATE HIGHWAY 220",
    "dropphycty": "MC DONOUGH",
    "dropphyst": "NY",
    "dropphyzpp": 138019998,
    "dropmaladd": "1600 STATE HIGHWAY 220",
    "dropmalcty": "MC DONOUGH",
    "dropmalst": "NY",
    "dropmalzpp": 138019998,
    "dropsitphn": 6076475453,
    "dropsitlph": 6076475453,
    "dropsitcph": 6076475453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14600",
    "droptype": "D",
    "dropname": "MC GRAW",
    "dropdeladd": "16 MAIN ST",
    "dropdelcty": "MC GRAW",
    "dropdelst": "NY",
    "dropdelzpp": 131019998,
    "dropphyadd": "16 MAIN ST",
    "dropphycty": "MC GRAW",
    "dropphyst": "NY",
    "dropphyzpp": 131019998,
    "dropmaladd": "16 MAIN ST",
    "dropmalcty": "MC GRAW",
    "dropmalst": "NY",
    "dropmalzpp": 131019998,
    "dropsitphn": 6078362013,
    "dropsitlph": 5184522299,
    "dropsitcph": 6078362013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14602",
    "droptype": "D",
    "dropname": "MC LEAN",
    "dropdeladd": "1 SCHOOL ST",
    "dropdelcty": "MC LEAN",
    "dropdelst": "NY",
    "dropdelzpp": 131029998,
    "dropphyadd": "1 SCHOOL ST",
    "dropphycty": "MC LEAN",
    "dropphyst": "NY",
    "dropphyzpp": 131029998,
    "dropmaladd": "1 SCHOOL ST",
    "dropmalcty": "MC LEAN",
    "dropmalst": "NY",
    "dropmalzpp": 131029998,
    "dropsitphn": 6078383391,
    "dropsitlph": 5184522299,
    "dropsitcph": 6078383391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14620",
    "droptype": "D",
    "dropname": "MECHANICVILLE",
    "dropdeladd": "18 S MAIN ST",
    "dropdelcty": "MECHANICVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121189998,
    "dropphyadd": "18 S MAIN ST",
    "dropphycty": "MECHANICVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121189998,
    "dropmaladd": "18 S MAIN ST",
    "dropmalcty": "MECHANICVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121189998,
    "dropsitphn": 5186644731,
    "dropsitlph": 5186644731,
    "dropsitcph": 5186644731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14621",
    "droptype": "D",
    "dropname": "MECKLENBURG",
    "dropdeladd": "6123 MECKLENBURG RD",
    "dropdelcty": "MECKLENBURG",
    "dropdelst": "NY",
    "dropdelzpp": 148639800,
    "dropphyadd": "6123 MECKLENBURG RD",
    "dropphycty": "MECKLENBURG",
    "dropphyst": "NY",
    "dropphyzpp": 148639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MECKLENBURG",
    "dropmalst": "NY",
    "dropmalzpp": 148639998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073875616,
    "dropsitcph": 6073875616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14624",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "1905 ROUTE 112",
    "dropdelcty": "MEDFORD",
    "dropdelst": "NY",
    "dropdelzpp": 117633670,
    "dropphyadd": "1905 ROUTE 112",
    "dropphycty": "MEDFORD",
    "dropphyst": "NY",
    "dropphyzpp": 117633670,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDFORD",
    "dropmalst": "NY",
    "dropmalzpp": 117639998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314758273,
    "dropfax": 6314753128
  },
  {
    "dcode": "D",
    "dropkey": "PV14625",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "128 W CENTER ST",
    "dropdelcty": "MEDINA",
    "dropdelst": "NY",
    "dropdelzpp": 141039998,
    "dropphyadd": "128 W CENTER ST",
    "dropphycty": "MEDINA",
    "dropphyst": "NY",
    "dropphyzpp": 141039998,
    "dropmaladd": "128 W CENTER ST",
    "dropmalcty": "MEDINA",
    "dropmalst": "NY",
    "dropmalzpp": 141039998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5857982440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14626",
    "droptype": "D",
    "dropname": "MEDUSA",
    "dropdeladd": "19 COUNTY ROUTE 351",
    "dropdelcty": "MEDUSA",
    "dropdelst": "NY",
    "dropdelzpp": 121209998,
    "dropphyadd": "19 COUNTY ROUTE 351",
    "dropphycty": "MEDUSA",
    "dropphyst": "NY",
    "dropphyzpp": 121209998,
    "dropmaladd": "19 COUNTY ROUTE 351",
    "dropmalcty": "MEDUSA",
    "dropmalst": "NY",
    "dropmalzpp": 121209998,
    "dropsitphn": 5182394826,
    "dropsitlph": 5182394826,
    "dropsitcph": 5182394826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14629",
    "droptype": "D",
    "dropname": "MELLENVILLE",
    "dropdeladd": "671 STATE ROUTE 217",
    "dropdelcty": "MELLENVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125449800,
    "dropphyadd": "671 STATE ROUTE 217",
    "dropphycty": "MELLENVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELLENVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125449998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186727400,
    "dropsitcph": 5186727400,
    "dropfax": 5186727400
  },
  {
    "dcode": "D",
    "dropkey": "PV14632",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "807 STATE ROUTE 40",
    "dropdelcty": "MELROSE",
    "dropdelst": "NY",
    "dropdelzpp": 121219998,
    "dropphyadd": "807 STATE ROUTE 40",
    "dropphycty": "MELROSE",
    "dropphyst": "NY",
    "dropphyzpp": 121219998,
    "dropmaladd": "807 STATE ROUTE 40",
    "dropmalcty": "MELROSE",
    "dropmalst": "NY",
    "dropmalzpp": 121219998,
    "dropsitphn": 5182352071,
    "dropsitlph": 5182352071,
    "dropsitcph": 5182352071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14636",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "1749 STATE ROUTE 173",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "NY",
    "dropdelzpp": 131129998,
    "dropphyadd": "1749 STATE ROUTE 173",
    "dropphycty": "MEMPHIS",
    "dropphyst": "NY",
    "dropphyzpp": 131129998,
    "dropmaladd": "1749 STATE ROUTE 173",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "NY",
    "dropmalzpp": 131129998,
    "dropsitphn": 3156897310,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156897310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14638",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "53 ASSEMBLY DR",
    "dropdelcty": "MENDON",
    "dropdelst": "NY",
    "dropdelzpp": 145069998,
    "dropphyadd": "53 ASSEMBLY DR",
    "dropphycty": "MENDON",
    "dropphyst": "NY",
    "dropphyzpp": 145069998,
    "dropmaladd": "53 ASSEMBLY DR",
    "dropmalcty": "MENDON",
    "dropmalst": "NY",
    "dropmalzpp": 145069998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856243441,
    "dropsitcph": 5856243441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14641",
    "droptype": "D",
    "dropname": "MERIDALE",
    "dropdeladd": "30 COUNTY HIGHWAY 10",
    "dropdelcty": "MERIDALE",
    "dropdelst": "NY",
    "dropdelzpp": 138069998,
    "dropphyadd": "30 COUNTY HIGHWAY 10",
    "dropphycty": "MERIDALE",
    "dropphyst": "NY",
    "dropphyzpp": 138069998,
    "dropmaladd": "30 COUNTY HIGHWAY 10",
    "dropmalcty": "MERIDALE",
    "dropmalst": "NY",
    "dropmalzpp": 138069998,
    "dropsitphn": 6077466440,
    "dropsitlph": 6077466440,
    "dropsitcph": 6077466440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14642",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "3078 STATE ROUTE 370",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "NY",
    "dropdelzpp": 131139998,
    "dropphyadd": "3078 STATE ROUTE 370",
    "dropphycty": "MERIDIAN",
    "dropphyst": "NY",
    "dropphyzpp": 131139998,
    "dropmaladd": "3078 STATE ROUTE 370",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "NY",
    "dropmalzpp": 131139998,
    "dropsitphn": 3156262070,
    "dropsitlph": 5184522299,
    "dropsitcph": 3156262070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14643",
    "droptype": "D",
    "dropname": "MERRICK",
    "dropdeladd": "2040 MERRICK RD",
    "dropdelcty": "MERRICK",
    "dropdelst": "NY",
    "dropdelzpp": 115664742,
    "dropphyadd": "2040 MERRICK RD",
    "dropphycty": "MERRICK",
    "dropphyst": "NY",
    "dropphyzpp": 115664742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRICK",
    "dropmalst": "NY",
    "dropmalzpp": 115669998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163787087,
    "dropfax": 5163784139
  },
  {
    "dcode": "D",
    "dropkey": "PV14655",
    "droptype": "D",
    "dropname": "MEXICO",
    "dropdeladd": "5640 NORMAN AVE",
    "dropdelcty": "MEXICO",
    "dropdelst": "NY",
    "dropdelzpp": 131149998,
    "dropphyadd": "5640 NORMAN AVE",
    "dropphycty": "MEXICO",
    "dropphyst": "NY",
    "dropphyzpp": 131149998,
    "dropmaladd": "5640 NORMAN AVE",
    "dropmalcty": "MEXICO",
    "dropmalst": "NY",
    "dropmalzpp": 131149998,
    "dropsitphn": 3159633611,
    "dropsitlph": 5184522299,
    "dropsitcph": 3159633611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14658",
    "droptype": "D",
    "dropname": "MID HUDSON",
    "dropdeladd": "99 ENTERPRISE DR",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 125558301,
    "dropphyadd": "99 ENTERPRISE DR",
    "dropphycty": "NEWBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 125558301,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 125559997,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 9145672301,
    "dropfax": 9145672309
  },
  {
    "dcode": "D",
    "dropkey": "PV14659",
    "droptype": "D",
    "dropname": "MIDDLE FALLS",
    "dropdeladd": "1079 STATE ROUTE 29",
    "dropdelcty": "MIDDLE FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 128489998,
    "dropphyadd": "1079 STATE ROUTE 29",
    "dropphycty": "MIDDLE FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 128489998,
    "dropmaladd": "1079 STATE ROUTE 29",
    "dropmalcty": "MIDDLE FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128489998,
    "dropsitphn": 5186922552,
    "dropsitlph": 5186922552,
    "dropsitcph": 5186922552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14660",
    "droptype": "D",
    "dropname": "MIDDLE GRANVILLE",
    "dropdeladd": "5 RIVERSIDE DR",
    "dropdelcty": "MIDDLE GRANVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128499998,
    "dropphyadd": "5 RIVERSIDE DR",
    "dropphycty": "MIDDLE GRANVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128499998,
    "dropmaladd": "5 RIVERSIDE DR",
    "dropmalcty": "MIDDLE GRANVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128499998,
    "dropsitphn": 5186420541,
    "dropsitlph": 5186420541,
    "dropsitcph": 5186420541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14662",
    "droptype": "D",
    "dropname": "MIDDLE GROVE",
    "dropdeladd": "3B LAKE DESOLATION RD",
    "dropdelcty": "MIDDLE GROVE",
    "dropdelst": "NY",
    "dropdelzpp": 128509998,
    "dropphyadd": "3B LAKE DESOLATION RD",
    "dropphycty": "MIDDLE GROVE",
    "dropphyst": "NY",
    "dropphyzpp": 128509998,
    "dropmaladd": "3B LAKE DESOLATION RD",
    "dropmalcty": "MIDDLE GROVE",
    "dropmalst": "NY",
    "dropmalzpp": 128509998,
    "dropsitphn": 5185847760,
    "dropsitlph": 5185847760,
    "dropsitcph": 5185847760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14665",
    "droptype": "D",
    "dropname": "MIDDLE ISLAND",
    "dropdeladd": "780 MIDDLE COUNTRY RD",
    "dropdelcty": "MIDDLE ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 119532559,
    "dropphyadd": "780 MIDDLE COUNTRY RD",
    "dropphycty": "MIDDLE ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 119532559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLE ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 119539998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312051089,
    "dropfax": 6313456170
  },
  {
    "dcode": "D",
    "dropkey": "PV14670",
    "droptype": "D",
    "dropname": "MIDDLEBURGH",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "MIDDLEBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 121229998,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "MIDDLEBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 121229998,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "MIDDLEBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 121229998,
    "dropsitphn": 5188275210,
    "dropsitlph": 5188275210,
    "dropsitcph": 5188275210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14672",
    "droptype": "D",
    "dropname": "MIDDLEPORT",
    "dropdeladd": "42 MAIN ST",
    "dropdelcty": "MIDDLEPORT",
    "dropdelst": "NY",
    "dropdelzpp": 141059998,
    "dropphyadd": "42 MAIN ST",
    "dropphycty": "MIDDLEPORT",
    "dropphyst": "NY",
    "dropphyzpp": 141059998,
    "dropmaladd": "42 MAIN ST",
    "dropmalcty": "MIDDLEPORT",
    "dropmalst": "NY",
    "dropmalzpp": 141059998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167353300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14673",
    "droptype": "D",
    "dropname": "MIDDLESEX",
    "dropdeladd": "1213 MAIN ST",
    "dropdelcty": "MIDDLESEX",
    "dropdelst": "NY",
    "dropdelzpp": 145079998,
    "dropphyadd": "1213 MAIN ST",
    "dropphycty": "MIDDLESEX",
    "dropphyst": "NY",
    "dropphyzpp": 145079998,
    "dropmaladd": "1213 MAIN ST",
    "dropmalcty": "MIDDLESEX",
    "dropmalst": "NY",
    "dropmalzpp": 145079998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855543390,
    "dropsitcph": 5855543390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14674",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "40 FULTON ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "NY",
    "dropdelzpp": 109409998,
    "dropphyadd": "40 FULTON ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "NY",
    "dropphyzpp": 109409998,
    "dropmaladd": "40 FULTON ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "NY",
    "dropmalzpp": 109409998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453411568,
    "dropsitcph": 8453411568,
    "dropfax": 8453422942
  },
  {
    "dcode": "D",
    "dropkey": "PV14682",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "43 S MAIN ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "NY",
    "dropdelzpp": 138079998,
    "dropphyadd": "43 S MAIN ST",
    "dropphycty": "MILFORD",
    "dropphyst": "NY",
    "dropphyzpp": 138079998,
    "dropmaladd": "43 S MAIN ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "NY",
    "dropmalzpp": 138079998,
    "dropsitphn": 6072867512,
    "dropsitlph": 6072867512,
    "dropsitcph": 6072867512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14685",
    "droptype": "D",
    "dropname": "MILL NECK",
    "dropdeladd": "32 FROST MILL RD",
    "dropdelcty": "MILL NECK",
    "dropdelst": "NY",
    "dropdelzpp": 117651102,
    "dropphyadd": "32 FROST MILL RD",
    "dropphycty": "MILL NECK",
    "dropphyst": "NY",
    "dropphyzpp": 117651102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILL NECK",
    "dropmalst": "NY",
    "dropmalzpp": 117659998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169228247,
    "dropfax": 5169221128
  },
  {
    "dcode": "D",
    "dropkey": "PV14687",
    "droptype": "D",
    "dropname": "MILLBROOK",
    "dropdeladd": "47 FRONT ST",
    "dropdelcty": "MILLBROOK",
    "dropdelst": "NY",
    "dropdelzpp": 125459998,
    "dropphyadd": "47 FRONT ST",
    "dropphycty": "MILLBROOK",
    "dropphyst": "NY",
    "dropphyzpp": 125459998,
    "dropmaladd": "47 FRONT ST",
    "dropmalcty": "MILLBROOK",
    "dropmalst": "NY",
    "dropmalzpp": 125459998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456771094,
    "dropsitcph": 8456771094,
    "dropfax": 8456773360
  },
  {
    "dcode": "D",
    "dropkey": "PV14689",
    "droptype": "D",
    "dropname": "MILLER PLACE",
    "dropdeladd": "47 ECHO AVE",
    "dropdelcty": "MILLER PLACE",
    "dropdelst": "NY",
    "dropdelzpp": 117642148,
    "dropphyadd": "47 ECHO AVE",
    "dropphycty": "MILLER PLACE",
    "dropphyst": "NY",
    "dropphyzpp": 117642148,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLER PLACE",
    "dropmalst": "NY",
    "dropmalzpp": 117649998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314738134,
    "dropfax": 6314737612
  },
  {
    "dcode": "D",
    "dropkey": "PV14691",
    "droptype": "D",
    "dropname": "MILLERTON",
    "dropdeladd": "33 CENTURY BLVD",
    "dropdelcty": "MILLERTON",
    "dropdelst": "NY",
    "dropdelzpp": 125469998,
    "dropphyadd": "33 CENTURY BLVD",
    "dropphycty": "MILLERTON",
    "dropphyst": "NY",
    "dropphyzpp": 125469998,
    "dropmaladd": "33 CENTURY BLVD",
    "dropmalcty": "MILLERTON",
    "dropmalst": "NY",
    "dropmalzpp": 125469998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187899093,
    "dropsitcph": 5187899093,
    "dropfax": 5187899523
  },
  {
    "dcode": "D",
    "dropkey": "PV14692",
    "droptype": "D",
    "dropname": "MILLPORT",
    "dropdeladd": "3 BURCH HILL RD",
    "dropdelcty": "MILLPORT",
    "dropdelst": "NY",
    "dropdelzpp": 148649998,
    "dropphyadd": "3 BURCH HILL RD",
    "dropphycty": "MILLPORT",
    "dropphyst": "NY",
    "dropphyzpp": 148649998,
    "dropmaladd": "3 BURCH HILL RD",
    "dropmalcty": "MILLPORT",
    "dropmalst": "NY",
    "dropmalzpp": 148649998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077399323,
    "dropsitcph": 6077399323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14694",
    "droptype": "D",
    "dropname": "MILLWOOD",
    "dropdeladd": "230 SAW MILL RIVER RD STE 10",
    "dropdelcty": "MILLWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 105469998,
    "dropphyadd": "230 SAW MILL RIVER RD STE 10",
    "dropphycty": "MILLWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 105469998,
    "dropmaladd": "230 SAW MILL RIVER RD STE 10",
    "dropmalcty": "MILLWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 105469998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149230365,
    "dropsitcph": 9149230365,
    "dropfax": 9147624846
  },
  {
    "dcode": "D",
    "dropkey": "PV14696",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "63 MAIN ST",
    "dropdelcty": "MILTON",
    "dropdelst": "NY",
    "dropdelzpp": 125479998,
    "dropphyadd": "63 MAIN ST",
    "dropphycty": "MILTON",
    "dropphyst": "NY",
    "dropphyzpp": 125479998,
    "dropmaladd": "63 MAIN ST",
    "dropmalcty": "MILTON",
    "dropmalst": "NY",
    "dropmalzpp": 125479998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457955380,
    "dropsitcph": 8457955380,
    "dropfax": 8457951369
  },
  {
    "dcode": "D",
    "dropkey": "PV14701",
    "droptype": "D",
    "dropname": "MINEOLA",
    "dropdeladd": "160 1ST ST",
    "dropdelcty": "MINEOLA",
    "dropdelst": "NY",
    "dropdelzpp": 115014070,
    "dropphyadd": "160 1ST ST",
    "dropphycty": "MINEOLA",
    "dropphyst": "NY",
    "dropphyzpp": 115014070,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINEOLA",
    "dropmalst": "NY",
    "dropmalzpp": 115019998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167461372,
    "dropfax": 5167475876
  },
  {
    "dcode": "D",
    "dropkey": "PV14703",
    "droptype": "D",
    "dropname": "MINERVA",
    "dropdeladd": "1709 STATE ROUTE 28N",
    "dropdelcty": "MINERVA",
    "dropdelst": "NY",
    "dropdelzpp": 128519998,
    "dropphyadd": "1709 STATE ROUTE 28N",
    "dropphycty": "MINERVA",
    "dropphyst": "NY",
    "dropphyzpp": 128519998,
    "dropmaladd": "1709 STATE ROUTE 28N",
    "dropmalcty": "MINERVA",
    "dropmalst": "NY",
    "dropmalzpp": 128519998,
    "dropsitphn": 5182512643,
    "dropsitlph": 5182512643,
    "dropsitcph": 5182512643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14704",
    "droptype": "D",
    "dropname": "MINETTO",
    "dropdeladd": "10 COUNTY ROUTE 24",
    "dropdelcty": "MINETTO",
    "dropdelst": "NY",
    "dropdelzpp": 131159998,
    "dropphyadd": "10 COUNTY ROUTE 24",
    "dropphycty": "MINETTO",
    "dropphyst": "NY",
    "dropphyzpp": 131159998,
    "dropmaladd": "10 COUNTY ROUTE 24",
    "dropmalcty": "MINETTO",
    "dropmalst": "NY",
    "dropmalzpp": 131159998,
    "dropsitphn": 3153424590,
    "dropsitlph": 5184522299,
    "dropsitcph": 3153424590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14705",
    "droptype": "D",
    "dropname": "MINEVILLE",
    "dropdeladd": "137 RAYMOND WRIGHT AVE",
    "dropdelcty": "MINEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129569998,
    "dropphyadd": "137 RAYMOND WRIGHT AVE",
    "dropphycty": "MINEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129569998,
    "dropmaladd": "137 RAYMOND WRIGHT AVE",
    "dropmalcty": "MINEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129569998,
    "dropsitphn": 5189427771,
    "dropsitlph": 5189427771,
    "dropsitcph": 5189427771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14706",
    "droptype": "D",
    "dropname": "MINOA",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "MINOA",
    "dropdelst": "NY",
    "dropdelzpp": 131169998,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "MINOA",
    "dropphyst": "NY",
    "dropphyzpp": 131169998,
    "dropmaladd": "115 N MAIN ST",
    "dropmalcty": "MINOA",
    "dropmalst": "NY",
    "dropmalzpp": 131169998,
    "dropsitphn": 3156568845,
    "dropsitlph": 3156568845,
    "dropsitcph": 3156568845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14712",
    "droptype": "D",
    "dropname": "MODEL CITY",
    "dropdeladd": "4746 MODEL CITY RD",
    "dropdelcty": "MODEL CITY",
    "dropdelst": "NY",
    "dropdelzpp": 141079800,
    "dropphyadd": "4746 MODEL CITY RD",
    "dropphycty": "MODEL CITY",
    "dropphyst": "NY",
    "dropphyzpp": 141079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MODEL CITY",
    "dropmalst": "NY",
    "dropmalzpp": 141079998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167548859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14713",
    "droptype": "D",
    "dropname": "MODENA",
    "dropdeladd": "2255 STATE ROUTE 32",
    "dropdelcty": "MODENA",
    "dropdelst": "NY",
    "dropdelzpp": 125489998,
    "dropphyadd": "2255 STATE ROUTE 32",
    "dropphycty": "MODENA",
    "dropphyst": "NY",
    "dropphyzpp": 125489998,
    "dropmaladd": "2255 STATE ROUTE 32",
    "dropmalcty": "MODENA",
    "dropmalst": "NY",
    "dropmalzpp": 125489998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458835071,
    "dropsitcph": 8458835071,
    "dropfax": 8458836525
  },
  {
    "dcode": "D",
    "dropkey": "PV14715",
    "droptype": "D",
    "dropname": "MOHAWK",
    "dropdeladd": "25 COLUMBIA ST",
    "dropdelcty": "MOHAWK",
    "dropdelst": "NY",
    "dropdelzpp": 134079998,
    "dropphyadd": "25 COLUMBIA ST",
    "dropphycty": "MOHAWK",
    "dropphyst": "NY",
    "dropphyzpp": 134079998,
    "dropmaladd": "25 COLUMBIA ST",
    "dropmalcty": "MOHAWK",
    "dropmalst": "NY",
    "dropmalzpp": 134079998,
    "dropsitphn": 3158661720,
    "dropsitlph": 3158661720,
    "dropsitcph": 3158661720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14717",
    "droptype": "D",
    "dropname": "MOHEGAN LAKE",
    "dropdeladd": "3147 E MAIN ST",
    "dropdelcty": "MOHEGAN LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 105479998,
    "dropphyadd": "3147 E MAIN ST",
    "dropphycty": "MOHEGAN LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 105479998,
    "dropmaladd": "3147 E MAIN ST",
    "dropmalcty": "MOHEGAN LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 105479998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145289067,
    "dropsitcph": 9145289067,
    "dropfax": 9145282079
  },
  {
    "dcode": "D",
    "dropkey": "PV14721",
    "droptype": "D",
    "dropname": "MOIRA",
    "dropdeladd": "816 STATE ROUTE 11",
    "dropdelcty": "MOIRA",
    "dropdelst": "NY",
    "dropdelzpp": 129579998,
    "dropphyadd": "816 STATE ROUTE 11",
    "dropphycty": "MOIRA",
    "dropphyst": "NY",
    "dropphyzpp": 129579998,
    "dropmaladd": "816 STATE ROUTE 11",
    "dropmalcty": "MOIRA",
    "dropmalst": "NY",
    "dropmalzpp": 129579998,
    "dropsitphn": 5185297325,
    "dropsitlph": 5185297325,
    "dropsitcph": 5185297325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14722",
    "droptype": "D",
    "dropname": "MONGAUP VALLEY",
    "dropdeladd": "933 STATE ROUTE 17B",
    "dropdelcty": "MONGAUP VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 127629998,
    "dropphyadd": "933 STATE ROUTE 17B",
    "dropphycty": "MONGAUP VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 127629998,
    "dropmaladd": "933 STATE ROUTE 17B",
    "dropmalcty": "MONGAUP VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 127629998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457915956,
    "dropsitcph": 8457915956,
    "dropfax": 8457915956
  },
  {
    "dcode": "D",
    "dropkey": "PV14723",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "787 STATE ROUTE 17M",
    "dropdelcty": "MONROE",
    "dropdelst": "NY",
    "dropdelzpp": 109509998,
    "dropphyadd": "787 STATE ROUTE 17M",
    "dropphycty": "MONROE",
    "dropphyst": "NY",
    "dropphyzpp": 109509998,
    "dropmaladd": "787 STATE ROUTE 17M",
    "dropmalcty": "MONROE",
    "dropmalst": "NY",
    "dropmalzpp": 109509998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457837827,
    "dropsitcph": 8457837827,
    "dropfax": 8457831093
  },
  {
    "dcode": "D",
    "dropkey": "PV14724",
    "droptype": "D",
    "dropname": "MONSEY",
    "dropdeladd": "15 MELNICK DR",
    "dropdelcty": "MONSEY",
    "dropdelst": "NY",
    "dropdelzpp": 109529998,
    "dropphyadd": "15 MELNICK DR",
    "dropphycty": "MONSEY",
    "dropphyst": "NY",
    "dropphyzpp": 109529998,
    "dropmaladd": "15 MELNICK DR",
    "dropmalcty": "MONSEY",
    "dropmalst": "NY",
    "dropmalzpp": 109529998,
    "dropsitphn": 9146974000,
    "dropsitlph": 8457323170,
    "dropsitcph": 8457323170,
    "dropfax": 8457323136
  },
  {
    "dcode": "D",
    "dropkey": "PV14726",
    "droptype": "D",
    "dropname": "MONTAUK",
    "dropdeladd": "73 S EUCLID AVE",
    "dropdelcty": "MONTAUK",
    "dropdelst": "NY",
    "dropdelzpp": 119545103,
    "dropphyadd": "73 S EUCLID AVE",
    "dropphycty": "MONTAUK",
    "dropphyst": "NY",
    "dropphyzpp": 119545103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTAUK",
    "dropmalst": "NY",
    "dropmalzpp": 119549998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316687043,
    "dropfax": 6316683944
  },
  {
    "dcode": "D",
    "dropkey": "PV14729",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "8109 STATE ROUTE 90",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "NY",
    "dropdelzpp": 131179998,
    "dropphyadd": "8109 STATE ROUTE 90",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "NY",
    "dropphyzpp": 131179998,
    "dropmaladd": "8109 STATE ROUTE 90",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "NY",
    "dropmalzpp": 131179998,
    "dropsitphn": 3157764294,
    "dropsitlph": 3157764294,
    "dropsitcph": 3157764294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14731",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "218 BOYD ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "NY",
    "dropdelzpp": 125499998,
    "dropphyadd": "218 BOYD ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "NY",
    "dropphyzpp": 125499998,
    "dropmaladd": "218 BOYD ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "NY",
    "dropmalzpp": 125499998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454571403,
    "dropsitcph": 8454571403,
    "dropfax": 8454571285
  },
  {
    "dcode": "D",
    "dropkey": "PV14732",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "486 BROADWAY",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "NY",
    "dropdelzpp": 127019998,
    "dropphyadd": "486 BROADWAY",
    "dropphycty": "MONTICELLO",
    "dropphyst": "NY",
    "dropphyzpp": 127019998,
    "dropmaladd": "486 BROADWAY",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "NY",
    "dropmalzpp": 127019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457947498,
    "dropsitcph": 8457947498,
    "dropfax": 8457942561
  },
  {
    "dcode": "D",
    "dropkey": "PV14733",
    "droptype": "D",
    "dropname": "MONTOUR FALLS",
    "dropdeladd": "309 W MAIN ST",
    "dropdelcty": "MONTOUR FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 148659998,
    "dropphyadd": "309 W MAIN ST",
    "dropphycty": "MONTOUR FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 148659998,
    "dropmaladd": "309 W MAIN ST",
    "dropmalcty": "MONTOUR FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 148659998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075357584,
    "dropsitcph": 6075357584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14734",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "13 KINGS FERRY RD",
    "dropdelcty": "MONTROSE",
    "dropdelst": "NY",
    "dropdelzpp": 105489998,
    "dropphyadd": "13 KINGS FERRY RD",
    "dropphycty": "MONTROSE",
    "dropphyst": "NY",
    "dropphyzpp": 105489998,
    "dropmaladd": "13 KINGS FERRY RD",
    "dropmalcty": "MONTROSE",
    "dropmalst": "NY",
    "dropmalzpp": 105489998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147377539,
    "dropsitcph": 9147377539,
    "dropfax": 9147393072
  },
  {
    "dcode": "D",
    "dropkey": "PV14736",
    "droptype": "D",
    "dropname": "MOOERS",
    "dropdeladd": "2578 STATE ROUTE 11",
    "dropdelcty": "MOOERS",
    "dropdelst": "NY",
    "dropdelzpp": 129589998,
    "dropphyadd": "2578 STATE ROUTE 11",
    "dropphycty": "MOOERS",
    "dropphyst": "NY",
    "dropphyzpp": 129589998,
    "dropmaladd": "2578 STATE ROUTE 11",
    "dropmalcty": "MOOERS",
    "dropmalst": "NY",
    "dropmalzpp": 129589998,
    "dropsitphn": 5182367377,
    "dropsitlph": 5182367377,
    "dropsitcph": 5182367377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14737",
    "droptype": "D",
    "dropname": "MOOERS FORKS",
    "dropdeladd": "3071 STATE ROUTE 11",
    "dropdelcty": "MOOERS FORKS",
    "dropdelst": "NY",
    "dropdelzpp": 129599998,
    "dropphyadd": "3071 STATE ROUTE 11",
    "dropphycty": "MOOERS FORKS",
    "dropphyst": "NY",
    "dropphyzpp": 129599998,
    "dropmaladd": "3071 STATE ROUTE 11",
    "dropmalcty": "MOOERS FORKS",
    "dropmalst": "NY",
    "dropmalzpp": 129599998,
    "dropsitphn": 5182367380,
    "dropsitlph": 5182367380,
    "dropsitcph": 5182367380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14740",
    "droptype": "D",
    "dropname": "MORAVIA",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "MORAVIA",
    "dropdelst": "NY",
    "dropdelzpp": 131189998,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "MORAVIA",
    "dropphyst": "NY",
    "dropphyzpp": 131189998,
    "dropmaladd": "100 S MAIN ST",
    "dropmalcty": "MORAVIA",
    "dropmalst": "NY",
    "dropmalzpp": 131189998,
    "dropsitphn": 3154971510,
    "dropsitlph": 3154971510,
    "dropsitcph": 3154971510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14745",
    "droptype": "D",
    "dropname": "MORIAH",
    "dropdeladd": "619 TARBELL HILL RD STE 1",
    "dropdelcty": "MORIAH",
    "dropdelst": "NY",
    "dropdelzpp": 129609998,
    "dropphyadd": "619 TARBELL HILL RD STE 1",
    "dropphycty": "MORIAH",
    "dropphyst": "NY",
    "dropphyzpp": 129609998,
    "dropmaladd": "619 TARBELL HILL RD STE 1",
    "dropmalcty": "MORIAH",
    "dropmalst": "NY",
    "dropmalzpp": 129609998,
    "dropsitphn": 5185463548,
    "dropsitlph": 5185463548,
    "dropsitcph": 5185463548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14746",
    "droptype": "D",
    "dropname": "MORIAH CENTER",
    "dropdeladd": "54 WITHERBEE RD STE 1",
    "dropdelcty": "MORIAH CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 129619998,
    "dropphyadd": "54 WITHERBEE RD STE 1",
    "dropphycty": "MORIAH CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 129619998,
    "dropmaladd": "54 WITHERBEE RD STE 1",
    "dropmalcty": "MORIAH CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 129619998,
    "dropsitphn": 5185468221,
    "dropsitlph": 5185468221,
    "dropsitcph": 5185468221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14748",
    "droptype": "D",
    "dropname": "MORICHES",
    "dropdeladd": "290 MONTAUK HWY",
    "dropdelcty": "MORICHES",
    "dropdelst": "NY",
    "dropdelzpp": 119551440,
    "dropphyadd": "290 MONTAUK HWY",
    "dropphycty": "MORICHES",
    "dropphyst": "NY",
    "dropphyzpp": 119551440,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORICHES",
    "dropmalst": "NY",
    "dropmalzpp": 119559998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6318781381,
    "dropfax": 6318742946
  },
  {
    "dcode": "D",
    "dropkey": "PV14752",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "127 MAIN ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "NY",
    "dropdelzpp": 138089998,
    "dropphyadd": "127 MAIN ST",
    "dropphycty": "MORRIS",
    "dropphyst": "NY",
    "dropphyzpp": 138089998,
    "dropmaladd": "127 MAIN ST",
    "dropmalcty": "MORRIS",
    "dropmalst": "NY",
    "dropmalzpp": 138089998,
    "dropsitphn": 6072635130,
    "dropsitlph": 6072635130,
    "dropsitcph": 6072635130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14759",
    "droptype": "D",
    "dropname": "MORRISONVILLE",
    "dropdeladd": "1934 STATE ROUTE 22B",
    "dropdelcty": "MORRISONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129629998,
    "dropphyadd": "1934 STATE ROUTE 22B",
    "dropphycty": "MORRISONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129629998,
    "dropmaladd": "1934 STATE ROUTE 22B",
    "dropmalcty": "MORRISONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129629998,
    "dropsitphn": 5185617496,
    "dropsitlph": 5185617496,
    "dropsitcph": 5185617496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14760",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 136649998,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 136649998,
    "dropmaladd": "306 MAIN ST",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 136649998,
    "dropsitphn": 3153756391,
    "dropsitlph": 3153756391,
    "dropsitcph": 3153756391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14762",
    "droptype": "D",
    "dropname": "MORRISVILLE",
    "dropdeladd": "18 EATON ST",
    "dropdelcty": "MORRISVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134089998,
    "dropphyadd": "18 EATON ST",
    "dropphycty": "MORRISVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134089998,
    "dropmaladd": "18 EATON ST",
    "dropmalcty": "MORRISVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134089998,
    "dropsitphn": 3156849188,
    "dropsitlph": 3156849188,
    "dropsitcph": 3156849188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14764",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "1205 COUNTY LINE RD STE 1",
    "dropdelcty": "MORTON",
    "dropdelst": "NY",
    "dropdelzpp": 145089800,
    "dropphyadd": "1205 COUNTY LINE RD STE 1",
    "dropphycty": "MORTON",
    "dropphyst": "NY",
    "dropphyzpp": 145089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORTON",
    "dropmalst": "NY",
    "dropmalzpp": 145089998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856592810,
    "dropsitcph": 5856592810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14781",
    "droptype": "D",
    "dropname": "MOUNT KISCO",
    "dropdeladd": "3 MORGAN DR",
    "dropdelcty": "MOUNT KISCO",
    "dropdelst": "NY",
    "dropdelzpp": 105499998,
    "dropphyadd": "3 MORGAN DR",
    "dropphycty": "MOUNT KISCO",
    "dropphyst": "NY",
    "dropphyzpp": 105499998,
    "dropmaladd": "3 MORGAN DR",
    "dropmalcty": "MOUNT KISCO",
    "dropmalst": "NY",
    "dropmalzpp": 105499998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146663842,
    "dropsitcph": 9146663842,
    "dropfax": 9146662056
  },
  {
    "dcode": "D",
    "dropkey": "PV14782",
    "droptype": "D",
    "dropname": "MOUNT MARION",
    "dropdeladd": "542 GLASCO TPKE",
    "dropdelcty": "MOUNT MARION",
    "dropdelst": "NY",
    "dropdelzpp": 124569998,
    "dropphyadd": "542 GLASCO TPKE",
    "dropphycty": "MOUNT MARION",
    "dropphyst": "NY",
    "dropphyzpp": 124569998,
    "dropmaladd": "542 GLASCO TPKE",
    "dropmalcty": "MOUNT MARION",
    "dropmalst": "NY",
    "dropmalzpp": 124569998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452469661,
    "dropsitcph": 8452469661,
    "dropfax": 8452469661
  },
  {
    "dcode": "D",
    "dropkey": "PV14785",
    "droptype": "D",
    "dropname": "MOUNT MORRIS",
    "dropdeladd": "31 CHAPEL ST",
    "dropdelcty": "MOUNT MORRIS",
    "dropdelst": "NY",
    "dropdelzpp": 145109998,
    "dropphyadd": "31 CHAPEL ST",
    "dropphycty": "MOUNT MORRIS",
    "dropphyst": "NY",
    "dropphyzpp": 145109998,
    "dropmaladd": "31 CHAPEL ST",
    "dropmalcty": "MOUNT MORRIS",
    "dropmalst": "NY",
    "dropmalzpp": 145109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856583200,
    "dropsitcph": 5856583200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14790",
    "droptype": "D",
    "dropname": "MOUNT SINAI",
    "dropdeladd": "457 ROUTE 25A",
    "dropdelcty": "MOUNT SINAI",
    "dropdelst": "NY",
    "dropdelzpp": 117662069,
    "dropphyadd": "457 ROUTE 25A",
    "dropphycty": "MOUNT SINAI",
    "dropphyst": "NY",
    "dropphyzpp": 117662069,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT SINAI",
    "dropmalst": "NY",
    "dropmalzpp": 117669998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319280394,
    "dropfax": 6314763512
  },
  {
    "dcode": "D",
    "dropkey": "PV14791",
    "droptype": "D",
    "dropname": "MOUNT TREMPER",
    "dropdeladd": "5340 ROUTE 28",
    "dropdelcty": "MOUNT TREMPER",
    "dropdelst": "NY",
    "dropdelzpp": 124579997,
    "dropphyadd": "5340 ROUTE 28",
    "dropphycty": "MOUNT TREMPER",
    "dropphyst": "NY",
    "dropphyzpp": 124579997,
    "dropmaladd": "5340 ROUTE 28",
    "dropmalcty": "MOUNT TREMPER",
    "dropmalst": "NY",
    "dropmalzpp": 124579997,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456887378,
    "dropsitcph": 8456887378,
    "dropfax": 8456887378
  },
  {
    "dcode": "D",
    "dropkey": "PV14792",
    "droptype": "D",
    "dropname": "MOUNT UPTON",
    "dropdeladd": "1753 STATE HIGHWAY 8",
    "dropdelcty": "MOUNT UPTON",
    "dropdelst": "NY",
    "dropdelzpp": 138099998,
    "dropphyadd": "1753 STATE HIGHWAY 8",
    "dropphycty": "MOUNT UPTON",
    "dropphyst": "NY",
    "dropphyzpp": 138099998,
    "dropmaladd": "1753 STATE HIGHWAY 8",
    "dropmalcty": "MOUNT UPTON",
    "dropmalst": "NY",
    "dropmalzpp": 138099998,
    "dropsitphn": 6077648463,
    "dropsitlph": 6077648463,
    "dropsitcph": 6077648463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14793",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "15 S 1ST AVE",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "NY",
    "dropdelzpp": 105503460,
    "dropphyadd": "15 S 1ST AVE",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "NY",
    "dropphyzpp": 105503460,
    "dropmaladd": "15 S 1ST AVE",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "NY",
    "dropmalzpp": 105503460,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146687672,
    "dropsitcph": 9146687672,
    "dropfax": 9146683475
  },
  {
    "dcode": "D",
    "dropkey": "PV14794",
    "droptype": "D",
    "dropname": "MOUNT VISION",
    "dropdeladd": "2363 STATE HIGHWAY 205",
    "dropdelcty": "MOUNT VISION",
    "dropdelst": "NY",
    "dropdelzpp": 138109998,
    "dropphyadd": "2363 STATE HIGHWAY 205",
    "dropphycty": "MOUNT VISION",
    "dropphyst": "NY",
    "dropphyzpp": 138109998,
    "dropmaladd": "2363 STATE HIGHWAY 205",
    "dropmalcty": "MOUNT VISION",
    "dropmalst": "NY",
    "dropmalzpp": 138109998,
    "dropsitphn": 6074323669,
    "dropsitlph": 6074323669,
    "dropsitcph": 6074323669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14795",
    "droptype": "D",
    "dropname": "MOUNTAIN DALE",
    "dropdeladd": "12 POST HILL RD",
    "dropdelcty": "MOUNTAIN DALE",
    "dropdelst": "NY",
    "dropdelzpp": 127639998,
    "dropphyadd": "12 POST HILL RD",
    "dropphycty": "MOUNTAIN DALE",
    "dropphyst": "NY",
    "dropphyzpp": 127639998,
    "dropmaladd": "12 POST HILL RD",
    "dropmalcty": "MOUNTAIN DALE",
    "dropmalst": "NY",
    "dropmalzpp": 127639998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454345810,
    "dropsitcph": 8454345810,
    "dropfax": 8454345810
  },
  {
    "dcode": "D",
    "dropkey": "PV14798",
    "droptype": "D",
    "dropname": "MOUNTAINVILLE",
    "dropdeladd": "107 STATION RD",
    "dropdelcty": "MOUNTAINVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109536009,
    "dropphyadd": "107 STATION RD",
    "dropphycty": "MOUNTAINVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109536009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAINVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109539998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455342861,
    "dropsitcph": 8455342861,
    "dropfax": 8455342861
  },
  {
    "dcode": "D",
    "dropkey": "PV14811",
    "droptype": "D",
    "dropname": "MUMFORD",
    "dropdeladd": "38 DAKIN ST",
    "dropdelcty": "MUMFORD",
    "dropdelst": "NY",
    "dropdelzpp": 145119800,
    "dropphyadd": "38 DAKIN ST",
    "dropphycty": "MUMFORD",
    "dropphyst": "NY",
    "dropphyzpp": 145119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MUMFORD",
    "dropmalst": "NY",
    "dropmalzpp": 145119998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855382212,
    "dropsitcph": 5855382212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14813",
    "droptype": "D",
    "dropname": "MUNNSVILLE",
    "dropdeladd": "6188 VALLEY MILLS RD",
    "dropdelcty": "MUNNSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134099998,
    "dropphyadd": "6188 VALLEY MILLS RD",
    "dropphycty": "MUNNSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134099998,
    "dropmaladd": "6188 VALLEY MILLS RD",
    "dropmalcty": "MUNNSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134099998,
    "dropsitphn": 3154952944,
    "dropsitlph": 3154952944,
    "dropsitcph": 3154952944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14902",
    "droptype": "D",
    "dropname": "NANUET",
    "dropdeladd": "10 PROSPECT ST",
    "dropdelcty": "NANUET",
    "dropdelst": "NY",
    "dropdelzpp": 109549998,
    "dropphyadd": "10 PROSPECT ST",
    "dropphycty": "NANUET",
    "dropphyst": "NY",
    "dropphyzpp": 109549998,
    "dropmaladd": "10 PROSPECT ST",
    "dropmalcty": "NANUET",
    "dropmalst": "NY",
    "dropmalzpp": 109549998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456236781,
    "dropsitcph": 8456236781,
    "dropfax": 8456236293
  },
  {
    "dcode": "D",
    "dropkey": "PV14903",
    "droptype": "D",
    "dropname": "NAPANOCH",
    "dropdeladd": "7600 STATE ROUTE 209 STE 1",
    "dropdelcty": "NAPANOCH",
    "dropdelst": "NY",
    "dropdelzpp": 124589998,
    "dropphyadd": "7600 STATE ROUTE 209 STE 1",
    "dropphycty": "NAPANOCH",
    "dropphyst": "NY",
    "dropphyzpp": 124589998,
    "dropmaladd": "7600 STATE ROUTE 209 STE 1",
    "dropmalcty": "NAPANOCH",
    "dropmalst": "NY",
    "dropmalzpp": 124589998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456474249,
    "dropsitcph": 8456474249,
    "dropfax": 8456479360
  },
  {
    "dcode": "D",
    "dropkey": "PV14904",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "137 N MAIN ST",
    "dropdelcty": "NAPLES",
    "dropdelst": "NY",
    "dropdelzpp": 145129998,
    "dropphyadd": "137 N MAIN ST",
    "dropphycty": "NAPLES",
    "dropphyst": "NY",
    "dropphyzpp": 145129998,
    "dropmaladd": "137 N MAIN ST",
    "dropmalcty": "NAPLES",
    "dropmalst": "NY",
    "dropmalzpp": 145129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853742920,
    "dropsitcph": 5853742920,
    "dropfax": 5853746557
  },
  {
    "dcode": "D",
    "dropkey": "PV14906",
    "droptype": "D",
    "dropname": "NARROWSBURG",
    "dropdeladd": "75 MAIN ST",
    "dropdelcty": "NARROWSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 127649998,
    "dropphyadd": "75 MAIN ST",
    "dropphycty": "NARROWSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 127649998,
    "dropmaladd": "75 MAIN ST",
    "dropmalcty": "NARROWSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 127649998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452523076,
    "dropsitcph": 8452523076,
    "dropfax": 8452527145
  },
  {
    "dcode": "D",
    "dropkey": "PV14907",
    "droptype": "D",
    "dropname": "NASSAU",
    "dropdeladd": "10 FAIRGROUNDS ST",
    "dropdelcty": "NASSAU",
    "dropdelst": "NY",
    "dropdelzpp": 121239998,
    "dropphyadd": "10 FAIRGROUNDS ST",
    "dropphycty": "NASSAU",
    "dropphyst": "NY",
    "dropphyzpp": 121239998,
    "dropmaladd": "10 FAIRGROUNDS ST",
    "dropmalcty": "NASSAU",
    "dropmalst": "NY",
    "dropmalzpp": 121239998,
    "dropsitphn": 5187663322,
    "dropsitlph": 5187663322,
    "dropsitcph": 5187663322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14917",
    "droptype": "D",
    "dropname": "NATURAL BRIDGE",
    "dropdeladd": "43889 STATE ROUTE 3",
    "dropdelcty": "NATURAL BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 136659998,
    "dropphyadd": "43889 STATE ROUTE 3",
    "dropphycty": "NATURAL BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 136659998,
    "dropmaladd": "43889 STATE ROUTE 3",
    "dropmalcty": "NATURAL BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 136659998,
    "dropsitphn": 3156449326,
    "dropsitlph": 3156449326,
    "dropsitcph": 3156449326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14920",
    "droptype": "D",
    "dropname": "NEDROW",
    "dropdeladd": "6709 S SALINA ST",
    "dropdelcty": "NEDROW",
    "dropdelst": "NY",
    "dropdelzpp": 131209998,
    "dropphyadd": "6709 S SALINA ST",
    "dropphycty": "NEDROW",
    "dropphyst": "NY",
    "dropphyzpp": 131209998,
    "dropmaladd": "6709 S SALINA ST",
    "dropmalcty": "NEDROW",
    "dropmalst": "NY",
    "dropmalzpp": 131209998,
    "dropsitphn": 3154926902,
    "dropsitlph": 3154926902,
    "dropsitcph": 3154926902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14921",
    "droptype": "D",
    "dropname": "NELLISTON",
    "dropdeladd": "19 E MAIN ST",
    "dropdelcty": "NELLISTON",
    "dropdelst": "NY",
    "dropdelzpp": 134109998,
    "dropphyadd": "19 E MAIN ST",
    "dropphycty": "NELLISTON",
    "dropphyst": "NY",
    "dropphyzpp": 134109998,
    "dropmaladd": "19 E MAIN ST",
    "dropmalcty": "NELLISTON",
    "dropmalst": "NY",
    "dropmalzpp": 134109998,
    "dropsitphn": 5189932269,
    "dropsitlph": 5189932269,
    "dropsitcph": 5189932269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14926",
    "droptype": "D",
    "dropname": "NESCONSET",
    "dropdeladd": "226 SMITHTOWN BLVD",
    "dropdelcty": "NESCONSET",
    "dropdelst": "NY",
    "dropdelzpp": 117672427,
    "dropphyadd": "226 SMITHTOWN BLVD",
    "dropphycty": "NESCONSET",
    "dropphyst": "NY",
    "dropphyzpp": 117672427,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NESCONSET",
    "dropmalst": "NY",
    "dropmalzpp": 117679998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312653278,
    "dropfax": 6317243427
  },
  {
    "dcode": "D",
    "dropkey": "PV14927",
    "droptype": "D",
    "dropname": "NEVERSINK",
    "dropdeladd": "7420 STATE ROUTE 55",
    "dropdelcty": "NEVERSINK",
    "dropdelst": "NY",
    "dropdelzpp": 127659998,
    "dropphyadd": "7420 STATE ROUTE 55",
    "dropphycty": "NEVERSINK",
    "dropphyst": "NY",
    "dropphyzpp": 127659998,
    "dropmaladd": "7420 STATE ROUTE 55",
    "dropmalcty": "NEVERSINK",
    "dropmalst": "NY",
    "dropmalzpp": 127659998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459857102,
    "dropsitcph": 8459857102,
    "dropfax": 8459857102
  },
  {
    "dcode": "D",
    "dropkey": "PV14929",
    "droptype": "D",
    "dropname": "NEW BALTIMORE",
    "dropdeladd": "849 STATE ROUTE 144",
    "dropdelcty": "NEW BALTIMORE",
    "dropdelst": "NY",
    "dropdelzpp": 121249998,
    "dropphyadd": "849 STATE ROUTE 144",
    "dropphycty": "NEW BALTIMORE",
    "dropphyst": "NY",
    "dropphyzpp": 121249998,
    "dropmaladd": "849 STATE ROUTE 144",
    "dropmalcty": "NEW BALTIMORE",
    "dropmalst": "NY",
    "dropmalzpp": 121249998,
    "dropsitphn": 5187562061,
    "dropsitlph": 5187562061,
    "dropsitcph": 5187562061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14930",
    "droptype": "D",
    "dropname": "NEW BERLIN",
    "dropdeladd": "8 GENESEE ST",
    "dropdelcty": "NEW BERLIN",
    "dropdelst": "NY",
    "dropdelzpp": 134119998,
    "dropphyadd": "8 GENESEE ST",
    "dropphycty": "NEW BERLIN",
    "dropphyst": "NY",
    "dropphyzpp": 134119998,
    "dropmaladd": "8 GENESEE ST",
    "dropmalcty": "NEW BERLIN",
    "dropmalst": "NY",
    "dropmalzpp": 134119998,
    "dropsitphn": 6078476557,
    "dropsitlph": 6078476557,
    "dropsitcph": 6078476557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14934",
    "droptype": "D",
    "dropname": "NEW CITY",
    "dropdeladd": "245 N MAIN ST",
    "dropdelcty": "NEW CITY",
    "dropdelst": "NY",
    "dropdelzpp": 109569998,
    "dropphyadd": "245 N MAIN ST",
    "dropphycty": "NEW CITY",
    "dropphyst": "NY",
    "dropphyzpp": 109569998,
    "dropmaladd": "245 N MAIN ST",
    "dropmalcty": "NEW CITY",
    "dropmalst": "NY",
    "dropmalzpp": 109569998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456347216,
    "dropsitcph": 8456347216,
    "dropfax": 8456399350
  },
  {
    "dcode": "D",
    "dropkey": "PV14938",
    "droptype": "D",
    "dropname": "NEW HAMPTON",
    "dropdeladd": "5070 ROUTE 17M",
    "dropdelcty": "NEW HAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 109589998,
    "dropphyadd": "5070 ROUTE 17M",
    "dropphycty": "NEW HAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 109589998,
    "dropmaladd": "5070 ROUTE 17M",
    "dropmalcty": "NEW HAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 109589998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453743234,
    "dropsitcph": 8453743234,
    "dropfax": 8453740050
  },
  {
    "dcode": "D",
    "dropkey": "PV14940",
    "droptype": "D",
    "dropname": "NEW HARTFORD",
    "dropdeladd": "40 CAMPION RD",
    "dropdelcty": "NEW HARTFORD",
    "dropdelst": "NY",
    "dropdelzpp": 134139998,
    "dropphyadd": "40 CAMPION RD",
    "dropphycty": "NEW HARTFORD",
    "dropphyst": "NY",
    "dropphyzpp": 134139998,
    "dropmaladd": "40 CAMPION RD",
    "dropmalcty": "NEW HARTFORD",
    "dropmalst": "NY",
    "dropmalzpp": 134139998,
    "dropsitphn": 3157330453,
    "dropsitlph": 3157330453,
    "dropsitcph": 3157330453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14941",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "4250 STATE ROUTE 104",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "NY",
    "dropdelzpp": 131219998,
    "dropphyadd": "4250 STATE ROUTE 104",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "NY",
    "dropphyzpp": 131219998,
    "dropmaladd": "4250 STATE ROUTE 104",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "NY",
    "dropmalzpp": 131219998,
    "dropsitphn": 3159633166,
    "dropsitlph": 3159633166,
    "dropsitcph": 3159633166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14945",
    "droptype": "D",
    "dropname": "NEW HYDE PARK",
    "dropdeladd": "1001 2ND AVE",
    "dropdelcty": "NEW HYDE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 110409998,
    "dropphyadd": "1001 2ND AVE",
    "dropphycty": "NEW HYDE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 110409998,
    "dropmaladd": "1001 2ND AVE",
    "dropmalcty": "NEW HYDE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 110409998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 5163546024,
    "dropfax": 5164372896
  },
  {
    "dcode": "D",
    "dropkey": "PV14949",
    "droptype": "D",
    "dropname": "NEW KINGSTON",
    "dropdeladd": "5060 COUNTY ROUTE 6",
    "dropdelcty": "NEW KINGSTON",
    "dropdelst": "NY",
    "dropdelzpp": 124599800,
    "dropphyadd": "5060 COUNTY ROUTE 6",
    "dropphycty": "NEW KINGSTON",
    "dropphyst": "NY",
    "dropphyzpp": 124599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW KINGSTON",
    "dropmalst": "NY",
    "dropmalzpp": 124599998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8455864057,
    "dropfax": 8455861883
  },
  {
    "dcode": "D",
    "dropkey": "PV14950",
    "droptype": "D",
    "dropname": "NEW LEBANON",
    "dropdeladd": "502 ROUTE 20",
    "dropdelcty": "NEW LEBANON",
    "dropdelst": "NY",
    "dropdelzpp": 121259998,
    "dropphyadd": "502 ROUTE 20",
    "dropphycty": "NEW LEBANON",
    "dropphyst": "NY",
    "dropphyzpp": 121259998,
    "dropmaladd": "502 ROUTE 20",
    "dropmalcty": "NEW LEBANON",
    "dropmalst": "NY",
    "dropmalzpp": 121259998,
    "dropsitphn": 5187949021,
    "dropsitlph": 5187949021,
    "dropsitcph": 5187949021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14955",
    "droptype": "D",
    "dropname": "NEW MILFORD",
    "dropdeladd": "3 JOCKEY HOLLOW RD STE 2",
    "dropdelcty": "NEW MILFORD",
    "dropdelst": "NY",
    "dropdelzpp": 109599800,
    "dropphyadd": "3 JOCKEY HOLLOW RD STE 2",
    "dropphycty": "NEW MILFORD",
    "dropphyst": "NY",
    "dropphyzpp": 109599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MILFORD",
    "dropmalst": "NY",
    "dropmalzpp": 109599998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459863557,
    "dropsitcph": 8459863557,
    "dropfax": 8459863557
  },
  {
    "dcode": "D",
    "dropkey": "PV14956",
    "droptype": "D",
    "dropname": "NEW PALTZ",
    "dropdeladd": "41 MAIN ST",
    "dropdelcty": "NEW PALTZ",
    "dropdelst": "NY",
    "dropdelzpp": 125619998,
    "dropphyadd": "41 MAIN ST",
    "dropphycty": "NEW PALTZ",
    "dropphyst": "NY",
    "dropphyzpp": 125619998,
    "dropmaladd": "41 MAIN ST",
    "dropmalcty": "NEW PALTZ",
    "dropmalst": "NY",
    "dropmalzpp": 125619998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452555479,
    "dropsitcph": 8452555479,
    "dropfax": 8452554524
  },
  {
    "dcode": "D",
    "dropkey": "PV14957",
    "droptype": "D",
    "dropname": "NEW ROCHELLE",
    "dropdeladd": "255 NORTH AVE",
    "dropdelcty": "NEW ROCHELLE",
    "dropdelst": "NY",
    "dropdelzpp": 108016457,
    "dropphyadd": "255 NORTH AVE",
    "dropphycty": "NEW ROCHELLE",
    "dropphyst": "NY",
    "dropphyzpp": 108016457,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ROCHELLE",
    "dropmalst": "NY",
    "dropmalzpp": 108029998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146326669,
    "dropsitcph": 9146326669,
    "dropfax": 9146320491
  },
  {
    "dcode": "D",
    "dropkey": "PV14958",
    "droptype": "D",
    "dropname": "NEW RUSSIA",
    "dropdeladd": "6690 US ROUTE 9 STE 1",
    "dropdelcty": "NEW RUSSIA",
    "dropdelst": "NY",
    "dropdelzpp": 129649998,
    "dropphyadd": "6690 US ROUTE 9 STE 1",
    "dropphycty": "NEW RUSSIA",
    "dropphyst": "NY",
    "dropphyzpp": 129649998,
    "dropmaladd": "6690 US ROUTE 9 STE 1",
    "dropmalcty": "NEW RUSSIA",
    "dropmalst": "NY",
    "dropmalzpp": 129649998,
    "dropsitphn": 5188732143,
    "dropsitlph": 5188732143,
    "dropsitcph": 5188732143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14961",
    "droptype": "D",
    "dropname": "NEW SUFFOLK",
    "dropdeladd": "375 1ST ST",
    "dropdelcty": "NEW SUFFOLK",
    "dropdelst": "NY",
    "dropdelzpp": 119569700,
    "dropphyadd": "375 1ST ST",
    "dropphycty": "NEW SUFFOLK",
    "dropphyst": "NY",
    "dropphyzpp": 119569700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW SUFFOLK",
    "dropmalst": "NY",
    "dropmalzpp": 119569998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317346271,
    "dropfax": 6317342878
  },
  {
    "dcode": "D",
    "dropkey": "PV14964",
    "droptype": "D",
    "dropname": "NEW WOODSTOCK",
    "dropdeladd": "2607 SCHOOL ST",
    "dropdelcty": "NEW WOODSTOCK",
    "dropdelst": "NY",
    "dropdelzpp": 131229998,
    "dropphyadd": "2607 SCHOOL ST",
    "dropphycty": "NEW WOODSTOCK",
    "dropphyst": "NY",
    "dropphyzpp": 131229998,
    "dropmaladd": "2607 SCHOOL ST",
    "dropmalcty": "NEW WOODSTOCK",
    "dropmalst": "NY",
    "dropmalzpp": 131229998,
    "dropsitphn": 3156627429,
    "dropsitlph": 3156627429,
    "dropsitcph": 3156627429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14966",
    "droptype": "D",
    "dropname": "NEW YORK",
    "dropdeladd": "421 8TH AVE STE E3160",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 101999998,
    "dropphyadd": "421 8TH AVE STE E3160",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 101999998,
    "dropmaladd": "421 8TH AVE STE E3160",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 101999998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2123303668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14970",
    "droptype": "D",
    "dropname": "NEW YORK MILLS",
    "dropdeladd": "310 MAIN ST",
    "dropdelcty": "NEW YORK MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 134179998,
    "dropphyadd": "310 MAIN ST",
    "dropphycty": "NEW YORK MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 134179998,
    "dropmaladd": "310 MAIN ST",
    "dropmalcty": "NEW YORK MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 134179998,
    "dropsitphn": 3157369510,
    "dropsitlph": 3157369510,
    "dropsitcph": 3157369510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14974",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "300 S MAIN ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "NY",
    "dropdelzpp": 145139998,
    "dropphyadd": "300 S MAIN ST",
    "dropphycty": "NEWARK",
    "dropphyst": "NY",
    "dropphyzpp": 145139998,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "NEWARK",
    "dropmalst": "NY",
    "dropmalzpp": 145139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3153314790,
    "dropsitcph": 3153314790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14975",
    "droptype": "D",
    "dropname": "NEWARK VALLEY",
    "dropdeladd": "9 PARK ST",
    "dropdelcty": "NEWARK VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 138119998,
    "dropphyadd": "9 PARK ST",
    "dropphycty": "NEWARK VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 138119998,
    "dropmaladd": "9 PARK ST",
    "dropmalcty": "NEWARK VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 138119998,
    "dropsitphn": 6076423611,
    "dropsitlph": 6076423611,
    "dropsitcph": 6076423611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14978",
    "droptype": "D",
    "dropname": "NEWBURGH",
    "dropdeladd": "217 LIBERTY ST",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 125509998,
    "dropphyadd": "217 LIBERTY ST",
    "dropphycty": "NEWBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 125509998,
    "dropmaladd": "217 LIBERTY ST",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 125509998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455615982,
    "dropsitcph": 8455615982,
    "dropfax": 8455691070
  },
  {
    "dcode": "D",
    "dropkey": "PV14979",
    "droptype": "D",
    "dropname": "NEWCOMB",
    "dropdeladd": "28 BISSELL LOOP",
    "dropdelcty": "NEWCOMB",
    "dropdelst": "NY",
    "dropdelzpp": 128529998,
    "dropphyadd": "28 BISSELL LOOP",
    "dropphycty": "NEWCOMB",
    "dropphyst": "NY",
    "dropphyzpp": 128529998,
    "dropmaladd": "28 BISSELL LOOP",
    "dropmalcty": "NEWCOMB",
    "dropmalst": "NY",
    "dropmalzpp": 128529998,
    "dropsitphn": 5185824242,
    "dropsitlph": 5185824242,
    "dropsitcph": 5185824242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14980",
    "droptype": "D",
    "dropname": "NEWFANE",
    "dropdeladd": "6000 EDWARD AVE",
    "dropdelcty": "NEWFANE",
    "dropdelst": "NY",
    "dropdelzpp": 141089998,
    "dropphyadd": "6000 EDWARD AVE",
    "dropphycty": "NEWFANE",
    "dropphyst": "NY",
    "dropphyzpp": 141089998,
    "dropmaladd": "6000 EDWARD AVE",
    "dropmalcty": "NEWFANE",
    "dropmalst": "NY",
    "dropmalzpp": 141089998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167788111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14981",
    "droptype": "D",
    "dropname": "NEWFIELD",
    "dropdeladd": "298 MAIN ST",
    "dropdelcty": "NEWFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 148679998,
    "dropphyadd": "298 MAIN ST",
    "dropphycty": "NEWFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 148679998,
    "dropmaladd": "298 MAIN ST",
    "dropmalcty": "NEWFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 148679998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075643421,
    "dropsitcph": 6075643421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14983",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "3087 BRIDGE ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "NY",
    "dropdelzpp": 134169998,
    "dropphyadd": "3087 BRIDGE ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "NY",
    "dropphyzpp": 134169998,
    "dropmaladd": "3087 BRIDGE ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "NY",
    "dropmalzpp": 134169998,
    "dropsitphn": 3158458593,
    "dropsitlph": 3158458593,
    "dropsitcph": 3158458593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14985",
    "droptype": "D",
    "dropname": "NEWTON FALLS",
    "dropdeladd": "926 COUNTY ROUTE 60",
    "dropdelcty": "NEWTON FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 136669998,
    "dropphyadd": "926 COUNTY ROUTE 60",
    "dropphycty": "NEWTON FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 136669998,
    "dropmaladd": "926 COUNTY ROUTE 60",
    "dropmalcty": "NEWTON FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 136669998,
    "dropsitphn": 3158482164,
    "dropsitlph": 3158482164,
    "dropsitcph": 3158482164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV14994",
    "droptype": "D",
    "dropname": "NIAGARA FALLS",
    "dropdeladd": "615 MAIN ST STE 1",
    "dropdelcty": "NIAGARA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 143019998,
    "dropphyadd": "615 MAIN ST STE 1",
    "dropphycty": "NIAGARA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 143019998,
    "dropmaladd": "615 MAIN ST STE 1",
    "dropmalcty": "NIAGARA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 143019998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7165131061,
    "dropsitcph": 7165131061,
    "dropfax": 7162858525
  },
  {
    "dcode": "D",
    "dropkey": "PV15000",
    "droptype": "D",
    "dropname": "NIAGARA UNIVERSITY",
    "dropdeladd": "11 VINCENTIAN DR",
    "dropdelcty": "NIAGARA UNIVERSITY",
    "dropdelst": "NY",
    "dropdelzpp": 141099810,
    "dropphyadd": "11 VINCENTIAN DR",
    "dropphycty": "NIAGARA UNIVERSITY",
    "dropphyst": "NY",
    "dropphyzpp": 141099810,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIAGARA UNIVERSITY",
    "dropmalst": "NY",
    "dropmalzpp": 141099998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162852655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15001",
    "droptype": "D",
    "dropname": "NICHOLS",
    "dropdeladd": "491 W RIVER RD",
    "dropdelcty": "NICHOLS",
    "dropdelst": "NY",
    "dropdelzpp": 138129998,
    "dropphyadd": "491 W RIVER RD",
    "dropphycty": "NICHOLS",
    "dropphyst": "NY",
    "dropphyzpp": 138129998,
    "dropmaladd": "491 W RIVER RD",
    "dropmalcty": "NICHOLS",
    "dropmalst": "NY",
    "dropmalzpp": 138129998,
    "dropsitphn": 6076997937,
    "dropsitlph": 6076997937,
    "dropsitcph": 6076997937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15002",
    "droptype": "D",
    "dropname": "NICHOLVILLE",
    "dropdeladd": "6 PORT KENT RD",
    "dropdelcty": "NICHOLVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129659998,
    "dropphyadd": "6 PORT KENT RD",
    "dropphycty": "NICHOLVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129659998,
    "dropmaladd": "6 PORT KENT RD",
    "dropmalcty": "NICHOLVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129659998,
    "dropsitphn": 3153284000,
    "dropsitlph": 3153284000,
    "dropsitcph": 3153284000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15005",
    "droptype": "D",
    "dropname": "NINEVEH",
    "dropdeladd": "3033 STATE ROUTE 7",
    "dropdelcty": "NINEVEH",
    "dropdelst": "NY",
    "dropdelzpp": 138139998,
    "dropphyadd": "3033 STATE ROUTE 7",
    "dropphycty": "NINEVEH",
    "dropphyst": "NY",
    "dropphyzpp": 138139998,
    "dropmaladd": "3033 STATE ROUTE 7",
    "dropmalcty": "NINEVEH",
    "dropmalst": "NY",
    "dropmalzpp": 138139998,
    "dropsitphn": 6076931404,
    "dropsitlph": 6076931404,
    "dropsitcph": 6076931404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15007",
    "droptype": "D",
    "dropname": "NIOBE",
    "dropdeladd": "5967 PANAMA NIOBE RD",
    "dropdelcty": "NIOBE",
    "dropdelst": "NY",
    "dropdelzpp": 147589800,
    "dropphyadd": "5967 PANAMA NIOBE RD",
    "dropphycty": "NIOBE",
    "dropphyst": "NY",
    "dropphyzpp": 147589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIOBE",
    "dropmalst": "NY",
    "dropmalzpp": 147589998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167822685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15010",
    "droptype": "D",
    "dropname": "NIVERVILLE",
    "dropdeladd": "845 MAIN ST",
    "dropdelcty": "NIVERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121309998,
    "dropphyadd": "845 MAIN ST",
    "dropphycty": "NIVERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121309998,
    "dropmaladd": "845 MAIN ST",
    "dropmalcty": "NIVERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121309998,
    "dropsitphn": 5187843812,
    "dropsitlph": 5187843812,
    "dropsitcph": 5187843812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15022",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "2 E HIGH ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "NY",
    "dropdelzpp": 136679998,
    "dropphyadd": "2 E HIGH ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "NY",
    "dropphyzpp": 136679998,
    "dropmaladd": "2 E HIGH ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "NY",
    "dropmalzpp": 136679998,
    "dropsitphn": 3153841220,
    "dropsitlph": 3153841220,
    "dropsitcph": 3153841220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15031",
    "droptype": "D",
    "dropname": "NORTH BANGOR",
    "dropdeladd": "2449 STATE ROUTE 11",
    "dropdelcty": "NORTH BANGOR",
    "dropdelst": "NY",
    "dropdelzpp": 129669998,
    "dropphyadd": "2449 STATE ROUTE 11",
    "dropphycty": "NORTH BANGOR",
    "dropphyst": "NY",
    "dropphyzpp": 129669998,
    "dropmaladd": "2449 STATE ROUTE 11",
    "dropmalcty": "NORTH BANGOR",
    "dropmalst": "NY",
    "dropmalzpp": 129669998,
    "dropsitphn": 5184832129,
    "dropsitlph": 5184832129,
    "dropsitcph": 5184832129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15032",
    "droptype": "D",
    "dropname": "NORTH BAY",
    "dropdeladd": "2079 STATE ROUTE 49",
    "dropdelcty": "NORTH BAY",
    "dropdelst": "NY",
    "dropdelzpp": 131239998,
    "dropphyadd": "2079 STATE ROUTE 49",
    "dropphycty": "NORTH BAY",
    "dropphyst": "NY",
    "dropphyzpp": 131239998,
    "dropmaladd": "2079 STATE ROUTE 49",
    "dropmalcty": "NORTH BAY",
    "dropmalst": "NY",
    "dropmalzpp": 131239998,
    "dropsitphn": 3152450870,
    "dropsitlph": 3152450870,
    "dropsitcph": 3152450870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15038",
    "droptype": "D",
    "dropname": "NORTH BLENHEIM",
    "dropdeladd": "1748 STATE ROUTE 30",
    "dropdelcty": "NORTH BLENHEIM",
    "dropdelst": "NY",
    "dropdelzpp": 121319998,
    "dropphyadd": "1748 STATE ROUTE 30",
    "dropphycty": "NORTH BLENHEIM",
    "dropphyst": "NY",
    "dropphyzpp": 121319998,
    "dropmaladd": "1748 STATE ROUTE 30",
    "dropmalcty": "NORTH BLENHEIM",
    "dropmalst": "NY",
    "dropmalzpp": 121319998,
    "dropsitphn": 5188274924,
    "dropsitlph": 5188274924,
    "dropsitcph": 5188274924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15039",
    "droptype": "D",
    "dropname": "NORTH BOSTON",
    "dropdeladd": "7170 BOSTON STATE RD",
    "dropdelcty": "NORTH BOSTON",
    "dropdelst": "NY",
    "dropdelzpp": 141109800,
    "dropphyadd": "7170 BOSTON STATE RD",
    "dropphycty": "NORTH BOSTON",
    "dropphyst": "NY",
    "dropphyzpp": 141109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BOSTON",
    "dropmalst": "NY",
    "dropmalzpp": 141109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166496220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15040",
    "droptype": "D",
    "dropname": "NORTH BRANCH",
    "dropdeladd": "60 N BRANCH CALLICOON CTR RD STE 2",
    "dropdelcty": "NORTH BRANCH",
    "dropdelst": "NY",
    "dropdelzpp": 127669997,
    "dropphyadd": "60 N BRANCH CALLICOON CTR RD STE 2",
    "dropphycty": "NORTH BRANCH",
    "dropphyst": "NY",
    "dropphyzpp": 127669997,
    "dropmaladd": "60 N BRANCH CALLICOON CTR RD STE 2",
    "dropmalcty": "NORTH BRANCH",
    "dropmalst": "NY",
    "dropmalzpp": 127669997,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454823910,
    "dropsitcph": 8454823910,
    "dropfax": 8454823910
  },
  {
    "dcode": "D",
    "dropkey": "PV15045",
    "droptype": "D",
    "dropname": "NORTH CHATHAM",
    "dropdeladd": "4241 ROUTE 203",
    "dropdelcty": "NORTH CHATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 121329998,
    "dropphyadd": "4241 ROUTE 203",
    "dropphycty": "NORTH CHATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 121329998,
    "dropmaladd": "4241 ROUTE 203",
    "dropmalcty": "NORTH CHATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 121329998,
    "dropsitphn": 5187662626,
    "dropsitlph": 5187662626,
    "dropsitcph": 5187662626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15046",
    "droptype": "D",
    "dropname": "NORTH CHILI",
    "dropdeladd": "3235 UNION ST",
    "dropdelcty": "NORTH CHILI",
    "dropdelst": "NY",
    "dropdelzpp": 145149998,
    "dropphyadd": "3235 UNION ST",
    "dropphycty": "NORTH CHILI",
    "dropphyst": "NY",
    "dropphyzpp": 145149998,
    "dropmaladd": "3235 UNION ST",
    "dropmalcty": "NORTH CHILI",
    "dropmalst": "NY",
    "dropmalzpp": 145149998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855942933,
    "dropsitcph": 5855942933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15050",
    "droptype": "D",
    "dropname": "NORTH COLLINS",
    "dropdeladd": "10607 MAIN ST",
    "dropdelcty": "NORTH COLLINS",
    "dropdelst": "NY",
    "dropdelzpp": 141119998,
    "dropphyadd": "10607 MAIN ST",
    "dropphycty": "NORTH COLLINS",
    "dropphyst": "NY",
    "dropphyzpp": 141119998,
    "dropmaladd": "10607 MAIN ST",
    "dropmalcty": "NORTH COLLINS",
    "dropmalst": "NY",
    "dropmalzpp": 141119998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163373014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15052",
    "droptype": "D",
    "dropname": "NORTH CREEK",
    "dropdeladd": "26 CIRCLE AVE",
    "dropdelcty": "NORTH CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 128539998,
    "dropphyadd": "26 CIRCLE AVE",
    "dropphycty": "NORTH CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 128539998,
    "dropmaladd": "26 CIRCLE AVE",
    "dropmalcty": "NORTH CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 128539998,
    "dropsitphn": 5182512121,
    "dropsitlph": 5182512121,
    "dropsitcph": 5182512121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15055",
    "droptype": "D",
    "dropname": "NORTH EVANS",
    "dropdeladd": "6971 VERSAILLES RD",
    "dropdelcty": "NORTH EVANS",
    "dropdelst": "NY",
    "dropdelzpp": 141129800,
    "dropphyadd": "6971 VERSAILLES RD",
    "dropphycty": "NORTH EVANS",
    "dropphyst": "NY",
    "dropphyzpp": 141129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH EVANS",
    "dropmalst": "NY",
    "dropmalzpp": 141129998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166277715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15061",
    "droptype": "D",
    "dropname": "NORTH GRANVILLE",
    "dropdeladd": "10217 STATE ROUTE 22",
    "dropdelcty": "NORTH GRANVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128549998,
    "dropphyadd": "10217 STATE ROUTE 22",
    "dropphycty": "NORTH GRANVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128549998,
    "dropmaladd": "10217 STATE ROUTE 22",
    "dropmalcty": "NORTH GRANVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128549998,
    "dropsitphn": 5186421441,
    "dropsitlph": 5186421441,
    "dropsitcph": 5186421441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15063",
    "droptype": "D",
    "dropname": "NORTH GREECE",
    "dropdeladd": "640 N GREECE RD",
    "dropdelcty": "NORTH GREECE",
    "dropdelst": "NY",
    "dropdelzpp": 145159800,
    "dropphyadd": "640 N GREECE RD",
    "dropphycty": "NORTH GREECE",
    "dropphyst": "NY",
    "dropphyzpp": 145159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH GREECE",
    "dropmalst": "NY",
    "dropmalzpp": 145159998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853926111,
    "dropsitcph": 5853926111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15074",
    "droptype": "D",
    "dropname": "NORTH HOOSICK",
    "dropdeladd": "22157 STATE ROUTE 22",
    "dropdelcty": "NORTH HOOSICK",
    "dropdelst": "NY",
    "dropdelzpp": 121339998,
    "dropphyadd": "22157 STATE ROUTE 22",
    "dropphycty": "NORTH HOOSICK",
    "dropphyst": "NY",
    "dropphyzpp": 121339998,
    "dropmaladd": "22157 STATE ROUTE 22",
    "dropmalcty": "NORTH HOOSICK",
    "dropmalst": "NY",
    "dropmalzpp": 121339998,
    "dropsitphn": 5186867711,
    "dropsitlph": 5186867711,
    "dropsitcph": 5186867711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15075",
    "droptype": "D",
    "dropname": "NORTH HUDSON",
    "dropdeladd": "2940 US ROUTE 9",
    "dropdelcty": "NORTH HUDSON",
    "dropdelst": "NY",
    "dropdelzpp": 128559998,
    "dropphyadd": "2940 US ROUTE 9",
    "dropphycty": "NORTH HUDSON",
    "dropphyst": "NY",
    "dropphyzpp": 128559998,
    "dropmaladd": "2940 US ROUTE 9",
    "dropmalcty": "NORTH HUDSON",
    "dropmalst": "NY",
    "dropmalzpp": 128559998,
    "dropsitphn": 5185329355,
    "dropsitlph": 5185329355,
    "dropsitcph": 5185329355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15077",
    "droptype": "D",
    "dropname": "NORTH JAVA",
    "dropdeladd": "2143 WETHERSFIELD RD",
    "dropdelcty": "NORTH JAVA",
    "dropdelst": "NY",
    "dropdelzpp": 141139998,
    "dropphyadd": "2143 WETHERSFIELD RD",
    "dropphycty": "NORTH JAVA",
    "dropphyst": "NY",
    "dropphyzpp": 141139998,
    "dropmaladd": "2143 WETHERSFIELD RD",
    "dropmalcty": "NORTH JAVA",
    "dropmalst": "NY",
    "dropmalzpp": 141139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855357150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15080",
    "droptype": "D",
    "dropname": "NORTH LAWRENCE",
    "dropdeladd": "1971 STATE HIGHWAY 11C",
    "dropdelcty": "NORTH LAWRENCE",
    "dropdelst": "NY",
    "dropdelzpp": 129679998,
    "dropphyadd": "1971 STATE HIGHWAY 11C",
    "dropphycty": "NORTH LAWRENCE",
    "dropphyst": "NY",
    "dropphyzpp": 129679998,
    "dropmaladd": "1971 STATE HIGHWAY 11C",
    "dropmalcty": "NORTH LAWRENCE",
    "dropmalst": "NY",
    "dropmalzpp": 129679998,
    "dropsitphn": 5183894477,
    "dropsitlph": 5183894477,
    "dropsitcph": 3153894477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15086",
    "droptype": "D",
    "dropname": "NORTH NORWICH",
    "dropdeladd": "168 COUNTY ROAD 23",
    "dropdelcty": "NORTH NORWICH",
    "dropdelst": "NY",
    "dropdelzpp": 138149998,
    "dropphyadd": "168 COUNTY ROAD 23",
    "dropphycty": "NORTH NORWICH",
    "dropphyst": "NY",
    "dropphyzpp": 138149998,
    "dropmaladd": "168 COUNTY ROAD 23",
    "dropmalcty": "NORTH NORWICH",
    "dropmalst": "NY",
    "dropmalzpp": 138149998,
    "dropsitphn": 6073343401,
    "dropsitlph": 6073343401,
    "dropsitcph": 6073343401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15092",
    "droptype": "D",
    "dropname": "NORTH PITCHER",
    "dropdeladd": "1027 STATE HIGHWAY 26",
    "dropdelcty": "NORTH PITCHER",
    "dropdelst": "NY",
    "dropdelzpp": 131249998,
    "dropphyadd": "1027 STATE HIGHWAY 26",
    "dropphycty": "NORTH PITCHER",
    "dropphyst": "NY",
    "dropphyzpp": 131249998,
    "dropmaladd": "1027 STATE HIGHWAY 26",
    "dropmalcty": "NORTH PITCHER",
    "dropmalst": "NY",
    "dropmalzpp": 131249998,
    "dropsitphn": 3154523575,
    "dropsitlph": 3154523575,
    "dropsitcph": 3156537812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15094",
    "droptype": "D",
    "dropname": "NORTH RIVER",
    "dropdeladd": "4631 STATE ROUTE 28",
    "dropdelcty": "NORTH RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 128569998,
    "dropphyadd": "4631 STATE ROUTE 28",
    "dropphycty": "NORTH RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 128569998,
    "dropmaladd": "4631 STATE ROUTE 28",
    "dropmalcty": "NORTH RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 128569998,
    "dropsitphn": 5182513311,
    "dropsitlph": 5182513311,
    "dropsitcph": 5182513311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15095",
    "droptype": "D",
    "dropname": "NORTH ROSE",
    "dropdeladd": "10374 E RAILROAD AVE",
    "dropdelcty": "NORTH ROSE",
    "dropdelst": "NY",
    "dropdelzpp": 145169998,
    "dropphyadd": "10374 E RAILROAD AVE",
    "dropphycty": "NORTH ROSE",
    "dropphyst": "NY",
    "dropphyzpp": 145169998,
    "dropmaladd": "10374 E RAILROAD AVE",
    "dropmalcty": "NORTH ROSE",
    "dropmalst": "NY",
    "dropmalzpp": 145169998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155872282,
    "dropsitcph": 3155872282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15097",
    "droptype": "D",
    "dropname": "NORTH SALEM",
    "dropdeladd": "60 JUNE RD",
    "dropdelcty": "NORTH SALEM",
    "dropdelst": "NY",
    "dropdelzpp": 105609998,
    "dropphyadd": "60 JUNE RD",
    "dropphycty": "NORTH SALEM",
    "dropphyst": "NY",
    "dropphyzpp": 105609998,
    "dropmaladd": "60 JUNE RD",
    "dropmalcty": "NORTH SALEM",
    "dropmalst": "NY",
    "dropmalzpp": 105609998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146698471,
    "dropsitcph": 9146698471,
    "dropfax": 9142761345
  },
  {
    "dcode": "D",
    "dropkey": "PV15108",
    "droptype": "D",
    "dropname": "NORTH TONAWANDA",
    "dropdeladd": "141 GOUNDRY ST",
    "dropdelcty": "NORTH TONAWANDA",
    "dropdelst": "NY",
    "dropdelzpp": 141209998,
    "dropphyadd": "141 GOUNDRY ST",
    "dropphycty": "NORTH TONAWANDA",
    "dropphyst": "NY",
    "dropphyzpp": 141209998,
    "dropmaladd": "141 GOUNDRY ST",
    "dropmalcty": "NORTH TONAWANDA",
    "dropmalst": "NY",
    "dropmalzpp": 141209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167996801,
    "dropfax": 7166927189
  },
  {
    "dcode": "D",
    "dropkey": "PV15124",
    "droptype": "D",
    "dropname": "NORTHPORT",
    "dropdeladd": "240 MAIN ST",
    "dropdelcty": "NORTHPORT",
    "dropdelst": "NY",
    "dropdelzpp": 117681870,
    "dropphyadd": "240 MAIN ST",
    "dropphycty": "NORTHPORT",
    "dropphyst": "NY",
    "dropphyzpp": 117681870,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTHPORT",
    "dropmalst": "NY",
    "dropmalzpp": 117689998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312616941,
    "dropfax": 6317577671
  },
  {
    "dcode": "D",
    "dropkey": "PV15129",
    "droptype": "D",
    "dropname": "NORTHVILLE",
    "dropdeladd": "151 N MAIN ST",
    "dropdelcty": "NORTHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121349998,
    "dropphyadd": "151 N MAIN ST",
    "dropphycty": "NORTHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121349998,
    "dropmaladd": "151 N MAIN ST",
    "dropmalcty": "NORTHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121349998,
    "dropsitphn": 5188634944,
    "dropsitlph": 5188634944,
    "dropsitcph": 5188634944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15133",
    "droptype": "D",
    "dropname": "NORWICH",
    "dropdeladd": "20-22 E MAIN ST",
    "dropdelcty": "NORWICH",
    "dropdelst": "NY",
    "dropdelzpp": 138159998,
    "dropphyadd": "20-22 E MAIN ST",
    "dropphycty": "NORWICH",
    "dropphyst": "NY",
    "dropphyzpp": 138159998,
    "dropmaladd": "20-22 E MAIN ST",
    "dropmalcty": "NORWICH",
    "dropmalst": "NY",
    "dropmalzpp": 138159998,
    "dropsitphn": 6073344134,
    "dropsitlph": 6073344134,
    "dropsitcph": 6073344134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15134",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "34 S MAIN ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 136689998,
    "dropphyadd": "34 S MAIN ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 136689998,
    "dropmaladd": "34 S MAIN ST",
    "dropmalcty": "NORWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 136689998,
    "dropsitphn": 3153532515,
    "dropsitlph": 3153532515,
    "dropsitcph": 3153532515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15137",
    "droptype": "D",
    "dropname": "NUNDA",
    "dropdeladd": "17 S STATE ST",
    "dropdelcty": "NUNDA",
    "dropdelst": "NY",
    "dropdelzpp": 145179998,
    "dropphyadd": "17 S STATE ST",
    "dropphycty": "NUNDA",
    "dropphyst": "NY",
    "dropphyzpp": 145179998,
    "dropmaladd": "17 S STATE ST",
    "dropmalcty": "NUNDA",
    "dropmalst": "NY",
    "dropmalzpp": 145179998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854683830,
    "dropsitcph": 5854683830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15153",
    "droptype": "D",
    "dropname": "NYACK",
    "dropdeladd": "48 S BROADWAY",
    "dropdelcty": "NYACK",
    "dropdelst": "NY",
    "dropdelzpp": 109609998,
    "dropphyadd": "48 S BROADWAY",
    "dropphycty": "NYACK",
    "dropphyst": "NY",
    "dropphyzpp": 109609998,
    "dropmaladd": "48 S BROADWAY",
    "dropmalcty": "NYACK",
    "dropmalst": "NY",
    "dropmalzpp": 109609998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453582756,
    "dropsitcph": 8453582756,
    "dropfax": 8453536495
  },
  {
    "dcode": "D",
    "dropkey": "PV15159",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "111 OAK HILL RD",
    "dropdelcty": "OAK HILL",
    "dropdelst": "NY",
    "dropdelzpp": 124609998,
    "dropphyadd": "111 OAK HILL RD",
    "dropphycty": "OAK HILL",
    "dropphyst": "NY",
    "dropphyzpp": 124609998,
    "dropmaladd": "111 OAK HILL RD",
    "dropmalcty": "OAK HILL",
    "dropmalst": "NY",
    "dropmalzpp": 124609998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5182394841,
    "dropsitcph": 5182394841,
    "dropfax": 5182398201
  },
  {
    "dcode": "D",
    "dropkey": "PV15168",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "927 MONTAUK HWY",
    "dropdelcty": "OAKDALE",
    "dropdelst": "NY",
    "dropdelzpp": 117691718,
    "dropphyadd": "927 MONTAUK HWY",
    "dropphycty": "OAKDALE",
    "dropphyst": "NY",
    "dropphyzpp": 117691718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKDALE",
    "dropmalst": "NY",
    "dropmalzpp": 117699998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315892683,
    "dropfax": 6315632799
  },
  {
    "dcode": "D",
    "dropkey": "PV15169",
    "droptype": "D",
    "dropname": "OAKFIELD",
    "dropdeladd": "28 MAIN ST",
    "dropdelcty": "OAKFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 141259998,
    "dropphyadd": "28 MAIN ST",
    "dropphycty": "OAKFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 141259998,
    "dropmaladd": "28 MAIN ST",
    "dropmalcty": "OAKFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 141259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859489410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15174",
    "droptype": "D",
    "dropname": "OAKS CORNERS",
    "dropdeladd": "2091 PRE EMPTION RD",
    "dropdelcty": "OAKS CORNERS",
    "dropdelst": "NY",
    "dropdelzpp": 145189800,
    "dropphyadd": "2091 PRE EMPTION RD",
    "dropphycty": "OAKS CORNERS",
    "dropphyst": "NY",
    "dropphyzpp": 145189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKS CORNERS",
    "dropmalst": "NY",
    "dropmalzpp": 145189998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3157897755,
    "dropsitcph": 3157897755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15176",
    "droptype": "D",
    "dropname": "OBERNBURG",
    "dropdeladd": "361 COUNTY ROAD 95",
    "dropdelcty": "OBERNBURG",
    "dropdelst": "NY",
    "dropdelzpp": 127679800,
    "dropphyadd": "361 COUNTY ROAD 95",
    "dropphycty": "OBERNBURG",
    "dropphyst": "NY",
    "dropphyzpp": 127679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OBERNBURG",
    "dropmalst": "NY",
    "dropmalzpp": 127679998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454825599,
    "dropsitcph": 8454825599,
    "dropfax": 8454825599
  },
  {
    "dcode": "D",
    "dropkey": "PV15180",
    "droptype": "D",
    "dropname": "OCEAN BEACH",
    "dropdeladd": "315 COTTAGE WALK",
    "dropdelcty": "OCEAN BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 117709700,
    "dropphyadd": "315 COTTAGE WALK",
    "dropphycty": "OCEAN BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 117709700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCEAN BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 117709998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315837368,
    "dropfax": 6315839002
  },
  {
    "dcode": "D",
    "dropkey": "PV15183",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "223 W MAIN ST",
    "dropdelcty": "ODESSA",
    "dropdelst": "NY",
    "dropdelzpp": 148699998,
    "dropphyadd": "223 W MAIN ST",
    "dropphycty": "ODESSA",
    "dropphyst": "NY",
    "dropphyzpp": 148699998,
    "dropmaladd": "223 W MAIN ST",
    "dropmalcty": "ODESSA",
    "dropmalst": "NY",
    "dropmalzpp": 148699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075942177,
    "dropsitcph": 6075942177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15187",
    "droptype": "D",
    "dropname": "OGDENSBURG",
    "dropdeladd": "431 STATE ST",
    "dropdelcty": "OGDENSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 136699998,
    "dropphyadd": "431 STATE ST",
    "dropphycty": "OGDENSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 136699998,
    "dropmaladd": "431 STATE ST",
    "dropmalcty": "OGDENSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 136699998,
    "dropsitphn": 3153935330,
    "dropsitlph": 3153935330,
    "dropsitcph": 3153935330,
    "dropfax": 3153936767
  },
  {
    "dcode": "D",
    "dropkey": "PV15189",
    "droptype": "D",
    "dropname": "OLCOTT",
    "dropdeladd": "1617 LOCKPORT OLCOTT RD",
    "dropdelcty": "OLCOTT",
    "dropdelst": "NY",
    "dropdelzpp": 141269800,
    "dropphyadd": "1617 LOCKPORT OLCOTT RD",
    "dropphycty": "OLCOTT",
    "dropphyst": "NY",
    "dropphyzpp": 141269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLCOTT",
    "dropmalst": "NY",
    "dropmalzpp": 141269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167788992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15195",
    "droptype": "D",
    "dropname": "OLD CHATHAM",
    "dropdeladd": "635 ALBANY TPKE",
    "dropdelcty": "OLD CHATHAM",
    "dropdelst": "NY",
    "dropdelzpp": 121369998,
    "dropphyadd": "635 ALBANY TPKE",
    "dropphycty": "OLD CHATHAM",
    "dropphyst": "NY",
    "dropphyzpp": 121369998,
    "dropmaladd": "635 ALBANY TPKE",
    "dropmalcty": "OLD CHATHAM",
    "dropmalst": "NY",
    "dropmalzpp": 121369998,
    "dropsitphn": 5187947176,
    "dropsitlph": 5187947176,
    "dropsitcph": 5187947176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15206",
    "droptype": "D",
    "dropname": "OLD FORGE",
    "dropdeladd": "2992 STATE ROUTE 28",
    "dropdelcty": "OLD FORGE",
    "dropdelst": "NY",
    "dropdelzpp": 134209998,
    "dropphyadd": "2992 STATE ROUTE 28",
    "dropphycty": "OLD FORGE",
    "dropphyst": "NY",
    "dropphyzpp": 134209998,
    "dropmaladd": "2992 STATE ROUTE 28",
    "dropmalcty": "OLD FORGE",
    "dropmalst": "NY",
    "dropmalzpp": 134209998,
    "dropsitphn": 3153693414,
    "dropsitlph": 3153693414,
    "dropsitcph": 3153693414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15211",
    "droptype": "D",
    "dropname": "OLEAN",
    "dropdeladd": "102 S UNION ST",
    "dropdelcty": "OLEAN",
    "dropdelst": "NY",
    "dropdelzpp": 147609998,
    "dropphyadd": "102 S UNION ST",
    "dropphycty": "OLEAN",
    "dropphyst": "NY",
    "dropphyzpp": 147609998,
    "dropmaladd": "102 S UNION ST",
    "dropmalcty": "OLEAN",
    "dropmalst": "NY",
    "dropmalzpp": 147609998,
    "dropsitphn": 7163721140,
    "dropsitlph": 7163721140,
    "dropsitcph": 7163725212,
    "dropfax": 7163725474
  },
  {
    "dcode": "D",
    "dropkey": "PV15213",
    "droptype": "D",
    "dropname": "OLIVEBRIDGE",
    "dropdeladd": "5147 STATE ROUTE 213 STE 1",
    "dropdelcty": "OLIVEBRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 124619998,
    "dropphyadd": "5147 STATE ROUTE 213 STE 1",
    "dropphycty": "OLIVEBRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 124619998,
    "dropmaladd": "5147 STATE ROUTE 213 STE 1",
    "dropmalcty": "OLIVEBRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 124619998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456577520,
    "dropsitcph": 8456577520,
    "dropfax": 8456579830
  },
  {
    "dcode": "D",
    "dropkey": "PV15215",
    "droptype": "D",
    "dropname": "OLMSTEDVILLE",
    "dropdeladd": "622 CHURCH RD",
    "dropdelcty": "OLMSTEDVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128579998,
    "dropphyadd": "622 CHURCH RD",
    "dropphycty": "OLMSTEDVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128579998,
    "dropmaladd": "622 CHURCH RD",
    "dropmalcty": "OLMSTEDVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128579998,
    "dropsitphn": 5182513192,
    "dropsitlph": 5182513192,
    "dropsitcph": 5182513192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15219",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "133 FARRIER AVE",
    "dropdelcty": "ONEIDA",
    "dropdelst": "NY",
    "dropdelzpp": 134219998,
    "dropphyadd": "133 FARRIER AVE",
    "dropphycty": "ONEIDA",
    "dropphyst": "NY",
    "dropphyzpp": 134219998,
    "dropmaladd": "133 FARRIER AVE",
    "dropmalcty": "ONEIDA",
    "dropmalst": "NY",
    "dropmalzpp": 134219998,
    "dropsitphn": 3153634218,
    "dropsitlph": 3153634218,
    "dropsitcph": 3153634210,
    "dropfax": 3153631210
  },
  {
    "dcode": "D",
    "dropkey": "PV15221",
    "droptype": "D",
    "dropname": "ONEONTA",
    "dropdeladd": "352 MAIN ST",
    "dropdelcty": "ONEONTA",
    "dropdelst": "NY",
    "dropdelzpp": 138209998,
    "dropphyadd": "352 MAIN ST",
    "dropphycty": "ONEONTA",
    "dropphyst": "NY",
    "dropphyzpp": 138209998,
    "dropmaladd": "352 MAIN ST",
    "dropmalcty": "ONEONTA",
    "dropmalst": "NY",
    "dropmalzpp": 138209998,
    "dropsitphn": 6074326100,
    "dropsitlph": 6074326100,
    "dropsitcph": 6074326100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15228",
    "droptype": "D",
    "dropname": "ONTARIO",
    "dropdeladd": "2001 FURGUSON ST",
    "dropdelcty": "ONTARIO",
    "dropdelst": "NY",
    "dropdelzpp": 145199998,
    "dropphyadd": "2001 FURGUSON ST",
    "dropphycty": "ONTARIO",
    "dropphyst": "NY",
    "dropphyzpp": 145199998,
    "dropmaladd": "2001 FURGUSON ST",
    "dropmalcty": "ONTARIO",
    "dropmalst": "NY",
    "dropmalzpp": 145199998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155248112,
    "dropsitcph": 3155248112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15229",
    "droptype": "D",
    "dropname": "ONTARIO CENTER",
    "dropdeladd": "1544 RIDGE RD",
    "dropdelcty": "ONTARIO CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 145209800,
    "dropphyadd": "1544 RIDGE RD",
    "dropphycty": "ONTARIO CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 145209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONTARIO CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 145209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155246801,
    "dropsitcph": 3155246801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15234",
    "droptype": "D",
    "dropname": "ORANGEBURG",
    "dropdeladd": "26 ORANGETOWN SHOPPING CTR",
    "dropdelcty": "ORANGEBURG",
    "dropdelst": "NY",
    "dropdelzpp": 109629998,
    "dropphyadd": "26 ORANGETOWN SHOPPING CTR",
    "dropphycty": "ORANGEBURG",
    "dropphyst": "NY",
    "dropphyzpp": 109629998,
    "dropmaladd": "26 ORANGETOWN SHOPPING CTR",
    "dropmalcty": "ORANGEBURG",
    "dropmalst": "NY",
    "dropmalzpp": 109629998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453593547,
    "dropsitcph": 8453593547,
    "dropfax": 8453982916
  },
  {
    "dcode": "D",
    "dropkey": "PV15235",
    "droptype": "D",
    "dropname": "ORCHARD PARK",
    "dropdeladd": "60 SCHOOL ST",
    "dropdelcty": "ORCHARD PARK",
    "dropdelst": "NY",
    "dropdelzpp": 141279998,
    "dropphyadd": "60 SCHOOL ST",
    "dropphycty": "ORCHARD PARK",
    "dropphyst": "NY",
    "dropphyzpp": 141279998,
    "dropmaladd": "60 SCHOOL ST",
    "dropmalcty": "ORCHARD PARK",
    "dropmalst": "NY",
    "dropmalzpp": 141279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166624110,
    "dropfax": 7166623547
  },
  {
    "dcode": "D",
    "dropkey": "PV15238",
    "droptype": "D",
    "dropname": "ORIENT",
    "dropdeladd": "980 VILLAGE LN",
    "dropdelcty": "ORIENT",
    "dropdelst": "NY",
    "dropdelzpp": 119571254,
    "dropphyadd": "980 VILLAGE LN",
    "dropphycty": "ORIENT",
    "dropphyst": "NY",
    "dropphyzpp": 119571254,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORIENT",
    "dropmalst": "NY",
    "dropmalzpp": 119579998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313239760,
    "dropfax": 6313233780
  },
  {
    "dcode": "D",
    "dropkey": "PV15242",
    "droptype": "D",
    "dropname": "ORISKANY",
    "dropdeladd": "101 PARK AVE",
    "dropdelcty": "ORISKANY",
    "dropdelst": "NY",
    "dropdelzpp": 134249998,
    "dropphyadd": "101 PARK AVE",
    "dropphycty": "ORISKANY",
    "dropphyst": "NY",
    "dropphyzpp": 134249998,
    "dropmaladd": "101 PARK AVE",
    "dropmalcty": "ORISKANY",
    "dropmalst": "NY",
    "dropmalzpp": 134249998,
    "dropsitphn": 3157366117,
    "dropsitlph": 3157366117,
    "dropsitcph": 3157366117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15243",
    "droptype": "D",
    "dropname": "ORISKANY FALLS",
    "dropdeladd": "216 MAIN ST",
    "dropdelcty": "ORISKANY FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 134259998,
    "dropphyadd": "216 MAIN ST",
    "dropphycty": "ORISKANY FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 134259998,
    "dropmaladd": "216 MAIN ST",
    "dropmalcty": "ORISKANY FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 134259998,
    "dropsitphn": 3158217925,
    "dropsitlph": 3158217925,
    "dropsitcph": 3158217925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15245",
    "droptype": "D",
    "dropname": "ORWELL",
    "dropdeladd": "2007 COUNTY ROUTE 2",
    "dropdelcty": "ORWELL",
    "dropdelst": "NY",
    "dropdelzpp": 134269998,
    "dropphyadd": "2007 COUNTY ROUTE 2",
    "dropphycty": "ORWELL",
    "dropphyst": "NY",
    "dropphyzpp": 134269998,
    "dropmaladd": "2007 COUNTY ROUTE 2",
    "dropmalcty": "ORWELL",
    "dropmalst": "NY",
    "dropmalzpp": 134269998,
    "dropsitphn": 3152982871,
    "dropsitlph": 3152982871,
    "dropsitcph": 3152982871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15249",
    "droptype": "D",
    "dropname": "OSSINING",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "OSSINING",
    "dropdelst": "NY",
    "dropdelzpp": 105629998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "OSSINING",
    "dropphyst": "NY",
    "dropphyzpp": 105629998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "OSSINING",
    "dropmalst": "NY",
    "dropmalzpp": 105629998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149417348,
    "dropsitcph": 9149417348,
    "dropfax": 9149448082
  },
  {
    "dcode": "D",
    "dropkey": "PV15252",
    "droptype": "D",
    "dropname": "OSWEGO",
    "dropdeladd": "391 W 1ST ST",
    "dropdelcty": "OSWEGO",
    "dropdelst": "NY",
    "dropdelzpp": 131269998,
    "dropphyadd": "391 W 1ST ST",
    "dropphycty": "OSWEGO",
    "dropphyst": "NY",
    "dropphyzpp": 131269998,
    "dropmaladd": "391 W 1ST ST",
    "dropmalcty": "OSWEGO",
    "dropmalst": "NY",
    "dropmalzpp": 131269998,
    "dropsitphn": 3153433881,
    "dropsitlph": 3153433881,
    "dropsitcph": 3153433881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15254",
    "droptype": "D",
    "dropname": "OTEGO",
    "dropdeladd": "7 RIVER ST",
    "dropdelcty": "OTEGO",
    "dropdelst": "NY",
    "dropdelzpp": 138259998,
    "dropphyadd": "7 RIVER ST",
    "dropphycty": "OTEGO",
    "dropphyst": "NY",
    "dropphyzpp": 138259998,
    "dropmaladd": "7 RIVER ST",
    "dropmalcty": "OTEGO",
    "dropmalst": "NY",
    "dropmalzpp": 138259998,
    "dropsitphn": 6079887724,
    "dropsitlph": 6079887724,
    "dropsitcph": 6079887724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15257",
    "droptype": "D",
    "dropname": "OTISVILLE",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "OTISVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109639998,
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "OTISVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109639998,
    "dropmaladd": "11 MAIN ST",
    "dropmalcty": "OTISVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109639998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453862935,
    "dropsitcph": 8453862935,
    "dropfax": 8453861722
  },
  {
    "dcode": "D",
    "dropkey": "PV15265",
    "droptype": "D",
    "dropname": "OTTO",
    "dropdeladd": "9120 OTTO EAST OTTO RD",
    "dropdelcty": "OTTO",
    "dropdelst": "NY",
    "dropdelzpp": 147669800,
    "dropphyadd": "9120 OTTO EAST OTTO RD",
    "dropphycty": "OTTO",
    "dropphyst": "NY",
    "dropphyzpp": 147669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTTO",
    "dropmalst": "NY",
    "dropmalzpp": 147669998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162579880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15267",
    "droptype": "D",
    "dropname": "OVID",
    "dropdeladd": "7161 MAIN ST",
    "dropdelcty": "OVID",
    "dropdelst": "NY",
    "dropdelzpp": 145219998,
    "dropphyadd": "7161 MAIN ST",
    "dropphycty": "OVID",
    "dropphyst": "NY",
    "dropphyzpp": 145219998,
    "dropmaladd": "7161 MAIN ST",
    "dropmalcty": "OVID",
    "dropmalst": "NY",
    "dropmalzpp": 145219998,
    "dropsitphn": 6078622001,
    "dropsitlph": 6078622001,
    "dropsitcph": 6078622001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15270",
    "droptype": "D",
    "dropname": "OWEGO",
    "dropdeladd": "6 LAKE ST",
    "dropdelcty": "OWEGO",
    "dropdelst": "NY",
    "dropdelzpp": 138279998,
    "dropphyadd": "6 LAKE ST",
    "dropphycty": "OWEGO",
    "dropphyst": "NY",
    "dropphyzpp": 138279998,
    "dropmaladd": "6 LAKE ST",
    "dropmalcty": "OWEGO",
    "dropmalst": "NY",
    "dropmalzpp": 138279998,
    "dropsitphn": 6076870661,
    "dropsitlph": 6076870661,
    "dropsitcph": 6076870661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15272",
    "droptype": "D",
    "dropname": "OWLS HEAD",
    "dropdeladd": "16 RAGGED LAKE RD",
    "dropdelcty": "OWLS HEAD",
    "dropdelst": "NY",
    "dropdelzpp": 129699998,
    "dropphyadd": "16 RAGGED LAKE RD",
    "dropphycty": "OWLS HEAD",
    "dropphyst": "NY",
    "dropphyzpp": 129699998,
    "dropmaladd": "16 RAGGED LAKE RD",
    "dropmalcty": "OWLS HEAD",
    "dropmalst": "NY",
    "dropmalzpp": 129699998,
    "dropsitphn": 5184836631,
    "dropsitlph": 5184836631,
    "dropsitcph": 5184836631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15275",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "2 S WASHINGTON AVE",
    "dropdelcty": "OXFORD",
    "dropdelst": "NY",
    "dropdelzpp": 138309998,
    "dropphyadd": "2 S WASHINGTON AVE",
    "dropphycty": "OXFORD",
    "dropphyst": "NY",
    "dropphyzpp": 138309998,
    "dropmaladd": "2 S WASHINGTON AVE",
    "dropmalcty": "OXFORD",
    "dropmalst": "NY",
    "dropmalzpp": 138309998,
    "dropsitphn": 6078432851,
    "dropsitlph": 6078432851,
    "dropsitcph": 6078432851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15277",
    "droptype": "D",
    "dropname": "OYSTER BAY",
    "dropdeladd": "1 SHORE AVE",
    "dropdelcty": "OYSTER BAY",
    "dropdelst": "NY",
    "dropdelzpp": 117711431,
    "dropphyadd": "1 SHORE AVE",
    "dropphycty": "OYSTER BAY",
    "dropphyst": "NY",
    "dropphyzpp": 117711431,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OYSTER BAY",
    "dropmalst": "NY",
    "dropmalzpp": 117719998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169228249,
    "dropfax": 5169223921
  },
  {
    "dcode": "D",
    "dropkey": "PV15286",
    "droptype": "D",
    "dropname": "PAINTED POST",
    "dropdeladd": "135 N HAMILTON ST",
    "dropdelcty": "PAINTED POST",
    "dropdelst": "NY",
    "dropdelzpp": 148709998,
    "dropphyadd": "135 N HAMILTON ST",
    "dropphycty": "PAINTED POST",
    "dropphyst": "NY",
    "dropphyzpp": 148709998,
    "dropmaladd": "135 N HAMILTON ST",
    "dropmalcty": "PAINTED POST",
    "dropmalst": "NY",
    "dropmalzpp": 148709998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6079366521,
    "dropsitcph": 6079366521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15289",
    "droptype": "D",
    "dropname": "PALATINE BRIDGE",
    "dropdeladd": "48 DUTCH TOWN PLZ",
    "dropdelcty": "PALATINE BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 134289800,
    "dropphyadd": "48 DUTCH TOWN PLZ",
    "dropphycty": "PALATINE BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 134289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALATINE BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 134289998,
    "dropsitphn": 5186732411,
    "dropsitlph": 5186732411,
    "dropsitcph": 5186732411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15290",
    "droptype": "D",
    "dropname": "PALENVILLE",
    "dropdeladd": "3378 ROUTE 23A",
    "dropdelcty": "PALENVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124639998,
    "dropphyadd": "3378 ROUTE 23A",
    "dropphycty": "PALENVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124639998,
    "dropmaladd": "3378 ROUTE 23A",
    "dropmalcty": "PALENVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124639998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186780588,
    "dropsitcph": 5186780588,
    "dropfax": 5186789229
  },
  {
    "dcode": "D",
    "dropkey": "PV15294",
    "droptype": "D",
    "dropname": "PALISADES",
    "dropdeladd": "705 OAK TREE RD",
    "dropdelcty": "PALISADES",
    "dropdelst": "NY",
    "dropdelzpp": 109649998,
    "dropphyadd": "705 OAK TREE RD",
    "dropphycty": "PALISADES",
    "dropphyst": "NY",
    "dropphyzpp": 109649998,
    "dropmaladd": "705 OAK TREE RD",
    "dropmalcty": "PALISADES",
    "dropmalst": "NY",
    "dropmalzpp": 109649998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453597841,
    "dropsitcph": 8453597841,
    "dropfax": 8453598334
  },
  {
    "dcode": "D",
    "dropkey": "PV15296",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "522 E MAIN ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "NY",
    "dropdelzpp": 145229998,
    "dropphyadd": "522 E MAIN ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "NY",
    "dropphyzpp": 145229998,
    "dropmaladd": "522 E MAIN ST",
    "dropmalcty": "PALMYRA",
    "dropmalst": "NY",
    "dropmalzpp": 145229998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155974151,
    "dropsitcph": 3155974151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15299",
    "droptype": "D",
    "dropname": "PANAMA",
    "dropdeladd": "6 E MAIN ST",
    "dropdelcty": "PANAMA",
    "dropdelst": "NY",
    "dropdelzpp": 147679998,
    "dropphyadd": "6 E MAIN ST",
    "dropphycty": "PANAMA",
    "dropphyst": "NY",
    "dropphyzpp": 147679998,
    "dropmaladd": "6 E MAIN ST",
    "dropmalcty": "PANAMA",
    "dropmalst": "NY",
    "dropmalzpp": 147679998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167822864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15307",
    "droptype": "D",
    "dropname": "PARISH",
    "dropdeladd": "2963 E MAIN ST",
    "dropdelcty": "PARISH",
    "dropdelst": "NY",
    "dropdelzpp": 131319998,
    "dropphyadd": "2963 E MAIN ST",
    "dropphycty": "PARISH",
    "dropphyst": "NY",
    "dropphyzpp": 131319998,
    "dropmaladd": "2963 E MAIN ST",
    "dropmalcty": "PARISH",
    "dropmalst": "NY",
    "dropmalzpp": 131319998,
    "dropsitphn": 3156257511,
    "dropsitlph": 3156257511,
    "dropsitcph": 3156257511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15308",
    "droptype": "D",
    "dropname": "PARISHVILLE",
    "dropdeladd": "1763 STATE HIGHWAY 72",
    "dropdelcty": "PARISHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136729998,
    "dropphyadd": "1763 STATE HIGHWAY 72",
    "dropphycty": "PARISHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136729998,
    "dropmaladd": "1763 STATE HIGHWAY 72",
    "dropmalcty": "PARISHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136729998,
    "dropsitphn": 3152652656,
    "dropsitlph": 3152652656,
    "dropsitcph": 3152652656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15320",
    "droptype": "D",
    "dropname": "PARKSVILLE",
    "dropdeladd": "12 COOLEY RD",
    "dropdelcty": "PARKSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127689998,
    "dropphyadd": "12 COOLEY RD",
    "dropphycty": "PARKSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127689998,
    "dropmaladd": "12 COOLEY RD",
    "dropmalcty": "PARKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127689998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452925451,
    "dropsitcph": 8452925451,
    "dropfax": 8452925451
  },
  {
    "dcode": "D",
    "dropkey": "PV15326",
    "droptype": "D",
    "dropname": "PATCHOGUE",
    "dropdeladd": "170 E MAIN ST",
    "dropdelcty": "PATCHOGUE",
    "dropdelst": "NY",
    "dropdelzpp": 117723187,
    "dropphyadd": "170 E MAIN ST",
    "dropphycty": "PATCHOGUE",
    "dropphyst": "NY",
    "dropphyzpp": 117723187,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATCHOGUE",
    "dropmalst": "NY",
    "dropmalzpp": 117729998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314750588,
    "dropfax": 6314750611
  },
  {
    "dcode": "D",
    "dropkey": "PV15331",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "19 FRONT ST",
    "dropdelcty": "PATTERSON",
    "dropdelst": "NY",
    "dropdelzpp": 125639998,
    "dropphyadd": "19 FRONT ST",
    "dropphycty": "PATTERSON",
    "dropphyst": "NY",
    "dropphyzpp": 125639998,
    "dropmaladd": "19 FRONT ST",
    "dropmalcty": "PATTERSON",
    "dropmalst": "NY",
    "dropmalzpp": 125639998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458783515,
    "dropsitcph": 8458783515,
    "dropfax": 8458783852
  },
  {
    "dcode": "D",
    "dropkey": "PV15332",
    "droptype": "D",
    "dropname": "PATTERSONVILLE",
    "dropdeladd": "1626 MAIN ST",
    "dropdelcty": "PATTERSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121379998,
    "dropphyadd": "1626 MAIN ST",
    "dropphycty": "PATTERSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121379998,
    "dropmaladd": "1626 MAIN ST",
    "dropmalcty": "PATTERSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121379998,
    "dropsitphn": 5188875153,
    "dropsitlph": 5188875153,
    "dropsitcph": 5188875153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15334",
    "droptype": "D",
    "dropname": "PAUL SMITHS",
    "dropdeladd": "7833 STATE ROUTE 30",
    "dropdelcty": "PAUL SMITHS",
    "dropdelst": "NY",
    "dropdelzpp": 129709998,
    "dropphyadd": "7833 STATE ROUTE 30",
    "dropphycty": "PAUL SMITHS",
    "dropphyst": "NY",
    "dropphyzpp": 129709998,
    "dropmaladd": "7833 STATE ROUTE 30",
    "dropmalcty": "PAUL SMITHS",
    "dropmalst": "NY",
    "dropmalzpp": 129709998,
    "dropsitphn": 5183273200,
    "dropsitlph": 5183273200,
    "dropsitcph": 5183273200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15335",
    "droptype": "D",
    "dropname": "PAVILION",
    "dropdeladd": "11142 LAKE ST",
    "dropdelcty": "PAVILION",
    "dropdelst": "NY",
    "dropdelzpp": 145259998,
    "dropphyadd": "11142 LAKE ST",
    "dropphycty": "PAVILION",
    "dropphyst": "NY",
    "dropphyzpp": 145259998,
    "dropmaladd": "11142 LAKE ST",
    "dropmalcty": "PAVILION",
    "dropmalst": "NY",
    "dropmalzpp": 145259998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855843670,
    "dropsitcph": 5855843670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15336",
    "droptype": "D",
    "dropname": "PAWLING",
    "dropdeladd": "10 BROAD ST",
    "dropdelcty": "PAWLING",
    "dropdelst": "NY",
    "dropdelzpp": 125649998,
    "dropphyadd": "10 BROAD ST",
    "dropphycty": "PAWLING",
    "dropphyst": "NY",
    "dropphyzpp": 125649998,
    "dropmaladd": "10 BROAD ST",
    "dropmalcty": "PAWLING",
    "dropmalst": "NY",
    "dropmalzpp": 125649998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458552669,
    "dropsitcph": 8458552669,
    "dropfax": 8458552669
  },
  {
    "dcode": "D",
    "dropkey": "PV15340",
    "droptype": "D",
    "dropname": "PEARL RIVER",
    "dropdeladd": "35 S MAIN ST",
    "dropdelcty": "PEARL RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 109659998,
    "dropphyadd": "35 S MAIN ST",
    "dropphycty": "PEARL RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 109659998,
    "dropmaladd": "35 S MAIN ST",
    "dropmalcty": "PEARL RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 109659998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457359578,
    "dropsitcph": 8457359578,
    "dropfax": 8457328444
  },
  {
    "dcode": "D",
    "dropkey": "PV15345",
    "droptype": "D",
    "dropname": "PECONIC",
    "dropdeladd": "2575 PECONIC LN",
    "dropdelcty": "PECONIC",
    "dropdelst": "NY",
    "dropdelzpp": 119581443,
    "dropphyadd": "2575 PECONIC LN",
    "dropphycty": "PECONIC",
    "dropphyst": "NY",
    "dropphyzpp": 119581443,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PECONIC",
    "dropmalst": "NY",
    "dropmalzpp": 119589998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317659348,
    "dropfax": 6317656052
  },
  {
    "dcode": "D",
    "dropkey": "PV15346",
    "droptype": "D",
    "dropname": "PEEKSKILL",
    "dropdeladd": "738 SOUTH ST",
    "dropdelcty": "PEEKSKILL",
    "dropdelst": "NY",
    "dropdelzpp": 105669997,
    "dropphyadd": "738 SOUTH ST",
    "dropphycty": "PEEKSKILL",
    "dropphyst": "NY",
    "dropphyzpp": 105669997,
    "dropmaladd": "738 SOUTH ST",
    "dropmalcty": "PEEKSKILL",
    "dropmalst": "NY",
    "dropmalzpp": 105669997,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147376437,
    "dropsitcph": 9147376437,
    "dropfax": 9147370409
  },
  {
    "dcode": "D",
    "dropkey": "PV15355",
    "droptype": "D",
    "dropname": "PENFIELD",
    "dropdeladd": "2080 FAIRPORT NINE MILE POINT RD",
    "dropdelcty": "PENFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 145269998,
    "dropphyadd": "2080 FAIRPORT NINE MILE POINT RD",
    "dropphycty": "PENFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 145269998,
    "dropmaladd": "2080 FAIRPORT NINE MILE POINT RD",
    "dropmalcty": "PENFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 145269998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853881920,
    "dropsitcph": 5853881920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15356",
    "droptype": "D",
    "dropname": "PENN YAN",
    "dropdeladd": "159 MAIN ST",
    "dropdelcty": "PENN YAN",
    "dropdelst": "NY",
    "dropdelzpp": 145279998,
    "dropphyadd": "159 MAIN ST",
    "dropphycty": "PENN YAN",
    "dropphyst": "NY",
    "dropphyzpp": 145279998,
    "dropmaladd": "159 MAIN ST",
    "dropmalcty": "PENN YAN",
    "dropmalst": "NY",
    "dropmalzpp": 145279998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155366159,
    "dropsitcph": 3155366159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15357",
    "droptype": "D",
    "dropname": "PENNELLVILLE",
    "dropdeladd": "374 COUNTY ROUTE 54",
    "dropdelcty": "PENNELLVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 131329998,
    "dropphyadd": "374 COUNTY ROUTE 54",
    "dropphycty": "PENNELLVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 131329998,
    "dropmaladd": "374 COUNTY ROUTE 54",
    "dropmalcty": "PENNELLVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 131329998,
    "dropsitphn": 3156952397,
    "dropsitlph": 3156952397,
    "dropsitcph": 3156952397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15360",
    "droptype": "D",
    "dropname": "PERKINSVILLE",
    "dropdeladd": "1904 MAIN ST",
    "dropdelcty": "PERKINSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145299800,
    "dropphyadd": "1904 MAIN ST",
    "dropphycty": "PERKINSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERKINSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145299998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5857285300,
    "dropsitcph": 5857285300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15361",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "24 MAIN ST N",
    "dropdelcty": "PERRY",
    "dropdelst": "NY",
    "dropdelzpp": 145309998,
    "dropphyadd": "24 MAIN ST N",
    "dropphycty": "PERRY",
    "dropphyst": "NY",
    "dropphyzpp": 145309998,
    "dropmaladd": "24 MAIN ST N",
    "dropmalcty": "PERRY",
    "dropmalst": "NY",
    "dropmalzpp": 145309998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852372880,
    "dropsitcph": 5852372880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15363",
    "droptype": "D",
    "dropname": "PERRYSBURG",
    "dropdeladd": "11980 MAIN ST",
    "dropdelcty": "PERRYSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 141299998,
    "dropphyadd": "11980 MAIN ST",
    "dropphycty": "PERRYSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 141299998,
    "dropmaladd": "11980 MAIN ST",
    "dropmalcty": "PERRYSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 141299998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165329993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15368",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "742 BEAR SWAMP RD",
    "dropdelcty": "PERU",
    "dropdelst": "NY",
    "dropdelzpp": 129729998,
    "dropphyadd": "742 BEAR SWAMP RD",
    "dropphycty": "PERU",
    "dropphyst": "NY",
    "dropphyzpp": 129729998,
    "dropmaladd": "742 BEAR SWAMP RD",
    "dropmalcty": "PERU",
    "dropmalst": "NY",
    "dropmalzpp": 129729998,
    "dropsitphn": 5186438126,
    "dropsitlph": 5186438126,
    "dropsitcph": 5186438126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15372",
    "droptype": "D",
    "dropname": "PETERBORO",
    "dropdeladd": "4667 PETERBORO RD",
    "dropdelcty": "PETERBORO",
    "dropdelst": "NY",
    "dropdelzpp": 131349998,
    "dropphyadd": "4667 PETERBORO RD",
    "dropphycty": "PETERBORO",
    "dropphyst": "NY",
    "dropphyzpp": 131349998,
    "dropmaladd": "4667 PETERBORO RD",
    "dropmalcty": "PETERBORO",
    "dropmalst": "NY",
    "dropmalzpp": 131349998,
    "dropsitphn": 3156849566,
    "dropsitlph": 3156849566,
    "dropsitcph": 3156849566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15374",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "90 MAIN ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 121389998,
    "dropphyadd": "90 MAIN ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 121389998,
    "dropmaladd": "90 MAIN ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 121389998,
    "dropsitphn": 5186521076,
    "dropsitlph": 5186521076,
    "dropsitcph": 5186521091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15377",
    "droptype": "D",
    "dropname": "PHELPS",
    "dropdeladd": "6 CHURCH ST",
    "dropdelcty": "PHELPS",
    "dropdelst": "NY",
    "dropdelzpp": 145329998,
    "dropphyadd": "6 CHURCH ST",
    "dropphycty": "PHELPS",
    "dropphyst": "NY",
    "dropphyzpp": 145329998,
    "dropmaladd": "6 CHURCH ST",
    "dropmalcty": "PHELPS",
    "dropmalst": "NY",
    "dropmalzpp": 145329998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155496174,
    "dropsitcph": 3155496174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15379",
    "droptype": "D",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "2 S MAIN ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "NY",
    "dropdelzpp": 136739998,
    "dropphyadd": "2 S MAIN ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "NY",
    "dropphyzpp": 136739998,
    "dropmaladd": "2 S MAIN ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "NY",
    "dropmalzpp": 136739998,
    "dropsitphn": 3156423476,
    "dropsitlph": 3156423476,
    "dropsitcph": 3156423476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15382",
    "droptype": "D",
    "dropname": "PHILLIPSPORT",
    "dropdeladd": "17 PHILLIPSPORT RD",
    "dropdelcty": "PHILLIPSPORT",
    "dropdelst": "NY",
    "dropdelzpp": 127699800,
    "dropphyadd": "17 PHILLIPSPORT RD",
    "dropphycty": "PHILLIPSPORT",
    "dropphyst": "NY",
    "dropphyzpp": 127699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHILLIPSPORT",
    "dropmalst": "NY",
    "dropmalzpp": 127699998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456473063,
    "dropsitcph": 8456473063,
    "dropfax": 8456473063
  },
  {
    "dcode": "D",
    "dropkey": "PV15383",
    "droptype": "D",
    "dropname": "PHILMONT",
    "dropdeladd": "5 MAPLE AVE",
    "dropdelcty": "PHILMONT",
    "dropdelst": "NY",
    "dropdelzpp": 125659998,
    "dropphyadd": "5 MAPLE AVE",
    "dropphycty": "PHILMONT",
    "dropphyst": "NY",
    "dropphyzpp": 125659998,
    "dropmaladd": "5 MAPLE AVE",
    "dropmalcty": "PHILMONT",
    "dropmalst": "NY",
    "dropmalzpp": 125659998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186724364,
    "dropsitcph": 5186724364,
    "dropfax": 5186724364
  },
  {
    "dcode": "D",
    "dropkey": "PV15384",
    "droptype": "D",
    "dropname": "PHOENICIA",
    "dropdeladd": "8 AVA MARIA DR",
    "dropdelcty": "PHOENICIA",
    "dropdelst": "NY",
    "dropdelzpp": 124649998,
    "dropphyadd": "8 AVA MARIA DR",
    "dropphycty": "PHOENICIA",
    "dropphyst": "NY",
    "dropphyzpp": 124649998,
    "dropmaladd": "8 AVA MARIA DR",
    "dropmalcty": "PHOENICIA",
    "dropmalst": "NY",
    "dropmalzpp": 124649998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456882449,
    "dropsitcph": 8456882449,
    "dropfax": 8456882449
  },
  {
    "dcode": "D",
    "dropkey": "PV15385",
    "droptype": "D",
    "dropname": "PHOENIX",
    "dropdeladd": "99 JEFFERSON ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "NY",
    "dropdelzpp": 131359998,
    "dropphyadd": "99 JEFFERSON ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "NY",
    "dropphyzpp": 131359998,
    "dropmaladd": "99 JEFFERSON ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "NY",
    "dropmalzpp": 131359998,
    "dropsitphn": 3156953261,
    "dropsitlph": 3156953261,
    "dropsitcph": 3156953261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15386",
    "droptype": "D",
    "dropname": "PIERCEFIELD",
    "dropdeladd": "39 WALLER ST",
    "dropdelcty": "PIERCEFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 129739998,
    "dropphyadd": "39 WALLER ST",
    "dropphycty": "PIERCEFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 129739998,
    "dropmaladd": "39 WALLER ST",
    "dropmalcty": "PIERCEFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 129739998,
    "dropsitphn": 5183593410,
    "dropsitlph": 5183593410,
    "dropsitcph": 5183593410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15389",
    "droptype": "D",
    "dropname": "PIERMONT",
    "dropdeladd": "393 PIERMONT AVE",
    "dropdelcty": "PIERMONT",
    "dropdelst": "NY",
    "dropdelzpp": 109689998,
    "dropphyadd": "393 PIERMONT AVE",
    "dropphycty": "PIERMONT",
    "dropphyst": "NY",
    "dropphyzpp": 109689998,
    "dropmaladd": "393 PIERMONT AVE",
    "dropmalcty": "PIERMONT",
    "dropmalst": "NY",
    "dropmalzpp": 109689998,
    "dropsitphn": 9146974123,
    "dropsitlph": "",
    "dropsitcph": 8453983364,
    "dropfax": 8453983364
  },
  {
    "dcode": "D",
    "dropkey": "PV15393",
    "droptype": "D",
    "dropname": "PIERREPONT MANOR",
    "dropdeladd": "4685 US ROUTE 11",
    "dropdelcty": "PIERREPONT MANOR",
    "dropdelst": "NY",
    "dropdelzpp": 136749998,
    "dropphyadd": "4685 US ROUTE 11",
    "dropphycty": "PIERREPONT MANOR",
    "dropphyst": "NY",
    "dropphyzpp": 136749998,
    "dropmaladd": "4685 US ROUTE 11",
    "dropmalcty": "PIERREPONT MANOR",
    "dropmalst": "NY",
    "dropmalzpp": 136749998,
    "dropsitphn": 3154656995,
    "dropsitlph": 3154656995,
    "dropsitcph": 3154656995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15394",
    "droptype": "D",
    "dropname": "PIFFARD",
    "dropdeladd": "3215 GENESEE ST",
    "dropdelcty": "PIFFARD",
    "dropdelst": "NY",
    "dropdelzpp": 145339998,
    "dropphyadd": "3215 GENESEE ST",
    "dropphycty": "PIFFARD",
    "dropphyst": "NY",
    "dropphyzpp": 145339998,
    "dropmaladd": "3215 GENESEE ST",
    "dropmalcty": "PIFFARD",
    "dropmalst": "NY",
    "dropmalzpp": 145339998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852434188,
    "dropsitcph": 5852434188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15395",
    "droptype": "D",
    "dropname": "PIKE",
    "dropdeladd": "59 E MAIN ST",
    "dropdelcty": "PIKE",
    "dropdelst": "NY",
    "dropdelzpp": 141309800,
    "dropphyadd": "59 E MAIN ST",
    "dropphycty": "PIKE",
    "dropphyst": "NY",
    "dropphyzpp": 141309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIKE",
    "dropmalst": "NY",
    "dropmalzpp": 141309998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854935440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15404",
    "droptype": "D",
    "dropname": "PINE BUSH",
    "dropdeladd": "27 MAIN ST",
    "dropdelcty": "PINE BUSH",
    "dropdelst": "NY",
    "dropdelzpp": 125669998,
    "dropphyadd": "27 MAIN ST",
    "dropphycty": "PINE BUSH",
    "dropphyst": "NY",
    "dropphyzpp": 125669998,
    "dropmaladd": "27 MAIN ST",
    "dropmalcty": "PINE BUSH",
    "dropmalst": "NY",
    "dropmalzpp": 125669998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457443013,
    "dropsitcph": 8457443013,
    "dropfax": 8457442098
  },
  {
    "dcode": "D",
    "dropkey": "PV15405",
    "droptype": "D",
    "dropname": "PINE CITY",
    "dropdeladd": "1565 PENNSYLVANIA AVE",
    "dropdelcty": "PINE CITY",
    "dropdelst": "NY",
    "dropdelzpp": 148719998,
    "dropphyadd": "1565 PENNSYLVANIA AVE",
    "dropphycty": "PINE CITY",
    "dropphyst": "NY",
    "dropphyzpp": 148719998,
    "dropmaladd": "1565 PENNSYLVANIA AVE",
    "dropmalcty": "PINE CITY",
    "dropmalst": "NY",
    "dropmalzpp": 148719998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077342558,
    "dropsitcph": 6077342558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15408",
    "droptype": "D",
    "dropname": "PINE HILL",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "PINE HILL",
    "dropdelst": "NY",
    "dropdelzpp": 124659998,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "PINE HILL",
    "dropphyst": "NY",
    "dropphyzpp": 124659998,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "PINE HILL",
    "dropmalst": "NY",
    "dropmalzpp": 124659998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452544756,
    "dropsitcph": 8452544756,
    "dropfax": 8452544756
  },
  {
    "dcode": "D",
    "dropkey": "PV15411",
    "droptype": "D",
    "dropname": "PINE ISLAND",
    "dropdeladd": "665 COUNTY ROUTE 1",
    "dropdelcty": "PINE ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 109699998,
    "dropphyadd": "665 COUNTY ROUTE 1",
    "dropphycty": "PINE ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 109699998,
    "dropmaladd": "665 COUNTY ROUTE 1",
    "dropmalcty": "PINE ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 109699998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8452584798,
    "dropfax": 8452580003
  },
  {
    "dcode": "D",
    "dropkey": "PV15415",
    "droptype": "D",
    "dropname": "PINE PLAINS",
    "dropdeladd": "7722 S MAIN ST",
    "dropdelcty": "PINE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 125679998,
    "dropphyadd": "7722 S MAIN ST",
    "dropphycty": "PINE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 125679998,
    "dropmaladd": "7722 S MAIN ST",
    "dropmalcty": "PINE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 125679998,
    "dropsitphn": 5186607017,
    "dropsitlph": 8773545777,
    "dropsitcph": 8773545777,
    "dropfax": 5183986427
  },
  {
    "dcode": "D",
    "dropkey": "PV15418",
    "droptype": "D",
    "dropname": "PINE VALLEY",
    "dropdeladd": "3703 WATKINS RD",
    "dropdelcty": "PINE VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 148729998,
    "dropphyadd": "3703 WATKINS RD",
    "dropphycty": "PINE VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 148729998,
    "dropmaladd": "3703 WATKINS RD",
    "dropmalcty": "PINE VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 148729998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077391485,
    "dropsitcph": 6077391485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15429",
    "droptype": "D",
    "dropname": "PITCHER",
    "dropdeladd": "253 STATE HIGHWAY 26",
    "dropdelcty": "PITCHER",
    "dropdelst": "NY",
    "dropdelzpp": 131369998,
    "dropphyadd": "253 STATE HIGHWAY 26",
    "dropphycty": "PITCHER",
    "dropphyst": "NY",
    "dropphyzpp": 131369998,
    "dropmaladd": "253 STATE HIGHWAY 26",
    "dropmalcty": "PITCHER",
    "dropmalst": "NY",
    "dropmalzpp": 131369998,
    "dropsitphn": 6078633773,
    "dropsitlph": 6078633773,
    "dropsitcph": 6078633773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15434",
    "droptype": "D",
    "dropname": "PITTSFORD",
    "dropdeladd": "5607 PALMYRA RD",
    "dropdelcty": "PITTSFORD",
    "dropdelst": "NY",
    "dropdelzpp": 145349998,
    "dropphyadd": "5607 PALMYRA RD",
    "dropphycty": "PITTSFORD",
    "dropphyst": "NY",
    "dropphyzpp": 145349998,
    "dropmaladd": "5607 PALMYRA RD",
    "dropmalcty": "PITTSFORD",
    "dropmalst": "NY",
    "dropmalzpp": 145349998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855861230,
    "dropsitcph": 5855861230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15439",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "8000 PLAINVILLE RD",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 131379998,
    "dropphyadd": "8000 PLAINVILLE RD",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 131379998,
    "dropmaladd": "8000 PLAINVILLE RD",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 131379998,
    "dropsitphn": 3156388123,
    "dropsitlph": 3156388123,
    "dropsitcph": 3156388123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15448",
    "droptype": "D",
    "dropname": "PLATTEKILL",
    "dropdeladd": "2 OLD FIREHOUSE RD",
    "dropdelcty": "PLATTEKILL",
    "dropdelst": "NY",
    "dropdelzpp": 125689800,
    "dropphyadd": "2 OLD FIREHOUSE RD",
    "dropphycty": "PLATTEKILL",
    "dropphyst": "NY",
    "dropphyzpp": 125689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLATTEKILL",
    "dropmalst": "NY",
    "dropmalzpp": 125689998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455640726,
    "dropsitcph": 8455640726,
    "dropfax": 8455640726
  },
  {
    "dcode": "D",
    "dropkey": "PV15450",
    "droptype": "D",
    "dropname": "PLATTSBURGH",
    "dropdeladd": "10 MILLER ST",
    "dropdelcty": "PLATTSBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 129019998,
    "dropphyadd": "10 MILLER ST",
    "dropphycty": "PLATTSBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 129019998,
    "dropmaladd": "10 MILLER ST",
    "dropmalcty": "PLATTSBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 129019998,
    "dropsitphn": 5185631450,
    "dropsitlph": 5185631450,
    "dropsitcph": 5185631450,
    "dropfax": 5185632152
  },
  {
    "dcode": "D",
    "dropkey": "PV15455",
    "droptype": "D",
    "dropname": "PLEASANT VALLEY",
    "dropdeladd": "1612 MAIN ST",
    "dropdelcty": "PLEASANT VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 125699998,
    "dropphyadd": "1612 MAIN ST",
    "dropphycty": "PLEASANT VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 125699998,
    "dropmaladd": "1612 MAIN ST",
    "dropmalcty": "PLEASANT VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 125699998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456358932,
    "dropsitcph": 8456358932,
    "dropfax": 8456359140
  },
  {
    "dcode": "D",
    "dropkey": "PV15458",
    "droptype": "D",
    "dropname": "PLEASANTVILLE",
    "dropdeladd": "50 MEMORIAL PLZ",
    "dropdelcty": "PLEASANTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 105709998,
    "dropphyadd": "50 MEMORIAL PLZ",
    "dropphycty": "PLEASANTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 105709998,
    "dropmaladd": "50 MEMORIAL PLZ",
    "dropmalcty": "PLEASANTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 105709998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147697351,
    "dropsitcph": 9147697351,
    "dropfax": 9147690298
  },
  {
    "dcode": "D",
    "dropkey": "PV15466",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "107 COUNTY ROAD 21",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "NY",
    "dropdelzpp": 138329998,
    "dropphyadd": "107 COUNTY ROAD 21",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "NY",
    "dropphyzpp": 138329998,
    "dropmaladd": "107 COUNTY ROAD 21",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "NY",
    "dropmalzpp": 138329998,
    "dropsitphn": 6073346917,
    "dropsitlph": 6073346917,
    "dropsitcph": 6073346917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15468",
    "droptype": "D",
    "dropname": "POESTENKILL",
    "dropdeladd": "15 PLANK RD",
    "dropdelcty": "POESTENKILL",
    "dropdelst": "NY",
    "dropdelzpp": 121409998,
    "dropphyadd": "15 PLANK RD",
    "dropphycty": "POESTENKILL",
    "dropphyst": "NY",
    "dropphyzpp": 121409998,
    "dropmaladd": "15 PLANK RD",
    "dropmalcty": "POESTENKILL",
    "dropmalst": "NY",
    "dropmalzpp": 121409998,
    "dropsitphn": 5182834012,
    "dropsitlph": 5182834012,
    "dropsitcph": 5182834012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15470",
    "droptype": "D",
    "dropname": "POINT LOOKOUT",
    "dropdeladd": "110 LIDO BLVD",
    "dropdelcty": "POINT LOOKOUT",
    "dropdelst": "NY",
    "dropdelzpp": 115699700,
    "dropphyadd": "110 LIDO BLVD",
    "dropphycty": "POINT LOOKOUT",
    "dropphyst": "NY",
    "dropphyzpp": 115699700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT LOOKOUT",
    "dropmalst": "NY",
    "dropmalzpp": 115699998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5164317590,
    "dropfax": 5164325572
  },
  {
    "dcode": "D",
    "dropkey": "PV15476",
    "droptype": "D",
    "dropname": "POLAND",
    "dropdeladd": "24 COLD BROOK ST",
    "dropdelcty": "POLAND",
    "dropdelst": "NY",
    "dropdelzpp": 134319998,
    "dropphyadd": "24 COLD BROOK ST",
    "dropphycty": "POLAND",
    "dropphyst": "NY",
    "dropphyzpp": 134319998,
    "dropmaladd": "24 COLD BROOK ST",
    "dropmalcty": "POLAND",
    "dropmalst": "NY",
    "dropmalzpp": 134319998,
    "dropsitphn": 3158263794,
    "dropsitlph": 3158263794,
    "dropsitcph": 3158263794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15479",
    "droptype": "D",
    "dropname": "POMONA",
    "dropdeladd": "1515 ROUTE 202",
    "dropdelcty": "POMONA",
    "dropdelst": "NY",
    "dropdelzpp": 109709998,
    "dropphyadd": "1515 ROUTE 202",
    "dropphycty": "POMONA",
    "dropphyst": "NY",
    "dropphyzpp": 109709998,
    "dropmaladd": "1515 ROUTE 202",
    "dropmalcty": "POMONA",
    "dropmalst": "NY",
    "dropmalzpp": 109709998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453645003,
    "dropsitcph": 8453645003,
    "dropfax": 8453543325
  },
  {
    "dcode": "D",
    "dropkey": "PV15482",
    "droptype": "D",
    "dropname": "POMPEY",
    "dropdeladd": "7360 ACADEMY ST",
    "dropdelcty": "POMPEY",
    "dropdelst": "NY",
    "dropdelzpp": 131389998,
    "dropphyadd": "7360 ACADEMY ST",
    "dropphycty": "POMPEY",
    "dropphyst": "NY",
    "dropphyzpp": 131389998,
    "dropmaladd": "7360 ACADEMY ST",
    "dropmalcty": "POMPEY",
    "dropmalst": "NY",
    "dropmalzpp": 131389998,
    "dropsitphn": 3156773611,
    "dropsitlph": 3156773611,
    "dropsitcph": 3156773611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15483",
    "droptype": "D",
    "dropname": "POND EDDY",
    "dropdeladd": "43 HOLLOW RD",
    "dropdelcty": "POND EDDY",
    "dropdelst": "NY",
    "dropdelzpp": 127709998,
    "dropphyadd": "43 HOLLOW RD",
    "dropphycty": "POND EDDY",
    "dropphyst": "NY",
    "dropphyzpp": 127709998,
    "dropmaladd": "43 HOLLOW RD",
    "dropmalcty": "POND EDDY",
    "dropmalst": "NY",
    "dropmalzpp": 127709998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458562750,
    "dropsitcph": 8458562750,
    "dropfax": 8458589820
  },
  {
    "dcode": "D",
    "dropkey": "PV15488",
    "droptype": "D",
    "dropname": "POPLAR RIDGE",
    "dropdeladd": "2485 STATE ROUTE 34B",
    "dropdelcty": "POPLAR RIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 131399998,
    "dropphyadd": "2485 STATE ROUTE 34B",
    "dropphycty": "POPLAR RIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 131399998,
    "dropmaladd": "2485 STATE ROUTE 34B",
    "dropmalcty": "POPLAR RIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 131399998,
    "dropsitphn": 3153648549,
    "dropsitlph": 3153648549,
    "dropsitcph": 3153648549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15492",
    "droptype": "D",
    "dropname": "PORT BYRON",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "PORT BYRON",
    "dropdelst": "NY",
    "dropdelzpp": 131409998,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "PORT BYRON",
    "dropphyst": "NY",
    "dropphyzpp": 131409998,
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "PORT BYRON",
    "dropmalst": "NY",
    "dropmalzpp": 131409998,
    "dropsitphn": 3157768629,
    "dropsitlph": 3157768629,
    "dropsitcph": 3157768629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15493",
    "droptype": "D",
    "dropname": "PORT CHESTER",
    "dropdeladd": "245 WESTCHESTER AVE",
    "dropdelcty": "PORT CHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 105739998,
    "dropphyadd": "245 WESTCHESTER AVE",
    "dropphycty": "PORT CHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 105739998,
    "dropmaladd": "245 WESTCHESTER AVE",
    "dropmalcty": "PORT CHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 105739998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149396783,
    "dropsitcph": 9149396783,
    "dropfax": 9149340968
  },
  {
    "dcode": "D",
    "dropkey": "PV15494",
    "droptype": "D",
    "dropname": "PORT CRANE",
    "dropdeladd": "12 CANAL ST",
    "dropdelcty": "PORT CRANE",
    "dropdelst": "NY",
    "dropdelzpp": 138339998,
    "dropphyadd": "12 CANAL ST",
    "dropphycty": "PORT CRANE",
    "dropphyst": "NY",
    "dropphyzpp": 138339998,
    "dropmaladd": "12 CANAL ST",
    "dropmalcty": "PORT CRANE",
    "dropmalst": "NY",
    "dropmalzpp": 138339998,
    "dropsitphn": 6076486828,
    "dropsitlph": 6076486828,
    "dropsitcph": 6076486828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15496",
    "droptype": "D",
    "dropname": "PORT EWEN",
    "dropdeladd": "194 BROADWAY",
    "dropdelcty": "PORT EWEN",
    "dropdelst": "NY",
    "dropdelzpp": 124669996,
    "dropphyadd": "194 BROADWAY",
    "dropphycty": "PORT EWEN",
    "dropphyst": "NY",
    "dropphyzpp": 124669996,
    "dropmaladd": "194 BROADWAY",
    "dropmalcty": "PORT EWEN",
    "dropmalst": "NY",
    "dropmalzpp": 124669996,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453312534,
    "dropsitcph": 8453312534,
    "dropfax": 8453385036
  },
  {
    "dcode": "D",
    "dropkey": "PV15497",
    "droptype": "D",
    "dropname": "PORT GIBSON",
    "dropdeladd": "41 ATWATER ST",
    "dropdelcty": "PORT GIBSON",
    "dropdelst": "NY",
    "dropdelzpp": 145379800,
    "dropphyadd": "41 ATWATER ST",
    "dropphycty": "PORT GIBSON",
    "dropphyst": "NY",
    "dropphyzpp": 145379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT GIBSON",
    "dropmalst": "NY",
    "dropmalzpp": 145379998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3153317477,
    "dropsitcph": 3153317477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15498",
    "droptype": "D",
    "dropname": "PORT HENRY",
    "dropdeladd": "3260 BROAD ST",
    "dropdelcty": "PORT HENRY",
    "dropdelst": "NY",
    "dropdelzpp": 129749998,
    "dropphyadd": "3260 BROAD ST",
    "dropphycty": "PORT HENRY",
    "dropphyst": "NY",
    "dropphyzpp": 129749998,
    "dropmaladd": "3260 BROAD ST",
    "dropmalcty": "PORT HENRY",
    "dropmalst": "NY",
    "dropmalzpp": 129749998,
    "dropsitphn": 5185467209,
    "dropsitlph": 5185467209,
    "dropsitcph": 5185467209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15503",
    "droptype": "D",
    "dropname": "PORT JEFFERSON STATION",
    "dropdeladd": "544 JEFFERSON PLZ",
    "dropdelcty": "PORT JEFFERSON STATION",
    "dropdelst": "NY",
    "dropdelzpp": 117761101,
    "dropphyadd": "544 JEFFERSON PLZ",
    "dropphycty": "PORT JEFFERSON STATION",
    "dropphyst": "NY",
    "dropphyzpp": 117761101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT JEFFERSON STATION",
    "dropmalst": "NY",
    "dropmalzpp": 117769998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314732751,
    "dropfax": 6314749769
  },
  {
    "dcode": "D",
    "dropkey": "PV15504",
    "droptype": "D",
    "dropname": "PORT JERVIS",
    "dropdeladd": "20 SUSSEX ST",
    "dropdelcty": "PORT JERVIS",
    "dropdelst": "NY",
    "dropdelzpp": 127719998,
    "dropphyadd": "20 SUSSEX ST",
    "dropphycty": "PORT JERVIS",
    "dropphyst": "NY",
    "dropphyzpp": 127719998,
    "dropmaladd": "20 SUSSEX ST",
    "dropmalcty": "PORT JERVIS",
    "dropmalst": "NY",
    "dropmalzpp": 127719998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458588173,
    "dropsitcph": 8458588173,
    "dropfax": 8458569689
  },
  {
    "dcode": "D",
    "dropkey": "PV15505",
    "droptype": "D",
    "dropname": "PORT KENT",
    "dropdeladd": "31 FIRST ST",
    "dropdelcty": "PORT KENT",
    "dropdelst": "NY",
    "dropdelzpp": 129759998,
    "dropphyadd": "31 FIRST ST",
    "dropphycty": "PORT KENT",
    "dropphyst": "NY",
    "dropphyzpp": 129759998,
    "dropmaladd": "31 FIRST ST",
    "dropmalcty": "PORT KENT",
    "dropmalst": "NY",
    "dropmalzpp": 129759998,
    "dropsitphn": 5188349071,
    "dropsitlph": 5188349071,
    "dropsitcph": 5188349071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15506",
    "droptype": "D",
    "dropname": "PORT LEYDEN",
    "dropdeladd": "7085 W MAIN ST",
    "dropdelcty": "PORT LEYDEN",
    "dropdelst": "NY",
    "dropdelzpp": 134339998,
    "dropphyadd": "7085 W MAIN ST",
    "dropphycty": "PORT LEYDEN",
    "dropphyst": "NY",
    "dropphyzpp": 134339998,
    "dropmaladd": "7085 W MAIN ST",
    "dropmalcty": "PORT LEYDEN",
    "dropmalst": "NY",
    "dropmalzpp": 134339998,
    "dropsitphn": 3153486312,
    "dropsitlph": 3153486312,
    "dropsitcph": 3153486312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15512",
    "droptype": "D",
    "dropname": "PORT WASHINGTON",
    "dropdeladd": "1051 PORT WASHINGTON BLVD",
    "dropdelcty": "PORT WASHINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 110509998,
    "dropphyadd": "1051 PORT WASHINGTON BLVD",
    "dropphycty": "PORT WASHINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 110509998,
    "dropmaladd": "1051 PORT WASHINGTON BLVD",
    "dropmalcty": "PORT WASHINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 110509998,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5168830754,
    "dropfax": 5168833585
  },
  {
    "dcode": "D",
    "dropkey": "PV15514",
    "droptype": "D",
    "dropname": "PORTAGEVILLE",
    "dropdeladd": "6676 HAMILTON ST",
    "dropdelcty": "PORTAGEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145369998,
    "dropphyadd": "6676 HAMILTON ST",
    "dropphycty": "PORTAGEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145369998,
    "dropmaladd": "6676 HAMILTON ST",
    "dropmalcty": "PORTAGEVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145369998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854682300,
    "dropsitcph": 5854682300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15518",
    "droptype": "D",
    "dropname": "PORTER CORNERS",
    "dropdeladd": "515 ALLEN RD",
    "dropdelcty": "PORTER CORNERS",
    "dropdelst": "NY",
    "dropdelzpp": 128599998,
    "dropphyadd": "515 ALLEN RD",
    "dropphycty": "PORTER CORNERS",
    "dropphyst": "NY",
    "dropphyzpp": 128599998,
    "dropmaladd": "515 ALLEN RD",
    "dropmalcty": "PORTER CORNERS",
    "dropmalst": "NY",
    "dropmalzpp": 128599998,
    "dropsitphn": 5188937141,
    "dropsitlph": 5188937141,
    "dropsitcph": 5188937141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15520",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "6372 W MAIN RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "NY",
    "dropdelzpp": 147699998,
    "dropphyadd": "6372 W MAIN RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "NY",
    "dropphyzpp": 147699998,
    "dropmaladd": "6372 W MAIN RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "NY",
    "dropmalzpp": 147699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167929865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15521",
    "droptype": "D",
    "dropname": "PORTLANDVILLE",
    "dropdeladd": "2846 STATE HIGHWAY 28",
    "dropdelcty": "PORTLANDVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 138349998,
    "dropphyadd": "2846 STATE HIGHWAY 28",
    "dropphycty": "PORTLANDVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 138349998,
    "dropmaladd": "2846 STATE HIGHWAY 28",
    "dropmalcty": "PORTLANDVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 138349998,
    "dropsitphn": 6072869838,
    "dropsitlph": 6072869838,
    "dropsitcph": 6072869838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15524",
    "droptype": "D",
    "dropname": "PORTVILLE",
    "dropdeladd": "1 S MAIN ST",
    "dropdelcty": "PORTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147709998,
    "dropphyadd": "1 S MAIN ST",
    "dropphycty": "PORTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147709998,
    "dropmaladd": "1 S MAIN ST",
    "dropmalcty": "PORTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147709998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169336463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15529",
    "droptype": "D",
    "dropname": "POTSDAM",
    "dropdeladd": "21 ELM ST",
    "dropdelcty": "POTSDAM",
    "dropdelst": "NY",
    "dropdelzpp": 136769998,
    "dropphyadd": "21 ELM ST",
    "dropphycty": "POTSDAM",
    "dropphyst": "NY",
    "dropphyzpp": 136769998,
    "dropmaladd": "21 ELM ST",
    "dropmalcty": "POTSDAM",
    "dropmalst": "NY",
    "dropmalzpp": 136769998,
    "dropsitphn": 3152658614,
    "dropsitlph": 3152658614,
    "dropsitcph": 3152658614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15531",
    "droptype": "D",
    "dropname": "POTTERSVILLE",
    "dropdeladd": "37 VALLEY FARM RD",
    "dropdelcty": "POTTERSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128609998,
    "dropphyadd": "37 VALLEY FARM RD",
    "dropphycty": "POTTERSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128609998,
    "dropmaladd": "37 VALLEY FARM RD",
    "dropmalcty": "POTTERSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128609998,
    "dropsitphn": 5184925003,
    "dropsitlph": 5184925003,
    "dropsitcph": 5184925003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15532",
    "droptype": "D",
    "dropname": "POUGHKEEPSIE",
    "dropdeladd": "55 MANSION ST",
    "dropdelcty": "POUGHKEEPSIE",
    "dropdelst": "NY",
    "dropdelzpp": 126019998,
    "dropphyadd": "55 MANSION ST",
    "dropphycty": "POUGHKEEPSIE",
    "dropphyst": "NY",
    "dropphyzpp": 126019998,
    "dropmaladd": "55 MANSION ST",
    "dropmalcty": "POUGHKEEPSIE",
    "dropmalst": "NY",
    "dropmalzpp": 126019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454525297,
    "dropsitcph": 8454525297,
    "dropfax": 8454736775
  },
  {
    "dcode": "D",
    "dropkey": "PV15533",
    "droptype": "D",
    "dropname": "POUGHQUAG",
    "dropdeladd": "2546 ROUTE 55",
    "dropdelcty": "POUGHQUAG",
    "dropdelst": "NY",
    "dropdelzpp": 125709998,
    "dropphyadd": "2546 ROUTE 55",
    "dropphycty": "POUGHQUAG",
    "dropphyst": "NY",
    "dropphyzpp": 125709998,
    "dropmaladd": "2546 ROUTE 55",
    "dropmalcty": "POUGHQUAG",
    "dropmalst": "NY",
    "dropmalzpp": 125709998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457244763,
    "dropsitcph": 8457244763,
    "dropfax": 8457245398
  },
  {
    "dcode": "D",
    "dropkey": "PV15534",
    "droptype": "D",
    "dropname": "POUND RIDGE",
    "dropdeladd": "57 WESTCHESTER AVE",
    "dropdelcty": "POUND RIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 105769919,
    "dropphyadd": "57 WESTCHESTER AVE",
    "dropphycty": "POUND RIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 105769919,
    "dropmaladd": "57 WESTCHESTER AVE",
    "dropmalcty": "POUND RIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 105769919,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147649139,
    "dropsitcph": 9147649139,
    "dropfax": 9147649657
  },
  {
    "dcode": "D",
    "dropkey": "PV15539",
    "droptype": "D",
    "dropname": "PRATTSBURGH",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "PRATTSBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 148739998,
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "PRATTSBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 148739998,
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "PRATTSBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 148739998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075224657,
    "dropsitcph": 6075224657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15540",
    "droptype": "D",
    "dropname": "PRATTSVILLE",
    "dropdeladd": "14546 MAIN ST",
    "dropdelcty": "PRATTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124689998,
    "dropphyadd": "14546 MAIN ST",
    "dropphycty": "PRATTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124689998,
    "dropmaladd": "14546 MAIN ST",
    "dropmalcty": "PRATTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124689998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5182993342,
    "dropsitcph": 5182993342,
    "dropfax": 5182993342
  },
  {
    "dcode": "D",
    "dropkey": "PV15543",
    "droptype": "D",
    "dropname": "PREBLE",
    "dropdeladd": "1968 PREBLE RD",
    "dropdelcty": "PREBLE",
    "dropdelst": "NY",
    "dropdelzpp": 131419998,
    "dropphyadd": "1968 PREBLE RD",
    "dropphycty": "PREBLE",
    "dropphyst": "NY",
    "dropphyzpp": 131419998,
    "dropmaladd": "1968 PREBLE RD",
    "dropmalcty": "PREBLE",
    "dropmalst": "NY",
    "dropmalzpp": 131419998,
    "dropsitphn": 6077492027,
    "dropsitlph": 6077492027,
    "dropsitcph": 6077492027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15548",
    "droptype": "D",
    "dropname": "PRESTON HOLLOW",
    "dropdeladd": "2930 ROUTE 145",
    "dropdelcty": "PRESTON HOLLOW",
    "dropdelst": "NY",
    "dropdelzpp": 124699998,
    "dropphyadd": "2930 ROUTE 145",
    "dropphycty": "PRESTON HOLLOW",
    "dropphyst": "NY",
    "dropphyzpp": 124699998,
    "dropmaladd": "2930 ROUTE 145",
    "dropmalcty": "PRESTON HOLLOW",
    "dropmalst": "NY",
    "dropmalzpp": 124699998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5182396111,
    "dropsitcph": 5182396111,
    "dropfax": 5182396111
  },
  {
    "dcode": "D",
    "dropkey": "PV15555",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "209 CHURCH ST",
    "dropdelcty": "PROSPECT",
    "dropdelst": "NY",
    "dropdelzpp": 134359998,
    "dropphyadd": "209 CHURCH ST",
    "dropphycty": "PROSPECT",
    "dropphyst": "NY",
    "dropphyzpp": 134359998,
    "dropmaladd": "209 CHURCH ST",
    "dropmalcty": "PROSPECT",
    "dropmalst": "NY",
    "dropmalzpp": 134359998,
    "dropsitphn": 3158962523,
    "dropsitlph": 3158962523,
    "dropsitcph": 3158962523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15585",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "4909 N JEFFERSON ST",
    "dropdelcty": "PULASKI",
    "dropdelst": "NY",
    "dropdelzpp": 131429998,
    "dropphyadd": "4909 N JEFFERSON ST",
    "dropphycty": "PULASKI",
    "dropphyst": "NY",
    "dropphyzpp": 131429998,
    "dropmaladd": "4909 N JEFFERSON ST",
    "dropmalcty": "PULASKI",
    "dropmalst": "NY",
    "dropmalzpp": 131429998,
    "dropsitphn": 3152982951,
    "dropsitlph": 3152982951,
    "dropsitcph": 3152982951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15586",
    "droptype": "D",
    "dropname": "PULTENEY",
    "dropdeladd": "9256 COUNTY ROUTE 74",
    "dropdelcty": "PULTENEY",
    "dropdelst": "NY",
    "dropdelzpp": 148749998,
    "dropphyadd": "9256 COUNTY ROUTE 74",
    "dropphycty": "PULTENEY",
    "dropphyst": "NY",
    "dropphyzpp": 148749998,
    "dropmaladd": "9256 COUNTY ROUTE 74",
    "dropmalcty": "PULTENEY",
    "dropmalst": "NY",
    "dropmalzpp": 148749998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6078684275,
    "dropsitcph": 6078684275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15587",
    "droptype": "D",
    "dropname": "PULTNEYVILLE",
    "dropdeladd": "4133 MILL ST",
    "dropdelcty": "PULTNEYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145389800,
    "dropphyadd": "4133 MILL ST",
    "dropphycty": "PULTNEYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULTNEYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145389998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155898820,
    "dropsitcph": 3155898820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15590",
    "droptype": "D",
    "dropname": "PURCHASE",
    "dropdeladd": "3003 PURCHASE ST",
    "dropdelcty": "PURCHASE",
    "dropdelst": "NY",
    "dropdelzpp": 105779998,
    "dropphyadd": "3003 PURCHASE ST",
    "dropphycty": "PURCHASE",
    "dropphyst": "NY",
    "dropphyzpp": 105779998,
    "dropmaladd": "3003 PURCHASE ST",
    "dropmalcty": "PURCHASE",
    "dropmalst": "NY",
    "dropmalzpp": 105779998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147611562,
    "dropsitcph": 9147611562,
    "dropfax": 9149936324
  },
  {
    "dcode": "D",
    "dropkey": "PV15592",
    "droptype": "D",
    "dropname": "PURDYS",
    "dropdeladd": "3 MAIN ST",
    "dropdelcty": "PURDYS",
    "dropdelst": "NY",
    "dropdelzpp": 105789998,
    "dropphyadd": "3 MAIN ST",
    "dropphycty": "PURDYS",
    "dropphyst": "NY",
    "dropphyzpp": 105789998,
    "dropmaladd": "3 MAIN ST",
    "dropmalcty": "PURDYS",
    "dropmalst": "NY",
    "dropmalzpp": 105789998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142774046,
    "dropsitcph": 9142774046,
    "dropfax": 9142761344
  },
  {
    "dcode": "D",
    "dropkey": "PV15599",
    "droptype": "D",
    "dropname": "PUTNAM STATION",
    "dropdeladd": "16783 STATE ROUTE 22",
    "dropdelcty": "PUTNAM STATION",
    "dropdelst": "NY",
    "dropdelzpp": 128619998,
    "dropphyadd": "16783 STATE ROUTE 22",
    "dropphycty": "PUTNAM STATION",
    "dropphyst": "NY",
    "dropphyzpp": 128619998,
    "dropmaladd": "16783 STATE ROUTE 22",
    "dropmalcty": "PUTNAM STATION",
    "dropmalst": "NY",
    "dropmalzpp": 128619998,
    "dropsitphn": 5185478357,
    "dropsitlph": 5185478357,
    "dropsitcph": 5185478357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15600",
    "droptype": "D",
    "dropname": "PUTNAM VALLEY",
    "dropdeladd": "12 PEEKSKILL HOLLOW RD",
    "dropdelcty": "PUTNAM VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 105799998,
    "dropphyadd": "12 PEEKSKILL HOLLOW RD",
    "dropphycty": "PUTNAM VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 105799998,
    "dropmaladd": "12 PEEKSKILL HOLLOW RD",
    "dropmalcty": "PUTNAM VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 105799998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455280341,
    "dropsitcph": 8455280341,
    "dropfax": 8455280953
  },
  {
    "dcode": "D",
    "dropkey": "PV15615",
    "droptype": "D",
    "dropname": "QUOGUE",
    "dropdeladd": "6 MIDLAND ST",
    "dropdelcty": "QUOGUE",
    "dropdelst": "NY",
    "dropdelzpp": 119599700,
    "dropphyadd": "6 MIDLAND ST",
    "dropphycty": "QUOGUE",
    "dropphyst": "NY",
    "dropphyzpp": 119599700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUOGUE",
    "dropmalst": "NY",
    "dropmalzpp": 119599998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316536427,
    "dropfax": 6316530626
  },
  {
    "dcode": "D",
    "dropkey": "PV15623",
    "droptype": "D",
    "dropname": "RAINBOW LAKE",
    "dropdeladd": "555 COUNTY ROUTE 60",
    "dropdelcty": "RAINBOW LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 129769998,
    "dropphyadd": "555 COUNTY ROUTE 60",
    "dropphycty": "RAINBOW LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 129769998,
    "dropmaladd": "555 COUNTY ROUTE 60",
    "dropmalcty": "RAINBOW LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 129769998,
    "dropsitphn": 5183275298,
    "dropsitlph": 5183275298,
    "dropsitcph": 5183275298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15629",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "90 MAIN ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "NY",
    "dropdelzpp": 147729998,
    "dropphyadd": "90 MAIN ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "NY",
    "dropphyzpp": 147729998,
    "dropmaladd": "90 MAIN ST",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "NY",
    "dropmalzpp": 147729998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163537037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15630",
    "droptype": "D",
    "dropname": "RANSOMVILLE",
    "dropdeladd": "2567 YOUNGSTOWN LOCKPORT RD",
    "dropdelcty": "RANSOMVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 141319998,
    "dropphyadd": "2567 YOUNGSTOWN LOCKPORT RD",
    "dropphycty": "RANSOMVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 141319998,
    "dropmaladd": "2567 YOUNGSTOWN LOCKPORT RD",
    "dropmalcty": "RANSOMVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 141319998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167913223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15634",
    "droptype": "D",
    "dropname": "RAQUETTE LAKE",
    "dropdeladd": "185 MAIN ST",
    "dropdelcty": "RAQUETTE LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 134369998,
    "dropphyadd": "185 MAIN ST",
    "dropphycty": "RAQUETTE LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 134369998,
    "dropmaladd": "185 MAIN ST",
    "dropmalcty": "RAQUETTE LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 134369998,
    "dropsitphn": 3153544291,
    "dropsitlph": 3153544291,
    "dropsitcph": 3153544291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15635",
    "droptype": "D",
    "dropname": "RAVENA",
    "dropdeladd": "167 MAIN ST",
    "dropdelcty": "RAVENA",
    "dropdelst": "NY",
    "dropdelzpp": 121439998,
    "dropphyadd": "167 MAIN ST",
    "dropphycty": "RAVENA",
    "dropphyst": "NY",
    "dropphyzpp": 121439998,
    "dropmaladd": "167 MAIN ST",
    "dropmalcty": "RAVENA",
    "dropmalst": "NY",
    "dropmalzpp": 121439998,
    "dropsitphn": 5187592003,
    "dropsitlph": 5187592003,
    "dropsitcph": 5187592003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15636",
    "droptype": "D",
    "dropname": "RAY BROOK",
    "dropdeladd": "900 NYS ROUTE 86",
    "dropdelcty": "RAY BROOK",
    "dropdelst": "NY",
    "dropdelzpp": 129779998,
    "dropphyadd": "900 NYS ROUTE 86",
    "dropphycty": "RAY BROOK",
    "dropphyst": "NY",
    "dropphyzpp": 129779998,
    "dropmaladd": "900 NYS ROUTE 86",
    "dropmalcty": "RAY BROOK",
    "dropmalst": "NY",
    "dropmalzpp": 129779998,
    "dropsitphn": 5188913430,
    "dropsitlph": 5188913430,
    "dropsitcph": 5188913430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15638",
    "droptype": "D",
    "dropname": "RAYMONDVILLE",
    "dropdeladd": "8766 STATE HIGHWAY 56",
    "dropdelcty": "RAYMONDVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136789998,
    "dropphyadd": "8766 STATE HIGHWAY 56",
    "dropphycty": "RAYMONDVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136789998,
    "dropmaladd": "8766 STATE HIGHWAY 56",
    "dropmalcty": "RAYMONDVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136789998,
    "dropsitphn": 3153844907,
    "dropsitlph": 3153844907,
    "dropsitcph": 3153844907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15643",
    "droptype": "D",
    "dropname": "READING CENTER",
    "dropdeladd": "4051 STATE ROUTE 14A",
    "dropdelcty": "READING CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 148769800,
    "dropphyadd": "4051 STATE ROUTE 14A",
    "dropphycty": "READING CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 148769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "READING CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 148769998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075359736,
    "dropsitcph": 6075359736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15645",
    "droptype": "D",
    "dropname": "RED CREEK",
    "dropdeladd": "6755 WOLCOTT ST",
    "dropdelcty": "RED CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 131439998,
    "dropphyadd": "6755 WOLCOTT ST",
    "dropphycty": "RED CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 131439998,
    "dropmaladd": "6755 WOLCOTT ST",
    "dropmalcty": "RED CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 131439998,
    "dropsitphn": 3157546388,
    "dropsitlph": 3157546388,
    "dropsitcph": 3157546388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15649",
    "droptype": "D",
    "dropname": "RED HOOK",
    "dropdeladd": "7525 N BROADWAY",
    "dropdelcty": "RED HOOK",
    "dropdelst": "NY",
    "dropdelzpp": 125719998,
    "dropphyadd": "7525 N BROADWAY",
    "dropphycty": "RED HOOK",
    "dropphyst": "NY",
    "dropphyzpp": 125719998,
    "dropmaladd": "7525 N BROADWAY",
    "dropmalcty": "RED HOOK",
    "dropmalst": "NY",
    "dropmalzpp": 125719998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457585361,
    "dropsitcph": 8457585361,
    "dropfax": 8457585404
  },
  {
    "dcode": "D",
    "dropkey": "PV15654",
    "droptype": "D",
    "dropname": "REDFIELD",
    "dropdeladd": "7 SCHOOL RD",
    "dropdelcty": "REDFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 134379800,
    "dropphyadd": "7 SCHOOL RD",
    "dropphycty": "REDFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 134379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 134379998,
    "dropsitphn": 3155997371,
    "dropsitlph": 3155997371,
    "dropsitcph": 3155997371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15655",
    "droptype": "D",
    "dropname": "REDFORD",
    "dropdeladd": "4314 STATE ROUTE 3",
    "dropdelcty": "REDFORD",
    "dropdelst": "NY",
    "dropdelzpp": 129789998,
    "dropphyadd": "4314 STATE ROUTE 3",
    "dropphycty": "REDFORD",
    "dropphyst": "NY",
    "dropphyzpp": 129789998,
    "dropmaladd": "4314 STATE ROUTE 3",
    "dropmalcty": "REDFORD",
    "dropmalst": "NY",
    "dropmalzpp": 129789998,
    "dropsitphn": 5182938820,
    "dropsitlph": 5182938820,
    "dropsitcph": 5182938820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15656",
    "droptype": "D",
    "dropname": "REDWOOD",
    "dropdeladd": "43711 STATE ROUTE 37",
    "dropdelcty": "REDWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 136799998,
    "dropphyadd": "43711 STATE ROUTE 37",
    "dropphycty": "REDWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 136799998,
    "dropmaladd": "43711 STATE ROUTE 37",
    "dropmalcty": "REDWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 136799998,
    "dropsitphn": 3154823121,
    "dropsitlph": 3154823121,
    "dropsitcph": 3154823121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15663",
    "droptype": "D",
    "dropname": "REMSEN",
    "dropdeladd": "10565 STEUBEN ST",
    "dropdelcty": "REMSEN",
    "dropdelst": "NY",
    "dropdelzpp": 134389998,
    "dropphyadd": "10565 STEUBEN ST",
    "dropphycty": "REMSEN",
    "dropphyst": "NY",
    "dropphyzpp": 134389998,
    "dropmaladd": "10565 STEUBEN ST",
    "dropmalcty": "REMSEN",
    "dropmalst": "NY",
    "dropmalzpp": 134389998,
    "dropsitphn": 3158313871,
    "dropsitlph": 3158313871,
    "dropsitcph": 3158313871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15664",
    "droptype": "D",
    "dropname": "REMSENBURG",
    "dropdeladd": "137 S COUNTRY RD",
    "dropdelcty": "REMSENBURG",
    "dropdelst": "NY",
    "dropdelzpp": 119609700,
    "dropphyadd": "137 S COUNTRY RD",
    "dropphycty": "REMSENBURG",
    "dropphyst": "NY",
    "dropphyzpp": 119609700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMSENBURG",
    "dropmalst": "NY",
    "dropmalzpp": 119609998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313255937,
    "dropfax": 6313258352
  },
  {
    "dcode": "D",
    "dropkey": "PV15666",
    "droptype": "D",
    "dropname": "RENSSELAER",
    "dropdeladd": "531 EAST ST",
    "dropdelcty": "RENSSELAER",
    "dropdelst": "NY",
    "dropdelzpp": 121449998,
    "dropphyadd": "531 EAST ST",
    "dropphycty": "RENSSELAER",
    "dropphyst": "NY",
    "dropphyzpp": 121449998,
    "dropmaladd": "531 EAST ST",
    "dropmalcty": "RENSSELAER",
    "dropmalst": "NY",
    "dropmalzpp": 121449998,
    "dropsitphn": 5184495012,
    "dropsitlph": 5184495012,
    "dropsitcph": 5184495012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15667",
    "droptype": "D",
    "dropname": "RENSSELAER FALLS",
    "dropdeladd": "217 RENSSELAER ST",
    "dropdelcty": "RENSSELAER FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 136809998,
    "dropphyadd": "217 RENSSELAER ST",
    "dropphycty": "RENSSELAER FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 136809998,
    "dropmaladd": "217 RENSSELAER ST",
    "dropmalcty": "RENSSELAER FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 136809998,
    "dropsitphn": 3153442468,
    "dropsitlph": 3153442468,
    "dropsitcph": 3153442468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15668",
    "droptype": "D",
    "dropname": "RENSSELAERVILLE",
    "dropdeladd": "26 COUNTY ROUTE 353",
    "dropdelcty": "RENSSELAERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121479998,
    "dropphyadd": "26 COUNTY ROUTE 353",
    "dropphycty": "RENSSELAERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121479998,
    "dropmaladd": "26 COUNTY ROUTE 353",
    "dropmalcty": "RENSSELAERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121479998,
    "dropsitphn": 5187973231,
    "dropsitlph": 5187973231,
    "dropsitcph": 5187973231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15671",
    "droptype": "D",
    "dropname": "RETSOF",
    "dropdeladd": "3681 RETSOF RD",
    "dropdelcty": "RETSOF",
    "dropdelst": "NY",
    "dropdelzpp": 145399800,
    "dropphyadd": "3681 RETSOF RD",
    "dropphycty": "RETSOF",
    "dropphyst": "NY",
    "dropphyzpp": 145399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RETSOF",
    "dropmalst": "NY",
    "dropmalzpp": 145399998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852433235,
    "dropsitcph": 5852433235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15673",
    "droptype": "D",
    "dropname": "REXFORD",
    "dropdeladd": "1590 ROUTE 146",
    "dropdelcty": "REXFORD",
    "dropdelst": "NY",
    "dropdelzpp": 121489998,
    "dropphyadd": "1590 ROUTE 146",
    "dropphycty": "REXFORD",
    "dropphyst": "NY",
    "dropphyzpp": 121489998,
    "dropmaladd": "1590 ROUTE 146",
    "dropmalcty": "REXFORD",
    "dropmalst": "NY",
    "dropmalzpp": 121489998,
    "dropsitphn": 5183992002,
    "dropsitlph": 5183992002,
    "dropsitcph": 5183992002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15675",
    "droptype": "D",
    "dropname": "REXVILLE",
    "dropdeladd": "881 COUNTY ROUTE 117",
    "dropdelcty": "REXVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 148779998,
    "dropphyadd": "881 COUNTY ROUTE 117",
    "dropphycty": "REXVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 148779998,
    "dropmaladd": "881 COUNTY ROUTE 117",
    "dropmalcty": "REXVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 148779998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072254646,
    "dropsitcph": 6072254646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15677",
    "droptype": "D",
    "dropname": "RHINEBECK",
    "dropdeladd": "6383 MILL ST",
    "dropdelcty": "RHINEBECK",
    "dropdelst": "NY",
    "dropdelzpp": 125729998,
    "dropphyadd": "6383 MILL ST",
    "dropphycty": "RHINEBECK",
    "dropphyst": "NY",
    "dropphyzpp": 125729998,
    "dropmaladd": "6383 MILL ST",
    "dropmalcty": "RHINEBECK",
    "dropmalst": "NY",
    "dropmalzpp": 125729998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458769652,
    "dropsitcph": 8458769652,
    "dropfax": 8458763558
  },
  {
    "dcode": "D",
    "dropkey": "PV15679",
    "droptype": "D",
    "dropname": "RHINECLIFF",
    "dropdeladd": "15 SHATZELL AVE",
    "dropdelcty": "RHINECLIFF",
    "dropdelst": "NY",
    "dropdelzpp": 125749800,
    "dropphyadd": "15 SHATZELL AVE",
    "dropphycty": "RHINECLIFF",
    "dropphyst": "NY",
    "dropphyzpp": 125749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RHINECLIFF",
    "dropmalst": "NY",
    "dropmalzpp": 125749998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458764256,
    "dropsitcph": 8458764256,
    "dropfax": 8458764258
  },
  {
    "dcode": "D",
    "dropkey": "PV15682",
    "droptype": "D",
    "dropname": "RICHBURG",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "RICHBURG",
    "dropdelst": "NY",
    "dropdelzpp": 147749800,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "RICHBURG",
    "dropphyst": "NY",
    "dropphyzpp": 147749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHBURG",
    "dropmalst": "NY",
    "dropmalzpp": 147749998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5859282410,
    "dropsitcph": 5859282410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15684",
    "droptype": "D",
    "dropname": "RICHFIELD SPRINGS",
    "dropdeladd": "152 MAIN ST",
    "dropdelcty": "RICHFIELD SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 134399998,
    "dropphyadd": "152 MAIN ST",
    "dropphycty": "RICHFIELD SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 134399998,
    "dropmaladd": "152 MAIN ST",
    "dropmalcty": "RICHFIELD SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 134399998,
    "dropsitphn": 3158580150,
    "dropsitlph": 3158580150,
    "dropsitcph": 3158580150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15686",
    "droptype": "D",
    "dropname": "RICHFORD",
    "dropdeladd": "1007 STATE ROUTE 79",
    "dropdelcty": "RICHFORD",
    "dropdelst": "NY",
    "dropdelzpp": 138359997,
    "dropphyadd": "1007 STATE ROUTE 79",
    "dropphycty": "RICHFORD",
    "dropphyst": "NY",
    "dropphyzpp": 138359997,
    "dropmaladd": "1007 STATE ROUTE 79",
    "dropmalcty": "RICHFORD",
    "dropmalst": "NY",
    "dropmalzpp": 138359997,
    "dropsitphn": 6076578529,
    "dropsitlph": 6076578529,
    "dropsitcph": 6076578529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15687",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "1110 COUNTY ROUTE 48",
    "dropdelcty": "RICHLAND",
    "dropdelst": "NY",
    "dropdelzpp": 131449998,
    "dropphyadd": "1110 COUNTY ROUTE 48",
    "dropphycty": "RICHLAND",
    "dropphyst": "NY",
    "dropphyzpp": 131449998,
    "dropmaladd": "1110 COUNTY ROUTE 48",
    "dropmalcty": "RICHLAND",
    "dropmalst": "NY",
    "dropmalzpp": 131449998,
    "dropsitphn": 3152984541,
    "dropsitlph": 3152984541,
    "dropsitcph": 3152984541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15691",
    "droptype": "D",
    "dropname": "RICHMONDVILLE",
    "dropdeladd": "278 MAIN ST",
    "dropdelcty": "RICHMONDVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121499998,
    "dropphyadd": "278 MAIN ST",
    "dropphycty": "RICHMONDVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121499998,
    "dropmaladd": "278 MAIN ST",
    "dropmalcty": "RICHMONDVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121499998,
    "dropsitphn": 5182946665,
    "dropsitlph": 5184542229,
    "dropsitcph": 5182946665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15692",
    "droptype": "D",
    "dropname": "RICHVILLE",
    "dropdeladd": "160 MAIN ST",
    "dropdelcty": "RICHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 136819998,
    "dropphyadd": "160 MAIN ST",
    "dropphycty": "RICHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 136819998,
    "dropmaladd": "160 MAIN ST",
    "dropmalcty": "RICHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 136819998,
    "dropsitphn": 3152872780,
    "dropsitlph": 3152872780,
    "dropsitcph": 3152872780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15695",
    "droptype": "D",
    "dropname": "RIDGE",
    "dropdeladd": "1700 MIDDLE COUNTRY RD",
    "dropdelcty": "RIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 119612407,
    "dropphyadd": "1700 MIDDLE COUNTRY RD",
    "dropphycty": "RIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 119612407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 119619998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313456842,
    "dropfax": 6313456291
  },
  {
    "dcode": "D",
    "dropkey": "PV15702",
    "droptype": "D",
    "dropname": "RIFTON",
    "dropdeladd": "1822 MAIN ST",
    "dropdelcty": "RIFTON",
    "dropdelst": "NY",
    "dropdelzpp": 124719800,
    "dropphyadd": "1822 MAIN ST",
    "dropphycty": "RIFTON",
    "dropphyst": "NY",
    "dropphyzpp": 124719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIFTON",
    "dropmalst": "NY",
    "dropmalzpp": 124719998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456588010,
    "dropsitcph": 8456588010,
    "dropfax": 8456588010
  },
  {
    "dcode": "D",
    "dropkey": "PV15704",
    "droptype": "D",
    "dropname": "RIPARIUS",
    "dropdeladd": "465 RIVERSIDE STATION RD",
    "dropdelcty": "RIPARIUS",
    "dropdelst": "NY",
    "dropdelzpp": 128629998,
    "dropphyadd": "465 RIVERSIDE STATION RD",
    "dropphycty": "RIPARIUS",
    "dropphyst": "NY",
    "dropphyzpp": 128629998,
    "dropmaladd": "465 RIVERSIDE STATION RD",
    "dropmalcty": "RIPARIUS",
    "dropmalst": "NY",
    "dropmalzpp": 128629998,
    "dropsitphn": 5184942882,
    "dropsitlph": 5184942882,
    "dropsitcph": 5184942882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15705",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "7 W MAIN ST",
    "dropdelcty": "RIPLEY",
    "dropdelst": "NY",
    "dropdelzpp": 147759998,
    "dropphyadd": "7 W MAIN ST",
    "dropphycty": "RIPLEY",
    "dropphyst": "NY",
    "dropphyzpp": 147759998,
    "dropmaladd": "7 W MAIN ST",
    "dropmalcty": "RIPLEY",
    "dropmalst": "NY",
    "dropmalzpp": 147759998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167367065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15711",
    "droptype": "D",
    "dropname": "RIVERHEAD",
    "dropdeladd": "1210 W MAIN ST",
    "dropdelcty": "RIVERHEAD",
    "dropdelst": "NY",
    "dropdelzpp": 119013110,
    "dropphyadd": "1210 W MAIN ST",
    "dropphycty": "RIVERHEAD",
    "dropphyst": "NY",
    "dropphyzpp": 119013110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERHEAD",
    "dropmalst": "NY",
    "dropmalzpp": 119019998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317271019,
    "dropfax": 6312080951
  },
  {
    "dcode": "D",
    "dropkey": "PV15732",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "1335 JEFFERSON RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146929998,
    "dropphyadd": "1335 JEFFERSON RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146929998,
    "dropmaladd": "1335 JEFFERSON RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146929998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852725916,
    "dropsitcph": 5852725953,
    "dropfax": 5852725870
  },
  {
    "dcode": "D",
    "dropkey": "PV15735",
    "droptype": "D",
    "dropname": "ROCK CITY FALLS",
    "dropdeladd": "744 ROUTE 29 STE 1",
    "dropdelcty": "ROCK CITY FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 128639998,
    "dropphyadd": "744 ROUTE 29 STE 1",
    "dropphycty": "ROCK CITY FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 128639998,
    "dropmaladd": "744 ROUTE 29 STE 1",
    "dropmalcty": "ROCK CITY FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 128639998,
    "dropsitphn": 5188851544,
    "dropsitlph": 5188851544,
    "dropsitcph": 5188851544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15740",
    "droptype": "D",
    "dropname": "ROCK HILL",
    "dropdeladd": "240 ROCK HILL DR",
    "dropdelcty": "ROCK HILL",
    "dropdelst": "NY",
    "dropdelzpp": 127759998,
    "dropphyadd": "240 ROCK HILL DR",
    "dropphycty": "ROCK HILL",
    "dropphyst": "NY",
    "dropphyzpp": 127759998,
    "dropmaladd": "240 ROCK HILL DR",
    "dropmalcty": "ROCK HILL",
    "dropmalst": "NY",
    "dropmalzpp": 127759998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457964535,
    "dropsitcph": 8457964535,
    "dropfax": 8457964170
  },
  {
    "dcode": "D",
    "dropkey": "PV15742",
    "droptype": "D",
    "dropname": "ROCK STREAM",
    "dropdeladd": "278 ROCK STREAM RD",
    "dropdelcty": "ROCK STREAM",
    "dropdelst": "NY",
    "dropdelzpp": 148789998,
    "dropphyadd": "278 ROCK STREAM RD",
    "dropphycty": "ROCK STREAM",
    "dropphyst": "NY",
    "dropphyzpp": 148789998,
    "dropmaladd": "278 ROCK STREAM RD",
    "dropmalcty": "ROCK STREAM",
    "dropmalst": "NY",
    "dropmalzpp": 148789998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072435443,
    "dropsitcph": 6072435443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15743",
    "droptype": "D",
    "dropname": "ROCK TAVERN",
    "dropdeladd": "1964 LITTLE BRITAIN RD",
    "dropdelcty": "ROCK TAVERN",
    "dropdelst": "NY",
    "dropdelzpp": 125759998,
    "dropphyadd": "1964 LITTLE BRITAIN RD",
    "dropphycty": "ROCK TAVERN",
    "dropphyst": "NY",
    "dropphyzpp": 125759998,
    "dropmaladd": "1964 LITTLE BRITAIN RD",
    "dropmalcty": "ROCK TAVERN",
    "dropmalst": "NY",
    "dropmalzpp": 125759998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454964017,
    "dropsitcph": 8454964017,
    "dropfax": 8454967888
  },
  {
    "dcode": "D",
    "dropkey": "PV15763",
    "droptype": "D",
    "dropname": "ROCKVILLE CENTRE",
    "dropdeladd": "250 MERRICK RD",
    "dropdelcty": "ROCKVILLE CENTRE",
    "dropdelst": "NY",
    "dropdelzpp": 115705294,
    "dropphyadd": "250 MERRICK RD",
    "dropphycty": "ROCKVILLE CENTRE",
    "dropphyst": "NY",
    "dropphyzpp": 115705294,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKVILLE CENTRE",
    "dropmalst": "NY",
    "dropmalzpp": 115719998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167665749,
    "dropfax": 5167665845
  },
  {
    "dcode": "D",
    "dropkey": "PV15770",
    "droptype": "D",
    "dropname": "ROCKY POINT",
    "dropdeladd": "346 ROUTE 25A STE 84",
    "dropdelcty": "ROCKY POINT",
    "dropdelst": "NY",
    "dropdelzpp": 117788407,
    "dropphyadd": "346 ROUTE 25A STE 84",
    "dropphycty": "ROCKY POINT",
    "dropphyst": "NY",
    "dropphyzpp": 117788407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKY POINT",
    "dropmalst": "NY",
    "dropmalzpp": 117789998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317440635,
    "dropfax": 6317447693
  },
  {
    "dcode": "D",
    "dropkey": "PV15772",
    "droptype": "D",
    "dropname": "RODMAN",
    "dropdeladd": "12509 SCHOOL ST",
    "dropdelcty": "RODMAN",
    "dropdelst": "NY",
    "dropdelzpp": 136829998,
    "dropphyadd": "12509 SCHOOL ST",
    "dropphycty": "RODMAN",
    "dropphyst": "NY",
    "dropphyzpp": 136829998,
    "dropmaladd": "12509 SCHOOL ST",
    "dropmalcty": "RODMAN",
    "dropmalst": "NY",
    "dropmalzpp": 136829998,
    "dropsitphn": 3152324451,
    "dropsitlph": 3152324451,
    "dropsitcph": 3152324451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15777",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "110 E GARDEN ST",
    "dropdelcty": "ROME",
    "dropdelst": "NY",
    "dropdelzpp": 134409998,
    "dropphyadd": "110 E GARDEN ST",
    "dropphycty": "ROME",
    "dropphyst": "NY",
    "dropphyzpp": 134409998,
    "dropmaladd": "110 E GARDEN ST",
    "dropmalcty": "ROME",
    "dropmalst": "NY",
    "dropmalzpp": 134409998,
    "dropsitphn": 3153361500,
    "dropsitlph": 3153361500,
    "dropsitcph": 3153361500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15778",
    "droptype": "D",
    "dropname": "ROMULUS",
    "dropdeladd": "1969 SENECA ST",
    "dropdelcty": "ROMULUS",
    "dropdelst": "NY",
    "dropdelzpp": 145419998,
    "dropphyadd": "1969 SENECA ST",
    "dropphycty": "ROMULUS",
    "dropphyst": "NY",
    "dropphyzpp": 145419998,
    "dropmaladd": "1969 SENECA ST",
    "dropmalcty": "ROMULUS",
    "dropmalst": "NY",
    "dropmalzpp": 145419998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6078699495,
    "dropsitcph": 6078699495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15780",
    "droptype": "D",
    "dropname": "RONKONKOMA",
    "dropdeladd": "200 HAWKINS AVE",
    "dropdelcty": "RONKONKOMA",
    "dropdelst": "NY",
    "dropdelzpp": 117794286,
    "dropphyadd": "200 HAWKINS AVE",
    "dropphycty": "RONKONKOMA",
    "dropphyst": "NY",
    "dropphyzpp": 117794286,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RONKONKOMA",
    "dropmalst": "NY",
    "dropmalzpp": 117799998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315880301,
    "dropfax": 6314711290
  },
  {
    "dcode": "D",
    "dropkey": "PV15782",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "1 BABYLON TPKE",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "NY",
    "dropdelzpp": 115752178,
    "dropphyadd": "1 BABYLON TPKE",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "NY",
    "dropphyzpp": 115752178,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "NY",
    "dropmalzpp": 115759998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163786973,
    "dropfax": 5163786785
  },
  {
    "dcode": "D",
    "dropkey": "PV15786",
    "droptype": "D",
    "dropname": "ROOSEVELTOWN",
    "dropdeladd": "3 COUNTY ROUTE 45",
    "dropdelcty": "ROOSEVELTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 136839998,
    "dropphyadd": "3 COUNTY ROUTE 45",
    "dropphycty": "ROOSEVELTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 136839998,
    "dropmaladd": "3 COUNTY ROUTE 45",
    "dropmalcty": "ROOSEVELTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 136839998,
    "dropsitphn": 3157699241,
    "dropsitlph": 3157699241,
    "dropsitcph": 3157699241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15789",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "2 MAPLE ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "NY",
    "dropdelzpp": 127769998,
    "dropphyadd": "2 MAPLE ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "NY",
    "dropphyzpp": 127769998,
    "dropmaladd": "2 MAPLE ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "NY",
    "dropmalzpp": 127769998,
    "dropsitphn": 9146974123,
    "dropsitlph": 6074985279,
    "dropsitcph": 6074985279,
    "dropfax": 6074984785
  },
  {
    "dcode": "D",
    "dropkey": "PV15790",
    "droptype": "D",
    "dropname": "ROSE",
    "dropdeladd": "10660 WOLCOTT ST",
    "dropdelcty": "ROSE",
    "dropdelst": "NY",
    "dropdelzpp": 145429800,
    "dropphyadd": "10660 WOLCOTT ST",
    "dropphycty": "ROSE",
    "dropphyst": "NY",
    "dropphyzpp": 145429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSE",
    "dropmalst": "NY",
    "dropmalzpp": 145429998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155872192,
    "dropsitcph": 3155872192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15796",
    "droptype": "D",
    "dropname": "ROSENDALE",
    "dropdeladd": "354 MAIN ST",
    "dropdelcty": "ROSENDALE",
    "dropdelst": "NY",
    "dropdelzpp": 124729998,
    "dropphyadd": "354 MAIN ST",
    "dropphycty": "ROSENDALE",
    "dropphyst": "NY",
    "dropphyzpp": 124729998,
    "dropmaladd": "354 MAIN ST",
    "dropmalcty": "ROSENDALE",
    "dropmalst": "NY",
    "dropmalzpp": 124729998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456588084,
    "dropsitcph": 8456588084,
    "dropfax": 8456587149
  },
  {
    "dcode": "D",
    "dropkey": "PV15799",
    "droptype": "D",
    "dropname": "ROSLYN",
    "dropdeladd": "1391 OLD NORTHERN BLVD",
    "dropdelcty": "ROSLYN",
    "dropdelst": "NY",
    "dropdelzpp": 115762180,
    "dropphyadd": "1391 OLD NORTHERN BLVD",
    "dropphycty": "ROSLYN",
    "dropphyst": "NY",
    "dropphyzpp": 115762180,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSLYN",
    "dropmalst": "NY",
    "dropmalzpp": 115769998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166217397,
    "dropfax": 5166210028
  },
  {
    "dcode": "D",
    "dropkey": "PV15804",
    "droptype": "D",
    "dropname": "ROSLYN HEIGHTS",
    "dropdeladd": "66 MINEOLA AVE",
    "dropdelcty": "ROSLYN HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 115771093,
    "dropphyadd": "66 MINEOLA AVE",
    "dropphycty": "ROSLYN HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 115771093,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSLYN HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 115779998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166218050,
    "dropfax": 5166258654
  },
  {
    "dcode": "D",
    "dropkey": "PV15813",
    "droptype": "D",
    "dropname": "ROTTERDAM JUNCTION",
    "dropdeladd": "1206 MAIN ST",
    "dropdelcty": "ROTTERDAM JUNCTION",
    "dropdelst": "NY",
    "dropdelzpp": 121509998,
    "dropphyadd": "1206 MAIN ST",
    "dropphycty": "ROTTERDAM JUNCTION",
    "dropphyst": "NY",
    "dropphyzpp": 121509998,
    "dropmaladd": "1206 MAIN ST",
    "dropmalcty": "ROTTERDAM JUNCTION",
    "dropmalst": "NY",
    "dropmalzpp": 121509998,
    "dropsitphn": 5188872411,
    "dropsitlph": 5188872411,
    "dropsitcph": 5188872411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15814",
    "droptype": "D",
    "dropname": "ROUND LAKE",
    "dropdeladd": "49 BURLINGTON AVE",
    "dropdelcty": "ROUND LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 121519998,
    "dropphyadd": "49 BURLINGTON AVE",
    "dropphycty": "ROUND LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 121519998,
    "dropmaladd": "49 BURLINGTON AVE",
    "dropmalcty": "ROUND LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 121519998,
    "dropsitphn": 5188994350,
    "dropsitlph": 5188994350,
    "dropsitcph": 5188994350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15815",
    "droptype": "D",
    "dropname": "ROUND TOP",
    "dropdeladd": "38 ROUTE 39",
    "dropdelcty": "ROUND TOP",
    "dropdelst": "NY",
    "dropdelzpp": 124739998,
    "dropphyadd": "38 ROUTE 39",
    "dropphycty": "ROUND TOP",
    "dropphyst": "NY",
    "dropphyzpp": 124739998,
    "dropmaladd": "38 ROUTE 39",
    "dropmalcty": "ROUND TOP",
    "dropmalst": "NY",
    "dropmalzpp": 124739998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186229533,
    "dropsitcph": 5186229533,
    "dropfax": 5186229533
  },
  {
    "dcode": "D",
    "dropkey": "PV15816",
    "droptype": "D",
    "dropname": "ROUSES POINT",
    "dropdeladd": "9 CHAPMAN ST",
    "dropdelcty": "ROUSES POINT",
    "dropdelst": "NY",
    "dropdelzpp": 129799998,
    "dropphyadd": "9 CHAPMAN ST",
    "dropphycty": "ROUSES POINT",
    "dropphyst": "NY",
    "dropphyzpp": 129799998,
    "dropmaladd": "9 CHAPMAN ST",
    "dropmalcty": "ROUSES POINT",
    "dropmalst": "NY",
    "dropmalzpp": 129799998,
    "dropsitphn": 5182974231,
    "dropsitlph": 5182974231,
    "dropsitcph": 5182974231,
    "dropfax": 5182974231
  },
  {
    "dcode": "D",
    "dropkey": "PV15818",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "2375 COUNTY HIGHWAY 41",
    "dropdelcty": "ROXBURY",
    "dropdelst": "NY",
    "dropdelzpp": 124749998,
    "dropphyadd": "2375 COUNTY HIGHWAY 41",
    "dropphycty": "ROXBURY",
    "dropphyst": "NY",
    "dropphyzpp": 124749998,
    "dropmaladd": "2375 COUNTY HIGHWAY 41",
    "dropmalcty": "ROXBURY",
    "dropmalst": "NY",
    "dropmalzpp": 124749998,
    "dropsitphn": 6073260040,
    "dropsitlph": 6073260041,
    "dropsitcph": 6073260041,
    "dropfax": 6073260041
  },
  {
    "dcode": "D",
    "dropkey": "PV15820",
    "droptype": "D",
    "dropname": "RUBY",
    "dropdeladd": "1165 MAIN ST",
    "dropdelcty": "RUBY",
    "dropdelst": "NY",
    "dropdelzpp": 124759800,
    "dropphyadd": "1165 MAIN ST",
    "dropphycty": "RUBY",
    "dropphyst": "NY",
    "dropphyzpp": 124759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUBY",
    "dropmalst": "NY",
    "dropmalzpp": 124759998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453364486,
    "dropsitcph": 8453364486,
    "dropfax": 8453364486
  },
  {
    "dcode": "D",
    "dropkey": "PV15825",
    "droptype": "D",
    "dropname": "RUSH",
    "dropdeladd": "6144 RUSH LIMA RD",
    "dropdelcty": "RUSH",
    "dropdelst": "NY",
    "dropdelzpp": 145439998,
    "dropphyadd": "6144 RUSH LIMA RD",
    "dropphycty": "RUSH",
    "dropphyst": "NY",
    "dropphyzpp": 145439998,
    "dropmaladd": "6144 RUSH LIMA RD",
    "dropmalcty": "RUSH",
    "dropmalst": "NY",
    "dropmalzpp": 145439998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855331300,
    "dropsitcph": 5855331300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15826",
    "droptype": "D",
    "dropname": "RUSHFORD",
    "dropdeladd": "9019 MAIN ST",
    "dropdelcty": "RUSHFORD",
    "dropdelst": "NY",
    "dropdelzpp": 147779998,
    "dropphyadd": "9019 MAIN ST",
    "dropphycty": "RUSHFORD",
    "dropphyst": "NY",
    "dropphyzpp": 147779998,
    "dropmaladd": "9019 MAIN ST",
    "dropmalcty": "RUSHFORD",
    "dropmalst": "NY",
    "dropmalzpp": 147779998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854372675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15828",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "12 S MAIN ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145449998,
    "dropphyadd": "12 S MAIN ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145449998,
    "dropmaladd": "12 S MAIN ST",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145449998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855543600,
    "dropsitcph": 5855543600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15829",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "4 PESTLE ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "NY",
    "dropdelzpp": 136849998,
    "dropphyadd": "4 PESTLE ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "NY",
    "dropphyzpp": 136849998,
    "dropmaladd": "4 PESTLE ST",
    "dropmalcty": "RUSSELL",
    "dropmalst": "NY",
    "dropmalzpp": 136849998,
    "dropsitphn": 3153472340,
    "dropsitlph": 3153472340,
    "dropsitcph": 3153472340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15835",
    "droptype": "D",
    "dropname": "RYE",
    "dropdeladd": "41 PURDY AVE",
    "dropdelcty": "RYE",
    "dropdelst": "NY",
    "dropdelzpp": 105809998,
    "dropphyadd": "41 PURDY AVE",
    "dropphycty": "RYE",
    "dropphyst": "NY",
    "dropphyzpp": 105809998,
    "dropmaladd": "41 PURDY AVE",
    "dropmalcty": "RYE",
    "dropmalst": "NY",
    "dropmalzpp": 105809998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149676258,
    "dropsitcph": 9149676258,
    "dropfax": 9149673982
  },
  {
    "dcode": "D",
    "dropkey": "PV15883",
    "droptype": "D",
    "dropname": "SACKETS HARBOR",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "SACKETS HARBOR",
    "dropdelst": "NY",
    "dropdelzpp": 136859998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "SACKETS HARBOR",
    "dropphyst": "NY",
    "dropphyzpp": 136859998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "SACKETS HARBOR",
    "dropmalst": "NY",
    "dropmalzpp": 136859998,
    "dropsitphn": 3156462100,
    "dropsitlph": 3156462100,
    "dropsitcph": 3156462100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15888",
    "droptype": "D",
    "dropname": "SAG HARBOR",
    "dropdeladd": "21 LONG ISLAND AVE",
    "dropdelcty": "SAG HARBOR",
    "dropdelst": "NY",
    "dropdelzpp": 119633030,
    "dropphyadd": "21 LONG ISLAND AVE",
    "dropphycty": "SAG HARBOR",
    "dropphyst": "NY",
    "dropphyzpp": 119633030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAG HARBOR",
    "dropmalst": "NY",
    "dropmalzpp": 119639998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317258968,
    "dropfax": 6317257316
  },
  {
    "dcode": "D",
    "dropkey": "PV15890",
    "droptype": "D",
    "dropname": "SAGAPONACK",
    "dropdeladd": "127 HEDGES LN",
    "dropdelcty": "SAGAPONACK",
    "dropdelst": "NY",
    "dropdelzpp": 119622111,
    "dropphyadd": "127 HEDGES LN",
    "dropphycty": "SAGAPONACK",
    "dropphyst": "NY",
    "dropphyzpp": 119622111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAGAPONACK",
    "dropmalst": "NY",
    "dropmalzpp": 119629998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315379346,
    "dropfax": 6315376078
  },
  {
    "dcode": "D",
    "dropkey": "PV15894",
    "droptype": "D",
    "dropname": "SAINT BONAVENTURE",
    "dropdeladd": "3261 W STATE RD",
    "dropdelcty": "SAINT BONAVENTURE",
    "dropdelst": "NY",
    "dropdelzpp": 147789800,
    "dropphyadd": "3261 W STATE RD",
    "dropphycty": "SAINT BONAVENTURE",
    "dropphyst": "NY",
    "dropphyzpp": 147789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT BONAVENTURE",
    "dropmalst": "NY",
    "dropmalzpp": 147789998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163724110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15897",
    "droptype": "D",
    "dropname": "SAINT JAMES",
    "dropdeladd": "325 LAKE AVE",
    "dropdelcty": "SAINT JAMES",
    "dropdelst": "NY",
    "dropdelzpp": 117802280,
    "dropphyadd": "325 LAKE AVE",
    "dropphycty": "SAINT JAMES",
    "dropphyst": "NY",
    "dropphyzpp": 117802280,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT JAMES",
    "dropmalst": "NY",
    "dropmalzpp": 117809998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315844138,
    "dropfax": 6318620631
  },
  {
    "dcode": "D",
    "dropkey": "PV15900",
    "droptype": "D",
    "dropname": "SAINT JOHNSVILLE",
    "dropdeladd": "15 E MAIN ST",
    "dropdelcty": "SAINT JOHNSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134529998,
    "dropphyadd": "15 E MAIN ST",
    "dropphycty": "SAINT JOHNSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134529998,
    "dropmaladd": "15 E MAIN ST",
    "dropmalcty": "SAINT JOHNSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134529998,
    "dropsitphn": 5185687421,
    "dropsitlph": 5185687421,
    "dropsitcph": 5185687421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15901",
    "droptype": "D",
    "dropname": "SAINT REGIS FALLS",
    "dropdeladd": "25 N MAIN ST",
    "dropdelcty": "SAINT REGIS FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 129809998,
    "dropphyadd": "25 N MAIN ST",
    "dropphycty": "SAINT REGIS FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 129809998,
    "dropmaladd": "25 N MAIN ST",
    "dropmalcty": "SAINT REGIS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 129809998,
    "dropsitphn": 5188569440,
    "dropsitlph": 5188569440,
    "dropsitcph": 5188569440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15903",
    "droptype": "D",
    "dropname": "SALAMANCA",
    "dropdeladd": "35 CHESTNUT ST",
    "dropdelcty": "SALAMANCA",
    "dropdelst": "NY",
    "dropdelzpp": 147799998,
    "dropphyadd": "35 CHESTNUT ST",
    "dropphycty": "SALAMANCA",
    "dropphyst": "NY",
    "dropphyzpp": 147799998,
    "dropmaladd": "35 CHESTNUT ST",
    "dropmalcty": "SALAMANCA",
    "dropmalst": "NY",
    "dropmalzpp": 147799998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169453390,
    "dropfax": 7169458589
  },
  {
    "dcode": "D",
    "dropkey": "PV15904",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "12 W BROADWAY ST",
    "dropdelcty": "SALEM",
    "dropdelst": "NY",
    "dropdelzpp": 128659701,
    "dropphyadd": "12 W BROADWAY ST",
    "dropphycty": "SALEM",
    "dropphyst": "NY",
    "dropphyzpp": 128659701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALEM",
    "dropmalst": "NY",
    "dropmalzpp": 128659998,
    "dropsitphn": 5188543542,
    "dropsitlph": 5188543542,
    "dropsitcph": 5188543542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15911",
    "droptype": "D",
    "dropname": "SALISBURY CENTER",
    "dropdeladd": "181 STATE ROUTE 29A",
    "dropdelcty": "SALISBURY CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 134549998,
    "dropphyadd": "181 STATE ROUTE 29A",
    "dropphycty": "SALISBURY CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 134549998,
    "dropmaladd": "181 STATE ROUTE 29A",
    "dropmalcty": "SALISBURY CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 134549998,
    "dropsitphn": 3154293522,
    "dropsitlph": 3154293522,
    "dropsitcph": 3154293522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15913",
    "droptype": "D",
    "dropname": "SALISBURY MILLS",
    "dropdeladd": "2130 STATE ROUTE 94 STE 5",
    "dropdelcty": "SALISBURY MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 125779998,
    "dropphyadd": "2130 STATE ROUTE 94 STE 5",
    "dropphycty": "SALISBURY MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 125779998,
    "dropmaladd": "2130 STATE ROUTE 94 STE 5",
    "dropmalcty": "SALISBURY MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 125779998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454962969,
    "dropsitcph": 8454962969,
    "dropfax": 8454977201
  },
  {
    "dcode": "D",
    "dropkey": "PV15916",
    "droptype": "D",
    "dropname": "SALT POINT",
    "dropdeladd": "59 COTTAGE ST",
    "dropdelcty": "SALT POINT",
    "dropdelst": "NY",
    "dropdelzpp": 125789998,
    "dropphyadd": "59 COTTAGE ST",
    "dropphycty": "SALT POINT",
    "dropphyst": "NY",
    "dropphyzpp": 125789998,
    "dropmaladd": "59 COTTAGE ST",
    "dropmalcty": "SALT POINT",
    "dropmalst": "NY",
    "dropmalzpp": 125789998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452665986,
    "dropsitcph": 8452665986,
    "dropfax": 8452664752
  },
  {
    "dcode": "D",
    "dropkey": "PV15923",
    "droptype": "D",
    "dropname": "SANBORN",
    "dropdeladd": "2901 NIAGARA ST",
    "dropdelcty": "SANBORN",
    "dropdelst": "NY",
    "dropdelzpp": 141329899,
    "dropphyadd": "2901 NIAGARA ST",
    "dropphycty": "SANBORN",
    "dropphyst": "NY",
    "dropphyzpp": 141329899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANBORN",
    "dropmalst": "NY",
    "dropmalzpp": 141329998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167313414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15925",
    "droptype": "D",
    "dropname": "SAND LAKE",
    "dropdeladd": "8427 MILLER HILL RD",
    "dropdelcty": "SAND LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 121539998,
    "dropphyadd": "8427 MILLER HILL RD",
    "dropphycty": "SAND LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 121539998,
    "dropmaladd": "8427 MILLER HILL RD",
    "dropmalcty": "SAND LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 121539998,
    "dropsitphn": 5186743288,
    "dropsitlph": 5186743288,
    "dropsitcph": 5186743288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15930",
    "droptype": "D",
    "dropname": "SANDY CREEK",
    "dropdeladd": "6067 S MAIN ST",
    "dropdelcty": "SANDY CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 131459998,
    "dropphyadd": "6067 S MAIN ST",
    "dropphycty": "SANDY CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 131459998,
    "dropmaladd": "6067 S MAIN ST",
    "dropmalcty": "SANDY CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 131459998,
    "dropsitphn": 3153873198,
    "dropsitlph": 3153873198,
    "dropsitcph": 3153873198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15935",
    "droptype": "D",
    "dropname": "SANGERFIELD",
    "dropdeladd": "1084 STATE ROUTE 12",
    "dropdelcty": "SANGERFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 134559998,
    "dropphyadd": "1084 STATE ROUTE 12",
    "dropphycty": "SANGERFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 134559998,
    "dropmaladd": "1084 STATE ROUTE 12",
    "dropmalcty": "SANGERFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 134559998,
    "dropsitphn": 3158418482,
    "dropsitlph": 3158418482,
    "dropsitcph": 3158418482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15939",
    "droptype": "D",
    "dropname": "SARANAC",
    "dropdeladd": "3439 STATE ROUTE 3",
    "dropdelcty": "SARANAC",
    "dropdelst": "NY",
    "dropdelzpp": 129819998,
    "dropphyadd": "3439 STATE ROUTE 3",
    "dropphycty": "SARANAC",
    "dropphyst": "NY",
    "dropphyzpp": 129819998,
    "dropmaladd": "3439 STATE ROUTE 3",
    "dropmalcty": "SARANAC",
    "dropmalst": "NY",
    "dropmalzpp": 129819998,
    "dropsitphn": 5182937550,
    "dropsitlph": 5182937550,
    "dropsitcph": 5182937550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15940",
    "droptype": "D",
    "dropname": "SARANAC LAKE",
    "dropdeladd": "51 BROADWAY",
    "dropdelcty": "SARANAC LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 129839998,
    "dropphyadd": "51 BROADWAY",
    "dropphycty": "SARANAC LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 129839998,
    "dropmaladd": "51 BROADWAY",
    "dropmalcty": "SARANAC LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 129839998,
    "dropsitphn": 5188914390,
    "dropsitlph": 5188914390,
    "dropsitcph": 5188914390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15945",
    "droptype": "D",
    "dropname": "SARDINIA",
    "dropdeladd": "12310 SAVAGE RD",
    "dropdelcty": "SARDINIA",
    "dropdelst": "NY",
    "dropdelzpp": 141349998,
    "dropphyadd": "12310 SAVAGE RD",
    "dropphycty": "SARDINIA",
    "dropphyst": "NY",
    "dropphyzpp": 141349998,
    "dropmaladd": "12310 SAVAGE RD",
    "dropmalcty": "SARDINIA",
    "dropmalst": "NY",
    "dropmalzpp": 141349998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164968270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15946",
    "droptype": "D",
    "dropname": "SAUGERTIES",
    "dropdeladd": "111 MARKET ST",
    "dropdelcty": "SAUGERTIES",
    "dropdelst": "NY",
    "dropdelzpp": 124779998,
    "dropphyadd": "111 MARKET ST",
    "dropphycty": "SAUGERTIES",
    "dropphyst": "NY",
    "dropphyzpp": 124779998,
    "dropmaladd": "111 MARKET ST",
    "dropmalcty": "SAUGERTIES",
    "dropmalst": "NY",
    "dropmalzpp": 124779998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452461998,
    "dropsitcph": 8452461998,
    "dropfax": 8452465117
  },
  {
    "dcode": "D",
    "dropkey": "PV15947",
    "droptype": "D",
    "dropname": "SAUQUOIT",
    "dropdeladd": "2952 ONEIDA ST",
    "dropdelcty": "SAUQUOIT",
    "dropdelst": "NY",
    "dropdelzpp": 134569998,
    "dropphyadd": "2952 ONEIDA ST",
    "dropphycty": "SAUQUOIT",
    "dropphyst": "NY",
    "dropphyzpp": 134569998,
    "dropmaladd": "2952 ONEIDA ST",
    "dropmalcty": "SAUQUOIT",
    "dropmalst": "NY",
    "dropmalzpp": 134569998,
    "dropsitphn": 3157378832,
    "dropsitlph": 3157378832,
    "dropsitcph": 3157378832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15948",
    "droptype": "D",
    "dropname": "SAVANNAH",
    "dropdeladd": "1542 N MAIN ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "NY",
    "dropdelzpp": 131469998,
    "dropphyadd": "1542 N MAIN ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "NY",
    "dropphyzpp": 131469998,
    "dropmaladd": "1542 N MAIN ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "NY",
    "dropmalzpp": 131469998,
    "dropsitphn": 3153652687,
    "dropsitlph": 3153652687,
    "dropsitcph": 3153652687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15949",
    "droptype": "D",
    "dropname": "SAVONA",
    "dropdeladd": "47 MAIN ST",
    "dropdelcty": "SAVONA",
    "dropdelst": "NY",
    "dropdelzpp": 148799998,
    "dropphyadd": "47 MAIN ST",
    "dropphycty": "SAVONA",
    "dropphyst": "NY",
    "dropphyzpp": 148799998,
    "dropmaladd": "47 MAIN ST",
    "dropmalcty": "SAVONA",
    "dropmalst": "NY",
    "dropmalzpp": 148799998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075834450,
    "dropsitcph": 6075834450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15951",
    "droptype": "D",
    "dropname": "SAYVILLE",
    "dropdeladd": "130 GREENE AVE",
    "dropdelcty": "SAYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117822747,
    "dropphyadd": "130 GREENE AVE",
    "dropphycty": "SAYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117822747,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117829998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315896963,
    "dropfax": 6315894571
  },
  {
    "dcode": "D",
    "dropkey": "PV15954",
    "droptype": "D",
    "dropname": "SCARSDALE",
    "dropdeladd": "29 CHASE RD",
    "dropdelcty": "SCARSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 105839998,
    "dropphyadd": "29 CHASE RD",
    "dropphycty": "SCARSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 105839998,
    "dropmaladd": "29 CHASE RD",
    "dropmalcty": "SCARSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 105839998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147236481,
    "dropsitcph": 9147236481,
    "dropfax": 8457235172
  },
  {
    "dcode": "D",
    "dropkey": "PV15956",
    "droptype": "D",
    "dropname": "SCHAGHTICOKE",
    "dropdeladd": "172 MAIN ST",
    "dropdelcty": "SCHAGHTICOKE",
    "dropdelst": "NY",
    "dropdelzpp": 121549998,
    "dropphyadd": "172 MAIN ST",
    "dropphycty": "SCHAGHTICOKE",
    "dropphyst": "NY",
    "dropphyzpp": 121549998,
    "dropmaladd": "172 MAIN ST",
    "dropmalcty": "SCHAGHTICOKE",
    "dropmalst": "NY",
    "dropmalzpp": 121549998,
    "dropsitphn": 5187534149,
    "dropsitlph": 5187534149,
    "dropsitcph": 5187534149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15958",
    "droptype": "D",
    "dropname": "SCHENECTADY",
    "dropdeladd": "29 JAY ST",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123059998,
    "dropphyadd": "29 JAY ST",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123059998,
    "dropmaladd": "29 JAY ST",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123059998,
    "dropsitphn": 5183883118,
    "dropsitlph": 5183883118,
    "dropsitcph": 5183883118,
    "dropfax": 5183883184
  },
  {
    "dcode": "D",
    "dropkey": "PV15959",
    "droptype": "D",
    "dropname": "SCHENEVUS",
    "dropdeladd": "97 MAIN ST",
    "dropdelcty": "SCHENEVUS",
    "dropdelst": "NY",
    "dropdelzpp": 121559998,
    "dropphyadd": "97 MAIN ST",
    "dropphycty": "SCHENEVUS",
    "dropphyst": "NY",
    "dropphyzpp": 121559998,
    "dropmaladd": "97 MAIN ST",
    "dropmalcty": "SCHENEVUS",
    "dropmalst": "NY",
    "dropmalzpp": 121559998,
    "dropsitphn": 6076389362,
    "dropsitlph": 6076389362,
    "dropsitcph": 6076389362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15962",
    "droptype": "D",
    "dropname": "SCHODACK LANDING",
    "dropdeladd": "630 RIVER RD",
    "dropdelcty": "SCHODACK LANDING",
    "dropdelst": "NY",
    "dropdelzpp": 121569998,
    "dropphyadd": "630 RIVER RD",
    "dropphycty": "SCHODACK LANDING",
    "dropphyst": "NY",
    "dropphyzpp": 121569998,
    "dropmaladd": "630 RIVER RD",
    "dropmalcty": "SCHODACK LANDING",
    "dropmalst": "NY",
    "dropmalzpp": 121569998,
    "dropsitphn": 5187322017,
    "dropsitlph": 5187322017,
    "dropsitcph": 5187322017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15964",
    "droptype": "D",
    "dropname": "SCHOHARIE",
    "dropdeladd": "420 MAIN ST",
    "dropdelcty": "SCHOHARIE",
    "dropdelst": "NY",
    "dropdelzpp": 121579998,
    "dropphyadd": "420 MAIN ST",
    "dropphycty": "SCHOHARIE",
    "dropphyst": "NY",
    "dropphyzpp": 121579998,
    "dropmaladd": "420 MAIN ST",
    "dropmalcty": "SCHOHARIE",
    "dropmalst": "NY",
    "dropmalzpp": 121579998,
    "dropsitphn": 5182957245,
    "dropsitlph": 5182957245,
    "dropsitcph": 5182957245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15966",
    "droptype": "D",
    "dropname": "SCHROON LAKE",
    "dropdeladd": "1097 US ROUTE 9 STE 1",
    "dropdelcty": "SCHROON LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 128709998,
    "dropphyadd": "1097 US ROUTE 9 STE 1",
    "dropphycty": "SCHROON LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 128709998,
    "dropmaladd": "1097 US ROUTE 9 STE 1",
    "dropmalcty": "SCHROON LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 128709998,
    "dropsitphn": 5185327644,
    "dropsitlph": 5185327644,
    "dropsitcph": 5185327644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15969",
    "droptype": "D",
    "dropname": "SCHUYLER FALLS",
    "dropdeladd": "954 STATE ROUTE 22B",
    "dropdelcty": "SCHUYLER FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 129859998,
    "dropphyadd": "954 STATE ROUTE 22B",
    "dropphycty": "SCHUYLER FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 129859998,
    "dropmaladd": "954 STATE ROUTE 22B",
    "dropmalcty": "SCHUYLER FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 129859998,
    "dropsitphn": 5186436675,
    "dropsitlph": 5186436675,
    "dropsitcph": 5186436675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15971",
    "droptype": "D",
    "dropname": "SCHUYLER LAKE",
    "dropdeladd": "7367 STATE HIGHWAY 28",
    "dropdelcty": "SCHUYLER LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 134579800,
    "dropphyadd": "7367 STATE HIGHWAY 28",
    "dropphycty": "SCHUYLER LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 134579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHUYLER LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 134579998,
    "dropsitphn": 3158580390,
    "dropsitlph": 3158580390,
    "dropsitcph": 3158580390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15972",
    "droptype": "D",
    "dropname": "SCHUYLERVILLE",
    "dropdeladd": "25 FERRY ST",
    "dropdelcty": "SCHUYLERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 128719998,
    "dropphyadd": "25 FERRY ST",
    "dropphycty": "SCHUYLERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 128719998,
    "dropmaladd": "25 FERRY ST",
    "dropmalcty": "SCHUYLERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 128719998,
    "dropsitphn": 5186959221,
    "dropsitlph": 5186959221,
    "dropsitcph": 5186959221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15973",
    "droptype": "D",
    "dropname": "SCIO",
    "dropdeladd": "4422 W SCIOTA ST",
    "dropdelcty": "SCIO",
    "dropdelst": "NY",
    "dropdelzpp": 148809998,
    "dropphyadd": "4422 W SCIOTA ST",
    "dropphycty": "SCIO",
    "dropphyst": "NY",
    "dropphyzpp": 148809998,
    "dropmaladd": "4422 W SCIOTA ST",
    "dropmalcty": "SCIO",
    "dropmalst": "NY",
    "dropmalzpp": 148809998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855933017,
    "dropsitcph": 5855933017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15976",
    "droptype": "D",
    "dropname": "SCIPIO CENTER",
    "dropdeladd": "3354 STATE ROUTE 34",
    "dropdelcty": "SCIPIO CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 131479998,
    "dropphyadd": "3354 STATE ROUTE 34",
    "dropphycty": "SCIPIO CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 131479998,
    "dropmaladd": "3354 STATE ROUTE 34",
    "dropmalcty": "SCIPIO CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 131479998,
    "dropsitphn": 3153647234,
    "dropsitlph": 3153647234,
    "dropsitcph": 3153647234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15988",
    "droptype": "D",
    "dropname": "SCOTTSVILLE",
    "dropdeladd": "3 ROCHESTER ST",
    "dropdelcty": "SCOTTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145469998,
    "dropphyadd": "3 ROCHESTER ST",
    "dropphycty": "SCOTTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145469998,
    "dropmaladd": "3 ROCHESTER ST",
    "dropmalcty": "SCOTTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145469998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5858892040,
    "dropsitcph": 5858892040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV15994",
    "droptype": "D",
    "dropname": "SEA CLIFF",
    "dropdeladd": "200 SEA CLIFF AVE",
    "dropdelcty": "SEA CLIFF",
    "dropdelst": "NY",
    "dropdelzpp": 115791277,
    "dropphyadd": "200 SEA CLIFF AVE",
    "dropphycty": "SEA CLIFF",
    "dropphyst": "NY",
    "dropphyzpp": 115791277,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEA CLIFF",
    "dropmalst": "NY",
    "dropmalzpp": 115799998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166718258,
    "dropfax": 5166714073
  },
  {
    "dcode": "D",
    "dropkey": "PV15995",
    "droptype": "D",
    "dropname": "SEAFORD",
    "dropdeladd": "3575 MERRICK RD",
    "dropdelcty": "SEAFORD",
    "dropdelst": "NY",
    "dropdelzpp": 117832850,
    "dropphyadd": "3575 MERRICK RD",
    "dropphycty": "SEAFORD",
    "dropphyst": "NY",
    "dropphyzpp": 117832850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEAFORD",
    "dropmalst": "NY",
    "dropmalzpp": 117839998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167853851,
    "dropfax": 5167852423
  },
  {
    "dcode": "D",
    "dropkey": "PV16006",
    "droptype": "D",
    "dropname": "SELDEN",
    "dropdeladd": "109 COLLEGE PLZ",
    "dropdelcty": "SELDEN",
    "dropdelst": "NY",
    "dropdelzpp": 117844042,
    "dropphyadd": "109 COLLEGE PLZ",
    "dropphycty": "SELDEN",
    "dropphyst": "NY",
    "dropphyzpp": 117844042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELDEN",
    "dropmalst": "NY",
    "dropmalzpp": 117849998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317328627,
    "dropfax": 6316963272
  },
  {
    "dcode": "D",
    "dropkey": "PV16008",
    "droptype": "D",
    "dropname": "SELKIRK",
    "dropdeladd": "1155 US ROUTE 9W",
    "dropdelcty": "SELKIRK",
    "dropdelst": "NY",
    "dropdelzpp": 121589998,
    "dropphyadd": "1155 US ROUTE 9W",
    "dropphycty": "SELKIRK",
    "dropphyst": "NY",
    "dropphyzpp": 121589998,
    "dropmaladd": "1155 US ROUTE 9W",
    "dropmalcty": "SELKIRK",
    "dropmalst": "NY",
    "dropmalzpp": 121589998,
    "dropsitphn": 5187673308,
    "dropsitlph": 5187673308,
    "dropsitcph": 5187673308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16011",
    "droptype": "D",
    "dropname": "SENECA CASTLE",
    "dropdeladd": "2081 BUFFALO ST",
    "dropdelcty": "SENECA CASTLE",
    "dropdelst": "NY",
    "dropdelzpp": 145479800,
    "dropphyadd": "2081 BUFFALO ST",
    "dropphycty": "SENECA CASTLE",
    "dropphyst": "NY",
    "dropphyzpp": 145479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECA CASTLE",
    "dropmalst": "NY",
    "dropmalzpp": 145479998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855266886,
    "dropsitcph": 5855266886,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16012",
    "droptype": "D",
    "dropname": "SENECA FALLS",
    "dropdeladd": "38 STATE ST",
    "dropdelcty": "SENECA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 131489998,
    "dropphyadd": "38 STATE ST",
    "dropphycty": "SENECA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 131489998,
    "dropmaladd": "38 STATE ST",
    "dropmalcty": "SENECA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 131489998,
    "dropsitphn": 3155682908,
    "dropsitlph": 3155682908,
    "dropsitcph": 3155682908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16022",
    "droptype": "D",
    "dropname": "SEVERANCE",
    "dropdeladd": "229 NYS ROUTE 74",
    "dropdelcty": "SEVERANCE",
    "dropdelst": "NY",
    "dropdelzpp": 128729998,
    "dropphyadd": "229 NYS ROUTE 74",
    "dropphycty": "SEVERANCE",
    "dropphyst": "NY",
    "dropphyzpp": 128729998,
    "dropmaladd": "229 NYS ROUTE 74",
    "dropmalcty": "SEVERANCE",
    "dropmalst": "NY",
    "dropmalzpp": 128729998,
    "dropsitphn": 5185329901,
    "dropsitlph": 5185329901,
    "dropsitcph": 5185329901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16027",
    "droptype": "D",
    "dropname": "SHANDAKEN",
    "dropdeladd": "22 STATE ROUTE 42",
    "dropdelcty": "SHANDAKEN",
    "dropdelst": "NY",
    "dropdelzpp": 124809998,
    "dropphyadd": "22 STATE ROUTE 42",
    "dropphycty": "SHANDAKEN",
    "dropphyst": "NY",
    "dropphyzpp": 124809998,
    "dropmaladd": "22 STATE ROUTE 42",
    "dropmalcty": "SHANDAKEN",
    "dropmalst": "NY",
    "dropmalzpp": 124809998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456885220,
    "dropsitcph": 8456885220,
    "dropfax": 8456885220
  },
  {
    "dcode": "D",
    "dropkey": "PV16029",
    "droptype": "D",
    "dropname": "SHARON SPRINGS",
    "dropdeladd": "105 MAIN ST STE 2",
    "dropdelcty": "SHARON SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 134599998,
    "dropphyadd": "105 MAIN ST STE 2",
    "dropphycty": "SHARON SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 134599998,
    "dropmaladd": "105 MAIN ST STE 2",
    "dropmalcty": "SHARON SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 134599998,
    "dropsitphn": 5182842301,
    "dropsitlph": 5182842301,
    "dropsitcph": 5182842301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16038",
    "droptype": "D",
    "dropname": "SHELTER ISLAND",
    "dropdeladd": "45 N FERRY RD",
    "dropdelcty": "SHELTER ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 119649700,
    "dropphyadd": "45 N FERRY RD",
    "dropphycty": "SHELTER ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 119649700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELTER ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 119649998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317491857,
    "dropfax": 6317490163
  },
  {
    "dcode": "D",
    "dropkey": "PV16039",
    "droptype": "D",
    "dropname": "SHELTER ISLAND HEIGHTS",
    "dropdeladd": "6 GRAND AVE",
    "dropdelcty": "SHELTER ISLAND HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 119659700,
    "dropphyadd": "6 GRAND AVE",
    "dropphycty": "SHELTER ISLAND HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 119659700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELTER ISLAND HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 119659998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317490486,
    "dropfax": 6317490158
  },
  {
    "dcode": "D",
    "dropkey": "PV16042",
    "droptype": "D",
    "dropname": "SHENOROCK",
    "dropdeladd": "18 TIGHE RD",
    "dropdelcty": "SHENOROCK",
    "dropdelst": "NY",
    "dropdelzpp": 105879800,
    "dropphyadd": "18 TIGHE RD",
    "dropphycty": "SHENOROCK",
    "dropphyst": "NY",
    "dropphyzpp": 105879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHENOROCK",
    "dropmalst": "NY",
    "dropmalzpp": 105879998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142487533,
    "dropsitcph": 9142487533,
    "dropfax": 9142487533
  },
  {
    "dcode": "D",
    "dropkey": "PV16043",
    "droptype": "D",
    "dropname": "SHERBURNE",
    "dropdeladd": "4 W STATE ST",
    "dropdelcty": "SHERBURNE",
    "dropdelst": "NY",
    "dropdelzpp": 134609998,
    "dropphyadd": "4 W STATE ST",
    "dropphycty": "SHERBURNE",
    "dropphyst": "NY",
    "dropphyzpp": 134609998,
    "dropmaladd": "4 W STATE ST",
    "dropmalcty": "SHERBURNE",
    "dropmalst": "NY",
    "dropmalzpp": 134609998,
    "dropsitphn": 6076742761,
    "dropsitlph": 6076742761,
    "dropsitcph": 6076742761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16044",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "2707 MAIN RD",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "NY",
    "dropdelzpp": 141359800,
    "dropphyadd": "2707 MAIN RD",
    "dropphycty": "SHERIDAN",
    "dropphyst": "NY",
    "dropphyzpp": 141359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "NY",
    "dropmalzpp": 141359998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166724131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16045",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "109 MILLER ST",
    "dropdelcty": "SHERMAN",
    "dropdelst": "NY",
    "dropdelzpp": 147819899,
    "dropphyadd": "109 MILLER ST",
    "dropphycty": "SHERMAN",
    "dropphyst": "NY",
    "dropphyzpp": 147819899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERMAN",
    "dropmalst": "NY",
    "dropmalzpp": 147819998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167616588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16047",
    "droptype": "D",
    "dropname": "SHERRILL",
    "dropdeladd": "510 SHERRILL RD",
    "dropdelcty": "SHERRILL",
    "dropdelst": "NY",
    "dropdelzpp": 134619998,
    "dropphyadd": "510 SHERRILL RD",
    "dropphycty": "SHERRILL",
    "dropphyst": "NY",
    "dropphyzpp": 134619998,
    "dropmaladd": "510 SHERRILL RD",
    "dropmalcty": "SHERRILL",
    "dropmalst": "NY",
    "dropmalzpp": 134619998,
    "dropsitphn": 3153632670,
    "dropsitlph": 3153632670,
    "dropsitcph": 3153632670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16051",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "800 MONTAUK HWY STE 1",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "NY",
    "dropdelzpp": 119672140,
    "dropphyadd": "800 MONTAUK HWY STE 1",
    "dropphycty": "SHIRLEY",
    "dropphyst": "NY",
    "dropphyzpp": 119672140,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "NY",
    "dropmalzpp": 119679998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312810479,
    "dropfax": 6313995277
  },
  {
    "dcode": "D",
    "dropkey": "PV16053",
    "droptype": "D",
    "dropname": "SHOKAN",
    "dropdeladd": "3110 STATE ROUTE 28",
    "dropdelcty": "SHOKAN",
    "dropdelst": "NY",
    "dropdelzpp": 124819998,
    "dropphyadd": "3110 STATE ROUTE 28",
    "dropphycty": "SHOKAN",
    "dropphyst": "NY",
    "dropphyzpp": 124819998,
    "dropmaladd": "3110 STATE ROUTE 28",
    "dropmalcty": "SHOKAN",
    "dropmalst": "NY",
    "dropmalzpp": 124819998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456577326,
    "dropsitcph": 8456577326,
    "dropfax": 8456578298
  },
  {
    "dcode": "D",
    "dropkey": "PV16055",
    "droptype": "D",
    "dropname": "SHOREHAM",
    "dropdeladd": "69 ROUTE 25A",
    "dropdelcty": "SHOREHAM",
    "dropdelst": "NY",
    "dropdelzpp": 117861844,
    "dropphyadd": "69 ROUTE 25A",
    "dropphycty": "SHOREHAM",
    "dropphyst": "NY",
    "dropphyzpp": 117861844,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHOREHAM",
    "dropmalst": "NY",
    "dropmalzpp": 117869998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317443185,
    "dropfax": 6317448854
  },
  {
    "dcode": "D",
    "dropkey": "PV16058",
    "droptype": "D",
    "dropname": "SHORTSVILLE",
    "dropdeladd": "2 SHELDON ST",
    "dropdelcty": "SHORTSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 145489998,
    "dropphyadd": "2 SHELDON ST",
    "dropphycty": "SHORTSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 145489998,
    "dropmaladd": "2 SHELDON ST",
    "dropmalcty": "SHORTSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 145489998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852896073,
    "dropsitcph": 5852896073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16059",
    "droptype": "D",
    "dropname": "SHRUB OAK",
    "dropdeladd": "1350 E MAIN ST",
    "dropdelcty": "SHRUB OAK",
    "dropdelst": "NY",
    "dropdelzpp": 105889998,
    "dropphyadd": "1350 E MAIN ST",
    "dropphycty": "SHRUB OAK",
    "dropphyst": "NY",
    "dropphyzpp": 105889998,
    "dropmaladd": "1350 E MAIN ST",
    "dropmalcty": "SHRUB OAK",
    "dropmalst": "NY",
    "dropmalzpp": 105889998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145289274,
    "dropsitcph": 9145289274,
    "dropfax": 9145282925
  },
  {
    "dcode": "D",
    "dropkey": "PV16060",
    "droptype": "D",
    "dropname": "SHUSHAN",
    "dropdeladd": "738 COUNTY ROUTE 64",
    "dropdelcty": "SHUSHAN",
    "dropdelst": "NY",
    "dropdelzpp": 128739998,
    "dropphyadd": "738 COUNTY ROUTE 64",
    "dropphycty": "SHUSHAN",
    "dropphyst": "NY",
    "dropphyzpp": 128739998,
    "dropmaladd": "738 COUNTY ROUTE 64",
    "dropmalcty": "SHUSHAN",
    "dropmalst": "NY",
    "dropmalzpp": 128739998,
    "dropsitphn": 5185524172,
    "dropsitlph": 5185524172,
    "dropsitcph": 5185524172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16061",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "6 MANG DR",
    "dropdelcty": "SIDNEY",
    "dropdelst": "NY",
    "dropdelzpp": 138389998,
    "dropphyadd": "6 MANG DR",
    "dropphycty": "SIDNEY",
    "dropphyst": "NY",
    "dropphyzpp": 138389998,
    "dropmaladd": "6 MANG DR",
    "dropmalcty": "SIDNEY",
    "dropmalst": "NY",
    "dropmalzpp": 138389998,
    "dropsitphn": 6075633131,
    "dropsitlph": 6075633131,
    "dropsitcph": 6075633131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16062",
    "droptype": "D",
    "dropname": "SIDNEY CENTER",
    "dropdeladd": "10445 COUNTY HIGHWAY 23",
    "dropdelcty": "SIDNEY CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 138399998,
    "dropphyadd": "10445 COUNTY HIGHWAY 23",
    "dropphycty": "SIDNEY CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 138399998,
    "dropmaladd": "10445 COUNTY HIGHWAY 23",
    "dropmalcty": "SIDNEY CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 138399998,
    "dropsitphn": 6073697577,
    "dropsitlph": 6073697577,
    "dropsitcph": 6073697577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16066",
    "droptype": "D",
    "dropname": "SILVER BAY",
    "dropdeladd": "8461 LAKESHORE DR",
    "dropdelcty": "SILVER BAY",
    "dropdelst": "NY",
    "dropdelzpp": 128742015,
    "dropphyadd": "8461 LAKESHORE DR",
    "dropphycty": "SILVER BAY",
    "dropphyst": "NY",
    "dropphyzpp": 128742015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER BAY",
    "dropmalst": "NY",
    "dropmalzpp": 128749998,
    "dropsitphn": 5185436613,
    "dropsitlph": 5185436613,
    "dropsitcph": 5185436613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16068",
    "droptype": "D",
    "dropname": "SILVER CREEK",
    "dropdeladd": "37 MAIN ST",
    "dropdelcty": "SILVER CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 141369998,
    "dropphyadd": "37 MAIN ST",
    "dropphycty": "SILVER CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 141369998,
    "dropmaladd": "37 MAIN ST",
    "dropmalcty": "SILVER CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 141369998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169343427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16071",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "36 PERRY AVE",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 145499800,
    "dropphyadd": "36 PERRY AVE",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 145499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 145499998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852375510,
    "dropsitcph": 5852375510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16074",
    "droptype": "D",
    "dropname": "SILVER SPRINGS",
    "dropdeladd": "37 N MAIN ST",
    "dropdelcty": "SILVER SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 145509998,
    "dropphyadd": "37 N MAIN ST",
    "dropphycty": "SILVER SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 145509998,
    "dropmaladd": "37 N MAIN ST",
    "dropmalcty": "SILVER SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 145509998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854932108,
    "dropsitcph": 5854932108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16076",
    "droptype": "D",
    "dropname": "SINCLAIRVILLE",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "SINCLAIRVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147829998,
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "SINCLAIRVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147829998,
    "dropmaladd": "11 MAIN ST",
    "dropmalcty": "SINCLAIRVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147829998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169629005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16082",
    "droptype": "D",
    "dropname": "SKANEATELES",
    "dropdeladd": "20 FENNELL ST",
    "dropdelcty": "SKANEATELES",
    "dropdelst": "NY",
    "dropdelzpp": 131529998,
    "dropphyadd": "20 FENNELL ST",
    "dropphycty": "SKANEATELES",
    "dropphyst": "NY",
    "dropphyzpp": 131529998,
    "dropmaladd": "20 FENNELL ST",
    "dropmalcty": "SKANEATELES",
    "dropmalst": "NY",
    "dropmalzpp": 131529998,
    "dropsitphn": 3156856189,
    "dropsitlph": 3156856189,
    "dropsitcph": 3156856189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16083",
    "droptype": "D",
    "dropname": "SKANEATELES FALLS",
    "dropdeladd": "4564 JORDAN RD",
    "dropdelcty": "SKANEATELES FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 131539998,
    "dropphyadd": "4564 JORDAN RD",
    "dropphycty": "SKANEATELES FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 131539998,
    "dropmaladd": "4564 JORDAN RD",
    "dropmalcty": "SKANEATELES FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 131539998,
    "dropsitphn": 3156857598,
    "dropsitlph": 3156857598,
    "dropsitcph": 3156857598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16087",
    "droptype": "D",
    "dropname": "SLATE HILL",
    "dropdeladd": "1990 ROUTE 284",
    "dropdelcty": "SLATE HILL",
    "dropdelst": "NY",
    "dropdelzpp": 109739998,
    "dropphyadd": "1990 ROUTE 284",
    "dropphycty": "SLATE HILL",
    "dropphyst": "NY",
    "dropphyzpp": 109739998,
    "dropmaladd": "1990 ROUTE 284",
    "dropmalcty": "SLATE HILL",
    "dropmalst": "NY",
    "dropmalzpp": 109739998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453554741,
    "dropsitcph": 8453554741,
    "dropfax": 8453552008
  },
  {
    "dcode": "D",
    "dropkey": "PV16088",
    "droptype": "D",
    "dropname": "SLATERVILLE SPRINGS",
    "dropdeladd": "2706 SLATERVILLE RD",
    "dropdelcty": "SLATERVILLE SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 148819998,
    "dropphyadd": "2706 SLATERVILLE RD",
    "dropphycty": "SLATERVILLE SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 148819998,
    "dropmaladd": "2706 SLATERVILLE RD",
    "dropmalcty": "SLATERVILLE SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 148819998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075397005,
    "dropsitcph": 6075397005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16091",
    "droptype": "D",
    "dropname": "SLINGERLANDS",
    "dropdeladd": "1399 NEW SCOTLAND RD",
    "dropdelcty": "SLINGERLANDS",
    "dropdelst": "NY",
    "dropdelzpp": 121599997,
    "dropphyadd": "1399 NEW SCOTLAND RD",
    "dropphycty": "SLINGERLANDS",
    "dropphyst": "NY",
    "dropphyzpp": 121599997,
    "dropmaladd": "1399 NEW SCOTLAND RD",
    "dropmalcty": "SLINGERLANDS",
    "dropmalst": "NY",
    "dropmalzpp": 121599997,
    "dropsitphn": 5184395371,
    "dropsitlph": 5184395371,
    "dropsitcph": 5184395371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16093",
    "droptype": "D",
    "dropname": "SLOANSVILLE",
    "dropdeladd": "766 SADDLEMIRE HILL RD",
    "dropdelcty": "SLOANSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121609998,
    "dropphyadd": "766 SADDLEMIRE HILL RD",
    "dropphycty": "SLOANSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121609998,
    "dropmaladd": "766 SADDLEMIRE HILL RD",
    "dropmalcty": "SLOANSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121609998,
    "dropsitphn": 5188684876,
    "dropsitlph": 5188684876,
    "dropsitcph": 5188684876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16094",
    "droptype": "D",
    "dropname": "SLOATSBURG",
    "dropdeladd": "39 ORANGE TPKE",
    "dropdelcty": "SLOATSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 109749998,
    "dropphyadd": "39 ORANGE TPKE",
    "dropphycty": "SLOATSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 109749998,
    "dropmaladd": "39 ORANGE TPKE",
    "dropmalcty": "SLOATSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 109749998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457538431,
    "dropsitcph": 8457538431,
    "dropfax": 8457535801
  },
  {
    "dcode": "D",
    "dropkey": "PV16095",
    "droptype": "D",
    "dropname": "SMALLWOOD",
    "dropdeladd": "220 PINE GROVE RD",
    "dropdelcty": "SMALLWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 127789800,
    "dropphyadd": "220 PINE GROVE RD",
    "dropphycty": "SMALLWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 127789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMALLWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 127789998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455835840,
    "dropsitcph": 8455835840,
    "dropfax": 8455835840
  },
  {
    "dcode": "D",
    "dropkey": "PV16107",
    "droptype": "D",
    "dropname": "SMITHTOWN",
    "dropdeladd": "25 ROUTE 111",
    "dropdelcty": "SMITHTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 117873743,
    "dropphyadd": "25 ROUTE 111",
    "dropphycty": "SMITHTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 117873743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 117879998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313606709,
    "dropfax": 6313600532
  },
  {
    "dcode": "D",
    "dropkey": "PV16113",
    "droptype": "D",
    "dropname": "SMITHVILLE FLATS",
    "dropdeladd": "5299 STATE HIGHWAY 41",
    "dropdelcty": "SMITHVILLE FLATS",
    "dropdelst": "NY",
    "dropdelzpp": 138419998,
    "dropphyadd": "5299 STATE HIGHWAY 41",
    "dropphycty": "SMITHVILLE FLATS",
    "dropphyst": "NY",
    "dropphyzpp": 138419998,
    "dropmaladd": "5299 STATE HIGHWAY 41",
    "dropmalcty": "SMITHVILLE FLATS",
    "dropmalst": "NY",
    "dropmalzpp": 138419998,
    "dropsitphn": 6076564968,
    "dropsitlph": 6076564968,
    "dropsitcph": 6076564968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16118",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "9 W MAIN ST",
    "dropdelcty": "SMYRNA",
    "dropdelst": "NY",
    "dropdelzpp": 134649998,
    "dropphyadd": "9 W MAIN ST",
    "dropphycty": "SMYRNA",
    "dropphyst": "NY",
    "dropphyzpp": 134649998,
    "dropmaladd": "9 W MAIN ST",
    "dropmalcty": "SMYRNA",
    "dropmalst": "NY",
    "dropmalzpp": 134649998,
    "dropsitphn": 6076276200,
    "dropsitlph": 6076276200,
    "dropsitcph": 6076276200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16141",
    "droptype": "D",
    "dropname": "SODUS",
    "dropdeladd": "44 W MAIN ST",
    "dropdelcty": "SODUS",
    "dropdelst": "NY",
    "dropdelzpp": 145519998,
    "dropphyadd": "44 W MAIN ST",
    "dropphycty": "SODUS",
    "dropphyst": "NY",
    "dropphyzpp": 145519998,
    "dropmaladd": "44 W MAIN ST",
    "dropmalcty": "SODUS",
    "dropmalst": "NY",
    "dropmalzpp": 145519998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3154839180,
    "dropsitcph": 3154839180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16144",
    "droptype": "D",
    "dropname": "SODUS POINT",
    "dropdeladd": "8432 BAY ST",
    "dropdelcty": "SODUS POINT",
    "dropdelst": "NY",
    "dropdelzpp": 145559998,
    "dropphyadd": "8432 BAY ST",
    "dropphycty": "SODUS POINT",
    "dropphyst": "NY",
    "dropphyzpp": 145559998,
    "dropmaladd": "8432 BAY ST",
    "dropmalcty": "SODUS POINT",
    "dropmalst": "NY",
    "dropmalzpp": 145559998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3154834335,
    "dropsitcph": 3154834335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16149",
    "droptype": "D",
    "dropname": "SOMERS",
    "dropdeladd": "110 MARKET PLZ",
    "dropdelcty": "SOMERS",
    "dropdelst": "NY",
    "dropdelzpp": 105899998,
    "dropphyadd": "110 MARKET PLZ",
    "dropphycty": "SOMERS",
    "dropphyst": "NY",
    "dropphyzpp": 105899998,
    "dropmaladd": "110 MARKET PLZ",
    "dropmalcty": "SOMERS",
    "dropmalst": "NY",
    "dropmalzpp": 105899998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9142760631,
    "dropsitcph": 9142760631,
    "dropfax": 9142761384
  },
  {
    "dcode": "D",
    "dropkey": "PV16152",
    "droptype": "D",
    "dropname": "SONYEA",
    "dropdeladd": "56 PORTER DR",
    "dropdelcty": "SONYEA",
    "dropdelst": "NY",
    "dropdelzpp": 145569800,
    "dropphyadd": "56 PORTER DR",
    "dropphycty": "SONYEA",
    "dropphyst": "NY",
    "dropphyzpp": 145569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SONYEA",
    "dropmalst": "NY",
    "dropmalzpp": 145569998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856583403,
    "dropsitcph": 5856583403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16154",
    "droptype": "D",
    "dropname": "SOUND BEACH",
    "dropdeladd": "25 NEW YORK AVE",
    "dropdelcty": "SOUND BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 117892559,
    "dropphyadd": "25 NEW YORK AVE",
    "dropphycty": "SOUND BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 117892559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUND BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 117899998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317440837,
    "dropfax": 6317443952
  },
  {
    "dcode": "D",
    "dropkey": "PV16166",
    "droptype": "D",
    "dropname": "SOUTH BETHLEHEM",
    "dropdeladd": "541 BRIDGE ST",
    "dropdelcty": "SOUTH BETHLEHEM",
    "dropdelst": "NY",
    "dropdelzpp": 121619998,
    "dropphyadd": "541 BRIDGE ST",
    "dropphycty": "SOUTH BETHLEHEM",
    "dropphyst": "NY",
    "dropphyzpp": 121619998,
    "dropmaladd": "541 BRIDGE ST",
    "dropmalcty": "SOUTH BETHLEHEM",
    "dropmalst": "NY",
    "dropmalzpp": 121619998,
    "dropsitphn": 5187673054,
    "dropsitlph": 5187673054,
    "dropsitcph": 5187673054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16170",
    "droptype": "D",
    "dropname": "SOUTH BUTLER",
    "dropdeladd": "3453 STATE ROUTE 89",
    "dropdelcty": "SOUTH BUTLER",
    "dropdelst": "NY",
    "dropdelzpp": 131549998,
    "dropphyadd": "3453 STATE ROUTE 89",
    "dropphycty": "SOUTH BUTLER",
    "dropphyst": "NY",
    "dropphyzpp": 131549998,
    "dropmaladd": "3453 STATE ROUTE 89",
    "dropmalcty": "SOUTH BUTLER",
    "dropmalst": "NY",
    "dropmalzpp": 131549998,
    "dropsitphn": 3153653401,
    "dropsitlph": 3153653401,
    "dropsitcph": 3153653401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16171",
    "droptype": "D",
    "dropname": "SOUTH BYRON",
    "dropdeladd": "7545 ROUTE 237",
    "dropdelcty": "SOUTH BYRON",
    "dropdelst": "NY",
    "dropdelzpp": 145579800,
    "dropphyadd": "7545 ROUTE 237",
    "dropphycty": "SOUTH BYRON",
    "dropphyst": "NY",
    "dropphyzpp": 145579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BYRON",
    "dropmalst": "NY",
    "dropmalzpp": 145579998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855487302,
    "dropsitcph": 5855487302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16172",
    "droptype": "D",
    "dropname": "SOUTH CAIRO",
    "dropdeladd": "2395 ROUTE 23B",
    "dropdelcty": "SOUTH CAIRO",
    "dropdelst": "NY",
    "dropdelzpp": 124829998,
    "dropphyadd": "2395 ROUTE 23B",
    "dropphycty": "SOUTH CAIRO",
    "dropphyst": "NY",
    "dropphyzpp": 124829998,
    "dropmaladd": "2395 ROUTE 23B",
    "dropmalcty": "SOUTH CAIRO",
    "dropmalst": "NY",
    "dropmalzpp": 124829998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5186223909,
    "dropsitcph": 5186223909,
    "dropfax": 5186223909
  },
  {
    "dcode": "D",
    "dropkey": "PV16174",
    "droptype": "D",
    "dropname": "SOUTH COLTON",
    "dropdeladd": "3935 STATE HIGHWAY 56",
    "dropdelcty": "SOUTH COLTON",
    "dropdelst": "NY",
    "dropdelzpp": 136879998,
    "dropphyadd": "3935 STATE HIGHWAY 56",
    "dropphycty": "SOUTH COLTON",
    "dropphyst": "NY",
    "dropphyzpp": 136879998,
    "dropmaladd": "3935 STATE HIGHWAY 56",
    "dropmalcty": "SOUTH COLTON",
    "dropmalst": "NY",
    "dropmalzpp": 136879998,
    "dropsitphn": 3152622887,
    "dropsitlph": 3152622887,
    "dropsitcph": 3152622887,
    "dropfax": 3152622220
  },
  {
    "dcode": "D",
    "dropkey": "PV16177",
    "droptype": "D",
    "dropname": "SOUTH DAYTON",
    "dropdeladd": "5 PARK ST",
    "dropdelcty": "SOUTH DAYTON",
    "dropdelst": "NY",
    "dropdelzpp": 141389998,
    "dropphyadd": "5 PARK ST",
    "dropphycty": "SOUTH DAYTON",
    "dropphyst": "NY",
    "dropphyzpp": 141389998,
    "dropmaladd": "5 PARK ST",
    "dropmalcty": "SOUTH DAYTON",
    "dropmalst": "NY",
    "dropmalzpp": 141389998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169885500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16181",
    "droptype": "D",
    "dropname": "SOUTH FALLSBURG",
    "dropdeladd": "25 RAILROAD PLZ",
    "dropdelcty": "SOUTH FALLSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 127799998,
    "dropphyadd": "25 RAILROAD PLZ",
    "dropphycty": "SOUTH FALLSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 127799998,
    "dropmaladd": "25 RAILROAD PLZ",
    "dropmalcty": "SOUTH FALLSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 127799998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454349116,
    "dropsitcph": 8454349116,
    "dropfax": 8454368626
  },
  {
    "dcode": "D",
    "dropkey": "PV16196",
    "droptype": "D",
    "dropname": "SOUTH JAMESPORT",
    "dropdeladd": "70 2ND ST",
    "dropdelcty": "SOUTH JAMESPORT",
    "dropdelst": "NY",
    "dropdelzpp": 119709700,
    "dropphyadd": "70 2ND ST",
    "dropphycty": "SOUTH JAMESPORT",
    "dropphyst": "NY",
    "dropphyzpp": 119709700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH JAMESPORT",
    "dropmalst": "NY",
    "dropmalzpp": 119709998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317224317,
    "dropfax": 6317224456
  },
  {
    "dcode": "D",
    "dropkey": "PV16203",
    "droptype": "D",
    "dropname": "SOUTH NEW BERLIN",
    "dropdeladd": "6338 STATE HIGHWAY 23",
    "dropdelcty": "SOUTH NEW BERLIN",
    "dropdelst": "NY",
    "dropdelzpp": 138439998,
    "dropphyadd": "6338 STATE HIGHWAY 23",
    "dropphycty": "SOUTH NEW BERLIN",
    "dropphyst": "NY",
    "dropphyzpp": 138439998,
    "dropmaladd": "6338 STATE HIGHWAY 23",
    "dropmalcty": "SOUTH NEW BERLIN",
    "dropmalst": "NY",
    "dropmalzpp": 138439998,
    "dropsitphn": 6078592558,
    "dropsitlph": 6078592558,
    "dropsitcph": 6078592558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16207",
    "droptype": "D",
    "dropname": "SOUTH OTSELIC",
    "dropdeladd": "1605 STATE HIGHWAY 26",
    "dropdelcty": "SOUTH OTSELIC",
    "dropdelst": "NY",
    "dropdelzpp": 131559998,
    "dropphyadd": "1605 STATE HIGHWAY 26",
    "dropphycty": "SOUTH OTSELIC",
    "dropphyst": "NY",
    "dropphyzpp": 131559998,
    "dropmaladd": "1605 STATE HIGHWAY 26",
    "dropmalcty": "SOUTH OTSELIC",
    "dropmalst": "NY",
    "dropmalzpp": 131559998,
    "dropsitphn": 3156537822,
    "dropsitlph": 3156537822,
    "dropsitcph": 3156537822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16214",
    "droptype": "D",
    "dropname": "SOUTH PLYMOUTH",
    "dropdeladd": "3799 STATE HIGHWAY 23",
    "dropdelcty": "SOUTH PLYMOUTH",
    "dropdelst": "NY",
    "dropdelzpp": 138449998,
    "dropphyadd": "3799 STATE HIGHWAY 23",
    "dropphycty": "SOUTH PLYMOUTH",
    "dropphyst": "NY",
    "dropphyzpp": 138449998,
    "dropmaladd": "3799 STATE HIGHWAY 23",
    "dropmalcty": "SOUTH PLYMOUTH",
    "dropmalst": "NY",
    "dropmalzpp": 138449998,
    "dropsitphn": 6073349201,
    "dropsitlph": 6073349201,
    "dropsitcph": 6073349201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16222",
    "droptype": "D",
    "dropname": "SOUTH SALEM",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "SOUTH SALEM",
    "dropdelst": "NY",
    "dropdelzpp": 105909998,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "SOUTH SALEM",
    "dropphyst": "NY",
    "dropphyzpp": 105909998,
    "dropmaladd": "17 MAIN ST",
    "dropmalcty": "SOUTH SALEM",
    "dropmalst": "NY",
    "dropmalzpp": 105909998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147633957,
    "dropsitcph": 9147633957,
    "dropfax": 9147636138
  },
  {
    "dcode": "D",
    "dropkey": "PV16230",
    "droptype": "D",
    "dropname": "SOUTH WALES",
    "dropdeladd": "6483 OLEAN RD",
    "dropdelcty": "SOUTH WALES",
    "dropdelst": "NY",
    "dropdelzpp": 141399998,
    "dropphyadd": "6483 OLEAN RD",
    "dropphycty": "SOUTH WALES",
    "dropphyst": "NY",
    "dropphyzpp": 141399998,
    "dropmaladd": "6483 OLEAN RD",
    "dropmalcty": "SOUTH WALES",
    "dropmalst": "NY",
    "dropmalzpp": 141399998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166528858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16233",
    "droptype": "D",
    "dropname": "SOUTHAMPTON",
    "dropdeladd": "123 N SEA RD",
    "dropdelcty": "SOUTHAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 119682068,
    "dropphyadd": "123 N SEA RD",
    "dropphycty": "SOUTHAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 119682068,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTHAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 119699998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312049822,
    "dropfax": 6312871828
  },
  {
    "dcode": "D",
    "dropkey": "PV16235",
    "droptype": "D",
    "dropname": "SOUTHFIELDS",
    "dropdeladd": "996 ROUTE 17 STOP 2",
    "dropdelcty": "SOUTHFIELDS",
    "dropdelst": "NY",
    "dropdelzpp": 109759998,
    "dropphyadd": "996 ROUTE 17 STOP 2",
    "dropphycty": "SOUTHFIELDS",
    "dropphyst": "NY",
    "dropphyzpp": 109759998,
    "dropmaladd": "996 ROUTE 17 STOP 2",
    "dropmalcty": "SOUTHFIELDS",
    "dropmalst": "NY",
    "dropmalzpp": 109759998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8453512628,
    "dropfax": 8453512628
  },
  {
    "dcode": "D",
    "dropkey": "PV16236",
    "droptype": "D",
    "dropname": "SOUTHOLD",
    "dropdeladd": "710 TRAVELER ST",
    "dropdelcty": "SOUTHOLD",
    "dropdelst": "NY",
    "dropdelzpp": 119711000,
    "dropphyadd": "710 TRAVELER ST",
    "dropphycty": "SOUTHOLD",
    "dropphyst": "NY",
    "dropphyzpp": 119711000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTHOLD",
    "dropmalst": "NY",
    "dropmalzpp": 119719998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317654027,
    "dropfax": 6317656053
  },
  {
    "dcode": "D",
    "dropkey": "PV16241",
    "droptype": "D",
    "dropname": "SPARKILL",
    "dropdeladd": "2 DEPOT SQ",
    "dropdelcty": "SPARKILL",
    "dropdelst": "NY",
    "dropdelzpp": 109769998,
    "dropphyadd": "2 DEPOT SQ",
    "dropphycty": "SPARKILL",
    "dropphyst": "NY",
    "dropphyzpp": 109769998,
    "dropmaladd": "2 DEPOT SQ",
    "dropmalcty": "SPARKILL",
    "dropmalst": "NY",
    "dropmalzpp": 109769998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453590406,
    "dropsitcph": 8453590406,
    "dropfax": 8453598358
  },
  {
    "dcode": "D",
    "dropkey": "PV16243",
    "droptype": "D",
    "dropname": "SPARROW BUSH",
    "dropdeladd": "505 STATE ROUTE 42",
    "dropdelcty": "SPARROW BUSH",
    "dropdelst": "NY",
    "dropdelzpp": 127809998,
    "dropphyadd": "505 STATE ROUTE 42",
    "dropphycty": "SPARROW BUSH",
    "dropphyst": "NY",
    "dropphyzpp": 127809998,
    "dropmaladd": "505 STATE ROUTE 42",
    "dropmalcty": "SPARROW BUSH",
    "dropmalst": "NY",
    "dropmalzpp": 127809998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458584232,
    "dropsitcph": 8458584232,
    "dropfax": 8458563416
  },
  {
    "dcode": "D",
    "dropkey": "PV16246",
    "droptype": "D",
    "dropname": "SPECULATOR",
    "dropdeladd": "1 FOUR CORS",
    "dropdelcty": "SPECULATOR",
    "dropdelst": "NY",
    "dropdelzpp": 121645000,
    "dropphyadd": "1 FOUR CORS",
    "dropphycty": "SPECULATOR",
    "dropphyst": "NY",
    "dropphyzpp": 121645000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPECULATOR",
    "dropmalst": "NY",
    "dropmalzpp": 121649998,
    "dropsitphn": 5185487744,
    "dropsitlph": 5185487744,
    "dropsitcph": 5185487744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16249",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "196 N MAIN ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "NY",
    "dropdelzpp": 148839998,
    "dropphyadd": "196 N MAIN ST",
    "dropphycty": "SPENCER",
    "dropphyst": "NY",
    "dropphyzpp": 148839998,
    "dropmaladd": "196 N MAIN ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "NY",
    "dropmalzpp": 148839998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075896144,
    "dropsitcph": 6075896144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16251",
    "droptype": "D",
    "dropname": "SPENCERPORT",
    "dropdeladd": "11 AMITY ST",
    "dropdelcty": "SPENCERPORT",
    "dropdelst": "NY",
    "dropdelzpp": 145599998,
    "dropphyadd": "11 AMITY ST",
    "dropphycty": "SPENCERPORT",
    "dropphyst": "NY",
    "dropphyzpp": 145599998,
    "dropmaladd": "11 AMITY ST",
    "dropmalcty": "SPENCERPORT",
    "dropmalst": "NY",
    "dropmalzpp": 145599998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853524322,
    "dropsitcph": 5853524322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16252",
    "droptype": "D",
    "dropname": "SPENCERTOWN",
    "dropdeladd": "5199 ROUTE 7",
    "dropdelcty": "SPENCERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 121659998,
    "dropphyadd": "5199 ROUTE 7",
    "dropphycty": "SPENCERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 121659998,
    "dropmaladd": "5199 ROUTE 7",
    "dropmalcty": "SPENCERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 121659998,
    "dropsitphn": 5183929700,
    "dropsitlph": 5183929700,
    "dropsitcph": 5183929700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16253",
    "droptype": "D",
    "dropname": "SPEONK",
    "dropdeladd": "323 MONTAUK HWY",
    "dropdelcty": "SPEONK",
    "dropdelst": "NY",
    "dropdelzpp": 119729700,
    "dropphyadd": "323 MONTAUK HWY",
    "dropphycty": "SPEONK",
    "dropphyst": "NY",
    "dropphyzpp": 119729700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPEONK",
    "dropmalst": "NY",
    "dropmalzpp": 119729998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313251741,
    "dropfax": 6313251438
  },
  {
    "dcode": "D",
    "dropkey": "PV16257",
    "droptype": "D",
    "dropname": "SPRAKERS",
    "dropdeladd": "582 SPRAKERS RD",
    "dropdelcty": "SPRAKERS",
    "dropdelst": "NY",
    "dropdelzpp": 121669998,
    "dropphyadd": "582 SPRAKERS RD",
    "dropphycty": "SPRAKERS",
    "dropphyst": "NY",
    "dropphyzpp": 121669998,
    "dropmaladd": "582 SPRAKERS RD",
    "dropmalcty": "SPRAKERS",
    "dropmalst": "NY",
    "dropmalzpp": 121669998,
    "dropsitphn": 5186735390,
    "dropsitlph": 5186735390,
    "dropsitcph": 5186735390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16258",
    "droptype": "D",
    "dropname": "SPRING BROOK",
    "dropdeladd": "6150 SENECA ST",
    "dropdelcty": "SPRING BROOK",
    "dropdelst": "NY",
    "dropdelzpp": 141409800,
    "dropphyadd": "6150 SENECA ST",
    "dropphycty": "SPRING BROOK",
    "dropphyst": "NY",
    "dropphyzpp": 141409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING BROOK",
    "dropmalst": "NY",
    "dropmalzpp": 141409998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166522577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16260",
    "droptype": "D",
    "dropname": "SPRING GLEN",
    "dropdeladd": "1395 OLD ROUTE 209",
    "dropdelcty": "SPRING GLEN",
    "dropdelst": "NY",
    "dropdelzpp": 124839800,
    "dropphyadd": "1395 OLD ROUTE 209",
    "dropphycty": "SPRING GLEN",
    "dropphyst": "NY",
    "dropphyzpp": 124839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING GLEN",
    "dropmalst": "NY",
    "dropmalzpp": 124839998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456475760,
    "dropsitcph": 8456475760,
    "dropfax": 8456475760
  },
  {
    "dcode": "D",
    "dropkey": "PV16263",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "7 N MADISON AVE",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 109779998,
    "dropphyadd": "7 N MADISON AVE",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 109779998,
    "dropmaladd": "7 N MADISON AVE",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 109779998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454256741,
    "dropsitcph": 8454256741,
    "dropfax": 8454252533
  },
  {
    "dcode": "D",
    "dropkey": "PV16266",
    "droptype": "D",
    "dropname": "SPRINGFIELD CENTER",
    "dropdeladd": "7670 STATE ROUTE 80",
    "dropdelcty": "SPRINGFIELD CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 134689998,
    "dropphyadd": "7670 STATE ROUTE 80",
    "dropphycty": "SPRINGFIELD CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 134689998,
    "dropmaladd": "7670 STATE ROUTE 80",
    "dropmalcty": "SPRINGFIELD CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 134689998,
    "dropsitphn": 3158580073,
    "dropsitlph": 3158580073,
    "dropsitcph": 3158580073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16275",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "75 FRANKLIN ST",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 141419998,
    "dropphyadd": "75 FRANKLIN ST",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 141419998,
    "dropmaladd": "75 FRANKLIN ST",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 141419998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165922927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16276",
    "droptype": "D",
    "dropname": "SPRINGWATER",
    "dropdeladd": "7886 N MAIN ST",
    "dropdelcty": "SPRINGWATER",
    "dropdelst": "NY",
    "dropdelzpp": 145609998,
    "dropphyadd": "7886 N MAIN ST",
    "dropphycty": "SPRINGWATER",
    "dropphyst": "NY",
    "dropphyzpp": 145609998,
    "dropmaladd": "7886 N MAIN ST",
    "dropmalcty": "SPRINGWATER",
    "dropmalst": "NY",
    "dropmalzpp": 145609998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856692700,
    "dropsitcph": 5856692700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16339",
    "droptype": "D",
    "dropname": "STAATSBURG",
    "dropdeladd": "1 MARKET ST",
    "dropdelcty": "STAATSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 125809998,
    "dropphyadd": "1 MARKET ST",
    "dropphycty": "STAATSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 125809998,
    "dropmaladd": "1 MARKET ST",
    "dropmalcty": "STAATSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 125809998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458894560,
    "dropsitcph": 8458894560,
    "dropfax": 8458894435
  },
  {
    "dcode": "D",
    "dropkey": "PV16344",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "8899 ROUTE 237",
    "dropdelcty": "STAFFORD",
    "dropdelst": "NY",
    "dropdelzpp": 141439998,
    "dropphyadd": "8899 ROUTE 237",
    "dropphycty": "STAFFORD",
    "dropphyst": "NY",
    "dropphyzpp": 141439998,
    "dropmaladd": "8899 ROUTE 237",
    "dropmalcty": "STAFFORD",
    "dropmalst": "NY",
    "dropmalzpp": 141439998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5853436742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16345",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "5 CHURCHILL AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "NY",
    "dropdelzpp": 121679998,
    "dropphyadd": "5 CHURCHILL AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "NY",
    "dropphyzpp": 121679998,
    "dropmaladd": "5 CHURCHILL AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "NY",
    "dropmalzpp": 121679998,
    "dropsitphn": 6076527777,
    "dropsitlph": 6076527777,
    "dropsitcph": 6076527777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16348",
    "droptype": "D",
    "dropname": "STANFORDVILLE",
    "dropdeladd": "6069 ROUTE 82",
    "dropdelcty": "STANFORDVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125819998,
    "dropphyadd": "6069 ROUTE 82",
    "dropphycty": "STANFORDVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125819998,
    "dropmaladd": "6069 ROUTE 82",
    "dropmalcty": "STANFORDVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125819998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458681694,
    "dropsitcph": 8458681694,
    "dropfax": 8458681615
  },
  {
    "dcode": "D",
    "dropkey": "PV16351",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "2102 STATE ROUTE 245",
    "dropdelcty": "STANLEY",
    "dropdelst": "NY",
    "dropdelzpp": 145619998,
    "dropphyadd": "2102 STATE ROUTE 245",
    "dropphycty": "STANLEY",
    "dropphyst": "NY",
    "dropphyzpp": 145619998,
    "dropmaladd": "2102 STATE ROUTE 245",
    "dropmalcty": "STANLEY",
    "dropmalst": "NY",
    "dropmalzpp": 145619998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855266695,
    "dropsitcph": 5855266695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16357",
    "droptype": "D",
    "dropname": "STAR LAKE",
    "dropdeladd": "4052 STATE HIGHWAY 3",
    "dropdelcty": "STAR LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 136909998,
    "dropphyadd": "4052 STATE HIGHWAY 3",
    "dropphycty": "STAR LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 136909998,
    "dropmaladd": "4052 STATE HIGHWAY 3",
    "dropmalcty": "STAR LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 136909998,
    "dropsitphn": 3158482242,
    "dropsitlph": 3158482242,
    "dropsitcph": 3158482242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16372",
    "droptype": "D",
    "dropname": "STEAMBURG",
    "dropdeladd": "2560 ROUTE 394",
    "dropdelcty": "STEAMBURG",
    "dropdelst": "NY",
    "dropdelzpp": 147839800,
    "dropphyadd": "2560 ROUTE 394",
    "dropphycty": "STEAMBURG",
    "dropphyst": "NY",
    "dropphyzpp": 147839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEAMBURG",
    "dropmalst": "NY",
    "dropmalzpp": 147839998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163546965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16375",
    "droptype": "D",
    "dropname": "STEPHENTOWN",
    "dropdeladd": "389 STATE ROUTE 43",
    "dropdelcty": "STEPHENTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 121689998,
    "dropphyadd": "389 STATE ROUTE 43",
    "dropphycty": "STEPHENTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 121689998,
    "dropmaladd": "389 STATE ROUTE 43",
    "dropmalcty": "STEPHENTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 121689998,
    "dropsitphn": 5187335005,
    "dropsitlph": 5187335005,
    "dropsitcph": 5187335005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16377",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "1325 STATE ROUTE 104A",
    "dropdelcty": "STERLING",
    "dropdelst": "NY",
    "dropdelzpp": 131569998,
    "dropphyadd": "1325 STATE ROUTE 104A",
    "dropphycty": "STERLING",
    "dropphyst": "NY",
    "dropphyzpp": 131569998,
    "dropmaladd": "1325 STATE ROUTE 104A",
    "dropmalcty": "STERLING",
    "dropmalst": "NY",
    "dropmalzpp": 131569998,
    "dropsitphn": 3159475763,
    "dropsitlph": 3159475763,
    "dropsitcph": 3159475763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16388",
    "droptype": "D",
    "dropname": "STILLWATER",
    "dropdeladd": "740 HUDSON AVE",
    "dropdelcty": "STILLWATER",
    "dropdelst": "NY",
    "dropdelzpp": 121709998,
    "dropphyadd": "740 HUDSON AVE",
    "dropphycty": "STILLWATER",
    "dropphyst": "NY",
    "dropphyzpp": 121709998,
    "dropmaladd": "740 HUDSON AVE",
    "dropmalcty": "STILLWATER",
    "dropmalst": "NY",
    "dropmalzpp": 121709998,
    "dropsitphn": 5186647980,
    "dropsitlph": 5186647980,
    "dropsitcph": 5186647980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16391",
    "droptype": "D",
    "dropname": "STITTVILLE",
    "dropdeladd": "9060 MAIN ST",
    "dropdelcty": "STITTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134699998,
    "dropphyadd": "9060 MAIN ST",
    "dropphycty": "STITTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134699998,
    "dropmaladd": "9060 MAIN ST",
    "dropmalcty": "STITTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134699998,
    "dropsitphn": 3158655338,
    "dropsitlph": 3158655338,
    "dropsitcph": 3158655338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16395",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "7254 ROUTE 380",
    "dropdelcty": "STOCKTON",
    "dropdelst": "NY",
    "dropdelzpp": 147849998,
    "dropphyadd": "7254 ROUTE 380",
    "dropphycty": "STOCKTON",
    "dropphyst": "NY",
    "dropphyzpp": 147849998,
    "dropmaladd": "7254 ROUTE 380",
    "dropmalcty": "STOCKTON",
    "dropmalst": "NY",
    "dropmalzpp": 147849998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165990004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16402",
    "droptype": "D",
    "dropname": "STONE RIDGE",
    "dropdeladd": "3765 MAIN ST",
    "dropdelcty": "STONE RIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 124849998,
    "dropphyadd": "3765 MAIN ST",
    "dropphycty": "STONE RIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 124849998,
    "dropmaladd": "3765 MAIN ST",
    "dropmalcty": "STONE RIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 124849998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456874029,
    "dropsitcph": 8456874029,
    "dropfax": 8456870290
  },
  {
    "dcode": "D",
    "dropkey": "PV16404",
    "droptype": "D",
    "dropname": "STONY BROOK",
    "dropdeladd": "129 MAIN ST",
    "dropdelcty": "STONY BROOK",
    "dropdelst": "NY",
    "dropdelzpp": 117901927,
    "dropphyadd": "129 MAIN ST",
    "dropphycty": "STONY BROOK",
    "dropphyst": "NY",
    "dropphyzpp": 117901927,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONY BROOK",
    "dropmalst": "NY",
    "dropmalzpp": 117909998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317515691,
    "dropfax": 6312468241
  },
  {
    "dcode": "D",
    "dropkey": "PV16405",
    "droptype": "D",
    "dropname": "STONY CREEK",
    "dropdeladd": "6 HADLEY RD",
    "dropdelcty": "STONY CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 128789998,
    "dropphyadd": "6 HADLEY RD",
    "dropphycty": "STONY CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 128789998,
    "dropmaladd": "6 HADLEY RD",
    "dropmalcty": "STONY CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 128789998,
    "dropsitphn": 5186963522,
    "dropsitlph": 5186963522,
    "dropsitcph": 5186963522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16406",
    "droptype": "D",
    "dropname": "STONY POINT",
    "dropdeladd": "81 CENTRAL HWY",
    "dropdelcty": "STONY POINT",
    "dropdelst": "NY",
    "dropdelzpp": 109809998,
    "dropphyadd": "81 CENTRAL HWY",
    "dropphycty": "STONY POINT",
    "dropphyst": "NY",
    "dropphyzpp": 109809998,
    "dropmaladd": "81 CENTRAL HWY",
    "dropmalcty": "STONY POINT",
    "dropmalst": "NY",
    "dropmalzpp": 109809998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457860429,
    "dropsitcph": 8457860429,
    "dropfax": 8457861749
  },
  {
    "dcode": "D",
    "dropkey": "PV16410",
    "droptype": "D",
    "dropname": "STORMVILLE",
    "dropdeladd": "7 OLD ROUTE 52",
    "dropdelcty": "STORMVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125829998,
    "dropphyadd": "7 OLD ROUTE 52",
    "dropphycty": "STORMVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125829998,
    "dropmaladd": "7 OLD ROUTE 52",
    "dropmalcty": "STORMVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 125829998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452191534,
    "dropsitcph": 8452191534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16413",
    "droptype": "D",
    "dropname": "STOTTVILLE",
    "dropdeladd": "2857 ATLANTIC AVE",
    "dropdelcty": "STOTTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121729998,
    "dropphyadd": "2857 ATLANTIC AVE",
    "dropphycty": "STOTTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121729998,
    "dropmaladd": "2857 ATLANTIC AVE",
    "dropmalcty": "STOTTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121729998,
    "dropsitphn": 5188286311,
    "dropsitlph": 5188286311,
    "dropsitcph": 5188286311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16414",
    "droptype": "D",
    "dropname": "STOW",
    "dropdeladd": "3479 OLD BRIDGE RD",
    "dropdelcty": "STOW",
    "dropdelst": "NY",
    "dropdelzpp": 147859800,
    "dropphyadd": "3479 OLD BRIDGE RD",
    "dropphycty": "STOW",
    "dropphyst": "NY",
    "dropphyzpp": 147859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOW",
    "dropmalst": "NY",
    "dropmalzpp": 147859998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167893235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16416",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "6186 STATE ROUTE 29A",
    "dropdelcty": "STRATFORD",
    "dropdelst": "NY",
    "dropdelzpp": 134709800,
    "dropphyadd": "6186 STATE ROUTE 29A",
    "dropphycty": "STRATFORD",
    "dropphyst": "NY",
    "dropphyzpp": 134709800,
    "dropmaladd": "6186 STATE ROUTE 29A",
    "dropmalcty": "STRATFORD",
    "dropmalst": "NY",
    "dropmalzpp": 134709998,
    "dropsitphn": 3154293481,
    "dropsitlph": 3154293481,
    "dropsitcph": 3154293481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16422",
    "droptype": "D",
    "dropname": "STRYKERSVILLE",
    "dropdeladd": "3778 MAIN ST",
    "dropdelcty": "STRYKERSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 141459998,
    "dropphyadd": "3778 MAIN ST",
    "dropphycty": "STRYKERSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 141459998,
    "dropmaladd": "3778 MAIN ST",
    "dropmalcty": "STRYKERSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 141459998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5854573506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16427",
    "droptype": "D",
    "dropname": "STUYVESANT",
    "dropdeladd": "48 RIVERVIEW ST",
    "dropdelcty": "STUYVESANT",
    "dropdelst": "NY",
    "dropdelzpp": 121739998,
    "dropphyadd": "48 RIVERVIEW ST",
    "dropphycty": "STUYVESANT",
    "dropphyst": "NY",
    "dropphyzpp": 121739998,
    "dropmaladd": "48 RIVERVIEW ST",
    "dropmalcty": "STUYVESANT",
    "dropmalst": "NY",
    "dropmalzpp": 121739998,
    "dropsitphn": 5187589399,
    "dropsitlph": 5187589399,
    "dropsitcph": 5187589399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16428",
    "droptype": "D",
    "dropname": "STUYVESANT FALLS",
    "dropdeladd": "2 ROUTE 25A",
    "dropdelcty": "STUYVESANT FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 121749998,
    "dropphyadd": "2 ROUTE 25A",
    "dropphycty": "STUYVESANT FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 121749998,
    "dropmaladd": "2 ROUTE 25A",
    "dropmalcty": "STUYVESANT FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 121749998,
    "dropsitphn": 5187992461,
    "dropsitlph": 5187992461,
    "dropsitcph": 5187992461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16431",
    "droptype": "D",
    "dropname": "SUFFERN",
    "dropdeladd": "15 CHESTNUT ST",
    "dropdelcty": "SUFFERN",
    "dropdelst": "NY",
    "dropdelzpp": 109019998,
    "dropphyadd": "15 CHESTNUT ST",
    "dropphycty": "SUFFERN",
    "dropphyst": "NY",
    "dropphyzpp": 109019998,
    "dropmaladd": "15 CHESTNUT ST",
    "dropmalcty": "SUFFERN",
    "dropmalst": "NY",
    "dropmalzpp": 109019998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453573615,
    "dropsitcph": 8453570601,
    "dropfax": 8453691519
  },
  {
    "dcode": "D",
    "dropkey": "PV16432",
    "droptype": "D",
    "dropname": "SUGAR LOAF",
    "dropdeladd": "1407 KINGS HWY",
    "dropdelcty": "SUGAR LOAF",
    "dropdelst": "NY",
    "dropdelzpp": 109819800,
    "dropphyadd": "1407 KINGS HWY",
    "dropphycty": "SUGAR LOAF",
    "dropphyst": "NY",
    "dropphyzpp": 109819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUGAR LOAF",
    "dropmalst": "NY",
    "dropmalzpp": 109819998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454694402,
    "dropsitcph": 8454694402,
    "dropfax": 8454694402
  },
  {
    "dcode": "D",
    "dropkey": "PV16436",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "2906 STATE ROUTE 10",
    "dropdelcty": "SUMMIT",
    "dropdelst": "NY",
    "dropdelzpp": 121759998,
    "dropphyadd": "2906 STATE ROUTE 10",
    "dropphycty": "SUMMIT",
    "dropphyst": "NY",
    "dropphyzpp": 121759998,
    "dropmaladd": "2906 STATE ROUTE 10",
    "dropmalcty": "SUMMIT",
    "dropmalst": "NY",
    "dropmalzpp": 121759998,
    "dropsitphn": 5182871533,
    "dropsitlph": 5182871533,
    "dropsitcph": 5182871533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16438",
    "droptype": "D",
    "dropname": "SUMMITVILLE",
    "dropdeladd": "3868 ROUTE 209",
    "dropdelcty": "SUMMITVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127819800,
    "dropphyadd": "3868 ROUTE 209",
    "dropphycty": "SUMMITVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMITVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127819998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458882213,
    "dropsitcph": 8458882213,
    "dropfax": 8458882213
  },
  {
    "dcode": "D",
    "dropkey": "PV16451",
    "droptype": "D",
    "dropname": "SWAIN",
    "dropdeladd": "2215 COUNTY ROAD 24",
    "dropdelcty": "SWAIN",
    "dropdelst": "NY",
    "dropdelzpp": 148849998,
    "dropphyadd": "2215 COUNTY ROAD 24",
    "dropphycty": "SWAIN",
    "dropphyst": "NY",
    "dropphyzpp": 148849998,
    "dropmaladd": "2215 COUNTY ROAD 24",
    "dropmalcty": "SWAIN",
    "dropmalst": "NY",
    "dropmalzpp": 148849998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075458351,
    "dropsitcph": 6075458351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16452",
    "droptype": "D",
    "dropname": "SWAN LAKE",
    "dropdeladd": "35 STANTON CORNER RD",
    "dropdelcty": "SWAN LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127839998,
    "dropphyadd": "35 STANTON CORNER RD",
    "dropphycty": "SWAN LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127839998,
    "dropmaladd": "35 STANTON CORNER RD",
    "dropmalcty": "SWAN LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127839998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452925425,
    "dropsitcph": 8452925425,
    "dropfax": 8452929153
  },
  {
    "dcode": "D",
    "dropkey": "PV16461",
    "droptype": "D",
    "dropname": "SYLVAN BEACH",
    "dropdeladd": "1404 MAIN ST",
    "dropdelcty": "SYLVAN BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 131579998,
    "dropphyadd": "1404 MAIN ST",
    "dropphycty": "SYLVAN BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 131579998,
    "dropmaladd": "1404 MAIN ST",
    "dropmalcty": "SYLVAN BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 131579998,
    "dropsitphn": 3157625663,
    "dropsitlph": 3157625663,
    "dropsitcph": 3157625663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16463",
    "droptype": "D",
    "dropname": "SYOSSET",
    "dropdeladd": "40 QUEENS ST",
    "dropdelcty": "SYOSSET",
    "dropdelst": "NY",
    "dropdelzpp": 117913065,
    "dropphyadd": "40 QUEENS ST",
    "dropphycty": "SYOSSET",
    "dropphyst": "NY",
    "dropphyzpp": 117913065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYOSSET",
    "dropmalst": "NY",
    "dropmalzpp": 117919998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169211921,
    "dropfax": 5164964736
  },
  {
    "dcode": "D",
    "dropkey": "PV16466",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "5640 E TAFT RD",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132209998,
    "dropphyadd": "5640 E TAFT RD",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132209998,
    "dropmaladd": "5640 E TAFT RD",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132209998,
    "dropsitphn": 3154523405,
    "dropsitlph": 3154523455,
    "dropsitcph": 3154523501,
    "dropfax": 3154523453
  },
  {
    "dcode": "D",
    "dropkey": "PV16470",
    "droptype": "D",
    "dropname": "TABERG",
    "dropdeladd": "9300 MAIN ST",
    "dropdelcty": "TABERG",
    "dropdelst": "NY",
    "dropdelzpp": 134719998,
    "dropphyadd": "9300 MAIN ST",
    "dropphycty": "TABERG",
    "dropphyst": "NY",
    "dropphyzpp": 134719998,
    "dropmaladd": "9300 MAIN ST",
    "dropmalcty": "TABERG",
    "dropmalst": "NY",
    "dropmalzpp": 134719998,
    "dropsitphn": 3153373949,
    "dropsitlph": 3153373949,
    "dropsitcph": 3153373949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16477",
    "droptype": "D",
    "dropname": "TALLMAN",
    "dropdeladd": "321 ROUTE 59",
    "dropdelcty": "TALLMAN",
    "dropdelst": "NY",
    "dropdelzpp": 109829800,
    "dropphyadd": "321 ROUTE 59",
    "dropphycty": "TALLMAN",
    "dropphyst": "NY",
    "dropphyzpp": 109829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALLMAN",
    "dropmalst": "NY",
    "dropmalzpp": 109829998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453579138,
    "dropsitcph": 8453579138,
    "dropfax": 8453571772
  },
  {
    "dcode": "D",
    "dropkey": "PV16478",
    "droptype": "D",
    "dropname": "TANNERSVILLE",
    "dropdeladd": "6070 MAIN ST",
    "dropdelcty": "TANNERSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 124859998,
    "dropphyadd": "6070 MAIN ST",
    "dropphycty": "TANNERSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 124859998,
    "dropmaladd": "6070 MAIN ST",
    "dropmalcty": "TANNERSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 124859998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5185897417,
    "dropsitcph": 5185897417,
    "dropfax": 8455897289
  },
  {
    "dcode": "D",
    "dropkey": "PV16481",
    "droptype": "D",
    "dropname": "TAPPAN",
    "dropdeladd": "57 OLD TAPPAN RD",
    "dropdelcty": "TAPPAN",
    "dropdelst": "NY",
    "dropdelzpp": 109839998,
    "dropphyadd": "57 OLD TAPPAN RD",
    "dropphycty": "TAPPAN",
    "dropphyst": "NY",
    "dropphyzpp": 109839998,
    "dropmaladd": "57 OLD TAPPAN RD",
    "dropmalcty": "TAPPAN",
    "dropmalst": "NY",
    "dropmalzpp": 109839998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453593495,
    "dropsitcph": 8453593495,
    "dropfax": 8453593364
  },
  {
    "dcode": "D",
    "dropkey": "PV16482",
    "droptype": "D",
    "dropname": "TARRYTOWN",
    "dropdeladd": "50 N BROADWAY",
    "dropdelcty": "TARRYTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 105919998,
    "dropphyadd": "50 N BROADWAY",
    "dropphycty": "TARRYTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 105919998,
    "dropmaladd": "50 N BROADWAY",
    "dropmalcty": "TARRYTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 105919998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146314591,
    "dropsitcph": 9146314591,
    "dropfax": 9145247322
  },
  {
    "dcode": "D",
    "dropkey": "PV16501",
    "droptype": "D",
    "dropname": "THERESA",
    "dropdeladd": "112 COMMERCIAL ST",
    "dropdelcty": "THERESA",
    "dropdelst": "NY",
    "dropdelzpp": 136919998,
    "dropphyadd": "112 COMMERCIAL ST",
    "dropphycty": "THERESA",
    "dropphyst": "NY",
    "dropphyzpp": 136919998,
    "dropmaladd": "112 COMMERCIAL ST",
    "dropmalcty": "THERESA",
    "dropmalst": "NY",
    "dropmalzpp": 136919998,
    "dropsitphn": 3156285991,
    "dropsitlph": 3156285991,
    "dropsitcph": 3156285991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16502",
    "droptype": "D",
    "dropname": "THIELLS",
    "dropdeladd": "177 THIELLS MT IVY RD",
    "dropdelcty": "THIELLS",
    "dropdelst": "NY",
    "dropdelzpp": 109849998,
    "dropphyadd": "177 THIELLS MT IVY RD",
    "dropphycty": "THIELLS",
    "dropphyst": "NY",
    "dropphyzpp": 109849998,
    "dropmaladd": "177 THIELLS MT IVY RD",
    "dropmalcty": "THIELLS",
    "dropmalst": "NY",
    "dropmalzpp": 109849998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454297396,
    "dropsitcph": 8454297396,
    "dropfax": 8459474736
  },
  {
    "dcode": "D",
    "dropkey": "PV16504",
    "droptype": "D",
    "dropname": "THOMPSON RIDGE",
    "dropdeladd": "49 COUNTY HIGHWAY 17",
    "dropdelcty": "THOMPSON RIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 109859998,
    "dropphyadd": "49 COUNTY HIGHWAY 17",
    "dropphycty": "THOMPSON RIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 109859998,
    "dropmaladd": "49 COUNTY HIGHWAY 17",
    "dropmalcty": "THOMPSON RIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 109859998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8453611525,
    "dropfax": 8453611525
  },
  {
    "dcode": "D",
    "dropkey": "PV16506",
    "droptype": "D",
    "dropname": "THOMPSONVILLE",
    "dropdeladd": "558 THOMPSON RD",
    "dropdelcty": "THOMPSONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127849800,
    "dropphyadd": "558 THOMPSON RD",
    "dropphycty": "THOMPSONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMPSONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127849998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454345758,
    "dropsitcph": 8454345758,
    "dropfax": 8454345758
  },
  {
    "dcode": "D",
    "dropkey": "PV16509",
    "droptype": "D",
    "dropname": "THORNWOOD",
    "dropdeladd": "822 COMMERCE ST",
    "dropdelcty": "THORNWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 105949998,
    "dropphyadd": "822 COMMERCE ST",
    "dropphycty": "THORNWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 105949998,
    "dropmaladd": "822 COMMERCE ST",
    "dropmalcty": "THORNWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 105949998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147697397,
    "dropsitcph": 9147697397,
    "dropfax": 9147698182
  },
  {
    "dcode": "D",
    "dropkey": "PV16512",
    "droptype": "D",
    "dropname": "THREE MILE BAY",
    "dropdeladd": "8685 STATE ROUTE 12E",
    "dropdelcty": "THREE MILE BAY",
    "dropdelst": "NY",
    "dropdelzpp": 136939998,
    "dropphyadd": "8685 STATE ROUTE 12E",
    "dropphycty": "THREE MILE BAY",
    "dropphyst": "NY",
    "dropphyzpp": 136939998,
    "dropmaladd": "8685 STATE ROUTE 12E",
    "dropmalcty": "THREE MILE BAY",
    "dropmalst": "NY",
    "dropmalzpp": 136939998,
    "dropsitphn": 3156495830,
    "dropsitlph": 3156495830,
    "dropsitcph": 3156495830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16524",
    "droptype": "D",
    "dropname": "TICONDEROGA",
    "dropdeladd": "169 CHAMPLAIN AVE",
    "dropdelcty": "TICONDEROGA",
    "dropdelst": "NY",
    "dropdelzpp": 128839998,
    "dropphyadd": "169 CHAMPLAIN AVE",
    "dropphycty": "TICONDEROGA",
    "dropphyst": "NY",
    "dropphyzpp": 128839998,
    "dropmaladd": "169 CHAMPLAIN AVE",
    "dropmalcty": "TICONDEROGA",
    "dropmalst": "NY",
    "dropmalzpp": 128839998,
    "dropsitphn": 5185857414,
    "dropsitlph": 5185857414,
    "dropsitcph": 5185857414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16525",
    "droptype": "D",
    "dropname": "TILLSON",
    "dropdeladd": "134 HARDENBERGH AVE",
    "dropdelcty": "TILLSON",
    "dropdelst": "NY",
    "dropdelzpp": 124869998,
    "dropphyadd": "134 HARDENBERGH AVE",
    "dropphycty": "TILLSON",
    "dropphyst": "NY",
    "dropphyzpp": 124869998,
    "dropmaladd": "134 HARDENBERGH AVE",
    "dropmalcty": "TILLSON",
    "dropmalst": "NY",
    "dropmalzpp": 124869998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456588181,
    "dropsitcph": 8456588181,
    "dropfax": 8456588181
  },
  {
    "dcode": "D",
    "dropkey": "PV16537",
    "droptype": "D",
    "dropname": "TIVOLI",
    "dropdeladd": "78 BROADWAY",
    "dropdelcty": "TIVOLI",
    "dropdelst": "NY",
    "dropdelzpp": 125839998,
    "dropphyadd": "78 BROADWAY",
    "dropphycty": "TIVOLI",
    "dropphyst": "NY",
    "dropphyzpp": 125839998,
    "dropmaladd": "78 BROADWAY",
    "dropmalcty": "TIVOLI",
    "dropmalst": "NY",
    "dropmalzpp": 125839998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457575679,
    "dropsitcph": 8457575679,
    "dropfax": 8457573053
  },
  {
    "dcode": "D",
    "dropkey": "PV16539",
    "droptype": "D",
    "dropname": "TOMKINS COVE",
    "dropdeladd": "160 N LIBERTY DR STE 5",
    "dropdelcty": "TOMKINS COVE",
    "dropdelst": "NY",
    "dropdelzpp": 109862451,
    "dropphyadd": "160 N LIBERTY DR STE 5",
    "dropphycty": "TOMKINS COVE",
    "dropphyst": "NY",
    "dropphyzpp": 109862451,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOMKINS COVE",
    "dropmalst": "NY",
    "dropmalzpp": 109869998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457860953,
    "dropsitcph": 8457860953,
    "dropfax": 8454292671
  },
  {
    "dcode": "D",
    "dropkey": "PV16546",
    "droptype": "D",
    "dropname": "TONAWANDA",
    "dropdeladd": "96 SEYMOUR ST",
    "dropdelcty": "TONAWANDA",
    "dropdelst": "NY",
    "dropdelzpp": 141509998,
    "dropphyadd": "96 SEYMOUR ST",
    "dropphycty": "TONAWANDA",
    "dropphyst": "NY",
    "dropphyzpp": 141509998,
    "dropmaladd": "96 SEYMOUR ST",
    "dropmalcty": "TONAWANDA",
    "dropmalst": "NY",
    "dropmalzpp": 141509998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7167996806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16562",
    "droptype": "D",
    "dropname": "TRIBES HILL",
    "dropdeladd": "216 MOHAWK DR",
    "dropdelcty": "TRIBES HILL",
    "dropdelst": "NY",
    "dropdelzpp": 121779998,
    "dropphyadd": "216 MOHAWK DR",
    "dropphycty": "TRIBES HILL",
    "dropphyst": "NY",
    "dropphyzpp": 121779998,
    "dropmaladd": "216 MOHAWK DR",
    "dropmalcty": "TRIBES HILL",
    "dropmalst": "NY",
    "dropmalzpp": 121779998,
    "dropsitphn": 5188297131,
    "dropsitlph": 5188297131,
    "dropsitcph": 5188297131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16567",
    "droptype": "D",
    "dropname": "TROUPSBURG",
    "dropdeladd": "878 STATE ROUTE 36",
    "dropdelcty": "TROUPSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 148859998,
    "dropphyadd": "878 STATE ROUTE 36",
    "dropphycty": "TROUPSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 148859998,
    "dropmaladd": "878 STATE ROUTE 36",
    "dropmalcty": "TROUPSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 148859998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075256374,
    "dropsitcph": 6075256374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16568",
    "droptype": "D",
    "dropname": "TROUT CREEK",
    "dropdeladd": "8650 COUNTY HIGHWAY 27",
    "dropdelcty": "TROUT CREEK",
    "dropdelst": "NY",
    "dropdelzpp": 138479998,
    "dropphyadd": "8650 COUNTY HIGHWAY 27",
    "dropphycty": "TROUT CREEK",
    "dropphyst": "NY",
    "dropphyzpp": 138479998,
    "dropmaladd": "8650 COUNTY HIGHWAY 27",
    "dropmalcty": "TROUT CREEK",
    "dropmalst": "NY",
    "dropmalzpp": 138479998,
    "dropsitphn": 6078654946,
    "dropsitlph": 6078654946,
    "dropsitcph": 6078654946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16572",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "400 BROADWAY",
    "dropdelcty": "TROY",
    "dropdelst": "NY",
    "dropdelzpp": 121809998,
    "dropphyadd": "400 BROADWAY",
    "dropphycty": "TROY",
    "dropphyst": "NY",
    "dropphyzpp": 121809998,
    "dropmaladd": "400 BROADWAY",
    "dropmalcty": "TROY",
    "dropmalst": "NY",
    "dropmalzpp": 121809998,
    "dropsitphn": 5182727300,
    "dropsitlph": 5182727300,
    "dropsitcph": 5182727300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16574",
    "droptype": "D",
    "dropname": "TRUMANSBURG",
    "dropdeladd": "67 W MAIN ST",
    "dropdelcty": "TRUMANSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 148869998,
    "dropphyadd": "67 W MAIN ST",
    "dropphycty": "TRUMANSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 148869998,
    "dropmaladd": "67 W MAIN ST",
    "dropmalcty": "TRUMANSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 148869998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073878612,
    "dropsitcph": 6073878612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16576",
    "droptype": "D",
    "dropname": "TRUXTON",
    "dropdeladd": "3726 STATE ROUTE 13",
    "dropdelcty": "TRUXTON",
    "dropdelst": "NY",
    "dropdelzpp": 131589998,
    "dropphyadd": "3726 STATE ROUTE 13",
    "dropphycty": "TRUXTON",
    "dropphyst": "NY",
    "dropphyzpp": 131589998,
    "dropmaladd": "3726 STATE ROUTE 13",
    "dropmalcty": "TRUXTON",
    "dropmalst": "NY",
    "dropmalzpp": 131589998,
    "dropsitphn": 6078426483,
    "dropsitlph": 6078426483,
    "dropsitcph": 6078426483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16580",
    "droptype": "D",
    "dropname": "TULLY",
    "dropdeladd": "24 ELM ST",
    "dropdelcty": "TULLY",
    "dropdelst": "NY",
    "dropdelzpp": 131599998,
    "dropphyadd": "24 ELM ST",
    "dropphycty": "TULLY",
    "dropphyst": "NY",
    "dropphyzpp": 131599998,
    "dropmaladd": "24 ELM ST",
    "dropmalcty": "TULLY",
    "dropmalst": "NY",
    "dropmalzpp": 131599998,
    "dropsitphn": 3156965301,
    "dropsitlph": 3156965301,
    "dropsitcph": 3156965301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16581",
    "droptype": "D",
    "dropname": "TUNNEL",
    "dropdeladd": "688 TUNNEL RD",
    "dropdelcty": "TUNNEL",
    "dropdelst": "NY",
    "dropdelzpp": 138489998,
    "dropphyadd": "688 TUNNEL RD",
    "dropphycty": "TUNNEL",
    "dropphyst": "NY",
    "dropphyzpp": 138489998,
    "dropmaladd": "688 TUNNEL RD",
    "dropmalcty": "TUNNEL",
    "dropmalst": "NY",
    "dropmalzpp": 138489998,
    "dropsitphn": 6076931076,
    "dropsitlph": 6076931076,
    "dropsitcph": 6076931076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16582",
    "droptype": "D",
    "dropname": "TUPPER LAKE",
    "dropdeladd": "9 CLIFF AVE",
    "dropdelcty": "TUPPER LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 129869998,
    "dropphyadd": "9 CLIFF AVE",
    "dropphycty": "TUPPER LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 129869998,
    "dropmaladd": "9 CLIFF AVE",
    "dropmalcty": "TUPPER LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 129869998,
    "dropsitphn": 5183599401,
    "dropsitlph": 5183599401,
    "dropsitcph": 5183599401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16583",
    "droptype": "D",
    "dropname": "TURIN",
    "dropdeladd": "4205 STATE ROUTE 26",
    "dropdelcty": "TURIN",
    "dropdelst": "NY",
    "dropdelzpp": 134739998,
    "dropphyadd": "4205 STATE ROUTE 26",
    "dropphycty": "TURIN",
    "dropphyst": "NY",
    "dropphyzpp": 134739998,
    "dropmaladd": "4205 STATE ROUTE 26",
    "dropmalcty": "TURIN",
    "dropmalst": "NY",
    "dropmalzpp": 134739998,
    "dropsitphn": 3153488007,
    "dropsitlph": 3153488007,
    "dropsitcph": 3153488007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16586",
    "droptype": "D",
    "dropname": "TUXEDO PARK",
    "dropdeladd": "228 ROUTE 17",
    "dropdelcty": "TUXEDO PARK",
    "dropdelst": "NY",
    "dropdelzpp": 109879998,
    "dropphyadd": "228 ROUTE 17",
    "dropphycty": "TUXEDO PARK",
    "dropphyst": "NY",
    "dropphyzpp": 109879998,
    "dropmaladd": "228 ROUTE 17",
    "dropmalcty": "TUXEDO PARK",
    "dropmalst": "NY",
    "dropmalzpp": 109879998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453515426,
    "dropsitcph": 8453515426,
    "dropfax": 8453514973
  },
  {
    "dcode": "D",
    "dropkey": "PV16593",
    "droptype": "D",
    "dropname": "TYRONE",
    "dropdeladd": "815 COUNTY ROAD 23",
    "dropdelcty": "TYRONE",
    "dropdelst": "NY",
    "dropdelzpp": 148879800,
    "dropphyadd": "815 COUNTY ROAD 23",
    "dropphycty": "TYRONE",
    "dropphyst": "NY",
    "dropphyzpp": 148879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYRONE",
    "dropmalst": "NY",
    "dropmalzpp": 148879998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072923506,
    "dropsitcph": 6072923506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16600",
    "droptype": "D",
    "dropname": "ULSTER PARK",
    "dropdeladd": "364 UNION CENTER RD",
    "dropdelcty": "ULSTER PARK",
    "dropdelst": "NY",
    "dropdelzpp": 124879998,
    "dropphyadd": "364 UNION CENTER RD",
    "dropphycty": "ULSTER PARK",
    "dropphyst": "NY",
    "dropphyzpp": 124879998,
    "dropmaladd": "364 UNION CENTER RD",
    "dropmalcty": "ULSTER PARK",
    "dropmalst": "NY",
    "dropmalzpp": 124879998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453312741,
    "dropsitcph": 8453312741,
    "dropfax": 8453312741
  },
  {
    "dcode": "D",
    "dropkey": "PV16603",
    "droptype": "D",
    "dropname": "UNADILLA",
    "dropdeladd": "4 BRIDGE ST",
    "dropdelcty": "UNADILLA",
    "dropdelst": "NY",
    "dropdelzpp": 138499998,
    "dropphyadd": "4 BRIDGE ST",
    "dropphycty": "UNADILLA",
    "dropphyst": "NY",
    "dropphyzpp": 138499998,
    "dropmaladd": "4 BRIDGE ST",
    "dropmalcty": "UNADILLA",
    "dropmalst": "NY",
    "dropmalzpp": 138499998,
    "dropsitphn": 6073699361,
    "dropsitlph": 6073699361,
    "dropsitcph": 6073699361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16608",
    "droptype": "D",
    "dropname": "UNION HILL",
    "dropdeladd": "82 RIDGE RD",
    "dropdelcty": "UNION HILL",
    "dropdelst": "NY",
    "dropdelzpp": 145639800,
    "dropphyadd": "82 RIDGE RD",
    "dropphycty": "UNION HILL",
    "dropphyst": "NY",
    "dropphyzpp": 145639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION HILL",
    "dropmalst": "NY",
    "dropmalzpp": 145639998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852650705,
    "dropsitcph": 5852650705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16611",
    "droptype": "D",
    "dropname": "UNION SPRINGS",
    "dropdeladd": "116 CAYUGA ST",
    "dropdelcty": "UNION SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 131609998,
    "dropphyadd": "116 CAYUGA ST",
    "dropphycty": "UNION SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 131609998,
    "dropmaladd": "116 CAYUGA ST",
    "dropmalcty": "UNION SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 131609998,
    "dropsitphn": 3158897711,
    "dropsitlph": 3158897711,
    "dropsitcph": 3158897711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16615",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109889800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109889998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457266143,
    "dropsitcph": 8457266143,
    "dropfax": 8457263658
  },
  {
    "dcode": "D",
    "dropkey": "PV16627",
    "droptype": "D",
    "dropname": "UPPER JAY",
    "dropdeladd": "12197 STATE ROUTE 9N",
    "dropdelcty": "UPPER JAY",
    "dropdelst": "NY",
    "dropdelzpp": 129879998,
    "dropphyadd": "12197 STATE ROUTE 9N",
    "dropphycty": "UPPER JAY",
    "dropphyst": "NY",
    "dropphyzpp": 129879998,
    "dropmaladd": "12197 STATE ROUTE 9N",
    "dropmalcty": "UPPER JAY",
    "dropmalst": "NY",
    "dropmalzpp": 129879998,
    "dropsitphn": 5189467182,
    "dropsitlph": 5189467182,
    "dropsitcph": 5189467182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16634",
    "droptype": "D",
    "dropname": "UPTON",
    "dropdeladd": "2 CENTER ST",
    "dropdelcty": "UPTON",
    "dropdelst": "NY",
    "dropdelzpp": 119739700,
    "dropphyadd": "2 CENTER ST",
    "dropphycty": "UPTON",
    "dropphyst": "NY",
    "dropphyzpp": 119739700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UPTON",
    "dropmalst": "NY",
    "dropmalzpp": 119739998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313442539,
    "dropfax": 6313447050
  },
  {
    "dcode": "D",
    "dropkey": "PV16643",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "100 PITCHER ST",
    "dropdelcty": "UTICA",
    "dropdelst": "NY",
    "dropdelzpp": 135049998,
    "dropphyadd": "100 PITCHER ST",
    "dropphycty": "UTICA",
    "dropphyst": "NY",
    "dropphyzpp": 135049998,
    "dropmaladd": "100 PITCHER ST",
    "dropmalcty": "UTICA",
    "dropmalst": "NY",
    "dropmalzpp": 135049998,
    "dropsitphn": 3157385313,
    "dropsitlph": 3157385313,
    "dropsitcph": 3157385313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16648",
    "droptype": "D",
    "dropname": "VAILS GATE",
    "dropdeladd": "6 OLD TEMPLE HILL RD",
    "dropdelcty": "VAILS GATE",
    "dropdelst": "NY",
    "dropdelzpp": 125849800,
    "dropphyadd": "6 OLD TEMPLE HILL RD",
    "dropphycty": "VAILS GATE",
    "dropphyst": "NY",
    "dropphyzpp": 125849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAILS GATE",
    "dropmalst": "NY",
    "dropmalzpp": 125849998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455623273,
    "dropsitcph": 8455623273,
    "dropfax": 8455612994
  },
  {
    "dcode": "D",
    "dropkey": "PV16649",
    "droptype": "D",
    "dropname": "VALATIE",
    "dropdeladd": "1050 KINDERHOOK ST",
    "dropdelcty": "VALATIE",
    "dropdelst": "NY",
    "dropdelzpp": 121849998,
    "dropphyadd": "1050 KINDERHOOK ST",
    "dropphycty": "VALATIE",
    "dropphyst": "NY",
    "dropphyzpp": 121849998,
    "dropmaladd": "1050 KINDERHOOK ST",
    "dropmalcty": "VALATIE",
    "dropmalst": "NY",
    "dropmalzpp": 121849998,
    "dropsitphn": 5187587133,
    "dropsitlph": 5187587133,
    "dropsitcph": 5187587133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16650",
    "droptype": "D",
    "dropname": "VALHALLA",
    "dropdeladd": "10 CLEVELAND ST",
    "dropdelcty": "VALHALLA",
    "dropdelst": "NY",
    "dropdelzpp": 105959998,
    "dropphyadd": "10 CLEVELAND ST",
    "dropphycty": "VALHALLA",
    "dropphyst": "NY",
    "dropphyzpp": 105959998,
    "dropmaladd": "10 CLEVELAND ST",
    "dropmalcty": "VALHALLA",
    "dropmalst": "NY",
    "dropmalzpp": 105959998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149487492,
    "dropsitcph": 9149487492,
    "dropfax": 9143281560
  },
  {
    "dcode": "D",
    "dropkey": "PV16651",
    "droptype": "D",
    "dropname": "VALLEY COTTAGE",
    "dropdeladd": "137 ROUTE 303",
    "dropdelcty": "VALLEY COTTAGE",
    "dropdelst": "NY",
    "dropdelzpp": 109899998,
    "dropphyadd": "137 ROUTE 303",
    "dropphycty": "VALLEY COTTAGE",
    "dropphyst": "NY",
    "dropphyzpp": 109899998,
    "dropmaladd": "137 ROUTE 303",
    "dropmalcty": "VALLEY COTTAGE",
    "dropmalst": "NY",
    "dropmalzpp": 109899998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452688675,
    "dropsitcph": 8452688675,
    "dropfax": 8452686547
  },
  {
    "dcode": "D",
    "dropkey": "PV16652",
    "droptype": "D",
    "dropname": "VALLEY FALLS",
    "dropdeladd": "40 STATE ST",
    "dropdelcty": "VALLEY FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 121859998,
    "dropphyadd": "40 STATE ST",
    "dropphycty": "VALLEY FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 121859998,
    "dropmaladd": "40 STATE ST",
    "dropmalcty": "VALLEY FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 121859998,
    "dropsitphn": 5187534410,
    "dropsitlph": 5187534410,
    "dropsitcph": 5187534410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16656",
    "droptype": "D",
    "dropname": "VALLEY STREAM",
    "dropdeladd": "111 S FRANKLIN AVE",
    "dropdelcty": "VALLEY STREAM",
    "dropdelst": "NY",
    "dropdelzpp": 115806136,
    "dropphyadd": "111 S FRANKLIN AVE",
    "dropphycty": "VALLEY STREAM",
    "dropphyst": "NY",
    "dropphyzpp": 115806136,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALLEY STREAM",
    "dropmalst": "NY",
    "dropmalzpp": 115829998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5168258739,
    "dropfax": 5165614145
  },
  {
    "dcode": "D",
    "dropkey": "PV16667",
    "droptype": "D",
    "dropname": "VAN ETTEN",
    "dropdeladd": "3 MAIN ST",
    "dropdelcty": "VAN ETTEN",
    "dropdelst": "NY",
    "dropdelzpp": 148899998,
    "dropphyadd": "3 MAIN ST",
    "dropphycty": "VAN ETTEN",
    "dropphyst": "NY",
    "dropphyzpp": 148899998,
    "dropmaladd": "3 MAIN ST",
    "dropmalcty": "VAN ETTEN",
    "dropmalst": "NY",
    "dropmalzpp": 148899998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075896595,
    "dropsitcph": 6075896595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16668",
    "droptype": "D",
    "dropname": "VAN HORNESVILLE",
    "dropdeladd": "2178 STATE ROUTE 80",
    "dropdelcty": "VAN HORNESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134759800,
    "dropphyadd": "2178 STATE ROUTE 80",
    "dropphycty": "VAN HORNESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN HORNESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134759998,
    "dropsitphn": 3158580967,
    "dropsitlph": 3158580967,
    "dropsitcph": 3158580967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16673",
    "droptype": "D",
    "dropname": "VARYSBURG",
    "dropdeladd": "2489 ROUTE 20A",
    "dropdelcty": "VARYSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 141679998,
    "dropphyadd": "2489 ROUTE 20A",
    "dropphycty": "VARYSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 141679998,
    "dropmaladd": "2489 ROUTE 20A",
    "dropmalcty": "VARYSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 141679998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5855357366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16677",
    "droptype": "D",
    "dropname": "VERBANK",
    "dropdeladd": "3393 ROUTE 82",
    "dropdelcty": "VERBANK",
    "dropdelst": "NY",
    "dropdelzpp": 125859998,
    "dropphyadd": "3393 ROUTE 82",
    "dropphycty": "VERBANK",
    "dropphyst": "NY",
    "dropphyzpp": 125859998,
    "dropmaladd": "3393 ROUTE 82",
    "dropmalcty": "VERBANK",
    "dropmalst": "NY",
    "dropmalzpp": 125859998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8456773066,
    "dropfax": 8456773066
  },
  {
    "dcode": "D",
    "dropkey": "PV16680",
    "droptype": "D",
    "dropname": "VERMONTVILLE",
    "dropdeladd": "6 COLD BROOK RD",
    "dropdelcty": "VERMONTVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 129899998,
    "dropphyadd": "6 COLD BROOK RD",
    "dropphycty": "VERMONTVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 129899998,
    "dropmaladd": "6 COLD BROOK RD",
    "dropmalcty": "VERMONTVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 129899998,
    "dropsitphn": 5188912800,
    "dropsitlph": 5188912800,
    "dropsitcph": 5188912800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16681",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "4470 PETERBORO ST",
    "dropdelcty": "VERNON",
    "dropdelst": "NY",
    "dropdelzpp": 134769998,
    "dropphyadd": "4470 PETERBORO ST",
    "dropphycty": "VERNON",
    "dropphyst": "NY",
    "dropphyzpp": 134769998,
    "dropmaladd": "4470 PETERBORO ST",
    "dropmalcty": "VERNON",
    "dropmalst": "NY",
    "dropmalzpp": 134769998,
    "dropsitphn": 3158293901,
    "dropsitlph": 3158293901,
    "dropsitcph": 3158293901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16682",
    "droptype": "D",
    "dropname": "VERNON CENTER",
    "dropdeladd": "3905 STATE ROUTE 26",
    "dropdelcty": "VERNON CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 134779998,
    "dropphyadd": "3905 STATE ROUTE 26",
    "dropphycty": "VERNON CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 134779998,
    "dropmaladd": "3905 STATE ROUTE 26",
    "dropmalcty": "VERNON CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 134779998,
    "dropsitphn": 3158292150,
    "dropsitlph": 3158292150,
    "dropsitcph": 3158292150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16684",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "5731 ROCK RD",
    "dropdelcty": "VERONA",
    "dropdelst": "NY",
    "dropdelzpp": 134789998,
    "dropphyadd": "5731 ROCK RD",
    "dropphycty": "VERONA",
    "dropphyst": "NY",
    "dropphyzpp": 134789998,
    "dropmaladd": "5731 ROCK RD",
    "dropmalcty": "VERONA",
    "dropmalst": "NY",
    "dropmalzpp": 134789998,
    "dropsitphn": 3153632718,
    "dropsitlph": 3153632718,
    "dropsitcph": 3153632718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16686",
    "droptype": "D",
    "dropname": "VERONA BEACH",
    "dropdeladd": "6783 LAKE SHORE RD N",
    "dropdelcty": "VERONA BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 131629998,
    "dropphyadd": "6783 LAKE SHORE RD N",
    "dropphycty": "VERONA BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 131629998,
    "dropmaladd": "6783 LAKE SHORE RD N",
    "dropmalcty": "VERONA BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 131629998,
    "dropsitphn": 3157625237,
    "dropsitlph": 3157625237,
    "dropsitcph": 3157625237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16687",
    "droptype": "D",
    "dropname": "VERPLANCK",
    "dropdeladd": "174 6TH ST",
    "dropdelcty": "VERPLANCK",
    "dropdelst": "NY",
    "dropdelzpp": 105969800,
    "dropphyadd": "174 6TH ST",
    "dropphycty": "VERPLANCK",
    "dropphyst": "NY",
    "dropphyzpp": 105969800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERPLANCK",
    "dropmalst": "NY",
    "dropmalzpp": 105969998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147372370,
    "dropsitcph": 9147372370,
    "dropfax": 9147881678
  },
  {
    "dcode": "D",
    "dropkey": "PV16690",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "11980 DIVISION ST",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "NY",
    "dropdelzpp": 141689800,
    "dropphyadd": "11980 DIVISION ST",
    "dropphycty": "VERSAILLES",
    "dropphyst": "NY",
    "dropphyzpp": 141689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "NY",
    "dropmalzpp": 141689998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165325718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16693",
    "droptype": "D",
    "dropname": "VESTAL",
    "dropdeladd": "117 RANO BLVD",
    "dropdelcty": "VESTAL",
    "dropdelst": "NY",
    "dropdelzpp": 138509998,
    "dropphyadd": "117 RANO BLVD",
    "dropphycty": "VESTAL",
    "dropphyst": "NY",
    "dropphyzpp": 138509998,
    "dropmaladd": "117 RANO BLVD",
    "dropmalcty": "VESTAL",
    "dropmalst": "NY",
    "dropmalzpp": 138509998,
    "dropsitphn": 6077981772,
    "dropsitlph": 6077981772,
    "dropsitcph": 6077981772,
    "dropfax": 6077981873
  },
  {
    "dcode": "D",
    "dropkey": "PV16699",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "21 FRAMARK DR",
    "dropdelcty": "VICTOR",
    "dropdelst": "NY",
    "dropdelzpp": 145649998,
    "dropphyadd": "21 FRAMARK DR",
    "dropphycty": "VICTOR",
    "dropphyst": "NY",
    "dropphyzpp": 145649998,
    "dropmaladd": "21 FRAMARK DR",
    "dropmalcty": "VICTOR",
    "dropmalst": "NY",
    "dropmalzpp": 145649998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5859243430,
    "dropsitcph": 5859243430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16700",
    "droptype": "D",
    "dropname": "VICTORY MILLS",
    "dropdeladd": "51 GATES AVE",
    "dropdelcty": "VICTORY MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 128849998,
    "dropphyadd": "51 GATES AVE",
    "dropphycty": "VICTORY MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 128849998,
    "dropmaladd": "51 GATES AVE",
    "dropmalcty": "VICTORY MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 128849998,
    "dropsitphn": 5186955353,
    "dropsitlph": 5186955353,
    "dropsitcph": 5186955353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16711",
    "droptype": "D",
    "dropname": "VOORHEESVILLE",
    "dropdeladd": "45 VOORHEESVILLE AVE",
    "dropdelcty": "VOORHEESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121869998,
    "dropphyadd": "45 VOORHEESVILLE AVE",
    "dropphycty": "VOORHEESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121869998,
    "dropmaladd": "45 VOORHEESVILLE AVE",
    "dropmalcty": "VOORHEESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121869998,
    "dropsitphn": 5187654022,
    "dropsitlph": 5187654022,
    "dropsitcph": 5187654022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16765",
    "droptype": "D",
    "dropname": "WACCABUC",
    "dropdeladd": "2 POST OFFICE RD",
    "dropdelcty": "WACCABUC",
    "dropdelst": "NY",
    "dropdelzpp": 105979998,
    "dropphyadd": "2 POST OFFICE RD",
    "dropphycty": "WACCABUC",
    "dropphyst": "NY",
    "dropphyzpp": 105979998,
    "dropmaladd": "2 POST OFFICE RD",
    "dropmalcty": "WACCABUC",
    "dropmalst": "NY",
    "dropmalzpp": 105979998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147633606,
    "dropsitcph": 9147633606,
    "dropfax": 9147630201
  },
  {
    "dcode": "D",
    "dropkey": "PV16766",
    "droptype": "D",
    "dropname": "WADDINGTON",
    "dropdeladd": "23 MAIN ST",
    "dropdelcty": "WADDINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 136949998,
    "dropphyadd": "23 MAIN ST",
    "dropphycty": "WADDINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 136949998,
    "dropmaladd": "23 MAIN ST",
    "dropmalcty": "WADDINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 136949998,
    "dropsitphn": 3153885945,
    "dropsitlph": 3153885945,
    "dropsitcph": 3153885945,
    "dropfax": 3153884026
  },
  {
    "dcode": "D",
    "dropkey": "PV16769",
    "droptype": "D",
    "dropname": "WADING RIVER",
    "dropdeladd": "1816 WADING RIVER MANOR RD",
    "dropdelcty": "WADING RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 117922137,
    "dropphyadd": "1816 WADING RIVER MANOR RD",
    "dropphycty": "WADING RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 117922137,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADING RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 117929998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319290219,
    "dropfax": 6319293806
  },
  {
    "dcode": "D",
    "dropkey": "PV16771",
    "droptype": "D",
    "dropname": "WAINSCOTT",
    "dropdeladd": "357 MONTAUK HWY",
    "dropdelcty": "WAINSCOTT",
    "dropdelst": "NY",
    "dropdelzpp": 119751100,
    "dropphyadd": "357 MONTAUK HWY",
    "dropphycty": "WAINSCOTT",
    "dropphyst": "NY",
    "dropphyzpp": 119751100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAINSCOTT",
    "dropmalst": "NY",
    "dropmalzpp": 119759998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315378943,
    "dropfax": 6315375126
  },
  {
    "dcode": "D",
    "dropkey": "PV16775",
    "droptype": "D",
    "dropname": "WALDEN",
    "dropdeladd": "2 ORANGE AVE",
    "dropdelcty": "WALDEN",
    "dropdelst": "NY",
    "dropdelzpp": 125861883,
    "dropphyadd": "2 ORANGE AVE",
    "dropphycty": "WALDEN",
    "dropphyst": "NY",
    "dropphyzpp": 125861883,
    "dropmaladd": "2 ORANGE AVE",
    "dropmalcty": "WALDEN",
    "dropmalst": "NY",
    "dropmalzpp": 125861883,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457781584,
    "dropsitcph": 8457781584,
    "dropfax": 8457781095
  },
  {
    "dcode": "D",
    "dropkey": "PV16778",
    "droptype": "D",
    "dropname": "WALES CENTER",
    "dropdeladd": "12273 BIG TREE RD",
    "dropdelcty": "WALES CENTER",
    "dropdelst": "NY",
    "dropdelzpp": 141699800,
    "dropphyadd": "12273 BIG TREE RD",
    "dropphycty": "WALES CENTER",
    "dropphyst": "NY",
    "dropphyzpp": 141699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALES CENTER",
    "dropmalst": "NY",
    "dropmalzpp": 141699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166522702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16781",
    "droptype": "D",
    "dropname": "WALKER VALLEY",
    "dropdeladd": "3619 ROUTE 52",
    "dropdelcty": "WALKER VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 125889800,
    "dropphyadd": "3619 ROUTE 52",
    "dropphycty": "WALKER VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 125889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALKER VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 125889998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457442722,
    "dropsitcph": 8457442722,
    "dropfax": 8457444206
  },
  {
    "dcode": "D",
    "dropkey": "PV16787",
    "droptype": "D",
    "dropname": "WALLKILL",
    "dropdeladd": "45 WALLKILL AVE",
    "dropdelcty": "WALLKILL",
    "dropdelst": "NY",
    "dropdelzpp": 125899998,
    "dropphyadd": "45 WALLKILL AVE",
    "dropphycty": "WALLKILL",
    "dropphyst": "NY",
    "dropphyzpp": 125899998,
    "dropmaladd": "45 WALLKILL AVE",
    "dropmalcty": "WALLKILL",
    "dropmalst": "NY",
    "dropmalzpp": 125899998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458951064,
    "dropsitcph": 8458951064,
    "dropfax": 8458958088
  },
  {
    "dcode": "D",
    "dropkey": "PV16789",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "34 GARDINER PL",
    "dropdelcty": "WALTON",
    "dropdelst": "NY",
    "dropdelzpp": 138569998,
    "dropphyadd": "34 GARDINER PL",
    "dropphycty": "WALTON",
    "dropphyst": "NY",
    "dropphyzpp": 138569998,
    "dropmaladd": "34 GARDINER PL",
    "dropmalcty": "WALTON",
    "dropmalst": "NY",
    "dropmalzpp": 138569998,
    "dropsitphn": 6078654289,
    "dropsitlph": 6078654289,
    "dropsitcph": 6078654289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16790",
    "droptype": "D",
    "dropname": "WALWORTH",
    "dropdeladd": "2263 WALWORTH MARION RD",
    "dropdelcty": "WALWORTH",
    "dropdelst": "NY",
    "dropdelzpp": 145689998,
    "dropphyadd": "2263 WALWORTH MARION RD",
    "dropphycty": "WALWORTH",
    "dropphyst": "NY",
    "dropphyzpp": 145689998,
    "dropmaladd": "2263 WALWORTH MARION RD",
    "dropmalcty": "WALWORTH",
    "dropmalst": "NY",
    "dropmalzpp": 145689998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3159861556,
    "dropsitcph": 3159861556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16791",
    "droptype": "D",
    "dropname": "WAMPSVILLE",
    "dropdeladd": "137 N COURT ST",
    "dropdelcty": "WAMPSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 131639998,
    "dropphyadd": "137 N COURT ST",
    "dropphycty": "WAMPSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 131639998,
    "dropmaladd": "137 N COURT ST",
    "dropmalcty": "WAMPSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 131639998,
    "dropsitphn": 3153636397,
    "dropsitlph": 3153636397,
    "dropsitcph": 3153636397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16795",
    "droptype": "D",
    "dropname": "WANAKENA",
    "dropdeladd": "6 HAMELE ST",
    "dropdelcty": "WANAKENA",
    "dropdelst": "NY",
    "dropdelzpp": 136959998,
    "dropphyadd": "6 HAMELE ST",
    "dropphycty": "WANAKENA",
    "dropphyst": "NY",
    "dropphyzpp": 136959998,
    "dropmaladd": "6 HAMELE ST",
    "dropmalcty": "WANAKENA",
    "dropmalst": "NY",
    "dropmalzpp": 136959998,
    "dropsitphn": 3158482580,
    "dropsitlph": 3158482580,
    "dropsitcph": 3158482580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16796",
    "droptype": "D",
    "dropname": "WANTAGH",
    "dropdeladd": "3300 PARK AVE",
    "dropdelcty": "WANTAGH",
    "dropdelst": "NY",
    "dropdelzpp": 117933342,
    "dropphyadd": "3300 PARK AVE",
    "dropphycty": "WANTAGH",
    "dropphyst": "NY",
    "dropphyzpp": 117933342,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WANTAGH",
    "dropmalst": "NY",
    "dropmalzpp": 117939998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167853425,
    "dropfax": 5166795176
  },
  {
    "dcode": "D",
    "dropkey": "PV16798",
    "droptype": "D",
    "dropname": "WAPPINGERS FALLS",
    "dropdeladd": "71 E MAIN ST",
    "dropdelcty": "WAPPINGERS FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 125909998,
    "dropphyadd": "71 E MAIN ST",
    "dropphycty": "WAPPINGERS FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 125909998,
    "dropmaladd": "71 E MAIN ST",
    "dropmalcty": "WAPPINGERS FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 125909998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452971839,
    "dropsitcph": 8452971839,
    "dropfax": 8452972476
  },
  {
    "dcode": "D",
    "dropkey": "PV16801",
    "droptype": "D",
    "dropname": "WARNERS",
    "dropdeladd": "6454 NEWPORT RD",
    "dropdelcty": "WARNERS",
    "dropdelst": "NY",
    "dropdelzpp": 131649998,
    "dropphyadd": "6454 NEWPORT RD",
    "dropphycty": "WARNERS",
    "dropphyst": "NY",
    "dropphyzpp": 131649998,
    "dropmaladd": "6454 NEWPORT RD",
    "dropmalcty": "WARNERS",
    "dropmalst": "NY",
    "dropmalzpp": 131649998,
    "dropsitphn": 3156723246,
    "dropsitlph": 3156723246,
    "dropsitcph": 3156723246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16802",
    "droptype": "D",
    "dropname": "WARNERVILLE",
    "dropdeladd": "1585 STATE ROUTE 7 STE 2",
    "dropdelcty": "WARNERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 121879998,
    "dropphyadd": "1585 STATE ROUTE 7 STE 2",
    "dropphycty": "WARNERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 121879998,
    "dropmaladd": "1585 STATE ROUTE 7 STE 2",
    "dropmalcty": "WARNERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 121879998,
    "dropsitphn": 5182348131,
    "dropsitlph": 5182348131,
    "dropsitcph": 5182348131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16804",
    "droptype": "D",
    "dropname": "WARRENSBURG",
    "dropdeladd": "3930 MAIN ST",
    "dropdelcty": "WARRENSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 128859998,
    "dropphyadd": "3930 MAIN ST",
    "dropphycty": "WARRENSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 128859998,
    "dropmaladd": "3930 MAIN ST",
    "dropmalcty": "WARRENSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 128859998,
    "dropsitphn": 5186234641,
    "dropsitlph": 5186234641,
    "dropsitcph": 5186234641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16805",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "35 S MAIN ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "NY",
    "dropdelzpp": 145699998,
    "dropphyadd": "35 S MAIN ST",
    "dropphycty": "WARSAW",
    "dropphyst": "NY",
    "dropphyzpp": 145699998,
    "dropmaladd": "35 S MAIN ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "NY",
    "dropmalzpp": 145699998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5857862300,
    "dropsitcph": 5857862300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16806",
    "droptype": "D",
    "dropname": "WARWICK",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "WARWICK",
    "dropdelst": "NY",
    "dropdelzpp": 109909998,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "WARWICK",
    "dropphyst": "NY",
    "dropphyzpp": 109909998,
    "dropmaladd": "108 MAIN ST",
    "dropmalcty": "WARWICK",
    "dropmalst": "NY",
    "dropmalzpp": 109909998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459860271,
    "dropsitcph": 8459860271,
    "dropfax": 8459871046
  },
  {
    "dcode": "D",
    "dropkey": "PV16810",
    "droptype": "D",
    "dropname": "WASHINGTON MILLS",
    "dropdeladd": "3910 ONEIDA ST",
    "dropdelcty": "WASHINGTON MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 134799998,
    "dropphyadd": "3910 ONEIDA ST",
    "dropphycty": "WASHINGTON MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 134799998,
    "dropmaladd": "3910 ONEIDA ST",
    "dropmalcty": "WASHINGTON MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 134799998,
    "dropsitphn": 3157378677,
    "dropsitlph": 3157378677,
    "dropsitcph": 3157378677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16811",
    "droptype": "D",
    "dropname": "WASHINGTONVILLE",
    "dropdeladd": "22 BROTHERHOOD PLAZA DR",
    "dropdelcty": "WASHINGTONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 109929998,
    "dropphyadd": "22 BROTHERHOOD PLAZA DR",
    "dropphycty": "WASHINGTONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 109929998,
    "dropmaladd": "22 BROTHERHOOD PLAZA DR",
    "dropmalcty": "WASHINGTONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 109929998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454961129,
    "dropsitcph": 8454961129,
    "dropfax": 8454968797
  },
  {
    "dcode": "D",
    "dropkey": "PV16812",
    "droptype": "D",
    "dropname": "WASSAIC",
    "dropdeladd": "18 MAIN ST",
    "dropdelcty": "WASSAIC",
    "dropdelst": "NY",
    "dropdelzpp": 125929998,
    "dropphyadd": "18 MAIN ST",
    "dropphycty": "WASSAIC",
    "dropphyst": "NY",
    "dropphyzpp": 125929998,
    "dropmaladd": "18 MAIN ST",
    "dropmalcty": "WASSAIC",
    "dropmalst": "NY",
    "dropmalzpp": 125929998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453738382,
    "dropsitcph": 8453738382,
    "dropfax": 8453738726
  },
  {
    "dcode": "D",
    "dropkey": "PV16814",
    "droptype": "D",
    "dropname": "WATER MILL",
    "dropdeladd": "670 MONTAUK HWY",
    "dropdelcty": "WATER MILL",
    "dropdelst": "NY",
    "dropdelzpp": 119762641,
    "dropphyadd": "670 MONTAUK HWY",
    "dropphycty": "WATER MILL",
    "dropphyst": "NY",
    "dropphyzpp": 119762641,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATER MILL",
    "dropmalst": "NY",
    "dropmalzpp": 119769998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317266310,
    "dropfax": 6317266742
  },
  {
    "dcode": "D",
    "dropkey": "PV16815",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "57 4TH ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "NY",
    "dropdelzpp": 121889998,
    "dropphyadd": "57 4TH ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "NY",
    "dropphyzpp": 121889998,
    "dropmaladd": "57 4TH ST",
    "dropmalcty": "WATERFORD",
    "dropmalst": "NY",
    "dropmalzpp": 121889998,
    "dropsitphn": 5182351733,
    "dropsitlph": 5182351733,
    "dropsitcph": 5182351733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16816",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "NY",
    "dropdelzpp": 131659998,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "NY",
    "dropphyzpp": 131659998,
    "dropmaladd": "2 E MAIN ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "NY",
    "dropmalzpp": 131659998,
    "dropsitphn": 3155395058,
    "dropsitlph": 3155395058,
    "dropsitcph": 3155395058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16817",
    "droptype": "D",
    "dropname": "WATERPORT",
    "dropdeladd": "1975 MAIN ST",
    "dropdelcty": "WATERPORT",
    "dropdelst": "NY",
    "dropdelzpp": 145719998,
    "dropphyadd": "1975 MAIN ST",
    "dropphycty": "WATERPORT",
    "dropphyst": "NY",
    "dropphyzpp": 145719998,
    "dropmaladd": "1975 MAIN ST",
    "dropmalcty": "WATERPORT",
    "dropmalst": "NY",
    "dropmalzpp": 145719998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856823384,
    "dropsitcph": 5856823384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16820",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "232 COMMERCE PARK DR",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 136019998,
    "dropphyadd": "232 COMMERCE PARK DR",
    "dropphycty": "WATERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 136019998,
    "dropmaladd": "232 COMMERCE PARK DR",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 136019998,
    "dropsitphn": 3157865982,
    "dropsitlph": 3157865982,
    "dropsitcph": 3157865982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16824",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134809998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "WATERVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134809998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134809998,
    "dropsitphn": 3158418721,
    "dropsitlph": 3158418721,
    "dropsitcph": 3158418721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16825",
    "droptype": "D",
    "dropname": "WATERVLIET",
    "dropdeladd": "145 16TH ST",
    "dropdelcty": "WATERVLIET",
    "dropdelst": "NY",
    "dropdelzpp": 121899998,
    "dropphyadd": "145 16TH ST",
    "dropphycty": "WATERVLIET",
    "dropphyst": "NY",
    "dropphyzpp": 121899998,
    "dropmaladd": "145 16TH ST",
    "dropmalcty": "WATERVLIET",
    "dropmalst": "NY",
    "dropmalzpp": 121899998,
    "dropsitphn": 5182730423,
    "dropsitlph": 5182730423,
    "dropsitcph": 5182730423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16826",
    "droptype": "D",
    "dropname": "WATKINS GLEN",
    "dropdeladd": "600 N FRANKLIN ST",
    "dropdelcty": "WATKINS GLEN",
    "dropdelst": "NY",
    "dropdelzpp": 148919998,
    "dropphyadd": "600 N FRANKLIN ST",
    "dropphycty": "WATKINS GLEN",
    "dropphyst": "NY",
    "dropphyzpp": 148919998,
    "dropmaladd": "600 N FRANKLIN ST",
    "dropmalcty": "WATKINS GLEN",
    "dropmalst": "NY",
    "dropmalzpp": 148919998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075354452,
    "dropsitcph": 6075354452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16829",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "434 WAVERLY ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "NY",
    "dropdelzpp": 148929998,
    "dropphyadd": "434 WAVERLY ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "NY",
    "dropphyzpp": 148929998,
    "dropmaladd": "434 WAVERLY ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "NY",
    "dropmalzpp": 148929998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6075652021,
    "dropsitcph": 6075652021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16830",
    "droptype": "D",
    "dropname": "WAWARSING",
    "dropdeladd": "7199 ROUTE 209",
    "dropdelcty": "WAWARSING",
    "dropdelst": "NY",
    "dropdelzpp": 124899800,
    "dropphyadd": "7199 ROUTE 209",
    "dropphycty": "WAWARSING",
    "dropphyst": "NY",
    "dropphyzpp": 124899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAWARSING",
    "dropmalst": "NY",
    "dropmalzpp": 124899998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456474520,
    "dropsitcph": 8456474520,
    "dropfax": 8456474520
  },
  {
    "dcode": "D",
    "dropkey": "PV16831",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "23 E NAPLES ST",
    "dropdelcty": "WAYLAND",
    "dropdelst": "NY",
    "dropdelzpp": 145729998,
    "dropphyadd": "23 E NAPLES ST",
    "dropphycty": "WAYLAND",
    "dropphyst": "NY",
    "dropphyzpp": 145729998,
    "dropmaladd": "23 E NAPLES ST",
    "dropmalcty": "WAYLAND",
    "dropmalst": "NY",
    "dropmalzpp": 145729998,
    "dropsitphn": 5857281005,
    "dropsitlph": 5857281005,
    "dropsitcph": 5857281005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16832",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "4894 COUNTY ROUTE 26",
    "dropdelcty": "WAYNE",
    "dropdelst": "NY",
    "dropdelzpp": 148939800,
    "dropphyadd": "4894 COUNTY ROUTE 26",
    "dropphycty": "WAYNE",
    "dropphyst": "NY",
    "dropphyzpp": 148939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYNE",
    "dropmalst": "NY",
    "dropmalzpp": 148939998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072926300,
    "dropsitcph": 6072926300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16833",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "75 BARRETT DR",
    "dropdelcty": "WEBSTER",
    "dropdelst": "NY",
    "dropdelzpp": 145809998,
    "dropphyadd": "75 BARRETT DR",
    "dropphycty": "WEBSTER",
    "dropphyst": "NY",
    "dropphyzpp": 145809998,
    "dropmaladd": "75 BARRETT DR",
    "dropmalcty": "WEBSTER",
    "dropmalst": "NY",
    "dropmalzpp": 145809998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5858723750,
    "dropsitcph": 5858723009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16836",
    "droptype": "D",
    "dropname": "WEEDSPORT",
    "dropdeladd": "8942 N SENECA ST",
    "dropdelcty": "WEEDSPORT",
    "dropdelst": "NY",
    "dropdelzpp": 131669998,
    "dropphyadd": "8942 N SENECA ST",
    "dropphycty": "WEEDSPORT",
    "dropphyst": "NY",
    "dropphyzpp": 131669998,
    "dropmaladd": "8942 N SENECA ST",
    "dropmalcty": "WEEDSPORT",
    "dropmalst": "NY",
    "dropmalzpp": 131669998,
    "dropsitphn": 3158349247,
    "dropsitlph": 3158349247,
    "dropsitcph": 3158349247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16840",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "1431 STATE ROUTE 30",
    "dropdelcty": "WELLS",
    "dropdelst": "NY",
    "dropdelzpp": 121909998,
    "dropphyadd": "1431 STATE ROUTE 30",
    "dropphycty": "WELLS",
    "dropphyst": "NY",
    "dropphyzpp": 121909998,
    "dropmaladd": "1431 STATE ROUTE 30",
    "dropmalcty": "WELLS",
    "dropmalst": "NY",
    "dropmalzpp": 121909998,
    "dropsitphn": 5189245991,
    "dropsitlph": 5189245991,
    "dropsitcph": 5189245991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16842",
    "droptype": "D",
    "dropname": "WELLS BRIDGE",
    "dropdeladd": "116 COUNTY HIGHWAY 4",
    "dropdelcty": "WELLS BRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 138599998,
    "dropphyadd": "116 COUNTY HIGHWAY 4",
    "dropphycty": "WELLS BRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 138599998,
    "dropmaladd": "116 COUNTY HIGHWAY 4",
    "dropmalcty": "WELLS BRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 138599998,
    "dropsitphn": 6079887750,
    "dropsitlph": 6079887750,
    "dropsitcph": 6079887750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16844",
    "droptype": "D",
    "dropname": "WELLSBURG",
    "dropdeladd": "3685 FRONT ST",
    "dropdelcty": "WELLSBURG",
    "dropdelst": "NY",
    "dropdelzpp": 148949998,
    "dropphyadd": "3685 FRONT ST",
    "dropphycty": "WELLSBURG",
    "dropphyst": "NY",
    "dropphyzpp": 148949998,
    "dropmaladd": "3685 FRONT ST",
    "dropmalcty": "WELLSBURG",
    "dropmalst": "NY",
    "dropmalzpp": 148949998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077324993,
    "dropsitcph": 6077324993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16845",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "40 E PEARL ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 148959998,
    "dropphyadd": "40 E PEARL ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 148959998,
    "dropmaladd": "40 E PEARL ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 148959998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5855933940,
    "dropsitcph": 5855933940,
    "dropfax": 5855934656
  },
  {
    "dcode": "D",
    "dropkey": "PV16856",
    "droptype": "D",
    "dropname": "WEST BLOOMFIELD",
    "dropdeladd": "9222 STATE ROUTE 5 AND 20",
    "dropdelcty": "WEST BLOOMFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 145859998,
    "dropphyadd": "9222 STATE ROUTE 5 AND 20",
    "dropphycty": "WEST BLOOMFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 145859998,
    "dropmaladd": "9222 STATE ROUTE 5 AND 20",
    "dropmalcty": "WEST BLOOMFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 145859998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856241890,
    "dropsitcph": 5856241890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16859",
    "droptype": "D",
    "dropname": "WEST BURLINGTON",
    "dropdeladd": "2353 STATE HIGHWAY 80",
    "dropdelcty": "WEST BURLINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 134829998,
    "dropphyadd": "2353 STATE HIGHWAY 80",
    "dropphycty": "WEST BURLINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 134829998,
    "dropmaladd": "2353 STATE HIGHWAY 80",
    "dropmalcty": "WEST BURLINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 134829998,
    "dropsitphn": 6079658068,
    "dropsitlph": 6079658068,
    "dropsitcph": 6079658068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16861",
    "droptype": "D",
    "dropname": "WEST CAMP",
    "dropdeladd": "4294 ROUTE 9W",
    "dropdelcty": "WEST CAMP",
    "dropdelst": "NY",
    "dropdelzpp": 124909800,
    "dropphyadd": "4294 ROUTE 9W",
    "dropphycty": "WEST CAMP",
    "dropphyst": "NY",
    "dropphyzpp": 124909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST CAMP",
    "dropmalst": "NY",
    "dropmalzpp": 124909998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452463434,
    "dropsitcph": 8452463434,
    "dropfax": 8452465780
  },
  {
    "dcode": "D",
    "dropkey": "PV16865",
    "droptype": "D",
    "dropname": "WEST CHAZY",
    "dropdeladd": "7634 STATE ROUTE 22",
    "dropdelcty": "WEST CHAZY",
    "dropdelst": "NY",
    "dropdelzpp": 129929998,
    "dropphyadd": "7634 STATE ROUTE 22",
    "dropphycty": "WEST CHAZY",
    "dropphyst": "NY",
    "dropphyzpp": 129929998,
    "dropmaladd": "7634 STATE ROUTE 22",
    "dropmalcty": "WEST CHAZY",
    "dropmalst": "NY",
    "dropmalzpp": 129929998,
    "dropsitphn": 5184936381,
    "dropsitlph": 5184936381,
    "dropsitcph": 5184936381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16867",
    "droptype": "D",
    "dropname": "WEST CLARKSVILLE",
    "dropdeladd": "2941 ROUTE 305",
    "dropdelcty": "WEST CLARKSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 147869800,
    "dropphyadd": "2941 ROUTE 305",
    "dropphycty": "WEST CLARKSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 147869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST CLARKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 147869998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 5859681786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16876",
    "droptype": "D",
    "dropname": "WEST DAVENPORT",
    "dropdeladd": "37 CHARLOTTE CREEK RD",
    "dropdelcty": "WEST DAVENPORT",
    "dropdelst": "NY",
    "dropdelzpp": 138609998,
    "dropphyadd": "37 CHARLOTTE CREEK RD",
    "dropphycty": "WEST DAVENPORT",
    "dropphyst": "NY",
    "dropphyzpp": 138609998,
    "dropmaladd": "37 CHARLOTTE CREEK RD",
    "dropmalcty": "WEST DAVENPORT",
    "dropmalst": "NY",
    "dropmalzpp": 138609998,
    "dropsitphn": 6074319428,
    "dropsitlph": 6074319428,
    "dropsitcph": 6074319428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16880",
    "droptype": "D",
    "dropname": "WEST EATON",
    "dropdeladd": "3328 STATE ROUTE 26",
    "dropdelcty": "WEST EATON",
    "dropdelst": "NY",
    "dropdelzpp": 134849998,
    "dropphyadd": "3328 STATE ROUTE 26",
    "dropphycty": "WEST EATON",
    "dropphyst": "NY",
    "dropphyzpp": 134849998,
    "dropmaladd": "3328 STATE ROUTE 26",
    "dropmalcty": "WEST EATON",
    "dropmalst": "NY",
    "dropmalzpp": 134849998,
    "dropsitphn": 3156843865,
    "dropsitlph": 3156843865,
    "dropsitcph": 3156843865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16881",
    "droptype": "D",
    "dropname": "WEST EDMESTON",
    "dropdeladd": "140 COUNTY HIGHWAY 18C",
    "dropdelcty": "WEST EDMESTON",
    "dropdelst": "NY",
    "dropdelzpp": 134859998,
    "dropphyadd": "140 COUNTY HIGHWAY 18C",
    "dropphycty": "WEST EDMESTON",
    "dropphyst": "NY",
    "dropphyzpp": 134859998,
    "dropmaladd": "140 COUNTY HIGHWAY 18C",
    "dropmalcty": "WEST EDMESTON",
    "dropmalst": "NY",
    "dropmalzpp": 134859998,
    "dropsitphn": 3158554175,
    "dropsitlph": 3158554175,
    "dropsitcph": 3158554175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16886",
    "droptype": "D",
    "dropname": "WEST FALLS",
    "dropdeladd": "17 ELLICOTT RD",
    "dropdelcty": "WEST FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 141709998,
    "dropphyadd": "17 ELLICOTT RD",
    "dropphycty": "WEST FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 141709998,
    "dropmaladd": "17 ELLICOTT RD",
    "dropmalcty": "WEST FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 141709998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166524280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16890",
    "droptype": "D",
    "dropname": "WEST FULTON",
    "dropdeladd": "832 W FULTON RD STE 1",
    "dropdelcty": "WEST FULTON",
    "dropdelst": "NY",
    "dropdelzpp": 121949900,
    "dropphyadd": "832 W FULTON RD STE 1",
    "dropphycty": "WEST FULTON",
    "dropphyst": "NY",
    "dropphyzpp": 121949900,
    "dropmaladd": "832 W FULTON RD STE 1",
    "dropmalcty": "WEST FULTON",
    "dropmalst": "NY",
    "dropmalzpp": 121949900,
    "dropsitphn": 5188275116,
    "dropsitlph": 5188275116,
    "dropsitcph": 5188275116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16897",
    "droptype": "D",
    "dropname": "WEST HAVERSTRAW",
    "dropdeladd": "71 S ROUTE 9W STE 7",
    "dropdelcty": "WEST HAVERSTRAW",
    "dropdelst": "NY",
    "dropdelzpp": 109939998,
    "dropphyadd": "71 S ROUTE 9W STE 7",
    "dropphycty": "WEST HAVERSTRAW",
    "dropphyst": "NY",
    "dropphyzpp": 109939998,
    "dropmaladd": "71 S ROUTE 9W STE 7",
    "dropmalcty": "WEST HAVERSTRAW",
    "dropmalst": "NY",
    "dropmalzpp": 109939998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459473405,
    "dropsitcph": 8459473405,
    "dropfax": 8454291829
  },
  {
    "dcode": "D",
    "dropkey": "PV16900",
    "droptype": "D",
    "dropname": "WEST HENRIETTA",
    "dropdeladd": "772 ERIE STATION RD",
    "dropdelcty": "WEST HENRIETTA",
    "dropdelst": "NY",
    "dropdelzpp": 145869998,
    "dropphyadd": "772 ERIE STATION RD",
    "dropphycty": "WEST HENRIETTA",
    "dropphyst": "NY",
    "dropphyzpp": 145869998,
    "dropmaladd": "772 ERIE STATION RD",
    "dropmalcty": "WEST HENRIETTA",
    "dropmalst": "NY",
    "dropmalzpp": 145869998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853345954,
    "dropsitcph": 5853345954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16903",
    "droptype": "D",
    "dropname": "WEST HURLEY",
    "dropdeladd": "1300 STATE ROUTE 28",
    "dropdelcty": "WEST HURLEY",
    "dropdelst": "NY",
    "dropdelzpp": 124919998,
    "dropphyadd": "1300 STATE ROUTE 28",
    "dropphycty": "WEST HURLEY",
    "dropphyst": "NY",
    "dropphyzpp": 124919998,
    "dropmaladd": "1300 STATE ROUTE 28",
    "dropmalcty": "WEST HURLEY",
    "dropmalst": "NY",
    "dropmalzpp": 124919998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456792938,
    "dropsitcph": 8456792938,
    "dropfax": 8456795741
  },
  {
    "dcode": "D",
    "dropkey": "PV16904",
    "droptype": "D",
    "dropname": "WEST ISLIP",
    "dropdeladd": "480 UNION BLVD",
    "dropdelcty": "WEST ISLIP",
    "dropdelst": "NY",
    "dropdelzpp": 117953106,
    "dropphyadd": "480 UNION BLVD",
    "dropphycty": "WEST ISLIP",
    "dropphyst": "NY",
    "dropphyzpp": 117953106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST ISLIP",
    "dropmalst": "NY",
    "dropmalzpp": 117959998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316695157,
    "dropfax": 6314223724
  },
  {
    "dcode": "D",
    "dropkey": "PV16905",
    "droptype": "D",
    "dropname": "WEST KILL",
    "dropdeladd": "30 SPRUCETON RD",
    "dropdelcty": "WEST KILL",
    "dropdelst": "NY",
    "dropdelzpp": 124929998,
    "dropphyadd": "30 SPRUCETON RD",
    "dropphycty": "WEST KILL",
    "dropphyst": "NY",
    "dropphyzpp": 124929998,
    "dropmaladd": "30 SPRUCETON RD",
    "dropmalcty": "WEST KILL",
    "dropmalst": "NY",
    "dropmalzpp": 124929998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5189896700,
    "dropsitcph": 5189896700,
    "dropfax": 5189896700
  },
  {
    "dcode": "D",
    "dropkey": "PV16909",
    "droptype": "D",
    "dropname": "WEST LEBANON",
    "dropdeladd": "1533 STATE ROUTE 20",
    "dropdelcty": "WEST LEBANON",
    "dropdelst": "NY",
    "dropdelzpp": 121959998,
    "dropphyadd": "1533 STATE ROUTE 20",
    "dropphycty": "WEST LEBANON",
    "dropphyst": "NY",
    "dropphyzpp": 121959998,
    "dropmaladd": "1533 STATE ROUTE 20",
    "dropmalcty": "WEST LEBANON",
    "dropmalst": "NY",
    "dropmalzpp": 121959998,
    "dropsitphn": 5187948660,
    "dropsitlph": 5187948660,
    "dropsitcph": 5187948660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16911",
    "droptype": "D",
    "dropname": "WEST LEYDEN",
    "dropdeladd": "1054 STATE ROUTE 26",
    "dropdelcty": "WEST LEYDEN",
    "dropdelst": "NY",
    "dropdelzpp": 134899998,
    "dropphyadd": "1054 STATE ROUTE 26",
    "dropphycty": "WEST LEYDEN",
    "dropphyst": "NY",
    "dropphyzpp": 134899998,
    "dropmaladd": "1054 STATE ROUTE 26",
    "dropmalcty": "WEST LEYDEN",
    "dropmalst": "NY",
    "dropmalzpp": 134899998,
    "dropsitphn": 3159422081,
    "dropsitlph": 3159422081,
    "dropsitcph": 3159422081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16917",
    "droptype": "D",
    "dropname": "WEST MONROE",
    "dropdeladd": "2301 STATE ROUTE 49",
    "dropdelcty": "WEST MONROE",
    "dropdelst": "NY",
    "dropdelzpp": 131679998,
    "dropphyadd": "2301 STATE ROUTE 49",
    "dropphycty": "WEST MONROE",
    "dropphyst": "NY",
    "dropphyzpp": 131679998,
    "dropmaladd": "2301 STATE ROUTE 49",
    "dropmalcty": "WEST MONROE",
    "dropmalst": "NY",
    "dropmalzpp": 131679998,
    "dropsitphn": 3156682856,
    "dropsitlph": 3156682856,
    "dropsitcph": 3156682856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16923",
    "droptype": "D",
    "dropname": "WEST NYACK",
    "dropdeladd": "720 W NYACK RD",
    "dropdelcty": "WEST NYACK",
    "dropdelst": "NY",
    "dropdelzpp": 109949998,
    "dropphyadd": "720 W NYACK RD",
    "dropphycty": "WEST NYACK",
    "dropphyst": "NY",
    "dropphyzpp": 109949998,
    "dropmaladd": "720 W NYACK RD",
    "dropmalcty": "WEST NYACK",
    "dropmalst": "NY",
    "dropmalzpp": 109949998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453582791,
    "dropsitcph": 8453582791,
    "dropfax": 8453587045
  },
  {
    "dcode": "D",
    "dropkey": "PV16924",
    "droptype": "D",
    "dropname": "WEST ONEONTA",
    "dropdeladd": "3912 STATE HIGHWAY 23",
    "dropdelcty": "WEST ONEONTA",
    "dropdelst": "NY",
    "dropdelzpp": 138619998,
    "dropphyadd": "3912 STATE HIGHWAY 23",
    "dropphycty": "WEST ONEONTA",
    "dropphyst": "NY",
    "dropphyzpp": 138619998,
    "dropmaladd": "3912 STATE HIGHWAY 23",
    "dropmalcty": "WEST ONEONTA",
    "dropmalst": "NY",
    "dropmalzpp": 138619998,
    "dropsitphn": 6074325860,
    "dropsitlph": 6074325860,
    "dropsitcph": 6074325860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16926",
    "droptype": "D",
    "dropname": "WEST PARK",
    "dropdeladd": "1740 ROUTE 9W",
    "dropdelcty": "WEST PARK",
    "dropdelst": "NY",
    "dropdelzpp": 124939800,
    "dropphyadd": "1740 ROUTE 9W",
    "dropphycty": "WEST PARK",
    "dropphyst": "NY",
    "dropphyzpp": 124939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST PARK",
    "dropmalst": "NY",
    "dropmalzpp": 124939998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8453846717,
    "dropfax": 8453846717
  },
  {
    "dcode": "D",
    "dropkey": "PV16929",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "634 SWIFT RD",
    "dropdelcty": "WEST POINT",
    "dropdelst": "NY",
    "dropdelzpp": 109961938,
    "dropphyadd": "634 SWIFT RD",
    "dropphycty": "WEST POINT",
    "dropphyst": "NY",
    "dropphyzpp": 109961938,
    "dropmaladd": "634 SWIFT RD",
    "dropmalcty": "WEST POINT",
    "dropmalst": "NY",
    "dropmalzpp": 109961938,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454468749,
    "dropsitcph": 8454468749,
    "dropfax": 8454466908
  },
  {
    "dcode": "D",
    "dropkey": "PV16937",
    "droptype": "D",
    "dropname": "WEST SAND LAKE",
    "dropdeladd": "38 MALL WAY",
    "dropdelcty": "WEST SAND LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 121969998,
    "dropphyadd": "38 MALL WAY",
    "dropphycty": "WEST SAND LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 121969998,
    "dropmaladd": "38 MALL WAY",
    "dropmalcty": "WEST SAND LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 121969998,
    "dropsitphn": 5186745661,
    "dropsitlph": 5186745661,
    "dropsitcph": 5186745661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16939",
    "droptype": "D",
    "dropname": "WEST SAYVILLE",
    "dropdeladd": "12 WASHINGTON AVE",
    "dropdelcty": "WEST SAYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 117961605,
    "dropphyadd": "12 WASHINGTON AVE",
    "dropphycty": "WEST SAYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 117961605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST SAYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 117969998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6315896958,
    "dropfax": 6315638141
  },
  {
    "dcode": "D",
    "dropkey": "PV16944",
    "droptype": "D",
    "dropname": "WEST SHOKAN",
    "dropdeladd": "4079 STATE ROUTE 28A",
    "dropdelcty": "WEST SHOKAN",
    "dropdelst": "NY",
    "dropdelzpp": 124949998,
    "dropphyadd": "4079 STATE ROUTE 28A",
    "dropphycty": "WEST SHOKAN",
    "dropphyst": "NY",
    "dropphyzpp": 124949998,
    "dropmaladd": "4079 STATE ROUTE 28A",
    "dropmalcty": "WEST SHOKAN",
    "dropmalst": "NY",
    "dropmalzpp": 124949998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8459473405,
    "dropsitcph": 8456572307,
    "dropfax": 8456572307
  },
  {
    "dcode": "D",
    "dropkey": "PV16948",
    "droptype": "D",
    "dropname": "WEST STOCKHOLM",
    "dropdeladd": "9 LIVINGSTON RD",
    "dropdelcty": "WEST STOCKHOLM",
    "dropdelst": "NY",
    "dropdelzpp": 136969998,
    "dropphyadd": "9 LIVINGSTON RD",
    "dropphycty": "WEST STOCKHOLM",
    "dropphyst": "NY",
    "dropphyzpp": 136969998,
    "dropmaladd": "9 LIVINGSTON RD",
    "dropmalcty": "WEST STOCKHOLM",
    "dropmalst": "NY",
    "dropmalzpp": 136969998,
    "dropsitphn": 3152655487,
    "dropsitlph": 3152655487,
    "dropsitcph": 3152655487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16952",
    "droptype": "D",
    "dropname": "WEST VALLEY",
    "dropdeladd": "9386 ROUTE 240",
    "dropdelcty": "WEST VALLEY",
    "dropdelst": "NY",
    "dropdelzpp": 141719998,
    "dropphyadd": "9386 ROUTE 240",
    "dropphycty": "WEST VALLEY",
    "dropphyst": "NY",
    "dropphyzpp": 141719998,
    "dropmaladd": "9386 ROUTE 240",
    "dropmalcty": "WEST VALLEY",
    "dropmalst": "NY",
    "dropmalzpp": 141719998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7169423221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16958",
    "droptype": "D",
    "dropname": "WEST WINFIELD",
    "dropdeladd": "376 W MAIN ST",
    "dropdelcty": "WEST WINFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 134919998,
    "dropphyadd": "376 W MAIN ST",
    "dropphycty": "WEST WINFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 134919998,
    "dropmaladd": "376 W MAIN ST",
    "dropmalcty": "WEST WINFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 134919998,
    "dropsitphn": 3158225350,
    "dropsitlph": 3158225350,
    "dropsitcph": 3158225350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16962",
    "droptype": "D",
    "dropname": "WESTBURY",
    "dropdeladd": "360 MAPLE AVE",
    "dropdelcty": "WESTBURY",
    "dropdelst": "NY",
    "dropdelzpp": 115907576,
    "dropphyadd": "360 MAPLE AVE",
    "dropphycty": "WESTBURY",
    "dropphyst": "NY",
    "dropphyzpp": 115907576,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTBURY",
    "dropmalst": "NY",
    "dropmalzpp": 115909998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163333598,
    "dropfax": 5163341817
  },
  {
    "dcode": "D",
    "dropkey": "PV16966",
    "droptype": "D",
    "dropname": "WESTDALE",
    "dropdeladd": "11129 STATE ROUTE 13",
    "dropdelcty": "WESTDALE",
    "dropdelst": "NY",
    "dropdelzpp": 134839998,
    "dropphyadd": "11129 STATE ROUTE 13",
    "dropphycty": "WESTDALE",
    "dropphyst": "NY",
    "dropphyzpp": 134839998,
    "dropmaladd": "11129 STATE ROUTE 13",
    "dropmalcty": "WESTDALE",
    "dropmalst": "NY",
    "dropmalzpp": 134839998,
    "dropsitphn": 3152450744,
    "dropsitlph": 3152450744,
    "dropsitcph": 3152450744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16967",
    "droptype": "D",
    "dropname": "WESTERLO",
    "dropdeladd": "591 STATE ROUTE 143",
    "dropdelcty": "WESTERLO",
    "dropdelst": "NY",
    "dropdelzpp": 121939998,
    "dropphyadd": "591 STATE ROUTE 143",
    "dropphycty": "WESTERLO",
    "dropphyst": "NY",
    "dropphyzpp": 121939998,
    "dropmaladd": "591 STATE ROUTE 143",
    "dropmalcty": "WESTERLO",
    "dropmalst": "NY",
    "dropmalzpp": 121939998,
    "dropsitphn": 5187973103,
    "dropsitlph": 5187973103,
    "dropsitcph": 5187973103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16970",
    "droptype": "D",
    "dropname": "WESTERN NASSAU",
    "dropdeladd": "830 STEWART AVE",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "NY",
    "dropdelzpp": 115999998,
    "dropphyadd": "830 STEWART AVE",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "NY",
    "dropphyzpp": 115999998,
    "dropmaladd": "830 STEWART AVE",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "NY",
    "dropmalzpp": 115999998,
    "dropsitphn": 5162287601,
    "dropsitlph": 5162287614,
    "dropsitcph": 5162287502,
    "dropfax": 5162287555
  },
  {
    "dcode": "D",
    "dropkey": "PV16972",
    "droptype": "D",
    "dropname": "WESTERNVILLE",
    "dropdeladd": "7638 GIFFORD HILL RD",
    "dropdelcty": "WESTERNVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134869998,
    "dropphyadd": "7638 GIFFORD HILL RD",
    "dropphycty": "WESTERNVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134869998,
    "dropmaladd": "7638 GIFFORD HILL RD",
    "dropmalcty": "WESTERNVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134869998,
    "dropsitphn": 3158274146,
    "dropsitlph": 3158274146,
    "dropsitcph": 3158274146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16973",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "7 ACADEMY ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "NY",
    "dropdelzpp": 147879998,
    "dropphyadd": "7 ACADEMY ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "NY",
    "dropphyzpp": 147879998,
    "dropmaladd": "7 ACADEMY ST",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "NY",
    "dropmalzpp": 147879998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163262841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16974",
    "droptype": "D",
    "dropname": "WESTFORD",
    "dropdeladd": "1743 COUNTY HIGHWAY 34",
    "dropdelcty": "WESTFORD",
    "dropdelst": "NY",
    "dropdelzpp": 134889998,
    "dropphyadd": "1743 COUNTY HIGHWAY 34",
    "dropphycty": "WESTFORD",
    "dropphyst": "NY",
    "dropphyzpp": 134889998,
    "dropmaladd": "1743 COUNTY HIGHWAY 34",
    "dropmalcty": "WESTFORD",
    "dropmalst": "NY",
    "dropmalzpp": 134889998,
    "dropsitphn": 6076389382,
    "dropsitlph": 6076389382,
    "dropsitcph": 6076389382,
    "dropfax": 6076385140
  },
  {
    "dcode": "D",
    "dropkey": "PV16976",
    "droptype": "D",
    "dropname": "WESTHAMPTON",
    "dropdeladd": "408 MILL RD",
    "dropdelcty": "WESTHAMPTON",
    "dropdelst": "NY",
    "dropdelzpp": 119771209,
    "dropphyadd": "408 MILL RD",
    "dropphycty": "WESTHAMPTON",
    "dropphyst": "NY",
    "dropphyzpp": 119771209,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTHAMPTON",
    "dropmalst": "NY",
    "dropmalzpp": 119779998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312884081,
    "dropfax": 6312882608
  },
  {
    "dcode": "D",
    "dropkey": "PV16978",
    "droptype": "D",
    "dropname": "WESTHAMPTON BEACH",
    "dropdeladd": "170 MAIN ST",
    "dropdelcty": "WESTHAMPTON BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 119782726,
    "dropphyadd": "170 MAIN ST",
    "dropphycty": "WESTHAMPTON BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 119782726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTHAMPTON BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 119789998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6312884093,
    "dropfax": 6312885718
  },
  {
    "dcode": "D",
    "dropkey": "PV16981",
    "droptype": "D",
    "dropname": "WESTMORELAND",
    "dropdeladd": "5281 STATE ROUTE 233",
    "dropdelcty": "WESTMORELAND",
    "dropdelst": "NY",
    "dropdelzpp": 134909998,
    "dropphyadd": "5281 STATE ROUTE 233",
    "dropphycty": "WESTMORELAND",
    "dropphyst": "NY",
    "dropphyzpp": 134909998,
    "dropmaladd": "5281 STATE ROUTE 233",
    "dropmalcty": "WESTMORELAND",
    "dropmalst": "NY",
    "dropmalzpp": 134909998,
    "dropsitphn": 3158532832,
    "dropsitlph": 3158532832,
    "dropsitcph": 3158532832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16983",
    "droptype": "D",
    "dropname": "WESTONS MILLS",
    "dropdeladd": "1319 OLEAN PORTVILLE RD",
    "dropdelcty": "WESTONS MILLS",
    "dropdelst": "NY",
    "dropdelzpp": 147889800,
    "dropphyadd": "1319 OLEAN PORTVILLE RD",
    "dropphycty": "WESTONS MILLS",
    "dropphyst": "NY",
    "dropphyzpp": 147889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTONS MILLS",
    "dropmalst": "NY",
    "dropmalzpp": 147889998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7163728111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16985",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "9 HARRIS LN",
    "dropdelcty": "WESTPORT",
    "dropdelst": "NY",
    "dropdelzpp": 129939998,
    "dropphyadd": "9 HARRIS LN",
    "dropphycty": "WESTPORT",
    "dropphyst": "NY",
    "dropphyzpp": 129939998,
    "dropmaladd": "9 HARRIS LN",
    "dropmalcty": "WESTPORT",
    "dropmalst": "NY",
    "dropmalzpp": 129939998,
    "dropsitphn": 5189624498,
    "dropsitlph": 5189624498,
    "dropsitcph": 5189624498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV16986",
    "droptype": "D",
    "dropname": "WESTTOWN",
    "dropdeladd": "2097 COUNTY ROUTE 1",
    "dropdelcty": "WESTTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 109989998,
    "dropphyadd": "2097 COUNTY ROUTE 1",
    "dropphycty": "WESTTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 109989998,
    "dropmaladd": "2097 COUNTY ROUTE 1",
    "dropmalcty": "WESTTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 109989998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457265026,
    "dropsitcph": 8457265026,
    "dropfax": 8457265026
  },
  {
    "dcode": "D",
    "dropkey": "PV16992",
    "droptype": "D",
    "dropname": "WEVERTOWN",
    "dropdeladd": "3854 STATE ROUTE 8",
    "dropdelcty": "WEVERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 128869998,
    "dropphyadd": "3854 STATE ROUTE 8",
    "dropphycty": "WEVERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 128869998,
    "dropmaladd": "3854 STATE ROUTE 8",
    "dropmalcty": "WEVERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 128869998,
    "dropsitphn": 5182513791,
    "dropsitlph": 5182513791,
    "dropsitcph": 5182513791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17007",
    "droptype": "D",
    "dropname": "WHITE LAKE",
    "dropdeladd": "1447 STATE ROUTE 17B",
    "dropdelcty": "WHITE LAKE",
    "dropdelst": "NY",
    "dropdelzpp": 127869998,
    "dropphyadd": "1447 STATE ROUTE 17B",
    "dropphycty": "WHITE LAKE",
    "dropphyst": "NY",
    "dropphyzpp": 127869998,
    "dropmaladd": "1447 STATE ROUTE 17B",
    "dropmalcty": "WHITE LAKE",
    "dropmalst": "NY",
    "dropmalzpp": 127869998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455836410,
    "dropsitcph": 8455836410,
    "dropfax": 8455836410
  },
  {
    "dcode": "D",
    "dropkey": "PV17010",
    "droptype": "D",
    "dropname": "WHITE PLAINS",
    "dropdeladd": "100 FISHER AVE",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 106061953,
    "dropphyadd": "100 FISHER AVE",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 106061953,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 106029998,
    "dropsitphn": 9146977356,
    "dropsitlph": 9146974094,
    "dropsitcph": 9142872501,
    "dropfax": 9142872593
  },
  {
    "dcode": "D",
    "dropkey": "PV17012",
    "droptype": "D",
    "dropname": "WHITE SULPHUR SPRINGS",
    "dropdeladd": "3300 STATE ROUTE 52",
    "dropdelcty": "WHITE SULPHUR SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 127879998,
    "dropphyadd": "3300 STATE ROUTE 52",
    "dropphycty": "WHITE SULPHUR SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 127879998,
    "dropmaladd": "3300 STATE ROUTE 52",
    "dropmalcty": "WHITE SULPHUR SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 127879998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452923140,
    "dropsitcph": 8452923140,
    "dropfax": 8452923140
  },
  {
    "dcode": "D",
    "dropkey": "PV17014",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "88 BROADWAY",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "NY",
    "dropdelzpp": 128879998,
    "dropphyadd": "88 BROADWAY",
    "dropphycty": "WHITEHALL",
    "dropphyst": "NY",
    "dropphyzpp": 128879998,
    "dropmaladd": "88 BROADWAY",
    "dropmalcty": "WHITEHALL",
    "dropmalst": "NY",
    "dropmalzpp": 128879998,
    "dropsitphn": 5184990022,
    "dropsitlph": 5184990022,
    "dropsitcph": 5184990022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17017",
    "droptype": "D",
    "dropname": "WHITESBORO",
    "dropdeladd": "30 ROOSEVELT DR",
    "dropdelcty": "WHITESBORO",
    "dropdelst": "NY",
    "dropdelzpp": 134929998,
    "dropphyadd": "30 ROOSEVELT DR",
    "dropphycty": "WHITESBORO",
    "dropphyst": "NY",
    "dropphyzpp": 134929998,
    "dropmaladd": "30 ROOSEVELT DR",
    "dropmalcty": "WHITESBORO",
    "dropmalst": "NY",
    "dropmalzpp": 134929998,
    "dropsitphn": 3157687861,
    "dropsitlph": 3157687861,
    "dropsitcph": 3157687861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17021",
    "droptype": "D",
    "dropname": "WHITESVILLE",
    "dropdeladd": "479 MAIN ST",
    "dropdelcty": "WHITESVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 148979998,
    "dropphyadd": "479 MAIN ST",
    "dropphycty": "WHITESVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 148979998,
    "dropmaladd": "479 MAIN ST",
    "dropmalcty": "WHITESVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 148979998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6073563355,
    "dropsitcph": 6073563355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17024",
    "droptype": "D",
    "dropname": "WHITNEY POINT",
    "dropdeladd": "2641 MAIN ST",
    "dropdelcty": "WHITNEY POINT",
    "dropdelst": "NY",
    "dropdelzpp": 138629998,
    "dropphyadd": "2641 MAIN ST",
    "dropphycty": "WHITNEY POINT",
    "dropphyst": "NY",
    "dropphyzpp": 138629998,
    "dropmaladd": "2641 MAIN ST",
    "dropmalcty": "WHITNEY POINT",
    "dropmalst": "NY",
    "dropmalzpp": 138629998,
    "dropsitphn": 6076923131,
    "dropsitlph": 6076923131,
    "dropsitcph": 6076923131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17032",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "1435 PROSPECT ST",
    "dropdelcty": "WILLARD",
    "dropdelst": "NY",
    "dropdelzpp": 145889998,
    "dropphyadd": "1435 PROSPECT ST",
    "dropphycty": "WILLARD",
    "dropphyst": "NY",
    "dropphyzpp": 145889998,
    "dropmaladd": "1435 PROSPECT ST",
    "dropmalcty": "WILLARD",
    "dropmalst": "NY",
    "dropmalzpp": 145889998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6078695275,
    "dropsitcph": 6078695275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17033",
    "droptype": "D",
    "dropname": "WILLET",
    "dropdeladd": "1300 LOWER CINCINNATUS RD",
    "dropdelcty": "WILLET",
    "dropdelst": "NY",
    "dropdelzpp": 138639998,
    "dropphyadd": "1300 LOWER CINCINNATUS RD",
    "dropphycty": "WILLET",
    "dropphyst": "NY",
    "dropphyzpp": 138639998,
    "dropmaladd": "1300 LOWER CINCINNATUS RD",
    "dropmalcty": "WILLET",
    "dropmalst": "NY",
    "dropmalzpp": 138639998,
    "dropsitphn": 6078633755,
    "dropsitlph": 6078633755,
    "dropsitcph": 6078633755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17038",
    "droptype": "D",
    "dropname": "WILLIAMSON",
    "dropdeladd": "6144 STATE ROUTE 21",
    "dropdelcty": "WILLIAMSON",
    "dropdelst": "NY",
    "dropdelzpp": 145899998,
    "dropphyadd": "6144 STATE ROUTE 21",
    "dropphycty": "WILLIAMSON",
    "dropphyst": "NY",
    "dropphyzpp": 145899998,
    "dropmaladd": "6144 STATE ROUTE 21",
    "dropmalcty": "WILLIAMSON",
    "dropmalst": "NY",
    "dropmalzpp": 145899998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155895621,
    "dropsitcph": 3155895621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17040",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "509 STATE ROUTE 13",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 134939998,
    "dropphyadd": "509 STATE ROUTE 13",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 134939998,
    "dropmaladd": "509 STATE ROUTE 13",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 134939998,
    "dropsitphn": 3159642412,
    "dropsitlph": 3159642412,
    "dropsitcph": 3159642412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17045",
    "droptype": "D",
    "dropname": "WILLISTON PARK",
    "dropdeladd": "446 WILLIS AVE",
    "dropdelcty": "WILLISTON PARK",
    "dropdelst": "NY",
    "dropdelzpp": 115962234,
    "dropphyadd": "446 WILLIS AVE",
    "dropphycty": "WILLISTON PARK",
    "dropphyst": "NY",
    "dropphyzpp": 115962234,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLISTON PARK",
    "dropmalst": "NY",
    "dropmalzpp": 115969998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167463247,
    "dropfax": 5167460638
  },
  {
    "dcode": "D",
    "dropkey": "PV17048",
    "droptype": "D",
    "dropname": "WILLOW",
    "dropdeladd": "41 VAN WAGNER RD",
    "dropdelcty": "WILLOW",
    "dropdelst": "NY",
    "dropdelzpp": 124959998,
    "dropphyadd": "41 VAN WAGNER RD",
    "dropphycty": "WILLOW",
    "dropphyst": "NY",
    "dropphyzpp": 124959998,
    "dropmaladd": "41 VAN WAGNER RD",
    "dropmalcty": "WILLOW",
    "dropmalst": "NY",
    "dropmalzpp": 124959998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456796767,
    "dropsitcph": 8456796767,
    "dropfax": 8456796767
  },
  {
    "dcode": "D",
    "dropkey": "PV17051",
    "droptype": "D",
    "dropname": "WILLSBORO",
    "dropdeladd": "3665 ESSEX RD STE 2",
    "dropdelcty": "WILLSBORO",
    "dropdelst": "NY",
    "dropdelzpp": 129969902,
    "dropphyadd": "3665 ESSEX RD STE 2",
    "dropphycty": "WILLSBORO",
    "dropphyst": "NY",
    "dropphyzpp": 129969902,
    "dropmaladd": "3665 ESSEX RD STE 2",
    "dropmalcty": "WILLSBORO",
    "dropmalst": "NY",
    "dropmalzpp": 129969902,
    "dropsitphn": 5189634455,
    "dropsitlph": 5189634455,
    "dropsitcph": 5189634455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17053",
    "droptype": "D",
    "dropname": "WILLSEYVILLE",
    "dropdeladd": "24 WILLSEYVILLE RD",
    "dropdelcty": "WILLSEYVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 138649998,
    "dropphyadd": "24 WILLSEYVILLE RD",
    "dropphycty": "WILLSEYVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 138649998,
    "dropmaladd": "24 WILLSEYVILLE RD",
    "dropmalcty": "WILLSEYVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 138649998,
    "dropsitphn": 6076595111,
    "dropsitlph": 6076595111,
    "dropsitcph": 6076595111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17057",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "5720 NYS ROUTE 86",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NY",
    "dropdelzpp": 129979998,
    "dropphyadd": "5720 NYS ROUTE 86",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NY",
    "dropphyzpp": 129979998,
    "dropmaladd": "5720 NYS ROUTE 86",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NY",
    "dropmalzpp": 129979998,
    "dropsitphn": 5189467159,
    "dropsitlph": 5189467159,
    "dropsitcph": 5189467159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17059",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "367 MCCHESNEY ST",
    "dropdelcty": "WILSON",
    "dropdelst": "NY",
    "dropdelzpp": 141729805,
    "dropphyadd": "367 MCCHESNEY ST",
    "dropphycty": "WILSON",
    "dropphyst": "NY",
    "dropphyzpp": 141729805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSON",
    "dropmalst": "NY",
    "dropmalzpp": 141729998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462514,
    "dropsitcph": 7167519340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17063",
    "droptype": "D",
    "dropname": "WINDHAM",
    "dropdeladd": "5365 STATE ROUTE 23",
    "dropdelcty": "WINDHAM",
    "dropdelst": "NY",
    "dropdelzpp": 124969998,
    "dropphyadd": "5365 STATE ROUTE 23",
    "dropphycty": "WINDHAM",
    "dropphyst": "NY",
    "dropphyzpp": 124969998,
    "dropmaladd": "5365 STATE ROUTE 23",
    "dropmalcty": "WINDHAM",
    "dropmalst": "NY",
    "dropmalzpp": 124969998,
    "dropsitphn": 9146974123,
    "dropsitlph": 5187346956,
    "dropsitcph": 5187346956,
    "dropfax": 5187346956
  },
  {
    "dcode": "D",
    "dropkey": "PV17064",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "652 OLD ROUTE 17",
    "dropdelcty": "WINDSOR",
    "dropdelst": "NY",
    "dropdelzpp": 138659998,
    "dropphyadd": "652 OLD ROUTE 17",
    "dropphycty": "WINDSOR",
    "dropphyst": "NY",
    "dropphyzpp": 138659998,
    "dropmaladd": "652 OLD ROUTE 17",
    "dropmalcty": "WINDSOR",
    "dropmalst": "NY",
    "dropmalzpp": 138659998,
    "dropsitphn": 6076552683,
    "dropsitlph": 6076552683,
    "dropsitcph": 6076552683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17066",
    "droptype": "D",
    "dropname": "WINGDALE",
    "dropdeladd": "1809 ROUTE 22",
    "dropdelcty": "WINGDALE",
    "dropdelst": "NY",
    "dropdelzpp": 125949998,
    "dropphyadd": "1809 ROUTE 22",
    "dropphycty": "WINGDALE",
    "dropphyst": "NY",
    "dropphyzpp": 125949998,
    "dropmaladd": "1809 ROUTE 22",
    "dropmalcty": "WINGDALE",
    "dropmalst": "NY",
    "dropmalzpp": 125949998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458326147,
    "dropsitcph": 8458326147,
    "dropfax": 8458329385
  },
  {
    "dcode": "D",
    "dropkey": "PV17068",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "656 STATE HIGHWAY 11C",
    "dropdelcty": "WINTHROP",
    "dropdelst": "NY",
    "dropdelzpp": 136979998,
    "dropphyadd": "656 STATE HIGHWAY 11C",
    "dropphycty": "WINTHROP",
    "dropphyst": "NY",
    "dropphyzpp": 136979998,
    "dropmaladd": "656 STATE HIGHWAY 11C",
    "dropmalcty": "WINTHROP",
    "dropmalst": "NY",
    "dropmalzpp": 136979998,
    "dropsitphn": 3153894735,
    "dropsitlph": 3153894735,
    "dropsitcph": 3153894735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17071",
    "droptype": "D",
    "dropname": "WOLCOTT",
    "dropdeladd": "6048 LAKE AVE",
    "dropdelcty": "WOLCOTT",
    "dropdelst": "NY",
    "dropdelzpp": 145909998,
    "dropphyadd": "6048 LAKE AVE",
    "dropphycty": "WOLCOTT",
    "dropphyst": "NY",
    "dropphyzpp": 145909998,
    "dropmaladd": "6048 LAKE AVE",
    "dropmalcty": "WOLCOTT",
    "dropmalst": "NY",
    "dropmalzpp": 145909998,
    "dropsitphn": 7168462415,
    "dropsitlph": 3155942106,
    "dropsitcph": 3155942106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17074",
    "droptype": "D",
    "dropname": "WOODBOURNE",
    "dropdeladd": "6169 STATE ROUTE 42",
    "dropdelcty": "WOODBOURNE",
    "dropdelst": "NY",
    "dropdelzpp": 127889998,
    "dropphyadd": "6169 STATE ROUTE 42",
    "dropphycty": "WOODBOURNE",
    "dropphyst": "NY",
    "dropphyzpp": 127889998,
    "dropmaladd": "6169 STATE ROUTE 42",
    "dropmalcty": "WOODBOURNE",
    "dropmalst": "NY",
    "dropmalzpp": 127889998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454344562,
    "dropsitcph": 8454344562,
    "dropfax": 8454368627
  },
  {
    "dcode": "D",
    "dropkey": "PV17075",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "217 WOODBURY RD",
    "dropdelcty": "WOODBURY",
    "dropdelst": "NY",
    "dropdelzpp": 117971254,
    "dropphyadd": "217 WOODBURY RD",
    "dropphycty": "WOODBURY",
    "dropphyst": "NY",
    "dropphyzpp": 117971254,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODBURY",
    "dropmalst": "NY",
    "dropmalzpp": 117979998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5166925470,
    "dropfax": 5166922968
  },
  {
    "dcode": "D",
    "dropkey": "PV17077",
    "droptype": "D",
    "dropname": "WOODGATE",
    "dropdeladd": "11045 WOODGATE RD",
    "dropdelcty": "WOODGATE",
    "dropdelst": "NY",
    "dropdelzpp": 134949998,
    "dropphyadd": "11045 WOODGATE RD",
    "dropphycty": "WOODGATE",
    "dropphyst": "NY",
    "dropphyzpp": 134949998,
    "dropmaladd": "11045 WOODGATE RD",
    "dropmalcty": "WOODGATE",
    "dropmalst": "NY",
    "dropmalzpp": 134949998,
    "dropsitphn": 3153924999,
    "dropsitlph": 3153924999,
    "dropsitcph": 3153924999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17080",
    "droptype": "D",
    "dropname": "WOODHULL",
    "dropdeladd": "1617 MAIN ST",
    "dropdelcty": "WOODHULL",
    "dropdelst": "NY",
    "dropdelzpp": 148989998,
    "dropphyadd": "1617 MAIN ST",
    "dropphycty": "WOODHULL",
    "dropphyst": "NY",
    "dropphyzpp": 148989998,
    "dropmaladd": "1617 MAIN ST",
    "dropmalcty": "WOODHULL",
    "dropmalst": "NY",
    "dropmalzpp": 148989998,
    "dropsitphn": 7168462415,
    "dropsitlph": 6074585103,
    "dropsitcph": 6074585103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17084",
    "droptype": "D",
    "dropname": "WOODMERE",
    "dropdeladd": "132 FRANKLIN PL",
    "dropdelcty": "WOODMERE",
    "dropdelst": "NY",
    "dropdelzpp": 115981200,
    "dropphyadd": "132 FRANKLIN PL",
    "dropphycty": "WOODMERE",
    "dropphyst": "NY",
    "dropphyzpp": 115981200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODMERE",
    "dropmalst": "NY",
    "dropmalzpp": 115989998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163743776,
    "dropfax": 5162955706
  },
  {
    "dcode": "D",
    "dropkey": "PV17085",
    "droptype": "D",
    "dropname": "WOODRIDGE",
    "dropdeladd": "47 BROADWAY",
    "dropdelcty": "WOODRIDGE",
    "dropdelst": "NY",
    "dropdelzpp": 127899998,
    "dropphyadd": "47 BROADWAY",
    "dropphycty": "WOODRIDGE",
    "dropphyst": "NY",
    "dropphyzpp": 127899998,
    "dropmaladd": "47 BROADWAY",
    "dropmalcty": "WOODRIDGE",
    "dropmalst": "NY",
    "dropmalzpp": 127899998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454341095,
    "dropsitcph": 8454341095,
    "dropfax": 8454344109
  },
  {
    "dcode": "D",
    "dropkey": "PV17092",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "2 WOODSTOCK MEADOWS LN",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "NY",
    "dropdelzpp": 124989998,
    "dropphyadd": "2 WOODSTOCK MEADOWS LN",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "NY",
    "dropphyzpp": 124989998,
    "dropmaladd": "2 WOODSTOCK MEADOWS LN",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "NY",
    "dropmalzpp": 124989998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8456790014,
    "dropsitcph": 8456790014,
    "dropfax": 8456797024
  },
  {
    "dcode": "D",
    "dropkey": "PV17097",
    "droptype": "D",
    "dropname": "WORCESTER",
    "dropdeladd": "80 MAIN ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "NY",
    "dropdelzpp": 121979998,
    "dropphyadd": "80 MAIN ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "NY",
    "dropphyzpp": 121979998,
    "dropmaladd": "80 MAIN ST",
    "dropmalcty": "WORCESTER",
    "dropmalst": "NY",
    "dropmalzpp": 121979998,
    "dropsitphn": 6073979100,
    "dropsitlph": 6073979100,
    "dropsitcph": 6073979100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17104",
    "droptype": "D",
    "dropname": "WURTSBORO",
    "dropdeladd": "39 SULLIVAN ST",
    "dropdelcty": "WURTSBORO",
    "dropdelst": "NY",
    "dropdelzpp": 127909998,
    "dropphyadd": "39 SULLIVAN ST",
    "dropphycty": "WURTSBORO",
    "dropphyst": "NY",
    "dropphyzpp": 127909998,
    "dropmaladd": "39 SULLIVAN ST",
    "dropmalcty": "WURTSBORO",
    "dropmalst": "NY",
    "dropmalzpp": 127909998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8458884447,
    "dropsitcph": 8458884447,
    "dropfax": 8458884042
  },
  {
    "dcode": "D",
    "dropkey": "PV17106",
    "droptype": "D",
    "dropname": "WYANDANCH",
    "dropdeladd": "1569 STRAIGHT PATH",
    "dropdelcty": "WYANDANCH",
    "dropdelst": "NY",
    "dropdelzpp": 117983230,
    "dropphyadd": "1569 STRAIGHT PATH",
    "dropphycty": "WYANDANCH",
    "dropphyst": "NY",
    "dropphyzpp": 117983230,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYANDANCH",
    "dropmalst": "NY",
    "dropmalzpp": 117989998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6316433913,
    "dropfax": 6316430411
  },
  {
    "dcode": "D",
    "dropkey": "PV17110",
    "droptype": "D",
    "dropname": "WYNANTSKILL",
    "dropdeladd": "85 MAIN AVE",
    "dropdelcty": "WYNANTSKILL",
    "dropdelst": "NY",
    "dropdelzpp": 121989998,
    "dropphyadd": "85 MAIN AVE",
    "dropphycty": "WYNANTSKILL",
    "dropphyst": "NY",
    "dropphyzpp": 121989998,
    "dropmaladd": "85 MAIN AVE",
    "dropmalcty": "WYNANTSKILL",
    "dropmalst": "NY",
    "dropmalzpp": 121989998,
    "dropsitphn": 5182835678,
    "dropsitlph": 5182835678,
    "dropsitcph": 5182835678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17111",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "2 S ACADEMY ST",
    "dropdelcty": "WYOMING",
    "dropdelst": "NY",
    "dropdelzpp": 145919998,
    "dropphyadd": "2 S ACADEMY ST",
    "dropphycty": "WYOMING",
    "dropphyst": "NY",
    "dropphyzpp": 145919998,
    "dropmaladd": "2 S ACADEMY ST",
    "dropmalcty": "WYOMING",
    "dropmalst": "NY",
    "dropmalzpp": 145919998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854956462,
    "dropsitcph": 5854956462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17115",
    "droptype": "D",
    "dropname": "YAPHANK",
    "dropdeladd": "5 E MAIN ST",
    "dropdelcty": "YAPHANK",
    "dropdelst": "NY",
    "dropdelzpp": 119801123,
    "dropphyadd": "5 E MAIN ST",
    "dropphycty": "YAPHANK",
    "dropphyst": "NY",
    "dropphyzpp": 119801123,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YAPHANK",
    "dropmalst": "NY",
    "dropmalzpp": 119809998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6313456829,
    "dropfax": 6313450636
  },
  {
    "dcode": "D",
    "dropkey": "PV17117",
    "droptype": "D",
    "dropname": "YONKERS",
    "dropdeladd": "79-81 MAIN ST",
    "dropdelcty": "YONKERS",
    "dropdelst": "NY",
    "dropdelzpp": 107017059,
    "dropphyadd": "79-81 MAIN ST",
    "dropphycty": "YONKERS",
    "dropphyst": "NY",
    "dropphyzpp": 107017059,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YONKERS",
    "dropmalst": "NY",
    "dropmalzpp": 107029998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9143783611,
    "dropsitcph": 9143783611,
    "dropfax": 9143751207
  },
  {
    "dcode": "D",
    "dropkey": "PV17118",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "2706 MAIN ST",
    "dropdelcty": "YORK",
    "dropdelst": "NY",
    "dropdelzpp": 145929800,
    "dropphyadd": "2706 MAIN ST",
    "dropphycty": "YORK",
    "dropphyst": "NY",
    "dropphyzpp": 145929800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YORK",
    "dropmalst": "NY",
    "dropmalzpp": 145929998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852432004,
    "dropsitcph": 5852432004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17120",
    "droptype": "D",
    "dropname": "YORKSHIRE",
    "dropdeladd": "3230 MAIN ST",
    "dropdelcty": "YORKSHIRE",
    "dropdelst": "NY",
    "dropdelzpp": 141739800,
    "dropphyadd": "3230 MAIN ST",
    "dropphycty": "YORKSHIRE",
    "dropphyst": "NY",
    "dropphyzpp": 141739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YORKSHIRE",
    "dropmalst": "NY",
    "dropmalzpp": 141739998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462514,
    "dropsitcph": 7164923132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17122",
    "droptype": "D",
    "dropname": "YORKTOWN HEIGHTS",
    "dropdeladd": "2020 MAPLE HILL ST",
    "dropdelcty": "YORKTOWN HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 105989998,
    "dropphyadd": "2020 MAPLE HILL ST",
    "dropphycty": "YORKTOWN HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 105989998,
    "dropmaladd": "2020 MAPLE HILL ST",
    "dropmalcty": "YORKTOWN HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 105989998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149622263,
    "dropsitcph": 9149622263,
    "dropfax": 9149622595
  },
  {
    "dcode": "D",
    "dropkey": "PV17126",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "2 MYERS AVE",
    "dropdelcty": "YORKVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 134959978,
    "dropphyadd": "2 MYERS AVE",
    "dropphycty": "YORKVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 134959978,
    "dropmaladd": "2 MYERS AVE",
    "dropmalcty": "YORKVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 134959978,
    "dropsitphn": 3157688993,
    "dropsitlph": 3157688993,
    "dropsitcph": 3157688993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17128",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "135 LOCKPORT ST",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 141749998,
    "dropphyadd": "135 LOCKPORT ST",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 141749998,
    "dropmaladd": "135 LOCKPORT ST",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 141749998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462514,
    "dropsitcph": 7167459743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV17129",
    "droptype": "D",
    "dropname": "YOUNGSVILLE",
    "dropdeladd": "4068 STATE ROUTE 52",
    "dropdelcty": "YOUNGSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 127919998,
    "dropphyadd": "4068 STATE ROUTE 52",
    "dropphycty": "YOUNGSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 127919998,
    "dropmaladd": "4068 STATE ROUTE 52",
    "dropmalcty": "YOUNGSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 127919998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8454824295,
    "dropfax": 8454824294
  },
  {
    "dcode": "D",
    "dropkey": "PV17130",
    "droptype": "D",
    "dropname": "YULAN",
    "dropdeladd": "219 AIRPORT RD",
    "dropdelcty": "YULAN",
    "dropdelst": "NY",
    "dropdelzpp": 127929998,
    "dropphyadd": "219 AIRPORT RD",
    "dropphycty": "YULAN",
    "dropphyst": "NY",
    "dropphyzpp": 127929998,
    "dropmaladd": "219 AIRPORT RD",
    "dropmalcty": "YULAN",
    "dropmalst": "NY",
    "dropmalzpp": 127929998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455578515,
    "dropsitcph": 8455578515,
    "dropfax": 8455578515
  },
  {
    "dcode": "D",
    "dropkey": "PV17135",
    "droptype": "D",
    "dropname": "ADJUNTAS",
    "dropdeladd": "37 CALLE MUNOZ RIVERA",
    "dropdelcty": "ADJUNTAS",
    "dropdelst": "PR",
    "dropdelzpp": "006019998",
    "dropphyadd": "37 CALLE MUNOZ RIVERA",
    "dropphycty": "ADJUNTAS",
    "dropphyst": "PR",
    "dropphyzpp": "006019998",
    "dropmaladd": "37 CALLE MUNOZ RIVERA",
    "dropmalcty": "ADJUNTAS",
    "dropmalst": "PR",
    "dropmalzpp": "006019998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878293740,
    "dropfax": 7878292620
  },
  {
    "dcode": "D",
    "dropkey": "PV17136",
    "droptype": "D",
    "dropname": "AGUADA",
    "dropdeladd": "5 AVE NATIVO ALERS",
    "dropdelcty": "AGUADA",
    "dropdelst": "PR",
    "dropdelzpp": "006029998",
    "dropphyadd": "5 AVE NATIVO ALERS",
    "dropphycty": "AGUADA",
    "dropphyst": "PR",
    "dropphyzpp": "006029998",
    "dropmaladd": "5 AVE NATIVO ALERS",
    "dropmalcty": "AGUADA",
    "dropmalst": "PR",
    "dropmalzpp": "006029998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878687405,
    "dropfax": 7878681660
  },
  {
    "dcode": "D",
    "dropkey": "PV17137",
    "droptype": "D",
    "dropname": "AGUADILLA",
    "dropdeladd": "50 CARR 459 STE 1",
    "dropdelcty": "AGUADILLA",
    "dropdelst": "PR",
    "dropdelzpp": "006039998",
    "dropphyadd": "50 CARR 459 STE 1",
    "dropphycty": "AGUADILLA",
    "dropphyst": "PR",
    "dropphyzpp": "006039998",
    "dropmaladd": "50 CARR 459 STE 1",
    "dropmalcty": "AGUADILLA",
    "dropmalst": "PR",
    "dropmalzpp": "006039998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878822235,
    "dropfax": 7878824260
  },
  {
    "dcode": "D",
    "dropkey": "PV17138",
    "droptype": "D",
    "dropname": "AGUAS BUENAS",
    "dropdeladd": "13 CALLE PIO RECHANI",
    "dropdelcty": "AGUAS BUENAS",
    "dropdelst": "PR",
    "dropdelzpp": "007039998",
    "dropphyadd": "13 CALLE PIO RECHANI",
    "dropphycty": "AGUAS BUENAS",
    "dropphyst": "PR",
    "dropphyzpp": "007039998",
    "dropmaladd": "13 CALLE PIO RECHANI",
    "dropmalcty": "AGUAS BUENAS",
    "dropmalst": "PR",
    "dropmalzpp": "007039998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877322461,
    "dropfax": 7877321810
  },
  {
    "dcode": "D",
    "dropkey": "PV17139",
    "droptype": "D",
    "dropname": "AGUIRRE",
    "dropdeladd": "100 CALLE PRINCIPAL",
    "dropdelcty": "AGUIRRE",
    "dropdelst": "PR",
    "dropdelzpp": "007049998",
    "dropphyadd": "100 CALLE PRINCIPAL",
    "dropphycty": "AGUIRRE",
    "dropphyst": "PR",
    "dropphyzpp": "007049998",
    "dropmaladd": "100 CALLE PRINCIPAL",
    "dropmalcty": "AGUIRRE",
    "dropmalst": "PR",
    "dropmalzpp": "007049998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878534020,
    "dropfax": 7878532977
  },
  {
    "dcode": "D",
    "dropkey": "PV17140",
    "droptype": "D",
    "dropname": "AIBONITO",
    "dropdeladd": "20 CALLE IGNACIO LOPEZ",
    "dropdelcty": "AIBONITO",
    "dropdelst": "PR",
    "dropdelzpp": "007059998",
    "dropphyadd": "20 CALLE IGNACIO LOPEZ",
    "dropphycty": "AIBONITO",
    "dropphyst": "PR",
    "dropphyzpp": "007059998",
    "dropmaladd": "20 CALLE IGNACIO LOPEZ",
    "dropmalcty": "AIBONITO",
    "dropmalst": "PR",
    "dropmalzpp": "007059998",
    "dropsitphn": 7876221644,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877354071,
    "dropfax": 7877350860
  },
  {
    "dcode": "D",
    "dropkey": "PV17142",
    "droptype": "D",
    "dropname": "ANASCO",
    "dropdeladd": "93 CALLE 65 INFANTERIA STE 1",
    "dropdelcty": "ANASCO",
    "dropdelst": "PR",
    "dropdelzpp": "006102947",
    "dropphyadd": "93 CALLE 65 INFANTERIA STE 1",
    "dropphycty": "ANASCO",
    "dropphyst": "PR",
    "dropphyzpp": "006102947",
    "dropmaladd": "93 CALLE 65 INFANTERIA STE 1",
    "dropmalcty": "ANASCO",
    "dropmalst": "PR",
    "dropmalzpp": "006102947",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878260660,
    "dropfax": 7878263990
  },
  {
    "dcode": "D",
    "dropkey": "PV17143",
    "droptype": "D",
    "dropname": "ANGELES",
    "dropdeladd": "100 CARR 111",
    "dropdelcty": "ANGELES",
    "dropdelst": "PR",
    "dropdelzpp": "006119998",
    "dropphyadd": "100 CARR 111",
    "dropphycty": "ANGELES",
    "dropphyst": "PR",
    "dropphyzpp": "006119998",
    "dropmaladd": "100 CARR 111",
    "dropmalcty": "ANGELES",
    "dropmalst": "PR",
    "dropmalzpp": "006119998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878947120,
    "dropfax": 7878948918
  },
  {
    "dcode": "D",
    "dropkey": "PV17144",
    "droptype": "D",
    "dropname": "ARECIBO",
    "dropdeladd": "10 AVE SAN PATRICIO",
    "dropdelcty": "ARECIBO",
    "dropdelst": "PR",
    "dropdelzpp": "006129998",
    "dropphyadd": "10 AVE SAN PATRICIO",
    "dropphycty": "ARECIBO",
    "dropphyst": "PR",
    "dropphyzpp": "006129998",
    "dropmaladd": "10 AVE SAN PATRICIO",
    "dropmalcty": "ARECIBO",
    "dropmalst": "PR",
    "dropmalzpp": "006129998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878782775,
    "dropfax": 7878781665
  },
  {
    "dcode": "D",
    "dropkey": "PV17145",
    "droptype": "D",
    "dropname": "ARROYO",
    "dropdeladd": "111 CALLE MORSE",
    "dropdelcty": "ARROYO",
    "dropdelst": "PR",
    "dropdelzpp": "007149998",
    "dropphyadd": "111 CALLE MORSE",
    "dropphycty": "ARROYO",
    "dropphyst": "PR",
    "dropphyzpp": "007149998",
    "dropmaladd": "111 CALLE MORSE",
    "dropmalcty": "ARROYO",
    "dropmalst": "PR",
    "dropmalzpp": "007149998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878393390,
    "dropfax": 7878394625
  },
  {
    "dcode": "D",
    "dropkey": "PV17147",
    "droptype": "D",
    "dropname": "BAJADERO",
    "dropdeladd": "100 CARR 656",
    "dropdelcty": "BAJADERO",
    "dropdelst": "PR",
    "dropdelzpp": "006169800",
    "dropphyadd": "100 CARR 656",
    "dropphycty": "BAJADERO",
    "dropphyst": "PR",
    "dropphyzpp": "006169800",
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "BAJADERO",
    "dropmalst": "PR",
    "dropmalzpp": "006169997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878811223,
    "dropfax": 7878810492
  },
  {
    "dcode": "D",
    "dropkey": "PV17148",
    "droptype": "D",
    "dropname": "BARCELONETA",
    "dropdeladd": "H1 CALLE 5",
    "dropdelcty": "BARCELONETA",
    "dropdelst": "PR",
    "dropdelzpp": "006179998",
    "dropphyadd": "H1 CALLE 5",
    "dropphycty": "BARCELONETA",
    "dropphyst": "PR",
    "dropphyzpp": "006179998",
    "dropmaladd": "H1 CALLE 5",
    "dropmalcty": "BARCELONETA",
    "dropmalst": "PR",
    "dropmalzpp": "006179998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878462380,
    "dropfax": 7878465423
  },
  {
    "dcode": "D",
    "dropkey": "PV17149",
    "droptype": "D",
    "dropname": "BARRANQUITAS",
    "dropdeladd": "41 CALLE MUNOZ RIVERA FRNT",
    "dropdelcty": "BARRANQUITAS",
    "dropdelst": "PR",
    "dropdelzpp": "007949998",
    "dropphyadd": "41 CALLE MUNOZ RIVERA FRNT",
    "dropphycty": "BARRANQUITAS",
    "dropphyst": "PR",
    "dropphyzpp": "007949998",
    "dropmaladd": "41 CALLE MUNOZ RIVERA FRNT",
    "dropmalcty": "BARRANQUITAS",
    "dropmalst": "PR",
    "dropmalzpp": "007949998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878573020,
    "dropfax": 7878571270
  },
  {
    "dcode": "D",
    "dropkey": "PV17154",
    "droptype": "D",
    "dropname": "BOQUERON",
    "dropdeladd": "300 CARR 101",
    "dropdelcty": "BOQUERON",
    "dropdelst": "PR",
    "dropdelzpp": "006229997",
    "dropphyadd": "300 CARR 101",
    "dropphycty": "BOQUERON",
    "dropphyst": "PR",
    "dropphyzpp": "006229997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOQUERON",
    "dropmalst": "PR",
    "dropmalzpp": "006229998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878513848,
    "dropfax": 7878511715
  },
  {
    "dcode": "D",
    "dropkey": "PV17156",
    "droptype": "D",
    "dropname": "CABO ROJO",
    "dropdeladd": "64 CALLE CARBONELL",
    "dropdelcty": "CABO ROJO",
    "dropdelst": "PR",
    "dropdelzpp": "006239998",
    "dropphyadd": "64 CALLE CARBONELL",
    "dropphycty": "CABO ROJO",
    "dropphyst": "PR",
    "dropphyzpp": "006239998",
    "dropmaladd": "64 CALLE CARBONELL",
    "dropmalcty": "CABO ROJO",
    "dropmalst": "PR",
    "dropmalzpp": "006239998",
    "dropsitphn": 7877672797,
    "dropsitlph": 7877673029,
    "dropsitcph": 7878511095,
    "dropfax": 7878516480
  },
  {
    "dcode": "D",
    "dropkey": "PV17157",
    "droptype": "D",
    "dropname": "CAGUAS",
    "dropdeladd": "225 CALLE GAUTIER BENITEZ",
    "dropdelcty": "CAGUAS",
    "dropdelst": "PR",
    "dropdelzpp": "007259998",
    "dropphyadd": "225 CALLE GAUTIER BENITEZ",
    "dropphycty": "CAGUAS",
    "dropphyst": "PR",
    "dropphyzpp": "007259998",
    "dropmaladd": "225 CALLE GAUTIER BENITEZ",
    "dropmalcty": "CAGUAS",
    "dropmalst": "PR",
    "dropmalzpp": "007259998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877435110,
    "dropfax": 7872586583
  },
  {
    "dcode": "D",
    "dropkey": "PV17158",
    "droptype": "D",
    "dropname": "CAMUY",
    "dropdeladd": "2 CALLE CORREO",
    "dropdelcty": "CAMUY",
    "dropdelst": "PR",
    "dropdelzpp": "006279998",
    "dropphyadd": "2 CALLE CORREO",
    "dropphycty": "CAMUY",
    "dropphyst": "PR",
    "dropphyzpp": "006279998",
    "dropmaladd": "2 CALLE CORREO",
    "dropmalcty": "CAMUY",
    "dropmalst": "PR",
    "dropmalzpp": "006279998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878982575,
    "dropfax": 7872621508
  },
  {
    "dcode": "D",
    "dropkey": "PV17159",
    "droptype": "D",
    "dropname": "CANOVANAS",
    "dropdeladd": "18400 CARR 3 STE 136",
    "dropdelcty": "CANOVANAS",
    "dropdelst": "PR",
    "dropdelzpp": "007299998",
    "dropphyadd": "18400 CARR 3 STE 136",
    "dropphycty": "CANOVANAS",
    "dropphyst": "PR",
    "dropphyzpp": "007299998",
    "dropmaladd": "18400 CARR 3 STE 136",
    "dropmalcty": "CANOVANAS",
    "dropmalst": "PR",
    "dropmalzpp": "007299998",
    "dropsitphn": 7872564777,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878762900,
    "dropfax": 7872564779
  },
  {
    "dcode": "D",
    "dropkey": "PV17165",
    "droptype": "D",
    "dropname": "CAROLINA",
    "dropdeladd": "1000 AVE SANCHEZ OSORIO",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009839998",
    "dropphyadd": "1000 AVE SANCHEZ OSORIO",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009839998",
    "dropmaladd": "1000 AVE SANCHEZ OSORIO",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009839998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877628842,
    "dropfax": 7877663593
  },
  {
    "dcode": "D",
    "dropkey": "PV17168",
    "droptype": "D",
    "dropname": "CAYEY",
    "dropdeladd": "11 AVE BALDORIOTY E",
    "dropdelcty": "CAYEY",
    "dropdelst": "PR",
    "dropdelzpp": "007369998",
    "dropphyadd": "11 AVE BALDORIOTY E",
    "dropphycty": "CAYEY",
    "dropphyst": "PR",
    "dropphyzpp": "007369998",
    "dropmaladd": "11 AVE BALDORIOTY E",
    "dropmalcty": "CAYEY",
    "dropmalst": "PR",
    "dropmalzpp": "007369998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877388020,
    "dropfax": 7872630240
  },
  {
    "dcode": "D",
    "dropkey": "PV17169",
    "droptype": "D",
    "dropname": "CEIBA",
    "dropdeladd": "305 AVE LAURO PINERO",
    "dropdelcty": "CEIBA",
    "dropdelst": "PR",
    "dropdelzpp": "007359998",
    "dropphyadd": "305 AVE LAURO PINERO",
    "dropphycty": "CEIBA",
    "dropphyst": "PR",
    "dropphyzpp": "007359998",
    "dropmaladd": "305 AVE LAURO PINERO",
    "dropmalcty": "CEIBA",
    "dropmalst": "PR",
    "dropmalzpp": "007359998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878850850,
    "dropfax": 7878850860
  },
  {
    "dcode": "D",
    "dropkey": "PV17172",
    "droptype": "D",
    "dropname": "CIALES",
    "dropdeladd": "25 CARR 149",
    "dropdelcty": "CIALES",
    "dropdelst": "PR",
    "dropdelzpp": "006389998",
    "dropphyadd": "25 CARR 149",
    "dropphycty": "CIALES",
    "dropphyst": "PR",
    "dropphyzpp": "006389998",
    "dropmaladd": "25 CARR 149",
    "dropmalcty": "CIALES",
    "dropmalst": "PR",
    "dropmalzpp": "006389998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878712384,
    "dropfax": 7878712342
  },
  {
    "dcode": "D",
    "dropkey": "PV17173",
    "droptype": "D",
    "dropname": "CIDRA",
    "dropdeladd": "100 AVE INDUSTRIAL",
    "dropdelcty": "CIDRA",
    "dropdelst": "PR",
    "dropdelzpp": "007399998",
    "dropphyadd": "100 AVE INDUSTRIAL",
    "dropphycty": "CIDRA",
    "dropphyst": "PR",
    "dropphyzpp": "007399998",
    "dropmaladd": "100 AVE INDUSTRIAL",
    "dropmalcty": "CIDRA",
    "dropmalst": "PR",
    "dropmalzpp": "007399998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877143999,
    "dropfax": 7877143995
  },
  {
    "dcode": "D",
    "dropkey": "PV17174",
    "droptype": "D",
    "dropname": "COAMO",
    "dropdeladd": "100 CALLE A STE 1",
    "dropdelcty": "COAMO",
    "dropdelst": "PR",
    "dropdelzpp": "007693419",
    "dropphyadd": "100 CALLE A STE 1",
    "dropphycty": "COAMO",
    "dropphyst": "PR",
    "dropphyzpp": "007693419",
    "dropmaladd": "100 CALLE A STE 1",
    "dropmalcty": "COAMO",
    "dropmalst": "PR",
    "dropmalzpp": "007693419",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878032721,
    "dropfax": 7878032722
  },
  {
    "dcode": "D",
    "dropkey": "PV17176",
    "droptype": "D",
    "dropname": "COMERIO",
    "dropdeladd": "37 CARR 778 STE 3",
    "dropdelcty": "COMERIO",
    "dropdelst": "PR",
    "dropdelzpp": "007829998",
    "dropphyadd": "37 CARR 778 STE 3",
    "dropphycty": "COMERIO",
    "dropphyst": "PR",
    "dropphyzpp": "007829998",
    "dropmaladd": "37 CARR 778 STE 3",
    "dropmalcty": "COMERIO",
    "dropmalst": "PR",
    "dropmalzpp": "007829998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878756030,
    "dropfax": 7878756031
  },
  {
    "dcode": "D",
    "dropkey": "PV17178",
    "droptype": "D",
    "dropname": "COROZAL",
    "dropdeladd": "100 COROZAL SHOP CTR STE 104",
    "dropdelcty": "COROZAL",
    "dropdelst": "PR",
    "dropdelzpp": "007839998",
    "dropphyadd": "100 COROZAL SHOP CTR STE 104",
    "dropphycty": "COROZAL",
    "dropphyst": "PR",
    "dropphyzpp": "007839998",
    "dropmaladd": "100 COROZAL SHOP CTR STE 104",
    "dropmalcty": "COROZAL",
    "dropmalst": "PR",
    "dropmalzpp": "007839998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878592640,
    "dropfax": 7878597794
  },
  {
    "dcode": "D",
    "dropkey": "PV17179",
    "droptype": "D",
    "dropname": "COTO LAUREL",
    "dropdeladd": "3007 AVE SAN CRISTOBAL",
    "dropdelcty": "COTO LAUREL",
    "dropdelst": "PR",
    "dropdelzpp": "007809998",
    "dropphyadd": "3007 AVE SAN CRISTOBAL",
    "dropphycty": "COTO LAUREL",
    "dropphyst": "PR",
    "dropphyzpp": "007809998",
    "dropmaladd": "3007 AVE SAN CRISTOBAL",
    "dropmalcty": "COTO LAUREL",
    "dropmalst": "PR",
    "dropmalzpp": "007809998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7872598475,
    "dropfax": 7878482447
  },
  {
    "dcode": "D",
    "dropkey": "PV17180",
    "droptype": "D",
    "dropname": "CULEBRA",
    "dropdeladd": "26 CALLE PEDRO MARQUEZ",
    "dropdelcty": "CULEBRA",
    "dropdelst": "PR",
    "dropdelzpp": "007759800",
    "dropphyadd": "26 CALLE PEDRO MARQUEZ",
    "dropphycty": "CULEBRA",
    "dropphyst": "PR",
    "dropphyzpp": "007759800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CULEBRA",
    "dropmalst": "PR",
    "dropmalzpp": "007759998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877423862,
    "dropfax": 7877421987
  },
  {
    "dcode": "D",
    "dropkey": "PV17181",
    "droptype": "D",
    "dropname": "DORADO",
    "dropdeladd": "618 AVE JOSE EFRON",
    "dropdelcty": "DORADO",
    "dropdelst": "PR",
    "dropdelzpp": "006469997",
    "dropphyadd": "618 AVE JOSE EFRON",
    "dropphycty": "DORADO",
    "dropphyst": "PR",
    "dropphyzpp": "006469997",
    "dropmaladd": "618 AVE JOSE EFRON",
    "dropmalcty": "DORADO",
    "dropmalst": "PR",
    "dropmalzpp": "006469997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877961052,
    "dropfax": 7877964468
  },
  {
    "dcode": "D",
    "dropkey": "PV17182",
    "droptype": "D",
    "dropname": "ENSENADA",
    "dropdeladd": "6 CALLE SEGUNDA SUR",
    "dropdelcty": "ENSENADA",
    "dropdelst": "PR",
    "dropdelzpp": "006479998",
    "dropphyadd": "6 CALLE SEGUNDA SUR",
    "dropphycty": "ENSENADA",
    "dropphyst": "PR",
    "dropphyzpp": "006479998",
    "dropmaladd": "6 CALLE SEGUNDA SUR",
    "dropmalcty": "ENSENADA",
    "dropmalst": "PR",
    "dropmalzpp": "006479998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878215419,
    "dropfax": 7878213992
  },
  {
    "dcode": "D",
    "dropkey": "PV17184",
    "droptype": "D",
    "dropname": "FAJARDO",
    "dropdeladd": "113 CALLE GARRIDO MORALES W",
    "dropdelcty": "FAJARDO",
    "dropdelst": "PR",
    "dropdelzpp": "007389998",
    "dropphyadd": "113 CALLE GARRIDO MORALES W",
    "dropphycty": "FAJARDO",
    "dropphyst": "PR",
    "dropphyzpp": "007389998",
    "dropmaladd": "113 CALLE GARRIDO MORALES W",
    "dropmalcty": "FAJARDO",
    "dropmalst": "PR",
    "dropmalzpp": "007389998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876558777,
    "dropfax": 7876558782
  },
  {
    "dcode": "D",
    "dropkey": "PV17188",
    "droptype": "D",
    "dropname": "FLORIDA",
    "dropdeladd": "66 CALLE MUNOZ RIVERA",
    "dropdelcty": "FLORIDA",
    "dropdelst": "PR",
    "dropdelzpp": "006509998",
    "dropphyadd": "66 CALLE MUNOZ RIVERA",
    "dropphycty": "FLORIDA",
    "dropphyst": "PR",
    "dropphyzpp": "006509998",
    "dropmaladd": "66 CALLE MUNOZ RIVERA",
    "dropmalcty": "FLORIDA",
    "dropmalst": "PR",
    "dropmalzpp": "006509998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878221357,
    "dropfax": 7878221357
  },
  {
    "dcode": "D",
    "dropkey": "PV17190",
    "droptype": "D",
    "dropname": "GARROCHALES",
    "dropdeladd": "100 CARR 682",
    "dropdelcty": "GARROCHALES",
    "dropdelst": "PR",
    "dropdelzpp": "006529997",
    "dropphyadd": "100 CARR 682",
    "dropphycty": "GARROCHALES",
    "dropphyst": "PR",
    "dropphyzpp": "006529997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARROCHALES",
    "dropmalst": "PR",
    "dropmalzpp": "006529998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878812990,
    "dropfax": 7878798355
  },
  {
    "dcode": "D",
    "dropkey": "PV17192",
    "droptype": "D",
    "dropname": "GUANICA",
    "dropdeladd": "39 CALLE 13 DE MARZO STE 101",
    "dropdelcty": "GUANICA",
    "dropdelst": "PR",
    "dropdelzpp": "006539998",
    "dropphyadd": "39 CALLE 13 DE MARZO STE 101",
    "dropphycty": "GUANICA",
    "dropphyst": "PR",
    "dropphyzpp": "006539998",
    "dropmaladd": "39 CALLE 13 DE MARZO STE 101",
    "dropmalcty": "GUANICA",
    "dropmalst": "PR",
    "dropmalzpp": "006539998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878212645,
    "dropfax": 7878215477
  },
  {
    "dcode": "D",
    "dropkey": "PV17193",
    "droptype": "D",
    "dropname": "GUAYAMA",
    "dropdeladd": "151 CALLE ASHFORD S",
    "dropdelcty": "GUAYAMA",
    "dropdelst": "PR",
    "dropdelzpp": "007849998",
    "dropphyadd": "151 CALLE ASHFORD S",
    "dropphycty": "GUAYAMA",
    "dropphyst": "PR",
    "dropphyzpp": "007849998",
    "dropmaladd": "151 CALLE ASHFORD S",
    "dropmalcty": "GUAYAMA",
    "dropmalst": "PR",
    "dropmalzpp": "007849998",
    "dropsitphn": 7877672797,
    "dropsitlph": 7877673029,
    "dropsitcph": 7878641150,
    "dropfax": 7878646420
  },
  {
    "dcode": "D",
    "dropkey": "PV17194",
    "droptype": "D",
    "dropname": "GUAYANILLA",
    "dropdeladd": "285 CALLE LUIS MUNOZ RIVERA",
    "dropdelcty": "GUAYANILLA",
    "dropdelst": "PR",
    "dropdelzpp": "006569998",
    "dropphyadd": "285 CALLE LUIS MUNOZ RIVERA",
    "dropphycty": "GUAYANILLA",
    "dropphyst": "PR",
    "dropphyzpp": "006569998",
    "dropmaladd": "285 CALLE LUIS MUNOZ RIVERA",
    "dropmalcty": "GUAYANILLA",
    "dropmalst": "PR",
    "dropmalzpp": "006569998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878350320,
    "dropfax": 7878350310
  },
  {
    "dcode": "D",
    "dropkey": "PV17195",
    "droptype": "D",
    "dropname": "GUAYNABO",
    "dropdeladd": "100 CALLE CECILIO URBINA",
    "dropdelcty": "GUAYNABO",
    "dropdelst": "PR",
    "dropdelzpp": "009699998",
    "dropphyadd": "100 CALLE CECILIO URBINA",
    "dropphycty": "GUAYNABO",
    "dropphyst": "PR",
    "dropphyzpp": "009699998",
    "dropmaladd": "100 CALLE CECILIO URBINA",
    "dropmalcty": "GUAYNABO",
    "dropmalst": "PR",
    "dropmalzpp": "009699998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877203891,
    "dropfax": 7872728666
  },
  {
    "dcode": "D",
    "dropkey": "PV17197",
    "droptype": "D",
    "dropname": "GURABO",
    "dropdeladd": "106 CALLE ANGEL C MORALES E",
    "dropdelcty": "GURABO",
    "dropdelst": "PR",
    "dropdelzpp": "007789998",
    "dropphyadd": "106 CALLE ANGEL C MORALES E",
    "dropphycty": "GURABO",
    "dropphyst": "PR",
    "dropphyzpp": "007789998",
    "dropmaladd": "106 CALLE ANGEL C MORALES E",
    "dropmalcty": "GURABO",
    "dropmalst": "PR",
    "dropmalzpp": "007789998",
    "dropsitphn": 7877672797,
    "dropsitlph": 7877673029,
    "dropsitcph": 7877370465,
    "dropfax": 7877371090
  },
  {
    "dcode": "D",
    "dropkey": "PV17198",
    "droptype": "D",
    "dropname": "HATILLO",
    "dropdeladd": "192 AVE DR SUSONI",
    "dropdelcty": "HATILLO",
    "dropdelst": "PR",
    "dropdelzpp": "006599998",
    "dropphyadd": "192 AVE DR SUSONI",
    "dropphycty": "HATILLO",
    "dropphyst": "PR",
    "dropphyzpp": "006599998",
    "dropmaladd": "192 AVE DR SUSONI",
    "dropmalcty": "HATILLO",
    "dropmalst": "PR",
    "dropmalzpp": "006599998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878982010,
    "dropfax": 7872620451
  },
  {
    "dcode": "D",
    "dropkey": "PV17202",
    "droptype": "D",
    "dropname": "HORMIGUEROS",
    "dropdeladd": "250 CARR 344",
    "dropdelcty": "HORMIGUEROS",
    "dropdelst": "PR",
    "dropdelzpp": "006601831",
    "dropphyadd": "250 CARR 344",
    "dropphycty": "HORMIGUEROS",
    "dropphyst": "PR",
    "dropphyzpp": "006609998",
    "dropmaladd": "250 CARR 344",
    "dropmalcty": "HORMIGUEROS",
    "dropmalst": "PR",
    "dropmalzpp": "006601831",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878492180,
    "dropfax": 7878492180
  },
  {
    "dcode": "D",
    "dropkey": "PV17203",
    "droptype": "D",
    "dropname": "HUMACAO",
    "dropdeladd": "122 CALLE FONT MARTELO",
    "dropdelcty": "HUMACAO",
    "dropdelst": "PR",
    "dropdelzpp": "007919998",
    "dropphyadd": "122 CALLE FONT MARTELO",
    "dropphycty": "HUMACAO",
    "dropphyst": "PR",
    "dropphyzpp": "007919998",
    "dropmaladd": "122 CALLE FONT MARTELO",
    "dropmalcty": "HUMACAO",
    "dropmalst": "PR",
    "dropmalzpp": "007919998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 2027917636,
    "dropfax": 2027917636
  },
  {
    "dcode": "D",
    "dropkey": "PV17204",
    "droptype": "D",
    "dropname": "ISABELA",
    "dropdeladd": "5 CALLE PINEIRO",
    "dropdelcty": "ISABELA",
    "dropdelst": "PR",
    "dropdelzpp": "006623669",
    "dropphyadd": "5 CALLE PINEIRO",
    "dropphycty": "ISABELA",
    "dropphyst": "PR",
    "dropphyzpp": "006623669",
    "dropmaladd": "5 CALLE PINEIRO",
    "dropmalcty": "ISABELA",
    "dropmalst": "PR",
    "dropmalzpp": "006623669",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878722284,
    "dropfax": 7878729461
  },
  {
    "dcode": "D",
    "dropkey": "PV17206",
    "droptype": "D",
    "dropname": "JAYUYA",
    "dropdeladd": "15 CALLE A BARCELO STE 2",
    "dropdelcty": "JAYUYA",
    "dropdelst": "PR",
    "dropdelzpp": "006649998",
    "dropphyadd": "15 CALLE A BARCELO STE 2",
    "dropphycty": "JAYUYA",
    "dropphyst": "PR",
    "dropphyzpp": "006649998",
    "dropmaladd": "15 CALLE A BARCELO STE 2",
    "dropmalcty": "JAYUYA",
    "dropmalst": "PR",
    "dropmalzpp": "006649998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878283010,
    "dropfax": 7878284167
  },
  {
    "dcode": "D",
    "dropkey": "PV17207",
    "droptype": "D",
    "dropname": "JUANA DIAZ",
    "dropdeladd": "72 CALLE EXT MUNOZ RIVERA",
    "dropdelcty": "JUANA DIAZ",
    "dropdelst": "PR",
    "dropdelzpp": "007959998",
    "dropphyadd": "72 CALLE EXT MUNOZ RIVERA",
    "dropphycty": "JUANA DIAZ",
    "dropphyst": "PR",
    "dropphyzpp": "007959998",
    "dropmaladd": "72 CALLE EXT MUNOZ RIVERA",
    "dropmalcty": "JUANA DIAZ",
    "dropmalst": "PR",
    "dropmalzpp": "007959998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878372050,
    "dropfax": 7872602859
  },
  {
    "dcode": "D",
    "dropkey": "PV17208",
    "droptype": "D",
    "dropname": "JUNCOS",
    "dropdeladd": "1 CALLE MUNOZ RIVERA",
    "dropdelcty": "JUNCOS",
    "dropdelst": "PR",
    "dropdelzpp": "007779998",
    "dropphyadd": "1 CALLE MUNOZ RIVERA",
    "dropphycty": "JUNCOS",
    "dropphyst": "PR",
    "dropphyzpp": "007779998",
    "dropmaladd": "1 CALLE MUNOZ RIVERA",
    "dropmalcty": "JUNCOS",
    "dropmalst": "PR",
    "dropmalzpp": "007779998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877343562,
    "dropfax": 7877344160
  },
  {
    "dcode": "D",
    "dropkey": "PV17210",
    "droptype": "D",
    "dropname": "LA PLATA",
    "dropdeladd": "5 CARR 173",
    "dropdelcty": "LA PLATA",
    "dropdelst": "PR",
    "dropdelzpp": "007869997",
    "dropphyadd": "5 CARR 173",
    "dropphycty": "LA PLATA",
    "dropphyst": "PR",
    "dropphyzpp": "007869997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA PLATA",
    "dropmalst": "PR",
    "dropmalzpp": "007869998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877357987,
    "dropfax": 7877355640
  },
  {
    "dcode": "D",
    "dropkey": "PV17211",
    "droptype": "D",
    "dropname": "LAJAS",
    "dropdeladd": "72 CALLE 65 DE INFANTERIA S",
    "dropdelcty": "LAJAS",
    "dropdelst": "PR",
    "dropdelzpp": "006679998",
    "dropphyadd": "72 CALLE 65 DE INFANTERIA S",
    "dropphycty": "LAJAS",
    "dropphyst": "PR",
    "dropphyzpp": "006679998",
    "dropmaladd": "72 CALLE 65 DE INFANTERIA S",
    "dropmalcty": "LAJAS",
    "dropmalst": "PR",
    "dropmalzpp": "006679998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878991440,
    "dropfax": 7878991110
  },
  {
    "dcode": "D",
    "dropkey": "PV17212",
    "droptype": "D",
    "dropname": "LARES",
    "dropdeladd": "100 AVE LOS PATRIOTAS STE 1",
    "dropdelcty": "LARES",
    "dropdelst": "PR",
    "dropdelzpp": "006699998",
    "dropphyadd": "100 AVE LOS PATRIOTAS STE 1",
    "dropphycty": "LARES",
    "dropphyst": "PR",
    "dropphyzpp": "006699998",
    "dropmaladd": "100 AVE LOS PATRIOTAS STE 1",
    "dropmalcty": "LARES",
    "dropmalst": "PR",
    "dropmalzpp": "006699998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878972260,
    "dropfax": 7878970340
  },
  {
    "dcode": "D",
    "dropkey": "PV17213",
    "droptype": "D",
    "dropname": "LAS MARIAS",
    "dropdeladd": "78 AVE MATIAS BRUGMAN",
    "dropdelcty": "LAS MARIAS",
    "dropdelst": "PR",
    "dropdelzpp": "006709998",
    "dropphyadd": "78 AVE MATIAS BRUGMAN",
    "dropphycty": "LAS MARIAS",
    "dropphyst": "PR",
    "dropphyzpp": "006709998",
    "dropmaladd": "78 AVE MATIAS BRUGMAN",
    "dropmalcty": "LAS MARIAS",
    "dropmalst": "PR",
    "dropmalzpp": "006709998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878272295,
    "dropfax": 7878274080
  },
  {
    "dcode": "D",
    "dropkey": "PV17214",
    "droptype": "D",
    "dropname": "LAS PIEDRAS",
    "dropdeladd": "77 CALLE JT PINERO STE 1",
    "dropdelcty": "LAS PIEDRAS",
    "dropdelst": "PR",
    "dropdelzpp": "007719998",
    "dropphyadd": "77 CALLE JT PINERO STE 1",
    "dropphycty": "LAS PIEDRAS",
    "dropphyst": "PR",
    "dropphyzpp": "007719998",
    "dropmaladd": "77 CALLE JT PINERO STE 1",
    "dropmalcty": "LAS PIEDRAS",
    "dropmalst": "PR",
    "dropmalzpp": "007719998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877334161,
    "dropfax": 7877332665
  },
  {
    "dcode": "D",
    "dropkey": "PV17218",
    "droptype": "D",
    "dropname": "LOIZA",
    "dropdeladd": "64 CALLE SAN PATRICIO",
    "dropdelcty": "LOIZA",
    "dropdelst": "PR",
    "dropdelzpp": "007729998",
    "dropphyadd": "64 CALLE SAN PATRICIO",
    "dropphycty": "LOIZA",
    "dropphyst": "PR",
    "dropphyzpp": "007729998",
    "dropmaladd": "64 CALLE SAN PATRICIO",
    "dropmalcty": "LOIZA",
    "dropmalst": "PR",
    "dropmalzpp": "007729998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878762025,
    "dropfax": 7878762025
  },
  {
    "dcode": "D",
    "dropkey": "PV17223",
    "droptype": "D",
    "dropname": "LUQUILLO",
    "dropdeladd": "160 CALLE QUINTO CENTENARIO",
    "dropdelcty": "LUQUILLO",
    "dropdelst": "PR",
    "dropdelzpp": "007739998",
    "dropphyadd": "160 CALLE QUINTO CENTENARIO",
    "dropphycty": "LUQUILLO",
    "dropphyst": "PR",
    "dropphyzpp": "007739998",
    "dropmaladd": "160 CALLE QUINTO CENTENARIO",
    "dropmalcty": "LUQUILLO",
    "dropmalst": "PR",
    "dropmalzpp": "007739998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878893170,
    "dropfax": 7878891449
  },
  {
    "dcode": "D",
    "dropkey": "PV17224",
    "droptype": "D",
    "dropname": "MANATI",
    "dropdeladd": "29 CALLE ELLIOT VELEZ",
    "dropdelcty": "MANATI",
    "dropdelst": "PR",
    "dropdelzpp": "006749998",
    "dropphyadd": "29 CALLE ELLIOT VELEZ",
    "dropphycty": "MANATI",
    "dropphyst": "PR",
    "dropphyzpp": "006749998",
    "dropmaladd": "29 CALLE ELLIOT VELEZ",
    "dropmalcty": "MANATI",
    "dropmalst": "PR",
    "dropmalzpp": "006749998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878542296,
    "dropfax": 7878842942
  },
  {
    "dcode": "D",
    "dropkey": "PV17225",
    "droptype": "D",
    "dropname": "MARICAO",
    "dropdeladd": "9 CALLE ZUZUARREGUI FRNT",
    "dropdelcty": "MARICAO",
    "dropdelst": "PR",
    "dropdelzpp": "006069998",
    "dropphyadd": "9 CALLE ZUZUARREGUI FRNT",
    "dropphycty": "MARICAO",
    "dropphyst": "PR",
    "dropphyzpp": "006069998",
    "dropmaladd": "9 CALLE ZUZUARREGUI FRNT",
    "dropmalcty": "MARICAO",
    "dropmalst": "PR",
    "dropmalzpp": "006069998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878383605,
    "dropfax": 7878383605
  },
  {
    "dcode": "D",
    "dropkey": "PV17226",
    "droptype": "D",
    "dropname": "MAUNABO",
    "dropdeladd": "184 AVE CALIMANO",
    "dropdelcty": "MAUNABO",
    "dropdelst": "PR",
    "dropdelzpp": "007079998",
    "dropphyadd": "184 AVE CALIMANO",
    "dropphycty": "MAUNABO",
    "dropphyst": "PR",
    "dropphyzpp": "007079998",
    "dropmaladd": "184 AVE CALIMANO",
    "dropmalcty": "MAUNABO",
    "dropmalst": "PR",
    "dropmalzpp": "007079998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878612955,
    "dropfax": 7878612366
  },
  {
    "dcode": "D",
    "dropkey": "PV17227",
    "droptype": "D",
    "dropname": "MAYAGUEZ",
    "dropdeladd": "60 CALLE MCKINLEY W",
    "dropdelcty": "MAYAGUEZ",
    "dropdelst": "PR",
    "dropdelzpp": "006809998",
    "dropphyadd": "60 CALLE MCKINLEY W",
    "dropphycty": "MAYAGUEZ",
    "dropphyst": "PR",
    "dropphyzpp": "006809998",
    "dropmaladd": "60 CALLE MCKINLEY W",
    "dropmalcty": "MAYAGUEZ",
    "dropmalst": "PR",
    "dropmalzpp": "006809998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7872653138,
    "dropfax": 7878316106
  },
  {
    "dcode": "D",
    "dropkey": "PV17228",
    "droptype": "D",
    "dropname": "MERCEDITA",
    "dropdeladd": "100 TURPEAUX IND PARK",
    "dropdelcty": "MERCEDITA",
    "dropdelst": "PR",
    "dropdelzpp": "007159998",
    "dropphyadd": "100 TURPEAUX IND PARK",
    "dropphycty": "MERCEDITA",
    "dropphyst": "PR",
    "dropphyzpp": "007159998",
    "dropmaladd": "100 TURPEAUX IND PARK",
    "dropmalcty": "MERCEDITA",
    "dropmalst": "PR",
    "dropmalzpp": "007159998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878120229,
    "dropfax": 7878120209
  },
  {
    "dcode": "D",
    "dropkey": "PV17232",
    "droptype": "D",
    "dropname": "MOCA",
    "dropdeladd": "212 AVE LA MOCA",
    "dropdelcty": "MOCA",
    "dropdelst": "PR",
    "dropdelzpp": "006769998",
    "dropphyadd": "212 AVE LA MOCA",
    "dropphycty": "MOCA",
    "dropphyst": "PR",
    "dropphyzpp": "006769998",
    "dropmaladd": "212 AVE LA MOCA",
    "dropmalcty": "MOCA",
    "dropmalst": "PR",
    "dropmalzpp": "006769998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878772455,
    "dropfax": 7878180005
  },
  {
    "dcode": "D",
    "dropkey": "PV17234",
    "droptype": "D",
    "dropname": "MOROVIS",
    "dropdeladd": "200 CARR 155",
    "dropdelcty": "MOROVIS",
    "dropdelst": "PR",
    "dropdelzpp": "006879998",
    "dropphyadd": "200 CARR 155",
    "dropphycty": "MOROVIS",
    "dropphyst": "PR",
    "dropphyzpp": "006879998",
    "dropmaladd": "200 CARR 155",
    "dropmalcty": "MOROVIS",
    "dropmalst": "PR",
    "dropmalzpp": "006879998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878621500,
    "dropfax": 7878621540
  },
  {
    "dcode": "D",
    "dropkey": "PV17235",
    "droptype": "D",
    "dropname": "NAGUABO",
    "dropdeladd": "100 CARR 31",
    "dropdelcty": "NAGUABO",
    "dropdelst": "PR",
    "dropdelzpp": "007189998",
    "dropphyadd": "100 CARR 31",
    "dropphycty": "NAGUABO",
    "dropphyst": "PR",
    "dropphyzpp": "007189998",
    "dropmaladd": "100 CARR 31",
    "dropmalcty": "NAGUABO",
    "dropmalst": "PR",
    "dropmalzpp": "007189998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878743115,
    "dropfax": 7878743160
  },
  {
    "dcode": "D",
    "dropkey": "PV17236",
    "droptype": "D",
    "dropname": "NARANJITO",
    "dropdeladd": "40 CALLE GEORGETTI",
    "dropdelcty": "NARANJITO",
    "dropdelst": "PR",
    "dropdelzpp": "007199998",
    "dropphyadd": "40 CALLE GEORGETTI",
    "dropphycty": "NARANJITO",
    "dropphyst": "PR",
    "dropphyzpp": "007199998",
    "dropmaladd": "40 CALLE GEORGETTI",
    "dropmalcty": "NARANJITO",
    "dropmalst": "PR",
    "dropmalzpp": "007199998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878692140,
    "dropfax": 7878697784
  },
  {
    "dcode": "D",
    "dropkey": "PV17239",
    "droptype": "D",
    "dropname": "OROCOVIS",
    "dropdeladd": "35 AVE ERNESTO RAMOS ANTONINI",
    "dropdelcty": "OROCOVIS",
    "dropdelst": "PR",
    "dropdelzpp": "007209998",
    "dropphyadd": "35 AVE ERNESTO RAMOS ANTONINI",
    "dropphycty": "OROCOVIS",
    "dropphyst": "PR",
    "dropphyzpp": "007209998",
    "dropmaladd": "35 AVE ERNESTO RAMOS ANTONINI",
    "dropmalcty": "OROCOVIS",
    "dropmalst": "PR",
    "dropmalzpp": "007209998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878670640,
    "dropfax": 7877672015
  },
  {
    "dcode": "D",
    "dropkey": "PV17241",
    "droptype": "D",
    "dropname": "PATILLAS",
    "dropdeladd": "101 CARR 3",
    "dropdelcty": "PATILLAS",
    "dropdelst": "PR",
    "dropdelzpp": "007239998",
    "dropphyadd": "101 CARR 3",
    "dropphycty": "PATILLAS",
    "dropphyst": "PR",
    "dropphyzpp": "007239998",
    "dropmaladd": "101 CARR 3",
    "dropmalcty": "PATILLAS",
    "dropmalst": "PR",
    "dropmalzpp": "007239998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878393270,
    "dropfax": 7878395767
  },
  {
    "dcode": "D",
    "dropkey": "PV17242",
    "droptype": "D",
    "dropname": "PENUELAS",
    "dropdeladd": "100 CARR 132",
    "dropdelcty": "PENUELAS",
    "dropdelst": "PR",
    "dropdelzpp": "006249998",
    "dropphyadd": "100 CARR 132",
    "dropphycty": "PENUELAS",
    "dropphyst": "PR",
    "dropphyzpp": "006249998",
    "dropmaladd": "100 CARR 132",
    "dropmalcty": "PENUELAS",
    "dropmalst": "PR",
    "dropmalzpp": "006249998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878361252,
    "dropfax": 7878367062
  },
  {
    "dcode": "D",
    "dropkey": "PV17246",
    "droptype": "D",
    "dropname": "PONCE",
    "dropdeladd": "2340 AVE EDUARDO RUBERTE",
    "dropdelcty": "PONCE",
    "dropdelst": "PR",
    "dropdelzpp": "007179998",
    "dropphyadd": "2340 AVE EDUARDO RUBERTE",
    "dropphycty": "PONCE",
    "dropphyst": "PR",
    "dropphyzpp": "007179998",
    "dropmaladd": "2340 AVE EDUARDO RUBERTE",
    "dropmalcty": "PONCE",
    "dropmalst": "PR",
    "dropmalzpp": "007179998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878431503,
    "dropfax": 7872598515
  },
  {
    "dcode": "D",
    "dropkey": "PV17252",
    "droptype": "D",
    "dropname": "PUERTO REAL",
    "dropdeladd": "477 CALLE UN",
    "dropdelcty": "PUERTO REAL",
    "dropdelst": "PR",
    "dropdelzpp": "007409998",
    "dropphyadd": "477 CALLE UN",
    "dropphycty": "PUERTO REAL",
    "dropphyst": "PR",
    "dropphyzpp": "007409998",
    "dropmaladd": "477 CALLE UN",
    "dropmalcty": "PUERTO REAL",
    "dropmalst": "PR",
    "dropmalzpp": "007409998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878631827,
    "dropfax": 7878633348
  },
  {
    "dcode": "D",
    "dropkey": "PV17253",
    "droptype": "D",
    "dropname": "PUNTA SANTIAGO",
    "dropdeladd": "15 CALLE ADUANA",
    "dropdelcty": "PUNTA SANTIAGO",
    "dropdelst": "PR",
    "dropdelzpp": "007419998",
    "dropphyadd": "15 CALLE ADUANA",
    "dropphycty": "PUNTA SANTIAGO",
    "dropphyst": "PR",
    "dropphyzpp": "007419998",
    "dropmaladd": "15 CALLE ADUANA",
    "dropmalcty": "PUNTA SANTIAGO",
    "dropmalst": "PR",
    "dropmalzpp": "007419998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878502240,
    "dropfax": 7878501483
  },
  {
    "dcode": "D",
    "dropkey": "PV17255",
    "droptype": "D",
    "dropname": "QUEBRADILLAS",
    "dropdeladd": "64 CALLE JOSE L LINARES",
    "dropdelcty": "QUEBRADILLAS",
    "dropdelst": "PR",
    "dropdelzpp": "006789998",
    "dropphyadd": "64 CALLE JOSE L LINARES",
    "dropphycty": "QUEBRADILLAS",
    "dropphyst": "PR",
    "dropphyzpp": "006789998",
    "dropmaladd": "64 CALLE JOSE L LINARES",
    "dropmalcty": "QUEBRADILLAS",
    "dropmalst": "PR",
    "dropmalzpp": "006789998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878952800,
    "dropfax": 7878958358
  },
  {
    "dcode": "D",
    "dropkey": "PV17258",
    "droptype": "D",
    "dropname": "RINCON",
    "dropdeladd": "100 CARR 115",
    "dropdelcty": "RINCON",
    "dropdelst": "PR",
    "dropdelzpp": "006779998",
    "dropphyadd": "100 CARR 115",
    "dropphycty": "RINCON",
    "dropphyst": "PR",
    "dropphyzpp": "006779998",
    "dropmaladd": "100 CARR 115",
    "dropmalcty": "RINCON",
    "dropmalst": "PR",
    "dropmalzpp": "006779998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878232625,
    "dropfax": 7878231565
  },
  {
    "dcode": "D",
    "dropkey": "PV17259",
    "droptype": "D",
    "dropname": "RIO BLANCO",
    "dropdeladd": "100 CARR 31",
    "dropdelcty": "RIO BLANCO",
    "dropdelst": "PR",
    "dropdelzpp": "007449800",
    "dropphyadd": "100 CARR 31",
    "dropphycty": "RIO BLANCO",
    "dropphyst": "PR",
    "dropphyzpp": "007449800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIO BLANCO",
    "dropmalst": "PR",
    "dropmalzpp": "007449998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878742524,
    "dropfax": 7878741857
  },
  {
    "dcode": "D",
    "dropkey": "PV17260",
    "droptype": "D",
    "dropname": "RIO GRANDE",
    "dropdeladd": "99 CALLE PIMENTEL STE 1",
    "dropdelcty": "RIO GRANDE",
    "dropdelst": "PR",
    "dropdelzpp": "007459998",
    "dropphyadd": "99 CALLE PIMENTEL STE 1",
    "dropphycty": "RIO GRANDE",
    "dropphyst": "PR",
    "dropphyzpp": "007459998",
    "dropmaladd": "99 CALLE PIMENTEL STE 1",
    "dropmalcty": "RIO GRANDE",
    "dropmalst": "PR",
    "dropmalzpp": "007459998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878872735,
    "dropfax": 7878876842
  },
  {
    "dcode": "D",
    "dropkey": "PV17264",
    "droptype": "D",
    "dropname": "SABANA GRANDE",
    "dropdeladd": "1 AVE VICENTE QUILINCHINI STE 4",
    "dropdelcty": "SABANA GRANDE",
    "dropdelst": "PR",
    "dropdelzpp": "006379998",
    "dropphyadd": "1 AVE VICENTE QUILINCHINI STE 4",
    "dropphycty": "SABANA GRANDE",
    "dropphyst": "PR",
    "dropphyzpp": "006379998",
    "dropmaladd": "1 AVE VICENTE QUILINCHINI STE 4",
    "dropmalcty": "SABANA GRANDE",
    "dropmalst": "PR",
    "dropmalzpp": "006379998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878040040,
    "dropfax": 7878040042
  },
  {
    "dcode": "D",
    "dropkey": "PV17265",
    "droptype": "D",
    "dropname": "SABANA HOYOS",
    "dropdeladd": "50 CARR 639",
    "dropdelcty": "SABANA HOYOS",
    "dropdelst": "PR",
    "dropdelzpp": "006889591",
    "dropphyadd": "50 CARR 639",
    "dropphycty": "SABANA HOYOS",
    "dropphyst": "PR",
    "dropphyzpp": "006889591",
    "dropmaladd": "50 CARR 639",
    "dropmalcty": "SABANA HOYOS",
    "dropmalst": "PR",
    "dropmalzpp": "006889591",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878160800,
    "dropfax": 7878160803
  },
  {
    "dcode": "D",
    "dropkey": "PV17266",
    "droptype": "D",
    "dropname": "SABANA SECA",
    "dropdeladd": "100 CARR 866",
    "dropdelcty": "SABANA SECA",
    "dropdelst": "PR",
    "dropdelzpp": "009529997",
    "dropphyadd": "100 CARR 866",
    "dropphycty": "SABANA SECA",
    "dropphyst": "PR",
    "dropphyzpp": "009529997",
    "dropmaladd": "100 CARR 866",
    "dropmalcty": "SABANA SECA",
    "dropmalst": "PR",
    "dropmalzpp": "009529997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877844455,
    "dropfax": 7877954820
  },
  {
    "dcode": "D",
    "dropkey": "PV17268",
    "droptype": "D",
    "dropname": "SALINAS",
    "dropdeladd": "100 CARR PLAYA",
    "dropdelcty": "SALINAS",
    "dropdelst": "PR",
    "dropdelzpp": "007519998",
    "dropphyadd": "100 CARR PLAYA",
    "dropphycty": "SALINAS",
    "dropphyst": "PR",
    "dropphyzpp": "007519998",
    "dropmaladd": "100 CARR PLAYA",
    "dropmalcty": "SALINAS",
    "dropmalst": "PR",
    "dropmalzpp": "007519998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878242485,
    "dropfax": 7878242696
  },
  {
    "dcode": "D",
    "dropkey": "PV17269",
    "droptype": "D",
    "dropname": "SAN ANTONIO",
    "dropdeladd": "1068 AVE GENERAL RAMEY",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "PR",
    "dropdelzpp": "006901216",
    "dropphyadd": "1068 AVE GENERAL RAMEY",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "PR",
    "dropphyzpp": "006901216",
    "dropmaladd": "1068 AVE GENERAL RAMEY",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "PR",
    "dropmalzpp": "006901216",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878823525,
    "dropfax": 7878901730
  },
  {
    "dcode": "D",
    "dropkey": "PV17271",
    "droptype": "D",
    "dropname": "SAN GERMAN",
    "dropdeladd": "181 AVE UNIV INTERAMERICANA",
    "dropdelcty": "SAN GERMAN",
    "dropdelst": "PR",
    "dropdelzpp": "006839998",
    "dropphyadd": "181 AVE UNIV INTERAMERICANA",
    "dropphycty": "SAN GERMAN",
    "dropphyst": "PR",
    "dropphyzpp": "006839998",
    "dropmaladd": "181 AVE UNIV INTERAMERICANA",
    "dropmalcty": "SAN GERMAN",
    "dropmalst": "PR",
    "dropmalzpp": "006839998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878921313,
    "dropfax": 7878926145
  },
  {
    "dcode": "D",
    "dropkey": "PV17274",
    "droptype": "D",
    "dropname": "SAN JUAN",
    "dropdeladd": "585 AVE FD ROOSEVELT STE 202",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009369998",
    "dropphyadd": "585 AVE FD ROOSEVELT STE 202",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009369998",
    "dropmaladd": "585 AVE FD ROOSEVELT STE 202",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009369998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7876221758,
    "dropfax": 7876221808
  },
  {
    "dcode": "D",
    "dropkey": "PV17276",
    "droptype": "D",
    "dropname": "SAN LORENZO",
    "dropdeladd": "123 CALLE DE DIEGO",
    "dropdelcty": "SAN LORENZO",
    "dropdelst": "PR",
    "dropdelzpp": "007549998",
    "dropphyadd": "123 CALLE DE DIEGO",
    "dropphycty": "SAN LORENZO",
    "dropphyst": "PR",
    "dropphyzpp": "007549998",
    "dropmaladd": "123 CALLE DE DIEGO",
    "dropmalcty": "SAN LORENZO",
    "dropmalst": "PR",
    "dropmalzpp": "007549998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877364101,
    "dropfax": 7877150040
  },
  {
    "dcode": "D",
    "dropkey": "PV17277",
    "droptype": "D",
    "dropname": "SAN SEBASTIAN",
    "dropdeladd": "211 CALLE RUIZ BELVIS",
    "dropdelcty": "SAN SEBASTIAN",
    "dropdelst": "PR",
    "dropdelzpp": "006859998",
    "dropphyadd": "211 CALLE RUIZ BELVIS",
    "dropphycty": "SAN SEBASTIAN",
    "dropphyst": "PR",
    "dropphyzpp": "006859998",
    "dropmaladd": "211 CALLE RUIZ BELVIS",
    "dropmalcty": "SAN SEBASTIAN",
    "dropmalst": "PR",
    "dropmalzpp": "006859998",
    "dropsitphn": 7872801333,
    "dropsitlph": 7876221796,
    "dropsitcph": 7872801333,
    "dropfax": 7872801332
  },
  {
    "dcode": "D",
    "dropkey": "PV17278",
    "droptype": "D",
    "dropname": "SANTA ISABEL",
    "dropdeladd": "36 CALLE LUIS MUNOZ RIVERA STE 1",
    "dropdelcty": "SANTA ISABEL",
    "dropdelst": "PR",
    "dropdelzpp": "007579998",
    "dropphyadd": "36 CALLE LUIS MUNOZ RIVERA STE 1",
    "dropphycty": "SANTA ISABEL",
    "dropphyst": "PR",
    "dropphyzpp": "007579998",
    "dropmaladd": "36 CALLE LUIS MUNOZ RIVERA STE 1",
    "dropmalcty": "SANTA ISABEL",
    "dropmalst": "PR",
    "dropmalzpp": "007579998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878453840,
    "dropfax": 7878455997
  },
  {
    "dcode": "D",
    "dropkey": "PV17285",
    "droptype": "D",
    "dropname": "TOA ALTA",
    "dropdeladd": "125 CARR 165 STE 1",
    "dropdelcty": "TOA ALTA",
    "dropdelst": "PR",
    "dropdelzpp": "009539997",
    "dropphyadd": "125 CARR 165 STE 1",
    "dropphycty": "TOA ALTA",
    "dropphyst": "PR",
    "dropphyzpp": "009539997",
    "dropmaladd": "125 CARR 165 STE 1",
    "dropmalcty": "TOA ALTA",
    "dropmalst": "PR",
    "dropmalzpp": "009539997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878702061,
    "dropfax": 7878707727
  },
  {
    "dcode": "D",
    "dropkey": "PV17286",
    "droptype": "D",
    "dropname": "TOA BAJA",
    "dropdeladd": "600 CALLE DR HERNAN CORTES STE 1",
    "dropdelcty": "TOA BAJA",
    "dropdelst": "PR",
    "dropdelzpp": "009499998",
    "dropphyadd": "600 CALLE DR HERNAN CORTES STE 1",
    "dropphycty": "TOA BAJA",
    "dropphyst": "PR",
    "dropphyzpp": "009499998",
    "dropmaladd": "600 CALLE DR HERNAN CORTES STE 1",
    "dropmalcty": "TOA BAJA",
    "dropmalst": "PR",
    "dropmalzpp": "009499998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877846977,
    "dropfax": 7872616035
  },
  {
    "dcode": "D",
    "dropkey": "PV17290",
    "droptype": "D",
    "dropname": "UTUADO",
    "dropdeladd": "41 AVE FERNANDO L RIBAS",
    "dropdelcty": "UTUADO",
    "dropdelst": "PR",
    "dropdelzpp": "006419998",
    "dropphyadd": "41 AVE FERNANDO L RIBAS",
    "dropphycty": "UTUADO",
    "dropphyst": "PR",
    "dropphyzpp": "006419998",
    "dropmaladd": "41 AVE FERNANDO L RIBAS",
    "dropmalcty": "UTUADO",
    "dropmalst": "PR",
    "dropmalzpp": "006419998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878942490,
    "dropfax": 7878946796
  },
  {
    "dcode": "D",
    "dropkey": "PV17291",
    "droptype": "D",
    "dropname": "VEGA ALTA",
    "dropdeladd": "100 CARR 2",
    "dropdelcty": "VEGA ALTA",
    "dropdelst": "PR",
    "dropdelzpp": "006929998",
    "dropphyadd": "100 CARR 2",
    "dropphycty": "VEGA ALTA",
    "dropphyst": "PR",
    "dropphyzpp": "006929998",
    "dropmaladd": "100 CARR 2",
    "dropmalcty": "VEGA ALTA",
    "dropmalst": "PR",
    "dropmalzpp": "006929998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878834200,
    "dropfax": 7872700497
  },
  {
    "dcode": "D",
    "dropkey": "PV17292",
    "droptype": "D",
    "dropname": "VEGA BAJA",
    "dropdeladd": "A10 CALLE 2",
    "dropdelcty": "VEGA BAJA",
    "dropdelst": "PR",
    "dropdelzpp": "006939998",
    "dropphyadd": "A10 CALLE 2",
    "dropphycty": "VEGA BAJA",
    "dropphyst": "PR",
    "dropphyzpp": "006939998",
    "dropmaladd": "A10 CALLE 2",
    "dropmalcty": "VEGA BAJA",
    "dropmalst": "PR",
    "dropmalzpp": "006939998",
    "dropsitphn": 7876221793,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878582710,
    "dropfax": 7878588854
  },
  {
    "dcode": "D",
    "dropkey": "PV17296",
    "droptype": "D",
    "dropname": "VIEQUES",
    "dropdeladd": "300 CALLE ANTONIO G MELLADO STE 1",
    "dropdelcty": "VIEQUES",
    "dropdelst": "PR",
    "dropdelzpp": "007659997",
    "dropphyadd": "300 CALLE ANTONIO G MELLADO STE 1",
    "dropphycty": "VIEQUES",
    "dropphyst": "PR",
    "dropphyzpp": "007659997",
    "dropmaladd": "300 CALLE ANTONIO G MELLADO STE 1",
    "dropmalcty": "VIEQUES",
    "dropmalst": "PR",
    "dropmalzpp": "007659997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877413891,
    "dropfax": 7877410370
  },
  {
    "dcode": "D",
    "dropkey": "PV17298",
    "droptype": "D",
    "dropname": "VILLALBA",
    "dropdeladd": "25 CALLE MUNOZ RIVERA",
    "dropdelcty": "VILLALBA",
    "dropdelst": "PR",
    "dropdelzpp": "007669998",
    "dropphyadd": "25 CALLE MUNOZ RIVERA",
    "dropphycty": "VILLALBA",
    "dropphyst": "PR",
    "dropphyzpp": "007669998",
    "dropmaladd": "25 CALLE MUNOZ RIVERA",
    "dropmalcty": "VILLALBA",
    "dropmalst": "PR",
    "dropmalzpp": "007669998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221796,
    "dropsitcph": 7878472560,
    "dropfax": 7878476163
  },
  {
    "dcode": "D",
    "dropkey": "PV17299",
    "droptype": "D",
    "dropname": "YABUCOA",
    "dropdeladd": "100 CALLE CATALINA MORALES",
    "dropdelcty": "YABUCOA",
    "dropdelst": "PR",
    "dropdelzpp": "007679998",
    "dropphyadd": "100 CALLE CATALINA MORALES",
    "dropphycty": "YABUCOA",
    "dropphyst": "PR",
    "dropphyzpp": "007679998",
    "dropmaladd": "100 CALLE CATALINA MORALES",
    "dropmalcty": "YABUCOA",
    "dropmalst": "PR",
    "dropmalzpp": "007679998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878932135,
    "dropfax": 7878930088
  },
  {
    "dcode": "D",
    "dropkey": "PV17300",
    "droptype": "D",
    "dropname": "YAUCO",
    "dropdeladd": "329 YAUCO PLAZA I",
    "dropdelcty": "YAUCO",
    "dropdelst": "PR",
    "dropdelzpp": "006989997",
    "dropphyadd": "329 YAUCO PLAZA I",
    "dropphycty": "YAUCO",
    "dropphyst": "PR",
    "dropphyzpp": "006989997",
    "dropmaladd": "329 YAUCO PLAZA I",
    "dropmalcty": "YAUCO",
    "dropmalst": "PR",
    "dropmalzpp": "006989997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878568080,
    "dropfax": 7872679095
  },
  {
    "dcode": "D",
    "dropkey": "PV17301",
    "droptype": "D",
    "dropname": "CHARLOTTE AMALIE",
    "dropdeladd": "9846 ESTATE THOMAS",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029998",
    "dropphyadd": "9846 ESTATE THOMAS",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029998",
    "dropmaladd": "9846 ESTATE THOMAS",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 3407741950,
    "dropfax": 3407741991
  },
  {
    "dcode": "D",
    "dropkey": "PV17302",
    "droptype": "D",
    "dropname": "CHRISTIANSTED",
    "dropdeladd": "1104 ESTATE RICHMOND",
    "dropdelcty": "CHRISTIANSTED",
    "dropdelst": "VI",
    "dropdelzpp": "008209998",
    "dropphyadd": "1104 ESTATE RICHMOND",
    "dropphycty": "CHRISTIANSTED",
    "dropphyst": "VI",
    "dropphyzpp": "008209998",
    "dropmaladd": "1104 ESTATE RICHMOND",
    "dropmalcty": "CHRISTIANSTED",
    "dropmalst": "VI",
    "dropmalzpp": "008209998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407731505,
    "dropfax": 3407736226
  },
  {
    "dcode": "D",
    "dropkey": "PV17303",
    "droptype": "D",
    "dropname": "CRUZ BAY",
    "dropdeladd": "100 VESTER GADE",
    "dropdelcty": "ST JOHN",
    "dropdelst": "VI",
    "dropdelzpp": "008309998",
    "dropphyadd": "100 VESTER GADE",
    "dropphycty": "ST JOHN",
    "dropphyst": "VI",
    "dropphyzpp": "008309998",
    "dropmaladd": "100 VESTER GADE",
    "dropmalcty": "ST JOHN",
    "dropmalst": "VI",
    "dropmalzpp": "008309998",
    "dropsitphn": 7676221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407794227,
    "dropfax": 3407794513
  },
  {
    "dcode": "D",
    "dropkey": "PV17305",
    "droptype": "D",
    "dropname": "FREDERIKSTED",
    "dropdeladd": "1 MARS HL",
    "dropdelcty": "FREDERIKSTED",
    "dropdelst": "VI",
    "dropdelzpp": "008409998",
    "dropphyadd": "1 MARS HL",
    "dropphycty": "FREDERIKSTED",
    "dropphyst": "VI",
    "dropphyzpp": "008409998",
    "dropmaladd": "1 MARS HL",
    "dropmalcty": "FREDERIKSTED",
    "dropmalst": "VI",
    "dropmalzpp": "008409998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407720040,
    "dropfax": 3407722858
  },
  {
    "dcode": "D",
    "dropkey": "PV17306",
    "droptype": "D",
    "dropname": "KINGSHILL",
    "dropdeladd": "2 EST LA REINE",
    "dropdelcty": "KINGSHILL",
    "dropdelst": "VI",
    "dropdelzpp": "008509998",
    "dropphyadd": "2 EST LA REINE",
    "dropphycty": "KINGSHILL",
    "dropphyst": "VI",
    "dropphyzpp": "008509998",
    "dropmaladd": "2 EST LA REINE",
    "dropmalcty": "KINGSHILL",
    "dropmalst": "VI",
    "dropmalzpp": "008509998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407780199,
    "dropfax": 3407785979
  },
  {
    "dcode": "D",
    "dropkey": "PV18809",
    "droptype": "D",
    "dropname": "SARATOGA SPRINGS",
    "dropdeladd": "245 WASHINGTON ST",
    "dropdelcty": "SARATOGA SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 128669997,
    "dropphyadd": "245 WASHINGTON ST",
    "dropphycty": "SARATOGA SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 128669997,
    "dropmaladd": "245 WASHINGTON ST",
    "dropmalcty": "SARATOGA SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 128669997,
    "dropsitphn": 5185841545,
    "dropsitlph": 5185841545,
    "dropsitcph": 5185841545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV19878",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "495 N BRIDGE ST",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "NJ",
    "dropdelzpp": "088079998",
    "dropphyadd": "495 N BRIDGE ST",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "NJ",
    "dropphyzpp": "088079998",
    "dropmaladd": "495 N BRIDGE ST",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "NJ",
    "dropmalzpp": "088079998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9085260222,
    "dropfax": 6505774103
  },
  {
    "dcode": "D",
    "dropkey": "PV20011",
    "droptype": "D",
    "dropname": "AMSTON",
    "dropdeladd": "540 CHURCH ST",
    "dropdelcty": "AMSTON",
    "dropdelst": "CT",
    "dropdelzpp": "062319998",
    "dropphyadd": "540 CHURCH ST",
    "dropphycty": "AMSTON",
    "dropphyst": "CT",
    "dropphyzpp": "062319998",
    "dropmaladd": "540 CHURCH ST",
    "dropmalcty": "AMSTON",
    "dropmalst": "CT",
    "dropmalzpp": "062319998",
    "dropsitphn": 8602283671,
    "dropsitlph": 8602883671,
    "dropsitcph": 8602283671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20012",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "335 ROUTE 6",
    "dropdelcty": "ANDOVER",
    "dropdelst": "CT",
    "dropdelzpp": "062329998",
    "dropphyadd": "335 ROUTE 6",
    "dropphycty": "ANDOVER",
    "dropphyst": "CT",
    "dropphyzpp": "062329998",
    "dropmaladd": "335 ROUTE 6",
    "dropmalcty": "ANDOVER",
    "dropmalst": "CT",
    "dropmalzpp": "062329998",
    "dropsitphn": 8607427756,
    "dropsitlph": 8607427756,
    "dropsitcph": 8607427756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20014",
    "droptype": "D",
    "dropname": "ANSONIA",
    "dropdeladd": "237 MAIN ST",
    "dropdelcty": "ANSONIA",
    "dropdelst": "CT",
    "dropdelzpp": "064019998",
    "dropphyadd": "237 MAIN ST",
    "dropphycty": "ANSONIA",
    "dropphyst": "CT",
    "dropphyzpp": "064019998",
    "dropmaladd": "237 MAIN ST",
    "dropmalcty": "ANSONIA",
    "dropmalst": "CT",
    "dropmalzpp": "064019998",
    "dropsitphn": 2037346818,
    "dropsitlph": 2037346818,
    "dropsitcph": 2037346818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20015",
    "droptype": "D",
    "dropname": "ASHFORD",
    "dropdeladd": "141 NOTT HWY STE 5",
    "dropdelcty": "ASHFORD",
    "dropdelst": "CT",
    "dropdelzpp": "062789998",
    "dropphyadd": "141 NOTT HWY STE 5",
    "dropphycty": "ASHFORD",
    "dropphyst": "CT",
    "dropphyzpp": "062789998",
    "dropmaladd": "141 NOTT HWY STE 5",
    "dropmalcty": "ASHFORD",
    "dropmalst": "CT",
    "dropmalzpp": "062789998",
    "dropsitphn": 8604298804,
    "dropsitlph": 8604298804,
    "dropsitcph": 8604298804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20019",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "15 ENFORD ST",
    "dropdelcty": "AVON",
    "dropdelst": "CT",
    "dropdelzpp": "060019998",
    "dropphyadd": "15 ENFORD ST",
    "dropphycty": "AVON",
    "dropphyst": "CT",
    "dropphyzpp": "060019998",
    "dropmaladd": "15 ENFORD ST",
    "dropmalcty": "AVON",
    "dropmalst": "CT",
    "dropmalzpp": "060019998",
    "dropsitphn": 8606780525,
    "dropsitlph": 8606780525,
    "dropsitcph": 8606780525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20022",
    "droptype": "D",
    "dropname": "BALLOUVILLE",
    "dropdeladd": "252 BALLOUVILLE RD",
    "dropdelcty": "BALLOUVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "062339997",
    "dropphyadd": "252 BALLOUVILLE RD",
    "dropphycty": "BALLOUVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "062339997",
    "dropmaladd": "252 BALLOUVILLE RD",
    "dropmalcty": "BALLOUVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "062339997",
    "dropsitphn": 8607748451,
    "dropsitlph": 8607748451,
    "dropsitcph": 8607748451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20025",
    "droptype": "D",
    "dropname": "BALTIC",
    "dropdeladd": "2 MAIN ST",
    "dropdelcty": "BALTIC",
    "dropdelst": "CT",
    "dropdelzpp": "063309998",
    "dropphyadd": "2 MAIN ST",
    "dropphycty": "BALTIC",
    "dropphyst": "CT",
    "dropphyzpp": "063309998",
    "dropmaladd": "2 MAIN ST",
    "dropmalcty": "BALTIC",
    "dropmalst": "CT",
    "dropmalzpp": "063309998",
    "dropsitphn": 8608226901,
    "dropsitlph": 8608226901,
    "dropsitcph": 8608226901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20026",
    "droptype": "D",
    "dropname": "BANTAM",
    "dropdeladd": "80 DOYLE RD",
    "dropdelcty": "BANTAM",
    "dropdelst": "CT",
    "dropdelzpp": "067509998",
    "dropphyadd": "80 DOYLE RD",
    "dropphycty": "BANTAM",
    "dropphyst": "CT",
    "dropphyzpp": "067509998",
    "dropmaladd": "80 DOYLE RD",
    "dropmalcty": "BANTAM",
    "dropmalst": "CT",
    "dropmalzpp": "067509998",
    "dropsitphn": 8605678505,
    "dropsitlph": 8605678505,
    "dropsitcph": 8605678505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20035",
    "droptype": "D",
    "dropname": "BEACON FALLS",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "BEACON FALLS",
    "dropdelst": "CT",
    "dropdelzpp": "064039998",
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "BEACON FALLS",
    "dropphyst": "CT",
    "dropphyzpp": "064039998",
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "BEACON FALLS",
    "dropmalst": "CT",
    "dropmalzpp": "064039998",
    "dropsitphn": 2037292341,
    "dropsitlph": 2037292341,
    "dropsitcph": 2037292341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20044",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "10 LIBRARY PL",
    "dropdelcty": "BETHEL",
    "dropdelst": "CT",
    "dropdelzpp": "068019998",
    "dropphyadd": "10 LIBRARY PL",
    "dropphycty": "BETHEL",
    "dropphyst": "CT",
    "dropphyzpp": "068019998",
    "dropmaladd": "10 LIBRARY PL",
    "dropmalcty": "BETHEL",
    "dropmalst": "CT",
    "dropmalzpp": "068019998",
    "dropsitphn": 2037484741,
    "dropsitlph": 2037484741,
    "dropsitcph": 2037484741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20045",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "34 EAST ST",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "CT",
    "dropdelzpp": "067519998",
    "dropphyadd": "34 EAST ST",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "CT",
    "dropphyzpp": "067519998",
    "dropmaladd": "34 EAST ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "CT",
    "dropmalzpp": "067519998",
    "dropsitphn": 2032667910,
    "dropsitlph": 2032667910,
    "dropsitcph": 2032667910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20052",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "40 JEROME AVE",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "060029998",
    "dropphyadd": "40 JEROME AVE",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "060029998",
    "dropmaladd": "40 JEROME AVE",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "060029998",
    "dropsitphn": 8602420727,
    "dropsitlph": 8602420727,
    "dropsitcph": 8602420727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20060",
    "droptype": "D",
    "dropname": "BOTSFORD",
    "dropdeladd": "1 BOTSFORD HILL RD",
    "dropdelcty": "BOTSFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064049991",
    "dropphyadd": "1 BOTSFORD HILL RD",
    "dropphycty": "BOTSFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064049991",
    "dropmaladd": "1 BOTSFORD HILL RD",
    "dropmalcty": "BOTSFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064049991",
    "dropsitphn": 2034264465,
    "dropsitlph": 2034264465,
    "dropsitcph": 2034264465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20061",
    "droptype": "D",
    "dropname": "BOZRAH",
    "dropdeladd": "181 FITCHVILLE RD",
    "dropdelcty": "BOZRAH",
    "dropdelst": "CT",
    "dropdelzpp": "063349998",
    "dropphyadd": "181 FITCHVILLE RD",
    "dropphycty": "BOZRAH",
    "dropphyst": "CT",
    "dropphyzpp": "063349998",
    "dropmaladd": "181 FITCHVILLE RD",
    "dropmalcty": "BOZRAH",
    "dropmalst": "CT",
    "dropmalzpp": "063349998",
    "dropsitphn": 8608874831,
    "dropsitlph": 8608874831,
    "dropsitcph": 8608874831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20063",
    "droptype": "D",
    "dropname": "BRANFORD",
    "dropdeladd": "35 PARK PL",
    "dropdelcty": "BRANFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064059998",
    "dropphyadd": "35 PARK PL",
    "dropphycty": "BRANFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064059998",
    "dropmaladd": "35 PARK PL",
    "dropmalcty": "BRANFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064059998",
    "dropsitphn": 2034880663,
    "dropsitlph": 2034880663,
    "dropsitcph": 2034880663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20069",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "120 MIDDLE ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066029998",
    "dropphyadd": "120 MIDDLE ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066029998",
    "dropmaladd": "120 MIDDLE ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066029998",
    "dropsitphn": 2033325302,
    "dropsitlph": 2033325302,
    "dropsitcph": 2033325307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20072",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "19 MAIN ST S",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "CT",
    "dropdelzpp": "067529998",
    "dropphyadd": "19 MAIN ST S",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "CT",
    "dropphyzpp": "067529998",
    "dropmaladd": "19 MAIN ST S",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "CT",
    "dropmalzpp": "067529998",
    "dropsitphn": 8603543383,
    "dropsitlph": 8603543383,
    "dropsitcph": 8603543383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20074",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "151 N MAIN ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "CT",
    "dropdelzpp": "060109998",
    "dropphyadd": "151 N MAIN ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "CT",
    "dropphyzpp": "060109998",
    "dropmaladd": "151 N MAIN ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "CT",
    "dropmalzpp": "060109998",
    "dropsitphn": 8605831371,
    "dropsitlph": 8605831371,
    "dropsitcph": 8605831371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20080",
    "droptype": "D",
    "dropname": "BROAD BROOK",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "BROAD BROOK",
    "dropdelst": "CT",
    "dropdelzpp": "060169998",
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "BROAD BROOK",
    "dropphyst": "CT",
    "dropphyzpp": "060169998",
    "dropmaladd": "113 MAIN ST",
    "dropmalcty": "BROAD BROOK",
    "dropmalst": "CT",
    "dropmalzpp": "060169998",
    "dropsitphn": 8606230249,
    "dropsitlph": 8606230249,
    "dropsitcph": 8606230249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20081",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "115 POCONO RD",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068049998",
    "dropphyadd": "115 POCONO RD",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068049998",
    "dropmaladd": "115 POCONO RD",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068049998",
    "dropsitphn": 2037752717,
    "dropsitlph": 2037752717,
    "dropsitcph": 2037752717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20085",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "29 CANTERBURY RD",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "CT",
    "dropdelzpp": "062349998",
    "dropphyadd": "29 CANTERBURY RD",
    "dropphycty": "BROOKLYN",
    "dropphyst": "CT",
    "dropphyzpp": "062349998",
    "dropmaladd": "29 CANTERBURY RD",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "CT",
    "dropmalzpp": "062349998",
    "dropsitphn": 8607744449,
    "dropsitlph": 8607744449,
    "dropsitcph": 8607744449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20097",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "9 CHURCH ST",
    "dropdelcty": "CANAAN",
    "dropdelst": "CT",
    "dropdelzpp": "060189992",
    "dropphyadd": "9 CHURCH ST",
    "dropphycty": "CANAAN",
    "dropphyst": "CT",
    "dropphyzpp": "060189992",
    "dropmaladd": "9 CHURCH ST",
    "dropmalcty": "CANAAN",
    "dropmalst": "CT",
    "dropmalzpp": "060189992",
    "dropsitphn": 8608247475,
    "dropsitlph": 8608247475,
    "dropsitcph": 8608247475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20104",
    "droptype": "D",
    "dropname": "CANTERBURY",
    "dropdeladd": "168 WESTMINSTER RD",
    "dropdelcty": "CANTERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "063319992",
    "dropphyadd": "168 WESTMINSTER RD",
    "dropphycty": "CANTERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "063319992",
    "dropmaladd": "168 WESTMINSTER RD",
    "dropmalcty": "CANTERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "063319992",
    "dropsitphn": 8605467100,
    "dropsitlph": 8605467100,
    "dropsitcph": 8605467100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20105",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "220 ALBANY TPKE",
    "dropdelcty": "CANTON",
    "dropdelst": "CT",
    "dropdelzpp": "060199998",
    "dropphyadd": "220 ALBANY TPKE",
    "dropphycty": "CANTON",
    "dropphyst": "CT",
    "dropphyzpp": "060199998",
    "dropmaladd": "220 ALBANY TPKE",
    "dropmalcty": "CANTON",
    "dropmalst": "CT",
    "dropmalzpp": "060199998",
    "dropsitphn": 8606934430,
    "dropsitlph": 8606934430,
    "dropsitcph": 8606934430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20106",
    "droptype": "D",
    "dropname": "CANTON CENTER",
    "dropdeladd": "178 CHERRY BROOK RD",
    "dropdelcty": "CANTON CENTER",
    "dropdelst": "CT",
    "dropdelzpp": "060209997",
    "dropphyadd": "178 CHERRY BROOK RD",
    "dropphycty": "CANTON CENTER",
    "dropphyst": "CT",
    "dropphyzpp": "060209997",
    "dropmaladd": "178 CHERRY BROOK RD",
    "dropmalcty": "CANTON CENTER",
    "dropmalst": "CT",
    "dropmalzpp": "060209997",
    "dropsitphn": 8606938826,
    "dropsitlph": 8606938826,
    "dropsitcph": 8606938826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20109",
    "droptype": "D",
    "dropname": "CENTERBROOK",
    "dropdeladd": "4 WESTBROOK RD",
    "dropdelcty": "CENTERBROOK",
    "dropdelst": "CT",
    "dropdelzpp": "064099998",
    "dropphyadd": "4 WESTBROOK RD",
    "dropphycty": "CENTERBROOK",
    "dropphyst": "CT",
    "dropphyzpp": "064099998",
    "dropmaladd": "4 WESTBROOK RD",
    "dropmalcty": "CENTERBROOK",
    "dropmalst": "CT",
    "dropmalzpp": "064099998",
    "dropsitphn": 8607678730,
    "dropsitlph": 8607678730,
    "dropsitcph": 8607678730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20114",
    "droptype": "D",
    "dropname": "CENTRAL VILLAGE",
    "dropdeladd": "29 SCHOOL ST",
    "dropdelcty": "CENTRAL VILLAGE",
    "dropdelst": "CT",
    "dropdelzpp": "063329992",
    "dropphyadd": "29 SCHOOL ST",
    "dropphycty": "CENTRAL VILLAGE",
    "dropphyst": "CT",
    "dropphyzpp": "063329992",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL VILLAGE",
    "dropmalst": "CT",
    "dropmalzpp": "063329998",
    "dropsitphn": 8605647132,
    "dropsitlph": 8605647132,
    "dropsitcph": 8605647132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20117",
    "droptype": "D",
    "dropname": "CHAPLIN",
    "dropdeladd": "181 WILLIMANTIC RD",
    "dropdelcty": "CHAPLIN",
    "dropdelst": "CT",
    "dropdelzpp": "062359998",
    "dropphyadd": "181 WILLIMANTIC RD",
    "dropphycty": "CHAPLIN",
    "dropphyst": "CT",
    "dropphyzpp": "062359998",
    "dropmaladd": "181 WILLIMANTIC RD",
    "dropmalcty": "CHAPLIN",
    "dropmalst": "CT",
    "dropmalzpp": "062359998",
    "dropsitphn": 8604550442,
    "dropsitlph": 8604550442,
    "dropsitcph": 8604550442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20119",
    "droptype": "D",
    "dropname": "CHESHIRE",
    "dropdeladd": "210 MAPLE AVE",
    "dropdelcty": "CHESHIRE",
    "dropdelst": "CT",
    "dropdelzpp": "064109998",
    "dropphyadd": "210 MAPLE AVE",
    "dropphycty": "CHESHIRE",
    "dropphyst": "CT",
    "dropphyzpp": "064109998",
    "dropmaladd": "210 MAPLE AVE",
    "dropmalcty": "CHESHIRE",
    "dropmalst": "CT",
    "dropmalzpp": "064109998",
    "dropsitphn": 2032723593,
    "dropsitlph": 2032723593,
    "dropsitcph": 2032723593,
    "dropfax": 2032501932
  },
  {
    "dcode": "D",
    "dropkey": "PV20120",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "CT",
    "dropdelzpp": "064129998",
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "CHESTER",
    "dropphyst": "CT",
    "dropphyzpp": "064129998",
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "CT",
    "dropmalzpp": "064129998",
    "dropsitphn": 8605262780,
    "dropsitlph": 8605262780,
    "dropsitcph": 8605262780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20124",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "CT",
    "dropdelzpp": "064139998",
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "CLINTON",
    "dropphyst": "CT",
    "dropphyzpp": "064139998",
    "dropmaladd": "2 W MAIN ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "CT",
    "dropmalzpp": "064139998",
    "dropsitphn": 8606694155,
    "dropsitlph": 8606694155,
    "dropsitcph": 8606694155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20125",
    "droptype": "D",
    "dropname": "COBALT",
    "dropdeladd": "371 W HIGH ST",
    "dropdelcty": "COBALT",
    "dropdelst": "CT",
    "dropdelzpp": "064149800",
    "dropphyadd": "371 W HIGH ST",
    "dropphycty": "COBALT",
    "dropphyst": "CT",
    "dropphyzpp": "064149800",
    "dropmaladd": "371 W HIGH ST",
    "dropmalcty": "COBALT",
    "dropmalst": "CT",
    "dropmalzpp": "064149800",
    "dropsitphn": 8602675605,
    "dropsitlph": 8602675605,
    "dropsitcph": 8602675605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20127",
    "droptype": "D",
    "dropname": "COLCHESTER",
    "dropdeladd": "103 S MAIN ST STE 3",
    "dropdelcty": "COLCHESTER",
    "dropdelst": "CT",
    "dropdelzpp": "064159998",
    "dropphyadd": "103 S MAIN ST STE 3",
    "dropphycty": "COLCHESTER",
    "dropphyst": "CT",
    "dropphyzpp": "064159998",
    "dropmaladd": "103 S MAIN ST STE 3",
    "dropmalcty": "COLCHESTER",
    "dropmalst": "CT",
    "dropmalzpp": "064159998",
    "dropsitphn": 8605375695,
    "dropsitlph": 8605375695,
    "dropsitcph": 8605375695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20128",
    "droptype": "D",
    "dropname": "COLEBROOK",
    "dropdeladd": "560 COLEBROOK RD",
    "dropdelcty": "COLEBROOK",
    "dropdelst": "CT",
    "dropdelzpp": "060219998",
    "dropphyadd": "560 COLEBROOK RD",
    "dropphycty": "COLEBROOK",
    "dropphyst": "CT",
    "dropphyzpp": "060219998",
    "dropmaladd": "560 COLEBROOK RD",
    "dropmalcty": "COLEBROOK",
    "dropmalst": "CT",
    "dropmalzpp": "060219998",
    "dropsitphn": 8603792834,
    "dropsitlph": 8603792834,
    "dropsitcph": 8603792834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20129",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "34 BRIDGE ST",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060229992",
    "dropphyadd": "34 BRIDGE ST",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060229992",
    "dropmaladd": "34 BRIDGE ST",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060229992",
    "dropsitphn": 8606938564,
    "dropsitlph": 8606938564,
    "dropsitcph": 8606938564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20132",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "172 ROUTE 66",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "CT",
    "dropdelzpp": "062379998",
    "dropphyadd": "172 ROUTE 66",
    "dropphycty": "COLUMBIA",
    "dropphyst": "CT",
    "dropphyzpp": "062379998",
    "dropmaladd": "172 ROUTE 66",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "CT",
    "dropmalzpp": "062379998",
    "dropsitphn": 8602283257,
    "dropsitlph": 8602283257,
    "dropsitcph": 8602283257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20140",
    "droptype": "D",
    "dropname": "CORNWALL",
    "dropdeladd": "36 BOLTON HILL RD",
    "dropdelcty": "CORNWALL",
    "dropdelst": "CT",
    "dropdelzpp": "067539800",
    "dropphyadd": "36 BOLTON HILL RD",
    "dropphycty": "CORNWALL",
    "dropphyst": "CT",
    "dropphyzpp": "067539800",
    "dropmaladd": "36 BOLTON HILL RD",
    "dropmalcty": "CORNWALL",
    "dropmalst": "CT",
    "dropmalzpp": "067539800",
    "dropsitphn": 8606726091,
    "dropsitlph": 8606726091,
    "dropsitcph": 8606726091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20143",
    "droptype": "D",
    "dropname": "CORNWALL BRIDGE",
    "dropdeladd": "18A KENT RD S",
    "dropdelcty": "CORNWALL BRIDGE",
    "dropdelst": "CT",
    "dropdelzpp": "067549997",
    "dropphyadd": "18A KENT RD S",
    "dropphycty": "CORNWALL BRIDGE",
    "dropphyst": "CT",
    "dropphyzpp": "067549997",
    "dropmaladd": "18A KENT RD S",
    "dropmalcty": "CORNWALL BRIDGE",
    "dropmalst": "CT",
    "dropmalzpp": "067549997",
    "dropsitphn": 8606726710,
    "dropsitlph": 8606726710,
    "dropsitcph": 8606726710,
    "dropfax": 8606726037
  },
  {
    "dcode": "D",
    "dropkey": "PV20144",
    "droptype": "D",
    "dropname": "COS COB",
    "dropdeladd": "152 E PUTNAM AVE",
    "dropdelcty": "COS COB",
    "dropdelst": "CT",
    "dropdelzpp": "068079984",
    "dropphyadd": "152 E PUTNAM AVE",
    "dropphycty": "COS COB",
    "dropphyst": "CT",
    "dropphyzpp": "068079984",
    "dropmaladd": "152 E PUTNAM AVE",
    "dropmalcty": "COS COB",
    "dropmalst": "CT",
    "dropmalzpp": "068079984",
    "dropsitphn": 2038691470,
    "dropsitlph": 2038691470,
    "dropsitcph": 2038691470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20145",
    "droptype": "D",
    "dropname": "COVENTRY",
    "dropdeladd": "1376 MAIN ST",
    "dropdelcty": "COVENTRY",
    "dropdelst": "CT",
    "dropdelzpp": "062389998",
    "dropphyadd": "1376 MAIN ST",
    "dropphycty": "COVENTRY",
    "dropphyst": "CT",
    "dropphyzpp": "062389998",
    "dropmaladd": "1376 MAIN ST",
    "dropmalcty": "COVENTRY",
    "dropmalst": "CT",
    "dropmalzpp": "062389998",
    "dropsitphn": 8607427272,
    "dropsitlph": 8607427272,
    "dropsitcph": 8607427272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20146",
    "droptype": "D",
    "dropname": "CROMWELL",
    "dropdeladd": "528 MAIN ST",
    "dropdelcty": "CROMWELL",
    "dropdelst": "CT",
    "dropdelzpp": "064169998",
    "dropphyadd": "528 MAIN ST",
    "dropphycty": "CROMWELL",
    "dropphyst": "CT",
    "dropphyzpp": "064169998",
    "dropmaladd": "528 MAIN ST",
    "dropmalcty": "CROMWELL",
    "dropmalst": "CT",
    "dropmalzpp": "064169998",
    "dropsitphn": 8606355611,
    "dropsitlph": 8606355611,
    "dropsitcph": 8606355611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20151",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "23 BACKUS AVE",
    "dropdelcty": "DANBURY",
    "dropdelst": "CT",
    "dropdelzpp": "068109998",
    "dropphyadd": "23 BACKUS AVE",
    "dropphycty": "DANBURY",
    "dropphyst": "CT",
    "dropphyzpp": "068109998",
    "dropmaladd": "23 BACKUS AVE",
    "dropmalcty": "DANBURY",
    "dropmalst": "CT",
    "dropmalzpp": "068109998",
    "dropsitphn": 2037961942,
    "dropsitlph": 2037961942,
    "dropsitcph": 2037961945,
    "dropfax": 2037961924
  },
  {
    "dcode": "D",
    "dropkey": "PV20152",
    "droptype": "D",
    "dropname": "DANIELSON",
    "dropdeladd": "70 WATER ST",
    "dropdelcty": "DANIELSON",
    "dropdelst": "CT",
    "dropdelzpp": "062399998",
    "dropphyadd": "70 WATER ST",
    "dropphycty": "DANIELSON",
    "dropphyst": "CT",
    "dropphyzpp": "062399998",
    "dropmaladd": "70 WATER ST",
    "dropmalcty": "DANIELSON",
    "dropmalst": "CT",
    "dropmalzpp": "062399998",
    "dropsitphn": 8607795066,
    "dropsitlph": 8607795066,
    "dropsitcph": 8607795066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20153",
    "droptype": "D",
    "dropname": "DARIEN",
    "dropdeladd": "25 OLD KINGS HWY N STE 18",
    "dropdelcty": "DARIEN",
    "dropdelst": "CT",
    "dropdelzpp": "068209998",
    "dropphyadd": "25 OLD KINGS HWY N STE 18",
    "dropphycty": "DARIEN",
    "dropphyst": "CT",
    "dropphyzpp": "068209998",
    "dropmaladd": "25 OLD KINGS HWY N STE 18",
    "dropmalcty": "DARIEN",
    "dropmalst": "CT",
    "dropmalzpp": "068209998",
    "dropsitphn": 2036552595,
    "dropsitlph": 2036552595,
    "dropsitcph": 2036552595,
    "dropfax": 2036550863
  },
  {
    "dcode": "D",
    "dropkey": "PV20154",
    "droptype": "D",
    "dropname": "DAYVILLE",
    "dropdeladd": "988 N MAIN ST",
    "dropdelcty": "DAYVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "062419998",
    "dropphyadd": "988 N MAIN ST",
    "dropphycty": "DAYVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "062419998",
    "dropmaladd": "988 N MAIN ST",
    "dropmalcty": "DAYVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "062419998",
    "dropsitphn": 8607744131,
    "dropsitlph": 8607744131,
    "dropsitcph": 8607744131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20158",
    "droptype": "D",
    "dropname": "DEEP RIVER",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "DEEP RIVER",
    "dropdelst": "CT",
    "dropdelzpp": "064179998",
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "DEEP RIVER",
    "dropphyst": "CT",
    "dropphyzpp": "064179998",
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "DEEP RIVER",
    "dropmalst": "CT",
    "dropmalzpp": "064179998",
    "dropsitphn": 8605265970,
    "dropsitlph": 8605265970,
    "dropsitcph": 8605265970,
    "dropfax": 8605262049
  },
  {
    "dcode": "D",
    "dropkey": "PV20159",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "74 OLIVIA ST",
    "dropdelcty": "DERBY",
    "dropdelst": "CT",
    "dropdelzpp": "064189998",
    "dropphyadd": "74 OLIVIA ST",
    "dropphycty": "DERBY",
    "dropphyst": "CT",
    "dropphyzpp": "064189998",
    "dropmaladd": "74 OLIVIA ST",
    "dropmalcty": "DERBY",
    "dropmalst": "CT",
    "dropmalzpp": "064189998",
    "dropsitphn": 2037340735,
    "dropsitlph": 2037340735,
    "dropsitcph": 2037340735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20162",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "103 MAIN ST",
    "dropdelcty": "DURHAM",
    "dropdelst": "CT",
    "dropdelzpp": "064229998",
    "dropphyadd": "103 MAIN ST",
    "dropphycty": "DURHAM",
    "dropphyst": "CT",
    "dropphyzpp": "064229998",
    "dropmaladd": "103 MAIN ST",
    "dropmalcty": "DURHAM",
    "dropmalst": "CT",
    "dropmalzpp": "064229998",
    "dropsitphn": 8603493350,
    "dropsitlph": 8603493350,
    "dropsitcph": 8603493350,
    "dropfax": 8603492010
  },
  {
    "dcode": "D",
    "dropkey": "PV20182",
    "droptype": "D",
    "dropname": "EAST BERLIN",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "EAST BERLIN",
    "dropdelst": "CT",
    "dropdelzpp": "060239992",
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "EAST BERLIN",
    "dropphyst": "CT",
    "dropphyzpp": "060239992",
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "EAST BERLIN",
    "dropmalst": "CT",
    "dropmalzpp": "060239992",
    "dropsitphn": 8608283618,
    "dropsitlph": 8608283618,
    "dropsitcph": 8608283618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20184",
    "droptype": "D",
    "dropname": "EAST CANAAN",
    "dropdeladd": "270 E CANAAN RD",
    "dropdelcty": "EAST CANAAN",
    "dropdelst": "CT",
    "dropdelzpp": "060249998",
    "dropphyadd": "270 E CANAAN RD",
    "dropphycty": "EAST CANAAN",
    "dropphyst": "CT",
    "dropphyzpp": "060249998",
    "dropmaladd": "270 E CANAAN RD",
    "dropmalcty": "EAST CANAAN",
    "dropmalst": "CT",
    "dropmalzpp": "060249998",
    "dropsitphn": 8608240427,
    "dropsitlph": 8608240427,
    "dropsitcph": 8608240427,
    "dropfax": 8608240427
  },
  {
    "dcode": "D",
    "dropkey": "PV20187",
    "droptype": "D",
    "dropname": "EAST GLASTONBURY",
    "dropdeladd": "538 MANCHESTER RD",
    "dropdelcty": "EAST GLASTONBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060259992",
    "dropphyadd": "538 MANCHESTER RD",
    "dropphycty": "EAST GLASTONBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060259992",
    "dropmaladd": "538 MANCHESTER RD",
    "dropmalcty": "EAST GLASTONBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060259992",
    "dropsitphn": 8606524033,
    "dropsitlph": 8606524033,
    "dropsitcph": 8606524033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20188",
    "droptype": "D",
    "dropname": "EAST GRANBY",
    "dropdeladd": "1 CENTER ST",
    "dropdelcty": "EAST GRANBY",
    "dropdelst": "CT",
    "dropdelzpp": "060269998",
    "dropphyadd": "1 CENTER ST",
    "dropphycty": "EAST GRANBY",
    "dropphyst": "CT",
    "dropphyzpp": "060269998",
    "dropmaladd": "1 CENTER ST",
    "dropmalcty": "EAST GRANBY",
    "dropmalst": "CT",
    "dropmalzpp": "060269998",
    "dropsitphn": 8606536466,
    "dropsitlph": 8606536466,
    "dropsitcph": 8606536466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20189",
    "droptype": "D",
    "dropname": "EAST HADDAM",
    "dropdeladd": "34 MAIN ST",
    "dropdelcty": "EAST HADDAM",
    "dropdelst": "CT",
    "dropdelzpp": "064239998",
    "dropphyadd": "34 MAIN ST",
    "dropphycty": "EAST HADDAM",
    "dropphyst": "CT",
    "dropphyzpp": "064239998",
    "dropmaladd": "34 MAIN ST",
    "dropmalcty": "EAST HADDAM",
    "dropmalst": "CT",
    "dropmalzpp": "064239998",
    "dropsitphn": 8608738521,
    "dropsitlph": 8608738521,
    "dropsitcph": 8608738521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20190",
    "droptype": "D",
    "dropname": "EAST HAMPTON",
    "dropdeladd": "57 MAIN ST",
    "dropdelcty": "EAST HAMPTON",
    "dropdelst": "CT",
    "dropdelzpp": "064249998",
    "dropphyadd": "57 MAIN ST",
    "dropphycty": "EAST HAMPTON",
    "dropphyst": "CT",
    "dropphyzpp": "064249998",
    "dropmaladd": "57 MAIN ST",
    "dropmalcty": "EAST HAMPTON",
    "dropmalst": "CT",
    "dropmalzpp": "064249998",
    "dropsitphn": 8602672094,
    "dropsitlph": 8602672094,
    "dropsitcph": 8602672094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20192",
    "droptype": "D",
    "dropname": "EAST HARTLAND",
    "dropdeladd": "23 SOUTH RD",
    "dropdelcty": "EAST HARTLAND",
    "dropdelst": "CT",
    "dropdelzpp": "060279998",
    "dropphyadd": "23 SOUTH RD",
    "dropphycty": "EAST HARTLAND",
    "dropphyst": "CT",
    "dropphyzpp": "060279998",
    "dropmaladd": "23 SOUTH RD",
    "dropmalcty": "EAST HARTLAND",
    "dropmalst": "CT",
    "dropmalzpp": "060279998",
    "dropsitphn": 8606536423,
    "dropsitlph": 8606536423,
    "dropsitcph": 8606536423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20195",
    "droptype": "D",
    "dropname": "EAST KILLINGLY",
    "dropdeladd": "1289 HARTFORD PIKE",
    "dropdelcty": "EAST KILLINGLY",
    "dropdelst": "CT",
    "dropdelzpp": "062439998",
    "dropphyadd": "1289 HARTFORD PIKE",
    "dropphycty": "EAST KILLINGLY",
    "dropphyst": "CT",
    "dropphyzpp": "062439998",
    "dropmaladd": "1289 HARTFORD PIKE",
    "dropmalcty": "EAST KILLINGLY",
    "dropmalst": "CT",
    "dropmalzpp": "062439998",
    "dropsitphn": 8607748285,
    "dropsitlph": 8607748285,
    "dropsitcph": 8607748285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20196",
    "droptype": "D",
    "dropname": "EAST LYME",
    "dropdeladd": "225 BOSTON POST RD",
    "dropdelcty": "EAST LYME",
    "dropdelst": "CT",
    "dropdelzpp": "063339992",
    "dropphyadd": "225 BOSTON POST RD",
    "dropphycty": "EAST LYME",
    "dropphyst": "CT",
    "dropphyzpp": "063339992",
    "dropmaladd": "225 BOSTON POST RD",
    "dropmalcty": "EAST LYME",
    "dropmalst": "CT",
    "dropmalzpp": "063339992",
    "dropsitphn": 8607392095,
    "dropsitlph": 8607392095,
    "dropsitcph": 8607392095,
    "dropfax": 8607396129
  },
  {
    "dcode": "D",
    "dropkey": "PV20203",
    "droptype": "D",
    "dropname": "EAST WINDSOR",
    "dropdeladd": "78 BRIDGE ST",
    "dropdelcty": "EAST WINDSOR",
    "dropdelst": "CT",
    "dropdelzpp": "060889998",
    "dropphyadd": "78 BRIDGE ST",
    "dropphycty": "EAST WINDSOR",
    "dropphyst": "CT",
    "dropphyzpp": "060889998",
    "dropmaladd": "78 BRIDGE ST",
    "dropmalcty": "EAST WINDSOR",
    "dropmalst": "CT",
    "dropmalzpp": "060889998",
    "dropsitphn": 8606237374,
    "dropsitlph": 8606237374,
    "dropsitcph": 8606237374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20204",
    "droptype": "D",
    "dropname": "EAST WINDSOR HILL",
    "dropdeladd": "1865 MAIN ST",
    "dropdelcty": "EAST WINDSOR HILL",
    "dropdelst": "CT",
    "dropdelzpp": "060289992",
    "dropphyadd": "1865 MAIN ST",
    "dropphycty": "EAST WINDSOR HILL",
    "dropphyst": "CT",
    "dropphyzpp": "060289992",
    "dropmaladd": "1865 MAIN ST",
    "dropmalcty": "EAST WINDSOR HILL",
    "dropmalst": "CT",
    "dropmalzpp": "060289992",
    "dropsitphn": 8602890044,
    "dropsitlph": 8602890044,
    "dropsitcph": 8602890044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20205",
    "droptype": "D",
    "dropname": "EAST WOODSTOCK",
    "dropdeladd": "217 WOODSTOCK RD",
    "dropdelcty": "EAST WOODSTOCK",
    "dropdelst": "CT",
    "dropdelzpp": "062449997",
    "dropphyadd": "217 WOODSTOCK RD",
    "dropphycty": "EAST WOODSTOCK",
    "dropphyst": "CT",
    "dropphyzpp": "062449997",
    "dropmaladd": "217 WOODSTOCK RD",
    "dropmalcty": "EAST WOODSTOCK",
    "dropmalst": "CT",
    "dropmalzpp": "062449997",
    "dropsitphn": 8609283176,
    "dropsitlph": 8609283176,
    "dropsitcph": 8609283176,
    "dropfax": 8609634939
  },
  {
    "dcode": "D",
    "dropkey": "PV20206",
    "droptype": "D",
    "dropname": "EASTFORD",
    "dropdeladd": "6 COUNTY RD",
    "dropdelcty": "EASTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "062429998",
    "dropphyadd": "6 COUNTY RD",
    "dropphycty": "EASTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "062429998",
    "dropmaladd": "6 COUNTY RD",
    "dropmalcty": "EASTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "062429998",
    "dropsitphn": 8609740078,
    "dropsitlph": 8609740078,
    "dropsitcph": 8609740078,
    "dropfax": 8603158039
  },
  {
    "dcode": "D",
    "dropkey": "PV20208",
    "droptype": "D",
    "dropname": "ELLINGTON",
    "dropdeladd": "2 CHURCH ST",
    "dropdelcty": "ELLINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "060299992",
    "dropphyadd": "2 CHURCH ST",
    "dropphycty": "ELLINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "060299992",
    "dropmaladd": "2 CHURCH ST",
    "dropmalcty": "ELLINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "060299992",
    "dropsitphn": 8608756391,
    "dropsitlph": 8608756391,
    "dropsitcph": 8608756391,
    "dropfax": 8608704772
  },
  {
    "dcode": "D",
    "dropkey": "PV20212",
    "droptype": "D",
    "dropname": "ENFIELD",
    "dropdeladd": "31 PALOMBA DR",
    "dropdelcty": "ENFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "060829998",
    "dropphyadd": "31 PALOMBA DR",
    "dropphycty": "ENFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "060829998",
    "dropmaladd": "31 PALOMBA DR",
    "dropmalcty": "ENFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "060829998",
    "dropsitphn": 8607452475,
    "dropsitlph": 8607452475,
    "dropsitcph": 8607452475,
    "dropfax": 8607410392
  },
  {
    "dcode": "D",
    "dropkey": "PV20215",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "12 MAIN ST STE 5",
    "dropdelcty": "ESSEX",
    "dropdelst": "CT",
    "dropdelzpp": "064269998",
    "dropphyadd": "12 MAIN ST STE 5",
    "dropphycty": "ESSEX",
    "dropphyst": "CT",
    "dropphyzpp": "064269998",
    "dropmaladd": "12 MAIN ST STE 5",
    "dropmalcty": "ESSEX",
    "dropmalst": "CT",
    "dropmalzpp": "064269998",
    "dropsitphn": 8607678476,
    "dropsitlph": 8607678476,
    "dropsitcph": 8607678476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20217",
    "droptype": "D",
    "dropname": "FABYAN",
    "dropdeladd": "831 RIVERSIDE DR",
    "dropdelcty": "NORTH GROSVENORDALE",
    "dropdelst": "CT",
    "dropdelzpp": "062559992",
    "dropphyadd": "831 RIVERSIDE DR",
    "dropphycty": "NORTH GROSVENORDALE",
    "dropphyst": "CT",
    "dropphyzpp": "062559992",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FABYAN",
    "dropmalst": "CT",
    "dropmalzpp": "062459998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8609239192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20221",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "1300 POST RD STE 5",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068249998",
    "dropphyadd": "1300 POST RD STE 5",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068249998",
    "dropmaladd": "1300 POST RD STE 5",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068249998",
    "dropsitphn": 2032548160,
    "dropsitlph": 2032548160,
    "dropsitcph": 2032548160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20223",
    "droptype": "D",
    "dropname": "FALLS VILLAGE",
    "dropdeladd": "5 MINER ST",
    "dropdelcty": "FALLS VILLAGE",
    "dropdelst": "CT",
    "dropdelzpp": "060319998",
    "dropphyadd": "5 MINER ST",
    "dropphycty": "FALLS VILLAGE",
    "dropphyst": "CT",
    "dropphyzpp": "060319998",
    "dropmaladd": "5 MINER ST",
    "dropmalcty": "FALLS VILLAGE",
    "dropmalst": "CT",
    "dropmalzpp": "060319998",
    "dropsitphn": 8608247781,
    "dropsitlph": 8608247781,
    "dropsitcph": 8608247781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20226",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "060329998",
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "060329998",
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "060329998",
    "dropsitphn": 8606797768,
    "dropsitlph": 8606797768,
    "dropsitcph": 8606797768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20241",
    "droptype": "D",
    "dropname": "GALES FERRY",
    "dropdeladd": "12 MILITARY HWY",
    "dropdelcty": "GALES FERRY",
    "dropdelst": "CT",
    "dropdelzpp": "063351400",
    "dropphyadd": "12 MILITARY HWY",
    "dropphycty": "GALES FERRY",
    "dropphyst": "CT",
    "dropphyzpp": "063351400",
    "dropmaladd": "12 MILITARY HWY",
    "dropmalcty": "GALES FERRY",
    "dropmalst": "CT",
    "dropmalzpp": "063351400",
    "dropsitphn": 8604647681,
    "dropsitlph": 8604647681,
    "dropsitcph": 8604647681,
    "dropfax": 8604643131
  },
  {
    "dcode": "D",
    "dropkey": "PV20242",
    "droptype": "D",
    "dropname": "GAYLORDSVILLE",
    "dropdeladd": "3 GEORGE WASHINGTON PLZ UNIT 8",
    "dropdelcty": "GAYLORDSVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "067559998",
    "dropphyadd": "3 GEORGE WASHINGTON PLZ UNIT 8",
    "dropphycty": "GAYLORDSVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "067559998",
    "dropmaladd": "3 GEORGE WASHINGTON PLZ UNIT 8",
    "dropmalcty": "GAYLORDSVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "067559998",
    "dropsitphn": 8603549727,
    "dropsitlph": 8603549727,
    "dropsitcph": 8603549727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20247",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "65 REDDING RD",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "CT",
    "dropdelzpp": "068299299",
    "dropphyadd": "65 REDDING RD",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "CT",
    "dropphyzpp": "068299299",
    "dropmaladd": "65 REDDING RD",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "CT",
    "dropmalzpp": "068299299",
    "dropsitphn": 2035448643,
    "dropsitlph": 2033262204,
    "dropsitcph": 2035448643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20249",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "26 GILMAN RD",
    "dropdelcty": "GILMAN",
    "dropdelst": "CT",
    "dropdelzpp": "063369992",
    "dropphyadd": "26 GILMAN RD",
    "dropphycty": "GILMAN",
    "dropphyst": "CT",
    "dropphyzpp": "063369992",
    "dropmaladd": "26 GILMAN RD",
    "dropmalcty": "GILMAN",
    "dropmalst": "CT",
    "dropmalzpp": "063369992",
    "dropsitphn": 8608895888,
    "dropsitlph": 8608895888,
    "dropsitcph": 8608895888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20251",
    "droptype": "D",
    "dropname": "GLASTONBURY",
    "dropdeladd": "145 NEW LONDON TPKE",
    "dropdelcty": "GLASTONBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060339998",
    "dropphyadd": "145 NEW LONDON TPKE",
    "dropphycty": "GLASTONBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060339998",
    "dropmaladd": "145 NEW LONDON TPKE",
    "dropmalcty": "GLASTONBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060339998",
    "dropsitphn": 8606527075,
    "dropsitlph": 8606527075,
    "dropsitcph": 8606527075,
    "dropfax": 8606594392
  },
  {
    "dcode": "D",
    "dropkey": "PV20256",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "9 SUNSET DR",
    "dropdelcty": "GOSHEN",
    "dropdelst": "CT",
    "dropdelzpp": "067569998",
    "dropphyadd": "9 SUNSET DR",
    "dropphycty": "GOSHEN",
    "dropphyst": "CT",
    "dropphyzpp": "067569998",
    "dropmaladd": "9 SUNSET DR",
    "dropmalcty": "GOSHEN",
    "dropmalst": "CT",
    "dropmalzpp": "067569998",
    "dropsitphn": 8604912733,
    "dropsitlph": 8604912733,
    "dropsitcph": 8604912733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20257",
    "droptype": "D",
    "dropname": "GRANBY",
    "dropdeladd": "10 BANK ST",
    "dropdelcty": "GRANBY",
    "dropdelst": "CT",
    "dropdelzpp": "060359998",
    "dropphyadd": "10 BANK ST",
    "dropphycty": "GRANBY",
    "dropphyst": "CT",
    "dropphyzpp": "060359998",
    "dropmaladd": "10 BANK ST",
    "dropmalcty": "GRANBY",
    "dropmalst": "CT",
    "dropmalzpp": "060359998",
    "dropsitphn": 8606532293,
    "dropsitlph": 8606532293,
    "dropsitcph": 8606532293,
    "dropfax": 8606531506
  },
  {
    "dcode": "D",
    "dropkey": "PV20260",
    "droptype": "D",
    "dropname": "GREENS FARMS",
    "dropdeladd": "4 POST OFFICE LN",
    "dropdelcty": "GREENS FARMS",
    "dropdelst": "CT",
    "dropdelzpp": "068389997",
    "dropphyadd": "4 POST OFFICE LN",
    "dropphycty": "GREENS FARMS",
    "dropphyst": "CT",
    "dropphyzpp": "068389997",
    "dropmaladd": "4 POST OFFICE LN",
    "dropmalcty": "GREENS FARMS",
    "dropmalst": "CT",
    "dropmalzpp": "068389997",
    "dropsitphn": 2032594378,
    "dropsitlph": 2032594378,
    "dropsitcph": 2032594378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20262",
    "droptype": "D",
    "dropname": "GREENWICH",
    "dropdeladd": "29 VALLEY DR",
    "dropdelcty": "GREENWICH",
    "dropdelst": "CT",
    "dropdelzpp": "068319998",
    "dropphyadd": "29 VALLEY DR",
    "dropphycty": "GREENWICH",
    "dropphyst": "CT",
    "dropphyzpp": "068319998",
    "dropmaladd": "29 VALLEY DR",
    "dropmalcty": "GREENWICH",
    "dropmalst": "CT",
    "dropmalzpp": "068319998",
    "dropsitphn": 2036253168,
    "dropsitlph": 2036253168,
    "dropsitcph": 2036253168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20267",
    "droptype": "D",
    "dropname": "GROSVENOR DALE",
    "dropdeladd": "655 RIVERSIDE DR",
    "dropdelcty": "GROSVENOR DALE",
    "dropdelst": "CT",
    "dropdelzpp": "062469997",
    "dropphyadd": "655 RIVERSIDE DR",
    "dropphycty": "GROSVENOR DALE",
    "dropphyst": "CT",
    "dropphyzpp": "062469997",
    "dropmaladd": "655 RIVERSIDE DR",
    "dropmalcty": "GROSVENOR DALE",
    "dropmalst": "CT",
    "dropmalzpp": "062469997",
    "dropsitphn": 8609239092,
    "dropsitlph": 8609239092,
    "dropsitcph": 8609239092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20271",
    "droptype": "D",
    "dropname": "GROTON",
    "dropdeladd": "100 PLAZA CT",
    "dropdelcty": "GROTON",
    "dropdelst": "CT",
    "dropdelzpp": "063409998",
    "dropphyadd": "100 PLAZA CT",
    "dropphycty": "GROTON",
    "dropphyst": "CT",
    "dropphyzpp": "063409998",
    "dropmaladd": "100 PLAZA CT",
    "dropmalcty": "GROTON",
    "dropmalst": "CT",
    "dropmalzpp": "063409998",
    "dropsitphn": 8604458154,
    "dropsitlph": 8604458154,
    "dropsitcph": 8604458154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20275",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "42 WATER ST",
    "dropdelcty": "GUILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064379994",
    "dropphyadd": "42 WATER ST",
    "dropphycty": "GUILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064379994",
    "dropmaladd": "42 WATER ST",
    "dropmalcty": "GUILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064379994",
    "dropsitphn": 2034532429,
    "dropsitlph": 2034532429,
    "dropsitcph": 2034532429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20277",
    "droptype": "D",
    "dropname": "HADDAM",
    "dropdeladd": "1050 SAYBROOK RD",
    "dropdelcty": "HADDAM",
    "dropdelst": "CT",
    "dropdelzpp": "064389998",
    "dropphyadd": "1050 SAYBROOK RD",
    "dropphycty": "HADDAM",
    "dropphyst": "CT",
    "dropphyzpp": "064389998",
    "dropmaladd": "1050 SAYBROOK RD",
    "dropmalcty": "HADDAM",
    "dropmalst": "CT",
    "dropmalzpp": "064389998",
    "dropsitphn": 8603454770,
    "dropsitlph": 8603454770,
    "dropsitcph": 8603454770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20279",
    "droptype": "D",
    "dropname": "HADLYME",
    "dropdeladd": "1 FERRY RD",
    "dropdelcty": "HADLYME",
    "dropdelst": "CT",
    "dropdelzpp": "064399992",
    "dropphyadd": "1 FERRY RD",
    "dropphycty": "HADLYME",
    "dropphyst": "CT",
    "dropphyzpp": "064399992",
    "dropmaladd": "1 FERRY RD",
    "dropmalcty": "HADLYME",
    "dropmalst": "CT",
    "dropmalzpp": "064399992",
    "dropsitphn": 8605266088,
    "dropsitlph": 8605266088,
    "dropsitcph": 8605266088,
    "dropfax": 8605262767
  },
  {
    "dcode": "D",
    "dropkey": "PV20282",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "222 MAIN ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "CT",
    "dropdelzpp": "062479998",
    "dropphyadd": "222 MAIN ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "CT",
    "dropphyzpp": "062479998",
    "dropmaladd": "222 MAIN ST",
    "dropmalcty": "HAMPTON",
    "dropmalst": "CT",
    "dropmalzpp": "062479998",
    "dropsitphn": 8604558047,
    "dropsitlph": 8604458047,
    "dropsitcph": 8604558047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20283",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "290 MAIN ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "CT",
    "dropdelzpp": "063509992",
    "dropphyadd": "290 MAIN ST",
    "dropphycty": "HANOVER",
    "dropphyst": "CT",
    "dropphyzpp": "063509992",
    "dropmaladd": "290 MAIN ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "CT",
    "dropmalzpp": "063509992",
    "dropsitphn": 8608226250,
    "dropsitlph": 8608226250,
    "dropsitcph": 8608226250,
    "dropfax": 8608223021
  },
  {
    "dcode": "D",
    "dropkey": "PV20285",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "141 WESTON ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061019998",
    "dropphyadd": "141 WESTON ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061019998",
    "dropmaladd": "141 WESTON ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061019998",
    "dropsitphn": 8605246075,
    "dropsitlph": 8605246075,
    "dropsitcph": 8605246050,
    "dropfax": 8605246006
  },
  {
    "dcode": "D",
    "dropkey": "PV20293",
    "droptype": "D",
    "dropname": "HAWLEYVILLE",
    "dropdeladd": "23 BARNABAS RD STE 5",
    "dropdelcty": "HAWLEYVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "064409992",
    "dropphyadd": "23 BARNABAS RD STE 5",
    "dropphycty": "HAWLEYVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "064409992",
    "dropmaladd": "23 BARNABAS RD STE 5",
    "dropmalcty": "HAWLEYVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "064409992",
    "dropsitphn": 2034260623,
    "dropsitlph": 2034260623,
    "dropsitcph": 2034260623,
    "dropfax": 2034260621
  },
  {
    "dcode": "D",
    "dropkey": "PV20298",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "93 MAIN ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "CT",
    "dropdelzpp": "062489998",
    "dropphyadd": "93 MAIN ST",
    "dropphycty": "HEBRON",
    "dropphyst": "CT",
    "dropphyzpp": "062489998",
    "dropmaladd": "93 MAIN ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "CT",
    "dropmalzpp": "062489998",
    "dropsitphn": 8602286904,
    "dropsitlph": 8602286904,
    "dropsitcph": 8602286904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20300",
    "droptype": "D",
    "dropname": "HIGGANUM",
    "dropdeladd": "26 KILLINGWORTH RD",
    "dropdelcty": "HIGGANUM",
    "dropdelst": "CT",
    "dropdelzpp": "064419998",
    "dropphyadd": "26 KILLINGWORTH RD",
    "dropphycty": "HIGGANUM",
    "dropphyst": "CT",
    "dropphyzpp": "064419998",
    "dropmaladd": "26 KILLINGWORTH RD",
    "dropmalcty": "HIGGANUM",
    "dropmalst": "CT",
    "dropmalzpp": "064419998",
    "dropsitphn": 8603452703,
    "dropsitlph": 8603452703,
    "dropsitcph": 8603452703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20309",
    "droptype": "D",
    "dropname": "IVORYTON",
    "dropdeladd": "98 MAIN ST",
    "dropdelcty": "IVORYTON",
    "dropdelst": "CT",
    "dropdelzpp": "064429992",
    "dropphyadd": "98 MAIN ST",
    "dropphycty": "IVORYTON",
    "dropphyst": "CT",
    "dropphyzpp": "064429992",
    "dropmaladd": "98 MAIN ST",
    "dropmalcty": "IVORYTON",
    "dropmalst": "CT",
    "dropmalzpp": "064429992",
    "dropsitphn": 8607678515,
    "dropsitlph": 8607678515,
    "dropsitcph": 8607678515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20311",
    "droptype": "D",
    "dropname": "JEWETT CITY",
    "dropdeladd": "54 MAIN ST",
    "dropdelcty": "JEWETT CITY",
    "dropdelst": "CT",
    "dropdelzpp": "063519998",
    "dropphyadd": "54 MAIN ST",
    "dropphycty": "JEWETT CITY",
    "dropphyst": "CT",
    "dropphyzpp": "063519998",
    "dropmaladd": "54 MAIN ST",
    "dropmalcty": "JEWETT CITY",
    "dropmalst": "CT",
    "dropmalzpp": "063519998",
    "dropsitphn": 8603762067,
    "dropsitlph": 8603762067,
    "dropsitcph": 8603762067,
    "dropfax": 8603766383
  },
  {
    "dcode": "D",
    "dropkey": "PV20317",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "62 KENSINGTON RD",
    "dropdelcty": "BERLIN",
    "dropdelst": "CT",
    "dropdelzpp": "060379998",
    "dropphyadd": "62 KENSINGTON RD",
    "dropphycty": "BERLIN",
    "dropphyst": "CT",
    "dropphyzpp": "060379998",
    "dropmaladd": "62 KENSINGTON RD",
    "dropmalcty": "BERLIN",
    "dropmalst": "CT",
    "dropmalzpp": "060379998",
    "dropsitphn": 8608284768,
    "dropsitlph": 8608284768,
    "dropsitcph": 8608284768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20318",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "31 KENT GREEN BLVD",
    "dropdelcty": "KENT",
    "dropdelst": "CT",
    "dropdelzpp": "067579998",
    "dropphyadd": "31 KENT GREEN BLVD",
    "dropphycty": "KENT",
    "dropphyst": "CT",
    "dropphyzpp": "067579998",
    "dropmaladd": "31 KENT GREEN BLVD",
    "dropmalcty": "KENT",
    "dropmalst": "CT",
    "dropmalzpp": "067579998",
    "dropsitphn": 8609273435,
    "dropsitlph": 8609273435,
    "dropsitcph": 8609273435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20334",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "339 MAIN ST",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060399992",
    "dropphyadd": "339 MAIN ST",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060399992",
    "dropmaladd": "339 MAIN ST",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060399992",
    "dropsitphn": 8604352780,
    "dropsitlph": 8604352780,
    "dropsitcph": 8604352780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20339",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "562 EXETER RD",
    "dropdelcty": "LEBANON",
    "dropdelst": "CT",
    "dropdelzpp": "062499998",
    "dropphyadd": "562 EXETER RD",
    "dropphycty": "LEBANON",
    "dropphyst": "CT",
    "dropphyzpp": "062499998",
    "dropmaladd": "562 EXETER RD",
    "dropmalcty": "LEBANON",
    "dropmalst": "CT",
    "dropmalzpp": "062499998",
    "dropsitphn": 8606427950,
    "dropsitlph": 8606427950,
    "dropsitcph": 8606427950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20344",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "16 SOUTH ST",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "067599998",
    "dropphyadd": "16 SOUTH ST",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "067599998",
    "dropmaladd": "16 SOUTH ST",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "067599998",
    "dropsitphn": 8605678016,
    "dropsitlph": 8605246297,
    "dropsitcph": 8605678016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20349",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "781 BOSTON POST RD",
    "dropdelcty": "MADISON",
    "dropdelst": "CT",
    "dropdelzpp": "064439998",
    "dropphyadd": "781 BOSTON POST RD",
    "dropphycty": "MADISON",
    "dropphyst": "CT",
    "dropphyzpp": "064439998",
    "dropmaladd": "781 BOSTON POST RD",
    "dropmalcty": "MADISON",
    "dropmalst": "CT",
    "dropmalzpp": "064439998",
    "dropsitphn": 2032452394,
    "dropsitlph": 2032452394,
    "dropsitcph": 2032452394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20352",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "111 SHELDON RD",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "CT",
    "dropdelzpp": "060429998",
    "dropphyadd": "111 SHELDON RD",
    "dropphycty": "MANCHESTER",
    "dropphyst": "CT",
    "dropphyzpp": "060429998",
    "dropmaladd": "111 SHELDON RD",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "CT",
    "dropmalzpp": "060429998",
    "dropsitphn": 8606432735,
    "dropsitlph": 8606432735,
    "dropsitcph": 8606432735,
    "dropfax": 8606478846
  },
  {
    "dcode": "D",
    "dropkey": "PV20357",
    "droptype": "D",
    "dropname": "MANSFIELD CENTER",
    "dropdeladd": "522 STORRS RD",
    "dropdelcty": "MANSFIELD CENTER",
    "dropdelst": "CT",
    "dropdelzpp": "062509998",
    "dropphyadd": "522 STORRS RD",
    "dropphycty": "MANSFIELD CENTER",
    "dropphyst": "CT",
    "dropphyzpp": "062509998",
    "dropmaladd": "522 STORRS RD",
    "dropmalcty": "MANSFIELD CENTER",
    "dropmalst": "CT",
    "dropmalzpp": "062509998",
    "dropsitphn": 8604236496,
    "dropsitlph": 8604236496,
    "dropsitcph": 8604236496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20368",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "2321 MERIDEN WATERBURY TPKE",
    "dropdelcty": "MARION",
    "dropdelst": "CT",
    "dropdelzpp": "064449992",
    "dropphyadd": "2321 MERIDEN WATERBURY TPKE",
    "dropphycty": "MARION",
    "dropphyst": "CT",
    "dropphyzpp": "064449992",
    "dropmaladd": "2321 MERIDEN WATERBURY TPKE",
    "dropmalcty": "MARION",
    "dropmalst": "CT",
    "dropmalzpp": "064449992",
    "dropsitphn": 8606210707,
    "dropsitlph": 8606210707,
    "dropsitcph": 8606210707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20376",
    "droptype": "D",
    "dropname": "MERIDEN",
    "dropdeladd": "190 CENTER ST",
    "dropdelcty": "MERIDEN",
    "dropdelst": "CT",
    "dropdelzpp": "064509998",
    "dropphyadd": "190 CENTER ST",
    "dropphycty": "MERIDEN",
    "dropphyst": "CT",
    "dropphyzpp": "064509998",
    "dropmaladd": "190 CENTER ST",
    "dropmalcty": "MERIDEN",
    "dropmalst": "CT",
    "dropmalzpp": "064509998",
    "dropsitphn": 2032355755,
    "dropsitlph": 2032355755,
    "dropsitcph": 2032355755,
    "dropfax": 2032350114
  },
  {
    "dcode": "D",
    "dropkey": "PV20378",
    "droptype": "D",
    "dropname": "MIDDLE HADDAM",
    "dropdeladd": "77 MIDDLE HADDAM RD",
    "dropdelcty": "MIDDLE HADDAM",
    "dropdelst": "CT",
    "dropdelzpp": "064569992",
    "dropphyadd": "77 MIDDLE HADDAM RD",
    "dropphycty": "MIDDLE HADDAM",
    "dropphyst": "CT",
    "dropphyzpp": "064569992",
    "dropmaladd": "77 MIDDLE HADDAM RD",
    "dropmalcty": "MIDDLE HADDAM",
    "dropmalst": "CT",
    "dropmalzpp": "064569992",
    "dropsitphn": 8602675604,
    "dropsitlph": 8602675604,
    "dropsitcph": 8602675604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20380",
    "droptype": "D",
    "dropname": "MIDDLEBURY",
    "dropdeladd": "590 MIDDLEBURY RD STE F",
    "dropdelcty": "MIDDLEBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067622564",
    "dropphyadd": "590 MIDDLEBURY RD STE F",
    "dropphycty": "MIDDLEBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067622564",
    "dropmaladd": "590 MIDDLEBURY RD STE F",
    "dropmalcty": "MIDDLEBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067622564",
    "dropsitphn": 2037295381,
    "dropsitlph": 2037295381,
    "dropsitcph": 2037582334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20381",
    "droptype": "D",
    "dropname": "MIDDLEFIELD",
    "dropdeladd": "456 MAIN ST",
    "dropdelcty": "MIDDLEFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "064559998",
    "dropphyadd": "456 MAIN ST",
    "dropphycty": "MIDDLEFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "064559998",
    "dropmaladd": "456 MAIN ST",
    "dropmalcty": "MIDDLEFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "064559998",
    "dropsitphn": 8605246158,
    "dropsitlph": 8603497174,
    "dropsitcph": 8603497174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20383",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "11 SILVER ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "CT",
    "dropdelzpp": "064579998",
    "dropphyadd": "11 SILVER ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "CT",
    "dropphyzpp": "064579998",
    "dropmaladd": "11 SILVER ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "CT",
    "dropmalzpp": "064579998",
    "dropsitphn": 8606386977,
    "dropsitlph": 8606386977,
    "dropsitcph": 8606386977,
    "dropfax": 8603435125
  },
  {
    "dcode": "D",
    "dropkey": "PV20385",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "300 PEPES FARM RD",
    "dropdelcty": "MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064609998",
    "dropphyadd": "300 PEPES FARM RD",
    "dropphycty": "MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064609998",
    "dropmaladd": "300 PEPES FARM RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064609998",
    "dropsitphn": 2038766180,
    "dropsitlph": 2038766180,
    "dropsitcph": 2038766180,
    "dropfax": 2038766424
  },
  {
    "dcode": "D",
    "dropkey": "PV20386",
    "droptype": "D",
    "dropname": "MILLDALE",
    "dropdeladd": "223 CLARK ST",
    "dropdelcty": "MILLDALE",
    "dropdelst": "CT",
    "dropdelzpp": "064676523",
    "dropphyadd": "223 CLARK ST",
    "dropphycty": "MILLDALE",
    "dropphyst": "CT",
    "dropphyzpp": "064676523",
    "dropmaladd": "223 CLARK ST",
    "dropmalcty": "MILLDALE",
    "dropmalst": "CT",
    "dropmalzpp": "064676523",
    "dropsitphn": 8606287800,
    "dropsitlph": 8606287800,
    "dropsitcph": 8606287800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20389",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "270 MONROE TPKE",
    "dropdelcty": "MONROE",
    "dropdelst": "CT",
    "dropdelzpp": "064689998",
    "dropphyadd": "270 MONROE TPKE",
    "dropphycty": "MONROE",
    "dropphyst": "CT",
    "dropphyzpp": "064689998",
    "dropmaladd": "270 MONROE TPKE",
    "dropmalcty": "MONROE",
    "dropmalst": "CT",
    "dropmalzpp": "064689998",
    "dropsitphn": 2032613880,
    "dropsitlph": 2032613880,
    "dropsitcph": 2032613880,
    "dropfax": 2034523891
  },
  {
    "dcode": "D",
    "dropkey": "PV20390",
    "droptype": "D",
    "dropname": "MONTVILLE",
    "dropdeladd": "293 ROUTE 163",
    "dropdelcty": "MONTVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "063539998",
    "dropphyadd": "293 ROUTE 163",
    "dropphycty": "MONTVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "063539998",
    "dropmaladd": "293 ROUTE 163",
    "dropmalcty": "MONTVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "063539998",
    "dropsitphn": 8608483371,
    "dropsitlph": 8608483371,
    "dropsitcph": 8608483371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20394",
    "droptype": "D",
    "dropname": "MOODUS",
    "dropdeladd": "34 FALLS RD",
    "dropdelcty": "MOODUS",
    "dropdelst": "CT",
    "dropdelzpp": "064699998",
    "dropphyadd": "34 FALLS RD",
    "dropphycty": "MOODUS",
    "dropphyst": "CT",
    "dropphyzpp": "064699998",
    "dropmaladd": "34 FALLS RD",
    "dropmalcty": "MOODUS",
    "dropmalst": "CT",
    "dropmalzpp": "064699998",
    "dropsitphn": 8608738632,
    "dropsitlph": 8608738632,
    "dropsitcph": 8608738632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20395",
    "droptype": "D",
    "dropname": "MOOSUP",
    "dropdeladd": "21 S MAIN ST",
    "dropdelcty": "MOOSUP",
    "dropdelst": "CT",
    "dropdelzpp": "063549998",
    "dropphyadd": "21 S MAIN ST",
    "dropphycty": "MOOSUP",
    "dropphyst": "CT",
    "dropphyzpp": "063549998",
    "dropmaladd": "21 S MAIN ST",
    "dropmalcty": "MOOSUP",
    "dropmalst": "CT",
    "dropmalzpp": "063549998",
    "dropsitphn": 8605643255,
    "dropsitlph": 8605643255,
    "dropsitcph": 8605643255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20397",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "8 WEST ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "CT",
    "dropdelzpp": "067639998",
    "dropphyadd": "8 WEST ST",
    "dropphycty": "MORRIS",
    "dropphyst": "CT",
    "dropphyzpp": "067639998",
    "dropmaladd": "8 WEST ST",
    "dropmalcty": "MORRIS",
    "dropmalst": "CT",
    "dropmalzpp": "067639998",
    "dropsitphn": 8605677075,
    "dropsitlph": 8605677075,
    "dropsitcph": 8605677075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20401",
    "droptype": "D",
    "dropname": "MYSTIC",
    "dropdeladd": "23 E MAIN ST",
    "dropdelcty": "MYSTIC",
    "dropdelst": "CT",
    "dropdelzpp": "063559998",
    "dropphyadd": "23 E MAIN ST",
    "dropphycty": "MYSTIC",
    "dropphyst": "CT",
    "dropphyzpp": "063559998",
    "dropmaladd": "23 E MAIN ST",
    "dropmalcty": "MYSTIC",
    "dropmalst": "CT",
    "dropmalzpp": "063559998",
    "dropsitphn": 8605368143,
    "dropsitlph": 8605368143,
    "dropsitcph": 8605368143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20412",
    "droptype": "D",
    "dropname": "NAUGATUCK",
    "dropdeladd": "170 WATER ST",
    "dropdelcty": "NAUGATUCK",
    "dropdelst": "CT",
    "dropdelzpp": "067709998",
    "dropphyadd": "170 WATER ST",
    "dropphycty": "NAUGATUCK",
    "dropphyst": "CT",
    "dropphyzpp": "067709998",
    "dropmaladd": "170 WATER ST",
    "dropmalcty": "NAUGATUCK",
    "dropmalst": "CT",
    "dropmalzpp": "067709998",
    "dropsitphn": 2037201686,
    "dropsitlph": 2037295381,
    "dropsitcph": 2037295381,
    "dropfax": 2037201686
  },
  {
    "dcode": "D",
    "dropkey": "PV20417",
    "droptype": "D",
    "dropname": "NEW BRITAIN",
    "dropdeladd": "135 CHESTNUT ST",
    "dropdelcty": "NEW BRITAIN",
    "dropdelst": "CT",
    "dropdelzpp": "060509998",
    "dropphyadd": "135 CHESTNUT ST",
    "dropphycty": "NEW BRITAIN",
    "dropphyst": "CT",
    "dropphyzpp": "060509998",
    "dropmaladd": "135 CHESTNUT ST",
    "dropmalcty": "NEW BRITAIN",
    "dropmalst": "CT",
    "dropmalzpp": "060509998",
    "dropsitphn": 8602233681,
    "dropsitlph": 8602233681,
    "dropsitcph": 8602233681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20418",
    "droptype": "D",
    "dropname": "NEW CANAAN",
    "dropdeladd": "18 LOCUST AVE",
    "dropdelcty": "NEW CANAAN",
    "dropdelst": "CT",
    "dropdelzpp": "068404762",
    "dropphyadd": "18 LOCUST AVE",
    "dropphycty": "NEW CANAAN",
    "dropphyst": "CT",
    "dropphyzpp": "068404762",
    "dropmaladd": "18 LOCUST AVE",
    "dropmalcty": "NEW CANAAN",
    "dropmalst": "CT",
    "dropmalzpp": "068404762",
    "dropsitphn": 2033262204,
    "dropsitlph": 2033262204,
    "dropsitcph": 2039661659,
    "dropfax": 2039664855
  },
  {
    "dcode": "D",
    "dropkey": "PV20421",
    "droptype": "D",
    "dropname": "NEW HARTFORD",
    "dropdeladd": "545 MAIN ST",
    "dropdelcty": "NEW HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "060579998",
    "dropphyadd": "545 MAIN ST",
    "dropphycty": "NEW HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "060579998",
    "dropmaladd": "545 MAIN ST",
    "dropmalcty": "NEW HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "060579998",
    "dropsitphn": 8603795029,
    "dropsitlph": 8603795029,
    "dropsitcph": 8603795029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20424",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "50 BREWERY ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065115925",
    "dropphyadd": "50 BREWERY ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065115925",
    "dropmaladd": "50 BREWERY ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065115925",
    "dropsitphn": 2037827011,
    "dropsitlph": 2037827011,
    "dropsitcph": 2037827011,
    "dropfax": 2037827084
  },
  {
    "dcode": "D",
    "dropkey": "PV20428",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "27 MASONIC ST STE 1",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "CT",
    "dropdelzpp": "063209998",
    "dropphyadd": "27 MASONIC ST STE 1",
    "dropphycty": "NEW LONDON",
    "dropphyst": "CT",
    "dropphyzpp": "063209998",
    "dropmaladd": "27 MASONIC ST STE 1",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "CT",
    "dropmalzpp": "063209998",
    "dropsitphn": 8604434393,
    "dropsitlph": 8604434393,
    "dropsitcph": 8604434393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20429",
    "droptype": "D",
    "dropname": "NEW MILFORD",
    "dropdeladd": "37 MAIN ST",
    "dropdelcty": "NEW MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "067769998",
    "dropphyadd": "37 MAIN ST",
    "dropphycty": "NEW MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "067769998",
    "dropmaladd": "37 MAIN ST",
    "dropmalcty": "NEW MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "067769998",
    "dropsitphn": 8603545563,
    "dropsitlph": 8603545563,
    "dropsitcph": 8603545563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20436",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "5 COMMERCE RD",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "CT",
    "dropdelzpp": "064709998",
    "dropphyadd": "5 COMMERCE RD",
    "dropphycty": "NEWTOWN",
    "dropphyst": "CT",
    "dropphyzpp": "064709998",
    "dropmaladd": "5 COMMERCE RD",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "CT",
    "dropmalzpp": "064709998",
    "dropsitphn": 2032700300,
    "dropsitlph": 2034264271,
    "dropsitcph": 2034264271,
    "dropfax": 2034264271
  },
  {
    "dcode": "D",
    "dropkey": "PV20438",
    "droptype": "D",
    "dropname": "NIANTIC",
    "dropdeladd": "58 PENNSYLVANIA AVE STE 2",
    "dropdelcty": "NIANTIC",
    "dropdelst": "CT",
    "dropdelzpp": "063579991",
    "dropphyadd": "58 PENNSYLVANIA AVE STE 2",
    "dropphycty": "NIANTIC",
    "dropphyst": "CT",
    "dropphyzpp": "063579991",
    "dropmaladd": "58 PENNSYLVANIA AVE STE 2",
    "dropmalcty": "NIANTIC",
    "dropmalst": "CT",
    "dropmalzpp": "063579991",
    "dropsitphn": 8604438407,
    "dropsitlph": 8607398211,
    "dropsitcph": 8607398211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20452",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "6 JOHN J CURTISS RD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "CT",
    "dropdelzpp": "060589998",
    "dropphyadd": "6 JOHN J CURTISS RD",
    "dropphycty": "NORFOLK",
    "dropphyst": "CT",
    "dropphyzpp": "060589998",
    "dropmaladd": "6 JOHN J CURTISS RD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "CT",
    "dropmalzpp": "060589998",
    "dropsitphn": 8605425087,
    "dropsitlph": 8605425087,
    "dropsitcph": 8605425087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20457",
    "droptype": "D",
    "dropname": "NORTH BRANFORD",
    "dropdeladd": "280 BRANFORD RD",
    "dropdelcty": "NORTH BRANFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064719998",
    "dropphyadd": "280 BRANFORD RD",
    "dropphycty": "NORTH BRANFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064719998",
    "dropmaladd": "280 BRANFORD RD",
    "dropmalcty": "NORTH BRANFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064719998",
    "dropsitphn": 2034885541,
    "dropsitlph": 2034885541,
    "dropsitcph": 2034885541,
    "dropfax": 2033152180
  },
  {
    "dcode": "D",
    "dropkey": "PV20459",
    "droptype": "D",
    "dropname": "NORTH CANTON",
    "dropdeladd": "531 CHERRY BROOK RD",
    "dropdelcty": "NORTH CANTON",
    "dropdelst": "CT",
    "dropdelzpp": "060599991",
    "dropphyadd": "531 CHERRY BROOK RD",
    "dropphycty": "NORTH CANTON",
    "dropphyst": "CT",
    "dropphyzpp": "060599991",
    "dropmaladd": "531 CHERRY BROOK RD",
    "dropmalcty": "NORTH CANTON",
    "dropmalst": "CT",
    "dropmalzpp": "060599991",
    "dropsitphn": 8606932570,
    "dropsitlph": 8606932570,
    "dropsitcph": 8606932570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20460",
    "droptype": "D",
    "dropname": "NORTH FRANKLIN",
    "dropdeladd": "683 ROUTE 32",
    "dropdelcty": "NORTH FRANKLIN",
    "dropdelst": "CT",
    "dropdelzpp": "062549998",
    "dropphyadd": "683 ROUTE 32",
    "dropphycty": "NORTH FRANKLIN",
    "dropphyst": "CT",
    "dropphyzpp": "062549998",
    "dropmaladd": "683 ROUTE 32",
    "dropmalcty": "NORTH FRANKLIN",
    "dropmalst": "CT",
    "dropmalzpp": "062549998",
    "dropsitphn": 8606427172,
    "dropsitlph": 8606427172,
    "dropsitcph": 8606427172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20461",
    "droptype": "D",
    "dropname": "NORTH GRANBY",
    "dropdeladd": "389 N GRANBY RD",
    "dropdelcty": "NORTH GRANBY",
    "dropdelst": "CT",
    "dropdelzpp": "060609998",
    "dropphyadd": "389 N GRANBY RD",
    "dropphycty": "NORTH GRANBY",
    "dropphyst": "CT",
    "dropphyzpp": "060609998",
    "dropmaladd": "389 N GRANBY RD",
    "dropmalcty": "NORTH GRANBY",
    "dropmalst": "CT",
    "dropmalzpp": "060609998",
    "dropsitphn": 8606537155,
    "dropsitlph": 8606537155,
    "dropsitcph": 8606537155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20463",
    "droptype": "D",
    "dropname": "NORTH GROSVENORDALE",
    "dropdeladd": "831 RIVERSIDE DR",
    "dropdelcty": "NORTH GROSVENORDALE",
    "dropdelst": "CT",
    "dropdelzpp": "062559998",
    "dropphyadd": "831 RIVERSIDE DR",
    "dropphycty": "NORTH GROSVENORDALE",
    "dropphyst": "CT",
    "dropphyzpp": "062559998",
    "dropmaladd": "831 RIVERSIDE DR",
    "dropmalcty": "NORTH GROSVENORDALE",
    "dropmalst": "CT",
    "dropmalzpp": "062559998",
    "dropsitphn": 8609239192,
    "dropsitlph": 8609239192,
    "dropsitcph": 8609239192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20464",
    "droptype": "D",
    "dropname": "NORTH HAVEN",
    "dropdeladd": "74 WASHINGTON AVE",
    "dropdelcty": "NORTH HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "064739994",
    "dropphyadd": "74 WASHINGTON AVE",
    "dropphycty": "NORTH HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "064739994",
    "dropmaladd": "74 WASHINGTON AVE",
    "dropmalcty": "NORTH HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "064739994",
    "dropsitphn": 2037724810,
    "dropsitlph": 2032390415,
    "dropsitcph": 2032390415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20468",
    "droptype": "D",
    "dropname": "NORTH STONINGTON",
    "dropdeladd": "391 NORWICH WESTERLY RD",
    "dropdelcty": "NORTH STONINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "063599998",
    "dropphyadd": "391 NORWICH WESTERLY RD",
    "dropphycty": "NORTH STONINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "063599998",
    "dropmaladd": "391 NORWICH WESTERLY RD",
    "dropmalcty": "NORTH STONINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "063599998",
    "dropsitphn": 8605352871,
    "dropsitlph": 8605352871,
    "dropsitcph": 8605352871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20471",
    "droptype": "D",
    "dropname": "NORTH WESTCHESTER",
    "dropdeladd": "103 S MAIN ST STE 3A",
    "dropdelcty": "COLCHESTER",
    "dropdelst": "CT",
    "dropdelzpp": "064159992",
    "dropphyadd": "103 S MAIN ST STE 3A",
    "dropphycty": "COLCHESTER",
    "dropphyst": "CT",
    "dropphyzpp": "064159992",
    "dropmaladd": "103 S MAIN ST STE 3A",
    "dropmalcty": "COLCHESTER",
    "dropmalst": "CT",
    "dropmalzpp": "064159992",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2035375695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20472",
    "droptype": "D",
    "dropname": "NORTH WINDHAM",
    "dropdeladd": "690 BOSTON POST RD",
    "dropdelcty": "NORTH WINDHAM",
    "dropdelst": "CT",
    "dropdelzpp": "062561115",
    "dropphyadd": "690 BOSTON POST RD",
    "dropphycty": "NORTH WINDHAM",
    "dropphyst": "CT",
    "dropphyzpp": "062561115",
    "dropmaladd": "690 BOSTON POST RD",
    "dropmalcty": "NORTH WINDHAM",
    "dropmalst": "CT",
    "dropmalzpp": "062561115",
    "dropsitphn": 8604563383,
    "dropsitlph": 8604563383,
    "dropsitcph": 8604563383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20476",
    "droptype": "D",
    "dropname": "NORTHFORD",
    "dropdeladd": "1447 MIDDLETOWN AVE",
    "dropdelcty": "NORTHFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064729998",
    "dropphyadd": "1447 MIDDLETOWN AVE",
    "dropphycty": "NORTHFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064729998",
    "dropmaladd": "1447 MIDDLETOWN AVE",
    "dropmalcty": "NORTHFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064729998",
    "dropsitphn": 2034842761,
    "dropsitlph": 2034842761,
    "dropsitcph": 2034842761,
    "dropfax": 2034841291
  },
  {
    "dcode": "D",
    "dropkey": "PV20478",
    "droptype": "D",
    "dropname": "NORWALK",
    "dropdeladd": "16 WASHINGTON ST",
    "dropdelcty": "NORWALK",
    "dropdelst": "CT",
    "dropdelzpp": "068549998",
    "dropphyadd": "16 WASHINGTON ST",
    "dropphycty": "NORWALK",
    "dropphyst": "CT",
    "dropphyzpp": "068549998",
    "dropmaladd": "16 WASHINGTON ST",
    "dropmalcty": "NORWALK",
    "dropmalst": "CT",
    "dropmalzpp": "068549998",
    "dropsitphn": 2038544747,
    "dropsitlph": 8608544747,
    "dropsitcph": 2038544747,
    "dropfax": 2038526708
  },
  {
    "dcode": "D",
    "dropkey": "PV20479",
    "droptype": "D",
    "dropname": "NORWICH",
    "dropdeladd": "340 MAIN ST",
    "dropdelcty": "NORWICH",
    "dropdelst": "CT",
    "dropdelzpp": "063609992",
    "dropphyadd": "340 MAIN ST",
    "dropphycty": "NORWICH",
    "dropphyst": "CT",
    "dropphyzpp": "063609992",
    "dropmaladd": "340 MAIN ST",
    "dropmalcty": "NORWICH",
    "dropmalst": "CT",
    "dropmalzpp": "063609992",
    "dropsitphn": 8608873559,
    "dropsitlph": 8608873559,
    "dropsitcph": 8608873559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20489",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "711 ROUTE 163",
    "dropdelcty": "OAKDALE",
    "dropdelst": "CT",
    "dropdelzpp": "063709998",
    "dropphyadd": "711 ROUTE 163",
    "dropphycty": "OAKDALE",
    "dropphyst": "CT",
    "dropphyzpp": "063709998",
    "dropmaladd": "711 ROUTE 163",
    "dropmalcty": "OAKDALE",
    "dropmalst": "CT",
    "dropmalzpp": "063709998",
    "dropsitphn": 8608480453,
    "dropsitlph": 8608480453,
    "dropsitcph": 8608480453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20493",
    "droptype": "D",
    "dropname": "OLD GREENWICH",
    "dropdeladd": "36 ARCADIA RD",
    "dropdelcty": "OLD GREENWICH",
    "dropdelst": "CT",
    "dropdelzpp": "068709203",
    "dropphyadd": "36 ARCADIA RD",
    "dropphycty": "OLD GREENWICH",
    "dropphyst": "CT",
    "dropphyzpp": "068709203",
    "dropmaladd": "36 ARCADIA RD",
    "dropmalcty": "OLD GREENWICH",
    "dropmalst": "CT",
    "dropmalzpp": "068709203",
    "dropsitphn": 2036371405,
    "dropsitlph": 2036371405,
    "dropsitcph": 2036371405,
    "dropfax": 2036370685
  },
  {
    "dcode": "D",
    "dropkey": "PV20496",
    "droptype": "D",
    "dropname": "OLD LYME",
    "dropdeladd": "12 HALLS RD",
    "dropdelcty": "OLD LYME",
    "dropdelst": "CT",
    "dropdelzpp": "063719992",
    "dropphyadd": "12 HALLS RD",
    "dropphycty": "OLD LYME",
    "dropphyst": "CT",
    "dropphyzpp": "063719992",
    "dropmaladd": "12 HALLS RD",
    "dropmalcty": "OLD LYME",
    "dropmalst": "CT",
    "dropmalzpp": "063719992",
    "dropsitphn": 8604341653,
    "dropsitlph": 8604341653,
    "dropsitcph": 8604341653,
    "dropfax": 8604347446
  },
  {
    "dcode": "D",
    "dropkey": "PV20497",
    "droptype": "D",
    "dropname": "OLD MYSTIC",
    "dropdeladd": "47 MAIN ST",
    "dropdelcty": "OLD MYSTIC",
    "dropdelst": "CT",
    "dropdelzpp": "063729992",
    "dropphyadd": "47 MAIN ST",
    "dropphycty": "OLD MYSTIC",
    "dropphyst": "CT",
    "dropphyzpp": "063729992",
    "dropmaladd": "47 MAIN ST",
    "dropmalcty": "OLD MYSTIC",
    "dropmalst": "CT",
    "dropmalzpp": "063729992",
    "dropsitphn": 8605360510,
    "dropsitlph": 8605360510,
    "dropsitcph": 8605360510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20498",
    "droptype": "D",
    "dropname": "OLD SAYBROOK",
    "dropdeladd": "36 MAIN ST",
    "dropdelcty": "OLD SAYBROOK",
    "dropdelst": "CT",
    "dropdelzpp": "064759998",
    "dropphyadd": "36 MAIN ST",
    "dropphycty": "OLD SAYBROOK",
    "dropphyst": "CT",
    "dropphyzpp": "064759998",
    "dropmaladd": "36 MAIN ST",
    "dropmalcty": "OLD SAYBROOK",
    "dropmalst": "CT",
    "dropmalzpp": "064759998",
    "dropsitphn": 8603884479,
    "dropsitlph": 8603884479,
    "dropsitcph": 8603884479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20500",
    "droptype": "D",
    "dropname": "ONECO",
    "dropdeladd": "1104 PLAINFIELD PIKE",
    "dropdelcty": "ONECO",
    "dropdelst": "CT",
    "dropdelzpp": "063739992",
    "dropphyadd": "1104 PLAINFIELD PIKE",
    "dropphycty": "ONECO",
    "dropphyst": "CT",
    "dropphyzpp": "063739992",
    "dropmaladd": "1104 PLAINFIELD PIKE",
    "dropmalcty": "ONECO",
    "dropmalst": "CT",
    "dropmalzpp": "063739992",
    "dropsitphn": 8605645601,
    "dropsitlph": 8605645601,
    "dropsitcph": 8605645601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20501",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "36 OLD TAVERN RD",
    "dropdelcty": "ORANGE",
    "dropdelst": "CT",
    "dropdelzpp": "064779994",
    "dropphyadd": "36 OLD TAVERN RD",
    "dropphycty": "ORANGE",
    "dropphyst": "CT",
    "dropphyzpp": "064779994",
    "dropmaladd": "36 OLD TAVERN RD",
    "dropmalcty": "ORANGE",
    "dropmalst": "CT",
    "dropmalzpp": "064779994",
    "dropsitphn": 2038766180,
    "dropsitlph": 2037953523,
    "dropsitcph": 2037953523,
    "dropfax": 2037951056
  },
  {
    "dcode": "D",
    "dropkey": "PV20506",
    "droptype": "D",
    "dropname": "PEQUABUCK",
    "dropdeladd": "153 S RIVERSIDE AVE",
    "dropdelcty": "PEQUABUCK",
    "dropdelst": "CT",
    "dropdelzpp": "067819995",
    "dropphyadd": "153 S RIVERSIDE AVE",
    "dropphycty": "PEQUABUCK",
    "dropphyst": "CT",
    "dropphyzpp": "067819995",
    "dropmaladd": "153 S RIVERSIDE AVE",
    "dropmalcty": "PEQUABUCK",
    "dropmalst": "CT",
    "dropmalzpp": "067819995",
    "dropsitphn": 8605892081,
    "dropsitlph": 8605892081,
    "dropsitcph": 8605892081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20509",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "110 TOM HARVEY RD",
    "dropdelcty": "WESTERLY",
    "dropdelst": "RI",
    "dropdelzpp": "02891",
    "dropphyadd": "110 TOM HARVEY RD",
    "dropphycty": "WESTERLY",
    "dropphyst": "RI",
    "dropphyzpp": "02891",
    "dropmaladd": "391 NORWICH WESTERLY RD",
    "dropmalcty": "NORTH STONINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "063599992",
    "dropsitphn": 4015961180,
    "dropsitlph": 4015961180,
    "dropsitcph": 4015961180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20511",
    "droptype": "D",
    "dropname": "PINE MEADOW",
    "dropdeladd": "377 MAIN ST",
    "dropdelcty": "PINE MEADOW",
    "dropdelst": "CT",
    "dropdelzpp": "060619992",
    "dropphyadd": "377 MAIN ST",
    "dropphycty": "PINE MEADOW",
    "dropphyst": "CT",
    "dropphyzpp": "060619992",
    "dropmaladd": "377 MAIN ST",
    "dropmalcty": "PINE MEADOW",
    "dropmalst": "CT",
    "dropmalzpp": "060619992",
    "dropsitphn": 8603793450,
    "dropsitlph": 8603793450,
    "dropsitcph": 8603793450,
    "dropfax": 8603795652
  },
  {
    "dcode": "D",
    "dropkey": "PV20514",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "42 RAILROAD AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "063749998",
    "dropphyadd": "42 RAILROAD AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "063749998",
    "dropmaladd": "42 RAILROAD AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "063749998",
    "dropsitphn": 8605648918,
    "dropsitlph": 8605648918,
    "dropsitcph": 8605648918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20516",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "56 WHITING ST",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060629998",
    "dropphyadd": "56 WHITING ST",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060629998",
    "dropmaladd": "56 WHITING ST",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060629998",
    "dropsitphn": 8607472797,
    "dropsitlph": 8607472797,
    "dropsitcph": 8607472797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20519",
    "droptype": "D",
    "dropname": "PLANTSVILLE",
    "dropdeladd": "847 S MAIN ST",
    "dropdelcty": "PLANTSVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "064799998",
    "dropphyadd": "847 S MAIN ST",
    "dropphycty": "PLANTSVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "064799998",
    "dropmaladd": "847 S MAIN ST",
    "dropmalcty": "PLANTSVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "064799998",
    "dropsitphn": 8606286517,
    "dropsitlph": 8606286517,
    "dropsitcph": 8606286517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20523",
    "droptype": "D",
    "dropname": "PLEASANT VALLEY",
    "dropdeladd": "105 RIVER RD",
    "dropdelcty": "BARKHAMSTED",
    "dropdelst": "CT",
    "dropdelzpp": "060639998",
    "dropphyadd": "105 RIVER RD",
    "dropphycty": "BARKHAMSTED",
    "dropphyst": "CT",
    "dropphyzpp": "060639998",
    "dropmaladd": "105 RIVER RD",
    "dropmalcty": "BARKHAMSTED",
    "dropmalst": "CT",
    "dropmalzpp": "060639998",
    "dropsitphn": 8603792252,
    "dropsitlph": 8603792252,
    "dropsitcph": 8603792252,
    "dropfax": 8607386022
  },
  {
    "dcode": "D",
    "dropkey": "PV20527",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "696 MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "CT",
    "dropdelzpp": "067829998",
    "dropphyadd": "696 MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "CT",
    "dropphyzpp": "067829998",
    "dropmaladd": "696 MAIN ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "CT",
    "dropmalzpp": "067829998",
    "dropsitphn": 8602835612,
    "dropsitlph": 8602835612,
    "dropsitcph": 8602835612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20529",
    "droptype": "D",
    "dropname": "POMFRET",
    "dropdeladd": "32 PUTNAM RD",
    "dropdelcty": "POMFRET",
    "dropdelst": "CT",
    "dropdelzpp": "062589997",
    "dropphyadd": "32 PUTNAM RD",
    "dropphycty": "POMFRET",
    "dropphyst": "CT",
    "dropphyzpp": "062589997",
    "dropmaladd": "32 PUTNAM RD",
    "dropmalcty": "POMFRET",
    "dropmalst": "CT",
    "dropmalzpp": "062589997",
    "dropsitphn": 8609283649,
    "dropsitlph": 8609283649,
    "dropsitcph": 8609283649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20531",
    "droptype": "D",
    "dropname": "POMFRET CENTER",
    "dropdeladd": "144 MURDOCK RD",
    "dropdelcty": "POMFRET CENTER",
    "dropdelst": "CT",
    "dropdelzpp": "062599998",
    "dropphyadd": "144 MURDOCK RD",
    "dropphycty": "POMFRET CENTER",
    "dropphyst": "CT",
    "dropphyzpp": "062599998",
    "dropmaladd": "144 MURDOCK RD",
    "dropmalcty": "POMFRET CENTER",
    "dropmalst": "CT",
    "dropmalzpp": "062599998",
    "dropsitphn": 8609284187,
    "dropsitlph": 8609284187,
    "dropsitcph": 8609284187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20536",
    "droptype": "D",
    "dropname": "POQUONOCK",
    "dropdeladd": "1771 POQUONOCK AVE",
    "dropdelcty": "POQUONOCK",
    "dropdelst": "CT",
    "dropdelzpp": "060649992",
    "dropphyadd": "1771 POQUONOCK AVE",
    "dropphycty": "POQUONOCK",
    "dropphyst": "CT",
    "dropphyzpp": "060649992",
    "dropmaladd": "1771 POQUONOCK AVE",
    "dropmalcty": "POQUONOCK",
    "dropmalst": "CT",
    "dropmalzpp": "060649992",
    "dropsitphn": 8606876928,
    "dropsitlph": 8606876928,
    "dropsitcph": 8606876928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20538",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "CT",
    "dropdelzpp": "064809998",
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "CT",
    "dropphyzpp": "064809998",
    "dropmaladd": "320 MAIN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "CT",
    "dropmalzpp": "064809998",
    "dropsitphn": 8603420081,
    "dropsitlph": 8603420081,
    "dropsitcph": 8603420081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20546",
    "droptype": "D",
    "dropname": "PUTNAM",
    "dropdeladd": "189 MAIN ST",
    "dropdelcty": "PUTNAM",
    "dropdelst": "CT",
    "dropdelzpp": "062609998",
    "dropphyadd": "189 MAIN ST",
    "dropphycty": "PUTNAM",
    "dropphyst": "CT",
    "dropphyzpp": "062609998",
    "dropmaladd": "189 MAIN ST",
    "dropmalcty": "PUTNAM",
    "dropmalst": "CT",
    "dropmalzpp": "062609998",
    "dropsitphn": 8609284051,
    "dropsitlph": 8609284051,
    "dropsitcph": 8609284051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20549",
    "droptype": "D",
    "dropname": "QUAKER HILL",
    "dropdeladd": "132 OLD NORWICH RD",
    "dropdelcty": "QUAKER HILL",
    "dropdelst": "CT",
    "dropdelzpp": "063759998",
    "dropphyadd": "132 OLD NORWICH RD",
    "dropphycty": "QUAKER HILL",
    "dropphyst": "CT",
    "dropphyzpp": "063759998",
    "dropmaladd": "132 OLD NORWICH RD",
    "dropmalcty": "QUAKER HILL",
    "dropmalst": "CT",
    "dropmalzpp": "063759998",
    "dropsitphn": 8604435020,
    "dropsitlph": 8604435020,
    "dropsitcph": 8604435020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20551",
    "droptype": "D",
    "dropname": "QUINEBAUG",
    "dropdeladd": "734 QUINEBAUG RD",
    "dropdelcty": "QUINEBAUG",
    "dropdelst": "CT",
    "dropdelzpp": "062629998",
    "dropphyadd": "734 QUINEBAUG RD",
    "dropphycty": "QUINEBAUG",
    "dropphyst": "CT",
    "dropphyzpp": "062629998",
    "dropmaladd": "734 QUINEBAUG RD",
    "dropmalcty": "QUINEBAUG",
    "dropmalst": "CT",
    "dropmalzpp": "062629998",
    "dropsitphn": 8609355549,
    "dropsitlph": 8609355549,
    "dropsitcph": 8609355549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20552",
    "droptype": "D",
    "dropname": "REDDING CENTER",
    "dropdeladd": "10 LONETOWN RD",
    "dropdelcty": "REDDING CENTER",
    "dropdelst": "CT",
    "dropdelzpp": "068759992",
    "dropphyadd": "10 LONETOWN RD",
    "dropphycty": "REDDING CENTER",
    "dropphyst": "CT",
    "dropphyzpp": "068759992",
    "dropmaladd": "10 LONETOWN RD",
    "dropmalcty": "REDDING CENTER",
    "dropmalst": "CT",
    "dropmalzpp": "068759992",
    "dropsitphn": 2039382309,
    "dropsitlph": 2039382309,
    "dropsitcph": 2039382309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20555",
    "droptype": "D",
    "dropname": "REDDING RIDGE",
    "dropdeladd": "121 BLACK ROCK TPKE",
    "dropdelcty": "REDDING RIDGE",
    "dropdelst": "CT",
    "dropdelzpp": "068769997",
    "dropphyadd": "121 BLACK ROCK TPKE",
    "dropphycty": "REDDING RIDGE",
    "dropphyst": "CT",
    "dropphyzpp": "068769997",
    "dropmaladd": "121 BLACK ROCK TPKE",
    "dropmalcty": "REDDING RIDGE",
    "dropmalst": "CT",
    "dropmalzpp": "068769997",
    "dropsitphn": 2039383337,
    "dropsitlph": 2039383337,
    "dropsitcph": 2039383337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20557",
    "droptype": "D",
    "dropname": "RIDGEFIELD",
    "dropdeladd": "26 CATOONAH ST",
    "dropdelcty": "RIDGEFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068779998",
    "dropphyadd": "26 CATOONAH ST",
    "dropphycty": "RIDGEFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068779998",
    "dropmaladd": "26 CATOONAH ST",
    "dropmalcty": "RIDGEFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068779998",
    "dropsitphn": 2034386561,
    "dropsitlph": 2034386561,
    "dropsitcph": 2034386561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20561",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "1273 E PUTNAM AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CT",
    "dropdelzpp": "068789998",
    "dropphyadd": "1273 E PUTNAM AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CT",
    "dropphyzpp": "068789998",
    "dropmaladd": "1273 E PUTNAM AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CT",
    "dropmalzpp": "068789998",
    "dropsitphn": 2036371385,
    "dropsitlph": 2036379332,
    "dropsitcph": 2036379332,
    "dropfax": 2036375982
  },
  {
    "dcode": "D",
    "dropkey": "PV20562",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "5 RIVERTON RD",
    "dropdelcty": "RIVERTON",
    "dropdelst": "CT",
    "dropdelzpp": "060659998",
    "dropphyadd": "5 RIVERTON RD",
    "dropphycty": "RIVERTON",
    "dropphyst": "CT",
    "dropphyzpp": "060659998",
    "dropmaladd": "5 RIVERTON RD",
    "dropmalcty": "RIVERTON",
    "dropmalst": "CT",
    "dropmalzpp": "060659998",
    "dropsitphn": 8603471027,
    "dropsitlph": 8603795250,
    "dropsitcph": 8603795250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20563",
    "droptype": "D",
    "dropname": "ROCKFALL",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "ROCKFALL",
    "dropdelst": "CT",
    "dropdelzpp": "064819998",
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "ROCKFALL",
    "dropphyst": "CT",
    "dropphyzpp": "064819998",
    "dropmaladd": "110 MAIN ST",
    "dropmalcty": "ROCKFALL",
    "dropmalst": "CT",
    "dropmalzpp": "064819998",
    "dropsitphn": 8603471027,
    "dropsitlph": 8603471027,
    "dropsitcph": 8603471027,
    "dropfax": 8603470019
  },
  {
    "dcode": "D",
    "dropkey": "PV20565",
    "droptype": "D",
    "dropname": "ROCKY HILL",
    "dropdeladd": "32 CHURCH ST",
    "dropdelcty": "ROCKY HILL",
    "dropdelst": "CT",
    "dropdelzpp": "060679998",
    "dropphyadd": "32 CHURCH ST",
    "dropphycty": "ROCKY HILL",
    "dropphyst": "CT",
    "dropphyzpp": "060679998",
    "dropmaladd": "32 CHURCH ST",
    "dropmalcty": "ROCKY HILL",
    "dropmalst": "CT",
    "dropmalzpp": "060679998",
    "dropsitphn": 8605633526,
    "dropsitlph": 8605633526,
    "dropsitcph": 8605633526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20567",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "29A WILLIAMSVILLE RD",
    "dropdelcty": "ROGERS",
    "dropdelst": "CT",
    "dropdelzpp": "062639997",
    "dropphyadd": "29A WILLIAMSVILLE RD",
    "dropphycty": "ROGERS",
    "dropphyst": "CT",
    "dropphyzpp": "062639997",
    "dropmaladd": "29A WILLIAMSVILLE RD",
    "dropmalcty": "ROGERS",
    "dropmalst": "CT",
    "dropmalzpp": "062639997",
    "dropsitphn": 8607745272,
    "dropsitlph": 8607745272,
    "dropsitcph": 8607745272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20570",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "26 NORTH ST",
    "dropdelcty": "ROXBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067839998",
    "dropphyadd": "26 NORTH ST",
    "dropphycty": "ROXBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067839998",
    "dropmaladd": "26 NORTH ST",
    "dropmalcty": "ROXBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067839998",
    "dropsitphn": 8603540591,
    "dropsitlph": 8603540591,
    "dropsitcph": 8603540591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20581",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "22 MAIN ST",
    "dropdelcty": "SALISBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060689998",
    "dropphyadd": "22 MAIN ST",
    "dropphycty": "SALISBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060689998",
    "dropmaladd": "22 MAIN ST",
    "dropmalcty": "SALISBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060689998",
    "dropsitphn": 8604355072,
    "dropsitlph": 8604355072,
    "dropsitcph": 8604355072,
    "dropfax": 8604535072
  },
  {
    "dcode": "D",
    "dropkey": "PV20590",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "10 PALMER RD",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "CT",
    "dropdelzpp": "062649998",
    "dropphyadd": "10 PALMER RD",
    "dropphycty": "SCOTLAND",
    "dropphyst": "CT",
    "dropphyzpp": "062649998",
    "dropmaladd": "10 PALMER RD",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "CT",
    "dropmalzpp": "062649998",
    "dropsitphn": 8604568987,
    "dropsitlph": 8604568987,
    "dropsitcph": 8604568987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20592",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "91 MAIN ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "CT",
    "dropdelzpp": "064839998",
    "dropphyadd": "91 MAIN ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "CT",
    "dropphyzpp": "064839998",
    "dropmaladd": "91 MAIN ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "CT",
    "dropmalzpp": "064839998",
    "dropsitphn": 2038883830,
    "dropsitlph": 2038883830,
    "dropsitcph": 2038883830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20596",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "2 LOW RD",
    "dropdelcty": "SHARON",
    "dropdelst": "CT",
    "dropdelzpp": "060699998",
    "dropphyadd": "2 LOW RD",
    "dropphycty": "SHARON",
    "dropphyst": "CT",
    "dropphyzpp": "060699998",
    "dropmaladd": "2 LOW RD",
    "dropmalcty": "SHARON",
    "dropmalst": "CT",
    "dropmalzpp": "060699998",
    "dropsitphn": 8603645306,
    "dropsitlph": 8603645306,
    "dropsitcph": 8603645306,
    "dropfax": 8603640799
  },
  {
    "dcode": "D",
    "dropkey": "PV20599",
    "droptype": "D",
    "dropname": "SHELTON",
    "dropdeladd": "83 BRIDGE ST",
    "dropdelcty": "SHELTON",
    "dropdelst": "CT",
    "dropdelzpp": "064849994",
    "dropphyadd": "83 BRIDGE ST",
    "dropphycty": "SHELTON",
    "dropphyst": "CT",
    "dropphyzpp": "064849994",
    "dropmaladd": "83 BRIDGE ST",
    "dropmalcty": "SHELTON",
    "dropmalst": "CT",
    "dropmalzpp": "064849994",
    "dropsitphn": 2039248349,
    "dropsitlph": 2039248349,
    "dropsitcph": 2039248349,
    "dropfax": 2039246780
  },
  {
    "dcode": "D",
    "dropkey": "PV20600",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "29 ROUTE 37 CTR STE 1",
    "dropdelcty": "SHERMAN",
    "dropdelst": "CT",
    "dropdelzpp": "067849998",
    "dropphyadd": "29 ROUTE 37 CTR STE 1",
    "dropphycty": "SHERMAN",
    "dropphyst": "CT",
    "dropphyzpp": "067849998",
    "dropmaladd": "29 ROUTE 37 CTR STE 1",
    "dropmalcty": "SHERMAN",
    "dropmalst": "CT",
    "dropmalzpp": "067849998",
    "dropsitphn": 8603546191,
    "dropsitlph": 8603546191,
    "dropsitcph": 8603546191,
    "dropfax": 8603547362
  },
  {
    "dcode": "D",
    "dropkey": "PV20605",
    "droptype": "D",
    "dropname": "SIMSBURY",
    "dropdeladd": "932 HOPMEADOW ST",
    "dropdelcty": "SIMSBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060709998",
    "dropphyadd": "932 HOPMEADOW ST",
    "dropphycty": "SIMSBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060709998",
    "dropmaladd": "932 HOPMEADOW ST",
    "dropmalcty": "SIMSBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060709998",
    "dropsitphn": 8606587811,
    "dropsitlph": 8606587811,
    "dropsitcph": 8606587811,
    "dropfax": 8604085477
  },
  {
    "dcode": "D",
    "dropkey": "PV20617",
    "droptype": "D",
    "dropname": "SOMERS",
    "dropdeladd": "26 BATTLE ST",
    "dropdelcty": "SOMERS",
    "dropdelst": "CT",
    "dropdelzpp": "060719998",
    "dropphyadd": "26 BATTLE ST",
    "dropphycty": "SOMERS",
    "dropphyst": "CT",
    "dropphyzpp": "060719998",
    "dropmaladd": "26 BATTLE ST",
    "dropmalcty": "SOMERS",
    "dropmalst": "CT",
    "dropmalzpp": "060719998",
    "dropsitphn": 8607497337,
    "dropsitlph": 8607497337,
    "dropsitcph": 8607497337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20618",
    "droptype": "D",
    "dropname": "SOMERSVILLE",
    "dropdeladd": "28 MAPLE ST",
    "dropdelcty": "SOMERSVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060729992",
    "dropphyadd": "28 MAPLE ST",
    "dropphycty": "SOMERSVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060729992",
    "dropmaladd": "28 MAPLE ST",
    "dropmalcty": "SOMERSVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060729992",
    "dropsitphn": 8607490047,
    "dropsitlph": 8607490047,
    "dropsitcph": 8607490047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20625",
    "droptype": "D",
    "dropname": "SOUTH GLASTONBURY",
    "dropdeladd": "885 MAIN ST",
    "dropdelcty": "SOUTH GLASTONBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060739998",
    "dropphyadd": "885 MAIN ST",
    "dropphycty": "SOUTH GLASTONBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060739998",
    "dropmaladd": "885 MAIN ST",
    "dropmalcty": "SOUTH GLASTONBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060739998",
    "dropsitphn": 8606334198,
    "dropsitlph": 8606334198,
    "dropsitcph": 8606334198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20626",
    "droptype": "D",
    "dropname": "SOUTH KENT",
    "dropdeladd": "314 S KENT RD",
    "dropdelcty": "SOUTH KENT",
    "dropdelst": "CT",
    "dropdelzpp": "067859998",
    "dropphyadd": "314 S KENT RD",
    "dropphycty": "SOUTH KENT",
    "dropphyst": "CT",
    "dropphyzpp": "067859998",
    "dropmaladd": "314 S KENT RD",
    "dropmalcty": "SOUTH KENT",
    "dropmalst": "CT",
    "dropmalzpp": "067859998",
    "dropsitphn": 8609273870,
    "dropsitlph": 8609273870,
    "dropsitcph": 8609273870,
    "dropfax": 8609272121
  },
  {
    "dcode": "D",
    "dropkey": "PV20628",
    "droptype": "D",
    "dropname": "SOUTH LYME",
    "dropdeladd": "389 SHORE RD",
    "dropdelcty": "SOUTH LYME",
    "dropdelst": "CT",
    "dropdelzpp": "063769992",
    "dropphyadd": "389 SHORE RD",
    "dropphycty": "SOUTH LYME",
    "dropphyst": "CT",
    "dropphyzpp": "063769992",
    "dropmaladd": "389 SHORE RD",
    "dropmalcty": "SOUTH LYME",
    "dropmalst": "CT",
    "dropmalzpp": "063769992",
    "dropsitphn": 8604345361,
    "dropsitlph": 8604345361,
    "dropsitcph": 8604345361,
    "dropfax": 8604345361
  },
  {
    "dcode": "D",
    "dropkey": "PV20630",
    "droptype": "D",
    "dropname": "SOUTH WILLINGTON",
    "dropdeladd": "310 ROUTE 169",
    "dropdelcty": "SOUTH WILLINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "06265",
    "dropphyadd": "310 ROUTE 169",
    "dropphycty": "SOUTH WILLINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "06265",
    "dropmaladd": "GENERAL DELIVERY",
    "dropmalcty": "SOUTH WILLINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "062659999",
    "dropsitphn": 8604295021,
    "dropsitlph": 8604295021,
    "dropsitcph": 8604295021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20631",
    "droptype": "D",
    "dropname": "SOUTH WINDHAM",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "SOUTH WINDHAM",
    "dropdelst": "CT",
    "dropdelzpp": "062669998",
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "SOUTH WINDHAM",
    "dropphyst": "CT",
    "dropphyzpp": "062669998",
    "dropmaladd": "12 MAIN ST",
    "dropmalcty": "SOUTH WINDHAM",
    "dropmalst": "CT",
    "dropmalzpp": "062669998",
    "dropsitphn": 8604560169,
    "dropsitlph": 8604560169,
    "dropsitcph": 8604560169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20632",
    "droptype": "D",
    "dropname": "SOUTH WINDSOR",
    "dropdeladd": "850 CLARK ST",
    "dropdelcty": "SOUTH WINDSOR",
    "dropdelst": "CT",
    "dropdelzpp": "060749998",
    "dropphyadd": "850 CLARK ST",
    "dropphycty": "SOUTH WINDSOR",
    "dropphyst": "CT",
    "dropphyzpp": "060749998",
    "dropmaladd": "850 CLARK ST",
    "dropmalcty": "SOUTH WINDSOR",
    "dropmalst": "CT",
    "dropmalzpp": "060749998",
    "dropsitphn": 8606481779,
    "dropsitlph": 8606481779,
    "dropsitcph": 8606481779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20633",
    "droptype": "D",
    "dropname": "SOUTH WOODSTOCK",
    "dropdeladd": "310 ROUTE 169",
    "dropdelcty": "SOUTH WOODSTOCK",
    "dropdelst": "CT",
    "dropdelzpp": "062679997",
    "dropphyadd": "310 ROUTE 169",
    "dropphycty": "SOUTH WOODSTOCK",
    "dropphyst": "CT",
    "dropphyzpp": "062679997",
    "dropmaladd": "310 ROUTE 169",
    "dropmalcty": "SOUTH WOODSTOCK",
    "dropmalst": "CT",
    "dropmalzpp": "062679997",
    "dropsitphn": 8609287508,
    "dropsitlph": 8609287508,
    "dropsitcph": 8609287508,
    "dropfax": 8609287508
  },
  {
    "dcode": "D",
    "dropkey": "PV20634",
    "droptype": "D",
    "dropname": "SOUTHBURY",
    "dropdeladd": "710 MAIN ST S",
    "dropdelcty": "SOUTHBURY",
    "dropdelst": "CT",
    "dropdelzpp": "064889998",
    "dropphyadd": "710 MAIN ST S",
    "dropphycty": "SOUTHBURY",
    "dropphyst": "CT",
    "dropphyzpp": "064889998",
    "dropmaladd": "710 MAIN ST S",
    "dropmalcty": "SOUTHBURY",
    "dropmalst": "CT",
    "dropmalzpp": "064889998",
    "dropsitphn": 8602642779,
    "dropsitlph": 2032642779,
    "dropsitcph": 2032642779,
    "dropfax": 2032642044
  },
  {
    "dcode": "D",
    "dropkey": "PV20636",
    "droptype": "D",
    "dropname": "SOUTHINGTON",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "SOUTHINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "064899998",
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "SOUTHINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "064899998",
    "dropmaladd": "125 MAIN ST",
    "dropmalcty": "SOUTHINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "064899998",
    "dropsitphn": 8606284766,
    "dropsitlph": 8606284766,
    "dropsitcph": 8606284766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20637",
    "droptype": "D",
    "dropname": "SOUTHPORT",
    "dropdeladd": "402 PEQUOT AVE",
    "dropdelcty": "SOUTHPORT",
    "dropdelst": "CT",
    "dropdelzpp": "068909998",
    "dropphyadd": "402 PEQUOT AVE",
    "dropphycty": "SOUTHPORT",
    "dropphyst": "CT",
    "dropphyzpp": "068909998",
    "dropmaladd": "402 PEQUOT AVE",
    "dropmalcty": "SOUTHPORT",
    "dropmalst": "CT",
    "dropmalzpp": "068909998",
    "dropsitphn": 2032592877,
    "dropsitlph": 2032592877,
    "dropsitcph": 2032592877,
    "dropfax": 2032592570
  },
  {
    "dcode": "D",
    "dropkey": "PV20662",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "216 EAST ST",
    "dropdelcty": "STAFFORD",
    "dropdelst": "CT",
    "dropdelzpp": "060759997",
    "dropphyadd": "216 EAST ST",
    "dropphycty": "STAFFORD",
    "dropphyst": "CT",
    "dropphyzpp": "060759997",
    "dropmaladd": "216 EAST ST",
    "dropmalcty": "STAFFORD",
    "dropmalst": "CT",
    "dropmalzpp": "060759997",
    "dropsitphn": 8606847687,
    "dropsitlph": 8606847687,
    "dropsitcph": 8606847687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20666",
    "droptype": "D",
    "dropname": "STAFFORD SPRINGS",
    "dropdeladd": "20 E MAIN ST",
    "dropdelcty": "STAFFORD SPRINGS",
    "dropdelst": "CT",
    "dropdelzpp": "060769998",
    "dropphyadd": "20 E MAIN ST",
    "dropphycty": "STAFFORD SPRINGS",
    "dropphyst": "CT",
    "dropphyzpp": "060769998",
    "dropmaladd": "20 E MAIN ST",
    "dropmalcty": "STAFFORD SPRINGS",
    "dropmalst": "CT",
    "dropmalzpp": "060769998",
    "dropsitphn": 8606842893,
    "dropsitlph": 8606842893,
    "dropsitcph": 8606842893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20667",
    "droptype": "D",
    "dropname": "STAFFORDVILLE",
    "dropdeladd": "7 LYONS RD",
    "dropdelcty": "STAFFORDVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060771402",
    "dropphyadd": "7 LYONS RD",
    "dropphycty": "STAFFORDVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060771402",
    "dropmaladd": "7 LYONS RD",
    "dropmalcty": "STAFFORDVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060771402",
    "dropsitphn": 8606844310,
    "dropsitlph": 8606844310,
    "dropsitcph": 8606844310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20671",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "24 CAMP AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069079998",
    "dropphyadd": "24 CAMP AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069079998",
    "dropmaladd": "24 CAMP AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069079998",
    "dropsitphn": 2033262037,
    "dropsitlph": 2033262037,
    "dropsitcph": 2033262037,
    "dropfax": 2033262153
  },
  {
    "dcode": "D",
    "dropkey": "PV20675",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "347 STERLING RD",
    "dropdelcty": "STERLING",
    "dropdelst": "CT",
    "dropdelzpp": "063779998",
    "dropphyadd": "347 STERLING RD",
    "dropphycty": "STERLING",
    "dropphyst": "CT",
    "dropphyzpp": "063779998",
    "dropmaladd": "347 STERLING RD",
    "dropmalcty": "STERLING",
    "dropmalst": "CT",
    "dropmalzpp": "063779998",
    "dropsitphn": 8605645737,
    "dropsitlph": 8605645737,
    "dropsitcph": 8605645737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20676",
    "droptype": "D",
    "dropname": "STEVENSON",
    "dropdeladd": "230 ROOSEVELT DR STE 2",
    "dropdelcty": "MONROE",
    "dropdelst": "CT",
    "dropdelzpp": "064682936",
    "dropphyadd": "230 ROOSEVELT DR STE 2",
    "dropphycty": "MONROE",
    "dropphyst": "CT",
    "dropphyzpp": "064682936",
    "dropmaladd": "230 ROOSEVELT DR STE 2",
    "dropmalcty": "MONROE",
    "dropmalst": "CT",
    "dropmalzpp": "064682936",
    "dropsitphn": 8602685254,
    "dropsitlph": 2032685254,
    "dropsitcph": 2032685254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20680",
    "droptype": "D",
    "dropname": "STONINGTON",
    "dropdeladd": "20 BROAD ST",
    "dropdelcty": "STONINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "063789998",
    "dropphyadd": "20 BROAD ST",
    "dropphycty": "STONINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "063789998",
    "dropmaladd": "20 BROAD ST",
    "dropmalcty": "STONINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "063789998",
    "dropsitphn": 8605350454,
    "dropsitlph": 8605350454,
    "dropsitcph": 8605350454,
    "dropfax": 8605354520
  },
  {
    "dcode": "D",
    "dropkey": "PV20683",
    "droptype": "D",
    "dropname": "STORRS MANSFIELD",
    "dropdeladd": "9 CHARLES SMITH WAY",
    "dropdelcty": "STORRS MANSFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "062689998",
    "dropphyadd": "9 CHARLES SMITH WAY",
    "dropphycty": "STORRS MANSFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "062689998",
    "dropmaladd": "9 CHARLES SMITH WAY",
    "dropmalcty": "STORRS MANSFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "062689998",
    "dropsitphn": 8604299681,
    "dropsitlph": 8604299681,
    "dropsitcph": 8604299681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20690",
    "droptype": "D",
    "dropname": "SUFFIELD",
    "dropdeladd": "235 MOUNTAIN RD",
    "dropdelcty": "SUFFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "060789998",
    "dropphyadd": "235 MOUNTAIN RD",
    "dropphycty": "SUFFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "060789998",
    "dropmaladd": "235 MOUNTAIN RD",
    "dropmalcty": "SUFFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "060789998",
    "dropsitphn": 8606682959,
    "dropsitlph": 8606682959,
    "dropsitcph": 8606682959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20692",
    "droptype": "D",
    "dropname": "TACONIC",
    "dropdeladd": "557 TWIN LAKES RD",
    "dropdelcty": "TACONIC",
    "dropdelst": "CT",
    "dropdelzpp": "060799995",
    "dropphyadd": "557 TWIN LAKES RD",
    "dropphycty": "TACONIC",
    "dropphyst": "CT",
    "dropphyzpp": "060799995",
    "dropmaladd": "557 TWIN LAKES RD",
    "dropmalcty": "TACONIC",
    "dropmalst": "CT",
    "dropmalzpp": "060799995",
    "dropsitphn": 8604350193,
    "dropsitlph": 8604350193,
    "dropsitcph": 8604350193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20693",
    "droptype": "D",
    "dropname": "TAFTVILLE",
    "dropdeladd": "72 S B ST",
    "dropdelcty": "TAFTVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "063809998",
    "dropphyadd": "72 S B ST",
    "dropphycty": "TAFTVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "063809998",
    "dropmaladd": "72 S B ST",
    "dropmalcty": "TAFTVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "063809998",
    "dropsitphn": 8608236226,
    "dropsitlph": 8608236226,
    "dropsitcph": 8608236226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20704",
    "droptype": "D",
    "dropname": "TERRYVILLE",
    "dropdeladd": "19 N RIVERSIDE AVE",
    "dropdelcty": "TERRYVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "067869998",
    "dropphyadd": "19 N RIVERSIDE AVE",
    "dropphycty": "TERRYVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "067869998",
    "dropmaladd": "19 N RIVERSIDE AVE",
    "dropmalcty": "TERRYVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "067869998",
    "dropsitphn": 8605823215,
    "dropsitlph": 8605823215,
    "dropsitcph": 8605823215,
    "dropfax": 8605246082
  },
  {
    "dcode": "D",
    "dropkey": "PV20708",
    "droptype": "D",
    "dropname": "THOMASTON",
    "dropdeladd": "150 MAIN ST",
    "dropdelcty": "THOMASTON",
    "dropdelst": "CT",
    "dropdelzpp": "067879998",
    "dropphyadd": "150 MAIN ST",
    "dropphycty": "THOMASTON",
    "dropphyst": "CT",
    "dropphyzpp": "067879998",
    "dropmaladd": "150 MAIN ST",
    "dropmalcty": "THOMASTON",
    "dropmalst": "CT",
    "dropmalzpp": "067879998",
    "dropsitphn": 8602834664,
    "dropsitlph": 8602834664,
    "dropsitcph": 8602834664,
    "dropfax": 8602833073
  },
  {
    "dcode": "D",
    "dropkey": "PV20712",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "366 THOMPSON HILL RD",
    "dropdelcty": "THOMPSON",
    "dropdelst": "CT",
    "dropdelzpp": "062779998",
    "dropphyadd": "366 THOMPSON HILL RD",
    "dropphycty": "THOMPSON",
    "dropphyst": "CT",
    "dropphyzpp": "062779998",
    "dropmaladd": "366 THOMPSON HILL RD",
    "dropmalcty": "THOMPSON",
    "dropmalst": "CT",
    "dropmalzpp": "062779998",
    "dropsitphn": 8609239130,
    "dropsitlph": 8609239130,
    "dropsitcph": 8609239130,
    "dropfax": 8609239690
  },
  {
    "dcode": "D",
    "dropkey": "PV20715",
    "droptype": "D",
    "dropname": "TOLLAND",
    "dropdeladd": "658 TOLLAND STAGE RD",
    "dropdelcty": "TOLLAND",
    "dropdelst": "CT",
    "dropdelzpp": "060849998",
    "dropphyadd": "658 TOLLAND STAGE RD",
    "dropphycty": "TOLLAND",
    "dropphyst": "CT",
    "dropphyzpp": "060849998",
    "dropmaladd": "658 TOLLAND STAGE RD",
    "dropmalcty": "TOLLAND",
    "dropmalst": "CT",
    "dropmalzpp": "060849998",
    "dropsitphn": 8608751364,
    "dropsitlph": 8608751364,
    "dropsitcph": 8608751364,
    "dropfax": 8608753928
  },
  {
    "dcode": "D",
    "dropkey": "PV20716",
    "droptype": "D",
    "dropname": "TORRINGTON",
    "dropdeladd": "185 E ELM ST",
    "dropdelcty": "TORRINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "067909998",
    "dropphyadd": "185 E ELM ST",
    "dropphycty": "TORRINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "067909998",
    "dropmaladd": "185 E ELM ST",
    "dropmalcty": "TORRINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "067909998",
    "dropsitphn": 8604890438,
    "dropsitlph": 8604890438,
    "dropsitcph": 8604890438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20727",
    "droptype": "D",
    "dropname": "UNCASVILLE",
    "dropdeladd": "1587 NORWICH NEW LONDON TPKE",
    "dropdelcty": "UNCASVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "063829998",
    "dropphyadd": "1587 NORWICH NEW LONDON TPKE",
    "dropphycty": "UNCASVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "063829998",
    "dropmaladd": "1587 NORWICH NEW LONDON TPKE",
    "dropmalcty": "UNCASVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "063829998",
    "dropsitphn": 8608488454,
    "dropsitlph": 8608488454,
    "dropsitcph": 8608488454,
    "dropfax": 8603672047
  },
  {
    "dcode": "D",
    "dropkey": "PV20733",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "24 MILL ST",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060859998",
    "dropphyadd": "24 MILL ST",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060859998",
    "dropmaladd": "715 GEORGE WASHINGTON TPKE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "060139992",
    "dropsitphn": 8606732004,
    "dropsitlph": 8606732004,
    "dropsitcph": 8606732004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20746",
    "droptype": "D",
    "dropname": "VERNON ROCKVILLE",
    "dropdeladd": "141 UNION ST",
    "dropdelcty": "VERNON ROCKVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060669998",
    "dropphyadd": "141 UNION ST",
    "dropphycty": "VERNON ROCKVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060669998",
    "dropmaladd": "141 UNION ST",
    "dropmalcty": "VERNON ROCKVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060669998",
    "dropsitphn": 8608727311,
    "dropsitlph": 8608727311,
    "dropsitcph": 8608727311,
    "dropfax": 8608753173
  },
  {
    "dcode": "D",
    "dropkey": "PV20748",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "35 MAIN ST STE 2",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "CT",
    "dropdelzpp": "063839992",
    "dropphyadd": "35 MAIN ST STE 2",
    "dropphycty": "VERSAILLES",
    "dropphyst": "CT",
    "dropphyzpp": "063839992",
    "dropmaladd": "35 MAIN ST STE 2",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "CT",
    "dropmalzpp": "063839992",
    "dropsitphn": 8608226124,
    "dropsitlph": 8608226124,
    "dropsitcph": 8608226124,
    "dropfax": 8608226124
  },
  {
    "dcode": "D",
    "dropkey": "PV20749",
    "droptype": "D",
    "dropname": "VOLUNTOWN",
    "dropdeladd": "42 CHURCH ST",
    "dropdelcty": "VOLUNTOWN",
    "dropdelst": "CT",
    "dropdelzpp": "063849998",
    "dropphyadd": "42 CHURCH ST",
    "dropphycty": "VOLUNTOWN",
    "dropphyst": "CT",
    "dropphyzpp": "063849998",
    "dropmaladd": "42 CHURCH ST",
    "dropmalcty": "VOLUNTOWN",
    "dropmalst": "CT",
    "dropmalzpp": "063849998",
    "dropsitphn": 8603760558,
    "dropsitlph": 8603760558,
    "dropsitcph": 8603760558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20763",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "4 S MAIN ST",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929998",
    "dropphyadd": "4 S MAIN ST",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929998",
    "dropmaladd": "4 S MAIN ST",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929998",
    "dropsitphn": 2032698712,
    "dropsitlph": 2032698712,
    "dropsitcph": 2032698712,
    "dropfax": 2039491182
  },
  {
    "dcode": "D",
    "dropkey": "PV20779",
    "droptype": "D",
    "dropname": "WASHINGTON DEPOT",
    "dropdeladd": "9 BRYAN HALL PLZ",
    "dropdelcty": "WASHINGTON DEPOT",
    "dropdelst": "CT",
    "dropdelzpp": "067949998",
    "dropphyadd": "9 BRYAN HALL PLZ",
    "dropphycty": "WASHINGTON DEPOT",
    "dropphyst": "CT",
    "dropphyzpp": "067949998",
    "dropmaladd": "9 BRYAN HALL PLZ",
    "dropmalcty": "WASHINGTON DEPOT",
    "dropmalst": "CT",
    "dropmalzpp": "067949998",
    "dropsitphn": 8608687474,
    "dropsitlph": 8608687474,
    "dropsitcph": 8608687474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20785",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "222 BOSTON POST RD",
    "dropdelcty": "WATERFORD",
    "dropdelst": "CT",
    "dropdelzpp": "063859998",
    "dropphyadd": "222 BOSTON POST RD",
    "dropphycty": "WATERFORD",
    "dropphyst": "CT",
    "dropphyzpp": "063859998",
    "dropmaladd": "222 BOSTON POST RD",
    "dropmalcty": "WATERFORD",
    "dropmalst": "CT",
    "dropmalzpp": "063859998",
    "dropsitphn": 8604438407,
    "dropsitlph": 8604438407,
    "dropsitcph": 8604438407,
    "dropfax": 8604433307
  },
  {
    "dcode": "D",
    "dropkey": "PV20787",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "30 WOODRUFF AVE",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "CT",
    "dropdelzpp": "067959998",
    "dropphyadd": "30 WOODRUFF AVE",
    "dropphycty": "WATERTOWN",
    "dropphyst": "CT",
    "dropphyzpp": "067959998",
    "dropmaladd": "30 WOODRUFF AVE",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "CT",
    "dropmalzpp": "067959998",
    "dropsitphn": 8602742900,
    "dropsitlph": 8602742900,
    "dropsitcph": 8602742900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20789",
    "droptype": "D",
    "dropname": "WAUREGAN",
    "dropdeladd": "60 WAUREGAN RD",
    "dropdelcty": "WAUREGAN",
    "dropdelst": "CT",
    "dropdelzpp": "063879992",
    "dropphyadd": "60 WAUREGAN RD",
    "dropphycty": "WAUREGAN",
    "dropphyst": "CT",
    "dropphyzpp": "063879992",
    "dropmaladd": "60 WAUREGAN RD",
    "dropmalcty": "WAUREGAN",
    "dropmalst": "CT",
    "dropmalzpp": "063879992",
    "dropsitphn": 8607744125,
    "dropsitlph": 8607744125,
    "dropsitcph": 8607744125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20791",
    "droptype": "D",
    "dropname": "WEATOGUE",
    "dropdeladd": "372 HOPMEADOW ST",
    "dropdelcty": "WEATOGUE",
    "dropdelst": "CT",
    "dropdelzpp": "060899998",
    "dropphyadd": "372 HOPMEADOW ST",
    "dropphycty": "WEATOGUE",
    "dropphyst": "CT",
    "dropphyzpp": "060899998",
    "dropmaladd": "372 HOPMEADOW ST",
    "dropmalcty": "WEATOGUE",
    "dropmalst": "CT",
    "dropmalzpp": "060899998",
    "dropsitphn": 8606583037,
    "dropsitlph": 8606583037,
    "dropsitcph": 8606583037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20796",
    "droptype": "D",
    "dropname": "WEST CORNWALL",
    "dropdeladd": "408 SHARON GOSHEN TPKE",
    "dropdelcty": "WEST CORNWALL",
    "dropdelst": "CT",
    "dropdelzpp": "067969998",
    "dropphyadd": "408 SHARON GOSHEN TPKE",
    "dropphycty": "WEST CORNWALL",
    "dropphyst": "CT",
    "dropphyzpp": "067969998",
    "dropmaladd": "408 SHARON GOSHEN TPKE",
    "dropmalcty": "WEST CORNWALL",
    "dropmalst": "CT",
    "dropmalzpp": "067969998",
    "dropsitphn": 8606726791,
    "dropsitlph": 8606726791,
    "dropsitcph": 8606726791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20798",
    "droptype": "D",
    "dropname": "WEST GRANBY",
    "dropdeladd": "250 W GRANBY RD",
    "dropdelcty": "WEST GRANBY",
    "dropdelst": "CT",
    "dropdelzpp": "060909998",
    "dropphyadd": "250 W GRANBY RD",
    "dropphycty": "WEST GRANBY",
    "dropphyst": "CT",
    "dropphyzpp": "060909998",
    "dropmaladd": "250 W GRANBY RD",
    "dropmalcty": "WEST GRANBY",
    "dropmalst": "CT",
    "dropmalzpp": "060909998",
    "dropsitphn": 8606532648,
    "dropsitlph": 8606532648,
    "dropsitcph": 8606532648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20806",
    "droptype": "D",
    "dropname": "WEST REDDING",
    "dropdeladd": "268 SIMPAUG TPKE",
    "dropdelcty": "REDDING",
    "dropdelst": "CT",
    "dropdelzpp": "068969998",
    "dropphyadd": "268 SIMPAUG TPKE",
    "dropphycty": "REDDING",
    "dropphyst": "CT",
    "dropphyzpp": "068969998",
    "dropmaladd": "268 SIMPAUG TPKE",
    "dropmalcty": "REDDING",
    "dropmalst": "CT",
    "dropmalzpp": "068969998",
    "dropsitphn": 2039382763,
    "dropsitlph": 2039382763,
    "dropsitcph": 2039382763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20807",
    "droptype": "D",
    "dropname": "WEST SIMSBURY",
    "dropdeladd": "239 FARMS VILLAGE RD",
    "dropdelcty": "WEST SIMSBURY",
    "dropdelst": "CT",
    "dropdelzpp": "060929998",
    "dropphyadd": "239 FARMS VILLAGE RD",
    "dropphycty": "WEST SIMSBURY",
    "dropphyst": "CT",
    "dropphyzpp": "060929998",
    "dropmaladd": "239 FARMS VILLAGE RD",
    "dropmalcty": "WEST SIMSBURY",
    "dropmalst": "CT",
    "dropmalzpp": "060929998",
    "dropsitphn": 8606583036,
    "dropsitlph": 8605246158,
    "dropsitcph": 8606583036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20809",
    "droptype": "D",
    "dropname": "WEST SUFFIELD",
    "dropdeladd": "1361 MOUNTAIN RD",
    "dropdelcty": "WEST SUFFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "060939992",
    "dropphyadd": "1361 MOUNTAIN RD",
    "dropphycty": "WEST SUFFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "060939992",
    "dropmaladd": "1361 MOUNTAIN RD",
    "dropmalcty": "WEST SUFFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "060939992",
    "dropsitphn": 8606687857,
    "dropsitlph": 8606687857,
    "dropsitcph": 8606687857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20811",
    "droptype": "D",
    "dropname": "WILLINGTON",
    "dropdeladd": "11 PHELPS WAY",
    "dropdelcty": "WILLINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "062799998",
    "dropphyadd": "11 PHELPS WAY",
    "dropphycty": "WILLINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "062799998",
    "dropmaladd": "11 PHELPS WAY",
    "dropmalcty": "WILLINGTON",
    "dropmalst": "CT",
    "dropmalzpp": "062799998",
    "dropsitphn": 8604295021,
    "dropsitlph": 8604295021,
    "dropsitcph": 8604295021,
    "dropfax": 8604874383
  },
  {
    "dcode": "D",
    "dropkey": "PV20813",
    "droptype": "D",
    "dropname": "WESTBROOK",
    "dropdeladd": "1411 BOSTON POST RD",
    "dropdelcty": "WESTBROOK",
    "dropdelst": "CT",
    "dropdelzpp": "064989998",
    "dropphyadd": "1411 BOSTON POST RD",
    "dropphycty": "WESTBROOK",
    "dropphyst": "CT",
    "dropphyzpp": "064989998",
    "dropmaladd": "1411 BOSTON POST RD",
    "dropmalcty": "WESTBROOK",
    "dropmalst": "CT",
    "dropmalzpp": "064989998",
    "dropsitphn": 8603996293,
    "dropsitlph": 8603996293,
    "dropsitcph": 8603996293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20815",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "275 POST RD E STE 10",
    "dropdelcty": "WESTPORT",
    "dropdelst": "CT",
    "dropdelzpp": "068809998",
    "dropphyadd": "275 POST RD E STE 10",
    "dropphycty": "WESTPORT",
    "dropphyst": "CT",
    "dropphyzpp": "068809998",
    "dropmaladd": "275 POST RD E STE 10",
    "dropmalcty": "WESTPORT",
    "dropmalst": "CT",
    "dropmalzpp": "068809998",
    "dropsitphn": 2032290480,
    "dropsitlph": 2032290480,
    "dropsitcph": 2032290480,
    "dropfax": 2032290403
  },
  {
    "dcode": "D",
    "dropkey": "PV20825",
    "droptype": "D",
    "dropname": "WILLIMANTIC",
    "dropdeladd": "919 MAIN ST",
    "dropdelcty": "WILLIMANTIC",
    "dropdelst": "CT",
    "dropdelzpp": "062269998",
    "dropphyadd": "919 MAIN ST",
    "dropphycty": "WILLIMANTIC",
    "dropphyst": "CT",
    "dropphyzpp": "062269998",
    "dropmaladd": "919 MAIN ST",
    "dropmalcty": "WILLIMANTIC",
    "dropmalst": "CT",
    "dropmalzpp": "062269998",
    "dropsitphn": 8604564270,
    "dropsitlph": 8604564270,
    "dropsitcph": 8604564270,
    "dropfax": 8604501762
  },
  {
    "dcode": "D",
    "dropkey": "PV20830",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "15 HUBBARD RD",
    "dropdelcty": "WILTON",
    "dropdelst": "CT",
    "dropdelzpp": "068979998",
    "dropphyadd": "15 HUBBARD RD",
    "dropphycty": "WILTON",
    "dropphyst": "CT",
    "dropphyzpp": "068979998",
    "dropmaladd": "15 HUBBARD RD",
    "dropmalcty": "WILTON",
    "dropmalst": "CT",
    "dropmalzpp": "068979998",
    "dropsitphn": 2037625555,
    "dropsitlph": 2037625555,
    "dropsitcph": 2037625555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20836",
    "droptype": "D",
    "dropname": "WINDHAM",
    "dropdeladd": "6 SCOTLAND RD",
    "dropdelcty": "WINDHAM",
    "dropdelst": "CT",
    "dropdelzpp": "062809998",
    "dropphyadd": "6 SCOTLAND RD",
    "dropphycty": "WINDHAM",
    "dropphyst": "CT",
    "dropphyzpp": "062809998",
    "dropmaladd": "6 SCOTLAND RD",
    "dropmalcty": "WINDHAM",
    "dropmalst": "CT",
    "dropmalzpp": "062809998",
    "dropsitphn": 8604507106,
    "dropsitlph": 8604507106,
    "dropsitcph": 8604507106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20837",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "245 BROAD ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "CT",
    "dropdelzpp": "060959998",
    "dropphyadd": "245 BROAD ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "CT",
    "dropphyzpp": "060959998",
    "dropmaladd": "245 BROAD ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "CT",
    "dropmalzpp": "060959998",
    "dropsitphn": 8606885259,
    "dropsitlph": 8606885259,
    "dropsitcph": 8606885259,
    "dropfax": 8606880610
  },
  {
    "dcode": "D",
    "dropkey": "PV20839",
    "droptype": "D",
    "dropname": "WINDSOR LOCKS",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "WINDSOR LOCKS",
    "dropdelst": "CT",
    "dropdelzpp": "060969998",
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "WINDSOR LOCKS",
    "dropphyst": "CT",
    "dropphyzpp": "060969998",
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "WINDSOR LOCKS",
    "dropmalst": "CT",
    "dropmalzpp": "060969998",
    "dropsitphn": 8606233897,
    "dropsitlph": 8606233897,
    "dropsitcph": 8606233897,
    "dropfax": 8602928630
  },
  {
    "dcode": "D",
    "dropkey": "PV20841",
    "droptype": "D",
    "dropname": "WINSTED",
    "dropdeladd": "328 MAIN ST",
    "dropdelcty": "WINSTED",
    "dropdelst": "CT",
    "dropdelzpp": "060989998",
    "dropphyadd": "328 MAIN ST",
    "dropphycty": "WINSTED",
    "dropphyst": "CT",
    "dropphyzpp": "060989998",
    "dropmaladd": "328 MAIN ST",
    "dropmalcty": "WINSTED",
    "dropmalst": "CT",
    "dropmalzpp": "060989998",
    "dropsitphn": 8603796675,
    "dropsitlph": 8603796675,
    "dropsitcph": 8603796675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV20844",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "1 WASHINGTON AVE",
    "dropdelcty": "WOODBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067989998",
    "dropphyadd": "1 WASHINGTON AVE",
    "dropphycty": "WOODBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067989998",
    "dropmaladd": "1 WASHINGTON AVE",
    "dropmalcty": "WOODBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067989998",
    "dropsitphn": 2032633507,
    "dropsitlph": 2032633507,
    "dropsitcph": 2032633507,
    "dropfax": 2032637876
  },
  {
    "dcode": "D",
    "dropkey": "PV20849",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "679 ROUTE 169",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "CT",
    "dropdelzpp": "062819998",
    "dropphyadd": "679 ROUTE 169",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "CT",
    "dropphyzpp": "062819998",
    "dropmaladd": "679 ROUTE 169",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "CT",
    "dropmalzpp": "062819998",
    "dropsitphn": 8609635341,
    "dropsitlph": 8609635341,
    "dropsitcph": 8609635341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21178",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189997,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189997,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361972,
    "dropsitcph": 2026361259,
    "dropfax": 2026361212
  },
  {
    "dcode": "D",
    "dropkey": "PV21192",
    "droptype": "D",
    "dropname": "BEAR",
    "dropdeladd": "125 RICKEY BLVD",
    "dropdelcty": "BEAR",
    "dropdelst": "DE",
    "dropdelzpp": 197019998,
    "dropphyadd": "125 RICKEY BLVD",
    "dropphycty": "BEAR",
    "dropphyst": "DE",
    "dropphyzpp": 197019998,
    "dropmaladd": "125 RICKEY BLVD",
    "dropmalcty": "BEAR",
    "dropmalst": "DE",
    "dropmalzpp": 197019998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028385006,
    "dropfax": 3028382461
  },
  {
    "dcode": "D",
    "dropkey": "PV21197",
    "droptype": "D",
    "dropname": "BETHANY BEACH",
    "dropdeladd": "14 N PENNSYLVANIA AVE",
    "dropdelcty": "BETHANY BEACH",
    "dropdelst": "DE",
    "dropdelzpp": 199309998,
    "dropphyadd": "14 N PENNSYLVANIA AVE",
    "dropphycty": "BETHANY BEACH",
    "dropphyst": "DE",
    "dropphyzpp": 199309998,
    "dropmaladd": "14 N PENNSYLVANIA AVE",
    "dropmalcty": "BETHANY BEACH",
    "dropmalst": "DE",
    "dropmalzpp": 199309998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3025399874,
    "dropfax": 3025375100
  },
  {
    "dcode": "D",
    "dropkey": "PV21198",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "7748 MAIN ST",
    "dropdelcty": "BETHEL",
    "dropdelst": "DE",
    "dropdelzpp": 199319998,
    "dropphyadd": "7748 MAIN ST",
    "dropphycty": "BETHEL",
    "dropphyst": "DE",
    "dropphyzpp": 199319998,
    "dropmaladd": "7748 MAIN ST",
    "dropmalcty": "BETHEL",
    "dropmalst": "DE",
    "dropmalzpp": 199319998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028754461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21212",
    "droptype": "D",
    "dropname": "BRIDGEVILLE",
    "dropdeladd": "300 WALNUT ST",
    "dropdelcty": "BRIDGEVILLE",
    "dropdelst": "DE",
    "dropdelzpp": 199339998,
    "dropphyadd": "300 WALNUT ST",
    "dropphycty": "BRIDGEVILLE",
    "dropphyst": "DE",
    "dropphyzpp": 199339998,
    "dropmaladd": "300 WALNUT ST",
    "dropmalcty": "BRIDGEVILLE",
    "dropmalst": "DE",
    "dropmalzpp": 199339998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023377354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21218",
    "droptype": "D",
    "dropname": "CAMDEN WYOMING",
    "dropdeladd": "2 OLD NORTH RD",
    "dropdelcty": "CAMDEN WYOMING",
    "dropdelst": "DE",
    "dropdelzpp": 199349998,
    "dropphyadd": "2 OLD NORTH RD",
    "dropphycty": "CAMDEN WYOMING",
    "dropphyst": "DE",
    "dropphyzpp": 199349998,
    "dropmaladd": "2 OLD NORTH RD",
    "dropmalcty": "CAMDEN WYOMING",
    "dropmalst": "DE",
    "dropmalzpp": 199349998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026972694,
    "dropfax": 3026976143
  },
  {
    "dcode": "D",
    "dropkey": "PV21228",
    "droptype": "D",
    "dropname": "CHESWOLD",
    "dropdeladd": "262 E MAIN ST",
    "dropdelcty": "CHESWOLD",
    "dropdelst": "DE",
    "dropdelzpp": 199369998,
    "dropphyadd": "262 E MAIN ST",
    "dropphycty": "CHESWOLD",
    "dropphyst": "DE",
    "dropphyzpp": 199369998,
    "dropmaladd": "262 E MAIN ST",
    "dropmalcty": "CHESWOLD",
    "dropmalst": "DE",
    "dropmalzpp": 199369998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026781876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21234",
    "droptype": "D",
    "dropname": "CLAYMONT",
    "dropdeladd": "3430 PHILADELPHIA PIKE",
    "dropdelcty": "CLAYMONT",
    "dropdelst": "DE",
    "dropdelzpp": 197039998,
    "dropphyadd": "3430 PHILADELPHIA PIKE",
    "dropphycty": "CLAYMONT",
    "dropphyst": "DE",
    "dropphyzpp": 197039998,
    "dropmaladd": "3430 PHILADELPHIA PIKE",
    "dropmalcty": "CLAYMONT",
    "dropmalst": "DE",
    "dropmalzpp": 197039998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027986671,
    "dropfax": 3027985041
  },
  {
    "dcode": "D",
    "dropkey": "PV21235",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "12 RAILROAD AVE",
    "dropdelcty": "CLAYTON",
    "dropdelst": "DE",
    "dropdelzpp": 199389998,
    "dropphyadd": "12 RAILROAD AVE",
    "dropphycty": "CLAYTON",
    "dropphyst": "DE",
    "dropphyzpp": 199389998,
    "dropmaladd": "12 RAILROAD AVE",
    "dropmalcty": "CLAYTON",
    "dropmalst": "DE",
    "dropmalzpp": 199389998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026537376,
    "dropfax": 3026593739
  },
  {
    "dcode": "D",
    "dropkey": "PV21238",
    "droptype": "D",
    "dropname": "DAGSBORO",
    "dropdeladd": "28290 CLAYTON ST",
    "dropdelcty": "DAGSBORO",
    "dropdelst": "DE",
    "dropdelzpp": 199399998,
    "dropphyadd": "28290 CLAYTON ST",
    "dropphycty": "DAGSBORO",
    "dropphyst": "DE",
    "dropphyzpp": 199399998,
    "dropmaladd": "28290 CLAYTON ST",
    "dropmalcty": "DAGSBORO",
    "dropmalst": "DE",
    "dropmalzpp": 199399998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027329404,
    "dropfax": 3027320165
  },
  {
    "dcode": "D",
    "dropkey": "PV21240",
    "droptype": "D",
    "dropname": "DELAWARE CITY",
    "dropdeladd": "54 CLINTON ST",
    "dropdelcty": "DELAWARE CITY",
    "dropdelst": "DE",
    "dropdelzpp": 197069998,
    "dropphyadd": "54 CLINTON ST",
    "dropphycty": "DELAWARE CITY",
    "dropphyst": "DE",
    "dropphyzpp": 197069998,
    "dropmaladd": "54 CLINTON ST",
    "dropmalcty": "DELAWARE CITY",
    "dropmalst": "DE",
    "dropmalzpp": 197069998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028344716,
    "dropfax": 3028340754
  },
  {
    "dcode": "D",
    "dropkey": "PV21242",
    "droptype": "D",
    "dropname": "DELMAR",
    "dropdeladd": "101 E GROVE ST",
    "dropdelcty": "DELMAR",
    "dropdelst": "DE",
    "dropdelzpp": 199409998,
    "dropphyadd": "101 E GROVE ST",
    "dropphycty": "DELMAR",
    "dropphyst": "DE",
    "dropphyzpp": 199409998,
    "dropmaladd": "101 E GROVE ST",
    "dropmalcty": "DELMAR",
    "dropmalst": "DE",
    "dropmalzpp": 199409998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028463170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21248",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "445 BANK LN",
    "dropdelcty": "DOVER",
    "dropdelst": "DE",
    "dropdelzpp": 199049997,
    "dropphyadd": "445 BANK LN",
    "dropphycty": "DOVER",
    "dropphyst": "DE",
    "dropphyzpp": 199049997,
    "dropmaladd": "445 BANK LN",
    "dropmalcty": "DOVER",
    "dropmalst": "DE",
    "dropmalzpp": 199049997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027345822,
    "dropfax": 3027343624
  },
  {
    "dcode": "D",
    "dropkey": "PV21257",
    "droptype": "D",
    "dropname": "ELLENDALE",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "ELLENDALE",
    "dropdelst": "DE",
    "dropdelzpp": 199419998,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "ELLENDALE",
    "dropphyst": "DE",
    "dropphyzpp": 199419998,
    "dropmaladd": "508 MAIN ST",
    "dropmalcty": "ELLENDALE",
    "dropmalst": "DE",
    "dropmalzpp": 199419998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024224900,
    "dropfax": 3024229201
  },
  {
    "dcode": "D",
    "dropkey": "PV21268",
    "droptype": "D",
    "dropname": "FELTON",
    "dropdeladd": "1 W SEWELL ST",
    "dropdelcty": "FELTON",
    "dropdelst": "DE",
    "dropdelzpp": 199439998,
    "dropphyadd": "1 W SEWELL ST",
    "dropphycty": "FELTON",
    "dropphyst": "DE",
    "dropphyzpp": 199439998,
    "dropmaladd": "1 W SEWELL ST",
    "dropmalcty": "FELTON",
    "dropmalst": "DE",
    "dropmalzpp": 199439998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3022849826,
    "dropfax": 3022842031
  },
  {
    "dcode": "D",
    "dropkey": "PV21273",
    "droptype": "D",
    "dropname": "FRANKFORD",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "FRANKFORD",
    "dropdelst": "DE",
    "dropdelzpp": 199459998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "FRANKFORD",
    "dropphyst": "DE",
    "dropphyzpp": 199459998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "FRANKFORD",
    "dropmalst": "DE",
    "dropmalzpp": 199459998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027326891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21275",
    "droptype": "D",
    "dropname": "FREDERICA",
    "dropdeladd": "128 W FRONT ST",
    "dropdelcty": "FREDERICA",
    "dropdelst": "DE",
    "dropdelzpp": 199469998,
    "dropphyadd": "128 W FRONT ST",
    "dropphycty": "FREDERICA",
    "dropphyst": "DE",
    "dropphyzpp": 199469998,
    "dropmaladd": "128 W FRONT ST",
    "dropmalcty": "FREDERICA",
    "dropmalst": "DE",
    "dropmalzpp": 199469998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023355524,
    "dropfax": 3023353172
  },
  {
    "dcode": "D",
    "dropkey": "PV21277",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "115 S KING ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "DE",
    "dropdelzpp": 199479998,
    "dropphyadd": "115 S KING ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "DE",
    "dropphyzpp": 199479998,
    "dropmaladd": "115 S KING ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "DE",
    "dropmalzpp": 199479998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028563647,
    "dropfax": 3028563475
  },
  {
    "dcode": "D",
    "dropkey": "PV21285",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "2 E MARKET ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "DE",
    "dropdelzpp": 199509998,
    "dropphyadd": "2 E MARKET ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "DE",
    "dropphyzpp": 199509998,
    "dropmaladd": "2 E MARKET ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "DE",
    "dropmalzpp": 199509998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023494006,
    "dropfax": 3023494955
  },
  {
    "dcode": "D",
    "dropkey": "PV21287",
    "droptype": "D",
    "dropname": "HARBESON",
    "dropdeladd": "18865 HARBESON RD",
    "dropdelcty": "HARBESON",
    "dropdelst": "DE",
    "dropdelzpp": 199519997,
    "dropphyadd": "18865 HARBESON RD",
    "dropphycty": "HARBESON",
    "dropphyst": "DE",
    "dropphyzpp": 199519997,
    "dropmaladd": "18865 HARBESON RD",
    "dropmalcty": "HARBESON",
    "dropmalst": "DE",
    "dropmalzpp": 199519997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026843158,
    "dropfax": 3026843159
  },
  {
    "dcode": "D",
    "dropkey": "PV21289",
    "droptype": "D",
    "dropname": "HARRINGTON",
    "dropdeladd": "2 COMMERCE ST",
    "dropdelcty": "HARRINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 199529998,
    "dropphyadd": "2 COMMERCE ST",
    "dropphycty": "HARRINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 199529998,
    "dropmaladd": "2 COMMERCE ST",
    "dropmalcty": "HARRINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 199529998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023983577,
    "dropfax": 3023989368
  },
  {
    "dcode": "D",
    "dropkey": "PV21291",
    "droptype": "D",
    "dropname": "HARTLY",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "HARTLY",
    "dropdelst": "DE",
    "dropdelzpp": 199539998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "HARTLY",
    "dropphyst": "DE",
    "dropphyzpp": 199539998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "HARTLY",
    "dropmalst": "DE",
    "dropmalzpp": 199539998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024923410,
    "dropfax": 3024923410
  },
  {
    "dcode": "D",
    "dropkey": "PV21294",
    "droptype": "D",
    "dropname": "HOCKESSIN",
    "dropdeladd": "651 VALLEY RD",
    "dropdelcty": "HOCKESSIN",
    "dropdelst": "DE",
    "dropdelzpp": 197079998,
    "dropphyadd": "651 VALLEY RD",
    "dropphycty": "HOCKESSIN",
    "dropphyst": "DE",
    "dropphyzpp": 197079998,
    "dropmaladd": "651 VALLEY RD",
    "dropmalcty": "HOCKESSIN",
    "dropmalst": "DE",
    "dropmalzpp": 197079998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3022394240,
    "dropfax": 3026352038
  },
  {
    "dcode": "D",
    "dropkey": "PV21297",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "156 BROAD ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "DE",
    "dropdelzpp": 199549998,
    "dropphyadd": "156 BROAD ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "DE",
    "dropphyzpp": 199549998,
    "dropmaladd": "156 BROAD ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "DE",
    "dropmalzpp": 199549998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024226154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21300",
    "droptype": "D",
    "dropname": "KENTON",
    "dropdeladd": "24 FRAZIER ST",
    "dropdelcty": "KENTON",
    "dropdelst": "DE",
    "dropdelzpp": 199559998,
    "dropphyadd": "24 FRAZIER ST",
    "dropphycty": "KENTON",
    "dropphyst": "DE",
    "dropphyzpp": 199559998,
    "dropmaladd": "24 FRAZIER ST",
    "dropmalcty": "KENTON",
    "dropmalst": "DE",
    "dropmalzpp": 199559998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026532317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21301",
    "droptype": "D",
    "dropname": "KIRKWOOD",
    "dropdeladd": "2501 RED LION RD",
    "dropdelcty": "KIRKWOOD",
    "dropdelst": "DE",
    "dropdelzpp": 197089998,
    "dropphyadd": "2501 RED LION RD",
    "dropphycty": "KIRKWOOD",
    "dropphyst": "DE",
    "dropphyzpp": 197089998,
    "dropmaladd": "2501 RED LION RD",
    "dropmalcty": "KIRKWOOD",
    "dropmalst": "DE",
    "dropmalzpp": 197089998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028349487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21303",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "1121 S CENTRAL AVE",
    "dropdelcty": "LAUREL",
    "dropdelst": "DE",
    "dropdelzpp": 199569998,
    "dropphyadd": "1121 S CENTRAL AVE",
    "dropphycty": "LAUREL",
    "dropphyst": "DE",
    "dropphyzpp": 199569998,
    "dropmaladd": "1121 S CENTRAL AVE",
    "dropmalcty": "LAUREL",
    "dropmalst": "DE",
    "dropmalzpp": 199569998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028753613,
    "dropfax": 3028759238
  },
  {
    "dcode": "D",
    "dropkey": "PV21304",
    "droptype": "D",
    "dropname": "LEWES",
    "dropdeladd": "116 FRONT ST STE 1",
    "dropdelcty": "LEWES",
    "dropdelst": "DE",
    "dropdelzpp": 199589998,
    "dropphyadd": "116 FRONT ST STE 1",
    "dropphycty": "LEWES",
    "dropphyst": "DE",
    "dropphyzpp": 199589998,
    "dropmaladd": "116 FRONT ST STE 1",
    "dropmalcty": "LEWES",
    "dropmalst": "DE",
    "dropmalzpp": 199589998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026450235,
    "dropfax": 3026440310
  },
  {
    "dcode": "D",
    "dropkey": "PV21307",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "8419 FRONT ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "DE",
    "dropdelzpp": 199609998,
    "dropphyadd": "8419 FRONT ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "DE",
    "dropphyzpp": 199609998,
    "dropmaladd": "8419 FRONT ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "DE",
    "dropmalzpp": 199609998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024225645,
    "dropfax": 3024229058
  },
  {
    "dcode": "D",
    "dropkey": "PV21308",
    "droptype": "D",
    "dropname": "LITTLE CREEK",
    "dropdeladd": "458 MAIN ST",
    "dropdelcty": "LITTLE CREEK",
    "dropdelst": "DE",
    "dropdelzpp": 199619998,
    "dropphyadd": "458 MAIN ST",
    "dropphycty": "LITTLE CREEK",
    "dropphyst": "DE",
    "dropphyzpp": 199619998,
    "dropmaladd": "458 MAIN ST",
    "dropmalcty": "LITTLE CREEK",
    "dropmalst": "DE",
    "dropmalzpp": 199619998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026789347,
    "dropfax": 3026782522
  },
  {
    "dcode": "D",
    "dropkey": "PV21311",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "8 N MAIN ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "DE",
    "dropdelzpp": 199629998,
    "dropphyadd": "8 N MAIN ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "DE",
    "dropphyzpp": 199629998,
    "dropmaladd": "8 N MAIN ST",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "DE",
    "dropmalzpp": 199629998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023353609,
    "dropfax": 3023352795
  },
  {
    "dcode": "D",
    "dropkey": "PV21317",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "298 E MAIN ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "DE",
    "dropdelzpp": 197099998,
    "dropphyadd": "298 E MAIN ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "DE",
    "dropphyzpp": 197099998,
    "dropmaladd": "298 E MAIN ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "DE",
    "dropmalzpp": 197099998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023786241,
    "dropfax": 3023760340
  },
  {
    "dcode": "D",
    "dropkey": "PV21320",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "110 CAUSEY AVE",
    "dropdelcty": "MILFORD",
    "dropdelst": "DE",
    "dropdelzpp": 199639998,
    "dropphyadd": "110 CAUSEY AVE",
    "dropphycty": "MILFORD",
    "dropphyst": "DE",
    "dropphyzpp": 199639998,
    "dropmaladd": "110 CAUSEY AVE",
    "dropmalcty": "MILFORD",
    "dropmalst": "DE",
    "dropmalzpp": 199639998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3024225618,
    "dropsitcph": 3024225618,
    "dropfax": 3024241922
  },
  {
    "dcode": "D",
    "dropkey": "PV21322",
    "droptype": "D",
    "dropname": "MILLSBORO",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MILLSBORO",
    "dropdelst": "DE",
    "dropdelzpp": 199669998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MILLSBORO",
    "dropphyst": "DE",
    "dropphyzpp": 199669998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "MILLSBORO",
    "dropmalst": "DE",
    "dropmalzpp": 199669998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3029349226,
    "dropfax": 3029348492
  },
  {
    "dcode": "D",
    "dropkey": "PV21327",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "219 MILTON ELLENDALE HWY",
    "dropdelcty": "MILTON",
    "dropdelst": "DE",
    "dropdelzpp": 199689998,
    "dropphyadd": "219 MILTON ELLENDALE HWY",
    "dropphycty": "MILTON",
    "dropphyst": "DE",
    "dropphyzpp": 199689998,
    "dropmaladd": "219 MILTON ELLENDALE HWY",
    "dropmalcty": "MILTON",
    "dropmalst": "DE",
    "dropmalzpp": 199689998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026845142,
    "dropfax": 3026840312
  },
  {
    "dcode": "D",
    "dropkey": "PV21329",
    "droptype": "D",
    "dropname": "MONTCHANIN",
    "dropdeladd": "101 STONE BLOCK ROW",
    "dropdelcty": "MONTCHANIN",
    "dropdelst": "DE",
    "dropdelzpp": 197109998,
    "dropphyadd": "101 STONE BLOCK ROW",
    "dropphycty": "MONTCHANIN",
    "dropphyst": "DE",
    "dropphyzpp": 197109998,
    "dropmaladd": "101 STONE BLOCK ROW",
    "dropmalcty": "MONTCHANIN",
    "dropmalst": "DE",
    "dropmalzpp": 197109998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3033233734,
    "dropsitcph": 3026521054,
    "dropfax": 3026525666
  },
  {
    "dcode": "D",
    "dropkey": "PV21332",
    "droptype": "D",
    "dropname": "NASSAU",
    "dropdeladd": "17601 COASTAL HWY UNIT 11",
    "dropdelcty": "NASSAU",
    "dropdelst": "DE",
    "dropdelzpp": 199699998,
    "dropphyadd": "17601 COASTAL HWY UNIT 11",
    "dropphycty": "NASSAU",
    "dropphyst": "DE",
    "dropphyzpp": 199699998,
    "dropmaladd": "17601 COASTAL HWY UNIT 11",
    "dropmalcty": "NASSAU",
    "dropmalst": "DE",
    "dropmalzpp": 199699998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026452565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21333",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "501 DELAWARE ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "DE",
    "dropdelzpp": 197209998,
    "dropphyadd": "501 DELAWARE ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "DE",
    "dropphyzpp": 197209998,
    "dropmaladd": "501 DELAWARE ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "DE",
    "dropmalzpp": 197209998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023286472,
    "dropfax": 3023288307
  },
  {
    "dcode": "D",
    "dropkey": "PV21334",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "401 OGLETOWN RD",
    "dropdelcty": "NEWARK",
    "dropdelst": "DE",
    "dropdelzpp": 197119998,
    "dropphyadd": "401 OGLETOWN RD",
    "dropphycty": "NEWARK",
    "dropphyst": "DE",
    "dropphyzpp": 197119998,
    "dropmaladd": "401 OGLETOWN RD",
    "dropmalcty": "NEWARK",
    "dropmalst": "DE",
    "dropmalzpp": 197119998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3027375771,
    "dropfax": 3027382490
  },
  {
    "dcode": "D",
    "dropkey": "PV21341",
    "droptype": "D",
    "dropname": "OCEAN VIEW",
    "dropdeladd": "35764 ATLANTIC AVE",
    "dropdelcty": "OCEAN VIEW",
    "dropdelst": "DE",
    "dropdelzpp": 199709998,
    "dropphyadd": "35764 ATLANTIC AVE",
    "dropphycty": "OCEAN VIEW",
    "dropphyst": "DE",
    "dropphyzpp": 199709998,
    "dropmaladd": "35764 ATLANTIC AVE",
    "dropmalcty": "OCEAN VIEW",
    "dropmalst": "DE",
    "dropmalzpp": 199709998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3025399466,
    "dropfax": 3025394377
  },
  {
    "dcode": "D",
    "dropkey": "PV21342",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "ODESSA",
    "dropdelst": "DE",
    "dropdelzpp": 197309998,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "ODESSA",
    "dropphyst": "DE",
    "dropphyzpp": 197309998,
    "dropmaladd": "312 MAIN ST",
    "dropmalcty": "ODESSA",
    "dropmalst": "DE",
    "dropmalzpp": 197309998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023782047,
    "dropfax": 3023782047
  },
  {
    "dcode": "D",
    "dropkey": "PV21345",
    "droptype": "D",
    "dropname": "PORT PENN",
    "dropdeladd": "3 S CONGRESS ST",
    "dropdelcty": "PORT PENN",
    "dropdelst": "DE",
    "dropdelzpp": 197319998,
    "dropphyadd": "3 S CONGRESS ST",
    "dropphycty": "PORT PENN",
    "dropphyst": "DE",
    "dropphyzpp": 197319998,
    "dropmaladd": "3 S CONGRESS ST",
    "dropmalcty": "PORT PENN",
    "dropmalst": "DE",
    "dropmalzpp": 197319998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028345091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21352",
    "droptype": "D",
    "dropname": "REHOBOTH BEACH",
    "dropdeladd": "179 REHOBOTH AVE",
    "dropdelcty": "REHOBOTH BEACH",
    "dropdelst": "DE",
    "dropdelzpp": 199719998,
    "dropphyadd": "179 REHOBOTH AVE",
    "dropphycty": "REHOBOTH BEACH",
    "dropphyst": "DE",
    "dropphyzpp": 199719998,
    "dropmaladd": "179 REHOBOTH AVE",
    "dropmalcty": "REHOBOTH BEACH",
    "dropmalst": "DE",
    "dropmalzpp": 199719998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3022278406,
    "dropfax": 3022273370
  },
  {
    "dcode": "D",
    "dropkey": "PV21355",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "700 ROCKLAND RD",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "DE",
    "dropdelzpp": 197329998,
    "dropphyadd": "700 ROCKLAND RD",
    "dropphycty": "ROCKLAND",
    "dropphyst": "DE",
    "dropphyzpp": 197329998,
    "dropmaladd": "700 ROCKLAND RD",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "DE",
    "dropmalzpp": 197329998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026527708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21358",
    "droptype": "D",
    "dropname": "SAINT GEORGES",
    "dropdeladd": "201 BROAD ST",
    "dropdelcty": "SAINT GEORGES",
    "dropdelst": "DE",
    "dropdelzpp": 197339998,
    "dropphyadd": "201 BROAD ST",
    "dropphycty": "SAINT GEORGES",
    "dropphyst": "DE",
    "dropphyzpp": 197339998,
    "dropmaladd": "201 BROAD ST",
    "dropmalcty": "SAINT GEORGES",
    "dropmalst": "DE",
    "dropmalzpp": 197339998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028349075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21359",
    "droptype": "D",
    "dropname": "SEAFORD",
    "dropdeladd": "2001 BRIDGEVILLE HWY",
    "dropdelcty": "SEAFORD",
    "dropdelst": "DE",
    "dropdelzpp": 199739998,
    "dropphyadd": "2001 BRIDGEVILLE HWY",
    "dropphycty": "SEAFORD",
    "dropphyst": "DE",
    "dropphyzpp": 199739998,
    "dropmaladd": "2001 BRIDGEVILLE HWY",
    "dropmalcty": "SEAFORD",
    "dropmalst": "DE",
    "dropmalzpp": 199739998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026283441,
    "dropfax": 3026287896
  },
  {
    "dcode": "D",
    "dropkey": "PV21361",
    "droptype": "D",
    "dropname": "SELBYVILLE",
    "dropdeladd": "23 W CHURCH ST",
    "dropdelcty": "SELBYVILLE",
    "dropdelst": "DE",
    "dropdelzpp": 199759998,
    "dropphyadd": "23 W CHURCH ST",
    "dropphycty": "SELBYVILLE",
    "dropphyst": "DE",
    "dropphyzpp": 199759998,
    "dropmaladd": "23 W CHURCH ST",
    "dropmalcty": "SELBYVILLE",
    "dropmalst": "DE",
    "dropmalzpp": 199759998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024368044,
    "dropfax": 3024361629
  },
  {
    "dcode": "D",
    "dropkey": "PV21366",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "13 S MARKET ST",
    "dropdelcty": "SMYRNA",
    "dropdelst": "DE",
    "dropdelzpp": 199779998,
    "dropphyadd": "13 S MARKET ST",
    "dropphycty": "SMYRNA",
    "dropphyst": "DE",
    "dropphyzpp": 199779998,
    "dropmaladd": "13 S MARKET ST",
    "dropmalcty": "SMYRNA",
    "dropmalst": "DE",
    "dropmalzpp": 199779998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026539935,
    "dropfax": 3026530244
  },
  {
    "dcode": "D",
    "dropkey": "PV21373",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "DE",
    "dropdelzpp": 197349998,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "TOWNSEND",
    "dropphyst": "DE",
    "dropphyzpp": 197349998,
    "dropmaladd": "400 MAIN ST",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "DE",
    "dropmalzpp": 197349998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023782592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21375",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "3 S MAIN ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "DE",
    "dropdelzpp": 199799998,
    "dropphyadd": "3 S MAIN ST",
    "dropphycty": "VIOLA",
    "dropphyst": "DE",
    "dropphyzpp": 199799998,
    "dropmaladd": "3 S MAIN ST",
    "dropmalcty": "VIOLA",
    "dropmalst": "DE",
    "dropmalzpp": 199799998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3022843017,
    "dropfax": 3022843814
  },
  {
    "dcode": "D",
    "dropkey": "PV21381",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "3911 CONCORD PIKE",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198039997,
    "dropphyadd": "3911 CONCORD PIKE",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198039997,
    "dropmaladd": "PO BOX 7500",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198039998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024799501,
    "dropfax": 3023233772
  },
  {
    "dcode": "D",
    "dropkey": "PV21388",
    "droptype": "D",
    "dropname": "WOODSIDE",
    "dropdeladd": "4568 TURKEY POINT RD",
    "dropdelcty": "WOODSIDE",
    "dropdelst": "DE",
    "dropdelzpp": 199809998,
    "dropphyadd": "4568 TURKEY POINT RD",
    "dropphycty": "WOODSIDE",
    "dropphyst": "DE",
    "dropphyzpp": 199809998,
    "dropmaladd": "4568 TURKEY POINT RD",
    "dropmalcty": "WOODSIDE",
    "dropmalst": "DE",
    "dropmalzpp": 199809998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026973917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21390",
    "droptype": "D",
    "dropname": "YORKLYN",
    "dropdeladd": "1149 YORKLYN RD",
    "dropdelcty": "YORKLYN",
    "dropdelst": "DE",
    "dropdelzpp": 197369998,
    "dropphyadd": "1149 YORKLYN RD",
    "dropphycty": "YORKLYN",
    "dropphyst": "DE",
    "dropphyzpp": 197369998,
    "dropmaladd": "1149 YORKLYN RD",
    "dropmalcty": "YORKLYN",
    "dropmalst": "DE",
    "dropmalzpp": 197369998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3022392702,
    "dropfax": 3022391860
  },
  {
    "dcode": "D",
    "dropkey": "PV21391",
    "droptype": "D",
    "dropname": "ABINGTON",
    "dropdeladd": "16 HARRISON AVE",
    "dropdelcty": "ABINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "023519998",
    "dropphyadd": "16 HARRISON AVE",
    "dropphycty": "ABINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "023519998",
    "dropmaladd": "16 HARRISON AVE",
    "dropmalcty": "ABINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "023519998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7819824027,
    "dropfax": 7818714878
  },
  {
    "dcode": "D",
    "dropkey": "PV21393",
    "droptype": "D",
    "dropname": "ACTON",
    "dropdeladd": "7 POST OFFICE SQ",
    "dropdelcty": "ACTON",
    "dropdelst": "MA",
    "dropdelzpp": "017209998",
    "dropphyadd": "7 POST OFFICE SQ",
    "dropphycty": "ACTON",
    "dropphyst": "MA",
    "dropphyzpp": "017209998",
    "dropmaladd": "7 POST OFFICE SQ",
    "dropmalcty": "ACTON",
    "dropmalst": "MA",
    "dropmalzpp": "017209998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782637744,
    "dropfax": 9782636725
  },
  {
    "dcode": "D",
    "dropkey": "PV21396",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "1 CENTER ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "MA",
    "dropdelzpp": "012209998",
    "dropphyadd": "1 CENTER ST",
    "dropphycty": "ADAMS",
    "dropphyst": "MA",
    "dropphyzpp": "012209998",
    "dropmaladd": "1 CENTER ST",
    "dropmalcty": "ADAMS",
    "dropmalst": "MA",
    "dropmalzpp": "012209998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137435177,
    "dropfax": 4137437094
  },
  {
    "dcode": "D",
    "dropkey": "PV21399",
    "droptype": "D",
    "dropname": "AGAWAM",
    "dropdeladd": "600 SUFFIELD ST",
    "dropdelcty": "AGAWAM",
    "dropdelst": "MA",
    "dropdelzpp": "010019998",
    "dropphyadd": "600 SUFFIELD ST",
    "dropphycty": "AGAWAM",
    "dropphyst": "MA",
    "dropphyzpp": "010019998",
    "dropmaladd": "600 SUFFIELD ST",
    "dropmalcty": "AGAWAM",
    "dropmalst": "MA",
    "dropmalzpp": "010019998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137861001,
    "dropfax": 4137866689
  },
  {
    "dcode": "D",
    "dropkey": "PV21412",
    "droptype": "D",
    "dropname": "AMESBURY",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "AMESBURY",
    "dropdelst": "MA",
    "dropdelzpp": "019139998",
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "AMESBURY",
    "dropphyst": "MA",
    "dropphyzpp": "019139998",
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "AMESBURY",
    "dropmalst": "MA",
    "dropmalzpp": "019139998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783887537,
    "dropfax": 9783882145
  },
  {
    "dcode": "D",
    "dropkey": "PV21413",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "145 UNIVERSITY DR",
    "dropdelcty": "AMHERST",
    "dropdelst": "MA",
    "dropdelzpp": "010029998",
    "dropphyadd": "145 UNIVERSITY DR",
    "dropphycty": "AMHERST",
    "dropphyst": "MA",
    "dropphyzpp": "010029998",
    "dropmaladd": "145 UNIVERSITY DR",
    "dropmalcty": "AMHERST",
    "dropmalst": "MA",
    "dropmalzpp": "010029998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135490523,
    "dropfax": 4135488836
  },
  {
    "dcode": "D",
    "dropkey": "PV21415",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "10 STEVENS ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "MA",
    "dropdelzpp": "018103572",
    "dropphyadd": "10 STEVENS ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "MA",
    "dropphyzpp": "018103572",
    "dropmaladd": "10 STEVENS ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "MA",
    "dropmalzpp": "018103572",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784759436,
    "dropfax": 9784740285
  },
  {
    "dcode": "D",
    "dropkey": "PV21422",
    "droptype": "D",
    "dropname": "ASHBURNHAM",
    "dropdeladd": "123 CENTRAL ST",
    "dropdelcty": "ASHBURNHAM",
    "dropdelst": "MA",
    "dropdelzpp": "014309998",
    "dropphyadd": "123 CENTRAL ST",
    "dropphycty": "ASHBURNHAM",
    "dropphyst": "MA",
    "dropphyzpp": "014309998",
    "dropmaladd": "123 CENTRAL ST",
    "dropmalcty": "ASHBURNHAM",
    "dropmalst": "MA",
    "dropmalzpp": "014309998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788273174,
    "dropfax": 9788274593
  },
  {
    "dcode": "D",
    "dropkey": "PV21423",
    "droptype": "D",
    "dropname": "ASHBY",
    "dropdeladd": "10 COMMON RD STE 2",
    "dropdelcty": "ASHBY",
    "dropdelst": "MA",
    "dropdelzpp": "014312323",
    "dropphyadd": "10 COMMON RD STE 2",
    "dropphycty": "ASHBY",
    "dropphyst": "MA",
    "dropphyzpp": "014312323",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHBY",
    "dropmalst": "MA",
    "dropmalzpp": "014319998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783860041,
    "dropfax": 9783866832
  },
  {
    "dcode": "D",
    "dropkey": "PV21424",
    "droptype": "D",
    "dropname": "ASHFIELD",
    "dropdeladd": "258 MAIN ST",
    "dropdelcty": "ASHFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013309998",
    "dropphyadd": "258 MAIN ST",
    "dropphycty": "ASHFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013309998",
    "dropmaladd": "258 MAIN ST",
    "dropmalcty": "ASHFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013309998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4136284511,
    "dropsitcph": 4136284511,
    "dropfax": 4136280213
  },
  {
    "dcode": "D",
    "dropkey": "PV21426",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "MA",
    "dropdelzpp": "017219998",
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "MA",
    "dropphyzpp": "017219998",
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "MA",
    "dropmalzpp": "017219998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088815888,
    "dropfax": 5088810865
  },
  {
    "dcode": "D",
    "dropkey": "PV21427",
    "droptype": "D",
    "dropname": "ASHLEY FALLS",
    "dropdeladd": "1180 ASHLEY FALLS RD",
    "dropdelcty": "ASHLEY FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "012229998",
    "dropphyadd": "1180 ASHLEY FALLS RD",
    "dropphycty": "ASHLEY FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "012229998",
    "dropmaladd": "1180 ASHLEY FALLS RD",
    "dropmalcty": "ASHLEY FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "012229998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856420,
    "dropsitcph": 4132298048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21432",
    "droptype": "D",
    "dropname": "ASSONET",
    "dropdeladd": "57 S MAIN ST",
    "dropdelcty": "ASSONET",
    "dropdelst": "MA",
    "dropdelzpp": "027021711",
    "dropphyadd": "57 S MAIN ST",
    "dropphycty": "ASSONET",
    "dropphyst": "MA",
    "dropphyzpp": "027021711",
    "dropmaladd": "57 S MAIN ST",
    "dropmalcty": "ASSONET",
    "dropmalst": "MA",
    "dropmalzpp": "027021711",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086442276,
    "dropfax": 5086448089
  },
  {
    "dcode": "D",
    "dropkey": "PV21436",
    "droptype": "D",
    "dropname": "ATHOL",
    "dropdeladd": "242 MAIN ST",
    "dropdelcty": "ATHOL",
    "dropdelst": "MA",
    "dropdelzpp": "013319998",
    "dropphyadd": "242 MAIN ST",
    "dropphycty": "ATHOL",
    "dropphyst": "MA",
    "dropphyzpp": "013319998",
    "dropmaladd": "242 MAIN ST",
    "dropmalcty": "ATHOL",
    "dropmalst": "MA",
    "dropmalzpp": "013319998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9782498535,
    "dropfax": 9782499572
  },
  {
    "dcode": "D",
    "dropkey": "PV21437",
    "droptype": "D",
    "dropname": "ATTLEBORO",
    "dropdeladd": "901 PLEASANT ST",
    "dropdelcty": "ATTLEBORO",
    "dropdelst": "MA",
    "dropdelzpp": "027039998",
    "dropphyadd": "901 PLEASANT ST",
    "dropphycty": "ATTLEBORO",
    "dropphyst": "MA",
    "dropphyzpp": "027039998",
    "dropmaladd": "901 PLEASANT ST",
    "dropmalcty": "ATTLEBORO",
    "dropmalst": "MA",
    "dropmalzpp": "027039998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082229201,
    "dropfax": 5082225650
  },
  {
    "dcode": "D",
    "dropkey": "PV21441",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "60 AUBURN ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "MA",
    "dropdelzpp": "015019998",
    "dropphyadd": "60 AUBURN ST",
    "dropphycty": "AUBURN",
    "dropphyst": "MA",
    "dropphyzpp": "015019998",
    "dropmaladd": "60 AUBURN ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "MA",
    "dropmalzpp": "015019998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088323406,
    "dropfax": 5088324427
  },
  {
    "dcode": "D",
    "dropkey": "PV21443",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "8 E MAIN ST",
    "dropdelcty": "AVON",
    "dropdelst": "MA",
    "dropdelzpp": "023229998",
    "dropphyadd": "8 E MAIN ST",
    "dropphycty": "AVON",
    "dropphyst": "MA",
    "dropphyzpp": "023229998",
    "dropmaladd": "8 E MAIN ST",
    "dropmalcty": "AVON",
    "dropmalst": "MA",
    "dropmalzpp": "023229998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085866220,
    "dropfax": 5085862958
  },
  {
    "dcode": "D",
    "dropkey": "PV21444",
    "droptype": "D",
    "dropname": "AYER",
    "dropdeladd": "1 COLUMBIA ST",
    "dropdelcty": "AYER",
    "dropdelst": "MA",
    "dropdelzpp": "014329998",
    "dropphyadd": "1 COLUMBIA ST",
    "dropphycty": "AYER",
    "dropphyst": "MA",
    "dropphyzpp": "014329998",
    "dropmaladd": "1 COLUMBIA ST",
    "dropmalcty": "AYER",
    "dropmalst": "MA",
    "dropmalzpp": "014329998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787726896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21449",
    "droptype": "D",
    "dropname": "BALDWINVILLE",
    "dropdeladd": "38 ELM ST",
    "dropdelcty": "BALDWINVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "014369998",
    "dropphyadd": "38 ELM ST",
    "dropphycty": "BALDWINVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "014369998",
    "dropmaladd": "38 ELM ST",
    "dropmalcty": "BALDWINVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "014369998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789395780,
    "dropfax": 9789392652
  },
  {
    "dcode": "D",
    "dropkey": "PV21456",
    "droptype": "D",
    "dropname": "BARNSTABLE",
    "dropdeladd": "3230 MAIN ST",
    "dropdelcty": "BARNSTABLE",
    "dropdelst": "MA",
    "dropdelzpp": "026309998",
    "dropphyadd": "3230 MAIN ST",
    "dropphycty": "BARNSTABLE",
    "dropphyst": "MA",
    "dropphyzpp": "026309998",
    "dropmaladd": "3230 MAIN ST",
    "dropmalcty": "BARNSTABLE",
    "dropmalst": "MA",
    "dropmalzpp": "026309998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083622413,
    "dropfax": 5083629308
  },
  {
    "dcode": "D",
    "dropkey": "PV21458",
    "droptype": "D",
    "dropname": "BARRE",
    "dropdeladd": "500 SOUTH ST",
    "dropdelcty": "BARRE",
    "dropdelst": "MA",
    "dropdelzpp": "010059998",
    "dropphyadd": "500 SOUTH ST",
    "dropphycty": "BARRE",
    "dropphyst": "MA",
    "dropphyzpp": "010059998",
    "dropmaladd": "500 SOUTH ST",
    "dropmalcty": "BARRE",
    "dropmalst": "MA",
    "dropmalzpp": "010059998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9783552375,
    "dropfax": 9783556859
  },
  {
    "dcode": "D",
    "dropkey": "PV21469",
    "droptype": "D",
    "dropname": "BECKET",
    "dropdeladd": "623 MAIN ST",
    "dropdelcty": "BECKET",
    "dropdelst": "MA",
    "dropdelzpp": "012239998",
    "dropphyadd": "623 MAIN ST",
    "dropphycty": "BECKET",
    "dropphyst": "MA",
    "dropphyzpp": "012239998",
    "dropmaladd": "623 MAIN ST",
    "dropmalcty": "BECKET",
    "dropmalst": "MA",
    "dropmalzpp": "012239998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136238845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21471",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "158 GREAT RD UNIT J",
    "dropdelcty": "BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "017309998",
    "dropphyadd": "158 GREAT RD UNIT J",
    "dropphycty": "BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "017309998",
    "dropmaladd": "158 GREAT RD UNIT J",
    "dropmalcty": "BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "017309998",
    "dropsitphn": 9786647013,
    "dropsitlph": 7812752924,
    "dropsitcph": 7812752924,
    "dropfax": 7812756049
  },
  {
    "dcode": "D",
    "dropkey": "PV21473",
    "droptype": "D",
    "dropname": "BELCHERTOWN",
    "dropdeladd": "35 MAIN ST",
    "dropdelcty": "BELCHERTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "010079998",
    "dropphyadd": "35 MAIN ST",
    "dropphycty": "BELCHERTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "010079998",
    "dropmaladd": "35 MAIN ST",
    "dropmalcty": "BELCHERTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "010079998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133236619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21475",
    "droptype": "D",
    "dropname": "BELLINGHAM",
    "dropdeladd": "111 MECHANIC ST",
    "dropdelcty": "BELLINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020199998",
    "dropphyadd": "111 MECHANIC ST",
    "dropphycty": "BELLINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020199998",
    "dropmaladd": "111 MECHANIC ST",
    "dropmalcty": "BELLINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "020199998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089663361,
    "dropfax": 5089661241
  },
  {
    "dcode": "D",
    "dropkey": "PV21481",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "260 PLEASANT ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "MA",
    "dropdelzpp": "015039998",
    "dropphyadd": "260 PLEASANT ST",
    "dropphycty": "BERLIN",
    "dropphyst": "MA",
    "dropphyzpp": "015039998",
    "dropmaladd": "260 PLEASANT ST",
    "dropmalcty": "BERLIN",
    "dropmalst": "MA",
    "dropmalzpp": "015039998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9788382612,
    "dropsitcph": 9788382847,
    "dropfax": 9788380451
  },
  {
    "dcode": "D",
    "dropkey": "PV21483",
    "droptype": "D",
    "dropname": "BERNARDSTON",
    "dropdeladd": "9 CENTER ST",
    "dropdelcty": "BERNARDSTON",
    "dropdelst": "MA",
    "dropdelzpp": "013379998",
    "dropphyadd": "9 CENTER ST",
    "dropphycty": "BERNARDSTON",
    "dropphyst": "MA",
    "dropphyzpp": "013379998",
    "dropmaladd": "9 CENTER ST",
    "dropmalcty": "BERNARDSTON",
    "dropmalst": "MA",
    "dropmalzpp": "013379998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136489064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21484",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "151 RANTOUL ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "MA",
    "dropdelzpp": "019159998",
    "dropphyadd": "151 RANTOUL ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "MA",
    "dropphyzpp": "019159998",
    "dropmaladd": "151 RANTOUL ST",
    "dropmalcty": "BEVERLY",
    "dropmalst": "MA",
    "dropmalzpp": "019159998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789223338,
    "dropfax": 9789278354
  },
  {
    "dcode": "D",
    "dropkey": "PV21489",
    "droptype": "D",
    "dropname": "BILLERICA",
    "dropdeladd": "460 BOSTON RD",
    "dropdelcty": "BILLERICA",
    "dropdelst": "MA",
    "dropdelzpp": "018219998",
    "dropphyadd": "460 BOSTON RD",
    "dropphycty": "BILLERICA",
    "dropphyst": "MA",
    "dropphyzpp": "018219998",
    "dropmaladd": "460 BOSTON RD",
    "dropmalcty": "BILLERICA",
    "dropmalst": "MA",
    "dropmalzpp": "018219998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786632791,
    "dropfax": 9786638548
  },
  {
    "dcode": "D",
    "dropkey": "PV21494",
    "droptype": "D",
    "dropname": "BLACKSTONE",
    "dropdeladd": "149 MAIN ST",
    "dropdelcty": "BLACKSTONE",
    "dropdelst": "MA",
    "dropdelzpp": "015049998",
    "dropphyadd": "149 MAIN ST",
    "dropphycty": "BLACKSTONE",
    "dropphyst": "MA",
    "dropphyzpp": "015049998",
    "dropmaladd": "149 MAIN ST",
    "dropmalcty": "BLACKSTONE",
    "dropmalst": "MA",
    "dropmalzpp": "015049998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088768015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21495",
    "droptype": "D",
    "dropname": "BLANDFORD",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "BLANDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "010089998",
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "BLANDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "010089998",
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "BLANDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "010089998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4138482480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21501",
    "droptype": "D",
    "dropname": "BOLTON",
    "dropdeladd": "1092 MAIN ST",
    "dropdelcty": "BOLTON",
    "dropdelst": "MA",
    "dropdelzpp": "017409998",
    "dropphyadd": "1092 MAIN ST",
    "dropphycty": "BOLTON",
    "dropphyst": "MA",
    "dropphyzpp": "017409998",
    "dropmaladd": "1092 MAIN ST",
    "dropmalcty": "BOLTON",
    "dropmalst": "MA",
    "dropmalzpp": "017409998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787795069,
    "dropfax": 9787790419
  },
  {
    "dcode": "D",
    "dropkey": "PV21502",
    "droptype": "D",
    "dropname": "BONDSVILLE",
    "dropdeladd": "3069 MAIN ST",
    "dropdelcty": "BONDSVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "010099998",
    "dropphyadd": "3069 MAIN ST",
    "dropphycty": "BONDSVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "010099998",
    "dropmaladd": "3069 MAIN ST",
    "dropmalcty": "BONDSVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "010099998",
    "dropsitphn": 4132833900,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132833900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21508",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "25 DORCHESTER AVE",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "022050002",
    "dropphyadd": "25 DORCHESTER AVE",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "022050002",
    "dropmaladd": "25 DORCHESTER AVE",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "022050002",
    "dropsitphn": 6176545113,
    "dropsitlph": "",
    "dropsitcph": 6176545302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21520",
    "droptype": "D",
    "dropname": "BOXFORD",
    "dropdeladd": "7 ELM ST STE 1",
    "dropdelcty": "BOXFORD",
    "dropdelst": "MA",
    "dropdelzpp": "019219998",
    "dropphyadd": "7 ELM ST STE 1",
    "dropphycty": "BOXFORD",
    "dropphyst": "MA",
    "dropphyzpp": "019219998",
    "dropmaladd": "7 ELM ST STE 1",
    "dropmalcty": "BOXFORD",
    "dropmalst": "MA",
    "dropmalzpp": "019219998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788870837,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV21541",
    "droptype": "D",
    "dropname": "BRANT ROCK",
    "dropdeladd": "555 OCEAN ST",
    "dropdelcty": "BRANT ROCK",
    "dropdelst": "MA",
    "dropdelzpp": "020209997",
    "dropphyadd": "555 OCEAN ST",
    "dropphycty": "BRANT ROCK",
    "dropphyst": "MA",
    "dropphyzpp": "020209997",
    "dropmaladd": "555 OCEAN ST",
    "dropmalcty": "BRANT ROCK",
    "dropmalst": "MA",
    "dropmalzpp": "020209997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818377616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21543",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "260 UNDERPASS RD",
    "dropdelcty": "BREWSTER",
    "dropdelst": "MA",
    "dropdelzpp": "026319998",
    "dropphyadd": "260 UNDERPASS RD",
    "dropphycty": "BREWSTER",
    "dropphyst": "MA",
    "dropphyzpp": "026319998",
    "dropmaladd": "260 UNDERPASS RD",
    "dropmalcty": "BREWSTER",
    "dropmalst": "MA",
    "dropmalzpp": "026319998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088968377,
    "dropfax": 5088963259
  },
  {
    "dcode": "D",
    "dropkey": "PV21545",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "169 BROAD ST",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "MA",
    "dropdelzpp": "023249998",
    "dropphyadd": "169 BROAD ST",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "MA",
    "dropphyzpp": "023249998",
    "dropmaladd": "169 BROAD ST",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "MA",
    "dropmalzpp": "023249998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086971576,
    "dropfax": 5086979718
  },
  {
    "dcode": "D",
    "dropkey": "PV21552",
    "droptype": "D",
    "dropname": "BRIMFIELD",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "BRIMFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010109998",
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "BRIMFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010109998",
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "BRIMFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010109998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132426021,
    "dropfax": 4132426020
  },
  {
    "dcode": "D",
    "dropkey": "PV21555",
    "droptype": "D",
    "dropname": "BROCKTON",
    "dropdeladd": "120 COMMERCIAL ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MA",
    "dropdelzpp": "023029998",
    "dropphyadd": "120 COMMERCIAL ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "MA",
    "dropphyzpp": "023029998",
    "dropmaladd": "120 COMMERCIAL ST",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MA",
    "dropmalzpp": "023029998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085591958,
    "dropfax": 5085800411
  },
  {
    "dcode": "D",
    "dropkey": "PV21557",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "5 POST RD",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "015069998",
    "dropphyadd": "5 POST RD",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "015069998",
    "dropmaladd": "5 POST RD",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "015069998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088675369,
    "dropfax": 5088674151
  },
  {
    "dcode": "D",
    "dropkey": "PV21562",
    "droptype": "D",
    "dropname": "BRYANTVILLE",
    "dropdeladd": "13 SCHOOL ST",
    "dropdelcty": "BRYANTVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "023279800",
    "dropphyadd": "13 SCHOOL ST",
    "dropphycty": "BRYANTVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "023279800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRYANTVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "023279998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7812933302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21565",
    "droptype": "D",
    "dropname": "BUCKLAND",
    "dropdeladd": "67 UPPER ST",
    "dropdelcty": "BUCKLAND",
    "dropdelst": "MA",
    "dropdelzpp": "013389800",
    "dropphyadd": "67 UPPER ST",
    "dropphycty": "BUCKLAND",
    "dropphyst": "MA",
    "dropphyzpp": "013389800",
    "dropmaladd": "67 UPPER ST",
    "dropmalcty": "BUCKLAND",
    "dropmalst": "MA",
    "dropmalzpp": "013389800",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136252776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21569",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "5 BEDFORD ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "018039998",
    "dropphyadd": "5 BEDFORD ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "018039998",
    "dropmaladd": "5 BEDFORD ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "018039998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812704449,
    "dropfax": 7812724486
  },
  {
    "dcode": "D",
    "dropkey": "PV21571",
    "droptype": "D",
    "dropname": "BUZZARDS BAY",
    "dropdeladd": "220 MAIN ST",
    "dropdelcty": "BUZZARDS BAY",
    "dropdelst": "MA",
    "dropdelzpp": "025329998",
    "dropphyadd": "220 MAIN ST",
    "dropphycty": "BUZZARDS BAY",
    "dropphyst": "MA",
    "dropphyzpp": "025329998",
    "dropmaladd": "220 MAIN ST",
    "dropmalcty": "BUZZARDS BAY",
    "dropmalst": "MA",
    "dropmalzpp": "025329998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087594160,
    "dropfax": 5087592058
  },
  {
    "dcode": "D",
    "dropkey": "PV21572",
    "droptype": "D",
    "dropname": "BYFIELD",
    "dropdeladd": "2 CENTRAL ST",
    "dropdelcty": "BYFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "019229998",
    "dropphyadd": "2 CENTRAL ST",
    "dropphycty": "BYFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "019229998",
    "dropmaladd": "2 CENTRAL ST",
    "dropmalcty": "BYFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "019229998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784651866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21576",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "770 MASSACHUSETTS AVE",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021399998",
    "dropphyadd": "770 MASSACHUSETTS AVE",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021399998",
    "dropmaladd": "770 MASSACHUSETTS AVE",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021399998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175758700,
    "dropfax": 6174918318
  },
  {
    "dcode": "D",
    "dropkey": "PV21579",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "661 WASHINGTON ST",
    "dropdelcty": "CANTON",
    "dropdelst": "MA",
    "dropdelzpp": "020219998",
    "dropphyadd": "661 WASHINGTON ST",
    "dropphycty": "CANTON",
    "dropphyst": "MA",
    "dropphyzpp": "020219998",
    "dropmaladd": "661 WASHINGTON ST",
    "dropmalcty": "CANTON",
    "dropmalst": "MA",
    "dropmalzpp": "020219998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818288585,
    "dropfax": 7818286210
  },
  {
    "dcode": "D",
    "dropkey": "PV21581",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "70 BEDFORD RD",
    "dropdelcty": "CARLISLE",
    "dropdelst": "MA",
    "dropdelzpp": "017411891",
    "dropphyadd": "70 BEDFORD RD",
    "dropphycty": "CARLISLE",
    "dropphyst": "MA",
    "dropphyzpp": "017411891",
    "dropmaladd": "70 BEDFORD RD",
    "dropmalcty": "CARLISLE",
    "dropmalst": "MA",
    "dropmalzpp": "017411891",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783696820,
    "dropfax": 9783719603
  },
  {
    "dcode": "D",
    "dropkey": "PV21582",
    "droptype": "D",
    "dropname": "CARVER",
    "dropdeladd": "126 MAIN ST STE 1",
    "dropdelcty": "CARVER",
    "dropdelst": "MA",
    "dropdelzpp": "023309998",
    "dropphyadd": "126 MAIN ST STE 1",
    "dropphycty": "CARVER",
    "dropphyst": "MA",
    "dropphyzpp": "023309998",
    "dropmaladd": "126 MAIN ST STE 1",
    "dropmalcty": "CARVER",
    "dropmalst": "MA",
    "dropmalzpp": "023309998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088667022,
    "dropfax": 5088667405
  },
  {
    "dcode": "D",
    "dropkey": "PV21584",
    "droptype": "D",
    "dropname": "CATAUMET",
    "dropdeladd": "1 POST OFFICE SQ",
    "dropdelcty": "CATAUMET",
    "dropdelst": "MA",
    "dropdelzpp": "025349800",
    "dropphyadd": "1 POST OFFICE SQ",
    "dropphycty": "CATAUMET",
    "dropphyst": "MA",
    "dropphyzpp": "025349800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CATAUMET",
    "dropmalst": "MA",
    "dropmalzpp": "025349998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085631751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21589",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "1672 FALMOUTH RD",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "026329998",
    "dropphyadd": "1672 FALMOUTH RD",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "026329998",
    "dropmaladd": "1672 FALMOUTH RD",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "026329998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087784443,
    "dropfax": 5087900874
  },
  {
    "dcode": "D",
    "dropkey": "PV21595",
    "droptype": "D",
    "dropname": "CHARLEMONT",
    "dropdeladd": "90-3 MAIN ST",
    "dropdelcty": "CHARLEMONT",
    "dropdelst": "MA",
    "dropdelzpp": "013399998",
    "dropphyadd": "90-3 MAIN ST",
    "dropphycty": "CHARLEMONT",
    "dropphyst": "MA",
    "dropphyzpp": "013399998",
    "dropmaladd": "90-3 MAIN ST",
    "dropmalcty": "CHARLEMONT",
    "dropmalst": "MA",
    "dropmalzpp": "013399998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133394825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21600",
    "droptype": "D",
    "dropname": "CHARLTON",
    "dropdeladd": "58 N MAIN ST",
    "dropdelcty": "CHARLTON",
    "dropdelst": "MA",
    "dropdelzpp": "015079998",
    "dropphyadd": "58 N MAIN ST",
    "dropphycty": "CHARLTON",
    "dropphyst": "MA",
    "dropphyzpp": "015079998",
    "dropmaladd": "58 N MAIN ST",
    "dropmalcty": "CHARLTON",
    "dropmalst": "MA",
    "dropmalzpp": "015079998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082486289,
    "dropfax": 5082484951
  },
  {
    "dcode": "D",
    "dropkey": "PV21601",
    "droptype": "D",
    "dropname": "CHARLTON CITY",
    "dropdeladd": "9 POWERSTATION RD",
    "dropdelcty": "CHARLTON CITY",
    "dropdelst": "MA",
    "dropdelzpp": "015089800",
    "dropphyadd": "9 POWERSTATION RD",
    "dropphycty": "CHARLTON CITY",
    "dropphyst": "MA",
    "dropphyzpp": "015089800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHARLTON CITY",
    "dropmalst": "MA",
    "dropmalzpp": "015089998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082486108,
    "dropfax": 5082487214
  },
  {
    "dcode": "D",
    "dropkey": "PV21603",
    "droptype": "D",
    "dropname": "CHARTLEY",
    "dropdeladd": "391 OLD COLONY RD",
    "dropdelcty": "CHARTLEY",
    "dropdelst": "MA",
    "dropdelzpp": "027129800",
    "dropphyadd": "391 OLD COLONY RD",
    "dropphycty": "CHARTLEY",
    "dropphyst": "MA",
    "dropphyzpp": "027129800",
    "dropmaladd": "391 OLD COLONY RD",
    "dropmalcty": "CHARTLEY",
    "dropmalst": "MA",
    "dropmalzpp": "027129800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082224695,
    "dropfax": 5082231947
  },
  {
    "dcode": "D",
    "dropkey": "PV21605",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "802 MAIN ST",
    "dropdelcty": "CHATHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026339998",
    "dropphyadd": "802 MAIN ST",
    "dropphycty": "CHATHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026339998",
    "dropmaladd": "802 MAIN ST",
    "dropmalcty": "CHATHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026339998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089456054,
    "dropfax": 5089457772
  },
  {
    "dcode": "D",
    "dropkey": "PV21606",
    "droptype": "D",
    "dropname": "CHELMSFORD",
    "dropdeladd": "45 ALPINE LN",
    "dropdelcty": "CHELMSFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018249998",
    "dropphyadd": "45 ALPINE LN",
    "dropphycty": "CHELMSFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018249998",
    "dropmaladd": "45 ALPINE LN",
    "dropmalcty": "CHELMSFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018249998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782562670,
    "dropfax": 9786709217
  },
  {
    "dcode": "D",
    "dropkey": "PV21611",
    "droptype": "D",
    "dropname": "CHESHIRE",
    "dropdeladd": "214 CHURCH ST",
    "dropdelcty": "CHESHIRE",
    "dropdelst": "MA",
    "dropdelzpp": "012259998",
    "dropphyadd": "214 CHURCH ST",
    "dropphycty": "CHESHIRE",
    "dropphyst": "MA",
    "dropphyzpp": "012259998",
    "dropmaladd": "214 CHURCH ST",
    "dropmalcty": "CHESHIRE",
    "dropmalst": "MA",
    "dropmalzpp": "012259998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137433184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21612",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "309 ROUTE 20",
    "dropdelcty": "CHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "010119998",
    "dropphyadd": "309 ROUTE 20",
    "dropphycty": "CHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "010119998",
    "dropmaladd": "309 ROUTE 20",
    "dropmalcty": "CHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "010119998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133547861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21613",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "6A SOUTH ST",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010129998",
    "dropphyadd": "6A SOUTH ST",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010129998",
    "dropmaladd": "6A SOUTH ST",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010129998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132964200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21617",
    "droptype": "D",
    "dropname": "CHICOPEE",
    "dropdeladd": "28 MAIN ST",
    "dropdelcty": "CHICOPEE",
    "dropdelst": "MA",
    "dropdelzpp": "010209998",
    "dropphyadd": "28 MAIN ST",
    "dropphycty": "CHICOPEE",
    "dropphyst": "MA",
    "dropphyzpp": "010209998",
    "dropmaladd": "28 MAIN ST",
    "dropmalcty": "CHICOPEE",
    "dropmalst": "MA",
    "dropmalzpp": "010209998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135929451,
    "dropfax": 4135980416
  },
  {
    "dcode": "D",
    "dropkey": "PV21622",
    "droptype": "D",
    "dropname": "CHILMARK",
    "dropdeladd": "4 STATE RD",
    "dropdelcty": "CHILMARK",
    "dropdelst": "MA",
    "dropdelzpp": "025359800",
    "dropphyadd": "4 STATE RD",
    "dropphycty": "CHILMARK",
    "dropphyst": "MA",
    "dropphyzpp": "025359800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHILMARK",
    "dropmalst": "MA",
    "dropmalzpp": "025359998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086452535,
    "dropfax": 5086453670
  },
  {
    "dcode": "D",
    "dropkey": "PV21625",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "320 HIGH ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "MA",
    "dropdelzpp": "015109998",
    "dropphyadd": "320 HIGH ST",
    "dropphycty": "CLINTON",
    "dropphyst": "MA",
    "dropphyzpp": "015109998",
    "dropmaladd": "320 HIGH ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "MA",
    "dropmalzpp": "015109998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783654903,
    "dropfax": 9783651784
  },
  {
    "dcode": "D",
    "dropkey": "PV21629",
    "droptype": "D",
    "dropname": "COHASSET",
    "dropdeladd": "100 RIPLEY RD",
    "dropdelcty": "COHASSET",
    "dropdelst": "MA",
    "dropdelzpp": "020259998",
    "dropphyadd": "100 RIPLEY RD",
    "dropphycty": "COHASSET",
    "dropphyst": "MA",
    "dropphyzpp": "020259998",
    "dropmaladd": "100 RIPLEY RD",
    "dropmalcty": "COHASSET",
    "dropmalst": "MA",
    "dropmalzpp": "020259998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7813830320,
    "dropfax": 7813831799
  },
  {
    "dcode": "D",
    "dropkey": "PV21633",
    "droptype": "D",
    "dropname": "COLRAIN",
    "dropdeladd": "16 MAIN RD",
    "dropdelcty": "COLRAIN",
    "dropdelst": "MA",
    "dropdelzpp": "013409998",
    "dropphyadd": "16 MAIN RD",
    "dropphycty": "COLRAIN",
    "dropphyst": "MA",
    "dropphyzpp": "013409998",
    "dropmaladd": "16 MAIN RD",
    "dropmalcty": "COLRAIN",
    "dropmalst": "MA",
    "dropmalzpp": "013409998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136243620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21636",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "34 WALDEN ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "MA",
    "dropdelzpp": "017429998",
    "dropphyadd": "34 WALDEN ST",
    "dropphycty": "CONCORD",
    "dropphyst": "MA",
    "dropphyzpp": "017429998",
    "dropmaladd": "34 WALDEN ST",
    "dropmalcty": "CONCORD",
    "dropmalst": "MA",
    "dropmalzpp": "017429998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783697613,
    "dropfax": 9782874037
  },
  {
    "dcode": "D",
    "dropkey": "PV21638",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "38 RIVER ST",
    "dropdelcty": "CONWAY",
    "dropdelst": "MA",
    "dropdelzpp": "013419998",
    "dropphyadd": "38 RIVER ST",
    "dropphycty": "CONWAY",
    "dropphyst": "MA",
    "dropphyzpp": "013419998",
    "dropmaladd": "38 RIVER ST",
    "dropmalcty": "CONWAY",
    "dropmalst": "MA",
    "dropmalzpp": "013419998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133694677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21641",
    "droptype": "D",
    "dropname": "COTUIT",
    "dropdeladd": "45 SCHOOL ST",
    "dropdelcty": "COTUIT",
    "dropdelst": "MA",
    "dropdelzpp": "026359998",
    "dropphyadd": "45 SCHOOL ST",
    "dropphycty": "COTUIT",
    "dropphyst": "MA",
    "dropphyzpp": "026359998",
    "dropmaladd": "45 SCHOOL ST",
    "dropmalcty": "COTUIT",
    "dropmalst": "MA",
    "dropmalzpp": "026359998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084280756,
    "dropfax": 5084284530
  },
  {
    "dcode": "D",
    "dropkey": "PV21645",
    "droptype": "D",
    "dropname": "CUMMAQUID",
    "dropdeladd": "4029 MAIN ST",
    "dropdelcty": "CUMMAQUID",
    "dropdelst": "MA",
    "dropdelzpp": "026379800",
    "dropphyadd": "4029 MAIN ST",
    "dropphycty": "CUMMAQUID",
    "dropphyst": "MA",
    "dropphyzpp": "026379800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUMMAQUID",
    "dropmalst": "MA",
    "dropmalzpp": "026379998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083629228,
    "dropfax": 5083628653
  },
  {
    "dcode": "D",
    "dropkey": "PV21646",
    "droptype": "D",
    "dropname": "CUMMINGTON",
    "dropdeladd": "21 MAIN ST STE 103",
    "dropdelcty": "CUMMINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "010269998",
    "dropphyadd": "21 MAIN ST STE 103",
    "dropphycty": "CUMMINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "010269998",
    "dropmaladd": "21 MAIN ST STE 103",
    "dropmalcty": "CUMMINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "010269998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4136348867,
    "dropsitcph": 4136348867,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21648",
    "droptype": "D",
    "dropname": "CUTTYHUNK",
    "dropdeladd": "13A BROADWAY",
    "dropdelcty": "CUTTYHUNK",
    "dropdelst": "MA",
    "dropdelzpp": "027139800",
    "dropphyadd": "13A BROADWAY",
    "dropphycty": "CUTTYHUNK",
    "dropphyst": "MA",
    "dropphyzpp": "027139800",
    "dropmaladd": "13A BROADWAY",
    "dropmalcty": "CUTTYHUNK",
    "dropmalst": "MA",
    "dropmalzpp": "027139800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089947392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21650",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "609 MAIN ST",
    "dropdelcty": "DALTON",
    "dropdelst": "MA",
    "dropdelzpp": "012269998",
    "dropphyadd": "609 MAIN ST",
    "dropphycty": "DALTON",
    "dropphyst": "MA",
    "dropphyzpp": "012269998",
    "dropmaladd": "609 MAIN ST",
    "dropmalcty": "DALTON",
    "dropmalst": "MA",
    "dropmalzpp": "012269998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4136840364,
    "dropsitcph": 4136840364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21651",
    "droptype": "D",
    "dropname": "DANVERS",
    "dropdeladd": "17 CONANT ST",
    "dropdelcty": "DANVERS",
    "dropdelst": "MA",
    "dropdelzpp": "019239998",
    "dropphyadd": "17 CONANT ST",
    "dropphycty": "DANVERS",
    "dropphyst": "MA",
    "dropphyzpp": "019239998",
    "dropmaladd": "17 CONANT ST",
    "dropmalcty": "DANVERS",
    "dropmalst": "MA",
    "dropmalzpp": "019239998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787778214,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV21656",
    "droptype": "D",
    "dropname": "DEDHAM",
    "dropdeladd": "611 HIGH ST",
    "dropdelcty": "DEDHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020269998",
    "dropphyadd": "611 HIGH ST",
    "dropphycty": "DEDHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020269998",
    "dropmaladd": "611 HIGH ST",
    "dropmalcty": "DEDHAM",
    "dropmalst": "MA",
    "dropmalzpp": "020269998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7813263462,
    "dropfax": 7812510285
  },
  {
    "dcode": "D",
    "dropkey": "PV21658",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "75 OLD MAIN ST",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013429998",
    "dropphyadd": "75 OLD MAIN ST",
    "dropphycty": "DEERFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013429998",
    "dropmaladd": "75 OLD MAIN ST",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013429998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137733222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21660",
    "droptype": "D",
    "dropname": "DENNIS",
    "dropdeladd": "788 MAIN ST",
    "dropdelcty": "DENNIS",
    "dropdelst": "MA",
    "dropdelzpp": "026389998",
    "dropphyadd": "788 MAIN ST",
    "dropphycty": "DENNIS",
    "dropphyst": "MA",
    "dropphyzpp": "026389998",
    "dropmaladd": "788 MAIN ST",
    "dropmalcty": "DENNIS",
    "dropmalst": "MA",
    "dropmalzpp": "026389998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083856834,
    "dropfax": 5083857293
  },
  {
    "dcode": "D",
    "dropkey": "PV21661",
    "droptype": "D",
    "dropname": "DENNIS PORT",
    "dropdeladd": "3 MILL ST",
    "dropdelcty": "DENNIS PORT",
    "dropdelst": "MA",
    "dropdelzpp": "026399998",
    "dropphyadd": "3 MILL ST",
    "dropphycty": "DENNIS PORT",
    "dropphyst": "MA",
    "dropphyzpp": "026399998",
    "dropmaladd": "3 MILL ST",
    "dropmalcty": "DENNIS PORT",
    "dropmalst": "MA",
    "dropmalzpp": "026399998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083984214,
    "dropfax": 5083984612
  },
  {
    "dcode": "D",
    "dropkey": "PV21663",
    "droptype": "D",
    "dropname": "DIGHTON",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "DIGHTON",
    "dropdelst": "MA",
    "dropdelzpp": "027151259",
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "DIGHTON",
    "dropphyst": "MA",
    "dropphyzpp": "027151259",
    "dropmaladd": "232 MAIN ST",
    "dropmalcty": "DIGHTON",
    "dropmalst": "MA",
    "dropmalzpp": "027151259",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086696308,
    "dropfax": 5086696308
  },
  {
    "dcode": "D",
    "dropkey": "PV21672",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "5 WALPOLE ST",
    "dropdelcty": "DOVER",
    "dropdelst": "MA",
    "dropdelzpp": "020309998",
    "dropphyadd": "5 WALPOLE ST",
    "dropphycty": "DOVER",
    "dropphyst": "MA",
    "dropphyzpp": "020309998",
    "dropmaladd": "5 WALPOLE ST",
    "dropmalcty": "DOVER",
    "dropmalst": "MA",
    "dropmalzpp": "020309998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087853152,
    "dropfax": 5087852648
  },
  {
    "dcode": "D",
    "dropkey": "PV21674",
    "droptype": "D",
    "dropname": "DRACUT",
    "dropdeladd": "54 BROADWAY RD",
    "dropdelcty": "DRACUT",
    "dropdelst": "MA",
    "dropdelzpp": "018269998",
    "dropphyadd": "54 BROADWAY RD",
    "dropphycty": "DRACUT",
    "dropphyst": "MA",
    "dropphyzpp": "018269998",
    "dropmaladd": "54 BROADWAY RD",
    "dropmalcty": "DRACUT",
    "dropmalst": "MA",
    "dropmalzpp": "018269998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784412458,
    "dropfax": 9789379076
  },
  {
    "dcode": "D",
    "dropkey": "PV21679",
    "droptype": "D",
    "dropname": "DUNSTABLE",
    "dropdeladd": "170 PLEASANT ST",
    "dropdelcty": "DUNSTABLE",
    "dropdelst": "MA",
    "dropdelzpp": "018271719",
    "dropphyadd": "170 PLEASANT ST",
    "dropphycty": "DUNSTABLE",
    "dropphyst": "MA",
    "dropphyzpp": "018271719",
    "dropmaladd": "170 PLEASANT ST",
    "dropmalcty": "DUNSTABLE",
    "dropmalst": "MA",
    "dropmalzpp": "018271719",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786496368,
    "dropfax": 9786494168
  },
  {
    "dcode": "D",
    "dropkey": "PV21680",
    "droptype": "D",
    "dropname": "DUXBURY",
    "dropdeladd": "56 DEPOT ST",
    "dropdelcty": "DUXBURY",
    "dropdelst": "MA",
    "dropdelzpp": "023329998",
    "dropphyadd": "56 DEPOT ST",
    "dropphycty": "DUXBURY",
    "dropphyst": "MA",
    "dropphyzpp": "023329998",
    "dropmaladd": "56 DEPOT ST",
    "dropmalcty": "DUXBURY",
    "dropmalst": "MA",
    "dropmalzpp": "023329998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7819345185,
    "dropfax": 7819344662
  },
  {
    "dcode": "D",
    "dropkey": "PV21707",
    "droptype": "D",
    "dropname": "EAST BRIDGEWATER",
    "dropdeladd": "63 W UNION ST",
    "dropdelcty": "EAST BRIDGEWATER",
    "dropdelst": "MA",
    "dropdelzpp": "023339998",
    "dropphyadd": "63 W UNION ST",
    "dropphycty": "EAST BRIDGEWATER",
    "dropphyst": "MA",
    "dropphyzpp": "023339998",
    "dropmaladd": "63 W UNION ST",
    "dropmalcty": "EAST BRIDGEWATER",
    "dropmalst": "MA",
    "dropmalzpp": "023339998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083787537,
    "dropfax": 5083781397
  },
  {
    "dcode": "D",
    "dropkey": "PV21709",
    "droptype": "D",
    "dropname": "EAST BROOKFIELD",
    "dropdeladd": "103 MECHANIC ST",
    "dropdelcty": "EAST BROOKFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "015159998",
    "dropphyadd": "103 MECHANIC ST",
    "dropphycty": "EAST BROOKFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "015159998",
    "dropmaladd": "103 MECHANIC ST",
    "dropmalcty": "EAST BROOKFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "015159998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088675396,
    "dropfax": 5088675526
  },
  {
    "dcode": "D",
    "dropkey": "PV21716",
    "droptype": "D",
    "dropname": "EAST DENNIS",
    "dropdeladd": "1600 MAIN ST",
    "dropdelcty": "EAST DENNIS",
    "dropdelst": "MA",
    "dropdelzpp": "026419800",
    "dropphyadd": "1600 MAIN ST",
    "dropphycty": "EAST DENNIS",
    "dropphyst": "MA",
    "dropphyzpp": "026419800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST DENNIS",
    "dropmalst": "MA",
    "dropmalzpp": "026419998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083853400,
    "dropfax": 5083857744
  },
  {
    "dcode": "D",
    "dropkey": "PV21717",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "331 MAIN ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "MA",
    "dropdelzpp": "015169998",
    "dropphyadd": "331 MAIN ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "MA",
    "dropphyzpp": "015169998",
    "dropmaladd": "331 MAIN ST",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "MA",
    "dropmalzpp": "015169998",
    "dropsitphn": 9786647013,
    "dropsitlph": 5084767775,
    "dropsitcph": 5084762750,
    "dropfax": 5084761284
  },
  {
    "dcode": "D",
    "dropkey": "PV21718",
    "droptype": "D",
    "dropname": "EAST FALMOUTH",
    "dropdeladd": "451 E FALMOUTH HWY",
    "dropdelcty": "EAST FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025369998",
    "dropphyadd": "451 E FALMOUTH HWY",
    "dropphycty": "EAST FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025369998",
    "dropmaladd": "451 E FALMOUTH HWY",
    "dropmalcty": "EAST FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025369998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085482393,
    "dropfax": 5085482774
  },
  {
    "dcode": "D",
    "dropkey": "PV21719",
    "droptype": "D",
    "dropname": "EAST FREETOWN",
    "dropdeladd": "10 CROSSROAD DR",
    "dropdelcty": "EAST FREETOWN",
    "dropdelst": "MA",
    "dropdelzpp": "027171642",
    "dropphyadd": "10 CROSSROAD DR",
    "dropphycty": "EAST FREETOWN",
    "dropphyst": "MA",
    "dropphyzpp": "027171642",
    "dropmaladd": "10 CROSSROAD DR",
    "dropmalcty": "EAST FREETOWN",
    "dropmalst": "MA",
    "dropmalzpp": "027171642",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087635372,
    "dropfax": 5087638965
  },
  {
    "dcode": "D",
    "dropkey": "PV21724",
    "droptype": "D",
    "dropname": "EAST LONGMEADOW",
    "dropdeladd": "119 INDUSTRIAL DR",
    "dropdelcty": "EAST LONGMEADOW",
    "dropdelst": "MA",
    "dropdelzpp": "010289998",
    "dropphyadd": "119 INDUSTRIAL DR",
    "dropphycty": "EAST LONGMEADOW",
    "dropphyst": "MA",
    "dropphyzpp": "010289998",
    "dropmaladd": "119 INDUSTRIAL DR",
    "dropmalcty": "EAST LONGMEADOW",
    "dropmalst": "MA",
    "dropmalzpp": "010289998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135258855,
    "dropfax": 4135258889
  },
  {
    "dcode": "D",
    "dropkey": "PV21734",
    "droptype": "D",
    "dropname": "EAST ORLEANS",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "EAST ORLEANS",
    "dropdelst": "MA",
    "dropdelzpp": "026439800",
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "EAST ORLEANS",
    "dropphyst": "MA",
    "dropphyzpp": "026439800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST ORLEANS",
    "dropmalst": "MA",
    "dropmalzpp": "026439998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082554078,
    "dropfax": 5082555946
  },
  {
    "dcode": "D",
    "dropkey": "PV21735",
    "droptype": "D",
    "dropname": "EAST OTIS",
    "dropdeladd": "1722 E OTIS RD",
    "dropdelcty": "EAST OTIS",
    "dropdelst": "MA",
    "dropdelzpp": "010299998",
    "dropphyadd": "1722 E OTIS RD",
    "dropphycty": "EAST OTIS",
    "dropphyst": "MA",
    "dropphyzpp": "010299998",
    "dropmaladd": "1722 E OTIS RD",
    "dropmalcty": "EAST OTIS",
    "dropmalst": "MA",
    "dropmalzpp": "010299998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132697227,
    "dropfax": 4132690297
  },
  {
    "dcode": "D",
    "dropkey": "PV21738",
    "droptype": "D",
    "dropname": "EAST PRINCETON",
    "dropdeladd": "76B MAIN ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "MA",
    "dropdelzpp": "015411016",
    "dropphyadd": "76B MAIN ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "MA",
    "dropphyzpp": "015411016",
    "dropmaladd": "76B MAIN ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "MA",
    "dropmalzpp": "015411016",
    "dropsitphn": 5086647013,
    "dropsitlph": 5086647013,
    "dropsitcph": 5084642811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21739",
    "droptype": "D",
    "dropname": "EAST SANDWICH",
    "dropdeladd": "443 ROUTE 6A",
    "dropdelcty": "EAST SANDWICH",
    "dropdelst": "MA",
    "dropdelzpp": "025379998",
    "dropphyadd": "443 ROUTE 6A",
    "dropphycty": "EAST SANDWICH",
    "dropphyst": "MA",
    "dropphyzpp": "025379998",
    "dropmaladd": "443 ROUTE 6A",
    "dropmalcty": "EAST SANDWICH",
    "dropmalst": "MA",
    "dropmalzpp": "025379998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088334684,
    "dropfax": 5088338910
  },
  {
    "dcode": "D",
    "dropkey": "PV21742",
    "droptype": "D",
    "dropname": "EAST TEMPLETON",
    "dropdeladd": "132B PATRIOTS RD",
    "dropdelcty": "EAST TEMPLETON",
    "dropdelst": "MA",
    "dropdelzpp": "014389800",
    "dropphyadd": "132B PATRIOTS RD",
    "dropphycty": "EAST TEMPLETON",
    "dropphyst": "MA",
    "dropphyzpp": "014389800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST TEMPLETON",
    "dropmalst": "MA",
    "dropmalzpp": "014389998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786327635,
    "dropfax": 9786300085
  },
  {
    "dcode": "D",
    "dropkey": "PV21744",
    "droptype": "D",
    "dropname": "EAST WALPOLE",
    "dropdeladd": "31 UNION ST",
    "dropdelcty": "EAST WALPOLE",
    "dropdelst": "MA",
    "dropdelzpp": "020329998",
    "dropphyadd": "31 UNION ST",
    "dropphycty": "EAST WALPOLE",
    "dropphyst": "MA",
    "dropphyzpp": "020329998",
    "dropmaladd": "31 UNION ST",
    "dropmalcty": "EAST WALPOLE",
    "dropmalst": "MA",
    "dropmalzpp": "020329998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086601592,
    "dropfax": 5086608317
  },
  {
    "dcode": "D",
    "dropkey": "PV21745",
    "droptype": "D",
    "dropname": "EAST WAREHAM",
    "dropdeladd": "2991C CRANBERRY HWY",
    "dropdelcty": "EAST WAREHAM",
    "dropdelst": "MA",
    "dropdelzpp": "025389998",
    "dropphyadd": "2991C CRANBERRY HWY",
    "dropphycty": "EAST WAREHAM",
    "dropphyst": "MA",
    "dropphyzpp": "025389998",
    "dropmaladd": "2991C CRANBERRY HWY",
    "dropmalcty": "EAST WAREHAM",
    "dropmalst": "MA",
    "dropmalzpp": "025389998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082959065,
    "dropfax": 5082955451
  },
  {
    "dcode": "D",
    "dropkey": "PV21749",
    "droptype": "D",
    "dropname": "EASTHAM",
    "dropdeladd": "2365 STATE HWY",
    "dropdelcty": "EASTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026429998",
    "dropphyadd": "2365 STATE HWY",
    "dropphycty": "EASTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026429998",
    "dropmaladd": "2365 STATE HWY",
    "dropmalcty": "EASTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026429998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082550671,
    "dropfax": 5082550864
  },
  {
    "dcode": "D",
    "dropkey": "PV21750",
    "droptype": "D",
    "dropname": "EASTHAMPTON",
    "dropdeladd": "191 NORTHAMPTON ST",
    "dropdelcty": "EASTHAMPTON",
    "dropdelst": "MA",
    "dropdelzpp": "010279998",
    "dropphyadd": "191 NORTHAMPTON ST",
    "dropphycty": "EASTHAMPTON",
    "dropphyst": "MA",
    "dropphyzpp": "010279998",
    "dropmaladd": "191 NORTHAMPTON ST",
    "dropmalcty": "EASTHAMPTON",
    "dropmalst": "MA",
    "dropmalzpp": "010279998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135270060,
    "dropfax": 4135299819
  },
  {
    "dcode": "D",
    "dropkey": "PV21751",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "670 DEPOT ST",
    "dropdelcty": "EASTON",
    "dropdelst": "MA",
    "dropdelzpp": "023349800",
    "dropphyadd": "670 DEPOT ST",
    "dropphycty": "EASTON",
    "dropphyst": "MA",
    "dropphyzpp": "023349800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTON",
    "dropmalst": "MA",
    "dropmalzpp": "023349998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082385369,
    "dropfax": 5082386616
  },
  {
    "dcode": "D",
    "dropkey": "PV21754",
    "droptype": "D",
    "dropname": "EDGARTOWN",
    "dropdeladd": "236B EDGARTOWN RD",
    "dropdelcty": "EDGARTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "025399800",
    "dropphyadd": "236B EDGARTOWN RD",
    "dropphycty": "EDGARTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "025399800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGARTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "025399998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086277319,
    "dropfax": 5086277963
  },
  {
    "dcode": "D",
    "dropkey": "PV21758",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "734 BEDFORD ST",
    "dropdelcty": "ELMWOOD",
    "dropdelst": "MA",
    "dropdelzpp": "023379800",
    "dropphyadd": "734 BEDFORD ST",
    "dropphycty": "ELMWOOD",
    "dropphyst": "MA",
    "dropphyzpp": "023379800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMWOOD",
    "dropmalst": "MA",
    "dropmalzpp": "023379998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083784352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21759",
    "droptype": "D",
    "dropname": "ERVING",
    "dropdeladd": "54 FRENCH KING HWY",
    "dropdelcty": "ERVING",
    "dropdelst": "MA",
    "dropdelzpp": "013449998",
    "dropphyadd": "54 FRENCH KING HWY",
    "dropphycty": "ERVING",
    "dropphyst": "MA",
    "dropphyzpp": "013449998",
    "dropmaladd": "54 FRENCH KING HWY",
    "dropmalcty": "ERVING",
    "dropmalst": "MA",
    "dropmalzpp": "013449998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134233600,
    "dropfax": 4134233700
  },
  {
    "dcode": "D",
    "dropkey": "PV21762",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "4 MARTIN ST",
    "dropdelcty": "ESSEX",
    "dropdelst": "MA",
    "dropdelzpp": "019299998",
    "dropphyadd": "4 MARTIN ST",
    "dropphycty": "ESSEX",
    "dropphyst": "MA",
    "dropphyzpp": "019299998",
    "dropmaladd": "4 MARTIN ST",
    "dropmalcty": "ESSEX",
    "dropmalst": "MA",
    "dropmalzpp": "019299998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787680097,
    "dropfax": 9787683946
  },
  {
    "dcode": "D",
    "dropkey": "PV21764",
    "droptype": "D",
    "dropname": "FAIRHAVEN",
    "dropdeladd": "13 WILLIAM ST",
    "dropdelcty": "FAIRHAVEN",
    "dropdelst": "MA",
    "dropdelzpp": "027199998",
    "dropphyadd": "13 WILLIAM ST",
    "dropphycty": "FAIRHAVEN",
    "dropphyst": "MA",
    "dropphyzpp": "027199998",
    "dropmaladd": "13 WILLIAM ST",
    "dropmalcty": "FAIRHAVEN",
    "dropmalst": "MA",
    "dropmalzpp": "027199998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089924410,
    "dropfax": 5089795904
  },
  {
    "dcode": "D",
    "dropkey": "PV21766",
    "droptype": "D",
    "dropname": "FALL RIVER",
    "dropdeladd": "2 GOVERNMENT CTR",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "027229998",
    "dropphyadd": "2 GOVERNMENT CTR",
    "dropphycty": "FALL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "027229998",
    "dropmaladd": "2 GOVERNMENT CTR",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "027229998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086466565,
    "dropfax": 5086774884
  },
  {
    "dcode": "D",
    "dropkey": "PV21767",
    "droptype": "D",
    "dropname": "FALMOUTH",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025409998",
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025409998",
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025409998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084570158,
    "dropfax": 5084574113
  },
  {
    "dcode": "D",
    "dropkey": "PV21774",
    "droptype": "D",
    "dropname": "FEEDING HILLS",
    "dropdeladd": "1339 SPRINGFIELD ST",
    "dropdelcty": "FEEDING HILLS",
    "dropdelst": "MA",
    "dropdelzpp": "010309998",
    "dropphyadd": "1339 SPRINGFIELD ST",
    "dropphycty": "FEEDING HILLS",
    "dropphyst": "MA",
    "dropphyzpp": "010309998",
    "dropmaladd": "1339 SPRINGFIELD ST",
    "dropmalcty": "FEEDING HILLS",
    "dropmalst": "MA",
    "dropmalzpp": "010309998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137861030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21782",
    "droptype": "D",
    "dropname": "FISKDALE",
    "dropdeladd": "458 MAIN ST",
    "dropdelcty": "FISKDALE",
    "dropdelst": "MA",
    "dropdelzpp": "015189998",
    "dropphyadd": "458 MAIN ST",
    "dropphycty": "FISKDALE",
    "dropphyst": "MA",
    "dropphyzpp": "015189998",
    "dropmaladd": "458 MAIN ST",
    "dropmalcty": "FISKDALE",
    "dropmalst": "MA",
    "dropmalzpp": "015189998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083476486,
    "dropfax": 5083472290
  },
  {
    "dcode": "D",
    "dropkey": "PV21783",
    "droptype": "D",
    "dropname": "FITCHBURG",
    "dropdeladd": "881 MAIN ST STE E",
    "dropdelcty": "FITCHBURG",
    "dropdelst": "MA",
    "dropdelzpp": "014209998",
    "dropphyadd": "881 MAIN ST STE E",
    "dropphycty": "FITCHBURG",
    "dropphyst": "MA",
    "dropphyzpp": "014209998",
    "dropmaladd": "881 MAIN ST STE E",
    "dropmalcty": "FITCHBURG",
    "dropmalst": "MA",
    "dropmalzpp": "014209998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783426343,
    "dropfax": 9783423614
  },
  {
    "dcode": "D",
    "dropkey": "PV21792",
    "droptype": "D",
    "dropname": "FORESTDALE",
    "dropdeladd": "290 ROUTE 130",
    "dropdelcty": "FORESTDALE",
    "dropdelst": "MA",
    "dropdelzpp": "026449998",
    "dropphyadd": "290 ROUTE 130",
    "dropphycty": "FORESTDALE",
    "dropphyst": "MA",
    "dropphyzpp": "026449998",
    "dropmaladd": "290 ROUTE 130",
    "dropmalcty": "FORESTDALE",
    "dropmalst": "MA",
    "dropmalzpp": "026449998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088330811,
    "dropfax": 5088330814
  },
  {
    "dcode": "D",
    "dropkey": "PV21797",
    "droptype": "D",
    "dropname": "FOXBORO",
    "dropdeladd": "15 WALL ST",
    "dropdelcty": "FOXBORO",
    "dropdelst": "MA",
    "dropdelzpp": "020359998",
    "dropphyadd": "15 WALL ST",
    "dropphycty": "FOXBORO",
    "dropphyst": "MA",
    "dropphyzpp": "020359998",
    "dropmaladd": "15 WALL ST",
    "dropmalcty": "FOXBORO",
    "dropmalst": "MA",
    "dropmalzpp": "020359998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085435821,
    "dropfax": 5085432501
  },
  {
    "dcode": "D",
    "dropkey": "PV21800",
    "droptype": "D",
    "dropname": "FRAMINGHAM",
    "dropdeladd": "330 COCHITUATE RD",
    "dropdelcty": "FRAMINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "017019998",
    "dropphyadd": "330 COCHITUATE RD",
    "dropphycty": "FRAMINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "017019998",
    "dropmaladd": "330 COCHITUATE RD",
    "dropmalcty": "FRAMINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "017019998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5086200400,
    "dropfax": 5088755311
  },
  {
    "dcode": "D",
    "dropkey": "PV21805",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "43 MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MA",
    "dropdelzpp": "020389998",
    "dropphyadd": "43 MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MA",
    "dropphyzpp": "020389998",
    "dropmaladd": "43 MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MA",
    "dropmalzpp": "020389998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085202210,
    "dropfax": 5085418682
  },
  {
    "dcode": "D",
    "dropkey": "PV21808",
    "droptype": "D",
    "dropname": "GARDNER",
    "dropdeladd": "69 PLEASANT ST",
    "dropdelcty": "GARDNER",
    "dropdelst": "MA",
    "dropdelzpp": "014409998",
    "dropphyadd": "69 PLEASANT ST",
    "dropphycty": "GARDNER",
    "dropphyst": "MA",
    "dropphyzpp": "014409998",
    "dropmaladd": "69 PLEASANT ST",
    "dropmalcty": "GARDNER",
    "dropmalst": "MA",
    "dropmalzpp": "014409998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786325697,
    "dropfax": 9786320328
  },
  {
    "dcode": "D",
    "dropkey": "PV21814",
    "droptype": "D",
    "dropname": "GILBERTVILLE",
    "dropdeladd": "39 NORTH ST",
    "dropdelcty": "GILBERTVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "010319998",
    "dropphyadd": "39 NORTH ST",
    "dropphycty": "GILBERTVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "010319998",
    "dropmaladd": "39 NORTH ST",
    "dropmalcty": "GILBERTVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "010319998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134778854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21821",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "17 GLENDALE RD",
    "dropdelcty": "GLENDALE",
    "dropdelst": "MA",
    "dropdelzpp": "012299998",
    "dropphyadd": "17 GLENDALE RD",
    "dropphycty": "GLENDALE",
    "dropphyst": "MA",
    "dropphyzpp": "012299998",
    "dropmaladd": "17 GLENDALE RD",
    "dropmalcty": "GLENDALE",
    "dropmalst": "MA",
    "dropmalzpp": "012299998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132983704,
    "dropfax": 4137856465
  },
  {
    "dcode": "D",
    "dropkey": "PV21825",
    "droptype": "D",
    "dropname": "GLOUCESTER",
    "dropdeladd": "15 DALE AVE",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "019309998",
    "dropphyadd": "15 DALE AVE",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "019309998",
    "dropmaladd": "15 DALE AVE",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "019309998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782832361,
    "dropfax": 9782837394
  },
  {
    "dcode": "D",
    "dropkey": "PV21826",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "33C MAIN ST",
    "dropdelcty": "GOSHEN",
    "dropdelst": "MA",
    "dropdelzpp": "010329998",
    "dropphyadd": "33C MAIN ST",
    "dropphycty": "GOSHEN",
    "dropphyst": "MA",
    "dropphyzpp": "010329998",
    "dropmaladd": "33C MAIN ST",
    "dropmalcty": "GOSHEN",
    "dropmalst": "MA",
    "dropmalzpp": "010329998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132689218,
    "dropfax": 4132683626
  },
  {
    "dcode": "D",
    "dropkey": "PV21830",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "23 UPTON ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "MA",
    "dropdelzpp": "015199998",
    "dropphyadd": "23 UPTON ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "MA",
    "dropphyzpp": "015199998",
    "dropmaladd": "23 UPTON ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "MA",
    "dropmalzpp": "015199998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088395406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21831",
    "droptype": "D",
    "dropname": "GRANBY",
    "dropdeladd": "63 W STATE ST",
    "dropdelcty": "GRANBY",
    "dropdelst": "MA",
    "dropdelzpp": "010339998",
    "dropphyadd": "63 W STATE ST",
    "dropphycty": "GRANBY",
    "dropphyst": "MA",
    "dropphyzpp": "010339998",
    "dropmaladd": "63 W STATE ST",
    "dropmalcty": "GRANBY",
    "dropmalst": "MA",
    "dropmalzpp": "010339998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134677099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21833",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "467 MAIN RD",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "010349998",
    "dropphyadd": "467 MAIN RD",
    "dropphycty": "GRANVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "010349998",
    "dropmaladd": "467 MAIN RD",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "010349998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136669000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21837",
    "droptype": "D",
    "dropname": "GREAT BARRINGTON",
    "dropdeladd": "222 MAIN ST",
    "dropdelcty": "GREAT BARRINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "012309998",
    "dropphyadd": "222 MAIN ST",
    "dropphycty": "GREAT BARRINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "012309998",
    "dropmaladd": "222 MAIN ST",
    "dropmalcty": "GREAT BARRINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "012309998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4135283670,
    "dropsitcph": 4135283670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21839",
    "droptype": "D",
    "dropname": "GREEN HARBOR",
    "dropdeladd": "62A BEACH ST",
    "dropdelcty": "GREEN HARBOR",
    "dropdelst": "MA",
    "dropdelzpp": "020419800",
    "dropphyadd": "62A BEACH ST",
    "dropphycty": "GREEN HARBOR",
    "dropphyst": "MA",
    "dropphyzpp": "020419800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN HARBOR",
    "dropmalst": "MA",
    "dropmalzpp": "020419998",
    "dropsitphn": 4017525649,
    "dropsitlph": 5084270159,
    "dropsitcph": 7818346490,
    "dropfax": 7818372460
  },
  {
    "dcode": "D",
    "dropkey": "PV21845",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "442 MAIN ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013019998",
    "dropphyadd": "442 MAIN ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013019998",
    "dropmaladd": "442 MAIN ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013019998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137733654,
    "dropfax": 4137744476
  },
  {
    "dcode": "D",
    "dropkey": "PV21851",
    "droptype": "D",
    "dropname": "GROTON",
    "dropdeladd": "80 BOSTON RD",
    "dropdelcty": "GROTON",
    "dropdelst": "MA",
    "dropdelzpp": "014509998",
    "dropphyadd": "80 BOSTON RD",
    "dropphycty": "GROTON",
    "dropphyst": "MA",
    "dropphyzpp": "014509998",
    "dropmaladd": "80 BOSTON RD",
    "dropmalcty": "GROTON",
    "dropmalst": "MA",
    "dropmalzpp": "014509998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784480628,
    "dropfax": 9784483408
  },
  {
    "dcode": "D",
    "dropkey": "PV21856",
    "droptype": "D",
    "dropname": "HADLEY",
    "dropdeladd": "186 RUSSELL ST",
    "dropdelcty": "HADLEY",
    "dropdelst": "MA",
    "dropdelzpp": "010359998",
    "dropphyadd": "186 RUSSELL ST",
    "dropphycty": "HADLEY",
    "dropphyst": "MA",
    "dropphyzpp": "010359998",
    "dropmaladd": "186 RUSSELL ST",
    "dropmalcty": "HADLEY",
    "dropmalst": "MA",
    "dropmalzpp": "010359998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135860961,
    "dropfax": 4135844815
  },
  {
    "dcode": "D",
    "dropkey": "PV21857",
    "droptype": "D",
    "dropname": "HALIFAX",
    "dropdeladd": "551 PLYMOUTH ST",
    "dropdelcty": "HALIFAX",
    "dropdelst": "MA",
    "dropdelzpp": "023389998",
    "dropphyadd": "551 PLYMOUTH ST",
    "dropphycty": "HALIFAX",
    "dropphyst": "MA",
    "dropphyzpp": "023389998",
    "dropmaladd": "551 PLYMOUTH ST",
    "dropmalcty": "HALIFAX",
    "dropmalst": "MA",
    "dropmalzpp": "023389998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7812938419,
    "dropfax": 7812934253
  },
  {
    "dcode": "D",
    "dropkey": "PV21858",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "589 BAY RD",
    "dropdelcty": "HAMILTON",
    "dropdelst": "MA",
    "dropdelzpp": "019369800",
    "dropphyadd": "589 BAY RD",
    "dropphycty": "HAMILTON",
    "dropphyst": "MA",
    "dropphyzpp": "019369800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMILTON",
    "dropmalst": "MA",
    "dropmalzpp": "019369998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784682672,
    "dropfax": 9783471029
  },
  {
    "dcode": "D",
    "dropkey": "PV21859",
    "droptype": "D",
    "dropname": "HAMPDEN",
    "dropdeladd": "534 MAIN ST",
    "dropdelcty": "HAMPDEN",
    "dropdelst": "MA",
    "dropdelzpp": "010369998",
    "dropphyadd": "534 MAIN ST",
    "dropphycty": "HAMPDEN",
    "dropphyst": "MA",
    "dropphyzpp": "010369998",
    "dropmaladd": "534 MAIN ST",
    "dropmalcty": "HAMPDEN",
    "dropmalst": "MA",
    "dropmalzpp": "010369998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135665393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21861",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "196 ROCKLAND ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "MA",
    "dropdelzpp": "023399998",
    "dropphyadd": "196 ROCKLAND ST",
    "dropphycty": "HANOVER",
    "dropphyst": "MA",
    "dropphyzpp": "023399998",
    "dropmaladd": "196 ROCKLAND ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "MA",
    "dropmalzpp": "023399998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818261618,
    "dropfax": 7818268303
  },
  {
    "dcode": "D",
    "dropkey": "PV21865",
    "droptype": "D",
    "dropname": "HANSON",
    "dropdeladd": "270 MAIN ST",
    "dropdelcty": "HANSON",
    "dropdelst": "MA",
    "dropdelzpp": "023419998",
    "dropphyadd": "270 MAIN ST",
    "dropphycty": "HANSON",
    "dropphyst": "MA",
    "dropphyzpp": "023419998",
    "dropmaladd": "270 MAIN ST",
    "dropmalcty": "HANSON",
    "dropmalst": "MA",
    "dropmalzpp": "023419998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7812937639,
    "dropfax": 7812949260
  },
  {
    "dcode": "D",
    "dropkey": "PV21866",
    "droptype": "D",
    "dropname": "HARDWICK",
    "dropdeladd": "14 BARRE RD",
    "dropdelcty": "HARDWICK",
    "dropdelst": "MA",
    "dropdelzpp": "010379998",
    "dropphyadd": "14 BARRE RD",
    "dropphycty": "HARDWICK",
    "dropphyst": "MA",
    "dropphyzpp": "010379998",
    "dropmaladd": "14 BARRE RD",
    "dropmalcty": "HARDWICK",
    "dropmalst": "MA",
    "dropmalzpp": "010379998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134776156,
    "dropfax": 4134770049
  },
  {
    "dcode": "D",
    "dropkey": "PV21868",
    "droptype": "D",
    "dropname": "HARVARD",
    "dropdeladd": "215 AYER RD",
    "dropdelcty": "HARVARD",
    "dropdelst": "MA",
    "dropdelzpp": "014519998",
    "dropphyadd": "215 AYER RD",
    "dropphycty": "HARVARD",
    "dropphyst": "MA",
    "dropphyzpp": "014519998",
    "dropmaladd": "215 AYER RD",
    "dropmalcty": "HARVARD",
    "dropmalst": "MA",
    "dropmalzpp": "014519998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784567949,
    "dropfax": 9784561280
  },
  {
    "dcode": "D",
    "dropkey": "PV21871",
    "droptype": "D",
    "dropname": "HARWICH",
    "dropdeladd": "1484 ORLEANS RD",
    "dropdelcty": "HARWICH",
    "dropdelst": "MA",
    "dropdelzpp": "026459998",
    "dropphyadd": "1484 ORLEANS RD",
    "dropphycty": "HARWICH",
    "dropphyst": "MA",
    "dropphyzpp": "026459998",
    "dropmaladd": "1484 ORLEANS RD",
    "dropmalcty": "HARWICH",
    "dropmalst": "MA",
    "dropmalzpp": "026459998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084328473,
    "dropfax": 5084320069
  },
  {
    "dcode": "D",
    "dropkey": "PV21872",
    "droptype": "D",
    "dropname": "HARWICH PORT",
    "dropdeladd": "10 POST OFFICE SQ",
    "dropdelcty": "HARWICH PORT",
    "dropdelst": "MA",
    "dropdelzpp": "026469998",
    "dropphyadd": "10 POST OFFICE SQ",
    "dropphycty": "HARWICH PORT",
    "dropphyst": "MA",
    "dropphyzpp": "026469998",
    "dropmaladd": "10 POST OFFICE SQ",
    "dropmalcty": "HARWICH PORT",
    "dropmalst": "MA",
    "dropmalzpp": "026469998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084306100,
    "dropfax": 5084329724
  },
  {
    "dcode": "D",
    "dropkey": "PV21878",
    "droptype": "D",
    "dropname": "HATFIELD",
    "dropdeladd": "7 SCHOOL ST",
    "dropdelcty": "HATFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010389998",
    "dropphyadd": "7 SCHOOL ST",
    "dropphycty": "HATFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010389998",
    "dropmaladd": "7 SCHOOL ST",
    "dropmalcty": "HATFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010389998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132475129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21880",
    "droptype": "D",
    "dropname": "HATHORNE",
    "dropdeladd": "496 MAPLE ST",
    "dropdelcty": "HATHORNE",
    "dropdelst": "MA",
    "dropdelzpp": "019379800",
    "dropphyadd": "496 MAPLE ST",
    "dropphycty": "HATHORNE",
    "dropphyst": "MA",
    "dropphyzpp": "019379800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HATHORNE",
    "dropmalst": "MA",
    "dropmalzpp": "019379998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787747305,
    "dropfax": 9787392354
  },
  {
    "dcode": "D",
    "dropkey": "PV21881",
    "droptype": "D",
    "dropname": "HAVERHILL",
    "dropdeladd": "2 WASHINGTON SQ",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "MA",
    "dropdelzpp": "018309998",
    "dropphyadd": "2 WASHINGTON SQ",
    "dropphycty": "HAVERHILL",
    "dropphyst": "MA",
    "dropphyzpp": "018309998",
    "dropmaladd": "2 WASHINGTON SQ",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "MA",
    "dropmalzpp": "018309998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783735417,
    "dropfax": 9783739700
  },
  {
    "dcode": "D",
    "dropkey": "PV21884",
    "droptype": "D",
    "dropname": "HAYDENVILLE",
    "dropdeladd": "140 MAIN ST",
    "dropdelcty": "HAYDENVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "010399998",
    "dropphyadd": "140 MAIN ST",
    "dropphycty": "HAYDENVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "010399998",
    "dropmaladd": "140 MAIN ST",
    "dropmalcty": "HAYDENVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "010399998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132687280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21892",
    "droptype": "D",
    "dropname": "HINGHAM",
    "dropdeladd": "121 NORTH ST",
    "dropdelcty": "HINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020439998",
    "dropphyadd": "121 NORTH ST",
    "dropphycty": "HINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020439998",
    "dropmaladd": "121 NORTH ST",
    "dropmalcty": "HINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "020439998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817490610,
    "dropfax": 7817492428
  },
  {
    "dcode": "D",
    "dropkey": "PV21893",
    "droptype": "D",
    "dropname": "HINSDALE",
    "dropdeladd": "25 MAPLE ST",
    "dropdelcty": "HINSDALE",
    "dropdelst": "MA",
    "dropdelzpp": "012359998",
    "dropphyadd": "25 MAPLE ST",
    "dropphycty": "HINSDALE",
    "dropphyst": "MA",
    "dropphyzpp": "012359998",
    "dropmaladd": "25 MAPLE ST",
    "dropmalcty": "HINSDALE",
    "dropmalst": "MA",
    "dropmalzpp": "012359998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136552910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21897",
    "droptype": "D",
    "dropname": "HOLBROOK",
    "dropdeladd": "333 PLYMOUTH ST",
    "dropdelcty": "HOLBROOK",
    "dropdelst": "MA",
    "dropdelzpp": "023439998",
    "dropphyadd": "333 PLYMOUTH ST",
    "dropphycty": "HOLBROOK",
    "dropphyst": "MA",
    "dropphyzpp": "023439998",
    "dropmaladd": "333 PLYMOUTH ST",
    "dropmalcty": "HOLBROOK",
    "dropmalst": "MA",
    "dropmalzpp": "023439998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817672346,
    "dropfax": 7817673550
  },
  {
    "dcode": "D",
    "dropkey": "PV21898",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "1037 MAIN ST",
    "dropdelcty": "HOLDEN",
    "dropdelst": "MA",
    "dropdelzpp": "015209998",
    "dropphyadd": "1037 MAIN ST",
    "dropphycty": "HOLDEN",
    "dropphyst": "MA",
    "dropphyzpp": "015209998",
    "dropmaladd": "1037 MAIN ST",
    "dropmalcty": "HOLDEN",
    "dropmalst": "MA",
    "dropmalzpp": "015209998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088297534,
    "dropfax": 5088295296
  },
  {
    "dcode": "D",
    "dropkey": "PV21901",
    "droptype": "D",
    "dropname": "HOLLISTON",
    "dropdeladd": "1661 WASHINGTON ST",
    "dropdelcty": "HOLLISTON",
    "dropdelst": "MA",
    "dropdelzpp": "017469998",
    "dropphyadd": "1661 WASHINGTON ST",
    "dropphycty": "HOLLISTON",
    "dropphyst": "MA",
    "dropphyzpp": "017469998",
    "dropmaladd": "1661 WASHINGTON ST",
    "dropmalcty": "HOLLISTON",
    "dropmalst": "MA",
    "dropmalzpp": "017469998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084291336,
    "dropfax": 5084293024
  },
  {
    "dcode": "D",
    "dropkey": "PV21902",
    "droptype": "D",
    "dropname": "HOLYOKE",
    "dropdeladd": "650 DWIGHT ST",
    "dropdelcty": "HOLYOKE",
    "dropdelst": "MA",
    "dropdelzpp": "010409998",
    "dropphyadd": "650 DWIGHT ST",
    "dropphycty": "HOLYOKE",
    "dropphyst": "MA",
    "dropphyzpp": "010409998",
    "dropmaladd": "650 DWIGHT ST",
    "dropmalcty": "HOLYOKE",
    "dropmalst": "MA",
    "dropmalzpp": "010409998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135344577,
    "dropfax": 4135345782
  },
  {
    "dcode": "D",
    "dropkey": "PV21904",
    "droptype": "D",
    "dropname": "HOPEDALE",
    "dropdeladd": "80 HOPEDALE ST",
    "dropdelcty": "HOPEDALE",
    "dropdelst": "MA",
    "dropdelzpp": "017479998",
    "dropphyadd": "80 HOPEDALE ST",
    "dropphycty": "HOPEDALE",
    "dropphyst": "MA",
    "dropphyzpp": "017479998",
    "dropmaladd": "80 HOPEDALE ST",
    "dropmalcty": "HOPEDALE",
    "dropmalst": "MA",
    "dropmalzpp": "017479998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084733974,
    "dropfax": 5084780528
  },
  {
    "dcode": "D",
    "dropkey": "PV21907",
    "droptype": "D",
    "dropname": "HOPKINTON",
    "dropdeladd": "5 CEDAR ST",
    "dropdelcty": "HOPKINTON",
    "dropdelst": "MA",
    "dropdelzpp": "017489998",
    "dropphyadd": "5 CEDAR ST",
    "dropphycty": "HOPKINTON",
    "dropphyst": "MA",
    "dropphyzpp": "017489998",
    "dropmaladd": "5 CEDAR ST",
    "dropmalcty": "HOPKINTON",
    "dropmalst": "MA",
    "dropmalzpp": "017489998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084358787,
    "dropfax": 5084357837
  },
  {
    "dcode": "D",
    "dropkey": "PV21911",
    "droptype": "D",
    "dropname": "HOUSATONIC",
    "dropdeladd": "11 DEPOT ST",
    "dropdelcty": "HOUSATONIC",
    "dropdelst": "MA",
    "dropdelzpp": "012369998",
    "dropphyadd": "11 DEPOT ST",
    "dropphycty": "HOUSATONIC",
    "dropphyst": "MA",
    "dropphyzpp": "012369998",
    "dropmaladd": "11 DEPOT ST",
    "dropmalcty": "HOUSATONIC",
    "dropmalst": "MA",
    "dropmalzpp": "012369998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132746640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21913",
    "droptype": "D",
    "dropname": "HUBBARDSTON",
    "dropdeladd": "6 MAIN ST",
    "dropdelcty": "HUBBARDSTON",
    "dropdelst": "MA",
    "dropdelzpp": "014529998",
    "dropphyadd": "6 MAIN ST",
    "dropphycty": "HUBBARDSTON",
    "dropphyst": "MA",
    "dropphyzpp": "014529998",
    "dropmaladd": "6 MAIN ST",
    "dropmalcty": "HUBBARDSTON",
    "dropmalst": "MA",
    "dropmalzpp": "014529998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789285947,
    "dropfax": 9789281308
  },
  {
    "dcode": "D",
    "dropkey": "PV21914",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "25 CHURCH ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "MA",
    "dropdelzpp": "017499998",
    "dropphyadd": "25 CHURCH ST",
    "dropphycty": "HUDSON",
    "dropphyst": "MA",
    "dropphyzpp": "017499998",
    "dropmaladd": "25 CHURCH ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "MA",
    "dropmalzpp": "017499998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785625551,
    "dropfax": 9785670906
  },
  {
    "dcode": "D",
    "dropkey": "PV21915",
    "droptype": "D",
    "dropname": "HULL",
    "dropdeladd": "515 NANTASKET AVE",
    "dropdelcty": "HULL",
    "dropdelst": "MA",
    "dropdelzpp": "020459998",
    "dropphyadd": "515 NANTASKET AVE",
    "dropphycty": "HULL",
    "dropphyst": "MA",
    "dropphyzpp": "020459998",
    "dropmaladd": "515 NANTASKET AVE",
    "dropmalcty": "HULL",
    "dropmalst": "MA",
    "dropmalzpp": "020459998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7819253745,
    "dropfax": 7819255974
  },
  {
    "dcode": "D",
    "dropkey": "PV21916",
    "droptype": "D",
    "dropname": "HUMAROCK",
    "dropdeladd": "10 CENTRAL AVE",
    "dropdelcty": "HUMAROCK",
    "dropdelst": "MA",
    "dropdelzpp": "020479800",
    "dropphyadd": "10 CENTRAL AVE",
    "dropphycty": "HUMAROCK",
    "dropphyst": "MA",
    "dropphyzpp": "020479800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMAROCK",
    "dropmalst": "MA",
    "dropmalzpp": "020479998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818341594,
    "dropfax": 7818378565
  },
  {
    "dcode": "D",
    "dropkey": "PV21918",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "16 RUSSELL RD",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "010509998",
    "dropphyadd": "16 RUSSELL RD",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "010509998",
    "dropmaladd": "16 RUSSELL RD",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "010509998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136673611,
    "dropfax": 4136673387
  },
  {
    "dcode": "D",
    "dropkey": "PV21919",
    "droptype": "D",
    "dropname": "HYANNIS",
    "dropdeladd": "385 MAIN ST",
    "dropdelcty": "HYANNIS",
    "dropdelst": "MA",
    "dropdelzpp": "026019998",
    "dropphyadd": "385 MAIN ST",
    "dropphycty": "HYANNIS",
    "dropphyst": "MA",
    "dropphyzpp": "026019998",
    "dropmaladd": "385 MAIN ST",
    "dropmalcty": "HYANNIS",
    "dropmalst": "MA",
    "dropmalzpp": "026019998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087757344,
    "dropfax": 5087780058
  },
  {
    "dcode": "D",
    "dropkey": "PV21920",
    "droptype": "D",
    "dropname": "HYANNIS PORT",
    "dropdeladd": "44 LONGWOOD AVE",
    "dropdelcty": "HYANNIS PORT",
    "dropdelst": "MA",
    "dropdelzpp": "026479800",
    "dropphyadd": "44 LONGWOOD AVE",
    "dropphycty": "HYANNIS PORT",
    "dropphyst": "MA",
    "dropphyzpp": "026479800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYANNIS PORT",
    "dropmalst": "MA",
    "dropmalzpp": "026479998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087752338,
    "dropfax": 5087710933
  },
  {
    "dcode": "D",
    "dropkey": "PV21931",
    "droptype": "D",
    "dropname": "IPSWICH",
    "dropdeladd": "27 MARKET ST",
    "dropdelcty": "IPSWICH",
    "dropdelst": "MA",
    "dropdelzpp": "019389998",
    "dropphyadd": "27 MARKET ST",
    "dropphycty": "IPSWICH",
    "dropphyst": "MA",
    "dropphyzpp": "019389998",
    "dropmaladd": "27 MARKET ST",
    "dropmalcty": "IPSWICH",
    "dropmalst": "MA",
    "dropmalzpp": "019389998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783562585,
    "dropfax": 9783565755
  },
  {
    "dcode": "D",
    "dropkey": "PV21938",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "140 PRINCETON ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "MA",
    "dropdelzpp": "015229998",
    "dropphyadd": "140 PRINCETON ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "MA",
    "dropphyzpp": "015229998",
    "dropmaladd": "140 PRINCETON ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "MA",
    "dropmalzpp": "015229998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088297194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21956",
    "droptype": "D",
    "dropname": "LAKE PLEASANT",
    "dropdeladd": "5 MONTAGUE AVE",
    "dropdelcty": "LAKE PLEASANT",
    "dropdelst": "MA",
    "dropdelzpp": "013479998",
    "dropphyadd": "5 MONTAGUE AVE",
    "dropphycty": "LAKE PLEASANT",
    "dropphyst": "MA",
    "dropphyzpp": "013479998",
    "dropmaladd": "5 MONTAGUE AVE",
    "dropmalcty": "LAKE PLEASANT",
    "dropmalst": "MA",
    "dropmalzpp": "013479998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133672135,
    "dropfax": 4133679707
  },
  {
    "dcode": "D",
    "dropkey": "PV21961",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "771 MAIN ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "MA",
    "dropdelzpp": "015239998",
    "dropphyadd": "771 MAIN ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "MA",
    "dropphyzpp": "015239998",
    "dropmaladd": "771 MAIN ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "MA",
    "dropmalzpp": "015239998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783654923,
    "dropfax": 9783686676
  },
  {
    "dcode": "D",
    "dropkey": "PV21963",
    "droptype": "D",
    "dropname": "LANESBOROUGH",
    "dropdeladd": "545 S MAIN ST",
    "dropdelcty": "LANESBOROUGH",
    "dropdelst": "MA",
    "dropdelzpp": "012379998",
    "dropphyadd": "545 S MAIN ST",
    "dropphycty": "LANESBOROUGH",
    "dropphyst": "MA",
    "dropphyzpp": "012379998",
    "dropmaladd": "545 S MAIN ST",
    "dropmalcty": "LANESBOROUGH",
    "dropmalst": "MA",
    "dropmalzpp": "012379998",
    "dropsitphn": 4134990850,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134990850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21967",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "431 COMMON ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "MA",
    "dropdelzpp": "018409998",
    "dropphyadd": "431 COMMON ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "MA",
    "dropphyzpp": "018409998",
    "dropmaladd": "431 COMMON ST",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "MA",
    "dropmalzpp": "018409998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786914588,
    "dropfax": 9786851061
  },
  {
    "dcode": "D",
    "dropkey": "PV21968",
    "droptype": "D",
    "dropname": "LEE",
    "dropdeladd": "35 FRANK P CONSOLATI WAY",
    "dropdelcty": "LEE",
    "dropdelst": "MA",
    "dropdelzpp": "012389998",
    "dropphyadd": "35 FRANK P CONSOLATI WAY",
    "dropphycty": "LEE",
    "dropphyst": "MA",
    "dropphyzpp": "012389998",
    "dropmaladd": "35 FRANK P CONSOLATI WAY",
    "dropmalcty": "LEE",
    "dropmalst": "MA",
    "dropmalzpp": "012389998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132431392,
    "dropfax": 4132431990
  },
  {
    "dcode": "D",
    "dropkey": "PV21969",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "24 MULBERRY ST",
    "dropdelcty": "LEEDS",
    "dropdelst": "MA",
    "dropdelzpp": "010539998",
    "dropphyadd": "24 MULBERRY ST",
    "dropphycty": "LEEDS",
    "dropphyst": "MA",
    "dropphyzpp": "010539998",
    "dropmaladd": "24 MULBERRY ST",
    "dropmalcty": "LEEDS",
    "dropmalst": "MA",
    "dropmalzpp": "010539998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135841078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21970",
    "droptype": "D",
    "dropname": "LEICESTER",
    "dropdeladd": "1199 MAIN ST STE 1",
    "dropdelcty": "LEICESTER",
    "dropdelst": "MA",
    "dropdelzpp": "015249998",
    "dropphyadd": "1199 MAIN ST STE 1",
    "dropphycty": "LEICESTER",
    "dropphyst": "MA",
    "dropphyzpp": "015249998",
    "dropmaladd": "1199 MAIN ST STE 1",
    "dropmalcty": "LEICESTER",
    "dropmalst": "MA",
    "dropmalzpp": "015249998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088927971,
    "dropfax": 5088921127
  },
  {
    "dcode": "D",
    "dropkey": "PV21972",
    "droptype": "D",
    "dropname": "LENOX",
    "dropdeladd": "68 MAIN ST STE A",
    "dropdelcty": "LENOX",
    "dropdelst": "MA",
    "dropdelzpp": "012409998",
    "dropphyadd": "68 MAIN ST STE A",
    "dropphycty": "LENOX",
    "dropphyst": "MA",
    "dropphyzpp": "012409998",
    "dropmaladd": "68 MAIN ST STE A",
    "dropmalcty": "LENOX",
    "dropmalst": "MA",
    "dropmalzpp": "012409998",
    "dropsitphn": 4137856246,
    "dropsitlph": "",
    "dropsitcph": 4136370710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21973",
    "droptype": "D",
    "dropname": "LENOX DALE",
    "dropdeladd": "42 CRYSTAL ST",
    "dropdelcty": "LENOX DALE",
    "dropdelst": "MA",
    "dropdelzpp": "012429998",
    "dropphyadd": "42 CRYSTAL ST",
    "dropphycty": "LENOX DALE",
    "dropphyst": "MA",
    "dropphyzpp": "012429998",
    "dropmaladd": "42 CRYSTAL ST",
    "dropmalcty": "LENOX DALE",
    "dropmalst": "MA",
    "dropmalzpp": "012429998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136370862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21975",
    "droptype": "D",
    "dropname": "LEOMINSTER",
    "dropdeladd": "68 MAIN ST",
    "dropdelcty": "LEOMINSTER",
    "dropdelst": "MA",
    "dropdelzpp": "014539998",
    "dropphyadd": "68 MAIN ST",
    "dropphycty": "LEOMINSTER",
    "dropphyst": "MA",
    "dropphyzpp": "014539998",
    "dropmaladd": "68 MAIN ST",
    "dropmalcty": "LEOMINSTER",
    "dropmalst": "MA",
    "dropmalzpp": "014539998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785348350,
    "dropfax": 9785342427
  },
  {
    "dcode": "D",
    "dropkey": "PV21976",
    "droptype": "D",
    "dropname": "LEVERETT",
    "dropdeladd": "7 MONTAGUE RD",
    "dropdelcty": "LEVERETT",
    "dropdelst": "MA",
    "dropdelzpp": "010549998",
    "dropphyadd": "7 MONTAGUE RD",
    "dropphycty": "LEVERETT",
    "dropphyst": "MA",
    "dropphyzpp": "010549998",
    "dropmaladd": "7 MONTAGUE RD",
    "dropmalcty": "LEVERETT",
    "dropmalst": "MA",
    "dropmalzpp": "010549998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135489000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21981",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "145 LINCOLN RD",
    "dropdelcty": "LINCOLN",
    "dropdelst": "MA",
    "dropdelzpp": "017739998",
    "dropphyadd": "145 LINCOLN RD",
    "dropphycty": "LINCOLN",
    "dropphyst": "MA",
    "dropphyzpp": "017739998",
    "dropmaladd": "145 LINCOLN RD",
    "dropmalcty": "LINCOLN",
    "dropmalst": "MA",
    "dropmalzpp": "017739998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812590161,
    "dropfax": 7812590162
  },
  {
    "dcode": "D",
    "dropkey": "PV21986",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "166 LINWOOD ST",
    "dropdelcty": "LINWOOD",
    "dropdelst": "MA",
    "dropdelzpp": "015259800",
    "dropphyadd": "166 LINWOOD ST",
    "dropphycty": "LINWOOD",
    "dropphyst": "MA",
    "dropphyzpp": "015259800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINWOOD",
    "dropmalst": "MA",
    "dropmalzpp": "015259998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082345490,
    "dropfax": 5082661094
  },
  {
    "dcode": "D",
    "dropkey": "PV21988",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "451 KING ST",
    "dropdelcty": "LITTLETON",
    "dropdelst": "MA",
    "dropdelzpp": "014609998",
    "dropphyadd": "451 KING ST",
    "dropphycty": "LITTLETON",
    "dropphyst": "MA",
    "dropphyzpp": "014609998",
    "dropmaladd": "451 KING ST",
    "dropmalcty": "LITTLETON",
    "dropmalst": "MA",
    "dropmalzpp": "014609998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784860939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21994",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "155 FATHER MORISSETTE BLVD",
    "dropdelcty": "LOWELL",
    "dropdelst": "MA",
    "dropdelzpp": "018549998",
    "dropphyadd": "155 FATHER MORISSETTE BLVD",
    "dropphycty": "LOWELL",
    "dropphyst": "MA",
    "dropphyzpp": "018549998",
    "dropmaladd": "155 FATHER MORISSETTE BLVD",
    "dropmalcty": "LOWELL",
    "dropmalst": "MA",
    "dropmalzpp": "018549998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789340997,
    "dropfax": 9784542195
  },
  {
    "dcode": "D",
    "dropkey": "PV21996",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "83 WINSOR ST",
    "dropdelcty": "LUDLOW",
    "dropdelst": "MA",
    "dropdelzpp": "010569998",
    "dropphyadd": "83 WINSOR ST",
    "dropphycty": "LUDLOW",
    "dropphyst": "MA",
    "dropphyzpp": "010569998",
    "dropmaladd": "83 WINSOR ST",
    "dropmalcty": "LUDLOW",
    "dropmalst": "MA",
    "dropmalzpp": "010569998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135833622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV21998",
    "droptype": "D",
    "dropname": "LUNENBURG",
    "dropdeladd": "945 MASSACHUSETTS AVE",
    "dropdelcty": "LUNENBURG",
    "dropdelst": "MA",
    "dropdelzpp": "014629998",
    "dropphyadd": "945 MASSACHUSETTS AVE",
    "dropphycty": "LUNENBURG",
    "dropphyst": "MA",
    "dropphyzpp": "014629998",
    "dropmaladd": "945 MASSACHUSETTS AVE",
    "dropmalcty": "LUNENBURG",
    "dropmalst": "MA",
    "dropmalzpp": "014629998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785820006,
    "dropfax": 9785827413
  },
  {
    "dcode": "D",
    "dropkey": "PV21999",
    "droptype": "D",
    "dropname": "LYNN",
    "dropdeladd": "51 WILLOW ST",
    "dropdelcty": "LYNN",
    "dropdelst": "MA",
    "dropdelzpp": "019019998",
    "dropphyadd": "51 WILLOW ST",
    "dropphycty": "LYNN",
    "dropphyst": "MA",
    "dropphyzpp": "019019998",
    "dropmaladd": "51 WILLOW ST",
    "dropmalcty": "LYNN",
    "dropmalst": "MA",
    "dropmalzpp": "019019998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 3394408504,
    "dropfax": 3394408495
  },
  {
    "dcode": "D",
    "dropkey": "PV22000",
    "droptype": "D",
    "dropname": "LYNNFIELD",
    "dropdeladd": "38 SUMMER ST",
    "dropdelcty": "LYNNFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "019409998",
    "dropphyadd": "38 SUMMER ST",
    "dropphycty": "LYNNFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "019409998",
    "dropmaladd": "38 SUMMER ST",
    "dropmalcty": "LYNNFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "019409998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7813343932,
    "dropfax": 7813340870
  },
  {
    "dcode": "D",
    "dropkey": "PV22009",
    "droptype": "D",
    "dropname": "MANCHAUG",
    "dropdeladd": "359 MANCHAUG RD",
    "dropdelcty": "MANCHAUG",
    "dropdelst": "MA",
    "dropdelzpp": "015269800",
    "dropphyadd": "359 MANCHAUG RD",
    "dropphycty": "MANCHAUG",
    "dropphyst": "MA",
    "dropphyzpp": "015269800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANCHAUG",
    "dropmalst": "MA",
    "dropmalzpp": "015269998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084762930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22010",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "15 BEACH ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "019449998",
    "dropphyadd": "15 BEACH ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "019449998",
    "dropmaladd": "15 BEACH ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "019449998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785264357,
    "dropfax": 9785268144
  },
  {
    "dcode": "D",
    "dropkey": "PV22012",
    "droptype": "D",
    "dropname": "MANOMET",
    "dropdeladd": "12 MANOMET POINT RD",
    "dropdelcty": "MANOMET",
    "dropdelst": "MA",
    "dropdelzpp": "023459800",
    "dropphyadd": "12 MANOMET POINT RD",
    "dropphycty": "MANOMET",
    "dropphyst": "MA",
    "dropphyzpp": "023459800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANOMET",
    "dropmalst": "MA",
    "dropmalzpp": "023459998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082249325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22013",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "12 GILES PL",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "020489998",
    "dropphyadd": "12 GILES PL",
    "dropphycty": "MANSFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "020489998",
    "dropmaladd": "12 GILES PL",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "020489998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083396942,
    "dropfax": 5082619789
  },
  {
    "dcode": "D",
    "dropkey": "PV22016",
    "droptype": "D",
    "dropname": "MARBLEHEAD",
    "dropdeladd": "27 SMITH ST",
    "dropdelcty": "MARBLEHEAD",
    "dropdelst": "MA",
    "dropdelzpp": "019459998",
    "dropphyadd": "27 SMITH ST",
    "dropphycty": "MARBLEHEAD",
    "dropphyst": "MA",
    "dropphyzpp": "019459998",
    "dropmaladd": "27 SMITH ST",
    "dropmalcty": "MARBLEHEAD",
    "dropmalst": "MA",
    "dropmalzpp": "019459998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7816312140,
    "dropfax": 7816391409
  },
  {
    "dcode": "D",
    "dropkey": "PV22018",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "143 FRONT ST",
    "dropdelcty": "MARION",
    "dropdelst": "MA",
    "dropdelzpp": "027381527",
    "dropphyadd": "143 FRONT ST",
    "dropphycty": "MARION",
    "dropphyst": "MA",
    "dropphyzpp": "027381527",
    "dropmaladd": "143 FRONT ST",
    "dropmalcty": "MARION",
    "dropmalst": "MA",
    "dropmalzpp": "027381527",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087483847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22020",
    "droptype": "D",
    "dropname": "MARLBOROUGH",
    "dropdeladd": "20 FLORENCE ST",
    "dropdelcty": "MARLBOROUGH",
    "dropdelst": "MA",
    "dropdelzpp": "017529998",
    "dropphyadd": "20 FLORENCE ST",
    "dropphycty": "MARLBOROUGH",
    "dropphyst": "MA",
    "dropphyzpp": "017529998",
    "dropmaladd": "20 FLORENCE ST",
    "dropmalcty": "MARLBOROUGH",
    "dropmalst": "MA",
    "dropmalzpp": "017529998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084854726,
    "dropfax": 5082298150
  },
  {
    "dcode": "D",
    "dropkey": "PV22021",
    "droptype": "D",
    "dropname": "MARSHFIELD",
    "dropdeladd": "111 SNOW RD",
    "dropdelcty": "MARSHFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "020509998",
    "dropphyadd": "111 SNOW RD",
    "dropphycty": "MARSHFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "020509998",
    "dropmaladd": "111 SNOW RD",
    "dropmalcty": "MARSHFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "020509998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818373802,
    "dropfax": 7818342045
  },
  {
    "dcode": "D",
    "dropkey": "PV22024",
    "droptype": "D",
    "dropname": "MARSHFIELD HILLS",
    "dropdeladd": "165 PROSPECT ST",
    "dropdelcty": "MARSHFIELD HILLS",
    "dropdelst": "MA",
    "dropdelzpp": "020519801",
    "dropphyadd": "165 PROSPECT ST",
    "dropphycty": "MARSHFIELD HILLS",
    "dropphyst": "MA",
    "dropphyzpp": "020519801",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHFIELD HILLS",
    "dropmalst": "MA",
    "dropmalzpp": "020519998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818377584,
    "dropfax": 7818377534
  },
  {
    "dcode": "D",
    "dropkey": "PV22028",
    "droptype": "D",
    "dropname": "MARSTONS MILLS",
    "dropdeladd": "40 RIVER RD",
    "dropdelcty": "MARSTONS MILLS",
    "dropdelst": "MA",
    "dropdelzpp": "026489998",
    "dropphyadd": "40 RIVER RD",
    "dropphycty": "MARSTONS MILLS",
    "dropphyst": "MA",
    "dropphyzpp": "026489998",
    "dropmaladd": "40 RIVER RD",
    "dropmalcty": "MARSTONS MILLS",
    "dropmalst": "MA",
    "dropmalzpp": "026489998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084283649,
    "dropfax": 5084287086
  },
  {
    "dcode": "D",
    "dropkey": "PV22035",
    "droptype": "D",
    "dropname": "MASHPEE",
    "dropdeladd": "11 MARKET ST",
    "dropdelcty": "MASHPEE",
    "dropdelst": "MA",
    "dropdelzpp": "026499998",
    "dropphyadd": "11 MARKET ST",
    "dropphycty": "MASHPEE",
    "dropphyst": "MA",
    "dropphyzpp": "026499998",
    "dropmaladd": "11 MARKET ST",
    "dropmalcty": "MASHPEE",
    "dropmalst": "MA",
    "dropmalzpp": "026499998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084774852,
    "dropfax": 5085392512
  },
  {
    "dcode": "D",
    "dropkey": "PV22040",
    "droptype": "D",
    "dropname": "MATTAPOISETT",
    "dropdeladd": "30 COUNTY RD",
    "dropdelcty": "MATTAPOISETT",
    "dropdelst": "MA",
    "dropdelzpp": "027391553",
    "dropphyadd": "30 COUNTY RD",
    "dropphycty": "MATTAPOISETT",
    "dropphyst": "MA",
    "dropphyzpp": "027391553",
    "dropmaladd": "30 COUNTY RD",
    "dropmalcty": "MATTAPOISETT",
    "dropmalst": "MA",
    "dropmalzpp": "027391553",
    "dropsitphn": 5087583179,
    "dropsitlph": 5087583179,
    "dropsitcph": 5087583179,
    "dropfax": 5087584961
  },
  {
    "dcode": "D",
    "dropkey": "PV22041",
    "droptype": "D",
    "dropname": "MAYNARD",
    "dropdeladd": "143 MAIN ST",
    "dropdelcty": "MAYNARD",
    "dropdelst": "MA",
    "dropdelzpp": "017549998",
    "dropphyadd": "143 MAIN ST",
    "dropphycty": "MAYNARD",
    "dropphyst": "MA",
    "dropphyzpp": "017549998",
    "dropmaladd": "143 MAIN ST",
    "dropmalcty": "MAYNARD",
    "dropmalst": "MA",
    "dropmalzpp": "017549998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788971963,
    "dropfax": 9788972602
  },
  {
    "dcode": "D",
    "dropkey": "PV22043",
    "droptype": "D",
    "dropname": "MEDFIELD",
    "dropdeladd": "60 NORTH ST",
    "dropdelcty": "MEDFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "020529998",
    "dropphyadd": "60 NORTH ST",
    "dropphycty": "MEDFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "020529998",
    "dropmaladd": "60 NORTH ST",
    "dropmalcty": "MEDFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "020529998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083595502,
    "dropfax": 5083599284
  },
  {
    "dcode": "D",
    "dropkey": "PV22045",
    "droptype": "D",
    "dropname": "MEDWAY",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "MEDWAY",
    "dropdelst": "MA",
    "dropdelzpp": "020539998",
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "MEDWAY",
    "dropphyst": "MA",
    "dropphyzpp": "020539998",
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "MEDWAY",
    "dropmalst": "MA",
    "dropmalzpp": "020539998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085334357,
    "dropfax": 5085337076
  },
  {
    "dcode": "D",
    "dropkey": "PV22051",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "12 MAPLE ST",
    "dropdelcty": "MENDON",
    "dropdelst": "MA",
    "dropdelzpp": "017569998",
    "dropphyadd": "12 MAPLE ST",
    "dropphycty": "MENDON",
    "dropphyst": "MA",
    "dropphyzpp": "017569998",
    "dropmaladd": "12 MAPLE ST",
    "dropmalcty": "MENDON",
    "dropmalst": "MA",
    "dropmalzpp": "017569998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084736451,
    "dropfax": 5084736451
  },
  {
    "dcode": "D",
    "dropkey": "PV22053",
    "droptype": "D",
    "dropname": "MERRIMAC",
    "dropdeladd": "79 E MAIN ST",
    "dropdelcty": "MERRIMAC",
    "dropdelst": "MA",
    "dropdelzpp": "018609998",
    "dropphyadd": "79 E MAIN ST",
    "dropphycty": "MERRIMAC",
    "dropphyst": "MA",
    "dropphyzpp": "018609998",
    "dropmaladd": "79 E MAIN ST",
    "dropmalcty": "MERRIMAC",
    "dropmalst": "MA",
    "dropmalzpp": "018609998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783467400,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV22056",
    "droptype": "D",
    "dropname": "MIDDLEBORO",
    "dropdeladd": "90 CENTRE ST",
    "dropdelcty": "MIDDLEBORO",
    "dropdelst": "MA",
    "dropdelzpp": "023469998",
    "dropphyadd": "90 CENTRE ST",
    "dropphycty": "MIDDLEBORO",
    "dropphyst": "MA",
    "dropphyzpp": "023469998",
    "dropmaladd": "90 CENTRE ST",
    "dropmalcty": "MIDDLEBORO",
    "dropmalst": "MA",
    "dropmalzpp": "023469998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089474767,
    "dropfax": 5089230742
  },
  {
    "dcode": "D",
    "dropkey": "PV22058",
    "droptype": "D",
    "dropname": "MIDDLEFIELD",
    "dropdeladd": "6 BELL RD",
    "dropdelcty": "MIDDLEFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "012439998",
    "dropphyadd": "6 BELL RD",
    "dropphycty": "MIDDLEFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "012439998",
    "dropmaladd": "6 BELL RD",
    "dropmalcty": "MIDDLEFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "012439998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136238930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22063",
    "droptype": "D",
    "dropname": "MIDDLETON",
    "dropdeladd": "41 S MAIN ST",
    "dropdelcty": "MIDDLETON",
    "dropdelst": "MA",
    "dropdelzpp": "019499998",
    "dropphyadd": "41 S MAIN ST",
    "dropphycty": "MIDDLETON",
    "dropphyst": "MA",
    "dropphyzpp": "019499998",
    "dropmaladd": "41 S MAIN ST",
    "dropmalcty": "MIDDLETON",
    "dropmalst": "MA",
    "dropmalzpp": "019499998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787744367,
    "dropfax": 9787743144
  },
  {
    "dcode": "D",
    "dropkey": "PV22064",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "2 CONGRESS ST STE 1",
    "dropdelcty": "MILFORD",
    "dropdelst": "MA",
    "dropdelzpp": "017574163",
    "dropphyadd": "2 CONGRESS ST STE 1",
    "dropphycty": "MILFORD",
    "dropphyst": "MA",
    "dropphyzpp": "017574163",
    "dropmaladd": "2 CONGRESS ST STE 1",
    "dropmalcty": "MILFORD",
    "dropmalst": "MA",
    "dropmalzpp": "017574163",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084735839,
    "dropfax": 5084731527
  },
  {
    "dcode": "D",
    "dropkey": "PV22066",
    "droptype": "D",
    "dropname": "MILL RIVER",
    "dropdeladd": "8 MILL RIVER GT BARRINGTON RD",
    "dropdelcty": "MILL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "012449998",
    "dropphyadd": "8 MILL RIVER GT BARRINGTON RD",
    "dropphycty": "MILL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "012449998",
    "dropmaladd": "8 MILL RIVER GT BARRINGTON RD",
    "dropmalcty": "MILL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "012449998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132296003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22067",
    "droptype": "D",
    "dropname": "MILLBURY",
    "dropdeladd": "119 ELM ST",
    "dropdelcty": "MILLBURY",
    "dropdelst": "MA",
    "dropdelzpp": "015279998",
    "dropphyadd": "119 ELM ST",
    "dropphycty": "MILLBURY",
    "dropphyst": "MA",
    "dropphyzpp": "015279998",
    "dropmaladd": "119 ELM ST",
    "dropmalcty": "MILLBURY",
    "dropmalst": "MA",
    "dropmalzpp": "015279998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088653392,
    "dropfax": 5088657879
  },
  {
    "dcode": "D",
    "dropkey": "PV22072",
    "droptype": "D",
    "dropname": "MILLIS",
    "dropdeladd": "1116 MAIN ST",
    "dropdelcty": "MILLIS",
    "dropdelst": "MA",
    "dropdelzpp": "020549998",
    "dropphyadd": "1116 MAIN ST",
    "dropphycty": "MILLIS",
    "dropphyst": "MA",
    "dropphyzpp": "020549998",
    "dropmaladd": "1116 MAIN ST",
    "dropmalcty": "MILLIS",
    "dropmalst": "MA",
    "dropmalzpp": "020549998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083769187,
    "dropfax": 5083765947
  },
  {
    "dcode": "D",
    "dropkey": "PV22073",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "31 CENTRAL ST",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "015299998",
    "dropphyadd": "31 CENTRAL ST",
    "dropphycty": "MILLVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "015299998",
    "dropmaladd": "31 CENTRAL ST",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "015299998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088768097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22080",
    "droptype": "D",
    "dropname": "MONPONSETT",
    "dropdeladd": "935 MONPONSETT ST",
    "dropdelcty": "MONPONSETT",
    "dropdelst": "MA",
    "dropdelzpp": "023509800",
    "dropphyadd": "935 MONPONSETT ST",
    "dropphycty": "MONPONSETT",
    "dropphyst": "MA",
    "dropphyzpp": "023509800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONPONSETT",
    "dropmalst": "MA",
    "dropmalzpp": "023509998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7812940326,
    "dropfax": 7812944705
  },
  {
    "dcode": "D",
    "dropkey": "PV22084",
    "droptype": "D",
    "dropname": "MONSON",
    "dropdeladd": "109 MAIN ST",
    "dropdelcty": "MONSON",
    "dropdelst": "MA",
    "dropdelzpp": "010579800",
    "dropphyadd": "109 MAIN ST",
    "dropphycty": "MONSON",
    "dropphyst": "MA",
    "dropphyzpp": "010579800",
    "dropmaladd": "109 MAIN ST",
    "dropmalcty": "MONSON",
    "dropmalst": "MA",
    "dropmalzpp": "010579800",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132679277,
    "dropfax": 4132674786
  },
  {
    "dcode": "D",
    "dropkey": "PV22085",
    "droptype": "D",
    "dropname": "MONTAGUE",
    "dropdeladd": "53 MAIN ST",
    "dropdelcty": "MONTAGUE",
    "dropdelst": "MA",
    "dropdelzpp": "013519998",
    "dropphyadd": "53 MAIN ST",
    "dropphycty": "MONTAGUE",
    "dropphyst": "MA",
    "dropphyzpp": "013519998",
    "dropmaladd": "53 MAIN ST",
    "dropmalcty": "MONTAGUE",
    "dropmalst": "MA",
    "dropmalzpp": "013519998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133672277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22089",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "444 MAIN RD",
    "dropdelcty": "MONTEREY",
    "dropdelst": "MA",
    "dropdelzpp": "012459998",
    "dropphyadd": "444 MAIN RD",
    "dropphycty": "MONTEREY",
    "dropphyst": "MA",
    "dropphyzpp": "012459998",
    "dropmaladd": "444 MAIN RD",
    "dropmalcty": "MONTEREY",
    "dropmalst": "MA",
    "dropmalzpp": "012459998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133002142,
    "dropfax": 4133002140
  },
  {
    "dcode": "D",
    "dropkey": "PV22093",
    "droptype": "D",
    "dropname": "MONUMENT BEACH",
    "dropdeladd": "436 SHORE RD",
    "dropdelcty": "MONUMENT BEACH",
    "dropdelst": "MA",
    "dropdelzpp": "025539800",
    "dropphyadd": "436 SHORE RD",
    "dropphycty": "MONUMENT BEACH",
    "dropphyst": "MA",
    "dropphyzpp": "025539800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONUMENT BEACH",
    "dropmalst": "MA",
    "dropmalzpp": "025539998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087595347,
    "dropfax": 5087590971
  },
  {
    "dcode": "D",
    "dropkey": "PV22139",
    "droptype": "D",
    "dropname": "NANTUCKET",
    "dropdeladd": "5 FEDERAL ST",
    "dropdelcty": "NANTUCKET",
    "dropdelst": "MA",
    "dropdelzpp": "025549998",
    "dropphyadd": "5 FEDERAL ST",
    "dropphycty": "NANTUCKET",
    "dropphyst": "MA",
    "dropphyzpp": "025549998",
    "dropmaladd": "5 FEDERAL ST",
    "dropmalcty": "NANTUCKET",
    "dropmalst": "MA",
    "dropmalzpp": "025549998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082284477,
    "dropfax": 5082287056
  },
  {
    "dcode": "D",
    "dropkey": "PV22140",
    "droptype": "D",
    "dropname": "NATICK",
    "dropdeladd": "18 HURON DR",
    "dropdelcty": "NATICK",
    "dropdelst": "MA",
    "dropdelzpp": "017605076",
    "dropphyadd": "18 HURON DR",
    "dropphycty": "NATICK",
    "dropphyst": "MA",
    "dropphyzpp": "017605076",
    "dropmaladd": "18 HURON DR",
    "dropmalcty": "NATICK",
    "dropmalst": "MA",
    "dropmalzpp": "017605076",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5086528053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22149",
    "droptype": "D",
    "dropname": "NEW BEDFORD",
    "dropdeladd": "695 PLEASANT ST",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "027409998",
    "dropphyadd": "695 PLEASANT ST",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "027409998",
    "dropmaladd": "695 PLEASANT ST",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "027409998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089797420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22150",
    "droptype": "D",
    "dropname": "NEW BRAINTREE",
    "dropdeladd": "10 UTLEY RD",
    "dropdelcty": "NEW BRAINTREE",
    "dropdelst": "MA",
    "dropdelzpp": "015319800",
    "dropphyadd": "10 UTLEY RD",
    "dropphycty": "NEW BRAINTREE",
    "dropphyst": "MA",
    "dropphyzpp": "015319800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW BRAINTREE",
    "dropmalst": "MA",
    "dropmalzpp": "015319998",
    "dropsitphn": 9786647013,
    "dropsitlph": 5088679221,
    "dropsitcph": 5088678125,
    "dropfax": 5088674778
  },
  {
    "dcode": "D",
    "dropkey": "PV22167",
    "droptype": "D",
    "dropname": "NEWBURYPORT",
    "dropdeladd": "61 PLEASANT ST",
    "dropdelcty": "NEWBURYPORT",
    "dropdelst": "MA",
    "dropdelzpp": "019509998",
    "dropphyadd": "61 PLEASANT ST",
    "dropphycty": "NEWBURYPORT",
    "dropphyst": "MA",
    "dropphyzpp": "019509998",
    "dropmaladd": "61 PLEASANT ST",
    "dropmalcty": "NEWBURYPORT",
    "dropmalst": "MA",
    "dropmalzpp": "019509998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784624284,
    "dropfax": 9784656930
  },
  {
    "dcode": "D",
    "dropkey": "PV22200",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "MA",
    "dropdelzpp": "020569998",
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "MA",
    "dropphyzpp": "020569998",
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "MA",
    "dropmalzpp": "020569998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085285508,
    "dropfax": 5085203531
  },
  {
    "dcode": "D",
    "dropkey": "PV22206",
    "droptype": "D",
    "dropname": "NORTH ADAMS",
    "dropdeladd": "67 SUMMER ST",
    "dropdelcty": "NORTH ADAMS",
    "dropdelst": "MA",
    "dropdelzpp": "012479998",
    "dropphyadd": "67 SUMMER ST",
    "dropphycty": "NORTH ADAMS",
    "dropphyst": "MA",
    "dropphyzpp": "012479998",
    "dropmaladd": "67 SUMMER ST",
    "dropmalcty": "NORTH ADAMS",
    "dropmalst": "MA",
    "dropmalzpp": "012479998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4136644554,
    "dropsitcph": 4136644554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22211",
    "droptype": "D",
    "dropname": "NORTH ATTLEBORO",
    "dropdeladd": "30 S WASHINGTON ST",
    "dropdelcty": "NORTH ATTLEBORO",
    "dropdelst": "MA",
    "dropdelzpp": "027609998",
    "dropphyadd": "30 S WASHINGTON ST",
    "dropphycty": "NORTH ATTLEBORO",
    "dropphyst": "MA",
    "dropphyzpp": "027609998",
    "dropmaladd": "30 S WASHINGTON ST",
    "dropmalcty": "NORTH ATTLEBORO",
    "dropmalst": "MA",
    "dropmalzpp": "027609998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086997556,
    "dropfax": 5086990256
  },
  {
    "dcode": "D",
    "dropkey": "PV22212",
    "droptype": "D",
    "dropname": "NORTH BILLERICA",
    "dropdeladd": "95 BOSTON RD STE 5",
    "dropdelcty": "NORTH BILLERICA",
    "dropdelst": "MA",
    "dropdelzpp": "018629998",
    "dropphyadd": "95 BOSTON RD STE 5",
    "dropphycty": "NORTH BILLERICA",
    "dropphyst": "MA",
    "dropphyzpp": "018629998",
    "dropmaladd": "95 BOSTON RD STE 5",
    "dropmalcty": "NORTH BILLERICA",
    "dropmalst": "MA",
    "dropmalzpp": "018629998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786639900,
    "dropfax": 9786710028
  },
  {
    "dcode": "D",
    "dropkey": "PV22214",
    "droptype": "D",
    "dropname": "NORTH BROOKFIELD",
    "dropdeladd": "357 N MAIN ST",
    "dropdelcty": "NORTH BROOKFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "015359998",
    "dropphyadd": "357 N MAIN ST",
    "dropphycty": "NORTH BROOKFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "015359998",
    "dropmaladd": "357 N MAIN ST",
    "dropmalcty": "NORTH BROOKFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "015359998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088678627,
    "dropfax": 5088670124
  },
  {
    "dcode": "D",
    "dropkey": "PV22216",
    "droptype": "D",
    "dropname": "NORTH CARVER",
    "dropdeladd": "171 PLYMOUTH ST",
    "dropdelcty": "NORTH CARVER",
    "dropdelst": "MA",
    "dropdelzpp": "023559800",
    "dropphyadd": "171 PLYMOUTH ST",
    "dropphycty": "NORTH CARVER",
    "dropphyst": "MA",
    "dropphyzpp": "023559800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH CARVER",
    "dropmalst": "MA",
    "dropmalzpp": "023559998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088663518,
    "dropfax": 5088666027
  },
  {
    "dcode": "D",
    "dropkey": "PV22217",
    "droptype": "D",
    "dropname": "NORTH CHATHAM",
    "dropdeladd": "200 ORLEANS RD",
    "dropdelcty": "NORTH CHATHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026509998",
    "dropphyadd": "200 ORLEANS RD",
    "dropphycty": "NORTH CHATHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026509998",
    "dropmaladd": "200 ORLEANS RD",
    "dropmalcty": "NORTH CHATHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026509998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089455560,
    "dropfax": 5089454184
  },
  {
    "dcode": "D",
    "dropkey": "PV22218",
    "droptype": "D",
    "dropname": "NORTH CHELMSFORD",
    "dropdeladd": "3 KENNEDY DR",
    "dropdelcty": "NORTH CHELMSFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018639998",
    "dropphyadd": "3 KENNEDY DR",
    "dropphycty": "NORTH CHELMSFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018639998",
    "dropmaladd": "3 KENNEDY DR",
    "dropmalcty": "NORTH CHELMSFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018639998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782513146,
    "dropfax": 9782510439
  },
  {
    "dcode": "D",
    "dropkey": "PV22221",
    "droptype": "D",
    "dropname": "NORTH DIGHTON",
    "dropdeladd": "1120 SOMERSET AVE",
    "dropdelcty": "NORTH DIGHTON",
    "dropdelst": "MA",
    "dropdelzpp": "027649998",
    "dropphyadd": "1120 SOMERSET AVE",
    "dropphycty": "NORTH DIGHTON",
    "dropphyst": "MA",
    "dropphyzpp": "027649998",
    "dropmaladd": "1120 SOMERSET AVE",
    "dropmalcty": "NORTH DIGHTON",
    "dropmalst": "MA",
    "dropmalzpp": "027649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086696905,
    "dropfax": 5086695536
  },
  {
    "dcode": "D",
    "dropkey": "PV22222",
    "droptype": "D",
    "dropname": "NORTH EASTHAM",
    "dropdeladd": "50 BRACKETT RD",
    "dropdelcty": "NORTH EASTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026519800",
    "dropphyadd": "50 BRACKETT RD",
    "dropphycty": "NORTH EASTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026519800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH EASTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026519998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082555089,
    "dropfax": 5082550372
  },
  {
    "dcode": "D",
    "dropkey": "PV22223",
    "droptype": "D",
    "dropname": "NORTH EASTON",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "NORTH EASTON",
    "dropdelst": "MA",
    "dropdelzpp": "023569998",
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "NORTH EASTON",
    "dropphyst": "MA",
    "dropphyzpp": "023569998",
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "NORTH EASTON",
    "dropmalst": "MA",
    "dropmalzpp": "023569998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082382053,
    "dropfax": 5082389045
  },
  {
    "dcode": "D",
    "dropkey": "PV22225",
    "droptype": "D",
    "dropname": "NORTH FALMOUTH",
    "dropdeladd": "634 N FALMOUTH HWY",
    "dropdelcty": "NORTH FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025569998",
    "dropphyadd": "634 N FALMOUTH HWY",
    "dropphycty": "NORTH FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025569998",
    "dropmaladd": "634 N FALMOUTH HWY",
    "dropmalcty": "NORTH FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025569998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085637388,
    "dropfax": 5085637613
  },
  {
    "dcode": "D",
    "dropkey": "PV22227",
    "droptype": "D",
    "dropname": "NORTH GRAFTON",
    "dropdeladd": "191 WORCESTER ST",
    "dropdelcty": "NORTH GRAFTON",
    "dropdelst": "MA",
    "dropdelzpp": "015369998",
    "dropphyadd": "191 WORCESTER ST",
    "dropphycty": "NORTH GRAFTON",
    "dropphyst": "MA",
    "dropphyzpp": "015369998",
    "dropmaladd": "191 WORCESTER ST",
    "dropmalcty": "NORTH GRAFTON",
    "dropmalst": "MA",
    "dropmalzpp": "015369998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088396291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22229",
    "droptype": "D",
    "dropname": "NORTH HATFIELD",
    "dropdeladd": "162 DEPOT RD",
    "dropdelcty": "NORTH HATFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010669998",
    "dropphyadd": "162 DEPOT RD",
    "dropphycty": "NORTH HATFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010669998",
    "dropmaladd": "162 DEPOT RD",
    "dropmalcty": "NORTH HATFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010669998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132479283,
    "dropfax": 4132477696
  },
  {
    "dcode": "D",
    "dropkey": "PV22234",
    "droptype": "D",
    "dropname": "NORTH MARSHFIELD",
    "dropdeladd": "647 HIGHLAND ST",
    "dropdelcty": "NORTH MARSHFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "020599800",
    "dropphyadd": "647 HIGHLAND ST",
    "dropphycty": "NORTH MARSHFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "020599800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH MARSHFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "020599998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818376953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22240",
    "droptype": "D",
    "dropname": "NORTH OXFORD",
    "dropdeladd": "681 MAIN ST",
    "dropdelcty": "NORTH OXFORD",
    "dropdelst": "MA",
    "dropdelzpp": "015379998",
    "dropphyadd": "681 MAIN ST",
    "dropphycty": "NORTH OXFORD",
    "dropphyst": "MA",
    "dropphyzpp": "015379998",
    "dropmaladd": "681 MAIN ST",
    "dropmalcty": "NORTH OXFORD",
    "dropmalst": "MA",
    "dropmalzpp": "015379998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5089871439,
    "dropfax": 5089872162
  },
  {
    "dcode": "D",
    "dropkey": "PV22241",
    "droptype": "D",
    "dropname": "NORTH PEMBROKE",
    "dropdeladd": "288 WASHINGTON ST",
    "dropdelcty": "NORTH PEMBROKE",
    "dropdelst": "MA",
    "dropdelzpp": "023589801",
    "dropphyadd": "288 WASHINGTON ST",
    "dropphycty": "NORTH PEMBROKE",
    "dropphyst": "MA",
    "dropphyzpp": "023589801",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH PEMBROKE",
    "dropmalst": "MA",
    "dropmalzpp": "023589998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818269541,
    "dropfax": 7818263753
  },
  {
    "dcode": "D",
    "dropkey": "PV22246",
    "droptype": "D",
    "dropname": "NORTH READING",
    "dropdeladd": "174 PARK ST",
    "dropdelcty": "NORTH READING",
    "dropdelst": "MA",
    "dropdelzpp": "018649998",
    "dropphyadd": "174 PARK ST",
    "dropphycty": "NORTH READING",
    "dropphyst": "MA",
    "dropphyzpp": "018649998",
    "dropmaladd": "174 PARK ST",
    "dropmalcty": "NORTH READING",
    "dropmalst": "MA",
    "dropmalzpp": "018649998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786640631,
    "dropfax": 9786641582
  },
  {
    "dcode": "D",
    "dropkey": "PV22251",
    "droptype": "D",
    "dropname": "NORTH TRURO",
    "dropdeladd": "1 HIGHLAND RD UNIT B",
    "dropdelcty": "NORTH TRURO",
    "dropdelst": "MA",
    "dropdelzpp": "026529801",
    "dropphyadd": "1 HIGHLAND RD UNIT B",
    "dropphycty": "NORTH TRURO",
    "dropphyst": "MA",
    "dropphyzpp": "026529801",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH TRURO",
    "dropmalst": "MA",
    "dropmalzpp": "026529998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084873080,
    "dropfax": 5084876199
  },
  {
    "dcode": "D",
    "dropkey": "PV22252",
    "droptype": "D",
    "dropname": "NORTH UXBRIDGE",
    "dropdeladd": "298 N MAIN ST",
    "dropdelcty": "NORTH UXBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "015389800",
    "dropphyadd": "298 N MAIN ST",
    "dropphycty": "NORTH UXBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "015389800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH UXBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "015389998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082787203,
    "dropfax": 5082785243
  },
  {
    "dcode": "D",
    "dropkey": "PV22255",
    "droptype": "D",
    "dropname": "NORTHAMPTON",
    "dropdeladd": "37 BRIDGE ST",
    "dropdelcty": "NORTHAMPTON",
    "dropdelst": "MA",
    "dropdelzpp": "010609998",
    "dropphyadd": "37 BRIDGE ST",
    "dropphycty": "NORTHAMPTON",
    "dropphyst": "MA",
    "dropphyzpp": "010609998",
    "dropmaladd": "37 BRIDGE ST",
    "dropmalcty": "NORTHAMPTON",
    "dropmalst": "MA",
    "dropmalzpp": "010609998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135840960,
    "dropfax": 4135866914
  },
  {
    "dcode": "D",
    "dropkey": "PV22257",
    "droptype": "D",
    "dropname": "NORTHBOROUGH",
    "dropdeladd": "235 W MAIN ST",
    "dropdelcty": "NORTHBOROUGH",
    "dropdelst": "MA",
    "dropdelzpp": "015329998",
    "dropphyadd": "235 W MAIN ST",
    "dropphycty": "NORTHBOROUGH",
    "dropphyst": "MA",
    "dropphyzpp": "015329998",
    "dropmaladd": "235 W MAIN ST",
    "dropmalcty": "NORTHBOROUGH",
    "dropmalst": "MA",
    "dropmalzpp": "015329998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083938285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22258",
    "droptype": "D",
    "dropname": "NORTHBRIDGE",
    "dropdeladd": "76 SUTTON ST STE 2",
    "dropdelcty": "NORTHBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "015349998",
    "dropphyadd": "76 SUTTON ST STE 2",
    "dropphycty": "NORTHBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "015349998",
    "dropmaladd": "76 SUTTON ST STE 2",
    "dropmalcty": "NORTHBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "015349998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082345826,
    "dropfax": 5082344070
  },
  {
    "dcode": "D",
    "dropkey": "PV22260",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "136 MAIN ST",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013609998",
    "dropphyadd": "136 MAIN ST",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013609998",
    "dropmaladd": "136 MAIN ST",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013609998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134982139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22263",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "6 TAUNTON AVE",
    "dropdelcty": "NORTON",
    "dropdelst": "MA",
    "dropdelzpp": "027662707",
    "dropphyadd": "6 TAUNTON AVE",
    "dropphycty": "NORTON",
    "dropphyst": "MA",
    "dropphyzpp": "027662707",
    "dropmaladd": "6 TAUNTON AVE",
    "dropmalcty": "NORTON",
    "dropmalst": "MA",
    "dropmalzpp": "027662707",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082858537,
    "dropfax": 5082855814
  },
  {
    "dcode": "D",
    "dropkey": "PV22264",
    "droptype": "D",
    "dropname": "NORWELL",
    "dropdeladd": "18 DOVER ST",
    "dropdelcty": "NORWELL",
    "dropdelst": "MA",
    "dropdelzpp": "020619998",
    "dropphyadd": "18 DOVER ST",
    "dropphycty": "NORWELL",
    "dropphyst": "MA",
    "dropphyzpp": "020619998",
    "dropmaladd": "18 DOVER ST",
    "dropmalcty": "NORWELL",
    "dropmalst": "MA",
    "dropmalzpp": "020619998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7816590494,
    "dropfax": 7816594863
  },
  {
    "dcode": "D",
    "dropkey": "PV22265",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "1 CENTRAL ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "MA",
    "dropdelzpp": "020629998",
    "dropphyadd": "1 CENTRAL ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "MA",
    "dropphyzpp": "020629998",
    "dropmaladd": "1 CENTRAL ST",
    "dropmalcty": "NORWOOD",
    "dropmalst": "MA",
    "dropmalzpp": "020629998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817624538,
    "dropfax": 7815510813
  },
  {
    "dcode": "D",
    "dropkey": "PV22266",
    "droptype": "D",
    "dropname": "NUTTING LAKE",
    "dropdeladd": "612 MIDDLESEX TPKE",
    "dropdelcty": "NUTTING LAKE",
    "dropdelst": "MA",
    "dropdelzpp": "018659800",
    "dropphyadd": "612 MIDDLESEX TPKE",
    "dropphycty": "NUTTING LAKE",
    "dropphyst": "MA",
    "dropphyzpp": "018659800",
    "dropmaladd": "612 MIDDLESEX TPKE",
    "dropmalcty": "NUTTING LAKE",
    "dropmalst": "MA",
    "dropmalzpp": "018659800",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786672100,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV22268",
    "droptype": "D",
    "dropname": "OAK BLUFFS",
    "dropdeladd": "24E KENNEBEC AVE",
    "dropdelcty": "OAK BLUFFS",
    "dropdelst": "MA",
    "dropdelzpp": "025579800",
    "dropphyadd": "24E KENNEBEC AVE",
    "dropphycty": "OAK BLUFFS",
    "dropphyst": "MA",
    "dropphyzpp": "025579800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAK BLUFFS",
    "dropmalst": "MA",
    "dropmalzpp": "025579998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086937737,
    "dropfax": 5086939547
  },
  {
    "dcode": "D",
    "dropkey": "PV22271",
    "droptype": "D",
    "dropname": "OAKHAM",
    "dropdeladd": "541 N BROOKFIELD RD",
    "dropdelcty": "OAKHAM",
    "dropdelst": "MA",
    "dropdelzpp": "010689806",
    "dropphyadd": "541 N BROOKFIELD RD",
    "dropphycty": "OAKHAM",
    "dropphyst": "MA",
    "dropphyzpp": "010689806",
    "dropmaladd": "541 N BROOKFIELD RD",
    "dropmalcty": "OAKHAM",
    "dropmalst": "MA",
    "dropmalzpp": "010689806",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 5088823159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22281",
    "droptype": "D",
    "dropname": "ONSET",
    "dropdeladd": "214 ONSET AVE",
    "dropdelcty": "ONSET",
    "dropdelst": "MA",
    "dropdelzpp": "025589800",
    "dropphyadd": "214 ONSET AVE",
    "dropphycty": "ONSET",
    "dropphyst": "MA",
    "dropphyzpp": "025589800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONSET",
    "dropmalst": "MA",
    "dropmalzpp": "025589998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083221485,
    "dropfax": 5082952997
  },
  {
    "dcode": "D",
    "dropkey": "PV22282",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "72 S MAIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "MA",
    "dropdelzpp": "013649998",
    "dropphyadd": "72 S MAIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "MA",
    "dropphyzpp": "013649998",
    "dropmaladd": "72 S MAIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "MA",
    "dropmalzpp": "013649998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9785446595,
    "dropfax": 9785447043
  },
  {
    "dcode": "D",
    "dropkey": "PV22285",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "56 MAIN ST",
    "dropdelcty": "ORLEANS",
    "dropdelst": "MA",
    "dropdelzpp": "026539998",
    "dropphyadd": "56 MAIN ST",
    "dropphycty": "ORLEANS",
    "dropphyst": "MA",
    "dropphyzpp": "026539998",
    "dropmaladd": "56 MAIN ST",
    "dropmalcty": "ORLEANS",
    "dropmalst": "MA",
    "dropmalzpp": "026539998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082550464,
    "dropfax": 5082478334
  },
  {
    "dcode": "D",
    "dropkey": "PV22287",
    "droptype": "D",
    "dropname": "OSTERVILLE",
    "dropdeladd": "42 WIANNO AVE",
    "dropdelcty": "OSTERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "026559998",
    "dropphyadd": "42 WIANNO AVE",
    "dropphycty": "OSTERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "026559998",
    "dropmaladd": "42 WIANNO AVE",
    "dropmalcty": "OSTERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "026559998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084286680,
    "dropfax": 5084280274
  },
  {
    "dcode": "D",
    "dropkey": "PV22288",
    "droptype": "D",
    "dropname": "OTIS",
    "dropdeladd": "45 N MAIN RD",
    "dropdelcty": "OTIS",
    "dropdelst": "MA",
    "dropdelzpp": "012539998",
    "dropphyadd": "45 N MAIN RD",
    "dropphycty": "OTIS",
    "dropphyst": "MA",
    "dropphyzpp": "012539998",
    "dropmaladd": "45 N MAIN RD",
    "dropmalcty": "OTIS",
    "dropmalst": "MA",
    "dropmalzpp": "012539998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132694608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22293",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "269 MAIN ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "MA",
    "dropdelzpp": "015409998",
    "dropphyadd": "269 MAIN ST",
    "dropphycty": "OXFORD",
    "dropphyst": "MA",
    "dropphyzpp": "015409998",
    "dropmaladd": "269 MAIN ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "MA",
    "dropmalzpp": "015409998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5089873814,
    "dropfax": 5089873308
  },
  {
    "dcode": "D",
    "dropkey": "PV22296",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "1057 PARK ST",
    "dropdelcty": "PALMER",
    "dropdelst": "MA",
    "dropdelzpp": "010699998",
    "dropphyadd": "1057 PARK ST",
    "dropphycty": "PALMER",
    "dropphyst": "MA",
    "dropphyzpp": "010699998",
    "dropmaladd": "1057 PARK ST",
    "dropmalcty": "PALMER",
    "dropmalst": "MA",
    "dropmalzpp": "010699998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132838211,
    "dropfax": 4132891772
  },
  {
    "dcode": "D",
    "dropkey": "PV22298",
    "droptype": "D",
    "dropname": "PEABODY",
    "dropdeladd": "4 ESSEX CENTER DR",
    "dropdelcty": "PEABODY",
    "dropdelst": "MA",
    "dropdelzpp": "019609998",
    "dropphyadd": "4 ESSEX CENTER DR",
    "dropphycty": "PEABODY",
    "dropphyst": "MA",
    "dropphyzpp": "019609998",
    "dropmaladd": "4 ESSEX CENTER DR",
    "dropmalcty": "PEABODY",
    "dropmalst": "MA",
    "dropmalzpp": "019609998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785316666,
    "dropfax": 9785316034
  },
  {
    "dcode": "D",
    "dropkey": "PV22301",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "3 ELLIOT AVE",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "MA",
    "dropdelzpp": "023599998",
    "dropphyadd": "3 ELLIOT AVE",
    "dropphycty": "PEMBROKE",
    "dropphyst": "MA",
    "dropphyzpp": "023599998",
    "dropmaladd": "3 ELLIOT AVE",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "MA",
    "dropmalzpp": "023599998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7812932631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22302",
    "droptype": "D",
    "dropname": "PEPPERELL",
    "dropdeladd": "41 LOWELL RD",
    "dropdelcty": "PEPPERELL",
    "dropdelst": "MA",
    "dropdelzpp": "014639998",
    "dropphyadd": "41 LOWELL RD",
    "dropphycty": "PEPPERELL",
    "dropphyst": "MA",
    "dropphyzpp": "014639998",
    "dropmaladd": "41 LOWELL RD",
    "dropmalcty": "PEPPERELL",
    "dropmalst": "MA",
    "dropmalzpp": "014639998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784335298,
    "dropfax": 9784336034
  },
  {
    "dcode": "D",
    "dropkey": "PV22305",
    "droptype": "D",
    "dropname": "PETERSHAM",
    "dropdeladd": "32 SPRING ST",
    "dropdelcty": "PETERSHAM",
    "dropdelst": "MA",
    "dropdelzpp": "013669998",
    "dropphyadd": "32 SPRING ST",
    "dropphycty": "PETERSHAM",
    "dropphyst": "MA",
    "dropphyzpp": "013669998",
    "dropmaladd": "32 SPRING ST",
    "dropmalcty": "PETERSHAM",
    "dropmalst": "MA",
    "dropmalzpp": "013669998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9787243289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22310",
    "droptype": "D",
    "dropname": "PINEHURST",
    "dropdeladd": "880 BOSTON RD STE I",
    "dropdelcty": "PINEHURST",
    "dropdelst": "MA",
    "dropdelzpp": "018669800",
    "dropphyadd": "880 BOSTON RD STE I",
    "dropphycty": "PINEHURST",
    "dropphyst": "MA",
    "dropphyzpp": "018669800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINEHURST",
    "dropmalst": "MA",
    "dropmalzpp": "018669998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786634449,
    "dropfax": 9786701458
  },
  {
    "dcode": "D",
    "dropkey": "PV22313",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "212 FENN ST",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "012019998",
    "dropphyadd": "212 FENN ST",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "012019998",
    "dropmaladd": "212 FENN ST",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "012019998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134426961,
    "dropfax": 4134478962
  },
  {
    "dcode": "D",
    "dropkey": "PV22315",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "6 S CENTRAL ST",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010709998",
    "dropphyadd": "6 S CENTRAL ST",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010709998",
    "dropmaladd": "6 S CENTRAL ST",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010709998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4136342145,
    "dropsitcph": 4136342145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22319",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "100 LONG POND RD",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "023609998",
    "dropphyadd": "100 LONG POND RD",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "023609998",
    "dropmaladd": "100 LONG POND RD",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "023609998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087466446,
    "dropfax": 5087474558
  },
  {
    "dcode": "D",
    "dropkey": "PV22320",
    "droptype": "D",
    "dropname": "PLYMPTON",
    "dropdeladd": "284 MAIN ST",
    "dropdelcty": "PLYMPTON",
    "dropdelst": "MA",
    "dropdelzpp": "023679998",
    "dropphyadd": "284 MAIN ST",
    "dropphycty": "PLYMPTON",
    "dropphyst": "MA",
    "dropphyzpp": "023679998",
    "dropmaladd": "284 MAIN ST",
    "dropmalcty": "PLYMPTON",
    "dropmalst": "MA",
    "dropmalzpp": "023679998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815857672,
    "dropfax": 7815852343
  },
  {
    "dcode": "D",
    "dropkey": "PV22321",
    "droptype": "D",
    "dropname": "POCASSET",
    "dropdeladd": "301 BARLOWS LANDING RD",
    "dropdelcty": "POCASSET",
    "dropdelst": "MA",
    "dropdelzpp": "025599998",
    "dropphyadd": "301 BARLOWS LANDING RD",
    "dropphycty": "POCASSET",
    "dropphyst": "MA",
    "dropphyzpp": "025599998",
    "dropmaladd": "301 BARLOWS LANDING RD",
    "dropmalcty": "POCASSET",
    "dropmalst": "MA",
    "dropmalzpp": "025599998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085632403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22327",
    "droptype": "D",
    "dropname": "PRIDES CROSSING",
    "dropdeladd": "64 THISSELL ST",
    "dropdelcty": "PRIDES CROSSING",
    "dropdelst": "MA",
    "dropdelzpp": "019659800",
    "dropphyadd": "64 THISSELL ST",
    "dropphycty": "PRIDES CROSSING",
    "dropphyst": "MA",
    "dropphyzpp": "019659800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRIDES CROSSING",
    "dropmalst": "MA",
    "dropmalzpp": "019659998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789224310,
    "dropfax": 9789224962
  },
  {
    "dcode": "D",
    "dropkey": "PV22329",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "206 WORCESTER RD",
    "dropdelcty": "PRINCETON",
    "dropdelst": "MA",
    "dropdelzpp": "015419998",
    "dropphyadd": "206 WORCESTER RD",
    "dropphycty": "PRINCETON",
    "dropphyst": "MA",
    "dropphyzpp": "015419998",
    "dropmaladd": "206 WORCESTER RD",
    "dropmalcty": "PRINCETON",
    "dropmalst": "MA",
    "dropmalzpp": "015419998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784645117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22331",
    "droptype": "D",
    "dropname": "PROVINCETOWN",
    "dropdeladd": "219 COMMERCIAL ST",
    "dropdelcty": "PROVINCETOWN",
    "dropdelst": "MA",
    "dropdelzpp": "026579998",
    "dropphyadd": "219 COMMERCIAL ST",
    "dropphycty": "PROVINCETOWN",
    "dropphyst": "MA",
    "dropphyzpp": "026579998",
    "dropmaladd": "219 COMMERCIAL ST",
    "dropmalcty": "PROVINCETOWN",
    "dropmalst": "MA",
    "dropmalzpp": "026579998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084870368,
    "dropfax": 5084877870
  },
  {
    "dcode": "D",
    "dropkey": "PV22336",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "16 THOMAS PATTEN DR",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "MA",
    "dropdelzpp": "023689998",
    "dropphyadd": "16 THOMAS PATTEN DR",
    "dropphycty": "RANDOLPH",
    "dropphyst": "MA",
    "dropphyzpp": "023689998",
    "dropmaladd": "16 THOMAS PATTEN DR",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "MA",
    "dropmalzpp": "023689998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7819630386,
    "dropfax": 7819631478
  },
  {
    "dcode": "D",
    "dropkey": "PV22337",
    "droptype": "D",
    "dropname": "RAYNHAM",
    "dropdeladd": "681 BROADWAY",
    "dropdelcty": "RAYNHAM",
    "dropdelst": "MA",
    "dropdelzpp": "027671734",
    "dropphyadd": "681 BROADWAY",
    "dropphycty": "RAYNHAM",
    "dropphyst": "MA",
    "dropphyzpp": "027671734",
    "dropmaladd": "681 BROADWAY",
    "dropmalcty": "RAYNHAM",
    "dropmalst": "MA",
    "dropmalzpp": "027671734",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088227673,
    "dropfax": 5088227643
  },
  {
    "dcode": "D",
    "dropkey": "PV22339",
    "droptype": "D",
    "dropname": "RAYNHAM CENTER",
    "dropdeladd": "622 N MAIN ST",
    "dropdelcty": "RAYNHAM CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "027680003",
    "dropphyadd": "622 N MAIN ST",
    "dropphycty": "RAYNHAM CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "027680003",
    "dropmaladd": "622 N MAIN ST",
    "dropmalcty": "RAYNHAM CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "027680003",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088234256,
    "dropfax": 5088233242
  },
  {
    "dcode": "D",
    "dropkey": "PV22340",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "123 HAVEN ST STE 2",
    "dropdelcty": "READING",
    "dropdelst": "MA",
    "dropdelzpp": "018672952",
    "dropphyadd": "123 HAVEN ST STE 2",
    "dropphycty": "READING",
    "dropphyst": "MA",
    "dropphyzpp": "018672952",
    "dropmaladd": "123 HAVEN ST STE 2",
    "dropmalcty": "READING",
    "dropmalst": "MA",
    "dropmalzpp": "018672952",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7819445782,
    "dropfax": 7819449373
  },
  {
    "dcode": "D",
    "dropkey": "PV22344",
    "droptype": "D",
    "dropname": "REHOBOTH",
    "dropdeladd": "275 WINTHROP ST",
    "dropdelcty": "REHOBOTH",
    "dropdelst": "MA",
    "dropdelzpp": "027699998",
    "dropphyadd": "275 WINTHROP ST",
    "dropphycty": "REHOBOTH",
    "dropphyst": "MA",
    "dropphyzpp": "027699998",
    "dropmaladd": "275 WINTHROP ST",
    "dropmalcty": "REHOBOTH",
    "dropmalst": "MA",
    "dropmalzpp": "027699998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082529278,
    "dropfax": 5082523246
  },
  {
    "dcode": "D",
    "dropkey": "PV22349",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "2089 STATE RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "MA",
    "dropdelzpp": "012549998",
    "dropphyadd": "2089 STATE RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "MA",
    "dropphyzpp": "012549998",
    "dropmaladd": "2089 STATE RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "MA",
    "dropmalzpp": "012549998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136983121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22358",
    "droptype": "D",
    "dropname": "ROCHDALE",
    "dropdeladd": "1138 STAFFORD ST",
    "dropdelcty": "ROCHDALE",
    "dropdelst": "MA",
    "dropdelzpp": "015429998",
    "dropphyadd": "1138 STAFFORD ST",
    "dropphycty": "ROCHDALE",
    "dropphyst": "MA",
    "dropphyzpp": "015429998",
    "dropmaladd": "1138 STAFFORD ST",
    "dropmalcty": "ROCHDALE",
    "dropmalst": "MA",
    "dropmalzpp": "015429998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088923937,
    "dropfax": 5088927987
  },
  {
    "dcode": "D",
    "dropkey": "PV22359",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "603 NEW BEDFORD RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "027704125",
    "dropphyadd": "603 NEW BEDFORD RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "027704125",
    "dropmaladd": "603 NEW BEDFORD RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "027704125",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087635007,
    "dropfax": 5087632134
  },
  {
    "dcode": "D",
    "dropkey": "PV22360",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "39 WEBSTER ST",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "MA",
    "dropdelzpp": "023709998",
    "dropphyadd": "39 WEBSTER ST",
    "dropphycty": "ROCKLAND",
    "dropphyst": "MA",
    "dropphyzpp": "023709998",
    "dropmaladd": "39 WEBSTER ST",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "MA",
    "dropmalzpp": "023709998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818786201,
    "dropfax": 7818780962
  },
  {
    "dcode": "D",
    "dropkey": "PV22361",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "39 BROADWAY",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "MA",
    "dropdelzpp": "019669998",
    "dropphyadd": "39 BROADWAY",
    "dropphycty": "ROCKPORT",
    "dropphyst": "MA",
    "dropphyzpp": "019669998",
    "dropmaladd": "39 BROADWAY",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "MA",
    "dropmalzpp": "019669998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785462667,
    "dropfax": 9785467168
  },
  {
    "dcode": "D",
    "dropkey": "PV22365",
    "droptype": "D",
    "dropname": "ROWE",
    "dropdeladd": "321 ZOAR RD STE 1",
    "dropdelcty": "ROWE",
    "dropdelst": "MA",
    "dropdelzpp": "013679998",
    "dropphyadd": "321 ZOAR RD STE 1",
    "dropphycty": "ROWE",
    "dropphyst": "MA",
    "dropphyzpp": "013679998",
    "dropmaladd": "321 ZOAR RD STE 1",
    "dropmalcty": "ROWE",
    "dropmalst": "MA",
    "dropmalzpp": "013679998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4133395390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22366",
    "droptype": "D",
    "dropname": "ROWLEY",
    "dropdeladd": "161 MAIN ST",
    "dropdelcty": "ROWLEY",
    "dropdelst": "MA",
    "dropdelzpp": "019699998",
    "dropphyadd": "161 MAIN ST",
    "dropphycty": "ROWLEY",
    "dropphyst": "MA",
    "dropphyzpp": "019699998",
    "dropmaladd": "161 MAIN ST",
    "dropmalcty": "ROWLEY",
    "dropmalst": "MA",
    "dropmalzpp": "019699998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789487829,
    "dropfax": 9789485363
  },
  {
    "dcode": "D",
    "dropkey": "PV22373",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "58 MAIN ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "MA",
    "dropdelzpp": "010719998",
    "dropphyadd": "58 MAIN ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "MA",
    "dropphyzpp": "010719998",
    "dropmaladd": "58 MAIN ST",
    "dropmalcty": "RUSSELL",
    "dropmalst": "MA",
    "dropmalzpp": "010719998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4138624551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22374",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "26 MAPLE AVE",
    "dropdelcty": "RUTLAND",
    "dropdelst": "MA",
    "dropdelzpp": "015439998",
    "dropphyadd": "26 MAPLE AVE",
    "dropphycty": "RUTLAND",
    "dropphyst": "MA",
    "dropphyzpp": "015439998",
    "dropmaladd": "26 MAPLE AVE",
    "dropmalcty": "RUTLAND",
    "dropmalst": "MA",
    "dropmalzpp": "015439998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088864278,
    "dropfax": 5088868882
  },
  {
    "dcode": "D",
    "dropkey": "PV22405",
    "droptype": "D",
    "dropname": "SAGAMORE",
    "dropdeladd": "883 SANDWICH RD",
    "dropdelcty": "SAGAMORE",
    "dropdelst": "MA",
    "dropdelzpp": "025619800",
    "dropphyadd": "883 SANDWICH RD",
    "dropphycty": "SAGAMORE",
    "dropphyst": "MA",
    "dropphyzpp": "025619800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAGAMORE",
    "dropmalst": "MA",
    "dropmalzpp": "025619998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088882642,
    "dropfax": 5088887226
  },
  {
    "dcode": "D",
    "dropkey": "PV22408",
    "droptype": "D",
    "dropname": "SAGAMORE BEACH",
    "dropdeladd": "45 MEETINGHOUSE LN",
    "dropdelcty": "SAGAMORE BEACH",
    "dropdelst": "MA",
    "dropdelzpp": "025629998",
    "dropphyadd": "45 MEETINGHOUSE LN",
    "dropphycty": "SAGAMORE BEACH",
    "dropphyst": "MA",
    "dropphyzpp": "025629998",
    "dropmaladd": "45 MEETINGHOUSE LN",
    "dropmalcty": "SAGAMORE BEACH",
    "dropmalst": "MA",
    "dropmalzpp": "025629998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088882239,
    "dropfax": 5088334377
  },
  {
    "dcode": "D",
    "dropkey": "PV22409",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "2 MARGIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "MA",
    "dropdelzpp": "019709998",
    "dropphyadd": "2 MARGIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "MA",
    "dropphyzpp": "019709998",
    "dropmaladd": "2 MARGIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "MA",
    "dropmalzpp": "019709998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787444671,
    "dropfax": 9787456453
  },
  {
    "dcode": "D",
    "dropkey": "PV22413",
    "droptype": "D",
    "dropname": "SANDISFIELD",
    "dropdeladd": "83 SANDISFIELD RD",
    "dropdelcty": "SANDISFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "012559998",
    "dropphyadd": "83 SANDISFIELD RD",
    "dropphycty": "SANDISFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "012559998",
    "dropmaladd": "83 SANDISFIELD RD",
    "dropmalcty": "SANDISFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "012559998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132584940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22416",
    "droptype": "D",
    "dropname": "SANDWICH",
    "dropdeladd": "69 ROUTE 6A",
    "dropdelcty": "SANDWICH",
    "dropdelst": "MA",
    "dropdelzpp": "025639998",
    "dropphyadd": "69 ROUTE 6A",
    "dropphycty": "SANDWICH",
    "dropphyst": "MA",
    "dropphyzpp": "025639998",
    "dropmaladd": "69 ROUTE 6A",
    "dropmalcty": "SANDWICH",
    "dropmalst": "MA",
    "dropmalzpp": "025639998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088330951,
    "dropfax": 5088330478
  },
  {
    "dcode": "D",
    "dropkey": "PV22422",
    "droptype": "D",
    "dropname": "SCITUATE",
    "dropdeladd": "108 FIRST PARISH RD",
    "dropdelcty": "SCITUATE",
    "dropdelst": "MA",
    "dropdelzpp": "020669998",
    "dropphyadd": "108 FIRST PARISH RD",
    "dropphycty": "SCITUATE",
    "dropphyst": "MA",
    "dropphyzpp": "020669998",
    "dropmaladd": "108 FIRST PARISH RD",
    "dropmalcty": "SCITUATE",
    "dropmalst": "MA",
    "dropmalzpp": "020669998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815451982,
    "dropfax": 7815451583
  },
  {
    "dcode": "D",
    "dropkey": "PV22426",
    "droptype": "D",
    "dropname": "SEEKONK",
    "dropdeladd": "156 TAUNTON AVE",
    "dropdelcty": "SEEKONK",
    "dropdelst": "MA",
    "dropdelzpp": "027719998",
    "dropphyadd": "156 TAUNTON AVE",
    "dropphycty": "SEEKONK",
    "dropphyst": "MA",
    "dropphyzpp": "027719998",
    "dropmaladd": "156 TAUNTON AVE",
    "dropmalcty": "SEEKONK",
    "dropmalst": "MA",
    "dropmalzpp": "027719998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083368229,
    "dropfax": 5083362670
  },
  {
    "dcode": "D",
    "dropkey": "PV22430",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "15 S MAIN ST",
    "dropdelcty": "SHARON",
    "dropdelst": "MA",
    "dropdelzpp": "020679998",
    "dropphyadd": "15 S MAIN ST",
    "dropphycty": "SHARON",
    "dropphyst": "MA",
    "dropphyzpp": "020679998",
    "dropmaladd": "15 S MAIN ST",
    "dropmalcty": "SHARON",
    "dropmalst": "MA",
    "dropmalzpp": "020679998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817849469,
    "dropfax": 7817847732
  },
  {
    "dcode": "D",
    "dropkey": "PV22435",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "99 MAIN ST",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "012579701",
    "dropphyadd": "99 MAIN ST",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "012579701",
    "dropmaladd": "99 MAIN ST",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "012579701",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132298772,
    "dropfax": 4132298283
  },
  {
    "dcode": "D",
    "dropkey": "PV22438",
    "droptype": "D",
    "dropname": "SHELBURNE FALLS",
    "dropdeladd": "7 CHURCH ST",
    "dropdelcty": "SHELBURNE FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "013709998",
    "dropphyadd": "7 CHURCH ST",
    "dropphycty": "SHELBURNE FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "013709998",
    "dropmaladd": "7 CHURCH ST",
    "dropmalcty": "SHELBURNE FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "013709998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136256757,
    "dropfax": 4136259880
  },
  {
    "dcode": "D",
    "dropkey": "PV22440",
    "droptype": "D",
    "dropname": "SHELDONVILLE",
    "dropdeladd": "1063 WEST ST",
    "dropdelcty": "SHELDONVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "020709800",
    "dropphyadd": "1063 WEST ST",
    "dropphycty": "SHELDONVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "020709800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELDONVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "020709998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083846394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22442",
    "droptype": "D",
    "dropname": "SHERBORN",
    "dropdeladd": "29 N MAIN ST STE 3",
    "dropdelcty": "SHERBORN",
    "dropdelst": "MA",
    "dropdelzpp": "017709998",
    "dropphyadd": "29 N MAIN ST STE 3",
    "dropphycty": "SHERBORN",
    "dropphyst": "MA",
    "dropphyzpp": "017709998",
    "dropmaladd": "29 N MAIN ST STE 3",
    "dropmalcty": "SHERBORN",
    "dropmalst": "MA",
    "dropmalzpp": "017709998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5086539405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22444",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "23 MAIN ST",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "MA",
    "dropdelzpp": "014649998",
    "dropphyadd": "23 MAIN ST",
    "dropphycty": "SHIRLEY",
    "dropphyst": "MA",
    "dropphyzpp": "014649998",
    "dropmaladd": "23 MAIN ST",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "MA",
    "dropmalzpp": "014649998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784250938,
    "dropfax": 9784250202
  },
  {
    "dcode": "D",
    "dropkey": "PV22446",
    "droptype": "D",
    "dropname": "SHREWSBURY",
    "dropdeladd": "43 MAPLE AVE",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "MA",
    "dropdelzpp": "015459998",
    "dropphyadd": "43 MAPLE AVE",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "MA",
    "dropphyzpp": "015459998",
    "dropmaladd": "43 MAPLE AVE",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "MA",
    "dropmalzpp": "015459998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088420243,
    "dropfax": 5088427485
  },
  {
    "dcode": "D",
    "dropkey": "PV22449",
    "droptype": "D",
    "dropname": "SHUTESBURY",
    "dropdeladd": "8 WENDELL RD",
    "dropdelcty": "SHUTESBURY",
    "dropdelst": "MA",
    "dropdelzpp": "010729998",
    "dropphyadd": "8 WENDELL RD",
    "dropphycty": "SHUTESBURY",
    "dropphyst": "MA",
    "dropphyzpp": "010729998",
    "dropmaladd": "8 WENDELL RD",
    "dropmalcty": "SHUTESBURY",
    "dropmalst": "MA",
    "dropmalzpp": "010729998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132591440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22490",
    "droptype": "D",
    "dropname": "SOUTH BARRE",
    "dropdeladd": "46 MAIN ST",
    "dropdelcty": "SOUTH BARRE",
    "dropdelst": "MA",
    "dropdelzpp": "010749998",
    "dropphyadd": "46 MAIN ST",
    "dropphycty": "SOUTH BARRE",
    "dropphyst": "MA",
    "dropphyzpp": "010749998",
    "dropmaladd": "46 MAIN ST",
    "dropmalcty": "SOUTH BARRE",
    "dropmalst": "MA",
    "dropmalzpp": "010749998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9783554900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22495",
    "droptype": "D",
    "dropname": "SOUTH CARVER",
    "dropdeladd": "239 TREMONT ST",
    "dropdelcty": "SOUTH CARVER",
    "dropdelst": "MA",
    "dropdelzpp": "023669800",
    "dropphyadd": "239 TREMONT ST",
    "dropphycty": "SOUTH CARVER",
    "dropphyst": "MA",
    "dropphyzpp": "023669800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH CARVER",
    "dropmalst": "MA",
    "dropmalzpp": "023669998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088663158,
    "dropfax": 5088664640
  },
  {
    "dcode": "D",
    "dropkey": "PV22498",
    "droptype": "D",
    "dropname": "SOUTH CHATHAM",
    "dropdeladd": "2455 MAIN ST",
    "dropdelcty": "SOUTH CHATHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026599998",
    "dropphyadd": "2455 MAIN ST",
    "dropphycty": "SOUTH CHATHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026599998",
    "dropmaladd": "2455 MAIN ST",
    "dropmalcty": "SOUTH CHATHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026599998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084327491,
    "dropfax": 5084327067
  },
  {
    "dcode": "D",
    "dropkey": "PV22501",
    "droptype": "D",
    "dropname": "SOUTH DEERFIELD",
    "dropdeladd": "60 SUGARLOAF ST STE 1",
    "dropdelcty": "SOUTH DEERFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013739998",
    "dropphyadd": "60 SUGARLOAF ST STE 1",
    "dropphycty": "SOUTH DEERFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013739998",
    "dropmaladd": "60 SUGARLOAF ST STE 1",
    "dropmalcty": "SOUTH DEERFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013739998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136652587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22502",
    "droptype": "D",
    "dropname": "SOUTH DENNIS",
    "dropdeladd": "9 MARKET PL",
    "dropdelcty": "SOUTH DENNIS",
    "dropdelst": "MA",
    "dropdelzpp": "026609998",
    "dropphyadd": "9 MARKET PL",
    "dropphycty": "SOUTH DENNIS",
    "dropphyst": "MA",
    "dropphyzpp": "026609998",
    "dropmaladd": "9 MARKET PL",
    "dropmalcty": "SOUTH DENNIS",
    "dropmalst": "MA",
    "dropmalzpp": "026609998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087601362,
    "dropfax": 5083949715
  },
  {
    "dcode": "D",
    "dropkey": "PV22503",
    "droptype": "D",
    "dropname": "SOUTH EASTON",
    "dropdeladd": "704 WASHINGTON ST",
    "dropdelcty": "SOUTH EASTON",
    "dropdelst": "MA",
    "dropdelzpp": "023759998",
    "dropphyadd": "704 WASHINGTON ST",
    "dropphycty": "SOUTH EASTON",
    "dropphyst": "MA",
    "dropphyzpp": "023759998",
    "dropmaladd": "704 WASHINGTON ST",
    "dropmalcty": "SOUTH EASTON",
    "dropmalst": "MA",
    "dropmalzpp": "023759998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082307398,
    "dropfax": 5082383662
  },
  {
    "dcode": "D",
    "dropkey": "PV22504",
    "droptype": "D",
    "dropname": "SOUTH EGREMONT",
    "dropdeladd": "64 MAIN ST",
    "dropdelcty": "SOUTH EGREMONT",
    "dropdelst": "MA",
    "dropdelzpp": "012589998",
    "dropphyadd": "64 MAIN ST",
    "dropphycty": "SOUTH EGREMONT",
    "dropphyst": "MA",
    "dropphyzpp": "012589998",
    "dropmaladd": "64 MAIN ST",
    "dropmalcty": "SOUTH EGREMONT",
    "dropmalst": "MA",
    "dropmalzpp": "012589998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135281571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22508",
    "droptype": "D",
    "dropname": "SOUTH GRAFTON",
    "dropdeladd": "17 FERRY ST",
    "dropdelcty": "SOUTH GRAFTON",
    "dropdelst": "MA",
    "dropdelzpp": "015609998",
    "dropphyadd": "17 FERRY ST",
    "dropphycty": "SOUTH GRAFTON",
    "dropphyst": "MA",
    "dropphyzpp": "015609998",
    "dropmaladd": "17 FERRY ST",
    "dropmalcty": "SOUTH GRAFTON",
    "dropmalst": "MA",
    "dropmalzpp": "015609998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088390473,
    "dropfax": 5088395376
  },
  {
    "dcode": "D",
    "dropkey": "PV22509",
    "droptype": "D",
    "dropname": "SOUTH HADLEY",
    "dropdeladd": "1 HADLEY ST",
    "dropdelcty": "SOUTH HADLEY",
    "dropdelst": "MA",
    "dropdelzpp": "010759998",
    "dropphyadd": "1 HADLEY ST",
    "dropphycty": "SOUTH HADLEY",
    "dropphyst": "MA",
    "dropphyzpp": "010759998",
    "dropmaladd": "1 HADLEY ST",
    "dropmalcty": "SOUTH HADLEY",
    "dropmalst": "MA",
    "dropmalzpp": "010759998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135388686,
    "dropfax": 4135344904
  },
  {
    "dcode": "D",
    "dropkey": "PV22511",
    "droptype": "D",
    "dropname": "SOUTH HAMILTON",
    "dropdeladd": "49 RAILROAD AVE",
    "dropdelcty": "SOUTH HAMILTON",
    "dropdelst": "MA",
    "dropdelzpp": "019829998",
    "dropphyadd": "49 RAILROAD AVE",
    "dropphycty": "SOUTH HAMILTON",
    "dropphyst": "MA",
    "dropphyzpp": "019829998",
    "dropmaladd": "49 RAILROAD AVE",
    "dropmalcty": "SOUTH HAMILTON",
    "dropmalst": "MA",
    "dropmalzpp": "019829998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784684471,
    "dropfax": 9784683898
  },
  {
    "dcode": "D",
    "dropkey": "PV22512",
    "droptype": "D",
    "dropname": "SOUTH HARWICH",
    "dropdeladd": "944 ROUTE 28",
    "dropdelcty": "SOUTH HARWICH",
    "dropdelst": "MA",
    "dropdelzpp": "026619800",
    "dropphyadd": "944 ROUTE 28",
    "dropphycty": "SOUTH HARWICH",
    "dropphyst": "MA",
    "dropphyzpp": "026619800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH HARWICH",
    "dropmalst": "MA",
    "dropmalzpp": "026619998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084327219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22513",
    "droptype": "D",
    "dropname": "SOUTH LANCASTER",
    "dropdeladd": "93 SAWYER ST",
    "dropdelcty": "SOUTH LANCASTER",
    "dropdelst": "MA",
    "dropdelzpp": "015619800",
    "dropphyadd": "93 SAWYER ST",
    "dropphycty": "SOUTH LANCASTER",
    "dropphyst": "MA",
    "dropphyzpp": "015619800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH LANCASTER",
    "dropmalst": "MA",
    "dropmalzpp": "015619998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783654631,
    "dropfax": 9783651798
  },
  {
    "dcode": "D",
    "dropkey": "PV22515",
    "droptype": "D",
    "dropname": "SOUTH LEE",
    "dropdeladd": "10 CHURCH ST",
    "dropdelcty": "SOUTH LEE",
    "dropdelst": "MA",
    "dropdelzpp": "012609998",
    "dropphyadd": "10 CHURCH ST",
    "dropphycty": "SOUTH LEE",
    "dropphyst": "MA",
    "dropphyzpp": "012609998",
    "dropmaladd": "10 CHURCH ST",
    "dropmalcty": "SOUTH LEE",
    "dropmalst": "MA",
    "dropmalzpp": "012609998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132433112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22522",
    "droptype": "D",
    "dropname": "SOUTH ORLEANS",
    "dropdeladd": "403 S ORLEANS RD",
    "dropdelcty": "SOUTH ORLEANS",
    "dropdelst": "MA",
    "dropdelzpp": "026629800",
    "dropphyadd": "403 S ORLEANS RD",
    "dropphycty": "SOUTH ORLEANS",
    "dropphyst": "MA",
    "dropphyzpp": "026629800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH ORLEANS",
    "dropmalst": "MA",
    "dropmalzpp": "026629998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082553879,
    "dropfax": 5082558413
  },
  {
    "dcode": "D",
    "dropkey": "PV22529",
    "droptype": "D",
    "dropname": "SOUTH WALPOLE",
    "dropdeladd": "44 SUMMER ST",
    "dropdelcty": "SOUTH WALPOLE",
    "dropdelst": "MA",
    "dropdelzpp": "020719998",
    "dropphyadd": "44 SUMMER ST",
    "dropphycty": "SOUTH WALPOLE",
    "dropphyst": "MA",
    "dropphyzpp": "020719998",
    "dropmaladd": "44 SUMMER ST",
    "dropmalcty": "SOUTH WALPOLE",
    "dropmalst": "MA",
    "dropmalzpp": "020719998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086686984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22531",
    "droptype": "D",
    "dropname": "SOUTH WELLFLEET",
    "dropdeladd": "1426 ROUTE 6",
    "dropdelcty": "SOUTH WELLFLEET",
    "dropdelst": "MA",
    "dropdelzpp": "026639800",
    "dropphyadd": "1426 ROUTE 6",
    "dropphycty": "SOUTH WELLFLEET",
    "dropphyst": "MA",
    "dropphyzpp": "026639800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH WELLFLEET",
    "dropmalst": "MA",
    "dropmalzpp": "026639998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083496953,
    "dropfax": 5083494094
  },
  {
    "dcode": "D",
    "dropkey": "PV22536",
    "droptype": "D",
    "dropname": "SOUTH YARMOUTH",
    "dropdeladd": "1057 ROUTE 28",
    "dropdelcty": "SOUTH YARMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "026649998",
    "dropphyadd": "1057 ROUTE 28",
    "dropphycty": "SOUTH YARMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "026649998",
    "dropmaladd": "1057 ROUTE 28",
    "dropmalcty": "SOUTH YARMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "026649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083984385,
    "dropfax": 5083984582
  },
  {
    "dcode": "D",
    "dropkey": "PV22538",
    "droptype": "D",
    "dropname": "SOUTHAMPTON",
    "dropdeladd": "8 POMEROY MEADOW RD",
    "dropdelcty": "SOUTHAMPTON",
    "dropdelst": "MA",
    "dropdelzpp": "010739998",
    "dropphyadd": "8 POMEROY MEADOW RD",
    "dropphycty": "SOUTHAMPTON",
    "dropphyst": "MA",
    "dropphyzpp": "010739998",
    "dropmaladd": "8 POMEROY MEADOW RD",
    "dropmalcty": "SOUTHAMPTON",
    "dropmalst": "MA",
    "dropmalzpp": "010739998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135274666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22540",
    "droptype": "D",
    "dropname": "SOUTHBOROUGH",
    "dropdeladd": "164 CORDAVILLE RD",
    "dropdelcty": "SOUTHBOROUGH",
    "dropdelst": "MA",
    "dropdelzpp": "017729998",
    "dropphyadd": "164 CORDAVILLE RD",
    "dropphycty": "SOUTHBOROUGH",
    "dropphyst": "MA",
    "dropphyzpp": "017729998",
    "dropmaladd": "164 CORDAVILLE RD",
    "dropmalcty": "SOUTHBOROUGH",
    "dropmalst": "MA",
    "dropmalzpp": "017729998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084854736,
    "dropfax": 5083578813
  },
  {
    "dcode": "D",
    "dropkey": "PV22541",
    "droptype": "D",
    "dropname": "SOUTHBRIDGE",
    "dropdeladd": "235 MAIN ST",
    "dropdelcty": "SOUTHBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "015509998",
    "dropphyadd": "235 MAIN ST",
    "dropphycty": "SOUTHBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "015509998",
    "dropmaladd": "235 MAIN ST",
    "dropmalcty": "SOUTHBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "015509998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5087644502,
    "dropfax": 5087643760
  },
  {
    "dcode": "D",
    "dropkey": "PV22544",
    "droptype": "D",
    "dropname": "SOUTHFIELD",
    "dropdeladd": "224 NORFOLK RD",
    "dropdelcty": "SOUTHFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "012599998",
    "dropphyadd": "224 NORFOLK RD",
    "dropphycty": "SOUTHFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "012599998",
    "dropmaladd": "224 NORFOLK RD",
    "dropmalcty": "SOUTHFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "012599998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132298476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22547",
    "droptype": "D",
    "dropname": "SOUTHWICK",
    "dropdeladd": "653 COLLEGE HWY",
    "dropdelcty": "SOUTHWICK",
    "dropdelst": "MA",
    "dropdelzpp": "010779998",
    "dropphyadd": "653 COLLEGE HWY",
    "dropphycty": "SOUTHWICK",
    "dropphyst": "MA",
    "dropphyzpp": "010779998",
    "dropmaladd": "653 COLLEGE HWY",
    "dropmalcty": "SOUTHWICK",
    "dropmalst": "MA",
    "dropmalzpp": "010779998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4135696619,
    "dropsitcph": 4135696619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22548",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "10 MECHANIC ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "MA",
    "dropdelzpp": "015629998",
    "dropphyadd": "10 MECHANIC ST",
    "dropphycty": "SPENCER",
    "dropphyst": "MA",
    "dropphyzpp": "015629998",
    "dropmaladd": "10 MECHANIC ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "MA",
    "dropmalzpp": "015629998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088855682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22552",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "1883 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011019998",
    "dropphyadd": "1883 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011019998",
    "dropmaladd": "1883 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011019998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137310573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22613",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "6 CLINTON RD",
    "dropdelcty": "STERLING",
    "dropdelst": "MA",
    "dropdelzpp": "015649998",
    "dropphyadd": "6 CLINTON RD",
    "dropphycty": "STERLING",
    "dropphyst": "MA",
    "dropphyzpp": "015649998",
    "dropmaladd": "6 CLINTON RD",
    "dropmalcty": "STERLING",
    "dropmalst": "MA",
    "dropmalzpp": "015649998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784225139,
    "dropfax": 9784223474
  },
  {
    "dcode": "D",
    "dropkey": "PV22617",
    "droptype": "D",
    "dropname": "STILL RIVER",
    "dropdeladd": "206 STILL RIVER RD",
    "dropdelcty": "STILL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "014679800",
    "dropphyadd": "206 STILL RIVER RD",
    "dropphycty": "STILL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "014679800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STILL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "014679998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784563632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22619",
    "droptype": "D",
    "dropname": "STOCKBRIDGE",
    "dropdeladd": "1 ELM ST",
    "dropdelcty": "STOCKBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "012629998",
    "dropphyadd": "1 ELM ST",
    "dropphycty": "STOCKBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "012629998",
    "dropmaladd": "1 ELM ST",
    "dropmalcty": "STOCKBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "012629998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132984422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22624",
    "droptype": "D",
    "dropname": "STOUGHTON",
    "dropdeladd": "31 PORTER ST",
    "dropdelcty": "STOUGHTON",
    "dropdelst": "MA",
    "dropdelzpp": "020729998",
    "dropphyadd": "31 PORTER ST",
    "dropphycty": "STOUGHTON",
    "dropphyst": "MA",
    "dropphyzpp": "020729998",
    "dropmaladd": "31 PORTER ST",
    "dropmalcty": "STOUGHTON",
    "dropmalst": "MA",
    "dropmalzpp": "020729998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7813441680,
    "dropfax": 7813410741
  },
  {
    "dcode": "D",
    "dropkey": "PV22625",
    "droptype": "D",
    "dropname": "STOW",
    "dropdeladd": "179 GREAT RD",
    "dropdelcty": "STOW",
    "dropdelst": "MA",
    "dropdelzpp": "017759998",
    "dropphyadd": "179 GREAT RD",
    "dropphycty": "STOW",
    "dropphyst": "MA",
    "dropphyzpp": "017759998",
    "dropmaladd": "179 GREAT RD",
    "dropmalcty": "STOW",
    "dropmalst": "MA",
    "dropmalzpp": "017759998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788971981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22626",
    "droptype": "D",
    "dropname": "STURBRIDGE",
    "dropdeladd": "316 MAIN ST",
    "dropdelcty": "STURBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "015669998",
    "dropphyadd": "316 MAIN ST",
    "dropphycty": "STURBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "015669998",
    "dropmaladd": "316 MAIN ST",
    "dropmalcty": "STURBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "015669998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083476463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22627",
    "droptype": "D",
    "dropname": "SUDBURY",
    "dropdeladd": "18 UNION AVE",
    "dropdelcty": "SUDBURY",
    "dropdelst": "MA",
    "dropdelzpp": "017769998",
    "dropphyadd": "18 UNION AVE",
    "dropphycty": "SUDBURY",
    "dropphyst": "MA",
    "dropphyzpp": "017769998",
    "dropmaladd": "18 UNION AVE",
    "dropmalcty": "SUDBURY",
    "dropmalst": "MA",
    "dropmalzpp": "017769998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784438188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22629",
    "droptype": "D",
    "dropname": "SUNDERLAND",
    "dropdeladd": "12 GARAGE RD",
    "dropdelcty": "SUNDERLAND",
    "dropdelst": "MA",
    "dropdelzpp": "013759998",
    "dropphyadd": "12 GARAGE RD",
    "dropphycty": "SUNDERLAND",
    "dropphyst": "MA",
    "dropphyzpp": "013759998",
    "dropmaladd": "12 GARAGE RD",
    "dropmalcty": "SUNDERLAND",
    "dropmalst": "MA",
    "dropmalzpp": "013759998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136652292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22632",
    "droptype": "D",
    "dropname": "SUTTON",
    "dropdeladd": "156 WORCESTER PROVIDENCE TPKE STE 12",
    "dropdelcty": "SUTTON",
    "dropdelst": "MA",
    "dropdelzpp": "015909998",
    "dropphyadd": "156 WORCESTER PROVIDENCE TPKE STE 12",
    "dropphycty": "SUTTON",
    "dropphyst": "MA",
    "dropphyzpp": "015909998",
    "dropmaladd": "156 WORCESTER PROVIDENCE TPKE STE 12",
    "dropmalcty": "SUTTON",
    "dropmalst": "MA",
    "dropmalzpp": "015909998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088652876,
    "dropfax": 5088655387
  },
  {
    "dcode": "D",
    "dropkey": "PV22634",
    "droptype": "D",
    "dropname": "SWANSEA",
    "dropdeladd": "1278 GAR HWY",
    "dropdelcty": "SWANSEA",
    "dropdelst": "MA",
    "dropdelzpp": "027779998",
    "dropphyadd": "1278 GAR HWY",
    "dropphycty": "SWANSEA",
    "dropphyst": "MA",
    "dropphyzpp": "027779998",
    "dropmaladd": "1278 GAR HWY",
    "dropmalcty": "SWANSEA",
    "dropmalst": "MA",
    "dropmalzpp": "027779998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086773397,
    "dropfax": 5087302872
  },
  {
    "dcode": "D",
    "dropkey": "PV22638",
    "droptype": "D",
    "dropname": "TAUNTON",
    "dropdeladd": "245 MYLES STANDISH BLVD",
    "dropdelcty": "TAUNTON",
    "dropdelst": "MA",
    "dropdelzpp": "027809998",
    "dropphyadd": "245 MYLES STANDISH BLVD",
    "dropphycty": "TAUNTON",
    "dropphyst": "MA",
    "dropphyzpp": "027809998",
    "dropmaladd": "245 MYLES STANDISH BLVD",
    "dropmalcty": "TAUNTON",
    "dropmalst": "MA",
    "dropmalzpp": "027809998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088225307,
    "dropfax": 5088281561
  },
  {
    "dcode": "D",
    "dropkey": "PV22640",
    "droptype": "D",
    "dropname": "TEMPLETON",
    "dropdeladd": "449 PATRIOTS RD",
    "dropdelcty": "TEMPLETON",
    "dropdelst": "MA",
    "dropdelzpp": "014689998",
    "dropphyadd": "449 PATRIOTS RD",
    "dropphycty": "TEMPLETON",
    "dropphyst": "MA",
    "dropphyzpp": "014689998",
    "dropmaladd": "449 PATRIOTS RD",
    "dropmalcty": "TEMPLETON",
    "dropmalst": "MA",
    "dropmalzpp": "014689998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789397309,
    "dropfax": 9789398685
  },
  {
    "dcode": "D",
    "dropkey": "PV22641",
    "droptype": "D",
    "dropname": "TEWKSBURY",
    "dropdeladd": "1751 MAIN ST",
    "dropdelcty": "TEWKSBURY",
    "dropdelst": "MA",
    "dropdelzpp": "018769998",
    "dropphyadd": "1751 MAIN ST",
    "dropphycty": "TEWKSBURY",
    "dropphyst": "MA",
    "dropphyzpp": "018769998",
    "dropmaladd": "1751 MAIN ST",
    "dropmalcty": "TEWKSBURY",
    "dropmalst": "MA",
    "dropmalzpp": "018769998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788516390,
    "dropfax": 9788514626
  },
  {
    "dcode": "D",
    "dropkey": "PV22644",
    "droptype": "D",
    "dropname": "THORNDIKE",
    "dropdeladd": "36 CHURCH ST",
    "dropdelcty": "THORNDIKE",
    "dropdelst": "MA",
    "dropdelzpp": "010799998",
    "dropphyadd": "36 CHURCH ST",
    "dropphycty": "THORNDIKE",
    "dropphyst": "MA",
    "dropphyzpp": "010799998",
    "dropmaladd": "36 CHURCH ST",
    "dropmalcty": "THORNDIKE",
    "dropmalst": "MA",
    "dropmalzpp": "010799998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132839566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22645",
    "droptype": "D",
    "dropname": "THREE RIVERS",
    "dropdeladd": "2020 BRIDGE ST",
    "dropdelcty": "THREE RIVERS",
    "dropdelst": "MA",
    "dropdelzpp": "010809998",
    "dropphyadd": "2020 BRIDGE ST",
    "dropphycty": "THREE RIVERS",
    "dropphyst": "MA",
    "dropphyzpp": "010809998",
    "dropmaladd": "2020 BRIDGE ST",
    "dropmalcty": "THREE RIVERS",
    "dropmalst": "MA",
    "dropmalzpp": "010809998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4132838812,
    "dropsitcph": 4132838812,
    "dropfax": 4132891694
  },
  {
    "dcode": "D",
    "dropkey": "PV22650",
    "droptype": "D",
    "dropname": "TOPSFIELD",
    "dropdeladd": "4 MAIN ST",
    "dropdelcty": "TOPSFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "019839998",
    "dropphyadd": "4 MAIN ST",
    "dropphycty": "TOPSFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "019839998",
    "dropmaladd": "4 MAIN ST",
    "dropmalcty": "TOPSFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "019839998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788875307,
    "dropfax": 9788876105
  },
  {
    "dcode": "D",
    "dropkey": "PV22652",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "227 MAIN ST",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "MA",
    "dropdelzpp": "014699998",
    "dropphyadd": "227 MAIN ST",
    "dropphycty": "TOWNSEND",
    "dropphyst": "MA",
    "dropphyzpp": "014699998",
    "dropmaladd": "227 MAIN ST",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "MA",
    "dropmalzpp": "014699998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785971894,
    "dropfax": 9785973462
  },
  {
    "dcode": "D",
    "dropkey": "PV22655",
    "droptype": "D",
    "dropname": "TRURO",
    "dropdeladd": "16 TRURO CENTER RD",
    "dropdelcty": "TRURO",
    "dropdelst": "MA",
    "dropdelzpp": "026669800",
    "dropphyadd": "16 TRURO CENTER RD",
    "dropphycty": "TRURO",
    "dropphyst": "MA",
    "dropphyzpp": "026669800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRURO",
    "dropmalst": "MA",
    "dropmalzpp": "026669998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083496712,
    "dropfax": 5083498241
  },
  {
    "dcode": "D",
    "dropkey": "PV22659",
    "droptype": "D",
    "dropname": "TURNERS FALLS",
    "dropdeladd": "178 AVENUE A",
    "dropdelcty": "TURNERS FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "013769998",
    "dropphyadd": "178 AVENUE A",
    "dropphycty": "TURNERS FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "013769998",
    "dropmaladd": "178 AVENUE A",
    "dropmalcty": "TURNERS FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "013769998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4138634727,
    "dropfax": 4138633009
  },
  {
    "dcode": "D",
    "dropkey": "PV22663",
    "droptype": "D",
    "dropname": "TYNGSBORO",
    "dropdeladd": "353 MIDDLESEX RD",
    "dropdelcty": "TYNGSBORO",
    "dropdelst": "MA",
    "dropdelzpp": "018791084",
    "dropphyadd": "353 MIDDLESEX RD",
    "dropphycty": "TYNGSBORO",
    "dropphyst": "MA",
    "dropphyzpp": "018791084",
    "dropmaladd": "353 MIDDLESEX RD",
    "dropmalcty": "TYNGSBORO",
    "dropmalst": "MA",
    "dropmalzpp": "018791084",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786497381,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV22672",
    "droptype": "D",
    "dropname": "UXBRIDGE",
    "dropdeladd": "287 MILLVILLE RD",
    "dropdelcty": "UXBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "015699998",
    "dropphyadd": "287 MILLVILLE RD",
    "dropphycty": "UXBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "015699998",
    "dropmaladd": "287 MILLVILLE RD",
    "dropmalcty": "UXBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "015699998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082786834,
    "dropfax": 5082782485
  },
  {
    "dcode": "D",
    "dropkey": "PV22675",
    "droptype": "D",
    "dropname": "VINEYARD HAVEN",
    "dropdeladd": "1 LAGOON POND RD",
    "dropdelcty": "VINEYARD HAVEN",
    "dropdelst": "MA",
    "dropdelzpp": "025685514",
    "dropphyadd": "1 LAGOON POND RD",
    "dropphycty": "VINEYARD HAVEN",
    "dropphyst": "MA",
    "dropphyzpp": "025685514",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VINEYARD HAVEN",
    "dropmalst": "MA",
    "dropmalzpp": "025689998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086932818,
    "dropfax": 5086968993
  },
  {
    "dcode": "D",
    "dropkey": "PV22709",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "321 MAIN ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "018809998",
    "dropphyadd": "321 MAIN ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "018809998",
    "dropmaladd": "321 MAIN ST",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "018809998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812453831,
    "dropfax": 7812240635
  },
  {
    "dcode": "D",
    "dropkey": "PV22710",
    "droptype": "D",
    "dropname": "WALES",
    "dropdeladd": "2 MONSON RD",
    "dropdelcty": "WALES",
    "dropdelst": "MA",
    "dropdelzpp": "010819998",
    "dropphyadd": "2 MONSON RD",
    "dropphycty": "WALES",
    "dropphyst": "MA",
    "dropphyzpp": "010819998",
    "dropmaladd": "2 MONSON RD",
    "dropmalcty": "WALES",
    "dropmalst": "MA",
    "dropmalzpp": "010819998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132459808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22714",
    "droptype": "D",
    "dropname": "WALPOLE",
    "dropdeladd": "10 COMMON ST",
    "dropdelcty": "WALPOLE",
    "dropdelst": "MA",
    "dropdelzpp": "020819998",
    "dropphyadd": "10 COMMON ST",
    "dropphycty": "WALPOLE",
    "dropphyst": "MA",
    "dropphyzpp": "020819998",
    "dropmaladd": "10 COMMON ST",
    "dropmalcty": "WALPOLE",
    "dropmalst": "MA",
    "dropmalzpp": "020819998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086687901,
    "dropfax": 5086607734
  },
  {
    "dcode": "D",
    "dropkey": "PV22720",
    "droptype": "D",
    "dropname": "WARE",
    "dropdeladd": "165 WEST ST",
    "dropdelcty": "WARE",
    "dropdelst": "MA",
    "dropdelzpp": "010821457",
    "dropphyadd": "165 WEST ST",
    "dropphycty": "WARE",
    "dropphyst": "MA",
    "dropphyzpp": "010821457",
    "dropmaladd": "165 WEST ST",
    "dropmalcty": "WARE",
    "dropmalst": "MA",
    "dropmalzpp": "010821457",
    "dropsitphn": 4139679914,
    "dropsitlph": 4137856246,
    "dropsitcph": 4139679914,
    "dropfax": 4139673649
  },
  {
    "dcode": "D",
    "dropkey": "PV22721",
    "droptype": "D",
    "dropname": "WAREHAM",
    "dropdeladd": "248 MAIN ST",
    "dropdelcty": "WAREHAM",
    "dropdelst": "MA",
    "dropdelzpp": "025719998",
    "dropphyadd": "248 MAIN ST",
    "dropphycty": "WAREHAM",
    "dropphyst": "MA",
    "dropphyzpp": "025719998",
    "dropmaladd": "248 MAIN ST",
    "dropmalcty": "WAREHAM",
    "dropmalst": "MA",
    "dropmalzpp": "025719998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082950968,
    "dropfax": 5082950749
  },
  {
    "dcode": "D",
    "dropkey": "PV22722",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "16 MILTON O FOUNTAIN WAY",
    "dropdelcty": "WARREN",
    "dropdelst": "MA",
    "dropdelzpp": "010839998",
    "dropphyadd": "16 MILTON O FOUNTAIN WAY",
    "dropphycty": "WARREN",
    "dropphyst": "MA",
    "dropphyzpp": "010839998",
    "dropmaladd": "16 MILTON O FOUNTAIN WAY",
    "dropmalcty": "WARREN",
    "dropmalst": "MA",
    "dropmalzpp": "010839998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134365623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22730",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "277 BOSTON POST RD",
    "dropdelcty": "WAYLAND",
    "dropdelst": "MA",
    "dropdelzpp": "017789998",
    "dropphyadd": "277 BOSTON POST RD",
    "dropphycty": "WAYLAND",
    "dropphyst": "MA",
    "dropphyzpp": "017789998",
    "dropmaladd": "277 BOSTON POST RD",
    "dropmalcty": "WAYLAND",
    "dropmalst": "MA",
    "dropmalzpp": "017789998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083580823,
    "dropfax": 5083580276
  },
  {
    "dcode": "D",
    "dropkey": "PV22732",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "339 MAIN ST",
    "dropdelcty": "WEBSTER",
    "dropdelst": "MA",
    "dropdelzpp": "015709998",
    "dropphyadd": "339 MAIN ST",
    "dropphycty": "WEBSTER",
    "dropphyst": "MA",
    "dropphyzpp": "015709998",
    "dropmaladd": "339 MAIN ST",
    "dropmalcty": "WEBSTER",
    "dropmalst": "MA",
    "dropmalzpp": "015709998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5089437525,
    "dropfax": 5089439103
  },
  {
    "dcode": "D",
    "dropkey": "PV22742",
    "droptype": "D",
    "dropname": "WELLFLEET",
    "dropdeladd": "2357 STATE HWY RTE 6",
    "dropdelcty": "WELLFLEET",
    "dropdelst": "MA",
    "dropdelzpp": "026679800",
    "dropphyadd": "2357 STATE HWY RTE 6",
    "dropphycty": "WELLFLEET",
    "dropphyst": "MA",
    "dropphyzpp": "026679800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLFLEET",
    "dropmalst": "MA",
    "dropmalzpp": "026679998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083496117,
    "dropfax": 5083492852
  },
  {
    "dcode": "D",
    "dropkey": "PV22745",
    "droptype": "D",
    "dropname": "WENDELL",
    "dropdeladd": "59 LOCKES VILLAGE RD",
    "dropdelcty": "WENDELL",
    "dropdelst": "MA",
    "dropdelzpp": "013799998",
    "dropphyadd": "59 LOCKES VILLAGE RD",
    "dropphycty": "WENDELL",
    "dropphyst": "MA",
    "dropphyzpp": "013799998",
    "dropmaladd": "59 LOCKES VILLAGE RD",
    "dropmalcty": "WENDELL",
    "dropmalst": "MA",
    "dropmalzpp": "013799998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9785447090,
    "dropfax": 9785447748
  },
  {
    "dcode": "D",
    "dropkey": "PV22746",
    "droptype": "D",
    "dropname": "WENDELL DEPOT",
    "dropdeladd": "466 WENDELL DEPOT RD",
    "dropdelcty": "WENDELL DEPOT",
    "dropdelst": "MA",
    "dropdelzpp": "013809998",
    "dropphyadd": "466 WENDELL DEPOT RD",
    "dropphycty": "WENDELL DEPOT",
    "dropphyst": "MA",
    "dropphyzpp": "013809998",
    "dropmaladd": "466 WENDELL DEPOT RD",
    "dropmalcty": "WENDELL DEPOT",
    "dropmalst": "MA",
    "dropmalzpp": "013809998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 9785446682,
    "dropfax": 9785445187
  },
  {
    "dcode": "D",
    "dropkey": "PV22747",
    "droptype": "D",
    "dropname": "WENHAM",
    "dropdeladd": "146 MAIN ST",
    "dropdelcty": "WENHAM",
    "dropdelst": "MA",
    "dropdelzpp": "019849998",
    "dropphyadd": "146 MAIN ST",
    "dropphycty": "WENHAM",
    "dropphyst": "MA",
    "dropphyzpp": "019849998",
    "dropmaladd": "146 MAIN ST",
    "dropmalcty": "WENHAM",
    "dropmalst": "MA",
    "dropmalzpp": "019849998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784684493,
    "dropfax": 9784681793
  },
  {
    "dcode": "D",
    "dropkey": "PV22751",
    "droptype": "D",
    "dropname": "WEST BARNSTABLE",
    "dropdeladd": "1165 MAIN ST",
    "dropdelcty": "WEST BARNSTABLE",
    "dropdelst": "MA",
    "dropdelzpp": "026689998",
    "dropphyadd": "1165 MAIN ST",
    "dropphycty": "WEST BARNSTABLE",
    "dropphyst": "MA",
    "dropphyzpp": "026689998",
    "dropmaladd": "1165 MAIN ST",
    "dropmalcty": "WEST BARNSTABLE",
    "dropmalst": "MA",
    "dropmalzpp": "026689998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083621750,
    "dropfax": 5083759276
  },
  {
    "dcode": "D",
    "dropkey": "PV22753",
    "droptype": "D",
    "dropname": "WEST BOXFORD",
    "dropdeladd": "561 MAIN ST",
    "dropdelcty": "WEST BOXFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018859800",
    "dropphyadd": "561 MAIN ST",
    "dropphycty": "WEST BOXFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018859800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST BOXFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018859998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783527698,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "PV22754",
    "droptype": "D",
    "dropname": "WEST BOYLSTON",
    "dropdeladd": "67 W BOYLSTON ST UNIT 5",
    "dropdelcty": "WEST BOYLSTON",
    "dropdelst": "MA",
    "dropdelzpp": "015839998",
    "dropphyadd": "67 W BOYLSTON ST UNIT 5",
    "dropphycty": "WEST BOYLSTON",
    "dropphyst": "MA",
    "dropphyzpp": "015839998",
    "dropmaladd": "67 W BOYLSTON ST UNIT 5",
    "dropmalcty": "WEST BOYLSTON",
    "dropmalst": "MA",
    "dropmalzpp": "015839998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088352022,
    "dropfax": 5088354185
  },
  {
    "dcode": "D",
    "dropkey": "PV22755",
    "droptype": "D",
    "dropname": "WEST BRIDGEWATER",
    "dropdeladd": "78 N MAIN ST",
    "dropdelcty": "WEST BRIDGEWATER",
    "dropdelst": "MA",
    "dropdelzpp": "023799998",
    "dropphyadd": "78 N MAIN ST",
    "dropphycty": "WEST BRIDGEWATER",
    "dropphyst": "MA",
    "dropphyzpp": "023799998",
    "dropmaladd": "78 N MAIN ST",
    "dropmalcty": "WEST BRIDGEWATER",
    "dropmalst": "MA",
    "dropmalzpp": "023799998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085887467,
    "dropfax": 5084279955
  },
  {
    "dcode": "D",
    "dropkey": "PV22756",
    "droptype": "D",
    "dropname": "WEST BROOKFIELD",
    "dropdeladd": "10 CENTRAL ST",
    "dropdelcty": "WEST BROOKFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "015859998",
    "dropphyadd": "10 CENTRAL ST",
    "dropphycty": "WEST BROOKFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "015859998",
    "dropmaladd": "10 CENTRAL ST",
    "dropmalcty": "WEST BROOKFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "015859998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088678641,
    "dropfax": 5088674436
  },
  {
    "dcode": "D",
    "dropkey": "PV22757",
    "droptype": "D",
    "dropname": "WEST CHATHAM",
    "dropdeladd": "1671 MAIN ST",
    "dropdelcty": "WEST CHATHAM",
    "dropdelst": "MA",
    "dropdelzpp": "026699800",
    "dropphyadd": "1671 MAIN ST",
    "dropphycty": "WEST CHATHAM",
    "dropphyst": "MA",
    "dropphyzpp": "026699800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST CHATHAM",
    "dropmalst": "MA",
    "dropmalzpp": "026699998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089457231,
    "dropfax": 5089454753
  },
  {
    "dcode": "D",
    "dropkey": "PV22764",
    "droptype": "D",
    "dropname": "WEST DENNIS",
    "dropdeladd": "97 SCHOOL ST",
    "dropdelcty": "WEST DENNIS",
    "dropdelst": "MA",
    "dropdelzpp": "026709998",
    "dropphyadd": "97 SCHOOL ST",
    "dropphycty": "WEST DENNIS",
    "dropphyst": "MA",
    "dropphyzpp": "026709998",
    "dropmaladd": "97 SCHOOL ST",
    "dropmalcty": "WEST DENNIS",
    "dropmalst": "MA",
    "dropmalzpp": "026709998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083984292,
    "dropfax": 5083946915
  },
  {
    "dcode": "D",
    "dropkey": "PV22766",
    "droptype": "D",
    "dropname": "WEST FALMOUTH",
    "dropdeladd": "410 W FALMOUTH HWY",
    "dropdelcty": "WEST FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025749800",
    "dropphyadd": "410 W FALMOUTH HWY",
    "dropphycty": "WEST FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025749800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025749998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084579012,
    "dropfax": 5085481766
  },
  {
    "dcode": "D",
    "dropkey": "PV22768",
    "droptype": "D",
    "dropname": "WEST GROTON",
    "dropdeladd": "6 PEPPERELL RD",
    "dropdelcty": "WEST GROTON",
    "dropdelst": "MA",
    "dropdelzpp": "014729800",
    "dropphyadd": "6 PEPPERELL RD",
    "dropphycty": "WEST GROTON",
    "dropphyst": "MA",
    "dropphyzpp": "014729800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST GROTON",
    "dropmalst": "MA",
    "dropmalzpp": "014729998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784480627,
    "dropfax": 9784483664
  },
  {
    "dcode": "D",
    "dropkey": "PV22771",
    "droptype": "D",
    "dropname": "WEST HARWICH",
    "dropdeladd": "216 ROUTE 28",
    "dropdelcty": "WEST HARWICH",
    "dropdelst": "MA",
    "dropdelzpp": "026719998",
    "dropphyadd": "216 ROUTE 28",
    "dropphycty": "WEST HARWICH",
    "dropphyst": "MA",
    "dropphyzpp": "026719998",
    "dropmaladd": "216 ROUTE 28",
    "dropmalcty": "WEST HARWICH",
    "dropmalst": "MA",
    "dropmalzpp": "026719998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5084323973,
    "dropfax": 5084301554
  },
  {
    "dcode": "D",
    "dropkey": "PV22774",
    "droptype": "D",
    "dropname": "WEST HYANNISPORT",
    "dropdeladd": "401 CRAIGVILLE BEACH RD",
    "dropdelcty": "WEST HYANNISPORT",
    "dropdelst": "MA",
    "dropdelzpp": "026729800",
    "dropphyadd": "401 CRAIGVILLE BEACH RD",
    "dropphycty": "WEST HYANNISPORT",
    "dropphyst": "MA",
    "dropphyzpp": "026729800",
    "dropmaladd": "401 CRAIGVILLE BEACH RD",
    "dropmalcty": "WEST HYANNISPORT",
    "dropmalst": "MA",
    "dropmalzpp": "026729800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087712818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22783",
    "droptype": "D",
    "dropname": "WEST NEWBURY",
    "dropdeladd": "284 MAIN ST",
    "dropdelcty": "WEST NEWBURY",
    "dropdelst": "MA",
    "dropdelzpp": "019859998",
    "dropphyadd": "284 MAIN ST",
    "dropphycty": "WEST NEWBURY",
    "dropphyst": "MA",
    "dropphyzpp": "019859998",
    "dropmaladd": "284 MAIN ST",
    "dropmalcty": "WEST NEWBURY",
    "dropmalst": "MA",
    "dropmalzpp": "019859998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783632948,
    "dropfax": 9783632140
  },
  {
    "dcode": "D",
    "dropkey": "PV22796",
    "droptype": "D",
    "dropname": "WEST SPRINGFIELD",
    "dropdeladd": "74 ELM ST",
    "dropdelcty": "WEST SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010899998",
    "dropphyadd": "74 ELM ST",
    "dropphycty": "WEST SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010899998",
    "dropmaladd": "74 ELM ST",
    "dropmalcty": "WEST SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010899998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137342321,
    "dropfax": 4137321635
  },
  {
    "dcode": "D",
    "dropkey": "PV22799",
    "droptype": "D",
    "dropname": "WEST STOCKBRIDGE",
    "dropdeladd": "4 CENTER ST",
    "dropdelcty": "WEST STOCKBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "012669998",
    "dropphyadd": "4 CENTER ST",
    "dropphycty": "WEST STOCKBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "012669998",
    "dropmaladd": "4 CENTER ST",
    "dropmalcty": "WEST STOCKBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "012669998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132328544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22801",
    "droptype": "D",
    "dropname": "WEST TISBURY",
    "dropdeladd": "479 STATE RD",
    "dropdelcty": "WEST TISBURY",
    "dropdelst": "MA",
    "dropdelzpp": "025759800",
    "dropphyadd": "479 STATE RD",
    "dropphycty": "WEST TISBURY",
    "dropphyst": "MA",
    "dropphyzpp": "025759800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST TISBURY",
    "dropmalst": "MA",
    "dropmalzpp": "025759998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086937899,
    "dropfax": 5086960794
  },
  {
    "dcode": "D",
    "dropkey": "PV22803",
    "droptype": "D",
    "dropname": "UPTON",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "UPTON",
    "dropdelst": "MA",
    "dropdelzpp": "015689998",
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "UPTON",
    "dropphyst": "MA",
    "dropphyzpp": "015689998",
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "UPTON",
    "dropmalst": "MA",
    "dropmalzpp": "015689998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5085299183,
    "dropfax": 5085296535
  },
  {
    "dcode": "D",
    "dropkey": "PV22804",
    "droptype": "D",
    "dropname": "WEST WAREHAM",
    "dropdeladd": "2360 CRANBERRY HWY",
    "dropdelcty": "WEST WAREHAM",
    "dropdelst": "MA",
    "dropdelzpp": "025769998",
    "dropphyadd": "2360 CRANBERRY HWY",
    "dropphycty": "WEST WAREHAM",
    "dropphyst": "MA",
    "dropphyzpp": "025769998",
    "dropmaladd": "2360 CRANBERRY HWY",
    "dropmalcty": "WEST WAREHAM",
    "dropmalst": "MA",
    "dropmalzpp": "025769998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082959206,
    "dropfax": 5082950280
  },
  {
    "dcode": "D",
    "dropkey": "PV22809",
    "droptype": "D",
    "dropname": "WESTBOROUGH",
    "dropdeladd": "150 E MAIN ST",
    "dropdelcty": "WESTBOROUGH",
    "dropdelst": "MA",
    "dropdelzpp": "015819998",
    "dropphyadd": "150 E MAIN ST",
    "dropphycty": "WESTBOROUGH",
    "dropphyst": "MA",
    "dropphyzpp": "015819998",
    "dropmaladd": "150 E MAIN ST",
    "dropmalcty": "WESTBOROUGH",
    "dropmalst": "MA",
    "dropmalzpp": "015819998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083667803,
    "dropfax": 5088989182
  },
  {
    "dcode": "D",
    "dropkey": "PV22810",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "8 W SILVER ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "010859998",
    "dropphyadd": "8 W SILVER ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "010859998",
    "dropmaladd": "8 W SILVER ST",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "010859998",
    "dropsitphn": 4135680096,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135680096,
    "dropfax": 4135627060
  },
  {
    "dcode": "D",
    "dropkey": "PV22811",
    "droptype": "D",
    "dropname": "WESTFORD",
    "dropdeladd": "301 LITTLETON RD",
    "dropdelcty": "WESTFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018866000",
    "dropphyadd": "301 LITTLETON RD",
    "dropphycty": "WESTFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018866000",
    "dropmaladd": "301 LITTLETON RD",
    "dropmalcty": "WESTFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018866000",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786923756,
    "dropfax": 9786920207
  },
  {
    "dcode": "D",
    "dropkey": "PV22813",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "6 NICHOLS ST",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "MA",
    "dropdelzpp": "014739998",
    "dropphyadd": "6 NICHOLS ST",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "MA",
    "dropphyzpp": "014739998",
    "dropmaladd": "6 NICHOLS ST",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "MA",
    "dropmalzpp": "014739998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9788740658,
    "dropfax": 9788741185
  },
  {
    "dcode": "D",
    "dropkey": "PV22818",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "649 STATE RD",
    "dropdelcty": "WESTPORT",
    "dropdelst": "MA",
    "dropdelzpp": "027909998",
    "dropphyadd": "649 STATE RD",
    "dropphycty": "WESTPORT",
    "dropphyst": "MA",
    "dropphyzpp": "027909998",
    "dropmaladd": "649 STATE RD",
    "dropmalcty": "WESTPORT",
    "dropmalst": "MA",
    "dropmalzpp": "027909998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086726881,
    "dropfax": 5086723950
  },
  {
    "dcode": "D",
    "dropkey": "PV22819",
    "droptype": "D",
    "dropname": "WESTPORT POINT",
    "dropdeladd": "1974 MAIN RD",
    "dropdelcty": "WESTPORT POINT",
    "dropdelst": "MA",
    "dropdelzpp": "027919800",
    "dropphyadd": "1974 MAIN RD",
    "dropphycty": "WESTPORT POINT",
    "dropphyst": "MA",
    "dropphyzpp": "027919800",
    "dropmaladd": "1974 MAIN RD",
    "dropmalcty": "WESTPORT POINT",
    "dropmalst": "MA",
    "dropmalzpp": "027919800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086361352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22821",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "697 HIGH ST",
    "dropdelcty": "WESTWOOD",
    "dropdelst": "MA",
    "dropdelzpp": "020909998",
    "dropphyadd": "697 HIGH ST",
    "dropphycty": "WESTWOOD",
    "dropphyst": "MA",
    "dropphyzpp": "020909998",
    "dropmaladd": "697 HIGH ST",
    "dropmalcty": "WESTWOOD",
    "dropmalst": "MA",
    "dropmalzpp": "020909998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7814612571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22827",
    "droptype": "D",
    "dropname": "WHATELY",
    "dropdeladd": "196 CHESTNUT PLAIN RD",
    "dropdelcty": "WHATELY",
    "dropdelst": "MA",
    "dropdelzpp": "010939998",
    "dropphyadd": "196 CHESTNUT PLAIN RD",
    "dropphycty": "WHATELY",
    "dropphyst": "MA",
    "dropphyzpp": "010939998",
    "dropmaladd": "196 CHESTNUT PLAIN RD",
    "dropmalcty": "WHATELY",
    "dropmalst": "MA",
    "dropmalzpp": "010939998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136652117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22828",
    "droptype": "D",
    "dropname": "WHEELWRIGHT",
    "dropdeladd": "60 CHURCH LN",
    "dropdelcty": "WHEELWRIGHT",
    "dropdelst": "MA",
    "dropdelzpp": "010949998",
    "dropphyadd": "60 CHURCH LN",
    "dropphycty": "WHEELWRIGHT",
    "dropphyst": "MA",
    "dropphyzpp": "010949998",
    "dropmaladd": "60 CHURCH LN",
    "dropmalcty": "WHEELWRIGHT",
    "dropmalst": "MA",
    "dropmalzpp": "010949998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134776014,
    "dropfax": 4134770048
  },
  {
    "dcode": "D",
    "dropkey": "PV22829",
    "droptype": "D",
    "dropname": "WHITE HORSE BEACH",
    "dropdeladd": "119 WHITE HORSE RD",
    "dropdelcty": "WHITE HORSE BEACH",
    "dropdelst": "MA",
    "dropdelzpp": "023819800",
    "dropphyadd": "119 WHITE HORSE RD",
    "dropphycty": "WHITE HORSE BEACH",
    "dropphyst": "MA",
    "dropphyzpp": "023819800",
    "dropmaladd": "119 WHITE HORSE RD",
    "dropmalcty": "WHITE HORSE BEACH",
    "dropmalst": "MA",
    "dropmalzpp": "023819800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082243482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22831",
    "droptype": "D",
    "dropname": "WHITINSVILLE",
    "dropdeladd": "44 CHURCH ST",
    "dropdelcty": "WHITINSVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "015889998",
    "dropphyadd": "44 CHURCH ST",
    "dropphycty": "WHITINSVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "015889998",
    "dropmaladd": "44 CHURCH ST",
    "dropmalcty": "WHITINSVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "015889998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5082345917,
    "dropfax": 5082349127
  },
  {
    "dcode": "D",
    "dropkey": "PV22832",
    "droptype": "D",
    "dropname": "WHITMAN",
    "dropdeladd": "64 SOUTH AVE",
    "dropdelcty": "WHITMAN",
    "dropdelst": "MA",
    "dropdelzpp": "023829998",
    "dropphyadd": "64 SOUTH AVE",
    "dropphycty": "WHITMAN",
    "dropphyst": "MA",
    "dropphyzpp": "023829998",
    "dropmaladd": "64 SOUTH AVE",
    "dropmalcty": "WHITMAN",
    "dropmalst": "MA",
    "dropmalzpp": "023829998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7814470968,
    "dropfax": 7814471685
  },
  {
    "dcode": "D",
    "dropkey": "PV22835",
    "droptype": "D",
    "dropname": "WILBRAHAM",
    "dropdeladd": "40 POST OFFICE PARK",
    "dropdelcty": "WILBRAHAM",
    "dropdelst": "MA",
    "dropdelzpp": "010959998",
    "dropphyadd": "40 POST OFFICE PARK",
    "dropphycty": "WILBRAHAM",
    "dropphyst": "MA",
    "dropphyzpp": "010959998",
    "dropmaladd": "40 POST OFFICE PARK",
    "dropmalcty": "WILBRAHAM",
    "dropmalst": "MA",
    "dropmalzpp": "010959998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135963146,
    "dropfax": 4135964305
  },
  {
    "dcode": "D",
    "dropkey": "PV22838",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "1 WILLIAMS ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "MA",
    "dropdelzpp": "010969998",
    "dropphyadd": "1 WILLIAMS ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "MA",
    "dropphyzpp": "010969998",
    "dropmaladd": "1 WILLIAMS ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "MA",
    "dropmalzpp": "010969998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132687274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22840",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "56 SPRING ST",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "012679998",
    "dropphyadd": "56 SPRING ST",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "012679998",
    "dropmaladd": "56 SPRING ST",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "012679998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4134583707,
    "dropfax": 4134580938
  },
  {
    "dcode": "D",
    "dropkey": "PV22844",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "18 CHURCH ST",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "018879998",
    "dropphyadd": "18 CHURCH ST",
    "dropphycty": "WILMINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "018879998",
    "dropmaladd": "18 CHURCH ST",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "018879998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786588063,
    "dropfax": 9786578917
  },
  {
    "dcode": "D",
    "dropkey": "PV22846",
    "droptype": "D",
    "dropname": "WINCHENDON",
    "dropdeladd": "160 CENTRAL ST",
    "dropdelcty": "WINCHENDON",
    "dropdelst": "MA",
    "dropdelzpp": "014759998",
    "dropphyadd": "160 CENTRAL ST",
    "dropphycty": "WINCHENDON",
    "dropphyst": "MA",
    "dropphyzpp": "014759998",
    "dropmaladd": "160 CENTRAL ST",
    "dropmalcty": "WINCHENDON",
    "dropmalst": "MA",
    "dropmalzpp": "014759998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782974108,
    "dropfax": 9782971938
  },
  {
    "dcode": "D",
    "dropkey": "PV22847",
    "droptype": "D",
    "dropname": "WINCHENDON SPRINGS",
    "dropdeladd": "159 MILL CIR",
    "dropdelcty": "WINCHENDON",
    "dropdelst": "MA",
    "dropdelzpp": "014752360",
    "dropphyadd": "159 MILL CIR",
    "dropphycty": "WINCHENDON",
    "dropphyst": "MA",
    "dropphyzpp": "014752360",
    "dropmaladd": "159 MILL CIR",
    "dropmalcty": "WINCHENDON",
    "dropmalst": "MA",
    "dropmalzpp": "014752360",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782974112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22848",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "48 WATERFIELD RD",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "018909998",
    "dropphyadd": "48 WATERFIELD RD",
    "dropphycty": "WINCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "018909998",
    "dropmaladd": "48 WATERFIELD RD",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "018909998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7817296024,
    "dropfax": 7817214919
  },
  {
    "dcode": "D",
    "dropkey": "PV22856",
    "droptype": "D",
    "dropname": "WOBURN",
    "dropdeladd": "462 WASHINGTON ST",
    "dropdelcty": "WOBURN",
    "dropdelst": "MA",
    "dropdelzpp": "018019998",
    "dropphyadd": "462 WASHINGTON ST",
    "dropphycty": "WOBURN",
    "dropphyst": "MA",
    "dropphyzpp": "018019998",
    "dropmaladd": "462 WASHINGTON ST",
    "dropmalcty": "WOBURN",
    "dropmalst": "MA",
    "dropmalzpp": "018019998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7819378600,
    "dropfax": 7819375827
  },
  {
    "dcode": "D",
    "dropkey": "PV22860",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "234 WOOD ST",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "017849800",
    "dropphyadd": "234 WOOD ST",
    "dropphycty": "WOODVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "017849800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "017849998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5084356458,
    "dropfax": 5084356458
  },
  {
    "dcode": "D",
    "dropkey": "PV22863",
    "droptype": "D",
    "dropname": "WORCESTER",
    "dropdeladd": "4 E CENTRAL ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016139998",
    "dropphyadd": "4 E CENTRAL ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016139998",
    "dropmaladd": "4 E CENTRAL ST",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016139998",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087953600,
    "dropsitcph": 5087953600,
    "dropfax": 5087953606
  },
  {
    "dcode": "D",
    "dropkey": "PV22867",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "2 PACKARD PARK",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "010989998",
    "dropphyadd": "2 PACKARD PARK",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "010989998",
    "dropmaladd": "2 PACKARD PARK",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "010989998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4132387750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22868",
    "droptype": "D",
    "dropname": "WRENTHAM",
    "dropdeladd": "100 RANDALL RD",
    "dropdelcty": "WRENTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020939998",
    "dropphyadd": "100 RANDALL RD",
    "dropphycty": "WRENTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020939998",
    "dropmaladd": "100 RANDALL RD",
    "dropmalcty": "WRENTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "020939998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083840027,
    "dropfax": 5083846452
  },
  {
    "dcode": "D",
    "dropkey": "PV22870",
    "droptype": "D",
    "dropname": "YARMOUTH PORT",
    "dropdeladd": "231 ROUTE 6A",
    "dropdelcty": "YARMOUTH PORT",
    "dropdelst": "MA",
    "dropdelzpp": "026759998",
    "dropphyadd": "231 ROUTE 6A",
    "dropphycty": "YARMOUTH PORT",
    "dropphyst": "MA",
    "dropphyzpp": "026759998",
    "dropmaladd": "231 ROUTE 6A",
    "dropmalcty": "YARMOUTH PORT",
    "dropmalst": "MA",
    "dropmalzpp": "026759998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083627485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22872",
    "droptype": "D",
    "dropname": "ABELL",
    "dropdeladd": "21388 ABELL RD",
    "dropdelcty": "ABELL",
    "dropdelst": "MD",
    "dropdelzpp": 206069998,
    "dropphyadd": "21388 ABELL RD",
    "dropphycty": "ABELL",
    "dropphyst": "MD",
    "dropphyzpp": 206069998,
    "dropmaladd": "21388 ABELL RD",
    "dropmalcty": "ABELL",
    "dropmalst": "MD",
    "dropmalzpp": 206069998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017692262,
    "dropsitcph": 3017692262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22873",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "30 W BEL AIR AVE",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "MD",
    "dropdelzpp": 210019998,
    "dropphyadd": "30 W BEL AIR AVE",
    "dropphycty": "ABERDEEN",
    "dropphyst": "MD",
    "dropphyzpp": 210019998,
    "dropmaladd": "30 W BEL AIR AVE",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "MD",
    "dropmalzpp": 210019998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102721610,
    "dropsitcph": 4102721610,
    "dropfax": 4102736570
  },
  {
    "dcode": "D",
    "dropkey": "PV22874",
    "droptype": "D",
    "dropname": "ABERDEEN PROVING GROUND",
    "dropdeladd": "4510 BOOTHBY HILL AVE",
    "dropdelcty": "ABERDEEN PROVING GROUND",
    "dropdelst": "MD",
    "dropdelzpp": 210059998,
    "dropphyadd": "4510 BOOTHBY HILL AVE",
    "dropphycty": "ABERDEEN PROVING GROUND",
    "dropphyst": "MD",
    "dropphyzpp": 210059998,
    "dropmaladd": "4510 BOOTHBY HILL AVE",
    "dropmalcty": "ABERDEEN PROVING GROUND",
    "dropmalst": "MD",
    "dropmalzpp": 210059998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102787967,
    "dropsitcph": 4102787967,
    "dropfax": 4102727185
  },
  {
    "dcode": "D",
    "dropkey": "PV22875",
    "droptype": "D",
    "dropname": "ABINGDON",
    "dropdeladd": "2945 EMMORTON RD",
    "dropdelcty": "ABINGDON",
    "dropdelst": "MD",
    "dropdelzpp": 210099998,
    "dropphyadd": "2945 EMMORTON RD",
    "dropphycty": "ABINGDON",
    "dropphyst": "MD",
    "dropphyzpp": 210099998,
    "dropmaladd": "2945 EMMORTON RD",
    "dropmalcty": "ABINGDON",
    "dropmalst": "MD",
    "dropmalzpp": 210099998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105694421,
    "dropsitcph": 4105694421,
    "dropfax": 4105691119
  },
  {
    "dcode": "D",
    "dropkey": "PV22877",
    "droptype": "D",
    "dropname": "ACCIDENT",
    "dropdeladd": "103 SOUTH ST",
    "dropdelcty": "ACCIDENT",
    "dropdelst": "MD",
    "dropdelzpp": 215209998,
    "dropphyadd": "103 SOUTH ST",
    "dropphycty": "ACCIDENT",
    "dropphyst": "MD",
    "dropphyzpp": 215209998,
    "dropmaladd": "103 SOUTH ST",
    "dropmalcty": "ACCIDENT",
    "dropmalst": "MD",
    "dropmalzpp": 215209998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3018952049,
    "dropsitcph": 3017468420,
    "dropfax": 3017468690
  },
  {
    "dcode": "D",
    "dropkey": "PV22878",
    "droptype": "D",
    "dropname": "ACCOKEEK",
    "dropdeladd": "16405 LIVINGSTON RD",
    "dropdelcty": "ACCOKEEK",
    "dropdelst": "MD",
    "dropdelzpp": 206079997,
    "dropphyadd": "16405 LIVINGSTON RD",
    "dropphycty": "ACCOKEEK",
    "dropphyst": "MD",
    "dropphyzpp": 206079997,
    "dropmaladd": "16405 LIVINGSTON RD",
    "dropmalcty": "ACCOKEEK",
    "dropmalst": "MD",
    "dropmalzpp": 206079997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012832861,
    "dropsitcph": 3012832861,
    "dropfax": 3012832094
  },
  {
    "dcode": "D",
    "dropkey": "PV22879",
    "droptype": "D",
    "dropname": "ADAMSTOWN",
    "dropdeladd": "5537 MOUNTVILLE RD",
    "dropdelcty": "ADAMSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217109998,
    "dropphyadd": "5537 MOUNTVILLE RD",
    "dropphycty": "ADAMSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217109998,
    "dropmaladd": "5537 MOUNTVILLE RD",
    "dropmalcty": "ADAMSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217109998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018745429,
    "dropsitcph": 3018745429,
    "dropfax": 3018746030
  },
  {
    "dcode": "D",
    "dropkey": "PV22886",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "3519 ALLEN RD",
    "dropdelcty": "ALLEN",
    "dropdelst": "MD",
    "dropdelzpp": 218109998,
    "dropphyadd": "3519 ALLEN RD",
    "dropphycty": "ALLEN",
    "dropphyst": "MD",
    "dropphyzpp": 218109998,
    "dropmaladd": "3519 ALLEN RD",
    "dropmalcty": "ALLEN",
    "dropmalst": "MD",
    "dropmalzpp": 218109998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107423981,
    "dropsitcph": 4107423981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22891",
    "droptype": "D",
    "dropname": "ANNAPOLIS",
    "dropdeladd": "60 WEST ST STE 101",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MD",
    "dropdelzpp": 214019998,
    "dropphyadd": "60 WEST ST STE 101",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MD",
    "dropphyzpp": 214019998,
    "dropmaladd": "60 WEST ST STE 101",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MD",
    "dropmalzpp": 214019998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105736537,
    "dropsitcph": 4105736537,
    "dropfax": 4106261217
  },
  {
    "dcode": "D",
    "dropkey": "PV22893",
    "droptype": "D",
    "dropname": "ANNAPOLIS JUNCTION",
    "dropdeladd": "10820 GUILFORD RD STE 212",
    "dropdelcty": "ANNAPOLIS JUNCTION",
    "dropdelst": "MD",
    "dropdelzpp": 207019998,
    "dropphyadd": "10820 GUILFORD RD STE 212",
    "dropphycty": "ANNAPOLIS JUNCTION",
    "dropphyst": "MD",
    "dropphyzpp": 207019998,
    "dropmaladd": "10820 GUILFORD RD STE 212",
    "dropmalcty": "ANNAPOLIS JUNCTION",
    "dropmalst": "MD",
    "dropmalzpp": 207019998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017252512,
    "dropsitcph": 3017252512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22899",
    "droptype": "D",
    "dropname": "AQUASCO",
    "dropdeladd": "22503 AQUASCO RD",
    "dropdelcty": "AQUASCO",
    "dropdelst": "MD",
    "dropdelzpp": 206089998,
    "dropphyadd": "22503 AQUASCO RD",
    "dropphycty": "AQUASCO",
    "dropphyst": "MD",
    "dropphyzpp": 206089998,
    "dropmaladd": "22503 AQUASCO RD",
    "dropmalcty": "AQUASCO",
    "dropmalst": "MD",
    "dropmalzpp": 206089998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015792273,
    "dropsitcph": 3015792273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22907",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "1521 RITCHIE HWY STE 100",
    "dropdelcty": "ARNOLD",
    "dropdelst": "MD",
    "dropdelzpp": 210122708,
    "dropphyadd": "1521 RITCHIE HWY STE 100",
    "dropphycty": "ARNOLD",
    "dropphyst": "MD",
    "dropphyzpp": 210122708,
    "dropmaladd": "1521 RITCHIE HWY STE 100",
    "dropmalcty": "ARNOLD",
    "dropmalst": "MD",
    "dropmalzpp": 210122708,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107578802,
    "dropsitcph": 4107578802,
    "dropfax": 4107579008
  },
  {
    "dcode": "D",
    "dropkey": "PV22915",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "19 OLNEY SANDY SPRING RD",
    "dropdelcty": "ASHTON",
    "dropdelst": "MD",
    "dropdelzpp": 208619998,
    "dropphyadd": "19 OLNEY SANDY SPRING RD",
    "dropphycty": "ASHTON",
    "dropphyst": "MD",
    "dropphyzpp": 208619998,
    "dropmaladd": "19 OLNEY SANDY SPRING RD",
    "dropmalcty": "ASHTON",
    "dropmalst": "MD",
    "dropmalzpp": 208619998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017740100,
    "dropsitcph": 3017740100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22921",
    "droptype": "D",
    "dropname": "AVENUE",
    "dropdeladd": "21535 COLTON POINT RD",
    "dropdelcty": "AVENUE",
    "dropdelst": "MD",
    "dropdelzpp": 206099998,
    "dropphyadd": "21535 COLTON POINT RD",
    "dropphycty": "AVENUE",
    "dropphyst": "MD",
    "dropphyzpp": 206099998,
    "dropmaladd": "21535 COLTON POINT RD",
    "dropmalcty": "AVENUE",
    "dropmalst": "MD",
    "dropmalzpp": 206099998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017692263,
    "dropsitcph": 3017692263,
    "dropfax": 3017693453
  },
  {
    "dcode": "D",
    "dropkey": "PV22927",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "13516 LONG GREEN PIKE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "MD",
    "dropdelzpp": 210139998,
    "dropphyadd": "13516 LONG GREEN PIKE",
    "dropphycty": "BALDWIN",
    "dropphyst": "MD",
    "dropphyzpp": 210139998,
    "dropmaladd": "13516 LONG GREEN PIKE",
    "dropmalcty": "BALDWIN",
    "dropmalst": "MD",
    "dropmalzpp": 210139998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105927538,
    "dropsitcph": 4105927538,
    "dropfax": 4105928478
  },
  {
    "dcode": "D",
    "dropkey": "PV22932",
    "droptype": "D",
    "dropname": "BALTIMORE",
    "dropdeladd": "900 E FAYETTE ST RM 118",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212339715,
    "dropphyadd": "900 E FAYETTE ST RM 118",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212339715,
    "dropmaladd": "900 E FAYETTE ST RM 118",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212339715,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474260,
    "dropsitcph": 4103474202,
    "dropfax": 4102348602
  },
  {
    "dcode": "D",
    "dropkey": "PV22935",
    "droptype": "D",
    "dropname": "BARCLAY",
    "dropdeladd": "1325 GOLDSBORO RD",
    "dropdelcty": "BARCLAY",
    "dropdelst": "MD",
    "dropdelzpp": 216079998,
    "dropphyadd": "1325 GOLDSBORO RD",
    "dropphycty": "BARCLAY",
    "dropphyst": "MD",
    "dropphyzpp": 216079998,
    "dropmaladd": "1325 GOLDSBORO RD",
    "dropmalcty": "BARCLAY",
    "dropmalst": "MD",
    "dropmalzpp": 216079998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104383565,
    "dropsitcph": 4104383565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22939",
    "droptype": "D",
    "dropname": "BARNESVILLE",
    "dropdeladd": "22110 BEALLSVILLE RD",
    "dropdelcty": "BARNESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208389998,
    "dropphyadd": "22110 BEALLSVILLE RD",
    "dropphycty": "BARNESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208389998,
    "dropmaladd": "22110 BEALLSVILLE RD",
    "dropmalcty": "BARNESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208389998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019728153,
    "dropsitcph": 3019728153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22942",
    "droptype": "D",
    "dropname": "BARSTOW",
    "dropdeladd": "2485 HALLOWING POINT RD",
    "dropdelcty": "BARSTOW",
    "dropdelst": "MD",
    "dropdelzpp": 206109998,
    "dropphyadd": "2485 HALLOWING POINT RD",
    "dropphycty": "BARSTOW",
    "dropphyst": "MD",
    "dropphyzpp": 206109998,
    "dropmaladd": "2485 HALLOWING POINT RD",
    "dropmalcty": "BARSTOW",
    "dropmalst": "MD",
    "dropmalzpp": 206109998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4105351479,
    "dropsitcph": 4105351479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22945",
    "droptype": "D",
    "dropname": "BARTON",
    "dropdeladd": "19112 S RAILROAD ST SW",
    "dropdelcty": "BARTON",
    "dropdelst": "MD",
    "dropdelzpp": 215219998,
    "dropphyadd": "19112 S RAILROAD ST SW",
    "dropphycty": "BARTON",
    "dropphyst": "MD",
    "dropphyzpp": 215219998,
    "dropmaladd": "19112 S RAILROAD ST SW",
    "dropmalcty": "BARTON",
    "dropmalst": "MD",
    "dropmalzpp": 215219998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3014635759,
    "dropsitcph": 3014635759,
    "dropfax": 3014632783
  },
  {
    "dcode": "D",
    "dropkey": "PV22956",
    "droptype": "D",
    "dropname": "BEL AIR",
    "dropdeladd": "202 BLUM CT",
    "dropdelcty": "BEL AIR",
    "dropdelst": "MD",
    "dropdelzpp": 210144318,
    "dropphyadd": "202 BLUM CT",
    "dropphycty": "BEL AIR",
    "dropphyst": "MD",
    "dropphyzpp": 210144318,
    "dropmaladd": "202 BLUM CT",
    "dropmalcty": "BEL AIR",
    "dropmalst": "MD",
    "dropmalzpp": 210144318,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104207544,
    "dropsitcph": 4104207544,
    "dropfax": 4108794796
  },
  {
    "dcode": "D",
    "dropkey": "PV22958",
    "droptype": "D",
    "dropname": "BEL ALTON",
    "dropdeladd": "9695 BEL ALTON NEWTOWN RD",
    "dropdelcty": "BEL ALTON",
    "dropdelst": "MD",
    "dropdelzpp": 206119998,
    "dropphyadd": "9695 BEL ALTON NEWTOWN RD",
    "dropphycty": "BEL ALTON",
    "dropphyst": "MD",
    "dropphyzpp": 206119998,
    "dropmaladd": "9695 BEL ALTON NEWTOWN RD",
    "dropmalcty": "BEL ALTON",
    "dropmalst": "MD",
    "dropmalzpp": 206119998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019342678,
    "dropsitcph": 3019342678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22959",
    "droptype": "D",
    "dropname": "BELCAMP",
    "dropdeladd": "1321 RIVERSIDE PKWY STE E3",
    "dropdelcty": "BELCAMP",
    "dropdelst": "MD",
    "dropdelzpp": 210179902,
    "dropphyadd": "1321 RIVERSIDE PKWY STE E3",
    "dropphycty": "BELCAMP",
    "dropphyst": "MD",
    "dropphyzpp": 210179902,
    "dropmaladd": "1321 RIVERSIDE PKWY STE E3",
    "dropmalcty": "BELCAMP",
    "dropmalst": "MD",
    "dropmalzpp": 210179902,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102723525,
    "dropsitcph": 4102723525,
    "dropfax": 4102727926
  },
  {
    "dcode": "D",
    "dropkey": "PV22964",
    "droptype": "D",
    "dropname": "BELTSVILLE",
    "dropdeladd": "10901 RHODE ISLAND AVE",
    "dropdelcty": "BELTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207052518,
    "dropphyadd": "10901 RHODE ISLAND AVE",
    "dropphycty": "BELTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207052518,
    "dropmaladd": "10901 RHODE ISLAND AVE",
    "dropmalcty": "BELTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207052518,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019310417,
    "dropsitcph": 3019310417,
    "dropfax": 3019374056
  },
  {
    "dcode": "D",
    "dropkey": "PV22968",
    "droptype": "D",
    "dropname": "BENEDICT",
    "dropdeladd": "7240 BENEDICT AVE",
    "dropdelcty": "BENEDICT",
    "dropdelst": "MD",
    "dropdelzpp": 206129998,
    "dropphyadd": "7240 BENEDICT AVE",
    "dropphycty": "BENEDICT",
    "dropphyst": "MD",
    "dropphyzpp": 206129998,
    "dropmaladd": "7240 BENEDICT AVE",
    "dropmalcty": "BENEDICT",
    "dropmalst": "MD",
    "dropmalzpp": 206129998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012743337,
    "dropsitcph": 3012743337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22971",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "108 CONNOLLY RD",
    "dropdelcty": "BENSON",
    "dropdelst": "MD",
    "dropdelzpp": 210189998,
    "dropphyadd": "108 CONNOLLY RD",
    "dropphycty": "BENSON",
    "dropphyst": "MD",
    "dropphyzpp": 210189998,
    "dropmaladd": "108 CONNOLLY RD",
    "dropmalcty": "BENSON",
    "dropmalst": "MD",
    "dropmalzpp": 210189998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108778325,
    "dropsitcph": 4108778325,
    "dropfax": 4108778325
  },
  {
    "dcode": "D",
    "dropkey": "PV22974",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "20 BROAD ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "MD",
    "dropdelzpp": 218119998,
    "dropphyadd": "20 BROAD ST",
    "dropphycty": "BERLIN",
    "dropphyst": "MD",
    "dropphyzpp": 218119998,
    "dropmaladd": "20 BROAD ST",
    "dropmalcty": "BERLIN",
    "dropmalst": "MD",
    "dropmalzpp": 218119998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102083959,
    "dropsitcph": 4102083959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22983",
    "droptype": "D",
    "dropname": "BETHESDA",
    "dropdeladd": "6900 WISCONSIN AVE STE 100",
    "dropdelcty": "CHEVY CHASE",
    "dropdelst": "MD",
    "dropdelzpp": 208159996,
    "dropphyadd": "6900 WISCONSIN AVE STE 100",
    "dropphycty": "CHEVY CHASE",
    "dropphyst": "MD",
    "dropphyzpp": 208159996,
    "dropmaladd": "6900 WISCONSIN AVE STE 100",
    "dropmalcty": "CHEVY CHASE",
    "dropmalst": "MD",
    "dropmalzpp": 208159996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019412670,
    "dropsitcph": 3019412670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22986",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "22015 DOVER BRIDGE RD",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "MD",
    "dropdelzpp": 216099998,
    "dropphyadd": "22015 DOVER BRIDGE RD",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "MD",
    "dropphyzpp": 216099998,
    "dropmaladd": "22015 DOVER BRIDGE RD",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "MD",
    "dropmalzpp": 216099998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106737024,
    "dropsitcph": 4106737024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22987",
    "droptype": "D",
    "dropname": "BETTERTON",
    "dropdeladd": "3 3RD AVE",
    "dropdelcty": "BETTERTON",
    "dropdelst": "MD",
    "dropdelzpp": 216109998,
    "dropphyadd": "3 3RD AVE",
    "dropphycty": "BETTERTON",
    "dropphyst": "MD",
    "dropphyzpp": 216109998,
    "dropmaladd": "3 3RD AVE",
    "dropmalcty": "BETTERTON",
    "dropmalst": "MD",
    "dropmalzpp": 216109998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103485153,
    "dropsitcph": 4103485153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22990",
    "droptype": "D",
    "dropname": "BIG POOL",
    "dropdeladd": "11304 HOMESTEAD DR",
    "dropdelcty": "BIG POOL",
    "dropdelst": "MD",
    "dropdelzpp": 217119998,
    "dropphyadd": "11304 HOMESTEAD DR",
    "dropphycty": "BIG POOL",
    "dropphyst": "MD",
    "dropphyzpp": 217119998,
    "dropmaladd": "11304 HOMESTEAD DR",
    "dropmalcty": "BIG POOL",
    "dropmalst": "MD",
    "dropmalzpp": 217119998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3018423278,
    "dropsitcph": 3018423278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22994",
    "droptype": "D",
    "dropname": "BISHOPVILLE",
    "dropdeladd": "10656 BISHOPVILLE RD",
    "dropdelcty": "BISHOPVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 218139998,
    "dropphyadd": "10656 BISHOPVILLE RD",
    "dropphycty": "BISHOPVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 218139998,
    "dropmaladd": "10656 BISHOPVILLE RD",
    "dropmalcty": "BISHOPVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 218139998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103525733,
    "dropsitcph": 4103525733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22995",
    "droptype": "D",
    "dropname": "BITTINGER",
    "dropdeladd": "60 MAYNARDIER RIDGE RD",
    "dropdelcty": "BITTINGER",
    "dropdelst": "MD",
    "dropdelzpp": 215221102,
    "dropphyadd": "60 MAYNARDIER RIDGE RD",
    "dropphycty": "BITTINGER",
    "dropphyst": "MD",
    "dropphyzpp": 215221102,
    "dropmaladd": "60 MAYNARDIER RIDGE RD",
    "dropmalcty": "BITTINGER",
    "dropmalst": "MD",
    "dropmalzpp": 215221102,
    "dropsitphn": 3017228194,
    "dropsitlph": 4102454460,
    "dropsitcph": 3012454014,
    "dropfax": 3012474719
  },
  {
    "dcode": "D",
    "dropkey": "PV22996",
    "droptype": "D",
    "dropname": "BIVALVE",
    "dropdeladd": "20972 NANTICOKE RD",
    "dropdelcty": "BIVALVE",
    "dropdelst": "MD",
    "dropdelzpp": 218149998,
    "dropphyadd": "20972 NANTICOKE RD",
    "dropphycty": "BIVALVE",
    "dropphyst": "MD",
    "dropphyzpp": 218149998,
    "dropmaladd": "20972 NANTICOKE RD",
    "dropmalcty": "BIVALVE",
    "dropmalst": "MD",
    "dropmalzpp": 218149998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108732967,
    "dropsitcph": 4108732967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV22998",
    "droptype": "D",
    "dropname": "BLADENSBURG",
    "dropdeladd": "4921 TILDEN RD",
    "dropdelcty": "BLADENSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 207109998,
    "dropphyadd": "4921 TILDEN RD",
    "dropphycty": "BLADENSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 207109998,
    "dropmaladd": "4921 TILDEN RD",
    "dropmalcty": "BLADENSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 207109998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018645985,
    "dropsitcph": 3018645985,
    "dropfax": 3019276270
  },
  {
    "dcode": "D",
    "dropkey": "PV23002",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "35 N HAMILL AVE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 215239998,
    "dropphyadd": "35 N HAMILL AVE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 215239998,
    "dropmaladd": "35 N HAMILL AVE",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 215239998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013590044,
    "dropsitcph": 3013590444,
    "dropfax": 3013590444
  },
  {
    "dcode": "D",
    "dropkey": "PV23009",
    "droptype": "D",
    "dropname": "BOONSBORO",
    "dropdeladd": "6822 OSTERTAG PASS",
    "dropdelcty": "BOONSBORO",
    "dropdelst": "MD",
    "dropdelzpp": 217132099,
    "dropphyadd": "6822 OSTERTAG PASS",
    "dropphycty": "BOONSBORO",
    "dropphyst": "MD",
    "dropphyzpp": 217132099,
    "dropmaladd": "6822 OSTERTAG PASS",
    "dropmalcty": "BOONSBORO",
    "dropmalst": "MD",
    "dropmalzpp": 217132099,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014326861,
    "dropsitcph": 3014326861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23012",
    "droptype": "D",
    "dropname": "BORING",
    "dropdeladd": "14707 OLD HANOVER RD",
    "dropdelcty": "BORING",
    "dropdelst": "MD",
    "dropdelzpp": 210209998,
    "dropphyadd": "14707 OLD HANOVER RD",
    "dropphycty": "BORING",
    "dropphyst": "MD",
    "dropphyzpp": 210209998,
    "dropmaladd": "14707 OLD HANOVER RD",
    "dropmalcty": "BORING",
    "dropmalst": "MD",
    "dropmalzpp": 210209998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104294474,
    "dropsitcph": 4104294474,
    "dropfax": 4104295407
  },
  {
    "dcode": "D",
    "dropkey": "PV23013",
    "droptype": "D",
    "dropname": "BOWIE",
    "dropdeladd": "6710 LAUREL BOWIE RD",
    "dropdelcty": "BOWIE",
    "dropdelst": "MD",
    "dropdelzpp": 207159997,
    "dropphyadd": "6710 LAUREL BOWIE RD",
    "dropphycty": "BOWIE",
    "dropphyst": "MD",
    "dropphyzpp": 207159997,
    "dropmaladd": "6710 LAUREL BOWIE RD",
    "dropmalcty": "BOWIE",
    "dropmalst": "MD",
    "dropmalzpp": 207159997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018600847,
    "dropsitcph": 3018600847,
    "dropfax": 3014640917
  },
  {
    "dcode": "D",
    "dropkey": "PV23017",
    "droptype": "D",
    "dropname": "BOYDS",
    "dropdeladd": "15300 BARNESVILLE RD",
    "dropdelcty": "BOYDS",
    "dropdelst": "MD",
    "dropdelzpp": 208419998,
    "dropphyadd": "15300 BARNESVILLE RD",
    "dropphycty": "BOYDS",
    "dropphyst": "MD",
    "dropphyzpp": 208419998,
    "dropmaladd": "15300 BARNESVILLE RD",
    "dropmalcty": "BOYDS",
    "dropmalst": "MD",
    "dropmalzpp": 208419998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019729527,
    "dropsitcph": 3019729527,
    "dropfax": 3019720039
  },
  {
    "dcode": "D",
    "dropkey": "PV23019",
    "droptype": "D",
    "dropname": "BOZMAN",
    "dropdeladd": "7983 QUAKER NECK RD",
    "dropdelcty": "BOZMAN",
    "dropdelst": "MD",
    "dropdelzpp": 216129998,
    "dropphyadd": "7983 QUAKER NECK RD",
    "dropphycty": "BOZMAN",
    "dropphyst": "MD",
    "dropphyzpp": 216129998,
    "dropmaladd": "7983 QUAKER NECK RD",
    "dropmalcty": "BOZMAN",
    "dropmalst": "MD",
    "dropmalzpp": 216129998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107452009,
    "dropsitcph": 4107452009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23020",
    "droptype": "D",
    "dropname": "BRADDOCK HEIGHTS",
    "dropdeladd": "4707 SCHLEY AVE STE A",
    "dropdelcty": "BRADDOCK HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 217149998,
    "dropphyadd": "4707 SCHLEY AVE STE A",
    "dropphycty": "BRADDOCK HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 217149998,
    "dropmaladd": "4707 SCHLEY AVE STE A",
    "dropmalcty": "BRADDOCK HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 217149998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3013715998,
    "dropsitcph": 3013715998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23024",
    "droptype": "D",
    "dropname": "BRANDYWINE",
    "dropdeladd": "14109 BRANDYWINE RD",
    "dropdelcty": "BRANDYWINE",
    "dropdelst": "MD",
    "dropdelzpp": 206139998,
    "dropphyadd": "14109 BRANDYWINE RD",
    "dropphycty": "BRANDYWINE",
    "dropphyst": "MD",
    "dropphyzpp": 206139998,
    "dropmaladd": "14109 BRANDYWINE RD",
    "dropmalcty": "BRANDYWINE",
    "dropmalst": "MD",
    "dropmalzpp": 206139998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017827930,
    "dropsitcph": 3017827930,
    "dropfax": 3017824402
  },
  {
    "dcode": "D",
    "dropkey": "PV23028",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "4314 41ST ST",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 207229998,
    "dropphyadd": "4314 41ST ST",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 207229998,
    "dropmaladd": "4314 41ST ST",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 207229998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017792952,
    "dropsitcph": 3017798966,
    "dropfax": 3017793964
  },
  {
    "dcode": "D",
    "dropkey": "PV23039",
    "droptype": "D",
    "dropname": "BROOKEVILLE",
    "dropdeladd": "22311 GEORGIA AVE",
    "dropdelcty": "BROOKEVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208339998,
    "dropphyadd": "22311 GEORGIA AVE",
    "dropphycty": "BROOKEVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208339998,
    "dropmaladd": "22311 GEORGIA AVE",
    "dropmalcty": "BROOKEVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208339998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012602975,
    "dropsitcph": 3012602975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23042",
    "droptype": "D",
    "dropname": "BROOKLANDVILLE",
    "dropdeladd": "10807 FALLS RD",
    "dropdelcty": "BROOKLANDVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210221406,
    "dropphyadd": "10807 FALLS RD",
    "dropphycty": "BROOKLANDVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210221406,
    "dropmaladd": "10807 FALLS RD",
    "dropmalcty": "BROOKLANDVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210221406,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103210593,
    "dropsitcph": 4103210593,
    "dropfax": 4103210702
  },
  {
    "dcode": "D",
    "dropkey": "PV23050",
    "droptype": "D",
    "dropname": "BROOMES ISLAND",
    "dropdeladd": "8320 BROOMES ISLAND RD",
    "dropdelcty": "BROOMES ISLAND",
    "dropdelst": "MD",
    "dropdelzpp": 206159998,
    "dropphyadd": "8320 BROOMES ISLAND RD",
    "dropphycty": "BROOMES ISLAND",
    "dropphyst": "MD",
    "dropphyzpp": 206159998,
    "dropmaladd": "8320 BROOMES ISLAND RD",
    "dropmalcty": "BROOMES ISLAND",
    "dropmalst": "MD",
    "dropmalzpp": 206159998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4105861728,
    "dropsitcph": 4105861728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23052",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "315 BRUNSWICK ST",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "MD",
    "dropdelzpp": 217169998,
    "dropphyadd": "315 BRUNSWICK ST",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "MD",
    "dropphyzpp": 217169998,
    "dropmaladd": "315 BRUNSWICK ST",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "MD",
    "dropmalzpp": 217169998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3108349944,
    "dropsitcph": 3018349944,
    "dropfax": 3018346079
  },
  {
    "dcode": "D",
    "dropkey": "PV23054",
    "droptype": "D",
    "dropname": "BRYANS ROAD",
    "dropdeladd": "6960 INDIAN HEAD HWY",
    "dropdelcty": "BRYANS ROAD",
    "dropdelst": "MD",
    "dropdelzpp": 206169997,
    "dropphyadd": "6960 INDIAN HEAD HWY",
    "dropphycty": "BRYANS ROAD",
    "dropphyst": "MD",
    "dropphyzpp": 206169997,
    "dropmaladd": "6960 INDIAN HEAD HWY",
    "dropmalcty": "BRYANS ROAD",
    "dropmalst": "MD",
    "dropmalzpp": 206169997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014856626,
    "dropsitcph": 3014856626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23056",
    "droptype": "D",
    "dropname": "BRYANTOWN",
    "dropdeladd": "6425 LEONARDTOWN RD",
    "dropdelcty": "BRYANTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 206179998,
    "dropphyadd": "6425 LEONARDTOWN RD",
    "dropphycty": "BRYANTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 206179998,
    "dropmaladd": "6425 LEONARDTOWN RD",
    "dropmalcty": "BRYANTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 206179998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012743731,
    "dropsitcph": 3012743731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23058",
    "droptype": "D",
    "dropname": "BUCKEYSTOWN",
    "dropdeladd": "4001 BUCKEYSTOWN PIKE",
    "dropdelcty": "BUCKEYSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217179998,
    "dropphyadd": "4001 BUCKEYSTOWN PIKE",
    "dropphycty": "BUCKEYSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217179998,
    "dropmaladd": "4001 BUCKEYSTOWN PIKE",
    "dropmalcty": "BUCKEYSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217179998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3108745294,
    "dropsitcph": 3018745294,
    "dropfax": 3018742701
  },
  {
    "dcode": "D",
    "dropkey": "PV23060",
    "droptype": "D",
    "dropname": "BURKITTSVILLE",
    "dropdeladd": "8 E MAIN ST",
    "dropdelcty": "BURKITTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217189998,
    "dropphyadd": "8 E MAIN ST",
    "dropphycty": "BURKITTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217189998,
    "dropmaladd": "8 E MAIN ST",
    "dropmalcty": "BURKITTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217189998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018349592,
    "dropsitcph": 3018349592,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23063",
    "droptype": "D",
    "dropname": "BURTONSVILLE",
    "dropdeladd": "15210 DINO DR",
    "dropdelcty": "BURTONSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208669998,
    "dropphyadd": "15210 DINO DR",
    "dropphycty": "BURTONSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208669998,
    "dropmaladd": "15210 DINO DR",
    "dropmalcty": "BURTONSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208669998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014769371,
    "dropsitcph": 3014769371,
    "dropfax": 3014211404
  },
  {
    "dcode": "D",
    "dropkey": "PV23067",
    "droptype": "D",
    "dropname": "BUSHWOOD",
    "dropdeladd": "22840 BUSHWOOD RD",
    "dropdelcty": "BUSHWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 206189998,
    "dropphyadd": "22840 BUSHWOOD RD",
    "dropphycty": "BUSHWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 206189998,
    "dropmaladd": "22840 BUSHWOOD RD",
    "dropmalcty": "BUSHWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 206189998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017692264,
    "dropsitcph": 3017692264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23068",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "14921 FALLS RD",
    "dropdelcty": "BUTLER",
    "dropdelst": "MD",
    "dropdelzpp": 210239998,
    "dropphyadd": "14921 FALLS RD",
    "dropphycty": "BUTLER",
    "dropphyst": "MD",
    "dropphyzpp": 210239998,
    "dropmaladd": "14921 FALLS RD",
    "dropmalcty": "BUTLER",
    "dropmalst": "MD",
    "dropmalzpp": 210239998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104720310,
    "dropsitcph": 4104720310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23073",
    "droptype": "D",
    "dropname": "CABIN JOHN",
    "dropdeladd": "7945 MACARTHUR BLVD STE 101",
    "dropdelcty": "CABIN JOHN",
    "dropdelst": "MD",
    "dropdelzpp": 208189998,
    "dropphyadd": "7945 MACARTHUR BLVD STE 101",
    "dropphycty": "CABIN JOHN",
    "dropphyst": "MD",
    "dropphyzpp": 208189998,
    "dropmaladd": "7945 MACARTHUR BLVD STE 101",
    "dropmalcty": "CABIN JOHN",
    "dropmalst": "MD",
    "dropmalzpp": 208189998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012296977,
    "dropsitcph": 3012296977,
    "dropfax": 3013206803
  },
  {
    "dcode": "D",
    "dropkey": "PV23076",
    "droptype": "D",
    "dropname": "CALIFORNIA",
    "dropdeladd": "22576 MACARTHUR BLVD STE 330",
    "dropdelcty": "CALIFORNIA",
    "dropdelst": "MD",
    "dropdelzpp": 206199997,
    "dropphyadd": "22576 MACARTHUR BLVD STE 330",
    "dropphycty": "CALIFORNIA",
    "dropphyst": "MD",
    "dropphyzpp": 206199997,
    "dropmaladd": "22576 MACARTHUR BLVD STE 330",
    "dropmalcty": "CALIFORNIA",
    "dropmalst": "MD",
    "dropmalzpp": 206199997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018639506,
    "dropsitcph": 3018639506,
    "dropfax": 3018636940
  },
  {
    "dcode": "D",
    "dropkey": "PV23077",
    "droptype": "D",
    "dropname": "CALLAWAY",
    "dropdeladd": "20293 PINEY POINT RD",
    "dropdelcty": "CALLAWAY",
    "dropdelst": "MD",
    "dropdelzpp": 206209998,
    "dropphyadd": "20293 PINEY POINT RD",
    "dropphycty": "CALLAWAY",
    "dropphyst": "MD",
    "dropphyzpp": 206209998,
    "dropmaladd": "20293 PINEY POINT RD",
    "dropmalcty": "CALLAWAY",
    "dropmalst": "MD",
    "dropmalzpp": 206209998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019941183,
    "dropsitcph": 3019941183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23081",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "301 HIGH ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MD",
    "dropdelzpp": 216139998,
    "dropphyadd": "301 HIGH ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MD",
    "dropphyzpp": 216139998,
    "dropmaladd": "301 HIGH ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MD",
    "dropmalzpp": 216139998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102281484,
    "dropsitcph": 4102281484,
    "dropfax": 4109011303
  },
  {
    "dcode": "D",
    "dropkey": "PV23114",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "25208 MILITARY RD",
    "dropdelcty": "CASCADE",
    "dropdelst": "MD",
    "dropdelzpp": 217199998,
    "dropphyadd": "25208 MILITARY RD",
    "dropphycty": "CASCADE",
    "dropphyst": "MD",
    "dropphyzpp": 217199998,
    "dropmaladd": "25208 MILITARY RD",
    "dropmalcty": "CASCADE",
    "dropmalst": "MD",
    "dropmalzpp": 217199998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3012413403,
    "dropsitcph": 3012413403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23123",
    "droptype": "D",
    "dropname": "CAVETOWN",
    "dropdeladd": "22509 CAVETOWN CHURCH RD",
    "dropdelcty": "CAVETOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217209998,
    "dropphyadd": "22509 CAVETOWN CHURCH RD",
    "dropphycty": "CAVETOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217209998,
    "dropmaladd": "22509 CAVETOWN CHURCH RD",
    "dropmalcty": "CAVETOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217209998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018245230,
    "dropsitcph": 3018245230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23125",
    "droptype": "D",
    "dropname": "CECILTON",
    "dropdeladd": "127 W MAIN ST",
    "dropdelcty": "CECILTON",
    "dropdelst": "MD",
    "dropdelzpp": 219131004,
    "dropphyadd": "127 W MAIN ST",
    "dropphycty": "CECILTON",
    "dropphyst": "MD",
    "dropphyzpp": 219131004,
    "dropmaladd": "127 W MAIN ST",
    "dropmalcty": "CECILTON",
    "dropmalst": "MD",
    "dropmalzpp": 219131004,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102758417,
    "dropsitcph": 4102758417,
    "dropfax": 4102758417
  },
  {
    "dcode": "D",
    "dropkey": "PV23131",
    "droptype": "D",
    "dropname": "CENTREVILLE",
    "dropdeladd": "202 E WATER ST",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216179998,
    "dropphyadd": "202 E WATER ST",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216179998,
    "dropmaladd": "202 E WATER ST",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216179998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107580640,
    "dropsitcph": 4107580640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23136",
    "droptype": "D",
    "dropname": "CHAPTICO",
    "dropdeladd": "25749 BUDDS CREEK RD",
    "dropdelcty": "CHAPTICO",
    "dropdelst": "MD",
    "dropdelzpp": 206219998,
    "dropphyadd": "25749 BUDDS CREEK RD",
    "dropphycty": "CHAPTICO",
    "dropphyst": "MD",
    "dropphyzpp": 206219998,
    "dropmaladd": "25749 BUDDS CREEK RD",
    "dropmalcty": "CHAPTICO",
    "dropmalst": "MD",
    "dropmalzpp": 206219998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018844334,
    "dropsitcph": 3018844334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23139",
    "droptype": "D",
    "dropname": "CHARLESTOWN",
    "dropdeladd": "241 MARKET ST",
    "dropdelcty": "CHARLESTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 219149998,
    "dropphyadd": "241 MARKET ST",
    "dropphycty": "CHARLESTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 219149998,
    "dropmaladd": "241 MARKET ST",
    "dropmalcty": "CHARLESTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 219149998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102872560,
    "dropsitcph": 4102872560,
    "dropfax": 4102872560
  },
  {
    "dcode": "D",
    "dropkey": "PV23142",
    "droptype": "D",
    "dropname": "CHARLOTTE HALL",
    "dropdeladd": "29948 THREE NOTCH RD",
    "dropdelcty": "CHARLOTTE HALL",
    "dropdelst": "MD",
    "dropdelzpp": 206229998,
    "dropphyadd": "29948 THREE NOTCH RD",
    "dropphycty": "CHARLOTTE HALL",
    "dropphyst": "MD",
    "dropphyzpp": 206229998,
    "dropmaladd": "29948 THREE NOTCH RD",
    "dropmalcty": "CHARLOTTE HALL",
    "dropmalst": "MD",
    "dropmalzpp": 206229998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018843050,
    "dropsitcph": 3018843050,
    "dropfax": 3012901337
  },
  {
    "dcode": "D",
    "dropkey": "PV23147",
    "droptype": "D",
    "dropname": "CHASE",
    "dropdeladd": "12404 EASTERN AVE",
    "dropdelcty": "CHASE",
    "dropdelst": "MD",
    "dropdelzpp": 210279998,
    "dropphyadd": "12404 EASTERN AVE",
    "dropphycty": "CHASE",
    "dropphyst": "MD",
    "dropphyzpp": 210279998,
    "dropmaladd": "12404 EASTERN AVE",
    "dropmalcty": "CHASE",
    "dropmalst": "MD",
    "dropmalzpp": 210279998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103356283,
    "dropsitcph": 4103356283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23150",
    "droptype": "D",
    "dropname": "CHELTENHAM",
    "dropdeladd": "11505 CHERRY TREE CROSSING RD",
    "dropdelcty": "CHELTENHAM",
    "dropdelst": "MD",
    "dropdelzpp": 206239998,
    "dropphyadd": "11505 CHERRY TREE CROSSING RD",
    "dropphycty": "CHELTENHAM",
    "dropphyst": "MD",
    "dropphyzpp": 206239998,
    "dropmaladd": "11505 CHERRY TREE CROSSING RD",
    "dropmalcty": "CHELTENHAM",
    "dropmalst": "MD",
    "dropmalzpp": 206239998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017827853,
    "dropsitcph": 3017827853,
    "dropfax": 3013728844
  },
  {
    "dcode": "D",
    "dropkey": "PV23156",
    "droptype": "D",
    "dropname": "CHESAPEAKE BEACH",
    "dropdeladd": "7905 BAYSIDE RD",
    "dropdelcty": "CHESAPEAKE BEACH",
    "dropdelst": "MD",
    "dropdelzpp": 207329998,
    "dropphyadd": "7905 BAYSIDE RD",
    "dropphycty": "CHESAPEAKE BEACH",
    "dropphyst": "MD",
    "dropphyzpp": 207329998,
    "dropmaladd": "7905 BAYSIDE RD",
    "dropmalcty": "CHESAPEAKE BEACH",
    "dropmalst": "MD",
    "dropmalzpp": 207329998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4102576180,
    "dropsitcph": 4102576180,
    "dropfax": 3018550693
  },
  {
    "dcode": "D",
    "dropkey": "PV23157",
    "droptype": "D",
    "dropname": "CHESAPEAKE CITY",
    "dropdeladd": "2551 AUGUSTINE HERMAN HWY",
    "dropdelcty": "CHESAPEAKE CITY",
    "dropdelst": "MD",
    "dropdelzpp": 219159998,
    "dropphyadd": "2551 AUGUSTINE HERMAN HWY",
    "dropphycty": "CHESAPEAKE CITY",
    "dropphyst": "MD",
    "dropphyzpp": 219159998,
    "dropmaladd": "2551 AUGUSTINE HERMAN HWY",
    "dropmalcty": "CHESAPEAKE CITY",
    "dropmalst": "MD",
    "dropmalzpp": 219159998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108852110,
    "dropsitcph": 4108852110,
    "dropfax": 4108855738
  },
  {
    "dcode": "D",
    "dropkey": "PV23160",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "1575 POSTAL RD",
    "dropdelcty": "CHESTER",
    "dropdelst": "MD",
    "dropdelzpp": 216199998,
    "dropphyadd": "1575 POSTAL RD",
    "dropphycty": "CHESTER",
    "dropphyst": "MD",
    "dropphyzpp": 216199998,
    "dropmaladd": "1575 POSTAL RD",
    "dropmalcty": "CHESTER",
    "dropmalst": "MD",
    "dropmalzpp": 216199998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106436488,
    "dropsitcph": 4106436488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23162",
    "droptype": "D",
    "dropname": "CHESTERTOWN",
    "dropdeladd": "104 SPRING AVE",
    "dropdelcty": "CHESTERTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 216209998,
    "dropphyadd": "104 SPRING AVE",
    "dropphycty": "CHESTERTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 216209998,
    "dropmaladd": "104 SPRING AVE",
    "dropmalcty": "CHESTERTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 216209998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107780867,
    "dropsitcph": 4107780690,
    "dropfax": 4108100462
  },
  {
    "dcode": "D",
    "dropkey": "PV23171",
    "droptype": "D",
    "dropname": "CHEWSVILLE",
    "dropdeladd": "21106 TWIN SPRINGS DR",
    "dropdelcty": "CHEWSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217219998,
    "dropphyadd": "21106 TWIN SPRINGS DR",
    "dropphycty": "CHEWSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217219998,
    "dropmaladd": "21106 TWIN SPRINGS DR",
    "dropmalcty": "CHEWSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217219998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3017338690,
    "dropsitcph": 3017338690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23172",
    "droptype": "D",
    "dropname": "CHILDS",
    "dropdeladd": "1470 BLUE BALL RD",
    "dropdelcty": "CHILDS",
    "dropdelst": "MD",
    "dropdelzpp": 219169998,
    "dropphyadd": "1470 BLUE BALL RD",
    "dropphycty": "CHILDS",
    "dropphyst": "MD",
    "dropphyzpp": 219169998,
    "dropmaladd": "1470 BLUE BALL RD",
    "dropmalcty": "CHILDS",
    "dropmalst": "MD",
    "dropmalzpp": 219169998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103985648,
    "dropsitcph": 4103985648,
    "dropfax": 4103985648
  },
  {
    "dcode": "D",
    "dropkey": "PV23175",
    "droptype": "D",
    "dropname": "CHURCH CREEK",
    "dropdeladd": "4681 GOLDEN HILL RD",
    "dropdelcty": "CHURCH CREEK",
    "dropdelst": "MD",
    "dropdelzpp": 216229998,
    "dropphyadd": "4681 GOLDEN HILL RD",
    "dropphycty": "CHURCH CREEK",
    "dropphyst": "MD",
    "dropphyzpp": 216229998,
    "dropmaladd": "4681 GOLDEN HILL RD",
    "dropmalcty": "CHURCH CREEK",
    "dropmalst": "MD",
    "dropmalzpp": 216229998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102287253,
    "dropsitcph": 4102287253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23176",
    "droptype": "D",
    "dropname": "CHURCH HILL",
    "dropdeladd": "558 MAIN ST",
    "dropdelcty": "CHURCH HILL",
    "dropdelst": "MD",
    "dropdelzpp": 216239998,
    "dropphyadd": "558 MAIN ST",
    "dropphycty": "CHURCH HILL",
    "dropphyst": "MD",
    "dropphyzpp": 216239998,
    "dropmaladd": "558 MAIN ST",
    "dropmalcty": "CHURCH HILL",
    "dropmalst": "MD",
    "dropmalzpp": 216239998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4105566118,
    "dropsitcph": 4105566118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23177",
    "droptype": "D",
    "dropname": "CHURCHTON",
    "dropdeladd": "5537 DEALE CHURCHTON RD",
    "dropdelcty": "CHURCHTON",
    "dropdelst": "MD",
    "dropdelzpp": 207339998,
    "dropphyadd": "5537 DEALE CHURCHTON RD",
    "dropphycty": "CHURCHTON",
    "dropphyst": "MD",
    "dropphyzpp": 207339998,
    "dropmaladd": "5537 DEALE CHURCHTON RD",
    "dropmalcty": "CHURCHTON",
    "dropmalst": "MD",
    "dropmalzpp": 207339998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012619957,
    "dropsitcph": 3012619957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23178",
    "droptype": "D",
    "dropname": "CHURCHVILLE",
    "dropdeladd": "2931 CHURCHVILLE RD",
    "dropdelcty": "CHURCHVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210289998,
    "dropphyadd": "2931 CHURCHVILLE RD",
    "dropphycty": "CHURCHVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210289998,
    "dropmaladd": "2931 CHURCHVILLE RD",
    "dropmalcty": "CHURCHVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210289998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107349119,
    "dropsitcph": 4107349119,
    "dropfax": 4107349307
  },
  {
    "dcode": "D",
    "dropkey": "PV23185",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "22505 GATEWAY CENTER DR",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208719998,
    "dropphyadd": "22505 GATEWAY CENTER DR",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208719998,
    "dropmaladd": "22505 GATEWAY CENTER DR",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208719998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015283886,
    "dropsitcph": 3015400856,
    "dropfax": 3014281335
  },
  {
    "dcode": "D",
    "dropkey": "PV23187",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "12171 CLARKSVILLE PIKE",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210299904,
    "dropphyadd": "12171 CLARKSVILLE PIKE",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210299904,
    "dropmaladd": "12171 CLARKSVILLE PIKE",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210299904,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105350742,
    "dropsitcph": 4435350742,
    "dropfax": 4105310946
  },
  {
    "dcode": "D",
    "dropkey": "PV23190",
    "droptype": "D",
    "dropname": "CLEAR SPRING",
    "dropdeladd": "21 MULBERRY ST",
    "dropdelcty": "CLEAR SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 217229998,
    "dropphyadd": "21 MULBERRY ST",
    "dropphycty": "CLEAR SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 217229998,
    "dropmaladd": "21 MULBERRY ST",
    "dropmalcty": "CLEAR SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 217229998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018422381,
    "dropsitcph": 3018422381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23193",
    "droptype": "D",
    "dropname": "CLEMENTS",
    "dropdeladd": "24015 COLTON POINT RD",
    "dropdelcty": "CLEMENTS",
    "dropdelst": "MD",
    "dropdelzpp": 206249998,
    "dropphyadd": "24015 COLTON POINT RD",
    "dropphycty": "CLEMENTS",
    "dropphyst": "MD",
    "dropphyzpp": 206249998,
    "dropmaladd": "24015 COLTON POINT RD",
    "dropmalcty": "CLEMENTS",
    "dropmalst": "MD",
    "dropmalzpp": 206249998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017694548,
    "dropsitcph": 3017694548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23197",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "9134 PISCATAWAY RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "MD",
    "dropdelzpp": 207359997,
    "dropphyadd": "9134 PISCATAWAY RD",
    "dropphycty": "CLINTON",
    "dropphyst": "MD",
    "dropphyzpp": 207359997,
    "dropmaladd": "9134 PISCATAWAY RD",
    "dropmalcty": "CLINTON",
    "dropmalst": "MD",
    "dropmalzpp": 207359997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018681470,
    "dropsitcph": 3018685397,
    "dropfax": 3018689772
  },
  {
    "dcode": "D",
    "dropkey": "PV23207",
    "droptype": "D",
    "dropname": "COBB ISLAND",
    "dropdeladd": "17009 COBB ISLAND RD",
    "dropdelcty": "COBB ISLAND",
    "dropdelst": "MD",
    "dropdelzpp": 206259998,
    "dropphyadd": "17009 COBB ISLAND RD",
    "dropphycty": "COBB ISLAND",
    "dropphyst": "MD",
    "dropphyzpp": 206259998,
    "dropmaladd": "17009 COBB ISLAND RD",
    "dropmalcty": "COBB ISLAND",
    "dropmalst": "MD",
    "dropmalzpp": 206259998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012594159,
    "dropsitcph": 3012594159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23210",
    "droptype": "D",
    "dropname": "COCKEYSVILLE HUNT VALLEY",
    "dropdeladd": "115 WIGHT AVE",
    "dropdelcty": "COCKEYSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210309998,
    "dropphyadd": "115 WIGHT AVE",
    "dropphycty": "COCKEYSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210309998,
    "dropmaladd": "115 WIGHT AVE",
    "dropmalcty": "COCKEYSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210309998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107710783,
    "dropsitcph": 4107710783,
    "dropfax": 4107710545
  },
  {
    "dcode": "D",
    "dropkey": "PV23226",
    "droptype": "D",
    "dropname": "COLLEGE PARK",
    "dropdeladd": "4815 CALVERT RD",
    "dropdelcty": "COLLEGE PARK",
    "dropdelst": "MD",
    "dropdelzpp": 207409997,
    "dropphyadd": "4815 CALVERT RD",
    "dropphycty": "COLLEGE PARK",
    "dropphyst": "MD",
    "dropphyzpp": 207409997,
    "dropmaladd": "9591 BALTIMORE AVE",
    "dropmalcty": "COLLEGE PARK",
    "dropmalst": "MD",
    "dropmalzpp": 207409998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013458923,
    "dropsitcph": 3016990258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23236",
    "droptype": "D",
    "dropname": "COLORA",
    "dropdeladd": "2167 LIBERTY GROVE RD",
    "dropdelcty": "COLORA",
    "dropdelst": "MD",
    "dropdelzpp": 219179998,
    "dropphyadd": "2167 LIBERTY GROVE RD",
    "dropphycty": "COLORA",
    "dropphyst": "MD",
    "dropphyzpp": 219179998,
    "dropmaladd": "2167 LIBERTY GROVE RD",
    "dropmalcty": "COLORA",
    "dropmalst": "MD",
    "dropmalzpp": 219179998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106585743,
    "dropsitcph": 4106585743,
    "dropfax": 4106585743
  },
  {
    "dcode": "D",
    "dropkey": "PV23237",
    "droptype": "D",
    "dropname": "COLTONS POINT",
    "dropdeladd": "20254 COLTON POINT RD",
    "dropdelcty": "COLTONS POINT",
    "dropdelst": "MD",
    "dropdelzpp": 206269998,
    "dropphyadd": "20254 COLTON POINT RD",
    "dropphycty": "COLTONS POINT",
    "dropphyst": "MD",
    "dropphyzpp": 206269998,
    "dropmaladd": "20254 COLTON POINT RD",
    "dropmalcty": "COLTONS POINT",
    "dropmalst": "MD",
    "dropmalzpp": 206269998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017693853,
    "dropsitcph": 3017693853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23240",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "6801 OAK HALL LN",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MD",
    "dropdelzpp": 210459998,
    "dropphyadd": "6801 OAK HALL LN",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MD",
    "dropphyzpp": 210459998,
    "dropmaladd": "6801 OAK HALL LN",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MD",
    "dropmalzpp": 210459998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103814373,
    "dropsitcph": 4103814373,
    "dropfax": 4103127442
  },
  {
    "dcode": "D",
    "dropkey": "PV23242",
    "droptype": "D",
    "dropname": "COMPTON",
    "dropdeladd": "22173 BAYSIDE RD",
    "dropdelcty": "COMPTON",
    "dropdelst": "MD",
    "dropdelzpp": 206279998,
    "dropphyadd": "22173 BAYSIDE RD",
    "dropphycty": "COMPTON",
    "dropphyst": "MD",
    "dropphyzpp": 206279998,
    "dropmaladd": "22173 BAYSIDE RD",
    "dropmalcty": "COMPTON",
    "dropmalst": "MD",
    "dropmalzpp": 206279998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014759354,
    "dropsitcph": 3014759354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23245",
    "droptype": "D",
    "dropname": "CONOWINGO",
    "dropdeladd": "305 CONOWINGO RD",
    "dropdelcty": "CONOWINGO",
    "dropdelst": "MD",
    "dropdelzpp": 219189998,
    "dropphyadd": "305 CONOWINGO RD",
    "dropphycty": "CONOWINGO",
    "dropphyst": "MD",
    "dropphyzpp": 219189998,
    "dropmaladd": "305 CONOWINGO RD",
    "dropmalcty": "CONOWINGO",
    "dropmalst": "MD",
    "dropmalzpp": 219189998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103782828,
    "dropsitcph": 4103782828,
    "dropfax": 4103789379
  },
  {
    "dcode": "D",
    "dropkey": "PV23276",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "11836 KITTYS CORNER RD",
    "dropdelcty": "CORDOVA",
    "dropdelst": "MD",
    "dropdelzpp": 216259998,
    "dropphyadd": "11836 KITTYS CORNER RD",
    "dropphycty": "CORDOVA",
    "dropphyst": "MD",
    "dropphyzpp": 216259998,
    "dropmaladd": "11836 KITTYS CORNER RD",
    "dropmalcty": "CORDOVA",
    "dropmalst": "MD",
    "dropmalzpp": 216259998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108202964,
    "dropsitcph": 4108202964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23277",
    "droptype": "D",
    "dropname": "CORRIGANVILLE",
    "dropdeladd": "10810 KREIGHBAUM RD",
    "dropdelcty": "CORRIGANVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 215249998,
    "dropphyadd": "10810 KREIGHBAUM RD",
    "dropphycty": "CORRIGANVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 215249998,
    "dropmaladd": "10810 KREIGHBAUM RD",
    "dropmalcty": "CORRIGANVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 215249998,
    "dropsitphn": 3017228190,
    "dropsitlph": 3017777373,
    "dropsitcph": 3017777373,
    "dropfax": 3017223947
  },
  {
    "dcode": "D",
    "dropkey": "PV23289",
    "droptype": "D",
    "dropname": "CRAPO",
    "dropdeladd": "2568 LAKESVILLE CRAPO RD",
    "dropdelcty": "CRAPO",
    "dropdelst": "MD",
    "dropdelzpp": 216269998,
    "dropphyadd": "2568 LAKESVILLE CRAPO RD",
    "dropphycty": "CRAPO",
    "dropphyst": "MD",
    "dropphyzpp": 216269998,
    "dropmaladd": "2568 LAKESVILLE CRAPO RD",
    "dropmalcty": "CRAPO",
    "dropmalst": "MD",
    "dropmalzpp": 216269998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103978036,
    "dropsitcph": 4103978036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23295",
    "droptype": "D",
    "dropname": "CRISFIELD",
    "dropdeladd": "400 W MAIN ST",
    "dropdelcty": "CRISFIELD",
    "dropdelst": "MD",
    "dropdelzpp": 218179998,
    "dropphyadd": "400 W MAIN ST",
    "dropphycty": "CRISFIELD",
    "dropphyst": "MD",
    "dropphyzpp": 218179998,
    "dropmaladd": "400 W MAIN ST",
    "dropmalcty": "CRISFIELD",
    "dropmalst": "MD",
    "dropmalzpp": 218179998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109681550,
    "dropsitcph": 4109681550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23297",
    "droptype": "D",
    "dropname": "CROFTON",
    "dropdeladd": "1296 CRONSON BLVD",
    "dropdelcty": "CROFTON",
    "dropdelst": "MD",
    "dropdelzpp": 211149998,
    "dropphyadd": "1296 CRONSON BLVD",
    "dropphycty": "CROFTON",
    "dropphyst": "MD",
    "dropphyzpp": 211149998,
    "dropmaladd": "1296 CRONSON BLVD",
    "dropmalcty": "CROFTON",
    "dropmalst": "MD",
    "dropmalzpp": 211149998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107215861,
    "dropsitcph": 4107215861,
    "dropfax": 4107930256
  },
  {
    "dcode": "D",
    "dropkey": "PV23305",
    "droptype": "D",
    "dropname": "CROWNSVILLE",
    "dropdeladd": "1333 GENERALS HWY",
    "dropdelcty": "CROWNSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210329998,
    "dropphyadd": "1333 GENERALS HWY",
    "dropphycty": "CROWNSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210329998,
    "dropmaladd": "1333 GENERALS HWY",
    "dropmalcty": "CROWNSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210329998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109871384,
    "dropsitcph": 4109871384,
    "dropfax": 4109877687
  },
  {
    "dcode": "D",
    "dropkey": "PV23306",
    "droptype": "D",
    "dropname": "CRUMPTON",
    "dropdeladd": "213 BROAD ST",
    "dropdelcty": "CRUMPTON",
    "dropdelst": "MD",
    "dropdelzpp": 216289998,
    "dropphyadd": "213 BROAD ST",
    "dropphycty": "CRUMPTON",
    "dropphyst": "MD",
    "dropphyzpp": 216289998,
    "dropmaladd": "213 BROAD ST",
    "dropmalcty": "CRUMPTON",
    "dropmalst": "MD",
    "dropmalzpp": 216289998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109285183,
    "dropsitcph": 4109285183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23311",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "215 PARK ST",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215029998,
    "dropphyadd": "215 PARK ST",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215029998,
    "dropmaladd": "215 PARK ST",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215029998,
    "dropsitphn": 3017228190,
    "dropsitlph": 3017228190,
    "dropsitcph": 3017228190,
    "dropfax": 3017773416
  },
  {
    "dcode": "D",
    "dropkey": "PV23313",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "26400 WOODFIELD RD",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "MD",
    "dropdelzpp": 208729998,
    "dropphyadd": "26400 WOODFIELD RD",
    "dropphycty": "DAMASCUS",
    "dropphyst": "MD",
    "dropphyzpp": 208729998,
    "dropmaladd": "26400 WOODFIELD RD",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "MD",
    "dropmalzpp": 208729998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012533781,
    "dropsitcph": 3012533781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23314",
    "droptype": "D",
    "dropname": "DAMERON",
    "dropdeladd": "17679 THREE NOTCH RD",
    "dropdelcty": "DAMERON",
    "dropdelst": "MD",
    "dropdelzpp": 206289998,
    "dropphyadd": "17679 THREE NOTCH RD",
    "dropphycty": "DAMERON",
    "dropphyst": "MD",
    "dropphyzpp": 206289998,
    "dropmaladd": "17679 THREE NOTCH RD",
    "dropmalcty": "DAMERON",
    "dropmalst": "MD",
    "dropmalzpp": 206289998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018725461,
    "dropsitcph": 3018725461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23320",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "1113 MAIN ST",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 210349998,
    "dropphyadd": "1113 MAIN ST",
    "dropphycty": "DARLINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 210349998,
    "dropmaladd": "1113 MAIN ST",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 210349998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104570461,
    "dropsitcph": 4104570461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23325",
    "droptype": "D",
    "dropname": "DAVIDSONVILLE",
    "dropdeladd": "1251 W CENTRAL AVE STE A",
    "dropdelcty": "DAVIDSONVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210352327,
    "dropphyadd": "1251 W CENTRAL AVE STE A",
    "dropphycty": "DAVIDSONVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210352327,
    "dropmaladd": "1251 W CENTRAL AVE STE A",
    "dropmalcty": "DAVIDSONVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210352327,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109568352,
    "dropsitcph": 4109568352,
    "dropfax": 4432030285
  },
  {
    "dcode": "D",
    "dropkey": "PV23327",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "4924A 10 OAKS RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "MD",
    "dropdelzpp": 210369998,
    "dropphyadd": "4924A 10 OAKS RD",
    "dropphycty": "DAYTON",
    "dropphyst": "MD",
    "dropphyzpp": 210369998,
    "dropmaladd": "4924A 10 OAKS RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "MD",
    "dropmalzpp": 210369998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105316194,
    "dropsitcph": 4105316194,
    "dropfax": 4105316194
  },
  {
    "dcode": "D",
    "dropkey": "PV23328",
    "droptype": "D",
    "dropname": "DEAL ISLAND",
    "dropdeladd": "10051 DEAL ISLAND RD",
    "dropdelcty": "DEAL ISLAND",
    "dropdelst": "MD",
    "dropdelzpp": 218219998,
    "dropphyadd": "10051 DEAL ISLAND RD",
    "dropphycty": "DEAL ISLAND",
    "dropphyst": "MD",
    "dropphyzpp": 218219998,
    "dropmaladd": "10051 DEAL ISLAND RD",
    "dropmalcty": "DEAL ISLAND",
    "dropmalst": "MD",
    "dropmalzpp": 218219998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107842824,
    "dropsitcph": 4107842824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23329",
    "droptype": "D",
    "dropname": "DEALE",
    "dropdeladd": "650 DEALE RD",
    "dropdelcty": "DEALE",
    "dropdelst": "MD",
    "dropdelzpp": 207519998,
    "dropphyadd": "650 DEALE RD",
    "dropphycty": "DEALE",
    "dropphyst": "MD",
    "dropphyzpp": 207519998,
    "dropmaladd": "650 DEALE RD",
    "dropmalcty": "DEALE",
    "dropmalst": "MD",
    "dropmalzpp": 207519998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4108676135,
    "dropsitcph": 4108676135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23338",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "503 MARKET ST",
    "dropdelcty": "DENTON",
    "dropdelst": "MD",
    "dropdelzpp": 216299998,
    "dropphyadd": "503 MARKET ST",
    "dropphycty": "DENTON",
    "dropphyst": "MD",
    "dropphyzpp": 216299998,
    "dropmaladd": "503 MARKET ST",
    "dropmalcty": "DENTON",
    "dropmalst": "MD",
    "dropmalzpp": 216299998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104792363,
    "dropsitcph": 4104792363,
    "dropfax": 4104794211
  },
  {
    "dcode": "D",
    "dropkey": "PV23347",
    "droptype": "D",
    "dropname": "DICKERSON",
    "dropdeladd": "22145 DICKERSON RD",
    "dropdelcty": "DICKERSON",
    "dropdelst": "MD",
    "dropdelzpp": 208429998,
    "dropphyadd": "22145 DICKERSON RD",
    "dropphycty": "DICKERSON",
    "dropphyst": "MD",
    "dropphyzpp": 208429998,
    "dropmaladd": "22145 DICKERSON RD",
    "dropmalcty": "DICKERSON",
    "dropmalst": "MD",
    "dropmalzpp": 208429998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014288243,
    "dropsitcph": 3014288243,
    "dropfax": 3014288249
  },
  {
    "dcode": "D",
    "dropkey": "PV23364",
    "droptype": "D",
    "dropname": "DOWELL",
    "dropdeladd": "14515 DOWELL RD",
    "dropdelcty": "DOWELL",
    "dropdelst": "MD",
    "dropdelzpp": 206299998,
    "dropphyadd": "14515 DOWELL RD",
    "dropphycty": "DOWELL",
    "dropphyst": "MD",
    "dropphyzpp": 206299998,
    "dropmaladd": "14515 DOWELL RD",
    "dropmalcty": "DOWELL",
    "dropmalst": "MD",
    "dropmalzpp": 206299998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4103262135,
    "dropsitcph": 4103262135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23366",
    "droptype": "D",
    "dropname": "DRAYDEN",
    "dropdeladd": "18552 CHERRYFIELD RD",
    "dropdelcty": "DRAYDEN",
    "dropdelst": "MD",
    "dropdelzpp": 206309998,
    "dropphyadd": "18552 CHERRYFIELD RD",
    "dropphycty": "DRAYDEN",
    "dropphyst": "MD",
    "dropphyzpp": 206309998,
    "dropmaladd": "18552 CHERRYFIELD RD",
    "dropmalcty": "DRAYDEN",
    "dropmalst": "MD",
    "dropmalzpp": 206309998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019940430,
    "dropsitcph": 3019940430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23376",
    "droptype": "D",
    "dropname": "DUNKIRK",
    "dropdeladd": "10383 SOUTHERN MARYLAND BLVD",
    "dropdelcty": "DUNKIRK",
    "dropdelst": "MD",
    "dropdelzpp": 207549998,
    "dropphyadd": "10383 SOUTHERN MARYLAND BLVD",
    "dropphycty": "DUNKIRK",
    "dropphyst": "MD",
    "dropphyzpp": 207549998,
    "dropmaladd": "10383 SOUTHERN MARYLAND BLVD",
    "dropmalcty": "DUNKIRK",
    "dropmalst": "MD",
    "dropmalzpp": 207549998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018555384,
    "dropsitcph": 3018555384,
    "dropfax": 3012576090
  },
  {
    "dcode": "D",
    "dropkey": "PV23379",
    "droptype": "D",
    "dropname": "EARLEVILLE",
    "dropdeladd": "1244 CRYSTAL BEACH RD",
    "dropdelcty": "EARLEVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 219199998,
    "dropphyadd": "1244 CRYSTAL BEACH RD",
    "dropphycty": "EARLEVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 219199998,
    "dropmaladd": "1244 CRYSTAL BEACH RD",
    "dropmalcty": "EARLEVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 219199998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102758400,
    "dropsitcph": 4102758400,
    "dropfax": 4102758400
  },
  {
    "dcode": "D",
    "dropkey": "PV23383",
    "droptype": "D",
    "dropname": "EAST NEW MARKET",
    "dropdeladd": "101 RAILROAD AVE",
    "dropdelcty": "EAST NEW MARKET",
    "dropdelst": "MD",
    "dropdelzpp": 216319998,
    "dropphyadd": "101 RAILROAD AVE",
    "dropphycty": "EAST NEW MARKET",
    "dropphyst": "MD",
    "dropphyzpp": 216319998,
    "dropmaladd": "101 RAILROAD AVE",
    "dropmalcty": "EAST NEW MARKET",
    "dropmalst": "MD",
    "dropmalzpp": 216319998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109434316,
    "dropsitcph": 4109434316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23387",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "116 E DOVER ST",
    "dropdelcty": "EASTON",
    "dropdelst": "MD",
    "dropdelzpp": 216019998,
    "dropphyadd": "116 E DOVER ST",
    "dropphycty": "EASTON",
    "dropphyst": "MD",
    "dropphyzpp": 216019998,
    "dropmaladd": "116 E DOVER ST",
    "dropmalcty": "EASTON",
    "dropmalst": "MD",
    "dropmalzpp": 216019998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108220486,
    "dropsitcph": 4108220486,
    "dropfax": 4108222505
  },
  {
    "dcode": "D",
    "dropkey": "PV23392",
    "droptype": "D",
    "dropname": "ECKHART MINES",
    "dropdeladd": "10501 ECKHART MINES ST",
    "dropdelcty": "ECKHART MINES",
    "dropdelst": "MD",
    "dropdelzpp": 215289998,
    "dropphyadd": "10501 ECKHART MINES ST",
    "dropphycty": "ECKHART MINES",
    "dropphyst": "MD",
    "dropphyzpp": 215289998,
    "dropmaladd": "10501 ECKHART MINES ST",
    "dropmalcty": "ECKHART MINES",
    "dropmalst": "MD",
    "dropmalzpp": 215289998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3016899580,
    "dropsitcph": 3016899580,
    "dropfax": 3016899580
  },
  {
    "dcode": "D",
    "dropkey": "PV23393",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "31676 EDEN ALLEN RD",
    "dropdelcty": "EDEN",
    "dropdelst": "MD",
    "dropdelzpp": 218229998,
    "dropphyadd": "31676 EDEN ALLEN RD",
    "dropphycty": "EDEN",
    "dropphyst": "MD",
    "dropphyzpp": 218229998,
    "dropmaladd": "31676 EDEN ALLEN RD",
    "dropmalcty": "EDEN",
    "dropmalst": "MD",
    "dropmalzpp": 218229998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107422759,
    "dropsitcph": 4107422759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23397",
    "droptype": "D",
    "dropname": "EDGEWATER",
    "dropdeladd": "39 STEPNEY LN",
    "dropdelcty": "EDGEWATER",
    "dropdelst": "MD",
    "dropdelzpp": 210371420,
    "dropphyadd": "39 STEPNEY LN",
    "dropphycty": "EDGEWATER",
    "dropphyst": "MD",
    "dropphyzpp": 210371420,
    "dropmaladd": "39 STEPNEY LN",
    "dropmalcty": "EDGEWATER",
    "dropmalst": "MD",
    "dropmalzpp": 210371420,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109562088,
    "dropsitcph": 4109562088,
    "dropfax": 4109566258
  },
  {
    "dcode": "D",
    "dropkey": "PV23399",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "2290 HANSON RD",
    "dropdelcty": "EDGEWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 210409998,
    "dropphyadd": "2290 HANSON RD",
    "dropphycty": "EDGEWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 210409998,
    "dropmaladd": "2290 HANSON RD",
    "dropmalcty": "EDGEWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 210409998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106769378,
    "dropsitcph": 4106769378,
    "dropfax": 4106717286
  },
  {
    "dcode": "D",
    "dropkey": "PV23410",
    "droptype": "D",
    "dropname": "ELK MILLS",
    "dropdeladd": "732 ELK MILLS RD",
    "dropdelcty": "ELK MILLS",
    "dropdelst": "MD",
    "dropdelzpp": 219209998,
    "dropphyadd": "732 ELK MILLS RD",
    "dropphycty": "ELK MILLS",
    "dropphyst": "MD",
    "dropphyzpp": 219209998,
    "dropmaladd": "732 ELK MILLS RD",
    "dropmalcty": "ELK MILLS",
    "dropmalst": "MD",
    "dropmalzpp": 219209998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103984474,
    "dropsitcph": 4103984474,
    "dropfax": 4103984474
  },
  {
    "dcode": "D",
    "dropkey": "PV23414",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "137 W MAIN ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "MD",
    "dropdelzpp": 219219998,
    "dropphyadd": "137 W MAIN ST",
    "dropphycty": "ELKTON",
    "dropphyst": "MD",
    "dropphyzpp": 219219998,
    "dropmaladd": "137 W MAIN ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "MD",
    "dropmalzpp": 219219998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103984040,
    "dropsitcph": 4103984040,
    "dropfax": 4106209258
  },
  {
    "dcode": "D",
    "dropkey": "PV23415",
    "droptype": "D",
    "dropname": "ELLERSLIE",
    "dropdeladd": "14302 ELLERSLIE RD NW",
    "dropdelcty": "ELLERSLIE",
    "dropdelst": "MD",
    "dropdelzpp": 215299998,
    "dropphyadd": "14302 ELLERSLIE RD NW",
    "dropphycty": "ELLERSLIE",
    "dropphyst": "MD",
    "dropphyzpp": 215299998,
    "dropmaladd": "14302 ELLERSLIE RD NW",
    "dropmalcty": "ELLERSLIE",
    "dropmalst": "MD",
    "dropmalzpp": 215299998,
    "dropsitphn": 3017228190,
    "dropsitlph": 3017593999,
    "dropsitcph": 3017593999,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23416",
    "droptype": "D",
    "dropname": "ELLICOTT CITY",
    "dropdeladd": "3375 ELLICOTT CENTER DR",
    "dropdelcty": "ELLICOTT CITY",
    "dropdelst": "MD",
    "dropdelzpp": 210439998,
    "dropphyadd": "3375 ELLICOTT CENTER DR",
    "dropphycty": "ELLICOTT CITY",
    "dropphyst": "MD",
    "dropphyzpp": 210439998,
    "dropmaladd": "3375 ELLICOTT CENTER DR",
    "dropmalcty": "ELLICOTT CITY",
    "dropmalst": "MD",
    "dropmalzpp": 210439998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107501340,
    "dropsitcph": 4107501340,
    "dropfax": 4104185511
  },
  {
    "dcode": "D",
    "dropkey": "PV23421",
    "droptype": "D",
    "dropname": "EMMITSBURG",
    "dropdeladd": "305 S SETON AVE",
    "dropdelcty": "EMMITSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 217279998,
    "dropphyadd": "305 S SETON AVE",
    "dropphycty": "EMMITSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 217279998,
    "dropmaladd": "305 S SETON AVE",
    "dropmalcty": "EMMITSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 217279998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014472655,
    "dropsitcph": 3014472655,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23429",
    "droptype": "D",
    "dropname": "EWELL",
    "dropdeladd": "20925 CALEB JONES RD",
    "dropdelcty": "EWELL",
    "dropdelst": "MD",
    "dropdelzpp": 218249998,
    "dropphyadd": "20925 CALEB JONES RD",
    "dropphycty": "EWELL",
    "dropphyst": "MD",
    "dropphyzpp": 218249998,
    "dropmaladd": "20925 CALEB JONES RD",
    "dropmalcty": "EWELL",
    "dropmalst": "MD",
    "dropmalzpp": 218249998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104255751,
    "dropsitcph": 4104255751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23433",
    "droptype": "D",
    "dropname": "FAIRPLAY",
    "dropdeladd": "8215 SHARPSBURG PIKE",
    "dropdelcty": "FAIRPLAY",
    "dropdelst": "MD",
    "dropdelzpp": 217339998,
    "dropphyadd": "8215 SHARPSBURG PIKE",
    "dropphycty": "FAIRPLAY",
    "dropphyst": "MD",
    "dropphyzpp": 217339998,
    "dropmaladd": "8215 SHARPSBURG PIKE",
    "dropmalcty": "FAIRPLAY",
    "dropmalst": "MD",
    "dropmalzpp": 217339998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3015820559,
    "dropsitcph": 3015820559,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23443",
    "droptype": "D",
    "dropname": "FALLSTON",
    "dropdeladd": "2416 WATERVALE RD",
    "dropdelcty": "FALLSTON",
    "dropdelst": "MD",
    "dropdelzpp": 210472352,
    "dropphyadd": "2416 WATERVALE RD",
    "dropphycty": "FALLSTON",
    "dropphyst": "MD",
    "dropphyzpp": 210472352,
    "dropmaladd": "2416 WATERVALE RD",
    "dropmalcty": "FALLSTON",
    "dropmalst": "MD",
    "dropmalzpp": 210472352,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108772846,
    "dropsitcph": 4108772846,
    "dropfax": 4108779299
  },
  {
    "dcode": "D",
    "dropkey": "PV23445",
    "droptype": "D",
    "dropname": "FAULKNER",
    "dropdeladd": "9977 FAULKNER RD",
    "dropdelcty": "FAULKNER",
    "dropdelst": "MD",
    "dropdelzpp": 206329998,
    "dropphyadd": "9977 FAULKNER RD",
    "dropphycty": "FAULKNER",
    "dropphyst": "MD",
    "dropphyzpp": 206329998,
    "dropmaladd": "9977 FAULKNER RD",
    "dropmalcty": "FAULKNER",
    "dropmalst": "MD",
    "dropmalzpp": 206329998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019349331,
    "dropsitcph": 3019349331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23447",
    "droptype": "D",
    "dropname": "FEDERALSBURG",
    "dropdeladd": "122 MORRIS AVE",
    "dropdelcty": "FEDERALSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 216329998,
    "dropphyadd": "122 MORRIS AVE",
    "dropphycty": "FEDERALSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 216329998,
    "dropmaladd": "122 MORRIS AVE",
    "dropmalcty": "FEDERALSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 216329998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107549091,
    "dropsitcph": 4107549091,
    "dropfax": 4107547461
  },
  {
    "dcode": "D",
    "dropkey": "PV23452",
    "droptype": "D",
    "dropname": "FINKSBURG",
    "dropdeladd": "3000 GAMBER RD STE 13",
    "dropdelcty": "FINKSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 210482250,
    "dropphyadd": "3000 GAMBER RD STE 13",
    "dropphycty": "FINKSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 210482250,
    "dropmaladd": "3000 GAMBER RD STE 13",
    "dropmalcty": "FINKSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 210482250,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108618026,
    "dropsitcph": 4108618026,
    "dropfax": 4107519888
  },
  {
    "dcode": "D",
    "dropkey": "PV23460",
    "droptype": "D",
    "dropname": "FISHING CREEK",
    "dropdeladd": "2654 HOOPERS ISLAND RD",
    "dropdelcty": "FISHING CREEK",
    "dropdelst": "MD",
    "dropdelzpp": 216349998,
    "dropphyadd": "2654 HOOPERS ISLAND RD",
    "dropphycty": "FISHING CREEK",
    "dropphyst": "MD",
    "dropphyzpp": 216349998,
    "dropmaladd": "2654 HOOPERS ISLAND RD",
    "dropmalcty": "FISHING CREEK",
    "dropmalst": "MD",
    "dropmalzpp": 216349998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103973318,
    "dropsitcph": 4103973318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23464",
    "droptype": "D",
    "dropname": "FLINTSTONE",
    "dropdeladd": "21600 NATIONAL PIKE NE",
    "dropdelcty": "FLINTSTONE",
    "dropdelst": "MD",
    "dropdelzpp": 215309998,
    "dropphyadd": "21600 NATIONAL PIKE NE",
    "dropphycty": "FLINTSTONE",
    "dropphyst": "MD",
    "dropphyzpp": 215309998,
    "dropmaladd": "21600 NATIONAL PIKE NE",
    "dropmalcty": "FLINTSTONE",
    "dropmalst": "MD",
    "dropmalzpp": 215309998,
    "dropsitphn": 3017228190,
    "dropsitlph": 3014782255,
    "dropsitcph": 3014782255,
    "dropfax": 3014783109
  },
  {
    "dcode": "D",
    "dropkey": "PV23469",
    "droptype": "D",
    "dropname": "FOREST HILL",
    "dropdeladd": "2329 ROCK SPRING RD",
    "dropdelcty": "FOREST HILL",
    "dropdelst": "MD",
    "dropdelzpp": 210509998,
    "dropphyadd": "2329 ROCK SPRING RD",
    "dropphycty": "FOREST HILL",
    "dropphyst": "MD",
    "dropphyzpp": 210509998,
    "dropmaladd": "2329 ROCK SPRING RD",
    "dropmalcty": "FOREST HILL",
    "dropmalst": "MD",
    "dropmalzpp": 210509998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108380820,
    "dropsitcph": 4108380820,
    "dropfax": 4105885977
  },
  {
    "dcode": "D",
    "dropkey": "PV23477",
    "droptype": "D",
    "dropname": "FORK",
    "dropdeladd": "12544 HARFORD RD",
    "dropdelcty": "FORK",
    "dropdelst": "MD",
    "dropdelzpp": 210519998,
    "dropphyadd": "12544 HARFORD RD",
    "dropphycty": "FORK",
    "dropphyst": "MD",
    "dropphyzpp": 210519998,
    "dropmaladd": "12544 HARFORD RD",
    "dropmalcty": "FORK",
    "dropmalst": "MD",
    "dropmalzpp": 210519998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105927279,
    "dropsitcph": 4105927279,
    "dropfax": 4105927279
  },
  {
    "dcode": "D",
    "dropkey": "PV23479",
    "droptype": "D",
    "dropname": "FORT GEORGE G MEADE",
    "dropdeladd": "2789 MACARTHUR RD",
    "dropdelcty": "FORT GEORGE G MEADE",
    "dropdelst": "MD",
    "dropdelzpp": 207559998,
    "dropphyadd": "2789 MACARTHUR RD",
    "dropphycty": "FORT GEORGE G MEADE",
    "dropphyst": "MD",
    "dropphyzpp": 207559998,
    "dropmaladd": "2789 MACARTHUR RD",
    "dropmalcty": "FORT GEORGE G MEADE",
    "dropmalst": "MD",
    "dropmalzpp": 207559998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016774660,
    "dropsitcph": 3016217071,
    "dropfax": 3019121303
  },
  {
    "dcode": "D",
    "dropkey": "PV23483",
    "droptype": "D",
    "dropname": "FORT HOWARD",
    "dropdeladd": "9200 HOWARD AVE",
    "dropdelcty": "FORT HOWARD",
    "dropdelst": "MD",
    "dropdelzpp": 210529998,
    "dropphyadd": "9200 HOWARD AVE",
    "dropphycty": "FORT HOWARD",
    "dropphyst": "MD",
    "dropphyzpp": 210529998,
    "dropmaladd": "9200 HOWARD AVE",
    "dropmalcty": "FORT HOWARD",
    "dropmalst": "MD",
    "dropmalzpp": 210529998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104772105,
    "dropsitcph": 4104772105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23501",
    "droptype": "D",
    "dropname": "FREDERICK",
    "dropdeladd": "201 E PATRICK ST",
    "dropdelcty": "FREDERICK",
    "dropdelst": "MD",
    "dropdelzpp": 217019998,
    "dropphyadd": "201 E PATRICK ST",
    "dropphycty": "FREDERICK",
    "dropphyst": "MD",
    "dropphyzpp": 217019998,
    "dropmaladd": "201 E PATRICK ST",
    "dropmalcty": "FREDERICK",
    "dropmalst": "MD",
    "dropmalzpp": 217019998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3016248050,
    "dropsitcph": 3016248050,
    "dropfax": 3016248070
  },
  {
    "dcode": "D",
    "dropkey": "PV23504",
    "droptype": "D",
    "dropname": "FREELAND",
    "dropdeladd": "21600 NEW FREEDOM RD",
    "dropdelcty": "FREELAND",
    "dropdelst": "MD",
    "dropdelzpp": 210539998,
    "dropphyadd": "21600 NEW FREEDOM RD",
    "dropphycty": "FREELAND",
    "dropphyst": "MD",
    "dropphyzpp": 210539998,
    "dropmaladd": "21600 NEW FREEDOM RD",
    "dropmalcty": "FREELAND",
    "dropmalst": "MD",
    "dropmalzpp": 210539998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103579969,
    "dropsitcph": 4103579969,
    "dropfax": 4103574048
  },
  {
    "dcode": "D",
    "dropkey": "PV23507",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "4 FRIENDSHIP RD W",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "MD",
    "dropdelzpp": 207583258,
    "dropphyadd": "4 FRIENDSHIP RD W",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "MD",
    "dropphyzpp": 207583258,
    "dropmaladd": "4 FRIENDSHIP RD W",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "MD",
    "dropmalzpp": 207583258,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018552478,
    "dropsitcph": 3018552478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23509",
    "droptype": "D",
    "dropname": "FRIENDSVILLE",
    "dropdeladd": "836 1ST AVE",
    "dropdelcty": "FRIENDSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 215319998,
    "dropphyadd": "836 1ST AVE",
    "dropphycty": "FRIENDSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 215319998,
    "dropmaladd": "836 1ST AVE",
    "dropmalcty": "FRIENDSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 215319998,
    "dropsitphn": 3017473364,
    "dropsitlph": 3017473364,
    "dropsitcph": 3017473364,
    "dropfax": 3017465985
  },
  {
    "dcode": "D",
    "dropkey": "PV23511",
    "droptype": "D",
    "dropname": "FROSTBURG",
    "dropdeladd": "37 W MAIN ST",
    "dropdelcty": "FROSTBURG",
    "dropdelst": "MD",
    "dropdelzpp": 215329998,
    "dropphyadd": "37 W MAIN ST",
    "dropphycty": "FROSTBURG",
    "dropphyst": "MD",
    "dropphyzpp": 215329998,
    "dropmaladd": "37 W MAIN ST",
    "dropmalcty": "FROSTBURG",
    "dropmalst": "MD",
    "dropmalzpp": 215329998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3106896648,
    "dropsitcph": 3016896648,
    "dropfax": 3016893827
  },
  {
    "dcode": "D",
    "dropkey": "PV23513",
    "droptype": "D",
    "dropname": "FRUITLAND",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "FRUITLAND",
    "dropdelst": "MD",
    "dropdelzpp": 218269998,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "FRUITLAND",
    "dropphyst": "MD",
    "dropphyzpp": 218269998,
    "dropmaladd": "201 E MAIN ST",
    "dropmalcty": "FRUITLAND",
    "dropmalst": "MD",
    "dropmalzpp": 218269998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107496677,
    "dropsitcph": 4107496677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23519",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "11831 SCAGGSVILLE RD",
    "dropdelcty": "FULTON",
    "dropdelst": "MD",
    "dropdelzpp": 207599998,
    "dropphyadd": "11831 SCAGGSVILLE RD",
    "dropphycty": "FULTON",
    "dropphyst": "MD",
    "dropphyzpp": 207599998,
    "dropmaladd": "11831 SCAGGSVILLE RD",
    "dropmalcty": "FULTON",
    "dropmalst": "MD",
    "dropmalzpp": 207599998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016043425,
    "dropsitcph": 3016043425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23520",
    "droptype": "D",
    "dropname": "FUNKSTOWN",
    "dropdeladd": "29 FREDERICK RD",
    "dropdelcty": "FUNKSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217341100,
    "dropphyadd": "29 FREDERICK RD",
    "dropphycty": "FUNKSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217341100,
    "dropmaladd": "29 FREDERICK RD",
    "dropmalcty": "FUNKSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217341100,
    "dropsitphn": 3016823129,
    "dropsitlph": 3017977331,
    "dropsitcph": 3017977331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23524",
    "droptype": "D",
    "dropname": "GAITHERSBURG",
    "dropdeladd": "21 S SUMMIT AVE",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208779998,
    "dropphyadd": "21 S SUMMIT AVE",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208779998,
    "dropmaladd": "21 S SUMMIT AVE",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208779998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083701,
    "dropsitcph": 3012083701,
    "dropfax": 3012083707
  },
  {
    "dcode": "D",
    "dropkey": "PV23526",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "124 W CROSS ST",
    "dropdelcty": "GALENA",
    "dropdelst": "MD",
    "dropdelzpp": 216359998,
    "dropphyadd": "124 W CROSS ST",
    "dropphycty": "GALENA",
    "dropphyst": "MD",
    "dropphyzpp": 216359998,
    "dropmaladd": "124 W CROSS ST",
    "dropmalcty": "GALENA",
    "dropmalst": "MD",
    "dropmalzpp": 216359998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106485783,
    "dropsitcph": 4106485783,
    "dropfax": 4106485030
  },
  {
    "dcode": "D",
    "dropkey": "PV23527",
    "droptype": "D",
    "dropname": "GALESVILLE",
    "dropdeladd": "948 GALESVILLE RD",
    "dropdelcty": "GALESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207659998,
    "dropphyadd": "948 GALESVILLE RD",
    "dropphycty": "GALESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207659998,
    "dropmaladd": "948 GALESVILLE RD",
    "dropmalcty": "GALESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207659998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4108672859,
    "dropsitcph": 4108672859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23531",
    "droptype": "D",
    "dropname": "GAMBRILLS",
    "dropdeladd": "388 GAMBRILLS RD",
    "dropdelcty": "GAMBRILLS",
    "dropdelst": "MD",
    "dropdelzpp": 210549998,
    "dropphyadd": "388 GAMBRILLS RD",
    "dropphycty": "GAMBRILLS",
    "dropphyst": "MD",
    "dropphyzpp": 210549998,
    "dropmaladd": "388 GAMBRILLS RD",
    "dropmalcty": "GAMBRILLS",
    "dropmalst": "MD",
    "dropmalzpp": 210549998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109236931,
    "dropsitcph": 4109236931,
    "dropfax": 4109231554
  },
  {
    "dcode": "D",
    "dropkey": "PV23537",
    "droptype": "D",
    "dropname": "GARRETT PARK",
    "dropdeladd": "4600 WAVERLY AVE",
    "dropdelcty": "GARRETT PARK",
    "dropdelst": "MD",
    "dropdelzpp": 208969998,
    "dropphyadd": "4600 WAVERLY AVE",
    "dropphycty": "GARRETT PARK",
    "dropphyst": "MD",
    "dropphyzpp": 208969998,
    "dropmaladd": "4600 WAVERLY AVE",
    "dropmalcty": "GARRETT PARK",
    "dropmalst": "MD",
    "dropmalzpp": 208969998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019332580,
    "dropsitcph": 3019332580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23543",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "7480 AUGUSTINE HERMAN HWY",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "MD",
    "dropdelzpp": 219309998,
    "dropphyadd": "7480 AUGUSTINE HERMAN HWY",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "MD",
    "dropphyzpp": 219309998,
    "dropmaladd": "7480 AUGUSTINE HERMAN HWY",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "MD",
    "dropmalzpp": 219309998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102758175,
    "dropsitcph": 4102758175,
    "dropfax": 4102758175
  },
  {
    "dcode": "D",
    "dropkey": "PV23544",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "12774 WISTERIA DR",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 208749998,
    "dropphyadd": "12774 WISTERIA DR",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 208749998,
    "dropmaladd": "12774 WISTERIA DR",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 208749998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014280189,
    "dropsitcph": 3014280460,
    "dropfax": 3015401978
  },
  {
    "dcode": "D",
    "dropkey": "PV23547",
    "droptype": "D",
    "dropname": "GIBSON ISLAND",
    "dropdeladd": "534 BROADWATER WAY",
    "dropdelcty": "GIBSON ISLAND",
    "dropdelst": "MD",
    "dropdelzpp": 210569998,
    "dropphyadd": "534 BROADWATER WAY",
    "dropphycty": "GIBSON ISLAND",
    "dropphyst": "MD",
    "dropphyzpp": 210569998,
    "dropmaladd": "534 BROADWATER WAY",
    "dropmalcty": "GIBSON ISLAND",
    "dropmalst": "MD",
    "dropmalzpp": 210569998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103605372,
    "dropsitcph": 4103605372,
    "dropfax": 4103604391
  },
  {
    "dcode": "D",
    "dropkey": "PV23551",
    "droptype": "D",
    "dropname": "GIRDLETREE",
    "dropdeladd": "2744 SNOW HILL RD",
    "dropdelcty": "GIRDLETREE",
    "dropdelst": "MD",
    "dropdelzpp": 218299998,
    "dropphyadd": "2744 SNOW HILL RD",
    "dropphycty": "GIRDLETREE",
    "dropphyst": "MD",
    "dropphyzpp": 218299998,
    "dropmaladd": "2744 SNOW HILL RD",
    "dropmalcty": "GIRDLETREE",
    "dropmalst": "MD",
    "dropmalzpp": 218299998,
    "dropsitphn": 4106320310,
    "dropsitlph": 4106320310,
    "dropsitcph": 4106320310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23556",
    "droptype": "D",
    "dropname": "GLEN ARM",
    "dropdeladd": "12112 LONG GREEN PIKE",
    "dropdelcty": "GLEN ARM",
    "dropdelst": "MD",
    "dropdelzpp": 210579998,
    "dropphyadd": "12112 LONG GREEN PIKE",
    "dropphycty": "GLEN ARM",
    "dropphyst": "MD",
    "dropphyzpp": 210579998,
    "dropmaladd": "12112 LONG GREEN PIKE",
    "dropmalcty": "GLEN ARM",
    "dropmalst": "MD",
    "dropmalzpp": 210579998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105929658,
    "dropsitcph": 4105929658,
    "dropfax": 4105928793
  },
  {
    "dcode": "D",
    "dropkey": "PV23557",
    "droptype": "D",
    "dropname": "GLEN BURNIE",
    "dropdeladd": "7596 RITCHIE HWY",
    "dropdelcty": "GLEN BURNIE",
    "dropdelst": "MD",
    "dropdelzpp": 210619998,
    "dropphyadd": "7596 RITCHIE HWY",
    "dropphycty": "GLEN BURNIE",
    "dropphyst": "MD",
    "dropphyzpp": 210619998,
    "dropmaladd": "7596 RITCHIE HWY",
    "dropmalcty": "GLEN BURNIE",
    "dropmalst": "MD",
    "dropmalzpp": 210619998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107668882,
    "dropsitcph": 4107668882,
    "dropfax": 4107607249
  },
  {
    "dcode": "D",
    "dropkey": "PV23560",
    "droptype": "D",
    "dropname": "GLEN ECHO",
    "dropdeladd": "6106 HARVARD AVE",
    "dropdelcty": "GLEN ECHO",
    "dropdelst": "MD",
    "dropdelzpp": 208129998,
    "dropphyadd": "6106 HARVARD AVE",
    "dropphycty": "GLEN ECHO",
    "dropphyst": "MD",
    "dropphyzpp": 208129998,
    "dropmaladd": "6106 HARVARD AVE",
    "dropmalcty": "GLEN ECHO",
    "dropmalst": "MD",
    "dropmalzpp": 208129998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012293025,
    "dropsitcph": 3012293025,
    "dropfax": 3012293025
  },
  {
    "dcode": "D",
    "dropkey": "PV23566",
    "droptype": "D",
    "dropname": "GLENELG",
    "dropdeladd": "3900 10 OAKS RD UNIT 7",
    "dropdelcty": "GLENELG",
    "dropdelst": "MD",
    "dropdelzpp": 217379998,
    "dropphyadd": "3900 10 OAKS RD UNIT 7",
    "dropphycty": "GLENELG",
    "dropphyst": "MD",
    "dropphyzpp": 217379998,
    "dropmaladd": "3900 10 OAKS RD UNIT 7",
    "dropmalcty": "GLENELG",
    "dropmalst": "MD",
    "dropmalzpp": 217379998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4105315016,
    "dropsitcph": 4105315016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23569",
    "droptype": "D",
    "dropname": "GLENN DALE",
    "dropdeladd": "7003 GLENN DALE RD",
    "dropdelcty": "GLENN DALE",
    "dropdelst": "MD",
    "dropdelzpp": 207699998,
    "dropphyadd": "7003 GLENN DALE RD",
    "dropphycty": "GLENN DALE",
    "dropphyst": "MD",
    "dropphyzpp": 207699998,
    "dropmaladd": "7003 GLENN DALE RD",
    "dropmalcty": "GLENN DALE",
    "dropmalst": "MD",
    "dropmalzpp": 207699998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013906565,
    "dropsitcph": 3018600187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23573",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "3000 ROUTE 97",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 217389998,
    "dropphyadd": "3000 ROUTE 97",
    "dropphycty": "GLENWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 217389998,
    "dropmaladd": "3000 ROUTE 97",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 217389998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4106803336,
    "dropsitcph": 4106803336,
    "dropfax": 4104894134
  },
  {
    "dcode": "D",
    "dropkey": "PV23575",
    "droptype": "D",
    "dropname": "GLYNDON",
    "dropdeladd": "2 RAILROAD AVE",
    "dropdelcty": "GLYNDON",
    "dropdelst": "MD",
    "dropdelzpp": 210719998,
    "dropphyadd": "2 RAILROAD AVE",
    "dropphycty": "GLYNDON",
    "dropphyst": "MD",
    "dropphyzpp": 210719998,
    "dropmaladd": "2 RAILROAD AVE",
    "dropmalcty": "GLYNDON",
    "dropmalst": "MD",
    "dropmalzpp": 210719998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105173184,
    "dropsitcph": 4105173184,
    "dropfax": 4105173184
  },
  {
    "dcode": "D",
    "dropkey": "PV23579",
    "droptype": "D",
    "dropname": "GOLDSBORO",
    "dropdeladd": "507 OLDTOWN RD",
    "dropdelcty": "GOLDSBORO",
    "dropdelst": "MD",
    "dropdelzpp": 216369998,
    "dropphyadd": "507 OLDTOWN RD",
    "dropphycty": "GOLDSBORO",
    "dropphyst": "MD",
    "dropphyzpp": 216369998,
    "dropmaladd": "507 OLDTOWN RD",
    "dropmalcty": "GOLDSBORO",
    "dropmalst": "MD",
    "dropmalzpp": 216369998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104822134,
    "dropsitcph": 4104822134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23592",
    "droptype": "D",
    "dropname": "GRANTSVILLE",
    "dropdeladd": "159 MAIN ST",
    "dropdelcty": "GRANTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 215369998,
    "dropphyadd": "159 MAIN ST",
    "dropphycty": "GRANTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 215369998,
    "dropmaladd": "159 MAIN ST",
    "dropmalcty": "GRANTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 215369998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3108955608,
    "dropsitcph": 3018955608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23593",
    "droptype": "D",
    "dropname": "GRASONVILLE",
    "dropdeladd": "4307 MAIN ST",
    "dropdelcty": "GRASONVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216389998,
    "dropphyadd": "4307 MAIN ST",
    "dropphycty": "GRASONVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216389998,
    "dropmaladd": "4307 MAIN ST",
    "dropmalcty": "GRASONVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216389998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108277322,
    "dropsitcph": 4108277322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23596",
    "droptype": "D",
    "dropname": "GREAT MILLS",
    "dropdeladd": "20041 POINT LOOKOUT RD",
    "dropdelcty": "GREAT MILLS",
    "dropdelst": "MD",
    "dropdelzpp": 206349900,
    "dropphyadd": "20041 POINT LOOKOUT RD",
    "dropphycty": "GREAT MILLS",
    "dropphyst": "MD",
    "dropphyzpp": 206349900,
    "dropmaladd": "20041 POINT LOOKOUT RD",
    "dropmalcty": "GREAT MILLS",
    "dropmalst": "MD",
    "dropmalzpp": 206349900,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019942240,
    "dropsitcph": 3019942240,
    "dropfax": 3019949431
  },
  {
    "dcode": "D",
    "dropkey": "PV23602",
    "droptype": "D",
    "dropname": "GREENBELT",
    "dropdeladd": "7600 ORA GLEN DR",
    "dropdelcty": "GREENBELT",
    "dropdelst": "MD",
    "dropdelzpp": 207709998,
    "dropphyadd": "7600 ORA GLEN DR",
    "dropphycty": "GREENBELT",
    "dropphyst": "MD",
    "dropphyzpp": 207709998,
    "dropmaladd": "7600 ORA GLEN DR",
    "dropmalcty": "GREENBELT",
    "dropmalst": "MD",
    "dropmalzpp": 207709998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013451721,
    "dropsitcph": 3013451722,
    "dropfax": 3013453827
  },
  {
    "dcode": "D",
    "dropkey": "PV23609",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "202 W SUNSET AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "MD",
    "dropdelzpp": 216399998,
    "dropphyadd": "202 W SUNSET AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "MD",
    "dropphyzpp": 216399998,
    "dropmaladd": "202 W SUNSET AVE",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "MD",
    "dropmalzpp": 216399998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103474536,
    "dropsitcph": 4104828366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23622",
    "droptype": "D",
    "dropname": "HAGERSTOWN",
    "dropdeladd": "44 W FRANKLIN ST",
    "dropdelcty": "HAGERSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217409998,
    "dropphyadd": "44 W FRANKLIN ST",
    "dropphycty": "HAGERSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217409998,
    "dropmaladd": "44 W FRANKLIN ST",
    "dropmalcty": "HAGERSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217409998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3017978100,
    "dropsitcph": 3017978100,
    "dropfax": 3017971313
  },
  {
    "dcode": "D",
    "dropkey": "PV23629",
    "droptype": "D",
    "dropname": "HAMPSTEAD",
    "dropdeladd": "4229 N WOODS TRL",
    "dropdelcty": "HAMPSTEAD",
    "dropdelst": "MD",
    "dropdelzpp": 210743207,
    "dropphyadd": "4229 N WOODS TRL",
    "dropphycty": "HAMPSTEAD",
    "dropphyst": "MD",
    "dropphyzpp": 210743207,
    "dropmaladd": "4229 N WOODS TRL",
    "dropmalcty": "HAMPSTEAD",
    "dropmalst": "MD",
    "dropmalzpp": 210743207,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103743035,
    "dropsitcph": 4103743035,
    "dropfax": 4103740650
  },
  {
    "dcode": "D",
    "dropkey": "PV23637",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "210 N PENNSYLVANIA AVE",
    "dropdelcty": "HANCOCK",
    "dropdelst": "MD",
    "dropdelzpp": 217509998,
    "dropphyadd": "210 N PENNSYLVANIA AVE",
    "dropphycty": "HANCOCK",
    "dropphyst": "MD",
    "dropphyzpp": 217509998,
    "dropmaladd": "210 N PENNSYLVANIA AVE",
    "dropmalcty": "HANCOCK",
    "dropmalst": "MD",
    "dropmalzpp": 217509998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4106786116,
    "dropsitcph": 3016786116,
    "dropfax": 3016787811
  },
  {
    "dcode": "D",
    "dropkey": "PV23638",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "7476 NEW RIDGE RD STE G",
    "dropdelcty": "HANOVER",
    "dropdelst": "MD",
    "dropdelzpp": 210769998,
    "dropphyadd": "7476 NEW RIDGE RD STE G",
    "dropphycty": "HANOVER",
    "dropphyst": "MD",
    "dropphyzpp": 210769998,
    "dropmaladd": "7476 NEW RIDGE RD STE G",
    "dropmalcty": "HANOVER",
    "dropmalst": "MD",
    "dropmalzpp": 210769998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106940386,
    "dropsitcph": 4106940386,
    "dropfax": 4108507535
  },
  {
    "dcode": "D",
    "dropkey": "PV23662",
    "droptype": "D",
    "dropname": "HARWOOD",
    "dropdeladd": "4450 SOLOMONS ISLAND RD",
    "dropdelcty": "HARWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 207769998,
    "dropphyadd": "4450 SOLOMONS ISLAND RD",
    "dropphycty": "HARWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 207769998,
    "dropmaladd": "4450 SOLOMONS ISLAND RD",
    "dropmalcty": "HARWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 207769998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4108673184,
    "dropsitcph": 4108673800,
    "dropfax": 4108672408
  },
  {
    "dcode": "D",
    "dropkey": "PV23664",
    "droptype": "D",
    "dropname": "HAVRE DE GRACE",
    "dropdeladd": "301 N JUNIATA ST",
    "dropdelcty": "HAVRE DE GRACE",
    "dropdelst": "MD",
    "dropdelzpp": 210789998,
    "dropphyadd": "301 N JUNIATA ST",
    "dropphycty": "HAVRE DE GRACE",
    "dropphyst": "MD",
    "dropphyzpp": 210789998,
    "dropmaladd": "301 N JUNIATA ST",
    "dropmalcty": "HAVRE DE GRACE",
    "dropmalst": "MD",
    "dropmalzpp": 210789998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109399507,
    "dropsitcph": 4109399507,
    "dropfax": 4109395631
  },
  {
    "dcode": "D",
    "dropkey": "PV23669",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "MD",
    "dropdelzpp": 218309998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "HEBRON",
    "dropphyst": "MD",
    "dropphyzpp": 218309998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "MD",
    "dropmalzpp": 218309998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107428297,
    "dropsitcph": 4107428297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23672",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "321 BEE TREE RD",
    "dropdelcty": "HENDERSON",
    "dropdelst": "MD",
    "dropdelzpp": 216409998,
    "dropphyadd": "321 BEE TREE RD",
    "dropphycty": "HENDERSON",
    "dropphyst": "MD",
    "dropphyzpp": 216409998,
    "dropmaladd": "321 BEE TREE RD",
    "dropmalcty": "HENDERSON",
    "dropmalst": "MD",
    "dropmalzpp": 216409998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104828466,
    "dropsitcph": 4104828466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23685",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "12975 HIGHLAND RD",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "MD",
    "dropdelzpp": 207779998,
    "dropphyadd": "12975 HIGHLAND RD",
    "dropphycty": "HIGHLAND",
    "dropphyst": "MD",
    "dropphyzpp": 207779998,
    "dropmaladd": "12975 HIGHLAND RD",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "MD",
    "dropmalzpp": 207779998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018542418,
    "dropsitcph": 3018542418,
    "dropfax": 3018543054
  },
  {
    "dcode": "D",
    "dropkey": "PV23695",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "22043 MAIN ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "MD",
    "dropdelzpp": 216419998,
    "dropphyadd": "22043 MAIN ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "MD",
    "dropphyzpp": 216419998,
    "dropmaladd": "22043 MAIN ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "MD",
    "dropmalzpp": 216419998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103645588,
    "dropsitcph": 4103645588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23710",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "24351 MERVELL DEAN RD",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 206369997,
    "dropphyadd": "24351 MERVELL DEAN RD",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 206369997,
    "dropmaladd": "24351 MERVELL DEAN RD",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 206369997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013735215,
    "dropsitcph": 3013735215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23725",
    "droptype": "D",
    "dropname": "HUGHESVILLE",
    "dropdeladd": "15485 PRINCE FREDERICK RD",
    "dropdelcty": "HUGHESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 206379998,
    "dropphyadd": "15485 PRINCE FREDERICK RD",
    "dropphycty": "HUGHESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 206379998,
    "dropmaladd": "15485 PRINCE FREDERICK RD",
    "dropmalcty": "HUGHESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 206379998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012743133,
    "dropsitcph": 3012743133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23736",
    "droptype": "D",
    "dropname": "HUNTINGTOWN",
    "dropdeladd": "4020 OLD TOWN RD",
    "dropdelcty": "HUNTINGTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 206399998,
    "dropphyadd": "4020 OLD TOWN RD",
    "dropphycty": "HUNTINGTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 206399998,
    "dropmaladd": "4020 OLD TOWN RD",
    "dropmalcty": "HUNTINGTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 206399998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018551733,
    "dropsitcph": 4105359633,
    "dropfax": 4105359632
  },
  {
    "dcode": "D",
    "dropkey": "PV23739",
    "droptype": "D",
    "dropname": "HURLOCK",
    "dropdeladd": "111 POPLAR ST",
    "dropdelcty": "HURLOCK",
    "dropdelst": "MD",
    "dropdelzpp": 216439998,
    "dropphyadd": "111 POPLAR ST",
    "dropphycty": "HURLOCK",
    "dropphyst": "MD",
    "dropphyzpp": 216439998,
    "dropmaladd": "111 POPLAR ST",
    "dropmalcty": "HURLOCK",
    "dropmalst": "MD",
    "dropmalzpp": 216439998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109438569,
    "dropsitcph": 4109438569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23742",
    "droptype": "D",
    "dropname": "HYATTSVILLE",
    "dropdeladd": "4325 GALLATIN ST",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207812051,
    "dropphyadd": "4325 GALLATIN ST",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207812051,
    "dropmaladd": "4325 GALLATIN ST",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207812051,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012098901,
    "dropsitcph": 3012098901,
    "dropfax": 3018642065
  },
  {
    "dcode": "D",
    "dropkey": "PV23747",
    "droptype": "D",
    "dropname": "HYDES",
    "dropdeladd": "5237 HYDES RD",
    "dropdelcty": "HYDES",
    "dropdelst": "MD",
    "dropdelzpp": 210829998,
    "dropphyadd": "5237 HYDES RD",
    "dropphycty": "HYDES",
    "dropphyst": "MD",
    "dropphyzpp": 210829998,
    "dropmaladd": "5237 HYDES RD",
    "dropmalcty": "HYDES",
    "dropmalst": "MD",
    "dropmalzpp": 210829998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105926294,
    "dropsitcph": 4105926294,
    "dropfax": 4105926294
  },
  {
    "dcode": "D",
    "dropkey": "PV23751",
    "droptype": "D",
    "dropname": "INDIAN HEAD",
    "dropdeladd": "4050 INDIAN HEAD HWY",
    "dropdelcty": "INDIAN HEAD",
    "dropdelst": "MD",
    "dropdelzpp": 206409998,
    "dropphyadd": "4050 INDIAN HEAD HWY",
    "dropphycty": "INDIAN HEAD",
    "dropphyst": "MD",
    "dropphyzpp": 206409998,
    "dropmaladd": "4050 INDIAN HEAD HWY",
    "dropmalcty": "INDIAN HEAD",
    "dropmalst": "MD",
    "dropmalzpp": 206409998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017433911,
    "dropsitcph": 3017433911,
    "dropfax": 3017535224
  },
  {
    "dcode": "D",
    "dropkey": "PV23754",
    "droptype": "D",
    "dropname": "INGLESIDE",
    "dropdeladd": "2626 ROBERTS STATION RD",
    "dropdelcty": "INGLESIDE",
    "dropdelst": "MD",
    "dropdelzpp": 216449998,
    "dropphyadd": "2626 ROBERTS STATION RD",
    "dropphycty": "INGLESIDE",
    "dropphyst": "MD",
    "dropphyzpp": 216449998,
    "dropmaladd": "2626 ROBERTS STATION RD",
    "dropmalcty": "INGLESIDE",
    "dropmalst": "MD",
    "dropmalzpp": 216449998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107583489,
    "dropsitcph": 4107583489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23758",
    "droptype": "D",
    "dropname": "ISSUE",
    "dropdeladd": "15800 COBB ISLAND RD",
    "dropdelcty": "ISSUE",
    "dropdelst": "MD",
    "dropdelzpp": 206459998,
    "dropphyadd": "15800 COBB ISLAND RD",
    "dropphycty": "ISSUE",
    "dropphyst": "MD",
    "dropphyzpp": 206459998,
    "dropmaladd": "15800 COBB ISLAND RD",
    "dropmalcty": "ISSUE",
    "dropmalst": "MD",
    "dropmalzpp": 206459998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017437236,
    "dropsitcph": 3012592532,
    "dropfax": 3012590562
  },
  {
    "dcode": "D",
    "dropkey": "PV23762",
    "droptype": "D",
    "dropname": "JARRETTSVILLE",
    "dropdeladd": "3713 FEDERAL HILL RD",
    "dropdelcty": "JARRETTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210849998,
    "dropphyadd": "3713 FEDERAL HILL RD",
    "dropphycty": "JARRETTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210849998,
    "dropmaladd": "3713 FEDERAL HILL RD",
    "dropmalcty": "JARRETTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210849998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106920972,
    "dropsitcph": 4106920972,
    "dropfax": 4106926897
  },
  {
    "dcode": "D",
    "dropkey": "PV23763",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "3702 JEFFERSON PIKE",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "MD",
    "dropdelzpp": 217559998,
    "dropphyadd": "3702 JEFFERSON PIKE",
    "dropphycty": "JEFFERSON",
    "dropphyst": "MD",
    "dropphyzpp": 217559998,
    "dropmaladd": "3702 JEFFERSON PIKE",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "MD",
    "dropmalzpp": 217559998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014738484,
    "dropsitcph": 3014738484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23765",
    "droptype": "D",
    "dropname": "JESSUP",
    "dropdeladd": "2851 JESSUP RD",
    "dropdelcty": "JESSUP",
    "dropdelst": "MD",
    "dropdelzpp": 207949997,
    "dropphyadd": "2851 JESSUP RD",
    "dropphycty": "JESSUP",
    "dropphyst": "MD",
    "dropphyzpp": 207949997,
    "dropmaladd": "2851 JESSUP RD",
    "dropmalcty": "JESSUP",
    "dropmalst": "MD",
    "dropmalzpp": 207949997,
    "dropsitphn": 3014997331,
    "dropsitlph": 4107998140,
    "dropsitcph": 4107998140,
    "dropfax": 3016211724
  },
  {
    "dcode": "D",
    "dropkey": "PV23770",
    "droptype": "D",
    "dropname": "JOPPA",
    "dropdeladd": "906 JOPPA FARM RD",
    "dropdelcty": "JOPPA",
    "dropdelst": "MD",
    "dropdelzpp": 210859998,
    "dropphyadd": "906 JOPPA FARM RD",
    "dropphycty": "JOPPA",
    "dropphyst": "MD",
    "dropphyzpp": 210859998,
    "dropmaladd": "906 JOPPA FARM RD",
    "dropmalcty": "JOPPA",
    "dropmalst": "MD",
    "dropmalzpp": 210859998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106795395,
    "dropsitcph": 4106795395,
    "dropfax": 4106795758
  },
  {
    "dcode": "D",
    "dropkey": "PV23774",
    "droptype": "D",
    "dropname": "KEEDYSVILLE",
    "dropdeladd": "21 S MAIN ST",
    "dropdelcty": "KEEDYSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217569998,
    "dropphyadd": "21 S MAIN ST",
    "dropphycty": "KEEDYSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217569998,
    "dropmaladd": "21 S MAIN ST",
    "dropmalcty": "KEEDYSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217569998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014325636,
    "dropsitcph": 3014325636,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23782",
    "droptype": "D",
    "dropname": "KENNEDYVILLE",
    "dropdeladd": "11959 AUGUSTINE HERMAN HWY",
    "dropdelcty": "KENNEDYVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216459998,
    "dropphyadd": "11959 AUGUSTINE HERMAN HWY",
    "dropphycty": "KENNEDYVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216459998,
    "dropmaladd": "11959 AUGUSTINE HERMAN HWY",
    "dropmalcty": "KENNEDYVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216459998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103485913,
    "dropsitcph": 4103485913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23784",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "10325 KENSINGTON PKWY",
    "dropdelcty": "KENSINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 208959996,
    "dropphyadd": "10325 KENSINGTON PKWY",
    "dropphycty": "KENSINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 208959996,
    "dropmaladd": "10325 KENSINGTON PKWY",
    "dropmalcty": "KENSINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 208959996,
    "dropsitphn": 2026364480,
    "dropsitlph": 3019492863,
    "dropsitcph": 3019492863,
    "dropfax": 3019427312
  },
  {
    "dcode": "D",
    "dropkey": "PV23790",
    "droptype": "D",
    "dropname": "KEYMAR",
    "dropdeladd": "6747 MIDDLEBURG RD",
    "dropdelcty": "KEYMAR",
    "dropdelst": "MD",
    "dropdelzpp": 217579998,
    "dropphyadd": "6747 MIDDLEBURG RD",
    "dropphycty": "KEYMAR",
    "dropphyst": "MD",
    "dropphyzpp": 217579998,
    "dropmaladd": "6747 MIDDLEBURG RD",
    "dropmalcty": "KEYMAR",
    "dropmalst": "MD",
    "dropmalzpp": 217579998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107752262,
    "dropsitcph": 4107752262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23797",
    "droptype": "D",
    "dropname": "KINGSVILLE",
    "dropdeladd": "7363 SUNSHINE AVE",
    "dropdelcty": "KINGSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 210879998,
    "dropphyadd": "7363 SUNSHINE AVE",
    "dropphycty": "KINGSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 210879998,
    "dropmaladd": "7363 SUNSHINE AVE",
    "dropmalcty": "KINGSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 210879998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105923503,
    "dropsitcph": 4105923503,
    "dropfax": 4108174238
  },
  {
    "dcode": "D",
    "dropkey": "PV23799",
    "droptype": "D",
    "dropname": "KITZMILLER",
    "dropdeladd": "103 W CENTER ST",
    "dropdelcty": "KITZMILLER",
    "dropdelst": "MD",
    "dropdelzpp": 215389998,
    "dropphyadd": "103 W CENTER ST",
    "dropphycty": "KITZMILLER",
    "dropphyst": "MD",
    "dropphyzpp": 215389998,
    "dropmaladd": "103 W CENTER ST",
    "dropmalcty": "KITZMILLER",
    "dropmalst": "MD",
    "dropmalzpp": 215389998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3014533461,
    "dropsitcph": 3014533461,
    "dropfax": 3014533219
  },
  {
    "dcode": "D",
    "dropkey": "PV23806",
    "droptype": "D",
    "dropname": "LA PLATA",
    "dropdeladd": "100 CENTENNIAL ST",
    "dropdelcty": "LA PLATA",
    "dropdelst": "MD",
    "dropdelzpp": 206469998,
    "dropphyadd": "100 CENTENNIAL ST",
    "dropphycty": "LA PLATA",
    "dropphyst": "MD",
    "dropphyzpp": 206469998,
    "dropmaladd": "100 CENTENNIAL ST",
    "dropmalcty": "LA PLATA",
    "dropmalst": "MD",
    "dropmalzpp": 206469998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019348463,
    "dropsitcph": 3019348463,
    "dropfax": 3019342760
  },
  {
    "dcode": "D",
    "dropkey": "PV23827",
    "droptype": "D",
    "dropname": "LANHAM SEABROOK",
    "dropdeladd": "9801 LANHAM SEVERN RD",
    "dropdelcty": "LANHAM",
    "dropdelst": "MD",
    "dropdelzpp": 207069998,
    "dropphyadd": "9801 LANHAM SEVERN RD",
    "dropphycty": "LANHAM",
    "dropphyst": "MD",
    "dropphyzpp": 207069998,
    "dropmaladd": "9801 LANHAM SEVERN RD",
    "dropmalcty": "LANHAM",
    "dropmalst": "MD",
    "dropmalzpp": 207069998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015771843,
    "dropsitcph": 3014299195,
    "dropfax": 3015771678
  },
  {
    "dcode": "D",
    "dropkey": "PV23838",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "324 MAIN ST",
    "dropdelcty": "LAUREL",
    "dropdelst": "MD",
    "dropdelzpp": 207079995,
    "dropphyadd": "324 MAIN ST",
    "dropphycty": "LAUREL",
    "dropphyst": "MD",
    "dropphyzpp": 207079995,
    "dropmaladd": "123 WASHINGTON BLVD S",
    "dropmalcty": "LAUREL",
    "dropmalst": "MD",
    "dropmalzpp": 207079997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017252008,
    "dropsitcph": 3017252008,
    "dropfax": 3014830929
  },
  {
    "dcode": "D",
    "dropkey": "PV23857",
    "droptype": "D",
    "dropname": "LEONARDTOWN",
    "dropdeladd": "22735 WASHINGTON ST",
    "dropdelcty": "LEONARDTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 206509998,
    "dropphyadd": "22735 WASHINGTON ST",
    "dropphycty": "LEONARDTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 206509998,
    "dropmaladd": "22735 WASHINGTON ST",
    "dropmalcty": "LEONARDTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 206509998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014759781,
    "dropsitcph": 3014759781,
    "dropfax": 3014756679
  },
  {
    "dcode": "D",
    "dropkey": "PV23864",
    "droptype": "D",
    "dropname": "LEXINGTON PARK",
    "dropdeladd": "21745 S CORAL DR",
    "dropdelcty": "LEXINGTON PARK",
    "dropdelst": "MD",
    "dropdelzpp": 206539998,
    "dropphyadd": "21745 S CORAL DR",
    "dropphycty": "LEXINGTON PARK",
    "dropphyst": "MD",
    "dropphyzpp": 206539998,
    "dropmaladd": "21745 S CORAL DR",
    "dropmalcty": "LEXINGTON PARK",
    "dropmalst": "MD",
    "dropmalzpp": 206539998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018622380,
    "dropsitcph": 3018622380,
    "dropfax": 3018627893
  },
  {
    "dcode": "D",
    "dropkey": "PV23868",
    "droptype": "D",
    "dropname": "LIBERTYTOWN",
    "dropdeladd": "11941 MAIN ST",
    "dropdelcty": "LIBERTYTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217629998,
    "dropphyadd": "11941 MAIN ST",
    "dropphycty": "LIBERTYTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217629998,
    "dropmaladd": "11941 MAIN ST",
    "dropmalcty": "LIBERTYTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217629998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018987156,
    "dropsitcph": 3018987156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23873",
    "droptype": "D",
    "dropname": "LINKWOOD",
    "dropdeladd": "3843 OCEAN GTWY",
    "dropdelcty": "LINKWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 218359998,
    "dropphyadd": "3843 OCEAN GTWY",
    "dropphycty": "LINKWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 218359998,
    "dropmaladd": "3843 OCEAN GTWY",
    "dropmalcty": "LINKWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 218359998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102289027,
    "dropsitcph": 4102289027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23874",
    "droptype": "D",
    "dropname": "LINTHICUM HEIGHTS",
    "dropdeladd": "515 S CAMP MEADE RD",
    "dropdelcty": "LINTHICUM HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 210909998,
    "dropphyadd": "515 S CAMP MEADE RD",
    "dropphycty": "LINTHICUM HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 210909998,
    "dropmaladd": "515 S CAMP MEADE RD",
    "dropmalcty": "LINTHICUM HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 210909998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108599886,
    "dropsitcph": 4108599886,
    "dropfax": 4108593116
  },
  {
    "dcode": "D",
    "dropkey": "PV23876",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "1280 HOPKINS ALY",
    "dropdelcty": "LISBON",
    "dropdelst": "MD",
    "dropdelzpp": 217659998,
    "dropphyadd": "1280 HOPKINS ALY",
    "dropphycty": "LISBON",
    "dropphyst": "MD",
    "dropphyzpp": 217659998,
    "dropmaladd": "1280 HOPKINS ALY",
    "dropmalcty": "LISBON",
    "dropmalst": "MD",
    "dropmalzpp": 217659998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4104897177,
    "dropsitcph": 4104897177,
    "dropfax": 4104895922
  },
  {
    "dcode": "D",
    "dropkey": "PV23877",
    "droptype": "D",
    "dropname": "LITTLE ORLEANS",
    "dropdeladd": "32319 ROBY SCHOOL RD SE",
    "dropdelcty": "LITTLE ORLEANS",
    "dropdelst": "MD",
    "dropdelzpp": 217669998,
    "dropphyadd": "32319 ROBY SCHOOL RD SE",
    "dropphycty": "LITTLE ORLEANS",
    "dropphyst": "MD",
    "dropphyzpp": 217669998,
    "dropmaladd": "32319 ROBY SCHOOL RD SE",
    "dropmalcty": "LITTLE ORLEANS",
    "dropmalst": "MD",
    "dropmalzpp": 217669998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014782840,
    "dropsitcph": 3014782840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23883",
    "droptype": "D",
    "dropname": "LONACONING",
    "dropdeladd": "9 E MAIN ST",
    "dropdelcty": "LONACONING",
    "dropdelst": "MD",
    "dropdelzpp": 215399998,
    "dropphyadd": "9 E MAIN ST",
    "dropphycty": "LONACONING",
    "dropphyst": "MD",
    "dropphyzpp": 215399998,
    "dropmaladd": "9 E MAIN ST",
    "dropmalcty": "LONACONING",
    "dropmalst": "MD",
    "dropmalzpp": 215399998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3014632666,
    "dropsitcph": 3014632666,
    "dropfax": 3014632488
  },
  {
    "dcode": "D",
    "dropkey": "PV23890",
    "droptype": "D",
    "dropname": "LOTHIAN",
    "dropdeladd": "5471 SOUTHERN MARYLAND BLVD",
    "dropdelcty": "LOTHIAN",
    "dropdelst": "MD",
    "dropdelzpp": 207119998,
    "dropphyadd": "5471 SOUTHERN MARYLAND BLVD",
    "dropphycty": "LOTHIAN",
    "dropphyst": "MD",
    "dropphyzpp": 207119998,
    "dropmaladd": "5471 SOUTHERN MARYLAND BLVD",
    "dropmalcty": "LOTHIAN",
    "dropmalst": "MD",
    "dropmalzpp": 207119998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4107410039,
    "dropsitcph": 3015743558,
    "dropfax": 4107410043
  },
  {
    "dcode": "D",
    "dropkey": "PV23893",
    "droptype": "D",
    "dropname": "LOVEVILLE",
    "dropdeladd": "27770 POINT LOOKOUT RD",
    "dropdelcty": "LOVEVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 206569998,
    "dropphyadd": "27770 POINT LOOKOUT RD",
    "dropphycty": "LOVEVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 206569998,
    "dropmaladd": "27770 POINT LOOKOUT RD",
    "dropmalcty": "LOVEVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 206569998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014755243,
    "dropsitcph": 3014755243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23899",
    "droptype": "D",
    "dropname": "LUSBY",
    "dropdeladd": "11575 LUSBY LN",
    "dropdelcty": "LUSBY",
    "dropdelst": "MD",
    "dropdelzpp": 206579998,
    "dropphyadd": "11575 LUSBY LN",
    "dropphycty": "LUSBY",
    "dropphyst": "MD",
    "dropphyzpp": 206579998,
    "dropmaladd": "11575 LUSBY LN",
    "dropmalcty": "LUSBY",
    "dropmalst": "MD",
    "dropmalzpp": 206579998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4103264406,
    "dropsitcph": 4103264406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23901",
    "droptype": "D",
    "dropname": "LUTHERVILLE TIMONIUM",
    "dropdeladd": "9603 DEERECO RD",
    "dropdelcty": "LUTHERVILLE TIMONIUM",
    "dropdelst": "MD",
    "dropdelzpp": 210939998,
    "dropphyadd": "9603 DEERECO RD",
    "dropphycty": "LUTHERVILLE TIMONIUM",
    "dropphyst": "MD",
    "dropphyzpp": 210939998,
    "dropmaladd": "9603 DEERECO RD",
    "dropmalcty": "LUTHERVILLE TIMONIUM",
    "dropmalst": "MD",
    "dropmalzpp": 210939998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102520741,
    "dropsitcph": 4102520741,
    "dropfax": 4105606399
  },
  {
    "dcode": "D",
    "dropkey": "PV23908",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "99 FORT HOYLE RD",
    "dropdelcty": "JOPPA",
    "dropdelst": "MD",
    "dropdelzpp": 210855000,
    "dropphyadd": "99 FORT HOYLE RD",
    "dropphycty": "JOPPA",
    "dropphyst": "MD",
    "dropphyzpp": 210855000,
    "dropmaladd": "99 FORT HOYLE RD",
    "dropmalcty": "JOPPA",
    "dropmalst": "MD",
    "dropmalzpp": 210855000,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106766610,
    "dropsitcph": 4106766610,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23913",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "3100 WESTMINSTER ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "MD",
    "dropdelzpp": 211029998,
    "dropphyadd": "3100 WESTMINSTER ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "MD",
    "dropphyzpp": 211029998,
    "dropmaladd": "3100 WESTMINSTER ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "MD",
    "dropmalzpp": 211029998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103740586,
    "dropsitcph": 4103740586,
    "dropfax": 4103741558
  },
  {
    "dcode": "D",
    "dropkey": "PV23920",
    "droptype": "D",
    "dropname": "MARBURY",
    "dropdeladd": "4570 BICKNELL RD",
    "dropdelcty": "MARBURY",
    "dropdelst": "MD",
    "dropdelzpp": 206589998,
    "dropphyadd": "4570 BICKNELL RD",
    "dropphycty": "MARBURY",
    "dropphyst": "MD",
    "dropphyzpp": 206589998,
    "dropmaladd": "4570 BICKNELL RD",
    "dropmalcty": "MARBURY",
    "dropmalst": "MD",
    "dropmalzpp": 206589998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017538756,
    "dropsitcph": 3017538756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23921",
    "droptype": "D",
    "dropname": "MARDELA SPRINGS",
    "dropdeladd": "301 RAILROAD AVE",
    "dropdelcty": "MARDELA SPRINGS",
    "dropdelst": "MD",
    "dropdelzpp": 218379998,
    "dropphyadd": "301 RAILROAD AVE",
    "dropphycty": "MARDELA SPRINGS",
    "dropphyst": "MD",
    "dropphyzpp": 218379998,
    "dropmaladd": "301 RAILROAD AVE",
    "dropmalcty": "MARDELA SPRINGS",
    "dropmalst": "MD",
    "dropmalzpp": 218379998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4105469050,
    "dropsitcph": 4105469050,
    "dropfax": 4105464145
  },
  {
    "dcode": "D",
    "dropkey": "PV23924",
    "droptype": "D",
    "dropname": "MARION STATION",
    "dropdeladd": "28530 HUDSON CORNER RD",
    "dropdelcty": "MARION STATION",
    "dropdelst": "MD",
    "dropdelzpp": 218389998,
    "dropphyadd": "28530 HUDSON CORNER RD",
    "dropphycty": "MARION STATION",
    "dropphyst": "MD",
    "dropphyzpp": 218389998,
    "dropmaladd": "28530 HUDSON CORNER RD",
    "dropmalcty": "MARION STATION",
    "dropmalst": "MD",
    "dropmalzpp": 218389998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106238270,
    "dropsitcph": 4106238270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23935",
    "droptype": "D",
    "dropname": "MARYDEL",
    "dropdeladd": "114 HALLTOWN RD",
    "dropdelcty": "MARYDEL",
    "dropdelst": "MD",
    "dropdelzpp": 216499998,
    "dropphyadd": "114 HALLTOWN RD",
    "dropphycty": "MARYDEL",
    "dropphyst": "MD",
    "dropphyzpp": 216499998,
    "dropmaladd": "114 HALLTOWN RD",
    "dropmalcty": "MARYDEL",
    "dropmalst": "MD",
    "dropmalzpp": 216499998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104828081,
    "dropsitcph": 4104828081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23938",
    "droptype": "D",
    "dropname": "MARYLAND LINE",
    "dropdeladd": "21400 YORK RD",
    "dropdelcty": "MARYLAND LINE",
    "dropdelst": "MD",
    "dropdelzpp": 211052101,
    "dropphyadd": "21400 YORK RD",
    "dropphycty": "MARYLAND LINE",
    "dropphyst": "MD",
    "dropphyzpp": 211052101,
    "dropmaladd": "21400 YORK RD",
    "dropmalcty": "MARYLAND LINE",
    "dropmalst": "MD",
    "dropmalzpp": 211052101,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103433064,
    "dropsitcph": 4103433064,
    "dropfax": 4103570504
  },
  {
    "dcode": "D",
    "dropkey": "PV23940",
    "droptype": "D",
    "dropname": "MASSEY",
    "dropdeladd": "12139 GALENA RD",
    "dropdelcty": "MASSEY",
    "dropdelst": "MD",
    "dropdelzpp": 216509998,
    "dropphyadd": "12139 GALENA RD",
    "dropphycty": "MASSEY",
    "dropphyst": "MD",
    "dropphyzpp": 216509998,
    "dropmaladd": "12139 GALENA RD",
    "dropmalcty": "MASSEY",
    "dropmalst": "MD",
    "dropmalzpp": 216509998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109285380,
    "dropsitcph": 4109285380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23941",
    "droptype": "D",
    "dropname": "MAUGANSVILLE",
    "dropdeladd": "13809 MAUGANSVILLE RD",
    "dropdelcty": "MAUGANSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217679998,
    "dropphyadd": "13809 MAUGANSVILLE RD",
    "dropphycty": "MAUGANSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217679998,
    "dropmaladd": "13809 MAUGANSVILLE RD",
    "dropmalcty": "MAUGANSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217679998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4103474536,
    "dropsitcph": 3017972131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23947",
    "droptype": "D",
    "dropname": "MAYO",
    "dropdeladd": "1157 MAYO RD",
    "dropdelcty": "MAYO",
    "dropdelst": "MD",
    "dropdelzpp": 211069998,
    "dropphyadd": "1157 MAYO RD",
    "dropphycty": "MAYO",
    "dropphyst": "MD",
    "dropphyzpp": 211069998,
    "dropmaladd": "1157 MAYO RD",
    "dropmalcty": "MAYO",
    "dropmalst": "MD",
    "dropmalzpp": 211069998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4432030152,
    "dropsitcph": 4432030152,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV23949",
    "droptype": "D",
    "dropname": "MC HENRY",
    "dropdeladd": "1914 DEEP CREEK DR",
    "dropdelcty": "MC HENRY",
    "dropdelst": "MD",
    "dropdelzpp": 215419998,
    "dropphyadd": "1914 DEEP CREEK DR",
    "dropphycty": "MC HENRY",
    "dropphyst": "MD",
    "dropphyzpp": 215419998,
    "dropmaladd": "1914 DEEP CREEK DR",
    "dropmalcty": "MC HENRY",
    "dropmalst": "MD",
    "dropmalzpp": 215419998,
    "dropsitphn": 3017228194,
    "dropsitlph": 4103875902,
    "dropsitcph": 3013875902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23958",
    "droptype": "D",
    "dropname": "MECHANICSVILLE",
    "dropdeladd": "28948 THREE NOTCH RD",
    "dropdelcty": "MECHANICSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 206599998,
    "dropphyadd": "28948 THREE NOTCH RD",
    "dropphycty": "MECHANICSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 206599998,
    "dropmaladd": "28948 THREE NOTCH RD",
    "dropmalcty": "MECHANICSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 206599998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018843013,
    "dropsitcph": 3018843013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23973",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "7227 HOLLOW RD",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217699998,
    "dropphyadd": "7227 HOLLOW RD",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217699998,
    "dropmaladd": "7227 HOLLOW RD",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217699998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3013716880,
    "dropsitcph": 3013716880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23976",
    "droptype": "D",
    "dropname": "MIDLOTHIAN",
    "dropdeladd": "19911 OLD MIDLOTHIAN RD SW",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "MD",
    "dropdelzpp": 215439998,
    "dropphyadd": "19911 OLD MIDLOTHIAN RD SW",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "MD",
    "dropphyzpp": 215439998,
    "dropmaladd": "19911 OLD MIDLOTHIAN RD SW",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "MD",
    "dropmalzpp": 215439998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3016898143,
    "dropsitcph": 3016898143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23983",
    "droptype": "D",
    "dropname": "MILLERSVILLE",
    "dropdeladd": "221 NAJOLES RD",
    "dropdelcty": "MILLERSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 211089998,
    "dropphyadd": "221 NAJOLES RD",
    "dropphycty": "MILLERSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 211089998,
    "dropmaladd": "221 NAJOLES RD",
    "dropmalcty": "MILLERSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 211089998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109873468,
    "dropsitcph": 4109873468,
    "dropfax": 4107290323
  },
  {
    "dcode": "D",
    "dropkey": "PV23984",
    "droptype": "D",
    "dropname": "MILLINGTON",
    "dropdeladd": "412 CYPRESS ST",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 216519998,
    "dropphyadd": "412 CYPRESS ST",
    "dropphycty": "MILLINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 216519998,
    "dropmaladd": "412 CYPRESS ST",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 216519998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109283909,
    "dropsitcph": 4109283909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV23989",
    "droptype": "D",
    "dropname": "MONKTON",
    "dropdeladd": "16944 YORK RD",
    "dropdelcty": "MONKTON",
    "dropdelst": "MD",
    "dropdelzpp": 211119998,
    "dropphyadd": "16944 YORK RD",
    "dropphycty": "MONKTON",
    "dropphyst": "MD",
    "dropphyzpp": 211119998,
    "dropmaladd": "16944 YORK RD",
    "dropmalcty": "MONKTON",
    "dropmalst": "MD",
    "dropmalzpp": 211119998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103578869,
    "dropsitcph": 4103578869,
    "dropfax": 4103579551
  },
  {
    "dcode": "D",
    "dropkey": "PV23990",
    "droptype": "D",
    "dropname": "MONROVIA",
    "dropdeladd": "4411 GREEN VALLEY RD",
    "dropdelcty": "MONROVIA",
    "dropdelst": "MD",
    "dropdelzpp": 217709998,
    "dropphyadd": "4411 GREEN VALLEY RD",
    "dropphycty": "MONROVIA",
    "dropphyst": "MD",
    "dropphyzpp": 217709998,
    "dropmaladd": "4411 GREEN VALLEY RD",
    "dropmalcty": "MONROVIA",
    "dropmalst": "MD",
    "dropmalzpp": 217709998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018655432,
    "dropsitcph": 3018655432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24004",
    "droptype": "D",
    "dropname": "MORGANZA",
    "dropdeladd": "39600 DOCTOR JOHNSON RD",
    "dropdelcty": "MORGANZA",
    "dropdelst": "MD",
    "dropdelzpp": 206609998,
    "dropphyadd": "39600 DOCTOR JOHNSON RD",
    "dropphycty": "MORGANZA",
    "dropphyst": "MD",
    "dropphyzpp": 206609998,
    "dropmaladd": "39600 DOCTOR JOHNSON RD",
    "dropmalcty": "MORGANZA",
    "dropmalst": "MD",
    "dropmalzpp": 206609998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014759858,
    "dropsitcph": 3014759858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24008",
    "droptype": "D",
    "dropname": "MOUNT AIRY",
    "dropdeladd": "505 WINDY KNOLL DR",
    "dropdelcty": "MOUNT AIRY",
    "dropdelst": "MD",
    "dropdelzpp": 217719998,
    "dropphyadd": "505 WINDY KNOLL DR",
    "dropphycty": "MOUNT AIRY",
    "dropphyst": "MD",
    "dropphyzpp": 217719998,
    "dropmaladd": "505 WINDY KNOLL DR",
    "dropmalcty": "MOUNT AIRY",
    "dropmalst": "MD",
    "dropmalzpp": 217719998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018291199,
    "dropsitcph": 3018291199,
    "dropfax": 3018293627
  },
  {
    "dcode": "D",
    "dropkey": "PV24014",
    "droptype": "D",
    "dropname": "MOUNT RAINIER",
    "dropdeladd": "3709 RHODE ISLAND AVE",
    "dropdelcty": "MOUNT RAINIER",
    "dropdelst": "MD",
    "dropdelzpp": 207129998,
    "dropphyadd": "3709 RHODE ISLAND AVE",
    "dropphycty": "MOUNT RAINIER",
    "dropphyst": "MD",
    "dropphyzpp": 207129998,
    "dropmaladd": "3709 RHODE ISLAND AVE",
    "dropmalcty": "MOUNT RAINIER",
    "dropmalst": "MD",
    "dropmalzpp": 207129998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018645168,
    "dropsitcph": 3016998856,
    "dropfax": 3012771451
  },
  {
    "dcode": "D",
    "dropkey": "PV24016",
    "droptype": "D",
    "dropname": "MOUNT SAVAGE",
    "dropdeladd": "12700 NEW SCHOOL RD NW",
    "dropdelcty": "MOUNT SAVAGE",
    "dropdelst": "MD",
    "dropdelzpp": 215459998,
    "dropphyadd": "12700 NEW SCHOOL RD NW",
    "dropphycty": "MOUNT SAVAGE",
    "dropphyst": "MD",
    "dropphyzpp": 215459998,
    "dropmaladd": "12700 NEW SCHOOL RD NW",
    "dropmalcty": "MOUNT SAVAGE",
    "dropmalst": "MD",
    "dropmalzpp": 215459998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3012643476,
    "dropsitcph": 3012643476,
    "dropfax": 3012643476
  },
  {
    "dcode": "D",
    "dropkey": "PV24017",
    "droptype": "D",
    "dropname": "MOUNT VICTORIA",
    "dropdeladd": "12085 MOUNT VICTORIA RD",
    "dropdelcty": "MOUNT VICTORIA",
    "dropdelst": "MD",
    "dropdelzpp": 206619998,
    "dropphyadd": "12085 MOUNT VICTORIA RD",
    "dropphycty": "MOUNT VICTORIA",
    "dropphyst": "MD",
    "dropphyzpp": 206619998,
    "dropmaladd": "12085 MOUNT VICTORIA RD",
    "dropmalcty": "MOUNT VICTORIA",
    "dropmalst": "MD",
    "dropmalzpp": 206619998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012594637,
    "dropsitcph": 3012594637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24030",
    "droptype": "D",
    "dropname": "MYERSVILLE",
    "dropdeladd": "1 WOLFSVILLE RD",
    "dropdelcty": "MYERSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217739998,
    "dropphyadd": "1 WOLFSVILLE RD",
    "dropphycty": "MYERSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217739998,
    "dropmaladd": "1 WOLFSVILLE RD",
    "dropmalcty": "MYERSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217739998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3012931180,
    "dropsitcph": 3012931180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24036",
    "droptype": "D",
    "dropname": "NANJEMOY",
    "dropdeladd": "9365 BEAVERDAM RD",
    "dropdelcty": "NANJEMOY",
    "dropdelst": "MD",
    "dropdelzpp": 206629998,
    "dropphyadd": "9365 BEAVERDAM RD",
    "dropphycty": "NANJEMOY",
    "dropphyst": "MD",
    "dropphyzpp": 206629998,
    "dropmaladd": "9365 BEAVERDAM RD",
    "dropmalcty": "NANJEMOY",
    "dropmalst": "MD",
    "dropmalzpp": 206629998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017435029,
    "dropsitcph": 3017435029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24037",
    "droptype": "D",
    "dropname": "NANTICOKE",
    "dropdeladd": "20501 NANTICOKE RD",
    "dropdelcty": "NANTICOKE",
    "dropdelst": "MD",
    "dropdelzpp": 218409998,
    "dropphyadd": "20501 NANTICOKE RD",
    "dropphycty": "NANTICOKE",
    "dropphyst": "MD",
    "dropphyzpp": 218409998,
    "dropmaladd": "20501 NANTICOKE RD",
    "dropmalcty": "NANTICOKE",
    "dropmalst": "MD",
    "dropmalzpp": 218409998,
    "dropsitphn": 3017637740,
    "dropsitlph": 4108732711,
    "dropsitcph": 4108732711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24048",
    "droptype": "D",
    "dropname": "NEAVITT",
    "dropdeladd": "6405 BOZMAN NEAVITT RD",
    "dropdelcty": "NEAVITT",
    "dropdelst": "MD",
    "dropdelzpp": 216529998,
    "dropphyadd": "6405 BOZMAN NEAVITT RD",
    "dropphycty": "NEAVITT",
    "dropphyst": "MD",
    "dropphyzpp": 216529998,
    "dropmaladd": "7983 QUAKER NECK RD",
    "dropmalcty": "BOZMAN",
    "dropmalst": "MD",
    "dropmalzpp": 216129998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107455653,
    "dropsitcph": 4107455653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24056",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "168 W MAIN ST",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "MD",
    "dropdelzpp": 217749998,
    "dropphyadd": "168 W MAIN ST",
    "dropphycty": "NEW MARKET",
    "dropphyst": "MD",
    "dropphyzpp": 217749998,
    "dropmaladd": "168 W MAIN ST",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "MD",
    "dropmalzpp": 217749998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018653333,
    "dropsitcph": 3018653333,
    "dropfax": 3018654589
  },
  {
    "dcode": "D",
    "dropkey": "PV24057",
    "droptype": "D",
    "dropname": "NEW MIDWAY",
    "dropdeladd": "12048A WOODSBORO PIKE",
    "dropdelcty": "NEW MIDWAY",
    "dropdelst": "MD",
    "dropdelzpp": 217759998,
    "dropphyadd": "12048A WOODSBORO PIKE",
    "dropphycty": "NEW MIDWAY",
    "dropphyst": "MD",
    "dropphyzpp": 217759998,
    "dropmaladd": "12048A WOODSBORO PIKE",
    "dropmalcty": "NEW MIDWAY",
    "dropmalst": "MD",
    "dropmalzpp": 217759998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018452145,
    "dropsitcph": 3018452145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24058",
    "droptype": "D",
    "dropname": "NEW WINDSOR",
    "dropdeladd": "204 MAPLE AVE",
    "dropdelcty": "NEW WINDSOR",
    "dropdelst": "MD",
    "dropdelzpp": 217769998,
    "dropphyadd": "204 MAPLE AVE",
    "dropphycty": "NEW WINDSOR",
    "dropphyst": "MD",
    "dropphyzpp": 217769998,
    "dropmaladd": "204 MAPLE AVE",
    "dropmalcty": "NEW WINDSOR",
    "dropmalst": "MD",
    "dropmalzpp": 217769998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4103474536,
    "dropsitcph": 4106352151,
    "dropfax": 4106352400
  },
  {
    "dcode": "D",
    "dropkey": "PV24059",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "8420 NEWARK RD",
    "dropdelcty": "NEWARK",
    "dropdelst": "MD",
    "dropdelzpp": 218419998,
    "dropphyadd": "8420 NEWARK RD",
    "dropphycty": "NEWARK",
    "dropphyst": "MD",
    "dropphyzpp": 218419998,
    "dropmaladd": "8420 NEWARK RD",
    "dropmalcty": "NEWARK",
    "dropmalst": "MD",
    "dropmalzpp": 218419998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106323312,
    "dropsitcph": 4106323312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24060",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "12179 ROCK POINT RD",
    "dropdelcty": "NEWBURG",
    "dropdelst": "MD",
    "dropdelzpp": 206649998,
    "dropphyadd": "12179 ROCK POINT RD",
    "dropphycty": "NEWBURG",
    "dropphyst": "MD",
    "dropphyzpp": 206649998,
    "dropmaladd": "12179 ROCK POINT RD",
    "dropmalcty": "NEWBURG",
    "dropmalst": "MD",
    "dropmalzpp": 206649998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012592527,
    "dropsitcph": 3012592527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24061",
    "droptype": "D",
    "dropname": "NEWCOMB",
    "dropdeladd": "7414 BACK ST",
    "dropdelcty": "NEWCOMB",
    "dropdelst": "MD",
    "dropdelzpp": 216539998,
    "dropphyadd": "7414 BACK ST",
    "dropphycty": "NEWCOMB",
    "dropphyst": "MD",
    "dropphyzpp": 216539998,
    "dropmaladd": "7414 BACK ST",
    "dropmalcty": "NEWCOMB",
    "dropmalst": "MD",
    "dropmalzpp": 216539998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107453116,
    "dropsitcph": 4107453116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24064",
    "droptype": "D",
    "dropname": "NIKEP",
    "dropdeladd": "17000 LOWER GEORGES CREEK RD SW",
    "dropdelcty": "LONACONING",
    "dropdelst": "MD",
    "dropdelzpp": 215391121,
    "dropphyadd": "17000 LOWER GEORGES CREEK RD SW",
    "dropphycty": "LONACONING",
    "dropphyst": "MD",
    "dropphyzpp": 215391121,
    "dropmaladd": "17000 LOWER GEORGES CREEK RD SW",
    "dropmalcty": "LONACONING",
    "dropmalst": "MD",
    "dropmalzpp": 215391121,
    "dropsitphn": 3017228194,
    "dropsitlph": 4104632666,
    "dropsitcph": 3014632666,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24069",
    "droptype": "D",
    "dropname": "NORTH BEACH",
    "dropdeladd": "9132A BAY AVE",
    "dropdelcty": "NORTH BEACH",
    "dropdelst": "MD",
    "dropdelzpp": 207149998,
    "dropphyadd": "9132A BAY AVE",
    "dropphycty": "NORTH BEACH",
    "dropphyst": "MD",
    "dropphyzpp": 207149998,
    "dropmaladd": "9132A BAY AVE",
    "dropmalcty": "NORTH BEACH",
    "dropmalst": "MD",
    "dropmalzpp": 207149998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018121597,
    "dropsitcph": 3018121597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24077",
    "droptype": "D",
    "dropname": "NORTH EAST",
    "dropdeladd": "406 S MAIN ST",
    "dropdelcty": "NORTH EAST",
    "dropdelst": "MD",
    "dropdelzpp": 219019998,
    "dropphyadd": "406 S MAIN ST",
    "dropphycty": "NORTH EAST",
    "dropphyst": "MD",
    "dropphyzpp": 219019998,
    "dropmaladd": "406 S MAIN ST",
    "dropmalcty": "NORTH EAST",
    "dropmalst": "MD",
    "dropmalzpp": 219019998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102876644,
    "dropsitcph": 4102876644,
    "dropfax": 4102872822
  },
  {
    "dcode": "D",
    "dropkey": "PV24104",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "22 S 2ND ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215509998,
    "dropphyadd": "22 S 2ND ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215509998,
    "dropmaladd": "22 S 2ND ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215509998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013343151,
    "dropsitcph": 3013343151,
    "dropfax": 3013343224
  },
  {
    "dcode": "D",
    "dropkey": "PV24110",
    "droptype": "D",
    "dropname": "OCEAN CITY",
    "dropdeladd": "7101 COASTAL HWY",
    "dropdelcty": "OCEAN CITY",
    "dropdelst": "MD",
    "dropdelzpp": 218429998,
    "dropphyadd": "7101 COASTAL HWY",
    "dropphycty": "OCEAN CITY",
    "dropphyst": "MD",
    "dropphyzpp": 218429998,
    "dropmaladd": "7101 COASTAL HWY",
    "dropmalcty": "OCEAN CITY",
    "dropmalst": "MD",
    "dropmalzpp": 218429998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4105247611,
    "dropsitcph": 4105247611,
    "dropfax": 4105244978
  },
  {
    "dcode": "D",
    "dropkey": "PV24111",
    "droptype": "D",
    "dropname": "ODENTON",
    "dropdeladd": "1177 ANNAPOLIS RD",
    "dropdelcty": "ODENTON",
    "dropdelst": "MD",
    "dropdelzpp": 211139998,
    "dropphyadd": "1177 ANNAPOLIS RD",
    "dropphycty": "ODENTON",
    "dropphyst": "MD",
    "dropphyzpp": 211139998,
    "dropmaladd": "1177 ANNAPOLIS RD",
    "dropmalcty": "ODENTON",
    "dropmalst": "MD",
    "dropmalzpp": 211139998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105512520,
    "dropsitcph": 4105512520,
    "dropfax": 4106743156
  },
  {
    "dcode": "D",
    "dropkey": "PV24116",
    "droptype": "D",
    "dropname": "OLDTOWN",
    "dropdeladd": "19104 OPESSA ST SE",
    "dropdelcty": "OLDTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 215559998,
    "dropphyadd": "19104 OPESSA ST SE",
    "dropphycty": "OLDTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 215559998,
    "dropmaladd": "19104 OPESSA ST SE",
    "dropmalcty": "OLDTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 215559998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3014785601,
    "dropsitcph": 3014785601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24118",
    "droptype": "D",
    "dropname": "OLNEY",
    "dropdeladd": "3570 OLNEY LAYTONSVILLE RD",
    "dropdelcty": "OLNEY",
    "dropdelst": "MD",
    "dropdelzpp": 208329998,
    "dropphyadd": "3570 OLNEY LAYTONSVILLE RD",
    "dropphycty": "OLNEY",
    "dropphyst": "MD",
    "dropphyzpp": 208329998,
    "dropmaladd": "3570 OLNEY LAYTONSVILLE RD",
    "dropmalcty": "OLNEY",
    "dropmalst": "MD",
    "dropmalzpp": 208329998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017742973,
    "dropsitcph": 3012609013,
    "dropfax": 3017742134
  },
  {
    "dcode": "D",
    "dropkey": "PV24124",
    "droptype": "D",
    "dropname": "OWINGS",
    "dropdeladd": "9440 OLD SOLOMONS ISLAND RD",
    "dropdelcty": "OWINGS",
    "dropdelst": "MD",
    "dropdelzpp": 207369997,
    "dropphyadd": "9440 OLD SOLOMONS ISLAND RD",
    "dropphycty": "OWINGS",
    "dropphyst": "MD",
    "dropphyzpp": 207369997,
    "dropmaladd": "9440 OLD SOLOMONS ISLAND RD",
    "dropmalcty": "OWINGS",
    "dropmalst": "MD",
    "dropmalzpp": 207369997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018122652,
    "dropsitcph": 3018122652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24125",
    "droptype": "D",
    "dropname": "OWINGS MILLS",
    "dropdeladd": "10821 RED RUN BLVD",
    "dropdelcty": "OWINGS MILLS",
    "dropdelst": "MD",
    "dropdelzpp": 211179998,
    "dropphyadd": "10821 RED RUN BLVD",
    "dropphycty": "OWINGS MILLS",
    "dropphyst": "MD",
    "dropphyzpp": 211179998,
    "dropmaladd": "10821 RED RUN BLVD",
    "dropmalcty": "OWINGS MILLS",
    "dropmalst": "MD",
    "dropmalzpp": 211179998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103940137,
    "dropsitcph": 4433940137,
    "dropfax": 4106549630
  },
  {
    "dcode": "D",
    "dropkey": "PV24127",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "101 WILSON ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "MD",
    "dropdelzpp": 216549998,
    "dropphyadd": "101 WILSON ST",
    "dropphycty": "OXFORD",
    "dropphyst": "MD",
    "dropphyzpp": 216549998,
    "dropmaladd": "101 WILSON ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "MD",
    "dropmalzpp": 216549998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102265629,
    "dropsitcph": 4102265629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24134",
    "droptype": "D",
    "dropname": "PARK HALL",
    "dropdeladd": "18400 POINT LOOKOUT RD",
    "dropdelcty": "PARK HALL",
    "dropdelst": "MD",
    "dropdelzpp": 206679998,
    "dropphyadd": "18400 POINT LOOKOUT RD",
    "dropphycty": "PARK HALL",
    "dropphyst": "MD",
    "dropphyzpp": 206679998,
    "dropmaladd": "18400 POINT LOOKOUT RD",
    "dropmalcty": "PARK HALL",
    "dropmalst": "MD",
    "dropmalzpp": 206679998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018624033,
    "dropsitcph": 3018624033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24137",
    "droptype": "D",
    "dropname": "PARKTON",
    "dropdeladd": "645 HAPPY LN",
    "dropdelcty": "PARKTON",
    "dropdelst": "MD",
    "dropdelzpp": 211209998,
    "dropphyadd": "645 HAPPY LN",
    "dropphycty": "PARKTON",
    "dropphyst": "MD",
    "dropphyzpp": 211209998,
    "dropmaladd": "645 HAPPY LN",
    "dropmalcty": "PARKTON",
    "dropmalst": "MD",
    "dropmalzpp": 211209998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103579255,
    "dropsitcph": 4103579255,
    "dropfax": 4103579066
  },
  {
    "dcode": "D",
    "dropkey": "PV24141",
    "droptype": "D",
    "dropname": "PARSONSBURG",
    "dropdeladd": "7237 PARSONSBURG RD",
    "dropdelcty": "PARSONSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 218499998,
    "dropphyadd": "7237 PARSONSBURG RD",
    "dropphycty": "PARSONSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 218499998,
    "dropmaladd": "7237 PARSONSBURG RD",
    "dropmalcty": "PARSONSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 218499998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107491783,
    "dropsitcph": 4107491783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24142",
    "droptype": "D",
    "dropname": "PASADENA",
    "dropdeladd": "4301 MOUNTAIN RD",
    "dropdelcty": "PASADENA",
    "dropdelst": "MD",
    "dropdelzpp": 211229998,
    "dropphyadd": "4301 MOUNTAIN RD",
    "dropphycty": "PASADENA",
    "dropphyst": "MD",
    "dropphyzpp": 211229998,
    "dropmaladd": "4301 MOUNTAIN RD",
    "dropmalcty": "PASADENA",
    "dropmalst": "MD",
    "dropmalzpp": 211229998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4436375320,
    "dropsitcph": 4436375320,
    "dropfax": 4104399166
  },
  {
    "dcode": "D",
    "dropkey": "PV24150",
    "droptype": "D",
    "dropname": "PATUXENT RIVER",
    "dropdeladd": "459 CEDAR POINT RD",
    "dropdelcty": "PATUXENT RIVER",
    "dropdelst": "MD",
    "dropdelzpp": 206709998,
    "dropphyadd": "459 CEDAR POINT RD",
    "dropphycty": "PATUXENT RIVER",
    "dropphyst": "MD",
    "dropphyzpp": 206709998,
    "dropmaladd": "459 CEDAR POINT RD",
    "dropmalcty": "PATUXENT RIVER",
    "dropmalst": "MD",
    "dropmalzpp": 206709998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013427642,
    "dropsitcph": 3013427642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24165",
    "droptype": "D",
    "dropname": "PERRY HALL",
    "dropdeladd": "8744 BELAIR RD",
    "dropdelcty": "PERRY HALL",
    "dropdelst": "MD",
    "dropdelzpp": 211289998,
    "dropphyadd": "8744 BELAIR RD",
    "dropphycty": "PERRY HALL",
    "dropphyst": "MD",
    "dropphyzpp": 211289998,
    "dropmaladd": "8744 BELAIR RD",
    "dropmalcty": "PERRY HALL",
    "dropmalst": "MD",
    "dropmalzpp": 211289998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102561014,
    "dropsitcph": 4102561014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24167",
    "droptype": "D",
    "dropname": "PERRY POINT",
    "dropdeladd": "0 AVENUE D BLDG 64",
    "dropdelcty": "PERRY POINT",
    "dropdelst": "MD",
    "dropdelzpp": 219029998,
    "dropphyadd": "0 AVENUE D BLDG 64",
    "dropphycty": "PERRY POINT",
    "dropphyst": "MD",
    "dropphyzpp": 219029998,
    "dropmaladd": "0 AVENUE D BLDG 64",
    "dropmalcty": "PERRY POINT",
    "dropmalst": "MD",
    "dropmalzpp": 219029998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106422924,
    "dropsitcph": 4106422924,
    "dropfax": 4106420179
  },
  {
    "dcode": "D",
    "dropkey": "PV24168",
    "droptype": "D",
    "dropname": "PERRYMAN",
    "dropdeladd": "428 MICHAELSVILLE RD",
    "dropdelcty": "PERRYMAN",
    "dropdelst": "MD",
    "dropdelzpp": 211309998,
    "dropphyadd": "428 MICHAELSVILLE RD",
    "dropphycty": "PERRYMAN",
    "dropphyst": "MD",
    "dropphyzpp": 211309998,
    "dropmaladd": "428 MICHAELSVILLE RD",
    "dropmalcty": "PERRYMAN",
    "dropmalst": "MD",
    "dropmalzpp": 211309998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102723981,
    "dropsitcph": 4102723981,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24169",
    "droptype": "D",
    "dropname": "PERRYVILLE",
    "dropdeladd": "620 BROAD ST",
    "dropdelcty": "PERRYVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 219039998,
    "dropphyadd": "620 BROAD ST",
    "dropphycty": "PERRYVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 219039998,
    "dropmaladd": "620 BROAD ST",
    "dropmalcty": "PERRYVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 219039998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106426012,
    "dropsitcph": 4106426012,
    "dropfax": 4106423731
  },
  {
    "dcode": "D",
    "dropkey": "PV24171",
    "droptype": "D",
    "dropname": "PHOENIX",
    "dropdeladd": "14320 JARRETTSVILLE PIKE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "MD",
    "dropdelzpp": 211319998,
    "dropphyadd": "14320 JARRETTSVILLE PIKE",
    "dropphycty": "PHOENIX",
    "dropphyst": "MD",
    "dropphyzpp": 211319998,
    "dropmaladd": "14320 JARRETTSVILLE PIKE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "MD",
    "dropmalzpp": 211319998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106660692,
    "dropsitcph": 4106660692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24182",
    "droptype": "D",
    "dropname": "PINEY POINT",
    "dropdeladd": "17160 PINEY POINT RD",
    "dropdelcty": "PINEY POINT",
    "dropdelst": "MD",
    "dropdelzpp": 206749998,
    "dropphyadd": "17160 PINEY POINT RD",
    "dropphycty": "PINEY POINT",
    "dropphyst": "MD",
    "dropphyzpp": 206749998,
    "dropmaladd": "17160 PINEY POINT RD",
    "dropmalcty": "PINEY POINT",
    "dropmalst": "MD",
    "dropmalzpp": 206749998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019942521,
    "dropsitcph": 3019942521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24184",
    "droptype": "D",
    "dropname": "PINTO",
    "dropdeladd": "16111 MCMULLEN HWY",
    "dropdelcty": "PINTO",
    "dropdelst": "MD",
    "dropdelzpp": 215569998,
    "dropphyadd": "16111 MCMULLEN HWY",
    "dropphycty": "PINTO",
    "dropphyst": "MD",
    "dropphyzpp": 215569998,
    "dropmaladd": "16111 MCMULLEN HWY",
    "dropmalcty": "PINTO",
    "dropmalst": "MD",
    "dropmalzpp": 215569998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3017296565,
    "dropsitcph": 3017296565,
    "dropfax": 3017290892
  },
  {
    "dcode": "D",
    "dropkey": "PV24186",
    "droptype": "D",
    "dropname": "PITTSVILLE",
    "dropdeladd": "7390 PINE ST",
    "dropdelcty": "PITTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 218509998,
    "dropphyadd": "7390 PINE ST",
    "dropphycty": "PITTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 218509998,
    "dropmaladd": "7390 PINE ST",
    "dropmalcty": "PITTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 218509998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108358318,
    "dropsitcph": 4108358318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24189",
    "droptype": "D",
    "dropname": "POCOMOKE CITY",
    "dropdeladd": "207 MARKET ST",
    "dropdelcty": "POCOMOKE CITY",
    "dropdelst": "MD",
    "dropdelzpp": 218519998,
    "dropphyadd": "207 MARKET ST",
    "dropphycty": "POCOMOKE CITY",
    "dropphyst": "MD",
    "dropphyzpp": 218519998,
    "dropmaladd": "207 MARKET ST",
    "dropmalcty": "POCOMOKE CITY",
    "dropmalst": "MD",
    "dropmalzpp": 218519998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109571620,
    "dropsitcph": 4109571620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24190",
    "droptype": "D",
    "dropname": "POINT OF ROCKS",
    "dropdeladd": "1597 BOWIS DR",
    "dropdelcty": "POINT OF ROCKS",
    "dropdelst": "MD",
    "dropdelzpp": 217779998,
    "dropphyadd": "1597 BOWIS DR",
    "dropphycty": "POINT OF ROCKS",
    "dropphyst": "MD",
    "dropphyzpp": 217779998,
    "dropmaladd": "1597 BOWIS DR",
    "dropmalcty": "POINT OF ROCKS",
    "dropmalst": "MD",
    "dropmalzpp": 217779998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018742131,
    "dropsitcph": 3018742131,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24191",
    "droptype": "D",
    "dropname": "POMFRET",
    "dropdeladd": "8205 MARSHALL CORNER RD",
    "dropdelcty": "POMFRET",
    "dropdelst": "MD",
    "dropdelzpp": 206759998,
    "dropphyadd": "8205 MARSHALL CORNER RD",
    "dropphycty": "POMFRET",
    "dropphyst": "MD",
    "dropphyzpp": 206759998,
    "dropmaladd": "8205 MARSHALL CORNER RD",
    "dropmalcty": "POMFRET",
    "dropmalst": "MD",
    "dropmalzpp": 206759998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019343117,
    "dropsitcph": 3019343117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24195",
    "droptype": "D",
    "dropname": "POOLESVILLE",
    "dropdeladd": "19820 FISHER AVE",
    "dropdelcty": "POOLESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208379998,
    "dropphyadd": "19820 FISHER AVE",
    "dropphycty": "POOLESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208379998,
    "dropmaladd": "19820 FISHER AVE",
    "dropmalcty": "POOLESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208379998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016050131,
    "dropsitcph": 3016050544,
    "dropfax": 3013493871
  },
  {
    "dcode": "D",
    "dropkey": "PV24201",
    "droptype": "D",
    "dropname": "PORT DEPOSIT",
    "dropdeladd": "11 S MAIN ST",
    "dropdelcty": "PORT DEPOSIT",
    "dropdelst": "MD",
    "dropdelzpp": 219041785,
    "dropphyadd": "11 S MAIN ST",
    "dropphycty": "PORT DEPOSIT",
    "dropphyst": "MD",
    "dropphyzpp": 219041785,
    "dropmaladd": "11 S MAIN ST",
    "dropmalcty": "PORT DEPOSIT",
    "dropmalst": "MD",
    "dropmalzpp": 219041785,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103784191,
    "dropsitcph": 4103784191,
    "dropfax": 4103785669
  },
  {
    "dcode": "D",
    "dropkey": "PV24203",
    "droptype": "D",
    "dropname": "PORT REPUBLIC",
    "dropdeladd": "3000 SAINT LEONARD RD",
    "dropdelcty": "PORT REPUBLIC",
    "dropdelst": "MD",
    "dropdelzpp": 206769998,
    "dropphyadd": "3000 SAINT LEONARD RD",
    "dropphycty": "PORT REPUBLIC",
    "dropphyst": "MD",
    "dropphyzpp": 206769998,
    "dropmaladd": "3000 SAINT LEONARD RD",
    "dropmalcty": "PORT REPUBLIC",
    "dropmalst": "MD",
    "dropmalzpp": 206769998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4105860580,
    "dropsitcph": 4105860580,
    "dropfax": 4105861537
  },
  {
    "dcode": "D",
    "dropkey": "PV24204",
    "droptype": "D",
    "dropname": "PORT TOBACCO",
    "dropdeladd": "8200 PORT TOBACCO RD",
    "dropdelcty": "PORT TOBACCO",
    "dropdelst": "MD",
    "dropdelzpp": 206779998,
    "dropphyadd": "8200 PORT TOBACCO RD",
    "dropphycty": "PORT TOBACCO",
    "dropphyst": "MD",
    "dropphyzpp": 206779998,
    "dropmaladd": "8200 PORT TOBACCO RD",
    "dropmalcty": "PORT TOBACCO",
    "dropmalst": "MD",
    "dropmalzpp": 206779998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019343229,
    "dropsitcph": 3019343229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24215",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "PRESTON",
    "dropdelst": "MD",
    "dropdelzpp": 216559998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "PRESTON",
    "dropphyst": "MD",
    "dropphyzpp": 216559998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "PRESTON",
    "dropmalst": "MD",
    "dropmalzpp": 216559998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106732166,
    "dropsitcph": 4106732166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24217",
    "droptype": "D",
    "dropname": "PRINCE FREDERICK",
    "dropdeladd": "35 DUKE ST",
    "dropdelcty": "PRINCE FREDERICK",
    "dropdelst": "MD",
    "dropdelzpp": 206789998,
    "dropphyadd": "35 DUKE ST",
    "dropphycty": "PRINCE FREDERICK",
    "dropphyst": "MD",
    "dropphyzpp": 206789998,
    "dropmaladd": "35 DUKE ST",
    "dropmalcty": "PRINCE FREDERICK",
    "dropmalst": "MD",
    "dropmalzpp": 206789998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018551742,
    "dropsitcph": 3018551742,
    "dropfax": 4104143880
  },
  {
    "dcode": "D",
    "dropkey": "PV24222",
    "droptype": "D",
    "dropname": "PRINCESS ANNE",
    "dropdeladd": "11690 SOMERSET AVE",
    "dropdelcty": "PRINCESS ANNE",
    "dropdelst": "MD",
    "dropdelzpp": 218539998,
    "dropphyadd": "11690 SOMERSET AVE",
    "dropphycty": "PRINCESS ANNE",
    "dropphyst": "MD",
    "dropphyzpp": 218539998,
    "dropmaladd": "11690 SOMERSET AVE",
    "dropmalcty": "PRINCESS ANNE",
    "dropmalst": "MD",
    "dropmalzpp": 218539998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106512101,
    "dropsitcph": 4106512101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24230",
    "droptype": "D",
    "dropname": "PYLESVILLE",
    "dropdeladd": "3965 ADY RD",
    "dropdelcty": "PYLESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 211329998,
    "dropphyadd": "3965 ADY RD",
    "dropphycty": "PYLESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 211329998,
    "dropmaladd": "3965 ADY RD",
    "dropmalcty": "PYLESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 211329998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104525597,
    "dropsitcph": 4104525597,
    "dropfax": 4104528516
  },
  {
    "dcode": "D",
    "dropkey": "PV24232",
    "droptype": "D",
    "dropname": "QUANTICO",
    "dropdeladd": "6300 CHERRY WALK RD",
    "dropdelcty": "QUANTICO",
    "dropdelst": "MD",
    "dropdelzpp": 218569998,
    "dropphyadd": "6300 CHERRY WALK RD",
    "dropphycty": "QUANTICO",
    "dropphyst": "MD",
    "dropphyzpp": 218569998,
    "dropmaladd": "6300 CHERRY WALK RD",
    "dropmalcty": "QUANTICO",
    "dropmalst": "MD",
    "dropmalzpp": 218569998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107428350,
    "dropsitcph": 4107428350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24233",
    "droptype": "D",
    "dropname": "QUEEN ANNE",
    "dropdeladd": "32209 PARK AVE",
    "dropdelcty": "QUEEN ANNE",
    "dropdelst": "MD",
    "dropdelzpp": 216579998,
    "dropphyadd": "32209 PARK AVE",
    "dropphycty": "QUEEN ANNE",
    "dropphyst": "MD",
    "dropphyzpp": 216579998,
    "dropmaladd": "32209 PARK AVE",
    "dropmalcty": "QUEEN ANNE",
    "dropmalst": "MD",
    "dropmalzpp": 216579998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108202939,
    "dropsitcph": 4108202939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24234",
    "droptype": "D",
    "dropname": "QUEENSTOWN",
    "dropdeladd": "7100 MAIN ST",
    "dropdelcty": "QUEENSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 216589998,
    "dropphyadd": "7100 MAIN ST",
    "dropphycty": "QUEENSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 216589998,
    "dropmaladd": "7100 MAIN ST",
    "dropmalcty": "QUEENSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 216589998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108277111,
    "dropsitcph": 4108277111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24237",
    "droptype": "D",
    "dropname": "RANDALLSTOWN",
    "dropdeladd": "3608 OFFUTT RD",
    "dropdelcty": "RANDALLSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 211339998,
    "dropphyadd": "3608 OFFUTT RD",
    "dropphycty": "RANDALLSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 211339998,
    "dropmaladd": "3608 OFFUTT RD",
    "dropmalcty": "RANDALLSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 211339998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104966153,
    "dropsitcph": 4104966153,
    "dropfax": 4105217158
  },
  {
    "dcode": "D",
    "dropkey": "PV24240",
    "droptype": "D",
    "dropname": "RAWLINGS",
    "dropdeladd": "19000 MCMULLEN HWY SW",
    "dropdelcty": "RAWLINGS",
    "dropdelst": "MD",
    "dropdelzpp": 215579998,
    "dropphyadd": "19000 MCMULLEN HWY SW",
    "dropphycty": "RAWLINGS",
    "dropphyst": "MD",
    "dropphyzpp": 215579998,
    "dropmaladd": "19000 MCMULLEN HWY SW",
    "dropmalcty": "RAWLINGS",
    "dropmalst": "MD",
    "dropmalzpp": 215579998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3017291684,
    "dropsitcph": 3017291684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24243",
    "droptype": "D",
    "dropname": "REHOBETH",
    "dropdeladd": "31358 REHOBETH RD",
    "dropdelcty": "REHOBETH",
    "dropdelst": "MD",
    "dropdelzpp": 218571111,
    "dropphyadd": "31358 REHOBETH RD",
    "dropphycty": "REHOBETH",
    "dropphyst": "MD",
    "dropphyzpp": 218571111,
    "dropmaladd": "31358 REHOBETH RD",
    "dropmalcty": "REHOBETH",
    "dropmalst": "MD",
    "dropmalzpp": 218571111,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109570377,
    "dropsitcph": 4109570377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24244",
    "droptype": "D",
    "dropname": "REISTERSTOWN",
    "dropdeladd": "5 GLYNDON DR",
    "dropdelcty": "REISTERSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 211369998,
    "dropphyadd": "5 GLYNDON DR",
    "dropphycty": "REISTERSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 211369998,
    "dropmaladd": "5 GLYNDON DR",
    "dropmalcty": "REISTERSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 211369998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108334259,
    "dropsitcph": 4108334259,
    "dropfax": 4108330125
  },
  {
    "dcode": "D",
    "dropkey": "PV24253",
    "droptype": "D",
    "dropname": "RHODESDALE",
    "dropdeladd": "5664 RHODESDALE VIENNA RD",
    "dropdelcty": "RHODESDALE",
    "dropdelst": "MD",
    "dropdelzpp": 216599998,
    "dropphyadd": "5664 RHODESDALE VIENNA RD",
    "dropphycty": "RHODESDALE",
    "dropphyst": "MD",
    "dropphyzpp": 216599998,
    "dropmaladd": "5664 RHODESDALE VIENNA RD",
    "dropmalcty": "RHODESDALE",
    "dropmalst": "MD",
    "dropmalzpp": 216599998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109433324,
    "dropsitcph": 4109433324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24258",
    "droptype": "D",
    "dropname": "RIDERWOOD",
    "dropdeladd": "8016 BELLONA AVE",
    "dropdelcty": "RIDERWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 211399998,
    "dropphyadd": "8016 BELLONA AVE",
    "dropphycty": "RIDERWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 211399998,
    "dropmaladd": "8016 BELLONA AVE",
    "dropmalcty": "RIDERWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 211399998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108217502,
    "dropsitcph": 4108217502,
    "dropfax": 4108237072
  },
  {
    "dcode": "D",
    "dropkey": "PV24260",
    "droptype": "D",
    "dropname": "RIDGE",
    "dropdeladd": "13274 POINT LOOKOUT RD",
    "dropdelcty": "RIDGE",
    "dropdelst": "MD",
    "dropdelzpp": 206809998,
    "dropphyadd": "13274 POINT LOOKOUT RD",
    "dropphycty": "RIDGE",
    "dropphyst": "MD",
    "dropphyzpp": 206809998,
    "dropmaladd": "13274 POINT LOOKOUT RD",
    "dropmalcty": "RIDGE",
    "dropmalst": "MD",
    "dropmalzpp": 206809998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018725864,
    "dropsitcph": 3018725864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24262",
    "droptype": "D",
    "dropname": "RIDGELY",
    "dropdeladd": "502 MARYLAND AVE",
    "dropdelcty": "RIDGELY",
    "dropdelst": "MD",
    "dropdelzpp": 216609998,
    "dropphyadd": "502 MARYLAND AVE",
    "dropphycty": "RIDGELY",
    "dropphyst": "MD",
    "dropphyzpp": 216609998,
    "dropmaladd": "502 MARYLAND AVE",
    "dropmalcty": "RIDGELY",
    "dropmalst": "MD",
    "dropmalzpp": 216609998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106342622,
    "dropsitcph": 4106342622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24267",
    "droptype": "D",
    "dropname": "RISING SUN",
    "dropdeladd": "105 N WALNUT ST",
    "dropdelcty": "RISING SUN",
    "dropdelst": "MD",
    "dropdelzpp": 219119998,
    "dropphyadd": "105 N WALNUT ST",
    "dropphycty": "RISING SUN",
    "dropphyst": "MD",
    "dropphyzpp": 219119998,
    "dropmaladd": "105 N WALNUT ST",
    "dropmalcty": "RISING SUN",
    "dropmalst": "MD",
    "dropmalzpp": 219119998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106586848,
    "dropsitcph": 4106586848,
    "dropfax": 4106582723
  },
  {
    "dcode": "D",
    "dropkey": "PV24269",
    "droptype": "D",
    "dropname": "RIVA",
    "dropdeladd": "3123 RIVA RD",
    "dropdelcty": "RIVA",
    "dropdelst": "MD",
    "dropdelzpp": 211409998,
    "dropphyadd": "3123 RIVA RD",
    "dropphycty": "RIVA",
    "dropphyst": "MD",
    "dropphyzpp": 211409998,
    "dropmaladd": "3123 RIVA RD",
    "dropmalcty": "RIVA",
    "dropmalst": "MD",
    "dropmalzpp": 211409998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4109562187,
    "dropsitcph": 4109562187,
    "dropfax": 4109561999
  },
  {
    "dcode": "D",
    "dropkey": "PV24272",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "6411 BALTIMORE AVE",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "MD",
    "dropdelzpp": 207379998,
    "dropphyadd": "6411 BALTIMORE AVE",
    "dropphycty": "RIVERDALE",
    "dropphyst": "MD",
    "dropphyzpp": 207379998,
    "dropmaladd": "6411 BALTIMORE AVE",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "MD",
    "dropmalzpp": 207379998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016991253,
    "dropsitcph": 3016991253,
    "dropfax": 3012776964
  },
  {
    "dcode": "D",
    "dropkey": "PV24278",
    "droptype": "D",
    "dropname": "ROCK HALL",
    "dropdeladd": "5691 LIBERTY ST",
    "dropdelcty": "ROCK HALL",
    "dropdelst": "MD",
    "dropdelzpp": 216619998,
    "dropphyadd": "5691 LIBERTY ST",
    "dropphycty": "ROCK HALL",
    "dropphyst": "MD",
    "dropphyzpp": 216619998,
    "dropmaladd": "5691 LIBERTY ST",
    "dropmalcty": "ROCK HALL",
    "dropmalst": "MD",
    "dropmalzpp": 216619998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106397054,
    "dropsitcph": 4106397054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24288",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "500 N WASHINGTON ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208509993,
    "dropphyadd": "500 N WASHINGTON ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208509993,
    "dropmaladd": "500 N WASHINGTON ST",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208509998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017625802,
    "dropsitcph": 3017625802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24294",
    "droptype": "D",
    "dropname": "ROCKY RIDGE",
    "dropdeladd": "13516 MOTTERS STATION RD",
    "dropdelcty": "ROCKY RIDGE",
    "dropdelst": "MD",
    "dropdelzpp": 217789998,
    "dropphyadd": "13516 MOTTERS STATION RD",
    "dropphycty": "ROCKY RIDGE",
    "dropphyst": "MD",
    "dropphyzpp": 217789998,
    "dropmaladd": "13516 MOTTERS STATION RD",
    "dropmalcty": "ROCKY RIDGE",
    "dropmalst": "MD",
    "dropmalzpp": 217789998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3012714920,
    "dropsitcph": 3012714920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24299",
    "droptype": "D",
    "dropname": "ROHRERSVILLE",
    "dropdeladd": "4314 MAIN ST",
    "dropdelcty": "ROHRERSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217799998,
    "dropphyadd": "4314 MAIN ST",
    "dropphycty": "ROHRERSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217799998,
    "dropmaladd": "4314 MAIN ST",
    "dropmalcty": "ROHRERSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217799998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014328909,
    "dropsitcph": 3014328909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24311",
    "droptype": "D",
    "dropname": "ROYAL OAK",
    "dropdeladd": "25897 ROYAL OAK RD",
    "dropdelcty": "ROYAL OAK",
    "dropdelst": "MD",
    "dropdelzpp": 216629998,
    "dropphyadd": "25897 ROYAL OAK RD",
    "dropphycty": "ROYAL OAK",
    "dropphyst": "MD",
    "dropphyzpp": 216629998,
    "dropmaladd": "25897 ROYAL OAK RD",
    "dropmalcty": "ROYAL OAK",
    "dropmalst": "MD",
    "dropmalzpp": 216629998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107452359,
    "dropsitcph": 4107452359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24321",
    "droptype": "D",
    "dropname": "SABILLASVILLE",
    "dropdeladd": "17235 SABILLASVILLE RD",
    "dropdelcty": "SABILLASVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217809998,
    "dropphyadd": "17235 SABILLASVILLE RD",
    "dropphycty": "SABILLASVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217809998,
    "dropmaladd": "17235 SABILLASVILLE RD",
    "dropmalcty": "SABILLASVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217809998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3012413875,
    "dropsitcph": 3012413875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24327",
    "droptype": "D",
    "dropname": "SAINT INIGOES",
    "dropdeladd": "15066 POINT LOOKOUT RD",
    "dropdelcty": "SAINT INIGOES",
    "dropdelst": "MD",
    "dropdelzpp": 206843145,
    "dropphyadd": "15066 POINT LOOKOUT RD",
    "dropphycty": "SAINT INIGOES",
    "dropphyst": "MD",
    "dropphyzpp": 206843145,
    "dropmaladd": "15066 POINT LOOKOUT RD",
    "dropmalcty": "SAINT INIGOES",
    "dropmalst": "MD",
    "dropmalzpp": 206843145,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018725010,
    "dropsitcph": 3018725010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24329",
    "droptype": "D",
    "dropname": "SAINT LEONARD",
    "dropdeladd": "4244 SAINT LEONARD RD STE 100",
    "dropdelcty": "SAINT LEONARD",
    "dropdelst": "MD",
    "dropdelzpp": 206859998,
    "dropphyadd": "4244 SAINT LEONARD RD STE 100",
    "dropphycty": "SAINT LEONARD",
    "dropphyst": "MD",
    "dropphyzpp": 206859998,
    "dropmaladd": "4244 SAINT LEONARD RD STE 100",
    "dropmalcty": "SAINT LEONARD",
    "dropmalst": "MD",
    "dropmalzpp": 206859998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4105860688,
    "dropsitcph": 4105860688,
    "dropfax": 4105863909
  },
  {
    "dcode": "D",
    "dropkey": "PV24330",
    "droptype": "D",
    "dropname": "SAINT MARYS CITY",
    "dropdeladd": "16855 POINT LOOKOUT RD",
    "dropdelcty": "SAINT MARYS CITY",
    "dropdelst": "MD",
    "dropdelzpp": 206869998,
    "dropphyadd": "16855 POINT LOOKOUT RD",
    "dropphycty": "SAINT MARYS CITY",
    "dropphyst": "MD",
    "dropphyzpp": 206869998,
    "dropmaladd": "16855 POINT LOOKOUT RD",
    "dropmalcty": "SAINT MARYS CITY",
    "dropmalst": "MD",
    "dropmalzpp": 206869998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018622665,
    "dropsitcph": 3018622665,
    "dropfax": 3018629406
  },
  {
    "dcode": "D",
    "dropkey": "PV24331",
    "droptype": "D",
    "dropname": "SAINT MICHAELS",
    "dropdeladd": "303 S TALBOT ST",
    "dropdelcty": "SAINT MICHAELS",
    "dropdelst": "MD",
    "dropdelzpp": 216639998,
    "dropphyadd": "303 S TALBOT ST",
    "dropphycty": "SAINT MICHAELS",
    "dropphyst": "MD",
    "dropphyzpp": 216639998,
    "dropmaladd": "303 S TALBOT ST",
    "dropmalcty": "SAINT MICHAELS",
    "dropmalst": "MD",
    "dropmalzpp": 216639998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107459616,
    "dropsitcph": 4107459616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24334",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "816 E SALISBURY PKWY",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MD",
    "dropdelzpp": 218019998,
    "dropphyadd": "816 E SALISBURY PKWY",
    "dropphycty": "SALISBURY",
    "dropphyst": "MD",
    "dropphyzpp": 218019998,
    "dropmaladd": "816 E SALISBURY PKWY",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MD",
    "dropmalzpp": 218019998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107429261,
    "dropsitcph": 4107429261,
    "dropfax": 4107429495
  },
  {
    "dcode": "D",
    "dropkey": "PV24340",
    "droptype": "D",
    "dropname": "SANDY SPRING",
    "dropdeladd": "901 OLNEY SANDY SPRING RD",
    "dropdelcty": "SANDY SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 208609998,
    "dropphyadd": "901 OLNEY SANDY SPRING RD",
    "dropphycty": "SANDY SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 208609998,
    "dropmaladd": "901 OLNEY SANDY SPRING RD",
    "dropmalcty": "SANDY SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 208609998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019241634,
    "dropsitcph": 3019299135,
    "dropfax": 3015701054
  },
  {
    "dcode": "D",
    "dropkey": "PV24344",
    "droptype": "D",
    "dropname": "SAVAGE",
    "dropdeladd": "8926 BALTIMORE ST",
    "dropdelcty": "SAVAGE",
    "dropdelst": "MD",
    "dropdelzpp": 207639998,
    "dropphyadd": "8926 BALTIMORE ST",
    "dropphycty": "SAVAGE",
    "dropphyst": "MD",
    "dropphyzpp": 207639998,
    "dropmaladd": "8926 BALTIMORE ST",
    "dropmalcty": "SAVAGE",
    "dropmalst": "MD",
    "dropmalzpp": 207639998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017253570,
    "dropsitcph": 3017253570,
    "dropfax": 3014971391
  },
  {
    "dcode": "D",
    "dropkey": "PV24350",
    "droptype": "D",
    "dropname": "SECRETARY",
    "dropdeladd": "145 MAIN ST",
    "dropdelcty": "SECRETARY",
    "dropdelst": "MD",
    "dropdelzpp": 216649998,
    "dropphyadd": "145 MAIN ST",
    "dropphycty": "SECRETARY",
    "dropphyst": "MD",
    "dropphyzpp": 216649998,
    "dropmaladd": "145 MAIN ST",
    "dropmalcty": "SECRETARY",
    "dropmalst": "MD",
    "dropmalzpp": 216649998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4109433792,
    "dropsitcph": 4109433792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24354",
    "droptype": "D",
    "dropname": "SEVERN",
    "dropdeladd": "819 REECE RD",
    "dropdelcty": "SEVERN",
    "dropdelst": "MD",
    "dropdelzpp": 211449998,
    "dropphyadd": "819 REECE RD",
    "dropphycty": "SEVERN",
    "dropphyst": "MD",
    "dropphyzpp": 211449998,
    "dropmaladd": "819 REECE RD",
    "dropmalcty": "SEVERN",
    "dropmalst": "MD",
    "dropmalzpp": 211449998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105519174,
    "dropsitcph": 4105519174,
    "dropfax": 4105514757
  },
  {
    "dcode": "D",
    "dropkey": "PV24355",
    "droptype": "D",
    "dropname": "SEVERNA PARK",
    "dropdeladd": "21 MAGOTHY BRIDGE RD",
    "dropdelcty": "SEVERNA PARK",
    "dropdelst": "MD",
    "dropdelzpp": 211469919,
    "dropphyadd": "21 MAGOTHY BRIDGE RD",
    "dropphycty": "SEVERNA PARK",
    "dropphyst": "MD",
    "dropphyzpp": 211469919,
    "dropmaladd": "21 MAGOTHY BRIDGE RD",
    "dropmalcty": "SEVERNA PARK",
    "dropmalst": "MD",
    "dropmalzpp": 211469919,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106472904,
    "dropsitcph": 4106472904,
    "dropfax": 4105447905
  },
  {
    "dcode": "D",
    "dropkey": "PV24357",
    "droptype": "D",
    "dropname": "SHADY SIDE",
    "dropdeladd": "6160 SHADY SIDE RD",
    "dropdelcty": "SHADY SIDE",
    "dropdelst": "MD",
    "dropdelzpp": 207649998,
    "dropphyadd": "6160 SHADY SIDE RD",
    "dropphycty": "SHADY SIDE",
    "dropphyst": "MD",
    "dropphyzpp": 207649998,
    "dropmaladd": "6160 SHADY SIDE RD",
    "dropmalcty": "SHADY SIDE",
    "dropmalst": "MD",
    "dropmalzpp": 207649998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4108676134,
    "dropsitcph": 4108676134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24362",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "118 E CHAPLINE ST",
    "dropdelcty": "SHARPSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 217829998,
    "dropphyadd": "118 E CHAPLINE ST",
    "dropphycty": "SHARPSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 217829998,
    "dropmaladd": "118 E CHAPLINE ST",
    "dropmalcty": "SHARPSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 217829998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3014326554,
    "dropsitcph": 3014326554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24363",
    "droptype": "D",
    "dropname": "SHARPTOWN",
    "dropdeladd": "403 4TH ST",
    "dropdelcty": "SHARPTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 218611041,
    "dropphyadd": "403 4TH ST",
    "dropphycty": "SHARPTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 218611041,
    "dropmaladd": "403 4TH ST",
    "dropmalcty": "SHARPTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 218611041,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108833300,
    "dropsitcph": 4108833300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24364",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "7689 SHERWOOD RD",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "MD",
    "dropdelzpp": 216659998,
    "dropphyadd": "7689 SHERWOOD RD",
    "dropphycty": "SHERWOOD",
    "dropphyst": "MD",
    "dropphyzpp": 216659998,
    "dropmaladd": "7689 SHERWOOD RD",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "MD",
    "dropmalzpp": 216659998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108862634,
    "dropsitcph": 4108862634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24373",
    "droptype": "D",
    "dropname": "SILVER SPRING",
    "dropdeladd": "940 THAYER AVE",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209105160,
    "dropphyadd": "940 THAYER AVE",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209105160,
    "dropmaladd": "940 THAYER AVE",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209105160,
    "dropsitphn": 3016081304,
    "dropsitlph": 3016081304,
    "dropsitcph": 3016081304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24376",
    "droptype": "D",
    "dropname": "SIMPSONVILLE",
    "dropdeladd": "10400 SHAKER DR",
    "dropdelcty": "SIMPSONVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 211509998,
    "dropphyadd": "10400 SHAKER DR",
    "dropphycty": "SIMPSONVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 211509998,
    "dropmaladd": "10400 SHAKER DR",
    "dropmalcty": "SIMPSONVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 211509998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107720194,
    "dropsitcph": 4107720194,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24378",
    "droptype": "D",
    "dropname": "SMITHSBURG",
    "dropdeladd": "43 GROVE LN",
    "dropdelcty": "SMITHSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 217839998,
    "dropphyadd": "43 GROVE LN",
    "dropphycty": "SMITHSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 217839998,
    "dropmaladd": "43 GROVE LN",
    "dropmalcty": "SMITHSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 217839998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018242828,
    "dropsitcph": 3018242828,
    "dropfax": 3018249935
  },
  {
    "dcode": "D",
    "dropkey": "PV24380",
    "droptype": "D",
    "dropname": "SNOW HILL",
    "dropdeladd": "306 N WASHINGTON ST",
    "dropdelcty": "SNOW HILL",
    "dropdelst": "MD",
    "dropdelzpp": 218639998,
    "dropphyadd": "306 N WASHINGTON ST",
    "dropphycty": "SNOW HILL",
    "dropphyst": "MD",
    "dropphyzpp": 218639998,
    "dropmaladd": "306 N WASHINGTON ST",
    "dropmalcty": "SNOW HILL",
    "dropmalst": "MD",
    "dropmalzpp": 218639998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106321275,
    "dropsitcph": 4106321275,
    "dropfax": 4106322139
  },
  {
    "dcode": "D",
    "dropkey": "PV24384",
    "droptype": "D",
    "dropname": "SOLOMONS",
    "dropdeladd": "13946 HG TRUEMAN RD",
    "dropdelcty": "SOLOMONS",
    "dropdelst": "MD",
    "dropdelzpp": 206889998,
    "dropphyadd": "13946 HG TRUEMAN RD",
    "dropphycty": "SOLOMONS",
    "dropphyst": "MD",
    "dropphyzpp": 206889998,
    "dropmaladd": "13946 HG TRUEMAN RD",
    "dropmalcty": "SOLOMONS",
    "dropmalst": "MD",
    "dropmalzpp": 206889998,
    "dropsitphn": 3014997331,
    "dropsitlph": 4103263193,
    "dropsitcph": 4103263193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24401",
    "droptype": "D",
    "dropname": "SOUTHERN MD FACILITY",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207909998,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207909998,
    "dropmaladd": "9201 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207909998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014997600,
    "dropsitcph": 3014997600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24404",
    "droptype": "D",
    "dropname": "SPARKS GLENCOE",
    "dropdeladd": "14800 YORK RD",
    "dropdelcty": "SPARKS GLENCOE",
    "dropdelst": "MD",
    "dropdelzpp": 211529998,
    "dropphyadd": "14800 YORK RD",
    "dropphycty": "SPARKS GLENCOE",
    "dropphyst": "MD",
    "dropphyzpp": 211529998,
    "dropmaladd": "14800 YORK RD",
    "dropmalcty": "SPARKS GLENCOE",
    "dropmalst": "MD",
    "dropmalzpp": 211529998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104720706,
    "dropsitcph": 4104720706,
    "dropfax": 4104729203
  },
  {
    "dcode": "D",
    "dropkey": "PV24406",
    "droptype": "D",
    "dropname": "SPENCERVILLE",
    "dropdeladd": "2323 SPENCERVILLE RD",
    "dropdelcty": "SPENCERVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208689998,
    "dropphyadd": "2323 SPENCERVILLE RD",
    "dropphycty": "SPENCERVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208689998,
    "dropmaladd": "2323 SPENCERVILLE RD",
    "dropmalcty": "SPENCERVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208689998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013842709,
    "dropsitcph": 3013842709,
    "dropfax": 3014211367
  },
  {
    "dcode": "D",
    "dropkey": "PV24412",
    "droptype": "D",
    "dropname": "SPRING GAP",
    "dropdeladd": "13400 OLDTOWN RD",
    "dropdelcty": "SPRING GAP",
    "dropdelst": "MD",
    "dropdelzpp": 215609998,
    "dropphyadd": "13400 OLDTOWN RD",
    "dropphycty": "SPRING GAP",
    "dropphyst": "MD",
    "dropphyzpp": 215609998,
    "dropmaladd": "13400 OLDTOWN RD",
    "dropmalcty": "SPRING GAP",
    "dropmalst": "MD",
    "dropmalzpp": 215609998,
    "dropsitphn": 3017228190,
    "dropsitlph": 3017778146,
    "dropsitcph": 3017778146,
    "dropfax": 3017778146
  },
  {
    "dcode": "D",
    "dropkey": "PV24437",
    "droptype": "D",
    "dropname": "STEVENSON",
    "dropdeladd": "10421 STEVENSON RD",
    "dropdelcty": "STEVENSON",
    "dropdelst": "MD",
    "dropdelzpp": 211539998,
    "dropphyadd": "10421 STEVENSON RD",
    "dropphycty": "STEVENSON",
    "dropphyst": "MD",
    "dropphyzpp": 211539998,
    "dropmaladd": "10421 STEVENSON RD",
    "dropmalcty": "STEVENSON",
    "dropmalst": "MD",
    "dropmalzpp": 211539998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106535613,
    "dropsitcph": 4106535613,
    "dropfax": 4106029418
  },
  {
    "dcode": "D",
    "dropkey": "PV24438",
    "droptype": "D",
    "dropname": "STEVENSVILLE",
    "dropdeladd": "366 THOMPSON CREEK MALL",
    "dropdelcty": "STEVENSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216669998,
    "dropphyadd": "366 THOMPSON CREEK MALL",
    "dropphycty": "STEVENSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216669998,
    "dropmaladd": "366 THOMPSON CREEK MALL",
    "dropmalcty": "STEVENSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216669998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106435640,
    "dropsitcph": 4106435640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24444",
    "droptype": "D",
    "dropname": "STREET",
    "dropdeladd": "708 HIGHLAND RD REAR",
    "dropdelcty": "STREET",
    "dropdelst": "MD",
    "dropdelzpp": 211549998,
    "dropphyadd": "708 HIGHLAND RD REAR",
    "dropphycty": "STREET",
    "dropphyst": "MD",
    "dropphyzpp": 211549998,
    "dropmaladd": "708 HIGHLAND RD REAR",
    "dropmalcty": "STREET",
    "dropmalst": "MD",
    "dropmalzpp": 211549998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108361666,
    "dropsitcph": 4108361666,
    "dropfax": 4104528198
  },
  {
    "dcode": "D",
    "dropkey": "PV24448",
    "droptype": "D",
    "dropname": "SUBURB MARYLAND FAC",
    "dropdeladd": "16501 SHADY GROVE RD",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208989998,
    "dropphyadd": "16501 SHADY GROVE RD",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208989998,
    "dropmaladd": "16501 SHADY GROVE RD",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208989998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016706003,
    "dropsitcph": 3016706085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24452",
    "droptype": "D",
    "dropname": "SUDLERSVILLE",
    "dropdeladd": "117 S CHURCH ST",
    "dropdelcty": "SUDLERSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216689998,
    "dropphyadd": "117 S CHURCH ST",
    "dropphycty": "SUDLERSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216689998,
    "dropmaladd": "117 S CHURCH ST",
    "dropmalcty": "SUDLERSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216689998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104383616,
    "dropsitcph": 4104383616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24464",
    "droptype": "D",
    "dropname": "SWANTON",
    "dropdeladd": "3320 SWANTON RD",
    "dropdelcty": "SWANTON",
    "dropdelst": "MD",
    "dropdelzpp": 215619998,
    "dropphyadd": "3320 SWANTON RD",
    "dropphycty": "SWANTON",
    "dropphyst": "MD",
    "dropphyzpp": 215619998,
    "dropmaladd": "3320 SWANTON RD",
    "dropmalcty": "SWANTON",
    "dropmalst": "MD",
    "dropmalzpp": 215619998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013876425,
    "dropsitcph": 3013876425,
    "dropfax": 3013875205
  },
  {
    "dcode": "D",
    "dropkey": "PV24465",
    "droptype": "D",
    "dropname": "SYKESVILLE",
    "dropdeladd": "1363 PROGRESS WAY",
    "dropdelcty": "SYKESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217849998,
    "dropphyadd": "1363 PROGRESS WAY",
    "dropphycty": "SYKESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217849998,
    "dropmaladd": "1363 PROGRESS WAY",
    "dropmalcty": "SYKESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217849998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107950350,
    "dropsitcph": 4107950350,
    "dropfax": 4105520740
  },
  {
    "dcode": "D",
    "dropkey": "PV24472",
    "droptype": "D",
    "dropname": "TALL TIMBERS",
    "dropdeladd": "44582 TALL TIMBERS RD",
    "dropdelcty": "TALL TIMBERS",
    "dropdelst": "MD",
    "dropdelzpp": 206909998,
    "dropphyadd": "44582 TALL TIMBERS RD",
    "dropphycty": "TALL TIMBERS",
    "dropphyst": "MD",
    "dropphyzpp": 206909998,
    "dropmaladd": "44582 TALL TIMBERS RD",
    "dropmalcty": "TALL TIMBERS",
    "dropmalst": "MD",
    "dropmalzpp": 206909998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019942241,
    "dropsitcph": 3019942241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24474",
    "droptype": "D",
    "dropname": "TANEYTOWN",
    "dropdeladd": "13 MIDDLE ST",
    "dropdelcty": "TANEYTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217879998,
    "dropphyadd": "13 MIDDLE ST",
    "dropphycty": "TANEYTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217879998,
    "dropmaladd": "13 MIDDLE ST",
    "dropmalcty": "TANEYTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217879998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107566411,
    "dropsitcph": 4107566411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24475",
    "droptype": "D",
    "dropname": "TAYLORS ISLAND",
    "dropdeladd": "517 TAYLORS ISLAND RD",
    "dropdelcty": "TAYLORS ISLAND",
    "dropdelst": "MD",
    "dropdelzpp": 216699998,
    "dropphyadd": "517 TAYLORS ISLAND RD",
    "dropphycty": "TAYLORS ISLAND",
    "dropphyst": "MD",
    "dropphyzpp": 216699998,
    "dropmaladd": "517 TAYLORS ISLAND RD",
    "dropmalcty": "TAYLORS ISLAND",
    "dropmalst": "MD",
    "dropmalzpp": 216699998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102218570,
    "dropsitcph": 4102218570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24484",
    "droptype": "D",
    "dropname": "TEMPLEVILLE",
    "dropdeladd": "3711 BARCLAY RD",
    "dropdelcty": "TEMPLEVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 216709998,
    "dropphyadd": "3711 BARCLAY RD",
    "dropphycty": "TEMPLEVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 216709998,
    "dropmaladd": "3711 BARCLAY RD",
    "dropmalcty": "TEMPLEVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 216709998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104822474,
    "dropsitcph": 4104822474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24495",
    "droptype": "D",
    "dropname": "THURMONT",
    "dropdeladd": "110 WATER ST",
    "dropdelcty": "THURMONT",
    "dropdelst": "MD",
    "dropdelzpp": 217889998,
    "dropphyadd": "110 WATER ST",
    "dropphycty": "THURMONT",
    "dropphyst": "MD",
    "dropphyzpp": 217889998,
    "dropmaladd": "110 WATER ST",
    "dropmalcty": "THURMONT",
    "dropmalst": "MD",
    "dropmalzpp": 217889998,
    "dropsitphn": 4103474587,
    "dropsitlph": 3012712226,
    "dropsitcph": 3012712226,
    "dropfax": 3012713728
  },
  {
    "dcode": "D",
    "dropkey": "PV24496",
    "droptype": "D",
    "dropname": "TILGHMAN",
    "dropdeladd": "5806 TILGHMAN ISLAND RD",
    "dropdelcty": "TILGHMAN",
    "dropdelst": "MD",
    "dropdelzpp": 216719998,
    "dropphyadd": "5806 TILGHMAN ISLAND RD",
    "dropphycty": "TILGHMAN",
    "dropphyst": "MD",
    "dropphyzpp": 216719998,
    "dropmaladd": "5806 TILGHMAN ISLAND RD",
    "dropmalcty": "TILGHMAN",
    "dropmalst": "MD",
    "dropmalzpp": 216719998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108862444,
    "dropsitcph": 4108862444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24515",
    "droptype": "D",
    "dropname": "TRACYS LANDING",
    "dropdeladd": "5889 SOLOMONS ISLAND RD",
    "dropdelcty": "TRACYS LANDING",
    "dropdelst": "MD",
    "dropdelzpp": 207799998,
    "dropphyadd": "5889 SOLOMONS ISLAND RD",
    "dropphycty": "TRACYS LANDING",
    "dropphyst": "MD",
    "dropphyzpp": 207799998,
    "dropmaladd": "5889 SOLOMONS ISLAND RD",
    "dropmalcty": "TRACYS LANDING",
    "dropmalst": "MD",
    "dropmalzpp": 207799998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012615415,
    "dropsitcph": 4108670296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24517",
    "droptype": "D",
    "dropname": "TRAPPE",
    "dropdeladd": "29381 GREENFIELD AVE",
    "dropdelcty": "TRAPPE",
    "dropdelst": "MD",
    "dropdelzpp": 216739998,
    "dropphyadd": "29381 GREENFIELD AVE",
    "dropphycty": "TRAPPE",
    "dropphyst": "MD",
    "dropphyzpp": 216739998,
    "dropmaladd": "29381 GREENFIELD AVE",
    "dropmalcty": "TRAPPE",
    "dropmalst": "MD",
    "dropmalzpp": 216739998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104763478,
    "dropsitcph": 4104763478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24521",
    "droptype": "D",
    "dropname": "TUSCARORA",
    "dropdeladd": "5709A TUSCARORA RD",
    "dropdelcty": "TUSCARORA",
    "dropdelst": "MD",
    "dropdelzpp": 217909998,
    "dropphyadd": "5709A TUSCARORA RD",
    "dropphycty": "TUSCARORA",
    "dropphyst": "MD",
    "dropphyzpp": 217909998,
    "dropmaladd": "5709A TUSCARORA RD",
    "dropmalcty": "TUSCARORA",
    "dropmalst": "MD",
    "dropmalzpp": 217909998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018742303,
    "dropsitcph": 3018742303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24527",
    "droptype": "D",
    "dropname": "TYASKIN",
    "dropdeladd": "4693 TYASKIN RD",
    "dropdelcty": "TYASKIN",
    "dropdelst": "MD",
    "dropdelzpp": 218659998,
    "dropphyadd": "4693 TYASKIN RD",
    "dropphycty": "TYASKIN",
    "dropphyst": "MD",
    "dropphyzpp": 218659998,
    "dropmaladd": "4693 TYASKIN RD",
    "dropmalcty": "TYASKIN",
    "dropmalst": "MD",
    "dropmalzpp": 218659998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108732346,
    "dropsitcph": 4108732346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24528",
    "droptype": "D",
    "dropname": "TYLERTON",
    "dropdeladd": "3071 UNION CHURCH RD",
    "dropdelcty": "TYLERTON",
    "dropdelst": "MD",
    "dropdelzpp": 218669998,
    "dropphyadd": "3071 UNION CHURCH RD",
    "dropphycty": "TYLERTON",
    "dropphyst": "MD",
    "dropphyzpp": 218669998,
    "dropmaladd": "3071 UNION CHURCH RD",
    "dropmalcty": "TYLERTON",
    "dropmalst": "MD",
    "dropmalzpp": 218669998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4104254181,
    "dropsitcph": 4104254181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24530",
    "droptype": "D",
    "dropname": "UNION BRIDGE",
    "dropdeladd": "111 PENROSE ST",
    "dropdelcty": "UNION BRIDGE",
    "dropdelst": "MD",
    "dropdelzpp": 217919998,
    "dropphyadd": "111 PENROSE ST",
    "dropphycty": "UNION BRIDGE",
    "dropphyst": "MD",
    "dropphyzpp": 217919998,
    "dropmaladd": "111 PENROSE ST",
    "dropmalcty": "UNION BRIDGE",
    "dropmalst": "MD",
    "dropmalzpp": 217919998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107759022,
    "dropsitcph": 4439373408,
    "dropfax": 4107751291
  },
  {
    "dcode": "D",
    "dropkey": "PV24534",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "13720 UNIONVILLE RD",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217929998,
    "dropphyadd": "13720 UNIONVILLE RD",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217929998,
    "dropmaladd": "13720 UNIONVILLE RD",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217929998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107752510,
    "dropsitcph": 4107752510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24542",
    "droptype": "D",
    "dropname": "UPPER FAIRMOUNT",
    "dropdeladd": "27741 FAIRMOUNT RD",
    "dropdelcty": "UPPER FAIRMOUNT",
    "dropdelst": "MD",
    "dropdelzpp": 218679998,
    "dropphyadd": "27741 FAIRMOUNT RD",
    "dropphycty": "UPPER FAIRMOUNT",
    "dropphyst": "MD",
    "dropphyzpp": 218679998,
    "dropmaladd": "27741 FAIRMOUNT RD",
    "dropmalcty": "UPPER FAIRMOUNT",
    "dropmalst": "MD",
    "dropmalzpp": 218679998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106512008,
    "dropsitcph": 4106512008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24543",
    "droptype": "D",
    "dropname": "UPPER FALLS",
    "dropdeladd": "7755 BRADSHAW RD",
    "dropdelcty": "UPPER FALLS",
    "dropdelst": "MD",
    "dropdelzpp": 211569998,
    "dropphyadd": "7755 BRADSHAW RD",
    "dropphycty": "UPPER FALLS",
    "dropphyst": "MD",
    "dropphyzpp": 211569998,
    "dropmaladd": "7755 BRADSHAW RD",
    "dropmalcty": "UPPER FALLS",
    "dropmalst": "MD",
    "dropmalzpp": 211569998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105923415,
    "dropsitcph": 4105923415,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24549",
    "droptype": "D",
    "dropname": "UPPER MARLBORO",
    "dropdeladd": "14605 ELM ST",
    "dropdelcty": "UPPER MARLBORO",
    "dropdelst": "MD",
    "dropdelzpp": 207729998,
    "dropphyadd": "14605 ELM ST",
    "dropphycty": "UPPER MARLBORO",
    "dropphyst": "MD",
    "dropphyzpp": 207729998,
    "dropmaladd": "14605 ELM ST",
    "dropmalcty": "UPPER MARLBORO",
    "dropmalst": "MD",
    "dropmalzpp": 207729998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017803427,
    "dropsitcph": 3017803427,
    "dropfax": 3016270021
  },
  {
    "dcode": "D",
    "dropkey": "PV24550",
    "droptype": "D",
    "dropname": "UPPERCO",
    "dropdeladd": "5420 ARCADIA AVE",
    "dropdelcty": "UPPERCO",
    "dropdelst": "MD",
    "dropdelzpp": 211559998,
    "dropphyadd": "5420 ARCADIA AVE",
    "dropphycty": "UPPERCO",
    "dropphyst": "MD",
    "dropphyzpp": 211559998,
    "dropmaladd": "5420 ARCADIA AVE",
    "dropmalcty": "UPPERCO",
    "dropmalst": "MD",
    "dropmalzpp": 211559998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103749404,
    "dropsitcph": 4103749404,
    "dropfax": 4103749404
  },
  {
    "dcode": "D",
    "dropkey": "PV24559",
    "droptype": "D",
    "dropname": "VALLEY LEE",
    "dropdeladd": "45150 BLAKE CREEK RD",
    "dropdelcty": "VALLEY LEE",
    "dropdelst": "MD",
    "dropdelzpp": 206929998,
    "dropphyadd": "45150 BLAKE CREEK RD",
    "dropphycty": "VALLEY LEE",
    "dropphyst": "MD",
    "dropphyzpp": 206929998,
    "dropmaladd": "45150 BLAKE CREEK RD",
    "dropmalcty": "VALLEY LEE",
    "dropmalst": "MD",
    "dropmalzpp": 206929998,
    "dropsitphn": 3018667059,
    "dropsitlph": 3018667059,
    "dropsitcph": 3018667059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24564",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "121 MARKET ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "MD",
    "dropdelzpp": 218699998,
    "dropphyadd": "121 MARKET ST",
    "dropphycty": "VIENNA",
    "dropphyst": "MD",
    "dropphyzpp": 218699998,
    "dropmaladd": "121 MARKET ST",
    "dropmalcty": "VIENNA",
    "dropmalst": "MD",
    "dropmalzpp": 218699998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4103763589,
    "dropsitcph": 4103763589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24586",
    "droptype": "D",
    "dropname": "WALDORF",
    "dropdeladd": "150 POST OFFICE RD",
    "dropdelcty": "WALDORF",
    "dropdelst": "MD",
    "dropdelzpp": 206029996,
    "dropphyadd": "150 POST OFFICE RD",
    "dropphycty": "WALDORF",
    "dropphyst": "MD",
    "dropphyzpp": 206029996,
    "dropmaladd": "150 POST OFFICE RD",
    "dropmalcty": "WALDORF",
    "dropmalst": "MD",
    "dropmalzpp": 206029996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017057288,
    "dropsitcph": 3017057288,
    "dropfax": 3018438404
  },
  {
    "dcode": "D",
    "dropkey": "PV24587",
    "droptype": "D",
    "dropname": "WALKERSVILLE",
    "dropdeladd": "7 E FREDERICK ST",
    "dropdelcty": "WALKERSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 217939998,
    "dropphyadd": "7 E FREDERICK ST",
    "dropphycty": "WALKERSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 217939998,
    "dropmaladd": "7 E FREDERICK ST",
    "dropmalcty": "WALKERSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 217939998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018458342,
    "dropsitcph": 3018458342,
    "dropfax": 3018454396
  },
  {
    "dcode": "D",
    "dropkey": "PV24591",
    "droptype": "D",
    "dropname": "WARWICK",
    "dropdeladd": "77 MAIN ST",
    "dropdelcty": "WARWICK",
    "dropdelst": "MD",
    "dropdelzpp": 219129998,
    "dropphyadd": "77 MAIN ST",
    "dropphycty": "WARWICK",
    "dropphyst": "MD",
    "dropphyzpp": 219129998,
    "dropmaladd": "77 MAIN ST",
    "dropmalcty": "WARWICK",
    "dropmalst": "MD",
    "dropmalzpp": 219129998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4107556744,
    "dropsitcph": 4107556744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24595",
    "droptype": "D",
    "dropname": "WASHINGTON NETWORKS DIST CTR",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207999998,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207999998,
    "dropmaladd": "9201 EDGEWORTH DR",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207999998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014997331,
    "dropsitcph": 3014997331,
    "dropfax": 3014997651
  },
  {
    "dcode": "D",
    "dropkey": "PV24596",
    "droptype": "D",
    "dropname": "WASHINGTON GROVE",
    "dropdeladd": "111 WASHINGTON GROVE LN",
    "dropdelcty": "WASHINGTON GROVE",
    "dropdelst": "MD",
    "dropdelzpp": 208809998,
    "dropphyadd": "111 WASHINGTON GROVE LN",
    "dropphycty": "WASHINGTON GROVE",
    "dropphyst": "MD",
    "dropphyzpp": 208809998,
    "dropmaladd": "111 WASHINGTON GROVE LN",
    "dropmalcty": "WASHINGTON GROVE",
    "dropmalst": "MD",
    "dropmalzpp": 208809998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019485009,
    "dropsitcph": 3019485009,
    "dropfax": 3017211970
  },
  {
    "dcode": "D",
    "dropkey": "PV24604",
    "droptype": "D",
    "dropname": "WELCOME",
    "dropdeladd": "6204 WELCOME RD",
    "dropdelcty": "WELCOME",
    "dropdelst": "MD",
    "dropdelzpp": 206939998,
    "dropphyadd": "6204 WELCOME RD",
    "dropphycty": "WELCOME",
    "dropphyst": "MD",
    "dropphyzpp": 206939998,
    "dropmaladd": "6204 WELCOME RD",
    "dropmalcty": "WELCOME",
    "dropmalst": "MD",
    "dropmalzpp": 206939998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019343052,
    "dropsitcph": 3019343052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24615",
    "droptype": "D",
    "dropname": "WEST FRIENDSHIP",
    "dropdeladd": "12800 STATE ROUTE 144",
    "dropdelcty": "WEST FRIENDSHIP",
    "dropdelst": "MD",
    "dropdelzpp": 217949998,
    "dropphyadd": "12800 STATE ROUTE 144",
    "dropphycty": "WEST FRIENDSHIP",
    "dropphyst": "MD",
    "dropphyzpp": 217949998,
    "dropmaladd": "12800 STATE ROUTE 144",
    "dropmalcty": "WEST FRIENDSHIP",
    "dropmalst": "MD",
    "dropmalzpp": 217949998,
    "dropsitphn": 4106823129,
    "dropsitlph": 4104421790,
    "dropsitcph": 4104421790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24629",
    "droptype": "D",
    "dropname": "WESTERNPORT",
    "dropdeladd": "72 MAIN ST",
    "dropdelcty": "WESTERNPORT",
    "dropdelst": "MD",
    "dropdelzpp": 215629998,
    "dropphyadd": "72 MAIN ST",
    "dropphycty": "WESTERNPORT",
    "dropphyst": "MD",
    "dropphyzpp": 215629998,
    "dropmaladd": "72 MAIN ST",
    "dropmalcty": "WESTERNPORT",
    "dropmalst": "MD",
    "dropmalzpp": 215629998,
    "dropsitphn": 3017228194,
    "dropsitlph": 3013599261,
    "dropsitcph": 3013599261,
    "dropfax": 3013599261
  },
  {
    "dcode": "D",
    "dropkey": "PV24630",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "345 WOODWARD RD",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "MD",
    "dropdelzpp": 211579998,
    "dropphyadd": "345 WOODWARD RD",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "MD",
    "dropphyzpp": 211579998,
    "dropmaladd": "345 WOODWARD RD",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "MD",
    "dropmalzpp": 211579998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108484805,
    "dropsitcph": 4108484805,
    "dropfax": 4107519888
  },
  {
    "dcode": "D",
    "dropkey": "PV24631",
    "droptype": "D",
    "dropname": "WESTOVER",
    "dropdeladd": "8930 CRISFIELD HWY",
    "dropdelcty": "WESTOVER",
    "dropdelst": "MD",
    "dropdelzpp": 218719998,
    "dropphyadd": "8930 CRISFIELD HWY",
    "dropphycty": "WESTOVER",
    "dropphyst": "MD",
    "dropphyzpp": 218719998,
    "dropmaladd": "8930 CRISFIELD HWY",
    "dropmalcty": "WESTOVER",
    "dropmalst": "MD",
    "dropmalzpp": 218719998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106510988,
    "dropsitcph": 4106510988,
    "dropfax": 4106510094
  },
  {
    "dcode": "D",
    "dropkey": "PV24638",
    "droptype": "D",
    "dropname": "WHALEYVILLE",
    "dropdeladd": "11721 SHEPPARDS CROSSING RD",
    "dropdelcty": "WHALEYVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 218729998,
    "dropphyadd": "11721 SHEPPARDS CROSSING RD",
    "dropphycty": "WHALEYVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 218729998,
    "dropmaladd": "11721 SHEPPARDS CROSSING RD",
    "dropmalcty": "WHALEYVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 218729998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4106411817,
    "dropsitcph": 4106411817,
    "dropfax": 4106290812
  },
  {
    "dcode": "D",
    "dropkey": "PV24643",
    "droptype": "D",
    "dropname": "WHITE HALL",
    "dropdeladd": "1415 WISEBURG RD",
    "dropdelcty": "WHITE HALL",
    "dropdelst": "MD",
    "dropdelzpp": 211619998,
    "dropphyadd": "1415 WISEBURG RD",
    "dropphycty": "WHITE HALL",
    "dropphyst": "MD",
    "dropphyzpp": 211619998,
    "dropmaladd": "1415 WISEBURG RD",
    "dropmalcty": "WHITE HALL",
    "dropmalst": "MD",
    "dropmalzpp": 211619998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103579886,
    "dropsitcph": 4103579886,
    "dropfax": 4103579960
  },
  {
    "dcode": "D",
    "dropkey": "PV24645",
    "droptype": "D",
    "dropname": "WHITE MARSH",
    "dropdeladd": "5422 EBENEZER RD",
    "dropdelcty": "WHITE MARSH",
    "dropdelst": "MD",
    "dropdelzpp": 211629998,
    "dropphyadd": "5422 EBENEZER RD",
    "dropphycty": "WHITE MARSH",
    "dropphyst": "MD",
    "dropphyzpp": 211629998,
    "dropmaladd": "5422 EBENEZER RD",
    "dropmalcty": "WHITE MARSH",
    "dropmalst": "MD",
    "dropmalzpp": 211629998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103357215,
    "dropsitcph": 4103357215,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24646",
    "droptype": "D",
    "dropname": "WHITE PLAINS",
    "dropdeladd": "4660 CRAIN HWY",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "MD",
    "dropdelzpp": 206959997,
    "dropphyadd": "4660 CRAIN HWY",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "MD",
    "dropphyzpp": 206959997,
    "dropmaladd": "4660 CRAIN HWY",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "MD",
    "dropmalzpp": 206959997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019322220,
    "dropsitcph": 3019322398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24648",
    "droptype": "D",
    "dropname": "WHITEFORD",
    "dropdeladd": "1508 MAIN ST STE 4",
    "dropdelcty": "WHITEFORD",
    "dropdelst": "MD",
    "dropdelzpp": 211609998,
    "dropphyadd": "1508 MAIN ST STE 4",
    "dropphycty": "WHITEFORD",
    "dropphyst": "MD",
    "dropphyzpp": 211609998,
    "dropmaladd": "1508 MAIN ST STE 4",
    "dropmalcty": "WHITEFORD",
    "dropmalst": "MD",
    "dropmalzpp": 211609998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4104520526,
    "dropsitcph": 4104520526,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24652",
    "droptype": "D",
    "dropname": "WILLARDS",
    "dropdeladd": "36311 RICHLAND RD",
    "dropdelcty": "WILLARDS",
    "dropdelst": "MD",
    "dropdelzpp": 218749998,
    "dropphyadd": "36311 RICHLAND RD",
    "dropphycty": "WILLARDS",
    "dropphyst": "MD",
    "dropphyzpp": 218749998,
    "dropmaladd": "36311 RICHLAND RD",
    "dropmalcty": "WILLARDS",
    "dropmalst": "MD",
    "dropmalzpp": 218749998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108358455,
    "dropsitcph": 4108358455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24655",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "28 W SALISBURY ST",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "MD",
    "dropdelzpp": 217959998,
    "dropphyadd": "28 W SALISBURY ST",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "MD",
    "dropphyzpp": 217959998,
    "dropmaladd": "28 W SALISBURY ST",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "MD",
    "dropmalzpp": 217959998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3012237007,
    "dropsitcph": 3012237007,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "PV24673",
    "droptype": "D",
    "dropname": "WITTMAN",
    "dropdeladd": "22611 POT PIE RD",
    "dropdelcty": "WITTMAN",
    "dropdelst": "MD",
    "dropdelzpp": 216769998,
    "dropphyadd": "22611 POT PIE RD",
    "dropphycty": "WITTMAN",
    "dropphyst": "MD",
    "dropphyzpp": 216769998,
    "dropmaladd": "22611 POT PIE RD",
    "dropmalcty": "WITTMAN",
    "dropmalst": "MD",
    "dropmalzpp": 216769998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107452815,
    "dropsitcph": 4107452815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24676",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "7623 WOODBINE RD",
    "dropdelcty": "WOODBINE",
    "dropdelst": "MD",
    "dropdelzpp": 217979998,
    "dropphyadd": "7623 WOODBINE RD",
    "dropphycty": "WOODBINE",
    "dropphyst": "MD",
    "dropphyzpp": 217979998,
    "dropmaladd": "7623 WOODBINE RD",
    "dropmalcty": "WOODBINE",
    "dropmalst": "MD",
    "dropmalzpp": 217979998,
    "dropsitphn": 3016823129,
    "dropsitlph": 4107959596,
    "dropsitcph": 4107959596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24688",
    "droptype": "D",
    "dropname": "WOODSBORO",
    "dropdeladd": "602 S MAIN ST",
    "dropdelcty": "WOODSBORO",
    "dropdelst": "MD",
    "dropdelzpp": 217989998,
    "dropphyadd": "602 S MAIN ST",
    "dropphycty": "WOODSBORO",
    "dropphyst": "MD",
    "dropphyzpp": 217989998,
    "dropmaladd": "602 S MAIN ST",
    "dropmalcty": "WOODSBORO",
    "dropmalst": "MD",
    "dropmalzpp": 217989998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3018458408,
    "dropsitcph": 3018458408,
    "dropfax": 3018456121
  },
  {
    "dcode": "D",
    "dropkey": "PV24691",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "10805 BIRMINGHAM WAY STE 25",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "MD",
    "dropdelzpp": 211631428,
    "dropphyadd": "10805 BIRMINGHAM WAY STE 25",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "MD",
    "dropphyzpp": 211631428,
    "dropmaladd": "10805 BIRMINGHAM WAY STE 25",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "MD",
    "dropmalzpp": 211631428,
    "dropsitphn": 4103474518,
    "dropsitlph": 4107501049,
    "dropsitcph": 4107501049,
    "dropfax": 4107501049
  },
  {
    "dcode": "D",
    "dropkey": "PV24697",
    "droptype": "D",
    "dropname": "WOOLFORD",
    "dropdeladd": "1614 TAYLORS ISLAND RD STE 1",
    "dropdelcty": "WOOLFORD",
    "dropdelst": "MD",
    "dropdelzpp": 216779998,
    "dropphyadd": "1614 TAYLORS ISLAND RD STE 1",
    "dropphycty": "WOOLFORD",
    "dropphyst": "MD",
    "dropphyzpp": 216779998,
    "dropmaladd": "1614 TAYLORS ISLAND RD STE 1",
    "dropmalcty": "WOOLFORD",
    "dropmalst": "MD",
    "dropmalzpp": 216779998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4102285344,
    "dropsitcph": 4102285344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24698",
    "droptype": "D",
    "dropname": "WORTON",
    "dropdeladd": "10802 WORTON RD",
    "dropdelcty": "WORTON",
    "dropdelst": "MD",
    "dropdelzpp": 216789998,
    "dropphyadd": "10802 WORTON RD",
    "dropphycty": "WORTON",
    "dropphyst": "MD",
    "dropphyzpp": 216789998,
    "dropmaladd": "10802 WORTON RD",
    "dropmalcty": "WORTON",
    "dropmalst": "MD",
    "dropmalzpp": 216789998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107783778,
    "dropsitcph": 4107783778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24700",
    "droptype": "D",
    "dropname": "WYE MILLS",
    "dropdeladd": "14278 OLD WYE MILLS RD",
    "dropdelcty": "WYE MILLS",
    "dropdelst": "MD",
    "dropdelzpp": 216799998,
    "dropphyadd": "14278 OLD WYE MILLS RD",
    "dropphycty": "WYE MILLS",
    "dropphyst": "MD",
    "dropphyzpp": 216799998,
    "dropmaladd": "14278 OLD WYE MILLS RD",
    "dropmalcty": "WYE MILLS",
    "dropmalst": "MD",
    "dropmalzpp": 216799998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4108278917,
    "dropsitcph": 4108278917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24706",
    "droptype": "D",
    "dropname": "ABBOT",
    "dropdeladd": "1 WEST RD",
    "dropdelcty": "ABBOT",
    "dropdelst": "ME",
    "dropdelzpp": "044069998",
    "dropphyadd": "1 WEST RD",
    "dropphycty": "ABBOT",
    "dropphyst": "ME",
    "dropphyzpp": "044069998",
    "dropmaladd": "1 WEST RD",
    "dropmalcty": "ABBOT",
    "dropmalst": "ME",
    "dropmalzpp": "044069998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078764009,
    "dropsitcph": 2078764009,
    "dropfax": 2078761040
  },
  {
    "dcode": "D",
    "dropkey": "PV24707",
    "droptype": "D",
    "dropname": "ACTON",
    "dropdeladd": "179 SAM PAGE RD",
    "dropdelcty": "ACTON",
    "dropdelst": "ME",
    "dropdelzpp": "040019998",
    "dropphyadd": "179 SAM PAGE RD",
    "dropphycty": "ACTON",
    "dropphyst": "ME",
    "dropphyzpp": "040019998",
    "dropmaladd": "179 SAM PAGE RD",
    "dropmalcty": "ACTON",
    "dropmalst": "ME",
    "dropmalzpp": "040019998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076361982,
    "dropsitcph": 2076361982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24708",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "297 WATER ST",
    "dropdelcty": "ADDISON",
    "dropdelst": "ME",
    "dropdelzpp": "046069998",
    "dropphyadd": "297 WATER ST",
    "dropphycty": "ADDISON",
    "dropphyst": "ME",
    "dropphyzpp": "046069998",
    "dropmaladd": "297 WATER ST",
    "dropmalcty": "ADDISON",
    "dropmalst": "ME",
    "dropmalzpp": "046069998",
    "dropsitphn": 2075102795,
    "dropsitlph": 3152156540,
    "dropsitcph": 3152156540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24709",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "36 MAIN ST",
    "dropdelcty": "ALBION",
    "dropdelst": "ME",
    "dropdelzpp": "049109998",
    "dropphyadd": "36 MAIN ST",
    "dropphycty": "ALBION",
    "dropphyst": "ME",
    "dropphyzpp": "049109998",
    "dropmaladd": "36 MAIN ST",
    "dropmalcty": "ALBION",
    "dropmalst": "ME",
    "dropmalzpp": "049109998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074372891,
    "dropsitcph": 2074372891,
    "dropfax": 2074372892
  },
  {
    "dcode": "D",
    "dropkey": "PV24710",
    "droptype": "D",
    "dropname": "ALFRED",
    "dropdeladd": "50 KENNEBUNK RD",
    "dropdelcty": "ALFRED",
    "dropdelst": "ME",
    "dropdelzpp": "040029998",
    "dropphyadd": "50 KENNEBUNK RD",
    "dropphycty": "ALFRED",
    "dropphyst": "ME",
    "dropphyzpp": "040029998",
    "dropmaladd": "50 KENNEBUNK RD",
    "dropmalcty": "ALFRED",
    "dropmalst": "ME",
    "dropmalzpp": "040029998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073245242,
    "dropsitcph": 2073245242,
    "dropfax": 2073246350
  },
  {
    "dcode": "D",
    "dropkey": "PV24712",
    "droptype": "D",
    "dropname": "ALNA",
    "dropdeladd": "148 DOCK RD",
    "dropdelcty": "ALNA",
    "dropdelst": "ME",
    "dropdelzpp": "045359998",
    "dropphyadd": "148 DOCK RD",
    "dropphycty": "ALNA",
    "dropphyst": "ME",
    "dropphyzpp": "045359998",
    "dropmaladd": "148 DOCK RD",
    "dropmalcty": "ALNA",
    "dropmalst": "ME",
    "dropmalzpp": "045359998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075865475,
    "dropsitcph": 2075865475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24713",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "6 CHURCH ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "ME",
    "dropdelzpp": "042169998",
    "dropphyadd": "6 CHURCH ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "ME",
    "dropphyzpp": "042169998",
    "dropmaladd": "6 CHURCH ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "ME",
    "dropmalzpp": "042169998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073924571,
    "dropsitcph": 2073924571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24714",
    "droptype": "D",
    "dropname": "ANSON",
    "dropdeladd": "72 MAIN ST",
    "dropdelcty": "ANSON",
    "dropdelst": "ME",
    "dropdelzpp": "049119998",
    "dropphyadd": "72 MAIN ST",
    "dropphycty": "ANSON",
    "dropphyst": "ME",
    "dropphyzpp": "049119998",
    "dropmaladd": "72 MAIN ST",
    "dropmalcty": "ANSON",
    "dropmalst": "ME",
    "dropmalzpp": "049119998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076963991,
    "dropsitcph": 2076963991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24718",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "14 SHERIDAN RD",
    "dropdelcty": "ASHLAND",
    "dropdelst": "ME",
    "dropdelzpp": "047329998",
    "dropphyadd": "14 SHERIDAN RD",
    "dropphycty": "ASHLAND",
    "dropphyst": "ME",
    "dropphyzpp": "047329998",
    "dropmaladd": "14 SHERIDAN RD",
    "dropmalcty": "ASHLAND",
    "dropmalst": "ME",
    "dropmalzpp": "047329998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074353321,
    "dropsitcph": 2074353321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24719",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "4 BRIGHTON RD",
    "dropdelcty": "ATHENS",
    "dropdelst": "ME",
    "dropdelzpp": "049129998",
    "dropphyadd": "4 BRIGHTON RD",
    "dropphycty": "ATHENS",
    "dropphyst": "ME",
    "dropphyzpp": "049129998",
    "dropmaladd": "4 BRIGHTON RD",
    "dropmalcty": "ATHENS",
    "dropmalst": "ME",
    "dropmalzpp": "049129998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076542733,
    "dropsitcph": 2076542733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24721",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "258 RODMAN RD",
    "dropdelcty": "AUBURN",
    "dropdelst": "ME",
    "dropdelzpp": "042109998",
    "dropphyadd": "258 RODMAN RD",
    "dropphycty": "AUBURN",
    "dropphyst": "ME",
    "dropphyzpp": "042109998",
    "dropmaladd": "258 RODMAN RD",
    "dropmalcty": "AUBURN",
    "dropmalst": "ME",
    "dropmalzpp": "042109998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077860604,
    "dropsitcph": 2077860604,
    "dropfax": 2077834647
  },
  {
    "dcode": "D",
    "dropkey": "PV24722",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "40 WESTERN AVE",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "ME",
    "dropdelzpp": "043309998",
    "dropphyadd": "40 WESTERN AVE",
    "dropphycty": "AUGUSTA",
    "dropphyst": "ME",
    "dropphyzpp": "043309998",
    "dropmaladd": "40 WESTERN AVE",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "ME",
    "dropmalzpp": "043309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076226114,
    "dropsitcph": 2076226114,
    "dropfax": 2076224586
  },
  {
    "dcode": "D",
    "dropkey": "PV24723",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "68 OLD AIRLINE RD",
    "dropdelcty": "AURORA",
    "dropdelst": "ME",
    "dropdelzpp": "044089998",
    "dropphyadd": "68 OLD AIRLINE RD",
    "dropphycty": "AURORA",
    "dropphyst": "ME",
    "dropphyzpp": "044089998",
    "dropmaladd": "68 OLD AIRLINE RD",
    "dropmalcty": "AURORA",
    "dropmalst": "ME",
    "dropmalzpp": "044089998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075845672,
    "dropsitcph": 2075845672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24724",
    "droptype": "D",
    "dropname": "BAILEY ISLAND",
    "dropdeladd": "2120 HARPSWELL ISLANDS RD",
    "dropdelcty": "BAILEY ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "040039998",
    "dropphyadd": "2120 HARPSWELL ISLANDS RD",
    "dropphycty": "BAILEY ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "040039998",
    "dropmaladd": "2120 HARPSWELL ISLANDS RD",
    "dropmalcty": "BAILEY ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "040039998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078335211,
    "dropsitcph": 2078335211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24727",
    "droptype": "D",
    "dropname": "BANGOR",
    "dropdeladd": "73 HAMMOND ST STE 9998",
    "dropdelcty": "BANGOR",
    "dropdelst": "ME",
    "dropdelzpp": "044019998",
    "dropphyadd": "73 HAMMOND ST STE 9998",
    "dropphycty": "BANGOR",
    "dropphyst": "ME",
    "dropphyzpp": "044019998",
    "dropmaladd": "73 HAMMOND ST STE 9998",
    "dropmalcty": "BANGOR",
    "dropmalst": "ME",
    "dropmalzpp": "044019998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079475629,
    "dropsitcph": 2079900520,
    "dropfax": 2079900521
  },
  {
    "dcode": "D",
    "dropkey": "PV24728",
    "droptype": "D",
    "dropname": "BAR HARBOR",
    "dropdeladd": "55 COTTAGE ST",
    "dropdelcty": "BAR HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046099998",
    "dropphyadd": "55 COTTAGE ST",
    "dropphycty": "BAR HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046099998",
    "dropmaladd": "55 COTTAGE ST",
    "dropmalcty": "BAR HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046099998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072883122,
    "dropsitcph": 2072883122,
    "dropfax": 2072885290
  },
  {
    "dcode": "D",
    "dropkey": "PV24729",
    "droptype": "D",
    "dropname": "BAR MILLS",
    "dropdeladd": "59 MAIN ST",
    "dropdelcty": "BAR MILLS",
    "dropdelst": "ME",
    "dropdelzpp": "040049998",
    "dropphyadd": "59 MAIN ST",
    "dropphycty": "BAR MILLS",
    "dropphyst": "ME",
    "dropphyzpp": "040049998",
    "dropmaladd": "59 MAIN ST",
    "dropmalcty": "BAR MILLS",
    "dropmalst": "ME",
    "dropmalzpp": "040049998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079296763,
    "dropsitcph": 2079296763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24730",
    "droptype": "D",
    "dropname": "BASS HARBOR",
    "dropdeladd": "209 HARBOR DR",
    "dropdelcty": "BASS HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046539998",
    "dropphyadd": "209 HARBOR DR",
    "dropphycty": "BASS HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046539998",
    "dropmaladd": "209 HARBOR DR",
    "dropmalcty": "BASS HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072445139,
    "dropsitcph": 2072445139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24732",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "750 WASHINGTON ST",
    "dropdelcty": "BATH",
    "dropdelst": "ME",
    "dropdelzpp": "045309998",
    "dropphyadd": "750 WASHINGTON ST",
    "dropphycty": "BATH",
    "dropphyst": "ME",
    "dropphyzpp": "045309998",
    "dropmaladd": "750 WASHINGTON ST",
    "dropmalcty": "BATH",
    "dropmalst": "ME",
    "dropmalzpp": "045309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074439778,
    "dropsitcph": 2074439778,
    "dropfax": 2074435435
  },
  {
    "dcode": "D",
    "dropkey": "PV24734",
    "droptype": "D",
    "dropname": "BEALS",
    "dropdeladd": "43 BAYVIEW DR",
    "dropdelcty": "BEALS",
    "dropdelst": "ME",
    "dropdelzpp": "046119998",
    "dropphyadd": "43 BAYVIEW DR",
    "dropphycty": "BEALS",
    "dropphyst": "ME",
    "dropphyzpp": "046119998",
    "dropmaladd": "43 BAYVIEW DR",
    "dropmalcty": "BEALS",
    "dropmalst": "ME",
    "dropmalzpp": "046119998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074972163,
    "dropsitcph": 2074972163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24735",
    "droptype": "D",
    "dropname": "BELFAST",
    "dropdeladd": "1 FRANKLIN ST",
    "dropdelcty": "BELFAST",
    "dropdelst": "ME",
    "dropdelzpp": "049159998",
    "dropphyadd": "1 FRANKLIN ST",
    "dropphycty": "BELFAST",
    "dropphyst": "ME",
    "dropphyzpp": "049159998",
    "dropmaladd": "1 FRANKLIN ST",
    "dropmalcty": "BELFAST",
    "dropmalst": "ME",
    "dropmalzpp": "049159998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073381820,
    "dropsitcph": 2073381820,
    "dropfax": 2073383788
  },
  {
    "dcode": "D",
    "dropkey": "PV24736",
    "droptype": "D",
    "dropname": "BELGRADE",
    "dropdeladd": "1010 AUGUSTA RD",
    "dropdelcty": "BELGRADE",
    "dropdelst": "ME",
    "dropdelzpp": "049179998",
    "dropphyadd": "1010 AUGUSTA RD",
    "dropphycty": "BELGRADE",
    "dropphyst": "ME",
    "dropphyzpp": "049179998",
    "dropmaladd": "1010 AUGUSTA RD",
    "dropmalcty": "BELGRADE",
    "dropmalst": "ME",
    "dropmalzpp": "049179998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074952011,
    "dropsitcph": 2074952011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24737",
    "droptype": "D",
    "dropname": "BELGRADE LAKES",
    "dropdeladd": "171 MAIN ST",
    "dropdelcty": "BELGRADE LAKES",
    "dropdelst": "ME",
    "dropdelzpp": "049189998",
    "dropphyadd": "171 MAIN ST",
    "dropphycty": "BELGRADE LAKES",
    "dropphyst": "ME",
    "dropphyzpp": "049189998",
    "dropmaladd": "171 MAIN ST",
    "dropmalcty": "BELGRADE LAKES",
    "dropmalst": "ME",
    "dropmalzpp": "049189998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074952064,
    "dropsitcph": 2074952064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24738",
    "droptype": "D",
    "dropname": "BENEDICTA",
    "dropdeladd": "6 SCHOOL ST",
    "dropdelcty": "BENEDICTA",
    "dropdelst": "ME",
    "dropdelzpp": "047339998",
    "dropphyadd": "6 SCHOOL ST",
    "dropphycty": "BENEDICTA",
    "dropphyst": "ME",
    "dropphyzpp": "047339998",
    "dropmaladd": "6 SCHOOL ST",
    "dropmalcty": "BENEDICTA",
    "dropmalst": "ME",
    "dropmalzpp": "047339998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073654809,
    "dropsitcph": 2073654809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24741",
    "droptype": "D",
    "dropname": "BERNARD",
    "dropdeladd": "71 BERNARD RD",
    "dropdelcty": "BERNARD",
    "dropdelst": "ME",
    "dropdelzpp": "046129998",
    "dropphyadd": "71 BERNARD RD",
    "dropphycty": "BERNARD",
    "dropphyst": "ME",
    "dropphyzpp": "046129998",
    "dropmaladd": "71 BERNARD RD",
    "dropmalcty": "BERNARD",
    "dropmalst": "ME",
    "dropmalzpp": "046129998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072445150,
    "dropsitcph": 2074011085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24742",
    "droptype": "D",
    "dropname": "BERWICK",
    "dropdeladd": "43 ROUTE 236",
    "dropdelcty": "BERWICK",
    "dropdelst": "ME",
    "dropdelzpp": "039019998",
    "dropphyadd": "43 ROUTE 236",
    "dropphycty": "BERWICK",
    "dropphyst": "ME",
    "dropphyzpp": "039019998",
    "dropmaladd": "43 ROUTE 236",
    "dropmalcty": "BERWICK",
    "dropmalst": "ME",
    "dropmalzpp": "039019998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077156001,
    "dropsitcph": 2077156001,
    "dropfax": 2076981017
  },
  {
    "dcode": "D",
    "dropkey": "PV24743",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "82 MAIN ST",
    "dropdelcty": "BETHEL",
    "dropdelst": "ME",
    "dropdelzpp": "042179998",
    "dropphyadd": "82 MAIN ST",
    "dropphycty": "BETHEL",
    "dropphyst": "ME",
    "dropphyzpp": "042179998",
    "dropmaladd": "82 MAIN ST",
    "dropmalcty": "BETHEL",
    "dropmalst": "ME",
    "dropmalzpp": "042179998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078242668,
    "dropsitcph": 2078242668,
    "dropfax": 2078242023
  },
  {
    "dcode": "D",
    "dropkey": "PV24744",
    "droptype": "D",
    "dropname": "BIDDEFORD",
    "dropdeladd": "100 ALFRED ST",
    "dropdelcty": "BIDDEFORD",
    "dropdelst": "ME",
    "dropdelzpp": "040059998",
    "dropphyadd": "100 ALFRED ST",
    "dropphycty": "BIDDEFORD",
    "dropphyst": "ME",
    "dropphyzpp": "040059998",
    "dropmaladd": "100 ALFRED ST",
    "dropmalcty": "BIDDEFORD",
    "dropmalst": "ME",
    "dropmalzpp": "040059998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072838565,
    "dropsitcph": 2072838565,
    "dropfax": 2072829929
  },
  {
    "dcode": "D",
    "dropkey": "PV24745",
    "droptype": "D",
    "dropname": "BIDDEFORD POOL",
    "dropdeladd": "8 LESTER B ORCUTT BLVD",
    "dropdelcty": "BIDDEFORD POOL",
    "dropdelst": "ME",
    "dropdelzpp": "040069998",
    "dropphyadd": "8 LESTER B ORCUTT BLVD",
    "dropphycty": "BIDDEFORD POOL",
    "dropphyst": "ME",
    "dropphyzpp": "040069998",
    "dropmaladd": "8 LESTER B ORCUTT BLVD",
    "dropmalcty": "BIDDEFORD POOL",
    "dropmalst": "ME",
    "dropmalzpp": "040069998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072826686,
    "dropsitcph": 2072826686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24746",
    "droptype": "D",
    "dropname": "BINGHAM",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "BINGHAM",
    "dropdelst": "ME",
    "dropdelzpp": "049209998",
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "BINGHAM",
    "dropphyst": "ME",
    "dropphyzpp": "049209998",
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "BINGHAM",
    "dropmalst": "ME",
    "dropmalzpp": "049209998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076722053,
    "dropsitcph": 2076722053,
    "dropfax": 2076723371
  },
  {
    "dcode": "D",
    "dropkey": "PV24747",
    "droptype": "D",
    "dropname": "BIRCH HARBOR",
    "dropdeladd": "3 E SCHOODIC DR",
    "dropdelcty": "BIRCH HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046139998",
    "dropphyadd": "3 E SCHOODIC DR",
    "dropphycty": "BIRCH HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046139998",
    "dropmaladd": "3 E SCHOODIC DR",
    "dropmalcty": "BIRCH HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046139998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079637652,
    "dropsitcph": 2079637652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24749",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "42 MILITARY RD",
    "dropdelcty": "BLAINE",
    "dropdelst": "ME",
    "dropdelzpp": "047349998",
    "dropphyadd": "42 MILITARY RD",
    "dropphycty": "BLAINE",
    "dropphyst": "ME",
    "dropphyzpp": "047349998",
    "dropmaladd": "42 MILITARY RD",
    "dropmalcty": "BLAINE",
    "dropmalst": "ME",
    "dropmalzpp": "047349998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074298236,
    "dropsitcph": 2074298236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24750",
    "droptype": "D",
    "dropname": "BLUE HILL",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "BLUE HILL",
    "dropdelst": "ME",
    "dropdelzpp": "046149998",
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "BLUE HILL",
    "dropphyst": "ME",
    "dropphyzpp": "046149998",
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "BLUE HILL",
    "dropmalst": "ME",
    "dropmalzpp": "046149998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073745667,
    "dropsitcph": 2073745667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24753",
    "droptype": "D",
    "dropname": "BOOTHBAY",
    "dropdeladd": "13 COREY LN",
    "dropdelcty": "BOOTHBAY",
    "dropdelst": "ME",
    "dropdelzpp": "045379998",
    "dropphyadd": "13 COREY LN",
    "dropphycty": "BOOTHBAY",
    "dropphyst": "ME",
    "dropphyzpp": "045379998",
    "dropmaladd": "13 COREY LN",
    "dropmalcty": "BOOTHBAY",
    "dropmalst": "ME",
    "dropmalzpp": "045379998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076337536,
    "dropsitcph": 2076337536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24754",
    "droptype": "D",
    "dropname": "BOOTHBAY HARBOR",
    "dropdeladd": "15 OAK ST",
    "dropdelcty": "BOOTHBAY HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "045389998",
    "dropphyadd": "15 OAK ST",
    "dropphycty": "BOOTHBAY HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "045389998",
    "dropmaladd": "15 OAK ST",
    "dropmalcty": "BOOTHBAY HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "045389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076333090,
    "dropsitcph": 2076333090,
    "dropfax": 2076336118
  },
  {
    "dcode": "D",
    "dropkey": "PV24755",
    "droptype": "D",
    "dropname": "BOWDOINHAM",
    "dropdeladd": "49 POND RD",
    "dropdelcty": "BOWDOINHAM",
    "dropdelst": "ME",
    "dropdelzpp": "040089998",
    "dropphyadd": "49 POND RD",
    "dropphycty": "BOWDOINHAM",
    "dropphyst": "ME",
    "dropphyzpp": "040089998",
    "dropmaladd": "49 POND RD",
    "dropmalcty": "BOWDOINHAM",
    "dropmalst": "ME",
    "dropmalzpp": "040089998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076663465,
    "dropsitcph": 2076663465,
    "dropfax": 2076663199
  },
  {
    "dcode": "D",
    "dropkey": "PV24756",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "11 STORER RD",
    "dropdelcty": "BRADFORD",
    "dropdelst": "ME",
    "dropdelzpp": "044109998",
    "dropphyadd": "11 STORER RD",
    "dropphycty": "BRADFORD",
    "dropphyst": "ME",
    "dropphyzpp": "044109998",
    "dropmaladd": "11 STORER RD",
    "dropmalcty": "BRADFORD",
    "dropmalst": "ME",
    "dropmalzpp": "044109998",
    "dropsitphn": 2075102795,
    "dropsitlph": 5856537426,
    "dropsitcph": 5856537426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24757",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "165A MAIN ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "ME",
    "dropdelzpp": "044119998",
    "dropphyadd": "165A MAIN ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "ME",
    "dropphyzpp": "044119998",
    "dropmaladd": "165A MAIN ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "ME",
    "dropmalzpp": "044119998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078276532,
    "dropsitcph": 2078276532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24758",
    "droptype": "D",
    "dropname": "BREWER",
    "dropdeladd": "22 PARKWAY S",
    "dropdelcty": "BREWER",
    "dropdelst": "ME",
    "dropdelzpp": "044129998",
    "dropphyadd": "22 PARKWAY S",
    "dropphycty": "BREWER",
    "dropphyst": "ME",
    "dropphyzpp": "044129998",
    "dropmaladd": "22 PARKWAY S",
    "dropmalcty": "BREWER",
    "dropmalst": "ME",
    "dropmalzpp": "044129998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079893855,
    "dropsitcph": 2079893855,
    "dropfax": 2079892841
  },
  {
    "dcode": "D",
    "dropkey": "PV24759",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "486 MAIN RD",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "ME",
    "dropdelzpp": "047359998",
    "dropphyadd": "486 MAIN RD",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "ME",
    "dropphyzpp": "047359998",
    "dropmaladd": "486 MAIN RD",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "ME",
    "dropmalzpp": "047359998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074298259,
    "dropsitcph": 2074298259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24760",
    "droptype": "D",
    "dropname": "BRIDGTON",
    "dropdeladd": "6 ELM ST",
    "dropdelcty": "BRIDGTON",
    "dropdelst": "ME",
    "dropdelzpp": "040099998",
    "dropphyadd": "6 ELM ST",
    "dropphycty": "BRIDGTON",
    "dropphyst": "ME",
    "dropphyzpp": "040099998",
    "dropmaladd": "6 ELM ST",
    "dropmalcty": "BRIDGTON",
    "dropmalst": "ME",
    "dropmalzpp": "040099998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076472081,
    "dropsitcph": 2076472081,
    "dropfax": 2076475714
  },
  {
    "dcode": "D",
    "dropkey": "PV24762",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "1249 BRISTOL RD",
    "dropdelcty": "BRISTOL",
    "dropdelst": "ME",
    "dropdelzpp": "045399998",
    "dropphyadd": "1249 BRISTOL RD",
    "dropphycty": "BRISTOL",
    "dropphyst": "ME",
    "dropphyzpp": "045399998",
    "dropmaladd": "1249 BRISTOL RD",
    "dropmalcty": "BRISTOL",
    "dropmalst": "ME",
    "dropmalzpp": "045399998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075616253,
    "dropsitcph": 2075616253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24763",
    "droptype": "D",
    "dropname": "BROOKLIN",
    "dropdeladd": "26 REACH RD",
    "dropdelcty": "BROOKLIN",
    "dropdelst": "ME",
    "dropdelzpp": "046169998",
    "dropphyadd": "26 REACH RD",
    "dropphycty": "BROOKLIN",
    "dropphyst": "ME",
    "dropphyzpp": "046169998",
    "dropmaladd": "26 REACH RD",
    "dropmalcty": "BROOKLIN",
    "dropmalst": "ME",
    "dropmalzpp": "046169998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073592088,
    "dropsitcph": 2073592088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24764",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "20 PURPLE HEART HWY",
    "dropdelcty": "BROOKS",
    "dropdelst": "ME",
    "dropdelzpp": "049219998",
    "dropphyadd": "20 PURPLE HEART HWY",
    "dropphycty": "BROOKS",
    "dropphyst": "ME",
    "dropphyzpp": "049219998",
    "dropmaladd": "20 PURPLE HEART HWY",
    "dropmalcty": "BROOKS",
    "dropmalst": "ME",
    "dropmalzpp": "049219998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773641308,
    "dropsitcph": 8773641308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24765",
    "droptype": "D",
    "dropname": "BROOKSVILLE",
    "dropdeladd": "945 COASTAL RD",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "046179998",
    "dropphyadd": "945 COASTAL RD",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "046179998",
    "dropmaladd": "945 COASTAL RD",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "046179998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076107641,
    "dropsitcph": 2076107641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24766",
    "droptype": "D",
    "dropname": "BROOKTON",
    "dropdeladd": "14 FOREST CITY RD",
    "dropdelcty": "BROOKTON",
    "dropdelst": "ME",
    "dropdelzpp": "044139998",
    "dropphyadd": "14 FOREST CITY RD",
    "dropphycty": "BROOKTON",
    "dropphyst": "ME",
    "dropphyzpp": "044139998",
    "dropmaladd": "14 FOREST CITY RD",
    "dropmalcty": "BROOKTON",
    "dropmalst": "ME",
    "dropmalzpp": "044139998",
    "dropsitphn": 2075102795,
    "dropsitlph": 5859022656,
    "dropsitcph": 5859022656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24767",
    "droptype": "D",
    "dropname": "BROWNFIELD",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "BROWNFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "040109998",
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "BROWNFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "040109998",
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "BROWNFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "040109998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079352713,
    "dropsitcph": 2079352713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24768",
    "droptype": "D",
    "dropname": "BROWNVILLE",
    "dropdeladd": "27 CHURCH ST",
    "dropdelcty": "BROWNVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "044149998",
    "dropphyadd": "27 CHURCH ST",
    "dropphycty": "BROWNVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "044149998",
    "dropmaladd": "27 CHURCH ST",
    "dropmalcty": "BROWNVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "044149998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079658520,
    "dropsitcph": 2079658520,
    "dropfax": 2079658742
  },
  {
    "dcode": "D",
    "dropkey": "PV24769",
    "droptype": "D",
    "dropname": "BROWNVILLE JUNCTION",
    "dropdeladd": "77 RAILROAD AVE",
    "dropdelcty": "BROWNVILLE JUNCTION",
    "dropdelst": "ME",
    "dropdelzpp": "044159998",
    "dropphyadd": "77 RAILROAD AVE",
    "dropphycty": "BROWNVILLE JUNCTION",
    "dropphyst": "ME",
    "dropphyzpp": "044159998",
    "dropmaladd": "77 RAILROAD AVE",
    "dropmalcty": "BROWNVILLE JUNCTION",
    "dropmalst": "ME",
    "dropmalzpp": "044159998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079658553,
    "dropsitcph": 2079658553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24770",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "30 PLEASANT ST",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "ME",
    "dropdelzpp": "040119998",
    "dropphyadd": "30 PLEASANT ST",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "ME",
    "dropphyzpp": "040119998",
    "dropmaladd": "30 PLEASANT ST",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "ME",
    "dropmalzpp": "040119998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077252542,
    "dropsitcph": 2077252542,
    "dropfax": 2077254902
  },
  {
    "dcode": "D",
    "dropkey": "PV24771",
    "droptype": "D",
    "dropname": "BRYANT POND",
    "dropdeladd": "1 N MAIN ST",
    "dropdelcty": "BRYANT POND",
    "dropdelst": "ME",
    "dropdelzpp": "042199998",
    "dropphyadd": "1 N MAIN ST",
    "dropphycty": "BRYANT POND",
    "dropphyst": "ME",
    "dropphyzpp": "042199998",
    "dropmaladd": "1 N MAIN ST",
    "dropmalcty": "BRYANT POND",
    "dropmalst": "ME",
    "dropmalzpp": "042199998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075078134,
    "dropsitcph": 2075078134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24772",
    "droptype": "D",
    "dropname": "BUCKFIELD",
    "dropdeladd": "8 TURNER ST",
    "dropdelcty": "BUCKFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "042209998",
    "dropphyadd": "8 TURNER ST",
    "dropphycty": "BUCKFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "042209998",
    "dropmaladd": "8 TURNER ST",
    "dropmalcty": "BUCKFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "042209998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075158632,
    "dropsitcph": 2075158632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24774",
    "droptype": "D",
    "dropname": "BUCKSPORT",
    "dropdeladd": "6 MECHANIC ST",
    "dropdelcty": "BUCKSPORT",
    "dropdelst": "ME",
    "dropdelzpp": "044169998",
    "dropphyadd": "6 MECHANIC ST",
    "dropphycty": "BUCKSPORT",
    "dropphyst": "ME",
    "dropphyzpp": "044169998",
    "dropmaladd": "6 MECHANIC ST",
    "dropmalcty": "BUCKSPORT",
    "dropmalst": "ME",
    "dropmalzpp": "044169998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074693621,
    "dropsitcph": 2074693621,
    "dropfax": 2074696039
  },
  {
    "dcode": "D",
    "dropkey": "PV24775",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "30 MAIN RD",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "044179998",
    "dropphyadd": "30 MAIN RD",
    "dropphycty": "BURLINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "044179998",
    "dropmaladd": "30 MAIN RD",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "044179998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078204250,
    "dropsitcph": 2078204250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24776",
    "droptype": "D",
    "dropname": "BURNHAM",
    "dropdeladd": "26 TROY RD",
    "dropdelcty": "BURNHAM",
    "dropdelst": "ME",
    "dropdelzpp": "049229998",
    "dropphyadd": "26 TROY RD",
    "dropphycty": "BURNHAM",
    "dropphyst": "ME",
    "dropphyzpp": "049229998",
    "dropmaladd": "26 TROY RD",
    "dropmalcty": "BURNHAM",
    "dropmalst": "ME",
    "dropmalzpp": "049229998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074872267,
    "dropsitcph": 2074872267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24780",
    "droptype": "D",
    "dropname": "CALAIS",
    "dropdeladd": "76 NORTH ST",
    "dropdelcty": "CALAIS",
    "dropdelst": "ME",
    "dropdelzpp": "046199998",
    "dropphyadd": "76 NORTH ST",
    "dropphycty": "CALAIS",
    "dropphyst": "ME",
    "dropphyzpp": "046199998",
    "dropmaladd": "76 NORTH ST",
    "dropmalcty": "CALAIS",
    "dropmalst": "ME",
    "dropmalzpp": "046199998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074542272,
    "dropsitcph": 2074542272,
    "dropfax": 2074548223
  },
  {
    "dcode": "D",
    "dropkey": "PV24781",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "ME",
    "dropdelzpp": "049239998",
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "ME",
    "dropphyzpp": "049239998",
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "ME",
    "dropmalzpp": "049239998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076145468,
    "dropsitcph": 2076145468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24782",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "28 CHESTNUT ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "ME",
    "dropdelzpp": "048439998",
    "dropphyadd": "28 CHESTNUT ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "ME",
    "dropphyzpp": "048439998",
    "dropmaladd": "28 CHESTNUT ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "ME",
    "dropmalzpp": "048439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072363570,
    "dropsitcph": 2072363570,
    "dropfax": 2072367019
  },
  {
    "dcode": "D",
    "dropkey": "PV24783",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "273 MAIN ST",
    "dropdelcty": "CANAAN",
    "dropdelst": "ME",
    "dropdelzpp": "049249998",
    "dropphyadd": "273 MAIN ST",
    "dropphycty": "CANAAN",
    "dropphyst": "ME",
    "dropphyzpp": "049249998",
    "dropmaladd": "273 MAIN ST",
    "dropmalcty": "CANAAN",
    "dropmalst": "ME",
    "dropmalzpp": "049249998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074743349,
    "dropsitcph": 2074743349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24784",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "13 MAIN ST",
    "dropdelcty": "CANTON",
    "dropdelst": "ME",
    "dropdelzpp": "042219998",
    "dropphyadd": "13 MAIN ST",
    "dropphycty": "CANTON",
    "dropphyst": "ME",
    "dropphyzpp": "042219998",
    "dropmaladd": "13 MAIN ST",
    "dropmalcty": "CANTON",
    "dropmalst": "ME",
    "dropmalzpp": "042219998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778543750,
    "dropsitcph": 8778543750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24787",
    "droptype": "D",
    "dropname": "CAPE NEDDICK",
    "dropdeladd": "1268 US ROUTE 1",
    "dropdelcty": "CAPE NEDDICK",
    "dropdelst": "ME",
    "dropdelzpp": "039029998",
    "dropphyadd": "1268 US ROUTE 1",
    "dropphycty": "CAPE NEDDICK",
    "dropphyst": "ME",
    "dropphyzpp": "039029998",
    "dropmaladd": "1268 US ROUTE 1",
    "dropmalcty": "CAPE NEDDICK",
    "dropmalst": "ME",
    "dropmalzpp": "039029998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073633813,
    "dropsitcph": 2073633813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24790",
    "droptype": "D",
    "dropname": "CARATUNK",
    "dropdeladd": "172 MAIN ST",
    "dropdelcty": "CARATUNK",
    "dropdelst": "ME",
    "dropdelzpp": "049259998",
    "dropphyadd": "172 MAIN ST",
    "dropphycty": "CARATUNK",
    "dropphyst": "ME",
    "dropphyzpp": "049259998",
    "dropmaladd": "172 MAIN ST",
    "dropmalcty": "CARATUNK",
    "dropmalst": "ME",
    "dropmalzpp": "049259998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076723416,
    "dropsitcph": 2076723416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24791",
    "droptype": "D",
    "dropname": "GREENBUSH",
    "dropdeladd": "1076 MAIN RD",
    "dropdelcty": "GREENBUSH",
    "dropdelst": "ME",
    "dropdelzpp": "044189998",
    "dropphyadd": "1076 MAIN RD",
    "dropphycty": "GREENBUSH",
    "dropphyst": "ME",
    "dropphyzpp": "044189998",
    "dropmaladd": "1076 MAIN RD",
    "dropmalcty": "GREENBUSH",
    "dropmalst": "ME",
    "dropmalzpp": "044189998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078204275,
    "dropsitcph": 2078204275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24792",
    "droptype": "D",
    "dropname": "CARIBOU",
    "dropdeladd": "41 SWEDEN ST",
    "dropdelcty": "CARIBOU",
    "dropdelst": "ME",
    "dropdelzpp": "047369998",
    "dropphyadd": "41 SWEDEN ST",
    "dropphycty": "CARIBOU",
    "dropphyst": "ME",
    "dropphyzpp": "047369998",
    "dropmaladd": "41 SWEDEN ST",
    "dropmalcty": "CARIBOU",
    "dropmalst": "ME",
    "dropmalzpp": "047369998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074920080,
    "dropsitcph": 2074920080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24793",
    "droptype": "D",
    "dropname": "CARMEL",
    "dropdeladd": "950 MAIN RD",
    "dropdelcty": "CARMEL",
    "dropdelst": "ME",
    "dropdelzpp": "044199998",
    "dropphyadd": "950 MAIN RD",
    "dropphycty": "CARMEL",
    "dropphyst": "ME",
    "dropphyzpp": "044199998",
    "dropmaladd": "950 MAIN RD",
    "dropmalcty": "CARMEL",
    "dropmalst": "ME",
    "dropmalzpp": "044199998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078483074,
    "dropsitcph": 2078483074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24795",
    "droptype": "D",
    "dropname": "CASCO",
    "dropdeladd": "942 MEADOW RD",
    "dropdelcty": "CASCO",
    "dropdelst": "ME",
    "dropdelzpp": "040159998",
    "dropphyadd": "942 MEADOW RD",
    "dropphycty": "CASCO",
    "dropphyst": "ME",
    "dropphyzpp": "040159998",
    "dropmaladd": "942 MEADOW RD",
    "dropmalcty": "CASCO",
    "dropmalst": "ME",
    "dropmalzpp": "040159998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076274892,
    "dropsitcph": 2076274892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24796",
    "droptype": "D",
    "dropname": "CASTINE",
    "dropdeladd": "43 MAIN ST",
    "dropdelcty": "CASTINE",
    "dropdelst": "ME",
    "dropdelzpp": "044219998",
    "dropphyadd": "43 MAIN ST",
    "dropphycty": "CASTINE",
    "dropphyst": "ME",
    "dropphyzpp": "044219998",
    "dropmaladd": "43 MAIN ST",
    "dropmalcty": "CASTINE",
    "dropmalst": "ME",
    "dropmalzpp": "044219998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073268551,
    "dropsitcph": 2073268551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24797",
    "droptype": "D",
    "dropname": "CENTER LOVELL",
    "dropdeladd": "11 OLD STAGE RD",
    "dropdelcty": "CENTER LOVELL",
    "dropdelst": "ME",
    "dropdelzpp": "040169998",
    "dropphyadd": "11 OLD STAGE RD",
    "dropphycty": "CENTER LOVELL",
    "dropphyst": "ME",
    "dropphyzpp": "040169998",
    "dropmaladd": "11 OLD STAGE RD",
    "dropmalcty": "CENTER LOVELL",
    "dropmalst": "ME",
    "dropmalzpp": "040169998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079253256,
    "dropsitcph": 2079253256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24799",
    "droptype": "D",
    "dropname": "CHAMBERLAIN",
    "dropdeladd": "419 STATE ROUTE 32",
    "dropdelcty": "CHAMBERLAIN",
    "dropdelst": "ME",
    "dropdelzpp": "045419998",
    "dropphyadd": "419 STATE ROUTE 32",
    "dropphycty": "CHAMBERLAIN",
    "dropphyst": "ME",
    "dropphyzpp": "045419998",
    "dropmaladd": "419 STATE ROUTE 32",
    "dropmalcty": "CHAMBERLAIN",
    "dropmalst": "ME",
    "dropmalzpp": "045419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778541625,
    "dropsitcph": 8778541625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24800",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "33 CHARLESTON RD",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "ME",
    "dropdelzpp": "044229998",
    "dropphyadd": "33 CHARLESTON RD",
    "dropphycty": "CHARLESTON",
    "dropphyst": "ME",
    "dropphyzpp": "044229998",
    "dropmaladd": "33 CHARLESTON RD",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "ME",
    "dropmalzpp": "044229998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072857997,
    "dropsitcph": 2072857997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24801",
    "droptype": "D",
    "dropname": "CHEBEAGUE ISLAND",
    "dropdeladd": "24 NIBLIC CIR STE 9998",
    "dropdelcty": "CHEBEAGUE ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "040179998",
    "dropphyadd": "24 NIBLIC CIR STE 9998",
    "dropphycty": "CHEBEAGUE ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "040179998",
    "dropmaladd": "24 NIBLIC CIR STE 9998",
    "dropmalcty": "CHEBEAGUE ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "040179998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078465820,
    "dropsitcph": 2078465820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24802",
    "droptype": "D",
    "dropname": "CHERRYFIELD",
    "dropdeladd": "14 MUNICIPAL WAY",
    "dropdelcty": "CHERRYFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "046229998",
    "dropphyadd": "14 MUNICIPAL WAY",
    "dropphycty": "CHERRYFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "046229998",
    "dropmaladd": "14 MUNICIPAL WAY",
    "dropmalcty": "CHERRYFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "046229998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074227137,
    "dropsitcph": 2074227137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24803",
    "droptype": "D",
    "dropname": "CHINA VILLAGE",
    "dropdeladd": "19 MAIN ST",
    "dropdelcty": "CHINA VILLAGE",
    "dropdelst": "ME",
    "dropdelzpp": "049269998",
    "dropphyadd": "19 MAIN ST",
    "dropphycty": "CHINA VILLAGE",
    "dropphyst": "ME",
    "dropphyzpp": "049269998",
    "dropmaladd": "19 MAIN ST",
    "dropmalcty": "CHINA VILLAGE",
    "dropmalst": "ME",
    "dropmalzpp": "049269998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079682623,
    "dropsitcph": 2079682623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24805",
    "droptype": "D",
    "dropname": "CLIFF ISLAND",
    "dropdeladd": "11 SUNSET RD UNIT 1",
    "dropdelcty": "CLIFF ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "040199998",
    "dropphyadd": "11 SUNSET RD UNIT 1",
    "dropphycty": "CLIFF ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "040199998",
    "dropmaladd": "11 SUNSET RD UNIT 1",
    "dropmalcty": "CLIFF ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "040199998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077662051,
    "dropsitcph": 2077662051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24806",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "15 RAILROAD ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "ME",
    "dropdelzpp": "049279998",
    "dropphyadd": "15 RAILROAD ST",
    "dropphycty": "CLINTON",
    "dropphyst": "ME",
    "dropphyzpp": "049279998",
    "dropmaladd": "15 RAILROAD ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "ME",
    "dropmalzpp": "049279998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074268971,
    "dropsitcph": 2074268971,
    "dropfax": 2074268067
  },
  {
    "dcode": "D",
    "dropkey": "PV24808",
    "droptype": "D",
    "dropname": "COLUMBIA FALLS",
    "dropdeladd": "169 MAIN ST",
    "dropdelcty": "COLUMBIA FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "046239998",
    "dropphyadd": "169 MAIN ST",
    "dropphycty": "COLUMBIA FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "046239998",
    "dropmaladd": "169 MAIN ST",
    "dropmalcty": "COLUMBIA FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "046239998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074832302,
    "dropsitcph": 2074832302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24809",
    "droptype": "D",
    "dropname": "COOPERS MILLS",
    "dropdeladd": "128 MAIN ST",
    "dropdelcty": "COOPERS MILLS",
    "dropdelst": "ME",
    "dropdelzpp": "043419998",
    "dropphyadd": "128 MAIN ST",
    "dropphycty": "COOPERS MILLS",
    "dropphyst": "ME",
    "dropphyzpp": "043419998",
    "dropmaladd": "128 MAIN ST",
    "dropmalcty": "COOPERS MILLS",
    "dropmalst": "ME",
    "dropmalzpp": "043419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075497961,
    "dropsitcph": 2075497961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24810",
    "droptype": "D",
    "dropname": "COREA",
    "dropdeladd": "646 COREA RD",
    "dropdelcty": "COREA",
    "dropdelst": "ME",
    "dropdelzpp": "046249998",
    "dropphyadd": "646 COREA RD",
    "dropphycty": "COREA",
    "dropphyst": "ME",
    "dropphyzpp": "046249998",
    "dropmaladd": "646 COREA RD",
    "dropmalcty": "COREA",
    "dropmalst": "ME",
    "dropmalzpp": "046249998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079632277,
    "dropsitcph": 2079632277,
    "dropfax": 2079632778
  },
  {
    "dcode": "D",
    "dropkey": "PV24811",
    "droptype": "D",
    "dropname": "CORINNA",
    "dropdeladd": "15 EXETER RD",
    "dropdelcty": "CORINNA",
    "dropdelst": "ME",
    "dropdelzpp": "049289998",
    "dropphyadd": "15 EXETER RD",
    "dropphycty": "CORINNA",
    "dropphyst": "ME",
    "dropphyzpp": "049289998",
    "dropmaladd": "15 EXETER RD",
    "dropmalcty": "CORINNA",
    "dropmalst": "ME",
    "dropmalzpp": "049289998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072784892,
    "dropsitcph": 2072784892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24813",
    "droptype": "D",
    "dropname": "CORNISH",
    "dropdeladd": "202 MAPLE ST STE 1",
    "dropdelcty": "CORNISH",
    "dropdelst": "ME",
    "dropdelzpp": "040209998",
    "dropphyadd": "202 MAPLE ST STE 1",
    "dropphycty": "CORNISH",
    "dropphyst": "ME",
    "dropphyzpp": "040209998",
    "dropmaladd": "202 MAPLE ST STE 1",
    "dropmalcty": "CORNISH",
    "dropmalst": "ME",
    "dropmalzpp": "040209998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076253218,
    "dropsitcph": 2076253218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24816",
    "droptype": "D",
    "dropname": "CRANBERRY ISLES",
    "dropdeladd": "1 FRENCHMAN BAY",
    "dropdelcty": "CRANBERRY ISLES",
    "dropdelst": "ME",
    "dropdelzpp": "046259998",
    "dropphyadd": "1 FRENCHMAN BAY",
    "dropphycty": "CRANBERRY ISLES",
    "dropphyst": "ME",
    "dropphyzpp": "046259998",
    "dropmaladd": "1 FRENCHMAN BAY",
    "dropmalcty": "CRANBERRY ISLES",
    "dropmalst": "ME",
    "dropmalzpp": "046259998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078132125,
    "dropsitcph": 2078132125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24817",
    "droptype": "D",
    "dropname": "CROUSEVILLE",
    "dropdeladd": "437 WASHBURN RD",
    "dropdelcty": "CROUSEVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "047389998",
    "dropphyadd": "437 WASHBURN RD",
    "dropphycty": "CROUSEVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "047389998",
    "dropmaladd": "437 WASHBURN RD",
    "dropmalcty": "CROUSEVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "047389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074555804,
    "dropsitcph": 2074555804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24819",
    "droptype": "D",
    "dropname": "CUMBERLAND CENTER",
    "dropdeladd": "1 FARWELL AVE",
    "dropdelcty": "CUMBERLAND CENTER",
    "dropdelst": "ME",
    "dropdelzpp": "040219998",
    "dropphyadd": "1 FARWELL AVE",
    "dropphycty": "CUMBERLAND CENTER",
    "dropphyst": "ME",
    "dropphyzpp": "040219998",
    "dropmaladd": "1 FARWELL AVE",
    "dropmalcty": "CUMBERLAND CENTER",
    "dropmalst": "ME",
    "dropmalzpp": "040219998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078293661,
    "dropsitcph": 2078293661,
    "dropfax": 2078299121
  },
  {
    "dcode": "D",
    "dropkey": "PV24822",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "384 PLEASANT POINT RD",
    "dropdelcty": "CUSHING",
    "dropdelst": "ME",
    "dropdelzpp": "045639998",
    "dropphyadd": "384 PLEASANT POINT RD",
    "dropphycty": "CUSHING",
    "dropphyst": "ME",
    "dropphyzpp": "045639998",
    "dropmaladd": "384 PLEASANT POINT RD",
    "dropmalcty": "CUSHING",
    "dropmalst": "ME",
    "dropmalzpp": "045639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073548014,
    "dropsitcph": 2073548014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24824",
    "droptype": "D",
    "dropname": "CUTLER",
    "dropdeladd": "2739 CUTLER RD",
    "dropdelcty": "CUTLER",
    "dropdelst": "ME",
    "dropdelzpp": "046269998",
    "dropphyadd": "2739 CUTLER RD",
    "dropphycty": "CUTLER",
    "dropphyst": "ME",
    "dropphyzpp": "046269998",
    "dropmaladd": "2739 CUTLER RD",
    "dropmalcty": "CUTLER",
    "dropmalst": "ME",
    "dropmalzpp": "046269998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072594493,
    "dropsitcph": 2072594493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24825",
    "droptype": "D",
    "dropname": "DAMARISCOTTA",
    "dropdeladd": "173 MAIN ST",
    "dropdelcty": "DAMARISCOTTA",
    "dropdelst": "ME",
    "dropdelzpp": "045439998",
    "dropphyadd": "173 MAIN ST",
    "dropphycty": "DAMARISCOTTA",
    "dropphyst": "ME",
    "dropphyzpp": "045439998",
    "dropmaladd": "173 MAIN ST",
    "dropmalcty": "DAMARISCOTTA",
    "dropmalst": "ME",
    "dropmalzpp": "045439998",
    "dropsitphn": 2075633203,
    "dropsitlph": 2075633203,
    "dropsitcph": 2075633203,
    "dropfax": 2075633253
  },
  {
    "dcode": "D",
    "dropkey": "PV24826",
    "droptype": "D",
    "dropname": "DANFORTH",
    "dropdeladd": "33 SPRINGFIELD RD",
    "dropdelcty": "DANFORTH",
    "dropdelst": "ME",
    "dropdelzpp": "044249998",
    "dropphyadd": "33 SPRINGFIELD RD",
    "dropphycty": "DANFORTH",
    "dropphyst": "ME",
    "dropphyzpp": "044249998",
    "dropmaladd": "33 SPRINGFIELD RD",
    "dropmalcty": "DANFORTH",
    "dropmalst": "ME",
    "dropmalzpp": "044249998",
    "dropsitphn": 8389003857,
    "dropsitlph": 6072471269,
    "dropsitcph": 6072471269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24827",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "25 DUNLAP ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "042239998",
    "dropphyadd": "25 DUNLAP ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "042239998",
    "dropmaladd": "25 DUNLAP ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "042239998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077822533,
    "dropsitcph": 2077822533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24829",
    "droptype": "D",
    "dropname": "DEER ISLE",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "DEER ISLE",
    "dropdelst": "ME",
    "dropdelzpp": "046279998",
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "DEER ISLE",
    "dropphyst": "ME",
    "dropphyzpp": "046279998",
    "dropmaladd": "12 MAIN ST",
    "dropmalcty": "DEER ISLE",
    "dropmalst": "ME",
    "dropmalzpp": "046279998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073486944,
    "dropsitcph": 2073486944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24830",
    "droptype": "D",
    "dropname": "DENMARK",
    "dropdeladd": "39 E MAIN ST",
    "dropdelcty": "DENMARK",
    "dropdelst": "ME",
    "dropdelzpp": "040229998",
    "dropphyadd": "39 E MAIN ST",
    "dropphycty": "DENMARK",
    "dropphyst": "ME",
    "dropphyzpp": "040229998",
    "dropmaladd": "39 E MAIN ST",
    "dropmalcty": "DENMARK",
    "dropmalst": "ME",
    "dropmalzpp": "040229998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779072796,
    "dropsitcph": 8779072796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24831",
    "droptype": "D",
    "dropname": "DENNYSVILLE",
    "dropdeladd": "128 MAIN ST",
    "dropdelcty": "DENNYSVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "046289998",
    "dropphyadd": "128 MAIN ST",
    "dropphycty": "DENNYSVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "046289998",
    "dropmaladd": "128 MAIN ST",
    "dropmalcty": "DENNYSVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "046289998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077265050,
    "dropsitcph": 2077265050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24833",
    "droptype": "D",
    "dropname": "DETROIT",
    "dropdeladd": "21 MAIN ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "ME",
    "dropdelzpp": "049299998",
    "dropphyadd": "21 MAIN ST",
    "dropphycty": "DETROIT",
    "dropphyst": "ME",
    "dropphyzpp": "049299998",
    "dropmaladd": "21 MAIN ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "ME",
    "dropmalzpp": "049299998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074264916,
    "dropsitcph": 2074264916,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24834",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "2 POST OFFICE RD",
    "dropdelcty": "DEXTER",
    "dropdelst": "ME",
    "dropdelzpp": "049309998",
    "dropphyadd": "2 POST OFFICE RD",
    "dropphycty": "DEXTER",
    "dropphyst": "ME",
    "dropphyzpp": "049309998",
    "dropmaladd": "2 POST OFFICE RD",
    "dropmalcty": "DEXTER",
    "dropmalst": "ME",
    "dropmalzpp": "049309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079247500,
    "dropsitcph": 2079247500,
    "dropfax": 2079245833
  },
  {
    "dcode": "D",
    "dropkey": "PV24836",
    "droptype": "D",
    "dropname": "DIXFIELD",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "DIXFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "042249998",
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "DIXFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "042249998",
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "DIXFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "042249998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075624931,
    "dropsitcph": 2075624931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24837",
    "droptype": "D",
    "dropname": "DIXMONT",
    "dropdeladd": "975 WESTERN AVE",
    "dropdelcty": "DIXMONT",
    "dropdelst": "ME",
    "dropdelzpp": "049329998",
    "dropphyadd": "975 WESTERN AVE",
    "dropphycty": "DIXMONT",
    "dropphyst": "ME",
    "dropphyzpp": "049329998",
    "dropmaladd": "975 WESTERN AVE",
    "dropmalcty": "DIXMONT",
    "dropmalst": "ME",
    "dropmalzpp": "049329998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075485712,
    "dropsitcph": 2075485712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24838",
    "droptype": "D",
    "dropname": "DOVER FOXCROFT",
    "dropdeladd": "41 NORTH ST",
    "dropdelcty": "DOVER FOXCROFT",
    "dropdelst": "ME",
    "dropdelzpp": "044269998",
    "dropphyadd": "41 NORTH ST",
    "dropphycty": "DOVER FOXCROFT",
    "dropphyst": "ME",
    "dropphyzpp": "044269998",
    "dropmaladd": "41 NORTH ST",
    "dropmalcty": "DOVER FOXCROFT",
    "dropmalst": "ME",
    "dropmalzpp": "044269998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075642511,
    "dropsitcph": 2075642511,
    "dropfax": 2075640734
  },
  {
    "dcode": "D",
    "dropkey": "PV24840",
    "droptype": "D",
    "dropname": "DRESDEN",
    "dropdeladd": "12 MIDDLE RD",
    "dropdelcty": "DRESDEN",
    "dropdelst": "ME",
    "dropdelzpp": "043429998",
    "dropphyadd": "12 MIDDLE RD",
    "dropphycty": "DRESDEN",
    "dropphyst": "ME",
    "dropphyzpp": "043429998",
    "dropmaladd": "12 MIDDLE RD",
    "dropmalcty": "DRESDEN",
    "dropmalst": "ME",
    "dropmalzpp": "043429998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077372897,
    "dropsitcph": 2077372897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24842",
    "droptype": "D",
    "dropname": "DRYDEN",
    "dropdeladd": "6 MUNSON RD",
    "dropdelcty": "DRYDEN",
    "dropdelst": "ME",
    "dropdelzpp": "042259998",
    "dropphyadd": "6 MUNSON RD",
    "dropphycty": "DRYDEN",
    "dropphyst": "ME",
    "dropphyzpp": "042259998",
    "dropmaladd": "6 MUNSON RD",
    "dropmalcty": "DRYDEN",
    "dropmalst": "ME",
    "dropmalzpp": "042259998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076454535,
    "dropsitcph": 2076454535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24844",
    "droptype": "D",
    "dropname": "EAGLE LAKE",
    "dropdeladd": "3315 AROOSTOOK RD",
    "dropdelcty": "EAGLE LAKE",
    "dropdelst": "ME",
    "dropdelzpp": "047399998",
    "dropphyadd": "3315 AROOSTOOK RD",
    "dropphycty": "EAGLE LAKE",
    "dropphyst": "ME",
    "dropphyzpp": "047399998",
    "dropmaladd": "3315 AROOSTOOK RD",
    "dropmalcty": "EAGLE LAKE",
    "dropmalst": "ME",
    "dropmalzpp": "047399998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773642019,
    "dropsitcph": 8773642019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24845",
    "droptype": "D",
    "dropname": "EAST ANDOVER",
    "dropdeladd": "466 E ANDOVER RD",
    "dropdelcty": "EAST ANDOVER",
    "dropdelst": "ME",
    "dropdelzpp": "042269998",
    "dropphyadd": "466 E ANDOVER RD",
    "dropphycty": "EAST ANDOVER",
    "dropphyst": "ME",
    "dropphyzpp": "042269998",
    "dropmaladd": "466 E ANDOVER RD",
    "dropmalcty": "EAST ANDOVER",
    "dropmalst": "ME",
    "dropmalzpp": "042269998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073921223,
    "dropsitcph": 2073921223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24846",
    "droptype": "D",
    "dropname": "EAST BALDWIN",
    "dropdeladd": "213 PEQUAWKET TRL",
    "dropdelcty": "EAST BALDWIN",
    "dropdelst": "ME",
    "dropdelzpp": "040249998",
    "dropphyadd": "213 PEQUAWKET TRL",
    "dropphycty": "EAST BALDWIN",
    "dropphyst": "ME",
    "dropphyzpp": "040249998",
    "dropmaladd": "213 PEQUAWKET TRL",
    "dropmalcty": "EAST BALDWIN",
    "dropmalst": "ME",
    "dropmalzpp": "040249998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077872544,
    "dropsitcph": 2077872544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24848",
    "droptype": "D",
    "dropname": "EAST BOOTHBAY",
    "dropdeladd": "216A OCEAN POINT RD",
    "dropdelcty": "EAST BOOTHBAY",
    "dropdelst": "ME",
    "dropdelzpp": "045449998",
    "dropphyadd": "216A OCEAN POINT RD",
    "dropphycty": "EAST BOOTHBAY",
    "dropphyst": "ME",
    "dropphyzpp": "045449998",
    "dropmaladd": "216A OCEAN POINT RD",
    "dropmalcty": "EAST BOOTHBAY",
    "dropmalst": "ME",
    "dropmalzpp": "045449998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076333553,
    "dropsitcph": 2076333553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24849",
    "droptype": "D",
    "dropname": "CORINTH",
    "dropdeladd": "274 MAIN ST",
    "dropdelcty": "CORINTH",
    "dropdelst": "ME",
    "dropdelzpp": "044279998",
    "dropphyadd": "274 MAIN ST",
    "dropphycty": "CORINTH",
    "dropphyst": "ME",
    "dropphyzpp": "044279998",
    "dropmaladd": "274 MAIN ST",
    "dropmalcty": "CORINTH",
    "dropmalst": "ME",
    "dropmalzpp": "044279998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072853316,
    "dropsitcph": 2072853316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24851",
    "droptype": "D",
    "dropname": "EAST DIXFIELD",
    "dropdeladd": "963 US ROUTE 2 W",
    "dropdelcty": "EAST DIXFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "042279998",
    "dropphyadd": "963 US ROUTE 2 W",
    "dropphycty": "EAST DIXFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "042279998",
    "dropmaladd": "963 US ROUTE 2 W",
    "dropmalcty": "EAST DIXFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "042279998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076453254,
    "dropsitcph": 2076453254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24852",
    "droptype": "D",
    "dropname": "EDDINGTON",
    "dropdeladd": "1042 MAIN RD",
    "dropdelcty": "EDDINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "044289998",
    "dropphyadd": "1042 MAIN RD",
    "dropphycty": "EDDINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "044289998",
    "dropmaladd": "1042 MAIN RD",
    "dropmalcty": "EDDINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "044289998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078436519,
    "dropsitcph": 2078436519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24854",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "966 MAIN RD",
    "dropdelcty": "HOLDEN",
    "dropdelst": "ME",
    "dropdelzpp": "044299998",
    "dropphyadd": "966 MAIN RD",
    "dropphycty": "HOLDEN",
    "dropphyst": "ME",
    "dropphyzpp": "044299998",
    "dropmaladd": "966 MAIN RD",
    "dropmalcty": "HOLDEN",
    "dropmalst": "ME",
    "dropmalzpp": "044299998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078436474,
    "dropsitcph": 2078436474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24855",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "5 LITTLE RIVER RD",
    "dropdelcty": "LEBANON",
    "dropdelst": "ME",
    "dropdelzpp": "040279998",
    "dropphyadd": "5 LITTLE RIVER RD",
    "dropphycty": "LEBANON",
    "dropphyst": "ME",
    "dropphyzpp": "040279998",
    "dropmaladd": "5 LITTLE RIVER RD",
    "dropmalcty": "LEBANON",
    "dropmalst": "ME",
    "dropmalzpp": "040279998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074571271,
    "dropsitcph": 2074571271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24856",
    "droptype": "D",
    "dropname": "EAST LIVERMORE",
    "dropdeladd": "1047 PARK ST",
    "dropdelcty": "EAST LIVERMORE",
    "dropdelst": "ME",
    "dropdelzpp": "042289998",
    "dropphyadd": "1047 PARK ST",
    "dropphycty": "EAST LIVERMORE",
    "dropphyst": "ME",
    "dropphyzpp": "042289998",
    "dropmaladd": "1047 PARK ST",
    "dropmalcty": "EAST LIVERMORE",
    "dropmalst": "ME",
    "dropmalzpp": "042289998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078976948,
    "dropsitcph": 2078976948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24857",
    "droptype": "D",
    "dropname": "EAST MACHIAS",
    "dropdeladd": "580 MAIN ST",
    "dropdelcty": "EAST MACHIAS",
    "dropdelst": "ME",
    "dropdelzpp": "046309998",
    "dropphyadd": "580 MAIN ST",
    "dropphycty": "EAST MACHIAS",
    "dropphyst": "ME",
    "dropphyzpp": "046309998",
    "dropmaladd": "580 MAIN ST",
    "dropmalcty": "EAST MACHIAS",
    "dropmalst": "ME",
    "dropmalzpp": "046309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072558380,
    "dropsitcph": 2072558380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24858",
    "droptype": "D",
    "dropname": "EAST MILLINOCKET",
    "dropdeladd": "95 MAIN ST",
    "dropdelcty": "EAST MILLINOCKET",
    "dropdelst": "ME",
    "dropdelzpp": "044309998",
    "dropphyadd": "95 MAIN ST",
    "dropphycty": "EAST MILLINOCKET",
    "dropphyst": "ME",
    "dropphyzpp": "044309998",
    "dropmaladd": "95 MAIN ST",
    "dropmalcty": "EAST MILLINOCKET",
    "dropmalst": "ME",
    "dropmalzpp": "044309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077460160,
    "dropsitcph": 2077460160,
    "dropfax": 2077463866
  },
  {
    "dcode": "D",
    "dropkey": "PV24859",
    "droptype": "D",
    "dropname": "EAST NEWPORT",
    "dropdeladd": "679 ELM ST",
    "dropdelcty": "EAST NEWPORT",
    "dropdelst": "ME",
    "dropdelzpp": "049339998",
    "dropphyadd": "679 ELM ST",
    "dropphycty": "EAST NEWPORT",
    "dropphyst": "ME",
    "dropphyzpp": "049339998",
    "dropmaladd": "679 ELM ST",
    "dropmalcty": "EAST NEWPORT",
    "dropmalst": "ME",
    "dropmalzpp": "049339998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074264861,
    "dropsitcph": 2074264861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24860",
    "droptype": "D",
    "dropname": "EAST ORLAND",
    "dropdeladd": "986 ACADIA HWY",
    "dropdelcty": "EAST ORLAND",
    "dropdelst": "ME",
    "dropdelzpp": "044319998",
    "dropphyadd": "986 ACADIA HWY",
    "dropphycty": "EAST ORLAND",
    "dropphyst": "ME",
    "dropphyzpp": "044319998",
    "dropmaladd": "986 ACADIA HWY",
    "dropmalcty": "EAST ORLAND",
    "dropmalst": "ME",
    "dropmalzpp": "044319998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074691170,
    "dropsitcph": 2074691170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24861",
    "droptype": "D",
    "dropname": "EAST PARSONSFIELD",
    "dropdeladd": "1682 NORTH RD",
    "dropdelcty": "EAST PARSONSFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "040289998",
    "dropphyadd": "1682 NORTH RD",
    "dropphycty": "EAST PARSONSFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "040289998",
    "dropmaladd": "1682 NORTH RD",
    "dropmalcty": "EAST PARSONSFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "040289998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077934815,
    "dropsitcph": 2077934815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24862",
    "droptype": "D",
    "dropname": "EAST POLAND",
    "dropdeladd": "726 EMPIRE RD",
    "dropdelcty": "EAST POLAND",
    "dropdelst": "ME",
    "dropdelzpp": "042309998",
    "dropphyadd": "726 EMPIRE RD",
    "dropphycty": "EAST POLAND",
    "dropphyst": "ME",
    "dropphyzpp": "042309998",
    "dropmaladd": "726 EMPIRE RD",
    "dropmalcty": "EAST POLAND",
    "dropmalst": "ME",
    "dropmalzpp": "042309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079984549,
    "dropsitcph": 2079984549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24863",
    "droptype": "D",
    "dropname": "SEBAGO",
    "dropdeladd": "222 SEBAGO RD",
    "dropdelcty": "SEBAGO",
    "dropdelst": "ME",
    "dropdelzpp": "040299998",
    "dropphyadd": "222 SEBAGO RD",
    "dropphycty": "SEBAGO",
    "dropphyst": "ME",
    "dropphyzpp": "040299998",
    "dropmaladd": "222 SEBAGO RD",
    "dropmalcty": "SEBAGO",
    "dropmalst": "ME",
    "dropmalzpp": "040299998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778546227,
    "dropsitcph": 8778546227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24864",
    "droptype": "D",
    "dropname": "STONEHAM",
    "dropdeladd": "341 MAINE ST",
    "dropdelcty": "STONEHAM",
    "dropdelst": "ME",
    "dropdelzpp": "042319998",
    "dropphyadd": "341 MAINE ST",
    "dropphycty": "STONEHAM",
    "dropphyst": "ME",
    "dropphyzpp": "042319998",
    "dropmaladd": "341 MAINE ST",
    "dropmalcty": "STONEHAM",
    "dropmalst": "ME",
    "dropmalzpp": "042319998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773642656,
    "dropsitcph": 8773642656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24865",
    "droptype": "D",
    "dropname": "EAST VASSALBORO",
    "dropdeladd": "351 MAIN ST",
    "dropdelcty": "EAST VASSALBORO",
    "dropdelst": "ME",
    "dropdelzpp": "049359998",
    "dropphyadd": "351 MAIN ST",
    "dropphycty": "EAST VASSALBORO",
    "dropphyst": "ME",
    "dropphyzpp": "049359998",
    "dropmaladd": "351 MAIN ST",
    "dropmalcty": "EAST VASSALBORO",
    "dropmalst": "ME",
    "dropmalzpp": "049359998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079233997,
    "dropsitcph": 2079233997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24866",
    "droptype": "D",
    "dropname": "EAST WATERBORO",
    "dropdeladd": "171 MAIN ST",
    "dropdelcty": "EAST WATERBORO",
    "dropdelst": "ME",
    "dropdelzpp": "040309998",
    "dropphyadd": "171 MAIN ST",
    "dropphycty": "EAST WATERBORO",
    "dropphyst": "ME",
    "dropphyzpp": "040309998",
    "dropmaladd": "171 MAIN ST",
    "dropmalcty": "EAST WATERBORO",
    "dropmalst": "ME",
    "dropmalzpp": "040309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072474225,
    "dropsitcph": 2072474225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24868",
    "droptype": "D",
    "dropname": "EAST WILTON",
    "dropdeladd": "1328 MAIN ST",
    "dropdelcty": "EAST WILTON",
    "dropdelst": "ME",
    "dropdelzpp": "042349998",
    "dropphyadd": "1328 MAIN ST",
    "dropphycty": "EAST WILTON",
    "dropphyst": "ME",
    "dropphyzpp": "042349998",
    "dropmaladd": "1328 MAIN ST",
    "dropmalcty": "EAST WILTON",
    "dropmalst": "ME",
    "dropmalzpp": "042349998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076454542,
    "dropsitcph": 2076454542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24869",
    "droptype": "D",
    "dropname": "EAST WINTHROP",
    "dropdeladd": "2402 US ROUTE 202",
    "dropdelcty": "EAST WINTHROP",
    "dropdelst": "ME",
    "dropdelzpp": "043439998",
    "dropphyadd": "2402 US ROUTE 202",
    "dropphycty": "EAST WINTHROP",
    "dropphyst": "ME",
    "dropphyzpp": "043439998",
    "dropmaladd": "2402 US ROUTE 202",
    "dropmalcty": "EAST WINTHROP",
    "dropmalst": "ME",
    "dropmalzpp": "043439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778540975,
    "dropsitcph": 8778540975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24871",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "87 CENTER RD",
    "dropdelcty": "EASTON",
    "dropdelst": "ME",
    "dropdelzpp": "047409998",
    "dropphyadd": "87 CENTER RD",
    "dropphycty": "EASTON",
    "dropphyst": "ME",
    "dropphyzpp": "047409998",
    "dropmaladd": "87 CENTER RD",
    "dropmalcty": "EASTON",
    "dropmalst": "ME",
    "dropmalzpp": "047409998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074885751,
    "dropsitcph": 2074885751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24872",
    "droptype": "D",
    "dropname": "EASTPORT",
    "dropdeladd": "1 WASHINGTON ST",
    "dropdelcty": "EASTPORT",
    "dropdelst": "ME",
    "dropdelzpp": "046319998",
    "dropphyadd": "1 WASHINGTON ST",
    "dropphycty": "EASTPORT",
    "dropphyst": "ME",
    "dropphyzpp": "046319998",
    "dropmaladd": "1 WASHINGTON ST",
    "dropmalcty": "EASTPORT",
    "dropmalst": "ME",
    "dropmalzpp": "046319998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078534422,
    "dropsitcph": 2078534422,
    "dropfax": 2078530697
  },
  {
    "dcode": "D",
    "dropkey": "PV24874",
    "droptype": "D",
    "dropname": "ELIOT",
    "dropdeladd": "33 LEVESQUE DR STE C",
    "dropdelcty": "ELIOT",
    "dropdelst": "ME",
    "dropdelzpp": "039039998",
    "dropphyadd": "33 LEVESQUE DR STE C",
    "dropphycty": "ELIOT",
    "dropphyst": "ME",
    "dropphyzpp": "039039998",
    "dropmaladd": "33 LEVESQUE DR STE C",
    "dropmalcty": "ELIOT",
    "dropmalst": "ME",
    "dropmalzpp": "039039998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074392019,
    "dropsitcph": 2074392019,
    "dropfax": 2074395396
  },
  {
    "dcode": "D",
    "dropkey": "PV24875",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "199 MAIN ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "ME",
    "dropdelzpp": "046059998",
    "dropphyadd": "199 MAIN ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "ME",
    "dropphyzpp": "046059998",
    "dropmaladd": "199 MAIN ST",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "ME",
    "dropmalzpp": "046059998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076675340,
    "dropsitcph": 2076675340,
    "dropfax": 2076673861
  },
  {
    "dcode": "D",
    "dropkey": "PV24881",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "205 STAGE RD",
    "dropdelcty": "ETNA",
    "dropdelst": "ME",
    "dropdelzpp": "044349998",
    "dropphyadd": "205 STAGE RD",
    "dropphycty": "ETNA",
    "dropphyst": "ME",
    "dropphyzpp": "044349998",
    "dropmaladd": "205 STAGE RD",
    "dropmalcty": "ETNA",
    "dropmalst": "ME",
    "dropmalzpp": "044349998",
    "dropsitphn": 2072692212,
    "dropsitlph": 2072692212,
    "dropsitcph": 2072692212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24882",
    "droptype": "D",
    "dropname": "EUSTIS",
    "dropdeladd": "1050 THE ARNOLD TRL",
    "dropdelcty": "EUSTIS",
    "dropdelst": "ME",
    "dropdelzpp": "049369998",
    "dropphyadd": "1050 THE ARNOLD TRL",
    "dropphycty": "EUSTIS",
    "dropphyst": "ME",
    "dropphyzpp": "049369998",
    "dropmaladd": "1050 THE ARNOLD TRL",
    "dropmalcty": "EUSTIS",
    "dropmalst": "ME",
    "dropmalzpp": "049369998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072462163,
    "dropsitcph": 2072462163,
    "dropfax": 2072462163
  },
  {
    "dcode": "D",
    "dropkey": "PV24883",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "1220 STETSON RD",
    "dropdelcty": "EXETER",
    "dropdelst": "ME",
    "dropdelzpp": "044359998",
    "dropphyadd": "1220 STETSON RD",
    "dropphycty": "EXETER",
    "dropphyst": "ME",
    "dropphyzpp": "044359998",
    "dropmaladd": "1220 STETSON RD",
    "dropmalcty": "EXETER",
    "dropmalst": "ME",
    "dropmalzpp": "044359998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076058004,
    "dropsitcph": 2076058004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24884",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "049379998",
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "049379998",
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "049379998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074536101,
    "dropsitcph": 2074536101,
    "dropfax": 2074537124
  },
  {
    "dcode": "D",
    "dropkey": "PV24890",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "196 MAIN ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "049389998",
    "dropphyadd": "196 MAIN ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "049389998",
    "dropmaladd": "196 MAIN ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "049389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077782740,
    "dropsitcph": 2077782740,
    "dropfax": 2077786307
  },
  {
    "dcode": "D",
    "dropkey": "PV24891",
    "droptype": "D",
    "dropname": "FARMINGTON FALLS",
    "dropdeladd": "174 CROSWELL RD",
    "dropdelcty": "FARMINGTON FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "049409998",
    "dropphyadd": "174 CROSWELL RD",
    "dropphycty": "FARMINGTON FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "049409998",
    "dropmaladd": "174 CROSWELL RD",
    "dropmalcty": "FARMINGTON FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "049409998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077786373,
    "dropsitcph": 2077786373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24892",
    "droptype": "D",
    "dropname": "FORT FAIRFIELD",
    "dropdeladd": "289 MAIN ST",
    "dropdelcty": "FORT FAIRFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "047429998",
    "dropphyadd": "289 MAIN ST",
    "dropphycty": "FORT FAIRFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "047429998",
    "dropmaladd": "289 MAIN ST",
    "dropmalcty": "FORT FAIRFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "047429998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074766021,
    "dropsitcph": 2074766021,
    "dropfax": 2074737954
  },
  {
    "dcode": "D",
    "dropkey": "PV24893",
    "droptype": "D",
    "dropname": "FORT KENT",
    "dropdeladd": "152 W MAIN ST",
    "dropdelcty": "FORT KENT",
    "dropdelst": "ME",
    "dropdelzpp": "047439998",
    "dropphyadd": "152 W MAIN ST",
    "dropphycty": "FORT KENT",
    "dropphyst": "ME",
    "dropphyzpp": "047439998",
    "dropmaladd": "152 W MAIN ST",
    "dropmalcty": "FORT KENT",
    "dropmalst": "ME",
    "dropmalzpp": "047439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078343313,
    "dropsitcph": 2078343313,
    "dropfax": 2078345990
  },
  {
    "dcode": "D",
    "dropkey": "PV24894",
    "droptype": "D",
    "dropname": "FORT KENT MILLS",
    "dropdeladd": "345 MARKET ST UNIT 102",
    "dropdelcty": "FORT KENT MILLS",
    "dropdelst": "ME",
    "dropdelzpp": "047449998",
    "dropphyadd": "345 MARKET ST UNIT 102",
    "dropphycty": "FORT KENT MILLS",
    "dropphyst": "ME",
    "dropphyzpp": "047449998",
    "dropmaladd": "345 MARKET ST UNIT 102",
    "dropmalcty": "FORT KENT MILLS",
    "dropmalst": "ME",
    "dropmalzpp": "047449998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773641386,
    "dropsitcph": 8773641386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24895",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "48B MAIN RD S",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "ME",
    "dropdelzpp": "044389998",
    "dropphyadd": "48B MAIN RD S",
    "dropphycty": "FRANKFORT",
    "dropphyst": "ME",
    "dropphyzpp": "044389998",
    "dropmaladd": "48B MAIN RD S",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "ME",
    "dropmalzpp": "044389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075483167,
    "dropsitcph": 2075483167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24896",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "48 BLACKSWOODS RD",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "ME",
    "dropdelzpp": "046349998",
    "dropphyadd": "48 BLACKSWOODS RD",
    "dropphycty": "FRANKLIN",
    "dropphyst": "ME",
    "dropphyzpp": "046349998",
    "dropmaladd": "48 BLACKSWOODS RD",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "ME",
    "dropmalzpp": "046349998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075652983,
    "dropsitcph": 2075652983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24897",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "93 BELFAST RD",
    "dropdelcty": "FREEDOM",
    "dropdelst": "ME",
    "dropdelzpp": "049419998",
    "dropphyadd": "93 BELFAST RD",
    "dropphycty": "FREEDOM",
    "dropphyst": "ME",
    "dropphyzpp": "049419998",
    "dropmaladd": "93 BELFAST RD",
    "dropmalcty": "FREEDOM",
    "dropmalst": "ME",
    "dropmalzpp": "049419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778543471,
    "dropsitcph": 8778543471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24898",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "141 MAIN ST",
    "dropdelcty": "FREEPORT",
    "dropdelst": "ME",
    "dropdelzpp": "040329998",
    "dropphyadd": "141 MAIN ST",
    "dropphycty": "FREEPORT",
    "dropphyst": "ME",
    "dropphyzpp": "040329998",
    "dropmaladd": "141 MAIN ST",
    "dropmalcty": "FREEPORT",
    "dropmalst": "ME",
    "dropmalzpp": "040329998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078654231,
    "dropsitcph": 2078654231,
    "dropfax": 2078654434
  },
  {
    "dcode": "D",
    "dropkey": "PV24901",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "71 HARBOR RD",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "ME",
    "dropdelzpp": "045479998",
    "dropphyadd": "71 HARBOR RD",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "ME",
    "dropphyzpp": "045479998",
    "dropmaladd": "71 HARBOR RD",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "ME",
    "dropmalzpp": "045479998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078327558,
    "dropsitcph": 2078327558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24903",
    "droptype": "D",
    "dropname": "FRYEBURG",
    "dropdeladd": "488 MAIN ST",
    "dropdelcty": "FRYEBURG",
    "dropdelst": "ME",
    "dropdelzpp": "040379998",
    "dropphyadd": "488 MAIN ST",
    "dropphycty": "FRYEBURG",
    "dropphyst": "ME",
    "dropphyzpp": "040379998",
    "dropmaladd": "488 MAIN ST",
    "dropmalcty": "FRYEBURG",
    "dropmalst": "ME",
    "dropmalzpp": "040379998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079352453,
    "dropsitcph": 2079352453,
    "dropfax": 2079353888
  },
  {
    "dcode": "D",
    "dropkey": "PV24904",
    "droptype": "D",
    "dropname": "GARDINER",
    "dropdeladd": "348 WATER ST",
    "dropdelcty": "GARDINER",
    "dropdelst": "ME",
    "dropdelzpp": "043459998",
    "dropphyadd": "348 WATER ST",
    "dropphycty": "GARDINER",
    "dropphyst": "ME",
    "dropphyzpp": "043459998",
    "dropmaladd": "348 WATER ST",
    "dropmalcty": "GARDINER",
    "dropmalst": "ME",
    "dropmalzpp": "043459998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075826160,
    "dropsitcph": 2075826160,
    "dropfax": 2075820984
  },
  {
    "dcode": "D",
    "dropkey": "PV24905",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "1 OLIVER HILL RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "ME",
    "dropdelzpp": "049399998",
    "dropphyadd": "1 OLIVER HILL RD",
    "dropphycty": "GARLAND",
    "dropphyst": "ME",
    "dropphyzpp": "049399998",
    "dropmaladd": "1 OLIVER HILL RD",
    "dropmalcty": "GARLAND",
    "dropmalst": "ME",
    "dropmalzpp": "049399998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076055849,
    "dropsitcph": 2076055849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24907",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "765 FIVE ISLANDS RD",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "ME",
    "dropdelzpp": "045489998",
    "dropphyadd": "765 FIVE ISLANDS RD",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "ME",
    "dropphyzpp": "045489998",
    "dropmaladd": "765 FIVE ISLANDS RD",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "ME",
    "dropmalzpp": "045489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073712000,
    "dropsitcph": 2073712000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24911",
    "droptype": "D",
    "dropname": "GORHAM",
    "dropdeladd": "1 POST OFFICE SQ",
    "dropdelcty": "GORHAM",
    "dropdelst": "ME",
    "dropdelzpp": "040389998",
    "dropphyadd": "1 POST OFFICE SQ",
    "dropphycty": "GORHAM",
    "dropphyst": "ME",
    "dropphyzpp": "040389998",
    "dropmaladd": "1 POST OFFICE SQ",
    "dropmalcty": "GORHAM",
    "dropmalst": "ME",
    "dropmalzpp": "040389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078393591,
    "dropsitcph": 2078393591,
    "dropfax": 2078398379
  },
  {
    "dcode": "D",
    "dropkey": "PV24912",
    "droptype": "D",
    "dropname": "GOULDSBORO",
    "dropdeladd": "411 ROUTE 1",
    "dropdelcty": "GOULDSBORO",
    "dropdelst": "ME",
    "dropdelzpp": "046079998",
    "dropphyadd": "411 ROUTE 1",
    "dropphycty": "GOULDSBORO",
    "dropphyst": "ME",
    "dropphyzpp": "046079998",
    "dropmaladd": "411 ROUTE 1",
    "dropmalcty": "GOULDSBORO",
    "dropmalst": "ME",
    "dropmalzpp": "046079998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076107167,
    "dropsitcph": 2076107167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24913",
    "droptype": "D",
    "dropname": "GRAND ISLE",
    "dropdeladd": "6 TRAVERSE ST",
    "dropdelcty": "GRAND ISLE",
    "dropdelst": "ME",
    "dropdelzpp": "047469998",
    "dropphyadd": "6 TRAVERSE ST",
    "dropphycty": "GRAND ISLE",
    "dropphyst": "ME",
    "dropphyzpp": "047469998",
    "dropmaladd": "6 TRAVERSE ST",
    "dropmalcty": "GRAND ISLE",
    "dropmalst": "ME",
    "dropmalzpp": "047469998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078956933,
    "dropsitcph": 2078956933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24915",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "10 TURNPIKE ACRES RD",
    "dropdelcty": "GRAY",
    "dropdelst": "ME",
    "dropdelzpp": "040399998",
    "dropphyadd": "10 TURNPIKE ACRES RD",
    "dropphycty": "GRAY",
    "dropphyst": "ME",
    "dropphyzpp": "040399998",
    "dropmaladd": "10 TURNPIKE ACRES RD",
    "dropmalcty": "GRAY",
    "dropmalst": "ME",
    "dropmalzpp": "040399998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076573211,
    "dropsitcph": 2076573211,
    "dropfax": 2076573249
  },
  {
    "dcode": "D",
    "dropkey": "PV24919",
    "droptype": "D",
    "dropname": "GREENE",
    "dropdeladd": "677 ROUTE 202",
    "dropdelcty": "GREENE",
    "dropdelst": "ME",
    "dropdelzpp": "042364256",
    "dropphyadd": "677 ROUTE 202",
    "dropphycty": "GREENE",
    "dropphyst": "ME",
    "dropphyzpp": "042364256",
    "dropmaladd": "677 ROUTE 202",
    "dropmalcty": "GREENE",
    "dropmalst": "ME",
    "dropmalzpp": "042364256",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075308245,
    "dropsitcph": 2075308245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24920",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "25 LILY BAY RD",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "044419998",
    "dropphyadd": "25 LILY BAY RD",
    "dropphycty": "GREENVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "044419998",
    "dropmaladd": "25 LILY BAY RD",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "044419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779074645,
    "dropsitcph": 8779074645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24921",
    "droptype": "D",
    "dropname": "GREENVILLE JUNCTION",
    "dropdeladd": "383 PRITHAM AVE",
    "dropdelcty": "GREENVILLE JUNCTION",
    "dropdelst": "ME",
    "dropdelzpp": "044429998",
    "dropphyadd": "383 PRITHAM AVE",
    "dropphycty": "GREENVILLE JUNCTION",
    "dropphyst": "ME",
    "dropphyzpp": "044429998",
    "dropmaladd": "383 PRITHAM AVE",
    "dropmalcty": "GREENVILLE JUNCTION",
    "dropmalst": "ME",
    "dropmalzpp": "044429998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076953353,
    "dropsitcph": 2076953353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24925",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "10 HUDSON AVE",
    "dropdelcty": "GUILFORD",
    "dropdelst": "ME",
    "dropdelzpp": "044439998",
    "dropphyadd": "10 HUDSON AVE",
    "dropphycty": "GUILFORD",
    "dropphyst": "ME",
    "dropphyzpp": "044439998",
    "dropmaladd": "10 HUDSON AVE",
    "dropmalcty": "GUILFORD",
    "dropmalst": "ME",
    "dropmalzpp": "044439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078764515,
    "dropsitcph": 2078764515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24926",
    "droptype": "D",
    "dropname": "HALLOWELL",
    "dropdeladd": "95 SECOND ST",
    "dropdelcty": "HALLOWELL",
    "dropdelst": "ME",
    "dropdelzpp": "043479998",
    "dropphyadd": "95 SECOND ST",
    "dropphycty": "HALLOWELL",
    "dropphyst": "ME",
    "dropphyzpp": "043479998",
    "dropmaladd": "95 SECOND ST",
    "dropmalcty": "HALLOWELL",
    "dropmalst": "ME",
    "dropmalzpp": "043479998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076221121,
    "dropsitcph": 2076221121,
    "dropfax": 2076221121
  },
  {
    "dcode": "D",
    "dropkey": "PV24927",
    "droptype": "D",
    "dropname": "HAMPDEN",
    "dropdeladd": "114 WESTERN AVE",
    "dropdelcty": "HAMPDEN",
    "dropdelst": "ME",
    "dropdelzpp": "044449998",
    "dropphyadd": "114 WESTERN AVE",
    "dropphycty": "HAMPDEN",
    "dropphyst": "ME",
    "dropphyzpp": "044449998",
    "dropmaladd": "114 WESTERN AVE",
    "dropmalcty": "HAMPDEN",
    "dropmalst": "ME",
    "dropmalzpp": "044449998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078623050,
    "dropsitcph": 2078623050,
    "dropfax": 2078623090
  },
  {
    "dcode": "D",
    "dropkey": "PV24928",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "1405 US HWY 1",
    "dropdelcty": "HANCOCK",
    "dropdelst": "ME",
    "dropdelzpp": "046409998",
    "dropphyadd": "1405 US HWY 1",
    "dropphycty": "HANCOCK",
    "dropphyst": "ME",
    "dropphyzpp": "046409998",
    "dropmaladd": "1405 US HWY 1",
    "dropmalcty": "HANCOCK",
    "dropmalst": "ME",
    "dropmalzpp": "046409998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074226259,
    "dropsitcph": 2074226259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24929",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "2046 MAIN ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "ME",
    "dropdelzpp": "042379998",
    "dropphyadd": "2046 MAIN ST",
    "dropphycty": "HANOVER",
    "dropphyst": "ME",
    "dropphyzpp": "042379998",
    "dropmaladd": "2046 MAIN ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "ME",
    "dropmalzpp": "042379998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073644953,
    "dropsitcph": 2073644953,
    "dropfax": 2073643513
  },
  {
    "dcode": "D",
    "dropkey": "PV24931",
    "droptype": "D",
    "dropname": "HARMONY",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "HARMONY",
    "dropdelst": "ME",
    "dropdelzpp": "049429998",
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "HARMONY",
    "dropphyst": "ME",
    "dropphyzpp": "049429998",
    "dropmaladd": "17 MAIN ST",
    "dropmalcty": "HARMONY",
    "dropmalst": "ME",
    "dropmalzpp": "049429998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076145324,
    "dropsitcph": 2076145324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24933",
    "droptype": "D",
    "dropname": "HARRINGTON",
    "dropdeladd": "1285 MAIN ST",
    "dropdelcty": "HARRINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "046439998",
    "dropphyadd": "1285 MAIN ST",
    "dropphycty": "HARRINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "046439998",
    "dropmaladd": "1285 MAIN ST",
    "dropmalcty": "HARRINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "046439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074834622,
    "dropsitcph": 2074834622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24934",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "5 FRONT ST",
    "dropdelcty": "HARRISON",
    "dropdelst": "ME",
    "dropdelzpp": "040409998",
    "dropphyadd": "5 FRONT ST",
    "dropphycty": "HARRISON",
    "dropphyst": "ME",
    "dropphyzpp": "040409998",
    "dropmaladd": "5 FRONT ST",
    "dropmalcty": "HARRISON",
    "dropmalst": "ME",
    "dropmalzpp": "040409998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075834773,
    "dropsitcph": 2075834773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24935",
    "droptype": "D",
    "dropname": "HARTLAND",
    "dropdeladd": "90 MAIN ST",
    "dropdelcty": "HARTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "049439998",
    "dropphyadd": "90 MAIN ST",
    "dropphycty": "HARTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "049439998",
    "dropmaladd": "90 MAIN ST",
    "dropmalcty": "HARTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "049439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079384463,
    "dropsitcph": 2079384463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24937",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "337 PARIS RD",
    "dropdelcty": "HEBRON",
    "dropdelst": "ME",
    "dropdelzpp": "042389998",
    "dropphyadd": "337 PARIS RD",
    "dropphycty": "HEBRON",
    "dropphyst": "ME",
    "dropphyzpp": "042389998",
    "dropmaladd": "337 PARIS RD",
    "dropmalcty": "HEBRON",
    "dropmalst": "ME",
    "dropmalzpp": "042389998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075205618,
    "dropsitcph": 2075205618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24938",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "753 SKOWHEGAN RD",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "ME",
    "dropdelzpp": "049449998",
    "dropphyadd": "753 SKOWHEGAN RD",
    "dropphycty": "HINCKLEY",
    "dropphyst": "ME",
    "dropphyzpp": "049449998",
    "dropmaladd": "753 SKOWHEGAN RD",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "ME",
    "dropmalzpp": "049449998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074539263,
    "dropsitcph": 2074539263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24939",
    "droptype": "D",
    "dropname": "HIRAM",
    "dropdeladd": "17 SCHOOLHOUSE RD",
    "dropdelcty": "HIRAM",
    "dropdelst": "ME",
    "dropdelzpp": "040419998",
    "dropphyadd": "17 SCHOOLHOUSE RD",
    "dropphycty": "HIRAM",
    "dropphyst": "ME",
    "dropphyzpp": "040419998",
    "dropmaladd": "17 SCHOOLHOUSE RD",
    "dropmalcty": "HIRAM",
    "dropmalst": "ME",
    "dropmalzpp": "040419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076254068,
    "dropsitcph": 2076254068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24941",
    "droptype": "D",
    "dropname": "HOLLIS CENTER",
    "dropdeladd": "14 BAR MILLS RD",
    "dropdelcty": "HOLLIS CENTER",
    "dropdelst": "ME",
    "dropdelzpp": "040429998",
    "dropphyadd": "14 BAR MILLS RD",
    "dropphycty": "HOLLIS CENTER",
    "dropphyst": "ME",
    "dropphyzpp": "040429998",
    "dropmaladd": "14 BAR MILLS RD",
    "dropmalcty": "HOLLIS CENTER",
    "dropmalst": "ME",
    "dropmalzpp": "040429998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779073773,
    "dropsitcph": 8779073773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24943",
    "droptype": "D",
    "dropname": "HOULTON",
    "dropdeladd": "39 COURT ST STE 9998",
    "dropdelcty": "HOULTON",
    "dropdelst": "ME",
    "dropdelzpp": "047309998",
    "dropphyadd": "39 COURT ST STE 9998",
    "dropphycty": "HOULTON",
    "dropphyst": "ME",
    "dropphyzpp": "047309998",
    "dropmaladd": "39 COURT ST STE 9998",
    "dropmalcty": "HOULTON",
    "dropmalst": "ME",
    "dropmalzpp": "047309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075323506,
    "dropsitcph": 2075323506,
    "dropfax": 2075327489
  },
  {
    "dcode": "D",
    "dropkey": "PV24944",
    "droptype": "D",
    "dropname": "HOWLAND",
    "dropdeladd": "18 MAIN ST",
    "dropdelcty": "HOWLAND",
    "dropdelst": "ME",
    "dropdelzpp": "044489998",
    "dropphyadd": "18 MAIN ST",
    "dropphycty": "HOWLAND",
    "dropphyst": "ME",
    "dropphyzpp": "044489998",
    "dropmaladd": "18 MAIN ST",
    "dropmalcty": "HOWLAND",
    "dropmalst": "ME",
    "dropmalzpp": "044489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074102138,
    "dropsitcph": 2074102138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24945",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "29 OLD TOWN RD",
    "dropdelcty": "HUDSON",
    "dropdelst": "ME",
    "dropdelzpp": "044499998",
    "dropphyadd": "29 OLD TOWN RD",
    "dropphycty": "HUDSON",
    "dropphyst": "ME",
    "dropphyzpp": "044499998",
    "dropmaladd": "29 OLD TOWN RD",
    "dropmalcty": "HUDSON",
    "dropmalst": "ME",
    "dropmalzpp": "044499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076055868,
    "dropsitcph": 2076055868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24946",
    "droptype": "D",
    "dropname": "HULLS COVE",
    "dropdeladd": "3 BREAK NECK RD",
    "dropdelcty": "HULLS COVE",
    "dropdelst": "ME",
    "dropdelzpp": "046449998",
    "dropphyadd": "3 BREAK NECK RD",
    "dropphycty": "HULLS COVE",
    "dropphyst": "ME",
    "dropphyzpp": "046449998",
    "dropmaladd": "3 BREAK NECK RD",
    "dropmalcty": "HULLS COVE",
    "dropmalst": "ME",
    "dropmalzpp": "046449998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074227632,
    "dropsitcph": 2074227632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24948",
    "droptype": "D",
    "dropname": "ISLAND FALLS",
    "dropdeladd": "1009 CRYSTAL RD",
    "dropdelcty": "ISLAND FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "047479998",
    "dropphyadd": "1009 CRYSTAL RD",
    "dropphycty": "ISLAND FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "047479998",
    "dropmaladd": "1009 CRYSTAL RD",
    "dropmalcty": "ISLAND FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "047479998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074632257,
    "dropsitcph": 2074632257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24951",
    "droptype": "D",
    "dropname": "ISLESBORO",
    "dropdeladd": "114 MAIN RD",
    "dropdelcty": "ISLESBORO",
    "dropdelst": "ME",
    "dropdelzpp": "048489998",
    "dropphyadd": "114 MAIN RD",
    "dropphycty": "ISLESBORO",
    "dropphyst": "ME",
    "dropphyzpp": "048489998",
    "dropmaladd": "114 MAIN RD",
    "dropmalcty": "ISLESBORO",
    "dropmalst": "ME",
    "dropmalzpp": "048489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077348884,
    "dropsitcph": 2077348884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24952",
    "droptype": "D",
    "dropname": "ISLESFORD",
    "dropdeladd": "61 MAIN ST",
    "dropdelcty": "ISLESFORD",
    "dropdelst": "ME",
    "dropdelzpp": "046469998",
    "dropphyadd": "61 MAIN ST",
    "dropphycty": "ISLESFORD",
    "dropphyst": "ME",
    "dropphyzpp": "046469998",
    "dropmaladd": "61 MAIN ST",
    "dropmalcty": "ISLESFORD",
    "dropmalst": "ME",
    "dropmalzpp": "046469998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072445621,
    "dropsitcph": 2072445621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24953",
    "droptype": "D",
    "dropname": "JACKMAN",
    "dropdeladd": "552 MAIN ST",
    "dropdelcty": "JACKMAN",
    "dropdelst": "ME",
    "dropdelzpp": "049459998",
    "dropphyadd": "552 MAIN ST",
    "dropphycty": "JACKMAN",
    "dropphyst": "ME",
    "dropphyzpp": "049459998",
    "dropmaladd": "552 MAIN ST",
    "dropmalcty": "JACKMAN",
    "dropmalst": "ME",
    "dropmalzpp": "049459998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076687771,
    "dropsitcph": 2076687771,
    "dropfax": 2076684022
  },
  {
    "dcode": "D",
    "dropkey": "PV24954",
    "droptype": "D",
    "dropname": "JAY",
    "dropdeladd": "158 MAIN ST",
    "dropdelcty": "JAY",
    "dropdelst": "ME",
    "dropdelzpp": "042399998",
    "dropphyadd": "158 MAIN ST",
    "dropphycty": "JAY",
    "dropphyst": "ME",
    "dropphyzpp": "042399998",
    "dropmaladd": "158 MAIN ST",
    "dropmalcty": "JAY",
    "dropmalst": "ME",
    "dropmalzpp": "042399998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078974461,
    "dropsitcph": 2078974461,
    "dropfax": 2078979370
  },
  {
    "dcode": "D",
    "dropkey": "PV24955",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "133 VILLAGE ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "ME",
    "dropdelzpp": "043489998",
    "dropphyadd": "133 VILLAGE ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "ME",
    "dropphyzpp": "043489998",
    "dropmaladd": "133 VILLAGE ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "ME",
    "dropmalzpp": "043489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075495083,
    "dropsitcph": 2075495083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24956",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "810 US RTE 1",
    "dropdelcty": "JONESBORO",
    "dropdelst": "ME",
    "dropdelzpp": "046489998",
    "dropphyadd": "810 US RTE 1",
    "dropphycty": "JONESBORO",
    "dropphyst": "ME",
    "dropphyzpp": "046489998",
    "dropmaladd": "810 US RTE 1",
    "dropmalcty": "JONESBORO",
    "dropmalst": "ME",
    "dropmalzpp": "046489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 3152038816,
    "dropsitcph": 3152038816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24957",
    "droptype": "D",
    "dropname": "JONESPORT",
    "dropdeladd": "193 MAIN ST",
    "dropdelcty": "JONESPORT",
    "dropdelst": "ME",
    "dropdelzpp": "046499998",
    "dropphyadd": "193 MAIN ST",
    "dropphycty": "JONESPORT",
    "dropphyst": "ME",
    "dropphyzpp": "046499998",
    "dropmaladd": "193 MAIN ST",
    "dropmalcty": "JONESPORT",
    "dropmalst": "ME",
    "dropmalzpp": "046499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074975550,
    "dropsitcph": 2074975550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24958",
    "droptype": "D",
    "dropname": "KENDUSKEAG",
    "dropdeladd": "4008 BROADWAY",
    "dropdelcty": "KENDUSKEAG",
    "dropdelst": "ME",
    "dropdelzpp": "044509998",
    "dropphyadd": "4008 BROADWAY",
    "dropphycty": "KENDUSKEAG",
    "dropphyst": "ME",
    "dropphyzpp": "044509998",
    "dropmaladd": "4008 BROADWAY",
    "dropmalcty": "KENDUSKEAG",
    "dropmalst": "ME",
    "dropmalzpp": "044509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076055739,
    "dropsitcph": 2076055739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24959",
    "droptype": "D",
    "dropname": "KENNEBUNK",
    "dropdeladd": "3 POST OFFICE SQ",
    "dropdelcty": "KENNEBUNK",
    "dropdelst": "ME",
    "dropdelzpp": "040439998",
    "dropphyadd": "3 POST OFFICE SQ",
    "dropphycty": "KENNEBUNK",
    "dropphyst": "ME",
    "dropphyzpp": "040439998",
    "dropmaladd": "3 POST OFFICE SQ",
    "dropmalcty": "KENNEBUNK",
    "dropmalst": "ME",
    "dropmalzpp": "040439998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079852092,
    "dropsitcph": 2079852092,
    "dropfax": 2079852068
  },
  {
    "dcode": "D",
    "dropkey": "PV24961",
    "droptype": "D",
    "dropname": "KENNEBUNKPORT",
    "dropdeladd": "5 TEMPLE ST",
    "dropdelcty": "KENNEBUNKPORT",
    "dropdelst": "ME",
    "dropdelzpp": "040466046",
    "dropphyadd": "5 TEMPLE ST",
    "dropphycty": "KENNEBUNKPORT",
    "dropphyst": "ME",
    "dropphyzpp": "040466046",
    "dropmaladd": "5 TEMPLE ST",
    "dropmalcty": "KENNEBUNKPORT",
    "dropmalst": "ME",
    "dropmalzpp": "040466046",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079672191,
    "dropsitcph": 2079672191,
    "dropfax": 2079674879
  },
  {
    "dcode": "D",
    "dropkey": "PV24962",
    "droptype": "D",
    "dropname": "KENTS HILL",
    "dropdeladd": "1613 MAIN ST",
    "dropdelcty": "KENTS HILL",
    "dropdelst": "ME",
    "dropdelzpp": "043499998",
    "dropphyadd": "1613 MAIN ST",
    "dropphycty": "KENTS HILL",
    "dropphyst": "ME",
    "dropphyzpp": "043499998",
    "dropmaladd": "1613 MAIN ST",
    "dropmalcty": "KENTS HILL",
    "dropmalst": "ME",
    "dropmalzpp": "043499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076586504,
    "dropsitcph": 2076856504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24963",
    "droptype": "D",
    "dropname": "PARSONSFIELD",
    "dropdeladd": "15 FEDERAL RD",
    "dropdelcty": "PARSONSFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "040479998",
    "dropphyadd": "15 FEDERAL RD",
    "dropphycty": "PARSONSFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "040479998",
    "dropmaladd": "15 FEDERAL RD",
    "dropmalcty": "PARSONSFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "040479998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076258624,
    "dropsitcph": 2076258624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24964",
    "droptype": "D",
    "dropname": "KINGFIELD",
    "dropdeladd": "8 DEPOT ST",
    "dropdelcty": "KINGFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "049479998",
    "dropphyadd": "8 DEPOT ST",
    "dropphycty": "KINGFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "049479998",
    "dropmaladd": "8 DEPOT ST",
    "dropmalcty": "KINGFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "049479998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072654122,
    "dropsitcph": 2072654122,
    "dropfax": 2072654122
  },
  {
    "dcode": "D",
    "dropkey": "PV24965",
    "droptype": "D",
    "dropname": "KINGMAN",
    "dropdeladd": "1383 KINGMAN RD",
    "dropdelcty": "KINGMAN",
    "dropdelst": "ME",
    "dropdelzpp": "044519998",
    "dropphyadd": "1383 KINGMAN RD",
    "dropphycty": "KINGMAN",
    "dropphyst": "ME",
    "dropphyzpp": "044519998",
    "dropmaladd": "1383 KINGMAN RD",
    "dropmalcty": "KINGMAN",
    "dropmalst": "ME",
    "dropmalzpp": "044519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077652275,
    "dropsitcph": 2077652275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24966",
    "droptype": "D",
    "dropname": "KITTERY",
    "dropdeladd": "10 SHAPLEIGH RD STE 9998",
    "dropdelcty": "KITTERY",
    "dropdelst": "ME",
    "dropdelzpp": "039049998",
    "dropphyadd": "10 SHAPLEIGH RD STE 9998",
    "dropphycty": "KITTERY",
    "dropphyst": "ME",
    "dropphyzpp": "039049998",
    "dropmaladd": "10 SHAPLEIGH RD STE 9998",
    "dropmalcty": "KITTERY",
    "dropmalst": "ME",
    "dropmalzpp": "039049998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074392018,
    "dropsitcph": 2074392018,
    "dropfax": 2074395261
  },
  {
    "dcode": "D",
    "dropkey": "PV24967",
    "droptype": "D",
    "dropname": "KITTERY POINT",
    "dropdeladd": "91 PEPPERRELL RD",
    "dropdelcty": "KITTERY POINT",
    "dropdelst": "ME",
    "dropdelzpp": "039059998",
    "dropphyadd": "91 PEPPERRELL RD",
    "dropphycty": "KITTERY POINT",
    "dropphyst": "ME",
    "dropphyzpp": "039059998",
    "dropmaladd": "91 PEPPERRELL RD",
    "dropmalcty": "KITTERY POINT",
    "dropmalst": "ME",
    "dropmalzpp": "039059998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074394353,
    "dropsitcph": 2074394353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24970",
    "droptype": "D",
    "dropname": "LAGRANGE",
    "dropdeladd": "5763 BENNOCH RD",
    "dropdelcty": "LAGRANGE",
    "dropdelst": "ME",
    "dropdelzpp": "044539998",
    "dropphyadd": "5763 BENNOCH RD",
    "dropphycty": "LAGRANGE",
    "dropphyst": "ME",
    "dropphyzpp": "044539998",
    "dropmaladd": "5763 BENNOCH RD",
    "dropmalcty": "LAGRANGE",
    "dropmalst": "ME",
    "dropmalzpp": "044539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079432838,
    "dropsitcph": 2079432838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24974",
    "droptype": "D",
    "dropname": "LEE",
    "dropdeladd": "2790 LEE RD",
    "dropdelcty": "LEE",
    "dropdelst": "ME",
    "dropdelzpp": "044559998",
    "dropphyadd": "2790 LEE RD",
    "dropphycty": "LEE",
    "dropphyst": "ME",
    "dropphyzpp": "044559998",
    "dropmaladd": "2790 LEE RD",
    "dropmalcty": "LEE",
    "dropmalst": "ME",
    "dropmalzpp": "044559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077384455,
    "dropsitcph": 2077384455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24975",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "1279 ROUTE 106",
    "dropdelcty": "LEEDS",
    "dropdelst": "ME",
    "dropdelzpp": "042639998",
    "dropphyadd": "1279 ROUTE 106",
    "dropphycty": "LEEDS",
    "dropphyst": "ME",
    "dropphyzpp": "042639998",
    "dropmaladd": "1279 ROUTE 106",
    "dropmalcty": "LEEDS",
    "dropmalst": "ME",
    "dropmalzpp": "042639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075243422,
    "dropsitcph": 2075243422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24976",
    "droptype": "D",
    "dropname": "LEVANT",
    "dropdeladd": "3454 UNION ST STE 1",
    "dropdelcty": "LEVANT",
    "dropdelst": "ME",
    "dropdelzpp": "044569998",
    "dropphyadd": "3454 UNION ST STE 1",
    "dropphycty": "LEVANT",
    "dropphyst": "ME",
    "dropphyzpp": "044569998",
    "dropmaladd": "3454 UNION ST STE 1",
    "dropmalcty": "LEVANT",
    "dropmalst": "ME",
    "dropmalzpp": "044569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078847264,
    "dropsitcph": 2078847264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24977",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "49 ASH ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "ME",
    "dropdelzpp": "042409998",
    "dropphyadd": "49 ASH ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "ME",
    "dropphyzpp": "042409998",
    "dropmaladd": "49 ASH ST",
    "dropmalcty": "LEWISTON",
    "dropmalst": "ME",
    "dropmalzpp": "042409998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077837449,
    "dropsitcph": 2077837449,
    "dropfax": 2077839714
  },
  {
    "dcode": "D",
    "dropkey": "PV24978",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "76 MAIN ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "ME",
    "dropdelzpp": "049499998",
    "dropphyadd": "76 MAIN ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "ME",
    "dropphyzpp": "049499998",
    "dropmaladd": "76 MAIN ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "ME",
    "dropmalzpp": "049499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075894200,
    "dropsitcph": 2075894200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24980",
    "droptype": "D",
    "dropname": "LIMERICK",
    "dropdeladd": "19 MAIN ST",
    "dropdelcty": "LIMERICK",
    "dropdelst": "ME",
    "dropdelzpp": "040489998",
    "dropphyadd": "19 MAIN ST",
    "dropphycty": "LIMERICK",
    "dropphyst": "ME",
    "dropphyzpp": "040489998",
    "dropmaladd": "19 MAIN ST",
    "dropmalcty": "LIMERICK",
    "dropmalst": "ME",
    "dropmalzpp": "040489998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077932955,
    "dropsitcph": 2077932955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24981",
    "droptype": "D",
    "dropname": "LIMESTONE",
    "dropdeladd": "29 MAIN ST",
    "dropdelcty": "LIMESTONE",
    "dropdelst": "ME",
    "dropdelzpp": "047509998",
    "dropphyadd": "29 MAIN ST",
    "dropphycty": "LIMESTONE",
    "dropphyst": "ME",
    "dropphyzpp": "047509998",
    "dropmaladd": "29 MAIN ST",
    "dropmalcty": "LIMESTONE",
    "dropmalst": "ME",
    "dropmalzpp": "047509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073254838,
    "dropsitcph": 2073254838,
    "dropfax": 2073258720
  },
  {
    "dcode": "D",
    "dropkey": "PV24982",
    "droptype": "D",
    "dropname": "LIMINGTON",
    "dropdeladd": "189 OSSIPEE TRL",
    "dropdelcty": "LIMINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "040499998",
    "dropphyadd": "189 OSSIPEE TRL",
    "dropphycty": "LIMINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "040499998",
    "dropmaladd": "189 OSSIPEE TRL",
    "dropmalcty": "LIMINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "040499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076372958,
    "dropsitcph": 2076372958,
    "dropfax": 2076373526
  },
  {
    "dcode": "D",
    "dropkey": "PV24983",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "50 FLEMING ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "ME",
    "dropdelzpp": "044579998",
    "dropphyadd": "50 FLEMING ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "ME",
    "dropphyzpp": "044579998",
    "dropmaladd": "50 FLEMING ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "ME",
    "dropmalzpp": "044579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077946609,
    "dropsitcph": 2077946609,
    "dropfax": 2077942344
  },
  {
    "dcode": "D",
    "dropkey": "PV24985",
    "droptype": "D",
    "dropname": "LINCOLNVILLE",
    "dropdeladd": "2512 ATLANTIC HWY",
    "dropdelcty": "LINCOLNVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "048499998",
    "dropphyadd": "2512 ATLANTIC HWY",
    "dropphycty": "LINCOLNVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "048499998",
    "dropmaladd": "2512 ATLANTIC HWY",
    "dropmalcty": "LINCOLNVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "048499998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073050203,
    "dropsitcph": 2073050203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24987",
    "droptype": "D",
    "dropname": "LINCOLNVILLE CENTER",
    "dropdeladd": "499 HOPE RD",
    "dropdelcty": "LINCOLNVILLE CENTER",
    "dropdelst": "ME",
    "dropdelzpp": "048509998",
    "dropphyadd": "499 HOPE RD",
    "dropphycty": "LINCOLNVILLE CENTER",
    "dropphyst": "ME",
    "dropphyzpp": "048509998",
    "dropmaladd": "499 HOPE RD",
    "dropmalcty": "LINCOLNVILLE CENTER",
    "dropmalst": "ME",
    "dropmalzpp": "048509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778545530,
    "dropsitcph": 8778545530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24988",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "331 LISBON ST",
    "dropdelcty": "LISBON",
    "dropdelst": "ME",
    "dropdelzpp": "042509998",
    "dropphyadd": "331 LISBON ST",
    "dropphycty": "LISBON",
    "dropphyst": "ME",
    "dropphyzpp": "042509998",
    "dropmaladd": "331 LISBON ST",
    "dropmalcty": "LISBON",
    "dropmalst": "ME",
    "dropmalzpp": "042509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073534395,
    "dropsitcph": 2073534395,
    "dropfax": 2073539375
  },
  {
    "dcode": "D",
    "dropkey": "PV24991",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "1882 HALLOWELL RD",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "043509998",
    "dropphyadd": "1882 HALLOWELL RD",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "043509998",
    "dropmaladd": "1882 HALLOWELL RD",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "043509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075308316,
    "dropsitcph": 2075308316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24992",
    "droptype": "D",
    "dropname": "LITTLE DEER ISLE",
    "dropdeladd": "17 EGGEMOGGIN RD",
    "dropdelcty": "LITTLE DEER ISLE",
    "dropdelst": "ME",
    "dropdelzpp": "046509998",
    "dropphyadd": "17 EGGEMOGGIN RD",
    "dropphycty": "LITTLE DEER ISLE",
    "dropphyst": "ME",
    "dropphyzpp": "046509998",
    "dropmaladd": "17 EGGEMOGGIN RD",
    "dropmalcty": "LITTLE DEER ISLE",
    "dropmalst": "ME",
    "dropmalzpp": "046509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073486812,
    "dropsitcph": 2073486812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24994",
    "droptype": "D",
    "dropname": "LIVERMORE",
    "dropdeladd": "5 BEAR MOUNTAIN RD",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "ME",
    "dropdelzpp": "042539998",
    "dropphyadd": "5 BEAR MOUNTAIN RD",
    "dropphycty": "LIVERMORE",
    "dropphyst": "ME",
    "dropphyzpp": "042539998",
    "dropmaladd": "5 BEAR MOUNTAIN RD",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "ME",
    "dropmalzpp": "042539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078974132,
    "dropsitcph": 2078974132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24995",
    "droptype": "D",
    "dropname": "LIVERMORE FALLS",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "LIVERMORE FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "042549998",
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "LIVERMORE FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "042549998",
    "dropmaladd": "60 MAIN ST",
    "dropmalcty": "LIVERMORE FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "042549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078973614,
    "dropsitcph": 2078973614,
    "dropfax": 2078979361
  },
  {
    "dcode": "D",
    "dropkey": "PV24996",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "268 MAIN ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "ME",
    "dropdelzpp": "042559998",
    "dropphyadd": "268 MAIN ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "ME",
    "dropphyzpp": "042559998",
    "dropmaladd": "268 MAIN ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "ME",
    "dropmalzpp": "042559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075078288,
    "dropsitcph": 2075078288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24997",
    "droptype": "D",
    "dropname": "LONG ISLAND",
    "dropdeladd": "280 ISLAND AVE",
    "dropdelcty": "LONG ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "040509998",
    "dropphyadd": "280 ISLAND AVE",
    "dropphycty": "LONG ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "040509998",
    "dropmaladd": "280 ISLAND AVE",
    "dropmalcty": "LONG ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "040509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077663367,
    "dropsitcph": 2077663367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV24999",
    "droptype": "D",
    "dropname": "LOVELL",
    "dropdeladd": "216 MAIN ST",
    "dropdelcty": "LOVELL",
    "dropdelst": "ME",
    "dropdelzpp": "040519998",
    "dropphyadd": "216 MAIN ST",
    "dropphycty": "LOVELL",
    "dropphyst": "ME",
    "dropphyzpp": "040519998",
    "dropmaladd": "216 MAIN ST",
    "dropmalcty": "LOVELL",
    "dropmalst": "ME",
    "dropmalzpp": "040519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778540136,
    "dropsitcph": 8778540136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25000",
    "droptype": "D",
    "dropname": "LUBEC",
    "dropdeladd": "3 WASHINGTON ST",
    "dropdelcty": "LUBEC",
    "dropdelst": "ME",
    "dropdelzpp": "046529998",
    "dropphyadd": "3 WASHINGTON ST",
    "dropphycty": "LUBEC",
    "dropphyst": "ME",
    "dropphyzpp": "046529998",
    "dropmaladd": "3 WASHINGTON ST",
    "dropmalcty": "LUBEC",
    "dropmalst": "ME",
    "dropmalzpp": "046529998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077335581,
    "dropsitcph": 2077335581,
    "dropfax": 2077332889
  },
  {
    "dcode": "D",
    "dropkey": "PV25003",
    "droptype": "D",
    "dropname": "MACHIAS",
    "dropdeladd": "89 COURT ST STE 1",
    "dropdelcty": "MACHIAS",
    "dropdelst": "ME",
    "dropdelzpp": "046549998",
    "dropphyadd": "89 COURT ST STE 1",
    "dropphycty": "MACHIAS",
    "dropphyst": "ME",
    "dropphyzpp": "046549998",
    "dropmaladd": "89 COURT ST STE 1",
    "dropmalcty": "MACHIAS",
    "dropmalst": "ME",
    "dropmalzpp": "046549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072553725,
    "dropsitcph": 2072553725,
    "dropfax": 2072558825
  },
  {
    "dcode": "D",
    "dropkey": "PV25004",
    "droptype": "D",
    "dropname": "MACHIASPORT",
    "dropdeladd": "2 UNITY SQ",
    "dropdelcty": "MACHIASPORT",
    "dropdelst": "ME",
    "dropdelzpp": "046559998",
    "dropphyadd": "2 UNITY SQ",
    "dropphycty": "MACHIASPORT",
    "dropphyst": "ME",
    "dropphyzpp": "046559998",
    "dropmaladd": "2 UNITY SQ",
    "dropmalcty": "MACHIASPORT",
    "dropmalst": "ME",
    "dropmalzpp": "046559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072553531,
    "dropsitcph": 2072553531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25005",
    "droptype": "D",
    "dropname": "MADAWASKA",
    "dropdeladd": "370 MAIN ST",
    "dropdelcty": "MADAWASKA",
    "dropdelst": "ME",
    "dropdelzpp": "047569998",
    "dropphyadd": "370 MAIN ST",
    "dropphycty": "MADAWASKA",
    "dropphyst": "ME",
    "dropphyzpp": "047569998",
    "dropmaladd": "370 MAIN ST",
    "dropmalcty": "MADAWASKA",
    "dropmalst": "ME",
    "dropmalzpp": "047569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077284302,
    "dropsitcph": 2077284302,
    "dropfax": 2077283311
  },
  {
    "dcode": "D",
    "dropkey": "PV25006",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "24 WESTON AVE",
    "dropdelcty": "MADISON",
    "dropdelst": "ME",
    "dropdelzpp": "049509998",
    "dropphyadd": "24 WESTON AVE",
    "dropphycty": "MADISON",
    "dropphyst": "ME",
    "dropphyzpp": "049509998",
    "dropmaladd": "24 WESTON AVE",
    "dropmalcty": "MADISON",
    "dropmalst": "ME",
    "dropmalzpp": "049509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074264941,
    "dropsitcph": 2074264941,
    "dropfax": 2076968524
  },
  {
    "dcode": "D",
    "dropkey": "PV25008",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "31 READFIELD RD",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "ME",
    "dropdelzpp": "043519998",
    "dropphyadd": "31 READFIELD RD",
    "dropphycty": "MANCHESTER",
    "dropphyst": "ME",
    "dropphyzpp": "043519998",
    "dropmaladd": "31 READFIELD RD",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "ME",
    "dropmalzpp": "043519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076229559,
    "dropsitcph": 2076229559,
    "dropfax": 2076224559
  },
  {
    "dcode": "D",
    "dropkey": "PV25010",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "1754 MAIN ST",
    "dropdelcty": "MAPLETON",
    "dropdelst": "ME",
    "dropdelzpp": "047579998",
    "dropphyadd": "1754 MAIN ST",
    "dropphycty": "MAPLETON",
    "dropphyst": "ME",
    "dropphyzpp": "047579998",
    "dropmaladd": "1754 MAIN ST",
    "dropmalcty": "MAPLETON",
    "dropmalst": "ME",
    "dropmalzpp": "047579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077645677,
    "dropsitcph": 2077645677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25012",
    "droptype": "D",
    "dropname": "MARS HILL",
    "dropdeladd": "7 LINCOLN ST",
    "dropdelcty": "MARS HILL",
    "dropdelst": "ME",
    "dropdelzpp": "047589998",
    "dropphyadd": "7 LINCOLN ST",
    "dropphycty": "MARS HILL",
    "dropphyst": "ME",
    "dropphyzpp": "047589998",
    "dropmaladd": "7 LINCOLN ST",
    "dropmalcty": "MARS HILL",
    "dropmalst": "ME",
    "dropmalzpp": "047589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074299177,
    "dropsitcph": 2074299177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25014",
    "droptype": "D",
    "dropname": "MATINICUS",
    "dropdeladd": "50 SOUTH RD",
    "dropdelcty": "MATINICUS",
    "dropdelst": "ME",
    "dropdelzpp": "048519998",
    "dropphyadd": "50 SOUTH RD",
    "dropphycty": "MATINICUS",
    "dropphyst": "ME",
    "dropphyzpp": "048519998",
    "dropmaladd": "50 SOUTH RD",
    "dropmalcty": "MATINICUS",
    "dropmalst": "ME",
    "dropmalzpp": "048519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073663755,
    "dropsitcph": 2073663755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25015",
    "droptype": "D",
    "dropname": "MATTAWAMKEAG",
    "dropdeladd": "328 MAIN ST",
    "dropdelcty": "MATTAWAMKEAG",
    "dropdelst": "ME",
    "dropdelzpp": "044599998",
    "dropphyadd": "328 MAIN ST",
    "dropphycty": "MATTAWAMKEAG",
    "dropphyst": "ME",
    "dropphyzpp": "044599998",
    "dropmaladd": "328 MAIN ST",
    "dropmalcty": "MATTAWAMKEAG",
    "dropmalst": "ME",
    "dropmalzpp": "044599998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077367891,
    "dropsitcph": 2077367891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25018",
    "droptype": "D",
    "dropname": "MECHANIC FALLS",
    "dropdeladd": "33 DEPOT SQ",
    "dropdelcty": "MECHANIC FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "042569998",
    "dropphyadd": "33 DEPOT SQ",
    "dropphycty": "MECHANIC FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "042569998",
    "dropmaladd": "33 DEPOT SQ",
    "dropmalcty": "MECHANIC FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "042569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073466171,
    "dropsitcph": 2073466171,
    "dropfax": 2073453257
  },
  {
    "dcode": "D",
    "dropkey": "PV25019",
    "droptype": "D",
    "dropname": "MEDDYBEMPS",
    "dropdeladd": "849 MAIN ST",
    "dropdelcty": "MEDDYBEMPS",
    "dropdelst": "ME",
    "dropdelzpp": "046579998",
    "dropphyadd": "849 MAIN ST",
    "dropphycty": "MEDDYBEMPS",
    "dropphyst": "ME",
    "dropphyzpp": "046579998",
    "dropmaladd": "849 MAIN ST",
    "dropmalcty": "MEDDYBEMPS",
    "dropmalst": "ME",
    "dropmalzpp": "046579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074548573,
    "dropsitcph": 2074548573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25020",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "160 MEDOMAK RD",
    "dropdelcty": "BREMEN",
    "dropdelst": "ME",
    "dropdelzpp": "045519998",
    "dropphyadd": "160 MEDOMAK RD",
    "dropphycty": "BREMEN",
    "dropphyst": "ME",
    "dropphyzpp": "045519998",
    "dropmaladd": "160 MEDOMAK RD",
    "dropmalcty": "BREMEN",
    "dropmalst": "ME",
    "dropmalzpp": "045519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074666465,
    "dropsitcph": 2074666465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25021",
    "droptype": "D",
    "dropname": "MEDWAY",
    "dropdeladd": "2070 MEDWAY RD",
    "dropdelcty": "MEDWAY",
    "dropdelst": "ME",
    "dropdelzpp": "044609998",
    "dropphyadd": "2070 MEDWAY RD",
    "dropphycty": "MEDWAY",
    "dropphyst": "ME",
    "dropphyzpp": "044609998",
    "dropmaladd": "2070 MEDWAY RD",
    "dropmalcty": "MEDWAY",
    "dropmalst": "ME",
    "dropmalzpp": "044609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077469949,
    "dropsitcph": 2077469949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25024",
    "droptype": "D",
    "dropname": "MEXICO",
    "dropdeladd": "7 RIVERSIDE AVE",
    "dropdelcty": "MEXICO",
    "dropdelst": "ME",
    "dropdelzpp": "042579998",
    "dropphyadd": "7 RIVERSIDE AVE",
    "dropphycty": "MEXICO",
    "dropphyst": "ME",
    "dropphyzpp": "042579998",
    "dropmaladd": "7 RIVERSIDE AVE",
    "dropmalcty": "MEXICO",
    "dropmalst": "ME",
    "dropmalzpp": "042579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073648302,
    "dropsitcph": 2073648302,
    "dropfax": 2073642705
  },
  {
    "dcode": "D",
    "dropkey": "PV25025",
    "droptype": "D",
    "dropname": "MILBRIDGE",
    "dropdeladd": "19 SCHOOL ST",
    "dropdelcty": "MILBRIDGE",
    "dropdelst": "ME",
    "dropdelzpp": "046589998",
    "dropphyadd": "19 SCHOOL ST",
    "dropphycty": "MILBRIDGE",
    "dropphyst": "ME",
    "dropphyzpp": "046589998",
    "dropmaladd": "19 SCHOOL ST",
    "dropmalcty": "MILBRIDGE",
    "dropmalst": "ME",
    "dropmalzpp": "046589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075467835,
    "dropsitcph": 2075467835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25026",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "104 MAIN RD",
    "dropdelcty": "MILFORD",
    "dropdelst": "ME",
    "dropdelzpp": "044619998",
    "dropphyadd": "104 MAIN RD",
    "dropphycty": "MILFORD",
    "dropphyst": "ME",
    "dropphyzpp": "044619998",
    "dropmaladd": "104 MAIN RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "ME",
    "dropmalzpp": "044619998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078274272,
    "dropsitcph": 2078274272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25027",
    "droptype": "D",
    "dropname": "MILLINOCKET",
    "dropdeladd": "113 PENOBSCOT AVE",
    "dropdelcty": "MILLINOCKET",
    "dropdelst": "ME",
    "dropdelzpp": "044629998",
    "dropphyadd": "113 PENOBSCOT AVE",
    "dropphycty": "MILLINOCKET",
    "dropphyst": "ME",
    "dropphyzpp": "044629998",
    "dropmaladd": "113 PENOBSCOT AVE",
    "dropmalcty": "MILLINOCKET",
    "dropmalst": "ME",
    "dropmalzpp": "044629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077235921,
    "dropsitcph": 2077235921,
    "dropfax": 2077239791
  },
  {
    "dcode": "D",
    "dropkey": "PV25029",
    "droptype": "D",
    "dropname": "MILO",
    "dropdeladd": "10 PLEASANT ST",
    "dropdelcty": "MILO",
    "dropdelst": "ME",
    "dropdelzpp": "044639998",
    "dropphyadd": "10 PLEASANT ST",
    "dropphycty": "MILO",
    "dropphyst": "ME",
    "dropphyzpp": "044639998",
    "dropmaladd": "10 PLEASANT ST",
    "dropmalcty": "MILO",
    "dropmalst": "ME",
    "dropmalzpp": "044639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079432272,
    "dropsitcph": 2079432272,
    "dropfax": 2079432504
  },
  {
    "dcode": "D",
    "dropkey": "PV25030",
    "droptype": "D",
    "dropname": "MINOT",
    "dropdeladd": "348 MINOT AVE",
    "dropdelcty": "MINOT",
    "dropdelst": "ME",
    "dropdelzpp": "042589998",
    "dropphyadd": "348 MINOT AVE",
    "dropphycty": "MINOT",
    "dropphyst": "ME",
    "dropphyzpp": "042589998",
    "dropmaladd": "348 MINOT AVE",
    "dropmalcty": "MINOT",
    "dropmalst": "ME",
    "dropmalzpp": "042589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077842202,
    "dropsitcph": 2077842202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25032",
    "droptype": "D",
    "dropname": "MONHEGAN",
    "dropdeladd": "258 MONHEGAN AVE",
    "dropdelcty": "MONHEGAN",
    "dropdelst": "ME",
    "dropdelzpp": "048529998",
    "dropphyadd": "258 MONHEGAN AVE",
    "dropphycty": "MONHEGAN",
    "dropphyst": "ME",
    "dropphyzpp": "048529998",
    "dropmaladd": "258 MONHEGAN AVE",
    "dropmalcty": "MONHEGAN",
    "dropmalst": "ME",
    "dropmalzpp": "048529998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075940609,
    "dropsitcph": 2075940609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25033",
    "droptype": "D",
    "dropname": "MONMOUTH",
    "dropdeladd": "744 MAIN ST",
    "dropdelcty": "MONMOUTH",
    "dropdelst": "ME",
    "dropdelzpp": "042599998",
    "dropphyadd": "744 MAIN ST",
    "dropphycty": "MONMOUTH",
    "dropphyst": "ME",
    "dropphyzpp": "042599998",
    "dropmaladd": "744 MAIN ST",
    "dropmalcty": "MONMOUTH",
    "dropmalst": "ME",
    "dropmalzpp": "042599998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079334585,
    "dropsitcph": 2079334585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25034",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "59 W MAIN ST",
    "dropdelcty": "MONROE",
    "dropdelst": "ME",
    "dropdelzpp": "049519998",
    "dropphyadd": "59 W MAIN ST",
    "dropphycty": "MONROE",
    "dropphyst": "ME",
    "dropphyzpp": "049519998",
    "dropmaladd": "59 W MAIN ST",
    "dropmalcty": "MONROE",
    "dropmalst": "ME",
    "dropmalzpp": "049519998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075257786,
    "dropsitcph": 2075257786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25035",
    "droptype": "D",
    "dropname": "MONSON",
    "dropdeladd": "2 GREENVILLE RD",
    "dropdelcty": "MONSON",
    "dropdelst": "ME",
    "dropdelzpp": "044649998",
    "dropphyadd": "2 GREENVILLE RD",
    "dropphycty": "MONSON",
    "dropphyst": "ME",
    "dropphyzpp": "044649998",
    "dropmaladd": "2 GREENVILLE RD",
    "dropmalcty": "MONSON",
    "dropmalst": "ME",
    "dropmalzpp": "044649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079973975,
    "dropsitcph": 2079973975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25036",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "428 US ROUTE 1",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "ME",
    "dropdelzpp": "047609998",
    "dropphyadd": "428 US ROUTE 1",
    "dropphycty": "MONTICELLO",
    "dropphyst": "ME",
    "dropphyzpp": "047609998",
    "dropmaladd": "428 US ROUTE 1",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "ME",
    "dropmalzpp": "047609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075389741,
    "dropsitcph": 2075389741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25037",
    "droptype": "D",
    "dropname": "MOODY",
    "dropdeladd": "243 POST RD",
    "dropdelcty": "MOODY",
    "dropdelst": "ME",
    "dropdelzpp": "040549998",
    "dropphyadd": "243 POST RD",
    "dropphycty": "MOODY",
    "dropphyst": "ME",
    "dropphyzpp": "040549998",
    "dropmaladd": "243 POST RD",
    "dropmalcty": "MOODY",
    "dropmalst": "ME",
    "dropmalzpp": "040549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076467125,
    "dropsitcph": 2076467125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25039",
    "droptype": "D",
    "dropname": "MORRILL",
    "dropdeladd": "63 N MAIN ST",
    "dropdelcty": "MORRILL",
    "dropdelst": "ME",
    "dropdelzpp": "049529998",
    "dropphyadd": "63 N MAIN ST",
    "dropphycty": "MORRILL",
    "dropphyst": "ME",
    "dropphyzpp": "049529998",
    "dropmaladd": "63 N MAIN ST",
    "dropmalcty": "MORRILL",
    "dropmalst": "ME",
    "dropmalzpp": "049529998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778546034,
    "dropsitcph": 8778546034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25041",
    "droptype": "D",
    "dropname": "MOUNT DESERT",
    "dropdeladd": "1057 MAIN ST",
    "dropdelcty": "MOUNT DESERT",
    "dropdelst": "ME",
    "dropdelzpp": "046609998",
    "dropphyadd": "1057 MAIN ST",
    "dropphycty": "MOUNT DESERT",
    "dropphyst": "ME",
    "dropphyzpp": "046609998",
    "dropmaladd": "1057 MAIN ST",
    "dropmalcty": "MOUNT DESERT",
    "dropmalst": "ME",
    "dropmalzpp": "046609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072445480,
    "dropsitcph": 2072445480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25042",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "ME",
    "dropdelzpp": "043529998",
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "ME",
    "dropphyzpp": "043529998",
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "ME",
    "dropmalzpp": "043529998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072932701,
    "dropsitcph": 2072932701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25043",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "17 VILLAGE GREEN LN",
    "dropdelcty": "NAPLES",
    "dropdelst": "ME",
    "dropdelzpp": "040559998",
    "dropphyadd": "17 VILLAGE GREEN LN",
    "dropphycty": "NAPLES",
    "dropphyst": "ME",
    "dropphyzpp": "040559998",
    "dropmaladd": "17 VILLAGE GREEN LN",
    "dropmalcty": "NAPLES",
    "dropmalst": "ME",
    "dropmalzpp": "040559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076936340,
    "dropsitcph": 2076936340,
    "dropfax": 2076933703
  },
  {
    "dcode": "D",
    "dropkey": "PV25046",
    "droptype": "D",
    "dropname": "NEW GLOUCESTER",
    "dropdeladd": "9 GILMORE RD",
    "dropdelcty": "NEW GLOUCESTER",
    "dropdelst": "ME",
    "dropdelzpp": "042609998",
    "dropphyadd": "9 GILMORE RD",
    "dropphycty": "NEW GLOUCESTER",
    "dropphyst": "ME",
    "dropphyzpp": "042609998",
    "dropmaladd": "9 GILMORE RD",
    "dropmalcty": "NEW GLOUCESTER",
    "dropmalst": "ME",
    "dropmalzpp": "042609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079264414,
    "dropsitcph": 2079264414,
    "dropfax": 2079264691
  },
  {
    "dcode": "D",
    "dropkey": "PV25047",
    "droptype": "D",
    "dropname": "NEW HARBOR",
    "dropdeladd": "2500 BRISTOL RD",
    "dropdelcty": "NEW HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "045549998",
    "dropphyadd": "2500 BRISTOL RD",
    "dropphycty": "NEW HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "045549998",
    "dropmaladd": "2500 BRISTOL RD",
    "dropmalcty": "NEW HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "045549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074192659,
    "dropsitcph": 2074192659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25050",
    "droptype": "D",
    "dropname": "NEW SHARON",
    "dropdeladd": "18 POST OFFICE RD",
    "dropdelcty": "NEW SHARON",
    "dropdelst": "ME",
    "dropdelzpp": "049559998",
    "dropphyadd": "18 POST OFFICE RD",
    "dropphycty": "NEW SHARON",
    "dropphyst": "ME",
    "dropphyzpp": "049559998",
    "dropmaladd": "18 POST OFFICE RD",
    "dropmalcty": "NEW SHARON",
    "dropmalst": "ME",
    "dropmalzpp": "049559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077782072,
    "dropsitcph": 2077782072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25051",
    "droptype": "D",
    "dropname": "NEW SWEDEN",
    "dropdeladd": "414 STATION RD",
    "dropdelcty": "NEW SWEDEN",
    "dropdelst": "ME",
    "dropdelzpp": "047629998",
    "dropphyadd": "414 STATION RD",
    "dropphycty": "NEW SWEDEN",
    "dropphyst": "ME",
    "dropphyzpp": "047629998",
    "dropmaladd": "414 STATION RD",
    "dropmalcty": "NEW SWEDEN",
    "dropmalst": "ME",
    "dropmalzpp": "047629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078965503,
    "dropsitcph": 2078965503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25052",
    "droptype": "D",
    "dropname": "NEW VINEYARD",
    "dropdeladd": "18 LAKE ST",
    "dropdelcty": "NEW VINEYARD",
    "dropdelst": "ME",
    "dropdelzpp": "049569998",
    "dropphyadd": "18 LAKE ST",
    "dropphycty": "NEW VINEYARD",
    "dropphyst": "ME",
    "dropphyzpp": "049569998",
    "dropmaladd": "18 LAKE ST",
    "dropmalcty": "NEW VINEYARD",
    "dropmalst": "ME",
    "dropmalzpp": "049569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076522337,
    "dropsitcph": 2076522337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25054",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "106 MILLS RD",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "ME",
    "dropdelzpp": "045539998",
    "dropphyadd": "106 MILLS RD",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "ME",
    "dropphyzpp": "045539998",
    "dropmaladd": "106 MILLS RD",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "ME",
    "dropmalzpp": "045539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075633809,
    "dropsitcph": 2075633809,
    "dropfax": 2075637648
  },
  {
    "dcode": "D",
    "dropkey": "PV25055",
    "droptype": "D",
    "dropname": "NEWFIELD",
    "dropdeladd": "68 ELM ST",
    "dropdelcty": "NEWFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "040569998",
    "dropphyadd": "68 ELM ST",
    "dropphycty": "NEWFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "040569998",
    "dropmaladd": "68 ELM ST",
    "dropmalcty": "NEWFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "040569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077938535,
    "dropsitcph": 2077938535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25056",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "85 MAIN ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "ME",
    "dropdelzpp": "049539998",
    "dropphyadd": "85 MAIN ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "ME",
    "dropphyzpp": "049539998",
    "dropmaladd": "85 MAIN ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "ME",
    "dropmalzpp": "049539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073684445,
    "dropsitcph": 2073684445,
    "dropfax": 2073685966
  },
  {
    "dcode": "D",
    "dropkey": "PV25057",
    "droptype": "D",
    "dropname": "NEWRY",
    "dropdeladd": "8 POST OFFICE DR",
    "dropdelcty": "NEWRY",
    "dropdelst": "ME",
    "dropdelzpp": "042619998",
    "dropphyadd": "8 POST OFFICE DR",
    "dropphycty": "NEWRY",
    "dropphyst": "ME",
    "dropphyzpp": "042619998",
    "dropmaladd": "8 POST OFFICE DR",
    "dropmalcty": "NEWRY",
    "dropmalst": "ME",
    "dropmalzpp": "042619998",
    "dropsitphn": 2075102795,
    "dropsitlph": 7167649277,
    "dropsitcph": 7167649277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25058",
    "droptype": "D",
    "dropname": "NOBLEBORO",
    "dropdeladd": "36 CENTER ST",
    "dropdelcty": "NOBLEBORO",
    "dropdelst": "ME",
    "dropdelzpp": "045559998",
    "dropphyadd": "36 CENTER ST",
    "dropphycty": "NOBLEBORO",
    "dropphyst": "ME",
    "dropphyzpp": "045559998",
    "dropmaladd": "36 CENTER ST",
    "dropmalcty": "NOBLEBORO",
    "dropmalst": "ME",
    "dropmalzpp": "045559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075968475,
    "dropsitcph": 2075968475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25059",
    "droptype": "D",
    "dropname": "NORRIDGEWOCK",
    "dropdeladd": "2 CLARK ST",
    "dropdelcty": "NORRIDGEWOCK",
    "dropdelst": "ME",
    "dropdelzpp": "049579998",
    "dropphyadd": "2 CLARK ST",
    "dropphycty": "NORRIDGEWOCK",
    "dropphyst": "ME",
    "dropphyzpp": "049579998",
    "dropmaladd": "2 CLARK ST",
    "dropmalcty": "NORRIDGEWOCK",
    "dropmalst": "ME",
    "dropmalzpp": "049579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076344201,
    "dropsitcph": 2076344201,
    "dropfax": 2076344201
  },
  {
    "dcode": "D",
    "dropkey": "PV25061",
    "droptype": "D",
    "dropname": "NORTH ANSON",
    "dropdeladd": "9 MADISON ST",
    "dropdelcty": "NORTH ANSON",
    "dropdelst": "ME",
    "dropdelzpp": "049589998",
    "dropphyadd": "9 MADISON ST",
    "dropphycty": "NORTH ANSON",
    "dropphyst": "ME",
    "dropphyzpp": "049589998",
    "dropmaladd": "9 MADISON ST",
    "dropmalcty": "NORTH ANSON",
    "dropmalst": "ME",
    "dropmalzpp": "049589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076352431,
    "dropsitcph": 2076352431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25062",
    "droptype": "D",
    "dropname": "NORTH BERWICK",
    "dropdeladd": "36 WELLS ST",
    "dropdelcty": "NORTH BERWICK",
    "dropdelst": "ME",
    "dropdelzpp": "039069998",
    "dropphyadd": "36 WELLS ST",
    "dropphycty": "NORTH BERWICK",
    "dropphyst": "ME",
    "dropphyzpp": "039069998",
    "dropmaladd": "36 WELLS ST",
    "dropmalcty": "NORTH BERWICK",
    "dropmalst": "ME",
    "dropmalzpp": "039069998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076762266,
    "dropsitcph": 2076762266,
    "dropfax": 2076765799
  },
  {
    "dcode": "D",
    "dropkey": "PV25063",
    "droptype": "D",
    "dropname": "NORTH BRIDGTON",
    "dropdeladd": "101 N BRIDGTON RD",
    "dropdelcty": "NORTH BRIDGTON",
    "dropdelst": "ME",
    "dropdelzpp": "040579998",
    "dropphyadd": "101 N BRIDGTON RD",
    "dropphycty": "NORTH BRIDGTON",
    "dropphyst": "ME",
    "dropphyzpp": "040579998",
    "dropmaladd": "101 N BRIDGTON RD",
    "dropmalcty": "NORTH BRIDGTON",
    "dropmalst": "ME",
    "dropmalzpp": "040579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076478836,
    "dropsitcph": 2076478836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25065",
    "droptype": "D",
    "dropname": "EDGECOMB",
    "dropdeladd": "5 CROSS RD",
    "dropdelcty": "EDGECOMB",
    "dropdelst": "ME",
    "dropdelzpp": "045569998",
    "dropphyadd": "5 CROSS RD",
    "dropphycty": "EDGECOMB",
    "dropphyst": "ME",
    "dropphyzpp": "045569998",
    "dropmaladd": "5 CROSS RD",
    "dropmalcty": "EDGECOMB",
    "dropmalst": "ME",
    "dropmalzpp": "045569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078825529,
    "dropsitcph": 2078825529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25067",
    "droptype": "D",
    "dropname": "NORTH HAVEN",
    "dropdeladd": "27 MAIN ST",
    "dropdelcty": "NORTH HAVEN",
    "dropdelst": "ME",
    "dropdelzpp": "048539998",
    "dropphyadd": "27 MAIN ST",
    "dropphycty": "NORTH HAVEN",
    "dropphyst": "ME",
    "dropphyzpp": "048539998",
    "dropmaladd": "27 MAIN ST",
    "dropmalcty": "NORTH HAVEN",
    "dropmalst": "ME",
    "dropmalzpp": "048539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078672244,
    "dropsitcph": 2078672244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25070",
    "droptype": "D",
    "dropname": "NORTH MONMOUTH",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "NORTH MONMOUTH",
    "dropdelst": "ME",
    "dropdelzpp": "042659998",
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "NORTH MONMOUTH",
    "dropphyst": "ME",
    "dropphyzpp": "042659998",
    "dropmaladd": "140 N MAIN ST",
    "dropmalcty": "NORTH MONMOUTH",
    "dropmalst": "ME",
    "dropmalzpp": "042659998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079334460,
    "dropsitcph": 2079334460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25071",
    "droptype": "D",
    "dropname": "NEW PORTLAND",
    "dropdeladd": "186 MEADOW BROOK RD",
    "dropdelcty": "NEW PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "049619998",
    "dropphyadd": "186 MEADOW BROOK RD",
    "dropphycty": "NEW PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "049619998",
    "dropmaladd": "186 MEADOW BROOK RD",
    "dropmalcty": "NEW PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "049619998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076284941,
    "dropsitcph": 2076284941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25074",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "96 TAUNTON DR",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "ME",
    "dropdelzpp": "046649998",
    "dropphyadd": "96 TAUNTON DR",
    "dropphycty": "SULLIVAN",
    "dropphyst": "ME",
    "dropphyzpp": "046649998",
    "dropmaladd": "96 TAUNTON DR",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "ME",
    "dropmalzpp": "046649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074229033,
    "dropsitcph": 2074229033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25075",
    "droptype": "D",
    "dropname": "NORTH TURNER",
    "dropdeladd": "36 HOWES CORNER RD",
    "dropdelcty": "NORTH TURNER",
    "dropdelst": "ME",
    "dropdelzpp": "042669998",
    "dropphyadd": "36 HOWES CORNER RD",
    "dropphycty": "NORTH TURNER",
    "dropphyst": "ME",
    "dropphyzpp": "042669998",
    "dropmaladd": "36 HOWES CORNER RD",
    "dropmalcty": "NORTH TURNER",
    "dropmalst": "ME",
    "dropmalzpp": "042669998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072247734,
    "dropsitcph": 2072247734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25076",
    "droptype": "D",
    "dropname": "NORTH VASSALBORO",
    "dropdeladd": "847 MAIN ST",
    "dropdelcty": "NORTH VASSALBORO",
    "dropdelst": "ME",
    "dropdelzpp": "049629998",
    "dropphyadd": "847 MAIN ST",
    "dropphycty": "NORTH VASSALBORO",
    "dropphyst": "ME",
    "dropphyzpp": "049629998",
    "dropmaladd": "847 MAIN ST",
    "dropmalcty": "NORTH VASSALBORO",
    "dropmalst": "ME",
    "dropmalzpp": "049629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078736254,
    "dropsitcph": 2078736254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25077",
    "droptype": "D",
    "dropname": "NORTH WATERBORO",
    "dropdeladd": "977 SOKOKIS TRL",
    "dropdelcty": "NORTH WATERBORO",
    "dropdelst": "ME",
    "dropdelzpp": "040619998",
    "dropphyadd": "977 SOKOKIS TRL",
    "dropphycty": "NORTH WATERBORO",
    "dropphyst": "ME",
    "dropphyzpp": "040619998",
    "dropmaladd": "977 SOKOKIS TRL",
    "dropmalcty": "NORTH WATERBORO",
    "dropmalst": "ME",
    "dropmalzpp": "040619998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077932358,
    "dropsitcph": 2077932358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25078",
    "droptype": "D",
    "dropname": "NORTH WATERFORD",
    "dropdeladd": "905 VALLEY RD",
    "dropdelcty": "NORTH WATERFORD",
    "dropdelst": "ME",
    "dropdelzpp": "042679998",
    "dropphyadd": "905 VALLEY RD",
    "dropphycty": "NORTH WATERFORD",
    "dropphyst": "ME",
    "dropphyzpp": "042679998",
    "dropmaladd": "905 VALLEY RD",
    "dropmalcty": "NORTH WATERFORD",
    "dropmalst": "ME",
    "dropmalzpp": "042679998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075834848,
    "dropsitcph": 2075834848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25079",
    "droptype": "D",
    "dropname": "WHITEFIELD",
    "dropdeladd": "32 JEFFERSON RD",
    "dropdelcty": "WHITEFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "043539998",
    "dropphyadd": "32 JEFFERSON RD",
    "dropphycty": "WHITEFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "043539998",
    "dropmaladd": "32 JEFFERSON RD",
    "dropmalcty": "WHITEFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "043539998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075497011,
    "dropsitcph": 2075497011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25082",
    "droptype": "D",
    "dropname": "NORTHEAST HARBOR",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "NORTHEAST HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046629998",
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "NORTHEAST HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046629998",
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "NORTHEAST HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072763221,
    "dropsitcph": 2072763221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25084",
    "droptype": "D",
    "dropname": "NORWAY",
    "dropdeladd": "299 MAIN ST",
    "dropdelcty": "NORWAY",
    "dropdelst": "ME",
    "dropdelzpp": "042689998",
    "dropphyadd": "299 MAIN ST",
    "dropphycty": "NORWAY",
    "dropphyst": "ME",
    "dropphyzpp": "042689998",
    "dropmaladd": "299 MAIN ST",
    "dropmalcty": "NORWAY",
    "dropmalst": "ME",
    "dropmalzpp": "042689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077438341,
    "dropsitcph": 2077438341,
    "dropfax": 2077436140
  },
  {
    "dcode": "D",
    "dropkey": "PV25085",
    "droptype": "D",
    "dropname": "OAKFIELD",
    "dropdeladd": "198 OAKFIELD SMYRNA RD",
    "dropdelcty": "OAKFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "047639998",
    "dropphyadd": "198 OAKFIELD SMYRNA RD",
    "dropphycty": "OAKFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "047639998",
    "dropmaladd": "198 OAKFIELD SMYRNA RD",
    "dropmalcty": "OAKFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "047639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077578134,
    "dropsitcph": 2077578134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25086",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "62 WATER ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "ME",
    "dropdelzpp": "049639998",
    "dropphyadd": "62 WATER ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "ME",
    "dropphyzpp": "049639998",
    "dropmaladd": "62 WATER ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "ME",
    "dropmalzpp": "049639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074652404,
    "dropsitcph": 2074652404,
    "dropfax": 2074652404
  },
  {
    "dcode": "D",
    "dropkey": "PV25088",
    "droptype": "D",
    "dropname": "OGUNQUIT",
    "dropdeladd": "172 MAIN ST",
    "dropdelcty": "OGUNQUIT",
    "dropdelst": "ME",
    "dropdelzpp": "039079998",
    "dropphyadd": "172 MAIN ST",
    "dropphycty": "OGUNQUIT",
    "dropphyst": "ME",
    "dropphyzpp": "039079998",
    "dropmaladd": "172 MAIN ST",
    "dropmalcty": "OGUNQUIT",
    "dropmalst": "ME",
    "dropmalzpp": "039079998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076465566,
    "dropsitcph": 2076465566,
    "dropfax": 2076465566
  },
  {
    "dcode": "D",
    "dropkey": "PV25090",
    "droptype": "D",
    "dropname": "OLD ORCHARD BEACH",
    "dropdeladd": "2 CASCADE RD STE 8",
    "dropdelcty": "OLD ORCHARD BEACH",
    "dropdelst": "ME",
    "dropdelzpp": "040649998",
    "dropphyadd": "2 CASCADE RD STE 8",
    "dropphycty": "OLD ORCHARD BEACH",
    "dropphyst": "ME",
    "dropphyzpp": "040649998",
    "dropmaladd": "2 CASCADE RD STE 8",
    "dropmalcty": "OLD ORCHARD BEACH",
    "dropmalst": "ME",
    "dropmalzpp": "040649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079344401,
    "dropsitcph": 2079344401,
    "dropfax": 2079343623
  },
  {
    "dcode": "D",
    "dropkey": "PV25091",
    "droptype": "D",
    "dropname": "OLD TOWN",
    "dropdeladd": "141 CENTER ST",
    "dropdelcty": "OLD TOWN",
    "dropdelst": "ME",
    "dropdelzpp": "044689998",
    "dropphyadd": "141 CENTER ST",
    "dropphycty": "OLD TOWN",
    "dropphyst": "ME",
    "dropphyzpp": "044689998",
    "dropmaladd": "141 CENTER ST",
    "dropmalcty": "OLD TOWN",
    "dropmalst": "ME",
    "dropmalzpp": "044689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078273327,
    "dropsitcph": 2078273327,
    "dropfax": 2078275251
  },
  {
    "dcode": "D",
    "dropkey": "PV25092",
    "droptype": "D",
    "dropname": "OQUOSSOC",
    "dropdeladd": "92 CARRY RD",
    "dropdelcty": "OQUOSSOC",
    "dropdelst": "ME",
    "dropdelzpp": "049649998",
    "dropphyadd": "92 CARRY RD",
    "dropphycty": "OQUOSSOC",
    "dropphyst": "ME",
    "dropphyzpp": "049649998",
    "dropmaladd": "92 CARRY RD",
    "dropmalcty": "OQUOSSOC",
    "dropmalst": "ME",
    "dropmalzpp": "049649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078643685,
    "dropsitcph": 2078643685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25094",
    "droptype": "D",
    "dropname": "ORLAND",
    "dropdeladd": "59 CASTINE RD",
    "dropdelcty": "ORLAND",
    "dropdelst": "ME",
    "dropdelzpp": "044729998",
    "dropphyadd": "59 CASTINE RD",
    "dropphycty": "ORLAND",
    "dropphyst": "ME",
    "dropphyzpp": "044729998",
    "dropmaladd": "59 CASTINE RD",
    "dropmalcty": "ORLAND",
    "dropmalst": "ME",
    "dropmalzpp": "044729998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074692184,
    "dropsitcph": 2074692184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25095",
    "droptype": "D",
    "dropname": "ORONO",
    "dropdeladd": "1 BENNOCH RD",
    "dropdelcty": "ORONO",
    "dropdelst": "ME",
    "dropdelzpp": "044739998",
    "dropphyadd": "1 BENNOCH RD",
    "dropphycty": "ORONO",
    "dropphyst": "ME",
    "dropphyzpp": "044739998",
    "dropmaladd": "1 BENNOCH RD",
    "dropmalcty": "ORONO",
    "dropmalst": "ME",
    "dropmalzpp": "044739998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078662566,
    "dropsitcph": 2078662566,
    "dropfax": 2078664075
  },
  {
    "dcode": "D",
    "dropkey": "PV25096",
    "droptype": "D",
    "dropname": "ORRINGTON",
    "dropdeladd": "726 RIVER RD",
    "dropdelcty": "ORRINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "044749998",
    "dropphyadd": "726 RIVER RD",
    "dropphycty": "ORRINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "044749998",
    "dropmaladd": "726 RIVER RD",
    "dropmalcty": "ORRINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "044749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078253337,
    "dropsitcph": 2078253337,
    "dropfax": 2078253337
  },
  {
    "dcode": "D",
    "dropkey": "PV25097",
    "droptype": "D",
    "dropname": "ORRS ISLAND",
    "dropdeladd": "1729 HARPSWELL ISLANDS RD",
    "dropdelcty": "ORRS ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "040669998",
    "dropphyadd": "1729 HARPSWELL ISLANDS RD",
    "dropphycty": "ORRS ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "040669998",
    "dropmaladd": "1729 HARPSWELL ISLANDS RD",
    "dropmalcty": "ORRS ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "040669998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078336278,
    "dropsitcph": 2078336278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25100",
    "droptype": "D",
    "dropname": "OWLS HEAD",
    "dropdeladd": "5 MAIN ST",
    "dropdelcty": "OWLS HEAD",
    "dropdelst": "ME",
    "dropdelzpp": "048549998",
    "dropphyadd": "5 MAIN ST",
    "dropphycty": "OWLS HEAD",
    "dropphyst": "ME",
    "dropphyzpp": "048549998",
    "dropmaladd": "5 MAIN ST",
    "dropmalcty": "OWLS HEAD",
    "dropmalst": "ME",
    "dropmalzpp": "048549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075947535,
    "dropsitcph": 2075947535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25102",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "98 PLEASANT ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "ME",
    "dropdelzpp": "042709998",
    "dropphyadd": "98 PLEASANT ST",
    "dropphycty": "OXFORD",
    "dropphyst": "ME",
    "dropphyzpp": "042709998",
    "dropmaladd": "98 PLEASANT ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "ME",
    "dropmalzpp": "042709998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075394484,
    "dropsitcph": 2075394484,
    "dropfax": 2075399120
  },
  {
    "dcode": "D",
    "dropkey": "PV25103",
    "droptype": "D",
    "dropname": "PALERMO",
    "dropdeladd": "111 BRANCH MLS",
    "dropdelcty": "PALERMO",
    "dropdelst": "ME",
    "dropdelzpp": "043549998",
    "dropphyadd": "111 BRANCH MLS",
    "dropphycty": "PALERMO",
    "dropphyst": "ME",
    "dropphyzpp": "043549998",
    "dropmaladd": "111 BRANCH MLS",
    "dropmalcty": "PALERMO",
    "dropmalst": "ME",
    "dropmalzpp": "043549998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779074351,
    "dropsitcph": 8779074351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25104",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "3 WARREN HILL RD",
    "dropdelcty": "PALMYRA",
    "dropdelst": "ME",
    "dropdelzpp": "049659998",
    "dropphyadd": "3 WARREN HILL RD",
    "dropphycty": "PALMYRA",
    "dropphyst": "ME",
    "dropphyzpp": "049659998",
    "dropmaladd": "3 WARREN HILL RD",
    "dropmalcty": "PALMYRA",
    "dropmalst": "ME",
    "dropmalzpp": "049659998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079384288,
    "dropsitcph": 2079384288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25105",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "39 TREMONT ST",
    "dropdelcty": "PARIS",
    "dropdelst": "ME",
    "dropdelzpp": "042719998",
    "dropphyadd": "39 TREMONT ST",
    "dropphycty": "PARIS",
    "dropphyst": "ME",
    "dropphyzpp": "042719998",
    "dropmaladd": "39 TREMONT ST",
    "dropmalcty": "PARIS",
    "dropmalst": "ME",
    "dropmalzpp": "042719998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077437959,
    "dropsitcph": 2077437959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25107",
    "droptype": "D",
    "dropname": "PASSADUMKEAG",
    "dropdeladd": "70 PLEASANT ST",
    "dropdelcty": "PASSADUMKEAG",
    "dropdelst": "ME",
    "dropdelzpp": "044759998",
    "dropphyadd": "70 PLEASANT ST",
    "dropphycty": "PASSADUMKEAG",
    "dropphyst": "ME",
    "dropphyzpp": "044759998",
    "dropmaladd": "70 PLEASANT ST",
    "dropmalcty": "PASSADUMKEAG",
    "dropmalst": "ME",
    "dropmalzpp": "044759998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077325189,
    "dropsitcph": 2077325189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25108",
    "droptype": "D",
    "dropname": "PATTEN",
    "dropdeladd": "24 MAIN ST",
    "dropdelcty": "PATTEN",
    "dropdelst": "ME",
    "dropdelzpp": "047659998",
    "dropphyadd": "24 MAIN ST",
    "dropphycty": "PATTEN",
    "dropphyst": "ME",
    "dropphyzpp": "047659998",
    "dropmaladd": "24 MAIN ST",
    "dropmalcty": "PATTEN",
    "dropmalst": "ME",
    "dropmalzpp": "047659998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075282210,
    "dropsitcph": 2075282210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25112",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "475 US ROUTE 1",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "ME",
    "dropdelzpp": "046669998",
    "dropphyadd": "475 US ROUTE 1",
    "dropphycty": "PEMBROKE",
    "dropphyst": "ME",
    "dropphyzpp": "046669998",
    "dropmaladd": "475 US ROUTE 1",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "ME",
    "dropmalzpp": "046669998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079528725,
    "dropsitcph": 2079528725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25113",
    "droptype": "D",
    "dropname": "PENOBSCOT",
    "dropdeladd": "21 N PENOBSCOT RD",
    "dropdelcty": "PENOBSCOT",
    "dropdelst": "ME",
    "dropdelzpp": "044769998",
    "dropphyadd": "21 N PENOBSCOT RD",
    "dropphycty": "PENOBSCOT",
    "dropphyst": "ME",
    "dropphyzpp": "044769998",
    "dropmaladd": "21 N PENOBSCOT RD",
    "dropmalcty": "PENOBSCOT",
    "dropmalst": "ME",
    "dropmalzpp": "044769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075483515,
    "dropsitcph": 2075483515,
    "dropfax": 2073268494
  },
  {
    "dcode": "D",
    "dropkey": "PV25115",
    "droptype": "D",
    "dropname": "PERHAM",
    "dropdeladd": "2A MOUSE ISLAND RD",
    "dropdelcty": "PERHAM",
    "dropdelst": "ME",
    "dropdelzpp": "047669998",
    "dropphyadd": "2A MOUSE ISLAND RD",
    "dropphycty": "PERHAM",
    "dropphyst": "ME",
    "dropphyzpp": "047669998",
    "dropmaladd": "2A MOUSE ISLAND RD",
    "dropmalcty": "PERHAM",
    "dropmalst": "ME",
    "dropmalzpp": "047669998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077627449,
    "dropsitcph": 2077627449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25116",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "972 US ROUTE 1",
    "dropdelcty": "PERRY",
    "dropdelst": "ME",
    "dropdelzpp": "046679998",
    "dropphyadd": "972 US ROUTE 1",
    "dropphycty": "PERRY",
    "dropphyst": "ME",
    "dropphyzpp": "046679998",
    "dropmaladd": "972 US ROUTE 1",
    "dropmalcty": "PERRY",
    "dropmalst": "ME",
    "dropmalzpp": "046679998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078534348,
    "dropsitcph": 2078534348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25117",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "93 MAIN ST",
    "dropdelcty": "PERU",
    "dropdelst": "ME",
    "dropdelzpp": "042909998",
    "dropphyadd": "93 MAIN ST",
    "dropphycty": "PERU",
    "dropphyst": "ME",
    "dropphyzpp": "042909998",
    "dropmaladd": "93 MAIN ST",
    "dropmalcty": "PERU",
    "dropmalst": "ME",
    "dropmalzpp": "042909998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075628896,
    "dropsitcph": 2075628896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25118",
    "droptype": "D",
    "dropname": "PHILLIPS",
    "dropdeladd": "91 DODGE RD",
    "dropdelcty": "PHILLIPS",
    "dropdelst": "ME",
    "dropdelzpp": "049669998",
    "dropphyadd": "91 DODGE RD",
    "dropphycty": "PHILLIPS",
    "dropphyst": "ME",
    "dropphyzpp": "049669998",
    "dropmaladd": "91 DODGE RD",
    "dropmalcty": "PHILLIPS",
    "dropmalst": "ME",
    "dropmalzpp": "049669998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076393852,
    "dropsitcph": 2076393852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25119",
    "droptype": "D",
    "dropname": "PHIPPSBURG",
    "dropdeladd": "520 MAIN RD",
    "dropdelcty": "PHIPPSBURG",
    "dropdelst": "ME",
    "dropdelzpp": "045629998",
    "dropphyadd": "520 MAIN RD",
    "dropphycty": "PHIPPSBURG",
    "dropphyst": "ME",
    "dropphyzpp": "045629998",
    "dropmaladd": "520 MAIN RD",
    "dropmalcty": "PHIPPSBURG",
    "dropmalst": "ME",
    "dropmalzpp": "045629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074420133,
    "dropsitcph": 2074420133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25121",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "131 CENTRAL ST",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "049679998",
    "dropphyadd": "131 CENTRAL ST",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "049679998",
    "dropmaladd": "131 CENTRAL ST",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "049679998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074872722,
    "dropsitcph": 2074872722,
    "dropfax": 2074873772
  },
  {
    "dcode": "D",
    "dropkey": "PV25123",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "1947 MOOSEHEAD TRL",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "ME",
    "dropdelzpp": "049699998",
    "dropphyadd": "1947 MOOSEHEAD TRL",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "ME",
    "dropphyzpp": "049699998",
    "dropmaladd": "1947 MOOSEHEAD TRL",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "ME",
    "dropmalzpp": "049699998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072574303,
    "dropsitcph": 2072574303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25125",
    "droptype": "D",
    "dropname": "POLAND",
    "dropdeladd": "965 MAINE ST",
    "dropdelcty": "POLAND",
    "dropdelst": "ME",
    "dropdelzpp": "042749998",
    "dropphyadd": "965 MAINE ST",
    "dropphycty": "POLAND",
    "dropphyst": "ME",
    "dropphyzpp": "042749998",
    "dropmaladd": "965 MAINE ST",
    "dropmalcty": "POLAND",
    "dropmalst": "ME",
    "dropmalzpp": "042749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773642745,
    "dropsitcph": 8773642745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25128",
    "droptype": "D",
    "dropname": "PORT CLYDE",
    "dropdeladd": "860 PORT CLYDE RD",
    "dropdelcty": "PORT CLYDE",
    "dropdelst": "ME",
    "dropdelzpp": "048559998",
    "dropphyadd": "860 PORT CLYDE RD",
    "dropphycty": "PORT CLYDE",
    "dropphyst": "ME",
    "dropphyzpp": "048559998",
    "dropmaladd": "860 PORT CLYDE RD",
    "dropmalcty": "PORT CLYDE",
    "dropmalst": "ME",
    "dropmalzpp": "048559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073726693,
    "dropsitcph": 2073726693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25129",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "1 SCHOOL ST",
    "dropdelcty": "PORTAGE",
    "dropdelst": "ME",
    "dropdelzpp": "047689998",
    "dropphyadd": "1 SCHOOL ST",
    "dropphycty": "PORTAGE",
    "dropphyst": "ME",
    "dropphyzpp": "047689998",
    "dropmaladd": "1 SCHOOL ST",
    "dropmalcty": "PORTAGE",
    "dropmalst": "ME",
    "dropmalzpp": "047689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074356947,
    "dropsitcph": 2074356947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25130",
    "droptype": "D",
    "dropname": "PORTER",
    "dropdeladd": "548 OSSIPEE TRL",
    "dropdelcty": "PORTER",
    "dropdelst": "ME",
    "dropdelzpp": "040689998",
    "dropphyadd": "548 OSSIPEE TRL",
    "dropphycty": "PORTER",
    "dropphyst": "ME",
    "dropphyzpp": "040689998",
    "dropmaladd": "548 OSSIPEE TRL",
    "dropmalcty": "PORTER",
    "dropmalst": "ME",
    "dropmalzpp": "040689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076253525,
    "dropsitcph": 2076253525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25132",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "125 FOREST AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041019998",
    "dropphyadd": "125 FOREST AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041019998",
    "dropmaladd": "125 FOREST AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041019998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078718529,
    "dropsitcph": 2078718437,
    "dropfax": 2078718516
  },
  {
    "dcode": "D",
    "dropkey": "PV25133",
    "droptype": "D",
    "dropname": "POWNAL",
    "dropdeladd": "195 ALLEN RD",
    "dropdelcty": "POWNAL",
    "dropdelst": "ME",
    "dropdelzpp": "040699998",
    "dropphyadd": "195 ALLEN RD",
    "dropphycty": "POWNAL",
    "dropphyst": "ME",
    "dropphyzpp": "040699998",
    "dropmaladd": "195 ALLEN RD",
    "dropmalcty": "POWNAL",
    "dropmalst": "ME",
    "dropmalzpp": "040699998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076884474,
    "dropsitcph": 2076884474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25134",
    "droptype": "D",
    "dropname": "PRESQUE ISLE",
    "dropdeladd": "23 2ND ST",
    "dropdelcty": "PRESQUE ISLE",
    "dropdelst": "ME",
    "dropdelzpp": "047699998",
    "dropphyadd": "23 2ND ST",
    "dropphycty": "PRESQUE ISLE",
    "dropphyst": "ME",
    "dropphyzpp": "047699998",
    "dropmaladd": "23 2ND ST",
    "dropmalcty": "PRESQUE ISLE",
    "dropmalst": "ME",
    "dropmalzpp": "047699998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077683931,
    "dropsitcph": 2077683931,
    "dropfax": 2077683912
  },
  {
    "dcode": "D",
    "dropkey": "PV25135",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "20 MAIN ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "ME",
    "dropdelzpp": "046689998",
    "dropphyadd": "20 MAIN ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "ME",
    "dropphyzpp": "046689998",
    "dropmaladd": "20 MAIN ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "ME",
    "dropmalzpp": "046689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075580074,
    "dropsitcph": 2075580074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25136",
    "droptype": "D",
    "dropname": "PROSPECT HARBOR",
    "dropdeladd": "11 W BAY RD",
    "dropdelcty": "PROSPECT HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046699998",
    "dropphyadd": "11 W BAY RD",
    "dropphycty": "PROSPECT HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046699998",
    "dropmaladd": "11 W BAY RD",
    "dropmalcty": "PROSPECT HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046699998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079637183,
    "dropsitcph": 2079637183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25142",
    "droptype": "D",
    "dropname": "RANGELEY",
    "dropdeladd": "2517 MAIN ST",
    "dropdelcty": "RANGELEY",
    "dropdelst": "ME",
    "dropdelzpp": "049709998",
    "dropphyadd": "2517 MAIN ST",
    "dropphycty": "RANGELEY",
    "dropphyst": "ME",
    "dropphyzpp": "049709998",
    "dropmaladd": "2517 MAIN ST",
    "dropmalcty": "RANGELEY",
    "dropmalst": "ME",
    "dropmalzpp": "049709998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076701147,
    "dropsitcph": 2076701147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25143",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "1235 ROOSEVELT TRL",
    "dropdelcty": "RAYMOND",
    "dropdelst": "ME",
    "dropdelzpp": "040719998",
    "dropphyadd": "1235 ROOSEVELT TRL",
    "dropphycty": "RAYMOND",
    "dropphyst": "ME",
    "dropphyzpp": "040719998",
    "dropmaladd": "1235 ROOSEVELT TRL",
    "dropmalcty": "RAYMOND",
    "dropmalst": "ME",
    "dropmalzpp": "040719998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778541574,
    "dropsitcph": 8778541574,
    "dropfax": 2076553792
  },
  {
    "dcode": "D",
    "dropkey": "PV25144",
    "droptype": "D",
    "dropname": "READFIELD",
    "dropdeladd": "1138 MAIN ST",
    "dropdelcty": "READFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "043559998",
    "dropphyadd": "1138 MAIN ST",
    "dropphycty": "READFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "043559998",
    "dropmaladd": "1138 MAIN ST",
    "dropmalcty": "READFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "043559998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076859220,
    "dropsitcph": 2076859220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25145",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "92 MAIN ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "ME",
    "dropdelzpp": "043579998",
    "dropphyadd": "92 MAIN ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "ME",
    "dropphyzpp": "043579998",
    "dropmaladd": "92 MAIN ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "ME",
    "dropmalzpp": "043579998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077374423,
    "dropsitcph": 2077374423,
    "dropfax": 2077372493
  },
  {
    "dcode": "D",
    "dropkey": "PV25146",
    "droptype": "D",
    "dropname": "ROBBINSTON",
    "dropdeladd": "398 US RTE 1",
    "dropdelcty": "ROBBINSTON",
    "dropdelst": "ME",
    "dropdelzpp": "046719998",
    "dropphyadd": "398 US RTE 1",
    "dropphycty": "ROBBINSTON",
    "dropphyst": "ME",
    "dropphyzpp": "046719998",
    "dropmaladd": "398 US RTE 1",
    "dropmalcty": "ROBBINSTON",
    "dropmalst": "ME",
    "dropmalzpp": "046719998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074543929,
    "dropsitcph": 2074543929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25147",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "21 LIMEROCK ST STE 9998",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "ME",
    "dropdelzpp": "048419998",
    "dropphyadd": "21 LIMEROCK ST STE 9998",
    "dropphycty": "ROCKLAND",
    "dropphyst": "ME",
    "dropphyzpp": "048419998",
    "dropmaladd": "21 LIMEROCK ST STE 9998",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "ME",
    "dropmalzpp": "048419998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075966461,
    "dropsitcph": 2075966461,
    "dropfax": 2075944168
  },
  {
    "dcode": "D",
    "dropkey": "PV25148",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "223 UNION ST",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "ME",
    "dropdelzpp": "048569998",
    "dropphyadd": "223 UNION ST",
    "dropphycty": "ROCKPORT",
    "dropphyst": "ME",
    "dropphyzpp": "048569998",
    "dropmaladd": "223 UNION ST",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "ME",
    "dropmalzpp": "048569998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072368809,
    "dropsitcph": 2072368809,
    "dropfax": 2072366828
  },
  {
    "dcode": "D",
    "dropkey": "PV25149",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "62 VILLAGE RD",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "ME",
    "dropdelzpp": "044789998",
    "dropphyadd": "62 VILLAGE RD",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "ME",
    "dropphyzpp": "044789998",
    "dropmaladd": "62 VILLAGE RD",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "ME",
    "dropmalzpp": "044789998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075342277,
    "dropsitcph": 2075342277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25150",
    "droptype": "D",
    "dropname": "ROUND POND",
    "dropdeladd": "2 POST OFFICE RD",
    "dropdelcty": "ROUND POND",
    "dropdelst": "ME",
    "dropdelzpp": "045649998",
    "dropphyadd": "2 POST OFFICE RD",
    "dropphycty": "ROUND POND",
    "dropphyst": "ME",
    "dropphyzpp": "045649998",
    "dropmaladd": "2 POST OFFICE RD",
    "dropmalcty": "ROUND POND",
    "dropmalst": "ME",
    "dropmalzpp": "045649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074192039,
    "dropsitcph": 2074192039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25151",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "6 FRYE CROSSOVER RD",
    "dropdelcty": "ROXBURY",
    "dropdelst": "ME",
    "dropdelzpp": "042759998",
    "dropphyadd": "6 FRYE CROSSOVER RD",
    "dropphycty": "ROXBURY",
    "dropphyst": "ME",
    "dropphyzpp": "042759998",
    "dropmaladd": "6 FRYE CROSSOVER RD",
    "dropmalcty": "ROXBURY",
    "dropmalst": "ME",
    "dropmalzpp": "042759998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073642410,
    "dropsitcph": 2073642410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25152",
    "droptype": "D",
    "dropname": "RUMFORD",
    "dropdeladd": "137 CONGRESS ST",
    "dropdelcty": "RUMFORD",
    "dropdelst": "ME",
    "dropdelzpp": "042769998",
    "dropphyadd": "137 CONGRESS ST",
    "dropphycty": "RUMFORD",
    "dropphyst": "ME",
    "dropphyzpp": "042769998",
    "dropmaladd": "137 CONGRESS ST",
    "dropmalcty": "RUMFORD",
    "dropmalst": "ME",
    "dropmalzpp": "042769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073648681,
    "dropsitcph": 2073648681,
    "dropfax": 2073647035
  },
  {
    "dcode": "D",
    "dropkey": "PV25155",
    "droptype": "D",
    "dropname": "SABATTUS",
    "dropdeladd": "4 MIDDLE RD",
    "dropdelcty": "SABATTUS",
    "dropdelst": "ME",
    "dropdelzpp": "042809998",
    "dropphyadd": "4 MIDDLE RD",
    "dropphycty": "SABATTUS",
    "dropphyst": "ME",
    "dropphyzpp": "042809998",
    "dropmaladd": "4 MIDDLE RD",
    "dropmalcty": "SABATTUS",
    "dropmalst": "ME",
    "dropmalzpp": "042809998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073754251,
    "dropsitcph": 2073754251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25156",
    "droptype": "D",
    "dropname": "SACO",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "SACO",
    "dropdelst": "ME",
    "dropdelzpp": "040729998",
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "SACO",
    "dropphyst": "ME",
    "dropphyzpp": "040729998",
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "SACO",
    "dropmalst": "ME",
    "dropmalzpp": "040729998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072847611,
    "dropsitcph": 2072847611,
    "dropfax": 2072841346
  },
  {
    "dcode": "D",
    "dropkey": "PV25157",
    "droptype": "D",
    "dropname": "SAINT AGATHA",
    "dropdeladd": "353 MAIN ST",
    "dropdelcty": "SAINT AGATHA",
    "dropdelst": "ME",
    "dropdelzpp": "047729998",
    "dropphyadd": "353 MAIN ST",
    "dropphycty": "SAINT AGATHA",
    "dropphyst": "ME",
    "dropphyzpp": "047729998",
    "dropmaladd": "353 MAIN ST",
    "dropmalcty": "SAINT AGATHA",
    "dropmalst": "ME",
    "dropmalzpp": "047729998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075437593,
    "dropsitcph": 2075437593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25158",
    "droptype": "D",
    "dropname": "SAINT ALBANS",
    "dropdeladd": "27 MAIN ST",
    "dropdelcty": "SAINT ALBANS",
    "dropdelst": "ME",
    "dropdelzpp": "049719998",
    "dropphyadd": "27 MAIN ST",
    "dropphycty": "SAINT ALBANS",
    "dropphyst": "ME",
    "dropphyzpp": "049719998",
    "dropmaladd": "27 MAIN ST",
    "dropmalcty": "SAINT ALBANS",
    "dropmalst": "ME",
    "dropmalzpp": "049719998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079382865,
    "dropsitcph": 2079382865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25159",
    "droptype": "D",
    "dropname": "SAINT DAVID",
    "dropdeladd": "994 MAIN ST",
    "dropdelcty": "SAINT DAVID",
    "dropdelst": "ME",
    "dropdelzpp": "047739998",
    "dropphyadd": "994 MAIN ST",
    "dropphycty": "SAINT DAVID",
    "dropphyst": "ME",
    "dropphyzpp": "047739998",
    "dropmaladd": "994 MAIN ST",
    "dropmalcty": "SAINT DAVID",
    "dropmalst": "ME",
    "dropmalzpp": "047739998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077287087,
    "dropsitcph": 2077287087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25160",
    "droptype": "D",
    "dropname": "SAINT FRANCIS",
    "dropdeladd": "890 MAIN ST",
    "dropdelcty": "SAINT FRANCIS",
    "dropdelst": "ME",
    "dropdelzpp": "047749998",
    "dropphyadd": "890 MAIN ST",
    "dropphycty": "SAINT FRANCIS",
    "dropphyst": "ME",
    "dropphyzpp": "047749998",
    "dropmaladd": "890 MAIN ST",
    "dropmalcty": "SAINT FRANCIS",
    "dropmalst": "ME",
    "dropmalzpp": "047749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779076273,
    "dropsitcph": 8779076273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25162",
    "droptype": "D",
    "dropname": "SALSBURY COVE",
    "dropdeladd": "855 NORWAY DR",
    "dropdelcty": "SALSBURY COVE",
    "dropdelst": "ME",
    "dropdelzpp": "046729998",
    "dropphyadd": "855 NORWAY DR",
    "dropphycty": "SALSBURY COVE",
    "dropphyst": "ME",
    "dropphyzpp": "046729998",
    "dropmaladd": "855 NORWAY DR",
    "dropmalcty": "SALSBURY COVE",
    "dropmalst": "ME",
    "dropmalzpp": "046729998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072884594,
    "dropsitcph": 2072884594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25164",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "30 SCHOOL ST",
    "dropdelcty": "SANFORD",
    "dropdelst": "ME",
    "dropdelzpp": "040739998",
    "dropphyadd": "30 SCHOOL ST",
    "dropphycty": "SANFORD",
    "dropphyst": "ME",
    "dropphyzpp": "040739998",
    "dropmaladd": "30 SCHOOL ST",
    "dropmalcty": "SANFORD",
    "dropmalst": "ME",
    "dropmalzpp": "040739998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073243664,
    "dropsitcph": 2073243664,
    "dropfax": 2073247275
  },
  {
    "dcode": "D",
    "dropkey": "PV25165",
    "droptype": "D",
    "dropname": "SANGERVILLE",
    "dropdeladd": "54 MAIN ST",
    "dropdelcty": "SANGERVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "044799998",
    "dropphyadd": "54 MAIN ST",
    "dropphycty": "SANGERVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "044799998",
    "dropmaladd": "54 MAIN ST",
    "dropmalcty": "SANGERVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "044799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078025459,
    "dropsitcph": 2078025459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25167",
    "droptype": "D",
    "dropname": "SCARBOROUGH",
    "dropdeladd": "31 GORHAM RD",
    "dropdelcty": "SCARBOROUGH",
    "dropdelst": "ME",
    "dropdelzpp": "040749998",
    "dropphyadd": "31 GORHAM RD",
    "dropphycty": "SCARBOROUGH",
    "dropphyst": "ME",
    "dropphyzpp": "040749998",
    "dropmaladd": "31 GORHAM RD",
    "dropmalcty": "SCARBOROUGH",
    "dropmalst": "ME",
    "dropmalzpp": "040749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075102792,
    "dropsitcph": 2078855328,
    "dropfax": 2078859824
  },
  {
    "dcode": "D",
    "dropkey": "PV25168",
    "droptype": "D",
    "dropname": "SEAL COVE",
    "dropdeladd": "896 TREMONT RD",
    "dropdelcty": "SEAL COVE",
    "dropdelst": "ME",
    "dropdelzpp": "046749998",
    "dropphyadd": "896 TREMONT RD",
    "dropphycty": "SEAL COVE",
    "dropphyst": "ME",
    "dropphyzpp": "046749998",
    "dropmaladd": "896 TREMONT RD",
    "dropmalcty": "SEAL COVE",
    "dropmalst": "ME",
    "dropmalzpp": "046749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072445161,
    "dropsitcph": 2072445161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25169",
    "droptype": "D",
    "dropname": "SEAL HARBOR",
    "dropdeladd": "14 MAIN ST",
    "dropdelcty": "SEAL HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046759998",
    "dropphyadd": "14 MAIN ST",
    "dropphycty": "SEAL HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046759998",
    "dropmaladd": "14 MAIN ST",
    "dropmalcty": "SEAL HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046759998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072765341,
    "dropsitcph": 2072765341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25170",
    "droptype": "D",
    "dropname": "SEARSMONT",
    "dropdeladd": "49 MAIN ST N",
    "dropdelcty": "SEARSMONT",
    "dropdelst": "ME",
    "dropdelzpp": "049739998",
    "dropphyadd": "49 MAIN ST N",
    "dropphycty": "SEARSMONT",
    "dropphyst": "ME",
    "dropphyzpp": "049739998",
    "dropmaladd": "49 MAIN ST N",
    "dropmalcty": "SEARSMONT",
    "dropmalst": "ME",
    "dropmalzpp": "049739998",
    "dropsitphn": 2073425944,
    "dropsitlph": 8778541795,
    "dropsitcph": 8778541795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25171",
    "droptype": "D",
    "dropname": "SEARSPORT",
    "dropdeladd": "4 WATER ST",
    "dropdelcty": "SEARSPORT",
    "dropdelst": "ME",
    "dropdelzpp": "049749998",
    "dropphyadd": "4 WATER ST",
    "dropphycty": "SEARSPORT",
    "dropphyst": "ME",
    "dropphyzpp": "049749998",
    "dropmaladd": "4 WATER ST",
    "dropmalcty": "SEARSPORT",
    "dropmalst": "ME",
    "dropmalzpp": "049749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075482703,
    "dropsitcph": 2075482703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25174",
    "droptype": "D",
    "dropname": "SEBASCO ESTATES",
    "dropdeladd": "415 SEBASCO RD",
    "dropdelcty": "SEBASCO ESTATES",
    "dropdelst": "ME",
    "dropdelzpp": "045659998",
    "dropphyadd": "415 SEBASCO RD",
    "dropphycty": "SEBASCO ESTATES",
    "dropphyst": "ME",
    "dropphyzpp": "045659998",
    "dropmaladd": "415 SEBASCO RD",
    "dropmalcty": "SEBASCO ESTATES",
    "dropmalst": "ME",
    "dropmalzpp": "045659998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073891551,
    "dropsitcph": 2073891551,
    "dropfax": 2073891269
  },
  {
    "dcode": "D",
    "dropkey": "PV25178",
    "droptype": "D",
    "dropname": "SEDGWICK",
    "dropdeladd": "47 REACH RD",
    "dropdelcty": "SEDGWICK",
    "dropdelst": "ME",
    "dropdelzpp": "046769998",
    "dropphyadd": "47 REACH RD",
    "dropphycty": "SEDGWICK",
    "dropphyst": "ME",
    "dropphyzpp": "046769998",
    "dropmaladd": "47 REACH RD",
    "dropmalcty": "SEDGWICK",
    "dropmalst": "ME",
    "dropmalzpp": "046769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073592009,
    "dropsitcph": 2073592009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25179",
    "droptype": "D",
    "dropname": "SHAPLEIGH",
    "dropdeladd": "994 SHAPLEIGH CORNER RD",
    "dropdelcty": "SHAPLEIGH",
    "dropdelst": "ME",
    "dropdelzpp": "040769998",
    "dropphyadd": "994 SHAPLEIGH CORNER RD",
    "dropphycty": "SHAPLEIGH",
    "dropphyst": "ME",
    "dropphyzpp": "040769998",
    "dropmaladd": "994 SHAPLEIGH CORNER RD",
    "dropmalcty": "SHAPLEIGH",
    "dropmalst": "ME",
    "dropmalzpp": "040769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076361400,
    "dropsitcph": 2076361400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25180",
    "droptype": "D",
    "dropname": "SHAWMUT",
    "dropdeladd": "117 BRAY AVE",
    "dropdelcty": "SHAWMUT",
    "dropdelst": "ME",
    "dropdelzpp": "049759998",
    "dropphyadd": "117 BRAY AVE",
    "dropphycty": "SHAWMUT",
    "dropphyst": "ME",
    "dropphyzpp": "049759998",
    "dropmaladd": "117 BRAY AVE",
    "dropmalcty": "SHAWMUT",
    "dropmalst": "ME",
    "dropmalzpp": "049759998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074537860,
    "dropsitcph": 2074537860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25182",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "11 WOODBRIDGE CORNER RD",
    "dropdelcty": "SHERMAN",
    "dropdelst": "ME",
    "dropdelzpp": "047769998",
    "dropphyadd": "11 WOODBRIDGE CORNER RD",
    "dropphycty": "SHERMAN",
    "dropphyst": "ME",
    "dropphyzpp": "047769998",
    "dropmaladd": "11 WOODBRIDGE CORNER RD",
    "dropmalcty": "SHERMAN",
    "dropmalst": "ME",
    "dropmalzpp": "047769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073654105,
    "dropsitcph": 2073654105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25183",
    "droptype": "D",
    "dropname": "STACYVILLE",
    "dropdeladd": "418 STATION RD",
    "dropdelcty": "STACYVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "047779998",
    "dropphyadd": "418 STATION RD",
    "dropphycty": "STACYVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "047779998",
    "dropmaladd": "418 STATION RD",
    "dropmalcty": "STACYVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "047779998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073654298,
    "dropsitcph": 2073654298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25186",
    "droptype": "D",
    "dropname": "SINCLAIR",
    "dropdeladd": "251 SINCLAIR RD",
    "dropdelcty": "SINCLAIR",
    "dropdelst": "ME",
    "dropdelzpp": "047799998",
    "dropphyadd": "251 SINCLAIR RD",
    "dropphycty": "SINCLAIR",
    "dropphyst": "ME",
    "dropphyzpp": "047799998",
    "dropmaladd": "251 SINCLAIR RD",
    "dropmalcty": "SINCLAIR",
    "dropmalst": "ME",
    "dropmalzpp": "047799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075437729,
    "dropsitcph": 2075437729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25187",
    "droptype": "D",
    "dropname": "SKOWHEGAN",
    "dropdeladd": "242 WATER ST",
    "dropdelcty": "SKOWHEGAN",
    "dropdelst": "ME",
    "dropdelzpp": "049769998",
    "dropphyadd": "242 WATER ST",
    "dropphycty": "SKOWHEGAN",
    "dropphyst": "ME",
    "dropphyzpp": "049769998",
    "dropmaladd": "242 WATER ST",
    "dropmalcty": "SKOWHEGAN",
    "dropmalst": "ME",
    "dropmalzpp": "049769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074743531,
    "dropsitcph": 2074743531,
    "dropfax": 2074743206
  },
  {
    "dcode": "D",
    "dropkey": "PV25189",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "860 VILLAGE RD",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "049789998",
    "dropphyadd": "860 VILLAGE RD",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "049789998",
    "dropmaladd": "860 VILLAGE RD",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "049789998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073625901,
    "dropsitcph": 2073625901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25190",
    "droptype": "D",
    "dropname": "SMYRNA MILLS",
    "dropdeladd": "3391 US ROUTE 2",
    "dropdelcty": "SMYRNA MILLS",
    "dropdelst": "ME",
    "dropdelzpp": "047809998",
    "dropphyadd": "3391 US ROUTE 2",
    "dropphycty": "SMYRNA MILLS",
    "dropphyst": "ME",
    "dropphyzpp": "047809998",
    "dropmaladd": "3391 US ROUTE 2",
    "dropmalcty": "SMYRNA MILLS",
    "dropmalst": "ME",
    "dropmalzpp": "047809998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077578241,
    "dropsitcph": 2077578241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25192",
    "droptype": "D",
    "dropname": "WALLAGRASS",
    "dropdeladd": "174 SOLDIER POND RD",
    "dropdelcty": "WALLAGRASS",
    "dropdelst": "ME",
    "dropdelzpp": "047819998",
    "dropphyadd": "174 SOLDIER POND RD",
    "dropphycty": "WALLAGRASS",
    "dropphyst": "ME",
    "dropphyzpp": "047819998",
    "dropmaladd": "174 SOLDIER POND RD",
    "dropmalcty": "WALLAGRASS",
    "dropmalst": "ME",
    "dropmalzpp": "047819998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778541390,
    "dropsitcph": 8778541390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25193",
    "droptype": "D",
    "dropname": "SOLON",
    "dropdeladd": "8 FERRY ST",
    "dropdelcty": "SOLON",
    "dropdelst": "ME",
    "dropdelzpp": "049799998",
    "dropphyadd": "8 FERRY ST",
    "dropphycty": "SOLON",
    "dropphyst": "ME",
    "dropphyzpp": "049799998",
    "dropmaladd": "8 FERRY ST",
    "dropmalcty": "SOLON",
    "dropmalst": "ME",
    "dropmalzpp": "049799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076432223,
    "dropsitcph": 2076432223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25194",
    "droptype": "D",
    "dropname": "SORRENTO",
    "dropdeladd": "16 MAIN ST",
    "dropdelcty": "SORRENTO",
    "dropdelst": "ME",
    "dropdelzpp": "046779998",
    "dropphyadd": "16 MAIN ST",
    "dropphycty": "SORRENTO",
    "dropphyst": "ME",
    "dropphyzpp": "046779998",
    "dropmaladd": "16 MAIN ST",
    "dropmalcty": "SORRENTO",
    "dropmalst": "ME",
    "dropmalzpp": "046779998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074226896,
    "dropsitcph": 2074226896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25195",
    "droptype": "D",
    "dropname": "SOUTH BERWICK",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "SOUTH BERWICK",
    "dropdelst": "ME",
    "dropdelzpp": "039089998",
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "SOUTH BERWICK",
    "dropphyst": "ME",
    "dropphyzpp": "039089998",
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "SOUTH BERWICK",
    "dropmalst": "ME",
    "dropmalzpp": "039089998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073842780,
    "dropsitcph": 2073842780,
    "dropfax": 2073842036
  },
  {
    "dcode": "D",
    "dropkey": "PV25196",
    "droptype": "D",
    "dropname": "SOUTH BRISTOL",
    "dropdeladd": "2171 STATE ROUTE 129",
    "dropdelcty": "SOUTH BRISTOL",
    "dropdelst": "ME",
    "dropdelzpp": "045689998",
    "dropphyadd": "2171 STATE ROUTE 129",
    "dropphycty": "SOUTH BRISTOL",
    "dropphyst": "ME",
    "dropphyzpp": "045689998",
    "dropmaladd": "2171 STATE ROUTE 129",
    "dropmalcty": "SOUTH BRISTOL",
    "dropmalst": "ME",
    "dropmalzpp": "045689998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076561936,
    "dropsitcph": 2076561936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25197",
    "droptype": "D",
    "dropname": "SOUTH CASCO",
    "dropdeladd": "326 ROOSEVELT TRL",
    "dropdelcty": "SOUTH CASCO",
    "dropdelst": "ME",
    "dropdelzpp": "040779998",
    "dropphyadd": "326 ROOSEVELT TRL",
    "dropphycty": "SOUTH CASCO",
    "dropphyst": "ME",
    "dropphyzpp": "040779998",
    "dropmaladd": "326 ROOSEVELT TRL",
    "dropmalcty": "SOUTH CASCO",
    "dropmalst": "ME",
    "dropmalzpp": "040779998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779071987,
    "dropsitcph": 8779071987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25198",
    "droptype": "D",
    "dropname": "SOUTH CHINA",
    "dropdeladd": "382 ROUTE 3",
    "dropdelcty": "SOUTH CHINA",
    "dropdelst": "ME",
    "dropdelzpp": "043589998",
    "dropphyadd": "382 ROUTE 3",
    "dropphycty": "SOUTH CHINA",
    "dropphyst": "ME",
    "dropphyzpp": "043589998",
    "dropmaladd": "382 ROUTE 3",
    "dropmalcty": "SOUTH CHINA",
    "dropmalst": "ME",
    "dropmalzpp": "043589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074452230,
    "dropsitcph": 2074452230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25199",
    "droptype": "D",
    "dropname": "SOUTH FREEPORT",
    "dropdeladd": "95 S FREEPORT RD",
    "dropdelcty": "SOUTH FREEPORT",
    "dropdelst": "ME",
    "dropdelzpp": "040789998",
    "dropphyadd": "95 S FREEPORT RD",
    "dropphycty": "SOUTH FREEPORT",
    "dropphyst": "ME",
    "dropphyzpp": "040789998",
    "dropmaladd": "95 S FREEPORT RD",
    "dropmalcty": "SOUTH FREEPORT",
    "dropmalst": "ME",
    "dropmalzpp": "040789998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078656578,
    "dropsitcph": 2078656578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25200",
    "droptype": "D",
    "dropname": "SOUTH GARDINER",
    "dropdeladd": "681 RIVER RD",
    "dropdelcty": "SOUTH GARDINER",
    "dropdelst": "ME",
    "dropdelzpp": "043599998",
    "dropphyadd": "681 RIVER RD",
    "dropphycty": "SOUTH GARDINER",
    "dropphyst": "ME",
    "dropphyzpp": "043599998",
    "dropmaladd": "681 RIVER RD",
    "dropmalcty": "SOUTH GARDINER",
    "dropmalst": "ME",
    "dropmalzpp": "043599998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075822200,
    "dropsitcph": 2075822200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25202",
    "droptype": "D",
    "dropname": "HARPSWELL",
    "dropdeladd": "1212 HARPSWELL NECK RD",
    "dropdelcty": "HARPSWELL",
    "dropdelst": "ME",
    "dropdelzpp": "040799998",
    "dropphyadd": "1212 HARPSWELL NECK RD",
    "dropphycty": "HARPSWELL",
    "dropphyst": "ME",
    "dropphyzpp": "040799998",
    "dropmaladd": "1212 HARPSWELL NECK RD",
    "dropmalcty": "HARPSWELL",
    "dropmalst": "ME",
    "dropmalzpp": "040799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078335526,
    "dropsitcph": 2078335526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25205",
    "droptype": "D",
    "dropname": "SOUTH PARIS",
    "dropdeladd": "13 PARK ST",
    "dropdelcty": "SOUTH PARIS",
    "dropdelst": "ME",
    "dropdelzpp": "042819998",
    "dropphyadd": "13 PARK ST",
    "dropphycty": "SOUTH PARIS",
    "dropphyst": "ME",
    "dropphyzpp": "042819998",
    "dropmaladd": "13 PARK ST",
    "dropmalcty": "SOUTH PARIS",
    "dropmalst": "ME",
    "dropmalzpp": "042819998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077436652,
    "dropsitcph": 2077436652,
    "dropfax": 2077431882
  },
  {
    "dcode": "D",
    "dropkey": "PV25208",
    "droptype": "D",
    "dropname": "SOUTH THOMASTON",
    "dropdeladd": "8 ELM ST",
    "dropdelcty": "SOUTH THOMASTON",
    "dropdelst": "ME",
    "dropdelzpp": "048589998",
    "dropphyadd": "8 ELM ST",
    "dropphycty": "SOUTH THOMASTON",
    "dropphyst": "ME",
    "dropphyzpp": "048589998",
    "dropmaladd": "8 ELM ST",
    "dropmalcty": "SOUTH THOMASTON",
    "dropmalst": "ME",
    "dropmalzpp": "048589998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075947400,
    "dropsitcph": 2075947400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25212",
    "droptype": "D",
    "dropname": "SOUTHWEST HARBOR",
    "dropdeladd": "21 CLARK POINT RD",
    "dropdelcty": "SOUTHWEST HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046799998",
    "dropphyadd": "21 CLARK POINT RD",
    "dropphycty": "SOUTHWEST HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046799998",
    "dropmaladd": "21 CLARK POINT RD",
    "dropmalcty": "SOUTHWEST HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072443456,
    "dropsitcph": 2072443456,
    "dropfax": 2072449670
  },
  {
    "dcode": "D",
    "dropkey": "PV25213",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "1007 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "044879998",
    "dropphyadd": "1007 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "044879998",
    "dropmaladd": "1007 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "044879998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077384487,
    "dropsitcph": 2077384487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25214",
    "droptype": "D",
    "dropname": "SPRINGVALE",
    "dropdeladd": "492 MAIN ST",
    "dropdelcty": "SPRINGVALE",
    "dropdelst": "ME",
    "dropdelzpp": "040839998",
    "dropphyadd": "492 MAIN ST",
    "dropphycty": "SPRINGVALE",
    "dropphyst": "ME",
    "dropphyzpp": "040839998",
    "dropmaladd": "492 MAIN ST",
    "dropmalcty": "SPRINGVALE",
    "dropmalst": "ME",
    "dropmalzpp": "040839998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073246360,
    "dropsitcph": 2073246360,
    "dropfax": 2073247665
  },
  {
    "dcode": "D",
    "dropkey": "PV25215",
    "droptype": "D",
    "dropname": "SPRUCE HEAD",
    "dropdeladd": "11 POST OFFICE RD",
    "dropdelcty": "SPRUCE HEAD",
    "dropdelst": "ME",
    "dropdelzpp": "048599998",
    "dropphyadd": "11 POST OFFICE RD",
    "dropphycty": "SPRUCE HEAD",
    "dropphyst": "ME",
    "dropphyzpp": "048599998",
    "dropmaladd": "11 POST OFFICE RD",
    "dropmalcty": "SPRUCE HEAD",
    "dropmalst": "ME",
    "dropmalzpp": "048599998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074666485,
    "dropsitcph": 2074666485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25223",
    "droptype": "D",
    "dropname": "STANDISH",
    "dropdeladd": "111 OSSIPEE TRL E STE 9998",
    "dropdelcty": "STANDISH",
    "dropdelst": "ME",
    "dropdelzpp": "040849998",
    "dropphyadd": "111 OSSIPEE TRL E STE 9998",
    "dropphycty": "STANDISH",
    "dropphyst": "ME",
    "dropphyzpp": "040849998",
    "dropmaladd": "111 OSSIPEE TRL E STE 9998",
    "dropmalcty": "STANDISH",
    "dropmalst": "ME",
    "dropmalzpp": "040849998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076424588,
    "dropsitcph": 2076424588,
    "dropfax": 2076425376
  },
  {
    "dcode": "D",
    "dropkey": "PV25226",
    "droptype": "D",
    "dropname": "STEEP FALLS",
    "dropdeladd": "1090 PEQUAWKET TRL",
    "dropdelcty": "STEEP FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "040859998",
    "dropphyadd": "1090 PEQUAWKET TRL",
    "dropphycty": "STEEP FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "040859998",
    "dropmaladd": "1090 PEQUAWKET TRL",
    "dropmalcty": "STEEP FALLS",
    "dropmalst": "ME",
    "dropmalzpp": "040859998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076753232,
    "dropsitcph": 2076753232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25227",
    "droptype": "D",
    "dropname": "STETSON",
    "dropdeladd": "6 STETSON RD",
    "dropdelcty": "STETSON",
    "dropdelst": "ME",
    "dropdelzpp": "044889998",
    "dropphyadd": "6 STETSON RD",
    "dropphycty": "STETSON",
    "dropphyst": "ME",
    "dropphyzpp": "044889998",
    "dropmaladd": "6 STETSON RD",
    "dropmalcty": "STETSON",
    "dropmalst": "ME",
    "dropmalzpp": "044889998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072963600,
    "dropsitcph": 2072963600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25228",
    "droptype": "D",
    "dropname": "STEUBEN",
    "dropdeladd": "18 MORGAN PARRITT RD",
    "dropdelcty": "STEUBEN",
    "dropdelst": "ME",
    "dropdelzpp": "046809998",
    "dropphyadd": "18 MORGAN PARRITT RD",
    "dropphycty": "STEUBEN",
    "dropphyst": "ME",
    "dropphyzpp": "046809998",
    "dropmaladd": "18 MORGAN PARRITT RD",
    "dropmalcty": "STEUBEN",
    "dropmalst": "ME",
    "dropmalzpp": "046809998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076107104,
    "dropsitcph": 2076107104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25229",
    "droptype": "D",
    "dropname": "STILLWATER",
    "dropdeladd": "441 BENNOCH RD",
    "dropdelcty": "STILLWATER",
    "dropdelst": "ME",
    "dropdelzpp": "044899998",
    "dropphyadd": "441 BENNOCH RD",
    "dropphycty": "STILLWATER",
    "dropphyst": "ME",
    "dropphyzpp": "044899998",
    "dropmaladd": "441 BENNOCH RD",
    "dropmalcty": "STILLWATER",
    "dropmalst": "ME",
    "dropmalzpp": "044899998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078276454,
    "dropsitcph": 2078276454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25230",
    "droptype": "D",
    "dropname": "STOCKHOLM",
    "dropdeladd": "279 MAIN ST",
    "dropdelcty": "STOCKHOLM",
    "dropdelst": "ME",
    "dropdelzpp": "047839998",
    "dropphyadd": "279 MAIN ST",
    "dropphycty": "STOCKHOLM",
    "dropphyst": "ME",
    "dropphyzpp": "047839998",
    "dropmaladd": "279 MAIN ST",
    "dropmalcty": "STOCKHOLM",
    "dropmalst": "ME",
    "dropmalzpp": "047839998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078965664,
    "dropsitcph": 2078965664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25231",
    "droptype": "D",
    "dropname": "STOCKTON SPRINGS",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "STOCKTON SPRINGS",
    "dropdelst": "ME",
    "dropdelzpp": "049819998",
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "STOCKTON SPRINGS",
    "dropphyst": "ME",
    "dropphyzpp": "049819998",
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "STOCKTON SPRINGS",
    "dropmalst": "ME",
    "dropmalzpp": "049819998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778544354,
    "dropsitcph": 8778544354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25233",
    "droptype": "D",
    "dropname": "STONINGTON",
    "dropdeladd": "28 W MAIN ST",
    "dropdelcty": "STONINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "046819998",
    "dropphyadd": "28 W MAIN ST",
    "dropphycty": "STONINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "046819998",
    "dropmaladd": "28 W MAIN ST",
    "dropmalcty": "STONINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "046819998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073672235,
    "dropsitcph": 2073672235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25235",
    "droptype": "D",
    "dropname": "STRATTON",
    "dropdeladd": "95 MAIN ST",
    "dropdelcty": "STRATTON",
    "dropdelst": "ME",
    "dropdelzpp": "049829998",
    "dropphyadd": "95 MAIN ST",
    "dropphycty": "STRATTON",
    "dropphyst": "ME",
    "dropphyzpp": "049829998",
    "dropmaladd": "95 MAIN ST",
    "dropmalcty": "STRATTON",
    "dropmalst": "ME",
    "dropmalzpp": "049829998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072466461,
    "dropsitcph": 2072466461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25236",
    "droptype": "D",
    "dropname": "STRONG",
    "dropdeladd": "136 N MAIN ST",
    "dropdelcty": "STRONG",
    "dropdelst": "ME",
    "dropdelzpp": "049839998",
    "dropphyadd": "136 N MAIN ST",
    "dropphycty": "STRONG",
    "dropphyst": "ME",
    "dropphyzpp": "049839998",
    "dropmaladd": "136 N MAIN ST",
    "dropmalcty": "STRONG",
    "dropmalst": "ME",
    "dropmalzpp": "049839998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076843436,
    "dropsitcph": 2076843436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25240",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "300 SUNSET RD",
    "dropdelcty": "SUNSET",
    "dropdelst": "ME",
    "dropdelzpp": "046839998",
    "dropphyadd": "300 SUNSET RD",
    "dropphycty": "SUNSET",
    "dropphyst": "ME",
    "dropphyzpp": "046839998",
    "dropmaladd": "300 SUNSET RD",
    "dropmalcty": "SUNSET",
    "dropmalst": "ME",
    "dropmalzpp": "046839998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073486989,
    "dropsitcph": 2073486989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25241",
    "droptype": "D",
    "dropname": "SURRY",
    "dropdeladd": "1197 SURRY RD",
    "dropdelcty": "SURRY",
    "dropdelst": "ME",
    "dropdelzpp": "046849998",
    "dropphyadd": "1197 SURRY RD",
    "dropphycty": "SURRY",
    "dropphyst": "ME",
    "dropphyzpp": "046849998",
    "dropmaladd": "1197 SURRY RD",
    "dropmalcty": "SURRY",
    "dropmalst": "ME",
    "dropmalzpp": "046849998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076674086,
    "dropsitcph": 2076674086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25242",
    "droptype": "D",
    "dropname": "SWANS ISLAND",
    "dropdeladd": "125 HARBOR RD",
    "dropdelcty": "SWANS ISLAND",
    "dropdelst": "ME",
    "dropdelzpp": "046859998",
    "dropphyadd": "125 HARBOR RD",
    "dropphycty": "SWANS ISLAND",
    "dropphyst": "ME",
    "dropphyzpp": "046859998",
    "dropmaladd": "125 HARBOR RD",
    "dropmalcty": "SWANS ISLAND",
    "dropmalst": "ME",
    "dropmalzpp": "046859998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773641638,
    "dropsitcph": 8773641638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25244",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "258 TEMPLE RD",
    "dropdelcty": "TEMPLE",
    "dropdelst": "ME",
    "dropdelzpp": "049849997",
    "dropphyadd": "258 TEMPLE RD",
    "dropphycty": "TEMPLE",
    "dropphyst": "ME",
    "dropphyzpp": "049849997",
    "dropmaladd": "258 TEMPLE RD",
    "dropmalcty": "TEMPLE",
    "dropmalst": "ME",
    "dropmalzpp": "049849997",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077786755,
    "dropsitcph": 2077786755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25245",
    "droptype": "D",
    "dropname": "TENANTS HARBOR",
    "dropdeladd": "4 MAIN ST",
    "dropdelcty": "TENANTS HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "048609998",
    "dropphyadd": "4 MAIN ST",
    "dropphycty": "TENANTS HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "048609998",
    "dropmaladd": "4 MAIN ST",
    "dropmalcty": "TENANTS HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "048609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073726301,
    "dropsitcph": 2073726301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25246",
    "droptype": "D",
    "dropname": "THOMASTON",
    "dropdeladd": "135 MAIN ST",
    "dropdelcty": "THOMASTON",
    "dropdelst": "ME",
    "dropdelzpp": "048619998",
    "dropphyadd": "135 MAIN ST",
    "dropphycty": "THOMASTON",
    "dropphyst": "ME",
    "dropphyzpp": "048619998",
    "dropmaladd": "135 MAIN ST",
    "dropmalcty": "THOMASTON",
    "dropmalst": "ME",
    "dropmalzpp": "048619998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073542420,
    "dropsitcph": 2073542420,
    "dropfax": 2073540362
  },
  {
    "dcode": "D",
    "dropkey": "PV25247",
    "droptype": "D",
    "dropname": "THORNDIKE",
    "dropdeladd": "58 MOUNT VIEW RD",
    "dropdelcty": "THORNDIKE",
    "dropdelst": "ME",
    "dropdelzpp": "049869998",
    "dropphyadd": "58 MOUNT VIEW RD",
    "dropphycty": "THORNDIKE",
    "dropphyst": "ME",
    "dropphyzpp": "049869998",
    "dropmaladd": "58 MOUNT VIEW RD",
    "dropmalcty": "THORNDIKE",
    "dropmalst": "ME",
    "dropmalzpp": "049869998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773641706,
    "dropsitcph": 8773641706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25250",
    "droptype": "D",
    "dropname": "TOPSFIELD",
    "dropdeladd": "61 SOUTH RD",
    "dropdelcty": "TOPSFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "044909998",
    "dropphyadd": "61 SOUTH RD",
    "dropphycty": "TOPSFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "044909998",
    "dropmaladd": "61 SOUTH RD",
    "dropmalcty": "TOPSFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "044909998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8389002587,
    "dropsitcph": 8389002587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25251",
    "droptype": "D",
    "dropname": "TOPSHAM",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "TOPSHAM",
    "dropdelst": "ME",
    "dropdelzpp": "040869998",
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "TOPSHAM",
    "dropphyst": "ME",
    "dropphyzpp": "040869998",
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "TOPSHAM",
    "dropmalst": "ME",
    "dropmalzpp": "040869998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077258243,
    "dropsitcph": 2077258243,
    "dropfax": 2077252841
  },
  {
    "dcode": "D",
    "dropkey": "PV25252",
    "droptype": "D",
    "dropname": "TREVETT",
    "dropdeladd": "381A BARTERS ISLAND RD",
    "dropdelcty": "TREVETT",
    "dropdelst": "ME",
    "dropdelzpp": "045719998",
    "dropphyadd": "381A BARTERS ISLAND RD",
    "dropphycty": "TREVETT",
    "dropphyst": "ME",
    "dropphyzpp": "045719998",
    "dropmaladd": "381A BARTERS ISLAND RD",
    "dropmalcty": "TREVETT",
    "dropmalst": "ME",
    "dropmalzpp": "045719998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076333403,
    "dropsitcph": 2076333403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25253",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "846 BANGOR RD",
    "dropdelcty": "TROY",
    "dropdelst": "ME",
    "dropdelzpp": "049879998",
    "dropphyadd": "846 BANGOR RD",
    "dropphycty": "TROY",
    "dropphyst": "ME",
    "dropphyzpp": "049879998",
    "dropmaladd": "846 BANGOR RD",
    "dropmalcty": "TROY",
    "dropmalst": "ME",
    "dropmalzpp": "049879998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778541578,
    "dropsitcph": 8778541578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25254",
    "droptype": "D",
    "dropname": "TURNER",
    "dropdeladd": "16 BUCKFIELD RD",
    "dropdelcty": "TURNER",
    "dropdelst": "ME",
    "dropdelzpp": "042829998",
    "dropphyadd": "16 BUCKFIELD RD",
    "dropphycty": "TURNER",
    "dropphyst": "ME",
    "dropphyzpp": "042829998",
    "dropmaladd": "16 BUCKFIELD RD",
    "dropmalcty": "TURNER",
    "dropmalst": "ME",
    "dropmalzpp": "042829998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072253339,
    "dropsitcph": 2072253339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25256",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "309 COMMON RD",
    "dropdelcty": "UNION",
    "dropdelst": "ME",
    "dropdelzpp": "048629998",
    "dropphyadd": "309 COMMON RD",
    "dropphycty": "UNION",
    "dropphyst": "ME",
    "dropphyzpp": "048629998",
    "dropmaladd": "309 COMMON RD",
    "dropmalcty": "UNION",
    "dropmalst": "ME",
    "dropmalzpp": "048629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077853734,
    "dropsitcph": 2077853734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25258",
    "droptype": "D",
    "dropname": "UNITY",
    "dropdeladd": "4 CLIFFORD COMMONS 1",
    "dropdelcty": "UNITY",
    "dropdelst": "ME",
    "dropdelzpp": "049889998",
    "dropphyadd": "4 CLIFFORD COMMONS 1",
    "dropphycty": "UNITY",
    "dropphyst": "ME",
    "dropphyzpp": "049889998",
    "dropmaladd": "4 CLIFFORD COMMONS 1",
    "dropmalcty": "UNITY",
    "dropmalst": "ME",
    "dropmalzpp": "049889998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773641531,
    "dropsitcph": 8773641531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25261",
    "droptype": "D",
    "dropname": "FRENCHVILLE",
    "dropdeladd": "386 US ROUTE 1",
    "dropdelcty": "FRENCHVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "047459998",
    "dropphyadd": "386 US ROUTE 1",
    "dropphycty": "FRENCHVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "047459998",
    "dropmaladd": "386 US ROUTE 1",
    "dropmalcty": "FRENCHVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "047459998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075437444,
    "dropsitcph": 2075437444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25262",
    "droptype": "D",
    "dropname": "VAN BUREN",
    "dropdeladd": "42 MAIN ST",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "ME",
    "dropdelzpp": "047859998",
    "dropphyadd": "42 MAIN ST",
    "dropphycty": "VAN BUREN",
    "dropphyst": "ME",
    "dropphyzpp": "047859998",
    "dropmaladd": "42 MAIN ST",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "ME",
    "dropmalzpp": "047859998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078682874,
    "dropsitcph": 2078682874,
    "dropfax": 2078685828
  },
  {
    "dcode": "D",
    "dropkey": "PV25263",
    "droptype": "D",
    "dropname": "VANCEBORO",
    "dropdeladd": "23 WATER ST",
    "dropdelcty": "VANCEBORO",
    "dropdelst": "ME",
    "dropdelzpp": "044919998",
    "dropphyadd": "23 WATER ST",
    "dropphycty": "VANCEBORO",
    "dropphyst": "ME",
    "dropphyzpp": "044919998",
    "dropmaladd": "23 WATER ST",
    "dropmalcty": "VANCEBORO",
    "dropmalst": "ME",
    "dropmalzpp": "044919998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077883801,
    "dropsitcph": 2077883801,
    "dropfax": 2077883935
  },
  {
    "dcode": "D",
    "dropkey": "PV25264",
    "droptype": "D",
    "dropname": "VASSALBORO",
    "dropdeladd": "25 ALPINE ST",
    "dropdelcty": "VASSALBORO",
    "dropdelst": "ME",
    "dropdelzpp": "049899998",
    "dropphyadd": "25 ALPINE ST",
    "dropphycty": "VASSALBORO",
    "dropphyst": "ME",
    "dropphyzpp": "049899998",
    "dropmaladd": "25 ALPINE ST",
    "dropmalcty": "VASSALBORO",
    "dropmalst": "ME",
    "dropmalzpp": "049899998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078726863,
    "dropsitcph": 2078724512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25266",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "8 KIMBALL POND RD",
    "dropdelcty": "VIENNA",
    "dropdelst": "ME",
    "dropdelzpp": "043609998",
    "dropphyadd": "8 KIMBALL POND RD",
    "dropphycty": "VIENNA",
    "dropphyst": "ME",
    "dropphyzpp": "043609998",
    "dropmaladd": "8 KIMBALL POND RD",
    "dropmalcty": "VIENNA",
    "dropmalst": "ME",
    "dropmalzpp": "043609998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8079076223,
    "dropsitcph": 8779076223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25267",
    "droptype": "D",
    "dropname": "VINALHAVEN",
    "dropdeladd": "42 MAIN ST",
    "dropdelcty": "VINALHAVEN",
    "dropdelst": "ME",
    "dropdelzpp": "048639998",
    "dropphyadd": "42 MAIN ST",
    "dropphycty": "VINALHAVEN",
    "dropphyst": "ME",
    "dropphyzpp": "048639998",
    "dropmaladd": "42 MAIN ST",
    "dropmalcty": "VINALHAVEN",
    "dropmalst": "ME",
    "dropmalzpp": "048639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078634620,
    "dropsitcph": 2078634620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25269",
    "droptype": "D",
    "dropname": "WALDOBORO",
    "dropdeladd": "959 MAIN ST",
    "dropdelcty": "WALDOBORO",
    "dropdelst": "ME",
    "dropdelzpp": "045729998",
    "dropphyadd": "959 MAIN ST",
    "dropphycty": "WALDOBORO",
    "dropphyst": "ME",
    "dropphyzpp": "045729998",
    "dropmaladd": "959 MAIN ST",
    "dropmalcty": "WALDOBORO",
    "dropmalst": "ME",
    "dropmalzpp": "045729998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078325575,
    "dropsitcph": 2078325575,
    "dropfax": 2078326177
  },
  {
    "dcode": "D",
    "dropkey": "PV25270",
    "droptype": "D",
    "dropname": "WALPOLE",
    "dropdeladd": "595 STATE ROUTE 129",
    "dropdelcty": "WALPOLE",
    "dropdelst": "ME",
    "dropdelzpp": "045739998",
    "dropphyadd": "595 STATE ROUTE 129",
    "dropphycty": "WALPOLE",
    "dropphyst": "ME",
    "dropphyzpp": "045739998",
    "dropmaladd": "595 STATE ROUTE 129",
    "dropmalcty": "WALPOLE",
    "dropmalst": "ME",
    "dropmalzpp": "045739998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074192697,
    "dropsitcph": 2074192697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25271",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "21 MAIN ST",
    "dropdelcty": "WARREN",
    "dropdelst": "ME",
    "dropdelzpp": "048649998",
    "dropphyadd": "21 MAIN ST",
    "dropphycty": "WARREN",
    "dropphyst": "ME",
    "dropphyzpp": "048649998",
    "dropmaladd": "21 MAIN ST",
    "dropmalcty": "WARREN",
    "dropmalst": "ME",
    "dropmalzpp": "048649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072732411,
    "dropsitcph": 2072732411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25272",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "9 WOODMAN ST",
    "dropdelcty": "WASHBURN",
    "dropdelst": "ME",
    "dropdelzpp": "047869998",
    "dropphyadd": "9 WOODMAN ST",
    "dropphycty": "WASHBURN",
    "dropphyst": "ME",
    "dropphyzpp": "047869998",
    "dropmaladd": "9 WOODMAN ST",
    "dropmalcty": "WASHBURN",
    "dropmalst": "ME",
    "dropmalzpp": "047869998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074554987,
    "dropsitcph": 2074554987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25273",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "11 LIBERTY RD",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "045749998",
    "dropphyadd": "11 LIBERTY RD",
    "dropphycty": "WASHINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "045749998",
    "dropmaladd": "11 LIBERTY RD",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "045749998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8773547476,
    "dropsitcph": 8773547476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25275",
    "droptype": "D",
    "dropname": "WATERBORO",
    "dropdeladd": "997 MAIN ST",
    "dropdelcty": "WATERBORO",
    "dropdelst": "ME",
    "dropdelzpp": "040879998",
    "dropphyadd": "997 MAIN ST",
    "dropphycty": "WATERBORO",
    "dropphyst": "ME",
    "dropphyzpp": "040879998",
    "dropmaladd": "997 MAIN ST",
    "dropmalcty": "WATERBORO",
    "dropmalst": "ME",
    "dropmalzpp": "040879998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072457762,
    "dropsitcph": 2072457762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25276",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "965 WATERFORD RD",
    "dropdelcty": "WATERFORD",
    "dropdelst": "ME",
    "dropdelzpp": "040889998",
    "dropphyadd": "965 WATERFORD RD",
    "dropphycty": "WATERFORD",
    "dropphyst": "ME",
    "dropphyzpp": "040889998",
    "dropmaladd": "965 WATERFORD RD",
    "dropmalcty": "WATERFORD",
    "dropmalst": "ME",
    "dropmalzpp": "040889998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075832240,
    "dropsitcph": 2075832240,
    "dropfax": 2075832240
  },
  {
    "dcode": "D",
    "dropkey": "PV25277",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "33 COLLEGE AVE",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "049019998",
    "dropphyadd": "33 COLLEGE AVE",
    "dropphycty": "WATERVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "049019998",
    "dropmaladd": "33 COLLEGE AVE",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "049019998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078730714,
    "dropsitcph": 2078730714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25278",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "516 MAIN ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "ME",
    "dropdelzpp": "042849998",
    "dropphyadd": "516 MAIN ST",
    "dropphycty": "WAYNE",
    "dropphyst": "ME",
    "dropphyzpp": "042849998",
    "dropmaladd": "516 MAIN ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "ME",
    "dropmalzpp": "042849998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076859229,
    "dropsitcph": 2076859229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25280",
    "droptype": "D",
    "dropname": "WELD",
    "dropdeladd": "21 MILL ST",
    "dropdelcty": "WELD",
    "dropdelst": "ME",
    "dropdelzpp": "042859998",
    "dropphyadd": "21 MILL ST",
    "dropphycty": "WELD",
    "dropphyst": "ME",
    "dropphyzpp": "042859998",
    "dropmaladd": "21 MILL ST",
    "dropmalcty": "WELD",
    "dropmalst": "ME",
    "dropmalzpp": "042859998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075852469,
    "dropsitcph": 2075852469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25282",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "1886 POST RD",
    "dropdelcty": "WELLS",
    "dropdelst": "ME",
    "dropdelzpp": "040909998",
    "dropphyadd": "1886 POST RD",
    "dropphycty": "WELLS",
    "dropphyst": "ME",
    "dropphyzpp": "040909998",
    "dropmaladd": "1886 POST RD",
    "dropmalcty": "WELLS",
    "dropmalst": "ME",
    "dropmalzpp": "040909998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076462984,
    "dropsitcph": 2076462984,
    "dropfax": 2076462735
  },
  {
    "dcode": "D",
    "dropkey": "PV25285",
    "droptype": "D",
    "dropname": "WEST BALDWIN",
    "dropdeladd": "932 PEQUAWKET TRL",
    "dropdelcty": "WEST BALDWIN",
    "dropdelst": "ME",
    "dropdelzpp": "040919998",
    "dropphyadd": "932 PEQUAWKET TRL",
    "dropphycty": "WEST BALDWIN",
    "dropphyst": "ME",
    "dropphyzpp": "040919998",
    "dropmaladd": "932 PEQUAWKET TRL",
    "dropmalcty": "WEST BALDWIN",
    "dropmalst": "ME",
    "dropmalzpp": "040919998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076258041,
    "dropsitcph": 2076258041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25287",
    "droptype": "D",
    "dropname": "WEST BOOTHBAY HARBOR",
    "dropdeladd": "143 WESTERN AVE",
    "dropdelcty": "WEST BOOTHBAY HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "045759998",
    "dropphyadd": "143 WESTERN AVE",
    "dropphycty": "WEST BOOTHBAY HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "045759998",
    "dropmaladd": "143 WESTERN AVE",
    "dropmalcty": "WEST BOOTHBAY HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "045759998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076334330,
    "dropsitcph": 2076334330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25289",
    "droptype": "D",
    "dropname": "BUXTON",
    "dropdeladd": "379 LONG PLAINS RD",
    "dropdelcty": "BUXTON",
    "dropdelst": "ME",
    "dropdelzpp": "040939998",
    "dropphyadd": "379 LONG PLAINS RD",
    "dropphycty": "BUXTON",
    "dropphyst": "ME",
    "dropphyzpp": "040939998",
    "dropmaladd": "379 LONG PLAINS RD",
    "dropmalcty": "BUXTON",
    "dropmalst": "ME",
    "dropmalzpp": "040939998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077273116,
    "dropsitcph": 2077273116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25290",
    "droptype": "D",
    "dropname": "WEST ENFIELD",
    "dropdeladd": "41 BRIDGE ST",
    "dropdelcty": "WEST ENFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "044939998",
    "dropphyadd": "41 BRIDGE ST",
    "dropphycty": "WEST ENFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "044939998",
    "dropmaladd": "41 BRIDGE ST",
    "dropmalcty": "WEST ENFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "044939998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078202826,
    "dropsitcph": 2078202826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25291",
    "droptype": "D",
    "dropname": "WEST FARMINGTON",
    "dropdeladd": "126 BRIDGE ST",
    "dropdelcty": "WEST FARMINGTON",
    "dropdelst": "ME",
    "dropdelzpp": "049929998",
    "dropphyadd": "126 BRIDGE ST",
    "dropphycty": "WEST FARMINGTON",
    "dropphyst": "ME",
    "dropphyzpp": "049929998",
    "dropmaladd": "126 BRIDGE ST",
    "dropmalcty": "WEST FARMINGTON",
    "dropmalst": "ME",
    "dropmalzpp": "049929998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077783973,
    "dropsitcph": 2077783973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25292",
    "droptype": "D",
    "dropname": "WEST FORKS",
    "dropdeladd": "2933 US RTE 201",
    "dropdelcty": "WEST FORKS",
    "dropdelst": "ME",
    "dropdelzpp": "049859998",
    "dropphyadd": "2933 US RTE 201",
    "dropphycty": "WEST FORKS",
    "dropphyst": "ME",
    "dropphyzpp": "049859998",
    "dropmaladd": "2933 US RTE 201",
    "dropmalcty": "WEST FORKS",
    "dropmalst": "ME",
    "dropmalzpp": "049859998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076722085,
    "dropsitcph": 2076722085,
    "dropfax": 2076634416
  },
  {
    "dcode": "D",
    "dropkey": "PV25293",
    "droptype": "D",
    "dropname": "WEST KENNEBUNK",
    "dropdeladd": "116 ALFRED RD",
    "dropdelcty": "WEST KENNEBUNK",
    "dropdelst": "ME",
    "dropdelzpp": "040949998",
    "dropphyadd": "116 ALFRED RD",
    "dropphycty": "WEST KENNEBUNK",
    "dropphyst": "ME",
    "dropphyzpp": "040949998",
    "dropmaladd": "116 ALFRED RD",
    "dropmalcty": "WEST KENNEBUNK",
    "dropmalst": "ME",
    "dropmalzpp": "040949998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079857255,
    "dropsitcph": 2079857255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25295",
    "droptype": "D",
    "dropname": "WEST MINOT",
    "dropdeladd": "758 W MINOT RD",
    "dropdelcty": "WEST MINOT",
    "dropdelst": "ME",
    "dropdelzpp": "042889998",
    "dropphyadd": "758 W MINOT RD",
    "dropphycty": "WEST MINOT",
    "dropphyst": "ME",
    "dropphyzpp": "042889998",
    "dropmaladd": "758 W MINOT RD",
    "dropmalcty": "WEST MINOT",
    "dropmalst": "ME",
    "dropmalzpp": "042889998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079662022,
    "dropsitcph": 2079662022,
    "dropfax": 2079662069
  },
  {
    "dcode": "D",
    "dropkey": "PV25296",
    "droptype": "D",
    "dropname": "WEST NEWFIELD",
    "dropdeladd": "24 S EFFINGHAM RD",
    "dropdelcty": "WEST NEWFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "040959998",
    "dropphyadd": "24 S EFFINGHAM RD",
    "dropphycty": "WEST NEWFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "040959998",
    "dropmaladd": "24 S EFFINGHAM RD",
    "dropmalcty": "WEST NEWFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "040959998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077938053,
    "dropsitcph": 2077938053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25297",
    "droptype": "D",
    "dropname": "WEST PARIS",
    "dropdeladd": "238 MAIN ST",
    "dropdelcty": "WEST PARIS",
    "dropdelst": "ME",
    "dropdelzpp": "042899998",
    "dropphyadd": "238 MAIN ST",
    "dropphycty": "WEST PARIS",
    "dropphyst": "ME",
    "dropphyzpp": "042899998",
    "dropmaladd": "238 MAIN ST",
    "dropmalcty": "WEST PARIS",
    "dropmalst": "ME",
    "dropmalzpp": "042899998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076742951,
    "dropsitcph": 2076742951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25299",
    "droptype": "D",
    "dropname": "WEST POLAND",
    "dropdeladd": "91 MEGQUIER HILL RD",
    "dropdelcty": "WEST POLAND",
    "dropdelst": "ME",
    "dropdelzpp": "042919998",
    "dropphyadd": "91 MEGQUIER HILL RD",
    "dropphycty": "WEST POLAND",
    "dropphyst": "ME",
    "dropphyzpp": "042919998",
    "dropmaladd": "91 MEGQUIER HILL RD",
    "dropmalcty": "WEST POLAND",
    "dropmalst": "ME",
    "dropmalzpp": "042919998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079982895,
    "dropsitcph": 2079982895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25300",
    "droptype": "D",
    "dropname": "WEST ROCKPORT",
    "dropdeladd": "642 ROCKLAND ST",
    "dropdelcty": "WEST ROCKPORT",
    "dropdelst": "ME",
    "dropdelzpp": "048659998",
    "dropphyadd": "642 ROCKLAND ST",
    "dropphycty": "WEST ROCKPORT",
    "dropphyst": "ME",
    "dropphyzpp": "048659998",
    "dropmaladd": "642 ROCKLAND ST",
    "dropmalcty": "WEST ROCKPORT",
    "dropmalst": "ME",
    "dropmalzpp": "048659998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072368285,
    "dropsitcph": 2072368285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25302",
    "droptype": "D",
    "dropname": "SOUTHPORT",
    "dropdeladd": "432 HENDRICKS HILL RD",
    "dropdelcty": "SOUTHPORT",
    "dropdelst": "ME",
    "dropdelzpp": "045769998",
    "dropphyadd": "432 HENDRICKS HILL RD",
    "dropphycty": "SOUTHPORT",
    "dropphyst": "ME",
    "dropphyzpp": "045769998",
    "dropmaladd": "432 HENDRICKS HILL RD",
    "dropmalcty": "SOUTHPORT",
    "dropmalst": "ME",
    "dropmalzpp": "045769998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076335588,
    "dropsitcph": 2076335588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25303",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "643 MAIN ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "ME",
    "dropdelzpp": "042929998",
    "dropphyadd": "643 MAIN ST",
    "dropphycty": "SUMNER",
    "dropphyst": "ME",
    "dropphyzpp": "042929998",
    "dropmaladd": "643 MAIN ST",
    "dropmalcty": "SUMNER",
    "dropmalst": "ME",
    "dropmalzpp": "042929998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073882066,
    "dropsitcph": 2073882066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25305",
    "droptype": "D",
    "dropname": "WESTBROOK",
    "dropdeladd": "775 MAIN ST",
    "dropdelcty": "WESTBROOK",
    "dropdelst": "ME",
    "dropdelzpp": "040923438",
    "dropphyadd": "775 MAIN ST",
    "dropphycty": "WESTBROOK",
    "dropphyst": "ME",
    "dropphyzpp": "040923438",
    "dropmaladd": "775 MAIN ST",
    "dropmalcty": "WESTBROOK",
    "dropmalst": "ME",
    "dropmalzpp": "040923438",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078544651,
    "dropsitcph": 2078718437,
    "dropfax": 2078566075
  },
  {
    "dcode": "D",
    "dropkey": "PV25306",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "286 BURLEIGH RD",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "ME",
    "dropdelzpp": "047879998",
    "dropphyadd": "286 BURLEIGH RD",
    "dropphycty": "WESTFIELD",
    "dropphyst": "ME",
    "dropphyzpp": "047879998",
    "dropmaladd": "286 BURLEIGH RD",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "ME",
    "dropmalzpp": "047879998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074298261,
    "dropsitcph": 2074298261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25307",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "240 US RTE 1",
    "dropdelcty": "WHITING",
    "dropdelst": "ME",
    "dropdelzpp": "046919998",
    "dropphyadd": "240 US RTE 1",
    "dropphycty": "WHITING",
    "dropphyst": "ME",
    "dropphyzpp": "046919998",
    "dropmaladd": "240 US RTE 1",
    "dropmalcty": "WHITING",
    "dropmalst": "ME",
    "dropmalzpp": "046919998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072558380,
    "dropsitcph": 2077332595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25309",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "454 MAIN ST",
    "dropdelcty": "WILTON",
    "dropdelst": "ME",
    "dropdelzpp": "042949998",
    "dropphyadd": "454 MAIN ST",
    "dropphycty": "WILTON",
    "dropphyst": "ME",
    "dropphyzpp": "042949998",
    "dropmaladd": "454 MAIN ST",
    "dropmalcty": "WILTON",
    "dropmalst": "ME",
    "dropmalzpp": "042949998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076452332,
    "dropsitcph": 2076452332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25310",
    "droptype": "D",
    "dropname": "WINDHAM",
    "dropdeladd": "765 ROOSEVELT TRL STE 7",
    "dropdelcty": "WINDHAM",
    "dropdelst": "ME",
    "dropdelzpp": "040629998",
    "dropphyadd": "765 ROOSEVELT TRL STE 7",
    "dropphycty": "WINDHAM",
    "dropphyst": "ME",
    "dropphyzpp": "040629998",
    "dropmaladd": "765 ROOSEVELT TRL STE 7",
    "dropmalcty": "WINDHAM",
    "dropmalst": "ME",
    "dropmalzpp": "040629998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078924742,
    "dropsitcph": 2078924742,
    "dropfax": 2078926264
  },
  {
    "dcode": "D",
    "dropkey": "PV25311",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "519 RIDGE RD",
    "dropdelcty": "WINDSOR",
    "dropdelst": "ME",
    "dropdelzpp": "043639998",
    "dropphyadd": "519 RIDGE RD",
    "dropphycty": "WINDSOR",
    "dropphyst": "ME",
    "dropphyzpp": "043639998",
    "dropmaladd": "519 RIDGE RD",
    "dropmalcty": "WINDSOR",
    "dropmalst": "ME",
    "dropmalzpp": "043639998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779079610,
    "dropsitcph": 8779079610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25312",
    "droptype": "D",
    "dropname": "WINN",
    "dropdeladd": "986 ROUTE 2",
    "dropdelcty": "WINN",
    "dropdelst": "ME",
    "dropdelzpp": "044959998",
    "dropphyadd": "986 ROUTE 2",
    "dropphycty": "WINN",
    "dropphyst": "ME",
    "dropphyzpp": "044959998",
    "dropmaladd": "986 ROUTE 2",
    "dropmalcty": "WINN",
    "dropmalst": "ME",
    "dropmalzpp": "044959998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8779076342,
    "dropsitcph": 8779076342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25314",
    "droptype": "D",
    "dropname": "WINTER HARBOR",
    "dropdeladd": "267 MAIN ST",
    "dropdelcty": "WINTER HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "046939998",
    "dropphyadd": "267 MAIN ST",
    "dropphycty": "WINTER HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "046939998",
    "dropmaladd": "267 MAIN ST",
    "dropmalcty": "WINTER HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "046939998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079637121,
    "dropsitcph": 2079637121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25315",
    "droptype": "D",
    "dropname": "WINTERPORT",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "WINTERPORT",
    "dropdelst": "ME",
    "dropdelzpp": "044969998",
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "WINTERPORT",
    "dropphyst": "ME",
    "dropphyzpp": "044969998",
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "WINTERPORT",
    "dropmalst": "ME",
    "dropmalzpp": "044969998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072234692,
    "dropsitcph": 2072234692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25317",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "WINTHROP",
    "dropdelst": "ME",
    "dropdelzpp": "043649998",
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "WINTHROP",
    "dropphyst": "ME",
    "dropphyzpp": "043649998",
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "WINTHROP",
    "dropmalst": "ME",
    "dropmalzpp": "043649998",
    "dropsitphn": 2075102795,
    "dropsitlph": 8778541533,
    "dropsitcph": 8778541533,
    "dropfax": 2073779424
  },
  {
    "dcode": "D",
    "dropkey": "PV25318",
    "droptype": "D",
    "dropname": "WISCASSET",
    "dropdeladd": "140 MAIN ST",
    "dropdelcty": "WISCASSET",
    "dropdelst": "ME",
    "dropdelzpp": "045789998",
    "dropphyadd": "140 MAIN ST",
    "dropphycty": "WISCASSET",
    "dropphyst": "ME",
    "dropphyzpp": "045789998",
    "dropmaladd": "140 MAIN ST",
    "dropmalcty": "WISCASSET",
    "dropmalst": "ME",
    "dropmalzpp": "045789998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078827611,
    "dropsitcph": 2078827611,
    "dropfax": 2078824026
  },
  {
    "dcode": "D",
    "dropkey": "PV25320",
    "droptype": "D",
    "dropname": "BAILEYVILLE",
    "dropdeladd": "667 HOULTON RD STE 1",
    "dropdelcty": "BAILEYVILLE",
    "dropdelst": "ME",
    "dropdelzpp": "046949998",
    "dropphyadd": "667 HOULTON RD STE 1",
    "dropphycty": "BAILEYVILLE",
    "dropphyst": "ME",
    "dropphyzpp": "046949998",
    "dropmaladd": "667 HOULTON RD STE 1",
    "dropmalcty": "BAILEYVILLE",
    "dropmalst": "ME",
    "dropmalzpp": "046949998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074273745,
    "dropsitcph": 2074273745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25323",
    "droptype": "D",
    "dropname": "WOOLWICH",
    "dropdeladd": "53 MAIN ST",
    "dropdelcty": "WOOLWICH",
    "dropdelst": "ME",
    "dropdelzpp": "045799998",
    "dropphyadd": "53 MAIN ST",
    "dropphycty": "WOOLWICH",
    "dropphyst": "ME",
    "dropphyzpp": "045799998",
    "dropmaladd": "53 MAIN ST",
    "dropmalcty": "WOOLWICH",
    "dropmalst": "ME",
    "dropmalzpp": "045799998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074432000,
    "dropsitcph": 2074432000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25324",
    "droptype": "D",
    "dropname": "WYTOPITLOCK",
    "dropdeladd": "751 MAIN ST",
    "dropdelcty": "WYTOPITLOCK",
    "dropdelst": "ME",
    "dropdelzpp": "044979998",
    "dropphyadd": "751 MAIN ST",
    "dropphycty": "WYTOPITLOCK",
    "dropphyst": "ME",
    "dropphyzpp": "044979998",
    "dropmaladd": "751 MAIN ST",
    "dropmalcty": "WYTOPITLOCK",
    "dropmalst": "ME",
    "dropmalzpp": "044979998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2074567505,
    "dropsitcph": 2074567505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25325",
    "droptype": "D",
    "dropname": "YARMOUTH",
    "dropdeladd": "36 FOREST FALLS DR",
    "dropdelcty": "YARMOUTH",
    "dropdelst": "ME",
    "dropdelzpp": "040969998",
    "dropphyadd": "36 FOREST FALLS DR",
    "dropphycty": "YARMOUTH",
    "dropphyst": "ME",
    "dropphyzpp": "040969998",
    "dropmaladd": "36 FOREST FALLS DR",
    "dropmalcty": "YARMOUTH",
    "dropmalst": "ME",
    "dropmalzpp": "040969998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078464211,
    "dropsitcph": 2078464211,
    "dropfax": 2078461471
  },
  {
    "dcode": "D",
    "dropkey": "PV25326",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "10 WOODBRIDGE RD",
    "dropdelcty": "YORK",
    "dropdelst": "ME",
    "dropdelzpp": "039099998",
    "dropphyadd": "10 WOODBRIDGE RD",
    "dropphycty": "YORK",
    "dropphyst": "ME",
    "dropphyzpp": "039099998",
    "dropmaladd": "10 WOODBRIDGE RD",
    "dropmalcty": "YORK",
    "dropmalst": "ME",
    "dropmalzpp": "039099998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073632441,
    "dropsitcph": 2073632441,
    "dropfax": 2073632640
  },
  {
    "dcode": "D",
    "dropkey": "PV25328",
    "droptype": "D",
    "dropname": "YORK HARBOR",
    "dropdeladd": "445 YORK ST",
    "dropdelcty": "YORK HARBOR",
    "dropdelst": "ME",
    "dropdelzpp": "039119998",
    "dropphyadd": "445 YORK ST",
    "dropphycty": "YORK HARBOR",
    "dropphyst": "ME",
    "dropphyzpp": "039119998",
    "dropmaladd": "445 YORK ST",
    "dropmalcty": "YORK HARBOR",
    "dropmalst": "ME",
    "dropmalzpp": "039119998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073634953,
    "dropsitcph": 2073634953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25329",
    "droptype": "D",
    "dropname": "ACWORTH",
    "dropdeladd": "123 HILL RD",
    "dropdelcty": "ACWORTH",
    "dropdelst": "NH",
    "dropdelzpp": "036019998",
    "dropphyadd": "123 HILL RD",
    "dropphycty": "ACWORTH",
    "dropphyst": "NH",
    "dropphyzpp": "036019998",
    "dropmaladd": "123 HILL RD",
    "dropmalcty": "ACWORTH",
    "dropmalst": "NH",
    "dropmalzpp": "036019998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038352146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25335",
    "droptype": "D",
    "dropname": "ALSTEAD",
    "dropdeladd": "42 HIGH ST",
    "dropdelcty": "ALSTEAD",
    "dropdelst": "NH",
    "dropdelzpp": "036029998",
    "dropphyadd": "42 HIGH ST",
    "dropphycty": "ALSTEAD",
    "dropphyst": "NH",
    "dropphyzpp": "036029998",
    "dropmaladd": "42 HIGH ST",
    "dropmalcty": "ALSTEAD",
    "dropmalst": "NH",
    "dropmalzpp": "036029998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038356068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25336",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "9 SCHOOL ST",
    "dropdelcty": "ALTON",
    "dropdelst": "NH",
    "dropdelzpp": "038099998",
    "dropphyadd": "9 SCHOOL ST",
    "dropphycty": "ALTON",
    "dropphyst": "NH",
    "dropphyzpp": "038099998",
    "dropmaladd": "9 SCHOOL ST",
    "dropmalcty": "ALTON",
    "dropmalst": "NH",
    "dropmalzpp": "038099998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038756411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25337",
    "droptype": "D",
    "dropname": "ALTON BAY",
    "dropdeladd": "5 MOUNT MAJOR HWY UNIT 1",
    "dropdelcty": "ALTON BAY",
    "dropdelst": "NH",
    "dropdelzpp": "038109998",
    "dropphyadd": "5 MOUNT MAJOR HWY UNIT 1",
    "dropphycty": "ALTON BAY",
    "dropphyst": "NH",
    "dropphyzpp": "038109998",
    "dropmaladd": "5 MOUNT MAJOR HWY UNIT 1",
    "dropmalcty": "ALTON BAY",
    "dropmalst": "NH",
    "dropmalzpp": "038109998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038756800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25338",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "199 STATE ROUTE 101 UNIT 4D",
    "dropdelcty": "AMHERST",
    "dropdelst": "NH",
    "dropdelzpp": "030319998",
    "dropphyadd": "199 STATE ROUTE 101 UNIT 4D",
    "dropphycty": "AMHERST",
    "dropphyst": "NH",
    "dropphyzpp": "030319998",
    "dropmaladd": "199 STATE ROUTE 101 UNIT 4D",
    "dropmalcty": "AMHERST",
    "dropmalst": "NH",
    "dropmalzpp": "030319998",
    "dropsitphn": 6036734132,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036734132,
    "dropfax": 6036735375
  },
  {
    "dcode": "D",
    "dropkey": "PV25339",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "164 MAIN ST REAR",
    "dropdelcty": "ANDOVER",
    "dropdelst": "NH",
    "dropdelzpp": "032169998",
    "dropphyadd": "164 MAIN ST REAR",
    "dropphycty": "ANDOVER",
    "dropphyst": "NH",
    "dropphyzpp": "032169998",
    "dropmaladd": "164 MAIN ST REAR",
    "dropmalcty": "ANDOVER",
    "dropmalst": "NH",
    "dropmalzpp": "032169998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037355483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25340",
    "droptype": "D",
    "dropname": "ANTRIM",
    "dropdeladd": "1 POST RD",
    "dropdelcty": "ANTRIM",
    "dropdelst": "NH",
    "dropdelzpp": "034409998",
    "dropphyadd": "1 POST RD",
    "dropphycty": "ANTRIM",
    "dropphyst": "NH",
    "dropphyzpp": "034409998",
    "dropmaladd": "1 POST RD",
    "dropmalcty": "ANTRIM",
    "dropmalst": "NH",
    "dropmalzpp": "034409998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035882614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25341",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "142 MAIN ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "NH",
    "dropdelzpp": "032179998",
    "dropphyadd": "142 MAIN ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "NH",
    "dropphyzpp": "032179998",
    "dropmaladd": "142 MAIN ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "NH",
    "dropmalzpp": "032179998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039687511,
    "dropfax": 6039689816
  },
  {
    "dcode": "D",
    "dropkey": "PV25342",
    "droptype": "D",
    "dropname": "ASHUELOT",
    "dropdeladd": "8 ASHUELOT MAIN ST",
    "dropdelcty": "ASHUELOT",
    "dropdelst": "NH",
    "dropdelzpp": "034419998",
    "dropphyadd": "8 ASHUELOT MAIN ST",
    "dropphycty": "ASHUELOT",
    "dropphyst": "NH",
    "dropphyzpp": "034419998",
    "dropmaladd": "8 ASHUELOT MAIN ST",
    "dropmalcty": "ASHUELOT",
    "dropmalst": "NH",
    "dropmalzpp": "034419998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032396003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25343",
    "droptype": "D",
    "dropname": "ATKINSON",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "ATKINSON",
    "dropdelst": "NH",
    "dropdelzpp": "038119998",
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "ATKINSON",
    "dropphyst": "NH",
    "dropphyzpp": "038119998",
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "ATKINSON",
    "dropmalst": "NH",
    "dropmalzpp": "038119998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033625717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25344",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "61 RAYMOND RD",
    "dropdelcty": "AUBURN",
    "dropdelst": "NH",
    "dropdelzpp": "030329998",
    "dropphyadd": "61 RAYMOND RD",
    "dropphycty": "AUBURN",
    "dropphyst": "NH",
    "dropphyzpp": "030329998",
    "dropmaladd": "61 RAYMOND RD",
    "dropmalcty": "AUBURN",
    "dropmalst": "NH",
    "dropmalzpp": "030329998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034835428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25345",
    "droptype": "D",
    "dropname": "BARNSTEAD",
    "dropdeladd": "335 PARADE RD",
    "dropdelcty": "BARNSTEAD",
    "dropdelst": "NH",
    "dropdelzpp": "032189998",
    "dropphyadd": "335 PARADE RD",
    "dropphycty": "BARNSTEAD",
    "dropphyst": "NH",
    "dropphyzpp": "032189998",
    "dropmaladd": "335 PARADE RD",
    "dropmalcty": "BARNSTEAD",
    "dropmalst": "NH",
    "dropmalzpp": "032189998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034358853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25346",
    "droptype": "D",
    "dropname": "BARRINGTON",
    "dropdeladd": "15 MALLEGO RD",
    "dropdelcty": "BARRINGTON",
    "dropdelst": "NH",
    "dropdelzpp": "038259998",
    "dropphyadd": "15 MALLEGO RD",
    "dropphycty": "BARRINGTON",
    "dropphyst": "NH",
    "dropphyzpp": "038259998",
    "dropmaladd": "15 MALLEGO RD",
    "dropmalcty": "BARRINGTON",
    "dropmalst": "NH",
    "dropmalzpp": "038259998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036649382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25347",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "1373 US ROUTE 302",
    "dropdelcty": "BARTLETT",
    "dropdelst": "NH",
    "dropdelzpp": "038129998",
    "dropphyadd": "1373 US ROUTE 302",
    "dropphycty": "BARTLETT",
    "dropphyst": "NH",
    "dropphyzpp": "038129998",
    "dropmaladd": "1373 US ROUTE 302",
    "dropmalcty": "BARTLETT",
    "dropmalst": "NH",
    "dropmalzpp": "038129998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033742351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25348",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "4 W BATH RD",
    "dropdelcty": "BATH",
    "dropdelst": "NH",
    "dropdelzpp": "037409998",
    "dropphyadd": "4 W BATH RD",
    "dropphycty": "BATH",
    "dropphyst": "NH",
    "dropphyzpp": "037409998",
    "dropmaladd": "4 W BATH RD",
    "dropmalcty": "BATH",
    "dropmalst": "NH",
    "dropmalzpp": "037409998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037473781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25352",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "24 POST OFFICE RD",
    "dropdelcty": "BELMONT",
    "dropdelst": "NH",
    "dropdelzpp": "032209998",
    "dropphyadd": "24 POST OFFICE RD",
    "dropphycty": "BELMONT",
    "dropphyst": "NH",
    "dropphyzpp": "032209998",
    "dropmaladd": "24 POST OFFICE RD",
    "dropmalcty": "BELMONT",
    "dropmalst": "NH",
    "dropmalzpp": "032209998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032676571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25356",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "15 MOUNT FORIST ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "NH",
    "dropdelzpp": "035701257",
    "dropphyadd": "15 MOUNT FORIST ST",
    "dropphycty": "BERLIN",
    "dropphyst": "NH",
    "dropphyzpp": "035701257",
    "dropmaladd": "15 MOUNT FORIST ST",
    "dropmalcty": "BERLIN",
    "dropmalst": "NH",
    "dropmalzpp": "035701257",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037521700,
    "dropfax": 6037524608
  },
  {
    "dcode": "D",
    "dropkey": "PV25357",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "2159 MAIN ST",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "NH",
    "dropdelzpp": "035749998",
    "dropphyadd": "2159 MAIN ST",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "NH",
    "dropphyzpp": "035749998",
    "dropmaladd": "2159 MAIN ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "NH",
    "dropmalzpp": "035749998",
    "dropsitphn": 6036444128,
    "dropsitlph": 5185958233,
    "dropsitcph": 5185958233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25361",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "2219 STATE ROUTE 114",
    "dropdelcty": "BRADFORD",
    "dropdelst": "NH",
    "dropdelzpp": "032219998",
    "dropphyadd": "2219 STATE ROUTE 114",
    "dropphycty": "BRADFORD",
    "dropphyst": "NH",
    "dropphyzpp": "032219998",
    "dropmaladd": "2219 STATE ROUTE 114",
    "dropmalcty": "BRADFORD",
    "dropmalst": "NH",
    "dropmalzpp": "032219998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039382125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25366",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "85 PLEASANT ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "NH",
    "dropdelzpp": "032229998",
    "dropphyadd": "85 PLEASANT ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "NH",
    "dropphyzpp": "032229998",
    "dropmaladd": "85 PLEASANT ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "NH",
    "dropmalzpp": "032229998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037443383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25368",
    "droptype": "D",
    "dropname": "BROOKLINE",
    "dropdeladd": "2 POST OFFICE DR",
    "dropdelcty": "BROOKLINE",
    "dropdelst": "NH",
    "dropdelzpp": "030339998",
    "dropphyadd": "2 POST OFFICE DR",
    "dropphycty": "BROOKLINE",
    "dropphyst": "NH",
    "dropphyzpp": "030339998",
    "dropmaladd": "2 POST OFFICE DR",
    "dropmalcty": "BROOKLINE",
    "dropmalst": "NH",
    "dropmalzpp": "030339998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036732271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25371",
    "droptype": "D",
    "dropname": "CAMPTON",
    "dropdeladd": "11 SOUTHMAYD ST",
    "dropdelcty": "CAMPTON",
    "dropdelst": "NH",
    "dropdelzpp": "032239998",
    "dropphyadd": "11 SOUTHMAYD ST",
    "dropphycty": "CAMPTON",
    "dropphyst": "NH",
    "dropphyzpp": "032239998",
    "dropmaladd": "11 SOUTHMAYD ST",
    "dropmalcty": "CAMPTON",
    "dropmalst": "NH",
    "dropmalzpp": "032239998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037268952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25372",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "1205 US ROUTE 4",
    "dropdelcty": "CANAAN",
    "dropdelst": "NH",
    "dropdelzpp": "037419998",
    "dropphyadd": "1205 US ROUTE 4",
    "dropphycty": "CANAAN",
    "dropphyst": "NH",
    "dropphyzpp": "037419998",
    "dropmaladd": "1205 US ROUTE 4",
    "dropmalcty": "CANAAN",
    "dropmalst": "NH",
    "dropmalzpp": "037419998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035237710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25373",
    "droptype": "D",
    "dropname": "CANDIA",
    "dropdeladd": "115 RAYMOND RD",
    "dropdelcty": "CANDIA",
    "dropdelst": "NH",
    "dropdelzpp": "030342135",
    "dropphyadd": "115 RAYMOND RD",
    "dropphycty": "CANDIA",
    "dropphyst": "NH",
    "dropphyzpp": "030342135",
    "dropmaladd": "115 RAYMOND RD",
    "dropmalcty": "CANDIA",
    "dropmalst": "NH",
    "dropmalzpp": "030342135",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034832739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25374",
    "droptype": "D",
    "dropname": "CANTERBURY",
    "dropdeladd": "3 CENTER RD",
    "dropdelcty": "CANTERBURY",
    "dropdelst": "NH",
    "dropdelzpp": "032249998",
    "dropphyadd": "3 CENTER RD",
    "dropphycty": "CANTERBURY",
    "dropphyst": "NH",
    "dropphyzpp": "032249998",
    "dropmaladd": "3 CENTER RD",
    "dropmalcty": "CANTERBURY",
    "dropmalst": "NH",
    "dropmalzpp": "032249998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037834158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25378",
    "droptype": "D",
    "dropname": "CENTER BARNSTEAD",
    "dropdeladd": "55 S BARNSTEAD RD",
    "dropdelcty": "CENTER BARNSTEAD",
    "dropdelst": "NH",
    "dropdelzpp": "032259998",
    "dropphyadd": "55 S BARNSTEAD RD",
    "dropphycty": "CENTER BARNSTEAD",
    "dropphyst": "NH",
    "dropphyzpp": "032259998",
    "dropmaladd": "55 S BARNSTEAD RD",
    "dropmalcty": "CENTER BARNSTEAD",
    "dropmalst": "NH",
    "dropmalzpp": "032259998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032694911,
    "dropfax": 6032694911
  },
  {
    "dcode": "D",
    "dropkey": "PV25380",
    "droptype": "D",
    "dropname": "CENTER CONWAY",
    "dropdeladd": "1848 E MAIN ST",
    "dropdelcty": "CENTER CONWAY",
    "dropdelst": "NH",
    "dropdelzpp": "038139998",
    "dropphyadd": "1848 E MAIN ST",
    "dropphycty": "CENTER CONWAY",
    "dropphyst": "NH",
    "dropphyzpp": "038139998",
    "dropmaladd": "1848 E MAIN ST",
    "dropmalcty": "CENTER CONWAY",
    "dropmalst": "NH",
    "dropmalzpp": "038139998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034475148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25381",
    "droptype": "D",
    "dropname": "CENTER HARBOR",
    "dropdeladd": "44 MAIN ST",
    "dropdelcty": "CENTER HARBOR",
    "dropdelst": "NH",
    "dropdelzpp": "032269998",
    "dropphyadd": "44 MAIN ST",
    "dropphycty": "CENTER HARBOR",
    "dropphyst": "NH",
    "dropphyzpp": "032269998",
    "dropmaladd": "44 MAIN ST",
    "dropmalcty": "CENTER HARBOR",
    "dropmalst": "NH",
    "dropmalzpp": "032269998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032534531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25382",
    "droptype": "D",
    "dropname": "CENTER OSSIPEE",
    "dropdeladd": "71 MAIN ST",
    "dropdelcty": "CENTER OSSIPEE",
    "dropdelst": "NH",
    "dropdelzpp": "038149998",
    "dropphyadd": "71 MAIN ST",
    "dropphycty": "CENTER OSSIPEE",
    "dropphyst": "NH",
    "dropphyzpp": "038149998",
    "dropmaladd": "71 MAIN ST",
    "dropmalcty": "CENTER OSSIPEE",
    "dropmalst": "NH",
    "dropmalzpp": "038149998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035394342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25383",
    "droptype": "D",
    "dropname": "CENTER SANDWICH",
    "dropdeladd": "31 MAIN ST",
    "dropdelcty": "CENTER SANDWICH",
    "dropdelst": "NH",
    "dropdelzpp": "032279998",
    "dropphyadd": "31 MAIN ST",
    "dropphycty": "CENTER SANDWICH",
    "dropphyst": "NH",
    "dropphyzpp": "032279998",
    "dropmaladd": "31 MAIN ST",
    "dropmalcty": "CENTER SANDWICH",
    "dropmalst": "NH",
    "dropmalzpp": "032279998",
    "dropsitphn": 6036444128,
    "dropsitlph": 5856537581,
    "dropsitcph": 5856537581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25387",
    "droptype": "D",
    "dropname": "CHARLESTOWN",
    "dropdeladd": "26 CHURCH ST",
    "dropdelcty": "CHARLESTOWN",
    "dropdelst": "NH",
    "dropdelzpp": "036039998",
    "dropphyadd": "26 CHURCH ST",
    "dropphycty": "CHARLESTOWN",
    "dropphyst": "NH",
    "dropphyzpp": "036039998",
    "dropmaladd": "26 CHURCH ST",
    "dropmalcty": "CHARLESTOWN",
    "dropmalst": "NH",
    "dropmalzpp": "036039998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038263611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25389",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "5 CHESTER ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "030369998",
    "dropphyadd": "5 CHESTER ST",
    "dropphycty": "CHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "030369998",
    "dropmaladd": "5 CHESTER ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "030369998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036915219,
    "dropsitcph": 6036915219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25390",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "523 ROUTE 63",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "034439998",
    "dropphyadd": "523 ROUTE 63",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "034439998",
    "dropmaladd": "523 ROUTE 63",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "034439998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038034091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25395",
    "droptype": "D",
    "dropname": "CHOCORUA",
    "dropdeladd": "40 CHOCORUA MOUNTAIN HWY",
    "dropdelcty": "CHOCORUA",
    "dropdelst": "NH",
    "dropdelzpp": "038179998",
    "dropphyadd": "40 CHOCORUA MOUNTAIN HWY",
    "dropphycty": "CHOCORUA",
    "dropphyst": "NH",
    "dropphyzpp": "038179998",
    "dropmaladd": "40 CHOCORUA MOUNTAIN HWY",
    "dropmalcty": "CHOCORUA",
    "dropmalst": "NH",
    "dropmalzpp": "038179998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033237537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25396",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "140 BROAD ST",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "NH",
    "dropdelzpp": "037433609",
    "dropphyadd": "140 BROAD ST",
    "dropphycty": "CLAREMONT",
    "dropphyst": "NH",
    "dropphyzpp": "037433609",
    "dropmaladd": "140 BROAD ST",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "NH",
    "dropmalzpp": "037433609",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035433051,
    "dropfax": 6035430043
  },
  {
    "dcode": "D",
    "dropkey": "PV25398",
    "droptype": "D",
    "dropname": "COLEBROOK",
    "dropdeladd": "21 PARSONS ST",
    "dropdelcty": "COLEBROOK",
    "dropdelst": "NH",
    "dropdelzpp": "035769998",
    "dropphyadd": "21 PARSONS ST",
    "dropphycty": "COLEBROOK",
    "dropphyst": "NH",
    "dropphyzpp": "035769998",
    "dropmaladd": "21 PARSONS ST",
    "dropmalcty": "COLEBROOK",
    "dropmalst": "NH",
    "dropmalzpp": "035769998",
    "dropsitphn": 6036444128,
    "dropsitlph": 3155171789,
    "dropsitcph": 3155171789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25401",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "18 LOUDON RD",
    "dropdelcty": "CONCORD",
    "dropdelst": "NH",
    "dropdelzpp": "033019998",
    "dropphyadd": "18 LOUDON RD",
    "dropphycty": "CONCORD",
    "dropphyst": "NH",
    "dropphyzpp": "033019998",
    "dropmaladd": "18 LOUDON RD",
    "dropmalcty": "CONCORD",
    "dropmalst": "NH",
    "dropmalzpp": "033019998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032250004,
    "dropfax": 6032288309
  },
  {
    "dcode": "D",
    "dropkey": "PV25404",
    "droptype": "D",
    "dropname": "CONTOOCOOK",
    "dropdeladd": "129 PARK AVE",
    "dropdelcty": "CONTOOCOOK",
    "dropdelst": "NH",
    "dropdelzpp": "032299998",
    "dropphyadd": "129 PARK AVE",
    "dropphycty": "CONTOOCOOK",
    "dropphyst": "NH",
    "dropphyzpp": "032299998",
    "dropmaladd": "129 PARK AVE",
    "dropmalcty": "CONTOOCOOK",
    "dropmalst": "NH",
    "dropmalzpp": "032299998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037463980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25405",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "175 MAIN ST",
    "dropdelcty": "CONWAY",
    "dropdelst": "NH",
    "dropdelzpp": "038189998",
    "dropphyadd": "175 MAIN ST",
    "dropphycty": "CONWAY",
    "dropphyst": "NH",
    "dropphyzpp": "038189998",
    "dropmaladd": "175 MAIN ST",
    "dropmalcty": "CONWAY",
    "dropmalst": "NH",
    "dropmalzpp": "038189998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034475160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25407",
    "droptype": "D",
    "dropname": "CORNISH FLAT",
    "dropdeladd": "241 NH ROUTE 120",
    "dropdelcty": "CORNISH FLAT",
    "dropdelst": "NH",
    "dropdelzpp": "037469998",
    "dropphyadd": "241 NH ROUTE 120",
    "dropphycty": "CORNISH FLAT",
    "dropphyst": "NH",
    "dropphyzpp": "037469998",
    "dropmaladd": "241 NH ROUTE 120",
    "dropmalcty": "CORNISH FLAT",
    "dropmalst": "NH",
    "dropmalzpp": "037469998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035433502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25419",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "41 NH ROUTE 104",
    "dropdelcty": "DANBURY",
    "dropdelst": "NH",
    "dropdelzpp": "032309998",
    "dropphyadd": "41 NH ROUTE 104",
    "dropphycty": "DANBURY",
    "dropphyst": "NH",
    "dropphyzpp": "032309998",
    "dropmaladd": "41 NH ROUTE 104",
    "dropmalcty": "DANBURY",
    "dropmalst": "NH",
    "dropmalzpp": "032309998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037683941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25421",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "5 PINE ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "NH",
    "dropdelzpp": "038199998",
    "dropphyadd": "5 PINE ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "NH",
    "dropphyzpp": "038199998",
    "dropmaladd": "5 PINE ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "NH",
    "dropmalzpp": "038199998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6033823093,
    "dropsitcph": 6033823093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25423",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "17A RAYMOND RD",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "030379998",
    "dropphyadd": "17A RAYMOND RD",
    "dropphycty": "DEERFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "030379998",
    "dropmaladd": "17A RAYMOND RD",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "030379998",
    "dropsitphn": "",
    "dropsitlph": 8382340016,
    "dropsitcph": 8382340016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25426",
    "droptype": "D",
    "dropname": "DERRY",
    "dropdeladd": "24 TSIENNETO RD",
    "dropdelcty": "DERRY",
    "dropdelst": "NH",
    "dropdelzpp": "030381599",
    "dropphyadd": "24 TSIENNETO RD",
    "dropphycty": "DERRY",
    "dropphyst": "NH",
    "dropphyzpp": "030381599",
    "dropmaladd": "24 TSIENNETO RD",
    "dropmalcty": "DERRY",
    "dropmalst": "NH",
    "dropmalzpp": "030381599",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034327835,
    "dropfax": 6034348200
  },
  {
    "dcode": "D",
    "dropkey": "PV25431",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "133 WASHINGTON ST",
    "dropdelcty": "DOVER",
    "dropdelst": "NH",
    "dropdelzpp": "038203707",
    "dropphyadd": "133 WASHINGTON ST",
    "dropphycty": "DOVER",
    "dropphyst": "NH",
    "dropphyzpp": "038203707",
    "dropmaladd": "133 WASHINGTON ST",
    "dropmalcty": "DOVER",
    "dropmalst": "NH",
    "dropmalzpp": "038203707",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037424040,
    "dropfax": 6037409623
  },
  {
    "dcode": "D",
    "dropkey": "PV25434",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "1251 MAIN ST",
    "dropdelcty": "DUBLIN",
    "dropdelst": "NH",
    "dropdelzpp": "034449998",
    "dropphyadd": "1251 MAIN ST",
    "dropphycty": "DUBLIN",
    "dropphyst": "NH",
    "dropphyzpp": "034449998",
    "dropmaladd": "1251 MAIN ST",
    "dropmalcty": "DUBLIN",
    "dropmalst": "NH",
    "dropmalzpp": "034449998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072700095,
    "dropsitcph": 6072700095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25438",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "2 MADBURY RD",
    "dropdelcty": "DURHAM",
    "dropdelst": "NH",
    "dropdelzpp": "038249998",
    "dropphyadd": "2 MADBURY RD",
    "dropphycty": "DURHAM",
    "dropphyst": "NH",
    "dropphyzpp": "038249998",
    "dropmaladd": "2 MADBURY RD",
    "dropmalcty": "DURHAM",
    "dropmalst": "NH",
    "dropmalzpp": "038249998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038682151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25449",
    "droptype": "D",
    "dropname": "EAST ANDOVER",
    "dropdeladd": "770 FRANKLIN HWY",
    "dropdelcty": "EAST ANDOVER",
    "dropdelst": "NH",
    "dropdelzpp": "032319998",
    "dropphyadd": "770 FRANKLIN HWY",
    "dropphycty": "EAST ANDOVER",
    "dropphyst": "NH",
    "dropphyzpp": "032319998",
    "dropmaladd": "770 FRANKLIN HWY",
    "dropmalcty": "EAST ANDOVER",
    "dropmalst": "NH",
    "dropmalzpp": "032319998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037355709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25451",
    "droptype": "D",
    "dropname": "EAST DERRY",
    "dropdeladd": "50 E DERRY RD",
    "dropdelcty": "EAST DERRY",
    "dropdelst": "NH",
    "dropdelzpp": "030419998",
    "dropphyadd": "50 E DERRY RD",
    "dropphycty": "EAST DERRY",
    "dropphyst": "NH",
    "dropphyzpp": "030419998",
    "dropmaladd": "50 E DERRY RD",
    "dropmalcty": "EAST DERRY",
    "dropmalst": "NH",
    "dropmalzpp": "030419998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034343952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25452",
    "droptype": "D",
    "dropname": "EAST HAMPSTEAD",
    "dropdeladd": "59 COLBY COR",
    "dropdelcty": "EAST HAMPSTEAD",
    "dropdelst": "NH",
    "dropdelzpp": "038269998",
    "dropphyadd": "59 COLBY COR",
    "dropphycty": "EAST HAMPSTEAD",
    "dropphyst": "NH",
    "dropphyzpp": "038269998",
    "dropmaladd": "59 COLBY COR",
    "dropmalcty": "EAST HAMPSTEAD",
    "dropmalst": "NH",
    "dropmalzpp": "038269998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033826519,
    "dropfax": 6033823681
  },
  {
    "dcode": "D",
    "dropkey": "PV25454",
    "droptype": "D",
    "dropname": "EAST KINGSTON",
    "dropdeladd": "176 HAVERHILL RD",
    "dropdelcty": "EAST KINGSTON",
    "dropdelst": "NH",
    "dropdelzpp": "038279998",
    "dropphyadd": "176 HAVERHILL RD",
    "dropphycty": "EAST KINGSTON",
    "dropphyst": "NH",
    "dropphyzpp": "038279998",
    "dropmaladd": "176 HAVERHILL RD",
    "dropmalcty": "EAST KINGSTON",
    "dropmalst": "NH",
    "dropmalzpp": "038279998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036424660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25455",
    "droptype": "D",
    "dropname": "LEMPSTER",
    "dropdeladd": "902 US ROUTE 10",
    "dropdelcty": "LEMPSTER",
    "dropdelst": "NH",
    "dropdelzpp": "036059998",
    "dropphyadd": "902 US ROUTE 10",
    "dropphycty": "LEMPSTER",
    "dropphyst": "NH",
    "dropphyzpp": "036059998",
    "dropmaladd": "902 US ROUTE 10",
    "dropmalcty": "LEMPSTER",
    "dropmalst": "NH",
    "dropmalzpp": "036059998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038632933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25458",
    "droptype": "D",
    "dropname": "SWANZEY",
    "dropdeladd": "486 OLD HOMESTEAD HWY",
    "dropdelcty": "SWANZEY",
    "dropdelst": "NH",
    "dropdelzpp": "034469998",
    "dropphyadd": "486 OLD HOMESTEAD HWY",
    "dropphycty": "SWANZEY",
    "dropphyst": "NH",
    "dropphyzpp": "034469998",
    "dropmaladd": "486 OLD HOMESTEAD HWY",
    "dropmalcty": "SWANZEY",
    "dropmalst": "NH",
    "dropmalzpp": "034469998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033526944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25459",
    "droptype": "D",
    "dropname": "EAST WAKEFIELD",
    "dropdeladd": "8 ROUTE 110",
    "dropdelcty": "EAST WAKEFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "038309998",
    "dropphyadd": "8 ROUTE 110",
    "dropphycty": "EAST WAKEFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "038309998",
    "dropmaladd": "8 ROUTE 110",
    "dropmalcty": "EAST WAKEFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "038309998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035226275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25464",
    "droptype": "D",
    "dropname": "ELKINS",
    "dropdeladd": "349 ELKINS RD",
    "dropdelcty": "ELKINS",
    "dropdelst": "NH",
    "dropdelzpp": "032339998",
    "dropphyadd": "349 ELKINS RD",
    "dropphycty": "ELKINS",
    "dropphyst": "NH",
    "dropphyzpp": "032339998",
    "dropmaladd": "349 ELKINS RD",
    "dropmalcty": "ELKINS",
    "dropmalst": "NH",
    "dropmalzpp": "032339998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035264591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25466",
    "droptype": "D",
    "dropname": "ENFIELD",
    "dropdeladd": "17 MAPLE ST",
    "dropdelcty": "ENFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "037489998",
    "dropphyadd": "17 MAPLE ST",
    "dropphycty": "ENFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "037489998",
    "dropmaladd": "17 MAPLE ST",
    "dropmalcty": "ENFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "037489998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036324361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25467",
    "droptype": "D",
    "dropname": "ENFIELD CENTER",
    "dropdeladd": "1089 NH ROUTE 4A",
    "dropdelcty": "ENFIELD CENTER",
    "dropdelst": "NH",
    "dropdelzpp": "037499998",
    "dropphyadd": "1089 NH ROUTE 4A",
    "dropphycty": "ENFIELD CENTER",
    "dropphyst": "NH",
    "dropphyzpp": "037499998",
    "dropmaladd": "1089 NH ROUTE 4A",
    "dropmalcty": "ENFIELD CENTER",
    "dropmalst": "NH",
    "dropmalzpp": "037499998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036327318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25469",
    "droptype": "D",
    "dropname": "EPPING",
    "dropdeladd": "71 MAIN ST",
    "dropdelcty": "EPPING",
    "dropdelst": "NH",
    "dropdelzpp": "030429998",
    "dropphyadd": "71 MAIN ST",
    "dropphycty": "EPPING",
    "dropphyst": "NH",
    "dropphyzpp": "030429998",
    "dropmaladd": "71 MAIN ST",
    "dropmalcty": "EPPING",
    "dropmalst": "NH",
    "dropmalzpp": "030429998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036795952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25470",
    "droptype": "D",
    "dropname": "EPSOM",
    "dropdeladd": "948 SUNCOOK VALLEY HWY",
    "dropdelcty": "EPSOM",
    "dropdelst": "NH",
    "dropdelzpp": "032349998",
    "dropphyadd": "948 SUNCOOK VALLEY HWY",
    "dropphycty": "EPSOM",
    "dropphyst": "NH",
    "dropphyzpp": "032349998",
    "dropmaladd": "948 SUNCOOK VALLEY HWY",
    "dropmalcty": "EPSOM",
    "dropmalst": "NH",
    "dropmalzpp": "032349998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037369302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25471",
    "droptype": "D",
    "dropname": "ERROL",
    "dropdeladd": "25 MAIN ST UNIT 1",
    "dropdelcty": "ERROL",
    "dropdelst": "NH",
    "dropdelzpp": "035799998",
    "dropphyadd": "25 MAIN ST UNIT 1",
    "dropphycty": "ERROL",
    "dropphyst": "NH",
    "dropphyzpp": "035799998",
    "dropmaladd": "25 MAIN ST UNIT 1",
    "dropmalcty": "ERROL",
    "dropmalst": "NH",
    "dropmalzpp": "035799998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034827764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25472",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "3 SCHOOL HOUSE LN",
    "dropdelcty": "ETNA",
    "dropdelst": "NH",
    "dropdelzpp": "037509998",
    "dropphyadd": "3 SCHOOL HOUSE LN",
    "dropphycty": "ETNA",
    "dropphyst": "NH",
    "dropphyzpp": "037509998",
    "dropmaladd": "3 SCHOOL HOUSE LN",
    "dropmalcty": "ETNA",
    "dropmalst": "NH",
    "dropmalzpp": "037509998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036435540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25473",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "34 FRONT ST",
    "dropdelcty": "EXETER",
    "dropdelst": "NH",
    "dropdelzpp": "038332782",
    "dropphyadd": "34 FRONT ST",
    "dropphycty": "EXETER",
    "dropphyst": "NH",
    "dropphyzpp": "038332782",
    "dropmaladd": "34 FRONT ST",
    "dropmalcty": "EXETER",
    "dropmalst": "NH",
    "dropmalzpp": "038332782",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037727894,
    "dropfax": 6037725981
  },
  {
    "dcode": "D",
    "dropkey": "PV25474",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "14 PLEASANT ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "NH",
    "dropdelzpp": "038359998",
    "dropphyadd": "14 PLEASANT ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "NH",
    "dropphyzpp": "038359998",
    "dropmaladd": "14 PLEASANT ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "NH",
    "dropmalzpp": "038359998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037552121,
    "dropfax": 6037552729
  },
  {
    "dcode": "D",
    "dropkey": "PV25475",
    "droptype": "D",
    "dropname": "FITZWILLIAM",
    "dropdeladd": "30 NH ROUTE 12 S",
    "dropdelcty": "FITZWILLIAM",
    "dropdelst": "NH",
    "dropdelzpp": "034479998",
    "dropphyadd": "30 NH ROUTE 12 S",
    "dropphycty": "FITZWILLIAM",
    "dropphyst": "NH",
    "dropphyzpp": "034479998",
    "dropmaladd": "30 NH ROUTE 12 S",
    "dropmalcty": "FITZWILLIAM",
    "dropmalst": "NH",
    "dropmalzpp": "034479998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035857731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25476",
    "droptype": "D",
    "dropname": "FRANCESTOWN",
    "dropdeladd": "158 2ND NH TPKE S",
    "dropdelcty": "FRANCESTOWN",
    "dropdelst": "NH",
    "dropdelzpp": "030439998",
    "dropphyadd": "158 2ND NH TPKE S",
    "dropphycty": "FRANCESTOWN",
    "dropphyst": "NH",
    "dropphyzpp": "030439998",
    "dropmaladd": "158 2ND NH TPKE S",
    "dropmalcty": "FRANCESTOWN",
    "dropmalst": "NH",
    "dropmalzpp": "030439998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035472958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25477",
    "droptype": "D",
    "dropname": "FRANCONIA",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "FRANCONIA",
    "dropdelst": "NH",
    "dropdelzpp": "035809998",
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "FRANCONIA",
    "dropphyst": "NH",
    "dropphyzpp": "035809998",
    "dropmaladd": "308 MAIN ST",
    "dropmalcty": "FRANCONIA",
    "dropmalst": "NH",
    "dropmalzpp": "035809998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038235611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25478",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "65 FRANKLIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NH",
    "dropdelzpp": "032351606",
    "dropphyadd": "65 FRANKLIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NH",
    "dropphyzpp": "032351606",
    "dropmaladd": "65 FRANKLIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NH",
    "dropmalzpp": "032351606",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039343209,
    "dropfax": 6039343455
  },
  {
    "dcode": "D",
    "dropkey": "PV25479",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "19 ELM ST UNIT 2",
    "dropdelcty": "FREEDOM",
    "dropdelst": "NH",
    "dropdelzpp": "038369998",
    "dropphyadd": "19 ELM ST UNIT 2",
    "dropphycty": "FREEDOM",
    "dropphyst": "NH",
    "dropphyzpp": "038369998",
    "dropmaladd": "19 ELM ST UNIT 2",
    "dropmalcty": "FREEDOM",
    "dropmalst": "NH",
    "dropmalzpp": "038369998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035397348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25480",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "51 BEEDE HILL RD",
    "dropdelcty": "FREMONT",
    "dropdelst": "NH",
    "dropdelzpp": "030449998",
    "dropphyadd": "51 BEEDE HILL RD",
    "dropphycty": "FREMONT",
    "dropphyst": "NH",
    "dropphyzpp": "030449998",
    "dropmaladd": "51 BEEDE HILL RD",
    "dropmalcty": "FREMONT",
    "dropmalst": "NH",
    "dropmalzpp": "030449998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038952094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25481",
    "droptype": "D",
    "dropname": "GEORGES MILLS",
    "dropdeladd": "1294 ROUTE 11",
    "dropdelcty": "GEORGES MILLS",
    "dropdelst": "NH",
    "dropdelzpp": "037519998",
    "dropphyadd": "1294 ROUTE 11",
    "dropphycty": "GEORGES MILLS",
    "dropphyst": "NH",
    "dropphyzpp": "037519998",
    "dropmaladd": "1294 ROUTE 11",
    "dropmalcty": "GEORGES MILLS",
    "dropmalst": "NH",
    "dropmalzpp": "037519998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037634094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25483",
    "droptype": "D",
    "dropname": "GILMANTON",
    "dropdeladd": "365 NH ROUTE 140",
    "dropdelcty": "GILMANTON",
    "dropdelst": "NH",
    "dropdelzpp": "032379998",
    "dropphyadd": "365 NH ROUTE 140",
    "dropphycty": "GILMANTON",
    "dropphyst": "NH",
    "dropphyzpp": "032379998",
    "dropmaladd": "365 NH ROUTE 140",
    "dropmalcty": "GILMANTON",
    "dropmalst": "NH",
    "dropmalzpp": "032379998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032678545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25485",
    "droptype": "D",
    "dropname": "GILMANTON IRON WORKS",
    "dropdeladd": "5 ELM ST",
    "dropdelcty": "GILMANTON IRON WORKS",
    "dropdelst": "NH",
    "dropdelzpp": "038379998",
    "dropphyadd": "5 ELM ST",
    "dropphycty": "GILMANTON IRON WORKS",
    "dropphyst": "NH",
    "dropphyzpp": "038379998",
    "dropmaladd": "5 ELM ST",
    "dropmalcty": "GILMANTON IRON WORKS",
    "dropmalst": "NH",
    "dropmalzpp": "038379998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072471563,
    "dropsitcph": 6072471563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25487",
    "droptype": "D",
    "dropname": "GILSUM",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "GILSUM",
    "dropdelst": "NH",
    "dropdelzpp": "034489998",
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "GILSUM",
    "dropphyst": "NH",
    "dropphyzpp": "034489998",
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "GILSUM",
    "dropmalst": "NH",
    "dropmalzpp": "034489998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033526949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25489",
    "droptype": "D",
    "dropname": "GLEN",
    "dropdeladd": "69 US ROUTE 302 UNIT B",
    "dropdelcty": "GLEN",
    "dropdelst": "NH",
    "dropdelzpp": "038389998",
    "dropphyadd": "69 US ROUTE 302 UNIT B",
    "dropphycty": "GLEN",
    "dropphyst": "NH",
    "dropphyzpp": "038389998",
    "dropmaladd": "69 US ROUTE 302 UNIT B",
    "dropmalcty": "GLEN",
    "dropmalst": "NH",
    "dropmalzpp": "038389998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033839065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25490",
    "droptype": "D",
    "dropname": "GLENCLIFF",
    "dropdeladd": "1385 NH ROUTE 25 UNIT 1",
    "dropdelcty": "GLENCLIFF",
    "dropdelst": "NH",
    "dropdelzpp": "032389998",
    "dropphyadd": "1385 NH ROUTE 25 UNIT 1",
    "dropphycty": "GLENCLIFF",
    "dropphyst": "NH",
    "dropphyzpp": "032389998",
    "dropmaladd": "1385 NH ROUTE 25 UNIT 1",
    "dropmalcty": "GLENCLIFF",
    "dropmalst": "NH",
    "dropmalzpp": "032389998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039895154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25492",
    "droptype": "D",
    "dropname": "GOFFSTOWN",
    "dropdeladd": "11 CHURCH ST STE 1",
    "dropdelcty": "GOFFSTOWN",
    "dropdelst": "NH",
    "dropdelzpp": "030459998",
    "dropphyadd": "11 CHURCH ST STE 1",
    "dropphycty": "GOFFSTOWN",
    "dropphyst": "NH",
    "dropphyzpp": "030459998",
    "dropmaladd": "11 CHURCH ST STE 1",
    "dropmalcty": "GOFFSTOWN",
    "dropmalst": "NH",
    "dropmalzpp": "030459998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034979907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25494",
    "droptype": "D",
    "dropname": "GORHAM",
    "dropdeladd": "165 MAIN ST",
    "dropdelcty": "GORHAM",
    "dropdelst": "NH",
    "dropdelzpp": "035819998",
    "dropphyadd": "165 MAIN ST",
    "dropphycty": "GORHAM",
    "dropphyst": "NH",
    "dropphyzpp": "035819998",
    "dropmaladd": "165 MAIN ST",
    "dropmalcty": "GORHAM",
    "dropmalst": "NH",
    "dropmalzpp": "035819998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034662182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25495",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "19 MILL VILLAGE RD N",
    "dropdelcty": "GOSHEN",
    "dropdelst": "NH",
    "dropdelzpp": "037529998",
    "dropphyadd": "19 MILL VILLAGE RD N",
    "dropphycty": "GOSHEN",
    "dropphyst": "NH",
    "dropphyzpp": "037529998",
    "dropmaladd": "19 MILL VILLAGE RD N",
    "dropmalcty": "GOSHEN",
    "dropmalst": "NH",
    "dropmalzpp": "037529998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072583209,
    "dropsitcph": 6072583209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25496",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "564 MAIN ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "NH",
    "dropdelzpp": "032409998",
    "dropphyadd": "564 MAIN ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "NH",
    "dropphyzpp": "032409998",
    "dropmaladd": "564 MAIN ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "NH",
    "dropmalzpp": "032409998",
    "dropsitphn": 6036444128,
    "dropsitlph": 8382172925,
    "dropsitcph": 8382172925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25497",
    "droptype": "D",
    "dropname": "GRANTHAM",
    "dropdeladd": "10 WILLIS AVE",
    "dropdelcty": "GRANTHAM",
    "dropdelst": "NH",
    "dropdelzpp": "037539998",
    "dropphyadd": "10 WILLIS AVE",
    "dropphycty": "GRANTHAM",
    "dropphyst": "NH",
    "dropphyzpp": "037539998",
    "dropmaladd": "10 WILLIS AVE",
    "dropmalcty": "GRANTHAM",
    "dropmalst": "NH",
    "dropmalzpp": "037539998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038632280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25498",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "75 SLIP RD",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "030479998",
    "dropphyadd": "75 SLIP RD",
    "dropphycty": "GREENFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "030479998",
    "dropmaladd": "75 SLIP RD",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "030479998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036990084,
    "dropsitcph": 6036990084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25499",
    "droptype": "D",
    "dropname": "GREENLAND",
    "dropdeladd": "609 PORTSMOUTH AVE",
    "dropdelcty": "GREENLAND",
    "dropdelst": "NH",
    "dropdelzpp": "038409998",
    "dropphyadd": "609 PORTSMOUTH AVE",
    "dropphycty": "GREENLAND",
    "dropphyst": "NH",
    "dropphyzpp": "038409998",
    "dropmaladd": "609 PORTSMOUTH AVE",
    "dropmalcty": "GREENLAND",
    "dropmalst": "NH",
    "dropmalzpp": "038409998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6034367174,
    "dropsitcph": 6034367098,
    "dropfax": 6034366003
  },
  {
    "dcode": "D",
    "dropkey": "PV25501",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "NH",
    "dropdelzpp": "030489998",
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "NH",
    "dropphyzpp": "030489998",
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "NH",
    "dropmalzpp": "030489998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 9783868015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25504",
    "droptype": "D",
    "dropname": "GROVETON",
    "dropdeladd": "59 CHURCH ST",
    "dropdelcty": "GROVETON",
    "dropdelst": "NH",
    "dropdelzpp": "035824224",
    "dropphyadd": "59 CHURCH ST",
    "dropphycty": "GROVETON",
    "dropphyst": "NH",
    "dropphyzpp": "035824224",
    "dropmaladd": "59 CHURCH ST",
    "dropmalcty": "GROVETON",
    "dropmalst": "NH",
    "dropmalzpp": "035824224",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036361610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25505",
    "droptype": "D",
    "dropname": "GUILD",
    "dropdeladd": "16 HALE ST",
    "dropdelcty": "GUILD",
    "dropdelst": "NH",
    "dropdelzpp": "037549998",
    "dropphyadd": "16 HALE ST",
    "dropphycty": "GUILD",
    "dropphyst": "NH",
    "dropphyzpp": "037549998",
    "dropmaladd": "16 HALE ST",
    "dropmalcty": "GUILD",
    "dropmalst": "NH",
    "dropmalzpp": "037549998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038635527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25506",
    "droptype": "D",
    "dropname": "HAMPSTEAD",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "HAMPSTEAD",
    "dropdelst": "NH",
    "dropdelzpp": "038419998",
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "HAMPSTEAD",
    "dropphyst": "NH",
    "dropphyzpp": "038419998",
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "HAMPSTEAD",
    "dropmalst": "NH",
    "dropmalzpp": "038419998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033295819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25507",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "25 STICKNEY TER",
    "dropdelcty": "HAMPTON",
    "dropdelst": "NH",
    "dropdelzpp": "038421963",
    "dropphyadd": "25 STICKNEY TER",
    "dropphycty": "HAMPTON",
    "dropphyst": "NH",
    "dropphyzpp": "038421963",
    "dropmaladd": "25 STICKNEY TER",
    "dropmalcty": "HAMPTON",
    "dropmalst": "NH",
    "dropmalzpp": "038421963",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039266413,
    "dropfax": 6039294109
  },
  {
    "dcode": "D",
    "dropkey": "PV25510",
    "droptype": "D",
    "dropname": "HAMPTON FALLS",
    "dropdeladd": "2 EXETER RD",
    "dropdelcty": "HAMPTON FALLS",
    "dropdelst": "NH",
    "dropdelzpp": "038442044",
    "dropphyadd": "2 EXETER RD",
    "dropphycty": "HAMPTON FALLS",
    "dropphyst": "NH",
    "dropphyzpp": "038442044",
    "dropmaladd": "2 EXETER RD",
    "dropmalcty": "HAMPTON FALLS",
    "dropmalst": "NH",
    "dropmalzpp": "038442044",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039266537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25511",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "59 MAIN ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "NH",
    "dropdelzpp": "034499998",
    "dropphyadd": "59 MAIN ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "NH",
    "dropphyzpp": "034499998",
    "dropmaladd": "59 MAIN ST",
    "dropmalcty": "HANCOCK",
    "dropmalst": "NH",
    "dropmalzpp": "034499998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035256669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25512",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "50 S MAIN ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "NH",
    "dropdelzpp": "037552066",
    "dropphyadd": "50 S MAIN ST",
    "dropphycty": "HANOVER",
    "dropphyst": "NH",
    "dropphyzpp": "037552066",
    "dropmaladd": "50 S MAIN ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "NH",
    "dropmalzpp": "037552066",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036435201,
    "dropfax": 6036436324
  },
  {
    "dcode": "D",
    "dropkey": "PV25514",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "29 CHURCH ST SIDE",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "NH",
    "dropdelzpp": "034509998",
    "dropphyadd": "29 CHURCH ST SIDE",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "NH",
    "dropphyzpp": "034509998",
    "dropmaladd": "29 CHURCH ST SIDE",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "NH",
    "dropmalzpp": "034509998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038273345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25516",
    "droptype": "D",
    "dropname": "HAVERHILL",
    "dropdeladd": "630 DARTMOUTH COLLEGE HWY",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "NH",
    "dropdelzpp": "037659998",
    "dropphyadd": "630 DARTMOUTH COLLEGE HWY",
    "dropphycty": "HAVERHILL",
    "dropphyst": "NH",
    "dropphyzpp": "037659998",
    "dropmaladd": "630 DARTMOUTH COLLEGE HWY",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "NH",
    "dropmalzpp": "037659998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039895811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25517",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "7 N SHORE RD UNIT 2",
    "dropdelcty": "HEBRON",
    "dropdelst": "NH",
    "dropdelzpp": "032419998",
    "dropphyadd": "7 N SHORE RD UNIT 2",
    "dropphycty": "HEBRON",
    "dropphyst": "NH",
    "dropphyzpp": "032419998",
    "dropmaladd": "7 N SHORE RD UNIT 2",
    "dropmalcty": "HEBRON",
    "dropmalst": "NH",
    "dropmalzpp": "032419998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037442394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25518",
    "droptype": "D",
    "dropname": "HENNIKER",
    "dropdeladd": "10 POST OFFICE PL",
    "dropdelcty": "HENNIKER",
    "dropdelst": "NH",
    "dropdelzpp": "032429998",
    "dropphyadd": "10 POST OFFICE PL",
    "dropphycty": "HENNIKER",
    "dropphyst": "NH",
    "dropphyzpp": "032429998",
    "dropmaladd": "10 POST OFFICE PL",
    "dropmalcty": "HENNIKER",
    "dropmalst": "NH",
    "dropmalzpp": "032429998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034283285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25519",
    "droptype": "D",
    "dropname": "HILL",
    "dropdeladd": "20 COMMERCE ST",
    "dropdelcty": "HILL",
    "dropdelst": "NH",
    "dropdelzpp": "032439998",
    "dropphyadd": "20 COMMERCE ST",
    "dropphycty": "HILL",
    "dropphyst": "NH",
    "dropphyzpp": "032439998",
    "dropmaladd": "20 COMMERCE ST",
    "dropmalcty": "HILL",
    "dropmalst": "NH",
    "dropmalzpp": "032439998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039344940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25520",
    "droptype": "D",
    "dropname": "HILLSBOROUGH",
    "dropdeladd": "11 CENTRAL ST",
    "dropdelcty": "HILLSBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "032449998",
    "dropphyadd": "11 CENTRAL ST",
    "dropphycty": "HILLSBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "032449998",
    "dropmaladd": "11 CENTRAL ST",
    "dropmalcty": "HILLSBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "032449998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034643900,
    "dropfax": 6034640251
  },
  {
    "dcode": "D",
    "dropkey": "PV25522",
    "droptype": "D",
    "dropname": "HINSDALE",
    "dropdeladd": "13 MAIN ST",
    "dropdelcty": "HINSDALE",
    "dropdelst": "NH",
    "dropdelzpp": "034519998",
    "dropphyadd": "13 MAIN ST",
    "dropphycty": "HINSDALE",
    "dropphyst": "NH",
    "dropphyzpp": "034519998",
    "dropmaladd": "13 MAIN ST",
    "dropmalcty": "HINSDALE",
    "dropmalst": "NH",
    "dropmalzpp": "034519998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033365544,
    "dropfax": 6033365580
  },
  {
    "dcode": "D",
    "dropkey": "PV25523",
    "droptype": "D",
    "dropname": "HOLDERNESS",
    "dropdeladd": "846 US ROUTE 3",
    "dropdelcty": "HOLDERNESS",
    "dropdelst": "NH",
    "dropdelzpp": "032459998",
    "dropphyadd": "846 US ROUTE 3",
    "dropphycty": "HOLDERNESS",
    "dropphyst": "NH",
    "dropphyzpp": "032459998",
    "dropmaladd": "846 US ROUTE 3",
    "dropmalcty": "HOLDERNESS",
    "dropmalst": "NH",
    "dropmalzpp": "032459998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039687173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25524",
    "droptype": "D",
    "dropname": "HOLLIS",
    "dropdeladd": "5 HUTCHINGS DR STE 100",
    "dropdelcty": "HOLLIS",
    "dropdelst": "NH",
    "dropdelzpp": "030499998",
    "dropphyadd": "5 HUTCHINGS DR STE 100",
    "dropphycty": "HOLLIS",
    "dropphyst": "NH",
    "dropphyzpp": "030499998",
    "dropmaladd": "5 HUTCHINGS DR STE 100",
    "dropmalcty": "HOLLIS",
    "dropmalst": "NH",
    "dropmalzpp": "030499998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034659030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25527",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "35 EXECUTIVE DR",
    "dropdelcty": "HUDSON",
    "dropdelst": "NH",
    "dropdelzpp": "030519997",
    "dropphyadd": "35 EXECUTIVE DR",
    "dropphycty": "HUDSON",
    "dropphyst": "NH",
    "dropphyzpp": "030519997",
    "dropmaladd": "35 EXECUTIVE DR",
    "dropmalcty": "HUDSON",
    "dropmalst": "NH",
    "dropmalzpp": "030519997",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038813795,
    "dropfax": 6038827154
  },
  {
    "dcode": "D",
    "dropkey": "PV25528",
    "droptype": "D",
    "dropname": "INTERVALE",
    "dropdeladd": "99 INTERVALE CROSS RD",
    "dropdelcty": "INTERVALE",
    "dropdelst": "NH",
    "dropdelzpp": "038459998",
    "dropphyadd": "99 INTERVALE CROSS RD",
    "dropphycty": "INTERVALE",
    "dropphyst": "NH",
    "dropphyzpp": "038459998",
    "dropmaladd": "99 INTERVALE CROSS RD",
    "dropmalcty": "INTERVALE",
    "dropmalst": "NH",
    "dropmalzpp": "038459998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033562315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25529",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "20 BLACK MOUNTAIN RD",
    "dropdelcty": "JACKSON",
    "dropdelst": "NH",
    "dropdelzpp": "038469998",
    "dropphyadd": "20 BLACK MOUNTAIN RD",
    "dropphycty": "JACKSON",
    "dropphyst": "NH",
    "dropphyzpp": "038469998",
    "dropmaladd": "20 BLACK MOUNTAIN RD",
    "dropmalcty": "JACKSON",
    "dropmalst": "NH",
    "dropmalzpp": "038469998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033836868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25530",
    "droptype": "D",
    "dropname": "JAFFREY",
    "dropdeladd": "30 TURNPIKE RD",
    "dropdelcty": "JAFFREY",
    "dropdelst": "NH",
    "dropdelzpp": "034529998",
    "dropphyadd": "30 TURNPIKE RD",
    "dropphycty": "JAFFREY",
    "dropphyst": "NH",
    "dropphyzpp": "034529998",
    "dropmaladd": "30 TURNPIKE RD",
    "dropmalcty": "JAFFREY",
    "dropmalst": "NH",
    "dropmalzpp": "034529998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035328281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25531",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "736 PRESIDENTIAL HWY",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "NH",
    "dropdelzpp": "035839998",
    "dropphyadd": "736 PRESIDENTIAL HWY",
    "dropphycty": "JEFFERSON",
    "dropphyst": "NH",
    "dropphyzpp": "035839998",
    "dropmaladd": "736 PRESIDENTIAL HWY",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "NH",
    "dropmalzpp": "035839998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035864330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25533",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "196 MAIN ST",
    "dropdelcty": "KEENE",
    "dropdelst": "NH",
    "dropdelzpp": "034319998",
    "dropphyadd": "196 MAIN ST",
    "dropphycty": "KEENE",
    "dropphyst": "NH",
    "dropphyzpp": "034319998",
    "dropmaladd": "196 MAIN ST",
    "dropmalcty": "KEENE",
    "dropmalst": "NH",
    "dropmalzpp": "034319998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033575610,
    "dropfax": 6033572574
  },
  {
    "dcode": "D",
    "dropkey": "PV25537",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "53 CHURCH ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "NH",
    "dropdelzpp": "038489998",
    "dropphyadd": "53 CHURCH ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "NH",
    "dropphyzpp": "038489998",
    "dropmaladd": "53 CHURCH ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "NH",
    "dropmalzpp": "038489998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036424028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25538",
    "droptype": "D",
    "dropname": "LACONIA",
    "dropdeladd": "33 CHURCH ST",
    "dropdelcty": "LACONIA",
    "dropdelst": "NH",
    "dropdelzpp": "032463471",
    "dropphyadd": "33 CHURCH ST",
    "dropphycty": "LACONIA",
    "dropphyst": "NH",
    "dropphyzpp": "032463471",
    "dropmaladd": "33 CHURCH ST",
    "dropmalcty": "LACONIA",
    "dropmalst": "NH",
    "dropmalzpp": "032463471",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035246271,
    "dropfax": 6035244710
  },
  {
    "dcode": "D",
    "dropkey": "PV25541",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "NH",
    "dropdelzpp": "035849998",
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "NH",
    "dropphyzpp": "035849998",
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "NH",
    "dropmalzpp": "035849998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037884612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25545",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "11 E PARK ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "NH",
    "dropdelzpp": "037661355",
    "dropphyadd": "11 E PARK ST",
    "dropphycty": "LEBANON",
    "dropphyst": "NH",
    "dropphyzpp": "037661355",
    "dropmaladd": "11 E PARK ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "NH",
    "dropmalzpp": "037661355",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034482348,
    "dropfax": 6034482482
  },
  {
    "dcode": "D",
    "dropkey": "PV25550",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "10 LUMBER YARD DR UNIT 9",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NH",
    "dropdelzpp": "032519998",
    "dropphyadd": "10 LUMBER YARD DR UNIT 9",
    "dropphycty": "LINCOLN",
    "dropphyst": "NH",
    "dropphyzpp": "032519998",
    "dropmaladd": "10 LUMBER YARD DR UNIT 9",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NH",
    "dropmalzpp": "032519998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037458133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25551",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "80 N MAIN ST",
    "dropdelcty": "LISBON",
    "dropdelst": "NH",
    "dropdelzpp": "035859998",
    "dropphyadd": "80 N MAIN ST",
    "dropphycty": "LISBON",
    "dropphyst": "NH",
    "dropphyzpp": "035859998",
    "dropmaladd": "80 N MAIN ST",
    "dropmalcty": "LISBON",
    "dropmalst": "NH",
    "dropmalzpp": "035859998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6038382881,
    "dropsitcph": 6038382881,
    "dropfax": 6038382881
  },
  {
    "dcode": "D",
    "dropkey": "PV25554",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "134 MAIN ST STE 100",
    "dropdelcty": "LITTLETON",
    "dropdelst": "NH",
    "dropdelzpp": "035619998",
    "dropphyadd": "134 MAIN ST STE 100",
    "dropphycty": "LITTLETON",
    "dropphyst": "NH",
    "dropphyzpp": "035619998",
    "dropmaladd": "134 MAIN ST STE 100",
    "dropmalcty": "LITTLETON",
    "dropmalst": "NH",
    "dropmalzpp": "035619998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034447787,
    "dropfax": 6034449956
  },
  {
    "dcode": "D",
    "dropkey": "PV25555",
    "droptype": "D",
    "dropname": "LOCHMERE",
    "dropdeladd": "60 SILVER LAKE RD",
    "dropdelcty": "LOCHMERE",
    "dropdelst": "NH",
    "dropdelzpp": "032529998",
    "dropphyadd": "60 SILVER LAKE RD",
    "dropphycty": "LOCHMERE",
    "dropphyst": "NH",
    "dropphyzpp": "032529998",
    "dropmaladd": "60 SILVER LAKE RD",
    "dropmalcty": "LOCHMERE",
    "dropmalst": "NH",
    "dropmalzpp": "032529998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035244723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25556",
    "droptype": "D",
    "dropname": "LONDONDERRY",
    "dropdeladd": "86 NASHUA RD",
    "dropdelcty": "LONDONDERRY",
    "dropdelst": "NH",
    "dropdelzpp": "030539998",
    "dropphyadd": "86 NASHUA RD",
    "dropphycty": "LONDONDERRY",
    "dropphyst": "NH",
    "dropphyzpp": "030539998",
    "dropmaladd": "86 NASHUA RD",
    "dropmalcty": "LONDONDERRY",
    "dropmalst": "NH",
    "dropmalzpp": "030539998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034327194,
    "dropfax": 6034372709
  },
  {
    "dcode": "D",
    "dropkey": "PV25562",
    "droptype": "D",
    "dropname": "LYME",
    "dropdeladd": "5 MAIN ST UNIT 5",
    "dropdelcty": "LYME",
    "dropdelst": "NH",
    "dropdelzpp": "037689998",
    "dropphyadd": "5 MAIN ST UNIT 5",
    "dropphycty": "LYME",
    "dropphyst": "NH",
    "dropphyzpp": "037689998",
    "dropmaladd": "5 MAIN ST UNIT 5",
    "dropmalcty": "LYME",
    "dropmalst": "NH",
    "dropmalzpp": "037689998",
    "dropsitphn": 6036444128,
    "dropsitlph": 5189927155,
    "dropsitcph": 5189927155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25563",
    "droptype": "D",
    "dropname": "LYME CENTER",
    "dropdeladd": "181 DORCHESTER RD UNIT 3",
    "dropdelcty": "LYME CENTER",
    "dropdelst": "NH",
    "dropdelzpp": "037699998",
    "dropphyadd": "181 DORCHESTER RD UNIT 3",
    "dropphycty": "LYME CENTER",
    "dropphyst": "NH",
    "dropphyzpp": "037699998",
    "dropmaladd": "181 DORCHESTER RD UNIT 3",
    "dropmalcty": "LYME CENTER",
    "dropmalst": "NH",
    "dropmalzpp": "037699998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072582283,
    "dropsitcph": 6072582283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25566",
    "droptype": "D",
    "dropname": "LYNDEBOROUGH",
    "dropdeladd": "36 FOREST RD",
    "dropdelcty": "LYNDEBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "030829998",
    "dropphyadd": "36 FOREST RD",
    "dropphycty": "LYNDEBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "030829998",
    "dropmaladd": "36 FOREST RD",
    "dropmalcty": "LYNDEBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "030829998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036546668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25568",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "1904 VILLAGE RD",
    "dropdelcty": "MADISON",
    "dropdelst": "NH",
    "dropdelzpp": "038499998",
    "dropphyadd": "1904 VILLAGE RD",
    "dropphycty": "MADISON",
    "dropphyst": "NH",
    "dropphyzpp": "038499998",
    "dropmaladd": "1904 VILLAGE RD",
    "dropmalcty": "MADISON",
    "dropmalst": "NH",
    "dropmalzpp": "038499998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033678880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25571",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "955 GOFFS FALLS RD STE 998",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "031039998",
    "dropphyadd": "955 GOFFS FALLS RD STE 998",
    "dropphycty": "MANCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "031039998",
    "dropmaladd": "955 GOFFS FALLS RD STE 998",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "031039998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036266885,
    "dropsitcph": 6036266887,
    "dropfax": 6036444122
  },
  {
    "dcode": "D",
    "dropkey": "PV25573",
    "droptype": "D",
    "dropname": "MARLBOROUGH",
    "dropdeladd": "136 MAIN ST",
    "dropdelcty": "MARLBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "034559998",
    "dropphyadd": "136 MAIN ST",
    "dropphycty": "MARLBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "034559998",
    "dropmaladd": "136 MAIN ST",
    "dropmalcty": "MARLBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "034559998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038764590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25574",
    "droptype": "D",
    "dropname": "MARLOW",
    "dropdeladd": "842 NH ROUTE 10",
    "dropdelcty": "MARLOW",
    "dropdelst": "NH",
    "dropdelzpp": "034569998",
    "dropphyadd": "842 NH ROUTE 10",
    "dropphycty": "MARLOW",
    "dropphyst": "NH",
    "dropphyzpp": "034569998",
    "dropmaladd": "842 NH ROUTE 10",
    "dropmalcty": "MARLOW",
    "dropmalst": "NH",
    "dropmalzpp": "034569998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034463489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25577",
    "droptype": "D",
    "dropname": "MELVIN VILLAGE",
    "dropdeladd": "448 GOVERNOR WENTWORTH HWY UNIT C",
    "dropdelcty": "MELVIN VILLAGE",
    "dropdelst": "NH",
    "dropdelzpp": "038509998",
    "dropphyadd": "448 GOVERNOR WENTWORTH HWY UNIT C",
    "dropphycty": "MELVIN VILLAGE",
    "dropphyst": "NH",
    "dropphyzpp": "038509998",
    "dropmaladd": "448 GOVERNOR WENTWORTH HWY UNIT C",
    "dropmalcty": "MELVIN VILLAGE",
    "dropmalst": "NH",
    "dropmalzpp": "038509998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035443393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25579",
    "droptype": "D",
    "dropname": "MEREDITH",
    "dropdeladd": "76 MAIN ST",
    "dropdelcty": "MEREDITH",
    "dropdelst": "NH",
    "dropdelzpp": "032539998",
    "dropphyadd": "76 MAIN ST",
    "dropphycty": "MEREDITH",
    "dropphyst": "NH",
    "dropphyzpp": "032539998",
    "dropmaladd": "76 MAIN ST",
    "dropmalcty": "MEREDITH",
    "dropmalst": "NH",
    "dropmalzpp": "032539998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032796242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25580",
    "droptype": "D",
    "dropname": "MERIDEN",
    "dropdeladd": "54 MAIN ST UNIT 1",
    "dropdelcty": "MERIDEN",
    "dropdelst": "NH",
    "dropdelzpp": "037709998",
    "dropphyadd": "54 MAIN ST UNIT 1",
    "dropphycty": "MERIDEN",
    "dropphyst": "NH",
    "dropphyzpp": "037709998",
    "dropmaladd": "54 MAIN ST UNIT 1",
    "dropmalcty": "MERIDEN",
    "dropmalst": "NH",
    "dropmalzpp": "037709998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6034693265,
    "dropsitcph": 6034693265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25581",
    "droptype": "D",
    "dropname": "MERRIMACK",
    "dropdeladd": "510 DANIEL WEBSTER HWY",
    "dropdelcty": "MERRIMACK",
    "dropdelst": "NH",
    "dropdelzpp": "030549998",
    "dropphyadd": "510 DANIEL WEBSTER HWY",
    "dropphycty": "MERRIMACK",
    "dropphyst": "NH",
    "dropphyzpp": "030549998",
    "dropmaladd": "510 DANIEL WEBSTER HWY",
    "dropmalcty": "MERRIMACK",
    "dropmalst": "NH",
    "dropmalzpp": "030549998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034249405,
    "dropfax": 6034242672
  },
  {
    "dcode": "D",
    "dropkey": "PV25583",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "19 BRIDGE ST",
    "dropdelcty": "MILAN",
    "dropdelst": "NH",
    "dropdelzpp": "035889998",
    "dropphyadd": "19 BRIDGE ST",
    "dropphycty": "MILAN",
    "dropphyst": "NH",
    "dropphyzpp": "035889998",
    "dropmaladd": "19 BRIDGE ST",
    "dropmalcty": "MILAN",
    "dropmalst": "NH",
    "dropmalzpp": "035889998",
    "dropsitphn": 6036444128,
    "dropsitlph": 3152033648,
    "dropsitcph": 3152033648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25584",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "12 MONT VERNON ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "NH",
    "dropdelzpp": "030559998",
    "dropphyadd": "12 MONT VERNON ST",
    "dropphycty": "MILFORD",
    "dropphyst": "NH",
    "dropphyzpp": "030559998",
    "dropmaladd": "12 MONT VERNON ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "NH",
    "dropmalzpp": "030559998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036734526,
    "dropfax": 6036725235
  },
  {
    "dcode": "D",
    "dropkey": "PV25587",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "851 WHITE MOUNTAIN HWY",
    "dropdelcty": "MILTON",
    "dropdelst": "NH",
    "dropdelzpp": "038514667",
    "dropphyadd": "851 WHITE MOUNTAIN HWY",
    "dropphycty": "MILTON",
    "dropphyst": "NH",
    "dropphyzpp": "038514667",
    "dropmaladd": "851 WHITE MOUNTAIN HWY",
    "dropmalcty": "MILTON",
    "dropmalst": "NH",
    "dropmalzpp": "038514667",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038503236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25588",
    "droptype": "D",
    "dropname": "MILTON MILLS",
    "dropdeladd": "70 MAIN ST",
    "dropdelcty": "MILTON MILLS",
    "dropdelst": "NH",
    "dropdelzpp": "038529998",
    "dropphyadd": "70 MAIN ST",
    "dropphycty": "MILTON MILLS",
    "dropphyst": "NH",
    "dropphyzpp": "038529998",
    "dropmaladd": "70 MAIN ST",
    "dropmalcty": "MILTON MILLS",
    "dropmalst": "NH",
    "dropmalzpp": "038529998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034732708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25589",
    "droptype": "D",
    "dropname": "MIRROR LAKE",
    "dropdeladd": "36 TUFTONBORO NECK RD",
    "dropdelcty": "MIRROR LAKE",
    "dropdelst": "NH",
    "dropdelzpp": "038539998",
    "dropphyadd": "36 TUFTONBORO NECK RD",
    "dropphycty": "MIRROR LAKE",
    "dropphyst": "NH",
    "dropphyzpp": "038539998",
    "dropmaladd": "36 TUFTONBORO NECK RD",
    "dropmalcty": "MIRROR LAKE",
    "dropmalst": "NH",
    "dropmalzpp": "038539998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6035694911,
    "dropsitcph": 6035694911,
    "dropfax": 6036444174
  },
  {
    "dcode": "D",
    "dropkey": "PV25590",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "89 MAIN ST",
    "dropdelcty": "MONROE",
    "dropdelst": "NH",
    "dropdelzpp": "037719998",
    "dropphyadd": "89 MAIN ST",
    "dropphycty": "MONROE",
    "dropphyst": "NH",
    "dropphyzpp": "037719998",
    "dropmaladd": "89 MAIN ST",
    "dropmalcty": "MONROE",
    "dropmalst": "NH",
    "dropmalzpp": "037719998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036384729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25591",
    "droptype": "D",
    "dropname": "MONT VERNON",
    "dropdeladd": "4 GRAND HILL RD",
    "dropdelcty": "MONT VERNON",
    "dropdelst": "NH",
    "dropdelzpp": "030579998",
    "dropphyadd": "4 GRAND HILL RD",
    "dropphycty": "MONT VERNON",
    "dropphyst": "NH",
    "dropphyzpp": "030579998",
    "dropmaladd": "4 GRAND HILL RD",
    "dropmalcty": "MONT VERNON",
    "dropmalst": "NH",
    "dropmalzpp": "030579998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036732587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25593",
    "droptype": "D",
    "dropname": "MOULTONBOROUGH",
    "dropdeladd": "995 WHITTIER HWY",
    "dropdelcty": "MOULTONBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "032549998",
    "dropphyadd": "995 WHITTIER HWY",
    "dropphycty": "MOULTONBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "032549998",
    "dropmaladd": "995 WHITTIER HWY",
    "dropmalcty": "MOULTONBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "032549998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034765663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25611",
    "droptype": "D",
    "dropname": "NASHUA",
    "dropdeladd": "38 SPRING ST",
    "dropdelcty": "NASHUA",
    "dropdelst": "NH",
    "dropdelzpp": "030609998",
    "dropphyadd": "38 SPRING ST",
    "dropphycty": "NASHUA",
    "dropphyst": "NH",
    "dropphyzpp": "030609998",
    "dropmaladd": "38 SPRING ST",
    "dropmalcty": "NASHUA",
    "dropmalst": "NH",
    "dropmalzpp": "030609998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6038823258,
    "dropsitcph": 6038827515,
    "dropfax": 6038823519
  },
  {
    "dcode": "D",
    "dropkey": "PV25616",
    "droptype": "D",
    "dropname": "NEW BOSTON",
    "dropdeladd": "71 MONT VERNON RD",
    "dropdelcty": "NEW BOSTON",
    "dropdelst": "NH",
    "dropdelzpp": "030709998",
    "dropphyadd": "71 MONT VERNON RD",
    "dropphycty": "NEW BOSTON",
    "dropphyst": "NH",
    "dropphyzpp": "030709998",
    "dropmaladd": "71 MONT VERNON RD",
    "dropmalcty": "NEW BOSTON",
    "dropmalst": "NH",
    "dropmalzpp": "030709998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034872245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25617",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "73 MAIN ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "NH",
    "dropdelzpp": "038549998",
    "dropphyadd": "73 MAIN ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "NH",
    "dropphyzpp": "038549998",
    "dropmaladd": "73 MAIN ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "NH",
    "dropmalzpp": "038549998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034363485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25618",
    "droptype": "D",
    "dropname": "NEW DURHAM",
    "dropdeladd": "7 DEPOT RD STE 1",
    "dropdelcty": "NEW DURHAM",
    "dropdelst": "NH",
    "dropdelzpp": "038559998",
    "dropphyadd": "7 DEPOT RD STE 1",
    "dropphycty": "NEW DURHAM",
    "dropphyst": "NH",
    "dropphyzpp": "038559998",
    "dropmaladd": "7 DEPOT RD STE 1",
    "dropmalcty": "NEW DURHAM",
    "dropmalst": "NH",
    "dropmalzpp": "038559998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038595200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25619",
    "droptype": "D",
    "dropname": "NEW HAMPTON",
    "dropdeladd": "15 NH ROUTE 132 N",
    "dropdelcty": "NEW HAMPTON",
    "dropdelst": "NH",
    "dropdelzpp": "032569998",
    "dropphyadd": "15 NH ROUTE 132 N",
    "dropphycty": "NEW HAMPTON",
    "dropphyst": "NH",
    "dropphyzpp": "032569998",
    "dropmaladd": "15 NH ROUTE 132 N",
    "dropmalcty": "NEW HAMPTON",
    "dropmalst": "NH",
    "dropmalzpp": "032569998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037442108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25620",
    "droptype": "D",
    "dropname": "NEW IPSWICH",
    "dropdeladd": "802 TURNPIKE RD",
    "dropdelcty": "NEW IPSWICH",
    "dropdelst": "NH",
    "dropdelzpp": "030719998",
    "dropphyadd": "802 TURNPIKE RD",
    "dropphycty": "NEW IPSWICH",
    "dropphyst": "NH",
    "dropphyzpp": "030719998",
    "dropmaladd": "802 TURNPIKE RD",
    "dropmalcty": "NEW IPSWICH",
    "dropmalst": "NH",
    "dropmalzpp": "030719998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 8779317870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25621",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "319 NEWPORT RD",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "NH",
    "dropdelzpp": "032579998",
    "dropphyadd": "319 NEWPORT RD",
    "dropphycty": "NEW LONDON",
    "dropphyst": "NH",
    "dropphyzpp": "032579998",
    "dropmaladd": "319 NEWPORT RD",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "NH",
    "dropmalzpp": "032579998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035264641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25622",
    "droptype": "D",
    "dropname": "NEWBURY",
    "dropdeladd": "976 ROUTE 103",
    "dropdelcty": "NEWBURY",
    "dropdelst": "NH",
    "dropdelzpp": "032559998",
    "dropphyadd": "976 ROUTE 103",
    "dropphycty": "NEWBURY",
    "dropphyst": "NH",
    "dropphyzpp": "032559998",
    "dropmaladd": "976 ROUTE 103",
    "dropmalcty": "NEWBURY",
    "dropmalst": "NH",
    "dropmalzpp": "032559998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072583102,
    "dropsitcph": 6072583102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25623",
    "droptype": "D",
    "dropname": "NEWFIELDS",
    "dropdeladd": "6 MAIN ST",
    "dropdelcty": "NEWFIELDS",
    "dropdelst": "NH",
    "dropdelzpp": "038569998",
    "dropphyadd": "6 MAIN ST",
    "dropphycty": "NEWFIELDS",
    "dropphyst": "NH",
    "dropphyzpp": "038569998",
    "dropmaladd": "6 MAIN ST",
    "dropmalcty": "NEWFIELDS",
    "dropmalst": "NH",
    "dropmalzpp": "038569998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037728147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25625",
    "droptype": "D",
    "dropname": "NEWMARKET",
    "dropdeladd": "126 MAIN ST",
    "dropdelcty": "NEWMARKET",
    "dropdelst": "NH",
    "dropdelzpp": "038571643",
    "dropphyadd": "126 MAIN ST",
    "dropphycty": "NEWMARKET",
    "dropphyst": "NH",
    "dropphyzpp": "038571643",
    "dropmaladd": "126 MAIN ST",
    "dropmalcty": "NEWMARKET",
    "dropmalst": "NH",
    "dropmalzpp": "038571643",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036598549,
    "dropfax": 6036597766
  },
  {
    "dcode": "D",
    "dropkey": "PV25626",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "15 PARK ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "NH",
    "dropdelzpp": "037731712",
    "dropphyadd": "15 PARK ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "NH",
    "dropphyzpp": "037731712",
    "dropmaladd": "15 PARK ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "NH",
    "dropmalzpp": "037731712",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038633600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25627",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "77 S MAIN ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "NH",
    "dropdelzpp": "038583723",
    "dropphyadd": "77 S MAIN ST",
    "dropphycty": "NEWTON",
    "dropphyst": "NH",
    "dropphyzpp": "038583723",
    "dropmaladd": "77 S MAIN ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "NH",
    "dropmalzpp": "038583723",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033829028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25629",
    "droptype": "D",
    "dropname": "NEWTON JUNCTION",
    "dropdeladd": "9 W MAIN ST",
    "dropdelcty": "NEWTON JUNCTION",
    "dropdelst": "NH",
    "dropdelzpp": "038599998",
    "dropphyadd": "9 W MAIN ST",
    "dropphycty": "NEWTON JUNCTION",
    "dropphyst": "NH",
    "dropphyzpp": "038599998",
    "dropmaladd": "9 W MAIN ST",
    "dropmalcty": "NEWTON JUNCTION",
    "dropmalst": "NH",
    "dropmalzpp": "038599998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033829408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25642",
    "droptype": "D",
    "dropname": "NORTH CONWAY",
    "dropdeladd": "78 GROVE ST",
    "dropdelcty": "NORTH CONWAY",
    "dropdelst": "NH",
    "dropdelzpp": "038609998",
    "dropphyadd": "78 GROVE ST",
    "dropphycty": "NORTH CONWAY",
    "dropphyst": "NH",
    "dropphyzpp": "038609998",
    "dropmaladd": "78 GROVE ST",
    "dropmalcty": "NORTH CONWAY",
    "dropmalst": "NH",
    "dropmalzpp": "038609998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033562293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25643",
    "droptype": "D",
    "dropname": "NORTH HAMPTON",
    "dropdeladd": "44 LAFAYETTE RD",
    "dropdelcty": "NORTH HAMPTON",
    "dropdelst": "NH",
    "dropdelzpp": "038629998",
    "dropphyadd": "44 LAFAYETTE RD",
    "dropphycty": "NORTH HAMPTON",
    "dropphyst": "NH",
    "dropphyzpp": "038629998",
    "dropmaladd": "44 LAFAYETTE RD",
    "dropmalcty": "NORTH HAMPTON",
    "dropmalst": "NH",
    "dropmalzpp": "038629998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039646257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25644",
    "droptype": "D",
    "dropname": "NORTH HAVERHILL",
    "dropdeladd": "2730 DARTMOUTH COLLEGE HWY",
    "dropdelcty": "NORTH HAVERHILL",
    "dropdelst": "NH",
    "dropdelzpp": "037749998",
    "dropphyadd": "2730 DARTMOUTH COLLEGE HWY",
    "dropphycty": "NORTH HAVERHILL",
    "dropphyst": "NH",
    "dropphyzpp": "037749998",
    "dropmaladd": "2730 DARTMOUTH COLLEGE HWY",
    "dropmalcty": "NORTH HAVERHILL",
    "dropmalst": "NH",
    "dropmalzpp": "037749998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037876731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25645",
    "droptype": "D",
    "dropname": "NORTH SALEM",
    "dropdeladd": "112 E BROADWAY",
    "dropdelcty": "NORTH SALEM",
    "dropdelst": "NH",
    "dropdelzpp": "030739998",
    "dropphyadd": "112 E BROADWAY",
    "dropphycty": "NORTH SALEM",
    "dropphyst": "NH",
    "dropphyzpp": "030739998",
    "dropmaladd": "112 E BROADWAY",
    "dropmalcty": "NORTH SALEM",
    "dropmalst": "NH",
    "dropmalzpp": "030739998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038982405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25646",
    "droptype": "D",
    "dropname": "NORTH SANDWICH",
    "dropdeladd": "2 MAPLE RIDGE RD",
    "dropdelcty": "NORTH SANDWICH",
    "dropdelst": "NH",
    "dropdelzpp": "032599998",
    "dropphyadd": "2 MAPLE RIDGE RD",
    "dropphycty": "NORTH SANDWICH",
    "dropphyst": "NH",
    "dropphyzpp": "032599998",
    "dropmaladd": "2 MAPLE RIDGE RD",
    "dropmalcty": "NORTH SANDWICH",
    "dropmalst": "NH",
    "dropmalzpp": "032599998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6037303744,
    "dropsitcph": 6037303744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25647",
    "droptype": "D",
    "dropname": "NORTH STRATFORD",
    "dropdeladd": "79 MAIN ST UNIT 1",
    "dropdelcty": "NORTH STRATFORD",
    "dropdelst": "NH",
    "dropdelzpp": "035909998",
    "dropphyadd": "79 MAIN ST UNIT 1",
    "dropphycty": "NORTH STRATFORD",
    "dropphyst": "NH",
    "dropphyzpp": "035909998",
    "dropmaladd": "79 MAIN ST UNIT 1",
    "dropmalcty": "NORTH STRATFORD",
    "dropmalst": "NH",
    "dropmalzpp": "035909998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039223819,
    "dropfax": 6039223327
  },
  {
    "dcode": "D",
    "dropkey": "PV25648",
    "droptype": "D",
    "dropname": "NORTH SUTTON",
    "dropdeladd": "1617 ROUTE 114",
    "dropdelcty": "NORTH SUTTON",
    "dropdelst": "NH",
    "dropdelzpp": "032609998",
    "dropphyadd": "1617 ROUTE 114",
    "dropphycty": "NORTH SUTTON",
    "dropphyst": "NH",
    "dropphyzpp": "032609998",
    "dropmaladd": "1617 ROUTE 114",
    "dropmalcty": "NORTH SUTTON",
    "dropmalst": "NH",
    "dropmalzpp": "032609998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039274640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25651",
    "droptype": "D",
    "dropname": "NORTH WOODSTOCK",
    "dropdeladd": "159 MAIN ST UNIT A",
    "dropdelcty": "NORTH WOODSTOCK",
    "dropdelst": "NH",
    "dropdelzpp": "032629998",
    "dropphyadd": "159 MAIN ST UNIT A",
    "dropphycty": "NORTH WOODSTOCK",
    "dropphyst": "NH",
    "dropphyzpp": "032629998",
    "dropmaladd": "159 MAIN ST UNIT A",
    "dropmalcty": "NORTH WOODSTOCK",
    "dropmalst": "NH",
    "dropmalzpp": "032629998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037458134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25655",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "6 TASKER SHORE DR",
    "dropdelcty": "NORTHWOOD",
    "dropdelst": "NH",
    "dropdelzpp": "032619998",
    "dropphyadd": "6 TASKER SHORE DR",
    "dropphycty": "NORTHWOOD",
    "dropphyst": "NH",
    "dropphyzpp": "032619998",
    "dropmaladd": "6 TASKER SHORE DR",
    "dropmalcty": "NORTHWOOD",
    "dropmalst": "NH",
    "dropmalzpp": "032619998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039428586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25656",
    "droptype": "D",
    "dropname": "NOTTINGHAM",
    "dropdeladd": "106 STAGE RD",
    "dropdelcty": "NOTTINGHAM",
    "dropdelst": "NH",
    "dropdelzpp": "032909998",
    "dropphyadd": "106 STAGE RD",
    "dropphycty": "NOTTINGHAM",
    "dropphyst": "NH",
    "dropphyzpp": "032909998",
    "dropmaladd": "106 STAGE RD",
    "dropmalcty": "NOTTINGHAM",
    "dropmalst": "NH",
    "dropmalzpp": "032909998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036798340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25659",
    "droptype": "D",
    "dropname": "ORFORD",
    "dropdeladd": "621 NH ROUTE 10",
    "dropdelcty": "ORFORD",
    "dropdelst": "NH",
    "dropdelzpp": "037779998",
    "dropphyadd": "621 NH ROUTE 10",
    "dropphycty": "ORFORD",
    "dropphyst": "NH",
    "dropphyzpp": "037779998",
    "dropmaladd": "621 NH ROUTE 10",
    "dropmalcty": "ORFORD",
    "dropmalst": "NH",
    "dropmalzpp": "037779998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033534559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25660",
    "droptype": "D",
    "dropname": "OSSIPEE",
    "dropdeladd": "10 OLD ROUTE 28",
    "dropdelcty": "OSSIPEE",
    "dropdelst": "NH",
    "dropdelzpp": "038647315",
    "dropphyadd": "10 OLD ROUTE 28",
    "dropphycty": "OSSIPEE",
    "dropphyst": "NH",
    "dropphyzpp": "038647315",
    "dropmaladd": "10 OLD ROUTE 28",
    "dropmalcty": "OSSIPEE",
    "dropmalst": "NH",
    "dropmalzpp": "038647315",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035396455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25661",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "150 BRIDGE ST",
    "dropdelcty": "PELHAM",
    "dropdelst": "NH",
    "dropdelzpp": "030769998",
    "dropphyadd": "150 BRIDGE ST",
    "dropphycty": "PELHAM",
    "dropphyst": "NH",
    "dropphyzpp": "030769998",
    "dropmaladd": "150 BRIDGE ST",
    "dropmalcty": "PELHAM",
    "dropmalst": "NH",
    "dropmalzpp": "030769998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036359783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25665",
    "droptype": "D",
    "dropname": "PETERBOROUGH",
    "dropdeladd": "23 GROVE ST",
    "dropdelcty": "PETERBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "034589998",
    "dropphyadd": "23 GROVE ST",
    "dropphycty": "PETERBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "034589998",
    "dropmaladd": "23 GROVE ST",
    "dropmalcty": "PETERBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "034589998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039243251,
    "dropfax": 6039243396
  },
  {
    "dcode": "D",
    "dropkey": "PV25666",
    "droptype": "D",
    "dropname": "PIERMONT",
    "dropdeladd": "15 CHURCH ST UNIT 2",
    "dropdelcty": "PIERMONT",
    "dropdelst": "NH",
    "dropdelzpp": "037799998",
    "dropphyadd": "15 CHURCH ST UNIT 2",
    "dropphycty": "PIERMONT",
    "dropphyst": "NH",
    "dropphyzpp": "037799998",
    "dropmaladd": "15 CHURCH ST UNIT 2",
    "dropmalcty": "PIERMONT",
    "dropmalst": "NH",
    "dropmalzpp": "037799998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032724897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25667",
    "droptype": "D",
    "dropname": "PIKE",
    "dropdeladd": "1572 MOUNT MOOSILAUKE HWY",
    "dropdelcty": "PIKE",
    "dropdelst": "NH",
    "dropdelzpp": "037809998",
    "dropphyadd": "1572 MOUNT MOOSILAUKE HWY",
    "dropphycty": "PIKE",
    "dropphyst": "NH",
    "dropphyzpp": "037809998",
    "dropmaladd": "1572 MOUNT MOOSILAUKE HWY",
    "dropmalcty": "PIKE",
    "dropmalst": "NH",
    "dropmalzpp": "037809998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039895549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25670",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "1551 MAIN ST",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "NH",
    "dropdelzpp": "035929998",
    "dropphyadd": "1551 MAIN ST",
    "dropphycty": "PITTSBURG",
    "dropphyst": "NH",
    "dropphyzpp": "035929998",
    "dropmaladd": "1551 MAIN ST",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "NH",
    "dropmalzpp": "035929998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035386513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25671",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "2 ELM ST",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "032639998",
    "dropphyadd": "2 ELM ST",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "032639998",
    "dropmaladd": "2 ELM ST",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "032639998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034356281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25672",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "1132 ROUTE 12A",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "037819998",
    "dropphyadd": "1132 ROUTE 12A",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "037819998",
    "dropmaladd": "1132 ROUTE 12A",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "037819998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036752723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25673",
    "droptype": "D",
    "dropname": "PLAISTOW",
    "dropdeladd": "38 MAIN ST",
    "dropdelcty": "PLAISTOW",
    "dropdelst": "NH",
    "dropdelzpp": "038659998",
    "dropphyadd": "38 MAIN ST",
    "dropphycty": "PLAISTOW",
    "dropphyst": "NH",
    "dropphyzpp": "038659998",
    "dropmaladd": "38 MAIN ST",
    "dropmalcty": "PLAISTOW",
    "dropmalst": "NH",
    "dropmalzpp": "038659998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033828529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25674",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "1 POST OFFICE SQ",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "NH",
    "dropdelzpp": "032649998",
    "dropphyadd": "1 POST OFFICE SQ",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "NH",
    "dropphyzpp": "032649998",
    "dropmaladd": "1 POST OFFICE SQ",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "NH",
    "dropmalzpp": "032649998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035361316,
    "dropfax": 6035364420
  },
  {
    "dcode": "D",
    "dropkey": "PV25676",
    "droptype": "D",
    "dropname": "PORTSMOUTH",
    "dropdeladd": "345 HERITAGE AVE UNIT 100",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "NH",
    "dropdelzpp": "038019995",
    "dropphyadd": "345 HERITAGE AVE UNIT 100",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "NH",
    "dropphyzpp": "038019995",
    "dropmaladd": "345 HERITAGE AVE UNIT 100",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "NH",
    "dropmalzpp": "038019995",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034312871,
    "dropfax": 6034308931
  },
  {
    "dcode": "D",
    "dropkey": "PV25681",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "15 FREETOWN RD STE 1",
    "dropdelcty": "RAYMOND",
    "dropdelst": "NH",
    "dropdelzpp": "030779998",
    "dropphyadd": "15 FREETOWN RD STE 1",
    "dropphycty": "RAYMOND",
    "dropphyst": "NH",
    "dropphyzpp": "030779998",
    "dropmaladd": "15 FREETOWN RD STE 1",
    "dropmalcty": "RAYMOND",
    "dropmalst": "NH",
    "dropmalzpp": "030779998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038953314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25683",
    "droptype": "D",
    "dropname": "RINDGE",
    "dropdeladd": "1056 NH ROUTE 119",
    "dropdelcty": "RINDGE",
    "dropdelst": "NH",
    "dropdelzpp": "034619998",
    "dropphyadd": "1056 NH ROUTE 119",
    "dropphycty": "RINDGE",
    "dropphyst": "NH",
    "dropphyzpp": "034619998",
    "dropmaladd": "1056 NH ROUTE 119",
    "dropmalcty": "RINDGE",
    "dropmalst": "NH",
    "dropmalzpp": "034619998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038993372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25684",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "20 ALLEN ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "038679998",
    "dropphyadd": "20 ALLEN ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "038679998",
    "dropmaladd": "20 ALLEN ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "038679998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033321429,
    "dropfax": 6033300824
  },
  {
    "dcode": "D",
    "dropkey": "PV25685",
    "droptype": "D",
    "dropname": "ROLLINSFORD",
    "dropdeladd": "664 MAIN ST",
    "dropdelcty": "ROLLINSFORD",
    "dropdelst": "NH",
    "dropdelzpp": "038699998",
    "dropphyadd": "664 MAIN ST",
    "dropphycty": "ROLLINSFORD",
    "dropphyst": "NH",
    "dropphyzpp": "038699998",
    "dropmaladd": "664 MAIN ST",
    "dropmalcty": "ROLLINSFORD",
    "dropmalst": "NH",
    "dropmalzpp": "038699998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037425077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25687",
    "droptype": "D",
    "dropname": "RUMNEY",
    "dropdeladd": "9 POST OFFICE LN",
    "dropdelcty": "RUMNEY",
    "dropdelst": "NH",
    "dropdelzpp": "032669998",
    "dropphyadd": "9 POST OFFICE LN",
    "dropphycty": "RUMNEY",
    "dropphyst": "NH",
    "dropphyzpp": "032669998",
    "dropmaladd": "9 POST OFFICE LN",
    "dropmalcty": "RUMNEY",
    "dropmalst": "NH",
    "dropmalzpp": "032669998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037869571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25688",
    "droptype": "D",
    "dropname": "RYE",
    "dropdeladd": "301 CENTRAL RD",
    "dropdelcty": "RYE",
    "dropdelst": "NH",
    "dropdelzpp": "038709998",
    "dropphyadd": "301 CENTRAL RD",
    "dropphycty": "RYE",
    "dropphyst": "NH",
    "dropphyzpp": "038709998",
    "dropmaladd": "301 CENTRAL RD",
    "dropmalcty": "RYE",
    "dropmalst": "NH",
    "dropmalzpp": "038709998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039645974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25689",
    "droptype": "D",
    "dropname": "RYE BEACH",
    "dropdeladd": "830 CENTRAL RD",
    "dropdelcty": "RYE BEACH",
    "dropdelst": "NH",
    "dropdelzpp": "038719998",
    "dropphyadd": "830 CENTRAL RD",
    "dropphycty": "RYE BEACH",
    "dropphyst": "NH",
    "dropphyzpp": "038719998",
    "dropmaladd": "830 CENTRAL RD",
    "dropmalcty": "RYE BEACH",
    "dropmalst": "NH",
    "dropmalzpp": "038719998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039646019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25697",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "51 S BROADWAY",
    "dropdelcty": "SALEM",
    "dropdelst": "NH",
    "dropdelzpp": "030793008",
    "dropphyadd": "51 S BROADWAY",
    "dropphycty": "SALEM",
    "dropphyst": "NH",
    "dropphyzpp": "030793008",
    "dropmaladd": "51 S BROADWAY",
    "dropmalcty": "SALEM",
    "dropmalst": "NH",
    "dropmalzpp": "030793008",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036852005,
    "dropfax": 6038982117
  },
  {
    "dcode": "D",
    "dropkey": "PV25700",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "269 OLD TURNPIKE RD",
    "dropdelcty": "SALISBURY",
    "dropdelst": "NH",
    "dropdelzpp": "032689998",
    "dropphyadd": "269 OLD TURNPIKE RD",
    "dropphycty": "SALISBURY",
    "dropphyst": "NH",
    "dropphyzpp": "032689998",
    "dropmaladd": "269 OLD TURNPIKE RD",
    "dropmalcty": "SALISBURY",
    "dropmalst": "NH",
    "dropmalzpp": "032689998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036482598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25701",
    "droptype": "D",
    "dropname": "SANBORNTON",
    "dropdeladd": "542 SANBORN RD",
    "dropdelcty": "SANBORNTON",
    "dropdelst": "NH",
    "dropdelzpp": "032699998",
    "dropphyadd": "542 SANBORN RD",
    "dropphycty": "SANBORNTON",
    "dropphyst": "NH",
    "dropphyzpp": "032699998",
    "dropmaladd": "542 SANBORN RD",
    "dropmalcty": "SANBORNTON",
    "dropmalst": "NH",
    "dropmalzpp": "032699998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032863335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25702",
    "droptype": "D",
    "dropname": "SANBORNVILLE",
    "dropdeladd": "378 MEADOW ST",
    "dropdelcty": "SANBORNVILLE",
    "dropdelst": "NH",
    "dropdelzpp": "038729998",
    "dropphyadd": "378 MEADOW ST",
    "dropphycty": "SANBORNVILLE",
    "dropphyst": "NH",
    "dropphyzpp": "038729998",
    "dropmaladd": "378 MEADOW ST",
    "dropmalcty": "SANBORNVILLE",
    "dropmalst": "NH",
    "dropmalzpp": "038729998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035228811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25703",
    "droptype": "D",
    "dropname": "SANDOWN",
    "dropdeladd": "345 MAIN ST",
    "dropdelcty": "SANDOWN",
    "dropdelst": "NH",
    "dropdelzpp": "038739998",
    "dropphyadd": "345 MAIN ST",
    "dropphycty": "SANDOWN",
    "dropphyst": "NH",
    "dropphyzpp": "038739998",
    "dropmaladd": "345 MAIN ST",
    "dropmalcty": "SANDOWN",
    "dropmalst": "NH",
    "dropmalzpp": "038739998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038874655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25706",
    "droptype": "D",
    "dropname": "SEABROOK",
    "dropdeladd": "19 MAIN ST",
    "dropdelcty": "SEABROOK",
    "dropdelst": "NH",
    "dropdelzpp": "038749998",
    "dropphyadd": "19 MAIN ST",
    "dropphycty": "SEABROOK",
    "dropphyst": "NH",
    "dropphyzpp": "038749998",
    "dropmaladd": "19 MAIN ST",
    "dropmalcty": "SEABROOK",
    "dropmalst": "NH",
    "dropmalzpp": "038749998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034745950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25711",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "1381 VILLAGE RD",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "NH",
    "dropdelzpp": "038759998",
    "dropphyadd": "1381 VILLAGE RD",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "NH",
    "dropphyzpp": "038759998",
    "dropmaladd": "1381 VILLAGE RD",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "NH",
    "dropmalzpp": "038759998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033674777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25719",
    "droptype": "D",
    "dropname": "SOMERSWORTH",
    "dropdeladd": "2 GOVERNMENT WAY",
    "dropdelcty": "SOMERSWORTH",
    "dropdelst": "NH",
    "dropdelzpp": "038783249",
    "dropphyadd": "2 GOVERNMENT WAY",
    "dropphycty": "SOMERSWORTH",
    "dropphyst": "NH",
    "dropphyzpp": "038783249",
    "dropmaladd": "2 GOVERNMENT WAY",
    "dropmalcty": "SOMERSWORTH",
    "dropmalst": "NH",
    "dropmalzpp": "038783249",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036924267,
    "dropfax": 6036924940
  },
  {
    "dcode": "D",
    "dropkey": "PV25722",
    "droptype": "D",
    "dropname": "EFFINGHAM",
    "dropdeladd": "1446 PROVINCE LAKE RD",
    "dropdelcty": "EFFINGHAM",
    "dropdelst": "NH",
    "dropdelzpp": "038829998",
    "dropphyadd": "1446 PROVINCE LAKE RD",
    "dropphycty": "EFFINGHAM",
    "dropphyst": "NH",
    "dropphyzpp": "038829998",
    "dropmaladd": "1446 PROVINCE LAKE RD",
    "dropmalcty": "EFFINGHAM",
    "dropmalst": "NH",
    "dropmalzpp": "038829998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035397179,
    "dropfax": 6035397490
  },
  {
    "dcode": "D",
    "dropkey": "PV25727",
    "droptype": "D",
    "dropname": "SOUTH SUTTON",
    "dropdeladd": "663 ROUTE 114",
    "dropdelcty": "SOUTH SUTTON",
    "dropdelst": "NH",
    "dropdelzpp": "032739998",
    "dropphyadd": "663 ROUTE 114",
    "dropphycty": "SOUTH SUTTON",
    "dropphyst": "NH",
    "dropphyzpp": "032739998",
    "dropmaladd": "663 ROUTE 114",
    "dropmalcty": "SOUTH SUTTON",
    "dropmalst": "NH",
    "dropmalzpp": "032739998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039274561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25728",
    "droptype": "D",
    "dropname": "SOUTH TAMWORTH",
    "dropdeladd": "882 BEARCAMP HWY",
    "dropdelcty": "SOUTH TAMWORTH",
    "dropdelst": "NH",
    "dropdelzpp": "038839998",
    "dropphyadd": "882 BEARCAMP HWY",
    "dropphycty": "SOUTH TAMWORTH",
    "dropphyst": "NH",
    "dropphyzpp": "038839998",
    "dropmaladd": "882 BEARCAMP HWY",
    "dropmalcty": "SOUTH TAMWORTH",
    "dropmalst": "NH",
    "dropmalzpp": "038839998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033237946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25729",
    "droptype": "D",
    "dropname": "SPOFFORD",
    "dropdeladd": "562 N SHORE RD",
    "dropdelcty": "SPOFFORD",
    "dropdelst": "NH",
    "dropdelzpp": "034629998",
    "dropphyadd": "562 N SHORE RD",
    "dropphycty": "SPOFFORD",
    "dropphyst": "NH",
    "dropphyzpp": "034629998",
    "dropmaladd": "562 N SHORE RD",
    "dropmalcty": "SPOFFORD",
    "dropmalst": "NH",
    "dropmalzpp": "034629998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033634711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25739",
    "droptype": "D",
    "dropname": "STRAFFORD",
    "dropdeladd": "1079 PARKER MOUNTAIN RD",
    "dropdelcty": "STRAFFORD",
    "dropdelst": "NH",
    "dropdelzpp": "038849998",
    "dropphyadd": "1079 PARKER MOUNTAIN RD",
    "dropphycty": "STRAFFORD",
    "dropphyst": "NH",
    "dropphyzpp": "038849998",
    "dropmaladd": "1079 PARKER MOUNTAIN RD",
    "dropmalcty": "STRAFFORD",
    "dropmalst": "NH",
    "dropmalzpp": "038849998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036642118,
    "dropfax": 6036645128
  },
  {
    "dcode": "D",
    "dropkey": "PV25742",
    "droptype": "D",
    "dropname": "STRATHAM",
    "dropdeladd": "2 COLLEGE RD",
    "dropdelcty": "STRATHAM",
    "dropdelst": "NH",
    "dropdelzpp": "038859998",
    "dropphyadd": "2 COLLEGE RD",
    "dropphycty": "STRATHAM",
    "dropphyst": "NH",
    "dropphyzpp": "038859998",
    "dropmaladd": "2 COLLEGE RD",
    "dropmalcty": "STRATHAM",
    "dropmalst": "NH",
    "dropmalzpp": "038859998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037728107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25747",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "311 CENTRE ST",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "NH",
    "dropdelzpp": "034459998",
    "dropphyadd": "311 CENTRE ST",
    "dropphycty": "SULLIVAN",
    "dropphyst": "NH",
    "dropphyzpp": "034459998",
    "dropmaladd": "311 CENTRE ST",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "NH",
    "dropmalzpp": "034459998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6072583439,
    "dropsitcph": 6072583439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25748",
    "droptype": "D",
    "dropname": "SUNAPEE",
    "dropdeladd": "5 ELM ST",
    "dropdelcty": "SUNAPEE",
    "dropdelst": "NH",
    "dropdelzpp": "037829998",
    "dropphyadd": "5 ELM ST",
    "dropphycty": "SUNAPEE",
    "dropphyst": "NH",
    "dropphyzpp": "037829998",
    "dropmaladd": "5 ELM ST",
    "dropmalcty": "SUNAPEE",
    "dropmalst": "NH",
    "dropmalzpp": "037829998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037635786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25749",
    "droptype": "D",
    "dropname": "SUNCOOK",
    "dropdeladd": "55 GLASS ST",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "NH",
    "dropdelzpp": "032751533",
    "dropphyadd": "55 GLASS ST",
    "dropphycty": "PEMBROKE",
    "dropphyst": "NH",
    "dropphyzpp": "032751533",
    "dropmaladd": "55 GLASS ST",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "NH",
    "dropmalzpp": "032751533",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034853127,
    "dropfax": 6034856033
  },
  {
    "dcode": "D",
    "dropkey": "PV25756",
    "droptype": "D",
    "dropname": "TAMWORTH",
    "dropdeladd": "182 TAMWORTH RD",
    "dropdelcty": "TAMWORTH",
    "dropdelst": "NH",
    "dropdelzpp": "038869998",
    "dropphyadd": "182 TAMWORTH RD",
    "dropphycty": "TAMWORTH",
    "dropphyst": "NH",
    "dropphyzpp": "038869998",
    "dropmaladd": "182 TAMWORTH RD",
    "dropmalcty": "TAMWORTH",
    "dropmalst": "NH",
    "dropmalzpp": "038869998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033238708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25757",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "19 MAIN ST UNIT 3",
    "dropdelcty": "TEMPLE",
    "dropdelst": "NH",
    "dropdelzpp": "030849998",
    "dropphyadd": "19 MAIN ST UNIT 3",
    "dropphycty": "TEMPLE",
    "dropphyst": "NH",
    "dropphyzpp": "030849998",
    "dropmaladd": "19 MAIN ST UNIT 3",
    "dropmalcty": "TEMPLE",
    "dropmalst": "NH",
    "dropmalzpp": "030849998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038781800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25759",
    "droptype": "D",
    "dropname": "TILTON",
    "dropdeladd": "66 E MAIN ST",
    "dropdelcty": "TILTON",
    "dropdelst": "NH",
    "dropdelzpp": "032765147",
    "dropphyadd": "66 E MAIN ST",
    "dropphycty": "TILTON",
    "dropphyst": "NH",
    "dropphyzpp": "032765147",
    "dropmaladd": "66 E MAIN ST",
    "dropmalcty": "TILTON",
    "dropmalst": "NH",
    "dropmalzpp": "032765147",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032864592,
    "dropfax": 6032863878
  },
  {
    "dcode": "D",
    "dropkey": "PV25760",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "7 MARLBORO RD STE F",
    "dropdelcty": "TROY",
    "dropdelst": "NH",
    "dropdelzpp": "034659998",
    "dropphyadd": "7 MARLBORO RD STE F",
    "dropphycty": "TROY",
    "dropphyst": "NH",
    "dropphyzpp": "034659998",
    "dropmaladd": "7 MARLBORO RD STE F",
    "dropmalcty": "TROY",
    "dropmalst": "NH",
    "dropmalzpp": "034659998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6037575740,
    "dropsitcph": 6037575740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25763",
    "droptype": "D",
    "dropname": "TWIN MOUNTAIN",
    "dropdeladd": "120 US HIGHWAY 3 N",
    "dropdelcty": "TWIN MOUNTAIN",
    "dropdelst": "NH",
    "dropdelzpp": "035959998",
    "dropphyadd": "120 US HIGHWAY 3 N",
    "dropphycty": "TWIN MOUNTAIN",
    "dropphyst": "NH",
    "dropphyzpp": "035959998",
    "dropmaladd": "120 US HIGHWAY 3 N",
    "dropmalcty": "TWIN MOUNTAIN",
    "dropmalst": "NH",
    "dropmalzpp": "035959998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038465570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25765",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "UNION",
    "dropdelst": "NH",
    "dropdelzpp": "038879998",
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "UNION",
    "dropphyst": "NH",
    "dropphyzpp": "038879998",
    "dropmaladd": "402 MAIN ST",
    "dropmalcty": "UNION",
    "dropmalst": "NH",
    "dropmalzpp": "038879998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034732046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25785",
    "droptype": "D",
    "dropname": "WALPOLE",
    "dropdeladd": "47 MAIN ST UNIT 1",
    "dropdelcty": "WALPOLE",
    "dropdelst": "NH",
    "dropdelzpp": "036089998",
    "dropphyadd": "47 MAIN ST UNIT 1",
    "dropphycty": "WALPOLE",
    "dropphyst": "NH",
    "dropphyzpp": "036089998",
    "dropmaladd": "47 MAIN ST UNIT 1",
    "dropmalcty": "WALPOLE",
    "dropmalst": "NH",
    "dropmalzpp": "036089998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037563363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25786",
    "droptype": "D",
    "dropname": "WARNER",
    "dropdeladd": "36 E MAIN ST",
    "dropdelcty": "WARNER",
    "dropdelst": "NH",
    "dropdelzpp": "032789998",
    "dropphyadd": "36 E MAIN ST",
    "dropphycty": "WARNER",
    "dropphyst": "NH",
    "dropphyzpp": "032789998",
    "dropmaladd": "36 E MAIN ST",
    "dropmalcty": "WARNER",
    "dropmalst": "NH",
    "dropmalzpp": "032789998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034563524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25787",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "18 LAKE TARLETON RD UNIT 1",
    "dropdelcty": "WARREN",
    "dropdelst": "NH",
    "dropdelzpp": "032799998",
    "dropphyadd": "18 LAKE TARLETON RD UNIT 1",
    "dropphycty": "WARREN",
    "dropphyst": "NH",
    "dropphyzpp": "032799998",
    "dropmaladd": "18 LAKE TARLETON RD UNIT 1",
    "dropmalcty": "WARREN",
    "dropmalst": "NH",
    "dropmalzpp": "032799998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037645733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25788",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "173 N MAIN ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "NH",
    "dropdelzpp": "032809998",
    "dropphyadd": "173 N MAIN ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "NH",
    "dropphyzpp": "032809998",
    "dropmaladd": "173 N MAIN ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "NH",
    "dropmalzpp": "032809998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034953467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25792",
    "droptype": "D",
    "dropname": "WEARE",
    "dropdeladd": "8 DUCK POND RD",
    "dropdelcty": "WEARE",
    "dropdelst": "NH",
    "dropdelzpp": "032819998",
    "dropphyadd": "8 DUCK POND RD",
    "dropphycty": "WEARE",
    "dropphyst": "NH",
    "dropphyzpp": "032819998",
    "dropmaladd": "8 DUCK POND RD",
    "dropmalcty": "WEARE",
    "dropmalst": "NH",
    "dropmalzpp": "032819998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035292636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25799",
    "droptype": "D",
    "dropname": "WENTWORTH",
    "dropdeladd": "12 WENTWORTH VILLAGE RD UNIT B",
    "dropdelcty": "WENTWORTH",
    "dropdelst": "NH",
    "dropdelzpp": "032829998",
    "dropphyadd": "12 WENTWORTH VILLAGE RD UNIT B",
    "dropphycty": "WENTWORTH",
    "dropphyst": "NH",
    "dropphyzpp": "032829998",
    "dropmaladd": "12 WENTWORTH VILLAGE RD UNIT B",
    "dropmalcty": "WENTWORTH",
    "dropmalst": "NH",
    "dropmalzpp": "032829998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037649444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25801",
    "droptype": "D",
    "dropname": "WEST CHESTERFIELD",
    "dropdeladd": "913 GULF RD UNIT C",
    "dropdelcty": "WEST CHESTERFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "034669998",
    "dropphyadd": "913 GULF RD UNIT C",
    "dropphycty": "WEST CHESTERFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "034669998",
    "dropmaladd": "913 GULF RD UNIT C",
    "dropmalcty": "WEST CHESTERFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "034669998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033753348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25806",
    "droptype": "D",
    "dropname": "WEST NOTTINGHAM",
    "dropdeladd": "368 STAGE RD UNIT 2",
    "dropdelcty": "WEST NOTTINGHAM",
    "dropdelst": "NH",
    "dropdelzpp": "032919998",
    "dropphyadd": "368 STAGE RD UNIT 2",
    "dropphycty": "WEST NOTTINGHAM",
    "dropphyst": "NH",
    "dropphyzpp": "032919998",
    "dropmaladd": "368 STAGE RD UNIT 2",
    "dropmalcty": "WEST NOTTINGHAM",
    "dropmalst": "NH",
    "dropmalzpp": "032919998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039427010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25807",
    "droptype": "D",
    "dropname": "WEST OSSIPEE",
    "dropdeladd": "2326 ROUTE 16",
    "dropdelcty": "WEST OSSIPEE",
    "dropdelst": "NH",
    "dropdelzpp": "038909998",
    "dropphyadd": "2326 ROUTE 16",
    "dropphycty": "WEST OSSIPEE",
    "dropphyst": "NH",
    "dropphyzpp": "038909998",
    "dropmaladd": "2326 ROUTE 16",
    "dropmalcty": "WEST OSSIPEE",
    "dropmalst": "NH",
    "dropmalzpp": "038909998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035394918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25808",
    "droptype": "D",
    "dropname": "WEST PETERBOROUGH",
    "dropdeladd": "301 UNION ST UNIT C",
    "dropdelcty": "WEST PETERBOROUGH",
    "dropdelst": "NH",
    "dropdelzpp": "034689998",
    "dropphyadd": "301 UNION ST UNIT C",
    "dropphycty": "WEST PETERBOROUGH",
    "dropphyst": "NH",
    "dropphyzpp": "034689998",
    "dropmaladd": "301 UNION ST UNIT C",
    "dropmalcty": "WEST PETERBOROUGH",
    "dropmalst": "NH",
    "dropmalzpp": "034689998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039246126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25809",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "2776 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "032849998",
    "dropphyadd": "2776 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "032849998",
    "dropmaladd": "2776 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "032849998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037635001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25811",
    "droptype": "D",
    "dropname": "WEST STEWARTSTOWN",
    "dropdeladd": "20 MAIN ST",
    "dropdelcty": "WEST STEWARTSTOWN",
    "dropdelst": "NH",
    "dropdelzpp": "035979998",
    "dropphyadd": "20 MAIN ST",
    "dropphycty": "WEST STEWARTSTOWN",
    "dropphyst": "NH",
    "dropphyzpp": "035979998",
    "dropmaladd": "20 MAIN ST",
    "dropmalcty": "WEST STEWARTSTOWN",
    "dropmalst": "NH",
    "dropmalzpp": "035979998",
    "dropsitphn": 6036444128,
    "dropsitlph": 5188613704,
    "dropsitcph": 5188613704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25812",
    "droptype": "D",
    "dropname": "WEST SWANZEY",
    "dropdeladd": "769 W SWANZEY RD",
    "dropdelcty": "WEST SWANZEY",
    "dropdelst": "NH",
    "dropdelzpp": "034699998",
    "dropphyadd": "769 W SWANZEY RD",
    "dropphycty": "WEST SWANZEY",
    "dropphyst": "NH",
    "dropphyzpp": "034699998",
    "dropmaladd": "769 W SWANZEY RD",
    "dropmalcty": "WEST SWANZEY",
    "dropmalst": "NH",
    "dropmalzpp": "034699998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033528092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25813",
    "droptype": "D",
    "dropname": "WESTMORELAND",
    "dropdeladd": "776 ROUTE 63",
    "dropdelcty": "WESTMORELAND",
    "dropdelst": "NH",
    "dropdelzpp": "034679998",
    "dropphyadd": "776 ROUTE 63",
    "dropphycty": "WESTMORELAND",
    "dropphyst": "NH",
    "dropphyzpp": "034679998",
    "dropmaladd": "776 ROUTE 63",
    "dropmalcty": "WESTMORELAND",
    "dropmalst": "NH",
    "dropmalzpp": "034679998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033997774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25814",
    "droptype": "D",
    "dropname": "WHITEFIELD",
    "dropdeladd": "26 JEFFERSON RD",
    "dropdelcty": "WHITEFIELD",
    "dropdelst": "NH",
    "dropdelzpp": "035989998",
    "dropphyadd": "26 JEFFERSON RD",
    "dropphycty": "WHITEFIELD",
    "dropphyst": "NH",
    "dropphyzpp": "035989998",
    "dropmaladd": "26 JEFFERSON RD",
    "dropmalcty": "WHITEFIELD",
    "dropmalst": "NH",
    "dropmalzpp": "035989998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038372212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25818",
    "droptype": "D",
    "dropname": "WILMOT",
    "dropdeladd": "60 VILLAGE RD",
    "dropdelcty": "WILMOT",
    "dropdelst": "NH",
    "dropdelzpp": "032879998",
    "dropphyadd": "60 VILLAGE RD",
    "dropphycty": "WILMOT",
    "dropphyst": "NH",
    "dropphyzpp": "032879998",
    "dropmaladd": "60 VILLAGE RD",
    "dropmalcty": "WILMOT",
    "dropmalst": "NH",
    "dropmalzpp": "032879998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6035264852,
    "dropsitcph": 6035264852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25819",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "79 MAIN ST",
    "dropdelcty": "WILTON",
    "dropdelst": "NH",
    "dropdelzpp": "030869998",
    "dropphyadd": "79 MAIN ST",
    "dropphycty": "WILTON",
    "dropphyst": "NH",
    "dropphyzpp": "030869998",
    "dropmaladd": "79 MAIN ST",
    "dropmalcty": "WILTON",
    "dropmalst": "NH",
    "dropmalzpp": "030869998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036545830,
    "dropfax": 6036545243
  },
  {
    "dcode": "D",
    "dropkey": "PV25820",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "11 RICHMOND RD",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "034709998",
    "dropphyadd": "11 RICHMOND RD",
    "dropphycty": "WINCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "034709998",
    "dropmaladd": "11 RICHMOND RD",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "034709998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032394401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25821",
    "droptype": "D",
    "dropname": "WINDHAM",
    "dropdeladd": "44 INDIAN ROCK RD",
    "dropdelcty": "WINDHAM",
    "dropdelst": "NH",
    "dropdelzpp": "030879998",
    "dropphyadd": "44 INDIAN ROCK RD",
    "dropphycty": "WINDHAM",
    "dropphyst": "NH",
    "dropphyzpp": "030879998",
    "dropmaladd": "44 INDIAN ROCK RD",
    "dropmalcty": "WINDHAM",
    "dropmalst": "NH",
    "dropmalzpp": "030879998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034373819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25823",
    "droptype": "D",
    "dropname": "WINNISQUAM",
    "dropdeladd": "969 LACONIA RD",
    "dropdelcty": "WINNISQUAM",
    "dropdelst": "NH",
    "dropdelzpp": "032899998",
    "dropphyadd": "969 LACONIA RD",
    "dropphycty": "WINNISQUAM",
    "dropphyst": "NH",
    "dropphyzpp": "032899998",
    "dropmaladd": "969 LACONIA RD",
    "dropmalcty": "WINNISQUAM",
    "dropmalst": "NH",
    "dropmalzpp": "032899998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035243317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25824",
    "droptype": "D",
    "dropname": "WOLFEBORO",
    "dropdeladd": "34 S MAIN ST",
    "dropdelcty": "WOLFEBORO",
    "dropdelst": "NH",
    "dropdelzpp": "038949998",
    "dropphyadd": "34 S MAIN ST",
    "dropphycty": "WOLFEBORO",
    "dropphyst": "NH",
    "dropphyzpp": "038949998",
    "dropmaladd": "34 S MAIN ST",
    "dropmalcty": "WOLFEBORO",
    "dropmalst": "NH",
    "dropmalzpp": "038949998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035692375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25825",
    "droptype": "D",
    "dropname": "WOLFEBORO FALLS",
    "dropdeladd": "35 CENTER ST",
    "dropdelcty": "WOLFEBORO FALLS",
    "dropdelst": "NH",
    "dropdelzpp": "038969998",
    "dropphyadd": "35 CENTER ST",
    "dropphycty": "WOLFEBORO FALLS",
    "dropphyst": "NH",
    "dropphyzpp": "038969998",
    "dropmaladd": "35 CENTER ST",
    "dropmalcty": "WOLFEBORO FALLS",
    "dropmalst": "NH",
    "dropmalzpp": "038969998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035694274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25829",
    "droptype": "D",
    "dropname": "WOODSVILLE",
    "dropdeladd": "31 S COURT ST STE 5",
    "dropdelcty": "WOODSVILLE",
    "dropdelst": "NH",
    "dropdelzpp": "037859998",
    "dropphyadd": "31 S COURT ST STE 5",
    "dropphycty": "WOODSVILLE",
    "dropphyst": "NH",
    "dropphyzpp": "037859998",
    "dropmaladd": "31 S COURT ST STE 5",
    "dropmalcty": "WOODSVILLE",
    "dropmalst": "NH",
    "dropmalzpp": "037859998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037473731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25832",
    "droptype": "D",
    "dropname": "FISHERS ISLAND",
    "dropdeladd": "1 ORIENTAL AVE",
    "dropdelcty": "FISHERS ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": "063909992",
    "dropphyadd": "1 ORIENTAL AVE",
    "dropphycty": "FISHERS ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": "063909992",
    "dropmaladd": "1 ORIENTAL AVE",
    "dropmalcty": "FISHERS ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": "063909992",
    "dropsitphn": 8605246297,
    "dropsitlph": 8605246297,
    "dropsitcph": 6317887835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25833",
    "droptype": "D",
    "dropname": "ADAMSVILLE",
    "dropdeladd": "70A CRANDALL RD",
    "dropdelcty": "ADAMSVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028019800",
    "dropphyadd": "70A CRANDALL RD",
    "dropphycty": "ADAMSVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028019800",
    "dropmaladd": "70A CRANDALL RD",
    "dropmalcty": "ADAMSVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028019800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016358738,
    "dropfax": 4016358738
  },
  {
    "dcode": "D",
    "dropkey": "PV25834",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "15 SCHOOL ST",
    "dropdelcty": "ALBION",
    "dropdelst": "RI",
    "dropdelzpp": "028029800",
    "dropphyadd": "15 SCHOOL ST",
    "dropphycty": "ALBION",
    "dropphyst": "RI",
    "dropphyzpp": "028029800",
    "dropmaladd": "15 SCHOOL ST",
    "dropmalcty": "ALBION",
    "dropmalst": "RI",
    "dropmalzpp": "028029800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013335274,
    "dropfax": 4013335274
  },
  {
    "dcode": "D",
    "dropkey": "PV25836",
    "droptype": "D",
    "dropname": "ASHAWAY",
    "dropdeladd": "129 MAIN ST",
    "dropdelcty": "ASHAWAY",
    "dropdelst": "RI",
    "dropdelzpp": "028042249",
    "dropphyadd": "129 MAIN ST",
    "dropphycty": "ASHAWAY",
    "dropphyst": "RI",
    "dropphyzpp": "028042249",
    "dropmaladd": "129 MAIN ST",
    "dropmalcty": "ASHAWAY",
    "dropmalst": "RI",
    "dropmalzpp": "028042249",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013778092,
    "dropfax": 4013777063
  },
  {
    "dcode": "D",
    "dropkey": "PV25837",
    "droptype": "D",
    "dropname": "BARRINGTON",
    "dropdeladd": "200 MIDDLE HWY",
    "dropdelcty": "BARRINGTON",
    "dropdelst": "RI",
    "dropdelzpp": "028069998",
    "dropphyadd": "200 MIDDLE HWY",
    "dropphycty": "BARRINGTON",
    "dropphyst": "RI",
    "dropphyzpp": "028069998",
    "dropmaladd": "200 MIDDLE HWY",
    "dropmalcty": "BARRINGTON",
    "dropmalst": "RI",
    "dropmalzpp": "028069998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012456435,
    "dropfax": 4012450743
  },
  {
    "dcode": "D",
    "dropkey": "PV25838",
    "droptype": "D",
    "dropname": "BLOCK ISLAND",
    "dropdeladd": "32T WATER ST",
    "dropdelcty": "BLOCK ISLAND",
    "dropdelst": "RI",
    "dropdelzpp": "028079800",
    "dropphyadd": "32T WATER ST",
    "dropphycty": "BLOCK ISLAND",
    "dropphyst": "RI",
    "dropphyzpp": "028079800",
    "dropmaladd": "32T WATER ST",
    "dropmalcty": "BLOCK ISLAND",
    "dropmalst": "RI",
    "dropmalzpp": "028079800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014667733,
    "dropfax": 6513066539
  },
  {
    "dcode": "D",
    "dropkey": "PV25841",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "416 BRADFORD RD",
    "dropdelcty": "BRADFORD",
    "dropdelst": "RI",
    "dropdelzpp": "028089998",
    "dropphyadd": "416 BRADFORD RD",
    "dropphycty": "BRADFORD",
    "dropphyst": "RI",
    "dropphyzpp": "028089998",
    "dropmaladd": "416 BRADFORD RD",
    "dropmalcty": "BRADFORD",
    "dropmalst": "RI",
    "dropmalzpp": "028089998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013778976,
    "dropfax": 4013774599
  },
  {
    "dcode": "D",
    "dropkey": "PV25844",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "515 HOPE ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "RI",
    "dropdelzpp": "028099998",
    "dropphyadd": "515 HOPE ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "RI",
    "dropphyzpp": "028099998",
    "dropmaladd": "515 HOPE ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "RI",
    "dropmalzpp": "028099998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012535821,
    "dropfax": 4012540402
  },
  {
    "dcode": "D",
    "dropkey": "PV25849",
    "droptype": "D",
    "dropname": "CAROLINA",
    "dropdeladd": "790 ALTON CAROLINA RD",
    "dropdelcty": "CAROLINA",
    "dropdelst": "RI",
    "dropdelzpp": "028129800",
    "dropphyadd": "790 ALTON CAROLINA RD",
    "dropphycty": "CAROLINA",
    "dropphyst": "RI",
    "dropphyzpp": "028129800",
    "dropmaladd": "790 ALTON CAROLINA RD",
    "dropmalcty": "CAROLINA",
    "dropmalst": "RI",
    "dropmalzpp": "028129800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013640251,
    "dropfax": 4013649730
  },
  {
    "dcode": "D",
    "dropkey": "PV25854",
    "droptype": "D",
    "dropname": "CHARLESTOWN",
    "dropdeladd": "3970 OLD POST RD",
    "dropdelcty": "CHARLESTOWN",
    "dropdelst": "RI",
    "dropdelzpp": "028139998",
    "dropphyadd": "3970 OLD POST RD",
    "dropphycty": "CHARLESTOWN",
    "dropphyst": "RI",
    "dropphyzpp": "028139998",
    "dropmaladd": "3970 OLD POST RD",
    "dropmalcty": "CHARLESTOWN",
    "dropmalst": "RI",
    "dropmalzpp": "028139998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013640448,
    "dropfax": 4013640265
  },
  {
    "dcode": "D",
    "dropkey": "PV25855",
    "droptype": "D",
    "dropname": "CHEPACHET",
    "dropdeladd": "1151 PUTNAM PIKE",
    "dropdelcty": "CHEPACHET",
    "dropdelst": "RI",
    "dropdelzpp": "028141960",
    "dropphyadd": "1151 PUTNAM PIKE",
    "dropphycty": "CHEPACHET",
    "dropphyst": "RI",
    "dropphyzpp": "028141960",
    "dropmaladd": "1151 PUTNAM PIKE",
    "dropmalcty": "CHEPACHET",
    "dropmalst": "RI",
    "dropmalzpp": "028141960",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015688784,
    "dropfax": 4015684972
  },
  {
    "dcode": "D",
    "dropkey": "PV25856",
    "droptype": "D",
    "dropname": "CLAYVILLE",
    "dropdeladd": "479 FIELD HILL RD",
    "dropdelcty": "CLAYVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028151107",
    "dropphyadd": "479 FIELD HILL RD",
    "dropphycty": "CLAYVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028151107",
    "dropmaladd": "479 FIELD HILL RD",
    "dropmalcty": "CLAYVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028151107",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016479184,
    "dropfax": 4016472885
  },
  {
    "dcode": "D",
    "dropkey": "PV25859",
    "droptype": "D",
    "dropname": "COVENTRY",
    "dropdeladd": "1550 NOOSENECK HILL RD",
    "dropdelcty": "COVENTRY",
    "dropdelst": "RI",
    "dropdelzpp": "028169998",
    "dropphyadd": "1550 NOOSENECK HILL RD",
    "dropphycty": "COVENTRY",
    "dropphyst": "RI",
    "dropphyzpp": "028169998",
    "dropmaladd": "1550 NOOSENECK HILL RD",
    "dropmalcty": "COVENTRY",
    "dropmalst": "RI",
    "dropmalzpp": "028169998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018217208,
    "dropfax": 4018268110
  },
  {
    "dcode": "D",
    "dropkey": "PV25867",
    "droptype": "D",
    "dropname": "EAST GREENWICH",
    "dropdeladd": "5775 POST RD",
    "dropdelcty": "EAST GREENWICH",
    "dropdelst": "RI",
    "dropdelzpp": "028189998",
    "dropphyadd": "5775 POST RD",
    "dropphycty": "EAST GREENWICH",
    "dropphyst": "RI",
    "dropphyzpp": "028189998",
    "dropmaladd": "5775 POST RD",
    "dropmalcty": "EAST GREENWICH",
    "dropmalst": "RI",
    "dropmalzpp": "028189998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018843962,
    "dropfax": 4018869552
  },
  {
    "dcode": "D",
    "dropkey": "PV25877",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "260 S COUNTY TRL",
    "dropdelcty": "EXETER",
    "dropdelst": "RI",
    "dropdelzpp": "028223500",
    "dropphyadd": "260 S COUNTY TRL",
    "dropphycty": "EXETER",
    "dropphyst": "RI",
    "dropphyzpp": "028223500",
    "dropmaladd": "260 S COUNTY TRL",
    "dropmalcty": "EXETER",
    "dropmalst": "RI",
    "dropmalzpp": "028223500",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012959381,
    "dropfax": 4012947950
  },
  {
    "dcode": "D",
    "dropkey": "PV25879",
    "droptype": "D",
    "dropname": "FISKEVILLE",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "FISKEVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028239800",
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "FISKEVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028239800",
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "FISKEVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028239800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018285434,
    "dropfax": 4018281282
  },
  {
    "dcode": "D",
    "dropkey": "PV25880",
    "droptype": "D",
    "dropname": "FORESTDALE",
    "dropdeladd": "134 SCHOOL ST",
    "dropdelcty": "FORESTDALE",
    "dropdelst": "RI",
    "dropdelzpp": "028249800",
    "dropphyadd": "134 SCHOOL ST",
    "dropphycty": "FORESTDALE",
    "dropphyst": "RI",
    "dropphyzpp": "028249800",
    "dropmaladd": "134 SCHOOL ST",
    "dropmalcty": "FORESTDALE",
    "dropmalst": "RI",
    "dropmalzpp": "028249800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017694618,
    "dropfax": 4017694618
  },
  {
    "dcode": "D",
    "dropkey": "PV25881",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "81 FOSTER CENTER RD",
    "dropdelcty": "FOSTER",
    "dropdelst": "RI",
    "dropdelzpp": "028251326",
    "dropphyadd": "81 FOSTER CENTER RD",
    "dropphycty": "FOSTER",
    "dropphyst": "RI",
    "dropphyzpp": "028251326",
    "dropmaladd": "81 FOSTER CENTER RD",
    "dropmalcty": "FOSTER",
    "dropmalst": "RI",
    "dropmalzpp": "028251326",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013971975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25885",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "1916 VICTORY HWY",
    "dropdelcty": "GLENDALE",
    "dropdelst": "RI",
    "dropdelzpp": "028269800",
    "dropphyadd": "1916 VICTORY HWY",
    "dropphycty": "GLENDALE",
    "dropphyst": "RI",
    "dropphyzpp": "028269800",
    "dropmaladd": "1916 VICTORY HWY",
    "dropmalcty": "GLENDALE",
    "dropmalst": "RI",
    "dropmalzpp": "028269800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015688782,
    "dropfax": 4015680518
  },
  {
    "dcode": "D",
    "dropkey": "PV25889",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "1 AUSTIN AVE REAR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028289998",
    "dropphyadd": "1 AUSTIN AVE REAR",
    "dropphycty": "GREENVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028289998",
    "dropmaladd": "1 AUSTIN AVE REAR",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028289998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4019491345,
    "dropfax": 4019495353
  },
  {
    "dcode": "D",
    "dropkey": "PV25890",
    "droptype": "D",
    "dropname": "HARMONY",
    "dropdeladd": "391 PUTNAM PIKE",
    "dropdelcty": "HARMONY",
    "dropdelst": "RI",
    "dropdelzpp": "028299800",
    "dropphyadd": "391 PUTNAM PIKE",
    "dropphycty": "HARMONY",
    "dropphyst": "RI",
    "dropphyzpp": "028299800",
    "dropmaladd": "391 PUTNAM PIKE",
    "dropmalcty": "HARMONY",
    "dropmalst": "RI",
    "dropmalzpp": "028299800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4019492745,
    "dropfax": 4019494149
  },
  {
    "dcode": "D",
    "dropkey": "PV25891",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "131 HARRISVILLE MAIN ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028309998",
    "dropphyadd": "131 HARRISVILLE MAIN ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028309998",
    "dropmaladd": "131 HARRISVILLE MAIN ST",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028309998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015679278,
    "dropfax": 4015679279
  },
  {
    "dcode": "D",
    "dropkey": "PV25893",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "134 JACKSON FLAT RD",
    "dropdelcty": "HOPE",
    "dropdelst": "RI",
    "dropdelzpp": "028319998",
    "dropphyadd": "134 JACKSON FLAT RD",
    "dropphycty": "HOPE",
    "dropphyst": "RI",
    "dropphyzpp": "028319998",
    "dropmaladd": "134 JACKSON FLAT RD",
    "dropmalcty": "HOPE",
    "dropmalst": "RI",
    "dropmalzpp": "028319998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018286105,
    "dropfax": 4018212848
  },
  {
    "dcode": "D",
    "dropkey": "PV25894",
    "droptype": "D",
    "dropname": "HOPE VALLEY",
    "dropdeladd": "1027 MAIN ST",
    "dropdelcty": "HOPE VALLEY",
    "dropdelst": "RI",
    "dropdelzpp": "028329998",
    "dropphyadd": "1027 MAIN ST",
    "dropphycty": "HOPE VALLEY",
    "dropphyst": "RI",
    "dropphyzpp": "028329998",
    "dropmaladd": "1027 MAIN ST",
    "dropmalcty": "HOPE VALLEY",
    "dropmalst": "RI",
    "dropmalzpp": "028329998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015397895,
    "dropfax": 4015398530
  },
  {
    "dcode": "D",
    "dropkey": "PV25897",
    "droptype": "D",
    "dropname": "HOPKINTON",
    "dropdeladd": "482 MAIN ST",
    "dropdelcty": "HOPKINTON",
    "dropdelst": "RI",
    "dropdelzpp": "028339800",
    "dropphyadd": "482 MAIN ST",
    "dropphycty": "HOPKINTON",
    "dropphyst": "RI",
    "dropphyzpp": "028339800",
    "dropmaladd": "482 MAIN ST",
    "dropmalcty": "HOPKINTON",
    "dropmalst": "RI",
    "dropmalzpp": "028339800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013778084,
    "dropfax": 4013778439
  },
  {
    "dcode": "D",
    "dropkey": "PV25899",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "109 NARRAGANSETT AVE",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "RI",
    "dropdelzpp": "028359998",
    "dropphyadd": "109 NARRAGANSETT AVE",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "RI",
    "dropphyzpp": "028359998",
    "dropmaladd": "109 NARRAGANSETT AVE",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "RI",
    "dropmalzpp": "028359998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014230420,
    "dropfax": 4014233430
  },
  {
    "dcode": "D",
    "dropkey": "PV25906",
    "droptype": "D",
    "dropname": "LITTLE COMPTON",
    "dropdeladd": "4 S OF COMMONS RD",
    "dropdelcty": "LITTLE COMPTON",
    "dropdelst": "RI",
    "dropdelzpp": "028379998",
    "dropphyadd": "4 S OF COMMONS RD",
    "dropphycty": "LITTLE COMPTON",
    "dropphyst": "RI",
    "dropphyzpp": "028379998",
    "dropmaladd": "4 S OF COMMONS RD",
    "dropmalcty": "LITTLE COMPTON",
    "dropmalst": "RI",
    "dropmalzpp": "028379998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016354310,
    "dropfax": 4016358471
  },
  {
    "dcode": "D",
    "dropkey": "PV25908",
    "droptype": "D",
    "dropname": "MANVILLE",
    "dropdeladd": "30 RAILROAD ST STE 3",
    "dropdelcty": "MANVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028389998",
    "dropphyadd": "30 RAILROAD ST STE 3",
    "dropphycty": "MANVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028389998",
    "dropmaladd": "30 RAILROAD ST STE 3",
    "dropmalcty": "MANVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028389998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017650851,
    "dropfax": 4017625484
  },
  {
    "dcode": "D",
    "dropkey": "PV25909",
    "droptype": "D",
    "dropname": "MAPLEVILLE",
    "dropdeladd": "963 VICTORY HWY",
    "dropdelcty": "MAPLEVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028391180",
    "dropphyadd": "963 VICTORY HWY",
    "dropphycty": "MAPLEVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028391180",
    "dropmaladd": "963 VICTORY HWY",
    "dropmalcty": "MAPLEVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028391180",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015687312,
    "dropfax": 4015687316
  },
  {
    "dcode": "D",
    "dropkey": "PV25919",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "320 THAMES ST STE 1",
    "dropdelcty": "NEWPORT",
    "dropdelst": "RI",
    "dropdelzpp": "028409998",
    "dropphyadd": "320 THAMES ST STE 1",
    "dropphycty": "NEWPORT",
    "dropphyst": "RI",
    "dropphyzpp": "028409998",
    "dropmaladd": "320 THAMES ST STE 1",
    "dropmalcty": "NEWPORT",
    "dropmalst": "RI",
    "dropmalzpp": "028409998",
    "dropsitphn": 4018479835,
    "dropsitlph": 4018479835,
    "dropsitcph": 4018479835,
    "dropfax": 4018467281
  },
  {
    "dcode": "D",
    "dropkey": "PV25921",
    "droptype": "D",
    "dropname": "NORTH KINGSTOWN",
    "dropdeladd": "7715 POST RD",
    "dropdelcty": "NORTH KINGSTOWN",
    "dropdelst": "RI",
    "dropdelzpp": "028529998",
    "dropphyadd": "7715 POST RD",
    "dropphycty": "NORTH KINGSTOWN",
    "dropphyst": "RI",
    "dropphyzpp": "028529998",
    "dropmaladd": "7715 POST RD",
    "dropmalcty": "NORTH KINGSTOWN",
    "dropmalst": "RI",
    "dropmalzpp": "028529998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012945842,
    "dropfax": 4012949679
  },
  {
    "dcode": "D",
    "dropkey": "PV25924",
    "droptype": "D",
    "dropname": "NORTH SCITUATE",
    "dropdeladd": "175 DANIELSON PIKE",
    "dropdelcty": "NORTH SCITUATE",
    "dropdelst": "RI",
    "dropdelzpp": "028571961",
    "dropphyadd": "175 DANIELSON PIKE",
    "dropphycty": "NORTH SCITUATE",
    "dropphyst": "RI",
    "dropphyzpp": "028571961",
    "dropmaladd": "175 DANIELSON PIKE",
    "dropmalcty": "NORTH SCITUATE",
    "dropmalst": "RI",
    "dropmalzpp": "028571961",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016479215,
    "dropfax": 4016475879
  },
  {
    "dcode": "D",
    "dropkey": "PV25928",
    "droptype": "D",
    "dropname": "PASCOAG",
    "dropdeladd": "35 BRIDGE WAY",
    "dropdelcty": "PASCOAG",
    "dropdelst": "RI",
    "dropdelzpp": "028593132",
    "dropphyadd": "35 BRIDGE WAY",
    "dropphycty": "PASCOAG",
    "dropphyst": "RI",
    "dropphyzpp": "028593132",
    "dropmaladd": "35 BRIDGE WAY",
    "dropmalcty": "PASCOAG",
    "dropmalst": "RI",
    "dropmalzpp": "028593132",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015688790,
    "dropfax": 4015686841
  },
  {
    "dcode": "D",
    "dropkey": "PV25929",
    "droptype": "D",
    "dropname": "PAWTUCKET",
    "dropdeladd": "40 MONTGOMERY ST",
    "dropdelcty": "PAWTUCKET",
    "dropdelst": "RI",
    "dropdelzpp": "028609998",
    "dropphyadd": "40 MONTGOMERY ST",
    "dropphycty": "PAWTUCKET",
    "dropphyst": "RI",
    "dropphyzpp": "028609998",
    "dropmaladd": "40 MONTGOMERY ST",
    "dropmalcty": "PAWTUCKET",
    "dropmalst": "RI",
    "dropmalzpp": "028609998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017297808,
    "dropfax": 4017297843
  },
  {
    "dcode": "D",
    "dropkey": "PV25933",
    "droptype": "D",
    "dropname": "PORTSMOUTH",
    "dropdeladd": "95 CHASE RD",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "RI",
    "dropdelzpp": "028719998",
    "dropphyadd": "95 CHASE RD",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "RI",
    "dropphyzpp": "028719998",
    "dropmaladd": "95 CHASE RD",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "RI",
    "dropmalzpp": "028719998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016836803,
    "dropfax": 4016835547
  },
  {
    "dcode": "D",
    "dropkey": "PV25936",
    "droptype": "D",
    "dropname": "PROVIDENCE",
    "dropdeladd": "24 CORLISS ST REAR DOCK",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029042477",
    "dropphyadd": "24 CORLISS ST RM 100",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029042477",
    "dropmaladd": "24 CORLISS ST RM 100",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029042477",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012768619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25947",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "332 CANONCHET RD",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028731015",
    "dropphyadd": "332 CANONCHET RD",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028731015",
    "dropmaladd": "332 CANONCHET RD",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028731015",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015398676,
    "dropfax": 4015397672
  },
  {
    "dcode": "D",
    "dropkey": "PV25949",
    "droptype": "D",
    "dropname": "SAUNDERSTOWN",
    "dropdeladd": "20 FERRY RD",
    "dropdelcty": "SAUNDERSTOWN",
    "dropdelst": "RI",
    "dropdelzpp": "028743818",
    "dropphyadd": "20 FERRY RD",
    "dropphycty": "SAUNDERSTOWN",
    "dropphyst": "RI",
    "dropphyzpp": "028743818",
    "dropmaladd": "20 FERRY RD",
    "dropmalcty": "SAUNDERSTOWN",
    "dropmalst": "RI",
    "dropmalzpp": "028743818",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012943761,
    "dropfax": 4012954918
  },
  {
    "dcode": "D",
    "dropkey": "PV25951",
    "droptype": "D",
    "dropname": "SHANNOCK",
    "dropdeladd": "196A SHANNOCK VILLAGE RD",
    "dropdelcty": "SHANNOCK",
    "dropdelst": "RI",
    "dropdelzpp": "028751001",
    "dropphyadd": "196A SHANNOCK VILLAGE RD",
    "dropphycty": "SHANNOCK",
    "dropphyst": "RI",
    "dropphyzpp": "028751001",
    "dropmaladd": "196A SHANNOCK VILLAGE RD",
    "dropmalcty": "SHANNOCK",
    "dropmalst": "RI",
    "dropmalzpp": "028751001",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013645240,
    "dropfax": 4013649574
  },
  {
    "dcode": "D",
    "dropkey": "PV25952",
    "droptype": "D",
    "dropname": "SLATERSVILLE",
    "dropdeladd": "42 MAIN ST",
    "dropdelcty": "SLATERSVILLE",
    "dropdelst": "RI",
    "dropdelzpp": "028769800",
    "dropphyadd": "42 MAIN ST",
    "dropphycty": "SLATERSVILLE",
    "dropphyst": "RI",
    "dropphyzpp": "028769800",
    "dropmaladd": "42 MAIN ST",
    "dropmalcty": "SLATERSVILLE",
    "dropmalst": "RI",
    "dropmalzpp": "028769800",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017672699,
    "dropfax": 4017670719
  },
  {
    "dcode": "D",
    "dropkey": "PV25953",
    "droptype": "D",
    "dropname": "SLOCUM",
    "dropdeladd": "743 INDIAN CORNER RD",
    "dropdelcty": "SLOCUM",
    "dropdelst": "RI",
    "dropdelzpp": "028771041",
    "dropphyadd": "743 INDIAN CORNER RD",
    "dropphycty": "SLOCUM",
    "dropphyst": "RI",
    "dropphyzpp": "028771041",
    "dropmaladd": "743 INDIAN CORNER RD",
    "dropmalcty": "SLOCUM",
    "dropmalst": "RI",
    "dropmalzpp": "028771041",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012958698,
    "dropfax": 4012948485
  },
  {
    "dcode": "D",
    "dropkey": "PV25965",
    "droptype": "D",
    "dropname": "TIVERTON",
    "dropdeladd": "600 MAIN RD",
    "dropdelcty": "TIVERTON",
    "dropdelst": "RI",
    "dropdelzpp": "028789998",
    "dropphyadd": "600 MAIN RD",
    "dropphycty": "TIVERTON",
    "dropphyst": "RI",
    "dropphyzpp": "028789998",
    "dropmaladd": "600 MAIN RD",
    "dropmalcty": "TIVERTON",
    "dropmalst": "RI",
    "dropmalzpp": "028789998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4016246839,
    "dropfax": 4016251653
  },
  {
    "dcode": "D",
    "dropkey": "PV25967",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "551 KINGSTOWN RD",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "RI",
    "dropdelzpp": "028799994",
    "dropphyadd": "551 KINGSTOWN RD",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "RI",
    "dropphyzpp": "028799994",
    "dropmaladd": "551 KINGSTOWN RD",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "RI",
    "dropmalzpp": "028799994",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017831091,
    "dropfax": 4017835059
  },
  {
    "dcode": "D",
    "dropkey": "PV25968",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "53 CHILD ST",
    "dropdelcty": "WARREN",
    "dropdelst": "RI",
    "dropdelzpp": "028859998",
    "dropphyadd": "53 CHILD ST",
    "dropphycty": "WARREN",
    "dropphyst": "RI",
    "dropphyzpp": "028859998",
    "dropmaladd": "53 CHILD ST",
    "dropmalcty": "WARREN",
    "dropmalst": "RI",
    "dropmalzpp": "028859998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4012450601,
    "dropfax": 4012459657
  },
  {
    "dcode": "D",
    "dropkey": "PV25969",
    "droptype": "D",
    "dropname": "WARWICK",
    "dropdeladd": "325 STRAWBERRY FIELD RD",
    "dropdelcty": "WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028869998",
    "dropphyadd": "325 STRAWBERRY FIELD RD",
    "dropphycty": "WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028869998",
    "dropmaladd": "325 STRAWBERRY FIELD RD",
    "dropmalcty": "WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028869998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014681077,
    "dropfax": 4014681078
  },
  {
    "dcode": "D",
    "dropkey": "PV25976",
    "droptype": "D",
    "dropname": "WEST KINGSTON",
    "dropdeladd": "3484 KINGSTOWN RD",
    "dropdelcty": "WEST KINGSTON",
    "dropdelst": "RI",
    "dropdelzpp": "028921408",
    "dropphyadd": "3484 KINGSTOWN RD",
    "dropphycty": "WEST KINGSTON",
    "dropphyst": "RI",
    "dropphyzpp": "028921408",
    "dropmaladd": "3484 KINGSTOWN RD",
    "dropmalcty": "WEST KINGSTON",
    "dropmalst": "RI",
    "dropmalzpp": "028921408",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017820189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25977",
    "droptype": "D",
    "dropname": "WEST WARWICK",
    "dropdeladd": "100 WASHINGTON ST",
    "dropdelcty": "WEST WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028939998",
    "dropphyadd": "100 WASHINGTON ST",
    "dropphycty": "WEST WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028939998",
    "dropmaladd": "100 WASHINGTON ST",
    "dropmalcty": "WEST WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028939998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018280592,
    "dropfax": 4018285274
  },
  {
    "dcode": "D",
    "dropkey": "PV25978",
    "droptype": "D",
    "dropname": "WESTERLY",
    "dropdeladd": "110 TOM HARVEY RD",
    "dropdelcty": "WESTERLY",
    "dropdelst": "RI",
    "dropdelzpp": "028919998",
    "dropphyadd": "110 TOM HARVEY RD",
    "dropphycty": "WESTERLY",
    "dropphyst": "RI",
    "dropphyzpp": "028919998",
    "dropmaladd": "110 TOM HARVEY RD",
    "dropmalcty": "WESTERLY",
    "dropmalst": "RI",
    "dropmalzpp": "028919998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015961181,
    "dropfax": 4013488342
  },
  {
    "dcode": "D",
    "dropkey": "PV25982",
    "droptype": "D",
    "dropname": "WOOD RIVER JUNCTION",
    "dropdeladd": "446 CHURCH ST",
    "dropdelcty": "WOOD RIVER JUNCTION",
    "dropdelst": "RI",
    "dropdelzpp": "028941206",
    "dropphyadd": "446 CHURCH ST",
    "dropphycty": "WOOD RIVER JUNCTION",
    "dropphyst": "RI",
    "dropphyzpp": "028941206",
    "dropmaladd": "446 CHURCH ST",
    "dropmalcty": "WOOD RIVER JUNCTION",
    "dropmalst": "RI",
    "dropmalzpp": "028941206",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013647960,
    "dropfax": 4013647960
  },
  {
    "dcode": "D",
    "dropkey": "PV25983",
    "droptype": "D",
    "dropname": "WOONSOCKET",
    "dropdeladd": "127 SOCIAL ST STE 1",
    "dropdelcty": "WOONSOCKET",
    "dropdelst": "RI",
    "dropdelzpp": "028959998",
    "dropphyadd": "127 SOCIAL ST STE 1",
    "dropphycty": "WOONSOCKET",
    "dropphyst": "RI",
    "dropphyzpp": "028959998",
    "dropmaladd": "127 SOCIAL ST STE 1",
    "dropmalcty": "WOONSOCKET",
    "dropmalst": "RI",
    "dropmalzpp": "028959998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017696853,
    "dropfax": 4017666631
  },
  {
    "dcode": "D",
    "dropkey": "PV25984",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "1190 MAIN ST",
    "dropdelcty": "WYOMING",
    "dropdelst": "RI",
    "dropdelzpp": "028981074",
    "dropphyadd": "1190 MAIN ST",
    "dropphycty": "WYOMING",
    "dropphyst": "RI",
    "dropphyzpp": "028981074",
    "dropmaladd": "1190 MAIN ST",
    "dropmalcty": "WYOMING",
    "dropmalst": "RI",
    "dropmalzpp": "028981074",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015398598,
    "dropfax": 4015398930
  },
  {
    "dcode": "D",
    "dropkey": "PV25990",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "803 MAIN ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "VT",
    "dropdelzpp": "058209998",
    "dropphyadd": "803 MAIN ST",
    "dropphycty": "ALBANY",
    "dropphyst": "VT",
    "dropphyzpp": "058209998",
    "dropmaladd": "803 MAIN ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "VT",
    "dropmalzpp": "058209998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027556791,
    "dropsitcph": 8027556791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV25993",
    "droptype": "D",
    "dropname": "ALBURGH",
    "dropdeladd": "12 S MAIN ST",
    "dropdelcty": "ALBURGH",
    "dropdelst": "VT",
    "dropdelzpp": "054409998",
    "dropphyadd": "12 S MAIN ST",
    "dropphycty": "ALBURGH",
    "dropphyst": "VT",
    "dropphyzpp": "054409998",
    "dropmaladd": "12 S MAIN ST",
    "dropmalcty": "ALBURGH",
    "dropmalst": "VT",
    "dropmalzpp": "054409998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027963489,
    "dropsitcph": 8027963489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26004",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "3575 VT ROUTE 7A",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "052509998",
    "dropphyadd": "3575 VT ROUTE 7A",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "052509998",
    "dropmaladd": "3575 VT ROUTE 7A",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "052509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023756904,
    "dropsitcph": 8023756904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26009",
    "droptype": "D",
    "dropname": "ASCUTNEY",
    "dropdeladd": "5159 ROUTE 5",
    "dropdelcty": "ASCUTNEY",
    "dropdelst": "VT",
    "dropdelzpp": "050309998",
    "dropphyadd": "5159 ROUTE 5",
    "dropphycty": "ASCUTNEY",
    "dropphyst": "VT",
    "dropphyzpp": "050309998",
    "dropmaladd": "5159 ROUTE 5",
    "dropmalcty": "ASCUTNEY",
    "dropmalst": "VT",
    "dropmalzpp": "050309998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026745308,
    "dropsitcph": 8026745308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26013",
    "droptype": "D",
    "dropname": "BAKERSFIELD",
    "dropdeladd": "65 MAIN ST N",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "054419998",
    "dropphyadd": "65 MAIN ST N",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "054419998",
    "dropmaladd": "65 MAIN ST N",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "054419998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028273262,
    "dropsitcph": 8028273262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26016",
    "droptype": "D",
    "dropname": "BARNARD",
    "dropdeladd": "6430 STAGE RD UNIT 1",
    "dropdelcty": "BARNARD",
    "dropdelst": "VT",
    "dropdelzpp": "050319998",
    "dropphyadd": "6430 STAGE RD UNIT 1",
    "dropphycty": "BARNARD",
    "dropphyst": "VT",
    "dropphyzpp": "050319998",
    "dropmaladd": "6430 STAGE RD UNIT 1",
    "dropmalcty": "BARNARD",
    "dropmalst": "VT",
    "dropmalzpp": "050319998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022345404,
    "dropsitcph": 8022345404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26017",
    "droptype": "D",
    "dropname": "BARNET",
    "dropdeladd": "30 MONUMENT CIR",
    "dropdelcty": "BARNET",
    "dropdelst": "VT",
    "dropdelzpp": "058219998",
    "dropphyadd": "30 MONUMENT CIR",
    "dropphycty": "BARNET",
    "dropphyst": "VT",
    "dropphyzpp": "058219998",
    "dropmaladd": "30 MONUMENT CIR",
    "dropmalcty": "BARNET",
    "dropmalst": "VT",
    "dropmalzpp": "058219998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026334000,
    "dropsitcph": 8026334000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26022",
    "droptype": "D",
    "dropname": "BARRE",
    "dropdeladd": "3 S MAIN ST",
    "dropdelcty": "BARRE",
    "dropdelst": "VT",
    "dropdelzpp": "056419998",
    "dropphyadd": "3 S MAIN ST",
    "dropphycty": "BARRE",
    "dropphyst": "VT",
    "dropphyzpp": "056419998",
    "dropmaladd": "3 S MAIN ST",
    "dropmalcty": "BARRE",
    "dropmalst": "VT",
    "dropmalzpp": "056419998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024799334,
    "dropsitcph": 8024799334,
    "dropfax": 8024795933
  },
  {
    "dcode": "D",
    "dropkey": "PV26027",
    "droptype": "D",
    "dropname": "BARTON",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "BARTON",
    "dropdelst": "VT",
    "dropdelzpp": "058229998",
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "BARTON",
    "dropphyst": "VT",
    "dropphyzpp": "058229998",
    "dropmaladd": "405 MAIN ST",
    "dropmalcty": "BARTON",
    "dropmalst": "VT",
    "dropmalzpp": "058229998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025256262,
    "dropsitcph": 8025256262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26035",
    "droptype": "D",
    "dropname": "BEEBE PLAIN",
    "dropdeladd": "3141 BEEBE RD",
    "dropdelcty": "BEEBE PLAIN",
    "dropdelst": "VT",
    "dropdelzpp": "058239998",
    "dropphyadd": "3141 BEEBE RD",
    "dropphycty": "BEEBE PLAIN",
    "dropphyst": "VT",
    "dropphyzpp": "058239998",
    "dropmaladd": "3141 BEEBE RD",
    "dropmalcty": "BEEBE PLAIN",
    "dropmalst": "VT",
    "dropmalzpp": "058239998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028737049,
    "dropsitcph": 8028737049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26037",
    "droptype": "D",
    "dropname": "BEECHER FALLS",
    "dropdeladd": "1110 VERMONT ROUTE 253",
    "dropdelcty": "BEECHER FALLS",
    "dropdelst": "VT",
    "dropdelzpp": "059029998",
    "dropphyadd": "1110 VERMONT ROUTE 253",
    "dropphycty": "BEECHER FALLS",
    "dropphyst": "VT",
    "dropphyzpp": "059029998",
    "dropmaladd": "1110 VERMONT ROUTE 253",
    "dropmalcty": "BEECHER FALLS",
    "dropmalst": "VT",
    "dropmalzpp": "059029998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022663037,
    "dropsitcph": 8022663037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26041",
    "droptype": "D",
    "dropname": "BELLOWS FALLS",
    "dropdeladd": "7 BRIDGE ST",
    "dropdelcty": "BELLOWS FALLS",
    "dropdelst": "VT",
    "dropdelzpp": "051019998",
    "dropphyadd": "7 BRIDGE ST",
    "dropphycty": "BELLOWS FALLS",
    "dropphyst": "VT",
    "dropphyzpp": "051019998",
    "dropmaladd": "7 BRIDGE ST",
    "dropmalcty": "BELLOWS FALLS",
    "dropmalst": "VT",
    "dropmalzpp": "051019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024633664,
    "dropsitcph": 8024633664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26044",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "2400 BELMONT RD",
    "dropdelcty": "BELMONT",
    "dropdelst": "VT",
    "dropdelzpp": "057309998",
    "dropphyadd": "2400 BELMONT RD",
    "dropphycty": "BELMONT",
    "dropphyst": "VT",
    "dropphyzpp": "057309998",
    "dropmaladd": "2400 BELMONT RD",
    "dropmalcty": "BELMONT",
    "dropmalst": "VT",
    "dropmalzpp": "057309998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022191290,
    "dropsitcph": 8022191290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26052",
    "droptype": "D",
    "dropname": "BENNINGTON",
    "dropdeladd": "108 ELM ST",
    "dropdelcty": "BENNINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "052019998",
    "dropphyadd": "108 ELM ST",
    "dropphycty": "BENNINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "052019998",
    "dropmaladd": "108 ELM ST",
    "dropmalcty": "BENNINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "052019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024422421,
    "dropsitcph": 8024422421,
    "dropfax": 8024421220
  },
  {
    "dcode": "D",
    "dropkey": "PV26062",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "34 N MAIN ST",
    "dropdelcty": "BETHEL",
    "dropdelst": "VT",
    "dropdelzpp": "050329998",
    "dropphyadd": "34 N MAIN ST",
    "dropphycty": "BETHEL",
    "dropphyst": "VT",
    "dropphyzpp": "050329998",
    "dropmaladd": "34 N MAIN ST",
    "dropmalcty": "BETHEL",
    "dropmalst": "VT",
    "dropmalzpp": "050329998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022349887,
    "dropsitcph": 8022349887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26073",
    "droptype": "D",
    "dropname": "BOMOSEEN",
    "dropdeladd": "63 ROUTE 4A W",
    "dropdelcty": "BOMOSEEN",
    "dropdelst": "VT",
    "dropdelzpp": "057329998",
    "dropphyadd": "63 ROUTE 4A W",
    "dropphycty": "BOMOSEEN",
    "dropphyst": "VT",
    "dropphyzpp": "057329998",
    "dropmaladd": "63 ROUTE 4A W",
    "dropmalcty": "BOMOSEEN",
    "dropmalst": "VT",
    "dropmalzpp": "057329998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024685558,
    "dropsitcph": 8024685558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26074",
    "droptype": "D",
    "dropname": "BONDVILLE",
    "dropdeladd": "43 VT ROUTE 30",
    "dropdelcty": "BONDVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "053409998",
    "dropphyadd": "43 VT ROUTE 30",
    "dropphycty": "BONDVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "053409998",
    "dropmaladd": "43 VT ROUTE 30",
    "dropmalcty": "BONDVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "053409998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022971671,
    "dropsitcph": 8022971671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26080",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "41 BARTON ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050339998",
    "dropphyadd": "41 BARTON ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050339998",
    "dropmaladd": "41 BARTON ST",
    "dropmalcty": "BRADFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050339998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022224414,
    "dropsitcph": 8022224414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26085",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "32 CONANT SQ",
    "dropdelcty": "BRANDON",
    "dropdelst": "VT",
    "dropdelzpp": "057339998",
    "dropphyadd": "32 CONANT SQ",
    "dropphycty": "BRANDON",
    "dropphyst": "VT",
    "dropphyzpp": "057339998",
    "dropmaladd": "32 CONANT SQ",
    "dropmalcty": "BRANDON",
    "dropmalst": "VT",
    "dropmalzpp": "057339998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022476666,
    "dropsitcph": 8022476666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26086",
    "droptype": "D",
    "dropname": "BRATTLEBORO",
    "dropdeladd": "204 MAIN ST STE JJ",
    "dropdelcty": "BRATTLEBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053019998",
    "dropphyadd": "204 MAIN ST STE JJ",
    "dropphycty": "BRATTLEBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053019998",
    "dropmaladd": "204 MAIN ST STE JJ",
    "dropmalcty": "BRATTLEBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022544110,
    "dropsitcph": 8022544110,
    "dropfax": 8022541353
  },
  {
    "dcode": "D",
    "dropkey": "PV26094",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "102 MILL RD",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "VT",
    "dropdelzpp": "050349998",
    "dropphyadd": "102 MILL RD",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "VT",
    "dropphyzpp": "050349998",
    "dropmaladd": "102 MILL RD",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "VT",
    "dropmalzpp": "050349998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022191405,
    "dropsitcph": 8022191405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26096",
    "droptype": "D",
    "dropname": "BRIDGEWATER CORNERS",
    "dropdeladd": "39 VT ROUTE 100A",
    "dropdelcty": "BRIDGEWATER CORNERS",
    "dropdelst": "VT",
    "dropdelzpp": "050359998",
    "dropphyadd": "39 VT ROUTE 100A",
    "dropphycty": "BRIDGEWATER CORNERS",
    "dropphyst": "VT",
    "dropphyzpp": "050359998",
    "dropmaladd": "39 VT ROUTE 100A",
    "dropmalcty": "BRIDGEWATER CORNERS",
    "dropmalst": "VT",
    "dropmalzpp": "050359998",
    "dropsitphn": 8022191431,
    "dropsitlph": 8022191537,
    "dropsitcph": 8022191537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26099",
    "droptype": "D",
    "dropname": "BRIDPORT",
    "dropdeladd": "3039 VT ROUTE 22A",
    "dropdelcty": "BRIDPORT",
    "dropdelst": "VT",
    "dropdelzpp": "057349998",
    "dropphyadd": "3039 VT ROUTE 22A",
    "dropphycty": "BRIDPORT",
    "dropphyst": "VT",
    "dropphyzpp": "057349998",
    "dropmaladd": "3039 VT ROUTE 22A",
    "dropmalcty": "BRIDPORT",
    "dropmalst": "VT",
    "dropmalzpp": "057349998",
    "dropsitphn": 8023522007,
    "dropsitlph": 8023522007,
    "dropsitcph": 8023522012,
    "dropfax": 8023522009
  },
  {
    "dcode": "D",
    "dropkey": "PV26103",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "11 WEST ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "VT",
    "dropdelzpp": "054439998",
    "dropphyadd": "11 WEST ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "VT",
    "dropphyzpp": "054439998",
    "dropmaladd": "11 WEST ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "VT",
    "dropmalzpp": "054439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022252018,
    "dropsitcph": 8022252018,
    "dropfax": 8024534780
  },
  {
    "dcode": "D",
    "dropkey": "PV26110",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "1870 VT ROUTE 65",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "050369998",
    "dropphyadd": "1870 VT ROUTE 65",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "050369998",
    "dropmaladd": "1870 VT ROUTE 65",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "050369998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022763033,
    "dropsitcph": 8022763033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26121",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "1269 ROUTE 44",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "050379998",
    "dropphyadd": "1269 ROUTE 44",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "050379998",
    "dropmaladd": "1269 ROUTE 44",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "050379998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024845057,
    "dropsitcph": 8024845057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26133",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "11 ELMWOOD AVE LBBY",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054019998",
    "dropphyadd": "11 ELMWOOD AVE LBBY",
    "dropphycty": "BURLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054019998",
    "dropmaladd": "11 ELMWOOD AVE LBBY",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026581176,
    "dropsitcph": 8028636033,
    "dropfax": 8028642011
  },
  {
    "dcode": "D",
    "dropkey": "PV26140",
    "droptype": "D",
    "dropname": "CABOT",
    "dropdeladd": "3123 MAIN ST",
    "dropdelcty": "CABOT",
    "dropdelst": "VT",
    "dropdelzpp": "056479998",
    "dropphyadd": "3123 MAIN ST",
    "dropphycty": "CABOT",
    "dropphyst": "VT",
    "dropphyzpp": "056479998",
    "dropmaladd": "3123 MAIN ST",
    "dropmalcty": "CABOT",
    "dropmalst": "VT",
    "dropmalzpp": "056479998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025639929,
    "dropsitcph": 8025639929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26142",
    "droptype": "D",
    "dropname": "CALAIS",
    "dropdeladd": "31 W COUNTY RD UNIT 2",
    "dropdelcty": "CALAIS",
    "dropdelst": "VT",
    "dropdelzpp": "056489998",
    "dropphyadd": "31 W COUNTY RD UNIT 2",
    "dropphycty": "CALAIS",
    "dropphyst": "VT",
    "dropphyzpp": "056489998",
    "dropmaladd": "31 W COUNTY RD UNIT 2",
    "dropmalcty": "CALAIS",
    "dropmalst": "VT",
    "dropmalzpp": "056489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022235313,
    "dropsitcph": 8022235313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26145",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "27 MANSFIELD AVE",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "VT",
    "dropdelzpp": "054449998",
    "dropphyadd": "27 MANSFIELD AVE",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "VT",
    "dropphyzpp": "054449998",
    "dropmaladd": "27 MANSFIELD AVE",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "VT",
    "dropmalzpp": "054449998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026442965,
    "dropsitcph": 8026442965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26152",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "350 CHRISTIAN HL",
    "dropdelcty": "CANAAN",
    "dropdelst": "VT",
    "dropdelzpp": "059039998",
    "dropphyadd": "350 CHRISTIAN HL",
    "dropphycty": "CANAAN",
    "dropphyst": "VT",
    "dropphyzpp": "059039998",
    "dropmaladd": "350 CHRISTIAN HL",
    "dropmalcty": "CANAAN",
    "dropmalst": "VT",
    "dropmalzpp": "059039998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026844418,
    "dropsitcph": 8026844418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26154",
    "droptype": "D",
    "dropname": "CASTLETON",
    "dropdeladd": "576 MAIN ST",
    "dropdelcty": "CASTLETON",
    "dropdelst": "VT",
    "dropdelzpp": "057359998",
    "dropphyadd": "576 MAIN ST",
    "dropphycty": "CASTLETON",
    "dropphyst": "VT",
    "dropphyzpp": "057359998",
    "dropmaladd": "576 MAIN ST",
    "dropmalcty": "CASTLETON",
    "dropmalst": "VT",
    "dropmalzpp": "057359998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024685559,
    "dropsitcph": 8024685559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26156",
    "droptype": "D",
    "dropname": "CAVENDISH",
    "dropdeladd": "2025 MAIN ST",
    "dropdelcty": "CAVENDISH",
    "dropdelst": "VT",
    "dropdelzpp": "051429998",
    "dropphyadd": "2025 MAIN ST",
    "dropphycty": "CAVENDISH",
    "dropphyst": "VT",
    "dropphyzpp": "051429998",
    "dropmaladd": "2025 MAIN ST",
    "dropmalcty": "CAVENDISH",
    "dropmalst": "VT",
    "dropmalzpp": "051429998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022267238,
    "dropsitcph": 8022267238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26165",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "161 FERRY RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "VT",
    "dropdelzpp": "054459998",
    "dropphyadd": "161 FERRY RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "VT",
    "dropphyzpp": "054459998",
    "dropmaladd": "161 FERRY RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "VT",
    "dropmalzpp": "054459998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024252200,
    "dropsitcph": 8024252200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26166",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "298 VT RTE 110",
    "dropdelcty": "CHELSEA",
    "dropdelst": "VT",
    "dropdelzpp": "050389998",
    "dropphyadd": "298 VT RTE 110",
    "dropphycty": "CHELSEA",
    "dropphyst": "VT",
    "dropphyzpp": "050389998",
    "dropmaladd": "298 VT RTE 110",
    "dropmalcty": "CHELSEA",
    "dropmalst": "VT",
    "dropmalzpp": "050389998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026854666,
    "dropsitcph": 8026854666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26167",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "203 S MAIN ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "VT",
    "dropdelzpp": "051439998",
    "dropphyadd": "203 S MAIN ST",
    "dropphycty": "CHESTER",
    "dropphyst": "VT",
    "dropphyzpp": "051439998",
    "dropmaladd": "203 S MAIN ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "VT",
    "dropmalzpp": "051439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028753014,
    "dropsitcph": 8028753014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26180",
    "droptype": "D",
    "dropname": "CHITTENDEN",
    "dropdeladd": "198 CHITTENDEN RD",
    "dropdelcty": "CHITTENDEN",
    "dropdelst": "VT",
    "dropdelzpp": "057379998",
    "dropphyadd": "198 CHITTENDEN RD",
    "dropphycty": "CHITTENDEN",
    "dropphyst": "VT",
    "dropphyzpp": "057379998",
    "dropmaladd": "198 CHITTENDEN RD",
    "dropmalcty": "CHITTENDEN",
    "dropmalst": "VT",
    "dropmalzpp": "057379998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027752180,
    "dropsitcph": 8027752180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26189",
    "droptype": "D",
    "dropname": "COLCHESTER",
    "dropdeladd": "218 MALLETTS BAY AVE",
    "dropdelcty": "COLCHESTER",
    "dropdelst": "VT",
    "dropdelzpp": "054469998",
    "dropphyadd": "218 MALLETTS BAY AVE",
    "dropphycty": "COLCHESTER",
    "dropphyst": "VT",
    "dropphyzpp": "054469998",
    "dropmaladd": "218 MALLETTS BAY AVE",
    "dropmalcty": "COLCHESTER",
    "dropmalst": "VT",
    "dropmalzpp": "054469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026551376,
    "dropsitcph": 8026551376,
    "dropfax": 8026543901
  },
  {
    "dcode": "D",
    "dropkey": "PV26194",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "343 MAIN ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "VT",
    "dropdelzpp": "058249998",
    "dropphyadd": "343 MAIN ST",
    "dropphycty": "CONCORD",
    "dropphyst": "VT",
    "dropphyzpp": "058249998",
    "dropmaladd": "343 MAIN ST",
    "dropmalcty": "CONCORD",
    "dropmalst": "VT",
    "dropmalzpp": "058249998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026952994,
    "dropsitcph": 8026952994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26198",
    "droptype": "D",
    "dropname": "CORINTH",
    "dropdeladd": "1776 CENTER RD",
    "dropdelcty": "CORINTH",
    "dropdelst": "VT",
    "dropdelzpp": "050399998",
    "dropphyadd": "1776 CENTER RD",
    "dropphycty": "CORINTH",
    "dropphyst": "VT",
    "dropphyzpp": "050399998",
    "dropmaladd": "1776 CENTER RD",
    "dropmalcty": "CORINTH",
    "dropmalst": "VT",
    "dropmalzpp": "050399998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022252014,
    "dropsitcph": 8022252014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26202",
    "droptype": "D",
    "dropname": "COVENTRY",
    "dropdeladd": "177 MAIN ST",
    "dropdelcty": "COVENTRY",
    "dropdelst": "VT",
    "dropdelzpp": "058259998",
    "dropphyadd": "177 MAIN ST",
    "dropphycty": "COVENTRY",
    "dropphyst": "VT",
    "dropphyzpp": "058259998",
    "dropmaladd": "177 MAIN ST",
    "dropmalcty": "COVENTRY",
    "dropmalst": "VT",
    "dropmalzpp": "058259998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027546013,
    "dropsitcph": 8027546013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26204",
    "droptype": "D",
    "dropname": "CRAFTSBURY",
    "dropdeladd": "118 S CRAFTSBURY RD STE 1",
    "dropdelcty": "CRAFTSBURY",
    "dropdelst": "VT",
    "dropdelzpp": "058269998",
    "dropphyadd": "118 S CRAFTSBURY RD STE 1",
    "dropphycty": "CRAFTSBURY",
    "dropphyst": "VT",
    "dropphyzpp": "058269998",
    "dropmaladd": "118 S CRAFTSBURY RD STE 1",
    "dropmalcty": "CRAFTSBURY",
    "dropmalst": "VT",
    "dropmalzpp": "058269998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025869650,
    "dropsitcph": 8025869650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26205",
    "droptype": "D",
    "dropname": "CRAFTSBURY COMMON",
    "dropdeladd": "1354 N CRAFTSBURY RD",
    "dropdelcty": "CRAFTSBURY COMMON",
    "dropdelst": "VT",
    "dropdelzpp": "058279998",
    "dropphyadd": "1354 N CRAFTSBURY RD",
    "dropphycty": "CRAFTSBURY COMMON",
    "dropphyst": "VT",
    "dropphyzpp": "058279998",
    "dropmaladd": "1354 N CRAFTSBURY RD",
    "dropmalcty": "CRAFTSBURY COMMON",
    "dropmalst": "VT",
    "dropmalzpp": "058279998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025862209,
    "dropsitcph": 8025862209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26213",
    "droptype": "D",
    "dropname": "CUTTINGSVILLE",
    "dropdeladd": "5446 VT ROUTE 103",
    "dropdelcty": "CUTTINGSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "057389998",
    "dropphyadd": "5446 VT ROUTE 103",
    "dropphycty": "CUTTINGSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "057389998",
    "dropmaladd": "5446 VT ROUTE 103",
    "dropmalcty": "CUTTINGSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "057389998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022301996,
    "dropsitcph": 8022301996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26216",
    "droptype": "D",
    "dropname": "DANBY",
    "dropdeladd": "214 N MAIN ST",
    "dropdelcty": "DANBY",
    "dropdelst": "VT",
    "dropdelzpp": "057399998",
    "dropphyadd": "214 N MAIN ST",
    "dropphycty": "DANBY",
    "dropphyst": "VT",
    "dropphyzpp": "057399998",
    "dropmaladd": "214 N MAIN ST",
    "dropmalcty": "DANBY",
    "dropmalst": "VT",
    "dropmalzpp": "057399998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675041,
    "dropsitcph": 8022675041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26218",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "35 PARK ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "058289998",
    "dropphyadd": "35 PARK ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "058289998",
    "dropmaladd": "35 PARK ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "058289998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026843406,
    "dropsitcph": 8026843406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26224",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "3275 US ROUTE 5",
    "dropdelcty": "DERBY",
    "dropdelst": "VT",
    "dropdelzpp": "058299998",
    "dropphyadd": "3275 US ROUTE 5",
    "dropphycty": "DERBY",
    "dropphyst": "VT",
    "dropphyzpp": "058299998",
    "dropmaladd": "3275 US ROUTE 5",
    "dropmalcty": "DERBY",
    "dropmalst": "VT",
    "dropmalzpp": "058299998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027665051,
    "dropsitcph": 8027665051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26225",
    "droptype": "D",
    "dropname": "DERBY LINE",
    "dropdeladd": "84 MAIN ST",
    "dropdelcty": "DERBY LINE",
    "dropdelst": "VT",
    "dropdelzpp": "058309998",
    "dropphyadd": "84 MAIN ST",
    "dropphycty": "DERBY LINE",
    "dropphyst": "VT",
    "dropphyzpp": "058309998",
    "dropmaladd": "84 MAIN ST",
    "dropmalcty": "DERBY LINE",
    "dropmalst": "VT",
    "dropmalzpp": "058309998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028733332,
    "dropsitcph": 8028733332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26226",
    "droptype": "D",
    "dropname": "DORSET",
    "dropdeladd": "3309 ROUTE 30",
    "dropdelcty": "DORSET",
    "dropdelst": "VT",
    "dropdelzpp": "052519998",
    "dropphyadd": "3309 ROUTE 30",
    "dropphycty": "DORSET",
    "dropphyst": "VT",
    "dropphyzpp": "052519998",
    "dropmaladd": "3309 ROUTE 30",
    "dropmalcty": "DORSET",
    "dropmalst": "VT",
    "dropmalzpp": "052519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028675501,
    "dropsitcph": 8028675501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26269",
    "droptype": "D",
    "dropname": "EAST ARLINGTON",
    "dropdeladd": "243 OLD MILL RD STE 1",
    "dropdelcty": "EAST ARLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "052529998",
    "dropphyadd": "243 OLD MILL RD STE 1",
    "dropphycty": "EAST ARLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "052529998",
    "dropmaladd": "243 OLD MILL RD STE 1",
    "dropmalcty": "EAST ARLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "052529998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023756695,
    "dropsitcph": 8023756695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26271",
    "droptype": "D",
    "dropname": "EAST BARRE",
    "dropdeladd": "491 WEBSTERVILLE RD",
    "dropdelcty": "EAST BARRE",
    "dropdelst": "VT",
    "dropdelzpp": "056499998",
    "dropphyadd": "491 WEBSTERVILLE RD",
    "dropphycty": "EAST BARRE",
    "dropphyst": "VT",
    "dropphyzpp": "056499998",
    "dropmaladd": "491 WEBSTERVILLE RD",
    "dropmalcty": "EAST BARRE",
    "dropmalst": "VT",
    "dropmalzpp": "056499998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024767801,
    "dropsitcph": 8024767801,
    "dropfax": 8024764453
  },
  {
    "dcode": "D",
    "dropkey": "PV26276",
    "droptype": "D",
    "dropname": "EAST BURKE",
    "dropdeladd": "552 VT ROUTE 114",
    "dropdelcty": "EAST BURKE",
    "dropdelst": "VT",
    "dropdelzpp": "058329998",
    "dropphyadd": "552 VT ROUTE 114",
    "dropphycty": "EAST BURKE",
    "dropphyst": "VT",
    "dropphyzpp": "058329998",
    "dropmaladd": "552 VT ROUTE 114",
    "dropmalcty": "EAST BURKE",
    "dropmalst": "VT",
    "dropmalzpp": "058329998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026263686,
    "dropsitcph": 8026263686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26280",
    "droptype": "D",
    "dropname": "EAST CALAIS",
    "dropdeladd": "12 BATTEN RD",
    "dropdelcty": "EAST CALAIS",
    "dropdelst": "VT",
    "dropdelzpp": "056509998",
    "dropphyadd": "12 BATTEN RD",
    "dropphycty": "EAST CALAIS",
    "dropphyst": "VT",
    "dropphyzpp": "056509998",
    "dropmaladd": "12 BATTEN RD",
    "dropmalcty": "EAST CALAIS",
    "dropmalst": "VT",
    "dropmalzpp": "056509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024568857,
    "dropsitcph": 8024568857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26282",
    "droptype": "D",
    "dropname": "EAST CHARLESTON",
    "dropdeladd": "5 MILL ST",
    "dropdelcty": "EAST CHARLESTON",
    "dropdelst": "VT",
    "dropdelzpp": "058339998",
    "dropphyadd": "5 MILL ST",
    "dropphycty": "EAST CHARLESTON",
    "dropphyst": "VT",
    "dropphyzpp": "058339998",
    "dropmaladd": "5 MILL ST",
    "dropmalcty": "EAST CHARLESTON",
    "dropmalst": "VT",
    "dropmalzpp": "058339998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027236235,
    "dropsitcph": 8027236235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26286",
    "droptype": "D",
    "dropname": "EAST CORINTH",
    "dropdeladd": "749 VILLAGE RD",
    "dropdelcty": "EAST CORINTH",
    "dropdelst": "VT",
    "dropdelzpp": "050409998",
    "dropphyadd": "749 VILLAGE RD",
    "dropphycty": "EAST CORINTH",
    "dropphyst": "VT",
    "dropphyzpp": "050409998",
    "dropmaladd": "749 VILLAGE RD",
    "dropmalcty": "EAST CORINTH",
    "dropmalst": "VT",
    "dropmalzpp": "050409998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022252009,
    "dropsitcph": 8022252009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26288",
    "droptype": "D",
    "dropname": "EAST DORSET",
    "dropdeladd": "35 MAD TOM RD",
    "dropdelcty": "EAST DORSET",
    "dropdelst": "VT",
    "dropdelzpp": "052539998",
    "dropphyadd": "35 MAD TOM RD",
    "dropphycty": "EAST DORSET",
    "dropphyst": "VT",
    "dropphyzpp": "052539998",
    "dropmaladd": "35 MAD TOM RD",
    "dropmalcty": "EAST DORSET",
    "dropmalst": "VT",
    "dropmalzpp": "052539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023623233,
    "dropsitcph": 8023623233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26289",
    "droptype": "D",
    "dropname": "EAST DOVER",
    "dropdeladd": "4 NORTH ST UNIT A",
    "dropdelcty": "EAST DOVER",
    "dropdelst": "VT",
    "dropdelzpp": "053419998",
    "dropphyadd": "4 NORTH ST UNIT A",
    "dropphycty": "EAST DOVER",
    "dropphyst": "VT",
    "dropphyzpp": "053419998",
    "dropmaladd": "4 NORTH ST UNIT A",
    "dropmalcty": "EAST DOVER",
    "dropmalst": "VT",
    "dropmalzpp": "053419998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8778541565,
    "dropsitcph": 8778541565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26293",
    "droptype": "D",
    "dropname": "EAST FAIRFIELD",
    "dropdeladd": "9516 ROUTE 36",
    "dropdelcty": "EAST FAIRFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "054489998",
    "dropphyadd": "9516 ROUTE 36",
    "dropphycty": "EAST FAIRFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "054489998",
    "dropmaladd": "9516 ROUTE 36",
    "dropmalcty": "EAST FAIRFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "054489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028273819,
    "dropsitcph": 8028273819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26300",
    "droptype": "D",
    "dropname": "EAST HARDWICK",
    "dropdeladd": "45 MAIN ST",
    "dropdelcty": "EAST HARDWICK",
    "dropdelst": "VT",
    "dropdelzpp": "058369998",
    "dropphyadd": "45 MAIN ST",
    "dropphycty": "EAST HARDWICK",
    "dropphyst": "VT",
    "dropphyzpp": "058369998",
    "dropmaladd": "45 MAIN ST",
    "dropmalcty": "EAST HARDWICK",
    "dropmalst": "VT",
    "dropmalzpp": "058369998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024725437,
    "dropsitcph": 8024725437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26301",
    "droptype": "D",
    "dropname": "EAST HAVEN",
    "dropdeladd": "472 SCHOOL ST",
    "dropdelcty": "EAST HAVEN",
    "dropdelst": "VT",
    "dropdelzpp": "058379998",
    "dropphyadd": "472 SCHOOL ST",
    "dropphycty": "EAST HAVEN",
    "dropphyst": "VT",
    "dropphyzpp": "058379998",
    "dropmaladd": "472 SCHOOL ST",
    "dropmalcty": "EAST HAVEN",
    "dropmalst": "VT",
    "dropmalzpp": "058379998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024673907,
    "dropsitcph": 8024673907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26310",
    "droptype": "D",
    "dropname": "EAST MIDDLEBURY",
    "dropdeladd": "1 CASE ST",
    "dropdelcty": "EAST MIDDLEBURY",
    "dropdelst": "VT",
    "dropdelzpp": "057409998",
    "dropphyadd": "1 CASE ST",
    "dropphycty": "EAST MIDDLEBURY",
    "dropphyst": "VT",
    "dropphyzpp": "057409998",
    "dropmaladd": "1 CASE ST",
    "dropmalcty": "EAST MIDDLEBURY",
    "dropmalst": "VT",
    "dropmalzpp": "057409998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023886685,
    "dropsitcph": 8023886685,
    "dropfax": 8023881097
  },
  {
    "dcode": "D",
    "dropkey": "PV26312",
    "droptype": "D",
    "dropname": "EAST MONTPELIER",
    "dropdeladd": "2893 US ROUTE 2",
    "dropdelcty": "EAST MONTPELIER",
    "dropdelst": "VT",
    "dropdelzpp": "056519998",
    "dropphyadd": "2893 US ROUTE 2",
    "dropphycty": "EAST MONTPELIER",
    "dropphyst": "VT",
    "dropphyzpp": "056519998",
    "dropmaladd": "2893 US ROUTE 2",
    "dropmalcty": "EAST MONTPELIER",
    "dropmalst": "VT",
    "dropmalzpp": "056519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022232832,
    "dropsitcph": 8022232832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26321",
    "droptype": "D",
    "dropname": "EAST RANDOLPH",
    "dropdeladd": "100 VT ROUTE 14 S",
    "dropdelcty": "EAST RANDOLPH",
    "dropdelst": "VT",
    "dropdelzpp": "050419998",
    "dropphyadd": "100 VT ROUTE 14 S",
    "dropphycty": "EAST RANDOLPH",
    "dropphyst": "VT",
    "dropphyzpp": "050419998",
    "dropmaladd": "100 VT ROUTE 14 S",
    "dropmalcty": "EAST RANDOLPH",
    "dropmalst": "VT",
    "dropmalzpp": "050419998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027283005,
    "dropsitcph": 8027283005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26324",
    "droptype": "D",
    "dropname": "EAST RYEGATE",
    "dropdeladd": "57 PAPERMILL RD",
    "dropdelcty": "EAST RYEGATE",
    "dropdelst": "VT",
    "dropdelzpp": "050429998",
    "dropphyadd": "57 PAPERMILL RD",
    "dropphycty": "EAST RYEGATE",
    "dropphyst": "VT",
    "dropphyzpp": "050429998",
    "dropmaladd": "57 PAPERMILL RD",
    "dropmalcty": "EAST RYEGATE",
    "dropmalst": "VT",
    "dropmalzpp": "050429998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027573067,
    "dropsitcph": 8027573067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26325",
    "droptype": "D",
    "dropname": "EAST SAINT JOHNSBURY",
    "dropdeladd": "1064 US ROUTE 2 E",
    "dropdelcty": "EAST SAINT JOHNSBURY",
    "dropdelst": "VT",
    "dropdelzpp": "058389998",
    "dropphyadd": "1064 US ROUTE 2 E",
    "dropphycty": "EAST SAINT JOHNSBURY",
    "dropphyst": "VT",
    "dropphyzpp": "058389998",
    "dropmaladd": "1064 US ROUTE 2 E",
    "dropmalcty": "EAST SAINT JOHNSBURY",
    "dropmalst": "VT",
    "dropmalzpp": "058389998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027487891,
    "dropsitcph": 8027487891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26329",
    "droptype": "D",
    "dropname": "EAST THETFORD",
    "dropdeladd": "2969 ROUTE 5",
    "dropdelcty": "EAST THETFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050439998",
    "dropphyadd": "2969 ROUTE 5",
    "dropphycty": "EAST THETFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050439998",
    "dropmaladd": "2969 ROUTE 5",
    "dropmalcty": "EAST THETFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8779075150,
    "dropsitcph": 8779075150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26330",
    "droptype": "D",
    "dropname": "EAST WALLINGFORD",
    "dropdeladd": "16 VILLAGE ST",
    "dropdelcty": "EAST WALLINGFORD",
    "dropdelst": "VT",
    "dropdelzpp": "057429998",
    "dropphyadd": "16 VILLAGE ST",
    "dropphycty": "EAST WALLINGFORD",
    "dropphyst": "VT",
    "dropphyzpp": "057429998",
    "dropmaladd": "16 VILLAGE ST",
    "dropmalcty": "EAST WALLINGFORD",
    "dropmalst": "VT",
    "dropmalzpp": "057429998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022456403,
    "dropsitcph": 8022456403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26335",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "29 NANCY LN",
    "dropdelcty": "EDEN",
    "dropdelst": "VT",
    "dropdelzpp": "056529998",
    "dropphyadd": "29 NANCY LN",
    "dropphycty": "EDEN",
    "dropphyst": "VT",
    "dropphyzpp": "056529998",
    "dropmaladd": "29 NANCY LN",
    "dropmalcty": "EDEN",
    "dropmalst": "VT",
    "dropmalzpp": "056529998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026357818,
    "dropsitcph": 8026357818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26345",
    "droptype": "D",
    "dropname": "ENOSBURG FALLS",
    "dropdeladd": "34 SCHOOL ST",
    "dropdelcty": "ENOSBURG FALLS",
    "dropdelst": "VT",
    "dropdelzpp": "054509998",
    "dropphyadd": "34 SCHOOL ST",
    "dropphycty": "ENOSBURG FALLS",
    "dropphyst": "VT",
    "dropphyzpp": "054509998",
    "dropmaladd": "34 SCHOOL ST",
    "dropmalcty": "ENOSBURG FALLS",
    "dropmalst": "VT",
    "dropmalzpp": "054509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029332206,
    "dropsitcph": 8029332206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26351",
    "droptype": "D",
    "dropname": "ESSEX JUNCTION",
    "dropdeladd": "22 ESSEX WAY",
    "dropdelcty": "ESSEX JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "054529998",
    "dropphyadd": "22 ESSEX WAY",
    "dropphycty": "ESSEX JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "054529998",
    "dropmaladd": "22 ESSEX WAY",
    "dropmalcty": "ESSEX JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "054529998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028781234,
    "dropsitcph": 8028781234,
    "dropfax": 8028784772
  },
  {
    "dcode": "D",
    "dropkey": "PV26354",
    "droptype": "D",
    "dropname": "FAIR HAVEN",
    "dropdeladd": "6 MARBLE ST",
    "dropdelcty": "FAIR HAVEN",
    "dropdelst": "VT",
    "dropdelzpp": "057439998",
    "dropphyadd": "6 MARBLE ST",
    "dropphycty": "FAIR HAVEN",
    "dropphyst": "VT",
    "dropphyzpp": "057439998",
    "dropmaladd": "6 MARBLE ST",
    "dropmalcty": "FAIR HAVEN",
    "dropmalst": "VT",
    "dropmalzpp": "057439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022653205,
    "dropsitcph": 8022653205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26358",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "997 MAIN ST",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "VT",
    "dropdelzpp": "054549998",
    "dropphyadd": "997 MAIN ST",
    "dropphycty": "FAIRFAX",
    "dropphyst": "VT",
    "dropphyzpp": "054549998",
    "dropmaladd": "997 MAIN ST",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "VT",
    "dropmalzpp": "054549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028494049,
    "dropsitcph": 8028494049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26360",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "4696 VT ROUTE 36",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "054559998",
    "dropphyadd": "4696 VT ROUTE 36",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "054559998",
    "dropmaladd": "4696 VT ROUTE 36",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "054559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028273734,
    "dropsitcph": 8028273734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26366",
    "droptype": "D",
    "dropname": "FAIRLEE",
    "dropdeladd": "21 SCHOOL ST",
    "dropdelcty": "FAIRLEE",
    "dropdelst": "VT",
    "dropdelzpp": "050459998",
    "dropphyadd": "21 SCHOOL ST",
    "dropphycty": "FAIRLEE",
    "dropphyst": "VT",
    "dropphyzpp": "050459998",
    "dropmaladd": "21 SCHOOL ST",
    "dropmalcty": "FAIRLEE",
    "dropmalst": "VT",
    "dropmalzpp": "050459998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023336659,
    "dropsitcph": 8023336659,
    "dropfax": 8023339406
  },
  {
    "dcode": "D",
    "dropkey": "PV26377",
    "droptype": "D",
    "dropname": "FERRISBURGH",
    "dropdeladd": "3153 ROUTE 7",
    "dropdelcty": "FERRISBURGH",
    "dropdelst": "VT",
    "dropdelzpp": "054569998",
    "dropphyadd": "3153 ROUTE 7",
    "dropphycty": "FERRISBURGH",
    "dropphyst": "VT",
    "dropphyzpp": "054569998",
    "dropmaladd": "3153 ROUTE 7",
    "dropmalcty": "FERRISBURGH",
    "dropmalst": "VT",
    "dropmalzpp": "054569998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028772869,
    "dropsitcph": 8028772869,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26383",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "1543 W CREEK RD",
    "dropdelcty": "FLORENCE",
    "dropdelst": "VT",
    "dropdelzpp": "057449998",
    "dropphyadd": "1543 W CREEK RD",
    "dropphycty": "FLORENCE",
    "dropphyst": "VT",
    "dropphyzpp": "057449998",
    "dropmaladd": "1543 W CREEK RD",
    "dropmalcty": "FLORENCE",
    "dropmalst": "VT",
    "dropmalzpp": "057449998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024832335,
    "dropsitcph": 8024832335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26387",
    "droptype": "D",
    "dropname": "FOREST DALE",
    "dropdeladd": "233 NORTH ST",
    "dropdelcty": "FOREST DALE",
    "dropdelst": "VT",
    "dropdelzpp": "057459998",
    "dropphyadd": "233 NORTH ST",
    "dropphycty": "FOREST DALE",
    "dropphyst": "VT",
    "dropphyzpp": "057459998",
    "dropmaladd": "233 NORTH ST",
    "dropmalcty": "FOREST DALE",
    "dropmalst": "VT",
    "dropmalzpp": "057459998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022473224,
    "dropsitcph": 8022473224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26394",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "5142 HANNA RD",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "VT",
    "dropdelzpp": "054579998",
    "dropphyadd": "5142 HANNA RD",
    "dropphycty": "FRANKLIN",
    "dropphyst": "VT",
    "dropphyzpp": "054579998",
    "dropmaladd": "5142 HANNA RD",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "VT",
    "dropmalzpp": "054579998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022081009,
    "dropsitcph": 8022081009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26405",
    "droptype": "D",
    "dropname": "GAYSVILLE",
    "dropdeladd": "35 BRIDGE ST",
    "dropdelcty": "GAYSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "057469998",
    "dropphyadd": "35 BRIDGE ST",
    "dropphycty": "GAYSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "057469998",
    "dropmaladd": "35 BRIDGE ST",
    "dropmalcty": "GAYSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "057469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022345575,
    "dropsitcph": 8022345575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26414",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "5 PARRISH ST",
    "dropdelcty": "GILMAN",
    "dropdelst": "VT",
    "dropdelzpp": "059049998",
    "dropphyadd": "5 PARRISH ST",
    "dropphycty": "GILMAN",
    "dropphyst": "VT",
    "dropphyzpp": "059049998",
    "dropmaladd": "5 PARRISH ST",
    "dropmalcty": "GILMAN",
    "dropmalst": "VT",
    "dropmalzpp": "059049998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028925904,
    "dropsitcph": 8028925904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26426",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "VT",
    "dropdelzpp": "051469998",
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "VT",
    "dropphyzpp": "051469998",
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "VT",
    "dropmalzpp": "051469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028432335,
    "dropsitcph": 8028432335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26430",
    "droptype": "D",
    "dropname": "GRAND ISLE",
    "dropdeladd": "203 US ROUTE 2",
    "dropdelcty": "GRAND ISLE",
    "dropdelst": "VT",
    "dropdelzpp": "054589998",
    "dropphyadd": "203 US ROUTE 2",
    "dropphycty": "GRAND ISLE",
    "dropphyst": "VT",
    "dropphyzpp": "054589998",
    "dropmaladd": "203 US ROUTE 2",
    "dropmalcty": "GRAND ISLE",
    "dropmalst": "VT",
    "dropmalzpp": "054589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023724681,
    "dropsitcph": 8023724681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26431",
    "droptype": "D",
    "dropname": "GRANITEVILLE",
    "dropdeladd": "623 GRANITEVILLE RD",
    "dropdelcty": "GRANITEVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "056549998",
    "dropphyadd": "623 GRANITEVILLE RD",
    "dropphycty": "GRANITEVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "056549998",
    "dropmaladd": "623 GRANITEVILLE RD",
    "dropmalcty": "GRANITEVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "056549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023120285,
    "dropsitcph": 8023120285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26434",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "4801 VT ROUTE 100",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "057479606",
    "dropphyadd": "4801 VT ROUTE 100",
    "dropphycty": "GRANVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "057479606",
    "dropmaladd": "4801 VT ROUTE 100",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "057479606",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027673306,
    "dropsitcph": 8027673306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26444",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "12 CEMETERY RDG",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "VT",
    "dropdelzpp": "058419998",
    "dropphyadd": "12 CEMETERY RDG",
    "dropphycty": "GREENSBORO",
    "dropphyst": "VT",
    "dropphyzpp": "058419998",
    "dropmaladd": "12 CEMETERY RDG",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "VT",
    "dropmalzpp": "058419998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025332500,
    "dropsitcph": 8025332500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26445",
    "droptype": "D",
    "dropname": "GREENSBORO BEND",
    "dropdeladd": "975 MAIN ST UNIT A",
    "dropdelcty": "GREENSBORO BEND",
    "dropdelst": "VT",
    "dropdelzpp": "058429998",
    "dropphyadd": "975 MAIN ST UNIT A",
    "dropphycty": "GREENSBORO BEND",
    "dropphyst": "VT",
    "dropphyzpp": "058429998",
    "dropmaladd": "975 MAIN ST UNIT A",
    "dropmalcty": "GREENSBORO BEND",
    "dropmalst": "VT",
    "dropmalzpp": "058429998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025337711,
    "dropsitcph": 8025337711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26450",
    "droptype": "D",
    "dropname": "GROTON",
    "dropdeladd": "1236 SCOTT HWY",
    "dropdelcty": "GROTON",
    "dropdelst": "VT",
    "dropdelzpp": "050469998",
    "dropphyadd": "1236 SCOTT HWY",
    "dropphycty": "GROTON",
    "dropphyst": "VT",
    "dropphyzpp": "050469998",
    "dropmaladd": "1236 SCOTT HWY",
    "dropmalcty": "GROTON",
    "dropmalst": "VT",
    "dropmalzpp": "050469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025843479,
    "dropsitcph": 8025843479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26452",
    "droptype": "D",
    "dropname": "GUILDHALL",
    "dropdeladd": "7031 ROUTE 102",
    "dropdelcty": "GUILDHALL",
    "dropdelst": "VT",
    "dropdelzpp": "059059998",
    "dropphyadd": "7031 ROUTE 102",
    "dropphycty": "GUILDHALL",
    "dropphyst": "VT",
    "dropphyzpp": "059059998",
    "dropmaladd": "7031 ROUTE 102",
    "dropmalcty": "GUILDHALL",
    "dropmalst": "VT",
    "dropmalzpp": "059059998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026760401,
    "dropsitcph": 8026760401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26459",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "882 VT ROUTE 100",
    "dropdelcty": "HANCOCK",
    "dropdelst": "VT",
    "dropdelzpp": "057489998",
    "dropphyadd": "882 VT ROUTE 100",
    "dropphycty": "HANCOCK",
    "dropphyst": "VT",
    "dropphyzpp": "057489998",
    "dropmaladd": "882 VT ROUTE 100",
    "dropmalcty": "HANCOCK",
    "dropmalst": "VT",
    "dropmalzpp": "057489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027673313,
    "dropsitcph": 8027673313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26462",
    "droptype": "D",
    "dropname": "HARDWICK",
    "dropdeladd": "52 MILL ST",
    "dropdelcty": "HARDWICK",
    "dropdelst": "VT",
    "dropdelzpp": "058439998",
    "dropphyadd": "52 MILL ST",
    "dropphycty": "HARDWICK",
    "dropphyst": "VT",
    "dropphyzpp": "058439998",
    "dropmaladd": "52 MILL ST",
    "dropmalcty": "HARDWICK",
    "dropmalst": "VT",
    "dropmalzpp": "058439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024726022,
    "dropsitcph": 8024726022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26467",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "1238 MAPLE ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050479998",
    "dropphyadd": "1238 MAPLE ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050479998",
    "dropmaladd": "1238 MAPLE ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050479998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022955511,
    "dropsitcph": 8022955511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26469",
    "droptype": "D",
    "dropname": "HARTLAND",
    "dropdeladd": "159 US ROUTE 5",
    "dropdelcty": "HARTLAND",
    "dropdelst": "VT",
    "dropdelzpp": "050489998",
    "dropphyadd": "159 US ROUTE 5",
    "dropphycty": "HARTLAND",
    "dropphyst": "VT",
    "dropphyzpp": "050489998",
    "dropmaladd": "159 US ROUTE 5",
    "dropmalcty": "HARTLAND",
    "dropmalst": "VT",
    "dropmalzpp": "050489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022191314,
    "dropsitcph": 8022191314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26484",
    "droptype": "D",
    "dropname": "HIGHGATE CENTER",
    "dropdeladd": "38 ST ARMAND RD",
    "dropdelcty": "HIGHGATE CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "054599998",
    "dropphyadd": "38 ST ARMAND RD",
    "dropphycty": "HIGHGATE CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "054599998",
    "dropmaladd": "38 ST ARMAND RD",
    "dropmalcty": "HIGHGATE CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "054599998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028682576,
    "dropsitcph": 8028682576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26488",
    "droptype": "D",
    "dropname": "HIGHGATE SPRINGS",
    "dropdeladd": "2934 VT ROUTE 7",
    "dropdelcty": "HIGHGATE SPRINGS",
    "dropdelst": "VT",
    "dropdelzpp": "054609998",
    "dropphyadd": "2934 VT ROUTE 7",
    "dropphycty": "HIGHGATE SPRINGS",
    "dropphyst": "VT",
    "dropphyzpp": "054609998",
    "dropmaladd": "2934 VT ROUTE 7",
    "dropmalcty": "HIGHGATE SPRINGS",
    "dropmalst": "VT",
    "dropmalzpp": "054609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028681016,
    "dropsitcph": 8028681016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26490",
    "droptype": "D",
    "dropname": "HINESBURG",
    "dropdeladd": "234 COMMERCE ST",
    "dropdelcty": "HINESBURG",
    "dropdelst": "VT",
    "dropdelzpp": "054619998",
    "dropphyadd": "234 COMMERCE ST",
    "dropphycty": "HINESBURG",
    "dropphyst": "VT",
    "dropphyzpp": "054619998",
    "dropmaladd": "234 COMMERCE ST",
    "dropmalcty": "HINESBURG",
    "dropmalst": "VT",
    "dropmalzpp": "054619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024822292,
    "dropsitcph": 8024822292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26508",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "2209 MAIN RD",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054629998",
    "dropphyadd": "2209 MAIN RD",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054629998",
    "dropmaladd": "2209 MAIN RD",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024342885,
    "dropsitcph": 8024342885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26513",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "214 CHURCH ST",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "VT",
    "dropdelzpp": "056559998",
    "dropphyadd": "214 CHURCH ST",
    "dropphycty": "HYDE PARK",
    "dropphyst": "VT",
    "dropphyzpp": "056559998",
    "dropmaladd": "214 CHURCH ST",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "VT",
    "dropmalzpp": "056559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028882325,
    "dropsitcph": 8028882325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26515",
    "droptype": "D",
    "dropname": "HYDEVILLE",
    "dropdeladd": "912 ROUTE 4A W",
    "dropdelcty": "HYDEVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "057509998",
    "dropphyadd": "912 ROUTE 4A W",
    "dropphycty": "HYDEVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "057509998",
    "dropmaladd": "912 ROUTE 4A W",
    "dropmalcty": "HYDEVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "057509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022658106,
    "dropsitcph": 8022658106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26521",
    "droptype": "D",
    "dropname": "IRASBURG",
    "dropdeladd": "94 PARK AVE",
    "dropdelcty": "IRASBURG",
    "dropdelst": "VT",
    "dropdelzpp": "058459998",
    "dropphyadd": "94 PARK AVE",
    "dropphycty": "IRASBURG",
    "dropphyst": "VT",
    "dropphyzpp": "058459998",
    "dropmaladd": "94 PARK AVE",
    "dropmalcty": "IRASBURG",
    "dropmalst": "VT",
    "dropmalzpp": "058459998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027546322,
    "dropsitcph": 8027546322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26524",
    "droptype": "D",
    "dropname": "ISLAND POND",
    "dropdeladd": "32 MAIN ST",
    "dropdelcty": "ISLAND POND",
    "dropdelst": "VT",
    "dropdelzpp": "058469998",
    "dropphyadd": "32 MAIN ST",
    "dropphycty": "ISLAND POND",
    "dropphyst": "VT",
    "dropphyzpp": "058469998",
    "dropmaladd": "32 MAIN ST",
    "dropmalcty": "ISLAND POND",
    "dropmalst": "VT",
    "dropmalzpp": "058469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027235995,
    "dropsitcph": 8027235995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26525",
    "droptype": "D",
    "dropname": "ISLE LA MOTTE",
    "dropdeladd": "46 SCHOOL ST",
    "dropdelcty": "ISLE LA MOTTE",
    "dropdelst": "VT",
    "dropdelzpp": "054639998",
    "dropphyadd": "46 SCHOOL ST",
    "dropphycty": "ISLE LA MOTTE",
    "dropphyst": "VT",
    "dropphyzpp": "054639998",
    "dropmaladd": "46 SCHOOL ST",
    "dropmalcty": "ISLE LA MOTTE",
    "dropmalst": "VT",
    "dropmalzpp": "054639998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029283232,
    "dropsitcph": 8029283232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26526",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "2939 VT ROUTE 100",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "053429998",
    "dropphyadd": "2939 VT ROUTE 100",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "053429998",
    "dropmaladd": "2939 VT ROUTE 100",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "053429998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023687700,
    "dropsitcph": 8023687700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26529",
    "droptype": "D",
    "dropname": "JAMAICA",
    "dropdeladd": "3912 VT ROUTE 30",
    "dropdelcty": "JAMAICA",
    "dropdelst": "VT",
    "dropdelzpp": "053439998",
    "dropphyadd": "3912 VT ROUTE 30",
    "dropphycty": "JAMAICA",
    "dropphyst": "VT",
    "dropphyzpp": "053439998",
    "dropmaladd": "3912 VT ROUTE 30",
    "dropmalcty": "JAMAICA",
    "dropmalst": "VT",
    "dropmalzpp": "053439998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028744242,
    "dropsitcph": 8028744242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26534",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "85 CHURCH ST",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "054649998",
    "dropphyadd": "85 CHURCH ST",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "054649998",
    "dropmaladd": "85 CHURCH ST",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "054649998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026442981,
    "dropsitcph": 8026442981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26539",
    "droptype": "D",
    "dropname": "JERICHO",
    "dropdeladd": "87 VT ROUTE 15",
    "dropdelcty": "JERICHO",
    "dropdelst": "VT",
    "dropdelzpp": "054659998",
    "dropphyadd": "87 VT ROUTE 15",
    "dropphycty": "JERICHO",
    "dropphyst": "VT",
    "dropphyzpp": "054659998",
    "dropmaladd": "87 VT ROUTE 15",
    "dropmalcty": "JERICHO",
    "dropmalst": "VT",
    "dropmalzpp": "054659998",
    "dropsitphn": 8028993202,
    "dropsitlph": 8028993202,
    "dropsitcph": 8028993202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26546",
    "droptype": "D",
    "dropname": "JOHNSON",
    "dropdeladd": "115 LOWER MAIN ST W",
    "dropdelcty": "JOHNSON",
    "dropdelst": "VT",
    "dropdelzpp": "056569998",
    "dropphyadd": "115 LOWER MAIN ST W",
    "dropphycty": "JOHNSON",
    "dropphyst": "VT",
    "dropphyzpp": "056569998",
    "dropmaladd": "115 LOWER MAIN ST W",
    "dropmalcty": "JOHNSON",
    "dropmalst": "VT",
    "dropmalzpp": "056569998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026357706,
    "dropsitcph": 8026357706,
    "dropfax": 8026357706
  },
  {
    "dcode": "D",
    "dropkey": "PV26548",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "3459 E MAIN ST",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "054669998",
    "dropphyadd": "3459 E MAIN ST",
    "dropphycty": "JONESVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "054669998",
    "dropmaladd": "3459 E MAIN ST",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "054669998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022043424,
    "dropsitcph": 8022043424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26556",
    "droptype": "D",
    "dropname": "KILLINGTON",
    "dropdeladd": "2046 US ROUTE 4",
    "dropdelcty": "KILLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "057519998",
    "dropphyadd": "2046 US ROUTE 4",
    "dropphycty": "KILLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "057519998",
    "dropmaladd": "2046 US ROUTE 4",
    "dropmalcty": "KILLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "057519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027754247,
    "dropsitcph": 8027754247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26601",
    "droptype": "D",
    "dropname": "LONDONDERRY",
    "dropdeladd": "5660 VT ROUTE 100",
    "dropdelcty": "LONDONDERRY",
    "dropdelst": "VT",
    "dropdelzpp": "051489998",
    "dropphyadd": "5660 VT ROUTE 100",
    "dropphycty": "LONDONDERRY",
    "dropphyst": "VT",
    "dropphyzpp": "051489998",
    "dropmaladd": "5660 VT ROUTE 100",
    "dropmalcty": "LONDONDERRY",
    "dropmalst": "VT",
    "dropmalzpp": "051489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028232530,
    "dropsitcph": 8028232530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26603",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "296 HAZEN NOTCH RD",
    "dropdelcty": "LOWELL",
    "dropdelst": "VT",
    "dropdelzpp": "058479998",
    "dropphyadd": "296 HAZEN NOTCH RD",
    "dropphycty": "LOWELL",
    "dropphyst": "VT",
    "dropphyzpp": "058479998",
    "dropmaladd": "296 HAZEN NOTCH RD",
    "dropmalcty": "LOWELL",
    "dropmalst": "VT",
    "dropmalzpp": "058479998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027442706,
    "dropsitcph": 8027442706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26609",
    "droptype": "D",
    "dropname": "LOWER WATERFORD",
    "dropdeladd": "532 MAPLE ST",
    "dropdelcty": "LOWER WATERFORD",
    "dropdelst": "VT",
    "dropdelzpp": "058489998",
    "dropphyadd": "532 MAPLE ST",
    "dropphycty": "LOWER WATERFORD",
    "dropphyst": "VT",
    "dropphyzpp": "058489998",
    "dropmaladd": "532 MAPLE ST",
    "dropmalcty": "LOWER WATERFORD",
    "dropmalst": "VT",
    "dropmalzpp": "058489998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027485312,
    "dropsitcph": 8027485312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26611",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "57 POND ST STE 8",
    "dropdelcty": "LUDLOW",
    "dropdelst": "VT",
    "dropdelzpp": "051499998",
    "dropphyadd": "57 POND ST STE 8",
    "dropphycty": "LUDLOW",
    "dropphyst": "VT",
    "dropphyzpp": "051499998",
    "dropmaladd": "57 POND ST STE 8",
    "dropmalcty": "LUDLOW",
    "dropmalst": "VT",
    "dropmalzpp": "051499998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022287436,
    "dropsitcph": 8022287436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26613",
    "droptype": "D",
    "dropname": "LUNENBURG",
    "dropdeladd": "10 S LUNENBURG RD",
    "dropdelcty": "LUNENBURG",
    "dropdelst": "VT",
    "dropdelzpp": "059069998",
    "dropphyadd": "10 S LUNENBURG RD",
    "dropphycty": "LUNENBURG",
    "dropphyst": "VT",
    "dropphyzpp": "059069998",
    "dropmaladd": "10 S LUNENBURG RD",
    "dropmalcty": "LUNENBURG",
    "dropmalst": "VT",
    "dropmalzpp": "059069998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028925396,
    "dropsitcph": 8028925396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26619",
    "droptype": "D",
    "dropname": "LYNDON",
    "dropdeladd": "5992 MEMORIAL DR",
    "dropdelcty": "LYNDON",
    "dropdelst": "VT",
    "dropdelzpp": "058499998",
    "dropphyadd": "5992 MEMORIAL DR",
    "dropphycty": "LYNDON",
    "dropphyst": "VT",
    "dropphyzpp": "058499998",
    "dropmaladd": "5992 MEMORIAL DR",
    "dropmalcty": "LYNDON",
    "dropmalst": "VT",
    "dropmalzpp": "058499998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026265837,
    "dropsitcph": 8026265837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26620",
    "droptype": "D",
    "dropname": "LYNDON CENTER",
    "dropdeladd": "325 CENTER ST",
    "dropdelcty": "LYNDON CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "058509998",
    "dropphyadd": "325 CENTER ST",
    "dropphycty": "LYNDON CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "058509998",
    "dropmaladd": "325 CENTER ST",
    "dropmalcty": "LYNDON CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "058509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026263310,
    "dropsitcph": 8026263310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26623",
    "droptype": "D",
    "dropname": "LYNDONVILLE",
    "dropdeladd": "1025 BROAD ST",
    "dropdelcty": "LYNDONVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "058519998",
    "dropphyadd": "1025 BROAD ST",
    "dropphycty": "LYNDONVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "058519998",
    "dropmaladd": "1025 BROAD ST",
    "dropmalcty": "LYNDONVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "058519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026265421,
    "dropsitcph": 8026265421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26633",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "300 SEMINARY AVE",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "VT",
    "dropdelzpp": "052549998",
    "dropphyadd": "300 SEMINARY AVE",
    "dropphycty": "MANCHESTER",
    "dropphyst": "VT",
    "dropphyzpp": "052549998",
    "dropmaladd": "300 SEMINARY AVE",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "VT",
    "dropmalzpp": "052549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023621170,
    "dropsitcph": 8023621170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26635",
    "droptype": "D",
    "dropname": "MANCHESTER CENTER",
    "dropdeladd": "3452 RICHVILLE RD",
    "dropdelcty": "MANCHESTER CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "052559998",
    "dropphyadd": "3452 RICHVILLE RD",
    "dropphycty": "MANCHESTER CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "052559998",
    "dropmaladd": "3452 RICHVILLE RD",
    "dropmalcty": "MANCHESTER CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "052559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023623070,
    "dropsitcph": 8023623070,
    "dropfax": 8023627559
  },
  {
    "dcode": "D",
    "dropkey": "PV26642",
    "droptype": "D",
    "dropname": "MARLBORO",
    "dropdeladd": "510 SOUTH RD",
    "dropdelcty": "MARLBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053449998",
    "dropphyadd": "510 SOUTH RD",
    "dropphycty": "MARLBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053449998",
    "dropmaladd": "510 SOUTH RD",
    "dropmalcty": "MARLBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053449998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022544400,
    "dropsitcph": 8022544400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26645",
    "droptype": "D",
    "dropname": "MARSHFIELD",
    "dropdeladd": "1401 US ROUTE 2",
    "dropdelcty": "MARSHFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "056589998",
    "dropphyadd": "1401 US ROUTE 2",
    "dropphycty": "MARSHFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "056589998",
    "dropmaladd": "1401 US ROUTE 2",
    "dropmalcty": "MARSHFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "056589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024263855,
    "dropsitcph": 8024263855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26650",
    "droptype": "D",
    "dropname": "MC INDOE FALLS",
    "dropdeladd": "37 ACADEMY LN",
    "dropdelcty": "MC INDOE FALLS",
    "dropdelst": "VT",
    "dropdelzpp": "050509998",
    "dropphyadd": "37 ACADEMY LN",
    "dropphycty": "MC INDOE FALLS",
    "dropphyst": "VT",
    "dropphyzpp": "050509998",
    "dropmaladd": "37 ACADEMY LN",
    "dropmalcty": "MC INDOE FALLS",
    "dropmalst": "VT",
    "dropmalzpp": "050509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026334178,
    "dropsitcph": 8026334178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26660",
    "droptype": "D",
    "dropname": "MIDDLEBURY",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "MIDDLEBURY",
    "dropdelst": "VT",
    "dropdelzpp": "057539998",
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "MIDDLEBURY",
    "dropphyst": "VT",
    "dropphyzpp": "057539998",
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "MIDDLEBURY",
    "dropmalst": "VT",
    "dropmalzpp": "057539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023882681,
    "dropsitcph": 8023882681,
    "dropfax": 8023881536
  },
  {
    "dcode": "D",
    "dropkey": "PV26664",
    "droptype": "D",
    "dropname": "MIDDLETOWN SPRINGS",
    "dropdeladd": "17 SOUTH ST",
    "dropdelcty": "MIDDLETOWN SPRINGS",
    "dropdelst": "VT",
    "dropdelzpp": "057579998",
    "dropphyadd": "17 SOUTH ST",
    "dropphycty": "MIDDLETOWN SPRINGS",
    "dropphyst": "VT",
    "dropphyzpp": "057579998",
    "dropmaladd": "17 SOUTH ST",
    "dropmalcty": "MIDDLETOWN SPRINGS",
    "dropmalst": "VT",
    "dropmalzpp": "057579998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675036,
    "dropsitcph": 8022675036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26672",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "215 ROUTE 7 S",
    "dropdelcty": "MILTON",
    "dropdelst": "VT",
    "dropdelzpp": "054689998",
    "dropphyadd": "215 ROUTE 7 S",
    "dropphycty": "MILTON",
    "dropphyst": "VT",
    "dropphyzpp": "054689998",
    "dropmaladd": "215 ROUTE 7 S",
    "dropmalcty": "MILTON",
    "dropmalst": "VT",
    "dropmalzpp": "054689998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028934014,
    "dropsitcph": 8028934014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26675",
    "droptype": "D",
    "dropname": "MONKTON",
    "dropdeladd": "3747 STATES PRISON HOLLOW RD SIDE",
    "dropdelcty": "MONKTON",
    "dropdelst": "VT",
    "dropdelzpp": "054699998",
    "dropphyadd": "3747 STATES PRISON HOLLOW RD SIDE",
    "dropphycty": "MONKTON",
    "dropphyst": "VT",
    "dropphyzpp": "054699998",
    "dropmaladd": "3747 STATES PRISON HOLLOW RD SIDE",
    "dropmalcty": "MONKTON",
    "dropmalst": "VT",
    "dropmalzpp": "054699998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022031482,
    "dropsitcph": 8022031482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26678",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "1 BLACK FALLS RD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "VT",
    "dropdelzpp": "054709998",
    "dropphyadd": "1 BLACK FALLS RD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "VT",
    "dropphyzpp": "054709998",
    "dropmaladd": "1 BLACK FALLS RD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "VT",
    "dropmalzpp": "054709998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023264433,
    "dropsitcph": 8023264433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26679",
    "droptype": "D",
    "dropname": "MONTGOMERY CENTER",
    "dropdeladd": "98 MAIN ST",
    "dropdelcty": "MONTGOMERY CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "054719998",
    "dropphyadd": "98 MAIN ST",
    "dropphycty": "MONTGOMERY CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "054719998",
    "dropmaladd": "98 MAIN ST",
    "dropmalcty": "MONTGOMERY CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "054719998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023264246,
    "dropsitcph": 8023264246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26681",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "89 MAIN ST STE 4B",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "VT",
    "dropdelzpp": "056029996",
    "dropphyadd": "89 MAIN ST STE 4B",
    "dropphycty": "MONTPELIER",
    "dropphyst": "VT",
    "dropphyzpp": "056029996",
    "dropmaladd": "89 MAIN ST STE 4B",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "VT",
    "dropmalzpp": "056029996",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022291718,
    "dropsitcph": 8022291718,
    "dropfax": 8022230481
  },
  {
    "dcode": "D",
    "dropkey": "PV26684",
    "droptype": "D",
    "dropname": "MORETOWN",
    "dropdeladd": "1115 ROUTE 100 B",
    "dropdelcty": "MORETOWN",
    "dropdelst": "VT",
    "dropdelzpp": "056609998",
    "dropphyadd": "1115 ROUTE 100 B",
    "dropphycty": "MORETOWN",
    "dropphyst": "VT",
    "dropphyzpp": "056609998",
    "dropmaladd": "1115 ROUTE 100 B",
    "dropmalcty": "MORETOWN",
    "dropmalst": "VT",
    "dropmalzpp": "056609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022031443,
    "dropsitcph": 8022031443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26686",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "8411 VT RTE 111",
    "dropdelcty": "MORGAN",
    "dropdelst": "VT",
    "dropdelzpp": "058539998",
    "dropphyadd": "8411 VT RTE 111",
    "dropphycty": "MORGAN",
    "dropphyst": "VT",
    "dropphyzpp": "058539998",
    "dropmaladd": "8411 VT RTE 111",
    "dropmalcty": "MORGAN",
    "dropmalst": "VT",
    "dropmalzpp": "058539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028952700,
    "dropsitcph": 8028952700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26689",
    "droptype": "D",
    "dropname": "MORRISVILLE",
    "dropdeladd": "16 PORTLAND ST",
    "dropdelcty": "MORRISVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "056619998",
    "dropphyadd": "16 PORTLAND ST",
    "dropphycty": "MORRISVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "056619998",
    "dropmaladd": "16 PORTLAND ST",
    "dropmalcty": "MORRISVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "056619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028883557,
    "dropsitcph": 8028883557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26696",
    "droptype": "D",
    "dropname": "MOUNT HOLLY",
    "dropdeladd": "53 BELMONT RD",
    "dropdelcty": "MOUNT HOLLY",
    "dropdelst": "VT",
    "dropdelzpp": "057589998",
    "dropphyadd": "53 BELMONT RD",
    "dropphycty": "MOUNT HOLLY",
    "dropphyst": "VT",
    "dropphyzpp": "057589998",
    "dropmaladd": "53 BELMONT RD",
    "dropmalcty": "MOUNT HOLLY",
    "dropmalst": "VT",
    "dropmalzpp": "057589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022191426,
    "dropsitcph": 8022191426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26732",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "73 MAIN ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "VT",
    "dropdelzpp": "054729998",
    "dropphyadd": "73 MAIN ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "VT",
    "dropphyzpp": "054729998",
    "dropmaladd": "73 MAIN ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "VT",
    "dropmalzpp": "054729998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023120073,
    "dropsitcph": 8023120073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26740",
    "droptype": "D",
    "dropname": "NEWBURY",
    "dropdeladd": "4982 MAIN ST N",
    "dropdelcty": "NEWBURY",
    "dropdelst": "VT",
    "dropdelzpp": "050519998",
    "dropphyadd": "4982 MAIN ST N",
    "dropphycty": "NEWBURY",
    "dropphyst": "VT",
    "dropphyzpp": "050519998",
    "dropmaladd": "4982 MAIN ST N",
    "dropmalcty": "NEWBURY",
    "dropmalst": "VT",
    "dropmalzpp": "050519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028665610,
    "dropsitcph": 8028665610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26742",
    "droptype": "D",
    "dropname": "NEWFANE",
    "dropdeladd": "562 VT ROUTE 30",
    "dropdelcty": "NEWFANE",
    "dropdelst": "VT",
    "dropdelzpp": "053459998",
    "dropphyadd": "562 VT ROUTE 30",
    "dropphycty": "NEWFANE",
    "dropphyst": "VT",
    "dropphyzpp": "053459998",
    "dropmaladd": "562 VT ROUTE 30",
    "dropmalcty": "NEWFANE",
    "dropmalst": "VT",
    "dropmalzpp": "053459998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023657643,
    "dropsitcph": 8023657643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26743",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "59 COVENTRY ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "VT",
    "dropdelzpp": "058559998",
    "dropphyadd": "59 COVENTRY ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "VT",
    "dropphyzpp": "058559998",
    "dropmaladd": "59 COVENTRY ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "VT",
    "dropmalzpp": "058559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023342420,
    "dropsitcph": 8023342420,
    "dropfax": 8023343137
  },
  {
    "dcode": "D",
    "dropkey": "PV26745",
    "droptype": "D",
    "dropname": "NEWPORT CENTER",
    "dropdeladd": "4168 VT ROUTE 105",
    "dropdelcty": "NEWPORT CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "058579998",
    "dropphyadd": "4168 VT ROUTE 105",
    "dropphycty": "NEWPORT CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "058579998",
    "dropmaladd": "4168 VT ROUTE 105",
    "dropmalcty": "NEWPORT CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "058579998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023347214,
    "dropsitcph": 8023347214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26769",
    "droptype": "D",
    "dropname": "NORTH BENNINGTON",
    "dropdeladd": "52 MAIN ST",
    "dropdelcty": "NORTH BENNINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "052579998",
    "dropphyadd": "52 MAIN ST",
    "dropphycty": "NORTH BENNINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "052579998",
    "dropmaladd": "52 MAIN ST",
    "dropmalcty": "NORTH BENNINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "052579998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024424884,
    "dropsitcph": 8024424884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26775",
    "droptype": "D",
    "dropname": "NORTH CLARENDON",
    "dropdeladd": "47 MOULTON AVE",
    "dropdelcty": "NORTH CLARENDON",
    "dropdelst": "VT",
    "dropdelzpp": "057599998",
    "dropphyadd": "47 MOULTON AVE",
    "dropphycty": "NORTH CLARENDON",
    "dropphyst": "VT",
    "dropphyzpp": "057599998",
    "dropmaladd": "47 MOULTON AVE",
    "dropmalcty": "NORTH CLARENDON",
    "dropmalst": "VT",
    "dropmalzpp": "057599998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027737893,
    "dropsitcph": 8027737893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26776",
    "droptype": "D",
    "dropname": "NORTH CONCORD",
    "dropdeladd": "131 VICTORY RD",
    "dropdelcty": "NORTH CONCORD",
    "dropdelst": "VT",
    "dropdelzpp": "058589998",
    "dropphyadd": "131 VICTORY RD",
    "dropphycty": "NORTH CONCORD",
    "dropphyst": "VT",
    "dropphyzpp": "058589998",
    "dropmaladd": "131 VICTORY RD",
    "dropmalcty": "NORTH CONCORD",
    "dropmalst": "VT",
    "dropmalzpp": "058589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026952911,
    "dropsitcph": 8026952911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26782",
    "droptype": "D",
    "dropname": "NORTH FERRISBURGH",
    "dropdeladd": "6935 ROUTE 7",
    "dropdelcty": "NORTH FERRISBURGH",
    "dropdelst": "VT",
    "dropdelzpp": "054739998",
    "dropphyadd": "6935 ROUTE 7",
    "dropphycty": "NORTH FERRISBURGH",
    "dropphyst": "VT",
    "dropphyzpp": "054739998",
    "dropmaladd": "6935 ROUTE 7",
    "dropmalcty": "NORTH FERRISBURGH",
    "dropmalst": "VT",
    "dropmalzpp": "054739998",
    "dropsitphn": 8022030782,
    "dropsitlph": 8022030783,
    "dropsitcph": 8022030783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26783",
    "droptype": "D",
    "dropname": "NORTH HARTLAND",
    "dropdeladd": "619 US ROUTE 5",
    "dropdelcty": "NORTH HARTLAND",
    "dropdelst": "VT",
    "dropdelzpp": "050529998",
    "dropphyadd": "619 US ROUTE 5",
    "dropphycty": "NORTH HARTLAND",
    "dropphyst": "VT",
    "dropphyzpp": "050529998",
    "dropmaladd": "619 US ROUTE 5",
    "dropmalcty": "NORTH HARTLAND",
    "dropmalst": "VT",
    "dropmalzpp": "050529998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022963741,
    "dropsitcph": 8022963741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26784",
    "droptype": "D",
    "dropname": "NORTH HERO",
    "dropdeladd": "3537 US ROUTE 2 STE A",
    "dropdelcty": "NORTH HERO",
    "dropdelst": "VT",
    "dropdelzpp": "054749998",
    "dropphyadd": "3537 US ROUTE 2 STE A",
    "dropphycty": "NORTH HERO",
    "dropphyst": "VT",
    "dropphyzpp": "054749998",
    "dropmaladd": "3537 US ROUTE 2 STE A",
    "dropmalcty": "NORTH HERO",
    "dropmalst": "VT",
    "dropmalzpp": "054749998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023725071,
    "dropsitcph": 8023725071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26785",
    "droptype": "D",
    "dropname": "NORTH HYDE PARK",
    "dropdeladd": "5541 VT RTE 100",
    "dropdelcty": "NORTH HYDE PARK",
    "dropdelst": "VT",
    "dropdelzpp": "056659998",
    "dropphyadd": "5541 VT RTE 100",
    "dropphycty": "NORTH HYDE PARK",
    "dropphyst": "VT",
    "dropphyzpp": "056659998",
    "dropmaladd": "5541 VT RTE 100",
    "dropmalcty": "NORTH HYDE PARK",
    "dropmalst": "VT",
    "dropmalzpp": "056659998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026352545,
    "dropsitcph": 8026352545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26791",
    "droptype": "D",
    "dropname": "NORTH POMFRET",
    "dropdeladd": "7868 POMFRET RD",
    "dropdelcty": "NORTH POMFRET",
    "dropdelst": "VT",
    "dropdelzpp": "050539998",
    "dropphyadd": "7868 POMFRET RD",
    "dropphycty": "NORTH POMFRET",
    "dropphyst": "VT",
    "dropphyzpp": "050539998",
    "dropmaladd": "7868 POMFRET RD",
    "dropmalcty": "NORTH POMFRET",
    "dropmalst": "VT",
    "dropmalzpp": "050539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024573388,
    "dropsitcph": 8024573388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26792",
    "droptype": "D",
    "dropname": "NORTH POWNAL",
    "dropdeladd": "3616 ROUTE 346",
    "dropdelcty": "NORTH POWNAL",
    "dropdelst": "VT",
    "dropdelzpp": "052609998",
    "dropphyadd": "3616 ROUTE 346",
    "dropphycty": "NORTH POWNAL",
    "dropphyst": "VT",
    "dropphyzpp": "052609998",
    "dropmaladd": "3616 ROUTE 346",
    "dropmalcty": "NORTH POWNAL",
    "dropmalst": "VT",
    "dropmalzpp": "052609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028235622,
    "dropsitcph": 8028235622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26799",
    "droptype": "D",
    "dropname": "NORTH SPRINGFIELD",
    "dropdeladd": "365 GIDDINGS ST",
    "dropdelcty": "NORTH SPRINGFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "051509998",
    "dropphyadd": "365 GIDDINGS ST",
    "dropphycty": "NORTH SPRINGFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "051509998",
    "dropmaladd": "365 GIDDINGS ST",
    "dropmalcty": "NORTH SPRINGFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "051509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028868161,
    "dropsitcph": 8028868161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26800",
    "droptype": "D",
    "dropname": "NORTH THETFORD",
    "dropdeladd": "5378 RTE 5",
    "dropdelcty": "NORTH THETFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050549998",
    "dropphyadd": "5378 RTE 5",
    "dropphycty": "NORTH THETFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050549998",
    "dropmaladd": "5378 RTE 5",
    "dropmalcty": "NORTH THETFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023339555,
    "dropsitcph": 8023339555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26801",
    "droptype": "D",
    "dropname": "NORTH TROY",
    "dropdeladd": "66 SOUTH ST",
    "dropdelcty": "NORTH TROY",
    "dropdelst": "VT",
    "dropdelzpp": "058599998",
    "dropphyadd": "66 SOUTH ST",
    "dropphycty": "NORTH TROY",
    "dropphyst": "VT",
    "dropphyzpp": "058599998",
    "dropmaladd": "66 SOUTH ST",
    "dropmalcty": "NORTH TROY",
    "dropmalst": "VT",
    "dropmalzpp": "058599998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029882229,
    "dropsitcph": 8029882229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26808",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "119 S MAIN ST STE 1",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "056639998",
    "dropphyadd": "119 S MAIN ST STE 1",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "056639998",
    "dropmaladd": "119 S MAIN ST STE 1",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "056639998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024854541,
    "dropsitcph": 8024854541,
    "dropfax": 8024859265
  },
  {
    "dcode": "D",
    "dropkey": "PV26810",
    "droptype": "D",
    "dropname": "NORTHFIELD FALLS",
    "dropdeladd": "51 GOULD RD",
    "dropdelcty": "NORTHFIELD FALLS",
    "dropdelst": "VT",
    "dropdelzpp": "056649998",
    "dropphyadd": "51 GOULD RD",
    "dropphycty": "NORTHFIELD FALLS",
    "dropphyst": "VT",
    "dropphyzpp": "056649998",
    "dropmaladd": "51 GOULD RD",
    "dropmalcty": "NORTHFIELD FALLS",
    "dropmalst": "VT",
    "dropmalzpp": "056649998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022252004,
    "dropsitcph": 8022252004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26813",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "445 VT ROUTE 114 S",
    "dropdelcty": "NORTON",
    "dropdelst": "VT",
    "dropdelzpp": "059079998",
    "dropphyadd": "445 VT ROUTE 114 S",
    "dropphycty": "NORTON",
    "dropphyst": "VT",
    "dropphyzpp": "059079998",
    "dropmaladd": "445 VT ROUTE 114 S",
    "dropmalcty": "NORTON",
    "dropmalst": "VT",
    "dropmalzpp": "059079998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028225577,
    "dropsitcph": 8028225577,
    "dropfax": 8028225524
  },
  {
    "dcode": "D",
    "dropkey": "PV26814",
    "droptype": "D",
    "dropname": "NORWICH",
    "dropdeladd": "293 MAIN ST",
    "dropdelcty": "NORWICH",
    "dropdelst": "VT",
    "dropdelzpp": "050559344",
    "dropphyadd": "293 MAIN ST",
    "dropphycty": "NORWICH",
    "dropphyst": "VT",
    "dropphyzpp": "050559344",
    "dropmaladd": "293 MAIN ST",
    "dropmalcty": "NORWICH",
    "dropmalst": "VT",
    "dropmalzpp": "050559344",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026491608,
    "dropsitcph": 8026491608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26827",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "2 WATER ST",
    "dropdelcty": "ORLEANS",
    "dropdelst": "VT",
    "dropdelzpp": "058609998",
    "dropphyadd": "2 WATER ST",
    "dropphycty": "ORLEANS",
    "dropphyst": "VT",
    "dropphyzpp": "058609998",
    "dropmaladd": "2 WATER ST",
    "dropmalcty": "ORLEANS",
    "dropmalst": "VT",
    "dropmalzpp": "058609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027546550,
    "dropsitcph": 8027546550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26828",
    "droptype": "D",
    "dropname": "ORWELL",
    "dropdeladd": "538 MAIN ST",
    "dropdelcty": "ORWELL",
    "dropdelst": "VT",
    "dropdelzpp": "057609998",
    "dropphyadd": "538 MAIN ST",
    "dropphycty": "ORWELL",
    "dropphyst": "VT",
    "dropphyzpp": "057609998",
    "dropmaladd": "538 MAIN ST",
    "dropmalcty": "ORWELL",
    "dropmalst": "VT",
    "dropmalzpp": "057609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675031,
    "dropsitcph": 8022675031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26834",
    "droptype": "D",
    "dropname": "PASSUMPSIC",
    "dropdeladd": "32 BRIDGE ST",
    "dropdelcty": "PASSUMPSIC",
    "dropdelst": "VT",
    "dropdelzpp": "058619998",
    "dropphyadd": "32 BRIDGE ST",
    "dropphycty": "PASSUMPSIC",
    "dropphyst": "VT",
    "dropphyzpp": "058619998",
    "dropmaladd": "32 BRIDGE ST",
    "dropmalcty": "PASSUMPSIC",
    "dropmalst": "VT",
    "dropmalzpp": "058619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027481325,
    "dropsitcph": 8027481325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26835",
    "droptype": "D",
    "dropname": "PAWLET",
    "dropdeladd": "5707 VT ROUTE 30",
    "dropdelcty": "PAWLET",
    "dropdelst": "VT",
    "dropdelzpp": "057619998",
    "dropphyadd": "5707 VT ROUTE 30",
    "dropphycty": "PAWLET",
    "dropphyst": "VT",
    "dropphyzpp": "057619998",
    "dropmaladd": "5707 VT ROUTE 30",
    "dropmalcty": "PAWLET",
    "dropmalst": "VT",
    "dropmalzpp": "057619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675024,
    "dropsitcph": 8022675024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26837",
    "droptype": "D",
    "dropname": "PEACHAM",
    "dropdeladd": "79 CHURCH ST",
    "dropdelcty": "PEACHAM",
    "dropdelst": "VT",
    "dropdelzpp": "058629998",
    "dropphyadd": "79 CHURCH ST",
    "dropphycty": "PEACHAM",
    "dropphyst": "VT",
    "dropphyzpp": "058629998",
    "dropmaladd": "79 CHURCH ST",
    "dropmalcty": "PEACHAM",
    "dropmalst": "VT",
    "dropmalzpp": "058629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025923372,
    "dropsitcph": 8025923372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26843",
    "droptype": "D",
    "dropname": "PERKINSVILLE",
    "dropdeladd": "7290 VT ROUTE 131",
    "dropdelcty": "PERKINSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "051519998",
    "dropphyadd": "7290 VT ROUTE 131",
    "dropphycty": "PERKINSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "051519998",
    "dropmaladd": "7290 VT ROUTE 131",
    "dropmalcty": "PERKINSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "051519998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022162026,
    "dropsitcph": 8022162026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26846",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "PERU",
    "dropdelst": "VT",
    "dropdelzpp": "051529998",
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "PERU",
    "dropphyst": "VT",
    "dropphyzpp": "051529998",
    "dropmaladd": "311 MAIN ST",
    "dropmalcty": "PERU",
    "dropmalst": "VT",
    "dropmalzpp": "051529998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028245472,
    "dropsitcph": 8028245472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26853",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "3934 ROUTE 100",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "057629998",
    "dropphyadd": "3934 ROUTE 100",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "057629998",
    "dropmaladd": "3934 ROUTE 100",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "057629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027468953,
    "dropsitcph": 8027468953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26855",
    "droptype": "D",
    "dropname": "PITTSFORD",
    "dropdeladd": "853 ARCH ST",
    "dropdelcty": "PITTSFORD",
    "dropdelst": "VT",
    "dropdelzpp": "057639998",
    "dropphyadd": "853 ARCH ST",
    "dropphycty": "PITTSFORD",
    "dropphyst": "VT",
    "dropphyzpp": "057639998",
    "dropmaladd": "853 ARCH ST",
    "dropmalcty": "PITTSFORD",
    "dropmalst": "VT",
    "dropmalzpp": "057639998",
    "dropsitphn": 8024833741,
    "dropsitlph": 8024833747,
    "dropsitcph": 8024833747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26857",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "189 TOWNE AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "056679998",
    "dropphyadd": "189 TOWNE AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "056679998",
    "dropmaladd": "189 TOWNE AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "056679998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024548350,
    "dropsitcph": 8024548350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26861",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "236 COOLIDGE MEMORIAL RD",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "VT",
    "dropdelzpp": "050569998",
    "dropphyadd": "236 COOLIDGE MEMORIAL RD",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "VT",
    "dropphyzpp": "050569998",
    "dropmaladd": "236 COOLIDGE MEMORIAL RD",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "VT",
    "dropmalzpp": "050569998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022191317,
    "dropsitcph": 8022191317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26869",
    "droptype": "D",
    "dropname": "POST MILLS",
    "dropdeladd": "7788 VT ROUTE 113",
    "dropdelcty": "POST MILLS",
    "dropdelst": "VT",
    "dropdelzpp": "050589998",
    "dropphyadd": "7788 VT ROUTE 113",
    "dropphycty": "POST MILLS",
    "dropphyst": "VT",
    "dropphyzpp": "050589998",
    "dropmaladd": "7788 VT ROUTE 113",
    "dropmalcty": "POST MILLS",
    "dropmalst": "VT",
    "dropmalzpp": "050589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023336657,
    "dropsitcph": 8023336657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26874",
    "droptype": "D",
    "dropname": "POULTNEY",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "POULTNEY",
    "dropdelst": "VT",
    "dropdelzpp": "057649998",
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "POULTNEY",
    "dropphyst": "VT",
    "dropphyzpp": "057649998",
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "POULTNEY",
    "dropmalst": "VT",
    "dropmalzpp": "057649998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022879033,
    "dropsitcph": 8022879033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26875",
    "droptype": "D",
    "dropname": "POWNAL",
    "dropdeladd": "235 VT ROUTE 346",
    "dropdelcty": "POWNAL",
    "dropdelst": "VT",
    "dropdelzpp": "052619998",
    "dropphyadd": "235 VT ROUTE 346",
    "dropphycty": "POWNAL",
    "dropphyst": "VT",
    "dropphyzpp": "052619998",
    "dropmaladd": "235 VT ROUTE 346",
    "dropmalcty": "POWNAL",
    "dropmalst": "VT",
    "dropmalzpp": "052619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028237922,
    "dropsitcph": 8028237922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26878",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "29 MAIN ST STE 2",
    "dropdelcty": "PROCTOR",
    "dropdelst": "VT",
    "dropdelzpp": "057659998",
    "dropphyadd": "29 MAIN ST STE 2",
    "dropphycty": "PROCTOR",
    "dropphyst": "VT",
    "dropphyzpp": "057659998",
    "dropmaladd": "29 MAIN ST STE 2",
    "dropmalcty": "PROCTOR",
    "dropmalst": "VT",
    "dropmalzpp": "057659998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024593359,
    "dropsitcph": 8024593359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26879",
    "droptype": "D",
    "dropname": "PROCTORSVILLE",
    "dropdeladd": "7 DEPOT ST",
    "dropdelcty": "PROCTORSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "051539998",
    "dropphyadd": "7 DEPOT ST",
    "dropphycty": "PROCTORSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "051539998",
    "dropmaladd": "7 DEPOT ST",
    "dropmalcty": "PROCTORSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "051539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022162319,
    "dropsitcph": 8022162319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26885",
    "droptype": "D",
    "dropname": "PUTNEY",
    "dropdeladd": "109 MAIN ST",
    "dropdelcty": "PUTNEY",
    "dropdelst": "VT",
    "dropdelzpp": "053469998",
    "dropphyadd": "109 MAIN ST",
    "dropphycty": "PUTNEY",
    "dropphyst": "VT",
    "dropphyzpp": "053469998",
    "dropmaladd": "109 MAIN ST",
    "dropmalcty": "PUTNEY",
    "dropmalst": "VT",
    "dropmalzpp": "053469998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023875555,
    "dropsitcph": 8023875555,
    "dropfax": 8023874763
  },
  {
    "dcode": "D",
    "dropkey": "PV26886",
    "droptype": "D",
    "dropname": "QUECHEE",
    "dropdeladd": "91 VILLAGE GREEN CIR",
    "dropdelcty": "QUECHEE",
    "dropdelst": "VT",
    "dropdelzpp": "050599998",
    "dropphyadd": "91 VILLAGE GREEN CIR",
    "dropphycty": "QUECHEE",
    "dropphyst": "VT",
    "dropphyzpp": "050599998",
    "dropmaladd": "91 VILLAGE GREEN CIR",
    "dropmalcty": "QUECHEE",
    "dropmalst": "VT",
    "dropmalzpp": "050599998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022953535,
    "dropsitcph": 8022953535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26890",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "9 SALISBURY ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "VT",
    "dropdelzpp": "050609998",
    "dropphyadd": "9 SALISBURY ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "VT",
    "dropphyzpp": "050609998",
    "dropmaladd": "9 SALISBURY ST",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "VT",
    "dropmalzpp": "050609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027285444,
    "dropsitcph": 8027285444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26891",
    "droptype": "D",
    "dropname": "RANDOLPH CENTER",
    "dropdeladd": "2952 VT ROUTE 66",
    "dropdelcty": "RANDOLPH CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "050619998",
    "dropphyadd": "2952 VT ROUTE 66",
    "dropphycty": "RANDOLPH CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "050619998",
    "dropmaladd": "2952 VT ROUTE 66",
    "dropmalcty": "RANDOLPH CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "050619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027289374,
    "dropsitcph": 8027289374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26895",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "799 ROUTE 106",
    "dropdelcty": "READING",
    "dropdelst": "VT",
    "dropdelzpp": "050629998",
    "dropphyadd": "799 ROUTE 106",
    "dropphycty": "READING",
    "dropphyst": "VT",
    "dropphyzpp": "050629998",
    "dropmaladd": "799 ROUTE 106",
    "dropmalcty": "READING",
    "dropmalst": "VT",
    "dropmalzpp": "050629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024845994,
    "dropsitcph": 8024845994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26897",
    "droptype": "D",
    "dropname": "READSBORO",
    "dropdeladd": "6802 MAIN ST",
    "dropdelcty": "READSBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053509998",
    "dropphyadd": "6802 MAIN ST",
    "dropphycty": "READSBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053509998",
    "dropmaladd": "6802 MAIN ST",
    "dropmalcty": "READSBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053509998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024237030,
    "dropsitcph": 8024237030,
    "dropfax": 8024237030
  },
  {
    "dcode": "D",
    "dropkey": "PV26905",
    "droptype": "D",
    "dropname": "RICHFORD",
    "dropdeladd": "80 MAIN ST STE 101",
    "dropdelcty": "RICHFORD",
    "dropdelst": "VT",
    "dropdelzpp": "054769998",
    "dropphyadd": "80 MAIN ST STE 101",
    "dropphycty": "RICHFORD",
    "dropphyst": "VT",
    "dropphyzpp": "054769998",
    "dropmaladd": "80 MAIN ST STE 101",
    "dropmalcty": "RICHFORD",
    "dropmalst": "VT",
    "dropmalzpp": "054769998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028487742,
    "dropsitcph": 8028487742,
    "dropfax": 8028487742
  },
  {
    "dcode": "D",
    "dropkey": "PV26909",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "205 BRIDGE ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VT",
    "dropdelzpp": "054779998",
    "dropphyadd": "205 BRIDGE ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "VT",
    "dropphyzpp": "054779998",
    "dropmaladd": "205 BRIDGE ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VT",
    "dropmalzpp": "054779998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022031400,
    "dropsitcph": 8022031400,
    "dropfax": 8024345403
  },
  {
    "dcode": "D",
    "dropkey": "PV26917",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "46 PARK ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "VT",
    "dropdelzpp": "057679998",
    "dropphyadd": "46 PARK ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "VT",
    "dropphyzpp": "057679998",
    "dropmaladd": "46 PARK ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "VT",
    "dropmalzpp": "057679998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027673371,
    "dropsitcph": 8027673371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26924",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "1593 ROXBURY RD",
    "dropdelcty": "ROXBURY",
    "dropdelst": "VT",
    "dropdelzpp": "056699998",
    "dropphyadd": "1593 ROXBURY RD",
    "dropphycty": "ROXBURY",
    "dropphyst": "VT",
    "dropphyzpp": "056699998",
    "dropmaladd": "1593 ROXBURY RD",
    "dropmalcty": "ROXBURY",
    "dropmalst": "VT",
    "dropmalzpp": "056699998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024858696,
    "dropsitcph": 8024858696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26927",
    "droptype": "D",
    "dropname": "RUPERT",
    "dropdeladd": "84 MAIN ST",
    "dropdelcty": "RUPERT",
    "dropdelst": "VT",
    "dropdelzpp": "057689998",
    "dropphyadd": "84 MAIN ST",
    "dropphycty": "RUPERT",
    "dropphyst": "VT",
    "dropphyzpp": "057689998",
    "dropmaladd": "84 MAIN ST",
    "dropmalcty": "RUPERT",
    "dropmalst": "VT",
    "dropmalzpp": "057689998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023947745,
    "dropsitcph": 8023947745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26930",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "173 WEST ST",
    "dropdelcty": "RUTLAND",
    "dropdelst": "VT",
    "dropdelzpp": "057019990",
    "dropphyadd": "173 WEST ST",
    "dropphycty": "RUTLAND",
    "dropphyst": "VT",
    "dropphyzpp": "057019990",
    "dropmaladd": "173 WEST ST",
    "dropmalcty": "RUTLAND",
    "dropmalst": "VT",
    "dropmalzpp": "057019990",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027730222,
    "dropsitcph": 8027730301,
    "dropfax": 8027730305
  },
  {
    "dcode": "D",
    "dropkey": "PV26953",
    "droptype": "D",
    "dropname": "SAINT ALBANS",
    "dropdeladd": "153 N MAIN ST",
    "dropdelcty": "SAINT ALBANS",
    "dropdelst": "VT",
    "dropdelzpp": "054789998",
    "dropphyadd": "153 N MAIN ST",
    "dropphycty": "SAINT ALBANS",
    "dropphyst": "VT",
    "dropphyzpp": "054789998",
    "dropmaladd": "153 N MAIN ST",
    "dropmalcty": "SAINT ALBANS",
    "dropmalst": "VT",
    "dropmalzpp": "054789998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025246518,
    "dropsitcph": 8025246518,
    "dropfax": 8025270574
  },
  {
    "dcode": "D",
    "dropkey": "PV26954",
    "droptype": "D",
    "dropname": "SAINT ALBANS BAY",
    "dropdeladd": "571 LAKE RD",
    "dropdelcty": "SAINT ALBANS BAY",
    "dropdelst": "VT",
    "dropdelzpp": "054819998",
    "dropphyadd": "571 LAKE RD",
    "dropphycty": "SAINT ALBANS BAY",
    "dropphyst": "VT",
    "dropphyzpp": "054819998",
    "dropmaladd": "571 LAKE RD",
    "dropmalcty": "SAINT ALBANS BAY",
    "dropmalst": "VT",
    "dropmalzpp": "054819998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025244076,
    "dropsitcph": 8025244076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26956",
    "droptype": "D",
    "dropname": "SAINT JOHNSBURY",
    "dropdeladd": "1153 MAIN ST RM 100",
    "dropdelcty": "SAINT JOHNSBURY",
    "dropdelst": "VT",
    "dropdelzpp": "058199998",
    "dropphyadd": "1153 MAIN ST RM 100",
    "dropphycty": "SAINT JOHNSBURY",
    "dropphyst": "VT",
    "dropphyzpp": "058199998",
    "dropmaladd": "1153 MAIN ST RM 100",
    "dropmalcty": "SAINT JOHNSBURY",
    "dropmalst": "VT",
    "dropmalzpp": "058199998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027483301,
    "dropsitcph": 8027483301,
    "dropfax": 8027480711
  },
  {
    "dcode": "D",
    "dropkey": "PV26958",
    "droptype": "D",
    "dropname": "SAINT JOHNSBURY CENTER",
    "dropdeladd": "1616 MEMORIAL DR",
    "dropdelcty": "SAINT JOHNSBURY CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "058639998",
    "dropphyadd": "1616 MEMORIAL DR",
    "dropphycty": "SAINT JOHNSBURY CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "058639998",
    "dropmaladd": "1616 MEMORIAL DR",
    "dropmalcty": "SAINT JOHNSBURY CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "058639998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027484773,
    "dropsitcph": 8027484773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26963",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "935 MAPLE ST",
    "dropdelcty": "SALISBURY",
    "dropdelst": "VT",
    "dropdelzpp": "057699998",
    "dropphyadd": "935 MAPLE ST",
    "dropphycty": "SALISBURY",
    "dropphyst": "VT",
    "dropphyzpp": "057699998",
    "dropmaladd": "935 MAPLE ST",
    "dropmalcty": "SALISBURY",
    "dropmalst": "VT",
    "dropmalzpp": "057699998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023524500,
    "dropsitcph": 8023524500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26967",
    "droptype": "D",
    "dropname": "SAXTONS RIVER",
    "dropdeladd": "39 MAIN ST",
    "dropdelcty": "SAXTONS RIVER",
    "dropdelst": "VT",
    "dropdelzpp": "051549998",
    "dropphyadd": "39 MAIN ST",
    "dropphycty": "SAXTONS RIVER",
    "dropphyst": "VT",
    "dropphyzpp": "051549998",
    "dropmaladd": "39 MAIN ST",
    "dropmalcty": "SAXTONS RIVER",
    "dropmalst": "VT",
    "dropmalzpp": "051549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022162125,
    "dropsitcph": 8022162125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26974",
    "droptype": "D",
    "dropname": "SHAFTSBURY",
    "dropdeladd": "56 CHURCH ST",
    "dropdelcty": "SHAFTSBURY",
    "dropdelst": "VT",
    "dropdelzpp": "052629998",
    "dropphyadd": "56 CHURCH ST",
    "dropphycty": "SHAFTSBURY",
    "dropphyst": "VT",
    "dropphyzpp": "052629998",
    "dropmaladd": "56 CHURCH ST",
    "dropmalcty": "SHAFTSBURY",
    "dropmalst": "VT",
    "dropmalzpp": "052629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024422142,
    "dropsitcph": 8024422142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26976",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "5094 ROUTE 14",
    "dropdelcty": "SHARON",
    "dropdelst": "VT",
    "dropdelzpp": "050659998",
    "dropphyadd": "5094 ROUTE 14",
    "dropphycty": "SHARON",
    "dropphyst": "VT",
    "dropphyzpp": "050659998",
    "dropmaladd": "5094 ROUTE 14",
    "dropmalcty": "SHARON",
    "dropmalst": "VT",
    "dropmalzpp": "050659998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027637637,
    "dropsitcph": 8027637637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26979",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "3037 MAIN ST",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "058669998",
    "dropphyadd": "3037 MAIN ST",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "058669998",
    "dropmaladd": "3037 MAIN ST",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "058669998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026269668,
    "dropsitcph": 8026269668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26982",
    "droptype": "D",
    "dropname": "SHELBURNE",
    "dropdeladd": "495 FALLS RD",
    "dropdelcty": "SHELBURNE",
    "dropdelst": "VT",
    "dropdelzpp": "054829998",
    "dropphyadd": "495 FALLS RD",
    "dropphycty": "SHELBURNE",
    "dropphyst": "VT",
    "dropphyzpp": "054829998",
    "dropmaladd": "495 FALLS RD",
    "dropmalcty": "SHELBURNE",
    "dropmalst": "VT",
    "dropmalzpp": "054829998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029853615,
    "dropsitcph": 8029853615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26983",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "1547 MAIN ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "VT",
    "dropdelzpp": "054839998",
    "dropphyadd": "1547 MAIN ST",
    "dropphycty": "SHELDON",
    "dropphyst": "VT",
    "dropphyzpp": "054839998",
    "dropmaladd": "1547 MAIN ST",
    "dropmalcty": "SHELDON",
    "dropmalst": "VT",
    "dropmalzpp": "054839998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029332188,
    "dropsitcph": 8029332188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26987",
    "droptype": "D",
    "dropname": "SHELDON SPRINGS",
    "dropdeladd": "614 MILL ST",
    "dropdelcty": "SHELDON SPRINGS",
    "dropdelst": "VT",
    "dropdelzpp": "054859998",
    "dropphyadd": "614 MILL ST",
    "dropphycty": "SHELDON SPRINGS",
    "dropphyst": "VT",
    "dropphyzpp": "054859998",
    "dropmaladd": "614 MILL ST",
    "dropmalcty": "SHELDON SPRINGS",
    "dropmalst": "VT",
    "dropmalzpp": "054859998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8029334994,
    "dropsitcph": 8029334994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV26990",
    "droptype": "D",
    "dropname": "SHOREHAM",
    "dropdeladd": "75 MAIN ST",
    "dropdelcty": "SHOREHAM",
    "dropdelst": "VT",
    "dropdelzpp": "057709998",
    "dropphyadd": "75 MAIN ST",
    "dropphycty": "SHOREHAM",
    "dropphyst": "VT",
    "dropphyzpp": "057709998",
    "dropmaladd": "75 MAIN ST",
    "dropmalcty": "SHOREHAM",
    "dropmalst": "VT",
    "dropmalzpp": "057709998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675056,
    "dropsitcph": 8022675056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27021",
    "droptype": "D",
    "dropname": "SOUTH BARRE",
    "dropdeladd": "379 S BARRE RD",
    "dropdelcty": "SOUTH BARRE",
    "dropdelst": "VT",
    "dropdelzpp": "056709998",
    "dropphyadd": "379 S BARRE RD",
    "dropphycty": "SOUTH BARRE",
    "dropphyst": "VT",
    "dropphyzpp": "056709998",
    "dropmaladd": "379 S BARRE RD",
    "dropmalcty": "SOUTH BARRE",
    "dropmalst": "VT",
    "dropmalzpp": "056709998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024768319,
    "dropsitcph": 8024768319,
    "dropfax": 8022536005
  },
  {
    "dcode": "D",
    "dropkey": "PV27032",
    "droptype": "D",
    "dropname": "SOUTH HERO",
    "dropdeladd": "291 ROUTE 2",
    "dropdelcty": "SOUTH HERO",
    "dropdelst": "VT",
    "dropdelzpp": "054869998",
    "dropphyadd": "291 ROUTE 2",
    "dropphycty": "SOUTH HERO",
    "dropphyst": "VT",
    "dropphyzpp": "054869998",
    "dropmaladd": "291 ROUTE 2",
    "dropmalcty": "SOUTH HERO",
    "dropmalst": "VT",
    "dropmalzpp": "054869998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023724825,
    "dropsitcph": 8023724825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27034",
    "droptype": "D",
    "dropname": "SOUTH LONDONDERRY",
    "dropdeladd": "67 MAIN ST",
    "dropdelcty": "SOUTH LONDONDERRY",
    "dropdelst": "VT",
    "dropdelzpp": "051559998",
    "dropphyadd": "67 MAIN ST",
    "dropphycty": "SOUTH LONDONDERRY",
    "dropphyst": "VT",
    "dropphyzpp": "051559998",
    "dropmaladd": "67 MAIN ST",
    "dropmalcty": "SOUTH LONDONDERRY",
    "dropmalst": "VT",
    "dropmalzpp": "051559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028246800,
    "dropsitcph": 8028246800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27040",
    "droptype": "D",
    "dropname": "SOUTH POMFRET",
    "dropdeladd": "2035 POMFRET RD UNIT B",
    "dropdelcty": "SOUTH POMFRET",
    "dropdelst": "VT",
    "dropdelzpp": "050679998",
    "dropphyadd": "2035 POMFRET RD UNIT B",
    "dropphycty": "SOUTH POMFRET",
    "dropphyst": "VT",
    "dropphyzpp": "050679998",
    "dropmaladd": "2035 POMFRET RD UNIT B",
    "dropmalcty": "SOUTH POMFRET",
    "dropmalst": "VT",
    "dropmalzpp": "050679998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024571147,
    "dropsitcph": 8024571147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27046",
    "droptype": "D",
    "dropname": "SOUTH ROYALTON",
    "dropdeladd": "239 CHELSEA ST",
    "dropdelcty": "SOUTH ROYALTON",
    "dropdelst": "VT",
    "dropdelzpp": "050689998",
    "dropphyadd": "239 CHELSEA ST",
    "dropphycty": "SOUTH ROYALTON",
    "dropphyst": "VT",
    "dropphyzpp": "050689998",
    "dropmaladd": "239 CHELSEA ST",
    "dropmalcty": "SOUTH ROYALTON",
    "dropmalst": "VT",
    "dropmalzpp": "050689998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027637330,
    "dropsitcph": 8027637330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27047",
    "droptype": "D",
    "dropname": "SOUTH RYEGATE",
    "dropdeladd": "2544 SCOTT HWY",
    "dropdelcty": "SOUTH RYEGATE",
    "dropdelst": "VT",
    "dropdelzpp": "050699998",
    "dropphyadd": "2544 SCOTT HWY",
    "dropphycty": "SOUTH RYEGATE",
    "dropphyst": "VT",
    "dropphyzpp": "050699998",
    "dropmaladd": "2544 SCOTT HWY",
    "dropmalcty": "SOUTH RYEGATE",
    "dropmalst": "VT",
    "dropmalzpp": "050699998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8025843615,
    "dropsitcph": 8025843615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27050",
    "droptype": "D",
    "dropname": "SOUTH STRAFFORD",
    "dropdeladd": "216 VT RTE 132",
    "dropdelcty": "SOUTH STRAFFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050709998",
    "dropphyadd": "216 VT RTE 132",
    "dropphycty": "SOUTH STRAFFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050709998",
    "dropmaladd": "216 VT RTE 132",
    "dropmalcty": "SOUTH STRAFFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050709998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027654065,
    "dropsitcph": 8027654065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27060",
    "droptype": "D",
    "dropname": "SOUTH WOODSTOCK",
    "dropdeladd": "4800 SOUTH RD",
    "dropdelcty": "SOUTH WOODSTOCK",
    "dropdelst": "VT",
    "dropdelzpp": "050719998",
    "dropphyadd": "4800 SOUTH RD",
    "dropphycty": "SOUTH WOODSTOCK",
    "dropphyst": "VT",
    "dropphyzpp": "050719998",
    "dropmaladd": "4800 SOUTH RD",
    "dropmalcty": "SOUTH WOODSTOCK",
    "dropmalst": "VT",
    "dropmalzpp": "050719998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024571680,
    "dropsitcph": 8024571680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27064",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "132 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "051569998",
    "dropphyadd": "132 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "051569998",
    "dropmaladd": "132 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "051569998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028854103,
    "dropsitcph": 8028854103,
    "dropfax": 8028852677
  },
  {
    "dcode": "D",
    "dropkey": "PV27080",
    "droptype": "D",
    "dropname": "STARKSBORO",
    "dropdeladd": "3054 VT ROUTE 116",
    "dropdelcty": "STARKSBORO",
    "dropdelst": "VT",
    "dropdelzpp": "054879998",
    "dropphyadd": "3054 VT ROUTE 116",
    "dropphycty": "STARKSBORO",
    "dropphyst": "VT",
    "dropphyzpp": "054879998",
    "dropmaladd": "3054 VT ROUTE 116",
    "dropmalcty": "STARKSBORO",
    "dropmalst": "VT",
    "dropmalzpp": "054879998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022031481,
    "dropsitcph": 8022031481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27086",
    "droptype": "D",
    "dropname": "STOCKBRIDGE",
    "dropdeladd": "1720 VT ROUTE 100",
    "dropdelcty": "STOCKBRIDGE",
    "dropdelst": "VT",
    "dropdelzpp": "057729998",
    "dropphyadd": "1720 VT ROUTE 100",
    "dropphycty": "STOCKBRIDGE",
    "dropphyst": "VT",
    "dropphyzpp": "057729998",
    "dropmaladd": "1720 VT ROUTE 100",
    "dropmalcty": "STOCKBRIDGE",
    "dropmalst": "VT",
    "dropmalzpp": "057729998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027465016,
    "dropsitcph": 8027465016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27088",
    "droptype": "D",
    "dropname": "STOWE",
    "dropdeladd": "105 DEPOT ST",
    "dropdelcty": "STOWE",
    "dropdelst": "VT",
    "dropdelzpp": "056729998",
    "dropphyadd": "105 DEPOT ST",
    "dropphycty": "STOWE",
    "dropphyst": "VT",
    "dropphyzpp": "056729998",
    "dropmaladd": "105 DEPOT ST",
    "dropmalcty": "STOWE",
    "dropmalst": "VT",
    "dropmalzpp": "056729998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022537521,
    "dropsitcph": 8022537521,
    "dropfax": 8022536005
  },
  {
    "dcode": "D",
    "dropkey": "PV27090",
    "droptype": "D",
    "dropname": "STRAFFORD",
    "dropdeladd": "1 BROOK RD",
    "dropdelcty": "STRAFFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050729998",
    "dropphyadd": "1 BROOK RD",
    "dropphycty": "STRAFFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050729998",
    "dropmaladd": "1 BROOK RD",
    "dropmalcty": "STRAFFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050729998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027654554,
    "dropsitcph": 8027654554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27103",
    "droptype": "D",
    "dropname": "SWANTON",
    "dropdeladd": "21 GRAND AVE",
    "dropdelcty": "SWANTON",
    "dropdelst": "VT",
    "dropdelzpp": "054889998",
    "dropphyadd": "21 GRAND AVE",
    "dropphycty": "SWANTON",
    "dropphyst": "VT",
    "dropphyzpp": "054889998",
    "dropmaladd": "21 GRAND AVE",
    "dropmalcty": "SWANTON",
    "dropmalst": "VT",
    "dropmalzpp": "054889998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028684188,
    "dropsitcph": 8028684188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27106",
    "droptype": "D",
    "dropname": "TAFTSVILLE",
    "dropdeladd": "33 HAPPY VALLEY RD",
    "dropdelcty": "TAFTSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "050739998",
    "dropphyadd": "33 HAPPY VALLEY RD",
    "dropphycty": "TAFTSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "050739998",
    "dropmaladd": "33 HAPPY VALLEY RD",
    "dropmalcty": "TAFTSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "050739998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024573504,
    "dropsitcph": 8024573504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27116",
    "droptype": "D",
    "dropname": "THETFORD",
    "dropdeladd": "2734 RTE 113",
    "dropdelcty": "THETFORD",
    "dropdelst": "VT",
    "dropdelzpp": "050749998",
    "dropphyadd": "2734 RTE 113",
    "dropphycty": "THETFORD",
    "dropphyst": "VT",
    "dropphyzpp": "050749998",
    "dropmaladd": "2734 RTE 113",
    "dropmalcty": "THETFORD",
    "dropmalst": "VT",
    "dropmalzpp": "050749998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027850008,
    "dropsitcph": 8027850008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27117",
    "droptype": "D",
    "dropname": "THETFORD CENTER",
    "dropdeladd": "3956 ROUTE 113",
    "dropdelcty": "THETFORD CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "050759998",
    "dropphyadd": "3956 ROUTE 113",
    "dropphycty": "THETFORD CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "050759998",
    "dropmaladd": "3956 ROUTE 113",
    "dropmalcty": "THETFORD CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "050759998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8778541489,
    "dropsitcph": 8778541489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27124",
    "droptype": "D",
    "dropname": "TOWNSHEND",
    "dropdeladd": "1955 VT ROUTE 30",
    "dropdelcty": "TOWNSHEND",
    "dropdelst": "VT",
    "dropdelzpp": "053539998",
    "dropphyadd": "1955 VT ROUTE 30",
    "dropphycty": "TOWNSHEND",
    "dropphyst": "VT",
    "dropphyzpp": "053539998",
    "dropmaladd": "1955 VT ROUTE 30",
    "dropmalcty": "TOWNSHEND",
    "dropmalst": "VT",
    "dropmalzpp": "053539998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023651066,
    "dropsitcph": 8023651066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27126",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "6694 VT ROUTE 100",
    "dropdelcty": "TROY",
    "dropdelst": "VT",
    "dropdelzpp": "058689998",
    "dropphyadd": "6694 VT ROUTE 100",
    "dropphycty": "TROY",
    "dropphyst": "VT",
    "dropphyzpp": "058689998",
    "dropmaladd": "6694 VT ROUTE 100",
    "dropmalcty": "TROY",
    "dropmalst": "VT",
    "dropmalzpp": "058689998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027442708,
    "dropsitcph": 8027442708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27128",
    "droptype": "D",
    "dropname": "TUNBRIDGE",
    "dropdeladd": "292 VT ROUTE 110",
    "dropdelcty": "TUNBRIDGE",
    "dropdelst": "VT",
    "dropdelzpp": "050779998",
    "dropphyadd": "292 VT ROUTE 110",
    "dropphycty": "TUNBRIDGE",
    "dropphyst": "VT",
    "dropphyzpp": "050779998",
    "dropmaladd": "292 VT ROUTE 110",
    "dropmalcty": "TUNBRIDGE",
    "dropmalst": "VT",
    "dropmalzpp": "050779998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028893769,
    "dropsitcph": 8028893769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27131",
    "droptype": "D",
    "dropname": "UNDERHILL",
    "dropdeladd": "2 HARVEST RUN",
    "dropdelcty": "UNDERHILL",
    "dropdelst": "VT",
    "dropdelzpp": "054899998",
    "dropphyadd": "2 HARVEST RUN",
    "dropphycty": "UNDERHILL",
    "dropphyst": "VT",
    "dropphyzpp": "054899998",
    "dropmaladd": "2 HARVEST RUN",
    "dropmalcty": "UNDERHILL",
    "dropmalst": "VT",
    "dropmalzpp": "054899998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028994682,
    "dropsitcph": 8028994682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27132",
    "droptype": "D",
    "dropname": "UNDERHILL CENTER",
    "dropdeladd": "286 RIVER RD",
    "dropdelcty": "UNDERHILL CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "054909998",
    "dropphyadd": "286 RIVER RD",
    "dropphycty": "UNDERHILL CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "054909998",
    "dropmaladd": "286 RIVER RD",
    "dropmalcty": "UNDERHILL CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "054909998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028990013,
    "dropsitcph": 8028990013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27142",
    "droptype": "D",
    "dropname": "VERGENNES",
    "dropdeladd": "9 N GREEN ST",
    "dropdelcty": "VERGENNES",
    "dropdelst": "VT",
    "dropdelzpp": "054919998",
    "dropphyadd": "9 N GREEN ST",
    "dropphycty": "VERGENNES",
    "dropphyst": "VT",
    "dropphyzpp": "054919998",
    "dropmaladd": "9 N GREEN ST",
    "dropmalcty": "VERGENNES",
    "dropmalst": "VT",
    "dropmalzpp": "054919998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028772681,
    "dropsitcph": 8028772681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27143",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "2531 FORT BRIDGMAN RD",
    "dropdelcty": "VERNON",
    "dropdelst": "VT",
    "dropdelzpp": "053549998",
    "dropphyadd": "2531 FORT BRIDGMAN RD",
    "dropphycty": "VERNON",
    "dropphyst": "VT",
    "dropphyzpp": "053549998",
    "dropmaladd": "2531 FORT BRIDGMAN RD",
    "dropmalcty": "VERNON",
    "dropmalst": "VT",
    "dropmalzpp": "053549998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022570606,
    "dropsitcph": 8022570606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27144",
    "droptype": "D",
    "dropname": "VERSHIRE",
    "dropdeladd": "6319 VT ROUTE 113",
    "dropdelcty": "VERSHIRE",
    "dropdelst": "VT",
    "dropdelzpp": "050799998",
    "dropphyadd": "6319 VT ROUTE 113",
    "dropphycty": "VERSHIRE",
    "dropphyst": "VT",
    "dropphyzpp": "050799998",
    "dropmaladd": "6319 VT ROUTE 113",
    "dropmalcty": "VERSHIRE",
    "dropmalst": "VT",
    "dropmalzpp": "050799998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026853046,
    "dropsitcph": 8026853046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27170",
    "droptype": "D",
    "dropname": "WAITSFIELD",
    "dropdeladd": "100 MAD RIVER GRN",
    "dropdelcty": "WAITSFIELD",
    "dropdelst": "VT",
    "dropdelzpp": "056739998",
    "dropphyadd": "100 MAD RIVER GRN",
    "dropphycty": "WAITSFIELD",
    "dropphyst": "VT",
    "dropphyzpp": "056739998",
    "dropmaladd": "100 MAD RIVER GRN",
    "dropmalcty": "WAITSFIELD",
    "dropmalst": "VT",
    "dropmalzpp": "056739998",
    "dropsitphn": 8022043369,
    "dropsitlph": 8022043372,
    "dropsitcph": 8022043372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27174",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "137 N MAIN ST UNIT A",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "VT",
    "dropdelzpp": "057739998",
    "dropphyadd": "137 N MAIN ST UNIT A",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "VT",
    "dropphyzpp": "057739998",
    "dropmaladd": "137 N MAIN ST UNIT A",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "VT",
    "dropmalzpp": "057739998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022456281,
    "dropsitcph": 8022456281,
    "dropfax": 8024463483
  },
  {
    "dcode": "D",
    "dropkey": "PV27179",
    "droptype": "D",
    "dropname": "WARDSBORO",
    "dropdeladd": "861 ROUTE 100",
    "dropdelcty": "WARDSBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053559998",
    "dropphyadd": "861 ROUTE 100",
    "dropphycty": "WARDSBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053559998",
    "dropmaladd": "861 ROUTE 100",
    "dropmalcty": "WARDSBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053559998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028966361,
    "dropsitcph": 8028966361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27182",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "354 MAIN ST",
    "dropdelcty": "WARREN",
    "dropdelst": "VT",
    "dropdelzpp": "056749998",
    "dropphyadd": "354 MAIN ST",
    "dropphycty": "WARREN",
    "dropphyst": "VT",
    "dropphyzpp": "056749998",
    "dropmaladd": "354 MAIN ST",
    "dropmalcty": "WARREN",
    "dropmalst": "VT",
    "dropmalzpp": "056749998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022252007,
    "dropsitcph": 8022252007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27186",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "3029 VT ROUTE 110",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "056759998",
    "dropphyadd": "3029 VT ROUTE 110",
    "dropphycty": "WASHINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "056759998",
    "dropmaladd": "3029 VT ROUTE 110",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "056759998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028832221,
    "dropsitcph": 8028832221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27188",
    "droptype": "D",
    "dropname": "WATERBURY",
    "dropdeladd": "47 N MAIN ST STE 2",
    "dropdelcty": "WATERBURY",
    "dropdelst": "VT",
    "dropdelzpp": "056769998",
    "dropphyadd": "47 N MAIN ST STE 2",
    "dropphycty": "WATERBURY",
    "dropphyst": "VT",
    "dropphyzpp": "056769998",
    "dropmaladd": "47 N MAIN ST STE 2",
    "dropmalcty": "WATERBURY",
    "dropmalst": "VT",
    "dropmalzpp": "056769998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022447318,
    "dropsitcph": 8022447318,
    "dropfax": 8022447318
  },
  {
    "dcode": "D",
    "dropkey": "PV27189",
    "droptype": "D",
    "dropname": "WATERBURY CENTER",
    "dropdeladd": "1787 GUPTIL RD",
    "dropdelcty": "WATERBURY CENTER",
    "dropdelst": "VT",
    "dropdelzpp": "056779998",
    "dropphyadd": "1787 GUPTIL RD",
    "dropphycty": "WATERBURY CENTER",
    "dropphyst": "VT",
    "dropphyzpp": "056779998",
    "dropmaladd": "1787 GUPTIL RD",
    "dropmalcty": "WATERBURY CENTER",
    "dropmalst": "VT",
    "dropmalzpp": "056779998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022446381,
    "dropsitcph": 8022446381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27192",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "1211 VT ROUTE 109 FRNT",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "054929998",
    "dropphyadd": "1211 VT ROUTE 109 FRNT",
    "dropphycty": "WATERVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "054929998",
    "dropmaladd": "1211 VT ROUTE 109 FRNT",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "054929998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8779072828,
    "dropsitcph": 8779072828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27198",
    "droptype": "D",
    "dropname": "WEBSTERVILLE",
    "dropdeladd": "37 CHURCH HILL RD",
    "dropdelcty": "WEBSTERVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "056789998",
    "dropphyadd": "37 CHURCH HILL RD",
    "dropphycty": "WEBSTERVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "056789998",
    "dropmaladd": "37 CHURCH HILL RD",
    "dropmalcty": "WEBSTERVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "056789998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024792321,
    "dropsitcph": 8024792321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27201",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "10 NORTH ST UNIT B",
    "dropdelcty": "WELLS",
    "dropdelst": "VT",
    "dropdelzpp": "057749998",
    "dropphyadd": "10 NORTH ST UNIT B",
    "dropphycty": "WELLS",
    "dropphyst": "VT",
    "dropphyzpp": "057749998",
    "dropmaladd": "10 NORTH ST UNIT B",
    "dropmalcty": "WELLS",
    "dropmalst": "VT",
    "dropmalzpp": "057749998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026450822,
    "dropsitcph": 8026450822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27203",
    "droptype": "D",
    "dropname": "WELLS RIVER",
    "dropdeladd": "31 MAIN ST",
    "dropdelcty": "WELLS RIVER",
    "dropdelst": "VT",
    "dropdelzpp": "050819998",
    "dropphyadd": "31 MAIN ST",
    "dropphycty": "WELLS RIVER",
    "dropphyst": "VT",
    "dropphyzpp": "050819998",
    "dropmaladd": "31 MAIN ST",
    "dropmalcty": "WELLS RIVER",
    "dropmalst": "VT",
    "dropmalzpp": "050819998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027572221,
    "dropsitcph": 8027572221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27216",
    "droptype": "D",
    "dropname": "WEST BURKE",
    "dropdeladd": "30 POST OFFICE RD",
    "dropdelcty": "WEST BURKE",
    "dropdelst": "VT",
    "dropdelzpp": "058719998",
    "dropphyadd": "30 POST OFFICE RD",
    "dropphycty": "WEST BURKE",
    "dropphyst": "VT",
    "dropphyzpp": "058719998",
    "dropmaladd": "30 POST OFFICE RD",
    "dropmalcty": "WEST BURKE",
    "dropmalst": "VT",
    "dropmalzpp": "058719998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024673344,
    "dropsitcph": 8024673344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27218",
    "droptype": "D",
    "dropname": "WEST CHARLESTON",
    "dropdeladd": "1165 VT ROUTE 105",
    "dropdelcty": "WEST CHARLESTON",
    "dropdelst": "VT",
    "dropdelzpp": "058729998",
    "dropphyadd": "1165 VT ROUTE 105",
    "dropphycty": "WEST CHARLESTON",
    "dropphyst": "VT",
    "dropphyzpp": "058729998",
    "dropmaladd": "1165 VT ROUTE 105",
    "dropmalcty": "WEST CHARLESTON",
    "dropmalst": "VT",
    "dropmalzpp": "058729998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028952738,
    "dropsitcph": 8028952738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27221",
    "droptype": "D",
    "dropname": "WEST DANVILLE",
    "dropdeladd": "2748 US ROUTE 2 W",
    "dropdelcty": "WEST DANVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "058739998",
    "dropphyadd": "2748 US ROUTE 2 W",
    "dropphycty": "WEST DANVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "058739998",
    "dropmaladd": "2748 US ROUTE 2 W",
    "dropmalcty": "WEST DANVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "058739998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026841158,
    "dropsitcph": 8026841158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27223",
    "droptype": "D",
    "dropname": "WEST DOVER",
    "dropdeladd": "1 MOUNTAIN PARK PLZ UNIT A",
    "dropdelcty": "WEST DOVER",
    "dropdelst": "VT",
    "dropdelzpp": "053569998",
    "dropphyadd": "1 MOUNTAIN PARK PLZ UNIT A",
    "dropphycty": "WEST DOVER",
    "dropphyst": "VT",
    "dropphyzpp": "053569998",
    "dropmaladd": "1 MOUNTAIN PARK PLZ UNIT A",
    "dropmalcty": "WEST DOVER",
    "dropmalst": "VT",
    "dropmalzpp": "053569998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024648677,
    "dropsitcph": 8024648677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27224",
    "droptype": "D",
    "dropname": "WEST DUMMERSTON",
    "dropdeladd": "9 LYONS ST UNIT A",
    "dropdelcty": "WEST DUMMERSTON",
    "dropdelst": "VT",
    "dropdelzpp": "053579998",
    "dropphyadd": "9 LYONS ST UNIT A",
    "dropphycty": "WEST DUMMERSTON",
    "dropphyst": "VT",
    "dropphyzpp": "053579998",
    "dropmaladd": "9 LYONS ST UNIT A",
    "dropmalcty": "WEST DUMMERSTON",
    "dropmalst": "VT",
    "dropmalzpp": "053579998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022577489,
    "dropsitcph": 8022577489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27232",
    "droptype": "D",
    "dropname": "WEST HALIFAX",
    "dropdeladd": "3438 REED HILL RD",
    "dropdelcty": "WEST HALIFAX",
    "dropdelst": "VT",
    "dropdelzpp": "053589998",
    "dropphyadd": "3438 REED HILL RD",
    "dropphycty": "WEST HALIFAX",
    "dropphyst": "VT",
    "dropphyzpp": "053589998",
    "dropmaladd": "3438 REED HILL RD",
    "dropmalcty": "WEST HALIFAX",
    "dropmalst": "VT",
    "dropmalzpp": "053589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023687690,
    "dropsitcph": 8023687690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27240",
    "droptype": "D",
    "dropname": "WEST NEWBURY",
    "dropdeladd": "3060 SNAKE RD",
    "dropdelcty": "WEST NEWBURY",
    "dropdelst": "VT",
    "dropdelzpp": "050859998",
    "dropphyadd": "3060 SNAKE RD",
    "dropphycty": "WEST NEWBURY",
    "dropphyst": "VT",
    "dropphyzpp": "050859998",
    "dropmaladd": "3060 SNAKE RD",
    "dropmalcty": "WEST NEWBURY",
    "dropmalst": "VT",
    "dropmalzpp": "050859998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024292306,
    "dropsitcph": 8024292306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27242",
    "droptype": "D",
    "dropname": "WEST PAWLET",
    "dropdeladd": "2841 VT ROUTE 153",
    "dropdelcty": "WEST PAWLET",
    "dropdelst": "VT",
    "dropdelzpp": "057759998",
    "dropphyadd": "2841 VT ROUTE 153",
    "dropphycty": "WEST PAWLET",
    "dropphyst": "VT",
    "dropphyzpp": "057759998",
    "dropmaladd": "2841 VT ROUTE 153",
    "dropmalcty": "WEST PAWLET",
    "dropmalst": "VT",
    "dropmalzpp": "057759998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026450278,
    "dropsitcph": 8026450278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27243",
    "droptype": "D",
    "dropname": "WEST RUPERT",
    "dropdeladd": "1151 VT ROUTE 153",
    "dropdelcty": "WEST RUPERT",
    "dropdelst": "VT",
    "dropdelzpp": "057769998",
    "dropphyadd": "1151 VT ROUTE 153",
    "dropphycty": "WEST RUPERT",
    "dropphyst": "VT",
    "dropphyzpp": "057769998",
    "dropmaladd": "1151 VT ROUTE 153",
    "dropmalcty": "WEST RUPERT",
    "dropmalst": "VT",
    "dropmalzpp": "057769998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023947874,
    "dropsitcph": 8023947874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27244",
    "droptype": "D",
    "dropname": "WEST RUTLAND",
    "dropdeladd": "66 WESTWAY MALL DR",
    "dropdelcty": "WEST RUTLAND",
    "dropdelst": "VT",
    "dropdelzpp": "057779998",
    "dropphyadd": "66 WESTWAY MALL DR",
    "dropphycty": "WEST RUTLAND",
    "dropphyst": "VT",
    "dropphyzpp": "057779998",
    "dropmaladd": "66 WESTWAY MALL DR",
    "dropmalcty": "WEST RUTLAND",
    "dropmalst": "VT",
    "dropmalzpp": "057779998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024385752,
    "dropsitcph": 8024385752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27249",
    "droptype": "D",
    "dropname": "WEST TOPSHAM",
    "dropdeladd": "7 BATTEN RD",
    "dropdelcty": "WEST TOPSHAM",
    "dropdelst": "VT",
    "dropdelzpp": "050869998",
    "dropphyadd": "7 BATTEN RD",
    "dropphycty": "WEST TOPSHAM",
    "dropphyst": "VT",
    "dropphyzpp": "050869998",
    "dropmaladd": "7 BATTEN RD",
    "dropmalcty": "WEST TOPSHAM",
    "dropmalst": "VT",
    "dropmalzpp": "050869998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022062014,
    "dropsitcph": 8022062014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27251",
    "droptype": "D",
    "dropname": "WEST WARDSBORO",
    "dropdeladd": "4690 ROUTE 100",
    "dropdelcty": "WEST WARDSBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053609998",
    "dropphyadd": "4690 ROUTE 100",
    "dropphycty": "WEST WARDSBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053609998",
    "dropmaladd": "4690 ROUTE 100",
    "dropmalcty": "WEST WARDSBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053609998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028965036,
    "dropsitcph": 8028965036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27258",
    "droptype": "D",
    "dropname": "WESTFORD",
    "dropdeladd": "5 POST RD",
    "dropdelcty": "WESTFORD",
    "dropdelst": "VT",
    "dropdelzpp": "054949998",
    "dropphyadd": "5 POST RD",
    "dropphycty": "WESTFORD",
    "dropphyst": "VT",
    "dropphyzpp": "054949998",
    "dropmaladd": "5 POST RD",
    "dropmalcty": "WESTFORD",
    "dropmalst": "VT",
    "dropmalzpp": "054949998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028796200,
    "dropsitcph": 8028796200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27260",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "3658 US ROUTE 5",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "VT",
    "dropdelzpp": "051589998",
    "dropphyadd": "3658 US ROUTE 5",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "VT",
    "dropphyzpp": "051589998",
    "dropmaladd": "3658 US ROUTE 5",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "VT",
    "dropmalzpp": "051589998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027223941,
    "dropsitcph": 8027223941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27261",
    "droptype": "D",
    "dropname": "WESTMINSTER STATION",
    "dropdeladd": "5187 US ROUTE 5",
    "dropdelcty": "WESTMINSTER STATION",
    "dropdelst": "VT",
    "dropdelzpp": "051599998",
    "dropphyadd": "5187 US ROUTE 5",
    "dropphycty": "WESTMINSTER STATION",
    "dropphyst": "VT",
    "dropphyzpp": "051599998",
    "dropmaladd": "5187 US ROUTE 5",
    "dropmalcty": "WESTMINSTER STATION",
    "dropmalst": "VT",
    "dropmalzpp": "051599998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8027223248,
    "dropsitcph": 8027223248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27265",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "664 MAIN ST",
    "dropdelcty": "WESTON",
    "dropdelst": "VT",
    "dropdelzpp": "051619998",
    "dropphyadd": "664 MAIN ST",
    "dropphycty": "WESTON",
    "dropphyst": "VT",
    "dropphyzpp": "051619998",
    "dropmaladd": "664 MAIN ST",
    "dropmalcty": "WESTON",
    "dropmalst": "VT",
    "dropmalzpp": "051619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028246642,
    "dropsitcph": 8028246642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27271",
    "droptype": "D",
    "dropname": "WHITE RIVER JUNCTION",
    "dropdeladd": "195 SYKES MOUNTAIN AVE",
    "dropdelcty": "WHITE RIVER JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "050019998",
    "dropphyadd": "195 SYKES MOUNTAIN AVE",
    "dropphycty": "WHITE RIVER JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "050019998",
    "dropmaladd": "195 SYKES MOUNTAIN AVE",
    "dropmalcty": "WHITE RIVER JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "050019998",
    "dropsitphn": 8022963237,
    "dropsitlph": 8022963237,
    "dropsitcph": 8022963346,
    "dropfax": 8022963311
  },
  {
    "dcode": "D",
    "dropkey": "PV27274",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "3 S MAIN ST",
    "dropdelcty": "WHITING",
    "dropdelst": "VT",
    "dropdelzpp": "057789998",
    "dropphyadd": "3 S MAIN ST",
    "dropphycty": "WHITING",
    "dropphyst": "VT",
    "dropphyzpp": "057789998",
    "dropmaladd": "3 S MAIN ST",
    "dropmalcty": "WHITING",
    "dropmalst": "VT",
    "dropmalzpp": "057789998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022675067,
    "dropsitcph": 8022675067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27275",
    "droptype": "D",
    "dropname": "WHITINGHAM",
    "dropdeladd": "6677 VT ROUTE 100",
    "dropdelcty": "WHITINGHAM",
    "dropdelst": "VT",
    "dropdelzpp": "053619998",
    "dropphyadd": "6677 VT ROUTE 100",
    "dropphycty": "WHITINGHAM",
    "dropphyst": "VT",
    "dropphyzpp": "053619998",
    "dropmaladd": "6677 VT ROUTE 100",
    "dropmalcty": "WHITINGHAM",
    "dropmalst": "VT",
    "dropmalzpp": "053619998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023687103,
    "dropsitcph": 8023687103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27278",
    "droptype": "D",
    "dropname": "WILDER",
    "dropdeladd": "80 DEPOT ST",
    "dropdelcty": "WILDER",
    "dropdelst": "VT",
    "dropdelzpp": "050889998",
    "dropphyadd": "80 DEPOT ST",
    "dropphycty": "WILDER",
    "dropphyst": "VT",
    "dropphyzpp": "050889998",
    "dropmaladd": "80 DEPOT ST",
    "dropmalcty": "WILDER",
    "dropmalst": "VT",
    "dropmalzpp": "050889998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022952442,
    "dropsitcph": 8022952442,
    "dropfax": 8022953008
  },
  {
    "dcode": "D",
    "dropkey": "PV27279",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "2632 VT ROUTE 14",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "VT",
    "dropdelzpp": "056799998",
    "dropphyadd": "2632 VT ROUTE 14",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "VT",
    "dropphyzpp": "056799998",
    "dropmaladd": "2632 VT ROUTE 14",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "VT",
    "dropmalzpp": "056799998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024336287,
    "dropsitcph": 8024336287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27281",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE",
    "dropdeladd": "67 DOVER RD",
    "dropdelcty": "WILLIAMSVILLE",
    "dropdelst": "VT",
    "dropdelzpp": "053629998",
    "dropphyadd": "67 DOVER RD",
    "dropphycty": "WILLIAMSVILLE",
    "dropphyst": "VT",
    "dropphyzpp": "053629998",
    "dropmaladd": "67 DOVER RD",
    "dropmalcty": "WILLIAMSVILLE",
    "dropmalst": "VT",
    "dropmalzpp": "053629998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023487808,
    "dropsitcph": 8023487808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27284",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "82 BLAIR PARK RD",
    "dropdelcty": "WILLISTON",
    "dropdelst": "VT",
    "dropdelzpp": "054959998",
    "dropphyadd": "82 BLAIR PARK RD",
    "dropphycty": "WILLISTON",
    "dropphyst": "VT",
    "dropphyzpp": "054959998",
    "dropmaladd": "82 BLAIR PARK RD",
    "dropmalcty": "WILLISTON",
    "dropmalst": "VT",
    "dropmalzpp": "054959998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028795257,
    "dropsitcph": 8028795257,
    "dropfax": 8028720954
  },
  {
    "dcode": "D",
    "dropkey": "PV27286",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "39 E MAIN ST",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "053639998",
    "dropphyadd": "39 E MAIN ST",
    "dropphycty": "WILMINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "053639998",
    "dropmaladd": "39 E MAIN ST",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "053639998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024645427,
    "dropsitcph": 8024645427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27288",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "57 MAIN ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "VT",
    "dropdelzpp": "050899998",
    "dropphyadd": "57 MAIN ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "VT",
    "dropphyzpp": "050899998",
    "dropmaladd": "57 MAIN ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "VT",
    "dropmalzpp": "050899998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026745822,
    "dropsitcph": 8026745822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27294",
    "droptype": "D",
    "dropname": "WOLCOTT",
    "dropdeladd": "4154 VT RTE 15",
    "dropdelcty": "WOLCOTT",
    "dropdelst": "VT",
    "dropdelzpp": "056809998",
    "dropphyadd": "4154 VT RTE 15",
    "dropphycty": "WOLCOTT",
    "dropphyst": "VT",
    "dropphyzpp": "056809998",
    "dropmaladd": "4154 VT RTE 15",
    "dropmalcty": "WOLCOTT",
    "dropmalst": "VT",
    "dropmalzpp": "056809998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028885860,
    "dropsitcph": 8028885860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27297",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "3655 ROUTE 14",
    "dropdelcty": "WOODBURY",
    "dropdelst": "VT",
    "dropdelzpp": "056819998",
    "dropphyadd": "3655 ROUTE 14",
    "dropphycty": "WOODBURY",
    "dropphyst": "VT",
    "dropphyzpp": "056819998",
    "dropmaladd": "3655 ROUTE 14",
    "dropmalcty": "WOODBURY",
    "dropmalst": "VT",
    "dropmalzpp": "056819998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024725551,
    "dropsitcph": 8024725551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27303",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "22 CENTRAL ST",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "VT",
    "dropdelzpp": "050919998",
    "dropphyadd": "22 CENTRAL ST",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "VT",
    "dropphyzpp": "050919998",
    "dropmaladd": "22 CENTRAL ST",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "VT",
    "dropmalzpp": "050919998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8024571323,
    "dropsitcph": 8024571323,
    "dropfax": 8024574027
  },
  {
    "dcode": "D",
    "dropkey": "PV27304",
    "droptype": "D",
    "dropname": "WORCESTER",
    "dropdeladd": "36 WORCESTER VILLAGE RD",
    "dropdelcty": "WORCESTER",
    "dropdelst": "VT",
    "dropdelzpp": "056829998",
    "dropphyadd": "36 WORCESTER VILLAGE RD",
    "dropphycty": "WORCESTER",
    "dropphyst": "VT",
    "dropphyzpp": "056829998",
    "dropmaladd": "36 WORCESTER VILLAGE RD",
    "dropmalcty": "WORCESTER",
    "dropmalst": "VT",
    "dropmalzpp": "056829998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022294233,
    "dropsitcph": 8022294233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27476",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "114 HALLSTOWN RD",
    "dropdelcty": "MARYDEL",
    "dropdelst": "DE",
    "dropdelzpp": 19964,
    "dropphyadd": "114 HALLSTOWN RD",
    "dropphycty": "MARYDEL",
    "dropphyst": "DE",
    "dropphyzpp": 19964,
    "dropmaladd": "PO BOX 1",
    "dropmalcty": "MARYDEL",
    "dropmalst": "DE",
    "dropmalzpp": 199640001,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474536,
    "dropsitcph": 4104828081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27587",
    "droptype": "D",
    "dropname": "TEMPLE HILLS",
    "dropdeladd": "4806 SAINT BARNABAS RD",
    "dropdelcty": "TEMPLE HILLS",
    "dropdelst": "MD",
    "dropdelzpp": 207489997,
    "dropphyadd": "4806 SAINT BARNABAS RD",
    "dropphycty": "TEMPLE HILLS",
    "dropphyst": "MD",
    "dropphyzpp": 207489997,
    "dropmaladd": "4806 SAINT BARNABAS RD",
    "dropmalcty": "TEMPLE HILLS",
    "dropmalst": "MD",
    "dropmalzpp": 207489997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014236182,
    "dropsitcph": 3013165783,
    "dropfax": 3017029641
  },
  {
    "dcode": "D",
    "dropkey": "PV27588",
    "droptype": "D",
    "dropname": "CAPITOL HEIGHTS",
    "dropdeladd": "6089 CENTRAL AVE",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207439997,
    "dropphyadd": "6089 CENTRAL AVE",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207439997,
    "dropmaladd": "6089 CENTRAL AVE",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207439997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013506982,
    "dropsitcph": 3013335497,
    "dropfax": 3013503489
  },
  {
    "dcode": "D",
    "dropkey": "PV27589",
    "droptype": "D",
    "dropname": "FORT WASHINGTON",
    "dropdeladd": "11550 LIVINGSTON RD",
    "dropdelcty": "FORT WASHINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 207449998,
    "dropphyadd": "11550 LIVINGSTON RD",
    "dropphycty": "FORT WASHINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 207449998,
    "dropmaladd": "11550 LIVINGSTON RD",
    "dropmalcty": "FORT WASHINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 207449998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012923658,
    "dropsitcph": 3012923658,
    "dropfax": 3012923754
  },
  {
    "dcode": "D",
    "dropkey": "PV27685",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "101 E GROVE ST",
    "dropdelcty": "DELMAR",
    "dropdelst": "DE",
    "dropdelzpp": 199401192,
    "dropphyadd": "101 E GROVE ST",
    "dropphycty": "DELMAR",
    "dropphyst": "DE",
    "dropphyzpp": 199401192,
    "dropmaladd": "101 E GROVE ST",
    "dropmalcty": "DELMAR",
    "dropmalst": "DE",
    "dropmalzpp": 199401192,
    "dropsitphn": 2026364480,
    "dropsitlph": 3028463170,
    "dropsitcph": 3028463170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PV27697",
    "droptype": "D",
    "dropname": "BOYLSTON",
    "dropdeladd": "67 SHREWSBURY ST",
    "dropdelcty": "BOYLSTON",
    "dropdelst": "MA",
    "dropdelzpp": "015059998",
    "dropphyadd": "67 SHREWSBURY ST",
    "dropphycty": "BOYLSTON",
    "dropphyst": "MA",
    "dropphyzpp": "015059998",
    "dropmaladd": "67 SHREWSBURY ST",
    "dropmalcty": "BOYLSTON",
    "dropmalst": "MA",
    "dropmalzpp": "015059998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5088696392,
    "dropfax": 5088696163
  },
  {
    "dcode": "D",
    "dropkey": "PW1A004",
    "droptype": "D",
    "dropname": "MEAD",
    "dropdeladd": "320 S VINE ST",
    "dropdelcty": "MEAD",
    "dropdelst": "NE",
    "dropdelzpp": 680413029,
    "dropphyadd": "320 S VINE ST",
    "dropphycty": "MEAD",
    "dropphyst": "NE",
    "dropphyzpp": 680413029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEAD",
    "dropmalst": "NE",
    "dropmalzpp": 680419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026243035,
    "dropsitcph": 4026243035,
    "dropfax": 4026243035
  },
  {
    "dcode": "D",
    "dropkey": "PW1A005",
    "droptype": "D",
    "dropname": "MEADOW GROVE",
    "dropdeladd": "214 MAIN ST",
    "dropdelcty": "MEADOW GROVE",
    "dropdelst": "NE",
    "dropdelzpp": 687524131,
    "dropphyadd": "214 MAIN ST",
    "dropphycty": "MEADOW GROVE",
    "dropphyst": "NE",
    "dropphyzpp": 687524131,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEADOW GROVE",
    "dropmalst": "NE",
    "dropmalzpp": 687529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026342900,
    "dropsitcph": 4026342900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A007",
    "droptype": "D",
    "dropname": "MELBETA",
    "dropdeladd": "101 2ND ST",
    "dropdelcty": "MELBETA",
    "dropdelst": "NE",
    "dropdelzpp": 693559700,
    "dropphyadd": "101 2ND ST",
    "dropphycty": "MELBETA",
    "dropphyst": "NE",
    "dropphyzpp": 693559700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELBETA",
    "dropmalst": "NE",
    "dropmalzpp": 693559998,
    "dropsitphn": 3087831844,
    "dropsitlph": 3087831844,
    "dropsitcph": 3087831844,
    "dropfax": 3087831844
  },
  {
    "dcode": "D",
    "dropkey": "PW1A009",
    "droptype": "D",
    "dropname": "MERNA",
    "dropdeladd": "100 CENTER AVE",
    "dropdelcty": "MERNA",
    "dropdelst": "NE",
    "dropdelzpp": 688569783,
    "dropphyadd": "100 CENTER AVE",
    "dropphycty": "MERNA",
    "dropphyst": "NE",
    "dropphyzpp": 688569783,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERNA",
    "dropmalst": "NE",
    "dropmalzpp": 688569998,
    "dropsitphn": 3086432219,
    "dropsitlph": 3086432219,
    "dropsitcph": 3086432219,
    "dropfax": 3086432219
  },
  {
    "dcode": "D",
    "dropkey": "PW1A010",
    "droptype": "D",
    "dropname": "MERRIMAN",
    "dropdeladd": "110 N MILLS ST",
    "dropdelcty": "MERRIMAN",
    "dropdelst": "NE",
    "dropdelzpp": 692189727,
    "dropphyadd": "110 N MILLS ST",
    "dropphycty": "MERRIMAN",
    "dropphyst": "NE",
    "dropphyzpp": 692189727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRIMAN",
    "dropmalst": "NE",
    "dropmalzpp": 692189998,
    "dropsitphn": 3086843381,
    "dropsitlph": 3086843381,
    "dropsitcph": 3086843381,
    "dropfax": 3086843381
  },
  {
    "dcode": "D",
    "dropkey": "PW1A014",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "602 1ST ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "NE",
    "dropdelzpp": 684059611,
    "dropphyadd": "602 1ST ST",
    "dropphycty": "MILFORD",
    "dropphyst": "NE",
    "dropphyzpp": 684059611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILFORD",
    "dropmalst": "NE",
    "dropmalzpp": 684059998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027613121,
    "dropsitcph": 4027613121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A016",
    "droptype": "D",
    "dropname": "MILLER",
    "dropdeladd": "301 W CUMMINGS AVE",
    "dropdelcty": "MILLER",
    "dropdelst": "NE",
    "dropdelzpp": 688582065,
    "dropphyadd": "301 W CUMMINGS AVE",
    "dropphycty": "MILLER",
    "dropphyst": "NE",
    "dropphyzpp": 688582065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLER",
    "dropmalst": "NE",
    "dropmalzpp": 688589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3084573055,
    "dropsitcph": 3084573055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A017",
    "droptype": "D",
    "dropname": "MILLIGAN",
    "dropdeladd": "616 MAIN ST",
    "dropdelcty": "MILLIGAN",
    "dropdelst": "NE",
    "dropdelzpp": 684069700,
    "dropphyadd": "616 MAIN ST",
    "dropphycty": "MILLIGAN",
    "dropphyst": "NE",
    "dropphyzpp": 684069700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLIGAN",
    "dropmalst": "NE",
    "dropmalzpp": 684069998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026294340,
    "dropsitcph": 4026294340,
    "dropfax": 4026294340
  },
  {
    "dcode": "D",
    "dropkey": "PW1A020",
    "droptype": "D",
    "dropname": "MINATARE",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "MINATARE",
    "dropdelst": "NE",
    "dropdelzpp": 693569701,
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "MINATARE",
    "dropphyst": "NE",
    "dropphyzpp": 693569701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINATARE",
    "dropmalst": "NE",
    "dropmalzpp": 693569998,
    "dropsitphn": 3087831822,
    "dropsitlph": 3087831822,
    "dropsitcph": 3087831822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A021",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "410 N MINDEN AVE",
    "dropdelcty": "MINDEN",
    "dropdelst": "NE",
    "dropdelzpp": 689599998,
    "dropphyadd": "410 N MINDEN AVE",
    "dropphycty": "MINDEN",
    "dropphyst": "NE",
    "dropphyzpp": 689599998,
    "dropmaladd": "410 N MINDEN AVE",
    "dropmalcty": "MINDEN",
    "dropmalst": "NE",
    "dropmalzpp": 689599998,
    "dropsitphn": 3088321350,
    "dropsitlph": 3088321350,
    "dropsitcph": 3088321350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A023",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "1441 CENTER AVE",
    "dropdelcty": "MITCHELL",
    "dropdelst": "NE",
    "dropdelzpp": 693579998,
    "dropphyadd": "1441 CENTER AVE",
    "dropphycty": "MITCHELL",
    "dropphyst": "NE",
    "dropphyzpp": 693579998,
    "dropmaladd": "1441 CENTER AVE",
    "dropmalcty": "MITCHELL",
    "dropmalst": "NE",
    "dropmalzpp": 693579998,
    "dropsitphn": 3086232700,
    "dropsitlph": 3086232700,
    "dropsitcph": 3086232700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A024",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "406 GERRARD AVE",
    "dropdelcty": "MONROE",
    "dropdelst": "NE",
    "dropdelzpp": 686474035,
    "dropphyadd": "406 GERRARD AVE",
    "dropphycty": "MONROE",
    "dropphyst": "NE",
    "dropphyzpp": 686474035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONROE",
    "dropmalst": "NE",
    "dropmalzpp": 686479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024954515,
    "dropsitcph": 4024954515,
    "dropfax": 4024954515
  },
  {
    "dcode": "D",
    "dropkey": "PW1A025",
    "droptype": "D",
    "dropname": "MOOREFIELD",
    "dropdeladd": "100 N ASH ST",
    "dropdelcty": "MOOREFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 690399727,
    "dropphyadd": "100 N ASH ST",
    "dropphycty": "MOOREFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 690399727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOOREFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 690399998,
    "dropsitphn": 3083674278,
    "dropsitlph": 3083674278,
    "dropsitcph": 3083674278,
    "dropfax": 3083674278
  },
  {
    "dcode": "D",
    "dropkey": "PW1A026",
    "droptype": "D",
    "dropname": "MORRILL",
    "dropdeladd": "125 CENTER AVE",
    "dropdelcty": "MORRILL",
    "dropdelst": "NE",
    "dropdelzpp": 693583019,
    "dropphyadd": "125 CENTER AVE",
    "dropphycty": "MORRILL",
    "dropphyst": "NE",
    "dropphyzpp": 693583019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRILL",
    "dropmalst": "NE",
    "dropmalzpp": 693589998,
    "dropsitphn": 3082472095,
    "dropsitlph": 3082472095,
    "dropsitcph": 3082472095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A027",
    "droptype": "D",
    "dropname": "MORSE BLUFF",
    "dropdeladd": "251 2ND ST",
    "dropdelcty": "MORSE BLUFF",
    "dropdelst": "NE",
    "dropdelzpp": 686484893,
    "dropphyadd": "251 2ND ST",
    "dropphycty": "MORSE BLUFF",
    "dropphyst": "NE",
    "dropphyzpp": 686484893,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORSE BLUFF",
    "dropmalst": "NE",
    "dropmalzpp": 686489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026669270,
    "dropsitcph": 4026669270,
    "dropfax": 4026669270
  },
  {
    "dcode": "D",
    "dropkey": "PW1A031",
    "droptype": "D",
    "dropname": "MULLEN",
    "dropdeladd": "106 NE 1ST ST",
    "dropdelcty": "MULLEN",
    "dropdelst": "NE",
    "dropdelzpp": 691529709,
    "dropphyadd": "106 NE 1ST ST",
    "dropphycty": "MULLEN",
    "dropphyst": "NE",
    "dropphyzpp": 691529709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MULLEN",
    "dropmalst": "NE",
    "dropmalzpp": 691529998,
    "dropsitphn": 3085462219,
    "dropsitlph": 4025207264,
    "dropsitcph": 4025207264,
    "dropfax": 3085462219
  },
  {
    "dcode": "D",
    "dropkey": "PW1A032",
    "droptype": "D",
    "dropname": "MURDOCK",
    "dropdeladd": "304 NEBRASKA ST",
    "dropdelcty": "MURDOCK",
    "dropdelst": "NE",
    "dropdelzpp": 684075026,
    "dropphyadd": "304 NEBRASKA ST",
    "dropphycty": "MURDOCK",
    "dropphyst": "NE",
    "dropphyzpp": 684075026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURDOCK",
    "dropmalst": "NE",
    "dropmalzpp": 684079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028673441,
    "dropsitcph": 4028673441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A034",
    "droptype": "D",
    "dropname": "MURRAY",
    "dropdeladd": "105 N LATTA AVE",
    "dropdelcty": "MURRAY",
    "dropdelst": "NE",
    "dropdelzpp": 684098511,
    "dropphyadd": "105 N LATTA AVE",
    "dropphycty": "MURRAY",
    "dropphyst": "NE",
    "dropphyzpp": 684098511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURRAY",
    "dropmalst": "NE",
    "dropmalzpp": 684099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022352166,
    "dropsitcph": 4022352166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A038",
    "droptype": "D",
    "dropname": "NAPER",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "NAPER",
    "dropdelst": "NE",
    "dropdelzpp": 687558000,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "NAPER",
    "dropphyst": "NE",
    "dropphyzpp": 687558000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAPER",
    "dropmalst": "NE",
    "dropmalzpp": 687559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028325977,
    "dropsitcph": 4028325977,
    "dropfax": 4028325977
  },
  {
    "dcode": "D",
    "dropkey": "PW1A042",
    "droptype": "D",
    "dropname": "NEBRASKA CITY",
    "dropdeladd": "508 CENTRAL AVE",
    "dropdelcty": "NEBRASKA CITY",
    "dropdelst": "NE",
    "dropdelzpp": 684102416,
    "dropphyadd": "508 CENTRAL AVE",
    "dropphycty": "NEBRASKA CITY",
    "dropphyst": "NE",
    "dropphyzpp": 684102416,
    "dropmaladd": "508 CENTRAL AVE",
    "dropmalcty": "NEBRASKA CITY",
    "dropmalst": "NE",
    "dropmalzpp": 684102416,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028735045,
    "dropsitcph": 4028735045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A045",
    "droptype": "D",
    "dropname": "NEHAWKA",
    "dropdeladd": "418 ELM ST",
    "dropdelcty": "NEHAWKA",
    "dropdelst": "NE",
    "dropdelzpp": 684139800,
    "dropphyadd": "418 ELM ST",
    "dropphycty": "NEHAWKA",
    "dropphyst": "NE",
    "dropphyzpp": 684139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEHAWKA",
    "dropmalst": "NE",
    "dropmalzpp": 684139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022273515,
    "dropsitcph": 4022273515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A046",
    "droptype": "D",
    "dropname": "NELIGH",
    "dropdeladd": "116 W 3RD ST",
    "dropdelcty": "NELIGH",
    "dropdelst": "NE",
    "dropdelzpp": 687569998,
    "dropphyadd": "116 W 3RD ST",
    "dropphycty": "NELIGH",
    "dropphyst": "NE",
    "dropphyzpp": 687569998,
    "dropmaladd": "116 W 3RD ST",
    "dropmalcty": "NELIGH",
    "dropmalst": "NE",
    "dropmalzpp": 687569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028874703,
    "dropsitcph": 4028874703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A047",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "363 S MAIN ST",
    "dropdelcty": "NELSON",
    "dropdelst": "NE",
    "dropdelzpp": 689616127,
    "dropphyadd": "363 S MAIN ST",
    "dropphycty": "NELSON",
    "dropphyst": "NE",
    "dropphyzpp": 689616127,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELSON",
    "dropmalst": "NE",
    "dropmalzpp": 689619998,
    "dropsitphn": 4022255361,
    "dropsitlph": 4022255361,
    "dropsitcph": 4022255361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A049",
    "droptype": "D",
    "dropname": "NEMAHA",
    "dropdeladd": "504 1ST ST",
    "dropdelcty": "NEMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 684146055,
    "dropphyadd": "504 1ST ST",
    "dropphycty": "NEMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 684146055,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 684149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028245475,
    "dropsitcph": 4028245475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A054",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "NE",
    "dropdelzpp": 687576006,
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "NE",
    "dropphyzpp": 687576006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "NE",
    "dropmalzpp": 687579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023552308,
    "dropsitcph": 4023552308,
    "dropfax": 4023552308
  },
  {
    "dcode": "D",
    "dropkey": "PW1A055",
    "droptype": "D",
    "dropname": "NEWMAN GROVE",
    "dropdeladd": "602 HALE AVE",
    "dropdelcty": "NEWMAN GROVE",
    "dropdelst": "NE",
    "dropdelzpp": 687589734,
    "dropphyadd": "602 HALE AVE",
    "dropphycty": "NEWMAN GROVE",
    "dropphyst": "NE",
    "dropphyzpp": 687589734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWMAN GROVE",
    "dropmalst": "NE",
    "dropmalzpp": 687589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024476111,
    "dropsitcph": 4024476111,
    "dropfax": 4024476111
  },
  {
    "dcode": "D",
    "dropkey": "PW1A058",
    "droptype": "D",
    "dropname": "NICKERSON",
    "dropdeladd": "209 E CEDAR ST",
    "dropdelcty": "NICKERSON",
    "dropdelst": "NE",
    "dropdelzpp": 680449712,
    "dropphyadd": "209 E CEDAR ST",
    "dropphycty": "NICKERSON",
    "dropphyst": "NE",
    "dropphyzpp": 680449712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NICKERSON",
    "dropmalst": "NE",
    "dropmalzpp": 680449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027212154,
    "dropsitcph": 4027212154,
    "dropfax": 4027212154
  },
  {
    "dcode": "D",
    "dropkey": "PW1A059",
    "droptype": "D",
    "dropname": "NIOBRARA",
    "dropdeladd": "25410 PARK AVE APT F",
    "dropdelcty": "NIOBRARA",
    "dropdelst": "NE",
    "dropdelzpp": 687607044,
    "dropphyadd": "25410 PARK AVE APT F",
    "dropphycty": "NIOBRARA",
    "dropphyst": "NE",
    "dropphyzpp": 687607044,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIOBRARA",
    "dropmalst": "NE",
    "dropmalzpp": 687609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028573577,
    "dropsitcph": 4028573577,
    "dropfax": 4028573577
  },
  {
    "dcode": "D",
    "dropkey": "PW1A065",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "1100 S PINE INDUSTRIAL RD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "NE",
    "dropdelzpp": 687019998,
    "dropphyadd": "1100 S PINE INDUSTRIAL RD",
    "dropphycty": "NORFOLK",
    "dropphyst": "NE",
    "dropphyzpp": 687019998,
    "dropmaladd": "1100 S PINE INDUSTRIAL RD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "NE",
    "dropmalzpp": 687019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026444134,
    "dropsitcph": 4026444134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A068",
    "droptype": "D",
    "dropname": "NORTH BEND",
    "dropdeladd": "134 W 7TH ST",
    "dropdelcty": "NORTH BEND",
    "dropdelst": "NE",
    "dropdelzpp": 686494401,
    "dropphyadd": "134 W 7TH ST",
    "dropphycty": "NORTH BEND",
    "dropphyst": "NE",
    "dropphyzpp": 686494401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BEND",
    "dropmalst": "NE",
    "dropmalzpp": 686499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026523413,
    "dropsitcph": 4026523413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A070",
    "droptype": "D",
    "dropname": "NORTH LOUP",
    "dropdeladd": "211 W 1ST ST",
    "dropdelcty": "NORTH LOUP",
    "dropdelst": "NE",
    "dropdelzpp": 688595010,
    "dropphyadd": "211 W 1ST ST",
    "dropphycty": "NORTH LOUP",
    "dropphyst": "NE",
    "dropphyzpp": 688595010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LOUP",
    "dropmalst": "NE",
    "dropmalzpp": 688599998,
    "dropsitphn": 3084964375,
    "dropsitlph": 3084964375,
    "dropsitcph": 3084964375,
    "dropfax": 3084964375
  },
  {
    "dcode": "D",
    "dropkey": "PW1A072",
    "droptype": "D",
    "dropname": "NORTH PLATTE",
    "dropdeladd": "1302 INDUSTRIAL AVE",
    "dropdelcty": "NORTH PLATTE",
    "dropdelst": "NE",
    "dropdelzpp": 691019998,
    "dropphyadd": "1302 INDUSTRIAL AVE",
    "dropphycty": "NORTH PLATTE",
    "dropphyst": "NE",
    "dropphyzpp": 691019998,
    "dropmaladd": "1302 INDUSTRIAL AVE",
    "dropmalcty": "NORTH PLATTE",
    "dropmalst": "NE",
    "dropmalzpp": 691019998,
    "dropsitphn": 3085323144,
    "dropsitlph": 3085323144,
    "dropsitcph": 3085323144,
    "dropfax": 3085328243
  },
  {
    "dcode": "D",
    "dropkey": "PW1A080",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "500 HOHMAN ST",
    "dropdelcty": "OAKDALE",
    "dropdelst": "NE",
    "dropdelzpp": 687619761,
    "dropphyadd": "500 HOHMAN ST",
    "dropphycty": "OAKDALE",
    "dropphyst": "NE",
    "dropphyzpp": 687619761,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKDALE",
    "dropmalst": "NE",
    "dropmalzpp": 687619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027762514,
    "dropsitcph": 4027762514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A081",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "313 N OAKLAND AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "NE",
    "dropdelzpp": 680459998,
    "dropphyadd": "313 N OAKLAND AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "NE",
    "dropphyzpp": 680459998,
    "dropmaladd": "313 N OAKLAND AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "NE",
    "dropmalzpp": 680459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026855945,
    "dropsitcph": 4026855945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A083",
    "droptype": "D",
    "dropname": "OCONTO",
    "dropdeladd": "103 GRAND",
    "dropdelcty": "OCONTO",
    "dropdelst": "NE",
    "dropdelzpp": 688609756,
    "dropphyadd": "103 GRAND",
    "dropphycty": "OCONTO",
    "dropphyst": "NE",
    "dropphyzpp": 688609756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCONTO",
    "dropmalst": "NE",
    "dropmalzpp": 688609998,
    "dropsitphn": 3088584448,
    "dropsitlph": 3088584448,
    "dropsitcph": 3088584448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A085",
    "droptype": "D",
    "dropname": "ODELL",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "ODELL",
    "dropdelst": "NE",
    "dropdelzpp": 684159800,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "ODELL",
    "dropphyst": "NE",
    "dropphyzpp": 684159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODELL",
    "dropmalst": "NE",
    "dropmalzpp": 684159998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027663855,
    "dropsitcph": 4027663855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A090",
    "droptype": "D",
    "dropname": "OGALLALA",
    "dropdeladd": "301 N SPRUCE ST",
    "dropdelcty": "OGALLALA",
    "dropdelst": "NE",
    "dropdelzpp": 691539998,
    "dropphyadd": "301 N SPRUCE ST",
    "dropphycty": "OGALLALA",
    "dropphyst": "NE",
    "dropphyzpp": 691539998,
    "dropmaladd": "301 N SPRUCE ST",
    "dropmalcty": "OGALLALA",
    "dropmalst": "NE",
    "dropmalzpp": 691539998,
    "dropsitphn": 3082843251,
    "dropsitlph": 3082843251,
    "dropsitcph": 3082843251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A091",
    "droptype": "D",
    "dropname": "OHIOWA",
    "dropdeladd": "602 S MAIN ST",
    "dropdelcty": "OHIOWA",
    "dropdelst": "NE",
    "dropdelzpp": 684169700,
    "dropphyadd": "602 S MAIN ST",
    "dropphycty": "OHIOWA",
    "dropphyst": "NE",
    "dropphyzpp": 684169700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OHIOWA",
    "dropmalst": "NE",
    "dropmalzpp": 684169998,
    "dropsitphn": 4027593317,
    "dropsitlph": 4022952222,
    "dropsitcph": 4022952222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A093",
    "droptype": "D",
    "dropname": "OMAHA",
    "dropdeladd": "1124 PACIFIC ST RM 222",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681089998,
    "dropphyadd": "1124 PACIFIC ST RM 222",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681089998,
    "dropmaladd": "1124 PACIFIC ST RM 222",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023482696,
    "dropsitcph": 4023482696,
    "dropfax": 4023482403
  },
  {
    "dcode": "D",
    "dropkey": "PW1A097",
    "droptype": "D",
    "dropname": "ONEILL",
    "dropdeladd": "201 N 4TH ST",
    "dropdelcty": "ONEILL",
    "dropdelst": "NE",
    "dropdelzpp": 687631517,
    "dropphyadd": "201 N 4TH ST",
    "dropphycty": "ONEILL",
    "dropphyst": "NE",
    "dropphyzpp": 687631517,
    "dropmaladd": "201 N 4TH ST",
    "dropmalcty": "ONEILL",
    "dropmalst": "NE",
    "dropmalzpp": 687631517,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023362530,
    "dropsitcph": 4023362530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A099",
    "droptype": "D",
    "dropname": "ORCHARD",
    "dropdeladd": "141 E 2ND ST",
    "dropdelcty": "ORCHARD",
    "dropdelst": "NE",
    "dropdelzpp": 687646302,
    "dropphyadd": "141 E 2ND ST",
    "dropphycty": "ORCHARD",
    "dropphyst": "NE",
    "dropphyzpp": 687646302,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCHARD",
    "dropmalst": "NE",
    "dropmalzpp": 687649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028935705,
    "dropsitcph": 4028935705,
    "dropfax": 4028935705
  },
  {
    "dcode": "D",
    "dropkey": "PW1A100",
    "droptype": "D",
    "dropname": "ORD",
    "dropdeladd": "1630 L ST",
    "dropdelcty": "ORD",
    "dropdelst": "NE",
    "dropdelzpp": 688629998,
    "dropphyadd": "1630 L ST",
    "dropphycty": "ORD",
    "dropphyst": "NE",
    "dropphyzpp": 688629998,
    "dropmaladd": "1630 L ST",
    "dropmalcty": "ORD",
    "dropmalst": "NE",
    "dropmalzpp": 688629998,
    "dropsitphn": 3087285721,
    "dropsitlph": 3087285721,
    "dropsitcph": 3087285721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A101",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "109 E MAPLE ST",
    "dropdelcty": "ORLEANS",
    "dropdelst": "NE",
    "dropdelzpp": 689669700,
    "dropphyadd": "109 E MAPLE ST",
    "dropphycty": "ORLEANS",
    "dropphyst": "NE",
    "dropphyzpp": 689669700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORLEANS",
    "dropmalst": "NE",
    "dropmalzpp": 689669998,
    "dropsitphn": 3084734421,
    "dropsitlph": 3084734421,
    "dropsitcph": 3084734421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A102",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "241 N MAIN ST",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "NE",
    "dropdelzpp": 686515512,
    "dropphyadd": "241 N MAIN ST",
    "dropphycty": "OSCEOLA",
    "dropphyst": "NE",
    "dropphyzpp": 686515512,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "NE",
    "dropmalzpp": 686519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027474751,
    "dropsitcph": 4027474751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A103",
    "droptype": "D",
    "dropname": "OSHKOSH",
    "dropdeladd": "201 W 1ST ST",
    "dropdelcty": "OSHKOSH",
    "dropdelst": "NE",
    "dropdelzpp": 691549900,
    "dropphyadd": "201 W 1ST ST",
    "dropphycty": "OSHKOSH",
    "dropphyst": "NE",
    "dropphyzpp": 691549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSHKOSH",
    "dropmalst": "NE",
    "dropmalzpp": 691549998,
    "dropsitphn": 3087723551,
    "dropsitlph": 3087723551,
    "dropsitcph": 3087723551,
    "dropfax": 3087724586
  },
  {
    "dcode": "D",
    "dropkey": "PW1A104",
    "droptype": "D",
    "dropname": "OSMOND",
    "dropdeladd": "209 N STATE ST",
    "dropdelcty": "OSMOND",
    "dropdelst": "NE",
    "dropdelzpp": 687655724,
    "dropphyadd": "209 N STATE ST",
    "dropphycty": "OSMOND",
    "dropphyst": "NE",
    "dropphyzpp": 687655724,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSMOND",
    "dropmalst": "NE",
    "dropmalzpp": 687659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027483804,
    "dropsitcph": 4027483804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A105",
    "droptype": "D",
    "dropname": "OTOE",
    "dropdeladd": "422 MAIN ST",
    "dropdelcty": "OTOE",
    "dropdelst": "NE",
    "dropdelzpp": 684179738,
    "dropphyadd": "422 MAIN ST",
    "dropphycty": "OTOE",
    "dropphyst": "NE",
    "dropphyzpp": 684179738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTOE",
    "dropmalst": "NE",
    "dropmalzpp": 684179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022652151,
    "dropsitcph": 4022652151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A106",
    "droptype": "D",
    "dropname": "OVERTON",
    "dropdeladd": "519 C ST",
    "dropdelcty": "OVERTON",
    "dropdelst": "NE",
    "dropdelzpp": 688635351,
    "dropphyadd": "519 C ST",
    "dropphycty": "OVERTON",
    "dropphyst": "NE",
    "dropphyzpp": 688635351,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OVERTON",
    "dropmalst": "NE",
    "dropmalzpp": 688639998,
    "dropsitphn": 3089872560,
    "dropsitlph": 3089872560,
    "dropsitcph": 3089872560,
    "dropfax": 3089872560
  },
  {
    "dcode": "D",
    "dropkey": "PW1A107",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "112 E SOUTH RAILWAY",
    "dropdelcty": "OXFORD",
    "dropdelst": "NE",
    "dropdelzpp": 689679749,
    "dropphyadd": "112 E SOUTH RAILWAY",
    "dropphycty": "OXFORD",
    "dropphyst": "NE",
    "dropphyzpp": 689679749,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OXFORD",
    "dropmalst": "NE",
    "dropmalzpp": 689679998,
    "dropsitphn": 3088243471,
    "dropsitlph": 3088243471,
    "dropsitcph": 3088243471,
    "dropfax": 3088243471
  },
  {
    "dcode": "D",
    "dropkey": "PW1A108",
    "droptype": "D",
    "dropname": "PAGE",
    "dropdeladd": "107 N 5TH ST",
    "dropdelcty": "PAGE",
    "dropdelst": "NE",
    "dropdelzpp": 687665018,
    "dropphyadd": "107 N 5TH ST",
    "dropphycty": "PAGE",
    "dropphyst": "NE",
    "dropphyzpp": 687665018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAGE",
    "dropmalst": "NE",
    "dropmalzpp": 687669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023385959,
    "dropsitcph": 4023385959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A109",
    "droptype": "D",
    "dropname": "PALISADE",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "PALISADE",
    "dropdelst": "NE",
    "dropdelzpp": 690409746,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "PALISADE",
    "dropphyst": "NE",
    "dropphyzpp": 690409746,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALISADE",
    "dropmalst": "NE",
    "dropmalzpp": 690409998,
    "dropsitphn": 3082853221,
    "dropsitlph": 3082853221,
    "dropsitcph": 3082853221,
    "dropfax": 3082853221
  },
  {
    "dcode": "D",
    "dropkey": "PW1A110",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "907 COMMERCIAL ST",
    "dropdelcty": "PALMER",
    "dropdelst": "NE",
    "dropdelzpp": 688642421,
    "dropphyadd": "907 COMMERCIAL ST",
    "dropphycty": "PALMER",
    "dropphyst": "NE",
    "dropphyzpp": 688642421,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMER",
    "dropmalst": "NE",
    "dropmalzpp": 688649998,
    "dropsitphn": 3088943804,
    "dropsitlph": 3088943804,
    "dropsitcph": 3088943804,
    "dropfax": 3088943804
  },
  {
    "dcode": "D",
    "dropkey": "PW1A111",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "320 C ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "NE",
    "dropdelzpp": 684184134,
    "dropphyadd": "320 C ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "NE",
    "dropphyzpp": 684184134,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMYRA",
    "dropmalst": "NE",
    "dropmalzpp": 684189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027805757,
    "dropsitcph": 4027805757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A112",
    "droptype": "D",
    "dropname": "PANAMA",
    "dropdeladd": "302 LOCUST ST",
    "dropdelcty": "PANAMA",
    "dropdelst": "NE",
    "dropdelzpp": 684199700,
    "dropphyadd": "302 LOCUST ST",
    "dropphycty": "PANAMA",
    "dropphyst": "NE",
    "dropphyzpp": 684199700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANAMA",
    "dropmalst": "NE",
    "dropmalzpp": 684199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027882252,
    "dropsitcph": 4027882252,
    "dropfax": 4027882252
  },
  {
    "dcode": "D",
    "dropkey": "PW1A118",
    "droptype": "D",
    "dropname": "PAWNEE CITY",
    "dropdeladd": "715 G ST",
    "dropdelcty": "PAWNEE CITY",
    "dropdelst": "NE",
    "dropdelzpp": 684209800,
    "dropphyadd": "715 G ST",
    "dropphycty": "PAWNEE CITY",
    "dropphyst": "NE",
    "dropphyzpp": 684209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAWNEE CITY",
    "dropmalst": "NE",
    "dropmalzpp": 684209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028522097,
    "dropsitcph": 4028522097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A121",
    "droptype": "D",
    "dropname": "PAXTON",
    "dropdeladd": "107 N OAK ST",
    "dropdelcty": "PAXTON",
    "dropdelst": "NE",
    "dropdelzpp": 691551343,
    "dropphyadd": "107 N OAK ST",
    "dropphycty": "PAXTON",
    "dropphyst": "NE",
    "dropphyzpp": 691551343,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAXTON",
    "dropmalst": "NE",
    "dropmalzpp": 691559998,
    "dropsitphn": 3082394515,
    "dropsitlph": 3082394515,
    "dropsitcph": 3082394515,
    "dropfax": 3082394515
  },
  {
    "dcode": "D",
    "dropkey": "PW1A122",
    "droptype": "D",
    "dropname": "PENDER",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "PENDER",
    "dropdelst": "NE",
    "dropdelzpp": 680475051,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "PENDER",
    "dropphyst": "NE",
    "dropphyzpp": 680475051,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENDER",
    "dropmalst": "NE",
    "dropmalzpp": 680479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023852465,
    "dropsitcph": 4023852465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A124",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "609 5TH ST",
    "dropdelcty": "PERU",
    "dropdelst": "NE",
    "dropdelzpp": 684213056,
    "dropphyadd": "609 5TH ST",
    "dropphycty": "PERU",
    "dropphyst": "NE",
    "dropphyzpp": 684213056,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERU",
    "dropmalst": "NE",
    "dropmalzpp": 684219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028724585,
    "dropsitcph": 4028724585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A125",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "NE",
    "dropdelzpp": 686525636,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "NE",
    "dropphyzpp": 686525636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "NE",
    "dropmalzpp": 686529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023865210,
    "dropsitcph": 4023865210,
    "dropfax": 4023865210
  },
  {
    "dcode": "D",
    "dropkey": "PW1A126",
    "droptype": "D",
    "dropname": "PHILLIPS",
    "dropdeladd": "515 WEST ST",
    "dropdelcty": "PHILLIPS",
    "dropdelst": "NE",
    "dropdelzpp": 688659701,
    "dropphyadd": "515 WEST ST",
    "dropphycty": "PHILLIPS",
    "dropphyst": "NE",
    "dropphyzpp": 688659701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHILLIPS",
    "dropmalst": "NE",
    "dropmalzpp": 688659998,
    "dropsitphn": 4028862318,
    "dropsitlph": 4028862318,
    "dropsitcph": 4028862318,
    "dropfax": 4028862318
  },
  {
    "dcode": "D",
    "dropkey": "PW1A127",
    "droptype": "D",
    "dropname": "PICKRELL",
    "dropdeladd": "222 AUSTIN ST",
    "dropdelcty": "PICKRELL",
    "dropdelst": "NE",
    "dropdelzpp": 684223000,
    "dropphyadd": "222 AUSTIN ST",
    "dropphycty": "PICKRELL",
    "dropphyst": "NE",
    "dropphyzpp": 684223000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PICKRELL",
    "dropmalst": "NE",
    "dropmalzpp": 684229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026733165,
    "dropsitcph": 4026733165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A128",
    "droptype": "D",
    "dropname": "PIERCE",
    "dropdeladd": "122 N LUCAS ST",
    "dropdelcty": "PIERCE",
    "dropdelst": "NE",
    "dropdelzpp": 687679998,
    "dropphyadd": "122 N LUCAS ST",
    "dropphycty": "PIERCE",
    "dropphyst": "NE",
    "dropphyzpp": 687679998,
    "dropmaladd": "122 N LUCAS ST",
    "dropmalcty": "PIERCE",
    "dropmalst": "NE",
    "dropmalzpp": 687679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023296375,
    "dropsitcph": 4023296375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A130",
    "droptype": "D",
    "dropname": "PLAINVIEW",
    "dropdeladd": "311 W LOCUST AVE",
    "dropdelcty": "PLAINVIEW",
    "dropdelst": "NE",
    "dropdelzpp": 687694117,
    "dropphyadd": "311 W LOCUST AVE",
    "dropphycty": "PLAINVIEW",
    "dropphyst": "NE",
    "dropphyzpp": 687694117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAINVIEW",
    "dropmalst": "NE",
    "dropmalzpp": 687699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025823521,
    "dropsitcph": 4025823521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A132",
    "droptype": "D",
    "dropname": "PLATTE CENTER",
    "dropdeladd": "221 3RD ST",
    "dropdelcty": "PLATTE CENTER",
    "dropdelst": "NE",
    "dropdelzpp": 686539794,
    "dropphyadd": "221 3RD ST",
    "dropphycty": "PLATTE CENTER",
    "dropphyst": "NE",
    "dropphyzpp": 686539794,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLATTE CENTER",
    "dropmalst": "NE",
    "dropmalzpp": 686539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022465500,
    "dropsitcph": 4022465500,
    "dropfax": 4022465500
  },
  {
    "dcode": "D",
    "dropkey": "PW1A134",
    "droptype": "D",
    "dropname": "PLATTSMOUTH",
    "dropdeladd": "802 AVENUE B",
    "dropdelcty": "PLATTSMOUTH",
    "dropdelst": "NE",
    "dropdelzpp": 680489998,
    "dropphyadd": "802 AVENUE B",
    "dropphycty": "PLATTSMOUTH",
    "dropphyst": "NE",
    "dropphyzpp": 680489998,
    "dropmaladd": "802 AVENUE B",
    "dropmalcty": "PLATTSMOUTH",
    "dropmalst": "NE",
    "dropmalzpp": 680489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022962152,
    "dropsitcph": 4022962152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A135",
    "droptype": "D",
    "dropname": "PLEASANT DALE",
    "dropdeladd": "206 ASH ST",
    "dropdelcty": "PLEASANT DALE",
    "dropdelst": "NE",
    "dropdelzpp": 684239802,
    "dropphyadd": "206 ASH ST",
    "dropphycty": "PLEASANT DALE",
    "dropphyst": "NE",
    "dropphyzpp": 684239802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT DALE",
    "dropmalst": "NE",
    "dropmalzpp": 684239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027952230,
    "dropsitcph": 4027952230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A138",
    "droptype": "D",
    "dropname": "PLEASANTON",
    "dropdeladd": "109 W ELM ST",
    "dropdelcty": "PLEASANTON",
    "dropdelst": "NE",
    "dropdelzpp": 688669700,
    "dropphyadd": "109 W ELM ST",
    "dropphycty": "PLEASANTON",
    "dropphyst": "NE",
    "dropphyzpp": 688669700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "NE",
    "dropmalzpp": 688669998,
    "dropsitphn": 3083883155,
    "dropsitlph": 3083883155,
    "dropsitcph": 3083883155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A139",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "321 E MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "NE",
    "dropdelzpp": 684249700,
    "dropphyadd": "321 E MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "NE",
    "dropphyzpp": 684249700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "NE",
    "dropmalzpp": 684249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026564325,
    "dropsitcph": 4026564325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A140",
    "droptype": "D",
    "dropname": "POLK",
    "dropdeladd": "210 N MAIN ST",
    "dropdelcty": "POLK",
    "dropdelst": "NE",
    "dropdelzpp": 686549766,
    "dropphyadd": "210 N MAIN ST",
    "dropphycty": "POLK",
    "dropphyst": "NE",
    "dropphyzpp": 686549766,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLK",
    "dropmalst": "NE",
    "dropmalzpp": 686549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027653311,
    "dropsitcph": 4027653311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A141",
    "droptype": "D",
    "dropname": "PONCA",
    "dropdeladd": "112 W 3RD ST",
    "dropdelcty": "PONCA",
    "dropdelst": "NE",
    "dropdelzpp": 687707222,
    "dropphyadd": "112 W 3RD ST",
    "dropphycty": "PONCA",
    "dropphyst": "NE",
    "dropphyzpp": 687707222,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PONCA",
    "dropmalst": "NE",
    "dropmalzpp": 687709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027552705,
    "dropsitcph": 4027552705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A143",
    "droptype": "D",
    "dropname": "POTTER",
    "dropdeladd": "1017 SHERMAN ST",
    "dropdelcty": "POTTER",
    "dropdelst": "NE",
    "dropdelzpp": 691561057,
    "dropphyadd": "1017 SHERMAN ST",
    "dropphycty": "POTTER",
    "dropphyst": "NE",
    "dropphyzpp": 691561057,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTTER",
    "dropmalst": "NE",
    "dropmalzpp": 691569998,
    "dropsitphn": 3088794381,
    "dropsitlph": 3088794381,
    "dropsitcph": 3088794381,
    "dropfax": 3088794381
  },
  {
    "dcode": "D",
    "dropkey": "PW1A145",
    "droptype": "D",
    "dropname": "PRAGUE",
    "dropdeladd": "313 W CENTER AVE",
    "dropdelcty": "PRAGUE",
    "dropdelst": "NE",
    "dropdelzpp": 680506300,
    "dropphyadd": "313 W CENTER AVE",
    "dropphycty": "PRAGUE",
    "dropphyst": "NE",
    "dropphyzpp": 680506300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAGUE",
    "dropmalst": "NE",
    "dropmalzpp": 680509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026634310,
    "dropsitcph": 4026634310,
    "dropfax": 4026634310
  },
  {
    "dcode": "D",
    "dropkey": "PW1A157",
    "droptype": "D",
    "dropname": "PURDUM",
    "dropdeladd": "84451 PURDUM AVE",
    "dropdelcty": "PURDUM",
    "dropdelst": "NE",
    "dropdelzpp": 691579900,
    "dropphyadd": "84451 PURDUM AVE",
    "dropphycty": "PURDUM",
    "dropphyst": "NE",
    "dropphyzpp": 691579900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PURDUM",
    "dropmalst": "NE",
    "dropmalzpp": 691579998,
    "dropsitphn": 3088343246,
    "dropsitlph": 3088343246,
    "dropsitcph": 3088343246,
    "dropfax": 3088343246
  },
  {
    "dcode": "D",
    "dropkey": "PW1A161",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "NE",
    "dropdelzpp": 687715516,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "NE",
    "dropphyzpp": 687715516,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "NE",
    "dropmalzpp": 687719998,
    "dropsitphn": 4023370272,
    "dropsitlph": 4023370272,
    "dropsitcph": 4023370272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A162",
    "droptype": "D",
    "dropname": "RAVENNA",
    "dropdeladd": "401 MILAN AVE",
    "dropdelcty": "RAVENNA",
    "dropdelst": "NE",
    "dropdelzpp": 688699998,
    "dropphyadd": "401 MILAN AVE",
    "dropphycty": "RAVENNA",
    "dropphyst": "NE",
    "dropphyzpp": 688699998,
    "dropmaladd": "401 MILAN AVE",
    "dropmalcty": "RAVENNA",
    "dropmalst": "NE",
    "dropmalzpp": 688699998,
    "dropsitphn": 3084524100,
    "dropsitlph": 3084524100,
    "dropsitcph": 3084524100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A163",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "14700 N 1ST ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "NE",
    "dropdelzpp": 684284391,
    "dropphyadd": "14700 N 1ST ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "NE",
    "dropphyzpp": 684284391,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYMOND",
    "dropmalst": "NE",
    "dropmalzpp": 684289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027833411,
    "dropsitcph": 4027833411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A164",
    "droptype": "D",
    "dropname": "RED CLOUD",
    "dropdeladd": "310 N WEBSTER ST",
    "dropdelcty": "RED CLOUD",
    "dropdelst": "NE",
    "dropdelzpp": 689709998,
    "dropphyadd": "310 N WEBSTER ST",
    "dropphycty": "RED CLOUD",
    "dropphyst": "NE",
    "dropphyzpp": 689709998,
    "dropmaladd": "310 N WEBSTER ST",
    "dropmalcty": "RED CLOUD",
    "dropmalst": "NE",
    "dropmalzpp": 689709998,
    "dropsitphn": 4027462800,
    "dropsitlph": 4027462800,
    "dropsitcph": 4027462800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A166",
    "droptype": "D",
    "dropname": "REPUBLICAN CITY",
    "dropdeladd": "2 CIRCLE DR",
    "dropdelcty": "REPUBLICAN CITY",
    "dropdelst": "NE",
    "dropdelzpp": 689719700,
    "dropphyadd": "2 CIRCLE DR",
    "dropphycty": "REPUBLICAN CITY",
    "dropphyst": "NE",
    "dropphyzpp": 689719700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REPUBLICAN CITY",
    "dropmalst": "NE",
    "dropmalzpp": 689719998,
    "dropsitphn": 3087992335,
    "dropsitlph": 3087992335,
    "dropsitcph": 3087992335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A175",
    "droptype": "D",
    "dropname": "RISING CITY",
    "dropdeladd": "750 MAIN ST",
    "dropdelcty": "RISING CITY",
    "dropdelst": "NE",
    "dropdelzpp": 686583876,
    "dropphyadd": "750 MAIN ST",
    "dropphycty": "RISING CITY",
    "dropphyst": "NE",
    "dropphyzpp": 686583876,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RISING CITY",
    "dropmalst": "NE",
    "dropmalzpp": 686589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025420162,
    "dropsitcph": 4025420162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A178",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "216 3RD AVE",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "NE",
    "dropdelzpp": 688707095,
    "dropphyadd": "216 3RD AVE",
    "dropphycty": "RIVERDALE",
    "dropphyst": "NE",
    "dropphyzpp": 688707095,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "NE",
    "dropmalzpp": 688709998,
    "dropsitphn": 3088933341,
    "dropsitlph": 3088933341,
    "dropsitcph": 3088933341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A181",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "284 LINCOLN ST",
    "dropdelcty": "RIVERTON",
    "dropdelst": "NE",
    "dropdelzpp": 689725175,
    "dropphyadd": "284 LINCOLN ST",
    "dropphycty": "RIVERTON",
    "dropphyst": "NE",
    "dropphyzpp": 689725175,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERTON",
    "dropmalst": "NE",
    "dropmalzpp": 689729998,
    "dropsitphn": 4027462790,
    "dropsitlph": 4022751228,
    "dropsitcph": 4022751228,
    "dropfax": 4027462790
  },
  {
    "dcode": "D",
    "dropkey": "PW1A182",
    "droptype": "D",
    "dropname": "ROCA",
    "dropdeladd": "4200 MAIN ST",
    "dropdelcty": "ROCA",
    "dropdelst": "NE",
    "dropdelzpp": 684309703,
    "dropphyadd": "4200 MAIN ST",
    "dropphycty": "ROCA",
    "dropphyst": "NE",
    "dropphyzpp": 684309703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCA",
    "dropmalst": "NE",
    "dropmalzpp": 684309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024233493,
    "dropsitcph": 4024233493,
    "dropfax": 4024233493
  },
  {
    "dcode": "D",
    "dropkey": "PW1A185",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "229 N LEY ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 688719766,
    "dropphyadd": "229 N LEY ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 688719766,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 688719998,
    "dropsitphn": 3083723464,
    "dropsitlph": 3083723464,
    "dropsitcph": 3083723464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A190",
    "droptype": "D",
    "dropname": "ROSALIE",
    "dropdeladd": "200 S FARLEY AVE",
    "dropdelcty": "ROSALIE",
    "dropdelst": "NE",
    "dropdelzpp": 680554013,
    "dropphyadd": "200 S FARLEY AVE",
    "dropphycty": "ROSALIE",
    "dropphyst": "NE",
    "dropphyzpp": 680554013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSALIE",
    "dropmalst": "NE",
    "dropmalzpp": 680559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028632556,
    "dropsitcph": 4028632556,
    "dropfax": 4028632556
  },
  {
    "dcode": "D",
    "dropkey": "PW1A193",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "9230 S LINCOLN AVE",
    "dropdelcty": "ROSELAND",
    "dropdelst": "NE",
    "dropdelzpp": 689731840,
    "dropphyadd": "9230 S LINCOLN AVE",
    "dropphycty": "ROSELAND",
    "dropphyst": "NE",
    "dropphyzpp": 689731840,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSELAND",
    "dropmalst": "NE",
    "dropmalzpp": 689739998,
    "dropsitphn": 4027566035,
    "dropsitlph": 4027566035,
    "dropsitcph": 4027566035,
    "dropfax": 4027566035
  },
  {
    "dcode": "D",
    "dropkey": "PW1A196",
    "droptype": "D",
    "dropname": "RULO",
    "dropdeladd": "113 S 1ST ST",
    "dropdelcty": "RULO",
    "dropdelst": "NE",
    "dropdelzpp": 684319803,
    "dropphyadd": "113 S 1ST ST",
    "dropphycty": "RULO",
    "dropphyst": "NE",
    "dropphyzpp": 684319803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RULO",
    "dropmalst": "NE",
    "dropmalzpp": 684319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022454328,
    "dropsitcph": 4022454328,
    "dropfax": 4022454328
  },
  {
    "dcode": "D",
    "dropkey": "PW1A198",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "111 E 2ND ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 693605111,
    "dropphyadd": "111 E 2ND ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 693605111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 693609998,
    "dropsitphn": 3083272436,
    "dropsitlph": 3083272436,
    "dropsitcph": 3083272436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A201",
    "droptype": "D",
    "dropname": "RUSKIN",
    "dropdeladd": "940 MAIN ST",
    "dropdelcty": "RUSKIN",
    "dropdelst": "NE",
    "dropdelzpp": 689746119,
    "dropphyadd": "940 MAIN ST",
    "dropphycty": "RUSKIN",
    "dropphyst": "NE",
    "dropphyzpp": 689746119,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSKIN",
    "dropmalst": "NE",
    "dropmalzpp": 689749998,
    "dropsitphn": 4022263811,
    "dropsitlph": 4022263811,
    "dropsitcph": 4022263811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A205",
    "droptype": "D",
    "dropname": "SAINT EDWARD",
    "dropdeladd": "207 BEAVER ST",
    "dropdelcty": "SAINT EDWARD",
    "dropdelst": "NE",
    "dropdelzpp": 686604511,
    "dropphyadd": "207 BEAVER ST",
    "dropphycty": "SAINT EDWARD",
    "dropphyst": "NE",
    "dropphyzpp": 686604511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT EDWARD",
    "dropmalst": "NE",
    "dropmalzpp": 686609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026782800,
    "dropsitcph": 4026782800,
    "dropfax": 4026782800
  },
  {
    "dcode": "D",
    "dropkey": "PW1A206",
    "droptype": "D",
    "dropname": "SAINT HELENA",
    "dropdeladd": "110 W 9TH ST",
    "dropdelcty": "SAINT HELENA",
    "dropdelst": "NE",
    "dropdelzpp": 687745038,
    "dropphyadd": "110 W 9TH ST",
    "dropphycty": "SAINT HELENA",
    "dropphyst": "NE",
    "dropphyzpp": 687745038,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT HELENA",
    "dropmalst": "NE",
    "dropmalzpp": 687749998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023572249,
    "dropsitcph": 4023572249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A207",
    "droptype": "D",
    "dropname": "SAINT LIBORY",
    "dropdeladd": "303 SPRUCE ST",
    "dropdelcty": "SAINT LIBORY",
    "dropdelst": "NE",
    "dropdelzpp": 688722858,
    "dropphyadd": "303 SPRUCE ST",
    "dropphycty": "SAINT LIBORY",
    "dropphyst": "NE",
    "dropphyzpp": 688722858,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT LIBORY",
    "dropmalst": "NE",
    "dropmalzpp": 688729998,
    "dropsitphn": 3086876431,
    "dropsitlph": 3086876431,
    "dropsitcph": 3086876431,
    "dropfax": 3086876431
  },
  {
    "dcode": "D",
    "dropkey": "PW1A209",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "901 7TH ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "NE",
    "dropdelzpp": 688739998,
    "dropphyadd": "901 7TH ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "NE",
    "dropphyzpp": 688739998,
    "dropmaladd": "901 7TH ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "NE",
    "dropmalzpp": 688739998,
    "dropsitphn": 3087544942,
    "dropsitlph": 3087544942,
    "dropsitcph": 3087544942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A216",
    "droptype": "D",
    "dropname": "SARGENT",
    "dropdeladd": "602 W MAIN ST",
    "dropdelcty": "SARGENT",
    "dropdelst": "NE",
    "dropdelzpp": 688744125,
    "dropphyadd": "602 W MAIN ST",
    "dropphycty": "SARGENT",
    "dropphyst": "NE",
    "dropphyzpp": 688744125,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARGENT",
    "dropmalst": "NE",
    "dropmalzpp": 688749998,
    "dropsitphn": 3085274100,
    "dropsitlph": 3085274100,
    "dropsitcph": 3085274100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A224",
    "droptype": "D",
    "dropname": "SCHUYLER",
    "dropdeladd": "119 E 11TH ST",
    "dropdelcty": "SCHUYLER",
    "dropdelst": "NE",
    "dropdelzpp": 686619998,
    "dropphyadd": "119 E 11TH ST",
    "dropphycty": "SCHUYLER",
    "dropphyst": "NE",
    "dropphyzpp": 686619998,
    "dropmaladd": "119 E 11TH ST",
    "dropmalcty": "SCHUYLER",
    "dropmalst": "NE",
    "dropmalzpp": 686619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023522313,
    "dropsitcph": 4023522313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A225",
    "droptype": "D",
    "dropname": "SCOTIA",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "SCOTIA",
    "dropdelst": "NE",
    "dropdelzpp": 688759776,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "SCOTIA",
    "dropphyst": "NE",
    "dropphyzpp": 688759776,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCOTIA",
    "dropmalst": "NE",
    "dropmalzpp": 688759998,
    "dropsitphn": 3082454375,
    "dropsitlph": 3082454375,
    "dropsitcph": 3082454375,
    "dropfax": 3082454375
  },
  {
    "dcode": "D",
    "dropkey": "PW1A228",
    "droptype": "D",
    "dropname": "SCOTTSBLUFF",
    "dropdeladd": "112 W 20TH ST",
    "dropdelcty": "SCOTTSBLUFF",
    "dropdelst": "NE",
    "dropdelzpp": 693619998,
    "dropphyadd": "112 W 20TH ST",
    "dropphycty": "SCOTTSBLUFF",
    "dropphyst": "NE",
    "dropphyzpp": 693619998,
    "dropmaladd": "112 W 20TH ST",
    "dropmalcty": "SCOTTSBLUFF",
    "dropmalst": "NE",
    "dropmalzpp": 693619998,
    "dropsitphn": 3086351121,
    "dropsitlph": 3086351121,
    "dropsitcph": 3086351121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A229",
    "droptype": "D",
    "dropname": "SCRIBNER",
    "dropdeladd": "501 3RD ST",
    "dropdelcty": "SCRIBNER",
    "dropdelst": "NE",
    "dropdelzpp": 680573184,
    "dropphyadd": "501 3RD ST",
    "dropphycty": "SCRIBNER",
    "dropphyst": "NE",
    "dropphyzpp": 680573184,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCRIBNER",
    "dropmalst": "NE",
    "dropmalzpp": 680579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026642427,
    "dropsitcph": 4026642427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A231",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "109 WEST ST",
    "dropdelcty": "SENECA",
    "dropdelst": "NE",
    "dropdelzpp": 691619700,
    "dropphyadd": "109 WEST ST",
    "dropphycty": "SENECA",
    "dropphyst": "NE",
    "dropphyzpp": 691619700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECA",
    "dropmalst": "NE",
    "dropmalzpp": 691619998,
    "dropsitphn": 3086393259,
    "dropsitlph": 3086393259,
    "dropsitcph": 3086393259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A232",
    "droptype": "D",
    "dropname": "SEWARD",
    "dropdeladd": "507 MAIN ST",
    "dropdelcty": "SEWARD",
    "dropdelst": "NE",
    "dropdelzpp": 684349998,
    "dropphyadd": "507 MAIN ST",
    "dropphycty": "SEWARD",
    "dropphyst": "NE",
    "dropphyzpp": 684349998,
    "dropmaladd": "507 MAIN ST",
    "dropmalcty": "SEWARD",
    "dropmalst": "NE",
    "dropmalzpp": 684349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026432668,
    "dropsitcph": 4026432668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A234",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "210 N WALNUT ST",
    "dropdelcty": "SHELBY",
    "dropdelst": "NE",
    "dropdelzpp": 686625578,
    "dropphyadd": "210 N WALNUT ST",
    "dropphycty": "SHELBY",
    "dropphyst": "NE",
    "dropphyzpp": 686625578,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELBY",
    "dropmalst": "NE",
    "dropmalzpp": 686629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025275484,
    "dropsitcph": 4025275484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A235",
    "droptype": "D",
    "dropname": "SHELTON",
    "dropdeladd": "201 C ST",
    "dropdelcty": "SHELTON",
    "dropdelst": "NE",
    "dropdelzpp": 688769611,
    "dropphyadd": "201 C ST",
    "dropphycty": "SHELTON",
    "dropphyst": "NE",
    "dropphyzpp": 688769611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELTON",
    "dropmalst": "NE",
    "dropmalzpp": 688769998,
    "dropsitphn": 3086476693,
    "dropsitlph": 3086476693,
    "dropsitcph": 3086476693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A239",
    "droptype": "D",
    "dropname": "SHICKLEY",
    "dropdeladd": "206 N MARKET ST",
    "dropdelcty": "SHICKLEY",
    "dropdelst": "NE",
    "dropdelzpp": 684364034,
    "dropphyadd": "206 N MARKET ST",
    "dropphycty": "SHICKLEY",
    "dropphyst": "NE",
    "dropphyzpp": 684364034,
    "dropmaladd": "206 N MARKET ST",
    "dropmalcty": "SHICKLEY",
    "dropmalst": "NE",
    "dropmalzpp": 684364034,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026273595,
    "dropsitcph": 4026273595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A241",
    "droptype": "D",
    "dropname": "SHUBERT",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "SHUBERT",
    "dropdelst": "NE",
    "dropdelzpp": 684379747,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "SHUBERT",
    "dropphyst": "NE",
    "dropphyzpp": 684379747,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHUBERT",
    "dropmalst": "NE",
    "dropmalzpp": 684379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028832290,
    "dropsitcph": 4028832290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A243",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "844 ILLINOIS ST",
    "dropdelcty": "SIDNEY",
    "dropdelst": "NE",
    "dropdelzpp": 691629998,
    "dropphyadd": "844 ILLINOIS ST",
    "dropphycty": "SIDNEY",
    "dropphyst": "NE",
    "dropphyzpp": 691629998,
    "dropmaladd": "844 ILLINOIS ST",
    "dropmalcty": "SIDNEY",
    "dropmalst": "NE",
    "dropmalzpp": 691629998,
    "dropsitphn": 3082542911,
    "dropsitlph": 3082542911,
    "dropsitcph": 3082542911,
    "dropfax": 3082545155
  },
  {
    "dcode": "D",
    "dropkey": "PW1A244",
    "droptype": "D",
    "dropname": "SILVER CREEK",
    "dropdeladd": "215 VINE ST",
    "dropdelcty": "SILVER CREEK",
    "dropdelst": "NE",
    "dropdelzpp": 686632740,
    "dropphyadd": "215 VINE ST",
    "dropphycty": "SILVER CREEK",
    "dropphyst": "NE",
    "dropphyzpp": 686632740,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER CREEK",
    "dropmalst": "NE",
    "dropmalzpp": 686639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3087732517,
    "dropsitcph": 3087732517,
    "dropfax": 3087732517
  },
  {
    "dcode": "D",
    "dropkey": "PW1A247",
    "droptype": "D",
    "dropname": "SNYDER",
    "dropdeladd": "121 ASH ST",
    "dropdelcty": "SNYDER",
    "dropdelst": "NE",
    "dropdelzpp": 686649700,
    "dropphyadd": "121 ASH ST",
    "dropphycty": "SNYDER",
    "dropphyst": "NE",
    "dropphyzpp": 686649700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNYDER",
    "dropmalst": "NE",
    "dropmalzpp": 686649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025682614,
    "dropsitcph": 4025682614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A250",
    "droptype": "D",
    "dropname": "SOUTH BEND",
    "dropdeladd": "300 LARCH ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "NE",
    "dropdelzpp": 680584368,
    "dropphyadd": "300 LARCH ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "NE",
    "dropphyzpp": 680584368,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "NE",
    "dropmalzpp": 680589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029442650,
    "dropsitcph": 4029442650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A255",
    "droptype": "D",
    "dropname": "SOUTH SIOUX CITY",
    "dropdeladd": "801 W 29TH ST",
    "dropdelcty": "SOUTH SIOUX CITY",
    "dropdelst": "NE",
    "dropdelzpp": 687769998,
    "dropphyadd": "801 W 29TH ST",
    "dropphycty": "SOUTH SIOUX CITY",
    "dropphyst": "NE",
    "dropphyzpp": 687769998,
    "dropmaladd": "801 W 29TH ST",
    "dropmalcty": "SOUTH SIOUX CITY",
    "dropmalst": "NE",
    "dropmalzpp": 687769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024941312,
    "dropsitcph": 4024941312,
    "dropfax": 4024941234
  },
  {
    "dcode": "D",
    "dropkey": "PW1A257",
    "droptype": "D",
    "dropname": "SPALDING",
    "dropdeladd": "210 E ST JOSEPH ST",
    "dropdelcty": "SPALDING",
    "dropdelst": "NE",
    "dropdelzpp": 686659791,
    "dropphyadd": "210 E ST JOSEPH ST",
    "dropphycty": "SPALDING",
    "dropphyst": "NE",
    "dropphyzpp": 686659791,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPALDING",
    "dropmalst": "NE",
    "dropmalzpp": 686659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3084972276,
    "dropsitcph": 3084972276,
    "dropfax": 3084972276
  },
  {
    "dcode": "D",
    "dropkey": "PW1A260",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "110 S THAYER ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "NE",
    "dropdelzpp": 687779784,
    "dropphyadd": "110 S THAYER ST",
    "dropphycty": "SPENCER",
    "dropphyst": "NE",
    "dropphyzpp": 687779784,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPENCER",
    "dropmalst": "NE",
    "dropmalzpp": 687779998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025891310,
    "dropsitcph": 4025891310,
    "dropfax": 4025891310
  },
  {
    "dcode": "D",
    "dropkey": "PW1A262",
    "droptype": "D",
    "dropname": "SPRAGUE",
    "dropdeladd": "18905 MARKET ST",
    "dropdelcty": "SPRAGUE",
    "dropdelst": "NE",
    "dropdelzpp": 684389700,
    "dropphyadd": "18905 MARKET ST",
    "dropphycty": "SPRAGUE",
    "dropphyst": "NE",
    "dropphyzpp": 684389700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRAGUE",
    "dropmalst": "NE",
    "dropmalzpp": 684389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027944700,
    "dropsitcph": 4027944700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A267",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "160 N 2ND ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 680599700,
    "dropphyadd": "160 N 2ND ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 680599700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 680599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022532476,
    "dropsitcph": 4022532476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A269",
    "droptype": "D",
    "dropname": "SPRINGVIEW",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "SPRINGVIEW",
    "dropdelst": "NE",
    "dropdelzpp": 687789738,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "SPRINGVIEW",
    "dropphyst": "NE",
    "dropphyzpp": 687789738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGVIEW",
    "dropmalst": "NE",
    "dropmalzpp": 687789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024972211,
    "dropsitcph": 4024972211,
    "dropfax": 4024972211
  },
  {
    "dcode": "D",
    "dropkey": "PW1A296",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "213 N MAIN AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "NE",
    "dropdelzpp": 689772038,
    "dropphyadd": "213 N MAIN AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "NE",
    "dropphyzpp": 689772038,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAMFORD",
    "dropmalst": "NE",
    "dropmalzpp": 689779998,
    "dropsitphn": 3088683085,
    "dropsitlph": "",
    "dropsitcph": 3088683085,
    "dropfax": 3088683085
  },
  {
    "dcode": "D",
    "dropkey": "PW1A297",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "1018 IVY ST",
    "dropdelcty": "STANTON",
    "dropdelst": "NE",
    "dropdelzpp": 687792341,
    "dropphyadd": "1018 IVY ST",
    "dropphycty": "STANTON",
    "dropphyst": "NE",
    "dropphyzpp": 687792341,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANTON",
    "dropmalst": "NE",
    "dropmalzpp": 687799998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024392090,
    "dropsitcph": 4024392090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A298",
    "droptype": "D",
    "dropname": "STAPLEHURST",
    "dropdeladd": "390 A ST",
    "dropdelcty": "STAPLEHURST",
    "dropdelst": "NE",
    "dropdelzpp": 684393031,
    "dropphyadd": "390 A ST",
    "dropphycty": "STAPLEHURST",
    "dropphyst": "NE",
    "dropphyzpp": 684393031,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAPLEHURST",
    "dropmalst": "NE",
    "dropmalzpp": 684399998,
    "dropsitphn": 4027283019,
    "dropsitlph": 4027283019,
    "dropsitcph": 4027283019,
    "dropfax": 4025352297
  },
  {
    "dcode": "D",
    "dropkey": "PW1A299",
    "droptype": "D",
    "dropname": "STAPLETON",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "STAPLETON",
    "dropdelst": "NE",
    "dropdelzpp": 691639700,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "STAPLETON",
    "dropphyst": "NE",
    "dropphyzpp": 691639700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAPLETON",
    "dropmalst": "NE",
    "dropmalzpp": 691639998,
    "dropsitphn": 3086362215,
    "dropsitlph": 3086362215,
    "dropsitcph": 3086362215,
    "dropfax": 3086362215
  },
  {
    "dcode": "D",
    "dropkey": "PW1A323",
    "droptype": "D",
    "dropname": "STELLA",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "STELLA",
    "dropdelst": "NE",
    "dropdelzpp": 684426016,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "STELLA",
    "dropphyst": "NE",
    "dropphyzpp": 684426016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STELLA",
    "dropmalst": "NE",
    "dropmalzpp": 684429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028832200,
    "dropsitcph": 4028832200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A324",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "155 BROADWAY ST",
    "dropdelcty": "STERLING",
    "dropdelst": "NE",
    "dropdelzpp": 684438664,
    "dropphyadd": "155 BROADWAY ST",
    "dropphycty": "STERLING",
    "dropphyst": "NE",
    "dropphyzpp": 684438664,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STERLING",
    "dropmalst": "NE",
    "dropmalzpp": 684439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028666161,
    "dropsitcph": 4028666161,
    "dropfax": 4028666161
  },
  {
    "dcode": "D",
    "dropkey": "PW1A326",
    "droptype": "D",
    "dropname": "STOCKVILLE",
    "dropdeladd": "203 WELLINGTON ST",
    "dropdelcty": "STOCKVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 690429701,
    "dropphyadd": "203 WELLINGTON ST",
    "dropphycty": "STOCKVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 690429701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 690429998,
    "dropsitphn": 3083675470,
    "dropsitlph": 3083675470,
    "dropsitcph": 3083675470,
    "dropfax": 3083675470
  },
  {
    "dcode": "D",
    "dropkey": "PW1A330",
    "droptype": "D",
    "dropname": "STRATTON",
    "dropdeladd": "310 BAILEY ST",
    "dropdelcty": "STRATTON",
    "dropdelst": "NE",
    "dropdelzpp": 690439758,
    "dropphyadd": "310 BAILEY ST",
    "dropphycty": "STRATTON",
    "dropphyst": "NE",
    "dropphyzpp": 690439758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATTON",
    "dropmalst": "NE",
    "dropmalzpp": 690439998,
    "dropsitphn": 3082762574,
    "dropsitlph": 3082762574,
    "dropsitcph": 3082762574,
    "dropfax": 3082762574
  },
  {
    "dcode": "D",
    "dropkey": "PW1A331",
    "droptype": "D",
    "dropname": "STROMSBURG",
    "dropdeladd": "109 E 4TH ST",
    "dropdelcty": "STROMSBURG",
    "dropdelst": "NE",
    "dropdelzpp": 686663026,
    "dropphyadd": "109 E 4TH ST",
    "dropphycty": "STROMSBURG",
    "dropphyst": "NE",
    "dropphyzpp": 686663026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STROMSBURG",
    "dropmalst": "NE",
    "dropmalzpp": 686669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027646861,
    "dropsitcph": 4027646861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A332",
    "droptype": "D",
    "dropname": "STUART",
    "dropdeladd": "121 N MAIN ST",
    "dropdelcty": "STUART",
    "dropdelst": "NE",
    "dropdelzpp": 687809800,
    "dropphyadd": "121 N MAIN ST",
    "dropphycty": "STUART",
    "dropphyst": "NE",
    "dropphyzpp": 687809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STUART",
    "dropmalst": "NE",
    "dropmalzpp": 687809998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029243232,
    "dropsitcph": 4029243232,
    "dropfax": 4029243232
  },
  {
    "dcode": "D",
    "dropkey": "PW1A333",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "504 MAIN ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "NE",
    "dropdelzpp": 688787236,
    "dropphyadd": "504 MAIN ST",
    "dropphycty": "SUMNER",
    "dropphyst": "NE",
    "dropphyzpp": 688787236,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMNER",
    "dropmalst": "NE",
    "dropmalzpp": 688789998,
    "dropsitphn": 3087524155,
    "dropsitlph": 3087524155,
    "dropsitcph": 3087524155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A335",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "214 E 4TH ST",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "NE",
    "dropdelzpp": 689789998,
    "dropphyadd": "214 E 4TH ST",
    "dropphycty": "SUPERIOR",
    "dropphyst": "NE",
    "dropphyzpp": 689789998,
    "dropmaladd": "214 E 4TH ST",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "NE",
    "dropmalzpp": 689789998,
    "dropsitphn": 4028794000,
    "dropsitlph": 4028794000,
    "dropsitcph": 4028794000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A338",
    "droptype": "D",
    "dropname": "SUTHERLAND",
    "dropdeladd": "110 WALNUT ST",
    "dropdelcty": "SUTHERLAND",
    "dropdelst": "NE",
    "dropdelzpp": 691652138,
    "dropphyadd": "110 WALNUT ST",
    "dropphycty": "SUTHERLAND",
    "dropphyst": "NE",
    "dropphyzpp": 691652138,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUTHERLAND",
    "dropmalst": "NE",
    "dropmalzpp": 691659998,
    "dropsitphn": 3083864440,
    "dropsitlph": 4026470739,
    "dropsitcph": 4026470739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A339",
    "droptype": "D",
    "dropname": "SUTTON",
    "dropdeladd": "108 E FORREST ST",
    "dropdelcty": "SUTTON",
    "dropdelst": "NE",
    "dropdelzpp": 689792230,
    "dropphyadd": "108 E FORREST ST",
    "dropphycty": "SUTTON",
    "dropphyst": "NE",
    "dropphyzpp": 689792230,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUTTON",
    "dropmalst": "NE",
    "dropmalzpp": 689799998,
    "dropsitphn": 4027734304,
    "dropsitlph": 4027734304,
    "dropsitcph": 4027734304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A340",
    "droptype": "D",
    "dropname": "SWANTON",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "SWANTON",
    "dropdelst": "NE",
    "dropdelzpp": 684459700,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "SWANTON",
    "dropphyst": "NE",
    "dropphyzpp": 684459700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWANTON",
    "dropmalst": "NE",
    "dropmalzpp": 684459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024482465,
    "dropsitcph": 4024482465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A342",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "578 PLUM ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NE",
    "dropdelzpp": 684469701,
    "dropphyadd": "578 PLUM ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NE",
    "dropphyzpp": 684469701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NE",
    "dropmalzpp": 684469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022692002,
    "dropsitcph": 4022692002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A344",
    "droptype": "D",
    "dropname": "TABLE ROCK",
    "dropdeladd": "416 LUZERNE ST",
    "dropdelcty": "TABLE ROCK",
    "dropdelst": "NE",
    "dropdelzpp": 684473130,
    "dropphyadd": "416 LUZERNE ST",
    "dropphycty": "TABLE ROCK",
    "dropphyst": "NE",
    "dropphyzpp": 684473130,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TABLE ROCK",
    "dropmalst": "NE",
    "dropmalzpp": 684479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028392255,
    "dropsitcph": 4028392255,
    "dropfax": 4028392255
  },
  {
    "dcode": "D",
    "dropkey": "PW1A345",
    "droptype": "D",
    "dropname": "TALMAGE",
    "dropdeladd": "303 4TH ST",
    "dropdelcty": "TALMAGE",
    "dropdelst": "NE",
    "dropdelzpp": 684483001,
    "dropphyadd": "303 4TH ST",
    "dropphycty": "TALMAGE",
    "dropphyst": "NE",
    "dropphyzpp": 684483001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALMAGE",
    "dropmalst": "NE",
    "dropmalzpp": 684489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022642155,
    "dropsitcph": 4022642155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A348",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "301 MURRAY ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "NE",
    "dropdelzpp": 688799738,
    "dropphyadd": "301 MURRAY ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "NE",
    "dropphyzpp": 688799738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLOR",
    "dropmalst": "NE",
    "dropmalzpp": 688799998,
    "dropsitphn": 3089426090,
    "dropsitlph": 3089426090,
    "dropsitcph": 3089426090,
    "dropfax": 3089426090
  },
  {
    "dcode": "D",
    "dropkey": "PW1A349",
    "droptype": "D",
    "dropname": "TECUMSEH",
    "dropdeladd": "484 BROADWAY ST",
    "dropdelcty": "TECUMSEH",
    "dropdelst": "NE",
    "dropdelzpp": 684502453,
    "dropphyadd": "484 BROADWAY ST",
    "dropphycty": "TECUMSEH",
    "dropphyst": "NE",
    "dropphyzpp": 684502453,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TECUMSEH",
    "dropmalst": "NE",
    "dropmalzpp": 684509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023352007,
    "dropsitcph": 4023352007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A350",
    "droptype": "D",
    "dropname": "TEKAMAH",
    "dropdeladd": "1323 K ST",
    "dropdelcty": "TEKAMAH",
    "dropdelst": "NE",
    "dropdelzpp": 680619998,
    "dropphyadd": "1323 K ST",
    "dropphycty": "TEKAMAH",
    "dropphyst": "NE",
    "dropphyzpp": 680619998,
    "dropmaladd": "1323 K ST",
    "dropmalcty": "TEKAMAH",
    "dropmalst": "NE",
    "dropmalzpp": 680619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023741604,
    "dropsitcph": 4023741604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A353",
    "droptype": "D",
    "dropname": "THEDFORD",
    "dropdeladd": "507 WALNUT ST",
    "dropdelcty": "THEDFORD",
    "dropdelst": "NE",
    "dropdelzpp": 691669701,
    "dropphyadd": "507 WALNUT ST",
    "dropphycty": "THEDFORD",
    "dropphyst": "NE",
    "dropphyzpp": 691669701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THEDFORD",
    "dropmalst": "NE",
    "dropmalzpp": 691669998,
    "dropsitphn": 3086452220,
    "dropsitlph": 4026748659,
    "dropsitcph": 4026748659,
    "dropfax": 3086452220
  },
  {
    "dcode": "D",
    "dropkey": "PW1A357",
    "droptype": "D",
    "dropname": "THURSTON",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "THURSTON",
    "dropdelst": "NE",
    "dropdelzpp": 680623078,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "THURSTON",
    "dropphyst": "NE",
    "dropphyzpp": 680623078,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THURSTON",
    "dropmalst": "NE",
    "dropmalzpp": 680629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023852488,
    "dropsitcph": 4023852488,
    "dropfax": 4023852488
  },
  {
    "dcode": "D",
    "dropkey": "PW1A358",
    "droptype": "D",
    "dropname": "TILDEN",
    "dropdeladd": "101 S MADISON ST",
    "dropdelcty": "TILDEN",
    "dropdelst": "NE",
    "dropdelzpp": 687814829,
    "dropphyadd": "101 S MADISON ST",
    "dropphycty": "TILDEN",
    "dropphyst": "NE",
    "dropphyzpp": 687814829,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TILDEN",
    "dropmalst": "NE",
    "dropmalzpp": 687819998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023685380,
    "dropsitcph": 4023685380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A359",
    "droptype": "D",
    "dropname": "TOBIAS",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "TOBIAS",
    "dropdelst": "NE",
    "dropdelzpp": 684532073,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "TOBIAS",
    "dropphyst": "NE",
    "dropphyzpp": 684532073,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOBIAS",
    "dropmalst": "NE",
    "dropmalzpp": 684539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022432284,
    "dropsitcph": 4022432284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A360",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "NE",
    "dropdelzpp": 690441809,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "TRENTON",
    "dropphyst": "NE",
    "dropphyzpp": 690441809,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRENTON",
    "dropmalst": "NE",
    "dropmalzpp": 690449998,
    "dropsitphn": 3083345265,
    "dropsitlph": 3083345265,
    "dropsitcph": 3083345265,
    "dropfax": 3083345265
  },
  {
    "dcode": "D",
    "dropkey": "PW1A362",
    "droptype": "D",
    "dropname": "TRUMBULL",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "TRUMBULL",
    "dropdelst": "NE",
    "dropdelzpp": 689802722,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "TRUMBULL",
    "dropphyst": "NE",
    "dropphyzpp": 689802722,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRUMBULL",
    "dropmalst": "NE",
    "dropmalzpp": 689809998,
    "dropsitphn": 3083856525,
    "dropsitlph": 3083856525,
    "dropsitcph": 4027432266,
    "dropfax": 4027432266
  },
  {
    "dcode": "D",
    "dropkey": "PW1A363",
    "droptype": "D",
    "dropname": "TRYON",
    "dropdeladd": "488 ANDERSON ST",
    "dropdelcty": "TRYON",
    "dropdelst": "NE",
    "dropdelzpp": 691679701,
    "dropphyadd": "488 ANDERSON ST",
    "dropphycty": "TRYON",
    "dropphyst": "NE",
    "dropphyzpp": 691679701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRYON",
    "dropmalst": "NE",
    "dropmalzpp": 691679998,
    "dropsitphn": 3085872422,
    "dropsitlph": 3085872422,
    "dropsitcph": 3085872422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A366",
    "droptype": "D",
    "dropname": "UEHLING",
    "dropdeladd": "406 MAIN ST",
    "dropdelcty": "UEHLING",
    "dropdelst": "NE",
    "dropdelzpp": 680639700,
    "dropphyadd": "406 MAIN ST",
    "dropphycty": "UEHLING",
    "dropphyst": "NE",
    "dropphyzpp": 680639700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UEHLING",
    "dropmalst": "NE",
    "dropmalzpp": 680639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025672291,
    "dropsitcph": 4025672291,
    "dropfax": 4025672291
  },
  {
    "dcode": "D",
    "dropkey": "PW1A367",
    "droptype": "D",
    "dropname": "ULYSSES",
    "dropdeladd": "210 N 4TH ST",
    "dropdelcty": "ULYSSES",
    "dropdelst": "NE",
    "dropdelzpp": 686699700,
    "dropphyadd": "210 N 4TH ST",
    "dropphycty": "ULYSSES",
    "dropphyst": "NE",
    "dropphyzpp": 686699700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ULYSSES",
    "dropmalst": "NE",
    "dropmalzpp": 686699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027283009,
    "dropsitcph": 4027283009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A369",
    "droptype": "D",
    "dropname": "UNADILLA",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "UNADILLA",
    "dropdelst": "NE",
    "dropdelzpp": 684544039,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "UNADILLA",
    "dropphyst": "NE",
    "dropphyzpp": 684544039,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNADILLA",
    "dropmalst": "NE",
    "dropmalzpp": 684549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028283775,
    "dropsitcph": 4028283775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A371",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "129 MAIN ST",
    "dropdelcty": "UNION",
    "dropdelst": "NE",
    "dropdelzpp": 684559700,
    "dropphyadd": "129 MAIN ST",
    "dropphycty": "UNION",
    "dropphyst": "NE",
    "dropphyzpp": 684559700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION",
    "dropmalst": "NE",
    "dropmalzpp": 684559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022632130,
    "dropsitcph": 4022632130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A378",
    "droptype": "D",
    "dropname": "UPLAND",
    "dropdeladd": "100 MIDLAND AVE",
    "dropdelcty": "UPLAND",
    "dropdelst": "NE",
    "dropdelzpp": 689819769,
    "dropphyadd": "100 MIDLAND AVE",
    "dropphycty": "UPLAND",
    "dropphyst": "NE",
    "dropphyzpp": 689819769,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UPLAND",
    "dropmalst": "NE",
    "dropmalzpp": 689819998,
    "dropsitphn": 4027560243,
    "dropsitlph": 4027560243,
    "dropsitcph": 4027560243,
    "dropfax": 4027560243
  },
  {
    "dcode": "D",
    "dropkey": "PW1A379",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "740 D ST",
    "dropdelcty": "UTICA",
    "dropdelst": "NE",
    "dropdelzpp": 684569700,
    "dropphyadd": "740 D ST",
    "dropphycty": "UTICA",
    "dropphyst": "NE",
    "dropphyzpp": 684569700,
    "dropmaladd": "740 D ST",
    "dropmalcty": "UTICA",
    "dropmalst": "NE",
    "dropmalzpp": 684569700,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025343801,
    "dropsitcph": 4025343801,
    "dropfax": 4025343801
  },
  {
    "dcode": "D",
    "dropkey": "PW1A381",
    "droptype": "D",
    "dropname": "VALENTINE",
    "dropdeladd": "239 N HALL ST",
    "dropdelcty": "VALENTINE",
    "dropdelst": "NE",
    "dropdelzpp": 692019998,
    "dropphyadd": "239 N HALL ST",
    "dropphycty": "VALENTINE",
    "dropphyst": "NE",
    "dropphyzpp": 692019998,
    "dropmaladd": "239 N HALL ST",
    "dropmalcty": "VALENTINE",
    "dropmalst": "NE",
    "dropmalzpp": 692019998,
    "dropsitphn": 4023761540,
    "dropsitlph": 4023761540,
    "dropsitcph": 4023761540,
    "dropfax": 4023761415
  },
  {
    "dcode": "D",
    "dropkey": "PW1A383",
    "droptype": "D",
    "dropname": "VALLEY",
    "dropdeladd": "108 E 2ND ST",
    "dropdelcty": "VALLEY",
    "dropdelst": "NE",
    "dropdelzpp": 680641000,
    "dropphyadd": "108 E 2ND ST",
    "dropphycty": "VALLEY",
    "dropphyst": "NE",
    "dropphyzpp": 680641000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALLEY",
    "dropmalst": "NE",
    "dropmalzpp": 680649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023592357,
    "dropsitcph": 4023592357,
    "dropfax": 4023592357
  },
  {
    "dcode": "D",
    "dropkey": "PW1A384",
    "droptype": "D",
    "dropname": "VALPARAISO",
    "dropdeladd": "120 N PINE ST",
    "dropdelcty": "VALPARAISO",
    "dropdelst": "NE",
    "dropdelzpp": 680655038,
    "dropphyadd": "120 N PINE ST",
    "dropphycty": "VALPARAISO",
    "dropphyst": "NE",
    "dropphyzpp": 680655038,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALPARAISO",
    "dropmalst": "NE",
    "dropmalzpp": 680659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027842321,
    "dropsitcph": 4027842321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A385",
    "droptype": "D",
    "dropname": "VENANGO",
    "dropdeladd": "112 N PENNSYLVANIA AVE",
    "dropdelcty": "VENANGO",
    "dropdelst": "NE",
    "dropdelzpp": 691689738,
    "dropphyadd": "112 N PENNSYLVANIA AVE",
    "dropphycty": "VENANGO",
    "dropphyst": "NE",
    "dropphyzpp": 691689738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENANGO",
    "dropmalst": "NE",
    "dropmalzpp": 691689998,
    "dropsitphn": 3084475636,
    "dropsitlph": 3084475636,
    "dropsitcph": 3084475636,
    "dropfax": 3084475636
  },
  {
    "dcode": "D",
    "dropkey": "PW1A387",
    "droptype": "D",
    "dropname": "VERDIGRE",
    "dropdeladd": "408 S MAIN ST",
    "dropdelcty": "VERDIGRE",
    "dropdelst": "NE",
    "dropdelzpp": 687835108,
    "dropphyadd": "408 S MAIN ST",
    "dropphycty": "VERDIGRE",
    "dropphyst": "NE",
    "dropphyzpp": 687835108,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERDIGRE",
    "dropmalst": "NE",
    "dropmalzpp": 687839998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026682612,
    "dropsitcph": 4026682612,
    "dropfax": 4026682612
  },
  {
    "dcode": "D",
    "dropkey": "PW1A388",
    "droptype": "D",
    "dropname": "VERDON",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "VERDON",
    "dropdelst": "NE",
    "dropdelzpp": 684579777,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "VERDON",
    "dropphyst": "NE",
    "dropphyzpp": 684579777,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERDON",
    "dropmalst": "NE",
    "dropmalzpp": 684579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028832021,
    "dropsitcph": 4028832021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A396",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "401 MIDLAND ST",
    "dropdelcty": "WACO",
    "dropdelst": "NE",
    "dropdelzpp": 684603018,
    "dropphyadd": "401 MIDLAND ST",
    "dropphycty": "WACO",
    "dropphyst": "NE",
    "dropphyzpp": 684603018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WACO",
    "dropmalst": "NE",
    "dropmalzpp": 684609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027285275,
    "dropsitcph": 4027285275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A397",
    "droptype": "D",
    "dropname": "WAHOO",
    "dropdeladd": "134 E 6TH ST",
    "dropdelcty": "WAHOO",
    "dropdelst": "NE",
    "dropdelzpp": 680669998,
    "dropphyadd": "134 E 6TH ST",
    "dropphycty": "WAHOO",
    "dropphyst": "NE",
    "dropphyzpp": 680669998,
    "dropmaladd": "134 E 6TH ST",
    "dropmalcty": "WAHOO",
    "dropmalst": "NE",
    "dropmalzpp": 680669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024433610,
    "dropsitcph": 4024433610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A398",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 687846026,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 687846026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 687849998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022872021,
    "dropsitcph": 4022872021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A399",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "233 S COMMERCIAL AVE",
    "dropdelcty": "WALLACE",
    "dropdelst": "NE",
    "dropdelzpp": 691698091,
    "dropphyadd": "233 S COMMERCIAL AVE",
    "dropphycty": "WALLACE",
    "dropphyst": "NE",
    "dropphyzpp": 691698091,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLACE",
    "dropmalst": "NE",
    "dropmalzpp": 691699998,
    "dropsitphn": 3083874521,
    "dropsitlph": 4025207260,
    "dropsitcph": 4025207260,
    "dropfax": 3083874521
  },
  {
    "dcode": "D",
    "dropkey": "PW1A400",
    "droptype": "D",
    "dropname": "WALTHILL",
    "dropdeladd": "316 MAIN ST",
    "dropdelcty": "WALTHILL",
    "dropdelst": "NE",
    "dropdelzpp": 680679800,
    "dropphyadd": "316 MAIN ST",
    "dropphycty": "WALTHILL",
    "dropphyst": "NE",
    "dropphyzpp": 680679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALTHILL",
    "dropmalst": "NE",
    "dropmalzpp": 680679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028465606,
    "dropsitcph": 4028465606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A401",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "1500 S 112TH ST",
    "dropdelcty": "WALTON",
    "dropdelst": "NE",
    "dropdelzpp": 684619538,
    "dropphyadd": "1500 S 112TH ST",
    "dropphycty": "WALTON",
    "dropphyst": "NE",
    "dropphyzpp": 684619538,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALTON",
    "dropmalst": "NE",
    "dropmalzpp": 684619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024883227,
    "dropsitcph": 4024883227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A408",
    "droptype": "D",
    "dropname": "WATERBURY",
    "dropdeladd": "301 LOGAN ST",
    "dropdelcty": "WATERBURY",
    "dropdelst": "NE",
    "dropdelzpp": 687859737,
    "dropphyadd": "301 LOGAN ST",
    "dropphycty": "WATERBURY",
    "dropphyst": "NE",
    "dropphyzpp": 687859737,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERBURY",
    "dropmalst": "NE",
    "dropmalzpp": 687859998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026382555,
    "dropsitcph": 4026382555,
    "dropfax": 4026382555
  },
  {
    "dcode": "D",
    "dropkey": "PW1A409",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "206 WASHINGTON ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "NE",
    "dropdelzpp": 680692010,
    "dropphyadd": "206 WASHINGTON ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "NE",
    "dropphyzpp": 680692010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERLOO",
    "dropmalst": "NE",
    "dropmalzpp": 680699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027792518,
    "dropsitcph": 4027792518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A410",
    "droptype": "D",
    "dropname": "WAUNETA",
    "dropdeladd": "215 N TECUMSEH",
    "dropdelcty": "WAUNETA",
    "dropdelst": "NE",
    "dropdelzpp": 690459725,
    "dropphyadd": "215 N TECUMSEH",
    "dropphycty": "WAUNETA",
    "dropphyst": "NE",
    "dropphyzpp": 690459725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUNETA",
    "dropmalst": "NE",
    "dropmalzpp": 690459998,
    "dropsitphn": 3083945708,
    "dropsitlph": 3083945708,
    "dropsitcph": 3083945708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A411",
    "droptype": "D",
    "dropname": "WAUSA",
    "dropdeladd": "612 E BROADWAY ST",
    "dropdelcty": "WAUSA",
    "dropdelst": "NE",
    "dropdelzpp": 687861560,
    "dropphyadd": "612 E BROADWAY ST",
    "dropphycty": "WAUSA",
    "dropphyst": "NE",
    "dropphyzpp": 687861560,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUSA",
    "dropmalst": "NE",
    "dropmalzpp": 687869998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025862121,
    "dropsitcph": 4025862121,
    "dropfax": 4025862121
  },
  {
    "dcode": "D",
    "dropkey": "PW1A412",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "10850 N 142ND ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "NE",
    "dropdelzpp": 684621103,
    "dropphyadd": "10850 N 142ND ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "NE",
    "dropphyzpp": 684621103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAVERLY",
    "dropmalst": "NE",
    "dropmalzpp": 684629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027862241,
    "dropsitcph": 4027862241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A414",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "120 N PEARL ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "NE",
    "dropdelzpp": 687871932,
    "dropphyadd": "120 N PEARL ST",
    "dropphycty": "WAYNE",
    "dropphyst": "NE",
    "dropphyzpp": 687871932,
    "dropmaladd": "120 N PEARL ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "NE",
    "dropmalzpp": 687879998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023752485,
    "dropsitcph": 4023752485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A418",
    "droptype": "D",
    "dropname": "WEEPING WATER",
    "dropdeladd": "107 N COMMERCIAL ST",
    "dropdelcty": "WEEPING WATER",
    "dropdelst": "NE",
    "dropdelzpp": 684634032,
    "dropphyadd": "107 N COMMERCIAL ST",
    "dropphycty": "WEEPING WATER",
    "dropphyst": "NE",
    "dropphyzpp": 684634032,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEEPING WATER",
    "dropmalst": "NE",
    "dropmalzpp": 684639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022676445,
    "dropsitcph": 4022676445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A420",
    "droptype": "D",
    "dropname": "WELLFLEET",
    "dropdeladd": "301 NILE AVE",
    "dropdelcty": "WELLFLEET",
    "dropdelst": "NE",
    "dropdelzpp": 691709900,
    "dropphyadd": "301 NILE AVE",
    "dropphycty": "WELLFLEET",
    "dropphyst": "NE",
    "dropphyzpp": 691709900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLFLEET",
    "dropmalst": "NE",
    "dropmalzpp": 691709998,
    "dropsitphn": 3089634447,
    "dropsitlph": 3089634447,
    "dropsitcph": 3089634447,
    "dropfax": 3089634447
  },
  {
    "dcode": "D",
    "dropkey": "PW1A423",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "127 E BRIDGE ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "NE",
    "dropdelzpp": 687881439,
    "dropphyadd": "127 E BRIDGE ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "NE",
    "dropphyzpp": 687881439,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST POINT",
    "dropmalst": "NE",
    "dropmalzpp": 687889998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023722903,
    "dropsitcph": 4023722903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A425",
    "droptype": "D",
    "dropname": "WESTERN",
    "dropdeladd": "100 N WEST AVE",
    "dropdelcty": "WESTERN",
    "dropdelst": "NE",
    "dropdelzpp": 684643000,
    "dropphyadd": "100 N WEST AVE",
    "dropphycty": "WESTERN",
    "dropphyst": "NE",
    "dropphyzpp": 684643000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTERN",
    "dropmalst": "NE",
    "dropmalzpp": 684649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024334681,
    "dropsitcph": 4024334681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A428",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "345 ELM ST",
    "dropdelcty": "WESTON",
    "dropdelst": "NE",
    "dropdelzpp": 680709700,
    "dropphyadd": "345 ELM ST",
    "dropphycty": "WESTON",
    "dropphyst": "NE",
    "dropphyzpp": 680709700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTON",
    "dropmalst": "NE",
    "dropmalzpp": 680709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026425254,
    "dropsitcph": 4026425254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A431",
    "droptype": "D",
    "dropname": "WHITMAN",
    "dropdeladd": "100 CORROTHER ST",
    "dropdelcty": "WHITMAN",
    "dropdelst": "NE",
    "dropdelzpp": 693669700,
    "dropphyadd": "100 CORROTHER ST",
    "dropphycty": "WHITMAN",
    "dropphyst": "NE",
    "dropphyzpp": 693669700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITMAN",
    "dropmalst": "NE",
    "dropmalzpp": 693669998,
    "dropsitphn": 3085446454,
    "dropsitlph": 3085446454,
    "dropsitcph": 3085446454,
    "dropfax": 3085446454
  },
  {
    "dcode": "D",
    "dropkey": "PW1A433",
    "droptype": "D",
    "dropname": "WILBER",
    "dropdeladd": "224 W 3RD ST",
    "dropdelcty": "WILBER",
    "dropdelst": "NE",
    "dropdelzpp": 684653193,
    "dropphyadd": "224 W 3RD ST",
    "dropphycty": "WILBER",
    "dropphyst": "NE",
    "dropphyzpp": 684653193,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILBER",
    "dropmalst": "NE",
    "dropmalzpp": 684659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028212775,
    "dropsitcph": 4028212775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A434",
    "droptype": "D",
    "dropname": "WILCOX",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "WILCOX",
    "dropdelst": "NE",
    "dropdelzpp": 689829700,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "WILCOX",
    "dropphyst": "NE",
    "dropphyzpp": 689829700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILCOX",
    "dropmalst": "NE",
    "dropmalzpp": 689829998,
    "dropsitphn": 3084785217,
    "dropsitlph": 3084785217,
    "dropsitcph": 3084785217,
    "dropfax": 3084785217
  },
  {
    "dcode": "D",
    "dropkey": "PW1A440",
    "droptype": "D",
    "dropname": "WILSONVILLE",
    "dropdeladd": "706 MAIN ST",
    "dropdelcty": "WILSONVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 690469734,
    "dropphyadd": "706 MAIN ST",
    "dropphycty": "WILSONVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 690469734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSONVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 690469998,
    "dropsitphn": 3083494324,
    "dropsitlph": "",
    "dropsitcph": 3083494324,
    "dropfax": 3083494324
  },
  {
    "dcode": "D",
    "dropkey": "PW1A441",
    "droptype": "D",
    "dropname": "WINNEBAGO",
    "dropdeladd": "100 BLUFF AVE",
    "dropdelcty": "WINNEBAGO",
    "dropdelst": "NE",
    "dropdelzpp": 680719787,
    "dropphyadd": "100 BLUFF AVE",
    "dropphycty": "WINNEBAGO",
    "dropphyst": "NE",
    "dropphyzpp": 680719787,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNEBAGO",
    "dropmalst": "NE",
    "dropmalzpp": 680719998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026959500,
    "dropsitcph": 4026959500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A443",
    "droptype": "D",
    "dropname": "WINSIDE",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "WINSIDE",
    "dropdelst": "NE",
    "dropdelzpp": 687905122,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "WINSIDE",
    "dropphyst": "NE",
    "dropphyzpp": 687905122,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINSIDE",
    "dropmalst": "NE",
    "dropmalzpp": 687909998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022304326,
    "dropsitcph": 4022304326,
    "dropfax": 4022864508
  },
  {
    "dcode": "D",
    "dropkey": "PW1A444",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "208 ELKHORN ST",
    "dropdelcty": "WINSLOW",
    "dropdelst": "NE",
    "dropdelzpp": 680729700,
    "dropphyadd": "208 ELKHORN ST",
    "dropphycty": "WINSLOW",
    "dropphyst": "NE",
    "dropphyzpp": 680729700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINSLOW",
    "dropmalst": "NE",
    "dropmalzpp": 680729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026542360,
    "dropsitcph": 4026542360,
    "dropfax": 4026542360
  },
  {
    "dcode": "D",
    "dropkey": "PW1A445",
    "droptype": "D",
    "dropname": "WISNER",
    "dropdeladd": "1114 AVENUE E",
    "dropdelcty": "WISNER",
    "dropdelst": "NE",
    "dropdelzpp": 687919988,
    "dropphyadd": "1114 AVENUE E",
    "dropphycty": "WISNER",
    "dropphyst": "NE",
    "dropphyzpp": 687919988,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WISNER",
    "dropmalst": "NE",
    "dropmalzpp": 687919998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025296917,
    "dropsitcph": 4025296917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A446",
    "droptype": "D",
    "dropname": "WOLBACH",
    "dropdeladd": "306 CENTER AVE",
    "dropdelcty": "WOLBACH",
    "dropdelst": "NE",
    "dropdelzpp": 688829710,
    "dropphyadd": "306 CENTER AVE",
    "dropphycty": "WOLBACH",
    "dropphyst": "NE",
    "dropphyzpp": 688829710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOLBACH",
    "dropmalst": "NE",
    "dropmalzpp": 688829998,
    "dropsitphn": 3082465246,
    "dropsitlph": 3082465246,
    "dropsitcph": 3082465246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A447",
    "droptype": "D",
    "dropname": "WOOD LAKE",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "WOOD LAKE",
    "dropdelst": "NE",
    "dropdelzpp": 692219717,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "WOOD LAKE",
    "dropphyst": "NE",
    "dropphyzpp": 692219717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOOD LAKE",
    "dropmalst": "NE",
    "dropmalzpp": 692219998,
    "dropsitphn": 4029673460,
    "dropsitlph": 4029673460,
    "dropsitcph": 4029673460,
    "dropfax": 4029673460
  },
  {
    "dcode": "D",
    "dropkey": "PW1A450",
    "droptype": "D",
    "dropname": "WOOD RIVER",
    "dropdeladd": "115 W 9TH ST",
    "dropdelcty": "WOOD RIVER",
    "dropdelst": "NE",
    "dropdelzpp": 688839176,
    "dropphyadd": "115 W 9TH ST",
    "dropphycty": "WOOD RIVER",
    "dropphyst": "NE",
    "dropphyzpp": 688839176,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOOD RIVER",
    "dropmalst": "NE",
    "dropmalzpp": 688839998,
    "dropsitphn": 3085832165,
    "dropsitlph": 3085832165,
    "dropsitcph": 3085832165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A453",
    "droptype": "D",
    "dropname": "WYMORE",
    "dropdeladd": "119 W F ST",
    "dropdelcty": "WYMORE",
    "dropdelst": "NE",
    "dropdelzpp": 684661735,
    "dropphyadd": "119 W F ST",
    "dropphycty": "WYMORE",
    "dropphyst": "NE",
    "dropphyzpp": 684661735,
    "dropmaladd": "119 W F ST",
    "dropmalcty": "WYMORE",
    "dropmalst": "NE",
    "dropmalzpp": 684661735,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026453434,
    "dropsitcph": 4026453434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A454",
    "droptype": "D",
    "dropname": "WYNOT",
    "dropdeladd": "418 SAINT JAMES AVE",
    "dropdelcty": "WYNOT",
    "dropdelst": "NE",
    "dropdelzpp": 687922019,
    "dropphyadd": "418 SAINT JAMES AVE",
    "dropphycty": "WYNOT",
    "dropphyst": "NE",
    "dropphyzpp": 687922019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYNOT",
    "dropmalst": "NE",
    "dropmalzpp": 687929998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023572417,
    "dropsitcph": 4023572417,
    "dropfax": 4023572417
  },
  {
    "dcode": "D",
    "dropkey": "PW1A457",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "626 N GRANT AVE",
    "dropdelcty": "YORK",
    "dropdelst": "NE",
    "dropdelzpp": 684679998,
    "dropphyadd": "626 N GRANT AVE",
    "dropphycty": "YORK",
    "dropphyst": "NE",
    "dropphyzpp": 684679998,
    "dropmaladd": "626 N GRANT AVE",
    "dropmalcty": "YORK",
    "dropmalst": "NE",
    "dropmalzpp": 684679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023624514,
    "dropsitcph": 4023624514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A458",
    "droptype": "D",
    "dropname": "YUTAN",
    "dropdeladd": "502 1ST ST",
    "dropdelcty": "YUTAN",
    "dropdelst": "NE",
    "dropdelzpp": 680739700,
    "dropphyadd": "502 1ST ST",
    "dropphycty": "YUTAN",
    "dropphyst": "NE",
    "dropphyzpp": 680739700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YUTAN",
    "dropmalst": "NE",
    "dropmalzpp": 680739998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026654042,
    "dropsitcph": 4026654042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A461",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "1202 S 5TH ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "SD",
    "dropdelzpp": 574019998,
    "dropphyadd": "1202 S 5TH ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "SD",
    "dropphyzpp": 574019998,
    "dropmaladd": "1202 S 5TH ST",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "SD",
    "dropmalzpp": 574019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052262673,
    "dropsitcph": 6052262673,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A464",
    "droptype": "D",
    "dropname": "AGAR",
    "dropdeladd": "206 ASH ST",
    "dropdelcty": "AGAR",
    "dropdelst": "SD",
    "dropdelzpp": 575209998,
    "dropphyadd": "206 ASH ST",
    "dropphycty": "AGAR",
    "dropphyst": "SD",
    "dropphyzpp": 575209998,
    "dropmaladd": "206 ASH ST",
    "dropmalcty": "AGAR",
    "dropmalst": "SD",
    "dropmalzpp": 575209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052582891,
    "dropsitcph": 6052582891,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A468",
    "droptype": "D",
    "dropname": "ALCESTER",
    "dropdeladd": "111 DAKOTA ST",
    "dropdelcty": "ALCESTER",
    "dropdelst": "SD",
    "dropdelzpp": 570019998,
    "dropphyadd": "111 DAKOTA ST",
    "dropphycty": "ALCESTER",
    "dropphyst": "SD",
    "dropphyzpp": 570019998,
    "dropmaladd": "111 DAKOTA ST",
    "dropmalcty": "ALCESTER",
    "dropmalst": "SD",
    "dropmalzpp": 570019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059342450,
    "dropsitcph": 6059342450,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A469",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "SD",
    "dropdelzpp": 573119998,
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "SD",
    "dropphyzpp": 573119998,
    "dropmaladd": "501 MAIN ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "SD",
    "dropmalzpp": 573119998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052394592,
    "dropsitcph": 6052394592,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A470",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "426 OGLALA LOOP",
    "dropdelcty": "ALLEN",
    "dropdelst": "SD",
    "dropdelzpp": 577149998,
    "dropphyadd": "426 OGLALA LOOP",
    "dropphycty": "ALLEN",
    "dropphyst": "SD",
    "dropphyzpp": 577149998,
    "dropmaladd": "426 OGLALA LOOP",
    "dropmalcty": "ALLEN",
    "dropmalst": "SD",
    "dropmalzpp": 577149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054552592,
    "dropsitcph": 6054552592,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A471",
    "droptype": "D",
    "dropname": "ALPENA",
    "dropdeladd": "818 MAIN ST",
    "dropdelcty": "ALPENA",
    "dropdelst": "SD",
    "dropdelzpp": 573129998,
    "dropphyadd": "818 MAIN ST",
    "dropphycty": "ALPENA",
    "dropphyst": "SD",
    "dropphyzpp": 573129998,
    "dropmaladd": "818 MAIN ST",
    "dropmalcty": "ALPENA",
    "dropmalst": "SD",
    "dropmalzpp": 573129998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058493305,
    "dropsitcph": 6058493305,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A480",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "SD",
    "dropdelzpp": 574229998,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "SD",
    "dropphyzpp": 574229998,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "SD",
    "dropmalzpp": 574229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052985636,
    "dropsitcph": 6052985636,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A484",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "110 S MAIN ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "SD",
    "dropdelzpp": 572129998,
    "dropphyadd": "110 S MAIN ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "SD",
    "dropphyzpp": 572129998,
    "dropmaladd": "110 S MAIN ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "SD",
    "dropmalzpp": 572129998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059835442,
    "dropsitcph": 6059835442,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A485",
    "droptype": "D",
    "dropname": "ARMOUR",
    "dropdeladd": "814 MAIN AVE",
    "dropdelcty": "ARMOUR",
    "dropdelst": "SD",
    "dropdelzpp": 573139998,
    "dropphyadd": "814 MAIN AVE",
    "dropphycty": "ARMOUR",
    "dropphyst": "SD",
    "dropphyzpp": 573139998,
    "dropmaladd": "814 MAIN AVE",
    "dropmalcty": "ARMOUR",
    "dropmalst": "SD",
    "dropmalzpp": 573139998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057242227,
    "dropsitcph": 6057242227,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A488",
    "droptype": "D",
    "dropname": "ARTESIAN",
    "dropdeladd": "225 N MAIN ST",
    "dropdelcty": "ARTESIAN",
    "dropdelst": "SD",
    "dropdelzpp": 573149998,
    "dropphyadd": "225 N MAIN ST",
    "dropphycty": "ARTESIAN",
    "dropphyst": "SD",
    "dropphyzpp": 573149998,
    "dropmaladd": "225 N MAIN ST",
    "dropmalcty": "ARTESIAN",
    "dropmalst": "SD",
    "dropmalzpp": 573149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055272478,
    "dropsitcph": 6055272478,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A489",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "ASHTON",
    "dropdelst": "SD",
    "dropdelzpp": 574249998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "ASHTON",
    "dropphyst": "SD",
    "dropphyzpp": 574249998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "ASHTON",
    "dropmalst": "SD",
    "dropmalzpp": 574249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054722114,
    "dropsitcph": 6054722114,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A490",
    "droptype": "D",
    "dropname": "ASTORIA",
    "dropdeladd": "331 MAIN ST",
    "dropdelcty": "ASTORIA",
    "dropdelst": "SD",
    "dropdelzpp": 572139998,
    "dropphyadd": "331 MAIN ST",
    "dropphycty": "ASTORIA",
    "dropphyst": "SD",
    "dropphyzpp": 572139998,
    "dropmaladd": "331 MAIN ST",
    "dropmalcty": "ASTORIA",
    "dropmalst": "SD",
    "dropmalzpp": 572139998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058324411,
    "dropsitcph": 6058324411,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A496",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "219 N BROADWAY ST",
    "dropdelcty": "AURORA",
    "dropdelst": "SD",
    "dropdelzpp": 570029998,
    "dropphyadd": "219 N BROADWAY ST",
    "dropphycty": "AURORA",
    "dropphyst": "SD",
    "dropphyzpp": 570029998,
    "dropmaladd": "219 N BROADWAY ST",
    "dropmalcty": "AURORA",
    "dropmalst": "SD",
    "dropmalzpp": 570029998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056933308,
    "dropsitcph": 6056933308,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A498",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "129 MAIN ST N",
    "dropdelcty": "AVON",
    "dropdelst": "SD",
    "dropdelzpp": 573159998,
    "dropphyadd": "129 MAIN ST N",
    "dropphycty": "AVON",
    "dropphyst": "SD",
    "dropphyzpp": 573159998,
    "dropmaladd": "129 MAIN ST N",
    "dropmalcty": "AVON",
    "dropmalst": "SD",
    "dropmalzpp": 573159998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052863922,
    "dropsitcph": 6052863922,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A500",
    "droptype": "D",
    "dropname": "BADGER",
    "dropdeladd": "319 E MAIN ST",
    "dropdelcty": "BADGER",
    "dropdelst": "SD",
    "dropdelzpp": 572149998,
    "dropphyadd": "319 E MAIN ST",
    "dropphycty": "BADGER",
    "dropphyst": "SD",
    "dropphyzpp": 572149998,
    "dropmaladd": "319 E MAIN ST",
    "dropmalcty": "BADGER",
    "dropmalst": "SD",
    "dropmalzpp": 572149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059834787,
    "dropsitcph": 6059834787,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A503",
    "droptype": "D",
    "dropname": "BALTIC",
    "dropdeladd": "132 ST OLAF AVE",
    "dropdelcty": "BALTIC",
    "dropdelst": "SD",
    "dropdelzpp": 570039998,
    "dropphyadd": "132 ST OLAF AVE",
    "dropphycty": "BALTIC",
    "dropphyst": "SD",
    "dropphyzpp": 570039998,
    "dropmaladd": "132 ST OLAF AVE",
    "dropmalcty": "BALTIC",
    "dropmalst": "SD",
    "dropmalzpp": 570039998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055295496,
    "dropsitcph": 6055295496,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A505",
    "droptype": "D",
    "dropname": "BARNARD",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "BARNARD",
    "dropdelst": "SD",
    "dropdelzpp": 574269998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "BARNARD",
    "dropphyst": "SD",
    "dropphyzpp": 574269998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "BARNARD",
    "dropmalst": "SD",
    "dropmalzpp": 574269998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053292391,
    "dropsitcph": 6056050119,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A506",
    "droptype": "D",
    "dropname": "BATESLAND",
    "dropdeladd": "100 ASH ST",
    "dropdelcty": "BATESLAND",
    "dropdelst": "SD",
    "dropdelzpp": 577169998,
    "dropphyadd": "100 ASH ST",
    "dropphycty": "BATESLAND",
    "dropphyst": "SD",
    "dropphyzpp": 577169998,
    "dropmaladd": "100 ASH ST",
    "dropmalcty": "BATESLAND",
    "dropmalst": "SD",
    "dropmalzpp": 577169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052881823,
    "dropsitcph": 6052881823,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A507",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "303 S MAIN ST",
    "dropdelcty": "BATH",
    "dropdelst": "SD",
    "dropdelzpp": 574279998,
    "dropphyadd": "303 S MAIN ST",
    "dropphycty": "BATH",
    "dropphyst": "SD",
    "dropphyzpp": 574279998,
    "dropmaladd": "303 S MAIN ST",
    "dropmalcty": "BATH",
    "dropmalst": "SD",
    "dropmalzpp": 574279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052257775,
    "dropsitcph": 6052257775,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A511",
    "droptype": "D",
    "dropname": "BELLE FOURCHE",
    "dropdeladd": "804 STATE ST",
    "dropdelcty": "BELLE FOURCHE",
    "dropdelst": "SD",
    "dropdelzpp": 577179998,
    "dropphyadd": "804 STATE ST",
    "dropphycty": "BELLE FOURCHE",
    "dropphyst": "SD",
    "dropphyzpp": 577179998,
    "dropmaladd": "804 STATE ST",
    "dropmalcty": "BELLE FOURCHE",
    "dropmalst": "SD",
    "dropmalzpp": 577179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058922815,
    "dropsitcph": 6058922815,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A512",
    "droptype": "D",
    "dropname": "BELVIDERE",
    "dropdeladd": "406 B ST",
    "dropdelcty": "BELVIDERE",
    "dropdelst": "SD",
    "dropdelzpp": 575219998,
    "dropphyadd": "406 B ST",
    "dropphycty": "BELVIDERE",
    "dropphyst": "SD",
    "dropphyzpp": 575219998,
    "dropmaladd": "406 B ST",
    "dropmalcty": "BELVIDERE",
    "dropmalst": "SD",
    "dropmalzpp": 575219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053442278,
    "dropsitcph": 6053442278,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A516",
    "droptype": "D",
    "dropname": "BERESFORD",
    "dropdeladd": "100 S 3RD ST",
    "dropdelcty": "BERESFORD",
    "dropdelst": "SD",
    "dropdelzpp": 570049998,
    "dropphyadd": "100 S 3RD ST",
    "dropphycty": "BERESFORD",
    "dropphyst": "SD",
    "dropphyzpp": 570049998,
    "dropmaladd": "100 S 3RD ST",
    "dropmalcty": "BERESFORD",
    "dropmalst": "SD",
    "dropmalzpp": 570049998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057632862,
    "dropsitcph": 6057632862,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A521",
    "droptype": "D",
    "dropname": "BIG STONE CITY",
    "dropdeladd": "650 MAIN ST STE A",
    "dropdelcty": "BIG STONE CITY",
    "dropdelst": "SD",
    "dropdelzpp": 572162226,
    "dropphyadd": "650 MAIN ST STE A",
    "dropphycty": "BIG STONE CITY",
    "dropphyst": "SD",
    "dropphyzpp": 572162226,
    "dropmaladd": "650 MAIN ST STE A",
    "dropmalcty": "BIG STONE CITY",
    "dropmalst": "SD",
    "dropmalzpp": 572162226,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058628396,
    "dropsitcph": 6058628396,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A524",
    "droptype": "D",
    "dropname": "BISON",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "BISON",
    "dropdelst": "SD",
    "dropdelzpp": 576209998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "BISON",
    "dropphyst": "SD",
    "dropphyzpp": 576209998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "BISON",
    "dropmalst": "SD",
    "dropmalzpp": 576209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052445440,
    "dropsitcph": 6052445440,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A526",
    "droptype": "D",
    "dropname": "BLACK HAWK",
    "dropdeladd": "7501 CAPTAIN SOELZER ST",
    "dropdelcty": "BLACK HAWK",
    "dropdelst": "SD",
    "dropdelzpp": 577189998,
    "dropphyadd": "7501 CAPTAIN SOELZER ST",
    "dropphycty": "BLACK HAWK",
    "dropphyst": "SD",
    "dropphyzpp": 577189998,
    "dropmaladd": "7501 CAPTAIN SOELZER ST",
    "dropmalcty": "BLACK HAWK",
    "dropmalst": "SD",
    "dropmalzpp": 577189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057875268,
    "dropsitcph": 6057875268,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A532",
    "droptype": "D",
    "dropname": "BLUNT",
    "dropdeladd": "301 N MAIN ST",
    "dropdelcty": "BLUNT",
    "dropdelst": "SD",
    "dropdelzpp": 575229998,
    "dropphyadd": "301 N MAIN ST",
    "dropphycty": "BLUNT",
    "dropphyst": "SD",
    "dropphyzpp": 575229998,
    "dropmaladd": "301 N MAIN ST",
    "dropmalcty": "BLUNT",
    "dropmalst": "SD",
    "dropmalzpp": 575229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059626217,
    "dropsitcph": 6059626217,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A533",
    "droptype": "D",
    "dropname": "BONESTEEL",
    "dropdeladd": "405 MELLETTE ST",
    "dropdelcty": "BONESTEEL",
    "dropdelst": "SD",
    "dropdelzpp": 573179998,
    "dropphyadd": "405 MELLETTE ST",
    "dropphycty": "BONESTEEL",
    "dropphyst": "SD",
    "dropphyzpp": 573179998,
    "dropmaladd": "405 MELLETTE ST",
    "dropmalcty": "BONESTEEL",
    "dropmalst": "SD",
    "dropmalzpp": 573179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056542532,
    "dropsitcph": 6056542532,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A536",
    "droptype": "D",
    "dropname": "BOWDLE",
    "dropdeladd": "2086 MAIN ST",
    "dropdelcty": "BOWDLE",
    "dropdelst": "SD",
    "dropdelzpp": 574289998,
    "dropphyadd": "2086 MAIN ST",
    "dropphycty": "BOWDLE",
    "dropphyst": "SD",
    "dropphyzpp": 574289998,
    "dropmaladd": "2086 MAIN ST",
    "dropmalcty": "BOWDLE",
    "dropmalst": "SD",
    "dropmalzpp": 574289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052856262,
    "dropsitcph": 6052856262,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A537",
    "droptype": "D",
    "dropname": "BOX ELDER",
    "dropdeladd": "511 N ELLSWORTH RD",
    "dropdelcty": "BOX ELDER",
    "dropdelst": "SD",
    "dropdelzpp": 577199998,
    "dropphyadd": "511 N ELLSWORTH RD",
    "dropphycty": "BOX ELDER",
    "dropphyst": "SD",
    "dropphyzpp": 577199998,
    "dropmaladd": "511 N ELLSWORTH RD",
    "dropmalcty": "BOX ELDER",
    "dropmalst": "SD",
    "dropmalzpp": 577199998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059232484,
    "dropsitcph": 6059232484,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A538",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "SD",
    "dropdelzpp": 572179998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "SD",
    "dropphyzpp": 572179998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "SD",
    "dropmalzpp": 572179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057843461,
    "dropsitcph": 6057843461,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A540",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "1420 E ASPEN BLVD",
    "dropdelcty": "BRANDON",
    "dropdelst": "SD",
    "dropdelzpp": 570059998,
    "dropphyadd": "1420 E ASPEN BLVD",
    "dropphycty": "BRANDON",
    "dropphyst": "SD",
    "dropphyzpp": 570059998,
    "dropmaladd": "1420 E ASPEN BLVD",
    "dropmalcty": "BRANDON",
    "dropmalst": "SD",
    "dropmalzpp": 570059998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055826062,
    "dropsitcph": 6055826062,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A541",
    "droptype": "D",
    "dropname": "BRANDT",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "BRANDT",
    "dropdelst": "SD",
    "dropdelzpp": 572189998,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "BRANDT",
    "dropphyst": "SD",
    "dropphyzpp": 572189998,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "BRANDT",
    "dropmalst": "SD",
    "dropmalzpp": 572189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058762901,
    "dropsitcph": 6058762901,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A542",
    "droptype": "D",
    "dropname": "BRENTFORD",
    "dropdeladd": "101 W 4TH ST",
    "dropdelcty": "BRENTFORD",
    "dropdelst": "SD",
    "dropdelzpp": 574299998,
    "dropphyadd": "101 W 4TH ST",
    "dropphycty": "BRENTFORD",
    "dropphyst": "SD",
    "dropphyzpp": 574299998,
    "dropmaladd": "101 W 4TH ST",
    "dropmalcty": "BRENTFORD",
    "dropmalst": "SD",
    "dropmalzpp": 574299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058873560,
    "dropsitcph": 6058873560,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A544",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "235 N MAIN AVE",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "SD",
    "dropdelzpp": 573199998,
    "dropphyadd": "235 N MAIN AVE",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "SD",
    "dropphyzpp": 573199998,
    "dropmaladd": "235 N MAIN AVE",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "SD",
    "dropmalzpp": 573199998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057292352,
    "dropsitcph": 6057292352,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A545",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "116 MAIN ST S",
    "dropdelcty": "BRISTOL",
    "dropdelst": "SD",
    "dropdelzpp": 572199998,
    "dropphyadd": "116 MAIN ST S",
    "dropphycty": "BRISTOL",
    "dropphyst": "SD",
    "dropphyzpp": 572199998,
    "dropmaladd": "116 MAIN ST S",
    "dropmalcty": "BRISTOL",
    "dropmalst": "SD",
    "dropmalzpp": 572199998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054923212,
    "dropsitcph": 6054923212,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A546",
    "droptype": "D",
    "dropname": "BRITTON",
    "dropdeladd": "605 MAIN AVE",
    "dropdelcty": "BRITTON",
    "dropdelst": "SD",
    "dropdelzpp": 574309998,
    "dropphyadd": "605 MAIN AVE",
    "dropphycty": "BRITTON",
    "dropphyst": "SD",
    "dropphyzpp": 574309998,
    "dropmaladd": "605 MAIN AVE",
    "dropmalcty": "BRITTON",
    "dropmalst": "SD",
    "dropmalzpp": 574309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059831355,
    "dropsitcph": 6059831355,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A548",
    "droptype": "D",
    "dropname": "BROOKINGS",
    "dropdeladd": "500 MAIN AVE",
    "dropdelcty": "BROOKINGS",
    "dropdelst": "SD",
    "dropdelzpp": 570069998,
    "dropphyadd": "500 MAIN AVE",
    "dropphycty": "BROOKINGS",
    "dropphyst": "SD",
    "dropphyzpp": 570069998,
    "dropmaladd": "500 MAIN AVE",
    "dropmalcty": "BROOKINGS",
    "dropmalst": "SD",
    "dropmalzpp": 570069998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056924735,
    "dropsitcph": 6056924735,
    "dropfax": 6056928164
  },
  {
    "dcode": "D",
    "dropkey": "PW1A549",
    "droptype": "D",
    "dropname": "BRUCE",
    "dropdeladd": "508 JEFFERSON ST",
    "dropdelcty": "BRUCE",
    "dropdelst": "SD",
    "dropdelzpp": 572209998,
    "dropphyadd": "508 JEFFERSON ST",
    "dropphycty": "BRUCE",
    "dropphyst": "SD",
    "dropphyzpp": 572209998,
    "dropmaladd": "508 JEFFERSON ST",
    "dropmalcty": "BRUCE",
    "dropmalst": "SD",
    "dropmalzpp": 572209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056275470,
    "dropsitcph": 6056275470,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A550",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "114 MAIN ST W",
    "dropdelcty": "BRYANT",
    "dropdelst": "SD",
    "dropdelzpp": 572219998,
    "dropphyadd": "114 MAIN ST W",
    "dropphycty": "BRYANT",
    "dropphyst": "SD",
    "dropphyzpp": 572219998,
    "dropmaladd": "114 MAIN ST W",
    "dropmalcty": "BRYANT",
    "dropmalst": "SD",
    "dropmalzpp": 572219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056282581,
    "dropsitcph": 6056282581,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A551",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "109 1ST ST W",
    "dropdelcty": "BUFFALO",
    "dropdelst": "SD",
    "dropdelzpp": 577209998,
    "dropphyadd": "109 1ST ST W",
    "dropphycty": "BUFFALO",
    "dropphyst": "SD",
    "dropphyzpp": 577209998,
    "dropmaladd": "109 1ST ST W",
    "dropmalcty": "BUFFALO",
    "dropmalst": "SD",
    "dropmalzpp": 577209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053753236,
    "dropsitcph": 6053753236,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A552",
    "droptype": "D",
    "dropname": "BUFFALO GAP",
    "dropdeladd": "200 N WALNUT ST",
    "dropdelcty": "BUFFALO GAP",
    "dropdelst": "SD",
    "dropdelzpp": 577229998,
    "dropphyadd": "200 N WALNUT ST",
    "dropphycty": "BUFFALO GAP",
    "dropphyst": "SD",
    "dropphyzpp": 577229998,
    "dropmaladd": "200 N WALNUT ST",
    "dropmalcty": "BUFFALO GAP",
    "dropmalst": "SD",
    "dropmalzpp": 577229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059820743,
    "dropsitcph": 6059820743,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A554",
    "droptype": "D",
    "dropname": "BULLHEAD",
    "dropdeladd": "104 TASUNKA ST",
    "dropdelcty": "BULLHEAD",
    "dropdelst": "SD",
    "dropdelzpp": 576219998,
    "dropphyadd": "104 TASUNKA ST",
    "dropphycty": "BULLHEAD",
    "dropphyst": "SD",
    "dropphyzpp": 576219998,
    "dropmaladd": "104 TASUNKA ST",
    "dropmalcty": "BULLHEAD",
    "dropmalst": "SD",
    "dropmalzpp": 576219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058234397,
    "dropsitcph": 6058234397,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A558",
    "droptype": "D",
    "dropname": "BURKE",
    "dropdeladd": "833 MAIN ST",
    "dropdelcty": "BURKE",
    "dropdelst": "SD",
    "dropdelzpp": 575239998,
    "dropphyadd": "833 MAIN ST",
    "dropphycty": "BURKE",
    "dropphyst": "SD",
    "dropphyzpp": 575239998,
    "dropmaladd": "833 MAIN ST",
    "dropmalcty": "BURKE",
    "dropmalst": "SD",
    "dropmalzpp": 575239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057752362,
    "dropsitcph": 6057752362,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A564",
    "droptype": "D",
    "dropname": "CAMP CROOK",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "CAMP CROOK",
    "dropdelst": "SD",
    "dropdelzpp": 577249998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "CAMP CROOK",
    "dropphyst": "SD",
    "dropphyzpp": 577249998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "CAMP CROOK",
    "dropmalst": "SD",
    "dropmalzpp": 577249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057974401,
    "dropsitcph": 6057974401,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A567",
    "droptype": "D",
    "dropname": "CANISTOTA",
    "dropdeladd": "222 W MAIN ST",
    "dropdelcty": "CANISTOTA",
    "dropdelst": "SD",
    "dropdelzpp": 570129998,
    "dropphyadd": "222 W MAIN ST",
    "dropphycty": "CANISTOTA",
    "dropphyst": "SD",
    "dropphyzpp": 570129998,
    "dropmaladd": "222 W MAIN ST",
    "dropmalcty": "CANISTOTA",
    "dropmalst": "SD",
    "dropmalzpp": 570129998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052963392,
    "dropsitcph": 6052963392,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A569",
    "droptype": "D",
    "dropname": "CANOVA",
    "dropdeladd": "120 MAIN ST W",
    "dropdelcty": "CANOVA",
    "dropdelst": "SD",
    "dropdelzpp": 573219998,
    "dropphyadd": "120 MAIN ST W",
    "dropphycty": "CANOVA",
    "dropphyst": "SD",
    "dropphyzpp": 573219998,
    "dropmaladd": "120 MAIN ST W",
    "dropmalcty": "CANOVA",
    "dropmalst": "SD",
    "dropmalzpp": 573219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055232287,
    "dropsitcph": 6055232287,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A570",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "315 E 5TH ST",
    "dropdelcty": "CANTON",
    "dropdelst": "SD",
    "dropdelzpp": 570139998,
    "dropphyadd": "315 E 5TH ST",
    "dropphycty": "CANTON",
    "dropphyst": "SD",
    "dropphyzpp": 570139998,
    "dropmaladd": "315 E 5TH ST",
    "dropmalcty": "CANTON",
    "dropmalst": "SD",
    "dropmalzpp": 570139998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6509878032,
    "dropsitcph": 6059878032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A572",
    "droptype": "D",
    "dropname": "CAPUTA",
    "dropdeladd": "23502 MAIN ST",
    "dropdelcty": "CAPUTA",
    "dropdelst": "SD",
    "dropdelzpp": 577259998,
    "dropphyadd": "23502 MAIN ST",
    "dropphycty": "CAPUTA",
    "dropphyst": "SD",
    "dropphyzpp": 577259998,
    "dropmaladd": "23502 MAIN ST",
    "dropmalcty": "CAPUTA",
    "dropmalst": "SD",
    "dropmalzpp": 577259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053931688,
    "dropsitcph": 6053931688,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A574",
    "droptype": "D",
    "dropname": "CARPENTER",
    "dropdeladd": "531 415TH AVE",
    "dropdelcty": "CARPENTER",
    "dropdelst": "SD",
    "dropdelzpp": 573229998,
    "dropphyadd": "531 415TH AVE",
    "dropphycty": "CARPENTER",
    "dropphyst": "SD",
    "dropphyzpp": 573229998,
    "dropmaladd": "531 415TH AVE",
    "dropmalcty": "CARPENTER",
    "dropmalst": "SD",
    "dropmalzpp": 573229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053527626,
    "dropsitcph": 6053527626,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A576",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "121 MAIN ST E",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "SD",
    "dropdelzpp": 573239998,
    "dropphyadd": "121 MAIN ST E",
    "dropphycty": "CARTHAGE",
    "dropphyst": "SD",
    "dropphyzpp": 573239998,
    "dropmaladd": "121 MAIN ST E",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "SD",
    "dropmalzpp": 573239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057724861,
    "dropsitcph": 6057724861,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A579",
    "droptype": "D",
    "dropname": "CASTLEWOOD",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "CASTLEWOOD",
    "dropdelst": "SD",
    "dropdelzpp": 572239998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "CASTLEWOOD",
    "dropphyst": "SD",
    "dropphyzpp": 572239998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "CASTLEWOOD",
    "dropmalst": "SD",
    "dropmalzpp": 572239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057932658,
    "dropsitcph": 6057932658,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A580",
    "droptype": "D",
    "dropname": "CAVOUR",
    "dropdeladd": "391 SOLFERINO ST",
    "dropdelcty": "CAVOUR",
    "dropdelst": "SD",
    "dropdelzpp": 573249998,
    "dropphyadd": "391 SOLFERINO ST",
    "dropphycty": "CAVOUR",
    "dropphyst": "SD",
    "dropphyzpp": 573249998,
    "dropmaladd": "391 SOLFERINO ST",
    "dropmalcty": "CAVOUR",
    "dropmalst": "SD",
    "dropmalzpp": 573249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055992842,
    "dropsitcph": 6055992842,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A585",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "533 BROADWAY ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "SD",
    "dropdelzpp": 570149998,
    "dropphyadd": "533 BROADWAY ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "SD",
    "dropphyzpp": 570149998,
    "dropmaladd": "533 BROADWAY ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "SD",
    "dropmalzpp": 570149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053574930,
    "dropsitcph": 6055632321,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A588",
    "droptype": "D",
    "dropname": "CHAMBERLAIN",
    "dropdeladd": "108 N SANBORN ST",
    "dropdelcty": "CHAMBERLAIN",
    "dropdelst": "SD",
    "dropdelzpp": 573259998,
    "dropphyadd": "108 N SANBORN ST",
    "dropphycty": "CHAMBERLAIN",
    "dropphyst": "SD",
    "dropphyzpp": 573259998,
    "dropmaladd": "108 N SANBORN ST",
    "dropmalcty": "CHAMBERLAIN",
    "dropmalst": "SD",
    "dropmalzpp": 573259998,
    "dropsitphn": "",
    "dropsitlph": 6057342392,
    "dropsitcph": 6057342392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A590",
    "droptype": "D",
    "dropname": "CHANCELLOR",
    "dropdeladd": "224 MAIN ST",
    "dropdelcty": "CHANCELLOR",
    "dropdelst": "SD",
    "dropdelzpp": 570159998,
    "dropphyadd": "224 MAIN ST",
    "dropphycty": "CHANCELLOR",
    "dropphyst": "SD",
    "dropphyzpp": 570159998,
    "dropmaladd": "224 MAIN ST",
    "dropmalcty": "CHANCELLOR",
    "dropmalst": "SD",
    "dropmalzpp": 570159998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056671530,
    "dropsitcph": 6056671530,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A593",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "410 4TH ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "SD",
    "dropdelzpp": 570169998,
    "dropphyadd": "410 4TH ST",
    "dropphycty": "CHESTER",
    "dropphyst": "SD",
    "dropphyzpp": 570169998,
    "dropmaladd": "410 4TH ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "SD",
    "dropmalzpp": 570169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054892261,
    "dropsitcph": 6054892261,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A596",
    "droptype": "D",
    "dropname": "CLAIRE CITY",
    "dropdeladd": "270 MAIN ST",
    "dropdelcty": "CLAIRE CITY",
    "dropdelst": "SD",
    "dropdelzpp": 572249998,
    "dropphyadd": "270 MAIN ST",
    "dropphycty": "CLAIRE CITY",
    "dropphyst": "SD",
    "dropphyzpp": 572249998,
    "dropmaladd": "270 MAIN ST",
    "dropmalcty": "CLAIRE CITY",
    "dropmalst": "SD",
    "dropmalzpp": 572249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056524613,
    "dropsitcph": 6056524613,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A598",
    "droptype": "D",
    "dropname": "CLARK",
    "dropdeladd": "111 N SMITH ST",
    "dropdelcty": "CLARK",
    "dropdelst": "SD",
    "dropdelzpp": 572259998,
    "dropphyadd": "111 N SMITH ST",
    "dropphycty": "CLARK",
    "dropphyst": "SD",
    "dropphyzpp": 572259998,
    "dropmaladd": "111 N SMITH ST",
    "dropmalcty": "CLARK",
    "dropmalst": "SD",
    "dropmalzpp": 572259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055323771,
    "dropsitcph": 6055323771,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A601",
    "droptype": "D",
    "dropname": "CLEAR LAKE",
    "dropdeladd": "405 3RD ST W",
    "dropdelcty": "CLEAR LAKE",
    "dropdelst": "SD",
    "dropdelzpp": 572269998,
    "dropphyadd": "405 3RD ST W",
    "dropphycty": "CLEAR LAKE",
    "dropphyst": "SD",
    "dropphyzpp": 572269998,
    "dropmaladd": "405 3RD ST W",
    "dropmalcty": "CLEAR LAKE",
    "dropmalst": "SD",
    "dropmalzpp": 572269998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058742402,
    "dropsitcph": 6058742402,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A606",
    "droptype": "D",
    "dropname": "COLMAN",
    "dropdeladd": "129 N MAIN ST",
    "dropdelcty": "COLMAN",
    "dropdelst": "SD",
    "dropdelzpp": 570179998,
    "dropphyadd": "129 N MAIN ST",
    "dropphycty": "COLMAN",
    "dropphyst": "SD",
    "dropphyzpp": 570179998,
    "dropmaladd": "129 N MAIN ST",
    "dropmalcty": "COLMAN",
    "dropmalst": "SD",
    "dropmalzpp": 570179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055343521,
    "dropsitcph": 6055343521,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A607",
    "droptype": "D",
    "dropname": "COLOME",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "COLOME",
    "dropdelst": "SD",
    "dropdelzpp": 575289998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "COLOME",
    "dropphyst": "SD",
    "dropphyzpp": 575289998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "COLOME",
    "dropmalst": "SD",
    "dropmalzpp": 575289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058421832,
    "dropsitcph": 6058421832,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A608",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "213 E 4TH ST",
    "dropdelcty": "COLTON",
    "dropdelst": "SD",
    "dropdelzpp": 570189998,
    "dropphyadd": "213 E 4TH ST",
    "dropphycty": "COLTON",
    "dropphyst": "SD",
    "dropphyzpp": 570189998,
    "dropmaladd": "213 E 4TH ST",
    "dropmalcty": "COLTON",
    "dropmalst": "SD",
    "dropmalzpp": 570189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 3056633026,
    "dropsitcph": 6056633026,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A609",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "5 N BROADWAY ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SD",
    "dropdelzpp": 574339998,
    "dropphyadd": "5 N BROADWAY ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SD",
    "dropphyzpp": 574339998,
    "dropmaladd": "5 N BROADWAY ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SD",
    "dropmalzpp": 574339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053962664,
    "dropsitcph": 6053962664,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A612",
    "droptype": "D",
    "dropname": "CONDE",
    "dropdeladd": "180 BROADWAY ST NE",
    "dropdelcty": "CONDE",
    "dropdelst": "SD",
    "dropdelzpp": 574349998,
    "dropphyadd": "180 BROADWAY ST NE",
    "dropphycty": "CONDE",
    "dropphyst": "SD",
    "dropphyzpp": 574349998,
    "dropmaladd": "180 BROADWAY ST NE",
    "dropmalcty": "CONDE",
    "dropmalst": "SD",
    "dropmalzpp": 574349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053825855,
    "dropsitcph": 6053825855,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A615",
    "droptype": "D",
    "dropname": "CORONA",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "CORONA",
    "dropdelst": "SD",
    "dropdelzpp": 572279998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "CORONA",
    "dropphyst": "SD",
    "dropphyzpp": 572279998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "CORONA",
    "dropmalst": "SD",
    "dropmalzpp": 572279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054344194,
    "dropsitcph": 6054344194,
    "dropfax": 6054349263
  },
  {
    "dcode": "D",
    "dropkey": "PW1A616",
    "droptype": "D",
    "dropname": "CORSICA",
    "dropdeladd": "225 E MAIN ST",
    "dropdelcty": "CORSICA",
    "dropdelst": "SD",
    "dropdelzpp": 573289998,
    "dropphyadd": "225 E MAIN ST",
    "dropphycty": "CORSICA",
    "dropphyst": "SD",
    "dropphyzpp": 573289998,
    "dropmaladd": "225 E MAIN ST",
    "dropmalcty": "CORSICA",
    "dropmalst": "SD",
    "dropmalzpp": 573289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059465284,
    "dropsitcph": 6059465284,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A623",
    "droptype": "D",
    "dropname": "CRESBARD",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "CRESBARD",
    "dropdelst": "SD",
    "dropdelzpp": 574359998,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "CRESBARD",
    "dropphyst": "SD",
    "dropphyzpp": 574359998,
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "CRESBARD",
    "dropmalst": "SD",
    "dropmalzpp": 574359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053243664,
    "dropsitcph": 6053243664,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A625",
    "droptype": "D",
    "dropname": "CROOKS",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "CROOKS",
    "dropdelst": "SD",
    "dropdelzpp": 570209998,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "CROOKS",
    "dropphyst": "SD",
    "dropphyzpp": 570209998,
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "CROOKS",
    "dropmalst": "SD",
    "dropmalzpp": 570209998,
    "dropsitphn": 6053494455,
    "dropsitlph": 6053494455,
    "dropsitcph": 6053494455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A627",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "643 MOUNT RUSHMORE RD",
    "dropdelcty": "CUSTER",
    "dropdelst": "SD",
    "dropdelzpp": 577309998,
    "dropphyadd": "643 MOUNT RUSHMORE RD",
    "dropphycty": "CUSTER",
    "dropphyst": "SD",
    "dropphyzpp": 577309998,
    "dropmaladd": "643 MOUNT RUSHMORE RD",
    "dropmalcty": "CUSTER",
    "dropmalst": "SD",
    "dropmalzpp": 577309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056734248,
    "dropsitcph": 6056734248,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A636",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "110 E US HIGHWAY 18",
    "dropdelcty": "DAVIS",
    "dropdelst": "SD",
    "dropdelzpp": 570219998,
    "dropphyadd": "110 E US HIGHWAY 18",
    "dropphycty": "DAVIS",
    "dropphyst": "SD",
    "dropphyzpp": 570219998,
    "dropmaladd": "110 E US HIGHWAY 18",
    "dropmalcty": "DAVIS",
    "dropmalst": "SD",
    "dropmalzpp": 570219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052385396,
    "dropsitcph": 6052385396,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A637",
    "droptype": "D",
    "dropname": "DE SMET",
    "dropdeladd": "119 CALUMET AVE SW",
    "dropdelcty": "DE SMET",
    "dropdelst": "SD",
    "dropdelzpp": 572319998,
    "dropphyadd": "119 CALUMET AVE SW",
    "dropphycty": "DE SMET",
    "dropphyst": "SD",
    "dropphyzpp": 572319998,
    "dropmaladd": "119 CALUMET AVE SW",
    "dropmalcty": "DE SMET",
    "dropmalst": "SD",
    "dropmalzpp": 572319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058543440,
    "dropsitcph": 6058543440,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A638",
    "droptype": "D",
    "dropname": "DEADWOOD",
    "dropdeladd": "68 SHERMAN ST",
    "dropdelcty": "DEADWOOD",
    "dropdelst": "SD",
    "dropdelzpp": 577329998,
    "dropphyadd": "68 SHERMAN ST",
    "dropphycty": "DEADWOOD",
    "dropphyst": "SD",
    "dropphyzpp": 577329998,
    "dropmaladd": "68 SHERMAN ST",
    "dropmalcty": "DEADWOOD",
    "dropmalst": "SD",
    "dropmalzpp": 577329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055781505,
    "dropsitcph": 6055781505,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A641",
    "droptype": "D",
    "dropname": "DELL RAPIDS",
    "dropdeladd": "305 E 4TH ST",
    "dropdelcty": "DELL RAPIDS",
    "dropdelst": "SD",
    "dropdelzpp": 570229998,
    "dropphyadd": "305 E 4TH ST",
    "dropphycty": "DELL RAPIDS",
    "dropphyst": "SD",
    "dropphyzpp": 570229998,
    "dropmaladd": "305 E 4TH ST",
    "dropmalcty": "DELL RAPIDS",
    "dropmalst": "SD",
    "dropmalzpp": 570229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052778153,
    "dropsitcph": 6052778153,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A642",
    "droptype": "D",
    "dropname": "DELMONT",
    "dropdeladd": "109 W MAIN ST",
    "dropdelcty": "DELMONT",
    "dropdelst": "SD",
    "dropdelzpp": 573309998,
    "dropphyadd": "109 W MAIN ST",
    "dropphycty": "DELMONT",
    "dropphyst": "SD",
    "dropphyzpp": 573309998,
    "dropmaladd": "109 W MAIN ST",
    "dropmalcty": "DELMONT",
    "dropmalst": "SD",
    "dropmalzpp": 573309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057792811,
    "dropsitcph": 6057792811,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A646",
    "droptype": "D",
    "dropname": "DIMOCK",
    "dropdeladd": "501 S MAIN ST",
    "dropdelcty": "DIMOCK",
    "dropdelst": "SD",
    "dropdelzpp": 573319998,
    "dropphyadd": "501 S MAIN ST",
    "dropphycty": "DIMOCK",
    "dropphyst": "SD",
    "dropphyzpp": 573319998,
    "dropmaladd": "501 S MAIN ST",
    "dropmalcty": "DIMOCK",
    "dropmalst": "SD",
    "dropmalzpp": 573319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059283831,
    "dropsitcph": 6059283831,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A648",
    "droptype": "D",
    "dropname": "DOLAND",
    "dropdeladd": "204 HUMPHREY DR N",
    "dropdelcty": "DOLAND",
    "dropdelst": "SD",
    "dropdelzpp": 574369998,
    "dropphyadd": "204 HUMPHREY DR N",
    "dropphycty": "DOLAND",
    "dropphyst": "SD",
    "dropphyzpp": 574369998,
    "dropmaladd": "204 HUMPHREY DR N",
    "dropmalcty": "DOLAND",
    "dropmalst": "SD",
    "dropmalzpp": 574369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056356921,
    "dropsitcph": 6056356921,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A652",
    "droptype": "D",
    "dropname": "DRAPER",
    "dropdeladd": "147 S MAIN ST",
    "dropdelcty": "DRAPER",
    "dropdelst": "SD",
    "dropdelzpp": 575319998,
    "dropphyadd": "147 S MAIN ST",
    "dropphycty": "DRAPER",
    "dropphyst": "SD",
    "dropphyzpp": 575319998,
    "dropmaladd": "147 S MAIN ST",
    "dropmalcty": "DRAPER",
    "dropmalst": "SD",
    "dropmalzpp": 575319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056692822,
    "dropsitcph": 6056692822,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A654",
    "droptype": "D",
    "dropname": "DUPREE",
    "dropdeladd": "323 S MAIN ST",
    "dropdelcty": "DUPREE",
    "dropdelst": "SD",
    "dropdelzpp": 576239998,
    "dropphyadd": "323 S MAIN ST",
    "dropphycty": "DUPREE",
    "dropphyst": "SD",
    "dropphyzpp": 576239998,
    "dropmaladd": "323 S MAIN ST",
    "dropmalcty": "DUPREE",
    "dropmalst": "SD",
    "dropmalzpp": 576239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053655110,
    "dropsitcph": 6053655110,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A656",
    "droptype": "D",
    "dropname": "EAGLE BUTTE",
    "dropdeladd": "307 S MAIN ST",
    "dropdelcty": "EAGLE BUTTE",
    "dropdelst": "SD",
    "dropdelzpp": 576259998,
    "dropphyadd": "307 S MAIN ST",
    "dropphycty": "EAGLE BUTTE",
    "dropphyst": "SD",
    "dropphyzpp": 576259998,
    "dropmaladd": "307 S MAIN ST",
    "dropmalcty": "EAGLE BUTTE",
    "dropmalst": "SD",
    "dropmalzpp": 576259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059646633,
    "dropsitcph": 6059646633,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A659",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "108 S 3RD ST",
    "dropdelcty": "EDEN",
    "dropdelst": "SD",
    "dropdelzpp": 572329998,
    "dropphyadd": "108 S 3RD ST",
    "dropphycty": "EDEN",
    "dropphyst": "SD",
    "dropphyzpp": 572329998,
    "dropmaladd": "108 S 3RD ST",
    "dropmalcty": "EDEN",
    "dropmalst": "SD",
    "dropmalzpp": 572329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054864160,
    "dropsitcph": 6054864160,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A660",
    "droptype": "D",
    "dropname": "EDGEMONT",
    "dropdeladd": "519 2ND AVE",
    "dropdelcty": "EDGEMONT",
    "dropdelst": "SD",
    "dropdelzpp": 577359998,
    "dropphyadd": "519 2ND AVE",
    "dropphycty": "EDGEMONT",
    "dropphyst": "SD",
    "dropphyzpp": 577359998,
    "dropmaladd": "519 2ND AVE",
    "dropmalcty": "EDGEMONT",
    "dropmalst": "SD",
    "dropmalzpp": 577359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6505038524,
    "dropsitcph": 6055038524,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A664",
    "droptype": "D",
    "dropname": "ELK POINT",
    "dropdeladd": "123 W MAIN ST",
    "dropdelcty": "ELK POINT",
    "dropdelst": "SD",
    "dropdelzpp": 570259998,
    "dropphyadd": "123 W MAIN ST",
    "dropphycty": "ELK POINT",
    "dropphyst": "SD",
    "dropphyzpp": 570259998,
    "dropmaladd": "123 W MAIN ST",
    "dropmalcty": "ELK POINT",
    "dropmalst": "SD",
    "dropmalzpp": 570259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053562402,
    "dropsitcph": 6053562402,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A665",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "207 ELK ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "SD",
    "dropdelzpp": 570269998,
    "dropphyadd": "207 ELK ST",
    "dropphycty": "ELKTON",
    "dropphyst": "SD",
    "dropphyzpp": 570269998,
    "dropmaladd": "207 ELK ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "SD",
    "dropmalzpp": 570269998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055427401,
    "dropsitcph": 6055427401,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A671",
    "droptype": "D",
    "dropname": "EMERY",
    "dropdeladd": "124 N 3RD ST",
    "dropdelcty": "EMERY",
    "dropdelst": "SD",
    "dropdelzpp": 573329998,
    "dropphyadd": "124 N 3RD ST",
    "dropphycty": "EMERY",
    "dropphyst": "SD",
    "dropphyzpp": 573329998,
    "dropmaladd": "124 N 3RD ST",
    "dropmalcty": "EMERY",
    "dropmalst": "SD",
    "dropmalzpp": 573329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054494323,
    "dropsitcph": 6054494323,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A675",
    "droptype": "D",
    "dropname": "ENNING",
    "dropdeladd": "17500 HIGHWAY 34",
    "dropdelcty": "ENNING",
    "dropdelst": "SD",
    "dropdelzpp": 577379998,
    "dropphyadd": "17500 HIGHWAY 34",
    "dropphycty": "ENNING",
    "dropphyst": "SD",
    "dropphyzpp": 577379998,
    "dropmaladd": "17500 HIGHWAY 34",
    "dropmalcty": "ENNING",
    "dropmalst": "SD",
    "dropmalzpp": 577379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059820102,
    "dropsitcph": 6059820102,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A679",
    "droptype": "D",
    "dropname": "ESTELLINE",
    "dropdeladd": "108 MAIN ST N",
    "dropdelcty": "ESTELLINE",
    "dropdelst": "SD",
    "dropdelzpp": 572349998,
    "dropphyadd": "108 MAIN ST N",
    "dropphycty": "ESTELLINE",
    "dropphyst": "SD",
    "dropphyzpp": 572349998,
    "dropmaladd": "108 MAIN ST N",
    "dropmalcty": "ESTELLINE",
    "dropmalst": "SD",
    "dropmalzpp": 572349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058732433,
    "dropsitcph": 6058732433,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A680",
    "droptype": "D",
    "dropname": "ETHAN",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "ETHAN",
    "dropdelst": "SD",
    "dropdelzpp": 573349998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "ETHAN",
    "dropphyst": "SD",
    "dropphyzpp": 573349998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "ETHAN",
    "dropmalst": "SD",
    "dropmalzpp": 573349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052274343,
    "dropsitcph": 6052274343,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A681",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "709 G AVE",
    "dropdelcty": "EUREKA",
    "dropdelst": "SD",
    "dropdelzpp": 574379998,
    "dropphyadd": "709 G AVE",
    "dropphycty": "EUREKA",
    "dropphyst": "SD",
    "dropphyzpp": 574379998,
    "dropmaladd": "709 G AVE",
    "dropmalcty": "EUREKA",
    "dropmalst": "SD",
    "dropmalzpp": 574379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052842301,
    "dropsitcph": 6052842301,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A683",
    "droptype": "D",
    "dropname": "FAIRBURN",
    "dropdeladd": "120 OAK ST",
    "dropdelcty": "FAIRBURN",
    "dropdelst": "SD",
    "dropdelzpp": 577389998,
    "dropphyadd": "120 OAK ST",
    "dropphycty": "FAIRBURN",
    "dropphyst": "SD",
    "dropphyzpp": 577389998,
    "dropmaladd": "120 OAK ST",
    "dropmalcty": "FAIRBURN",
    "dropmalst": "SD",
    "dropmalzpp": 577389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052554051,
    "dropsitcph": 6052554051,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A684",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "412 MAIN ST",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "SD",
    "dropdelzpp": 573359998,
    "dropphyadd": "412 MAIN ST",
    "dropphycty": "FAIRFAX",
    "dropphyst": "SD",
    "dropphyzpp": 573359998,
    "dropmaladd": "412 MAIN ST",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "SD",
    "dropmalzpp": 573359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056542243,
    "dropsitcph": 6056542243,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A686",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "320 LINCOLN AVE",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "SD",
    "dropdelzpp": 570279998,
    "dropphyadd": "320 LINCOLN AVE",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "SD",
    "dropphyzpp": 570279998,
    "dropmaladd": "320 LINCOLN AVE",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "SD",
    "dropmalzpp": 570279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059874311,
    "dropsitcph": 6059874311,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A687",
    "droptype": "D",
    "dropname": "FAITH",
    "dropdeladd": "114 MAIN ST",
    "dropdelcty": "FAITH",
    "dropdelst": "SD",
    "dropdelzpp": 576269998,
    "dropphyadd": "114 MAIN ST",
    "dropphycty": "FAITH",
    "dropphyst": "SD",
    "dropphyzpp": 576269998,
    "dropmaladd": "114 MAIN ST",
    "dropmalcty": "FAITH",
    "dropmalst": "SD",
    "dropmalzpp": 576269998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059672482,
    "dropsitcph": 6059672482,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A690",
    "droptype": "D",
    "dropname": "FAULKTON",
    "dropdeladd": "115 8TH AVE S",
    "dropdelcty": "FAULKTON",
    "dropdelst": "SD",
    "dropdelzpp": 574389998,
    "dropphyadd": "115 8TH AVE S",
    "dropphycty": "FAULKTON",
    "dropphyst": "SD",
    "dropphyzpp": 574389998,
    "dropmaladd": "115 8TH AVE S",
    "dropmalcty": "FAULKTON",
    "dropmalst": "SD",
    "dropmalzpp": 574389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055984366,
    "dropsitcph": 6055984366,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A694",
    "droptype": "D",
    "dropname": "FLANDREAU",
    "dropdeladd": "102 W 2ND AVE",
    "dropdelcty": "FLANDREAU",
    "dropdelst": "SD",
    "dropdelzpp": 570289998,
    "dropphyadd": "102 W 2ND AVE",
    "dropphycty": "FLANDREAU",
    "dropphyst": "SD",
    "dropphyzpp": 570289998,
    "dropmaladd": "102 W 2ND AVE",
    "dropmalcty": "FLANDREAU",
    "dropmalst": "SD",
    "dropmalzpp": 570289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059973202,
    "dropsitcph": 6059973202,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A696",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "235 MAIN AVE",
    "dropdelcty": "FLORENCE",
    "dropdelst": "SD",
    "dropdelzpp": 572359998,
    "dropphyadd": "235 MAIN AVE",
    "dropphycty": "FLORENCE",
    "dropphyst": "SD",
    "dropphyzpp": 572359998,
    "dropmaladd": "235 MAIN AVE",
    "dropmalcty": "FLORENCE",
    "dropmalst": "SD",
    "dropmalzpp": 572359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057582286,
    "dropsitcph": 6057582286,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A702",
    "droptype": "D",
    "dropname": "FORT MEADE",
    "dropdeladd": "50 SHERIDAN RD",
    "dropdelcty": "FORT MEADE",
    "dropdelst": "SD",
    "dropdelzpp": 577419998,
    "dropphyadd": "50 SHERIDAN RD",
    "dropphycty": "FORT MEADE",
    "dropphyst": "SD",
    "dropphyzpp": 577419998,
    "dropmaladd": "50 SHERIDAN RD",
    "dropmalcty": "FORT MEADE",
    "dropmalst": "SD",
    "dropmalzpp": 577419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057207169,
    "dropsitcph": 6057207169,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A703",
    "droptype": "D",
    "dropname": "FORT PIERRE",
    "dropdeladd": "412 N DEADWOOD ST",
    "dropdelcty": "FORT PIERRE",
    "dropdelst": "SD",
    "dropdelzpp": 575329998,
    "dropphyadd": "412 N DEADWOOD ST",
    "dropphycty": "FORT PIERRE",
    "dropphyst": "SD",
    "dropphyzpp": 575329998,
    "dropmaladd": "412 N DEADWOOD ST",
    "dropmalcty": "FORT PIERRE",
    "dropmalst": "SD",
    "dropmalzpp": 575329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052232472,
    "dropsitcph": 6052232472,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A704",
    "droptype": "D",
    "dropname": "FORT THOMPSON",
    "dropdeladd": "119 SD HIGHWAY 249",
    "dropdelcty": "FORT THOMPSON",
    "dropdelst": "SD",
    "dropdelzpp": 573399998,
    "dropphyadd": "119 SD HIGHWAY 249",
    "dropphycty": "FORT THOMPSON",
    "dropphyst": "SD",
    "dropphyzpp": 573399998,
    "dropmaladd": "119 SD HIGHWAY 249",
    "dropmalcty": "FORT THOMPSON",
    "dropmalst": "SD",
    "dropmalzpp": 573399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052452364,
    "dropsitcph": 6052452364,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A707",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "611 JEFFERSON AVE",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "SD",
    "dropdelzpp": 574409998,
    "dropphyadd": "611 JEFFERSON AVE",
    "dropphycty": "FRANKFORT",
    "dropphyst": "SD",
    "dropphyzpp": 574409998,
    "dropmaladd": "611 JEFFERSON AVE",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "SD",
    "dropmalzpp": 574409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054721339,
    "dropsitcph": 6054721339,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A709",
    "droptype": "D",
    "dropname": "FREDERICK",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "FREDERICK",
    "dropdelst": "SD",
    "dropdelzpp": 574419998,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "FREDERICK",
    "dropphyst": "SD",
    "dropphyzpp": 574419998,
    "dropmaladd": "413 MAIN ST",
    "dropmalcty": "FREDERICK",
    "dropmalst": "SD",
    "dropmalzpp": 574419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053292441,
    "dropsitcph": 6056050137,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A710",
    "droptype": "D",
    "dropname": "FREEMAN",
    "dropdeladd": "421 S POPLAR ST",
    "dropdelcty": "FREEMAN",
    "dropdelst": "SD",
    "dropdelzpp": 570299998,
    "dropphyadd": "421 S POPLAR ST",
    "dropphycty": "FREEMAN",
    "dropphyst": "SD",
    "dropphyzpp": 570299998,
    "dropmaladd": "421 S POPLAR ST",
    "dropmalcty": "FREEMAN",
    "dropmalst": "SD",
    "dropmalzpp": 570299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059257386,
    "dropsitcph": 6059257386,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A712",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "217 N MAIN AVE",
    "dropdelcty": "FULTON",
    "dropdelst": "SD",
    "dropdelzpp": 573409998,
    "dropphyadd": "217 N MAIN AVE",
    "dropphycty": "FULTON",
    "dropphyst": "SD",
    "dropphyzpp": 573409998,
    "dropmaladd": "217 N MAIN AVE",
    "dropmalcty": "FULTON",
    "dropmalst": "SD",
    "dropmalzpp": 573409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059964845,
    "dropsitcph": 6059964845,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A714",
    "droptype": "D",
    "dropname": "GANN VALLEY",
    "dropdeladd": "229 MAIN ST",
    "dropdelcty": "GANN VALLEY",
    "dropdelst": "SD",
    "dropdelzpp": 573419998,
    "dropphyadd": "229 MAIN ST",
    "dropphycty": "GANN VALLEY",
    "dropphyst": "SD",
    "dropphyzpp": 573419998,
    "dropmaladd": "229 MAIN ST",
    "dropmalcty": "GANN VALLEY",
    "dropmalst": "SD",
    "dropmalzpp": 573419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052933210,
    "dropsitcph": 6052933210,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A715",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "127 MAIN ST W",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "SD",
    "dropdelzpp": 572369998,
    "dropphyadd": "127 MAIN ST W",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "SD",
    "dropphyzpp": 572369998,
    "dropmaladd": "127 MAIN ST W",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "SD",
    "dropmalzpp": 572369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055323761,
    "dropsitcph": 6055323761,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A716",
    "droptype": "D",
    "dropname": "GARRETSON",
    "dropdeladd": "641 N MAIN AVE",
    "dropdelcty": "GARRETSON",
    "dropdelst": "SD",
    "dropdelzpp": 570309998,
    "dropphyadd": "641 N MAIN AVE",
    "dropphycty": "GARRETSON",
    "dropphyst": "SD",
    "dropphyzpp": 570309998,
    "dropmaladd": "641 N MAIN AVE",
    "dropmalcty": "GARRETSON",
    "dropmalst": "SD",
    "dropmalzpp": 570309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055943405,
    "dropsitcph": 6055943405,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A717",
    "droptype": "D",
    "dropname": "GARY",
    "dropdeladd": "1109 COTEAU ST",
    "dropdelcty": "GARY",
    "dropdelst": "SD",
    "dropdelzpp": 572379998,
    "dropphyadd": "1109 COTEAU ST",
    "dropphycty": "GARY",
    "dropphyst": "SD",
    "dropphyzpp": 572379998,
    "dropmaladd": "1109 COTEAU ST",
    "dropmalcty": "GARY",
    "dropmalst": "SD",
    "dropmalzpp": 572379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052725871,
    "dropsitcph": 6052725871,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A718",
    "droptype": "D",
    "dropname": "GAYVILLE",
    "dropdeladd": "508 WASHINGTON ST",
    "dropdelcty": "GAYVILLE",
    "dropdelst": "SD",
    "dropdelzpp": 570319998,
    "dropphyadd": "508 WASHINGTON ST",
    "dropphycty": "GAYVILLE",
    "dropphyst": "SD",
    "dropphyzpp": 570319998,
    "dropmaladd": "508 WASHINGTON ST",
    "dropmalcty": "GAYVILLE",
    "dropmalst": "SD",
    "dropmalzpp": 570319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052674389,
    "dropsitcph": 6052674389,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A719",
    "droptype": "D",
    "dropname": "GEDDES",
    "dropdeladd": "312 MAIN AVE",
    "dropdelcty": "GEDDES",
    "dropdelst": "SD",
    "dropdelzpp": 573429998,
    "dropphyadd": "312 MAIN AVE",
    "dropphycty": "GEDDES",
    "dropphyst": "SD",
    "dropphyzpp": 573429998,
    "dropmaladd": "312 MAIN AVE",
    "dropmalcty": "GEDDES",
    "dropmalst": "SD",
    "dropmalzpp": 573429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053372469,
    "dropsitcph": 6053372469,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A720",
    "droptype": "D",
    "dropname": "GETTYSBURG",
    "dropdeladd": "110 N EXENE ST",
    "dropdelcty": "GETTYSBURG",
    "dropdelst": "SD",
    "dropdelzpp": 574429998,
    "dropphyadd": "110 N EXENE ST",
    "dropphycty": "GETTYSBURG",
    "dropphyst": "SD",
    "dropphyzpp": 574429998,
    "dropmaladd": "110 N EXENE ST",
    "dropmalcty": "GETTYSBURG",
    "dropmalst": "SD",
    "dropmalzpp": 574429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052778215,
    "dropsitcph": 6052778215,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A726",
    "droptype": "D",
    "dropname": "GLENHAM",
    "dropdeladd": "23 MAIN ST",
    "dropdelcty": "GLENHAM",
    "dropdelst": "SD",
    "dropdelzpp": 576319998,
    "dropphyadd": "23 MAIN ST",
    "dropphycty": "GLENHAM",
    "dropphyst": "SD",
    "dropphyzpp": 576319998,
    "dropmaladd": "23 MAIN ST",
    "dropmalcty": "GLENHAM",
    "dropmalst": "SD",
    "dropmalzpp": 576319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057623290,
    "dropsitcph": 6057623290,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A727",
    "droptype": "D",
    "dropname": "GOODWIN",
    "dropdeladd": "130 W CHICAGO AVE",
    "dropdelcty": "GOODWIN",
    "dropdelst": "SD",
    "dropdelzpp": 572389998,
    "dropphyadd": "130 W CHICAGO AVE",
    "dropphycty": "GOODWIN",
    "dropphyst": "SD",
    "dropphyzpp": 572389998,
    "dropmaladd": "130 W CHICAGO AVE",
    "dropmalcty": "GOODWIN",
    "dropmalst": "SD",
    "dropmalzpp": 572389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057952991,
    "dropsitcph": 6057952991,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A736",
    "droptype": "D",
    "dropname": "GREGORY",
    "dropdeladd": "517 MAIN ST",
    "dropdelcty": "GREGORY",
    "dropdelst": "SD",
    "dropdelzpp": 575339998,
    "dropphyadd": "517 MAIN ST",
    "dropphycty": "GREGORY",
    "dropphyst": "SD",
    "dropphyzpp": 575339998,
    "dropmaladd": "517 MAIN ST",
    "dropmalcty": "GREGORY",
    "dropmalst": "SD",
    "dropmalzpp": 575339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058359265,
    "dropsitcph": 6058359265,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A737",
    "droptype": "D",
    "dropname": "GRENVILLE",
    "dropdeladd": "915 KOSCIUSKO AVE",
    "dropdelcty": "GRENVILLE",
    "dropdelst": "SD",
    "dropdelzpp": 572399998,
    "dropphyadd": "915 KOSCIUSKO AVE",
    "dropphycty": "GRENVILLE",
    "dropphyst": "SD",
    "dropphyzpp": 572399998,
    "dropmaladd": "915 KOSCIUSKO AVE",
    "dropmalcty": "GRENVILLE",
    "dropmalst": "SD",
    "dropmalzpp": 572399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054864804,
    "dropsitcph": 6054864804,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A739",
    "droptype": "D",
    "dropname": "GROTON",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "GROTON",
    "dropdelst": "SD",
    "dropdelzpp": 574459998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "GROTON",
    "dropphyst": "SD",
    "dropphyzpp": 574459998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "GROTON",
    "dropmalst": "SD",
    "dropmalzpp": 574459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056050023,
    "dropsitcph": 6056050023,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A744",
    "droptype": "D",
    "dropname": "HAMILL",
    "dropdeladd": "26245 MAIN ST",
    "dropdelcty": "HAMILL",
    "dropdelst": "SD",
    "dropdelzpp": 575349998,
    "dropphyadd": "26245 MAIN ST",
    "dropphycty": "HAMILL",
    "dropphyst": "SD",
    "dropphyzpp": 575349998,
    "dropmaladd": "26245 MAIN ST",
    "dropmalcty": "HAMILL",
    "dropmalst": "SD",
    "dropmalzpp": 575349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058421756,
    "dropsitcph": 6058421756,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A749",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "518 N CLIFF AVE",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "SD",
    "dropdelzpp": 570322729,
    "dropphyadd": "518 N CLIFF AVE",
    "dropphycty": "HARRISBURG",
    "dropphyst": "SD",
    "dropphyzpp": 570322729,
    "dropmaladd": "518 N CLIFF AVE",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "SD",
    "dropmalzpp": 570322729,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057768051,
    "dropsitcph": 6057768051,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A751",
    "droptype": "D",
    "dropname": "HARROLD",
    "dropdeladd": "204 S WYMAN ST",
    "dropdelcty": "HARROLD",
    "dropdelst": "SD",
    "dropdelzpp": 575369998,
    "dropphyadd": "204 S WYMAN ST",
    "dropphycty": "HARROLD",
    "dropphyst": "SD",
    "dropphyzpp": 575369998,
    "dropmaladd": "204 S WYMAN ST",
    "dropmalcty": "HARROLD",
    "dropmalst": "SD",
    "dropmalzpp": 575369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058753281,
    "dropsitcph": 6058753281,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A752",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "901 N OAKS AVE",
    "dropdelcty": "HARTFORD",
    "dropdelst": "SD",
    "dropdelzpp": 570339998,
    "dropphyadd": "901 N OAKS AVE",
    "dropphycty": "HARTFORD",
    "dropphyst": "SD",
    "dropphyzpp": 570339998,
    "dropmaladd": "901 N OAKS AVE",
    "dropmalcty": "HARTFORD",
    "dropmalst": "SD",
    "dropmalzpp": 570339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055283841,
    "dropsitcph": 6055283841,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A755",
    "droptype": "D",
    "dropname": "HAYTI",
    "dropdeladd": "207 MAIN AVE",
    "dropdelcty": "HAYTI",
    "dropdelst": "SD",
    "dropdelzpp": 572419998,
    "dropphyadd": "207 MAIN AVE",
    "dropphycty": "HAYTI",
    "dropphyst": "SD",
    "dropphyzpp": 572419998,
    "dropmaladd": "207 MAIN AVE",
    "dropmalcty": "HAYTI",
    "dropmalst": "SD",
    "dropmalzpp": 572419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057833221,
    "dropsitcph": 6057833221,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A757",
    "droptype": "D",
    "dropname": "HAZEL",
    "dropdeladd": "17 W WILLIAMS ST",
    "dropdelcty": "HAZEL",
    "dropdelst": "SD",
    "dropdelzpp": 572429998,
    "dropphyadd": "17 W WILLIAMS ST",
    "dropphycty": "HAZEL",
    "dropphyst": "SD",
    "dropphyzpp": 572429998,
    "dropmaladd": "17 W WILLIAMS ST",
    "dropmalcty": "HAZEL",
    "dropmalst": "SD",
    "dropmalzpp": 572429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056282003,
    "dropsitcph": 6056282003,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A759",
    "droptype": "D",
    "dropname": "HECLA",
    "dropdeladd": "226 MAIN ST",
    "dropdelcty": "HECLA",
    "dropdelst": "SD",
    "dropdelzpp": 574469998,
    "dropphyadd": "226 MAIN ST",
    "dropphycty": "HECLA",
    "dropphyst": "SD",
    "dropphyzpp": 574469998,
    "dropmaladd": "226 MAIN ST",
    "dropmalcty": "HECLA",
    "dropmalst": "SD",
    "dropmalzpp": 574469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059942255,
    "dropsitcph": 6059942255,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A760",
    "droptype": "D",
    "dropname": "HENRY",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "HENRY",
    "dropdelst": "SD",
    "dropdelzpp": 572439998,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "HENRY",
    "dropphyst": "SD",
    "dropphyzpp": 572439998,
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "HENRY",
    "dropmalst": "SD",
    "dropmalzpp": 572439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055325660,
    "dropsitcph": 6055325660,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A763",
    "droptype": "D",
    "dropname": "HERMOSA",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "HERMOSA",
    "dropdelst": "SD",
    "dropdelzpp": 577449998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "HERMOSA",
    "dropphyst": "SD",
    "dropphyzpp": 577449998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "HERMOSA",
    "dropmalst": "SD",
    "dropmalzpp": 577449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052554507,
    "dropsitcph": 6052554507,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A764",
    "droptype": "D",
    "dropname": "HERREID",
    "dropdeladd": "118 MAIN ST N",
    "dropdelcty": "HERREID",
    "dropdelst": "SD",
    "dropdelzpp": 576329998,
    "dropphyadd": "118 MAIN ST N",
    "dropphycty": "HERREID",
    "dropphyst": "SD",
    "dropphyzpp": 576329998,
    "dropmaladd": "118 MAIN ST N",
    "dropmalcty": "HERREID",
    "dropmalst": "SD",
    "dropmalzpp": 576329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054372902,
    "dropsitcph": 6054372902,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A765",
    "droptype": "D",
    "dropname": "HERRICK",
    "dropdeladd": "727 HERRICK AVE",
    "dropdelcty": "HERRICK",
    "dropdelst": "SD",
    "dropdelzpp": 575389998,
    "dropphyadd": "727 HERRICK AVE",
    "dropphycty": "HERRICK",
    "dropphyst": "SD",
    "dropphyzpp": 575389998,
    "dropmaladd": "727 HERRICK AVE",
    "dropmalcty": "HERRICK",
    "dropmalst": "SD",
    "dropmalzpp": 575389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057752505,
    "dropsitcph": 6057752505,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A768",
    "droptype": "D",
    "dropname": "HIGHMORE",
    "dropdeladd": "111 COMMERCIAL AVE SE",
    "dropdelcty": "HIGHMORE",
    "dropdelst": "SD",
    "dropdelzpp": 573459998,
    "dropphyadd": "111 COMMERCIAL AVE SE",
    "dropphycty": "HIGHMORE",
    "dropphyst": "SD",
    "dropphyzpp": 573459998,
    "dropmaladd": "111 COMMERCIAL AVE SE",
    "dropmalcty": "HIGHMORE",
    "dropmalst": "SD",
    "dropmalzpp": 573459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058522631,
    "dropsitcph": 6058522631,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A770",
    "droptype": "D",
    "dropname": "HILL CITY",
    "dropdeladd": "150 E MAIN ST",
    "dropdelcty": "HILL CITY",
    "dropdelst": "SD",
    "dropdelzpp": 577459998,
    "dropphyadd": "150 E MAIN ST",
    "dropphycty": "HILL CITY",
    "dropphyst": "SD",
    "dropphyzpp": 577459998,
    "dropmaladd": "150 E MAIN ST",
    "dropmalcty": "HILL CITY",
    "dropmalst": "SD",
    "dropmalzpp": 577459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055742730,
    "dropsitcph": 6055742730,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A779",
    "droptype": "D",
    "dropname": "HITCHCOCK",
    "dropdeladd": "386 CLARKE ST",
    "dropdelcty": "HITCHCOCK",
    "dropdelst": "SD",
    "dropdelzpp": 573489998,
    "dropphyadd": "386 CLARKE ST",
    "dropphycty": "HITCHCOCK",
    "dropphyst": "SD",
    "dropphyzpp": 573489998,
    "dropmaladd": "386 CLARKE ST",
    "dropmalcty": "HITCHCOCK",
    "dropmalst": "SD",
    "dropmalzpp": 573489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052662801,
    "dropsitcph": 6052662801,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A784",
    "droptype": "D",
    "dropname": "HOSMER",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "HOSMER",
    "dropdelst": "SD",
    "dropdelzpp": 574489998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "HOSMER",
    "dropphyst": "SD",
    "dropphyzpp": 574489998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "HOSMER",
    "dropmalst": "SD",
    "dropmalzpp": 574489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052832270,
    "dropsitcph": 6052832270,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A785",
    "droptype": "D",
    "dropname": "HOT SPRINGS",
    "dropdeladd": "146 N CHICAGO ST",
    "dropdelcty": "HOT SPRINGS",
    "dropdelst": "SD",
    "dropdelzpp": 577479998,
    "dropphyadd": "146 N CHICAGO ST",
    "dropphycty": "HOT SPRINGS",
    "dropphyst": "SD",
    "dropphyzpp": 577479998,
    "dropmaladd": "146 N CHICAGO ST",
    "dropmalcty": "HOT SPRINGS",
    "dropmalst": "SD",
    "dropmalzpp": 577479998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058246720,
    "dropsitcph": 6058246720,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A788",
    "droptype": "D",
    "dropname": "HOVEN",
    "dropdeladd": "262 MAIN ST",
    "dropdelcty": "HOVEN",
    "dropdelst": "SD",
    "dropdelzpp": 574509998,
    "dropphyadd": "262 MAIN ST",
    "dropphycty": "HOVEN",
    "dropphyst": "SD",
    "dropphyzpp": 574509998,
    "dropmaladd": "262 MAIN ST",
    "dropmalcty": "HOVEN",
    "dropmalst": "SD",
    "dropmalzpp": 574509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059482393,
    "dropsitcph": 6059482393,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A789",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "HOWARD",
    "dropdelst": "SD",
    "dropdelzpp": 573499998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "HOWARD",
    "dropphyst": "SD",
    "dropphyzpp": 573499998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "HOWARD",
    "dropmalst": "SD",
    "dropmalzpp": 573499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057724762,
    "dropsitcph": 6057724762,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A791",
    "droptype": "D",
    "dropname": "HOWES",
    "dropdeladd": "19188 SD HIGHWAY 73",
    "dropdelcty": "HOWES",
    "dropdelst": "SD",
    "dropdelzpp": 577489998,
    "dropphyadd": "19188 SD HIGHWAY 73",
    "dropphycty": "HOWES",
    "dropphyst": "SD",
    "dropphyzpp": 577489998,
    "dropmaladd": "19188 SD HIGHWAY 73",
    "dropmalcty": "HOWES",
    "dropmalst": "SD",
    "dropmalzpp": 577489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 8779076439,
    "dropsitcph": 8779076439,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A793",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "318 WHEELOCK ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "SD",
    "dropdelzpp": 570349998,
    "dropphyadd": "318 WHEELOCK ST",
    "dropphycty": "HUDSON",
    "dropphyst": "SD",
    "dropphyzpp": 570349998,
    "dropmaladd": "318 WHEELOCK ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "SD",
    "dropmalzpp": 570349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059842080,
    "dropsitcph": 6059842080,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A795",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "1005 W 2ND AVE",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "SD",
    "dropdelzpp": 570359998,
    "dropphyadd": "1005 W 2ND AVE",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "SD",
    "dropphyzpp": 570359998,
    "dropmaladd": "1005 W 2ND AVE",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "SD",
    "dropmalzpp": 570359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053633018,
    "dropsitcph": 6053633018,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A797",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "608 CENTER AVE",
    "dropdelcty": "HURLEY",
    "dropdelst": "SD",
    "dropdelzpp": 570369998,
    "dropphyadd": "608 CENTER AVE",
    "dropphycty": "HURLEY",
    "dropphyst": "SD",
    "dropphyzpp": 570369998,
    "dropmaladd": "608 CENTER AVE",
    "dropmalcty": "HURLEY",
    "dropmalst": "SD",
    "dropmalzpp": 570369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056671271,
    "dropsitcph": 6056671271,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A798",
    "droptype": "D",
    "dropname": "HURON",
    "dropdeladd": "410 DAKOTA AVE S",
    "dropdelcty": "HURON",
    "dropdelst": "SD",
    "dropdelzpp": 573509998,
    "dropphyadd": "410 DAKOTA AVE S",
    "dropphycty": "HURON",
    "dropphyst": "SD",
    "dropphyzpp": 573509998,
    "dropmaladd": "410 DAKOTA AVE S",
    "dropmalcty": "HURON",
    "dropmalst": "SD",
    "dropmalzpp": 573509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053522725,
    "dropsitcph": 6053522725,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A803",
    "droptype": "D",
    "dropname": "IDEAL",
    "dropdeladd": "31210 266TH ST",
    "dropdelcty": "IDEAL",
    "dropdelst": "SD",
    "dropdelzpp": 575419998,
    "dropphyadd": "31210 266TH ST",
    "dropphycty": "IDEAL",
    "dropphyst": "SD",
    "dropphyzpp": 575419998,
    "dropmaladd": "31210 266TH ST",
    "dropmalcty": "IDEAL",
    "dropmalst": "SD",
    "dropmalzpp": 575419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058420598,
    "dropsitcph": 6058420598,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A810",
    "droptype": "D",
    "dropname": "IPSWICH",
    "dropdeladd": "336 1ST AVE",
    "dropdelcty": "IPSWICH",
    "dropdelst": "SD",
    "dropdelzpp": 574519998,
    "dropphyadd": "336 1ST AVE",
    "dropphycty": "IPSWICH",
    "dropphyst": "SD",
    "dropphyzpp": 574519998,
    "dropmaladd": "336 1ST AVE",
    "dropmalcty": "IPSWICH",
    "dropmalst": "SD",
    "dropmalzpp": 574519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054266091,
    "dropsitcph": 6054266091,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A811",
    "droptype": "D",
    "dropname": "IRENE",
    "dropdeladd": "205 W MAIN ST",
    "dropdelcty": "IRENE",
    "dropdelst": "SD",
    "dropdelzpp": 570379998,
    "dropphyadd": "205 W MAIN ST",
    "dropphycty": "IRENE",
    "dropphyst": "SD",
    "dropphyzpp": 570379998,
    "dropmaladd": "205 W MAIN ST",
    "dropmalcty": "IRENE",
    "dropmalst": "SD",
    "dropmalzpp": 570379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052633513,
    "dropsitcph": 6052633513,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A813",
    "droptype": "D",
    "dropname": "IROQUOIS",
    "dropdeladd": "199 S OTTOWA ST",
    "dropdelcty": "IROQUOIS",
    "dropdelst": "SD",
    "dropdelzpp": 573539998,
    "dropphyadd": "199 S OTTOWA ST",
    "dropphycty": "IROQUOIS",
    "dropphyst": "SD",
    "dropphyzpp": 573539998,
    "dropmaladd": "199 S OTTOWA ST",
    "dropmalcty": "IROQUOIS",
    "dropmalst": "SD",
    "dropmalzpp": 573539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055462340,
    "dropsitcph": 6055462340,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A814",
    "droptype": "D",
    "dropname": "ISABEL",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "ISABEL",
    "dropdelst": "SD",
    "dropdelzpp": 576339998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "ISABEL",
    "dropphyst": "SD",
    "dropphyzpp": 576339998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "ISABEL",
    "dropmalst": "SD",
    "dropmalzpp": 576339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054662165,
    "dropsitcph": 6054662165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A819",
    "droptype": "D",
    "dropname": "JAVA",
    "dropdeladd": "4125 N MAIN ST",
    "dropdelcty": "JAVA",
    "dropdelst": "SD",
    "dropdelzpp": 574529998,
    "dropphyadd": "4125 N MAIN ST",
    "dropphycty": "JAVA",
    "dropphyst": "SD",
    "dropphyzpp": 574529998,
    "dropmaladd": "4125 N MAIN ST",
    "dropmalcty": "JAVA",
    "dropmalst": "SD",
    "dropmalzpp": 574529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056496431,
    "dropsitcph": 6056496431,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A820",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "303 MAIN ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "SD",
    "dropdelzpp": 570389998,
    "dropphyadd": "303 MAIN ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "SD",
    "dropphyzpp": 570389998,
    "dropmaladd": "303 MAIN ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "SD",
    "dropmalzpp": 570389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056384341,
    "dropsitcph": 6056384341,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A827",
    "droptype": "D",
    "dropname": "KADOKA",
    "dropdeladd": "1001 MAIN ST",
    "dropdelcty": "KADOKA",
    "dropdelst": "SD",
    "dropdelzpp": 575439998,
    "dropphyadd": "1001 MAIN ST",
    "dropphycty": "KADOKA",
    "dropphyst": "SD",
    "dropphyzpp": 575439998,
    "dropmaladd": "1001 MAIN ST",
    "dropmalcty": "KADOKA",
    "dropmalst": "SD",
    "dropmalzpp": 575439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058372227,
    "dropsitcph": 6058372227,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A833",
    "droptype": "D",
    "dropname": "KAYLOR",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "KAYLOR",
    "dropdelst": "SD",
    "dropdelzpp": 573549998,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "KAYLOR",
    "dropphyst": "SD",
    "dropphyzpp": 573549998,
    "dropmaladd": "105 MAIN ST",
    "dropmalcty": "KAYLOR",
    "dropmalst": "SD",
    "dropmalzpp": 573549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052732071,
    "dropsitcph": 6052732071,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A836",
    "droptype": "D",
    "dropname": "KENNEBEC",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "KENNEBEC",
    "dropdelst": "SD",
    "dropdelzpp": 575449998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "KENNEBEC",
    "dropphyst": "SD",
    "dropphyzpp": 575449998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "KENNEBEC",
    "dropmalst": "SD",
    "dropmalzpp": 575449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058692224,
    "dropsitcph": 6058692224,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A838",
    "droptype": "D",
    "dropname": "KEYSTONE",
    "dropdeladd": "233 SWANZEY ST",
    "dropdelcty": "KEYSTONE",
    "dropdelst": "SD",
    "dropdelzpp": 577519998,
    "dropphyadd": "233 SWANZEY ST",
    "dropphycty": "KEYSTONE",
    "dropphyst": "SD",
    "dropphyzpp": 577519998,
    "dropmaladd": "233 SWANZEY ST",
    "dropmalcty": "KEYSTONE",
    "dropmalst": "SD",
    "dropmalzpp": 577519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055745640,
    "dropsitcph": 6055745640,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A840",
    "droptype": "D",
    "dropname": "KIMBALL",
    "dropdeladd": "212 S MAIN ST",
    "dropdelcty": "KIMBALL",
    "dropdelst": "SD",
    "dropdelzpp": 573559998,
    "dropphyadd": "212 S MAIN ST",
    "dropphycty": "KIMBALL",
    "dropphyst": "SD",
    "dropphyzpp": 573559998,
    "dropmaladd": "212 S MAIN ST",
    "dropmalcty": "KIMBALL",
    "dropmalst": "SD",
    "dropmalzpp": 573559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057786260,
    "dropsitcph": 6057786260,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A844",
    "droptype": "D",
    "dropname": "KRANZBURG",
    "dropdeladd": "102 DAKOTA AVE N",
    "dropdelcty": "KRANZBURG",
    "dropdelst": "SD",
    "dropdelzpp": 572459998,
    "dropphyadd": "102 DAKOTA AVE N",
    "dropphycty": "KRANZBURG",
    "dropphyst": "SD",
    "dropphyzpp": 572459998,
    "dropmaladd": "102 DAKOTA AVE N",
    "dropmalcty": "KRANZBURG",
    "dropmalst": "SD",
    "dropmalzpp": 572459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058868598,
    "dropsitcph": 6058868598,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A845",
    "droptype": "D",
    "dropname": "KYLE",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "KYLE",
    "dropdelst": "SD",
    "dropdelzpp": 577529998,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "KYLE",
    "dropphyst": "SD",
    "dropphyzpp": 577529998,
    "dropmaladd": "405 MAIN ST",
    "dropmalcty": "KYLE",
    "dropmalst": "SD",
    "dropmalzpp": 577529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054552357,
    "dropsitcph": 6054552357,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A851",
    "droptype": "D",
    "dropname": "LAKE ANDES",
    "dropdeladd": "499 MAIN ST",
    "dropdelcty": "LAKE ANDES",
    "dropdelst": "SD",
    "dropdelzpp": 573569998,
    "dropphyadd": "499 MAIN ST",
    "dropphycty": "LAKE ANDES",
    "dropphyst": "SD",
    "dropphyzpp": 573569998,
    "dropmaladd": "499 MAIN ST",
    "dropmalcty": "LAKE ANDES",
    "dropmalst": "SD",
    "dropmalzpp": 573569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054877411,
    "dropsitcph": 6054877411,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A855",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "303 S BROADWAY ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "SD",
    "dropdelzpp": 572479998,
    "dropphyadd": "303 S BROADWAY ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "SD",
    "dropphyzpp": 572479998,
    "dropmaladd": "303 S BROADWAY ST",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "SD",
    "dropmalzpp": 572479998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057382194,
    "dropsitcph": 6057382194,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A859",
    "droptype": "D",
    "dropname": "LAKE NORDEN",
    "dropdeladd": "500 MAIN AVE",
    "dropdelcty": "LAKE NORDEN",
    "dropdelst": "SD",
    "dropdelzpp": 572489998,
    "dropphyadd": "500 MAIN AVE",
    "dropphycty": "LAKE NORDEN",
    "dropphyst": "SD",
    "dropphyzpp": 572489998,
    "dropmaladd": "500 MAIN AVE",
    "dropmalcty": "LAKE NORDEN",
    "dropmalst": "SD",
    "dropmalzpp": 572489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057853904,
    "dropsitcph": 6057853904,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A861",
    "droptype": "D",
    "dropname": "LAKE PRESTON",
    "dropdeladd": "220 MAIN AVE N",
    "dropdelcty": "LAKE PRESTON",
    "dropdelst": "SD",
    "dropdelzpp": 572499998,
    "dropphyadd": "220 MAIN AVE N",
    "dropphycty": "LAKE PRESTON",
    "dropphyst": "SD",
    "dropphyzpp": 572499998,
    "dropmaladd": "220 MAIN AVE N",
    "dropmalcty": "LAKE PRESTON",
    "dropmalst": "SD",
    "dropmalzpp": 572499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058474627,
    "dropsitcph": 6058474627,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A865",
    "droptype": "D",
    "dropname": "LANGFORD",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "LANGFORD",
    "dropdelst": "SD",
    "dropdelzpp": 574549998,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "LANGFORD",
    "dropphyst": "SD",
    "dropphyzpp": 574549998,
    "dropmaladd": "309 MAIN ST",
    "dropmalcty": "LANGFORD",
    "dropmalst": "SD",
    "dropmalzpp": 574549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054936446,
    "dropsitcph": 6054936446,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A866",
    "droptype": "D",
    "dropname": "LANTRY",
    "dropdeladd": "10 WHEAT AVE",
    "dropdelcty": "LANTRY",
    "dropdelst": "SD",
    "dropdelzpp": 576369998,
    "dropphyadd": "10 WHEAT AVE",
    "dropphycty": "LANTRY",
    "dropphyst": "SD",
    "dropphyzpp": 576369998,
    "dropmaladd": "10 WHEAT AVE",
    "dropmalcty": "LANTRY",
    "dropmalst": "SD",
    "dropmalzpp": 576369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059648018,
    "dropsitcph": 6059648018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1A869",
    "droptype": "D",
    "dropname": "LEAD",
    "dropdeladd": "329 W MAIN ST",
    "dropdelcty": "LEAD",
    "dropdelst": "SD",
    "dropdelzpp": 577549998,
    "dropphyadd": "329 W MAIN ST",
    "dropphycty": "LEAD",
    "dropphyst": "SD",
    "dropphyzpp": 577549998,
    "dropmaladd": "329 W MAIN ST",
    "dropmalcty": "LEAD",
    "dropmalst": "SD",
    "dropmalzpp": 577549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055842110,
    "dropsitcph": 6055842110,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A871",
    "droptype": "D",
    "dropname": "LEMMON",
    "dropdeladd": "310 1ST AVE W",
    "dropdelcty": "LEMMON",
    "dropdelst": "SD",
    "dropdelzpp": 576389998,
    "dropphyadd": "310 1ST AVE W",
    "dropphycty": "LEMMON",
    "dropphyst": "SD",
    "dropphyzpp": 576389998,
    "dropmaladd": "310 1ST AVE W",
    "dropmalcty": "LEMMON",
    "dropmalst": "SD",
    "dropmalzpp": 576389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053743621,
    "dropsitcph": 6053743621,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A872",
    "droptype": "D",
    "dropname": "LENNOX",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "LENNOX",
    "dropdelst": "SD",
    "dropdelzpp": 570399998,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "LENNOX",
    "dropphyst": "SD",
    "dropphyzpp": 570399998,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "LENNOX",
    "dropmalst": "SD",
    "dropmalzpp": 570399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056472265,
    "dropsitcph": 6056472265,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A873",
    "droptype": "D",
    "dropname": "LEOLA",
    "dropdeladd": "5 S SHERMAN ST",
    "dropdelcty": "LEOLA",
    "dropdelst": "SD",
    "dropdelzpp": 574569998,
    "dropphyadd": "5 S SHERMAN ST",
    "dropphycty": "LEOLA",
    "dropphyst": "SD",
    "dropphyzpp": 574569998,
    "dropmaladd": "5 S SHERMAN ST",
    "dropmalcty": "LEOLA",
    "dropmalst": "SD",
    "dropmalzpp": 574569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054393170,
    "dropsitcph": 6054393170,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A874",
    "droptype": "D",
    "dropname": "LESTERVILLE",
    "dropdeladd": "223 MAIN AVE",
    "dropdelcty": "LESTERVILLE",
    "dropdelst": "SD",
    "dropdelzpp": 570409998,
    "dropphyadd": "223 MAIN AVE",
    "dropphycty": "LESTERVILLE",
    "dropphyst": "SD",
    "dropphyzpp": 570409998,
    "dropmaladd": "223 MAIN AVE",
    "dropmalcty": "LESTERVILLE",
    "dropmalst": "SD",
    "dropmalzpp": 570409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053647351,
    "dropsitcph": 6053647351,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A875",
    "droptype": "D",
    "dropname": "LETCHER",
    "dropdeladd": "119 E MAIN ST",
    "dropdelcty": "LETCHER",
    "dropdelst": "SD",
    "dropdelzpp": 573599998,
    "dropphyadd": "119 E MAIN ST",
    "dropphycty": "LETCHER",
    "dropphyst": "SD",
    "dropphyzpp": 573599998,
    "dropmaladd": "119 E MAIN ST",
    "dropmalcty": "LETCHER",
    "dropmalst": "SD",
    "dropmalzpp": 573599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052482616,
    "dropsitcph": 6052482616,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A885",
    "droptype": "D",
    "dropname": "LITTLE EAGLE",
    "dropdeladd": "1 RUNNING ANTELOPE DR",
    "dropdelcty": "LITTLE EAGLE",
    "dropdelst": "SD",
    "dropdelzpp": 576399998,
    "dropphyadd": "1 RUNNING ANTELOPE DR",
    "dropphycty": "LITTLE EAGLE",
    "dropphyst": "SD",
    "dropphyzpp": 576399998,
    "dropmaladd": "1 RUNNING ANTELOPE DR",
    "dropmalcty": "LITTLE EAGLE",
    "dropmalst": "SD",
    "dropmalzpp": 576399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058234387,
    "dropsitcph": 6058234387,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A890",
    "droptype": "D",
    "dropname": "LOWER BRULE",
    "dropdeladd": "312 CRAZY HORSE AVE",
    "dropdelcty": "LOWER BRULE",
    "dropdelst": "SD",
    "dropdelzpp": 575489998,
    "dropphyadd": "312 CRAZY HORSE AVE",
    "dropphycty": "LOWER BRULE",
    "dropphyst": "SD",
    "dropphyzpp": 575489998,
    "dropmaladd": "312 CRAZY HORSE AVE",
    "dropmalcty": "LOWER BRULE",
    "dropmalst": "SD",
    "dropmalzpp": 575489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054735495,
    "dropsitcph": 6054735495,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A898",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "119 E CENTER ST",
    "dropdelcty": "MADISON",
    "dropdelst": "SD",
    "dropdelzpp": 570429998,
    "dropphyadd": "119 E CENTER ST",
    "dropphycty": "MADISON",
    "dropphyst": "SD",
    "dropphyzpp": 570429998,
    "dropmaladd": "119 E CENTER ST",
    "dropmalcty": "MADISON",
    "dropmalst": "SD",
    "dropmalzpp": 570429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052562035,
    "dropsitcph": 6052562035,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A902",
    "droptype": "D",
    "dropname": "MANDERSON",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "MANDERSON",
    "dropdelst": "SD",
    "dropdelzpp": 577569998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "MANDERSON",
    "dropphyst": "SD",
    "dropphyzpp": 577569998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "MANDERSON",
    "dropmalst": "SD",
    "dropmalzpp": 577569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058675116,
    "dropsitcph": 6058675116,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A903",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "SD",
    "dropdelzpp": 574609998,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "SD",
    "dropphyzpp": 574609998,
    "dropmaladd": "205 E MAIN ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "SD",
    "dropmalzpp": 574609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058873688,
    "dropsitcph": 6058873688,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A908",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "209 N BROADWAY AVE",
    "dropdelcty": "MARION",
    "dropdelst": "SD",
    "dropdelzpp": 570439998,
    "dropphyadd": "209 N BROADWAY AVE",
    "dropphycty": "MARION",
    "dropphyst": "SD",
    "dropphyzpp": 570439998,
    "dropmaladd": "209 N BROADWAY AVE",
    "dropmalcty": "MARION",
    "dropmalst": "SD",
    "dropmalzpp": 570439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056483210,
    "dropsitcph": 6056483210,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A909",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "506 3RD AVE",
    "dropdelcty": "MARTIN",
    "dropdelst": "SD",
    "dropdelzpp": 575519998,
    "dropphyadd": "506 3RD AVE",
    "dropphycty": "MARTIN",
    "dropphyst": "SD",
    "dropphyzpp": 575519998,
    "dropmaladd": "506 3RD AVE",
    "dropmalcty": "MARTIN",
    "dropmalst": "SD",
    "dropmalzpp": 575519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056856550,
    "dropsitcph": 6056856550,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A911",
    "droptype": "D",
    "dropname": "MARVIN",
    "dropdeladd": "101 E DIVISION ST",
    "dropdelcty": "MARVIN",
    "dropdelst": "SD",
    "dropdelzpp": 572519998,
    "dropphyadd": "101 E DIVISION ST",
    "dropphycty": "MARVIN",
    "dropphyst": "SD",
    "dropphyzpp": 572519998,
    "dropmaladd": "101 E DIVISION ST",
    "dropmalcty": "MARVIN",
    "dropmalst": "SD",
    "dropmalzpp": 572519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053986163,
    "dropsitcph": 6053986163,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A916",
    "droptype": "D",
    "dropname": "MC INTOSH",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "MC INTOSH",
    "dropdelst": "SD",
    "dropdelzpp": 576419998,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "MC INTOSH",
    "dropphyst": "SD",
    "dropphyzpp": 576419998,
    "dropmaladd": "312 MAIN ST",
    "dropmalcty": "MC INTOSH",
    "dropmalst": "SD",
    "dropmalzpp": 576419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052734308,
    "dropsitcph": 6052734308,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A917",
    "droptype": "D",
    "dropname": "MC LAUGHLIN",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "MC LAUGHLIN",
    "dropdelst": "SD",
    "dropdelzpp": 576429998,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "MC LAUGHLIN",
    "dropphyst": "SD",
    "dropphyzpp": 576429998,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "MC LAUGHLIN",
    "dropmalst": "SD",
    "dropmalzpp": 576429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058234274,
    "dropsitcph": 6058234274,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A920",
    "droptype": "D",
    "dropname": "MEADOW",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "MEADOW",
    "dropdelst": "SD",
    "dropdelzpp": 576449998,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "MEADOW",
    "dropphyst": "SD",
    "dropphyzpp": 576449998,
    "dropmaladd": "111 MAIN ST",
    "dropmalcty": "MEADOW",
    "dropmalst": "SD",
    "dropmalzpp": 576449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057882800,
    "dropsitcph": 6057882800,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A923",
    "droptype": "D",
    "dropname": "MELLETTE",
    "dropdeladd": "1 W MAIN ST",
    "dropdelcty": "MELLETTE",
    "dropdelst": "SD",
    "dropdelzpp": 574619998,
    "dropphyadd": "1 W MAIN ST",
    "dropphycty": "MELLETTE",
    "dropphyst": "SD",
    "dropphyzpp": 574619998,
    "dropmaladd": "1 W MAIN ST",
    "dropmalcty": "MELLETTE",
    "dropmalst": "SD",
    "dropmalzpp": 574619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058873282,
    "dropsitcph": 6058873282,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A924",
    "droptype": "D",
    "dropname": "MENNO",
    "dropdeladd": "227 S 5TH ST",
    "dropdelcty": "MENNO",
    "dropdelst": "SD",
    "dropdelzpp": 570459998,
    "dropphyadd": "227 S 5TH ST",
    "dropphycty": "MENNO",
    "dropphyst": "SD",
    "dropphyzpp": 570459998,
    "dropmaladd": "227 S 5TH ST",
    "dropmalcty": "MENNO",
    "dropmalst": "SD",
    "dropmalzpp": 570459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053875198,
    "dropsitcph": 6053875198,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A925",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "MIDLAND",
    "dropdelst": "SD",
    "dropdelzpp": 575529998,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "MIDLAND",
    "dropphyst": "SD",
    "dropphyzpp": 575529998,
    "dropmaladd": "402 MAIN ST",
    "dropmalcty": "MIDLAND",
    "dropmalst": "SD",
    "dropmalzpp": 575529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058432596,
    "dropsitcph": 6058432596,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A928",
    "droptype": "D",
    "dropname": "MILBANK",
    "dropdeladd": "222 E 3RD AVE",
    "dropdelcty": "MILBANK",
    "dropdelst": "SD",
    "dropdelzpp": 572529998,
    "dropphyadd": "222 E 3RD AVE",
    "dropphycty": "MILBANK",
    "dropphyst": "SD",
    "dropphyzpp": 572529998,
    "dropmaladd": "222 E 3RD AVE",
    "dropmalcty": "MILBANK",
    "dropmalst": "SD",
    "dropmalzpp": 572529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054326531,
    "dropsitcph": 6054326531,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A932",
    "droptype": "D",
    "dropname": "MILLER",
    "dropdeladd": "320 N BROADWAY AVE",
    "dropdelcty": "MILLER",
    "dropdelst": "SD",
    "dropdelzpp": 573629998,
    "dropphyadd": "320 N BROADWAY AVE",
    "dropphycty": "MILLER",
    "dropphyst": "SD",
    "dropphyzpp": 573629998,
    "dropmaladd": "320 N BROADWAY AVE",
    "dropmalcty": "MILLER",
    "dropmalst": "SD",
    "dropmalzpp": 573629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058533772,
    "dropsitcph": 6058533772,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A937",
    "droptype": "D",
    "dropname": "MISSION",
    "dropdeladd": "150 E 3RD ST",
    "dropdelcty": "MISSION",
    "dropdelst": "SD",
    "dropdelzpp": 575559998,
    "dropphyadd": "150 E 3RD ST",
    "dropphycty": "MISSION",
    "dropphyst": "SD",
    "dropphyzpp": 575559998,
    "dropmaladd": "150 E 3RD ST",
    "dropmalcty": "MISSION",
    "dropmalst": "SD",
    "dropmalzpp": 575559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058564854,
    "dropsitcph": 6058564854,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A938",
    "droptype": "D",
    "dropname": "MISSION HILL",
    "dropdeladd": "109 WASHINGTON AVE S",
    "dropdelcty": "MISSION HILL",
    "dropdelst": "SD",
    "dropdelzpp": 570469998,
    "dropphyadd": "109 WASHINGTON AVE S",
    "dropphycty": "MISSION HILL",
    "dropphyst": "SD",
    "dropphyzpp": 570469998,
    "dropmaladd": "109 WASHINGTON AVE S",
    "dropmalcty": "MISSION HILL",
    "dropmalst": "SD",
    "dropmalzpp": 570469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056659200,
    "dropsitcph": 6056659200,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A941",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "200 W 5TH AVE",
    "dropdelcty": "MITCHELL",
    "dropdelst": "SD",
    "dropdelzpp": 573019998,
    "dropphyadd": "200 W 5TH AVE",
    "dropphycty": "MITCHELL",
    "dropphyst": "SD",
    "dropphyzpp": 573019998,
    "dropmaladd": "200 W 5TH AVE",
    "dropmalcty": "MITCHELL",
    "dropmalst": "SD",
    "dropmalzpp": 573019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059960957,
    "dropsitcph": 6059960957,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A943",
    "droptype": "D",
    "dropname": "MOBRIDGE",
    "dropdeladd": "404 N MAIN ST",
    "dropdelcty": "MOBRIDGE",
    "dropdelst": "SD",
    "dropdelzpp": 576019998,
    "dropphyadd": "404 N MAIN ST",
    "dropphycty": "MOBRIDGE",
    "dropphyst": "SD",
    "dropphyzpp": 576019998,
    "dropmaladd": "404 N MAIN ST",
    "dropmalcty": "MOBRIDGE",
    "dropmalst": "SD",
    "dropmalzpp": 576019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058455770,
    "dropsitcph": 6058455770,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A947",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "MONTROSE",
    "dropdelst": "SD",
    "dropdelzpp": 570489998,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "MONTROSE",
    "dropphyst": "SD",
    "dropphyzpp": 570489998,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "MONTROSE",
    "dropmalst": "SD",
    "dropmalzpp": 570489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053635119,
    "dropsitcph": 6053635119,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A949",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "SD",
    "dropdelzpp": 576459998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "SD",
    "dropphyzpp": 576459998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "SD",
    "dropmalzpp": 576459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055243300,
    "dropsitcph": 6055243300,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A951",
    "droptype": "D",
    "dropname": "MOUND CITY",
    "dropdeladd": "202 MAIN ST N",
    "dropdelcty": "MOUND CITY",
    "dropdelst": "SD",
    "dropdelzpp": 576469998,
    "dropphyadd": "202 MAIN ST N",
    "dropphycty": "MOUND CITY",
    "dropphyst": "SD",
    "dropphyzpp": 576469998,
    "dropmaladd": "202 MAIN ST N",
    "dropmalcty": "MOUND CITY",
    "dropmalst": "SD",
    "dropmalzpp": 576469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059553520,
    "dropsitcph": 6059553520,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A952",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "SD",
    "dropdelzpp": 573639998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "SD",
    "dropphyzpp": 573639998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "SD",
    "dropmalzpp": 573639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052365367,
    "dropsitcph": 6052365367,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A955",
    "droptype": "D",
    "dropname": "MURDO",
    "dropdeladd": "216 MAIN ST",
    "dropdelcty": "MURDO",
    "dropdelst": "SD",
    "dropdelzpp": 575599998,
    "dropphyadd": "216 MAIN ST",
    "dropphycty": "MURDO",
    "dropphyst": "SD",
    "dropphyzpp": 575599998,
    "dropmaladd": "216 MAIN ST",
    "dropmalcty": "MURDO",
    "dropmalst": "SD",
    "dropmalzpp": 575599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052778347,
    "dropsitcph": 6052778347,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A959",
    "droptype": "D",
    "dropname": "NEMO",
    "dropdeladd": "12748 NEMO RD",
    "dropdelcty": "NEMO",
    "dropdelst": "SD",
    "dropdelzpp": 577599998,
    "dropphyadd": "12748 NEMO RD",
    "dropphycty": "NEMO",
    "dropphyst": "SD",
    "dropphyzpp": 577599998,
    "dropmaladd": "12748 NEMO RD",
    "dropmalcty": "NEMO",
    "dropmalst": "SD",
    "dropmalzpp": 577599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055781806,
    "dropsitcph": 6055781806,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A960",
    "droptype": "D",
    "dropname": "NEW EFFINGTON",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "NEW EFFINGTON",
    "dropdelst": "SD",
    "dropdelzpp": 572559998,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "NEW EFFINGTON",
    "dropphyst": "SD",
    "dropphyzpp": 572559998,
    "dropmaladd": "211 MAIN ST",
    "dropmalcty": "NEW EFFINGTON",
    "dropmalst": "SD",
    "dropmalzpp": 572559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056375392,
    "dropsitcph": 6052299783,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A961",
    "droptype": "D",
    "dropname": "NEW HOLLAND",
    "dropdeladd": "208 E MAIN ST",
    "dropdelcty": "NEW HOLLAND",
    "dropdelst": "SD",
    "dropdelzpp": 573649998,
    "dropphyadd": "208 E MAIN ST",
    "dropphycty": "NEW HOLLAND",
    "dropphyst": "SD",
    "dropphyzpp": 573649998,
    "dropmaladd": "208 E MAIN ST",
    "dropmalcty": "NEW HOLLAND",
    "dropmalst": "SD",
    "dropmalzpp": 573649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052432299,
    "dropsitcph": 6052432299,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A962",
    "droptype": "D",
    "dropname": "NEW UNDERWOOD",
    "dropdeladd": "408 S A AVE",
    "dropdelcty": "NEW UNDERWOOD",
    "dropdelst": "SD",
    "dropdelzpp": 577619998,
    "dropphyadd": "408 S A AVE",
    "dropphycty": "NEW UNDERWOOD",
    "dropphyst": "SD",
    "dropphyzpp": 577619998,
    "dropmaladd": "408 S A AVE",
    "dropmalcty": "NEW UNDERWOOD",
    "dropmalst": "SD",
    "dropmalzpp": 577619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057546456,
    "dropsitcph": 6057546456,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A964",
    "droptype": "D",
    "dropname": "NEWELL",
    "dropdeladd": "207 GIRARD AVE",
    "dropdelcty": "NEWELL",
    "dropdelst": "SD",
    "dropdelzpp": 577609998,
    "dropphyadd": "207 GIRARD AVE",
    "dropphycty": "NEWELL",
    "dropphyst": "SD",
    "dropphyzpp": 577609998,
    "dropmaladd": "207 GIRARD AVE",
    "dropmalcty": "NEWELL",
    "dropmalst": "SD",
    "dropmalzpp": 577609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054562345,
    "dropsitcph": 6054562345,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A965",
    "droptype": "D",
    "dropname": "NISLAND",
    "dropdeladd": "405 2ND ST",
    "dropdelcty": "NISLAND",
    "dropdelst": "SD",
    "dropdelzpp": 577629998,
    "dropphyadd": "405 2ND ST",
    "dropphycty": "NISLAND",
    "dropphyst": "SD",
    "dropphyzpp": 577629998,
    "dropmaladd": "405 2ND ST",
    "dropmalcty": "NISLAND",
    "dropmalst": "SD",
    "dropmalzpp": 577629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052572121,
    "dropsitcph": 6052572121,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A969",
    "droptype": "D",
    "dropname": "NORRIS",
    "dropdeladd": "27149 SD HIGHWAY 63",
    "dropdelcty": "NORRIS",
    "dropdelst": "SD",
    "dropdelzpp": 575609998,
    "dropphyadd": "27149 SD HIGHWAY 63",
    "dropphycty": "NORRIS",
    "dropphyst": "SD",
    "dropphyzpp": 575609998,
    "dropmaladd": "27149 SD HIGHWAY 63",
    "dropmalcty": "NORRIS",
    "dropmalst": "SD",
    "dropmalzpp": 575609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054626398,
    "dropsitcph": 6054626398,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A970",
    "droptype": "D",
    "dropname": "NORTH SIOUX CITY",
    "dropdeladd": "310 N DERBY LN",
    "dropdelcty": "NORTH SIOUX CITY",
    "dropdelst": "SD",
    "dropdelzpp": 570499998,
    "dropphyadd": "310 N DERBY LN",
    "dropphycty": "NORTH SIOUX CITY",
    "dropphyst": "SD",
    "dropphyzpp": 570499998,
    "dropmaladd": "310 N DERBY LN",
    "dropmalcty": "NORTH SIOUX CITY",
    "dropmalst": "SD",
    "dropmalzpp": 570499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052324206,
    "dropsitcph": 6052324206,
    "dropfax": 6052323165
  },
  {
    "dcode": "D",
    "dropkey": "PW1A971",
    "droptype": "D",
    "dropname": "NORTHVILLE",
    "dropdeladd": "306 W ELM ST",
    "dropdelcty": "NORTHVILLE",
    "dropdelst": "SD",
    "dropdelzpp": 574659998,
    "dropphyadd": "306 W ELM ST",
    "dropphycty": "NORTHVILLE",
    "dropphyst": "SD",
    "dropphyzpp": 574659998,
    "dropmaladd": "306 W ELM ST",
    "dropmalcty": "NORTHVILLE",
    "dropmalst": "SD",
    "dropmalzpp": 574659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058873477,
    "dropsitcph": 6058873477,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A974",
    "droptype": "D",
    "dropname": "NUNDA",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "NUNDA",
    "dropdelst": "SD",
    "dropdelzpp": 570509998,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "NUNDA",
    "dropphyst": "SD",
    "dropphyzpp": 570509998,
    "dropmaladd": "409 MAIN ST",
    "dropmalcty": "NUNDA",
    "dropmalst": "SD",
    "dropmalzpp": 570509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055864336,
    "dropsitcph": 6055864336,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A975",
    "droptype": "D",
    "dropname": "OACOMA",
    "dropdeladd": "101 W 2ND ST",
    "dropdelcty": "OACOMA",
    "dropdelst": "SD",
    "dropdelzpp": 573659998,
    "dropphyadd": "101 W 2ND ST",
    "dropphycty": "OACOMA",
    "dropphyst": "SD",
    "dropphyzpp": 573659998,
    "dropmaladd": "101 W 2ND ST",
    "dropmalcty": "OACOMA",
    "dropmalst": "SD",
    "dropmalzpp": 573659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057342546,
    "dropsitcph": 6057342546,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A978",
    "droptype": "D",
    "dropname": "OELRICHS",
    "dropdeladd": "411 MAIN ST",
    "dropdelcty": "OELRICHS",
    "dropdelst": "SD",
    "dropdelzpp": 577639998,
    "dropphyadd": "411 MAIN ST",
    "dropphycty": "OELRICHS",
    "dropphyst": "SD",
    "dropphyzpp": 577639998,
    "dropmaladd": "411 MAIN ST",
    "dropmalcty": "OELRICHS",
    "dropmalst": "SD",
    "dropmalzpp": 577639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059821087,
    "dropsitcph": 6059821087,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A979",
    "droptype": "D",
    "dropname": "OGLALA",
    "dropdeladd": "1 HIGHWAY 18 W",
    "dropdelcty": "OGLALA",
    "dropdelst": "SD",
    "dropdelzpp": 577649998,
    "dropphyadd": "1 HIGHWAY 18 W",
    "dropphycty": "OGLALA",
    "dropphyst": "SD",
    "dropphyzpp": 577649998,
    "dropmaladd": "1 HIGHWAY 18 W",
    "dropmalcty": "OGLALA",
    "dropmalst": "SD",
    "dropmalzpp": 577649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058675351,
    "dropsitcph": 6058675351,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A983",
    "droptype": "D",
    "dropname": "OKREEK",
    "dropdeladd": "1 SE FIRST ST",
    "dropdelcty": "OKREEK",
    "dropdelst": "SD",
    "dropdelzpp": 575639998,
    "dropphyadd": "1 SE FIRST ST",
    "dropphycty": "OKREEK",
    "dropphyst": "SD",
    "dropphyzpp": 575639998,
    "dropmaladd": "1 SE FIRST ST",
    "dropmalcty": "OKREEK",
    "dropmalst": "SD",
    "dropmalzpp": 575639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058562651,
    "dropsitcph": 6058562651,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A986",
    "droptype": "D",
    "dropname": "OLDHAM",
    "dropdeladd": "105 N LILLIE AVE",
    "dropdelcty": "OLDHAM",
    "dropdelst": "SD",
    "dropdelzpp": 570519998,
    "dropphyadd": "105 N LILLIE AVE",
    "dropphycty": "OLDHAM",
    "dropphyst": "SD",
    "dropphyzpp": 570519998,
    "dropmaladd": "105 N LILLIE AVE",
    "dropmalcty": "OLDHAM",
    "dropmalst": "SD",
    "dropmalzpp": 570519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054828492,
    "dropsitcph": 6054828492,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A987",
    "droptype": "D",
    "dropname": "OLIVET",
    "dropdeladd": "145 EUCLID ST",
    "dropdelcty": "OLIVET",
    "dropdelst": "SD",
    "dropdelzpp": 570529998,
    "dropphyadd": "145 EUCLID ST",
    "dropphycty": "OLIVET",
    "dropphyst": "SD",
    "dropphyzpp": 570529998,
    "dropmaladd": "145 EUCLID ST",
    "dropmalcty": "OLIVET",
    "dropmalst": "SD",
    "dropmalzpp": 570529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053875131,
    "dropsitcph": 6053875131,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A990",
    "droptype": "D",
    "dropname": "ONAKA",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "ONAKA",
    "dropdelst": "SD",
    "dropdelzpp": 574669998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "ONAKA",
    "dropphyst": "SD",
    "dropphyzpp": 574669998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "ONAKA",
    "dropmalst": "SD",
    "dropmalzpp": 574669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054475885,
    "dropsitcph": 6054475885,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A991",
    "droptype": "D",
    "dropname": "ONIDA",
    "dropdeladd": "703 BIRCH AVE",
    "dropdelcty": "ONIDA",
    "dropdelst": "SD",
    "dropdelzpp": 575649998,
    "dropphyadd": "703 BIRCH AVE",
    "dropphycty": "ONIDA",
    "dropphyst": "SD",
    "dropphyzpp": 575649998,
    "dropmaladd": "703 BIRCH AVE",
    "dropmalcty": "ONIDA",
    "dropmalst": "SD",
    "dropmalzpp": 575649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052582421,
    "dropsitcph": 6052582421,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A993",
    "droptype": "D",
    "dropname": "ORAL",
    "dropdeladd": "117 S GOODMAN ST",
    "dropdelcty": "ORAL",
    "dropdelst": "SD",
    "dropdelzpp": 577669998,
    "dropphyadd": "117 S GOODMAN ST",
    "dropphycty": "ORAL",
    "dropphyst": "SD",
    "dropphyzpp": 577669998,
    "dropmaladd": "117 S GOODMAN ST",
    "dropmalcty": "ORAL",
    "dropmalst": "SD",
    "dropmalzpp": 577669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059821085,
    "dropsitcph": 6059821085,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1A995",
    "droptype": "D",
    "dropname": "ORIENT",
    "dropdeladd": "101 WINTER ST",
    "dropdelcty": "ORIENT",
    "dropdelst": "SD",
    "dropdelzpp": 574679998,
    "dropphyadd": "101 WINTER ST",
    "dropphycty": "ORIENT",
    "dropphyst": "SD",
    "dropphyzpp": 574679998,
    "dropmaladd": "101 WINTER ST",
    "dropmalcty": "ORIENT",
    "dropmalst": "SD",
    "dropmalzpp": 574679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053922323,
    "dropsitcph": 6053922323,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B006",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "125 S MAIN AVE",
    "dropdelcty": "PARKER",
    "dropdelst": "SD",
    "dropdelzpp": 570539998,
    "dropphyadd": "125 S MAIN AVE",
    "dropphycty": "PARKER",
    "dropphyst": "SD",
    "dropphyzpp": 570539998,
    "dropmaladd": "125 S MAIN AVE",
    "dropmalcty": "PARKER",
    "dropmalst": "SD",
    "dropmalzpp": 570539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056671069,
    "dropsitcph": 6056671069,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B007",
    "droptype": "D",
    "dropname": "PARKSTON",
    "dropdeladd": "111 N 1ST ST",
    "dropdelcty": "PARKSTON",
    "dropdelst": "SD",
    "dropdelzpp": 573669998,
    "dropphyadd": "111 N 1ST ST",
    "dropphycty": "PARKSTON",
    "dropphyst": "SD",
    "dropphyzpp": 573669998,
    "dropmaladd": "111 N 1ST ST",
    "dropmalcty": "PARKSTON",
    "dropmalst": "SD",
    "dropmalzpp": 573669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055507395,
    "dropsitcph": 6055507395,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B008",
    "droptype": "D",
    "dropname": "PARMELEE",
    "dropdeladd": "200 2ND ST",
    "dropdelcty": "PARMELEE",
    "dropdelst": "SD",
    "dropdelzpp": 575669998,
    "dropphyadd": "200 2ND ST",
    "dropphycty": "PARMELEE",
    "dropphyst": "SD",
    "dropphyzpp": 575669998,
    "dropmaladd": "200 2ND ST",
    "dropmalcty": "PARMELEE",
    "dropmalst": "SD",
    "dropmalzpp": 575669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057472579,
    "dropsitcph": 6057472579,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B012",
    "droptype": "D",
    "dropname": "PEEVER",
    "dropdeladd": "310 MAIN ST",
    "dropdelcty": "PEEVER",
    "dropdelst": "SD",
    "dropdelzpp": 572579998,
    "dropphyadd": "310 MAIN ST",
    "dropphycty": "PEEVER",
    "dropphyst": "SD",
    "dropphyzpp": 572579998,
    "dropmaladd": "310 MAIN ST",
    "dropmalcty": "PEEVER",
    "dropmalst": "SD",
    "dropmalzpp": 572579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059323622,
    "dropsitcph": 6059323622,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B014",
    "droptype": "D",
    "dropname": "PHILIP",
    "dropdeladd": "214 E PINE ST",
    "dropdelcty": "PHILIP",
    "dropdelst": "SD",
    "dropdelzpp": 575679998,
    "dropphyadd": "214 E PINE ST",
    "dropphycty": "PHILIP",
    "dropphyst": "SD",
    "dropphyzpp": 575679998,
    "dropmaladd": "214 E PINE ST",
    "dropmalcty": "PHILIP",
    "dropmalst": "SD",
    "dropmalzpp": 575679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058592131,
    "dropsitcph": 6058592131,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B015",
    "droptype": "D",
    "dropname": "PICKSTOWN",
    "dropdeladd": "106 LEWIS AVE",
    "dropdelcty": "PICKSTOWN",
    "dropdelst": "SD",
    "dropdelzpp": 573679998,
    "dropphyadd": "106 LEWIS AVE",
    "dropphycty": "PICKSTOWN",
    "dropphyst": "SD",
    "dropphyzpp": 573679998,
    "dropmaladd": "106 LEWIS AVE",
    "dropmalcty": "PICKSTOWN",
    "dropmalst": "SD",
    "dropmalzpp": 573679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054877770,
    "dropsitcph": 6054877770,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B016",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "10224 MAIN ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "SD",
    "dropdelzpp": 577699998,
    "dropphyadd": "10224 MAIN ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "SD",
    "dropphyzpp": 577699998,
    "dropmaladd": "10224 MAIN ST",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "SD",
    "dropmalzpp": 577699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057874731,
    "dropsitcph": 6057874731,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B017",
    "droptype": "D",
    "dropname": "PIERPONT",
    "dropdeladd": "121 W MAIN ST",
    "dropdelcty": "PIERPONT",
    "dropdelst": "SD",
    "dropdelzpp": 574689998,
    "dropphyadd": "121 W MAIN ST",
    "dropphycty": "PIERPONT",
    "dropphyst": "SD",
    "dropphyzpp": 574689998,
    "dropmaladd": "121 W MAIN ST",
    "dropmalcty": "PIERPONT",
    "dropmalst": "SD",
    "dropmalzpp": 574689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053253463,
    "dropsitcph": 6053253463,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B019",
    "droptype": "D",
    "dropname": "PIERRE",
    "dropdeladd": "225 S PIERRE ST STE 101",
    "dropdelcty": "PIERRE",
    "dropdelst": "SD",
    "dropdelzpp": 575019998,
    "dropphyadd": "225 S PIERRE ST STE 101",
    "dropphycty": "PIERRE",
    "dropphyst": "SD",
    "dropphyzpp": 575019998,
    "dropmaladd": "225 S PIERRE ST STE 101",
    "dropmalcty": "PIERRE",
    "dropmalst": "SD",
    "dropmalzpp": 575019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052241204,
    "dropsitcph": 6052241204,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B020",
    "droptype": "D",
    "dropname": "PINE RIDGE",
    "dropdeladd": "1 HIGHWAY 18",
    "dropdelcty": "PINE RIDGE",
    "dropdelst": "SD",
    "dropdelzpp": 577709998,
    "dropphyadd": "1 HIGHWAY 18",
    "dropphycty": "PINE RIDGE",
    "dropphyst": "SD",
    "dropphyzpp": 577709998,
    "dropmaladd": "1 HIGHWAY 18",
    "dropmalcty": "PINE RIDGE",
    "dropmalst": "SD",
    "dropmalzpp": 577709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058675430,
    "dropsitcph": 6058675430,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B024",
    "droptype": "D",
    "dropname": "PLANKINTON",
    "dropdeladd": "208 N MAIN ST",
    "dropdelcty": "PLANKINTON",
    "dropdelst": "SD",
    "dropdelzpp": 573689998,
    "dropphyadd": "208 N MAIN ST",
    "dropphycty": "PLANKINTON",
    "dropphyst": "SD",
    "dropphyzpp": 573689998,
    "dropmaladd": "208 N MAIN ST",
    "dropmalcty": "PLANKINTON",
    "dropmalst": "SD",
    "dropmalzpp": 573689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059427584,
    "dropsitcph": 6059427584,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B026",
    "droptype": "D",
    "dropname": "PLATTE",
    "dropdeladd": "20 E 5TH ST",
    "dropdelcty": "PLATTE",
    "dropdelst": "SD",
    "dropdelzpp": 573699998,
    "dropphyadd": "20 E 5TH ST",
    "dropphycty": "PLATTE",
    "dropphyst": "SD",
    "dropphyzpp": 573699998,
    "dropmaladd": "20 E 5TH ST",
    "dropmalcty": "PLATTE",
    "dropmalst": "SD",
    "dropmalzpp": 573699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053373491,
    "dropsitcph": 6053373491,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B029",
    "droptype": "D",
    "dropname": "POLLOCK",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "POLLOCK",
    "dropdelst": "SD",
    "dropdelzpp": 576489998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "POLLOCK",
    "dropphyst": "SD",
    "dropphyzpp": 576489998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "POLLOCK",
    "dropmalst": "SD",
    "dropmalzpp": 576489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058892430,
    "dropsitcph": 6058892430,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B031",
    "droptype": "D",
    "dropname": "PORCUPINE",
    "dropdeladd": "111 EAGLE DR",
    "dropdelcty": "PORCUPINE",
    "dropdelst": "SD",
    "dropdelzpp": 577729998,
    "dropphyadd": "111 EAGLE DR",
    "dropphycty": "PORCUPINE",
    "dropphyst": "SD",
    "dropphyzpp": 577729998,
    "dropmaladd": "111 EAGLE DR",
    "dropmalcty": "PORCUPINE",
    "dropmalst": "SD",
    "dropmalzpp": 577729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058675539,
    "dropsitcph": 6058675539,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B035",
    "droptype": "D",
    "dropname": "PRESHO",
    "dropdeladd": "210 N MAIN AVE",
    "dropdelcty": "PRESHO",
    "dropdelst": "SD",
    "dropdelzpp": 575689998,
    "dropphyadd": "210 N MAIN AVE",
    "dropphycty": "PRESHO",
    "dropphyst": "SD",
    "dropphyzpp": 575689998,
    "dropmaladd": "210 N MAIN AVE",
    "dropmalcty": "PRESHO",
    "dropmalst": "SD",
    "dropmalzpp": 575689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058952460,
    "dropsitcph": 6058952460,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B036",
    "droptype": "D",
    "dropname": "PRINGLE",
    "dropdeladd": "369 MAIN ST",
    "dropdelcty": "PRINGLE",
    "dropdelst": "SD",
    "dropdelzpp": 577739998,
    "dropphyadd": "369 MAIN ST",
    "dropphycty": "PRINGLE",
    "dropphyst": "SD",
    "dropphyzpp": 577739998,
    "dropmaladd": "369 MAIN ST",
    "dropmalcty": "PRINGLE",
    "dropmalst": "SD",
    "dropmalzpp": 577739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056733149,
    "dropsitcph": 6056733149,
    "dropfax": 6056733531
  },
  {
    "dcode": "D",
    "dropkey": "PW1B039",
    "droptype": "D",
    "dropname": "PUKWANA",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "PUKWANA",
    "dropdelst": "SD",
    "dropdelzpp": 573709998,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "PUKWANA",
    "dropphyst": "SD",
    "dropphyzpp": 573709998,
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "PUKWANA",
    "dropmalst": "SD",
    "dropmalzpp": 573709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057342483,
    "dropsitcph": 6057342483,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B041",
    "droptype": "D",
    "dropname": "QUINN",
    "dropdeladd": "30 HIGHWAY 1416",
    "dropdelcty": "QUINN",
    "dropdelst": "SD",
    "dropdelzpp": 577759998,
    "dropphyadd": "30 HIGHWAY 1416",
    "dropphycty": "QUINN",
    "dropphyst": "SD",
    "dropphyzpp": 577759998,
    "dropmaladd": "30 HIGHWAY 1416",
    "dropmalcty": "QUINN",
    "dropmalst": "SD",
    "dropmalzpp": 577759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053862482,
    "dropsitcph": 6053862482,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B043",
    "droptype": "D",
    "dropname": "RAMONA",
    "dropdeladd": "217 E MAIN ST",
    "dropdelcty": "RAMONA",
    "dropdelst": "SD",
    "dropdelzpp": 570549998,
    "dropphyadd": "217 E MAIN ST",
    "dropphycty": "RAMONA",
    "dropphyst": "SD",
    "dropphyzpp": 570549998,
    "dropmaladd": "217 E MAIN ST",
    "dropmalcty": "RAMONA",
    "dropmalst": "SD",
    "dropmalzpp": 570549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054828556,
    "dropsitcph": 6054828556,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B047",
    "droptype": "D",
    "dropname": "RAPID CITY",
    "dropdeladd": "500 EAST BLVD",
    "dropdelcty": "RAPID CITY",
    "dropdelst": "SD",
    "dropdelzpp": 577019998,
    "dropphyadd": "500 EAST BLVD",
    "dropphycty": "RAPID CITY",
    "dropphyst": "SD",
    "dropphyzpp": 577019998,
    "dropmaladd": "500 EAST BLVD",
    "dropmalcty": "RAPID CITY",
    "dropmalst": "SD",
    "dropmalzpp": 577019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053948634,
    "dropsitcph": 6053948617,
    "dropfax": 6053948616
  },
  {
    "dcode": "D",
    "dropkey": "PW1B050",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "211 FLOWER ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "SD",
    "dropdelzpp": 572589998,
    "dropphyadd": "211 FLOWER ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "SD",
    "dropphyzpp": 572589998,
    "dropmaladd": "211 FLOWER ST",
    "dropmalcty": "RAYMOND",
    "dropmalst": "SD",
    "dropmalzpp": 572589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055323510,
    "dropsitcph": 6055323510,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B055",
    "droptype": "D",
    "dropname": "REDFIELD",
    "dropdeladd": "24 E 6TH AVE",
    "dropdelcty": "REDFIELD",
    "dropdelst": "SD",
    "dropdelzpp": 574699998,
    "dropphyadd": "24 E 6TH AVE",
    "dropphycty": "REDFIELD",
    "dropphyst": "SD",
    "dropphyzpp": 574699998,
    "dropmaladd": "24 E 6TH AVE",
    "dropmalcty": "REDFIELD",
    "dropmalst": "SD",
    "dropmalzpp": 574699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053574930,
    "dropsitcph": 6054720311,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B056",
    "droptype": "D",
    "dropname": "REDIG",
    "dropdeladd": "14695 US HIGHWAY 85",
    "dropdelcty": "REDIG",
    "dropdelst": "SD",
    "dropdelzpp": 577769998,
    "dropphyadd": "14695 US HIGHWAY 85",
    "dropphycty": "REDIG",
    "dropphyst": "SD",
    "dropphyzpp": 577769998,
    "dropmaladd": "14695 US HIGHWAY 85",
    "dropmalcty": "REDIG",
    "dropmalst": "SD",
    "dropmalzpp": 577769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053753636,
    "dropsitcph": 6053753636,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B058",
    "droptype": "D",
    "dropname": "REE HEIGHTS",
    "dropdeladd": "108 DAKOTA AVE S",
    "dropdelcty": "REE HEIGHTS",
    "dropdelst": "SD",
    "dropdelzpp": 573719998,
    "dropphyadd": "108 DAKOTA AVE S",
    "dropphycty": "REE HEIGHTS",
    "dropphyst": "SD",
    "dropphyzpp": 573719998,
    "dropmaladd": "108 DAKOTA AVE S",
    "dropmalcty": "REE HEIGHTS",
    "dropmalst": "SD",
    "dropmalzpp": 573719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059435630,
    "dropsitcph": 6059435630,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B059",
    "droptype": "D",
    "dropname": "RELIANCE",
    "dropdeladd": "202 W HIGHWAY 47",
    "dropdelcty": "RELIANCE",
    "dropdelst": "SD",
    "dropdelzpp": 575699998,
    "dropphyadd": "202 W HIGHWAY 47",
    "dropphycty": "RELIANCE",
    "dropphyst": "SD",
    "dropphyzpp": 575699998,
    "dropmaladd": "202 W HIGHWAY 47",
    "dropmalcty": "RELIANCE",
    "dropmalst": "SD",
    "dropmalzpp": 575699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057342611,
    "dropsitcph": 6057342611,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B061",
    "droptype": "D",
    "dropname": "REVA",
    "dropdeladd": "14759 SD HIGHWAY 20",
    "dropdelcty": "REVA",
    "dropdelst": "SD",
    "dropdelzpp": 576519998,
    "dropphyadd": "14759 SD HIGHWAY 20",
    "dropphycty": "REVA",
    "dropphyst": "SD",
    "dropphyzpp": 576519998,
    "dropmaladd": "14759 SD HIGHWAY 20",
    "dropmalcty": "REVA",
    "dropmalst": "SD",
    "dropmalzpp": 576519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053753527,
    "dropsitcph": 6053753527,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B062",
    "droptype": "D",
    "dropname": "REVILLO",
    "dropdeladd": "317 N 2ND AVE",
    "dropdelcty": "REVILLO",
    "dropdelst": "SD",
    "dropdelzpp": 572599998,
    "dropphyadd": "317 N 2ND AVE",
    "dropphycty": "REVILLO",
    "dropphyst": "SD",
    "dropphyzpp": 572599998,
    "dropmaladd": "317 N 2ND AVE",
    "dropmalcty": "REVILLO",
    "dropmalst": "SD",
    "dropmalzpp": 572599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056234461,
    "dropsitcph": 6056234461,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B064",
    "droptype": "D",
    "dropname": "RIDGEVIEW",
    "dropdeladd": "15951 264 1/2 AVE",
    "dropdelcty": "RIDGEVIEW",
    "dropdelst": "SD",
    "dropdelzpp": 576529998,
    "dropphyadd": "15951 264 1/2 AVE",
    "dropphycty": "RIDGEVIEW",
    "dropphyst": "SD",
    "dropphyzpp": 576529998,
    "dropmaladd": "15951 264 1/2 AVE",
    "dropmalcty": "RIDGEVIEW",
    "dropmalst": "SD",
    "dropmalzpp": 576529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057332400,
    "dropsitcph": 6057332400,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B068",
    "droptype": "D",
    "dropname": "ROCKHAM",
    "dropdeladd": "116 S BROADWAY AVE",
    "dropdelcty": "ROCKHAM",
    "dropdelst": "SD",
    "dropdelzpp": 574709998,
    "dropphyadd": "116 S BROADWAY AVE",
    "dropphycty": "ROCKHAM",
    "dropphyst": "SD",
    "dropphyzpp": 574709998,
    "dropmaladd": "116 S BROADWAY AVE",
    "dropmalcty": "ROCKHAM",
    "dropmalst": "SD",
    "dropmalzpp": 574709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054721236,
    "dropsitcph": 6054721236,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B071",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "SD",
    "dropdelzpp": 574719998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "SD",
    "dropphyzpp": 574719998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "SD",
    "dropmalzpp": 574719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052874341,
    "dropsitcph": 6052874341,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B072",
    "droptype": "D",
    "dropname": "ROSEBUD",
    "dropdeladd": "123 E SHARPFISH ST",
    "dropdelcty": "ROSEBUD",
    "dropdelst": "SD",
    "dropdelzpp": 575709998,
    "dropphyadd": "123 E SHARPFISH ST",
    "dropphycty": "ROSEBUD",
    "dropphyst": "SD",
    "dropphyzpp": 575709998,
    "dropmaladd": "123 E SHARPFISH ST",
    "dropmalcty": "ROSEBUD",
    "dropmalst": "SD",
    "dropmalzpp": 575709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057472295,
    "dropsitcph": 6057472295,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B074",
    "droptype": "D",
    "dropname": "ROSHOLT",
    "dropdeladd": "12 W MAIN ST",
    "dropdelcty": "ROSHOLT",
    "dropdelst": "SD",
    "dropdelzpp": 572609998,
    "dropphyadd": "12 W MAIN ST",
    "dropphycty": "ROSHOLT",
    "dropphyst": "SD",
    "dropphyzpp": 572609998,
    "dropmaladd": "12 W MAIN ST",
    "dropmalcty": "ROSHOLT",
    "dropmalst": "SD",
    "dropmalzpp": 572609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058246173,
    "dropsitcph": 6055038917,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B075",
    "droptype": "D",
    "dropname": "ROSLYN",
    "dropdeladd": "509 N MAIN ST",
    "dropdelcty": "ROSLYN",
    "dropdelst": "SD",
    "dropdelzpp": 572619998,
    "dropphyadd": "509 N MAIN ST",
    "dropphycty": "ROSLYN",
    "dropphyst": "SD",
    "dropphyzpp": 572619998,
    "dropmaladd": "509 N MAIN ST",
    "dropmalcty": "ROSLYN",
    "dropmalst": "SD",
    "dropmalzpp": 572619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054864236,
    "dropsitcph": 6054864236,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B085",
    "droptype": "D",
    "dropname": "SAINT FRANCIS",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SAINT FRANCIS",
    "dropdelst": "SD",
    "dropdelzpp": 575729998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SAINT FRANCIS",
    "dropphyst": "SD",
    "dropphyzpp": 575729998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "SAINT FRANCIS",
    "dropmalst": "SD",
    "dropmalzpp": 575729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052778748,
    "dropsitcph": 6052778748,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B086",
    "droptype": "D",
    "dropname": "SAINT LAWRENCE",
    "dropdeladd": "201 N COMMERCIAL AVE",
    "dropdelcty": "SAINT LAWRENCE",
    "dropdelst": "SD",
    "dropdelzpp": 573739998,
    "dropphyadd": "201 N COMMERCIAL AVE",
    "dropphycty": "SAINT LAWRENCE",
    "dropphyst": "SD",
    "dropphyzpp": 573739998,
    "dropmaladd": "201 N COMMERCIAL AVE",
    "dropmalcty": "SAINT LAWRENCE",
    "dropmalst": "SD",
    "dropmalzpp": 573739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058532173,
    "dropsitcph": 6058532173,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B087",
    "droptype": "D",
    "dropname": "SAINT ONGE",
    "dropdeladd": "176 PURL ST",
    "dropdelcty": "SAINT ONGE",
    "dropdelst": "SD",
    "dropdelzpp": 577799998,
    "dropphyadd": "176 PURL ST",
    "dropphycty": "SAINT ONGE",
    "dropphyst": "SD",
    "dropphyzpp": 577799998,
    "dropmaladd": "176 PURL ST",
    "dropmalcty": "SAINT ONGE",
    "dropmalst": "SD",
    "dropmalzpp": 577799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056422436,
    "dropsitcph": 6056422436,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B088",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "311 N MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "SD",
    "dropdelzpp": 570589998,
    "dropphyadd": "311 N MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "SD",
    "dropphyzpp": 570589998,
    "dropmaladd": "311 N MAIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "SD",
    "dropmalzpp": 570589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054252861,
    "dropsitcph": 6054252861,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B093",
    "droptype": "D",
    "dropname": "SCENIC",
    "dropdeladd": "27 2ND ST",
    "dropdelcty": "SCENIC",
    "dropdelst": "SD",
    "dropdelzpp": 577809998,
    "dropphyadd": "27 2ND ST",
    "dropphycty": "SCENIC",
    "dropphyst": "SD",
    "dropphyzpp": 577809998,
    "dropmaladd": "27 2ND ST",
    "dropmalcty": "SCENIC",
    "dropmalst": "SD",
    "dropmalzpp": 577809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059936120,
    "dropsitcph": 6059936120,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B094",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "640 1ST ST",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "SD",
    "dropdelzpp": 570599998,
    "dropphyadd": "640 1ST ST",
    "dropphycty": "SCOTLAND",
    "dropphyst": "SD",
    "dropphyzpp": 570599998,
    "dropmaladd": "640 1ST ST",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "SD",
    "dropmalzpp": 570599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052525504,
    "dropsitcph": 6502525504,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B096",
    "droptype": "D",
    "dropname": "SELBY",
    "dropdeladd": "3408 MAIN ST",
    "dropdelcty": "SELBY",
    "dropdelst": "SD",
    "dropdelzpp": 574729998,
    "dropphyadd": "3408 MAIN ST",
    "dropphycty": "SELBY",
    "dropphyst": "SD",
    "dropphyzpp": 574729998,
    "dropmaladd": "3408 MAIN ST",
    "dropmalcty": "SELBY",
    "dropmalst": "SD",
    "dropmalzpp": 574729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056497088,
    "dropsitcph": 6056497088,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B097",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "200 PINE ST",
    "dropdelcty": "SENECA",
    "dropdelst": "SD",
    "dropdelzpp": 574739998,
    "dropphyadd": "200 PINE ST",
    "dropphycty": "SENECA",
    "dropphyst": "SD",
    "dropphyzpp": 574739998,
    "dropmaladd": "200 PINE ST",
    "dropmalcty": "SENECA",
    "dropmalst": "SD",
    "dropmalzpp": 574739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054366243,
    "dropsitcph": 6054366243,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B106",
    "droptype": "D",
    "dropname": "SINAI",
    "dropdeladd": "301 MAIN AVE",
    "dropdelcty": "SINAI",
    "dropdelst": "SD",
    "dropdelzpp": 570619998,
    "dropphyadd": "301 MAIN AVE",
    "dropphycty": "SINAI",
    "dropphyst": "SD",
    "dropphyzpp": 570619998,
    "dropmaladd": "301 MAIN AVE",
    "dropmalcty": "SINAI",
    "dropmalst": "SD",
    "dropmalzpp": 570619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058264306,
    "dropsitcph": 6058264306,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B109",
    "droptype": "D",
    "dropname": "SIOUX FALLS",
    "dropdeladd": "320 S 2ND AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571047500,
    "dropphyadd": "320 S 2ND AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571047500,
    "dropmaladd": "320 S 2ND AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571047500,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055753542,
    "dropsitcph": 6055753542,
    "dropfax": 6055753553
  },
  {
    "dcode": "D",
    "dropkey": "PW1B110",
    "droptype": "D",
    "dropname": "SISSETON",
    "dropdeladd": "205 E OAK ST STE 103",
    "dropdelcty": "SISSETON",
    "dropdelst": "SD",
    "dropdelzpp": 572629998,
    "dropphyadd": "205 E OAK ST STE 103",
    "dropphycty": "SISSETON",
    "dropphyst": "SD",
    "dropphyzpp": 572629998,
    "dropmaladd": "205 E OAK ST STE 103",
    "dropmalcty": "SISSETON",
    "dropmalst": "SD",
    "dropmalzpp": 572629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056987121,
    "dropsitcph": 6056987121,
    "dropfax": 6056987470
  },
  {
    "dcode": "D",
    "dropkey": "PW1B116",
    "droptype": "D",
    "dropname": "SOUTH SHORE",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "SOUTH SHORE",
    "dropdelst": "SD",
    "dropdelzpp": 572639998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "SOUTH SHORE",
    "dropphyst": "SD",
    "dropphyzpp": 572639998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "SOUTH SHORE",
    "dropmalst": "SD",
    "dropmalzpp": 572639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057564111,
    "dropsitcph": 6057564111,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B118",
    "droptype": "D",
    "dropname": "SPEARFISH",
    "dropdeladd": "120 YANKEE ST",
    "dropdelcty": "SPEARFISH",
    "dropdelst": "SD",
    "dropdelzpp": 577839998,
    "dropphyadd": "120 YANKEE ST",
    "dropphycty": "SPEARFISH",
    "dropphyst": "SD",
    "dropphyzpp": 577839998,
    "dropmaladd": "120 YANKEE ST",
    "dropmalcty": "SPEARFISH",
    "dropmalst": "SD",
    "dropmalzpp": 577839998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056423119,
    "dropsitcph": 6056423119,
    "dropfax": 6056425135
  },
  {
    "dcode": "D",
    "dropkey": "PW1B120",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "SD",
    "dropdelzpp": 573749998,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "SPENCER",
    "dropphyst": "SD",
    "dropphyzpp": 573749998,
    "dropmaladd": "306 MAIN ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "SD",
    "dropmalzpp": 573749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052462392,
    "dropsitcph": 6052462392,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B126",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "811 8TH ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "SD",
    "dropdelzpp": 570629998,
    "dropphyadd": "811 8TH ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "SD",
    "dropphyzpp": 570629998,
    "dropmaladd": "811 8TH ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "SD",
    "dropmalzpp": 570629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053695530,
    "dropsitcph": 6052914179,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B167",
    "droptype": "D",
    "dropname": "STICKNEY",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "STICKNEY",
    "dropdelst": "SD",
    "dropdelzpp": 573759998,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "STICKNEY",
    "dropphyst": "SD",
    "dropphyzpp": 573759998,
    "dropmaladd": "309 MAIN ST",
    "dropmalcty": "STICKNEY",
    "dropmalst": "SD",
    "dropmalzpp": 573759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057324277,
    "dropsitcph": 6057324277,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B168",
    "droptype": "D",
    "dropname": "STOCKHOLM",
    "dropdeladd": "204 N MAIN ST",
    "dropdelcty": "STOCKHOLM",
    "dropdelst": "SD",
    "dropdelzpp": 572649998,
    "dropphyadd": "204 N MAIN ST",
    "dropphycty": "STOCKHOLM",
    "dropphyst": "SD",
    "dropphyzpp": 572649998,
    "dropmaladd": "204 N MAIN ST",
    "dropmalcty": "STOCKHOLM",
    "dropmalst": "SD",
    "dropmalzpp": 572649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056762394,
    "dropsitcph": 6056762394,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B174",
    "droptype": "D",
    "dropname": "STURGIS",
    "dropdeladd": "820 KINSHIP RD",
    "dropdelcty": "STURGIS",
    "dropdelst": "SD",
    "dropdelzpp": 577859998,
    "dropphyadd": "820 KINSHIP RD",
    "dropphycty": "STURGIS",
    "dropphyst": "SD",
    "dropphyzpp": 577859998,
    "dropmaladd": "820 KINSHIP RD",
    "dropmalcty": "STURGIS",
    "dropmalst": "SD",
    "dropmalzpp": 577859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053470100,
    "dropsitcph": 6053470100,
    "dropfax": 6053476084
  },
  {
    "dcode": "D",
    "dropkey": "PW1B176",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "301 MAPLE ST",
    "dropdelcty": "SUMMIT",
    "dropdelst": "SD",
    "dropdelzpp": 572669998,
    "dropphyadd": "301 MAPLE ST",
    "dropphycty": "SUMMIT",
    "dropphyst": "SD",
    "dropphyzpp": 572669998,
    "dropmaladd": "301 MAPLE ST",
    "dropmalcty": "SUMMIT",
    "dropmalst": "SD",
    "dropmalzpp": 572669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053986348,
    "dropsitcph": 6053986348,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B182",
    "droptype": "D",
    "dropname": "TABOR",
    "dropdeladd": "105 S LIDICE AVE",
    "dropdelcty": "TABOR",
    "dropdelst": "SD",
    "dropdelzpp": 570639998,
    "dropphyadd": "105 S LIDICE AVE",
    "dropphycty": "TABOR",
    "dropphyst": "SD",
    "dropphyzpp": 570639998,
    "dropmaladd": "105 S LIDICE AVE",
    "dropmalcty": "TABOR",
    "dropmalst": "SD",
    "dropmalzpp": 570639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056535435,
    "dropsitcph": 6056535435,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B184",
    "droptype": "D",
    "dropname": "TEA",
    "dropdeladd": "502 E FIGZEL CT STE A",
    "dropdelcty": "TEA",
    "dropdelst": "SD",
    "dropdelzpp": 570649997,
    "dropphyadd": "502 E FIGZEL CT STE A",
    "dropphycty": "TEA",
    "dropphyst": "SD",
    "dropphyzpp": 570649997,
    "dropmaladd": "502 E FIGZEL CT STE A",
    "dropmalcty": "TEA",
    "dropmalst": "SD",
    "dropmalzpp": 570649997,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053682871,
    "dropsitcph": 6053682871,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B194",
    "droptype": "D",
    "dropname": "TIMBER LAKE",
    "dropdeladd": "801 MAIN ST",
    "dropdelcty": "TIMBER LAKE",
    "dropdelst": "SD",
    "dropdelzpp": 576569998,
    "dropphyadd": "801 MAIN ST",
    "dropphycty": "TIMBER LAKE",
    "dropphyst": "SD",
    "dropphyzpp": 576569998,
    "dropmaladd": "801 MAIN ST",
    "dropmalcty": "TIMBER LAKE",
    "dropmalst": "SD",
    "dropmalzpp": 576569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058653622,
    "dropsitcph": 6058653622,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B195",
    "droptype": "D",
    "dropname": "TOLSTOY",
    "dropdeladd": "102 5TH AVE NW RM 1",
    "dropdelcty": "TOLSTOY",
    "dropdelst": "SD",
    "dropdelzpp": 574759998,
    "dropphyadd": "102 5TH AVE NW RM 1",
    "dropphycty": "TOLSTOY",
    "dropphyst": "SD",
    "dropphyzpp": 574759998,
    "dropmaladd": "102 5TH AVE NW RM 1",
    "dropmalcty": "TOLSTOY",
    "dropmalst": "SD",
    "dropmalzpp": 574759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054422431,
    "dropsitcph": 6054422431,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B196",
    "droptype": "D",
    "dropname": "TORONTO",
    "dropdeladd": "540 MAIN AVE",
    "dropdelcty": "TORONTO",
    "dropdelst": "SD",
    "dropdelzpp": 572689998,
    "dropphyadd": "540 MAIN AVE",
    "dropphycty": "TORONTO",
    "dropphyst": "SD",
    "dropphyzpp": 572689998,
    "dropmaladd": "540 MAIN AVE",
    "dropmalcty": "TORONTO",
    "dropmalst": "SD",
    "dropmalzpp": 572689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057948601,
    "dropsitcph": 6057948601,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B197",
    "droptype": "D",
    "dropname": "TRAIL CITY",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "TRAIL CITY",
    "dropdelst": "SD",
    "dropdelzpp": 576579998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "TRAIL CITY",
    "dropphyst": "SD",
    "dropphyzpp": 576579998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "TRAIL CITY",
    "dropmalst": "SD",
    "dropmalzpp": 576579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058453473,
    "dropsitcph": 6058453473,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B198",
    "droptype": "D",
    "dropname": "TRENT",
    "dropdeladd": "107 W 3RD ST",
    "dropdelcty": "TRENT",
    "dropdelst": "SD",
    "dropdelzpp": 570659998,
    "dropphyadd": "107 W 3RD ST",
    "dropphycty": "TRENT",
    "dropphyst": "SD",
    "dropphyzpp": 570659998,
    "dropmaladd": "107 W 3RD ST",
    "dropmalcty": "TRENT",
    "dropmalst": "SD",
    "dropmalzpp": 570659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053494432,
    "dropsitcph": 6052778153,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B199",
    "droptype": "D",
    "dropname": "TRIPP",
    "dropdeladd": "303 S MAIN ST",
    "dropdelcty": "TRIPP",
    "dropdelst": "SD",
    "dropdelzpp": 573769998,
    "dropphyadd": "303 S MAIN ST",
    "dropphycty": "TRIPP",
    "dropphyst": "SD",
    "dropphyzpp": 573769998,
    "dropmaladd": "303 S MAIN ST",
    "dropmalcty": "TRIPP",
    "dropmalst": "SD",
    "dropmalzpp": 573769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059356262,
    "dropsitcph": 6059356262,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B202",
    "droptype": "D",
    "dropname": "TULARE",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "TULARE",
    "dropdelst": "SD",
    "dropdelzpp": 574769998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "TULARE",
    "dropphyst": "SD",
    "dropphyzpp": 574769998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "TULARE",
    "dropmalst": "SD",
    "dropmalzpp": 574769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055964196,
    "dropsitcph": 6055964196,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B205",
    "droptype": "D",
    "dropname": "TURTON",
    "dropdeladd": "108 E CENTER ST",
    "dropdelcty": "TURTON",
    "dropdelst": "SD",
    "dropdelzpp": 574779998,
    "dropphyadd": "108 E CENTER ST",
    "dropphycty": "TURTON",
    "dropphyst": "SD",
    "dropphyzpp": 574779998,
    "dropmaladd": "108 E CENTER ST",
    "dropmalcty": "TURTON",
    "dropmalst": "SD",
    "dropmalzpp": 574779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058976620,
    "dropsitcph": 6058976620,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B207",
    "droptype": "D",
    "dropname": "TWIN BROOKS",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "TWIN BROOKS",
    "dropdelst": "SD",
    "dropdelzpp": 572699998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "TWIN BROOKS",
    "dropphyst": "SD",
    "dropphyzpp": 572699998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "TWIN BROOKS",
    "dropmalst": "SD",
    "dropmalzpp": 572699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054325092,
    "dropsitcph": 6054325092,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B208",
    "droptype": "D",
    "dropname": "TYNDALL",
    "dropdeladd": "1716 MAIN ST",
    "dropdelcty": "TYNDALL",
    "dropdelst": "SD",
    "dropdelzpp": 570669998,
    "dropphyadd": "1716 MAIN ST",
    "dropphycty": "TYNDALL",
    "dropphyst": "SD",
    "dropphyzpp": 570669998,
    "dropmaladd": "1716 MAIN ST",
    "dropmalcty": "TYNDALL",
    "dropmalst": "SD",
    "dropmalzpp": 570669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059831620,
    "dropsitcph": 6059831620,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B209",
    "droptype": "D",
    "dropname": "UNION CENTER",
    "dropdeladd": "16946 SD HIGHWAY 34 STE 3",
    "dropdelcty": "UNION CENTER",
    "dropdelst": "SD",
    "dropdelzpp": 577879998,
    "dropphyadd": "16946 SD HIGHWAY 34 STE 3",
    "dropphycty": "UNION CENTER",
    "dropphyst": "SD",
    "dropphyzpp": 577879998,
    "dropmaladd": "16946 SD HIGHWAY 34 STE 3",
    "dropmalcty": "UNION CENTER",
    "dropmalst": "SD",
    "dropmalzpp": 577879998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059855503,
    "dropsitcph": 6059855503,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B215",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "109 2ND ST",
    "dropdelcty": "UTICA",
    "dropdelst": "SD",
    "dropdelzpp": 570679998,
    "dropphyadd": "109 2ND ST",
    "dropphycty": "UTICA",
    "dropphyst": "SD",
    "dropphyzpp": 570679998,
    "dropmaladd": "109 2ND ST",
    "dropmalcty": "UTICA",
    "dropmalst": "SD",
    "dropmalzpp": 570679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056655104,
    "dropsitcph": 6056655104,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B216",
    "droptype": "D",
    "dropname": "VALE",
    "dropdeladd": "304 ROSANDER AVE",
    "dropdelcty": "VALE",
    "dropdelst": "SD",
    "dropdelzpp": 577889998,
    "dropphyadd": "304 ROSANDER AVE",
    "dropphycty": "VALE",
    "dropphyst": "SD",
    "dropphyzpp": 577889998,
    "dropmaladd": "304 ROSANDER AVE",
    "dropmalcty": "VALE",
    "dropmalst": "SD",
    "dropmalzpp": 577889998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054562404,
    "dropsitcph": 6054562404,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B217",
    "droptype": "D",
    "dropname": "VALLEY SPRINGS",
    "dropdeladd": "409 BROADWAY AVE",
    "dropdelcty": "VALLEY SPRINGS",
    "dropdelst": "SD",
    "dropdelzpp": 570689998,
    "dropphyadd": "409 BROADWAY AVE",
    "dropphycty": "VALLEY SPRINGS",
    "dropphyst": "SD",
    "dropphyzpp": 570689998,
    "dropmaladd": "409 BROADWAY AVE",
    "dropmalcty": "VALLEY SPRINGS",
    "dropmalst": "SD",
    "dropmalzpp": 570689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057576219,
    "dropsitcph": 6057576219,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B220",
    "droptype": "D",
    "dropname": "VEBLEN",
    "dropdeladd": "206 S MAIN ST",
    "dropdelcty": "VEBLEN",
    "dropdelst": "SD",
    "dropdelzpp": 572709998,
    "dropphyadd": "206 S MAIN ST",
    "dropphycty": "VEBLEN",
    "dropphyst": "SD",
    "dropphyzpp": 572709998,
    "dropmaladd": "206 S MAIN ST",
    "dropmalcty": "VEBLEN",
    "dropmalst": "SD",
    "dropmalzpp": 572709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057382194,
    "dropsitcph": 6057382194,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B222",
    "droptype": "D",
    "dropname": "VERMILLION",
    "dropdeladd": "16 COURT ST",
    "dropdelcty": "VERMILLION",
    "dropdelst": "SD",
    "dropdelzpp": 570699998,
    "dropphyadd": "16 COURT ST",
    "dropphycty": "VERMILLION",
    "dropphyst": "SD",
    "dropphyzpp": 570699998,
    "dropmaladd": "16 COURT ST",
    "dropmalcty": "VERMILLION",
    "dropmalst": "SD",
    "dropmalzpp": 570699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056244701,
    "dropsitcph": 6056244701,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B224",
    "droptype": "D",
    "dropname": "VIBORG",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "VIBORG",
    "dropdelst": "SD",
    "dropdelzpp": 570709998,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "VIBORG",
    "dropphyst": "SD",
    "dropphyzpp": 570709998,
    "dropmaladd": "103 S MAIN ST",
    "dropmalcty": "VIBORG",
    "dropmalst": "SD",
    "dropmalzpp": 570709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056534960,
    "dropsitcph": 6056534960,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B230",
    "droptype": "D",
    "dropname": "VIVIAN",
    "dropdeladd": "109 S MAIN AVE",
    "dropdelcty": "VIVIAN",
    "dropdelst": "SD",
    "dropdelzpp": 575769998,
    "dropphyadd": "109 S MAIN AVE",
    "dropphycty": "VIVIAN",
    "dropphyst": "SD",
    "dropphyzpp": 575769998,
    "dropmaladd": "109 S MAIN AVE",
    "dropmalcty": "VIVIAN",
    "dropmalst": "SD",
    "dropmalzpp": 575769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056834655,
    "dropsitcph": 6056834655,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B231",
    "droptype": "D",
    "dropname": "VOLGA",
    "dropdeladd": "125 W 3RD ST",
    "dropdelcty": "VOLGA",
    "dropdelst": "SD",
    "dropdelzpp": 570719998,
    "dropphyadd": "125 W 3RD ST",
    "dropphycty": "VOLGA",
    "dropphyst": "SD",
    "dropphyzpp": 570719998,
    "dropmaladd": "125 W 3RD ST",
    "dropmalcty": "VOLGA",
    "dropmalst": "SD",
    "dropmalzpp": 570719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056279411,
    "dropsitcph": 6056279411,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B232",
    "droptype": "D",
    "dropname": "VOLIN",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "VOLIN",
    "dropdelst": "SD",
    "dropdelzpp": 570729998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "VOLIN",
    "dropphyst": "SD",
    "dropphyzpp": 570729998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "VOLIN",
    "dropmalst": "SD",
    "dropmalzpp": 570729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052672368,
    "dropsitcph": 6052672368,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B234",
    "droptype": "D",
    "dropname": "WAGNER",
    "dropdeladd": "109 2ND ST SE",
    "dropdelcty": "WAGNER",
    "dropdelst": "SD",
    "dropdelzpp": 573809998,
    "dropphyadd": "109 2ND ST SE",
    "dropphycty": "WAGNER",
    "dropphyst": "SD",
    "dropphyzpp": 573809998,
    "dropmaladd": "109 2ND ST SE",
    "dropmalcty": "WAGNER",
    "dropmalst": "SD",
    "dropmalzpp": 573809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053845508,
    "dropsitcph": 6053845508,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B235",
    "droptype": "D",
    "dropname": "WAKONDA",
    "dropdeladd": "109 OHIO ST",
    "dropdelcty": "WAKONDA",
    "dropdelst": "SD",
    "dropdelzpp": 570739998,
    "dropphyadd": "109 OHIO ST",
    "dropphycty": "WAKONDA",
    "dropphyst": "SD",
    "dropphyzpp": 570739998,
    "dropmaladd": "109 OHIO ST",
    "dropmalcty": "WAKONDA",
    "dropmalst": "SD",
    "dropmalzpp": 570739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052672661,
    "dropsitcph": 6052672661,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B236",
    "droptype": "D",
    "dropname": "WAKPALA",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "WAKPALA",
    "dropdelst": "SD",
    "dropdelzpp": 576589998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "WAKPALA",
    "dropphyst": "SD",
    "dropphyzpp": 576589998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "WAKPALA",
    "dropmalst": "SD",
    "dropmalzpp": 576589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058457969,
    "dropsitcph": 6058457969,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B238",
    "droptype": "D",
    "dropname": "WALL",
    "dropdeladd": "529 MAIN ST",
    "dropdelcty": "WALL",
    "dropdelst": "SD",
    "dropdelzpp": 577909998,
    "dropphyadd": "529 MAIN ST",
    "dropphycty": "WALL",
    "dropphyst": "SD",
    "dropphyzpp": 577909998,
    "dropmaladd": "529 MAIN ST",
    "dropmalcty": "WALL",
    "dropmalst": "SD",
    "dropmalzpp": 577909998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052792466,
    "dropsitcph": 6052792466,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B240",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "WALLACE",
    "dropdelst": "SD",
    "dropdelzpp": 572729998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "WALLACE",
    "dropphyst": "SD",
    "dropphyzpp": 572729998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "WALLACE",
    "dropmalst": "SD",
    "dropmalzpp": 572729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057582229,
    "dropsitcph": 6057582229,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B242",
    "droptype": "D",
    "dropname": "WANBLEE",
    "dropdeladd": "310 SD HIGHWAY 44",
    "dropdelcty": "WANBLEE",
    "dropdelst": "SD",
    "dropdelzpp": 575779998,
    "dropphyadd": "310 SD HIGHWAY 44",
    "dropphycty": "WANBLEE",
    "dropphyst": "SD",
    "dropphyzpp": 575779998,
    "dropmaladd": "310 SD HIGHWAY 44",
    "dropmalcty": "WANBLEE",
    "dropmalst": "SD",
    "dropmalzpp": 575779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054626150,
    "dropsitcph": 6054626150,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B244",
    "droptype": "D",
    "dropname": "WARNER",
    "dropdeladd": "22 W MAIN ST",
    "dropdelcty": "WARNER",
    "dropdelst": "SD",
    "dropdelzpp": 574799998,
    "dropphyadd": "22 W MAIN ST",
    "dropphycty": "WARNER",
    "dropphyst": "SD",
    "dropphyzpp": 574799998,
    "dropmaladd": "22 W MAIN ST",
    "dropmalcty": "WARNER",
    "dropmalst": "SD",
    "dropmalzpp": 574799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052261701,
    "dropsitcph": 6052261701,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B245",
    "droptype": "D",
    "dropname": "WASTA",
    "dropdeladd": "54 C AVE",
    "dropdelcty": "WASTA",
    "dropdelst": "SD",
    "dropdelzpp": 577919998,
    "dropphyadd": "54 C AVE",
    "dropphycty": "WASTA",
    "dropphyst": "SD",
    "dropphyzpp": 577919998,
    "dropmaladd": "54 C AVE",
    "dropmalcty": "WASTA",
    "dropmalst": "SD",
    "dropmalzpp": 577919998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059933139,
    "dropsitcph": 6059933139,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B248",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "405 E KEMP AVE",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "SD",
    "dropdelzpp": 572019998,
    "dropphyadd": "405 E KEMP AVE",
    "dropphycty": "WATERTOWN",
    "dropphyst": "SD",
    "dropphyzpp": 572019998,
    "dropmaladd": "405 E KEMP AVE",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "SD",
    "dropmalzpp": 572019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058867765,
    "dropsitcph": 6058867765,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B249",
    "droptype": "D",
    "dropname": "WAUBAY",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "WAUBAY",
    "dropdelst": "SD",
    "dropdelzpp": 572739998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "WAUBAY",
    "dropphyst": "SD",
    "dropphyzpp": 572739998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "WAUBAY",
    "dropmalst": "SD",
    "dropmalzpp": 572739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059474262,
    "dropsitcph": 6059474262,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B252",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "715 MAIN ST",
    "dropdelcty": "WEBSTER",
    "dropdelst": "SD",
    "dropdelzpp": 572749998,
    "dropphyadd": "715 MAIN ST",
    "dropphycty": "WEBSTER",
    "dropphyst": "SD",
    "dropphyzpp": 572749998,
    "dropmaladd": "715 MAIN ST",
    "dropmalcty": "WEBSTER",
    "dropmalst": "SD",
    "dropmalzpp": 572749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053574930,
    "dropsitcph": 6053453121,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B256",
    "droptype": "D",
    "dropname": "WENTWORTH",
    "dropdeladd": "107 S MAIN AVE",
    "dropdelcty": "WENTWORTH",
    "dropdelst": "SD",
    "dropdelzpp": 570759998,
    "dropphyadd": "107 S MAIN AVE",
    "dropphycty": "WENTWORTH",
    "dropphyst": "SD",
    "dropphyzpp": 570759998,
    "dropmaladd": "107 S MAIN AVE",
    "dropmalcty": "WENTWORTH",
    "dropmalst": "SD",
    "dropmalzpp": 570759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054833144,
    "dropsitcph": 6054833144,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B257",
    "droptype": "D",
    "dropname": "WESSINGTON",
    "dropdeladd": "170 WESSINGTON ST S",
    "dropdelcty": "WESSINGTON",
    "dropdelst": "SD",
    "dropdelzpp": 573819998,
    "dropphyadd": "170 WESSINGTON ST S",
    "dropphycty": "WESSINGTON",
    "dropphyst": "SD",
    "dropphyzpp": 573819998,
    "dropmaladd": "170 WESSINGTON ST S",
    "dropmalcty": "WESSINGTON",
    "dropmalst": "SD",
    "dropmalzpp": 573819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054582250,
    "dropsitcph": 6054582250,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B258",
    "droptype": "D",
    "dropname": "WESSINGTON SPRINGS",
    "dropdeladd": "124 WALLACE AVE S",
    "dropdelcty": "WESSINGTON SPRINGS",
    "dropdelst": "SD",
    "dropdelzpp": 573829998,
    "dropphyadd": "124 WALLACE AVE S",
    "dropphycty": "WESSINGTON SPRINGS",
    "dropphyst": "SD",
    "dropphyzpp": 573829998,
    "dropmaladd": "124 WALLACE AVE S",
    "dropmalcty": "WESSINGTON SPRINGS",
    "dropmalst": "SD",
    "dropmalzpp": 573829998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055391799,
    "dropsitcph": 6055391799,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B263",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "14 MAIN ST W",
    "dropdelcty": "WESTPORT",
    "dropdelst": "SD",
    "dropdelzpp": 574819998,
    "dropphyadd": "14 MAIN ST W",
    "dropphycty": "WESTPORT",
    "dropphyst": "SD",
    "dropphyzpp": 574819998,
    "dropmaladd": "14 MAIN ST W",
    "dropmalcty": "WESTPORT",
    "dropmalst": "SD",
    "dropmalzpp": 574819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052255749,
    "dropsitcph": 6052255749,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B266",
    "droptype": "D",
    "dropname": "WHITE",
    "dropdeladd": "311 W MAIN ST",
    "dropdelcty": "WHITE",
    "dropdelst": "SD",
    "dropdelzpp": 572769998,
    "dropphyadd": "311 W MAIN ST",
    "dropphycty": "WHITE",
    "dropphyst": "SD",
    "dropphyzpp": 572769998,
    "dropmaladd": "311 W MAIN ST",
    "dropmalcty": "WHITE",
    "dropmalst": "SD",
    "dropmalzpp": 572769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056292231,
    "dropsitcph": 6056292231,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B268",
    "droptype": "D",
    "dropname": "WHITE LAKE",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "WHITE LAKE",
    "dropdelst": "SD",
    "dropdelzpp": 573839998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "WHITE LAKE",
    "dropphyst": "SD",
    "dropphyzpp": 573839998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "WHITE LAKE",
    "dropmalst": "SD",
    "dropmalzpp": 573839998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052525462,
    "dropsitcph": 6052525462,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B269",
    "droptype": "D",
    "dropname": "WHITE OWL",
    "dropdeladd": "19371 MAIN ST",
    "dropdelcty": "WHITE OWL",
    "dropdelst": "SD",
    "dropdelzpp": 577929998,
    "dropphyadd": "19371 MAIN ST",
    "dropphycty": "WHITE OWL",
    "dropphyst": "SD",
    "dropphyzpp": 577929998,
    "dropmaladd": "19371 MAIN ST",
    "dropmalcty": "WHITE OWL",
    "dropmalst": "SD",
    "dropmalzpp": 577929998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059855402,
    "dropsitcph": 6059855402,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B270",
    "droptype": "D",
    "dropname": "WHITE RIVER",
    "dropdeladd": "415 N MAIN ST",
    "dropdelcty": "WHITE RIVER",
    "dropdelst": "SD",
    "dropdelzpp": 575799998,
    "dropphyadd": "415 N MAIN ST",
    "dropphycty": "WHITE RIVER",
    "dropphyst": "SD",
    "dropphyzpp": 575799998,
    "dropmaladd": "415 N MAIN ST",
    "dropmalcty": "WHITE RIVER",
    "dropmalst": "SD",
    "dropmalzpp": 575799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052593216,
    "dropsitcph": 6052593216,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B271",
    "droptype": "D",
    "dropname": "WHITEHORSE",
    "dropdeladd": "18 S 2ND AVE",
    "dropdelcty": "WHITEHORSE",
    "dropdelst": "SD",
    "dropdelzpp": 576619998,
    "dropphyadd": "18 S 2ND AVE",
    "dropphycty": "WHITEHORSE",
    "dropphyst": "SD",
    "dropphyzpp": 576619998,
    "dropmaladd": "18 S 2ND AVE",
    "dropmalcty": "WHITEHORSE",
    "dropmalst": "SD",
    "dropmalzpp": 576619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057332520,
    "dropsitcph": 6057332520,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B272",
    "droptype": "D",
    "dropname": "WHITEWOOD",
    "dropdeladd": "1400 LAUREL ST",
    "dropdelcty": "WHITEWOOD",
    "dropdelst": "SD",
    "dropdelzpp": 577939998,
    "dropphyadd": "1400 LAUREL ST",
    "dropphycty": "WHITEWOOD",
    "dropphyst": "SD",
    "dropphyzpp": 577939998,
    "dropmaladd": "1400 LAUREL ST",
    "dropmalcty": "WHITEWOOD",
    "dropmalst": "SD",
    "dropmalzpp": 577939998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6052692505,
    "dropsitcph": 6052692505,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B275",
    "droptype": "D",
    "dropname": "WILLOW LAKE",
    "dropdeladd": "214 GARFIELD AVE",
    "dropdelcty": "WILLOW LAKE",
    "dropdelst": "SD",
    "dropdelzpp": 572789998,
    "dropphyadd": "214 GARFIELD AVE",
    "dropphycty": "WILLOW LAKE",
    "dropphyst": "SD",
    "dropphyzpp": 572789998,
    "dropmaladd": "214 GARFIELD AVE",
    "dropmalcty": "WILLOW LAKE",
    "dropmalst": "SD",
    "dropmalzpp": 572789998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056253387,
    "dropsitcph": 6056253387,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B276",
    "droptype": "D",
    "dropname": "WILMOT",
    "dropdeladd": "713 MAIN ST",
    "dropdelcty": "WILMOT",
    "dropdelst": "SD",
    "dropdelzpp": 572799998,
    "dropphyadd": "713 MAIN ST",
    "dropphycty": "WILMOT",
    "dropphyst": "SD",
    "dropphyzpp": 572799998,
    "dropmaladd": "713 MAIN ST",
    "dropmalcty": "WILMOT",
    "dropmalst": "SD",
    "dropmalzpp": 572799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6059384511,
    "dropsitcph": 6059384511,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B278",
    "droptype": "D",
    "dropname": "WINFRED",
    "dropdeladd": "352 MAIN ST",
    "dropdelcty": "WINFRED",
    "dropdelst": "SD",
    "dropdelzpp": 570769998,
    "dropphyadd": "352 MAIN ST",
    "dropphycty": "WINFRED",
    "dropphyst": "SD",
    "dropphyzpp": 570769998,
    "dropmaladd": "352 MAIN ST",
    "dropmalcty": "WINFRED",
    "dropmalst": "SD",
    "dropmalzpp": 570769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054852284,
    "dropsitcph": 6054852284,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B279",
    "droptype": "D",
    "dropname": "WINNER",
    "dropdeladd": "402 S MONROE ST",
    "dropdelcty": "WINNER",
    "dropdelst": "SD",
    "dropdelzpp": 575809998,
    "dropphyadd": "402 S MONROE ST",
    "dropphycty": "WINNER",
    "dropphyst": "SD",
    "dropphyzpp": 575809998,
    "dropmaladd": "402 S MONROE ST",
    "dropmalcty": "WINNER",
    "dropmalst": "SD",
    "dropmalzpp": 575809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058420494,
    "dropsitcph": 6058420494,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B280",
    "droptype": "D",
    "dropname": "WITTEN",
    "dropdeladd": "119 E 1ST ST",
    "dropdelcty": "WITTEN",
    "dropdelst": "SD",
    "dropdelzpp": 575849998,
    "dropphyadd": "119 E 1ST ST",
    "dropphycty": "WITTEN",
    "dropphyst": "SD",
    "dropphyzpp": 575849998,
    "dropmaladd": "119 E 1ST ST",
    "dropmalcty": "WITTEN",
    "dropmalst": "SD",
    "dropmalzpp": 575849998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058792466,
    "dropsitcph": 6058792466,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B282",
    "droptype": "D",
    "dropname": "WOLSEY",
    "dropdeladd": "125 COMMERCIAL AVE SW",
    "dropdelcty": "WOLSEY",
    "dropdelst": "SD",
    "dropdelzpp": 573849998,
    "dropphyadd": "125 COMMERCIAL AVE SW",
    "dropphycty": "WOLSEY",
    "dropphyst": "SD",
    "dropphyzpp": 573849998,
    "dropmaladd": "125 COMMERCIAL AVE SW",
    "dropmalcty": "WOLSEY",
    "dropmalst": "SD",
    "dropmalzpp": 573849998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058834632,
    "dropsitcph": 6058834632,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B283",
    "droptype": "D",
    "dropname": "WOOD",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "WOOD",
    "dropdelst": "SD",
    "dropdelzpp": 575859998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "WOOD",
    "dropphyst": "SD",
    "dropphyzpp": 575859998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "WOOD",
    "dropmalst": "SD",
    "dropmalzpp": 575859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6054523235,
    "dropsitcph": 6054523235,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B284",
    "droptype": "D",
    "dropname": "WOONSOCKET",
    "dropdeladd": "202 S DUMONT AVE",
    "dropdelcty": "WOONSOCKET",
    "dropdelst": "SD",
    "dropdelzpp": 573859998,
    "dropphyadd": "202 S DUMONT AVE",
    "dropphycty": "WOONSOCKET",
    "dropphyst": "SD",
    "dropphyzpp": 573859998,
    "dropmaladd": "202 S DUMONT AVE",
    "dropmalcty": "WOONSOCKET",
    "dropmalst": "SD",
    "dropmalzpp": 573859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6057964495,
    "dropsitcph": 6057964495,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B285",
    "droptype": "D",
    "dropname": "WORTHING",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "WORTHING",
    "dropdelst": "SD",
    "dropdelzpp": 570779998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "WORTHING",
    "dropphyst": "SD",
    "dropphyzpp": 570779998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "WORTHING",
    "dropmalst": "SD",
    "dropmalzpp": 570779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056671532,
    "dropsitcph": 6056671532,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B286",
    "droptype": "D",
    "dropname": "WOUNDED KNEE",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "WOUNDED KNEE",
    "dropdelst": "SD",
    "dropdelzpp": 577949998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "WOUNDED KNEE",
    "dropphyst": "SD",
    "dropphyzpp": 577949998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "WOUNDED KNEE",
    "dropmalst": "SD",
    "dropmalzpp": 577949998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6058675278,
    "dropsitcph": 6058675278,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B288",
    "droptype": "D",
    "dropname": "YANKTON",
    "dropdeladd": "506 W 25TH ST",
    "dropdelcty": "YANKTON",
    "dropdelst": "SD",
    "dropdelzpp": 570789998,
    "dropphyadd": "506 W 25TH ST",
    "dropphycty": "YANKTON",
    "dropphyst": "SD",
    "dropphyzpp": 570789998,
    "dropmaladd": "506 W 25TH ST",
    "dropmalcty": "YANKTON",
    "dropmalst": "SD",
    "dropmalzpp": 570789998,
    "dropsitphn": 6053574932,
    "dropsitlph": 6056650626,
    "dropsitcph": 6056650626,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW1B293",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "31 W 4TH AVE",
    "dropdelcty": "AFTON",
    "dropdelst": "WY",
    "dropdelzpp": 831109998,
    "dropphyadd": "31 W 4TH AVE",
    "dropphycty": "AFTON",
    "dropphyst": "WY",
    "dropphyzpp": 831109998,
    "dropmaladd": "31 W 4TH AVE",
    "dropmalcty": "AFTON",
    "dropmalst": "WY",
    "dropmalzpp": 831109998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078863625,
    "dropsitcph": 3078863625,
    "dropfax": 3078869416
  },
  {
    "dcode": "D",
    "dropkey": "PW1B296",
    "droptype": "D",
    "dropname": "ALBIN",
    "dropdeladd": "221 CHEYENNE AVE",
    "dropdelcty": "ALBIN",
    "dropdelst": "WY",
    "dropdelzpp": 820509901,
    "dropphyadd": "221 CHEYENNE AVE",
    "dropphycty": "ALBIN",
    "dropphyst": "WY",
    "dropphyzpp": 820509901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBIN",
    "dropmalst": "WY",
    "dropmalzpp": 820509998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072463446,
    "dropsitcph": 3072463446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B297",
    "droptype": "D",
    "dropname": "ALCOVA",
    "dropdeladd": "22495 STATE HIGHWAY 220",
    "dropdelcty": "ALCOVA",
    "dropdelst": "WY",
    "dropdelzpp": 826209800,
    "dropphyadd": "22495 STATE HIGHWAY 220",
    "dropphycty": "ALCOVA",
    "dropphyst": "WY",
    "dropphyzpp": 826209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALCOVA",
    "dropmalst": "WY",
    "dropmalzpp": 826209998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072340074,
    "dropsitcph": 3072340074,
    "dropfax": 3072340074
  },
  {
    "dcode": "D",
    "dropkey": "PW1B300",
    "droptype": "D",
    "dropname": "ALVA",
    "dropdeladd": "2510 STATE HIGHWAY 24",
    "dropdelcty": "ALVA",
    "dropdelst": "WY",
    "dropdelzpp": 827119901,
    "dropphyadd": "2510 STATE HIGHWAY 24",
    "dropphycty": "ALVA",
    "dropphyst": "WY",
    "dropphyzpp": 827119901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALVA",
    "dropmalst": "WY",
    "dropmalzpp": 827119998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074675677,
    "dropsitcph": 3074675677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B304",
    "droptype": "D",
    "dropname": "ARVADA",
    "dropdeladd": "25 ATOKA ST",
    "dropdelcty": "ARVADA",
    "dropdelst": "WY",
    "dropdelzpp": 828319901,
    "dropphyadd": "25 ATOKA ST",
    "dropphycty": "ARVADA",
    "dropphyst": "WY",
    "dropphyzpp": 828319901,
    "dropmaladd": "25 ATOKA ST",
    "dropmalcty": "ARVADA",
    "dropmalst": "WY",
    "dropmalzpp": 828319901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077362214,
    "dropsitcph": 3077362214,
    "dropfax": 3077362225
  },
  {
    "dcode": "D",
    "dropkey": "PW1B307",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "449 1ST WEST ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "WY",
    "dropdelzpp": 831119901,
    "dropphyadd": "449 1ST WEST ST",
    "dropphycty": "AUBURN",
    "dropphyst": "WY",
    "dropphyzpp": 831119901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUBURN",
    "dropmalst": "WY",
    "dropmalzpp": 831119998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078869933,
    "dropsitcph": 3078869933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B308",
    "droptype": "D",
    "dropname": "BAGGS",
    "dropdeladd": "55 S PENLAND ST",
    "dropdelcty": "BAGGS",
    "dropdelst": "WY",
    "dropdelzpp": 823219900,
    "dropphyadd": "55 S PENLAND ST",
    "dropphycty": "BAGGS",
    "dropphyst": "WY",
    "dropphyzpp": 823219900,
    "dropmaladd": "55 S PENLAND ST",
    "dropmalcty": "BAGGS",
    "dropmalst": "WY",
    "dropmalzpp": 823219900,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073832315,
    "dropsitcph": 3073832315,
    "dropfax": 3073832315
  },
  {
    "dcode": "D",
    "dropkey": "PW1B309",
    "droptype": "D",
    "dropname": "BAIROIL",
    "dropdeladd": "503 ANTELOPE DR",
    "dropdelcty": "BAIROIL",
    "dropdelst": "WY",
    "dropdelzpp": 823229900,
    "dropphyadd": "503 ANTELOPE DR",
    "dropphycty": "BAIROIL",
    "dropphyst": "WY",
    "dropphyzpp": 823229900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAIROIL",
    "dropmalst": "WY",
    "dropmalzpp": 823229998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073245541,
    "dropsitcph": 3073245541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B312",
    "droptype": "D",
    "dropname": "BASIN",
    "dropdeladd": "402 W C ST",
    "dropdelcty": "BASIN",
    "dropdelst": "WY",
    "dropdelzpp": 824109901,
    "dropphyadd": "402 W C ST",
    "dropphycty": "BASIN",
    "dropphyst": "WY",
    "dropphyzpp": 824109901,
    "dropmaladd": "402 W C ST",
    "dropmalcty": "BASIN",
    "dropmalst": "WY",
    "dropmalzpp": 824109901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075682228,
    "dropsitcph": 3075682228,
    "dropfax": 3075682230
  },
  {
    "dcode": "D",
    "dropkey": "PW1B314",
    "droptype": "D",
    "dropname": "BEULAH",
    "dropdeladd": "5930 OLD HIGHWAY 14",
    "dropdelcty": "BEULAH",
    "dropdelst": "WY",
    "dropdelzpp": 827128805,
    "dropphyadd": "5930 OLD HIGHWAY 14",
    "dropphycty": "BEULAH",
    "dropphyst": "WY",
    "dropphyzpp": 827128805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEULAH",
    "dropmalst": "WY",
    "dropmalzpp": 827129998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076432216,
    "dropsitcph": 3076432216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B315",
    "droptype": "D",
    "dropname": "BIG HORN",
    "dropdeladd": "226 JOHNSON ST",
    "dropdelcty": "BIG HORN",
    "dropdelst": "WY",
    "dropdelzpp": 828339900,
    "dropphyadd": "226 JOHNSON ST",
    "dropphycty": "BIG HORN",
    "dropphyst": "WY",
    "dropphyzpp": 828339900,
    "dropmaladd": "226 JOHNSON ST",
    "dropmalcty": "BIG HORN",
    "dropmalst": "WY",
    "dropmalzpp": 828339900,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076722013,
    "dropsitcph": 3076722013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B316",
    "droptype": "D",
    "dropname": "BIG PINEY",
    "dropdeladd": "420 BUDD AVE",
    "dropdelcty": "BIG PINEY",
    "dropdelst": "WY",
    "dropdelzpp": 831139904,
    "dropphyadd": "420 BUDD AVE",
    "dropphycty": "BIG PINEY",
    "dropphyst": "WY",
    "dropphyzpp": 831139904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG PINEY",
    "dropmalst": "WY",
    "dropmalzpp": 831139998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072940030,
    "dropsitcph": 3072940030,
    "dropfax": 3072763440
  },
  {
    "dcode": "D",
    "dropkey": "PW1B319",
    "droptype": "D",
    "dropname": "BONDURANT",
    "dropdeladd": "13884 HIGHWAY 191",
    "dropdelcty": "BONDURANT",
    "dropdelst": "WY",
    "dropdelzpp": 829229800,
    "dropphyadd": "13884 HIGHWAY 191",
    "dropphycty": "BONDURANT",
    "dropphyst": "WY",
    "dropphyzpp": 829229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BONDURANT",
    "dropmalst": "WY",
    "dropmalzpp": 829229998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077338420,
    "dropsitcph": 3077338420,
    "dropfax": 3077338420
  },
  {
    "dcode": "D",
    "dropkey": "PW1B322",
    "droptype": "D",
    "dropname": "BOULDER",
    "dropdeladd": "7 STATE HIGHWAY 353",
    "dropdelcty": "BOULDER",
    "dropdelst": "WY",
    "dropdelzpp": 829239624,
    "dropphyadd": "7 STATE HIGHWAY 353",
    "dropphycty": "BOULDER",
    "dropphyst": "WY",
    "dropphyzpp": 829239624,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOULDER",
    "dropmalst": "WY",
    "dropmalzpp": 829239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075375623,
    "dropsitcph": 3075375623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B323",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "193 S MAIN ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "WY",
    "dropdelzpp": 828349998,
    "dropphyadd": "193 S MAIN ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "WY",
    "dropphyzpp": 828349998,
    "dropmaladd": "193 S MAIN ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "WY",
    "dropmalzpp": 828349998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076849126,
    "dropsitcph": 3076849126,
    "dropfax": 3076849605
  },
  {
    "dcode": "D",
    "dropkey": "PW1B325",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "211 S MAIN ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "WY",
    "dropdelzpp": 824119998,
    "dropphyadd": "211 S MAIN ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "WY",
    "dropphyzpp": 824119998,
    "dropmaladd": "211 S MAIN ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "WY",
    "dropmalzpp": 824119998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077623323,
    "dropsitcph": 3077623323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B326",
    "droptype": "D",
    "dropname": "BURNS",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "BURNS",
    "dropdelst": "WY",
    "dropdelzpp": 820539903,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "BURNS",
    "dropphyst": "WY",
    "dropphyzpp": 820539903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNS",
    "dropmalst": "WY",
    "dropmalzpp": 820539998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075473576,
    "dropsitcph": 3075473576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B328",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "120 E MAIN ST",
    "dropdelcty": "BYRON",
    "dropdelst": "WY",
    "dropdelzpp": 824129900,
    "dropphyadd": "120 E MAIN ST",
    "dropphycty": "BYRON",
    "dropphyst": "WY",
    "dropphyzpp": 824129900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYRON",
    "dropmalst": "WY",
    "dropmalzpp": 824129998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075487672,
    "dropsitcph": 3075487672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B332",
    "droptype": "D",
    "dropname": "CARPENTER",
    "dropdeladd": "322 1ST ST",
    "dropdelcty": "CARPENTER",
    "dropdelst": "WY",
    "dropdelzpp": 820549610,
    "dropphyadd": "322 1ST ST",
    "dropphycty": "CARPENTER",
    "dropphyst": "WY",
    "dropphyzpp": 820549610,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARPENTER",
    "dropmalst": "WY",
    "dropmalzpp": 820549998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076492304,
    "dropsitcph": 3076492304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B334",
    "droptype": "D",
    "dropname": "CASPER",
    "dropdeladd": "411 N FOREST DR",
    "dropdelcty": "CASPER",
    "dropdelst": "WY",
    "dropdelzpp": 826099998,
    "dropphyadd": "411 N FOREST DR",
    "dropphycty": "CASPER",
    "dropphyst": "WY",
    "dropphyzpp": 826099998,
    "dropmaladd": "411 N FOREST DR",
    "dropmalcty": "CASPER",
    "dropmalst": "WY",
    "dropmalzpp": 826099998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072664034,
    "dropsitcph": 3072664034,
    "dropfax": 3072660133
  },
  {
    "dcode": "D",
    "dropkey": "PW1B335",
    "droptype": "D",
    "dropname": "CENTENNIAL",
    "dropdeladd": "1 PINE ST",
    "dropdelcty": "CENTENNIAL",
    "dropdelst": "WY",
    "dropdelzpp": 820559900,
    "dropphyadd": "1 PINE ST",
    "dropphycty": "CENTENNIAL",
    "dropphyst": "WY",
    "dropphyzpp": 820559900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTENNIAL",
    "dropmalst": "WY",
    "dropmalzpp": 820559998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077422057,
    "dropsitcph": 3077422057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B337",
    "droptype": "D",
    "dropname": "CHEYENNE",
    "dropdeladd": "4800 CONVERSE AVE",
    "dropdelcty": "CHEYENNE",
    "dropdelst": "WY",
    "dropdelzpp": 820099998,
    "dropphyadd": "4800 CONVERSE AVE",
    "dropphycty": "CHEYENNE",
    "dropphyst": "WY",
    "dropphyzpp": 820099998,
    "dropmaladd": "4800 CONVERSE AVE",
    "dropmalcty": "CHEYENNE",
    "dropmalst": "WY",
    "dropmalzpp": 820099998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077726501,
    "dropsitcph": 3077727080,
    "dropfax": 3077726532
  },
  {
    "dcode": "D",
    "dropkey": "PW1B340",
    "droptype": "D",
    "dropname": "CHUGWATER",
    "dropdeladd": "237 2ND ST",
    "dropdelcty": "CHUGWATER",
    "dropdelst": "WY",
    "dropdelzpp": 822109624,
    "dropphyadd": "237 2ND ST",
    "dropphycty": "CHUGWATER",
    "dropphyst": "WY",
    "dropphyzpp": 822109624,
    "dropmaladd": "237 2ND ST",
    "dropmalcty": "CHUGWATER",
    "dropmalst": "WY",
    "dropmalzpp": 822109624,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074223530,
    "dropsitcph": 3074223530,
    "dropfax": 3074223530
  },
  {
    "dcode": "D",
    "dropkey": "PW1B341",
    "droptype": "D",
    "dropname": "CLEARMONT",
    "dropdeladd": "1210 FRONT ST",
    "dropdelcty": "CLEARMONT",
    "dropdelst": "WY",
    "dropdelzpp": 828359901,
    "dropphyadd": "1210 FRONT ST",
    "dropphycty": "CLEARMONT",
    "dropphyst": "WY",
    "dropphyzpp": 828359901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARMONT",
    "dropmalst": "WY",
    "dropmalzpp": 828359998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077584338,
    "dropsitcph": 3077584338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B342",
    "droptype": "D",
    "dropname": "CODY",
    "dropdeladd": "1301 STAMPEDE AVE",
    "dropdelcty": "CODY",
    "dropdelst": "WY",
    "dropdelzpp": 824149998,
    "dropphyadd": "1301 STAMPEDE AVE",
    "dropphycty": "CODY",
    "dropphyst": "WY",
    "dropphyzpp": 824149998,
    "dropmaladd": "1301 STAMPEDE AVE",
    "dropmalcty": "CODY",
    "dropmalst": "WY",
    "dropmalzpp": 824149998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075277161,
    "dropsitcph": 3075277161,
    "dropfax": 3075879332
  },
  {
    "dcode": "D",
    "dropkey": "PW1B343",
    "droptype": "D",
    "dropname": "COKEVILLE",
    "dropdeladd": "100 POST ST",
    "dropdelcty": "COKEVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 831149901,
    "dropphyadd": "100 POST ST",
    "dropphycty": "COKEVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 831149901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COKEVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 831149998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072793219,
    "dropsitcph": 3072793219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B345",
    "droptype": "D",
    "dropname": "CORA",
    "dropdeladd": "5 NOBLE RD",
    "dropdelcty": "CORA",
    "dropdelst": "WY",
    "dropdelzpp": 829259800,
    "dropphyadd": "5 NOBLE RD",
    "dropphycty": "CORA",
    "dropphyst": "WY",
    "dropphyzpp": 829259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORA",
    "dropmalst": "WY",
    "dropmalzpp": 829259998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073676680,
    "dropsitcph": 3073676680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B346",
    "droptype": "D",
    "dropname": "COWLEY",
    "dropdeladd": "71 E MAIN ST",
    "dropdelcty": "COWLEY",
    "dropdelst": "WY",
    "dropdelzpp": 824209900,
    "dropphyadd": "71 E MAIN ST",
    "dropphycty": "COWLEY",
    "dropphyst": "WY",
    "dropphyzpp": 824209900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COWLEY",
    "dropmalst": "WY",
    "dropmalzpp": 824209998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075482689,
    "dropsitcph": 3075482689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B348",
    "droptype": "D",
    "dropname": "CROWHEART",
    "dropdeladd": "8526 US HIGHWAY 26 287",
    "dropdelcty": "CROWHEART",
    "dropdelst": "WY",
    "dropdelzpp": 825129901,
    "dropphyadd": "8526 US HIGHWAY 26 287",
    "dropphycty": "CROWHEART",
    "dropphyst": "WY",
    "dropphyzpp": 825129901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWHEART",
    "dropmalst": "WY",
    "dropmalzpp": 825129998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074862239,
    "dropsitcph": 3074862239,
    "dropfax": 3074862357
  },
  {
    "dcode": "D",
    "dropkey": "PW1B349",
    "droptype": "D",
    "dropname": "DANIEL",
    "dropdeladd": "12958 STATE HIGHWAY 189",
    "dropdelcty": "DANIEL",
    "dropdelst": "WY",
    "dropdelzpp": 831159901,
    "dropphyadd": "12958 STATE HIGHWAY 189",
    "dropphycty": "DANIEL",
    "dropphyst": "WY",
    "dropphyzpp": 831159901,
    "dropmaladd": "12958 STATE HIGHWAY 189",
    "dropmalcty": "DANIEL",
    "dropmalst": "WY",
    "dropmalzpp": 831159901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078598251,
    "dropsitcph": 3078598251,
    "dropfax": 3078598892
  },
  {
    "dcode": "D",
    "dropkey": "PW1B350",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "112 3RD ST W",
    "dropdelcty": "DAYTON",
    "dropdelst": "WY",
    "dropdelzpp": 828369901,
    "dropphyadd": "112 3RD ST W",
    "dropphycty": "DAYTON",
    "dropphyst": "WY",
    "dropphyzpp": 828369901,
    "dropmaladd": "112 3RD ST W",
    "dropmalcty": "DAYTON",
    "dropmalst": "WY",
    "dropmalzpp": 828369901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076559342,
    "dropsitcph": 3076559342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B351",
    "droptype": "D",
    "dropname": "DEAVER",
    "dropdeladd": "18 CENTRAL AVE",
    "dropdelcty": "DEAVER",
    "dropdelst": "WY",
    "dropdelzpp": 824219998,
    "dropphyadd": "18 CENTRAL AVE",
    "dropphycty": "DEAVER",
    "dropphyst": "WY",
    "dropphyzpp": 824219998,
    "dropmaladd": "18 CENTRAL AVE",
    "dropmalcty": "DEAVER",
    "dropmalst": "WY",
    "dropmalzpp": 824219998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076642701,
    "dropsitcph": 3076642701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B352",
    "droptype": "D",
    "dropname": "DEVILS TOWER",
    "dropdeladd": "56 STATE HIGHWAY 110",
    "dropdelcty": "DEVILS TOWER",
    "dropdelst": "WY",
    "dropdelzpp": 827149905,
    "dropphyadd": "56 STATE HIGHWAY 110",
    "dropphycty": "DEVILS TOWER",
    "dropphyst": "WY",
    "dropphyzpp": 827149905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEVILS TOWER",
    "dropmalst": "WY",
    "dropmalzpp": 827149998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074675937,
    "dropsitcph": 3074675937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B354",
    "droptype": "D",
    "dropname": "DIAMONDVILLE",
    "dropdeladd": "317 DIAMONDVILLE AVE",
    "dropdelcty": "DIAMONDVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 831169900,
    "dropphyadd": "317 DIAMONDVILLE AVE",
    "dropphycty": "DIAMONDVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 831169900,
    "dropmaladd": "317 DIAMONDVILLE AVE",
    "dropmalcty": "DIAMONDVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 831169900,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078773911,
    "dropsitcph": 3078773911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B355",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "207 HIGHWAY 70",
    "dropdelcty": "DIXON",
    "dropdelst": "WY",
    "dropdelzpp": 823239900,
    "dropphyadd": "207 HIGHWAY 70",
    "dropphycty": "DIXON",
    "dropphyst": "WY",
    "dropphyzpp": 823239900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIXON",
    "dropmalst": "WY",
    "dropmalzpp": 823239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073836760,
    "dropsitcph": 3073836760,
    "dropfax": 3073836760
  },
  {
    "dcode": "D",
    "dropkey": "PW1B356",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "129 N 3RD ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "WY",
    "dropdelzpp": 826339998,
    "dropphyadd": "129 N 3RD ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "WY",
    "dropphyzpp": 826339998,
    "dropmaladd": "129 N 3RD ST",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "WY",
    "dropmalzpp": 826339998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073589358,
    "dropsitcph": 3073589358,
    "dropfax": 3073584227
  },
  {
    "dcode": "D",
    "dropkey": "PW1B357",
    "droptype": "D",
    "dropname": "DUBOIS",
    "dropdeladd": "804 RAMSHORN ST",
    "dropdelcty": "DUBOIS",
    "dropdelst": "WY",
    "dropdelzpp": 825139746,
    "dropphyadd": "804 RAMSHORN ST",
    "dropphycty": "DUBOIS",
    "dropphyst": "WY",
    "dropphyzpp": 825139746,
    "dropmaladd": "804 RAMSHORN ST",
    "dropmalcty": "DUBOIS",
    "dropmalst": "WY",
    "dropmalzpp": 825139746,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074552735,
    "dropsitcph": 3074552735,
    "dropfax": 3074552742
  },
  {
    "dcode": "D",
    "dropkey": "PW1B359",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "307 S 2 ST",
    "dropdelcty": "EDGERTON",
    "dropdelst": "WY",
    "dropdelzpp": 826359000,
    "dropphyadd": "307 S 2 ST",
    "dropphycty": "EDGERTON",
    "dropphyst": "WY",
    "dropphyzpp": 826359000,
    "dropmaladd": "307 S 2 ST",
    "dropmalcty": "EDGERTON",
    "dropmalst": "WY",
    "dropmalzpp": 826359000,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074376638,
    "dropsitcph": 3074376638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B361",
    "droptype": "D",
    "dropname": "ELK MOUNTAIN",
    "dropdeladd": "211 BRIDGE ST",
    "dropdelcty": "ELK MOUNTAIN",
    "dropdelst": "WY",
    "dropdelzpp": 823249900,
    "dropphyadd": "211 BRIDGE ST",
    "dropphycty": "ELK MOUNTAIN",
    "dropphyst": "WY",
    "dropphyzpp": 823249900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK MOUNTAIN",
    "dropmalst": "WY",
    "dropmalzpp": 823249998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073487313,
    "dropsitcph": 3073487313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B363",
    "droptype": "D",
    "dropname": "EMBLEM",
    "dropdeladd": "979 US HIGHWAY 20",
    "dropdelcty": "EMBLEM",
    "dropdelst": "WY",
    "dropdelzpp": 824229900,
    "dropphyadd": "979 US HIGHWAY 20",
    "dropphycty": "EMBLEM",
    "dropphyst": "WY",
    "dropphyzpp": 824229900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMBLEM",
    "dropmalst": "WY",
    "dropmalzpp": 824229998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077623475,
    "dropsitcph": 3077623475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B364",
    "droptype": "D",
    "dropname": "ENCAMPMENT",
    "dropdeladd": "622 MCCAFFREY AVE",
    "dropdelcty": "ENCAMPMENT",
    "dropdelst": "WY",
    "dropdelzpp": 823259904,
    "dropphyadd": "622 MCCAFFREY AVE",
    "dropphycty": "ENCAMPMENT",
    "dropphyst": "WY",
    "dropphyzpp": 823259904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENCAMPMENT",
    "dropmalst": "WY",
    "dropmalzpp": 823259998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074230654,
    "dropsitcph": 3074230654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B367",
    "droptype": "D",
    "dropname": "EVANSTON",
    "dropdeladd": "100 HARRISON DR",
    "dropdelcty": "EVANSTON",
    "dropdelst": "WY",
    "dropdelzpp": 829309998,
    "dropphyadd": "100 HARRISON DR",
    "dropphycty": "EVANSTON",
    "dropphyst": "WY",
    "dropphyzpp": 829309998,
    "dropmaladd": "100 HARRISON DR",
    "dropmalcty": "EVANSTON",
    "dropmalst": "WY",
    "dropmalzpp": 829309998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077892912,
    "dropsitcph": 3077892912,
    "dropfax": 3077896148
  },
  {
    "dcode": "D",
    "dropkey": "PW1B368",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "236 TEXAS ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 826369990,
    "dropphyadd": "236 TEXAS ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 826369990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 826369998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072377268,
    "dropsitcph": 3072377268,
    "dropfax": 3072372959
  },
  {
    "dcode": "D",
    "dropkey": "PW1B369",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "210 FAIRVIEW S",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "WY",
    "dropdelzpp": 831199900,
    "dropphyadd": "210 FAIRVIEW S",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "WY",
    "dropphyzpp": 831199900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "WY",
    "dropmalzpp": 831199998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078860515,
    "dropsitcph": 3078860515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B370",
    "droptype": "D",
    "dropname": "FARSON",
    "dropdeladd": "4050 N US HIGHWAY 191",
    "dropdelcty": "FARSON",
    "dropdelst": "WY",
    "dropdelzpp": 829329800,
    "dropphyadd": "4050 N US HIGHWAY 191",
    "dropphycty": "FARSON",
    "dropphyst": "WY",
    "dropphyzpp": 829329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARSON",
    "dropmalst": "WY",
    "dropmalzpp": 829329998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072735123,
    "dropsitcph": 3072735123,
    "dropfax": 3072735360
  },
  {
    "dcode": "D",
    "dropkey": "PW1B375",
    "droptype": "D",
    "dropname": "FORT BRIDGER",
    "dropdeladd": "3730 COUNTY ROAD 219",
    "dropdelcty": "FORT BRIDGER",
    "dropdelst": "WY",
    "dropdelzpp": 829338850,
    "dropphyadd": "3730 COUNTY ROAD 219",
    "dropphycty": "FORT BRIDGER",
    "dropphyst": "WY",
    "dropphyzpp": 829338850,
    "dropmaladd": "3730 COUNTY ROAD 219",
    "dropmalcty": "FORT BRIDGER",
    "dropmalst": "WY",
    "dropmalzpp": 829338850,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077826573,
    "dropsitcph": 3077826573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B376",
    "droptype": "D",
    "dropname": "FORT LARAMIE",
    "dropdeladd": "105 E MERRIAM ST",
    "dropdelcty": "FORT LARAMIE",
    "dropdelst": "WY",
    "dropdelzpp": 822129900,
    "dropphyadd": "105 E MERRIAM ST",
    "dropphycty": "FORT LARAMIE",
    "dropphyst": "WY",
    "dropphyzpp": 822129900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT LARAMIE",
    "dropmalst": "WY",
    "dropmalzpp": 822129998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078372232,
    "dropsitcph": 3078372232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B378",
    "droptype": "D",
    "dropname": "FORT WASHAKIE",
    "dropdeladd": "14 N FORK RD",
    "dropdelcty": "FORT WASHAKIE",
    "dropdelst": "WY",
    "dropdelzpp": 825149900,
    "dropphyadd": "14 N FORK RD",
    "dropphycty": "FORT WASHAKIE",
    "dropphyst": "WY",
    "dropphyzpp": 825149900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT WASHAKIE",
    "dropmalst": "WY",
    "dropmalzpp": 825149998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073322481,
    "dropsitcph": 3073322481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B380",
    "droptype": "D",
    "dropname": "FRANNIE",
    "dropdeladd": "392 ASH ST",
    "dropdelcty": "FRANNIE",
    "dropdelst": "WY",
    "dropdelzpp": 824239900,
    "dropphyadd": "392 ASH ST",
    "dropphycty": "FRANNIE",
    "dropphyst": "WY",
    "dropphyzpp": 824239900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANNIE",
    "dropmalst": "WY",
    "dropmalzpp": 824239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076642791,
    "dropsitcph": 3076642791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B381",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "5740 COUNTY ROAD 125",
    "dropdelcty": "FREEDOM",
    "dropdelst": "WY",
    "dropdelzpp": 831209901,
    "dropphyadd": "5740 COUNTY ROAD 125",
    "dropphycty": "FREEDOM",
    "dropphyst": "WY",
    "dropphyzpp": 831209901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEDOM",
    "dropmalst": "WY",
    "dropmalzpp": 831209998,
    "dropsitphn": 3077726524,
    "dropsitlph": 8779078009,
    "dropsitcph": 8779078009,
    "dropfax": 3078832811
  },
  {
    "dcode": "D",
    "dropkey": "PW1B388",
    "droptype": "D",
    "dropname": "GILLETTE",
    "dropdeladd": "311 S KENDRICK AVE",
    "dropdelcty": "GILLETTE",
    "dropdelst": "WY",
    "dropdelzpp": 827169998,
    "dropphyadd": "311 S KENDRICK AVE",
    "dropphycty": "GILLETTE",
    "dropphyst": "WY",
    "dropphyzpp": 827169998,
    "dropmaladd": "311 S KENDRICK AVE",
    "dropmalcty": "GILLETTE",
    "dropmalst": "WY",
    "dropmalzpp": 827169998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076823727,
    "dropsitcph": 3076823727,
    "dropfax": 3076872818
  },
  {
    "dcode": "D",
    "dropkey": "PW1B389",
    "droptype": "D",
    "dropname": "GLENDO",
    "dropdeladd": "118 N YELLOWSTONE HWY",
    "dropdelcty": "GLENDO",
    "dropdelst": "WY",
    "dropdelzpp": 822139901,
    "dropphyadd": "118 N YELLOWSTONE HWY",
    "dropphycty": "GLENDO",
    "dropphyst": "WY",
    "dropphyzpp": 822139901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENDO",
    "dropmalst": "WY",
    "dropmalzpp": 822139998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077353410,
    "dropsitcph": 3077353413,
    "dropfax": 3077354574
  },
  {
    "dcode": "D",
    "dropkey": "PW1B390",
    "droptype": "D",
    "dropname": "GLENROCK",
    "dropdeladd": "703 W BIRCH ST",
    "dropdelcty": "GLENROCK",
    "dropdelst": "WY",
    "dropdelzpp": 826379990,
    "dropphyadd": "703 W BIRCH ST",
    "dropphycty": "GLENROCK",
    "dropphyst": "WY",
    "dropphyzpp": 826379990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENROCK",
    "dropmalst": "WY",
    "dropmalzpp": 826379998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074369723,
    "dropsitcph": 3074369723,
    "dropfax": 3074369003
  },
  {
    "dcode": "D",
    "dropkey": "PW1B391",
    "droptype": "D",
    "dropname": "GRANGER",
    "dropdeladd": "102 PINE ST",
    "dropdelcty": "GRANGER",
    "dropdelst": "WY",
    "dropdelzpp": 829349800,
    "dropphyadd": "102 PINE ST",
    "dropphycty": "GRANGER",
    "dropphyst": "WY",
    "dropphyzpp": 829349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANGER",
    "dropmalst": "WY",
    "dropmalzpp": 829349998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078756961,
    "dropsitcph": 3078756961,
    "dropfax": 3078759722
  },
  {
    "dcode": "D",
    "dropkey": "PW1B396",
    "droptype": "D",
    "dropname": "GREEN RIVER",
    "dropdeladd": "350 UINTA DR",
    "dropdelcty": "GREEN RIVER",
    "dropdelst": "WY",
    "dropdelzpp": 829359998,
    "dropphyadd": "350 UINTA DR",
    "dropphycty": "GREEN RIVER",
    "dropphyst": "WY",
    "dropphyzpp": 829359998,
    "dropmaladd": "350 UINTA DR",
    "dropmalcty": "GREEN RIVER",
    "dropmalst": "WY",
    "dropmalzpp": 829359998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078754920,
    "dropsitcph": 3078754920,
    "dropfax": 3078759421
  },
  {
    "dcode": "D",
    "dropkey": "PW1B397",
    "droptype": "D",
    "dropname": "GREYBULL",
    "dropdeladd": "401 GREYBULL AVE",
    "dropdelcty": "GREYBULL",
    "dropdelst": "WY",
    "dropdelzpp": 824262059,
    "dropphyadd": "401 GREYBULL AVE",
    "dropphycty": "GREYBULL",
    "dropphyst": "WY",
    "dropphyzpp": 824262059,
    "dropmaladd": "401 GREYBULL AVE",
    "dropmalcty": "GREYBULL",
    "dropmalst": "WY",
    "dropmalzpp": 824269998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077654771,
    "dropsitcph": 3077654771,
    "dropfax": 3077654503
  },
  {
    "dcode": "D",
    "dropkey": "PW1B398",
    "droptype": "D",
    "dropname": "GROVER",
    "dropdeladd": "89768 US HIGHWAY 89",
    "dropdelcty": "GROVER",
    "dropdelst": "WY",
    "dropdelzpp": 831229901,
    "dropphyadd": "89768 US HIGHWAY 89",
    "dropphycty": "GROVER",
    "dropphyst": "WY",
    "dropphyzpp": 831229901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GROVER",
    "dropmalst": "WY",
    "dropmalzpp": 831229998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078863038,
    "dropsitcph": 3078863038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B399",
    "droptype": "D",
    "dropname": "GUERNSEY",
    "dropdeladd": "101 S WYOMING",
    "dropdelcty": "GUERNSEY",
    "dropdelst": "WY",
    "dropdelzpp": 822149901,
    "dropphyadd": "101 S WYOMING",
    "dropphycty": "GUERNSEY",
    "dropphyst": "WY",
    "dropphyzpp": 822149901,
    "dropmaladd": "101 S WYOMING",
    "dropmalcty": "GUERNSEY",
    "dropmalst": "WY",
    "dropmalzpp": 822149901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078362804,
    "dropsitcph": 3078362804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B402",
    "droptype": "D",
    "dropname": "HANNA",
    "dropdeladd": "1001 JADE DR",
    "dropdelcty": "HANNA",
    "dropdelst": "WY",
    "dropdelzpp": 823279901,
    "dropphyadd": "1001 JADE DR",
    "dropphycty": "HANNA",
    "dropphyst": "WY",
    "dropphyzpp": 823279901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANNA",
    "dropmalst": "WY",
    "dropmalzpp": 823279998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073256742,
    "dropsitcph": 3073256742,
    "dropfax": 3073256742
  },
  {
    "dcode": "D",
    "dropkey": "PW1B404",
    "droptype": "D",
    "dropname": "HARTVILLE",
    "dropdeladd": "135 MAIN ST",
    "dropdelcty": "HARTVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 822159901,
    "dropphyadd": "135 MAIN ST",
    "dropphycty": "HARTVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 822159901,
    "dropmaladd": "135 MAIN ST",
    "dropmalcty": "HARTVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 822159901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078362516,
    "dropsitcph": 3078362516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B405",
    "droptype": "D",
    "dropname": "HAWK SPRINGS",
    "dropdeladd": "114 RAILWAY ST",
    "dropdelcty": "HAWK SPRINGS",
    "dropdelst": "WY",
    "dropdelzpp": 822179900,
    "dropphyadd": "114 RAILWAY ST",
    "dropphycty": "HAWK SPRINGS",
    "dropphyst": "WY",
    "dropphyzpp": 822179900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWK SPRINGS",
    "dropmalst": "WY",
    "dropmalzpp": 822179998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075328888,
    "dropsitcph": 3075328888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B408",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "1463 COATES AVE",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "WY",
    "dropdelzpp": 820609990,
    "dropphyadd": "1463 COATES AVE",
    "dropphycty": "HILLSDALE",
    "dropphyst": "WY",
    "dropphyzpp": 820609990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "WY",
    "dropmalzpp": 820609998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075479250,
    "dropsitcph": 3075479250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B411",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "280 S MAIN ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "WY",
    "dropdelzpp": 825159900,
    "dropphyadd": "280 S MAIN ST",
    "dropphycty": "HUDSON",
    "dropphyst": "WY",
    "dropphyzpp": 825159900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUDSON",
    "dropmalst": "WY",
    "dropmalzpp": 825159998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073325596,
    "dropsitcph": 3073325596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B412",
    "droptype": "D",
    "dropname": "HULETT",
    "dropdeladd": "193 BIRCH ST",
    "dropdelcty": "HULETT",
    "dropdelst": "WY",
    "dropdelzpp": 827209998,
    "dropphyadd": "193 BIRCH ST",
    "dropphycty": "HULETT",
    "dropphyst": "WY",
    "dropphyzpp": 827209998,
    "dropmaladd": "193 BIRCH ST",
    "dropmalcty": "HULETT",
    "dropmalst": "WY",
    "dropmalzpp": 827209998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073065662,
    "dropsitcph": 3073065662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B413",
    "droptype": "D",
    "dropname": "HUNTLEY",
    "dropdeladd": "245 BROADWAY",
    "dropdelcty": "HUNTLEY",
    "dropdelst": "WY",
    "dropdelzpp": 822189901,
    "dropphyadd": "245 BROADWAY",
    "dropphycty": "HUNTLEY",
    "dropphyst": "WY",
    "dropphyzpp": 822189901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTLEY",
    "dropmalst": "WY",
    "dropmalzpp": 822189998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075328710,
    "dropsitcph": 3075328710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B414",
    "droptype": "D",
    "dropname": "HYATTVILLE",
    "dropdeladd": "223 S MAIN ST",
    "dropdelcty": "HYATTVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 824289900,
    "dropphyadd": "223 S MAIN ST",
    "dropphycty": "HYATTVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 824289900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYATTVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 824289998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074692360,
    "dropsitcph": 3074692360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B415",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "1070 MAPLE WAY",
    "dropdelcty": "JACKSON",
    "dropdelst": "WY",
    "dropdelzpp": 830029998,
    "dropphyadd": "1070 MAPLE WAY",
    "dropphycty": "JACKSON",
    "dropphyst": "WY",
    "dropphyzpp": 830029998,
    "dropmaladd": "1070 MAPLE WAY",
    "dropmalcty": "JACKSON",
    "dropmalst": "WY",
    "dropmalzpp": 830029998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072647213,
    "dropsitcph": 3077333650,
    "dropfax": 3077337413
  },
  {
    "dcode": "D",
    "dropkey": "PW1B416",
    "droptype": "D",
    "dropname": "JAY EM",
    "dropdeladd": "220 AUTUMN ST",
    "dropdelcty": "JAY EM",
    "dropdelst": "WY",
    "dropdelzpp": 822199900,
    "dropphyadd": "220 AUTUMN ST",
    "dropphycty": "JAY EM",
    "dropphyst": "WY",
    "dropphyzpp": 822199900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAY EM",
    "dropmalst": "WY",
    "dropmalzpp": 822199998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072939689,
    "dropsitcph": 3075322944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B420",
    "droptype": "D",
    "dropname": "KAYCEE",
    "dropdeladd": "352 NOLAN AVE",
    "dropdelcty": "KAYCEE",
    "dropdelst": "WY",
    "dropdelzpp": 826399990,
    "dropphyadd": "352 NOLAN AVE",
    "dropphycty": "KAYCEE",
    "dropphyst": "WY",
    "dropphyzpp": 826399990,
    "dropmaladd": "352 NOLAN AVE",
    "dropmalcty": "KAYCEE",
    "dropmalst": "WY",
    "dropmalzpp": 826399990,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077382333,
    "dropsitcph": 3077382333,
    "dropfax": 3077382397
  },
  {
    "dcode": "D",
    "dropkey": "PW1B422",
    "droptype": "D",
    "dropname": "KELLY",
    "dropdeladd": "4486 LOWER GROS VENTRE RD",
    "dropdelcty": "KELLY",
    "dropdelst": "WY",
    "dropdelzpp": 830119902,
    "dropphyadd": "4486 LOWER GROS VENTRE RD",
    "dropphycty": "KELLY",
    "dropphyst": "WY",
    "dropphyzpp": 830119902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLY",
    "dropmalst": "WY",
    "dropmalzpp": 830119998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077338884,
    "dropsitcph": 3077338884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B423",
    "droptype": "D",
    "dropname": "KEMMERER",
    "dropdeladd": "318 SAPPHIRE ST",
    "dropdelcty": "KEMMERER",
    "dropdelst": "WY",
    "dropdelzpp": 831019998,
    "dropphyadd": "318 SAPPHIRE ST",
    "dropphycty": "KEMMERER",
    "dropphyst": "WY",
    "dropphyzpp": 831019998,
    "dropmaladd": "318 SAPPHIRE ST",
    "dropmalcty": "KEMMERER",
    "dropmalst": "WY",
    "dropmalzpp": 831019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078773432,
    "dropsitcph": 3078773432,
    "dropfax": 3078779537
  },
  {
    "dcode": "D",
    "dropkey": "PW1B424",
    "droptype": "D",
    "dropname": "KINNEAR",
    "dropdeladd": "11517 US HIGHWAY 26",
    "dropdelcty": "KINNEAR",
    "dropdelst": "WY",
    "dropdelzpp": 825168719,
    "dropphyadd": "11517 US HIGHWAY 26",
    "dropphycty": "KINNEAR",
    "dropphyst": "WY",
    "dropphyzpp": 825168719,
    "dropmaladd": "11517 US HIGHWAY 26",
    "dropmalcty": "KINNEAR",
    "dropmalst": "WY",
    "dropmalzpp": 825168719,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078564440,
    "dropsitcph": 3078564440,
    "dropfax": 3078564440
  },
  {
    "dcode": "D",
    "dropkey": "PW1B428",
    "droptype": "D",
    "dropname": "LA BARGE",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "LA BARGE",
    "dropdelst": "WY",
    "dropdelzpp": 831239900,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "LA BARGE",
    "dropphyst": "WY",
    "dropphyzpp": 831239900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA BARGE",
    "dropmalst": "WY",
    "dropmalzpp": 831239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073862279,
    "dropsitcph": 3073862279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B429",
    "droptype": "D",
    "dropname": "LAGRANGE",
    "dropdeladd": "201 5TH AVE",
    "dropdelcty": "LAGRANGE",
    "dropdelst": "WY",
    "dropdelzpp": 822219900,
    "dropphyadd": "201 5TH AVE",
    "dropphycty": "LAGRANGE",
    "dropphyst": "WY",
    "dropphyzpp": 822219900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAGRANGE",
    "dropmalst": "WY",
    "dropmalzpp": 822219998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078342213,
    "dropsitcph": 3078342213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B432",
    "droptype": "D",
    "dropname": "LANCE CREEK",
    "dropdeladd": "1805 HIGHWAY 270",
    "dropdelcty": "LANCE CREEK",
    "dropdelst": "WY",
    "dropdelzpp": 822229900,
    "dropphyadd": "1805 HIGHWAY 270",
    "dropphycty": "LANCE CREEK",
    "dropphyst": "WY",
    "dropphyzpp": 822229900,
    "dropmaladd": "1805 HIGHWAY 270",
    "dropmalcty": "LANCE CREEK",
    "dropmalst": "WY",
    "dropmalzpp": 822229900,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074813092,
    "dropsitcph": 3074813092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B433",
    "droptype": "D",
    "dropname": "LANDER",
    "dropdeladd": "230 GRANDVIEW DR",
    "dropdelcty": "LANDER",
    "dropdelst": "WY",
    "dropdelzpp": 825209998,
    "dropphyadd": "230 GRANDVIEW DR",
    "dropphycty": "LANDER",
    "dropphyst": "WY",
    "dropphyzpp": 825209998,
    "dropmaladd": "230 GRANDVIEW DR",
    "dropmalcty": "LANDER",
    "dropmalst": "WY",
    "dropmalzpp": 825209998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073322126,
    "dropsitcph": 3073322126,
    "dropfax": 3073328166
  },
  {
    "dcode": "D",
    "dropkey": "PW1B434",
    "droptype": "D",
    "dropname": "LARAMIE",
    "dropdeladd": "152 N 5TH ST",
    "dropdelcty": "LARAMIE",
    "dropdelst": "WY",
    "dropdelzpp": 820729998,
    "dropphyadd": "152 N 5TH ST",
    "dropphycty": "LARAMIE",
    "dropphyst": "WY",
    "dropphyzpp": 820729998,
    "dropmaladd": "152 N 5TH ST",
    "dropmalcty": "LARAMIE",
    "dropmalst": "WY",
    "dropmalzpp": 820729998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077555510,
    "dropsitcph": 3077218837,
    "dropfax": 3077456259
  },
  {
    "dcode": "D",
    "dropkey": "PW1B435",
    "droptype": "D",
    "dropname": "LEITER",
    "dropdeladd": "4679 US HIGHWAY 14-16 E",
    "dropdelcty": "LEITER",
    "dropdelst": "WY",
    "dropdelzpp": 828379900,
    "dropphyadd": "4679 US HIGHWAY 14-16 E",
    "dropphycty": "LEITER",
    "dropphyst": "WY",
    "dropphyzpp": 828379900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEITER",
    "dropmalst": "WY",
    "dropmalzpp": 828379998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077584414,
    "dropsitcph": 3077584414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B437",
    "droptype": "D",
    "dropname": "LINCH",
    "dropdeladd": "200 JACKSON ST",
    "dropdelcty": "LINCH",
    "dropdelst": "WY",
    "dropdelzpp": 826409990,
    "dropphyadd": "200 JACKSON ST",
    "dropphycty": "LINCH",
    "dropphyst": "WY",
    "dropphyzpp": 826409990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCH",
    "dropmalst": "WY",
    "dropmalzpp": 826409998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074376301,
    "dropsitcph": 3074376301,
    "dropfax": 3074376301
  },
  {
    "dcode": "D",
    "dropkey": "PW1B439",
    "droptype": "D",
    "dropname": "LINGLE",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "LINGLE",
    "dropdelst": "WY",
    "dropdelzpp": 822239901,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "LINGLE",
    "dropphyst": "WY",
    "dropphyzpp": 822239901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINGLE",
    "dropmalst": "WY",
    "dropmalzpp": 822239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076229136,
    "dropsitcph": 3076229170,
    "dropfax": 3076229145
  },
  {
    "dcode": "D",
    "dropkey": "PW1B445",
    "droptype": "D",
    "dropname": "LOVELL",
    "dropdeladd": "167 E 3RD ST",
    "dropdelcty": "LOVELL",
    "dropdelst": "WY",
    "dropdelzpp": 824319998,
    "dropphyadd": "167 E 3RD ST",
    "dropphycty": "LOVELL",
    "dropphyst": "WY",
    "dropphyzpp": 824319998,
    "dropmaladd": "167 E 3RD ST",
    "dropmalcty": "LOVELL",
    "dropmalst": "WY",
    "dropmalzpp": 824319998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075487605,
    "dropsitcph": 3075487605,
    "dropfax": 3075486300
  },
  {
    "dcode": "D",
    "dropkey": "PW1B447",
    "droptype": "D",
    "dropname": "LUSK",
    "dropdeladd": "116 W 3RD ST",
    "dropdelcty": "LUSK",
    "dropdelst": "WY",
    "dropdelzpp": 822259903,
    "dropphyadd": "116 W 3RD ST",
    "dropphycty": "LUSK",
    "dropphyst": "WY",
    "dropphyzpp": 822259903,
    "dropmaladd": "116 W 3RD ST",
    "dropmalcty": "LUSK",
    "dropmalst": "WY",
    "dropmalzpp": 822259903,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076229135,
    "dropsitcph": 3076229135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B448",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "LYMAN",
    "dropdelst": "WY",
    "dropdelzpp": 829379800,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "LYMAN",
    "dropphyst": "WY",
    "dropphyzpp": 829379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYMAN",
    "dropmalst": "WY",
    "dropmalzpp": 829379998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072484269,
    "dropsitcph": 3077353783,
    "dropfax": 3077873342
  },
  {
    "dcode": "D",
    "dropkey": "PW1B449",
    "droptype": "D",
    "dropname": "LYSITE",
    "dropdeladd": "25 FREMONT ST",
    "dropdelcty": "LYSITE",
    "dropdelst": "WY",
    "dropdelzpp": 826429990,
    "dropphyadd": "25 FREMONT ST",
    "dropphycty": "LYSITE",
    "dropphyst": "WY",
    "dropphyzpp": 826429990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYSITE",
    "dropmalst": "WY",
    "dropmalzpp": 826429998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078762456,
    "dropsitcph": 3078762456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B451",
    "droptype": "D",
    "dropname": "MANDERSON",
    "dropdeladd": "193 N SHERMAN AVE",
    "dropdelcty": "MANDERSON",
    "dropdelst": "WY",
    "dropdelzpp": 824329901,
    "dropphyadd": "193 N SHERMAN AVE",
    "dropphycty": "MANDERSON",
    "dropphyst": "WY",
    "dropphyzpp": 824329901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANDERSON",
    "dropmalst": "WY",
    "dropmalzpp": 824329997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075682606,
    "dropsitcph": 3075682606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B453",
    "droptype": "D",
    "dropname": "MANVILLE",
    "dropdeladd": "225 9TH AVE",
    "dropdelcty": "MANVILLE",
    "dropdelst": "WY",
    "dropdelzpp": 822279901,
    "dropphyadd": "225 9TH AVE",
    "dropphycty": "MANVILLE",
    "dropphyst": "WY",
    "dropphyzpp": 822279901,
    "dropmaladd": "225 9TH AVE",
    "dropmalcty": "MANVILLE",
    "dropmalst": "WY",
    "dropmalzpp": 822279901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073342945,
    "dropsitcph": 3073342945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B458",
    "droptype": "D",
    "dropname": "MEDICINE BOW",
    "dropdeladd": "113 CEDAR ST",
    "dropdelcty": "MEDICINE BOW",
    "dropdelst": "WY",
    "dropdelzpp": 823298117,
    "dropphyadd": "113 CEDAR ST",
    "dropphycty": "MEDICINE BOW",
    "dropphyst": "WY",
    "dropphyzpp": 823298117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDICINE BOW",
    "dropmalst": "WY",
    "dropmalzpp": 823299998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073792356,
    "dropsitcph": 3073792356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B459",
    "droptype": "D",
    "dropname": "MEETEETSE",
    "dropdeladd": "1022 PARK AVE",
    "dropdelcty": "MEETEETSE",
    "dropdelst": "WY",
    "dropdelzpp": 824339997,
    "dropphyadd": "1022 PARK AVE",
    "dropphycty": "MEETEETSE",
    "dropphyst": "WY",
    "dropphyzpp": 824339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEETEETSE",
    "dropmalst": "WY",
    "dropmalzpp": 824339998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078682461,
    "dropsitcph": 3078682461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B462",
    "droptype": "D",
    "dropname": "MIDWEST",
    "dropdeladd": "132 STOCK ST",
    "dropdelcty": "MIDWEST",
    "dropdelst": "WY",
    "dropdelzpp": 826439990,
    "dropphyadd": "132 STOCK ST",
    "dropphycty": "MIDWEST",
    "dropphyst": "WY",
    "dropphyzpp": 826439990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDWEST",
    "dropmalst": "WY",
    "dropmalzpp": 826439998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074376859,
    "dropsitcph": 3074376859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B463",
    "droptype": "D",
    "dropname": "MILLS",
    "dropdeladd": "526 SW WYOMING BLVD",
    "dropdelcty": "MILLS",
    "dropdelst": "WY",
    "dropdelzpp": 826449990,
    "dropphyadd": "526 SW WYOMING BLVD",
    "dropphycty": "MILLS",
    "dropphyst": "WY",
    "dropphyzpp": 826449990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLS",
    "dropmalst": "WY",
    "dropmalzpp": 826449998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072353500,
    "dropsitcph": 3072353500,
    "dropfax": 3072344569
  },
  {
    "dcode": "D",
    "dropkey": "PW1B464",
    "droptype": "D",
    "dropname": "MOORCROFT",
    "dropdeladd": "120 N BIG HORN AVE",
    "dropdelcty": "MOORCROFT",
    "dropdelst": "WY",
    "dropdelzpp": 827219998,
    "dropphyadd": "120 N BIG HORN AVE",
    "dropphycty": "MOORCROFT",
    "dropphyst": "WY",
    "dropphyzpp": 827219998,
    "dropmaladd": "120 N BIG HORN AVE",
    "dropmalcty": "MOORCROFT",
    "dropmalst": "WY",
    "dropmalzpp": 827219998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077563362,
    "dropsitcph": 3077563362,
    "dropfax": 3077563857
  },
  {
    "dcode": "D",
    "dropkey": "PW1B465",
    "droptype": "D",
    "dropname": "MOOSE",
    "dropdeladd": "3 TETON PARK RD",
    "dropdelcty": "MOOSE",
    "dropdelst": "WY",
    "dropdelzpp": 830129903,
    "dropphyadd": "3 TETON PARK RD",
    "dropphycty": "MOOSE",
    "dropphyst": "WY",
    "dropphyzpp": 830129903,
    "dropmaladd": "3 TETON PARK RD",
    "dropmalcty": "MOOSE",
    "dropmalst": "WY",
    "dropmalzpp": 830129903,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077333336,
    "dropsitcph": 3077333336,
    "dropfax": 3077340941
  },
  {
    "dcode": "D",
    "dropkey": "PW1B466",
    "droptype": "D",
    "dropname": "MORAN",
    "dropdeladd": "1 CENTRAL ST",
    "dropdelcty": "MORAN",
    "dropdelst": "WY",
    "dropdelzpp": 830139901,
    "dropphyadd": "1 CENTRAL ST",
    "dropphycty": "MORAN",
    "dropphyst": "WY",
    "dropphyzpp": 830139901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORAN",
    "dropmalst": "WY",
    "dropmalzpp": 830139998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075432527,
    "dropsitcph": 3075432527,
    "dropfax": 3075439108
  },
  {
    "dcode": "D",
    "dropkey": "PW1B469",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "1700 E PARKWAY ST",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "WY",
    "dropdelzpp": 829399900,
    "dropphyadd": "1700 E PARKWAY ST",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "WY",
    "dropphyzpp": 829399900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "WY",
    "dropmalzpp": 829399998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077823718,
    "dropsitcph": 3077823718,
    "dropfax": 3072158125
  },
  {
    "dcode": "D",
    "dropkey": "PW1B473",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "24 W MAIN ST",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "WY",
    "dropdelzpp": 827019998,
    "dropphyadd": "24 W MAIN ST",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "WY",
    "dropphyzpp": 827019998,
    "dropmaladd": "24 W MAIN ST",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "WY",
    "dropmalzpp": 827019998,
    "dropsitphn": 3076291681,
    "dropsitlph": 3077353418,
    "dropsitcph": 3077462309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B482",
    "droptype": "D",
    "dropname": "OPAL",
    "dropdeladd": "554 SOLIDAY ST",
    "dropdelcty": "OPAL",
    "dropdelst": "WY",
    "dropdelzpp": 831249900,
    "dropphyadd": "554 SOLIDAY ST",
    "dropphycty": "OPAL",
    "dropphyst": "WY",
    "dropphyzpp": 831249900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OPAL",
    "dropmalst": "WY",
    "dropmalzpp": 831249998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078776345,
    "dropsitcph": 3078776345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B484",
    "droptype": "D",
    "dropname": "OSAGE",
    "dropdeladd": "319 NEFSY AVE",
    "dropdelcty": "OSAGE",
    "dropdelst": "WY",
    "dropdelzpp": 827238804,
    "dropphyadd": "319 NEFSY AVE",
    "dropphycty": "OSAGE",
    "dropphyst": "WY",
    "dropphyzpp": 827238804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSAGE",
    "dropmalst": "WY",
    "dropmalzpp": 827239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074652330,
    "dropsitcph": 3074652330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B488",
    "droptype": "D",
    "dropname": "PARKMAN",
    "dropdeladd": "49 RAILWAY AVE",
    "dropdelcty": "PARKMAN",
    "dropdelst": "WY",
    "dropdelzpp": 828389901,
    "dropphyadd": "49 RAILWAY AVE",
    "dropphycty": "PARKMAN",
    "dropphyst": "WY",
    "dropphyzpp": 828389901,
    "dropmaladd": "49 RAILWAY AVE",
    "dropmalcty": "PARKMAN",
    "dropmalst": "WY",
    "dropmalzpp": 828389901,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076559368,
    "dropsitcph": 3076559368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B489",
    "droptype": "D",
    "dropname": "PAVILLION",
    "dropdeladd": "224 N MAIN ST",
    "dropdelcty": "PAVILLION",
    "dropdelst": "WY",
    "dropdelzpp": 825239001,
    "dropphyadd": "224 N MAIN ST",
    "dropphycty": "PAVILLION",
    "dropphyst": "WY",
    "dropphyzpp": 825239001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAVILLION",
    "dropmalst": "WY",
    "dropmalzpp": 825239998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078566333,
    "dropsitcph": 3078566333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B491",
    "droptype": "D",
    "dropname": "PINE BLUFFS",
    "dropdeladd": "115 W 4TH ST",
    "dropdelcty": "PINE BLUFFS",
    "dropdelst": "WY",
    "dropdelzpp": 820829901,
    "dropphyadd": "115 W 4TH ST",
    "dropphycty": "PINE BLUFFS",
    "dropphyst": "WY",
    "dropphyzpp": 820829901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE BLUFFS",
    "dropmalst": "WY",
    "dropmalzpp": 820829998,
    "dropsitphn": 3072453568,
    "dropsitlph": 3072453568,
    "dropsitcph": 3072453568,
    "dropfax": 3072453234
  },
  {
    "dcode": "D",
    "dropkey": "PW1B493",
    "droptype": "D",
    "dropname": "PINEDALE",
    "dropdeladd": "413 PINE ST",
    "dropdelcty": "PINEDALE",
    "dropdelst": "WY",
    "dropdelzpp": 829419050,
    "dropphyadd": "413 PINE ST",
    "dropphycty": "PINEDALE",
    "dropphyst": "WY",
    "dropphyzpp": 829419050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINEDALE",
    "dropmalst": "WY",
    "dropmalzpp": 829419998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073672650,
    "dropsitcph": 3073672650,
    "dropfax": 3073672273
  },
  {
    "dcode": "D",
    "dropkey": "PW1B495",
    "droptype": "D",
    "dropname": "POWDER RIVER",
    "dropdeladd": "35304 W HIGHWAY 20 26",
    "dropdelcty": "POWDER RIVER",
    "dropdelst": "WY",
    "dropdelzpp": 826489990,
    "dropphyadd": "35304 W HIGHWAY 20 26",
    "dropphycty": "POWDER RIVER",
    "dropphyst": "WY",
    "dropphyzpp": 826489990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POWDER RIVER",
    "dropmalst": "WY",
    "dropmalzpp": 826489998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075778146,
    "dropsitcph": 3075778146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B496",
    "droptype": "D",
    "dropname": "POWELL",
    "dropdeladd": "270 N BENT ST",
    "dropdelcty": "POWELL",
    "dropdelst": "WY",
    "dropdelzpp": 824359998,
    "dropphyadd": "270 N BENT ST",
    "dropphycty": "POWELL",
    "dropphyst": "WY",
    "dropphyzpp": 824359998,
    "dropmaladd": "270 N BENT ST",
    "dropmalcty": "POWELL",
    "dropmalst": "WY",
    "dropmalzpp": 824359998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077542952,
    "dropsitcph": 3077542952,
    "dropfax": 3077544878
  },
  {
    "dcode": "D",
    "dropkey": "PW1B499",
    "droptype": "D",
    "dropname": "RALSTON",
    "dropdeladd": "680 MAIN ST",
    "dropdelcty": "RALSTON",
    "dropdelst": "WY",
    "dropdelzpp": 824409900,
    "dropphyadd": "680 MAIN ST",
    "dropphycty": "RALSTON",
    "dropphyst": "WY",
    "dropphyzpp": 824409900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RALSTON",
    "dropmalst": "WY",
    "dropmalzpp": 824409998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077547955,
    "dropsitcph": 3077543712,
    "dropfax": 3077547955
  },
  {
    "dcode": "D",
    "dropkey": "PW1B500",
    "droptype": "D",
    "dropname": "RANCHESTER",
    "dropdeladd": "551 US HIGHWAY 14",
    "dropdelcty": "RANCHESTER",
    "dropdelst": "WY",
    "dropdelzpp": 828399903,
    "dropphyadd": "551 US HIGHWAY 14",
    "dropphycty": "RANCHESTER",
    "dropphyst": "WY",
    "dropphyzpp": 828399903,
    "dropmaladd": "551 US HIGHWAY 14",
    "dropmalcty": "RANCHESTER",
    "dropmalst": "WY",
    "dropmalzpp": 828399903,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076552576,
    "dropsitcph": 3076552576,
    "dropfax": 3076552576
  },
  {
    "dcode": "D",
    "dropkey": "PW1B502",
    "droptype": "D",
    "dropname": "RAWLINS",
    "dropdeladd": "106 5TH ST",
    "dropdelcty": "RAWLINS",
    "dropdelst": "WY",
    "dropdelzpp": 823019998,
    "dropphyadd": "106 5TH ST",
    "dropphycty": "RAWLINS",
    "dropphyst": "WY",
    "dropphyzpp": 823019998,
    "dropmaladd": "106 5TH ST",
    "dropmalcty": "RAWLINS",
    "dropmalst": "WY",
    "dropmalzpp": 823019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073243521,
    "dropsitcph": 3073243521,
    "dropfax": 3073246134
  },
  {
    "dcode": "D",
    "dropkey": "PW1B504",
    "droptype": "D",
    "dropname": "RECLUSE",
    "dropdeladd": "485 RECLUSE RD",
    "dropdelcty": "RECLUSE",
    "dropdelst": "WY",
    "dropdelzpp": 827259901,
    "dropphyadd": "485 RECLUSE RD",
    "dropphycty": "RECLUSE",
    "dropphyst": "WY",
    "dropphyzpp": 827259901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RECLUSE",
    "dropmalst": "WY",
    "dropmalzpp": 827259998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076853071,
    "dropsitcph": 3076853071,
    "dropfax": 3076853071
  },
  {
    "dcode": "D",
    "dropkey": "PW1B510",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "501 E MAIN ST",
    "dropdelcty": "RIVERTON",
    "dropdelst": "WY",
    "dropdelzpp": 825019998,
    "dropphyadd": "501 E MAIN ST",
    "dropphycty": "RIVERTON",
    "dropphyst": "WY",
    "dropphyzpp": 825019998,
    "dropmaladd": "501 E MAIN ST",
    "dropmalcty": "RIVERTON",
    "dropmalst": "WY",
    "dropmalzpp": 825019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078563725,
    "dropsitcph": 3078563725,
    "dropfax": 3078569033
  },
  {
    "dcode": "D",
    "dropkey": "PW1B511",
    "droptype": "D",
    "dropname": "ROBERTSON",
    "dropdeladd": "12286 STATE HIGHWAY 410",
    "dropdelcty": "ROBERTSON",
    "dropdelst": "WY",
    "dropdelzpp": 829449800,
    "dropphyadd": "12286 STATE HIGHWAY 410",
    "dropphycty": "ROBERTSON",
    "dropphyst": "WY",
    "dropphyzpp": 829449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBERTSON",
    "dropmalst": "WY",
    "dropmalzpp": 829449998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077823577,
    "dropsitcph": 3077823577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B512",
    "droptype": "D",
    "dropname": "ROCK RIVER",
    "dropdeladd": "104 S 5TH ST",
    "dropdelcty": "ROCK RIVER",
    "dropdelst": "WY",
    "dropdelzpp": 820839900,
    "dropphyadd": "104 S 5TH ST",
    "dropphycty": "ROCK RIVER",
    "dropphyst": "WY",
    "dropphyzpp": 820839900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK RIVER",
    "dropmalst": "WY",
    "dropmalzpp": 820839998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073782248,
    "dropsitcph": 3073782248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B514",
    "droptype": "D",
    "dropname": "ROCK SPRINGS",
    "dropdeladd": "2829 COMMERCIAL WAY",
    "dropdelcty": "ROCK SPRINGS",
    "dropdelst": "WY",
    "dropdelzpp": 829019998,
    "dropphyadd": "2829 COMMERCIAL WAY",
    "dropphycty": "ROCK SPRINGS",
    "dropphyst": "WY",
    "dropphyzpp": 829019998,
    "dropmaladd": "2829 COMMERCIAL WAY",
    "dropmalcty": "ROCK SPRINGS",
    "dropmalst": "WY",
    "dropmalzpp": 829019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073629792,
    "dropsitcph": 3073629792,
    "dropfax": 3073829735
  },
  {
    "dcode": "D",
    "dropkey": "PW1B516",
    "droptype": "D",
    "dropname": "ROZET",
    "dropdeladd": "14076 STATE HIGHWAY 51",
    "dropdelcty": "ROZET",
    "dropdelst": "WY",
    "dropdelzpp": 827278825,
    "dropphyadd": "14076 STATE HIGHWAY 51",
    "dropphycty": "ROZET",
    "dropphyst": "WY",
    "dropphyzpp": 827278825,
    "dropmaladd": "14076 STATE HIGHWAY 51",
    "dropmalcty": "ROZET",
    "dropmalst": "WY",
    "dropmalzpp": 827278825,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076823962,
    "dropsitcph": 3076823962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B519",
    "droptype": "D",
    "dropname": "SAINT STEPHENS",
    "dropdeladd": "33 SAINT STEPHENS RD",
    "dropdelcty": "SAINT STEPHENS",
    "dropdelst": "WY",
    "dropdelzpp": 825249900,
    "dropphyadd": "33 SAINT STEPHENS RD",
    "dropphycty": "SAINT STEPHENS",
    "dropphyst": "WY",
    "dropphyzpp": 825249900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT STEPHENS",
    "dropmalst": "WY",
    "dropmalzpp": 825249998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078567050,
    "dropsitcph": 3078567050,
    "dropfax": 3078567050
  },
  {
    "dcode": "D",
    "dropkey": "PW1B521",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "SARATOGA",
    "dropdelst": "WY",
    "dropdelzpp": 823319990,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "SARATOGA",
    "dropphyst": "WY",
    "dropphyzpp": 823319990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARATOGA",
    "dropmalst": "WY",
    "dropmalzpp": 823319998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072910655,
    "dropsitcph": 3072910655,
    "dropfax": 3073263071
  },
  {
    "dcode": "D",
    "dropkey": "PW1B522",
    "droptype": "D",
    "dropname": "SAVERY",
    "dropdeladd": "1132 STATE HIGHWAY 70",
    "dropdelcty": "SAVERY",
    "dropdelst": "WY",
    "dropdelzpp": 823329997,
    "dropphyadd": "1132 STATE HIGHWAY 70",
    "dropphycty": "SAVERY",
    "dropphyst": "WY",
    "dropphyzpp": 823329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAVERY",
    "dropmalst": "WY",
    "dropmalzpp": 823329998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073837878,
    "dropsitcph": 3073837878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B524",
    "droptype": "D",
    "dropname": "SHELL",
    "dropdeladd": "114 MAIN ST",
    "dropdelcty": "SHELL",
    "dropdelst": "WY",
    "dropdelzpp": 824419901,
    "dropphyadd": "114 MAIN ST",
    "dropphycty": "SHELL",
    "dropphyst": "WY",
    "dropphyzpp": 824419901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELL",
    "dropmalst": "WY",
    "dropmalzpp": 824419998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077652719,
    "dropsitcph": 3077652719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B526",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "101 E LOUCKS ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "WY",
    "dropdelzpp": 828019998,
    "dropphyadd": "101 E LOUCKS ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "WY",
    "dropphyzpp": 828019998,
    "dropmaladd": "101 E LOUCKS ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "WY",
    "dropmalzpp": 828019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076723430,
    "dropsitcph": 3076720714,
    "dropfax": 3076723292
  },
  {
    "dcode": "D",
    "dropkey": "PW1B528",
    "droptype": "D",
    "dropname": "SHOSHONI",
    "dropdeladd": "112 WYOMING ST",
    "dropdelcty": "SHOSHONI",
    "dropdelst": "WY",
    "dropdelzpp": 826499990,
    "dropphyadd": "112 WYOMING ST",
    "dropphycty": "SHOSHONI",
    "dropphyst": "WY",
    "dropphyzpp": 826499990,
    "dropmaladd": "112 WYOMING ST",
    "dropmalcty": "SHOSHONI",
    "dropmalst": "WY",
    "dropmalzpp": 826499990,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078762456,
    "dropsitcph": 3078762456,
    "dropfax": 3078762739
  },
  {
    "dcode": "D",
    "dropkey": "PW1B529",
    "droptype": "D",
    "dropname": "SINCLAIR",
    "dropdeladd": "100 N 5TH ST",
    "dropdelcty": "SINCLAIR",
    "dropdelst": "WY",
    "dropdelzpp": 823349900,
    "dropphyadd": "100 N 5TH ST",
    "dropphycty": "SINCLAIR",
    "dropphyst": "WY",
    "dropphyzpp": 823349900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SINCLAIR",
    "dropmalst": "WY",
    "dropmalzpp": 823349998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073246883,
    "dropsitcph": 3073246883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B531",
    "droptype": "D",
    "dropname": "SMOOT",
    "dropdeladd": "77693 US HIGHWAY 89",
    "dropdelcty": "SMOOT",
    "dropdelst": "WY",
    "dropdelzpp": 831269901,
    "dropphyadd": "77693 US HIGHWAY 89",
    "dropphycty": "SMOOT",
    "dropphyst": "WY",
    "dropphyzpp": 831269901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMOOT",
    "dropmalst": "WY",
    "dropmalzpp": 831269998,
    "dropsitphn": 3078860562,
    "dropsitlph": 3078860562,
    "dropsitcph": 3078860562,
    "dropfax": 3078865670
  },
  {
    "dcode": "D",
    "dropkey": "PW1B539",
    "droptype": "D",
    "dropname": "STORY",
    "dropdeladd": "23 N PINEY RD",
    "dropdelcty": "STORY",
    "dropdelst": "WY",
    "dropdelzpp": 828429900,
    "dropphyadd": "23 N PINEY RD",
    "dropphycty": "STORY",
    "dropphyst": "WY",
    "dropphyzpp": 828429900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STORY",
    "dropmalst": "WY",
    "dropmalzpp": 828429998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076832807,
    "dropsitcph": 3076832807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B540",
    "droptype": "D",
    "dropname": "SUNDANCE",
    "dropdeladd": "121 E MAIN ST",
    "dropdelcty": "SUNDANCE",
    "dropdelst": "WY",
    "dropdelzpp": 827299998,
    "dropphyadd": "121 E MAIN ST",
    "dropphycty": "SUNDANCE",
    "dropphyst": "WY",
    "dropphyzpp": 827299998,
    "dropmaladd": "121 E MAIN ST",
    "dropmalcty": "SUNDANCE",
    "dropmalst": "WY",
    "dropmalzpp": 827299998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3076629986,
    "dropsitcph": 3072859145,
    "dropfax": 3072832593
  },
  {
    "dcode": "D",
    "dropkey": "PW1B543",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "81 MAIN ST",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "WY",
    "dropdelzpp": 829459800,
    "dropphyadd": "81 MAIN ST",
    "dropphycty": "SUPERIOR",
    "dropphyst": "WY",
    "dropphyzpp": 829459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "WY",
    "dropmalzpp": 829459998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073627073,
    "dropsitcph": 3073627073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B546",
    "droptype": "D",
    "dropname": "TEN SLEEP",
    "dropdeladd": "115 PINE ST",
    "dropdelcty": "TEN SLEEP",
    "dropdelst": "WY",
    "dropdelzpp": 824429901,
    "dropphyadd": "115 PINE ST",
    "dropphycty": "TEN SLEEP",
    "dropphyst": "WY",
    "dropphyzpp": 824429901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEN SLEEP",
    "dropmalst": "WY",
    "dropmalzpp": 824429998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073662505,
    "dropsitcph": 3073662505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B548",
    "droptype": "D",
    "dropname": "THAYNE",
    "dropdeladd": "390 N MAIN ST",
    "dropdelcty": "THAYNE",
    "dropdelst": "WY",
    "dropdelzpp": 831279902,
    "dropphyadd": "390 N MAIN ST",
    "dropphycty": "THAYNE",
    "dropphyst": "WY",
    "dropphyzpp": 831279902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THAYNE",
    "dropmalst": "WY",
    "dropmalzpp": 831279998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078832477,
    "dropsitcph": 3078832477,
    "dropfax": 3078832478
  },
  {
    "dcode": "D",
    "dropkey": "PW1B549",
    "droptype": "D",
    "dropname": "THERMOPOLIS",
    "dropdeladd": "440 ARAPAHOE ST",
    "dropdelcty": "THERMOPOLIS",
    "dropdelst": "WY",
    "dropdelzpp": 824439998,
    "dropphyadd": "440 ARAPAHOE ST",
    "dropphycty": "THERMOPOLIS",
    "dropphyst": "WY",
    "dropphyzpp": 824439998,
    "dropmaladd": "440 ARAPAHOE ST",
    "dropmalcty": "THERMOPOLIS",
    "dropmalst": "WY",
    "dropmalzpp": 824439998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078642511,
    "dropsitcph": 3078642511,
    "dropfax": 3078645436
  },
  {
    "dcode": "D",
    "dropkey": "PW1B550",
    "droptype": "D",
    "dropname": "TIE SIDING",
    "dropdeladd": "1741 S US HIGHWAY 287",
    "dropdelcty": "TIE SIDING",
    "dropdelst": "WY",
    "dropdelzpp": 820849900,
    "dropphyadd": "1741 S US HIGHWAY 287",
    "dropphycty": "TIE SIDING",
    "dropphyst": "WY",
    "dropphyzpp": 820849900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIE SIDING",
    "dropmalst": "WY",
    "dropmalzpp": 820849998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077555350,
    "dropsitcph": 3077555350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B552",
    "droptype": "D",
    "dropname": "TORRINGTON",
    "dropdeladd": "2145 MAIN ST",
    "dropdelcty": "TORRINGTON",
    "dropdelst": "WY",
    "dropdelzpp": 822409998,
    "dropphyadd": "2145 MAIN ST",
    "dropphycty": "TORRINGTON",
    "dropphyst": "WY",
    "dropphyzpp": 822409998,
    "dropmaladd": "2145 MAIN ST",
    "dropmalcty": "TORRINGTON",
    "dropmalst": "WY",
    "dropmalzpp": 822409998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075322213,
    "dropsitcph": 3075322213,
    "dropfax": 3075327577
  },
  {
    "dcode": "D",
    "dropkey": "PW1B557",
    "droptype": "D",
    "dropname": "UPTON",
    "dropdeladd": "622 PINE ST",
    "dropdelcty": "UPTON",
    "dropdelst": "WY",
    "dropdelzpp": 827309901,
    "dropphyadd": "622 PINE ST",
    "dropphycty": "UPTON",
    "dropphyst": "WY",
    "dropphyzpp": 827309901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UPTON",
    "dropmalst": "WY",
    "dropmalzpp": 827309998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3074682530,
    "dropsitcph": 3074682530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B561",
    "droptype": "D",
    "dropname": "VETERAN",
    "dropdeladd": "111 3RD ST",
    "dropdelcty": "VETERAN",
    "dropdelst": "WY",
    "dropdelzpp": 822439990,
    "dropphyadd": "111 3RD ST",
    "dropphycty": "VETERAN",
    "dropphyst": "WY",
    "dropphyzpp": 822439990,
    "dropmaladd": "111 3RD ST",
    "dropmalcty": "VETERAN",
    "dropmalst": "WY",
    "dropmalzpp": 822439990,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078372633,
    "dropsitcph": 3078372633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B563",
    "droptype": "D",
    "dropname": "WAMSUTTER",
    "dropdeladd": "302 BROADWAY ST",
    "dropdelcty": "WAMSUTTER",
    "dropdelst": "WY",
    "dropdelzpp": 823369902,
    "dropphyadd": "302 BROADWAY ST",
    "dropphycty": "WAMSUTTER",
    "dropphyst": "WY",
    "dropphyzpp": 823369902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAMSUTTER",
    "dropmalst": "WY",
    "dropmalzpp": 823369998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073243674,
    "dropsitcph": 3073243674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B564",
    "droptype": "D",
    "dropname": "WAPITI",
    "dropdeladd": "4 STREAMSIDE DR",
    "dropdelcty": "WAPITI",
    "dropdelst": "WY",
    "dropdelzpp": 824509998,
    "dropphyadd": "4 STREAMSIDE DR",
    "dropphycty": "WAPITI",
    "dropphyst": "WY",
    "dropphyzpp": 824509998,
    "dropmaladd": "4 STREAMSIDE DR",
    "dropmalcty": "WAPITI",
    "dropmalst": "WY",
    "dropmalzpp": 824509998,
    "dropsitphn": 3075874503,
    "dropsitlph": 3075874503,
    "dropsitcph": 3075874503,
    "dropfax": 3075874778
  },
  {
    "dcode": "D",
    "dropkey": "PW1B570",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "852 WALNUT ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "WY",
    "dropdelzpp": 822019998,
    "dropphyadd": "852 WALNUT ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "WY",
    "dropphyzpp": 822019998,
    "dropmaladd": "852 WALNUT ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "WY",
    "dropmalzpp": 822019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073223287,
    "dropsitcph": 3073223287,
    "dropfax": 3073225930
  },
  {
    "dcode": "D",
    "dropkey": "PW1B572",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "5605 W HIGHWAY 22",
    "dropdelcty": "WILSON",
    "dropdelst": "WY",
    "dropdelzpp": 830149998,
    "dropphyadd": "5605 W HIGHWAY 22",
    "dropphycty": "WILSON",
    "dropphyst": "WY",
    "dropphyzpp": 830149998,
    "dropmaladd": "5605 W HIGHWAY 22",
    "dropmalcty": "WILSON",
    "dropmalst": "WY",
    "dropmalzpp": 830149998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077333335,
    "dropsitcph": 3077333335,
    "dropfax": 3077341534
  },
  {
    "dcode": "D",
    "dropkey": "PW1B577",
    "droptype": "D",
    "dropname": "WORLAND",
    "dropdeladd": "119 N 7TH ST",
    "dropdelcty": "WORLAND",
    "dropdelst": "WY",
    "dropdelzpp": 824019998,
    "dropphyadd": "119 N 7TH ST",
    "dropphycty": "WORLAND",
    "dropphyst": "WY",
    "dropphyzpp": 824019998,
    "dropmaladd": "119 N 7TH ST",
    "dropmalcty": "WORLAND",
    "dropmalst": "WY",
    "dropmalzpp": 824019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073473321,
    "dropsitcph": 3073473321,
    "dropfax": 3073472142
  },
  {
    "dcode": "D",
    "dropkey": "PW1B581",
    "droptype": "D",
    "dropname": "YELLOWSTONE NATIONAL PARK",
    "dropdeladd": "114 ALBRIGHT AVE",
    "dropdelcty": "YELLOWSTONE NATIONAL PARK",
    "dropdelst": "WY",
    "dropdelzpp": 821909998,
    "dropphyadd": "114 ALBRIGHT AVE",
    "dropphycty": "YELLOWSTONE NATIONAL PARK",
    "dropphyst": "WY",
    "dropphyzpp": 821909998,
    "dropmaladd": "114 ALBRIGHT AVE",
    "dropmalcty": "YELLOWSTONE NATIONAL PARK",
    "dropmalst": "WY",
    "dropmalzpp": 821909998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3073447764,
    "dropsitcph": 3073447764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B582",
    "droptype": "D",
    "dropname": "YODER",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "YODER",
    "dropdelst": "WY",
    "dropdelzpp": 822448800,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "YODER",
    "dropphyst": "WY",
    "dropphyzpp": 822448800,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "YODER",
    "dropmalst": "WY",
    "dropmalzpp": 822448800,
    "dropsitphn": 3077726524,
    "dropsitlph": 3075324503,
    "dropsitcph": 3075324503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW1B782",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "8 S 6TH ST STE 122",
    "dropdelcty": "COUNCIL BLUFFS",
    "dropdelst": "IA",
    "dropdelzpp": 515019916,
    "dropphyadd": "8 S 6TH ST STE 122",
    "dropphycty": "COUNCIL BLUFFS",
    "dropphyst": "IA",
    "dropphyzpp": 515019916,
    "dropmaladd": "8 S 6TH ST STE 122",
    "dropmalcty": "COUNCIL BLUFFS",
    "dropmalst": "IA",
    "dropmalzpp": 515019916,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123250630,
    "dropsitcph": 7123250630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10002",
    "droptype": "D",
    "dropname": "ACKLEY",
    "dropdeladd": "706 1ST AVE",
    "dropdelcty": "ACKLEY",
    "dropdelst": "IA",
    "dropdelzpp": 506011555,
    "dropphyadd": "706 1ST AVE",
    "dropphycty": "ACKLEY",
    "dropphyst": "IA",
    "dropphyzpp": 506011555,
    "dropmaladd": "706 1ST AVE",
    "dropmalcty": "ACKLEY",
    "dropmalst": "IA",
    "dropmalzpp": 506011555,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418472347,
    "dropsitcph": 6418472347,
    "dropfax": 6418473919
  },
  {
    "dcode": "D",
    "dropkey": "PW10004",
    "droptype": "D",
    "dropname": "ADAIR",
    "dropdeladd": "317 AUDUBON ST",
    "dropdelcty": "ADAIR",
    "dropdelst": "IA",
    "dropdelzpp": 500027711,
    "dropphyadd": "317 AUDUBON ST",
    "dropphycty": "ADAIR",
    "dropphyst": "IA",
    "dropphyzpp": 500027711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAIR",
    "dropmalst": "IA",
    "dropmalzpp": 500029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417425511,
    "dropsitcph": 6417425511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10007",
    "droptype": "D",
    "dropname": "ADEL",
    "dropdeladd": "904 NILE KINNICK DR S",
    "dropdelcty": "ADEL",
    "dropdelst": "IA",
    "dropdelzpp": 500039998,
    "dropphyadd": "904 NILE KINNICK DR S",
    "dropphycty": "ADEL",
    "dropphyst": "IA",
    "dropphyzpp": 500039998,
    "dropmaladd": "904 NILE KINNICK DR S",
    "dropmalcty": "ADEL",
    "dropmalst": "IA",
    "dropmalzpp": 500039998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159932258,
    "dropsitcph": 5159933003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10010",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "208 W KANSAS ST",
    "dropdelcty": "AFTON",
    "dropdelst": "IA",
    "dropdelzpp": 508301091,
    "dropphyadd": "208 W KANSAS ST",
    "dropphycty": "AFTON",
    "dropphyst": "IA",
    "dropphyzpp": 508301091,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AFTON",
    "dropmalst": "IA",
    "dropmalzpp": 508309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413478727,
    "dropsitcph": 6413478727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10011",
    "droptype": "D",
    "dropname": "AGENCY",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "AGENCY",
    "dropdelst": "IA",
    "dropdelzpp": 525309712,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "AGENCY",
    "dropphyst": "IA",
    "dropphyzpp": 525309712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AGENCY",
    "dropmalst": "IA",
    "dropmalzpp": 525309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419376623,
    "dropsitcph": 6419376623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10012",
    "droptype": "D",
    "dropname": "AINSWORTH",
    "dropdeladd": "150 N RAILROAD ST",
    "dropdelcty": "AINSWORTH",
    "dropdelst": "IA",
    "dropdelzpp": 522019308,
    "dropphyadd": "150 N RAILROAD ST",
    "dropphycty": "AINSWORTH",
    "dropphyst": "IA",
    "dropphyzpp": 522019308,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AINSWORTH",
    "dropmalst": "IA",
    "dropmalzpp": 522019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196573191,
    "dropsitcph": 3196573191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10013",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "351 REED ST",
    "dropdelcty": "AKRON",
    "dropdelst": "IA",
    "dropdelzpp": 510017741,
    "dropphyadd": "351 REED ST",
    "dropphycty": "AKRON",
    "dropphyst": "IA",
    "dropphyzpp": 510017741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKRON",
    "dropmalst": "IA",
    "dropmalzpp": 510019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125683145,
    "dropsitcph": 7125683145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10015",
    "droptype": "D",
    "dropname": "ALBERT CITY",
    "dropdeladd": "114 MAIN ST",
    "dropdelcty": "ALBERT CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505101217,
    "dropphyadd": "114 MAIN ST",
    "dropphycty": "ALBERT CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505101217,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBERT CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128432234,
    "dropsitcph": 7128432234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10016",
    "droptype": "D",
    "dropname": "ALBIA",
    "dropdeladd": "104 BENTON AVE W",
    "dropdelcty": "ALBIA",
    "dropdelst": "IA",
    "dropdelzpp": 525311963,
    "dropphyadd": "104 BENTON AVE W",
    "dropphycty": "ALBIA",
    "dropphyst": "IA",
    "dropphyzpp": 525311963,
    "dropmaladd": "104 BENTON AVE W",
    "dropmalcty": "ALBIA",
    "dropmalst": "IA",
    "dropmalzpp": 525311963,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419325430,
    "dropsitcph": 6419325430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10017",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "103 W BROWN ST",
    "dropdelcty": "ALBION",
    "dropdelst": "IA",
    "dropdelzpp": 500057781,
    "dropphyadd": "103 W BROWN ST",
    "dropphycty": "ALBION",
    "dropphyst": "IA",
    "dropphyzpp": 500057781,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBION",
    "dropmalst": "IA",
    "dropmalzpp": 500059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414882470,
    "dropsitcph": 6414882470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10018",
    "droptype": "D",
    "dropname": "ALBURNETT",
    "dropdeladd": "101 N MAIN AVE",
    "dropdelcty": "ALBURNETT",
    "dropdelst": "IA",
    "dropdelzpp": 522024400,
    "dropphyadd": "101 N MAIN AVE",
    "dropphycty": "ALBURNETT",
    "dropphyst": "IA",
    "dropphyzpp": 522024400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBURNETT",
    "dropmalst": "IA",
    "dropmalzpp": 522029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198422229,
    "dropsitcph": 3198422229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10019",
    "droptype": "D",
    "dropname": "ALDEN",
    "dropdeladd": "1223 WATER ST",
    "dropdelcty": "ALDEN",
    "dropdelst": "IA",
    "dropdelzpp": 500069997,
    "dropphyadd": "1223 WATER ST",
    "dropphycty": "ALDEN",
    "dropphyst": "IA",
    "dropphyzpp": 500069997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALDEN",
    "dropmalst": "IA",
    "dropmalzpp": 500069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158592018,
    "dropsitcph": 5158592018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10020",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "407 HARRIMAN ST",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "IA",
    "dropdelzpp": 504208066,
    "dropphyadd": "407 HARRIMAN ST",
    "dropphycty": "ALEXANDER",
    "dropphyst": "IA",
    "dropphyzpp": 504208066,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "IA",
    "dropmalzpp": 504209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416923539,
    "dropsitcph": 6416923539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10021",
    "droptype": "D",
    "dropname": "ALGONA",
    "dropdeladd": "112 N MINNESOTA ST",
    "dropdelcty": "ALGONA",
    "dropdelst": "IA",
    "dropdelzpp": 505112806,
    "dropphyadd": "112 N MINNESOTA ST",
    "dropphycty": "ALGONA",
    "dropphyst": "IA",
    "dropphyzpp": 505112806,
    "dropmaladd": "112 N MINNESOTA ST",
    "dropmalcty": "ALGONA",
    "dropmalst": "IA",
    "dropmalzpp": 505112806,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152952203,
    "dropsitcph": 5152952203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10022",
    "droptype": "D",
    "dropname": "ALLEMAN",
    "dropdeladd": "14172 NE 6TH ST",
    "dropdelcty": "ALLEMAN",
    "dropdelst": "IA",
    "dropdelzpp": 500077702,
    "dropphyadd": "14172 NE 6TH ST",
    "dropphycty": "ALLEMAN",
    "dropphyst": "IA",
    "dropphyzpp": 500077702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLEMAN",
    "dropmalst": "IA",
    "dropmalzpp": 500079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156853611,
    "dropsitcph": 5156853611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10024",
    "droptype": "D",
    "dropname": "ALLERTON",
    "dropdeladd": "108 N CENTRAL AVE",
    "dropdelcty": "ALLERTON",
    "dropdelst": "IA",
    "dropdelzpp": 500087726,
    "dropphyadd": "108 N CENTRAL AVE",
    "dropphycty": "ALLERTON",
    "dropphyst": "IA",
    "dropphyzpp": 500087726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLERTON",
    "dropmalst": "IA",
    "dropmalzpp": 500089998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418734642,
    "dropsitcph": 6418734642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10026",
    "droptype": "D",
    "dropname": "ALLISON",
    "dropdeladd": "307 N MAIN ST",
    "dropdelcty": "ALLISON",
    "dropdelst": "IA",
    "dropdelzpp": 506027708,
    "dropphyadd": "307 N MAIN ST",
    "dropphycty": "ALLISON",
    "dropphyst": "IA",
    "dropphyzpp": 506027708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLISON",
    "dropmalst": "IA",
    "dropmalzpp": 506029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192672744,
    "dropsitcph": 3192672744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10029",
    "droptype": "D",
    "dropname": "ALTA",
    "dropdeladd": "106 S CHEROKEE ST",
    "dropdelcty": "ALTA",
    "dropdelst": "IA",
    "dropdelzpp": 510029901,
    "dropphyadd": "106 S CHEROKEE ST",
    "dropphycty": "ALTA",
    "dropphyst": "IA",
    "dropphyzpp": 510029901,
    "dropmaladd": "106 S CHEROKEE ST",
    "dropmalcty": "ALTA",
    "dropmalst": "IA",
    "dropmalzpp": 510029901,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122842000,
    "dropsitcph": 7122842000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10030",
    "droptype": "D",
    "dropname": "ALTA VISTA",
    "dropdeladd": "108 N WHITE AVE",
    "dropdelcty": "ALTA VISTA",
    "dropdelst": "IA",
    "dropdelzpp": 506037708,
    "dropphyadd": "108 N WHITE AVE",
    "dropphycty": "ALTA VISTA",
    "dropphyst": "IA",
    "dropphyzpp": 506037708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTA VISTA",
    "dropmalst": "IA",
    "dropmalzpp": 506039998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413644600,
    "dropsitcph": 6413644600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10031",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "1022 3RD AVE",
    "dropdelcty": "ALTON",
    "dropdelst": "IA",
    "dropdelzpp": 510038680,
    "dropphyadd": "1022 3RD AVE",
    "dropphycty": "ALTON",
    "dropphyst": "IA",
    "dropphyzpp": 510038680,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTON",
    "dropmalst": "IA",
    "dropmalzpp": 510039998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127568815,
    "dropsitcph": 7127568815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10032",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "300 8TH ST SE",
    "dropdelcty": "ALTOONA",
    "dropdelst": "IA",
    "dropdelzpp": 500099998,
    "dropphyadd": "300 8TH ST SE",
    "dropphycty": "ALTOONA",
    "dropphyst": "IA",
    "dropphyzpp": 500099998,
    "dropmaladd": "300 8TH ST SE",
    "dropmalcty": "ALTOONA",
    "dropmalst": "IA",
    "dropmalzpp": 500099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159672262,
    "dropsitcph": 5159675374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10033",
    "droptype": "D",
    "dropname": "ALVORD",
    "dropdeladd": "217 N MAIN ST",
    "dropdelcty": "ALVORD",
    "dropdelst": "IA",
    "dropdelzpp": 512307707,
    "dropphyadd": "217 N MAIN ST",
    "dropphycty": "ALVORD",
    "dropphyst": "IA",
    "dropphyzpp": 512307707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALVORD",
    "dropmalst": "IA",
    "dropmalzpp": 512309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124732260,
    "dropsitcph": 7124732260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10034",
    "droptype": "D",
    "dropname": "AMANA",
    "dropdeladd": "4015 G ST",
    "dropdelcty": "AMANA",
    "dropdelst": "IA",
    "dropdelzpp": 522038014,
    "dropphyadd": "4015 G ST",
    "dropphycty": "AMANA",
    "dropphyst": "IA",
    "dropphyzpp": 522038014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMANA",
    "dropmalst": "IA",
    "dropmalzpp": 522039998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196223019,
    "dropsitcph": 3196223019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10040",
    "droptype": "D",
    "dropname": "AMES",
    "dropdeladd": "525 KELLOGG AVE",
    "dropdelcty": "AMES",
    "dropdelst": "IA",
    "dropdelzpp": 500109998,
    "dropphyadd": "525 KELLOGG AVE",
    "dropphycty": "AMES",
    "dropphyst": "IA",
    "dropphyzpp": 500109998,
    "dropmaladd": "525 KELLOGG AVE",
    "dropmalcty": "AMES",
    "dropmalst": "IA",
    "dropmalzpp": 500109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152321113,
    "dropsitcph": 5152321113,
    "dropfax": 5152324723
  },
  {
    "dcode": "D",
    "dropkey": "PW10042",
    "droptype": "D",
    "dropname": "ANAMOSA",
    "dropdeladd": "116 S FORD ST",
    "dropdelcty": "ANAMOSA",
    "dropdelst": "IA",
    "dropdelzpp": 522059998,
    "dropphyadd": "116 S FORD ST",
    "dropphycty": "ANAMOSA",
    "dropphyst": "IA",
    "dropphyzpp": 522059998,
    "dropmaladd": "116 S FORD ST",
    "dropmalcty": "ANAMOSA",
    "dropmalst": "IA",
    "dropmalzpp": 522059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194622684,
    "dropsitcph": 3194622684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10043",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "4326 MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "IA",
    "dropdelzpp": 527019000,
    "dropphyadd": "4326 MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "IA",
    "dropphyzpp": 527019000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDOVER",
    "dropmalst": "IA",
    "dropmalzpp": 527019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636827304,
    "dropsitcph": 5636827304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10044",
    "droptype": "D",
    "dropname": "ANDREW",
    "dropdeladd": "13 W BENTON ST",
    "dropdelcty": "ANDREW",
    "dropdelst": "IA",
    "dropdelzpp": 520304400,
    "dropphyadd": "13 W BENTON ST",
    "dropphycty": "ANDREW",
    "dropphyst": "IA",
    "dropphyzpp": 520304400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDREW",
    "dropmalst": "IA",
    "dropmalzpp": 520309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636723412,
    "dropsitcph": 5636723412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10045",
    "droptype": "D",
    "dropname": "ANITA",
    "dropdeladd": "906 MAIN ST",
    "dropdelcty": "ANITA",
    "dropdelst": "IA",
    "dropdelzpp": 500201056,
    "dropphyadd": "906 MAIN ST",
    "dropphycty": "ANITA",
    "dropphyst": "IA",
    "dropphyzpp": 500201056,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANITA",
    "dropmalst": "IA",
    "dropmalzpp": 500209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127624445,
    "dropsitcph": 7127624445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10046",
    "droptype": "D",
    "dropname": "ANKENY",
    "dropdeladd": "1011 N ANKENY BLVD",
    "dropdelcty": "ANKENY",
    "dropdelst": "IA",
    "dropdelzpp": 500239998,
    "dropphyadd": "1011 N ANKENY BLVD",
    "dropphycty": "ANKENY",
    "dropphyst": "IA",
    "dropphyzpp": 500239998,
    "dropmaladd": "1011 N ANKENY BLVD",
    "dropmalcty": "ANKENY",
    "dropmalst": "IA",
    "dropmalzpp": 500239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159640464,
    "dropsitcph": 5159638387,
    "dropfax": 5159645720
  },
  {
    "dcode": "D",
    "dropkey": "PW10047",
    "droptype": "D",
    "dropname": "ANTHON",
    "dropdeladd": "109 N 2ND AVE",
    "dropdelcty": "ANTHON",
    "dropdelst": "IA",
    "dropdelzpp": 510047700,
    "dropphyadd": "109 N 2ND AVE",
    "dropphycty": "ANTHON",
    "dropphyst": "IA",
    "dropphyzpp": 510047700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANTHON",
    "dropmalst": "IA",
    "dropmalzpp": 510049998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123735301,
    "dropsitcph": 7123735301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10048",
    "droptype": "D",
    "dropname": "APLINGTON",
    "dropdeladd": "925 PARRIOTT ST",
    "dropdelcty": "APLINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 506047705,
    "dropphyadd": "925 PARRIOTT ST",
    "dropphycty": "APLINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 506047705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "APLINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 506049998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193476675,
    "dropsitcph": 3193476675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10050",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "212 S GAULT ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "IA",
    "dropdelzpp": 514301005,
    "dropphyadd": "212 S GAULT ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "IA",
    "dropphyzpp": 514301005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "IA",
    "dropmalzpp": 514309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126892508,
    "dropsitcph": 7126892508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10051",
    "droptype": "D",
    "dropname": "ARCHER",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "ARCHER",
    "dropdelst": "IA",
    "dropdelzpp": 512317708,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "ARCHER",
    "dropphyst": "IA",
    "dropphyzpp": 512317708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCHER",
    "dropmalst": "IA",
    "dropmalzpp": 512319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127235213,
    "dropsitcph": 7127235213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10052",
    "droptype": "D",
    "dropname": "AREDALE",
    "dropdeladd": "117 E MAIN ST",
    "dropdelcty": "AREDALE",
    "dropdelst": "IA",
    "dropdelzpp": 506058402,
    "dropphyadd": "117 E MAIN ST",
    "dropphycty": "AREDALE",
    "dropphyst": "IA",
    "dropphyzpp": 506058402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AREDALE",
    "dropmalst": "IA",
    "dropmalzpp": 506059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418943440,
    "dropsitcph": 6418943440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10054",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "2951 180TH AVE",
    "dropdelcty": "ARGYLE",
    "dropdelst": "IA",
    "dropdelzpp": 526199604,
    "dropphyadd": "2951 180TH AVE",
    "dropphycty": "ARGYLE",
    "dropphyst": "IA",
    "dropphyzpp": 526199604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARGYLE",
    "dropmalst": "IA",
    "dropmalzpp": 526199998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198382821,
    "dropsitcph": 3198382821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10056",
    "droptype": "D",
    "dropname": "ARISPE",
    "dropdeladd": "307 FORBES ST",
    "dropdelcty": "ARISPE",
    "dropdelst": "IA",
    "dropdelzpp": 508319900,
    "dropphyadd": "307 FORBES ST",
    "dropphycty": "ARISPE",
    "dropphyst": "IA",
    "dropphyzpp": 508319900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARISPE",
    "dropmalst": "IA",
    "dropmalzpp": 508319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413462513,
    "dropsitcph": 6413462513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10058",
    "droptype": "D",
    "dropname": "ARMSTRONG",
    "dropdeladd": "608 1ST AVE",
    "dropdelcty": "ARMSTRONG",
    "dropdelst": "IA",
    "dropdelzpp": 505147604,
    "dropphyadd": "608 1ST AVE",
    "dropphycty": "ARMSTRONG",
    "dropphyst": "IA",
    "dropphyzpp": 505147604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARMSTRONG",
    "dropmalst": "IA",
    "dropmalzpp": 505149998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128683677,
    "dropsitcph": 7128683677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10059",
    "droptype": "D",
    "dropname": "ARNOLDS PARK",
    "dropdeladd": "50 N HIGHWAY 71",
    "dropdelcty": "ARNOLDS PARK",
    "dropdelst": "IA",
    "dropdelzpp": 513317710,
    "dropphyadd": "50 N HIGHWAY 71",
    "dropphycty": "ARNOLDS PARK",
    "dropphyst": "IA",
    "dropphyzpp": 513317710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARNOLDS PARK",
    "dropmalst": "IA",
    "dropmalzpp": 513319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123325172,
    "dropsitcph": 7123325172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10061",
    "droptype": "D",
    "dropname": "ARTHUR",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "ARTHUR",
    "dropdelst": "IA",
    "dropdelzpp": 514318053,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "ARTHUR",
    "dropphyst": "IA",
    "dropphyzpp": 514318053,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARTHUR",
    "dropmalst": "IA",
    "dropmalzpp": 514319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123672267,
    "dropsitcph": 7123672267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10063",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "152 1ST AVE",
    "dropdelcty": "ASHTON",
    "dropdelst": "IA",
    "dropdelzpp": 512327098,
    "dropphyadd": "152 1ST AVE",
    "dropphycty": "ASHTON",
    "dropphyst": "IA",
    "dropphyzpp": 512327098,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHTON",
    "dropmalst": "IA",
    "dropmalzpp": 512329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127246241,
    "dropsitcph": 7127246241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10065",
    "droptype": "D",
    "dropname": "ATALISSA",
    "dropdeladd": "212 CHERRY ST",
    "dropdelcty": "ATALISSA",
    "dropdelst": "IA",
    "dropdelzpp": 527207727,
    "dropphyadd": "212 CHERRY ST",
    "dropphycty": "ATALISSA",
    "dropphyst": "IA",
    "dropphyzpp": 527207727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATALISSA",
    "dropmalst": "IA",
    "dropmalzpp": 527209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636492525,
    "dropsitcph": 5636492525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10067",
    "droptype": "D",
    "dropname": "ATKINS",
    "dropdeladd": "87 MAIN AVE",
    "dropdelcty": "ATKINS",
    "dropdelst": "IA",
    "dropdelzpp": 522069750,
    "dropphyadd": "87 MAIN AVE",
    "dropphycty": "ATKINS",
    "dropphyst": "IA",
    "dropphyzpp": 522069750,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATKINS",
    "dropmalst": "IA",
    "dropmalzpp": 522069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194467272,
    "dropsitcph": 3194467272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10068",
    "droptype": "D",
    "dropname": "ATLANTIC",
    "dropdeladd": "20 E 5TH ST",
    "dropdelcty": "ATLANTIC",
    "dropdelst": "IA",
    "dropdelzpp": 500226400,
    "dropphyadd": "20 E 5TH ST",
    "dropphycty": "ATLANTIC",
    "dropphyst": "IA",
    "dropphyzpp": 500226400,
    "dropmaladd": "20 E 5TH ST",
    "dropmalcty": "ATLANTIC",
    "dropmalst": "IA",
    "dropmalzpp": 500226400,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122431208,
    "dropsitcph": 7122431208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10069",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "107 PINE ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "IA",
    "dropdelzpp": 514335022,
    "dropphyadd": "107 PINE ST",
    "dropphycty": "AUBURN",
    "dropphyst": "IA",
    "dropphyzpp": 514335022,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUBURN",
    "dropmalst": "IA",
    "dropmalzpp": 514339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126887715,
    "dropsitcph": 7126887715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10071",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "428 TRACY ST",
    "dropdelcty": "AUDUBON",
    "dropdelst": "IA",
    "dropdelzpp": 500251228,
    "dropphyadd": "428 TRACY ST",
    "dropphycty": "AUDUBON",
    "dropphyst": "IA",
    "dropphyzpp": 500251228,
    "dropmaladd": "428 TRACY ST",
    "dropmalcty": "AUDUBON",
    "dropmalst": "IA",
    "dropmalzpp": 500251228,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125633412,
    "dropsitcph": 7125633412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10073",
    "droptype": "D",
    "dropname": "AURELIA",
    "dropdeladd": "209 MYRTLE ST",
    "dropdelcty": "AURELIA",
    "dropdelst": "IA",
    "dropdelzpp": 510057798,
    "dropphyadd": "209 MYRTLE ST",
    "dropphycty": "AURELIA",
    "dropphyst": "IA",
    "dropphyzpp": 510057798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AURELIA",
    "dropmalst": "IA",
    "dropmalzpp": 510059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124342077,
    "dropsitcph": 7124342077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10075",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "AURORA",
    "dropdelst": "IA",
    "dropdelzpp": 506079756,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "AURORA",
    "dropphyst": "IA",
    "dropphyzpp": 506079756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AURORA",
    "dropmalst": "IA",
    "dropmalzpp": 506079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196343659,
    "dropsitcph": 3196343659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10078",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "202 N ELM ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "IA",
    "dropdelzpp": 515219000,
    "dropphyadd": "202 N ELM ST",
    "dropphycty": "AVOCA",
    "dropphyst": "IA",
    "dropphyzpp": 515219000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVOCA",
    "dropmalst": "IA",
    "dropmalzpp": 515219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123436730,
    "dropsitcph": 7123436730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10081",
    "droptype": "D",
    "dropname": "AYRSHIRE",
    "dropdeladd": "1303 CAMPBELL ST",
    "dropdelcty": "AYRSHIRE",
    "dropdelst": "IA",
    "dropdelzpp": 505158550,
    "dropphyadd": "1303 CAMPBELL ST",
    "dropphycty": "AYRSHIRE",
    "dropphyst": "IA",
    "dropphyzpp": 505158550,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AYRSHIRE",
    "dropmalst": "IA",
    "dropmalzpp": 505159998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124263541,
    "dropsitcph": 7124263541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10082",
    "droptype": "D",
    "dropname": "BADGER",
    "dropdeladd": "130 1ST AVE SE",
    "dropdelcty": "BADGER",
    "dropdelst": "IA",
    "dropdelzpp": 505167735,
    "dropphyadd": "130 1ST AVE SE",
    "dropphycty": "BADGER",
    "dropphyst": "IA",
    "dropphyzpp": 505167735,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BADGER",
    "dropmalst": "IA",
    "dropmalzpp": 505169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155454569,
    "dropsitcph": 5155454569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10083",
    "droptype": "D",
    "dropname": "BAGLEY",
    "dropdeladd": "213 MAIN ST",
    "dropdelcty": "BAGLEY",
    "dropdelst": "IA",
    "dropdelzpp": 500261015,
    "dropphyadd": "213 MAIN ST",
    "dropphycty": "BAGLEY",
    "dropphyst": "IA",
    "dropphyzpp": 500261015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAGLEY",
    "dropmalst": "IA",
    "dropmalzpp": 500269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414275291,
    "dropsitcph": 6414275291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10084",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "4932 HIGHWAY 64",
    "dropdelcty": "BALDWIN",
    "dropdelst": "IA",
    "dropdelzpp": 522074400,
    "dropphyadd": "4932 HIGHWAY 64",
    "dropphycty": "BALDWIN",
    "dropphyst": "IA",
    "dropphyzpp": 522074400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN",
    "dropmalst": "IA",
    "dropmalzpp": 522079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636735271,
    "dropsitcph": 5636735271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10086",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "200 W RAMSEY ST",
    "dropdelcty": "BANCROFT",
    "dropdelst": "IA",
    "dropdelzpp": 505178077,
    "dropphyadd": "200 W RAMSEY ST",
    "dropphycty": "BANCROFT",
    "dropphyst": "IA",
    "dropphyzpp": 505178077,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANCROFT",
    "dropmalst": "IA",
    "dropmalzpp": 505179998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158852585,
    "dropsitcph": 5158852585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10090",
    "droptype": "D",
    "dropname": "BARNES CITY",
    "dropdeladd": "610 SPRUCE ST",
    "dropdelcty": "BARNES CITY",
    "dropdelst": "IA",
    "dropdelzpp": 500279000,
    "dropphyadd": "610 SPRUCE ST",
    "dropphycty": "BARNES CITY",
    "dropphyst": "IA",
    "dropphyzpp": 500279000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNES CITY",
    "dropmalst": "IA",
    "dropmalzpp": 500279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416445212,
    "dropsitcph": 6416445212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10092",
    "droptype": "D",
    "dropname": "BARNUM",
    "dropdeladd": "404 FRONT ST",
    "dropdelcty": "BARNUM",
    "dropdelst": "IA",
    "dropdelzpp": 505187548,
    "dropphyadd": "404 FRONT ST",
    "dropphycty": "BARNUM",
    "dropphyst": "IA",
    "dropphyzpp": 505187548,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNUM",
    "dropmalst": "IA",
    "dropmalzpp": 505189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155423276,
    "dropsitcph": 5155423276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10096",
    "droptype": "D",
    "dropname": "BATAVIA",
    "dropdeladd": "1009 3RD ST",
    "dropdelcty": "BATAVIA",
    "dropdelst": "IA",
    "dropdelzpp": 525339604,
    "dropphyadd": "1009 3RD ST",
    "dropphycty": "BATAVIA",
    "dropphyst": "IA",
    "dropphyzpp": 525339604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATAVIA",
    "dropmalst": "IA",
    "dropmalzpp": 525339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416622377,
    "dropsitcph": 6416622377,
    "dropfax": 6416622378
  },
  {
    "dcode": "D",
    "dropkey": "PW10097",
    "droptype": "D",
    "dropname": "BATTLE CREEK",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "BATTLE CREEK",
    "dropdelst": "IA",
    "dropdelzpp": 510067704,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "BATTLE CREEK",
    "dropphyst": "IA",
    "dropphyzpp": 510067704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATTLE CREEK",
    "dropmalst": "IA",
    "dropmalzpp": 510069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123654450,
    "dropsitcph": 7123654450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10098",
    "droptype": "D",
    "dropname": "BAXTER",
    "dropdeladd": "105 E STATE ST",
    "dropdelcty": "BAXTER",
    "dropdelst": "IA",
    "dropdelzpp": 500287771,
    "dropphyadd": "105 E STATE ST",
    "dropphycty": "BAXTER",
    "dropphyst": "IA",
    "dropphyzpp": 500287771,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAXTER",
    "dropmalst": "IA",
    "dropmalzpp": 500289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412273300,
    "dropsitcph": 6412273300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10099",
    "droptype": "D",
    "dropname": "BAYARD",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "BAYARD",
    "dropdelst": "IA",
    "dropdelzpp": 500291019,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "BAYARD",
    "dropphyst": "IA",
    "dropphyzpp": 500291019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYARD",
    "dropmalst": "IA",
    "dropmalzpp": 500299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126515009,
    "dropsitcph": 7126515009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10100",
    "droptype": "D",
    "dropname": "BEACON",
    "dropdeladd": "320 KILBOURN ST",
    "dropdelcty": "BEACON",
    "dropdelst": "IA",
    "dropdelzpp": 525349715,
    "dropphyadd": "320 KILBOURN ST",
    "dropphycty": "BEACON",
    "dropphyst": "IA",
    "dropphyzpp": 525349715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEACON",
    "dropmalst": "IA",
    "dropmalzpp": 525349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416739254,
    "dropsitcph": 6416739254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10102",
    "droptype": "D",
    "dropname": "BEAMAN",
    "dropdeladd": "208 CENTER ST",
    "dropdelcty": "BEAMAN",
    "dropdelst": "IA",
    "dropdelzpp": 506098562,
    "dropphyadd": "208 CENTER ST",
    "dropphycty": "BEAMAN",
    "dropphyst": "IA",
    "dropphyzpp": 506098562,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAMAN",
    "dropmalst": "IA",
    "dropmalzpp": 506099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412611014,
    "dropsitcph": 6412611014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10103",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "117 3RD ST",
    "dropdelcty": "BEAVER",
    "dropdelst": "IA",
    "dropdelzpp": 500317700,
    "dropphyadd": "117 3RD ST",
    "dropphycty": "BEAVER",
    "dropphyst": "IA",
    "dropphyzpp": 500317700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "IA",
    "dropmalzpp": 500319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152752799,
    "dropsitcph": 5152752799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10108",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "609 CENTRAL AVE",
    "dropdelcty": "BEDFORD",
    "dropdelst": "IA",
    "dropdelzpp": 508339998,
    "dropphyadd": "609 CENTRAL AVE",
    "dropphycty": "BEDFORD",
    "dropphyst": "IA",
    "dropphyzpp": 508339998,
    "dropmaladd": "609 CENTRAL AVE",
    "dropmalcty": "BEDFORD",
    "dropmalst": "IA",
    "dropmalzpp": 508339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125232360,
    "dropsitcph": 7125232360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10112",
    "droptype": "D",
    "dropname": "BELLE PLAINE",
    "dropdeladd": "1008 13TH ST",
    "dropdelcty": "BELLE PLAINE",
    "dropdelst": "IA",
    "dropdelzpp": 522081674,
    "dropphyadd": "1008 13TH ST",
    "dropphycty": "BELLE PLAINE",
    "dropphyst": "IA",
    "dropphyzpp": 522081674,
    "dropmaladd": "1008 13TH ST",
    "dropmalcty": "BELLE PLAINE",
    "dropmalst": "IA",
    "dropmalzpp": 522081674,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194442340,
    "dropsitcph": 3194442340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10113",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "401 N 2ND ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "IA",
    "dropdelzpp": 520319998,
    "dropphyadd": "401 N 2ND ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "IA",
    "dropphyzpp": 520319998,
    "dropmaladd": "401 N 2ND ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "IA",
    "dropmalzpp": 520319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638723657,
    "dropsitcph": 5638723657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10114",
    "droptype": "D",
    "dropname": "BELMOND",
    "dropdeladd": "216 1ST ST NE",
    "dropdelcty": "BELMOND",
    "dropdelst": "IA",
    "dropdelzpp": 504211004,
    "dropphyadd": "216 1ST ST NE",
    "dropphycty": "BELMOND",
    "dropphyst": "IA",
    "dropphyzpp": 504211004,
    "dropmaladd": "216 1ST ST NE",
    "dropmalcty": "BELMOND",
    "dropmalst": "IA",
    "dropmalzpp": 504211004,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414444151,
    "dropsitcph": 6414444151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10115",
    "droptype": "D",
    "dropname": "BENNETT",
    "dropdeladd": "341 MAIN ST",
    "dropdelcty": "BENNETT",
    "dropdelst": "IA",
    "dropdelzpp": 527217713,
    "dropphyadd": "341 MAIN ST",
    "dropphycty": "BENNETT",
    "dropphyst": "IA",
    "dropphyzpp": 527217713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENNETT",
    "dropmalst": "IA",
    "dropmalzpp": 527219998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635933053,
    "dropsitcph": 5638933053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10116",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "200 E MARKET ST",
    "dropdelcty": "BENTON",
    "dropdelst": "IA",
    "dropdelzpp": 508359901,
    "dropphyadd": "200 E MARKET ST",
    "dropphycty": "BENTON",
    "dropphyst": "IA",
    "dropphyzpp": 508359901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENTON",
    "dropmalst": "IA",
    "dropmalzpp": 508359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417852216,
    "dropsitcph": 6417852216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10120",
    "droptype": "D",
    "dropname": "BERNARD",
    "dropdeladd": "157 JESS ST",
    "dropdelcty": "BERNARD",
    "dropdelst": "IA",
    "dropdelzpp": 520324400,
    "dropphyadd": "157 JESS ST",
    "dropphycty": "BERNARD",
    "dropphyst": "IA",
    "dropphyzpp": 520324400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERNARD",
    "dropmalst": "IA",
    "dropmalzpp": 520329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638793591,
    "dropsitcph": 5638793591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10123",
    "droptype": "D",
    "dropname": "BERWICK",
    "dropdeladd": "5760 NE BERWICK DR",
    "dropdelcty": "BERWICK",
    "dropdelst": "IA",
    "dropdelzpp": 500327700,
    "dropphyadd": "5760 NE BERWICK DR",
    "dropphycty": "BERWICK",
    "dropphyst": "IA",
    "dropphyzpp": 500327700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERWICK",
    "dropmalst": "IA",
    "dropmalzpp": 500329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152664258,
    "dropsitcph": 5152664258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10125",
    "droptype": "D",
    "dropname": "BETTENDORF",
    "dropdeladd": "4439 DEVILS GLEN RD",
    "dropdelcty": "BETTENDORF",
    "dropdelst": "IA",
    "dropdelzpp": 527229998,
    "dropphyadd": "4439 DEVILS GLEN RD",
    "dropphycty": "BETTENDORF",
    "dropphyst": "IA",
    "dropphyzpp": 527229998,
    "dropmaladd": "4439 DEVILS GLEN RD",
    "dropmalcty": "BETTENDORF",
    "dropmalst": "IA",
    "dropmalzpp": 527229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633326656,
    "dropsitcph": 5633326164,
    "dropfax": 5633326763
  },
  {
    "dcode": "D",
    "dropkey": "PW10129",
    "droptype": "D",
    "dropname": "BIRMINGHAM",
    "dropdeladd": "221 E CEDAR ST",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "IA",
    "dropdelzpp": 525357706,
    "dropphyadd": "221 E CEDAR ST",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "IA",
    "dropphyzpp": 525357706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "IA",
    "dropmalzpp": 525359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194984676,
    "dropsitcph": 3194984676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10132",
    "droptype": "D",
    "dropname": "BLAIRSBURG",
    "dropdeladd": "512 LAKE ST",
    "dropdelcty": "BLAIRSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 500347717,
    "dropphyadd": "512 LAKE ST",
    "dropphycty": "BLAIRSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 500347717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAIRSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 500349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153256263,
    "dropsitcph": 5153256263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10133",
    "droptype": "D",
    "dropname": "BLAIRSTOWN",
    "dropdeladd": "311 LOCUST ST NW",
    "dropdelcty": "BLAIRSTOWN",
    "dropdelst": "IA",
    "dropdelzpp": 522094400,
    "dropphyadd": "311 LOCUST ST NW",
    "dropphycty": "BLAIRSTOWN",
    "dropphyst": "IA",
    "dropphyzpp": 522094400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAIRSTOWN",
    "dropmalst": "IA",
    "dropmalzpp": 522099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194546543,
    "dropsitcph": 3194546543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10134",
    "droptype": "D",
    "dropname": "BLAKESBURG",
    "dropdeladd": "104 W STATE ST",
    "dropdelcty": "BLAKESBURG",
    "dropdelst": "IA",
    "dropdelzpp": 525368212,
    "dropphyadd": "104 W STATE ST",
    "dropphycty": "BLAKESBURG",
    "dropphyst": "IA",
    "dropphyzpp": 525368212,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAKESBURG",
    "dropmalst": "IA",
    "dropmalzpp": 525369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419382234,
    "dropsitcph": 6419382234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10135",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "IA",
    "dropdelzpp": 516309000,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "BLANCHARD",
    "dropphyst": "IA",
    "dropphyzpp": 516309000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "IA",
    "dropmalzpp": 516309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125833617,
    "dropsitcph": 7125833617,
    "dropfax": 7125833617
  },
  {
    "dcode": "D",
    "dropkey": "PW10136",
    "droptype": "D",
    "dropname": "BLENCOE",
    "dropdeladd": "412 MAIN ST",
    "dropdelcty": "BLENCOE",
    "dropdelst": "IA",
    "dropdelzpp": 515232029,
    "dropphyadd": "412 MAIN ST",
    "dropphycty": "BLENCOE",
    "dropphyst": "IA",
    "dropphyzpp": 515232029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLENCOE",
    "dropmalst": "IA",
    "dropmalzpp": 515239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124522797,
    "dropsitcph": 7124522797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10137",
    "droptype": "D",
    "dropname": "BLOCKTON",
    "dropdeladd": "609 KING ST",
    "dropdelcty": "BLOCKTON",
    "dropdelst": "IA",
    "dropdelzpp": 508362042,
    "dropphyadd": "609 KING ST",
    "dropphycty": "BLOCKTON",
    "dropphyst": "IA",
    "dropphyzpp": 508362042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOCKTON",
    "dropmalst": "IA",
    "dropmalzpp": 508369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417882415,
    "dropsitcph": 6417882415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10138",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "202 W JEFFERSON ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 525372068,
    "dropphyadd": "202 W JEFFERSON ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 525372068,
    "dropmaladd": "202 W JEFFERSON ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 525372068,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416642042,
    "dropsitcph": 6416642042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10139",
    "droptype": "D",
    "dropname": "BLUE GRASS",
    "dropdeladd": "102 TERRACE DR",
    "dropdelcty": "BLUE GRASS",
    "dropdelst": "IA",
    "dropdelzpp": 527267700,
    "dropphyadd": "102 TERRACE DR",
    "dropphycty": "BLUE GRASS",
    "dropphyst": "IA",
    "dropphyzpp": 527267700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE GRASS",
    "dropmalst": "IA",
    "dropmalzpp": 527269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633811321,
    "dropsitcph": 5633811321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10143",
    "droptype": "D",
    "dropname": "BODE",
    "dropdeladd": "113 HUMBOLDT AVE",
    "dropdelcty": "BODE",
    "dropdelst": "IA",
    "dropdelzpp": 505195034,
    "dropphyadd": "113 HUMBOLDT AVE",
    "dropphycty": "BODE",
    "dropphyst": "IA",
    "dropphyzpp": 505195034,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BODE",
    "dropmalst": "IA",
    "dropmalzpp": 505199998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153791793,
    "dropsitcph": 5153791793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10146",
    "droptype": "D",
    "dropname": "BONAPARTE",
    "dropdeladd": "626 1ST ST",
    "dropdelcty": "BONAPARTE",
    "dropdelst": "IA",
    "dropdelzpp": 526201012,
    "dropphyadd": "626 1ST ST",
    "dropphycty": "BONAPARTE",
    "dropphyst": "IA",
    "dropphyzpp": 526201012,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BONAPARTE",
    "dropmalst": "IA",
    "dropmalzpp": 526209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3195923580,
    "dropsitcph": 3195923580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10147",
    "droptype": "D",
    "dropname": "BONDURANT",
    "dropdeladd": "89 PAINE ST SE",
    "dropdelcty": "BONDURANT",
    "dropdelst": "IA",
    "dropdelzpp": 500351052,
    "dropphyadd": "89 PAINE ST SE",
    "dropphycty": "BONDURANT",
    "dropphyst": "IA",
    "dropphyzpp": 500351052,
    "dropmaladd": "89 PAINE ST SE",
    "dropmalcty": "BONDURANT",
    "dropmalst": "IA",
    "dropmalzpp": 500351052,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159672266,
    "dropsitcph": 5159672266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10148",
    "droptype": "D",
    "dropname": "BOONE",
    "dropdeladd": "815 ARDEN ST",
    "dropdelcty": "BOONE",
    "dropdelst": "IA",
    "dropdelzpp": 500362923,
    "dropphyadd": "815 ARDEN ST",
    "dropphycty": "BOONE",
    "dropphyst": "IA",
    "dropphyzpp": 500362923,
    "dropmaladd": "815 ARDEN ST",
    "dropmalcty": "BOONE",
    "dropmalst": "IA",
    "dropmalzpp": 500362923,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154323203,
    "dropsitcph": 5154323203,
    "dropfax": 5154325726
  },
  {
    "dcode": "D",
    "dropkey": "PW10149",
    "droptype": "D",
    "dropname": "BOONEVILLE",
    "dropdeladd": "31080 MAIN ST",
    "dropdelcty": "BOONEVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 500387707,
    "dropphyadd": "31080 MAIN ST",
    "dropphycty": "BOONEVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 500387707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOONEVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 500389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159871437,
    "dropsitcph": 5159871437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10151",
    "droptype": "D",
    "dropname": "BOUTON",
    "dropdeladd": "108 E 1ST ST",
    "dropdelcty": "BOUTON",
    "dropdelst": "IA",
    "dropdelzpp": 500397704,
    "dropphyadd": "108 E 1ST ST",
    "dropphycty": "BOUTON",
    "dropphyst": "IA",
    "dropphyzpp": 500397704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOUTON",
    "dropmalst": "IA",
    "dropmalzpp": 500399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156762841,
    "dropsitcph": 5156762841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10152",
    "droptype": "D",
    "dropname": "BOXHOLM",
    "dropdeladd": "402 2ND ST",
    "dropdelcty": "BOXHOLM",
    "dropdelst": "IA",
    "dropdelzpp": 500407700,
    "dropphyadd": "402 2ND ST",
    "dropphycty": "BOXHOLM",
    "dropphyst": "IA",
    "dropphyzpp": 500407700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOXHOLM",
    "dropmalst": "IA",
    "dropmalzpp": 500409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158466211,
    "dropsitcph": 5158466211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10154",
    "droptype": "D",
    "dropname": "BOYDEN",
    "dropdeladd": "911 MAIN ST",
    "dropdelcty": "BOYDEN",
    "dropdelst": "IA",
    "dropdelzpp": 512347727,
    "dropphyadd": "911 MAIN ST",
    "dropphycty": "BOYDEN",
    "dropphyst": "IA",
    "dropphyzpp": 512347727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYDEN",
    "dropmalst": "IA",
    "dropmalzpp": 512349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127252131,
    "dropsitcph": 7127252131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10160",
    "droptype": "D",
    "dropname": "BRADDYVILLE",
    "dropdeladd": "700 MULBERRY ST",
    "dropdelcty": "BRADDYVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 516319000,
    "dropphyadd": "700 MULBERRY ST",
    "dropphycty": "BRADDYVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 516319000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADDYVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 516319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125893321,
    "dropsitcph": 7125893321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10161",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "IA",
    "dropdelzpp": 500417713,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "IA",
    "dropphyzpp": 500417713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADFORD",
    "dropmalst": "IA",
    "dropmalzpp": 500419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416485513,
    "dropsitcph": 6416485513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10162",
    "droptype": "D",
    "dropname": "BRADGATE",
    "dropdeladd": "200 S GARFIELD ST",
    "dropdelcty": "BRADGATE",
    "dropdelst": "IA",
    "dropdelzpp": 505208740,
    "dropphyadd": "200 S GARFIELD ST",
    "dropphycty": "BRADGATE",
    "dropphyst": "IA",
    "dropphyzpp": 505208740,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADGATE",
    "dropmalst": "IA",
    "dropmalzpp": 505209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153756563,
    "dropsitcph": 5153756563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10165",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "704 MAIN ST",
    "dropdelcty": "BRANDON",
    "dropdelst": "IA",
    "dropdelzpp": 522109760,
    "dropphyadd": "704 MAIN ST",
    "dropphycty": "BRANDON",
    "dropphyst": "IA",
    "dropphyzpp": 522109760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANDON",
    "dropmalst": "IA",
    "dropmalzpp": 522109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194742192,
    "dropsitcph": 3194742192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10166",
    "droptype": "D",
    "dropname": "BRAYTON",
    "dropdeladd": "200 COUNTY TRUNK RD",
    "dropdelcty": "BRAYTON",
    "dropdelst": "IA",
    "dropdelzpp": 500427706,
    "dropphyadd": "200 COUNTY TRUNK RD",
    "dropphycty": "BRAYTON",
    "dropphyst": "IA",
    "dropphyzpp": 500427706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRAYTON",
    "dropmalst": "IA",
    "dropmalzpp": 500429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125492279,
    "dropsitcph": 7125492279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10168",
    "droptype": "D",
    "dropname": "BREDA",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "BREDA",
    "dropdelst": "IA",
    "dropdelzpp": 514368702,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "BREDA",
    "dropphyst": "IA",
    "dropphyzpp": 514368702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BREDA",
    "dropmalst": "IA",
    "dropmalzpp": 514369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122205450,
    "dropsitcph": 7122205450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10171",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "IA",
    "dropdelzpp": 508371001,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "IA",
    "dropphyzpp": 508371001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "IA",
    "dropmalzpp": 508379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413694161,
    "dropsitcph": 6413694161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10172",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "102 N VAN BUREN ST",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "IA",
    "dropdelzpp": 525408646,
    "dropphyadd": "102 N VAN BUREN ST",
    "dropphycty": "BRIGHTON",
    "dropphyst": "IA",
    "dropphyzpp": 525408646,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "IA",
    "dropmalzpp": 525409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196946003,
    "dropsitcph": 3196946003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10174",
    "droptype": "D",
    "dropname": "BRITT",
    "dropdeladd": "52 1ST ST SW",
    "dropdelcty": "BRITT",
    "dropdelst": "IA",
    "dropdelzpp": 504231512,
    "dropphyadd": "52 1ST ST SW",
    "dropphycty": "BRITT",
    "dropphyst": "IA",
    "dropphyzpp": 504231512,
    "dropmaladd": "52 1ST ST SW",
    "dropmalcty": "BRITT",
    "dropmalst": "IA",
    "dropmalzpp": 504231512,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418433500,
    "dropsitcph": 6418433500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10175",
    "droptype": "D",
    "dropname": "BRONSON",
    "dropdeladd": "110 E 1ST ST",
    "dropdelcty": "BRONSON",
    "dropdelst": "IA",
    "dropdelzpp": 510077724,
    "dropphyadd": "110 E 1ST ST",
    "dropphycty": "BRONSON",
    "dropphyst": "IA",
    "dropphyzpp": 510077724,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRONSON",
    "dropmalst": "IA",
    "dropmalzpp": 510079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129483220,
    "dropsitcph": 7129483220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10176",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "127 W FRONT ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "IA",
    "dropdelzpp": 522119496,
    "dropphyadd": "127 W FRONT ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "IA",
    "dropphyzpp": 522119496,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "IA",
    "dropmalzpp": 522119998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415229277,
    "dropsitcph": 6415229277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10179",
    "droptype": "D",
    "dropname": "BRUNSVILLE",
    "dropdeladd": "230 OAK ST",
    "dropdelcty": "BRUNSVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 510087700,
    "dropphyadd": "230 OAK ST",
    "dropphycty": "BRUNSVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 510087700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUNSVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 510089998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125336030,
    "dropsitcph": 7125336030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10186",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "329 DODGE ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "IA",
    "dropdelzpp": 527287735,
    "dropphyadd": "329 DODGE ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "IA",
    "dropphyzpp": 527287735,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUFFALO",
    "dropmalst": "IA",
    "dropmalzpp": 527289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633811345,
    "dropsitcph": 5633811345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10187",
    "droptype": "D",
    "dropname": "BUFFALO CENTER",
    "dropdeladd": "15 2ND AVE NE",
    "dropdelcty": "BUFFALO CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 504241003,
    "dropphyadd": "15 2ND AVE NE",
    "dropphycty": "BUFFALO CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 504241003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUFFALO CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 504249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8778546566,
    "dropsitcph": 8778546566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10193",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "300 N MAIN ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 526015215,
    "dropphyadd": "300 N MAIN ST STE 100",
    "dropphycty": "BURLINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 526019998,
    "dropmaladd": "300 N MAIN ST STE 100",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 526019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197547581,
    "dropsitcph": 3197547581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10194",
    "droptype": "D",
    "dropname": "BURNSIDE",
    "dropdeladd": "30594 249TH AVE",
    "dropdelcty": "BURNSIDE",
    "dropdelst": "IA",
    "dropdelzpp": 505215000,
    "dropphyadd": "30594 249TH AVE",
    "dropphycty": "BURNSIDE",
    "dropphyst": "IA",
    "dropphyzpp": 505215000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNSIDE",
    "dropmalst": "IA",
    "dropmalzpp": 505219998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153592258,
    "dropsitcph": 5153592258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10197",
    "droptype": "D",
    "dropname": "BURT",
    "dropdeladd": "117 WALNUT ST",
    "dropdelcty": "BURT",
    "dropdelst": "IA",
    "dropdelzpp": 505227738,
    "dropphyadd": "117 WALNUT ST",
    "dropphycty": "BURT",
    "dropphyst": "IA",
    "dropphyzpp": 505227738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURT",
    "dropmalst": "IA",
    "dropmalzpp": 505229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159243491,
    "dropsitcph": 5159243491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10198",
    "droptype": "D",
    "dropname": "BUSSEY",
    "dropdeladd": "408 MERRILL ST",
    "dropdelcty": "BUSSEY",
    "dropdelst": "IA",
    "dropdelzpp": 500448150,
    "dropphyadd": "408 MERRILL ST",
    "dropphycty": "BUSSEY",
    "dropphyst": "IA",
    "dropphyzpp": 500448150,
    "dropmaladd": "408 MERRILL ST",
    "dropmalcty": "BUSSEY",
    "dropmalst": "IA",
    "dropmalzpp": 500448150,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419445332,
    "dropsitcph": 6419445332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10200",
    "droptype": "D",
    "dropname": "CALAMUS",
    "dropdeladd": "200 2ND ST",
    "dropdelcty": "CALAMUS",
    "dropdelst": "IA",
    "dropdelzpp": 527299000,
    "dropphyadd": "200 2ND ST",
    "dropphycty": "CALAMUS",
    "dropphyst": "IA",
    "dropphyzpp": 527299000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALAMUS",
    "dropmalst": "IA",
    "dropmalzpp": 527299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632462681,
    "dropsitcph": 5632462681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10201",
    "droptype": "D",
    "dropname": "CALLENDER",
    "dropdeladd": "706 AGNES ST",
    "dropdelcty": "CALLENDER",
    "dropdelst": "IA",
    "dropdelzpp": 505235001,
    "dropphyadd": "706 AGNES ST",
    "dropphycty": "CALLENDER",
    "dropphyst": "IA",
    "dropphyzpp": 505235001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALLENDER",
    "dropmalst": "IA",
    "dropmalzpp": 505239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155483232,
    "dropsitcph": 5155483232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10202",
    "droptype": "D",
    "dropname": "CALMAR",
    "dropdeladd": "107 S MARYVILLE ST",
    "dropdelcty": "CALMAR",
    "dropdelst": "IA",
    "dropdelzpp": 521328527,
    "dropphyadd": "107 S MARYVILLE ST",
    "dropphycty": "CALMAR",
    "dropphyst": "IA",
    "dropphyzpp": 521328527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALMAR",
    "dropmalst": "IA",
    "dropmalzpp": 521329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635623385,
    "dropsitcph": 5635623385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10203",
    "droptype": "D",
    "dropname": "CALUMET",
    "dropdeladd": "105 2ND ST",
    "dropdelcty": "CALUMET",
    "dropdelst": "IA",
    "dropdelzpp": 510097700,
    "dropphyadd": "105 2ND ST",
    "dropphycty": "CALUMET",
    "dropphyst": "IA",
    "dropphyzpp": 510097700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALUMET",
    "dropmalst": "IA",
    "dropmalzpp": 510099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8778542315,
    "dropsitcph": 8778542315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10204",
    "droptype": "D",
    "dropname": "CAMANCHE",
    "dropdeladd": "820 S WASHINGTON BLVD",
    "dropdelcty": "CAMANCHE",
    "dropdelst": "IA",
    "dropdelzpp": 527309998,
    "dropphyadd": "820 S WASHINGTON BLVD",
    "dropphycty": "CAMANCHE",
    "dropphyst": "IA",
    "dropphyzpp": 527309998,
    "dropmaladd": "820 S WASHINGTON BLVD",
    "dropmalcty": "CAMANCHE",
    "dropmalst": "IA",
    "dropmalzpp": 527309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632598038,
    "dropsitcph": 5632598038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10206",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "304 WATER ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "IA",
    "dropdelzpp": 500467701,
    "dropphyadd": "304 WATER ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "IA",
    "dropphyzpp": 500467701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "IA",
    "dropmalzpp": 500469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153834462,
    "dropsitcph": 5153834462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10210",
    "droptype": "D",
    "dropname": "CANTRIL",
    "dropdeladd": "124 DIVISION ST",
    "dropdelcty": "CANTRIL",
    "dropdelst": "IA",
    "dropdelzpp": 525421061,
    "dropphyadd": "124 DIVISION ST",
    "dropphycty": "CANTRIL",
    "dropphyst": "IA",
    "dropphyzpp": 525421061,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANTRIL",
    "dropmalst": "IA",
    "dropmalzpp": 525429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193972213,
    "dropsitcph": 3193972213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10217",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "200 S 1ST ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "IA",
    "dropdelzpp": 500477601,
    "dropphyadd": "200 S 1ST ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "IA",
    "dropphyzpp": 500477601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLISLE",
    "dropmalst": "IA",
    "dropmalzpp": 500479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159893378,
    "dropsitcph": 5159893352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10225",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "614 N CLARK ST",
    "dropdelcty": "CARROLL",
    "dropdelst": "IA",
    "dropdelzpp": 514019998,
    "dropphyadd": "614 N CLARK ST",
    "dropphycty": "CARROLL",
    "dropphyst": "IA",
    "dropphyzpp": 514019998,
    "dropmaladd": "614 N CLARK ST",
    "dropmalcty": "CARROLL",
    "dropmalst": "IA",
    "dropmalzpp": 514019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127922341,
    "dropsitcph": 7127922341,
    "dropfax": 7127925581
  },
  {
    "dcode": "D",
    "dropkey": "PW10226",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "115 BROADWAY ST",
    "dropdelcty": "CARSON",
    "dropdelst": "IA",
    "dropdelzpp": 515254412,
    "dropphyadd": "115 BROADWAY ST",
    "dropphycty": "CARSON",
    "dropphyst": "IA",
    "dropphyzpp": 515254412,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARSON",
    "dropmalst": "IA",
    "dropmalzpp": 515259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124843810,
    "dropsitcph": 7124843810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10229",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "305 2ND AVE NW",
    "dropdelcty": "CASCADE",
    "dropdelst": "IA",
    "dropdelzpp": 520334400,
    "dropphyadd": "305 2ND AVE NW",
    "dropphycty": "CASCADE",
    "dropphyst": "IA",
    "dropphyzpp": 520334400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASCADE",
    "dropmalst": "IA",
    "dropmalzpp": 520339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638523393,
    "dropsitcph": 5638523393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10230",
    "droptype": "D",
    "dropname": "CASEY",
    "dropdeladd": "101 E GRANT ST",
    "dropdelcty": "CASEY",
    "dropdelst": "IA",
    "dropdelzpp": 500481009,
    "dropphyadd": "101 E GRANT ST",
    "dropphycty": "CASEY",
    "dropphyst": "IA",
    "dropphyzpp": 500481009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASEY",
    "dropmalst": "IA",
    "dropmalzpp": 500489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417462618,
    "dropsitcph": 6417462618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10232",
    "droptype": "D",
    "dropname": "CASTALIA",
    "dropdeladd": "206 E GREENE ST",
    "dropdelcty": "CASTALIA",
    "dropdelst": "IA",
    "dropdelzpp": 521338549,
    "dropphyadd": "206 E GREENE ST",
    "dropphycty": "CASTALIA",
    "dropphyst": "IA",
    "dropphyzpp": 521338549,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTALIA",
    "dropmalst": "IA",
    "dropmalzpp": 521339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638025282,
    "dropsitcph": 5638025282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10233",
    "droptype": "D",
    "dropname": "CASTANA",
    "dropdeladd": "100 N 3RD ST",
    "dropdelcty": "CASTANA",
    "dropdelst": "IA",
    "dropdelzpp": 510107719,
    "dropphyadd": "100 N 3RD ST",
    "dropphycty": "CASTANA",
    "dropphyst": "IA",
    "dropphyzpp": 510107719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTANA",
    "dropmalst": "IA",
    "dropmalzpp": 510109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123536306,
    "dropsitcph": 7123536306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10235",
    "droptype": "D",
    "dropname": "CEDAR",
    "dropdeladd": "2804 HIGHWAY 23",
    "dropdelcty": "CEDAR",
    "dropdelst": "IA",
    "dropdelzpp": 525439704,
    "dropphyadd": "2804 HIGHWAY 23",
    "dropphycty": "CEDAR",
    "dropphyst": "IA",
    "dropphyzpp": 525439704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR",
    "dropmalst": "IA",
    "dropmalzpp": 525439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419334766,
    "dropsitcph": 6419334766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10238",
    "droptype": "D",
    "dropname": "CEDAR FALLS",
    "dropdeladd": "221 W 6TH ST",
    "dropdelcty": "CEDAR FALLS",
    "dropdelst": "IA",
    "dropdelzpp": 506139998,
    "dropphyadd": "221 W 6TH ST",
    "dropphycty": "CEDAR FALLS",
    "dropphyst": "IA",
    "dropphyzpp": 506139998,
    "dropmaladd": "221 W 6TH ST",
    "dropmalcty": "CEDAR FALLS",
    "dropmalst": "IA",
    "dropmalzpp": 506139998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192664734,
    "dropsitcph": 3192664734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10240",
    "droptype": "D",
    "dropname": "CEDAR RAPIDS",
    "dropdeladd": "615 6TH AVE SE",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 524011923,
    "dropphyadd": "615 6TH AVE SE",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 524011923,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 524069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193992986,
    "dropsitcph": 3193995560,
    "dropfax": 3193992983
  },
  {
    "dcode": "D",
    "dropkey": "PW10244",
    "droptype": "D",
    "dropname": "CENTER JUNCTION",
    "dropdeladd": "10612 MAIN ST",
    "dropdelcty": "CENTER JUNCTION",
    "dropdelst": "IA",
    "dropdelzpp": 522124803,
    "dropphyadd": "10612 MAIN ST",
    "dropphycty": "CENTER JUNCTION",
    "dropphyst": "IA",
    "dropphyzpp": 522124803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER JUNCTION",
    "dropmalst": "IA",
    "dropmalzpp": 522129998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634872171,
    "dropsitcph": 5634872171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10245",
    "droptype": "D",
    "dropname": "CENTER POINT",
    "dropdeladd": "708 MAIN ST",
    "dropdelcty": "CENTER POINT",
    "dropdelst": "IA",
    "dropdelzpp": 522134400,
    "dropphyadd": "708 MAIN ST",
    "dropphycty": "CENTER POINT",
    "dropphyst": "IA",
    "dropphyzpp": 522134400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER POINT",
    "dropmalst": "IA",
    "dropmalzpp": 522139998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198494006,
    "dropsitcph": 3198494006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10248",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "300 N 10TH ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525441769,
    "dropphyadd": "300 N 10TH ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525441769,
    "dropmaladd": "300 N 10TH ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525441769,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418563403,
    "dropsitcph": 6418563403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10251",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "55 4TH ST S",
    "dropdelcty": "CENTRAL CITY",
    "dropdelst": "IA",
    "dropdelzpp": 522147702,
    "dropphyadd": "55 4TH ST S",
    "dropphycty": "CENTRAL CITY",
    "dropphyst": "IA",
    "dropphyzpp": 522147702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL CITY",
    "dropmalst": "IA",
    "dropmalzpp": 522149998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194386112,
    "dropsitcph": 3194386112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10256",
    "droptype": "D",
    "dropname": "CHARITON",
    "dropdeladd": "126 S GRAND ST",
    "dropdelcty": "CHARITON",
    "dropdelst": "IA",
    "dropdelzpp": 500490010,
    "dropphyadd": "126 S GRAND ST",
    "dropphycty": "CHARITON",
    "dropphyst": "IA",
    "dropphyzpp": 500490010,
    "dropmaladd": "126 S GRAND ST",
    "dropmalcty": "CHARITON",
    "dropmalst": "IA",
    "dropmalzpp": 500490010,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417745216,
    "dropsitcph": 6417745216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10257",
    "droptype": "D",
    "dropname": "CHARLES CITY",
    "dropdeladd": "500 N MAIN ST",
    "dropdelcty": "CHARLES CITY",
    "dropdelst": "IA",
    "dropdelzpp": 506162005,
    "dropphyadd": "500 N MAIN ST",
    "dropphycty": "CHARLES CITY",
    "dropphyst": "IA",
    "dropphyzpp": 506162005,
    "dropmaladd": "500 N MAIN ST",
    "dropmalcty": "CHARLES CITY",
    "dropmalst": "IA",
    "dropmalzpp": 506162005,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412283233,
    "dropsitcph": 6412283233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10259",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "125 BROADWAY ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "IA",
    "dropdelzpp": 527319686,
    "dropphyadd": "125 BROADWAY ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "IA",
    "dropphyzpp": 527319686,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "IA",
    "dropmalzpp": 527319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636775020,
    "dropsitcph": 5636775024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10260",
    "droptype": "D",
    "dropname": "CHARTER OAK",
    "dropdeladd": "82 MAIN ST",
    "dropdelcty": "CHARTER OAK",
    "dropdelst": "IA",
    "dropdelzpp": 514397469,
    "dropphyadd": "82 MAIN ST",
    "dropphycty": "CHARTER OAK",
    "dropphyst": "IA",
    "dropphyzpp": 514397469,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHARTER OAK",
    "dropmalst": "IA",
    "dropmalzpp": 514399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126783374,
    "dropsitcph": 7126783374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10262",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "2899 HIGHWAY E66",
    "dropdelcty": "CHELSEA",
    "dropdelst": "IA",
    "dropdelzpp": 522159700,
    "dropphyadd": "2899 HIGHWAY E66",
    "dropphycty": "CHELSEA",
    "dropphyst": "IA",
    "dropphyzpp": 522159700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHELSEA",
    "dropmalst": "IA",
    "dropmalzpp": 522159998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414892811,
    "dropsitcph": 6414892811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10263",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "410 W WILLOW ST",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "IA",
    "dropdelzpp": 510121775,
    "dropphyadd": "410 W WILLOW ST",
    "dropphycty": "CHEROKEE",
    "dropphyst": "IA",
    "dropphyzpp": 510121775,
    "dropmaladd": "410 W WILLOW ST",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "IA",
    "dropmalzpp": 510121775,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122253708,
    "dropsitcph": 7122253708,
    "dropfax": 7122250706
  },
  {
    "dcode": "D",
    "dropkey": "PW10264",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "IA",
    "dropdelzpp": 521347705,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "CHESTER",
    "dropphyst": "IA",
    "dropphyzpp": 521347705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTER",
    "dropmalst": "IA",
    "dropmalzpp": 521349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635653931,
    "dropsitcph": 5635653931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10266",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "318 MARKET ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "IA",
    "dropdelzpp": 525489014,
    "dropphyadd": "318 MARKET ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "IA",
    "dropphyzpp": 525489014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "IA",
    "dropmalzpp": 525489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419354310,
    "dropsitcph": 6419354310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10269",
    "droptype": "D",
    "dropname": "CHURDAN",
    "dropdeladd": "517 SAND ST",
    "dropdelcty": "CHURDAN",
    "dropdelst": "IA",
    "dropdelzpp": 500507712,
    "dropphyadd": "517 SAND ST",
    "dropphycty": "CHURDAN",
    "dropphyst": "IA",
    "dropphyzpp": 500507712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHURDAN",
    "dropmalst": "IA",
    "dropmalzpp": 500509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153893420,
    "dropsitcph": 5153893420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10270",
    "droptype": "D",
    "dropname": "CINCINNATI",
    "dropdeladd": "101 ALPINE STE 1",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "IA",
    "dropdelzpp": 525498824,
    "dropphyadd": "101 ALPINE STE 1",
    "dropphycty": "CINCINNATI",
    "dropphyst": "IA",
    "dropphyzpp": 525498824,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "IA",
    "dropmalzpp": 525499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416582702,
    "dropsitcph": 6416582702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10271",
    "droptype": "D",
    "dropname": "CLARE",
    "dropdeladd": "200 W FRONT ST",
    "dropdelcty": "CLARE",
    "dropdelst": "IA",
    "dropdelzpp": 505247606,
    "dropphyadd": "200 W FRONT ST",
    "dropphycty": "CLARE",
    "dropphyst": "IA",
    "dropphyzpp": 505247606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARE",
    "dropmalst": "IA",
    "dropmalzpp": 505249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155466251,
    "dropsitcph": 5155466251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10272",
    "droptype": "D",
    "dropname": "CLARENCE",
    "dropdeladd": "310 6TH AVE",
    "dropdelcty": "CLARENCE",
    "dropdelst": "IA",
    "dropdelzpp": 522164400,
    "dropphyadd": "310 6TH AVE",
    "dropphycty": "CLARENCE",
    "dropphyst": "IA",
    "dropphyzpp": 522164400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARENCE",
    "dropmalst": "IA",
    "dropmalzpp": 522169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634523443,
    "dropsitcph": 5634523443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10273",
    "droptype": "D",
    "dropname": "CLARINDA",
    "dropdeladd": "101 S 16TH ST",
    "dropdelcty": "CLARINDA",
    "dropdelst": "IA",
    "dropdelzpp": 516329998,
    "dropphyadd": "101 S 16TH ST",
    "dropphycty": "CLARINDA",
    "dropphyst": "IA",
    "dropphyzpp": 516329998,
    "dropmaladd": "101 S 16TH ST",
    "dropmalcty": "CLARINDA",
    "dropmalst": "IA",
    "dropmalzpp": 516329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125423615,
    "dropsitcph": 7125423615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10274",
    "droptype": "D",
    "dropname": "CLARION",
    "dropdeladd": "115 1ST ST NE STE 1",
    "dropdelcty": "CLARION",
    "dropdelst": "IA",
    "dropdelzpp": 505259998,
    "dropphyadd": "115 1ST ST NE STE 1",
    "dropphycty": "CLARION",
    "dropphyst": "IA",
    "dropphyzpp": 505259998,
    "dropmaladd": "115 1ST ST NE STE 1",
    "dropmalcty": "CLARION",
    "dropmalst": "IA",
    "dropmalzpp": 505259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155323182,
    "dropsitcph": 5155323182,
    "dropfax": 5155326566
  },
  {
    "dcode": "D",
    "dropkey": "PW10276",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 506197748,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 506197748,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 506199998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193463006,
    "dropsitcph": 3193463006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10281",
    "droptype": "D",
    "dropname": "CLEAR LAKE",
    "dropdeladd": "410 1ST AVE N",
    "dropdelcty": "CLEAR LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 504281830,
    "dropphyadd": "410 1ST AVE N",
    "dropphycty": "CLEAR LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 504281830,
    "dropmaladd": "410 1ST AVE N",
    "dropmalcty": "CLEAR LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 504281830,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413572013,
    "dropsitcph": 6413572013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10282",
    "droptype": "D",
    "dropname": "CLEARFIELD",
    "dropdeladd": "303 BROADWAY ST",
    "dropdelcty": "CLEARFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 508409902,
    "dropphyadd": "303 BROADWAY ST",
    "dropphycty": "CLEARFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 508409902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 508409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413362491,
    "dropsitcph": 6413362491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10283",
    "droptype": "D",
    "dropname": "CLEGHORN",
    "dropdeladd": "110 N LEWIS AVE",
    "dropdelcty": "CLEGHORN",
    "dropdelst": "IA",
    "dropdelzpp": 510147704,
    "dropphyadd": "110 N LEWIS AVE",
    "dropphycty": "CLEGHORN",
    "dropphyst": "IA",
    "dropphyzpp": 510147704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEGHORN",
    "dropmalst": "IA",
    "dropmalzpp": 510149998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124362212,
    "dropsitcph": 7124362212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10284",
    "droptype": "D",
    "dropname": "CLEMONS",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "CLEMONS",
    "dropdelst": "IA",
    "dropdelzpp": 500517714,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "CLEMONS",
    "dropphyst": "IA",
    "dropphyzpp": 500517714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEMONS",
    "dropmalst": "IA",
    "dropmalzpp": 500519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414778328,
    "dropsitcph": 6414778328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10285",
    "droptype": "D",
    "dropname": "CLERMONT",
    "dropdeladd": "319 MILL ST",
    "dropdelcty": "CLERMONT",
    "dropdelst": "IA",
    "dropdelzpp": 521354400,
    "dropphyadd": "319 MILL ST",
    "dropphycty": "CLERMONT",
    "dropphyst": "IA",
    "dropphyzpp": 521354400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLERMONT",
    "dropmalst": "IA",
    "dropmalzpp": 521359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634235996,
    "dropsitcph": 5634235996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10289",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "300 S 1ST ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "IA",
    "dropdelzpp": 527329998,
    "dropphyadd": "300 S 1ST ST",
    "dropphycty": "CLINTON",
    "dropphyst": "IA",
    "dropphyzpp": 527329998,
    "dropmaladd": "300 S 1ST ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "IA",
    "dropmalzpp": 527329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632426214,
    "dropsitcph": 5632426214,
    "dropfax": 5632423630
  },
  {
    "dcode": "D",
    "dropkey": "PW10298",
    "droptype": "D",
    "dropname": "COGGON",
    "dropdeladd": "112 E MAIN ST",
    "dropdelcty": "COGGON",
    "dropdelst": "IA",
    "dropdelzpp": 522189314,
    "dropphyadd": "112 E MAIN ST",
    "dropphycty": "COGGON",
    "dropphyst": "IA",
    "dropphyzpp": 522189314,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COGGON",
    "dropmalst": "IA",
    "dropmalzpp": 522189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194352461,
    "dropsitcph": 3194352461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10299",
    "droptype": "D",
    "dropname": "COIN",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "COIN",
    "dropdelst": "IA",
    "dropdelzpp": 516369900,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "COIN",
    "dropphyst": "IA",
    "dropphyzpp": 516369900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COIN",
    "dropmalst": "IA",
    "dropmalzpp": 516369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125833511,
    "dropsitcph": 7125833511,
    "dropfax": 7125833511
  },
  {
    "dcode": "D",
    "dropkey": "PW10300",
    "droptype": "D",
    "dropname": "COLESBURG",
    "dropdeladd": "204 MAIN ST UNIT A",
    "dropdelcty": "COLESBURG",
    "dropdelst": "IA",
    "dropdelzpp": 520358743,
    "dropphyadd": "204 MAIN ST UNIT A",
    "dropphycty": "COLESBURG",
    "dropphyst": "IA",
    "dropphyzpp": 520358743,
    "dropmaladd": "204 MAIN ST UNIT A",
    "dropmalcty": "COLESBURG",
    "dropmalst": "IA",
    "dropmalzpp": 520358743,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638564315,
    "dropsitcph": 5638564315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10301",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "110 E HOWARD ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "IA",
    "dropdelzpp": 500549998,
    "dropphyadd": "110 E HOWARD ST",
    "dropphycty": "COLFAX",
    "dropphyst": "IA",
    "dropphyzpp": 500549998,
    "dropmaladd": "110 E HOWARD ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "IA",
    "dropmalzpp": 500549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156744172,
    "dropsitcph": 5156744172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10302",
    "droptype": "D",
    "dropname": "COLLEGE SPRINGS",
    "dropdeladd": "504 MISSOURI AVE",
    "dropdelcty": "COLLEGE SPRINGS",
    "dropdelst": "IA",
    "dropdelzpp": 516379000,
    "dropphyadd": "504 MISSOURI AVE",
    "dropphycty": "COLLEGE SPRINGS",
    "dropphyst": "IA",
    "dropphyzpp": 516379000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLEGE SPRINGS",
    "dropmalst": "IA",
    "dropmalzpp": 516379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125823310,
    "dropsitcph": 7125823310,
    "dropfax": 7125823310
  },
  {
    "dcode": "D",
    "dropkey": "PW10304",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "205 1ST ST",
    "dropdelcty": "COLLINS",
    "dropdelst": "IA",
    "dropdelzpp": 500551023,
    "dropphyadd": "205 1ST ST",
    "dropphycty": "COLLINS",
    "dropphyst": "IA",
    "dropphyzpp": 500551023,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLINS",
    "dropmalst": "IA",
    "dropmalzpp": 500559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413852330,
    "dropsitcph": 6413852330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10305",
    "droptype": "D",
    "dropname": "COLO",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "COLO",
    "dropdelst": "IA",
    "dropdelzpp": 500567723,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "COLO",
    "dropphyst": "IA",
    "dropphyzpp": 500567723,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLO",
    "dropmalst": "IA",
    "dropmalzpp": 500569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413772217,
    "dropsitcph": 6413772217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10309",
    "droptype": "D",
    "dropname": "COLUMBUS JUNCTION",
    "dropdeladd": "204 2ND ST",
    "dropdelcty": "COLUMBUS JUNCTION",
    "dropdelst": "IA",
    "dropdelzpp": 527389998,
    "dropphyadd": "204 2ND ST",
    "dropphycty": "COLUMBUS JUNCTION",
    "dropphyst": "IA",
    "dropphyzpp": 527389998,
    "dropmaladd": "204 2ND ST",
    "dropmalcty": "COLUMBUS JUNCTION",
    "dropmalst": "IA",
    "dropmalzpp": 527389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197282512,
    "dropsitcph": 3197282512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10316",
    "droptype": "D",
    "dropname": "CONESVILLE",
    "dropdeladd": "205 N TODDS FERRY RD",
    "dropdelcty": "CONESVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 527398531,
    "dropphyadd": "205 N TODDS FERRY RD",
    "dropphycty": "CONESVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 527398531,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONESVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 527399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197254256,
    "dropsitcph": 3197254256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10321",
    "droptype": "D",
    "dropname": "CONRAD",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "CONRAD",
    "dropdelst": "IA",
    "dropdelzpp": 506217748,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "CONRAD",
    "dropphyst": "IA",
    "dropphyzpp": 506217748,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONRAD",
    "dropmalst": "IA",
    "dropmalzpp": 506219998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412611012,
    "dropsitcph": 6412611012,
    "dropfax": 6412611011
  },
  {
    "dcode": "D",
    "dropkey": "PW10322",
    "droptype": "D",
    "dropname": "CONROY",
    "dropdeladd": "572 7TH AVE",
    "dropdelcty": "CONROY",
    "dropdelst": "IA",
    "dropdelzpp": 522208800,
    "dropphyadd": "572 7TH AVE",
    "dropphycty": "CONROY",
    "dropphyst": "IA",
    "dropphyzpp": 522208800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONROY",
    "dropmalst": "IA",
    "dropmalzpp": 522209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196624367,
    "dropsitcph": 3196624367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10325",
    "droptype": "D",
    "dropname": "COON RAPIDS",
    "dropdeladd": "507 MAIN ST",
    "dropdelcty": "COON RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 500586400,
    "dropphyadd": "507 MAIN ST",
    "dropphycty": "COON RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 500586400,
    "dropmaladd": "507 MAIN ST",
    "dropmalcty": "COON RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 500586400,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126842224,
    "dropsitcph": 7126842224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10331",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "608 7TH ST",
    "dropdelcty": "CORNING",
    "dropdelst": "IA",
    "dropdelzpp": 508419998,
    "dropphyadd": "608 7TH ST",
    "dropphycty": "CORNING",
    "dropphyst": "IA",
    "dropphyzpp": 508419998,
    "dropmaladd": "608 7TH ST",
    "dropmalcty": "CORNING",
    "dropmalst": "IA",
    "dropmalzpp": 508419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413223646,
    "dropsitcph": 6413223646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10332",
    "droptype": "D",
    "dropname": "CORRECTIONVILLE",
    "dropdeladd": "305 5TH ST",
    "dropdelcty": "CORRECTIONVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 510167710,
    "dropphyadd": "305 5TH ST",
    "dropphycty": "CORRECTIONVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 510167710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORRECTIONVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 510169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123724353,
    "dropsitcph": 7123724353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10334",
    "droptype": "D",
    "dropname": "CORWITH",
    "dropdeladd": "112 NW ELM ST",
    "dropdelcty": "CORWITH",
    "dropdelst": "IA",
    "dropdelzpp": 504305007,
    "dropphyadd": "112 NW ELM ST",
    "dropphycty": "CORWITH",
    "dropphyst": "IA",
    "dropphyzpp": 504305007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORWITH",
    "dropmalst": "IA",
    "dropmalzpp": 504309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155832445,
    "dropsitcph": 5155832445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10335",
    "droptype": "D",
    "dropname": "CORYDON",
    "dropdeladd": "215 W STATE ST",
    "dropdelcty": "CORYDON",
    "dropdelst": "IA",
    "dropdelzpp": 500606400,
    "dropphyadd": "215 W STATE ST",
    "dropphycty": "CORYDON",
    "dropphyst": "IA",
    "dropphyzpp": 500606400,
    "dropmaladd": "215 W STATE ST",
    "dropmalcty": "CORYDON",
    "dropmalst": "IA",
    "dropmalzpp": 500606400,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418742020,
    "dropsitcph": 6418742020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10339",
    "droptype": "D",
    "dropname": "COULTER",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "COULTER",
    "dropdelst": "IA",
    "dropdelzpp": 504315000,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "COULTER",
    "dropphyst": "IA",
    "dropphyzpp": 504315000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COULTER",
    "dropmalst": "IA",
    "dropmalzpp": 504319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418666941,
    "dropsitcph": 6418666941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10340",
    "droptype": "D",
    "dropname": "COUNCIL BLUFFS",
    "dropdeladd": "1441 MALL DR STE 100",
    "dropdelcty": "COUNCIL BLUFFS",
    "dropdelst": "IA",
    "dropdelzpp": 515034724,
    "dropphyadd": "1441 MALL DR STE 100",
    "dropphycty": "COUNCIL BLUFFS",
    "dropphyst": "IA",
    "dropphyzpp": 515034724,
    "dropmaladd": "1441 MALL DR STE 100",
    "dropmalcty": "COUNCIL BLUFFS",
    "dropmalst": "IA",
    "dropmalzpp": 515034724,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123521379,
    "dropsitcph": 7123521289,
    "dropfax": 7123250984
  },
  {
    "dcode": "D",
    "dropkey": "PW10345",
    "droptype": "D",
    "dropname": "CRAWFORDSVILLE",
    "dropdeladd": "111 E VINE ST",
    "dropdelcty": "CRAWFORDSVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 526219719,
    "dropphyadd": "111 E VINE ST",
    "dropphycty": "CRAWFORDSVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 526219719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRAWFORDSVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 526219998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196583281,
    "dropsitcph": 3196583281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10347",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "718 OLD LINCOLN HWY",
    "dropdelcty": "CRESCENT",
    "dropdelst": "IA",
    "dropdelzpp": 515263047,
    "dropphyadd": "718 OLD LINCOLN HWY",
    "dropphycty": "CRESCENT",
    "dropphyst": "IA",
    "dropphyzpp": 515263047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESCENT",
    "dropmalst": "IA",
    "dropmalzpp": 515269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125453571,
    "dropsitcph": 7125453571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10348",
    "droptype": "D",
    "dropname": "CRESCO",
    "dropdeladd": "128 2ND AVE W",
    "dropdelcty": "CRESCO",
    "dropdelst": "IA",
    "dropdelzpp": 521361509,
    "dropphyadd": "128 2ND AVE W",
    "dropphycty": "CRESCO",
    "dropphyst": "IA",
    "dropphyzpp": 521361509,
    "dropmaladd": "128 2ND AVE W",
    "dropmalcty": "CRESCO",
    "dropmalst": "IA",
    "dropmalzpp": 521361509,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635473780,
    "dropsitcph": 5635473780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10350",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "300 S ELM ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "IA",
    "dropdelzpp": 508013600,
    "dropphyadd": "300 S ELM ST",
    "dropphycty": "CRESTON",
    "dropphyst": "IA",
    "dropphyzpp": 508019998,
    "dropmaladd": "300 S ELM ST",
    "dropmalcty": "CRESTON",
    "dropmalst": "IA",
    "dropmalzpp": 508019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417822184,
    "dropsitcph": 6417822184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10355",
    "droptype": "D",
    "dropname": "CRYSTAL LAKE",
    "dropdeladd": "210 STATE AVE S",
    "dropdelcty": "CRYSTAL LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 504327734,
    "dropphyadd": "210 STATE AVE S",
    "dropphycty": "CRYSTAL LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 504327734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 504329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415653338,
    "dropsitcph": 6415653338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10357",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "IA",
    "dropdelzpp": 508439900,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "IA",
    "dropphyzpp": 508439900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "IA",
    "dropmalzpp": 508439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127745759,
    "dropsitcph": 7127745759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10358",
    "droptype": "D",
    "dropname": "CUMMING",
    "dropdeladd": "121 44TH ST",
    "dropdelcty": "CUMMING",
    "dropdelst": "IA",
    "dropdelzpp": 500611047,
    "dropphyadd": "121 44TH ST",
    "dropphycty": "CUMMING",
    "dropphyst": "IA",
    "dropphyzpp": 500611047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUMMING",
    "dropmalst": "IA",
    "dropmalzpp": 500619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159814460,
    "dropsitcph": 5159814460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10359",
    "droptype": "D",
    "dropname": "CURLEW",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "CURLEW",
    "dropdelst": "IA",
    "dropdelzpp": 505278577,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "CURLEW",
    "dropphyst": "IA",
    "dropphyzpp": 505278577,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURLEW",
    "dropmalst": "IA",
    "dropmalzpp": 505279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128552320,
    "dropsitcph": 7128552320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10360",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "406 3RD ST",
    "dropdelcty": "CUSHING",
    "dropdelst": "IA",
    "dropdelzpp": 510187715,
    "dropphyadd": "406 3RD ST",
    "dropphycty": "CUSHING",
    "dropphyst": "IA",
    "dropphyzpp": 510187715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSHING",
    "dropmalst": "IA",
    "dropmalzpp": 510189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123842403,
    "dropsitcph": 7123842403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10361",
    "droptype": "D",
    "dropname": "CYLINDER",
    "dropdeladd": "229 MAIN ST",
    "dropdelcty": "CYLINDER",
    "dropdelst": "IA",
    "dropdelzpp": 505287702,
    "dropphyadd": "229 MAIN ST",
    "dropphycty": "CYLINDER",
    "dropphyst": "IA",
    "dropphyzpp": 505287702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CYLINDER",
    "dropmalst": "IA",
    "dropmalzpp": 505289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124243434,
    "dropsitcph": 7124243434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10363",
    "droptype": "D",
    "dropname": "DAKOTA CITY",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "DAKOTA CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505295064,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "DAKOTA CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505295064,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAKOTA CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153324255,
    "dropsitcph": 5153324255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10368",
    "droptype": "D",
    "dropname": "DALLAS CENTER",
    "dropdeladd": "506 14TH ST",
    "dropdelcty": "DALLAS CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 500632075,
    "dropphyadd": "506 14TH ST",
    "dropphycty": "DALLAS CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 500632075,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALLAS CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 500639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159923320,
    "dropsitcph": 5159923320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10369",
    "droptype": "D",
    "dropname": "DANA",
    "dropdeladd": "100 GILMORE ST",
    "dropdelcty": "DANA",
    "dropdelst": "IA",
    "dropdelzpp": 500644621,
    "dropphyadd": "100 GILMORE ST",
    "dropphycty": "DANA",
    "dropphyst": "IA",
    "dropphyzpp": 500644621,
    "dropmaladd": "100 GILMORE ST",
    "dropmalcty": "DANA",
    "dropmalst": "IA",
    "dropmalzpp": 500644621,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157382139,
    "dropsitcph": 5157382139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10370",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "DANBURY",
    "dropdelst": "IA",
    "dropdelzpp": 510197725,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "DANBURY",
    "dropphyst": "IA",
    "dropphyzpp": 510197725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANBURY",
    "dropmalst": "IA",
    "dropmalzpp": 510199998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128832469,
    "dropsitcph": 7128832469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10371",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "104 N ELM ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 526239710,
    "dropphyadd": "104 N ELM ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 526239710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 526239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193924291,
    "dropsitcph": 3193924291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10373",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "933 W 2ND ST",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "IA",
    "dropdelzpp": 528029998,
    "dropphyadd": "933 W 2ND ST",
    "dropphycty": "DAVENPORT",
    "dropphyst": "IA",
    "dropphyzpp": 528029998,
    "dropmaladd": "933 W 2ND ST",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "IA",
    "dropmalzpp": 528029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633234274,
    "dropsitcph": 5633230306,
    "dropfax": 5633220774
  },
  {
    "dcode": "D",
    "dropkey": "PW10374",
    "droptype": "D",
    "dropname": "DAVIS CITY",
    "dropdeladd": "613 S MUIR ST",
    "dropdelcty": "DAVIS CITY",
    "dropdelst": "IA",
    "dropdelzpp": 500654311,
    "dropphyadd": "613 S MUIR ST",
    "dropphycty": "DAVIS CITY",
    "dropphyst": "IA",
    "dropphyzpp": 500654311,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVIS CITY",
    "dropmalst": "IA",
    "dropmalzpp": 500659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414422505,
    "dropsitcph": 6414422505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10375",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "302 E WALNUT AVE",
    "dropdelcty": "DAWSON",
    "dropdelst": "IA",
    "dropdelzpp": 500667708,
    "dropphyadd": "302 E WALNUT AVE",
    "dropphycty": "DAWSON",
    "dropphyst": "IA",
    "dropphyzpp": 500667708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWSON",
    "dropmalst": "IA",
    "dropmalzpp": 500669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154288327,
    "dropsitcph": 5154288327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10376",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "24 1ST ST NW",
    "dropdelcty": "DAYTON",
    "dropdelst": "IA",
    "dropdelzpp": 505307609,
    "dropphyadd": "24 1ST ST NW",
    "dropphycty": "DAYTON",
    "dropphyst": "IA",
    "dropphyzpp": 505307609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAYTON",
    "dropmalst": "IA",
    "dropmalzpp": 505309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155472392,
    "dropsitcph": 5155472392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10378",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "859 GUTHRIE ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "IA",
    "dropdelzpp": 500697712,
    "dropphyadd": "859 GUTHRIE ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "IA",
    "dropphyzpp": 500697712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE SOTO",
    "dropmalst": "IA",
    "dropmalzpp": 500699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158342014,
    "dropsitcph": 5158342014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10379",
    "droptype": "D",
    "dropname": "DE WITT",
    "dropdeladd": "618 9TH ST",
    "dropdelcty": "DE WITT",
    "dropdelst": "IA",
    "dropdelzpp": 527421323,
    "dropphyadd": "618 9TH ST",
    "dropphycty": "DE WITT",
    "dropphyst": "IA",
    "dropphyzpp": 527421323,
    "dropmaladd": "618 9TH ST",
    "dropmalcty": "DE WITT",
    "dropmalst": "IA",
    "dropmalzpp": 527421323,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636593712,
    "dropsitcph": 5636593712,
    "dropfax": 5636595452
  },
  {
    "dcode": "D",
    "dropkey": "PW10381",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "408 W NATIONAL ST",
    "dropdelcty": "DECATUR",
    "dropdelst": "IA",
    "dropdelzpp": 500677700,
    "dropphyadd": "408 W NATIONAL ST",
    "dropphycty": "DECATUR",
    "dropphyst": "IA",
    "dropphyzpp": 500677700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DECATUR",
    "dropmalst": "IA",
    "dropmalzpp": 500679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414464981,
    "dropsitcph": 6414464981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10383",
    "droptype": "D",
    "dropname": "DECORAH",
    "dropdeladd": "401 HEIVLY ST",
    "dropdelcty": "DECORAH",
    "dropdelst": "IA",
    "dropdelzpp": 521019998,
    "dropphyadd": "401 HEIVLY ST",
    "dropphycty": "DECORAH",
    "dropphyst": "IA",
    "dropphyzpp": 521019998,
    "dropmaladd": "401 HEIVLY ST",
    "dropmalcty": "DECORAH",
    "dropmalst": "IA",
    "dropmalzpp": 521019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633822903,
    "dropsitcph": 5633822903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10384",
    "droptype": "D",
    "dropname": "DEDHAM",
    "dropdeladd": "415 3RD ST",
    "dropdelcty": "DEDHAM",
    "dropdelst": "IA",
    "dropdelzpp": 514408567,
    "dropphyadd": "415 3RD ST",
    "dropphycty": "DEDHAM",
    "dropphyst": "IA",
    "dropphyzpp": 514408567,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEDHAM",
    "dropmalst": "IA",
    "dropmalzpp": 514409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126835831,
    "dropsitcph": 7126835831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10385",
    "droptype": "D",
    "dropname": "DEEP RIVER",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "DEEP RIVER",
    "dropdelst": "IA",
    "dropdelzpp": 522228598,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "DEEP RIVER",
    "dropphyst": "IA",
    "dropphyzpp": 522228598,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEEP RIVER",
    "dropmalst": "IA",
    "dropmalzpp": 522229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415953145,
    "dropsitcph": 6415953145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10386",
    "droptype": "D",
    "dropname": "DEFIANCE",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "DEFIANCE",
    "dropdelst": "IA",
    "dropdelzpp": 515279900,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "DEFIANCE",
    "dropphyst": "IA",
    "dropphyzpp": 515279900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEFIANCE",
    "dropmalst": "IA",
    "dropmalzpp": 515279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127483077,
    "dropsitcph": 7127483077,
    "dropfax": 7127483077
  },
  {
    "dcode": "D",
    "dropkey": "PW10389",
    "droptype": "D",
    "dropname": "DELHI",
    "dropdeladd": "300 FRANKLIN ST",
    "dropdelcty": "DELHI",
    "dropdelst": "IA",
    "dropdelzpp": 522239602,
    "dropphyadd": "300 FRANKLIN ST",
    "dropphycty": "DELHI",
    "dropphyst": "IA",
    "dropphyzpp": 522239602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELHI",
    "dropmalst": "IA",
    "dropmalzpp": 522239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639220030,
    "dropsitcph": 5639220030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10390",
    "droptype": "D",
    "dropname": "DELMAR",
    "dropdeladd": "604 VANE ST",
    "dropdelcty": "DELMAR",
    "dropdelst": "IA",
    "dropdelzpp": 520374400,
    "dropphyadd": "604 VANE ST",
    "dropphycty": "DELMAR",
    "dropphyst": "IA",
    "dropphyzpp": 520374400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELMAR",
    "dropmalst": "IA",
    "dropmalzpp": 520379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636744124,
    "dropsitcph": 5636744124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10391",
    "droptype": "D",
    "dropname": "DELOIT",
    "dropdeladd": "600 WOLF ST",
    "dropdelcty": "DELOIT",
    "dropdelst": "IA",
    "dropdelzpp": 514417555,
    "dropphyadd": "600 WOLF ST",
    "dropphycty": "DELOIT",
    "dropphyst": "IA",
    "dropphyzpp": 514417555,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELOIT",
    "dropmalst": "IA",
    "dropmalzpp": 514419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122633239,
    "dropsitcph": 7122633239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10395",
    "droptype": "D",
    "dropname": "DENISON",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "DENISON",
    "dropdelst": "IA",
    "dropdelzpp": 514429998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "DENISON",
    "dropphyst": "IA",
    "dropphyzpp": 514429998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "DENISON",
    "dropmalst": "IA",
    "dropmalzpp": 514429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122632343,
    "dropsitcph": 7122632343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10396",
    "droptype": "D",
    "dropname": "DENMARK",
    "dropdeladd": "104 ACADEMY AVE",
    "dropdelcty": "DENMARK",
    "dropdelst": "IA",
    "dropdelzpp": 526245000,
    "dropphyadd": "104 ACADEMY AVE",
    "dropphycty": "DENMARK",
    "dropphyst": "IA",
    "dropphyzpp": 526245000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENMARK",
    "dropmalst": "IA",
    "dropmalzpp": 526249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3195286213,
    "dropsitcph": 3195286213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10397",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "340 S STATE ST",
    "dropdelcty": "DENVER",
    "dropdelst": "IA",
    "dropdelzpp": 506227706,
    "dropphyadd": "340 S STATE ST",
    "dropphycty": "DENVER",
    "dropphyst": "IA",
    "dropphyzpp": 506227706,
    "dropmaladd": "340 S STATE ST",
    "dropmalcty": "DENVER",
    "dropmalst": "IA",
    "dropmalzpp": 506227706,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199846230,
    "dropsitcph": 3199846230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10399",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "481 FRONT ST",
    "dropdelcty": "DERBY",
    "dropdelst": "IA",
    "dropdelzpp": 500688505,
    "dropphyadd": "481 FRONT ST",
    "dropphycty": "DERBY",
    "dropphyst": "IA",
    "dropphyzpp": 500688505,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DERBY",
    "dropmalst": "IA",
    "dropmalzpp": 500689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415334495,
    "dropsitcph": 6415334495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10402",
    "droptype": "D",
    "dropname": "DES MOINES",
    "dropdeladd": "1165 2ND AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503189998,
    "dropphyadd": "1165 2ND AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503189998,
    "dropmaladd": "1165 2ND AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152837644,
    "dropsitcph": 5152837585,
    "dropfax": 5152837637
  },
  {
    "dcode": "D",
    "dropkey": "PW10403",
    "droptype": "D",
    "dropname": "DEWAR",
    "dropdeladd": "5916 1ST ST",
    "dropdelcty": "DEWAR",
    "dropdelst": "IA",
    "dropdelzpp": 506235000,
    "dropphyadd": "5916 1ST ST",
    "dropphycty": "DEWAR",
    "dropphyst": "IA",
    "dropphyzpp": 506235000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEWAR",
    "dropmalst": "IA",
    "dropmalzpp": 506239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192325493,
    "dropsitcph": 3192325493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10405",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "702 MARSHALL ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "IA",
    "dropdelzpp": 500701030,
    "dropphyadd": "702 MARSHALL ST",
    "dropphycty": "DEXTER",
    "dropphyst": "IA",
    "dropphyzpp": 500701030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEXTER",
    "dropmalst": "IA",
    "dropmalzpp": 500709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157894000,
    "dropsitcph": 5157894000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10406",
    "droptype": "D",
    "dropname": "DIAGONAL",
    "dropdeladd": "221 BROADWAY ST",
    "dropdelcty": "DIAGONAL",
    "dropdelst": "IA",
    "dropdelzpp": 508451046,
    "dropphyadd": "221 BROADWAY ST",
    "dropphycty": "DIAGONAL",
    "dropphyst": "IA",
    "dropphyzpp": 508451046,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIAGONAL",
    "dropmalst": "IA",
    "dropmalzpp": 508459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417344028,
    "dropsitcph": 6417344028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10408",
    "droptype": "D",
    "dropname": "DICKENS",
    "dropdeladd": "201 2ND ST",
    "dropdelcty": "DICKENS",
    "dropdelst": "IA",
    "dropdelzpp": 513337917,
    "dropphyadd": "201 2ND ST",
    "dropphycty": "DICKENS",
    "dropphyst": "IA",
    "dropphyzpp": 513337917,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DICKENS",
    "dropmalst": "IA",
    "dropmalzpp": 513339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128362315,
    "dropsitcph": 7128362315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10409",
    "droptype": "D",
    "dropname": "DIKE",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "DIKE",
    "dropdelst": "IA",
    "dropdelzpp": 506247730,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "DIKE",
    "dropphyst": "IA",
    "dropphyzpp": 506247730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIKE",
    "dropmalst": "IA",
    "dropmalzpp": 506249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199892077,
    "dropsitcph": 3199892077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10412",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "502 RAILROAD ST",
    "dropdelcty": "DIXON",
    "dropdelst": "IA",
    "dropdelzpp": 527457711,
    "dropphyadd": "502 RAILROAD ST",
    "dropphycty": "DIXON",
    "dropphyst": "IA",
    "dropphyzpp": 527457711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIXON",
    "dropmalst": "IA",
    "dropmalzpp": 527459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632056084,
    "dropsitcph": 5632056084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10414",
    "droptype": "D",
    "dropname": "DOLLIVER",
    "dropdeladd": "5088 MAIN ST",
    "dropdelcty": "DOLLIVER",
    "dropdelst": "IA",
    "dropdelzpp": 505317568,
    "dropphyadd": "5088 MAIN ST",
    "dropphycty": "DOLLIVER",
    "dropphyst": "IA",
    "dropphyzpp": 505317568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOLLIVER",
    "dropmalst": "IA",
    "dropmalzpp": 505319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128652445,
    "dropsitcph": 7128652445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10415",
    "droptype": "D",
    "dropname": "DONAHUE",
    "dropdeladd": "303 N MAIN ST",
    "dropdelcty": "DONAHUE",
    "dropdelst": "IA",
    "dropdelzpp": 527467725,
    "dropphyadd": "303 N MAIN ST",
    "dropphycty": "DONAHUE",
    "dropphyst": "IA",
    "dropphyzpp": 527467725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONAHUE",
    "dropmalst": "IA",
    "dropmalzpp": 527469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632824511,
    "dropsitcph": 5632824511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10417",
    "droptype": "D",
    "dropname": "DONNELLSON",
    "dropdeladd": "516 CHESTNUT ST",
    "dropdelcty": "DONNELLSON",
    "dropdelst": "IA",
    "dropdelzpp": 526259701,
    "dropphyadd": "516 CHESTNUT ST",
    "dropphycty": "DONNELLSON",
    "dropphyst": "IA",
    "dropphyzpp": 526259701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONNELLSON",
    "dropmalst": "IA",
    "dropmalzpp": 526259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198355118,
    "dropsitcph": 3198355118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10418",
    "droptype": "D",
    "dropname": "DOON",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "DOON",
    "dropdelst": "IA",
    "dropdelzpp": 512357710,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "DOON",
    "dropphyst": "IA",
    "dropphyzpp": 512357710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOON",
    "dropmalst": "IA",
    "dropmalzpp": 512359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127263485,
    "dropsitcph": 7127263485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10421",
    "droptype": "D",
    "dropname": "DOUDS",
    "dropdeladd": "14173 HIGHWAY 98",
    "dropdelcty": "DOUDS",
    "dropdelst": "IA",
    "dropdelzpp": 525518213,
    "dropphyadd": "14173 HIGHWAY 98",
    "dropphycty": "DOUDS",
    "dropphyst": "IA",
    "dropphyzpp": 525518213,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOUDS",
    "dropmalst": "IA",
    "dropmalzpp": 525519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419364622,
    "dropsitcph": 6419364622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10424",
    "droptype": "D",
    "dropname": "DOW CITY",
    "dropdeladd": "105 N FRANKLIN ST",
    "dropdelcty": "DOW CITY",
    "dropdelst": "IA",
    "dropdelzpp": 515289700,
    "dropphyadd": "105 N FRANKLIN ST",
    "dropphycty": "DOW CITY",
    "dropphyst": "IA",
    "dropphyzpp": 515289700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOW CITY",
    "dropmalst": "IA",
    "dropmalzpp": 515289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7122082107,
    "dropsitcph": 7122082107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10427",
    "droptype": "D",
    "dropname": "DOWS",
    "dropdeladd": "105 W ELLSWORTH ST",
    "dropdelcty": "DOWS",
    "dropdelst": "IA",
    "dropdelzpp": 500712032,
    "dropphyadd": "105 W ELLSWORTH ST",
    "dropphycty": "DOWS",
    "dropphyst": "IA",
    "dropphyzpp": 500712032,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOWS",
    "dropmalst": "IA",
    "dropmalzpp": 500719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158524243,
    "dropsitcph": 5158524243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10428",
    "droptype": "D",
    "dropname": "DRAKESVILLE",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "DRAKESVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525527721,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "DRAKESVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525527721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRAKESVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417225214,
    "dropsitcph": 6417225214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10431",
    "droptype": "D",
    "dropname": "DUBUQUE",
    "dropdeladd": "350 W 6TH ST STE 124",
    "dropdelcty": "DUBUQUE",
    "dropdelst": "IA",
    "dropdelzpp": 520019998,
    "dropphyadd": "350 W 6TH ST STE 124",
    "dropphycty": "DUBUQUE",
    "dropphyst": "IA",
    "dropphyzpp": 520019998,
    "dropmaladd": "350 W 6TH ST STE 124",
    "dropmalcty": "DUBUQUE",
    "dropmalst": "IA",
    "dropmalzpp": 520019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635824365,
    "dropsitcph": 5635822997,
    "dropfax": 5635822528
  },
  {
    "dcode": "D",
    "dropkey": "PW10433",
    "droptype": "D",
    "dropname": "DUMONT",
    "dropdeladd": "603 MAIN ST",
    "dropdelcty": "DUMONT",
    "dropdelst": "IA",
    "dropdelzpp": 506251035,
    "dropphyadd": "603 MAIN ST",
    "dropphycty": "DUMONT",
    "dropphyst": "IA",
    "dropphyzpp": 506251035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUMONT",
    "dropmalst": "IA",
    "dropmalzpp": 506259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418573418,
    "dropsitcph": 6418573418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10436",
    "droptype": "D",
    "dropname": "DUNCOMBE",
    "dropdeladd": "414 MAIN ST",
    "dropdelcty": "DUNCOMBE",
    "dropdelst": "IA",
    "dropdelzpp": 505327604,
    "dropphyadd": "414 MAIN ST",
    "dropphycty": "DUNCOMBE",
    "dropphyst": "IA",
    "dropphyzpp": 505327604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNCOMBE",
    "dropmalst": "IA",
    "dropmalzpp": 505329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155438125,
    "dropsitcph": 5155438125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10437",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "106 N CENTER ST",
    "dropdelcty": "DUNDEE",
    "dropdelst": "IA",
    "dropdelzpp": 520384400,
    "dropphyadd": "106 N CENTER ST",
    "dropphycty": "DUNDEE",
    "dropphyst": "IA",
    "dropphyzpp": 520384400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNDEE",
    "dropmalst": "IA",
    "dropmalzpp": 520389998,
    "dropsitphn": 5639240014,
    "dropsitlph": 5639242528,
    "dropsitcph": 5639240014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10438",
    "droptype": "D",
    "dropname": "DUNKERTON",
    "dropdeladd": "713 S CANFIELD ST",
    "dropdelcty": "DUNKERTON",
    "dropdelst": "IA",
    "dropdelzpp": 506269514,
    "dropphyadd": "713 S CANFIELD ST",
    "dropphycty": "DUNKERTON",
    "dropphyst": "IA",
    "dropphyzpp": 506269514,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNKERTON",
    "dropmalst": "IA",
    "dropmalzpp": 506269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198224400,
    "dropsitcph": 3198224400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10439",
    "droptype": "D",
    "dropname": "DUNLAP",
    "dropdeladd": "719 IOWA AVE",
    "dropdelcty": "DUNLAP",
    "dropdelst": "IA",
    "dropdelzpp": 515299998,
    "dropphyadd": "719 IOWA AVE",
    "dropphycty": "DUNLAP",
    "dropphyst": "IA",
    "dropphyzpp": 515299998,
    "dropmaladd": "719 IOWA AVE",
    "dropmalcty": "DUNLAP",
    "dropmalst": "IA",
    "dropmalzpp": 515299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126433019,
    "dropsitcph": 7126433019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10443",
    "droptype": "D",
    "dropname": "DURANT",
    "dropdeladd": "822 5TH ST",
    "dropdelcty": "DURANT",
    "dropdelst": "IA",
    "dropdelzpp": 527477733,
    "dropphyadd": "822 5TH ST",
    "dropphycty": "DURANT",
    "dropphyst": "IA",
    "dropphyzpp": 527477733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DURANT",
    "dropmalst": "IA",
    "dropmalzpp": 527479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637856362,
    "dropsitcph": 5637856362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10446",
    "droptype": "D",
    "dropname": "DYERSVILLE",
    "dropdeladd": "315 3RD AVE SE",
    "dropdelcty": "DYERSVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 520401835,
    "dropphyadd": "315 3RD AVE SE",
    "dropphycty": "DYERSVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 520401835,
    "dropmaladd": "315 3RD AVE SE",
    "dropmalcty": "DYERSVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 520401835,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638758027,
    "dropsitcph": 5638758027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10447",
    "droptype": "D",
    "dropname": "DYSART",
    "dropdeladd": "306 JEFFERSON ST",
    "dropdelcty": "DYSART",
    "dropdelst": "IA",
    "dropdelzpp": 522249612,
    "dropphyadd": "306 JEFFERSON ST",
    "dropphycty": "DYSART",
    "dropphyst": "IA",
    "dropphyzpp": 522249612,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DYSART",
    "dropmalst": "IA",
    "dropmalzpp": 522249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192810673,
    "dropsitcph": 3192810673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10449",
    "droptype": "D",
    "dropname": "EAGLE GROVE",
    "dropdeladd": "119 S IOWA AVE",
    "dropdelcty": "EAGLE GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 505339998,
    "dropphyadd": "119 S IOWA AVE",
    "dropphycty": "EAGLE GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 505339998,
    "dropmaladd": "119 S IOWA AVE",
    "dropmalcty": "EAGLE GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 505339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154483471,
    "dropsitcph": 5154483471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10452",
    "droptype": "D",
    "dropname": "EARLHAM",
    "dropdeladd": "125 E 1ST ST",
    "dropdelcty": "EARLHAM",
    "dropdelst": "IA",
    "dropdelzpp": 500727717,
    "dropphyadd": "125 E 1ST ST",
    "dropphycty": "EARLHAM",
    "dropphyst": "IA",
    "dropphyzpp": 500727717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARLHAM",
    "dropmalst": "IA",
    "dropmalzpp": 500729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157582118,
    "dropsitcph": 5157582118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10455",
    "droptype": "D",
    "dropname": "EARLING",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "EARLING",
    "dropdelst": "IA",
    "dropdelzpp": 515309701,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "EARLING",
    "dropphyst": "IA",
    "dropphyzpp": 515309701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARLING",
    "dropmalst": "IA",
    "dropmalzpp": 515309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127476992,
    "dropsitcph": 7127476992,
    "dropfax": 7127476992
  },
  {
    "dcode": "D",
    "dropkey": "PW10457",
    "droptype": "D",
    "dropname": "EARLY",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "EARLY",
    "dropdelst": "IA",
    "dropdelzpp": 505355011,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "EARLY",
    "dropphyst": "IA",
    "dropphyzpp": 505355011,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARLY",
    "dropmalst": "IA",
    "dropmalzpp": 505359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122735110,
    "dropsitcph": 7122735110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10464",
    "droptype": "D",
    "dropname": "EDDYVILLE",
    "dropdeladd": "102 WALNUT ST",
    "dropdelcty": "EDDYVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525539688,
    "dropphyadd": "102 WALNUT ST",
    "dropphycty": "EDDYVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525539688,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDDYVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419694648,
    "dropsitcph": 6419694648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10465",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "200 E UNION ST",
    "dropdelcty": "EDGEWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 520428700,
    "dropphyadd": "200 E UNION ST",
    "dropphycty": "EDGEWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 520428700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGEWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 520429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639286212,
    "dropsitcph": 5639286212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10469",
    "droptype": "D",
    "dropname": "ELBERON",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "ELBERON",
    "dropdelst": "IA",
    "dropdelzpp": 522258729,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "ELBERON",
    "dropphyst": "IA",
    "dropphyzpp": 522258729,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBERON",
    "dropmalst": "IA",
    "dropmalzpp": 522259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194395380,
    "dropsitcph": 3194395380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10470",
    "droptype": "D",
    "dropname": "ELDON",
    "dropdeladd": "402 ELM ST",
    "dropdelcty": "ELDON",
    "dropdelst": "IA",
    "dropdelzpp": 525549668,
    "dropphyadd": "402 ELM ST",
    "dropphycty": "ELDON",
    "dropphyst": "IA",
    "dropphyzpp": 525549668,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELDON",
    "dropmalst": "IA",
    "dropmalzpp": 525549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416523117,
    "dropsitcph": 6416523117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10471",
    "droptype": "D",
    "dropname": "ELDORA",
    "dropdeladd": "1334 EDGINGTON AVE",
    "dropdelcty": "ELDORA",
    "dropdelst": "IA",
    "dropdelzpp": 506279998,
    "dropphyadd": "1334 EDGINGTON AVE",
    "dropphycty": "ELDORA",
    "dropphyst": "IA",
    "dropphyzpp": 506279998,
    "dropmaladd": "1334 EDGINGTON AVE",
    "dropmalcty": "ELDORA",
    "dropmalst": "IA",
    "dropmalzpp": 506279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418583971,
    "dropsitcph": 6418583971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10473",
    "droptype": "D",
    "dropname": "ELDRIDGE",
    "dropdeladd": "120 W LE CLAIRE RD",
    "dropdelcty": "ELDRIDGE",
    "dropdelst": "IA",
    "dropdelzpp": 527489998,
    "dropphyadd": "120 W LE CLAIRE RD",
    "dropphycty": "ELDRIDGE",
    "dropphyst": "IA",
    "dropphyzpp": 527489998,
    "dropmaladd": "120 W LE CLAIRE RD",
    "dropmalcty": "ELDRIDGE",
    "dropmalst": "IA",
    "dropmalzpp": 527489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632859625,
    "dropsitcph": 5632859625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10474",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "238 CENTER ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "IA",
    "dropdelzpp": 521419334,
    "dropphyadd": "238 CENTER ST",
    "dropphycty": "ELGIN",
    "dropphyst": "IA",
    "dropphyzpp": 521419334,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELGIN",
    "dropmalst": "IA",
    "dropmalzpp": 521419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632176206,
    "dropsitcph": 5632176206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10475",
    "droptype": "D",
    "dropname": "ELK HORN",
    "dropdeladd": "4214 MAIN ST",
    "dropdelcty": "ELK HORN",
    "dropdelst": "IA",
    "dropdelzpp": 515318018,
    "dropphyadd": "4214 MAIN ST",
    "dropphycty": "ELK HORN",
    "dropphyst": "IA",
    "dropphyzpp": 515318018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK HORN",
    "dropmalst": "IA",
    "dropmalzpp": 515319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127648792,
    "dropsitcph": 7127648792,
    "dropfax": 7127648792
  },
  {
    "dcode": "D",
    "dropkey": "PW10477",
    "droptype": "D",
    "dropname": "ELKADER",
    "dropdeladd": "105 MULBERRY ST",
    "dropdelcty": "ELKADER",
    "dropdelst": "IA",
    "dropdelzpp": 520434400,
    "dropphyadd": "105 MULBERRY ST",
    "dropphycty": "ELKADER",
    "dropphyst": "IA",
    "dropphyzpp": 520434400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKADER",
    "dropmalst": "IA",
    "dropmalzpp": 520439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632451252,
    "dropsitcph": 5632451252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10478",
    "droptype": "D",
    "dropname": "ELKHART",
    "dropdeladd": "263 NW MAIN ST",
    "dropdelcty": "ELKHART",
    "dropdelst": "IA",
    "dropdelzpp": 500737739,
    "dropphyadd": "263 NW MAIN ST",
    "dropphycty": "ELKHART",
    "dropphyst": "IA",
    "dropphyzpp": 500737739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKHART",
    "dropmalst": "IA",
    "dropmalzpp": 500739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153673034,
    "dropsitcph": 5153673034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10481",
    "droptype": "D",
    "dropname": "ELLIOTT",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "ELLIOTT",
    "dropdelst": "IA",
    "dropdelzpp": 515325074,
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "ELLIOTT",
    "dropphyst": "IA",
    "dropphyzpp": 515325074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLIOTT",
    "dropmalst": "IA",
    "dropmalzpp": 515329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127672331,
    "dropsitcph": 7127672331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10482",
    "droptype": "D",
    "dropname": "ELLSTON",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "ELLSTON",
    "dropdelst": "IA",
    "dropdelzpp": 500744652,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "ELLSTON",
    "dropphyst": "IA",
    "dropphyzpp": 500744652,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSTON",
    "dropmalst": "IA",
    "dropmalzpp": 500749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417724385,
    "dropsitcph": 6417724385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10483",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "1545 DEWITT ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "IA",
    "dropdelzpp": 500755007,
    "dropphyadd": "1545 DEWITT ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "IA",
    "dropphyzpp": 500755007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "IA",
    "dropmalzpp": 500759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158364737,
    "dropsitcph": 5158364737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10484",
    "droptype": "D",
    "dropname": "ELMA",
    "dropdeladd": "412 MAIN ST",
    "dropdelcty": "ELMA",
    "dropdelst": "IA",
    "dropdelzpp": 506288372,
    "dropphyadd": "412 MAIN ST",
    "dropphycty": "ELMA",
    "dropphyst": "IA",
    "dropphyzpp": 506288372,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMA",
    "dropmalst": "IA",
    "dropmalzpp": 506289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413932163,
    "dropsitcph": 6413932163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10489",
    "droptype": "D",
    "dropname": "ELY",
    "dropdeladd": "1690 DOWS ST",
    "dropdelcty": "ELY",
    "dropdelst": "IA",
    "dropdelzpp": 522279568,
    "dropphyadd": "1690 DOWS ST",
    "dropphycty": "ELY",
    "dropphyst": "IA",
    "dropphyzpp": 522279568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELY",
    "dropmalst": "IA",
    "dropmalzpp": 522279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192490427,
    "dropsitcph": 3192490427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10491",
    "droptype": "D",
    "dropname": "EMERSON",
    "dropdeladd": "707 MORTON AVE",
    "dropdelcty": "EMERSON",
    "dropdelst": "IA",
    "dropdelzpp": 515335000,
    "dropphyadd": "707 MORTON AVE",
    "dropphycty": "EMERSON",
    "dropphyst": "IA",
    "dropphyzpp": 515335000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMERSON",
    "dropmalst": "IA",
    "dropmalzpp": 515339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7128247595,
    "dropsitcph": 7128247595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10493",
    "droptype": "D",
    "dropname": "EMMETSBURG",
    "dropdeladd": "2210 10TH ST",
    "dropdelcty": "EMMETSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 505362490,
    "dropphyadd": "2210 10TH ST",
    "dropphycty": "EMMETSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 505362490,
    "dropmaladd": "2210 10TH ST",
    "dropmalcty": "EMMETSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 505362490,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128524600,
    "dropsitcph": 7128524600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10495",
    "droptype": "D",
    "dropname": "EPWORTH",
    "dropdeladd": "103 N CENTER AVE",
    "dropdelcty": "EPWORTH",
    "dropdelst": "IA",
    "dropdelzpp": 520457744,
    "dropphyadd": "103 N CENTER AVE",
    "dropphycty": "EPWORTH",
    "dropphyst": "IA",
    "dropphyzpp": 520457744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EPWORTH",
    "dropmalst": "IA",
    "dropmalzpp": 520459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638763211,
    "dropsitcph": 5638763211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10498",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "610 IOWA AVE",
    "dropdelcty": "ESSEX",
    "dropdelst": "IA",
    "dropdelzpp": 516389000,
    "dropphyadd": "610 IOWA AVE",
    "dropphycty": "ESSEX",
    "dropphyst": "IA",
    "dropphyzpp": 516389000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESSEX",
    "dropmalst": "IA",
    "dropmalzpp": 516389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123793703,
    "dropsitcph": 7123793703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10499",
    "droptype": "D",
    "dropname": "ESTHERVILLE",
    "dropdeladd": "605 2ND AVE N",
    "dropdelcty": "ESTHERVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 513349997,
    "dropphyadd": "605 2ND AVE N",
    "dropphycty": "ESTHERVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 513349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESTHERVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 513349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123623654,
    "dropsitcph": 7123623654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10504",
    "droptype": "D",
    "dropname": "EVERLY",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "EVERLY",
    "dropdelst": "IA",
    "dropdelzpp": 513387729,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "EVERLY",
    "dropphyst": "IA",
    "dropphyzpp": 513387729,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERLY",
    "dropmalst": "IA",
    "dropmalzpp": 513389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128342251,
    "dropsitcph": 7128342251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10506",
    "droptype": "D",
    "dropname": "EXIRA",
    "dropdeladd": "101 N CARTHAGE ST",
    "dropdelcty": "EXIRA",
    "dropdelst": "IA",
    "dropdelzpp": 500767707,
    "dropphyadd": "101 N CARTHAGE ST",
    "dropphycty": "EXIRA",
    "dropphyst": "IA",
    "dropphyzpp": 500767707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXIRA",
    "dropmalst": "IA",
    "dropmalzpp": 500769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122685336,
    "dropsitcph": 7122685336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10507",
    "droptype": "D",
    "dropname": "EXLINE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "EXLINE",
    "dropdelst": "IA",
    "dropdelzpp": 525558093,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "EXLINE",
    "dropphyst": "IA",
    "dropphyzpp": 525558093,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXLINE",
    "dropmalst": "IA",
    "dropmalzpp": 525559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416582894,
    "dropsitcph": 6416582894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10508",
    "droptype": "D",
    "dropname": "FAIRBANK",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "FAIRBANK",
    "dropdelst": "IA",
    "dropdelzpp": 506298623,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "FAIRBANK",
    "dropphyst": "IA",
    "dropphyzpp": 506298623,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRBANK",
    "dropmalst": "IA",
    "dropmalzpp": 506299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196352772,
    "dropsitcph": 3196352772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10509",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "418 VANDERBILT ST",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "IA",
    "dropdelzpp": 522289508,
    "dropphyadd": "418 VANDERBILT ST",
    "dropphycty": "FAIRFAX",
    "dropphyst": "IA",
    "dropphyzpp": 522289508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "IA",
    "dropmalzpp": 522289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198462285,
    "dropsitcph": 3198462285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10510",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "200 W BROADWAY AVE",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 525569998,
    "dropphyadd": "200 W BROADWAY AVE",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 525569998,
    "dropmaladd": "200 W BROADWAY AVE",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 525569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414720754,
    "dropsitcph": 6414725015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10515",
    "droptype": "D",
    "dropname": "FARLEY",
    "dropdeladd": "108 1ST ST N",
    "dropdelcty": "FARLEY",
    "dropdelst": "IA",
    "dropdelzpp": 520469318,
    "dropphyadd": "108 1ST ST N",
    "dropphycty": "FARLEY",
    "dropphyst": "IA",
    "dropphyzpp": 520469318,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARLEY",
    "dropmalst": "IA",
    "dropmalzpp": 520469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637443284,
    "dropsitcph": 5637443284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10517",
    "droptype": "D",
    "dropname": "FARMERSBURG",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "FARMERSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 520474400,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "FARMERSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 520474400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMERSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 520479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635362238,
    "dropsitcph": 5635362238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10518",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "101 S FRONT ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 526269231,
    "dropphyadd": "101 S FRONT ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 526269231,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 526269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198783360,
    "dropsitcph": 3198783360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10519",
    "droptype": "D",
    "dropname": "FARNHAMVILLE",
    "dropdeladd": "300 GARFIELD AVE",
    "dropdelcty": "FARNHAMVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 505385000,
    "dropphyadd": "300 GARFIELD AVE",
    "dropphycty": "FARNHAMVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 505385000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARNHAMVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 505389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155443696,
    "dropsitcph": 5155443696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10520",
    "droptype": "D",
    "dropname": "FARRAGUT",
    "dropdeladd": "604 HARTFORD AVE",
    "dropdelcty": "FARRAGUT",
    "dropdelst": "IA",
    "dropdelzpp": 516399000,
    "dropphyadd": "604 HARTFORD AVE",
    "dropphycty": "FARRAGUT",
    "dropphyst": "IA",
    "dropphyzpp": 516399000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARRAGUT",
    "dropmalst": "IA",
    "dropmalzpp": 516399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123858621,
    "dropsitcph": 7123858621,
    "dropfax": 7123858621
  },
  {
    "dcode": "D",
    "dropkey": "PW10524",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "201 E WATER ST",
    "dropdelcty": "FAYETTE",
    "dropdelst": "IA",
    "dropdelzpp": 521424400,
    "dropphyadd": "201 E WATER ST",
    "dropphycty": "FAYETTE",
    "dropphyst": "IA",
    "dropphyzpp": 521424400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAYETTE",
    "dropmalst": "IA",
    "dropmalzpp": 521429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634253626,
    "dropsitcph": 5634253626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10525",
    "droptype": "D",
    "dropname": "FENTON",
    "dropdeladd": "609 MAPLE ST",
    "dropdelcty": "FENTON",
    "dropdelst": "IA",
    "dropdelzpp": 505395009,
    "dropphyadd": "609 MAPLE ST",
    "dropphycty": "FENTON",
    "dropphyst": "IA",
    "dropphyzpp": 505395009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENTON",
    "dropmalst": "IA",
    "dropmalzpp": 505399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158892713,
    "dropsitcph": 5158892713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10526",
    "droptype": "D",
    "dropname": "FERGUSON",
    "dropdeladd": "275 1ST ST",
    "dropdelcty": "FERGUSON",
    "dropdelst": "IA",
    "dropdelzpp": 500787700,
    "dropphyadd": "275 1ST ST",
    "dropphycty": "FERGUSON",
    "dropphyst": "IA",
    "dropphyzpp": 500787700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERGUSON",
    "dropmalst": "IA",
    "dropmalzpp": 500789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414783221,
    "dropsitcph": 6414783221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10529",
    "droptype": "D",
    "dropname": "FERTILE",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "FERTILE",
    "dropdelst": "IA",
    "dropdelzpp": 504341018,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "FERTILE",
    "dropphyst": "IA",
    "dropphyzpp": 504341018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERTILE",
    "dropmalst": "IA",
    "dropmalzpp": 504349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417972252,
    "dropsitcph": 6417972252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10538",
    "droptype": "D",
    "dropname": "FLORIS",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "FLORIS",
    "dropdelst": "IA",
    "dropdelzpp": 525608807,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "FLORIS",
    "dropphyst": "IA",
    "dropphyzpp": 525608807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLORIS",
    "dropmalst": "IA",
    "dropmalzpp": 525609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412092020,
    "dropsitcph": 6412092020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10539",
    "droptype": "D",
    "dropname": "FLOYD",
    "dropdeladd": "410 MONROE ST",
    "dropdelcty": "FLOYD",
    "dropdelst": "IA",
    "dropdelzpp": 504355007,
    "dropphyadd": "410 MONROE ST",
    "dropphycty": "FLOYD",
    "dropphyst": "IA",
    "dropphyzpp": 504355007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLOYD",
    "dropmalst": "IA",
    "dropmalzpp": 504359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413982293,
    "dropsitcph": 6413982293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10541",
    "droptype": "D",
    "dropname": "FONDA",
    "dropdeladd": "218 N MAIN ST",
    "dropdelcty": "FONDA",
    "dropdelst": "IA",
    "dropdelzpp": 505401003,
    "dropphyadd": "218 N MAIN ST",
    "dropphycty": "FONDA",
    "dropphyst": "IA",
    "dropphyzpp": 505401003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FONDA",
    "dropmalst": "IA",
    "dropmalzpp": 505409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122886166,
    "dropsitcph": 7122886166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10542",
    "droptype": "D",
    "dropname": "FONTANELLE",
    "dropdeladd": "407 WASHINGTON ST",
    "dropdelcty": "FONTANELLE",
    "dropdelst": "IA",
    "dropdelzpp": 508469900,
    "dropphyadd": "407 WASHINGTON ST",
    "dropphycty": "FONTANELLE",
    "dropphyst": "IA",
    "dropphyzpp": 508469900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FONTANELLE",
    "dropmalst": "IA",
    "dropmalzpp": 508469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417454891,
    "dropsitcph": 6417454891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10544",
    "droptype": "D",
    "dropname": "FOREST CITY",
    "dropdeladd": "312 N CLARK ST",
    "dropdelcty": "FOREST CITY",
    "dropdelst": "IA",
    "dropdelzpp": 504361442,
    "dropphyadd": "312 N CLARK ST",
    "dropphycty": "FOREST CITY",
    "dropphyst": "IA",
    "dropphyzpp": 504361442,
    "dropmaladd": "312 N CLARK ST",
    "dropmalcty": "FOREST CITY",
    "dropmalst": "IA",
    "dropmalzpp": 504361442,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415853090,
    "dropsitcph": 6415853090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10545",
    "droptype": "D",
    "dropname": "FORT ATKINSON",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "FORT ATKINSON",
    "dropdelst": "IA",
    "dropdelzpp": 521447506,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "FORT ATKINSON",
    "dropphyst": "IA",
    "dropphyzpp": 521447506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT ATKINSON",
    "dropmalst": "IA",
    "dropmalzpp": 521449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635347246,
    "dropsitcph": 5635347246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10547",
    "droptype": "D",
    "dropname": "FORT DODGE",
    "dropdeladd": "3440 MAPLE DR",
    "dropdelcty": "FORT DODGE",
    "dropdelst": "IA",
    "dropdelzpp": 505019998,
    "dropphyadd": "3440 MAPLE DR",
    "dropphycty": "FORT DODGE",
    "dropphyst": "IA",
    "dropphyzpp": 505019998,
    "dropmaladd": "3440 MAPLE DR",
    "dropmalcty": "FORT DODGE",
    "dropmalst": "IA",
    "dropmalzpp": 505019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155734130,
    "dropsitcph": 5155734130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10548",
    "droptype": "D",
    "dropname": "FORT MADISON",
    "dropdeladd": "1019 AVENUE H",
    "dropdelcty": "FORT MADISON",
    "dropdelst": "IA",
    "dropdelzpp": 526279998,
    "dropphyadd": "1019 AVENUE H",
    "dropphycty": "FORT MADISON",
    "dropphyst": "IA",
    "dropphyzpp": 526279998,
    "dropmaladd": "1019 AVENUE H",
    "dropmalcty": "FORT MADISON",
    "dropmalst": "IA",
    "dropmalzpp": 526279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193722032,
    "dropsitcph": 3193722032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10549",
    "droptype": "D",
    "dropname": "FOSTORIA",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "FOSTORIA",
    "dropdelst": "IA",
    "dropdelzpp": 513407700,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "FOSTORIA",
    "dropphyst": "IA",
    "dropphyzpp": 513407700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOSTORIA",
    "dropmalst": "IA",
    "dropmalzpp": 513409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122624506,
    "dropsitcph": 7122624506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10555",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "130 E MAIN ST",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 506302014,
    "dropphyadd": "130 E MAIN ST",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 506302014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 506309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632376108,
    "dropsitcph": 5632376108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10556",
    "droptype": "D",
    "dropname": "FREDERIKA",
    "dropdeladd": "104 3RD ST",
    "dropdelcty": "FREDERIKA",
    "dropdelst": "IA",
    "dropdelzpp": 506315000,
    "dropphyadd": "104 3RD ST",
    "dropphycty": "FREDERIKA",
    "dropphyst": "IA",
    "dropphyzpp": 506315000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERIKA",
    "dropmalst": "IA",
    "dropmalzpp": 506319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192754754,
    "dropsitcph": 3192754754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10560",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "106 N WALNUT ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "IA",
    "dropdelzpp": 525617726,
    "dropphyadd": "106 N WALNUT ST",
    "dropphycty": "FREMONT",
    "dropphyst": "IA",
    "dropphyzpp": 525617726,
    "dropmaladd": "106 N WALNUT ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "IA",
    "dropmalzpp": 525617726,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419334746,
    "dropsitcph": 6419334746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10562",
    "droptype": "D",
    "dropname": "FRUITLAND",
    "dropdeladd": "136A NORTH ST",
    "dropdelcty": "FRUITLAND",
    "dropdelst": "IA",
    "dropdelzpp": 527499371,
    "dropphyadd": "136A NORTH ST",
    "dropphycty": "FRUITLAND",
    "dropphyst": "IA",
    "dropphyzpp": 527499371,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRUITLAND",
    "dropmalst": "IA",
    "dropmalzpp": 527499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632646128,
    "dropsitcph": 5632646128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10568",
    "droptype": "D",
    "dropname": "GALVA",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "GALVA",
    "dropdelst": "IA",
    "dropdelzpp": 510207716,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "GALVA",
    "dropphyst": "IA",
    "dropphyzpp": 510207716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALVA",
    "dropmalst": "IA",
    "dropmalzpp": 510209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122824782,
    "dropsitcph": 7122824782,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10571",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "31550 COUNTY HIGHWAY S27",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "IA",
    "dropdelzpp": 501024400,
    "dropphyadd": "31550 COUNTY HIGHWAY S27",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "IA",
    "dropphyzpp": 501024400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "IA",
    "dropmalzpp": 501029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158932219,
    "dropsitcph": 5158932219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10572",
    "droptype": "D",
    "dropname": "GARDEN GROVE",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "GARDEN GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 501031033,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "GARDEN GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 501031033,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 501039998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414432105,
    "dropsitcph": 6414432105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10575",
    "droptype": "D",
    "dropname": "GARNAVILLO",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "GARNAVILLO",
    "dropdelst": "IA",
    "dropdelzpp": 520494400,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "GARNAVILLO",
    "dropphyst": "IA",
    "dropphyzpp": 520494400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARNAVILLO",
    "dropmalst": "IA",
    "dropmalzpp": 520499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639642318,
    "dropsitcph": 5639642318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10576",
    "droptype": "D",
    "dropname": "GARNER",
    "dropdeladd": "190 E 3RD ST",
    "dropdelcty": "GARNER",
    "dropdelst": "IA",
    "dropdelzpp": 504381244,
    "dropphyadd": "190 E 3RD ST",
    "dropphycty": "GARNER",
    "dropphyst": "IA",
    "dropphyzpp": 504381244,
    "dropmaladd": "190 E 3RD ST",
    "dropmalcty": "GARNER",
    "dropmalst": "IA",
    "dropmalzpp": 504381244,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419233251,
    "dropsitcph": 6419233251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10577",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "102 PINE ST",
    "dropdelcty": "GARRISON",
    "dropdelst": "IA",
    "dropdelzpp": 522299508,
    "dropphyadd": "102 PINE ST",
    "dropphycty": "GARRISON",
    "dropphyst": "IA",
    "dropphyzpp": 522299508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARRISON",
    "dropmalst": "IA",
    "dropmalzpp": 522299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194776362,
    "dropsitcph": 3194776362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10583",
    "droptype": "D",
    "dropname": "GEORGE",
    "dropdeladd": "120 E MICHIGAN AVE",
    "dropdelcty": "GEORGE",
    "dropdelst": "IA",
    "dropdelzpp": 512377751,
    "dropphyadd": "120 E MICHIGAN AVE",
    "dropphycty": "GEORGE",
    "dropphyst": "IA",
    "dropphyzpp": 512377751,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GEORGE",
    "dropmalst": "IA",
    "dropmalzpp": 512379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124753333,
    "dropsitcph": 7124753333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10589",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "105 S MARSHALL ST",
    "dropdelcty": "GIBSON",
    "dropdelst": "IA",
    "dropdelzpp": 501044400,
    "dropphyadd": "105 S MARSHALL ST",
    "dropphycty": "GIBSON",
    "dropphyst": "IA",
    "dropphyzpp": 501044400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIBSON",
    "dropmalst": "IA",
    "dropmalzpp": 501049998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156342675,
    "dropsitcph": 5156342675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10591",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "117 MAIN ST",
    "dropdelcty": "GILBERT",
    "dropdelst": "IA",
    "dropdelzpp": 501057705,
    "dropphyadd": "117 MAIN ST",
    "dropphycty": "GILBERT",
    "dropphyst": "IA",
    "dropphyzpp": 501057705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILBERT",
    "dropmalst": "IA",
    "dropmalzpp": 501059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152320797,
    "dropsitcph": 5152320797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10592",
    "droptype": "D",
    "dropname": "GILBERTVILLE",
    "dropdeladd": "1320 5TH ST",
    "dropdelcty": "GILBERTVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 506347726,
    "dropphyadd": "1320 5TH ST",
    "dropphycty": "GILBERTVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 506347726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILBERTVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 506349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192961720,
    "dropsitcph": 3192961720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10593",
    "droptype": "D",
    "dropname": "GILLETT GROVE",
    "dropdeladd": "211 RAILWAY ST",
    "dropdelcty": "GILLETT GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 513417700,
    "dropphyadd": "211 RAILWAY ST",
    "dropphycty": "GILLETT GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 513417700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILLETT GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 513419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128352055,
    "dropsitcph": 7128352055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10594",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "GILMAN",
    "dropdelst": "IA",
    "dropdelzpp": 501067702,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "GILMAN",
    "dropphyst": "IA",
    "dropphyzpp": 501067702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILMAN",
    "dropmalst": "IA",
    "dropmalzpp": 501069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414987762,
    "dropsitcph": 6414987762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10595",
    "droptype": "D",
    "dropname": "GILMORE CITY",
    "dropdeladd": "402 S GILMORE ST",
    "dropdelcty": "GILMORE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505418801,
    "dropphyadd": "402 S GILMORE ST",
    "dropphycty": "GILMORE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505418801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILMORE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153736446,
    "dropsitcph": 5153736446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10596",
    "droptype": "D",
    "dropname": "GLADBROOK",
    "dropdeladd": "101 GOULD ST",
    "dropdelcty": "GLADBROOK",
    "dropdelst": "IA",
    "dropdelzpp": 506359322,
    "dropphyadd": "101 GOULD ST",
    "dropphycty": "GLADBROOK",
    "dropphyst": "IA",
    "dropphyzpp": 506359322,
    "dropmaladd": "101 GOULD ST",
    "dropmalcty": "GLADBROOK",
    "dropmalst": "IA",
    "dropmalzpp": 506359322,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414732543,
    "dropsitcph": 6414732543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10600",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "101 S VINE ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 515349998,
    "dropphyadd": "101 S VINE ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 515349998,
    "dropmaladd": "101 S VINE ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 515349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125274840,
    "dropsitcph": 7125274840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10601",
    "droptype": "D",
    "dropname": "GLIDDEN",
    "dropdeladd": "128 W 2ND ST",
    "dropdelcty": "GLIDDEN",
    "dropdelst": "IA",
    "dropdelzpp": 514431076,
    "dropphyadd": "128 W 2ND ST",
    "dropphycty": "GLIDDEN",
    "dropphyst": "IA",
    "dropphyzpp": 514431076,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLIDDEN",
    "dropmalst": "IA",
    "dropmalzpp": 514439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126592141,
    "dropsitcph": 7126592141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10603",
    "droptype": "D",
    "dropname": "GOLDFIELD",
    "dropdeladd": "539 N MAIN ST",
    "dropdelcty": "GOLDFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 505425043,
    "dropphyadd": "539 N MAIN ST",
    "dropphycty": "GOLDFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 505425043,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLDFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 505429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158253712,
    "dropsitcph": 5158253712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10605",
    "droptype": "D",
    "dropname": "GOOSE LAKE",
    "dropdeladd": "228 MAIN ST",
    "dropdelcty": "GOOSE LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 527509655,
    "dropphyadd": "228 MAIN ST",
    "dropphycty": "GOOSE LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 527509655,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOOSE LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 527509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635772204,
    "dropsitcph": 5635772204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10606",
    "droptype": "D",
    "dropname": "GOWRIE",
    "dropdeladd": "1112 BEEK ST",
    "dropdelcty": "GOWRIE",
    "dropdelst": "IA",
    "dropdelzpp": 505437547,
    "dropphyadd": "1112 BEEK ST",
    "dropphycty": "GOWRIE",
    "dropphyst": "IA",
    "dropphyzpp": 505437547,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOWRIE",
    "dropmalst": "IA",
    "dropmalzpp": 505439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153525211,
    "dropsitcph": 5153525211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10608",
    "droptype": "D",
    "dropname": "GRAETTINGER",
    "dropdeladd": "111 W ROBINS ST",
    "dropdelcty": "GRAETTINGER",
    "dropdelst": "IA",
    "dropdelzpp": 513427732,
    "dropphyadd": "111 W ROBINS ST",
    "dropphycty": "GRAETTINGER",
    "dropphyst": "IA",
    "dropphyzpp": 513427732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAETTINGER",
    "dropmalst": "IA",
    "dropmalzpp": 513429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128593419,
    "dropsitcph": 7128593419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10610",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "311 3RD ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "IA",
    "dropdelzpp": 504407559,
    "dropphyadd": "311 3RD ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "IA",
    "dropphyzpp": 504407559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAFTON",
    "dropmalst": "IA",
    "dropmalzpp": 504409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417482720,
    "dropsitcph": 6417482720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10611",
    "droptype": "D",
    "dropname": "GRAND JUNCTION",
    "dropdeladd": "403 MAIN ST E",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "IA",
    "dropdelzpp": 501077703,
    "dropphyadd": "403 MAIN ST E",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "IA",
    "dropphyzpp": 501077703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "IA",
    "dropmalzpp": 501079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157382342,
    "dropsitcph": 5157382342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10612",
    "droptype": "D",
    "dropname": "GRAND MOUND",
    "dropdeladd": "501 EAST ST",
    "dropdelcty": "GRAND MOUND",
    "dropdelst": "IA",
    "dropdelzpp": 527519000,
    "dropphyadd": "501 EAST ST",
    "dropphycty": "GRAND MOUND",
    "dropphyst": "IA",
    "dropphyzpp": 527519000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND MOUND",
    "dropmalst": "IA",
    "dropmalzpp": 527519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638477222,
    "dropsitcph": 5638477222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10613",
    "droptype": "D",
    "dropname": "GRAND RIVER",
    "dropdeladd": "246 BROADWAY ST",
    "dropdelcty": "GRAND RIVER",
    "dropdelst": "IA",
    "dropdelzpp": 501084400,
    "dropphyadd": "246 BROADWAY ST",
    "dropphycty": "GRAND RIVER",
    "dropphyst": "IA",
    "dropphyzpp": 501084400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RIVER",
    "dropmalst": "IA",
    "dropmalzpp": 501089998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417735274,
    "dropsitcph": 6417735274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10614",
    "droptype": "D",
    "dropname": "GRANDVIEW",
    "dropdeladd": "112 S MAIN ST",
    "dropdelcty": "GRANDVIEW",
    "dropdelst": "IA",
    "dropdelzpp": 527529000,
    "dropphyadd": "112 S MAIN ST",
    "dropphycty": "GRANDVIEW",
    "dropphyst": "IA",
    "dropphyzpp": 527529000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANDVIEW",
    "dropmalst": "IA",
    "dropmalzpp": 527529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197292026,
    "dropsitcph": 3197292026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10615",
    "droptype": "D",
    "dropname": "GRANGER",
    "dropdeladd": "1902 OAK ST",
    "dropdelcty": "GRANGER",
    "dropdelst": "IA",
    "dropdelzpp": 501094400,
    "dropphyadd": "1902 OAK ST",
    "dropphycty": "GRANGER",
    "dropphyst": "IA",
    "dropphyzpp": 501094400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANGER",
    "dropmalst": "IA",
    "dropmalzpp": 501099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159992910,
    "dropsitcph": 5159990927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10617",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "507 2ND ST",
    "dropdelcty": "GRANT",
    "dropdelst": "IA",
    "dropdelzpp": 508479900,
    "dropphyadd": "507 2ND ST",
    "dropphycty": "GRANT",
    "dropphyst": "IA",
    "dropphyzpp": 508479900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANT",
    "dropmalst": "IA",
    "dropmalzpp": 508479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122502214,
    "dropsitcph": 7122502214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10620",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "839 BROAD ST",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 510227714,
    "dropphyadd": "839 BROAD ST",
    "dropphycty": "GRANVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 510227714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 510229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127273402,
    "dropsitcph": 7127273402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10621",
    "droptype": "D",
    "dropname": "GRAVITY",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "GRAVITY",
    "dropdelst": "IA",
    "dropdelzpp": 508489900,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "GRAVITY",
    "dropphyst": "IA",
    "dropphyzpp": 508489900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAVITY",
    "dropmalst": "IA",
    "dropmalzpp": 508489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125372780,
    "dropsitcph": 7125372780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10622",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "GRAY",
    "dropdelst": "IA",
    "dropdelzpp": 501104400,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "GRAY",
    "dropphyst": "IA",
    "dropphyzpp": 501104400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAY",
    "dropmalst": "IA",
    "dropmalzpp": 501109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125634168,
    "dropsitcph": 7125634168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10623",
    "droptype": "D",
    "dropname": "GREELEY",
    "dropdeladd": "108 E 3RD ST",
    "dropdelcty": "GREELEY",
    "dropdelst": "IA",
    "dropdelzpp": 520504400,
    "dropphyadd": "108 E 3RD ST",
    "dropphycty": "GREELEY",
    "dropphyst": "IA",
    "dropphyzpp": 520504400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREELEY",
    "dropmalst": "IA",
    "dropmalzpp": 520509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639252212,
    "dropsitcph": 5639252212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10627",
    "droptype": "D",
    "dropname": "GREENE",
    "dropdeladd": "114 S 1ST ST",
    "dropdelcty": "GREENE",
    "dropdelst": "IA",
    "dropdelzpp": 506367758,
    "dropphyadd": "114 S 1ST ST",
    "dropphycty": "GREENE",
    "dropphyst": "IA",
    "dropphyzpp": 506367758,
    "dropmaladd": "114 S 1ST ST",
    "dropmalcty": "GREENE",
    "dropmalst": "IA",
    "dropmalzpp": 506367758,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418164244,
    "dropsitcph": 6412383073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10628",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "119 SE JACKSON ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 508499998,
    "dropphyadd": "119 SE JACKSON ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 508499998,
    "dropmaladd": "119 SE JACKSON ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 508499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417438423,
    "dropsitcph": 6417438423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10630",
    "droptype": "D",
    "dropname": "GRIMES",
    "dropdeladd": "400 SE GATEWAY DR",
    "dropdelcty": "GRIMES",
    "dropdelst": "IA",
    "dropdelzpp": 501114995,
    "dropphyadd": "400 SE GATEWAY DR",
    "dropphycty": "GRIMES",
    "dropphyst": "IA",
    "dropphyzpp": 501114995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRIMES",
    "dropmalst": "IA",
    "dropmalzpp": 501119998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159864550,
    "dropsitcph": 5159863460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10631",
    "droptype": "D",
    "dropname": "GRINNELL",
    "dropdeladd": "932 BROAD ST",
    "dropdelcty": "GRINNELL",
    "dropdelst": "IA",
    "dropdelzpp": 501129998,
    "dropphyadd": "932 BROAD ST",
    "dropphycty": "GRINNELL",
    "dropphyst": "IA",
    "dropphyzpp": 501129998,
    "dropmaladd": "932 BROAD ST",
    "dropmalcty": "GRINNELL",
    "dropmalst": "IA",
    "dropmalzpp": 501129998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412365353,
    "dropsitcph": 6412365353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10632",
    "droptype": "D",
    "dropname": "GRISWOLD",
    "dropdeladd": "608 4TH ST",
    "dropdelcty": "GRISWOLD",
    "dropdelst": "IA",
    "dropdelzpp": 515359000,
    "dropphyadd": "608 4TH ST",
    "dropphycty": "GRISWOLD",
    "dropphyst": "IA",
    "dropphyzpp": 515359000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRISWOLD",
    "dropmalst": "IA",
    "dropmalzpp": 515359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7122502283,
    "dropsitcph": 7122502283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10633",
    "droptype": "D",
    "dropname": "GRUNDY CENTER",
    "dropdeladd": "1700 G AVE",
    "dropdelcty": "GRUNDY CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 506389998,
    "dropphyadd": "1700 G AVE",
    "dropphycty": "GRUNDY CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 506389998,
    "dropmaladd": "1700 G AVE",
    "dropmalcty": "GRUNDY CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 506389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198243241,
    "dropsitcph": 3198243241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10638",
    "droptype": "D",
    "dropname": "GUTHRIE CENTER",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "GUTHRIE CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 501151314,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "GUTHRIE CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 501151314,
    "dropmaladd": "500 MAIN ST",
    "dropmalcty": "GUTHRIE CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 501151314,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417473212,
    "dropsitcph": 6417473212,
    "dropfax": 6417472042
  },
  {
    "dcode": "D",
    "dropkey": "PW10639",
    "droptype": "D",
    "dropname": "GUTTENBERG",
    "dropdeladd": "519 S 1ST ST",
    "dropdelcty": "GUTTENBERG",
    "dropdelst": "IA",
    "dropdelzpp": 520529333,
    "dropphyadd": "519 S 1ST ST",
    "dropphycty": "GUTTENBERG",
    "dropphyst": "IA",
    "dropphyzpp": 520529333,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUTTENBERG",
    "dropmalst": "IA",
    "dropmalzpp": 520529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632521517,
    "dropsitcph": 5632521517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10640",
    "droptype": "D",
    "dropname": "HALBUR",
    "dropdeladd": "206 W 2ND ST",
    "dropdelcty": "HALBUR",
    "dropdelst": "IA",
    "dropdelzpp": 514447700,
    "dropphyadd": "206 W 2ND ST",
    "dropphycty": "HALBUR",
    "dropphyst": "IA",
    "dropphyzpp": 514447700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALBUR",
    "dropmalst": "IA",
    "dropmalzpp": 514449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126582515,
    "dropsitcph": 7126582515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10643",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "308 F ST",
    "dropdelcty": "HAMBURG",
    "dropdelst": "IA",
    "dropdelzpp": 516401310,
    "dropphyadd": "308 F ST",
    "dropphycty": "HAMBURG",
    "dropphyst": "IA",
    "dropphyzpp": 516401310,
    "dropmaladd": "308 F ST",
    "dropmalcty": "HAMBURG",
    "dropmalst": "IA",
    "dropmalzpp": 516401310,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123822442,
    "dropsitcph": 7123822442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10644",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "514 EAST ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "IA",
    "dropdelzpp": 501167503,
    "dropphyadd": "514 EAST ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "IA",
    "dropphyzpp": 501167503,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMILTON",
    "dropmalst": "IA",
    "dropmalzpp": 501169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419467661,
    "dropsitcph": 6419467661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10646",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "22 S FEDERAL ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "IA",
    "dropdelzpp": 504412162,
    "dropphyadd": "22 S FEDERAL ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "IA",
    "dropphyzpp": 504412162,
    "dropmaladd": "22 S FEDERAL ST",
    "dropmalcty": "HAMPTON",
    "dropmalst": "IA",
    "dropmalzpp": 504412162,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414563511,
    "dropsitcph": 6414563511,
    "dropfax": 6414562032
  },
  {
    "dcode": "D",
    "dropkey": "PW10647",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "117 N MAIN ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "IA",
    "dropdelzpp": 515369700,
    "dropphyadd": "117 N MAIN ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "IA",
    "dropphyzpp": 515369700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANCOCK",
    "dropmalst": "IA",
    "dropmalzpp": 515369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127415621,
    "dropsitcph": 7127415621,
    "dropfax": 7127415621
  },
  {
    "dcode": "D",
    "dropkey": "PW10650",
    "droptype": "D",
    "dropname": "HANLONTOWN",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "HANLONTOWN",
    "dropdelst": "IA",
    "dropdelzpp": 504441016,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "HANLONTOWN",
    "dropphyst": "IA",
    "dropphyzpp": 504441016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANLONTOWN",
    "dropmalst": "IA",
    "dropmalzpp": 504449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418962921,
    "dropsitcph": 6418962921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10656",
    "droptype": "D",
    "dropname": "HARCOURT",
    "dropdeladd": "109 S ASH ST",
    "dropdelcty": "HARCOURT",
    "dropdelst": "IA",
    "dropdelzpp": 505447576,
    "dropphyadd": "109 S ASH ST",
    "dropphycty": "HARCOURT",
    "dropphyst": "IA",
    "dropphyzpp": 505447576,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARCOURT",
    "dropmalst": "IA",
    "dropmalzpp": 505449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153545354,
    "dropsitcph": 5153545354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10659",
    "droptype": "D",
    "dropname": "HARLAN",
    "dropdeladd": "1209 7TH ST",
    "dropdelcty": "HARLAN",
    "dropdelst": "IA",
    "dropdelzpp": 515379998,
    "dropphyadd": "1209 7TH ST",
    "dropphycty": "HARLAN",
    "dropphyst": "IA",
    "dropphyzpp": 515379998,
    "dropmaladd": "1209 7TH ST",
    "dropmalcty": "HARLAN",
    "dropmalst": "IA",
    "dropmalzpp": 515379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127555812,
    "dropsitcph": 7127555812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10661",
    "droptype": "D",
    "dropname": "HARPERS FERRY",
    "dropdeladd": "131 N GREELEY AVE",
    "dropdelcty": "HARPERS FERRY",
    "dropdelst": "IA",
    "dropdelzpp": 521464400,
    "dropphyadd": "131 N GREELEY AVE",
    "dropphycty": "HARPERS FERRY",
    "dropphyst": "IA",
    "dropphyzpp": 521464400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARPERS FERRY",
    "dropmalst": "IA",
    "dropmalzpp": 521469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635862175,
    "dropsitcph": 5635862175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10662",
    "droptype": "D",
    "dropname": "HARRIS",
    "dropdeladd": "312 MAIN ST N",
    "dropdelcty": "HARRIS",
    "dropdelst": "IA",
    "dropdelzpp": 513457728,
    "dropphyadd": "312 MAIN ST N",
    "dropphycty": "HARRIS",
    "dropphyst": "IA",
    "dropphyzpp": 513457728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRIS",
    "dropmalst": "IA",
    "dropmalzpp": 513459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123492398,
    "dropsitcph": 7123492398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10663",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "120 S VINE ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "IA",
    "dropdelzpp": 501188748,
    "dropphyadd": "120 S VINE ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "IA",
    "dropphyzpp": 501188748,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTFORD",
    "dropmalst": "IA",
    "dropmalzpp": 501189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159894238,
    "dropsitcph": 5159894238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10664",
    "droptype": "D",
    "dropname": "HARTLEY",
    "dropdeladd": "41 S CENTRAL AVE",
    "dropdelcty": "HARTLEY",
    "dropdelst": "IA",
    "dropdelzpp": 513466400,
    "dropphyadd": "41 S CENTRAL AVE",
    "dropphycty": "HARTLEY",
    "dropphyst": "IA",
    "dropphyzpp": 513466400,
    "dropmaladd": "41 S CENTRAL AVE",
    "dropmalcty": "HARTLEY",
    "dropmalst": "IA",
    "dropmalzpp": 513466400,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127283065,
    "dropsitcph": 7127283065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10667",
    "droptype": "D",
    "dropname": "HARVEY",
    "dropdeladd": "603 CENTRAL ST",
    "dropdelcty": "HARVEY",
    "dropdelst": "IA",
    "dropdelzpp": 501197727,
    "dropphyadd": "603 CENTRAL ST",
    "dropphycty": "HARVEY",
    "dropphyst": "IA",
    "dropphyzpp": 501197727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARVEY",
    "dropmalst": "IA",
    "dropmalzpp": 501199998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418470051,
    "dropsitcph": 6418470051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10670",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "427 INDIAN AVE",
    "dropdelcty": "HASTINGS",
    "dropdelst": "IA",
    "dropdelzpp": 515405012,
    "dropphyadd": "427 INDIAN AVE",
    "dropphycty": "HASTINGS",
    "dropphyst": "IA",
    "dropphyzpp": 515405012,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HASTINGS",
    "dropmalst": "IA",
    "dropmalzpp": 515409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126249013,
    "dropsitcph": 7126249013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10672",
    "droptype": "D",
    "dropname": "HAVELOCK",
    "dropdeladd": "850 WOOD ST",
    "dropdelcty": "HAVELOCK",
    "dropdelst": "IA",
    "dropdelzpp": 505467593,
    "dropphyadd": "850 WOOD ST",
    "dropphycty": "HAVELOCK",
    "dropphyst": "IA",
    "dropphyzpp": 505467593,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAVELOCK",
    "dropmalst": "IA",
    "dropmalzpp": 505469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127762680,
    "dropsitcph": 7127762680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10674",
    "droptype": "D",
    "dropname": "HAVERHILL",
    "dropdeladd": "5 MAIN ST",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "IA",
    "dropdelzpp": 501207714,
    "dropphyadd": "5 MAIN ST",
    "dropphycty": "HAVERHILL",
    "dropphyst": "IA",
    "dropphyzpp": 501207714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "IA",
    "dropmalzpp": 501209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414753470,
    "dropsitcph": 6414753470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10675",
    "droptype": "D",
    "dropname": "HAWARDEN",
    "dropdeladd": "900 CENTRAL AVE",
    "dropdelcty": "HAWARDEN",
    "dropdelst": "IA",
    "dropdelzpp": 510239998,
    "dropphyadd": "900 CENTRAL AVE",
    "dropphycty": "HAWARDEN",
    "dropphyst": "IA",
    "dropphyzpp": 510239998,
    "dropmaladd": "900 CENTRAL AVE",
    "dropmalcty": "HAWARDEN",
    "dropmalst": "IA",
    "dropmalzpp": 510239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125512305,
    "dropsitcph": 7125512305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10676",
    "droptype": "D",
    "dropname": "HAWKEYE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "HAWKEYE",
    "dropdelst": "IA",
    "dropdelzpp": 521474400,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "HAWKEYE",
    "dropphyst": "IA",
    "dropphyzpp": 521474400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWKEYE",
    "dropmalst": "IA",
    "dropmalzpp": 521479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634273410,
    "dropsitcph": 5634273410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10680",
    "droptype": "D",
    "dropname": "HAZLETON",
    "dropdeladd": "200 MAIN ST S",
    "dropdelcty": "HAZLETON",
    "dropdelst": "IA",
    "dropdelzpp": 506419504,
    "dropphyadd": "200 MAIN ST S",
    "dropphycty": "HAZLETON",
    "dropphyst": "IA",
    "dropphyzpp": 506419504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAZLETON",
    "dropmalst": "IA",
    "dropmalzpp": 506419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196362033,
    "dropsitcph": 3196362033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10682",
    "droptype": "D",
    "dropname": "HEDRICK",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "HEDRICK",
    "dropdelst": "IA",
    "dropdelzpp": 525637720,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "HEDRICK",
    "dropphyst": "IA",
    "dropphyzpp": 525637720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEDRICK",
    "dropmalst": "IA",
    "dropmalzpp": 525639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416534716,
    "dropsitcph": 6416534716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10688",
    "droptype": "D",
    "dropname": "HIAWATHA",
    "dropdeladd": "99 E WILLMAN ST",
    "dropdelcty": "HIAWATHA",
    "dropdelst": "IA",
    "dropdelzpp": 522331572,
    "dropphyadd": "99 E WILLMAN ST",
    "dropphycty": "HIAWATHA",
    "dropphyst": "IA",
    "dropphyzpp": 522331572,
    "dropmaladd": "99 E WILLMAN ST",
    "dropmalcty": "HIAWATHA",
    "dropmalst": "IA",
    "dropmalzpp": 522331572,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193932383,
    "dropsitcph": 3193932383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10697",
    "droptype": "D",
    "dropname": "HILLS",
    "dropdeladd": "14 EAST AVE",
    "dropdelcty": "HILLS",
    "dropdelst": "IA",
    "dropdelzpp": 522358800,
    "dropphyadd": "14 EAST AVE",
    "dropphycty": "HILLS",
    "dropphyst": "IA",
    "dropphyzpp": 522358800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLS",
    "dropmalst": "IA",
    "dropmalzpp": 522359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192552004,
    "dropsitcph": 3192552004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10698",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "101 W COMMERCIAL ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "IA",
    "dropdelzpp": 526309312,
    "dropphyadd": "101 W COMMERCIAL ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "IA",
    "dropphyzpp": 526309312,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "IA",
    "dropmalzpp": 526309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192534225,
    "dropsitcph": 3192534225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10699",
    "droptype": "D",
    "dropname": "HINTON",
    "dropdeladd": "125 W MAIN ST",
    "dropdelcty": "HINTON",
    "dropdelst": "IA",
    "dropdelzpp": 510247713,
    "dropphyadd": "125 W MAIN ST",
    "dropphycty": "HINTON",
    "dropphyst": "IA",
    "dropphyzpp": 510247713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HINTON",
    "dropmalst": "IA",
    "dropmalzpp": 510249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129474241,
    "dropsitcph": 7129474241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10704",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "HOLLAND",
    "dropdelst": "IA",
    "dropdelzpp": 506427713,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "HOLLAND",
    "dropphyst": "IA",
    "dropphyzpp": 506427713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLAND",
    "dropmalst": "IA",
    "dropmalzpp": 506429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198243794,
    "dropsitcph": 3198243794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10707",
    "droptype": "D",
    "dropname": "HOLSTEIN",
    "dropdeladd": "121 E 2ND ST",
    "dropdelcty": "HOLSTEIN",
    "dropdelst": "IA",
    "dropdelzpp": 510257704,
    "dropphyadd": "121 E 2ND ST",
    "dropphycty": "HOLSTEIN",
    "dropphyst": "IA",
    "dropphyzpp": 510257704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLSTEIN",
    "dropmalst": "IA",
    "dropmalzpp": 510259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123682117,
    "dropsitcph": 7123682117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10708",
    "droptype": "D",
    "dropname": "HOLY CROSS",
    "dropdeladd": "5952 MAPLE RD",
    "dropdelcty": "HOLY CROSS",
    "dropdelst": "IA",
    "dropdelzpp": 520539321,
    "dropphyadd": "5952 MAPLE RD",
    "dropphycty": "HOLY CROSS",
    "dropphyst": "IA",
    "dropphyzpp": 520539321,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLY CROSS",
    "dropmalst": "IA",
    "dropmalzpp": 520539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638703205,
    "dropsitcph": 5638703205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10714",
    "droptype": "D",
    "dropname": "HOPKINTON",
    "dropdeladd": "104 1ST ST SW",
    "dropdelcty": "HOPKINTON",
    "dropdelst": "IA",
    "dropdelzpp": 522377769,
    "dropphyadd": "104 1ST ST SW",
    "dropphycty": "HOPKINTON",
    "dropphyst": "IA",
    "dropphyzpp": 522377769,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPKINTON",
    "dropmalst": "IA",
    "dropmalzpp": 522379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639262981,
    "dropsitcph": 5639262981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10715",
    "droptype": "D",
    "dropname": "HORNICK",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "HORNICK",
    "dropdelst": "IA",
    "dropdelzpp": 510268161,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "HORNICK",
    "dropphyst": "IA",
    "dropphyzpp": 510268161,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HORNICK",
    "dropmalst": "IA",
    "dropmalzpp": 510269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128743799,
    "dropsitcph": 7128743799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10717",
    "droptype": "D",
    "dropname": "HOSPERS",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "HOSPERS",
    "dropdelst": "IA",
    "dropdelzpp": 512387725,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "HOSPERS",
    "dropphyst": "IA",
    "dropphyzpp": 512387725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOSPERS",
    "dropmalst": "IA",
    "dropmalzpp": 512389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127528627,
    "dropsitcph": 7127528627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10718",
    "droptype": "D",
    "dropname": "HOUGHTON",
    "dropdeladd": "525 MAIN ST",
    "dropdelcty": "HOUGHTON",
    "dropdelst": "IA",
    "dropdelzpp": 526315000,
    "dropphyadd": "525 MAIN ST",
    "dropphycty": "HOUGHTON",
    "dropphyst": "IA",
    "dropphyzpp": 526315000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUGHTON",
    "dropmalst": "IA",
    "dropmalzpp": 526319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194697141,
    "dropsitcph": 3194697141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10720",
    "droptype": "D",
    "dropname": "HUBBARD",
    "dropdeladd": "219 E MAPLE ST",
    "dropdelcty": "HUBBARD",
    "dropdelst": "IA",
    "dropdelzpp": 501227729,
    "dropphyadd": "219 E MAPLE ST",
    "dropphycty": "HUBBARD",
    "dropphyst": "IA",
    "dropphyzpp": 501227729,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBARD",
    "dropmalst": "IA",
    "dropmalzpp": 501229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413273067,
    "dropsitcph": 6413273067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10721",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "410 JEFFERSON ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "IA",
    "dropdelzpp": 506439719,
    "dropphyadd": "410 JEFFERSON ST",
    "dropphycty": "HUDSON",
    "dropphyst": "IA",
    "dropphyzpp": 506439719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUDSON",
    "dropmalst": "IA",
    "dropmalzpp": 506439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199883329,
    "dropsitcph": 3199883329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10722",
    "droptype": "D",
    "dropname": "HULL",
    "dropdeladd": "1204 MAIN ST",
    "dropdelcty": "HULL",
    "dropdelst": "IA",
    "dropdelzpp": 512397777,
    "dropphyadd": "1204 MAIN ST",
    "dropphycty": "HULL",
    "dropphyst": "IA",
    "dropphyzpp": 512397777,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HULL",
    "dropmalst": "IA",
    "dropmalzpp": 512399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124391606,
    "dropsitcph": 7124391606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10723",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "601 SUMNER AVE",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "IA",
    "dropdelzpp": 505489998,
    "dropphyadd": "601 SUMNER AVE",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "IA",
    "dropphyzpp": 505489998,
    "dropmaladd": "601 SUMNER AVE",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "IA",
    "dropmalzpp": 505489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153323506,
    "dropsitcph": 5153323506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10724",
    "droptype": "D",
    "dropname": "HUMESTON",
    "dropdeladd": "117 BROAD ST",
    "dropdelcty": "HUMESTON",
    "dropdelst": "IA",
    "dropdelzpp": 501237736,
    "dropphyadd": "117 BROAD ST",
    "dropphycty": "HUMESTON",
    "dropphyst": "IA",
    "dropphyzpp": 501237736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMESTON",
    "dropmalst": "IA",
    "dropmalzpp": 501239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418772871,
    "dropsitcph": 6418772871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10729",
    "droptype": "D",
    "dropname": "HUXLEY",
    "dropdeladd": "624 N US HIGHWAY 69",
    "dropdelcty": "HUXLEY",
    "dropdelst": "IA",
    "dropdelzpp": 501249313,
    "dropphyadd": "624 N US HIGHWAY 69",
    "dropphycty": "HUXLEY",
    "dropphyst": "IA",
    "dropphyzpp": 501249313,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUXLEY",
    "dropmalst": "IA",
    "dropmalzpp": 501249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155972261,
    "dropsitcph": 5155972261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10731",
    "droptype": "D",
    "dropname": "IDA GROVE",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "IDA GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 514450010,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "IDA GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 514450010,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "IDA GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 514450010,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123643623,
    "dropsitcph": 7123643623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10733",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "200 2ND AVE NE",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "IA",
    "dropdelzpp": 506441857,
    "dropphyadd": "200 2ND AVE NE",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "IA",
    "dropphyzpp": 506441857,
    "dropmaladd": "200 2ND AVE NE",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "IA",
    "dropmalzpp": 506441857,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193342495,
    "dropsitcph": 3193342495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10736",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "201 W 1ST AVE",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "IA",
    "dropdelzpp": 501252525,
    "dropphyadd": "201 W 1ST AVE",
    "dropphycty": "INDIANOLA",
    "dropphyst": "IA",
    "dropphyzpp": 501252525,
    "dropmaladd": "201 W 1ST AVE",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "IA",
    "dropmalzpp": 501252525,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159616236,
    "dropsitcph": 5159615976,
    "dropfax": 5158086031
  },
  {
    "dcode": "D",
    "dropkey": "PW10740",
    "droptype": "D",
    "dropname": "INWOOD",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "INWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 512407807,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "INWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 512407807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 512409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127534400,
    "dropsitcph": 7127534400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10741",
    "droptype": "D",
    "dropname": "IONIA",
    "dropdeladd": "203 W MAIN ST",
    "dropdelcty": "IONIA",
    "dropdelst": "IA",
    "dropdelzpp": 506459622,
    "dropphyadd": "203 W MAIN ST",
    "dropphycty": "IONIA",
    "dropphyst": "IA",
    "dropphyzpp": 506459622,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IONIA",
    "dropmalst": "IA",
    "dropmalzpp": 506459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413943063,
    "dropsitcph": 6413943063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10743",
    "droptype": "D",
    "dropname": "IOWA CITY",
    "dropdeladd": "925 HIGHWAY 6 E",
    "dropdelcty": "IOWA CITY",
    "dropdelst": "IA",
    "dropdelzpp": 522409998,
    "dropphyadd": "925 HIGHWAY 6 E",
    "dropphycty": "IOWA CITY",
    "dropphyst": "IA",
    "dropphyzpp": 522409998,
    "dropmaladd": "925 HIGHWAY 6 E",
    "dropmalcty": "IOWA CITY",
    "dropmalst": "IA",
    "dropmalzpp": 522409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193541560,
    "dropsitcph": 3193541560,
    "dropfax": 3193542574
  },
  {
    "dcode": "D",
    "dropkey": "PW10744",
    "droptype": "D",
    "dropname": "IOWA FALLS",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "IOWA FALLS",
    "dropdelst": "IA",
    "dropdelzpp": 501262203,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "IOWA FALLS",
    "dropphyst": "IA",
    "dropphyzpp": 501262203,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "IOWA FALLS",
    "dropmalst": "IA",
    "dropmalzpp": 501262203,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416489492,
    "dropsitcph": 6416489492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10749",
    "droptype": "D",
    "dropname": "IRETON",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "IRETON",
    "dropdelst": "IA",
    "dropdelzpp": 510277749,
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "IRETON",
    "dropphyst": "IA",
    "dropphyzpp": 510277749,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRETON",
    "dropmalst": "IA",
    "dropmalzpp": 510279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122782591,
    "dropsitcph": 7122782591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10754",
    "droptype": "D",
    "dropname": "IRWIN",
    "dropdeladd": "516 ANN ST",
    "dropdelcty": "IRWIN",
    "dropdelst": "IA",
    "dropdelzpp": 514467568,
    "dropphyadd": "516 ANN ST",
    "dropphycty": "IRWIN",
    "dropphyst": "IA",
    "dropphyzpp": 514467568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRWIN",
    "dropmalst": "IA",
    "dropmalzpp": 514469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127823136,
    "dropsitcph": 7127823136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10758",
    "droptype": "D",
    "dropname": "JAMAICA",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "JAMAICA",
    "dropdelst": "IA",
    "dropdelzpp": 501287703,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "JAMAICA",
    "dropphyst": "IA",
    "dropphyzpp": 501287703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAMAICA",
    "dropmalst": "IA",
    "dropmalzpp": 501289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414293232,
    "dropsitcph": 6414293232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10761",
    "droptype": "D",
    "dropname": "JANESVILLE",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "JANESVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 506477738,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "JANESVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 506477738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JANESVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 506479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199872137,
    "dropsitcph": 3199872137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10762",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "106 W HARRISON ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "IA",
    "dropdelzpp": 501299998,
    "dropphyadd": "106 W HARRISON ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "IA",
    "dropphyzpp": 501299998,
    "dropmaladd": "106 W HARRISON ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "IA",
    "dropmalzpp": 501299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153862061,
    "dropsitcph": 5153862061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10765",
    "droptype": "D",
    "dropname": "JESUP",
    "dropdeladd": "811 MAIN ST",
    "dropdelcty": "JESUP",
    "dropdelst": "IA",
    "dropdelzpp": 506487703,
    "dropphyadd": "811 MAIN ST",
    "dropphycty": "JESUP",
    "dropphyst": "IA",
    "dropphyzpp": 506487703,
    "dropmaladd": "811 MAIN ST",
    "dropmalcty": "JESUP",
    "dropmalst": "IA",
    "dropmalzpp": 506487703,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198271215,
    "dropsitcph": 3198271215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10766",
    "droptype": "D",
    "dropname": "JEWELL",
    "dropdeladd": "549 MAIN ST",
    "dropdelcty": "JEWELL",
    "dropdelst": "IA",
    "dropdelzpp": 501307708,
    "dropphyadd": "549 MAIN ST",
    "dropphycty": "JEWELL",
    "dropphyst": "IA",
    "dropphyzpp": 501307708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEWELL",
    "dropmalst": "IA",
    "dropmalzpp": 501309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158270004,
    "dropsitcph": 5158270004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10768",
    "droptype": "D",
    "dropname": "JOHNSTON",
    "dropdeladd": "5874 MERLE HAY RD",
    "dropdelcty": "JOHNSTON",
    "dropdelst": "IA",
    "dropdelzpp": 501311291,
    "dropphyadd": "5874 MERLE HAY RD",
    "dropphycty": "JOHNSTON",
    "dropphyst": "IA",
    "dropphyzpp": 501311291,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHNSTON",
    "dropmalst": "IA",
    "dropmalzpp": 501319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153340216,
    "dropsitcph": 5153340186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10769",
    "droptype": "D",
    "dropname": "JOICE",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "JOICE",
    "dropdelst": "IA",
    "dropdelzpp": 504467713,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "JOICE",
    "dropphyst": "IA",
    "dropphyzpp": 504467713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOICE",
    "dropmalst": "IA",
    "dropmalzpp": 504469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412516140,
    "dropsitcph": 6412516140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10770",
    "droptype": "D",
    "dropname": "JOLLEY",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "JOLLEY",
    "dropdelst": "IA",
    "dropdelzpp": 505517568,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "JOLLEY",
    "dropphyst": "IA",
    "dropphyzpp": 505517568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOLLEY",
    "dropmalst": "IA",
    "dropmalzpp": 505519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122975065,
    "dropsitcph": 7122975065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10775",
    "droptype": "D",
    "dropname": "KALONA",
    "dropdeladd": "302 5TH ST",
    "dropdelcty": "KALONA",
    "dropdelst": "IA",
    "dropdelzpp": 522477707,
    "dropphyadd": "302 5TH ST",
    "dropphycty": "KALONA",
    "dropphyst": "IA",
    "dropphyzpp": 522477707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALONA",
    "dropmalst": "IA",
    "dropmalzpp": 522479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196562422,
    "dropsitcph": 3196562422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10776",
    "droptype": "D",
    "dropname": "KAMRAR",
    "dropdeladd": "610 MAPLE ST",
    "dropdelcty": "KAMRAR",
    "dropdelst": "IA",
    "dropdelzpp": 501327705,
    "dropphyadd": "610 MAPLE ST",
    "dropphycty": "KAMRAR",
    "dropphyst": "IA",
    "dropphyzpp": 501327705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAMRAR",
    "dropmalst": "IA",
    "dropmalzpp": 501329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155310039,
    "dropsitcph": 5155310039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10777",
    "droptype": "D",
    "dropname": "KANAWHA",
    "dropdeladd": "221 N MAIN ST",
    "dropdelcty": "KANAWHA",
    "dropdelst": "IA",
    "dropdelzpp": 504477707,
    "dropphyadd": "221 N MAIN ST",
    "dropphycty": "KANAWHA",
    "dropphyst": "IA",
    "dropphyzpp": 504477707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KANAWHA",
    "dropmalst": "IA",
    "dropmalzpp": 504479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417623557,
    "dropsitcph": 6417623557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10778",
    "droptype": "D",
    "dropname": "KELLERTON",
    "dropdeladd": "101 S DECATUR ST",
    "dropdelcty": "KELLERTON",
    "dropdelst": "IA",
    "dropdelzpp": 501333457,
    "dropphyadd": "101 S DECATUR ST",
    "dropphycty": "KELLERTON",
    "dropphyst": "IA",
    "dropphyzpp": 501333457,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLERTON",
    "dropmalst": "IA",
    "dropmalzpp": 501339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417832131,
    "dropsitcph": 6417832131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10780",
    "droptype": "D",
    "dropname": "KELLOGG",
    "dropdeladd": "411 MAIN ST",
    "dropdelcty": "KELLOGG",
    "dropdelst": "IA",
    "dropdelzpp": 501351144,
    "dropphyadd": "411 MAIN ST",
    "dropphycty": "KELLOGG",
    "dropphyst": "IA",
    "dropphyzpp": 501351144,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLOGG",
    "dropmalst": "IA",
    "dropmalzpp": 501359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415263280,
    "dropsitcph": 6415263280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10782",
    "droptype": "D",
    "dropname": "KENSETT",
    "dropdeladd": "511 ELM ST",
    "dropdelcty": "KENSETT",
    "dropdelst": "IA",
    "dropdelzpp": 504487625,
    "dropphyadd": "511 ELM ST",
    "dropphycty": "KENSETT",
    "dropphyst": "IA",
    "dropphyzpp": 504487625,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENSETT",
    "dropmalst": "IA",
    "dropmalzpp": 504489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418452505,
    "dropsitcph": 6418452505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10784",
    "droptype": "D",
    "dropname": "KEOKUK",
    "dropdeladd": "214 S 2ND ST",
    "dropdelcty": "KEOKUK",
    "dropdelst": "IA",
    "dropdelzpp": 526329998,
    "dropphyadd": "214 S 2ND ST",
    "dropphycty": "KEOKUK",
    "dropphyst": "IA",
    "dropphyzpp": 526329998,
    "dropmaladd": "214 S 2ND ST",
    "dropmalcty": "KEOKUK",
    "dropmalst": "IA",
    "dropmalzpp": 526329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3195249923,
    "dropsitcph": 3195249923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10786",
    "droptype": "D",
    "dropname": "KEOSAUQUA",
    "dropdeladd": "807 2ND ST",
    "dropdelcty": "KEOSAUQUA",
    "dropdelst": "IA",
    "dropdelzpp": 525657730,
    "dropphyadd": "807 2ND ST",
    "dropphycty": "KEOSAUQUA",
    "dropphyst": "IA",
    "dropphyzpp": 525657730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEOSAUQUA",
    "dropmalst": "IA",
    "dropmalzpp": 525659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192933298,
    "dropsitcph": 3192933298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10787",
    "droptype": "D",
    "dropname": "KEOTA",
    "dropdeladd": "307 E BROADWAY AVE",
    "dropdelcty": "KEOTA",
    "dropdelst": "IA",
    "dropdelzpp": 522489402,
    "dropphyadd": "307 E BROADWAY AVE",
    "dropphycty": "KEOTA",
    "dropphyst": "IA",
    "dropphyzpp": 522489402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEOTA",
    "dropmalst": "IA",
    "dropmalzpp": 522489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416363700,
    "dropsitcph": 6416363700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10789",
    "droptype": "D",
    "dropname": "KESWICK",
    "dropdeladd": "114 S IRONS ST",
    "dropdelcty": "KESWICK",
    "dropdelst": "IA",
    "dropdelzpp": 501361029,
    "dropphyadd": "114 S IRONS ST",
    "dropphycty": "KESWICK",
    "dropphyst": "IA",
    "dropphyzpp": 501361029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KESWICK",
    "dropmalst": "IA",
    "dropmalzpp": 501369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197383431,
    "dropsitcph": 3197383431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10791",
    "droptype": "D",
    "dropname": "KEYSTONE",
    "dropdeladd": "87 MAIN ST",
    "dropdelcty": "KEYSTONE",
    "dropdelst": "IA",
    "dropdelzpp": 522499998,
    "dropphyadd": "87 MAIN ST",
    "dropphycty": "KEYSTONE",
    "dropphyst": "IA",
    "dropphyzpp": 522499998,
    "dropmaladd": "87 MAIN ST",
    "dropmalcty": "KEYSTONE",
    "dropmalst": "IA",
    "dropmalzpp": 522499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414892065,
    "dropsitcph": 6414892065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10793",
    "droptype": "D",
    "dropname": "KILLDUFF",
    "dropdeladd": "7229 MAIN ST",
    "dropdelcty": "KILLDUFF",
    "dropdelst": "IA",
    "dropdelzpp": 501379900,
    "dropphyadd": "7229 MAIN ST",
    "dropphycty": "KILLDUFF",
    "dropphyst": "IA",
    "dropphyzpp": 501379900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KILLDUFF",
    "dropmalst": "IA",
    "dropmalzpp": 501379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417984696,
    "dropsitcph": 6417984696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10794",
    "droptype": "D",
    "dropname": "KIMBALLTON",
    "dropdeladd": "207 N MAIN ST",
    "dropdelcty": "KIMBALLTON",
    "dropdelst": "IA",
    "dropdelzpp": 515433043,
    "dropphyadd": "207 N MAIN ST",
    "dropphycty": "KIMBALLTON",
    "dropphyst": "IA",
    "dropphyzpp": 515433043,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIMBALLTON",
    "dropmalst": "IA",
    "dropmalzpp": 515439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127735082,
    "dropsitcph": 7127735082,
    "dropfax": 7127735082
  },
  {
    "dcode": "D",
    "dropkey": "PW10795",
    "droptype": "D",
    "dropname": "KINGSLEY",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "KINGSLEY",
    "dropdelst": "IA",
    "dropdelzpp": 510287726,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "KINGSLEY",
    "dropphyst": "IA",
    "dropphyzpp": 510287726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSLEY",
    "dropmalst": "IA",
    "dropmalzpp": 510289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123783711,
    "dropsitcph": 7123783711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10800",
    "droptype": "D",
    "dropname": "KIRKVILLE",
    "dropdeladd": "100 S CEDAR ST",
    "dropdelcty": "KIRKVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525668812,
    "dropphyadd": "100 S CEDAR ST",
    "dropphycty": "KIRKVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525668812,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRKVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159334171,
    "dropsitcph": 5159334171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10801",
    "droptype": "D",
    "dropname": "KIRON",
    "dropdeladd": "134 MAIN ST",
    "dropdelcty": "KIRON",
    "dropdelst": "IA",
    "dropdelzpp": 514487560,
    "dropphyadd": "134 MAIN ST",
    "dropphycty": "KIRON",
    "dropphyst": "IA",
    "dropphyzpp": 514487560,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRON",
    "dropmalst": "IA",
    "dropmalzpp": 514489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126754800,
    "dropsitcph": 7126754800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10802",
    "droptype": "D",
    "dropname": "KLEMME",
    "dropdeladd": "115 E MAIN ST",
    "dropdelcty": "KLEMME",
    "dropdelst": "IA",
    "dropdelzpp": 504499048,
    "dropphyadd": "115 E MAIN ST",
    "dropphycty": "KLEMME",
    "dropphyst": "IA",
    "dropphyzpp": 504499048,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KLEMME",
    "dropmalst": "IA",
    "dropmalzpp": 504499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415872239,
    "dropsitcph": 6415872239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10804",
    "droptype": "D",
    "dropname": "KNIERIM",
    "dropdeladd": "218 CENTER ST",
    "dropdelcty": "KNIERIM",
    "dropdelst": "IA",
    "dropdelzpp": 505525000,
    "dropphyadd": "218 CENTER ST",
    "dropphycty": "KNIERIM",
    "dropphyst": "IA",
    "dropphyzpp": 505525000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KNIERIM",
    "dropmalst": "IA",
    "dropmalzpp": 505529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154632248,
    "dropsitcph": 5154632248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10807",
    "droptype": "D",
    "dropname": "KNOXVILLE",
    "dropdeladd": "201 E MARION ST",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 501382505,
    "dropphyadd": "201 E MARION ST",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 501382505,
    "dropmaladd": "201 E MARION ST",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 501382505,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418422210,
    "dropsitcph": 6418422210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10812",
    "droptype": "D",
    "dropname": "LA MOTTE",
    "dropdeladd": "800 PLEASANT ST",
    "dropdelcty": "LA MOTTE",
    "dropdelst": "IA",
    "dropdelzpp": 520544400,
    "dropphyadd": "800 PLEASANT ST",
    "dropphycty": "LA MOTTE",
    "dropphyst": "IA",
    "dropphyzpp": 520544400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA MOTTE",
    "dropmalst": "IA",
    "dropmalzpp": 520549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637738850,
    "dropsitcph": 5637738850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10813",
    "droptype": "D",
    "dropname": "LA PORTE CITY",
    "dropdeladd": "408 CHESTNUT ST",
    "dropdelcty": "LA PORTE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 506511357,
    "dropphyadd": "408 CHESTNUT ST",
    "dropphycty": "LA PORTE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 506511357,
    "dropmaladd": "408 CHESTNUT ST",
    "dropmalcty": "LA PORTE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 506511357,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193423045,
    "dropsitcph": 3172711754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10816",
    "droptype": "D",
    "dropname": "LACONA",
    "dropdeladd": "104 S WASHINGTON AVE",
    "dropdelcty": "LACONA",
    "dropdelst": "IA",
    "dropdelzpp": 501397705,
    "dropphyadd": "104 S WASHINGTON AVE",
    "dropphycty": "LACONA",
    "dropphyst": "IA",
    "dropphyzpp": 501397705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LACONA",
    "dropmalst": "IA",
    "dropmalzpp": 501399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415344931,
    "dropsitcph": 6415344931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10817",
    "droptype": "D",
    "dropname": "LADORA",
    "dropdeladd": "605 PACIFIC ST",
    "dropdelcty": "LADORA",
    "dropdelst": "IA",
    "dropdelzpp": 522517500,
    "dropphyadd": "605 PACIFIC ST",
    "dropphycty": "LADORA",
    "dropphyst": "IA",
    "dropphyzpp": 522517500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LADORA",
    "dropmalst": "IA",
    "dropmalzpp": 522519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196233242,
    "dropsitcph": 3196233242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10818",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "202 E JEFFERSON ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 514496500,
    "dropphyadd": "202 E JEFFERSON ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 514496500,
    "dropmaladd": "202 E JEFFERSON ST",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 514496500,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124643011,
    "dropsitcph": 7124643011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10819",
    "droptype": "D",
    "dropname": "LAKE MILLS",
    "dropdeladd": "206 N MILL ST",
    "dropdelcty": "LAKE MILLS",
    "dropdelst": "IA",
    "dropdelzpp": 504501350,
    "dropphyadd": "206 N MILL ST",
    "dropphycty": "LAKE MILLS",
    "dropphyst": "IA",
    "dropphyzpp": 504501350,
    "dropmaladd": "206 N MILL ST",
    "dropmalcty": "LAKE MILLS",
    "dropmalst": "IA",
    "dropmalzpp": 504501350,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412516157,
    "dropsitcph": 6412516157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10821",
    "droptype": "D",
    "dropname": "LAKE PARK",
    "dropdeladd": "202 N MARKET ST",
    "dropdelcty": "LAKE PARK",
    "dropdelst": "IA",
    "dropdelzpp": 513477819,
    "dropphyadd": "202 N MARKET ST",
    "dropphycty": "LAKE PARK",
    "dropphyst": "IA",
    "dropphyzpp": 513477819,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE PARK",
    "dropmalst": "IA",
    "dropmalzpp": 513479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128323364,
    "dropsitcph": 7128323364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10822",
    "droptype": "D",
    "dropname": "LAKE VIEW",
    "dropdeladd": "521 3RD ST",
    "dropdelcty": "LAKE VIEW",
    "dropdelst": "IA",
    "dropdelzpp": 514507605,
    "dropphyadd": "521 3RD ST",
    "dropphycty": "LAKE VIEW",
    "dropphyst": "IA",
    "dropphyzpp": 514507605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE VIEW",
    "dropmalst": "IA",
    "dropmalzpp": 514509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126578531,
    "dropsitcph": 7126578531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10826",
    "droptype": "D",
    "dropname": "LAKOTA",
    "dropdeladd": "223 3RD ST",
    "dropdelcty": "LAKOTA",
    "dropdelst": "IA",
    "dropdelzpp": 504517084,
    "dropphyadd": "223 3RD ST",
    "dropphycty": "LAKOTA",
    "dropphyst": "IA",
    "dropphyzpp": 504517084,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKOTA",
    "dropmalst": "IA",
    "dropmalzpp": 504519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158862206,
    "dropsitcph": 5158862206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10828",
    "droptype": "D",
    "dropname": "LAMONI",
    "dropdeladd": "112 N MAPLE ST",
    "dropdelcty": "LAMONI",
    "dropdelst": "IA",
    "dropdelzpp": 501401000,
    "dropphyadd": "112 N MAPLE ST",
    "dropphycty": "LAMONI",
    "dropphyst": "IA",
    "dropphyzpp": 501401000,
    "dropmaladd": "112 N MAPLE ST",
    "dropmalcty": "LAMONI",
    "dropmalst": "IA",
    "dropmalzpp": 501401000,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417846428,
    "dropsitcph": 6417846428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10829",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "620 BUSH ST",
    "dropdelcty": "LAMONT",
    "dropdelst": "IA",
    "dropdelzpp": 506509041,
    "dropphyadd": "620 BUSH ST",
    "dropphycty": "LAMONT",
    "dropphyst": "IA",
    "dropphyzpp": 506509041,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAMONT",
    "dropmalst": "IA",
    "dropmalzpp": 506509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639242035,
    "dropsitcph": 5639242035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10832",
    "droptype": "D",
    "dropname": "LANESBORO",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "LANESBORO",
    "dropdelst": "IA",
    "dropdelzpp": 514517704,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "LANESBORO",
    "dropphyst": "IA",
    "dropphyzpp": 514517704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANESBORO",
    "dropmalst": "IA",
    "dropmalzpp": 514519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126562222,
    "dropsitcph": 7126562222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10836",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "383 MAIN ST",
    "dropdelcty": "LANSING",
    "dropdelst": "IA",
    "dropdelzpp": 521514400,
    "dropphyadd": "383 MAIN ST",
    "dropphycty": "LANSING",
    "dropphyst": "IA",
    "dropphyzpp": 521514400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANSING",
    "dropmalst": "IA",
    "dropmalzpp": 521519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635384767,
    "dropsitcph": 5635384767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10838",
    "droptype": "D",
    "dropname": "LARCHWOOD",
    "dropdeladd": "935 BROADWAY ST",
    "dropdelcty": "LARCHWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 512417765,
    "dropphyadd": "935 BROADWAY ST",
    "dropphycty": "LARCHWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 512417765,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LARCHWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 512419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124772323,
    "dropsitcph": 7124772323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10839",
    "droptype": "D",
    "dropname": "LARRABEE",
    "dropdeladd": "116 N MAIN ST",
    "dropdelcty": "LARRABEE",
    "dropdelst": "IA",
    "dropdelzpp": 510297717,
    "dropphyadd": "116 N MAIN ST",
    "dropphycty": "LARRABEE",
    "dropphyst": "IA",
    "dropphyzpp": 510297717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LARRABEE",
    "dropmalst": "IA",
    "dropmalzpp": 510299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124372293,
    "dropsitcph": 7124372293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10841",
    "droptype": "D",
    "dropname": "LATIMER",
    "dropdeladd": "102 N AKIR ST",
    "dropdelcty": "LATIMER",
    "dropdelst": "IA",
    "dropdelzpp": 504527591,
    "dropphyadd": "102 N AKIR ST",
    "dropphycty": "LATIMER",
    "dropphyst": "IA",
    "dropphyzpp": 504527591,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LATIMER",
    "dropmalst": "IA",
    "dropmalzpp": 504529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415796254,
    "dropsitcph": 6415796254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10843",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "104 W MARKET ST",
    "dropdelcty": "LAUREL",
    "dropdelst": "IA",
    "dropdelzpp": 501417734,
    "dropphyadd": "104 W MARKET ST",
    "dropphycty": "LAUREL",
    "dropphyst": "IA",
    "dropphyzpp": 501417734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUREL",
    "dropmalst": "IA",
    "dropmalzpp": 501419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414763413,
    "dropsitcph": 6414763413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10844",
    "droptype": "D",
    "dropname": "LAURENS",
    "dropdeladd": "316 W MAIN ST",
    "dropdelcty": "LAURENS",
    "dropdelst": "IA",
    "dropdelzpp": 505541367,
    "dropphyadd": "316 W MAIN ST",
    "dropphycty": "LAURENS",
    "dropphyst": "IA",
    "dropphyzpp": 505541367,
    "dropmaladd": "316 W MAIN ST",
    "dropmalcty": "LAURENS",
    "dropmalst": "IA",
    "dropmalzpp": 505541367,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128454910,
    "dropsitcph": 7128454910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10846",
    "droptype": "D",
    "dropname": "LAWLER",
    "dropdeladd": "316 E GROVE ST",
    "dropdelcty": "LAWLER",
    "dropdelst": "IA",
    "dropdelzpp": 521544400,
    "dropphyadd": "316 E GROVE ST",
    "dropphycty": "LAWLER",
    "dropphyst": "IA",
    "dropphyzpp": 521544400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWLER",
    "dropmalst": "IA",
    "dropmalzpp": 521549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632383971,
    "dropsitcph": 5632383971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10848",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "314 CEDAR ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "IA",
    "dropdelzpp": 510307721,
    "dropphyadd": "314 CEDAR ST",
    "dropphycty": "LAWTON",
    "dropphyst": "IA",
    "dropphyzpp": 510307721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWTON",
    "dropmalst": "IA",
    "dropmalzpp": 510309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129445500,
    "dropsitcph": 7129445500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10849",
    "droptype": "D",
    "dropname": "LE CLAIRE",
    "dropdeladd": "310 JONES ST",
    "dropdelcty": "LE CLAIRE",
    "dropdelst": "IA",
    "dropdelzpp": 527539680,
    "dropphyadd": "310 JONES ST",
    "dropphycty": "LE CLAIRE",
    "dropphyst": "IA",
    "dropphyzpp": 527539680,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LE CLAIRE",
    "dropmalst": "IA",
    "dropmalzpp": 527539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632842487,
    "dropsitcph": 5632842487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10850",
    "droptype": "D",
    "dropname": "LE GRAND",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "LE GRAND",
    "dropdelst": "IA",
    "dropdelzpp": 501427807,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "LE GRAND",
    "dropphyst": "IA",
    "dropphyzpp": 501427807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LE GRAND",
    "dropmalst": "IA",
    "dropmalzpp": 501429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414792613,
    "dropsitcph": 6414792613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10851",
    "droptype": "D",
    "dropname": "LE MARS",
    "dropdeladd": "230 1ST ST NW",
    "dropdelcty": "LE MARS",
    "dropdelst": "IA",
    "dropdelzpp": 510313404,
    "dropphyadd": "230 1ST ST NW",
    "dropphycty": "LE MARS",
    "dropphyst": "IA",
    "dropphyzpp": 510319998,
    "dropmaladd": "230 1ST ST NW",
    "dropmalcty": "LE MARS",
    "dropmalst": "IA",
    "dropmalzpp": 510319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125464313,
    "dropsitcph": 7125464313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10856",
    "droptype": "D",
    "dropname": "LEDYARD",
    "dropdeladd": "217 EDMUNDS ST",
    "dropdelcty": "LEDYARD",
    "dropdelst": "IA",
    "dropdelzpp": 505567716,
    "dropphyadd": "217 EDMUNDS ST",
    "dropphycty": "LEDYARD",
    "dropphyst": "IA",
    "dropphyzpp": 505567716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEDYARD",
    "dropmalst": "IA",
    "dropmalzpp": 505569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156462744,
    "dropsitcph": 5156462744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10859",
    "droptype": "D",
    "dropname": "LEHIGH",
    "dropdeladd": "131 MAIN ST",
    "dropdelcty": "LEHIGH",
    "dropdelst": "IA",
    "dropdelzpp": 505577596,
    "dropphyadd": "131 MAIN ST",
    "dropphycty": "LEHIGH",
    "dropphyst": "IA",
    "dropphyzpp": 505577596,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEHIGH",
    "dropmalst": "IA",
    "dropmalzpp": 505579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153592313,
    "dropsitcph": 5153592313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10860",
    "droptype": "D",
    "dropname": "LEIGHTON",
    "dropdeladd": "219 OTLEY ST",
    "dropdelcty": "LEIGHTON",
    "dropdelst": "IA",
    "dropdelzpp": 501437701,
    "dropphyadd": "219 OTLEY ST",
    "dropphycty": "LEIGHTON",
    "dropphyst": "IA",
    "dropphyzpp": 501437701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEIGHTON",
    "dropmalst": "IA",
    "dropmalzpp": 501439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416263107,
    "dropsitcph": 6416263107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10861",
    "droptype": "D",
    "dropname": "LELAND",
    "dropdeladd": "212 W BROADWAY",
    "dropdelcty": "LELAND",
    "dropdelst": "IA",
    "dropdelzpp": 504537470,
    "dropphyadd": "212 W BROADWAY",
    "dropphycty": "LELAND",
    "dropphyst": "IA",
    "dropphyzpp": 504537470,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LELAND",
    "dropmalst": "IA",
    "dropmalzpp": 504539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415673580,
    "dropsitcph": 6415673580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10863",
    "droptype": "D",
    "dropname": "LENOX",
    "dropdeladd": "110 W TEMPLE ST",
    "dropdelcty": "LENOX",
    "dropdelst": "IA",
    "dropdelzpp": 508511248,
    "dropphyadd": "110 W TEMPLE ST",
    "dropphycty": "LENOX",
    "dropphyst": "IA",
    "dropphyzpp": 508511248,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LENOX",
    "dropmalst": "IA",
    "dropmalzpp": 508519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413334193,
    "dropsitcph": 6413334193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10864",
    "droptype": "D",
    "dropname": "LEON",
    "dropdeladd": "109 NE 2ND ST",
    "dropdelcty": "LEON",
    "dropdelst": "IA",
    "dropdelzpp": 501449998,
    "dropphyadd": "109 NE 2ND ST",
    "dropphycty": "LEON",
    "dropphyst": "IA",
    "dropphyzpp": 501449998,
    "dropmaladd": "109 NE 2ND ST",
    "dropmalcty": "LEON",
    "dropmalst": "IA",
    "dropmalzpp": 501449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414464732,
    "dropsitcph": 6414464732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10865",
    "droptype": "D",
    "dropname": "LESTER",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "LESTER",
    "dropdelst": "IA",
    "dropdelzpp": 512427700,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "LESTER",
    "dropphyst": "IA",
    "dropphyzpp": 512427700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LESTER",
    "dropmalst": "IA",
    "dropmalzpp": 512429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124784321,
    "dropsitcph": 7124784321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10866",
    "droptype": "D",
    "dropname": "LETTS",
    "dropdeladd": "105 S CHERRY ST",
    "dropdelcty": "LETTS",
    "dropdelst": "IA",
    "dropdelzpp": 527549702,
    "dropphyadd": "105 S CHERRY ST",
    "dropphycty": "LETTS",
    "dropphyst": "IA",
    "dropphyzpp": 527549702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LETTS",
    "dropmalst": "IA",
    "dropmalzpp": 527549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197264691,
    "dropsitcph": 3197264691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10867",
    "droptype": "D",
    "dropname": "LEWIS",
    "dropdeladd": "501 W MAIN ST",
    "dropdelcty": "LEWIS",
    "dropdelst": "IA",
    "dropdelzpp": 515445536,
    "dropphyadd": "501 W MAIN ST",
    "dropphycty": "LEWIS",
    "dropphyst": "IA",
    "dropphyzpp": 515445536,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWIS",
    "dropmalst": "IA",
    "dropmalzpp": 515449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127692357,
    "dropsitcph": 7127692357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10869",
    "droptype": "D",
    "dropname": "LIBERTY CENTER",
    "dropdeladd": "21979 160TH AVE",
    "dropdelcty": "LIBERTY CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 501457709,
    "dropphyadd": "21979 160TH AVE",
    "dropphycty": "LIBERTY CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 501457709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTY CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 501459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414663313,
    "dropsitcph": 6414663313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10870",
    "droptype": "D",
    "dropname": "LIBERTYVILLE",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "LIBERTYVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525677754,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "LIBERTYVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525677754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTYVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416934451,
    "dropsitcph": 6416934451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10871",
    "droptype": "D",
    "dropname": "LIDDERDALE",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "LIDDERDALE",
    "dropdelst": "IA",
    "dropdelzpp": 514527700,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "LIDDERDALE",
    "dropphyst": "IA",
    "dropphyzpp": 514527700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIDDERDALE",
    "dropmalst": "IA",
    "dropmalzpp": 514529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128225314,
    "dropsitcph": 7128225314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10876",
    "droptype": "D",
    "dropname": "LIME SPRINGS",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "LIME SPRINGS",
    "dropdelst": "IA",
    "dropdelzpp": 521554400,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "LIME SPRINGS",
    "dropphyst": "IA",
    "dropphyzpp": 521554400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIME SPRINGS",
    "dropmalst": "IA",
    "dropmalzpp": 521559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635662300,
    "dropsitcph": 5635662300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10877",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "IA",
    "dropdelzpp": 506525000,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "IA",
    "dropphyzpp": 506525000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "IA",
    "dropmalzpp": 506529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414733142,
    "dropsitcph": 6414733142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10878",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "133 S MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "IA",
    "dropdelzpp": 501467701,
    "dropphyadd": "133 S MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "IA",
    "dropphyzpp": 501467701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINDEN",
    "dropmalst": "IA",
    "dropmalzpp": 501469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417442770,
    "dropsitcph": 6417442770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10879",
    "droptype": "D",
    "dropname": "LINEVILLE",
    "dropdeladd": "220 BROWN ST",
    "dropdelcty": "LINEVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 501477701,
    "dropphyadd": "220 BROWN ST",
    "dropphycty": "LINEVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 501477701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINEVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 501479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6428742026,
    "dropsitcph": 6428742026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10880",
    "droptype": "D",
    "dropname": "LINN GROVE",
    "dropdeladd": "130 WEAVER ST",
    "dropdelcty": "LINN GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 510331019,
    "dropphyadd": "130 WEAVER ST",
    "dropphycty": "LINN GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 510331019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINN GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 510339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122963265,
    "dropsitcph": 7122963265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10882",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "129 W MAIN ST",
    "dropdelcty": "LISBON",
    "dropdelst": "IA",
    "dropdelzpp": 522539693,
    "dropphyadd": "129 W MAIN ST",
    "dropphycty": "LISBON",
    "dropphyst": "IA",
    "dropphyzpp": 522539693,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LISBON",
    "dropmalst": "IA",
    "dropmalzpp": 522539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194552525,
    "dropsitcph": 3194552525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10883",
    "droptype": "D",
    "dropname": "LISCOMB",
    "dropdeladd": "109 MAIN ST",
    "dropdelcty": "LISCOMB",
    "dropdelst": "IA",
    "dropdelzpp": 501487733,
    "dropphyadd": "109 MAIN ST",
    "dropphycty": "LISCOMB",
    "dropphyst": "IA",
    "dropphyzpp": 501487733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LISCOMB",
    "dropmalst": "IA",
    "dropmalzpp": 501489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414965390,
    "dropsitcph": 6414965390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10885",
    "droptype": "D",
    "dropname": "LITTLE ROCK",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "IA",
    "dropdelzpp": 512437701,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "IA",
    "dropphyzpp": 512437701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "IA",
    "dropmalzpp": 512439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124792263,
    "dropsitcph": 7124792263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10890",
    "droptype": "D",
    "dropname": "LIVERMORE",
    "dropdeladd": "407 4TH AVE",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "IA",
    "dropdelzpp": 505589541,
    "dropphyadd": "407 4TH AVE",
    "dropphycty": "LIVERMORE",
    "dropphyst": "IA",
    "dropphyzpp": 505589541,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "IA",
    "dropmalzpp": 505589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153791325,
    "dropsitcph": 5153791325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10892",
    "droptype": "D",
    "dropname": "LOCKRIDGE",
    "dropdeladd": "103 S CENTER ST",
    "dropdelcty": "LOCKRIDGE",
    "dropdelst": "IA",
    "dropdelzpp": 526359756,
    "dropphyadd": "103 S CENTER ST",
    "dropphycty": "LOCKRIDGE",
    "dropphyst": "IA",
    "dropphyzpp": 526359756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCKRIDGE",
    "dropmalst": "IA",
    "dropmalzpp": 526359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196962811,
    "dropsitcph": 3196962811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10894",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "315 E 6TH ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "IA",
    "dropdelzpp": 515469998,
    "dropphyadd": "315 E 6TH ST",
    "dropphycty": "LOGAN",
    "dropphyst": "IA",
    "dropphyzpp": 515469998,
    "dropmaladd": "315 E 6TH ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "IA",
    "dropmalzpp": 515469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126443100,
    "dropsitcph": 7126443100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10896",
    "droptype": "D",
    "dropname": "LOHRVILLE",
    "dropdeladd": "416 2ND ST",
    "dropdelcty": "LOHRVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 514531060,
    "dropphyadd": "416 2ND ST",
    "dropphycty": "LOHRVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 514531060,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOHRVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 514539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124654615,
    "dropsitcph": 7124654615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10897",
    "droptype": "D",
    "dropname": "LONE ROCK",
    "dropdeladd": "209 MAINE ST",
    "dropdelcty": "LONE ROCK",
    "dropdelst": "IA",
    "dropdelzpp": 505598566,
    "dropphyadd": "209 MAINE ST",
    "dropphycty": "LONE ROCK",
    "dropphyst": "IA",
    "dropphyzpp": 505598566,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONE ROCK",
    "dropmalst": "IA",
    "dropmalzpp": 505599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159253288,
    "dropsitcph": 5159253288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10898",
    "droptype": "D",
    "dropname": "LONE TREE",
    "dropdeladd": "104 N DEVOE ST",
    "dropdelcty": "LONE TREE",
    "dropdelst": "IA",
    "dropdelzpp": 527557742,
    "dropphyadd": "104 N DEVOE ST",
    "dropphycty": "LONE TREE",
    "dropphyst": "IA",
    "dropphyzpp": 527557742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONE TREE",
    "dropmalst": "IA",
    "dropmalzpp": 527559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196295231,
    "dropsitcph": 3196295231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10899",
    "droptype": "D",
    "dropname": "LONG GROVE",
    "dropdeladd": "123 S 1ST ST",
    "dropdelcty": "LONG GROVE",
    "dropdelst": "IA",
    "dropdelzpp": 527569998,
    "dropphyadd": "123 S 1ST ST",
    "dropphycty": "LONG GROVE",
    "dropphyst": "IA",
    "dropphyzpp": 527569998,
    "dropmaladd": "123 S 1ST ST",
    "dropmalcty": "LONG GROVE",
    "dropmalst": "IA",
    "dropmalzpp": 527569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632854722,
    "dropsitcph": 5632854722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10901",
    "droptype": "D",
    "dropname": "LORIMOR",
    "dropdeladd": "512 MAIN ST",
    "dropdelcty": "LORIMOR",
    "dropdelst": "IA",
    "dropdelzpp": 501491060,
    "dropphyadd": "512 MAIN ST",
    "dropphycty": "LORIMOR",
    "dropphyst": "IA",
    "dropphyzpp": 501491060,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LORIMOR",
    "dropmalst": "IA",
    "dropmalzpp": 501499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417632119,
    "dropsitcph": 6417632119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10903",
    "droptype": "D",
    "dropname": "LOST NATION",
    "dropdeladd": "415 MAIN ST",
    "dropdelcty": "LOST NATION",
    "dropdelst": "IA",
    "dropdelzpp": 522549696,
    "dropphyadd": "415 MAIN ST",
    "dropphycty": "LOST NATION",
    "dropphyst": "IA",
    "dropphyzpp": 522549696,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOST NATION",
    "dropmalst": "IA",
    "dropmalzpp": 522549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636782223,
    "dropsitcph": 5636782223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10906",
    "droptype": "D",
    "dropname": "LOVILIA",
    "dropdeladd": "1712 S E AVE",
    "dropdelcty": "LOVILIA",
    "dropdelst": "IA",
    "dropdelzpp": 501501013,
    "dropphyadd": "1712 S E AVE",
    "dropphycty": "LOVILIA",
    "dropphyst": "IA",
    "dropphyzpp": 501501013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOVILIA",
    "dropmalst": "IA",
    "dropmalzpp": 501509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419468131,
    "dropsitcph": 6419468131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10908",
    "droptype": "D",
    "dropname": "LOW MOOR",
    "dropdeladd": "207 3RD ST",
    "dropdelcty": "LOW MOOR",
    "dropdelst": "IA",
    "dropdelzpp": 527579000,
    "dropphyadd": "207 3RD ST",
    "dropphycty": "LOW MOOR",
    "dropphyst": "IA",
    "dropphyzpp": 527579000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOW MOOR",
    "dropmalst": "IA",
    "dropmalzpp": 527579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635222112,
    "dropsitcph": 5635222112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10909",
    "droptype": "D",
    "dropname": "LOWDEN",
    "dropdeladd": "308 WASHINGTON AVE",
    "dropdelcty": "LOWDEN",
    "dropdelst": "IA",
    "dropdelzpp": 522559613,
    "dropphyadd": "308 WASHINGTON AVE",
    "dropphycty": "LOWDEN",
    "dropphyst": "IA",
    "dropphyzpp": 522559613,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWDEN",
    "dropmalst": "IA",
    "dropmalzpp": 522559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639417775,
    "dropsitcph": 5639417775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10911",
    "droptype": "D",
    "dropname": "LU VERNE",
    "dropdeladd": "109 DEWITT ST",
    "dropdelcty": "LU VERNE",
    "dropdelst": "IA",
    "dropdelzpp": 505605006,
    "dropphyadd": "109 DEWITT ST",
    "dropphycty": "LU VERNE",
    "dropphyst": "IA",
    "dropphyzpp": 505605006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LU VERNE",
    "dropmalst": "IA",
    "dropmalzpp": 505609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158823428,
    "dropsitcph": 5158823428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10912",
    "droptype": "D",
    "dropname": "LUANA",
    "dropdeladd": "105 BURGES ST",
    "dropdelcty": "LUANA",
    "dropdelst": "IA",
    "dropdelzpp": 521564400,
    "dropphyadd": "105 BURGES ST",
    "dropphycty": "LUANA",
    "dropphyst": "IA",
    "dropphyzpp": 521564400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUANA",
    "dropmalst": "IA",
    "dropmalzpp": 521569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635392263,
    "dropsitcph": 5635392263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10913",
    "droptype": "D",
    "dropname": "LUCAS",
    "dropdeladd": "106 E FRONT ST",
    "dropdelcty": "LUCAS",
    "dropdelst": "IA",
    "dropdelzpp": 501519617,
    "dropphyadd": "106 E FRONT ST",
    "dropphycty": "LUCAS",
    "dropphyst": "IA",
    "dropphyzpp": 501519617,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCAS",
    "dropmalst": "IA",
    "dropmalzpp": 501519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417666822,
    "dropsitcph": 6417666822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10918",
    "droptype": "D",
    "dropname": "LUXEMBURG",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "LUXEMBURG",
    "dropdelst": "IA",
    "dropdelzpp": 520564400,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "LUXEMBURG",
    "dropphyst": "IA",
    "dropphyzpp": 520564400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUXEMBURG",
    "dropmalst": "IA",
    "dropmalzpp": 520569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638532109,
    "dropsitcph": 5638532109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10920",
    "droptype": "D",
    "dropname": "LYNNVILLE",
    "dropdeladd": "409 EAST ST",
    "dropdelcty": "LYNNVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 501538553,
    "dropphyadd": "409 EAST ST",
    "dropphycty": "LYNNVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 501538553,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNNVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 501539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415273131,
    "dropsitcph": 6415273131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10924",
    "droptype": "D",
    "dropname": "LYTTON",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "LYTTON",
    "dropdelst": "IA",
    "dropdelzpp": 505617556,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "LYTTON",
    "dropphyst": "IA",
    "dropphyzpp": 505617556,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYTTON",
    "dropmalst": "IA",
    "dropmalzpp": 505619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124662277,
    "dropsitcph": 7124662277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10925",
    "droptype": "D",
    "dropname": "MACEDONIA",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "MACEDONIA",
    "dropdelst": "IA",
    "dropdelzpp": 515493002,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "MACEDONIA",
    "dropphyst": "IA",
    "dropphyzpp": 515493002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACEDONIA",
    "dropmalst": "IA",
    "dropmalzpp": 515499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124862560,
    "dropsitcph": 7124862560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10927",
    "droptype": "D",
    "dropname": "MACKSBURG",
    "dropdeladd": "104 E NORTH ST",
    "dropdelcty": "MACKSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 501551020,
    "dropphyadd": "104 E NORTH ST",
    "dropphycty": "MACKSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 501551020,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACKSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 501559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417682465,
    "dropsitcph": 6417682465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10929",
    "droptype": "D",
    "dropname": "MADRID",
    "dropdeladd": "232 S MAIN ST",
    "dropdelcty": "MADRID",
    "dropdelst": "IA",
    "dropdelzpp": 501561225,
    "dropphyadd": "232 S MAIN ST",
    "dropphycty": "MADRID",
    "dropphyst": "IA",
    "dropphyzpp": 501561225,
    "dropmaladd": "232 S MAIN ST",
    "dropmalcty": "MADRID",
    "dropmalst": "IA",
    "dropmalzpp": 501561225,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157840288,
    "dropsitcph": 5157840288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10932",
    "droptype": "D",
    "dropname": "MALCOM",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "MALCOM",
    "dropdelst": "IA",
    "dropdelzpp": 501577706,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "MALCOM",
    "dropphyst": "IA",
    "dropphyzpp": 501577706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALCOM",
    "dropmalst": "IA",
    "dropmalzpp": 501579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415282965,
    "dropsitcph": 6415282965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10936",
    "droptype": "D",
    "dropname": "MALVERN",
    "dropdeladd": "202 W 4TH ST",
    "dropdelcty": "MALVERN",
    "dropdelst": "IA",
    "dropdelzpp": 515514092,
    "dropphyadd": "202 W 4TH ST",
    "dropphycty": "MALVERN",
    "dropphyst": "IA",
    "dropphyzpp": 515514092,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALVERN",
    "dropmalst": "IA",
    "dropmalzpp": 515519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126248519,
    "dropsitcph": 7126248519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10938",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "116 E DELAWARE ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "IA",
    "dropdelzpp": 520572209,
    "dropphyadd": "116 E DELAWARE ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "IA",
    "dropphyzpp": 520572209,
    "dropmaladd": "116 E DELAWARE ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "IA",
    "dropmalzpp": 520572209,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639274700,
    "dropsitcph": 5639274700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10939",
    "droptype": "D",
    "dropname": "MANILLA",
    "dropdeladd": "348 4TH ST",
    "dropdelcty": "MANILLA",
    "dropdelst": "IA",
    "dropdelzpp": 514547636,
    "dropphyadd": "348 4TH ST",
    "dropphycty": "MANILLA",
    "dropphyst": "IA",
    "dropphyzpp": 514547636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANILLA",
    "dropmalst": "IA",
    "dropmalzpp": 514549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126549561,
    "dropsitcph": 7126549561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10940",
    "droptype": "D",
    "dropname": "MANLY",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "MANLY",
    "dropdelst": "IA",
    "dropdelzpp": 504567717,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "MANLY",
    "dropphyst": "IA",
    "dropphyzpp": 504567717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANLY",
    "dropmalst": "IA",
    "dropmalzpp": 504569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414542860,
    "dropsitcph": 6414542860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10941",
    "droptype": "D",
    "dropname": "MANNING",
    "dropdeladd": "216 MAIN ST",
    "dropdelcty": "MANNING",
    "dropdelst": "IA",
    "dropdelzpp": 514556500,
    "dropphyadd": "216 MAIN ST",
    "dropphycty": "MANNING",
    "dropphyst": "IA",
    "dropphyzpp": 514556500,
    "dropmaladd": "216 MAIN ST",
    "dropmalcty": "MANNING",
    "dropmalst": "IA",
    "dropmalzpp": 514556500,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126533414,
    "dropsitcph": 7126533414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10942",
    "droptype": "D",
    "dropname": "MANSON",
    "dropdeladd": "1006 11TH ST",
    "dropdelcty": "MANSON",
    "dropdelst": "IA",
    "dropdelzpp": 505635029,
    "dropphyadd": "1006 11TH ST",
    "dropphycty": "MANSON",
    "dropphyst": "IA",
    "dropphyzpp": 505635029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANSON",
    "dropmalst": "IA",
    "dropmalzpp": 505639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124693714,
    "dropsitcph": 7124693714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10946",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "106 S 5TH ST",
    "dropdelcty": "MAPLETON",
    "dropdelst": "IA",
    "dropdelzpp": 510346401,
    "dropphyadd": "106 S 5TH ST",
    "dropphycty": "MAPLETON",
    "dropphyst": "IA",
    "dropphyzpp": 510346401,
    "dropmaladd": "106 S 5TH ST",
    "dropmalcty": "MAPLETON",
    "dropmalst": "IA",
    "dropmalzpp": 510346401,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128822545,
    "dropsitcph": 7128822545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10947",
    "droptype": "D",
    "dropname": "MAQUOKETA",
    "dropdeladd": "208 N MAIN ST",
    "dropdelcty": "MAQUOKETA",
    "dropdelst": "IA",
    "dropdelzpp": 520609998,
    "dropphyadd": "208 N MAIN ST",
    "dropphycty": "MAQUOKETA",
    "dropphyst": "IA",
    "dropphyzpp": 520609998,
    "dropmaladd": "208 N MAIN ST",
    "dropmalcty": "MAQUOKETA",
    "dropmalst": "IA",
    "dropmalzpp": 520609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636524160,
    "dropsitcph": 5636524160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10948",
    "droptype": "D",
    "dropname": "MARATHON",
    "dropdeladd": "114 AGORA ST",
    "dropdelcty": "MARATHON",
    "dropdelst": "IA",
    "dropdelzpp": 505655005,
    "dropphyadd": "114 AGORA ST",
    "dropphycty": "MARATHON",
    "dropphyst": "IA",
    "dropphyzpp": 505655005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARATHON",
    "dropmalst": "IA",
    "dropmalzpp": 505659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122896101,
    "dropsitcph": 7122896101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10949",
    "droptype": "D",
    "dropname": "MARBLE ROCK",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "MARBLE ROCK",
    "dropdelst": "IA",
    "dropdelzpp": 506539998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "MARBLE ROCK",
    "dropphyst": "IA",
    "dropphyzpp": 506539998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "MARBLE ROCK",
    "dropmalst": "IA",
    "dropmalzpp": 506539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413974400,
    "dropsitcph": 6413974400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10950",
    "droptype": "D",
    "dropname": "MARCUS",
    "dropdeladd": "108 E PINE ST",
    "dropdelcty": "MARCUS",
    "dropdelst": "IA",
    "dropdelzpp": 510357820,
    "dropphyadd": "108 E PINE ST",
    "dropphycty": "MARCUS",
    "dropphyst": "IA",
    "dropphyzpp": 510357820,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARCUS",
    "dropmalst": "IA",
    "dropmalzpp": 510359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123764315,
    "dropsitcph": 7123764315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10951",
    "droptype": "D",
    "dropname": "MARENGO",
    "dropdeladd": "198 W WASHINGTON ST",
    "dropdelcty": "MARENGO",
    "dropdelst": "IA",
    "dropdelzpp": 523011459,
    "dropphyadd": "198 W WASHINGTON ST",
    "dropphycty": "MARENGO",
    "dropphyst": "IA",
    "dropphyzpp": 523011459,
    "dropmaladd": "198 W WASHINGTON ST",
    "dropmalcty": "MARENGO",
    "dropmalst": "IA",
    "dropmalzpp": 523011459,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196423231,
    "dropsitcph": 3196423231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10953",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "3800 BUSINESS HIGHWAY 151",
    "dropdelcty": "MARION",
    "dropdelst": "IA",
    "dropdelzpp": 523029998,
    "dropphyadd": "3800 BUSINESS HIGHWAY 151",
    "dropphycty": "MARION",
    "dropphyst": "IA",
    "dropphyzpp": 523029998,
    "dropmaladd": "3800 BUSINESS HIGHWAY 151",
    "dropmalcty": "MARION",
    "dropmalst": "IA",
    "dropmalzpp": 523029998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193772818,
    "dropsitcph": 3193772818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10955",
    "droptype": "D",
    "dropname": "MARNE",
    "dropdeladd": "202 WASHINGTON ST",
    "dropdelcty": "MARNE",
    "dropdelst": "IA",
    "dropdelzpp": 515522528,
    "dropphyadd": "202 WASHINGTON ST",
    "dropphycty": "MARNE",
    "dropphyst": "IA",
    "dropphyzpp": 515522528,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARNE",
    "dropmalst": "IA",
    "dropmalzpp": 515529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127812347,
    "dropsitcph": 7127812347,
    "dropfax": 7127812347
  },
  {
    "dcode": "D",
    "dropkey": "PW10956",
    "droptype": "D",
    "dropname": "MARQUETTE",
    "dropdeladd": "112 NORTH ST",
    "dropdelcty": "MARQUETTE",
    "dropdelst": "IA",
    "dropdelzpp": 521584400,
    "dropphyadd": "112 NORTH ST",
    "dropphycty": "MARQUETTE",
    "dropphyst": "IA",
    "dropphyzpp": 521584400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARQUETTE",
    "dropmalst": "IA",
    "dropmalzpp": 521589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638732338,
    "dropsitcph": 5638732338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10958",
    "droptype": "D",
    "dropname": "MARSHALLTOWN",
    "dropdeladd": "309 E LINN ST",
    "dropdelcty": "MARSHALLTOWN",
    "dropdelst": "IA",
    "dropdelzpp": 501589998,
    "dropphyadd": "309 E LINN ST",
    "dropphycty": "MARSHALLTOWN",
    "dropphyst": "IA",
    "dropphyzpp": 501589998,
    "dropmaladd": "309 E LINN ST",
    "dropmalcty": "MARSHALLTOWN",
    "dropmalst": "IA",
    "dropmalzpp": 501589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417586120,
    "dropsitcph": 6417525841,
    "dropfax": 6417586122
  },
  {
    "dcode": "D",
    "dropkey": "PW10959",
    "droptype": "D",
    "dropname": "MARTELLE",
    "dropdeladd": "204 S MILITARY ST",
    "dropdelcty": "MARTELLE",
    "dropdelst": "IA",
    "dropdelzpp": 523058800,
    "dropphyadd": "204 S MILITARY ST",
    "dropphycty": "MARTELLE",
    "dropphyst": "IA",
    "dropphyzpp": 523058800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTELLE",
    "dropmalst": "IA",
    "dropmalzpp": 523059998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194823181,
    "dropsitcph": 3194823181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10960",
    "droptype": "D",
    "dropname": "MARTENSDALE",
    "dropdeladd": "400 IOWA AVE",
    "dropdelcty": "MARTENSDALE",
    "dropdelst": "IA",
    "dropdelzpp": 501607719,
    "dropphyadd": "400 IOWA AVE",
    "dropphycty": "MARTENSDALE",
    "dropphyst": "IA",
    "dropphyzpp": 501607719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTENSDALE",
    "dropmalst": "IA",
    "dropmalzpp": 501609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417642713,
    "dropsitcph": 6417642713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10961",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "605 MAIN ST",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 525687714,
    "dropphyadd": "605 MAIN ST",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 525687714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 525689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416612531,
    "dropsitcph": 6416612531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10966",
    "droptype": "D",
    "dropname": "MASON CITY",
    "dropdeladd": "211 N DELAWARE AVE STE 100",
    "dropdelcty": "MASON CITY",
    "dropdelst": "IA",
    "dropdelzpp": 504019998,
    "dropphyadd": "211 N DELAWARE AVE STE 100",
    "dropphycty": "MASON CITY",
    "dropphyst": "IA",
    "dropphyzpp": 504019998,
    "dropmaladd": "211 N DELAWARE AVE STE 100",
    "dropmalcty": "MASON CITY",
    "dropmalst": "IA",
    "dropmalzpp": 504019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414231860,
    "dropsitcph": 6414235231,
    "dropfax": 6414236918
  },
  {
    "dcode": "D",
    "dropkey": "PW10968",
    "droptype": "D",
    "dropname": "MASONVILLE",
    "dropdeladd": "504 BARRETT ST",
    "dropdelcty": "MASONVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 506548533,
    "dropphyadd": "504 BARRETT ST",
    "dropphycty": "MASONVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 506548533,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASONVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 506549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639275814,
    "dropsitcph": 5639275814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10969",
    "droptype": "D",
    "dropname": "MASSENA",
    "dropdeladd": "99 MAIN ST",
    "dropdelcty": "MASSENA",
    "dropdelst": "IA",
    "dropdelzpp": 508531016,
    "dropphyadd": "99 MAIN ST",
    "dropphycty": "MASSENA",
    "dropphyst": "IA",
    "dropphyzpp": 508531016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASSENA",
    "dropmalst": "IA",
    "dropmalzpp": 508539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127793357,
    "dropsitcph": 7127793357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10973",
    "droptype": "D",
    "dropname": "MAURICE",
    "dropdeladd": "410 2ND ST",
    "dropdelcty": "MAURICE",
    "dropdelst": "IA",
    "dropdelzpp": 510367731,
    "dropphyadd": "410 2ND ST",
    "dropphycty": "MAURICE",
    "dropphyst": "IA",
    "dropphyzpp": 510367731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAURICE",
    "dropmalst": "IA",
    "dropmalzpp": 510369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125675821,
    "dropsitcph": 7125675821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10974",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "85 MAIN ST",
    "dropdelcty": "MAXWELL",
    "dropdelst": "IA",
    "dropdelzpp": 501617722,
    "dropphyadd": "85 MAIN ST",
    "dropphycty": "MAXWELL",
    "dropphyst": "IA",
    "dropphyzpp": 501617722,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAXWELL",
    "dropmalst": "IA",
    "dropmalzpp": 501619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153871135,
    "dropsitcph": 5153871135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10976",
    "droptype": "D",
    "dropname": "MAYNARD",
    "dropdeladd": "255 MAIN ST W",
    "dropdelcty": "MAYNARD",
    "dropdelst": "IA",
    "dropdelzpp": 506557655,
    "dropphyadd": "255 MAIN ST W",
    "dropphycty": "MAYNARD",
    "dropphyst": "IA",
    "dropphyzpp": 506557655,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYNARD",
    "dropmalst": "IA",
    "dropmalzpp": 506559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636372340,
    "dropsitcph": 5636372340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10978",
    "droptype": "D",
    "dropname": "MC CALLSBURG",
    "dropdeladd": "460 MAIN ST",
    "dropdelcty": "MC CALLSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 501547719,
    "dropphyadd": "460 MAIN ST",
    "dropphycty": "MC CALLSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 501547719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CALLSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 501549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154342610,
    "dropsitcph": 5154342610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10979",
    "droptype": "D",
    "dropname": "MC CAUSLAND",
    "dropdeladd": "304 N SALINA ST",
    "dropdelcty": "MC CAUSLAND",
    "dropdelst": "IA",
    "dropdelzpp": 527589000,
    "dropphyadd": "304 N SALINA ST",
    "dropphycty": "MC CAUSLAND",
    "dropphyst": "IA",
    "dropphyzpp": 527589000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CAUSLAND",
    "dropmalst": "IA",
    "dropmalzpp": 527589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632252460,
    "dropsitcph": 5632252460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10981",
    "droptype": "D",
    "dropname": "MC GREGOR",
    "dropdeladd": "107 2ND ST",
    "dropdelcty": "MC GREGOR",
    "dropdelst": "IA",
    "dropdelzpp": 521574400,
    "dropphyadd": "107 2ND ST",
    "dropphycty": "MC GREGOR",
    "dropphyst": "IA",
    "dropphyzpp": 521574400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GREGOR",
    "dropmalst": "IA",
    "dropmalzpp": 521579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638733626,
    "dropsitcph": 5638733626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10984",
    "droptype": "D",
    "dropname": "MECHANICSVILLE",
    "dropdeladd": "200 E 1ST ST",
    "dropdelcty": "MECHANICSVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 523067701,
    "dropphyadd": "200 E 1ST ST",
    "dropphycty": "MECHANICSVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 523067701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MECHANICSVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 523069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634327104,
    "dropsitcph": 5634327104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10987",
    "droptype": "D",
    "dropname": "MEDIAPOLIS",
    "dropdeladd": "706 MAIN ST",
    "dropdelcty": "MEDIAPOLIS",
    "dropdelst": "IA",
    "dropdelzpp": 526379492,
    "dropphyadd": "706 MAIN ST",
    "dropphycty": "MEDIAPOLIS",
    "dropphyst": "IA",
    "dropphyzpp": 526379492,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDIAPOLIS",
    "dropmalst": "IA",
    "dropmalzpp": 526379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193943979,
    "dropsitcph": 3193943979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10989",
    "droptype": "D",
    "dropname": "MELBOURNE",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "IA",
    "dropdelzpp": 501627713,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "MELBOURNE",
    "dropphyst": "IA",
    "dropphyzpp": 501627713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "IA",
    "dropmalzpp": 501629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414823157,
    "dropsitcph": 6414823157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10990",
    "droptype": "D",
    "dropname": "MELCHER",
    "dropdeladd": "125 S MAIN ST",
    "dropdelcty": "MELCHER DALLAS",
    "dropdelst": "IA",
    "dropdelzpp": 501634400,
    "dropphyadd": "125 S MAIN ST",
    "dropphycty": "MELCHER DALLAS",
    "dropphyst": "IA",
    "dropphyzpp": 501634400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELCHER DALLAS",
    "dropmalst": "IA",
    "dropmalzpp": 501639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419474871,
    "dropsitcph": 6419474871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10992",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "103 ERIN AVE",
    "dropdelcty": "MELROSE",
    "dropdelst": "IA",
    "dropdelzpp": 525698634,
    "dropphyadd": "103 ERIN AVE",
    "dropphycty": "MELROSE",
    "dropphyst": "IA",
    "dropphyzpp": 525698634,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELROSE",
    "dropmalst": "IA",
    "dropmalzpp": 525699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417263200,
    "dropsitcph": 6417263200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10994",
    "droptype": "D",
    "dropname": "MELVIN",
    "dropdeladd": "246 MAIN ST",
    "dropdelcty": "MELVIN",
    "dropdelst": "IA",
    "dropdelzpp": 513501006,
    "dropphyadd": "246 MAIN ST",
    "dropphycty": "MELVIN",
    "dropphyst": "IA",
    "dropphyzpp": 513501006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELVIN",
    "dropmalst": "IA",
    "dropmalzpp": 513509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127362410,
    "dropsitcph": 7127362410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10995",
    "droptype": "D",
    "dropname": "MENLO",
    "dropdeladd": "503 SHERMAN ST",
    "dropdelcty": "MENLO",
    "dropdelst": "IA",
    "dropdelzpp": 501641027,
    "dropphyadd": "503 SHERMAN ST",
    "dropphycty": "MENLO",
    "dropphyst": "IA",
    "dropphyzpp": 501641027,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENLO",
    "dropmalst": "IA",
    "dropmalzpp": 501649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415242691,
    "dropsitcph": 6415242691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW10999",
    "droptype": "D",
    "dropname": "MERIDEN",
    "dropdeladd": "112 EAGLE ST",
    "dropdelcty": "MERIDEN",
    "dropdelst": "IA",
    "dropdelzpp": 510377733,
    "dropphyadd": "112 EAGLE ST",
    "dropphycty": "MERIDEN",
    "dropphyst": "IA",
    "dropphyzpp": 510377733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERIDEN",
    "dropmalst": "IA",
    "dropmalzpp": 510379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124438389,
    "dropsitcph": 7124438389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11003",
    "droptype": "D",
    "dropname": "MERRILL",
    "dropdeladd": "134 MAIN ST",
    "dropdelcty": "MERRILL",
    "dropdelst": "IA",
    "dropdelzpp": 510387739,
    "dropphyadd": "134 MAIN ST",
    "dropphycty": "MERRILL",
    "dropphyst": "IA",
    "dropphyzpp": 510387739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRILL",
    "dropmalst": "IA",
    "dropmalzpp": 510389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129382325,
    "dropsitcph": 7129382325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11004",
    "droptype": "D",
    "dropname": "MESERVEY",
    "dropdeladd": "424 1ST ST",
    "dropdelcty": "MESERVEY",
    "dropdelst": "IA",
    "dropdelzpp": 504571004,
    "dropphyadd": "424 1ST ST",
    "dropphycty": "MESERVEY",
    "dropphyst": "IA",
    "dropphyzpp": 504571004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESERVEY",
    "dropmalst": "IA",
    "dropmalzpp": 504579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413586329,
    "dropsitcph": 6413586329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11008",
    "droptype": "D",
    "dropname": "MIDDLE AMANA",
    "dropdeladd": "2516 220TH TRL",
    "dropdelcty": "MIDDLE AMANA",
    "dropdelst": "IA",
    "dropdelzpp": 523077700,
    "dropphyadd": "2516 220TH TRL",
    "dropphycty": "MIDDLE AMANA",
    "dropphyst": "IA",
    "dropphyzpp": 523077700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLE AMANA",
    "dropmalst": "IA",
    "dropmalzpp": 523079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196223861,
    "dropsitcph": 3196223861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11010",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "250 MAIN ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "IA",
    "dropdelzpp": 526389751,
    "dropphyadd": "250 MAIN ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "IA",
    "dropphyzpp": 526389751,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "IA",
    "dropmalzpp": 526389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197532151,
    "dropsitcph": 3197532151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11014",
    "droptype": "D",
    "dropname": "MILES",
    "dropdeladd": "323 FERRY RD",
    "dropdelcty": "MILES",
    "dropdelst": "IA",
    "dropdelzpp": 520644400,
    "dropphyadd": "323 FERRY RD",
    "dropphycty": "MILES",
    "dropphyst": "IA",
    "dropphyzpp": 520644400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILES",
    "dropmalst": "IA",
    "dropmalzpp": 520649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636827134,
    "dropsitcph": 5636827134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11015",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "900 N AVE",
    "dropdelcty": "MILFORD",
    "dropdelst": "IA",
    "dropdelzpp": 513516500,
    "dropphyadd": "900 N AVE",
    "dropphycty": "MILFORD",
    "dropphyst": "IA",
    "dropphyzpp": 513516500,
    "dropmaladd": "900 N AVE",
    "dropmalcty": "MILFORD",
    "dropmalst": "IA",
    "dropmalzpp": 513516500,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123384556,
    "dropsitcph": 7123384556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11017",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "692 WASHINGTON ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 523088800,
    "dropphyadd": "692 WASHINGTON ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 523088800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 523089998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196557961,
    "dropsitcph": 3196557961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11021",
    "droptype": "D",
    "dropname": "MILO",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "MILO",
    "dropdelst": "IA",
    "dropdelzpp": 501667700,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "MILO",
    "dropphyst": "IA",
    "dropphyzpp": 501667700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILO",
    "dropmalst": "IA",
    "dropmalzpp": 501669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419426560,
    "dropsitcph": 6419426560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11022",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "401 N MAIN ST",
    "dropdelcty": "MILTON",
    "dropdelst": "IA",
    "dropdelzpp": 525707701,
    "dropphyadd": "401 N MAIN ST",
    "dropphycty": "MILTON",
    "dropphyst": "IA",
    "dropphyzpp": 525707701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILTON",
    "dropmalst": "IA",
    "dropmalzpp": 525709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416564415,
    "dropsitcph": 6416564415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11023",
    "droptype": "D",
    "dropname": "MINBURN",
    "dropdeladd": "514 CHESTNUT ST",
    "dropdelcty": "MINBURN",
    "dropdelst": "IA",
    "dropdelzpp": 501674400,
    "dropphyadd": "514 CHESTNUT ST",
    "dropphycty": "MINBURN",
    "dropphyst": "IA",
    "dropphyzpp": 501674400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINBURN",
    "dropmalst": "IA",
    "dropmalzpp": 501679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156772688,
    "dropsitcph": 5156772688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11024",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "207 BROADWAY ST",
    "dropdelcty": "MINDEN",
    "dropdelst": "IA",
    "dropdelzpp": 515532123,
    "dropphyadd": "207 BROADWAY ST",
    "dropphycty": "MINDEN",
    "dropphyst": "IA",
    "dropphyzpp": 515532123,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINDEN",
    "dropmalst": "IA",
    "dropmalzpp": 515539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124832021,
    "dropsitcph": 7124832021,
    "dropfax": 7124832021
  },
  {
    "dcode": "D",
    "dropkey": "PW11025",
    "droptype": "D",
    "dropname": "MINEOLA",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "MINEOLA",
    "dropdelst": "IA",
    "dropdelzpp": 515549700,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "MINEOLA",
    "dropphyst": "IA",
    "dropphyzpp": 515549700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINEOLA",
    "dropmalst": "IA",
    "dropmalzpp": 515549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125262200,
    "dropsitcph": 7125262200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11028",
    "droptype": "D",
    "dropname": "MINGO",
    "dropdeladd": "100 N STATION ST",
    "dropdelcty": "MINGO",
    "dropdelst": "IA",
    "dropdelzpp": 501687706,
    "dropphyadd": "100 N STATION ST",
    "dropphycty": "MINGO",
    "dropphyst": "IA",
    "dropphyzpp": 501687706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINGO",
    "dropmalst": "IA",
    "dropmalzpp": 501689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413634206,
    "dropsitcph": 6413634206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11029",
    "droptype": "D",
    "dropname": "MISSOURI VALLEY",
    "dropdeladd": "116 N 5TH ST",
    "dropdelcty": "MISSOURI VALLEY",
    "dropdelst": "IA",
    "dropdelzpp": 515559998,
    "dropphyadd": "116 N 5TH ST",
    "dropphycty": "MISSOURI VALLEY",
    "dropphyst": "IA",
    "dropphyzpp": 515559998,
    "dropmaladd": "116 N 5TH ST",
    "dropmalcty": "MISSOURI VALLEY",
    "dropmalst": "IA",
    "dropmalzpp": 515559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126423436,
    "dropsitcph": 7126423436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11031",
    "droptype": "D",
    "dropname": "MITCHELLVILLE",
    "dropdeladd": "205 CENTER AVE S",
    "dropdelcty": "MITCHELLVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 501697723,
    "dropphyadd": "205 CENTER AVE S",
    "dropphycty": "MITCHELLVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 501697723,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MITCHELLVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 501699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159673301,
    "dropsitcph": 5159673301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11032",
    "droptype": "D",
    "dropname": "MODALE",
    "dropdeladd": "204 N MAIN ST",
    "dropdelcty": "MODALE",
    "dropdelst": "IA",
    "dropdelzpp": 515562030,
    "dropphyadd": "204 N MAIN ST",
    "dropphycty": "MODALE",
    "dropphyst": "IA",
    "dropphyzpp": 515562030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MODALE",
    "dropmalst": "IA",
    "dropmalzpp": 515569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126452626,
    "dropsitcph": 7126452626,
    "dropfax": 7126452626
  },
  {
    "dcode": "D",
    "dropkey": "PW11034",
    "droptype": "D",
    "dropname": "MONDAMIN",
    "dropdeladd": "106 MAPLE ST",
    "dropdelcty": "MONDAMIN",
    "dropdelst": "IA",
    "dropdelzpp": 515572088,
    "dropphyadd": "106 MAPLE ST",
    "dropphycty": "MONDAMIN",
    "dropphyst": "IA",
    "dropphyzpp": 515572088,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONDAMIN",
    "dropmalst": "IA",
    "dropmalzpp": 515579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126462626,
    "dropsitcph": 7126462626,
    "dropfax": 7126462626
  },
  {
    "dcode": "D",
    "dropkey": "PW11036",
    "droptype": "D",
    "dropname": "MONMOUTH",
    "dropdeladd": "306 N DIVISION ST",
    "dropdelcty": "MONMOUTH",
    "dropdelst": "IA",
    "dropdelzpp": 523099498,
    "dropphyadd": "306 N DIVISION ST",
    "dropphycty": "MONMOUTH",
    "dropphyst": "IA",
    "dropphyzpp": 523099498,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONMOUTH",
    "dropmalst": "IA",
    "dropmalzpp": 523099998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196736061,
    "dropsitcph": 3196736061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11037",
    "droptype": "D",
    "dropname": "MONONA",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "MONONA",
    "dropdelst": "IA",
    "dropdelzpp": 521594400,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "MONONA",
    "dropphyst": "IA",
    "dropphyzpp": 521594400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONONA",
    "dropmalst": "IA",
    "dropmalzpp": 521599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635392195,
    "dropsitcph": 5635392195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11038",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "117 W MARION ST",
    "dropdelcty": "MONROE",
    "dropdelst": "IA",
    "dropdelzpp": 501707760,
    "dropphyadd": "117 W MARION ST",
    "dropphycty": "MONROE",
    "dropphyst": "IA",
    "dropphyzpp": 501707760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONROE",
    "dropmalst": "IA",
    "dropmalzpp": 501709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412592312,
    "dropsitcph": 6412592312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11041",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "201 E LIBERTY ST",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "IA",
    "dropdelzpp": 501714400,
    "dropphyadd": "201 E LIBERTY ST",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "IA",
    "dropphyzpp": 501714400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "IA",
    "dropmalzpp": 501719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416232163,
    "dropsitcph": 6416232163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11044",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "119 N CEDAR ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "IA",
    "dropdelzpp": 523109998,
    "dropphyadd": "119 N CEDAR ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "IA",
    "dropphyzpp": 523109998,
    "dropmaladd": "119 N CEDAR ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "IA",
    "dropmalzpp": 523109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194654334,
    "dropsitcph": 3194654334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11045",
    "droptype": "D",
    "dropname": "MONTOUR",
    "dropdeladd": "112 E ELM ST",
    "dropdelcty": "MONTOUR",
    "dropdelst": "IA",
    "dropdelzpp": 501737732,
    "dropphyadd": "112 E ELM ST",
    "dropphycty": "MONTOUR",
    "dropphyst": "IA",
    "dropphyzpp": 501737732,
    "dropmaladd": "112 E ELM ST",
    "dropmalcty": "MONTOUR",
    "dropmalst": "IA",
    "dropmalzpp": 501737732,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414926225,
    "dropsitcph": 6414926225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11047",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "MONTROSE",
    "dropdelst": "IA",
    "dropdelzpp": 526399700,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "MONTROSE",
    "dropphyst": "IA",
    "dropphyzpp": 526399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTROSE",
    "dropmalst": "IA",
    "dropmalzpp": 526399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194635446,
    "dropsitcph": 3194635446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11049",
    "droptype": "D",
    "dropname": "MOORHEAD",
    "dropdeladd": "106 1ST ST",
    "dropdelcty": "MOORHEAD",
    "dropdelst": "IA",
    "dropdelzpp": 515583005,
    "dropphyadd": "106 1ST ST",
    "dropphycty": "MOORHEAD",
    "dropphyst": "IA",
    "dropphyzpp": 515583005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOORHEAD",
    "dropmalst": "IA",
    "dropmalzpp": 515589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7128865476,
    "dropsitcph": 7128865476,
    "dropfax": 7128865476
  },
  {
    "dcode": "D",
    "dropkey": "PW11050",
    "droptype": "D",
    "dropname": "MOORLAND",
    "dropdeladd": "525 FRONT ST",
    "dropdelcty": "MOORLAND",
    "dropdelst": "IA",
    "dropdelzpp": 505667569,
    "dropphyadd": "525 FRONT ST",
    "dropphycty": "MOORLAND",
    "dropphyst": "IA",
    "dropphyzpp": 505667569,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOORLAND",
    "dropmalst": "IA",
    "dropmalzpp": 505669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155493389,
    "dropsitcph": 5155493389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11052",
    "droptype": "D",
    "dropname": "MORAVIA",
    "dropdeladd": "107 N WILLIAM ST",
    "dropdelcty": "MORAVIA",
    "dropdelst": "IA",
    "dropdelzpp": 525717730,
    "dropphyadd": "107 N WILLIAM ST",
    "dropphycty": "MORAVIA",
    "dropphyst": "IA",
    "dropphyzpp": 525717730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORAVIA",
    "dropmalst": "IA",
    "dropmalzpp": 525719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417243214,
    "dropsitcph": 6417243214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11054",
    "droptype": "D",
    "dropname": "MORNING SUN",
    "dropdeladd": "19 N MAIN ST",
    "dropdelcty": "MORNING SUN",
    "dropdelst": "IA",
    "dropdelzpp": 526409701,
    "dropphyadd": "19 N MAIN ST",
    "dropphycty": "MORNING SUN",
    "dropphyst": "IA",
    "dropphyzpp": 526409701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORNING SUN",
    "dropmalst": "IA",
    "dropmalzpp": 526409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198687576,
    "dropsitcph": 3198687576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11059",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "2476 112TH ST",
    "dropdelcty": "MOSCOW",
    "dropdelst": "IA",
    "dropdelzpp": 527609741,
    "dropphyadd": "2476 112TH ST",
    "dropphycty": "MOSCOW",
    "dropphyst": "IA",
    "dropphyzpp": 527609741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSCOW",
    "dropmalst": "IA",
    "dropmalzpp": 527609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637243510,
    "dropsitcph": 5637243510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11060",
    "droptype": "D",
    "dropname": "MOULTON",
    "dropdeladd": "103 E 4TH ST",
    "dropdelcty": "MOULTON",
    "dropdelst": "IA",
    "dropdelzpp": 525721363,
    "dropphyadd": "103 E 4TH ST",
    "dropphycty": "MOULTON",
    "dropphyst": "IA",
    "dropphyzpp": 525721363,
    "dropmaladd": "103 E 4TH ST",
    "dropmalcty": "MOULTON",
    "dropmalst": "IA",
    "dropmalzpp": 525721363,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416423928,
    "dropsitcph": 6416423928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11061",
    "droptype": "D",
    "dropname": "MOUNT AUBURN",
    "dropdeladd": "211 2ND ST",
    "dropdelcty": "MOUNT AUBURN",
    "dropdelst": "IA",
    "dropdelzpp": 523138800,
    "dropphyadd": "211 2ND ST",
    "dropphycty": "MOUNT AUBURN",
    "dropphyst": "IA",
    "dropphyzpp": 523138800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT AUBURN",
    "dropmalst": "IA",
    "dropmalzpp": 523139998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194752324,
    "dropsitcph": 3194752324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11062",
    "droptype": "D",
    "dropname": "MOUNT AYR",
    "dropdeladd": "202 W MADISON ST",
    "dropdelcty": "MOUNT AYR",
    "dropdelst": "IA",
    "dropdelzpp": 508549998,
    "dropphyadd": "202 W MADISON ST",
    "dropphycty": "MOUNT AYR",
    "dropphyst": "IA",
    "dropphyzpp": 508549998,
    "dropmaladd": "202 W MADISON ST",
    "dropmalcty": "MOUNT AYR",
    "dropmalst": "IA",
    "dropmalzpp": 508549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414580082,
    "dropsitcph": 6414580082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11064",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "200 N JEFFERSON ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "IA",
    "dropdelzpp": 526412289,
    "dropphyadd": "200 N JEFFERSON ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "IA",
    "dropphyzpp": 526412289,
    "dropmaladd": "200 N JEFFERSON ST",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "IA",
    "dropmalzpp": 526412289,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193854974,
    "dropsitcph": 3193852641,
    "dropfax": 3193852602
  },
  {
    "dcode": "D",
    "dropkey": "PW11067",
    "droptype": "D",
    "dropname": "MOUNT UNION",
    "dropdeladd": "206 W RAILROAD ST",
    "dropdelcty": "MOUNT UNION",
    "dropdelst": "IA",
    "dropdelzpp": 526449608,
    "dropphyadd": "206 W RAILROAD ST",
    "dropphycty": "MOUNT UNION",
    "dropphyst": "IA",
    "dropphyzpp": 526449608,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT UNION",
    "dropmalst": "IA",
    "dropmalzpp": 526449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198654451,
    "dropsitcph": 3198654451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11068",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "124 2ND ST SW",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "IA",
    "dropdelzpp": 523141600,
    "dropphyadd": "124 2ND ST SW",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "IA",
    "dropphyzpp": 523141600,
    "dropmaladd": "124 2ND ST SW",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "IA",
    "dropmalzpp": 523141600,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198956123,
    "dropsitcph": 3198956123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11070",
    "droptype": "D",
    "dropname": "MOVILLE",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "MOVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 510397714,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "MOVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 510397714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 510399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128733414,
    "dropsitcph": 7128733414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11076",
    "droptype": "D",
    "dropname": "MURRAY",
    "dropdeladd": "430 MAPLE ST",
    "dropdelcty": "MURRAY",
    "dropdelst": "IA",
    "dropdelzpp": 501742003,
    "dropphyadd": "430 MAPLE ST",
    "dropphycty": "MURRAY",
    "dropphyst": "IA",
    "dropphyzpp": 501742003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURRAY",
    "dropmalst": "IA",
    "dropmalzpp": 501749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414472666,
    "dropsitcph": 6414472666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11077",
    "droptype": "D",
    "dropname": "MUSCATINE",
    "dropdeladd": "3100 CEDAR ST",
    "dropdelcty": "MUSCATINE",
    "dropdelst": "IA",
    "dropdelzpp": 527619998,
    "dropphyadd": "3100 CEDAR ST",
    "dropphycty": "MUSCATINE",
    "dropphyst": "IA",
    "dropphyzpp": 527619998,
    "dropmaladd": "3100 CEDAR ST",
    "dropmalcty": "MUSCATINE",
    "dropmalst": "IA",
    "dropmalzpp": 527619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632631531,
    "dropsitcph": 5632631531,
    "dropfax": 5632635155
  },
  {
    "dcode": "D",
    "dropkey": "PW11078",
    "droptype": "D",
    "dropname": "MYSTIC",
    "dropdeladd": "312 W MAIN ST",
    "dropdelcty": "MYSTIC",
    "dropdelst": "IA",
    "dropdelzpp": 525748822,
    "dropphyadd": "312 W MAIN ST",
    "dropphycty": "MYSTIC",
    "dropphyst": "IA",
    "dropphyzpp": 525748822,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MYSTIC",
    "dropmalst": "IA",
    "dropmalzpp": 525749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416472887,
    "dropsitcph": 6416472887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11083",
    "droptype": "D",
    "dropname": "NASHUA",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "NASHUA",
    "dropdelst": "IA",
    "dropdelzpp": 506587746,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "NASHUA",
    "dropphyst": "IA",
    "dropphyzpp": 506587746,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NASHUA",
    "dropmalst": "IA",
    "dropmalzpp": 506589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414352276,
    "dropsitcph": 6414352276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11087",
    "droptype": "D",
    "dropname": "NEMAHA",
    "dropdeladd": "220 MAIN ST",
    "dropdelcty": "NEMAHA",
    "dropdelst": "IA",
    "dropdelzpp": 505677554,
    "dropphyadd": "220 MAIN ST",
    "dropphycty": "NEMAHA",
    "dropphyst": "IA",
    "dropphyzpp": 505677554,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEMAHA",
    "dropmalst": "IA",
    "dropmalzpp": 505679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126364510,
    "dropsitcph": 7126364510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11088",
    "droptype": "D",
    "dropname": "NEOLA",
    "dropdeladd": "314 FRONT ST",
    "dropdelcty": "NEOLA",
    "dropdelst": "IA",
    "dropdelzpp": 515593103,
    "dropphyadd": "314 FRONT ST",
    "dropphycty": "NEOLA",
    "dropphyst": "IA",
    "dropphyzpp": 515593103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEOLA",
    "dropmalst": "IA",
    "dropmalzpp": 515599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124852120,
    "dropsitcph": 7124852120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11090",
    "droptype": "D",
    "dropname": "NEVADA",
    "dropdeladd": "437 K AVE",
    "dropdelcty": "NEVADA",
    "dropdelst": "IA",
    "dropdelzpp": 502011824,
    "dropphyadd": "437 K AVE",
    "dropphycty": "NEVADA",
    "dropphyst": "IA",
    "dropphyzpp": 502011824,
    "dropmaladd": "437 K AVE",
    "dropmalcty": "NEVADA",
    "dropmalst": "IA",
    "dropmalzpp": 502011824,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153822709,
    "dropsitcph": 5153822709,
    "dropfax": 5153826504
  },
  {
    "dcode": "D",
    "dropkey": "PW11092",
    "droptype": "D",
    "dropname": "NEW ALBIN",
    "dropdeladd": "190 MAIN ST NE",
    "dropdelcty": "NEW ALBIN",
    "dropdelst": "IA",
    "dropdelzpp": 521604400,
    "dropphyadd": "190 MAIN ST NE",
    "dropphycty": "NEW ALBIN",
    "dropphyst": "IA",
    "dropphyzpp": 521604400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ALBIN",
    "dropmalst": "IA",
    "dropmalzpp": 521609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635444248,
    "dropsitcph": 5635444248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11095",
    "droptype": "D",
    "dropname": "NEW HAMPTON",
    "dropdeladd": "108 N CHESTNUT AVE",
    "dropdelcty": "NEW HAMPTON",
    "dropdelst": "IA",
    "dropdelzpp": 506599998,
    "dropphyadd": "108 N CHESTNUT AVE",
    "dropphycty": "NEW HAMPTON",
    "dropphyst": "IA",
    "dropphyzpp": 506599998,
    "dropmaladd": "108 N CHESTNUT AVE",
    "dropmalcty": "NEW HAMPTON",
    "dropmalst": "IA",
    "dropmalzpp": 506599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413942241,
    "dropsitcph": 6413942241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11096",
    "droptype": "D",
    "dropname": "NEW HARTFORD",
    "dropdeladd": "403 PACKWAUKEE ST",
    "dropdelcty": "NEW HARTFORD",
    "dropdelst": "IA",
    "dropdelzpp": 506609706,
    "dropphyadd": "403 PACKWAUKEE ST",
    "dropphycty": "NEW HARTFORD",
    "dropphyst": "IA",
    "dropphyzpp": 506609706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW HARTFORD",
    "dropmalst": "IA",
    "dropmalzpp": 506609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199832785,
    "dropsitcph": 3199832785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11098",
    "droptype": "D",
    "dropname": "NEW LIBERTY",
    "dropdeladd": "655 MAIN ST",
    "dropdelcty": "NEW LIBERTY",
    "dropdelst": "IA",
    "dropdelzpp": 527652207,
    "dropphyadd": "655 MAIN ST",
    "dropphycty": "NEW LIBERTY",
    "dropphyst": "IA",
    "dropphyzpp": 527652207,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW LIBERTY",
    "dropmalst": "IA",
    "dropmalzpp": 527659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638932380,
    "dropsitcph": 5637856362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11099",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "107 S WALNUT ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "IA",
    "dropdelzpp": 526459998,
    "dropphyadd": "107 S WALNUT ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "IA",
    "dropphyzpp": 526459998,
    "dropmaladd": "107 S WALNUT ST",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "IA",
    "dropmalzpp": 526459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193672716,
    "dropsitcph": 3193672716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11100",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "412 MAIN ST",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "IA",
    "dropdelzpp": 516469000,
    "dropphyadd": "412 MAIN ST",
    "dropphycty": "NEW MARKET",
    "dropphyst": "IA",
    "dropphyzpp": 516469000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "IA",
    "dropmalzpp": 516469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125853311,
    "dropsitcph": 7125853311,
    "dropfax": 7125853311
  },
  {
    "dcode": "D",
    "dropkey": "PW11101",
    "droptype": "D",
    "dropname": "NEW PROVIDENCE",
    "dropdeladd": "409 W MAIN STREET DR",
    "dropdelcty": "NEW PROVIDENCE",
    "dropdelst": "IA",
    "dropdelzpp": 502067716,
    "dropphyadd": "409 W MAIN STREET DR",
    "dropphycty": "NEW PROVIDENCE",
    "dropphyst": "IA",
    "dropphyzpp": 502067716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW PROVIDENCE",
    "dropmalst": "IA",
    "dropmalzpp": 502069998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414975430,
    "dropsitcph": 6414975430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11102",
    "droptype": "D",
    "dropname": "NEW SHARON",
    "dropdeladd": "106 S PEARL ST",
    "dropdelcty": "NEW SHARON",
    "dropdelst": "IA",
    "dropdelzpp": 502079214,
    "dropphyadd": "106 S PEARL ST",
    "dropphycty": "NEW SHARON",
    "dropphyst": "IA",
    "dropphyzpp": 502079214,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW SHARON",
    "dropmalst": "IA",
    "dropmalzpp": 502079998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416374145,
    "dropsitcph": 6416374145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11103",
    "droptype": "D",
    "dropname": "NEW VIENNA",
    "dropdeladd": "2177 MAIN ST",
    "dropdelcty": "NEW VIENNA",
    "dropdelst": "IA",
    "dropdelzpp": 520657734,
    "dropphyadd": "2177 MAIN ST",
    "dropphycty": "NEW VIENNA",
    "dropphyst": "IA",
    "dropphyzpp": 520657734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW VIENNA",
    "dropmalst": "IA",
    "dropmalzpp": 520659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639213945,
    "dropsitcph": 5639213945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11104",
    "droptype": "D",
    "dropname": "NEW VIRGINIA",
    "dropdeladd": "407 WEST ST",
    "dropdelcty": "NEW VIRGINIA",
    "dropdelst": "IA",
    "dropdelzpp": 502107705,
    "dropphyadd": "407 WEST ST",
    "dropphycty": "NEW VIRGINIA",
    "dropphyst": "IA",
    "dropphyzpp": 502107705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW VIRGINIA",
    "dropmalst": "IA",
    "dropmalzpp": 502109998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414493415,
    "dropsitcph": 6414493415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11108",
    "droptype": "D",
    "dropname": "NEWELL",
    "dropdeladd": "119 S FULTON ST",
    "dropdelcty": "NEWELL",
    "dropdelst": "IA",
    "dropdelzpp": 505685022,
    "dropphyadd": "119 S FULTON ST",
    "dropphycty": "NEWELL",
    "dropphyst": "IA",
    "dropphyzpp": 505685022,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWELL",
    "dropmalst": "IA",
    "dropmalzpp": 505689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122723395,
    "dropsitcph": 7122723395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11109",
    "droptype": "D",
    "dropname": "NEWHALL",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "NEWHALL",
    "dropdelst": "IA",
    "dropdelzpp": 523158800,
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "NEWHALL",
    "dropphyst": "IA",
    "dropphyzpp": 523158800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWHALL",
    "dropmalst": "IA",
    "dropmalzpp": 523159998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192235487,
    "dropsitcph": 3192235487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11111",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "215 S 2ND AVE E",
    "dropdelcty": "NEWTON",
    "dropdelst": "IA",
    "dropdelzpp": 502083737,
    "dropphyadd": "215 S 2ND AVE E",
    "dropphycty": "NEWTON",
    "dropphyst": "IA",
    "dropphyzpp": 502089998,
    "dropmaladd": "215 S 2ND AVE E",
    "dropmalcty": "NEWTON",
    "dropmalst": "IA",
    "dropmalzpp": 502089998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417924730,
    "dropsitcph": 6417924730,
    "dropfax": 6417919692
  },
  {
    "dcode": "D",
    "dropkey": "PW11112",
    "droptype": "D",
    "dropname": "NICHOLS",
    "dropdeladd": "410 IJEM AVE",
    "dropdelcty": "NICHOLS",
    "dropdelst": "IA",
    "dropdelzpp": 527667710,
    "dropphyadd": "410 IJEM AVE",
    "dropphycty": "NICHOLS",
    "dropphyst": "IA",
    "dropphyzpp": 527667710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NICHOLS",
    "dropmalst": "IA",
    "dropmalzpp": 527669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197234425,
    "dropsitcph": 3197234425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11115",
    "droptype": "D",
    "dropname": "NORA SPRINGS",
    "dropdeladd": "19 S HAWKEYE AVE",
    "dropdelcty": "NORA SPRINGS",
    "dropdelst": "IA",
    "dropdelzpp": 504587739,
    "dropphyadd": "19 S HAWKEYE AVE",
    "dropphycty": "NORA SPRINGS",
    "dropphyst": "IA",
    "dropphyzpp": 504587739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORA SPRINGS",
    "dropmalst": "IA",
    "dropmalzpp": 504589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417495316,
    "dropsitcph": 6417495316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11120",
    "droptype": "D",
    "dropname": "NORTH ENGLISH",
    "dropdeladd": "108 W OAK ST",
    "dropdelcty": "NORTH ENGLISH",
    "dropdelst": "IA",
    "dropdelzpp": 523169537,
    "dropphyadd": "108 W OAK ST",
    "dropphycty": "NORTH ENGLISH",
    "dropphyst": "IA",
    "dropphyzpp": 523169537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH ENGLISH",
    "dropmalst": "IA",
    "dropmalzpp": 523169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196643848,
    "dropsitcph": 3196643848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11122",
    "droptype": "D",
    "dropname": "NORTH LIBERTY",
    "dropdeladd": "75 COMMERCIAL DR",
    "dropdelcty": "NORTH LIBERTY",
    "dropdelst": "IA",
    "dropdelzpp": 523178802,
    "dropphyadd": "75 COMMERCIAL DR",
    "dropphycty": "NORTH LIBERTY",
    "dropphyst": "IA",
    "dropphyzpp": 523178802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LIBERTY",
    "dropmalst": "IA",
    "dropmalzpp": 523179998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196934354,
    "dropsitcph": 3196934354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11133",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "806 1ST AVE S",
    "dropdelcty": "NORTHWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 504599998,
    "dropphyadd": "806 1ST AVE S",
    "dropphycty": "NORTHWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 504599998,
    "dropmaladd": "806 1ST AVE S",
    "dropmalcty": "NORTHWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 504599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413242067,
    "dropsitcph": 6413242067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11134",
    "droptype": "D",
    "dropname": "NORWALK",
    "dropdeladd": "1105 HIGH RD",
    "dropdelcty": "NORWALK",
    "dropdelst": "IA",
    "dropdelzpp": 502119998,
    "dropphyadd": "1105 HIGH RD",
    "dropphycty": "NORWALK",
    "dropphyst": "IA",
    "dropphyzpp": 502119998,
    "dropmaladd": "1105 HIGH RD",
    "dropmalcty": "NORWALK",
    "dropmalst": "IA",
    "dropmalzpp": 502119998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159815398,
    "dropsitcph": 5159815871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11135",
    "droptype": "D",
    "dropname": "NORWAY",
    "dropdeladd": "202 W RAILROAD ST",
    "dropdelcty": "NORWAY",
    "dropdelst": "IA",
    "dropdelzpp": 523188800,
    "dropphyadd": "202 W RAILROAD ST",
    "dropphycty": "NORWAY",
    "dropphyst": "IA",
    "dropphyzpp": 523188800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWAY",
    "dropmalst": "IA",
    "dropmalzpp": 523189998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192277671,
    "dropsitcph": 3192277671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11141",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "503 PIONEER AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "IA",
    "dropdelzpp": 515604080,
    "dropphyadd": "503 PIONEER AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "IA",
    "dropphyzpp": 515604080,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKLAND",
    "dropmalst": "IA",
    "dropmalzpp": 515609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124826618,
    "dropsitcph": 7124826618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11145",
    "droptype": "D",
    "dropname": "OAKVILLE",
    "dropdeladd": "505 RUSSELL ST",
    "dropdelcty": "OAKVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 526467569,
    "dropphyadd": "505 RUSSELL ST",
    "dropphycty": "OAKVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 526467569,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 526469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197663681,
    "dropsitcph": 3197663681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11148",
    "droptype": "D",
    "dropname": "OCHEYEDAN",
    "dropdeladd": "851 MAIN ST",
    "dropdelcty": "OCHEYEDAN",
    "dropdelst": "IA",
    "dropdelzpp": 513547726,
    "dropphyadd": "851 MAIN ST",
    "dropphycty": "OCHEYEDAN",
    "dropphyst": "IA",
    "dropphyzpp": 513547726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCHEYEDAN",
    "dropmalst": "IA",
    "dropmalzpp": 513549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127583600,
    "dropsitcph": 7127583600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11149",
    "droptype": "D",
    "dropname": "ODEBOLT",
    "dropdeladd": "315 S MAIN ST",
    "dropdelcty": "ODEBOLT",
    "dropdelst": "IA",
    "dropdelzpp": 514587719,
    "dropphyadd": "315 S MAIN ST",
    "dropphycty": "ODEBOLT",
    "dropphyst": "IA",
    "dropphyzpp": 514587719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODEBOLT",
    "dropmalst": "IA",
    "dropmalzpp": 514589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126684450,
    "dropsitcph": 7126684450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11150",
    "droptype": "D",
    "dropname": "OELWEIN",
    "dropdeladd": "30 1ST AVE NE",
    "dropdelcty": "OELWEIN",
    "dropdelst": "IA",
    "dropdelzpp": 506621747,
    "dropphyadd": "30 1ST AVE NE",
    "dropphycty": "OELWEIN",
    "dropphyst": "IA",
    "dropphyzpp": 506621747,
    "dropmaladd": "30 1ST AVE NE",
    "dropmalcty": "OELWEIN",
    "dropmalst": "IA",
    "dropmalzpp": 506621747,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192835437,
    "dropsitcph": 3192835437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11151",
    "droptype": "D",
    "dropname": "OGDEN",
    "dropdeladd": "202 SW 4TH ST",
    "dropdelcty": "OGDEN",
    "dropdelst": "IA",
    "dropdelzpp": 502122086,
    "dropphyadd": "202 SW 4TH ST",
    "dropphycty": "OGDEN",
    "dropphyst": "IA",
    "dropphyzpp": 502122086,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OGDEN",
    "dropmalst": "IA",
    "dropmalzpp": 502129998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152752747,
    "dropsitcph": 5152752747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11152",
    "droptype": "D",
    "dropname": "OKOBOJI",
    "dropdeladd": "1009 HIGHWAY 71 S",
    "dropdelcty": "OKOBOJI",
    "dropdelst": "IA",
    "dropdelzpp": 513552544,
    "dropphyadd": "1009 HIGHWAY 71 S",
    "dropphycty": "OKOBOJI",
    "dropphyst": "IA",
    "dropphyzpp": 513552544,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OKOBOJI",
    "dropmalst": "IA",
    "dropmalzpp": 513559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123322466,
    "dropsitcph": 7123322466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11155",
    "droptype": "D",
    "dropname": "OLDS",
    "dropdeladd": "110 S MAIN ST",
    "dropdelcty": "OLDS",
    "dropdelst": "IA",
    "dropdelzpp": 526475000,
    "dropphyadd": "110 S MAIN ST",
    "dropphycty": "OLDS",
    "dropphyst": "IA",
    "dropphyzpp": 526475000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLDS",
    "dropmalst": "IA",
    "dropmalzpp": 526479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192542211,
    "dropsitcph": 3192542211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11156",
    "droptype": "D",
    "dropname": "OLIN",
    "dropdeladd": "106 W LOCUST ST",
    "dropdelcty": "OLIN",
    "dropdelst": "IA",
    "dropdelzpp": 523209612,
    "dropphyadd": "106 W LOCUST ST",
    "dropphycty": "OLIN",
    "dropphyst": "IA",
    "dropphyzpp": 523209612,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLIN",
    "dropmalst": "IA",
    "dropmalzpp": 523209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194842311,
    "dropsitcph": 3194842311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11158",
    "droptype": "D",
    "dropname": "OLLIE",
    "dropdeladd": "306 N 4TH ST",
    "dropdelcty": "OLLIE",
    "dropdelst": "IA",
    "dropdelzpp": 525767708,
    "dropphyadd": "306 N 4TH ST",
    "dropphycty": "OLLIE",
    "dropphyst": "IA",
    "dropphyzpp": 525767708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLLIE",
    "dropmalst": "IA",
    "dropmalzpp": 525769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416672251,
    "dropsitcph": 6416672251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11159",
    "droptype": "D",
    "dropname": "ONAWA",
    "dropdeladd": "1017 IOWA AVE",
    "dropdelcty": "ONAWA",
    "dropdelst": "IA",
    "dropdelzpp": 510409998,
    "dropphyadd": "1017 IOWA AVE",
    "dropphycty": "ONAWA",
    "dropphyst": "IA",
    "dropphyzpp": 510409998,
    "dropmaladd": "1017 IOWA AVE",
    "dropmalcty": "ONAWA",
    "dropmalst": "IA",
    "dropmalzpp": 510409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124232811,
    "dropsitcph": 7124232811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11161",
    "droptype": "D",
    "dropname": "ONSLOW",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "ONSLOW",
    "dropdelst": "IA",
    "dropdelzpp": 523217605,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "ONSLOW",
    "dropphyst": "IA",
    "dropphyzpp": 523217605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONSLOW",
    "dropmalst": "IA",
    "dropmalzpp": 523219998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634852844,
    "dropsitcph": 5634852844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11166",
    "droptype": "D",
    "dropname": "ORANGE CITY",
    "dropdeladd": "108 ALBANY AVE SE",
    "dropdelcty": "ORANGE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 510419998,
    "dropphyadd": "108 ALBANY AVE SE",
    "dropphycty": "ORANGE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 510419998,
    "dropmaladd": "108 ALBANY AVE SE",
    "dropmalcty": "ORANGE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 510419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127374207,
    "dropsitcph": 7127374207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11167",
    "droptype": "D",
    "dropname": "ORCHARD",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "ORCHARD",
    "dropdelst": "IA",
    "dropdelzpp": 504607526,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "ORCHARD",
    "dropphyst": "IA",
    "dropphyzpp": 504607526,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCHARD",
    "dropmalst": "IA",
    "dropmalzpp": 504609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417323915,
    "dropsitcph": 6417323915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11168",
    "droptype": "D",
    "dropname": "ORIENT",
    "dropdeladd": "122 N BROAD ST",
    "dropdelcty": "ORIENT",
    "dropdelst": "IA",
    "dropdelzpp": 508589900,
    "dropphyadd": "122 N BROAD ST",
    "dropphycty": "ORIENT",
    "dropphyst": "IA",
    "dropphyzpp": 508589900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORIENT",
    "dropmalst": "IA",
    "dropmalzpp": 508589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413375702,
    "dropsitcph": 6413375702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11170",
    "droptype": "D",
    "dropname": "OSAGE",
    "dropdeladd": "119 N 8TH ST",
    "dropdelcty": "OSAGE",
    "dropdelst": "IA",
    "dropdelzpp": 504619998,
    "dropphyadd": "119 N 8TH ST",
    "dropphycty": "OSAGE",
    "dropphyst": "IA",
    "dropphyzpp": 504619998,
    "dropmaladd": "119 N 8TH ST",
    "dropmalcty": "OSAGE",
    "dropmalst": "IA",
    "dropmalzpp": 504619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417324634,
    "dropsitcph": 6417324634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11172",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "104 S FILLMORE ST",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "IA",
    "dropdelzpp": 502131201,
    "dropphyadd": "104 S FILLMORE ST",
    "dropphycty": "OSCEOLA",
    "dropphyst": "IA",
    "dropphyzpp": 502131201,
    "dropmaladd": "104 S FILLMORE ST",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "IA",
    "dropmalzpp": 502131201,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413422311,
    "dropsitcph": 6413422311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11174",
    "droptype": "D",
    "dropname": "OSKALOOSA",
    "dropdeladd": "113 6TH AVE E",
    "dropdelcty": "OSKALOOSA",
    "dropdelst": "IA",
    "dropdelzpp": 525779998,
    "dropphyadd": "113 6TH AVE E",
    "dropphycty": "OSKALOOSA",
    "dropphyst": "IA",
    "dropphyzpp": 525779998,
    "dropmaladd": "113 6TH AVE E",
    "dropmalcty": "OSKALOOSA",
    "dropmalst": "IA",
    "dropmalzpp": 525779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416736547,
    "dropsitcph": 6416736547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11175",
    "droptype": "D",
    "dropname": "OSSIAN",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "OSSIAN",
    "dropdelst": "IA",
    "dropdelzpp": 521618132,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "OSSIAN",
    "dropphyst": "IA",
    "dropphyzpp": 521618132,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSSIAN",
    "dropmalst": "IA",
    "dropmalzpp": 521619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635329754,
    "dropsitcph": 5635329754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11178",
    "droptype": "D",
    "dropname": "OTLEY",
    "dropdeladd": "100 BUSINESS HIGHWAY 163",
    "dropdelcty": "OTLEY",
    "dropdelst": "IA",
    "dropdelzpp": 502147718,
    "dropphyadd": "100 BUSINESS HIGHWAY 163",
    "dropphycty": "OTLEY",
    "dropphyst": "IA",
    "dropphyzpp": 502147718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTLEY",
    "dropmalst": "IA",
    "dropmalzpp": 502149998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416275571,
    "dropsitcph": 6416275571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11179",
    "droptype": "D",
    "dropname": "OTO",
    "dropdeladd": "32 WASHINGTON ST",
    "dropdelcty": "OTO",
    "dropdelst": "IA",
    "dropdelzpp": 510447705,
    "dropphyadd": "32 WASHINGTON ST",
    "dropphycty": "OTO",
    "dropphyst": "IA",
    "dropphyzpp": 510447705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTO",
    "dropmalst": "IA",
    "dropmalzpp": 510449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128274144,
    "dropsitcph": 7128274144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11183",
    "droptype": "D",
    "dropname": "OTTOSEN",
    "dropdeladd": "110 BRADY AVE",
    "dropdelcty": "OTTOSEN",
    "dropdelst": "IA",
    "dropdelzpp": 505708751,
    "dropphyadd": "110 BRADY AVE",
    "dropphycty": "OTTOSEN",
    "dropphyst": "IA",
    "dropphyzpp": 505708751,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTTOSEN",
    "dropmalst": "IA",
    "dropmalzpp": 505709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153791534,
    "dropsitcph": 5153791534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11185",
    "droptype": "D",
    "dropname": "OTTUMWA",
    "dropdeladd": "616 W 2ND ST",
    "dropdelcty": "OTTUMWA",
    "dropdelst": "IA",
    "dropdelzpp": 525012302,
    "dropphyadd": "616 W 2ND ST",
    "dropphycty": "OTTUMWA",
    "dropphyst": "IA",
    "dropphyzpp": 525012302,
    "dropmaladd": "616 W 2ND ST",
    "dropmalcty": "OTTUMWA",
    "dropmalst": "IA",
    "dropmalzpp": 525012302,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416844591,
    "dropsitcph": 6416845439,
    "dropfax": 6416844424
  },
  {
    "dcode": "D",
    "dropkey": "PW11189",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "IA",
    "dropdelzpp": 523229021,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "OXFORD",
    "dropphyst": "IA",
    "dropphyzpp": 523229021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OXFORD",
    "dropmalst": "IA",
    "dropmalzpp": 523229998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198284407,
    "dropsitcph": 3198284407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11191",
    "droptype": "D",
    "dropname": "OXFORD JUNCTION",
    "dropdeladd": "214 BROADWAY ST",
    "dropdelcty": "OXFORD JUNCTION",
    "dropdelst": "IA",
    "dropdelzpp": 523237585,
    "dropphyadd": "214 BROADWAY ST",
    "dropphycty": "OXFORD JUNCTION",
    "dropphyst": "IA",
    "dropphyzpp": 523237585,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OXFORD JUNCTION",
    "dropmalst": "IA",
    "dropmalzpp": 523239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638262030,
    "dropsitcph": 5638262030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11193",
    "droptype": "D",
    "dropname": "OYENS",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "OYENS",
    "dropdelst": "IA",
    "dropdelzpp": 510457701,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "OYENS",
    "dropphyst": "IA",
    "dropphyzpp": 510457701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OYENS",
    "dropmalst": "IA",
    "dropmalzpp": 510459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125465356,
    "dropsitcph": 7125465356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11194",
    "droptype": "D",
    "dropname": "PACIFIC JUNCTION",
    "dropdeladd": "405 LINCOLN AVE",
    "dropdelcty": "PACIFIC JUNCTION",
    "dropdelst": "IA",
    "dropdelzpp": 515613014,
    "dropphyadd": "405 LINCOLN AVE",
    "dropphycty": "PACIFIC JUNCTION",
    "dropphyst": "IA",
    "dropphyzpp": 515613014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACIFIC JUNCTION",
    "dropmalst": "IA",
    "dropmalzpp": 515619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126228146,
    "dropsitcph": 7126228146,
    "dropfax": 7126228146
  },
  {
    "dcode": "D",
    "dropkey": "PW11196",
    "droptype": "D",
    "dropname": "PACKWOOD",
    "dropdeladd": "204 W 2ND ST",
    "dropdelcty": "PACKWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 525807722,
    "dropphyadd": "204 W 2ND ST",
    "dropphycty": "PACKWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 525807722,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACKWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 525809998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196955141,
    "dropsitcph": 3196955141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11199",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "402 HENRIETTA AVE",
    "dropdelcty": "PALMER",
    "dropdelst": "IA",
    "dropdelzpp": 505715000,
    "dropphyadd": "402 HENRIETTA AVE",
    "dropphycty": "PALMER",
    "dropphyst": "IA",
    "dropphyzpp": 505715000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMER",
    "dropmalst": "IA",
    "dropmalzpp": 505719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123592494,
    "dropsitcph": 7123592494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11201",
    "droptype": "D",
    "dropname": "PALO",
    "dropdeladd": "700 1ST ST",
    "dropdelcty": "PALO",
    "dropdelst": "IA",
    "dropdelzpp": 523249667,
    "dropphyadd": "700 1ST ST",
    "dropphycty": "PALO",
    "dropphyst": "IA",
    "dropphyzpp": 523249667,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALO",
    "dropmalst": "IA",
    "dropmalzpp": 523249998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198515901,
    "dropsitcph": 3198515901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11202",
    "droptype": "D",
    "dropname": "PANAMA",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "PANAMA",
    "dropdelst": "IA",
    "dropdelzpp": 515629700,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "PANAMA",
    "dropphyst": "IA",
    "dropphyzpp": 515629700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANAMA",
    "dropmalst": "IA",
    "dropmalzpp": 515629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124892222,
    "dropsitcph": 7124892222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11204",
    "droptype": "D",
    "dropname": "PANORA",
    "dropdeladd": "117 E CHURCH ST",
    "dropdelcty": "PANORA",
    "dropdelst": "IA",
    "dropdelzpp": 502161111,
    "dropphyadd": "117 E CHURCH ST",
    "dropphycty": "PANORA",
    "dropphyst": "IA",
    "dropphyzpp": 502161111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANORA",
    "dropmalst": "IA",
    "dropmalzpp": 502169998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417552430,
    "dropsitcph": 6417552430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11210",
    "droptype": "D",
    "dropname": "PARKERSBURG",
    "dropdeladd": "602 COATES ST",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 506657732,
    "dropphyadd": "602 COATES ST",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 506657732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 506659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193461567,
    "dropsitcph": 3193461567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11211",
    "droptype": "D",
    "dropname": "PARNELL",
    "dropdeladd": "691 CLEVELAND ST",
    "dropdelcty": "PARNELL",
    "dropdelst": "IA",
    "dropdelzpp": 523258871,
    "dropphyadd": "691 CLEVELAND ST",
    "dropphycty": "PARNELL",
    "dropphyst": "IA",
    "dropphyzpp": 523258871,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARNELL",
    "dropmalst": "IA",
    "dropmalzpp": 523259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196682117,
    "dropsitcph": 3196682117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11212",
    "droptype": "D",
    "dropname": "PATON",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "PATON",
    "dropdelst": "IA",
    "dropdelzpp": 502177729,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "PATON",
    "dropphyst": "IA",
    "dropphyzpp": 502177729,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATON",
    "dropmalst": "IA",
    "dropmalzpp": 502179998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159684315,
    "dropsitcph": 5159684315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11214",
    "droptype": "D",
    "dropname": "PAULLINA",
    "dropdeladd": "121 S MAIN ST",
    "dropdelcty": "PAULLINA",
    "dropdelst": "IA",
    "dropdelzpp": 510467768,
    "dropphyadd": "121 S MAIN ST",
    "dropphycty": "PAULLINA",
    "dropphyst": "IA",
    "dropphyzpp": 510467768,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAULLINA",
    "dropmalst": "IA",
    "dropmalzpp": 510469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124140003,
    "dropsitcph": 7124140003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11216",
    "droptype": "D",
    "dropname": "PELLA",
    "dropdeladd": "801 FRANKLIN ST",
    "dropdelcty": "PELLA",
    "dropdelst": "IA",
    "dropdelzpp": 502191603,
    "dropphyadd": "801 FRANKLIN ST",
    "dropphycty": "PELLA",
    "dropphyst": "IA",
    "dropphyzpp": 502191603,
    "dropmaladd": "801 FRANKLIN ST",
    "dropmalcty": "PELLA",
    "dropmalst": "IA",
    "dropmalzpp": 502191603,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416282951,
    "dropsitcph": 6416282951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11218",
    "droptype": "D",
    "dropname": "PEOSTA",
    "dropdeladd": "8554 KAPP DR",
    "dropdelcty": "PEOSTA",
    "dropdelst": "IA",
    "dropdelzpp": 520689759,
    "dropphyadd": "8554 KAPP DR",
    "dropphycty": "PEOSTA",
    "dropphyst": "IA",
    "dropphyzpp": 520689759,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEOSTA",
    "dropmalst": "IA",
    "dropmalzpp": 520689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635566212,
    "dropsitcph": 5635566212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11222",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "1420 2ND ST",
    "dropdelcty": "PERRY",
    "dropdelst": "IA",
    "dropdelzpp": 502209998,
    "dropphyadd": "1420 2ND ST",
    "dropphycty": "PERRY",
    "dropphyst": "IA",
    "dropphyzpp": 502209998,
    "dropmaladd": "1420 2ND ST",
    "dropmalcty": "PERRY",
    "dropmalst": "IA",
    "dropmalzpp": 502209998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154653615,
    "dropsitcph": 5154653615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11225",
    "droptype": "D",
    "dropname": "PERSIA",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "PERSIA",
    "dropdelst": "IA",
    "dropdelzpp": 515636040,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "PERSIA",
    "dropphyst": "IA",
    "dropphyzpp": 515636040,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERSIA",
    "dropmalst": "IA",
    "dropmalzpp": 515639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124883215,
    "dropsitcph": 7124883215,
    "dropfax": 7124883215
  },
  {
    "dcode": "D",
    "dropkey": "PW11228",
    "droptype": "D",
    "dropname": "PETERSON",
    "dropdeladd": "222 MAIN ST",
    "dropdelcty": "PETERSON",
    "dropdelst": "IA",
    "dropdelzpp": 510477713,
    "dropphyadd": "222 MAIN ST",
    "dropphycty": "PETERSON",
    "dropphyst": "IA",
    "dropphyzpp": 510477713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSON",
    "dropmalst": "IA",
    "dropmalzpp": 510479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122956321,
    "dropsitcph": 7122956321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11230",
    "droptype": "D",
    "dropname": "PIERSON",
    "dropdeladd": "324 FRONT ST",
    "dropdelcty": "PIERSON",
    "dropdelst": "IA",
    "dropdelzpp": 510488063,
    "dropphyadd": "324 FRONT ST",
    "dropphycty": "PIERSON",
    "dropphyst": "IA",
    "dropphyzpp": 510488063,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERSON",
    "dropmalst": "IA",
    "dropmalzpp": 510489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123755085,
    "dropsitcph": 7123755085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11232",
    "droptype": "D",
    "dropname": "PILOT MOUND",
    "dropdeladd": "102 PILOT ST",
    "dropdelcty": "PILOT MOUND",
    "dropdelst": "IA",
    "dropdelzpp": 502237730,
    "dropphyadd": "102 PILOT ST",
    "dropphycty": "PILOT MOUND",
    "dropphyst": "IA",
    "dropphyzpp": 502237730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PILOT MOUND",
    "dropmalst": "IA",
    "dropmalzpp": 502239998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153534242,
    "dropsitcph": 5153534242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11235",
    "droptype": "D",
    "dropname": "PISGAH",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "PISGAH",
    "dropdelst": "IA",
    "dropdelzpp": 515642046,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "PISGAH",
    "dropphyst": "IA",
    "dropphyzpp": 515642046,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PISGAH",
    "dropmalst": "IA",
    "dropmalzpp": 515649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124563038,
    "dropsitcph": 7124563038,
    "dropfax": 7124562992
  },
  {
    "dcode": "D",
    "dropkey": "PW11239",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "720 MAIN ST",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 506667730,
    "dropphyadd": "720 MAIN ST",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 506667730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 506669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192764470,
    "dropsitcph": 3192764470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11240",
    "droptype": "D",
    "dropname": "PLANO",
    "dropdeladd": "403 FRONT ST STE B",
    "dropdelcty": "PLANO",
    "dropdelst": "IA",
    "dropdelzpp": 525818625,
    "dropphyadd": "403 FRONT ST STE B",
    "dropphycty": "PLANO",
    "dropphyst": "IA",
    "dropphyzpp": 525818625,
    "dropmaladd": "403 FRONT ST STE B",
    "dropmalcty": "PLANO",
    "dropmalst": "IA",
    "dropmalzpp": 525818625,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416492992,
    "dropsitcph": 6416492992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11245",
    "droptype": "D",
    "dropname": "PLEASANT VALLEY",
    "dropdeladd": "24641 VALLEY DR",
    "dropdelcty": "PLEASANT VALLEY",
    "dropdelst": "IA",
    "dropdelzpp": 527679000,
    "dropphyadd": "24641 VALLEY DR",
    "dropphycty": "PLEASANT VALLEY",
    "dropphyst": "IA",
    "dropphyzpp": 527679000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT VALLEY",
    "dropmalst": "IA",
    "dropmalzpp": 527679998,
    "dropsitphn": 5633326232,
    "dropsitlph": 5633326232,
    "dropsitcph": 5633326232,
    "dropfax": 5633326232
  },
  {
    "dcode": "D",
    "dropkey": "PW11249",
    "droptype": "D",
    "dropname": "PLEASANTVILLE",
    "dropdeladd": "112 E MONROE ST",
    "dropdelcty": "PLEASANTVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 502257744,
    "dropphyadd": "112 E MONROE ST",
    "dropphycty": "PLEASANTVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 502257744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANTVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 502259998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158485712,
    "dropsitcph": 5154813016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11250",
    "droptype": "D",
    "dropname": "PLOVER",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "PLOVER",
    "dropdelst": "IA",
    "dropdelzpp": 505735000,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "PLOVER",
    "dropphyst": "IA",
    "dropphyzpp": 505735000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLOVER",
    "dropmalst": "IA",
    "dropmalzpp": 505739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128573936,
    "dropsitcph": 7128573936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11251",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "502 MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "IA",
    "dropdelzpp": 504647712,
    "dropphyadd": "502 MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "IA",
    "dropphyzpp": 504647712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "IA",
    "dropmalzpp": 504649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416963304,
    "dropsitcph": 6416963304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11252",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "88 COURT SQ",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "IA",
    "dropdelzpp": 505741639,
    "dropphyadd": "88 COURT SQ",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "IA",
    "dropphyzpp": 505741639,
    "dropmaladd": "88 COURT SQ",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "IA",
    "dropmalzpp": 505741639,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123354545,
    "dropsitcph": 7123354545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11253",
    "droptype": "D",
    "dropname": "POLK CITY",
    "dropdeladd": "302 N 3RD ST",
    "dropdelcty": "POLK CITY",
    "dropdelst": "IA",
    "dropdelzpp": 502261213,
    "dropphyadd": "302 N 3RD ST",
    "dropphycty": "POLK CITY",
    "dropphyst": "IA",
    "dropphyzpp": 502261213,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLK CITY",
    "dropmalst": "IA",
    "dropmalzpp": 502269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159846137,
    "dropsitcph": 5159846137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11254",
    "droptype": "D",
    "dropname": "POMEROY",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "POMEROY",
    "dropdelst": "IA",
    "dropdelzpp": 505757736,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "POMEROY",
    "dropphyst": "IA",
    "dropphyzpp": 505757736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POMEROY",
    "dropmalst": "IA",
    "dropmalzpp": 505759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124682413,
    "dropsitcph": 7124682413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11257",
    "droptype": "D",
    "dropname": "PORTSMOUTH",
    "dropdeladd": "207 MAIN ST",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "IA",
    "dropdelzpp": 515652013,
    "dropphyadd": "207 MAIN ST",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "IA",
    "dropphyzpp": 515652013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "IA",
    "dropmalzpp": 515659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127435511,
    "dropsitcph": 7127435511,
    "dropfax": 7127435511
  },
  {
    "dcode": "D",
    "dropkey": "PW11258",
    "droptype": "D",
    "dropname": "POSTVILLE",
    "dropdeladd": "146 W TILDEN ST",
    "dropdelcty": "POSTVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 521627793,
    "dropphyadd": "146 W TILDEN ST",
    "dropphycty": "POSTVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 521627793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POSTVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 521629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638647630,
    "dropsitcph": 5638647630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11260",
    "droptype": "D",
    "dropname": "PRAIRIE CITY",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "PRAIRIE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 502288686,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "PRAIRIE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 502288686,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAIRIE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 502289998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159942367,
    "dropsitcph": 5159942367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11264",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "113 6TH AVE",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "IA",
    "dropdelzpp": 508599901,
    "dropphyadd": "113 6TH AVE",
    "dropphycty": "PRESCOTT",
    "dropphyst": "IA",
    "dropphyzpp": 508599901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "IA",
    "dropmalzpp": 508599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413352587,
    "dropsitcph": 6413352587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11265",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "172 W GILLET ST",
    "dropdelcty": "PRESTON",
    "dropdelst": "IA",
    "dropdelzpp": 520699744,
    "dropphyadd": "172 W GILLET ST",
    "dropphycty": "PRESTON",
    "dropphyst": "IA",
    "dropphyzpp": 520699744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESTON",
    "dropmalst": "IA",
    "dropmalzpp": 520699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636894891,
    "dropsitcph": 5636894891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11266",
    "droptype": "D",
    "dropname": "PRIMGHAR",
    "dropdeladd": "280 S GREEN AVE",
    "dropdelcty": "PRIMGHAR",
    "dropdelst": "IA",
    "dropdelzpp": 512457777,
    "dropphyadd": "280 S GREEN AVE",
    "dropphycty": "PRIMGHAR",
    "dropphyst": "IA",
    "dropphyzpp": 512457777,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRIMGHAR",
    "dropmalst": "IA",
    "dropmalzpp": 512459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155759465,
    "dropsitcph": 5155759465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11268",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "634 HIGHWAY 67",
    "dropdelcty": "PRINCETON",
    "dropdelst": "IA",
    "dropdelzpp": 527689772,
    "dropphyadd": "634 HIGHWAY 67",
    "dropphycty": "PRINCETON",
    "dropphyst": "IA",
    "dropphyzpp": 527689772,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRINCETON",
    "dropmalst": "IA",
    "dropmalzpp": 527689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632894013,
    "dropsitcph": 5632894013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11270",
    "droptype": "D",
    "dropname": "PROLE",
    "dropdeladd": "8056 HIGHWAY 28 STE 2",
    "dropdelcty": "PROLE",
    "dropdelst": "IA",
    "dropdelzpp": 502299108,
    "dropphyadd": "8056 HIGHWAY 28 STE 2",
    "dropphycty": "PROLE",
    "dropphyst": "IA",
    "dropphyzpp": 502299108,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROLE",
    "dropmalst": "IA",
    "dropmalzpp": 502299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159814158,
    "dropsitcph": 5159814158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11271",
    "droptype": "D",
    "dropname": "PROMISE CITY",
    "dropdeladd": "105 N CENTER ST",
    "dropdelcty": "PROMISE CITY",
    "dropdelst": "IA",
    "dropdelzpp": 525838700,
    "dropphyadd": "105 N CENTER ST",
    "dropphycty": "PROMISE CITY",
    "dropphyst": "IA",
    "dropphyzpp": 525838700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROMISE CITY",
    "dropmalst": "IA",
    "dropmalzpp": 525839998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418745711,
    "dropsitcph": 6418745711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11274",
    "droptype": "D",
    "dropname": "PROTIVIN",
    "dropdeladd": "221 S MAIN ST",
    "dropdelcty": "PROTIVIN",
    "dropdelst": "IA",
    "dropdelzpp": 521637744,
    "dropphyadd": "221 S MAIN ST",
    "dropphycty": "PROTIVIN",
    "dropphyst": "IA",
    "dropphyzpp": 521637744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROTIVIN",
    "dropmalst": "IA",
    "dropmalzpp": 521639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635698336,
    "dropsitcph": 5635698336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11275",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "PULASKI",
    "dropdelst": "IA",
    "dropdelzpp": 525847702,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "PULASKI",
    "dropphyst": "IA",
    "dropphyzpp": 525847702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULASKI",
    "dropmalst": "IA",
    "dropmalzpp": 525849998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412761022,
    "dropsitcph": 6412761022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11278",
    "droptype": "D",
    "dropname": "QUASQUETON",
    "dropdeladd": "113 E DUBUQUE ST",
    "dropdelcty": "QUASQUETON",
    "dropdelst": "IA",
    "dropdelzpp": 523269719,
    "dropphyadd": "113 E DUBUQUE ST",
    "dropphycty": "QUASQUETON",
    "dropphyst": "IA",
    "dropphyzpp": 523269719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUASQUETON",
    "dropmalst": "IA",
    "dropmalzpp": 523269998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199343667,
    "dropsitcph": 3199343667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11279",
    "droptype": "D",
    "dropname": "QUIMBY",
    "dropdeladd": "106 W 2ND AVE",
    "dropdelcty": "QUIMBY",
    "dropdelst": "IA",
    "dropdelzpp": 510497736,
    "dropphyadd": "106 W 2ND AVE",
    "dropphycty": "QUIMBY",
    "dropphyst": "IA",
    "dropphyzpp": 510497736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUIMBY",
    "dropmalst": "IA",
    "dropmalzpp": 510499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124452316,
    "dropsitcph": 7124452316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11280",
    "droptype": "D",
    "dropname": "RADCLIFFE",
    "dropdeladd": "215 ISABELLA ST",
    "dropdelcty": "RADCLIFFE",
    "dropdelst": "IA",
    "dropdelzpp": 502307712,
    "dropphyadd": "215 ISABELLA ST",
    "dropphycty": "RADCLIFFE",
    "dropphyst": "IA",
    "dropphyzpp": 502307712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RADCLIFFE",
    "dropmalst": "IA",
    "dropmalzpp": 502309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154354365,
    "dropsitcph": 5154354365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11281",
    "droptype": "D",
    "dropname": "RAKE",
    "dropdeladd": "121 N MAIN ST",
    "dropdelcty": "RAKE",
    "dropdelst": "IA",
    "dropdelzpp": 504655000,
    "dropphyadd": "121 N MAIN ST",
    "dropphycty": "RAKE",
    "dropphyst": "IA",
    "dropphyzpp": 504655000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAKE",
    "dropmalst": "IA",
    "dropmalzpp": 504659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415663720,
    "dropsitcph": 6415663720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11284",
    "droptype": "D",
    "dropname": "RANDALL",
    "dropdeladd": "440 MAIN ST",
    "dropdelcty": "RANDALL",
    "dropdelst": "IA",
    "dropdelzpp": 502317706,
    "dropphyadd": "440 MAIN ST",
    "dropphycty": "RANDALL",
    "dropphyst": "IA",
    "dropphyzpp": 502317706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDALL",
    "dropmalst": "IA",
    "dropmalzpp": 502319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123406954,
    "dropsitcph": 7123406954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11285",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "IA",
    "dropdelzpp": 516499000,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "IA",
    "dropphyzpp": 516499000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "IA",
    "dropmalzpp": 516499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126255007,
    "dropsitcph": 7126255007,
    "dropfax": 7126253641
  },
  {
    "dcode": "D",
    "dropkey": "PW11289",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "111 COMMERCIAL ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "IA",
    "dropdelzpp": 506677727,
    "dropphyadd": "111 COMMERCIAL ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "IA",
    "dropphyzpp": 506677727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYMOND",
    "dropmalst": "IA",
    "dropmalzpp": 506679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192326244,
    "dropsitcph": 3192326244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11290",
    "droptype": "D",
    "dropname": "READLYN",
    "dropdeladd": "218 MAIN ST",
    "dropdelcty": "READLYN",
    "dropdelst": "IA",
    "dropdelzpp": 506687733,
    "dropphyadd": "218 MAIN ST",
    "dropphycty": "READLYN",
    "dropphyst": "IA",
    "dropphyzpp": 506687733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "READLYN",
    "dropmalst": "IA",
    "dropmalzpp": 506689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192793790,
    "dropsitcph": 3192793790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11291",
    "droptype": "D",
    "dropname": "REASNOR",
    "dropdeladd": "322 NEWTON ST",
    "dropdelcty": "REASNOR",
    "dropdelst": "IA",
    "dropdelzpp": 502327709,
    "dropphyadd": "322 NEWTON ST",
    "dropphycty": "REASNOR",
    "dropphyst": "IA",
    "dropphyzpp": 502327709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REASNOR",
    "dropmalst": "IA",
    "dropmalzpp": 502329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417932274,
    "dropsitcph": 6417932274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11293",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "503 E COOLBAUGH ST",
    "dropdelcty": "RED OAK",
    "dropdelst": "IA",
    "dropdelzpp": 515669998,
    "dropphyadd": "503 E COOLBAUGH ST",
    "dropphycty": "RED OAK",
    "dropphyst": "IA",
    "dropphyzpp": 515669998,
    "dropmaladd": "503 E COOLBAUGH ST",
    "dropmalcty": "RED OAK",
    "dropmalst": "IA",
    "dropmalzpp": 515669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126232121,
    "dropsitcph": 7126239758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11294",
    "droptype": "D",
    "dropname": "REDDING",
    "dropdeladd": "206 3RD ST",
    "dropdelcty": "REDDING",
    "dropdelst": "IA",
    "dropdelzpp": 508608863,
    "dropphyadd": "206 3RD ST",
    "dropphycty": "REDDING",
    "dropphyst": "IA",
    "dropphyzpp": 508608863,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDDING",
    "dropmalst": "IA",
    "dropmalzpp": 508609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417675350,
    "dropsitcph": 6417675350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11295",
    "droptype": "D",
    "dropname": "REDFIELD",
    "dropdeladd": "1106 THOMAS ST",
    "dropdelcty": "REDFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 502337749,
    "dropphyadd": "1106 THOMAS ST",
    "dropphycty": "REDFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 502337749,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 502339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158332741,
    "dropsitcph": 5158332741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11296",
    "droptype": "D",
    "dropname": "REINBECK",
    "dropdeladd": "509 CLARK ST",
    "dropdelcty": "REINBECK",
    "dropdelst": "IA",
    "dropdelzpp": 506691185,
    "dropphyadd": "509 CLARK ST",
    "dropphycty": "REINBECK",
    "dropphyst": "IA",
    "dropphyzpp": 506691185,
    "dropmaladd": "509 CLARK ST",
    "dropmalcty": "REINBECK",
    "dropmalst": "IA",
    "dropmalzpp": 506691185,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193452612,
    "dropsitcph": 3193452612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11297",
    "droptype": "D",
    "dropname": "REMBRANDT",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "REMBRANDT",
    "dropdelst": "IA",
    "dropdelzpp": 505765003,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "REMBRANDT",
    "dropphyst": "IA",
    "dropphyzpp": 505765003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMBRANDT",
    "dropmalst": "IA",
    "dropmalzpp": 505769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122866611,
    "dropsitcph": 7122866611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11298",
    "droptype": "D",
    "dropname": "REMSEN",
    "dropdeladd": "23 E 2ND ST",
    "dropdelcty": "REMSEN",
    "dropdelst": "IA",
    "dropdelzpp": 510501125,
    "dropphyadd": "23 E 2ND ST",
    "dropphycty": "REMSEN",
    "dropphyst": "IA",
    "dropphyzpp": 510501125,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMSEN",
    "dropmalst": "IA",
    "dropmalzpp": 510509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127862734,
    "dropsitcph": 7127862734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11299",
    "droptype": "D",
    "dropname": "RENWICK",
    "dropdeladd": "505 MAIN ST",
    "dropdelcty": "RENWICK",
    "dropdelst": "IA",
    "dropdelzpp": 505778857,
    "dropphyadd": "505 MAIN ST",
    "dropphycty": "RENWICK",
    "dropphyst": "IA",
    "dropphyzpp": 505778857,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RENWICK",
    "dropmalst": "IA",
    "dropmalzpp": 505779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158243212,
    "dropsitcph": 5158243212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11300",
    "droptype": "D",
    "dropname": "RHODES",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "RHODES",
    "dropdelst": "IA",
    "dropdelzpp": 502347730,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "RHODES",
    "dropphyst": "IA",
    "dropphyzpp": 502347730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RHODES",
    "dropmalst": "IA",
    "dropmalzpp": 502349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414932412,
    "dropsitcph": 6414932412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11301",
    "droptype": "D",
    "dropname": "RICEVILLE",
    "dropdeladd": "209 W MAIN ST",
    "dropdelcty": "RICEVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 504667706,
    "dropphyadd": "209 W MAIN ST",
    "dropphycty": "RICEVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 504667706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICEVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 504669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413648173,
    "dropsitcph": 6413648173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11303",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "111 N RICHLAND ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "IA",
    "dropdelzpp": 525859506,
    "dropphyadd": "111 N RICHLAND ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "IA",
    "dropphyzpp": 525859506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHLAND",
    "dropmalst": "IA",
    "dropmalzpp": 525859998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194562681,
    "dropsitcph": 3194562681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11306",
    "droptype": "D",
    "dropname": "RICKETTS",
    "dropdeladd": "40 MAPLE ST",
    "dropdelcty": "RICKETTS",
    "dropdelst": "IA",
    "dropdelzpp": 514607700,
    "dropphyadd": "40 MAPLE ST",
    "dropphycty": "RICKETTS",
    "dropphyst": "IA",
    "dropphyzpp": 514607700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICKETTS",
    "dropmalst": "IA",
    "dropmalzpp": 514609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126792395,
    "dropsitcph": 7126792395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11308",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "635 RAILROAD ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "IA",
    "dropdelzpp": 521657715,
    "dropphyadd": "635 RAILROAD ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "IA",
    "dropphyzpp": 521657715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "IA",
    "dropmalzpp": 521659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637372701,
    "dropsitcph": 5637372701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11310",
    "droptype": "D",
    "dropname": "RINGSTED",
    "dropdeladd": "102 W MAPLE ST",
    "dropdelcty": "RINGSTED",
    "dropdelst": "IA",
    "dropdelzpp": 505785036,
    "dropphyadd": "102 W MAPLE ST",
    "dropphycty": "RINGSTED",
    "dropphyst": "IA",
    "dropphyzpp": 505785036,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RINGSTED",
    "dropmalst": "IA",
    "dropmalzpp": 505789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128661789,
    "dropsitcph": 7128661789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11311",
    "droptype": "D",
    "dropname": "RIPPEY",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "RIPPEY",
    "dropdelst": "IA",
    "dropdelzpp": 502355000,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "RIPPEY",
    "dropphyst": "IA",
    "dropphyzpp": 502355000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIPPEY",
    "dropmalst": "IA",
    "dropmalzpp": 502359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154367732,
    "dropsitcph": 5154367732,
    "dropfax": 8002157474
  },
  {
    "dcode": "D",
    "dropkey": "PW11316",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "81 GREENE ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "IA",
    "dropdelzpp": 523279614,
    "dropphyadd": "81 GREENE ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "IA",
    "dropphyzpp": 523279614,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "IA",
    "dropmalzpp": 523279998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196482051,
    "dropsitcph": 3196482051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11317",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "909 SUMMER AVE",
    "dropdelcty": "RIVERTON",
    "dropdelst": "IA",
    "dropdelzpp": 516502022,
    "dropphyadd": "909 SUMMER AVE",
    "dropphycty": "RIVERTON",
    "dropphyst": "IA",
    "dropphyzpp": 516502022,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERTON",
    "dropmalst": "IA",
    "dropmalzpp": 516509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123874040,
    "dropsitcph": 7123874040,
    "dropfax": 7123873711
  },
  {
    "dcode": "D",
    "dropkey": "PW11326",
    "droptype": "D",
    "dropname": "ROCK RAPIDS",
    "dropdeladd": "217 N 2ND AVE",
    "dropdelcty": "ROCK RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 512460072,
    "dropphyadd": "217 N 2ND AVE",
    "dropphycty": "ROCK RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 512460072,
    "dropmaladd": "217 N 2ND AVE",
    "dropmalcty": "ROCK RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 512460072,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124723215,
    "dropsitcph": 7124723215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11327",
    "droptype": "D",
    "dropname": "ROCK VALLEY",
    "dropdeladd": "1501 MAIN ST",
    "dropdelcty": "ROCK VALLEY",
    "dropdelst": "IA",
    "dropdelzpp": 512476400,
    "dropphyadd": "1501 MAIN ST",
    "dropphycty": "ROCK VALLEY",
    "dropphyst": "IA",
    "dropphyzpp": 512476400,
    "dropmaladd": "1501 MAIN ST",
    "dropmalcty": "ROCK VALLEY",
    "dropmalst": "IA",
    "dropmalzpp": 512476400,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124762627,
    "dropsitcph": 7124762627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11329",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "104 W MAIN AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IA",
    "dropdelzpp": 504687718,
    "dropphyadd": "104 W MAIN AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IA",
    "dropphyzpp": 504687718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IA",
    "dropmalzpp": 504689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417563812,
    "dropsitcph": 6417563812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11330",
    "droptype": "D",
    "dropname": "ROCKWELL",
    "dropdeladd": "313 MAIN ST E",
    "dropdelcty": "ROCKWELL",
    "dropdelst": "IA",
    "dropdelzpp": 504691073,
    "dropphyadd": "313 MAIN ST E",
    "dropphycty": "ROCKWELL",
    "dropphyst": "IA",
    "dropphyzpp": 504691073,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKWELL",
    "dropmalst": "IA",
    "dropmalzpp": 504699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418223302,
    "dropsitcph": 6418223302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11331",
    "droptype": "D",
    "dropname": "ROCKWELL CITY",
    "dropdeladd": "520 4TH ST",
    "dropdelcty": "ROCKWELL CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505799998,
    "dropphyadd": "520 4TH ST",
    "dropphycty": "ROCKWELL CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505799998,
    "dropmaladd": "520 4TH ST",
    "dropmalcty": "ROCKWELL CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505799998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122978423,
    "dropsitcph": 7122978423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11334",
    "droptype": "D",
    "dropname": "RODNEY",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "RODNEY",
    "dropdelst": "IA",
    "dropdelzpp": 510517700,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "RODNEY",
    "dropphyst": "IA",
    "dropphyzpp": 510517700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RODNEY",
    "dropmalst": "IA",
    "dropmalzpp": 510519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128892225,
    "dropsitcph": 7128892225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11336",
    "droptype": "D",
    "dropname": "ROLAND",
    "dropdeladd": "225 N MAIN ST",
    "dropdelcty": "ROLAND",
    "dropdelst": "IA",
    "dropdelzpp": 502367741,
    "dropphyadd": "225 N MAIN ST",
    "dropphycty": "ROLAND",
    "dropphyst": "IA",
    "dropphyzpp": 502367741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROLAND",
    "dropmalst": "IA",
    "dropmalzpp": 502369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153884822,
    "dropsitcph": 5153884822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11337",
    "droptype": "D",
    "dropname": "ROLFE",
    "dropdeladd": "208 GARFIELD ST",
    "dropdelcty": "ROLFE",
    "dropdelst": "IA",
    "dropdelzpp": 505811168,
    "dropphyadd": "208 GARFIELD ST",
    "dropphycty": "ROLFE",
    "dropphyst": "IA",
    "dropphyzpp": 505811168,
    "dropmaladd": "208 GARFIELD ST",
    "dropmalcty": "ROLFE",
    "dropmalst": "IA",
    "dropmalzpp": 505811168,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128483550,
    "dropsitcph": 7128483550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11340",
    "droptype": "D",
    "dropname": "ROSE HILL",
    "dropdeladd": "339 MAIN ST",
    "dropdelcty": "ROSE HILL",
    "dropdelst": "IA",
    "dropdelzpp": 525869559,
    "dropphyadd": "339 MAIN ST",
    "dropphycty": "ROSE HILL",
    "dropphyst": "IA",
    "dropphyzpp": 525869559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSE HILL",
    "dropmalst": "IA",
    "dropmalzpp": 525869998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416328374,
    "dropsitcph": 6416328374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11346",
    "droptype": "D",
    "dropname": "ROWAN",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "ROWAN",
    "dropdelst": "IA",
    "dropdelzpp": 504705005,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "ROWAN",
    "dropphyst": "IA",
    "dropphyzpp": 504705005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROWAN",
    "dropmalst": "IA",
    "dropmalzpp": 504709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418532341,
    "dropsitcph": 6418532341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11347",
    "droptype": "D",
    "dropname": "ROWLEY",
    "dropdeladd": "111 ELY ST",
    "dropdelcty": "ROWLEY",
    "dropdelst": "IA",
    "dropdelzpp": 523299802,
    "dropphyadd": "111 ELY ST",
    "dropphycty": "ROWLEY",
    "dropphyst": "IA",
    "dropphyzpp": 523299802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROWLEY",
    "dropmalst": "IA",
    "dropmalzpp": 523299998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199382890,
    "dropsitcph": 3199382890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11348",
    "droptype": "D",
    "dropname": "ROYAL",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "ROYAL",
    "dropdelst": "IA",
    "dropdelzpp": 513577607,
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "ROYAL",
    "dropphyst": "IA",
    "dropphyzpp": 513577607,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROYAL",
    "dropmalst": "IA",
    "dropmalzpp": 513579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129332343,
    "dropsitcph": 7129332343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11352",
    "droptype": "D",
    "dropname": "RUDD",
    "dropdeladd": "514 CHICKASAW ST",
    "dropdelcty": "RUDD",
    "dropdelst": "IA",
    "dropdelzpp": 504715029,
    "dropphyadd": "514 CHICKASAW ST",
    "dropphycty": "RUDD",
    "dropphyst": "IA",
    "dropphyzpp": 504715029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUDD",
    "dropmalst": "IA",
    "dropmalzpp": 504719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413155072,
    "dropsitcph": 6413155072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11353",
    "droptype": "D",
    "dropname": "RUNNELLS",
    "dropdeladd": "112 BROWN ST",
    "dropdelcty": "RUNNELLS",
    "dropdelst": "IA",
    "dropdelzpp": 502377720,
    "dropphyadd": "112 BROWN ST",
    "dropphycty": "RUNNELLS",
    "dropphyst": "IA",
    "dropphyzpp": 502377720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUNNELLS",
    "dropmalst": "IA",
    "dropmalzpp": 502379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159662049,
    "dropsitcph": 5159662049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11354",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "103 S MAPLE ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "IA",
    "dropdelzpp": 502382020,
    "dropphyadd": "103 S MAPLE ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "IA",
    "dropphyzpp": 502382020,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSELL",
    "dropmalst": "IA",
    "dropmalzpp": 502389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415354621,
    "dropsitcph": 6415354621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11355",
    "droptype": "D",
    "dropname": "RUTHVEN",
    "dropdeladd": "1202 GOWRIE ST",
    "dropdelcty": "RUTHVEN",
    "dropdelst": "IA",
    "dropdelzpp": 513587717,
    "dropphyadd": "1202 GOWRIE ST",
    "dropphycty": "RUTHVEN",
    "dropphyst": "IA",
    "dropphyzpp": 513587717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTHVEN",
    "dropmalst": "IA",
    "dropmalzpp": 513589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128375217,
    "dropsitcph": 7128375217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11356",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "109 SHERIDAN AVE",
    "dropdelcty": "RUTLAND",
    "dropdelst": "IA",
    "dropdelzpp": 505825001,
    "dropphyadd": "109 SHERIDAN AVE",
    "dropphycty": "RUTLAND",
    "dropphyst": "IA",
    "dropphyzpp": 505825001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTLAND",
    "dropmalst": "IA",
    "dropmalzpp": 505829998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153325330,
    "dropsitcph": 5153325330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11358",
    "droptype": "D",
    "dropname": "RYAN",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "RYAN",
    "dropdelst": "IA",
    "dropdelzpp": 523308586,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "RYAN",
    "dropphyst": "IA",
    "dropphyzpp": 523308586,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RYAN",
    "dropmalst": "IA",
    "dropmalzpp": 523309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639322917,
    "dropsitcph": 5639322917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11361",
    "droptype": "D",
    "dropname": "SABULA",
    "dropdeladd": "411 BROAD ST",
    "dropdelcty": "SABULA",
    "dropdelst": "IA",
    "dropdelzpp": 520704400,
    "dropphyadd": "411 BROAD ST",
    "dropphycty": "SABULA",
    "dropphyst": "IA",
    "dropphyzpp": 520704400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SABULA",
    "dropmalst": "IA",
    "dropmalzpp": 520709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5636872848,
    "dropsitcph": 5636872848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11362",
    "droptype": "D",
    "dropname": "SAC CITY",
    "dropdeladd": "519 AUDUBON ST",
    "dropdelcty": "SAC CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505832207,
    "dropphyadd": "519 AUDUBON ST",
    "dropphycty": "SAC CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505832207,
    "dropmaladd": "519 AUDUBON ST",
    "dropmalcty": "SAC CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505832207,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126624269,
    "dropsitcph": 7126624269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11364",
    "droptype": "D",
    "dropname": "SAINT ANSGAR",
    "dropdeladd": "704 E 4TH ST",
    "dropdelcty": "SAINT ANSGAR",
    "dropdelst": "IA",
    "dropdelzpp": 504729571,
    "dropphyadd": "704 E 4TH ST",
    "dropphycty": "SAINT ANSGAR",
    "dropphyst": "IA",
    "dropphyzpp": 504729571,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT ANSGAR",
    "dropmalst": "IA",
    "dropmalzpp": 504729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413812660,
    "dropsitcph": 6413812660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11365",
    "droptype": "D",
    "dropname": "SAINT ANTHONY",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "SAINT ANTHONY",
    "dropdelst": "IA",
    "dropdelzpp": 502399700,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "SAINT ANTHONY",
    "dropphyst": "IA",
    "dropphyzpp": 502399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT ANTHONY",
    "dropmalst": "IA",
    "dropmalzpp": 502399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414778014,
    "dropsitcph": 6414778014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11367",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "129 W MAIN ST",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "IA",
    "dropdelzpp": 502407700,
    "dropphyadd": "129 W MAIN ST",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "IA",
    "dropphyzpp": 502407700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "IA",
    "dropmalzpp": 502409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413962585,
    "dropsitcph": 6413962585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11370",
    "droptype": "D",
    "dropname": "SAINT LUCAS",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "SAINT LUCAS",
    "dropdelst": "IA",
    "dropdelzpp": 521664400,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "SAINT LUCAS",
    "dropphyst": "IA",
    "dropphyzpp": 521664400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT LUCAS",
    "dropmalst": "IA",
    "dropmalzpp": 521669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637782248,
    "dropsitcph": 5637782248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11371",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "104 IOWA ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "IA",
    "dropdelzpp": 502415000,
    "dropphyadd": "104 IOWA ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "IA",
    "dropphyzpp": 502415000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "IA",
    "dropmalzpp": 502419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412972305,
    "dropsitcph": 6412972305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11372",
    "droptype": "D",
    "dropname": "SAINT OLAF",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "SAINT OLAF",
    "dropdelst": "IA",
    "dropdelzpp": 520724400,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "SAINT OLAF",
    "dropphyst": "IA",
    "dropphyzpp": 520724400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT OLAF",
    "dropmalst": "IA",
    "dropmalzpp": 520729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197832408,
    "dropsitcph": 3197832408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11375",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "103A S MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "IA",
    "dropdelzpp": 526497704,
    "dropphyadd": "103A S MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "IA",
    "dropphyzpp": 526497704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALEM",
    "dropmalst": "IA",
    "dropmalzpp": 526499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192584071,
    "dropsitcph": 3192584071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11377",
    "droptype": "D",
    "dropname": "SALIX",
    "dropdeladd": "310 TIPTON ST",
    "dropdelcty": "SALIX",
    "dropdelst": "IA",
    "dropdelzpp": 510527718,
    "dropphyadd": "310 TIPTON ST",
    "dropphycty": "SALIX",
    "dropphyst": "IA",
    "dropphyzpp": 510527718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALIX",
    "dropmalst": "IA",
    "dropmalzpp": 510529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129465443,
    "dropsitcph": 7129465443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11378",
    "droptype": "D",
    "dropname": "SANBORN",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "SANBORN",
    "dropdelst": "IA",
    "dropdelzpp": 512481142,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "SANBORN",
    "dropphyst": "IA",
    "dropphyzpp": 512481142,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANBORN",
    "dropmalst": "IA",
    "dropmalzpp": 512489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127293451,
    "dropsitcph": 7127293451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11391",
    "droptype": "D",
    "dropname": "SCARVILLE",
    "dropdeladd": "403 MAIN ST",
    "dropdelcty": "SCARVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 504737555,
    "dropphyadd": "403 MAIN ST",
    "dropphycty": "SCARVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 504737555,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCARVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 504739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6412516132,
    "dropsitcph": 6412516132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11392",
    "droptype": "D",
    "dropname": "SCHALLER",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "SCHALLER",
    "dropdelst": "IA",
    "dropdelzpp": 510537732,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "SCHALLER",
    "dropphyst": "IA",
    "dropphyzpp": 510537732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHALLER",
    "dropmalst": "IA",
    "dropmalzpp": 510539998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122754531,
    "dropsitcph": 7122754531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11393",
    "droptype": "D",
    "dropname": "SCHLESWIG",
    "dropdeladd": "200 CEDAR ST",
    "dropdelcty": "SCHLESWIG",
    "dropdelst": "IA",
    "dropdelzpp": 514611024,
    "dropphyadd": "200 CEDAR ST",
    "dropphycty": "SCHLESWIG",
    "dropphyst": "IA",
    "dropphyzpp": 514611024,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHLESWIG",
    "dropmalst": "IA",
    "dropmalzpp": 514619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126763310,
    "dropsitcph": 7126763310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11397",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "1020 MAIN ST",
    "dropdelcty": "SCRANTON",
    "dropdelst": "IA",
    "dropdelzpp": 514628511,
    "dropphyadd": "1020 MAIN ST",
    "dropphycty": "SCRANTON",
    "dropphyst": "IA",
    "dropphyzpp": 514628511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCRANTON",
    "dropmalst": "IA",
    "dropmalzpp": 514629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126523852,
    "dropsitcph": 7126523852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11403",
    "droptype": "D",
    "dropname": "SERGEANT BLUFF",
    "dropdeladd": "410 4TH ST",
    "dropdelcty": "SERGEANT BLUFF",
    "dropdelst": "IA",
    "dropdelzpp": 510548585,
    "dropphyadd": "410 4TH ST",
    "dropphycty": "SERGEANT BLUFF",
    "dropphyst": "IA",
    "dropphyzpp": 510548585,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SERGEANT BLUFF",
    "dropmalst": "IA",
    "dropmalzpp": 510549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7129435560,
    "dropsitcph": 7129435560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11406",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "230 N 4TH ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "IA",
    "dropdelzpp": 525901378,
    "dropphyadd": "230 N 4TH ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "IA",
    "dropphyzpp": 525901378,
    "dropmaladd": "230 N 4TH ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "IA",
    "dropmalzpp": 525901378,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418982828,
    "dropsitcph": 6418982828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11410",
    "droptype": "D",
    "dropname": "SHAMBAUGH",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "SHAMBAUGH",
    "dropdelst": "IA",
    "dropdelzpp": 516519000,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "SHAMBAUGH",
    "dropphyst": "IA",
    "dropphyzpp": 516519000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAMBAUGH",
    "dropmalst": "IA",
    "dropmalzpp": 516519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125425020,
    "dropsitcph": 7125425020,
    "dropfax": 7125425020
  },
  {
    "dcode": "D",
    "dropkey": "PW11411",
    "droptype": "D",
    "dropname": "SHANNON CITY",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "SHANNON CITY",
    "dropdelst": "IA",
    "dropdelzpp": 508619900,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "SHANNON CITY",
    "dropphyst": "IA",
    "dropphyzpp": 508619900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHANNON CITY",
    "dropmalst": "IA",
    "dropmalzpp": 508619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413392404,
    "dropsitcph": 6413392404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11413",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "109 WABASH ST",
    "dropdelcty": "SHARPSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 508629900,
    "dropphyadd": "109 WABASH ST",
    "dropphycty": "SHARPSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 508629900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARPSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 508629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413498550,
    "dropsitcph": 6413498550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11415",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "121 N 2ND ST",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 504757703,
    "dropphyadd": "121 N 2ND ST",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 504757703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 504759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418924156,
    "dropsitcph": 6418924156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11416",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "415 EAST ST",
    "dropdelcty": "SHELBY",
    "dropdelst": "IA",
    "dropdelzpp": 515703315,
    "dropphyadd": "415 EAST ST",
    "dropphycty": "SHELBY",
    "dropphyst": "IA",
    "dropphyzpp": 515703315,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELBY",
    "dropmalst": "IA",
    "dropmalzpp": 515709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125442929,
    "dropsitcph": 7125442929,
    "dropfax": 7125442929
  },
  {
    "dcode": "D",
    "dropkey": "PW11417",
    "droptype": "D",
    "dropname": "SHELDAHL",
    "dropdeladd": "106 COUNTY AVE",
    "dropdelcty": "SHELDAHL",
    "dropdelst": "IA",
    "dropdelzpp": 502437722,
    "dropphyadd": "106 COUNTY AVE",
    "dropphycty": "SHELDAHL",
    "dropphyst": "IA",
    "dropphyzpp": 502437722,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELDAHL",
    "dropmalst": "IA",
    "dropmalzpp": 502439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156852837,
    "dropsitcph": 5156852837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11419",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "312 11TH ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "IA",
    "dropdelzpp": 512012319,
    "dropphyadd": "312 11TH ST",
    "dropphycty": "SHELDON",
    "dropphyst": "IA",
    "dropphyzpp": 512012319,
    "dropmaladd": "312 11TH ST",
    "dropmalcty": "SHELDON",
    "dropmalst": "IA",
    "dropmalzpp": 512012319,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123244618,
    "dropsitcph": 7123244618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11420",
    "droptype": "D",
    "dropname": "SHELL ROCK",
    "dropdeladd": "203 S WALNUT ST",
    "dropdelcty": "SHELL ROCK",
    "dropdelst": "IA",
    "dropdelzpp": 506707780,
    "dropphyadd": "203 S WALNUT ST",
    "dropphycty": "SHELL ROCK",
    "dropphyst": "IA",
    "dropphyzpp": 506707780,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELL ROCK",
    "dropmalst": "IA",
    "dropmalzpp": 506709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198854709,
    "dropsitcph": 3198854709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11421",
    "droptype": "D",
    "dropname": "SHELLSBURG",
    "dropdeladd": "103 PEARL ST SE",
    "dropdelcty": "SHELLSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 523329717,
    "dropphyadd": "103 PEARL ST SE",
    "dropphycty": "SHELLSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 523329717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELLSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 523329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192490604,
    "dropsitcph": 3192490604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11422",
    "droptype": "D",
    "dropname": "SHENANDOAH",
    "dropdeladd": "501 W LOWELL AVE",
    "dropdelcty": "SHENANDOAH",
    "dropdelst": "IA",
    "dropdelzpp": 516019998,
    "dropphyadd": "501 W LOWELL AVE",
    "dropphycty": "SHENANDOAH",
    "dropphyst": "IA",
    "dropphyzpp": 516019998,
    "dropmaladd": "501 W LOWELL AVE",
    "dropmalcty": "SHENANDOAH",
    "dropmalst": "IA",
    "dropmalzpp": 516019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7122462703,
    "dropsitcph": 7122462703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11424",
    "droptype": "D",
    "dropname": "SHERRILL",
    "dropdeladd": "14857 SHERRILL RD",
    "dropdelcty": "SHERRILL",
    "dropdelst": "IA",
    "dropdelzpp": 520739564,
    "dropphyadd": "14857 SHERRILL RD",
    "dropphycty": "SHERRILL",
    "dropphyst": "IA",
    "dropphyzpp": 520739564,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERRILL",
    "dropmalst": "IA",
    "dropmalzpp": 520739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635522102,
    "dropsitcph": 5635522102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11429",
    "droptype": "D",
    "dropname": "SIBLEY",
    "dropdeladd": "412 9TH ST",
    "dropdelcty": "SIBLEY",
    "dropdelst": "IA",
    "dropdelzpp": 512491851,
    "dropphyadd": "412 9TH ST",
    "dropphycty": "SIBLEY",
    "dropphyst": "IA",
    "dropphyzpp": 512491851,
    "dropmaladd": "412 9TH ST",
    "dropmalcty": "SIBLEY",
    "dropmalst": "IA",
    "dropmalzpp": 512491851,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127543112,
    "dropsitcph": 7127543112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11430",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "509 FILMORE ST",
    "dropdelcty": "SIDNEY",
    "dropdelst": "IA",
    "dropdelzpp": 516522002,
    "dropphyadd": "509 FILMORE ST",
    "dropphycty": "SIDNEY",
    "dropphyst": "IA",
    "dropphyzpp": 516522002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIDNEY",
    "dropmalst": "IA",
    "dropmalzpp": 516529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7123747146,
    "dropsitcph": 7123747146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11431",
    "droptype": "D",
    "dropname": "SIGOURNEY",
    "dropdeladd": "115 W WASHINGTON ST",
    "dropdelcty": "SIGOURNEY",
    "dropdelst": "IA",
    "dropdelzpp": 525911354,
    "dropphyadd": "115 W WASHINGTON ST",
    "dropphycty": "SIGOURNEY",
    "dropphyst": "IA",
    "dropphyzpp": 525911354,
    "dropmaladd": "115 W WASHINGTON ST",
    "dropmalcty": "SIGOURNEY",
    "dropmalst": "IA",
    "dropmalzpp": 525911354,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416223280,
    "dropsitcph": 6416223280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11432",
    "droptype": "D",
    "dropname": "SILVER CITY",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "SILVER CITY",
    "dropdelst": "IA",
    "dropdelzpp": 515713001,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "SILVER CITY",
    "dropphyst": "IA",
    "dropphyzpp": 515713001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER CITY",
    "dropmalst": "IA",
    "dropmalzpp": 515719998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125259860,
    "dropsitcph": 7125259860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11435",
    "droptype": "D",
    "dropname": "SIOUX CENTER",
    "dropdeladd": "100 N MAIN AVE",
    "dropdelcty": "SIOUX CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 512509998,
    "dropphyadd": "100 N MAIN AVE",
    "dropphycty": "SIOUX CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 512509998,
    "dropmaladd": "100 N MAIN AVE",
    "dropmalcty": "SIOUX CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 512509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127223437,
    "dropsitcph": 7127223437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11437",
    "droptype": "D",
    "dropname": "SIOUX CITY",
    "dropdeladd": "214 JACKSON ST",
    "dropdelcty": "SIOUX CITY",
    "dropdelst": "IA",
    "dropdelzpp": 511019998,
    "dropphyadd": "214 JACKSON ST",
    "dropphycty": "SIOUX CITY",
    "dropphyst": "IA",
    "dropphyzpp": 511019998,
    "dropmaladd": "214 JACKSON ST",
    "dropmalcty": "SIOUX CITY",
    "dropmalst": "IA",
    "dropmalzpp": 511019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122776415,
    "dropsitcph": 7122776415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11439",
    "droptype": "D",
    "dropname": "SIOUX RAPIDS",
    "dropdeladd": "114 THOMAS ST",
    "dropdelcty": "SIOUX RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 505852056,
    "dropphyadd": "114 THOMAS ST",
    "dropphycty": "SIOUX RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 505852056,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIOUX RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 505859998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122832300,
    "dropsitcph": 7122832300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11441",
    "droptype": "D",
    "dropname": "SLATER",
    "dropdeladd": "422 MAIN ST",
    "dropdelcty": "SLATER",
    "dropdelst": "IA",
    "dropdelzpp": 502447782,
    "dropphyadd": "422 MAIN ST",
    "dropphycty": "SLATER",
    "dropphyst": "IA",
    "dropphyzpp": 502447782,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLATER",
    "dropmalst": "IA",
    "dropmalzpp": 502449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154354415,
    "dropsitcph": 5154354415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11443",
    "droptype": "D",
    "dropname": "SLOAN",
    "dropdeladd": "309 4TH ST",
    "dropdelcty": "SLOAN",
    "dropdelst": "IA",
    "dropdelzpp": 510557702,
    "dropphyadd": "309 4TH ST",
    "dropphycty": "SLOAN",
    "dropphyst": "IA",
    "dropphyzpp": 510557702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLOAN",
    "dropmalst": "IA",
    "dropmalzpp": 510559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124286225,
    "dropsitcph": 7124286225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11444",
    "droptype": "D",
    "dropname": "SMITHLAND",
    "dropdeladd": "207 S HICKORY ST",
    "dropdelcty": "SMITHLAND",
    "dropdelst": "IA",
    "dropdelzpp": 510568633,
    "dropphyadd": "207 S HICKORY ST",
    "dropphycty": "SMITHLAND",
    "dropphyst": "IA",
    "dropphyzpp": 510568633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHLAND",
    "dropmalst": "IA",
    "dropmalzpp": 510569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128892145,
    "dropsitcph": 7128892145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11445",
    "droptype": "D",
    "dropname": "SOLDIER",
    "dropdeladd": "200 ELM ST",
    "dropdelcty": "SOLDIER",
    "dropdelst": "IA",
    "dropdelzpp": 515729900,
    "dropphyadd": "200 ELM ST",
    "dropphycty": "SOLDIER",
    "dropphyst": "IA",
    "dropphyzpp": 515729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOLDIER",
    "dropmalst": "IA",
    "dropmalzpp": 515729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7122082112,
    "dropsitcph": 7122082112,
    "dropfax": 7128842285
  },
  {
    "dcode": "D",
    "dropkey": "PW11446",
    "droptype": "D",
    "dropname": "SOLON",
    "dropdeladd": "1100 S MARKET ST",
    "dropdelcty": "SOLON",
    "dropdelst": "IA",
    "dropdelzpp": 523338829,
    "dropphyadd": "1100 S MARKET ST",
    "dropphycty": "SOLON",
    "dropphyst": "IA",
    "dropphyzpp": 523338829,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOLON",
    "dropmalst": "IA",
    "dropmalzpp": 523339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196242542,
    "dropsitcph": 3196242542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11447",
    "droptype": "D",
    "dropname": "SOMERS",
    "dropdeladd": "614 6TH AVE",
    "dropdelcty": "SOMERS",
    "dropdelst": "IA",
    "dropdelzpp": 505865006,
    "dropphyadd": "614 6TH AVE",
    "dropphycty": "SOMERS",
    "dropphyst": "IA",
    "dropphyzpp": 505865006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERS",
    "dropmalst": "IA",
    "dropmalzpp": 505869998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154675742,
    "dropsitcph": 5154675742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11448",
    "droptype": "D",
    "dropname": "SOUTH AMANA",
    "dropdeladd": "515 P ST",
    "dropdelcty": "SOUTH AMANA",
    "dropdelst": "IA",
    "dropdelzpp": 523348532,
    "dropphyadd": "515 P ST",
    "dropphycty": "SOUTH AMANA",
    "dropphyst": "IA",
    "dropphyzpp": 523348532,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH AMANA",
    "dropmalst": "IA",
    "dropmalzpp": 523349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196223425,
    "dropsitcph": 3196223425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11451",
    "droptype": "D",
    "dropname": "SOUTH ENGLISH",
    "dropdeladd": "210 IVES ST",
    "dropdelcty": "SOUTH ENGLISH",
    "dropdelst": "IA",
    "dropdelzpp": 523358678,
    "dropphyadd": "210 IVES ST",
    "dropphycty": "SOUTH ENGLISH",
    "dropphyst": "IA",
    "dropphyzpp": 523358678,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH ENGLISH",
    "dropmalst": "IA",
    "dropmalzpp": 523359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196672405,
    "dropsitcph": 3196672405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11456",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "11 E 18TH ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "IA",
    "dropdelzpp": 513019998,
    "dropphyadd": "11 E 18TH ST",
    "dropphycty": "SPENCER",
    "dropphyst": "IA",
    "dropphyzpp": 513019998,
    "dropmaladd": "11 E 18TH ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "IA",
    "dropmalzpp": 513019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122648815,
    "dropsitcph": 7122648815,
    "dropfax": 7122648822
  },
  {
    "dcode": "D",
    "dropkey": "PW11457",
    "droptype": "D",
    "dropname": "SPERRY",
    "dropdeladd": "11745 SPERRY RD",
    "dropdelcty": "SPERRY",
    "dropdelst": "IA",
    "dropdelzpp": 526509705,
    "dropphyadd": "11745 SPERRY RD",
    "dropphycty": "SPERRY",
    "dropphyst": "IA",
    "dropphyzpp": 526509705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDIAPOLIS",
    "dropmalst": "IA",
    "dropmalzpp": 526379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199852206,
    "dropsitcph": 3199852206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11458",
    "droptype": "D",
    "dropname": "SPILLVILLE",
    "dropdeladd": "211 S MAIN ST",
    "dropdelcty": "SPILLVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 521684400,
    "dropphyadd": "211 S MAIN ST",
    "dropphycty": "SPILLVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 521684400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPILLVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 521689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635623006,
    "dropsitcph": 5635623006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11459",
    "droptype": "D",
    "dropname": "SPIRIT LAKE",
    "dropdeladd": "1513 HILL AVE",
    "dropdelcty": "SPIRIT LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 513606700,
    "dropphyadd": "1513 HILL AVE",
    "dropphycty": "SPIRIT LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 513606700,
    "dropmaladd": "1513 HILL AVE",
    "dropmalcty": "SPIRIT LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 513606700,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123361683,
    "dropsitcph": 7123361683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11463",
    "droptype": "D",
    "dropname": "SPRINGBROOK",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "SPRINGBROOK",
    "dropdelst": "IA",
    "dropdelzpp": 520754400,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "SPRINGBROOK",
    "dropphyst": "IA",
    "dropphyzpp": 520754400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGBROOK",
    "dropmalst": "IA",
    "dropmalzpp": 520759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198725835,
    "dropsitcph": 3198725835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11465",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "262 BROADWAY ST",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 523369668,
    "dropphyadd": "262 BROADWAY ST",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 523369668,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 523369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198547240,
    "dropsitcph": 3198547240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11540",
    "droptype": "D",
    "dropname": "STACYVILLE",
    "dropdeladd": "107 N BROAD ST",
    "dropdelcty": "STACYVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 504765054,
    "dropphyadd": "107 N BROAD ST",
    "dropphycty": "STACYVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 504765054,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STACYVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 504769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417102572,
    "dropsitcph": 6417102572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11541",
    "droptype": "D",
    "dropname": "STANHOPE",
    "dropdeladd": "605 PARKER ST",
    "dropdelcty": "STANHOPE",
    "dropdelst": "IA",
    "dropdelzpp": 502467721,
    "dropphyadd": "605 PARKER ST",
    "dropphycty": "STANHOPE",
    "dropphyst": "IA",
    "dropphyzpp": 502467721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANHOPE",
    "dropmalst": "IA",
    "dropmalzpp": 502469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158263264,
    "dropsitcph": 5158263264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11543",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "304 BROAD AVE",
    "dropdelcty": "STANTON",
    "dropdelst": "IA",
    "dropdelzpp": 515732028,
    "dropphyadd": "304 BROAD AVE",
    "dropphycty": "STANTON",
    "dropphyst": "IA",
    "dropphyzpp": 515732028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANTON",
    "dropmalst": "IA",
    "dropmalzpp": 515739998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7128292375,
    "dropsitcph": 7128292375,
    "dropfax": 7128292375
  },
  {
    "dcode": "D",
    "dropkey": "PW11544",
    "droptype": "D",
    "dropname": "STANWOOD",
    "dropdeladd": "206 E BROADWAY ST",
    "dropdelcty": "STANWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 523379764,
    "dropphyadd": "206 E BROADWAY ST",
    "dropphycty": "STANWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 523379764,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 523379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5639453987,
    "dropsitcph": 5639453987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11546",
    "droptype": "D",
    "dropname": "STATE CENTER",
    "dropdeladd": "114 MAIN ST E",
    "dropdelcty": "STATE CENTER",
    "dropdelst": "IA",
    "dropdelzpp": 502477765,
    "dropphyadd": "114 MAIN ST E",
    "dropphycty": "STATE CENTER",
    "dropphyst": "IA",
    "dropphyzpp": 502477765,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STATE CENTER",
    "dropmalst": "IA",
    "dropmalzpp": 502479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414832369,
    "dropsitcph": 6414832369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11549",
    "droptype": "D",
    "dropname": "STEAMBOAT ROCK",
    "dropdeladd": "108 4TH ST",
    "dropdelcty": "STEAMBOAT ROCK",
    "dropdelst": "IA",
    "dropdelzpp": 506721021,
    "dropphyadd": "108 4TH ST",
    "dropphycty": "STEAMBOAT ROCK",
    "dropphyst": "IA",
    "dropphyzpp": 506721021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEAMBOAT ROCK",
    "dropmalst": "IA",
    "dropmalzpp": 506729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418682115,
    "dropsitcph": 6418682115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11552",
    "droptype": "D",
    "dropname": "STOCKPORT",
    "dropdeladd": "121 S MAIN ST",
    "dropdelcty": "STOCKPORT",
    "dropdelst": "IA",
    "dropdelzpp": 526517715,
    "dropphyadd": "121 S MAIN ST",
    "dropphycty": "STOCKPORT",
    "dropphyst": "IA",
    "dropphyzpp": 526517715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKPORT",
    "dropmalst": "IA",
    "dropmalzpp": 526519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197964466,
    "dropsitcph": 3197964466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11553",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "318 COMMERCE ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "IA",
    "dropdelzpp": 527699000,
    "dropphyadd": "318 COMMERCE ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "IA",
    "dropphyzpp": 527699000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKTON",
    "dropmalst": "IA",
    "dropmalzpp": 527699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637854878,
    "dropsitcph": 5637854878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11555",
    "droptype": "D",
    "dropname": "STORM LAKE",
    "dropdeladd": "509 CAYUGA ST",
    "dropdelcty": "STORM LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 505882396,
    "dropphyadd": "509 CAYUGA ST",
    "dropphycty": "STORM LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 505882396,
    "dropmaladd": "509 CAYUGA ST",
    "dropmalcty": "STORM LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 505882396,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127321329,
    "dropsitcph": 7127321329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11556",
    "droptype": "D",
    "dropname": "STORY CITY",
    "dropdeladd": "613 BROAD ST",
    "dropdelcty": "STORY CITY",
    "dropdelst": "IA",
    "dropdelzpp": 502481225,
    "dropphyadd": "613 BROAD ST",
    "dropphycty": "STORY CITY",
    "dropphyst": "IA",
    "dropphyzpp": 502481225,
    "dropmaladd": "613 BROAD ST",
    "dropmalcty": "STORY CITY",
    "dropmalst": "IA",
    "dropmalzpp": 502481225,
    "dropsitphn": 5152837530,
    "dropsitlph": 5157334774,
    "dropsitcph": 5157334774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11557",
    "droptype": "D",
    "dropname": "STOUT",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "STOUT",
    "dropdelst": "IA",
    "dropdelzpp": 506735000,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "STOUT",
    "dropphyst": "IA",
    "dropphyzpp": 506735000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOUT",
    "dropmalst": "IA",
    "dropmalzpp": 506739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193461762,
    "dropsitcph": 3193461762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11558",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "720 SHAKESPEARE AVE",
    "dropdelcty": "STRATFORD",
    "dropdelst": "IA",
    "dropdelzpp": 502497775,
    "dropphyadd": "720 SHAKESPEARE AVE",
    "dropphycty": "STRATFORD",
    "dropphyst": "IA",
    "dropphyzpp": 502497775,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATFORD",
    "dropmalst": "IA",
    "dropmalzpp": 502499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158382479,
    "dropsitcph": 5158382479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11559",
    "droptype": "D",
    "dropname": "STRAWBERRY POINT",
    "dropdeladd": "132 W MISSION ST",
    "dropdelcty": "STRAWBERRY POINT",
    "dropdelst": "IA",
    "dropdelzpp": 520764400,
    "dropphyadd": "132 W MISSION ST",
    "dropphycty": "STRAWBERRY POINT",
    "dropphyst": "IA",
    "dropphyzpp": 520764400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRAWBERRY POINT",
    "dropmalst": "IA",
    "dropmalzpp": 520769998,
    "dropsitphn": 5639336050,
    "dropsitlph": 5639336050,
    "dropsitcph": 5639336050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11563",
    "droptype": "D",
    "dropname": "STUART",
    "dropdeladd": "208 NE 2ND ST",
    "dropdelcty": "STUART",
    "dropdelst": "IA",
    "dropdelzpp": 502507700,
    "dropphyadd": "208 NE 2ND ST",
    "dropphycty": "STUART",
    "dropphyst": "IA",
    "dropphyzpp": 502507700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STUART",
    "dropmalst": "IA",
    "dropmalzpp": 502509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5155232716,
    "dropsitcph": 5155232716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11565",
    "droptype": "D",
    "dropname": "SULLY",
    "dropdeladd": "624 4TH ST",
    "dropdelcty": "SULLY",
    "dropdelst": "IA",
    "dropdelzpp": 502517707,
    "dropphyadd": "624 4TH ST",
    "dropphycty": "SULLY",
    "dropphyst": "IA",
    "dropphyzpp": 502517707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SULLY",
    "dropmalst": "IA",
    "dropmalzpp": 502519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415942755,
    "dropsitcph": 6415942755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11569",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "113 S CARPENTER ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "IA",
    "dropdelzpp": 506741443,
    "dropphyadd": "113 S CARPENTER ST",
    "dropphycty": "SUMNER",
    "dropphyst": "IA",
    "dropphyzpp": 506741443,
    "dropmaladd": "113 S CARPENTER ST",
    "dropmalcty": "SUMNER",
    "dropmalst": "IA",
    "dropmalzpp": 506741443,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635785411,
    "dropsitcph": 5635785411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11571",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "110 7TH ST",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "IA",
    "dropdelzpp": 513637700,
    "dropphyadd": "110 7TH ST",
    "dropphycty": "SUPERIOR",
    "dropphyst": "IA",
    "dropphyzpp": 513637700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "IA",
    "dropmalzpp": 513639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128584480,
    "dropsitcph": 7128584480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11572",
    "droptype": "D",
    "dropname": "SUTHERLAND",
    "dropdeladd": "111 W 1ST ST",
    "dropdelcty": "SUTHERLAND",
    "dropdelst": "IA",
    "dropdelzpp": 510587720,
    "dropphyadd": "111 W 1ST ST",
    "dropphycty": "SUTHERLAND",
    "dropphyst": "IA",
    "dropphyzpp": 510587720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUTHERLAND",
    "dropmalst": "IA",
    "dropmalzpp": 510589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122218444,
    "dropsitcph": 7122218444,
    "dropfax": 7124463421
  },
  {
    "dcode": "D",
    "dropkey": "PW11574",
    "droptype": "D",
    "dropname": "SWALEDALE",
    "dropdeladd": "202 5TH ST S",
    "dropdelcty": "SWALEDALE",
    "dropdelst": "IA",
    "dropdelzpp": 504778825,
    "dropphyadd": "202 5TH ST S",
    "dropphycty": "SWALEDALE",
    "dropphyst": "IA",
    "dropphyzpp": 504778825,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWALEDALE",
    "dropmalst": "IA",
    "dropmalzpp": 504779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419952332,
    "dropsitcph": 6419952332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11576",
    "droptype": "D",
    "dropname": "SWEA CITY",
    "dropdeladd": "202 3RD AVE W",
    "dropdelcty": "SWEA CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505901107,
    "dropphyadd": "202 3RD AVE W",
    "dropphycty": "SWEA CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505901107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWEA CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505909998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152724690,
    "dropsitcph": 5152724690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11577",
    "droptype": "D",
    "dropname": "SWEDESBURG",
    "dropdeladd": "101 JAMES AVE",
    "dropdelcty": "SWEDESBURG",
    "dropdelst": "IA",
    "dropdelzpp": 526525000,
    "dropphyadd": "101 JAMES AVE",
    "dropphycty": "SWEDESBURG",
    "dropphyst": "IA",
    "dropphyzpp": 526525000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWEDESBURG",
    "dropmalst": "IA",
    "dropmalzpp": 526529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192542183,
    "dropsitcph": 3192542183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11579",
    "droptype": "D",
    "dropname": "SWISHER",
    "dropdeladd": "401 DIVISION ST SW",
    "dropdelcty": "SWISHER",
    "dropdelst": "IA",
    "dropdelzpp": 523389628,
    "dropphyadd": "401 DIVISION ST SW",
    "dropphycty": "SWISHER",
    "dropphyst": "IA",
    "dropphyzpp": 523389628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWISHER",
    "dropmalst": "IA",
    "dropmalzpp": 523389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198574194,
    "dropsitcph": 3198574194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11580",
    "droptype": "D",
    "dropname": "TABOR",
    "dropdeladd": "502 ORANGE ST",
    "dropdelcty": "TABOR",
    "dropdelst": "IA",
    "dropdelzpp": 516532074,
    "dropphyadd": "502 ORANGE ST",
    "dropphycty": "TABOR",
    "dropphyst": "IA",
    "dropphyzpp": 516532074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TABOR",
    "dropmalst": "IA",
    "dropmalzpp": 516539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126291075,
    "dropsitcph": 7126291075,
    "dropfax": 7126291075
  },
  {
    "dcode": "D",
    "dropkey": "PW11584",
    "droptype": "D",
    "dropname": "TAMA",
    "dropdeladd": "412 STATE ST",
    "dropdelcty": "TAMA",
    "dropdelst": "IA",
    "dropdelzpp": 523399998,
    "dropphyadd": "412 STATE ST",
    "dropphycty": "TAMA",
    "dropphyst": "IA",
    "dropphyzpp": 523399998,
    "dropmaladd": "412 STATE ST",
    "dropmalcty": "TAMA",
    "dropmalst": "IA",
    "dropmalzpp": 523399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414843220,
    "dropsitcph": 6414843220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11589",
    "droptype": "D",
    "dropname": "TEMPLETON",
    "dropdeladd": "203 S MAIN ST",
    "dropdelcty": "TEMPLETON",
    "dropdelst": "IA",
    "dropdelzpp": 514632309,
    "dropphyadd": "203 S MAIN ST",
    "dropphycty": "TEMPLETON",
    "dropphyst": "IA",
    "dropphyzpp": 514632309,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEMPLETON",
    "dropmalst": "IA",
    "dropmalzpp": 514639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126693340,
    "dropsitcph": 7126693340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11593",
    "droptype": "D",
    "dropname": "TERRIL",
    "dropdeladd": "109 S STATE ST",
    "dropdelcty": "TERRIL",
    "dropdelst": "IA",
    "dropdelzpp": 513647706,
    "dropphyadd": "109 S STATE ST",
    "dropphycty": "TERRIL",
    "dropphyst": "IA",
    "dropphyzpp": 513647706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TERRIL",
    "dropmalst": "IA",
    "dropmalzpp": 513649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128536497,
    "dropsitcph": 7128536497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11597",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "132 N JACKSON ST",
    "dropdelcty": "THOMPSON",
    "dropdelst": "IA",
    "dropdelzpp": 504785035,
    "dropphyadd": "132 N JACKSON ST",
    "dropphycty": "THOMPSON",
    "dropphyst": "IA",
    "dropphyzpp": 504785035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMPSON",
    "dropmalst": "IA",
    "dropmalzpp": 504789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6415842460,
    "dropsitcph": 6415842460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11598",
    "droptype": "D",
    "dropname": "THOR",
    "dropdeladd": "215 N ANN ST",
    "dropdelcty": "THOR",
    "dropdelst": "IA",
    "dropdelzpp": 505915000,
    "dropphyadd": "215 N ANN ST",
    "dropphycty": "THOR",
    "dropphyst": "IA",
    "dropphyzpp": 505915000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOR",
    "dropmalst": "IA",
    "dropmalzpp": 505919998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153783349,
    "dropsitcph": 5153783349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11599",
    "droptype": "D",
    "dropname": "THORNBURG",
    "dropdeladd": "1009 BROADWAY ST",
    "dropdelcty": "THORNBURG",
    "dropdelst": "IA",
    "dropdelzpp": 502555000,
    "dropphyadd": "1009 BROADWAY ST",
    "dropphycty": "THORNBURG",
    "dropphyst": "IA",
    "dropphyzpp": 502555000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THORNBURG",
    "dropmalst": "IA",
    "dropmalzpp": 502559998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416342441,
    "dropsitcph": 6416342441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11600",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "313 MAIN ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "IA",
    "dropdelzpp": 504797720,
    "dropphyadd": "313 MAIN ST",
    "dropphycty": "THORNTON",
    "dropphyst": "IA",
    "dropphyzpp": 504797720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THORNTON",
    "dropmalst": "IA",
    "dropmalzpp": 504799998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419982215,
    "dropsitcph": 6419982215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11602",
    "droptype": "D",
    "dropname": "THURMAN",
    "dropdeladd": "611 WEST ST",
    "dropdelcty": "THURMAN",
    "dropdelst": "IA",
    "dropdelzpp": 516542100,
    "dropphyadd": "611 WEST ST",
    "dropphycty": "THURMAN",
    "dropphyst": "IA",
    "dropphyzpp": 516542100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THURMAN",
    "dropmalst": "IA",
    "dropmalzpp": 516549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7126282144,
    "dropsitcph": 7126282144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11604",
    "droptype": "D",
    "dropname": "TIFFIN",
    "dropdeladd": "484 STATE ST",
    "dropdelcty": "TIFFIN",
    "dropdelst": "IA",
    "dropdelzpp": 523404402,
    "dropphyadd": "484 STATE ST",
    "dropphycty": "TIFFIN",
    "dropphyst": "IA",
    "dropphyzpp": 523404402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIFFIN",
    "dropmalst": "IA",
    "dropmalzpp": 523409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192490616,
    "dropsitcph": 3192490616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11606",
    "droptype": "D",
    "dropname": "TINGLEY",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "TINGLEY",
    "dropdelst": "IA",
    "dropdelzpp": 508639900,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "TINGLEY",
    "dropphyst": "IA",
    "dropphyzpp": 508639900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TINGLEY",
    "dropmalst": "IA",
    "dropmalzpp": 508639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417724425,
    "dropsitcph": 6417724425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11607",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "512 LYNN ST",
    "dropdelcty": "TIPTON",
    "dropdelst": "IA",
    "dropdelzpp": 527729998,
    "dropphyadd": "512 LYNN ST",
    "dropphycty": "TIPTON",
    "dropphyst": "IA",
    "dropphyzpp": 527729998,
    "dropmaladd": "512 LYNN ST",
    "dropmalcty": "TIPTON",
    "dropmalst": "IA",
    "dropmalzpp": 527729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638862129,
    "dropsitcph": 5638862129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11608",
    "droptype": "D",
    "dropname": "TITONKA",
    "dropdeladd": "259 MAIN ST N",
    "dropdelcty": "TITONKA",
    "dropdelst": "IA",
    "dropdelzpp": 504807725,
    "dropphyadd": "259 MAIN ST N",
    "dropphycty": "TITONKA",
    "dropphyst": "IA",
    "dropphyzpp": 504807725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TITONKA",
    "dropmalst": "IA",
    "dropmalzpp": 504809998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159282505,
    "dropsitcph": 5159282505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11611",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "200 W HIGH ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "IA",
    "dropdelzpp": 523421344,
    "dropphyadd": "200 W HIGH ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "IA",
    "dropphyzpp": 523421344,
    "dropmaladd": "200 W HIGH ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "IA",
    "dropmalzpp": 523421344,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414843560,
    "dropsitcph": 6414843560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11614",
    "droptype": "D",
    "dropname": "TRACY",
    "dropdeladd": "513 BRADLEY ST",
    "dropdelcty": "TRACY",
    "dropdelst": "IA",
    "dropdelzpp": 502568556,
    "dropphyadd": "513 BRADLEY ST",
    "dropphycty": "TRACY",
    "dropphyst": "IA",
    "dropphyzpp": 502568556,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRACY",
    "dropmalst": "IA",
    "dropmalzpp": 502569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419496421,
    "dropsitcph": 6419496421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11615",
    "droptype": "D",
    "dropname": "TRAER",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "TRAER",
    "dropdelst": "IA",
    "dropdelzpp": 506751027,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "TRAER",
    "dropphyst": "IA",
    "dropphyzpp": 506751027,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "TRAER",
    "dropmalst": "IA",
    "dropmalzpp": 506751027,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194788100,
    "dropsitcph": 3194788100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11617",
    "droptype": "D",
    "dropname": "TREYNOR",
    "dropdeladd": "5 N EYBERG AVE",
    "dropdelcty": "TREYNOR",
    "dropdelst": "IA",
    "dropdelzpp": 515759700,
    "dropphyadd": "5 N EYBERG AVE",
    "dropphycty": "TREYNOR",
    "dropphyst": "IA",
    "dropphyzpp": 515759700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TREYNOR",
    "dropmalst": "IA",
    "dropmalzpp": 515759998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7124873300,
    "dropsitcph": 7124873300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11619",
    "droptype": "D",
    "dropname": "TRIPOLI",
    "dropdeladd": "114 S MAIN ST",
    "dropdelcty": "TRIPOLI",
    "dropdelst": "IA",
    "dropdelzpp": 506767713,
    "dropphyadd": "114 S MAIN ST",
    "dropphycty": "TRIPOLI",
    "dropphyst": "IA",
    "dropphyzpp": 506767713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRIPOLI",
    "dropmalst": "IA",
    "dropmalzpp": 506769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194016000,
    "dropsitcph": 3194016000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11621",
    "droptype": "D",
    "dropname": "TROY MILLS",
    "dropdeladd": "5923 MAIN ST",
    "dropdelcty": "TROY MILLS",
    "dropdelst": "IA",
    "dropdelzpp": 523448800,
    "dropphyadd": "5923 MAIN ST",
    "dropphycty": "TROY MILLS",
    "dropphyst": "IA",
    "dropphyzpp": 523448800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROY MILLS",
    "dropmalst": "IA",
    "dropmalzpp": 523449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192243206,
    "dropsitcph": 3192243206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11623",
    "droptype": "D",
    "dropname": "TRUESDALE",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "TRUESDALE",
    "dropdelst": "IA",
    "dropdelzpp": 505925001,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "TRUESDALE",
    "dropphyst": "IA",
    "dropphyzpp": 505925001,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "TRUESDALE",
    "dropmalst": "IA",
    "dropmalzpp": 505925001,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127325451,
    "dropsitcph": 7127325451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11624",
    "droptype": "D",
    "dropname": "TRURO",
    "dropdeladd": "200 E NORTH ST",
    "dropdelcty": "TRURO",
    "dropdelst": "IA",
    "dropdelzpp": 502571014,
    "dropphyadd": "200 E NORTH ST",
    "dropphycty": "TRURO",
    "dropphyst": "IA",
    "dropphyzpp": 502571014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRURO",
    "dropmalst": "IA",
    "dropmalzpp": 502579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6417654804,
    "dropsitcph": 6417654804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11631",
    "droptype": "D",
    "dropname": "UNDERWOOD",
    "dropdeladd": "313 3RD ST",
    "dropdelcty": "UNDERWOOD",
    "dropdelst": "IA",
    "dropdelzpp": 515768019,
    "dropphyadd": "313 3RD ST",
    "dropphycty": "UNDERWOOD",
    "dropphyst": "IA",
    "dropphyzpp": 515768019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNDERWOOD",
    "dropmalst": "IA",
    "dropmalzpp": 515769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125662324,
    "dropsitcph": 7125662324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11632",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "307 CENTER ST",
    "dropdelcty": "UNION",
    "dropdelst": "IA",
    "dropdelzpp": 502587810,
    "dropphyadd": "307 CENTER ST",
    "dropphycty": "UNION",
    "dropphyst": "IA",
    "dropphyzpp": 502587810,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION",
    "dropmalst": "IA",
    "dropmalzpp": 502589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414862557,
    "dropsitcph": 6414862557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11635",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "105 W UNION ST",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "IA",
    "dropdelzpp": 525947721,
    "dropphyadd": "105 W UNION ST",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "IA",
    "dropphyzpp": 525947721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "IA",
    "dropmalzpp": 525949998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414526660,
    "dropsitcph": 6414526660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11639",
    "droptype": "D",
    "dropname": "UNIVERSITY PARK",
    "dropdeladd": "2204 9TH AVE E",
    "dropdelcty": "UNIVERSITY PARK",
    "dropdelst": "IA",
    "dropdelzpp": 525957700,
    "dropphyadd": "2204 9TH AVE E",
    "dropphycty": "UNIVERSITY PARK",
    "dropphyst": "IA",
    "dropphyzpp": 525957700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIVERSITY PARK",
    "dropmalst": "IA",
    "dropmalzpp": 525959998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416735369,
    "dropsitcph": 6416735369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11643",
    "droptype": "D",
    "dropname": "URBANA",
    "dropdeladd": "304 W WOOD ST",
    "dropdelcty": "URBANA",
    "dropdelst": "IA",
    "dropdelzpp": 523459105,
    "dropphyadd": "304 W WOOD ST",
    "dropphycty": "URBANA",
    "dropphyst": "IA",
    "dropphyzpp": 523459105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "URBANA",
    "dropmalst": "IA",
    "dropmalzpp": 523459998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192490581,
    "dropsitcph": 3192490581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11646",
    "droptype": "D",
    "dropname": "UTE",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "UTE",
    "dropdelst": "IA",
    "dropdelzpp": 510601062,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "UTE",
    "dropphyst": "IA",
    "dropphyzpp": 510601062,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UTE",
    "dropmalst": "IA",
    "dropmalzpp": 510609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128852287,
    "dropsitcph": 7128852287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11647",
    "droptype": "D",
    "dropname": "VAIL",
    "dropdeladd": "117 HIGHWAY 30",
    "dropdelcty": "VAIL",
    "dropdelst": "IA",
    "dropdelzpp": 514657701,
    "dropphyadd": "117 HIGHWAY 30",
    "dropphycty": "VAIL",
    "dropphyst": "IA",
    "dropphyzpp": 514657701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAIL",
    "dropmalst": "IA",
    "dropmalzpp": 514659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126772222,
    "dropsitcph": 7126772222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11650",
    "droptype": "D",
    "dropname": "VAN HORNE",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "VAN HORNE",
    "dropdelst": "IA",
    "dropdelzpp": 523469718,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "VAN HORNE",
    "dropphyst": "IA",
    "dropphyzpp": 523469718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN HORNE",
    "dropmalst": "IA",
    "dropmalzpp": 523469998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192288175,
    "dropsitcph": 3192288175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11651",
    "droptype": "D",
    "dropname": "VAN METER",
    "dropdeladd": "409 GRANT ST",
    "dropdelcty": "VAN METER",
    "dropdelst": "IA",
    "dropdelzpp": 502619770,
    "dropphyadd": "409 GRANT ST",
    "dropphycty": "VAN METER",
    "dropphyst": "IA",
    "dropphyzpp": 502619770,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN METER",
    "dropmalst": "IA",
    "dropmalzpp": 502619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159962458,
    "dropsitcph": 5159962458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11652",
    "droptype": "D",
    "dropname": "VAN WERT",
    "dropdeladd": "101 S CHAMPA ST",
    "dropdelcty": "VAN WERT",
    "dropdelst": "IA",
    "dropdelzpp": 502625000,
    "dropphyadd": "101 S CHAMPA ST",
    "dropphycty": "VAN WERT",
    "dropphyst": "IA",
    "dropphyzpp": 502625000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN WERT",
    "dropmalst": "IA",
    "dropmalzpp": 502629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414455139,
    "dropsitcph": 6414455139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11654",
    "droptype": "D",
    "dropname": "VARINA",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "VARINA",
    "dropdelst": "IA",
    "dropdelzpp": 505935000,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "VARINA",
    "dropphyst": "IA",
    "dropphyzpp": 505935000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VARINA",
    "dropmalst": "IA",
    "dropmalzpp": 505939998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7122886508,
    "dropsitcph": 7122886508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11655",
    "droptype": "D",
    "dropname": "VENTURA",
    "dropdeladd": "101 N WEIMER ST",
    "dropdelcty": "VENTURA",
    "dropdelst": "IA",
    "dropdelzpp": 504825035,
    "dropphyadd": "101 N WEIMER ST",
    "dropphycty": "VENTURA",
    "dropphyst": "IA",
    "dropphyzpp": 504825035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENTURA",
    "dropmalst": "IA",
    "dropmalzpp": 504829998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418293518,
    "dropsitcph": 6418293518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11659",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "108 WASHINGTON ST",
    "dropdelcty": "VICTOR",
    "dropdelst": "IA",
    "dropdelzpp": 523477779,
    "dropphyadd": "108 WASHINGTON ST",
    "dropphycty": "VICTOR",
    "dropphyst": "IA",
    "dropphyzpp": 523477779,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VICTOR",
    "dropmalst": "IA",
    "dropmalzpp": 523479998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196473347,
    "dropsitcph": 3196473347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11661",
    "droptype": "D",
    "dropname": "VILLISCA",
    "dropdeladd": "500 S 3RD AVE",
    "dropdelcty": "VILLISCA",
    "dropdelst": "IA",
    "dropdelzpp": 508649998,
    "dropphyadd": "500 S 3RD AVE",
    "dropphycty": "VILLISCA",
    "dropphyst": "IA",
    "dropphyzpp": 508649998,
    "dropmaladd": "500 S 3RD AVE",
    "dropmalcty": "VILLISCA",
    "dropmalst": "IA",
    "dropmalzpp": 508649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7123277053,
    "dropsitcph": 7123277053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11662",
    "droptype": "D",
    "dropname": "VINCENT",
    "dropdeladd": "104 N 1ST ST",
    "dropdelcty": "VINCENT",
    "dropdelst": "IA",
    "dropdelzpp": 505947506,
    "dropphyadd": "104 N 1ST ST",
    "dropphycty": "VINCENT",
    "dropphyst": "IA",
    "dropphyzpp": 505947506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VINCENT",
    "dropmalst": "IA",
    "dropmalzpp": 505949998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5153562105,
    "dropsitcph": 5153562105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11663",
    "droptype": "D",
    "dropname": "VINING",
    "dropdeladd": "306 1ST ST",
    "dropdelcty": "VINING",
    "dropdelst": "IA",
    "dropdelzpp": 523488800,
    "dropphyadd": "306 1ST ST",
    "dropphycty": "VINING",
    "dropphyst": "IA",
    "dropphyzpp": 523488800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VINING",
    "dropmalst": "IA",
    "dropmalzpp": 523489998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414892065,
    "dropsitcph": 6414892065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11664",
    "droptype": "D",
    "dropname": "VINTON",
    "dropdeladd": "516 1ST AVE",
    "dropdelcty": "VINTON",
    "dropdelst": "IA",
    "dropdelzpp": 523499998,
    "dropphyadd": "516 1ST AVE",
    "dropphycty": "VINTON",
    "dropphyst": "IA",
    "dropphyzpp": 523499998,
    "dropmaladd": "516 1ST AVE",
    "dropmalcty": "VINTON",
    "dropmalst": "IA",
    "dropmalzpp": 523499998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194723227,
    "dropsitcph": 3194723227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11668",
    "droptype": "D",
    "dropname": "VOLGA",
    "dropdeladd": "501 WASHINGTON ST",
    "dropdelcty": "VOLGA",
    "dropdelst": "IA",
    "dropdelzpp": 520777731,
    "dropphyadd": "501 WASHINGTON ST",
    "dropphycty": "VOLGA",
    "dropphyst": "IA",
    "dropphyzpp": 520777731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VOLGA",
    "dropmalst": "IA",
    "dropmalzpp": 520779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637674002,
    "dropsitcph": 5637674002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11677",
    "droptype": "D",
    "dropname": "WADENA",
    "dropdeladd": "124 E 2ND AVE",
    "dropdelcty": "WADENA",
    "dropdelst": "IA",
    "dropdelzpp": 521694400,
    "dropphyadd": "124 E 2ND AVE",
    "dropphycty": "WADENA",
    "dropphyst": "IA",
    "dropphyzpp": 521694400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADENA",
    "dropmalst": "IA",
    "dropmalzpp": 521699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637743475,
    "dropsitcph": 5637743475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11680",
    "droptype": "D",
    "dropname": "WALCOTT",
    "dropdeladd": "117 E BRYANT ST",
    "dropdelcty": "WALCOTT",
    "dropdelst": "IA",
    "dropdelzpp": 527737703,
    "dropphyadd": "117 E BRYANT ST",
    "dropphycty": "WALCOTT",
    "dropphyst": "IA",
    "dropphyzpp": 527737703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALCOTT",
    "dropmalst": "IA",
    "dropmalzpp": 527739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632846446,
    "dropsitcph": 5632846446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11681",
    "droptype": "D",
    "dropname": "WALFORD",
    "dropdeladd": "100 HIGHWAY 151 W",
    "dropdelcty": "WALFORD",
    "dropdelst": "IA",
    "dropdelzpp": 523518013,
    "dropphyadd": "100 HIGHWAY 151 W",
    "dropphycty": "WALFORD",
    "dropphyst": "IA",
    "dropphyzpp": 523518013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALFORD",
    "dropmalst": "IA",
    "dropmalzpp": 523519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198462801,
    "dropsitcph": 3198462801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11682",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "117 GREENE ST",
    "dropdelcty": "WALKER",
    "dropdelst": "IA",
    "dropdelzpp": 523529400,
    "dropphyadd": "117 GREENE ST",
    "dropphycty": "WALKER",
    "dropphyst": "IA",
    "dropphyzpp": 523529400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALKER",
    "dropmalst": "IA",
    "dropmalzpp": 523529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3194482020,
    "dropsitcph": 3194482020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11683",
    "droptype": "D",
    "dropname": "WALL LAKE",
    "dropdeladd": "106 BOYER ST",
    "dropdelcty": "WALL LAKE",
    "dropdelst": "IA",
    "dropdelzpp": 514667030,
    "dropphyadd": "106 BOYER ST",
    "dropphycty": "WALL LAKE",
    "dropphyst": "IA",
    "dropphyzpp": 514667030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALL LAKE",
    "dropmalst": "IA",
    "dropmalzpp": 514669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126642034,
    "dropsitcph": 7126642034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11684",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "18 SAINT JAMES AVE",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "IA",
    "dropdelzpp": 513657701,
    "dropphyadd": "18 SAINT JAMES AVE",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "IA",
    "dropphyzpp": 513657701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "IA",
    "dropmalzpp": 513659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128674521,
    "dropsitcph": 7128674521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11685",
    "droptype": "D",
    "dropname": "WALNUT",
    "dropdeladd": "217 ANTIQUE CITY DR",
    "dropdelcty": "WALNUT",
    "dropdelst": "IA",
    "dropdelzpp": 515772000,
    "dropphyadd": "217 ANTIQUE CITY DR",
    "dropphycty": "WALNUT",
    "dropphyst": "IA",
    "dropphyzpp": 515772000,
    "dropmaladd": "217 ANTIQUE CITY DR",
    "dropmalcty": "WALNUT",
    "dropmalst": "IA",
    "dropmalzpp": 515772000,
    "dropsitphn": 4023482736,
    "dropsitlph": 7127843883,
    "dropsitcph": 7127843883,
    "dropfax": 7127843883
  },
  {
    "dcode": "D",
    "dropkey": "PW11687",
    "droptype": "D",
    "dropname": "WAPELLO",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "WAPELLO",
    "dropdelst": "IA",
    "dropdelzpp": 526531207,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "WAPELLO",
    "dropphyst": "IA",
    "dropphyzpp": 526531207,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "WAPELLO",
    "dropmalst": "IA",
    "dropmalzpp": 526531207,
    "dropsitphn": 5152837530,
    "dropsitlph": 3195234932,
    "dropsitcph": 3195234932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11690",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "115 N MARION AVE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 523531758,
    "dropphyadd": "115 N MARION AVE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 523531758,
    "dropmaladd": "115 N MARION AVE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 523531758,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196532385,
    "dropsitcph": 3196532385,
    "dropfax": 3196533804
  },
  {
    "dcode": "D",
    "dropkey": "PW11691",
    "droptype": "D",
    "dropname": "WASHTA",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "WASHTA",
    "dropdelst": "IA",
    "dropdelzpp": 510611018,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "WASHTA",
    "dropphyst": "IA",
    "dropphyzpp": 510611018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHTA",
    "dropmalst": "IA",
    "dropmalzpp": 510619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124476146,
    "dropsitcph": 7124476146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11693",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "300 SYCAMORE ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "IA",
    "dropdelzpp": 507019998,
    "dropphyadd": "300 SYCAMORE ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "IA",
    "dropphyzpp": 507019998,
    "dropmaladd": "300 SYCAMORE ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "IA",
    "dropmalzpp": 507019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192742221,
    "dropsitcph": 3192742210,
    "dropfax": 3192742275
  },
  {
    "dcode": "D",
    "dropkey": "PW11695",
    "droptype": "D",
    "dropname": "WATKINS",
    "dropdeladd": "206 1ST ST",
    "dropdelcty": "WATKINS",
    "dropdelst": "IA",
    "dropdelzpp": 523549660,
    "dropphyadd": "206 1ST ST",
    "dropphycty": "WATKINS",
    "dropphyst": "IA",
    "dropphyzpp": 523549660,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATKINS",
    "dropmalst": "IA",
    "dropmalzpp": 523549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192277788,
    "dropsitcph": 3192277788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11698",
    "droptype": "D",
    "dropname": "WAUCOMA",
    "dropdeladd": "106 RIVERVIEW DR",
    "dropdelcty": "WAUCOMA",
    "dropdelst": "IA",
    "dropdelzpp": 521719463,
    "dropphyadd": "106 RIVERVIEW DR",
    "dropphycty": "WAUCOMA",
    "dropphyst": "IA",
    "dropphyzpp": 521719463,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUCOMA",
    "dropmalst": "IA",
    "dropmalzpp": 521719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637767841,
    "dropsitcph": 5637767841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11699",
    "droptype": "D",
    "dropname": "WAUKEE",
    "dropdeladd": "500 W HICKMAN RD",
    "dropdelcty": "WAUKEE",
    "dropdelst": "IA",
    "dropdelzpp": 502637713,
    "dropphyadd": "500 W HICKMAN RD",
    "dropphycty": "WAUKEE",
    "dropphyst": "IA",
    "dropphyzpp": 502637713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUKEE",
    "dropmalst": "IA",
    "dropmalzpp": 502639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159875409,
    "dropsitcph": 5159875409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11700",
    "droptype": "D",
    "dropname": "WAUKON",
    "dropdeladd": "113 W MAIN ST",
    "dropdelcty": "WAUKON",
    "dropdelst": "IA",
    "dropdelzpp": 521721663,
    "dropphyadd": "113 W MAIN ST",
    "dropphycty": "WAUKON",
    "dropphyst": "IA",
    "dropphyzpp": 521721663,
    "dropmaladd": "113 W MAIN ST",
    "dropmalcty": "WAUKON",
    "dropmalst": "IA",
    "dropmalzpp": 521721663,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635682401,
    "dropsitcph": 5635682401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11703",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "124 2ND ST SE",
    "dropdelcty": "WAVERLY",
    "dropdelst": "IA",
    "dropdelzpp": 506779998,
    "dropphyadd": "124 2ND ST SE",
    "dropphycty": "WAVERLY",
    "dropphyst": "IA",
    "dropphyzpp": 506779998,
    "dropmaladd": "124 2ND ST SE",
    "dropmalcty": "WAVERLY",
    "dropmalst": "IA",
    "dropmalzpp": 506779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193524395,
    "dropsitcph": 3193524395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11704",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "209 W MAIN ST",
    "dropdelcty": "WAYLAND",
    "dropdelst": "IA",
    "dropdelzpp": 526549760,
    "dropphyadd": "209 W MAIN ST",
    "dropphycty": "WAYLAND",
    "dropphyst": "IA",
    "dropphyzpp": 526549760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYLAND",
    "dropmalst": "IA",
    "dropmalzpp": 526549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192564413,
    "dropsitcph": 3192564413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11705",
    "droptype": "D",
    "dropname": "WEBB",
    "dropdeladd": "104 2ND AVE",
    "dropdelcty": "WEBB",
    "dropdelst": "IA",
    "dropdelzpp": 513667582,
    "dropphyadd": "104 2ND AVE",
    "dropphycty": "WEBB",
    "dropphyst": "IA",
    "dropphyzpp": 513667582,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBB",
    "dropmalst": "IA",
    "dropmalzpp": 513669998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7128387710,
    "dropsitcph": 7128387710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11708",
    "droptype": "D",
    "dropname": "WEBSTER CITY",
    "dropdeladd": "805 SENECA ST",
    "dropdelcty": "WEBSTER CITY",
    "dropdelst": "IA",
    "dropdelzpp": 505959998,
    "dropphyadd": "805 SENECA ST",
    "dropphycty": "WEBSTER CITY",
    "dropphyst": "IA",
    "dropphyzpp": 505959998,
    "dropmaladd": "805 SENECA ST",
    "dropmalcty": "WEBSTER CITY",
    "dropmalst": "IA",
    "dropmalzpp": 505959998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158321611,
    "dropsitcph": 5158321611,
    "dropfax": 5158326970
  },
  {
    "dcode": "D",
    "dropkey": "PW11711",
    "droptype": "D",
    "dropname": "WELDON",
    "dropdeladd": "202 HIGHWAY J12",
    "dropdelcty": "WELDON",
    "dropdelst": "IA",
    "dropdelzpp": 502648549,
    "dropphyadd": "202 HIGHWAY J12",
    "dropphycty": "WELDON",
    "dropphyst": "IA",
    "dropphyzpp": 502648549,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELDON",
    "dropmalst": "IA",
    "dropmalzpp": 502649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414455311,
    "dropsitcph": 6414455311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11713",
    "droptype": "D",
    "dropname": "WELLMAN",
    "dropdeladd": "310 9TH AVE",
    "dropdelcty": "WELLMAN",
    "dropdelst": "IA",
    "dropdelzpp": 523569301,
    "dropphyadd": "310 9TH AVE",
    "dropphycty": "WELLMAN",
    "dropphyst": "IA",
    "dropphyzpp": 523569301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLMAN",
    "dropmalst": "IA",
    "dropmalzpp": 523569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192598019,
    "dropsitcph": 3192598019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11714",
    "droptype": "D",
    "dropname": "WELLSBURG",
    "dropdeladd": "500 N ADAMS ST",
    "dropdelcty": "WELLSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 506807811,
    "dropphyadd": "500 N ADAMS ST",
    "dropphycty": "WELLSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 506807811,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 506809998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418695255,
    "dropsitcph": 6418695255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11715",
    "droptype": "D",
    "dropname": "WELTON",
    "dropdeladd": "502 MAIN ST",
    "dropdelcty": "WELTON",
    "dropdelst": "IA",
    "dropdelzpp": 527749007,
    "dropphyadd": "502 MAIN ST",
    "dropphycty": "WELTON",
    "dropphyst": "IA",
    "dropphyzpp": 527749007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELTON",
    "dropmalst": "IA",
    "dropmalzpp": 527749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196598454,
    "dropsitcph": 3196598454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11716",
    "droptype": "D",
    "dropname": "WESLEY",
    "dropdeladd": "105 MAIN ST W",
    "dropdelcty": "WESLEY",
    "dropdelst": "IA",
    "dropdelzpp": 504837761,
    "dropphyadd": "105 MAIN ST W",
    "dropphycty": "WESLEY",
    "dropphyst": "IA",
    "dropphyzpp": 504837761,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESLEY",
    "dropmalst": "IA",
    "dropmalzpp": 504839998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156794263,
    "dropsitcph": 5156794263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11718",
    "droptype": "D",
    "dropname": "WEST BEND",
    "dropdeladd": "315 S BROADWAY AVE",
    "dropdelcty": "WEST BEND",
    "dropdelst": "IA",
    "dropdelzpp": 505977746,
    "dropphyadd": "315 S BROADWAY AVE",
    "dropphycty": "WEST BEND",
    "dropphyst": "IA",
    "dropphyzpp": 505977746,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST BEND",
    "dropmalst": "IA",
    "dropmalzpp": 505979998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158874841,
    "dropsitcph": 5158874841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11719",
    "droptype": "D",
    "dropname": "WEST BRANCH",
    "dropdeladd": "104 PARKSIDE DR",
    "dropdelcty": "WEST BRANCH",
    "dropdelst": "IA",
    "dropdelzpp": 523589669,
    "dropphyadd": "104 PARKSIDE DR",
    "dropphycty": "WEST BRANCH",
    "dropphyst": "IA",
    "dropphyzpp": 523589669,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST BRANCH",
    "dropmalst": "IA",
    "dropmalzpp": 523589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192598022,
    "dropsitcph": 3192598022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11720",
    "droptype": "D",
    "dropname": "WEST BURLINGTON",
    "dropdeladd": "201 BROADWAY ST",
    "dropdelcty": "WEST BURLINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 526551202,
    "dropphyadd": "201 BROADWAY ST",
    "dropphycty": "WEST BURLINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 526551202,
    "dropmaladd": "201 BROADWAY ST",
    "dropmalcty": "WEST BURLINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 526551202,
    "dropsitphn": 5152837530,
    "dropsitlph": 3197548588,
    "dropsitcph": 3197548588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11727",
    "droptype": "D",
    "dropname": "WEST LIBERTY",
    "dropdeladd": "203 N COLUMBUS ST",
    "dropdelcty": "WEST LIBERTY",
    "dropdelst": "IA",
    "dropdelzpp": 527769998,
    "dropphyadd": "203 N COLUMBUS ST",
    "dropphycty": "WEST LIBERTY",
    "dropphyst": "IA",
    "dropphyzpp": 527769998,
    "dropmaladd": "203 N COLUMBUS ST",
    "dropmalcty": "WEST LIBERTY",
    "dropmalst": "IA",
    "dropmalzpp": 527769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196272815,
    "dropsitcph": 3196272815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11729",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "326 4TH ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "IA",
    "dropdelzpp": 526569410,
    "dropphyadd": "326 4TH ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "IA",
    "dropphyzpp": 526569410,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST POINT",
    "dropmalst": "IA",
    "dropmalzpp": 526569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3198376611,
    "dropsitcph": 3198376611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11732",
    "droptype": "D",
    "dropname": "WEST UNION",
    "dropdeladd": "211 N VINE ST",
    "dropdelcty": "WEST UNION",
    "dropdelst": "IA",
    "dropdelzpp": 521751269,
    "dropphyadd": "211 N VINE ST",
    "dropphycty": "WEST UNION",
    "dropphyst": "IA",
    "dropphyzpp": 521751269,
    "dropmaladd": "211 N VINE ST",
    "dropmalcty": "WEST UNION",
    "dropmalst": "IA",
    "dropmalzpp": 521751269,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634223465,
    "dropsitcph": 5634223465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11735",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "220 UNION ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 510627701,
    "dropphyadd": "220 UNION ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 510627701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 510629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7125683252,
    "dropsitcph": 7125683252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11738",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "WESTSIDE",
    "dropdelst": "IA",
    "dropdelzpp": 514677592,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "WESTSIDE",
    "dropphyst": "IA",
    "dropphyzpp": 514677592,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTSIDE",
    "dropmalst": "IA",
    "dropmalzpp": 514679998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7126634416,
    "dropsitcph": 7126634416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11739",
    "droptype": "D",
    "dropname": "WEVER",
    "dropdeladd": "1694 354TH AVE",
    "dropdelcty": "WEVER",
    "dropdelst": "IA",
    "dropdelzpp": 526589582,
    "dropphyadd": "1694 354TH AVE",
    "dropphycty": "WEVER",
    "dropphyst": "IA",
    "dropphyzpp": 526589582,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEVER",
    "dropmalst": "IA",
    "dropmalzpp": 526589998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193722832,
    "dropsitcph": 3193722832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11740",
    "droptype": "D",
    "dropname": "WHAT CHEER",
    "dropdeladd": "113 S BARNES ST",
    "dropdelcty": "WHAT CHEER",
    "dropdelst": "IA",
    "dropdelzpp": 502687709,
    "dropphyadd": "113 S BARNES ST",
    "dropphycty": "WHAT CHEER",
    "dropphyst": "IA",
    "dropphyzpp": 502687709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHAT CHEER",
    "dropmalst": "IA",
    "dropmalzpp": 502689998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6416342720,
    "dropsitcph": 6416342720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11741",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "104 S MAIN ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "IA",
    "dropdelzpp": 527777702,
    "dropphyadd": "104 S MAIN ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "IA",
    "dropphyzpp": 527777702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "IA",
    "dropmalzpp": 527779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633741536,
    "dropsitcph": 5633741536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11745",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "609 WHITTIER ST",
    "dropdelcty": "WHITING",
    "dropdelst": "IA",
    "dropdelzpp": 510637702,
    "dropphyadd": "609 WHITTIER ST",
    "dropphycty": "WHITING",
    "dropphyst": "IA",
    "dropphyzpp": 510637702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITING",
    "dropmalst": "IA",
    "dropmalzpp": 510639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7124581005,
    "dropsitcph": 7124581005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11746",
    "droptype": "D",
    "dropname": "WHITTEMORE",
    "dropdeladd": "421 BROAD ST",
    "dropdelcty": "WHITTEMORE",
    "dropdelst": "IA",
    "dropdelzpp": 505988512,
    "dropphyadd": "421 BROAD ST",
    "dropphycty": "WHITTEMORE",
    "dropphyst": "IA",
    "dropphyzpp": 505988512,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITTEMORE",
    "dropmalst": "IA",
    "dropmalzpp": 505989998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158842235,
    "dropsitcph": 5158842235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11747",
    "droptype": "D",
    "dropname": "WHITTEN",
    "dropdeladd": "706 IRWIN ST",
    "dropdelcty": "WHITTEN",
    "dropdelst": "IA",
    "dropdelzpp": 502695000,
    "dropphyadd": "706 IRWIN ST",
    "dropphycty": "WHITTEN",
    "dropphyst": "IA",
    "dropphyzpp": 502695000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITTEN",
    "dropmalst": "IA",
    "dropmalzpp": 502699998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414865302,
    "dropsitcph": 6414865302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11757",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "IA",
    "dropdelzpp": 502717731,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "WILLIAMS",
    "dropphyst": "IA",
    "dropphyzpp": 502717731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "IA",
    "dropmalzpp": 502719998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158542252,
    "dropsitcph": 5158542252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11758",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "601 COURT ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "IA",
    "dropdelzpp": 523619477,
    "dropphyadd": "601 COURT ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "IA",
    "dropphyzpp": 523619477,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "IA",
    "dropmalzpp": 523619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3196681860,
    "dropsitcph": 3196681860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11760",
    "droptype": "D",
    "dropname": "WILLIAMSON",
    "dropdeladd": "103 W SOUTH AVE",
    "dropdelcty": "WILLIAMSON",
    "dropdelst": "IA",
    "dropdelzpp": 502725000,
    "dropphyadd": "103 W SOUTH AVE",
    "dropphycty": "WILLIAMSON",
    "dropphyst": "IA",
    "dropphyzpp": 502725000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSON",
    "dropmalst": "IA",
    "dropmalzpp": 502729998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6418623812,
    "dropsitcph": 6418623812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11762",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "118 E 4TH ST",
    "dropdelcty": "WILTON",
    "dropdelst": "IA",
    "dropdelzpp": 527789002,
    "dropphyadd": "118 E 4TH ST",
    "dropphycty": "WILTON",
    "dropphyst": "IA",
    "dropphyzpp": 527789002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILTON",
    "dropmalst": "IA",
    "dropmalzpp": 527789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637322157,
    "dropsitcph": 5637322157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11765",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "107 W PINE ST",
    "dropdelcty": "WINFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 526599795,
    "dropphyadd": "107 W PINE ST",
    "dropphycty": "WINFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 526599795,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 526599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192573307,
    "dropsitcph": 3192573307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11767",
    "droptype": "D",
    "dropname": "WINTERSET",
    "dropdeladd": "120 N 2ND AVE",
    "dropdelcty": "WINTERSET",
    "dropdelst": "IA",
    "dropdelzpp": 502739998,
    "dropphyadd": "120 N 2ND AVE",
    "dropphycty": "WINTERSET",
    "dropphyst": "IA",
    "dropphyzpp": 502739998,
    "dropmaladd": "120 N 2ND AVE",
    "dropmalcty": "WINTERSET",
    "dropmalst": "IA",
    "dropmalzpp": 502739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154623030,
    "dropsitcph": 5154623030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11768",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "253 W MADISON ST",
    "dropdelcty": "WINTHROP",
    "dropdelst": "IA",
    "dropdelzpp": 506827705,
    "dropphyadd": "253 W MADISON ST",
    "dropphycty": "WINTHROP",
    "dropphyst": "IA",
    "dropphyzpp": 506827705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINTHROP",
    "dropmalst": "IA",
    "dropmalzpp": 506829998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3199353363,
    "dropsitcph": 3199353363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11769",
    "droptype": "D",
    "dropname": "WIOTA",
    "dropdeladd": "405 PIONEER AVE",
    "dropdelcty": "WIOTA",
    "dropdelst": "IA",
    "dropdelzpp": 502741102,
    "dropphyadd": "405 PIONEER AVE",
    "dropphycty": "WIOTA",
    "dropphyst": "IA",
    "dropphyzpp": 502741102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WIOTA",
    "dropmalst": "IA",
    "dropmalzpp": 502749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 7127834544,
    "dropsitcph": 7127834544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11771",
    "droptype": "D",
    "dropname": "WODEN",
    "dropdeladd": "222 MAIN",
    "dropdelcty": "WODEN",
    "dropdelst": "IA",
    "dropdelzpp": 504847719,
    "dropphyadd": "222 MAIN",
    "dropphycty": "WODEN",
    "dropphyst": "IA",
    "dropphyzpp": 504847719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WODEN",
    "dropmalst": "IA",
    "dropmalzpp": 504849998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6419265522,
    "dropsitcph": 6419265522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11773",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "405 LINCOLNWAY ST",
    "dropdelcty": "WOODBINE",
    "dropdelst": "IA",
    "dropdelzpp": 515799998,
    "dropphyadd": "405 LINCOLNWAY ST",
    "dropphycty": "WOODBINE",
    "dropphyst": "IA",
    "dropphyzpp": 515799998,
    "dropmaladd": "405 LINCOLNWAY ST",
    "dropmalcty": "WOODBINE",
    "dropmalst": "IA",
    "dropmalzpp": 515799998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7122073197,
    "dropsitcph": 7122073197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11774",
    "droptype": "D",
    "dropname": "WOODBURN",
    "dropdeladd": "610 SIGLER ST",
    "dropdelcty": "WOODBURN",
    "dropdelst": "IA",
    "dropdelzpp": 502758089,
    "dropphyadd": "610 SIGLER ST",
    "dropphycty": "WOODBURN",
    "dropphyst": "IA",
    "dropphyzpp": 502758089,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODBURN",
    "dropmalst": "IA",
    "dropmalzpp": 502759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6413422415,
    "dropsitcph": 6413422415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11776",
    "droptype": "D",
    "dropname": "WOODWARD",
    "dropdeladd": "212 S MAIN ST",
    "dropdelcty": "WOODWARD",
    "dropdelst": "IA",
    "dropdelzpp": 502767710,
    "dropphyadd": "212 S MAIN ST",
    "dropphycty": "WOODWARD",
    "dropphyst": "IA",
    "dropphyzpp": 502767710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODWARD",
    "dropmalst": "IA",
    "dropmalzpp": 502769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5154382026,
    "dropsitcph": 5154382026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11777",
    "droptype": "D",
    "dropname": "WOOLSTOCK",
    "dropdeladd": "226 HERMAN ST",
    "dropdelcty": "WOOLSTOCK",
    "dropdelst": "IA",
    "dropdelzpp": 505998055,
    "dropphyadd": "226 HERMAN ST",
    "dropphycty": "WOOLSTOCK",
    "dropphyst": "IA",
    "dropphyzpp": 505998055,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOOLSTOCK",
    "dropmalst": "IA",
    "dropmalzpp": 505999998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5158395515,
    "dropsitcph": 5158395515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11778",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "203 1ST ST S",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "IA",
    "dropdelzpp": 520789677,
    "dropphyadd": "203 1ST ST S",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "IA",
    "dropphyzpp": 520789677,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "IA",
    "dropmalzpp": 520789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5638554105,
    "dropsitcph": 5638554105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11781",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "WYOMING",
    "dropdelst": "IA",
    "dropdelzpp": 523627703,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "WYOMING",
    "dropphyst": "IA",
    "dropphyzpp": 523627703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYOMING",
    "dropmalst": "IA",
    "dropmalzpp": 523629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5634883411,
    "dropsitcph": 5634883411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11782",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "YALE",
    "dropdelst": "IA",
    "dropdelzpp": 502778500,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "YALE",
    "dropphyst": "IA",
    "dropphyzpp": 502778500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YALE",
    "dropmalst": "IA",
    "dropmalzpp": 502779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414396616,
    "dropsitcph": 6414396616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11785",
    "droptype": "D",
    "dropname": "YORKTOWN",
    "dropdeladd": "303 ADAMS ST",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "IA",
    "dropdelzpp": 516569403,
    "dropphyadd": "303 ADAMS ST",
    "dropphycty": "YORKTOWN",
    "dropphyst": "IA",
    "dropphyzpp": 516569403,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "IA",
    "dropmalzpp": 516569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7125422506,
    "dropsitcph": 7125422506,
    "dropfax": 7125422506
  },
  {
    "dcode": "D",
    "dropkey": "PW11788",
    "droptype": "D",
    "dropname": "ZEARING",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "ZEARING",
    "dropdelst": "IA",
    "dropdelzpp": 502787728,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "ZEARING",
    "dropphyst": "IA",
    "dropphyzpp": 502787728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZEARING",
    "dropmalst": "IA",
    "dropmalzpp": 502789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414877580,
    "dropsitcph": 6414877580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11791",
    "droptype": "D",
    "dropname": "ZWINGLE",
    "dropdeladd": "168 N MAIN ST",
    "dropdelcty": "ZWINGLE",
    "dropdelst": "IA",
    "dropdelzpp": 520797719,
    "dropphyadd": "168 N MAIN ST",
    "dropphycty": "ZWINGLE",
    "dropphyst": "IA",
    "dropphyzpp": 520797719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZWINGLE",
    "dropmalst": "IA",
    "dropmalzpp": 520799998,
    "dropsitphn": 5152837530,
    "dropsitlph": 5637738854,
    "dropsitcph": 5637738854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11795",
    "droptype": "D",
    "dropname": "ABINGDON",
    "dropdeladd": "123 W MEEK ST",
    "dropdelcty": "ABINGDON",
    "dropdelst": "IL",
    "dropdelzpp": 614109998,
    "dropphyadd": "123 W MEEK ST",
    "dropphycty": "ABINGDON",
    "dropphyst": "IL",
    "dropphyzpp": 614109998,
    "dropmaladd": "123 W MEEK ST",
    "dropmalcty": "ABINGDON",
    "dropmalst": "IL",
    "dropmalzpp": 614109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3094622441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11796",
    "droptype": "D",
    "dropname": "ADAIR",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "ADAIR",
    "dropdelst": "IL",
    "dropdelzpp": 614119800,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "ADAIR",
    "dropphyst": "IL",
    "dropphyzpp": 614119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAIR",
    "dropmalst": "IL",
    "dropmalzpp": 614119998,
    "dropsitphn": 3096532477,
    "dropsitlph": 3096532477,
    "dropsitcph": 3096532477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11798",
    "droptype": "D",
    "dropname": "ADDIEVILLE",
    "dropdeladd": "226 N MIDDLE ST",
    "dropdelcty": "ADDIEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622149998,
    "dropphyadd": "226 N MIDDLE ST",
    "dropphycty": "ADDIEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622149998,
    "dropmaladd": "226 N MIDDLE ST",
    "dropmalcty": "ADDIEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184247986,
    "dropsitcph": 6184247986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11801",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "175 S LINCOLN AVE",
    "dropdelcty": "ADDISON",
    "dropdelst": "IL",
    "dropdelzpp": 601015816,
    "dropphyadd": "175 S LINCOLN AVE",
    "dropphycty": "ADDISON",
    "dropphyst": "IL",
    "dropphyzpp": 601015816,
    "dropmaladd": "175 S LINCOLN AVE",
    "dropmalcty": "ADDISON",
    "dropmalst": "IL",
    "dropmalzpp": 601015816,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305434071,
    "dropsitcph": 6305434071,
    "dropfax": 6305430229
  },
  {
    "dcode": "D",
    "dropkey": "PW11810",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "204 3RD AVE S",
    "dropdelcty": "ALBANY",
    "dropdelst": "IL",
    "dropdelzpp": 612309000,
    "dropphyadd": "204 3RD AVE S",
    "dropphycty": "ALBANY",
    "dropphyst": "IL",
    "dropphyzpp": 612309000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBANY",
    "dropmalst": "IL",
    "dropmalzpp": 612309998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3098874433,
    "dropsitcph": 3098874433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11811",
    "droptype": "D",
    "dropname": "ALBERS",
    "dropdeladd": "110 N BROADWAY",
    "dropdelcty": "ALBERS",
    "dropdelst": "IL",
    "dropdelzpp": 622159998,
    "dropphyadd": "110 N BROADWAY",
    "dropphycty": "ALBERS",
    "dropphyst": "IL",
    "dropphyzpp": 622159998,
    "dropmaladd": "110 N BROADWAY",
    "dropmalcty": "ALBERS",
    "dropmalst": "IL",
    "dropmalzpp": 622159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182485158,
    "dropsitcph": 6182485158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11812",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "ALBION",
    "dropdelst": "IL",
    "dropdelzpp": 628069998,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "ALBION",
    "dropphyst": "IL",
    "dropphyzpp": 628069998,
    "dropmaladd": "104 W MAIN ST",
    "dropmalcty": "ALBION",
    "dropmalst": "IL",
    "dropmalzpp": 628069998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184453331,
    "dropsitcph": 6184453331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11816",
    "droptype": "D",
    "dropname": "ALEDO",
    "dropdeladd": "117 N COLLEGE AVE",
    "dropdelcty": "ALEDO",
    "dropdelst": "IL",
    "dropdelzpp": 612319998,
    "dropphyadd": "117 N COLLEGE AVE",
    "dropphycty": "ALEDO",
    "dropphyst": "IL",
    "dropphyzpp": 612319998,
    "dropmaladd": "117 N COLLEGE AVE",
    "dropmalcty": "ALEDO",
    "dropmalst": "IL",
    "dropmalzpp": 612319998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095827113,
    "dropsitcph": 3095827113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11817",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "107 S PARK ST",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "IL",
    "dropdelzpp": 626019998,
    "dropphyadd": "107 S PARK ST",
    "dropphycty": "ALEXANDER",
    "dropphyst": "IL",
    "dropphyzpp": 626019998,
    "dropmaladd": "107 S PARK ST",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "IL",
    "dropmalzpp": 626019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174782161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11818",
    "droptype": "D",
    "dropname": "ALEXIS",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "ALEXIS",
    "dropdelst": "IL",
    "dropdelzpp": 614125158,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "ALEXIS",
    "dropphyst": "IL",
    "dropphyzpp": 614125158,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXIS",
    "dropmalst": "IL",
    "dropmalzpp": 614129998,
    "dropsitphn": 3094823264,
    "dropsitlph": 3094823264,
    "dropsitcph": 3094823264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11820",
    "droptype": "D",
    "dropname": "ALGONQUIN",
    "dropdeladd": "801 W ALGONQUIN RD",
    "dropdelcty": "ALGONQUIN",
    "dropdelst": "IL",
    "dropdelzpp": 601022487,
    "dropphyadd": "801 W ALGONQUIN RD",
    "dropphycty": "ALGONQUIN",
    "dropphyst": "IL",
    "dropphyzpp": 601022487,
    "dropmaladd": "801 W ALGONQUIN RD",
    "dropmalcty": "ALGONQUIN",
    "dropmalst": "IL",
    "dropmalzpp": 601022487,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476580012,
    "dropsitcph": 8476580012,
    "dropfax": 8476584732
  },
  {
    "dcode": "D",
    "dropkey": "PW11821",
    "droptype": "D",
    "dropname": "ALHAMBRA",
    "dropdeladd": "506 E MAIN ST",
    "dropdelcty": "ALHAMBRA",
    "dropdelst": "IL",
    "dropdelzpp": 620019998,
    "dropphyadd": "506 E MAIN ST",
    "dropphycty": "ALHAMBRA",
    "dropphyst": "IL",
    "dropphyzpp": 620019998,
    "dropmaladd": "506 E MAIN ST",
    "dropmalcty": "ALHAMBRA",
    "dropmalst": "IL",
    "dropmalzpp": 620019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184887938,
    "dropsitcph": 6184887938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11826",
    "droptype": "D",
    "dropname": "ALLENDALE",
    "dropdeladd": "304 E MAIN ST",
    "dropdelcty": "ALLENDALE",
    "dropdelst": "IL",
    "dropdelzpp": 624109998,
    "dropphyadd": "304 E MAIN ST",
    "dropphycty": "ALLENDALE",
    "dropphyst": "IL",
    "dropphyzpp": 624109998,
    "dropmaladd": "304 E MAIN ST",
    "dropmalcty": "ALLENDALE",
    "dropmalst": "IL",
    "dropmalzpp": 624109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182995151,
    "dropsitcph": 6182995151,
    "dropfax": 6182995151
  },
  {
    "dcode": "D",
    "dropkey": "PW11829",
    "droptype": "D",
    "dropname": "ALLERTON",
    "dropdeladd": "110 VERMILION AVE",
    "dropdelcty": "ALLERTON",
    "dropdelst": "IL",
    "dropdelzpp": 618109998,
    "dropphyadd": "110 VERMILION AVE",
    "dropphycty": "ALLERTON",
    "dropphyst": "IL",
    "dropphyzpp": 618109998,
    "dropmaladd": "110 VERMILION AVE",
    "dropmalcty": "ALLERTON",
    "dropmalst": "IL",
    "dropmalzpp": 618109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2179196050,
    "dropsitcph": 2178343332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11833",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "127 7TH ST",
    "dropdelcty": "ALMA",
    "dropdelst": "IL",
    "dropdelzpp": 628079998,
    "dropphyadd": "127 7TH ST",
    "dropphycty": "ALMA",
    "dropphyst": "IL",
    "dropphyzpp": 628079998,
    "dropmaladd": "127 7TH ST",
    "dropmalcty": "ALMA",
    "dropmalst": "IL",
    "dropmalzpp": 628079998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185477200,
    "dropsitcph": 6185477200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11835",
    "droptype": "D",
    "dropname": "ALPHA",
    "dropdeladd": "108 W D ST",
    "dropdelcty": "ALPHA",
    "dropdelst": "IL",
    "dropdelzpp": 614139800,
    "dropphyadd": "108 W D ST",
    "dropphycty": "ALPHA",
    "dropphyst": "IL",
    "dropphyzpp": 614139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPHA",
    "dropmalst": "IL",
    "dropmalzpp": 614139998,
    "dropsitphn": 3095298551,
    "dropsitlph": 3095298551,
    "dropsitcph": 3095298551,
    "dropfax": 3095298551
  },
  {
    "dcode": "D",
    "dropkey": "PW11836",
    "droptype": "D",
    "dropname": "ALSEY",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "ALSEY",
    "dropdelst": "IL",
    "dropdelzpp": 626109998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "ALSEY",
    "dropphyst": "IL",
    "dropphyzpp": 626109998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "ALSEY",
    "dropmalst": "IL",
    "dropmalzpp": 626109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177423613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11840",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "122 W WASHINGTON AVE",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "IL",
    "dropdelzpp": 624119998,
    "dropphyadd": "122 W WASHINGTON AVE",
    "dropphycty": "ALTAMONT",
    "dropphyst": "IL",
    "dropphyzpp": 624119998,
    "dropmaladd": "122 W WASHINGTON AVE",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "IL",
    "dropmalzpp": 624119998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184836314,
    "dropsitcph": 6184836314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11842",
    "droptype": "D",
    "dropname": "ALTO PASS",
    "dropdeladd": "85 N ELM ST",
    "dropdelcty": "ALTO PASS",
    "dropdelst": "IL",
    "dropdelzpp": 629059998,
    "dropphyadd": "85 N ELM ST",
    "dropphycty": "ALTO PASS",
    "dropphyst": "IL",
    "dropphyzpp": 629059998,
    "dropmaladd": "85 N ELM ST",
    "dropmalcty": "ALTO PASS",
    "dropmalst": "IL",
    "dropmalzpp": 629059998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188934014,
    "dropsitcph": 6188934014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11843",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "2350 HOMER M ADAMS PKWY",
    "dropdelcty": "ALTON",
    "dropdelst": "IL",
    "dropdelzpp": 620029998,
    "dropphyadd": "2350 HOMER M ADAMS PKWY",
    "dropphycty": "ALTON",
    "dropphyst": "IL",
    "dropphyzpp": 620029998,
    "dropmaladd": "2350 HOMER M ADAMS PKWY",
    "dropmalcty": "ALTON",
    "dropmalst": "IL",
    "dropmalzpp": 620029998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184622501,
    "dropsitcph": 6184622501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11846",
    "droptype": "D",
    "dropname": "ALTONA",
    "dropdeladd": "111 S DEPOT ST",
    "dropdelcty": "ALTONA",
    "dropdelst": "IL",
    "dropdelzpp": 614149997,
    "dropphyadd": "111 S DEPOT ST",
    "dropphycty": "ALTONA",
    "dropphyst": "IL",
    "dropphyzpp": 614149997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTONA",
    "dropmalst": "IL",
    "dropmalzpp": 614149998,
    "dropsitphn": 3094846201,
    "dropsitlph": 3094846201,
    "dropsitcph": 3094846201,
    "dropfax": 3094846201
  },
  {
    "dcode": "D",
    "dropkey": "PW11847",
    "droptype": "D",
    "dropname": "ALVIN",
    "dropdeladd": "104 CHICAGO ST",
    "dropdelcty": "ALVIN",
    "dropdelst": "IL",
    "dropdelzpp": 618119998,
    "dropphyadd": "104 CHICAGO ST",
    "dropphycty": "ALVIN",
    "dropphyst": "IL",
    "dropphyzpp": 618119998,
    "dropmaladd": "104 CHICAGO ST",
    "dropmalcty": "ALVIN",
    "dropmalst": "IL",
    "dropmalzpp": 618119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2179096050,
    "dropsitcph": 2177652042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11849",
    "droptype": "D",
    "dropname": "AMBOY",
    "dropdeladd": "215 E DIVISION ST",
    "dropdelcty": "AMBOY",
    "dropdelst": "IL",
    "dropdelzpp": 613109800,
    "dropphyadd": "215 E DIVISION ST",
    "dropphycty": "AMBOY",
    "dropphyst": "IL",
    "dropphyzpp": 613109800,
    "dropmaladd": "215 E DIVISION ST",
    "dropmalcty": "AMBOY",
    "dropmalst": "IL",
    "dropmalzpp": 613109800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158572212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11853",
    "droptype": "D",
    "dropname": "AMF OHARE",
    "dropdeladd": "11600 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606669910,
    "dropphyadd": "11600 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606669910,
    "dropmaladd": "11600 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606669910,
    "dropsitphn": 7085637318,
    "dropsitlph": 3128941400,
    "dropsitcph": 7736861309,
    "dropfax": 3126864945
  },
  {
    "dcode": "D",
    "dropkey": "PW11856",
    "droptype": "D",
    "dropname": "ANCHOR",
    "dropdeladd": "239 2ND ST",
    "dropdelcty": "ANCHOR",
    "dropdelst": "IL",
    "dropdelzpp": 617209900,
    "dropphyadd": "239 2ND ST",
    "dropphycty": "ANCHOR",
    "dropphyst": "IL",
    "dropphyzpp": 617209900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANCHOR",
    "dropmalst": "IL",
    "dropmalzpp": 617209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097236211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11858",
    "droptype": "D",
    "dropname": "ANDALUSIA",
    "dropdeladd": "124 2ND AVE E",
    "dropdelcty": "ANDALUSIA",
    "dropdelst": "IL",
    "dropdelzpp": 612329000,
    "dropphyadd": "124 2ND AVE E",
    "dropphycty": "ANDALUSIA",
    "dropphyst": "IL",
    "dropphyzpp": 612329000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDALUSIA",
    "dropmalst": "IL",
    "dropmalzpp": 612329998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097982110,
    "dropsitcph": 3097982110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11860",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "513 5TH ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "IL",
    "dropdelzpp": 612339000,
    "dropphyadd": "513 5TH ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "IL",
    "dropphyzpp": 612339000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDOVER",
    "dropmalst": "IL",
    "dropmalzpp": 612339998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095218242,
    "dropsitcph": 3095218242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11862",
    "droptype": "D",
    "dropname": "ANNA",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "ANNA",
    "dropdelst": "IL",
    "dropdelzpp": 629069998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "ANNA",
    "dropphyst": "IL",
    "dropphyzpp": 629069998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "ANNA",
    "dropmalst": "IL",
    "dropmalzpp": 629069998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188332713,
    "dropsitcph": 6188332713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11863",
    "droptype": "D",
    "dropname": "ANNAPOLIS",
    "dropdeladd": "7047 E 2000TH AVE",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "IL",
    "dropdelzpp": 624139998,
    "dropphyadd": "7047 E 2000TH AVE",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "IL",
    "dropphyzpp": 624139998,
    "dropmaladd": "7047 E 2000TH AVE",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "IL",
    "dropmalzpp": 624139998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185693903,
    "dropsitcph": 6185693903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11864",
    "droptype": "D",
    "dropname": "ANNAWAN",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "ANNAWAN",
    "dropdelst": "IL",
    "dropdelzpp": 612347701,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "ANNAWAN",
    "dropphyst": "IL",
    "dropphyzpp": 612347701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANNAWAN",
    "dropmalst": "IL",
    "dropmalzpp": 612349998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3099356651,
    "dropsitcph": 3099356651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11865",
    "droptype": "D",
    "dropname": "ANTIOCH",
    "dropdeladd": "420 ORCHARD ST",
    "dropdelcty": "ANTIOCH",
    "dropdelst": "IL",
    "dropdelzpp": 600023135,
    "dropphyadd": "420 ORCHARD ST",
    "dropphycty": "ANTIOCH",
    "dropphyst": "IL",
    "dropphyzpp": 600023135,
    "dropmaladd": "420 ORCHARD ST",
    "dropmalcty": "ANTIOCH",
    "dropmalst": "IL",
    "dropmalzpp": 600023135,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473953482,
    "dropsitcph": 8473953482,
    "dropfax": 8473953725
  },
  {
    "dcode": "D",
    "dropkey": "PW11867",
    "droptype": "D",
    "dropname": "APPLE RIVER",
    "dropdeladd": "110 W RAILROAD ST",
    "dropdelcty": "APPLE RIVER",
    "dropdelst": "IL",
    "dropdelzpp": 610019233,
    "dropphyadd": "110 W RAILROAD ST",
    "dropphycty": "APPLE RIVER",
    "dropphyst": "IL",
    "dropphyzpp": 610019233,
    "dropmaladd": "110 W RAILROAD ST",
    "dropmalcty": "APPLE RIVER",
    "dropmalst": "IL",
    "dropmalzpp": 610019233,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155942337,
    "dropsitcph": 8155942337,
    "dropfax": 8155942358
  },
  {
    "dcode": "D",
    "dropkey": "PW11872",
    "droptype": "D",
    "dropname": "ARCOLA",
    "dropdeladd": "107 S OAK ST",
    "dropdelcty": "ARCOLA",
    "dropdelst": "IL",
    "dropdelzpp": 619109998,
    "dropphyadd": "107 S OAK ST",
    "dropphycty": "ARCOLA",
    "dropphyst": "IL",
    "dropphyzpp": 619109998,
    "dropmaladd": "107 S OAK ST",
    "dropmalcty": "ARCOLA",
    "dropmalst": "IL",
    "dropmalzpp": 619109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2179261014,
    "dropsitcph": 2179261014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11874",
    "droptype": "D",
    "dropname": "ARENZVILLE",
    "dropdeladd": "213 W FREDERICK ST",
    "dropdelcty": "ARENZVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626119998,
    "dropphyadd": "213 W FREDERICK ST",
    "dropphycty": "ARENZVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626119998,
    "dropmaladd": "213 W FREDERICK ST",
    "dropmalcty": "ARENZVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179975589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11875",
    "droptype": "D",
    "dropname": "ARGENTA",
    "dropdeladd": "187 N NORTH ST",
    "dropdelcty": "ARGENTA",
    "dropdelst": "IL",
    "dropdelzpp": 625019998,
    "dropphyadd": "187 N NORTH ST",
    "dropphycty": "ARGENTA",
    "dropphyst": "IL",
    "dropphyzpp": 625019998,
    "dropmaladd": "187 N NORTH ST",
    "dropmalcty": "ARGENTA",
    "dropmalst": "IL",
    "dropmalzpp": 625019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177952065,
    "dropfax": 2177952065
  },
  {
    "dcode": "D",
    "dropkey": "PW11882",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "203 E RAILROAD AVE",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 613129800,
    "dropphyadd": "203 E RAILROAD AVE",
    "dropphycty": "ARLINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 613129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 613129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156382178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11888",
    "droptype": "D",
    "dropname": "ARLINGTON HEIGHTS",
    "dropdeladd": "909 W EUCLID AVE",
    "dropdelcty": "ARLINGTON HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 600059998,
    "dropphyadd": "909 W EUCLID AVE",
    "dropphycty": "ARLINGTON HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 600059998,
    "dropmaladd": "909 W EUCLID AVE",
    "dropmalcty": "ARLINGTON HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 600059998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472537806,
    "dropsitcph": 8472537806,
    "dropfax": 8472537460
  },
  {
    "dcode": "D",
    "dropkey": "PW11895",
    "droptype": "D",
    "dropname": "ARMINGTON",
    "dropdeladd": "104 N GRIFFIN ST",
    "dropdelcty": "ARMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617219900,
    "dropphyadd": "104 N GRIFFIN ST",
    "dropphycty": "ARMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617219900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617219998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093922712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11896",
    "droptype": "D",
    "dropname": "ARMSTRONG",
    "dropdeladd": "30515 ARMSTRONG RD",
    "dropdelcty": "ARMSTRONG",
    "dropdelst": "IL",
    "dropdelzpp": 618129998,
    "dropphyadd": "30515 ARMSTRONG RD",
    "dropphycty": "ARMSTRONG",
    "dropphyst": "IL",
    "dropphyzpp": 618129998,
    "dropmaladd": "30515 ARMSTRONG RD",
    "dropmalcty": "ARMSTRONG",
    "dropmalst": "IL",
    "dropmalzpp": 618129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175692590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11898",
    "droptype": "D",
    "dropname": "AROMA PARK",
    "dropdeladd": "300 S BRIDGE ST",
    "dropdelcty": "AROMA PARK",
    "dropdelst": "IL",
    "dropdelzpp": 609109800,
    "dropphyadd": "300 S BRIDGE ST",
    "dropphycty": "AROMA PARK",
    "dropphyst": "IL",
    "dropphyzpp": 609109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AROMA PARK",
    "dropmalst": "IL",
    "dropmalzpp": 609109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8159379361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11901",
    "droptype": "D",
    "dropname": "ARROWSMITH",
    "dropdeladd": "103 W CROSSON ST",
    "dropdelcty": "ARROWSMITH",
    "dropdelst": "IL",
    "dropdelzpp": 617227523,
    "dropphyadd": "103 W CROSSON ST",
    "dropphycty": "ARROWSMITH",
    "dropphyst": "IL",
    "dropphyzpp": 617227523,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARROWSMITH",
    "dropmalst": "IL",
    "dropmalzpp": 617229998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097271131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11902",
    "droptype": "D",
    "dropname": "ARTHUR",
    "dropdeladd": "315 S VINE ST STE 2",
    "dropdelcty": "ARTHUR",
    "dropdelst": "IL",
    "dropdelzpp": 619119998,
    "dropphyadd": "315 S VINE ST STE 2",
    "dropphycty": "ARTHUR",
    "dropphyst": "IL",
    "dropphyzpp": 619119998,
    "dropmaladd": "315 S VINE ST STE 2",
    "dropmalcty": "ARTHUR",
    "dropmalst": "IL",
    "dropmalzpp": 619119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175432212,
    "dropfax": 2175432192
  },
  {
    "dcode": "D",
    "dropkey": "PW11906",
    "droptype": "D",
    "dropname": "ASHKUM",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "ASHKUM",
    "dropdelst": "IL",
    "dropdelzpp": 609117169,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "ASHKUM",
    "dropphyst": "IL",
    "dropphyzpp": 609117169,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHKUM",
    "dropmalst": "IL",
    "dropmalzpp": 609119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156982412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11907",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "124 N YATES ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "IL",
    "dropdelzpp": 626129998,
    "dropphyadd": "124 N YATES ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "IL",
    "dropphyzpp": 626129998,
    "dropmaladd": "124 N YATES ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "IL",
    "dropmalzpp": 626129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174768267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11908",
    "droptype": "D",
    "dropname": "ASHLEY",
    "dropdeladd": "167 E JACKSON ST",
    "dropdelcty": "ASHLEY",
    "dropdelst": "IL",
    "dropdelzpp": 628089998,
    "dropphyadd": "167 E JACKSON ST",
    "dropphycty": "ASHLEY",
    "dropphyst": "IL",
    "dropphyzpp": 628089998,
    "dropmaladd": "167 E JACKSON ST",
    "dropmalcty": "ASHLEY",
    "dropmalst": "IL",
    "dropmalzpp": 628089998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184856697,
    "dropsitcph": 6184856697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11909",
    "droptype": "D",
    "dropname": "ASHMORE",
    "dropdeladd": "103 W ASHMORE ST",
    "dropdelcty": "ASHMORE",
    "dropdelst": "IL",
    "dropdelzpp": 619129998,
    "dropphyadd": "103 W ASHMORE ST",
    "dropphycty": "ASHMORE",
    "dropphyst": "IL",
    "dropphyzpp": 619129998,
    "dropmaladd": "103 W ASHMORE ST",
    "dropmalcty": "ASHMORE",
    "dropmalst": "IL",
    "dropmalzpp": 619129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173498331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11910",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "605 BROWN AVE",
    "dropdelcty": "ASHTON",
    "dropdelst": "IL",
    "dropdelzpp": 610069777,
    "dropphyadd": "605 BROWN AVE",
    "dropphycty": "ASHTON",
    "dropphyst": "IL",
    "dropphyzpp": 610069777,
    "dropmaladd": "605 BROWN AVE",
    "dropmalcty": "ASHTON",
    "dropmalst": "IL",
    "dropmalzpp": 610069777,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154532212,
    "dropsitcph": 8154532212,
    "dropfax": 8152342781
  },
  {
    "dcode": "D",
    "dropkey": "PW11911",
    "droptype": "D",
    "dropname": "ASSUMPTION",
    "dropdeladd": "219 N CHESTNUT ST",
    "dropdelcty": "ASSUMPTION",
    "dropdelst": "IL",
    "dropdelzpp": 625109998,
    "dropphyadd": "219 N CHESTNUT ST",
    "dropphycty": "ASSUMPTION",
    "dropphyst": "IL",
    "dropphyzpp": 625109998,
    "dropmaladd": "219 N CHESTNUT ST",
    "dropmalcty": "ASSUMPTION",
    "dropmalst": "IL",
    "dropmalzpp": 625109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172263921,
    "dropfax": 2172263923
  },
  {
    "dcode": "D",
    "dropkey": "PW11912",
    "droptype": "D",
    "dropname": "ASTORIA",
    "dropdeladd": "214 W BROADWAY",
    "dropdelcty": "ASTORIA",
    "dropdelst": "IL",
    "dropdelzpp": 615019800,
    "dropphyadd": "214 W BROADWAY",
    "dropphycty": "ASTORIA",
    "dropphyst": "IL",
    "dropphyzpp": 615019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASTORIA",
    "dropmalst": "IL",
    "dropmalzpp": 615019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093292700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11914",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "215 N MAIN ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "IL",
    "dropdelzpp": 626139998,
    "dropphyadd": "215 N MAIN ST",
    "dropphycty": "ATHENS",
    "dropphyst": "IL",
    "dropphyzpp": 626139998,
    "dropmaladd": "215 N MAIN ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "IL",
    "dropmalzpp": 626139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176368631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11916",
    "droptype": "D",
    "dropname": "ATKINSON",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "ATKINSON",
    "dropdelst": "IL",
    "dropdelzpp": 612357717,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "ATKINSON",
    "dropphyst": "IL",
    "dropphyzpp": 612357717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATKINSON",
    "dropmalst": "IL",
    "dropmalzpp": 612359998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3099367276,
    "dropsitcph": 3099367276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11917",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "100 SW CHURCH ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "IL",
    "dropdelzpp": 617239998,
    "dropphyadd": "100 SW CHURCH ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "IL",
    "dropphyzpp": 617239998,
    "dropmaladd": "100 SW CHURCH ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "IL",
    "dropmalzpp": 617239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2176482531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11922",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "117 W CENTRAL ST",
    "dropdelcty": "ATWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 619139998,
    "dropphyadd": "117 W CENTRAL ST",
    "dropphycty": "ATWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 619139998,
    "dropmaladd": "117 W CENTRAL ST",
    "dropmalcty": "ATWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 619139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175783223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11923",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "202 S 5TH ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "IL",
    "dropdelzpp": 626159998,
    "dropphyadd": "202 S 5TH ST",
    "dropphycty": "AUBURN",
    "dropphyst": "IL",
    "dropphyzpp": 626159998,
    "dropmaladd": "202 S 5TH ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "IL",
    "dropmalzpp": 626159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174386216,
    "dropfax": 2174386857
  },
  {
    "dcode": "D",
    "dropkey": "PW11929",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "503 MAIN ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "IL",
    "dropdelzpp": 623119998,
    "dropphyadd": "503 MAIN ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "IL",
    "dropphyzpp": 623119998,
    "dropmaladd": "503 MAIN ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "IL",
    "dropmalzpp": 623119998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172161004,
    "dropsitcph": 2172161004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11930",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "525 N BROADWAY",
    "dropdelcty": "AURORA",
    "dropdelst": "IL",
    "dropdelzpp": 605059998,
    "dropphyadd": "525 N BROADWAY",
    "dropphycty": "AURORA",
    "dropphyst": "IL",
    "dropphyzpp": 605059998,
    "dropmaladd": "525 N BROADWAY",
    "dropmalcty": "AURORA",
    "dropmalst": "IL",
    "dropmalzpp": 605059998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6308448810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11935",
    "droptype": "D",
    "dropname": "AVA",
    "dropdeladd": "222 W MAIN ST",
    "dropdelcty": "AVA",
    "dropdelst": "IL",
    "dropdelzpp": 629079998,
    "dropphyadd": "222 W MAIN ST",
    "dropphycty": "AVA",
    "dropphyst": "IL",
    "dropphyzpp": 629079998,
    "dropmaladd": "222 W MAIN ST",
    "dropmalcty": "AVA",
    "dropmalst": "IL",
    "dropmalzpp": 629079998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184263621,
    "dropsitcph": 6184263621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11936",
    "droptype": "D",
    "dropname": "AVISTON",
    "dropdeladd": "102 S PAGE ST",
    "dropdelcty": "AVISTON",
    "dropdelst": "IL",
    "dropdelzpp": 622169998,
    "dropphyadd": "102 S PAGE ST",
    "dropphycty": "AVISTON",
    "dropphyst": "IL",
    "dropphyzpp": 622169998,
    "dropmaladd": "102 S PAGE ST",
    "dropmalcty": "AVISTON",
    "dropmalst": "IL",
    "dropmalzpp": 622169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182287759,
    "dropsitcph": 6182287759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11938",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "101 E WASHINGTON ST",
    "dropdelcty": "AVON",
    "dropdelst": "IL",
    "dropdelzpp": 614159800,
    "dropphyadd": "101 E WASHINGTON ST",
    "dropphycty": "AVON",
    "dropphyst": "IL",
    "dropphyzpp": 614159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVON",
    "dropmalst": "IL",
    "dropmalzpp": 614159998,
    "dropsitphn": 3094653103,
    "dropsitlph": 3094653103,
    "dropsitcph": 3094653103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11943",
    "droptype": "D",
    "dropname": "BAILEYVILLE",
    "dropdeladd": "100 S COMMERCIAL ST",
    "dropdelcty": "BAILEYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 610079762,
    "dropphyadd": "100 S COMMERCIAL ST",
    "dropphycty": "BAILEYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 610079762,
    "dropmaladd": "100 S COMMERCIAL ST",
    "dropmalcty": "BAILEYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 610079762,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152354828,
    "dropsitcph": 8152354828,
    "dropfax": 8152358620
  },
  {
    "dcode": "D",
    "dropkey": "PW11949",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "109 S 5TH ST",
    "dropdelcty": "BALDWIN",
    "dropdelst": "IL",
    "dropdelzpp": 622179998,
    "dropphyadd": "109 S 5TH ST",
    "dropphycty": "BALDWIN",
    "dropphyst": "IL",
    "dropphyzpp": 622179998,
    "dropmaladd": "109 S 5TH ST",
    "dropmalcty": "BALDWIN",
    "dropmalst": "IL",
    "dropmalzpp": 622179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187852271,
    "dropsitcph": 6187852271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11956",
    "droptype": "D",
    "dropname": "BARDOLPH",
    "dropdeladd": "202 S CHESTNUT ST",
    "dropdelcty": "BARDOLPH",
    "dropdelst": "IL",
    "dropdelzpp": 614169800,
    "dropphyadd": "202 S CHESTNUT ST",
    "dropphycty": "BARDOLPH",
    "dropphyst": "IL",
    "dropphyzpp": 614169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARDOLPH",
    "dropmalst": "IL",
    "dropmalzpp": 614169998,
    "dropsitphn": 3097695504,
    "dropsitlph": 3097695504,
    "dropsitcph": 3097695504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11967",
    "droptype": "D",
    "dropname": "BARRINGTON",
    "dropdeladd": "1515 S GROVE AVE",
    "dropdelcty": "BARRINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 600105268,
    "dropphyadd": "1515 S GROVE AVE",
    "dropphycty": "BARRINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 600105268,
    "dropmaladd": "1515 S GROVE AVE",
    "dropmalcty": "BARRINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 600105268,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473810510,
    "dropsitcph": 8473810510,
    "dropfax": 8473816472
  },
  {
    "dcode": "D",
    "dropkey": "PW11981",
    "droptype": "D",
    "dropname": "BARRY",
    "dropdeladd": "600 DECATUR ST",
    "dropdelcty": "BARRY",
    "dropdelst": "IL",
    "dropdelzpp": 623129997,
    "dropphyadd": "600 DECATUR ST",
    "dropphycty": "BARRY",
    "dropphyst": "IL",
    "dropphyzpp": 623129997,
    "dropmaladd": "600 DECATUR ST",
    "dropmalcty": "BARRY",
    "dropmalst": "IL",
    "dropmalzpp": 623129997,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173352218,
    "dropsitcph": 2173352218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11982",
    "droptype": "D",
    "dropname": "BARSTOW",
    "dropdeladd": "18617 1ST AVE",
    "dropdelcty": "BARSTOW",
    "dropdelst": "IL",
    "dropdelzpp": 612369000,
    "dropphyadd": "18617 1ST AVE",
    "dropphycty": "BARSTOW",
    "dropphyst": "IL",
    "dropphyzpp": 612369000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARSTOW",
    "dropmalst": "IL",
    "dropmalzpp": 612369998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3094962610,
    "dropsitcph": 3094962610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11983",
    "droptype": "D",
    "dropname": "BARTELSO",
    "dropdeladd": "303 S WASHINGTON ST",
    "dropdelcty": "BARTELSO",
    "dropdelst": "IL",
    "dropdelzpp": 622189998,
    "dropphyadd": "303 S WASHINGTON ST",
    "dropphycty": "BARTELSO",
    "dropphyst": "IL",
    "dropphyzpp": 622189998,
    "dropmaladd": "303 S WASHINGTON ST",
    "dropmalcty": "BARTELSO",
    "dropmalst": "IL",
    "dropmalzpp": 622189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187652150,
    "dropsitcph": 6187652150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11984",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "160 BARTLETT PLZ",
    "dropdelcty": "BARTLETT",
    "dropdelst": "IL",
    "dropdelzpp": 601034265,
    "dropphyadd": "160 BARTLETT PLZ",
    "dropphycty": "BARTLETT",
    "dropphyst": "IL",
    "dropphyzpp": 601034265,
    "dropmaladd": "160 BARTLETT PLZ",
    "dropmalcty": "BARTLETT",
    "dropmalst": "IL",
    "dropmalzpp": 601034265,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308374468,
    "dropsitcph": 6308374468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11987",
    "droptype": "D",
    "dropname": "BASCO",
    "dropdeladd": "12 N MAIN ST",
    "dropdelcty": "BASCO",
    "dropdelst": "IL",
    "dropdelzpp": 623139998,
    "dropphyadd": "12 N MAIN ST",
    "dropphycty": "BASCO",
    "dropphyst": "IL",
    "dropphyzpp": 623139998,
    "dropmaladd": "12 N MAIN ST",
    "dropmalcty": "BASCO",
    "dropmalst": "IL",
    "dropmalzpp": 623139998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177435427,
    "dropsitcph": 2177435427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11988",
    "droptype": "D",
    "dropname": "BATAVIA",
    "dropdeladd": "500 N RANDALL RD",
    "dropdelcty": "BATAVIA",
    "dropdelst": "IL",
    "dropdelzpp": 605109998,
    "dropphyadd": "500 N RANDALL RD",
    "dropphycty": "BATAVIA",
    "dropphyst": "IL",
    "dropphyzpp": 605109998,
    "dropmaladd": "500 N RANDALL RD",
    "dropmalcty": "BATAVIA",
    "dropmalst": "IL",
    "dropmalzpp": 605109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6308791483,
    "dropfax": 6308792312
  },
  {
    "dcode": "D",
    "dropkey": "PW11989",
    "droptype": "D",
    "dropname": "BATCHTOWN",
    "dropdeladd": "301 BATCHTOWN RD",
    "dropdelcty": "BATCHTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 620069998,
    "dropphyadd": "301 BATCHTOWN RD",
    "dropphycty": "BATCHTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 620069998,
    "dropmaladd": "301 BATCHTOWN RD",
    "dropmalcty": "BATCHTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 620069998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182324019,
    "dropsitcph": 6182324019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11992",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "109 E 1ST ST",
    "dropdelcty": "BATH",
    "dropdelst": "IL",
    "dropdelzpp": 626179998,
    "dropphyadd": "109 E 1ST ST",
    "dropphycty": "BATH",
    "dropphyst": "IL",
    "dropphyzpp": 626179998,
    "dropmaladd": "109 E 1ST ST",
    "dropmalcty": "BATH",
    "dropmalst": "IL",
    "dropmalzpp": 626179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 3095462400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11994",
    "droptype": "D",
    "dropname": "BAYLIS",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "BAYLIS",
    "dropdelst": "IL",
    "dropdelzpp": 623149998,
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "BAYLIS",
    "dropphyst": "IL",
    "dropphyzpp": 623149998,
    "dropmaladd": "140 N MAIN ST",
    "dropmalcty": "BAYLIS",
    "dropmalst": "IL",
    "dropmalzpp": 623149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173362081,
    "dropsitcph": 2173362081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW11997",
    "droptype": "D",
    "dropname": "BEARDSTOWN",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "BEARDSTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 626189998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "BEARDSTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 626189998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "BEARDSTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 626189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173233044,
    "dropfax": 2173234783
  },
  {
    "dcode": "D",
    "dropkey": "PW11999",
    "droptype": "D",
    "dropname": "BEASON",
    "dropdeladd": "1555 BROADWAY ST",
    "dropdelcty": "BEASON",
    "dropdelst": "IL",
    "dropdelzpp": 625129998,
    "dropphyadd": "1555 BROADWAY ST",
    "dropphycty": "BEASON",
    "dropphyst": "IL",
    "dropphyzpp": 625129998,
    "dropmaladd": "1555 BROADWAY ST",
    "dropmalcty": "BEASON",
    "dropmalst": "IL",
    "dropmalzpp": 625129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174473308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12003",
    "droptype": "D",
    "dropname": "BEAVERVILLE",
    "dropdeladd": "702 SAINT CHARLES ST",
    "dropdelcty": "BEAVERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 609129998,
    "dropphyadd": "702 SAINT CHARLES ST",
    "dropphycty": "BEAVERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 609129998,
    "dropmaladd": "702 SAINT CHARLES ST",
    "dropmalcty": "BEAVERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 609129998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154352013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12006",
    "droptype": "D",
    "dropname": "BECKEMEYER",
    "dropdeladd": "470 LOUIS ST",
    "dropdelcty": "BECKEMEYER",
    "dropdelst": "IL",
    "dropdelzpp": 622199998,
    "dropphyadd": "470 LOUIS ST",
    "dropphycty": "BECKEMEYER",
    "dropphyst": "IL",
    "dropphyzpp": 622199998,
    "dropmaladd": "470 LOUIS ST",
    "dropmalcty": "BECKEMEYER",
    "dropmalst": "IL",
    "dropmalzpp": 622199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182278698,
    "dropsitcph": 6182278698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12010",
    "droptype": "D",
    "dropname": "BEDFORD PARK",
    "dropdeladd": "6801 W 73RD ST",
    "dropdelcty": "BEDFORD PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604999998,
    "dropphyadd": "6801 W 73RD ST",
    "dropphycty": "BEDFORD PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604999998,
    "dropmaladd": "6801 W 73RD ST",
    "dropmalcty": "BEDFORD PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604999998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7085637800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12014",
    "droptype": "D",
    "dropname": "BEECHER",
    "dropdeladd": "712 PENFIELD ST",
    "dropdelcty": "BEECHER",
    "dropdelst": "IL",
    "dropdelzpp": 604019800,
    "dropphyadd": "712 PENFIELD ST",
    "dropphycty": "BEECHER",
    "dropphyst": "IL",
    "dropphyzpp": 604019800,
    "dropmaladd": "712 PENFIELD ST",
    "dropmalcty": "BEECHER",
    "dropmalst": "IL",
    "dropmalzpp": 604019800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7089462550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12015",
    "droptype": "D",
    "dropname": "BEECHER CITY",
    "dropdeladd": "101 S SWEAZY ST",
    "dropdelcty": "BEECHER CITY",
    "dropdelst": "IL",
    "dropdelzpp": 624149998,
    "dropphyadd": "101 S SWEAZY ST",
    "dropphycty": "BEECHER CITY",
    "dropphyst": "IL",
    "dropphyzpp": 624149998,
    "dropmaladd": "101 S SWEAZY ST",
    "dropmalcty": "BEECHER CITY",
    "dropmalst": "IL",
    "dropmalzpp": 624149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184875520,
    "dropsitcph": 6184875520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12020",
    "droptype": "D",
    "dropname": "BELKNAP",
    "dropdeladd": "58 W MAIN ST",
    "dropdelcty": "BELKNAP",
    "dropdelst": "IL",
    "dropdelzpp": 629089998,
    "dropphyadd": "58 W MAIN ST",
    "dropphycty": "BELKNAP",
    "dropphyst": "IL",
    "dropphyzpp": 629089998,
    "dropmaladd": "58 W MAIN ST",
    "dropmalcty": "BELKNAP",
    "dropmalst": "IL",
    "dropmalzpp": 629089998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186349560,
    "dropsitcph": 6186349560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12024",
    "droptype": "D",
    "dropname": "BELLE RIVE",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "BELLE RIVE",
    "dropdelst": "IL",
    "dropdelzpp": 628109998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "BELLE RIVE",
    "dropphyst": "IL",
    "dropphyzpp": 628109998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "BELLE RIVE",
    "dropmalst": "IL",
    "dropmalzpp": 628109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187562484,
    "dropsitcph": 6187562484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12025",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "120 W WASHINGTON ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622209998,
    "dropphyadd": "120 W WASHINGTON ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622209998,
    "dropmaladd": "120 W WASHINGTON ST",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182330390,
    "dropsitcph": 6182330390,
    "dropfax": 6182339624
  },
  {
    "dcode": "D",
    "dropkey": "PW12029",
    "droptype": "D",
    "dropname": "BELLFLOWER",
    "dropdeladd": "204 N LATCHA ST",
    "dropdelcty": "BELLFLOWER",
    "dropdelst": "IL",
    "dropdelzpp": 617249998,
    "dropphyadd": "204 N LATCHA ST",
    "dropphycty": "BELLFLOWER",
    "dropphyst": "IL",
    "dropphyzpp": 617249998,
    "dropmaladd": "204 N LATCHA ST",
    "dropmalcty": "BELLFLOWER",
    "dropmalst": "IL",
    "dropmalzpp": 617249998,
    "dropsitphn": 3094756231,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097223213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12030",
    "droptype": "D",
    "dropname": "BELLMONT",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "BELLMONT",
    "dropdelst": "IL",
    "dropdelzpp": 628119998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "BELLMONT",
    "dropphyst": "IL",
    "dropphyzpp": 628119998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "BELLMONT",
    "dropmalst": "IL",
    "dropmalzpp": 628119998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182982218,
    "dropsitcph": 6182982413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12033",
    "droptype": "D",
    "dropname": "BELLWOOD",
    "dropdeladd": "2800 SAINT CHARLES RD",
    "dropdelcty": "BELLWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 601041568,
    "dropphyadd": "2800 SAINT CHARLES RD",
    "dropphycty": "BELLWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 601041568,
    "dropmaladd": "2800 SAINT CHARLES RD",
    "dropmalcty": "BELLWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 601041568,
    "dropsitphn": 6302605499,
    "dropsitlph": 7085445040,
    "dropsitcph": 7085445040,
    "dropfax": 7085445070
  },
  {
    "dcode": "D",
    "dropkey": "PW12036",
    "droptype": "D",
    "dropname": "BELVIDERE",
    "dropdeladd": "1800 DOC WOLF DR",
    "dropdelcty": "BELVIDERE",
    "dropdelst": "IL",
    "dropdelzpp": 610081801,
    "dropphyadd": "1800 DOC WOLF DR",
    "dropphycty": "BELVIDERE",
    "dropphyst": "IL",
    "dropphyzpp": 610081801,
    "dropmaladd": "1800 DOC WOLF DR",
    "dropmalcty": "BELVIDERE",
    "dropmalst": "IL",
    "dropmalzpp": 610081801,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155475457,
    "dropsitcph": 8155475457,
    "dropfax": 8155473401
  },
  {
    "dcode": "D",
    "dropkey": "PW12037",
    "droptype": "D",
    "dropname": "BEMENT",
    "dropdeladd": "200 E BODMAN ST",
    "dropdelcty": "BEMENT",
    "dropdelst": "IL",
    "dropdelzpp": 618139998,
    "dropphyadd": "200 E BODMAN ST",
    "dropphycty": "BEMENT",
    "dropphyst": "IL",
    "dropphyzpp": 618139998,
    "dropmaladd": "200 E BODMAN ST",
    "dropmalcty": "BEMENT",
    "dropmalst": "IL",
    "dropmalzpp": 618139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176782791,
    "dropfax": 2176783013
  },
  {
    "dcode": "D",
    "dropkey": "PW12038",
    "droptype": "D",
    "dropname": "BENLD",
    "dropdeladd": "106 E CENTRAL AVE STE 1",
    "dropdelcty": "BENLD",
    "dropdelst": "IL",
    "dropdelzpp": 620099998,
    "dropphyadd": "106 E CENTRAL AVE STE 1",
    "dropphycty": "BENLD",
    "dropphyst": "IL",
    "dropphyzpp": 620099998,
    "dropmaladd": "106 E CENTRAL AVE STE 1",
    "dropmalcty": "BENLD",
    "dropmalst": "IL",
    "dropmalzpp": 620099998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178352178,
    "dropsitcph": 2178352178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12040",
    "droptype": "D",
    "dropname": "BENSENVILLE",
    "dropdeladd": "303 E GREEN ST",
    "dropdelcty": "BENSENVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 601062500,
    "dropphyadd": "303 E GREEN ST",
    "dropphycty": "BENSENVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 601062500,
    "dropmaladd": "303 E GREEN ST",
    "dropmalcty": "BENSENVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 601062500,
    "dropsitphn": 6302605499,
    "dropsitlph": 6307662671,
    "dropsitcph": 6307662671,
    "dropfax": 6307666738
  },
  {
    "dcode": "D",
    "dropkey": "PW12044",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "320 FRONT ST",
    "dropdelcty": "BENSON",
    "dropdelst": "IL",
    "dropdelzpp": 615167500,
    "dropphyadd": "320 FRONT ST",
    "dropphycty": "BENSON",
    "dropphyst": "IL",
    "dropphyzpp": 615167500,
    "dropmaladd": "320 FRONT ST",
    "dropmalcty": "BENSON",
    "dropmalst": "IL",
    "dropmalzpp": 615167500,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093942613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12046",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "301 N DU QUOIN ST",
    "dropdelcty": "BENTON",
    "dropdelst": "IL",
    "dropdelzpp": 628129997,
    "dropphyadd": "301 N DU QUOIN ST",
    "dropphycty": "BENTON",
    "dropphyst": "IL",
    "dropphyzpp": 628129997,
    "dropmaladd": "301 N DU QUOIN ST",
    "dropmalcty": "BENTON",
    "dropmalst": "IL",
    "dropmalzpp": 628129997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184384931,
    "dropsitcph": 6184384931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12052",
    "droptype": "D",
    "dropname": "BERWICK",
    "dropdeladd": "1162 130TH ST",
    "dropdelcty": "BERWICK",
    "dropdelst": "IL",
    "dropdelzpp": 614179636,
    "dropphyadd": "1162 130TH ST",
    "dropphycty": "BERWICK",
    "dropphyst": "IL",
    "dropphyzpp": 614179636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERWICK",
    "dropmalst": "IL",
    "dropmalzpp": 614179998,
    "dropsitphn": 3094622932,
    "dropsitlph": 3094622932,
    "dropsitcph": 3094622932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12053",
    "droptype": "D",
    "dropname": "BERWYN",
    "dropdeladd": "6625 CERMAK RD",
    "dropdelcty": "BERWYN",
    "dropdelst": "IL",
    "dropdelzpp": 604029998,
    "dropphyadd": "6625 CERMAK RD",
    "dropphycty": "BERWYN",
    "dropphyst": "IL",
    "dropphyzpp": 604029998,
    "dropmaladd": "6625 CERMAK RD",
    "dropmalcty": "BERWYN",
    "dropmalst": "IL",
    "dropmalzpp": 604029998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084845392,
    "dropfax": 7087490348
  },
  {
    "dcode": "D",
    "dropkey": "PW12054",
    "droptype": "D",
    "dropname": "BETHALTO",
    "dropdeladd": "115 W CENTRAL ST",
    "dropdelcty": "BETHALTO",
    "dropdelst": "IL",
    "dropdelzpp": 620109998,
    "dropphyadd": "115 W CENTRAL ST",
    "dropphycty": "BETHALTO",
    "dropphyst": "IL",
    "dropphyzpp": 620109998,
    "dropmaladd": "115 W CENTRAL ST",
    "dropmalcty": "BETHALTO",
    "dropmalst": "IL",
    "dropmalzpp": 620109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183778714,
    "dropsitcph": 6183778714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12056",
    "droptype": "D",
    "dropname": "BETHANY",
    "dropdeladd": "119 S WASHINGTON ST",
    "dropdelcty": "BETHANY",
    "dropdelst": "IL",
    "dropdelzpp": 619149998,
    "dropphyadd": "119 S WASHINGTON ST",
    "dropphycty": "BETHANY",
    "dropphyst": "IL",
    "dropphyzpp": 619149998,
    "dropmaladd": "119 S WASHINGTON ST",
    "dropmalcty": "BETHANY",
    "dropmalst": "IL",
    "dropmalzpp": 619149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176653415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12068",
    "droptype": "D",
    "dropname": "BIG ROCK",
    "dropdeladd": "100 E 1ST ST",
    "dropdelcty": "BIG ROCK",
    "dropdelst": "IL",
    "dropdelzpp": 605119998,
    "dropphyadd": "100 E 1ST ST",
    "dropphycty": "BIG ROCK",
    "dropphyst": "IL",
    "dropphyzpp": 605119998,
    "dropmaladd": "100 E 1ST ST",
    "dropmalcty": "BIG ROCK",
    "dropmalst": "IL",
    "dropmalzpp": 605119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6305563177,
    "dropfax": 6305564776
  },
  {
    "dcode": "D",
    "dropkey": "PW12071",
    "droptype": "D",
    "dropname": "BIGGSVILLE",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "BIGGSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 614189800,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "BIGGSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 614189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIGGSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 614189998,
    "dropsitphn": 3097344312,
    "dropsitlph": 3096272360,
    "dropsitcph": 3096272360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12080",
    "droptype": "D",
    "dropname": "BISHOP HILL",
    "dropdeladd": "107 N BISHOP HILL ST",
    "dropdelcty": "BISHOP HILL",
    "dropdelst": "IL",
    "dropdelzpp": 614199800,
    "dropphyadd": "107 N BISHOP HILL ST",
    "dropphycty": "BISHOP HILL",
    "dropphyst": "IL",
    "dropphyzpp": 614199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BISHOP HILL",
    "dropmalst": "IL",
    "dropmalzpp": 614199998,
    "dropsitphn": 3099273595,
    "dropsitlph": 3099273595,
    "dropsitcph": 3099273595,
    "dropfax": 3099273595
  },
  {
    "dcode": "D",
    "dropkey": "PW12081",
    "droptype": "D",
    "dropname": "BISMARCK",
    "dropdeladd": "104 E HOLLOWAY ST",
    "dropdelcty": "BISMARCK",
    "dropdelst": "IL",
    "dropdelzpp": 618149998,
    "dropphyadd": "104 E HOLLOWAY ST",
    "dropphycty": "BISMARCK",
    "dropphyst": "IL",
    "dropphyzpp": 618149998,
    "dropmaladd": "104 E HOLLOWAY ST",
    "dropmalcty": "BISMARCK",
    "dropmalst": "IL",
    "dropmalzpp": 618149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177597851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12085",
    "droptype": "D",
    "dropname": "BLACKSTONE",
    "dropdeladd": "12385 E 3153 NORTH RD",
    "dropdelcty": "BLACKSTONE",
    "dropdelst": "IL",
    "dropdelzpp": 613139609,
    "dropphyadd": "12385 E 3153 NORTH RD",
    "dropphycty": "BLACKSTONE",
    "dropphyst": "IL",
    "dropphyzpp": 613139609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACKSTONE",
    "dropmalst": "IL",
    "dropmalzpp": 613139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156723545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12091",
    "droptype": "D",
    "dropname": "BLANDINSVILLE",
    "dropdeladd": "123 E JEFFERSON ST",
    "dropdelcty": "BLANDINSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 614209800,
    "dropphyadd": "123 E JEFFERSON ST",
    "dropphycty": "BLANDINSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 614209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLANDINSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 614209998,
    "dropsitphn": 3096523181,
    "dropsitlph": 3096523181,
    "dropsitcph": 3096523181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12092",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "108 W SCHICK RD",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "IL",
    "dropdelzpp": 601082914,
    "dropphyadd": "108 W SCHICK RD",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "IL",
    "dropphyzpp": 601082914,
    "dropmaladd": "108 W SCHICK RD",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "IL",
    "dropmalzpp": 601082914,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305295287,
    "dropsitcph": 6305295287,
    "dropfax": 6305295596
  },
  {
    "dcode": "D",
    "dropkey": "PW12095",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "1511 E EMPIRE ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617013528,
    "dropphyadd": "1511 E EMPIRE ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617013528,
    "dropmaladd": "1511 E EMPIRE ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617013528,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096644600,
    "dropfax": 3096680076
  },
  {
    "dcode": "D",
    "dropkey": "PW12100",
    "droptype": "D",
    "dropname": "BLUE ISLAND",
    "dropdeladd": "2441 VERMONT ST",
    "dropdelcty": "BLUE ISLAND",
    "dropdelst": "IL",
    "dropdelzpp": 604069998,
    "dropphyadd": "2441 VERMONT ST",
    "dropphycty": "BLUE ISLAND",
    "dropphyst": "IL",
    "dropphyzpp": 604069998,
    "dropmaladd": "2441 VERMONT ST",
    "dropmalcty": "BLUE ISLAND",
    "dropmalst": "IL",
    "dropmalzpp": 604069998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083850113,
    "dropfax": 7083851675
  },
  {
    "dcode": "D",
    "dropkey": "PW12101",
    "droptype": "D",
    "dropname": "BLUE MOUND",
    "dropdeladd": "230 W NILES ST",
    "dropdelcty": "BLUE MOUND",
    "dropdelst": "IL",
    "dropdelzpp": 625139998,
    "dropphyadd": "230 W NILES ST",
    "dropphycty": "BLUE MOUND",
    "dropphyst": "IL",
    "dropphyzpp": 625139998,
    "dropmaladd": "230 W NILES ST",
    "dropmalcty": "BLUE MOUND",
    "dropmalst": "IL",
    "dropmalzpp": 625139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176922285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12106",
    "droptype": "D",
    "dropname": "BLUFF SPRINGS",
    "dropdeladd": "7463 S BLUFF SPRINGS RD",
    "dropdelcty": "BLUFF SPRINGS",
    "dropdelst": "IL",
    "dropdelzpp": 626229998,
    "dropphyadd": "7463 S BLUFF SPRINGS RD",
    "dropphycty": "BLUFF SPRINGS",
    "dropphyst": "IL",
    "dropphyzpp": 626229998,
    "dropmaladd": "7463 S BLUFF SPRINGS RD",
    "dropmalcty": "BLUFF SPRINGS",
    "dropmalst": "IL",
    "dropmalzpp": 626229998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173231160,
    "dropfax": 2173231160
  },
  {
    "dcode": "D",
    "dropkey": "PW12107",
    "droptype": "D",
    "dropname": "BLUFFS",
    "dropdeladd": "119 E OAKES ST",
    "dropdelcty": "BLUFFS",
    "dropdelst": "IL",
    "dropdelzpp": 626219998,
    "dropphyadd": "119 E OAKES ST",
    "dropphycty": "BLUFFS",
    "dropphyst": "IL",
    "dropphyzpp": 626219998,
    "dropmaladd": "119 E OAKES ST",
    "dropmalcty": "BLUFFS",
    "dropmalst": "IL",
    "dropmalzpp": 626219998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177543551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12108",
    "droptype": "D",
    "dropname": "BLUFORD",
    "dropdeladd": "1010 W 2ND ST",
    "dropdelcty": "BLUFORD",
    "dropdelst": "IL",
    "dropdelzpp": 628149998,
    "dropphyadd": "1010 W 2ND ST",
    "dropphycty": "BLUFORD",
    "dropphyst": "IL",
    "dropphyzpp": 628149998,
    "dropmaladd": "1010 W 2ND ST",
    "dropmalcty": "BLUFORD",
    "dropmalst": "IL",
    "dropmalzpp": 628149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187328502,
    "dropsitcph": 6187328502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12123",
    "droptype": "D",
    "dropname": "BONDVILLE",
    "dropdeladd": "307 S MARKET ST",
    "dropdelcty": "BONDVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 618159998,
    "dropphyadd": "307 S MARKET ST",
    "dropphycty": "BONDVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 618159998,
    "dropmaladd": "307 S MARKET ST",
    "dropmalcty": "BONDVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 618159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178632240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12124",
    "droptype": "D",
    "dropname": "BONE GAP",
    "dropdeladd": "105 N STATE ST",
    "dropdelcty": "BONE GAP",
    "dropdelst": "IL",
    "dropdelzpp": 628159998,
    "dropphyadd": "105 N STATE ST",
    "dropphycty": "BONE GAP",
    "dropphyst": "IL",
    "dropphyzpp": 628159998,
    "dropmaladd": "105 N STATE ST",
    "dropmalcty": "BONE GAP",
    "dropmalst": "IL",
    "dropmalzpp": 628159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184463313,
    "dropsitcph": 6184463313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12125",
    "droptype": "D",
    "dropname": "BONFIELD",
    "dropdeladd": "157 W SMITH ST",
    "dropdelcty": "BONFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 609139800,
    "dropphyadd": "157 W SMITH ST",
    "dropphycty": "BONFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 609139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BONFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 609139998,
    "dropsitphn": 8159334168,
    "dropsitlph": 8159334168,
    "dropsitcph": 8159334168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12126",
    "droptype": "D",
    "dropname": "BONNIE",
    "dropdeladd": "285 S IL HIGHWAY 37",
    "dropdelcty": "BONNIE",
    "dropdelst": "IL",
    "dropdelzpp": 628169998,
    "dropphyadd": "285 S IL HIGHWAY 37",
    "dropphycty": "BONNIE",
    "dropphyst": "IL",
    "dropphyzpp": 628169998,
    "dropmaladd": "285 S IL HIGHWAY 37",
    "dropmalcty": "BONNIE",
    "dropmalst": "IL",
    "dropmalzpp": 628169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182426583,
    "dropsitcph": 6182426583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12129",
    "droptype": "D",
    "dropname": "BOODY",
    "dropdeladd": "6164 S ROUTE 48",
    "dropdelcty": "BOODY",
    "dropdelst": "IL",
    "dropdelzpp": 625149998,
    "dropphyadd": "6164 S ROUTE 48",
    "dropphycty": "BOODY",
    "dropphyst": "IL",
    "dropphyzpp": 625149998,
    "dropmaladd": "6164 S ROUTE 48",
    "dropmalcty": "BOODY",
    "dropmalst": "IL",
    "dropmalzpp": 625149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178652472,
    "dropfax": 2178652472
  },
  {
    "dcode": "D",
    "dropkey": "PW12133",
    "droptype": "D",
    "dropname": "BOURBONNAIS",
    "dropdeladd": "850 MAIN ST NW",
    "dropdelcty": "BOURBONNAIS",
    "dropdelst": "IL",
    "dropdelzpp": 609149998,
    "dropphyadd": "850 MAIN ST NW",
    "dropphycty": "BOURBONNAIS",
    "dropphyst": "IL",
    "dropphyzpp": 609149998,
    "dropmaladd": "850 MAIN ST NW",
    "dropmalcty": "BOURBONNAIS",
    "dropmalst": "IL",
    "dropmalzpp": 609149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8159391531,
    "dropfax": 8159350262
  },
  {
    "dcode": "D",
    "dropkey": "PW12134",
    "droptype": "D",
    "dropname": "BOWEN",
    "dropdeladd": "114 E 5TH ST",
    "dropdelcty": "BOWEN",
    "dropdelst": "IL",
    "dropdelzpp": 623169998,
    "dropphyadd": "114 E 5TH ST",
    "dropphycty": "BOWEN",
    "dropphyst": "IL",
    "dropphyzpp": 623169998,
    "dropmaladd": "114 E 5TH ST",
    "dropmalcty": "BOWEN",
    "dropmalst": "IL",
    "dropmalzpp": 623169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178425215,
    "dropsitcph": 2178425215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12145",
    "droptype": "D",
    "dropname": "BRACEVILLE",
    "dropdeladd": "106 N MITCHELL ST",
    "dropdelcty": "BRACEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 604079998,
    "dropphyadd": "106 N MITCHELL ST",
    "dropphycty": "BRACEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 604079998,
    "dropmaladd": "106 N MITCHELL ST",
    "dropmalcty": "BRACEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 604079998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152372627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12149",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "129 W MAIN ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "IL",
    "dropdelzpp": 614219800,
    "dropphyadd": "129 W MAIN ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "IL",
    "dropphyzpp": 614219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADFORD",
    "dropmalst": "IL",
    "dropmalzpp": 614219998,
    "dropsitphn": 3098977901,
    "dropsitlph": 3098977901,
    "dropsitcph": 3098977901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12152",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "258 W BROADWAY ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "IL",
    "dropdelzpp": 609159998,
    "dropphyadd": "258 W BROADWAY ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "IL",
    "dropphyzpp": 609159998,
    "dropmaladd": "258 W BROADWAY ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "IL",
    "dropmalzpp": 609159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8159324133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12154",
    "droptype": "D",
    "dropname": "BRAIDWOOD",
    "dropdeladd": "280 W MAIN ST",
    "dropdelcty": "BRAIDWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 604089998,
    "dropphyadd": "280 W MAIN ST",
    "dropphycty": "BRAIDWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 604089998,
    "dropmaladd": "280 W MAIN ST",
    "dropmalcty": "BRAIDWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 604089998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154583422,
    "dropfax": 8154583433
  },
  {
    "dcode": "D",
    "dropkey": "PW12158",
    "droptype": "D",
    "dropname": "BREESE",
    "dropdeladd": "501 N 2ND ST",
    "dropdelcty": "BREESE",
    "dropdelst": "IL",
    "dropdelzpp": 622309998,
    "dropphyadd": "501 N 2ND ST",
    "dropphycty": "BREESE",
    "dropphyst": "IL",
    "dropphyzpp": 622309998,
    "dropmaladd": "501 N 2ND ST",
    "dropmalcty": "BREESE",
    "dropmalst": "IL",
    "dropmalzpp": 622309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185267912,
    "dropsitcph": 6185267912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12165",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "250 E OLIVE ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "IL",
    "dropdelzpp": 624179998,
    "dropphyadd": "250 E OLIVE ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "IL",
    "dropphyzpp": 624179998,
    "dropmaladd": "250 E OLIVE ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "IL",
    "dropmalzpp": 624179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189458261,
    "dropsitcph": 6189458261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12168",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "410 N MAIN ST",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "IL",
    "dropdelzpp": 620129997,
    "dropphyadd": "410 N MAIN ST",
    "dropphycty": "BRIGHTON",
    "dropphyst": "IL",
    "dropphyzpp": 620129997,
    "dropmaladd": "410 N MAIN ST",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "IL",
    "dropmalzpp": 620129997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183723011,
    "dropsitcph": 6183723011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12169",
    "droptype": "D",
    "dropname": "BRIMFIELD",
    "dropdeladd": "123 N GALENA AVE",
    "dropdelcty": "BRIMFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 615179900,
    "dropphyadd": "123 N GALENA AVE",
    "dropphycty": "BRIMFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 615179900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIMFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 615179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094463025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12170",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "11 CANNONBALL TRL",
    "dropdelcty": "BRISTOL",
    "dropdelst": "IL",
    "dropdelzpp": 605129998,
    "dropphyadd": "11 CANNONBALL TRL",
    "dropphycty": "BRISTOL",
    "dropphyst": "IL",
    "dropphyzpp": 605129998,
    "dropmaladd": "11 CANNONBALL TRL",
    "dropmalcty": "BRISTOL",
    "dropmalst": "IL",
    "dropmalzpp": 605129998,
    "dropsitphn": 6305537100,
    "dropsitlph": 7085635789,
    "dropsitcph": 6305530666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12172",
    "droptype": "D",
    "dropname": "BROADLANDS",
    "dropdeladd": "107 E DILLER ST",
    "dropdelcty": "BROADLANDS",
    "dropdelst": "IL",
    "dropdelzpp": 618169998,
    "dropphyadd": "107 E DILLER ST",
    "dropphycty": "BROADLANDS",
    "dropphyst": "IL",
    "dropphyzpp": 618169998,
    "dropmaladd": "107 E DILLER ST",
    "dropmalcty": "BROADLANDS",
    "dropmalst": "IL",
    "dropmalzpp": 618169998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178343415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12176",
    "droptype": "D",
    "dropname": "BROCTON",
    "dropdeladd": "110 E 3RD ST",
    "dropdelcty": "BROCTON",
    "dropdelst": "IL",
    "dropdelzpp": 619179998,
    "dropphyadd": "110 E 3RD ST",
    "dropphycty": "BROCTON",
    "dropphyst": "IL",
    "dropphyzpp": 619179998,
    "dropmaladd": "110 E 3RD ST",
    "dropmalcty": "BROCTON",
    "dropmalst": "IL",
    "dropmalzpp": 619179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173852413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12177",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "3731 PRAIRIE AVE",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 605139998,
    "dropphyadd": "3731 PRAIRIE AVE",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 605139998,
    "dropmaladd": "3731 PRAIRIE AVE",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 605139998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 7084850572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12181",
    "droptype": "D",
    "dropname": "BROOKPORT",
    "dropdeladd": "200 OHIO ST",
    "dropdelcty": "BROOKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 629109998,
    "dropphyadd": "200 OHIO ST",
    "dropphycty": "BROOKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 629109998,
    "dropmaladd": "200 OHIO ST",
    "dropmalcty": "BROOKPORT",
    "dropmalst": "IL",
    "dropmalzpp": 629109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185643133,
    "dropsitcph": 6185643133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12184",
    "droptype": "D",
    "dropname": "BROUGHTON",
    "dropdeladd": "211 DAWES ST",
    "dropdelcty": "BROUGHTON",
    "dropdelst": "IL",
    "dropdelzpp": 628179998,
    "dropphyadd": "211 DAWES ST",
    "dropphycty": "BROUGHTON",
    "dropphyst": "IL",
    "dropphyzpp": 628179998,
    "dropmaladd": "211 DAWES ST",
    "dropmalcty": "BROUGHTON",
    "dropmalst": "IL",
    "dropmalzpp": 628179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186472282,
    "dropsitcph": 6186472282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12187",
    "droptype": "D",
    "dropname": "BROWNING",
    "dropdeladd": "102 N WALNUT ST",
    "dropdelcty": "BROWNING",
    "dropdelst": "IL",
    "dropdelzpp": 626249998,
    "dropphyadd": "102 N WALNUT ST",
    "dropphycty": "BROWNING",
    "dropphyst": "IL",
    "dropphyzpp": 626249998,
    "dropmaladd": "102 N WALNUT ST",
    "dropmalcty": "BROWNING",
    "dropmalst": "IL",
    "dropmalzpp": 626249998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173232771,
    "dropfax": 2173232771
  },
  {
    "dcode": "D",
    "dropkey": "PW12188",
    "droptype": "D",
    "dropname": "BROWNS",
    "dropdeladd": "602 HENDERSON ST",
    "dropdelcty": "BROWNS",
    "dropdelst": "IL",
    "dropdelzpp": 628189998,
    "dropphyadd": "602 HENDERSON ST",
    "dropphycty": "BROWNS",
    "dropphyst": "IL",
    "dropphyzpp": 628189998,
    "dropmaladd": "602 HENDERSON ST",
    "dropmalcty": "BROWNS",
    "dropmalst": "IL",
    "dropmalzpp": 628189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184465244,
    "dropsitcph": 6184465244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12189",
    "droptype": "D",
    "dropname": "BROWNSTOWN",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "BROWNSTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 624189998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "BROWNSTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 624189998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "BROWNSTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 624189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184275155,
    "dropsitcph": 6184275155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12193",
    "droptype": "D",
    "dropname": "BRUSSELS",
    "dropdeladd": "167 E MAIN ST",
    "dropdelcty": "BRUSSELS",
    "dropdelst": "IL",
    "dropdelzpp": 620139998,
    "dropphyadd": "167 E MAIN ST",
    "dropphycty": "BRUSSELS",
    "dropphyst": "IL",
    "dropphyzpp": 620139998,
    "dropmaladd": "167 E MAIN ST",
    "dropmalcty": "BRUSSELS",
    "dropmalst": "IL",
    "dropmalzpp": 620139998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188838046,
    "dropsitcph": 6188838046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12195",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "BRYANT",
    "dropdelst": "IL",
    "dropdelzpp": 615199500,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "BRYANT",
    "dropphyst": "IL",
    "dropphyzpp": 615199500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRYANT",
    "dropmalst": "IL",
    "dropmalzpp": 615199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096682980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12198",
    "droptype": "D",
    "dropname": "BUCKINGHAM",
    "dropdeladd": "110 RAILROAD ST",
    "dropdelcty": "BUCKINGHAM",
    "dropdelst": "IL",
    "dropdelzpp": 609179998,
    "dropphyadd": "110 RAILROAD ST",
    "dropphycty": "BUCKINGHAM",
    "dropphyst": "IL",
    "dropphyzpp": 609179998,
    "dropmaladd": "110 RAILROAD ST",
    "dropmalcty": "BUCKINGHAM",
    "dropmalst": "IL",
    "dropmalzpp": 609179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154266378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12199",
    "droptype": "D",
    "dropname": "BUCKLEY",
    "dropdeladd": "116 N RAILROAD AVE",
    "dropdelcty": "BUCKLEY",
    "dropdelst": "IL",
    "dropdelzpp": 609189998,
    "dropphyadd": "116 N RAILROAD AVE",
    "dropphycty": "BUCKLEY",
    "dropphyst": "IL",
    "dropphyzpp": 609189998,
    "dropmaladd": "116 N RAILROAD AVE",
    "dropmalcty": "BUCKLEY",
    "dropmalst": "IL",
    "dropmalzpp": 609189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173942273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12200",
    "droptype": "D",
    "dropname": "BUCKNER",
    "dropdeladd": "100 S MARKET ST",
    "dropdelcty": "BUCKNER",
    "dropdelst": "IL",
    "dropdelzpp": 628199998,
    "dropphyadd": "100 S MARKET ST",
    "dropphycty": "BUCKNER",
    "dropphyst": "IL",
    "dropphyzpp": 628199998,
    "dropmaladd": "100 S MARKET ST",
    "dropmalcty": "BUCKNER",
    "dropmalst": "IL",
    "dropmalzpp": 628199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187244644,
    "dropsitcph": 6187244644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12201",
    "droptype": "D",
    "dropname": "BUDA",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "BUDA",
    "dropdelst": "IL",
    "dropdelzpp": 613149609,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "BUDA",
    "dropphyst": "IL",
    "dropphyzpp": 613149609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUDA",
    "dropmalst": "IL",
    "dropmalzpp": 613149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3098956381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12204",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "102 W ELM ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "IL",
    "dropdelzpp": 625159998,
    "dropphyadd": "102 W ELM ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "IL",
    "dropphyzpp": 625159998,
    "dropmaladd": "102 W ELM ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "IL",
    "dropmalzpp": 625159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173644989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12207",
    "droptype": "D",
    "dropname": "BUFFALO GROVE",
    "dropdeladd": "255 N BUFFALO GROVE RD",
    "dropdelcty": "BUFFALO GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 600892431,
    "dropphyadd": "255 N BUFFALO GROVE RD",
    "dropphycty": "BUFFALO GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 600892431,
    "dropmaladd": "255 N BUFFALO GROVE RD",
    "dropmalcty": "BUFFALO GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 600892431,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475200268,
    "dropsitcph": 8475200268,
    "dropfax": 8475200251
  },
  {
    "dcode": "D",
    "dropkey": "PW12213",
    "droptype": "D",
    "dropname": "BUFFALO PRAIRIE",
    "dropdeladd": "18401 206TH ST W",
    "dropdelcty": "BUFFALO PRAIRIE",
    "dropdelst": "IL",
    "dropdelzpp": 612379001,
    "dropphyadd": "18401 206TH ST W",
    "dropphycty": "BUFFALO PRAIRIE",
    "dropphyst": "IL",
    "dropphyzpp": 612379001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUFFALO PRAIRIE",
    "dropmalst": "IL",
    "dropmalzpp": 612379998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095373169,
    "dropsitcph": 3095373169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12216",
    "droptype": "D",
    "dropname": "BULPITT",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "BULPITT",
    "dropdelst": "IL",
    "dropdelzpp": 625179701,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "BULPITT",
    "dropphyst": "IL",
    "dropphyzpp": 625179701,
    "dropmaladd": "111 MAIN ST",
    "dropmalcty": "BULPITT",
    "dropmalst": "IL",
    "dropmalzpp": 625179701,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172372242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12217",
    "droptype": "D",
    "dropname": "BUNCOMBE",
    "dropdeladd": "55 MAIN ST",
    "dropdelcty": "BUNCOMBE",
    "dropdelst": "IL",
    "dropdelzpp": 629129998,
    "dropphyadd": "55 MAIN ST",
    "dropphycty": "BUNCOMBE",
    "dropphyst": "IL",
    "dropphyzpp": 629129998,
    "dropmaladd": "55 MAIN ST",
    "dropmalcty": "BUNCOMBE",
    "dropmalst": "IL",
    "dropmalzpp": 629129998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186588711,
    "dropsitcph": 6186588711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12219",
    "droptype": "D",
    "dropname": "BUNKER HILL",
    "dropdeladd": "105 E FAYETTE ST",
    "dropdelcty": "BUNKER HILL",
    "dropdelst": "IL",
    "dropdelzpp": 620149998,
    "dropphyadd": "105 E FAYETTE ST",
    "dropphycty": "BUNKER HILL",
    "dropphyst": "IL",
    "dropphyzpp": 620149998,
    "dropmaladd": "105 E FAYETTE ST",
    "dropmalcty": "BUNKER HILL",
    "dropmalst": "IL",
    "dropmalzpp": 620149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185853017,
    "dropsitcph": 6185853017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12223",
    "droptype": "D",
    "dropname": "BUREAU",
    "dropdeladd": "201 E NEBRASKA ST",
    "dropdelcty": "BUREAU",
    "dropdelst": "IL",
    "dropdelzpp": 613159700,
    "dropphyadd": "201 E NEBRASKA ST",
    "dropphycty": "BUREAU",
    "dropphyst": "IL",
    "dropphyzpp": 613159700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUREAU",
    "dropmalst": "IL",
    "dropmalzpp": 613159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156593128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12229",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "375 S MAIN ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 601091000,
    "dropphyadd": "375 S MAIN ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 601091000,
    "dropmaladd": "375 S MAIN ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 601091000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476833590,
    "dropsitcph": 8476833590,
    "dropfax": 8476833950
  },
  {
    "dcode": "D",
    "dropkey": "PW12245",
    "droptype": "D",
    "dropname": "BUSHNELL",
    "dropdeladd": "223 E HAIL ST",
    "dropdelcty": "BUSHNELL",
    "dropdelst": "IL",
    "dropdelzpp": 614229800,
    "dropphyadd": "223 E HAIL ST",
    "dropphycty": "BUSHNELL",
    "dropphyst": "IL",
    "dropphyzpp": 614229800,
    "dropmaladd": "223 E HAIL ST",
    "dropmalcty": "BUSHNELL",
    "dropmalst": "IL",
    "dropmalzpp": 614229800,
    "dropsitphn": 3097723515,
    "dropsitlph": 3097723515,
    "dropsitcph": 3097723515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12246",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "712 WATER ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "IL",
    "dropdelzpp": 620159998,
    "dropphyadd": "712 WATER ST",
    "dropphycty": "BUTLER",
    "dropphyst": "IL",
    "dropphyzpp": 620159998,
    "dropmaladd": "712 WATER ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "IL",
    "dropmalzpp": 620159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175322541,
    "dropsitcph": 2175322541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12247",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "232 N UNION ST",
    "dropdelcty": "BYRON",
    "dropdelst": "IL",
    "dropdelzpp": 610108812,
    "dropphyadd": "232 N UNION ST",
    "dropphycty": "BYRON",
    "dropphyst": "IL",
    "dropphyzpp": 610108812,
    "dropmaladd": "232 N UNION ST",
    "dropmalcty": "BYRON",
    "dropmalst": "IL",
    "dropmalzpp": 610108812,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152344561,
    "dropsitcph": 8152344561,
    "dropfax": 8152347533
  },
  {
    "dcode": "D",
    "dropkey": "PW12250",
    "droptype": "D",
    "dropname": "CABERY",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "CABERY",
    "dropdelst": "IL",
    "dropdelzpp": 609199800,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "CABERY",
    "dropphyst": "IL",
    "dropphyzpp": 609199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CABERY",
    "dropmalst": "IL",
    "dropmalzpp": 609199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8159491700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12255",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "1500 WASHINGTON AVE",
    "dropdelcty": "CAIRO",
    "dropdelst": "IL",
    "dropdelzpp": 629149998,
    "dropphyadd": "1500 WASHINGTON AVE",
    "dropphycty": "CAIRO",
    "dropphyst": "IL",
    "dropphyzpp": 629149998,
    "dropmaladd": "1500 WASHINGTON AVE",
    "dropmalcty": "CAIRO",
    "dropmalst": "IL",
    "dropmalzpp": 629149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187342062,
    "dropsitcph": 6187342062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12257",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "2201 IL ROUTE 173",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "IL",
    "dropdelzpp": 610119796,
    "dropphyadd": "2201 IL ROUTE 173",
    "dropphycty": "CALEDONIA",
    "dropphyst": "IL",
    "dropphyzpp": 610119796,
    "dropmaladd": "2201 IL ROUTE 173",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "IL",
    "dropmalzpp": 610119796,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157652023,
    "dropsitcph": 8157652023,
    "dropfax": 8157652051
  },
  {
    "dcode": "D",
    "dropkey": "PW12258",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "CALHOUN",
    "dropdelst": "IL",
    "dropdelzpp": 624199998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "CALHOUN",
    "dropphyst": "IL",
    "dropphyzpp": 624199998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "CALHOUN",
    "dropmalst": "IL",
    "dropmalzpp": 624199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188632390,
    "dropsitcph": 6188632390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12259",
    "droptype": "D",
    "dropname": "CALUMET CITY",
    "dropdeladd": "1200 RING RD",
    "dropdelcty": "CALUMET CITY",
    "dropdelst": "IL",
    "dropdelzpp": 604099998,
    "dropphyadd": "1200 RING RD",
    "dropphycty": "CALUMET CITY",
    "dropphyst": "IL",
    "dropphyzpp": 604099998,
    "dropmaladd": "1200 RING RD",
    "dropmalcty": "CALUMET CITY",
    "dropmalst": "IL",
    "dropmalzpp": 604099998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7088626900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12265",
    "droptype": "D",
    "dropname": "CAMARGO",
    "dropdeladd": "203 W MAIN ST",
    "dropdelcty": "CAMARGO",
    "dropdelst": "IL",
    "dropdelzpp": 619199998,
    "dropphyadd": "203 W MAIN ST",
    "dropphycty": "CAMARGO",
    "dropphyst": "IL",
    "dropphyzpp": 619199998,
    "dropmaladd": "203 W MAIN ST",
    "dropmalcty": "CAMARGO",
    "dropmalst": "IL",
    "dropmalzpp": 619199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178329219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12266",
    "droptype": "D",
    "dropname": "CAMBRIA",
    "dropdeladd": "104 N MAPLE ST",
    "dropdelcty": "CAMBRIA",
    "dropdelst": "IL",
    "dropdelzpp": 629159998,
    "dropphyadd": "104 N MAPLE ST",
    "dropphycty": "CAMBRIA",
    "dropphyst": "IL",
    "dropphyzpp": 629159998,
    "dropmaladd": "104 N MAPLE ST",
    "dropmalcty": "CAMBRIA",
    "dropmalst": "IL",
    "dropmalzpp": 629159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189856501,
    "dropsitcph": 6189856501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12267",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "109 N PROSPECT ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 612389998,
    "dropphyadd": "109 N PROSPECT ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 612389998,
    "dropmaladd": "109 N PROSPECT ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 612389998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3099372133,
    "dropsitcph": 3099372133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12268",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "12270 BROADWAY ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "IL",
    "dropdelzpp": 623199998,
    "dropphyadd": "12270 BROADWAY ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "IL",
    "dropphyzpp": 623199998,
    "dropmaladd": "12270 BROADWAY ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "IL",
    "dropmalzpp": 623199998,
    "dropsitphn": 2173922499,
    "dropsitlph": 2173922499,
    "dropsitcph": 2173224584,
    "dropfax": 2173224584
  },
  {
    "dcode": "D",
    "dropkey": "PW12269",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "559 CARE ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "IL",
    "dropdelzpp": 614239800,
    "dropphyadd": "559 CARE ST",
    "dropphycty": "CAMERON",
    "dropphyst": "IL",
    "dropphyzpp": 614239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMERON",
    "dropmalst": "IL",
    "dropmalzpp": 614239998,
    "dropsitphn": 3094622441,
    "dropsitlph": 3095639627,
    "dropsitcph": 3095639627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12272",
    "droptype": "D",
    "dropname": "CAMP GROVE",
    "dropdeladd": "1060 2ND ST",
    "dropdelcty": "CAMP GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 614249800,
    "dropphyadd": "1060 2ND ST",
    "dropphycty": "CAMP GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 614249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMP GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 614249998,
    "dropsitphn": 3094937861,
    "dropsitlph": 3094937861,
    "dropsitcph": 3094937861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12273",
    "droptype": "D",
    "dropname": "CAMP POINT",
    "dropdeladd": "108 N ILLINOIS ST",
    "dropdelcty": "CAMP POINT",
    "dropdelst": "IL",
    "dropdelzpp": 623209998,
    "dropphyadd": "108 N ILLINOIS ST",
    "dropphycty": "CAMP POINT",
    "dropphyst": "IL",
    "dropphyzpp": 623209998,
    "dropmaladd": "108 N ILLINOIS ST",
    "dropmalcty": "CAMP POINT",
    "dropmalst": "IL",
    "dropmalzpp": 623209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175937119,
    "dropsitcph": 2175937119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12274",
    "droptype": "D",
    "dropname": "CAMPBELL HILL",
    "dropdeladd": "106 W FRONT ST",
    "dropdelcty": "CAMPBELL HILL",
    "dropdelst": "IL",
    "dropdelzpp": 629169998,
    "dropphyadd": "106 W FRONT ST",
    "dropphycty": "CAMPBELL HILL",
    "dropphyst": "IL",
    "dropphyzpp": 629169998,
    "dropmaladd": "106 W FRONT ST",
    "dropmalcty": "CAMPBELL HILL",
    "dropmalst": "IL",
    "dropmalzpp": 629169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184263284,
    "dropsitcph": 6184263284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12277",
    "droptype": "D",
    "dropname": "CAMPUS",
    "dropdeladd": "107 CENTER ST",
    "dropdelcty": "CAMPUS",
    "dropdelst": "IL",
    "dropdelzpp": 609209998,
    "dropphyadd": "107 CENTER ST",
    "dropphycty": "CAMPUS",
    "dropphyst": "IL",
    "dropphyzpp": 609209998,
    "dropmaladd": "107 CENTER ST",
    "dropmalcty": "CAMPUS",
    "dropmalst": "IL",
    "dropmalzpp": 609209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8155673337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12281",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "60 W ELM ST",
    "dropdelcty": "CANTON",
    "dropdelst": "IL",
    "dropdelzpp": 615209998,
    "dropphyadd": "60 W ELM ST",
    "dropphycty": "CANTON",
    "dropphyst": "IL",
    "dropphyzpp": 615209998,
    "dropmaladd": "60 W ELM ST",
    "dropmalcty": "CANTON",
    "dropmalst": "IL",
    "dropmalzpp": 615209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096470309,
    "dropfax": 3096471987
  },
  {
    "dcode": "D",
    "dropkey": "PW12282",
    "droptype": "D",
    "dropname": "CANTRALL",
    "dropdeladd": "9446 STATE ROUTE 29",
    "dropdelcty": "CANTRALL",
    "dropdelst": "IL",
    "dropdelzpp": 626259998,
    "dropphyadd": "9446 STATE ROUTE 29",
    "dropphycty": "CANTRALL",
    "dropphyst": "IL",
    "dropphyzpp": 626259998,
    "dropmaladd": "9446 STATE ROUTE 29",
    "dropmalcty": "CANTRALL",
    "dropmalst": "IL",
    "dropmalzpp": 626259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174877245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12284",
    "droptype": "D",
    "dropname": "CAPRON",
    "dropdeladd": "120 W MAIN ST",
    "dropdelcty": "CAPRON",
    "dropdelst": "IL",
    "dropdelzpp": 610129783,
    "dropphyadd": "120 W MAIN ST",
    "dropphycty": "CAPRON",
    "dropphyst": "IL",
    "dropphyzpp": 610129783,
    "dropmaladd": "120 W MAIN ST",
    "dropmalcty": "CAPRON",
    "dropmalst": "IL",
    "dropmalzpp": 610129783,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155692100,
    "dropsitcph": 8155692100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12285",
    "droptype": "D",
    "dropname": "CARBON CLIFF",
    "dropdeladd": "118 3RD ST",
    "dropdelcty": "CARBON CLIFF",
    "dropdelst": "IL",
    "dropdelzpp": 612397711,
    "dropphyadd": "118 3RD ST",
    "dropphycty": "CARBON CLIFF",
    "dropphyst": "IL",
    "dropphyzpp": 612397711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARBON CLIFF",
    "dropmalst": "IL",
    "dropmalzpp": 612399998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097923163,
    "dropsitcph": 3097923163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12288",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "1301 E MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "IL",
    "dropdelzpp": 629019998,
    "dropphyadd": "1301 E MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "IL",
    "dropphyzpp": 629019998,
    "dropmaladd": "1301 E MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "IL",
    "dropmalzpp": 629019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183515651,
    "dropsitcph": 6183515651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12290",
    "droptype": "D",
    "dropname": "CARLINVILLE",
    "dropdeladd": "129 E 1ST SOUTH ST",
    "dropdelcty": "CARLINVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626269998,
    "dropphyadd": "129 E 1ST SOUTH ST",
    "dropphycty": "CARLINVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626269998,
    "dropmaladd": "129 E 1ST SOUTH ST",
    "dropmalcty": "CARLINVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626269998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178547071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12291",
    "droptype": "D",
    "dropname": "CARLOCK",
    "dropdeladd": "210 E WASHINGTON ST",
    "dropdelcty": "CARLOCK",
    "dropdelst": "IL",
    "dropdelzpp": 617259901,
    "dropphyadd": "210 E WASHINGTON ST",
    "dropphycty": "CARLOCK",
    "dropphyst": "IL",
    "dropphyzpp": 617259901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLOCK",
    "dropmalst": "IL",
    "dropmalzpp": 617259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093764211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12292",
    "droptype": "D",
    "dropname": "CARLYLE",
    "dropdeladd": "1080 FAIRFAX ST",
    "dropdelcty": "CARLYLE",
    "dropdelst": "IL",
    "dropdelzpp": 622319998,
    "dropphyadd": "1080 FAIRFAX ST",
    "dropphycty": "CARLYLE",
    "dropphyst": "IL",
    "dropphyzpp": 622319998,
    "dropmaladd": "1080 FAIRFAX ST",
    "dropmalcty": "CARLYLE",
    "dropmalst": "IL",
    "dropmalzpp": 622319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185943322,
    "dropsitcph": 6185943322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12293",
    "droptype": "D",
    "dropname": "CARMAN",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "CARMAN",
    "dropdelst": "IL",
    "dropdelzpp": 614259800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "CARMAN",
    "dropphyst": "IL",
    "dropphyzpp": 614259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARMAN",
    "dropmalst": "IL",
    "dropmalzpp": 614259998,
    "dropsitphn": 3098732426,
    "dropsitlph": 3098732426,
    "dropsitcph": 3098732426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12294",
    "droptype": "D",
    "dropname": "CARMI",
    "dropdeladd": "201 S WALNUT ST",
    "dropdelcty": "CARMI",
    "dropdelst": "IL",
    "dropdelzpp": 628219997,
    "dropphyadd": "201 S WALNUT ST",
    "dropphycty": "CARMI",
    "dropphyst": "IL",
    "dropphyzpp": 628219997,
    "dropmaladd": "201 S WALNUT ST",
    "dropmalcty": "CARMI",
    "dropmalst": "IL",
    "dropmalzpp": 628219997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183825215,
    "dropsitcph": 6183825215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12296",
    "droptype": "D",
    "dropname": "CAROL STREAM",
    "dropdeladd": "550 FULLERTON AVE",
    "dropdelcty": "CAROL STREAM",
    "dropdelst": "IL",
    "dropdelzpp": 601885204,
    "dropphyadd": "550 FULLERTON AVE",
    "dropphycty": "CAROL STREAM",
    "dropphyst": "IL",
    "dropphyzpp": 601885204,
    "dropmaladd": "550 FULLERTON AVE",
    "dropmalcty": "CAROL STREAM",
    "dropmalst": "IL",
    "dropmalzpp": 601885204,
    "dropsitphn": 6302605609,
    "dropsitlph": 6302605610,
    "dropsitcph": 6302605610,
    "dropfax": 6302605170
  },
  {
    "dcode": "D",
    "dropkey": "PW12298",
    "droptype": "D",
    "dropname": "CARPENTERSVILLE",
    "dropdeladd": "100 S KENNEDY DR",
    "dropdelcty": "CARPENTERSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 601109998,
    "dropphyadd": "100 S KENNEDY DR",
    "dropphycty": "CARPENTERSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 601109998,
    "dropmaladd": "100 S KENNEDY DR",
    "dropmalcty": "CARPENTERSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 601109998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474266724,
    "dropsitcph": 8474266724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12301",
    "droptype": "D",
    "dropname": "CARRIER MILLS",
    "dropdeladd": "107 W OAK ST",
    "dropdelcty": "CARRIER MILLS",
    "dropdelst": "IL",
    "dropdelzpp": 629179998,
    "dropphyadd": "107 W OAK ST",
    "dropphycty": "CARRIER MILLS",
    "dropphyst": "IL",
    "dropphyzpp": 629179998,
    "dropmaladd": "107 W OAK ST",
    "dropmalcty": "CARRIER MILLS",
    "dropmalst": "IL",
    "dropmalzpp": 629179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189942014,
    "dropsitcph": 6189942014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12305",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "409 N MAIN ST",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "IL",
    "dropdelzpp": 620169998,
    "dropphyadd": "409 N MAIN ST",
    "dropphycty": "CARROLLTON",
    "dropphyst": "IL",
    "dropphyzpp": 620169998,
    "dropmaladd": "409 N MAIN ST",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "IL",
    "dropmalzpp": 620169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179423521,
    "dropsitcph": 2179423521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12307",
    "droptype": "D",
    "dropname": "CARTERVILLE",
    "dropdeladd": "101 E GRAND AVE",
    "dropdelcty": "CARTERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 629189998,
    "dropphyadd": "101 E GRAND AVE",
    "dropphycty": "CARTERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 629189998,
    "dropmaladd": "101 E GRAND AVE",
    "dropmalcty": "CARTERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 629189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189852380,
    "dropsitcph": 6189852380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12310",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "615 MAIN ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "IL",
    "dropdelzpp": 623219998,
    "dropphyadd": "615 MAIN ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "IL",
    "dropphyzpp": 623219998,
    "dropmaladd": "615 MAIN ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "IL",
    "dropmalzpp": 623219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173572725,
    "dropsitcph": 2173572725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12313",
    "droptype": "D",
    "dropname": "CARY",
    "dropdeladd": "2707 3 OAKS RD",
    "dropdelcty": "CARY",
    "dropdelst": "IL",
    "dropdelzpp": 600139998,
    "dropphyadd": "2707 3 OAKS RD",
    "dropphycty": "CARY",
    "dropphyst": "IL",
    "dropphyzpp": 600139998,
    "dropmaladd": "2707 3 OAKS RD",
    "dropmalcty": "CARY",
    "dropmalst": "IL",
    "dropmalzpp": 600139998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476393151,
    "dropsitcph": 8476393151,
    "dropfax": 8476393184
  },
  {
    "dcode": "D",
    "dropkey": "PW12314",
    "droptype": "D",
    "dropname": "CASEY",
    "dropdeladd": "100 W ALABAMA AVE",
    "dropdelcty": "CASEY",
    "dropdelst": "IL",
    "dropdelzpp": 624209998,
    "dropphyadd": "100 W ALABAMA AVE",
    "dropphycty": "CASEY",
    "dropphyst": "IL",
    "dropphyzpp": 624209998,
    "dropmaladd": "100 W ALABAMA AVE",
    "dropmalcty": "CASEY",
    "dropmalst": "IL",
    "dropmalzpp": 624209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179322163,
    "dropsitcph": 2179322163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12315",
    "droptype": "D",
    "dropname": "CASEYVILLE",
    "dropdeladd": "113 S LONG ST",
    "dropdelcty": "CASEYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622329998,
    "dropphyadd": "113 S LONG ST",
    "dropphycty": "CASEYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622329998,
    "dropmaladd": "113 S LONG ST",
    "dropmalcty": "CASEYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183444594,
    "dropsitcph": 6183444594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12322",
    "droptype": "D",
    "dropname": "CASTLETON",
    "dropdeladd": "219 MAIN ST",
    "dropdelcty": "CASTLETON",
    "dropdelst": "IL",
    "dropdelzpp": 614269998,
    "dropphyadd": "219 MAIN ST",
    "dropphycty": "CASTLETON",
    "dropphyst": "IL",
    "dropphyzpp": 614269998,
    "dropmaladd": "219 MAIN ST",
    "dropmalcty": "CASTLETON",
    "dropmalst": "IL",
    "dropmalzpp": 614269998,
    "dropsitphn": 3094793891,
    "dropsitlph": 3094793891,
    "dropsitcph": 3094793891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12324",
    "droptype": "D",
    "dropname": "CATLIN",
    "dropdeladd": "201 S SANDUSKY ST",
    "dropdelcty": "CATLIN",
    "dropdelst": "IL",
    "dropdelzpp": 618179998,
    "dropphyadd": "201 S SANDUSKY ST",
    "dropphycty": "CATLIN",
    "dropphyst": "IL",
    "dropphyzpp": 618179998,
    "dropmaladd": "201 S SANDUSKY ST",
    "dropmalcty": "CATLIN",
    "dropmalst": "IL",
    "dropmalzpp": 618179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174275925,
    "dropfax": 2174275927
  },
  {
    "dcode": "D",
    "dropkey": "PW12327",
    "droptype": "D",
    "dropname": "CAVE IN ROCK",
    "dropdeladd": "153 E MAIN ST",
    "dropdelcty": "CAVE IN ROCK",
    "dropdelst": "IL",
    "dropdelzpp": 629199998,
    "dropphyadd": "153 E MAIN ST",
    "dropphycty": "CAVE IN ROCK",
    "dropphyst": "IL",
    "dropphyzpp": 629199998,
    "dropmaladd": "153 E MAIN ST",
    "dropmalcty": "CAVE IN ROCK",
    "dropmalst": "IL",
    "dropmalzpp": 629199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182894655,
    "dropsitcph": 6182894655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12332",
    "droptype": "D",
    "dropname": "CEDAR POINT",
    "dropdeladd": "302 CEDAR ST",
    "dropdelcty": "CEDAR POINT",
    "dropdelst": "IL",
    "dropdelzpp": 613169700,
    "dropphyadd": "302 CEDAR ST",
    "dropphycty": "CEDAR POINT",
    "dropphyst": "IL",
    "dropphyzpp": 613169700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR POINT",
    "dropmalst": "IL",
    "dropmalzpp": 613169998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718849,
    "dropsitcph": 8154464272,
    "dropfax": 8154464272
  },
  {
    "dcode": "D",
    "dropkey": "PW12333",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "125 W WASHINGTON ST",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 610139800,
    "dropphyadd": "125 W WASHINGTON ST",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 610139800,
    "dropmaladd": "125 W WASHINGTON ST",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 610139800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155634364,
    "dropsitcph": 8155634364,
    "dropfax": 8155639038
  },
  {
    "dcode": "D",
    "dropkey": "PW12346",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "314 S POPLAR ST",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "IL",
    "dropdelzpp": 628019998,
    "dropphyadd": "314 S POPLAR ST",
    "dropphycty": "CENTRALIA",
    "dropphyst": "IL",
    "dropphyzpp": 628019998,
    "dropmaladd": "314 S POPLAR ST",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "IL",
    "dropmalzpp": 628019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185326717,
    "dropsitcph": 6185326717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12349",
    "droptype": "D",
    "dropname": "CERRO GORDO",
    "dropdeladd": "313 E SOUTH ST",
    "dropdelcty": "CERRO GORDO",
    "dropdelst": "IL",
    "dropdelzpp": 618189998,
    "dropphyadd": "313 E SOUTH ST",
    "dropphycty": "CERRO GORDO",
    "dropphyst": "IL",
    "dropphyzpp": 618189998,
    "dropmaladd": "313 E SOUTH ST",
    "dropmalcty": "CERRO GORDO",
    "dropmalst": "IL",
    "dropmalzpp": 618189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177635411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12352",
    "droptype": "D",
    "dropname": "CHADWICK",
    "dropdeladd": "218 N MAIN ST",
    "dropdelcty": "CHADWICK",
    "dropdelst": "IL",
    "dropdelzpp": 610149380,
    "dropphyadd": "218 N MAIN ST",
    "dropphycty": "CHADWICK",
    "dropphyst": "IL",
    "dropphyzpp": 610149380,
    "dropmaladd": "218 N MAIN ST",
    "dropmalcty": "CHADWICK",
    "dropmalst": "IL",
    "dropmalzpp": 610149380,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156845170,
    "dropsitcph": 8156845170,
    "dropfax": 8156845065
  },
  {
    "dcode": "D",
    "dropkey": "PW12357",
    "droptype": "D",
    "dropname": "CHAMPAIGN",
    "dropdeladd": "2001 N MATTIS AVE",
    "dropdelcty": "CHAMPAIGN",
    "dropdelst": "IL",
    "dropdelzpp": 618219998,
    "dropphyadd": "2001 N MATTIS AVE",
    "dropphycty": "CHAMPAIGN",
    "dropphyst": "IL",
    "dropphyzpp": 618219998,
    "dropmaladd": "2001 N MATTIS AVE",
    "dropmalcty": "CHAMPAIGN",
    "dropmalst": "IL",
    "dropmalzpp": 618219998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173522167,
    "dropfax": 2173736004
  },
  {
    "dcode": "D",
    "dropkey": "PW12359",
    "droptype": "D",
    "dropname": "CHANA",
    "dropdeladd": "300 MAIN ST UNIT A",
    "dropdelcty": "CHANA",
    "dropdelst": "IL",
    "dropdelzpp": 610159796,
    "dropphyadd": "300 MAIN ST UNIT A",
    "dropphycty": "CHANA",
    "dropphyst": "IL",
    "dropphyzpp": 610159796,
    "dropmaladd": "300 MAIN ST UNIT A",
    "dropmalcty": "CHANA",
    "dropmalst": "IL",
    "dropmalzpp": 610159796,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157327447,
    "dropsitcph": 8157327447,
    "dropfax": 8157324530
  },
  {
    "dcode": "D",
    "dropkey": "PW12360",
    "droptype": "D",
    "dropname": "CHANDLERVILLE",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "CHANDLERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626279998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "CHANDLERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626279998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "CHANDLERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626279998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174582211,
    "dropfax": 2174582298
  },
  {
    "dcode": "D",
    "dropkey": "PW12361",
    "droptype": "D",
    "dropname": "CHANNAHON",
    "dropdeladd": "25150 W CHANNON DR",
    "dropdelcty": "CHANNAHON",
    "dropdelst": "IL",
    "dropdelzpp": 604109998,
    "dropphyadd": "25150 W CHANNON DR",
    "dropphycty": "CHANNAHON",
    "dropphyst": "IL",
    "dropphyzpp": 604109998,
    "dropmaladd": "25150 W CHANNON DR",
    "dropmalcty": "CHANNAHON",
    "dropmalst": "IL",
    "dropmalzpp": 604109998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154675488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12366",
    "droptype": "D",
    "dropname": "CHAPIN",
    "dropdeladd": "520 SUPERIOR ST",
    "dropdelcty": "CHAPIN",
    "dropdelst": "IL",
    "dropdelzpp": 626289998,
    "dropphyadd": "520 SUPERIOR ST",
    "dropphycty": "CHAPIN",
    "dropphyst": "IL",
    "dropphyzpp": 626289998,
    "dropmaladd": "520 SUPERIOR ST",
    "dropmalcty": "CHAPIN",
    "dropmalst": "IL",
    "dropmalzpp": 626289998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174727211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12368",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "667 WINDSOR RD",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "IL",
    "dropdelzpp": 619209998,
    "dropphyadd": "667 WINDSOR RD",
    "dropphycty": "CHARLESTON",
    "dropphyst": "IL",
    "dropphyzpp": 619209998,
    "dropmaladd": "667 WINDSOR RD",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "IL",
    "dropmalzpp": 619209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173452900,
    "dropfax": 2173483021
  },
  {
    "dcode": "D",
    "dropkey": "PW12370",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "111 E WALNUT ST",
    "dropdelcty": "CHATHAM",
    "dropdelst": "IL",
    "dropdelzpp": 626299998,
    "dropphyadd": "111 E WALNUT ST",
    "dropphycty": "CHATHAM",
    "dropphyst": "IL",
    "dropphyzpp": 626299998,
    "dropmaladd": "111 E WALNUT ST",
    "dropmalcty": "CHATHAM",
    "dropmalst": "IL",
    "dropmalzpp": 626299998,
    "dropsitphn": "",
    "dropsitlph": 2177887251,
    "dropsitcph": 2174833312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12371",
    "droptype": "D",
    "dropname": "CHATSWORTH",
    "dropdeladd": "15 N 4TH ST",
    "dropdelcty": "CHATSWORTH",
    "dropdelst": "IL",
    "dropdelzpp": 609219800,
    "dropphyadd": "15 N 4TH ST",
    "dropphycty": "CHATSWORTH",
    "dropphyst": "IL",
    "dropphyzpp": 609219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHATSWORTH",
    "dropmalst": "IL",
    "dropmalzpp": 609219998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156353148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12374",
    "droptype": "D",
    "dropname": "CHEBANSE",
    "dropdeladd": "209 S CHESTNUT ST",
    "dropdelcty": "CHEBANSE",
    "dropdelst": "IL",
    "dropdelzpp": 609229998,
    "dropphyadd": "209 S CHESTNUT ST",
    "dropphycty": "CHEBANSE",
    "dropphyst": "IL",
    "dropphyzpp": 609229998,
    "dropmaladd": "209 S CHESTNUT ST",
    "dropmalcty": "CHEBANSE",
    "dropmalst": "IL",
    "dropmalzpp": 609229998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8156972221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12377",
    "droptype": "D",
    "dropname": "CHENOA",
    "dropdeladd": "213 E OWSLEY ST",
    "dropdelcty": "CHENOA",
    "dropdelst": "IL",
    "dropdelzpp": 617269998,
    "dropphyadd": "213 E OWSLEY ST",
    "dropphycty": "CHENOA",
    "dropphyst": "IL",
    "dropphyzpp": 617269998,
    "dropmaladd": "213 E OWSLEY ST",
    "dropmalcty": "CHENOA",
    "dropmalst": "IL",
    "dropmalzpp": 617269998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8159452131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12378",
    "droptype": "D",
    "dropname": "CHERRY",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "CHERRY",
    "dropdelst": "IL",
    "dropdelzpp": 613179998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "CHERRY",
    "dropphyst": "IL",
    "dropphyzpp": 613179998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "CHERRY",
    "dropmalst": "IL",
    "dropmalzpp": 613179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158943284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12379",
    "droptype": "D",
    "dropname": "CHERRY VALLEY",
    "dropdeladd": "210 E STATE ST",
    "dropdelcty": "CHERRY VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 610169293,
    "dropphyadd": "210 E STATE ST",
    "dropphycty": "CHERRY VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 610169293,
    "dropmaladd": "210 E STATE ST",
    "dropmalcty": "CHERRY VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 610169293,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153324333,
    "dropsitcph": 8153324333,
    "dropfax": 8153324881
  },
  {
    "dcode": "D",
    "dropkey": "PW12382",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "1321 SWANWICK ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 622339998,
    "dropphyadd": "1321 SWANWICK ST",
    "dropphycty": "CHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 622339998,
    "dropmaladd": "1321 SWANWICK ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 622339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188262233,
    "dropsitcph": 6188262233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12383",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "20 S MAIN ST",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 626309998,
    "dropphyadd": "20 S MAIN ST",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 626309998,
    "dropmaladd": "20 S MAIN ST",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 626309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 6187533119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12386",
    "droptype": "D",
    "dropname": "CHESTNUT",
    "dropdeladd": "120 E OLIVE ST",
    "dropdelcty": "CHESTNUT",
    "dropdelst": "IL",
    "dropdelzpp": 625189998,
    "dropphyadd": "120 E OLIVE ST",
    "dropphycty": "CHESTNUT",
    "dropphyst": "IL",
    "dropphyzpp": 625189998,
    "dropmaladd": "120 E OLIVE ST",
    "dropmalcty": "CHESTNUT",
    "dropmalst": "IL",
    "dropmalzpp": 625189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177963302,
    "dropfax": 2177963302
  },
  {
    "dcode": "D",
    "dropkey": "PW12401",
    "droptype": "D",
    "dropname": "CHICAGO",
    "dropdeladd": "433 W HARRISON ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606993916,
    "dropphyadd": "433 W HARRISON ST STE 2036",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999998,
    "dropmaladd": "433 W HARRISON ST STE 2036",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999998,
    "dropsitphn": "",
    "dropsitlph": 3127653225,
    "dropsitcph": 3129837550,
    "dropfax": 3129838135
  },
  {
    "dcode": "D",
    "dropkey": "PW12404",
    "droptype": "D",
    "dropname": "CHICAGO HEIGHTS",
    "dropdeladd": "1333 W END AVE",
    "dropdelcty": "CHICAGO HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 604119998,
    "dropphyadd": "1333 W END AVE",
    "dropphycty": "CHICAGO HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 604119998,
    "dropmaladd": "1333 W END AVE",
    "dropmalcty": "CHICAGO HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 604119998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087542277,
    "dropfax": 7087542762
  },
  {
    "dcode": "D",
    "dropkey": "PW12410",
    "droptype": "D",
    "dropname": "CHICAGO RIDGE",
    "dropdeladd": "10525 RIDGELAND AVE",
    "dropdelcty": "CHICAGO RIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 604159623,
    "dropphyadd": "10525 RIDGELAND AVE",
    "dropphycty": "CHICAGO RIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 604159623,
    "dropmaladd": "10525 RIDGELAND AVE",
    "dropmalcty": "CHICAGO RIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 604159623,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084233346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12413",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "1114 N 2ND ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "IL",
    "dropdelzpp": 615239998,
    "dropphyadd": "1114 N 2ND ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "IL",
    "dropphyzpp": 615239998,
    "dropmaladd": "1114 N 2ND ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "IL",
    "dropmalzpp": 615239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092742276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12417",
    "droptype": "D",
    "dropname": "CHRISMAN",
    "dropdeladd": "210 W MADISON AVE",
    "dropdelcty": "CHRISMAN",
    "dropdelst": "IL",
    "dropdelzpp": 619249998,
    "dropphyadd": "210 W MADISON AVE",
    "dropphycty": "CHRISMAN",
    "dropphyst": "IL",
    "dropphyzpp": 619249998,
    "dropmaladd": "210 W MADISON AVE",
    "dropmalcty": "CHRISMAN",
    "dropmalst": "IL",
    "dropmalzpp": 619249998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172692031,
    "dropfax": 2172692031
  },
  {
    "dcode": "D",
    "dropkey": "PW12418",
    "droptype": "D",
    "dropname": "CHRISTOPHER",
    "dropdeladd": "110 N EMMA ST",
    "dropdelcty": "CHRISTOPHER",
    "dropdelst": "IL",
    "dropdelzpp": 628229998,
    "dropphyadd": "110 N EMMA ST",
    "dropphycty": "CHRISTOPHER",
    "dropphyst": "IL",
    "dropphyzpp": 628229998,
    "dropmaladd": "110 N EMMA ST",
    "dropmalcty": "CHRISTOPHER",
    "dropmalst": "IL",
    "dropmalzpp": 628229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187242551,
    "dropsitcph": 6187242551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12421",
    "droptype": "D",
    "dropname": "CISCO",
    "dropdeladd": "150 S MAIN ST",
    "dropdelcty": "CISCO",
    "dropdelst": "IL",
    "dropdelzpp": 618309998,
    "dropphyadd": "150 S MAIN ST",
    "dropphycty": "CISCO",
    "dropphyst": "IL",
    "dropphyzpp": 618309998,
    "dropmaladd": "150 S MAIN ST",
    "dropmalcty": "CISCO",
    "dropmalst": "IL",
    "dropmalzpp": 618309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176692313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12422",
    "droptype": "D",
    "dropname": "CISNE",
    "dropdeladd": "300 SIMPSON ST",
    "dropdelcty": "CISNE",
    "dropdelst": "IL",
    "dropdelzpp": 628239998,
    "dropphyadd": "300 SIMPSON ST",
    "dropphycty": "CISNE",
    "dropphyst": "IL",
    "dropphyzpp": 628239998,
    "dropmaladd": "300 SIMPSON ST",
    "dropmalcty": "CISNE",
    "dropmalst": "IL",
    "dropmalzpp": 628239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186732702,
    "dropsitcph": 6186732702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12423",
    "droptype": "D",
    "dropname": "CISSNA PARK",
    "dropdeladd": "129 W GARFIELD AVE",
    "dropdelcty": "CISSNA PARK",
    "dropdelst": "IL",
    "dropdelzpp": 609249800,
    "dropphyadd": "129 W GARFIELD AVE",
    "dropphycty": "CISSNA PARK",
    "dropphyst": "IL",
    "dropphyzpp": 609249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CISSNA PARK",
    "dropmalst": "IL",
    "dropmalzpp": 609249998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154572250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12426",
    "droptype": "D",
    "dropname": "CLARE",
    "dropdeladd": "26450 CLARE RD",
    "dropdelcty": "CLARE",
    "dropdelst": "IL",
    "dropdelzpp": 601119151,
    "dropphyadd": "26450 CLARE RD",
    "dropphycty": "CLARE",
    "dropphyst": "IL",
    "dropphyzpp": 601119151,
    "dropmaladd": "26450 CLARE RD",
    "dropmalcty": "CLARE",
    "dropmalst": "IL",
    "dropmalzpp": 601119151,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158952034,
    "dropsitcph": 8158952034,
    "dropfax": 8158954763
  },
  {
    "dcode": "D",
    "dropkey": "PW12427",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "100 N WASHINGTON BLVD",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "IL",
    "dropdelzpp": 624219998,
    "dropphyadd": "100 N WASHINGTON BLVD",
    "dropphycty": "CLAREMONT",
    "dropphyst": "IL",
    "dropphyzpp": 624219998,
    "dropmaladd": "100 N WASHINGTON BLVD",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "IL",
    "dropmalzpp": 624219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188692647,
    "dropsitcph": 6188692647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12430",
    "droptype": "D",
    "dropname": "CLARENDON HILLS",
    "dropdeladd": "312 PARK AVE",
    "dropdelcty": "CLARENDON HILLS",
    "dropdelst": "IL",
    "dropdelzpp": 605149998,
    "dropphyadd": "312 PARK AVE",
    "dropphycty": "CLARENDON HILLS",
    "dropphyst": "IL",
    "dropphyzpp": 605149998,
    "dropmaladd": "312 PARK AVE",
    "dropmalcty": "CLARENDON HILLS",
    "dropmalst": "IL",
    "dropmalzpp": 605149998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6303230309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12437",
    "droptype": "D",
    "dropname": "CLAY CITY",
    "dropdeladd": "332 S MAIN ST",
    "dropdelcty": "CLAY CITY",
    "dropdelst": "IL",
    "dropdelzpp": 628249998,
    "dropphyadd": "332 S MAIN ST",
    "dropphycty": "CLAY CITY",
    "dropphyst": "IL",
    "dropphyzpp": 628249998,
    "dropmaladd": "332 S MAIN ST",
    "dropmalcty": "CLAY CITY",
    "dropmalst": "IL",
    "dropmalzpp": 628249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186761242,
    "dropsitcph": 6186761242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12441",
    "droptype": "D",
    "dropname": "CLAYTONVILLE",
    "dropdeladd": "107 N MANNING ST",
    "dropdelcty": "CLAYTONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 609269998,
    "dropphyadd": "107 N MANNING ST",
    "dropphycty": "CLAYTONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 609269998,
    "dropmaladd": "107 N MANNING ST",
    "dropmalcty": "CLAYTONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 609269998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154572932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12451",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "175 E 6TH AVE",
    "dropdelcty": "CLIFTON",
    "dropdelst": "IL",
    "dropdelzpp": 609279800,
    "dropphyadd": "175 E 6TH AVE",
    "dropphycty": "CLIFTON",
    "dropphyst": "IL",
    "dropphyzpp": 609279800,
    "dropmaladd": "175 E 6TH AVE",
    "dropmalcty": "CLIFTON",
    "dropmalst": "IL",
    "dropmalzpp": 609279800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156942551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12452",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "105 N QUINCY ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "IL",
    "dropdelzpp": 617279998,
    "dropphyadd": "105 N QUINCY ST",
    "dropphycty": "CLINTON",
    "dropphyst": "IL",
    "dropphyzpp": 617279998,
    "dropmaladd": "105 N QUINCY ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "IL",
    "dropmalzpp": 617279998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179355584,
    "dropfax": 2179359205
  },
  {
    "dcode": "D",
    "dropkey": "PW12460",
    "droptype": "D",
    "dropname": "COAL CITY",
    "dropdeladd": "495 S BROADWAY ST",
    "dropdelcty": "COAL CITY",
    "dropdelst": "IL",
    "dropdelzpp": 604169998,
    "dropphyadd": "495 S BROADWAY ST",
    "dropphycty": "COAL CITY",
    "dropphyst": "IL",
    "dropphyzpp": 604169998,
    "dropmaladd": "495 S BROADWAY ST",
    "dropmalcty": "COAL CITY",
    "dropmalst": "IL",
    "dropmalzpp": 604169998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8156344501,
    "dropfax": 8156343281
  },
  {
    "dcode": "D",
    "dropkey": "PW12464",
    "droptype": "D",
    "dropname": "COAL VALLEY",
    "dropdeladd": "121 E 22ND AVE",
    "dropdelcty": "COAL VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 612409900,
    "dropphyadd": "121 E 22ND AVE",
    "dropphycty": "COAL VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 612409900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COAL VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 612409998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097995357,
    "dropsitcph": 3097995357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12467",
    "droptype": "D",
    "dropname": "COBDEN",
    "dropdeladd": "113 S APPLEKNOCKER ST",
    "dropdelcty": "COBDEN",
    "dropdelst": "IL",
    "dropdelzpp": 629209998,
    "dropphyadd": "113 S APPLEKNOCKER ST",
    "dropphycty": "COBDEN",
    "dropphyst": "IL",
    "dropphyzpp": 629209998,
    "dropmaladd": "113 S APPLEKNOCKER ST",
    "dropmalcty": "COBDEN",
    "dropmalst": "IL",
    "dropmalzpp": 629209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188932742,
    "dropsitcph": 6188932742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12469",
    "droptype": "D",
    "dropname": "COELLO",
    "dropdeladd": "9091 MAIN ST",
    "dropdelcty": "COELLO",
    "dropdelst": "IL",
    "dropdelzpp": 628259998,
    "dropphyadd": "9091 MAIN ST",
    "dropphycty": "COELLO",
    "dropphyst": "IL",
    "dropphyzpp": 628259998,
    "dropmaladd": "9091 MAIN ST",
    "dropmalcty": "COELLO",
    "dropmalst": "IL",
    "dropmalzpp": 628259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187244952,
    "dropsitcph": 6187244952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12471",
    "droptype": "D",
    "dropname": "COFFEEN",
    "dropdeladd": "203 W MAIN ST",
    "dropdelcty": "COFFEEN",
    "dropdelst": "IL",
    "dropdelzpp": 620179998,
    "dropphyadd": "203 W MAIN ST",
    "dropphycty": "COFFEEN",
    "dropphyst": "IL",
    "dropphyzpp": 620179998,
    "dropmaladd": "203 W MAIN ST",
    "dropmalcty": "COFFEEN",
    "dropmalst": "IL",
    "dropmalzpp": 620179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175342524,
    "dropsitcph": 2175342524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12472",
    "droptype": "D",
    "dropname": "COLCHESTER",
    "dropdeladd": "105 W MARKET ST",
    "dropdelcty": "COLCHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 623269998,
    "dropphyadd": "105 W MARKET ST",
    "dropphycty": "COLCHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 623269998,
    "dropmaladd": "105 W MARKET ST",
    "dropmalcty": "COLCHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 623269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3097763255,
    "dropsitcph": 3097763255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12474",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "109 W MAIN ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "IL",
    "dropdelzpp": 617289902,
    "dropphyadd": "109 W MAIN ST",
    "dropphycty": "COLFAX",
    "dropphyst": "IL",
    "dropphyzpp": 617289902,
    "dropmaladd": "109 W MAIN ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "IL",
    "dropmalzpp": 617289902,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097235741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12478",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "1610 EASTPORT PLAZA DR",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622349998,
    "dropphyadd": "1610 EASTPORT PLAZA DR",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622349998,
    "dropmaladd": "1610 EASTPORT PLAZA DR",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183443787,
    "dropsitcph": 6183443787,
    "dropfax": 6183454507
  },
  {
    "dcode": "D",
    "dropkey": "PW12481",
    "droptype": "D",
    "dropname": "COLLISON",
    "dropdeladd": "7205 WALNUT ST",
    "dropdelcty": "COLLISON",
    "dropdelst": "IL",
    "dropdelzpp": 618319998,
    "dropphyadd": "7205 WALNUT ST",
    "dropphycty": "COLLISON",
    "dropphyst": "IL",
    "dropphyzpp": 618319998,
    "dropmaladd": "7205 WALNUT ST",
    "dropmalcty": "COLLISON",
    "dropmalst": "IL",
    "dropmalzpp": 618319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177762231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12483",
    "droptype": "D",
    "dropname": "COLONA",
    "dropdeladd": "900 1ST ST",
    "dropdelcty": "COLONA",
    "dropdelst": "IL",
    "dropdelzpp": 612419030,
    "dropphyadd": "900 1ST ST",
    "dropphycty": "COLONA",
    "dropphyst": "IL",
    "dropphyzpp": 612419030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLONA",
    "dropmalst": "IL",
    "dropmalzpp": 612419998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097922895,
    "dropsitcph": 3097922895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12484",
    "droptype": "D",
    "dropname": "COLP",
    "dropdeladd": "105 N MAYOR CALIPER DR",
    "dropdelcty": "COLP",
    "dropdelst": "IL",
    "dropdelzpp": 629219998,
    "dropphyadd": "105 N MAYOR CALIPER DR",
    "dropphycty": "COLP",
    "dropphyst": "IL",
    "dropphyzpp": 629219998,
    "dropmaladd": "105 N MAYOR CALIPER DR",
    "dropmalcty": "COLP",
    "dropmalst": "IL",
    "dropmalzpp": 629219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189856761,
    "dropsitcph": 6189856761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12485",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "800 COLUMBIA CTR",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "IL",
    "dropdelzpp": 622369998,
    "dropphyadd": "800 COLUMBIA CTR",
    "dropphycty": "COLUMBIA",
    "dropphyst": "IL",
    "dropphyzpp": 622369998,
    "dropmaladd": "800 COLUMBIA CTR",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "IL",
    "dropmalzpp": 622369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182815300,
    "dropsitcph": 6182815300,
    "dropfax": 6182819300
  },
  {
    "dcode": "D",
    "dropkey": "PW12492",
    "droptype": "D",
    "dropname": "COMPTON",
    "dropdeladd": "240 W MAIN ST",
    "dropdelcty": "COMPTON",
    "dropdelst": "IL",
    "dropdelzpp": 613189897,
    "dropphyadd": "240 W MAIN ST",
    "dropphycty": "COMPTON",
    "dropphyst": "IL",
    "dropphyzpp": 613189897,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMPTON",
    "dropmalst": "IL",
    "dropmalzpp": 613189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154972311,
    "dropfax": 8154972311
  },
  {
    "dcode": "D",
    "dropkey": "PW12494",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "403 STATE ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "IL",
    "dropdelzpp": 626319998,
    "dropphyadd": "403 STATE ST",
    "dropphycty": "CONCORD",
    "dropphyst": "IL",
    "dropphyzpp": 626319998,
    "dropmaladd": "403 STATE ST",
    "dropmalcty": "CONCORD",
    "dropmalst": "IL",
    "dropmalzpp": 626319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174572289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12497",
    "droptype": "D",
    "dropname": "CONGERVILLE",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "CONGERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 617299900,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "CONGERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 617299900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONGERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 617299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094482386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12500",
    "droptype": "D",
    "dropname": "COOKSVILLE",
    "dropdeladd": "105 N KOCH ST",
    "dropdelcty": "COOKSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 617307537,
    "dropphyadd": "105 N KOCH ST",
    "dropphycty": "COOKSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 617307537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOKSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 617309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097253226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12503",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "1001 MAIN AVE",
    "dropdelcty": "CORDOVA",
    "dropdelst": "IL",
    "dropdelzpp": 612429000,
    "dropphyadd": "1001 MAIN AVE",
    "dropphycty": "CORDOVA",
    "dropphyst": "IL",
    "dropphyzpp": 612429000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORDOVA",
    "dropmalst": "IL",
    "dropmalzpp": 612429998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3096542349,
    "dropsitcph": 3096542349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12505",
    "droptype": "D",
    "dropname": "CORNELL",
    "dropdeladd": "108 N 6TH ST",
    "dropdelcty": "CORNELL",
    "dropdelst": "IL",
    "dropdelzpp": 613199900,
    "dropphyadd": "108 N 6TH ST",
    "dropphycty": "CORNELL",
    "dropphyst": "IL",
    "dropphyzpp": 613199900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNELL",
    "dropmalst": "IL",
    "dropmalzpp": 613199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153582248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12507",
    "droptype": "D",
    "dropname": "CORNLAND",
    "dropdeladd": "1017 DAY ST",
    "dropdelcty": "CORNLAND",
    "dropdelst": "IL",
    "dropdelzpp": 625199998,
    "dropphyadd": "1017 DAY ST",
    "dropphycty": "CORNLAND",
    "dropphyst": "IL",
    "dropphyzpp": 625199998,
    "dropmaladd": "1017 DAY ST",
    "dropmalcty": "CORNLAND",
    "dropmalst": "IL",
    "dropmalzpp": 625199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173649887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12509",
    "droptype": "D",
    "dropname": "CORTLAND",
    "dropdeladd": "50 S SOMONAUK RD",
    "dropdelcty": "CORTLAND",
    "dropdelst": "IL",
    "dropdelzpp": 601124071,
    "dropphyadd": "50 S SOMONAUK RD",
    "dropphycty": "CORTLAND",
    "dropphyst": "IL",
    "dropphyzpp": 601124071,
    "dropmaladd": "50 S SOMONAUK RD",
    "dropmalcty": "CORTLAND",
    "dropmalst": "IL",
    "dropmalzpp": 601124071,
    "dropsitphn": 8158952888,
    "dropsitlph": 8157562002,
    "dropsitcph": 8157562002,
    "dropfax": 8157483057
  },
  {
    "dcode": "D",
    "dropkey": "PW12512",
    "droptype": "D",
    "dropname": "COTTAGE HILLS",
    "dropdeladd": "36 W MACARTHUR DR",
    "dropdelcty": "COTTAGE HILLS",
    "dropdelst": "IL",
    "dropdelzpp": 620189998,
    "dropphyadd": "36 W MACARTHUR DR",
    "dropphycty": "COTTAGE HILLS",
    "dropphyst": "IL",
    "dropphyzpp": 620189998,
    "dropmaladd": "36 W MACARTHUR DR",
    "dropmalcty": "COTTAGE HILLS",
    "dropmalst": "IL",
    "dropmalzpp": 620189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182592212,
    "dropsitcph": 6182592212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12517",
    "droptype": "D",
    "dropname": "COULTERVILLE",
    "dropdeladd": "107 N 4TH ST",
    "dropdelcty": "COULTERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622379998,
    "dropphyadd": "107 N 4TH ST",
    "dropphycty": "COULTERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622379998,
    "dropmaladd": "107 N 4TH ST",
    "dropmalcty": "COULTERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187582421,
    "dropsitcph": 6187582421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12527",
    "droptype": "D",
    "dropname": "COWDEN",
    "dropdeladd": "100 E ELM ST",
    "dropdelcty": "COWDEN",
    "dropdelst": "IL",
    "dropdelzpp": 624229998,
    "dropphyadd": "100 E ELM ST",
    "dropphycty": "COWDEN",
    "dropphyst": "IL",
    "dropphyzpp": 624229998,
    "dropmaladd": "100 E ELM ST",
    "dropmalcty": "COWDEN",
    "dropmalst": "IL",
    "dropmalzpp": 624229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177832422,
    "dropsitcph": 2177832422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12538",
    "droptype": "D",
    "dropname": "CREAL SPRINGS",
    "dropdeladd": "112 W BLUE AVE",
    "dropdelcty": "CREAL SPRINGS",
    "dropdelst": "IL",
    "dropdelzpp": 629229998,
    "dropphyadd": "112 W BLUE AVE",
    "dropphycty": "CREAL SPRINGS",
    "dropphyst": "IL",
    "dropphyzpp": 629229998,
    "dropmaladd": "112 W BLUE AVE",
    "dropmalcty": "CREAL SPRINGS",
    "dropmalst": "IL",
    "dropmalzpp": 629229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189962191,
    "dropsitcph": 6189962191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12540",
    "droptype": "D",
    "dropname": "CRESCENT CITY",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "CRESCENT CITY",
    "dropdelst": "IL",
    "dropdelzpp": 609289800,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "CRESCENT CITY",
    "dropphyst": "IL",
    "dropphyzpp": 609289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESCENT CITY",
    "dropmalst": "IL",
    "dropmalzpp": 609289998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156832136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12544",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "111 N MAIN ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "IL",
    "dropdelzpp": 601131001,
    "dropphyadd": "111 N MAIN ST",
    "dropphycty": "CRESTON",
    "dropphyst": "IL",
    "dropphyzpp": 601131001,
    "dropmaladd": "111 N MAIN ST",
    "dropmalcty": "CRESTON",
    "dropmalst": "IL",
    "dropmalzpp": 601131001,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153845340,
    "dropsitcph": 8153845340,
    "dropfax": 8153845340
  },
  {
    "dcode": "D",
    "dropkey": "PW12547",
    "droptype": "D",
    "dropname": "CRETE",
    "dropdeladd": "515 CASS ST",
    "dropdelcty": "CRETE",
    "dropdelst": "IL",
    "dropdelzpp": 604179998,
    "dropphyadd": "515 CASS ST",
    "dropphycty": "CRETE",
    "dropphyst": "IL",
    "dropphyzpp": 604179998,
    "dropmaladd": "515 CASS ST",
    "dropmalcty": "CRETE",
    "dropmalst": "IL",
    "dropmalzpp": 604179998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7086728571,
    "dropfax": 7086721134
  },
  {
    "dcode": "D",
    "dropkey": "PW12551",
    "droptype": "D",
    "dropname": "CROPSEY",
    "dropdeladd": "146 MAIN ST",
    "dropdelcty": "CROPSEY",
    "dropdelst": "IL",
    "dropdelzpp": 617317510,
    "dropphyadd": "146 MAIN ST",
    "dropphycty": "CROPSEY",
    "dropphyst": "IL",
    "dropphyzpp": 617317510,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROPSEY",
    "dropmalst": "IL",
    "dropmalzpp": 617319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093772981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12552",
    "droptype": "D",
    "dropname": "CROSSVILLE",
    "dropdeladd": "208 W MAIN ST",
    "dropdelcty": "CROSSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628279998,
    "dropphyadd": "208 W MAIN ST",
    "dropphycty": "CROSSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628279998,
    "dropmaladd": "208 W MAIN ST",
    "dropmalcty": "CROSSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628279998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189663940,
    "dropsitcph": 6189663940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12558",
    "droptype": "D",
    "dropname": "CRYSTAL LAKE",
    "dropdeladd": "301 E CONGRESS PKWY",
    "dropdelcty": "CRYSTAL LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600146286,
    "dropphyadd": "301 E CONGRESS PKWY",
    "dropphycty": "CRYSTAL LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600146286,
    "dropmaladd": "301 E CONGRESS PKWY",
    "dropmalcty": "CRYSTAL LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600146286,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154598084,
    "dropsitcph": 8154598084,
    "dropfax": 8154590152
  },
  {
    "dcode": "D",
    "dropkey": "PW12563",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "307 E JEFFERSON ST",
    "dropdelcty": "CUBA",
    "dropdelst": "IL",
    "dropdelzpp": 614279800,
    "dropphyadd": "307 E JEFFERSON ST",
    "dropphycty": "CUBA",
    "dropphyst": "IL",
    "dropphyzpp": 614279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUBA",
    "dropmalst": "IL",
    "dropmalzpp": 614279998,
    "dropsitphn": 3097858043,
    "dropsitlph": 3097858043,
    "dropsitcph": 3097858043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12564",
    "droptype": "D",
    "dropname": "CULLOM",
    "dropdeladd": "101 W HACK ST",
    "dropdelcty": "CULLOM",
    "dropdelst": "IL",
    "dropdelzpp": 609297133,
    "dropphyadd": "101 W HACK ST",
    "dropphycty": "CULLOM",
    "dropphyst": "IL",
    "dropphyzpp": 609297133,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CULLOM",
    "dropmalst": "IL",
    "dropmalzpp": 609299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156892152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12571",
    "droptype": "D",
    "dropname": "CUTLER",
    "dropdeladd": "409B S MAIN ST",
    "dropdelcty": "CUTLER",
    "dropdelst": "IL",
    "dropdelzpp": 622389998,
    "dropphyadd": "409B S MAIN ST",
    "dropphycty": "CUTLER",
    "dropphyst": "IL",
    "dropphyzpp": 622389998,
    "dropmaladd": "409B S MAIN ST",
    "dropmalcty": "CUTLER",
    "dropmalst": "IL",
    "dropmalzpp": 622389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184972873,
    "dropsitcph": 6184972873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12572",
    "droptype": "D",
    "dropname": "CYPRESS",
    "dropdeladd": "7824 MAIN ST",
    "dropdelcty": "CYPRESS",
    "dropdelst": "IL",
    "dropdelzpp": 629239998,
    "dropphyadd": "7824 MAIN ST",
    "dropphycty": "CYPRESS",
    "dropphyst": "IL",
    "dropphyzpp": 629239998,
    "dropmaladd": "7824 MAIN ST",
    "dropmalcty": "CYPRESS",
    "dropmalst": "IL",
    "dropmalzpp": 629239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186572326,
    "dropsitcph": 6186572326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12574",
    "droptype": "D",
    "dropname": "DAHINDA",
    "dropdeladd": "1453 KNOX HIGHWAY 15",
    "dropdelcty": "DAHINDA",
    "dropdelst": "IL",
    "dropdelzpp": 614289802,
    "dropphyadd": "1453 KNOX HIGHWAY 15",
    "dropphycty": "DAHINDA",
    "dropphyst": "IL",
    "dropphyzpp": 614289802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAHINDA",
    "dropmalst": "IL",
    "dropmalzpp": 614289998,
    "dropsitphn": 3092892612,
    "dropsitlph": 3096394481,
    "dropsitcph": 3096394481,
    "dropfax": 3096394481
  },
  {
    "dcode": "D",
    "dropkey": "PW12575",
    "droptype": "D",
    "dropname": "DAHLGREN",
    "dropdeladd": "203 S 1ST ST",
    "dropdelcty": "DAHLGREN",
    "dropdelst": "IL",
    "dropdelzpp": 628289998,
    "dropphyadd": "203 S 1ST ST",
    "dropphycty": "DAHLGREN",
    "dropphyst": "IL",
    "dropphyzpp": 628289998,
    "dropmaladd": "203 S 1ST ST",
    "dropmalcty": "DAHLGREN",
    "dropmalst": "IL",
    "dropmalzpp": 628289998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187362944,
    "dropsitcph": 6187362944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12576",
    "droptype": "D",
    "dropname": "DAKOTA",
    "dropdeladd": "139 W MAIN ST",
    "dropdelcty": "DAKOTA",
    "dropdelst": "IL",
    "dropdelzpp": 610189792,
    "dropphyadd": "139 W MAIN ST",
    "dropphycty": "DAKOTA",
    "dropphyst": "IL",
    "dropphyzpp": 610189792,
    "dropmaladd": "139 W MAIN ST",
    "dropmalcty": "DAKOTA",
    "dropmalst": "IL",
    "dropmalzpp": 610189792,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154492428,
    "dropsitcph": 8154492428,
    "dropfax": 8154499210
  },
  {
    "dcode": "D",
    "dropkey": "PW12578",
    "droptype": "D",
    "dropname": "DALLAS CITY",
    "dropdeladd": "45 E 3RD ST",
    "dropdelcty": "DALLAS CITY",
    "dropdelst": "IL",
    "dropdelzpp": 623309998,
    "dropphyadd": "45 E 3RD ST",
    "dropphycty": "DALLAS CITY",
    "dropphyst": "IL",
    "dropphyzpp": 623309998,
    "dropmaladd": "45 E 3RD ST",
    "dropmalcty": "DALLAS CITY",
    "dropmalst": "IL",
    "dropmalzpp": 623309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178523516,
    "dropsitcph": 2178523516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12582",
    "droptype": "D",
    "dropname": "DALTON CITY",
    "dropdeladd": "135 E MAIN ST",
    "dropdelcty": "DALTON CITY",
    "dropdelst": "IL",
    "dropdelzpp": 619259998,
    "dropphyadd": "135 E MAIN ST",
    "dropphycty": "DALTON CITY",
    "dropphyst": "IL",
    "dropphyzpp": 619259998,
    "dropmaladd": "135 E MAIN ST",
    "dropmalcty": "DALTON CITY",
    "dropmalst": "IL",
    "dropmalzpp": 619259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178742712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12583",
    "droptype": "D",
    "dropname": "DALZELL",
    "dropdeladd": "139 SAUNDERS ST",
    "dropdelcty": "DALZELL",
    "dropdelst": "IL",
    "dropdelzpp": 613209705,
    "dropphyadd": "139 SAUNDERS ST",
    "dropphycty": "DALZELL",
    "dropphyst": "IL",
    "dropphyzpp": 613209705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALZELL",
    "dropmalst": "IL",
    "dropmalzpp": 613209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156644532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12585",
    "droptype": "D",
    "dropname": "DANA",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "DANA",
    "dropdelst": "IL",
    "dropdelzpp": 613219700,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "DANA",
    "dropphyst": "IL",
    "dropphyzpp": 613219700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANA",
    "dropmalst": "IL",
    "dropmalzpp": 613219998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158542441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12586",
    "droptype": "D",
    "dropname": "DANFORTH",
    "dropdeladd": "108 N FRONT ST",
    "dropdelcty": "DANFORTH",
    "dropdelst": "IL",
    "dropdelzpp": 609309013,
    "dropphyadd": "108 N FRONT ST",
    "dropphycty": "DANFORTH",
    "dropphyst": "IL",
    "dropphyzpp": 609309013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANFORTH",
    "dropmalst": "IL",
    "dropmalzpp": 609309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152692110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12587",
    "droptype": "D",
    "dropname": "DANVERS",
    "dropdeladd": "119 E EXCHANGE ST",
    "dropdelcty": "DANVERS",
    "dropdelst": "IL",
    "dropdelzpp": 617329347,
    "dropphyadd": "119 E EXCHANGE ST",
    "dropphycty": "DANVERS",
    "dropphyst": "IL",
    "dropphyzpp": 617329347,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANVERS",
    "dropmalst": "IL",
    "dropmalzpp": 617329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099634327,
    "dropfax": 3099634327
  },
  {
    "dcode": "D",
    "dropkey": "PW12588",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "303 N HAZEL ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 618329998,
    "dropphyadd": "303 N HAZEL ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 618329998,
    "dropmaladd": "303 N HAZEL ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 618329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174469440,
    "dropfax": 2174464749
  },
  {
    "dcode": "D",
    "dropkey": "PW12594",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "420 N STANTON ST",
    "dropdelcty": "DAVIS",
    "dropdelst": "IL",
    "dropdelzpp": 610199113,
    "dropphyadd": "420 N STANTON ST",
    "dropphycty": "DAVIS",
    "dropphyst": "IL",
    "dropphyzpp": 610199113,
    "dropmaladd": "420 N STANTON ST",
    "dropmalcty": "DAVIS",
    "dropmalst": "IL",
    "dropmalzpp": 610199113,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158655416,
    "dropsitcph": 8158655416,
    "dropfax": 8158659123
  },
  {
    "dcode": "D",
    "dropkey": "PW12596",
    "droptype": "D",
    "dropname": "DAVIS JUNCTION",
    "dropdeladd": "402 W CHICAGO AVE",
    "dropdelcty": "DAVIS JUNCTION",
    "dropdelst": "IL",
    "dropdelzpp": 610209414,
    "dropphyadd": "402 W CHICAGO AVE",
    "dropphycty": "DAVIS JUNCTION",
    "dropphyst": "IL",
    "dropphyzpp": 610209414,
    "dropmaladd": "402 W CHICAGO AVE",
    "dropmalcty": "DAVIS JUNCTION",
    "dropmalst": "IL",
    "dropmalzpp": 610209414,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156458116,
    "dropsitcph": 8156458116,
    "dropfax": 8156458539
  },
  {
    "dcode": "D",
    "dropkey": "PW12597",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "106 N CONSTANT ST",
    "dropdelcty": "DAWSON",
    "dropdelst": "IL",
    "dropdelzpp": 625209998,
    "dropphyadd": "106 N CONSTANT ST",
    "dropphycty": "DAWSON",
    "dropphyst": "IL",
    "dropphyzpp": 625209998,
    "dropmaladd": "106 N CONSTANT ST",
    "dropmalcty": "DAWSON",
    "dropmalst": "IL",
    "dropmalzpp": 625209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173644629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12602",
    "droptype": "D",
    "dropname": "DEKALB",
    "dropdeladd": "600 E LINCOLN HWY",
    "dropdelcty": "DEKALB",
    "dropdelst": "IL",
    "dropdelzpp": 601153883,
    "dropphyadd": "600 E LINCOLN HWY",
    "dropphycty": "DEKALB",
    "dropphyst": "IL",
    "dropphyzpp": 601153883,
    "dropmaladd": "600 E LINCOLN HWY",
    "dropmalcty": "DEKALB",
    "dropmalst": "IL",
    "dropmalzpp": 601153883,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157586677,
    "dropsitcph": 8157586677,
    "dropfax": 8157568527
  },
  {
    "dcode": "D",
    "dropkey": "PW12603",
    "droptype": "D",
    "dropname": "DE LAND",
    "dropdeladd": "101 NE 3RD ST",
    "dropdelcty": "DE LAND",
    "dropdelst": "IL",
    "dropdelzpp": 618399998,
    "dropphyadd": "101 NE 3RD ST",
    "dropphycty": "DE LAND",
    "dropphyst": "IL",
    "dropphyzpp": 618399998,
    "dropmaladd": "101 NE 3RD ST",
    "dropmalcty": "DE LAND",
    "dropmalst": "IL",
    "dropmalzpp": 618399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085636050,
    "dropsitcph": 2176643517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12605",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "104 N CHESTNUT ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "IL",
    "dropdelzpp": 629249998,
    "dropphyadd": "104 N CHESTNUT ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "IL",
    "dropphyzpp": 629249998,
    "dropmaladd": "104 N CHESTNUT ST",
    "dropmalcty": "DE SOTO",
    "dropmalst": "IL",
    "dropmalzpp": 629249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188672522,
    "dropsitcph": 6188672522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12606",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "214 N FRANKLIN ST FL 1",
    "dropdelcty": "DECATUR",
    "dropdelst": "IL",
    "dropdelzpp": 625239998,
    "dropphyadd": "214 N FRANKLIN ST FL 1",
    "dropphycty": "DECATUR",
    "dropphyst": "IL",
    "dropphyzpp": 625239998,
    "dropmaladd": "214 N FRANKLIN ST FL 1",
    "dropmalcty": "DECATUR",
    "dropmalst": "IL",
    "dropmalzpp": 625239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2174284471,
    "dropsitcph": 2174284471,
    "dropfax": 2174284290
  },
  {
    "dcode": "D",
    "dropkey": "PW12608",
    "droptype": "D",
    "dropname": "DEER CREEK",
    "dropdeladd": "104 E 1ST AVE",
    "dropdelcty": "DEER CREEK",
    "dropdelst": "IL",
    "dropdelzpp": 617339534,
    "dropphyadd": "104 E 1ST AVE",
    "dropphycty": "DEER CREEK",
    "dropphyst": "IL",
    "dropphyzpp": 617339534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER CREEK",
    "dropmalst": "IL",
    "dropmalzpp": 617339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094476266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12609",
    "droptype": "D",
    "dropname": "DEER GROVE",
    "dropdeladd": "28983 HUB ST",
    "dropdelcty": "DEER GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 612439005,
    "dropphyadd": "28983 HUB ST",
    "dropphycty": "DEER GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 612439005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 612439998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8154384223,
    "dropsitcph": 8154384223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12612",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "707 OSTERMAN AVE",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 600154421,
    "dropphyadd": "707 OSTERMAN AVE",
    "dropphycty": "DEERFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 600154421,
    "dropmaladd": "707 OSTERMAN AVE",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 600154421,
    "dropsitphn": 6302605499,
    "dropsitlph": 8479450293,
    "dropsitcph": 8479450293,
    "dropfax": 8479450179
  },
  {
    "dcode": "D",
    "dropkey": "PW12617",
    "droptype": "D",
    "dropname": "DELAVAN",
    "dropdeladd": "114 E 5TH ST",
    "dropdelcty": "DELAVAN",
    "dropdelst": "IL",
    "dropdelzpp": 617349800,
    "dropphyadd": "114 E 5TH ST",
    "dropphycty": "DELAVAN",
    "dropphyst": "IL",
    "dropphyzpp": 617349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELAVAN",
    "dropmalst": "IL",
    "dropmalzpp": 617349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092448267,
    "dropfax": 3092448267
  },
  {
    "dcode": "D",
    "dropkey": "PW12628",
    "droptype": "D",
    "dropname": "DEPUE",
    "dropdeladd": "200 W 4TH ST",
    "dropdelcty": "DEPUE",
    "dropdelst": "IL",
    "dropdelzpp": 613229700,
    "dropphyadd": "200 W 4TH ST",
    "dropphycty": "DEPUE",
    "dropphyst": "IL",
    "dropphyzpp": 613229700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEPUE",
    "dropmalst": "IL",
    "dropmalzpp": 613229998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154472300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12634",
    "droptype": "D",
    "dropname": "DES PLAINES",
    "dropdeladd": "1000 E OAKTON ST",
    "dropdelcty": "DES PLAINES",
    "dropdelst": "IL",
    "dropdelzpp": 600186318,
    "dropphyadd": "1000 E OAKTON ST",
    "dropphycty": "DES PLAINES",
    "dropphyst": "IL",
    "dropphyzpp": 600186318,
    "dropmaladd": "1000 E OAKTON ST",
    "dropmalcty": "DES PLAINES",
    "dropmalst": "IL",
    "dropmalzpp": 600186318,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478275592,
    "dropsitcph": 8478275592,
    "dropfax": 8478273924
  },
  {
    "dcode": "D",
    "dropkey": "PW12642",
    "droptype": "D",
    "dropname": "DEWEY",
    "dropdeladd": "110 2ND ST",
    "dropdelcty": "DEWEY",
    "dropdelst": "IL",
    "dropdelzpp": 618409998,
    "dropphyadd": "110 2ND ST",
    "dropphycty": "DEWEY",
    "dropphyst": "IL",
    "dropphyzpp": 618409998,
    "dropmaladd": "110 2ND ST",
    "dropmalcty": "DEWEY",
    "dropmalst": "IL",
    "dropmalzpp": 618409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178976294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12643",
    "droptype": "D",
    "dropname": "DEWITT",
    "dropdeladd": "105 CHICAGO ST",
    "dropdelcty": "DEWITT",
    "dropdelst": "IL",
    "dropdelzpp": 617359900,
    "dropphyadd": "105 CHICAGO ST",
    "dropphycty": "DEWITT",
    "dropphyst": "IL",
    "dropphyzpp": 617359900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEWITT",
    "dropmalst": "IL",
    "dropmalzpp": 617359998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179352978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12647",
    "droptype": "D",
    "dropname": "DIETERICH",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "DIETERICH",
    "dropdelst": "IL",
    "dropdelzpp": 624249998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "DIETERICH",
    "dropphyst": "IL",
    "dropphyzpp": 624249998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "DIETERICH",
    "dropmalst": "IL",
    "dropmalzpp": 624249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179255535,
    "dropsitcph": 2179255535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12653",
    "droptype": "D",
    "dropname": "DIVERNON",
    "dropdeladd": "157 W DODDS ST",
    "dropdelcty": "DIVERNON",
    "dropdelst": "IL",
    "dropdelzpp": 625309998,
    "dropphyadd": "157 W DODDS ST",
    "dropphycty": "DIVERNON",
    "dropphyst": "IL",
    "dropphyzpp": 625309998,
    "dropmaladd": "157 W DODDS ST",
    "dropmalcty": "DIVERNON",
    "dropmalst": "IL",
    "dropmalzpp": 625309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176283522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12657",
    "droptype": "D",
    "dropname": "DIX",
    "dropdeladd": "302 N MAIN ST",
    "dropdelcty": "DIX",
    "dropdelst": "IL",
    "dropdelzpp": 628309998,
    "dropphyadd": "302 N MAIN ST",
    "dropphycty": "DIX",
    "dropphyst": "IL",
    "dropphyzpp": 628309998,
    "dropmaladd": "302 N MAIN ST",
    "dropmalcty": "DIX",
    "dropmalst": "IL",
    "dropmalzpp": 628309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182667369,
    "dropsitcph": 6182667369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12660",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "405 W 2ND ST",
    "dropdelcty": "DIXON",
    "dropdelst": "IL",
    "dropdelzpp": 610212928,
    "dropphyadd": "405 W 2ND ST",
    "dropphycty": "DIXON",
    "dropphyst": "IL",
    "dropphyzpp": 610212928,
    "dropmaladd": "405 W 2ND ST",
    "dropmalcty": "DIXON",
    "dropmalst": "IL",
    "dropmalzpp": 610212928,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152845015,
    "dropsitcph": 8152845015,
    "dropfax": 7792516457
  },
  {
    "dcode": "D",
    "dropkey": "PW12667",
    "droptype": "D",
    "dropname": "DOLTON",
    "dropdeladd": "14212 COTTAGE GROVE AVE",
    "dropdelcty": "DOLTON",
    "dropdelst": "IL",
    "dropdelzpp": 604199998,
    "dropphyadd": "14212 COTTAGE GROVE AVE",
    "dropphycty": "DOLTON",
    "dropphyst": "IL",
    "dropphyzpp": 604199998,
    "dropmaladd": "14212 COTTAGE GROVE AVE",
    "dropmalcty": "DOLTON",
    "dropmalst": "IL",
    "dropmalzpp": 604199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7088492777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12670",
    "droptype": "D",
    "dropname": "DONGOLA",
    "dropdeladd": "106 E CROSS ST",
    "dropdelcty": "DONGOLA",
    "dropdelst": "IL",
    "dropdelzpp": 629269998,
    "dropphyadd": "106 E CROSS ST",
    "dropphycty": "DONGOLA",
    "dropphyst": "IL",
    "dropphyzpp": 629269998,
    "dropmaladd": "106 E CROSS ST",
    "dropmalcty": "DONGOLA",
    "dropmalst": "IL",
    "dropmalzpp": 629269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188273824,
    "dropsitcph": 6188273824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12671",
    "droptype": "D",
    "dropname": "DONNELLSON",
    "dropdeladd": "606 WASHINGTON ST",
    "dropdelcty": "DONNELLSON",
    "dropdelst": "IL",
    "dropdelzpp": 620199998,
    "dropphyadd": "606 WASHINGTON ST",
    "dropphycty": "DONNELLSON",
    "dropphyst": "IL",
    "dropphyzpp": 620199998,
    "dropmaladd": "606 WASHINGTON ST",
    "dropmalcty": "DONNELLSON",
    "dropmalst": "IL",
    "dropmalzpp": 620199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175373011,
    "dropsitcph": 2175373011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12673",
    "droptype": "D",
    "dropname": "DONOVAN",
    "dropdeladd": "301 E 2ND ST",
    "dropdelcty": "DONOVAN",
    "dropdelst": "IL",
    "dropdelzpp": 609319998,
    "dropphyadd": "301 E 2ND ST",
    "dropphycty": "DONOVAN",
    "dropphyst": "IL",
    "dropphyzpp": 609319998,
    "dropmaladd": "301 E 2ND ST",
    "dropmalcty": "DONOVAN",
    "dropmalst": "IL",
    "dropmalzpp": 609319998,
    "dropsitphn": 8154293841,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154867020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12677",
    "droptype": "D",
    "dropname": "DORSEY",
    "dropdeladd": "4611 SEILER RD",
    "dropdelcty": "DORSEY",
    "dropdelst": "IL",
    "dropdelzpp": 620219998,
    "dropphyadd": "4611 SEILER RD",
    "dropphycty": "DORSEY",
    "dropphyst": "IL",
    "dropphyzpp": 620219998,
    "dropmaladd": "4611 SEILER RD",
    "dropmalcty": "DORSEY",
    "dropmalst": "IL",
    "dropmalzpp": 620219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183776222,
    "dropsitcph": 6183776222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12680",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "106 E WASHINGTON ST",
    "dropdelcty": "DOVER",
    "dropdelst": "IL",
    "dropdelzpp": 613239700,
    "dropphyadd": "106 E WASHINGTON ST",
    "dropphycty": "DOVER",
    "dropphyst": "IL",
    "dropphyzpp": 613239700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOVER",
    "dropmalst": "IL",
    "dropmalzpp": 613239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156432393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12681",
    "droptype": "D",
    "dropname": "DOW",
    "dropdeladd": "24443 PINE ST",
    "dropdelcty": "DOW",
    "dropdelst": "IL",
    "dropdelzpp": 620229998,
    "dropphyadd": "24443 PINE ST",
    "dropphycty": "DOW",
    "dropphyst": "IL",
    "dropphyzpp": 620229998,
    "dropmaladd": "24443 PINE ST",
    "dropmalcty": "DOW",
    "dropmalst": "IL",
    "dropmalzpp": 620229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188855231,
    "dropsitcph": 6188855231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12682",
    "droptype": "D",
    "dropname": "DOWELL",
    "dropdeladd": "501 UNION AVE",
    "dropdelcty": "DOWELL",
    "dropdelst": "IL",
    "dropdelzpp": 629279998,
    "dropphyadd": "501 UNION AVE",
    "dropphycty": "DOWELL",
    "dropphyst": "IL",
    "dropphyzpp": 629279998,
    "dropmaladd": "501 UNION AVE",
    "dropmalcty": "DOWELL",
    "dropmalst": "IL",
    "dropmalzpp": 629279998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185681821,
    "dropsitcph": 6185681821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12683",
    "droptype": "D",
    "dropname": "DOWNERS GROVE",
    "dropdeladd": "920 CURTISS ST",
    "dropdelcty": "DOWNERS GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 605159998,
    "dropphyadd": "920 CURTISS ST",
    "dropphycty": "DOWNERS GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 605159998,
    "dropmaladd": "920 CURTISS ST",
    "dropmalcty": "DOWNERS GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 605159998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6309692001,
    "dropfax": 6309692082
  },
  {
    "dcode": "D",
    "dropkey": "PW12687",
    "droptype": "D",
    "dropname": "DOWNS",
    "dropdeladd": "403 S SEMINARY ST",
    "dropdelcty": "DOWNS",
    "dropdelst": "IL",
    "dropdelzpp": 617367583,
    "dropphyadd": "403 S SEMINARY ST",
    "dropphycty": "DOWNS",
    "dropphyst": "IL",
    "dropphyzpp": 617367583,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOWNS",
    "dropmalst": "IL",
    "dropmalzpp": 617369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093784431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12696",
    "droptype": "D",
    "dropname": "DU BOIS",
    "dropdeladd": "75 W BROADWAY ST",
    "dropdelcty": "DU BOIS",
    "dropdelst": "IL",
    "dropdelzpp": 628319998,
    "dropphyadd": "75 W BROADWAY ST",
    "dropphycty": "DU BOIS",
    "dropphyst": "IL",
    "dropphyzpp": 628319998,
    "dropmaladd": "75 W BROADWAY ST",
    "dropmalcty": "DU BOIS",
    "dropmalst": "IL",
    "dropmalzpp": 628319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187874161,
    "dropsitcph": 6187874161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12697",
    "droptype": "D",
    "dropname": "DU QUOIN",
    "dropdeladd": "304 E MAIN ST",
    "dropdelcty": "DU QUOIN",
    "dropdelst": "IL",
    "dropdelzpp": 628329997,
    "dropphyadd": "304 E MAIN ST",
    "dropphycty": "DU QUOIN",
    "dropphyst": "IL",
    "dropphyzpp": 628329997,
    "dropmaladd": "304 E MAIN ST",
    "dropmalcty": "DU QUOIN",
    "dropmalst": "IL",
    "dropmalzpp": 628329997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185423933,
    "dropsitcph": 6185423933,
    "dropfax": 6185422567
  },
  {
    "dcode": "D",
    "dropkey": "PW12705",
    "droptype": "D",
    "dropname": "DUNDAS",
    "dropdeladd": "7220 N WASHINGTON ST",
    "dropdelcty": "DUNDAS",
    "dropdelst": "IL",
    "dropdelzpp": 624259998,
    "dropphyadd": "7220 N WASHINGTON ST",
    "dropphycty": "DUNDAS",
    "dropphyst": "IL",
    "dropphyzpp": 624259998,
    "dropmaladd": "7220 N WASHINGTON ST",
    "dropmalcty": "DUNDAS",
    "dropmalst": "IL",
    "dropmalzpp": 624259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187543455,
    "dropsitcph": 6187543455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12706",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "611 S 8TH ST",
    "dropdelcty": "WEST DUNDEE",
    "dropdelst": "IL",
    "dropdelzpp": 601189998,
    "dropphyadd": "611 S 8TH ST",
    "dropphycty": "WEST DUNDEE",
    "dropphyst": "IL",
    "dropphyzpp": 601189998,
    "dropmaladd": "611 S 8TH ST",
    "dropmalcty": "WEST DUNDEE",
    "dropmalst": "IL",
    "dropmalzpp": 601189998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474262441,
    "dropsitcph": 8474262441,
    "dropfax": 8474269812
  },
  {
    "dcode": "D",
    "dropkey": "PW12707",
    "droptype": "D",
    "dropname": "DUNFERMLINE",
    "dropdeladd": "316 CENTER ST",
    "dropdelcty": "DUNFERMLINE",
    "dropdelst": "IL",
    "dropdelzpp": 615249700,
    "dropphyadd": "316 CENTER ST",
    "dropphycty": "DUNFERMLINE",
    "dropphyst": "IL",
    "dropphyzpp": 615249700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNFERMLINE",
    "dropmalst": "IL",
    "dropmalzpp": 615249998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096682645,
    "dropfax": 3096682645
  },
  {
    "dcode": "D",
    "dropkey": "PW12709",
    "droptype": "D",
    "dropname": "DUNLAP",
    "dropdeladd": "114 N 2ND ST",
    "dropdelcty": "DUNLAP",
    "dropdelst": "IL",
    "dropdelzpp": 615259998,
    "dropphyadd": "114 N 2ND ST",
    "dropphycty": "DUNLAP",
    "dropphyst": "IL",
    "dropphyzpp": 615259998,
    "dropmaladd": "114 N 2ND ST",
    "dropmalcty": "DUNLAP",
    "dropmalst": "IL",
    "dropmalzpp": 615259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092437557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12714",
    "droptype": "D",
    "dropname": "DUPO",
    "dropdeladd": "116 EMMA AVE",
    "dropdelcty": "DUPO",
    "dropdelst": "IL",
    "dropdelzpp": 622399998,
    "dropphyadd": "116 EMMA AVE",
    "dropphycty": "DUPO",
    "dropphyst": "IL",
    "dropphyzpp": 622399998,
    "dropmaladd": "116 EMMA AVE",
    "dropmalcty": "DUPO",
    "dropmalst": "IL",
    "dropmalzpp": 622399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182863917,
    "dropsitcph": 6182863917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12715",
    "droptype": "D",
    "dropname": "DURAND",
    "dropdeladd": "211 N CENTER ST",
    "dropdelcty": "DURAND",
    "dropdelst": "IL",
    "dropdelzpp": 610248922,
    "dropphyadd": "211 N CENTER ST",
    "dropphycty": "DURAND",
    "dropphyst": "IL",
    "dropphyzpp": 610248922,
    "dropmaladd": "211 N CENTER ST",
    "dropmalcty": "DURAND",
    "dropmalst": "IL",
    "dropmalzpp": 610248922,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152482677,
    "dropsitcph": 8152482677,
    "dropfax": 8152483701
  },
  {
    "dcode": "D",
    "dropkey": "PW12718",
    "droptype": "D",
    "dropname": "DWIGHT",
    "dropdeladd": "100 E MAZON AVE",
    "dropdelcty": "DWIGHT",
    "dropdelst": "IL",
    "dropdelzpp": 604209998,
    "dropphyadd": "100 E MAZON AVE",
    "dropphycty": "DWIGHT",
    "dropphyst": "IL",
    "dropphyzpp": 604209998,
    "dropmaladd": "100 E MAZON AVE",
    "dropmalcty": "DWIGHT",
    "dropmalst": "IL",
    "dropmalzpp": 604209998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8155843465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12739",
    "droptype": "D",
    "dropname": "EAGARVILLE",
    "dropdeladd": "106 S MOUNT OLIVE RD",
    "dropdelcty": "EAGARVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620231000,
    "dropphyadd": "106 S MOUNT OLIVE RD",
    "dropphycty": "EAGARVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620231000,
    "dropmaladd": "106 S MOUNT OLIVE RD",
    "dropmalcty": "EAGARVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620231000,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178352700,
    "dropsitcph": 2178352700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12747",
    "droptype": "D",
    "dropname": "EARLVILLE",
    "dropdeladd": "200 W WINTHROP ST",
    "dropdelcty": "EARLVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605189998,
    "dropphyadd": "200 W WINTHROP ST",
    "dropphycty": "EARLVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605189998,
    "dropmaladd": "200 W WINTHROP ST",
    "dropmalcty": "EARLVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605189998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152467155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12752",
    "droptype": "D",
    "dropname": "EAST ALTON",
    "dropdeladd": "200 SMITH AVE",
    "dropdelcty": "EAST ALTON",
    "dropdelst": "IL",
    "dropdelzpp": 620249998,
    "dropphyadd": "200 SMITH AVE",
    "dropphycty": "EAST ALTON",
    "dropphyst": "IL",
    "dropphyzpp": 620249998,
    "dropmaladd": "200 SMITH AVE",
    "dropmalcty": "EAST ALTON",
    "dropmalst": "IL",
    "dropmalzpp": 620249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182598721,
    "dropsitcph": 6182598721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12755",
    "droptype": "D",
    "dropname": "EAST CARONDELET",
    "dropdeladd": "824 STATE ST",
    "dropdelcty": "EAST CARONDELET",
    "dropdelst": "IL",
    "dropdelzpp": 622409998,
    "dropphyadd": "824 STATE ST",
    "dropphycty": "EAST CARONDELET",
    "dropphyst": "IL",
    "dropphyzpp": 622409998,
    "dropmaladd": "824 STATE ST",
    "dropmalcty": "EAST CARONDELET",
    "dropmalst": "IL",
    "dropmalzpp": 622409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182864446,
    "dropsitcph": 6182864446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12759",
    "droptype": "D",
    "dropname": "EAST DUBUQUE",
    "dropdeladd": "200 WALL ST",
    "dropdelcty": "EAST DUBUQUE",
    "dropdelst": "IL",
    "dropdelzpp": 610251240,
    "dropphyadd": "200 WALL ST",
    "dropphycty": "EAST DUBUQUE",
    "dropphyst": "IL",
    "dropphyzpp": 610251240,
    "dropmaladd": "200 WALL ST",
    "dropmalcty": "EAST DUBUQUE",
    "dropmalst": "IL",
    "dropmalzpp": 610251240,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157473013,
    "dropsitcph": 8157473013,
    "dropfax": 8157473039
  },
  {
    "dcode": "D",
    "dropkey": "PW12764",
    "droptype": "D",
    "dropname": "EAST GALESBURG",
    "dropdeladd": "407 1/2 S STATE ST",
    "dropdelcty": "EAST GALESBURG",
    "dropdelst": "IL",
    "dropdelzpp": 614309998,
    "dropphyadd": "407 1/2 S STATE ST",
    "dropphycty": "EAST GALESBURG",
    "dropphyst": "IL",
    "dropphyzpp": 614309998,
    "dropmaladd": "407 1/2 S STATE ST",
    "dropmalcty": "EAST GALESBURG",
    "dropmalst": "IL",
    "dropmalzpp": 614309998,
    "dropsitphn": 3093423612,
    "dropsitlph": 3093423612,
    "dropsitcph": 3093423612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12769",
    "droptype": "D",
    "dropname": "EAST LYNN",
    "dropdeladd": "41495 MAIN ST",
    "dropdelcty": "EAST LYNN",
    "dropdelst": "IL",
    "dropdelzpp": 609329998,
    "dropphyadd": "41495 MAIN ST",
    "dropphycty": "EAST LYNN",
    "dropphyst": "IL",
    "dropphyzpp": 609329998,
    "dropmaladd": "41495 MAIN ST",
    "dropmalcty": "EAST LYNN",
    "dropmalst": "IL",
    "dropmalzpp": 609329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173754403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12770",
    "droptype": "D",
    "dropname": "EAST MOLINE",
    "dropdeladd": "805 16TH AVE",
    "dropdelcty": "EAST MOLINE",
    "dropdelst": "IL",
    "dropdelzpp": 612449998,
    "dropphyadd": "805 16TH AVE",
    "dropphycty": "EAST MOLINE",
    "dropphyst": "IL",
    "dropphyzpp": 612449998,
    "dropmaladd": "805 16TH AVE",
    "dropmalcty": "EAST MOLINE",
    "dropmalst": "IL",
    "dropmalzpp": 612449998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097557227,
    "dropsitcph": 3097555746,
    "dropfax": 3097550332
  },
  {
    "dcode": "D",
    "dropkey": "PW12775",
    "droptype": "D",
    "dropname": "EAST SAINT LOUIS",
    "dropdeladd": "950 MISSOURI AVE",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622019998,
    "dropphyadd": "950 MISSOURI AVE",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622019998,
    "dropmaladd": "950 MISSOURI AVE",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188750200,
    "dropsitcph": 6188750200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12782",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "104 S 2ND ST",
    "dropdelcty": "EASTON",
    "dropdelst": "IL",
    "dropdelzpp": 626339998,
    "dropphyadd": "104 S 2ND ST",
    "dropphycty": "EASTON",
    "dropphyst": "IL",
    "dropphyzpp": 626339998,
    "dropmaladd": "104 S 2ND ST",
    "dropmalcty": "EASTON",
    "dropmalst": "IL",
    "dropmalzpp": 626339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 3095627412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12785",
    "droptype": "D",
    "dropname": "EDDYVILLE",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "EDDYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 629289998,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "EDDYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 629289998,
    "dropmaladd": "110 MAIN ST",
    "dropmalcty": "EDDYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 629289998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186724711,
    "dropsitcph": 6186724711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12788",
    "droptype": "D",
    "dropname": "EDELSTEIN",
    "dropdeladd": "2809 W MAIN ST",
    "dropdelcty": "EDELSTEIN",
    "dropdelst": "IL",
    "dropdelzpp": 615269636,
    "dropphyadd": "2809 W MAIN ST",
    "dropphycty": "EDELSTEIN",
    "dropphyst": "IL",
    "dropphyzpp": 615269636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDELSTEIN",
    "dropmalst": "IL",
    "dropmalzpp": 615269998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092492441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12797",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "807 BROAD ST",
    "dropdelcty": "EDGEWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 624269998,
    "dropphyadd": "807 BROAD ST",
    "dropphycty": "EDGEWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 624269998,
    "dropmaladd": "807 BROAD ST",
    "dropmalcty": "EDGEWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 624269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182382052,
    "dropsitcph": 6182382052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12800",
    "droptype": "D",
    "dropname": "EDINBURG",
    "dropdeladd": "114 W WASHINGTON ST",
    "dropdelcty": "EDINBURG",
    "dropdelst": "IL",
    "dropdelzpp": 625319998,
    "dropphyadd": "114 W WASHINGTON ST",
    "dropphycty": "EDINBURG",
    "dropphyst": "IL",
    "dropphyzpp": 625319998,
    "dropmaladd": "114 W WASHINGTON ST",
    "dropmalcty": "EDINBURG",
    "dropmalst": "IL",
    "dropmalzpp": 625319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176235219,
    "dropfax": 2176235219
  },
  {
    "dcode": "D",
    "dropkey": "PW12802",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "10112 W DUBOIS RD STE A",
    "dropdelcty": "EDWARDS",
    "dropdelst": "IL",
    "dropdelzpp": 615289998,
    "dropphyadd": "10112 W DUBOIS RD STE A",
    "dropphycty": "EDWARDS",
    "dropphyst": "IL",
    "dropphyzpp": 615289998,
    "dropmaladd": "10112 W DUBOIS RD STE A",
    "dropmalcty": "EDWARDS",
    "dropmalst": "IL",
    "dropmalzpp": 615289998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096765866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12803",
    "droptype": "D",
    "dropname": "EDWARDSVILLE",
    "dropdeladd": "132 N KANSAS ST",
    "dropdelcty": "EDWARDSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620259998,
    "dropphyadd": "132 N KANSAS ST",
    "dropphycty": "EDWARDSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620259998,
    "dropmaladd": "132 N KANSAS ST",
    "dropmalcty": "EDWARDSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186568460,
    "dropsitcph": 6186568460,
    "dropfax": 6513066052
  },
  {
    "dcode": "D",
    "dropkey": "PW12807",
    "droptype": "D",
    "dropname": "EFFINGHAM",
    "dropdeladd": "210 N 3RD ST",
    "dropdelcty": "EFFINGHAM",
    "dropdelst": "IL",
    "dropdelzpp": 624019998,
    "dropphyadd": "210 N 3RD ST",
    "dropphycty": "EFFINGHAM",
    "dropphyst": "IL",
    "dropphyzpp": 624019998,
    "dropmaladd": "210 N 3RD ST",
    "dropmalcty": "EFFINGHAM",
    "dropmalst": "IL",
    "dropmalzpp": 624019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173426016,
    "dropsitcph": 2173426016,
    "dropfax": 2173426016
  },
  {
    "dcode": "D",
    "dropkey": "PW12813",
    "droptype": "D",
    "dropname": "EL PASO",
    "dropdeladd": "401 W FRONT ST",
    "dropdelcty": "EL PASO",
    "dropdelst": "IL",
    "dropdelzpp": 617389998,
    "dropphyadd": "401 W FRONT ST",
    "dropphycty": "EL PASO",
    "dropphyst": "IL",
    "dropphyzpp": 617389998,
    "dropmaladd": "401 W FRONT ST",
    "dropmalcty": "EL PASO",
    "dropmalst": "IL",
    "dropmalzpp": 617389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3095274220,
    "dropfax": 3095274221
  },
  {
    "dcode": "D",
    "dropkey": "PW12817",
    "droptype": "D",
    "dropname": "ELBURN",
    "dropdeladd": "815 N MAIN ST",
    "dropdelcty": "ELBURN",
    "dropdelst": "IL",
    "dropdelzpp": 601199998,
    "dropphyadd": "815 N MAIN ST",
    "dropphycty": "ELBURN",
    "dropphyst": "IL",
    "dropphyzpp": 601199998,
    "dropmaladd": "815 N MAIN ST",
    "dropmalcty": "ELBURN",
    "dropmalst": "IL",
    "dropmalzpp": 601199998,
    "dropsitphn": 6303656360,
    "dropsitlph": 6303656360,
    "dropsitcph": 6303656360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12821",
    "droptype": "D",
    "dropname": "ELDORADO",
    "dropdeladd": "900 4TH ST",
    "dropdelcty": "ELDORADO",
    "dropdelst": "IL",
    "dropdelzpp": 629309998,
    "dropphyadd": "900 4TH ST",
    "dropphycty": "ELDORADO",
    "dropphyst": "IL",
    "dropphyzpp": 629309998,
    "dropmaladd": "900 4TH ST",
    "dropmalcty": "ELDORADO",
    "dropmalst": "IL",
    "dropmalzpp": 629309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182738100,
    "dropsitcph": 6182738100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12822",
    "droptype": "D",
    "dropname": "ELDRED",
    "dropdeladd": "417 PINE ST",
    "dropdelcty": "ELDRED",
    "dropdelst": "IL",
    "dropdelzpp": 620279998,
    "dropphyadd": "417 PINE ST",
    "dropphycty": "ELDRED",
    "dropphyst": "IL",
    "dropphyzpp": 620279998,
    "dropmaladd": "417 PINE ST",
    "dropmalcty": "ELDRED",
    "dropmalst": "IL",
    "dropmalzpp": 620279998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179832314,
    "dropsitcph": 2179832314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12826",
    "droptype": "D",
    "dropname": "ELEROY",
    "dropdeladd": "316 N BRIDGE ST",
    "dropdelcty": "ELEROY",
    "dropdelst": "IL",
    "dropdelzpp": 610279800,
    "dropphyadd": "316 N BRIDGE ST",
    "dropphycty": "ELEROY",
    "dropphyst": "IL",
    "dropphyzpp": 610279800,
    "dropmaladd": "316 N BRIDGE ST",
    "dropmalcty": "ELEROY",
    "dropmalst": "IL",
    "dropmalzpp": 610279800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152354726,
    "dropsitcph": 8152354726,
    "dropfax": 8152326772
  },
  {
    "dcode": "D",
    "dropkey": "PW12827",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "66 GROVE CT",
    "dropdelcty": "ELGIN",
    "dropdelst": "IL",
    "dropdelzpp": 601205588,
    "dropphyadd": "66 GROVE CT",
    "dropphycty": "ELGIN",
    "dropphyst": "IL",
    "dropphyzpp": 601205588,
    "dropmaladd": "66 GROVE CT",
    "dropmalcty": "ELGIN",
    "dropmalst": "IL",
    "dropmalzpp": 601205588,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477410725,
    "dropsitcph": 8477410725,
    "dropfax": 8477411959
  },
  {
    "dcode": "D",
    "dropkey": "PW12830",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "102 E MYRTLE ST",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "IL",
    "dropdelzpp": 610289787,
    "dropphyadd": "102 E MYRTLE ST",
    "dropphycty": "ELIZABETH",
    "dropphyst": "IL",
    "dropphyzpp": 610289787,
    "dropmaladd": "102 E MYRTLE ST",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "IL",
    "dropmalzpp": 610289787,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158582050,
    "dropsitcph": 8158582050,
    "dropfax": 8158582661
  },
  {
    "dcode": "D",
    "dropkey": "PW12846",
    "droptype": "D",
    "dropname": "ELKHART",
    "dropdeladd": "106 N BOGARDUS ST",
    "dropdelcty": "ELKHART",
    "dropdelst": "IL",
    "dropdelzpp": 626349998,
    "dropphyadd": "106 N BOGARDUS ST",
    "dropphycty": "ELKHART",
    "dropphyst": "IL",
    "dropphyzpp": 626349998,
    "dropmaladd": "106 N BOGARDUS ST",
    "dropmalcty": "ELKHART",
    "dropmalst": "IL",
    "dropmalzpp": 626349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179472312,
    "dropfax": 2179472312
  },
  {
    "dcode": "D",
    "dropkey": "PW12848",
    "droptype": "D",
    "dropname": "ELKVILLE",
    "dropdeladd": "108 S 4TH ST",
    "dropdelcty": "ELKVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 629329998,
    "dropphyadd": "108 S 4TH ST",
    "dropphycty": "ELKVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 629329998,
    "dropmaladd": "108 S 4TH ST",
    "dropmalcty": "ELKVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 629329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185681711,
    "dropsitcph": 6185681711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12852",
    "droptype": "D",
    "dropname": "ELLIOTT",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "ELLIOTT",
    "dropdelst": "IL",
    "dropdelzpp": 609339800,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "ELLIOTT",
    "dropphyst": "IL",
    "dropphyzpp": 609339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLIOTT",
    "dropmalst": "IL",
    "dropmalzpp": 609339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2177492312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12853",
    "droptype": "D",
    "dropname": "ELLIS GROVE",
    "dropdeladd": "211 ELLIS BLVD",
    "dropdelcty": "ELLIS GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 622419998,
    "dropphyadd": "211 ELLIS BLVD",
    "dropphycty": "ELLIS GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 622419998,
    "dropmaladd": "211 ELLIS BLVD",
    "dropmalcty": "ELLIS GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 622419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188593341,
    "dropsitcph": 6188593341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12857",
    "droptype": "D",
    "dropname": "ELLISVILLE",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "ELLISVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 614319800,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "ELLISVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 614319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLISVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 614319998,
    "dropsitphn": 3092934682,
    "dropsitlph": 3092934682,
    "dropsitcph": 3092934682,
    "dropfax": 3092934682
  },
  {
    "dcode": "D",
    "dropkey": "PW12858",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "113 N MAIN ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "IL",
    "dropdelzpp": 617377544,
    "dropphyadd": "113 N MAIN ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "IL",
    "dropphyzpp": 617377544,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "IL",
    "dropmalzpp": 617379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097248231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12861",
    "droptype": "D",
    "dropname": "ELMHURST",
    "dropdeladd": "154 W PARK AVE",
    "dropdelcty": "ELMHURST",
    "dropdelst": "IL",
    "dropdelzpp": 601263380,
    "dropphyadd": "154 W PARK AVE",
    "dropphycty": "ELMHURST",
    "dropphyst": "IL",
    "dropphyzpp": 601263380,
    "dropmaladd": "154 W PARK AVE",
    "dropmalcty": "ELMHURST",
    "dropmalst": "IL",
    "dropmalzpp": 601263380,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308335375,
    "dropsitcph": 6308335375,
    "dropfax": 6308339898
  },
  {
    "dcode": "D",
    "dropkey": "PW12865",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "114 N MAGNOLIA ST",
    "dropdelcty": "ELMWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 615297929,
    "dropphyadd": "114 N MAGNOLIA ST",
    "dropphycty": "ELMWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 615297929,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 615299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097428022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12868",
    "droptype": "D",
    "dropname": "ELSAH",
    "dropdeladd": "48 MILL ST",
    "dropdelcty": "ELSAH",
    "dropdelst": "IL",
    "dropdelzpp": 620289998,
    "dropphyadd": "48 MILL ST",
    "dropphycty": "ELSAH",
    "dropphyst": "IL",
    "dropphyzpp": 620289998,
    "dropmaladd": "48 MILL ST",
    "dropmalcty": "ELSAH",
    "dropmalst": "IL",
    "dropmalzpp": 620289998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183742491,
    "dropsitcph": 6183742491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12871",
    "droptype": "D",
    "dropname": "ELVASTON",
    "dropdeladd": "104 W MAINE ST",
    "dropdelcty": "ELVASTON",
    "dropdelst": "IL",
    "dropdelzpp": 623349998,
    "dropphyadd": "104 W MAINE ST",
    "dropphycty": "ELVASTON",
    "dropphyst": "IL",
    "dropphyzpp": 623349998,
    "dropmaladd": "104 W MAINE ST",
    "dropmalcty": "ELVASTON",
    "dropmalst": "IL",
    "dropmalzpp": 623349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178453116,
    "dropsitcph": 2178453116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12873",
    "droptype": "D",
    "dropname": "ELWIN",
    "dropdeladd": "4945 S TAYLOR ST",
    "dropdelcty": "ELWIN",
    "dropdelst": "IL",
    "dropdelzpp": 625329998,
    "dropphyadd": "4945 S TAYLOR ST",
    "dropphycty": "ELWIN",
    "dropphyst": "IL",
    "dropphyzpp": 625329998,
    "dropmaladd": "4945 S TAYLOR ST",
    "dropmalcty": "ELWIN",
    "dropmalst": "IL",
    "dropmalzpp": 625329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178653231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12874",
    "droptype": "D",
    "dropname": "ELWOOD",
    "dropdeladd": "303 E MISSISSIPPI AVE",
    "dropdelcty": "ELWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 604219212,
    "dropphyadd": "303 E MISSISSIPPI AVE",
    "dropphycty": "ELWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 604219212,
    "dropmaladd": "303 E MISSISSIPPI AVE",
    "dropmalcty": "ELWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 604219212,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154235656,
    "dropfax": 8154235656
  },
  {
    "dcode": "D",
    "dropkey": "PW12875",
    "droptype": "D",
    "dropname": "EMDEN",
    "dropdeladd": "304 LINCOLN ST",
    "dropdelcty": "EMDEN",
    "dropdelst": "IL",
    "dropdelzpp": 626359998,
    "dropphyadd": "304 LINCOLN ST",
    "dropphycty": "EMDEN",
    "dropphyst": "IL",
    "dropphyzpp": 626359998,
    "dropmaladd": "304 LINCOLN ST",
    "dropmalcty": "EMDEN",
    "dropmalst": "IL",
    "dropmalzpp": 626359998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173763819,
    "dropfax": 2173763819
  },
  {
    "dcode": "D",
    "dropkey": "PW12877",
    "droptype": "D",
    "dropname": "EMINGTON",
    "dropdeladd": "107 1/2 WABASH ST",
    "dropdelcty": "EMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 609349800,
    "dropphyadd": "107 1/2 WABASH ST",
    "dropphycty": "EMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 609349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 609349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8159345424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12879",
    "droptype": "D",
    "dropname": "ENERGY",
    "dropdeladd": "208 N PERSHING ST",
    "dropdelcty": "ENERGY",
    "dropdelst": "IL",
    "dropdelzpp": 629339998,
    "dropphyadd": "208 N PERSHING ST",
    "dropphycty": "ENERGY",
    "dropphyst": "IL",
    "dropphyzpp": 629339998,
    "dropmaladd": "208 N PERSHING ST",
    "dropmalcty": "ENERGY",
    "dropmalst": "IL",
    "dropmalzpp": 629339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189423300,
    "dropsitcph": 6189423300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12880",
    "droptype": "D",
    "dropname": "ENFIELD",
    "dropdeladd": "114 E MAIN ST",
    "dropdelcty": "ENFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 628359998,
    "dropphyadd": "114 E MAIN ST",
    "dropphycty": "ENFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 628359998,
    "dropmaladd": "114 E MAIN ST",
    "dropmalcty": "ENFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 628359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189632447,
    "dropsitcph": 6189632447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12887",
    "droptype": "D",
    "dropname": "EOLA",
    "dropdeladd": "6S404 OLD EOLA RD",
    "dropdelcty": "EOLA",
    "dropdelst": "IL",
    "dropdelzpp": 605199800,
    "dropphyadd": "6S404 OLD EOLA RD",
    "dropphycty": "EOLA",
    "dropphyst": "IL",
    "dropphyzpp": 605199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EOLA",
    "dropmalst": "IL",
    "dropmalzpp": 605199998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6308512288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12890",
    "droptype": "D",
    "dropname": "EQUALITY",
    "dropdeladd": "205 W LANE ST",
    "dropdelcty": "EQUALITY",
    "dropdelst": "IL",
    "dropdelzpp": 629349998,
    "dropphyadd": "205 W LANE ST",
    "dropphycty": "EQUALITY",
    "dropphyst": "IL",
    "dropphyzpp": 629349998,
    "dropmaladd": "205 W LANE ST",
    "dropmalcty": "EQUALITY",
    "dropmalst": "IL",
    "dropmalzpp": 629349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182764215,
    "dropsitcph": 6182764215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12891",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "802 MAIN ST",
    "dropdelcty": "ERIE",
    "dropdelst": "IL",
    "dropdelzpp": 612507773,
    "dropphyadd": "802 MAIN ST",
    "dropphycty": "ERIE",
    "dropphyst": "IL",
    "dropphyzpp": 612507773,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ERIE",
    "dropmalst": "IL",
    "dropmalzpp": 612509998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3096592350,
    "dropsitcph": 3096592350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12893",
    "droptype": "D",
    "dropname": "ESMOND",
    "dropdeladd": "650 EYCHANER RD",
    "dropdelcty": "ESMOND",
    "dropdelst": "IL",
    "dropdelzpp": 601291000,
    "dropphyadd": "650 EYCHANER RD",
    "dropphycty": "ESMOND",
    "dropphyst": "IL",
    "dropphyzpp": 601291000,
    "dropmaladd": "650 EYCHANER RD",
    "dropmalcty": "ESMOND",
    "dropmalst": "IL",
    "dropmalzpp": 601291000,
    "dropsitphn": 8155223328,
    "dropsitlph": 8153934980,
    "dropsitcph": 8153934980,
    "dropfax": 8153934503
  },
  {
    "dcode": "D",
    "dropkey": "PW12894",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "ESSEX",
    "dropdelst": "IL",
    "dropdelzpp": 609359800,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "ESSEX",
    "dropphyst": "IL",
    "dropphyzpp": 609359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESSEX",
    "dropmalst": "IL",
    "dropmalzpp": 609359998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8153654260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12897",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "106 W EUREKA AVE",
    "dropdelcty": "EUREKA",
    "dropdelst": "IL",
    "dropdelzpp": 615301206,
    "dropphyadd": "106 W EUREKA AVE",
    "dropphycty": "EUREKA",
    "dropphyst": "IL",
    "dropphyzpp": 615301206,
    "dropmaladd": "106 W EUREKA AVE",
    "dropmalcty": "EUREKA",
    "dropmalst": "IL",
    "dropmalzpp": 615301206,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094672921,
    "dropfax": 3094674511
  },
  {
    "dcode": "D",
    "dropkey": "PW12900",
    "droptype": "D",
    "dropname": "EVANSTON",
    "dropdeladd": "1101 DAVIS ST",
    "dropdelcty": "EVANSTON",
    "dropdelst": "IL",
    "dropdelzpp": 602015945,
    "dropphyadd": "1101 DAVIS ST",
    "dropphycty": "EVANSTON",
    "dropphyst": "IL",
    "dropphyzpp": 602015945,
    "dropmaladd": "1101 DAVIS ST",
    "dropmalcty": "EVANSTON",
    "dropmalst": "IL",
    "dropmalzpp": 602019998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473286288,
    "dropsitcph": 8473286288,
    "dropfax": 8473286285
  },
  {
    "dcode": "D",
    "dropkey": "PW12903",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "402 LIBERTY ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622429998,
    "dropphyadd": "402 LIBERTY ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622429998,
    "dropmaladd": "402 LIBERTY ST",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622429998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188534415,
    "dropsitcph": 6188534415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12913",
    "droptype": "D",
    "dropname": "EWING",
    "dropdeladd": "22 MILL ST",
    "dropdelcty": "EWING",
    "dropdelst": "IL",
    "dropdelzpp": 628369998,
    "dropphyadd": "22 MILL ST",
    "dropphycty": "EWING",
    "dropphyst": "IL",
    "dropphyzpp": 628369998,
    "dropmaladd": "22 MILL ST",
    "dropmalcty": "EWING",
    "dropmalst": "IL",
    "dropmalzpp": 628369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186292593,
    "dropsitcph": 6186292593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12919",
    "droptype": "D",
    "dropname": "FAIRBURY",
    "dropdeladd": "127 E LOCUST ST",
    "dropdelcty": "FAIRBURY",
    "dropdelst": "IL",
    "dropdelzpp": 617399998,
    "dropphyadd": "127 E LOCUST ST",
    "dropphycty": "FAIRBURY",
    "dropphyst": "IL",
    "dropphyzpp": 617399998,
    "dropmaladd": "127 E LOCUST ST",
    "dropmalcty": "FAIRBURY",
    "dropmalst": "IL",
    "dropmalzpp": 617399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156922041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12921",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "220 E DELAWARE ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 628379997,
    "dropphyadd": "220 E DELAWARE ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 628379997,
    "dropmaladd": "220 E DELAWARE ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 628379997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188425126,
    "dropsitcph": 6188425126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12927",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "FAIRMOUNT",
    "dropdelst": "IL",
    "dropdelzpp": 618419998,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "FAIRMOUNT",
    "dropphyst": "IL",
    "dropphyzpp": 618419998,
    "dropmaladd": "106 S MAIN ST",
    "dropmalcty": "FAIRMOUNT",
    "dropmalst": "IL",
    "dropmalzpp": 618419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177332356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12931",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "520 CARTER ST",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 614329800,
    "dropphyadd": "520 CARTER ST",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 614329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 614329998,
    "dropsitphn": 3092454823,
    "dropsitlph": 3097782625,
    "dropsitcph": 3097782625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12945",
    "droptype": "D",
    "dropname": "FARINA",
    "dropdeladd": "306 W MADISON ST",
    "dropdelcty": "FARINA",
    "dropdelst": "IL",
    "dropdelzpp": 628389998,
    "dropphyadd": "306 W MADISON ST",
    "dropphycty": "FARINA",
    "dropphyst": "IL",
    "dropphyzpp": 628389998,
    "dropmaladd": "306 W MADISON ST",
    "dropmalcty": "FARINA",
    "dropmalst": "IL",
    "dropmalzpp": 628389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182456113,
    "dropsitcph": 6182456113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12947",
    "droptype": "D",
    "dropname": "FARMER CITY",
    "dropdeladd": "110 E GREEN ST",
    "dropdelcty": "FARMER CITY",
    "dropdelst": "IL",
    "dropdelzpp": 618429998,
    "dropphyadd": "110 E GREEN ST",
    "dropphycty": "FARMER CITY",
    "dropphyst": "IL",
    "dropphyzpp": 618429998,
    "dropmaladd": "110 E GREEN ST",
    "dropmalcty": "FARMER CITY",
    "dropmalst": "IL",
    "dropmalzpp": 618429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 3099283612,
    "dropfax": 3099282412
  },
  {
    "dcode": "D",
    "dropkey": "PW12948",
    "droptype": "D",
    "dropname": "FARMERSVILLE",
    "dropdeladd": "206 S CLEVELAND ST",
    "dropdelcty": "FARMERSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 625339998,
    "dropphyadd": "206 S CLEVELAND ST",
    "dropphycty": "FARMERSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 625339998,
    "dropmaladd": "206 S CLEVELAND ST",
    "dropmalcty": "FARMERSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 625339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172273614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12950",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "67 W FORT ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 615311296,
    "dropphyadd": "67 W FORT ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 615311296,
    "dropmaladd": "67 W FORT ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 615311296,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092454823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12958",
    "droptype": "D",
    "dropname": "FENTON",
    "dropdeladd": "9979 FENTON RD",
    "dropdelcty": "FENTON",
    "dropdelst": "IL",
    "dropdelzpp": 612519716,
    "dropphyadd": "9979 FENTON RD",
    "dropphycty": "FENTON",
    "dropphyst": "IL",
    "dropphyzpp": 612519716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENTON",
    "dropmalst": "IL",
    "dropmalzpp": 612519998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8157784869,
    "dropsitcph": 8157784869,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12962",
    "droptype": "D",
    "dropname": "FERRIS",
    "dropdeladd": "131 MAIN ST",
    "dropdelcty": "FERRIS",
    "dropdelst": "IL",
    "dropdelzpp": 623369998,
    "dropphyadd": "131 MAIN ST",
    "dropphycty": "FERRIS",
    "dropphyst": "IL",
    "dropphyzpp": 623369998,
    "dropmaladd": "131 MAIN ST",
    "dropmalcty": "FERRIS",
    "dropmalst": "IL",
    "dropmalzpp": 623369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177463051,
    "dropsitcph": 2177463051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12963",
    "droptype": "D",
    "dropname": "FIATT",
    "dropdeladd": "14279 E STATE ROUTE 9",
    "dropdelcty": "FIATT",
    "dropdelst": "IL",
    "dropdelzpp": 614339998,
    "dropphyadd": "14279 E STATE ROUTE 9",
    "dropphycty": "FIATT",
    "dropphyst": "IL",
    "dropphyzpp": 614339998,
    "dropmaladd": "14279 E STATE ROUTE 9",
    "dropmalcty": "FIATT",
    "dropmalst": "IL",
    "dropmalzpp": 614339998,
    "dropsitphn": 3097896506,
    "dropsitlph": 3097896506,
    "dropsitcph": 3097896506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12964",
    "droptype": "D",
    "dropname": "FIDELITY",
    "dropdeladd": "304 STATE ST",
    "dropdelcty": "FIDELITY",
    "dropdelst": "IL",
    "dropdelzpp": 620309998,
    "dropphyadd": "304 STATE ST",
    "dropphycty": "FIDELITY",
    "dropphyst": "IL",
    "dropphyzpp": 620309998,
    "dropmaladd": "304 STATE ST",
    "dropmalcty": "FIDELITY",
    "dropmalst": "IL",
    "dropmalzpp": 620309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187293793,
    "dropsitcph": 6187293793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12966",
    "droptype": "D",
    "dropname": "FIELDON",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "FIELDON",
    "dropdelst": "IL",
    "dropdelzpp": 620319998,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "FIELDON",
    "dropphyst": "IL",
    "dropphyzpp": 620319998,
    "dropmaladd": "110 E MAIN ST",
    "dropmalcty": "FIELDON",
    "dropmalst": "IL",
    "dropmalzpp": 620319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183763771,
    "dropsitcph": 6183763771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12967",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "FILLMORE",
    "dropdelst": "IL",
    "dropdelzpp": 620329998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "FILLMORE",
    "dropphyst": "IL",
    "dropphyzpp": 620329998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "FILLMORE",
    "dropmalst": "IL",
    "dropmalzpp": 620329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175382021,
    "dropsitcph": 2175382021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12968",
    "droptype": "D",
    "dropname": "FINDLAY",
    "dropdeladd": "215 E SOUTH 2ND ST",
    "dropdelcty": "FINDLAY",
    "dropdelst": "IL",
    "dropdelzpp": 625349998,
    "dropphyadd": "215 E SOUTH 2ND ST",
    "dropphycty": "FINDLAY",
    "dropphyst": "IL",
    "dropphyzpp": 625349998,
    "dropmaladd": "215 E SOUTH 2ND ST",
    "dropmalcty": "FINDLAY",
    "dropmalst": "IL",
    "dropmalzpp": 625349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2172621063,
    "dropsitcph": 2172621063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12972",
    "droptype": "D",
    "dropname": "FISHER",
    "dropdeladd": "102 N THIRD ST",
    "dropdelcty": "FISHER",
    "dropdelst": "IL",
    "dropdelzpp": 618439998,
    "dropphyadd": "102 N THIRD ST",
    "dropphycty": "FISHER",
    "dropphyst": "IL",
    "dropphyzpp": 618439998,
    "dropmaladd": "102 N THIRD ST",
    "dropmalcty": "FISHER",
    "dropmalst": "IL",
    "dropmalzpp": 618439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178971440,
    "dropfax": 2178971440
  },
  {
    "dcode": "D",
    "dropkey": "PW12973",
    "droptype": "D",
    "dropname": "FITHIAN",
    "dropdeladd": "204 N MAIN ST",
    "dropdelcty": "FITHIAN",
    "dropdelst": "IL",
    "dropdelzpp": 618449998,
    "dropphyadd": "204 N MAIN ST",
    "dropphycty": "FITHIAN",
    "dropphyst": "IL",
    "dropphyzpp": 618449998,
    "dropmaladd": "204 N MAIN ST",
    "dropmalcty": "FITHIAN",
    "dropmalst": "IL",
    "dropmalzpp": 618449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175482296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12976",
    "droptype": "D",
    "dropname": "FLANAGAN",
    "dropdeladd": "203 S MAIN ST",
    "dropdelcty": "FLANAGAN",
    "dropdelst": "IL",
    "dropdelzpp": 617407538,
    "dropphyadd": "203 S MAIN ST",
    "dropphycty": "FLANAGAN",
    "dropphyst": "IL",
    "dropphyzpp": 617407538,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLANAGAN",
    "dropmalst": "IL",
    "dropmalzpp": 617409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8157964188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12977",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "201 W 2ND ST",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "IL",
    "dropdelzpp": 624279998,
    "dropphyadd": "201 W 2ND ST",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "IL",
    "dropphyzpp": 624279998,
    "dropmaladd": "201 W 2ND ST",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "IL",
    "dropmalzpp": 624279998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185843781,
    "dropsitcph": 6185843781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12979",
    "droptype": "D",
    "dropname": "FLORA",
    "dropdeladd": "312 E NORTH AVE",
    "dropdelcty": "FLORA",
    "dropdelst": "IL",
    "dropdelzpp": 628399998,
    "dropphyadd": "312 E NORTH AVE",
    "dropphycty": "FLORA",
    "dropphyst": "IL",
    "dropphyzpp": 628399998,
    "dropmaladd": "312 E NORTH AVE",
    "dropmalcty": "FLORA",
    "dropmalst": "IL",
    "dropmalzpp": 628399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186625626,
    "dropsitcph": 6186625626,
    "dropfax": 6186627223
  },
  {
    "dcode": "D",
    "dropkey": "PW12984",
    "droptype": "D",
    "dropname": "FLOSSMOOR",
    "dropdeladd": "1020 PARK DR",
    "dropdelcty": "FLOSSMOOR",
    "dropdelst": "IL",
    "dropdelzpp": 604229998,
    "dropphyadd": "1020 PARK DR",
    "dropphycty": "FLOSSMOOR",
    "dropphyst": "IL",
    "dropphyzpp": 604229998,
    "dropmaladd": "1020 PARK DR",
    "dropmalcty": "FLOSSMOOR",
    "dropmalst": "IL",
    "dropmalzpp": 604229998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087998573,
    "dropfax": 7087999882
  },
  {
    "dcode": "D",
    "dropkey": "PW12986",
    "droptype": "D",
    "dropname": "FOOSLAND",
    "dropdeladd": "202 2ND ST",
    "dropdelcty": "FOOSLAND",
    "dropdelst": "IL",
    "dropdelzpp": 618459998,
    "dropphyadd": "202 2ND ST",
    "dropphycty": "FOOSLAND",
    "dropphyst": "IL",
    "dropphyzpp": 618459998,
    "dropmaladd": "202 2ND ST",
    "dropmalcty": "FOOSLAND",
    "dropmalst": "IL",
    "dropmalzpp": 618459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178463256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12989",
    "droptype": "D",
    "dropname": "FOREST CITY",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "FOREST CITY",
    "dropdelst": "IL",
    "dropdelzpp": 615329800,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "FOREST CITY",
    "dropphyst": "IL",
    "dropphyzpp": 615329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOREST CITY",
    "dropmalst": "IL",
    "dropmalzpp": 615329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3095972363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12991",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "417 DES PLAINES AVE",
    "dropdelcty": "FOREST PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601301798,
    "dropphyadd": "417 DES PLAINES AVE",
    "dropphycty": "FOREST PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601301798,
    "dropmaladd": "417 DES PLAINES AVE",
    "dropmalcty": "FOREST PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601301798,
    "dropsitphn": 7083865831,
    "dropsitlph": 7083665790,
    "dropsitcph": 7083665790,
    "dropfax": 7083661564
  },
  {
    "dcode": "D",
    "dropkey": "PW12994",
    "droptype": "D",
    "dropname": "FORREST",
    "dropdeladd": "202 E KRACK ST",
    "dropdelcty": "FORREST",
    "dropdelst": "IL",
    "dropdelzpp": 617419345,
    "dropphyadd": "202 E KRACK ST",
    "dropphycty": "FORREST",
    "dropphyst": "IL",
    "dropphyzpp": 617419345,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORREST",
    "dropmalst": "IL",
    "dropmalzpp": 617419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 8156571005,
    "dropsitcph": 8156571006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW12995",
    "droptype": "D",
    "dropname": "FORRESTON",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "FORRESTON",
    "dropdelst": "IL",
    "dropdelzpp": 610309470,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "FORRESTON",
    "dropphyst": "IL",
    "dropphyzpp": 610309470,
    "dropmaladd": "210 E MAIN ST",
    "dropmalcty": "FORRESTON",
    "dropmalst": "IL",
    "dropmalzpp": 610309470,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159382161,
    "dropsitcph": 8159382161,
    "dropfax": 8159383563
  },
  {
    "dcode": "D",
    "dropkey": "PW12996",
    "droptype": "D",
    "dropname": "FORSYTH",
    "dropdeladd": "300 E RUEHL ST",
    "dropdelcty": "FORSYTH",
    "dropdelst": "IL",
    "dropdelzpp": 625359998,
    "dropphyadd": "300 E RUEHL ST",
    "dropphycty": "FORSYTH",
    "dropphyst": "IL",
    "dropphyzpp": 625359998,
    "dropmaladd": "300 E RUEHL ST",
    "dropmalcty": "FORSYTH",
    "dropmalst": "IL",
    "dropmalzpp": 625359998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178779684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13009",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "1321 HIGHWAY 24",
    "dropdelcty": "FOWLER",
    "dropdelst": "IL",
    "dropdelzpp": 623389998,
    "dropphyadd": "1321 HIGHWAY 24",
    "dropphycty": "FOWLER",
    "dropphyst": "IL",
    "dropphyzpp": 623389998,
    "dropmaladd": "1321 HIGHWAY 24",
    "dropmalcty": "FOWLER",
    "dropmalst": "IL",
    "dropmalzpp": 623389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174348400,
    "dropsitcph": 2174348400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13010",
    "droptype": "D",
    "dropname": "FOX LAKE",
    "dropdeladd": "33 E GRAND AVE",
    "dropdelcty": "FOX LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600201449,
    "dropphyadd": "33 E GRAND AVE",
    "dropphycty": "FOX LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600201449,
    "dropmaladd": "33 E GRAND AVE",
    "dropmalcty": "FOX LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600201449,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475870243,
    "dropsitcph": 8475870243,
    "dropfax": 8475872186
  },
  {
    "dcode": "D",
    "dropkey": "PW13014",
    "droptype": "D",
    "dropname": "FOX RIVER GROVE",
    "dropdeladd": "938 IL ROUTE 22",
    "dropdelcty": "FOX RIVER GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 600211918,
    "dropphyadd": "938 IL ROUTE 22",
    "dropphycty": "FOX RIVER GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 600211918,
    "dropmaladd": "938 IL ROUTE 22",
    "dropmalcty": "FOX RIVER GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 600211918,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476393150,
    "dropsitcph": 8476393150,
    "dropfax": 8476390222
  },
  {
    "dcode": "D",
    "dropkey": "PW13019",
    "droptype": "D",
    "dropname": "FOX VALLEY",
    "dropdeladd": "3900 GABRIELLE LN",
    "dropdelcty": "FOX VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 605999998,
    "dropphyadd": "3900 GABRIELLE LN",
    "dropphycty": "FOX VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 605999998,
    "dropmaladd": "3900 GABRIELLE LN",
    "dropmalcty": "FOX VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 605999998,
    "dropsitphn": 6309784432,
    "dropsitlph": 6309784432,
    "dropsitcph": 6309784432,
    "dropfax": 6309784336
  },
  {
    "dcode": "D",
    "dropkey": "PW13024",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "21201 S ELSNER RD",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "IL",
    "dropdelzpp": 604239998,
    "dropphyadd": "21201 S ELSNER RD",
    "dropphycty": "FRANKFORT",
    "dropphyst": "IL",
    "dropphyzpp": 604239998,
    "dropmaladd": "21201 S ELSNER RD",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "IL",
    "dropmalzpp": 604239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154695786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13026",
    "droptype": "D",
    "dropname": "FRANKFORT HEIGHTS",
    "dropdeladd": "1711 E MAIN ST",
    "dropdelcty": "FRANKFORT HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 628401000,
    "dropphyadd": "1711 E MAIN ST",
    "dropphycty": "FRANKFORT HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 628401000,
    "dropmaladd": "1711 E MAIN ST",
    "dropmalcty": "FRANKFORT HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 628401000,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189372051,
    "dropsitcph": 6189374161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13030",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "312 WYATT AVE",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "IL",
    "dropdelzpp": 626389998,
    "dropphyadd": "312 WYATT AVE",
    "dropphycty": "FRANKLIN",
    "dropphyst": "IL",
    "dropphyzpp": 626389998,
    "dropmaladd": "312 WYATT AVE",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "IL",
    "dropmalzpp": 626389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176752321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13031",
    "droptype": "D",
    "dropname": "FRANKLIN GROVE",
    "dropdeladd": "113 S ELM ST",
    "dropdelcty": "FRANKLIN GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 610319788,
    "dropphyadd": "113 S ELM ST",
    "dropphycty": "FRANKLIN GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 610319788,
    "dropmaladd": "113 S ELM ST",
    "dropmalcty": "FRANKLIN GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 610319788,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154562132,
    "dropsitcph": 8154562132,
    "dropfax": 8154562918
  },
  {
    "dcode": "D",
    "dropkey": "PW13034",
    "droptype": "D",
    "dropname": "FRANKLIN PARK",
    "dropdeladd": "9760 FRANKLIN AVE",
    "dropdelcty": "FRANKLIN PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601311786,
    "dropphyadd": "9760 FRANKLIN AVE",
    "dropphycty": "FRANKLIN PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601311786,
    "dropmaladd": "9760 FRANKLIN AVE",
    "dropmalcty": "FRANKLIN PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601311786,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474555396,
    "dropsitcph": 8474555396,
    "dropfax": 8474553610
  },
  {
    "dcode": "D",
    "dropkey": "PW13037",
    "droptype": "D",
    "dropname": "FREEBURG",
    "dropdeladd": "3 S BELLEVILLE ST",
    "dropdelcty": "FREEBURG",
    "dropdelst": "IL",
    "dropdelzpp": 622439998,
    "dropphyadd": "3 S BELLEVILLE ST",
    "dropphycty": "FREEBURG",
    "dropphyst": "IL",
    "dropphyzpp": 622439998,
    "dropmaladd": "3 S BELLEVILLE ST",
    "dropmalcty": "FREEBURG",
    "dropmalst": "IL",
    "dropmalzpp": 622439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185393191,
    "dropsitcph": 6185393191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13038",
    "droptype": "D",
    "dropname": "FREEMAN SPUR",
    "dropdeladd": "19072 FREEMAN SPUR RD",
    "dropdelcty": "FREEMAN SPUR",
    "dropdelst": "IL",
    "dropdelzpp": 628419998,
    "dropphyadd": "19072 FREEMAN SPUR RD",
    "dropphycty": "FREEMAN SPUR",
    "dropphyst": "IL",
    "dropphyzpp": 628419998,
    "dropmaladd": "19072 FREEMAN SPUR RD",
    "dropmalcty": "FREEMAN SPUR",
    "dropmalst": "IL",
    "dropmalzpp": 628419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189881454,
    "dropsitcph": 6189881454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13039",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "103 N CHICAGO AVE FL 1",
    "dropdelcty": "FREEPORT",
    "dropdelst": "IL",
    "dropdelzpp": 610329998,
    "dropphyadd": "103 N CHICAGO AVE FL 1",
    "dropphycty": "FREEPORT",
    "dropphyst": "IL",
    "dropphyzpp": 610329998,
    "dropmaladd": "103 N CHICAGO AVE FL 1",
    "dropmalcty": "FREEPORT",
    "dropmalst": "IL",
    "dropmalzpp": 610329998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152327119,
    "dropsitcph": 8152327119,
    "dropfax": 8152327177
  },
  {
    "dcode": "D",
    "dropkey": "PW13047",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "915 4TH ST",
    "dropdelcty": "FULTON",
    "dropdelst": "IL",
    "dropdelzpp": 612529998,
    "dropphyadd": "915 4TH ST",
    "dropphycty": "FULTON",
    "dropphyst": "IL",
    "dropphyzpp": 612529998,
    "dropmaladd": "915 4TH ST",
    "dropmalcty": "FULTON",
    "dropmalst": "IL",
    "dropmalzpp": 612529998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8155892020,
    "dropsitcph": 8155892020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13048",
    "droptype": "D",
    "dropname": "FULTS",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "FULTS",
    "dropdelst": "IL",
    "dropdelzpp": 622449998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "FULTS",
    "dropphyst": "IL",
    "dropphyzpp": 622449998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "FULTS",
    "dropmalst": "IL",
    "dropmalzpp": 622449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184586592,
    "dropsitcph": 6184586592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13054",
    "droptype": "D",
    "dropname": "GALATIA",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "GALATIA",
    "dropdelst": "IL",
    "dropdelzpp": 629359998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "GALATIA",
    "dropphyst": "IL",
    "dropphyzpp": 629359998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "GALATIA",
    "dropmalst": "IL",
    "dropmalzpp": 629359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182684933,
    "dropsitcph": 6182684933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13056",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "110 GREEN ST",
    "dropdelcty": "GALENA",
    "dropdelst": "IL",
    "dropdelzpp": 610362247,
    "dropphyadd": "110 GREEN ST",
    "dropphycty": "GALENA",
    "dropphyst": "IL",
    "dropphyzpp": 610362247,
    "dropmaladd": "110 GREEN ST",
    "dropmalcty": "GALENA",
    "dropmalst": "IL",
    "dropmalzpp": 610362247,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157770225,
    "dropsitcph": 8157770225,
    "dropfax": 8157771293
  },
  {
    "dcode": "D",
    "dropkey": "PW13059",
    "droptype": "D",
    "dropname": "GALESBURG",
    "dropdeladd": "476 E MAIN ST STE A",
    "dropdelcty": "GALESBURG",
    "dropdelst": "IL",
    "dropdelzpp": 614019998,
    "dropphyadd": "476 E MAIN ST STE A",
    "dropphycty": "GALESBURG",
    "dropphyst": "IL",
    "dropphyzpp": 614019998,
    "dropmaladd": "476 E MAIN ST STE A",
    "dropmalcty": "GALESBURG",
    "dropmalst": "IL",
    "dropmalzpp": 614019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3093426166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13060",
    "droptype": "D",
    "dropname": "GALT",
    "dropdeladd": "411 GALT RD",
    "dropdelcty": "GALT",
    "dropdelst": "IL",
    "dropdelzpp": 610379800,
    "dropphyadd": "411 GALT RD",
    "dropphycty": "GALT",
    "dropphyst": "IL",
    "dropphyzpp": 610379800,
    "dropmaladd": "411 GALT RD",
    "dropmalcty": "GALT",
    "dropmalst": "IL",
    "dropmalzpp": 610379800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156265270,
    "dropsitcph": 8156265270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13061",
    "droptype": "D",
    "dropname": "GALVA",
    "dropdeladd": "116 EXCHANGE ST",
    "dropdelcty": "GALVA",
    "dropdelst": "IL",
    "dropdelzpp": 614349800,
    "dropphyadd": "116 EXCHANGE ST",
    "dropphycty": "GALVA",
    "dropphyst": "IL",
    "dropphyzpp": 614349800,
    "dropmaladd": "116 EXCHANGE ST",
    "dropmalcty": "GALVA",
    "dropmalst": "IL",
    "dropmalzpp": 614349800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3099323120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13068",
    "droptype": "D",
    "dropname": "GARDEN PRAIRIE",
    "dropdeladd": "6820 PLEASANT ST",
    "dropdelcty": "GARDEN PRAIRIE",
    "dropdelst": "IL",
    "dropdelzpp": 610389998,
    "dropphyadd": "6820 PLEASANT ST",
    "dropphycty": "GARDEN PRAIRIE",
    "dropphyst": "IL",
    "dropphyzpp": 610389998,
    "dropmaladd": "6820 PLEASANT ST",
    "dropmalcty": "GARDEN PRAIRIE",
    "dropmalst": "IL",
    "dropmalzpp": 610389998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155972941,
    "dropsitcph": 8155972941,
    "dropfax": 8155971502
  },
  {
    "dcode": "D",
    "dropkey": "PW13069",
    "droptype": "D",
    "dropname": "GARDNER",
    "dropdeladd": "106 E JEFFERSON ST",
    "dropdelcty": "GARDNER",
    "dropdelst": "IL",
    "dropdelzpp": 604249998,
    "dropphyadd": "106 E JEFFERSON ST",
    "dropphycty": "GARDNER",
    "dropphyst": "IL",
    "dropphyzpp": 604249998,
    "dropmaladd": "106 E JEFFERSON ST",
    "dropmalcty": "GARDNER",
    "dropmalst": "IL",
    "dropmalzpp": 604249998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152372262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13076",
    "droptype": "D",
    "dropname": "GEFF",
    "dropdeladd": "124 W MECHANIC ST",
    "dropdelcty": "GEFF",
    "dropdelst": "IL",
    "dropdelzpp": 628429998,
    "dropphyadd": "124 W MECHANIC ST",
    "dropphycty": "GEFF",
    "dropphyst": "IL",
    "dropphyzpp": 628429998,
    "dropmaladd": "124 W MECHANIC ST",
    "dropmalcty": "GEFF",
    "dropmalst": "IL",
    "dropmalzpp": 628429998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188972271,
    "dropsitcph": 6188972271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13079",
    "droptype": "D",
    "dropname": "GENESEO",
    "dropdeladd": "120 W 1ST ST",
    "dropdelcty": "GENESEO",
    "dropdelst": "IL",
    "dropdelzpp": 612549998,
    "dropphyadd": "120 W 1ST ST",
    "dropphycty": "GENESEO",
    "dropphyst": "IL",
    "dropphyzpp": 612549998,
    "dropmaladd": "120 W 1ST ST",
    "dropmalcty": "GENESEO",
    "dropmalst": "IL",
    "dropmalzpp": 612549998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3099443497,
    "dropsitcph": 3099442560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13080",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "26 S 3RD ST",
    "dropdelcty": "GENEVA",
    "dropdelst": "IL",
    "dropdelzpp": 601342271,
    "dropphyadd": "26 S 3RD ST",
    "dropphycty": "GENEVA",
    "dropphyst": "IL",
    "dropphyzpp": 601342271,
    "dropmaladd": "26 S 3RD ST",
    "dropmalcty": "GENEVA",
    "dropmalst": "IL",
    "dropmalzpp": 601342271,
    "dropsitphn": 6302605499,
    "dropsitlph": 6302326262,
    "dropsitcph": 6302326262,
    "dropfax": 6302322529
  },
  {
    "dcode": "D",
    "dropkey": "PW13081",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "705 PEARSON DR",
    "dropdelcty": "GENOA",
    "dropdelst": "IL",
    "dropdelzpp": 601351366,
    "dropphyadd": "705 PEARSON DR",
    "dropphycty": "GENOA",
    "dropphyst": "IL",
    "dropphyzpp": 601351366,
    "dropmaladd": "705 PEARSON DR",
    "dropmalcty": "GENOA",
    "dropmalst": "IL",
    "dropmalzpp": 601351366,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157843349,
    "dropsitcph": 8157843349,
    "dropfax": 8157845814
  },
  {
    "dcode": "D",
    "dropkey": "PW13082",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "111 E WEST ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "IL",
    "dropdelzpp": 618469998,
    "dropphyadd": "111 E WEST ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "IL",
    "dropphyzpp": 618469998,
    "dropmaladd": "111 E WEST ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "IL",
    "dropmalzpp": 618469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176628729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13085",
    "droptype": "D",
    "dropname": "GERMAN VALLEY",
    "dropdeladd": "35 CHURCH ST",
    "dropdelcty": "GERMAN VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 610399536,
    "dropphyadd": "35 CHURCH ST",
    "dropphycty": "GERMAN VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 610399536,
    "dropmaladd": "35 CHURCH ST",
    "dropmalcty": "GERMAN VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 610399536,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153623421,
    "dropsitcph": 8153623421,
    "dropfax": 8153625006
  },
  {
    "dcode": "D",
    "dropkey": "PW13087",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "405 MUNSTER ST",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 622459998,
    "dropphyadd": "405 MUNSTER ST",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 622459998,
    "dropmaladd": "405 MUNSTER ST",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 622459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185234726,
    "dropsitcph": 6185234726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13091",
    "droptype": "D",
    "dropname": "GIBSON CITY",
    "dropdeladd": "127 E 9TH ST",
    "dropdelcty": "GIBSON CITY",
    "dropdelst": "IL",
    "dropdelzpp": 609369998,
    "dropphyadd": "127 E 9TH ST",
    "dropphycty": "GIBSON CITY",
    "dropphyst": "IL",
    "dropphyzpp": 609369998,
    "dropmaladd": "127 E 9TH ST",
    "dropmalcty": "GIBSON CITY",
    "dropmalst": "IL",
    "dropmalzpp": 609369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177845260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13094",
    "droptype": "D",
    "dropname": "GIFFORD",
    "dropdeladd": "213 S MAIN ST",
    "dropdelcty": "GIFFORD",
    "dropdelst": "IL",
    "dropdelzpp": 618479998,
    "dropphyadd": "213 S MAIN ST",
    "dropphycty": "GIFFORD",
    "dropphyst": "IL",
    "dropphyzpp": 618479998,
    "dropmaladd": "213 S MAIN ST",
    "dropmalcty": "GIFFORD",
    "dropmalst": "IL",
    "dropmalzpp": 618479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175687975,
    "dropfax": 2175687251
  },
  {
    "dcode": "D",
    "dropkey": "PW13096",
    "droptype": "D",
    "dropname": "GILBERTS",
    "dropdeladd": "57 RAILROAD ST",
    "dropdelcty": "GILBERTS",
    "dropdelst": "IL",
    "dropdelzpp": 601369670,
    "dropphyadd": "57 RAILROAD ST",
    "dropphycty": "GILBERTS",
    "dropphyst": "IL",
    "dropphyzpp": 601369670,
    "dropmaladd": "57 RAILROAD ST",
    "dropmalcty": "GILBERTS",
    "dropmalst": "IL",
    "dropmalzpp": 601369670,
    "dropsitphn": 8475158042,
    "dropsitlph": 8474266313,
    "dropsitcph": 8474266313,
    "dropfax": 8474266359
  },
  {
    "dcode": "D",
    "dropkey": "PW13099",
    "droptype": "D",
    "dropname": "GILLESPIE",
    "dropdeladd": "200 W SPRUCE ST",
    "dropdelcty": "GILLESPIE",
    "dropdelst": "IL",
    "dropdelzpp": 620339998,
    "dropphyadd": "200 W SPRUCE ST",
    "dropphycty": "GILLESPIE",
    "dropphyst": "IL",
    "dropphyzpp": 620339998,
    "dropmaladd": "200 W SPRUCE ST",
    "dropmalcty": "GILLESPIE",
    "dropmalst": "IL",
    "dropmalzpp": 620339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178393020,
    "dropsitcph": 2178393020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13101",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "204 N CENTRAL ST",
    "dropdelcty": "GILMAN",
    "dropdelst": "IL",
    "dropdelzpp": 609389998,
    "dropphyadd": "204 N CENTRAL ST",
    "dropphycty": "GILMAN",
    "dropphyst": "IL",
    "dropphyzpp": 609389998,
    "dropmaladd": "204 N CENTRAL ST",
    "dropmalcty": "GILMAN",
    "dropmalst": "IL",
    "dropmalzpp": 609389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152654242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13103",
    "droptype": "D",
    "dropname": "GILSON",
    "dropdeladd": "1016 MOSS ST",
    "dropdelcty": "GILSON",
    "dropdelst": "IL",
    "dropdelzpp": 614369800,
    "dropphyadd": "1016 MOSS ST",
    "dropphycty": "GILSON",
    "dropphyst": "IL",
    "dropphyzpp": 614369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILSON",
    "dropmalst": "IL",
    "dropmalzpp": 614369998,
    "dropsitphn": 3098762270,
    "dropsitlph": 3098762270,
    "dropsitcph": 3098762270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13105",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "153 S 2ND ST",
    "dropdelcty": "GIRARD",
    "dropdelst": "IL",
    "dropdelzpp": 626409998,
    "dropphyadd": "153 S 2ND ST",
    "dropphycty": "GIRARD",
    "dropphyst": "IL",
    "dropphyzpp": 626409998,
    "dropmaladd": "153 S 2ND ST",
    "dropmalcty": "GIRARD",
    "dropmalst": "IL",
    "dropmalzpp": 626409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176273016,
    "dropfax": 2176273016
  },
  {
    "dcode": "D",
    "dropkey": "PW13106",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "306 S MAIN ST",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "IL",
    "dropdelzpp": 614375110,
    "dropphyadd": "306 S MAIN ST",
    "dropphycty": "GLADSTONE",
    "dropphyst": "IL",
    "dropphyzpp": 614375110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "IL",
    "dropmalzpp": 614379998,
    "dropsitphn": 3096272766,
    "dropsitlph": 3096272766,
    "dropsitcph": 3096272766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13107",
    "droptype": "D",
    "dropname": "GLASFORD",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "GLASFORD",
    "dropdelst": "IL",
    "dropdelzpp": 615338979,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "GLASFORD",
    "dropphyst": "IL",
    "dropphyzpp": 615338979,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLASFORD",
    "dropmalst": "IL",
    "dropmalzpp": 615339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093893611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13112",
    "droptype": "D",
    "dropname": "GLEN CARBON",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "GLEN CARBON",
    "dropdelst": "IL",
    "dropdelzpp": 620349998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "GLEN CARBON",
    "dropphyst": "IL",
    "dropphyzpp": 620349998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "GLEN CARBON",
    "dropmalst": "IL",
    "dropmalzpp": 620349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182889503,
    "dropsitcph": 6182889503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13113",
    "droptype": "D",
    "dropname": "GLEN ELLYN",
    "dropdeladd": "757 DU PAGE BLVD",
    "dropdelcty": "GLEN ELLYN",
    "dropdelst": "IL",
    "dropdelzpp": 601379998,
    "dropphyadd": "757 DU PAGE BLVD",
    "dropphycty": "GLEN ELLYN",
    "dropphyst": "IL",
    "dropphyzpp": 601379998,
    "dropmaladd": "757 DU PAGE BLVD",
    "dropmalcty": "GLEN ELLYN",
    "dropmalst": "IL",
    "dropmalzpp": 601379998,
    "dropsitphn": 6302605499,
    "dropsitlph": 6304691166,
    "dropsitcph": 6304691166,
    "dropfax": 6304691053
  },
  {
    "dcode": "D",
    "dropkey": "PW13117",
    "droptype": "D",
    "dropname": "GLENARM",
    "dropdeladd": "53 JUDD RD",
    "dropdelcty": "GLENARM",
    "dropdelst": "IL",
    "dropdelzpp": 625369998,
    "dropphyadd": "53 JUDD RD",
    "dropphycty": "GLENARM",
    "dropphyst": "IL",
    "dropphyzpp": 625369998,
    "dropmaladd": "53 JUDD RD",
    "dropmalcty": "GLENARM",
    "dropmalst": "IL",
    "dropmalzpp": 625369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174832357,
    "dropfax": 2174832357
  },
  {
    "dcode": "D",
    "dropkey": "PW13119",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "336 HAZEL AVE",
    "dropdelcty": "GLENCOE",
    "dropdelst": "IL",
    "dropdelzpp": 600222600,
    "dropphyadd": "336 HAZEL AVE",
    "dropphycty": "GLENCOE",
    "dropphyst": "IL",
    "dropphyzpp": 600222600,
    "dropmaladd": "336 HAZEL AVE",
    "dropmalcty": "GLENCOE",
    "dropmalst": "IL",
    "dropmalzpp": 600222600,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478350899,
    "dropsitcph": 8478350899,
    "dropfax": 8478350509
  },
  {
    "dcode": "D",
    "dropkey": "PW13125",
    "droptype": "D",
    "dropname": "GLENVIEW",
    "dropdeladd": "1400 PATRIOT BLVD",
    "dropdelcty": "GLENVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 600267702,
    "dropphyadd": "1400 PATRIOT BLVD",
    "dropphycty": "GLENVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 600267702,
    "dropmaladd": "1400 PATRIOT BLVD",
    "dropmalcty": "GLENVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 600267702,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478324693,
    "dropsitcph": 8478324693,
    "dropfax": 8478324695
  },
  {
    "dcode": "D",
    "dropkey": "PW13129",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "19 W MAIN ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 604259998,
    "dropphyadd": "19 W MAIN ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 604259998,
    "dropmaladd": "19 W MAIN ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 604259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7087585170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13131",
    "droptype": "D",
    "dropname": "GODFREY",
    "dropdeladd": "400 TOLLE LN",
    "dropdelcty": "GODFREY",
    "dropdelst": "IL",
    "dropdelzpp": 620359998,
    "dropphyadd": "400 TOLLE LN",
    "dropphycty": "GODFREY",
    "dropphyst": "IL",
    "dropphyzpp": 620359998,
    "dropmaladd": "400 TOLLE LN",
    "dropmalcty": "GODFREY",
    "dropmalst": "IL",
    "dropmalzpp": 620359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184663121,
    "dropsitcph": 6184663121,
    "dropfax": 6184665172
  },
  {
    "dcode": "D",
    "dropkey": "PW13133",
    "droptype": "D",
    "dropname": "GOLCONDA",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "GOLCONDA",
    "dropdelst": "IL",
    "dropdelzpp": 629389998,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "GOLCONDA",
    "dropphyst": "IL",
    "dropphyzpp": 629389998,
    "dropmaladd": "202 W MAIN ST",
    "dropmalcty": "GOLCONDA",
    "dropmalst": "IL",
    "dropmalzpp": 629389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186833231,
    "dropsitcph": 6186833231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13135",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "305 SMITH ST",
    "dropdelcty": "GOLDEN",
    "dropdelst": "IL",
    "dropdelzpp": 623399998,
    "dropphyadd": "305 SMITH ST",
    "dropphycty": "GOLDEN",
    "dropphyst": "IL",
    "dropphyzpp": 623399998,
    "dropmaladd": "305 SMITH ST",
    "dropmalcty": "GOLDEN",
    "dropmalst": "IL",
    "dropmalzpp": 623399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176962570,
    "dropsitcph": 2176962570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13139",
    "droptype": "D",
    "dropname": "GOLF",
    "dropdeladd": "1 BRIAR RD",
    "dropdelcty": "GOLF",
    "dropdelst": "IL",
    "dropdelzpp": 600299998,
    "dropphyadd": "1 BRIAR RD",
    "dropphycty": "GOLF",
    "dropphyst": "IL",
    "dropphyzpp": 600299998,
    "dropmaladd": "1 BRIAR RD",
    "dropmalcty": "GOLF",
    "dropmalst": "IL",
    "dropmalzpp": 600299998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477291666,
    "dropsitcph": 8477291666,
    "dropfax": 8477291666
  },
  {
    "dcode": "D",
    "dropkey": "PW13140",
    "droptype": "D",
    "dropname": "GOOD HOPE",
    "dropdeladd": "125 W MAIN ST",
    "dropdelcty": "GOOD HOPE",
    "dropdelst": "IL",
    "dropdelzpp": 614389800,
    "dropphyadd": "125 W MAIN ST",
    "dropphycty": "GOOD HOPE",
    "dropphyst": "IL",
    "dropphyzpp": 614389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOOD HOPE",
    "dropmalst": "IL",
    "dropmalzpp": 614389998,
    "dropsitphn": 3096523181,
    "dropsitlph": 3094563561,
    "dropsitcph": 3094563561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13143",
    "droptype": "D",
    "dropname": "GOODFIELD",
    "dropdeladd": "208 E PEORIA ST",
    "dropdelcty": "GOODFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 617429900,
    "dropphyadd": "208 E PEORIA ST",
    "dropphycty": "GOODFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 617429900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 617429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099652621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13144",
    "droptype": "D",
    "dropname": "GOODWINE",
    "dropdeladd": "553 N 1800 EAST RD",
    "dropdelcty": "GOODWINE",
    "dropdelst": "IL",
    "dropdelzpp": 609399998,
    "dropphyadd": "553 N 1800 EAST RD",
    "dropphycty": "GOODWINE",
    "dropphyst": "IL",
    "dropphyzpp": 609399998,
    "dropmaladd": "553 N 1800 EAST RD",
    "dropmalcty": "GOODWINE",
    "dropmalst": "IL",
    "dropmalzpp": 609399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154572773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13147",
    "droptype": "D",
    "dropname": "GOREVILLE",
    "dropdeladd": "117 S BROADWAY",
    "dropdelcty": "GOREVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 629399998,
    "dropphyadd": "117 S BROADWAY",
    "dropphycty": "GOREVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 629399998,
    "dropmaladd": "117 S BROADWAY",
    "dropmalcty": "GOREVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 629399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189952642,
    "dropsitcph": 6189952642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13150",
    "droptype": "D",
    "dropname": "GORHAM",
    "dropdeladd": "407 MAIN ST",
    "dropdelcty": "GORHAM",
    "dropdelst": "IL",
    "dropdelzpp": 629409998,
    "dropphyadd": "407 MAIN ST",
    "dropphycty": "GORHAM",
    "dropphyst": "IL",
    "dropphyzpp": 629409998,
    "dropmaladd": "407 MAIN ST",
    "dropmalcty": "GORHAM",
    "dropmalst": "IL",
    "dropmalzpp": 629409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185652042,
    "dropsitcph": 6185652042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13157",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "419 E MAIN ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "IL",
    "dropdelzpp": 620379998,
    "dropphyadd": "419 E MAIN ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "IL",
    "dropphyzpp": 620379998,
    "dropmaladd": "419 E MAIN ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "IL",
    "dropmalzpp": 620379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182324026,
    "dropsitcph": 6182324026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13158",
    "droptype": "D",
    "dropname": "GRAND CHAIN",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "GRAND CHAIN",
    "dropdelst": "IL",
    "dropdelzpp": 629419998,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "GRAND CHAIN",
    "dropphyst": "IL",
    "dropphyzpp": 629419998,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "GRAND CHAIN",
    "dropmalst": "IL",
    "dropmalzpp": 629419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186342320,
    "dropsitcph": 6186342320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13164",
    "droptype": "D",
    "dropname": "GRAND RIDGE",
    "dropdeladd": "150 W MAIN ST",
    "dropdelcty": "GRAND RIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 613259800,
    "dropphyadd": "150 W MAIN ST",
    "dropphycty": "GRAND RIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 613259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 613259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8152495520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13165",
    "droptype": "D",
    "dropname": "GRAND TOWER",
    "dropdeladd": "522 FRONT ST",
    "dropdelcty": "GRAND TOWER",
    "dropdelst": "IL",
    "dropdelzpp": 629429998,
    "dropphyadd": "522 FRONT ST",
    "dropphycty": "GRAND TOWER",
    "dropphyst": "IL",
    "dropphyzpp": 629429998,
    "dropmaladd": "522 FRONT ST",
    "dropmalcty": "GRAND TOWER",
    "dropmalst": "IL",
    "dropmalzpp": 629429998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185652332,
    "dropsitcph": 6185652332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13168",
    "droptype": "D",
    "dropname": "GRANITE CITY",
    "dropdeladd": "2350 MADISON AVE",
    "dropdelcty": "GRANITE CITY",
    "dropdelst": "IL",
    "dropdelzpp": 620409998,
    "dropphyadd": "2350 MADISON AVE",
    "dropphycty": "GRANITE CITY",
    "dropphyst": "IL",
    "dropphyzpp": 620409998,
    "dropmaladd": "2350 MADISON AVE",
    "dropmalcty": "GRANITE CITY",
    "dropmalst": "IL",
    "dropmalzpp": 620409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188770700,
    "dropsitcph": 6188770700,
    "dropfax": 6514566632
  },
  {
    "dcode": "D",
    "dropkey": "PW13171",
    "droptype": "D",
    "dropname": "GRANT PARK",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "GRANT PARK",
    "dropdelst": "IL",
    "dropdelzpp": 609409998,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "GRANT PARK",
    "dropphyst": "IL",
    "dropphyzpp": 609409998,
    "dropmaladd": "115 N MAIN ST",
    "dropmalcty": "GRANT PARK",
    "dropmalst": "IL",
    "dropmalzpp": 609409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154656487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13174",
    "droptype": "D",
    "dropname": "GRANTSBURG",
    "dropdeladd": "8655 STATE ROUTE 146 E",
    "dropdelcty": "GRANTSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 629439998,
    "dropphyadd": "8655 STATE ROUTE 146 E",
    "dropphycty": "GRANTSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 629439998,
    "dropmaladd": "8655 STATE ROUTE 146 E",
    "dropmalcty": "GRANTSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 629439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186588570,
    "dropsitcph": 6186588570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13175",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "107 S MCCOY ST",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 613269331,
    "dropphyadd": "107 S MCCOY ST",
    "dropphycty": "GRANVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 613269331,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 613269998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153396541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13176",
    "droptype": "D",
    "dropname": "GRAYMONT",
    "dropdeladd": "307 N MAIN ST",
    "dropdelcty": "GRAYMONT",
    "dropdelst": "IL",
    "dropdelzpp": 617439998,
    "dropphyadd": "307 N MAIN ST",
    "dropphycty": "GRAYMONT",
    "dropphyst": "IL",
    "dropphyzpp": 617439998,
    "dropmaladd": "307 N MAIN ST",
    "dropmalcty": "GRAYMONT",
    "dropmalst": "IL",
    "dropmalzpp": 617439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8157435356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13177",
    "droptype": "D",
    "dropname": "GRAYSLAKE",
    "dropdeladd": "75 COMMERCE DR",
    "dropdelcty": "GRAYSLAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600309998,
    "dropphyadd": "75 COMMERCE DR",
    "dropphycty": "GRAYSLAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600309998,
    "dropmaladd": "75 COMMERCE DR",
    "dropmalcty": "GRAYSLAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600309998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472232787,
    "dropsitcph": 8472232787,
    "dropfax": 8472230571
  },
  {
    "dcode": "D",
    "dropkey": "PW13179",
    "droptype": "D",
    "dropname": "GRAYVILLE",
    "dropdeladd": "210 E SOUTH ST",
    "dropdelcty": "GRAYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628449997,
    "dropphyadd": "210 E SOUTH ST",
    "dropphycty": "GRAYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628449997,
    "dropmaladd": "210 E SOUTH ST",
    "dropmalcty": "GRAYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628449997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183754861,
    "dropsitcph": 6183754861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13189",
    "droptype": "D",
    "dropname": "GREEN VALLEY",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "GREEN VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 615349800,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "GREEN VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 615349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 615349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093525480,
    "dropfax": 3093520030
  },
  {
    "dcode": "D",
    "dropkey": "PW13192",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "609 MAIN ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 620449998,
    "dropphyadd": "609 MAIN ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 620449998,
    "dropmaladd": "609 MAIN ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 620449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173682848,
    "dropsitcph": 2173682848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13194",
    "droptype": "D",
    "dropname": "GREENUP",
    "dropdeladd": "125 E CUMBERLAND ST",
    "dropdelcty": "GREENUP",
    "dropdelst": "IL",
    "dropdelzpp": 624289998,
    "dropphyadd": "125 E CUMBERLAND ST",
    "dropphycty": "GREENUP",
    "dropphyst": "IL",
    "dropphyzpp": 624289998,
    "dropmaladd": "125 E CUMBERLAND ST",
    "dropmalcty": "GREENUP",
    "dropmalst": "IL",
    "dropmalzpp": 624289998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179233451,
    "dropsitcph": 2179233451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13195",
    "droptype": "D",
    "dropname": "GREENVIEW",
    "dropdeladd": "158 W WASHINGTON ST",
    "dropdelcty": "GREENVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 626429998,
    "dropphyadd": "158 W WASHINGTON ST",
    "dropphycty": "GREENVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 626429998,
    "dropmaladd": "158 W WASHINGTON ST",
    "dropmalcty": "GREENVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 626429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179685331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13196",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "300 W MAIN ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622469998,
    "dropphyadd": "300 W MAIN ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622469998,
    "dropmaladd": "300 W MAIN ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186640145,
    "dropsitcph": 6186640145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13199",
    "droptype": "D",
    "dropname": "GRIDLEY",
    "dropdeladd": "324 N CENTER ST",
    "dropdelcty": "GRIDLEY",
    "dropdelst": "IL",
    "dropdelzpp": 617449900,
    "dropphyadd": "324 N CENTER ST",
    "dropphycty": "GRIDLEY",
    "dropphyst": "IL",
    "dropphyzpp": 617449900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRIDLEY",
    "dropmalst": "IL",
    "dropmalzpp": 617449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097472078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13201",
    "droptype": "D",
    "dropname": "GRIGGSVILLE",
    "dropdeladd": "102 W QUINCY ST",
    "dropdelcty": "GRIGGSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 623409998,
    "dropphyadd": "102 W QUINCY ST",
    "dropphycty": "GRIGGSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 623409998,
    "dropmaladd": "102 W QUINCY ST",
    "dropmalcty": "GRIGGSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 623409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178332414,
    "dropsitcph": 2178332414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13205",
    "droptype": "D",
    "dropname": "GROVELAND",
    "dropdeladd": "18769 SPRINGFIELD RD",
    "dropdelcty": "GROVELAND",
    "dropdelst": "IL",
    "dropdelzpp": 615359800,
    "dropphyadd": "18769 SPRINGFIELD RD",
    "dropphycty": "GROVELAND",
    "dropphyst": "IL",
    "dropphyzpp": 615359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GROVELAND",
    "dropmalst": "IL",
    "dropmalzpp": 615359998,
    "dropsitphn": 7089255213,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093876770,
    "dropfax": 3093876770
  },
  {
    "dcode": "D",
    "dropkey": "PW13209",
    "droptype": "D",
    "dropname": "GURNEE",
    "dropdeladd": "1 N OPLAINE RD",
    "dropdelcty": "GURNEE",
    "dropdelst": "IL",
    "dropdelzpp": 600312601,
    "dropphyadd": "1 N OPLAINE RD",
    "dropphycty": "GURNEE",
    "dropphyst": "IL",
    "dropphyzpp": 600312601,
    "dropmaladd": "1 N OPLAINE RD",
    "dropmalcty": "GURNEE",
    "dropmalst": "IL",
    "dropmalzpp": 600312601,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476626943,
    "dropsitcph": 8476626943,
    "dropfax": 8475962095
  },
  {
    "dcode": "D",
    "dropkey": "PW13225",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "408 STATE ST",
    "dropdelcty": "HAMBURG",
    "dropdelst": "IL",
    "dropdelzpp": 620459998,
    "dropphyadd": "408 STATE ST",
    "dropphycty": "HAMBURG",
    "dropphyst": "IL",
    "dropphyzpp": 620459998,
    "dropmaladd": "408 STATE ST",
    "dropmalcty": "HAMBURG",
    "dropmalst": "IL",
    "dropmalzpp": 620459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182321111,
    "dropsitcph": 6182321111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13226",
    "droptype": "D",
    "dropname": "HAMEL",
    "dropdeladd": "143 W STATE ST",
    "dropdelcty": "HAMEL",
    "dropdelst": "IL",
    "dropdelzpp": 620469998,
    "dropphyadd": "143 W STATE ST",
    "dropphycty": "HAMEL",
    "dropphyst": "IL",
    "dropphyzpp": 620469998,
    "dropmaladd": "143 W STATE ST",
    "dropmalcty": "HAMEL",
    "dropmalst": "IL",
    "dropmalzpp": 620469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186332526,
    "dropsitcph": 6186332526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13227",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "1160 BROADWAY ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "IL",
    "dropdelzpp": 623419998,
    "dropphyadd": "1160 BROADWAY ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "IL",
    "dropphyzpp": 623419998,
    "dropmaladd": "1160 BROADWAY ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "IL",
    "dropmalzpp": 623419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178472117,
    "dropsitcph": 2178472117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13230",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "111 E 1ST ST",
    "dropdelcty": "HAMMOND",
    "dropdelst": "IL",
    "dropdelzpp": 619299998,
    "dropphyadd": "111 E 1ST ST",
    "dropphycty": "HAMMOND",
    "dropphyst": "IL",
    "dropphyzpp": 619299998,
    "dropmaladd": "111 E 1ST ST",
    "dropmalcty": "HAMMOND",
    "dropmalst": "IL",
    "dropmalzpp": 619299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172623322,
    "dropfax": 2172623322
  },
  {
    "dcode": "D",
    "dropkey": "PW13231",
    "droptype": "D",
    "dropname": "HAMPSHIRE",
    "dropdeladd": "196 WASHINGTON AVE",
    "dropdelcty": "HAMPSHIRE",
    "dropdelst": "IL",
    "dropdelzpp": 601401000,
    "dropphyadd": "196 WASHINGTON AVE",
    "dropphycty": "HAMPSHIRE",
    "dropphyst": "IL",
    "dropphyzpp": 601401000,
    "dropmaladd": "196 WASHINGTON AVE",
    "dropmalcty": "HAMPSHIRE",
    "dropmalst": "IL",
    "dropmalzpp": 601401000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476832636,
    "dropsitcph": 8476832636,
    "dropfax": 8476831889
  },
  {
    "dcode": "D",
    "dropkey": "PW13232",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "625 8TH ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "IL",
    "dropdelzpp": 612569625,
    "dropphyadd": "625 8TH ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "IL",
    "dropphyzpp": 612569625,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMPTON",
    "dropmalst": "IL",
    "dropmalzpp": 612569998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3094963300,
    "dropsitcph": 3094963300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13236",
    "droptype": "D",
    "dropname": "HANNA CITY",
    "dropdeladd": "213 N MAIN ST",
    "dropdelcty": "HANNA CITY",
    "dropdelst": "IL",
    "dropdelzpp": 615369800,
    "dropphyadd": "213 N MAIN ST",
    "dropphycty": "HANNA CITY",
    "dropphyst": "IL",
    "dropphyzpp": 615369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANNA CITY",
    "dropmalst": "IL",
    "dropmalzpp": 615369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3092179281,
    "dropsitcph": 3096501211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13237",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "220 JEFFERSON ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "IL",
    "dropdelzpp": 610419697,
    "dropphyadd": "220 JEFFERSON ST",
    "dropphycty": "HANOVER",
    "dropphyst": "IL",
    "dropphyzpp": 610419697,
    "dropmaladd": "220 JEFFERSON ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "IL",
    "dropmalzpp": 610419697,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155912219,
    "dropsitcph": 8155912219,
    "dropfax": 8155913749
  },
  {
    "dcode": "D",
    "dropkey": "PW13242",
    "droptype": "D",
    "dropname": "HARDIN",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "HARDIN",
    "dropdelst": "IL",
    "dropdelzpp": 620479998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "HARDIN",
    "dropphyst": "IL",
    "dropphyzpp": 620479998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "HARDIN",
    "dropmalst": "IL",
    "dropmalzpp": 620479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185767002,
    "dropsitcph": 6185767002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13246",
    "droptype": "D",
    "dropname": "HARMON",
    "dropdeladd": "205 N 1ST ST",
    "dropdelcty": "HARMON",
    "dropdelst": "IL",
    "dropdelzpp": 610429442,
    "dropphyadd": "205 N 1ST ST",
    "dropphycty": "HARMON",
    "dropphyst": "IL",
    "dropphyzpp": 610429442,
    "dropmaladd": "205 N 1ST ST",
    "dropmalcty": "HARMON",
    "dropmalst": "IL",
    "dropmalzpp": 610429442,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153597334,
    "dropsitcph": 8153597334,
    "dropfax": 8153592010
  },
  {
    "dcode": "D",
    "dropkey": "PW13251",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "101 W CHURCH ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "IL",
    "dropdelzpp": 629469998,
    "dropphyadd": "101 W CHURCH ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "IL",
    "dropphyzpp": 629469998,
    "dropmaladd": "101 W CHURCH ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "IL",
    "dropmalzpp": 629469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182537836,
    "dropsitcph": 6182537836,
    "dropfax": 6182524012
  },
  {
    "dcode": "D",
    "dropkey": "PW13255",
    "droptype": "D",
    "dropname": "HARRISTOWN",
    "dropdeladd": "1355 N MERIDIAN RD",
    "dropdelcty": "HARRISTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 625379998,
    "dropphyadd": "1355 N MERIDIAN RD",
    "dropphycty": "HARRISTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 625379998,
    "dropmaladd": "1355 N MERIDIAN RD",
    "dropmalcty": "HARRISTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 625379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179632613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13257",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "100 W CHERRY ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "IL",
    "dropdelzpp": 620489998,
    "dropphyadd": "100 W CHERRY ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "IL",
    "dropphyzpp": 620489998,
    "dropmaladd": "100 W CHERRY ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "IL",
    "dropmalzpp": 620489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182540213,
    "dropsitcph": 6182540213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13258",
    "droptype": "D",
    "dropname": "HARTSBURG",
    "dropdeladd": "112 N 2ND ST",
    "dropdelcty": "HARTSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 626439998,
    "dropphyadd": "112 N 2ND ST",
    "dropphycty": "HARTSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 626439998,
    "dropmaladd": "112 N 2ND ST",
    "dropmalcty": "HARTSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 626439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176425258,
    "dropfax": 2176425258
  },
  {
    "dcode": "D",
    "dropkey": "PW13259",
    "droptype": "D",
    "dropname": "HARVARD",
    "dropdeladd": "300 N EASTMAN ST",
    "dropdelcty": "HARVARD",
    "dropdelst": "IL",
    "dropdelzpp": 600332760,
    "dropphyadd": "300 N EASTMAN ST",
    "dropphycty": "HARVARD",
    "dropphyst": "IL",
    "dropphyzpp": 600332760,
    "dropmaladd": "300 N EASTMAN ST",
    "dropmalcty": "HARVARD",
    "dropmalst": "IL",
    "dropmalzpp": 600332760,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159435182,
    "dropsitcph": 8159435182,
    "dropfax": 8159432867
  },
  {
    "dcode": "D",
    "dropkey": "PW13260",
    "droptype": "D",
    "dropname": "HARVEL",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "HARVEL",
    "dropdelst": "IL",
    "dropdelzpp": 625389998,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "HARVEL",
    "dropphyst": "IL",
    "dropphyzpp": 625389998,
    "dropmaladd": "125 MAIN ST",
    "dropmalcty": "HARVEL",
    "dropmalst": "IL",
    "dropmalzpp": 625389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172294421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13261",
    "droptype": "D",
    "dropname": "HARVEY",
    "dropdeladd": "15441 CENTER AVE",
    "dropdelcty": "HARVEY",
    "dropdelst": "IL",
    "dropdelzpp": 604263656,
    "dropphyadd": "15441 CENTER AVE",
    "dropphycty": "HARVEY",
    "dropphyst": "IL",
    "dropphyzpp": 604263656,
    "dropmaladd": "15441 CENTER AVE",
    "dropmalcty": "HARVEY",
    "dropmalst": "IL",
    "dropmalzpp": 604263656,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083391211,
    "dropfax": 7083391249
  },
  {
    "dcode": "D",
    "dropkey": "PW13266",
    "droptype": "D",
    "dropname": "HAVANA",
    "dropdeladd": "128 S ORANGE ST",
    "dropdelcty": "HAVANA",
    "dropdelst": "IL",
    "dropdelzpp": 626449998,
    "dropphyadd": "128 S ORANGE ST",
    "dropphycty": "HAVANA",
    "dropphyst": "IL",
    "dropphyzpp": 626449998,
    "dropmaladd": "128 S ORANGE ST",
    "dropmalcty": "HAVANA",
    "dropmalst": "IL",
    "dropmalzpp": 626449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 3095432581,
    "dropfax": 3095436530
  },
  {
    "dcode": "D",
    "dropkey": "PW13273",
    "droptype": "D",
    "dropname": "HAZEL CREST",
    "dropdeladd": "17541 KEDZIE AVE",
    "dropdelcty": "HAZEL CREST",
    "dropdelst": "IL",
    "dropdelzpp": 604299998,
    "dropphyadd": "17541 KEDZIE AVE",
    "dropphycty": "HAZEL CREST",
    "dropphyst": "IL",
    "dropphyzpp": 604299998,
    "dropmaladd": "17541 KEDZIE AVE",
    "dropmalcty": "HAZEL CREST",
    "dropmalst": "IL",
    "dropmalzpp": 604299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7086470465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13279",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "9912 ILLINOIS ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "IL",
    "dropdelzpp": 600348912,
    "dropphyadd": "9912 ILLINOIS ST",
    "dropphycty": "HEBRON",
    "dropphyst": "IL",
    "dropphyzpp": 600348912,
    "dropmaladd": "9912 ILLINOIS ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "IL",
    "dropmalzpp": 600348912,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156481719,
    "dropsitcph": 8156481719,
    "dropfax": 8156484626
  },
  {
    "dcode": "D",
    "dropkey": "PW13280",
    "droptype": "D",
    "dropname": "HECKER",
    "dropdeladd": "140 W MONROE ST",
    "dropdelcty": "HECKER",
    "dropdelst": "IL",
    "dropdelzpp": 622489998,
    "dropphyadd": "140 W MONROE ST",
    "dropphycty": "HECKER",
    "dropphyst": "IL",
    "dropphyzpp": 622489998,
    "dropmaladd": "140 W MONROE ST",
    "dropmalcty": "HECKER",
    "dropmalst": "IL",
    "dropmalzpp": 622489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184732922,
    "dropsitcph": 6184732922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13288",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "IL",
    "dropdelzpp": 614399800,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "IL",
    "dropphyzpp": 614399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENDERSON",
    "dropmalst": "IL",
    "dropmalzpp": 614399998,
    "dropsitphn": 3093441339,
    "dropsitlph": 3093441339,
    "dropsitcph": 3093441339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13290",
    "droptype": "D",
    "dropname": "HENNEPIN",
    "dropdeladd": "316 E HIGH ST",
    "dropdelcty": "HENNEPIN",
    "dropdelst": "IL",
    "dropdelzpp": 613279800,
    "dropphyadd": "316 E HIGH ST",
    "dropphycty": "HENNEPIN",
    "dropphyst": "IL",
    "dropphyzpp": 613279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENNEPIN",
    "dropmalst": "IL",
    "dropmalzpp": 613279998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8159257077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13291",
    "droptype": "D",
    "dropname": "HENNING",
    "dropdeladd": "122 E LANE ST",
    "dropdelcty": "HENNING",
    "dropdelst": "IL",
    "dropdelzpp": 618489998,
    "dropphyadd": "122 E LANE ST",
    "dropphycty": "HENNING",
    "dropphyst": "IL",
    "dropphyzpp": 618489998,
    "dropmaladd": "122 E LANE ST",
    "dropmalcty": "HENNING",
    "dropmalst": "IL",
    "dropmalzpp": 618489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172863278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13292",
    "droptype": "D",
    "dropname": "HENRY",
    "dropdeladd": "505 MAIN ST",
    "dropdelcty": "HENRY",
    "dropdelst": "IL",
    "dropdelzpp": 615379998,
    "dropphyadd": "505 MAIN ST",
    "dropphycty": "HENRY",
    "dropphyst": "IL",
    "dropphyzpp": 615379998,
    "dropmaladd": "505 MAIN ST",
    "dropmalcty": "HENRY",
    "dropmalst": "IL",
    "dropmalzpp": 615379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093643254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13298",
    "droptype": "D",
    "dropname": "HEROD",
    "dropdeladd": "100 HIGHWAY 34 S",
    "dropdelcty": "HEROD",
    "dropdelst": "IL",
    "dropdelzpp": 629479998,
    "dropphyadd": "100 HIGHWAY 34 S",
    "dropphycty": "HEROD",
    "dropphyst": "IL",
    "dropphyzpp": 629479998,
    "dropmaladd": "100 HIGHWAY 34 S",
    "dropmalcty": "HEROD",
    "dropmalst": "IL",
    "dropmalzpp": 629479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144363460,
    "dropsitcph": 6182645787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13299",
    "droptype": "D",
    "dropname": "HERRICK",
    "dropdeladd": "9 S BROADWAY ST",
    "dropdelcty": "HERRICK",
    "dropdelst": "IL",
    "dropdelzpp": 624319998,
    "dropphyadd": "9 S BROADWAY ST",
    "dropphycty": "HERRICK",
    "dropphyst": "IL",
    "dropphyzpp": 624319998,
    "dropmaladd": "9 S BROADWAY ST",
    "dropmalcty": "HERRICK",
    "dropmalst": "IL",
    "dropmalzpp": 624319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184285900,
    "dropsitcph": 6184285900,
    "dropfax": 6184285900
  },
  {
    "dcode": "D",
    "dropkey": "PW13300",
    "droptype": "D",
    "dropname": "HERRIN",
    "dropdeladd": "200 S PARK AVE",
    "dropdelcty": "HERRIN",
    "dropdelst": "IL",
    "dropdelzpp": 629489998,
    "dropphyadd": "200 S PARK AVE",
    "dropphycty": "HERRIN",
    "dropphyst": "IL",
    "dropphyzpp": 629489998,
    "dropmaladd": "200 S PARK AVE",
    "dropmalcty": "HERRIN",
    "dropmalst": "IL",
    "dropmalzpp": 629489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189424845,
    "dropsitcph": 6189424845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13301",
    "droptype": "D",
    "dropname": "HERSCHER",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "HERSCHER",
    "dropdelst": "IL",
    "dropdelzpp": 609419811,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "HERSCHER",
    "dropphyst": "IL",
    "dropphyzpp": 609419811,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERSCHER",
    "dropmalst": "IL",
    "dropmalzpp": 609419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154262286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13304",
    "droptype": "D",
    "dropname": "HETTICK",
    "dropdeladd": "116 E POST ST",
    "dropdelcty": "HETTICK",
    "dropdelst": "IL",
    "dropdelzpp": 626499998,
    "dropphyadd": "116 E POST ST",
    "dropphycty": "HETTICK",
    "dropphyst": "IL",
    "dropphyzpp": 626499998,
    "dropmaladd": "116 E POST ST",
    "dropmalcty": "HETTICK",
    "dropmalst": "IL",
    "dropmalzpp": 626499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 6187785500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13306",
    "droptype": "D",
    "dropname": "HEYWORTH",
    "dropdeladd": "102 S WILLIS ST",
    "dropdelcty": "HEYWORTH",
    "dropdelst": "IL",
    "dropdelzpp": 617459900,
    "dropphyadd": "102 S WILLIS ST",
    "dropphycty": "HEYWORTH",
    "dropphyst": "IL",
    "dropphyzpp": 617459900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEYWORTH",
    "dropmalst": "IL",
    "dropmalzpp": 617459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094732722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13309",
    "droptype": "D",
    "dropname": "HIDALGO",
    "dropdeladd": "117 E HARRISON ST",
    "dropdelcty": "HIDALGO",
    "dropdelst": "IL",
    "dropdelzpp": 624329998,
    "dropphyadd": "117 E HARRISON ST",
    "dropphycty": "HIDALGO",
    "dropphyst": "IL",
    "dropphyzpp": 624329998,
    "dropmaladd": "117 E HARRISON ST",
    "dropmalcty": "HIDALGO",
    "dropmalst": "IL",
    "dropmalzpp": 624329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187932365,
    "dropsitcph": 6187932365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13311",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "801 MAIN ST",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "IL",
    "dropdelzpp": 622499998,
    "dropphyadd": "801 MAIN ST",
    "dropphycty": "HIGHLAND",
    "dropphyst": "IL",
    "dropphyzpp": 622499998,
    "dropmaladd": "801 MAIN ST",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "IL",
    "dropmalzpp": 622499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186546791,
    "dropsitcph": 6186546791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13313",
    "droptype": "D",
    "dropname": "HIGHLAND PARK",
    "dropdeladd": "833 CENTRAL AVE",
    "dropdelcty": "HIGHLAND PARK",
    "dropdelst": "IL",
    "dropdelzpp": 600353266,
    "dropphyadd": "833 CENTRAL AVE",
    "dropphycty": "HIGHLAND PARK",
    "dropphyst": "IL",
    "dropphyzpp": 600353266,
    "dropmaladd": "833 CENTRAL AVE",
    "dropmalcty": "HIGHLAND PARK",
    "dropmalst": "IL",
    "dropmalzpp": 600353266,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474333201,
    "dropsitcph": 8474333201,
    "dropfax": 8474335941
  },
  {
    "dcode": "D",
    "dropkey": "PW13320",
    "droptype": "D",
    "dropname": "HIGHWOOD",
    "dropdeladd": "130 HIGHWOOD AVE",
    "dropdelcty": "HIGHWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 600401540,
    "dropphyadd": "130 HIGHWOOD AVE",
    "dropphycty": "HIGHWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 600401540,
    "dropmaladd": "130 HIGHWOOD AVE",
    "dropmalcty": "HIGHWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 600401540,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474320115,
    "dropsitcph": 8474320115,
    "dropfax": 8474327439
  },
  {
    "dcode": "D",
    "dropkey": "PW13323",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "120 W WOOD ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "IL",
    "dropdelzpp": 620499998,
    "dropphyadd": "120 W WOOD ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "IL",
    "dropphyzpp": 620499998,
    "dropmaladd": "120 W WOOD ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "IL",
    "dropmalzpp": 620499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175323649,
    "dropsitcph": 2175323649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13326",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "108 BUTZER ST",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "IL",
    "dropdelzpp": 612577703,
    "dropphyadd": "108 BUTZER ST",
    "dropphycty": "HILLSDALE",
    "dropphyst": "IL",
    "dropphyzpp": 612577703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "IL",
    "dropmalzpp": 612579998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3096582146,
    "dropsitcph": 3096582146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13331",
    "droptype": "D",
    "dropname": "HILLVIEW",
    "dropdeladd": "201 W BLUFF ST",
    "dropdelcty": "HILLVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 620509998,
    "dropphyadd": "201 W BLUFF ST",
    "dropphycty": "HILLVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 620509998,
    "dropmaladd": "201 W BLUFF ST",
    "dropmalcty": "HILLVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 620509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179456373,
    "dropsitcph": 2179456373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13332",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "557 E LINCOLN AVE",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "IL",
    "dropdelzpp": 605209800,
    "dropphyadd": "557 E LINCOLN AVE",
    "dropphycty": "HINCKLEY",
    "dropphyst": "IL",
    "dropphyzpp": 605209800,
    "dropmaladd": "557 E LINCOLN AVE",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "IL",
    "dropmalzpp": 605209800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152863636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13333",
    "droptype": "D",
    "dropname": "HINDSBORO",
    "dropdeladd": "407 MISSOURI ST",
    "dropdelcty": "HINDSBORO",
    "dropdelst": "IL",
    "dropdelzpp": 619309998,
    "dropphyadd": "407 MISSOURI ST",
    "dropphycty": "HINDSBORO",
    "dropphyst": "IL",
    "dropphyzpp": 619309998,
    "dropmaladd": "407 MISSOURI ST",
    "dropmalcty": "HINDSBORO",
    "dropmalst": "IL",
    "dropmalzpp": 619309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173462226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13335",
    "droptype": "D",
    "dropname": "HINES",
    "dropdeladd": "220 SCOTT DR",
    "dropdelcty": "HINES",
    "dropdelst": "IL",
    "dropdelzpp": 601419998,
    "dropphyadd": "220 SCOTT DR",
    "dropphycty": "HINES",
    "dropphyst": "IL",
    "dropphyzpp": 601419998,
    "dropmaladd": "220 SCOTT DR",
    "dropmalcty": "HINES",
    "dropmalst": "IL",
    "dropmalzpp": 601419998,
    "dropsitphn": 6302605499,
    "dropsitlph": 7083458668,
    "dropsitcph": 7083458668,
    "dropfax": 7083456094
  },
  {
    "dcode": "D",
    "dropkey": "PW13336",
    "droptype": "D",
    "dropname": "OAK BROOK",
    "dropdeladd": "1314 KENSINGTON RD",
    "dropdelcty": "OAK BROOK",
    "dropdelst": "IL",
    "dropdelzpp": 605239998,
    "dropphyadd": "1314 KENSINGTON RD",
    "dropphycty": "OAK BROOK",
    "dropphyst": "IL",
    "dropphyzpp": 605239998,
    "dropmaladd": "1314 KENSINGTON RD",
    "dropmalcty": "OAK BROOK",
    "dropmalst": "IL",
    "dropmalzpp": 605239998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6309904224,
    "dropfax": 6309904234
  },
  {
    "dcode": "D",
    "dropkey": "PW13344",
    "droptype": "D",
    "dropname": "HOFFMAN",
    "dropdeladd": "101 S BROADWAY",
    "dropdelcty": "HOFFMAN",
    "dropdelst": "IL",
    "dropdelzpp": 622509998,
    "dropphyadd": "101 S BROADWAY",
    "dropphycty": "HOFFMAN",
    "dropphyst": "IL",
    "dropphyzpp": 622509998,
    "dropmaladd": "101 S BROADWAY",
    "dropmalcty": "HOFFMAN",
    "dropmalst": "IL",
    "dropmalzpp": 622509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184952632,
    "dropsitcph": 6184952632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13352",
    "droptype": "D",
    "dropname": "HOLCOMB",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "HOLCOMB",
    "dropdelst": "IL",
    "dropdelzpp": 610439800,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "HOLCOMB",
    "dropphyst": "IL",
    "dropphyzpp": 610439800,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "HOLCOMB",
    "dropmalst": "IL",
    "dropmalzpp": 610439800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153934255,
    "dropsitcph": 8153934255,
    "dropfax": 8153934809
  },
  {
    "dcode": "D",
    "dropkey": "PW13361",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "135 S MAIN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "IL",
    "dropdelzpp": 618499998,
    "dropphyadd": "135 S MAIN ST",
    "dropphycty": "HOMER",
    "dropphyst": "IL",
    "dropphyzpp": 618499998,
    "dropmaladd": "135 S MAIN ST",
    "dropmalcty": "HOMER",
    "dropmalst": "IL",
    "dropmalzpp": 618499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178962413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13364",
    "droptype": "D",
    "dropname": "HOMEWOOD",
    "dropdeladd": "1921 RIDGE RD",
    "dropdelcty": "HOMEWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 604309998,
    "dropphyadd": "1921 RIDGE RD",
    "dropphycty": "HOMEWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 604309998,
    "dropmaladd": "701 W HOLBROOK RD",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 604259800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087985762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13370",
    "droptype": "D",
    "dropname": "HOOPESTON",
    "dropdeladd": "314 S MARKET ST",
    "dropdelcty": "HOOPESTON",
    "dropdelst": "IL",
    "dropdelzpp": 609429998,
    "dropphyadd": "314 S MARKET ST",
    "dropphycty": "HOOPESTON",
    "dropphyst": "IL",
    "dropphyzpp": 609429998,
    "dropmaladd": "314 S MARKET ST",
    "dropmalcty": "HOOPESTON",
    "dropmalst": "IL",
    "dropmalzpp": 609429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172836321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13374",
    "droptype": "D",
    "dropname": "HOPEDALE",
    "dropdeladd": "118 NW MAIN ST",
    "dropdelcty": "HOPEDALE",
    "dropdelst": "IL",
    "dropdelzpp": 617479801,
    "dropphyadd": "118 NW MAIN ST",
    "dropphycty": "HOPEDALE",
    "dropphyst": "IL",
    "dropphyzpp": 617479801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPEDALE",
    "dropmalst": "IL",
    "dropmalzpp": 617479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094495531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13377",
    "droptype": "D",
    "dropname": "HOPKINS PARK",
    "dropdeladd": "3952 S KING DR",
    "dropdelcty": "HOPKINS PARK",
    "dropdelst": "IL",
    "dropdelzpp": 609449998,
    "dropphyadd": "3952 S KING DR",
    "dropphycty": "HOPKINS PARK",
    "dropphyst": "IL",
    "dropphyzpp": 609449998,
    "dropmaladd": "3952 S KING DR",
    "dropmalcty": "HOPKINS PARK",
    "dropmalst": "IL",
    "dropmalzpp": 609449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8159448611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13390",
    "droptype": "D",
    "dropname": "HOYLETON",
    "dropdeladd": "75 E SAINT LOUIS ST",
    "dropdelcty": "HOYLETON",
    "dropdelst": "IL",
    "dropdelzpp": 628039998,
    "dropphyadd": "75 E SAINT LOUIS ST",
    "dropphycty": "HOYLETON",
    "dropphyst": "IL",
    "dropphyzpp": 628039998,
    "dropmaladd": "75 E SAINT LOUIS ST",
    "dropmalcty": "HOYLETON",
    "dropmalst": "IL",
    "dropmalzpp": 628039998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184936300,
    "dropsitcph": 6184936300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13395",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "104 E WALNUT ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "IL",
    "dropdelzpp": 617487702,
    "dropphyadd": "104 E WALNUT ST",
    "dropphycty": "HUDSON",
    "dropphyst": "IL",
    "dropphyzpp": 617487702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUDSON",
    "dropmalst": "IL",
    "dropmalzpp": 617489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097261511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13397",
    "droptype": "D",
    "dropname": "HUEY",
    "dropdeladd": "231 COLLINS ST",
    "dropdelcty": "HUEY",
    "dropdelst": "IL",
    "dropdelzpp": 622529998,
    "dropphyadd": "231 COLLINS ST",
    "dropphycty": "HUEY",
    "dropphyst": "IL",
    "dropphyzpp": 622529998,
    "dropmaladd": "231 COLLINS ST",
    "dropmalcty": "HUEY",
    "dropmalst": "IL",
    "dropmalzpp": 622529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185944671,
    "dropsitcph": 6185944671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13398",
    "droptype": "D",
    "dropname": "HULL",
    "dropdeladd": "201 E HULL AVE",
    "dropdelcty": "HULL",
    "dropdelst": "IL",
    "dropdelzpp": 623439998,
    "dropphyadd": "201 E HULL AVE",
    "dropphycty": "HULL",
    "dropphyst": "IL",
    "dropphyzpp": 623439998,
    "dropmaladd": "201 E HULL AVE",
    "dropmalcty": "HULL",
    "dropmalst": "IL",
    "dropmalzpp": 623439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174325421,
    "dropsitcph": 2174325421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13399",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "407 ELM ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "IL",
    "dropdelzpp": 619319998,
    "dropphyadd": "407 ELM ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "IL",
    "dropphyzpp": 619319998,
    "dropmaladd": "407 ELM ST",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "IL",
    "dropmalzpp": 619319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2172624458,
    "dropsitcph": 2172624458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13400",
    "droptype": "D",
    "dropname": "HUME",
    "dropdeladd": "150 FRONT ST",
    "dropdelcty": "HUME",
    "dropdelst": "IL",
    "dropdelzpp": 619329998,
    "dropphyadd": "150 FRONT ST",
    "dropphycty": "HUME",
    "dropphyst": "IL",
    "dropphyzpp": 619329998,
    "dropmaladd": "150 FRONT ST",
    "dropmalcty": "HUME",
    "dropmalst": "IL",
    "dropmalzpp": 619329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178879031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13403",
    "droptype": "D",
    "dropname": "HUNTLEY",
    "dropdeladd": "11013 N WOODSTOCK ST",
    "dropdelcty": "HUNTLEY",
    "dropdelst": "IL",
    "dropdelzpp": 601426957,
    "dropphyadd": "11013 N WOODSTOCK ST",
    "dropphycty": "HUNTLEY",
    "dropphyst": "IL",
    "dropphyzpp": 601426957,
    "dropmaladd": "11013 N WOODSTOCK ST",
    "dropmalcty": "HUNTLEY",
    "dropmalst": "IL",
    "dropmalzpp": 601426957,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476695423,
    "dropsitcph": 8476695423,
    "dropfax": 8476695509
  },
  {
    "dcode": "D",
    "dropkey": "PW13405",
    "droptype": "D",
    "dropname": "HURST",
    "dropdeladd": "212 N BUSH AVE",
    "dropdelcty": "HURST",
    "dropdelst": "IL",
    "dropdelzpp": 629499998,
    "dropphyadd": "212 N BUSH AVE",
    "dropphycty": "HURST",
    "dropphyst": "IL",
    "dropphyzpp": 629499998,
    "dropmaladd": "212 N BUSH AVE",
    "dropmalcty": "HURST",
    "dropmalst": "IL",
    "dropmalzpp": 629499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189872381,
    "dropsitcph": 6189872381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13407",
    "droptype": "D",
    "dropname": "HUTSONVILLE",
    "dropdeladd": "114 S MAIN ST",
    "dropdelcty": "HUTSONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 624339998,
    "dropphyadd": "114 S MAIN ST",
    "dropphycty": "HUTSONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 624339998,
    "dropmaladd": "114 S MAIN ST",
    "dropmalcty": "HUTSONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 624339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185634773,
    "dropsitcph": 6185634773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13429",
    "droptype": "D",
    "dropname": "ILLINOIS CITY",
    "dropdeladd": "23828 124TH AVE W",
    "dropdelcty": "ILLINOIS CITY",
    "dropdelst": "IL",
    "dropdelzpp": 612599000,
    "dropphyadd": "23828 124TH AVE W",
    "dropphycty": "ILLINOIS CITY",
    "dropphyst": "IL",
    "dropphyzpp": 612599000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ILLINOIS CITY",
    "dropmalst": "IL",
    "dropmalzpp": 612599998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097910060,
    "dropsitcph": 3097910060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13432",
    "droptype": "D",
    "dropname": "ILLIOPOLIS",
    "dropdeladd": "463 LOUISA ST",
    "dropdelcty": "ILLIOPOLIS",
    "dropdelst": "IL",
    "dropdelzpp": 625399998,
    "dropphyadd": "463 LOUISA ST",
    "dropphycty": "ILLIOPOLIS",
    "dropphyst": "IL",
    "dropphyzpp": 625399998,
    "dropmaladd": "463 LOUISA ST",
    "dropmalcty": "ILLIOPOLIS",
    "dropmalst": "IL",
    "dropmalzpp": 625399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174867541,
    "dropfax": 2174867541
  },
  {
    "dcode": "D",
    "dropkey": "PW13434",
    "droptype": "D",
    "dropname": "INA",
    "dropdeladd": "111 1/2 W 3RD ST",
    "dropdelcty": "INA",
    "dropdelst": "IL",
    "dropdelzpp": 628469998,
    "dropphyadd": "111 1/2 W 3RD ST",
    "dropphycty": "INA",
    "dropphyst": "IL",
    "dropphyzpp": 628469998,
    "dropmaladd": "111 1/2 W 3RD ST",
    "dropmalcty": "INA",
    "dropmalst": "IL",
    "dropmalzpp": 628469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184375308,
    "dropsitcph": 6184375308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13440",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "2 N VERMILION ST",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "IL",
    "dropdelzpp": 618509998,
    "dropphyadd": "2 N VERMILION ST",
    "dropphycty": "INDIANOLA",
    "dropphyst": "IL",
    "dropphyzpp": 618509998,
    "dropmaladd": "2 N VERMILION ST",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "IL",
    "dropmalzpp": 618509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172843154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13441",
    "droptype": "D",
    "dropname": "INDUSTRY",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "INDUSTRY",
    "dropdelst": "IL",
    "dropdelzpp": 614405059,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "INDUSTRY",
    "dropphyst": "IL",
    "dropphyzpp": 614405059,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDUSTRY",
    "dropmalst": "IL",
    "dropmalzpp": 614409998,
    "dropsitphn": 3097845051,
    "dropsitlph": 3092543410,
    "dropsitcph": 3092543410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13442",
    "droptype": "D",
    "dropname": "INGLESIDE",
    "dropdeladd": "604 ROLLINS RD",
    "dropdelcty": "INGLESIDE",
    "dropdelst": "IL",
    "dropdelzpp": 600411000,
    "dropphyadd": "604 ROLLINS RD",
    "dropphycty": "INGLESIDE",
    "dropphyst": "IL",
    "dropphyzpp": 600411000,
    "dropmaladd": "604 ROLLINS RD",
    "dropmalcty": "INGLESIDE",
    "dropmalst": "IL",
    "dropmalzpp": 600411000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475877812,
    "dropsitcph": 8475877812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13443",
    "droptype": "D",
    "dropname": "INGRAHAM",
    "dropdeladd": "5253 OLD INGRAHAM RD",
    "dropdelcty": "INGRAHAM",
    "dropdelst": "IL",
    "dropdelzpp": 624349998,
    "dropphyadd": "5253 OLD INGRAHAM RD",
    "dropphycty": "INGRAHAM",
    "dropphyst": "IL",
    "dropphyzpp": 624349998,
    "dropmaladd": "5253 OLD INGRAHAM RD",
    "dropmalcty": "INGRAHAM",
    "dropmalst": "IL",
    "dropmalzpp": 624349998,
    "dropsitphn": 6187522513,
    "dropsitlph": 6187522513,
    "dropsitcph": 6187522513,
    "dropfax": 6187525049
  },
  {
    "dcode": "D",
    "dropkey": "PW13449",
    "droptype": "D",
    "dropname": "IPAVA",
    "dropdeladd": "40 E MAIN ST",
    "dropdelcty": "IPAVA",
    "dropdelst": "IL",
    "dropdelzpp": 614419800,
    "dropphyadd": "40 E MAIN ST",
    "dropphycty": "IPAVA",
    "dropphyst": "IL",
    "dropphyzpp": 614419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IPAVA",
    "dropmalst": "IL",
    "dropmalzpp": 614419998,
    "dropsitphn": 3097845051,
    "dropsitlph": 3097538844,
    "dropsitcph": 3097538844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13452",
    "droptype": "D",
    "dropname": "IROQUOIS",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "IROQUOIS",
    "dropdelst": "IL",
    "dropdelzpp": 609459800,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "IROQUOIS",
    "dropphyst": "IL",
    "dropphyzpp": 609459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IROQUOIS",
    "dropmalst": "IL",
    "dropmalzpp": 609459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154293021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13453",
    "droptype": "D",
    "dropname": "IRVING",
    "dropdeladd": "101 E STATE ST",
    "dropdelcty": "IRVING",
    "dropdelst": "IL",
    "dropdelzpp": 620519998,
    "dropphyadd": "101 E STATE ST",
    "dropphycty": "IRVING",
    "dropphyst": "IL",
    "dropphyzpp": 620519998,
    "dropmaladd": "101 E STATE ST",
    "dropmalcty": "IRVING",
    "dropmalst": "IL",
    "dropmalzpp": 620519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175334619,
    "dropsitcph": 2175334619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13456",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "108 N 2ND ST",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 628489998,
    "dropphyadd": "108 N 2ND ST",
    "dropphycty": "IRVINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 628489998,
    "dropmaladd": "108 N 2ND ST",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 628489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182498352,
    "dropsitcph": 6182498352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13458",
    "droptype": "D",
    "dropname": "ISLAND LAKE",
    "dropdeladd": "129 E STATE RD",
    "dropdelcty": "ISLAND LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600421000,
    "dropphyadd": "129 E STATE RD",
    "dropphycty": "ISLAND LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600421000,
    "dropmaladd": "129 E STATE RD",
    "dropmalcty": "ISLAND LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600421000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475266153,
    "dropsitcph": 8475266153,
    "dropfax": 8475266198
  },
  {
    "dcode": "D",
    "dropkey": "PW13460",
    "droptype": "D",
    "dropname": "ITASCA",
    "dropdeladd": "1050 W IRVING PARK RD",
    "dropdelcty": "ITASCA",
    "dropdelst": "IL",
    "dropdelzpp": 601432059,
    "dropphyadd": "1050 W IRVING PARK RD",
    "dropphycty": "ITASCA",
    "dropphyst": "IL",
    "dropphyzpp": 601432059,
    "dropmaladd": "1050 W IRVING PARK RD",
    "dropmalcty": "ITASCA",
    "dropmalst": "IL",
    "dropmalzpp": 601432059,
    "dropsitphn": 6302605499,
    "dropsitlph": 6307730979,
    "dropsitcph": 6307730979,
    "dropfax": 6307732037
  },
  {
    "dcode": "D",
    "dropkey": "PW13461",
    "droptype": "D",
    "dropname": "IUKA",
    "dropdeladd": "311 N FRONT ST",
    "dropdelcty": "IUKA",
    "dropdelst": "IL",
    "dropdelzpp": 628499998,
    "dropphyadd": "311 N FRONT ST",
    "dropphycty": "IUKA",
    "dropphyst": "IL",
    "dropphyzpp": 628499998,
    "dropmaladd": "311 N FRONT ST",
    "dropmalcty": "IUKA",
    "dropmalst": "IL",
    "dropmalzpp": 628499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183236401,
    "dropsitcph": 6183236401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13463",
    "droptype": "D",
    "dropname": "IVESDALE",
    "dropdeladd": "205 CHAPIN ST",
    "dropdelcty": "IVESDALE",
    "dropdelst": "IL",
    "dropdelzpp": 618519998,
    "dropphyadd": "205 CHAPIN ST",
    "dropphycty": "IVESDALE",
    "dropphyst": "IL",
    "dropphyzpp": 618519998,
    "dropmaladd": "205 CHAPIN ST",
    "dropmalcty": "IVESDALE",
    "dropmalst": "IL",
    "dropmalzpp": 618519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175642445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13467",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "200 W COURT ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626509998,
    "dropphyadd": "200 W COURT ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626509998,
    "dropmaladd": "200 W COURT ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172452149,
    "dropfax": 2172450645
  },
  {
    "dcode": "D",
    "dropkey": "PW13468",
    "droptype": "D",
    "dropname": "JACOB",
    "dropdeladd": "3093 E JACOB RD",
    "dropdelcty": "JACOB",
    "dropdelst": "IL",
    "dropdelzpp": 629509998,
    "dropphyadd": "3093 E JACOB RD",
    "dropphycty": "JACOB",
    "dropphyst": "IL",
    "dropphyzpp": 629509998,
    "dropmaladd": "3093 E JACOB RD",
    "dropmalcty": "JACOB",
    "dropmalst": "IL",
    "dropmalzpp": 629509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187634214,
    "dropsitcph": 6187634214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13480",
    "droptype": "D",
    "dropname": "JERSEYVILLE",
    "dropdeladd": "115 N WASHINGTON ST",
    "dropdelcty": "JERSEYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620529998,
    "dropphyadd": "115 N WASHINGTON ST",
    "dropphycty": "JERSEYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620529998,
    "dropmaladd": "115 N WASHINGTON ST",
    "dropmalcty": "JERSEYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184986713,
    "dropsitcph": 6184986713,
    "dropfax": 6184982695
  },
  {
    "dcode": "D",
    "dropkey": "PW13485",
    "droptype": "D",
    "dropname": "JEWETT",
    "dropdeladd": "1100 CUMBERLAND RD",
    "dropdelcty": "JEWETT",
    "dropdelst": "IL",
    "dropdelzpp": 624369998,
    "dropphyadd": "1100 CUMBERLAND RD",
    "dropphycty": "JEWETT",
    "dropphyst": "IL",
    "dropphyzpp": 624369998,
    "dropmaladd": "1100 CUMBERLAND RD",
    "dropmalcty": "JEWETT",
    "dropmalst": "IL",
    "dropmalzpp": 624369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178492421,
    "dropsitcph": 2178492421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13487",
    "droptype": "D",
    "dropname": "JOHNSONVILLE",
    "dropdeladd": "301 N 2ND ST",
    "dropdelcty": "JOHNSONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628509998,
    "dropphyadd": "301 N 2ND ST",
    "dropphycty": "JOHNSONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628509998,
    "dropmaladd": "301 N 2ND ST",
    "dropmalcty": "JOHNSONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186732019,
    "dropsitcph": 6186732019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13490",
    "droptype": "D",
    "dropname": "JOHNSTON CITY",
    "dropdeladd": "205 W BROADWAY BLVD",
    "dropdelcty": "JOHNSTON CITY",
    "dropdelst": "IL",
    "dropdelzpp": 629519998,
    "dropphyadd": "205 W BROADWAY BLVD",
    "dropphycty": "JOHNSTON CITY",
    "dropphyst": "IL",
    "dropphyzpp": 629519998,
    "dropmaladd": "205 W BROADWAY BLVD",
    "dropmalcty": "JOHNSTON CITY",
    "dropmalst": "IL",
    "dropmalzpp": 629519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189835001,
    "dropsitcph": 6189835001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13493",
    "droptype": "D",
    "dropname": "JOLIET",
    "dropdeladd": "2000 MCDONOUGH ST",
    "dropdelcty": "JOLIET",
    "dropdelst": "IL",
    "dropdelzpp": 604369998,
    "dropphyadd": "2000 MCDONOUGH ST",
    "dropphycty": "JOLIET",
    "dropphyst": "IL",
    "dropphyzpp": 604369998,
    "dropmaladd": "2000 MCDONOUGH ST",
    "dropmalcty": "JOLIET",
    "dropmalst": "IL",
    "dropmalzpp": 604369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8157731060,
    "dropfax": 8157731079
  },
  {
    "dcode": "D",
    "dropkey": "PW13494",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "103 W BROAD ST",
    "dropdelcty": "JONESBORO",
    "dropdelst": "IL",
    "dropdelzpp": 629529998,
    "dropphyadd": "103 W BROAD ST",
    "dropphycty": "JONESBORO",
    "dropphyst": "IL",
    "dropphyzpp": 629529998,
    "dropmaladd": "103 W BROAD ST",
    "dropmalcty": "JONESBORO",
    "dropmalst": "IL",
    "dropmalzpp": 629529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188332492,
    "dropsitcph": 6188332492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13497",
    "droptype": "D",
    "dropname": "JOPPA",
    "dropdeladd": "205 JOPPA RD",
    "dropdelcty": "JOPPA",
    "dropdelst": "IL",
    "dropdelzpp": 629539998,
    "dropphyadd": "205 JOPPA RD",
    "dropphycty": "JOPPA",
    "dropphyst": "IL",
    "dropphyzpp": 629539998,
    "dropmaladd": "205 JOPPA RD",
    "dropmalcty": "JOPPA",
    "dropmalst": "IL",
    "dropmalzpp": 629539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185437347,
    "dropsitcph": 6185437347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13500",
    "droptype": "D",
    "dropname": "JOY",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "JOY",
    "dropdelst": "IL",
    "dropdelzpp": 612607704,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "JOY",
    "dropphyst": "IL",
    "dropphyzpp": 612607704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOY",
    "dropmalst": "IL",
    "dropmalzpp": 612609998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095844851,
    "dropsitcph": 3095844851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13501",
    "droptype": "D",
    "dropname": "JUNCTION",
    "dropdeladd": "348 FRONT ST",
    "dropdelcty": "JUNCTION",
    "dropdelst": "IL",
    "dropdelzpp": 629549998,
    "dropphyadd": "348 FRONT ST",
    "dropphycty": "JUNCTION",
    "dropphyst": "IL",
    "dropphyzpp": 629549998,
    "dropmaladd": "348 FRONT ST",
    "dropmalcty": "JUNCTION",
    "dropmalst": "IL",
    "dropmalzpp": 629549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182694271,
    "dropsitcph": 6182694271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13505",
    "droptype": "D",
    "dropname": "KAMPSVILLE",
    "dropdeladd": "100 N BROADWAY",
    "dropdelcty": "KAMPSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620539998,
    "dropphyadd": "100 N BROADWAY",
    "dropphycty": "KAMPSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620539998,
    "dropmaladd": "100 N BROADWAY",
    "dropmalcty": "KAMPSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186532005,
    "dropsitcph": 6186532005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13508",
    "droptype": "D",
    "dropname": "KANE",
    "dropdeladd": "309 N MAIN ST",
    "dropdelcty": "KANE",
    "dropdelst": "IL",
    "dropdelzpp": 620549998,
    "dropphyadd": "309 N MAIN ST",
    "dropphycty": "KANE",
    "dropphyst": "IL",
    "dropphyzpp": 620549998,
    "dropmaladd": "309 N MAIN ST",
    "dropmalcty": "KANE",
    "dropmalst": "IL",
    "dropmalzpp": 620549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179425022,
    "dropsitcph": 2179425022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13509",
    "droptype": "D",
    "dropname": "KANEVILLE",
    "dropdeladd": "2S101 HARTER RD",
    "dropdelcty": "KANEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 601441000,
    "dropphyadd": "2S101 HARTER RD",
    "dropphycty": "KANEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 601441000,
    "dropmaladd": "2S101 HARTER RD",
    "dropmalcty": "KANEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 601441000,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305572120,
    "dropsitcph": 6305572120,
    "dropfax": 6305572120
  },
  {
    "dcode": "D",
    "dropkey": "PW13514",
    "droptype": "D",
    "dropname": "KANKAKEE",
    "dropdeladd": "475 E COURT ST",
    "dropdelcty": "KANKAKEE",
    "dropdelst": "IL",
    "dropdelzpp": 609019998,
    "dropphyadd": "475 E COURT ST",
    "dropphycty": "KANKAKEE",
    "dropphyst": "IL",
    "dropphyzpp": 609019998,
    "dropmaladd": "475 E COURT ST",
    "dropmalcty": "KANKAKEE",
    "dropmalst": "IL",
    "dropmalzpp": 609019998,
    "dropsitphn": 8159357440,
    "dropsitlph": 8159357440,
    "dropsitcph": 8159357440,
    "dropfax": 8159326375
  },
  {
    "dcode": "D",
    "dropkey": "PW13515",
    "droptype": "D",
    "dropname": "KANSAS",
    "dropdeladd": "126 E BUENA VISTA ST",
    "dropdelcty": "KANSAS",
    "dropdelst": "IL",
    "dropdelzpp": 619339998,
    "dropphyadd": "126 E BUENA VISTA ST",
    "dropphycty": "KANSAS",
    "dropphyst": "IL",
    "dropphyzpp": 619339998,
    "dropmaladd": "126 E BUENA VISTA ST",
    "dropmalcty": "KANSAS",
    "dropmalst": "IL",
    "dropmalzpp": 619339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2179485331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13519",
    "droptype": "D",
    "dropname": "KARNAK",
    "dropdeladd": "210 N 1ST ST",
    "dropdelcty": "KARNAK",
    "dropdelst": "IL",
    "dropdelzpp": 629569998,
    "dropphyadd": "210 N 1ST ST",
    "dropphycty": "KARNAK",
    "dropphyst": "IL",
    "dropphyzpp": 629569998,
    "dropmaladd": "210 N 1ST ST",
    "dropmalcty": "KARNAK",
    "dropmalst": "IL",
    "dropmalzpp": 629569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186349355,
    "dropsitcph": 6186349355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13520",
    "droptype": "D",
    "dropname": "KASBEER",
    "dropdeladd": "20367 2470 NORTH AVE",
    "dropdelcty": "KASBEER",
    "dropdelst": "IL",
    "dropdelzpp": 613289800,
    "dropphyadd": "20367 2470 NORTH AVE",
    "dropphycty": "KASBEER",
    "dropphyst": "IL",
    "dropphyzpp": 613289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KASBEER",
    "dropmalst": "IL",
    "dropmalzpp": 613289998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158721466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13525",
    "droptype": "D",
    "dropname": "KEENES",
    "dropdeladd": "400 SYCAMORE ST",
    "dropdelcty": "KEENES",
    "dropdelst": "IL",
    "dropdelzpp": 628519998,
    "dropphyadd": "400 SYCAMORE ST",
    "dropphycty": "KEENES",
    "dropphyst": "IL",
    "dropphyzpp": 628519998,
    "dropmaladd": "400 SYCAMORE ST",
    "dropmalcty": "KEENES",
    "dropmalst": "IL",
    "dropmalzpp": 628519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188952554,
    "dropsitcph": 6188952554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13527",
    "droptype": "D",
    "dropname": "KEENSBURG",
    "dropdeladd": "9337 W MARKET ST",
    "dropdelcty": "KEENSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 628529998,
    "dropphyadd": "9337 W MARKET ST",
    "dropphycty": "KEENSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 628529998,
    "dropmaladd": "9337 W MARKET ST",
    "dropmalcty": "KEENSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 628529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182982090,
    "dropsitcph": 6182982090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13529",
    "droptype": "D",
    "dropname": "KEITHSBURG",
    "dropdeladd": "103 S 4TH ST",
    "dropdelcty": "KEITHSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 614429998,
    "dropphyadd": "103 S 4TH ST",
    "dropphycty": "KEITHSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 614429998,
    "dropmaladd": "103 S 4TH ST",
    "dropmalcty": "KEITHSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 614429998,
    "dropsitphn": 3095864611,
    "dropsitlph": 3093742261,
    "dropsitcph": 3093742261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13530",
    "droptype": "D",
    "dropname": "KELL",
    "dropdeladd": "303 3RD ST",
    "dropdelcty": "KELL",
    "dropdelst": "IL",
    "dropdelzpp": 628539998,
    "dropphyadd": "303 3RD ST",
    "dropphycty": "KELL",
    "dropphyst": "IL",
    "dropphyzpp": 628539998,
    "dropmaladd": "303 3RD ST",
    "dropmalcty": "KELL",
    "dropmalst": "IL",
    "dropmalzpp": 628539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188226878,
    "dropsitcph": 6188226878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13534",
    "droptype": "D",
    "dropname": "KEMPTON",
    "dropdeladd": "213 E MAIN ST",
    "dropdelcty": "KEMPTON",
    "dropdelst": "IL",
    "dropdelzpp": 609469800,
    "dropphyadd": "213 E MAIN ST",
    "dropphycty": "KEMPTON",
    "dropphyst": "IL",
    "dropphyzpp": 609469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEMPTON",
    "dropmalst": "IL",
    "dropmalzpp": 609469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152536240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13536",
    "droptype": "D",
    "dropname": "KENILWORTH",
    "dropdeladd": "408 GREEN BAY RD",
    "dropdelcty": "KENILWORTH",
    "dropdelst": "IL",
    "dropdelzpp": 600431098,
    "dropphyadd": "408 GREEN BAY RD",
    "dropphycty": "KENILWORTH",
    "dropphyst": "IL",
    "dropphyzpp": 600431098,
    "dropmaladd": "408 GREEN BAY RD",
    "dropmalcty": "KENILWORTH",
    "dropmalst": "IL",
    "dropmalzpp": 600431098,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472511370,
    "dropsitcph": 8472511370,
    "dropfax": 8472514302
  },
  {
    "dcode": "D",
    "dropkey": "PW13538",
    "droptype": "D",
    "dropname": "KENNEY",
    "dropdeladd": "208 S JOHNSTON ST",
    "dropdelcty": "KENNEY",
    "dropdelst": "IL",
    "dropdelzpp": 617499607,
    "dropphyadd": "208 S JOHNSTON ST",
    "dropphycty": "KENNEY",
    "dropphyst": "IL",
    "dropphyzpp": 617499607,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNEY",
    "dropmalst": "IL",
    "dropmalzpp": 617499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179442511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13539",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "767 N KENT RD",
    "dropdelcty": "KENT",
    "dropdelst": "IL",
    "dropdelzpp": 610449614,
    "dropphyadd": "767 N KENT RD",
    "dropphycty": "KENT",
    "dropphyst": "IL",
    "dropphyzpp": 610449614,
    "dropmaladd": "767 N KENT RD",
    "dropmalcty": "KENT",
    "dropmalst": "IL",
    "dropmalzpp": 610449614,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154432405,
    "dropsitcph": 8154432405,
    "dropfax": 8154432306
  },
  {
    "dcode": "D",
    "dropkey": "PW13542",
    "droptype": "D",
    "dropname": "KEWANEE",
    "dropdeladd": "116 S TREMONT ST",
    "dropdelcty": "KEWANEE",
    "dropdelst": "IL",
    "dropdelzpp": 614439998,
    "dropphyadd": "116 S TREMONT ST",
    "dropphycty": "KEWANEE",
    "dropphyst": "IL",
    "dropphyzpp": 614439998,
    "dropmaladd": "116 S TREMONT ST",
    "dropmalcty": "KEWANEE",
    "dropmalst": "IL",
    "dropmalzpp": 614439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3098522466,
    "dropfax": 3098565060
  },
  {
    "dcode": "D",
    "dropkey": "PW13543",
    "droptype": "D",
    "dropname": "KEYESPORT",
    "dropdeladd": "401 WASHINGTON ST",
    "dropdelcty": "KEYESPORT",
    "dropdelst": "IL",
    "dropdelzpp": 622539998,
    "dropphyadd": "401 WASHINGTON ST",
    "dropphycty": "KEYESPORT",
    "dropphyst": "IL",
    "dropphyzpp": 622539998,
    "dropmaladd": "401 WASHINGTON ST",
    "dropmalcty": "KEYESPORT",
    "dropmalst": "IL",
    "dropmalzpp": 622539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187495252,
    "dropsitcph": 6187495252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13548",
    "droptype": "D",
    "dropname": "KILBOURNE",
    "dropdeladd": "109 N 5TH ST",
    "dropdelcty": "KILBOURNE",
    "dropdelst": "IL",
    "dropdelzpp": 626559998,
    "dropphyadd": "109 N 5TH ST",
    "dropphycty": "KILBOURNE",
    "dropphyst": "IL",
    "dropphyzpp": 626559998,
    "dropmaladd": "109 N 5TH ST",
    "dropmalcty": "KILBOURNE",
    "dropmalst": "IL",
    "dropmalzpp": 626559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 3095384414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13551",
    "droptype": "D",
    "dropname": "KINCAID",
    "dropdeladd": "607 DIAL ST",
    "dropdelcty": "KINCAID",
    "dropdelst": "IL",
    "dropdelzpp": 625409998,
    "dropphyadd": "607 DIAL ST",
    "dropphycty": "KINCAID",
    "dropphyst": "IL",
    "dropphyzpp": 625409998,
    "dropmaladd": "607 DIAL ST",
    "dropmalcty": "KINCAID",
    "dropmalst": "IL",
    "dropmalzpp": 625409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172372242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13552",
    "droptype": "D",
    "dropname": "KINDERHOOK",
    "dropdeladd": "185 S HARPER ST",
    "dropdelcty": "KINDERHOOK",
    "dropdelst": "IL",
    "dropdelzpp": 623459998,
    "dropphyadd": "185 S HARPER ST",
    "dropphycty": "KINDERHOOK",
    "dropphyst": "IL",
    "dropphyzpp": 623459998,
    "dropmaladd": "185 S HARPER ST",
    "dropmalcty": "KINDERHOOK",
    "dropmalst": "IL",
    "dropmalzpp": 623459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174325412,
    "dropsitcph": 2174325412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13557",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "430 E RAILROAD ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "IL",
    "dropdelzpp": 601457933,
    "dropphyadd": "430 E RAILROAD ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "IL",
    "dropphyzpp": 601457933,
    "dropmaladd": "430 E RAILROAD ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "IL",
    "dropmalzpp": 601457933,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157844301,
    "dropsitcph": 8157845711,
    "dropfax": 8157844206
  },
  {
    "dcode": "D",
    "dropkey": "PW13558",
    "droptype": "D",
    "dropname": "KINGSTON MINES",
    "dropdeladd": "209 WASHINGTON ST",
    "dropdelcty": "KINGSTON MINES",
    "dropdelst": "IL",
    "dropdelzpp": 615399800,
    "dropphyadd": "209 WASHINGTON ST",
    "dropphycty": "KINGSTON MINES",
    "dropphyst": "IL",
    "dropphyzpp": 615399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSTON MINES",
    "dropmalst": "IL",
    "dropmalzpp": 615399998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093894160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13560",
    "droptype": "D",
    "dropname": "KINMUNDY",
    "dropdeladd": "109 W 3RD ST",
    "dropdelcty": "KINMUNDY",
    "dropdelst": "IL",
    "dropdelzpp": 628549998,
    "dropphyadd": "109 W 3RD ST",
    "dropphycty": "KINMUNDY",
    "dropphyst": "IL",
    "dropphyzpp": 628549998,
    "dropmaladd": "109 W 3RD ST",
    "dropmalcty": "KINMUNDY",
    "dropmalst": "IL",
    "dropmalzpp": 628549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185473322,
    "dropsitcph": 6185473322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13561",
    "droptype": "D",
    "dropname": "KINSMAN",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "KINSMAN",
    "dropdelst": "IL",
    "dropdelzpp": 604379998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "KINSMAN",
    "dropphyst": "IL",
    "dropphyzpp": 604379998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "KINSMAN",
    "dropmalst": "IL",
    "dropmalzpp": 604379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8153924279,
    "dropfax": 8153924279
  },
  {
    "dcode": "D",
    "dropkey": "PW13562",
    "droptype": "D",
    "dropname": "KIRKLAND",
    "dropdeladd": "508 W MAIN ST",
    "dropdelcty": "KIRKLAND",
    "dropdelst": "IL",
    "dropdelzpp": 601468658,
    "dropphyadd": "508 W MAIN ST",
    "dropphycty": "KIRKLAND",
    "dropphyst": "IL",
    "dropphyzpp": 601468658,
    "dropmaladd": "508 W MAIN ST",
    "dropmalcty": "KIRKLAND",
    "dropmalst": "IL",
    "dropmalzpp": 601468658,
    "dropsitphn": 8155223328,
    "dropsitlph": 8155223328,
    "dropsitcph": 8155223328,
    "dropfax": 8155229025
  },
  {
    "dcode": "D",
    "dropkey": "PW13563",
    "droptype": "D",
    "dropname": "KIRKWOOD",
    "dropdeladd": "131 S KIRK ST",
    "dropdelcty": "KIRKWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 614479800,
    "dropphyadd": "131 S KIRK ST",
    "dropphycty": "KIRKWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 614479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRKWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 614479998,
    "dropsitphn": 3097344312,
    "dropsitlph": 3097682526,
    "dropsitcph": 3097682526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13569",
    "droptype": "D",
    "dropname": "KNOXVILLE",
    "dropdeladd": "121 N PUBLIC SQ",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 614489800,
    "dropphyadd": "121 N PUBLIC SQ",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 614489800,
    "dropmaladd": "121 N PUBLIC SQ",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 614489800,
    "dropsitphn": 3092892612,
    "dropsitlph": 7085637318,
    "dropsitcph": 3092892612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13576",
    "droptype": "D",
    "dropname": "LA FAYETTE",
    "dropdeladd": "301 COMMERCIAL ST",
    "dropdelcty": "LA FAYETTE",
    "dropdelst": "IL",
    "dropdelzpp": 614499800,
    "dropphyadd": "301 COMMERCIAL ST",
    "dropphycty": "LA FAYETTE",
    "dropphyst": "IL",
    "dropphyzpp": 614499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA FAYETTE",
    "dropmalst": "IL",
    "dropmalzpp": 614499998,
    "dropsitphn": 3099953334,
    "dropsitlph": 3099953334,
    "dropsitcph": 3099953334,
    "dropfax": 3099953334
  },
  {
    "dcode": "D",
    "dropkey": "PW13578",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "121 W HILLGROVE AVE",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "IL",
    "dropdelzpp": 605259998,
    "dropphyadd": "121 W HILLGROVE AVE",
    "dropphycty": "LA GRANGE",
    "dropphyst": "IL",
    "dropphyzpp": 605259998,
    "dropmaladd": "121 W HILLGROVE AVE",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "IL",
    "dropmalzpp": 605259998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083523611,
    "dropfax": 7083523669
  },
  {
    "dcode": "D",
    "dropkey": "PW13586",
    "droptype": "D",
    "dropname": "LA HARPE",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "LA HARPE",
    "dropdelst": "IL",
    "dropdelzpp": 614509800,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "LA HARPE",
    "dropphyst": "IL",
    "dropphyzpp": 614509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA HARPE",
    "dropmalst": "IL",
    "dropmalzpp": 614509998,
    "dropsitphn": 2176597720,
    "dropsitlph": 2176597720,
    "dropsitcph": 2176597720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13587",
    "droptype": "D",
    "dropname": "LA MOILLE",
    "dropdeladd": "98 FRANKLIN ST",
    "dropdelcty": "LA MOILLE",
    "dropdelst": "IL",
    "dropdelzpp": 613309701,
    "dropphyadd": "98 FRANKLIN ST",
    "dropphycty": "LA MOILLE",
    "dropphyst": "IL",
    "dropphyzpp": 613309701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA MOILLE",
    "dropmalst": "IL",
    "dropmalzpp": 613309998,
    "dropsitphn": 8156382120,
    "dropsitlph": 8156382120,
    "dropsitcph": 8156382120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13588",
    "droptype": "D",
    "dropname": "LA PLACE",
    "dropdeladd": "110 E FRONT ST",
    "dropdelcty": "LA PLACE",
    "dropdelst": "IL",
    "dropdelzpp": 619369998,
    "dropphyadd": "110 E FRONT ST",
    "dropphycty": "LA PLACE",
    "dropphyst": "IL",
    "dropphyzpp": 619369998,
    "dropmaladd": "110 E FRONT ST",
    "dropmalcty": "LA PLACE",
    "dropmalst": "IL",
    "dropmalzpp": 619369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176772211,
    "dropfax": 2176772153
  },
  {
    "dcode": "D",
    "dropkey": "PW13590",
    "droptype": "D",
    "dropname": "LA ROSE",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "LA ROSE",
    "dropdelst": "IL",
    "dropdelzpp": 615419800,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "LA ROSE",
    "dropphyst": "IL",
    "dropphyzpp": 615419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA ROSE",
    "dropmalst": "IL",
    "dropmalzpp": 615419998,
    "dropsitphn": 3093997471,
    "dropsitlph": 3093997471,
    "dropsitcph": 3093997471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13592",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "2950 CHARTRES ST",
    "dropdelcty": "LA SALLE",
    "dropdelst": "IL",
    "dropdelzpp": 613019998,
    "dropphyadd": "2950 CHARTRES ST",
    "dropphycty": "LA SALLE",
    "dropphyst": "IL",
    "dropphyzpp": 613019998,
    "dropmaladd": "2950 CHARTRES ST",
    "dropmalcty": "LA SALLE",
    "dropmalst": "IL",
    "dropmalzpp": 613019998,
    "dropsitphn": 8152232635,
    "dropsitlph": 7085637318,
    "dropsitcph": 8152232635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13594",
    "droptype": "D",
    "dropname": "LACON",
    "dropdeladd": "209 N WASHINGTON ST",
    "dropdelcty": "LACON",
    "dropdelst": "IL",
    "dropdelzpp": 615409998,
    "dropphyadd": "209 N WASHINGTON ST",
    "dropphycty": "LACON",
    "dropphyst": "IL",
    "dropphyzpp": 615409998,
    "dropmaladd": "209 N WASHINGTON ST",
    "dropmalcty": "LACON",
    "dropmalst": "IL",
    "dropmalzpp": 615409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092467312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13595",
    "droptype": "D",
    "dropname": "LADD",
    "dropdeladd": "233 N MAIN AVE",
    "dropdelcty": "LADD",
    "dropdelst": "IL",
    "dropdelzpp": 613299998,
    "dropphyadd": "233 N MAIN AVE",
    "dropphycty": "LADD",
    "dropphyst": "IL",
    "dropphyzpp": 613299998,
    "dropmaladd": "233 N MAIN AVE",
    "dropmalcty": "LADD",
    "dropmalst": "IL",
    "dropmalzpp": 613299998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158943030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13597",
    "droptype": "D",
    "dropname": "LAFOX",
    "dropdeladd": "1N279 LAFOX RD",
    "dropdelcty": "LAFOX",
    "dropdelst": "IL",
    "dropdelzpp": 601471000,
    "dropphyadd": "1N279 LAFOX RD",
    "dropphycty": "LAFOX",
    "dropphyst": "IL",
    "dropphyzpp": 601471000,
    "dropmaladd": "1N279 LAFOX RD",
    "dropmalcty": "LAFOX",
    "dropmalst": "IL",
    "dropmalzpp": 601471000,
    "dropsitphn": 6302605499,
    "dropsitlph": 6302321088,
    "dropsitcph": 6302321088,
    "dropfax": 6302321088
  },
  {
    "dcode": "D",
    "dropkey": "PW13602",
    "droptype": "D",
    "dropname": "LAKE BLUFF",
    "dropdeladd": "26 E SCRANTON AVE",
    "dropdelcty": "LAKE BLUFF",
    "dropdelst": "IL",
    "dropdelzpp": 600441788,
    "dropphyadd": "26 E SCRANTON AVE",
    "dropphycty": "LAKE BLUFF",
    "dropphyst": "IL",
    "dropphyzpp": 600441788,
    "dropmaladd": "26 E SCRANTON AVE",
    "dropmalcty": "LAKE BLUFF",
    "dropmalst": "IL",
    "dropmalzpp": 600441788,
    "dropsitphn": "",
    "dropsitlph": 8472342779,
    "dropsitcph": 8472342779,
    "dropfax": 8472342894
  },
  {
    "dcode": "D",
    "dropkey": "PW13607",
    "droptype": "D",
    "dropname": "LAKE FOREST",
    "dropdeladd": "230 NORTHGATE ST",
    "dropdelcty": "LAKE FOREST",
    "dropdelst": "IL",
    "dropdelzpp": 600451858,
    "dropphyadd": "230 NORTHGATE ST",
    "dropphycty": "LAKE FOREST",
    "dropphyst": "IL",
    "dropphyzpp": 600451858,
    "dropmaladd": "230 NORTHGATE ST",
    "dropmalcty": "LAKE FOREST",
    "dropmalst": "IL",
    "dropmalzpp": 600459998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472340454,
    "dropsitcph": 8472340454,
    "dropfax": 8472340782
  },
  {
    "dcode": "D",
    "dropkey": "PW13608",
    "droptype": "D",
    "dropname": "LAKE FORK",
    "dropdeladd": "201 OAK ST",
    "dropdelcty": "LAKE FORK",
    "dropdelst": "IL",
    "dropdelzpp": 625419998,
    "dropphyadd": "201 OAK ST",
    "dropphycty": "LAKE FORK",
    "dropphyst": "IL",
    "dropphyzpp": 625419998,
    "dropmaladd": "201 OAK ST",
    "dropmalcty": "LAKE FORK",
    "dropmalst": "IL",
    "dropmalzpp": 625419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177923933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13619",
    "droptype": "D",
    "dropname": "LAKE VILLA",
    "dropdeladd": "206 CEDAR AVE",
    "dropdelcty": "LAKE VILLA",
    "dropdelst": "IL",
    "dropdelzpp": 600468448,
    "dropphyadd": "206 CEDAR AVE",
    "dropphycty": "LAKE VILLA",
    "dropphyst": "IL",
    "dropphyzpp": 600468448,
    "dropmaladd": "206 CEDAR AVE",
    "dropmalcty": "LAKE VILLA",
    "dropmalst": "IL",
    "dropmalzpp": 600468448,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473565995,
    "dropsitcph": 8473565995,
    "dropfax": 8473566349
  },
  {
    "dcode": "D",
    "dropkey": "PW13621",
    "droptype": "D",
    "dropname": "LAKE ZURICH",
    "dropdeladd": "25 TELSER RD",
    "dropdelcty": "LAKE ZURICH",
    "dropdelst": "IL",
    "dropdelzpp": 600471510,
    "dropphyadd": "25 TELSER RD",
    "dropphycty": "LAKE ZURICH",
    "dropphyst": "IL",
    "dropphyzpp": 600471510,
    "dropmaladd": "25 TELSER RD",
    "dropmalcty": "LAKE ZURICH",
    "dropmalst": "IL",
    "dropmalzpp": 600471510,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474385455,
    "dropsitcph": 8474385225,
    "dropfax": 8474381661
  },
  {
    "dcode": "D",
    "dropkey": "PW13632",
    "droptype": "D",
    "dropname": "LANARK",
    "dropdeladd": "600 W OLYMPIC DR",
    "dropdelcty": "LANARK",
    "dropdelst": "IL",
    "dropdelzpp": 610469122,
    "dropphyadd": "600 W OLYMPIC DR",
    "dropphycty": "LANARK",
    "dropphyst": "IL",
    "dropphyzpp": 610469122,
    "dropmaladd": "600 W OLYMPIC DR",
    "dropmalcty": "LANARK",
    "dropmalst": "IL",
    "dropmalzpp": 610469122,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154932550,
    "dropsitcph": 8154936726,
    "dropfax": 8154932006
  },
  {
    "dcode": "D",
    "dropkey": "PW13635",
    "droptype": "D",
    "dropname": "LANE",
    "dropdeladd": "215 1ST ST",
    "dropdelcty": "LANE",
    "dropdelst": "IL",
    "dropdelzpp": 617509998,
    "dropphyadd": "215 1ST ST",
    "dropphycty": "LANE",
    "dropphyst": "IL",
    "dropphyzpp": 617509998,
    "dropmaladd": "215 1ST ST",
    "dropmalcty": "LANE",
    "dropmalst": "IL",
    "dropmalzpp": 617509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179354115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13638",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "18125 ROY ST",
    "dropdelcty": "LANSING",
    "dropdelst": "IL",
    "dropdelzpp": 604389998,
    "dropphyadd": "18125 ROY ST",
    "dropphycty": "LANSING",
    "dropphyst": "IL",
    "dropphyzpp": 604389998,
    "dropmaladd": "18125 ROY ST",
    "dropmalcty": "LANSING",
    "dropmalst": "IL",
    "dropmalzpp": 604389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084740080,
    "dropfax": 7084746750
  },
  {
    "dcode": "D",
    "dropkey": "PW13643",
    "droptype": "D",
    "dropname": "LATHAM",
    "dropdeladd": "221 N MACON ST",
    "dropdelcty": "LATHAM",
    "dropdelst": "IL",
    "dropdelzpp": 625439998,
    "dropphyadd": "221 N MACON ST",
    "dropphycty": "LATHAM",
    "dropphyst": "IL",
    "dropphyzpp": 625439998,
    "dropmaladd": "221 N MACON ST",
    "dropmalcty": "LATHAM",
    "dropmalst": "IL",
    "dropmalzpp": 625439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176743785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13645",
    "droptype": "D",
    "dropname": "LAURA",
    "dropdeladd": "21014 MAPLE ST",
    "dropdelcty": "LAURA",
    "dropdelst": "IL",
    "dropdelzpp": 614519800,
    "dropphyadd": "21014 MAPLE ST",
    "dropphycty": "LAURA",
    "dropphyst": "IL",
    "dropphyzpp": 614519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAURA",
    "dropmalst": "IL",
    "dropmalzpp": 614519998,
    "dropsitphn": 3094463925,
    "dropsitlph": 3094463925,
    "dropsitcph": 3094463925,
    "dropfax": 3094463925
  },
  {
    "dcode": "D",
    "dropkey": "PW13647",
    "droptype": "D",
    "dropname": "LAWNDALE",
    "dropdeladd": "10 S LINCOLN ST",
    "dropdelcty": "LAWNDALE",
    "dropdelst": "IL",
    "dropdelzpp": 617519900,
    "dropphyadd": "10 S LINCOLN ST",
    "dropphycty": "LAWNDALE",
    "dropphyst": "IL",
    "dropphyzpp": 617519900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWNDALE",
    "dropmalst": "IL",
    "dropmalzpp": 617519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2177353239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13649",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE",
    "dropdeladd": "1014 JEFFERSON ST",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 624399998,
    "dropphyadd": "1014 JEFFERSON ST",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 624399998,
    "dropmaladd": "1014 JEFFERSON ST",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 624399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189432912,
    "dropsitcph": 6189432912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13651",
    "droptype": "D",
    "dropname": "LE ROY",
    "dropdeladd": "104 E CHERRY ST",
    "dropdelcty": "LE ROY",
    "dropdelst": "IL",
    "dropdelzpp": 617529998,
    "dropphyadd": "104 E CHERRY ST",
    "dropphycty": "LE ROY",
    "dropphyst": "IL",
    "dropphyzpp": 617529998,
    "dropmaladd": "104 E CHERRY ST",
    "dropmalcty": "LE ROY",
    "dropmalst": "IL",
    "dropmalzpp": 617529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099629141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13653",
    "droptype": "D",
    "dropname": "LEAF RIVER",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "LEAF RIVER",
    "dropdelst": "IL",
    "dropdelzpp": 610479793,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "LEAF RIVER",
    "dropphyst": "IL",
    "dropphyzpp": 610479793,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "LEAF RIVER",
    "dropmalst": "IL",
    "dropmalzpp": 610479793,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157382249,
    "dropsitcph": 8157382249,
    "dropfax": 8157382206
  },
  {
    "dcode": "D",
    "dropkey": "PW13654",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "201 E SAINT LOUIS ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "IL",
    "dropdelzpp": 622549998,
    "dropphyadd": "201 E SAINT LOUIS ST",
    "dropphycty": "LEBANON",
    "dropphyst": "IL",
    "dropphyzpp": 622549998,
    "dropmaladd": "201 E SAINT LOUIS ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "IL",
    "dropmalzpp": 622549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185374439,
    "dropsitcph": 6185374439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13656",
    "droptype": "D",
    "dropname": "LEE",
    "dropdeladd": "105 E LEE RD",
    "dropdelcty": "LEE",
    "dropdelst": "IL",
    "dropdelzpp": 605309998,
    "dropphyadd": "105 E LEE RD",
    "dropphycty": "LEE",
    "dropphyst": "IL",
    "dropphyzpp": 605309998,
    "dropmaladd": "105 E LEE RD",
    "dropmalcty": "LEE",
    "dropmalst": "IL",
    "dropmalzpp": 605309998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158242828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13657",
    "droptype": "D",
    "dropname": "LEE CENTER",
    "dropdeladd": "1132 INLET RD",
    "dropdelcty": "LEE CENTER",
    "dropdelst": "IL",
    "dropdelzpp": 613319998,
    "dropphyadd": "1132 INLET RD",
    "dropphycty": "LEE CENTER",
    "dropphyst": "IL",
    "dropphyzpp": 613319998,
    "dropmaladd": "1132 INLET RD",
    "dropmalcty": "LEE CENTER",
    "dropmalst": "IL",
    "dropmalzpp": 613319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158572640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13659",
    "droptype": "D",
    "dropname": "LELAND",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "LELAND",
    "dropdelst": "IL",
    "dropdelzpp": 605319998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "LELAND",
    "dropphyst": "IL",
    "dropphyzpp": 605319998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "LELAND",
    "dropmalst": "IL",
    "dropmalzpp": 605319998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154959348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13661",
    "droptype": "D",
    "dropname": "BOLINGBROOK",
    "dropdeladd": "105 CANTERBURY LN",
    "dropdelcty": "BOLINGBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 604409998,
    "dropphyadd": "105 CANTERBURY LN",
    "dropphycty": "BOLINGBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 604409998,
    "dropmaladd": "105 CANTERBURY LN",
    "dropmalcty": "BOLINGBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 604409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 6307593811,
    "dropfax": 6307593625
  },
  {
    "dcode": "D",
    "dropkey": "PW13662",
    "droptype": "D",
    "dropname": "LENA",
    "dropdeladd": "913 S LOGAN ST",
    "dropdelcty": "LENA",
    "dropdelst": "IL",
    "dropdelzpp": 610489205,
    "dropphyadd": "913 S LOGAN ST",
    "dropphycty": "LENA",
    "dropphyst": "IL",
    "dropphyzpp": 610489205,
    "dropmaladd": "913 S LOGAN ST",
    "dropmalcty": "LENA",
    "dropmalst": "IL",
    "dropmalzpp": 610489205,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153692813,
    "dropsitcph": 8153692813,
    "dropfax": 8153699114
  },
  {
    "dcode": "D",
    "dropkey": "PW13663",
    "droptype": "D",
    "dropname": "LENZBURG",
    "dropdeladd": "312 N CHARLES ST",
    "dropdelcty": "LENZBURG",
    "dropdelst": "IL",
    "dropdelzpp": 622559998,
    "dropphyadd": "312 N CHARLES ST",
    "dropphycty": "LENZBURG",
    "dropphyst": "IL",
    "dropphyzpp": 622559998,
    "dropmaladd": "312 N CHARLES ST",
    "dropmalcty": "LENZBURG",
    "dropmalst": "IL",
    "dropmalzpp": 622559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184753309,
    "dropsitcph": 6184753309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13665",
    "droptype": "D",
    "dropname": "LEONORE",
    "dropdeladd": "402 GARY ST",
    "dropdelcty": "LEONORE",
    "dropdelst": "IL",
    "dropdelzpp": 613329998,
    "dropphyadd": "402 GARY ST",
    "dropphycty": "LEONORE",
    "dropphyst": "IL",
    "dropphyzpp": 613329998,
    "dropmaladd": "402 GARY ST",
    "dropmalcty": "LEONORE",
    "dropmalst": "IL",
    "dropmalzpp": 613329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158562539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13666",
    "droptype": "D",
    "dropname": "LERNA",
    "dropdeladd": "513 MAIN ST",
    "dropdelcty": "LERNA",
    "dropdelst": "IL",
    "dropdelzpp": 624409998,
    "dropphyadd": "513 MAIN ST",
    "dropphycty": "LERNA",
    "dropphyst": "IL",
    "dropphyzpp": 624409998,
    "dropmaladd": "513 MAIN ST",
    "dropmalcty": "LERNA",
    "dropmalst": "IL",
    "dropmalzpp": 624409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172351011,
    "dropsitcph": 2172351011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13668",
    "droptype": "D",
    "dropname": "LEWISTOWN",
    "dropdeladd": "301 N MAIN ST",
    "dropdelcty": "LEWISTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 615429998,
    "dropphyadd": "301 N MAIN ST",
    "dropphycty": "LEWISTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 615429998,
    "dropmaladd": "301 N MAIN ST",
    "dropmalcty": "LEWISTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 615429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3095472931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13669",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "301 W MAIN ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617539998,
    "dropphyadd": "301 W MAIN ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617539998,
    "dropmaladd": "301 W MAIN ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093653711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13672",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "407 S MAIN ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "IL",
    "dropdelzpp": 623479998,
    "dropphyadd": "407 S MAIN ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "IL",
    "dropphyzpp": 623479998,
    "dropmaladd": "407 S MAIN ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "IL",
    "dropmalzpp": 623479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176453633,
    "dropsitcph": 2176453633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13674",
    "droptype": "D",
    "dropname": "LIBERTYVILLE",
    "dropdeladd": "1520 ARTAIUS PKWY",
    "dropdelcty": "LIBERTYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 600485269,
    "dropphyadd": "1520 ARTAIUS PKWY",
    "dropphycty": "LIBERTYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 600485269,
    "dropmaladd": "1520 ARTAIUS PKWY",
    "dropmalcty": "LIBERTYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 600485269,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473622266,
    "dropsitcph": 8473622266,
    "dropfax": 8473627459
  },
  {
    "dcode": "D",
    "dropkey": "PW13681",
    "droptype": "D",
    "dropname": "LIMA",
    "dropdeladd": "1000 MAIN ST",
    "dropdelcty": "LIMA",
    "dropdelst": "IL",
    "dropdelzpp": 623489998,
    "dropphyadd": "1000 MAIN ST",
    "dropphycty": "LIMA",
    "dropphyst": "IL",
    "dropphyzpp": 623489998,
    "dropmaladd": "1000 MAIN ST",
    "dropmalcty": "LIMA",
    "dropmalst": "IL",
    "dropmalzpp": 623489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179854423,
    "dropsitcph": 2179854423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13684",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "102 S MCLEAN ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "IL",
    "dropdelzpp": 626569998,
    "dropphyadd": "102 S MCLEAN ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "IL",
    "dropphyzpp": 626569998,
    "dropmaladd": "102 S MCLEAN ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "IL",
    "dropmalzpp": 626569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177324912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13692",
    "droptype": "D",
    "dropname": "LINCOLNSHIRE",
    "dropdeladd": "125 SCHELTER RD",
    "dropdelcty": "LINCOLNSHIRE",
    "dropdelst": "IL",
    "dropdelzpp": 600693666,
    "dropphyadd": "125 SCHELTER RD",
    "dropphycty": "LINCOLNSHIRE",
    "dropphyst": "IL",
    "dropphyzpp": 600693666,
    "dropmaladd": "125 SCHELTER RD",
    "dropmalcty": "LINCOLNSHIRE",
    "dropmalst": "IL",
    "dropmalzpp": 600693666,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476343260,
    "dropsitcph": 8476343260,
    "dropfax": 8476343274
  },
  {
    "dcode": "D",
    "dropkey": "PW13697",
    "droptype": "D",
    "dropname": "LINDENWOOD",
    "dropdeladd": "104 S WALNUT ST",
    "dropdelcty": "LINDENWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 610499742,
    "dropphyadd": "104 S WALNUT ST",
    "dropphycty": "LINDENWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 610499742,
    "dropmaladd": "104 S WALNUT ST",
    "dropmalcty": "LINDENWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 610499742,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153934839,
    "dropsitcph": 8153934839,
    "dropfax": 8153934903
  },
  {
    "dcode": "D",
    "dropkey": "PW13705",
    "droptype": "D",
    "dropname": "LISLE",
    "dropdeladd": "817 OGDEN AVE",
    "dropdelcty": "LISLE",
    "dropdelst": "IL",
    "dropdelzpp": 605329998,
    "dropphyadd": "817 OGDEN AVE",
    "dropphycty": "LISLE",
    "dropphyst": "IL",
    "dropphyzpp": 605329998,
    "dropmaladd": "817 OGDEN AVE",
    "dropmalcty": "LISLE",
    "dropmalst": "IL",
    "dropmalzpp": 605329998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6309690548,
    "dropfax": 6309690720
  },
  {
    "dcode": "D",
    "dropkey": "PW13706",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "202 E KIRKHAM ST",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 620569998,
    "dropphyadd": "202 E KIRKHAM ST",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 620569998,
    "dropmaladd": "202 E KIRKHAM ST",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 620569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173242004,
    "dropsitcph": 2173242004,
    "dropfax": 2173242017
  },
  {
    "dcode": "D",
    "dropkey": "PW13713",
    "droptype": "D",
    "dropname": "LITTLE YORK",
    "dropdeladd": "102 N WALNUT",
    "dropdelcty": "LITTLE YORK",
    "dropdelst": "IL",
    "dropdelzpp": 614539870,
    "dropphyadd": "102 N WALNUT",
    "dropphycty": "LITTLE YORK",
    "dropphyst": "IL",
    "dropphyzpp": 614539870,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE YORK",
    "dropmalst": "IL",
    "dropmalzpp": 614539998,
    "dropsitphn": 3097295130,
    "dropsitlph": 3097295130,
    "dropsitcph": 3097295130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13714",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "LITTLETON",
    "dropdelst": "IL",
    "dropdelzpp": 614525076,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "LITTLETON",
    "dropphyst": "IL",
    "dropphyzpp": 614525076,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLETON",
    "dropmalst": "IL",
    "dropmalzpp": 614529998,
    "dropsitphn": 3092572226,
    "dropsitlph": 3092572226,
    "dropsitcph": 3092572226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13716",
    "droptype": "D",
    "dropname": "LIVERPOOL",
    "dropdeladd": "145 W CHESTNUT ST",
    "dropdelcty": "LIVERPOOL",
    "dropdelst": "IL",
    "dropdelzpp": 615439995,
    "dropphyadd": "145 W CHESTNUT ST",
    "dropphycty": "LIVERPOOL",
    "dropphyst": "IL",
    "dropphyzpp": 615439995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIVERPOOL",
    "dropmalst": "IL",
    "dropmalzpp": 615439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096682557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13717",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "482 PARK ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "IL",
    "dropdelzpp": 620589900,
    "dropphyadd": "482 PARK ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "IL",
    "dropphyzpp": 620589900,
    "dropmaladd": "482 PARK ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "IL",
    "dropmalzpp": 620589900,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186372135,
    "dropsitcph": 6186372135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13726",
    "droptype": "D",
    "dropname": "LOAMI",
    "dropdeladd": "100 CHURCH ST",
    "dropdelcty": "LOAMI",
    "dropdelst": "IL",
    "dropdelzpp": 626619998,
    "dropphyadd": "100 CHURCH ST",
    "dropphycty": "LOAMI",
    "dropphyst": "IL",
    "dropphyzpp": 626619998,
    "dropmaladd": "100 CHURCH ST",
    "dropmalcty": "LOAMI",
    "dropmalst": "IL",
    "dropmalzpp": 626619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176245851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13727",
    "droptype": "D",
    "dropname": "ROMEOVILLE",
    "dropdeladd": "315 W ROMEO RD",
    "dropdelcty": "ROMEOVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 604469998,
    "dropphyadd": "315 W ROMEO RD",
    "dropphycty": "ROMEOVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 604469998,
    "dropmaladd": "315 W ROMEO RD",
    "dropmalcty": "ROMEOVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 604469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158869040,
    "dropfax": 8153729862
  },
  {
    "dcode": "D",
    "dropkey": "PW13728",
    "droptype": "D",
    "dropname": "LODA",
    "dropdeladd": "203 N OAK ST",
    "dropdelcty": "LODA",
    "dropdelst": "IL",
    "dropdelzpp": 609489998,
    "dropphyadd": "203 N OAK ST",
    "dropphycty": "LODA",
    "dropphyst": "IL",
    "dropphyzpp": 609489998,
    "dropmaladd": "203 N OAK ST",
    "dropmalcty": "LODA",
    "dropmalst": "IL",
    "dropmalzpp": 609489998,
    "dropsitphn": 2173793131,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173862013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13730",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "6352 MAIN ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "IL",
    "dropdelzpp": 628569998,
    "dropphyadd": "6352 MAIN ST",
    "dropphycty": "LOGAN",
    "dropphyst": "IL",
    "dropphyzpp": 628569998,
    "dropmaladd": "6352 MAIN ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "IL",
    "dropmalzpp": 628569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184353212,
    "dropsitcph": 6184353212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13734",
    "droptype": "D",
    "dropname": "LOMAX",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "LOMAX",
    "dropdelst": "IL",
    "dropdelzpp": 614549800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "LOMAX",
    "dropphyst": "IL",
    "dropphyzpp": 614549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOMAX",
    "dropmalst": "IL",
    "dropmalzpp": 614549998,
    "dropsitphn": 2174493304,
    "dropsitlph": 2174493304,
    "dropsitcph": 2174493304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13735",
    "droptype": "D",
    "dropname": "LOMBARD",
    "dropdeladd": "380 E SAINT CHARLES RD",
    "dropdelcty": "LOMBARD",
    "dropdelst": "IL",
    "dropdelzpp": 601482375,
    "dropphyadd": "380 E SAINT CHARLES RD",
    "dropphycty": "LOMBARD",
    "dropphyst": "IL",
    "dropphyzpp": 601482375,
    "dropmaladd": "380 E SAINT CHARLES RD",
    "dropmalcty": "LOMBARD",
    "dropmalst": "IL",
    "dropmalzpp": 601482375,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306271864,
    "dropsitcph": 6306271864,
    "dropfax": 6306278934
  },
  {
    "dcode": "D",
    "dropkey": "PW13738",
    "droptype": "D",
    "dropname": "LONDON MILLS",
    "dropdeladd": "102 S 2ND ST",
    "dropdelcty": "LONDON MILLS",
    "dropdelst": "IL",
    "dropdelzpp": 615449995,
    "dropphyadd": "102 S 2ND ST",
    "dropphycty": "LONDON MILLS",
    "dropphyst": "IL",
    "dropphyzpp": 615449995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONDON MILLS",
    "dropmalst": "IL",
    "dropmalzpp": 615449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094863654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13748",
    "droptype": "D",
    "dropname": "LONG POINT",
    "dropdeladd": "414 S MAIN ST",
    "dropdelcty": "LONG POINT",
    "dropdelst": "IL",
    "dropdelzpp": 613339701,
    "dropphyadd": "414 S MAIN ST",
    "dropphycty": "LONG POINT",
    "dropphyst": "IL",
    "dropphyzpp": 613339701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG POINT",
    "dropmalst": "IL",
    "dropmalzpp": 613339998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158542443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13749",
    "droptype": "D",
    "dropname": "LONGVIEW",
    "dropdeladd": "204 E LOGAN ST",
    "dropdelcty": "LONGVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 618529998,
    "dropphyadd": "204 E LOGAN ST",
    "dropphycty": "LONGVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 618529998,
    "dropmaladd": "204 E LOGAN ST",
    "dropmalcty": "LONGVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 618529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178343312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13754",
    "droptype": "D",
    "dropname": "LORAINE",
    "dropdeladd": "113 N BROAD ST",
    "dropdelcty": "LORAINE",
    "dropdelst": "IL",
    "dropdelzpp": 623499998,
    "dropphyadd": "113 N BROAD ST",
    "dropphycty": "LORAINE",
    "dropphyst": "IL",
    "dropphyzpp": 623499998,
    "dropmaladd": "113 N BROAD ST",
    "dropmalcty": "LORAINE",
    "dropmalst": "IL",
    "dropmalzpp": 623499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179382915,
    "dropsitcph": 2179382915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13759",
    "droptype": "D",
    "dropname": "LOSTANT",
    "dropdeladd": "104 W 2ND ST",
    "dropdelcty": "LOSTANT",
    "dropdelst": "IL",
    "dropdelzpp": 613349700,
    "dropphyadd": "104 W 2ND ST",
    "dropphycty": "LOSTANT",
    "dropphyst": "IL",
    "dropphyzpp": 613349700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOSTANT",
    "dropmalst": "IL",
    "dropmalzpp": 613349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153683271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13761",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "150 E CHESTNUT ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628589998,
    "dropphyadd": "150 E CHESTNUT ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628589998,
    "dropmaladd": "150 E CHESTNUT ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186653354,
    "dropsitcph": 6186653354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13764",
    "droptype": "D",
    "dropname": "LOVEJOY",
    "dropdeladd": "413 S 3RD ST",
    "dropdelcty": "LOVEJOY",
    "dropdelst": "IL",
    "dropdelzpp": 620599998,
    "dropphyadd": "413 S 3RD ST",
    "dropphycty": "LOVEJOY",
    "dropphyst": "IL",
    "dropphyzpp": 620599998,
    "dropmaladd": "413 S 3RD ST",
    "dropmalcty": "LOVEJOY",
    "dropmalst": "IL",
    "dropmalzpp": 620599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188747993,
    "dropsitcph": 6188747993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13767",
    "droptype": "D",
    "dropname": "LOVINGTON",
    "dropdeladd": "101 E STATE ST",
    "dropdelcty": "LOVINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 619379998,
    "dropphyadd": "101 E STATE ST",
    "dropphycty": "LOVINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 619379998,
    "dropmaladd": "101 E STATE ST",
    "dropmalcty": "LOVINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 619379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178734499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13770",
    "droptype": "D",
    "dropname": "LOWPOINT",
    "dropdeladd": "1954 N GRANT ST",
    "dropdelcty": "LOWPOINT",
    "dropdelst": "IL",
    "dropdelzpp": 615459800,
    "dropphyadd": "1954 N GRANT ST",
    "dropphycty": "LOWPOINT",
    "dropphyst": "IL",
    "dropphyzpp": 615459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWPOINT",
    "dropmalst": "IL",
    "dropmalzpp": 615459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094435322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13771",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "113 E THOMAS ST",
    "dropdelcty": "LUDLOW",
    "dropdelst": "IL",
    "dropdelzpp": 609499998,
    "dropphyadd": "113 E THOMAS ST",
    "dropphycty": "LUDLOW",
    "dropphyst": "IL",
    "dropphyzpp": 609499998,
    "dropmaladd": "113 E THOMAS ST",
    "dropmalcty": "LUDLOW",
    "dropmalst": "IL",
    "dropmalzpp": 609499998,
    "dropsitphn": 2173793131,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173964141,
    "dropfax": 2173964141
  },
  {
    "dcode": "D",
    "dropkey": "PW13777",
    "droptype": "D",
    "dropname": "LYNDON",
    "dropdeladd": "409 2ND AVE E",
    "dropdelcty": "LYNDON",
    "dropdelst": "IL",
    "dropdelzpp": 612619000,
    "dropphyadd": "409 2ND AVE E",
    "dropphycty": "LYNDON",
    "dropphyst": "IL",
    "dropphyzpp": 612619000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNDON",
    "dropmalst": "IL",
    "dropmalzpp": 612619998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8153365820,
    "dropsitcph": 8153365820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13779",
    "droptype": "D",
    "dropname": "LYNN CENTER",
    "dropdeladd": "404 SOUTH ST",
    "dropdelcty": "LYNN CENTER",
    "dropdelst": "IL",
    "dropdelzpp": 612629706,
    "dropphyadd": "404 SOUTH ST",
    "dropphycty": "LYNN CENTER",
    "dropphyst": "IL",
    "dropphyzpp": 612629706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNN CENTER",
    "dropmalst": "IL",
    "dropmalzpp": 612629998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3094768646,
    "dropsitcph": 3094768646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13783",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "7836 OGDEN AVE",
    "dropdelcty": "LYONS",
    "dropdelst": "IL",
    "dropdelzpp": 605349998,
    "dropphyadd": "7836 OGDEN AVE",
    "dropphycty": "LYONS",
    "dropphyst": "IL",
    "dropphyzpp": 605349998,
    "dropmaladd": "7836 OGDEN AVE",
    "dropmalcty": "LYONS",
    "dropmalst": "IL",
    "dropmalzpp": 605349998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 7084425400,
    "dropfax": 7084425480
  },
  {
    "dcode": "D",
    "dropkey": "PW13786",
    "droptype": "D",
    "dropname": "MACEDONIA",
    "dropdeladd": "106 E BENTON ST",
    "dropdelcty": "MACEDONIA",
    "dropdelst": "IL",
    "dropdelzpp": 628609998,
    "dropphyadd": "106 E BENTON ST",
    "dropphycty": "MACEDONIA",
    "dropphyst": "IL",
    "dropphyzpp": 628609998,
    "dropmaladd": "106 E BENTON ST",
    "dropmalcty": "MACEDONIA",
    "dropmalst": "IL",
    "dropmalzpp": 628609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187284490,
    "dropsitcph": 6187284490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13790",
    "droptype": "D",
    "dropname": "MACKINAW",
    "dropdeladd": "110 S MAIN ST",
    "dropdelcty": "MACKINAW",
    "dropdelst": "IL",
    "dropdelzpp": 617559900,
    "dropphyadd": "110 S MAIN ST",
    "dropphycty": "MACKINAW",
    "dropphyst": "IL",
    "dropphyzpp": 617559900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACKINAW",
    "dropmalst": "IL",
    "dropmalzpp": 617559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093596431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13791",
    "droptype": "D",
    "dropname": "MACOMB",
    "dropdeladd": "205 S RANDOLPH ST",
    "dropdelcty": "MACOMB",
    "dropdelst": "IL",
    "dropdelzpp": 614559998,
    "dropphyadd": "205 S RANDOLPH ST",
    "dropphycty": "MACOMB",
    "dropphyst": "IL",
    "dropphyzpp": 614559998,
    "dropmaladd": "205 S RANDOLPH ST",
    "dropmalcty": "MACOMB",
    "dropmalst": "IL",
    "dropmalzpp": 614559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3098335593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13792",
    "droptype": "D",
    "dropname": "MACON",
    "dropdeladd": "101 W DUNN ST",
    "dropdelcty": "MACON",
    "dropdelst": "IL",
    "dropdelzpp": 625449998,
    "dropphyadd": "101 W DUNN ST",
    "dropphycty": "MACON",
    "dropphyst": "IL",
    "dropphyzpp": 625449998,
    "dropmaladd": "101 W DUNN ST",
    "dropmalcty": "MACON",
    "dropmalst": "IL",
    "dropmalzpp": 625449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177643823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13793",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "549 MADISON AVE",
    "dropdelcty": "MADISON",
    "dropdelst": "IL",
    "dropdelzpp": 620609998,
    "dropphyadd": "549 MADISON AVE",
    "dropphycty": "MADISON",
    "dropphyst": "IL",
    "dropphyzpp": 620609998,
    "dropmaladd": "549 MADISON AVE",
    "dropmalcty": "MADISON",
    "dropmalst": "IL",
    "dropmalzpp": 620609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188766332,
    "dropsitcph": 6188766332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13796",
    "droptype": "D",
    "dropname": "MAEYSTOWN",
    "dropdeladd": "941 MILL ST",
    "dropdelcty": "MAEYSTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 622569998,
    "dropphyadd": "941 MILL ST",
    "dropphycty": "MAEYSTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 622569998,
    "dropmaladd": "941 MILL ST",
    "dropmalcty": "MAEYSTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 622569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184586968,
    "dropsitcph": 6184586968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13799",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "106 N CHICAGO ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "IL",
    "dropdelzpp": 613369682,
    "dropphyadd": "106 N CHICAGO ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "IL",
    "dropphyzpp": 613369682,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "IL",
    "dropmalzpp": 613369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158693311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13800",
    "droptype": "D",
    "dropname": "MAHOMET",
    "dropdeladd": "304 E MAIN ST",
    "dropdelcty": "MAHOMET",
    "dropdelst": "IL",
    "dropdelzpp": 618539998,
    "dropphyadd": "304 E MAIN ST",
    "dropphycty": "MAHOMET",
    "dropphyst": "IL",
    "dropphyzpp": 618539998,
    "dropmaladd": "304 E MAIN ST",
    "dropmalcty": "MAHOMET",
    "dropmalst": "IL",
    "dropmalzpp": 618539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175863213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13803",
    "droptype": "D",
    "dropname": "MAKANDA",
    "dropdeladd": "709 MAKANDA RD",
    "dropdelcty": "MAKANDA",
    "dropdelst": "IL",
    "dropdelzpp": 629589998,
    "dropphyadd": "709 MAKANDA RD",
    "dropphycty": "MAKANDA",
    "dropphyst": "IL",
    "dropphyzpp": 629589998,
    "dropmaladd": "709 MAKANDA RD",
    "dropmalcty": "MAKANDA",
    "dropmalst": "IL",
    "dropmalzpp": 629589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184575348,
    "dropsitcph": 6184575348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13804",
    "droptype": "D",
    "dropname": "MALDEN",
    "dropdeladd": "221 W MAIN ST",
    "dropdelcty": "MALDEN",
    "dropdelst": "IL",
    "dropdelzpp": 613379026,
    "dropphyadd": "221 W MAIN ST",
    "dropphycty": "MALDEN",
    "dropphyst": "IL",
    "dropphyzpp": 613379026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALDEN",
    "dropmalst": "IL",
    "dropmalzpp": 613379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156432161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13805",
    "droptype": "D",
    "dropname": "MALTA",
    "dropdeladd": "403 E ADAMS ST",
    "dropdelcty": "MALTA",
    "dropdelst": "IL",
    "dropdelzpp": 601501000,
    "dropphyadd": "403 E ADAMS ST",
    "dropphycty": "MALTA",
    "dropphyst": "IL",
    "dropphyzpp": 601501000,
    "dropmaladd": "403 E ADAMS ST",
    "dropmalcty": "MALTA",
    "dropmalst": "IL",
    "dropmalzpp": 601501000,
    "dropsitphn": 8157586677,
    "dropsitlph": 8158252446,
    "dropsitcph": 8158252446,
    "dropfax": 8158259071
  },
  {
    "dcode": "D",
    "dropkey": "PW13807",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 626639998,
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 626639998,
    "dropmaladd": "308 MAIN ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 626639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175873441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13808",
    "droptype": "D",
    "dropname": "MANHATTAN",
    "dropdeladd": "185 S STATE ST",
    "dropdelcty": "MANHATTAN",
    "dropdelst": "IL",
    "dropdelzpp": 604429998,
    "dropphyadd": "185 S STATE ST",
    "dropphycty": "MANHATTAN",
    "dropphyst": "IL",
    "dropphyzpp": 604429998,
    "dropmaladd": "185 S STATE ST",
    "dropmalcty": "MANHATTAN",
    "dropmalst": "IL",
    "dropmalzpp": 604429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154783112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13809",
    "droptype": "D",
    "dropname": "MANITO",
    "dropdeladd": "115 E MARKET ST",
    "dropdelcty": "MANITO",
    "dropdelst": "IL",
    "dropdelzpp": 615469244,
    "dropphyadd": "115 E MARKET ST",
    "dropphycty": "MANITO",
    "dropphyst": "IL",
    "dropphyzpp": 615469244,
    "dropmaladd": "115 E MARKET ST",
    "dropmalcty": "MANITO",
    "dropmalst": "IL",
    "dropmalzpp": 615469244,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099686680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13810",
    "droptype": "D",
    "dropname": "MANLIUS",
    "dropdeladd": "107 E MAPLE AVE",
    "dropdelcty": "MANLIUS",
    "dropdelst": "IL",
    "dropdelzpp": 613389700,
    "dropphyadd": "107 E MAPLE AVE",
    "dropphycty": "MANLIUS",
    "dropphyst": "IL",
    "dropphyzpp": 613389700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANLIUS",
    "dropmalst": "IL",
    "dropmalzpp": 613389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154454781,
    "dropfax": 8154454781
  },
  {
    "dcode": "D",
    "dropkey": "PW13811",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "102 W OLIVER ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 618549998,
    "dropphyadd": "102 W OLIVER ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 618549998,
    "dropmaladd": "102 W OLIVER ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 618549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174899023,
    "dropfax": 2174899233
  },
  {
    "dcode": "D",
    "dropkey": "PW13812",
    "droptype": "D",
    "dropname": "MANTENO",
    "dropdeladd": "157 N MAIN ST",
    "dropdelcty": "MANTENO",
    "dropdelst": "IL",
    "dropdelzpp": 609509998,
    "dropphyadd": "157 N MAIN ST",
    "dropphycty": "MANTENO",
    "dropphyst": "IL",
    "dropphyzpp": 609509998,
    "dropmaladd": "157 N MAIN ST",
    "dropmalcty": "MANTENO",
    "dropmalst": "IL",
    "dropmalzpp": 609509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8154688222,
    "dropfax": 8154687958
  },
  {
    "dcode": "D",
    "dropkey": "PW13815",
    "droptype": "D",
    "dropname": "MAPLE PARK",
    "dropdeladd": "321 MAIN ST",
    "dropdelcty": "MAPLE PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601517674,
    "dropphyadd": "321 MAIN ST",
    "dropphycty": "MAPLE PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601517674,
    "dropmaladd": "321 MAIN ST",
    "dropmalcty": "MAPLE PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601517674,
    "dropsitphn": 6303656360,
    "dropsitlph": 8158273525,
    "dropsitcph": 8158273525,
    "dropfax": 8158273723
  },
  {
    "dcode": "D",
    "dropkey": "PW13819",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "8607 W MAIN ST",
    "dropdelcty": "MAPLETON",
    "dropdelst": "IL",
    "dropdelzpp": 615479305,
    "dropphyadd": "8607 W MAIN ST",
    "dropphycty": "MAPLETON",
    "dropphyst": "IL",
    "dropphyzpp": 615479305,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLETON",
    "dropmalst": "IL",
    "dropmalzpp": 615479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096970042,
    "dropfax": 3096970042
  },
  {
    "dcode": "D",
    "dropkey": "PW13820",
    "droptype": "D",
    "dropname": "MAQUON",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "MAQUON",
    "dropdelst": "IL",
    "dropdelzpp": 614589800,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "MAQUON",
    "dropphyst": "IL",
    "dropphyzpp": 614589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAQUON",
    "dropmalst": "IL",
    "dropmalzpp": 614589998,
    "dropsitphn": 3098753269,
    "dropsitlph": 3098753269,
    "dropsitcph": 3098753269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13825",
    "droptype": "D",
    "dropname": "MARENGO",
    "dropdeladd": "223 E GRANT HWY",
    "dropdelcty": "MARENGO",
    "dropdelst": "IL",
    "dropdelzpp": 601523371,
    "dropphyadd": "223 E GRANT HWY",
    "dropphycty": "MARENGO",
    "dropphyst": "IL",
    "dropphyzpp": 601523371,
    "dropmaladd": "223 E GRANT HWY",
    "dropmalcty": "MARENGO",
    "dropmalst": "IL",
    "dropmalzpp": 601523371,
    "dropsitphn": 8155687449,
    "dropsitlph": 8155687449,
    "dropsitcph": 8155687449,
    "dropfax": 8155680059
  },
  {
    "dcode": "D",
    "dropkey": "PW13826",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "107 W COAL ST",
    "dropdelcty": "MARIETTA",
    "dropdelst": "IL",
    "dropdelzpp": 614599800,
    "dropphyadd": "107 W COAL ST",
    "dropphycty": "MARIETTA",
    "dropphyst": "IL",
    "dropphyzpp": 614599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARIETTA",
    "dropmalst": "IL",
    "dropmalzpp": 614599998,
    "dropsitphn": 3099267711,
    "dropsitlph": 3099267711,
    "dropsitcph": 3099267711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13827",
    "droptype": "D",
    "dropname": "MARINE",
    "dropdeladd": "120 E MAGNOLIA ST",
    "dropdelcty": "MARINE",
    "dropdelst": "IL",
    "dropdelzpp": 620619998,
    "dropphyadd": "120 E MAGNOLIA ST",
    "dropphycty": "MARINE",
    "dropphyst": "IL",
    "dropphyzpp": 620619998,
    "dropmaladd": "120 E MAGNOLIA ST",
    "dropmalcty": "MARINE",
    "dropmalst": "IL",
    "dropmalzpp": 620619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188874729,
    "dropsitcph": 6188874729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13828",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "IL",
    "dropdelzpp": 629599998,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "IL",
    "dropphyzpp": 629599998,
    "dropmaladd": "205 E MAIN ST",
    "dropmalcty": "MARION",
    "dropmalst": "IL",
    "dropmalzpp": 629599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189932933,
    "dropsitcph": 6189932933,
    "dropfax": 6189931163
  },
  {
    "dcode": "D",
    "dropkey": "PW13829",
    "droptype": "D",
    "dropname": "MARISSA",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "MARISSA",
    "dropdelst": "IL",
    "dropdelzpp": 622579998,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "MARISSA",
    "dropphyst": "IL",
    "dropphyzpp": 622579998,
    "dropmaladd": "114 N MAIN ST",
    "dropmalcty": "MARISSA",
    "dropmalst": "IL",
    "dropmalzpp": 622579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182953051,
    "dropsitcph": 6182953051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13831",
    "droptype": "D",
    "dropname": "MARK",
    "dropdeladd": "106 W HENNEPIN ST",
    "dropdelcty": "MARK",
    "dropdelst": "IL",
    "dropdelzpp": 613409700,
    "dropphyadd": "106 W HENNEPIN ST",
    "dropphycty": "MARK",
    "dropphyst": "IL",
    "dropphyzpp": 613409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARK",
    "dropmalst": "IL",
    "dropmalzpp": 613409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153396273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13835",
    "droptype": "D",
    "dropname": "MAROA",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "MAROA",
    "dropdelst": "IL",
    "dropdelzpp": 617567502,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "MAROA",
    "dropphyst": "IL",
    "dropphyzpp": 617567502,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAROA",
    "dropmalst": "IL",
    "dropmalzpp": 617569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2177945011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13839",
    "droptype": "D",
    "dropname": "MARSEILLES",
    "dropdeladd": "100 WASHINGTON ST",
    "dropdelcty": "MARSEILLES",
    "dropdelst": "IL",
    "dropdelzpp": 613419800,
    "dropphyadd": "100 WASHINGTON ST",
    "dropphycty": "MARSEILLES",
    "dropphyst": "IL",
    "dropphyzpp": 613419800,
    "dropmaladd": "100 WASHINGTON ST",
    "dropmalcty": "MARSEILLES",
    "dropmalst": "IL",
    "dropmalzpp": 613419800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8157952148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13840",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "115 N 7TH ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "IL",
    "dropdelzpp": 624419998,
    "dropphyadd": "115 N 7TH ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "IL",
    "dropphyzpp": 624419998,
    "dropmaladd": "115 N 7TH ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "IL",
    "dropmalzpp": 624419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178265311,
    "dropsitcph": 2178265311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13843",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "2 N YORK ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 624429998,
    "dropphyadd": "2 N YORK ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 624429998,
    "dropmaladd": "2 N YORK ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 624429998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172750011,
    "dropsitcph": 2172750011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13844",
    "droptype": "D",
    "dropname": "MARTINTON",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "MARTINTON",
    "dropdelst": "IL",
    "dropdelzpp": 609519800,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "MARTINTON",
    "dropphyst": "IL",
    "dropphyzpp": 609519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTINTON",
    "dropmalst": "IL",
    "dropmalzpp": 609519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154287412,
    "dropfax": 8154287197
  },
  {
    "dcode": "D",
    "dropkey": "PW13847",
    "droptype": "D",
    "dropname": "MARYVILLE",
    "dropdeladd": "1 OAK DR",
    "dropdelcty": "MARYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620629998,
    "dropphyadd": "1 OAK DR",
    "dropphycty": "MARYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620629998,
    "dropmaladd": "1 OAK DR",
    "dropmalcty": "MARYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182881720,
    "dropsitcph": 6182881720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13850",
    "droptype": "D",
    "dropname": "MASCOUTAH",
    "dropdeladd": "18 W MAIN ST",
    "dropdelcty": "MASCOUTAH",
    "dropdelst": "IL",
    "dropdelzpp": 622589998,
    "dropphyadd": "18 W MAIN ST",
    "dropphycty": "MASCOUTAH",
    "dropphyst": "IL",
    "dropphyzpp": 622589998,
    "dropmaladd": "18 W MAIN ST",
    "dropmalcty": "MASCOUTAH",
    "dropmalst": "IL",
    "dropmalzpp": 622589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185662618,
    "dropsitcph": 6185662618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13851",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "755 ADAMS ST",
    "dropdelcty": "MASON",
    "dropdelst": "IL",
    "dropdelzpp": 624439998,
    "dropphyadd": "755 ADAMS ST",
    "dropphycty": "MASON",
    "dropphyst": "IL",
    "dropphyzpp": 624439998,
    "dropmaladd": "755 ADAMS ST",
    "dropmalcty": "MASON",
    "dropmalst": "IL",
    "dropmalzpp": 624439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182384830,
    "dropsitcph": 6182384830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13852",
    "droptype": "D",
    "dropname": "MASON CITY",
    "dropdeladd": "155 W CHESTNUT ST",
    "dropdelcty": "MASON CITY",
    "dropdelst": "IL",
    "dropdelzpp": 626649998,
    "dropphyadd": "155 W CHESTNUT ST",
    "dropphycty": "MASON CITY",
    "dropphyst": "IL",
    "dropphyzpp": 626649998,
    "dropmaladd": "155 W CHESTNUT ST",
    "dropmalcty": "MASON CITY",
    "dropmalst": "IL",
    "dropmalzpp": 626649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174825725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13854",
    "droptype": "D",
    "dropname": "MATHERVILLE",
    "dropdeladd": "509 2ND ST",
    "dropdelcty": "MATHERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 612639000,
    "dropphyadd": "509 2ND ST",
    "dropphycty": "MATHERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 612639000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATHERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 612639998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097548938,
    "dropsitcph": 3097548938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13855",
    "droptype": "D",
    "dropname": "MATTESON",
    "dropdeladd": "20650 S CICERO AVE",
    "dropdelcty": "MATTESON",
    "dropdelst": "IL",
    "dropdelzpp": 604439998,
    "dropphyadd": "20650 S CICERO AVE",
    "dropphycty": "MATTESON",
    "dropphyst": "IL",
    "dropphyzpp": 604439998,
    "dropmaladd": "20650 S CICERO AVE",
    "dropmalcty": "MATTESON",
    "dropmalst": "IL",
    "dropmalzpp": 604439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087488630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13856",
    "droptype": "D",
    "dropname": "MATTOON",
    "dropdeladd": "120 N 15TH ST",
    "dropdelcty": "MATTOON",
    "dropdelst": "IL",
    "dropdelzpp": 619389998,
    "dropphyadd": "120 N 15TH ST",
    "dropphycty": "MATTOON",
    "dropphyst": "IL",
    "dropphyzpp": 619389998,
    "dropmaladd": "120 N 15TH ST",
    "dropmalcty": "MATTOON",
    "dropmalst": "IL",
    "dropmalzpp": 619389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172348836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13858",
    "droptype": "D",
    "dropname": "MAUNIE",
    "dropdeladd": "321 NORTH ST",
    "dropdelcty": "MAUNIE",
    "dropdelst": "IL",
    "dropdelzpp": 628619998,
    "dropphyadd": "321 NORTH ST",
    "dropphycty": "MAUNIE",
    "dropphyst": "IL",
    "dropphyzpp": 628619998,
    "dropmaladd": "321 NORTH ST",
    "dropmalcty": "MAUNIE",
    "dropmalst": "IL",
    "dropmalzpp": 628619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189682258,
    "dropsitcph": 6189682258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13864",
    "droptype": "D",
    "dropname": "MAYWOOD",
    "dropdeladd": "415 S 5TH AVE",
    "dropdelcty": "MAYWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 601532086,
    "dropphyadd": "415 S 5TH AVE",
    "dropphycty": "MAYWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 601532086,
    "dropmaladd": "415 S 5TH AVE",
    "dropmalcty": "MAYWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 601532086,
    "dropsitphn": 6302605499,
    "dropsitlph": 7083444246,
    "dropsitcph": 7083444246,
    "dropfax": 7083440238
  },
  {
    "dcode": "D",
    "dropkey": "PW13865",
    "droptype": "D",
    "dropname": "MAZON",
    "dropdeladd": "600 DEPOT ST",
    "dropdelcty": "MAZON",
    "dropdelst": "IL",
    "dropdelzpp": 604449998,
    "dropphyadd": "600 DEPOT ST",
    "dropphycty": "MAZON",
    "dropphyst": "IL",
    "dropphyzpp": 604449998,
    "dropmaladd": "600 DEPOT ST",
    "dropmalcty": "MAZON",
    "dropmalst": "IL",
    "dropmalzpp": 604449998,
    "dropsitphn": 8159420345,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154485697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13867",
    "droptype": "D",
    "dropname": "MC CLURE",
    "dropdeladd": "37914 GRAPEVINE TRL",
    "dropdelcty": "MC CLURE",
    "dropdelst": "IL",
    "dropdelzpp": 629579998,
    "dropphyadd": "37914 GRAPEVINE TRL",
    "dropphycty": "MC CLURE",
    "dropphyst": "IL",
    "dropphyzpp": 629579998,
    "dropmaladd": "37914 GRAPEVINE TRL",
    "dropmalcty": "MC CLURE",
    "dropmalst": "IL",
    "dropmalzpp": 629579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186611555,
    "dropsitcph": 6186611555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13868",
    "droptype": "D",
    "dropname": "MC CONNELL",
    "dropdeladd": "218 E MAIN ST",
    "dropdelcty": "MC CONNELL",
    "dropdelst": "IL",
    "dropdelzpp": 610509998,
    "dropphyadd": "218 E MAIN ST",
    "dropphycty": "MC CONNELL",
    "dropphyst": "IL",
    "dropphyzpp": 610509998,
    "dropmaladd": "218 E MAIN ST",
    "dropmalcty": "MC CONNELL",
    "dropmalst": "IL",
    "dropmalzpp": 610509998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158682486,
    "dropsitcph": 8158682486,
    "dropfax": 8158682120
  },
  {
    "dcode": "D",
    "dropkey": "PW13871",
    "droptype": "D",
    "dropname": "MCHENRY",
    "dropdeladd": "4530 W CRYSTAL LAKE RD",
    "dropdelcty": "MCHENRY",
    "dropdelst": "IL",
    "dropdelzpp": 600505308,
    "dropphyadd": "4530 W CRYSTAL LAKE RD",
    "dropphycty": "MCHENRY",
    "dropphyst": "IL",
    "dropphyzpp": 600505308,
    "dropmaladd": "4530 W CRYSTAL LAKE RD",
    "dropmalcty": "MCHENRY",
    "dropmalst": "IL",
    "dropmalzpp": 600505308,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153852108,
    "dropsitcph": 8153852108,
    "dropfax": 8153850984
  },
  {
    "dcode": "D",
    "dropkey": "PW13872",
    "droptype": "D",
    "dropname": "MC LEAN",
    "dropdeladd": "117 S HAMILTON ST",
    "dropdelcty": "MC LEAN",
    "dropdelst": "IL",
    "dropdelzpp": 617549900,
    "dropphyadd": "117 S HAMILTON ST",
    "dropphycty": "MC LEAN",
    "dropphyst": "IL",
    "dropphyzpp": 617549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC LEAN",
    "dropmalst": "IL",
    "dropmalzpp": 617549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3098742241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13873",
    "droptype": "D",
    "dropname": "MC LEANSBORO",
    "dropdeladd": "211 S JACKSON ST",
    "dropdelcty": "MC LEANSBORO",
    "dropdelst": "IL",
    "dropdelzpp": 628599997,
    "dropphyadd": "211 S JACKSON ST",
    "dropphycty": "MC LEANSBORO",
    "dropphyst": "IL",
    "dropphyzpp": 628599997,
    "dropmaladd": "211 S JACKSON ST",
    "dropmalcty": "MC LEANSBORO",
    "dropmalst": "IL",
    "dropmalzpp": 628599997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186432423,
    "dropsitcph": 6186432423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13874",
    "droptype": "D",
    "dropname": "MC NABB",
    "dropdeladd": "318 W MAIN ST",
    "dropdelcty": "MC NABB",
    "dropdelst": "IL",
    "dropdelzpp": 613359998,
    "dropphyadd": "318 W MAIN ST",
    "dropphycty": "MC NABB",
    "dropphyst": "IL",
    "dropphyzpp": 613359998,
    "dropmaladd": "318 W MAIN ST",
    "dropmalcty": "MC NABB",
    "dropmalst": "IL",
    "dropmalzpp": 613359998,
    "dropsitphn": "",
    "dropsitlph": 8158822572,
    "dropsitcph": 8158822572,
    "dropfax": 8158822570
  },
  {
    "dcode": "D",
    "dropkey": "PW13897",
    "droptype": "D",
    "dropname": "MECHANICSBURG",
    "dropdeladd": "301 W MAIN ST",
    "dropdelcty": "MECHANICSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 625459998,
    "dropphyadd": "301 W MAIN ST",
    "dropphycty": "MECHANICSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 625459998,
    "dropmaladd": "301 W MAIN ST",
    "dropmalcty": "MECHANICSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 625459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173644983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13898",
    "droptype": "D",
    "dropname": "MEDIA",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "MEDIA",
    "dropdelst": "IL",
    "dropdelzpp": 614609800,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "MEDIA",
    "dropphyst": "IL",
    "dropphyzpp": 614609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDIA",
    "dropmalst": "IL",
    "dropmalzpp": 614609998,
    "dropsitphn": 3093257128,
    "dropsitlph": 3099241761,
    "dropsitcph": 3099241761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13899",
    "droptype": "D",
    "dropname": "MEDINAH",
    "dropdeladd": "6N736 MEDINAH RD",
    "dropdelcty": "MEDINAH",
    "dropdelst": "IL",
    "dropdelzpp": 601579998,
    "dropphyadd": "6N736 MEDINAH RD",
    "dropphycty": "MEDINAH",
    "dropphyst": "IL",
    "dropphyzpp": 601579998,
    "dropmaladd": "6N736 MEDINAH RD",
    "dropmalcty": "MEDINAH",
    "dropmalst": "IL",
    "dropmalzpp": 601579998,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308945231,
    "dropsitcph": 6308945231,
    "dropfax": 6308945627
  },
  {
    "dcode": "D",
    "dropkey": "PW13900",
    "droptype": "D",
    "dropname": "MEDORA",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "MEDORA",
    "dropdelst": "IL",
    "dropdelzpp": 620639998,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "MEDORA",
    "dropphyst": "IL",
    "dropphyzpp": 620639998,
    "dropmaladd": "104 N MAIN ST",
    "dropmalcty": "MEDORA",
    "dropmalst": "IL",
    "dropmalzpp": 620639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187293730,
    "dropsitcph": 6187293730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13905",
    "droptype": "D",
    "dropname": "MELROSE PARK",
    "dropdeladd": "1824 N 25TH AVE",
    "dropdelcty": "MELROSE PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601601846,
    "dropphyadd": "1824 N 25TH AVE",
    "dropphycty": "MELROSE PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601601846,
    "dropmaladd": "1824 N 25TH AVE",
    "dropmalcty": "MELROSE PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601601846,
    "dropsitphn": 6302605499,
    "dropsitlph": 7083432150,
    "dropsitcph": 7083432150,
    "dropfax": 7083432215
  },
  {
    "dcode": "D",
    "dropkey": "PW13908",
    "droptype": "D",
    "dropname": "MELVIN",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "MELVIN",
    "dropdelst": "IL",
    "dropdelzpp": 609529800,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "MELVIN",
    "dropphyst": "IL",
    "dropphyzpp": 609529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELVIN",
    "dropmalst": "IL",
    "dropmalzpp": 609529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173887723,
    "dropfax": 2173887723
  },
  {
    "dcode": "D",
    "dropkey": "PW13912",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "102 W COLLINS ST",
    "dropdelcty": "MENDON",
    "dropdelst": "IL",
    "dropdelzpp": 623519998,
    "dropphyadd": "102 W COLLINS ST",
    "dropphycty": "MENDON",
    "dropphyst": "IL",
    "dropphyzpp": 623519998,
    "dropmaladd": "102 W COLLINS ST",
    "dropmalcty": "MENDON",
    "dropmalst": "IL",
    "dropmalzpp": 623519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179362443,
    "dropsitcph": 2179362443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13913",
    "droptype": "D",
    "dropname": "MENDOTA",
    "dropdeladd": "818 WASHINGTON ST",
    "dropdelcty": "MENDOTA",
    "dropdelst": "IL",
    "dropdelzpp": 613429800,
    "dropphyadd": "818 WASHINGTON ST",
    "dropphycty": "MENDOTA",
    "dropphyst": "IL",
    "dropphyzpp": 613429800,
    "dropmaladd": "818 WASHINGTON ST",
    "dropmalcty": "MENDOTA",
    "dropmalst": "IL",
    "dropmalzpp": 613429800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8155396366,
    "dropfax": 8155386502
  },
  {
    "dcode": "D",
    "dropkey": "PW13919",
    "droptype": "D",
    "dropname": "MEREDOSIA",
    "dropdeladd": "113 S WASHINGTON ST",
    "dropdelcty": "MEREDOSIA",
    "dropdelst": "IL",
    "dropdelzpp": 626659998,
    "dropphyadd": "113 S WASHINGTON ST",
    "dropphycty": "MEREDOSIA",
    "dropphyst": "IL",
    "dropphyzpp": 626659998,
    "dropmaladd": "113 S WASHINGTON ST",
    "dropmalcty": "MEREDOSIA",
    "dropmalst": "IL",
    "dropmalzpp": 626659998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175841581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13923",
    "droptype": "D",
    "dropname": "MERNA",
    "dropdeladd": "16032 N 2300 EAST RD",
    "dropdelcty": "MERNA",
    "dropdelst": "IL",
    "dropdelzpp": 617589998,
    "dropphyadd": "16032 N 2300 EAST RD",
    "dropphycty": "MERNA",
    "dropphyst": "IL",
    "dropphyzpp": 617589998,
    "dropmaladd": "16032 N 2300 EAST RD",
    "dropmalcty": "MERNA",
    "dropmalst": "IL",
    "dropmalzpp": 617589998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097282935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13931",
    "droptype": "D",
    "dropname": "METAMORA",
    "dropdeladd": "123 E PARTRIDGE ST",
    "dropdelcty": "METAMORA",
    "dropdelst": "IL",
    "dropdelzpp": 615489998,
    "dropphyadd": "123 E PARTRIDGE ST",
    "dropphycty": "METAMORA",
    "dropphyst": "IL",
    "dropphyzpp": 615489998,
    "dropmaladd": "123 E PARTRIDGE ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "IL",
    "dropmalzpp": 615489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093674741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13932",
    "droptype": "D",
    "dropname": "METCALF",
    "dropdeladd": "212 N CENTRAL ST",
    "dropdelcty": "METCALF",
    "dropdelst": "IL",
    "dropdelzpp": 619409998,
    "dropphyadd": "212 N CENTRAL ST",
    "dropphycty": "METCALF",
    "dropphyst": "IL",
    "dropphyzpp": 619409998,
    "dropmaladd": "212 N CENTRAL ST",
    "dropmalcty": "METCALF",
    "dropmalst": "IL",
    "dropmalzpp": 619409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178872412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13934",
    "droptype": "D",
    "dropname": "METROPOLIS",
    "dropdeladd": "101 W 5TH ST",
    "dropdelcty": "METROPOLIS",
    "dropdelst": "IL",
    "dropdelzpp": 629609998,
    "dropphyadd": "101 W 5TH ST",
    "dropphycty": "METROPOLIS",
    "dropphyst": "IL",
    "dropphyzpp": 629609998,
    "dropmaladd": "101 W 5TH ST",
    "dropmalcty": "METROPOLIS",
    "dropmalst": "IL",
    "dropmalzpp": 629609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185244921,
    "dropsitcph": 6185244921,
    "dropfax": 6185243090
  },
  {
    "dcode": "D",
    "dropkey": "PW13940",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "407 5TH ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "IL",
    "dropdelzpp": 626669998,
    "dropphyadd": "407 5TH ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "IL",
    "dropphyzpp": 626669998,
    "dropmaladd": "407 5TH ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "IL",
    "dropmalzpp": 626669998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174452823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13943",
    "droptype": "D",
    "dropname": "MIDLOTHIAN",
    "dropdeladd": "14722 PULASKI RD",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "IL",
    "dropdelzpp": 604459998,
    "dropphyadd": "14722 PULASKI RD",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "IL",
    "dropphyzpp": 604459998,
    "dropmaladd": "14722 PULASKI RD",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "IL",
    "dropmalzpp": 604459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083857900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13948",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "111 3RD ST W",
    "dropdelcty": "MILAN",
    "dropdelst": "IL",
    "dropdelzpp": 612649998,
    "dropphyadd": "111 3RD ST W",
    "dropphycty": "MILAN",
    "dropphyst": "IL",
    "dropphyzpp": 612649998,
    "dropmaladd": "111 3RD ST W",
    "dropmalcty": "MILAN",
    "dropmalst": "IL",
    "dropmalzpp": 612649998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097874314,
    "dropsitcph": 3097874314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13950",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "108 N WEST AVE",
    "dropdelcty": "MILFORD",
    "dropdelst": "IL",
    "dropdelzpp": 609539998,
    "dropphyadd": "108 N WEST AVE",
    "dropphycty": "MILFORD",
    "dropphyst": "IL",
    "dropphyzpp": 609539998,
    "dropmaladd": "108 N WEST AVE",
    "dropmalcty": "MILFORD",
    "dropmalst": "IL",
    "dropmalzpp": 609539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158894439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13951",
    "droptype": "D",
    "dropname": "MILL SHOALS",
    "dropdeladd": "483 LOCUST ST",
    "dropdelcty": "MILL SHOALS",
    "dropdelst": "IL",
    "dropdelzpp": 628629997,
    "dropphyadd": "483 LOCUST ST",
    "dropphycty": "MILL SHOALS",
    "dropphyst": "IL",
    "dropphyzpp": 628629997,
    "dropmaladd": "483 LOCUST ST",
    "dropmalcty": "MILL SHOALS",
    "dropmalst": "IL",
    "dropmalzpp": 628629997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188962286,
    "dropsitcph": 6188962286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13953",
    "droptype": "D",
    "dropname": "MILLBROOK",
    "dropdeladd": "27 HARRIS AVE",
    "dropdelcty": "MILLBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 605369800,
    "dropphyadd": "27 HARRIS AVE",
    "dropphycty": "MILLBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 605369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 605369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7085535351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13954",
    "droptype": "D",
    "dropname": "MILLCREEK",
    "dropdeladd": "60 WALNUT ST",
    "dropdelcty": "MILLCREEK",
    "dropdelst": "IL",
    "dropdelzpp": 629619998,
    "dropphyadd": "60 WALNUT ST",
    "dropphycty": "MILLCREEK",
    "dropphyst": "IL",
    "dropphyzpp": 629619998,
    "dropmaladd": "60 WALNUT ST",
    "dropmalcty": "MILLCREEK",
    "dropmalst": "IL",
    "dropmalzpp": 629619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187472410,
    "dropsitcph": 6187472410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13955",
    "droptype": "D",
    "dropname": "MILLEDGEVILLE",
    "dropdeladd": "315 N MEYERS AVE",
    "dropdelcty": "MILLEDGEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 610519998,
    "dropphyadd": "315 N MEYERS AVE",
    "dropphycty": "MILLEDGEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 610519998,
    "dropmaladd": "315 N MEYERS AVE",
    "dropmalcty": "MILLEDGEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 610519998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152257216,
    "dropsitcph": 8152257216,
    "dropfax": 8152257219
  },
  {
    "dcode": "D",
    "dropkey": "PW13966",
    "droptype": "D",
    "dropname": "MILLINGTON",
    "dropdeladd": "200 N GRANT ST",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 605379800,
    "dropphyadd": "200 N GRANT ST",
    "dropphycty": "MILLINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 605379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 605379998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156955868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13967",
    "droptype": "D",
    "dropname": "MILLSTADT",
    "dropdeladd": "20 W WHITE ST",
    "dropdelcty": "MILLSTADT",
    "dropdelst": "IL",
    "dropdelzpp": 622609998,
    "dropphyadd": "20 W WHITE ST",
    "dropphycty": "MILLSTADT",
    "dropphyst": "IL",
    "dropphyzpp": 622609998,
    "dropmaladd": "20 W WHITE ST",
    "dropmalcty": "MILLSTADT",
    "dropmalst": "IL",
    "dropmalzpp": 622609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184761717,
    "dropsitcph": 6184761717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13973",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "435 PITTSFIELD ST",
    "dropdelcty": "MILTON",
    "dropdelst": "IL",
    "dropdelzpp": 623529998,
    "dropphyadd": "435 PITTSFIELD ST",
    "dropphycty": "MILTON",
    "dropphyst": "IL",
    "dropphyzpp": 623529998,
    "dropmaladd": "435 PITTSFIELD ST",
    "dropmalcty": "MILTON",
    "dropmalst": "IL",
    "dropmalzpp": 623529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177234414,
    "dropsitcph": 2177234414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13974",
    "droptype": "D",
    "dropname": "MINERAL",
    "dropdeladd": "150 E MAIN ST",
    "dropdelcty": "MINERAL",
    "dropdelst": "IL",
    "dropdelzpp": 613448900,
    "dropphyadd": "150 E MAIN ST",
    "dropphycty": "MINERAL",
    "dropphyst": "IL",
    "dropphyzpp": 613448900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINERAL",
    "dropmalst": "IL",
    "dropmalzpp": 613449997,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092885311,
    "dropfax": 3092885311
  },
  {
    "dcode": "D",
    "dropkey": "PW13976",
    "droptype": "D",
    "dropname": "MINIER",
    "dropdeladd": "219 W CHICAGO ST",
    "dropdelcty": "MINIER",
    "dropdelst": "IL",
    "dropdelzpp": 617597579,
    "dropphyadd": "219 W CHICAGO ST",
    "dropphycty": "MINIER",
    "dropphyst": "IL",
    "dropphyzpp": 617597579,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINIER",
    "dropmalst": "IL",
    "dropmalzpp": 617599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093922037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13977",
    "droptype": "D",
    "dropname": "MINONK",
    "dropdeladd": "160 W 5TH ST",
    "dropdelcty": "MINONK",
    "dropdelst": "IL",
    "dropdelzpp": 617609998,
    "dropphyadd": "160 W 5TH ST",
    "dropphycty": "MINONK",
    "dropphyst": "IL",
    "dropphyzpp": 617609998,
    "dropmaladd": "160 W 5TH ST",
    "dropmalcty": "MINONK",
    "dropmalst": "IL",
    "dropmalzpp": 617609998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094322848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13978",
    "droptype": "D",
    "dropname": "MINOOKA",
    "dropdeladd": "301 W MONDAMIN ST",
    "dropdelcty": "MINOOKA",
    "dropdelst": "IL",
    "dropdelzpp": 604479998,
    "dropphyadd": "301 W MONDAMIN ST",
    "dropphycty": "MINOOKA",
    "dropphyst": "IL",
    "dropphyzpp": 604479998,
    "dropmaladd": "301 W MONDAMIN ST",
    "dropmalcty": "MINOOKA",
    "dropmalst": "IL",
    "dropmalzpp": 604479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154676360,
    "dropfax": 8154670169
  },
  {
    "dcode": "D",
    "dropkey": "PW13986",
    "droptype": "D",
    "dropname": "MODESTO",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "MODESTO",
    "dropdelst": "IL",
    "dropdelzpp": 626679998,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "MODESTO",
    "dropphyst": "IL",
    "dropphyzpp": 626679998,
    "dropmaladd": "108 S MAIN ST",
    "dropmalcty": "MODESTO",
    "dropmalst": "IL",
    "dropmalzpp": 626679998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174397285,
    "dropfax": 2174397285
  },
  {
    "dcode": "D",
    "dropkey": "PW13988",
    "droptype": "D",
    "dropname": "MOKENA",
    "dropdeladd": "19934 WOLF RD",
    "dropdelcty": "MOKENA",
    "dropdelst": "IL",
    "dropdelzpp": 604489998,
    "dropphyadd": "19934 WOLF RD",
    "dropphycty": "MOKENA",
    "dropphyst": "IL",
    "dropphyzpp": 604489998,
    "dropmaladd": "19934 WOLF RD",
    "dropmalcty": "MOKENA",
    "dropmalst": "IL",
    "dropmalzpp": 604489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084799431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13989",
    "droptype": "D",
    "dropname": "MOLINE",
    "dropdeladd": "514 17TH ST",
    "dropdelcty": "MOLINE",
    "dropdelst": "IL",
    "dropdelzpp": 612652167,
    "dropphyadd": "514 17TH ST",
    "dropphycty": "MOLINE",
    "dropphyst": "IL",
    "dropphyzpp": 612652167,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOLINE",
    "dropmalst": "IL",
    "dropmalzpp": 612659998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097645629,
    "dropsitcph": 3097645011,
    "dropfax": 3097645995
  },
  {
    "dcode": "D",
    "dropkey": "PW13990",
    "droptype": "D",
    "dropname": "MOMENCE",
    "dropdeladd": "202 E WASHINGTON ST",
    "dropdelcty": "MOMENCE",
    "dropdelst": "IL",
    "dropdelzpp": 609549998,
    "dropphyadd": "202 E WASHINGTON ST",
    "dropphycty": "MOMENCE",
    "dropphyst": "IL",
    "dropphyzpp": 609549998,
    "dropmaladd": "202 E WASHINGTON ST",
    "dropmalcty": "MOMENCE",
    "dropmalst": "IL",
    "dropmalzpp": 609549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8154722811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13991",
    "droptype": "D",
    "dropname": "MONEE",
    "dropdeladd": "5410 W MAIN ST",
    "dropdelcty": "MONEE",
    "dropdelst": "IL",
    "dropdelzpp": 604499998,
    "dropphyadd": "5410 W MAIN ST",
    "dropphycty": "MONEE",
    "dropphyst": "IL",
    "dropphyzpp": 604499998,
    "dropmaladd": "5410 W MAIN ST",
    "dropmalcty": "MONEE",
    "dropmalst": "IL",
    "dropmalzpp": 604499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7085348057,
    "dropfax": 7085342217
  },
  {
    "dcode": "D",
    "dropkey": "PW13994",
    "droptype": "D",
    "dropname": "MONMOUTH",
    "dropdeladd": "235 S 1ST ST",
    "dropdelcty": "MONMOUTH",
    "dropdelst": "IL",
    "dropdelzpp": 614629998,
    "dropphyadd": "235 S 1ST ST",
    "dropphycty": "MONMOUTH",
    "dropphyst": "IL",
    "dropphyzpp": 614629998,
    "dropmaladd": "235 S 1ST ST",
    "dropmalcty": "MONMOUTH",
    "dropmalst": "IL",
    "dropmalzpp": 614629998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637318,
    "dropsitcph": 3097344312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW13995",
    "droptype": "D",
    "dropname": "MONROE CENTER",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "MONROE CENTER",
    "dropdelst": "IL",
    "dropdelzpp": 610529474,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "MONROE CENTER",
    "dropphyst": "IL",
    "dropphyzpp": 610529474,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "MONROE CENTER",
    "dropmalst": "IL",
    "dropmalzpp": 610529474,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153934345,
    "dropsitcph": 8153934345,
    "dropfax": 8153933126
  },
  {
    "dcode": "D",
    "dropkey": "PW14002",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "1899 VILLAGE CENTER PKWY",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "IL",
    "dropdelzpp": 605389998,
    "dropphyadd": "1899 VILLAGE CENTER PKWY",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "IL",
    "dropphyzpp": 605389998,
    "dropmaladd": "1899 VILLAGE CENTER PKWY",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "IL",
    "dropmalzpp": 605389998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6308441655,
    "dropfax": 6308449055
  },
  {
    "dcode": "D",
    "dropkey": "PW14004",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "104 W LIVINGSTON ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "IL",
    "dropdelzpp": 618569998,
    "dropphyadd": "104 W LIVINGSTON ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "IL",
    "dropphyzpp": 618569998,
    "dropmaladd": "104 W LIVINGSTON ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "IL",
    "dropmalzpp": 618569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177627221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14005",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "301 W NATIONAL RD",
    "dropdelcty": "MONTROSE",
    "dropdelst": "IL",
    "dropdelzpp": 624459998,
    "dropphyadd": "301 W NATIONAL RD",
    "dropphycty": "MONTROSE",
    "dropphyst": "IL",
    "dropphyzpp": 624459998,
    "dropmaladd": "301 W NATIONAL RD",
    "dropmalcty": "MONTROSE",
    "dropmalst": "IL",
    "dropmalzpp": 624459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179244147,
    "dropsitcph": 2179244147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14012",
    "droptype": "D",
    "dropname": "MORO",
    "dropdeladd": "31 N MAIN ST",
    "dropdelcty": "MORO",
    "dropdelst": "IL",
    "dropdelzpp": 620679998,
    "dropphyadd": "31 N MAIN ST",
    "dropphycty": "MORO",
    "dropphyst": "IL",
    "dropphyzpp": 620679998,
    "dropmaladd": "31 N MAIN ST",
    "dropmalcty": "MORO",
    "dropmalst": "IL",
    "dropmalzpp": 620679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183776721,
    "dropsitcph": 6183776721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14013",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "202 E WASHINGTON ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "IL",
    "dropdelzpp": 604509998,
    "dropphyadd": "202 E WASHINGTON ST",
    "dropphycty": "MORRIS",
    "dropphyst": "IL",
    "dropphyzpp": 604509998,
    "dropmaladd": "202 E WASHINGTON ST",
    "dropmalcty": "MORRIS",
    "dropmalst": "IL",
    "dropmalzpp": 604509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8159420345,
    "dropfax": 8159428002
  },
  {
    "dcode": "D",
    "dropkey": "PW14014",
    "droptype": "D",
    "dropname": "MORRISON",
    "dropdeladd": "226 W MAIN ST",
    "dropdelcty": "MORRISON",
    "dropdelst": "IL",
    "dropdelzpp": 612709998,
    "dropphyadd": "226 W MAIN ST",
    "dropphycty": "MORRISON",
    "dropphyst": "IL",
    "dropphyzpp": 612709998,
    "dropmaladd": "226 W MAIN ST",
    "dropmalcty": "MORRISON",
    "dropmalst": "IL",
    "dropmalzpp": 612709998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8157723311,
    "dropsitcph": 8157723311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14015",
    "droptype": "D",
    "dropname": "MORRISONVILLE",
    "dropdeladd": "601 RICKS ST",
    "dropdelcty": "MORRISONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 625469998,
    "dropphyadd": "601 RICKS ST",
    "dropphycty": "MORRISONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 625469998,
    "dropmaladd": "601 RICKS ST",
    "dropmalcty": "MORRISONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 625469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175263331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14020",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "600 W JEFFERSON ST",
    "dropdelcty": "MORTON",
    "dropdelst": "IL",
    "dropdelzpp": 615509998,
    "dropphyadd": "600 W JEFFERSON ST",
    "dropphycty": "MORTON",
    "dropphyst": "IL",
    "dropphyzpp": 615509998,
    "dropmaladd": "600 W JEFFERSON ST",
    "dropmalcty": "MORTON",
    "dropmalst": "IL",
    "dropmalzpp": 615509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092666421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14021",
    "droptype": "D",
    "dropname": "MORTON GROVE",
    "dropdeladd": "9114 WAUKEGAN RD",
    "dropdelcty": "MORTON GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 600532123,
    "dropphyadd": "9114 WAUKEGAN RD",
    "dropphycty": "MORTON GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 600532123,
    "dropmaladd": "9114 WAUKEGAN RD",
    "dropmalcty": "MORTON GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 600532123,
    "dropsitphn": 6302605499,
    "dropsitlph": 8479651621,
    "dropsitcph": 8479651621,
    "dropfax": 8479658994
  },
  {
    "dcode": "D",
    "dropkey": "PW14023",
    "droptype": "D",
    "dropname": "MOSSVILLE",
    "dropdeladd": "10420 STATE ST",
    "dropdelcty": "MOSSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 615529800,
    "dropphyadd": "10420 STATE ST",
    "dropphycty": "MOSSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 615529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 615529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3095792264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14024",
    "droptype": "D",
    "dropname": "MOUND CITY",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "MOUND CITY",
    "dropdelst": "IL",
    "dropdelzpp": 629639998,
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "MOUND CITY",
    "dropphyst": "IL",
    "dropphyzpp": 629639998,
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "MOUND CITY",
    "dropmalst": "IL",
    "dropmalzpp": 629639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187489813,
    "dropsitcph": 6187489813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14027",
    "droptype": "D",
    "dropname": "MOUNDS",
    "dropdeladd": "110 N FRONT ST",
    "dropdelcty": "MOUNDS",
    "dropdelst": "IL",
    "dropdelzpp": 629649998,
    "dropphyadd": "110 N FRONT ST",
    "dropphycty": "MOUNDS",
    "dropphyst": "IL",
    "dropphyzpp": 629649998,
    "dropmaladd": "110 N FRONT ST",
    "dropmalcty": "MOUNDS",
    "dropmalst": "IL",
    "dropmalzpp": 629649998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187456453,
    "dropsitcph": 6187456453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14028",
    "droptype": "D",
    "dropname": "MOUNT AUBURN",
    "dropdeladd": "240 E ARCH ST",
    "dropdelcty": "MOUNT AUBURN",
    "dropdelst": "IL",
    "dropdelzpp": 625479998,
    "dropphyadd": "240 E ARCH ST",
    "dropphycty": "MOUNT AUBURN",
    "dropphyst": "IL",
    "dropphyzpp": 625479998,
    "dropmaladd": "240 E ARCH ST",
    "dropmalcty": "MOUNT AUBURN",
    "dropmalst": "IL",
    "dropmalzpp": 625479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176763321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14030",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "503 N MARKET ST",
    "dropdelcty": "MOUNT CARMEL",
    "dropdelst": "IL",
    "dropdelzpp": 628639998,
    "dropphyadd": "503 N MARKET ST",
    "dropphycty": "MOUNT CARMEL",
    "dropphyst": "IL",
    "dropphyzpp": 628639998,
    "dropmaladd": "503 N MARKET ST",
    "dropmalcty": "MOUNT CARMEL",
    "dropmalst": "IL",
    "dropmalzpp": 628639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182627024,
    "dropsitcph": 6182627024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14031",
    "droptype": "D",
    "dropname": "MOUNT CARROLL",
    "dropdeladd": "211 N CLAY ST",
    "dropdelcty": "MOUNT CARROLL",
    "dropdelst": "IL",
    "dropdelzpp": 610531148,
    "dropphyadd": "211 N CLAY ST",
    "dropphycty": "MOUNT CARROLL",
    "dropphyst": "IL",
    "dropphyzpp": 610531148,
    "dropmaladd": "211 N CLAY ST",
    "dropmalcty": "MOUNT CARROLL",
    "dropmalst": "IL",
    "dropmalzpp": 610531148,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152443711,
    "dropsitcph": 8152443711,
    "dropfax": 8152444077
  },
  {
    "dcode": "D",
    "dropkey": "PW14033",
    "droptype": "D",
    "dropname": "MOUNT ERIE",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "MOUNT ERIE",
    "dropdelst": "IL",
    "dropdelzpp": 624469998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "MOUNT ERIE",
    "dropphyst": "IL",
    "dropphyzpp": 624469998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "MOUNT ERIE",
    "dropmalst": "IL",
    "dropmalzpp": 624469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188542446,
    "dropsitcph": 6188542446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14036",
    "droptype": "D",
    "dropname": "MOUNT MORRIS",
    "dropdeladd": "21 W MAIN ST",
    "dropdelcty": "MOUNT MORRIS",
    "dropdelst": "IL",
    "dropdelzpp": 610541486,
    "dropphyadd": "21 W MAIN ST",
    "dropphycty": "MOUNT MORRIS",
    "dropphyst": "IL",
    "dropphyzpp": 610541486,
    "dropmaladd": "21 W MAIN ST",
    "dropmalcty": "MOUNT MORRIS",
    "dropmalst": "IL",
    "dropmalzpp": 610541486,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157346518,
    "dropsitcph": 8157346518,
    "dropfax": 8157349012
  },
  {
    "dcode": "D",
    "dropkey": "PW14037",
    "droptype": "D",
    "dropname": "MOUNT OLIVE",
    "dropdeladd": "118 S POPLAR ST",
    "dropdelcty": "MOUNT OLIVE",
    "dropdelst": "IL",
    "dropdelzpp": 620699998,
    "dropphyadd": "118 S POPLAR ST",
    "dropphycty": "MOUNT OLIVE",
    "dropphyst": "IL",
    "dropphyzpp": 620699998,
    "dropmaladd": "118 S POPLAR ST",
    "dropmalcty": "MOUNT OLIVE",
    "dropmalst": "IL",
    "dropmalzpp": 620699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179995901,
    "dropsitcph": 2179995901,
    "dropfax": 2179995901
  },
  {
    "dcode": "D",
    "dropkey": "PW14041",
    "droptype": "D",
    "dropname": "MOUNT PROSPECT",
    "dropdeladd": "300 W CENTRAL RD",
    "dropdelcty": "MOUNT PROSPECT",
    "dropdelst": "IL",
    "dropdelzpp": 600562470,
    "dropphyadd": "300 W CENTRAL RD",
    "dropphycty": "MOUNT PROSPECT",
    "dropphyst": "IL",
    "dropphyzpp": 600562470,
    "dropmaladd": "300 W CENTRAL RD",
    "dropmalcty": "MOUNT PROSPECT",
    "dropmalst": "IL",
    "dropmalzpp": 600562470,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473922731,
    "dropsitcph": 8473922731,
    "dropfax": 8473925468
  },
  {
    "dcode": "D",
    "dropkey": "PW14042",
    "droptype": "D",
    "dropname": "MOUNT PULASKI",
    "dropdeladd": "121 N LAFAYETTE ST",
    "dropdelcty": "MOUNT PULASKI",
    "dropdelst": "IL",
    "dropdelzpp": 625489998,
    "dropphyadd": "121 N LAFAYETTE ST",
    "dropphycty": "MOUNT PULASKI",
    "dropphyst": "IL",
    "dropphyzpp": 625489998,
    "dropmaladd": "121 N LAFAYETTE ST",
    "dropmalcty": "MOUNT PULASKI",
    "dropmalst": "IL",
    "dropmalzpp": 625489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177925814,
    "dropfax": 2177925814
  },
  {
    "dcode": "D",
    "dropkey": "PW14043",
    "droptype": "D",
    "dropname": "MOUNT STERLING",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "MOUNT STERLING",
    "dropdelst": "IL",
    "dropdelzpp": 623539998,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "MOUNT STERLING",
    "dropphyst": "IL",
    "dropphyzpp": 623539998,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "MOUNT STERLING",
    "dropmalst": "IL",
    "dropmalzpp": 623539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177732619,
    "dropsitcph": 2177732619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14044",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "301 S 10TH ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "IL",
    "dropdelzpp": 628649995,
    "dropphyadd": "301 S 10TH ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "IL",
    "dropphyzpp": 628649995,
    "dropmaladd": "301 S 10TH ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "IL",
    "dropmalzpp": 628649995,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182420640,
    "dropsitcph": 6182420640,
    "dropfax": 6519943232
  },
  {
    "dcode": "D",
    "dropkey": "PW14046",
    "droptype": "D",
    "dropname": "MT ZION",
    "dropdeladd": "450 W MAIN ST",
    "dropdelcty": "MT ZION",
    "dropdelst": "IL",
    "dropdelzpp": 625499998,
    "dropphyadd": "450 W MAIN ST",
    "dropphycty": "MT ZION",
    "dropphyst": "IL",
    "dropphyzpp": 625499998,
    "dropmaladd": "450 W MAIN ST",
    "dropmalcty": "MT ZION",
    "dropmalst": "IL",
    "dropmalzpp": 625499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178642712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14048",
    "droptype": "D",
    "dropname": "MOWEAQUA",
    "dropdeladd": "115 W MAIN ST",
    "dropdelcty": "MOWEAQUA",
    "dropdelst": "IL",
    "dropdelzpp": 625509998,
    "dropphyadd": "115 W MAIN ST",
    "dropphycty": "MOWEAQUA",
    "dropphyst": "IL",
    "dropphyzpp": 625509998,
    "dropmaladd": "115 W MAIN ST",
    "dropmalcty": "MOWEAQUA",
    "dropmalst": "IL",
    "dropmalzpp": 625509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177683315,
    "dropfax": 2177683315
  },
  {
    "dcode": "D",
    "dropkey": "PW14066",
    "droptype": "D",
    "dropname": "MUDDY",
    "dropdeladd": "305 PUBLIC RD",
    "dropdelcty": "MUDDY",
    "dropdelst": "IL",
    "dropdelzpp": 629659998,
    "dropphyadd": "305 PUBLIC RD",
    "dropphycty": "MUDDY",
    "dropphyst": "IL",
    "dropphyzpp": 629659998,
    "dropmaladd": "305 PUBLIC RD",
    "dropmalcty": "MUDDY",
    "dropmalst": "IL",
    "dropmalzpp": 629659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182522931,
    "dropsitcph": 6182522931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14067",
    "droptype": "D",
    "dropname": "MULBERRY GROVE",
    "dropdeladd": "201 N MAPLE ST",
    "dropdelcty": "MULBERRY GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 622629998,
    "dropphyadd": "201 N MAPLE ST",
    "dropphycty": "MULBERRY GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 622629998,
    "dropmaladd": "201 N MAPLE ST",
    "dropmalcty": "MULBERRY GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 622629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183267346,
    "dropsitcph": 6183267346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14069",
    "droptype": "D",
    "dropname": "MULKEYTOWN",
    "dropdeladd": "7803 MAIN ST",
    "dropdelcty": "MULKEYTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 628659998,
    "dropphyadd": "7803 MAIN ST",
    "dropphycty": "MULKEYTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 628659998,
    "dropmaladd": "7803 MAIN ST",
    "dropmalcty": "MULKEYTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 628659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187242355,
    "dropsitcph": 6187242355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14071",
    "droptype": "D",
    "dropname": "MUNCIE",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "MUNCIE",
    "dropdelst": "IL",
    "dropdelzpp": 618579998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "MUNCIE",
    "dropphyst": "IL",
    "dropphyzpp": 618579998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "MUNCIE",
    "dropmalst": "IL",
    "dropmalzpp": 618579998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175482315,
    "dropfax": 2175482315
  },
  {
    "dcode": "D",
    "dropkey": "PW14072",
    "droptype": "D",
    "dropname": "MUNDELEIN",
    "dropdeladd": "435 E HAWLEY ST",
    "dropdelcty": "MUNDELEIN",
    "dropdelst": "IL",
    "dropdelzpp": 600602469,
    "dropphyadd": "435 E HAWLEY ST",
    "dropphycty": "MUNDELEIN",
    "dropphyst": "IL",
    "dropphyzpp": 600602469,
    "dropmaladd": "435 E HAWLEY ST",
    "dropmalcty": "MUNDELEIN",
    "dropmalst": "IL",
    "dropmalzpp": 600602469,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475663907,
    "dropsitcph": 8475663907,
    "dropfax": 8475664820
  },
  {
    "dcode": "D",
    "dropkey": "PW14075",
    "droptype": "D",
    "dropname": "MURDOCK",
    "dropdeladd": "203 N CENTER ST",
    "dropdelcty": "MURDOCK",
    "dropdelst": "IL",
    "dropdelzpp": 619419998,
    "dropphyadd": "203 N CENTER ST",
    "dropphycty": "MURDOCK",
    "dropphyst": "IL",
    "dropphyzpp": 619419998,
    "dropmaladd": "203 N CENTER ST",
    "dropmalcty": "MURDOCK",
    "dropmalst": "IL",
    "dropmalzpp": 619419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178372921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14076",
    "droptype": "D",
    "dropname": "MURPHYSBORO",
    "dropdeladd": "203 N 11TH ST",
    "dropdelcty": "MURPHYSBORO",
    "dropdelst": "IL",
    "dropdelzpp": 629669998,
    "dropphyadd": "203 N 11TH ST",
    "dropphycty": "MURPHYSBORO",
    "dropphyst": "IL",
    "dropphyzpp": 629669998,
    "dropmaladd": "203 N 11TH ST",
    "dropmalcty": "MURPHYSBORO",
    "dropmalst": "IL",
    "dropmalzpp": 629669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186844841,
    "dropsitcph": 6186844841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14077",
    "droptype": "D",
    "dropname": "MURRAYVILLE",
    "dropdeladd": "105 CHURCH ST",
    "dropdelcty": "MURRAYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626689998,
    "dropphyadd": "105 CHURCH ST",
    "dropphycty": "MURRAYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626689998,
    "dropmaladd": "105 CHURCH ST",
    "dropmalcty": "MURRAYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178827111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14089",
    "droptype": "D",
    "dropname": "NACHUSA",
    "dropdeladd": "1712 WARREN ST",
    "dropdelcty": "NACHUSA",
    "dropdelst": "IL",
    "dropdelzpp": 610579800,
    "dropphyadd": "1712 WARREN ST",
    "dropphycty": "NACHUSA",
    "dropphyst": "IL",
    "dropphyzpp": 610579800,
    "dropmaladd": "1712 WARREN ST",
    "dropmalcty": "NACHUSA",
    "dropmalst": "IL",
    "dropmalzpp": 610579800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152885447,
    "dropsitcph": 8152885447,
    "dropfax": 8152850481
  },
  {
    "dcode": "D",
    "dropkey": "PW14091",
    "droptype": "D",
    "dropname": "NAPERVILLE",
    "dropdeladd": "1750 W OGDEN AVE",
    "dropdelcty": "NAPERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605409998,
    "dropphyadd": "1750 W OGDEN AVE",
    "dropphycty": "NAPERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605409998,
    "dropmaladd": "1750 W OGDEN AVE",
    "dropmalcty": "NAPERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6307172662,
    "dropfax": 6307174128
  },
  {
    "dcode": "D",
    "dropkey": "PW14099",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "181 S KASKASKIA ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622639998,
    "dropphyadd": "181 S KASKASKIA ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622639998,
    "dropmaladd": "181 S KASKASKIA ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183278148,
    "dropsitcph": 6183278148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14105",
    "droptype": "D",
    "dropname": "NATIONAL STOCK YARDS",
    "dropdeladd": "3900 COLLINSVILLE RD",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622019997,
    "dropphyadd": "3900 COLLINSVILLE RD",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622019997,
    "dropmaladd": "3900 COLLINSVILLE RD",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622019997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188740458,
    "dropsitcph": 6188740458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14108",
    "droptype": "D",
    "dropname": "NAUVOO",
    "dropdeladd": "55 N BARNETT ST",
    "dropdelcty": "NAUVOO",
    "dropdelst": "IL",
    "dropdelzpp": 623549998,
    "dropphyadd": "55 N BARNETT ST",
    "dropphycty": "NAUVOO",
    "dropphyst": "IL",
    "dropphyzpp": 623549998,
    "dropmaladd": "55 N BARNETT ST",
    "dropmalcty": "NAUVOO",
    "dropmalst": "IL",
    "dropmalzpp": 623549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174532305,
    "dropsitcph": 2174532305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14111",
    "droptype": "D",
    "dropname": "NEBO",
    "dropdeladd": "133 S UNION ST",
    "dropdelcty": "NEBO",
    "dropdelst": "IL",
    "dropdelzpp": 623559998,
    "dropphyadd": "133 S UNION ST",
    "dropphycty": "NEBO",
    "dropphyst": "IL",
    "dropphyzpp": 623559998,
    "dropmaladd": "133 S UNION ST",
    "dropmalcty": "NEBO",
    "dropmalst": "IL",
    "dropmalzpp": 623559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177342141,
    "dropsitcph": 2177342141,
    "dropfax": 2177349256
  },
  {
    "dcode": "D",
    "dropkey": "PW14117",
    "droptype": "D",
    "dropname": "NEOGA",
    "dropdeladd": "256 E 6TH ST",
    "dropdelcty": "NEOGA",
    "dropdelst": "IL",
    "dropdelzpp": 624479998,
    "dropphyadd": "256 E 6TH ST",
    "dropphycty": "NEOGA",
    "dropphyst": "IL",
    "dropphyzpp": 624479998,
    "dropmaladd": "256 E 6TH ST",
    "dropmalcty": "NEOGA",
    "dropmalst": "IL",
    "dropmalzpp": 624479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178953111,
    "dropsitcph": 2178953111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14118",
    "droptype": "D",
    "dropname": "NEPONSET",
    "dropdeladd": "118 W COMMERCIAL ST",
    "dropdelcty": "NEPONSET",
    "dropdelst": "IL",
    "dropdelzpp": 613459708,
    "dropphyadd": "118 W COMMERCIAL ST",
    "dropphycty": "NEPONSET",
    "dropphyst": "IL",
    "dropphyzpp": 613459708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEPONSET",
    "dropmalst": "IL",
    "dropmalzpp": 613459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3095942422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14122",
    "droptype": "D",
    "dropname": "NEW ATHENS",
    "dropdeladd": "200 S BENTON ST",
    "dropdelcty": "NEW ATHENS",
    "dropdelst": "IL",
    "dropdelzpp": 622649998,
    "dropphyadd": "200 S BENTON ST",
    "dropphycty": "NEW ATHENS",
    "dropphyst": "IL",
    "dropphyzpp": 622649998,
    "dropmaladd": "200 S BENTON ST",
    "dropmalcty": "NEW ATHENS",
    "dropmalst": "IL",
    "dropmalzpp": 622649998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182302004,
    "dropsitcph": 6182302004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14123",
    "droptype": "D",
    "dropname": "NEW BADEN",
    "dropdeladd": "203 E HANOVER ST",
    "dropdelcty": "NEW BADEN",
    "dropdelst": "IL",
    "dropdelzpp": 622659998,
    "dropphyadd": "203 E HANOVER ST",
    "dropphycty": "NEW BADEN",
    "dropphyst": "IL",
    "dropphyzpp": 622659998,
    "dropmaladd": "203 E HANOVER ST",
    "dropmalcty": "NEW BADEN",
    "dropmalst": "IL",
    "dropmalzpp": 622659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185884733,
    "dropsitcph": 6185884733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14124",
    "droptype": "D",
    "dropname": "NEW BEDFORD",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "IL",
    "dropdelzpp": 613469700,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "IL",
    "dropphyzpp": 613469700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "IL",
    "dropmalzpp": 613469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154454791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14125",
    "droptype": "D",
    "dropname": "NEW BERLIN",
    "dropdeladd": "102 E ILLINOIS ST",
    "dropdelcty": "NEW BERLIN",
    "dropdelst": "IL",
    "dropdelzpp": 626709998,
    "dropphyadd": "102 E ILLINOIS ST",
    "dropphycty": "NEW BERLIN",
    "dropphyst": "IL",
    "dropphyzpp": 626709998,
    "dropmaladd": "102 E ILLINOIS ST",
    "dropmalcty": "NEW BERLIN",
    "dropmalst": "IL",
    "dropmalzpp": 626709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174887670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14127",
    "droptype": "D",
    "dropname": "NEW BURNSIDE",
    "dropdeladd": "20 W 2ND ST",
    "dropdelcty": "NEW BURNSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 629679998,
    "dropphyadd": "20 W 2ND ST",
    "dropphycty": "NEW BURNSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 629679998,
    "dropmaladd": "20 W 2ND ST",
    "dropmalcty": "NEW BURNSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 629679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187772723,
    "dropsitcph": 6187772723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14129",
    "droptype": "D",
    "dropname": "NEW CANTON",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "NEW CANTON",
    "dropdelst": "IL",
    "dropdelzpp": 623569998,
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "NEW CANTON",
    "dropphyst": "IL",
    "dropphyzpp": 623569998,
    "dropmaladd": "140 N MAIN ST",
    "dropmalcty": "NEW CANTON",
    "dropmalst": "IL",
    "dropmalzpp": 623569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174264181,
    "dropsitcph": 2174264181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14135",
    "droptype": "D",
    "dropname": "NEW DOUGLAS",
    "dropdeladd": "113 N MAIN ST",
    "dropdelcty": "NEW DOUGLAS",
    "dropdelst": "IL",
    "dropdelzpp": 620749998,
    "dropphyadd": "113 N MAIN ST",
    "dropphycty": "NEW DOUGLAS",
    "dropphyst": "IL",
    "dropphyzpp": 620749998,
    "dropmaladd": "113 N MAIN ST",
    "dropmalcty": "NEW DOUGLAS",
    "dropmalst": "IL",
    "dropmalzpp": 620749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174568811,
    "dropsitcph": 2174568811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14137",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "526 VINE ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "IL",
    "dropdelzpp": 628679998,
    "dropphyadd": "526 VINE ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "IL",
    "dropphyzpp": 628679998,
    "dropmaladd": "526 VINE ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "IL",
    "dropmalzpp": 628679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182653293,
    "dropsitcph": 6182653293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14139",
    "droptype": "D",
    "dropname": "NEW HOLLAND",
    "dropdeladd": "104 W LINCOLN ST",
    "dropdelcty": "NEW HOLLAND",
    "dropdelst": "IL",
    "dropdelzpp": 626719998,
    "dropphyadd": "104 W LINCOLN ST",
    "dropphycty": "NEW HOLLAND",
    "dropphyst": "IL",
    "dropphyzpp": 626719998,
    "dropmaladd": "104 W LINCOLN ST",
    "dropmalcty": "NEW HOLLAND",
    "dropmalst": "IL",
    "dropmalzpp": 626719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174452371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14140",
    "droptype": "D",
    "dropname": "NEW LENOX",
    "dropdeladd": "300 N VINE ST",
    "dropdelcty": "NEW LENOX",
    "dropdelst": "IL",
    "dropdelzpp": 604519998,
    "dropphyadd": "300 N VINE ST",
    "dropphycty": "NEW LENOX",
    "dropphyst": "IL",
    "dropphyzpp": 604519998,
    "dropmaladd": "300 N VINE ST",
    "dropmalcty": "NEW LENOX",
    "dropmalst": "IL",
    "dropmalzpp": 604519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154858273,
    "dropfax": 8154857183
  },
  {
    "dcode": "D",
    "dropkey": "PW14142",
    "droptype": "D",
    "dropname": "NEW MEMPHIS",
    "dropdeladd": "84 S 2ND ST",
    "dropdelcty": "NEW MEMPHIS",
    "dropdelst": "IL",
    "dropdelzpp": 622669998,
    "dropphyadd": "84 S 2ND ST",
    "dropphycty": "NEW MEMPHIS",
    "dropphyst": "IL",
    "dropphyzpp": 622669998,
    "dropmaladd": "84 S 2ND ST",
    "dropmalcty": "NEW MEMPHIS",
    "dropmalst": "IL",
    "dropmalzpp": 622669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185884074,
    "dropsitcph": 6185884074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14147",
    "droptype": "D",
    "dropname": "NEW SALEM",
    "dropdeladd": "201 GRIGGSVILLE ST",
    "dropdelcty": "NEW SALEM",
    "dropdelst": "IL",
    "dropdelzpp": 623579998,
    "dropphyadd": "201 GRIGGSVILLE ST",
    "dropphycty": "NEW SALEM",
    "dropphyst": "IL",
    "dropphyzpp": 623579998,
    "dropmaladd": "201 GRIGGSVILLE ST",
    "dropmalcty": "NEW SALEM",
    "dropmalst": "IL",
    "dropmalzpp": 623579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172856805,
    "dropsitcph": 2172856805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14150",
    "droptype": "D",
    "dropname": "NEW WINDSOR",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "NEW WINDSOR",
    "dropdelst": "IL",
    "dropdelzpp": 614659800,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "NEW WINDSOR",
    "dropphyst": "IL",
    "dropphyzpp": 614659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW WINDSOR",
    "dropmalst": "IL",
    "dropmalzpp": 614659998,
    "dropsitphn": 3096672219,
    "dropsitlph": 3096672219,
    "dropsitcph": 3096672219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14151",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "11 E MAIN ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "IL",
    "dropdelzpp": 605419808,
    "dropphyadd": "11 E MAIN ST",
    "dropphycty": "NEWARK",
    "dropphyst": "IL",
    "dropphyzpp": 605419808,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWARK",
    "dropmalst": "IL",
    "dropmalzpp": 605419998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156955242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14154",
    "droptype": "D",
    "dropname": "NEWMAN",
    "dropdeladd": "101 S HOWARD ST",
    "dropdelcty": "NEWMAN",
    "dropdelst": "IL",
    "dropdelzpp": 619429998,
    "dropphyadd": "101 S HOWARD ST",
    "dropphycty": "NEWMAN",
    "dropphyst": "IL",
    "dropphyzpp": 619429998,
    "dropmaladd": "101 S HOWARD ST",
    "dropmalcty": "NEWMAN",
    "dropmalst": "IL",
    "dropmalzpp": 619429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178372783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14158",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "201 W JOURDAN ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "IL",
    "dropdelzpp": 624489998,
    "dropphyadd": "201 W JOURDAN ST",
    "dropphycty": "NEWTON",
    "dropphyst": "IL",
    "dropphyzpp": 624489998,
    "dropmaladd": "201 W JOURDAN ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "IL",
    "dropmalzpp": 624489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187832013,
    "dropsitcph": 6187832013,
    "dropfax": 6187833494
  },
  {
    "dcode": "D",
    "dropkey": "PW14159",
    "droptype": "D",
    "dropname": "NIANTIC",
    "dropdeladd": "155 E LEWIS ST",
    "dropdelcty": "NIANTIC",
    "dropdelst": "IL",
    "dropdelzpp": 625519998,
    "dropphyadd": "155 E LEWIS ST",
    "dropphycty": "NIANTIC",
    "dropphyst": "IL",
    "dropphyzpp": 625519998,
    "dropmaladd": "155 E LEWIS ST",
    "dropmalcty": "NIANTIC",
    "dropmalst": "IL",
    "dropmalzpp": 625519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176687613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14161",
    "droptype": "D",
    "dropname": "NILWOOD",
    "dropdeladd": "31 MOREAN ST",
    "dropdelcty": "NILWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 626729998,
    "dropphyadd": "31 MOREAN ST",
    "dropphycty": "NILWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 626729998,
    "dropmaladd": "31 MOREAN ST",
    "dropmalcty": "NILWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 626729998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176273341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14162",
    "droptype": "D",
    "dropname": "NIOTA",
    "dropdeladd": "275 ARBOR ST",
    "dropdelcty": "NIOTA",
    "dropdelst": "IL",
    "dropdelzpp": 623589998,
    "dropphyadd": "275 ARBOR ST",
    "dropphycty": "NIOTA",
    "dropphyst": "IL",
    "dropphyzpp": 623589998,
    "dropmaladd": "275 ARBOR ST",
    "dropmalcty": "NIOTA",
    "dropmalst": "IL",
    "dropmalzpp": 623589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174484421,
    "dropsitcph": 2174484421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14172",
    "droptype": "D",
    "dropname": "NOBLE",
    "dropdeladd": "110 W NORTH AVE",
    "dropdelcty": "NOBLE",
    "dropdelst": "IL",
    "dropdelzpp": 628689997,
    "dropphyadd": "110 W NORTH AVE",
    "dropphycty": "NOBLE",
    "dropphyst": "IL",
    "dropphyzpp": 628689997,
    "dropmaladd": "110 W NORTH AVE",
    "dropmalcty": "NOBLE",
    "dropmalst": "IL",
    "dropmalzpp": 628689997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187232691,
    "dropsitcph": 6187232691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14173",
    "droptype": "D",
    "dropname": "NOKOMIS",
    "dropdeladd": "121 S PINE ST",
    "dropdelcty": "NOKOMIS",
    "dropdelst": "IL",
    "dropdelzpp": 620759998,
    "dropphyadd": "121 S PINE ST",
    "dropphycty": "NOKOMIS",
    "dropphyst": "IL",
    "dropphyzpp": 620759998,
    "dropmaladd": "121 S PINE ST",
    "dropmalcty": "NOKOMIS",
    "dropmalst": "IL",
    "dropmalzpp": 620759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175632114,
    "dropsitcph": 2175632114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14174",
    "droptype": "D",
    "dropname": "NORA",
    "dropdeladd": "111 W CHESTNUT ST",
    "dropdelcty": "NORA",
    "dropdelst": "IL",
    "dropdelzpp": 610599998,
    "dropphyadd": "111 W CHESTNUT ST",
    "dropphycty": "NORA",
    "dropphyst": "IL",
    "dropphyzpp": 610599998,
    "dropmaladd": "111 W CHESTNUT ST",
    "dropmalcty": "NORA",
    "dropmalst": "IL",
    "dropmalzpp": 610599998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157453128,
    "dropsitcph": 8157453128,
    "dropfax": 8157453113
  },
  {
    "dcode": "D",
    "dropkey": "PW14175",
    "droptype": "D",
    "dropname": "NORMAL",
    "dropdeladd": "200 W NORTH ST",
    "dropdelcty": "NORMAL",
    "dropdelst": "IL",
    "dropdelzpp": 617619900,
    "dropphyadd": "200 W NORTH ST",
    "dropphycty": "NORMAL",
    "dropphyst": "IL",
    "dropphyzpp": 617619900,
    "dropmaladd": "200 W NORTH ST",
    "dropmalcty": "NORMAL",
    "dropmalst": "IL",
    "dropmalzpp": 617619900,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094522909,
    "dropfax": 3098889042
  },
  {
    "dcode": "D",
    "dropkey": "PW14179",
    "droptype": "D",
    "dropname": "NORRIS",
    "dropdeladd": "205 W DIVISION ST",
    "dropdelcty": "NORRIS",
    "dropdelst": "IL",
    "dropdelzpp": 615539995,
    "dropphyadd": "205 W DIVISION ST",
    "dropphycty": "NORRIS",
    "dropphyst": "IL",
    "dropphyzpp": 615539995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORRIS",
    "dropmalst": "IL",
    "dropmalzpp": 615539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096474686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14180",
    "droptype": "D",
    "dropname": "NORRIS CITY",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "NORRIS CITY",
    "dropdelst": "IL",
    "dropdelzpp": 628699998,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "NORRIS CITY",
    "dropphyst": "IL",
    "dropphyzpp": 628699998,
    "dropmaladd": "210 E MAIN ST",
    "dropmalcty": "NORRIS CITY",
    "dropmalst": "IL",
    "dropmalzpp": 628699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183783231,
    "dropsitcph": 6183783231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14183",
    "droptype": "D",
    "dropname": "NORTH AURORA",
    "dropdeladd": "65 S RANDALL RD",
    "dropdelcty": "NORTH AURORA",
    "dropdelst": "IL",
    "dropdelzpp": 605429998,
    "dropphyadd": "65 S RANDALL RD",
    "dropphycty": "NORTH AURORA",
    "dropphyst": "IL",
    "dropphyzpp": 605429998,
    "dropmaladd": "65 S RANDALL RD",
    "dropmalcty": "NORTH AURORA",
    "dropmalst": "IL",
    "dropmalzpp": 605429998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6308963836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14185",
    "droptype": "D",
    "dropname": "NORTH CHICAGO",
    "dropdeladd": "1514 SHERIDAN RD",
    "dropdelcty": "NORTH CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 600641852,
    "dropphyadd": "1514 SHERIDAN RD",
    "dropphycty": "NORTH CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 600641852,
    "dropmaladd": "1514 SHERIDAN RD",
    "dropmalcty": "NORTH CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 600641852,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476891659,
    "dropsitcph": 8476891659,
    "dropfax": 8476891652
  },
  {
    "dcode": "D",
    "dropkey": "PW14189",
    "droptype": "D",
    "dropname": "NORTH HENDERSON",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "NORTH HENDERSON",
    "dropdelst": "IL",
    "dropdelzpp": 614669800,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "NORTH HENDERSON",
    "dropphyst": "IL",
    "dropphyzpp": 614669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH HENDERSON",
    "dropmalst": "IL",
    "dropmalzpp": 614669998,
    "dropsitphn": 3094823264,
    "dropsitlph": 3094645130,
    "dropsitcph": 3094645130,
    "dropfax": 3094645130
  },
  {
    "dcode": "D",
    "dropkey": "PW14201",
    "droptype": "D",
    "dropname": "NORTHBROOK",
    "dropdeladd": "2460 DUNDEE RD",
    "dropdelcty": "NORTHBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 600622620,
    "dropphyadd": "2460 DUNDEE RD",
    "dropphycty": "NORTHBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 600622620,
    "dropmaladd": "2460 DUNDEE RD",
    "dropmalcty": "NORTHBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 600622620,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472720174,
    "dropsitcph": 8472720174,
    "dropfax": 8472729304
  },
  {
    "dcode": "D",
    "dropkey": "PW14228",
    "droptype": "D",
    "dropname": "O FALLON",
    "dropdeladd": "1111 S LINCOLN AVE",
    "dropdelcty": "O FALLON",
    "dropdelst": "IL",
    "dropdelzpp": 622699998,
    "dropphyadd": "1111 S LINCOLN AVE",
    "dropphycty": "O FALLON",
    "dropphyst": "IL",
    "dropphyzpp": 622699998,
    "dropmaladd": "1111 S LINCOLN AVE",
    "dropmalcty": "O FALLON",
    "dropmalst": "IL",
    "dropmalzpp": 622699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186324691,
    "dropsitcph": 6186324691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14233",
    "droptype": "D",
    "dropname": "OAK FOREST",
    "dropdeladd": "15811 CENTRAL AVE",
    "dropdelcty": "OAK FOREST",
    "dropdelst": "IL",
    "dropdelzpp": 604529998,
    "dropphyadd": "15811 CENTRAL AVE",
    "dropphycty": "OAK FOREST",
    "dropphyst": "IL",
    "dropphyzpp": 604529998,
    "dropmaladd": "15811 CENTRAL AVE",
    "dropmalcty": "OAK FOREST",
    "dropmalst": "IL",
    "dropmalzpp": 604529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7086872137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14237",
    "droptype": "D",
    "dropname": "OAK LAWN",
    "dropdeladd": "9249 S CICERO AVE",
    "dropdelcty": "OAK LAWN",
    "dropdelst": "IL",
    "dropdelzpp": 604539700,
    "dropphyadd": "9249 S CICERO AVE",
    "dropphycty": "OAK LAWN",
    "dropphyst": "IL",
    "dropphyzpp": 604539700,
    "dropmaladd": "7401 W 100TH PL",
    "dropmalcty": "BRIDGEVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 604559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7084240880,
    "dropfax": 7082337374
  },
  {
    "dcode": "D",
    "dropkey": "PW14239",
    "droptype": "D",
    "dropname": "OAK PARK",
    "dropdeladd": "901 LAKE ST",
    "dropdelcty": "OAK PARK",
    "dropdelst": "IL",
    "dropdelzpp": 603011286,
    "dropphyadd": "901 LAKE ST",
    "dropphycty": "OAK PARK",
    "dropphyst": "IL",
    "dropphyzpp": 603011286,
    "dropmaladd": "901 LAKE ST",
    "dropmalcty": "OAK PARK",
    "dropmalst": "IL",
    "dropmalzpp": 603011286,
    "dropsitphn": 6302605499,
    "dropsitlph": 7084060122,
    "dropsitcph": 7088482440,
    "dropfax": 7088485196
  },
  {
    "dcode": "D",
    "dropkey": "PW14248",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "21 E 2ND ST",
    "dropdelcty": "OAKDALE",
    "dropdelst": "IL",
    "dropdelzpp": 622689998,
    "dropphyadd": "21 E 2ND ST",
    "dropphycty": "OAKDALE",
    "dropphyst": "IL",
    "dropphyzpp": 622689998,
    "dropmaladd": "21 E 2ND ST",
    "dropmalcty": "OAKDALE",
    "dropmalst": "IL",
    "dropmalzpp": 622689998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183295370,
    "dropsitcph": 6183295370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14249",
    "droptype": "D",
    "dropname": "OAKFORD",
    "dropdeladd": "105 S WHITLEY ST",
    "dropdelcty": "OAKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 626739998,
    "dropphyadd": "105 S WHITLEY ST",
    "dropphycty": "OAKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 626739998,
    "dropmaladd": "105 S WHITLEY ST",
    "dropmalcty": "OAKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 626739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176355387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14250",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "4 PIKE ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "IL",
    "dropdelzpp": 619439998,
    "dropphyadd": "4 PIKE ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "IL",
    "dropphyzpp": 619439998,
    "dropmaladd": "4 PIKE ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "IL",
    "dropmalzpp": 619439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2175150007,
    "dropsitcph": 2175150007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14252",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "110 S SCOTT ST",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 618589998,
    "dropphyadd": "110 S SCOTT ST",
    "dropphycty": "OAKWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 618589998,
    "dropmaladd": "110 S SCOTT ST",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 618589998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173542100,
    "dropfax": 2173542100
  },
  {
    "dcode": "D",
    "dropkey": "PW14255",
    "droptype": "D",
    "dropname": "OBLONG",
    "dropdeladd": "207 N RANGE ST",
    "dropdelcty": "OBLONG",
    "dropdelst": "IL",
    "dropdelzpp": 624499998,
    "dropphyadd": "207 N RANGE ST",
    "dropphycty": "OBLONG",
    "dropphyst": "IL",
    "dropphyzpp": 624499998,
    "dropmaladd": "207 N RANGE ST",
    "dropmalcty": "OBLONG",
    "dropmalst": "IL",
    "dropmalzpp": 624499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185924431,
    "dropsitcph": 6185924431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14256",
    "droptype": "D",
    "dropname": "OCONEE",
    "dropdeladd": "10 OAK ST",
    "dropdelcty": "OCONEE",
    "dropdelst": "IL",
    "dropdelzpp": 625539998,
    "dropphyadd": "10 OAK ST",
    "dropphycty": "OCONEE",
    "dropphyst": "IL",
    "dropphyzpp": 625539998,
    "dropmaladd": "10 OAK ST",
    "dropmalcty": "OCONEE",
    "dropmalst": "IL",
    "dropmalzpp": 625539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2172960004,
    "dropsitcph": 2172960004,
    "dropfax": 2175394320
  },
  {
    "dcode": "D",
    "dropkey": "PW14258",
    "droptype": "D",
    "dropname": "ODELL",
    "dropdeladd": "108 S WAUPANSIE ST",
    "dropdelcty": "ODELL",
    "dropdelst": "IL",
    "dropdelzpp": 604609800,
    "dropphyadd": "108 S WAUPANSIE ST",
    "dropphycty": "ODELL",
    "dropphyst": "IL",
    "dropphyzpp": 604609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODELL",
    "dropmalst": "IL",
    "dropmalzpp": 604609998,
    "dropsitphn": 7085637318,
    "dropsitlph": 8159985041,
    "dropsitcph": 8159985042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14260",
    "droptype": "D",
    "dropname": "ODIN",
    "dropdeladd": "104 E KIRKWOOD ST",
    "dropdelcty": "ODIN",
    "dropdelst": "IL",
    "dropdelzpp": 628709998,
    "dropphyadd": "104 E KIRKWOOD ST",
    "dropphycty": "ODIN",
    "dropphyst": "IL",
    "dropphyzpp": 628709998,
    "dropmaladd": "104 E KIRKWOOD ST",
    "dropmalcty": "ODIN",
    "dropmalst": "IL",
    "dropmalzpp": 628709998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187758327,
    "dropsitcph": 6187758327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14261",
    "droptype": "D",
    "dropname": "OGDEN",
    "dropdeladd": "307 S EAST AVE",
    "dropdelcty": "OGDEN",
    "dropdelst": "IL",
    "dropdelzpp": 618599998,
    "dropphyadd": "307 S EAST AVE",
    "dropphycty": "OGDEN",
    "dropphyst": "IL",
    "dropphyzpp": 618599998,
    "dropmaladd": "307 S EAST AVE",
    "dropmalcty": "OGDEN",
    "dropmalst": "IL",
    "dropmalzpp": 618599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175822694,
    "dropfax": 2175822694
  },
  {
    "dcode": "D",
    "dropkey": "PW14264",
    "droptype": "D",
    "dropname": "OGLESBY",
    "dropdeladd": "203 W WALNUT ST",
    "dropdelcty": "OGLESBY",
    "dropdelst": "IL",
    "dropdelzpp": 613489800,
    "dropphyadd": "203 W WALNUT ST",
    "dropphycty": "OGLESBY",
    "dropphyst": "IL",
    "dropphyzpp": 613489800,
    "dropmaladd": "203 W WALNUT ST",
    "dropmalcty": "OGLESBY",
    "dropmalst": "IL",
    "dropmalzpp": 613489800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158838541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14270",
    "droptype": "D",
    "dropname": "OHIO",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "OHIO",
    "dropdelst": "IL",
    "dropdelzpp": 613499701,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "OHIO",
    "dropphyst": "IL",
    "dropphyzpp": 613499701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OHIO",
    "dropmalst": "IL",
    "dropmalzpp": 613499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153764441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14272",
    "droptype": "D",
    "dropname": "OHLMAN",
    "dropdeladd": "405 1ST ST",
    "dropdelcty": "OHLMAN",
    "dropdelst": "IL",
    "dropdelzpp": 620769998,
    "dropphyadd": "405 1ST ST",
    "dropphycty": "OHLMAN",
    "dropphyst": "IL",
    "dropphyzpp": 620769998,
    "dropmaladd": "405 1ST ST",
    "dropmalcty": "OHLMAN",
    "dropmalst": "IL",
    "dropmalzpp": 620769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175632342,
    "dropsitcph": 2175632342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14273",
    "droptype": "D",
    "dropname": "OKAWVILLE",
    "dropdeladd": "113 E WALNUT ST",
    "dropdelcty": "OKAWVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622719998,
    "dropphyadd": "113 E WALNUT ST",
    "dropphycty": "OKAWVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622719998,
    "dropmaladd": "113 E WALNUT ST",
    "dropmalcty": "OKAWVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622719998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182436183,
    "dropsitcph": 6182436183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14290",
    "droptype": "D",
    "dropname": "OLIVE BRANCH",
    "dropdeladd": "22475 RAILROAD ST",
    "dropdelcty": "OLIVE BRANCH",
    "dropdelst": "IL",
    "dropdelzpp": 629699998,
    "dropphyadd": "22475 RAILROAD ST",
    "dropphycty": "OLIVE BRANCH",
    "dropphyst": "IL",
    "dropphyzpp": 629699998,
    "dropmaladd": "22475 RAILROAD ST",
    "dropmalcty": "OLIVE BRANCH",
    "dropmalst": "IL",
    "dropmalzpp": 629699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187765838,
    "dropsitcph": 6187765838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14292",
    "droptype": "D",
    "dropname": "OLMSTED",
    "dropdeladd": "100 N FRONT ST",
    "dropdelcty": "OLMSTED",
    "dropdelst": "IL",
    "dropdelzpp": 629709998,
    "dropphyadd": "100 N FRONT ST",
    "dropphycty": "OLMSTED",
    "dropphyst": "IL",
    "dropphyzpp": 629709998,
    "dropmaladd": "100 N FRONT ST",
    "dropmalcty": "OLMSTED",
    "dropmalst": "IL",
    "dropmalzpp": 629709998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187428135,
    "dropsitcph": 6187428135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14293",
    "droptype": "D",
    "dropname": "OLNEY",
    "dropdeladd": "330 S WHITTLE AVE",
    "dropdelcty": "OLNEY",
    "dropdelst": "IL",
    "dropdelzpp": 624509998,
    "dropphyadd": "330 S WHITTLE AVE",
    "dropphycty": "OLNEY",
    "dropphyst": "IL",
    "dropphyzpp": 624509998,
    "dropmaladd": "330 S WHITTLE AVE",
    "dropmalcty": "OLNEY",
    "dropmalst": "IL",
    "dropmalzpp": 624509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183957097,
    "dropsitcph": 6183957097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14296",
    "droptype": "D",
    "dropname": "OLYMPIA FIELDS",
    "dropdeladd": "3033 203RD ST",
    "dropdelcty": "OLYMPIA FIELDS",
    "dropdelst": "IL",
    "dropdelzpp": 604619998,
    "dropphyadd": "3033 203RD ST",
    "dropphycty": "OLYMPIA FIELDS",
    "dropphyst": "IL",
    "dropphyzpp": 604619998,
    "dropmaladd": "3033 203RD ST",
    "dropmalcty": "OLYMPIA FIELDS",
    "dropmalst": "IL",
    "dropmalzpp": 604619998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087489222,
    "dropfax": 7087485838
  },
  {
    "dcode": "D",
    "dropkey": "PW14298",
    "droptype": "D",
    "dropname": "OMAHA",
    "dropdeladd": "430 2ND ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "IL",
    "dropdelzpp": 628719997,
    "dropphyadd": "430 2ND ST",
    "dropphycty": "OMAHA",
    "dropphyst": "IL",
    "dropphyzpp": 628719997,
    "dropmaladd": "430 2ND ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "IL",
    "dropmalzpp": 628719997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189623128,
    "dropsitcph": 6189623128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14300",
    "droptype": "D",
    "dropname": "ONARGA",
    "dropdeladd": "120 W SEMINARY AVE",
    "dropdelcty": "ONARGA",
    "dropdelst": "IL",
    "dropdelzpp": 609559998,
    "dropphyadd": "120 W SEMINARY AVE",
    "dropphycty": "ONARGA",
    "dropphyst": "IL",
    "dropphyzpp": 609559998,
    "dropmaladd": "120 W SEMINARY AVE",
    "dropmalcty": "ONARGA",
    "dropmalst": "IL",
    "dropmalzpp": 609559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152684267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14302",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "126 E HOLMES ST",
    "dropdelcty": "ONEIDA",
    "dropdelst": "IL",
    "dropdelzpp": 614675054,
    "dropphyadd": "126 E HOLMES ST",
    "dropphycty": "ONEIDA",
    "dropphyst": "IL",
    "dropphyzpp": 614675054,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONEIDA",
    "dropmalst": "IL",
    "dropmalzpp": 614679998,
    "dropsitphn": 3094838365,
    "dropsitlph": 3094838365,
    "dropsitcph": 3094838365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14308",
    "droptype": "D",
    "dropname": "OPDYKE",
    "dropdeladd": "19206 E 8TH ST",
    "dropdelcty": "OPDYKE",
    "dropdelst": "IL",
    "dropdelzpp": 628729997,
    "dropphyadd": "19206 E 8TH ST",
    "dropphycty": "OPDYKE",
    "dropphyst": "IL",
    "dropphyzpp": 628729997,
    "dropmaladd": "19206 E 8TH ST",
    "dropmalcty": "OPDYKE",
    "dropmalst": "IL",
    "dropmalzpp": 628729997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187562409,
    "dropsitcph": 6187562409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14310",
    "droptype": "D",
    "dropname": "OQUAWKA",
    "dropdeladd": "403 SCHUYLER ST",
    "dropdelcty": "OQUAWKA",
    "dropdelst": "IL",
    "dropdelzpp": 614699998,
    "dropphyadd": "403 SCHUYLER ST",
    "dropphycty": "OQUAWKA",
    "dropphyst": "IL",
    "dropphyzpp": 614699998,
    "dropmaladd": "403 SCHUYLER ST",
    "dropmalcty": "OQUAWKA",
    "dropmalst": "IL",
    "dropmalzpp": 614699998,
    "dropsitphn": 3098672781,
    "dropsitlph": 3098672781,
    "dropsitcph": 3098672781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14311",
    "droptype": "D",
    "dropname": "ORANGEVILLE",
    "dropdeladd": "211 W HIGH ST",
    "dropdelcty": "ORANGEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 610609215,
    "dropphyadd": "211 W HIGH ST",
    "dropphycty": "ORANGEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 610609215,
    "dropmaladd": "211 W HIGH ST",
    "dropmalcty": "ORANGEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 610609215,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157894750,
    "dropsitcph": 8157894750,
    "dropfax": 8157893350
  },
  {
    "dcode": "D",
    "dropkey": "PW14321",
    "droptype": "D",
    "dropname": "OREANA",
    "dropdeladd": "205 W SOUTH ST",
    "dropdelcty": "OREANA",
    "dropdelst": "IL",
    "dropdelzpp": 625549998,
    "dropphyadd": "205 W SOUTH ST",
    "dropphycty": "OREANA",
    "dropphyst": "IL",
    "dropphyzpp": 625549998,
    "dropmaladd": "205 W SOUTH ST",
    "dropmalcty": "OREANA",
    "dropmalst": "IL",
    "dropmalzpp": 625549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174682042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14322",
    "droptype": "D",
    "dropname": "OREGON",
    "dropdeladd": "500 W WASHINGTON ST",
    "dropdelcty": "OREGON",
    "dropdelst": "IL",
    "dropdelzpp": 610611630,
    "dropphyadd": "500 W WASHINGTON ST",
    "dropphycty": "OREGON",
    "dropphyst": "IL",
    "dropphyzpp": 610611630,
    "dropmaladd": "500 W WASHINGTON ST",
    "dropmalcty": "OREGON",
    "dropmalst": "IL",
    "dropmalzpp": 610611630,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157322418,
    "dropsitcph": 8157322418,
    "dropfax": 8157327649
  },
  {
    "dcode": "D",
    "dropkey": "PW14325",
    "droptype": "D",
    "dropname": "ORION",
    "dropdeladd": "1012 4TH ST",
    "dropdelcty": "ORION",
    "dropdelst": "IL",
    "dropdelzpp": 612737731,
    "dropphyadd": "1012 4TH ST",
    "dropphycty": "ORION",
    "dropphyst": "IL",
    "dropphyzpp": 612737731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORION",
    "dropmalst": "IL",
    "dropmalzpp": 612739998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095268065,
    "dropsitcph": 3095268065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14328",
    "droptype": "D",
    "dropname": "ORLAND PARK",
    "dropdeladd": "9500 W 144TH PL",
    "dropdelcty": "ORLAND PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604629998,
    "dropphyadd": "9500 W 144TH PL",
    "dropphycty": "ORLAND PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604629998,
    "dropmaladd": "9500 W 144TH PL",
    "dropmalcty": "ORLAND PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604629998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083498030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14335",
    "droptype": "D",
    "dropname": "OSCO",
    "dropdeladd": "203 N RAILROAD ST",
    "dropdelcty": "OSCO",
    "dropdelst": "IL",
    "dropdelzpp": 612749000,
    "dropphyadd": "203 N RAILROAD ST",
    "dropphycty": "OSCO",
    "dropphyst": "IL",
    "dropphyzpp": 612749000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSCO",
    "dropmalst": "IL",
    "dropmalzpp": 612749998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095225504,
    "dropsitcph": 3095225504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14339",
    "droptype": "D",
    "dropname": "OSWEGO",
    "dropdeladd": "26 S MADISON ST",
    "dropdelcty": "OSWEGO",
    "dropdelst": "IL",
    "dropdelzpp": 605439998,
    "dropphyadd": "26 S MADISON ST",
    "dropphycty": "OSWEGO",
    "dropphyst": "IL",
    "dropphyzpp": 605439998,
    "dropmaladd": "26 S MADISON ST",
    "dropmalcty": "OSWEGO",
    "dropmalst": "IL",
    "dropmalzpp": 605439998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6305548410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14341",
    "droptype": "D",
    "dropname": "OTTAWA",
    "dropdeladd": "750 E ETNA RD",
    "dropdelcty": "OTTAWA",
    "dropdelst": "IL",
    "dropdelzpp": 613509998,
    "dropphyadd": "750 E ETNA RD",
    "dropphycty": "OTTAWA",
    "dropphyst": "IL",
    "dropphyzpp": 613509998,
    "dropmaladd": "750 E ETNA RD",
    "dropmalcty": "OTTAWA",
    "dropmalst": "IL",
    "dropmalzpp": 613509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154331177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14352",
    "droptype": "D",
    "dropname": "OZARK",
    "dropdeladd": "495 OZARK RD",
    "dropdelcty": "OZARK",
    "dropdelst": "IL",
    "dropdelzpp": 629729998,
    "dropphyadd": "495 OZARK RD",
    "dropphycty": "OZARK",
    "dropphyst": "IL",
    "dropphyzpp": 629729998,
    "dropmaladd": "495 OZARK RD",
    "dropmalcty": "OZARK",
    "dropmalst": "IL",
    "dropmalzpp": 629729998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187772355,
    "dropsitcph": 6187772355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14358",
    "droptype": "D",
    "dropname": "PALATINE",
    "dropdeladd": "440 W COLFAX ST",
    "dropdelcty": "PALATINE",
    "dropdelst": "IL",
    "dropdelzpp": 600672537,
    "dropphyadd": "440 W COLFAX ST",
    "dropphycty": "PALATINE",
    "dropphyst": "IL",
    "dropphyzpp": 600672537,
    "dropmaladd": "440 W COLFAX ST",
    "dropmalcty": "PALATINE",
    "dropmalst": "IL",
    "dropmalzpp": 600672537,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473591799,
    "dropsitcph": 8473591799,
    "dropfax": 8473591797
  },
  {
    "dcode": "D",
    "dropkey": "PW14364",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "107 W MARKET ST",
    "dropdelcty": "PALESTINE",
    "dropdelst": "IL",
    "dropdelzpp": 624519998,
    "dropphyadd": "107 W MARKET ST",
    "dropphycty": "PALESTINE",
    "dropphyst": "IL",
    "dropphyzpp": 624519998,
    "dropmaladd": "107 W MARKET ST",
    "dropmalcty": "PALESTINE",
    "dropmalst": "IL",
    "dropmalzpp": 624519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185862574,
    "dropsitcph": 6185862574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14366",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "910 5TH ST",
    "dropdelcty": "PALMER",
    "dropdelst": "IL",
    "dropdelzpp": 625569998,
    "dropphyadd": "910 5TH ST",
    "dropphycty": "PALMER",
    "dropphyst": "IL",
    "dropphyzpp": 625569998,
    "dropmaladd": "910 5TH ST",
    "dropmalcty": "PALMER",
    "dropmalst": "IL",
    "dropmalzpp": 625569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175263143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14367",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "130 S MAIN ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "IL",
    "dropdelzpp": 626749998,
    "dropphyadd": "130 S MAIN ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "IL",
    "dropphyzpp": 626749998,
    "dropmaladd": "130 S MAIN ST",
    "dropmalcty": "PALMYRA",
    "dropmalst": "IL",
    "dropmalzpp": 626749998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174362013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14369",
    "droptype": "D",
    "dropname": "PALOS HEIGHTS",
    "dropdeladd": "12238 S HARLEM AVE",
    "dropdelcty": "PALOS HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 604639998,
    "dropphyadd": "12238 S HARLEM AVE",
    "dropphycty": "PALOS HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 604639998,
    "dropmaladd": "12238 S HARLEM AVE",
    "dropmalcty": "PALOS HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 604639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084482040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14375",
    "droptype": "D",
    "dropname": "PALOS PARK",
    "dropdeladd": "12100 S 80TH AVE",
    "dropdelcty": "PALOS PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604649998,
    "dropphyadd": "12100 S 80TH AVE",
    "dropphycty": "PALOS PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604649998,
    "dropmaladd": "12100 S 80TH AVE",
    "dropmalcty": "PALOS PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7084486134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14378",
    "droptype": "D",
    "dropname": "PANA",
    "dropdeladd": "214 S LOCUST ST",
    "dropdelcty": "PANA",
    "dropdelst": "IL",
    "dropdelzpp": 625579998,
    "dropphyadd": "214 S LOCUST ST",
    "dropphycty": "PANA",
    "dropphyst": "IL",
    "dropphyzpp": 625579998,
    "dropmaladd": "214 S LOCUST ST",
    "dropmalcty": "PANA",
    "dropmalst": "IL",
    "dropmalzpp": 625579998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175622020,
    "dropfax": 2175622029
  },
  {
    "dcode": "D",
    "dropkey": "PW14379",
    "droptype": "D",
    "dropname": "PANAMA",
    "dropdeladd": "106 NORTH AVE",
    "dropdelcty": "PANAMA",
    "dropdelst": "IL",
    "dropdelzpp": 620779998,
    "dropphyadd": "106 NORTH AVE",
    "dropphycty": "PANAMA",
    "dropphyst": "IL",
    "dropphyzpp": 620779998,
    "dropmaladd": "106 NORTH AVE",
    "dropmalcty": "PANAMA",
    "dropmalst": "IL",
    "dropmalzpp": 620779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175373441,
    "dropsitcph": 2175373441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14383",
    "droptype": "D",
    "dropname": "PAPINEAU",
    "dropdeladd": "105 E PAPINEAU ST",
    "dropdelcty": "PAPINEAU",
    "dropdelst": "IL",
    "dropdelzpp": 609569800,
    "dropphyadd": "105 E PAPINEAU ST",
    "dropphycty": "PAPINEAU",
    "dropphyst": "IL",
    "dropphyzpp": 609569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAPINEAU",
    "dropmalst": "IL",
    "dropmalzpp": 609569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154287406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14384",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "139 E WOOD ST",
    "dropdelcty": "PARIS",
    "dropdelst": "IL",
    "dropdelzpp": 619449998,
    "dropphyadd": "139 E WOOD ST",
    "dropphycty": "PARIS",
    "dropphyst": "IL",
    "dropphyzpp": 619449998,
    "dropmaladd": "139 E WOOD ST",
    "dropmalcty": "PARIS",
    "dropmalst": "IL",
    "dropmalzpp": 619449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174665960,
    "dropfax": 2174631495
  },
  {
    "dcode": "D",
    "dropkey": "PW14386",
    "droptype": "D",
    "dropname": "PARK FOREST",
    "dropdeladd": "123 INDIANWOOD BLVD",
    "dropdelcty": "PARK FOREST",
    "dropdelst": "IL",
    "dropdelzpp": 604669998,
    "dropphyadd": "123 INDIANWOOD BLVD",
    "dropphycty": "PARK FOREST",
    "dropphyst": "IL",
    "dropphyzpp": 604669998,
    "dropmaladd": "123 INDIANWOOD BLVD",
    "dropmalcty": "PARK FOREST",
    "dropmalst": "IL",
    "dropmalzpp": 604669998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087485471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14393",
    "droptype": "D",
    "dropname": "PARK RIDGE",
    "dropdeladd": "333 BUSSE HWY",
    "dropdelcty": "PARK RIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 600683285,
    "dropphyadd": "333 BUSSE HWY",
    "dropphycty": "PARK RIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 600683285,
    "dropmaladd": "333 BUSSE HWY",
    "dropmalcty": "PARK RIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 600683285,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478251111,
    "dropsitcph": 8478251111,
    "dropfax": 8478253017
  },
  {
    "dcode": "D",
    "dropkey": "PW14396",
    "droptype": "D",
    "dropname": "PARKERSBURG",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 624529998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 624529998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 624529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184425565,
    "dropsitcph": 6184425565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14402",
    "droptype": "D",
    "dropname": "PATOKA",
    "dropdeladd": "105 S RAILROAD ST",
    "dropdelcty": "PATOKA",
    "dropdelst": "IL",
    "dropdelzpp": 628759998,
    "dropphyadd": "105 S RAILROAD ST",
    "dropphycty": "PATOKA",
    "dropphyst": "IL",
    "dropphyzpp": 628759998,
    "dropmaladd": "105 S RAILROAD ST",
    "dropmalcty": "PATOKA",
    "dropmalst": "IL",
    "dropmalzpp": 628759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184325922,
    "dropsitcph": 6184325922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14403",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "36 ELIZABETH ST",
    "dropdelcty": "PATTERSON",
    "dropdelst": "IL",
    "dropdelzpp": 620789998,
    "dropphyadd": "36 ELIZABETH ST",
    "dropphycty": "PATTERSON",
    "dropphyst": "IL",
    "dropphyzpp": 620789998,
    "dropmaladd": "36 ELIZABETH ST",
    "dropmalcty": "PATTERSON",
    "dropmalst": "IL",
    "dropmalzpp": 620789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179274250,
    "dropsitcph": 2179274250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14407",
    "droptype": "D",
    "dropname": "PAW PAW",
    "dropdeladd": "226 CHICAGO RD",
    "dropdelcty": "PAW PAW",
    "dropdelst": "IL",
    "dropdelzpp": 613539536,
    "dropphyadd": "226 CHICAGO RD",
    "dropphycty": "PAW PAW",
    "dropphyst": "IL",
    "dropphyzpp": 613539536,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAW PAW",
    "dropmalst": "IL",
    "dropmalzpp": 613539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156273711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14408",
    "droptype": "D",
    "dropname": "PAWNEE",
    "dropdeladd": "620 5TH ST",
    "dropdelcty": "PAWNEE",
    "dropdelst": "IL",
    "dropdelzpp": 625589998,
    "dropphyadd": "620 5TH ST",
    "dropphycty": "PAWNEE",
    "dropphyst": "IL",
    "dropphyzpp": 625589998,
    "dropmaladd": "620 5TH ST",
    "dropmalcty": "PAWNEE",
    "dropmalst": "IL",
    "dropmalzpp": 625589998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176257070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14409",
    "droptype": "D",
    "dropname": "PAXTON",
    "dropdeladd": "209 S MARKET ST",
    "dropdelcty": "PAXTON",
    "dropdelst": "IL",
    "dropdelzpp": 609571458,
    "dropphyadd": "209 S MARKET ST",
    "dropphycty": "PAXTON",
    "dropphyst": "IL",
    "dropphyzpp": 609571458,
    "dropmaladd": "209 S MARKET ST",
    "dropmalcty": "PAXTON",
    "dropmalst": "IL",
    "dropmalzpp": 609571458,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173793131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14411",
    "droptype": "D",
    "dropname": "PAYSON",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "PAYSON",
    "dropdelst": "IL",
    "dropdelzpp": 623609998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "PAYSON",
    "dropphyst": "IL",
    "dropphyzpp": 623609998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "PAYSON",
    "dropmalst": "IL",
    "dropmalzpp": 623609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176563002,
    "dropsitcph": 2176563002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14412",
    "droptype": "D",
    "dropname": "PEARL",
    "dropdeladd": "105 N FRONT ST",
    "dropdelcty": "PEARL",
    "dropdelst": "IL",
    "dropdelzpp": 623619998,
    "dropphyadd": "105 N FRONT ST",
    "dropphycty": "PEARL",
    "dropphyst": "IL",
    "dropphyzpp": 623619998,
    "dropmaladd": "105 N FRONT ST",
    "dropmalcty": "PEARL",
    "dropmalst": "IL",
    "dropmalzpp": 623619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178294213,
    "dropsitcph": 2178294213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14413",
    "droptype": "D",
    "dropname": "PEARL CITY",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "PEARL CITY",
    "dropdelst": "IL",
    "dropdelzpp": 610628702,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "PEARL CITY",
    "dropphyst": "IL",
    "dropphyzpp": 610628702,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "PEARL CITY",
    "dropmalst": "IL",
    "dropmalzpp": 610628702,
    "dropsitphn": 6302605499,
    "dropsitlph": 8154432574,
    "dropsitcph": 8154432574,
    "dropfax": 8154432900
  },
  {
    "dcode": "D",
    "dropkey": "PW14415",
    "droptype": "D",
    "dropname": "PECATONICA",
    "dropdeladd": "120 E 3RD ST",
    "dropdelcty": "PECATONICA",
    "dropdelst": "IL",
    "dropdelzpp": 610639194,
    "dropphyadd": "120 E 3RD ST",
    "dropphycty": "PECATONICA",
    "dropphyst": "IL",
    "dropphyzpp": 610639194,
    "dropmaladd": "120 E 3RD ST",
    "dropmalcty": "PECATONICA",
    "dropmalst": "IL",
    "dropmalzpp": 610639194,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152392656,
    "dropsitcph": 8152392656,
    "dropfax": 8152399042
  },
  {
    "dcode": "D",
    "dropkey": "PW14418",
    "droptype": "D",
    "dropname": "PEKIN",
    "dropdeladd": "514 BROADWAY ST",
    "dropdelcty": "PEKIN",
    "dropdelst": "IL",
    "dropdelzpp": 615549998,
    "dropphyadd": "514 BROADWAY ST",
    "dropphycty": "PEKIN",
    "dropphyst": "IL",
    "dropphyzpp": 615549998,
    "dropmaladd": "514 BROADWAY ST",
    "dropmalcty": "PEKIN",
    "dropmalst": "IL",
    "dropmalzpp": 615549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093467878,
    "dropfax": 3093467666
  },
  {
    "dcode": "D",
    "dropkey": "PW14423",
    "droptype": "D",
    "dropname": "PENFIELD",
    "dropdeladd": "128 MAIN ST",
    "dropdelcty": "PENFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 618629998,
    "dropphyadd": "128 MAIN ST",
    "dropphycty": "PENFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 618629998,
    "dropmaladd": "128 MAIN ST",
    "dropmalcty": "PENFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 618629998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175955544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14427",
    "droptype": "D",
    "dropname": "PEORIA",
    "dropdeladd": "95 STATE ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616019998,
    "dropphyadd": "95 STATE ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616019998,
    "dropmaladd": "95 STATE ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096718822,
    "dropfax": 3096748983
  },
  {
    "dcode": "D",
    "dropkey": "PW14431",
    "droptype": "D",
    "dropname": "PEOTONE",
    "dropdeladd": "117 S WEST ST",
    "dropdelcty": "PEOTONE",
    "dropdelst": "IL",
    "dropdelzpp": 604689998,
    "dropphyadd": "117 S WEST ST",
    "dropphycty": "PEOTONE",
    "dropphyst": "IL",
    "dropphyzpp": 604689998,
    "dropmaladd": "117 S WEST ST",
    "dropmalcty": "PEOTONE",
    "dropmalst": "IL",
    "dropmalzpp": 604689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7082586717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14432",
    "droptype": "D",
    "dropname": "PERCY",
    "dropdeladd": "112 E PINE ST",
    "dropdelcty": "PERCY",
    "dropdelst": "IL",
    "dropdelzpp": 622729998,
    "dropphyadd": "112 E PINE ST",
    "dropphycty": "PERCY",
    "dropphyst": "IL",
    "dropphyzpp": 622729998,
    "dropmaladd": "112 E PINE ST",
    "dropmalcty": "PERCY",
    "dropmalst": "IL",
    "dropmalzpp": 622729998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184972821,
    "dropsitcph": 6184972821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14435",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "PERRY",
    "dropdelst": "IL",
    "dropdelzpp": 623629998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "PERRY",
    "dropphyst": "IL",
    "dropphyzpp": 623629998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "PERRY",
    "dropmalst": "IL",
    "dropmalzpp": 623629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172365131,
    "dropsitcph": 2172365131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14438",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "1500 4TH ST",
    "dropdelcty": "PERU",
    "dropdelst": "IL",
    "dropdelzpp": 613549801,
    "dropphyadd": "1500 4TH ST",
    "dropphycty": "PERU",
    "dropphyst": "IL",
    "dropphyzpp": 613549801,
    "dropmaladd": "1500 4TH ST",
    "dropmalcty": "PERU",
    "dropmalst": "IL",
    "dropmalzpp": 613549801,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8152230320,
    "dropfax": 8152230788
  },
  {
    "dcode": "D",
    "dropkey": "PW14439",
    "droptype": "D",
    "dropname": "PESOTUM",
    "dropdeladd": "103 1/2 E LINCOLN ST",
    "dropdelcty": "PESOTUM",
    "dropdelst": "IL",
    "dropdelzpp": 618639998,
    "dropphyadd": "103 1/2 E LINCOLN ST",
    "dropphycty": "PESOTUM",
    "dropphyst": "IL",
    "dropphyzpp": 618639998,
    "dropmaladd": "103 1/2 E LINCOLN ST",
    "dropmalcty": "PESOTUM",
    "dropmalst": "IL",
    "dropmalzpp": 618639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178672459,
    "dropfax": 2178672459
  },
  {
    "dcode": "D",
    "dropkey": "PW14441",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "220 S 7TH ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 626759998,
    "dropphyadd": "220 S 7TH ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 626759998,
    "dropmaladd": "220 S 7TH ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 626759998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176323291,
    "dropfax": 2176323958
  },
  {
    "dcode": "D",
    "dropkey": "PW14446",
    "droptype": "D",
    "dropname": "PHILO",
    "dropdeladd": "126 W WASHINGTON ST",
    "dropdelcty": "PHILO",
    "dropdelst": "IL",
    "dropdelzpp": 618649998,
    "dropphyadd": "126 W WASHINGTON ST",
    "dropphycty": "PHILO",
    "dropphyst": "IL",
    "dropphyzpp": 618649998,
    "dropmaladd": "126 W WASHINGTON ST",
    "dropmalcty": "PHILO",
    "dropmalst": "IL",
    "dropmalzpp": 618649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176842819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14449",
    "droptype": "D",
    "dropname": "PIASA",
    "dropdeladd": "1276 ROUTE 16",
    "dropdelcty": "PIASA",
    "dropdelst": "IL",
    "dropdelzpp": 620799998,
    "dropphyadd": "1276 ROUTE 16",
    "dropphycty": "PIASA",
    "dropphyst": "IL",
    "dropphyzpp": 620799998,
    "dropmaladd": "1276 ROUTE 16",
    "dropmalcty": "PIASA",
    "dropmalst": "IL",
    "dropmalzpp": 620799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187293850,
    "dropsitcph": 6187293850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14451",
    "droptype": "D",
    "dropname": "PIERRON",
    "dropdeladd": "237 ILLINOIS ROUTE 143",
    "dropdelcty": "PIERRON",
    "dropdelst": "IL",
    "dropdelzpp": 622739998,
    "dropphyadd": "237 ILLINOIS ROUTE 143",
    "dropphycty": "PIERRON",
    "dropphyst": "IL",
    "dropphyzpp": 622739998,
    "dropmaladd": "237 ILLINOIS ROUTE 143",
    "dropmalcty": "PIERRON",
    "dropmalst": "IL",
    "dropmalzpp": 622739998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186547214,
    "dropsitcph": 6186547214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14459",
    "droptype": "D",
    "dropname": "PINCKNEYVILLE",
    "dropdeladd": "212 S WALNUT ST",
    "dropdelcty": "PINCKNEYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622749998,
    "dropphyadd": "212 S WALNUT ST",
    "dropphycty": "PINCKNEYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622749998,
    "dropmaladd": "212 S WALNUT ST",
    "dropmalcty": "PINCKNEYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183572323,
    "dropsitcph": 6183572323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14468",
    "droptype": "D",
    "dropname": "PIPER CITY",
    "dropdeladd": "2 N PINE ST",
    "dropdelcty": "PIPER CITY",
    "dropdelst": "IL",
    "dropdelzpp": 609599800,
    "dropphyadd": "2 N PINE ST",
    "dropphycty": "PIPER CITY",
    "dropphyst": "IL",
    "dropphyzpp": 609599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIPER CITY",
    "dropmalst": "IL",
    "dropmalzpp": 609599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156862627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14472",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "16181 PITTSBURG RD",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 629749998,
    "dropphyadd": "16181 PITTSBURG RD",
    "dropphycty": "PITTSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 629749998,
    "dropmaladd": "16181 PITTSBURG RD",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 629749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189938643,
    "dropsitcph": 6189938643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14474",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "129 S MADISON ST",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 623639998,
    "dropphyadd": "129 S MADISON ST",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 623639998,
    "dropmaladd": "129 S MADISON ST",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 623639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172856963,
    "dropsitcph": 2172856963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14479",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "14855 S VAN DYKE RD",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 605449998,
    "dropphyadd": "14855 S VAN DYKE RD",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 605449998,
    "dropmaladd": "14855 S VAN DYKE RD",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 605449998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 8154363095,
    "dropfax": 8154363872
  },
  {
    "dcode": "D",
    "dropkey": "PW14482",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "230 E MAIN ST",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 623659998,
    "dropphyadd": "230 E MAIN ST",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 623659998,
    "dropmaladd": "230 E MAIN ST",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 623659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176563106,
    "dropsitcph": 2176563106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14483",
    "droptype": "D",
    "dropname": "PLANO",
    "dropdeladd": "102 N CENTER ST",
    "dropdelcty": "PLANO",
    "dropdelst": "IL",
    "dropdelzpp": 605459998,
    "dropphyadd": "102 N CENTER ST",
    "dropphycty": "PLANO",
    "dropphyst": "IL",
    "dropphyzpp": 605459998,
    "dropmaladd": "102 N CENTER ST",
    "dropmalcty": "PLANO",
    "dropmalst": "IL",
    "dropmalzpp": 605459998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6305523451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14488",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "108 E QUINCY ST",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "IL",
    "dropdelzpp": 623669998,
    "dropphyadd": "108 E QUINCY ST",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "IL",
    "dropphyzpp": 623669998,
    "dropmaladd": "108 E QUINCY ST",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "IL",
    "dropmalzpp": 623669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177342913,
    "dropsitcph": 2177342913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14491",
    "droptype": "D",
    "dropname": "PLEASANT PLAINS",
    "dropdeladd": "210 N CARTWRIGHT ST",
    "dropdelcty": "PLEASANT PLAINS",
    "dropdelst": "IL",
    "dropdelzpp": 626779998,
    "dropphyadd": "210 N CARTWRIGHT ST",
    "dropphycty": "PLEASANT PLAINS",
    "dropphyst": "IL",
    "dropphyzpp": 626779998,
    "dropmaladd": "210 N CARTWRIGHT ST",
    "dropmalcty": "PLEASANT PLAINS",
    "dropmalst": "IL",
    "dropmalzpp": 626779998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176261571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14495",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "107 EASTSIDE SQ",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "IL",
    "dropdelzpp": 623679998,
    "dropphyadd": "107 EASTSIDE SQ",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "IL",
    "dropphyzpp": 623679998,
    "dropmaladd": "107 EASTSIDE SQ",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "IL",
    "dropmalzpp": 623679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3094583320,
    "dropsitcph": 3094583320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14496",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "107 PARK ST",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "IL",
    "dropdelzpp": 622759998,
    "dropphyadd": "107 PARK ST",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "IL",
    "dropphyzpp": 622759998,
    "dropmaladd": "107 PARK ST",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "IL",
    "dropmalzpp": 622759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186692384,
    "dropsitcph": 6186692384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14498",
    "droptype": "D",
    "dropname": "POLO",
    "dropdeladd": "110 N FRANKLIN AVE",
    "dropdelcty": "POLO",
    "dropdelst": "IL",
    "dropdelzpp": 610641553,
    "dropphyadd": "110 N FRANKLIN AVE",
    "dropphycty": "POLO",
    "dropphyst": "IL",
    "dropphyzpp": 610641553,
    "dropmaladd": "110 N FRANKLIN AVE",
    "dropmalcty": "POLO",
    "dropmalst": "IL",
    "dropmalzpp": 610641553,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159463615,
    "dropsitcph": 8159463615,
    "dropfax": 8159464348
  },
  {
    "dcode": "D",
    "dropkey": "PW14500",
    "droptype": "D",
    "dropname": "PONTIAC",
    "dropdeladd": "302 W MADISON ST",
    "dropdelcty": "PONTIAC",
    "dropdelst": "IL",
    "dropdelzpp": 617649998,
    "dropphyadd": "302 W MADISON ST",
    "dropphycty": "PONTIAC",
    "dropphyst": "IL",
    "dropphyzpp": 617649998,
    "dropmaladd": "302 W MADISON ST",
    "dropmalcty": "PONTIAC",
    "dropmalst": "IL",
    "dropmalzpp": 617649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158446195,
    "dropfax": 8158423096
  },
  {
    "dcode": "D",
    "dropkey": "PW14509",
    "droptype": "D",
    "dropname": "POPLAR GROVE",
    "dropdeladd": "105 E BRITNIE DR",
    "dropdelcty": "POPLAR GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 610658325,
    "dropphyadd": "105 E BRITNIE DR",
    "dropphycty": "POPLAR GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 610658325,
    "dropmaladd": "105 E BRITNIE DR",
    "dropmalcty": "POPLAR GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 610658325,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157651572,
    "dropsitcph": 8157651572,
    "dropfax": 8157652368
  },
  {
    "dcode": "D",
    "dropkey": "PW14511",
    "droptype": "D",
    "dropname": "PORT BYRON",
    "dropdeladd": "105 HICKORY ST",
    "dropdelcty": "PORT BYRON",
    "dropdelst": "IL",
    "dropdelzpp": 612759490,
    "dropphyadd": "105 HICKORY ST",
    "dropphycty": "PORT BYRON",
    "dropphyst": "IL",
    "dropphyzpp": 612759490,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT BYRON",
    "dropmalst": "IL",
    "dropmalzpp": 612759998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095232345,
    "dropsitcph": 3095232345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14515",
    "droptype": "D",
    "dropname": "POSEN",
    "dropdeladd": "2720 147TH ST",
    "dropdelcty": "POSEN",
    "dropdelst": "IL",
    "dropdelzpp": 604691548,
    "dropphyadd": "2720 147TH ST",
    "dropphycty": "POSEN",
    "dropphyst": "IL",
    "dropphyzpp": 604691548,
    "dropmaladd": "2720 147TH ST",
    "dropmalcty": "POSEN",
    "dropmalst": "IL",
    "dropmalzpp": 604691548,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083887788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14517",
    "droptype": "D",
    "dropname": "POTOMAC",
    "dropdeladd": "107 W STATE ST",
    "dropdelcty": "POTOMAC",
    "dropdelst": "IL",
    "dropdelzpp": 618659998,
    "dropphyadd": "107 W STATE ST",
    "dropphycty": "POTOMAC",
    "dropphyst": "IL",
    "dropphyzpp": 618659998,
    "dropmaladd": "107 W STATE ST",
    "dropmalcty": "POTOMAC",
    "dropmalst": "IL",
    "dropmalzpp": 618659998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2179876677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14522",
    "droptype": "D",
    "dropname": "PRAIRIE CITY",
    "dropdeladd": "325 E MAIN ST",
    "dropdelcty": "PRAIRIE CITY",
    "dropdelst": "IL",
    "dropdelzpp": 614705100,
    "dropphyadd": "325 E MAIN ST",
    "dropphycty": "PRAIRIE CITY",
    "dropphyst": "IL",
    "dropphyzpp": 614705100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAIRIE CITY",
    "dropmalst": "IL",
    "dropmalzpp": 614709998,
    "dropsitphn": 3097754403,
    "dropsitlph": 3097754403,
    "dropsitcph": 3097754403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14523",
    "droptype": "D",
    "dropname": "PRAIRIE DU ROCHER",
    "dropdeladd": "211 HENRY ST",
    "dropdelcty": "PRAIRIE DU ROCHER",
    "dropdelst": "IL",
    "dropdelzpp": 622779998,
    "dropphyadd": "211 HENRY ST",
    "dropphycty": "PRAIRIE DU ROCHER",
    "dropphyst": "IL",
    "dropphyzpp": 622779998,
    "dropmaladd": "211 HENRY ST",
    "dropmalcty": "PRAIRIE DU ROCHER",
    "dropmalst": "IL",
    "dropmalzpp": 622779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182843377,
    "dropsitcph": 6182843377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14531",
    "droptype": "D",
    "dropname": "PREEMPTION",
    "dropdeladd": "1699 US HIGHWAY 67",
    "dropdelcty": "PREEMPTION",
    "dropdelst": "IL",
    "dropdelzpp": 612769000,
    "dropphyadd": "1699 US HIGHWAY 67",
    "dropphycty": "PREEMPTION",
    "dropphyst": "IL",
    "dropphyzpp": 612769000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PREEMPTION",
    "dropmalst": "IL",
    "dropmalzpp": 612769998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095348349,
    "dropsitcph": 3095348349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14533",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "326 S MAIN ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "IL",
    "dropdelzpp": 613569800,
    "dropphyadd": "326 S MAIN ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "IL",
    "dropphyzpp": 613569800,
    "dropmaladd": "326 S MAIN ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "IL",
    "dropmalzpp": 613569800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158793001,
    "dropfax": 8158753047
  },
  {
    "dcode": "D",
    "dropkey": "PW14534",
    "droptype": "D",
    "dropname": "PRINCEVILLE",
    "dropdeladd": "133 E EVANS ST",
    "dropdelcty": "PRINCEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 615597534,
    "dropphyadd": "133 E EVANS ST",
    "dropphycty": "PRINCEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 615597534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRINCEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 615599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093852221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14535",
    "droptype": "D",
    "dropname": "PROPHETSTOWN",
    "dropdeladd": "313 WASHINGTON ST",
    "dropdelcty": "PROPHETSTOWN",
    "dropdelst": "IL",
    "dropdelzpp": 612779998,
    "dropphyadd": "313 WASHINGTON ST",
    "dropphycty": "PROPHETSTOWN",
    "dropphyst": "IL",
    "dropphyzpp": 612779998,
    "dropmaladd": "313 WASHINGTON ST",
    "dropmalcty": "PROPHETSTOWN",
    "dropmalst": "IL",
    "dropmalzpp": 612779998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8155372710,
    "dropsitcph": 8155372710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14538",
    "droptype": "D",
    "dropname": "PROSPECT HEIGHTS",
    "dropdeladd": "9 S ELMHURST RD",
    "dropdelcty": "PROSPECT HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 600702895,
    "dropphyadd": "9 S ELMHURST RD",
    "dropphycty": "PROSPECT HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 600702895,
    "dropmaladd": "9 S ELMHURST RD",
    "dropmalcty": "PROSPECT HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 600702895,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472551771,
    "dropsitcph": 8472551771,
    "dropfax": 8472520556
  },
  {
    "dcode": "D",
    "dropkey": "PW14542",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "225 E COMMERCIAL AVE",
    "dropdelcty": "PULASKI",
    "dropdelst": "IL",
    "dropdelzpp": 629762533,
    "dropphyadd": "225 E COMMERCIAL AVE",
    "dropphycty": "PULASKI",
    "dropphyst": "IL",
    "dropphyzpp": 629762533,
    "dropmaladd": "225 E COMMERCIAL AVE",
    "dropmalcty": "PULASKI",
    "dropmalst": "IL",
    "dropmalzpp": 629762533,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183426416,
    "dropsitcph": 6183426416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14544",
    "droptype": "D",
    "dropname": "PUTNAM",
    "dropdeladd": "107 CENTERS ST",
    "dropdelcty": "PUTNAM",
    "dropdelst": "IL",
    "dropdelzpp": 615609995,
    "dropphyadd": "107 CENTERS ST",
    "dropphycty": "PUTNAM",
    "dropphyst": "IL",
    "dropphyzpp": 615609995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PUTNAM",
    "dropmalst": "IL",
    "dropmalzpp": 615609998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154372415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14549",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "3535 LOCUST ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "IL",
    "dropdelzpp": 623019998,
    "dropphyadd": "3535 LOCUST ST",
    "dropphycty": "QUINCY",
    "dropphyst": "IL",
    "dropphyzpp": 623019998,
    "dropmaladd": "3535 LOCUST ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "IL",
    "dropmalzpp": 623019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172244950,
    "dropsitcph": 2172244950,
    "dropfax": 2172244979
  },
  {
    "dcode": "D",
    "dropkey": "PW14553",
    "droptype": "D",
    "dropname": "RADOM",
    "dropdeladd": "15 S 3RD ST",
    "dropdelcty": "RADOM",
    "dropdelst": "IL",
    "dropdelzpp": 628769998,
    "dropphyadd": "15 S 3RD ST",
    "dropphycty": "RADOM",
    "dropphyst": "IL",
    "dropphyzpp": 628769998,
    "dropmaladd": "15 S 3RD ST",
    "dropmalcty": "RADOM",
    "dropmalst": "IL",
    "dropmalzpp": 628769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184856006,
    "dropsitcph": 6184856006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14554",
    "droptype": "D",
    "dropname": "RALEIGH",
    "dropdeladd": "16 E CHURCH ST",
    "dropdelcty": "RALEIGH",
    "dropdelst": "IL",
    "dropdelzpp": 629779998,
    "dropphyadd": "16 E CHURCH ST",
    "dropphycty": "RALEIGH",
    "dropphyst": "IL",
    "dropphyzpp": 629779998,
    "dropmaladd": "16 E CHURCH ST",
    "dropmalcty": "RALEIGH",
    "dropmalst": "IL",
    "dropmalzpp": 629779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182684532,
    "dropsitcph": 6182684532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14556",
    "droptype": "D",
    "dropname": "RAMSEY",
    "dropdeladd": "320 S SUPERIOR ST",
    "dropdelcty": "RAMSEY",
    "dropdelst": "IL",
    "dropdelzpp": 620809998,
    "dropphyadd": "320 S SUPERIOR ST",
    "dropphycty": "RAMSEY",
    "dropphyst": "IL",
    "dropphyzpp": 620809998,
    "dropmaladd": "320 S SUPERIOR ST",
    "dropmalcty": "RAMSEY",
    "dropmalst": "IL",
    "dropmalzpp": 620809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184232111,
    "dropsitcph": 6184232111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14559",
    "droptype": "D",
    "dropname": "RANKIN",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "RANKIN",
    "dropdelst": "IL",
    "dropdelzpp": 609609998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "RANKIN",
    "dropphyst": "IL",
    "dropphyzpp": 609609998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "RANKIN",
    "dropmalst": "IL",
    "dropmalzpp": 609609998,
    "dropsitphn": 2173793131,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173972440,
    "dropfax": 2173972440
  },
  {
    "dcode": "D",
    "dropkey": "PW14560",
    "droptype": "D",
    "dropname": "RANSOM",
    "dropdeladd": "120 N LINCOLN ST",
    "dropdelcty": "RANSOM",
    "dropdelst": "IL",
    "dropdelzpp": 604708500,
    "dropphyadd": "120 N LINCOLN ST",
    "dropphycty": "RANSOM",
    "dropphyst": "IL",
    "dropphyzpp": 604708500,
    "dropmaladd": "120 N LINCOLN ST",
    "dropmalcty": "RANSOM",
    "dropmalst": "IL",
    "dropmalzpp": 604709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8155864689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14561",
    "droptype": "D",
    "dropname": "RANTOUL",
    "dropdeladd": "401 N MAPLEWOOD DR",
    "dropdelcty": "RANTOUL",
    "dropdelst": "IL",
    "dropdelzpp": 618669998,
    "dropphyadd": "401 N MAPLEWOOD DR",
    "dropphycty": "RANTOUL",
    "dropphyst": "IL",
    "dropphyzpp": 618669998,
    "dropmaladd": "401 N MAPLEWOOD DR",
    "dropmalcty": "RANTOUL",
    "dropmalst": "IL",
    "dropmalzpp": 618669998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178925900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14563",
    "droptype": "D",
    "dropname": "RAPIDS CITY",
    "dropdeladd": "135 13TH ST",
    "dropdelcty": "RAPIDS CITY",
    "dropdelst": "IL",
    "dropdelzpp": 612789000,
    "dropphyadd": "135 13TH ST",
    "dropphycty": "RAPIDS CITY",
    "dropphyst": "IL",
    "dropphyzpp": 612789000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAPIDS CITY",
    "dropmalst": "IL",
    "dropmalzpp": 612789998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3094962593,
    "dropsitcph": 3094962593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14565",
    "droptype": "D",
    "dropname": "RARITAN",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "RARITAN",
    "dropdelst": "IL",
    "dropdelzpp": 614719800,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "RARITAN",
    "dropphyst": "IL",
    "dropphyzpp": 614719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RARITAN",
    "dropmalst": "IL",
    "dropmalzpp": 614719998,
    "dropsitphn": 3097466185,
    "dropsitlph": 3097466185,
    "dropsitcph": 3097466185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14572",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "401 E BROAD ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "IL",
    "dropdelzpp": 625609998,
    "dropphyadd": "401 E BROAD ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "IL",
    "dropphyzpp": 625609998,
    "dropmaladd": "401 E BROAD ST",
    "dropmalcty": "RAYMOND",
    "dropmalst": "IL",
    "dropmalzpp": 625609998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172294432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14575",
    "droptype": "D",
    "dropname": "RED BUD",
    "dropdeladd": "150 S MAIN ST",
    "dropdelcty": "RED BUD",
    "dropdelst": "IL",
    "dropdelzpp": 622789998,
    "dropphyadd": "150 S MAIN ST",
    "dropphycty": "RED BUD",
    "dropphyst": "IL",
    "dropphyzpp": 622789998,
    "dropmaladd": "150 S MAIN ST",
    "dropmalcty": "RED BUD",
    "dropmalst": "IL",
    "dropmalzpp": 622789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182128802,
    "dropsitcph": 6182128802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14578",
    "droptype": "D",
    "dropname": "REDDICK",
    "dropdeladd": "113 W LINCOLN ST",
    "dropdelcty": "REDDICK",
    "dropdelst": "IL",
    "dropdelzpp": 609615606,
    "dropphyadd": "113 W LINCOLN ST",
    "dropphycty": "REDDICK",
    "dropphyst": "IL",
    "dropphyzpp": 609615606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDDICK",
    "dropmalst": "IL",
    "dropmalzpp": 609619998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8153654215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14579",
    "droptype": "D",
    "dropname": "REDMON",
    "dropdeladd": "402 OAK ST",
    "dropdelcty": "REDMON",
    "dropdelst": "IL",
    "dropdelzpp": 619499998,
    "dropphyadd": "402 OAK ST",
    "dropphycty": "REDMON",
    "dropphyst": "IL",
    "dropphyzpp": 619499998,
    "dropmaladd": "402 OAK ST",
    "dropmalcty": "REDMON",
    "dropmalst": "IL",
    "dropmalzpp": 619499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178842241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14584",
    "droptype": "D",
    "dropname": "RENAULT",
    "dropdeladd": "2130 MAIN ST",
    "dropdelcty": "RENAULT",
    "dropdelst": "IL",
    "dropdelzpp": 622799998,
    "dropphyadd": "2130 MAIN ST",
    "dropphycty": "RENAULT",
    "dropphyst": "IL",
    "dropphyzpp": 622799998,
    "dropmaladd": "2130 MAIN ST",
    "dropmalcty": "RENAULT",
    "dropmalst": "IL",
    "dropmalzpp": 622799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184587233,
    "dropsitcph": 6184587233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14591",
    "droptype": "D",
    "dropname": "REYNOLDS",
    "dropdeladd": "217 N MAIN ST",
    "dropdelcty": "REYNOLDS",
    "dropdelst": "IL",
    "dropdelzpp": 612799000,
    "dropphyadd": "217 N MAIN ST",
    "dropphycty": "REYNOLDS",
    "dropphyst": "IL",
    "dropphyzpp": 612799000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REYNOLDS",
    "dropmalst": "IL",
    "dropmalzpp": 612799998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3093728313,
    "dropsitcph": 3093728313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14602",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "5510 MILL ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "IL",
    "dropdelzpp": 600718018,
    "dropphyadd": "5510 MILL ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "IL",
    "dropphyzpp": 600718018,
    "dropmaladd": "5510 MILL ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "IL",
    "dropmalzpp": 600718018,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156783951,
    "dropsitcph": 8156783951,
    "dropfax": 8156784275
  },
  {
    "dcode": "D",
    "dropkey": "PW14603",
    "droptype": "D",
    "dropname": "RICHTON PARK",
    "dropdeladd": "22332 GOVERNORS HWY",
    "dropdelcty": "RICHTON PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604719998,
    "dropphyadd": "22332 GOVERNORS HWY",
    "dropphycty": "RICHTON PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604719998,
    "dropmaladd": "22332 GOVERNORS HWY",
    "dropmalcty": "RICHTON PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087481688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14605",
    "droptype": "D",
    "dropname": "RICHVIEW",
    "dropdeladd": "218 S SHANNON AVE",
    "dropdelcty": "RICHVIEW",
    "dropdelst": "IL",
    "dropdelzpp": 628779997,
    "dropphyadd": "218 S SHANNON AVE",
    "dropphycty": "RICHVIEW",
    "dropphyst": "IL",
    "dropphyzpp": 628779997,
    "dropmaladd": "218 S SHANNON AVE",
    "dropmalcty": "RICHVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 628779997,
    "dropsitphn": 2877999860,
    "dropsitlph": 6182498380,
    "dropsitcph": 6182498380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14607",
    "droptype": "D",
    "dropname": "RIDGE FARM",
    "dropdeladd": "10 W WOODYARD AVE",
    "dropdelcty": "RIDGE FARM",
    "dropdelst": "IL",
    "dropdelzpp": 618709998,
    "dropphyadd": "10 W WOODYARD AVE",
    "dropphycty": "RIDGE FARM",
    "dropphyst": "IL",
    "dropphyzpp": 618709998,
    "dropmaladd": "10 W WOODYARD AVE",
    "dropmalcty": "RIDGE FARM",
    "dropmalst": "IL",
    "dropmalzpp": 618709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172472252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14609",
    "droptype": "D",
    "dropname": "RIDGWAY",
    "dropdeladd": "116 S MURPHY ST",
    "dropdelcty": "RIDGWAY",
    "dropdelst": "IL",
    "dropdelzpp": 629799998,
    "dropphyadd": "116 S MURPHY ST",
    "dropphycty": "RIDGWAY",
    "dropphyst": "IL",
    "dropphyzpp": 629799998,
    "dropmaladd": "116 S MURPHY ST",
    "dropmalcty": "RIDGWAY",
    "dropmalst": "IL",
    "dropmalzpp": 629799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182727212,
    "dropsitcph": 6182727212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14610",
    "droptype": "D",
    "dropname": "RIDOTT",
    "dropdeladd": "103 ADAMS ST",
    "dropdelcty": "RIDOTT",
    "dropdelst": "IL",
    "dropdelzpp": 610679685,
    "dropphyadd": "103 ADAMS ST",
    "dropphycty": "RIDOTT",
    "dropphyst": "IL",
    "dropphyzpp": 610679685,
    "dropmaladd": "103 ADAMS ST",
    "dropmalcty": "RIDOTT",
    "dropmalst": "IL",
    "dropmalzpp": 610679685,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152353201,
    "dropsitcph": 8152353201,
    "dropfax": 8152353201
  },
  {
    "dcode": "D",
    "dropkey": "PW14613",
    "droptype": "D",
    "dropname": "RINARDX",
    "dropdeladd": "12501 E 2175TH AVE",
    "dropdelcty": "RINARD",
    "dropdelst": "IL",
    "dropdelzpp": 628789998,
    "dropphyadd": "12501 E 2175TH AVE",
    "dropphycty": "RINARD",
    "dropphyst": "IL",
    "dropphyzpp": 628789998,
    "dropmaladd": "12501 E 2175TH AVE",
    "dropmalcty": "RINARD",
    "dropmalst": "IL",
    "dropmalzpp": 628789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186732106,
    "dropsitcph": 6186732106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14614",
    "droptype": "D",
    "dropname": "RINGWOOD",
    "dropdeladd": "5016 BARNARD MILL RD",
    "dropdelcty": "RINGWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 600729670,
    "dropphyadd": "5016 BARNARD MILL RD",
    "dropphycty": "RINGWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 600729670,
    "dropmaladd": "5016 BARNARD MILL RD",
    "dropmalcty": "RINGWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 600729670,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156539047,
    "dropsitcph": 8156539047,
    "dropfax": 8156536028
  },
  {
    "dcode": "D",
    "dropkey": "PW14615",
    "droptype": "D",
    "dropname": "RIO",
    "dropdeladd": "110 E CENTER AVE",
    "dropdelcty": "RIO",
    "dropdelst": "IL",
    "dropdelzpp": 614725000,
    "dropphyadd": "110 E CENTER AVE",
    "dropphycty": "RIO",
    "dropphyst": "IL",
    "dropphyzpp": 614725000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIO",
    "dropmalst": "IL",
    "dropmalzpp": 614729998,
    "dropsitphn": 3098723601,
    "dropsitlph": 3098723601,
    "dropsitcph": 3099723601,
    "dropfax": 3099723602
  },
  {
    "dcode": "D",
    "dropkey": "PW14622",
    "droptype": "D",
    "dropname": "RIVER GROVE",
    "dropdeladd": "2728 CLINTON ST",
    "dropdelcty": "RIVER GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 601711565,
    "dropphyadd": "2728 CLINTON ST",
    "dropphycty": "RIVER GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 601711565,
    "dropmaladd": "2728 CLINTON ST",
    "dropmalcty": "RIVER GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 601711565,
    "dropsitphn": 6302605499,
    "dropsitlph": 7084532876,
    "dropsitcph": 7084532876,
    "dropfax": 7084569257
  },
  {
    "dcode": "D",
    "dropkey": "PW14626",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "45 E BURLINGTON ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "IL",
    "dropdelzpp": 605469997,
    "dropphyadd": "45 E BURLINGTON ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "IL",
    "dropphyzpp": 605469997,
    "dropmaladd": "45 E BURLINGTON ST",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "IL",
    "dropmalzpp": 605469997,
    "dropsitphn": 7085637318,
    "dropsitlph": 7084428207,
    "dropsitcph": 7084428207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14627",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "619 N 7TH ST",
    "dropdelcty": "RIVERTON",
    "dropdelst": "IL",
    "dropdelzpp": 625619998,
    "dropphyadd": "619 N 7TH ST",
    "dropphycty": "RIVERTON",
    "dropphyst": "IL",
    "dropphyzpp": 625619998,
    "dropmaladd": "619 N 7TH ST",
    "dropmalcty": "RIVERTON",
    "dropmalst": "IL",
    "dropmalzpp": 625619998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176299842,
    "dropfax": 2176299923
  },
  {
    "dcode": "D",
    "dropkey": "PW14635",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "413 N MAIN ST",
    "dropdelcty": "ROANOKE",
    "dropdelst": "IL",
    "dropdelzpp": 615619900,
    "dropphyadd": "413 N MAIN ST",
    "dropphycty": "ROANOKE",
    "dropphyst": "IL",
    "dropphyzpp": 615619900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROANOKE",
    "dropmalst": "IL",
    "dropmalzpp": 615619998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099237173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14636",
    "droptype": "D",
    "dropname": "ROBBINS",
    "dropdeladd": "3447 W 137TH ST",
    "dropdelcty": "ROBBINS",
    "dropdelst": "IL",
    "dropdelzpp": 604729800,
    "dropphyadd": "3447 W 137TH ST",
    "dropphycty": "ROBBINS",
    "dropphyst": "IL",
    "dropphyzpp": 604729800,
    "dropmaladd": "3447 W 137TH ST",
    "dropmalcty": "ROBBINS",
    "dropmalst": "IL",
    "dropmalzpp": 604729800,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083891166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14639",
    "droptype": "D",
    "dropname": "ROBERTS",
    "dropdeladd": "110 E GREEN ST",
    "dropdelcty": "ROBERTS",
    "dropdelst": "IL",
    "dropdelzpp": 609629800,
    "dropphyadd": "110 E GREEN ST",
    "dropphycty": "ROBERTS",
    "dropphyst": "IL",
    "dropphyzpp": 609629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBERTS",
    "dropmalst": "IL",
    "dropmalzpp": 609629998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173952403,
    "dropfax": 2173952403
  },
  {
    "dcode": "D",
    "dropkey": "PW14640",
    "droptype": "D",
    "dropname": "ROBINSON",
    "dropdeladd": "101 E WALNUT ST",
    "dropdelcty": "ROBINSON",
    "dropdelst": "IL",
    "dropdelzpp": 624549998,
    "dropphyadd": "101 E WALNUT ST",
    "dropphycty": "ROBINSON",
    "dropphyst": "IL",
    "dropphyzpp": 624549998,
    "dropmaladd": "101 E WALNUT ST",
    "dropmalcty": "ROBINSON",
    "dropmalst": "IL",
    "dropmalzpp": 624549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185461131,
    "dropsitcph": 6185461131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14642",
    "droptype": "D",
    "dropname": "ROCHELLE",
    "dropdeladd": "501 LINCOLN HWY",
    "dropdelcty": "ROCHELLE",
    "dropdelst": "IL",
    "dropdelzpp": 610681699,
    "dropphyadd": "501 LINCOLN HWY",
    "dropphycty": "ROCHELLE",
    "dropphyst": "IL",
    "dropphyzpp": 610681699,
    "dropmaladd": "501 LINCOLN HWY",
    "dropmalcty": "ROCHELLE",
    "dropmalst": "IL",
    "dropmalzpp": 610681699,
    "dropsitphn": 6302605499,
    "dropsitlph": 8155624634,
    "dropsitcph": 8155624634,
    "dropfax": 8155627747
  },
  {
    "dcode": "D",
    "dropkey": "PW14643",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "200 S WALNUT ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 625639998,
    "dropphyadd": "200 S WALNUT ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 625639998,
    "dropmaladd": "200 S WALNUT ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 625639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174987212,
    "dropfax": 2174988579
  },
  {
    "dcode": "D",
    "dropkey": "PW14644",
    "droptype": "D",
    "dropname": "ROCK CITY",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "ROCK CITY",
    "dropdelst": "IL",
    "dropdelzpp": 610709998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "ROCK CITY",
    "dropphyst": "IL",
    "dropphyzpp": 610709998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "ROCK CITY",
    "dropmalst": "IL",
    "dropmalzpp": 610709998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158655714,
    "dropsitcph": 8158655714,
    "dropfax": 8158655346
  },
  {
    "dcode": "D",
    "dropkey": "PW14648",
    "droptype": "D",
    "dropname": "ROCK FALLS",
    "dropdeladd": "210 2ND AVE",
    "dropdelcty": "ROCK FALLS",
    "dropdelst": "IL",
    "dropdelzpp": 610711299,
    "dropphyadd": "210 2ND AVE",
    "dropphycty": "ROCK FALLS",
    "dropphyst": "IL",
    "dropphyzpp": 610711299,
    "dropmaladd": "210 2ND AVE",
    "dropmalcty": "ROCK FALLS",
    "dropmalst": "IL",
    "dropmalzpp": 610711299,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156260514,
    "dropsitcph": 8156260514,
    "dropfax": 8156261715
  },
  {
    "dcode": "D",
    "dropkey": "PW14652",
    "droptype": "D",
    "dropname": "ROCK ISLAND",
    "dropdeladd": "2633 11TH ST",
    "dropdelcty": "ROCK ISLAND",
    "dropdelst": "IL",
    "dropdelzpp": 612019998,
    "dropphyadd": "2633 11TH ST",
    "dropphycty": "ROCK ISLAND",
    "dropphyst": "IL",
    "dropphyzpp": 612019998,
    "dropmaladd": "2633 11TH ST",
    "dropmalcty": "ROCK ISLAND",
    "dropmalst": "IL",
    "dropmalzpp": 612019998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097882142,
    "dropsitcph": 3097882142,
    "dropfax": 3097882131
  },
  {
    "dcode": "D",
    "dropkey": "PW14654",
    "droptype": "D",
    "dropname": "ROCKBRIDGE",
    "dropdeladd": "4 OLIVE ST",
    "dropdelcty": "ROCKBRIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 620819998,
    "dropphyadd": "4 OLIVE ST",
    "dropphycty": "ROCKBRIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 620819998,
    "dropmaladd": "4 OLIVE ST",
    "dropmalcty": "ROCKBRIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 620819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187533525,
    "dropsitcph": 6187533525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14662",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "301 MERCHANT ST",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 623709998,
    "dropphyadd": "301 MERCHANT ST",
    "dropphycty": "ROCKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 623709998,
    "dropmaladd": "301 MERCHANT ST",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "IL",
    "dropmalzpp": 623709998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2174375231,
    "dropsitcph": 2174375231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14663",
    "droptype": "D",
    "dropname": "ROCKTON",
    "dropdeladd": "214 W MAIN ST",
    "dropdelcty": "ROCKTON",
    "dropdelst": "IL",
    "dropdelzpp": 610722400,
    "dropphyadd": "214 W MAIN ST",
    "dropphycty": "ROCKTON",
    "dropphyst": "IL",
    "dropphyzpp": 610722400,
    "dropmaladd": "214 W MAIN ST",
    "dropmalcty": "ROCKTON",
    "dropmalst": "IL",
    "dropmalzpp": 610722400,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156246281,
    "dropsitcph": 8156246281,
    "dropfax": 8156244138
  },
  {
    "dcode": "D",
    "dropkey": "PW14665",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "900 ORIGINAL ST",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 622809998,
    "dropphyadd": "900 ORIGINAL ST",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 622809998,
    "dropmaladd": "900 ORIGINAL ST",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 622809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187634367,
    "dropsitcph": 6187634367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14680",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "15715 RIVER BEACH RD",
    "dropdelcty": "ROME",
    "dropdelst": "IL",
    "dropdelzpp": 615629995,
    "dropphyadd": "15715 RIVER BEACH RD",
    "dropphycty": "ROME",
    "dropphyst": "IL",
    "dropphyzpp": 615629995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROME",
    "dropmalst": "IL",
    "dropmalzpp": 615629998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092742773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14685",
    "droptype": "D",
    "dropname": "ROODHOUSE",
    "dropdeladd": "209 S MORSE ST",
    "dropdelcty": "ROODHOUSE",
    "dropdelst": "IL",
    "dropdelzpp": 620829998,
    "dropphyadd": "209 S MORSE ST",
    "dropphycty": "ROODHOUSE",
    "dropphyst": "IL",
    "dropphyzpp": 620829998,
    "dropmaladd": "209 S MORSE ST",
    "dropmalcty": "ROODHOUSE",
    "dropmalst": "IL",
    "dropmalzpp": 620829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175895037,
    "dropsitcph": 2175895037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14687",
    "droptype": "D",
    "dropname": "ROSAMOND",
    "dropdeladd": "201 N ROSAMOND AVE",
    "dropdelcty": "ROSAMOND",
    "dropdelst": "IL",
    "dropdelzpp": 620839998,
    "dropphyadd": "201 N ROSAMOND AVE",
    "dropphycty": "ROSAMOND",
    "dropphyst": "IL",
    "dropphyzpp": 620839998,
    "dropmaladd": "201 N ROSAMOND AVE",
    "dropmalcty": "ROSAMOND",
    "dropmalst": "IL",
    "dropmalzpp": 620839998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175625140,
    "dropsitcph": 2175625140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14688",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "11320 MAIN ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "IL",
    "dropdelzpp": 610736508,
    "dropphyadd": "11320 MAIN ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "IL",
    "dropphyzpp": 610736508,
    "dropmaladd": "11320 MAIN ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "IL",
    "dropmalzpp": 610736508,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156232500,
    "dropsitcph": 8156232500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14701",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "140 N ARBITARY ST",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 614739002,
    "dropphyadd": "140 N ARBITARY ST",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 614739002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 614739998,
    "dropsitphn": 3094262464,
    "dropsitlph": 3094262464,
    "dropsitcph": 3094262464,
    "dropfax": 3094262464
  },
  {
    "dcode": "D",
    "dropkey": "PW14704",
    "droptype": "D",
    "dropname": "ROSICLARE",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "ROSICLARE",
    "dropdelst": "IL",
    "dropdelzpp": 629829998,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "ROSICLARE",
    "dropphyst": "IL",
    "dropphyzpp": 629829998,
    "dropmaladd": "1 POSTAL WAY",
    "dropmalcty": "ROSICLARE",
    "dropmalst": "IL",
    "dropmalzpp": 629829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185183020,
    "dropsitcph": 6185183018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14706",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "106 MAPLE ST",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 609639998,
    "dropphyadd": "106 MAPLE ST",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 609639998,
    "dropmaladd": "106 MAPLE ST",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 609639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2177486864,
    "dropfax": 2177484154
  },
  {
    "dcode": "D",
    "dropkey": "PW14712",
    "droptype": "D",
    "dropname": "ROUND LAKE",
    "dropdeladd": "1940 N MUNICIPAL WAY",
    "dropdelcty": "ROUND LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600734957,
    "dropphyadd": "1940 N MUNICIPAL WAY",
    "dropphycty": "ROUND LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600734957,
    "dropmaladd": "1940 N MUNICIPAL WAY",
    "dropmalcty": "ROUND LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600734957,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477406528,
    "dropsitcph": 8477406528,
    "dropfax": 8472450751
  },
  {
    "dcode": "D",
    "dropkey": "PW14734",
    "droptype": "D",
    "dropname": "ROYAL",
    "dropdeladd": "104 CHESTER ST",
    "dropdelcty": "ROYAL",
    "dropdelst": "IL",
    "dropdelzpp": 618719998,
    "dropphyadd": "104 CHESTER ST",
    "dropphycty": "ROYAL",
    "dropphyst": "IL",
    "dropphyzpp": 618719998,
    "dropmaladd": "104 CHESTER ST",
    "dropmalcty": "ROYAL",
    "dropmalst": "IL",
    "dropmalzpp": 618719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175833113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14738",
    "droptype": "D",
    "dropname": "ROYALTON",
    "dropdeladd": "309 S MAIN ST",
    "dropdelcty": "ROYALTON",
    "dropdelst": "IL",
    "dropdelzpp": 629839998,
    "dropphyadd": "309 S MAIN ST",
    "dropphycty": "ROYALTON",
    "dropphyst": "IL",
    "dropphyzpp": 629839998,
    "dropmaladd": "309 S MAIN ST",
    "dropmalcty": "ROYALTON",
    "dropmalst": "IL",
    "dropmalzpp": 629839998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189842032,
    "dropsitcph": 6189842032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14744",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "101 E WASHINGTON ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626819998,
    "dropphyadd": "101 E WASHINGTON ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626819998,
    "dropmaladd": "101 E WASHINGTON ST",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626819998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2173226717,
    "dropfax": 2173222709
  },
  {
    "dcode": "D",
    "dropkey": "PW14745",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "43410 N KILBOURNE RD",
    "dropdelcty": "RUSSELL",
    "dropdelst": "IL",
    "dropdelzpp": 600751000,
    "dropphyadd": "43410 N KILBOURNE RD",
    "dropphycty": "RUSSELL",
    "dropphyst": "IL",
    "dropphyzpp": 600751000,
    "dropmaladd": "43410 N KILBOURNE RD",
    "dropmalcty": "RUSSELL",
    "dropmalst": "IL",
    "dropmalzpp": 600751000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473950717,
    "dropsitcph": 8473950717,
    "dropfax": 8473953948
  },
  {
    "dcode": "D",
    "dropkey": "PW14748",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "118 SW FRONT ST",
    "dropdelcty": "RUTLAND",
    "dropdelst": "IL",
    "dropdelzpp": 613589703,
    "dropphyadd": "118 SW FRONT ST",
    "dropphycty": "RUTLAND",
    "dropphyst": "IL",
    "dropphyzpp": 613589703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTLAND",
    "dropmalst": "IL",
    "dropmalzpp": 613589998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158635106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14759",
    "droptype": "D",
    "dropname": "SADORUS",
    "dropdeladd": "123 E MARKET ST",
    "dropdelcty": "SADORUS",
    "dropdelst": "IL",
    "dropdelzpp": 618729998,
    "dropphyadd": "123 E MARKET ST",
    "dropphycty": "SADORUS",
    "dropphyst": "IL",
    "dropphyzpp": 618729998,
    "dropmaladd": "123 E MARKET ST",
    "dropmalcty": "SADORUS",
    "dropmalst": "IL",
    "dropmalzpp": 618729998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2175982445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14762",
    "droptype": "D",
    "dropname": "SAINT ANNE",
    "dropdeladd": "201 S CHICAGO AVE",
    "dropdelcty": "SAINT ANNE",
    "dropdelst": "IL",
    "dropdelzpp": 609647224,
    "dropphyadd": "201 S CHICAGO AVE",
    "dropphycty": "SAINT ANNE",
    "dropphyst": "IL",
    "dropphyzpp": 609647224,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT ANNE",
    "dropmalst": "IL",
    "dropmalzpp": 609649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8154278179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14763",
    "droptype": "D",
    "dropname": "SAINT AUGUSTINE",
    "dropdeladd": "34 N MAIN ST",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "IL",
    "dropdelzpp": 614749800,
    "dropphyadd": "34 N MAIN ST",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "IL",
    "dropphyzpp": 614749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "IL",
    "dropmalzpp": 614749998,
    "dropsitphn": 3094653579,
    "dropsitlph": 3094653579,
    "dropsitcph": 3094653579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14764",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "2600 OAK ST",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "IL",
    "dropdelzpp": 601759998,
    "dropphyadd": "2600 OAK ST",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "IL",
    "dropphyzpp": 601759998,
    "dropmaladd": "2600 OAK ST",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "IL",
    "dropmalzpp": 601759998,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305842318,
    "dropsitcph": 6305842318,
    "dropfax": 6305842451
  },
  {
    "dcode": "D",
    "dropkey": "PW14765",
    "droptype": "D",
    "dropname": "SAINT DAVID",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "SAINT DAVID",
    "dropdelst": "IL",
    "dropdelzpp": 615639995,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "SAINT DAVID",
    "dropphyst": "IL",
    "dropphyzpp": 615639995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT DAVID",
    "dropmalst": "IL",
    "dropmalzpp": 615639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096682123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14766",
    "droptype": "D",
    "dropname": "SAINT ELMO",
    "dropdeladd": "112 E 5TH ST",
    "dropdelcty": "SAINT ELMO",
    "dropdelst": "IL",
    "dropdelzpp": 624589998,
    "dropphyadd": "112 E 5TH ST",
    "dropphycty": "SAINT ELMO",
    "dropphyst": "IL",
    "dropphyzpp": 624589998,
    "dropmaladd": "112 E 5TH ST",
    "dropmalcty": "SAINT ELMO",
    "dropmalst": "IL",
    "dropmalzpp": 624589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188295116,
    "dropsitcph": 6188295116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14767",
    "droptype": "D",
    "dropname": "SAINT FRANCISVILLE",
    "dropdeladd": "803 MAIN ST",
    "dropdelcty": "SAINT FRANCISVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 624609998,
    "dropphyadd": "803 MAIN ST",
    "dropphycty": "SAINT FRANCISVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 624609998,
    "dropmaladd": "803 MAIN ST",
    "dropmalcty": "SAINT FRANCISVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 624609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189482651,
    "dropsitcph": 6189482651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14768",
    "droptype": "D",
    "dropname": "SAINT JACOB",
    "dropdeladd": "309 N DOUGLAS ST",
    "dropdelcty": "SAINT JACOB",
    "dropdelst": "IL",
    "dropdelzpp": 622819998,
    "dropphyadd": "309 N DOUGLAS ST",
    "dropphycty": "SAINT JACOB",
    "dropphyst": "IL",
    "dropphyzpp": 622819998,
    "dropmaladd": "309 N DOUGLAS ST",
    "dropmalcty": "SAINT JACOB",
    "dropmalst": "IL",
    "dropmalzpp": 622819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186445603,
    "dropsitcph": 6186445603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14770",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "IL",
    "dropdelzpp": 618739998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "IL",
    "dropphyzpp": 618739998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "IL",
    "dropmalzpp": 618739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174697611,
    "dropfax": 2174697611
  },
  {
    "dcode": "D",
    "dropkey": "PW14771",
    "droptype": "D",
    "dropname": "SAINT LIBORY",
    "dropdeladd": "7340 STATE ROUTE 15",
    "dropdelcty": "SAINT LIBORY",
    "dropdelst": "IL",
    "dropdelzpp": 622829998,
    "dropphyadd": "7340 STATE ROUTE 15",
    "dropphycty": "SAINT LIBORY",
    "dropphyst": "IL",
    "dropphyzpp": 622829998,
    "dropmaladd": "7340 STATE ROUTE 15",
    "dropmalcty": "SAINT LIBORY",
    "dropmalst": "IL",
    "dropmalzpp": 622829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187684972,
    "dropsitcph": 6187684972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14774",
    "droptype": "D",
    "dropname": "SAINT PETER",
    "dropdeladd": "109 E 3RD ST",
    "dropdelcty": "SAINT PETER",
    "dropdelst": "IL",
    "dropdelzpp": 628809998,
    "dropphyadd": "109 E 3RD ST",
    "dropphycty": "SAINT PETER",
    "dropphyst": "IL",
    "dropphyzpp": 628809998,
    "dropmaladd": "109 E 3RD ST",
    "dropmalcty": "SAINT PETER",
    "dropmalst": "IL",
    "dropmalzpp": 628809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183496366,
    "dropsitcph": 6183496366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14777",
    "droptype": "D",
    "dropname": "SAINTE MARIE",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "SAINTE MARIE",
    "dropdelst": "IL",
    "dropdelzpp": 624599998,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "SAINTE MARIE",
    "dropphyst": "IL",
    "dropphyzpp": 624599998,
    "dropmaladd": "104 N MAIN ST",
    "dropmalcty": "SAINTE MARIE",
    "dropmalst": "IL",
    "dropmalzpp": 624599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184553521,
    "dropsitcph": 6184553521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14778",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "125 S DELMAR AVE",
    "dropdelcty": "SALEM",
    "dropdelst": "IL",
    "dropdelzpp": 628819997,
    "dropphyadd": "125 S DELMAR AVE",
    "dropphycty": "SALEM",
    "dropphyst": "IL",
    "dropphyzpp": 628819997,
    "dropmaladd": "125 S DELMAR AVE",
    "dropmalcty": "SALEM",
    "dropmalst": "IL",
    "dropmalzpp": 628819997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185480503,
    "dropsitcph": 6185480503,
    "dropfax": 6519943592
  },
  {
    "dcode": "D",
    "dropkey": "PW14782",
    "droptype": "D",
    "dropname": "SAN JOSE",
    "dropdeladd": "207 W VINE ST",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "IL",
    "dropdelzpp": 626829998,
    "dropphyadd": "207 W VINE ST",
    "dropphycty": "SAN JOSE",
    "dropphyst": "IL",
    "dropphyzpp": 626829998,
    "dropmaladd": "207 W VINE ST",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "IL",
    "dropmalzpp": 626829998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 3092473211,
    "dropfax": 3144363601
  },
  {
    "dcode": "D",
    "dropkey": "PW14785",
    "droptype": "D",
    "dropname": "SANDOVAL",
    "dropdeladd": "308 N MAIN ST",
    "dropdelcty": "SANDOVAL",
    "dropdelst": "IL",
    "dropdelzpp": 628829998,
    "dropphyadd": "308 N MAIN ST",
    "dropphycty": "SANDOVAL",
    "dropphyst": "IL",
    "dropphyzpp": 628829998,
    "dropmaladd": "308 N MAIN ST",
    "dropmalcty": "SANDOVAL",
    "dropmalst": "IL",
    "dropmalzpp": 628829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182473895,
    "dropsitcph": 6182473895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14786",
    "droptype": "D",
    "dropname": "SANDWICH",
    "dropdeladd": "22 N EDDY ST",
    "dropdelcty": "SANDWICH",
    "dropdelst": "IL",
    "dropdelzpp": 605489998,
    "dropphyadd": "22 N EDDY ST",
    "dropphycty": "SANDWICH",
    "dropphyst": "IL",
    "dropphyzpp": 605489998,
    "dropmaladd": "22 N EDDY ST",
    "dropmalcty": "SANDWICH",
    "dropmalst": "IL",
    "dropmalzpp": 605489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 8157866716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14793",
    "droptype": "D",
    "dropname": "SAUNEMIN",
    "dropdeladd": "76 NORTH ST",
    "dropdelcty": "SAUNEMIN",
    "dropdelst": "IL",
    "dropdelzpp": 617699900,
    "dropphyadd": "76 NORTH ST",
    "dropphycty": "SAUNEMIN",
    "dropphyst": "IL",
    "dropphyzpp": 617699900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAUNEMIN",
    "dropmalst": "IL",
    "dropmalzpp": 617699998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158324903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14794",
    "droptype": "D",
    "dropname": "SAVANNA",
    "dropdeladd": "321 3RD ST",
    "dropdelcty": "SAVANNA",
    "dropdelst": "IL",
    "dropdelzpp": 610749998,
    "dropphyadd": "321 3RD ST",
    "dropphycty": "SAVANNA",
    "dropphyst": "IL",
    "dropphyzpp": 610749998,
    "dropmaladd": "321 3RD ST",
    "dropmalcty": "SAVANNA",
    "dropmalst": "IL",
    "dropmalzpp": 610749998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152733621,
    "dropsitcph": 8152733621,
    "dropfax": 8152734780
  },
  {
    "dcode": "D",
    "dropkey": "PW14796",
    "droptype": "D",
    "dropname": "SAVOY",
    "dropdeladd": "415 N DUNLAP AVE",
    "dropdelcty": "SAVOY",
    "dropdelst": "IL",
    "dropdelzpp": 618749998,
    "dropphyadd": "415 N DUNLAP AVE",
    "dropphycty": "SAVOY",
    "dropphyst": "IL",
    "dropphyzpp": 618749998,
    "dropmaladd": "415 N DUNLAP AVE",
    "dropmalcty": "SAVOY",
    "dropmalst": "IL",
    "dropmalzpp": 618749998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173558298,
    "dropfax": 2174031505
  },
  {
    "dcode": "D",
    "dropkey": "PW14797",
    "droptype": "D",
    "dropname": "SAWYERVILLE",
    "dropdeladd": "200 MINE RD",
    "dropdelcty": "SAWYERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620859998,
    "dropphyadd": "200 MINE RD",
    "dropphycty": "SAWYERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620859998,
    "dropmaladd": "200 MINE RD",
    "dropmalcty": "SAWYERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178352622,
    "dropsitcph": 2178352622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14799",
    "droptype": "D",
    "dropname": "SAYBROOK",
    "dropdeladd": "209 W LINCOLN ST",
    "dropdelcty": "SAYBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 617709900,
    "dropphyadd": "209 W LINCOLN ST",
    "dropphycty": "SAYBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 617709900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAYBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 617709998,
    "dropsitphn": 3094756231,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094756231,
    "dropfax": 3094756231
  },
  {
    "dcode": "D",
    "dropkey": "PW14801",
    "droptype": "D",
    "dropname": "SCALES MOUND",
    "dropdeladd": "310 SOUTH AVE",
    "dropdelcty": "SCALES MOUND",
    "dropdelst": "IL",
    "dropdelzpp": 610759599,
    "dropphyadd": "310 SOUTH AVE",
    "dropphycty": "SCALES MOUND",
    "dropphyst": "IL",
    "dropphyzpp": 610759599,
    "dropmaladd": "310 SOUTH AVE",
    "dropmalcty": "SCALES MOUND",
    "dropmalst": "IL",
    "dropmalzpp": 610759599,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158452245,
    "dropsitcph": 8158452245,
    "dropfax": 8158459004
  },
  {
    "dcode": "D",
    "dropkey": "PW14806",
    "droptype": "D",
    "dropname": "SCHAUMBURG",
    "dropdeladd": "450 W SCHAUMBURG RD",
    "dropdelcty": "SCHAUMBURG",
    "dropdelst": "IL",
    "dropdelzpp": 601949998,
    "dropphyadd": "450 W SCHAUMBURG RD",
    "dropphycty": "SCHAUMBURG",
    "dropphyst": "IL",
    "dropphyzpp": 601949998,
    "dropmaladd": "450 W SCHAUMBURG RD",
    "dropmalcty": "SCHAUMBURG",
    "dropmalst": "IL",
    "dropmalzpp": 601949998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478856501,
    "dropsitcph": 8478856501,
    "dropfax": 8478851570
  },
  {
    "dcode": "D",
    "dropkey": "PW14807",
    "droptype": "D",
    "dropname": "SCHELLER",
    "dropdeladd": "4411 N SCHELLER LN",
    "dropdelcty": "SCHELLER",
    "dropdelst": "IL",
    "dropdelzpp": 628839997,
    "dropphyadd": "4411 N SCHELLER LN",
    "dropphycty": "SCHELLER",
    "dropphyst": "IL",
    "dropphyzpp": 628839997,
    "dropmaladd": "4411 N SCHELLER LN",
    "dropmalcty": "SCHELLER",
    "dropmalst": "IL",
    "dropmalzpp": 628839997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182797700,
    "dropsitcph": 6182797700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14826",
    "droptype": "D",
    "dropname": "SEATON",
    "dropdeladd": "312 3RD ST",
    "dropdelcty": "SEATON",
    "dropdelst": "IL",
    "dropdelzpp": 614769996,
    "dropphyadd": "312 3RD ST",
    "dropphycty": "SEATON",
    "dropphyst": "IL",
    "dropphyzpp": 614769996,
    "dropmaladd": "312 3RD ST",
    "dropmalcty": "SEATON",
    "dropmalst": "IL",
    "dropmalzpp": 614769996,
    "dropsitphn": 3095864611,
    "dropsitlph": 3095864611,
    "dropsitcph": 3095864611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14827",
    "droptype": "D",
    "dropname": "SEATONVILLE",
    "dropdeladd": "114 ROUTE 6",
    "dropdelcty": "SEATONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 613599700,
    "dropphyadd": "114 ROUTE 6",
    "dropphycty": "SEATONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 613599700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEATONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 613599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158943084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14828",
    "droptype": "D",
    "dropname": "SECOR",
    "dropdeladd": "103 W GILMAN ST",
    "dropdelcty": "SECOR",
    "dropdelst": "IL",
    "dropdelzpp": 617719900,
    "dropphyadd": "103 W GILMAN ST",
    "dropphycty": "SECOR",
    "dropphyst": "IL",
    "dropphyzpp": 617719900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SECOR",
    "dropmalst": "IL",
    "dropmalzpp": 617719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097442400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14831",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "121 E ARMOUR ST",
    "dropdelcty": "SENECA",
    "dropdelst": "IL",
    "dropdelzpp": 613609700,
    "dropphyadd": "121 E ARMOUR ST",
    "dropphycty": "SENECA",
    "dropphyst": "IL",
    "dropphyzpp": 613609700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECA",
    "dropmalst": "IL",
    "dropmalzpp": 613609998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153578393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14833",
    "droptype": "D",
    "dropname": "SERENA",
    "dropdeladd": "3809 E 2276TH RD",
    "dropdelcty": "SERENA",
    "dropdelst": "IL",
    "dropdelzpp": 605499800,
    "dropphyadd": "3809 E 2276TH RD",
    "dropphycty": "SERENA",
    "dropphyst": "IL",
    "dropphyzpp": 605499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SERENA",
    "dropmalst": "IL",
    "dropmalzpp": 605499998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154962837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14834",
    "droptype": "D",
    "dropname": "SESSER",
    "dropdeladd": "207 W FRANKLIN ST",
    "dropdelcty": "SESSER",
    "dropdelst": "IL",
    "dropdelzpp": 628849998,
    "dropphyadd": "207 W FRANKLIN ST",
    "dropphycty": "SESSER",
    "dropphyst": "IL",
    "dropphyzpp": 628849998,
    "dropmaladd": "207 W FRANKLIN ST",
    "dropmalcty": "SESSER",
    "dropmalst": "IL",
    "dropmalzpp": 628849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186252911,
    "dropsitcph": 6186252911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14836",
    "droptype": "D",
    "dropname": "SEWARD",
    "dropdeladd": "2970 TRACY ST",
    "dropdelcty": "SEWARD",
    "dropdelst": "IL",
    "dropdelzpp": 610779802,
    "dropphyadd": "2970 TRACY ST",
    "dropphycty": "SEWARD",
    "dropphyst": "IL",
    "dropphyzpp": 610779802,
    "dropmaladd": "2970 TRACY ST",
    "dropmalcty": "SEWARD",
    "dropmalst": "IL",
    "dropmalzpp": 610779802,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152478777,
    "dropsitcph": 8152478777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14837",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "110 N MAIN ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "IL",
    "dropdelzpp": 618759998,
    "dropphyadd": "110 N MAIN ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "IL",
    "dropphyzpp": 618759998,
    "dropmaladd": "110 N MAIN ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "IL",
    "dropmalzpp": 618759998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176872823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14838",
    "droptype": "D",
    "dropname": "SHABBONA",
    "dropdeladd": "206C W COMANCHE AVE",
    "dropdelcty": "SHABBONA",
    "dropdelst": "IL",
    "dropdelzpp": 605509998,
    "dropphyadd": "206C W COMANCHE AVE",
    "dropphycty": "SHABBONA",
    "dropphyst": "IL",
    "dropphyzpp": 605509998,
    "dropmaladd": "206C W COMANCHE AVE",
    "dropmalcty": "SHABBONA",
    "dropmalst": "IL",
    "dropmalzpp": 605509998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158242224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14844",
    "droptype": "D",
    "dropname": "SHANNON",
    "dropdeladd": "2 N LOCUST ST",
    "dropdelcty": "SHANNON",
    "dropdelst": "IL",
    "dropdelzpp": 610789012,
    "dropphyadd": "2 N LOCUST ST",
    "dropphycty": "SHANNON",
    "dropphyst": "IL",
    "dropphyzpp": 610789012,
    "dropmaladd": "2 N LOCUST ST",
    "dropmalcty": "SHANNON",
    "dropmalst": "IL",
    "dropmalzpp": 610789012,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158642747,
    "dropsitcph": 8158642747,
    "dropfax": 8158642837
  },
  {
    "dcode": "D",
    "dropkey": "PW14849",
    "droptype": "D",
    "dropname": "SHAWNEETOWN",
    "dropdeladd": "200 N LINCOLN BLVD E",
    "dropdelcty": "SHAWNEETOWN",
    "dropdelst": "IL",
    "dropdelzpp": 629849998,
    "dropphyadd": "200 N LINCOLN BLVD E",
    "dropphycty": "SHAWNEETOWN",
    "dropphyst": "IL",
    "dropphyzpp": 629849998,
    "dropmaladd": "200 N LINCOLN BLVD E",
    "dropmalcty": "SHAWNEETOWN",
    "dropmalst": "IL",
    "dropmalzpp": 629849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182693772,
    "dropsitcph": 6182693772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14851",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 613619016,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 613619016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 613619998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154542547,
    "dropfax": 8154542547
  },
  {
    "dcode": "D",
    "dropkey": "PW14852",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "200 S MORGAN ST",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 625659998,
    "dropphyadd": "200 S MORGAN ST",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 625659998,
    "dropmaladd": "200 S MORGAN ST",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 625659998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177743212,
    "dropfax": 2177745096
  },
  {
    "dcode": "D",
    "dropkey": "PW14853",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "110 W DEPOT ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "IL",
    "dropdelzpp": 609669800,
    "dropphyadd": "110 W DEPOT ST",
    "dropphycty": "SHELDON",
    "dropphyst": "IL",
    "dropphyzpp": 609669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELDON",
    "dropmalst": "IL",
    "dropmalzpp": 609669998,
    "dropsitphn": 8154293841,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154293841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14855",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "180 W SI JOHNSON AVE",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "IL",
    "dropdelzpp": 605519998,
    "dropphyadd": "180 W SI JOHNSON AVE",
    "dropphycty": "SHERIDAN",
    "dropphyst": "IL",
    "dropphyzpp": 605519998,
    "dropmaladd": "180 W SI JOHNSON AVE",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "IL",
    "dropmalzpp": 605519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154962077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14856",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "2605 E ANDREW RD",
    "dropdelcty": "SHERMAN",
    "dropdelst": "IL",
    "dropdelzpp": 626849998,
    "dropphyadd": "2605 E ANDREW RD",
    "dropphycty": "SHERMAN",
    "dropphyst": "IL",
    "dropphyzpp": 626849998,
    "dropmaladd": "2605 E ANDREW RD",
    "dropmalcty": "SHERMAN",
    "dropmalst": "IL",
    "dropmalzpp": 626849998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174962032,
    "dropfax": 2174963272
  },
  {
    "dcode": "D",
    "dropkey": "PW14857",
    "droptype": "D",
    "dropname": "SHERRARD",
    "dropdeladd": "402 3RD ST",
    "dropdelcty": "SHERRARD",
    "dropdelst": "IL",
    "dropdelzpp": 612817705,
    "dropphyadd": "402 3RD ST",
    "dropphycty": "SHERRARD",
    "dropphyst": "IL",
    "dropphyzpp": 612817705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERRARD",
    "dropmalst": "IL",
    "dropmalzpp": 612819998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3095932515,
    "dropsitcph": 3095932515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14861",
    "droptype": "D",
    "dropname": "SHIPMAN",
    "dropdeladd": "123 KEATING ST",
    "dropdelcty": "SHIPMAN",
    "dropdelst": "IL",
    "dropdelzpp": 626859998,
    "dropphyadd": "123 KEATING ST",
    "dropphycty": "SHIPMAN",
    "dropphyst": "IL",
    "dropphyzpp": 626859998,
    "dropmaladd": "123 KEATING ST",
    "dropmalcty": "SHIPMAN",
    "dropmalst": "IL",
    "dropmalzpp": 626859998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 6188365551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14862",
    "droptype": "D",
    "dropname": "SHIRLAND",
    "dropdeladd": "13047 PUTNAM ST",
    "dropdelcty": "SHIRLAND",
    "dropdelst": "IL",
    "dropdelzpp": 610799801,
    "dropphyadd": "13047 PUTNAM ST",
    "dropphycty": "SHIRLAND",
    "dropphyst": "IL",
    "dropphyzpp": 610799801,
    "dropmaladd": "13047 PUTNAM ST",
    "dropmalcty": "SHIRLAND",
    "dropmalst": "IL",
    "dropmalzpp": 610799801,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156292081,
    "dropsitcph": 8156292081,
    "dropfax": 8156292826
  },
  {
    "dcode": "D",
    "dropkey": "PW14863",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "100 FOSTER ST",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "IL",
    "dropdelzpp": 617729900,
    "dropphyadd": "100 FOSTER ST",
    "dropphycty": "SHIRLEY",
    "dropphyst": "IL",
    "dropphyzpp": 617729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "IL",
    "dropmalzpp": 617729998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3098284924,
    "dropfax": 3098284924
  },
  {
    "dcode": "D",
    "dropkey": "PW14864",
    "droptype": "D",
    "dropname": "SHOBONIER",
    "dropdeladd": "9998 BLACKMAN ADDITION",
    "dropdelcty": "SHOBONIER",
    "dropdelst": "IL",
    "dropdelzpp": 628859998,
    "dropphyadd": "9998 BLACKMAN ADDITION",
    "dropphycty": "SHOBONIER",
    "dropphyst": "IL",
    "dropphyzpp": 628859998,
    "dropmaladd": "9998 BLACKMAN ADDITION",
    "dropmalcty": "SHOBONIER",
    "dropmalst": "IL",
    "dropmalzpp": 628859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188463651,
    "dropsitcph": 6188463651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14870",
    "droptype": "D",
    "dropname": "SHUMWAY",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "SHUMWAY",
    "dropdelst": "IL",
    "dropdelzpp": 624619998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "SHUMWAY",
    "dropphyst": "IL",
    "dropphyzpp": 624619998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "SHUMWAY",
    "dropmalst": "IL",
    "dropmalzpp": 624619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178685527,
    "dropsitcph": 2178685527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14871",
    "droptype": "D",
    "dropname": "SIBLEY",
    "dropdeladd": "115 S SCIOTA ST",
    "dropdelcty": "SIBLEY",
    "dropdelst": "IL",
    "dropdelzpp": 617739900,
    "dropphyadd": "115 S SCIOTA ST",
    "dropphycty": "SIBLEY",
    "dropphyst": "IL",
    "dropphyzpp": 617739900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIBLEY",
    "dropmalst": "IL",
    "dropmalzpp": 617739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2177452575,
    "dropfax": 2177452575
  },
  {
    "dcode": "D",
    "dropkey": "PW14873",
    "droptype": "D",
    "dropname": "SIDELL",
    "dropdeladd": "201 E MARKET ST",
    "dropdelcty": "SIDELL",
    "dropdelst": "IL",
    "dropdelzpp": 618769998,
    "dropphyadd": "201 E MARKET ST",
    "dropphycty": "SIDELL",
    "dropphyst": "IL",
    "dropphyzpp": 618769998,
    "dropmaladd": "201 E MARKET ST",
    "dropmalcty": "SIDELL",
    "dropmalst": "IL",
    "dropmalzpp": 618769998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172889423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14874",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "222 S DAVID ST",
    "dropdelcty": "SIDNEY",
    "dropdelst": "IL",
    "dropdelzpp": 618779998,
    "dropphyadd": "222 S DAVID ST",
    "dropphycty": "SIDNEY",
    "dropphyst": "IL",
    "dropphyzpp": 618779998,
    "dropmaladd": "222 S DAVID ST",
    "dropmalcty": "SIDNEY",
    "dropmalst": "IL",
    "dropmalzpp": 618779998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176882511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14875",
    "droptype": "D",
    "dropname": "SIGEL",
    "dropdeladd": "102 E LOUIS ST",
    "dropdelcty": "SIGEL",
    "dropdelst": "IL",
    "dropdelzpp": 624629998,
    "dropphyadd": "102 E LOUIS ST",
    "dropphycty": "SIGEL",
    "dropphyst": "IL",
    "dropphyzpp": 624629998,
    "dropmaladd": "102 E LOUIS ST",
    "dropmalcty": "SIGEL",
    "dropmalst": "IL",
    "dropmalzpp": 624629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178442158,
    "dropsitcph": 2178442158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14878",
    "droptype": "D",
    "dropname": "SILVIS",
    "dropdeladd": "1001 1ST AVE",
    "dropdelcty": "SILVIS",
    "dropdelst": "IL",
    "dropdelzpp": 612829998,
    "dropphyadd": "1001 1ST AVE",
    "dropphycty": "SILVIS",
    "dropphyst": "IL",
    "dropphyzpp": 612829998,
    "dropmaladd": "1001 1ST AVE",
    "dropmalcty": "SILVIS",
    "dropmalst": "IL",
    "dropmalzpp": 612829998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097920343,
    "dropsitcph": 3097920343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14879",
    "droptype": "D",
    "dropname": "SIMPSON",
    "dropdeladd": "329 MAIN ST",
    "dropdelcty": "SIMPSON",
    "dropdelst": "IL",
    "dropdelzpp": 629859998,
    "dropphyadd": "329 MAIN ST",
    "dropphycty": "SIMPSON",
    "dropphyst": "IL",
    "dropphyzpp": 629859998,
    "dropmaladd": "329 MAIN ST",
    "dropmalcty": "SIMPSON",
    "dropmalst": "IL",
    "dropmalzpp": 629859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186953341,
    "dropsitcph": 6186953341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14880",
    "droptype": "D",
    "dropname": "SIMS",
    "dropdeladd": "601A S RAILROAD ST",
    "dropdelcty": "SIMS",
    "dropdelst": "IL",
    "dropdelzpp": 628869998,
    "dropphyadd": "601A S RAILROAD ST",
    "dropphycty": "SIMS",
    "dropphyst": "IL",
    "dropphyzpp": 628869998,
    "dropmaladd": "601A S RAILROAD ST",
    "dropmalcty": "SIMS",
    "dropmalst": "IL",
    "dropmalzpp": 628869998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188952952,
    "dropsitcph": 6188952952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14888",
    "droptype": "D",
    "dropname": "SKOKIE",
    "dropdeladd": "4950 MADISON ST",
    "dropdelcty": "SKOKIE",
    "dropdelst": "IL",
    "dropdelzpp": 600772570,
    "dropphyadd": "4950 MADISON ST",
    "dropphycty": "SKOKIE",
    "dropphyst": "IL",
    "dropphyzpp": 600772570,
    "dropmaladd": "4950 MADISON ST",
    "dropmalcty": "SKOKIE",
    "dropmalst": "IL",
    "dropmalzpp": 600772570,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476762232,
    "dropsitcph": 8476762232,
    "dropfax": 8476762873
  },
  {
    "dcode": "D",
    "dropkey": "PW14891",
    "droptype": "D",
    "dropname": "SMITHBORO",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "SMITHBORO",
    "dropdelst": "IL",
    "dropdelzpp": 622849998,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "SMITHBORO",
    "dropphyst": "IL",
    "dropphyzpp": 622849998,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "SMITHBORO",
    "dropmalst": "IL",
    "dropmalzpp": 622849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186642095,
    "dropsitcph": 6186642095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14893",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "148 S MAIN ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 614779679,
    "dropphyadd": "148 S MAIN ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 614779679,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 614779998,
    "dropsitphn": 3097833401,
    "dropsitlph": 3097833401,
    "dropsitcph": 3097833401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14894",
    "droptype": "D",
    "dropname": "SMITHSHIRE",
    "dropdeladd": "124 E STATE ST",
    "dropdelcty": "SMITHSHIRE",
    "dropdelst": "IL",
    "dropdelzpp": 614789410,
    "dropphyadd": "124 E STATE ST",
    "dropphycty": "SMITHSHIRE",
    "dropphyst": "IL",
    "dropphyzpp": 614789410,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHSHIRE",
    "dropmalst": "IL",
    "dropmalzpp": 614789998,
    "dropsitphn": 3093257128,
    "dropsitlph": 3093257128,
    "dropsitcph": 3093257128,
    "dropfax": 3093257128
  },
  {
    "dcode": "D",
    "dropkey": "PW14896",
    "droptype": "D",
    "dropname": "SMITHTON",
    "dropdeladd": "512 S MAIN ST",
    "dropdelcty": "SMITHTON",
    "dropdelst": "IL",
    "dropdelzpp": 622859998,
    "dropphyadd": "512 S MAIN ST",
    "dropphycty": "SMITHTON",
    "dropphyst": "IL",
    "dropphyzpp": 622859998,
    "dropmaladd": "512 S MAIN ST",
    "dropmalcty": "SMITHTON",
    "dropmalst": "IL",
    "dropmalzpp": 622859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182348680,
    "dropsitcph": 6182348680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14914",
    "droptype": "D",
    "dropname": "SOMONAUK",
    "dropdeladd": "115 N GAGE ST",
    "dropdelcty": "SOMONAUK",
    "dropdelst": "IL",
    "dropdelzpp": 605529998,
    "dropphyadd": "115 N GAGE ST",
    "dropphycty": "SOMONAUK",
    "dropphyst": "IL",
    "dropphyzpp": 605529998,
    "dropmaladd": "115 N GAGE ST",
    "dropmalcty": "SOMONAUK",
    "dropmalst": "IL",
    "dropmalzpp": 605529998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154982724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14916",
    "droptype": "D",
    "dropname": "SORENTO",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "SORENTO",
    "dropdelst": "IL",
    "dropdelzpp": 620869998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "SORENTO",
    "dropphyst": "IL",
    "dropphyzpp": 620869998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "SORENTO",
    "dropmalst": "IL",
    "dropmalzpp": 620869998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172724212,
    "dropsitcph": 2172724212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14918",
    "droptype": "D",
    "dropname": "SOUTH BELOIT",
    "dropdeladd": "311 OAK GROVE AVE",
    "dropdelcty": "SOUTH BELOIT",
    "dropdelst": "IL",
    "dropdelzpp": 610801968,
    "dropphyadd": "311 OAK GROVE AVE",
    "dropphycty": "SOUTH BELOIT",
    "dropphyst": "IL",
    "dropphyzpp": 610801968,
    "dropmaladd": "311 OAK GROVE AVE",
    "dropmalcty": "SOUTH BELOIT",
    "dropmalst": "IL",
    "dropmalzpp": 610801968,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153891367,
    "dropsitcph": 8153891367,
    "dropfax": 8153891617
  },
  {
    "dcode": "D",
    "dropkey": "PW14925",
    "droptype": "D",
    "dropname": "SOUTH ELGIN",
    "dropdeladd": "310 N LA FOX ST STE 5",
    "dropdelcty": "SOUTH ELGIN",
    "dropdelst": "IL",
    "dropdelzpp": 601779998,
    "dropphyadd": "310 N LA FOX ST STE 5",
    "dropphycty": "SOUTH ELGIN",
    "dropphyst": "IL",
    "dropphyzpp": 601779998,
    "dropmaladd": "310 N LA FOX ST STE 5",
    "dropmalcty": "SOUTH ELGIN",
    "dropmalst": "IL",
    "dropmalzpp": 601779998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477425325,
    "dropsitcph": 8476957119,
    "dropfax": 8477425380
  },
  {
    "dcode": "D",
    "dropkey": "PW14927",
    "droptype": "D",
    "dropname": "SOUTH HOLLAND",
    "dropdeladd": "16260 LOUIS AVE",
    "dropdelcty": "SOUTH HOLLAND",
    "dropdelst": "IL",
    "dropdelzpp": 604739998,
    "dropphyadd": "16260 LOUIS AVE",
    "dropphycty": "SOUTH HOLLAND",
    "dropphyst": "IL",
    "dropphyzpp": 604739998,
    "dropmaladd": "16260 LOUIS AVE",
    "dropmalcty": "SOUTH HOLLAND",
    "dropmalst": "IL",
    "dropmalzpp": 604739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7083310302,
    "dropfax": 7083318043
  },
  {
    "dcode": "D",
    "dropkey": "PW14930",
    "droptype": "D",
    "dropname": "SOUTH PEKIN",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "SOUTH PEKIN",
    "dropdelst": "IL",
    "dropdelzpp": 615649800,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "SOUTH PEKIN",
    "dropphyst": "IL",
    "dropphyzpp": 615649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH PEKIN",
    "dropmalst": "IL",
    "dropmalzpp": 615649998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093483090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14932",
    "droptype": "D",
    "dropname": "SOUTH ROXANA",
    "dropdeladd": "215 SINCLAIR AVE",
    "dropdelcty": "SOUTH ROXANA",
    "dropdelst": "IL",
    "dropdelzpp": 620879998,
    "dropphyadd": "215 SINCLAIR AVE",
    "dropphycty": "SOUTH ROXANA",
    "dropphyst": "IL",
    "dropphyzpp": 620879998,
    "dropmaladd": "215 SINCLAIR AVE",
    "dropmalcty": "SOUTH ROXANA",
    "dropmalst": "IL",
    "dropmalzpp": 620879998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182543692,
    "dropsitcph": 6182543692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14940",
    "droptype": "D",
    "dropname": "SOUTH WILMINGTON",
    "dropdeladd": "280 3RD AVE",
    "dropdelcty": "SOUTH WILMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 604749800,
    "dropphyadd": "280 3RD AVE",
    "dropphycty": "SOUTH WILMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 604749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH WILMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 604749998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152372646,
    "dropfax": 8152372646
  },
  {
    "dcode": "D",
    "dropkey": "PW14946",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "208 W BROADWAY ST",
    "dropdelcty": "SPARTA",
    "dropdelst": "IL",
    "dropdelzpp": 622869998,
    "dropphyadd": "208 W BROADWAY ST",
    "dropphycty": "SPARTA",
    "dropphyst": "IL",
    "dropphyzpp": 622869998,
    "dropmaladd": "208 W BROADWAY ST",
    "dropmalcty": "SPARTA",
    "dropmalst": "IL",
    "dropmalzpp": 622869998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184432213,
    "dropsitcph": 6184432213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14948",
    "droptype": "D",
    "dropname": "SPEER",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "SPEER",
    "dropdelst": "IL",
    "dropdelzpp": 614799800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "SPEER",
    "dropphyst": "IL",
    "dropphyzpp": 614799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPEER",
    "dropmalst": "IL",
    "dropmalzpp": 614799998,
    "dropsitphn": 3092496271,
    "dropsitlph": 3092496271,
    "dropsitcph": 3092496271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14958",
    "droptype": "D",
    "dropname": "SPRING GROVE",
    "dropdeladd": "2410 WESTWARD DR",
    "dropdelcty": "SPRING GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 600818855,
    "dropphyadd": "2410 WESTWARD DR",
    "dropphycty": "SPRING GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 600818855,
    "dropmaladd": "2410 WESTWARD DR",
    "dropmalcty": "SPRING GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 600818855,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156752161,
    "dropsitcph": 8156752161,
    "dropfax": 8156751022
  },
  {
    "dcode": "D",
    "dropkey": "PW14962",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "100 E ERIE ST",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 613629800,
    "dropphyadd": "100 E ERIE ST",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 613629800,
    "dropmaladd": "100 E ERIE ST",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 613629800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156636321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14963",
    "droptype": "D",
    "dropname": "SPRINGERTON",
    "dropdeladd": "125 S MAIN ST",
    "dropdelcty": "SPRINGERTON",
    "dropdelst": "IL",
    "dropdelzpp": 628879997,
    "dropphyadd": "125 S MAIN ST",
    "dropphycty": "SPRINGERTON",
    "dropphyst": "IL",
    "dropphyzpp": 628879997,
    "dropmaladd": "125 S MAIN ST",
    "dropmalcty": "SPRINGERTON",
    "dropmalst": "IL",
    "dropmalzpp": 628879997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189632761,
    "dropsitcph": 6189632761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW14965",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "2105 E COOK ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627039998,
    "dropphyadd": "2105 E COOK ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627039998,
    "dropmaladd": "2105 E COOK ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627039998,
    "dropsitphn": 2177887407,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177887200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15140",
    "droptype": "D",
    "dropname": "STANDARD",
    "dropdeladd": "106 S 2ND ST",
    "dropdelcty": "STANDARD",
    "dropdelst": "IL",
    "dropdelzpp": 613637500,
    "dropphyadd": "106 S 2ND ST",
    "dropphycty": "STANDARD",
    "dropphyst": "IL",
    "dropphyzpp": 613637500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANDARD",
    "dropmalst": "IL",
    "dropmalzpp": 613639998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153392234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15143",
    "droptype": "D",
    "dropname": "STANFORD",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "STANFORD",
    "dropdelst": "IL",
    "dropdelzpp": 617747540,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "STANFORD",
    "dropphyst": "IL",
    "dropphyzpp": 617747540,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANFORD",
    "dropmalst": "IL",
    "dropmalzpp": 617749998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093794441,
    "dropfax": 3093794441
  },
  {
    "dcode": "D",
    "dropkey": "PW15155",
    "droptype": "D",
    "dropname": "STAUNTON",
    "dropdeladd": "113 S EDWARDSVILLE ST",
    "dropdelcty": "STAUNTON",
    "dropdelst": "IL",
    "dropdelzpp": 620889998,
    "dropphyadd": "113 S EDWARDSVILLE ST",
    "dropphycty": "STAUNTON",
    "dropphyst": "IL",
    "dropphyzpp": 620889998,
    "dropmaladd": "113 S EDWARDSVILLE ST",
    "dropmalcty": "STAUNTON",
    "dropmalst": "IL",
    "dropmalzpp": 620889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182785851,
    "dropsitcph": 6182785851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15159",
    "droptype": "D",
    "dropname": "STEELEVILLE",
    "dropdeladd": "409 W BROADWAY",
    "dropdelcty": "STEELEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622889998,
    "dropphyadd": "409 W BROADWAY",
    "dropphycty": "STEELEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622889998,
    "dropmaladd": "409 W BROADWAY",
    "dropmalcty": "STEELEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189653341,
    "dropsitcph": 6189653341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15163",
    "droptype": "D",
    "dropname": "STEGER",
    "dropdeladd": "23 W 34TH ST",
    "dropdelcty": "STEGER",
    "dropdelst": "IL",
    "dropdelzpp": 604759998,
    "dropphyadd": "23 W 34TH ST",
    "dropphycty": "STEGER",
    "dropphyst": "IL",
    "dropphyzpp": 604759998,
    "dropmaladd": "23 W 34TH ST",
    "dropmalcty": "STEGER",
    "dropmalst": "IL",
    "dropmalzpp": 604759998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087542128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15165",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "408 3RD AVE",
    "dropdelcty": "STERLING",
    "dropdelst": "IL",
    "dropdelzpp": 610813677,
    "dropphyadd": "408 3RD AVE",
    "dropphycty": "STERLING",
    "dropphyst": "IL",
    "dropphyzpp": 610813677,
    "dropmaladd": "408 3RD AVE",
    "dropmalcty": "STERLING",
    "dropmalst": "IL",
    "dropmalzpp": 610813677,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156250812,
    "dropsitcph": 8156250812,
    "dropfax": 8156250879
  },
  {
    "dcode": "D",
    "dropkey": "PW15166",
    "droptype": "D",
    "dropname": "STEWARD",
    "dropdeladd": "403 MAIN ST STE A",
    "dropdelcty": "STEWARD",
    "dropdelst": "IL",
    "dropdelzpp": 605539800,
    "dropphyadd": "403 MAIN ST STE A",
    "dropphycty": "STEWARD",
    "dropphyst": "IL",
    "dropphyzpp": 605539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEWARD",
    "dropmalst": "IL",
    "dropmalzpp": 605539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8153962222,
    "dropfax": 8153962215
  },
  {
    "dcode": "D",
    "dropkey": "PW15167",
    "droptype": "D",
    "dropname": "STEWARDSON",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "STEWARDSON",
    "dropdelst": "IL",
    "dropdelzpp": 624639998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "STEWARDSON",
    "dropphyst": "IL",
    "dropphyzpp": 624639998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "STEWARDSON",
    "dropmalst": "IL",
    "dropmalzpp": 624639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176823833,
    "dropsitcph": 2176823833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15169",
    "droptype": "D",
    "dropname": "STILLMAN VALLEY",
    "dropdeladd": "215 N WALNUT ST",
    "dropdelcty": "STILLMAN VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 610848947,
    "dropphyadd": "215 N WALNUT ST",
    "dropphycty": "STILLMAN VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 610848947,
    "dropmaladd": "215 N WALNUT ST",
    "dropmalcty": "STILLMAN VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 610848947,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156458875,
    "dropsitcph": 8156458875,
    "dropfax": 8156452582
  },
  {
    "dcode": "D",
    "dropkey": "PW15179",
    "droptype": "D",
    "dropname": "STOCKLAND",
    "dropdeladd": "2842 E 860 NORTH RD",
    "dropdelcty": "STOCKLAND",
    "dropdelst": "IL",
    "dropdelzpp": 609679998,
    "dropphyadd": "2842 E 860 NORTH RD",
    "dropphycty": "STOCKLAND",
    "dropphyst": "IL",
    "dropphyzpp": 609679998,
    "dropmaladd": "2842 E 860 NORTH RD",
    "dropmalcty": "STOCKLAND",
    "dropmalst": "IL",
    "dropmalzpp": 609679998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8156824481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15180",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "201 W RAILROAD AVE",
    "dropdelcty": "STOCKTON",
    "dropdelst": "IL",
    "dropdelzpp": 610851588,
    "dropphyadd": "201 W RAILROAD AVE",
    "dropphycty": "STOCKTON",
    "dropphyst": "IL",
    "dropphyzpp": 610851588,
    "dropmaladd": "201 W RAILROAD AVE",
    "dropmalcty": "STOCKTON",
    "dropmalst": "IL",
    "dropmalzpp": 610851588,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159473613,
    "dropsitcph": 8159473613,
    "dropfax": 8159479068
  },
  {
    "dcode": "D",
    "dropkey": "PW15182",
    "droptype": "D",
    "dropname": "STONEFORT",
    "dropdeladd": "1055 WILSON ST",
    "dropdelcty": "STONEFORT",
    "dropdelst": "IL",
    "dropdelzpp": 629879998,
    "dropphyadd": "1055 WILSON ST",
    "dropphycty": "STONEFORT",
    "dropphyst": "IL",
    "dropphyzpp": 629879998,
    "dropmaladd": "1055 WILSON ST",
    "dropmalcty": "STONEFORT",
    "dropmalst": "IL",
    "dropmalzpp": 629879998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187772214,
    "dropsitcph": 6187772214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15184",
    "droptype": "D",
    "dropname": "STONINGTON",
    "dropdeladd": "116 E 4TH ST",
    "dropdelcty": "STONINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 625679998,
    "dropphyadd": "116 E 4TH ST",
    "dropphycty": "STONINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 625679998,
    "dropmaladd": "116 E 4TH ST",
    "dropmalcty": "STONINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 625679998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173253647,
    "dropsitcph": 2173253647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15185",
    "droptype": "D",
    "dropname": "STOY",
    "dropdeladd": "10065 N MAIN ST",
    "dropdelcty": "STOY",
    "dropdelst": "IL",
    "dropdelzpp": 624649998,
    "dropphyadd": "10065 N MAIN ST",
    "dropphycty": "STOY",
    "dropphyst": "IL",
    "dropphyzpp": 624649998,
    "dropmaladd": "10065 N MAIN ST",
    "dropmalcty": "STOY",
    "dropmalst": "IL",
    "dropmalzpp": 624649998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185923451,
    "dropsitcph": 6185923451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15187",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "106 E COMMERCIAL ST",
    "dropdelcty": "STRASBURG",
    "dropdelst": "IL",
    "dropdelzpp": 624659998,
    "dropphyadd": "106 E COMMERCIAL ST",
    "dropphycty": "STRASBURG",
    "dropphyst": "IL",
    "dropphyzpp": 624659998,
    "dropmaladd": "106 E COMMERCIAL ST",
    "dropmalcty": "STRASBURG",
    "dropmalst": "IL",
    "dropmalzpp": 624659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2176442616,
    "dropsitcph": 2176442616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15190",
    "droptype": "D",
    "dropname": "STRAWN",
    "dropdeladd": "205 S 1ST ST",
    "dropdelcty": "STRAWN",
    "dropdelst": "IL",
    "dropdelzpp": 617759900,
    "dropphyadd": "205 S 1ST ST",
    "dropphycty": "STRAWN",
    "dropphyst": "IL",
    "dropphyzpp": 617759900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRAWN",
    "dropmalst": "IL",
    "dropmalzpp": 617759998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156883385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15193",
    "droptype": "D",
    "dropname": "STREATOR",
    "dropdeladd": "221 E HICKORY ST",
    "dropdelcty": "STREATOR",
    "dropdelst": "IL",
    "dropdelzpp": 613649800,
    "dropphyadd": "221 E HICKORY ST",
    "dropphycty": "STREATOR",
    "dropphyst": "IL",
    "dropphyzpp": 613649800,
    "dropmaladd": "221 E HICKORY ST",
    "dropmalcty": "STREATOR",
    "dropmalst": "IL",
    "dropmalzpp": 613649800,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156722606,
    "dropfax": 8156732138
  },
  {
    "dcode": "D",
    "dropkey": "PW15198",
    "droptype": "D",
    "dropname": "STRONGHURST",
    "dropdeladd": "106 S BROADWAY ST",
    "dropdelcty": "STRONGHURST",
    "dropdelst": "IL",
    "dropdelzpp": 614809800,
    "dropphyadd": "106 S BROADWAY ST",
    "dropphycty": "STRONGHURST",
    "dropphyst": "IL",
    "dropphyzpp": 614809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRONGHURST",
    "dropmalst": "IL",
    "dropmalzpp": 614809998,
    "dropsitphn": 3099241755,
    "dropsitlph": 3099241755,
    "dropsitcph": 3099241755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15200",
    "droptype": "D",
    "dropname": "SUBLETTE",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "SUBLETTE",
    "dropdelst": "IL",
    "dropdelzpp": 613679437,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "SUBLETTE",
    "dropphyst": "IL",
    "dropphyzpp": 613679437,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUBLETTE",
    "dropmalst": "IL",
    "dropmalzpp": 613679998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158495936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15204",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "45 E CROSS ST",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 605549998,
    "dropphyadd": "45 E CROSS ST",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 605549998,
    "dropmaladd": "45 E CROSS ST",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 605549998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6304664386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15206",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "16 S MADISON ST",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "IL",
    "dropdelzpp": 619519998,
    "dropphyadd": "16 S MADISON ST",
    "dropphycty": "SULLIVAN",
    "dropphyst": "IL",
    "dropphyzpp": 619519998,
    "dropmaladd": "16 S MADISON ST",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "IL",
    "dropmalzpp": 619519998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177287111,
    "dropfax": 2177287475
  },
  {
    "dcode": "D",
    "dropkey": "PW15208",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "101 E PARK ST",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 622899998,
    "dropphyadd": "101 E PARK ST",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 622899998,
    "dropmaladd": "101 E PARK ST",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 622899998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189343461,
    "dropsitcph": 6189343461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15213",
    "droptype": "D",
    "dropname": "SUMMIT ARGO",
    "dropdeladd": "7415 W 63RD ST",
    "dropdelcty": "SUMMIT ARGO",
    "dropdelst": "IL",
    "dropdelzpp": 605019998,
    "dropphyadd": "7415 W 63RD ST",
    "dropphycty": "SUMMIT ARGO",
    "dropphyst": "IL",
    "dropphyzpp": 605019998,
    "dropmaladd": "7415 W 63RD ST",
    "dropmalcty": "SUMMIT ARGO",
    "dropmalst": "IL",
    "dropmalzpp": 605019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 7084580551,
    "dropfax": 7084586175
  },
  {
    "dcode": "D",
    "dropkey": "PW15216",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "120 W SOUTH AVE",
    "dropdelcty": "SUMNER",
    "dropdelst": "IL",
    "dropdelzpp": 624669998,
    "dropphyadd": "120 W SOUTH AVE",
    "dropphycty": "SUMNER",
    "dropphyst": "IL",
    "dropphyzpp": 624669998,
    "dropmaladd": "120 W SOUTH AVE",
    "dropmalcty": "SUMNER",
    "dropmalst": "IL",
    "dropmalzpp": 624669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189362613,
    "dropsitcph": 6189362613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15233",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "104 E STATE ST",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "IL",
    "dropdelzpp": 601781467,
    "dropphyadd": "104 E STATE ST",
    "dropphycty": "SYCAMORE",
    "dropphyst": "IL",
    "dropphyzpp": 601781467,
    "dropmaladd": "104 E STATE ST",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "IL",
    "dropmalzpp": 601781467,
    "dropsitphn": 6302605499,
    "dropsitlph": 8158952888,
    "dropsitcph": 8158952888,
    "dropfax": 8158952492
  },
  {
    "dcode": "D",
    "dropkey": "PW15236",
    "droptype": "D",
    "dropname": "TABLE GROVE",
    "dropdeladd": "123 E SIDE SQ",
    "dropdelcty": "TABLE GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 614829800,
    "dropphyadd": "123 E SIDE SQ",
    "dropphycty": "TABLE GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 614829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TABLE GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 614829998,
    "dropsitphn": 3097585257,
    "dropsitlph": 3097585257,
    "dropsitcph": 3097585257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15239",
    "droptype": "D",
    "dropname": "TALLULA",
    "dropdeladd": "109 W MAIN ST",
    "dropdelcty": "TALLULA",
    "dropdelst": "IL",
    "dropdelzpp": 626889998,
    "dropphyadd": "109 W MAIN ST",
    "dropphycty": "TALLULA",
    "dropphyst": "IL",
    "dropphyzpp": 626889998,
    "dropmaladd": "109 W MAIN ST",
    "dropmalcty": "TALLULA",
    "dropmalst": "IL",
    "dropmalzpp": 626889998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176344242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15241",
    "droptype": "D",
    "dropname": "TAMAROA",
    "dropdeladd": "11 N CHESTNUT ST",
    "dropdelcty": "TAMAROA",
    "dropdelst": "IL",
    "dropdelzpp": 628889998,
    "dropphyadd": "11 N CHESTNUT ST",
    "dropphycty": "TAMAROA",
    "dropphyst": "IL",
    "dropphyzpp": 628889998,
    "dropmaladd": "11 N CHESTNUT ST",
    "dropmalcty": "TAMAROA",
    "dropmalst": "IL",
    "dropmalzpp": 628889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184963311,
    "dropsitcph": 6184963311,
    "dropfax": 6184963311
  },
  {
    "dcode": "D",
    "dropkey": "PW15242",
    "droptype": "D",
    "dropname": "TAMMS",
    "dropdeladd": "250 FRONT ST",
    "dropdelcty": "TAMMS",
    "dropdelst": "IL",
    "dropdelzpp": 629889998,
    "dropphyadd": "250 FRONT ST",
    "dropphycty": "TAMMS",
    "dropphyst": "IL",
    "dropphyzpp": 629889998,
    "dropmaladd": "250 FRONT ST",
    "dropmalcty": "TAMMS",
    "dropmalst": "IL",
    "dropmalzpp": 629889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187472232,
    "dropsitcph": 6187472232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15243",
    "droptype": "D",
    "dropname": "TAMPICO",
    "dropdeladd": "113 N MAIN ST",
    "dropdelcty": "TAMPICO",
    "dropdelst": "IL",
    "dropdelzpp": 612837721,
    "dropphyadd": "113 N MAIN ST",
    "dropphycty": "TAMPICO",
    "dropphyst": "IL",
    "dropphyzpp": 612837721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAMPICO",
    "dropmalst": "IL",
    "dropmalzpp": 612839998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8154387222,
    "dropsitcph": 8154387222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15244",
    "droptype": "D",
    "dropname": "TAYLOR RIDGE",
    "dropdeladd": "6928 134TH AVE W",
    "dropdelcty": "TAYLOR RIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 612849726,
    "dropphyadd": "6928 134TH AVE W",
    "dropphycty": "TAYLOR RIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 612849726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLOR RIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 612849998,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097937238,
    "dropsitcph": 3097982302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15246",
    "droptype": "D",
    "dropname": "TAYLOR SPRINGS",
    "dropdeladd": "618 E MAIN ST",
    "dropdelcty": "TAYLOR SPRINGS",
    "dropdelst": "IL",
    "dropdelzpp": 620899998,
    "dropphyadd": "618 E MAIN ST",
    "dropphycty": "TAYLOR SPRINGS",
    "dropphyst": "IL",
    "dropphyzpp": 620899998,
    "dropmaladd": "618 E MAIN ST",
    "dropmalcty": "TAYLOR SPRINGS",
    "dropmalst": "IL",
    "dropmalzpp": 620899998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175322254,
    "dropsitcph": 2175322254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15247",
    "droptype": "D",
    "dropname": "TAYLORVILLE",
    "dropdeladd": "300 S MAIN ST",
    "dropdelcty": "TAYLORVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 625689998,
    "dropphyadd": "300 S MAIN ST",
    "dropphycty": "TAYLORVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 625689998,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "TAYLORVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 625689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2178243210,
    "dropfax": 2178246543
  },
  {
    "dcode": "D",
    "dropkey": "PW15248",
    "droptype": "D",
    "dropname": "TECHNY",
    "dropdeladd": "2001A WAUKEGAN RD",
    "dropdelcty": "TECHNY",
    "dropdelst": "IL",
    "dropdelzpp": 600821000,
    "dropphyadd": "2001A WAUKEGAN RD",
    "dropphycty": "TECHNY",
    "dropphyst": "IL",
    "dropphyzpp": 600821000,
    "dropmaladd": "2001A WAUKEGAN RD",
    "dropmalcty": "TECHNY",
    "dropmalst": "IL",
    "dropmalzpp": 600821000,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472720258,
    "dropsitcph": 8472720258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15251",
    "droptype": "D",
    "dropname": "TENNESSEE",
    "dropdeladd": "209 W BUSHNELL ST",
    "dropdelcty": "TENNESSEE",
    "dropdelst": "IL",
    "dropdelzpp": 623749998,
    "dropphyadd": "209 W BUSHNELL ST",
    "dropphycty": "TENNESSEE",
    "dropphyst": "IL",
    "dropphyzpp": 623749998,
    "dropmaladd": "209 W BUSHNELL ST",
    "dropmalcty": "TENNESSEE",
    "dropmalst": "IL",
    "dropmalzpp": 623749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3097764777,
    "dropsitcph": 3097764777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15252",
    "droptype": "D",
    "dropname": "TEUTOPOLIS",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "TEUTOPOLIS",
    "dropdelst": "IL",
    "dropdelzpp": 624679998,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "TEUTOPOLIS",
    "dropphyst": "IL",
    "dropphyzpp": 624679998,
    "dropmaladd": "100 W MAIN ST",
    "dropmalcty": "TEUTOPOLIS",
    "dropmalst": "IL",
    "dropmalzpp": 624679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178573422,
    "dropsitcph": 2178573422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15255",
    "droptype": "D",
    "dropname": "TEXICO",
    "dropdeladd": "13398 E DIX TEXICO RD",
    "dropdelcty": "TEXICO",
    "dropdelst": "IL",
    "dropdelzpp": 628899997,
    "dropphyadd": "13398 E DIX TEXICO RD",
    "dropphycty": "TEXICO",
    "dropphyst": "IL",
    "dropphyzpp": 628899997,
    "dropmaladd": "13398 E DIX TEXICO RD",
    "dropmalcty": "TEXICO",
    "dropmalst": "IL",
    "dropmalzpp": 628899997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182667370,
    "dropsitcph": 6182667370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15257",
    "droptype": "D",
    "dropname": "THAWVILLE",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "THAWVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 609689800,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "THAWVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 609689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THAWVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 609689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 2173872481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15260",
    "droptype": "D",
    "dropname": "THAYER",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "THAYER",
    "dropdelst": "IL",
    "dropdelzpp": 626899998,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "THAYER",
    "dropphyst": "IL",
    "dropphyzpp": 626899998,
    "dropmaladd": "210 E MAIN ST",
    "dropmalcty": "THAYER",
    "dropmalst": "IL",
    "dropmalzpp": 626899998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179655031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15263",
    "droptype": "D",
    "dropname": "THEBES",
    "dropdeladd": "815 POPLAR ST",
    "dropdelcty": "THEBES",
    "dropdelst": "IL",
    "dropdelzpp": 629909998,
    "dropphyadd": "815 POPLAR ST",
    "dropphycty": "THEBES",
    "dropphyst": "IL",
    "dropphyzpp": 629909998,
    "dropmaladd": "815 POPLAR ST",
    "dropmalcty": "THEBES",
    "dropmalst": "IL",
    "dropmalzpp": 629909998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187642263,
    "dropsitcph": 6187642263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15267",
    "droptype": "D",
    "dropname": "THOMASBORO",
    "dropdeladd": "610 N COMMERCIAL ST",
    "dropdelcty": "THOMASBORO",
    "dropdelst": "IL",
    "dropdelzpp": 618789998,
    "dropphyadd": "610 N COMMERCIAL ST",
    "dropphycty": "THOMASBORO",
    "dropphyst": "IL",
    "dropphyzpp": 618789998,
    "dropmaladd": "610 N COMMERCIAL ST",
    "dropmalcty": "THOMASBORO",
    "dropmalst": "IL",
    "dropmalzpp": 618789998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2176437106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15270",
    "droptype": "D",
    "dropname": "THOMPSONVILLE",
    "dropdeladd": "21302 SHAWNEETOWN RD",
    "dropdelcty": "THOMPSONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628909998,
    "dropphyadd": "21302 SHAWNEETOWN RD",
    "dropphycty": "THOMPSONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628909998,
    "dropmaladd": "21302 SHAWNEETOWN RD",
    "dropmalcty": "THOMPSONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628909998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186272613,
    "dropsitcph": 6186272613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15273",
    "droptype": "D",
    "dropname": "THOMSON",
    "dropdeladd": "705 ARGO FAY RTE",
    "dropdelcty": "THOMSON",
    "dropdelst": "IL",
    "dropdelzpp": 612857772,
    "dropphyadd": "705 ARGO FAY RTE",
    "dropphycty": "THOMSON",
    "dropphyst": "IL",
    "dropphyzpp": 612857772,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMSON",
    "dropmalst": "IL",
    "dropmalzpp": 612859998,
    "dropsitphn": 5152837530,
    "dropsitlph": 8152593121,
    "dropsitcph": 8152593121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15275",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "103 E ELEANOR ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "IL",
    "dropdelzpp": 604769998,
    "dropphyadd": "103 E ELEANOR ST",
    "dropphycty": "THORNTON",
    "dropphyst": "IL",
    "dropphyzpp": 604769998,
    "dropmaladd": "103 E ELEANOR ST",
    "dropmalcty": "THORNTON",
    "dropmalst": "IL",
    "dropmalzpp": 604769998,
    "dropsitphn": 7087540674,
    "dropsitlph": 7085635789,
    "dropsitcph": 7088776072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15278",
    "droptype": "D",
    "dropname": "TILDEN",
    "dropdeladd": "722 N CENTRE ST",
    "dropdelcty": "TILDEN",
    "dropdelst": "IL",
    "dropdelzpp": 622929998,
    "dropphyadd": "722 N CENTRE ST",
    "dropphycty": "TILDEN",
    "dropphyst": "IL",
    "dropphyzpp": 622929998,
    "dropmaladd": "722 N CENTRE ST",
    "dropmalcty": "TILDEN",
    "dropmalst": "IL",
    "dropmalzpp": 622929998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185875131,
    "dropsitcph": 6185875131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15283",
    "droptype": "D",
    "dropname": "TIMEWELL",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "TIMEWELL",
    "dropdelst": "IL",
    "dropdelzpp": 623759998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "TIMEWELL",
    "dropphyst": "IL",
    "dropphyzpp": 623759998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "TIMEWELL",
    "dropmalst": "IL",
    "dropmalzpp": 623759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177732114,
    "dropsitcph": 2177732114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15285",
    "droptype": "D",
    "dropname": "TINLEY PARK",
    "dropdeladd": "7230 171ST ST",
    "dropdelcty": "TINLEY PARK",
    "dropdelst": "IL",
    "dropdelzpp": 604779998,
    "dropphyadd": "7230 171ST ST",
    "dropphycty": "TINLEY PARK",
    "dropphyst": "IL",
    "dropphyzpp": 604779998,
    "dropmaladd": "7230 171ST ST",
    "dropmalcty": "TINLEY PARK",
    "dropmalst": "IL",
    "dropmalzpp": 604779998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7085323131,
    "dropfax": 7085329969
  },
  {
    "dcode": "D",
    "dropkey": "PW15290",
    "droptype": "D",
    "dropname": "TISKILWA",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "TISKILWA",
    "dropdelst": "IL",
    "dropdelzpp": 613689800,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "TISKILWA",
    "dropphyst": "IL",
    "dropphyzpp": 613689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TISKILWA",
    "dropmalst": "IL",
    "dropmalzpp": 613689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156464461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15292",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "112 COURTHOUSE SQ",
    "dropdelcty": "TOLEDO",
    "dropdelst": "IL",
    "dropdelzpp": 624689998,
    "dropphyadd": "112 COURTHOUSE SQ",
    "dropphycty": "TOLEDO",
    "dropphyst": "IL",
    "dropphyzpp": 624689998,
    "dropmaladd": "112 COURTHOUSE SQ",
    "dropmalcty": "TOLEDO",
    "dropmalst": "IL",
    "dropmalzpp": 624689998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178492121,
    "dropsitcph": 2178492121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15293",
    "droptype": "D",
    "dropname": "TOLONO",
    "dropdeladd": "113 N VORCEY ST",
    "dropdelcty": "TOLONO",
    "dropdelst": "IL",
    "dropdelzpp": 618809998,
    "dropphyadd": "113 N VORCEY ST",
    "dropphycty": "TOLONO",
    "dropphyst": "IL",
    "dropphyzpp": 618809998,
    "dropmaladd": "113 N VORCEY ST",
    "dropmalcty": "TOLONO",
    "dropmalst": "IL",
    "dropmalzpp": 618809998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174858955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15294",
    "droptype": "D",
    "dropname": "TOLUCA",
    "dropdeladd": "120 W SANTA FE AVE",
    "dropdelcty": "TOLUCA",
    "dropdelst": "IL",
    "dropdelzpp": 613699708,
    "dropphyadd": "120 W SANTA FE AVE",
    "dropphycty": "TOLUCA",
    "dropphyst": "IL",
    "dropphyzpp": 613699708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOLUCA",
    "dropmalst": "IL",
    "dropmalzpp": 613699998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154522226,
    "dropfax": 8154522226
  },
  {
    "dcode": "D",
    "dropkey": "PW15297",
    "droptype": "D",
    "dropname": "TONICA",
    "dropdeladd": "110 S ONECA ST",
    "dropdelcty": "TONICA",
    "dropdelst": "IL",
    "dropdelzpp": 613709701,
    "dropphyadd": "110 S ONECA ST",
    "dropphycty": "TONICA",
    "dropphyst": "IL",
    "dropphyzpp": 613709701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONICA",
    "dropmalst": "IL",
    "dropmalzpp": 613709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8154428220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15298",
    "droptype": "D",
    "dropname": "TOPEKA",
    "dropdeladd": "111 W 4TH ST",
    "dropdelcty": "TOPEKA",
    "dropdelst": "IL",
    "dropdelzpp": 615679395,
    "dropphyadd": "111 W 4TH ST",
    "dropphycty": "TOPEKA",
    "dropphyst": "IL",
    "dropphyzpp": 615679395,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPEKA",
    "dropmalst": "IL",
    "dropmalzpp": 615679998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097906001,
    "dropfax": 3095353360
  },
  {
    "dcode": "D",
    "dropkey": "PW15300",
    "droptype": "D",
    "dropname": "TOULON",
    "dropdeladd": "111 W VINE ST",
    "dropdelcty": "TOULON",
    "dropdelst": "IL",
    "dropdelzpp": 614839800,
    "dropphyadd": "111 W VINE ST",
    "dropphycty": "TOULON",
    "dropphyst": "IL",
    "dropphyzpp": 614839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOULON",
    "dropmalst": "IL",
    "dropmalzpp": 614839998,
    "dropsitphn": 3092866441,
    "dropsitlph": 3092866441,
    "dropsitcph": 3092402012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15301",
    "droptype": "D",
    "dropname": "TOVEY",
    "dropdeladd": "411 MIDLAND ST",
    "dropdelcty": "TOVEY",
    "dropdelst": "IL",
    "dropdelzpp": 625709998,
    "dropphyadd": "411 MIDLAND ST",
    "dropphycty": "TOVEY",
    "dropphyst": "IL",
    "dropphyzpp": 625709998,
    "dropmaladd": "411 MIDLAND ST",
    "dropmalcty": "TOVEY",
    "dropmalst": "IL",
    "dropmalzpp": 625709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172372431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15302",
    "droptype": "D",
    "dropname": "TOWANDA",
    "dropdeladd": "104 S MADISON ST",
    "dropdelcty": "TOWANDA",
    "dropdelst": "IL",
    "dropdelzpp": 617767614,
    "dropphyadd": "104 S MADISON ST",
    "dropphycty": "TOWANDA",
    "dropphyst": "IL",
    "dropphyzpp": 617767614,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOWANDA",
    "dropmalst": "IL",
    "dropmalzpp": 617769998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3097282132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15303",
    "droptype": "D",
    "dropname": "TOWER HILL",
    "dropdeladd": "105 S MICHIGAN ST",
    "dropdelcty": "TOWER HILL",
    "dropdelst": "IL",
    "dropdelzpp": 625719998,
    "dropphyadd": "105 S MICHIGAN ST",
    "dropphycty": "TOWER HILL",
    "dropphyst": "IL",
    "dropphyzpp": 625719998,
    "dropmaladd": "105 S MICHIGAN ST",
    "dropmalcty": "TOWER HILL",
    "dropmalst": "IL",
    "dropmalzpp": 625719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175673522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15307",
    "droptype": "D",
    "dropname": "TREMONT",
    "dropdeladd": "109 W WALNUT ST",
    "dropdelcty": "TREMONT",
    "dropdelst": "IL",
    "dropdelzpp": 615689998,
    "dropphyadd": "109 W WALNUT ST",
    "dropphycty": "TREMONT",
    "dropphyst": "IL",
    "dropphyzpp": 615689998,
    "dropmaladd": "109 W WALNUT ST",
    "dropmalcty": "TREMONT",
    "dropmalst": "IL",
    "dropmalzpp": 615689998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3099255213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15308",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "120 E BROADWAY",
    "dropdelcty": "TRENTON",
    "dropdelst": "IL",
    "dropdelzpp": 622939998,
    "dropphyadd": "120 E BROADWAY",
    "dropphycty": "TRENTON",
    "dropphyst": "IL",
    "dropphyzpp": 622939998,
    "dropmaladd": "120 E BROADWAY",
    "dropmalcty": "TRENTON",
    "dropmalst": "IL",
    "dropmalzpp": 622939998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182249412,
    "dropsitcph": 6182249412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15309",
    "droptype": "D",
    "dropname": "TRILLA",
    "dropdeladd": "102 W TRILLA RD",
    "dropdelcty": "TRILLA",
    "dropdelst": "IL",
    "dropdelzpp": 624699998,
    "dropphyadd": "102 W TRILLA RD",
    "dropphycty": "TRILLA",
    "dropphyst": "IL",
    "dropphyzpp": 624699998,
    "dropmaladd": "102 W TRILLA RD",
    "dropmalcty": "TRILLA",
    "dropmalst": "IL",
    "dropmalzpp": 624699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172342970,
    "dropsitcph": 2172342970,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15312",
    "droptype": "D",
    "dropname": "TRIUMPH",
    "dropdeladd": "3906 E 752ND RD",
    "dropdelcty": "TRIUMPH",
    "dropdelst": "IL",
    "dropdelzpp": 613719700,
    "dropphyadd": "3906 E 752ND RD",
    "dropphycty": "TRIUMPH",
    "dropphyst": "IL",
    "dropphyzpp": 613719700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRIUMPH",
    "dropmalst": "IL",
    "dropmalzpp": 613719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8155395517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15313",
    "droptype": "D",
    "dropname": "TRIVOLI",
    "dropdeladd": "18610 W MAIN ST",
    "dropdelcty": "TRIVOLI",
    "dropdelst": "IL",
    "dropdelzpp": 615699756,
    "dropphyadd": "18610 W MAIN ST",
    "dropphycty": "TRIVOLI",
    "dropphyst": "IL",
    "dropphyzpp": 615699756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRIVOLI",
    "dropmalst": "IL",
    "dropmalzpp": 615699998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093622163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15315",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "515 EDWARDSVILLE RD",
    "dropdelcty": "TROY",
    "dropdelst": "IL",
    "dropdelzpp": 622949998,
    "dropphyadd": "515 EDWARDSVILLE RD",
    "dropphycty": "TROY",
    "dropphyst": "IL",
    "dropphyzpp": 622949998,
    "dropmaladd": "515 EDWARDSVILLE RD",
    "dropmalcty": "TROY",
    "dropmalst": "IL",
    "dropmalzpp": 622949998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186676421,
    "dropsitcph": 6186676421,
    "dropfax": 6186678293
  },
  {
    "dcode": "D",
    "dropkey": "PW15316",
    "droptype": "D",
    "dropname": "TROY GROVE",
    "dropdeladd": "107 E OTTAWA ST",
    "dropdelcty": "TROY GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 613729800,
    "dropphyadd": "107 E OTTAWA ST",
    "dropphycty": "TROY GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 613729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROY GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 613729998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8155399403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15321",
    "droptype": "D",
    "dropname": "TUSCOLA",
    "dropdeladd": "120 E SALE ST",
    "dropdelcty": "TUSCOLA",
    "dropdelst": "IL",
    "dropdelzpp": 619539998,
    "dropphyadd": "120 E SALE ST",
    "dropphycty": "TUSCOLA",
    "dropphyst": "IL",
    "dropphyzpp": 619539998,
    "dropmaladd": "120 E SALE ST",
    "dropmalcty": "TUSCOLA",
    "dropmalst": "IL",
    "dropmalzpp": 619539998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172533513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15327",
    "droptype": "D",
    "dropname": "ULLIN",
    "dropdeladd": "121 S CENTRAL ST",
    "dropdelcty": "ULLIN",
    "dropdelst": "IL",
    "dropdelzpp": 629929998,
    "dropphyadd": "121 S CENTRAL ST",
    "dropphycty": "ULLIN",
    "dropphyst": "IL",
    "dropphyzpp": 629929998,
    "dropmaladd": "121 S CENTRAL ST",
    "dropmalcty": "ULLIN",
    "dropmalst": "IL",
    "dropmalzpp": 629929998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188453517,
    "dropsitcph": 6188453517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15329",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "17803 DEPOT ST",
    "dropdelcty": "UNION",
    "dropdelst": "IL",
    "dropdelzpp": 601801000,
    "dropphyadd": "17803 DEPOT ST",
    "dropphycty": "UNION",
    "dropphyst": "IL",
    "dropphyzpp": 601801000,
    "dropmaladd": "17803 DEPOT ST",
    "dropmalcty": "UNION",
    "dropmalst": "IL",
    "dropmalzpp": 601801000,
    "dropsitphn": 8155687449,
    "dropsitlph": 8159234307,
    "dropsitcph": 8159234307,
    "dropfax": 8159234307
  },
  {
    "dcode": "D",
    "dropkey": "PW15332",
    "droptype": "D",
    "dropname": "UNION HILL",
    "dropdeladd": "1 CENTER ST",
    "dropdelcty": "UNION HILL",
    "dropdelst": "IL",
    "dropdelzpp": 609699800,
    "dropphyadd": "1 CENTER ST",
    "dropphycty": "UNION HILL",
    "dropphyst": "IL",
    "dropphyzpp": 609699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION HILL",
    "dropmalst": "IL",
    "dropmalzpp": 609699998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154266314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15344",
    "droptype": "D",
    "dropname": "URBANA",
    "dropdeladd": "3100 E TATMAN CT",
    "dropdelcty": "URBANA",
    "dropdelst": "IL",
    "dropdelzpp": 618029998,
    "dropphyadd": "3100 E TATMAN CT",
    "dropphycty": "URBANA",
    "dropphyst": "IL",
    "dropphyzpp": 618029998,
    "dropmaladd": "3100 E TATMAN CT",
    "dropmalcty": "URBANA",
    "dropmalst": "IL",
    "dropmalzpp": 618029998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173376297,
    "dropfax": 2173376435
  },
  {
    "dcode": "D",
    "dropkey": "PW15346",
    "droptype": "D",
    "dropname": "URSA",
    "dropdeladd": "107 N WARSAW ST",
    "dropdelcty": "URSA",
    "dropdelst": "IL",
    "dropdelzpp": 623769998,
    "dropphyadd": "107 N WARSAW ST",
    "dropphycty": "URSA",
    "dropphyst": "IL",
    "dropphyzpp": 623769998,
    "dropmaladd": "107 N WARSAW ST",
    "dropmalcty": "URSA",
    "dropmalst": "IL",
    "dropmalzpp": 623769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179642508,
    "dropsitcph": 2179642508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15348",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "310 N MILL ST",
    "dropdelcty": "UTICA",
    "dropdelst": "IL",
    "dropdelzpp": 613739800,
    "dropphyadd": "310 N MILL ST",
    "dropphycty": "UTICA",
    "dropphyst": "IL",
    "dropphyzpp": 613739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UTICA",
    "dropmalst": "IL",
    "dropmalzpp": 613739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 8156678025,
    "dropsitcph": 8156678025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15349",
    "droptype": "D",
    "dropname": "VALIER",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "VALIER",
    "dropdelst": "IL",
    "dropdelzpp": 628919998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "VALIER",
    "dropphyst": "IL",
    "dropphyzpp": 628919998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "VALIER",
    "dropmalst": "IL",
    "dropmalzpp": 628919998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187249350,
    "dropsitcph": 6187249350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15353",
    "droptype": "D",
    "dropname": "VALMEYER",
    "dropdeladd": "100 KNOBLOCH BLVD",
    "dropdelcty": "VALMEYER",
    "dropdelst": "IL",
    "dropdelzpp": 622959998,
    "dropphyadd": "100 KNOBLOCH BLVD",
    "dropphycty": "VALMEYER",
    "dropphyst": "IL",
    "dropphyzpp": 622959998,
    "dropmaladd": "100 KNOBLOCH BLVD",
    "dropmalcty": "VALMEYER",
    "dropmalst": "IL",
    "dropmalzpp": 622959998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189352679,
    "dropsitcph": 6189352679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15355",
    "droptype": "D",
    "dropname": "VAN ORIN",
    "dropdeladd": "27861 2600 EAST ST",
    "dropdelcty": "VAN ORIN",
    "dropdelst": "IL",
    "dropdelzpp": 613749700,
    "dropphyadd": "27861 2600 EAST ST",
    "dropphycty": "VAN ORIN",
    "dropphyst": "IL",
    "dropphyzpp": 613749700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN ORIN",
    "dropmalst": "IL",
    "dropmalzpp": 613749998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156382230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15356",
    "droptype": "D",
    "dropname": "VANDALIA",
    "dropdeladd": "304 S 4TH ST",
    "dropdelcty": "VANDALIA",
    "dropdelst": "IL",
    "dropdelzpp": 624719998,
    "dropphyadd": "304 S 4TH ST",
    "dropphycty": "VANDALIA",
    "dropphyst": "IL",
    "dropphyzpp": 624719998,
    "dropmaladd": "304 S 4TH ST",
    "dropmalcty": "VANDALIA",
    "dropmalst": "IL",
    "dropmalzpp": 624719998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182830328,
    "dropsitcph": 6182830328,
    "dropfax": 6513066223
  },
  {
    "dcode": "D",
    "dropkey": "PW15357",
    "droptype": "D",
    "dropname": "VARNA",
    "dropdeladd": "304 WALNUT ST",
    "dropdelcty": "VARNA",
    "dropdelst": "IL",
    "dropdelzpp": 613759700,
    "dropphyadd": "304 WALNUT ST",
    "dropphycty": "VARNA",
    "dropphyst": "IL",
    "dropphyzpp": 613759700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VARNA",
    "dropmalst": "IL",
    "dropmalzpp": 613759998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094632456,
    "dropfax": 3094632456
  },
  {
    "dcode": "D",
    "dropkey": "PW15361",
    "droptype": "D",
    "dropname": "VENICE",
    "dropdeladd": "408 BROADWAY",
    "dropdelcty": "VENICE",
    "dropdelst": "IL",
    "dropdelzpp": 620909998,
    "dropphyadd": "408 BROADWAY",
    "dropphycty": "VENICE",
    "dropphyst": "IL",
    "dropphyzpp": 620909998,
    "dropmaladd": "408 BROADWAY",
    "dropmalcty": "VENICE",
    "dropmalst": "IL",
    "dropmalzpp": 620909998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188774516,
    "dropsitcph": 6188774516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15363",
    "droptype": "D",
    "dropname": "VERGENNES",
    "dropdeladd": "725 HACK AVE",
    "dropdelcty": "VERGENNES",
    "dropdelst": "IL",
    "dropdelzpp": 629949998,
    "dropphyadd": "725 HACK AVE",
    "dropphycty": "VERGENNES",
    "dropphyst": "IL",
    "dropphyzpp": 629949998,
    "dropmaladd": "725 HACK AVE",
    "dropmalcty": "VERGENNES",
    "dropmalst": "IL",
    "dropmalzpp": 629949998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186846631,
    "dropsitcph": 6186846631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15364",
    "droptype": "D",
    "dropname": "VERMILION",
    "dropdeladd": "109 EDGAR ST",
    "dropdelcty": "VERMILION",
    "dropdelst": "IL",
    "dropdelzpp": 619559998,
    "dropphyadd": "109 EDGAR ST",
    "dropphycty": "VERMILION",
    "dropphyst": "IL",
    "dropphyzpp": 619559998,
    "dropmaladd": "109 EDGAR ST",
    "dropmalcty": "VERMILION",
    "dropmalst": "IL",
    "dropmalzpp": 619559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172753711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15367",
    "droptype": "D",
    "dropname": "VERMONT",
    "dropdeladd": "100 W 2ND ST",
    "dropdelcty": "VERMONT",
    "dropdelst": "IL",
    "dropdelzpp": 614849800,
    "dropphyadd": "100 W 2ND ST",
    "dropphycty": "VERMONT",
    "dropphyst": "IL",
    "dropphyzpp": 614849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERMONT",
    "dropmalst": "IL",
    "dropmalzpp": 614849998,
    "dropsitphn": 3097845051,
    "dropsitlph": 3097845051,
    "dropsitcph": 3097845051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15368",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "200 N RACE ST",
    "dropdelcty": "VERNON",
    "dropdelst": "IL",
    "dropdelzpp": 628929998,
    "dropphyadd": "200 N RACE ST",
    "dropphycty": "VERNON",
    "dropphyst": "IL",
    "dropphyzpp": 628929998,
    "dropmaladd": "200 N RACE ST",
    "dropmalcty": "VERNON",
    "dropmalst": "IL",
    "dropmalzpp": 628929998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184327723,
    "dropsitcph": 6184327723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15372",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "421 N DIVISION ST",
    "dropdelcty": "VERONA",
    "dropdelst": "IL",
    "dropdelzpp": 604799998,
    "dropphyadd": "421 N DIVISION ST",
    "dropphycty": "VERONA",
    "dropphyst": "IL",
    "dropphyzpp": 604799998,
    "dropmaladd": "421 N DIVISION ST",
    "dropmalcty": "VERONA",
    "dropmalst": "IL",
    "dropmalzpp": 604799998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152872224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15373",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "IL",
    "dropdelzpp": 623789998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "VERSAILLES",
    "dropphyst": "IL",
    "dropphyzpp": 623789998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "IL",
    "dropmalzpp": 623789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172253311,
    "dropsitcph": 2172253311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15375",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "229 E MAIN ST",
    "dropdelcty": "VICTORIA",
    "dropdelst": "IL",
    "dropdelzpp": 614859850,
    "dropphyadd": "229 E MAIN ST",
    "dropphycty": "VICTORIA",
    "dropphyst": "IL",
    "dropphyzpp": 614859850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VICTORIA",
    "dropmalst": "IL",
    "dropmalzpp": 614859998,
    "dropsitphn": 3096394483,
    "dropsitlph": 3098792105,
    "dropsitcph": 3098792105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15376",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "207 E VINE ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "IL",
    "dropdelzpp": 629959998,
    "dropphyadd": "207 E VINE ST",
    "dropphycty": "VIENNA",
    "dropphyst": "IL",
    "dropphyzpp": 629959998,
    "dropmaladd": "207 E VINE ST",
    "dropmalcty": "VIENNA",
    "dropmalst": "IL",
    "dropmalzpp": 629959998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186585281,
    "dropsitcph": 6186585281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15377",
    "droptype": "D",
    "dropname": "VILLA GROVE",
    "dropdeladd": "110 N MAIN ST",
    "dropdelcty": "VILLA GROVE",
    "dropdelst": "IL",
    "dropdelzpp": 619569998,
    "dropphyadd": "110 N MAIN ST",
    "dropphycty": "VILLA GROVE",
    "dropphyst": "IL",
    "dropphyzpp": 619569998,
    "dropmaladd": "110 N MAIN ST",
    "dropmalcty": "VILLA GROVE",
    "dropmalst": "IL",
    "dropmalzpp": 619569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2178324501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15378",
    "droptype": "D",
    "dropname": "VILLA PARK",
    "dropdeladd": "1415 S ARDMORE AVE",
    "dropdelcty": "VILLA PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601814906,
    "dropphyadd": "1415 S ARDMORE AVE",
    "dropphycty": "VILLA PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601814906,
    "dropmaladd": "1415 S ARDMORE AVE",
    "dropmalcty": "VILLA PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601814906,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308341392,
    "dropsitcph": 6308341392,
    "dropfax": 6308348520
  },
  {
    "dcode": "D",
    "dropkey": "PW15383",
    "droptype": "D",
    "dropname": "VILLA RIDGE",
    "dropdeladd": "2926 OLD VILLA RIDGE RD",
    "dropdelcty": "VILLA RIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 629969998,
    "dropphyadd": "2926 OLD VILLA RIDGE RD",
    "dropphycty": "VILLA RIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 629969998,
    "dropmaladd": "2926 OLD VILLA RIDGE RD",
    "dropmalcty": "VILLA RIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 629969998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183426741,
    "dropsitcph": 6183426741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15384",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "1508 13TH ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "IL",
    "dropdelzpp": 614869800,
    "dropphyadd": "1508 13TH ST",
    "dropphycty": "VIOLA",
    "dropphyst": "IL",
    "dropphyzpp": 614869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIOLA",
    "dropmalst": "IL",
    "dropmalzpp": 614869998,
    "dropsitphn": 3095962707,
    "dropsitlph": 3095962707,
    "dropsitcph": 3095962707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15385",
    "droptype": "D",
    "dropname": "VIRDEN",
    "dropdeladd": "211 N SPRINGFIELD ST",
    "dropdelcty": "VIRDEN",
    "dropdelst": "IL",
    "dropdelzpp": 626909998,
    "dropphyadd": "211 N SPRINGFIELD ST",
    "dropphycty": "VIRDEN",
    "dropphyst": "IL",
    "dropphyzpp": 626909998,
    "dropmaladd": "211 N SPRINGFIELD ST",
    "dropmalcty": "VIRDEN",
    "dropmalst": "IL",
    "dropmalzpp": 626909998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2179653629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15387",
    "droptype": "D",
    "dropname": "VIRGINIA",
    "dropdeladd": "230 E BEARDSTOWN ST",
    "dropdelcty": "VIRGINIA",
    "dropdelst": "IL",
    "dropdelzpp": 626919998,
    "dropphyadd": "230 E BEARDSTOWN ST",
    "dropphycty": "VIRGINIA",
    "dropphyst": "IL",
    "dropphyzpp": 626919998,
    "dropmaladd": "230 E BEARDSTOWN ST",
    "dropmalcty": "VIRGINIA",
    "dropmalst": "IL",
    "dropmalzpp": 626919998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174523222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15406",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "39067 N CAROLINE AVE",
    "dropdelcty": "WADSWORTH",
    "dropdelst": "IL",
    "dropdelzpp": 600838931,
    "dropphyadd": "39067 N CAROLINE AVE",
    "dropphycty": "WADSWORTH",
    "dropphyst": "IL",
    "dropphyzpp": 600838931,
    "dropmaladd": "39067 N CAROLINE AVE",
    "dropmalcty": "WADSWORTH",
    "dropmalst": "IL",
    "dropmalzpp": 600838931,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476622678,
    "dropsitcph": 8476622678,
    "dropfax": 8476626697
  },
  {
    "dcode": "D",
    "dropkey": "PW15407",
    "droptype": "D",
    "dropname": "WAGGONER",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "WAGGONER",
    "dropdelst": "IL",
    "dropdelzpp": 625729998,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "WAGGONER",
    "dropphyst": "IL",
    "dropphyzpp": 625729998,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "WAGGONER",
    "dropmalst": "IL",
    "dropmalzpp": 625729998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2172273623,
    "dropfax": 2172273675
  },
  {
    "dcode": "D",
    "dropkey": "PW15412",
    "droptype": "D",
    "dropname": "WALNUT",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "WALNUT",
    "dropdelst": "IL",
    "dropdelzpp": 613769702,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "WALNUT",
    "dropphyst": "IL",
    "dropphyzpp": 613769702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALNUT",
    "dropmalst": "IL",
    "dropmalzpp": 613769998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8153792111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15415",
    "droptype": "D",
    "dropname": "WALNUT HILL",
    "dropdeladd": "61 HARRISON ST",
    "dropdelcty": "WALNUT HILL",
    "dropdelst": "IL",
    "dropdelzpp": 628939998,
    "dropphyadd": "61 HARRISON ST",
    "dropphycty": "WALNUT HILL",
    "dropphyst": "IL",
    "dropphyzpp": 628939998,
    "dropmaladd": "61 HARRISON ST",
    "dropmalcty": "WALNUT HILL",
    "dropmalst": "IL",
    "dropmalzpp": 628939998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185321387,
    "dropsitcph": 6185321387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15419",
    "droptype": "D",
    "dropname": "WALSH",
    "dropdeladd": "8000 SCHULINE RD",
    "dropdelcty": "WALSH",
    "dropdelst": "IL",
    "dropdelzpp": 622979998,
    "dropphyadd": "8000 SCHULINE RD",
    "dropphycty": "WALSH",
    "dropphyst": "IL",
    "dropphyzpp": 622979998,
    "dropmaladd": "8000 SCHULINE RD",
    "dropmalcty": "WALSH",
    "dropmalst": "IL",
    "dropmalzpp": 622979998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188534400,
    "dropsitcph": 6188534400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15424",
    "droptype": "D",
    "dropname": "WALTONVILLE",
    "dropdeladd": "504 E MAIN ST",
    "dropdelcty": "WALTONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 628949997,
    "dropphyadd": "504 E MAIN ST",
    "dropphycty": "WALTONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 628949997,
    "dropmaladd": "504 E MAIN ST",
    "dropmalcty": "WALTONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 628949997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182797224,
    "dropsitcph": 6182797224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15429",
    "droptype": "D",
    "dropname": "WAPELLA",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "WAPELLA",
    "dropdelst": "IL",
    "dropdelzpp": 617779900,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "WAPELLA",
    "dropphyst": "IL",
    "dropphyzpp": 617779900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAPELLA",
    "dropmalst": "IL",
    "dropmalzpp": 617779998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179353423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15433",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "WARREN",
    "dropdelst": "IL",
    "dropdelzpp": 610879382,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "WARREN",
    "dropphyst": "IL",
    "dropphyzpp": 610879382,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "WARREN",
    "dropmalst": "IL",
    "dropmalzpp": 610879382,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157452139,
    "dropsitcph": 8157452139,
    "dropfax": 8157453806
  },
  {
    "dcode": "D",
    "dropkey": "PW15434",
    "droptype": "D",
    "dropname": "WARRENSBURG",
    "dropdeladd": "164 N MAIN ST",
    "dropdelcty": "WARRENSBURG",
    "dropdelst": "IL",
    "dropdelzpp": 625739998,
    "dropphyadd": "164 N MAIN ST",
    "dropphycty": "WARRENSBURG",
    "dropphyst": "IL",
    "dropphyzpp": 625739998,
    "dropmaladd": "164 N MAIN ST",
    "dropmalcty": "WARRENSBURG",
    "dropmalst": "IL",
    "dropmalzpp": 625739998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176723516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15435",
    "droptype": "D",
    "dropname": "WARRENVILLE",
    "dropdeladd": "3S101 ROCKWELL ST",
    "dropdelcty": "WARRENVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605559998,
    "dropphyadd": "3S101 ROCKWELL ST",
    "dropphycty": "WARRENVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605559998,
    "dropmaladd": "3S101 ROCKWELL ST",
    "dropmalcty": "WARRENVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6303931109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15438",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "520 MAIN ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "IL",
    "dropdelzpp": 623799998,
    "dropphyadd": "520 MAIN ST",
    "dropphycty": "WARSAW",
    "dropphyst": "IL",
    "dropphyzpp": 623799998,
    "dropmaladd": "520 MAIN ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "IL",
    "dropmalzpp": 623799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172563112,
    "dropsitcph": 2172563112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15441",
    "droptype": "D",
    "dropname": "WASCO",
    "dropdeladd": "40W514 IL ROUTE 64",
    "dropdelcty": "WASCO",
    "dropdelst": "IL",
    "dropdelzpp": 601831000,
    "dropphyadd": "40W514 IL ROUTE 64",
    "dropphycty": "WASCO",
    "dropphyst": "IL",
    "dropphyzpp": 601831000,
    "dropmaladd": "40W514 IL ROUTE 64",
    "dropmalcty": "WASCO",
    "dropmalst": "IL",
    "dropmalzpp": 601831000,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305847299,
    "dropsitcph": 6305847299,
    "dropfax": 6305847415
  },
  {
    "dcode": "D",
    "dropkey": "PW15442",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "139 S JEFFERSON ST",
    "dropdelcty": "WASHBURN",
    "dropdelst": "IL",
    "dropdelzpp": 615707526,
    "dropphyadd": "139 S JEFFERSON ST",
    "dropphycty": "WASHBURN",
    "dropphyst": "IL",
    "dropphyzpp": 615707526,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHBURN",
    "dropmalst": "IL",
    "dropmalzpp": 615709998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3092487711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15445",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "106 S HIGH ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 615719998,
    "dropphyadd": "106 S HIGH ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 615719998,
    "dropmaladd": "106 S HIGH ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 615719998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3094444044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15450",
    "droptype": "D",
    "dropname": "WATAGA",
    "dropdeladd": "140 S MAIN ST",
    "dropdelcty": "WATAGA",
    "dropdelst": "IL",
    "dropdelzpp": 614889800,
    "dropphyadd": "140 S MAIN ST",
    "dropphycty": "WATAGA",
    "dropphyst": "IL",
    "dropphyzpp": 614889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATAGA",
    "dropmalst": "IL",
    "dropmalzpp": 614889998,
    "dropsitphn": 3093756612,
    "dropsitlph": 3093756612,
    "dropsitcph": 3093756612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15452",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "305 E 3RD ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "IL",
    "dropdelzpp": 622989998,
    "dropphyadd": "305 E 3RD ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "IL",
    "dropphyzpp": 622989998,
    "dropmaladd": "305 E 3RD ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "IL",
    "dropmalzpp": 622989998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189397317,
    "dropsitcph": 6189397317,
    "dropfax": 6189392992
  },
  {
    "dcode": "D",
    "dropkey": "PW15453",
    "droptype": "D",
    "dropname": "WATERMAN",
    "dropdeladd": "105 N ELM ST",
    "dropdelcty": "WATERMAN",
    "dropdelst": "IL",
    "dropdelzpp": 605569843,
    "dropphyadd": "105 N ELM ST",
    "dropphycty": "WATERMAN",
    "dropphyst": "IL",
    "dropphyzpp": 605569843,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERMAN",
    "dropmalst": "IL",
    "dropmalzpp": 605569998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8152643609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15455",
    "droptype": "D",
    "dropname": "WATSEKA",
    "dropdeladd": "101 W WALNUT ST",
    "dropdelcty": "WATSEKA",
    "dropdelst": "IL",
    "dropdelzpp": 609709800,
    "dropphyadd": "101 W WALNUT ST",
    "dropphycty": "WATSEKA",
    "dropphyst": "IL",
    "dropphyzpp": 609709800,
    "dropmaladd": "101 W WALNUT ST",
    "dropmalcty": "WATSEKA",
    "dropmalst": "IL",
    "dropmalzpp": 609709800,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 8154324628,
    "dropfax": 8154324634
  },
  {
    "dcode": "D",
    "dropkey": "PW15456",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "101 S MONROE ST",
    "dropdelcty": "WATSON",
    "dropdelst": "IL",
    "dropdelzpp": 624739998,
    "dropphyadd": "101 S MONROE ST",
    "dropphycty": "WATSON",
    "dropphyst": "IL",
    "dropphyzpp": 624739998,
    "dropmaladd": "101 S MONROE ST",
    "dropmalcty": "WATSON",
    "dropmalst": "IL",
    "dropmalzpp": 624739998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175366136,
    "dropsitcph": 2175366136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15457",
    "droptype": "D",
    "dropname": "WAUCONDA",
    "dropdeladd": "539 W LIBERTY ST",
    "dropdelcty": "WAUCONDA",
    "dropdelst": "IL",
    "dropdelzpp": 600842492,
    "dropphyadd": "539 W LIBERTY ST",
    "dropphycty": "WAUCONDA",
    "dropphyst": "IL",
    "dropphyzpp": 600842492,
    "dropmaladd": "539 W LIBERTY ST",
    "dropmalcty": "WAUCONDA",
    "dropmalst": "IL",
    "dropmalzpp": 600842492,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475267116,
    "dropsitcph": 8475267116,
    "dropfax": 8475264462
  },
  {
    "dcode": "D",
    "dropkey": "PW15458",
    "droptype": "D",
    "dropname": "WAUKEGAN",
    "dropdeladd": "326 N GENESEE ST",
    "dropdelcty": "WAUKEGAN",
    "dropdelst": "IL",
    "dropdelzpp": 600854257,
    "dropphyadd": "326 N GENESEE ST",
    "dropphycty": "WAUKEGAN",
    "dropphyst": "IL",
    "dropphyzpp": 600854257,
    "dropmaladd": "326 N GENESEE ST",
    "dropmalcty": "WAUKEGAN",
    "dropmalst": "IL",
    "dropmalzpp": 600854257,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476626802,
    "dropsitcph": 8476626802,
    "dropfax": 8473362754
  },
  {
    "dcode": "D",
    "dropkey": "PW15459",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "109 N PEARL ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "IL",
    "dropdelzpp": 626929998,
    "dropphyadd": "109 N PEARL ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "IL",
    "dropphyzpp": 626929998,
    "dropmaladd": "109 N PEARL ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "IL",
    "dropmalzpp": 626929998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2174355201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15460",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "5N431 RAILROAD ST UNIT 1",
    "dropdelcty": "WAYNE",
    "dropdelst": "IL",
    "dropdelzpp": 601849802,
    "dropphyadd": "5N431 RAILROAD ST UNIT 1",
    "dropphycty": "WAYNE",
    "dropphyst": "IL",
    "dropphyzpp": 601849802,
    "dropmaladd": "5N431 RAILROAD ST UNIT 1",
    "dropmalcty": "WAYNE",
    "dropmalst": "IL",
    "dropmalzpp": 601849802,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305843411,
    "dropsitcph": 6305843411,
    "dropfax": 6305844898
  },
  {
    "dcode": "D",
    "dropkey": "PW15461",
    "droptype": "D",
    "dropname": "WAYNE CITY",
    "dropdeladd": "305 S MAIN ST",
    "dropdelcty": "WAYNE CITY",
    "dropdelst": "IL",
    "dropdelzpp": 628959998,
    "dropphyadd": "305 S MAIN ST",
    "dropphycty": "WAYNE CITY",
    "dropphyst": "IL",
    "dropphyzpp": 628959998,
    "dropmaladd": "305 S MAIN ST",
    "dropmalcty": "WAYNE CITY",
    "dropmalst": "IL",
    "dropmalzpp": 628959998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188952212,
    "dropsitcph": 6188952212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15464",
    "droptype": "D",
    "dropname": "WAYNESVILLE",
    "dropdeladd": "108 S ISHAM ST",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 617789900,
    "dropphyadd": "108 S ISHAM ST",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 617789900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 617789998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 2179494141,
    "dropfax": 2179495009
  },
  {
    "dcode": "D",
    "dropkey": "PW15469",
    "droptype": "D",
    "dropname": "WEDRON",
    "dropdeladd": "3465 E 2056TH RD",
    "dropdelcty": "WEDRON",
    "dropdelst": "IL",
    "dropdelzpp": 605579902,
    "dropphyadd": "3465 E 2056TH RD",
    "dropphycty": "WEDRON",
    "dropphyst": "IL",
    "dropphyzpp": 605579902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEDRON",
    "dropmalst": "IL",
    "dropmalzpp": 605579998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154962837,
    "dropfax": 8154962837
  },
  {
    "dcode": "D",
    "dropkey": "PW15470",
    "droptype": "D",
    "dropname": "WELDON",
    "dropdeladd": "450 MAPLE ST",
    "dropdelcty": "WELDON",
    "dropdelst": "IL",
    "dropdelzpp": 618829998,
    "dropphyadd": "450 MAPLE ST",
    "dropphycty": "WELDON",
    "dropphyst": "IL",
    "dropphyzpp": 618829998,
    "dropmaladd": "450 MAPLE ST",
    "dropmalcty": "WELDON",
    "dropmalst": "IL",
    "dropmalzpp": 618829998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177362212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15474",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "311 E MAIN ST",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 609739998,
    "dropphyadd": "311 E MAIN ST",
    "dropphycty": "WELLINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 609739998,
    "dropmaladd": "311 E MAIN ST",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 609739998,
    "dropsitphn": 2172836321,
    "dropsitlph": 7085635789,
    "dropsitcph": 8159843521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15477",
    "droptype": "D",
    "dropname": "WENONA",
    "dropdeladd": "212 N CHESTNUT ST",
    "dropdelcty": "WENONA",
    "dropdelst": "IL",
    "dropdelzpp": 613779743,
    "dropphyadd": "212 N CHESTNUT ST",
    "dropphycty": "WENONA",
    "dropphyst": "IL",
    "dropphyzpp": 613779743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WENONA",
    "dropmalst": "IL",
    "dropmalzpp": 613779998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8158534707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15481",
    "droptype": "D",
    "dropname": "WEST BROOKLYN",
    "dropdeladd": "2521 JOHNSON ST",
    "dropdelcty": "WEST BROOKLYN",
    "dropdelst": "IL",
    "dropdelzpp": 613789703,
    "dropphyadd": "2521 JOHNSON ST",
    "dropphycty": "WEST BROOKLYN",
    "dropphyst": "IL",
    "dropphyzpp": 613789703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST BROOKLYN",
    "dropmalst": "IL",
    "dropmalzpp": 613789998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156283101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15482",
    "droptype": "D",
    "dropname": "WEST CHICAGO",
    "dropdeladd": "1130 W WASHINGTON ST",
    "dropdelcty": "WEST CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 601852622,
    "dropphyadd": "1130 W WASHINGTON ST",
    "dropphycty": "WEST CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 601852622,
    "dropmaladd": "1130 W WASHINGTON ST",
    "dropmalcty": "WEST CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 601852622,
    "dropsitphn": 6302605499,
    "dropsitlph": 6302312020,
    "dropsitcph": 6302312020,
    "dropfax": 3314650713
  },
  {
    "dcode": "D",
    "dropkey": "PW15486",
    "droptype": "D",
    "dropname": "WEST FRANKFORT",
    "dropdeladd": "219 E MAIN ST",
    "dropdelcty": "WEST FRANKFORT",
    "dropdelst": "IL",
    "dropdelzpp": 628969998,
    "dropphyadd": "219 E MAIN ST",
    "dropphycty": "WEST FRANKFORT",
    "dropphyst": "IL",
    "dropphyzpp": 628969998,
    "dropmaladd": "219 E MAIN ST",
    "dropmalcty": "WEST FRANKFORT",
    "dropmalst": "IL",
    "dropmalzpp": 628969998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6189374161,
    "dropsitcph": 6189374161,
    "dropfax": 6513066137
  },
  {
    "dcode": "D",
    "dropkey": "PW15490",
    "droptype": "D",
    "dropname": "WEST LIBERTY",
    "dropdeladd": "107 N SILVER ST",
    "dropdelcty": "WEST LIBERTY",
    "dropdelst": "IL",
    "dropdelzpp": 624759998,
    "dropphyadd": "107 N SILVER ST",
    "dropphycty": "WEST LIBERTY",
    "dropphyst": "IL",
    "dropphyzpp": 624759998,
    "dropmaladd": "107 N SILVER ST",
    "dropmalcty": "WEST LIBERTY",
    "dropmalst": "IL",
    "dropmalzpp": 624759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187543650,
    "dropsitcph": 6187543650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15494",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "100 E CENTER ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "IL",
    "dropdelzpp": 623809998,
    "dropphyadd": "100 E CENTER ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "IL",
    "dropphyzpp": 623809998,
    "dropmaladd": "100 E CENTER ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "IL",
    "dropmalzpp": 623809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2177435506,
    "dropsitcph": 2177435506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15495",
    "droptype": "D",
    "dropname": "WEST SALEM",
    "dropdeladd": "115 E NORTH ST",
    "dropdelcty": "WEST SALEM",
    "dropdelst": "IL",
    "dropdelzpp": 624769998,
    "dropphyadd": "115 E NORTH ST",
    "dropphycty": "WEST SALEM",
    "dropphyst": "IL",
    "dropphyzpp": 624769998,
    "dropmaladd": "115 E NORTH ST",
    "dropmalcty": "WEST SALEM",
    "dropmalst": "IL",
    "dropmalzpp": 624769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184563461,
    "dropsitcph": 6184563461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15496",
    "droptype": "D",
    "dropname": "WEST UNION",
    "dropdeladd": "211 W UNION ST",
    "dropdelcty": "WEST UNION",
    "dropdelst": "IL",
    "dropdelzpp": 624779998,
    "dropphyadd": "211 W UNION ST",
    "dropphycty": "WEST UNION",
    "dropphyst": "IL",
    "dropphyzpp": 624779998,
    "dropmaladd": "211 W UNION ST",
    "dropmalcty": "WEST UNION",
    "dropmalst": "IL",
    "dropmalzpp": 624779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172793310,
    "dropsitcph": 2172793310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15497",
    "droptype": "D",
    "dropname": "WEST YORK",
    "dropdeladd": "21962 N 1470TH ST",
    "dropdelcty": "WEST YORK",
    "dropdelst": "IL",
    "dropdelzpp": 624789998,
    "dropphyadd": "21962 N 1470TH ST",
    "dropphycty": "WEST YORK",
    "dropphyst": "IL",
    "dropphyzpp": 624789998,
    "dropmaladd": "21962 N 1470TH ST",
    "dropmalcty": "WEST YORK",
    "dropmalst": "IL",
    "dropmalzpp": 624789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185634331,
    "dropsitcph": 6185634331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15504",
    "droptype": "D",
    "dropname": "WESTERN SPRINGS",
    "dropdeladd": "4479 LAWN AVE",
    "dropdelcty": "WESTERN SPRINGS",
    "dropdelst": "IL",
    "dropdelzpp": 605589998,
    "dropphyadd": "4479 LAWN AVE",
    "dropphycty": "WESTERN SPRINGS",
    "dropphyst": "IL",
    "dropphyzpp": 605589998,
    "dropmaladd": "4479 LAWN AVE",
    "dropmalcty": "WESTERN SPRINGS",
    "dropmalst": "IL",
    "dropmalzpp": 605589998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 7082460807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15507",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "130 W STATE ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 624749998,
    "dropphyadd": "130 W STATE ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 624749998,
    "dropmaladd": "130 W STATE ST",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 624749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179675205,
    "dropsitcph": 2179675205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15509",
    "droptype": "D",
    "dropname": "WESTMONT",
    "dropdeladd": "5707 S CASS AVE",
    "dropdelcty": "WESTMONT",
    "dropdelst": "IL",
    "dropdelzpp": 605599998,
    "dropphyadd": "5707 S CASS AVE",
    "dropphycty": "WESTMONT",
    "dropphyst": "IL",
    "dropphyzpp": 605599998,
    "dropmaladd": "5707 S CASS AVE",
    "dropmalcty": "WESTMONT",
    "dropmalst": "IL",
    "dropmalzpp": 605599998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6309680855,
    "dropfax": 3312512065
  },
  {
    "dcode": "D",
    "dropkey": "PW15514",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "300 S STATE ST",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 618839998,
    "dropphyadd": "300 S STATE ST",
    "dropphycty": "WESTVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 618839998,
    "dropmaladd": "300 S STATE ST",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 618839998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2172677072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15518",
    "droptype": "D",
    "dropname": "WHEATON",
    "dropdeladd": "122 N WHEATON AVE",
    "dropdelcty": "WHEATON",
    "dropdelst": "IL",
    "dropdelzpp": 601879998,
    "dropphyadd": "122 N WHEATON AVE",
    "dropphycty": "WHEATON",
    "dropphyst": "IL",
    "dropphyzpp": 601879998,
    "dropmaladd": "122 N WHEATON AVE",
    "dropmalcty": "WHEATON",
    "dropmalst": "IL",
    "dropmalzpp": 601879998,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306683530,
    "dropsitcph": 6306683530,
    "dropfax": 6305972617
  },
  {
    "dcode": "D",
    "dropkey": "PW15520",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "13244 N MAIN ST",
    "dropdelcty": "WHEELER",
    "dropdelst": "IL",
    "dropdelzpp": 624799998,
    "dropphyadd": "13244 N MAIN ST",
    "dropphycty": "WHEELER",
    "dropphyst": "IL",
    "dropphyzpp": 624799998,
    "dropmaladd": "13244 N MAIN ST",
    "dropmalcty": "WHEELER",
    "dropmalst": "IL",
    "dropmalzpp": 624799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2179255556,
    "dropsitcph": 2179255556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15521",
    "droptype": "D",
    "dropname": "WHEELING",
    "dropdeladd": "250 W DUNDEE RD",
    "dropdelcty": "WHEELING",
    "dropdelst": "IL",
    "dropdelzpp": 600904756,
    "dropphyadd": "250 W DUNDEE RD",
    "dropphycty": "WHEELING",
    "dropphyst": "IL",
    "dropphyzpp": 600904756,
    "dropmaladd": "250 W DUNDEE RD",
    "dropmalcty": "WHEELING",
    "dropmalst": "IL",
    "dropmalzpp": 600904756,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475371150,
    "dropsitcph": 8475371150,
    "dropfax": 8475370754
  },
  {
    "dcode": "D",
    "dropkey": "PW15524",
    "droptype": "D",
    "dropname": "WHITE HALL",
    "dropdeladd": "120 S JACKSONVILLE ST",
    "dropdelcty": "WHITE HALL",
    "dropdelst": "IL",
    "dropdelzpp": 620929998,
    "dropphyadd": "120 S JACKSONVILLE ST",
    "dropphycty": "WHITE HALL",
    "dropphyst": "IL",
    "dropphyzpp": 620929998,
    "dropmaladd": "120 S JACKSONVILLE ST",
    "dropmalcty": "WHITE HALL",
    "dropmalst": "IL",
    "dropmalzpp": 620929998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173742311,
    "dropsitcph": 2173742311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15525",
    "droptype": "D",
    "dropname": "WHITE HEATH",
    "dropdeladd": "215 E HIGH ST",
    "dropdelcty": "WHITE HEATH",
    "dropdelst": "IL",
    "dropdelzpp": 618849998,
    "dropphyadd": "215 E HIGH ST",
    "dropphycty": "WHITE HEATH",
    "dropphyst": "IL",
    "dropphyzpp": 618849998,
    "dropmaladd": "215 E HIGH ST",
    "dropmalcty": "WHITE HEATH",
    "dropmalst": "IL",
    "dropmalzpp": 618849998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2177627922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15529",
    "droptype": "D",
    "dropname": "WHITTINGTON",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "WHITTINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 628979997,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "WHITTINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 628979997,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "WHITTINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 628979997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186292486,
    "dropsitcph": 6186292486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15537",
    "droptype": "D",
    "dropname": "WILLIAMSFIELD",
    "dropdeladd": "107 E GALE ST",
    "dropdelcty": "WILLIAMSFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 614895407,
    "dropphyadd": "107 E GALE ST",
    "dropphycty": "WILLIAMSFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 614895407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 614899998,
    "dropsitphn": 3096394483,
    "dropsitlph": 3096394483,
    "dropsitcph": 3096394483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15539",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "WILLIAMSVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 626939998,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "WILLIAMSVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 626939998,
    "dropmaladd": "100 E MAIN ST",
    "dropmalcty": "WILLIAMSVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 626939998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2175663651,
    "dropfax": 2175662153
  },
  {
    "dcode": "D",
    "dropkey": "PW15540",
    "droptype": "D",
    "dropname": "WILLISVILLE",
    "dropdeladd": "808 BROADWAY ST",
    "dropdelcty": "WILLISVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 629979998,
    "dropphyadd": "808 BROADWAY ST",
    "dropphycty": "WILLISVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 629979998,
    "dropmaladd": "808 BROADWAY ST",
    "dropmalcty": "WILLISVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 629979998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184972818,
    "dropsitcph": 6184972818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15548",
    "droptype": "D",
    "dropname": "WILLOW HILL",
    "dropdeladd": "201 N CUMBERLAND ST",
    "dropdelcty": "WILLOW HILL",
    "dropdelst": "IL",
    "dropdelzpp": 624809998,
    "dropphyadd": "201 N CUMBERLAND ST",
    "dropphycty": "WILLOW HILL",
    "dropphyst": "IL",
    "dropphyzpp": 624809998,
    "dropmaladd": "201 N CUMBERLAND ST",
    "dropmalcty": "WILLOW HILL",
    "dropmalst": "IL",
    "dropmalzpp": 624809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184553577,
    "dropsitcph": 6184553577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15550",
    "droptype": "D",
    "dropname": "WILLOW SPRINGS",
    "dropdeladd": "8448 ARCHER AVE STE 1",
    "dropdelcty": "WILLOW SPRINGS",
    "dropdelst": "IL",
    "dropdelzpp": 604809998,
    "dropphyadd": "8448 ARCHER AVE STE 1",
    "dropphycty": "WILLOW SPRINGS",
    "dropphyst": "IL",
    "dropphyzpp": 604809998,
    "dropmaladd": "8448 ARCHER AVE STE 1",
    "dropmalcty": "WILLOW SPRINGS",
    "dropmalst": "IL",
    "dropmalzpp": 604809998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7088396949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15553",
    "droptype": "D",
    "dropname": "WILMETTE",
    "dropdeladd": "1241 CENTRAL AVE",
    "dropdelcty": "WILMETTE",
    "dropdelst": "IL",
    "dropdelzpp": 600912571,
    "dropphyadd": "1241 CENTRAL AVE",
    "dropphycty": "WILMETTE",
    "dropphyst": "IL",
    "dropphyzpp": 600912571,
    "dropmaladd": "1241 CENTRAL AVE",
    "dropmalcty": "WILMETTE",
    "dropmalst": "IL",
    "dropmalzpp": 600912571,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472516039,
    "dropsitcph": 8472516039,
    "dropfax": 8472518294
  },
  {
    "dcode": "D",
    "dropkey": "PW15555",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "301 N WATER ST",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 604819998,
    "dropphyadd": "301 N WATER ST",
    "dropphycty": "WILMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 604819998,
    "dropmaladd": "301 N WATER ST",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 604819998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8154769052,
    "dropfax": 8154767965
  },
  {
    "dcode": "D",
    "dropkey": "PW15556",
    "droptype": "D",
    "dropname": "WILSONVILLE",
    "dropdeladd": "510 DEAN ST",
    "dropdelcty": "WILSONVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 620939998,
    "dropphyadd": "510 DEAN ST",
    "dropphycty": "WILSONVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 620939998,
    "dropmaladd": "510 DEAN ST",
    "dropmalcty": "WILSONVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 620939998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2178352963,
    "dropsitcph": 2178352963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15558",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "55 S MAIN ST",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "IL",
    "dropdelzpp": 626949998,
    "dropphyadd": "55 S MAIN ST",
    "dropphycty": "WINCHESTER",
    "dropphyst": "IL",
    "dropphyzpp": 626949998,
    "dropmaladd": "55 S MAIN ST",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "IL",
    "dropmalzpp": 626949998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2177423857,
    "dropfax": 2177423868
  },
  {
    "dcode": "D",
    "dropkey": "PW15559",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "1105 MAINE ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "IL",
    "dropdelzpp": 619579998,
    "dropphyadd": "1105 MAINE ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "IL",
    "dropphyzpp": 619579998,
    "dropmaladd": "1105 MAINE ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "IL",
    "dropmalzpp": 619579998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2174592540,
    "dropfax": 2174592420
  },
  {
    "dcode": "D",
    "dropkey": "PW15563",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "27W525 HIGH LAKE RD",
    "dropdelcty": "WINFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 601901290,
    "dropphyadd": "27W525 HIGH LAKE RD",
    "dropphycty": "WINFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 601901290,
    "dropmaladd": "27W525 HIGH LAKE RD",
    "dropmalcty": "WINFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 601901290,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306652977,
    "dropsitcph": 6306652977,
    "dropfax": 6306684096
  },
  {
    "dcode": "D",
    "dropkey": "PW15567",
    "droptype": "D",
    "dropname": "WINNEBAGO",
    "dropdeladd": "105 LANDMARK DR",
    "dropdelcty": "WINNEBAGO",
    "dropdelst": "IL",
    "dropdelzpp": 610888591,
    "dropphyadd": "105 LANDMARK DR",
    "dropphycty": "WINNEBAGO",
    "dropphyst": "IL",
    "dropphyzpp": 610888591,
    "dropmaladd": "105 LANDMARK DR",
    "dropmalcty": "WINNEBAGO",
    "dropmalst": "IL",
    "dropmalzpp": 610888591,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153351179,
    "dropsitcph": 8153351179,
    "dropfax": 8153353024
  },
  {
    "dcode": "D",
    "dropkey": "PW15569",
    "droptype": "D",
    "dropname": "WINNETKA",
    "dropdeladd": "512 CHESTNUT ST",
    "dropdelcty": "WINNETKA",
    "dropdelst": "IL",
    "dropdelzpp": 600932400,
    "dropphyadd": "512 CHESTNUT ST",
    "dropphycty": "WINNETKA",
    "dropphyst": "IL",
    "dropphyzpp": 600932400,
    "dropmaladd": "512 CHESTNUT ST",
    "dropmalcty": "WINNETKA",
    "dropmalst": "IL",
    "dropmalzpp": 600932400,
    "dropsitphn": 6302605499,
    "dropsitlph": 8474461721,
    "dropsitcph": 8474461721,
    "dropfax": 8474466701
  },
  {
    "dcode": "D",
    "dropkey": "PW15570",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "200 CARVER ST",
    "dropdelcty": "WINSLOW",
    "dropdelst": "IL",
    "dropdelzpp": 610899488,
    "dropphyadd": "200 CARVER ST",
    "dropphycty": "WINSLOW",
    "dropphyst": "IL",
    "dropphyzpp": 610899488,
    "dropmaladd": "200 CARVER ST",
    "dropmalcty": "WINSLOW",
    "dropmalst": "IL",
    "dropmalzpp": 610899488,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153673601,
    "dropsitcph": 8153673601,
    "dropfax": 8153672901
  },
  {
    "dcode": "D",
    "dropkey": "PW15571",
    "droptype": "D",
    "dropname": "WINTHROP HARBOR",
    "dropdeladd": "1225 SHERIDAN RD STE F",
    "dropdelcty": "WINTHROP HARBOR",
    "dropdelst": "IL",
    "dropdelzpp": 600961870,
    "dropphyadd": "1225 SHERIDAN RD STE F",
    "dropphycty": "WINTHROP HARBOR",
    "dropphyst": "IL",
    "dropphyzpp": 600961870,
    "dropmaladd": "1225 SHERIDAN RD STE F",
    "dropmalcty": "WINTHROP HARBOR",
    "dropmalst": "IL",
    "dropmalzpp": 600961870,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477318215,
    "dropsitcph": 8477318215,
    "dropfax": 8477318826
  },
  {
    "dcode": "D",
    "dropkey": "PW15574",
    "droptype": "D",
    "dropname": "WITT",
    "dropdeladd": "35 W BROADWAY",
    "dropdelcty": "WITT",
    "dropdelst": "IL",
    "dropdelzpp": 620949998,
    "dropphyadd": "35 W BROADWAY",
    "dropphycty": "WITT",
    "dropphyst": "IL",
    "dropphyzpp": 620949998,
    "dropmaladd": "35 W BROADWAY",
    "dropmalcty": "WITT",
    "dropmalst": "IL",
    "dropmalzpp": 620949998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2175947722,
    "dropsitcph": 2175947722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15576",
    "droptype": "D",
    "dropname": "WOLF LAKE",
    "dropdeladd": "4675 N STATE ROUTE 3",
    "dropdelcty": "WOLF LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 629989998,
    "dropphyadd": "4675 N STATE ROUTE 3",
    "dropphycty": "WOLF LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 629989998,
    "dropmaladd": "4675 N STATE ROUTE 3",
    "dropmalcty": "WOLF LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 629989998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188338223,
    "dropsitcph": 6188338223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15579",
    "droptype": "D",
    "dropname": "WONDER LAKE",
    "dropdeladd": "3710 E WONDER LAKE RD",
    "dropdelcty": "WONDER LAKE",
    "dropdelst": "IL",
    "dropdelzpp": 600979800,
    "dropphyadd": "3710 E WONDER LAKE RD",
    "dropphycty": "WONDER LAKE",
    "dropphyst": "IL",
    "dropphyzpp": 600979800,
    "dropmaladd": "3710 E WONDER LAKE RD",
    "dropmalcty": "WONDER LAKE",
    "dropmalst": "IL",
    "dropmalzpp": 600979800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8156537771,
    "dropsitcph": 8156537771,
    "dropfax": 8476536311
  },
  {
    "dcode": "D",
    "dropkey": "PW15581",
    "droptype": "D",
    "dropname": "WOOD DALE",
    "dropdeladd": "270 N WOOD DALE RD",
    "dropdelcty": "WOOD DALE",
    "dropdelst": "IL",
    "dropdelzpp": 601912094,
    "dropphyadd": "270 N WOOD DALE RD",
    "dropphycty": "WOOD DALE",
    "dropphyst": "IL",
    "dropphyzpp": 601912094,
    "dropmaladd": "270 N WOOD DALE RD",
    "dropmalcty": "WOOD DALE",
    "dropmalst": "IL",
    "dropmalzpp": 601912094,
    "dropsitphn": 6302605499,
    "dropsitlph": 6307660504,
    "dropsitcph": 6307660504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15586",
    "droptype": "D",
    "dropname": "WOOD RIVER",
    "dropdeladd": "161 E FERGUSON AVE",
    "dropdelcty": "WOOD RIVER",
    "dropdelst": "IL",
    "dropdelzpp": 620959998,
    "dropphyadd": "161 E FERGUSON AVE",
    "dropphycty": "WOOD RIVER",
    "dropphyst": "IL",
    "dropphyzpp": 620959998,
    "dropmaladd": "161 E FERGUSON AVE",
    "dropmalcty": "WOOD RIVER",
    "dropmalst": "IL",
    "dropmalzpp": 620959998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182546422,
    "dropsitcph": 6182546422,
    "dropfax": 6182546424
  },
  {
    "dcode": "D",
    "dropkey": "PW15597",
    "droptype": "D",
    "dropname": "WOODHULL",
    "dropdeladd": "212 N DIVISION ST",
    "dropdelcty": "WOODHULL",
    "dropdelst": "IL",
    "dropdelzpp": 614909800,
    "dropphyadd": "212 N DIVISION ST",
    "dropphycty": "WOODHULL",
    "dropphyst": "IL",
    "dropphyzpp": 614909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODHULL",
    "dropmalst": "IL",
    "dropmalzpp": 614909998,
    "dropsitphn": 3093342301,
    "dropsitlph": 3093342301,
    "dropsitcph": 3093342301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15598",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "102 S WEST AVE",
    "dropdelcty": "WOODLAND",
    "dropdelst": "IL",
    "dropdelzpp": 609749997,
    "dropphyadd": "102 S WEST AVE",
    "dropphycty": "WOODLAND",
    "dropphyst": "IL",
    "dropphyzpp": 609749997,
    "dropmaladd": "102 S WEST AVE",
    "dropmalcty": "WOODLAND",
    "dropmalst": "IL",
    "dropmalzpp": 609749997,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8154734301,
    "dropfax": 8154734301
  },
  {
    "dcode": "D",
    "dropkey": "PW15601",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "606 N MAIN ST",
    "dropdelcty": "WOODLAWN",
    "dropdelst": "IL",
    "dropdelzpp": 628989998,
    "dropphyadd": "606 N MAIN ST",
    "dropphycty": "WOODLAWN",
    "dropphyst": "IL",
    "dropphyzpp": 628989998,
    "dropmaladd": "606 N MAIN ST",
    "dropmalcty": "WOODLAWN",
    "dropmalst": "IL",
    "dropmalzpp": 628989998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187352044,
    "dropsitcph": 6187352044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15604",
    "droptype": "D",
    "dropname": "WOODSON",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "WOODSON",
    "dropdelst": "IL",
    "dropdelzpp": 626959998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "WOODSON",
    "dropphyst": "IL",
    "dropphyzpp": 626959998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "WOODSON",
    "dropmalst": "IL",
    "dropmalzpp": 626959998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2177887251,
    "dropsitcph": 2176735221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15606",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "1050 COUNTRY CLUB RD",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "IL",
    "dropdelzpp": 600986402,
    "dropphyadd": "1050 COUNTRY CLUB RD",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "IL",
    "dropphyzpp": 600986402,
    "dropmaladd": "1050 COUNTRY CLUB RD",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "IL",
    "dropmalzpp": 600986402,
    "dropsitphn": 6302605499,
    "dropsitlph": 8153381094,
    "dropsitcph": 8153381094,
    "dropfax": 8153385898
  },
  {
    "dcode": "D",
    "dropkey": "PW15609",
    "droptype": "D",
    "dropname": "WOOSUNG",
    "dropdeladd": "604 GRISWOLD ST",
    "dropdelcty": "WOOSUNG",
    "dropdelst": "IL",
    "dropdelzpp": 610919800,
    "dropphyadd": "604 GRISWOLD ST",
    "dropphycty": "WOOSUNG",
    "dropphyst": "IL",
    "dropphyzpp": 610919800,
    "dropmaladd": "604 GRISWOLD ST",
    "dropmalcty": "WOOSUNG",
    "dropmalst": "IL",
    "dropmalzpp": 610919800,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152843303,
    "dropsitcph": 8152843303,
    "dropfax": 8152840304
  },
  {
    "dcode": "D",
    "dropkey": "PW15610",
    "droptype": "D",
    "dropname": "WORDEN",
    "dropdeladd": "101 E WALL ST",
    "dropdelcty": "WORDEN",
    "dropdelst": "IL",
    "dropdelzpp": 620979998,
    "dropphyadd": "101 E WALL ST",
    "dropphycty": "WORDEN",
    "dropphyst": "IL",
    "dropphyzpp": 620979998,
    "dropmaladd": "101 E WALL ST",
    "dropmalcty": "WORDEN",
    "dropmalst": "IL",
    "dropmalzpp": 620979998,
    "dropsitphn": 6184593600,
    "dropsitlph": 6182785097,
    "dropsitcph": 6182785120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15614",
    "droptype": "D",
    "dropname": "WORTH",
    "dropdeladd": "11114 S HARLEM AVE",
    "dropdelcty": "WORTH",
    "dropdelst": "IL",
    "dropdelzpp": 604829998,
    "dropphyadd": "11114 S HARLEM AVE",
    "dropphycty": "WORTH",
    "dropphyst": "IL",
    "dropphyzpp": 604829998,
    "dropmaladd": "11114 S HARLEM AVE",
    "dropmalcty": "WORTH",
    "dropmalst": "IL",
    "dropmalzpp": 604829998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7083614787,
    "dropfax": 7083614810
  },
  {
    "dcode": "D",
    "dropkey": "PW15615",
    "droptype": "D",
    "dropname": "WRIGHTS",
    "dropdeladd": "744 DEWITT ST",
    "dropdelcty": "WRIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 620989998,
    "dropphyadd": "744 DEWITT ST",
    "dropphycty": "WRIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 620989998,
    "dropmaladd": "744 DEWITT ST",
    "dropmalcty": "WRIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 620989998,
    "dropsitphn": 3148959275,
    "dropsitlph": 2173682402,
    "dropsitcph": 2173682402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15621",
    "droptype": "D",
    "dropname": "WYANET",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "WYANET",
    "dropdelst": "IL",
    "dropdelzpp": 613799700,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "WYANET",
    "dropphyst": "IL",
    "dropphyzpp": 613799700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYANET",
    "dropmalst": "IL",
    "dropmalzpp": 613799998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 8156992481,
    "dropfax": 8156992481
  },
  {
    "dcode": "D",
    "dropkey": "PW15623",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "101 E WILLIAMS ST",
    "dropdelcty": "WYOMING",
    "dropdelst": "IL",
    "dropdelzpp": 614911509,
    "dropphyadd": "101 E WILLIAMS ST",
    "dropphycty": "WYOMING",
    "dropphyst": "IL",
    "dropphyzpp": 614911509,
    "dropmaladd": "101 E WILLIAMS ST",
    "dropmalcty": "WYOMING",
    "dropmalst": "IL",
    "dropmalzpp": 614911509,
    "dropsitphn": 3096956181,
    "dropsitlph": 3096956181,
    "dropsitcph": 3096956181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15624",
    "droptype": "D",
    "dropname": "XENIA",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "XENIA",
    "dropdelst": "IL",
    "dropdelzpp": 628999998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "XENIA",
    "dropphyst": "IL",
    "dropphyzpp": 628999998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "XENIA",
    "dropmalst": "IL",
    "dropmalzpp": 628999998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6186782226,
    "dropsitcph": 6186782226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15625",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "200 S RANGE ST",
    "dropdelcty": "YALE",
    "dropdelst": "IL",
    "dropdelzpp": 624819998,
    "dropphyadd": "200 S RANGE ST",
    "dropphycty": "YALE",
    "dropphyst": "IL",
    "dropphyzpp": 624819998,
    "dropmaladd": "200 S RANGE ST",
    "dropmalcty": "YALE",
    "dropmalst": "IL",
    "dropmalzpp": 624819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6187932425,
    "dropsitcph": 6187932425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15628",
    "droptype": "D",
    "dropname": "YATES CITY",
    "dropdeladd": "109 W MAIN ST",
    "dropdelcty": "YATES CITY",
    "dropdelst": "IL",
    "dropdelzpp": 615727552,
    "dropphyadd": "109 W MAIN ST",
    "dropphycty": "YATES CITY",
    "dropphyst": "IL",
    "dropphyzpp": 615727552,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YATES CITY",
    "dropmalst": "IL",
    "dropmalzpp": 615729998,
    "dropsitphn": 3097428022,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093581666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15637",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "601 E COUNTRYSIDE PKWY",
    "dropdelcty": "YORKVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605609997,
    "dropphyadd": "601 E COUNTRYSIDE PKWY",
    "dropphycty": "YORKVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605609997,
    "dropmaladd": "601 E COUNTRYSIDE PKWY",
    "dropmalcty": "YORKVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605609997,
    "dropsitphn": 6305537100,
    "dropsitlph": 6309784440,
    "dropsitcph": 6305537100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15643",
    "droptype": "D",
    "dropname": "ZEIGLER",
    "dropdeladd": "2 CIRCLE ST",
    "dropdelcty": "ZEIGLER",
    "dropdelst": "IL",
    "dropdelzpp": 629999998,
    "dropphyadd": "2 CIRCLE ST",
    "dropphycty": "ZEIGLER",
    "dropphyst": "IL",
    "dropphyzpp": 629999998,
    "dropmaladd": "2 CIRCLE ST",
    "dropmalcty": "ZEIGLER",
    "dropmalst": "IL",
    "dropmalzpp": 629999998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185965761,
    "dropsitcph": 6185965761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15645",
    "droptype": "D",
    "dropname": "ZION",
    "dropdeladd": "1225 SHILOH BLVD",
    "dropdelcty": "ZION",
    "dropdelst": "IL",
    "dropdelzpp": 600992683,
    "dropphyadd": "1225 SHILOH BLVD",
    "dropphycty": "ZION",
    "dropphyst": "IL",
    "dropphyzpp": 600992683,
    "dropmaladd": "1225 SHILOH BLVD",
    "dropmalcty": "ZION",
    "dropmalst": "IL",
    "dropmalzpp": 600992683,
    "dropsitphn": 8478725917,
    "dropsitlph": 8478725917,
    "dropsitcph": 8478725917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15652",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "127 E MAIN ST",
    "dropdelcty": "ADRIAN",
    "dropdelst": "MO",
    "dropdelzpp": 647209998,
    "dropphyadd": "127 E MAIN ST",
    "dropphycty": "ADRIAN",
    "dropphyst": "MO",
    "dropphyzpp": 647209998,
    "dropmaladd": "127 E MAIN ST",
    "dropmalcty": "ADRIAN",
    "dropmalst": "MO",
    "dropmalzpp": 647209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162972210,
    "dropsitcph": 8162972210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15653",
    "droptype": "D",
    "dropname": "ADVANCE",
    "dropdeladd": "502 W GABRIEL ST",
    "dropdelcty": "ADVANCE",
    "dropdelst": "MO",
    "dropdelzpp": 637309998,
    "dropphyadd": "502 W GABRIEL ST",
    "dropphycty": "ADVANCE",
    "dropphyst": "MO",
    "dropphyzpp": 637309998,
    "dropmaladd": "502 W GABRIEL ST",
    "dropmalcty": "ADVANCE",
    "dropmalst": "MO",
    "dropmalzpp": 637309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737223552,
    "dropsitcph": 5737223552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15656",
    "droptype": "D",
    "dropname": "AGENCY",
    "dropdeladd": "10580 STATE ROUTE FF SE",
    "dropdelcty": "AGENCY",
    "dropdelst": "MO",
    "dropdelzpp": 644019998,
    "dropphyadd": "10580 STATE ROUTE FF SE",
    "dropphycty": "AGENCY",
    "dropphyst": "MO",
    "dropphyzpp": 644019998,
    "dropmaladd": "10580 STATE ROUTE FF SE",
    "dropmalcty": "AGENCY",
    "dropmalst": "MO",
    "dropmalzpp": 644019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162539255,
    "dropsitcph": 8162539255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15690",
    "droptype": "D",
    "dropname": "ALBA",
    "dropdeladd": "210 N MAIN ST",
    "dropdelcty": "ALBA",
    "dropdelst": "MO",
    "dropdelzpp": 648309998,
    "dropphyadd": "210 N MAIN ST",
    "dropphycty": "ALBA",
    "dropphyst": "MO",
    "dropphyzpp": 648309998,
    "dropmaladd": "210 N MAIN ST",
    "dropmalcty": "ALBA",
    "dropmalst": "MO",
    "dropmalzpp": 648309998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4175254513,
    "dropfax": 4175254513
  },
  {
    "dcode": "D",
    "dropkey": "PW15691",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "101 E CLAY ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "MO",
    "dropdelzpp": 644029998,
    "dropphyadd": "101 E CLAY ST",
    "dropphycty": "ALBANY",
    "dropphyst": "MO",
    "dropphyzpp": 644029998,
    "dropmaladd": "101 E CLAY ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "MO",
    "dropmalzpp": 644029998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607263113,
    "dropsitcph": 6607263113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15692",
    "droptype": "D",
    "dropname": "ALDRICH",
    "dropdeladd": "470 COMMERCIAL ST",
    "dropdelcty": "ALDRICH",
    "dropdelst": "MO",
    "dropdelzpp": 656019998,
    "dropphyadd": "470 COMMERCIAL ST",
    "dropphycty": "ALDRICH",
    "dropphyst": "MO",
    "dropphyzpp": 656019998,
    "dropmaladd": "470 COMMERCIAL ST",
    "dropmalcty": "ALDRICH",
    "dropmalst": "MO",
    "dropmalzpp": 656019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176942215,
    "dropsitcph": 4176942215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15693",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "303 MARKET ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "MO",
    "dropdelzpp": 634309998,
    "dropphyadd": "303 MARKET ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "MO",
    "dropphyzpp": 634309998,
    "dropmaladd": "303 MARKET ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "MO",
    "dropmalzpp": 634309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607546441,
    "dropsitcph": 6607546441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15697",
    "droptype": "D",
    "dropname": "ALLENDALE",
    "dropdeladd": "2108 MAIN ST",
    "dropdelcty": "ALLENDALE",
    "dropdelst": "MO",
    "dropdelzpp": 644209998,
    "dropphyadd": "2108 MAIN ST",
    "dropphycty": "ALLENDALE",
    "dropphyst": "MO",
    "dropphyzpp": 644209998,
    "dropmaladd": "2108 MAIN ST",
    "dropmalcty": "ALLENDALE",
    "dropmalst": "MO",
    "dropmalzpp": 644209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607862293,
    "dropsitcph": 6607862293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15703",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "200 S COUNTY RD",
    "dropdelcty": "ALMA",
    "dropdelst": "MO",
    "dropdelzpp": 640019998,
    "dropphyadd": "200 S COUNTY RD",
    "dropphycty": "ALMA",
    "dropphyst": "MO",
    "dropphyzpp": 640019998,
    "dropmaladd": "200 S COUNTY RD",
    "dropmalcty": "ALMA",
    "dropmalst": "MO",
    "dropmalzpp": 640019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606742310,
    "dropsitcph": 6606742310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15704",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "MO",
    "dropdelzpp": 646209998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "ALTAMONT",
    "dropphyst": "MO",
    "dropphyzpp": 646209998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "MO",
    "dropmalzpp": 646209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607495711,
    "dropsitcph": 6607495711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15705",
    "droptype": "D",
    "dropname": "ALTENBURG",
    "dropdeladd": "51 POPLAR ST",
    "dropdelcty": "ALTENBURG",
    "dropdelst": "MO",
    "dropdelzpp": 637329998,
    "dropphyadd": "51 POPLAR ST",
    "dropphycty": "ALTENBURG",
    "dropphyst": "MO",
    "dropphyzpp": 637329998,
    "dropmaladd": "51 POPLAR ST",
    "dropmalcty": "ALTENBURG",
    "dropmalst": "MO",
    "dropmalzpp": 637329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738245266,
    "dropsitcph": 5738245266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15707",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "198 MAIN ST",
    "dropdelcty": "ALTON",
    "dropdelst": "MO",
    "dropdelzpp": 656069998,
    "dropphyadd": "198 MAIN ST",
    "dropphycty": "ALTON",
    "dropphyst": "MO",
    "dropphyzpp": 656069998,
    "dropmaladd": "198 MAIN ST",
    "dropmalcty": "ALTON",
    "dropmalst": "MO",
    "dropmalzpp": 656069998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177787270,
    "dropsitcph": 4177787270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15708",
    "droptype": "D",
    "dropname": "AMAZONIA",
    "dropdeladd": "142 STATE ROUTE K",
    "dropdelcty": "AMAZONIA",
    "dropdelst": "MO",
    "dropdelzpp": 644219998,
    "dropphyadd": "142 STATE ROUTE K",
    "dropphycty": "AMAZONIA",
    "dropphyst": "MO",
    "dropphyzpp": 644219998,
    "dropmaladd": "142 STATE ROUTE K",
    "dropmalcty": "AMAZONIA",
    "dropmalst": "MO",
    "dropmalzpp": 644219998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164753821,
    "dropsitcph": 8164753821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15712",
    "droptype": "D",
    "dropname": "AMORET",
    "dropdeladd": "101 STATE ROUTE 52",
    "dropdelcty": "AMORET",
    "dropdelst": "MO",
    "dropdelzpp": 647229998,
    "dropphyadd": "101 STATE ROUTE 52",
    "dropphycty": "AMORET",
    "dropphyst": "MO",
    "dropphyzpp": 647229998,
    "dropmaladd": "101 STATE ROUTE 52",
    "dropmalcty": "AMORET",
    "dropmalst": "MO",
    "dropmalzpp": 647229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609253221,
    "dropsitcph": 6609253221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15713",
    "droptype": "D",
    "dropname": "AMSTERDAM",
    "dropdeladd": "13151 NW MAIN ST",
    "dropdelcty": "AMSTERDAM",
    "dropdelst": "MO",
    "dropdelzpp": 647239998,
    "dropphyadd": "13151 NW MAIN ST",
    "dropphycty": "AMSTERDAM",
    "dropphyst": "MO",
    "dropphyzpp": 647239998,
    "dropmaladd": "13151 NW MAIN ST",
    "dropmalcty": "AMSTERDAM",
    "dropmalst": "MO",
    "dropmalzpp": 647239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602673228,
    "dropsitcph": 6602673228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15715",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "MO",
    "dropdelzpp": 648319998,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "MO",
    "dropphyzpp": 648319998,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "MO",
    "dropmalzpp": 648319998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4178456113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15716",
    "droptype": "D",
    "dropname": "ANNADA",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "ANNADA",
    "dropdelst": "MO",
    "dropdelzpp": 633309800,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "ANNADA",
    "dropphyst": "MO",
    "dropphyzpp": 633309800,
    "dropmaladd": "306 MAIN ST",
    "dropmalcty": "ANNADA",
    "dropmalst": "MO",
    "dropmalzpp": 633309800,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738472297,
    "dropsitcph": 5738472297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15717",
    "droptype": "D",
    "dropname": "ANNAPOLIS",
    "dropdeladd": "303 E 2ND ST",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MO",
    "dropdelzpp": 636209998,
    "dropphyadd": "303 E 2ND ST",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MO",
    "dropphyzpp": 636209998,
    "dropmaladd": "303 E 2ND ST",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MO",
    "dropmalzpp": 636209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735984289,
    "dropsitcph": 5735984289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15718",
    "droptype": "D",
    "dropname": "ANNISTON",
    "dropdeladd": "100 HIGHWAY 75 N",
    "dropdelcty": "ANNISTON",
    "dropdelst": "MO",
    "dropdelzpp": 638209998,
    "dropphyadd": "100 HIGHWAY 75 N",
    "dropphycty": "ANNISTON",
    "dropphyst": "MO",
    "dropphyzpp": 638209998,
    "dropmaladd": "100 HIGHWAY 75 N",
    "dropmalcty": "ANNISTON",
    "dropmalst": "MO",
    "dropmalzpp": 638209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736492150,
    "dropsitcph": 5736492150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15728",
    "droptype": "D",
    "dropname": "APPLETON CITY",
    "dropdeladd": "119 W 4TH ST",
    "dropdelcty": "APPLETON CITY",
    "dropdelst": "MO",
    "dropdelzpp": 647249998,
    "dropphyadd": "119 W 4TH ST",
    "dropphycty": "APPLETON CITY",
    "dropphyst": "MO",
    "dropphyzpp": 647249998,
    "dropmaladd": "119 W 4TH ST",
    "dropmalcty": "APPLETON CITY",
    "dropmalst": "MO",
    "dropmalzpp": 647249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603749724,
    "dropsitcph": 6604765454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15734",
    "droptype": "D",
    "dropname": "ARBYRD",
    "dropdeladd": "104 NE FRISCO ST",
    "dropdelcty": "ARBYRD",
    "dropdelst": "MO",
    "dropdelzpp": 638219998,
    "dropphyadd": "104 NE FRISCO ST",
    "dropphycty": "ARBYRD",
    "dropphyst": "MO",
    "dropphyzpp": 638219998,
    "dropmaladd": "104 NE FRISCO ST",
    "dropmalcty": "ARBYRD",
    "dropmalst": "MO",
    "dropmalzpp": 638219998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736543903,
    "dropsitcph": 5736543903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15736",
    "droptype": "D",
    "dropname": "ARCHIE",
    "dropdeladd": "208 S MAIN ST",
    "dropdelcty": "ARCHIE",
    "dropdelst": "MO",
    "dropdelzpp": 647259998,
    "dropphyadd": "208 S MAIN ST",
    "dropphycty": "ARCHIE",
    "dropphyst": "MO",
    "dropphyzpp": 647259998,
    "dropmaladd": "208 S MAIN ST",
    "dropmalcty": "ARCHIE",
    "dropmalst": "MO",
    "dropmalzpp": 647259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162935593,
    "dropsitcph": 8162935593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15737",
    "droptype": "D",
    "dropname": "ARCOLA",
    "dropdeladd": "102 CHURCH ST",
    "dropdelcty": "ARCOLA",
    "dropdelst": "MO",
    "dropdelzpp": 656039998,
    "dropphyadd": "102 CHURCH ST",
    "dropphycty": "ARCOLA",
    "dropphyst": "MO",
    "dropphyzpp": 656039998,
    "dropmaladd": "102 CHURCH ST",
    "dropmalcty": "ARCOLA",
    "dropmalst": "MO",
    "dropmalzpp": 656039998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174243231,
    "dropsitcph": 4174243231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15739",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "3 2ND ST",
    "dropdelcty": "ARGYLE",
    "dropdelst": "MO",
    "dropdelzpp": 650019998,
    "dropphyadd": "3 2ND ST",
    "dropphycty": "ARGYLE",
    "dropphyst": "MO",
    "dropphyzpp": 650019998,
    "dropmaladd": "3 2ND ST",
    "dropmalcty": "ARGYLE",
    "dropmalst": "MO",
    "dropmalzpp": 650019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737286245,
    "dropsitcph": 5737286245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15740",
    "droptype": "D",
    "dropname": "ARMSTRONG",
    "dropdeladd": "104 S CENTRAL ST",
    "dropdelcty": "ARMSTRONG",
    "dropdelst": "MO",
    "dropdelzpp": 652309998,
    "dropphyadd": "104 S CENTRAL ST",
    "dropphycty": "ARMSTRONG",
    "dropphyst": "MO",
    "dropphyzpp": 652309998,
    "dropmaladd": "104 S CENTRAL ST",
    "dropmalcty": "ARMSTRONG",
    "dropmalst": "MO",
    "dropmalzpp": 652309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602732247,
    "dropsitcph": 6602732247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15741",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "2184 MICHIGAN AVE",
    "dropdelcty": "ARNOLD",
    "dropdelst": "MO",
    "dropdelzpp": 630109934,
    "dropphyadd": "2184 MICHIGAN AVE",
    "dropphycty": "ARNOLD",
    "dropphyst": "MO",
    "dropphyzpp": 630109934,
    "dropmaladd": "2184 MICHIGAN AVE",
    "dropmalcty": "ARNOLD",
    "dropmalst": "MO",
    "dropmalzpp": 630109934,
    "dropsitphn": 6366360608,
    "dropsitlph": 6365487069,
    "dropsitcph": 6362960608,
    "dropfax": 6362965260
  },
  {
    "dcode": "D",
    "dropkey": "PW15743",
    "droptype": "D",
    "dropname": "ARROW ROCK",
    "dropdeladd": "304 MAIN ST",
    "dropdelcty": "ARROW ROCK",
    "dropdelst": "MO",
    "dropdelzpp": 653209998,
    "dropphyadd": "304 MAIN ST",
    "dropphycty": "ARROW ROCK",
    "dropphyst": "MO",
    "dropphyzpp": 653209998,
    "dropmaladd": "304 MAIN ST",
    "dropmalcty": "ARROW ROCK",
    "dropmalst": "MO",
    "dropmalzpp": 653209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608373464,
    "dropsitcph": 6608373464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15744",
    "droptype": "D",
    "dropname": "ASBURY",
    "dropdeladd": "497 MAIN ST",
    "dropdelcty": "ASBURY",
    "dropdelst": "MO",
    "dropdelzpp": 648329998,
    "dropphyadd": "497 MAIN ST",
    "dropphycty": "ASBURY",
    "dropphyst": "MO",
    "dropphyzpp": 648329998,
    "dropmaladd": "497 MAIN ST",
    "dropmalcty": "ASBURY",
    "dropmalst": "MO",
    "dropmalzpp": 648329998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4176425800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15746",
    "droptype": "D",
    "dropname": "ASH GROVE",
    "dropdeladd": "102 N TOWER ST",
    "dropdelcty": "ASH GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 656049998,
    "dropphyadd": "102 N TOWER ST",
    "dropphycty": "ASH GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 656049998,
    "dropmaladd": "102 N TOWER ST",
    "dropmalcty": "ASH GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 656049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176722350,
    "dropsitcph": 4176722350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15750",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "131 E BROADWAY",
    "dropdelcty": "ASHLAND",
    "dropdelst": "MO",
    "dropdelzpp": 650109998,
    "dropphyadd": "131 E BROADWAY",
    "dropphycty": "ASHLAND",
    "dropphyst": "MO",
    "dropphyzpp": 650109998,
    "dropmaladd": "131 E BROADWAY",
    "dropmalcty": "ASHLAND",
    "dropmalst": "MO",
    "dropmalzpp": 650109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736572103,
    "dropsitcph": 5736572103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15754",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "MO",
    "dropdelzpp": 635309998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "MO",
    "dropphyzpp": 635309998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "MO",
    "dropmalzpp": 635309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602394484,
    "dropsitcph": 6602394484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15759",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "237 FERRY ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "MO",
    "dropdelzpp": 633329998,
    "dropphyadd": "237 FERRY ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "MO",
    "dropphyzpp": 633329998,
    "dropmaladd": "237 FERRY ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "MO",
    "dropmalzpp": 633329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362284888,
    "dropsitcph": 6362284888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15761",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "102 E OLIVE ST",
    "dropdelcty": "AURORA",
    "dropdelst": "MO",
    "dropdelzpp": 656059998,
    "dropphyadd": "102 E OLIVE ST",
    "dropphycty": "AURORA",
    "dropphyst": "MO",
    "dropphyzpp": 656059998,
    "dropmaladd": "102 E OLIVE ST",
    "dropmalcty": "AURORA",
    "dropmalst": "MO",
    "dropmalzpp": 656059998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176782370,
    "dropsitcph": 4176782370,
    "dropfax": 4176787350
  },
  {
    "dcode": "D",
    "dropkey": "PW15765",
    "droptype": "D",
    "dropname": "AUXVASSE",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "AUXVASSE",
    "dropdelst": "MO",
    "dropdelzpp": 652319998,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "AUXVASSE",
    "dropphyst": "MO",
    "dropphyzpp": 652319998,
    "dropmaladd": "207 S MAIN ST",
    "dropmalcty": "AUXVASSE",
    "dropmalst": "MO",
    "dropmalzpp": 652319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733862850,
    "dropsitcph": 5733862850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15766",
    "droptype": "D",
    "dropname": "AVA",
    "dropdeladd": "499 W WASHINGTON AVE",
    "dropdelcty": "AVA",
    "dropdelst": "MO",
    "dropdelzpp": 656089998,
    "dropphyadd": "499 W WASHINGTON AVE",
    "dropphycty": "AVA",
    "dropphyst": "MO",
    "dropphyzpp": 656089998,
    "dropmaladd": "499 W WASHINGTON AVE",
    "dropmalcty": "AVA",
    "dropmalst": "MO",
    "dropmalzpp": 656089998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176834412,
    "dropsitcph": 4176834412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15768",
    "droptype": "D",
    "dropname": "AVILLA",
    "dropdeladd": "205 GREENFIELD ST",
    "dropdelcty": "AVILLA",
    "dropdelst": "MO",
    "dropdelzpp": 648339998,
    "dropphyadd": "205 GREENFIELD ST",
    "dropphycty": "AVILLA",
    "dropphyst": "MO",
    "dropphyzpp": 648339998,
    "dropmaladd": "205 GREENFIELD ST",
    "dropmalcty": "AVILLA",
    "dropmalst": "MO",
    "dropmalzpp": 648339998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172465760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15779",
    "droptype": "D",
    "dropname": "BAKERSFIELD",
    "dropdeladd": "56 MAIN ST",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 656099998,
    "dropphyadd": "56 MAIN ST",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 656099998,
    "dropmaladd": "56 MAIN ST",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 656099998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172843263,
    "dropsitcph": 4172843263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15781",
    "droptype": "D",
    "dropname": "BALLWIN",
    "dropdeladd": "15455 MANCHESTER RD",
    "dropdelcty": "BALLWIN",
    "dropdelst": "MO",
    "dropdelzpp": 630119998,
    "dropphyadd": "15455 MANCHESTER RD",
    "dropphycty": "BALLWIN",
    "dropphyst": "MO",
    "dropphyzpp": 630119998,
    "dropmaladd": "15455 MANCHESTER RD",
    "dropmalcty": "BALLWIN",
    "dropmalst": "MO",
    "dropmalzpp": 630119998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362275783,
    "dropsitcph": 6362275783,
    "dropfax": 6519945598
  },
  {
    "dcode": "D",
    "dropkey": "PW15783",
    "droptype": "D",
    "dropname": "BARING",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "BARING",
    "dropdelst": "MO",
    "dropdelzpp": 635319998,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "BARING",
    "dropphyst": "MO",
    "dropphyzpp": 635319998,
    "dropmaladd": "400 MAIN ST",
    "dropmalcty": "BARING",
    "dropmalst": "MO",
    "dropmalzpp": 635319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608924555,
    "dropsitcph": 6608924555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15784",
    "droptype": "D",
    "dropname": "BARNARD",
    "dropdeladd": "504 4TH ST",
    "dropdelcty": "BARNARD",
    "dropdelst": "MO",
    "dropdelzpp": 644239998,
    "dropphyadd": "504 4TH ST",
    "dropphycty": "BARNARD",
    "dropphyst": "MO",
    "dropphyzpp": 644239998,
    "dropmaladd": "504 4TH ST",
    "dropmalcty": "BARNARD",
    "dropmalst": "MO",
    "dropmalzpp": 644239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606523738,
    "dropsitcph": 6606523738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15786",
    "droptype": "D",
    "dropname": "BARNETT",
    "dropdeladd": "409 2ND ST",
    "dropdelcty": "BARNETT",
    "dropdelst": "MO",
    "dropdelzpp": 650119998,
    "dropphyadd": "409 2ND ST",
    "dropphycty": "BARNETT",
    "dropphyst": "MO",
    "dropphyzpp": 650119998,
    "dropmaladd": "409 2ND ST",
    "dropmalcty": "BARNETT",
    "dropmalst": "MO",
    "dropmalzpp": 650119998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733926081,
    "dropsitcph": 5733926081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15787",
    "droptype": "D",
    "dropname": "BARNHART",
    "dropdeladd": "1635 MARRIOTT LN",
    "dropdelcty": "BARNHART",
    "dropdelst": "MO",
    "dropdelzpp": 630129998,
    "dropphyadd": "1635 MARRIOTT LN",
    "dropphycty": "BARNHART",
    "dropphyst": "MO",
    "dropphyzpp": 630129998,
    "dropmaladd": "1635 MARRIOTT LN",
    "dropmalcty": "BARNHART",
    "dropmalst": "MO",
    "dropmalzpp": 630129998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364643606,
    "dropsitcph": 6364643606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15790",
    "droptype": "D",
    "dropname": "BATES CITY",
    "dropdeladd": "404 E HIGHWAY Z",
    "dropdelcty": "BATES CITY",
    "dropdelst": "MO",
    "dropdelzpp": 640119998,
    "dropphyadd": "404 E HIGHWAY Z",
    "dropphycty": "BATES CITY",
    "dropphyst": "MO",
    "dropphyzpp": 640119998,
    "dropmaladd": "404 E HIGHWAY Z",
    "dropmalcty": "BATES CITY",
    "dropmalst": "MO",
    "dropmalzpp": 640119998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166229329,
    "dropsitcph": 8166229329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15796",
    "droptype": "D",
    "dropname": "BEAUFORT",
    "dropdeladd": "6611 HIGHWAY 185",
    "dropdelcty": "BEAUFORT",
    "dropdelst": "MO",
    "dropdelzpp": 630139998,
    "dropphyadd": "6611 HIGHWAY 185",
    "dropphycty": "BEAUFORT",
    "dropphyst": "MO",
    "dropphyzpp": 630139998,
    "dropmaladd": "6611 HIGHWAY 185",
    "dropmalcty": "BEAUFORT",
    "dropmalst": "MO",
    "dropmalzpp": 630139998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734843763,
    "dropsitcph": 5734843763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15800",
    "droptype": "D",
    "dropname": "BELGRADE",
    "dropdeladd": "14135 STATE HIGHWAY C",
    "dropdelcty": "BELGRADE",
    "dropdelst": "MO",
    "dropdelzpp": 636229998,
    "dropphyadd": "14135 STATE HIGHWAY C",
    "dropphycty": "BELGRADE",
    "dropphyst": "MO",
    "dropphyzpp": 636229998,
    "dropmaladd": "14135 STATE HIGHWAY C",
    "dropmalcty": "BELGRADE",
    "dropmalst": "MO",
    "dropmalzpp": 636229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737665659,
    "dropsitcph": 5737665659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15801",
    "droptype": "D",
    "dropname": "BELL CITY",
    "dropdeladd": "25233 WALNUT ST",
    "dropdelcty": "BELL CITY",
    "dropdelst": "MO",
    "dropdelzpp": 637359998,
    "dropphyadd": "25233 WALNUT ST",
    "dropphycty": "BELL CITY",
    "dropphyst": "MO",
    "dropphyzpp": 637359998,
    "dropmaladd": "25233 WALNUT ST",
    "dropmalcty": "BELL CITY",
    "dropmalst": "MO",
    "dropmalzpp": 637359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737334602,
    "dropsitcph": 5737334602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15805",
    "droptype": "D",
    "dropname": "BELLE",
    "dropdeladd": "203 E 3RD ST",
    "dropdelcty": "BELLE",
    "dropdelst": "MO",
    "dropdelzpp": 650139998,
    "dropphyadd": "203 E 3RD ST",
    "dropphycty": "BELLE",
    "dropphyst": "MO",
    "dropphyzpp": 650139998,
    "dropmaladd": "203 E 3RD ST",
    "dropmalcty": "BELLE",
    "dropmalst": "MO",
    "dropmalzpp": 650139998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738593353,
    "dropsitcph": 5738593353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15814",
    "droptype": "D",
    "dropname": "BELLFLOWER",
    "dropdeladd": "119 S MAIN ST",
    "dropdelcty": "BELLFLOWER",
    "dropdelst": "MO",
    "dropdelzpp": 633339998,
    "dropphyadd": "119 S MAIN ST",
    "dropphycty": "BELLFLOWER",
    "dropphyst": "MO",
    "dropphyzpp": 633339998,
    "dropmaladd": "119 S MAIN ST",
    "dropmalcty": "BELLFLOWER",
    "dropmalst": "MO",
    "dropmalzpp": 633339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5739293615,
    "dropsitcph": 5739293615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15820",
    "droptype": "D",
    "dropname": "BELTON",
    "dropdeladd": "121 BRADFORD LN",
    "dropdelcty": "BELTON",
    "dropdelst": "MO",
    "dropdelzpp": 640129998,
    "dropphyadd": "121 BRADFORD LN",
    "dropphycty": "BELTON",
    "dropphyst": "MO",
    "dropphyzpp": 640129998,
    "dropmaladd": "121 BRADFORD LN",
    "dropmalcty": "BELTON",
    "dropmalst": "MO",
    "dropmalzpp": 640129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163223793,
    "dropsitcph": 8163312122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15824",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "112 S WINCHESTER",
    "dropdelcty": "BENTON",
    "dropdelst": "MO",
    "dropdelzpp": 637369998,
    "dropphyadd": "112 S WINCHESTER",
    "dropphycty": "BENTON",
    "dropphyst": "MO",
    "dropphyzpp": 637369998,
    "dropmaladd": "112 S WINCHESTER",
    "dropmalcty": "BENTON",
    "dropmalst": "MO",
    "dropmalzpp": 637369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735453222,
    "dropsitcph": 5735453222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15825",
    "droptype": "D",
    "dropname": "BENTON CITY",
    "dropdeladd": "203 FRONT ST",
    "dropdelcty": "BENTON CITY",
    "dropdelst": "MO",
    "dropdelzpp": 652329998,
    "dropphyadd": "203 FRONT ST",
    "dropphycty": "BENTON CITY",
    "dropphyst": "MO",
    "dropphyzpp": 652329998,
    "dropmaladd": "203 FRONT ST",
    "dropmalcty": "BENTON CITY",
    "dropmalst": "MO",
    "dropmalzpp": 652329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735818408,
    "dropsitcph": 5735818408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15831",
    "droptype": "D",
    "dropname": "BERGER",
    "dropdeladd": "211 MARKET ST",
    "dropdelcty": "BERGER",
    "dropdelst": "MO",
    "dropdelzpp": 630149998,
    "dropphyadd": "211 MARKET ST",
    "dropphycty": "BERGER",
    "dropphyst": "MO",
    "dropphyzpp": 630149998,
    "dropmaladd": "211 MARKET ST",
    "dropmalcty": "BERGER",
    "dropmalst": "MO",
    "dropmalzpp": 630149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738345244,
    "dropsitcph": 5738345244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15836",
    "droptype": "D",
    "dropname": "BERNIE",
    "dropdeladd": "115 WOODS AVE",
    "dropdelcty": "BERNIE",
    "dropdelst": "MO",
    "dropdelzpp": 638229998,
    "dropphyadd": "115 WOODS AVE",
    "dropphycty": "BERNIE",
    "dropphyst": "MO",
    "dropphyzpp": 638229998,
    "dropmaladd": "115 WOODS AVE",
    "dropmalcty": "BERNIE",
    "dropmalst": "MO",
    "dropmalzpp": 638229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732935514,
    "dropsitcph": 5732935514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15838",
    "droptype": "D",
    "dropname": "BERTRAND",
    "dropdeladd": "210 W CEDAR ST",
    "dropdelcty": "BERTRAND",
    "dropdelst": "MO",
    "dropdelzpp": 638239998,
    "dropphyadd": "210 W CEDAR ST",
    "dropphycty": "BERTRAND",
    "dropphyst": "MO",
    "dropphyzpp": 638239998,
    "dropmaladd": "210 W CEDAR ST",
    "dropmalcty": "BERTRAND",
    "dropmalst": "MO",
    "dropmalzpp": 638239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736832291,
    "dropsitcph": 5736832291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15840",
    "droptype": "D",
    "dropname": "BETHANY",
    "dropdeladd": "1407 CENTRAL ST",
    "dropdelcty": "BETHANY",
    "dropdelst": "MO",
    "dropdelzpp": 644249998,
    "dropphyadd": "1407 CENTRAL ST",
    "dropphycty": "BETHANY",
    "dropphyst": "MO",
    "dropphyzpp": 644249998,
    "dropmaladd": "1407 CENTRAL ST",
    "dropmalcty": "BETHANY",
    "dropmalst": "MO",
    "dropmalzpp": 644249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604256627,
    "dropsitcph": 6604256627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15845",
    "droptype": "D",
    "dropname": "BEVIER",
    "dropdeladd": "108 N MACON ST",
    "dropdelcty": "BEVIER",
    "dropdelst": "MO",
    "dropdelzpp": 635329998,
    "dropphyadd": "108 N MACON ST",
    "dropphycty": "BEVIER",
    "dropphyst": "MO",
    "dropphyzpp": 635329998,
    "dropmaladd": "108 N MACON ST",
    "dropmalcty": "BEVIER",
    "dropmalst": "MO",
    "dropmalzpp": 635329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607736793,
    "dropsitcph": 6607736793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15852",
    "droptype": "D",
    "dropname": "BILLINGS",
    "dropdeladd": "109 NE US HIGHWAY 60",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MO",
    "dropdelzpp": 656109998,
    "dropphyadd": "109 NE US HIGHWAY 60",
    "dropphycty": "BILLINGS",
    "dropphyst": "MO",
    "dropphyzpp": 656109998,
    "dropmaladd": "109 NE US HIGHWAY 60",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MO",
    "dropmalzpp": 656109998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176952881,
    "dropsitcph": 4176952881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15854",
    "droptype": "D",
    "dropname": "BIRCH TREE",
    "dropdeladd": "7274 OAK ST",
    "dropdelcty": "BIRCH TREE",
    "dropdelst": "MO",
    "dropdelzpp": 654389055,
    "dropphyadd": "7274 OAK ST",
    "dropphycty": "BIRCH TREE",
    "dropphyst": "MO",
    "dropphyzpp": 654389055,
    "dropmaladd": "7274 OAK ST",
    "dropmalcty": "BIRCH TREE",
    "dropmalst": "MO",
    "dropmalzpp": 654389055,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732923411,
    "dropsitcph": 5732923411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15856",
    "droptype": "D",
    "dropname": "BISMARCK",
    "dropdeladd": "911 WALNUT ST",
    "dropdelcty": "BISMARCK",
    "dropdelst": "MO",
    "dropdelzpp": 636249998,
    "dropphyadd": "911 WALNUT ST",
    "dropphycty": "BISMARCK",
    "dropphyst": "MO",
    "dropphyzpp": 636249998,
    "dropmaladd": "911 WALNUT ST",
    "dropmalcty": "BISMARCK",
    "dropmalst": "MO",
    "dropmalzpp": 636249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737342821,
    "dropsitcph": 5737342821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15859",
    "droptype": "D",
    "dropname": "BIXBY",
    "dropdeladd": "2573 STATE ROUTE 32",
    "dropdelcty": "BIXBY",
    "dropdelst": "MO",
    "dropdelzpp": 654399998,
    "dropphyadd": "2573 STATE ROUTE 32",
    "dropphycty": "BIXBY",
    "dropphyst": "MO",
    "dropphyzpp": 654399998,
    "dropmaladd": "2573 STATE ROUTE 32",
    "dropmalcty": "BIXBY",
    "dropmalst": "MO",
    "dropmalzpp": 654399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736264669,
    "dropsitcph": 5736264669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15860",
    "droptype": "D",
    "dropname": "BLACK",
    "dropdeladd": "24634 HIGHWAY 49",
    "dropdelcty": "BLACK",
    "dropdelst": "MO",
    "dropdelzpp": 636259998,
    "dropphyadd": "24634 HIGHWAY 49",
    "dropphycty": "BLACK",
    "dropphyst": "MO",
    "dropphyzpp": 636259998,
    "dropmaladd": "24634 HIGHWAY 49",
    "dropmalcty": "BLACK",
    "dropmalst": "MO",
    "dropmalzpp": 636259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732694248,
    "dropsitcph": 5732694248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15864",
    "droptype": "D",
    "dropname": "BLACKBURN",
    "dropdeladd": "210 N MAIN ST",
    "dropdelcty": "BLACKBURN",
    "dropdelst": "MO",
    "dropdelzpp": 653219998,
    "dropphyadd": "210 N MAIN ST",
    "dropphycty": "BLACKBURN",
    "dropphyst": "MO",
    "dropphyzpp": 653219998,
    "dropmaladd": "210 N MAIN ST",
    "dropmalcty": "BLACKBURN",
    "dropmalst": "MO",
    "dropmalzpp": 653219998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605384300,
    "dropsitcph": 6605384300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15865",
    "droptype": "D",
    "dropname": "BLACKWATER",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "BLACKWATER",
    "dropdelst": "MO",
    "dropdelzpp": 653229998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "BLACKWATER",
    "dropphyst": "MO",
    "dropphyzpp": 653229998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "BLACKWATER",
    "dropmalst": "MO",
    "dropmalzpp": 653229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608464261,
    "dropsitcph": 6608464261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15867",
    "droptype": "D",
    "dropname": "BLAIRSTOWN",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "BLAIRSTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 647269998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "BLAIRSTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 647269998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "BLAIRSTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 647269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604983322,
    "dropsitcph": 6604983322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15869",
    "droptype": "D",
    "dropname": "BLAND",
    "dropdeladd": "208 W COLORADO AVE",
    "dropdelcty": "BLAND",
    "dropdelst": "MO",
    "dropdelzpp": 650149998,
    "dropphyadd": "208 W COLORADO AVE",
    "dropphycty": "BLAND",
    "dropphyst": "MO",
    "dropphyzpp": 650149998,
    "dropmaladd": "208 W COLORADO AVE",
    "dropmalcty": "BLAND",
    "dropmalst": "MO",
    "dropmalzpp": 650149998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736463022,
    "dropsitcph": 5736463022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15871",
    "droptype": "D",
    "dropname": "BLODGETT",
    "dropdeladd": "406 STATE HIGHWAY H",
    "dropdelcty": "BLODGETT",
    "dropdelst": "MO",
    "dropdelzpp": 638249998,
    "dropphyadd": "406 STATE HIGHWAY H",
    "dropphycty": "BLODGETT",
    "dropphyst": "MO",
    "dropphyzpp": 638249998,
    "dropmaladd": "406 STATE HIGHWAY H",
    "dropmalcty": "BLODGETT",
    "dropmalst": "MO",
    "dropmalzpp": 638249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734711197,
    "dropsitcph": 5734711197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15872",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "301 N PRAIRIE ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 638259998,
    "dropphyadd": "301 N PRAIRIE ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 638259998,
    "dropmaladd": "301 N PRAIRIE ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 638259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735684588,
    "dropsitcph": 5735684588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15875",
    "droptype": "D",
    "dropname": "BLUE EYE",
    "dropdeladd": "112 STATE HIGHWAY 13",
    "dropdelcty": "BLUE EYE",
    "dropdelst": "MO",
    "dropdelzpp": 656119998,
    "dropphyadd": "112 STATE HIGHWAY 13",
    "dropphycty": "BLUE EYE",
    "dropphyst": "MO",
    "dropphyzpp": 656119998,
    "dropmaladd": "112 STATE HIGHWAY 13",
    "dropmalcty": "BLUE EYE",
    "dropmalst": "MO",
    "dropmalzpp": 656119998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177794396,
    "dropsitcph": 4177794396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15877",
    "droptype": "D",
    "dropname": "BLUE SPRINGS",
    "dropdeladd": "500 SW SOUTH AVE",
    "dropdelcty": "BLUE SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 640149998,
    "dropphyadd": "500 SW SOUTH AVE",
    "dropphycty": "BLUE SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 640149998,
    "dropmaladd": "500 SW SOUTH AVE",
    "dropmalcty": "BLUE SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 640149998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162200820,
    "dropsitcph": 8162200820,
    "dropfax": 8162297412
  },
  {
    "dcode": "D",
    "dropkey": "PW15880",
    "droptype": "D",
    "dropname": "BLYTHEDALE",
    "dropdeladd": "629 STATE HWY N",
    "dropdelcty": "BLYTHEDALE",
    "dropdelst": "MO",
    "dropdelzpp": 644269998,
    "dropphyadd": "629 STATE HWY N",
    "dropphycty": "BLYTHEDALE",
    "dropphyst": "MO",
    "dropphyzpp": 644269998,
    "dropmaladd": "629 STATE HWY N",
    "dropmalcty": "BLYTHEDALE",
    "dropmalst": "MO",
    "dropmalzpp": 644269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608673242,
    "dropsitcph": 6608673242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15883",
    "droptype": "D",
    "dropname": "BOGARD",
    "dropdeladd": "100 W 3RD ST",
    "dropdelcty": "BOGARD",
    "dropdelst": "MO",
    "dropdelzpp": 646229998,
    "dropphyadd": "100 W 3RD ST",
    "dropphycty": "BOGARD",
    "dropphyst": "MO",
    "dropphyzpp": 646229998,
    "dropmaladd": "100 W 3RD ST",
    "dropmalcty": "BOGARD",
    "dropmalst": "MO",
    "dropmalzpp": 646229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607315513,
    "dropsitcph": 6607315513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15884",
    "droptype": "D",
    "dropname": "BOIS D ARC",
    "dropdeladd": "10507 W STATE HIGHWAY T",
    "dropdelcty": "BOIS D ARC",
    "dropdelst": "MO",
    "dropdelzpp": 656129998,
    "dropphyadd": "10507 W STATE HIGHWAY T",
    "dropphycty": "BOIS D ARC",
    "dropphyst": "MO",
    "dropphyzpp": 656129998,
    "dropmaladd": "10507 W STATE HIGHWAY T",
    "dropmalcty": "BOIS D ARC",
    "dropmalst": "MO",
    "dropmalzpp": 656129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177423011,
    "dropsitcph": 4177423011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15886",
    "droptype": "D",
    "dropname": "BOLCKOW",
    "dropdeladd": "305 RICHARDSON ST",
    "dropdelcty": "BOLCKOW",
    "dropdelst": "MO",
    "dropdelzpp": 644279998,
    "dropphyadd": "305 RICHARDSON ST",
    "dropphycty": "BOLCKOW",
    "dropphyst": "MO",
    "dropphyzpp": 644279998,
    "dropmaladd": "305 RICHARDSON ST",
    "dropmalcty": "BOLCKOW",
    "dropmalst": "MO",
    "dropmalzpp": 644279998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164282605,
    "dropsitcph": 8164282605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15887",
    "droptype": "D",
    "dropname": "BOLIVAR",
    "dropdeladd": "328 S MAIN AVE",
    "dropdelcty": "BOLIVAR",
    "dropdelst": "MO",
    "dropdelzpp": 656139998,
    "dropphyadd": "328 S MAIN AVE",
    "dropphycty": "BOLIVAR",
    "dropphyst": "MO",
    "dropphyzpp": 656139998,
    "dropmaladd": "328 S MAIN AVE",
    "dropmalcty": "BOLIVAR",
    "dropmalst": "MO",
    "dropmalzpp": 656139998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173264132,
    "dropsitcph": 4173264132,
    "dropfax": 4177773791
  },
  {
    "dcode": "D",
    "dropkey": "PW15890",
    "droptype": "D",
    "dropname": "BONNE TERRE",
    "dropdeladd": "103 NE MAIN ST",
    "dropdelcty": "BONNE TERRE",
    "dropdelst": "MO",
    "dropdelzpp": 636289998,
    "dropphyadd": "103 NE MAIN ST",
    "dropphycty": "BONNE TERRE",
    "dropphyst": "MO",
    "dropphyzpp": 636289998,
    "dropmaladd": "103 NE MAIN ST",
    "dropmalcty": "BONNE TERRE",
    "dropmalst": "MO",
    "dropmalzpp": 636289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733582101,
    "dropsitcph": 5733582101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15891",
    "droptype": "D",
    "dropname": "BONNOTS MILL",
    "dropdeladd": "110 RIVERVIEW DR",
    "dropdelcty": "BONNOTS MILL",
    "dropdelst": "MO",
    "dropdelzpp": 650169998,
    "dropphyadd": "110 RIVERVIEW DR",
    "dropphycty": "BONNOTS MILL",
    "dropphyst": "MO",
    "dropphyzpp": 650169998,
    "dropmaladd": "110 RIVERVIEW DR",
    "dropmalcty": "BONNOTS MILL",
    "dropmalst": "MO",
    "dropmalzpp": 650169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738973677,
    "dropsitcph": 5738973677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15894",
    "droptype": "D",
    "dropname": "BOONVILLE",
    "dropdeladd": "526 E SPRING ST",
    "dropdelcty": "BOONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652339998,
    "dropphyadd": "526 E SPRING ST",
    "dropphycty": "BOONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652339998,
    "dropmaladd": "526 E SPRING ST",
    "dropmalcty": "BOONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608825666,
    "dropsitcph": 6608825666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15898",
    "droptype": "D",
    "dropname": "BOSS",
    "dropdeladd": "22333 E HIGHWAY 32",
    "dropdelcty": "BOSS",
    "dropdelst": "MO",
    "dropdelzpp": 654409998,
    "dropphyadd": "22333 E HIGHWAY 32",
    "dropphycty": "BOSS",
    "dropphyst": "MO",
    "dropphyzpp": 654409998,
    "dropmaladd": "22333 E HIGHWAY 32",
    "dropmalcty": "BOSS",
    "dropmalst": "MO",
    "dropmalzpp": 654409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736264613,
    "dropsitcph": 5736264613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15899",
    "droptype": "D",
    "dropname": "BOSWORTH",
    "dropdeladd": "111 N KANSAS AVE",
    "dropdelcty": "BOSWORTH",
    "dropdelst": "MO",
    "dropdelzpp": 646239998,
    "dropphyadd": "111 N KANSAS AVE",
    "dropphycty": "BOSWORTH",
    "dropphyst": "MO",
    "dropphyzpp": 646239998,
    "dropmaladd": "111 N KANSAS AVE",
    "dropmalcty": "BOSWORTH",
    "dropmalst": "MO",
    "dropmalzpp": 646239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605347419,
    "dropsitcph": 6605347419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15901",
    "droptype": "D",
    "dropname": "BOURBON",
    "dropdeladd": "218 E PINE ST",
    "dropdelcty": "BOURBON",
    "dropdelst": "MO",
    "dropdelzpp": 654419998,
    "dropphyadd": "218 E PINE ST",
    "dropphycty": "BOURBON",
    "dropphyst": "MO",
    "dropphyzpp": 654419998,
    "dropmaladd": "218 E PINE ST",
    "dropmalcty": "BOURBON",
    "dropmalst": "MO",
    "dropmalzpp": 654419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737324600,
    "dropsitcph": 5737324600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15903",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "17 W CHURCH ST",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "MO",
    "dropdelzpp": 633349998,
    "dropphyadd": "17 W CHURCH ST",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "MO",
    "dropphyzpp": 633349998,
    "dropmaladd": "17 W CHURCH ST",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "MO",
    "dropmalzpp": 633349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733245531,
    "dropsitcph": 5733245531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15920",
    "droptype": "D",
    "dropname": "BRADLEYVILLE",
    "dropdeladd": "25856 STATE HIGHWAY 76",
    "dropdelcty": "BRADLEYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656149998,
    "dropphyadd": "25856 STATE HIGHWAY 76",
    "dropphycty": "BRADLEYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656149998,
    "dropmaladd": "25856 STATE HIGHWAY 76",
    "dropmalcty": "BRADLEYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656149998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177962487,
    "dropsitcph": 4177962487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15923",
    "droptype": "D",
    "dropname": "BRAGG CITY",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "BRAGG CITY",
    "dropdelst": "MO",
    "dropdelzpp": 638279998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "BRAGG CITY",
    "dropphyst": "MO",
    "dropphyzpp": 638279998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "BRAGG CITY",
    "dropmalst": "MO",
    "dropmalzpp": 638279998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738886129,
    "dropsitcph": 5738886129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15926",
    "droptype": "D",
    "dropname": "BRAGGADOCIO",
    "dropdeladd": "2064 STATE HIGHWAY Z",
    "dropdelcty": "BRAGGADOCIO",
    "dropdelst": "MO",
    "dropdelzpp": 638269998,
    "dropphyadd": "2064 STATE HIGHWAY Z",
    "dropphycty": "BRAGGADOCIO",
    "dropphyst": "MO",
    "dropphyzpp": 638269998,
    "dropmaladd": "2064 STATE HIGHWAY Z",
    "dropmalcty": "BRAGGADOCIO",
    "dropmalst": "MO",
    "dropmalzpp": 638269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737576401,
    "dropsitcph": 5737576401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15928",
    "droptype": "D",
    "dropname": "BRANDSVILLE",
    "dropdeladd": "212 E MAIN ST",
    "dropdelcty": "BRANDSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656889998,
    "dropphyadd": "212 E MAIN ST",
    "dropphycty": "BRANDSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656889998,
    "dropmaladd": "212 E MAIN ST",
    "dropmalcty": "BRANDSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178673374,
    "dropsitcph": 4178673374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15931",
    "droptype": "D",
    "dropname": "BRANSON",
    "dropdeladd": "320 S COMMERCIAL ST",
    "dropdelcty": "BRANSON",
    "dropdelst": "MO",
    "dropdelzpp": 656169998,
    "dropphyadd": "320 S COMMERCIAL ST",
    "dropphycty": "BRANSON",
    "dropphyst": "MO",
    "dropphyzpp": 656169998,
    "dropmaladd": "320 S COMMERCIAL ST",
    "dropmalcty": "BRANSON",
    "dropmalst": "MO",
    "dropmalzpp": 656169998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173364014,
    "dropsitcph": 4173364014,
    "dropfax": 6505784325
  },
  {
    "dcode": "D",
    "dropkey": "PW15938",
    "droptype": "D",
    "dropname": "BRASHEAR",
    "dropdeladd": "201 S KING ST",
    "dropdelcty": "BRASHEAR",
    "dropdelst": "MO",
    "dropdelzpp": 635339998,
    "dropphyadd": "201 S KING ST",
    "dropphycty": "BRASHEAR",
    "dropphyst": "MO",
    "dropphyzpp": 635339998,
    "dropmaladd": "201 S KING ST",
    "dropmalcty": "BRASHEAR",
    "dropmalst": "MO",
    "dropmalzpp": 635339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603235688,
    "dropsitcph": 6603235688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15939",
    "droptype": "D",
    "dropname": "BRAYMER",
    "dropdeladd": "115 E 2ND ST",
    "dropdelcty": "BRAYMER",
    "dropdelst": "MO",
    "dropdelzpp": 646249998,
    "dropphyadd": "115 E 2ND ST",
    "dropphycty": "BRAYMER",
    "dropphyst": "MO",
    "dropphyzpp": 646249998,
    "dropmaladd": "115 E 2ND ST",
    "dropmalcty": "BRAYMER",
    "dropmalst": "MO",
    "dropmalzpp": 646249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606452700,
    "dropsitcph": 6606452700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15943",
    "droptype": "D",
    "dropname": "BRECKENRIDGE",
    "dropdeladd": "165 S 7TH ST",
    "dropdelcty": "BRECKENRIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 646259998,
    "dropphyadd": "165 S 7TH ST",
    "dropphycty": "BRECKENRIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 646259998,
    "dropmaladd": "165 S 7TH ST",
    "dropmalcty": "BRECKENRIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 646259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606445885,
    "dropsitcph": 6606445885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15959",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "1584 HIGHWAY 215",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "MO",
    "dropdelzpp": 656179998,
    "dropphyadd": "1584 HIGHWAY 215",
    "dropphycty": "BRIGHTON",
    "dropphyst": "MO",
    "dropphyzpp": 656179998,
    "dropmaladd": "1584 HIGHWAY 215",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "MO",
    "dropmalzpp": 656179998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173762511,
    "dropsitcph": 4173762511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15969",
    "droptype": "D",
    "dropname": "BRONAUGH",
    "dropdeladd": "101 W 4TH ST",
    "dropdelcty": "BRONAUGH",
    "dropdelst": "MO",
    "dropdelzpp": 647289998,
    "dropphyadd": "101 W 4TH ST",
    "dropphycty": "BRONAUGH",
    "dropphyst": "MO",
    "dropphyzpp": 647289998,
    "dropmaladd": "101 W 4TH ST",
    "dropmalcty": "BRONAUGH",
    "dropmalst": "MO",
    "dropmalzpp": 647289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179223316,
    "dropsitcph": 4179223316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15970",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "201 W BOSTON ST",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 646289998,
    "dropphyadd": "201 W BOSTON ST",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 646289998,
    "dropmaladd": "201 W BOSTON ST",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 646289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602587044,
    "dropsitcph": 6602587044,
    "dropfax": 6602585149
  },
  {
    "dcode": "D",
    "dropkey": "PW15974",
    "droptype": "D",
    "dropname": "BROOKLINE",
    "dropdeladd": "2874 N BROOKLINE AVE",
    "dropdelcty": "BROOKLINE",
    "dropdelst": "MO",
    "dropdelzpp": 656199998,
    "dropphyadd": "2874 N BROOKLINE AVE",
    "dropphycty": "BROOKLINE",
    "dropphyst": "MO",
    "dropphyzpp": 656199998,
    "dropmaladd": "2874 N BROOKLINE AVE",
    "dropmalcty": "BROOKLINE",
    "dropmalst": "MO",
    "dropmalzpp": 656199998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178694354,
    "dropsitcph": 4178694354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15976",
    "droptype": "D",
    "dropname": "BROSELEY",
    "dropdeladd": "779A COUNTY ROAD 639",
    "dropdelcty": "BROSELEY",
    "dropdelst": "MO",
    "dropdelzpp": 639329998,
    "dropphyadd": "779A COUNTY ROAD 639",
    "dropphycty": "BROSELEY",
    "dropphyst": "MO",
    "dropphyzpp": 639329998,
    "dropmaladd": "779A COUNTY ROAD 639",
    "dropmalcty": "BROSELEY",
    "dropmalst": "MO",
    "dropmalzpp": 639329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733284187,
    "dropsitcph": 5733284187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15977",
    "droptype": "D",
    "dropname": "BROWNING",
    "dropdeladd": "502 W MAIN ST",
    "dropdelcty": "BROWNING",
    "dropdelst": "MO",
    "dropdelzpp": 646309998,
    "dropphyadd": "502 W MAIN ST",
    "dropphycty": "BROWNING",
    "dropphyst": "MO",
    "dropphyzpp": 646309998,
    "dropmaladd": "502 W MAIN ST",
    "dropmalcty": "BROWNING",
    "dropmalst": "MO",
    "dropmalzpp": 646309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609464415,
    "dropsitcph": 6609464415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15981",
    "droptype": "D",
    "dropname": "BROWNWOOD",
    "dropdeladd": "31927 CENTER ST",
    "dropdelcty": "BROWNWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 637389998,
    "dropphyadd": "31927 CENTER ST",
    "dropphycty": "BROWNWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 637389998,
    "dropmaladd": "31927 CENTER ST",
    "dropmalcty": "BROWNWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 637389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737223138,
    "dropsitcph": 5737223138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15982",
    "droptype": "D",
    "dropname": "BRUMLEY",
    "dropdeladd": "859 HIGHWAY C",
    "dropdelcty": "BRUMLEY",
    "dropdelst": "MO",
    "dropdelzpp": 650179998,
    "dropphyadd": "859 HIGHWAY C",
    "dropphycty": "BRUMLEY",
    "dropphyst": "MO",
    "dropphyzpp": 650179998,
    "dropmaladd": "859 HIGHWAY C",
    "dropmalcty": "BRUMLEY",
    "dropmalst": "MO",
    "dropmalzpp": 650179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733692733,
    "dropsitcph": 5733692733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15983",
    "droptype": "D",
    "dropname": "BRUNER",
    "dropdeladd": "13547 STATE HIGHWAY 14 E",
    "dropdelcty": "BRUNER",
    "dropdelst": "MO",
    "dropdelzpp": 656209998,
    "dropphyadd": "13547 STATE HIGHWAY 14 E",
    "dropphycty": "BRUNER",
    "dropphyst": "MO",
    "dropphyzpp": 656209998,
    "dropmaladd": "13547 STATE HIGHWAY 14 E",
    "dropmalcty": "BRUNER",
    "dropmalst": "MO",
    "dropmalzpp": 656209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176344210,
    "dropsitcph": 4176344210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW15984",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "101 W BROADWAY ST",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "MO",
    "dropdelzpp": 652369998,
    "dropphyadd": "101 W BROADWAY ST",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "MO",
    "dropphyzpp": 652369998,
    "dropmaladd": "101 W BROADWAY ST",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "MO",
    "dropmalzpp": 652369998,
    "dropsitphn": 6605483677,
    "dropsitlph": 6605483677,
    "dropsitcph": 6605483677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16021",
    "droptype": "D",
    "dropname": "BUCKLIN",
    "dropdeladd": "31 N LIVINGSTON ST",
    "dropdelcty": "BUCKLIN",
    "dropdelst": "MO",
    "dropdelzpp": 646319998,
    "dropphyadd": "31 N LIVINGSTON ST",
    "dropphycty": "BUCKLIN",
    "dropphyst": "MO",
    "dropphyzpp": 646319998,
    "dropmaladd": "31 N LIVINGSTON ST",
    "dropmalcty": "BUCKLIN",
    "dropmalst": "MO",
    "dropmalzpp": 646319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606954414,
    "dropsitcph": 6606954414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16022",
    "droptype": "D",
    "dropname": "BUCKNER",
    "dropdeladd": "16 WASHINGTON ST",
    "dropdelcty": "BUCKNER",
    "dropdelst": "MO",
    "dropdelzpp": 640169998,
    "dropphyadd": "16 WASHINGTON ST",
    "dropphycty": "BUCKNER",
    "dropphyst": "MO",
    "dropphyzpp": 640169998,
    "dropmaladd": "16 WASHINGTON ST",
    "dropmalcty": "BUCKNER",
    "dropmalst": "MO",
    "dropmalzpp": 640169998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166503915,
    "dropsitcph": 8166503915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16023",
    "droptype": "D",
    "dropname": "BUCYRUS",
    "dropdeladd": "7866 HIGHWAY 17",
    "dropdelcty": "BUCYRUS",
    "dropdelst": "MO",
    "dropdelzpp": 654449998,
    "dropphyadd": "7866 HIGHWAY 17",
    "dropphycty": "BUCYRUS",
    "dropphyst": "MO",
    "dropphyzpp": 654449998,
    "dropmaladd": "7866 HIGHWAY 17",
    "dropmalcty": "BUCYRUS",
    "dropmalst": "MO",
    "dropmalzpp": 654449998,
    "dropsitphn": 8165043662,
    "dropsitlph": 4179672738,
    "dropsitcph": 4179672738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16025",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "215 S PINE ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "MO",
    "dropdelzpp": 656229998,
    "dropphyadd": "215 S PINE ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "MO",
    "dropphyzpp": 656229998,
    "dropmaladd": "215 S PINE ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "MO",
    "dropmalzpp": 656229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173457372,
    "dropsitcph": 4173457372,
    "dropfax": 4173455319
  },
  {
    "dcode": "D",
    "dropkey": "PW16026",
    "droptype": "D",
    "dropname": "BUNCETON",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "BUNCETON",
    "dropdelst": "MO",
    "dropdelzpp": 652379998,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "BUNCETON",
    "dropphyst": "MO",
    "dropphyzpp": 652379998,
    "dropmaladd": "112 W MAIN ST",
    "dropmalcty": "BUNCETON",
    "dropmalst": "MO",
    "dropmalzpp": 652379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604275431,
    "dropsitcph": 6604275431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16027",
    "droptype": "D",
    "dropname": "BUNKER",
    "dropdeladd": "400 OAK ST",
    "dropdelcty": "BUNKER",
    "dropdelst": "MO",
    "dropdelzpp": 636299998,
    "dropphyadd": "400 OAK ST",
    "dropphycty": "BUNKER",
    "dropphyst": "MO",
    "dropphyzpp": 636299998,
    "dropmaladd": "400 OAK ST",
    "dropmalcty": "BUNKER",
    "dropmalst": "MO",
    "dropmalzpp": 636299998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736843138,
    "dropsitcph": 5736843138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16035",
    "droptype": "D",
    "dropname": "BURLINGTON JUNCTION",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "BURLINGTON JUNCTION",
    "dropdelst": "MO",
    "dropdelzpp": 644289998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "BURLINGTON JUNCTION",
    "dropphyst": "MO",
    "dropphyzpp": 644289998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "BURLINGTON JUNCTION",
    "dropmalst": "MO",
    "dropmalzpp": 644289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607254486,
    "dropsitcph": 6607254486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16037",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "114 W OHIO ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "MO",
    "dropdelzpp": 647309998,
    "dropphyadd": "114 W OHIO ST",
    "dropphycty": "BUTLER",
    "dropphyst": "MO",
    "dropphyzpp": 647309998,
    "dropmaladd": "114 W OHIO ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "MO",
    "dropmalzpp": 647309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606793921,
    "dropsitcph": 6606793921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16048",
    "droptype": "D",
    "dropname": "CABOOL",
    "dropdeladd": "519 CEDAR AVE",
    "dropdelcty": "CABOOL",
    "dropdelst": "MO",
    "dropdelzpp": 656899998,
    "dropphyadd": "519 CEDAR AVE",
    "dropphycty": "CABOOL",
    "dropphyst": "MO",
    "dropphyzpp": 656899998,
    "dropmaladd": "519 CEDAR AVE",
    "dropmalcty": "CABOOL",
    "dropmalst": "MO",
    "dropmalzpp": 656899998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179624723,
    "dropsitcph": 4179624723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16049",
    "droptype": "D",
    "dropname": "CADET",
    "dropdeladd": "15026 E STATE HIGHWAY 47",
    "dropdelcty": "CADET",
    "dropdelst": "MO",
    "dropdelzpp": 636309998,
    "dropphyadd": "15026 E STATE HIGHWAY 47",
    "dropphycty": "CADET",
    "dropphyst": "MO",
    "dropphyzpp": 636309998,
    "dropmaladd": "15026 E STATE HIGHWAY 47",
    "dropmalcty": "CADET",
    "dropmalst": "MO",
    "dropmalzpp": 636309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734384938,
    "dropsitcph": 5734384938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16050",
    "droptype": "D",
    "dropname": "CAINSVILLE",
    "dropdeladd": "702 MAIN ST",
    "dropdelcty": "CAINSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 646329998,
    "dropphyadd": "702 MAIN ST",
    "dropphycty": "CAINSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 646329998,
    "dropmaladd": "702 MAIN ST",
    "dropmalcty": "CAINSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 646329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608935317,
    "dropsitcph": 6608935317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16053",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "CAIRO",
    "dropdelst": "MO",
    "dropdelzpp": 652399998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "CAIRO",
    "dropphyst": "MO",
    "dropphyzpp": 652399998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "CAIRO",
    "dropmalst": "MO",
    "dropmalzpp": 652399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602632765,
    "dropsitcph": 6602632765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16054",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "3 VALLEY CTR",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "MO",
    "dropdelzpp": 636319998,
    "dropphyadd": "3 VALLEY CTR",
    "dropphycty": "CALEDONIA",
    "dropphyst": "MO",
    "dropphyzpp": 636319998,
    "dropmaladd": "3 VALLEY CTR",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "MO",
    "dropmalzpp": 636319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737793720,
    "dropsitcph": 5737793720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16055",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "200 E 5TH ST",
    "dropdelcty": "CALHOUN",
    "dropdelst": "MO",
    "dropdelzpp": 653239998,
    "dropphyadd": "200 E 5TH ST",
    "dropphycty": "CALHOUN",
    "dropphyst": "MO",
    "dropphyzpp": 653239998,
    "dropmaladd": "200 E 5TH ST",
    "dropmalcty": "CALHOUN",
    "dropmalst": "MO",
    "dropmalzpp": 653239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606943524,
    "dropsitcph": 6606943524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16056",
    "droptype": "D",
    "dropname": "CALIFORNIA",
    "dropdeladd": "200 N HIGH ST",
    "dropdelcty": "CALIFORNIA",
    "dropdelst": "MO",
    "dropdelzpp": 650189998,
    "dropphyadd": "200 N HIGH ST",
    "dropphycty": "CALIFORNIA",
    "dropphyst": "MO",
    "dropphyzpp": 650189998,
    "dropmaladd": "200 N HIGH ST",
    "dropmalcty": "CALIFORNIA",
    "dropmalst": "MO",
    "dropmalzpp": 650189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737964401,
    "dropsitcph": 5737964401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16057",
    "droptype": "D",
    "dropname": "CALLAO",
    "dropdeladd": "109 MARKET ST",
    "dropdelcty": "CALLAO",
    "dropdelst": "MO",
    "dropdelzpp": 635349998,
    "dropphyadd": "109 MARKET ST",
    "dropphycty": "CALLAO",
    "dropphyst": "MO",
    "dropphyzpp": 635349998,
    "dropmaladd": "109 MARKET ST",
    "dropmalcty": "CALLAO",
    "dropmalst": "MO",
    "dropmalzpp": 635349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607685612,
    "dropsitcph": 6607685612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16064",
    "droptype": "D",
    "dropname": "CAMDEN POINT",
    "dropdeladd": "310 CAMDEN ST",
    "dropdelcty": "CAMDEN POINT",
    "dropdelst": "MO",
    "dropdelzpp": 640189998,
    "dropphyadd": "310 CAMDEN ST",
    "dropphycty": "CAMDEN POINT",
    "dropphyst": "MO",
    "dropphyzpp": 640189998,
    "dropmaladd": "310 CAMDEN ST",
    "dropmalcty": "CAMDEN POINT",
    "dropmalst": "MO",
    "dropmalzpp": 640189998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164453513,
    "dropsitcph": 8164453513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16066",
    "droptype": "D",
    "dropname": "CAMDENTON",
    "dropdeladd": "625 W US HIGHWAY 54",
    "dropdelcty": "CAMDENTON",
    "dropdelst": "MO",
    "dropdelzpp": 650209998,
    "dropphyadd": "625 W US HIGHWAY 54",
    "dropphycty": "CAMDENTON",
    "dropphyst": "MO",
    "dropphyzpp": 650209998,
    "dropmaladd": "625 W US HIGHWAY 54",
    "dropmalcty": "CAMDENTON",
    "dropmalst": "MO",
    "dropmalzpp": 650209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733462011,
    "dropsitcph": 5733462011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16067",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "112 E GRAND AVE",
    "dropdelcty": "CAMERON",
    "dropdelst": "MO",
    "dropdelzpp": 644299998,
    "dropphyadd": "112 E GRAND AVE",
    "dropphycty": "CAMERON",
    "dropphyst": "MO",
    "dropphyzpp": 644299998,
    "dropmaladd": "112 E GRAND AVE",
    "dropmalcty": "CAMERON",
    "dropmalst": "MO",
    "dropmalzpp": 644299998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166323071,
    "dropsitcph": 8166323071,
    "dropfax": 8166322300
  },
  {
    "dcode": "D",
    "dropkey": "PW16070",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "405 W GRAND AVE",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "MO",
    "dropdelzpp": 639339998,
    "dropphyadd": "405 W GRAND AVE",
    "dropphycty": "CAMPBELL",
    "dropphyst": "MO",
    "dropphyzpp": 639339998,
    "dropmaladd": "405 W GRAND AVE",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "MO",
    "dropmalzpp": 639339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732462574,
    "dropsitcph": 5732462574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16076",
    "droptype": "D",
    "dropname": "CANALOU",
    "dropdeladd": "235 MADISON ST",
    "dropdelcty": "CANALOU",
    "dropdelst": "MO",
    "dropdelzpp": 638289998,
    "dropphyadd": "235 MADISON ST",
    "dropphycty": "CANALOU",
    "dropphyst": "MO",
    "dropphyzpp": 638289998,
    "dropmaladd": "235 MADISON ST",
    "dropmalcty": "CANALOU",
    "dropmalst": "MO",
    "dropmalzpp": 638289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736675123,
    "dropsitcph": 5736675123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16077",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "500 LEWIS ST",
    "dropdelcty": "CANTON",
    "dropdelst": "MO",
    "dropdelzpp": 634359998,
    "dropphyadd": "500 LEWIS ST",
    "dropphycty": "CANTON",
    "dropphyst": "MO",
    "dropphyzpp": 634359998,
    "dropmaladd": "500 LEWIS ST",
    "dropmalcty": "CANTON",
    "dropmalst": "MO",
    "dropmalzpp": 634359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732883171,
    "dropsitcph": 5732883171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16078",
    "droptype": "D",
    "dropname": "CAPE FAIR",
    "dropdeladd": "8089 W STATE HIGHWAY 76 UNIT D",
    "dropdelcty": "CAPE FAIR",
    "dropdelst": "MO",
    "dropdelzpp": 656244618,
    "dropphyadd": "8089 W STATE HIGHWAY 76 UNIT D",
    "dropphycty": "CAPE FAIR",
    "dropphyst": "MO",
    "dropphyzpp": 656244618,
    "dropmaladd": "8089 W STATE HIGHWAY 76 UNIT D",
    "dropmalcty": "CAPE FAIR",
    "dropmalst": "MO",
    "dropmalzpp": 656244618,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175382894,
    "dropsitcph": 4175382894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16081",
    "droptype": "D",
    "dropname": "CAPE GIRARDEAU",
    "dropdeladd": "320 N FREDERICK ST",
    "dropdelcty": "CAPE GIRARDEAU",
    "dropdelst": "MO",
    "dropdelzpp": 637019998,
    "dropphyadd": "320 N FREDERICK ST",
    "dropphycty": "CAPE GIRARDEAU",
    "dropphyst": "MO",
    "dropphyzpp": 637019998,
    "dropmaladd": "320 N FREDERICK ST",
    "dropmalcty": "CAPE GIRARDEAU",
    "dropmalst": "MO",
    "dropmalzpp": 637019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733310800,
    "dropsitcph": 5733355501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16087",
    "droptype": "D",
    "dropname": "CARDWELL",
    "dropdeladd": "107 S MAIN ST",
    "dropdelcty": "CARDWELL",
    "dropdelst": "MO",
    "dropdelzpp": 638299998,
    "dropphyadd": "107 S MAIN ST",
    "dropphycty": "CARDWELL",
    "dropphyst": "MO",
    "dropphyzpp": 638299998,
    "dropmaladd": "107 S MAIN ST",
    "dropmalcty": "CARDWELL",
    "dropmalst": "MO",
    "dropmalzpp": 638299998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736543558,
    "dropsitcph": 5736543558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16089",
    "droptype": "D",
    "dropname": "CARL JUNCTION",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "CARL JUNCTION",
    "dropdelst": "MO",
    "dropdelzpp": 648349998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "CARL JUNCTION",
    "dropphyst": "MO",
    "dropphyzpp": 648349998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "CARL JUNCTION",
    "dropmalst": "MO",
    "dropmalzpp": 648349998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4176497831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16095",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "101 N FOLGER ST",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "MO",
    "dropdelzpp": 646339998,
    "dropphyadd": "101 N FOLGER ST",
    "dropphycty": "CARROLLTON",
    "dropphyst": "MO",
    "dropphyzpp": 646339998,
    "dropmaladd": "101 N FOLGER ST",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "MO",
    "dropmalzpp": 646339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605422777,
    "dropsitcph": 6605422777,
    "dropfax": 6605421314
  },
  {
    "dcode": "D",
    "dropkey": "PW16099",
    "droptype": "D",
    "dropname": "CARTERVILLE",
    "dropdeladd": "121 E MAIN ST",
    "dropdelcty": "CARTERVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 648359998,
    "dropphyadd": "121 E MAIN ST",
    "dropphycty": "CARTERVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 648359998,
    "dropmaladd": "121 E MAIN ST",
    "dropmalcty": "CARTERVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 648359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176733041,
    "dropsitcph": 4176733041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16102",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "226 W 3RD ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "MO",
    "dropdelzpp": 648369998,
    "dropphyadd": "226 W 3RD ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "MO",
    "dropphyzpp": 648369998,
    "dropmaladd": "226 W 3RD ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "MO",
    "dropmalzpp": 648369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173582307,
    "dropsitcph": 4173582307,
    "dropfax": 4173586194
  },
  {
    "dcode": "D",
    "dropkey": "PW16104",
    "droptype": "D",
    "dropname": "CARUTHERSVILLE",
    "dropdeladd": "300 CARLETON AVE",
    "dropdelcty": "CARUTHERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 638309998,
    "dropphyadd": "300 CARLETON AVE",
    "dropphycty": "CARUTHERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 638309998,
    "dropmaladd": "300 CARLETON AVE",
    "dropmalcty": "CARUTHERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 638309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733332548,
    "dropsitcph": 5733332548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16112",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "800 WEST ST",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656259998,
    "dropphyadd": "800 WEST ST",
    "dropphycty": "CASSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656259998,
    "dropmaladd": "800 WEST ST",
    "dropmalcty": "CASSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178472890,
    "dropsitcph": 4178472890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16119",
    "droptype": "D",
    "dropname": "CATAWISSA",
    "dropdeladd": "3016 HIGHWAY N",
    "dropdelcty": "CATAWISSA",
    "dropdelst": "MO",
    "dropdelzpp": 630159998,
    "dropphyadd": "3016 HIGHWAY N",
    "dropphycty": "CATAWISSA",
    "dropphyst": "MO",
    "dropphyzpp": 630159998,
    "dropmaladd": "3016 HIGHWAY N",
    "dropmalcty": "CATAWISSA",
    "dropmalst": "MO",
    "dropmalzpp": 630159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362579834,
    "dropsitcph": 6362579834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16120",
    "droptype": "D",
    "dropname": "CATRON",
    "dropdeladd": "3770 STATE HIGHWAY D",
    "dropdelcty": "CATRON",
    "dropdelst": "MO",
    "dropdelzpp": 638339998,
    "dropphyadd": "3770 STATE HIGHWAY D",
    "dropphycty": "CATRON",
    "dropphyst": "MO",
    "dropphyzpp": 638339998,
    "dropmaladd": "3770 STATE HIGHWAY D",
    "dropmalcty": "CATRON",
    "dropmalst": "MO",
    "dropmalzpp": 638339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736885063,
    "dropsitcph": 5736885063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16121",
    "droptype": "D",
    "dropname": "CAULFIELD",
    "dropdeladd": "377 US HIGHWAY 160",
    "dropdelcty": "CAULFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 656269998,
    "dropphyadd": "377 US HIGHWAY 160",
    "dropphycty": "CAULFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 656269998,
    "dropmaladd": "377 US HIGHWAY 160",
    "dropmalcty": "CAULFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 656269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172843830,
    "dropsitcph": 4172843830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16130",
    "droptype": "D",
    "dropname": "CEDAR HILL",
    "dropdeladd": "7050 STATE ROAD BB",
    "dropdelcty": "CEDAR HILL",
    "dropdelst": "MO",
    "dropdelzpp": 630169998,
    "dropphyadd": "7050 STATE ROAD BB",
    "dropphycty": "CEDAR HILL",
    "dropphyst": "MO",
    "dropphyzpp": 630169998,
    "dropmaladd": "7050 STATE ROAD BB",
    "dropmalcty": "CEDAR HILL",
    "dropmalst": "MO",
    "dropmalzpp": 630169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362850497,
    "dropsitcph": 6362850497,
    "dropfax": 6362856091
  },
  {
    "dcode": "D",
    "dropkey": "PW16136",
    "droptype": "D",
    "dropname": "CEDARCREEK",
    "dropdeladd": "6589 STATE HIGHWAY M",
    "dropdelcty": "CEDARCREEK",
    "dropdelst": "MO",
    "dropdelzpp": 656279998,
    "dropphyadd": "6589 STATE HIGHWAY M",
    "dropphycty": "CEDARCREEK",
    "dropphyst": "MO",
    "dropphyzpp": 656279998,
    "dropmaladd": "6589 STATE HIGHWAY M",
    "dropmalcty": "CEDARCREEK",
    "dropmalst": "MO",
    "dropmalzpp": 656279998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177943482,
    "dropsitcph": 4177943482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16140",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "112 N PUBLIC ST",
    "dropdelcty": "CENTER",
    "dropdelst": "MO",
    "dropdelzpp": 634369998,
    "dropphyadd": "112 N PUBLIC ST",
    "dropphycty": "CENTER",
    "dropphyst": "MO",
    "dropphyzpp": 634369998,
    "dropmaladd": "112 N PUBLIC ST",
    "dropmalcty": "CENTER",
    "dropmalst": "MO",
    "dropmalzpp": 634369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732673523,
    "dropsitcph": 5732673523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16143",
    "droptype": "D",
    "dropname": "CENTERTOWN",
    "dropdeladd": "11917 MAIN ST",
    "dropdelcty": "CENTERTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 650239998,
    "dropphyadd": "11917 MAIN ST",
    "dropphycty": "CENTERTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 650239998,
    "dropmaladd": "11917 MAIN ST",
    "dropmalcty": "CENTERTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 650239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735843612,
    "dropsitcph": 5735843612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16145",
    "droptype": "D",
    "dropname": "CENTERVIEW",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "CENTERVIEW",
    "dropdelst": "MO",
    "dropdelzpp": 640199998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "CENTERVIEW",
    "dropphyst": "MO",
    "dropphyzpp": 640199998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "CENTERVIEW",
    "dropmalst": "MO",
    "dropmalzpp": 640199998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606563413,
    "dropsitcph": 6606563413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16146",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "2312 GREEN ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 636339998,
    "dropphyadd": "2312 GREEN ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 636339998,
    "dropmaladd": "2312 GREEN ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 636339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736482323,
    "dropsitcph": 5736482323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16149",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "104 W SNEED ST",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "MO",
    "dropdelzpp": 652409998,
    "dropphyadd": "104 W SNEED ST",
    "dropphycty": "CENTRALIA",
    "dropphyst": "MO",
    "dropphyzpp": 652409998,
    "dropmaladd": "104 W SNEED ST",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "MO",
    "dropmalzpp": 652409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736822912,
    "dropsitcph": 5736822912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16151",
    "droptype": "D",
    "dropname": "CHADWICK",
    "dropdeladd": "6409 STATE HIGHWAY 125 S",
    "dropdelcty": "CHADWICK",
    "dropdelst": "MO",
    "dropdelzpp": 656299998,
    "dropphyadd": "6409 STATE HIGHWAY 125 S",
    "dropphycty": "CHADWICK",
    "dropphyst": "MO",
    "dropphyzpp": 656299998,
    "dropmaladd": "6409 STATE HIGHWAY 125 S",
    "dropmalcty": "CHADWICK",
    "dropmalst": "MO",
    "dropmalzpp": 656299998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176343287,
    "dropsitcph": 4176343287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16152",
    "droptype": "D",
    "dropname": "CHAFFEE",
    "dropdeladd": "217 S MAIN ST",
    "dropdelcty": "CHAFFEE",
    "dropdelst": "MO",
    "dropdelzpp": 637409998,
    "dropphyadd": "217 S MAIN ST",
    "dropphycty": "CHAFFEE",
    "dropphyst": "MO",
    "dropphyzpp": 637409998,
    "dropmaladd": "217 S MAIN ST",
    "dropmalcty": "CHAFFEE",
    "dropmalst": "MO",
    "dropmalzpp": 637409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738873594,
    "dropsitcph": 5738873594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16154",
    "droptype": "D",
    "dropname": "CHAMOIS",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "CHAMOIS",
    "dropdelst": "MO",
    "dropdelzpp": 650249998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "CHAMOIS",
    "dropphyst": "MO",
    "dropphyzpp": 650249998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "CHAMOIS",
    "dropmalst": "MO",
    "dropmalzpp": 650249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737635377,
    "dropsitcph": 5737635377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16160",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "300 S MAIN ST",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "MO",
    "dropdelzpp": 638349998,
    "dropphyadd": "300 S MAIN ST",
    "dropphycty": "CHARLESTON",
    "dropphyst": "MO",
    "dropphyzpp": 638349998,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "MO",
    "dropmalzpp": 638349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736839076,
    "dropsitcph": 5736839076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16163",
    "droptype": "D",
    "dropname": "CHERRYVILLE",
    "dropdeladd": "20376 HIGHWAY 19",
    "dropdelcty": "CHERRYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 654469998,
    "dropphyadd": "20376 HIGHWAY 19",
    "dropphycty": "CHERRYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 654469998,
    "dropmaladd": "20376 HIGHWAY 19",
    "dropmalcty": "CHERRYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 654469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737436601,
    "dropsitcph": 5737436601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16165",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "16105 SWINGLEY RIDGE RD",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 630179998,
    "dropphyadd": "16105 SWINGLEY RIDGE RD",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 630179998,
    "dropmaladd": "16105 SWINGLEY RIDGE RD",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 630179998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365324174,
    "dropsitcph": 6365325999,
    "dropfax": 6365328203
  },
  {
    "dcode": "D",
    "dropkey": "PW16171",
    "droptype": "D",
    "dropname": "CHILHOWEE",
    "dropdeladd": "111 E WALNUT ST",
    "dropdelcty": "CHILHOWEE",
    "dropdelst": "MO",
    "dropdelzpp": 647339998,
    "dropphyadd": "111 E WALNUT ST",
    "dropphycty": "CHILHOWEE",
    "dropphyst": "MO",
    "dropphyzpp": 647339998,
    "dropmaladd": "111 E WALNUT ST",
    "dropmalcty": "CHILHOWEE",
    "dropmalst": "MO",
    "dropmalzpp": 647339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606782271,
    "dropsitcph": 6606782271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16173",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "401 S WASHINGTON ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "MO",
    "dropdelzpp": 646019998,
    "dropphyadd": "401 S WASHINGTON ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "MO",
    "dropphyzpp": 646019998,
    "dropmaladd": "401 S WASHINGTON ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "MO",
    "dropmalzpp": 646019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606461133,
    "dropsitcph": 6606461133,
    "dropfax": 6606464063
  },
  {
    "dcode": "D",
    "dropkey": "PW16177",
    "droptype": "D",
    "dropname": "CHULA",
    "dropdeladd": "640 MANSUR ST",
    "dropdelcty": "CHULA",
    "dropdelst": "MO",
    "dropdelzpp": 646359998,
    "dropphyadd": "640 MANSUR ST",
    "dropphycty": "CHULA",
    "dropphyst": "MO",
    "dropphyzpp": 646359998,
    "dropmaladd": "640 MANSUR ST",
    "dropmalcty": "CHULA",
    "dropmalst": "MO",
    "dropmalzpp": 646359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606393965,
    "dropsitcph": 6606393965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16180",
    "droptype": "D",
    "dropname": "CLARENCE",
    "dropdeladd": "101 N GRAND ST",
    "dropdelcty": "CLARENCE",
    "dropdelst": "MO",
    "dropdelzpp": 634379998,
    "dropphyadd": "101 N GRAND ST",
    "dropphycty": "CLARENCE",
    "dropphyst": "MO",
    "dropphyzpp": 634379998,
    "dropmaladd": "101 N GRAND ST",
    "dropmalcty": "CLARENCE",
    "dropmalst": "MO",
    "dropmalzpp": 634379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606992440,
    "dropsitcph": 6606992440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16181",
    "droptype": "D",
    "dropname": "CLARK",
    "dropdeladd": "104 HUBBARD ST",
    "dropdelcty": "CLARK",
    "dropdelst": "MO",
    "dropdelzpp": 652439998,
    "dropphyadd": "104 HUBBARD ST",
    "dropphycty": "CLARK",
    "dropphyst": "MO",
    "dropphyzpp": 652439998,
    "dropmaladd": "104 HUBBARD ST",
    "dropmalcty": "CLARK",
    "dropmalst": "MO",
    "dropmalzpp": 652439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736415704,
    "dropsitcph": 5736415704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16184",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "112 W STATE ST",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 650259998,
    "dropphyadd": "112 W STATE ST",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 650259998,
    "dropmaladd": "112 W STATE ST",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 650259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737873512,
    "dropsitcph": 5737873512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16185",
    "droptype": "D",
    "dropname": "CLARKSDALE",
    "dropdeladd": "105 MAY ST",
    "dropdelcty": "CLARKSDALE",
    "dropdelst": "MO",
    "dropdelzpp": 644309998,
    "dropphyadd": "105 MAY ST",
    "dropphycty": "CLARKSDALE",
    "dropphyst": "MO",
    "dropphyzpp": 644309998,
    "dropmaladd": "105 MAY ST",
    "dropmalcty": "CLARKSDALE",
    "dropmalst": "MO",
    "dropmalzpp": 644309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163935217,
    "dropsitcph": 8163935217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16188",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "309 S 1ST ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633369998,
    "dropphyadd": "309 S 1ST ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633369998,
    "dropmaladd": "309 S 1ST ST",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732423960,
    "dropsitcph": 5732423960,
    "dropfax": 5732429622
  },
  {
    "dcode": "D",
    "dropkey": "PW16191",
    "droptype": "D",
    "dropname": "CLARKTON",
    "dropdeladd": "109 N MAIN ST",
    "dropdelcty": "CLARKTON",
    "dropdelst": "MO",
    "dropdelzpp": 638379998,
    "dropphyadd": "109 N MAIN ST",
    "dropphycty": "CLARKTON",
    "dropphyst": "MO",
    "dropphyzpp": 638379998,
    "dropmaladd": "109 N MAIN ST",
    "dropmalcty": "CLARKTON",
    "dropmalst": "MO",
    "dropmalzpp": 638379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734485585,
    "dropsitcph": 5734485585,
    "dropfax": 5734483177
  },
  {
    "dcode": "D",
    "dropkey": "PW16197",
    "droptype": "D",
    "dropname": "CLEARMONT",
    "dropdeladd": "201 2ND ST",
    "dropdelcty": "CLEARMONT",
    "dropdelst": "MO",
    "dropdelzpp": 644319998,
    "dropphyadd": "201 2ND ST",
    "dropphycty": "CLEARMONT",
    "dropphyst": "MO",
    "dropphyzpp": 644319998,
    "dropmaladd": "201 2ND ST",
    "dropmalcty": "CLEARMONT",
    "dropmalst": "MO",
    "dropmalzpp": 644319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607293325,
    "dropsitcph": 6607293325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16200",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "MO",
    "dropdelzpp": 647349998,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "MO",
    "dropphyzpp": 647349998,
    "dropmaladd": "215 MAIN ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "MO",
    "dropmalzpp": 647349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166583200,
    "dropsitcph": 8166583200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16203",
    "droptype": "D",
    "dropname": "CLEVER",
    "dropdeladd": "209 CLARKE AVE",
    "dropdelcty": "CLEVER",
    "dropdelst": "MO",
    "dropdelzpp": 656319998,
    "dropphyadd": "209 CLARKE AVE",
    "dropphycty": "CLEVER",
    "dropphyst": "MO",
    "dropphyzpp": 656319998,
    "dropmaladd": "209 CLARKE AVE",
    "dropmalcty": "CLEVER",
    "dropmalst": "MO",
    "dropmalzpp": 656319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177432131,
    "dropsitcph": 4177432131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16204",
    "droptype": "D",
    "dropname": "CLIFTON HILL",
    "dropdeladd": "639 HARLAN ST",
    "dropdelcty": "CLIFTON HILL",
    "dropdelst": "MO",
    "dropdelzpp": 652449998,
    "dropphyadd": "639 HARLAN ST",
    "dropphycty": "CLIFTON HILL",
    "dropphyst": "MO",
    "dropphyzpp": 652449998,
    "dropmaladd": "639 HARLAN ST",
    "dropmalcty": "CLIFTON HILL",
    "dropmalst": "MO",
    "dropmalzpp": 652449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602614468,
    "dropsitcph": 6602614468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16207",
    "droptype": "D",
    "dropname": "CLIMAX SPRINGS",
    "dropdeladd": "14389 N STATE HIGHWAY 7",
    "dropdelcty": "CLIMAX SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 653249998,
    "dropphyadd": "14389 N STATE HIGHWAY 7",
    "dropphycty": "CLIMAX SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 653249998,
    "dropmaladd": "14389 N STATE HIGHWAY 7",
    "dropmalcty": "CLIMAX SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 653249998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733472312,
    "dropsitcph": 5733472312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16208",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "101 S 2ND ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "MO",
    "dropdelzpp": 647359998,
    "dropphyadd": "101 S 2ND ST",
    "dropphycty": "CLINTON",
    "dropphyst": "MO",
    "dropphyzpp": 647359998,
    "dropmaladd": "101 S 2ND ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "MO",
    "dropmalzpp": 647359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608855221,
    "dropsitcph": 6608855221,
    "dropfax": 6608854071
  },
  {
    "dcode": "D",
    "dropkey": "PW16213",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "404 MAIN ST",
    "dropdelcty": "CLYDE",
    "dropdelst": "MO",
    "dropdelzpp": 644329998,
    "dropphyadd": "404 MAIN ST",
    "dropphycty": "CLYDE",
    "dropphyst": "MO",
    "dropphyzpp": 644329998,
    "dropmaladd": "404 MAIN ST",
    "dropmalcty": "CLYDE",
    "dropmalst": "MO",
    "dropmalzpp": 644329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605043362,
    "dropsitcph": 6609442516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16216",
    "droptype": "D",
    "dropname": "COFFEY",
    "dropdeladd": "212 E STATE HIGHWAY B",
    "dropdelcty": "COFFEY",
    "dropdelst": "MO",
    "dropdelzpp": 646369998,
    "dropphyadd": "212 E STATE HIGHWAY B",
    "dropphycty": "COFFEY",
    "dropphyst": "MO",
    "dropphyzpp": 646369998,
    "dropmaladd": "212 E STATE HIGHWAY B",
    "dropmalcty": "COFFEY",
    "dropmalst": "MO",
    "dropmalzpp": 646369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605332875,
    "dropsitcph": 6605332875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16219",
    "droptype": "D",
    "dropname": "COLE CAMP",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "COLE CAMP",
    "dropdelst": "MO",
    "dropdelzpp": 653259998,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "COLE CAMP",
    "dropphyst": "MO",
    "dropphyzpp": 653259998,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "COLE CAMP",
    "dropmalst": "MO",
    "dropmalzpp": 653259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606683321,
    "dropsitcph": 6606683321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16223",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "1312 MAIN ST",
    "dropdelcty": "COLLINS",
    "dropdelst": "MO",
    "dropdelzpp": 647389998,
    "dropphyadd": "1312 MAIN ST",
    "dropphycty": "COLLINS",
    "dropphyst": "MO",
    "dropphyzpp": 647389998,
    "dropmaladd": "1312 MAIN ST",
    "dropmalcty": "COLLINS",
    "dropmalst": "MO",
    "dropmalzpp": 647389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172754329,
    "dropsitcph": 4172754329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16226",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "511 E WALNUT ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652019998,
    "dropphyadd": "511 E WALNUT ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652019998,
    "dropmaladd": "511 E WALNUT ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738767844,
    "dropsitcph": 5738767800,
    "dropfax": 6513066249
  },
  {
    "dcode": "D",
    "dropkey": "PW16232",
    "droptype": "D",
    "dropname": "CONCEPTION",
    "dropdeladd": "37114 STATE HIGHWAY VV",
    "dropdelcty": "CONCEPTION",
    "dropdelst": "MO",
    "dropdelzpp": 644339998,
    "dropphyadd": "37114 STATE HIGHWAY VV",
    "dropphycty": "CONCEPTION",
    "dropphyst": "MO",
    "dropphyzpp": 644339998,
    "dropmaladd": "37114 STATE HIGHWAY VV",
    "dropmalcty": "CONCEPTION",
    "dropmalst": "MO",
    "dropmalzpp": 644339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609442324,
    "dropsitcph": 6609442324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16233",
    "droptype": "D",
    "dropname": "CONCEPTION JUNCTION",
    "dropdeladd": "609 S MAIN ST",
    "dropdelcty": "CONCEPTION JUNCTION",
    "dropdelst": "MO",
    "dropdelzpp": 644349998,
    "dropphyadd": "609 S MAIN ST",
    "dropphycty": "CONCEPTION JUNCTION",
    "dropphyst": "MO",
    "dropphyzpp": 644349998,
    "dropmaladd": "609 S MAIN ST",
    "dropmalcty": "CONCEPTION JUNCTION",
    "dropmalst": "MO",
    "dropmalzpp": 644349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609442260,
    "dropsitcph": 6609442260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16234",
    "droptype": "D",
    "dropname": "CONCORDIA",
    "dropdeladd": "13 SE 7TH ST",
    "dropdelcty": "CONCORDIA",
    "dropdelst": "MO",
    "dropdelzpp": 640209998,
    "dropphyadd": "13 SE 7TH ST",
    "dropphycty": "CONCORDIA",
    "dropphyst": "MO",
    "dropphyzpp": 640209998,
    "dropmaladd": "13 SE 7TH ST",
    "dropmalcty": "CONCORDIA",
    "dropmalst": "MO",
    "dropmalzpp": 640209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604632263,
    "dropsitcph": 6604632263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16238",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "601 W JEFFERSON AVE STE D",
    "dropdelcty": "CONWAY",
    "dropdelst": "MO",
    "dropdelzpp": 656329998,
    "dropphyadd": "601 W JEFFERSON AVE STE D",
    "dropphycty": "CONWAY",
    "dropphyst": "MO",
    "dropphyzpp": 656329998,
    "dropmaladd": "601 W JEFFERSON AVE STE D",
    "dropmalcty": "CONWAY",
    "dropmalst": "MO",
    "dropmalzpp": 656329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175893111,
    "dropsitcph": 4175893111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16244",
    "droptype": "D",
    "dropname": "COOTER",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "COOTER",
    "dropdelst": "MO",
    "dropdelzpp": 638399998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "COOTER",
    "dropphyst": "MO",
    "dropphyzpp": 638399998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "COOTER",
    "dropmalst": "MO",
    "dropmalzpp": 638399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736953618,
    "dropsitcph": 5736953618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16246",
    "droptype": "D",
    "dropname": "CORDER",
    "dropdeladd": "222 N LAFAYETTE ST",
    "dropdelcty": "CORDER",
    "dropdelst": "MO",
    "dropdelzpp": 640219998,
    "dropphyadd": "222 N LAFAYETTE ST",
    "dropphycty": "CORDER",
    "dropphyst": "MO",
    "dropphyzpp": 640219998,
    "dropmaladd": "222 N LAFAYETTE ST",
    "dropmalcty": "CORDER",
    "dropmalst": "MO",
    "dropmalzpp": 640219998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603942550,
    "dropsitcph": 6603942550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16250",
    "droptype": "D",
    "dropname": "COSBY",
    "dropdeladd": "421 LEIDY ST",
    "dropdelcty": "COSBY",
    "dropdelst": "MO",
    "dropdelzpp": 644369998,
    "dropphyadd": "421 LEIDY ST",
    "dropphycty": "COSBY",
    "dropphyst": "MO",
    "dropphyzpp": 644369998,
    "dropmaladd": "421 LEIDY ST",
    "dropmalcty": "COSBY",
    "dropmalst": "MO",
    "dropmalzpp": 644369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163783245,
    "dropsitcph": 8163783245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16251",
    "droptype": "D",
    "dropname": "COTTLEVILLE",
    "dropdeladd": "5323 HIGHWAY N",
    "dropdelcty": "COTTLEVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633389998,
    "dropphyadd": "5323 HIGHWAY N",
    "dropphycty": "COTTLEVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633389998,
    "dropmaladd": "5323 HIGHWAY N",
    "dropmalcty": "COTTLEVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364476537,
    "dropsitcph": 6364476537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16262",
    "droptype": "D",
    "dropname": "COWGILL",
    "dropdeladd": "460 MAIN ST",
    "dropdelcty": "COWGILL",
    "dropdelst": "MO",
    "dropdelzpp": 646379998,
    "dropphyadd": "460 MAIN ST",
    "dropphycty": "COWGILL",
    "dropphyst": "MO",
    "dropphyzpp": 646379998,
    "dropmaladd": "460 MAIN ST",
    "dropmalcty": "COWGILL",
    "dropmalst": "MO",
    "dropmalzpp": 646379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602554521,
    "dropsitcph": 6602554521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16265",
    "droptype": "D",
    "dropname": "CRAIG",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "CRAIG",
    "dropdelst": "MO",
    "dropdelzpp": 644379998,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "CRAIG",
    "dropphyst": "MO",
    "dropphyzpp": 644379998,
    "dropmaladd": "103 S MAIN ST",
    "dropmalcty": "CRAIG",
    "dropmalst": "MO",
    "dropmalzpp": 644379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606835623,
    "dropsitcph": 6606835623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16266",
    "droptype": "D",
    "dropname": "CRANE",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "CRANE",
    "dropdelst": "MO",
    "dropdelzpp": 656339998,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "CRANE",
    "dropphyst": "MO",
    "dropphyzpp": 656339998,
    "dropmaladd": "118 MAIN ST",
    "dropmalcty": "CRANE",
    "dropmalst": "MO",
    "dropmalzpp": 656339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177191255,
    "dropsitcph": 4177191255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16268",
    "droptype": "D",
    "dropname": "CREIGHTON",
    "dropdeladd": "200 W 2ND ST",
    "dropdelcty": "CREIGHTON",
    "dropdelst": "MO",
    "dropdelzpp": 647399998,
    "dropphyadd": "200 W 2ND ST",
    "dropphycty": "CREIGHTON",
    "dropphyst": "MO",
    "dropphyzpp": 647399998,
    "dropmaladd": "200 W 2ND ST",
    "dropmalcty": "CREIGHTON",
    "dropmalst": "MO",
    "dropmalzpp": 647399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604992391,
    "dropsitcph": 6604992391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16284",
    "droptype": "D",
    "dropname": "CROCKER",
    "dropdeladd": "109 10TH ST",
    "dropdelcty": "CROCKER",
    "dropdelst": "MO",
    "dropdelzpp": 654529998,
    "dropphyadd": "109 10TH ST",
    "dropphycty": "CROCKER",
    "dropphyst": "MO",
    "dropphyzpp": 654529998,
    "dropmaladd": "109 10TH ST",
    "dropmalcty": "CROCKER",
    "dropmalst": "MO",
    "dropmalzpp": 654529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737362617,
    "dropsitcph": 5737362617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16286",
    "droptype": "D",
    "dropname": "CROSS TIMBERS",
    "dropdeladd": "12808 PARK ST",
    "dropdelcty": "CROSS TIMBERS",
    "dropdelst": "MO",
    "dropdelzpp": 656349998,
    "dropphyadd": "12808 PARK ST",
    "dropphycty": "CROSS TIMBERS",
    "dropphyst": "MO",
    "dropphyzpp": 656349998,
    "dropmaladd": "12808 PARK ST",
    "dropmalcty": "CROSS TIMBERS",
    "dropmalst": "MO",
    "dropmalzpp": 656349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179986341,
    "dropsitcph": 4179986341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16288",
    "droptype": "D",
    "dropname": "CRYSTAL CITY",
    "dropdeladd": "324 BAILEY RD",
    "dropdelcty": "CRYSTAL CITY",
    "dropdelst": "MO",
    "dropdelzpp": 630199998,
    "dropphyadd": "324 BAILEY RD",
    "dropphycty": "CRYSTAL CITY",
    "dropphyst": "MO",
    "dropphyzpp": 630199998,
    "dropmaladd": "324 BAILEY RD",
    "dropmalcty": "CRYSTAL CITY",
    "dropmalst": "MO",
    "dropmalzpp": 630199998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369375430,
    "dropsitcph": 6369375430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16296",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "703 W WASHINGTON ST",
    "dropdelcty": "CUBA",
    "dropdelst": "MO",
    "dropdelzpp": 654539998,
    "dropphyadd": "703 W WASHINGTON ST",
    "dropphycty": "CUBA",
    "dropphyst": "MO",
    "dropphyzpp": 654539998,
    "dropmaladd": "703 W WASHINGTON ST",
    "dropmalcty": "CUBA",
    "dropmalst": "MO",
    "dropmalzpp": 654539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738853612,
    "dropsitcph": 5738853612,
    "dropfax": 5738853612
  },
  {
    "dcode": "D",
    "dropkey": "PW16297",
    "droptype": "D",
    "dropname": "CURRYVILLE",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "CURRYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633399998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "CURRYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633399998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "CURRYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733243597,
    "dropsitcph": 5733243597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16301",
    "droptype": "D",
    "dropname": "DADEVILLE",
    "dropdeladd": "103 E MAIN ST STE 103",
    "dropdelcty": "DADEVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656359998,
    "dropphyadd": "103 E MAIN ST STE 103",
    "dropphycty": "DADEVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656359998,
    "dropmaladd": "103 E MAIN ST STE 103",
    "dropmalcty": "DADEVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179953300,
    "dropsitcph": 4179953300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16313",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "408 CENTRE ST",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 644389998,
    "dropphyadd": "408 CENTRE ST",
    "dropphycty": "DARLINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 644389998,
    "dropmaladd": "408 CENTRE ST",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 644389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606662315,
    "dropsitcph": 6606662315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16317",
    "droptype": "D",
    "dropname": "DAWN",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "DAWN",
    "dropdelst": "MO",
    "dropdelzpp": 646389998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "DAWN",
    "dropphyst": "MO",
    "dropphyzpp": 646389998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "DAWN",
    "dropmalst": "MO",
    "dropmalzpp": 646389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607453330,
    "dropsitcph": 6607453330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16318",
    "droptype": "D",
    "dropname": "DE KALB",
    "dropdeladd": "503 MAIN ST",
    "dropdelcty": "DE KALB",
    "dropdelst": "MO",
    "dropdelzpp": 644409998,
    "dropphyadd": "503 MAIN ST",
    "dropphycty": "DE KALB",
    "dropphyst": "MO",
    "dropphyzpp": 644409998,
    "dropmaladd": "503 MAIN ST",
    "dropmalcty": "DE KALB",
    "dropmalst": "MO",
    "dropmalzpp": 644409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166853122,
    "dropsitcph": 8166853122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16319",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "950 BOYD ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "MO",
    "dropdelzpp": 630209998,
    "dropphyadd": "950 BOYD ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "MO",
    "dropphyzpp": 630209998,
    "dropmaladd": "950 BOYD ST",
    "dropmalcty": "DE SOTO",
    "dropmalst": "MO",
    "dropmalzpp": 630209998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365865617,
    "dropsitcph": 6365865617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16320",
    "droptype": "D",
    "dropname": "DE WITT",
    "dropdeladd": "711 JEFFERSON ST",
    "dropdelcty": "DE WITT",
    "dropdelst": "MO",
    "dropdelzpp": 646399998,
    "dropphyadd": "711 JEFFERSON ST",
    "dropphycty": "DE WITT",
    "dropphyst": "MO",
    "dropphyzpp": 646399998,
    "dropmaladd": "711 JEFFERSON ST",
    "dropmalcty": "DE WITT",
    "dropmalst": "MO",
    "dropmalzpp": 646399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605493421,
    "dropsitcph": 6605493421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16321",
    "droptype": "D",
    "dropname": "DEARBORN",
    "dropdeladd": "109 W 3RD ST",
    "dropdelcty": "DEARBORN",
    "dropdelst": "MO",
    "dropdelzpp": 644399998,
    "dropphyadd": "109 W 3RD ST",
    "dropphycty": "DEARBORN",
    "dropphyst": "MO",
    "dropphyzpp": 644399998,
    "dropmaladd": "109 W 3RD ST",
    "dropmalcty": "DEARBORN",
    "dropmalst": "MO",
    "dropmalzpp": 644399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8169923624,
    "dropsitcph": 8169923624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16322",
    "droptype": "D",
    "dropname": "DEEPWATER",
    "dropdeladd": "108 S 8TH ST",
    "dropdelcty": "DEEPWATER",
    "dropdelst": "MO",
    "dropdelzpp": 647409998,
    "dropphyadd": "108 S 8TH ST",
    "dropphycty": "DEEPWATER",
    "dropphyst": "MO",
    "dropphyzpp": 647409998,
    "dropmaladd": "108 S 8TH ST",
    "dropmalcty": "DEEPWATER",
    "dropmalst": "MO",
    "dropmalzpp": 647409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606962466,
    "dropsitcph": 6606962466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16325",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 647419998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "DEERFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 647419998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 647419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179667277,
    "dropsitcph": 4179667277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16327",
    "droptype": "D",
    "dropname": "DEERING",
    "dropdeladd": "6296 STATE HIGHWAY J",
    "dropdelcty": "DEERING",
    "dropdelst": "MO",
    "dropdelzpp": 638409998,
    "dropphyadd": "6296 STATE HIGHWAY J",
    "dropphycty": "DEERING",
    "dropphyst": "MO",
    "dropphyzpp": 638409998,
    "dropmaladd": "6296 STATE HIGHWAY J",
    "dropmalcty": "DEERING",
    "dropmalst": "MO",
    "dropmalzpp": 638409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737576208,
    "dropsitcph": 5737576208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16328",
    "droptype": "D",
    "dropname": "DEFIANCE",
    "dropdeladd": "2959 S HIGHWAY 94",
    "dropdelcty": "DEFIANCE",
    "dropdelst": "MO",
    "dropdelzpp": 633419998,
    "dropphyadd": "2959 S HIGHWAY 94",
    "dropphycty": "DEFIANCE",
    "dropphyst": "MO",
    "dropphyzpp": 633419998,
    "dropmaladd": "2959 S HIGHWAY 94",
    "dropmalcty": "DEFIANCE",
    "dropmalst": "MO",
    "dropmalzpp": 633419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369872407,
    "dropsitcph": 6369872407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16331",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "114 S JACKSON ST",
    "dropdelcty": "DELTA",
    "dropdelst": "MO",
    "dropdelzpp": 637449998,
    "dropphyadd": "114 S JACKSON ST",
    "dropphycty": "DELTA",
    "dropphyst": "MO",
    "dropphyzpp": 637449998,
    "dropmaladd": "114 S JACKSON ST",
    "dropmalcty": "DELTA",
    "dropmalst": "MO",
    "dropmalzpp": 637449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737942717,
    "dropsitcph": 5737942717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16332",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "311 NORTH ST",
    "dropdelcty": "DENVER",
    "dropdelst": "MO",
    "dropdelzpp": 644419998,
    "dropphyadd": "311 NORTH ST",
    "dropphycty": "DENVER",
    "dropphyst": "MO",
    "dropphyzpp": 644419998,
    "dropmaladd": "311 NORTH ST",
    "dropmalcty": "DENVER",
    "dropmalst": "MO",
    "dropmalzpp": 644419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603262325,
    "dropsitcph": 6603262325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16334",
    "droptype": "D",
    "dropname": "DES ARC",
    "dropdeladd": "226 N FRONT ST",
    "dropdelcty": "DES ARC",
    "dropdelst": "MO",
    "dropdelzpp": 636369998,
    "dropphyadd": "226 N FRONT ST",
    "dropphycty": "DES ARC",
    "dropphyst": "MO",
    "dropphyzpp": 636369998,
    "dropmaladd": "226 N FRONT ST",
    "dropmalcty": "DES ARC",
    "dropmalst": "MO",
    "dropmalzpp": 636369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735983341,
    "dropsitcph": 5735983341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16342",
    "droptype": "D",
    "dropname": "DEVILS ELBOW",
    "dropdeladd": "12175 TIMBER RD",
    "dropdelcty": "DEVILS ELBOW",
    "dropdelst": "MO",
    "dropdelzpp": 654579998,
    "dropphyadd": "12175 TIMBER RD",
    "dropphycty": "DEVILS ELBOW",
    "dropphyst": "MO",
    "dropphyzpp": 654579998,
    "dropmaladd": "12175 TIMBER RD",
    "dropmalcty": "DEVILS ELBOW",
    "dropmalst": "MO",
    "dropmalzpp": 654579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733369446,
    "dropsitcph": 5733369446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16344",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "202 E STODDARD ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "MO",
    "dropdelzpp": 638419998,
    "dropphyadd": "202 E STODDARD ST",
    "dropphycty": "DEXTER",
    "dropphyst": "MO",
    "dropphyzpp": 638419998,
    "dropmaladd": "202 E STODDARD ST",
    "dropmalcty": "DEXTER",
    "dropmalst": "MO",
    "dropmalzpp": 638419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736243684,
    "dropsitcph": 5736243684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16345",
    "droptype": "D",
    "dropname": "DIAMOND",
    "dropdeladd": "103 E MARKET ST",
    "dropdelcty": "DIAMOND",
    "dropdelst": "MO",
    "dropdelzpp": 648409998,
    "dropphyadd": "103 E MARKET ST",
    "dropphycty": "DIAMOND",
    "dropphyst": "MO",
    "dropphyzpp": 648409998,
    "dropmaladd": "103 E MARKET ST",
    "dropmalcty": "DIAMOND",
    "dropmalst": "MO",
    "dropmalzpp": 648409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163255200,
    "dropsitcph": 4173255200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16347",
    "droptype": "D",
    "dropname": "DIGGINS",
    "dropdeladd": "505 PLAZA DR",
    "dropdelcty": "DIGGINS",
    "dropdelst": "MO",
    "dropdelzpp": 656369998,
    "dropphyadd": "505 PLAZA DR",
    "dropphycty": "DIGGINS",
    "dropphyst": "MO",
    "dropphyzpp": 656369998,
    "dropmaladd": "505 PLAZA DR",
    "dropmalcty": "DIGGINS",
    "dropmalst": "MO",
    "dropmalzpp": 656369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177382610,
    "dropsitcph": 4177382610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16350",
    "droptype": "D",
    "dropname": "DITTMER",
    "dropdeladd": "7768 STATE ROUTE 30",
    "dropdelcty": "DITTMER",
    "dropdelst": "MO",
    "dropdelzpp": 630239998,
    "dropphyadd": "7768 STATE ROUTE 30",
    "dropphycty": "DITTMER",
    "dropphyst": "MO",
    "dropphyzpp": 630239998,
    "dropmaladd": "7768 STATE ROUTE 30",
    "dropmalcty": "DITTMER",
    "dropmalst": "MO",
    "dropmalzpp": 630239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362850947,
    "dropsitcph": 6362850935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16356",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "102 W 2ND ST",
    "dropdelcty": "DIXON",
    "dropdelst": "MO",
    "dropdelzpp": 654599998,
    "dropphyadd": "102 W 2ND ST",
    "dropphycty": "DIXON",
    "dropphyst": "MO",
    "dropphyzpp": 654599998,
    "dropmaladd": "102 W 2ND ST",
    "dropmalcty": "DIXON",
    "dropmalst": "MO",
    "dropmalzpp": 654599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737597219,
    "dropsitcph": 5737597219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16358",
    "droptype": "D",
    "dropname": "DONIPHAN",
    "dropdeladd": "303 N GRAND AVE",
    "dropdelcty": "DONIPHAN",
    "dropdelst": "MO",
    "dropdelzpp": 639359998,
    "dropphyadd": "303 N GRAND AVE",
    "dropphycty": "DONIPHAN",
    "dropphyst": "MO",
    "dropphyzpp": 639359998,
    "dropmaladd": "303 N GRAND AVE",
    "dropmalcty": "DONIPHAN",
    "dropmalst": "MO",
    "dropmalzpp": 639359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5739963621,
    "dropsitcph": 5739963621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16360",
    "droptype": "D",
    "dropname": "DORA",
    "dropdeladd": "100 COUNTY ROAD 379",
    "dropdelcty": "DORA",
    "dropdelst": "MO",
    "dropdelzpp": 656379998,
    "dropphyadd": "100 COUNTY ROAD 379",
    "dropphycty": "DORA",
    "dropphyst": "MO",
    "dropphyzpp": 656379998,
    "dropmaladd": "100 COUNTY ROAD 379",
    "dropmalcty": "DORA",
    "dropmalst": "MO",
    "dropmalzpp": 656379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172612512,
    "dropsitcph": 4172612512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16362",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "270 W WALNUT ST",
    "dropdelcty": "DOVER",
    "dropdelst": "MO",
    "dropdelzpp": 640229998,
    "dropphyadd": "270 W WALNUT ST",
    "dropphycty": "DOVER",
    "dropphyst": "MO",
    "dropphyzpp": 640229998,
    "dropmaladd": "270 W WALNUT ST",
    "dropmalcty": "DOVER",
    "dropmalst": "MO",
    "dropmalzpp": 640229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602594991,
    "dropsitcph": 6602594991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16363",
    "droptype": "D",
    "dropname": "DOWNING",
    "dropdeladd": "101 W PRIME ST",
    "dropdelcty": "DOWNING",
    "dropdelst": "MO",
    "dropdelzpp": 635369998,
    "dropphyadd": "101 W PRIME ST",
    "dropphycty": "DOWNING",
    "dropphyst": "MO",
    "dropphyzpp": 635369998,
    "dropmaladd": "101 W PRIME ST",
    "dropmalcty": "DOWNING",
    "dropmalst": "MO",
    "dropmalzpp": 635369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603792301,
    "dropsitcph": 6603792301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16367",
    "droptype": "D",
    "dropname": "DREXEL",
    "dropdeladd": "118 S 2ND ST",
    "dropdelcty": "DREXEL",
    "dropdelst": "MO",
    "dropdelzpp": 647429998,
    "dropphyadd": "118 S 2ND ST",
    "dropphycty": "DREXEL",
    "dropphyst": "MO",
    "dropphyzpp": 647429998,
    "dropmaladd": "118 S 2ND ST",
    "dropmalcty": "DREXEL",
    "dropmalst": "MO",
    "dropmalzpp": 647429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166572036,
    "dropsitcph": 8166572036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16369",
    "droptype": "D",
    "dropname": "DUDLEY",
    "dropdeladd": "10363 BRENDA ST",
    "dropdelcty": "DUDLEY",
    "dropdelst": "MO",
    "dropdelzpp": 639369998,
    "dropphyadd": "10363 BRENDA ST",
    "dropphycty": "DUDLEY",
    "dropphyst": "MO",
    "dropphyzpp": 639369998,
    "dropmaladd": "10363 BRENDA ST",
    "dropmalcty": "DUDLEY",
    "dropmalst": "MO",
    "dropmalzpp": 639369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736242961,
    "dropsitcph": 5736242961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16370",
    "droptype": "D",
    "dropname": "DUENWEG",
    "dropdeladd": "201 WOLFE DR",
    "dropdelcty": "DUENWEG",
    "dropdelst": "MO",
    "dropdelzpp": 648419998,
    "dropphyadd": "201 WOLFE DR",
    "dropphycty": "DUENWEG",
    "dropphyst": "MO",
    "dropphyzpp": 648419998,
    "dropmaladd": "201 WOLFE DR",
    "dropmalcty": "DUENWEG",
    "dropmalst": "MO",
    "dropmalzpp": 648419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177821463,
    "dropsitcph": 4177821463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16375",
    "droptype": "D",
    "dropname": "DUNNEGAN",
    "dropdeladd": "3777 S 28TH RD",
    "dropdelcty": "DUNNEGAN",
    "dropdelst": "MO",
    "dropdelzpp": 656409998,
    "dropphyadd": "3777 S 28TH RD",
    "dropphycty": "DUNNEGAN",
    "dropphyst": "MO",
    "dropphyzpp": 656409998,
    "dropmaladd": "3777 S 28TH RD",
    "dropmalcty": "DUNNEGAN",
    "dropmalst": "MO",
    "dropmalzpp": 656409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177542630,
    "dropsitcph": 4177542630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16378",
    "droptype": "D",
    "dropname": "DUTCHTOWN",
    "dropdeladd": "10469 STATE HIGHWAY 25",
    "dropdelcty": "DUTCHTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 637459998,
    "dropphyadd": "10469 STATE HIGHWAY 25",
    "dropphycty": "DUTCHTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 637459998,
    "dropmaladd": "10469 STATE HIGHWAY 25",
    "dropmalcty": "DUTCHTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 637459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733355354,
    "dropsitcph": 5733355354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16379",
    "droptype": "D",
    "dropname": "DUTZOW",
    "dropdeladd": "11854 BLUFF RD",
    "dropdelcty": "DUTZOW",
    "dropdelst": "MO",
    "dropdelzpp": 633421001,
    "dropphyadd": "11854 BLUFF RD",
    "dropphycty": "DUTZOW",
    "dropphyst": "MO",
    "dropphyzpp": 633421001,
    "dropmaladd": "11854 BLUFF RD",
    "dropmalcty": "DUTZOW",
    "dropmalst": "MO",
    "dropmalzpp": 633421001,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364332259,
    "dropsitcph": 6364332259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16384",
    "droptype": "D",
    "dropname": "EAGLE ROCK",
    "dropdeladd": "28815 STATE HIGHWAY 86",
    "dropdelcty": "EAGLE ROCK",
    "dropdelst": "MO",
    "dropdelzpp": 656419998,
    "dropphyadd": "28815 STATE HIGHWAY 86",
    "dropphycty": "EAGLE ROCK",
    "dropphyst": "MO",
    "dropphyzpp": 656419998,
    "dropmaladd": "28815 STATE HIGHWAY 86",
    "dropmalcty": "EAGLE ROCK",
    "dropmalst": "MO",
    "dropmalzpp": 656419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172713434,
    "dropsitcph": 4172713434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16385",
    "droptype": "D",
    "dropname": "EAGLEVILLE",
    "dropdeladd": "14042 14TH ST",
    "dropdelcty": "EAGLEVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644429998,
    "dropphyadd": "14042 14TH ST",
    "dropphycty": "EAGLEVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644429998,
    "dropmaladd": "14042 14TH ST",
    "dropmalcty": "EAGLEVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608675713,
    "dropsitcph": 6608675713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16392",
    "droptype": "D",
    "dropname": "EAST LYNNE",
    "dropdeladd": "415 MAIN ST",
    "dropdelcty": "EAST LYNNE",
    "dropdelst": "MO",
    "dropdelzpp": 647439998,
    "dropphyadd": "415 MAIN ST",
    "dropphycty": "EAST LYNNE",
    "dropphyst": "MO",
    "dropphyzpp": 647439998,
    "dropmaladd": "415 MAIN ST",
    "dropmalcty": "EAST LYNNE",
    "dropmalst": "MO",
    "dropmalzpp": 647439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168693442,
    "dropsitcph": 8168693442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16393",
    "droptype": "D",
    "dropname": "EAST PRAIRIE",
    "dropdeladd": "122 W PINE ST",
    "dropdelcty": "EAST PRAIRIE",
    "dropdelst": "MO",
    "dropdelzpp": 638459998,
    "dropphyadd": "122 W PINE ST",
    "dropphycty": "EAST PRAIRIE",
    "dropphyst": "MO",
    "dropphyzpp": 638459998,
    "dropmaladd": "122 W PINE ST",
    "dropmalcty": "EAST PRAIRIE",
    "dropmalst": "MO",
    "dropmalzpp": 638459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736492811,
    "dropsitcph": 5736492811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16394",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "201 N BUCKLIN DR",
    "dropdelcty": "EASTON",
    "dropdelst": "MO",
    "dropdelzpp": 644439998,
    "dropphyadd": "201 N BUCKLIN DR",
    "dropphycty": "EASTON",
    "dropphyst": "MO",
    "dropphyzpp": 644439998,
    "dropmaladd": "201 N BUCKLIN DR",
    "dropmalcty": "EASTON",
    "dropmalst": "MO",
    "dropmalzpp": 644439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164732751,
    "dropsitcph": 8164732751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16398",
    "droptype": "D",
    "dropname": "EDGAR SPRINGS",
    "dropdeladd": "579 BROADWAY ST",
    "dropdelcty": "EDGAR SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 654629998,
    "dropphyadd": "579 BROADWAY ST",
    "dropphycty": "EDGAR SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 654629998,
    "dropmaladd": "579 BROADWAY ST",
    "dropmalcty": "EDGAR SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 654629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735484103,
    "dropsitcph": 5735484103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16399",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "604 BELT AVE",
    "dropdelcty": "EDGERTON",
    "dropdelst": "MO",
    "dropdelzpp": 644449998,
    "dropphyadd": "604 BELT AVE",
    "dropphycty": "EDGERTON",
    "dropphyst": "MO",
    "dropphyzpp": 644449998,
    "dropmaladd": "604 BELT AVE",
    "dropmalcty": "EDGERTON",
    "dropmalst": "MO",
    "dropmalzpp": 644449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162273724,
    "dropsitcph": 8162273734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16400",
    "droptype": "D",
    "dropname": "EDINA",
    "dropdeladd": "107 S 2ND ST",
    "dropdelcty": "EDINA",
    "dropdelst": "MO",
    "dropdelzpp": 635379998,
    "dropphyadd": "107 S 2ND ST",
    "dropphycty": "EDINA",
    "dropphyst": "MO",
    "dropphyzpp": 635379998,
    "dropmaladd": "107 S 2ND ST",
    "dropmalcty": "EDINA",
    "dropmalst": "MO",
    "dropmalzpp": 635379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603976283,
    "dropsitcph": 6603976283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16402",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "29184 HIGHWAY 7",
    "dropdelcty": "EDWARDS",
    "dropdelst": "MO",
    "dropdelzpp": 653269998,
    "dropphyadd": "29184 HIGHWAY 7",
    "dropphycty": "EDWARDS",
    "dropphyst": "MO",
    "dropphyzpp": 653269998,
    "dropmaladd": "29184 HIGHWAY 7",
    "dropmalcty": "EDWARDS",
    "dropmalst": "MO",
    "dropmalzpp": 653269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 4179986324,
    "dropsitcph": 4179986324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16404",
    "droptype": "D",
    "dropname": "EL DORADO SPRINGS",
    "dropdeladd": "407 S MAIN ST",
    "dropdelcty": "EL DORADO SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 647449998,
    "dropphyadd": "407 S MAIN ST",
    "dropphycty": "EL DORADO SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 647449998,
    "dropmaladd": "407 S MAIN ST",
    "dropmalcty": "EL DORADO SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 647449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178763311,
    "dropsitcph": 4178763311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16405",
    "droptype": "D",
    "dropname": "ELDON",
    "dropdeladd": "202 E 1ST ST",
    "dropdelcty": "ELDON",
    "dropdelst": "MO",
    "dropdelzpp": 650269998,
    "dropphyadd": "202 E 1ST ST",
    "dropphycty": "ELDON",
    "dropphyst": "MO",
    "dropphyzpp": 650269998,
    "dropmaladd": "202 E 1ST ST",
    "dropmalcty": "ELDON",
    "dropmalst": "MO",
    "dropmalzpp": 650269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733925451,
    "dropsitcph": 5733925451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16408",
    "droptype": "D",
    "dropname": "ELDRIDGE",
    "dropdeladd": "15964 HIGHWAY E",
    "dropdelcty": "ELDRIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 654639998,
    "dropphyadd": "15964 HIGHWAY E",
    "dropphycty": "ELDRIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 654639998,
    "dropmaladd": "15964 HIGHWAY E",
    "dropmalcty": "ELDRIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 654639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174265671,
    "dropsitcph": 4174265671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16409",
    "droptype": "D",
    "dropname": "ELK CREEK",
    "dropdeladd": "15668 STATE ROUTE H",
    "dropdelcty": "ELK CREEK",
    "dropdelst": "MO",
    "dropdelzpp": 654649998,
    "dropphyadd": "15668 STATE ROUTE H",
    "dropphycty": "ELK CREEK",
    "dropphyst": "MO",
    "dropphyzpp": 654649998,
    "dropmaladd": "15668 STATE ROUTE H",
    "dropmalcty": "ELK CREEK",
    "dropmalst": "MO",
    "dropmalzpp": 654649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179624425,
    "dropsitcph": 4179624425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16413",
    "droptype": "D",
    "dropname": "ELKLAND",
    "dropdeladd": "3550 STATE HIGHWAY 38",
    "dropdelcty": "ELKLAND",
    "dropdelst": "MO",
    "dropdelzpp": 656449998,
    "dropphyadd": "3550 STATE HIGHWAY 38",
    "dropphycty": "ELKLAND",
    "dropphyst": "MO",
    "dropphyzpp": 656449998,
    "dropmaladd": "3550 STATE HIGHWAY 38",
    "dropmalcty": "ELKLAND",
    "dropmalst": "MO",
    "dropmalzpp": 656449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179335429,
    "dropsitcph": 4179335429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16414",
    "droptype": "D",
    "dropname": "ELLINGTON",
    "dropdeladd": "301 2ND ST",
    "dropdelcty": "ELLINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 636389998,
    "dropphyadd": "301 2ND ST",
    "dropphycty": "ELLINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 636389998,
    "dropmaladd": "301 2ND ST",
    "dropmalcty": "ELLINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 636389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736637528,
    "dropsitcph": 5736637528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16418",
    "droptype": "D",
    "dropname": "ELLSINORE",
    "dropdeladd": "1 NORTH ST",
    "dropdelcty": "ELLSINORE",
    "dropdelst": "MO",
    "dropdelzpp": 639379998,
    "dropphyadd": "1 NORTH ST",
    "dropphycty": "ELLSINORE",
    "dropphyst": "MO",
    "dropphyzpp": 639379998,
    "dropmaladd": "1 NORTH ST",
    "dropmalcty": "ELLSINORE",
    "dropmalst": "MO",
    "dropmalzpp": 639379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733225427,
    "dropsitcph": 5733225427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16420",
    "droptype": "D",
    "dropname": "ELMER",
    "dropdeladd": "105 N SANTA FE ST",
    "dropdelcty": "ELMER",
    "dropdelst": "MO",
    "dropdelzpp": 635389998,
    "dropphyadd": "105 N SANTA FE ST",
    "dropphycty": "ELMER",
    "dropphyst": "MO",
    "dropphyzpp": 635389998,
    "dropmaladd": "105 N SANTA FE ST",
    "dropmalcty": "ELMER",
    "dropmalst": "MO",
    "dropmalzpp": 635389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608254492,
    "dropsitcph": 6608254492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16421",
    "droptype": "D",
    "dropname": "ELMO",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "ELMO",
    "dropdelst": "MO",
    "dropdelzpp": 644459998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "ELMO",
    "dropphyst": "MO",
    "dropphyzpp": 644459998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "ELMO",
    "dropmalst": "MO",
    "dropmalzpp": 644459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607423353,
    "dropsitcph": 6607423353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16423",
    "droptype": "D",
    "dropname": "ELSBERRY",
    "dropdeladd": "110 N 3RD ST",
    "dropdelcty": "ELSBERRY",
    "dropdelst": "MO",
    "dropdelzpp": 633439998,
    "dropphyadd": "110 N 3RD ST",
    "dropphycty": "ELSBERRY",
    "dropphyst": "MO",
    "dropphyzpp": 633439998,
    "dropmaladd": "110 N 3RD ST",
    "dropmalcty": "ELSBERRY",
    "dropmalst": "MO",
    "dropmalzpp": 633439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738982428,
    "dropsitcph": 5738982428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16427",
    "droptype": "D",
    "dropname": "EMDEN",
    "dropdeladd": "9191 HIGHWAY 168",
    "dropdelcty": "EMDEN",
    "dropdelst": "MO",
    "dropdelzpp": 634399998,
    "dropphyadd": "9191 HIGHWAY 168",
    "dropphycty": "EMDEN",
    "dropphyst": "MO",
    "dropphyzpp": 634399998,
    "dropmaladd": "9191 HIGHWAY 168",
    "dropmalcty": "EMDEN",
    "dropmalst": "MO",
    "dropmalzpp": 634399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734395521,
    "dropsitcph": 5734395521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16428",
    "droptype": "D",
    "dropname": "EMINENCE",
    "dropdeladd": "18253 MAIN ST",
    "dropdelcty": "EMINENCE",
    "dropdelst": "MO",
    "dropdelzpp": 654669998,
    "dropphyadd": "18253 MAIN ST",
    "dropphycty": "EMINENCE",
    "dropphyst": "MO",
    "dropphyzpp": 654669998,
    "dropmaladd": "18253 MAIN ST",
    "dropmalcty": "EMINENCE",
    "dropmalst": "MO",
    "dropmalzpp": 654669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732262041,
    "dropsitcph": 5732262041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16429",
    "droptype": "D",
    "dropname": "EMMA",
    "dropdeladd": "204 N ELM ST",
    "dropdelcty": "EMMA",
    "dropdelst": "MO",
    "dropdelzpp": 653279998,
    "dropphyadd": "204 N ELM ST",
    "dropphycty": "EMMA",
    "dropphyst": "MO",
    "dropphyzpp": 653279998,
    "dropmaladd": "204 N ELM ST",
    "dropmalcty": "EMMA",
    "dropmalst": "MO",
    "dropmalzpp": 653279998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604632177,
    "dropsitcph": 6604632177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16433",
    "droptype": "D",
    "dropname": "EOLIA",
    "dropdeladd": "107 GREEN ST",
    "dropdelcty": "EOLIA",
    "dropdelst": "MO",
    "dropdelzpp": 633449998,
    "dropphyadd": "107 GREEN ST",
    "dropphycty": "EOLIA",
    "dropphyst": "MO",
    "dropphyzpp": 633449998,
    "dropmaladd": "107 GREEN ST",
    "dropmalcty": "EOLIA",
    "dropmalst": "MO",
    "dropmalzpp": 633449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734853485,
    "dropsitcph": 5734853485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16436",
    "droptype": "D",
    "dropname": "ESSEX",
    "dropdeladd": "112 N CYPRESS ST",
    "dropdelcty": "ESSEX",
    "dropdelst": "MO",
    "dropdelzpp": 638469998,
    "dropphyadd": "112 N CYPRESS ST",
    "dropphycty": "ESSEX",
    "dropphyst": "MO",
    "dropphyzpp": 638469998,
    "dropmaladd": "112 N CYPRESS ST",
    "dropmalcty": "ESSEX",
    "dropmalst": "MO",
    "dropmalzpp": 638469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732835221,
    "dropsitcph": 5732835221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16440",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "ETHEL",
    "dropdelst": "MO",
    "dropdelzpp": 635399998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "ETHEL",
    "dropphyst": "MO",
    "dropphyzpp": 635399998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "ETHEL",
    "dropmalst": "MO",
    "dropmalzpp": 635399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604863260,
    "dropsitcph": 6604863260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16447",
    "droptype": "D",
    "dropname": "EUGENE",
    "dropdeladd": "16106 BERRY ST",
    "dropdelcty": "EUGENE",
    "dropdelst": "MO",
    "dropdelzpp": 650329998,
    "dropphyadd": "16106 BERRY ST",
    "dropphycty": "EUGENE",
    "dropphyst": "MO",
    "dropphyzpp": 650329998,
    "dropmaladd": "16106 BERRY ST",
    "dropmalcty": "EUGENE",
    "dropmalst": "MO",
    "dropmalzpp": 650329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734983713,
    "dropsitcph": 5734983713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16449",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "101 THRESHER DR",
    "dropdelcty": "EUREKA",
    "dropdelst": "MO",
    "dropdelzpp": 630259998,
    "dropphyadd": "101 THRESHER DR",
    "dropphycty": "EUREKA",
    "dropphyst": "MO",
    "dropphyzpp": 630259998,
    "dropmaladd": "101 THRESHER DR",
    "dropmalcty": "EUREKA",
    "dropmalst": "MO",
    "dropmalzpp": 630259998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369389985,
    "dropsitcph": 6369381352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16452",
    "droptype": "D",
    "dropname": "EVERTON",
    "dropdeladd": "102 W COMMERCIAL ST",
    "dropdelcty": "EVERTON",
    "dropdelst": "MO",
    "dropdelzpp": 656469998,
    "dropphyadd": "102 W COMMERCIAL ST",
    "dropphycty": "EVERTON",
    "dropphyst": "MO",
    "dropphyzpp": 656469998,
    "dropmaladd": "102 W COMMERCIAL ST",
    "dropmalcty": "EVERTON",
    "dropmalst": "MO",
    "dropmalzpp": 656469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175354500,
    "dropsitcph": 4175354500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16453",
    "droptype": "D",
    "dropname": "EWING",
    "dropdeladd": "106 S GILEAD ST",
    "dropdelcty": "EWING",
    "dropdelst": "MO",
    "dropdelzpp": 634409998,
    "dropphyadd": "106 S GILEAD ST",
    "dropphycty": "EWING",
    "dropphyst": "MO",
    "dropphyzpp": 634409998,
    "dropmaladd": "106 S GILEAD ST",
    "dropmalcty": "EWING",
    "dropmalst": "MO",
    "dropmalzpp": 634409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734943625,
    "dropsitcph": 5734943625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16454",
    "droptype": "D",
    "dropname": "EXCELLO",
    "dropdeladd": "38129 KAYAK AVE",
    "dropdelcty": "EXCELLO",
    "dropdelst": "MO",
    "dropdelzpp": 652479998,
    "dropphyadd": "38129 KAYAK AVE",
    "dropphycty": "EXCELLO",
    "dropphyst": "MO",
    "dropphyzpp": 652479998,
    "dropmaladd": "38129 KAYAK AVE",
    "dropmalcty": "EXCELLO",
    "dropmalst": "MO",
    "dropmalzpp": 652479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607752254,
    "dropsitcph": 6607752254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16456",
    "droptype": "D",
    "dropname": "EXCELSIOR SPRINGS",
    "dropdeladd": "515 SAINT LOUIS AVE",
    "dropdelcty": "EXCELSIOR SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 640249998,
    "dropphyadd": "515 SAINT LOUIS AVE",
    "dropphycty": "EXCELSIOR SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 640249998,
    "dropmaladd": "515 SAINT LOUIS AVE",
    "dropmalcty": "EXCELSIOR SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 640249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166303251,
    "dropsitcph": 8166303251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16458",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "100 S FRONT ST",
    "dropdelcty": "EXETER",
    "dropdelst": "MO",
    "dropdelzpp": 656479998,
    "dropphyadd": "100 S FRONT ST",
    "dropphycty": "EXETER",
    "dropphyst": "MO",
    "dropphyzpp": 656479998,
    "dropmaladd": "100 S FRONT ST",
    "dropmalcty": "EXETER",
    "dropmalst": "MO",
    "dropmalzpp": 656479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178355111,
    "dropsitcph": 4178355111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16460",
    "droptype": "D",
    "dropname": "FAIR GROVE",
    "dropdeladd": "210 E OLD MILL RD",
    "dropdelcty": "FAIR GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 656489998,
    "dropphyadd": "210 E OLD MILL RD",
    "dropphycty": "FAIR GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 656489998,
    "dropmaladd": "210 E OLD MILL RD",
    "dropmalcty": "FAIR GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 656489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177592739,
    "dropsitcph": 4177592739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16462",
    "droptype": "D",
    "dropname": "FAIR PLAY",
    "dropdeladd": "103 S TROOST AVE",
    "dropdelcty": "FAIR PLAY",
    "dropdelst": "MO",
    "dropdelzpp": 656499998,
    "dropphyadd": "103 S TROOST AVE",
    "dropphycty": "FAIR PLAY",
    "dropphyst": "MO",
    "dropphyzpp": 656499998,
    "dropmaladd": "103 S TROOST AVE",
    "dropmalcty": "FAIR PLAY",
    "dropmalst": "MO",
    "dropmalzpp": 656499998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176542213,
    "dropsitcph": 4176542213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16463",
    "droptype": "D",
    "dropname": "FAIRDEALING",
    "dropdeladd": "101 N COUNTY ROAD 160E26",
    "dropdelcty": "FAIRDEALING",
    "dropdelst": "MO",
    "dropdelzpp": 639399998,
    "dropphyadd": "101 N COUNTY ROAD 160E26",
    "dropphycty": "FAIRDEALING",
    "dropphyst": "MO",
    "dropphyzpp": 639399998,
    "dropmaladd": "101 N COUNTY ROAD 160E26",
    "dropmalcty": "FAIRDEALING",
    "dropmalst": "MO",
    "dropmalzpp": 639399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738572416,
    "dropsitcph": 5738572416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16464",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "104 N DENNY ST",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "MO",
    "dropdelzpp": 644469998,
    "dropphyadd": "104 N DENNY ST",
    "dropphycty": "FAIRFAX",
    "dropphyst": "MO",
    "dropphyzpp": 644469998,
    "dropmaladd": "104 N DENNY ST",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "MO",
    "dropmalzpp": 644469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606862870,
    "dropsitcph": 6606862870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16469",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "MO",
    "dropdelzpp": 648429998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "MO",
    "dropphyzpp": 648429998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "MO",
    "dropmalzpp": 648429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176324206,
    "dropsitcph": 4176324206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16470",
    "droptype": "D",
    "dropname": "FALCON",
    "dropdeladd": "18906 VINTAGE DR",
    "dropdelcty": "FALCON",
    "dropdelst": "MO",
    "dropdelzpp": 654709998,
    "dropphyadd": "18906 VINTAGE DR",
    "dropphycty": "FALCON",
    "dropphyst": "MO",
    "dropphyzpp": 654709998,
    "dropmaladd": "18906 VINTAGE DR",
    "dropmalcty": "FALCON",
    "dropmalst": "MO",
    "dropmalzpp": 654709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174536420,
    "dropsitcph": 4174536420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16471",
    "droptype": "D",
    "dropname": "FARBER",
    "dropdeladd": "101 W FRONT ST",
    "dropdelcty": "FARBER",
    "dropdelst": "MO",
    "dropdelzpp": 633459998,
    "dropphyadd": "101 W FRONT ST",
    "dropphycty": "FARBER",
    "dropphyst": "MO",
    "dropphyzpp": 633459998,
    "dropmaladd": "101 W FRONT ST",
    "dropmalcty": "FARBER",
    "dropmalst": "MO",
    "dropmalzpp": 633459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732493857,
    "dropsitcph": 5732493857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16472",
    "droptype": "D",
    "dropname": "FARLEY",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "FARLEY",
    "dropdelst": "MO",
    "dropdelzpp": 640289998,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "FARLEY",
    "dropphyst": "MO",
    "dropphyzpp": 640289998,
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "FARLEY",
    "dropmalst": "MO",
    "dropmalzpp": 640289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163303690,
    "dropsitcph": 8163303690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16473",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "102 E COLUMBIA ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 636403162,
    "dropphyadd": "102 E COLUMBIA ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 636403162,
    "dropmaladd": "102 E COLUMBIA ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 636403162,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737563427,
    "dropsitcph": 5737560280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16476",
    "droptype": "D",
    "dropname": "FAUCETT",
    "dropdeladd": "716 SE GRAND DD",
    "dropdelcty": "FAUCETT",
    "dropdelst": "MO",
    "dropdelzpp": 644489998,
    "dropphyadd": "716 SE GRAND DD",
    "dropphycty": "FAUCETT",
    "dropphyst": "MO",
    "dropphyzpp": 644489998,
    "dropmaladd": "716 SE GRAND DD",
    "dropmalcty": "FAUCETT",
    "dropmalst": "MO",
    "dropmalzpp": 644489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162381631,
    "dropsitcph": 8162381631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16477",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "103 W MORRISON ST",
    "dropdelcty": "FAYETTE",
    "dropdelst": "MO",
    "dropdelzpp": 652489998,
    "dropphyadd": "103 W MORRISON ST",
    "dropphycty": "FAYETTE",
    "dropphyst": "MO",
    "dropphyzpp": 652489998,
    "dropmaladd": "103 W MORRISON ST",
    "dropmalcty": "FAYETTE",
    "dropmalst": "MO",
    "dropmalzpp": 652489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602483309,
    "dropsitcph": 6602483309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16481",
    "droptype": "D",
    "dropname": "FENTON",
    "dropdeladd": "10 FENTON PLZ",
    "dropdelcty": "FENTON",
    "dropdelst": "MO",
    "dropdelzpp": 630269998,
    "dropphyadd": "10 FENTON PLZ",
    "dropphycty": "FENTON",
    "dropphyst": "MO",
    "dropphyzpp": 630269998,
    "dropmaladd": "10 FENTON PLZ",
    "dropmalcty": "FENTON",
    "dropmalst": "MO",
    "dropmalzpp": 630269998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363496693,
    "dropsitcph": 6363496693,
    "dropfax": 6363262632
  },
  {
    "dcode": "D",
    "dropkey": "PW16486",
    "droptype": "D",
    "dropname": "FESTUS",
    "dropdeladd": "109 WALNUT ST",
    "dropdelcty": "FESTUS",
    "dropdelst": "MO",
    "dropdelzpp": 630289998,
    "dropphyadd": "109 WALNUT ST",
    "dropphycty": "FESTUS",
    "dropphyst": "MO",
    "dropphyzpp": 630289998,
    "dropmaladd": "109 WALNUT ST",
    "dropmalcty": "FESTUS",
    "dropmalst": "MO",
    "dropmalzpp": 630289998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369372107,
    "dropsitcph": 6369372107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16489",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "126 E MAIN ST",
    "dropdelcty": "FILLMORE",
    "dropdelst": "MO",
    "dropdelzpp": 644499998,
    "dropphyadd": "126 E MAIN ST",
    "dropphycty": "FILLMORE",
    "dropphyst": "MO",
    "dropphyzpp": 644499998,
    "dropmaladd": "126 E MAIN ST",
    "dropmalcty": "FILLMORE",
    "dropmalst": "MO",
    "dropmalzpp": 644499998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164873755,
    "dropsitcph": 8164873755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16493",
    "droptype": "D",
    "dropname": "FISK",
    "dropdeladd": "204 LINCOLN AVE",
    "dropdelcty": "FISK",
    "dropdelst": "MO",
    "dropdelzpp": 639409998,
    "dropphyadd": "204 LINCOLN AVE",
    "dropphycty": "FISK",
    "dropphyst": "MO",
    "dropphyzpp": 639409998,
    "dropmaladd": "204 LINCOLN AVE",
    "dropmalcty": "FISK",
    "dropmalst": "MO",
    "dropmalzpp": 639409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5739673610,
    "dropsitcph": 5739673610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16495",
    "droptype": "D",
    "dropname": "PARK HILLS",
    "dropdeladd": "302 T J STEWART DR",
    "dropdelcty": "PARK HILLS",
    "dropdelst": "MO",
    "dropdelzpp": 636019998,
    "dropphyadd": "302 T J STEWART DR",
    "dropphycty": "PARK HILLS",
    "dropphyst": "MO",
    "dropphyzpp": 636019998,
    "dropmaladd": "302 T J STEWART DR",
    "dropmalcty": "PARK HILLS",
    "dropmalst": "MO",
    "dropmalzpp": 636019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734314907,
    "dropsitcph": 5734314906,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16497",
    "droptype": "D",
    "dropname": "FLEMINGTON",
    "dropdeladd": "691 MAIN ST",
    "dropdelcty": "FLEMINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 656509998,
    "dropphyadd": "691 MAIN ST",
    "dropphycty": "FLEMINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 656509998,
    "dropmaladd": "691 MAIN ST",
    "dropmalcty": "FLEMINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 656509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177548209,
    "dropsitcph": 4177548209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16498",
    "droptype": "D",
    "dropname": "FLETCHER",
    "dropdeladd": "7682 OLD HIGHWAY H",
    "dropdelcty": "FLETCHER",
    "dropdelst": "MO",
    "dropdelzpp": 630309998,
    "dropphyadd": "7682 OLD HIGHWAY H",
    "dropphycty": "FLETCHER",
    "dropphyst": "MO",
    "dropphyzpp": 630309998,
    "dropmaladd": "7682 OLD HIGHWAY H",
    "dropmalcty": "FLETCHER",
    "dropmalst": "MO",
    "dropmalzpp": 630309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736782786,
    "dropsitcph": 5736782786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16499",
    "droptype": "D",
    "dropname": "FLINTHILL",
    "dropdeladd": "5025 HIGHWAY P",
    "dropdelcty": "FLINTHILL",
    "dropdelst": "MO",
    "dropdelzpp": 633469998,
    "dropphyadd": "5025 HIGHWAY P",
    "dropphycty": "FLINTHILL",
    "dropphyst": "MO",
    "dropphyzpp": 633469998,
    "dropmaladd": "5025 HIGHWAY P",
    "dropmalcty": "FLINTHILL",
    "dropmalst": "MO",
    "dropmalzpp": 633469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363273070,
    "dropsitcph": 6363273070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16505",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "6628 HIGHWAY JJ",
    "dropdelcty": "FLORENCE",
    "dropdelst": "MO",
    "dropdelzpp": 653299998,
    "dropphyadd": "6628 HIGHWAY JJ",
    "dropphycty": "FLORENCE",
    "dropphyst": "MO",
    "dropphyzpp": 653299998,
    "dropmaladd": "6628 HIGHWAY JJ",
    "dropmalcty": "FLORENCE",
    "dropmalst": "MO",
    "dropmalzpp": 653299998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603682121,
    "dropsitcph": 6603682121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16507",
    "droptype": "D",
    "dropname": "FLORISSANT",
    "dropdeladd": "2200 N HIGHWAY 67",
    "dropdelcty": "FLORISSANT",
    "dropdelst": "MO",
    "dropdelzpp": 630339998,
    "dropphyadd": "2200 N HIGHWAY 67",
    "dropphycty": "FLORISSANT",
    "dropphyst": "MO",
    "dropphyzpp": 630339998,
    "dropmaladd": "2200 N HIGHWAY 67",
    "dropmalcty": "FLORISSANT",
    "dropmalst": "MO",
    "dropmalzpp": 630339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3148306150,
    "dropsitcph": 3148306101,
    "dropfax": 3148398741
  },
  {
    "dcode": "D",
    "dropkey": "PW16509",
    "droptype": "D",
    "dropname": "FOLEY",
    "dropdeladd": "467 ADDISON ST",
    "dropdelcty": "FOLEY",
    "dropdelst": "MO",
    "dropdelzpp": 633479998,
    "dropphyadd": "467 ADDISON ST",
    "dropphycty": "FOLEY",
    "dropphyst": "MO",
    "dropphyzpp": 633479998,
    "dropmaladd": "467 ADDISON ST",
    "dropmalcty": "FOLEY",
    "dropmalst": "MO",
    "dropmalzpp": 633479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366610197,
    "dropsitcph": 6366610197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16512",
    "droptype": "D",
    "dropname": "FORDLAND",
    "dropdeladd": "132 MAIN ST",
    "dropdelcty": "FORDLAND",
    "dropdelst": "MO",
    "dropdelzpp": 656529998,
    "dropphyadd": "132 MAIN ST",
    "dropphycty": "FORDLAND",
    "dropphyst": "MO",
    "dropphyzpp": 656529998,
    "dropmaladd": "132 MAIN ST",
    "dropmalcty": "FORDLAND",
    "dropmalst": "MO",
    "dropmalzpp": 656529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177672662,
    "dropsitcph": 4177672662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16513",
    "droptype": "D",
    "dropname": "FOREST CITY",
    "dropdeladd": "108 GRAND AVE",
    "dropdelcty": "FOREST CITY",
    "dropdelst": "MO",
    "dropdelzpp": 644519998,
    "dropphyadd": "108 GRAND AVE",
    "dropphycty": "FOREST CITY",
    "dropphyst": "MO",
    "dropphyzpp": 644519998,
    "dropmaladd": "108 GRAND AVE",
    "dropmalcty": "FOREST CITY",
    "dropmalst": "MO",
    "dropmalzpp": 644519998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604462824,
    "dropsitcph": 6604462824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16518",
    "droptype": "D",
    "dropname": "FORISTELL",
    "dropdeladd": "100 TOWN CENTRE CT",
    "dropdelcty": "FORISTELL",
    "dropdelst": "MO",
    "dropdelzpp": 633489998,
    "dropphyadd": "100 TOWN CENTRE CT",
    "dropphycty": "FORISTELL",
    "dropphyst": "MO",
    "dropphyzpp": 633489998,
    "dropmaladd": "100 TOWN CENTRE CT",
    "dropmalcty": "FORISTELL",
    "dropmalst": "MO",
    "dropmalzpp": 633489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366732693,
    "dropsitcph": 6366732693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16519",
    "droptype": "D",
    "dropname": "FORSYTH",
    "dropdeladd": "215 SHADOWROCK DR",
    "dropdelcty": "FORSYTH",
    "dropdelst": "MO",
    "dropdelzpp": 656539998,
    "dropphyadd": "215 SHADOWROCK DR",
    "dropphycty": "FORSYTH",
    "dropphyst": "MO",
    "dropphyzpp": 656539998,
    "dropmaladd": "215 SHADOWROCK DR",
    "dropmalcty": "FORSYTH",
    "dropmalst": "MO",
    "dropmalzpp": 656539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175463802,
    "dropsitcph": 4175463802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16520",
    "droptype": "D",
    "dropname": "FORT LEONARD WOOD",
    "dropdeladd": "233 ILLINOIS AVE STE 1",
    "dropdelcty": "FORT LEONARD WOOD",
    "dropdelst": "MO",
    "dropdelzpp": 654739998,
    "dropphyadd": "233 ILLINOIS AVE STE 1",
    "dropphycty": "FORT LEONARD WOOD",
    "dropphyst": "MO",
    "dropphyzpp": 654739998,
    "dropmaladd": "233 ILLINOIS AVE STE 1",
    "dropmalcty": "FORT LEONARD WOOD",
    "dropmalst": "MO",
    "dropmalzpp": 654739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733295909,
    "dropsitcph": 5733295909,
    "dropfax": 5733293558
  },
  {
    "dcode": "D",
    "dropkey": "PW16523",
    "droptype": "D",
    "dropname": "FORTUNA",
    "dropdeladd": "72456 WEBER ST",
    "dropdelcty": "FORTUNA",
    "dropdelst": "MO",
    "dropdelzpp": 650349998,
    "dropphyadd": "72456 WEBER ST",
    "dropphycty": "FORTUNA",
    "dropphyst": "MO",
    "dropphyzpp": 650349998,
    "dropmaladd": "72456 WEBER ST",
    "dropmalcty": "FORTUNA",
    "dropmalst": "MO",
    "dropmalzpp": 650349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603376221,
    "dropsitcph": 6603376221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16524",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "FOSTER",
    "dropdelst": "MO",
    "dropdelzpp": 647459998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "FOSTER",
    "dropphyst": "MO",
    "dropphyzpp": 647459998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "FOSTER",
    "dropmalst": "MO",
    "dropmalzpp": 647459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608324823,
    "dropsitcph": 6608324823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16528",
    "droptype": "D",
    "dropname": "FRANKFORD",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "FRANKFORD",
    "dropdelst": "MO",
    "dropdelzpp": 634419998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "FRANKFORD",
    "dropphyst": "MO",
    "dropphyzpp": 634419998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "FRANKFORD",
    "dropmalst": "MO",
    "dropmalzpp": 634419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737842927,
    "dropsitcph": 5737842927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16529",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "107 2ND ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MO",
    "dropdelzpp": 652509998,
    "dropphyadd": "107 2ND ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MO",
    "dropphyzpp": 652509998,
    "dropmaladd": "107 2ND ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MO",
    "dropmalzpp": 652509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608482908,
    "dropsitcph": 6608482908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16532",
    "droptype": "D",
    "dropname": "FREDERICKTOWN",
    "dropdeladd": "155 S MAIN ST",
    "dropdelcty": "FREDERICKTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 636459998,
    "dropphyadd": "155 S MAIN ST",
    "dropphycty": "FREDERICKTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 636459998,
    "dropmaladd": "155 S MAIN ST",
    "dropmalcty": "FREDERICKTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 636459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737832446,
    "dropsitcph": 5737832446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16534",
    "droptype": "D",
    "dropname": "FREEBURG",
    "dropdeladd": "100 HARRISON ST",
    "dropdelcty": "FREEBURG",
    "dropdelst": "MO",
    "dropdelzpp": 650359998,
    "dropphyadd": "100 HARRISON ST",
    "dropphycty": "FREEBURG",
    "dropphyst": "MO",
    "dropphyzpp": 650359998,
    "dropmaladd": "100 HARRISON ST",
    "dropmalcty": "FREEBURG",
    "dropmalst": "MO",
    "dropmalzpp": 650359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737440039,
    "dropsitcph": 5737440039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16536",
    "droptype": "D",
    "dropname": "FREEMAN",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "FREEMAN",
    "dropdelst": "MO",
    "dropdelzpp": 647469998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "FREEMAN",
    "dropphyst": "MO",
    "dropphyzpp": 647469998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "FREEMAN",
    "dropmalst": "MO",
    "dropmalzpp": 647469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168992558,
    "dropsitcph": 8168992558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16538",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "303 3RD ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "MO",
    "dropdelzpp": 639419998,
    "dropphyadd": "303 3RD ST",
    "dropphycty": "FREMONT",
    "dropphyst": "MO",
    "dropphyzpp": 639419998,
    "dropmaladd": "303 3RD ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "MO",
    "dropmalzpp": 639419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732513525,
    "dropsitcph": 5732513525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16539",
    "droptype": "D",
    "dropname": "FRENCH VILLAGE",
    "dropdeladd": "6104 HIGHWAY Y",
    "dropdelcty": "FRENCH VILLAGE",
    "dropdelst": "MO",
    "dropdelzpp": 630369998,
    "dropphyadd": "6104 HIGHWAY Y",
    "dropphycty": "FRENCH VILLAGE",
    "dropphyst": "MO",
    "dropphyzpp": 630369998,
    "dropmaladd": "6104 HIGHWAY Y",
    "dropmalcty": "FRENCH VILLAGE",
    "dropmalst": "MO",
    "dropmalzpp": 630369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733588941,
    "dropsitcph": 5733588941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16543",
    "droptype": "D",
    "dropname": "FROHNA",
    "dropdeladd": "7 BALL PARK DR",
    "dropdelcty": "FROHNA",
    "dropdelst": "MO",
    "dropdelzpp": 637489998,
    "dropphyadd": "7 BALL PARK DR",
    "dropphycty": "FROHNA",
    "dropphyst": "MO",
    "dropphyzpp": 637489998,
    "dropmaladd": "7 BALL PARK DR",
    "dropmalcty": "FROHNA",
    "dropmalst": "MO",
    "dropmalzpp": 637489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738245209,
    "dropsitcph": 5738245209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16550",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "301 COURT ST",
    "dropdelcty": "FULTON",
    "dropdelst": "MO",
    "dropdelzpp": 652519998,
    "dropphyadd": "301 COURT ST",
    "dropphycty": "FULTON",
    "dropphyst": "MO",
    "dropphyzpp": 652519998,
    "dropmaladd": "301 COURT ST",
    "dropmalcty": "FULTON",
    "dropmalst": "MO",
    "dropmalzpp": 652519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736422857,
    "dropsitcph": 5736422857,
    "dropfax": 5735927125
  },
  {
    "dcode": "D",
    "dropkey": "PW16551",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "203 ELM ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656559998,
    "dropphyadd": "203 ELM ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656559998,
    "dropmaladd": "203 ELM ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176794112,
    "dropsitcph": 4176794112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16554",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "30691 STATE HIGHWAY 413",
    "dropdelcty": "GALENA",
    "dropdelst": "MO",
    "dropdelzpp": 656569998,
    "dropphyadd": "30691 STATE HIGHWAY 413",
    "dropphycty": "GALENA",
    "dropphyst": "MO",
    "dropphyzpp": 656569998,
    "dropmaladd": "30691 STATE HIGHWAY 413",
    "dropmalcty": "GALENA",
    "dropmalst": "MO",
    "dropmalzpp": 656569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173576217,
    "dropsitcph": 4173576217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16555",
    "droptype": "D",
    "dropname": "GALLATIN",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "GALLATIN",
    "dropdelst": "MO",
    "dropdelzpp": 646409998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "GALLATIN",
    "dropphyst": "MO",
    "dropphyzpp": 646409998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "GALLATIN",
    "dropmalst": "MO",
    "dropmalzpp": 646409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606633312,
    "dropsitcph": 6606633312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16557",
    "droptype": "D",
    "dropname": "GALT",
    "dropdeladd": "100 CENTER ST",
    "dropdelcty": "GALT",
    "dropdelst": "MO",
    "dropdelzpp": 646419998,
    "dropphyadd": "100 CENTER ST",
    "dropphycty": "GALT",
    "dropphyst": "MO",
    "dropphyzpp": 646419998,
    "dropmaladd": "100 CENTER ST",
    "dropmalcty": "GALT",
    "dropmalst": "MO",
    "dropmalzpp": 646419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606736513,
    "dropsitcph": 6606736513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16559",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "201 N 3RD ST",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "MO",
    "dropdelzpp": 647479998,
    "dropphyadd": "201 N 3RD ST",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "MO",
    "dropphyzpp": 647479998,
    "dropmaladd": "201 N 3RD ST",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "MO",
    "dropmalzpp": 647479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168626404,
    "dropsitcph": 8168626404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16567",
    "droptype": "D",
    "dropname": "GENTRY",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "GENTRY",
    "dropdelst": "MO",
    "dropdelzpp": 644539998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "GENTRY",
    "dropphyst": "MO",
    "dropphyzpp": 644539998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "GENTRY",
    "dropmalst": "MO",
    "dropmalzpp": 644539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604482265,
    "dropsitcph": 6604482265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16570",
    "droptype": "D",
    "dropname": "GERALD",
    "dropdeladd": "20 W 4TH ST",
    "dropdelcty": "GERALD",
    "dropdelst": "MO",
    "dropdelzpp": 630379998,
    "dropphyadd": "20 W 4TH ST",
    "dropphycty": "GERALD",
    "dropphyst": "MO",
    "dropphyzpp": 630379998,
    "dropmaladd": "20 W 4TH ST",
    "dropmalcty": "GERALD",
    "dropmalst": "MO",
    "dropmalzpp": 630379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737643301,
    "dropsitcph": 5737643301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16572",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "GIBSON",
    "dropdelst": "MO",
    "dropdelzpp": 638479998,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "GIBSON",
    "dropphyst": "MO",
    "dropphyzpp": 638479998,
    "dropmaladd": "110 MAIN ST",
    "dropmalcty": "GIBSON",
    "dropmalst": "MO",
    "dropmalzpp": 638479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737923202,
    "dropsitcph": 5737923202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16573",
    "droptype": "D",
    "dropname": "GIDEON",
    "dropdeladd": "102 E 1ST ST",
    "dropdelcty": "GIDEON",
    "dropdelst": "MO",
    "dropdelzpp": 638489998,
    "dropphyadd": "102 E 1ST ST",
    "dropphycty": "GIDEON",
    "dropphyst": "MO",
    "dropphyzpp": 638489998,
    "dropmaladd": "102 E 1ST ST",
    "dropmalcty": "GIDEON",
    "dropmalst": "MO",
    "dropmalzpp": 638489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734486187,
    "dropsitcph": 5734486187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16574",
    "droptype": "D",
    "dropname": "GILLIAM",
    "dropdeladd": "103 N BARTLETT ST",
    "dropdelcty": "GILLIAM",
    "dropdelst": "MO",
    "dropdelzpp": 653309998,
    "dropphyadd": "103 N BARTLETT ST",
    "dropphycty": "GILLIAM",
    "dropphyst": "MO",
    "dropphyzpp": 653309998,
    "dropmaladd": "103 N BARTLETT ST",
    "dropmalcty": "GILLIAM",
    "dropmalst": "MO",
    "dropmalzpp": 653309998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607842200,
    "dropsitcph": 6607842200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16579",
    "droptype": "D",
    "dropname": "GIPSY",
    "dropdeladd": "3500 STATE HWY E",
    "dropdelcty": "GIPSY",
    "dropdelst": "MO",
    "dropdelzpp": 637509998,
    "dropphyadd": "3500 STATE HWY E",
    "dropphycty": "GIPSY",
    "dropphyst": "MO",
    "dropphyzpp": 637509998,
    "dropmaladd": "3500 STATE HWY E",
    "dropmalcty": "GIPSY",
    "dropmalst": "MO",
    "dropmalzpp": 637509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737225418,
    "dropsitcph": 5737225418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16583",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "404 1ST ST",
    "dropdelcty": "GLASGOW",
    "dropdelst": "MO",
    "dropdelzpp": 652549998,
    "dropphyadd": "404 1ST ST",
    "dropphycty": "GLASGOW",
    "dropphyst": "MO",
    "dropphyzpp": 652549998,
    "dropmaladd": "404 1ST ST",
    "dropmalcty": "GLASGOW",
    "dropmalst": "MO",
    "dropmalzpp": 652549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603382247,
    "dropsitcph": 6603382247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16588",
    "droptype": "D",
    "dropname": "GLENALLEN",
    "dropdeladd": "19158 SHORT ST",
    "dropdelcty": "GLENALLEN",
    "dropdelst": "MO",
    "dropdelzpp": 637519998,
    "dropphyadd": "19158 SHORT ST",
    "dropphycty": "GLENALLEN",
    "dropphyst": "MO",
    "dropphyzpp": 637519998,
    "dropmaladd": "19158 SHORT ST",
    "dropmalcty": "GLENALLEN",
    "dropmalst": "MO",
    "dropmalzpp": 637519998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732383684,
    "dropsitcph": 5732383684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16589",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "18072 MANCHESTER RD",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630389998,
    "dropphyadd": "18072 MANCHESTER RD",
    "dropphycty": "WILDWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630389998,
    "dropmaladd": "18072 MANCHESTER RD",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364583853,
    "dropsitcph": 6364588840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16597",
    "droptype": "D",
    "dropname": "GOBLER",
    "dropdeladd": "11 GRANT LN",
    "dropdelcty": "GOBLER",
    "dropdelst": "MO",
    "dropdelzpp": 638499998,
    "dropphyadd": "11 GRANT LN",
    "dropphycty": "GOBLER",
    "dropphyst": "MO",
    "dropphyzpp": 638499998,
    "dropmaladd": "11 GRANT LN",
    "dropmalcty": "GOBLER",
    "dropmalst": "MO",
    "dropmalzpp": 638499998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737576500,
    "dropsitcph": 5737576500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16599",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "28667 STATE HIGHWAY J",
    "dropdelcty": "GOLDEN",
    "dropdelst": "MO",
    "dropdelzpp": 656589998,
    "dropphyadd": "28667 STATE HIGHWAY J",
    "dropphycty": "GOLDEN",
    "dropphyst": "MO",
    "dropphyzpp": 656589998,
    "dropmaladd": "28667 STATE HIGHWAY J",
    "dropmalcty": "GOLDEN",
    "dropmalst": "MO",
    "dropmalzpp": 656589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172713428,
    "dropsitcph": 4172713428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16600",
    "droptype": "D",
    "dropname": "GOLDEN CITY",
    "dropdeladd": "519 MAIN ST",
    "dropdelcty": "GOLDEN CITY",
    "dropdelst": "MO",
    "dropdelzpp": 647489998,
    "dropphyadd": "519 MAIN ST",
    "dropphycty": "GOLDEN CITY",
    "dropphyst": "MO",
    "dropphyzpp": 647489998,
    "dropmaladd": "519 MAIN ST",
    "dropmalcty": "GOLDEN CITY",
    "dropmalst": "MO",
    "dropmalzpp": 647489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175374447,
    "dropsitcph": 4175374447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16608",
    "droptype": "D",
    "dropname": "GOODMAN",
    "dropdeladd": "103 W SPLITLOG ST",
    "dropdelcty": "GOODMAN",
    "dropdelst": "MO",
    "dropdelzpp": 648439998,
    "dropphyadd": "103 W SPLITLOG ST",
    "dropphycty": "GOODMAN",
    "dropphyst": "MO",
    "dropphyzpp": 648439998,
    "dropmaladd": "103 W SPLITLOG ST",
    "dropmalcty": "GOODMAN",
    "dropmalst": "MO",
    "dropmalzpp": 648439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173648555,
    "dropsitcph": 4173648555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16611",
    "droptype": "D",
    "dropname": "GORDONVILLE",
    "dropdeladd": "5850 STATE HIGHWAY 25",
    "dropdelcty": "GORDONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 637529998,
    "dropphyadd": "5850 STATE HIGHWAY 25",
    "dropphycty": "GORDONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 637529998,
    "dropmaladd": "5850 STATE HIGHWAY 25",
    "dropmalcty": "GORDONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 637529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732435977,
    "dropsitcph": 5732435977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16616",
    "droptype": "D",
    "dropname": "GOWER",
    "dropdeladd": "99 N 3RD ST",
    "dropdelcty": "GOWER",
    "dropdelst": "MO",
    "dropdelzpp": 644549998,
    "dropphyadd": "99 N 3RD ST",
    "dropphycty": "GOWER",
    "dropphyst": "MO",
    "dropphyzpp": 644549998,
    "dropmaladd": "99 N 3RD ST",
    "dropmalcty": "GOWER",
    "dropmalst": "MO",
    "dropmalzpp": 644549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164243322,
    "dropsitcph": 8164243322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16617",
    "droptype": "D",
    "dropname": "GRAFF",
    "dropdeladd": "9335 HIGHWAY 38",
    "dropdelcty": "GRAFF",
    "dropdelst": "MO",
    "dropdelzpp": 656609998,
    "dropphyadd": "9335 HIGHWAY 38",
    "dropphycty": "GRAFF",
    "dropphyst": "MO",
    "dropphyzpp": 656609998,
    "dropmaladd": "9335 HIGHWAY 38",
    "dropmalcty": "GRAFF",
    "dropmalst": "MO",
    "dropmalzpp": 656609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176685665,
    "dropsitcph": 4176685665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16618",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "412 E JACKSON ST",
    "dropdelcty": "GRAHAM",
    "dropdelst": "MO",
    "dropdelzpp": 644559998,
    "dropphyadd": "412 E JACKSON ST",
    "dropphycty": "GRAHAM",
    "dropphyst": "MO",
    "dropphyzpp": 644559998,
    "dropmaladd": "412 E JACKSON ST",
    "dropmalcty": "GRAHAM",
    "dropmalst": "MO",
    "dropmalzpp": 644559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609394855,
    "dropsitcph": 6609394855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16619",
    "droptype": "D",
    "dropname": "GRAIN VALLEY",
    "dropdeladd": "112 W WALNUT ST",
    "dropdelcty": "GRAIN VALLEY",
    "dropdelst": "MO",
    "dropdelzpp": 640299998,
    "dropphyadd": "112 W WALNUT ST",
    "dropphycty": "GRAIN VALLEY",
    "dropphyst": "MO",
    "dropphyzpp": 640299998,
    "dropmaladd": "112 W WALNUT ST",
    "dropmalcty": "GRAIN VALLEY",
    "dropmalst": "MO",
    "dropmalzpp": 640299998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162282024,
    "dropsitcph": 8162282024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16621",
    "droptype": "D",
    "dropname": "GRANBY",
    "dropdeladd": "126 S MAIN ST",
    "dropdelcty": "GRANBY",
    "dropdelst": "MO",
    "dropdelzpp": 648449998,
    "dropphyadd": "126 S MAIN ST",
    "dropphycty": "GRANBY",
    "dropphyst": "MO",
    "dropphyzpp": 648449998,
    "dropmaladd": "126 S MAIN ST",
    "dropmalcty": "GRANBY",
    "dropmalst": "MO",
    "dropmalzpp": 648449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174726219,
    "dropsitcph": 4174726219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16624",
    "droptype": "D",
    "dropname": "GRANDIN",
    "dropdeladd": "406 5TH ST",
    "dropdelcty": "GRANDIN",
    "dropdelst": "MO",
    "dropdelzpp": 639439998,
    "dropphyadd": "406 5TH ST",
    "dropphycty": "GRANDIN",
    "dropphyst": "MO",
    "dropphyzpp": 639439998,
    "dropmaladd": "406 5TH ST",
    "dropmalcty": "GRANDIN",
    "dropmalst": "MO",
    "dropmalzpp": 639439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735934332,
    "dropsitcph": 5735934332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16625",
    "droptype": "D",
    "dropname": "GRANDVIEW",
    "dropdeladd": "1415 MAIN ST",
    "dropdelcty": "GRANDVIEW",
    "dropdelst": "MO",
    "dropdelzpp": 640309998,
    "dropphyadd": "1415 MAIN ST",
    "dropphycty": "GRANDVIEW",
    "dropphyst": "MO",
    "dropphyzpp": 640309998,
    "dropmaladd": "1415 MAIN ST",
    "dropmalcty": "GRANDVIEW",
    "dropmalst": "MO",
    "dropmalzpp": 640309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167615693,
    "dropsitcph": 8167610345,
    "dropfax": 8167634029
  },
  {
    "dcode": "D",
    "dropkey": "PW16627",
    "droptype": "D",
    "dropname": "GRANT CITY",
    "dropdeladd": "109 W 3RD ST",
    "dropdelcty": "GRANT CITY",
    "dropdelst": "MO",
    "dropdelzpp": 644569998,
    "dropphyadd": "109 W 3RD ST",
    "dropphycty": "GRANT CITY",
    "dropphyst": "MO",
    "dropphyzpp": 644569998,
    "dropmaladd": "109 W 3RD ST",
    "dropmalcty": "GRANT CITY",
    "dropmalst": "MO",
    "dropmalzpp": 644569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605642317,
    "dropsitcph": 6605642317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16636",
    "droptype": "D",
    "dropname": "GRAVOIS MILLS",
    "dropdeladd": "25707 HIGHWAY 5",
    "dropdelcty": "GRAVOIS MILLS",
    "dropdelst": "MO",
    "dropdelzpp": 650379998,
    "dropphyadd": "25707 HIGHWAY 5",
    "dropphycty": "GRAVOIS MILLS",
    "dropphyst": "MO",
    "dropphyzpp": 650379998,
    "dropmaladd": "25707 HIGHWAY 5",
    "dropmalcty": "GRAVOIS MILLS",
    "dropmalst": "MO",
    "dropmalzpp": 650379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733726509,
    "dropsitcph": 5733726509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16638",
    "droptype": "D",
    "dropname": "GRAY SUMMIT",
    "dropdeladd": "2666 HIGHWAY 100",
    "dropdelcty": "GRAY SUMMIT",
    "dropdelst": "MO",
    "dropdelzpp": 630399998,
    "dropphyadd": "2666 HIGHWAY 100",
    "dropphycty": "GRAY SUMMIT",
    "dropphyst": "MO",
    "dropphyzpp": 630399998,
    "dropmaladd": "2666 HIGHWAY 100",
    "dropmalcty": "GRAY SUMMIT",
    "dropmalst": "MO",
    "dropmalzpp": 630399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6367424299,
    "dropsitcph": 6367424299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16639",
    "droptype": "D",
    "dropname": "GRAYRIDGE",
    "dropdeladd": "14348 OAK ST",
    "dropdelcty": "GRAYRIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 638509998,
    "dropphyadd": "14348 OAK ST",
    "dropphycty": "GRAYRIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 638509998,
    "dropmaladd": "14348 OAK ST",
    "dropmalcty": "GRAYRIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 638509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732835256,
    "dropsitcph": 5732835256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16645",
    "droptype": "D",
    "dropname": "GREEN CASTLE",
    "dropdeladd": "405 HIGHWAY 6",
    "dropdelcty": "GREEN CASTLE",
    "dropdelst": "MO",
    "dropdelzpp": 635449998,
    "dropphyadd": "405 HIGHWAY 6",
    "dropphycty": "GREEN CASTLE",
    "dropphyst": "MO",
    "dropphyzpp": 635449998,
    "dropmaladd": "405 HIGHWAY 6",
    "dropmalcty": "GREEN CASTLE",
    "dropmalst": "MO",
    "dropmalzpp": 635449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608744669,
    "dropsitcph": 6608744669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16646",
    "droptype": "D",
    "dropname": "GREEN CITY",
    "dropdeladd": "2 W 3RD ST",
    "dropdelcty": "GREEN CITY",
    "dropdelst": "MO",
    "dropdelzpp": 635459998,
    "dropphyadd": "2 W 3RD ST",
    "dropphycty": "GREEN CITY",
    "dropphyst": "MO",
    "dropphyzpp": 635459998,
    "dropmaladd": "2 W 3RD ST",
    "dropmalcty": "GREEN CITY",
    "dropmalst": "MO",
    "dropmalzpp": 635459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608744585,
    "dropsitcph": 6608744585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16651",
    "droptype": "D",
    "dropname": "GREEN RIDGE",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "GREEN RIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 653329998,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "GREEN RIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 653329998,
    "dropmaladd": "106 N MAIN ST",
    "dropmalcty": "GREEN RIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 653329998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605273385,
    "dropsitcph": 6605273385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16655",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "114 S MAIN ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 656619998,
    "dropphyadd": "114 S MAIN ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 656619998,
    "dropmaladd": "114 S MAIN ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 656619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176372613,
    "dropsitcph": 4176372613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16658",
    "droptype": "D",
    "dropname": "GREENTOP",
    "dropdeladd": "868 MAIN ST",
    "dropdelcty": "GREENTOP",
    "dropdelst": "MO",
    "dropdelzpp": 635469998,
    "dropphyadd": "868 MAIN ST",
    "dropphycty": "GREENTOP",
    "dropphyst": "MO",
    "dropphyzpp": 635469998,
    "dropmaladd": "868 MAIN ST",
    "dropmalcty": "GREENTOP",
    "dropmalst": "MO",
    "dropmalzpp": 635469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6609492318,
    "dropsitcph": 6609492318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16660",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 639449998,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 639449998,
    "dropmaladd": "111 MAIN ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 639449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732243864,
    "dropsitcph": 5732243864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16663",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "604 WALNUT ST STE A",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 640349998,
    "dropphyadd": "604 WALNUT ST STE A",
    "dropphycty": "GREENWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 640349998,
    "dropmaladd": "604 WALNUT ST STE A",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 640349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165378656,
    "dropsitcph": 8165378656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16670",
    "droptype": "D",
    "dropname": "GROVER",
    "dropdeladd": "16982 MANCHESTER RD",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630409998,
    "dropphyadd": "16982 MANCHESTER RD",
    "dropphycty": "WILDWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630409998,
    "dropmaladd": "16982 MANCHESTER RD",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364582958,
    "dropsitcph": 6364582958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16672",
    "droptype": "D",
    "dropname": "GROVESPRING",
    "dropdeladd": "2123 HIGHWAY M",
    "dropdelcty": "GROVESPRING",
    "dropdelst": "MO",
    "dropdelzpp": 656629998,
    "dropphyadd": "2123 HIGHWAY M",
    "dropphycty": "GROVESPRING",
    "dropphyst": "MO",
    "dropphyzpp": 656629998,
    "dropmaladd": "2123 HIGHWAY M",
    "dropmalcty": "GROVESPRING",
    "dropmalst": "MO",
    "dropmalzpp": 656629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174623380,
    "dropsitcph": 4174623380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16673",
    "droptype": "D",
    "dropname": "GRUBVILLE",
    "dropdeladd": "9994 STATE ROAD Y",
    "dropdelcty": "GRUBVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 630419998,
    "dropphyadd": "9994 STATE ROAD Y",
    "dropphycty": "GRUBVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 630419998,
    "dropmaladd": "9994 STATE ROAD Y",
    "dropmalcty": "GRUBVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 630419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362855009,
    "dropsitcph": 6362855009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16676",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "GUILFORD",
    "dropdelst": "MO",
    "dropdelzpp": 644579998,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "GUILFORD",
    "dropphyst": "MO",
    "dropphyzpp": 644579998,
    "dropmaladd": "119 MAIN ST",
    "dropmalcty": "GUILFORD",
    "dropmalst": "MO",
    "dropmalzpp": 644579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606524403,
    "dropsitcph": 6606524403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16683",
    "droptype": "D",
    "dropname": "HALE",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "HALE",
    "dropdelst": "MO",
    "dropdelzpp": 646439998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "HALE",
    "dropphyst": "MO",
    "dropphyzpp": 646439998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "HALE",
    "dropmalst": "MO",
    "dropmalzpp": 646439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605652480,
    "dropsitcph": 6605652480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16684",
    "droptype": "D",
    "dropname": "HALF WAY",
    "dropdeladd": "2132 HIGHWAY 32",
    "dropdelcty": "HALF WAY",
    "dropdelst": "MO",
    "dropdelzpp": 656639998,
    "dropphyadd": "2132 HIGHWAY 32",
    "dropphycty": "HALF WAY",
    "dropphyst": "MO",
    "dropphyzpp": 656639998,
    "dropmaladd": "2132 HIGHWAY 32",
    "dropmalcty": "HALF WAY",
    "dropmalst": "MO",
    "dropmalzpp": 656639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174452302,
    "dropsitcph": 4174452302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16685",
    "droptype": "D",
    "dropname": "HALLSVILLE",
    "dropdeladd": "319 HWY 124 E",
    "dropdelcty": "HALLSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652559998,
    "dropphyadd": "319 HWY 124 E",
    "dropphycty": "HALLSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652559998,
    "dropmaladd": "319 HWY 124 E",
    "dropmalcty": "HALLSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736963434,
    "dropsitcph": 5736963434,
    "dropfax": 5736963434
  },
  {
    "dcode": "D",
    "dropkey": "PW16688",
    "droptype": "D",
    "dropname": "HALLTOWN",
    "dropdeladd": "224 MAIN ST",
    "dropdelcty": "HALLTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 656649998,
    "dropphyadd": "224 MAIN ST",
    "dropphycty": "HALLTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 656649998,
    "dropmaladd": "224 MAIN ST",
    "dropmalcty": "HALLTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 656649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177492208,
    "dropsitcph": 4177492208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16690",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "106 W BIRD ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "MO",
    "dropdelzpp": 646449998,
    "dropphyadd": "106 W BIRD ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "MO",
    "dropphyzpp": 646449998,
    "dropmaladd": "106 W BIRD ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "MO",
    "dropmalzpp": 646449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165832422,
    "dropsitcph": 8165832422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16696",
    "droptype": "D",
    "dropname": "HANNIBAL",
    "dropdeladd": "801 BROADWAY",
    "dropdelcty": "HANNIBAL",
    "dropdelst": "MO",
    "dropdelzpp": 634019998,
    "dropphyadd": "801 BROADWAY",
    "dropphycty": "HANNIBAL",
    "dropphyst": "MO",
    "dropphyzpp": 634019998,
    "dropmaladd": "801 BROADWAY",
    "dropmalcty": "HANNIBAL",
    "dropmalst": "MO",
    "dropmalzpp": 634019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732210957,
    "dropsitcph": 5732210957,
    "dropfax": 5732212384
  },
  {
    "dcode": "D",
    "dropkey": "PW16697",
    "droptype": "D",
    "dropname": "HARDENVILLE",
    "dropdeladd": "25736 US HIGHWAY 160",
    "dropdelcty": "HARDENVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656669998,
    "dropphyadd": "25736 US HIGHWAY 160",
    "dropphycty": "HARDENVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656669998,
    "dropmaladd": "25736 US HIGHWAY 160",
    "dropmalcty": "HARDENVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176794706,
    "dropsitcph": 4176794706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16700",
    "droptype": "D",
    "dropname": "HARDIN",
    "dropdeladd": "108 NE 2ND ST",
    "dropdelcty": "HARDIN",
    "dropdelst": "MO",
    "dropdelzpp": 640359998,
    "dropphyadd": "108 NE 2ND ST",
    "dropphycty": "HARDIN",
    "dropphyst": "MO",
    "dropphyzpp": 640359998,
    "dropmaladd": "108 NE 2ND ST",
    "dropmalcty": "HARDIN",
    "dropmalst": "MO",
    "dropmalzpp": 640359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603984420,
    "dropsitcph": 6603984420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16704",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "181 W SEXTON ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "MO",
    "dropdelzpp": 652569998,
    "dropphyadd": "181 W SEXTON ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "MO",
    "dropphyzpp": 652569998,
    "dropmaladd": "181 W SEXTON ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "MO",
    "dropmalzpp": 652569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738755613,
    "dropsitcph": 5738755613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16706",
    "droptype": "D",
    "dropname": "HARRISONVILLE",
    "dropdeladd": "305 E MECHANIC ST",
    "dropdelcty": "HARRISONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 647019998,
    "dropphyadd": "305 E MECHANIC ST",
    "dropphycty": "HARRISONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 647019998,
    "dropmaladd": "305 E MECHANIC ST",
    "dropmalcty": "HARRISONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 647019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163803951,
    "dropsitcph": 8163803841,
    "dropfax": 8168841007
  },
  {
    "dcode": "D",
    "dropkey": "PW16712",
    "droptype": "D",
    "dropname": "HARTSBURG",
    "dropdeladd": "11 N 2ND ST",
    "dropdelcty": "HARTSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 650399998,
    "dropphyadd": "11 N 2ND ST",
    "dropphycty": "HARTSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 650399998,
    "dropmaladd": "11 N 2ND ST",
    "dropmalcty": "HARTSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 650399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736572300,
    "dropsitcph": 5736572300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16713",
    "droptype": "D",
    "dropname": "HARTSHORN",
    "dropdeladd": "6041 STATE ROUTE KK",
    "dropdelcty": "HARTSHORN",
    "dropdelst": "MO",
    "dropdelzpp": 654799998,
    "dropphyadd": "6041 STATE ROUTE KK",
    "dropphycty": "HARTSHORN",
    "dropphyst": "MO",
    "dropphyzpp": 654799998,
    "dropmaladd": "6041 STATE ROUTE KK",
    "dropmalcty": "HARTSHORN",
    "dropmalst": "MO",
    "dropmalzpp": 654799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179324443,
    "dropsitcph": 4179324443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16714",
    "droptype": "D",
    "dropname": "HARTVILLE",
    "dropdeladd": "130 COURT SQ",
    "dropdelcty": "HARTVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656679998,
    "dropphyadd": "130 COURT SQ",
    "dropphycty": "HARTVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656679998,
    "dropmaladd": "130 COURT SQ",
    "dropmalcty": "HARTVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177416645,
    "dropsitcph": 4177416645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16719",
    "droptype": "D",
    "dropname": "HARVIELL",
    "dropdeladd": "54 E MAIN ST",
    "dropdelcty": "HARVIELL",
    "dropdelst": "MO",
    "dropdelzpp": 639459998,
    "dropphyadd": "54 E MAIN ST",
    "dropphycty": "HARVIELL",
    "dropphyst": "MO",
    "dropphyzpp": 639459998,
    "dropmaladd": "54 E MAIN ST",
    "dropmalcty": "HARVIELL",
    "dropmalst": "MO",
    "dropmalzpp": 639459998,
    "dropsitphn": 8165043622,
    "dropsitlph": 5737851528,
    "dropsitcph": 5737851528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16721",
    "droptype": "D",
    "dropname": "HARWOOD",
    "dropdeladd": "211 E COATES AVE",
    "dropdelcty": "HARWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 647509998,
    "dropphyadd": "211 E COATES AVE",
    "dropphycty": "HARWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 647509998,
    "dropmaladd": "211 E COATES AVE",
    "dropmalcty": "HARWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 647509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174323721,
    "dropsitcph": 4174323721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16727",
    "droptype": "D",
    "dropname": "HAWK POINT",
    "dropdeladd": "441 MAIN ST",
    "dropdelcty": "HAWK POINT",
    "dropdelst": "MO",
    "dropdelzpp": 633499998,
    "dropphyadd": "441 MAIN ST",
    "dropphycty": "HAWK POINT",
    "dropphyst": "MO",
    "dropphyzpp": 633499998,
    "dropmaladd": "441 MAIN ST",
    "dropmalcty": "HAWK POINT",
    "dropmalst": "MO",
    "dropmalzpp": 633499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363381004,
    "dropsitcph": 6363381004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16730",
    "droptype": "D",
    "dropname": "HAYTI",
    "dropdeladd": "607 E WASHINGTON ST",
    "dropdelcty": "HAYTI",
    "dropdelst": "MO",
    "dropdelzpp": 638511760,
    "dropphyadd": "607 E WASHINGTON ST",
    "dropphycty": "HAYTI",
    "dropphyst": "MO",
    "dropphyzpp": 638511760,
    "dropmaladd": "607 E WASHINGTON ST",
    "dropmalcty": "HAYTI",
    "dropmalst": "MO",
    "dropmalzpp": 638511760,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733590418,
    "dropsitcph": 5733590418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16735",
    "droptype": "D",
    "dropname": "HAZELWOOD",
    "dropdeladd": "6135 N LINDBERGH BLVD",
    "dropdelcty": "HAZELWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630429998,
    "dropphyadd": "6135 N LINDBERGH BLVD",
    "dropphycty": "HAZELWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630429998,
    "dropmaladd": "6135 N LINDBERGH BLVD",
    "dropmalcty": "HAZELWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630429998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145510421,
    "dropsitcph": 3147311536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16736",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "21295 SYCAMORE ST",
    "dropdelcty": "HELENA",
    "dropdelst": "MO",
    "dropdelzpp": 644599998,
    "dropphyadd": "21295 SYCAMORE ST",
    "dropphycty": "HELENA",
    "dropphyst": "MO",
    "dropphyzpp": 644599998,
    "dropmaladd": "21295 SYCAMORE ST",
    "dropmalcty": "HELENA",
    "dropmalst": "MO",
    "dropmalzpp": 644599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163693095,
    "dropsitcph": 8163693095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16737",
    "droptype": "D",
    "dropname": "HEMATITE",
    "dropdeladd": "3677 STATE ROAD P",
    "dropdelcty": "HEMATITE",
    "dropdelst": "MO",
    "dropdelzpp": 630479998,
    "dropphyadd": "3677 STATE ROAD P",
    "dropphycty": "HEMATITE",
    "dropphyst": "MO",
    "dropphyzpp": 630479998,
    "dropmaladd": "3677 STATE ROAD P",
    "dropmalcty": "HEMATITE",
    "dropmalst": "MO",
    "dropmalzpp": 630479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369379131,
    "dropsitcph": 6369379131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16739",
    "droptype": "D",
    "dropname": "HENLEY",
    "dropdeladd": "16503 PIT RD",
    "dropdelcty": "HENLEY",
    "dropdelst": "MO",
    "dropdelzpp": 650409998,
    "dropphyadd": "16503 PIT RD",
    "dropphycty": "HENLEY",
    "dropphyst": "MO",
    "dropphyzpp": 650409998,
    "dropmaladd": "16503 PIT RD",
    "dropmalcty": "HENLEY",
    "dropmalst": "MO",
    "dropmalzpp": 650409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734986677,
    "dropsitcph": 5734986677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16740",
    "droptype": "D",
    "dropname": "HENRIETTA",
    "dropdeladd": "100 W 3RD ST",
    "dropdelcty": "HENRIETTA",
    "dropdelst": "MO",
    "dropdelzpp": 640369998,
    "dropphyadd": "100 W 3RD ST",
    "dropphycty": "HENRIETTA",
    "dropphyst": "MO",
    "dropphyzpp": 640369998,
    "dropmaladd": "100 W 3RD ST",
    "dropmalcty": "HENRIETTA",
    "dropmalst": "MO",
    "dropmalzpp": 640369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164945522,
    "dropsitcph": 8164945522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16742",
    "droptype": "D",
    "dropname": "HERCULANEUM",
    "dropdeladd": "1234 COMMERCIAL BLVD",
    "dropdelcty": "HERCULANEUM",
    "dropdelst": "MO",
    "dropdelzpp": 630489998,
    "dropphyadd": "1234 COMMERCIAL BLVD",
    "dropphycty": "HERCULANEUM",
    "dropphyst": "MO",
    "dropphyzpp": 630489998,
    "dropmaladd": "1234 COMMERCIAL BLVD",
    "dropmalcty": "HERCULANEUM",
    "dropmalst": "MO",
    "dropmalzpp": 630489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369377220,
    "dropsitcph": 6369377220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16744",
    "droptype": "D",
    "dropname": "HERMANN",
    "dropdeladd": "412 W 16TH ST",
    "dropdelcty": "HERMANN",
    "dropdelst": "MO",
    "dropdelzpp": 650419998,
    "dropphyadd": "412 W 16TH ST",
    "dropphycty": "HERMANN",
    "dropphyst": "MO",
    "dropphyzpp": 650419998,
    "dropmaladd": "412 W 16TH ST",
    "dropmalcty": "HERMANN",
    "dropmalst": "MO",
    "dropmalzpp": 650419998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734862798,
    "dropsitcph": 5734862798,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16745",
    "droptype": "D",
    "dropname": "HERMITAGE",
    "dropdeladd": "18704 SPRING ST",
    "dropdelcty": "HERMITAGE",
    "dropdelst": "MO",
    "dropdelzpp": 656689998,
    "dropphyadd": "18704 SPRING ST",
    "dropphycty": "HERMITAGE",
    "dropphyst": "MO",
    "dropphyzpp": 656689998,
    "dropmaladd": "18704 SPRING ST",
    "dropmalcty": "HERMITAGE",
    "dropmalst": "MO",
    "dropmalzpp": 656689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177456440,
    "dropsitcph": 4177456440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16748",
    "droptype": "D",
    "dropname": "HIGBEE",
    "dropdeladd": "503 DIVISION ST",
    "dropdelcty": "HIGBEE",
    "dropdelst": "MO",
    "dropdelzpp": 652579998,
    "dropphyadd": "503 DIVISION ST",
    "dropphycty": "HIGBEE",
    "dropphyst": "MO",
    "dropphyzpp": 652579998,
    "dropmaladd": "503 DIVISION ST",
    "dropmalcty": "HIGBEE",
    "dropmalst": "MO",
    "dropmalzpp": 652579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604567273,
    "dropsitcph": 6604567273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16749",
    "droptype": "D",
    "dropname": "HIGGINSVILLE",
    "dropdeladd": "2001 MAIN ST",
    "dropdelcty": "HIGGINSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 640379998,
    "dropphyadd": "2001 MAIN ST",
    "dropphycty": "HIGGINSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 640379998,
    "dropmaladd": "2001 MAIN ST",
    "dropmalcty": "HIGGINSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 640379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605842242,
    "dropsitcph": 6605842242,
    "dropfax": 6605845791
  },
  {
    "dcode": "D",
    "dropkey": "PW16753",
    "droptype": "D",
    "dropname": "HIGH HILL",
    "dropdeladd": "879 BOONESLICK RD",
    "dropdelcty": "HIGH HILL",
    "dropdelst": "MO",
    "dropdelzpp": 633509998,
    "dropphyadd": "879 BOONESLICK RD",
    "dropphycty": "HIGH HILL",
    "dropphyst": "MO",
    "dropphyzpp": 633509998,
    "dropmaladd": "879 BOONESLICK RD",
    "dropmalcty": "HIGH HILL",
    "dropmalst": "MO",
    "dropmalzpp": 633509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365852350,
    "dropsitcph": 6365852350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16758",
    "droptype": "D",
    "dropname": "HIGH RIDGE",
    "dropdeladd": "2829 HIGH RIDGE BLVD",
    "dropdelcty": "HIGH RIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 630499998,
    "dropphyadd": "2829 HIGH RIDGE BLVD",
    "dropphycty": "HIGH RIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 630499998,
    "dropmaladd": "2829 HIGH RIDGE BLVD",
    "dropmalcty": "HIGH RIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 630499998,
    "dropsitphn": 6366771786,
    "dropsitlph": 6366771786,
    "dropsitcph": 6366771786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16760",
    "droptype": "D",
    "dropname": "HIGHLANDVILLE",
    "dropdeladd": "299 KENTLING AVE",
    "dropdelcty": "HIGHLANDVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656699998,
    "dropphyadd": "299 KENTLING AVE",
    "dropphycty": "HIGHLANDVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656699998,
    "dropmaladd": "299 KENTLING AVE",
    "dropmalcty": "HIGHLANDVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174434422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16763",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "4620 YEAGER RD",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "MO",
    "dropdelzpp": 630509998,
    "dropphyadd": "4620 YEAGER RD",
    "dropphycty": "HILLSBORO",
    "dropphyst": "MO",
    "dropphyzpp": 630509998,
    "dropmaladd": "4620 YEAGER RD",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "MO",
    "dropmalzpp": 630509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6367892231,
    "dropsitcph": 6367892231,
    "dropfax": 6367892492
  },
  {
    "dcode": "D",
    "dropkey": "PW16774",
    "droptype": "D",
    "dropname": "HOLCOMB",
    "dropdeladd": "205 CHURCH ST",
    "dropdelcty": "HOLCOMB",
    "dropdelst": "MO",
    "dropdelzpp": 638529998,
    "dropphyadd": "205 CHURCH ST",
    "dropphycty": "HOLCOMB",
    "dropphyst": "MO",
    "dropphyzpp": 638529998,
    "dropmaladd": "205 CHURCH ST",
    "dropmalcty": "HOLCOMB",
    "dropmalst": "MO",
    "dropmalzpp": 638529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737923601,
    "dropsitcph": 5737923601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16775",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "105 S LEXINGTON ST",
    "dropdelcty": "HOLDEN",
    "dropdelst": "MO",
    "dropdelzpp": 640409998,
    "dropphyadd": "105 S LEXINGTON ST",
    "dropphycty": "HOLDEN",
    "dropphyst": "MO",
    "dropphyzpp": 640409998,
    "dropmaladd": "105 S LEXINGTON ST",
    "dropmalcty": "HOLDEN",
    "dropmalst": "MO",
    "dropmalzpp": 640409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168505575,
    "dropsitcph": 8168505575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16776",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "208 WALNUT ST",
    "dropdelcty": "HOLLAND",
    "dropdelst": "MO",
    "dropdelzpp": 638539998,
    "dropphyadd": "208 WALNUT ST",
    "dropphycty": "HOLLAND",
    "dropphyst": "MO",
    "dropphyzpp": 638539998,
    "dropmaladd": "208 WALNUT ST",
    "dropmalcty": "HOLLAND",
    "dropmalst": "MO",
    "dropmalzpp": 638539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736953124,
    "dropsitcph": 5736953124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16777",
    "droptype": "D",
    "dropname": "HOLLIDAY",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "HOLLIDAY",
    "dropdelst": "MO",
    "dropdelzpp": 652589998,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "HOLLIDAY",
    "dropphyst": "MO",
    "dropphyzpp": 652589998,
    "dropmaladd": "305 MAIN ST",
    "dropmalcty": "HOLLIDAY",
    "dropmalst": "MO",
    "dropmalzpp": 652589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602663379,
    "dropsitcph": 6602663379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16778",
    "droptype": "D",
    "dropname": "HOLLISTER",
    "dropdeladd": "1980 S BUSINESS 65",
    "dropdelcty": "HOLLISTER",
    "dropdelst": "MO",
    "dropdelzpp": 656739998,
    "dropphyadd": "1980 S BUSINESS 65",
    "dropphycty": "HOLLISTER",
    "dropphyst": "MO",
    "dropphyzpp": 656739998,
    "dropmaladd": "1980 S BUSINESS 65",
    "dropmalcty": "HOLLISTER",
    "dropmalst": "MO",
    "dropmalzpp": 656739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173342910,
    "dropsitcph": 4173342910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16779",
    "droptype": "D",
    "dropname": "HOLT",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "HOLT",
    "dropdelst": "MO",
    "dropdelzpp": 640489998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "HOLT",
    "dropphyst": "MO",
    "dropphyzpp": 640489998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "HOLT",
    "dropmalst": "MO",
    "dropmalzpp": 640489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163203838,
    "dropsitcph": 8163203838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16781",
    "droptype": "D",
    "dropname": "HOLTS SUMMIT",
    "dropdeladd": "357 S SUMMIT DR",
    "dropdelcty": "HOLTS SUMMIT",
    "dropdelst": "MO",
    "dropdelzpp": 650439998,
    "dropphyadd": "357 S SUMMIT DR",
    "dropphycty": "HOLTS SUMMIT",
    "dropphyst": "MO",
    "dropphyzpp": 650439998,
    "dropmaladd": "357 S SUMMIT DR",
    "dropmalcty": "HOLTS SUMMIT",
    "dropmalst": "MO",
    "dropmalzpp": 650439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738964767,
    "dropsitcph": 5738964767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16786",
    "droptype": "D",
    "dropname": "HOPKINS",
    "dropdeladd": "401 E BARNARD ST",
    "dropdelcty": "HOPKINS",
    "dropdelst": "MO",
    "dropdelzpp": 644619998,
    "dropphyadd": "401 E BARNARD ST",
    "dropphycty": "HOPKINS",
    "dropphyst": "MO",
    "dropphyzpp": 644619998,
    "dropmaladd": "401 E BARNARD ST",
    "dropmalcty": "HOPKINS",
    "dropmalst": "MO",
    "dropmalzpp": 644619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607783211,
    "dropsitcph": 6607783211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16788",
    "droptype": "D",
    "dropname": "HORNERSVILLE",
    "dropdeladd": "405 PECAN ST",
    "dropdelcty": "HORNERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 638559998,
    "dropphyadd": "405 PECAN ST",
    "dropphycty": "HORNERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 638559998,
    "dropmaladd": "405 PECAN ST",
    "dropmalcty": "HORNERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 638559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737372752,
    "dropsitcph": 5737372752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16798",
    "droptype": "D",
    "dropname": "HOUSE SPRINGS",
    "dropdeladd": "4650 GRAVOIS RD",
    "dropdelcty": "HOUSE SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 630519998,
    "dropphyadd": "4650 GRAVOIS RD",
    "dropphycty": "HOUSE SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 630519998,
    "dropmaladd": "4650 GRAVOIS RD",
    "dropmalcty": "HOUSE SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 630519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366711391,
    "dropsitcph": 6366711384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16800",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "203 N 1ST ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "MO",
    "dropdelzpp": 654839998,
    "dropphyadd": "203 N 1ST ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "MO",
    "dropphyzpp": 654839998,
    "dropmaladd": "203 N 1ST ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "MO",
    "dropmalzpp": 654839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179672376,
    "dropsitcph": 4179672376,
    "dropfax": 4179675268
  },
  {
    "dcode": "D",
    "dropkey": "PW16801",
    "droptype": "D",
    "dropname": "HOUSTONIA",
    "dropdeladd": "103 N WALNUT ST",
    "dropdelcty": "HOUSTONIA",
    "dropdelst": "MO",
    "dropdelzpp": 653339998,
    "dropphyadd": "103 N WALNUT ST",
    "dropphycty": "HOUSTONIA",
    "dropphyst": "MO",
    "dropphyzpp": 653339998,
    "dropmaladd": "103 N WALNUT ST",
    "dropmalcty": "HOUSTONIA",
    "dropmalst": "MO",
    "dropmalzpp": 653339998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605683351,
    "dropsitcph": 6605683351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16808",
    "droptype": "D",
    "dropname": "HUGGINS",
    "dropdeladd": "7394 HIGHWAY M",
    "dropdelcty": "HUGGINS",
    "dropdelst": "MO",
    "dropdelzpp": 654849998,
    "dropphyadd": "7394 HIGHWAY M",
    "dropphycty": "HUGGINS",
    "dropphyst": "MO",
    "dropphyzpp": 654849998,
    "dropmaladd": "7394 HIGHWAY M",
    "dropmalcty": "HUGGINS",
    "dropmalst": "MO",
    "dropmalzpp": 654849998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179267833,
    "dropsitcph": 4179267833,
    "dropfax": 4179267347
  },
  {
    "dcode": "D",
    "dropkey": "PW16809",
    "droptype": "D",
    "dropname": "HUGHESVILLE",
    "dropdeladd": "102 MOCKBEE ST",
    "dropdelcty": "HUGHESVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 653349998,
    "dropphyadd": "102 MOCKBEE ST",
    "dropphycty": "HUGHESVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 653349998,
    "dropmaladd": "102 MOCKBEE ST",
    "dropmalcty": "HUGHESVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 653349998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608271331,
    "dropsitcph": 6608271331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16813",
    "droptype": "D",
    "dropname": "HUMANSVILLE",
    "dropdeladd": "200 W TILDEN ST",
    "dropdelcty": "HUMANSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656749998,
    "dropphyadd": "200 W TILDEN ST",
    "dropphycty": "HUMANSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656749998,
    "dropmaladd": "200 W TILDEN ST",
    "dropmalcty": "HUMANSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177542502,
    "dropsitcph": 4177542502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16816",
    "droptype": "D",
    "dropname": "HUME",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "HUME",
    "dropdelst": "MO",
    "dropdelzpp": 647529998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "HUME",
    "dropphyst": "MO",
    "dropphyzpp": 647529998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "HUME",
    "dropmalst": "MO",
    "dropmalzpp": 647529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606437817,
    "dropsitcph": 6606437817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16818",
    "droptype": "D",
    "dropname": "HUNNEWELL",
    "dropdeladd": "106 E MAPLE ST",
    "dropdelcty": "HUNNEWELL",
    "dropdelst": "MO",
    "dropdelzpp": 634439998,
    "dropphyadd": "106 E MAPLE ST",
    "dropphycty": "HUNNEWELL",
    "dropphyst": "MO",
    "dropphyzpp": 634439998,
    "dropmaladd": "106 E MAPLE ST",
    "dropmalcty": "HUNNEWELL",
    "dropmalst": "MO",
    "dropmalzpp": 634439998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5739832208,
    "dropsitcph": 5739832208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16823",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "121 S MAIN ST",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652599998,
    "dropphyadd": "121 S MAIN ST",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652599998,
    "dropmaladd": "121 S MAIN ST",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602773400,
    "dropsitcph": 6602773400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16826",
    "droptype": "D",
    "dropname": "HURDLAND",
    "dropdeladd": "404 N 3RD ST",
    "dropdelcty": "HURDLAND",
    "dropdelst": "MO",
    "dropdelzpp": 635479998,
    "dropphyadd": "404 N 3RD ST",
    "dropphycty": "HURDLAND",
    "dropphyst": "MO",
    "dropphyzpp": 635479998,
    "dropmaladd": "404 N 3RD ST",
    "dropmalcty": "HURDLAND",
    "dropmalst": "MO",
    "dropmalzpp": 635479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607303025,
    "dropsitcph": 6607303025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16827",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "103 S RAIL ST",
    "dropdelcty": "HURLEY",
    "dropdelst": "MO",
    "dropdelzpp": 656759998,
    "dropphyadd": "103 S RAIL ST",
    "dropphycty": "HURLEY",
    "dropphyst": "MO",
    "dropphyzpp": 656759998,
    "dropmaladd": "103 S RAIL ST",
    "dropmalcty": "HURLEY",
    "dropmalst": "MO",
    "dropmalzpp": 656759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177482220,
    "dropsitcph": 4177482220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16830",
    "droptype": "D",
    "dropname": "IBERIA",
    "dropdeladd": "836 HIGHWAY 42",
    "dropdelcty": "IBERIA",
    "dropdelst": "MO",
    "dropdelzpp": 654869998,
    "dropphyadd": "836 HIGHWAY 42",
    "dropphycty": "IBERIA",
    "dropphyst": "MO",
    "dropphyzpp": 654869998,
    "dropmaladd": "836 HIGHWAY 42",
    "dropmalcty": "IBERIA",
    "dropmalst": "MO",
    "dropmalzpp": 654869998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737932713,
    "dropsitcph": 5737932713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16833",
    "droptype": "D",
    "dropname": "IMPERIAL",
    "dropdeladd": "6035 W OUTER RD",
    "dropdelcty": "IMPERIAL",
    "dropdelst": "MO",
    "dropdelzpp": 630529998,
    "dropphyadd": "6035 W OUTER RD",
    "dropphycty": "IMPERIAL",
    "dropphyst": "MO",
    "dropphyzpp": 630529998,
    "dropmaladd": "6035 W OUTER RD",
    "dropmalcty": "IMPERIAL",
    "dropmalst": "MO",
    "dropmalzpp": 630529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364643571,
    "dropsitcph": 6364643538,
    "dropfax": 6364644882
  },
  {
    "dcode": "D",
    "dropkey": "PW16836",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "301 W LEXINGTON AVE STE 110",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "MO",
    "dropdelzpp": 640509998,
    "dropphyadd": "301 W LEXINGTON AVE STE 110",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "MO",
    "dropphyzpp": 640509998,
    "dropmaladd": "301 W LEXINGTON AVE STE 110",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "MO",
    "dropmalzpp": 640509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164125619,
    "dropsitcph": 8164125619,
    "dropfax": 8165213650
  },
  {
    "dcode": "D",
    "dropkey": "PW16840",
    "droptype": "D",
    "dropname": "IONIA",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "IONIA",
    "dropdelst": "MO",
    "dropdelzpp": 653359998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "IONIA",
    "dropphyst": "MO",
    "dropphyzpp": 653359998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "IONIA",
    "dropmalst": "MO",
    "dropmalzpp": 653359998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602853449,
    "dropsitcph": 6602853449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16844",
    "droptype": "D",
    "dropname": "IRONDALE",
    "dropdeladd": "111 S HICKORY ST",
    "dropdelcty": "IRONDALE",
    "dropdelst": "MO",
    "dropdelzpp": 636489998,
    "dropphyadd": "111 S HICKORY ST",
    "dropphycty": "IRONDALE",
    "dropphyst": "MO",
    "dropphyzpp": 636489998,
    "dropmaladd": "111 S HICKORY ST",
    "dropmalcty": "IRONDALE",
    "dropmalst": "MO",
    "dropmalzpp": 636489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737493711,
    "dropsitcph": 5737493711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16845",
    "droptype": "D",
    "dropname": "IRONTON",
    "dropdeladd": "118 W RUSSELL ST",
    "dropdelcty": "IRONTON",
    "dropdelst": "MO",
    "dropdelzpp": 636509998,
    "dropphyadd": "118 W RUSSELL ST",
    "dropphycty": "IRONTON",
    "dropphyst": "MO",
    "dropphyzpp": 636509998,
    "dropmaladd": "118 W RUSSELL ST",
    "dropmalcty": "IRONTON",
    "dropmalst": "MO",
    "dropmalzpp": 636509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735467518,
    "dropsitcph": 5735467518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16848",
    "droptype": "D",
    "dropname": "ISABELLA",
    "dropdeladd": "9614 US HIGHWAY 160",
    "dropdelcty": "ISABELLA",
    "dropdelst": "MO",
    "dropdelzpp": 656769998,
    "dropphyadd": "9614 US HIGHWAY 160",
    "dropphycty": "ISABELLA",
    "dropphyst": "MO",
    "dropphyzpp": 656769998,
    "dropmaladd": "9614 US HIGHWAY 160",
    "dropmalcty": "ISABELLA",
    "dropmalst": "MO",
    "dropmalzpp": 656769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172734550,
    "dropsitcph": 4172734550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16850",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "MO",
    "dropdelzpp": 637559998,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "JACKSON",
    "dropphyst": "MO",
    "dropphyzpp": 637559998,
    "dropmaladd": "210 E MAIN ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "MO",
    "dropmalzpp": 637559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732434146,
    "dropsitcph": 5732434146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16851",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "124 W RANDOLPH ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652609998,
    "dropphyadd": "124 W RANDOLPH ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652609998,
    "dropmaladd": "124 W RANDOLPH ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602954243,
    "dropsitcph": 6602954243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16853",
    "droptype": "D",
    "dropname": "JADWIN",
    "dropdeladd": "9326 HIGHWAY K",
    "dropdelcty": "JADWIN",
    "dropdelst": "MO",
    "dropdelzpp": 655019998,
    "dropphyadd": "9326 HIGHWAY K",
    "dropphycty": "JADWIN",
    "dropphyst": "MO",
    "dropphyzpp": 655019998,
    "dropmaladd": "9326 HIGHWAY K",
    "dropmalcty": "JADWIN",
    "dropmalst": "MO",
    "dropmalzpp": 655019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737295058,
    "dropsitcph": 5737295058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16855",
    "droptype": "D",
    "dropname": "JAMESON",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "JAMESON",
    "dropdelst": "MO",
    "dropdelzpp": 646479998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "JAMESON",
    "dropphyst": "MO",
    "dropphyzpp": 646479998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "JAMESON",
    "dropmalst": "MO",
    "dropmalzpp": 646479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608284368,
    "dropsitcph": 6608284368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16856",
    "droptype": "D",
    "dropname": "JAMESPORT",
    "dropdeladd": "201 S BROADWAY ST",
    "dropdelcty": "JAMESPORT",
    "dropdelst": "MO",
    "dropdelzpp": 646489998,
    "dropphyadd": "201 S BROADWAY ST",
    "dropphycty": "JAMESPORT",
    "dropphyst": "MO",
    "dropphyzpp": 646489998,
    "dropmaladd": "201 S BROADWAY ST",
    "dropmalcty": "JAMESPORT",
    "dropmalst": "MO",
    "dropmalzpp": 646489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606846213,
    "dropsitcph": 6606846213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16857",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "100 W ROW ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 650469998,
    "dropphyadd": "100 W ROW ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 650469998,
    "dropmaladd": "100 W ROW ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 650469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608492423,
    "dropsitcph": 6608492423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16861",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "122 W GRAND ST",
    "dropdelcty": "JASPER",
    "dropdelst": "MO",
    "dropdelzpp": 647559998,
    "dropphyadd": "122 W GRAND ST",
    "dropphycty": "JASPER",
    "dropphyst": "MO",
    "dropphyzpp": 647559998,
    "dropmaladd": "122 W GRAND ST",
    "dropmalcty": "JASPER",
    "dropmalst": "MO",
    "dropmalzpp": 647559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173942519,
    "dropsitcph": 4173942519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16863",
    "droptype": "D",
    "dropname": "JEFFERSON CITY",
    "dropdeladd": "131 W HIGH ST RM 104",
    "dropdelcty": "JEFFERSON CITY",
    "dropdelst": "MO",
    "dropdelzpp": 651019998,
    "dropphyadd": "131 W HIGH ST RM 104",
    "dropphycty": "JEFFERSON CITY",
    "dropphyst": "MO",
    "dropphyzpp": 651019998,
    "dropmaladd": "131 W HIGH ST RM 104",
    "dropmalcty": "JEFFERSON CITY",
    "dropmalst": "MO",
    "dropmalzpp": 651019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736364186,
    "dropsitcph": 5736364186,
    "dropfax": 5736365708
  },
  {
    "dcode": "D",
    "dropkey": "PW16870",
    "droptype": "D",
    "dropname": "JERICO SPRINGS",
    "dropdeladd": "200 E BROADWAY ST",
    "dropdelcty": "JERICO SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 647569998,
    "dropphyadd": "200 E BROADWAY ST",
    "dropphycty": "JERICO SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 647569998,
    "dropmaladd": "200 E BROADWAY ST",
    "dropmalcty": "JERICO SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 647569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173982802,
    "dropsitcph": 4173982802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16874",
    "droptype": "D",
    "dropname": "JONESBURG",
    "dropdeladd": "116 E LION ST",
    "dropdelcty": "JONESBURG",
    "dropdelst": "MO",
    "dropdelzpp": 633519998,
    "dropphyadd": "116 E LION ST",
    "dropphycty": "JONESBURG",
    "dropphyst": "MO",
    "dropphyzpp": 633519998,
    "dropmaladd": "116 E LION ST",
    "dropmalcty": "JONESBURG",
    "dropmalst": "MO",
    "dropmalzpp": 633519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364885510,
    "dropsitcph": 6364885510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16875",
    "droptype": "D",
    "dropname": "JOPLIN",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "JOPLIN",
    "dropdelst": "MO",
    "dropdelzpp": 648019998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "JOPLIN",
    "dropphyst": "MO",
    "dropphyzpp": 648019998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "JOPLIN",
    "dropmalst": "MO",
    "dropmalzpp": 648019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176236176,
    "dropsitcph": 4176236176,
    "dropfax": 4176230218
  },
  {
    "dcode": "D",
    "dropkey": "PW16880",
    "droptype": "D",
    "dropname": "KAHOKA",
    "dropdeladd": "111 W COMMERCIAL ST",
    "dropdelcty": "KAHOKA",
    "dropdelst": "MO",
    "dropdelzpp": 634459998,
    "dropphyadd": "111 W COMMERCIAL ST",
    "dropphycty": "KAHOKA",
    "dropphyst": "MO",
    "dropphyzpp": 634459998,
    "dropmaladd": "111 W COMMERCIAL ST",
    "dropmalcty": "KAHOKA",
    "dropmalst": "MO",
    "dropmalzpp": 634459998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607272430,
    "dropsitcph": 6607272430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16881",
    "droptype": "D",
    "dropname": "KAISER",
    "dropdeladd": "405 HIGHWAY 42",
    "dropdelcty": "KAISER",
    "dropdelst": "MO",
    "dropdelzpp": 650479998,
    "dropphyadd": "405 HIGHWAY 42",
    "dropphycty": "KAISER",
    "dropphyst": "MO",
    "dropphyzpp": 650479998,
    "dropmaladd": "405 HIGHWAY 42",
    "dropmalcty": "KAISER",
    "dropmalst": "MO",
    "dropmalzpp": 650479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733483924,
    "dropsitcph": 5733483924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16888",
    "droptype": "D",
    "dropname": "KANSAS CITY",
    "dropdeladd": "300 W PERSHING RD STE 251",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641089998,
    "dropphyadd": "300 W PERSHING RD STE 251",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641089998,
    "dropmaladd": "300 W PERSHING RD STE 251",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641089998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 8163749180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16894",
    "droptype": "D",
    "dropname": "KEARNEY",
    "dropdeladd": "1 S PLATTE CLAY WAY",
    "dropdelcty": "KEARNEY",
    "dropdelst": "MO",
    "dropdelzpp": 640609998,
    "dropphyadd": "1 S PLATTE CLAY WAY",
    "dropphycty": "KEARNEY",
    "dropphyst": "MO",
    "dropphyzpp": 640609998,
    "dropmaladd": "1 S PLATTE CLAY WAY",
    "dropmalcty": "KEARNEY",
    "dropmalst": "MO",
    "dropmalzpp": 640609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166283641,
    "dropsitcph": 8166285717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16895",
    "droptype": "D",
    "dropname": "KELSO",
    "dropdeladd": "140 S MESSMER ST",
    "dropdelcty": "KELSO",
    "dropdelst": "MO",
    "dropdelzpp": 637589998,
    "dropphyadd": "140 S MESSMER ST",
    "dropphycty": "KELSO",
    "dropphyst": "MO",
    "dropphyzpp": 637589998,
    "dropmaladd": "140 S MESSMER ST",
    "dropmalcty": "KELSO",
    "dropmalst": "MO",
    "dropmalzpp": 637589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732642341,
    "dropsitcph": 5732642341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16897",
    "droptype": "D",
    "dropname": "KENNETT",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "KENNETT",
    "dropdelst": "MO",
    "dropdelzpp": 638579998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "KENNETT",
    "dropphyst": "MO",
    "dropphyzpp": 638579998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "KENNETT",
    "dropmalst": "MO",
    "dropmalzpp": 638579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738882588,
    "dropsitcph": 5738882588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16900",
    "droptype": "D",
    "dropname": "KEWANEE",
    "dropdeladd": "517 STATE HWY W",
    "dropdelcty": "KEWANEE",
    "dropdelst": "MO",
    "dropdelzpp": 638609998,
    "dropphyadd": "517 STATE HWY W",
    "dropphycty": "KEWANEE",
    "dropphyst": "MO",
    "dropphyzpp": 638609998,
    "dropmaladd": "517 STATE HWY W",
    "dropmalcty": "KEWANEE",
    "dropmalst": "MO",
    "dropmalzpp": 638609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737482260,
    "dropsitcph": 5737482260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16902",
    "droptype": "D",
    "dropname": "KEYTESVILLE",
    "dropdeladd": "418 W BRIDGE ST",
    "dropdelcty": "KEYTESVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652619998,
    "dropphyadd": "418 W BRIDGE ST",
    "dropphycty": "KEYTESVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652619998,
    "dropmaladd": "418 W BRIDGE ST",
    "dropmalcty": "KEYTESVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602883530,
    "dropsitcph": 6602883530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16905",
    "droptype": "D",
    "dropname": "KIDDER",
    "dropdeladd": "315 E 3RD ST",
    "dropdelcty": "KIDDER",
    "dropdelst": "MO",
    "dropdelzpp": 646499998,
    "dropphyadd": "315 E 3RD ST",
    "dropphycty": "KIDDER",
    "dropphyst": "MO",
    "dropphyzpp": 646499998,
    "dropmaladd": "315 E 3RD ST",
    "dropmalcty": "KIDDER",
    "dropmalst": "MO",
    "dropmalzpp": 646499998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165752411,
    "dropsitcph": 8165752411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16906",
    "droptype": "D",
    "dropname": "KIMBERLING CITY",
    "dropdeladd": "38A KIMBERLING CTR LN",
    "dropdelcty": "KIMBERLING CITY",
    "dropdelst": "MO",
    "dropdelzpp": 656869998,
    "dropphyadd": "38A KIMBERLING CTR LN",
    "dropphycty": "KIMBERLING CITY",
    "dropphyst": "MO",
    "dropphyzpp": 656869998,
    "dropmaladd": "38A KIMBERLING CTR LN",
    "dropmalcty": "KIMBERLING CITY",
    "dropmalst": "MO",
    "dropmalzpp": 656869998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177394646,
    "dropsitcph": 4177394646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16911",
    "droptype": "D",
    "dropname": "KING CITY",
    "dropdeladd": "102 E VERMONT ST",
    "dropdelcty": "KING CITY",
    "dropdelst": "MO",
    "dropdelzpp": 644639998,
    "dropphyadd": "102 E VERMONT ST",
    "dropphycty": "KING CITY",
    "dropphyst": "MO",
    "dropphyzpp": 644639998,
    "dropmaladd": "102 E VERMONT ST",
    "dropmalcty": "KING CITY",
    "dropmalst": "MO",
    "dropmalzpp": 644639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605354515,
    "dropsitcph": 6605354515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16912",
    "droptype": "D",
    "dropname": "KINGDOM CITY",
    "dropdeladd": "5500 OLD US HIGHWAY 40",
    "dropdelcty": "KINGDOM CITY",
    "dropdelst": "MO",
    "dropdelzpp": 652629998,
    "dropphyadd": "5500 OLD US HIGHWAY 40",
    "dropphycty": "KINGDOM CITY",
    "dropphyst": "MO",
    "dropphyzpp": 652629998,
    "dropmaladd": "5500 OLD US HIGHWAY 40",
    "dropmalcty": "KINGDOM CITY",
    "dropmalst": "MO",
    "dropmalzpp": 652629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736423877,
    "dropsitcph": 5736423877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16916",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "36 N FRANKLIN ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "MO",
    "dropdelzpp": 646509998,
    "dropphyadd": "36 N FRANKLIN ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "MO",
    "dropphyzpp": 646509998,
    "dropmaladd": "36 N FRANKLIN ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "MO",
    "dropmalzpp": 646509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165862071,
    "dropsitcph": 8165862071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16917",
    "droptype": "D",
    "dropname": "KINGSVILLE",
    "dropdeladd": "201 E PACIFIC ST",
    "dropdelcty": "KINGSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 640619998,
    "dropphyadd": "201 E PACIFIC ST",
    "dropphycty": "KINGSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 640619998,
    "dropmaladd": "201 E PACIFIC ST",
    "dropmalcty": "KINGSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 640619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167203513,
    "dropsitcph": 8167203513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16922",
    "droptype": "D",
    "dropname": "KIRBYVILLE",
    "dropdeladd": "4202 E STATE HIGHWAY 76",
    "dropdelcty": "KIRBYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 656799998,
    "dropphyadd": "4202 E STATE HIGHWAY 76",
    "dropphycty": "KIRBYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 656799998,
    "dropmaladd": "4202 E STATE HIGHWAY 76",
    "dropmalcty": "KIRBYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 656799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173344038,
    "dropsitcph": 4173344038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16925",
    "droptype": "D",
    "dropname": "KIRKSVILLE",
    "dropdeladd": "210 E JEFFERSON ST",
    "dropdelcty": "KIRKSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 635019998,
    "dropphyadd": "210 E JEFFERSON ST",
    "dropphycty": "KIRKSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 635019998,
    "dropmaladd": "210 E JEFFERSON ST",
    "dropmalcty": "KIRKSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 635019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606656077,
    "dropsitcph": 6606656077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16928",
    "droptype": "D",
    "dropname": "KISSEE MILLS",
    "dropdeladd": "13044 E STATE HIGHWAY 76",
    "dropdelcty": "KISSEE MILLS",
    "dropdelst": "MO",
    "dropdelzpp": 656809998,
    "dropphyadd": "13044 E STATE HIGHWAY 76",
    "dropphycty": "KISSEE MILLS",
    "dropphyst": "MO",
    "dropphyzpp": 656809998,
    "dropmaladd": "13044 E STATE HIGHWAY 76",
    "dropmalcty": "KISSEE MILLS",
    "dropmalst": "MO",
    "dropmalzpp": 656809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175466236,
    "dropsitcph": 4175466236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16932",
    "droptype": "D",
    "dropname": "KNOB LICK",
    "dropdeladd": "5961 STATE ROUTE DD",
    "dropdelcty": "KNOB LICK",
    "dropdelst": "MO",
    "dropdelzpp": 636519998,
    "dropphyadd": "5961 STATE ROUTE DD",
    "dropphycty": "KNOB LICK",
    "dropphyst": "MO",
    "dropphyzpp": 636519998,
    "dropmaladd": "5961 STATE ROUTE DD",
    "dropmalcty": "KNOB LICK",
    "dropmalst": "MO",
    "dropmalzpp": 636519998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737567911,
    "dropsitcph": 5737567911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16933",
    "droptype": "D",
    "dropname": "KNOB NOSTER",
    "dropdeladd": "505 W MCPHERSON ST",
    "dropdelcty": "KNOB NOSTER",
    "dropdelst": "MO",
    "dropdelzpp": 653369998,
    "dropphyadd": "505 W MCPHERSON ST",
    "dropphycty": "KNOB NOSTER",
    "dropphyst": "MO",
    "dropphyzpp": 653369998,
    "dropmaladd": "505 W MCPHERSON ST",
    "dropmalcty": "KNOB NOSTER",
    "dropmalst": "MO",
    "dropmalzpp": 653369998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605632808,
    "dropsitcph": 6605632808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16934",
    "droptype": "D",
    "dropname": "KNOX CITY",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "KNOX CITY",
    "dropdelst": "MO",
    "dropdelzpp": 634469998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "KNOX CITY",
    "dropphyst": "MO",
    "dropphyzpp": 634469998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "KNOX CITY",
    "dropmalst": "MO",
    "dropmalzpp": 634469998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604540571,
    "dropsitcph": 6604540571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16943",
    "droptype": "D",
    "dropname": "KOSHKONONG",
    "dropdeladd": "303 DIGGINS ST",
    "dropdelcty": "KOSHKONONG",
    "dropdelst": "MO",
    "dropdelzpp": 656929998,
    "dropphyadd": "303 DIGGINS ST",
    "dropphycty": "KOSHKONONG",
    "dropphyst": "MO",
    "dropphyzpp": 656929998,
    "dropmaladd": "303 DIGGINS ST",
    "dropmalcty": "KOSHKONONG",
    "dropmalst": "MO",
    "dropmalzpp": 656929998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178675510,
    "dropsitcph": 4178675510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16945",
    "droptype": "D",
    "dropname": "LA BELLE",
    "dropdeladd": "109 N 3RD ST",
    "dropdelcty": "LA BELLE",
    "dropdelst": "MO",
    "dropdelzpp": 634479998,
    "dropphyadd": "109 N 3RD ST",
    "dropphycty": "LA BELLE",
    "dropphyst": "MO",
    "dropphyzpp": 634479998,
    "dropmaladd": "109 N 3RD ST",
    "dropmalcty": "LA BELLE",
    "dropmalst": "MO",
    "dropmalzpp": 634479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604622004,
    "dropsitcph": 6604622004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16946",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "MO",
    "dropdelzpp": 634489998,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "LA GRANGE",
    "dropphyst": "MO",
    "dropphyzpp": 634489998,
    "dropmaladd": "202 N MAIN ST",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "MO",
    "dropmalzpp": 634489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736552249,
    "dropsitcph": 5736552249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16947",
    "droptype": "D",
    "dropname": "LA MONTE",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "LA MONTE",
    "dropdelst": "MO",
    "dropdelzpp": 653379998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "LA MONTE",
    "dropphyst": "MO",
    "dropphyzpp": 653379998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "LA MONTE",
    "dropmalst": "MO",
    "dropmalzpp": 653379998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603475450,
    "dropsitcph": 6603475450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16948",
    "droptype": "D",
    "dropname": "LA PLATA",
    "dropdeladd": "102 E SANDERS ST",
    "dropdelcty": "LA PLATA",
    "dropdelst": "MO",
    "dropdelzpp": 635499998,
    "dropphyadd": "102 E SANDERS ST",
    "dropphycty": "LA PLATA",
    "dropphyst": "MO",
    "dropphyzpp": 635499998,
    "dropmaladd": "102 E SANDERS ST",
    "dropmalcty": "LA PLATA",
    "dropmalst": "MO",
    "dropmalzpp": 635499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603324344,
    "dropsitcph": 6603324344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16949",
    "droptype": "D",
    "dropname": "LA RUSSELL",
    "dropdeladd": "311 S MAIN ST",
    "dropdelcty": "LA RUSSELL",
    "dropdelst": "MO",
    "dropdelzpp": 648489998,
    "dropphyadd": "311 S MAIN ST",
    "dropphycty": "LA RUSSELL",
    "dropphyst": "MO",
    "dropphyzpp": 648489998,
    "dropmaladd": "311 S MAIN ST",
    "dropmalcty": "LA RUSSELL",
    "dropmalst": "MO",
    "dropmalzpp": 648489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175483388,
    "dropsitcph": 4175483388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16950",
    "droptype": "D",
    "dropname": "LABADIE",
    "dropdeladd": "106 3RD ST",
    "dropdelcty": "LABADIE",
    "dropdelst": "MO",
    "dropdelzpp": 630559998,
    "dropphyadd": "106 3RD ST",
    "dropphycty": "LABADIE",
    "dropphyst": "MO",
    "dropphyzpp": 630559998,
    "dropmaladd": "106 3RD ST",
    "dropmalcty": "LABADIE",
    "dropmalst": "MO",
    "dropmalzpp": 630559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6367422677,
    "dropsitcph": 6367422677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16953",
    "droptype": "D",
    "dropname": "LACLEDE",
    "dropdeladd": "607 PERSHING DR",
    "dropdelcty": "LACLEDE",
    "dropdelst": "MO",
    "dropdelzpp": 646519103,
    "dropphyadd": "607 PERSHING DR",
    "dropphycty": "LACLEDE",
    "dropphyst": "MO",
    "dropphyzpp": 646519103,
    "dropmaladd": "607 PERSHING DR",
    "dropmalcty": "LACLEDE",
    "dropmalst": "MO",
    "dropmalzpp": 646519103,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609632557,
    "dropsitcph": 6609632557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16955",
    "droptype": "D",
    "dropname": "LADDONIA",
    "dropdeladd": "501 E 2ND ST",
    "dropdelcty": "LADDONIA",
    "dropdelst": "MO",
    "dropdelzpp": 633529998,
    "dropphyadd": "501 E 2ND ST",
    "dropphycty": "LADDONIA",
    "dropphyst": "MO",
    "dropphyzpp": 633529998,
    "dropmaladd": "501 E 2ND ST",
    "dropmalcty": "LADDONIA",
    "dropmalst": "MO",
    "dropmalzpp": 633529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733732366,
    "dropsitcph": 5733732366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16968",
    "droptype": "D",
    "dropname": "LAKE OZARK",
    "dropdeladd": "2111 BAGNELL DAM BLVD",
    "dropdelcty": "LAKE OZARK",
    "dropdelst": "MO",
    "dropdelzpp": 650499998,
    "dropphyadd": "2111 BAGNELL DAM BLVD",
    "dropphycty": "LAKE OZARK",
    "dropphyst": "MO",
    "dropphyzpp": 650499998,
    "dropmaladd": "2111 BAGNELL DAM BLVD",
    "dropmalcty": "LAKE OZARK",
    "dropmalst": "MO",
    "dropmalzpp": 650499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733653344,
    "dropsitcph": 5733653344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16971",
    "droptype": "D",
    "dropname": "LAKE SPRING",
    "dropdeladd": "100 STATE ROUTE 72",
    "dropdelcty": "LAKE SPRING",
    "dropdelst": "MO",
    "dropdelzpp": 655329998,
    "dropphyadd": "100 STATE ROUTE 72",
    "dropphycty": "LAKE SPRING",
    "dropphyst": "MO",
    "dropphyzpp": 655329998,
    "dropmaladd": "100 STATE ROUTE 72",
    "dropmalcty": "LAKE SPRING",
    "dropmalst": "MO",
    "dropmalzpp": 655329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733648366,
    "dropsitcph": 5733648366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16983",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "131 W 11TH ST",
    "dropdelcty": "LAMAR",
    "dropdelst": "MO",
    "dropdelzpp": 647599998,
    "dropphyadd": "131 W 11TH ST",
    "dropphycty": "LAMAR",
    "dropphyst": "MO",
    "dropphyzpp": 647599998,
    "dropmaladd": "131 W 11TH ST",
    "dropmalcty": "LAMAR",
    "dropmalst": "MO",
    "dropmalzpp": 647599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176825435,
    "dropsitcph": 4176825435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW16999",
    "droptype": "D",
    "dropname": "LAMPE",
    "dropdeladd": "99 STATE ROUTE H",
    "dropdelcty": "LAMPE",
    "dropdelst": "MO",
    "dropdelzpp": 656819998,
    "dropphyadd": "99 STATE ROUTE H",
    "dropphycty": "LAMPE",
    "dropphyst": "MO",
    "dropphyzpp": 656819998,
    "dropmaladd": "99 STATE ROUTE H",
    "dropmalcty": "LAMPE",
    "dropmalst": "MO",
    "dropmalzpp": 656819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177794949,
    "dropsitcph": 4177794949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17000",
    "droptype": "D",
    "dropname": "LANAGAN",
    "dropdeladd": "117 N MAIN ST",
    "dropdelcty": "LANAGAN",
    "dropdelst": "MO",
    "dropdelzpp": 648479998,
    "dropphyadd": "117 N MAIN ST",
    "dropphycty": "LANAGAN",
    "dropphyst": "MO",
    "dropphyzpp": 648479998,
    "dropmaladd": "117 N MAIN ST",
    "dropmalcty": "LANAGAN",
    "dropmalst": "MO",
    "dropmalzpp": 648479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174362498,
    "dropsitcph": 4174362498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17001",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "110 N GREEN ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "MO",
    "dropdelzpp": 635489998,
    "dropphyadd": "110 N GREEN ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "MO",
    "dropphyzpp": 635489998,
    "dropmaladd": "110 N GREEN ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "MO",
    "dropmalzpp": 635489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604573222,
    "dropsitcph": 6604573222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17005",
    "droptype": "D",
    "dropname": "LAQUEY",
    "dropdeladd": "28125 HIGHWAY AA",
    "dropdelcty": "LAQUEY",
    "dropdelst": "MO",
    "dropdelzpp": 655349998,
    "dropphyadd": "28125 HIGHWAY AA",
    "dropphycty": "LAQUEY",
    "dropphyst": "MO",
    "dropphyzpp": 655349998,
    "dropmaladd": "28125 HIGHWAY AA",
    "dropmalcty": "LAQUEY",
    "dropmalst": "MO",
    "dropmalzpp": 655349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734352030,
    "dropsitcph": 5734352030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17006",
    "droptype": "D",
    "dropname": "LAREDO",
    "dropdeladd": "216 E MAIN ST",
    "dropdelcty": "LAREDO",
    "dropdelst": "MO",
    "dropdelzpp": 646529998,
    "dropphyadd": "216 E MAIN ST",
    "dropphycty": "LAREDO",
    "dropphyst": "MO",
    "dropphyzpp": 646529998,
    "dropmaladd": "216 E MAIN ST",
    "dropmalcty": "LAREDO",
    "dropmalst": "MO",
    "dropmalzpp": 646529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602862975,
    "dropsitcph": 6602862975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17007",
    "droptype": "D",
    "dropname": "LATHAM",
    "dropdeladd": "100 STATE RTE E",
    "dropdelcty": "LATHAM",
    "dropdelst": "MO",
    "dropdelzpp": 650509998,
    "dropphyadd": "100 STATE RTE E",
    "dropphycty": "LATHAM",
    "dropphyst": "MO",
    "dropphyzpp": 650509998,
    "dropmaladd": "100 STATE RTE E",
    "dropmalcty": "LATHAM",
    "dropmalst": "MO",
    "dropmalzpp": 650509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604586211,
    "dropsitcph": 6604586211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17008",
    "droptype": "D",
    "dropname": "LATHROP",
    "dropdeladd": "606 OAK ST",
    "dropdelcty": "LATHROP",
    "dropdelst": "MO",
    "dropdelzpp": 644659998,
    "dropphyadd": "606 OAK ST",
    "dropphycty": "LATHROP",
    "dropphyst": "MO",
    "dropphyzpp": 644659998,
    "dropmaladd": "606 OAK ST",
    "dropmalcty": "LATHROP",
    "dropmalst": "MO",
    "dropmalzpp": 644659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165284228,
    "dropsitcph": 8165284228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17011",
    "droptype": "D",
    "dropname": "LAWSON",
    "dropdeladd": "420 N PENNSYLVANIA AVE",
    "dropdelcty": "LAWSON",
    "dropdelst": "MO",
    "dropdelzpp": 640629998,
    "dropphyadd": "420 N PENNSYLVANIA AVE",
    "dropphycty": "LAWSON",
    "dropphyst": "MO",
    "dropphyzpp": 640629998,
    "dropmaladd": "420 N PENNSYLVANIA AVE",
    "dropmalcty": "LAWSON",
    "dropmalst": "MO",
    "dropmalzpp": 640629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165807042,
    "dropsitcph": 8165807042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17014",
    "droptype": "D",
    "dropname": "LEASBURG",
    "dropdeladd": "2302 HIGHWAY H",
    "dropdelcty": "LEASBURG",
    "dropdelst": "MO",
    "dropdelzpp": 655359998,
    "dropphyadd": "2302 HIGHWAY H",
    "dropphycty": "LEASBURG",
    "dropphyst": "MO",
    "dropphyzpp": 655359998,
    "dropmaladd": "2302 HIGHWAY H",
    "dropmalcty": "LEASBURG",
    "dropmalst": "MO",
    "dropmalzpp": 655359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732456466,
    "dropsitcph": 5732456466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17015",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "121 E COMMERCIAL ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "MO",
    "dropdelzpp": 655369998,
    "dropphyadd": "121 E COMMERCIAL ST",
    "dropphycty": "LEBANON",
    "dropphyst": "MO",
    "dropphyzpp": 655369998,
    "dropmaladd": "121 E COMMERCIAL ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "MO",
    "dropmalzpp": 655369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175322222,
    "dropsitcph": 4175322222,
    "dropfax": 4175321080
  },
  {
    "dcode": "D",
    "dropkey": "PW17019",
    "droptype": "D",
    "dropname": "LEES SUMMIT",
    "dropdeladd": "1404 SW MARKET ST",
    "dropdelcty": "LEES SUMMIT",
    "dropdelst": "MO",
    "dropdelzpp": 640819923,
    "dropphyadd": "1404 SW MARKET ST",
    "dropphycty": "LEES SUMMIT",
    "dropphyst": "MO",
    "dropphyzpp": 640819923,
    "dropmaladd": "1404 SW MARKET ST",
    "dropmalcty": "LEES SUMMIT",
    "dropmalst": "MO",
    "dropmalzpp": 640819923,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165254173,
    "dropsitcph": 8165253589,
    "dropfax": 8165243592
  },
  {
    "dcode": "D",
    "dropkey": "PW17020",
    "droptype": "D",
    "dropname": "LEETON",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "LEETON",
    "dropdelst": "MO",
    "dropdelzpp": 647619998,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "LEETON",
    "dropphyst": "MO",
    "dropphyzpp": 647619998,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "LEETON",
    "dropmalst": "MO",
    "dropmalzpp": 647619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606534353,
    "dropsitcph": 6606534353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17026",
    "droptype": "D",
    "dropname": "LEONARD",
    "dropdeladd": "142 E HIGHWAY 151",
    "dropdelcty": "LEONARD",
    "dropdelst": "MO",
    "dropdelzpp": 634519998,
    "dropphyadd": "142 E HIGHWAY 151",
    "dropphycty": "LEONARD",
    "dropphyst": "MO",
    "dropphyzpp": 634519998,
    "dropmaladd": "142 E HIGHWAY 151",
    "dropmalcty": "LEONARD",
    "dropmalst": "MO",
    "dropmalzpp": 634519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607624411,
    "dropsitcph": 6607624411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17027",
    "droptype": "D",
    "dropname": "LEOPOLD",
    "dropdeladd": "15243 BCR 402",
    "dropdelcty": "LEOPOLD",
    "dropdelst": "MO",
    "dropdelzpp": 637609998,
    "dropphyadd": "15243 BCR 402",
    "dropphycty": "LEOPOLD",
    "dropphyst": "MO",
    "dropphyzpp": 637609998,
    "dropmaladd": "15243 BCR 402",
    "dropmalcty": "LEOPOLD",
    "dropmalst": "MO",
    "dropmalzpp": 637609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732382241,
    "dropsitcph": 5732382241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17028",
    "droptype": "D",
    "dropname": "LESLIE",
    "dropdeladd": "321 MAIN ST",
    "dropdelcty": "LESLIE",
    "dropdelst": "MO",
    "dropdelzpp": 630569998,
    "dropphyadd": "321 MAIN ST",
    "dropphycty": "LESLIE",
    "dropphyst": "MO",
    "dropphyzpp": 630569998,
    "dropmaladd": "321 MAIN ST",
    "dropmalcty": "LESLIE",
    "dropmalst": "MO",
    "dropmalzpp": 630569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734843111,
    "dropsitcph": 5734843111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17029",
    "droptype": "D",
    "dropname": "LESTERVILLE",
    "dropdeladd": "33010 HIGHWAY 21",
    "dropdelcty": "LESTERVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 636549998,
    "dropphyadd": "33010 HIGHWAY 21",
    "dropphycty": "LESTERVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 636549998,
    "dropmaladd": "33010 HIGHWAY 21",
    "dropmalcty": "LESTERVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 636549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736372327,
    "dropsitcph": 5736372327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17031",
    "droptype": "D",
    "dropname": "LEVASY",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "LEVASY",
    "dropdelst": "MO",
    "dropdelzpp": 640669998,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "LEVASY",
    "dropphyst": "MO",
    "dropphyzpp": 640669998,
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "LEVASY",
    "dropmalst": "MO",
    "dropmalzpp": 640669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166503955,
    "dropsitcph": 8166503955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17033",
    "droptype": "D",
    "dropname": "LEWISTOWN",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "LEWISTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 634529998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "LEWISTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 634529998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "LEWISTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 634529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732152525,
    "dropsitcph": 5732152525,
    "dropfax": 5732152525
  },
  {
    "dcode": "D",
    "dropkey": "PW17035",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "301 S BUSINESS HIGHWAY 13",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 640679998,
    "dropphyadd": "301 S BUSINESS HIGHWAY 13",
    "dropphycty": "LEXINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 640679998,
    "dropmaladd": "301 S BUSINESS HIGHWAY 13",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 640679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602593612,
    "dropsitcph": 6602593612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17036",
    "droptype": "D",
    "dropname": "LIBERAL",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "LIBERAL",
    "dropdelst": "MO",
    "dropdelzpp": 647629998,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "LIBERAL",
    "dropphyst": "MO",
    "dropphyzpp": 647629998,
    "dropmaladd": "128 S MAIN ST",
    "dropmalcty": "LIBERAL",
    "dropmalst": "MO",
    "dropmalzpp": 647629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178436505,
    "dropsitcph": 4178436505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17037",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "1000 PROGRESS DR",
    "dropdelcty": "LIBERTY",
    "dropdelst": "MO",
    "dropdelzpp": 640689998,
    "dropphyadd": "1000 PROGRESS DR",
    "dropphycty": "LIBERTY",
    "dropphyst": "MO",
    "dropphyzpp": 640689998,
    "dropmaladd": "1000 PROGRESS DR",
    "dropmalcty": "LIBERTY",
    "dropmalst": "MO",
    "dropmalzpp": 640689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167922630,
    "dropsitcph": 8167922872,
    "dropfax": 6505784548
  },
  {
    "dcode": "D",
    "dropkey": "PW17039",
    "droptype": "D",
    "dropname": "LICKING",
    "dropdeladd": "133 S MAIN ST",
    "dropdelcty": "LICKING",
    "dropdelst": "MO",
    "dropdelzpp": 655429998,
    "dropphyadd": "133 S MAIN ST",
    "dropphycty": "LICKING",
    "dropphyst": "MO",
    "dropphyzpp": 655429998,
    "dropmaladd": "133 S MAIN ST",
    "dropmalcty": "LICKING",
    "dropmalst": "MO",
    "dropmalzpp": 655429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736746048,
    "dropsitcph": 5736746048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17041",
    "droptype": "D",
    "dropname": "LIGUORI",
    "dropdeladd": "1 LIGUORI DR",
    "dropdelcty": "LIGUORI",
    "dropdelst": "MO",
    "dropdelzpp": 630579998,
    "dropphyadd": "1 LIGUORI DR",
    "dropphycty": "LIGUORI",
    "dropphyst": "MO",
    "dropphyzpp": 630579998,
    "dropmaladd": "1 LIGUORI DR",
    "dropmalcty": "LIGUORI",
    "dropmalst": "MO",
    "dropmalzpp": 630579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364648446,
    "dropsitcph": 6364648446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17042",
    "droptype": "D",
    "dropname": "LILBOURN",
    "dropdeladd": "203 N 3RD ST",
    "dropdelcty": "LILBOURN",
    "dropdelst": "MO",
    "dropdelzpp": 638629998,
    "dropphyadd": "203 N 3RD ST",
    "dropphycty": "LILBOURN",
    "dropphyst": "MO",
    "dropphyzpp": 638629998,
    "dropmaladd": "203 N 3RD ST",
    "dropmalcty": "LILBOURN",
    "dropmalst": "MO",
    "dropmalzpp": 638629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736882088,
    "dropsitcph": 5736882088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17043",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "214 E MAIN ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "MO",
    "dropdelzpp": 653389998,
    "dropphyadd": "214 E MAIN ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "MO",
    "dropphyzpp": 653389998,
    "dropmaladd": "214 E MAIN ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "MO",
    "dropmalzpp": 653389998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605473728,
    "dropsitcph": 6605473728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17046",
    "droptype": "D",
    "dropname": "LINN",
    "dropdeladd": "1009 E MAIN ST",
    "dropdelcty": "LINN",
    "dropdelst": "MO",
    "dropdelzpp": 650519998,
    "dropphyadd": "1009 E MAIN ST",
    "dropphycty": "LINN",
    "dropphyst": "MO",
    "dropphyzpp": 650519998,
    "dropmaladd": "1009 E MAIN ST",
    "dropmalcty": "LINN",
    "dropmalst": "MO",
    "dropmalzpp": 650519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738972146,
    "dropsitcph": 5738972146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17047",
    "droptype": "D",
    "dropname": "LINN CREEK",
    "dropdeladd": "199 BUSINESS PARK RD",
    "dropdelcty": "LINN CREEK",
    "dropdelst": "MO",
    "dropdelzpp": 650529998,
    "dropphyadd": "199 BUSINESS PARK RD",
    "dropphycty": "LINN CREEK",
    "dropphyst": "MO",
    "dropphyzpp": 650529998,
    "dropmaladd": "199 BUSINESS PARK RD",
    "dropmalcty": "LINN CREEK",
    "dropmalst": "MO",
    "dropmalzpp": 650529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733467331,
    "dropsitcph": 5733467331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17049",
    "droptype": "D",
    "dropname": "LINNEUS",
    "dropdeladd": "200 S HIGH ST",
    "dropdelcty": "LINNEUS",
    "dropdelst": "MO",
    "dropdelzpp": 646539998,
    "dropphyadd": "200 S HIGH ST",
    "dropphycty": "LINNEUS",
    "dropphyst": "MO",
    "dropphyzpp": 646539998,
    "dropmaladd": "200 S HIGH ST",
    "dropmalcty": "LINNEUS",
    "dropmalst": "MO",
    "dropmalzpp": 646539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608955218,
    "dropsitcph": 6608955218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17051",
    "droptype": "D",
    "dropname": "LIVONIA",
    "dropdeladd": "204 E D AVE",
    "dropdelcty": "LIVONIA",
    "dropdelst": "MO",
    "dropdelzpp": 635519998,
    "dropphyadd": "204 E D AVE",
    "dropphycty": "LIVONIA",
    "dropphyst": "MO",
    "dropphyzpp": 635519998,
    "dropmaladd": "204 E D AVE",
    "dropmalcty": "LIVONIA",
    "dropmalst": "MO",
    "dropmalzpp": 635519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607769024,
    "dropsitcph": 6607769024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17058",
    "droptype": "D",
    "dropname": "LOCKWOOD",
    "dropdeladd": "800 MAIN ST",
    "dropdelcty": "LOCKWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 656829998,
    "dropphyadd": "800 MAIN ST",
    "dropphycty": "LOCKWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 656829998,
    "dropmaladd": "800 MAIN ST",
    "dropmalcty": "LOCKWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 656829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172324767,
    "dropsitcph": 4172324767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17062",
    "droptype": "D",
    "dropname": "LOHMAN",
    "dropdeladd": "2922 MAIN ST",
    "dropdelcty": "LOHMAN",
    "dropdelst": "MO",
    "dropdelzpp": 650539998,
    "dropphyadd": "2922 MAIN ST",
    "dropphycty": "LOHMAN",
    "dropphyst": "MO",
    "dropphyzpp": 650539998,
    "dropmaladd": "2922 MAIN ST",
    "dropmalcty": "LOHMAN",
    "dropmalst": "MO",
    "dropmalzpp": 650539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737824444,
    "dropsitcph": 5737824444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17065",
    "droptype": "D",
    "dropname": "LONE JACK",
    "dropdeladd": "309 N BYNUM RD",
    "dropdelcty": "LONE JACK",
    "dropdelst": "MO",
    "dropdelzpp": 640709998,
    "dropphyadd": "309 N BYNUM RD",
    "dropphycty": "LONE JACK",
    "dropphyst": "MO",
    "dropphyzpp": 640709998,
    "dropmaladd": "309 N BYNUM RD",
    "dropmalcty": "LONE JACK",
    "dropmalst": "MO",
    "dropmalzpp": 640709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166972242,
    "dropsitcph": 8166972242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17066",
    "droptype": "D",
    "dropname": "LONEDELL",
    "dropdeladd": "3735 HIGHWAY 30",
    "dropdelcty": "LONEDELL",
    "dropdelst": "MO",
    "dropdelzpp": 630609998,
    "dropphyadd": "3735 HIGHWAY 30",
    "dropphycty": "LONEDELL",
    "dropphyst": "MO",
    "dropphyzpp": 630609998,
    "dropmaladd": "3735 HIGHWAY 30",
    "dropmalcty": "LONEDELL",
    "dropmalst": "MO",
    "dropmalzpp": 630609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366291636,
    "dropsitcph": 6366291636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17067",
    "droptype": "D",
    "dropname": "LONG LANE",
    "dropdeladd": "1668 STATE HIGHWAY 32",
    "dropdelcty": "LONG LANE",
    "dropdelst": "MO",
    "dropdelzpp": 655909998,
    "dropphyadd": "1668 STATE HIGHWAY 32",
    "dropphycty": "LONG LANE",
    "dropphyst": "MO",
    "dropphyzpp": 655909998,
    "dropmaladd": "1668 STATE HIGHWAY 32",
    "dropmalcty": "LONG LANE",
    "dropmalst": "MO",
    "dropmalzpp": 655909998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173458293,
    "dropsitcph": 4173458293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17073",
    "droptype": "D",
    "dropname": "LOOSE CREEK",
    "dropdeladd": "162 COUNTY ROAD 402 STE 1",
    "dropdelcty": "LOOSE CREEK",
    "dropdelst": "MO",
    "dropdelzpp": 650549998,
    "dropphyadd": "162 COUNTY ROAD 402 STE 1",
    "dropphycty": "LOOSE CREEK",
    "dropphyst": "MO",
    "dropphyzpp": 650549998,
    "dropmaladd": "162 COUNTY ROAD 402 STE 1",
    "dropmalcty": "LOOSE CREEK",
    "dropmalst": "MO",
    "dropmalzpp": 650549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738973881,
    "dropsitcph": 5738973881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17108",
    "droptype": "D",
    "dropname": "LOUISBURG",
    "dropdeladd": "274 STATE HIGHWAY 64",
    "dropdelcty": "LOUISBURG",
    "dropdelst": "MO",
    "dropdelzpp": 656859998,
    "dropphyadd": "274 STATE HIGHWAY 64",
    "dropphycty": "LOUISBURG",
    "dropphyst": "MO",
    "dropphyzpp": 656859998,
    "dropmaladd": "274 STATE HIGHWAY 64",
    "dropmalcty": "LOUISBURG",
    "dropmalst": "MO",
    "dropmalzpp": 656859998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177523721,
    "dropsitcph": 4177523721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17109",
    "droptype": "D",
    "dropname": "LOUISIANA",
    "dropdeladd": "522 GEORGIA ST",
    "dropdelcty": "LOUISIANA",
    "dropdelst": "MO",
    "dropdelzpp": 633539998,
    "dropphyadd": "522 GEORGIA ST",
    "dropphycty": "LOUISIANA",
    "dropphyst": "MO",
    "dropphyzpp": 633539998,
    "dropmaladd": "522 GEORGIA ST",
    "dropmalcty": "LOUISIANA",
    "dropmalst": "MO",
    "dropmalzpp": 633539998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737545291,
    "dropsitcph": 5737545291,
    "dropfax": 5737545126
  },
  {
    "dcode": "D",
    "dropkey": "PW17111",
    "droptype": "D",
    "dropname": "LOWNDES",
    "dropdeladd": "13066 WAYNE RTE E",
    "dropdelcty": "LOWNDES",
    "dropdelst": "MO",
    "dropdelzpp": 639519998,
    "dropphyadd": "13066 WAYNE RTE E",
    "dropphycty": "LOWNDES",
    "dropphyst": "MO",
    "dropphyzpp": 639519998,
    "dropmaladd": "13066 WAYNE RTE E",
    "dropmalcty": "LOWNDES",
    "dropmalst": "MO",
    "dropmalzpp": 639519998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734952443,
    "dropsitcph": 5734952443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17112",
    "droptype": "D",
    "dropname": "LOWRY CITY",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "LOWRY CITY",
    "dropdelst": "MO",
    "dropdelzpp": 647639998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "LOWRY CITY",
    "dropphyst": "MO",
    "dropphyzpp": 647639998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "LOWRY CITY",
    "dropmalst": "MO",
    "dropmalzpp": 647639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176442241,
    "dropsitcph": 4176442241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17120",
    "droptype": "D",
    "dropname": "LUCERNE",
    "dropdeladd": "205 STATE HIGHWAY A E",
    "dropdelcty": "LUCERNE",
    "dropdelst": "MO",
    "dropdelzpp": 646559998,
    "dropphyadd": "205 STATE HIGHWAY A E",
    "dropphycty": "LUCERNE",
    "dropphyst": "MO",
    "dropphyzpp": 646559998,
    "dropmaladd": "205 STATE HIGHWAY A E",
    "dropmalcty": "LUCERNE",
    "dropmalst": "MO",
    "dropmalzpp": 646559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607932225,
    "dropsitcph": 6607932225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17121",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "LUDLOW",
    "dropdelst": "MO",
    "dropdelzpp": 646569998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "LUDLOW",
    "dropphyst": "MO",
    "dropphyzpp": 646569998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "LUDLOW",
    "dropmalst": "MO",
    "dropmalzpp": 646569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607384737,
    "dropsitcph": 6607384737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17132",
    "droptype": "D",
    "dropname": "MACKS CREEK",
    "dropdeladd": "13073 W US HIGHWAY 54",
    "dropdelcty": "MACKS CREEK",
    "dropdelst": "MO",
    "dropdelzpp": 657869998,
    "dropphyadd": "13073 W US HIGHWAY 54",
    "dropphycty": "MACKS CREEK",
    "dropphyst": "MO",
    "dropphyzpp": 657869998,
    "dropmaladd": "13073 W US HIGHWAY 54",
    "dropmalcty": "MACKS CREEK",
    "dropmalst": "MO",
    "dropmalzpp": 657869998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 5733635431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17134",
    "droptype": "D",
    "dropname": "MACOMB",
    "dropdeladd": "4880 HIGHWAY A",
    "dropdelcty": "MACOMB",
    "dropdelst": "MO",
    "dropdelzpp": 657029998,
    "dropphyadd": "4880 HIGHWAY A",
    "dropphycty": "MACOMB",
    "dropphyst": "MO",
    "dropphyzpp": 657029998,
    "dropmaladd": "4880 HIGHWAY A",
    "dropmalcty": "MACOMB",
    "dropmalst": "MO",
    "dropmalzpp": 657029998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177464400,
    "dropsitcph": 4177464400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17135",
    "droptype": "D",
    "dropname": "MACON",
    "dropdeladd": "105 DUFF ST",
    "dropdelcty": "MACON",
    "dropdelst": "MO",
    "dropdelzpp": 635529998,
    "dropphyadd": "105 DUFF ST",
    "dropphycty": "MACON",
    "dropphyst": "MO",
    "dropphyzpp": 635529998,
    "dropmaladd": "105 DUFF ST",
    "dropmalcty": "MACON",
    "dropmalst": "MO",
    "dropmalzpp": 635529998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603852816,
    "dropsitcph": 6603852816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17136",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "MO",
    "dropdelzpp": 652639998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "MO",
    "dropphyzpp": 652639998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "MADISON",
    "dropmalst": "MO",
    "dropmalzpp": 652639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602913091,
    "dropsitcph": 6602913091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17139",
    "droptype": "D",
    "dropname": "MAITLAND",
    "dropdeladd": "205 ASH ST",
    "dropdelcty": "MAITLAND",
    "dropdelst": "MO",
    "dropdelzpp": 644669998,
    "dropphyadd": "205 ASH ST",
    "dropphycty": "MAITLAND",
    "dropphyst": "MO",
    "dropphyzpp": 644669998,
    "dropmaladd": "205 ASH ST",
    "dropmalcty": "MAITLAND",
    "dropmalst": "MO",
    "dropmalzpp": 644669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609352221,
    "dropsitcph": 6609352221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17140",
    "droptype": "D",
    "dropname": "MALDEN",
    "dropdeladd": "107 N DOUGLASS ST",
    "dropdelcty": "MALDEN",
    "dropdelst": "MO",
    "dropdelzpp": 638639998,
    "dropphyadd": "107 N DOUGLASS ST",
    "dropphycty": "MALDEN",
    "dropphyst": "MO",
    "dropphyzpp": 638639998,
    "dropmaladd": "107 N DOUGLASS ST",
    "dropmalcty": "MALDEN",
    "dropmalst": "MO",
    "dropmalzpp": 638639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732764483,
    "dropsitcph": 5732764483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17141",
    "droptype": "D",
    "dropname": "MALTA BEND",
    "dropdeladd": "106 N LINN ST",
    "dropdelcty": "MALTA BEND",
    "dropdelst": "MO",
    "dropdelzpp": 653399998,
    "dropphyadd": "106 N LINN ST",
    "dropphycty": "MALTA BEND",
    "dropphyst": "MO",
    "dropphyzpp": 653399998,
    "dropmaladd": "106 N LINN ST",
    "dropmalcty": "MALTA BEND",
    "dropmalst": "MO",
    "dropmalzpp": 653399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605952211,
    "dropsitcph": 6605952211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17148",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "310 E COMMERCIAL ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 657049998,
    "dropphyadd": "310 E COMMERCIAL ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 657049998,
    "dropmaladd": "310 E COMMERCIAL ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 657049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179243415,
    "dropsitcph": 4179243415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17150",
    "droptype": "D",
    "dropname": "MAPAVILLE",
    "dropdeladd": "3823 STATE ROAD Z",
    "dropdelcty": "MAPAVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 630659998,
    "dropphyadd": "3823 STATE ROAD Z",
    "dropphycty": "MAPAVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 630659998,
    "dropmaladd": "3823 STATE ROAD Z",
    "dropmalcty": "MAPAVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 630659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369374112,
    "dropsitcph": 6369374112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17156",
    "droptype": "D",
    "dropname": "MARBLE HILL",
    "dropdeladd": "200 STATE HIGHWAY 34 W",
    "dropdelcty": "MARBLE HILL",
    "dropdelst": "MO",
    "dropdelzpp": 637649998,
    "dropphyadd": "200 STATE HIGHWAY 34 W",
    "dropphycty": "MARBLE HILL",
    "dropphyst": "MO",
    "dropphyzpp": 637649998,
    "dropmaladd": "200 STATE HIGHWAY 34 W",
    "dropmalcty": "MARBLE HILL",
    "dropmalst": "MO",
    "dropmalzpp": 637649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732382662,
    "dropsitcph": 5732382662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17158",
    "droptype": "D",
    "dropname": "MARCELINE",
    "dropdeladd": "120 E RITCHIE AVE",
    "dropdelcty": "MARCELINE",
    "dropdelst": "MO",
    "dropdelzpp": 646589998,
    "dropphyadd": "120 E RITCHIE AVE",
    "dropphycty": "MARCELINE",
    "dropphyst": "MO",
    "dropphyzpp": 646589998,
    "dropmaladd": "120 E RITCHIE AVE",
    "dropmalcty": "MARCELINE",
    "dropmalst": "MO",
    "dropmalzpp": 646589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603763300,
    "dropsitcph": 6603763300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17161",
    "droptype": "D",
    "dropname": "MARIONVILLE",
    "dropdeladd": "201 W WASHINGTON",
    "dropdelcty": "MARIONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 657059998,
    "dropphyadd": "201 W WASHINGTON",
    "dropphycty": "MARIONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 657059998,
    "dropmaladd": "201 W WASHINGTON",
    "dropmalcty": "MARIONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 657059998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174632555,
    "dropsitcph": 4174632555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17166",
    "droptype": "D",
    "dropname": "MARQUAND",
    "dropdeladd": "105 WHITENER ST",
    "dropdelcty": "MARQUAND",
    "dropdelst": "MO",
    "dropdelzpp": 636559998,
    "dropphyadd": "105 WHITENER ST",
    "dropphycty": "MARQUAND",
    "dropphyst": "MO",
    "dropphyzpp": 636559998,
    "dropmaladd": "105 WHITENER ST",
    "dropmalcty": "MARQUAND",
    "dropmalst": "MO",
    "dropmalzpp": 636559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737835213,
    "dropsitcph": 5737835213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17167",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "205 N LAFAYETTE AVE",
    "dropdelcty": "MARSHALL",
    "dropdelst": "MO",
    "dropdelzpp": 653409998,
    "dropphyadd": "205 N LAFAYETTE AVE",
    "dropphycty": "MARSHALL",
    "dropphyst": "MO",
    "dropphyzpp": 653409998,
    "dropmaladd": "205 N LAFAYETTE AVE",
    "dropmalcty": "MARSHALL",
    "dropmalst": "MO",
    "dropmalzpp": 653409998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608866200,
    "dropsitcph": 6608866200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17169",
    "droptype": "D",
    "dropname": "MARSHFIELD",
    "dropdeladd": "203 N CLAY ST",
    "dropdelcty": "MARSHFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 657069998,
    "dropphyadd": "203 N CLAY ST",
    "dropphycty": "MARSHFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 657069998,
    "dropmaladd": "203 N CLAY ST",
    "dropmalcty": "MARSHFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 657069998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4178597058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17171",
    "droptype": "D",
    "dropname": "MARSTON",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "MARSTON",
    "dropdelst": "MO",
    "dropdelzpp": 638669998,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "MARSTON",
    "dropphyst": "MO",
    "dropphyzpp": 638669998,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "MARSTON",
    "dropmalst": "MO",
    "dropmalzpp": 638669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736432135,
    "dropsitcph": 5736432135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17172",
    "droptype": "D",
    "dropname": "MARTHASVILLE",
    "dropdeladd": "105 DEPOT ST",
    "dropdelcty": "MARTHASVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633579998,
    "dropphyadd": "105 DEPOT ST",
    "dropphycty": "MARTHASVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633579998,
    "dropmaladd": "105 DEPOT ST",
    "dropmalcty": "MARTHASVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364332272,
    "dropsitcph": 6364332272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17178",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "208 E JEFFERSON ST",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 652649998,
    "dropphyadd": "208 E JEFFERSON ST",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 652649998,
    "dropmaladd": "208 E JEFFERSON ST",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 652649998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734926511,
    "dropsitcph": 5734926511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17181",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "13751 W 261ST ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644679998,
    "dropphyadd": "13751 W 261ST ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644679998,
    "dropmaladd": "13751 W 261ST ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608452455,
    "dropsitcph": 6608452455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17192",
    "droptype": "D",
    "dropname": "MARYVILLE",
    "dropdeladd": "507 N FILLMORE ST",
    "dropdelcty": "MARYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644689998,
    "dropphyadd": "507 N FILLMORE ST",
    "dropphycty": "MARYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644689998,
    "dropmaladd": "507 N FILLMORE ST",
    "dropmalcty": "MARYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605822751,
    "dropsitcph": 6605822751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17198",
    "droptype": "D",
    "dropname": "MATTHEWS",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "MATTHEWS",
    "dropdelst": "MO",
    "dropdelzpp": 638679998,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "MATTHEWS",
    "dropphyst": "MO",
    "dropphyzpp": 638679998,
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "MATTHEWS",
    "dropmalst": "MO",
    "dropmalzpp": 638679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734719692,
    "dropsitcph": 5734719692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17203",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "303 W MAIN ST",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644699998,
    "dropphyadd": "303 W MAIN ST",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644699998,
    "dropmaladd": "303 W MAIN ST",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164495800,
    "dropsitcph": 8164495800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17204",
    "droptype": "D",
    "dropname": "MAYVIEW",
    "dropdeladd": "100 S WEST BOUNDARY ST",
    "dropdelcty": "MAYVIEW",
    "dropdelst": "MO",
    "dropdelzpp": 640712510,
    "dropphyadd": "100 S WEST BOUNDARY ST",
    "dropphycty": "MAYVIEW",
    "dropphyst": "MO",
    "dropphyzpp": 640712510,
    "dropmaladd": "100 S WEST BOUNDARY ST",
    "dropmalcty": "MAYVIEW",
    "dropmalst": "MO",
    "dropmalzpp": 640712510,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602374420,
    "dropsitcph": 6602374420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17205",
    "droptype": "D",
    "dropname": "MAYWOOD",
    "dropdeladd": "28925 STATE HIGHWAY V",
    "dropdelcty": "MAYWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 634549998,
    "dropphyadd": "28925 STATE HIGHWAY V",
    "dropphycty": "MAYWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 634549998,
    "dropmaladd": "28925 STATE HIGHWAY V",
    "dropmalcty": "MAYWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 634549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734783303,
    "dropsitcph": 5734783303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17208",
    "droptype": "D",
    "dropname": "MC FALL",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "MC FALL",
    "dropdelst": "MO",
    "dropdelzpp": 646579998,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "MC FALL",
    "dropphyst": "MO",
    "dropphyzpp": 646579998,
    "dropmaladd": "508 MAIN ST",
    "dropmalcty": "MC FALL",
    "dropmalst": "MO",
    "dropmalzpp": 646579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603674753,
    "dropsitcph": 6603674753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17210",
    "droptype": "D",
    "dropname": "MC GIRK",
    "dropdeladd": "31461 EAST ST",
    "dropdelcty": "MC GIRK",
    "dropdelst": "MO",
    "dropdelzpp": 650559998,
    "dropphyadd": "31461 EAST ST",
    "dropphycty": "MC GIRK",
    "dropphyst": "MO",
    "dropphyzpp": 650559998,
    "dropmaladd": "31461 EAST ST",
    "dropmalcty": "MC GIRK",
    "dropmalst": "MO",
    "dropmalzpp": 650559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737963485,
    "dropsitcph": 5737963485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17222",
    "droptype": "D",
    "dropname": "MEADVILLE",
    "dropdeladd": "212 S MACON ST",
    "dropdelcty": "MEADVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 646599998,
    "dropphyadd": "212 S MACON ST",
    "dropphycty": "MEADVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 646599998,
    "dropmaladd": "212 S MACON ST",
    "dropmalcty": "MEADVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 646599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176950268,
    "dropsitcph": 4176950268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17230",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "128 N MARKET ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "MO",
    "dropdelzpp": 635559998,
    "dropphyadd": "128 N MARKET ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "MO",
    "dropphyzpp": 635559998,
    "dropmaladd": "128 N MARKET ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "MO",
    "dropmalzpp": 635559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604652150,
    "dropsitcph": 6604652150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17231",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "MENDON",
    "dropdelst": "MO",
    "dropdelzpp": 646609998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "MENDON",
    "dropphyst": "MO",
    "dropphyzpp": 646609998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "MENDON",
    "dropmalst": "MO",
    "dropmalzpp": 646609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602723222,
    "dropsitcph": 6602723222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17235",
    "droptype": "D",
    "dropname": "MERCER",
    "dropdeladd": "101 N STATE ST",
    "dropdelcty": "MERCER",
    "dropdelst": "MO",
    "dropdelzpp": 646619998,
    "dropphyadd": "101 N STATE ST",
    "dropphycty": "MERCER",
    "dropphyst": "MO",
    "dropphyzpp": 646619998,
    "dropmaladd": "101 N STATE ST",
    "dropmalcty": "MERCER",
    "dropmalst": "MO",
    "dropmalzpp": 646619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603824917,
    "dropsitcph": 6603824917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17237",
    "droptype": "D",
    "dropname": "META",
    "dropdeladd": "201 3RD ST",
    "dropdelcty": "META",
    "dropdelst": "MO",
    "dropdelzpp": 650589998,
    "dropphyadd": "201 3RD ST",
    "dropphycty": "META",
    "dropphyst": "MO",
    "dropphyzpp": 650589998,
    "dropmaladd": "201 3RD ST",
    "dropmalcty": "META",
    "dropmalst": "MO",
    "dropmalzpp": 650589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732294200,
    "dropsitcph": 5732294200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17238",
    "droptype": "D",
    "dropname": "METZ",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "METZ",
    "dropdelst": "MO",
    "dropdelzpp": 647659998,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "METZ",
    "dropphyst": "MO",
    "dropphyzpp": 647659998,
    "dropmaladd": "117 S MAIN ST",
    "dropmalcty": "METZ",
    "dropmalst": "MO",
    "dropmalzpp": 647659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174843437,
    "dropsitcph": 4174843437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17239",
    "droptype": "D",
    "dropname": "MEXICO",
    "dropdeladd": "420 W JACKSON ST",
    "dropdelcty": "MEXICO",
    "dropdelst": "MO",
    "dropdelzpp": 652659998,
    "dropphyadd": "420 W JACKSON ST",
    "dropphycty": "MEXICO",
    "dropphyst": "MO",
    "dropphyzpp": 652659998,
    "dropmaladd": "420 W JACKSON ST",
    "dropmalcty": "MEXICO",
    "dropmalst": "MO",
    "dropmalzpp": 652659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735815967,
    "dropsitcph": 5735815967,
    "dropfax": 5735819582
  },
  {
    "dcode": "D",
    "dropkey": "PW17240",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "212 N HIGH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "MO",
    "dropdelzpp": 653449998,
    "dropphyadd": "212 N HIGH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "MO",
    "dropphyzpp": 653449998,
    "dropmaladd": "212 N HIGH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "MO",
    "dropmalzpp": 653449998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608523311,
    "dropsitcph": 6608523311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17242",
    "droptype": "D",
    "dropname": "MID MISSOURI GMF",
    "dropdeladd": "11450 S AIRPORT DR",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652999998,
    "dropphyadd": "11450 S AIRPORT DR",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652999998,
    "dropmaladd": "11450 S AIRPORT DR",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652999998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738746558,
    "dropsitcph": 5738746558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17246",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "MO",
    "dropdelzpp": 633599998,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "MO",
    "dropphyzpp": 633599998,
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "MO",
    "dropmalzpp": 633599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735492889,
    "dropsitcph": 5735492889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17252",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "100 E 4TH ST",
    "dropdelcty": "MILAN",
    "dropdelst": "MO",
    "dropdelzpp": 635569998,
    "dropphyadd": "100 E 4TH ST",
    "dropphycty": "MILAN",
    "dropphyst": "MO",
    "dropphyzpp": 635569998,
    "dropmaladd": "100 E 4TH ST",
    "dropmalcty": "MILAN",
    "dropmalst": "MO",
    "dropmalzpp": 635569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602653200,
    "dropsitcph": 6602653200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17258",
    "droptype": "D",
    "dropname": "MILLER",
    "dropdeladd": "210 E MAIN ST",
    "dropdelcty": "MILLER",
    "dropdelst": "MO",
    "dropdelzpp": 657079998,
    "dropphyadd": "210 E MAIN ST",
    "dropphycty": "MILLER",
    "dropphyst": "MO",
    "dropphyzpp": 657079998,
    "dropmaladd": "210 E MAIN ST",
    "dropmalcty": "MILLER",
    "dropmalst": "MO",
    "dropmalzpp": 657079998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174523577,
    "dropsitcph": 4174523577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17260",
    "droptype": "D",
    "dropname": "MILLERSVILLE",
    "dropdeladd": "120 COUNTY ROAD 482",
    "dropdelcty": "MILLERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 637669998,
    "dropphyadd": "120 COUNTY ROAD 482",
    "dropphycty": "MILLERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 637669998,
    "dropmaladd": "120 COUNTY ROAD 482",
    "dropmalcty": "MILLERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 637669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732436105,
    "dropsitcph": 5732436105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17262",
    "droptype": "D",
    "dropname": "MILO",
    "dropdeladd": "162 E MAIN ST",
    "dropdelcty": "MILO",
    "dropdelst": "MO",
    "dropdelzpp": 647679998,
    "dropphyadd": "162 E MAIN ST",
    "dropphycty": "MILO",
    "dropphyst": "MO",
    "dropphyzpp": 647679998,
    "dropmaladd": "162 E MAIN ST",
    "dropmalcty": "MILO",
    "dropmalst": "MO",
    "dropmalzpp": 647679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179442965,
    "dropsitcph": 4179442965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17266",
    "droptype": "D",
    "dropname": "MINDENMINES",
    "dropdeladd": "604 MAIN ST",
    "dropdelcty": "MINDENMINES",
    "dropdelst": "MO",
    "dropdelzpp": 647699998,
    "dropphyadd": "604 MAIN ST",
    "dropphycty": "MINDENMINES",
    "dropphyst": "MO",
    "dropphyzpp": 647699998,
    "dropmaladd": "604 MAIN ST",
    "dropmalcty": "MINDENMINES",
    "dropmalst": "MO",
    "dropmalzpp": 647699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178423416,
    "dropsitcph": 4178423416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17268",
    "droptype": "D",
    "dropname": "MINERAL POINT",
    "dropdeladd": "102 5TH ST",
    "dropdelcty": "MINERAL POINT",
    "dropdelst": "MO",
    "dropdelzpp": 636609998,
    "dropphyadd": "102 5TH ST",
    "dropphycty": "MINERAL POINT",
    "dropphyst": "MO",
    "dropphyzpp": 636609998,
    "dropmaladd": "102 5TH ST",
    "dropmalcty": "MINERAL POINT",
    "dropmalst": "MO",
    "dropmalzpp": 636609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734385315,
    "dropsitcph": 5734385315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17272",
    "droptype": "D",
    "dropname": "MISSOURI CITY",
    "dropdeladd": "426 MAIN ST",
    "dropdelcty": "MISSOURI CITY",
    "dropdelst": "MO",
    "dropdelzpp": 640729998,
    "dropphyadd": "426 MAIN ST",
    "dropphycty": "MISSOURI CITY",
    "dropphyst": "MO",
    "dropphyzpp": 640729998,
    "dropmaladd": "426 MAIN ST",
    "dropmalcty": "MISSOURI CITY",
    "dropmalst": "MO",
    "dropmalzpp": 640729998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167504452,
    "dropsitcph": 8167504452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17283",
    "droptype": "D",
    "dropname": "MOBERLY",
    "dropdeladd": "121 JOHNSON ST",
    "dropdelcty": "MOBERLY",
    "dropdelst": "MO",
    "dropdelzpp": 652709998,
    "dropphyadd": "121 JOHNSON ST",
    "dropphycty": "MOBERLY",
    "dropphyst": "MO",
    "dropphyzpp": 652709998,
    "dropmaladd": "121 JOHNSON ST",
    "dropmalcty": "MOBERLY",
    "dropmalst": "MO",
    "dropmalzpp": 652709998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602635522,
    "dropsitcph": 6602635522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17284",
    "droptype": "D",
    "dropname": "MOKANE",
    "dropdeladd": "212 FULTON AVE",
    "dropdelcty": "MOKANE",
    "dropdelst": "MO",
    "dropdelzpp": 650599998,
    "dropphyadd": "212 FULTON AVE",
    "dropphycty": "MOKANE",
    "dropphyst": "MO",
    "dropphyzpp": 650599998,
    "dropmaladd": "212 FULTON AVE",
    "dropmalcty": "MOKANE",
    "dropmalst": "MO",
    "dropmalzpp": 650599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736765881,
    "dropsitcph": 5736765881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17286",
    "droptype": "D",
    "dropname": "MONETT",
    "dropdeladd": "300 4TH ST",
    "dropdelcty": "MONETT",
    "dropdelst": "MO",
    "dropdelzpp": 657089998,
    "dropphyadd": "300 4TH ST",
    "dropphycty": "MONETT",
    "dropphyst": "MO",
    "dropphyzpp": 657089998,
    "dropmaladd": "300 4TH ST",
    "dropmalcty": "MONETT",
    "dropmalst": "MO",
    "dropmalzpp": 657089998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172357511,
    "dropsitcph": 4172357511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17288",
    "droptype": "D",
    "dropname": "MONROE CITY",
    "dropdeladd": "416 N MAIN ST",
    "dropdelcty": "MONROE CITY",
    "dropdelst": "MO",
    "dropdelzpp": 634569998,
    "dropphyadd": "416 N MAIN ST",
    "dropphycty": "MONROE CITY",
    "dropphyst": "MO",
    "dropphyzpp": 634569998,
    "dropmaladd": "416 N MAIN ST",
    "dropmalcty": "MONROE CITY",
    "dropmalst": "MO",
    "dropmalzpp": 634569998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737354757,
    "dropsitcph": 5737354757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17293",
    "droptype": "D",
    "dropname": "MONTGOMERY CITY",
    "dropdeladd": "404 N STURGEON ST",
    "dropdelcty": "MONTGOMERY CITY",
    "dropdelst": "MO",
    "dropdelzpp": 633619998,
    "dropphyadd": "404 N STURGEON ST",
    "dropphycty": "MONTGOMERY CITY",
    "dropphyst": "MO",
    "dropphyzpp": 633619998,
    "dropmaladd": "404 N STURGEON ST",
    "dropmalcty": "MONTGOMERY CITY",
    "dropmalst": "MO",
    "dropmalzpp": 633619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735642324,
    "dropsitcph": 5735642324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17296",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "101 E LAFAYETTE ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "MO",
    "dropdelzpp": 634579998,
    "dropphyadd": "101 E LAFAYETTE ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "MO",
    "dropphyzpp": 634579998,
    "dropmaladd": "101 E LAFAYETTE ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "MO",
    "dropmalzpp": 634579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737675432,
    "dropsitcph": 5737675432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17298",
    "droptype": "D",
    "dropname": "MONTREAL",
    "dropdeladd": "4000 STATE RD E",
    "dropdelcty": "MONTREAL",
    "dropdelst": "MO",
    "dropdelzpp": 655919998,
    "dropphyadd": "4000 STATE RD E",
    "dropphycty": "MONTREAL",
    "dropphyst": "MO",
    "dropphyzpp": 655919998,
    "dropmaladd": "4000 STATE RD E",
    "dropmalcty": "MONTREAL",
    "dropmalst": "MO",
    "dropmalzpp": 655919998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733467960,
    "dropsitcph": 5733467960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17299",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "307 ILLINOIS AVE",
    "dropdelcty": "MONTROSE",
    "dropdelst": "MO",
    "dropdelzpp": 647709998,
    "dropphyadd": "307 ILLINOIS AVE",
    "dropphycty": "MONTROSE",
    "dropphyst": "MO",
    "dropphyzpp": 647709998,
    "dropmaladd": "307 ILLINOIS AVE",
    "dropmalcty": "MONTROSE",
    "dropmalst": "MO",
    "dropmalzpp": 647709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606934514,
    "dropsitcph": 6606934514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17306",
    "droptype": "D",
    "dropname": "MOREHOUSE",
    "dropdeladd": "312 W BEECH ST",
    "dropdelcty": "MOREHOUSE",
    "dropdelst": "MO",
    "dropdelzpp": 638689998,
    "dropphyadd": "312 W BEECH ST",
    "dropphycty": "MOREHOUSE",
    "dropphyst": "MO",
    "dropphyzpp": 638689998,
    "dropmaladd": "312 W BEECH ST",
    "dropmalcty": "MOREHOUSE",
    "dropmalst": "MO",
    "dropmalzpp": 638689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736675778,
    "dropsitcph": 5736675778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17308",
    "droptype": "D",
    "dropname": "MORLEY",
    "dropdeladd": "104 N HARDING ST",
    "dropdelcty": "MORLEY",
    "dropdelst": "MO",
    "dropdelzpp": 637679998,
    "dropphyadd": "104 N HARDING ST",
    "dropphycty": "MORLEY",
    "dropphyst": "MO",
    "dropphyzpp": 637679998,
    "dropmaladd": "104 N HARDING ST",
    "dropmalcty": "MORLEY",
    "dropmalst": "MO",
    "dropmalzpp": 637679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732623150,
    "dropsitcph": 5732623150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17309",
    "droptype": "D",
    "dropname": "MORRISON",
    "dropdeladd": "155 MAIN ST",
    "dropdelcty": "MORRISON",
    "dropdelst": "MO",
    "dropdelzpp": 650619998,
    "dropphyadd": "155 MAIN ST",
    "dropphycty": "MORRISON",
    "dropphyst": "MO",
    "dropphyzpp": 650619998,
    "dropmaladd": "155 MAIN ST",
    "dropmalcty": "MORRISON",
    "dropmalst": "MO",
    "dropmalzpp": 650619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732947370,
    "dropsitcph": 5732947370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17310",
    "droptype": "D",
    "dropname": "MORRISVILLE",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "MORRISVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 657109998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "MORRISVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 657109998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "MORRISVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 657109998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 4173762225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17313",
    "droptype": "D",
    "dropname": "MORSE MILL",
    "dropdeladd": "8415 STATE ROAD EE",
    "dropdelcty": "MORSE MILL",
    "dropdelst": "MO",
    "dropdelzpp": 630669998,
    "dropphyadd": "8415 STATE ROAD EE",
    "dropphycty": "MORSE MILL",
    "dropphyst": "MO",
    "dropphyzpp": 630669998,
    "dropmaladd": "8415 STATE ROAD EE",
    "dropmalcty": "MORSE MILL",
    "dropmalst": "MO",
    "dropmalzpp": 630669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362853552,
    "dropsitcph": 6362853552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17316",
    "droptype": "D",
    "dropname": "MOSCOW MILLS",
    "dropdeladd": "150 W 3RD ST",
    "dropdelcty": "MOSCOW MILLS",
    "dropdelst": "MO",
    "dropdelzpp": 633629998,
    "dropphyadd": "150 W 3RD ST",
    "dropphycty": "MOSCOW MILLS",
    "dropphyst": "MO",
    "dropphyzpp": 633629998,
    "dropmaladd": "150 W 3RD ST",
    "dropmalcty": "MOSCOW MILLS",
    "dropmalst": "MO",
    "dropmalzpp": 633629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363440617,
    "dropsitcph": 6363440617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17319",
    "droptype": "D",
    "dropname": "MOUND CITY",
    "dropdeladd": "116 W 6TH ST",
    "dropdelcty": "MOUND CITY",
    "dropdelst": "MO",
    "dropdelzpp": 644709998,
    "dropphyadd": "116 W 6TH ST",
    "dropphycty": "MOUND CITY",
    "dropphyst": "MO",
    "dropphyzpp": 644709998,
    "dropmaladd": "116 W 6TH ST",
    "dropmalcty": "MOUND CITY",
    "dropmalst": "MO",
    "dropmalzpp": 644709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604425482,
    "dropsitcph": 6604425482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17322",
    "droptype": "D",
    "dropname": "MOUNDVILLE",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "MOUNDVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 647719998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "MOUNDVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 647719998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "MOUNDVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 647719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179223448,
    "dropsitcph": 4179223448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17329",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "205 E SOUTH ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "MO",
    "dropdelzpp": 657129998,
    "dropphyadd": "205 E SOUTH ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "MO",
    "dropphyzpp": 657129998,
    "dropmaladd": "205 E SOUTH ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "MO",
    "dropmalzpp": 657129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174662212,
    "dropsitcph": 4174662212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17330",
    "droptype": "D",
    "dropname": "MOUNTAIN GROVE",
    "dropdeladd": "111 S UNION ST",
    "dropdelcty": "MOUNTAIN GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 657119998,
    "dropphyadd": "111 S UNION ST",
    "dropphycty": "MOUNTAIN GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 657119998,
    "dropmaladd": "111 S UNION ST",
    "dropmalcty": "MOUNTAIN GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 657119998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179265711,
    "dropsitcph": 4179265711,
    "dropfax": 4179261040
  },
  {
    "dcode": "D",
    "dropkey": "PW17332",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "110 W 2ND ST",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "MO",
    "dropdelzpp": 655489998,
    "dropphyadd": "110 W 2ND ST",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "MO",
    "dropphyzpp": 655489998,
    "dropmaladd": "110 W 2ND ST",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "MO",
    "dropmalzpp": 655489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179342392,
    "dropsitcph": 4179342392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17342",
    "droptype": "D",
    "dropname": "MYRTLE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MYRTLE",
    "dropdelst": "MO",
    "dropdelzpp": 657789998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MYRTLE",
    "dropphyst": "MO",
    "dropphyzpp": 657789998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "MYRTLE",
    "dropmalst": "MO",
    "dropmalzpp": 657789998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179384582,
    "dropsitcph": 4179384582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17346",
    "droptype": "D",
    "dropname": "NAPOLEON",
    "dropdeladd": "265 W 2ND ST",
    "dropdelcty": "NAPOLEON",
    "dropdelst": "MO",
    "dropdelzpp": 640749998,
    "dropphyadd": "265 W 2ND ST",
    "dropphycty": "NAPOLEON",
    "dropphyst": "MO",
    "dropphyzpp": 640749998,
    "dropmaladd": "265 W 2ND ST",
    "dropmalcty": "NAPOLEON",
    "dropmalst": "MO",
    "dropmalzpp": 640749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8169348223,
    "dropsitcph": 8169348223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17348",
    "droptype": "D",
    "dropname": "NAYLOR",
    "dropdeladd": "100 BROAD ST",
    "dropdelcty": "NAYLOR",
    "dropdelst": "MO",
    "dropdelzpp": 639539998,
    "dropphyadd": "100 BROAD ST",
    "dropphycty": "NAYLOR",
    "dropphyst": "MO",
    "dropphyzpp": 639539998,
    "dropmaladd": "100 BROAD ST",
    "dropmalcty": "NAYLOR",
    "dropmalst": "MO",
    "dropmalzpp": 639539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733992600,
    "dropsitcph": 5733992600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17350",
    "droptype": "D",
    "dropname": "NECK CITY",
    "dropdeladd": "200 GRAND AVE",
    "dropdelcty": "NECK CITY",
    "dropdelst": "MO",
    "dropdelzpp": 648499998,
    "dropphyadd": "200 GRAND AVE",
    "dropphycty": "NECK CITY",
    "dropphyst": "MO",
    "dropphyzpp": 648499998,
    "dropmaladd": "200 GRAND AVE",
    "dropmalcty": "NECK CITY",
    "dropmalst": "MO",
    "dropmalzpp": 648499998,
    "dropsitphn": 8165043662,
    "dropsitlph": 4175254416,
    "dropsitcph": 4175254416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17353",
    "droptype": "D",
    "dropname": "NEELYVILLE",
    "dropdeladd": "407 HART ST",
    "dropdelcty": "NEELYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 639549998,
    "dropphyadd": "407 HART ST",
    "dropphycty": "NEELYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 639549998,
    "dropmaladd": "407 HART ST",
    "dropmalcty": "NEELYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 639549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5739896334,
    "dropsitcph": 5739896334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17355",
    "droptype": "D",
    "dropname": "NEOSHO",
    "dropdeladd": "101 E HICKORY ST",
    "dropdelcty": "NEOSHO",
    "dropdelst": "MO",
    "dropdelzpp": 648509998,
    "dropphyadd": "101 E HICKORY ST",
    "dropphycty": "NEOSHO",
    "dropphyst": "MO",
    "dropphyzpp": 648509998,
    "dropmaladd": "101 E HICKORY ST",
    "dropmalcty": "NEOSHO",
    "dropmalst": "MO",
    "dropmalzpp": 648509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174514172,
    "dropsitcph": 4174514172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17359",
    "droptype": "D",
    "dropname": "NEVADA",
    "dropdeladd": "104 S OAK ST",
    "dropdelcty": "NEVADA",
    "dropdelst": "MO",
    "dropdelzpp": 647729998,
    "dropphyadd": "104 S OAK ST",
    "dropphycty": "NEVADA",
    "dropphyst": "MO",
    "dropphyzpp": 647729998,
    "dropmaladd": "104 S OAK ST",
    "dropmalcty": "NEVADA",
    "dropmalst": "MO",
    "dropmalzpp": 647729998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176675241,
    "dropsitcph": 4176675241,
    "dropfax": 4176672778
  },
  {
    "dcode": "D",
    "dropkey": "PW17361",
    "droptype": "D",
    "dropname": "NEW BLOOMFIELD",
    "dropdeladd": "150 CHESTNUT ST",
    "dropdelcty": "NEW BLOOMFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 650639998,
    "dropphyadd": "150 CHESTNUT ST",
    "dropphycty": "NEW BLOOMFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 650639998,
    "dropmaladd": "150 CHESTNUT ST",
    "dropmalcty": "NEW BLOOMFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 650639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734913717,
    "dropsitcph": 5734913717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17363",
    "droptype": "D",
    "dropname": "NEW BOSTON",
    "dropdeladd": "15832 HIGHWAY 129",
    "dropdelcty": "NEW BOSTON",
    "dropdelst": "MO",
    "dropdelzpp": 635579998,
    "dropphyadd": "15832 HIGHWAY 129",
    "dropphycty": "NEW BOSTON",
    "dropphyst": "MO",
    "dropphyzpp": 635579998,
    "dropmaladd": "15832 HIGHWAY 129",
    "dropmalcty": "NEW BOSTON",
    "dropmalst": "MO",
    "dropmalzpp": 635579998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606897576,
    "dropsitcph": 6606897576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17364",
    "droptype": "D",
    "dropname": "NEW CAMBRIA",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "NEW CAMBRIA",
    "dropdelst": "MO",
    "dropdelzpp": 635589998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "NEW CAMBRIA",
    "dropphyst": "MO",
    "dropphyzpp": 635589998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "NEW CAMBRIA",
    "dropmalst": "MO",
    "dropmalzpp": 635589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602265690,
    "dropsitcph": 6602265690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17365",
    "droptype": "D",
    "dropname": "NEW FLORENCE",
    "dropdeladd": "119 S MAIN ST",
    "dropdelcty": "NEW FLORENCE",
    "dropdelst": "MO",
    "dropdelzpp": 633639998,
    "dropphyadd": "119 S MAIN ST",
    "dropphycty": "NEW FLORENCE",
    "dropphyst": "MO",
    "dropphyzpp": 633639998,
    "dropmaladd": "119 S MAIN ST",
    "dropmalcty": "NEW FLORENCE",
    "dropmalst": "MO",
    "dropmalzpp": 633639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738352555,
    "dropsitcph": 5738352555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17366",
    "droptype": "D",
    "dropname": "NEW FRANKLIN",
    "dropdeladd": "128 E BROADWAY",
    "dropdelcty": "NEW FRANKLIN",
    "dropdelst": "MO",
    "dropdelzpp": 652749998,
    "dropphyadd": "128 E BROADWAY",
    "dropphycty": "NEW FRANKLIN",
    "dropphyst": "MO",
    "dropphyzpp": 652749998,
    "dropmaladd": "128 E BROADWAY",
    "dropmalcty": "NEW FRANKLIN",
    "dropmalst": "MO",
    "dropmalzpp": 652749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608482543,
    "dropsitcph": 6608482543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17368",
    "droptype": "D",
    "dropname": "NEW HAMPTON",
    "dropdeladd": "210 E LINCOLN WAY",
    "dropdelcty": "NEW HAMPTON",
    "dropdelst": "MO",
    "dropdelzpp": 644719998,
    "dropphyadd": "210 E LINCOLN WAY",
    "dropphycty": "NEW HAMPTON",
    "dropphyst": "MO",
    "dropphyzpp": 644719998,
    "dropmaladd": "210 E LINCOLN WAY",
    "dropmalcty": "NEW HAMPTON",
    "dropmalst": "MO",
    "dropmalzpp": 644719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604393765,
    "dropsitcph": 6604393765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17370",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "1103 MILLER ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "MO",
    "dropdelzpp": 630689998,
    "dropphyadd": "1103 MILLER ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "MO",
    "dropphyzpp": 630689998,
    "dropmaladd": "1103 MILLER ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "MO",
    "dropmalzpp": 630689998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732372134,
    "dropsitcph": 5732372134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17372",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "312 S MAIN ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "MO",
    "dropdelzpp": 634599998,
    "dropphyadd": "312 S MAIN ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "MO",
    "dropphyzpp": 634599998,
    "dropmaladd": "312 S MAIN ST",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "MO",
    "dropmalzpp": 634599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5739858521,
    "dropsitcph": 5739858521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17373",
    "droptype": "D",
    "dropname": "NEW MADRID",
    "dropdeladd": "450 MILL ST",
    "dropdelcty": "NEW MADRID",
    "dropdelst": "MO",
    "dropdelzpp": 638699998,
    "dropphyadd": "450 MILL ST",
    "dropphycty": "NEW MADRID",
    "dropphyst": "MO",
    "dropphyzpp": 638699998,
    "dropmaladd": "450 MILL ST",
    "dropmalcty": "NEW MADRID",
    "dropmalst": "MO",
    "dropmalzpp": 638699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737485130,
    "dropsitcph": 5737485130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17374",
    "droptype": "D",
    "dropname": "NEW MELLE",
    "dropdeladd": "30 W HIGHWAY D STE 107",
    "dropdelcty": "NEW MELLE",
    "dropdelst": "MO",
    "dropdelzpp": 633659998,
    "dropphyadd": "30 W HIGHWAY D STE 107",
    "dropphycty": "NEW MELLE",
    "dropphyst": "MO",
    "dropphyzpp": 633659998,
    "dropmaladd": "30 W HIGHWAY D STE 107",
    "dropmalcty": "NEW MELLE",
    "dropmalst": "MO",
    "dropmalzpp": 633659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6368285850,
    "dropsitcph": 6368285850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17381",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "MO",
    "dropdelzpp": 634589998,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "NEWARK",
    "dropphyst": "MO",
    "dropphyzpp": 634589998,
    "dropmaladd": "106 S MAIN ST",
    "dropmalcty": "NEWARK",
    "dropmalst": "MO",
    "dropmalzpp": 634589998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607335524,
    "dropsitcph": 6607335524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17382",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "71 E 1ST ST",
    "dropdelcty": "NEWBURG",
    "dropdelst": "MO",
    "dropdelzpp": 655509998,
    "dropphyadd": "71 E 1ST ST",
    "dropphycty": "NEWBURG",
    "dropphyst": "MO",
    "dropphyzpp": 655509998,
    "dropmaladd": "71 E 1ST ST",
    "dropmalcty": "NEWBURG",
    "dropmalst": "MO",
    "dropmalzpp": 655509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732615037,
    "dropsitcph": 5732615037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17384",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "MO",
    "dropdelzpp": 646679998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "NEWTOWN",
    "dropphyst": "MO",
    "dropphyzpp": 646679998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "MO",
    "dropmalzpp": 646679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607945295,
    "dropsitcph": 6607945295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17386",
    "droptype": "D",
    "dropname": "NIANGUA",
    "dropdeladd": "113 S MAIN ST",
    "dropdelcty": "NIANGUA",
    "dropdelst": "MO",
    "dropdelzpp": 657139998,
    "dropphyadd": "113 S MAIN ST",
    "dropphycty": "NIANGUA",
    "dropphyst": "MO",
    "dropphyzpp": 657139998,
    "dropmaladd": "113 S MAIN ST",
    "dropmalcty": "NIANGUA",
    "dropmalst": "MO",
    "dropmalzpp": 657139998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174736313,
    "dropsitcph": 4174736313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17388",
    "droptype": "D",
    "dropname": "NIXA",
    "dropdeladd": "404 W SOUTH ST",
    "dropdelcty": "NIXA",
    "dropdelst": "MO",
    "dropdelzpp": 657149998,
    "dropphyadd": "404 W SOUTH ST",
    "dropphycty": "NIXA",
    "dropphyst": "MO",
    "dropphyzpp": 657149998,
    "dropmaladd": "404 W SOUTH ST",
    "dropmalcty": "NIXA",
    "dropmalst": "MO",
    "dropmalzpp": 657149998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177255112,
    "dropsitcph": 4177255112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17391",
    "droptype": "D",
    "dropname": "NOEL",
    "dropdeladd": "318 MAIN ST",
    "dropdelcty": "NOEL",
    "dropdelst": "MO",
    "dropdelzpp": 648549998,
    "dropphyadd": "318 MAIN ST",
    "dropphycty": "NOEL",
    "dropphyst": "MO",
    "dropphyzpp": 648549998,
    "dropmaladd": "318 MAIN ST",
    "dropmalcty": "NOEL",
    "dropmalst": "MO",
    "dropmalzpp": 648549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174730364,
    "dropsitcph": 4174730364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17392",
    "droptype": "D",
    "dropname": "NORBORNE",
    "dropdeladd": "204 E 2ND ST",
    "dropdelcty": "NORBORNE",
    "dropdelst": "MO",
    "dropdelzpp": 646689998,
    "dropphyadd": "204 E 2ND ST",
    "dropphycty": "NORBORNE",
    "dropphyst": "MO",
    "dropphyzpp": 646689998,
    "dropmaladd": "204 E 2ND ST",
    "dropmalcty": "NORBORNE",
    "dropmalst": "MO",
    "dropmalzpp": 646689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605933613,
    "dropsitcph": 6605933613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17406",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 657179998,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 657179998,
    "dropmaladd": "100 E MAIN ST",
    "dropmalcty": "NORWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 657179998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177464141,
    "dropsitcph": 4177464141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17410",
    "droptype": "D",
    "dropname": "NOVELTY",
    "dropdeladd": "220 E MAIN ST",
    "dropdelcty": "NOVELTY",
    "dropdelst": "MO",
    "dropdelzpp": 634609998,
    "dropphyadd": "220 E MAIN ST",
    "dropphycty": "NOVELTY",
    "dropphyst": "MO",
    "dropphyzpp": 634609998,
    "dropmaladd": "220 E MAIN ST",
    "dropmalcty": "NOVELTY",
    "dropmalst": "MO",
    "dropmalzpp": 634609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607394317,
    "dropsitcph": 6607394317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17411",
    "droptype": "D",
    "dropname": "NOVINGER",
    "dropdeladd": "214 S FRANKFORD AVE",
    "dropdelcty": "NOVINGER",
    "dropdelst": "MO",
    "dropdelzpp": 635599998,
    "dropphyadd": "214 S FRANKFORD AVE",
    "dropphycty": "NOVINGER",
    "dropphyst": "MO",
    "dropphyzpp": 635599998,
    "dropmaladd": "214 S FRANKFORD AVE",
    "dropmalcty": "NOVINGER",
    "dropmalst": "MO",
    "dropmalzpp": 635599998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604885373,
    "dropsitcph": 6604885373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17417",
    "droptype": "D",
    "dropname": "O FALLON",
    "dropdeladd": "401 CHURCH ST",
    "dropdelcty": "O FALLON",
    "dropdelst": "MO",
    "dropdelzpp": 633669998,
    "dropphyadd": "401 CHURCH ST",
    "dropphycty": "O FALLON",
    "dropphyst": "MO",
    "dropphyzpp": 633669998,
    "dropmaladd": "401 CHURCH ST",
    "dropmalcty": "O FALLON",
    "dropmalst": "MO",
    "dropmalzpp": 633669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366964003,
    "dropsitcph": 6362723811,
    "dropfax": 6514566627
  },
  {
    "dcode": "D",
    "dropkey": "PW17419",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "1700 S BROADWAY",
    "dropdelcty": "OAK GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 640759998,
    "dropphyadd": "1700 S BROADWAY",
    "dropphycty": "OAK GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 640759998,
    "dropmaladd": "1700 S BROADWAY",
    "dropmalcty": "OAK GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 640759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166904993,
    "dropsitcph": 8166903500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17421",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "4042 STATE HWY E",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 637699998,
    "dropphyadd": "4042 STATE HWY E",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 637699998,
    "dropmaladd": "4042 STATE HWY E",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 637699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732663211,
    "dropsitcph": 5732663211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17432",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "101 E DRYDEN ST",
    "dropdelcty": "ODESSA",
    "dropdelst": "MO",
    "dropdelzpp": 640769998,
    "dropphyadd": "101 E DRYDEN ST",
    "dropphycty": "ODESSA",
    "dropphyst": "MO",
    "dropphyzpp": 640769998,
    "dropmaladd": "101 E DRYDEN ST",
    "dropmalcty": "ODESSA",
    "dropmalst": "MO",
    "dropmalzpp": 640769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162308081,
    "dropsitcph": 8162308081,
    "dropfax": 8166338454
  },
  {
    "dcode": "D",
    "dropkey": "PW17435",
    "droptype": "D",
    "dropname": "OLD APPLETON",
    "dropdeladd": "343 APPLETON MAIN ST",
    "dropdelcty": "OLD APPLETON",
    "dropdelst": "MO",
    "dropdelzpp": 637709998,
    "dropphyadd": "343 APPLETON MAIN ST",
    "dropphycty": "OLD APPLETON",
    "dropphyst": "MO",
    "dropphyzpp": 637709998,
    "dropmaladd": "343 APPLETON MAIN ST",
    "dropmalcty": "OLD APPLETON",
    "dropmalst": "MO",
    "dropmalzpp": 637709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737882214,
    "dropsitcph": 5737882214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17438",
    "droptype": "D",
    "dropname": "OLD MONROE",
    "dropdeladd": "104 SYCAMORE ST",
    "dropdelcty": "OLD MONROE",
    "dropdelst": "MO",
    "dropdelzpp": 633699998,
    "dropphyadd": "104 SYCAMORE ST",
    "dropphycty": "OLD MONROE",
    "dropphyst": "MO",
    "dropphyzpp": 633699998,
    "dropmaladd": "104 SYCAMORE ST",
    "dropmalcty": "OLD MONROE",
    "dropmalst": "MO",
    "dropmalzpp": 633699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366610191,
    "dropsitcph": 6366610191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17444",
    "droptype": "D",
    "dropname": "OLDFIELD",
    "dropdeladd": "2838 STATE HIGHWAY 125 S",
    "dropdelcty": "OLDFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 657209998,
    "dropphyadd": "2838 STATE HIGHWAY 125 S",
    "dropphycty": "OLDFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 657209998,
    "dropmaladd": "2838 STATE HIGHWAY 125 S",
    "dropmalcty": "OLDFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 657209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176344360,
    "dropsitcph": 4176344360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17445",
    "droptype": "D",
    "dropname": "OLEAN",
    "dropdeladd": "252 MAIN ST",
    "dropdelcty": "OLEAN",
    "dropdelst": "MO",
    "dropdelzpp": 650649998,
    "dropphyadd": "252 MAIN ST",
    "dropphycty": "OLEAN",
    "dropphyst": "MO",
    "dropphyzpp": 650649998,
    "dropmaladd": "252 MAIN ST",
    "dropmalcty": "OLEAN",
    "dropmalst": "MO",
    "dropmalzpp": 650649998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733926912,
    "dropsitcph": 5733926912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17449",
    "droptype": "D",
    "dropname": "ORAN",
    "dropdeladd": "111 N RAILROAD ST",
    "dropdelcty": "ORAN",
    "dropdelst": "MO",
    "dropdelzpp": 637719998,
    "dropphyadd": "111 N RAILROAD ST",
    "dropphycty": "ORAN",
    "dropphyst": "MO",
    "dropphyzpp": 637719998,
    "dropmaladd": "111 N RAILROAD ST",
    "dropmalcty": "ORAN",
    "dropmalst": "MO",
    "dropmalzpp": 637719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732623548,
    "dropsitcph": 5732623548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17451",
    "droptype": "D",
    "dropname": "OREGON",
    "dropdeladd": "100 S JEFFERSON ST",
    "dropdelcty": "OREGON",
    "dropdelst": "MO",
    "dropdelzpp": 644739998,
    "dropphyadd": "100 S JEFFERSON ST",
    "dropphycty": "OREGON",
    "dropphyst": "MO",
    "dropphyzpp": 644739998,
    "dropmaladd": "100 S JEFFERSON ST",
    "dropmalcty": "OREGON",
    "dropmalst": "MO",
    "dropmalzpp": 644739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604463646,
    "dropsitcph": 6604463646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17453",
    "droptype": "D",
    "dropname": "ORONOGO",
    "dropdeladd": "101 S 2ND ST",
    "dropdelcty": "ORONOGO",
    "dropdelst": "MO",
    "dropdelzpp": 648559998,
    "dropphyadd": "101 S 2ND ST",
    "dropphycty": "ORONOGO",
    "dropphyst": "MO",
    "dropphyzpp": 648559998,
    "dropmaladd": "101 S 2ND ST",
    "dropmalcty": "ORONOGO",
    "dropmalst": "MO",
    "dropmalzpp": 648559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176735658,
    "dropsitcph": 4176735658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17454",
    "droptype": "D",
    "dropname": "ORRICK",
    "dropdeladd": "107 W SOUTH FRONT ST",
    "dropdelcty": "ORRICK",
    "dropdelst": "MO",
    "dropdelzpp": 640779998,
    "dropphyadd": "107 W SOUTH FRONT ST",
    "dropphycty": "ORRICK",
    "dropphyst": "MO",
    "dropphyzpp": 640779998,
    "dropmaladd": "107 W SOUTH FRONT ST",
    "dropmalcty": "ORRICK",
    "dropmalst": "MO",
    "dropmalzpp": 640779998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167703431,
    "dropsitcph": 8167703431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17456",
    "droptype": "D",
    "dropname": "OSAGE BEACH",
    "dropdeladd": "5545 OSAGE BEACH PKWY",
    "dropdelcty": "OSAGE BEACH",
    "dropdelst": "MO",
    "dropdelzpp": 650659998,
    "dropphyadd": "5545 OSAGE BEACH PKWY",
    "dropphycty": "OSAGE BEACH",
    "dropphyst": "MO",
    "dropphyzpp": 650659998,
    "dropmaladd": "5545 OSAGE BEACH PKWY",
    "dropmalcty": "OSAGE BEACH",
    "dropmalst": "MO",
    "dropmalzpp": 650659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733482915,
    "dropsitcph": 5733482915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17460",
    "droptype": "D",
    "dropname": "OSBORN",
    "dropdeladd": "600 CLINTON AVE",
    "dropdelcty": "OSBORN",
    "dropdelst": "MO",
    "dropdelzpp": 644749998,
    "dropphyadd": "600 CLINTON AVE",
    "dropphycty": "OSBORN",
    "dropphyst": "MO",
    "dropphyzpp": 644749998,
    "dropmaladd": "600 CLINTON AVE",
    "dropmalcty": "OSBORN",
    "dropmalst": "MO",
    "dropmalzpp": 644749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166752676,
    "dropsitcph": 8166752676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17461",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "565 3RD ST",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "MO",
    "dropdelzpp": 647769998,
    "dropphyadd": "565 3RD ST",
    "dropphycty": "OSCEOLA",
    "dropphyst": "MO",
    "dropphyzpp": 647769998,
    "dropmaladd": "565 3RD ST",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "MO",
    "dropmalzpp": 647769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176462578,
    "dropsitcph": 4176462578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17462",
    "droptype": "D",
    "dropname": "OTTERVILLE",
    "dropdeladd": "204 E GROVER ST",
    "dropdelcty": "OTTERVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 653489998,
    "dropphyadd": "204 E GROVER ST",
    "dropphycty": "OTTERVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 653489998,
    "dropmaladd": "204 E GROVER ST",
    "dropmalcty": "OTTERVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 653489998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603664604,
    "dropsitcph": 6603664604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17471",
    "droptype": "D",
    "dropname": "OWENSVILLE",
    "dropdeladd": "201 W LINCOLN AVE",
    "dropdelcty": "OWENSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 650669998,
    "dropphyadd": "201 W LINCOLN AVE",
    "dropphycty": "OWENSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 650669998,
    "dropmaladd": "201 W LINCOLN AVE",
    "dropmalcty": "OWENSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 650669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734372332,
    "dropsitcph": 5734372332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17475",
    "droptype": "D",
    "dropname": "OXLY",
    "dropdeladd": "150 STATE HIGHWAY 142 E",
    "dropdelcty": "OXLY",
    "dropdelst": "MO",
    "dropdelzpp": 639559998,
    "dropphyadd": "150 STATE HIGHWAY 142 E",
    "dropphycty": "OXLY",
    "dropphyst": "MO",
    "dropphyzpp": 639559998,
    "dropmaladd": "150 STATE HIGHWAY 142 E",
    "dropmalcty": "OXLY",
    "dropmalst": "MO",
    "dropmalzpp": 639559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733542611,
    "dropsitcph": 5733542611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17476",
    "droptype": "D",
    "dropname": "OZARK",
    "dropdeladd": "1450 W JACKSON ST",
    "dropdelcty": "OZARK",
    "dropdelst": "MO",
    "dropdelzpp": 657219998,
    "dropphyadd": "1450 W JACKSON ST",
    "dropphycty": "OZARK",
    "dropphyst": "MO",
    "dropphyzpp": 657219998,
    "dropmaladd": "1450 W JACKSON ST",
    "dropmalcty": "OZARK",
    "dropmalst": "MO",
    "dropmalzpp": 657219998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175812807,
    "dropsitcph": 4175812754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17478",
    "droptype": "D",
    "dropname": "PACIFIC",
    "dropdeladd": "211 W SAINT LOUIS ST",
    "dropdelcty": "PACIFIC",
    "dropdelst": "MO",
    "dropdelzpp": 630699998,
    "dropphyadd": "211 W SAINT LOUIS ST",
    "dropphycty": "PACIFIC",
    "dropphyst": "MO",
    "dropphyzpp": 630699998,
    "dropmaladd": "211 W SAINT LOUIS ST",
    "dropmalcty": "PACIFIC",
    "dropmalst": "MO",
    "dropmalzpp": 630699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362573500,
    "dropsitcph": 6362573500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17486",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "323 S MAIN ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "MO",
    "dropdelzpp": 634619998,
    "dropphyadd": "323 S MAIN ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "MO",
    "dropphyzpp": 634619998,
    "dropmaladd": "323 S MAIN ST",
    "dropmalcty": "PALMYRA",
    "dropmalst": "MO",
    "dropmalzpp": 634619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737465142,
    "dropsitcph": 5737465142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17489",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "307 N WASHINGTON ST",
    "dropdelcty": "PARIS",
    "dropdelst": "MO",
    "dropdelzpp": 652759998,
    "dropphyadd": "307 N WASHINGTON ST",
    "dropphycty": "PARIS",
    "dropphyst": "MO",
    "dropphyzpp": 652759998,
    "dropmaladd": "307 N WASHINGTON ST",
    "dropmalcty": "PARIS",
    "dropmalst": "MO",
    "dropmalzpp": 652759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603274717,
    "dropsitcph": 6603274717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17494",
    "droptype": "D",
    "dropname": "PARMA",
    "dropdeladd": "205 S BROAD ST",
    "dropdelcty": "PARMA",
    "dropdelst": "MO",
    "dropdelzpp": 638709998,
    "dropphyadd": "205 S BROAD ST",
    "dropphycty": "PARMA",
    "dropphyst": "MO",
    "dropphyzpp": 638709998,
    "dropmaladd": "205 S BROAD ST",
    "dropmalcty": "PARMA",
    "dropmalst": "MO",
    "dropmalzpp": 638709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733574466,
    "dropsitcph": 5733574466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17495",
    "droptype": "D",
    "dropname": "PARNELL",
    "dropdeladd": "211 E ROBINSON AVE",
    "dropdelcty": "PARNELL",
    "dropdelst": "MO",
    "dropdelzpp": 644759998,
    "dropphyadd": "211 E ROBINSON AVE",
    "dropphycty": "PARNELL",
    "dropphyst": "MO",
    "dropphyzpp": 644759998,
    "dropmaladd": "211 E ROBINSON AVE",
    "dropmalcty": "PARNELL",
    "dropmalst": "MO",
    "dropmalzpp": 644759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609862475,
    "dropsitcph": 6609862475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17502",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "1234 OLD STATE ROUTE 34",
    "dropdelcty": "PATTERSON",
    "dropdelst": "MO",
    "dropdelzpp": 639569998,
    "dropphyadd": "1234 OLD STATE ROUTE 34",
    "dropphycty": "PATTERSON",
    "dropphyst": "MO",
    "dropphyzpp": 639569998,
    "dropmaladd": "1234 OLD STATE ROUTE 34",
    "dropmalcty": "PATTERSON",
    "dropmalst": "MO",
    "dropmalzpp": 639569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738564548,
    "dropsitcph": 5738564548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17503",
    "droptype": "D",
    "dropname": "PATTON",
    "dropdeladd": "1000 STATE ROUTE 51",
    "dropdelcty": "PATTON",
    "dropdelst": "MO",
    "dropdelzpp": 636629998,
    "dropphyadd": "1000 STATE ROUTE 51",
    "dropphycty": "PATTON",
    "dropphyst": "MO",
    "dropphyzpp": 636629998,
    "dropmaladd": "1000 STATE ROUTE 51",
    "dropmalcty": "PATTON",
    "dropmalst": "MO",
    "dropmalzpp": 636629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738662157,
    "dropsitcph": 5738662157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17505",
    "droptype": "D",
    "dropname": "PATTONSBURG",
    "dropdeladd": "105 2ND AVE",
    "dropdelcty": "PATTONSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 646709998,
    "dropphyadd": "105 2ND AVE",
    "dropphycty": "PATTONSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 646709998,
    "dropmaladd": "105 2ND AVE",
    "dropmalcty": "PATTONSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 646709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603672364,
    "dropsitcph": 6603672364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17512",
    "droptype": "D",
    "dropname": "PEACE VALLEY",
    "dropdeladd": "7120 STATE RTE W",
    "dropdelcty": "PEACE VALLEY",
    "dropdelst": "MO",
    "dropdelzpp": 657889998,
    "dropphyadd": "7120 STATE RTE W",
    "dropphycty": "PEACE VALLEY",
    "dropphyst": "MO",
    "dropphyzpp": 657889998,
    "dropmaladd": "7120 STATE RTE W",
    "dropmalcty": "PEACE VALLEY",
    "dropmalst": "MO",
    "dropmalzpp": 657889998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172775788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17516",
    "droptype": "D",
    "dropname": "PECULIAR",
    "dropdeladd": "401 SCHUG AVE",
    "dropdelcty": "PECULIAR",
    "dropdelst": "MO",
    "dropdelzpp": 640789998,
    "dropphyadd": "401 SCHUG AVE",
    "dropphycty": "PECULIAR",
    "dropphyst": "MO",
    "dropphyzpp": 640789998,
    "dropmaladd": "401 SCHUG AVE",
    "dropmalcty": "PECULIAR",
    "dropmalst": "MO",
    "dropmalzpp": 640789998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167795960,
    "dropsitcph": 8167795222,
    "dropfax": 8167795125
  },
  {
    "dcode": "D",
    "dropkey": "PW17521",
    "droptype": "D",
    "dropname": "PERKINS",
    "dropdeladd": "622 HIGHWAY P",
    "dropdelcty": "PERKINS",
    "dropdelst": "MO",
    "dropdelzpp": 637749998,
    "dropphyadd": "622 HIGHWAY P",
    "dropphycty": "PERKINS",
    "dropphyst": "MO",
    "dropphyzpp": 637749998,
    "dropmaladd": "622 HIGHWAY P",
    "dropmalcty": "PERKINS",
    "dropmalst": "MO",
    "dropmalzpp": 637749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737942961,
    "dropsitcph": 5737942961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17522",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "PERRY",
    "dropdelst": "MO",
    "dropdelzpp": 634629998,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "PERRY",
    "dropphyst": "MO",
    "dropphyzpp": 634629998,
    "dropmaladd": "108 E MAIN ST",
    "dropmalcty": "PERRY",
    "dropmalst": "MO",
    "dropmalzpp": 634629998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735652220,
    "dropsitcph": 5735652220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17523",
    "droptype": "D",
    "dropname": "PERRYVILLE",
    "dropdeladd": "20 E SAINTE MARIE ST",
    "dropdelcty": "PERRYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 637759998,
    "dropphyadd": "20 E SAINTE MARIE ST",
    "dropphycty": "PERRYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 637759998,
    "dropmaladd": "20 E SAINTE MARIE ST",
    "dropmalcty": "PERRYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 637759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735474343,
    "dropsitcph": 5735474343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17530",
    "droptype": "D",
    "dropname": "PEVELY",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "PEVELY",
    "dropdelst": "MO",
    "dropdelzpp": 630709998,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "PEVELY",
    "dropphyst": "MO",
    "dropphyzpp": 630709998,
    "dropmaladd": "305 MAIN ST",
    "dropmalcty": "PEVELY",
    "dropmalst": "MO",
    "dropmalzpp": 630709998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364794405,
    "dropsitcph": 6364794405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17532",
    "droptype": "D",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "2990 COUNTY ROAD 13",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "MO",
    "dropdelzpp": 634639998,
    "dropphyadd": "2990 COUNTY ROAD 13",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "MO",
    "dropphyzpp": 634639998,
    "dropmaladd": "2990 COUNTY ROAD 13",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "MO",
    "dropmalzpp": 634639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734395408,
    "dropsitcph": 5734395408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17535",
    "droptype": "D",
    "dropname": "PHILLIPSBURG",
    "dropdeladd": "100 S FRONT ST",
    "dropdelcty": "PHILLIPSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 657229998,
    "dropphyadd": "100 S FRONT ST",
    "dropphycty": "PHILLIPSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 657229998,
    "dropmaladd": "100 S FRONT ST",
    "dropmalcty": "PHILLIPSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 657229998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175896828,
    "dropsitcph": 4175896828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17536",
    "droptype": "D",
    "dropname": "PICKERING",
    "dropdeladd": "411 E 5TH ST",
    "dropdelcty": "PICKERING",
    "dropdelst": "MO",
    "dropdelzpp": 644769998,
    "dropphyadd": "411 E 5TH ST",
    "dropphycty": "PICKERING",
    "dropphyst": "MO",
    "dropphyzpp": 644769998,
    "dropmaladd": "411 E 5TH ST",
    "dropmalcty": "PICKERING",
    "dropmalst": "MO",
    "dropmalzpp": 644769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609273321,
    "dropsitcph": 6609273321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17537",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "125 W GREEN ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "MO",
    "dropdelzpp": 639579998,
    "dropphyadd": "125 W GREEN ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "MO",
    "dropphyzpp": 639579998,
    "dropmaladd": "125 W GREEN ST",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "MO",
    "dropmalzpp": 639579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732234824,
    "dropsitcph": 5732234824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17539",
    "droptype": "D",
    "dropname": "PIERCE CITY",
    "dropdeladd": "114 E COMMERCIAL ST",
    "dropdelcty": "PIERCE CITY",
    "dropdelst": "MO",
    "dropdelzpp": 657239998,
    "dropphyadd": "114 E COMMERCIAL ST",
    "dropphycty": "PIERCE CITY",
    "dropphyst": "MO",
    "dropphyzpp": 657239998,
    "dropmaladd": "114 E COMMERCIAL ST",
    "dropmalcty": "PIERCE CITY",
    "dropmalst": "MO",
    "dropmalzpp": 657239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174762215,
    "dropsitcph": 4174762215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17544",
    "droptype": "D",
    "dropname": "PILOT GROVE",
    "dropdeladd": "206 ROE ST",
    "dropdelcty": "PILOT GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 652769998,
    "dropphyadd": "206 ROE ST",
    "dropphycty": "PILOT GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 652769998,
    "dropmaladd": "206 ROE ST",
    "dropmalcty": "PILOT GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 652769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608346011,
    "dropsitcph": 6608346011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17546",
    "droptype": "D",
    "dropname": "PILOT KNOB",
    "dropdeladd": "201 W MAPLE ST",
    "dropdelcty": "PILOT KNOB",
    "dropdelst": "MO",
    "dropdelzpp": 636639998,
    "dropphyadd": "201 W MAPLE ST",
    "dropphycty": "PILOT KNOB",
    "dropphyst": "MO",
    "dropphyzpp": 636639998,
    "dropmaladd": "201 W MAPLE ST",
    "dropmalcty": "PILOT KNOB",
    "dropmalst": "MO",
    "dropmalzpp": 636639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735463127,
    "dropsitcph": 5735463127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17549",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "304 HARMON ST",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 648569998,
    "dropphyadd": "304 HARMON ST",
    "dropphycty": "PINEVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 648569998,
    "dropmaladd": "304 HARMON ST",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 648569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172234533,
    "dropsitcph": 4172234533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17554",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "25397 STATE HIGHWAY 64",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 657249998,
    "dropphyadd": "25397 STATE HIGHWAY 64",
    "dropphycty": "PITTSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 657249998,
    "dropmaladd": "25397 STATE HIGHWAY 64",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 657249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178525002,
    "dropsitcph": 4178525002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17556",
    "droptype": "D",
    "dropname": "PLATO",
    "dropdeladd": "10594 HIGHWAY 32",
    "dropdelcty": "PLATO",
    "dropdelst": "MO",
    "dropdelzpp": 655529998,
    "dropphyadd": "10594 HIGHWAY 32",
    "dropphycty": "PLATO",
    "dropphyst": "MO",
    "dropphyzpp": 655529998,
    "dropmaladd": "10594 HIGHWAY 32",
    "dropmalcty": "PLATO",
    "dropmalst": "MO",
    "dropmalzpp": 655529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174584843,
    "dropsitcph": 4174584843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17557",
    "droptype": "D",
    "dropname": "PLATTE CITY",
    "dropdeladd": "1101 HAMPTON LN",
    "dropdelcty": "PLATTE CITY",
    "dropdelst": "MO",
    "dropdelzpp": 640799998,
    "dropphyadd": "1101 HAMPTON LN",
    "dropphycty": "PLATTE CITY",
    "dropphyst": "MO",
    "dropphyzpp": 640799998,
    "dropmaladd": "1101 HAMPTON LN",
    "dropmalcty": "PLATTE CITY",
    "dropmalst": "MO",
    "dropmalzpp": 640799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168582431,
    "dropsitcph": 8168582431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17561",
    "droptype": "D",
    "dropname": "PLATTSBURG",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "PLATTSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 644779998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "PLATTSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 644779998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "PLATTSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 644779998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165392241,
    "dropsitcph": 8165392241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17563",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "124 VETERANS PKWY",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "MO",
    "dropdelzpp": 640809998,
    "dropphyadd": "124 VETERANS PKWY",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "MO",
    "dropphyzpp": 640809998,
    "dropmaladd": "124 VETERANS PKWY",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "MO",
    "dropmalzpp": 640809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165403312,
    "dropsitcph": 8165403312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17565",
    "droptype": "D",
    "dropname": "PLEASANT HOPE",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "PLEASANT HOPE",
    "dropdelst": "MO",
    "dropdelzpp": 657259998,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "PLEASANT HOPE",
    "dropphyst": "MO",
    "dropphyzpp": 657259998,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "PLEASANT HOPE",
    "dropmalst": "MO",
    "dropmalzpp": 657259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172672210,
    "dropsitcph": 4172672210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17575",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "131 POCAHONTAS MAIN ST",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "MO",
    "dropdelzpp": 637799998,
    "dropphyadd": "131 POCAHONTAS MAIN ST",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "MO",
    "dropphyzpp": 637799998,
    "dropmaladd": "131 POCAHONTAS MAIN ST",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "MO",
    "dropmalzpp": 637799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738336256,
    "dropsitcph": 5738336256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17576",
    "droptype": "D",
    "dropname": "POINT LOOKOUT",
    "dropdeladd": "9998 ACADEMIC AVE",
    "dropdelcty": "POINT LOOKOUT",
    "dropdelst": "MO",
    "dropdelzpp": 657269998,
    "dropphyadd": "9998 ACADEMIC AVE",
    "dropphycty": "POINT LOOKOUT",
    "dropphyst": "MO",
    "dropphyzpp": 657269998,
    "dropmaladd": "9998 ACADEMIC AVE",
    "dropmalcty": "POINT LOOKOUT",
    "dropmalst": "MO",
    "dropmalzpp": 657269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173344050,
    "dropsitcph": 4173344050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17579",
    "droptype": "D",
    "dropname": "POLLOCK",
    "dropdeladd": "506 C ST",
    "dropdelcty": "POLLOCK",
    "dropdelst": "MO",
    "dropdelzpp": 635609998,
    "dropphyadd": "506 C ST",
    "dropphycty": "POLLOCK",
    "dropphyst": "MO",
    "dropphyzpp": 635609998,
    "dropmaladd": "506 C ST",
    "dropmalcty": "POLLOCK",
    "dropmalst": "MO",
    "dropmalzpp": 635609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606924512,
    "dropsitcph": 6606924512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17580",
    "droptype": "D",
    "dropname": "POLO",
    "dropdeladd": "104 W ELM ST",
    "dropdelcty": "POLO",
    "dropdelst": "MO",
    "dropdelzpp": 646719998,
    "dropphyadd": "104 W ELM ST",
    "dropphycty": "POLO",
    "dropphyst": "MO",
    "dropphyzpp": 646719998,
    "dropmaladd": "104 W ELM ST",
    "dropmalcty": "POLO",
    "dropmalst": "MO",
    "dropmalzpp": 646719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607493568,
    "dropsitcph": 6607493568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17581",
    "droptype": "D",
    "dropname": "POMONA",
    "dropdeladd": "4279 COUNTY ROAD 4860",
    "dropdelcty": "POMONA",
    "dropdelst": "MO",
    "dropdelzpp": 657899998,
    "dropphyadd": "4279 COUNTY ROAD 4860",
    "dropphycty": "POMONA",
    "dropphyst": "MO",
    "dropphyzpp": 657899998,
    "dropmaladd": "4279 COUNTY ROAD 4860",
    "dropmalcty": "POMONA",
    "dropmalst": "MO",
    "dropmalzpp": 657899998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174693536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17582",
    "droptype": "D",
    "dropname": "PONCE DE LEON",
    "dropdeladd": "2684 MEDICAL SPRINGS RD",
    "dropdelcty": "PONCE DE LEON",
    "dropdelst": "MO",
    "dropdelzpp": 657289998,
    "dropphyadd": "2684 MEDICAL SPRINGS RD",
    "dropphycty": "PONCE DE LEON",
    "dropphyst": "MO",
    "dropphyzpp": 657289998,
    "dropmaladd": "2684 MEDICAL SPRINGS RD",
    "dropmalcty": "PONCE DE LEON",
    "dropmalst": "MO",
    "dropmalzpp": 657289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173576058,
    "dropsitcph": 4173576058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17586",
    "droptype": "D",
    "dropname": "PONTIAC",
    "dropdeladd": "8180 STATE HWY W",
    "dropdelcty": "PONTIAC",
    "dropdelst": "MO",
    "dropdelzpp": 657297141,
    "dropphyadd": "8180 STATE HWY W",
    "dropphycty": "PONTIAC",
    "dropphyst": "MO",
    "dropphyzpp": 657297141,
    "dropmaladd": "8180 STATE HWY W",
    "dropmalcty": "PONTIAC",
    "dropmalst": "MO",
    "dropmalzpp": 657297141,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176793440,
    "dropsitcph": 4176793440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17588",
    "droptype": "D",
    "dropname": "POPLAR BLUFF",
    "dropdeladd": "430 POPLAR ST",
    "dropdelcty": "POPLAR BLUFF",
    "dropdelst": "MO",
    "dropdelzpp": 639019998,
    "dropphyadd": "430 POPLAR ST",
    "dropphycty": "POPLAR BLUFF",
    "dropphyst": "MO",
    "dropphyzpp": 639019998,
    "dropmaladd": "430 POPLAR ST",
    "dropmalcty": "POPLAR BLUFF",
    "dropmalst": "MO",
    "dropmalzpp": 639019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737851491,
    "dropsitcph": 5737851491,
    "dropfax": 5736861499
  },
  {
    "dcode": "D",
    "dropkey": "PW17589",
    "droptype": "D",
    "dropname": "PORTAGE DES SIOUX",
    "dropdeladd": "1375 CLARK ST",
    "dropdelcty": "PORTAGE DES SIOUX",
    "dropdelst": "MO",
    "dropdelzpp": 633739998,
    "dropphyadd": "1375 CLARK ST",
    "dropphycty": "PORTAGE DES SIOUX",
    "dropphyst": "MO",
    "dropphyzpp": 633739998,
    "dropmaladd": "1375 CLARK ST",
    "dropmalcty": "PORTAGE DES SIOUX",
    "dropmalst": "MO",
    "dropmalzpp": 633739998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6368990033,
    "dropsitcph": 6368990033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17590",
    "droptype": "D",
    "dropname": "PORTAGEVILLE",
    "dropdeladd": "305 KING AVE",
    "dropdelcty": "PORTAGEVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 638739998,
    "dropphyadd": "305 KING AVE",
    "dropphycty": "PORTAGEVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 638739998,
    "dropmaladd": "305 KING AVE",
    "dropmalcty": "PORTAGEVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 638739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733795672,
    "dropsitcph": 5733795672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17593",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "10452 STATE ROUTE 94",
    "dropdelcty": "PORTLAND",
    "dropdelst": "MO",
    "dropdelzpp": 650679998,
    "dropphyadd": "10452 STATE ROUTE 94",
    "dropphycty": "PORTLAND",
    "dropphyst": "MO",
    "dropphyzpp": 650679998,
    "dropmaladd": "10452 STATE ROUTE 94",
    "dropmalcty": "PORTLAND",
    "dropmalst": "MO",
    "dropmalzpp": 650679998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736765831,
    "dropsitcph": 5736765831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17595",
    "droptype": "D",
    "dropname": "POTOSI",
    "dropdeladd": "103 LAUREL ST",
    "dropdelcty": "POTOSI",
    "dropdelst": "MO",
    "dropdelzpp": 636649998,
    "dropphyadd": "103 LAUREL ST",
    "dropphycty": "POTOSI",
    "dropphyst": "MO",
    "dropphyzpp": 636649998,
    "dropmaladd": "103 LAUREL ST",
    "dropmalcty": "POTOSI",
    "dropmalst": "MO",
    "dropmalzpp": 636649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734382991,
    "dropsitcph": 5734382991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17596",
    "droptype": "D",
    "dropname": "POTTERSVILLE",
    "dropdeladd": "1783 STATE ROUTE K",
    "dropdelcty": "POTTERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 657909998,
    "dropphyadd": "1783 STATE ROUTE K",
    "dropphycty": "POTTERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 657909998,
    "dropmaladd": "1783 STATE ROUTE K",
    "dropmalcty": "POTTERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 657909998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172564512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17599",
    "droptype": "D",
    "dropname": "POWELL",
    "dropdeladd": "98 ALBERT E BRUMLEY PKWY",
    "dropdelcty": "POWELL",
    "dropdelst": "MO",
    "dropdelzpp": 657309998,
    "dropphyadd": "98 ALBERT E BRUMLEY PKWY",
    "dropphycty": "POWELL",
    "dropphyst": "MO",
    "dropphyzpp": 657309998,
    "dropmaladd": "98 ALBERT E BRUMLEY PKWY",
    "dropmalcty": "POWELL",
    "dropmalst": "MO",
    "dropmalzpp": 657309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174352530,
    "dropsitcph": 4174352530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17600",
    "droptype": "D",
    "dropname": "POWERSITE",
    "dropdeladd": "1885 STATE HIGHWAY VV",
    "dropdelcty": "POWERSITE",
    "dropdelst": "MO",
    "dropdelzpp": 657319998,
    "dropphyadd": "1885 STATE HIGHWAY VV",
    "dropphycty": "POWERSITE",
    "dropphyst": "MO",
    "dropphyzpp": 657319998,
    "dropmaladd": "1885 STATE HIGHWAY VV",
    "dropmalcty": "POWERSITE",
    "dropmalst": "MO",
    "dropmalzpp": 657319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173356609,
    "dropsitcph": 4173356609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17601",
    "droptype": "D",
    "dropname": "POWERSVILLE",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "POWERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 646729998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "POWERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 646729998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "POWERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 646729998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605922235,
    "dropsitcph": 6605922235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17608",
    "droptype": "D",
    "dropname": "PRAIRIE HOME",
    "dropdeladd": "484 MAIN ST",
    "dropdelcty": "PRAIRIE HOME",
    "dropdelst": "MO",
    "dropdelzpp": 650689998,
    "dropphyadd": "484 MAIN ST",
    "dropphycty": "PRAIRIE HOME",
    "dropphyst": "MO",
    "dropphyzpp": 650689998,
    "dropmaladd": "484 MAIN ST",
    "dropmalcty": "PRAIRIE HOME",
    "dropmalst": "MO",
    "dropmalzpp": 650689998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608415690,
    "dropsitcph": 6608415690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17611",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "29024 US HIGHWAY 54",
    "dropdelcty": "PRESTON",
    "dropdelst": "MO",
    "dropdelzpp": 657329998,
    "dropphyadd": "29024 US HIGHWAY 54",
    "dropphycty": "PRESTON",
    "dropphyst": "MO",
    "dropphyzpp": 657329998,
    "dropmaladd": "29024 US HIGHWAY 54",
    "dropmalcty": "PRESTON",
    "dropmalst": "MO",
    "dropmalzpp": 657329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177222004,
    "dropsitcph": 4177222004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17613",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "204 S BROADWAY ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "MO",
    "dropdelzpp": 646731100,
    "dropphyadd": "204 S BROADWAY ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "MO",
    "dropphyzpp": 646731100,
    "dropmaladd": "204 S BROADWAY ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "MO",
    "dropmalzpp": 646731100,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607484245,
    "dropsitcph": 6607484245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17617",
    "droptype": "D",
    "dropname": "PROTEM",
    "dropdeladd": "5242 S STATE HIGHWAY 125",
    "dropdelcty": "PROTEM",
    "dropdelst": "MO",
    "dropdelzpp": 657339998,
    "dropphyadd": "5242 S STATE HIGHWAY 125",
    "dropphycty": "PROTEM",
    "dropphyst": "MO",
    "dropphyzpp": 657339998,
    "dropmaladd": "5242 S STATE HIGHWAY 125",
    "dropmalcty": "PROTEM",
    "dropmalst": "MO",
    "dropmalzpp": 657339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177854450,
    "dropsitcph": 4177854450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17619",
    "droptype": "D",
    "dropname": "PURCELL",
    "dropdeladd": "104 W 4TH ST",
    "dropdelcty": "PURCELL",
    "dropdelst": "MO",
    "dropdelzpp": 648579998,
    "dropphyadd": "104 W 4TH ST",
    "dropphycty": "PURCELL",
    "dropphyst": "MO",
    "dropphyzpp": 648579998,
    "dropmaladd": "104 W 4TH ST",
    "dropmalcty": "PURCELL",
    "dropmalst": "MO",
    "dropmalzpp": 648579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175254815,
    "dropsitcph": 4175254815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17620",
    "droptype": "D",
    "dropname": "PURDIN",
    "dropdeladd": "401 C ST",
    "dropdelcty": "PURDIN",
    "dropdelst": "MO",
    "dropdelzpp": 646749998,
    "dropphyadd": "401 C ST",
    "dropphycty": "PURDIN",
    "dropphyst": "MO",
    "dropphyzpp": 646749998,
    "dropmaladd": "401 C ST",
    "dropmalcty": "PURDIN",
    "dropmalst": "MO",
    "dropmalzpp": 646749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602445445,
    "dropsitcph": 6602445445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17621",
    "droptype": "D",
    "dropname": "PURDY",
    "dropdeladd": "100 E WASHINGTON ST",
    "dropdelcty": "PURDY",
    "dropdelst": "MO",
    "dropdelzpp": 657349998,
    "dropphyadd": "100 E WASHINGTON ST",
    "dropphycty": "PURDY",
    "dropphyst": "MO",
    "dropphyzpp": 657349998,
    "dropmaladd": "100 E WASHINGTON ST",
    "dropmalcty": "PURDY",
    "dropmalst": "MO",
    "dropmalzpp": 657349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174423543,
    "dropsitcph": 4174423543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17623",
    "droptype": "D",
    "dropname": "PUXICO",
    "dropdeladd": "196 N E L HAWKS ST",
    "dropdelcty": "PUXICO",
    "dropdelst": "MO",
    "dropdelzpp": 639609998,
    "dropphyadd": "196 N E L HAWKS ST",
    "dropphycty": "PUXICO",
    "dropphyst": "MO",
    "dropphyzpp": 639609998,
    "dropmaladd": "196 N E L HAWKS ST",
    "dropmalcty": "PUXICO",
    "dropmalst": "MO",
    "dropmalzpp": 639609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732223544,
    "dropsitcph": 5732223544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17624",
    "droptype": "D",
    "dropname": "QUEEN CITY",
    "dropdeladd": "508 N CEDAR ST",
    "dropdelcty": "QUEEN CITY",
    "dropdelst": "MO",
    "dropdelzpp": 635619998,
    "dropphyadd": "508 N CEDAR ST",
    "dropphycty": "QUEEN CITY",
    "dropphyst": "MO",
    "dropphyzpp": 635619998,
    "dropmaladd": "508 N CEDAR ST",
    "dropmalcty": "QUEEN CITY",
    "dropmalst": "MO",
    "dropmalzpp": 635619998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607662614,
    "dropsitcph": 6607662614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17627",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "14324 STATE ROUTE 83",
    "dropdelcty": "QUINCY",
    "dropdelst": "MO",
    "dropdelzpp": 657359998,
    "dropphyadd": "14324 STATE ROUTE 83",
    "dropphycty": "QUINCY",
    "dropphyst": "MO",
    "dropphyzpp": 657359998,
    "dropmaladd": "14324 STATE ROUTE 83",
    "dropmalcty": "QUINCY",
    "dropmalst": "MO",
    "dropmalzpp": 657359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172825980,
    "dropsitcph": 4172825980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17629",
    "droptype": "D",
    "dropname": "QULIN",
    "dropdeladd": "548 D ST",
    "dropdelcty": "QULIN",
    "dropdelst": "MO",
    "dropdelzpp": 639619998,
    "dropphyadd": "548 D ST",
    "dropphycty": "QULIN",
    "dropphyst": "MO",
    "dropphyzpp": 639619998,
    "dropmaladd": "548 D ST",
    "dropmalcty": "QULIN",
    "dropmalst": "MO",
    "dropmalzpp": 639619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733284458,
    "dropsitcph": 5733284458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17630",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "11945 W HIGHWAY 86",
    "dropdelcty": "RACINE",
    "dropdelst": "MO",
    "dropdelzpp": 648589998,
    "dropphyadd": "11945 W HIGHWAY 86",
    "dropphycty": "RACINE",
    "dropphyst": "MO",
    "dropphyzpp": 648589998,
    "dropmaladd": "11945 W HIGHWAY 86",
    "dropmalcty": "RACINE",
    "dropmalst": "MO",
    "dropmalzpp": 648589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177763393,
    "dropsitcph": 4177763393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17635",
    "droptype": "D",
    "dropname": "RAVENWOOD",
    "dropdeladd": "121 S MAIN ST",
    "dropdelcty": "RAVENWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 644799998,
    "dropphyadd": "121 S MAIN ST",
    "dropphycty": "RAVENWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 644799998,
    "dropmaladd": "121 S MAIN ST",
    "dropmalcty": "RAVENWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 644799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609372745,
    "dropsitcph": 6609372745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17636",
    "droptype": "D",
    "dropname": "RAYMONDVILLE",
    "dropdeladd": "174 N HIGHWAY 137",
    "dropdelcty": "RAYMONDVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 655559998,
    "dropphyadd": "174 N HIGHWAY 137",
    "dropphycty": "RAYMONDVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 655559998,
    "dropmaladd": "174 N HIGHWAY 137",
    "dropmalcty": "RAYMONDVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 655559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174576315,
    "dropsitcph": 4174576315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17638",
    "droptype": "D",
    "dropname": "RAYMORE",
    "dropdeladd": "329 N MADISON ST",
    "dropdelcty": "RAYMORE",
    "dropdelst": "MO",
    "dropdelzpp": 640839998,
    "dropphyadd": "329 N MADISON ST",
    "dropphycty": "RAYMORE",
    "dropphyst": "MO",
    "dropphyzpp": 640839998,
    "dropmaladd": "329 N MADISON ST",
    "dropmalcty": "RAYMORE",
    "dropmalst": "MO",
    "dropmalzpp": 640839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163315025,
    "dropsitcph": 8163312736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17641",
    "droptype": "D",
    "dropname": "RAYVILLE",
    "dropdeladd": "107 N HIGHWAY C",
    "dropdelcty": "RAYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 640849709,
    "dropphyadd": "107 N HIGHWAY C",
    "dropphycty": "RAYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 640849709,
    "dropmaladd": "107 N HIGHWAY C",
    "dropmalcty": "RAYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 640849709,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164702176,
    "dropsitcph": 8164702176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17644",
    "droptype": "D",
    "dropname": "REA",
    "dropdeladd": "218 BYERS ST",
    "dropdelcty": "REA",
    "dropdelst": "MO",
    "dropdelzpp": 644809998,
    "dropphyadd": "218 BYERS ST",
    "dropphycty": "REA",
    "dropphyst": "MO",
    "dropphyzpp": 644809998,
    "dropmaladd": "218 BYERS ST",
    "dropmalcty": "REA",
    "dropmalst": "MO",
    "dropmalzpp": 644809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165262155,
    "dropsitcph": 8165262155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17647",
    "droptype": "D",
    "dropname": "REDFORD",
    "dropdeladd": "150 REDFORD LOOP",
    "dropdelcty": "REDFORD",
    "dropdelst": "MO",
    "dropdelzpp": 636659998,
    "dropphyadd": "150 REDFORD LOOP",
    "dropphycty": "REDFORD",
    "dropphyst": "MO",
    "dropphyzpp": 636659998,
    "dropmaladd": "150 REDFORD LOOP",
    "dropmalcty": "REDFORD",
    "dropmalst": "MO",
    "dropmalzpp": 636659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735582474,
    "dropsitcph": 5735582474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17649",
    "droptype": "D",
    "dropname": "REEDS",
    "dropdeladd": "5970 5TH ST",
    "dropdelcty": "REEDS",
    "dropdelst": "MO",
    "dropdelzpp": 648599998,
    "dropphyadd": "5970 5TH ST",
    "dropphycty": "REEDS",
    "dropphyst": "MO",
    "dropphyzpp": 648599998,
    "dropmaladd": "5970 5TH ST",
    "dropmalcty": "REEDS",
    "dropmalst": "MO",
    "dropmalzpp": 648599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173586085,
    "dropsitcph": 4173586085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17651",
    "droptype": "D",
    "dropname": "REEDS SPRING",
    "dropdeladd": "22153 MAIN ST",
    "dropdelcty": "REEDS SPRING",
    "dropdelst": "MO",
    "dropdelzpp": 657379998,
    "dropphyadd": "22153 MAIN ST",
    "dropphycty": "REEDS SPRING",
    "dropphyst": "MO",
    "dropphyzpp": 657379998,
    "dropmaladd": "22153 MAIN ST",
    "dropmalcty": "REEDS SPRING",
    "dropmalst": "MO",
    "dropmalzpp": 657379998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172723243,
    "dropsitcph": 4172723243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17654",
    "droptype": "D",
    "dropname": "RENICK",
    "dropdeladd": "200 ROBINSON ST",
    "dropdelcty": "RENICK",
    "dropdelst": "MO",
    "dropdelzpp": 652789998,
    "dropphyadd": "200 ROBINSON ST",
    "dropphycty": "RENICK",
    "dropphyst": "MO",
    "dropphyzpp": 652789998,
    "dropmaladd": "200 ROBINSON ST",
    "dropmalcty": "RENICK",
    "dropmalst": "MO",
    "dropmalzpp": 652789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602634590,
    "dropsitcph": 6602634590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17656",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "660 E HARRISON ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "MO",
    "dropdelzpp": 657389998,
    "dropphyadd": "660 E HARRISON ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "MO",
    "dropphyzpp": 657389998,
    "dropmaladd": "660 E HARRISON ST",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "MO",
    "dropmalzpp": 657389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177321525,
    "dropsitcph": 4177324733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17657",
    "droptype": "D",
    "dropname": "REVERE",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "REVERE",
    "dropdelst": "MO",
    "dropdelzpp": 634659998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "REVERE",
    "dropphyst": "MO",
    "dropphyzpp": 634659998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "REVERE",
    "dropmalst": "MO",
    "dropmalzpp": 634659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6609482181,
    "dropsitcph": 6609482181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17659",
    "droptype": "D",
    "dropname": "RHINELAND",
    "dropdeladd": "102 BLUFF ST",
    "dropdelcty": "RHINELAND",
    "dropdelst": "MO",
    "dropdelzpp": 650699998,
    "dropphyadd": "102 BLUFF ST",
    "dropphycty": "RHINELAND",
    "dropphyst": "MO",
    "dropphyzpp": 650699998,
    "dropmaladd": "102 BLUFF ST",
    "dropmalcty": "RHINELAND",
    "dropmalst": "MO",
    "dropmalzpp": 650699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732364330,
    "dropsitcph": 5732364330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17661",
    "droptype": "D",
    "dropname": "RICH HILL",
    "dropdeladd": "114 N 6TH ST",
    "dropdelcty": "RICH HILL",
    "dropdelst": "MO",
    "dropdelzpp": 647799998,
    "dropphyadd": "114 N 6TH ST",
    "dropphycty": "RICH HILL",
    "dropphyst": "MO",
    "dropphyzpp": 647799998,
    "dropmaladd": "114 N 6TH ST",
    "dropmalcty": "RICH HILL",
    "dropmalst": "MO",
    "dropmalzpp": 647799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173952135,
    "dropsitcph": 4173952135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17663",
    "droptype": "D",
    "dropname": "RICHARDS",
    "dropdeladd": "12309 S MAIN ST",
    "dropdelcty": "RICHARDS",
    "dropdelst": "MO",
    "dropdelzpp": 647789998,
    "dropphyadd": "12309 S MAIN ST",
    "dropphycty": "RICHARDS",
    "dropphyst": "MO",
    "dropphyzpp": 647789998,
    "dropmaladd": "12309 S MAIN ST",
    "dropmalcty": "RICHARDS",
    "dropmalst": "MO",
    "dropmalzpp": 647789998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179279439,
    "dropsitcph": 4179273439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17666",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "114 W MCCLURG AVE",
    "dropdelcty": "RICHLAND",
    "dropdelst": "MO",
    "dropdelzpp": 655569998,
    "dropphyadd": "114 W MCCLURG AVE",
    "dropphycty": "RICHLAND",
    "dropphyst": "MO",
    "dropphyzpp": 655569998,
    "dropmaladd": "114 W MCCLURG AVE",
    "dropmalcty": "RICHLAND",
    "dropmalst": "MO",
    "dropmalzpp": 655569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737653295,
    "dropsitcph": 5737653295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17668",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "209 S COLLEGE ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "MO",
    "dropdelzpp": 640859998,
    "dropphyadd": "209 S COLLEGE ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "MO",
    "dropphyzpp": 640859998,
    "dropmaladd": "209 S COLLEGE ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "MO",
    "dropmalzpp": 640859998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167763391,
    "dropsitcph": 8167763391,
    "dropfax": 8164703811
  },
  {
    "dcode": "D",
    "dropkey": "PW17673",
    "droptype": "D",
    "dropname": "RICHWOODS",
    "dropdeladd": "11218 STATE HIGHWAY A",
    "dropdelcty": "RICHWOODS",
    "dropdelst": "MO",
    "dropdelzpp": 630719998,
    "dropphyadd": "11218 STATE HIGHWAY A",
    "dropphycty": "RICHWOODS",
    "dropphyst": "MO",
    "dropphyzpp": 630719998,
    "dropmaladd": "11218 STATE HIGHWAY A",
    "dropmalcty": "RICHWOODS",
    "dropmalst": "MO",
    "dropmalzpp": 630719998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736782777,
    "dropsitcph": 5736782777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17674",
    "droptype": "D",
    "dropname": "RIDGEDALE",
    "dropdeladd": "3234 RIDGEDALE RD",
    "dropdelcty": "RIDGEDALE",
    "dropdelst": "MO",
    "dropdelzpp": 657399998,
    "dropphyadd": "3234 RIDGEDALE RD",
    "dropphycty": "RIDGEDALE",
    "dropphyst": "MO",
    "dropphyzpp": 657399998,
    "dropmaladd": "3234 RIDGEDALE RD",
    "dropmalcty": "RIDGEDALE",
    "dropmalst": "MO",
    "dropmalzpp": 657399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173344773,
    "dropsitcph": 4173344773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17675",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "402 PINE ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "MO",
    "dropdelzpp": 644819998,
    "dropphyadd": "402 PINE ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "MO",
    "dropphyzpp": 644819998,
    "dropmaladd": "402 PINE ST",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "MO",
    "dropmalzpp": 644819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608726924,
    "dropsitcph": 6608726924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17677",
    "droptype": "D",
    "dropname": "RISCO",
    "dropdeladd": "203 FRONT ST",
    "dropdelcty": "RISCO",
    "dropdelst": "MO",
    "dropdelzpp": 638749998,
    "dropphyadd": "203 FRONT ST",
    "dropphycty": "RISCO",
    "dropphyst": "MO",
    "dropphyzpp": 638749998,
    "dropmaladd": "203 FRONT ST",
    "dropmalcty": "RISCO",
    "dropmalst": "MO",
    "dropmalzpp": 638749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733965770,
    "dropsitcph": 5733965770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17691",
    "droptype": "D",
    "dropname": "ROACH",
    "dropdeladd": "353 STATE ROAD AA",
    "dropdelcty": "ROACH",
    "dropdelst": "MO",
    "dropdelzpp": 657879998,
    "dropphyadd": "353 STATE ROAD AA",
    "dropphycty": "ROACH",
    "dropphyst": "MO",
    "dropphyzpp": 657879998,
    "dropmaladd": "353 STATE ROAD AA",
    "dropmalcty": "ROACH",
    "dropmalst": "MO",
    "dropmalzpp": 657879998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 5733467880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17694",
    "droptype": "D",
    "dropname": "ROBERTSVILLE",
    "dropdeladd": "7292 HIGHWAY O",
    "dropdelcty": "ROBERTSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 630729998,
    "dropphyadd": "7292 HIGHWAY O",
    "dropphycty": "ROBERTSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 630729998,
    "dropmaladd": "7292 HIGHWAY O",
    "dropmalcty": "ROBERTSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 630729998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362572378,
    "dropsitcph": 6362572378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17697",
    "droptype": "D",
    "dropname": "ROBY",
    "dropdeladd": "12445 CASS LN",
    "dropdelcty": "ROBY",
    "dropdelst": "MO",
    "dropdelzpp": 655579998,
    "dropphyadd": "12445 CASS LN",
    "dropphycty": "ROBY",
    "dropphyst": "MO",
    "dropphyzpp": 655579998,
    "dropmaladd": "12445 CASS LN",
    "dropmalcty": "ROBY",
    "dropmalst": "MO",
    "dropmalzpp": 655579998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174584540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17698",
    "droptype": "D",
    "dropname": "ROCHEPORT",
    "dropdeladd": "200 CENTRAL ST",
    "dropdelcty": "ROCHEPORT",
    "dropdelst": "MO",
    "dropdelzpp": 652799998,
    "dropphyadd": "200 CENTRAL ST",
    "dropphycty": "ROCHEPORT",
    "dropphyst": "MO",
    "dropphyzpp": 652799998,
    "dropmaladd": "200 CENTRAL ST",
    "dropmalcty": "ROCHEPORT",
    "dropmalst": "MO",
    "dropmalzpp": 652799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736982605,
    "dropsitcph": 5736982605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17701",
    "droptype": "D",
    "dropname": "ROCK PORT",
    "dropdeladd": "110 W OPP ST",
    "dropdelcty": "ROCK PORT",
    "dropdelst": "MO",
    "dropdelzpp": 644829998,
    "dropphyadd": "110 W OPP ST",
    "dropphycty": "ROCK PORT",
    "dropphyst": "MO",
    "dropphyzpp": 644829998,
    "dropmaladd": "110 W OPP ST",
    "dropmalcty": "ROCK PORT",
    "dropmalst": "MO",
    "dropmalzpp": 644829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607442188,
    "dropsitcph": 6607442188,
    "dropfax": 6607446585
  },
  {
    "dcode": "D",
    "dropkey": "PW17703",
    "droptype": "D",
    "dropname": "ROCKAWAY BEACH",
    "dropdeladd": "2578 STATE HIGHWAY 176",
    "dropdelcty": "ROCKAWAY BEACH",
    "dropdelst": "MO",
    "dropdelzpp": 657409998,
    "dropphyadd": "2578 STATE HIGHWAY 176",
    "dropphycty": "ROCKAWAY BEACH",
    "dropphyst": "MO",
    "dropphyzpp": 657409998,
    "dropmaladd": "2578 STATE HIGHWAY 176",
    "dropmalcty": "ROCKAWAY BEACH",
    "dropmalst": "MO",
    "dropmalzpp": 657409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175614100,
    "dropsitcph": 4175614100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17708",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "407 OSAGE AVE",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 647809998,
    "dropphyadd": "407 OSAGE AVE",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 647809998,
    "dropmaladd": "407 OSAGE AVE",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 647809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6605982683,
    "dropsitcph": 6605982683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17709",
    "droptype": "D",
    "dropname": "ROCKY COMFORT",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "ROCKY COMFORT",
    "dropdelst": "MO",
    "dropdelzpp": 648619998,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "ROCKY COMFORT",
    "dropphyst": "MO",
    "dropphyzpp": 648619998,
    "dropmaladd": "121 MAIN ST",
    "dropmalcty": "ROCKY COMFORT",
    "dropmalst": "MO",
    "dropmalzpp": 648619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176527320,
    "dropsitcph": 4176527320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17714",
    "droptype": "D",
    "dropname": "ROGERSVILLE",
    "dropdeladd": "226 W CENTER ST",
    "dropdelcty": "ROGERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 657429998,
    "dropphyadd": "226 W CENTER ST",
    "dropphycty": "ROGERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 657429998,
    "dropmaladd": "226 W CENTER ST",
    "dropmalcty": "ROGERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 657429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177532811,
    "dropsitcph": 4177532811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17717",
    "droptype": "D",
    "dropname": "ROLLA",
    "dropdeladd": "501 W 8TH ST",
    "dropdelcty": "ROLLA",
    "dropdelst": "MO",
    "dropdelzpp": 654019998,
    "dropphyadd": "501 W 8TH ST",
    "dropphycty": "ROLLA",
    "dropphyst": "MO",
    "dropphyzpp": 654019998,
    "dropmaladd": "501 W 8TH ST",
    "dropmalcty": "ROLLA",
    "dropmalst": "MO",
    "dropmalzpp": 654019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733641775,
    "dropsitcph": 5733641775,
    "dropfax": 5733646787
  },
  {
    "dcode": "D",
    "dropkey": "PW17721",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "100 PECAN ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "MO",
    "dropdelzpp": 647819998,
    "dropphyadd": "100 PECAN ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "MO",
    "dropphyzpp": 647819998,
    "dropmaladd": "100 PECAN ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "MO",
    "dropmalzpp": 647819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176468210,
    "dropsitcph": 4176468210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17723",
    "droptype": "D",
    "dropname": "ROSEBUD",
    "dropdeladd": "257 HIGHWAY 50",
    "dropdelcty": "ROSEBUD",
    "dropdelst": "MO",
    "dropdelzpp": 630919998,
    "dropphyadd": "257 HIGHWAY 50",
    "dropphycty": "ROSEBUD",
    "dropphyst": "MO",
    "dropphyzpp": 630919998,
    "dropmaladd": "257 HIGHWAY 50",
    "dropmalcty": "ROSEBUD",
    "dropmalst": "MO",
    "dropmalzpp": 630919998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737642643,
    "dropsitcph": 5737642643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17725",
    "droptype": "D",
    "dropname": "ROSENDALE",
    "dropdeladd": "11501 HIGHWAY 48",
    "dropdelcty": "ROSENDALE",
    "dropdelst": "MO",
    "dropdelzpp": 644839998,
    "dropphyadd": "11501 HIGHWAY 48",
    "dropphycty": "ROSENDALE",
    "dropphyst": "MO",
    "dropphyzpp": 644839998,
    "dropmaladd": "11501 HIGHWAY 48",
    "dropmalcty": "ROSENDALE",
    "dropmalst": "MO",
    "dropmalzpp": 644839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165672665,
    "dropsitcph": 8165672665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17726",
    "droptype": "D",
    "dropname": "ROTHVILLE",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "ROTHVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 646769998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "ROTHVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 646769998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "ROTHVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 646769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6602563215,
    "dropsitcph": 6602563215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17733",
    "droptype": "D",
    "dropname": "RUSH HILL",
    "dropdeladd": "301 N CENTER ST",
    "dropdelcty": "RUSH HILL",
    "dropdelst": "MO",
    "dropdelzpp": 652809998,
    "dropphyadd": "301 N CENTER ST",
    "dropphycty": "RUSH HILL",
    "dropphyst": "MO",
    "dropphyzpp": 652809998,
    "dropmaladd": "301 N CENTER ST",
    "dropmalcty": "RUSH HILL",
    "dropmalst": "MO",
    "dropmalzpp": 652809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735812210,
    "dropsitcph": 5735812210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17735",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "209 VALLEY ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644849998,
    "dropphyadd": "209 VALLEY ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644849998,
    "dropmaladd": "209 VALLEY ST",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644849998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166887919,
    "dropsitcph": 8166887919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17738",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "5103 SIMPSON ST",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 650749998,
    "dropphyadd": "5103 SIMPSON ST",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 650749998,
    "dropmaladd": "5103 SIMPSON ST",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 650749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5737824712,
    "dropsitcph": 5737824712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17741",
    "droptype": "D",
    "dropname": "RUTLEDGE",
    "dropdeladd": "55 MAIN ST",
    "dropdelcty": "RUTLEDGE",
    "dropdelst": "MO",
    "dropdelzpp": 635639998,
    "dropphyadd": "55 MAIN ST",
    "dropphycty": "RUTLEDGE",
    "dropphyst": "MO",
    "dropphyzpp": 635639998,
    "dropmaladd": "55 MAIN ST",
    "dropmalcty": "RUTLEDGE",
    "dropmalst": "MO",
    "dropmalzpp": 635639998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608835532,
    "dropsitcph": 6608835532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17747",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "5301 S RANGE LINE RD",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MO",
    "dropdelzpp": 648649998,
    "dropphyadd": "5301 S RANGE LINE RD",
    "dropphycty": "SAGINAW",
    "dropphyst": "MO",
    "dropphyzpp": 648649998,
    "dropmaladd": "5301 S RANGE LINE RD",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MO",
    "dropmalzpp": 648649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176230636,
    "dropsitcph": 4176230636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17749",
    "droptype": "D",
    "dropname": "SAINT ALBANS",
    "dropdeladd": "3451 SAINT ALBANS RD STE E",
    "dropdelcty": "SAINT ALBANS",
    "dropdelst": "MO",
    "dropdelzpp": 630739998,
    "dropphyadd": "3451 SAINT ALBANS RD STE E",
    "dropphycty": "SAINT ALBANS",
    "dropphyst": "MO",
    "dropphyzpp": 630739998,
    "dropmaladd": "3451 SAINT ALBANS RD STE E",
    "dropmalcty": "SAINT ALBANS",
    "dropmalst": "MO",
    "dropmalzpp": 630739998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362735306,
    "dropsitcph": 6362735306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17750",
    "droptype": "D",
    "dropname": "SAINT ANN",
    "dropdeladd": "10401 INTERNATIONAL PLAZA DR",
    "dropdelcty": "SAINT ANN",
    "dropdelst": "MO",
    "dropdelzpp": 630749998,
    "dropphyadd": "10401 INTERNATIONAL PLAZA DR",
    "dropphycty": "SAINT ANN",
    "dropphyst": "MO",
    "dropphyzpp": 630749998,
    "dropmaladd": "10401 INTERNATIONAL PLAZA DR",
    "dropmalcty": "SAINT ANN",
    "dropmalst": "MO",
    "dropmalzpp": 630749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144285465,
    "dropsitcph": 3144285380,
    "dropfax": 3144280331
  },
  {
    "dcode": "D",
    "dropkey": "PW17756",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "1890 1ST CAPITOL DR",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "MO",
    "dropdelzpp": 633019998,
    "dropphyadd": "1890 1ST CAPITOL DR",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "MO",
    "dropphyzpp": 633019998,
    "dropmaladd": "1890 1ST CAPITOL DR",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "MO",
    "dropmalzpp": 633019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369492291,
    "dropsitcph": 6369492291,
    "dropfax": 6369461509
  },
  {
    "dcode": "D",
    "dropkey": "PW17757",
    "droptype": "D",
    "dropname": "SAINT CLAIR",
    "dropdeladd": "1020 PLAZA CT S STE A",
    "dropdelcty": "SAINT CLAIR",
    "dropdelst": "MO",
    "dropdelzpp": 630779998,
    "dropphyadd": "1020 PLAZA CT S STE A",
    "dropphycty": "SAINT CLAIR",
    "dropphyst": "MO",
    "dropphyzpp": 630779998,
    "dropmaladd": "1020 PLAZA CT S STE A",
    "dropmalcty": "SAINT CLAIR",
    "dropmalst": "MO",
    "dropmalzpp": 630779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366291866,
    "dropsitcph": 6366291866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17759",
    "droptype": "D",
    "dropname": "SAINT ELIZABETH",
    "dropdeladd": "140 S WALNUT ST",
    "dropdelcty": "SAINT ELIZABETH",
    "dropdelst": "MO",
    "dropdelzpp": 650759998,
    "dropphyadd": "140 S WALNUT ST",
    "dropphycty": "SAINT ELIZABETH",
    "dropphyst": "MO",
    "dropphyzpp": 650759998,
    "dropmaladd": "140 S WALNUT ST",
    "dropmalcty": "SAINT ELIZABETH",
    "dropmalst": "MO",
    "dropmalzpp": 650759998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734932343,
    "dropsitcph": 5734932343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17763",
    "droptype": "D",
    "dropname": "SAINT JAMES",
    "dropdeladd": "201 N BOURBEUSE ST",
    "dropdelcty": "SAINT JAMES",
    "dropdelst": "MO",
    "dropdelzpp": 655599998,
    "dropphyadd": "201 N BOURBEUSE ST",
    "dropphycty": "SAINT JAMES",
    "dropphyst": "MO",
    "dropphyzpp": 655599998,
    "dropmaladd": "201 N BOURBEUSE ST",
    "dropmalcty": "SAINT JAMES",
    "dropmalst": "MO",
    "dropmalzpp": 655599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732657664,
    "dropsitcph": 5732657664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17767",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "201 S 8TH ST",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MO",
    "dropdelzpp": 645019998,
    "dropphyadd": "201 S 8TH ST",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MO",
    "dropphyzpp": 645019998,
    "dropmaladd": "201 S 8TH ST",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MO",
    "dropmalzpp": 645019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163643231,
    "dropsitcph": 8163643231,
    "dropfax": 8163641926
  },
  {
    "dcode": "D",
    "dropkey": "PW17799",
    "droptype": "D",
    "dropname": "SAINT LOUIS",
    "dropdeladd": "1720 MARKET ST RM 3035",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631559998,
    "dropphyadd": "1720 MARKET ST RM 3035",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631559998,
    "dropmaladd": "1720 MARKET ST RM 3035",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144366853,
    "dropsitcph": 3144366853,
    "dropfax": 3144364565
  },
  {
    "dcode": "D",
    "dropkey": "PW17843",
    "droptype": "D",
    "dropname": "SAINT MARY",
    "dropdeladd": "17410 BARTELS INDUSTRIAL DR",
    "dropdelcty": "SAINT MARY",
    "dropdelst": "MO",
    "dropdelzpp": 636739998,
    "dropphyadd": "17410 BARTELS INDUSTRIAL DR",
    "dropphycty": "SAINT MARY",
    "dropphyst": "MO",
    "dropphyzpp": 636739998,
    "dropmaladd": "17410 BARTELS INDUSTRIAL DR",
    "dropmalcty": "SAINT MARY",
    "dropmalst": "MO",
    "dropmalzpp": 636739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5735432144,
    "dropsitcph": 5735432144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17845",
    "droptype": "D",
    "dropname": "SAINT PATRICK",
    "dropdeladd": "2 ERIN CIR",
    "dropdelcty": "SAINT PATRICK",
    "dropdelst": "MO",
    "dropdelzpp": 634669998,
    "dropphyadd": "2 ERIN CIR",
    "dropphycty": "SAINT PATRICK",
    "dropphyst": "MO",
    "dropphyzpp": 634669998,
    "dropmaladd": "2 ERIN CIR",
    "dropmalcty": "SAINT PATRICK",
    "dropmalst": "MO",
    "dropmalzpp": 634669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607546511,
    "dropsitcph": 6607546511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17848",
    "droptype": "D",
    "dropname": "SAINT PETERS",
    "dropdeladd": "7055 MEXICO RD",
    "dropdelcty": "SAINT PETERS",
    "dropdelst": "MO",
    "dropdelzpp": 633769998,
    "dropphyadd": "7055 MEXICO RD",
    "dropphycty": "SAINT PETERS",
    "dropphyst": "MO",
    "dropphyzpp": 633769998,
    "dropmaladd": "7055 MEXICO RD",
    "dropmalcty": "SAINT PETERS",
    "dropmalst": "MO",
    "dropmalzpp": 633769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363971640,
    "dropsitcph": 6363979022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17851",
    "droptype": "D",
    "dropname": "SAINT THOMAS",
    "dropdeladd": "14807 ROUTE B",
    "dropdelcty": "SAINT THOMAS",
    "dropdelst": "MO",
    "dropdelzpp": 650769998,
    "dropphyadd": "14807 ROUTE B",
    "dropphycty": "SAINT THOMAS",
    "dropphyst": "MO",
    "dropphyzpp": 650769998,
    "dropmaladd": "14807 ROUTE B",
    "dropmalcty": "SAINT THOMAS",
    "dropmalst": "MO",
    "dropmalzpp": 650769998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734773553,
    "dropsitcph": 5734773553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17857",
    "droptype": "D",
    "dropname": "SAINTE GENEVIEVE",
    "dropdeladd": "135 MERCHANT ST",
    "dropdelcty": "SAINTE GENEVIEVE",
    "dropdelst": "MO",
    "dropdelzpp": 636709998,
    "dropphyadd": "135 MERCHANT ST",
    "dropphycty": "SAINTE GENEVIEVE",
    "dropphyst": "MO",
    "dropphyzpp": 636709998,
    "dropmaladd": "135 MERCHANT ST",
    "dropmalcty": "SAINTE GENEVIEVE",
    "dropmalst": "MO",
    "dropmalzpp": 636709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738833250,
    "dropsitcph": 5738833250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17862",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "303 N JACKSON ST",
    "dropdelcty": "SALEM",
    "dropdelst": "MO",
    "dropdelzpp": 655609998,
    "dropphyadd": "303 N JACKSON ST",
    "dropphycty": "SALEM",
    "dropphyst": "MO",
    "dropphyzpp": 655609998,
    "dropmaladd": "303 N JACKSON ST",
    "dropmalcty": "SALEM",
    "dropmalst": "MO",
    "dropmalzpp": 655609998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 5737293442,
    "dropfax": 5737298532
  },
  {
    "dcode": "D",
    "dropkey": "PW17865",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "110 E 4TH ST",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MO",
    "dropdelzpp": 652819998,
    "dropphyadd": "110 E 4TH ST",
    "dropphycty": "SALISBURY",
    "dropphyst": "MO",
    "dropphyzpp": 652819998,
    "dropmaladd": "110 E 4TH ST",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MO",
    "dropmalzpp": 652819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603885118,
    "dropsitcph": 6603885118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17870",
    "droptype": "D",
    "dropname": "SANTA FE",
    "dropdeladd": "35595 ROUTE D",
    "dropdelcty": "SANTA FE",
    "dropdelst": "MO",
    "dropdelzpp": 652829998,
    "dropphyadd": "35595 ROUTE D",
    "dropphycty": "SANTA FE",
    "dropphyst": "MO",
    "dropphyzpp": 652829998,
    "dropmaladd": "35595 ROUTE D",
    "dropmalcty": "SANTA FE",
    "dropmalst": "MO",
    "dropmalzpp": 652829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736852261,
    "dropsitcph": 5736852261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17876",
    "droptype": "D",
    "dropname": "SARCOXIE",
    "dropdeladd": "216 N 5TH ST",
    "dropdelcty": "SARCOXIE",
    "dropdelst": "MO",
    "dropdelzpp": 648629998,
    "dropphyadd": "216 N 5TH ST",
    "dropphycty": "SARCOXIE",
    "dropphyst": "MO",
    "dropphyzpp": 648629998,
    "dropmaladd": "216 N 5TH ST",
    "dropmalcty": "SARCOXIE",
    "dropmalst": "MO",
    "dropmalzpp": 648629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175483531,
    "dropsitcph": 4175483531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17877",
    "droptype": "D",
    "dropname": "SAVANNAH",
    "dropdeladd": "507 W MAIN ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "MO",
    "dropdelzpp": 644859998,
    "dropphyadd": "507 W MAIN ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "MO",
    "dropphyzpp": 644859998,
    "dropmaladd": "507 W MAIN ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "MO",
    "dropmalzpp": 644859998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163244000,
    "dropsitcph": 8163244000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17879",
    "droptype": "D",
    "dropname": "SCHELL CITY",
    "dropdeladd": "101 W 1ST ST",
    "dropdelcty": "SCHELL CITY",
    "dropdelst": "MO",
    "dropdelzpp": 647839998,
    "dropphyadd": "101 W 1ST ST",
    "dropphycty": "SCHELL CITY",
    "dropphyst": "MO",
    "dropphyzpp": 647839998,
    "dropmaladd": "101 W 1ST ST",
    "dropmalcty": "SCHELL CITY",
    "dropmalst": "MO",
    "dropmalzpp": 647839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174323661,
    "dropsitcph": 4174323661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17892",
    "droptype": "D",
    "dropname": "SCOTT CITY",
    "dropdeladd": "605 2ND ST E",
    "dropdelcty": "SCOTT CITY",
    "dropdelst": "MO",
    "dropdelzpp": 637809998,
    "dropphyadd": "605 2ND ST E",
    "dropphycty": "SCOTT CITY",
    "dropphyst": "MO",
    "dropphyzpp": 637809998,
    "dropmaladd": "605 2ND ST E",
    "dropmalcty": "SCOTT CITY",
    "dropmalst": "MO",
    "dropmalzpp": 637809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732642345,
    "dropsitcph": 5732642345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17895",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "405 E 5TH ST",
    "dropdelcty": "SEDALIA",
    "dropdelst": "MO",
    "dropdelzpp": 653019998,
    "dropphyadd": "405 E 5TH ST",
    "dropphycty": "SEDALIA",
    "dropphyst": "MO",
    "dropphyzpp": 653019998,
    "dropmaladd": "405 E 5TH ST",
    "dropmalcty": "SEDALIA",
    "dropmalst": "MO",
    "dropmalzpp": 653019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608268887,
    "dropsitcph": 6608268887,
    "dropfax": 6608291698
  },
  {
    "dcode": "D",
    "dropkey": "PW17896",
    "droptype": "D",
    "dropname": "SEDGEWICKVILLE",
    "dropdeladd": "7 STATE ROUTE WW",
    "dropdelcty": "SEDGEWICKVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 637819998,
    "dropphyadd": "7 STATE ROUTE WW",
    "dropphycty": "SEDGEWICKVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 637819998,
    "dropmaladd": "7 STATE ROUTE WW",
    "dropmalcty": "SEDGEWICKVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 637819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738662158,
    "dropsitcph": 5738662158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17901",
    "droptype": "D",
    "dropname": "SELIGMAN",
    "dropdeladd": "28048 N HICKORY ST",
    "dropdelcty": "SELIGMAN",
    "dropdelst": "MO",
    "dropdelzpp": 657459998,
    "dropphyadd": "28048 N HICKORY ST",
    "dropphycty": "SELIGMAN",
    "dropphyst": "MO",
    "dropphyzpp": 657459998,
    "dropmaladd": "28048 N HICKORY ST",
    "dropmalcty": "SELIGMAN",
    "dropmalst": "MO",
    "dropmalzpp": 657459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176623500,
    "dropsitcph": 4176623500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17904",
    "droptype": "D",
    "dropname": "SENATH",
    "dropdeladd": "205 W COMMERCIAL ST",
    "dropdelcty": "SENATH",
    "dropdelst": "MO",
    "dropdelzpp": 638769998,
    "dropphyadd": "205 W COMMERCIAL ST",
    "dropphycty": "SENATH",
    "dropphyst": "MO",
    "dropphyzpp": 638769998,
    "dropmaladd": "205 W COMMERCIAL ST",
    "dropmalcty": "SENATH",
    "dropmalst": "MO",
    "dropmalzpp": 638769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737382018,
    "dropsitcph": 5737382018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17905",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "1205 CHEROKEE AVE",
    "dropdelcty": "SENECA",
    "dropdelst": "MO",
    "dropdelzpp": 648659998,
    "dropphyadd": "1205 CHEROKEE AVE",
    "dropphycty": "SENECA",
    "dropphyst": "MO",
    "dropphyzpp": 648659998,
    "dropmaladd": "1205 CHEROKEE AVE",
    "dropmalcty": "SENECA",
    "dropmalst": "MO",
    "dropmalzpp": 648659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177762246,
    "dropsitcph": 4177762246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17907",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "218 W WASHINGTON ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "MO",
    "dropdelzpp": 657469998,
    "dropphyadd": "218 W WASHINGTON ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "MO",
    "dropphyzpp": 657469998,
    "dropmaladd": "218 W WASHINGTON ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "MO",
    "dropmalzpp": 657469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179352275,
    "dropsitcph": 4179352275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17911",
    "droptype": "D",
    "dropname": "SHELBINA",
    "dropdeladd": "107 E CHESTNUT ST",
    "dropdelcty": "SHELBINA",
    "dropdelst": "MO",
    "dropdelzpp": 634689998,
    "dropphyadd": "107 E CHESTNUT ST",
    "dropphycty": "SHELBINA",
    "dropphyst": "MO",
    "dropphyzpp": 634689998,
    "dropmaladd": "107 E CHESTNUT ST",
    "dropmalcty": "SHELBINA",
    "dropmalst": "MO",
    "dropmalzpp": 634689998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735884118,
    "dropsitcph": 5735884118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17912",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "108 E 3RD ST",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 634699998,
    "dropphyadd": "108 E 3RD ST",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 634699998,
    "dropmaladd": "108 E 3RD ST",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 634699998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736332240,
    "dropsitcph": 5736332240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17913",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "300 W MAIN ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "MO",
    "dropdelzpp": 647849998,
    "dropphyadd": "300 W MAIN ST",
    "dropphycty": "SHELDON",
    "dropphyst": "MO",
    "dropphyzpp": 647849998,
    "dropmaladd": "300 W MAIN ST",
    "dropmalcty": "SHELDON",
    "dropmalst": "MO",
    "dropmalzpp": 647849998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178845121,
    "dropsitcph": 4178845121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17914",
    "droptype": "D",
    "dropname": "SHELL KNOB",
    "dropdeladd": "24847 STATE HIGHWAY 39",
    "dropdelcty": "SHELL KNOB",
    "dropdelst": "MO",
    "dropdelzpp": 657479998,
    "dropphyadd": "24847 STATE HIGHWAY 39",
    "dropphycty": "SHELL KNOB",
    "dropphyst": "MO",
    "dropphyzpp": 657479998,
    "dropmaladd": "24847 STATE HIGHWAY 39",
    "dropmalcty": "SHELL KNOB",
    "dropmalst": "MO",
    "dropmalzpp": 657479998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178586485,
    "dropsitcph": 4178586485,
    "dropfax": 4178589215
  },
  {
    "dcode": "D",
    "dropkey": "PW17916",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "126 W JEFFERSON ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "MO",
    "dropdelzpp": 644869998,
    "dropphyadd": "126 W JEFFERSON ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "MO",
    "dropphyzpp": 644869998,
    "dropmaladd": "126 W JEFFERSON ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "MO",
    "dropmalzpp": 644869998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607992695,
    "dropsitcph": 6607992695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17923",
    "droptype": "D",
    "dropname": "SIBLEY",
    "dropdeladd": "100 CHICAGO AVE",
    "dropdelcty": "SIBLEY",
    "dropdelst": "MO",
    "dropdelzpp": 640889998,
    "dropphyadd": "100 CHICAGO AVE",
    "dropphycty": "SIBLEY",
    "dropphyst": "MO",
    "dropphyzpp": 640889998,
    "dropmaladd": "100 CHICAGO AVE",
    "dropmalcty": "SIBLEY",
    "dropmalst": "MO",
    "dropmalzpp": 640889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166503704,
    "dropsitcph": 8166503704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17925",
    "droptype": "D",
    "dropname": "SIKESTON",
    "dropdeladd": "120 E NORTH ST",
    "dropdelcty": "SIKESTON",
    "dropdelst": "MO",
    "dropdelzpp": 638019998,
    "dropphyadd": "120 E NORTH ST",
    "dropphycty": "SIKESTON",
    "dropphyst": "MO",
    "dropphyzpp": 638019998,
    "dropmaladd": "120 E NORTH ST",
    "dropmalcty": "SIKESTON",
    "dropmalst": "MO",
    "dropmalzpp": 638019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734715231,
    "dropsitcph": 5734715231,
    "dropfax": 5734710606
  },
  {
    "dcode": "D",
    "dropkey": "PW17926",
    "droptype": "D",
    "dropname": "SILEX",
    "dropdeladd": "52 DUNCAN MANSION DR",
    "dropdelcty": "SILEX",
    "dropdelst": "MO",
    "dropdelzpp": 633779998,
    "dropphyadd": "52 DUNCAN MANSION DR",
    "dropphycty": "SILEX",
    "dropphyst": "MO",
    "dropphyzpp": 633779998,
    "dropmaladd": "52 DUNCAN MANSION DR",
    "dropmalcty": "SILEX",
    "dropmalst": "MO",
    "dropmalzpp": 633779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733845311,
    "dropsitcph": 5733845311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17928",
    "droptype": "D",
    "dropname": "SILVA",
    "dropdeladd": "662 WAYNE 219",
    "dropdelcty": "SILVA",
    "dropdelst": "MO",
    "dropdelzpp": 639649998,
    "dropphyadd": "662 WAYNE 219",
    "dropphycty": "SILVA",
    "dropphyst": "MO",
    "dropphyzpp": 639649998,
    "dropmaladd": "662 WAYNE 219",
    "dropmalcty": "SILVA",
    "dropmalst": "MO",
    "dropmalzpp": 639649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732243870,
    "dropsitcph": 5732243870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17933",
    "droptype": "D",
    "dropname": "SKIDMORE",
    "dropdeladd": "305 E ELM ST",
    "dropdelcty": "SKIDMORE",
    "dropdelst": "MO",
    "dropdelzpp": 644879998,
    "dropphyadd": "305 E ELM ST",
    "dropphycty": "SKIDMORE",
    "dropphyst": "MO",
    "dropphyzpp": 644879998,
    "dropmaladd": "305 E ELM ST",
    "dropmalcty": "SKIDMORE",
    "dropmalst": "MO",
    "dropmalzpp": 644879998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609283218,
    "dropsitcph": 6609283218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17936",
    "droptype": "D",
    "dropname": "SLATER",
    "dropdeladd": "159 W MAPLE ST",
    "dropdelcty": "SLATER",
    "dropdelst": "MO",
    "dropdelzpp": 653499998,
    "dropphyadd": "159 W MAPLE ST",
    "dropphycty": "SLATER",
    "dropphyst": "MO",
    "dropphyzpp": 653499998,
    "dropmaladd": "159 W MAPLE ST",
    "dropmalcty": "SLATER",
    "dropmalst": "MO",
    "dropmalzpp": 653499998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6605292525,
    "dropsitcph": 6605292525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17939",
    "droptype": "D",
    "dropname": "SMITHTON",
    "dropdeladd": "104 S WALNUT AVE",
    "dropdelcty": "SMITHTON",
    "dropdelst": "MO",
    "dropdelzpp": 653509998,
    "dropphyadd": "104 S WALNUT AVE",
    "dropphycty": "SMITHTON",
    "dropphyst": "MO",
    "dropphyzpp": 653509998,
    "dropmaladd": "104 S WALNUT AVE",
    "dropmalcty": "SMITHTON",
    "dropmalst": "MO",
    "dropmalzpp": 653509998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603435330,
    "dropsitcph": 6603435330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17940",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "206 RICHARDSON ST",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 640899998,
    "dropphyadd": "206 RICHARDSON ST",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 640899998,
    "dropmaladd": "206 RICHARDSON ST",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 640899998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165320643,
    "dropsitcph": 8165320975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17960",
    "droptype": "D",
    "dropname": "SOUTH GREENFIELD",
    "dropdeladd": "400 PARK AVE",
    "dropdelcty": "SOUTH GREENFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 657529998,
    "dropphyadd": "400 PARK AVE",
    "dropphycty": "SOUTH GREENFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 657529998,
    "dropmaladd": "400 PARK AVE",
    "dropmalcty": "SOUTH GREENFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 657529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176375674,
    "dropsitcph": 4176375674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17969",
    "droptype": "D",
    "dropname": "SOUTH WEST CITY",
    "dropdeladd": "214 S MAIN ST",
    "dropdelcty": "SOUTH WEST CITY",
    "dropdelst": "MO",
    "dropdelzpp": 648639998,
    "dropphyadd": "214 S MAIN ST",
    "dropphycty": "SOUTH WEST CITY",
    "dropphyst": "MO",
    "dropphyzpp": 648639998,
    "dropmaladd": "214 S MAIN ST",
    "dropmalcty": "SOUTH WEST CITY",
    "dropmalst": "MO",
    "dropmalzpp": 648639998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177623300,
    "dropsitcph": 4177623300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17977",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "7060 STATE HIGHWAY 14 E",
    "dropdelcty": "SPARTA",
    "dropdelst": "MO",
    "dropdelzpp": 657539998,
    "dropphyadd": "7060 STATE HIGHWAY 14 E",
    "dropphycty": "SPARTA",
    "dropphyst": "MO",
    "dropphyzpp": 657539998,
    "dropmaladd": "7060 STATE HIGHWAY 14 E",
    "dropmalcty": "SPARTA",
    "dropmalst": "MO",
    "dropmalzpp": 657539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176343898,
    "dropsitcph": 4176343898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17982",
    "droptype": "D",
    "dropname": "SPICKARD",
    "dropdeladd": "303 N 2ND ST",
    "dropdelcty": "SPICKARD",
    "dropdelst": "MO",
    "dropdelzpp": 646799998,
    "dropphyadd": "303 N 2ND ST",
    "dropphycty": "SPICKARD",
    "dropphyst": "MO",
    "dropphyzpp": 646799998,
    "dropmaladd": "303 N 2ND ST",
    "dropmalcty": "SPICKARD",
    "dropmalst": "MO",
    "dropmalzpp": 646799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604856712,
    "dropsitcph": 6604856712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17983",
    "droptype": "D",
    "dropname": "SPOKANE",
    "dropdeladd": "745 SPOKANE RD",
    "dropdelcty": "SPOKANE",
    "dropdelst": "MO",
    "dropdelzpp": 657549998,
    "dropphyadd": "745 SPOKANE RD",
    "dropphycty": "SPOKANE",
    "dropphyst": "MO",
    "dropphyzpp": 657549998,
    "dropmaladd": "745 SPOKANE RD",
    "dropmalcty": "SPOKANE",
    "dropmalst": "MO",
    "dropmalzpp": 657549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175873035,
    "dropsitcph": 4175873035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW17989",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "500 W CHESTNUT EXPY",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658019998,
    "dropphyadd": "500 W CHESTNUT EXPY",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658019998,
    "dropmaladd": "500 W CHESTNUT EXPY",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178640153,
    "dropsitcph": 4178640199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18011",
    "droptype": "D",
    "dropname": "SQUIRES",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SQUIRES",
    "dropdelst": "MO",
    "dropdelzpp": 657559998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SQUIRES",
    "dropphyst": "MO",
    "dropphyzpp": 657559998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "SQUIRES",
    "dropmalst": "MO",
    "dropmalzpp": 657559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176835959,
    "dropsitcph": 4176835959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18279",
    "droptype": "D",
    "dropname": "STANBERRY",
    "dropdeladd": "220 N PARK ST",
    "dropdelcty": "STANBERRY",
    "dropdelst": "MO",
    "dropdelzpp": 644899998,
    "dropphyadd": "220 N PARK ST",
    "dropphycty": "STANBERRY",
    "dropphyst": "MO",
    "dropphyzpp": 644899998,
    "dropmaladd": "220 N PARK ST",
    "dropmalcty": "STANBERRY",
    "dropmalst": "MO",
    "dropmalzpp": 644899998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607832660,
    "dropsitcph": 6607832660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18281",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "51 HIGHWAY W",
    "dropdelcty": "STANTON",
    "dropdelst": "MO",
    "dropdelzpp": 630799998,
    "dropphyadd": "51 HIGHWAY W",
    "dropphycty": "STANTON",
    "dropphyst": "MO",
    "dropphyzpp": 630799998,
    "dropmaladd": "51 HIGHWAY W",
    "dropmalcty": "STANTON",
    "dropmalst": "MO",
    "dropmalzpp": 630799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5739275330,
    "dropsitcph": 5739275330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18282",
    "droptype": "D",
    "dropname": "STARK CITY",
    "dropdeladd": "302 KENT ST",
    "dropdelcty": "STARK CITY",
    "dropdelst": "MO",
    "dropdelzpp": 648669998,
    "dropphyadd": "302 KENT ST",
    "dropphycty": "STARK CITY",
    "dropphyst": "MO",
    "dropphyzpp": 648669998,
    "dropmaladd": "302 KENT ST",
    "dropmalcty": "STARK CITY",
    "dropmalst": "MO",
    "dropmalzpp": 648669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176385622,
    "dropsitcph": 4176385622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18325",
    "droptype": "D",
    "dropname": "STEEDMAN",
    "dropdeladd": "9635 STATE ROAD CC",
    "dropdelcty": "STEEDMAN",
    "dropdelst": "MO",
    "dropdelzpp": 650779998,
    "dropphyadd": "9635 STATE ROAD CC",
    "dropphycty": "STEEDMAN",
    "dropphyst": "MO",
    "dropphyzpp": 650779998,
    "dropmaladd": "9635 STATE ROAD CC",
    "dropmalcty": "STEEDMAN",
    "dropmalst": "MO",
    "dropmalzpp": 650779998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736765717,
    "dropsitcph": 5736765717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18326",
    "droptype": "D",
    "dropname": "STEELE",
    "dropdeladd": "301 S 1ST ST",
    "dropdelcty": "STEELE",
    "dropdelst": "MO",
    "dropdelzpp": 638779998,
    "dropphyadd": "301 S 1ST ST",
    "dropphycty": "STEELE",
    "dropphyst": "MO",
    "dropphyzpp": 638779998,
    "dropmaladd": "301 S 1ST ST",
    "dropmalcty": "STEELE",
    "dropmalst": "MO",
    "dropmalzpp": 638779998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736953532,
    "dropsitcph": 5736953532,
    "dropfax": 5736951721
  },
  {
    "dcode": "D",
    "dropkey": "PW18327",
    "droptype": "D",
    "dropname": "STEELVILLE",
    "dropdeladd": "204 S 1ST ST",
    "dropdelcty": "STEELVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 655659998,
    "dropphyadd": "204 S 1ST ST",
    "dropphycty": "STEELVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 655659998,
    "dropmaladd": "204 S 1ST ST",
    "dropmalcty": "STEELVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 655659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737752842,
    "dropsitcph": 5737752842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18330",
    "droptype": "D",
    "dropname": "STELLA",
    "dropdeladd": "774 OZARK ST",
    "dropdelcty": "STELLA",
    "dropdelst": "MO",
    "dropdelzpp": 648679998,
    "dropphyadd": "774 OZARK ST",
    "dropphycty": "STELLA",
    "dropphyst": "MO",
    "dropphyzpp": 648679998,
    "dropmaladd": "774 OZARK ST",
    "dropmalcty": "STELLA",
    "dropmalst": "MO",
    "dropmalzpp": 648679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176283939,
    "dropsitcph": 4176283939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18334",
    "droptype": "D",
    "dropname": "STEWARTSVILLE",
    "dropdeladd": "406 MAIN ST",
    "dropdelcty": "STEWARTSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 644909998,
    "dropphyadd": "406 MAIN ST",
    "dropphycty": "STEWARTSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 644909998,
    "dropmaladd": "406 MAIN ST",
    "dropmalcty": "STEWARTSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 644909998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166693775,
    "dropsitcph": 8166693775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18337",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "406 EAST ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "MO",
    "dropdelzpp": 657859998,
    "dropphyadd": "406 EAST ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "MO",
    "dropphyzpp": 657859998,
    "dropmaladd": "406 EAST ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "MO",
    "dropmalzpp": 657859998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172763316,
    "dropfax": 4172766514
  },
  {
    "dcode": "D",
    "dropkey": "PW18346",
    "droptype": "D",
    "dropname": "STOTTS CITY",
    "dropdeladd": "107 E MOUNT VERNON ST",
    "dropdelcty": "STOTTS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 657569998,
    "dropphyadd": "107 E MOUNT VERNON ST",
    "dropphycty": "STOTTS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 657569998,
    "dropmaladd": "107 E MOUNT VERNON ST",
    "dropmalcty": "STOTTS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 657569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172854255,
    "dropsitcph": 4172854255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18349",
    "droptype": "D",
    "dropname": "STOUTLAND",
    "dropdeladd": "40 E STATE ROAD H",
    "dropdelcty": "STOUTLAND",
    "dropdelst": "MO",
    "dropdelzpp": 655679998,
    "dropphyadd": "40 E STATE ROAD H",
    "dropphycty": "STOUTLAND",
    "dropphyst": "MO",
    "dropphyzpp": 655679998,
    "dropmaladd": "40 E STATE ROAD H",
    "dropmalcty": "STOUTLAND",
    "dropmalst": "MO",
    "dropmalzpp": 655679998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172863511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18350",
    "droptype": "D",
    "dropname": "STOUTSVILLE",
    "dropdeladd": "24599 MONROE ROAD 473",
    "dropdelcty": "STOUTSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 652839998,
    "dropphyadd": "24599 MONROE ROAD 473",
    "dropphycty": "STOUTSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 652839998,
    "dropmaladd": "24599 MONROE ROAD 473",
    "dropmalcty": "STOUTSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 652839998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736723311,
    "dropsitcph": 5736723311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18353",
    "droptype": "D",
    "dropname": "STOVER",
    "dropdeladd": "300 W 2ND ST",
    "dropdelcty": "STOVER",
    "dropdelst": "MO",
    "dropdelzpp": 650789998,
    "dropphyadd": "300 W 2ND ST",
    "dropphycty": "STOVER",
    "dropphyst": "MO",
    "dropphyzpp": 650789998,
    "dropmaladd": "300 W 2ND ST",
    "dropmalcty": "STOVER",
    "dropmalst": "MO",
    "dropmalzpp": 650789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733772312,
    "dropsitcph": 5733772312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18354",
    "droptype": "D",
    "dropname": "STRAFFORD",
    "dropdeladd": "125 S WASHINGTON ST",
    "dropdelcty": "STRAFFORD",
    "dropdelst": "MO",
    "dropdelzpp": 657579998,
    "dropphyadd": "125 S WASHINGTON ST",
    "dropphycty": "STRAFFORD",
    "dropphyst": "MO",
    "dropphyzpp": 657579998,
    "dropmaladd": "125 S WASHINGTON ST",
    "dropmalcty": "STRAFFORD",
    "dropmalst": "MO",
    "dropmalzpp": 657579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177362684,
    "dropsitcph": 4177362684,
    "dropfax": 4177369343
  },
  {
    "dcode": "D",
    "dropkey": "PW18360",
    "droptype": "D",
    "dropname": "STURDIVANT",
    "dropdeladd": "100 COUNTY ROAD 636",
    "dropdelcty": "STURDIVANT",
    "dropdelst": "MO",
    "dropdelzpp": 637829998,
    "dropphyadd": "100 COUNTY ROAD 636",
    "dropphycty": "STURDIVANT",
    "dropphyst": "MO",
    "dropphyzpp": 637829998,
    "dropmaladd": "100 COUNTY ROAD 636",
    "dropmalcty": "STURDIVANT",
    "dropmalst": "MO",
    "dropmalzpp": 637829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737225579,
    "dropsitcph": 5737225579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18361",
    "droptype": "D",
    "dropname": "STURGEON",
    "dropdeladd": "111 N WENTZ ST",
    "dropdelcty": "STURGEON",
    "dropdelst": "MO",
    "dropdelzpp": 652849998,
    "dropphyadd": "111 N WENTZ ST",
    "dropphycty": "STURGEON",
    "dropphyst": "MO",
    "dropphyzpp": 652849998,
    "dropmaladd": "111 N WENTZ ST",
    "dropmalcty": "STURGEON",
    "dropmalst": "MO",
    "dropmalzpp": 652849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736873885,
    "dropsitcph": 5736873885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18363",
    "droptype": "D",
    "dropname": "SUCCESS",
    "dropdeladd": "10798 HIGHWAY 17",
    "dropdelcty": "SUCCESS",
    "dropdelst": "MO",
    "dropdelzpp": 655709998,
    "dropphyadd": "10798 HIGHWAY 17",
    "dropphycty": "SUCCESS",
    "dropphyst": "MO",
    "dropphyzpp": 655709998,
    "dropmaladd": "10798 HIGHWAY 17",
    "dropmalcty": "SUCCESS",
    "dropmalst": "MO",
    "dropmalzpp": 655709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174584381,
    "dropsitcph": 4174584381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18366",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "33 W VINE ST",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "MO",
    "dropdelzpp": 630809998,
    "dropphyadd": "33 W VINE ST",
    "dropphycty": "SULLIVAN",
    "dropphyst": "MO",
    "dropphyzpp": 630809998,
    "dropmaladd": "33 W VINE ST",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "MO",
    "dropmalzpp": 630809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734684513,
    "dropsitcph": 5734684513,
    "dropfax": 6519943423
  },
  {
    "dcode": "D",
    "dropkey": "PW18372",
    "droptype": "D",
    "dropname": "SUMMERSVILLE",
    "dropdeladd": "485 2ND ST",
    "dropdelcty": "SUMMERSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 655719998,
    "dropphyadd": "485 2ND ST",
    "dropphycty": "SUMMERSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 655719998,
    "dropmaladd": "485 2ND ST",
    "dropmalcty": "SUMMERSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 655719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4179324622,
    "dropsitcph": 4179324622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18375",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "200 W CENTRE ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "MO",
    "dropdelzpp": 646819998,
    "dropphyadd": "200 W CENTRE ST",
    "dropphycty": "SUMNER",
    "dropphyst": "MO",
    "dropphyzpp": 646819998,
    "dropmaladd": "200 W CENTRE ST",
    "dropmalcty": "SUMNER",
    "dropmalst": "MO",
    "dropmalzpp": 646819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6608563335,
    "dropsitcph": 6608563335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18378",
    "droptype": "D",
    "dropname": "SUNRISE BEACH",
    "dropdeladd": "14190 N STATE HIGHWAY 5",
    "dropdelcty": "SUNRISE BEACH",
    "dropdelst": "MO",
    "dropdelzpp": 650799998,
    "dropphyadd": "14190 N STATE HIGHWAY 5",
    "dropphycty": "SUNRISE BEACH",
    "dropphyst": "MO",
    "dropphyzpp": 650799998,
    "dropmaladd": "14190 N STATE HIGHWAY 5",
    "dropmalcty": "SUNRISE BEACH",
    "dropmalst": "MO",
    "dropmalzpp": 650799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733747993,
    "dropsitcph": 5733747993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18385",
    "droptype": "D",
    "dropname": "SWEET SPRINGS",
    "dropdeladd": "311 SPRING ST",
    "dropdelcty": "SWEET SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 653519998,
    "dropphyadd": "311 SPRING ST",
    "dropphycty": "SWEET SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 653519998,
    "dropmaladd": "311 SPRING ST",
    "dropmalcty": "SWEET SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 653519998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6603354211,
    "dropsitcph": 6603354211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18392",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "214 E FRONT ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "MO",
    "dropdelzpp": 653549998,
    "dropphyadd": "214 E FRONT ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "MO",
    "dropphyzpp": 653549998,
    "dropmaladd": "214 E FRONT ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "MO",
    "dropmalzpp": 653549998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6602983429,
    "dropsitcph": 6602983429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18427",
    "droptype": "D",
    "dropname": "TALLAPOOSA",
    "dropdeladd": "308 1ST ST",
    "dropdelcty": "TALLAPOOSA",
    "dropdelst": "MO",
    "dropdelzpp": 638789998,
    "dropphyadd": "308 1ST ST",
    "dropphycty": "TALLAPOOSA",
    "dropphyst": "MO",
    "dropphyzpp": 638789998,
    "dropmaladd": "308 1ST ST",
    "dropmalcty": "TALLAPOOSA",
    "dropmalst": "MO",
    "dropmalzpp": 638789998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733965865,
    "dropsitcph": 5733965865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18428",
    "droptype": "D",
    "dropname": "TANEYVILLE",
    "dropdeladd": "310 GRAND AVE",
    "dropdelcty": "TANEYVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 657599998,
    "dropphyadd": "310 GRAND AVE",
    "dropphycty": "TANEYVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 657599998,
    "dropmaladd": "310 GRAND AVE",
    "dropmalcty": "TANEYVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 657599998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175464848,
    "dropsitcph": 4175464848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18433",
    "droptype": "D",
    "dropname": "TARKIO",
    "dropdeladd": "505 MAIN ST",
    "dropdelcty": "TARKIO",
    "dropdelst": "MO",
    "dropdelzpp": 644919998,
    "dropphyadd": "505 MAIN ST",
    "dropphycty": "TARKIO",
    "dropphyst": "MO",
    "dropphyzpp": 644919998,
    "dropmaladd": "505 MAIN ST",
    "dropmalcty": "TARKIO",
    "dropmalst": "MO",
    "dropmalzpp": 644919998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607364257,
    "dropsitcph": 6607364257,
    "dropfax": 6607365768
  },
  {
    "dcode": "D",
    "dropkey": "PW18435",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "250 COUNTY ROAD 313",
    "dropdelcty": "TAYLOR",
    "dropdelst": "MO",
    "dropdelzpp": 634719998,
    "dropphyadd": "250 COUNTY ROAD 313",
    "dropphycty": "TAYLOR",
    "dropphyst": "MO",
    "dropphyzpp": 634719998,
    "dropmaladd": "250 COUNTY ROAD 313",
    "dropmalcty": "TAYLOR",
    "dropmalst": "MO",
    "dropmalzpp": 634719998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733932154,
    "dropsitcph": 5733932154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18436",
    "droptype": "D",
    "dropname": "TEBBETTS",
    "dropdeladd": "5599 COUNTY ROAD 4011",
    "dropdelcty": "TEBBETTS",
    "dropdelst": "MO",
    "dropdelzpp": 650809998,
    "dropphyadd": "5599 COUNTY ROAD 4011",
    "dropphycty": "TEBBETTS",
    "dropphyst": "MO",
    "dropphyzpp": 650809998,
    "dropmaladd": "5599 COUNTY ROAD 4011",
    "dropmalcty": "TEBBETTS",
    "dropmalst": "MO",
    "dropmalzpp": 650809998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732954866,
    "dropsitcph": 5732954866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18437",
    "droptype": "D",
    "dropname": "TECUMSEH",
    "dropdeladd": "33256 US HIGHWAY 160",
    "dropdelcty": "TECUMSEH",
    "dropdelst": "MO",
    "dropdelzpp": 657609998,
    "dropphyadd": "33256 US HIGHWAY 160",
    "dropphycty": "TECUMSEH",
    "dropphyst": "MO",
    "dropphyzpp": 657609998,
    "dropmaladd": "33256 US HIGHWAY 160",
    "dropmalcty": "TECUMSEH",
    "dropmalst": "MO",
    "dropmalzpp": 657609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172943996,
    "dropsitcph": 4172843996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18440",
    "droptype": "D",
    "dropname": "THAYER",
    "dropdeladd": "118 N 2ND ST",
    "dropdelcty": "THAYER",
    "dropdelst": "MO",
    "dropdelzpp": 657919998,
    "dropphyadd": "118 N 2ND ST",
    "dropphycty": "THAYER",
    "dropphyst": "MO",
    "dropphyzpp": 657919998,
    "dropmaladd": "118 N 2ND ST",
    "dropmalcty": "THAYER",
    "dropmalst": "MO",
    "dropmalzpp": 657919998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172647921,
    "dropsitcph": 4172647921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18441",
    "droptype": "D",
    "dropname": "THEODOSIA",
    "dropdeladd": "5625 US HIGHWAY 160",
    "dropdelcty": "THEODOSIA",
    "dropdelst": "MO",
    "dropdelzpp": 657619998,
    "dropphyadd": "5625 US HIGHWAY 160",
    "dropphycty": "THEODOSIA",
    "dropphyst": "MO",
    "dropphyzpp": 657619998,
    "dropmaladd": "5625 US HIGHWAY 160",
    "dropmalcty": "THEODOSIA",
    "dropmalst": "MO",
    "dropmalzpp": 657619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172734936,
    "dropsitcph": 4172734936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18444",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "10339 AUDRAIN ROAD 945",
    "dropdelcty": "THOMPSON",
    "dropdelst": "MO",
    "dropdelzpp": 652859998,
    "dropphyadd": "10339 AUDRAIN ROAD 945",
    "dropphycty": "THOMPSON",
    "dropphyst": "MO",
    "dropphyzpp": 652859998,
    "dropmaladd": "10339 AUDRAIN ROAD 945",
    "dropmalcty": "THOMPSON",
    "dropmalst": "MO",
    "dropmalzpp": 652859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735817690,
    "dropsitcph": 5735817690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18445",
    "droptype": "D",
    "dropname": "THORNFIELD",
    "dropdeladd": "13 COUNTY ROAD 916",
    "dropdelcty": "THORNFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 657629998,
    "dropphyadd": "13 COUNTY ROAD 916",
    "dropphycty": "THORNFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 657629998,
    "dropmaladd": "13 COUNTY ROAD 916",
    "dropmalcty": "THORNFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 657629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4172653625,
    "dropsitcph": 4172653625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18446",
    "droptype": "D",
    "dropname": "TIFF",
    "dropdeladd": "13528 TIFF LN",
    "dropdelcty": "TIFF",
    "dropdelst": "MO",
    "dropdelzpp": 636749998,
    "dropphyadd": "13528 TIFF LN",
    "dropphycty": "TIFF",
    "dropphyst": "MO",
    "dropphyzpp": 636749998,
    "dropmaladd": "13528 TIFF LN",
    "dropmalcty": "TIFF",
    "dropmalst": "MO",
    "dropmalzpp": 636749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6365865620,
    "dropsitcph": 6365865620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18447",
    "droptype": "D",
    "dropname": "TIFF CITY",
    "dropdeladd": "10703 W STATE HIGHWAY 76",
    "dropdelcty": "TIFF CITY",
    "dropdelst": "MO",
    "dropdelzpp": 648689998,
    "dropphyadd": "10703 W STATE HIGHWAY 76",
    "dropphycty": "TIFF CITY",
    "dropphyst": "MO",
    "dropphyzpp": 648689998,
    "dropmaladd": "10703 W STATE HIGHWAY 76",
    "dropmalcty": "TIFF CITY",
    "dropmalst": "MO",
    "dropmalzpp": 648689998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4177752301,
    "dropsitcph": 4177752301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18454",
    "droptype": "D",
    "dropname": "TINA",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "TINA",
    "dropdelst": "MO",
    "dropdelzpp": 646829998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "TINA",
    "dropphyst": "MO",
    "dropphyzpp": 646829998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "TINA",
    "dropmalst": "MO",
    "dropmalzpp": 646829998,
    "dropsitphn": 8166224281,
    "dropsitlph": 6606224281,
    "dropsitcph": 6606224281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18455",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "235 S OSAGE AVE",
    "dropdelcty": "TIPTON",
    "dropdelst": "MO",
    "dropdelzpp": 650819998,
    "dropphyadd": "235 S OSAGE AVE",
    "dropphycty": "TIPTON",
    "dropphyst": "MO",
    "dropphyzpp": 650819998,
    "dropmaladd": "235 S OSAGE AVE",
    "dropmalcty": "TIPTON",
    "dropmalst": "MO",
    "dropmalzpp": 650819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604332331,
    "dropsitcph": 6604332331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18462",
    "droptype": "D",
    "dropname": "TRELOAR",
    "dropdeladd": "21797 M K T ST",
    "dropdelcty": "TRELOAR",
    "dropdelst": "MO",
    "dropdelzpp": 633789998,
    "dropphyadd": "21797 M K T ST",
    "dropphycty": "TRELOAR",
    "dropphyst": "MO",
    "dropphyzpp": 633789998,
    "dropmaladd": "21797 M K T ST",
    "dropmalcty": "TRELOAR",
    "dropmalst": "MO",
    "dropmalzpp": 633789998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369324227,
    "dropsitcph": 6369324227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18463",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "201 W 11TH ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "MO",
    "dropdelzpp": 646839998,
    "dropphyadd": "201 W 11TH ST",
    "dropphycty": "TRENTON",
    "dropphyst": "MO",
    "dropphyzpp": 646839998,
    "dropmaladd": "201 W 11TH ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "MO",
    "dropmalzpp": 646839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6603595674,
    "dropsitcph": 6603595674,
    "dropfax": 6603599994
  },
  {
    "dcode": "D",
    "dropkey": "PW18464",
    "droptype": "D",
    "dropname": "TRIMBLE",
    "dropdeladd": "304 N 169 HWY",
    "dropdelcty": "TRIMBLE",
    "dropdelst": "MO",
    "dropdelzpp": 644929998,
    "dropphyadd": "304 N 169 HWY",
    "dropphycty": "TRIMBLE",
    "dropphyst": "MO",
    "dropphyzpp": 644929998,
    "dropmaladd": "304 N 169 HWY",
    "dropmalcty": "TRIMBLE",
    "dropmalst": "MO",
    "dropmalzpp": 644929998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163702278,
    "dropsitcph": 8163702278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18466",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "350 E CHERRY ST",
    "dropdelcty": "TROY",
    "dropdelst": "MO",
    "dropdelzpp": 633799998,
    "dropphyadd": "350 E CHERRY ST",
    "dropphycty": "TROY",
    "dropphyst": "MO",
    "dropphyzpp": 633799998,
    "dropmaladd": "350 E CHERRY ST",
    "dropmalcty": "TROY",
    "dropmalst": "MO",
    "dropmalzpp": 633799998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365284800,
    "dropsitcph": 6365284800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18469",
    "droptype": "D",
    "dropname": "TRUXTON",
    "dropdeladd": "199 MAIN ST",
    "dropdelcty": "TRUXTON",
    "dropdelst": "MO",
    "dropdelzpp": 633819998,
    "dropphyadd": "199 MAIN ST",
    "dropphycty": "TRUXTON",
    "dropphyst": "MO",
    "dropphyzpp": 633819998,
    "dropmaladd": "199 MAIN ST",
    "dropmalcty": "TRUXTON",
    "dropmalst": "MO",
    "dropmalzpp": 633819998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365973010,
    "dropsitcph": 6365973010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18470",
    "droptype": "D",
    "dropname": "TUNAS",
    "dropdeladd": "4 STATE RD E",
    "dropdelcty": "TUNAS",
    "dropdelst": "MO",
    "dropdelzpp": 657649998,
    "dropphyadd": "4 STATE RD E",
    "dropphycty": "TUNAS",
    "dropphyst": "MO",
    "dropphyzpp": 657649998,
    "dropmaladd": "4 STATE RD E",
    "dropmalcty": "TUNAS",
    "dropmalst": "MO",
    "dropmalzpp": 657649998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4179934668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18471",
    "droptype": "D",
    "dropname": "TURNERS",
    "dropdeladd": "6480 E FARM ROAD 148",
    "dropdelcty": "TURNERS",
    "dropdelst": "MO",
    "dropdelzpp": 657659998,
    "dropphyadd": "6480 E FARM ROAD 148",
    "dropphycty": "TURNERS",
    "dropphyst": "MO",
    "dropphyzpp": 657659998,
    "dropmaladd": "6480 E FARM ROAD 148",
    "dropmalcty": "TURNERS",
    "dropmalst": "MO",
    "dropmalzpp": 657659998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4178816905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18472",
    "droptype": "D",
    "dropname": "TURNEY",
    "dropdeladd": "205 SHERMAN ST",
    "dropdelcty": "TURNEY",
    "dropdelst": "MO",
    "dropdelzpp": 644939998,
    "dropphyadd": "205 SHERMAN ST",
    "dropphycty": "TURNEY",
    "dropphyst": "MO",
    "dropphyzpp": 644939998,
    "dropmaladd": "205 SHERMAN ST",
    "dropmalcty": "TURNEY",
    "dropmalst": "MO",
    "dropmalzpp": 644939998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166642125,
    "dropsitcph": 8166642125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18473",
    "droptype": "D",
    "dropname": "TUSCUMBIA",
    "dropdeladd": "1972 HIGHWAY 52",
    "dropdelcty": "TUSCUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 650829998,
    "dropphyadd": "1972 HIGHWAY 52",
    "dropphycty": "TUSCUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 650829998,
    "dropmaladd": "1972 HIGHWAY 52",
    "dropmalcty": "TUSCUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 650829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733692309,
    "dropsitcph": 5733692309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18487",
    "droptype": "D",
    "dropname": "ULMAN",
    "dropdeladd": "357 HIGHWAY C",
    "dropdelcty": "ULMAN",
    "dropdelst": "MO",
    "dropdelzpp": 650839998,
    "dropphyadd": "357 HIGHWAY C",
    "dropphycty": "ULMAN",
    "dropphyst": "MO",
    "dropphyzpp": 650839998,
    "dropmaladd": "357 HIGHWAY C",
    "dropmalcty": "ULMAN",
    "dropmalst": "MO",
    "dropmalzpp": 650839998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733692821,
    "dropsitcph": 5733692821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18490",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "1276 N HIGHWAY 47",
    "dropdelcty": "UNION",
    "dropdelst": "MO",
    "dropdelzpp": 630849998,
    "dropphyadd": "1276 N HIGHWAY 47",
    "dropphycty": "UNION",
    "dropphyst": "MO",
    "dropphyzpp": 630849998,
    "dropmaladd": "1276 N HIGHWAY 47",
    "dropmalcty": "UNION",
    "dropmalst": "MO",
    "dropmalzpp": 630849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365832442,
    "dropsitcph": 6365832442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18492",
    "droptype": "D",
    "dropname": "UNION STAR",
    "dropdeladd": "335 CEDAR ST",
    "dropdelcty": "UNION STAR",
    "dropdelst": "MO",
    "dropdelzpp": 644949998,
    "dropphyadd": "335 CEDAR ST",
    "dropphycty": "UNION STAR",
    "dropphyst": "MO",
    "dropphyzpp": 644949998,
    "dropmaladd": "335 CEDAR ST",
    "dropmalcty": "UNION STAR",
    "dropmalst": "MO",
    "dropmalzpp": 644949998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165932525,
    "dropsitcph": 8165932525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18494",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "1603 GRANT ST",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 635659998,
    "dropphyadd": "1603 GRANT ST",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 635659998,
    "dropmaladd": "1603 GRANT ST",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 635659998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6609472527,
    "dropsitcph": 6609472527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18510",
    "droptype": "D",
    "dropname": "URBANA",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "URBANA",
    "dropdelst": "MO",
    "dropdelzpp": 657679998,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "URBANA",
    "dropphyst": "MO",
    "dropphyzpp": 657679998,
    "dropmaladd": "200 N MAIN ST",
    "dropmalcty": "URBANA",
    "dropmalst": "MO",
    "dropmalzpp": 657679998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4179934653,
    "dropfax": 4179934770
  },
  {
    "dcode": "D",
    "dropkey": "PW18512",
    "droptype": "D",
    "dropname": "URICH",
    "dropdeladd": "310 N MAIN ST",
    "dropdelcty": "URICH",
    "dropdelst": "MO",
    "dropdelzpp": 647889998,
    "dropphyadd": "310 N MAIN ST",
    "dropphycty": "URICH",
    "dropphyst": "MO",
    "dropphyzpp": 647889998,
    "dropmaladd": "310 N MAIN ST",
    "dropmalcty": "URICH",
    "dropmalst": "MO",
    "dropmalzpp": 647889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606384617,
    "dropsitcph": 6606384617,
    "dropfax": 8166384851
  },
  {
    "dcode": "D",
    "dropkey": "PW18514",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "509 W THROOP ST",
    "dropdelcty": "UTICA",
    "dropdelst": "MO",
    "dropdelzpp": 646869998,
    "dropphyadd": "509 W THROOP ST",
    "dropphycty": "UTICA",
    "dropphyst": "MO",
    "dropphyzpp": 646869998,
    "dropmaladd": "509 W THROOP ST",
    "dropmalcty": "UTICA",
    "dropmalst": "MO",
    "dropmalzpp": 646869998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606464337,
    "dropsitcph": 6606464337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18516",
    "droptype": "D",
    "dropname": "VALLES MINES",
    "dropdeladd": "3225 STATE ROAD V",
    "dropdelcty": "VALLES MINES",
    "dropdelst": "MO",
    "dropdelzpp": 630879998,
    "dropphyadd": "3225 STATE ROAD V",
    "dropphycty": "VALLES MINES",
    "dropphyst": "MO",
    "dropphyzpp": 630879998,
    "dropmaladd": "3225 STATE ROAD V",
    "dropmalcty": "VALLES MINES",
    "dropmalst": "MO",
    "dropmalzpp": 630879998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6365863069,
    "dropsitcph": 6365863069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18521",
    "droptype": "D",
    "dropname": "VALLEY PARK",
    "dropdeladd": "305 SAINT LOUIS AVE",
    "dropdelcty": "VALLEY PARK",
    "dropdelst": "MO",
    "dropdelzpp": 630889998,
    "dropphyadd": "305 SAINT LOUIS AVE",
    "dropphycty": "VALLEY PARK",
    "dropphyst": "MO",
    "dropphyzpp": 630889998,
    "dropmaladd": "305 SAINT LOUIS AVE",
    "dropmalcty": "VALLEY PARK",
    "dropmalst": "MO",
    "dropmalzpp": 630889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364353005,
    "dropsitcph": 6368614568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18524",
    "droptype": "D",
    "dropname": "VAN BUREN",
    "dropdeladd": "307 W OLIVER ST",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "MO",
    "dropdelzpp": 639659998,
    "dropphyadd": "307 W OLIVER ST",
    "dropphycty": "VAN BUREN",
    "dropphyst": "MO",
    "dropphyzpp": 639659998,
    "dropmaladd": "307 W OLIVER ST",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "MO",
    "dropmalzpp": 639659998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733234703,
    "dropsitcph": 5733234703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18526",
    "droptype": "D",
    "dropname": "VANDALIA",
    "dropdeladd": "401 S MAIN ST",
    "dropdelcty": "VANDALIA",
    "dropdelst": "MO",
    "dropdelzpp": 633829998,
    "dropphyadd": "401 S MAIN ST",
    "dropphycty": "VANDALIA",
    "dropphyst": "MO",
    "dropphyzpp": 633829998,
    "dropmaladd": "401 S MAIN ST",
    "dropmalcty": "VANDALIA",
    "dropmalst": "MO",
    "dropmalzpp": 633829998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5735942229,
    "dropsitcph": 5735942229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18528",
    "droptype": "D",
    "dropname": "VANDUSER",
    "dropdeladd": "902 VANDUSER ST",
    "dropdelcty": "VANDUSER",
    "dropdelst": "MO",
    "dropdelzpp": 637849998,
    "dropphyadd": "902 VANDUSER ST",
    "dropphycty": "VANDUSER",
    "dropphyst": "MO",
    "dropphyzpp": 637849998,
    "dropmaladd": "902 VANDUSER ST",
    "dropmalcty": "VANDUSER",
    "dropmalst": "MO",
    "dropmalzpp": 637849998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734717141,
    "dropsitcph": 5734717141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18536",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "170 S 3RD ST",
    "dropdelcty": "VERONA",
    "dropdelst": "MO",
    "dropdelzpp": 657699998,
    "dropphyadd": "170 S 3RD ST",
    "dropphycty": "VERONA",
    "dropphyst": "MO",
    "dropphyzpp": 657699998,
    "dropmaladd": "170 S 3RD ST",
    "dropmalcty": "VERONA",
    "dropmalst": "MO",
    "dropmalzpp": 657699998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174986550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18537",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "205 S MONROE ST",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "MO",
    "dropdelzpp": 650849998,
    "dropphyadd": "205 S MONROE ST",
    "dropphycty": "VERSAILLES",
    "dropphyst": "MO",
    "dropphyzpp": 650849998,
    "dropmaladd": "205 S MONROE ST",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "MO",
    "dropmalzpp": 650849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5733784949,
    "dropsitcph": 5733784949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18540",
    "droptype": "D",
    "dropname": "VICHY",
    "dropdeladd": "14788 HIGHWAY 63 S",
    "dropdelcty": "VICHY",
    "dropdelst": "MO",
    "dropdelzpp": 655809998,
    "dropphyadd": "14788 HIGHWAY 63 S",
    "dropphycty": "VICHY",
    "dropphyst": "MO",
    "dropphyzpp": 655809998,
    "dropmaladd": "14788 HIGHWAY 63 S",
    "dropmalcty": "VICHY",
    "dropmalst": "MO",
    "dropmalzpp": 655809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732990017,
    "dropsitcph": 5732990017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18541",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "MO",
    "dropdelzpp": 655829998,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "VIENNA",
    "dropphyst": "MO",
    "dropphyzpp": 655829998,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "VIENNA",
    "dropmalst": "MO",
    "dropmalzpp": 655829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5734223446,
    "dropsitcph": 5734223446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18544",
    "droptype": "D",
    "dropname": "VILLA RIDGE",
    "dropdeladd": "461 HIGHWAY M",
    "dropdelcty": "VILLA RIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 630899998,
    "dropphyadd": "461 HIGHWAY M",
    "dropphycty": "VILLA RIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 630899998,
    "dropmaladd": "461 HIGHWAY M",
    "dropmalcty": "VILLA RIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 630899998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6367424609,
    "dropsitcph": 6367424609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18564",
    "droptype": "D",
    "dropname": "WALDRON",
    "dropdeladd": "7230 NW RIVER RD",
    "dropdelcty": "WALDRON",
    "dropdelst": "MO",
    "dropdelzpp": 640929998,
    "dropphyadd": "7230 NW RIVER RD",
    "dropphycty": "WALDRON",
    "dropphyst": "MO",
    "dropphyzpp": 640929998,
    "dropmaladd": "7230 NW RIVER RD",
    "dropmalcty": "WALDRON",
    "dropmalst": "MO",
    "dropmalzpp": 640929998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168919482,
    "dropsitcph": 8168919482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18565",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "116 E MARVIN AVE",
    "dropdelcty": "WALKER",
    "dropdelst": "MO",
    "dropdelzpp": 647909998,
    "dropphyadd": "116 E MARVIN AVE",
    "dropphycty": "WALKER",
    "dropphyst": "MO",
    "dropphyzpp": 647909998,
    "dropmaladd": "116 E MARVIN AVE",
    "dropmalcty": "WALKER",
    "dropmalst": "MO",
    "dropmalzpp": 647909998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4174652250,
    "dropsitcph": 4174652250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18566",
    "droptype": "D",
    "dropname": "WALNUT GROVE",
    "dropdeladd": "412 S WASHINGTON AVE",
    "dropdelcty": "WALNUT GROVE",
    "dropdelst": "MO",
    "dropdelzpp": 657709998,
    "dropphyadd": "412 S WASHINGTON AVE",
    "dropphycty": "WALNUT GROVE",
    "dropphyst": "MO",
    "dropphyzpp": 657709998,
    "dropmaladd": "412 S WASHINGTON AVE",
    "dropmalcty": "WALNUT GROVE",
    "dropmalst": "MO",
    "dropmalzpp": 657709998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4179942513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18569",
    "droptype": "D",
    "dropname": "WAPPAPELLO",
    "dropdeladd": "19200 WAYNE ROUTE D",
    "dropdelcty": "WAPPAPELLO",
    "dropdelst": "MO",
    "dropdelzpp": 639668672,
    "dropphyadd": "19200 WAYNE ROUTE D",
    "dropphycty": "WAPPAPELLO",
    "dropphyst": "MO",
    "dropphyzpp": 639668672,
    "dropmaladd": "19200 WAYNE ROUTE D",
    "dropmalcty": "WAPPAPELLO",
    "dropmalst": "MO",
    "dropmalzpp": 639668672,
    "dropsitphn": 8165043362,
    "dropsitlph": 5732228638,
    "dropsitcph": 5732228638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18570",
    "droptype": "D",
    "dropname": "WARDELL",
    "dropdeladd": "115 W BROAD ST",
    "dropdelcty": "WARDELL",
    "dropdelst": "MO",
    "dropdelzpp": 638799998,
    "dropphyadd": "115 W BROAD ST",
    "dropphycty": "WARDELL",
    "dropphyst": "MO",
    "dropphyzpp": 638799998,
    "dropmaladd": "115 W BROAD ST",
    "dropmalcty": "WARDELL",
    "dropmalst": "MO",
    "dropmalzpp": 638799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736283687,
    "dropsitcph": 5736283687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18574",
    "droptype": "D",
    "dropname": "WARRENSBURG",
    "dropdeladd": "201 E GAY ST",
    "dropdelcty": "WARRENSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 640939998,
    "dropphyadd": "201 E GAY ST",
    "dropphycty": "WARRENSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 640939998,
    "dropmaladd": "201 E GAY ST",
    "dropmalcty": "WARRENSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 640939998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167475211,
    "dropsitcph": 6607475211,
    "dropfax": 6607475288
  },
  {
    "dcode": "D",
    "dropkey": "PW18575",
    "droptype": "D",
    "dropname": "WARRENTON",
    "dropdeladd": "501 E BOONESLICK RD",
    "dropdelcty": "WARRENTON",
    "dropdelst": "MO",
    "dropdelzpp": 633839998,
    "dropphyadd": "501 E BOONESLICK RD",
    "dropphycty": "WARRENTON",
    "dropphyst": "MO",
    "dropphyzpp": 633839998,
    "dropmaladd": "501 E BOONESLICK RD",
    "dropmalcty": "WARRENTON",
    "dropmalst": "MO",
    "dropmalzpp": 633839998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364563324,
    "dropsitcph": 6364563324,
    "dropfax": 6514065819
  },
  {
    "dcode": "D",
    "dropkey": "PW18576",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "406 BENTON ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "MO",
    "dropdelzpp": 653559998,
    "dropphyadd": "406 BENTON ST",
    "dropphycty": "WARSAW",
    "dropphyst": "MO",
    "dropphyzpp": 653559998,
    "dropmaladd": "406 BENTON ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "MO",
    "dropmalzpp": 653559998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604386211,
    "dropsitcph": 6604386211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18580",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "303 MAIN ST",
    "dropdelcty": "WASHBURN",
    "dropdelst": "MO",
    "dropdelzpp": 657729998,
    "dropphyadd": "303 MAIN ST",
    "dropphycty": "WASHBURN",
    "dropphyst": "MO",
    "dropphyzpp": 657729998,
    "dropmaladd": "303 MAIN ST",
    "dropmalcty": "WASHBURN",
    "dropmalst": "MO",
    "dropmalzpp": 657729998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4178265884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18582",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "1777 WASHINGTON XING",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 630909998,
    "dropphyadd": "1777 WASHINGTON XING",
    "dropphycty": "WASHINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 630909998,
    "dropmaladd": "1777 WASHINGTON XING",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 630909998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6362393207,
    "dropsitcph": 6362393207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18584",
    "droptype": "D",
    "dropname": "WASOLA",
    "dropdeladd": "1652 COUNTY ROAD 129",
    "dropdelcty": "WASOLA",
    "dropdelst": "MO",
    "dropdelzpp": 657739998,
    "dropphyadd": "1652 COUNTY ROAD 129",
    "dropphycty": "WASOLA",
    "dropphyst": "MO",
    "dropphyzpp": 657739998,
    "dropmaladd": "1652 COUNTY ROAD 129",
    "dropmalcty": "WASOLA",
    "dropmalst": "MO",
    "dropmalzpp": 657739998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172653543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18586",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "110 E KELLING AVE",
    "dropdelcty": "WAVERLY",
    "dropdelst": "MO",
    "dropdelzpp": 640969998,
    "dropphyadd": "110 E KELLING AVE",
    "dropphycty": "WAVERLY",
    "dropphyst": "MO",
    "dropphyzpp": 640969998,
    "dropmaladd": "110 E KELLING AVE",
    "dropmalcty": "WAVERLY",
    "dropmalst": "MO",
    "dropmalzpp": 640969998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604932550,
    "dropsitcph": 6604932550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18587",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "113 E DES MOINES ST",
    "dropdelcty": "WAYLAND",
    "dropdelst": "MO",
    "dropdelzpp": 634729998,
    "dropphyadd": "113 E DES MOINES ST",
    "dropphycty": "WAYLAND",
    "dropphyst": "MO",
    "dropphyzpp": 634729998,
    "dropmaladd": "113 E DES MOINES ST",
    "dropmalcty": "WAYLAND",
    "dropmalst": "MO",
    "dropmalzpp": 634729998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6607546321,
    "dropsitcph": 6607546321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18588",
    "droptype": "D",
    "dropname": "WAYNESVILLE",
    "dropdeladd": "301 NORTH ST",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 655839998,
    "dropphyadd": "301 NORTH ST",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 655839998,
    "dropmaladd": "301 NORTH ST",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 655839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737746752,
    "dropsitcph": 5737746752,
    "dropfax": 5737748421
  },
  {
    "dcode": "D",
    "dropkey": "PW18590",
    "droptype": "D",
    "dropname": "WEATHERBY",
    "dropdeladd": "148 N MAIN ST",
    "dropdelcty": "WEATHERBY",
    "dropdelst": "MO",
    "dropdelzpp": 644979998,
    "dropphyadd": "148 N MAIN ST",
    "dropphycty": "WEATHERBY",
    "dropphyst": "MO",
    "dropphyzpp": 644979998,
    "dropmaladd": "148 N MAIN ST",
    "dropmalcty": "WEATHERBY",
    "dropmalst": "MO",
    "dropmalzpp": 644979998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164495814,
    "dropsitcph": 8164495814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18592",
    "droptype": "D",
    "dropname": "WEAUBLEAU",
    "dropdeladd": "144 E US HIGHWAY 54",
    "dropdelcty": "WEAUBLEAU",
    "dropdelst": "MO",
    "dropdelzpp": 657749998,
    "dropphyadd": "144 E US HIGHWAY 54",
    "dropphycty": "WEAUBLEAU",
    "dropphyst": "MO",
    "dropphyzpp": 657749998,
    "dropmaladd": "144 E US HIGHWAY 54",
    "dropmalcty": "WEAUBLEAU",
    "dropmalst": "MO",
    "dropmalzpp": 657749998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174283550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18594",
    "droptype": "D",
    "dropname": "WEBB CITY",
    "dropdeladd": "220 W DAUGHERTY ST",
    "dropdelcty": "WEBB CITY",
    "dropdelst": "MO",
    "dropdelzpp": 648709998,
    "dropphyadd": "220 W DAUGHERTY ST",
    "dropphycty": "WEBB CITY",
    "dropphyst": "MO",
    "dropphyzpp": 648709998,
    "dropmaladd": "220 W DAUGHERTY ST",
    "dropmalcty": "WEBB CITY",
    "dropmalst": "MO",
    "dropmalzpp": 648709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176734346,
    "dropsitcph": 4176734346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18613",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "110 E HIGHWAY 224",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "MO",
    "dropdelzpp": 640979998,
    "dropphyadd": "110 E HIGHWAY 224",
    "dropphycty": "WELLINGTON",
    "dropphyst": "MO",
    "dropphyzpp": 640979998,
    "dropmaladd": "110 E HIGHWAY 224",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "MO",
    "dropmalzpp": 640979998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8169342341,
    "dropsitcph": 8169342341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18616",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "115 E HUDSON ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633849998,
    "dropphyadd": "115 E HUDSON ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633849998,
    "dropmaladd": "115 E HUDSON ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633849998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736842257,
    "dropsitcph": 5736842257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18621",
    "droptype": "D",
    "dropname": "WENTZVILLE",
    "dropdeladd": "762 LUETKENHAUS BLVD",
    "dropdelcty": "WENTZVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 633859998,
    "dropphyadd": "762 LUETKENHAUS BLVD",
    "dropphycty": "WENTZVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 633859998,
    "dropmaladd": "762 LUETKENHAUS BLVD",
    "dropmalcty": "WENTZVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 633859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6363273550,
    "dropsitcph": 6363273550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18624",
    "droptype": "D",
    "dropname": "WESCO",
    "dropdeladd": "494 WESCO RD",
    "dropdelcty": "WESCO",
    "dropdelst": "MO",
    "dropdelzpp": 655869998,
    "dropphyadd": "494 WESCO RD",
    "dropphycty": "WESCO",
    "dropphyst": "MO",
    "dropphyzpp": 655869998,
    "dropmaladd": "494 WESCO RD",
    "dropmalcty": "WESCO",
    "dropmalst": "MO",
    "dropmalzpp": 655869998,
    "dropsitphn": 8165053362,
    "dropsitlph": 5737755422,
    "dropsitcph": 5737755422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18625",
    "droptype": "D",
    "dropname": "WEST ALTON",
    "dropdeladd": "14000R US HIGHWAY 67",
    "dropdelcty": "WEST ALTON",
    "dropdelst": "MO",
    "dropdelzpp": 633869998,
    "dropphyadd": "14000R US HIGHWAY 67",
    "dropphycty": "WEST ALTON",
    "dropphyst": "MO",
    "dropphyzpp": 633869998,
    "dropmaladd": "14000R US HIGHWAY 67",
    "dropmalcty": "WEST ALTON",
    "dropmalst": "MO",
    "dropmalzpp": 633869998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6368990036,
    "dropsitcph": 6368990036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18629",
    "droptype": "D",
    "dropname": "WEST PLAINS",
    "dropdeladd": "212 WASHINGTON AVE",
    "dropdelcty": "WEST PLAINS",
    "dropdelst": "MO",
    "dropdelzpp": 657759998,
    "dropphyadd": "212 WASHINGTON AVE",
    "dropphycty": "WEST PLAINS",
    "dropphyst": "MO",
    "dropphyzpp": 657759998,
    "dropmaladd": "212 WASHINGTON AVE",
    "dropmalcty": "WEST PLAINS",
    "dropmalst": "MO",
    "dropmalzpp": 657759998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172565775,
    "dropfax": 4172561446
  },
  {
    "dcode": "D",
    "dropkey": "PW18631",
    "droptype": "D",
    "dropname": "WESTBORO",
    "dropdeladd": "303 E MAIN ST",
    "dropdelcty": "WESTBORO",
    "dropdelst": "MO",
    "dropdelzpp": 644989998,
    "dropphyadd": "303 E MAIN ST",
    "dropphycty": "WESTBORO",
    "dropphyst": "MO",
    "dropphyzpp": 644989998,
    "dropmaladd": "303 E MAIN ST",
    "dropmalcty": "WESTBORO",
    "dropmalst": "MO",
    "dropmalzpp": 644989998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6609845289,
    "dropsitcph": 6609845289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18633",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "18205 LIBRARY DR",
    "dropdelcty": "WESTON",
    "dropdelst": "MO",
    "dropdelzpp": 640989998,
    "dropphyadd": "18205 LIBRARY DR",
    "dropphycty": "WESTON",
    "dropphyst": "MO",
    "dropphyzpp": 640989998,
    "dropmaladd": "18205 LIBRARY DR",
    "dropmalcty": "WESTON",
    "dropmalst": "MO",
    "dropmalzpp": 640989998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8166405521,
    "dropsitcph": 8166405521,
    "dropfax": 8166400172
  },
  {
    "dcode": "D",
    "dropkey": "PW18634",
    "droptype": "D",
    "dropname": "WESTPHALIA",
    "dropdeladd": "126 E MAIN ST",
    "dropdelcty": "WESTPHALIA",
    "dropdelst": "MO",
    "dropdelzpp": 650859998,
    "dropphyadd": "126 E MAIN ST",
    "dropphycty": "WESTPHALIA",
    "dropphyst": "MO",
    "dropphyzpp": 650859998,
    "dropmaladd": "126 E MAIN ST",
    "dropmalcty": "WESTPHALIA",
    "dropmalst": "MO",
    "dropmalzpp": 650859998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734552327,
    "dropsitcph": 5734552327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18636",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "18545 N MAIN ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "MO",
    "dropdelzpp": 657799998,
    "dropphyadd": "18545 N MAIN ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "MO",
    "dropphyzpp": 657799998,
    "dropmaladd": "18545 N MAIN ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "MO",
    "dropmalzpp": 657799998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4172828209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18637",
    "droptype": "D",
    "dropname": "WHEATON",
    "dropdeladd": "300 S GILMAN ST",
    "dropdelcty": "WHEATON",
    "dropdelst": "MO",
    "dropdelzpp": 648749998,
    "dropphyadd": "300 S GILMAN ST",
    "dropphycty": "WHEATON",
    "dropphyst": "MO",
    "dropphyzpp": 648749998,
    "dropmaladd": "300 S GILMAN ST",
    "dropmalcty": "WHEATON",
    "dropmalst": "MO",
    "dropmalzpp": 648749998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176527310,
    "dropsitcph": 4176527310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18638",
    "droptype": "D",
    "dropname": "WHEELING",
    "dropdeladd": "104 N GRANT ST",
    "dropdelcty": "WHEELING",
    "dropdelst": "MO",
    "dropdelzpp": 646889998,
    "dropphyadd": "104 N GRANT ST",
    "dropphycty": "WHEELING",
    "dropphyst": "MO",
    "dropphyzpp": 646889998,
    "dropmaladd": "104 N GRANT ST",
    "dropmalcty": "WHEELING",
    "dropmalst": "MO",
    "dropmalzpp": 646889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6606592102,
    "dropsitcph": 6606592102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18645",
    "droptype": "D",
    "dropname": "WHITEOAK",
    "dropdeladd": "23340 STATE HIGHWAY 25",
    "dropdelcty": "WHITEOAK",
    "dropdelst": "MO",
    "dropdelzpp": 638809998,
    "dropphyadd": "23340 STATE HIGHWAY 25",
    "dropphycty": "WHITEOAK",
    "dropphyst": "MO",
    "dropphyzpp": 638809998,
    "dropmaladd": "23340 STATE HIGHWAY 25",
    "dropmalcty": "WHITEOAK",
    "dropmalst": "MO",
    "dropmalzpp": 638809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5738880700,
    "dropsitcph": 5738880700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18646",
    "droptype": "D",
    "dropname": "WHITESIDE",
    "dropdeladd": "120 PRAIRIE ST",
    "dropdelcty": "WHITESIDE",
    "dropdelst": "MO",
    "dropdelzpp": 633879998,
    "dropphyadd": "120 PRAIRIE ST",
    "dropphycty": "WHITESIDE",
    "dropphyst": "MO",
    "dropphyzpp": 633879998,
    "dropmaladd": "120 PRAIRIE ST",
    "dropmalcty": "WHITESIDE",
    "dropmalst": "MO",
    "dropmalzpp": 633879998,
    "dropsitphn": 3148959275,
    "dropsitlph": 4177780971,
    "dropsitcph": 4177780971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18647",
    "droptype": "D",
    "dropname": "WHITEWATER",
    "dropdeladd": "8742 STATE HIGHWAY A",
    "dropdelcty": "WHITEWATER",
    "dropdelst": "MO",
    "dropdelzpp": 637859998,
    "dropphyadd": "8742 STATE HIGHWAY A",
    "dropphycty": "WHITEWATER",
    "dropphyst": "MO",
    "dropphyzpp": 637859998,
    "dropmaladd": "8742 STATE HIGHWAY A",
    "dropmalcty": "WHITEWATER",
    "dropmalst": "MO",
    "dropmalzpp": 637859998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737942002,
    "dropsitcph": 5737942002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18648",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "107 WILLEY ST",
    "dropdelcty": "WILLARD",
    "dropdelst": "MO",
    "dropdelzpp": 657819998,
    "dropphyadd": "107 WILLEY ST",
    "dropphycty": "WILLARD",
    "dropphyst": "MO",
    "dropphyzpp": 657819998,
    "dropmaladd": "107 WILLEY ST",
    "dropmalcty": "WILLARD",
    "dropmalst": "MO",
    "dropmalzpp": 657819998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4177423311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18651",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "3828 COUNTY ROAD 1005",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "MO",
    "dropdelzpp": 633889998,
    "dropphyadd": "3828 COUNTY ROAD 1005",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "MO",
    "dropphyzpp": 633889998,
    "dropmaladd": "3828 COUNTY ROAD 1005",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "MO",
    "dropmalzpp": 633889998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5732543664,
    "dropsitcph": 5732543664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18653",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE",
    "dropdeladd": "100 N HIGHWAY A ST",
    "dropdelcty": "WILLIAMSVILLE",
    "dropdelst": "MO",
    "dropdelzpp": 639679998,
    "dropphyadd": "100 N HIGHWAY A ST",
    "dropphycty": "WILLIAMSVILLE",
    "dropphyst": "MO",
    "dropphyzpp": 639679998,
    "dropmaladd": "100 N HIGHWAY A ST",
    "dropmalcty": "WILLIAMSVILLE",
    "dropmalst": "MO",
    "dropmalzpp": 639679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5739982860,
    "dropsitcph": 5739982860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18657",
    "droptype": "D",
    "dropname": "WILLOW SPRINGS",
    "dropdeladd": "111 E 3RD ST",
    "dropdelcty": "WILLOW SPRINGS",
    "dropdelst": "MO",
    "dropdelzpp": 657939998,
    "dropphyadd": "111 E 3RD ST",
    "dropphycty": "WILLOW SPRINGS",
    "dropphyst": "MO",
    "dropphyzpp": 657939998,
    "dropmaladd": "111 E 3RD ST",
    "dropmalcty": "WILLOW SPRINGS",
    "dropmalst": "MO",
    "dropmalzpp": 657939998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 4174692112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18660",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "MO",
    "dropdelzpp": 653609998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "MO",
    "dropphyzpp": 653609998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "MO",
    "dropmalzpp": 653609998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6606472313,
    "dropsitcph": 6606472313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18664",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "298 W CHERRY ST",
    "dropdelcty": "WINFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 633899998,
    "dropphyadd": "298 W CHERRY ST",
    "dropphycty": "WINFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 633899998,
    "dropmaladd": "298 W CHERRY ST",
    "dropmalcty": "WINFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 633899998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366610194,
    "dropsitcph": 6366610194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18666",
    "droptype": "D",
    "dropname": "WINIGAN",
    "dropdeladd": "33314 MAIN ST",
    "dropdelcty": "WINIGAN",
    "dropdelst": "MO",
    "dropdelzpp": 635669998,
    "dropphyadd": "33314 MAIN ST",
    "dropphycty": "WINIGAN",
    "dropphyst": "MO",
    "dropphyzpp": 635669998,
    "dropmaladd": "33314 MAIN ST",
    "dropmalcty": "WINIGAN",
    "dropmalst": "MO",
    "dropmalzpp": 635669998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608574714,
    "dropsitcph": 6608574714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18667",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "102 E 1ST ST",
    "dropdelcty": "WINONA",
    "dropdelst": "MO",
    "dropdelzpp": 655889998,
    "dropphyadd": "102 E 1ST ST",
    "dropphycty": "WINONA",
    "dropphyst": "MO",
    "dropphyzpp": 655889998,
    "dropmaladd": "102 E 1ST ST",
    "dropmalcty": "WINONA",
    "dropmalst": "MO",
    "dropmalzpp": 655889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733254210,
    "dropsitcph": 5733254210,
    "dropfax": 5733258125
  },
  {
    "dcode": "D",
    "dropkey": "PW18668",
    "droptype": "D",
    "dropname": "WINSTON",
    "dropdeladd": "101 W 2ND ST",
    "dropdelcty": "WINSTON",
    "dropdelst": "MO",
    "dropdelzpp": 646899998,
    "dropphyadd": "101 W 2ND ST",
    "dropphycty": "WINSTON",
    "dropphyst": "MO",
    "dropphyzpp": 646899998,
    "dropmaladd": "101 W 2ND ST",
    "dropmalcty": "WINSTON",
    "dropmalst": "MO",
    "dropmalzpp": 646899998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6607495511,
    "dropsitcph": 6607495511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18683",
    "droptype": "D",
    "dropname": "WOOLDRIDGE",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "WOOLDRIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 652879998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "WOOLDRIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 652879998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "WOOLDRIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 652879998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6608392229,
    "dropsitcph": 6608392229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18686",
    "droptype": "D",
    "dropname": "WORTH",
    "dropdeladd": "401 WASHINGTON ST",
    "dropdelcty": "WORTH",
    "dropdelst": "MO",
    "dropdelzpp": 644999998,
    "dropphyadd": "401 WASHINGTON ST",
    "dropphycty": "WORTH",
    "dropphyst": "MO",
    "dropphyzpp": 644999998,
    "dropmaladd": "401 WASHINGTON ST",
    "dropmalcty": "WORTH",
    "dropmalst": "MO",
    "dropmalzpp": 644999998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6604483531,
    "dropsitcph": 6604483531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18688",
    "droptype": "D",
    "dropname": "WRIGHT CITY",
    "dropdeladd": "206 W 2ND ST N",
    "dropdelcty": "WRIGHT CITY",
    "dropdelst": "MO",
    "dropdelzpp": 633909998,
    "dropphyadd": "206 W 2ND ST N",
    "dropphycty": "WRIGHT CITY",
    "dropphyst": "MO",
    "dropphyzpp": 633909998,
    "dropmaladd": "206 W 2ND ST N",
    "dropmalcty": "WRIGHT CITY",
    "dropmalst": "MO",
    "dropmalzpp": 633909998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6367453513,
    "dropsitcph": 6367453513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18691",
    "droptype": "D",
    "dropname": "WYACONDA",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "WYACONDA",
    "dropdelst": "MO",
    "dropdelzpp": 634749998,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "WYACONDA",
    "dropphyst": "MO",
    "dropphyzpp": 634749998,
    "dropmaladd": "118 MAIN ST",
    "dropmalcty": "WYACONDA",
    "dropmalst": "MO",
    "dropmalzpp": 634749998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6604795414,
    "dropsitcph": 6604795414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18692",
    "droptype": "D",
    "dropname": "WYATT",
    "dropdeladd": "211 S MAIN ST",
    "dropdelcty": "WYATT",
    "dropdelst": "MO",
    "dropdelzpp": 638829998,
    "dropphyadd": "211 S MAIN ST",
    "dropphycty": "WYATT",
    "dropphyst": "MO",
    "dropphyzpp": 638829998,
    "dropmaladd": "211 S MAIN ST",
    "dropmalcty": "WYATT",
    "dropmalst": "MO",
    "dropmalzpp": 638829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5736753561,
    "dropsitcph": 5736753561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18701",
    "droptype": "D",
    "dropname": "ZALMA",
    "dropdeladd": "7173 MAIN ST",
    "dropdelcty": "ZALMA",
    "dropdelst": "MO",
    "dropdelzpp": 637879998,
    "dropphyadd": "7173 MAIN ST",
    "dropphycty": "ZALMA",
    "dropphyst": "MO",
    "dropphyzpp": 637879998,
    "dropmaladd": "7173 MAIN ST",
    "dropmalcty": "ZALMA",
    "dropmalst": "MO",
    "dropmalzpp": 637879998,
    "dropsitphn": 8165043362,
    "dropsitlph": 5737223769,
    "dropsitcph": 5737223769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18705",
    "droptype": "D",
    "dropname": "ABERCROMBIE",
    "dropdeladd": "515 BROADWAY",
    "dropdelcty": "ABERCROMBIE",
    "dropdelst": "ND",
    "dropdelzpp": 580019998,
    "dropphyadd": "515 BROADWAY",
    "dropphycty": "ABERCROMBIE",
    "dropphyst": "ND",
    "dropphyzpp": 580019998,
    "dropmaladd": "515 BROADWAY",
    "dropmalcty": "ABERCROMBIE",
    "dropmalst": "ND",
    "dropmalzpp": 580019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015538756,
    "dropsitcph": 7015538756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18707",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "ND",
    "dropdelzpp": 582109998,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "ADAMS",
    "dropphyst": "ND",
    "dropphyzpp": 582109998,
    "dropmaladd": "500 MAIN ST",
    "dropmalcty": "ADAMS",
    "dropmalst": "ND",
    "dropmalzpp": 582109998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019442722,
    "dropsitcph": 7019442722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18710",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "24 MAIN ST",
    "dropdelcty": "ALAMO",
    "dropdelst": "ND",
    "dropdelzpp": 588309998,
    "dropphyadd": "24 MAIN ST",
    "dropphycty": "ALAMO",
    "dropphyst": "ND",
    "dropphyzpp": 588309998,
    "dropmaladd": "24 MAIN ST",
    "dropmalcty": "ALAMO",
    "dropmalst": "ND",
    "dropmalzpp": 588309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015283132,
    "dropsitcph": 7015283132,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18711",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "602 ELK ST",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "ND",
    "dropdelzpp": 588319998,
    "dropphyadd": "602 ELK ST",
    "dropphycty": "ALEXANDER",
    "dropphyst": "ND",
    "dropphyzpp": 588319998,
    "dropmaladd": "602 ELK ST",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "ND",
    "dropmalzpp": 588319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018283563,
    "dropsitcph": 7018283563,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18715",
    "droptype": "D",
    "dropname": "ALMONT",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "ALMONT",
    "dropdelst": "ND",
    "dropdelzpp": 585209998,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "ALMONT",
    "dropphyst": "ND",
    "dropphyzpp": 585209998,
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "ALMONT",
    "dropmalst": "ND",
    "dropmalzpp": 585209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018437518,
    "dropsitcph": 7018437518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18717",
    "droptype": "D",
    "dropname": "AMBROSE",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "AMBROSE",
    "dropdelst": "ND",
    "dropdelzpp": 588339998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "AMBROSE",
    "dropphyst": "ND",
    "dropphyzpp": 588339998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "AMBROSE",
    "dropmalst": "ND",
    "dropmalzpp": 588339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019823381,
    "dropsitcph": 7019823381,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18719",
    "droptype": "D",
    "dropname": "AMIDON",
    "dropdeladd": "108 INMAN ST",
    "dropdelcty": "AMIDON",
    "dropdelst": "ND",
    "dropdelzpp": 586209998,
    "dropphyadd": "108 INMAN ST",
    "dropphycty": "AMIDON",
    "dropphyst": "ND",
    "dropphyzpp": 586209998,
    "dropmaladd": "108 INMAN ST",
    "dropmalcty": "AMIDON",
    "dropmalst": "ND",
    "dropmalzpp": 586209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018796291,
    "dropsitcph": 7018796291,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18720",
    "droptype": "D",
    "dropname": "ANAMOOSE",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "ANAMOOSE",
    "dropdelst": "ND",
    "dropdelzpp": 587109998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "ANAMOOSE",
    "dropphyst": "ND",
    "dropphyzpp": 587109998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "ANAMOOSE",
    "dropmalst": "ND",
    "dropmalzpp": 587109998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014653916,
    "dropsitcph": 7014653916,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18721",
    "droptype": "D",
    "dropname": "ANETA",
    "dropdeladd": "207 MAIN AVE",
    "dropdelcty": "ANETA",
    "dropdelst": "ND",
    "dropdelzpp": 582129998,
    "dropphyadd": "207 MAIN AVE",
    "dropphycty": "ANETA",
    "dropphyst": "ND",
    "dropphyzpp": 582129998,
    "dropmaladd": "207 MAIN AVE",
    "dropmalcty": "ANETA",
    "dropmalst": "ND",
    "dropmalzpp": 582129998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013264333,
    "dropsitcph": 7013264333,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18722",
    "droptype": "D",
    "dropname": "ANTLER",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "ANTLER",
    "dropdelst": "ND",
    "dropdelzpp": 587119998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "ANTLER",
    "dropphyst": "ND",
    "dropphyzpp": 587119998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "ANTLER",
    "dropmalst": "ND",
    "dropmalzpp": 587119998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012673339,
    "dropsitcph": 7012673339,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18729",
    "droptype": "D",
    "dropname": "ARNEGARD",
    "dropdeladd": "110 MAIN ST S",
    "dropdelcty": "ARNEGARD",
    "dropdelst": "ND",
    "dropdelzpp": 588359998,
    "dropphyadd": "110 MAIN ST S",
    "dropphycty": "ARNEGARD",
    "dropphyst": "ND",
    "dropphyzpp": 588359998,
    "dropmaladd": "110 MAIN ST S",
    "dropmalcty": "ARNEGARD",
    "dropmalst": "ND",
    "dropmalzpp": 588359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015863420,
    "dropsitcph": 7015863420,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18730",
    "droptype": "D",
    "dropname": "ARTHUR",
    "dropdeladd": "330 MAIN ST",
    "dropdelcty": "ARTHUR",
    "dropdelst": "ND",
    "dropdelzpp": 580069998,
    "dropphyadd": "330 MAIN ST",
    "dropphycty": "ARTHUR",
    "dropphyst": "ND",
    "dropphyzpp": 580069998,
    "dropmaladd": "330 MAIN ST",
    "dropmalcty": "ARTHUR",
    "dropmalst": "ND",
    "dropmalzpp": 580069998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019678588,
    "dropsitcph": 7019678588,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18731",
    "droptype": "D",
    "dropname": "ARVILLA",
    "dropdeladd": "303 HUGHES AVE",
    "dropdelcty": "ARVILLA",
    "dropdelst": "ND",
    "dropdelzpp": 582149998,
    "dropphyadd": "303 HUGHES AVE",
    "dropphycty": "ARVILLA",
    "dropphyst": "ND",
    "dropphyzpp": 582149998,
    "dropmaladd": "303 HUGHES AVE",
    "dropmalcty": "ARVILLA",
    "dropmalst": "ND",
    "dropmalzpp": 582149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013432655,
    "dropsitcph": 7013432655,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18732",
    "droptype": "D",
    "dropname": "ASHLEY",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "ASHLEY",
    "dropdelst": "ND",
    "dropdelzpp": 584139998,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "ASHLEY",
    "dropphyst": "ND",
    "dropphyzpp": 584139998,
    "dropmaladd": "110 E MAIN ST",
    "dropmalcty": "ASHLEY",
    "dropmalst": "ND",
    "dropmalzpp": 584139998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012883422,
    "dropsitcph": 7012883422,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18738",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "20101 26TH ST NE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "ND",
    "dropdelzpp": 585219998,
    "dropphyadd": "20101 26TH ST NE",
    "dropphycty": "BALDWIN",
    "dropphyst": "ND",
    "dropphyzpp": 585219998,
    "dropmaladd": "20101 26TH ST NE",
    "dropmalcty": "BALDWIN",
    "dropmalst": "ND",
    "dropmalzpp": 585219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012554229,
    "dropsitcph": 7012554229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18748",
    "droptype": "D",
    "dropname": "BEACH",
    "dropdeladd": "177 S CENTRAL AVE",
    "dropdelcty": "BEACH",
    "dropdelst": "ND",
    "dropdelzpp": 586219998,
    "dropphyadd": "177 S CENTRAL AVE",
    "dropphycty": "BEACH",
    "dropphyst": "ND",
    "dropphyzpp": 586219998,
    "dropmaladd": "177 S CENTRAL AVE",
    "dropmalcty": "BEACH",
    "dropmalst": "ND",
    "dropmalzpp": 586219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015817995,
    "dropsitcph": 7015817995,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18749",
    "droptype": "D",
    "dropname": "BELCOURT",
    "dropdeladd": "1 EXPRESS LN",
    "dropdelcty": "BELCOURT",
    "dropdelst": "ND",
    "dropdelzpp": 583169998,
    "dropphyadd": "1 EXPRESS LN",
    "dropphycty": "BELCOURT",
    "dropphyst": "ND",
    "dropphyzpp": 583169998,
    "dropmaladd": "1 EXPRESS LN",
    "dropmalcty": "BELCOURT",
    "dropmalst": "ND",
    "dropmalzpp": 583169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014773460,
    "dropsitcph": 7016952489,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18751",
    "droptype": "D",
    "dropname": "BELFIELD",
    "dropdeladd": "105 1ST AVE NW",
    "dropdelcty": "BELFIELD",
    "dropdelst": "ND",
    "dropdelzpp": 586229998,
    "dropphyadd": "105 1ST AVE NW",
    "dropphycty": "BELFIELD",
    "dropphyst": "ND",
    "dropphyzpp": 586229998,
    "dropmaladd": "105 1ST AVE NW",
    "dropmalcty": "BELFIELD",
    "dropmalst": "ND",
    "dropmalzpp": 586229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015754913,
    "dropsitcph": 7015754913,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18752",
    "droptype": "D",
    "dropname": "BENEDICT",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "BENEDICT",
    "dropdelst": "ND",
    "dropdelzpp": 587169998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "BENEDICT",
    "dropphyst": "ND",
    "dropphyzpp": 587169998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "BENEDICT",
    "dropmalst": "ND",
    "dropmalzpp": 587169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016792588,
    "dropsitcph": 7014041174,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18756",
    "droptype": "D",
    "dropname": "BERTHOLD",
    "dropdeladd": "204 MAIN ST N",
    "dropdelcty": "BERTHOLD",
    "dropdelst": "ND",
    "dropdelzpp": 587189998,
    "dropphyadd": "204 MAIN ST N",
    "dropphycty": "BERTHOLD",
    "dropphyst": "ND",
    "dropphyzpp": 587189998,
    "dropmaladd": "204 MAIN ST N",
    "dropmalcty": "BERTHOLD",
    "dropmalst": "ND",
    "dropmalzpp": 587189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014533610,
    "dropsitcph": 7014533610,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18758",
    "droptype": "D",
    "dropname": "BEULAH",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "BEULAH",
    "dropdelst": "ND",
    "dropdelzpp": 585239998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "BEULAH",
    "dropphyst": "ND",
    "dropphyzpp": 585239998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "BEULAH",
    "dropmalst": "ND",
    "dropmalzpp": 585239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018734479,
    "dropsitcph": 7018854042,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18759",
    "droptype": "D",
    "dropname": "BINFORD",
    "dropdeladd": "215 WHINERY ST",
    "dropdelcty": "BINFORD",
    "dropdelst": "ND",
    "dropdelzpp": 584169998,
    "dropphyadd": "215 WHINERY ST",
    "dropphycty": "BINFORD",
    "dropphyst": "ND",
    "dropphyzpp": 584169998,
    "dropmaladd": "215 WHINERY ST",
    "dropmalcty": "BINFORD",
    "dropmalst": "ND",
    "dropmalzpp": 584169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016762212,
    "dropsitcph": 7016719007,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18761",
    "droptype": "D",
    "dropname": "BISBEE",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "BISBEE",
    "dropdelst": "ND",
    "dropdelzpp": 583179998,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "BISBEE",
    "dropphyst": "ND",
    "dropphyzpp": 583179998,
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "BISBEE",
    "dropmalst": "ND",
    "dropmalzpp": 583179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016563443,
    "dropsitcph": 7013538656,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18763",
    "droptype": "D",
    "dropname": "BISMARCK",
    "dropdeladd": "403 AIRPORT RD",
    "dropdelcty": "BISMARCK",
    "dropdelst": "ND",
    "dropdelzpp": 585049998,
    "dropphyadd": "403 AIRPORT RD",
    "dropphycty": "BISMARCK",
    "dropphyst": "ND",
    "dropphyzpp": 585049998,
    "dropmaladd": "403 AIRPORT RD",
    "dropmalcty": "BISMARCK",
    "dropmalst": "ND",
    "dropmalzpp": 585049998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012216553,
    "dropsitcph": 7012216509,
    "dropfax": 7012216542
  },
  {
    "dcode": "D",
    "dropkey": "PW18772",
    "droptype": "D",
    "dropname": "BOTTINEAU",
    "dropdeladd": "522 THOMPSON ST",
    "dropdelcty": "BOTTINEAU",
    "dropdelst": "ND",
    "dropdelzpp": 583189998,
    "dropphyadd": "522 THOMPSON ST",
    "dropphycty": "BOTTINEAU",
    "dropphyst": "ND",
    "dropphyzpp": 583189998,
    "dropmaladd": "522 THOMPSON ST",
    "dropmalcty": "BOTTINEAU",
    "dropmalst": "ND",
    "dropmalzpp": 583189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012282152,
    "dropsitcph": 7016952492,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18773",
    "droptype": "D",
    "dropname": "BOWBELLS",
    "dropdeladd": "107 MAIN ST NE",
    "dropdelcty": "BOWBELLS",
    "dropdelst": "ND",
    "dropdelzpp": 587219998,
    "dropphyadd": "107 MAIN ST NE",
    "dropphycty": "BOWBELLS",
    "dropphyst": "ND",
    "dropphyzpp": 587219998,
    "dropmaladd": "107 MAIN ST NE",
    "dropmalcty": "BOWBELLS",
    "dropmalst": "ND",
    "dropmalzpp": 587219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013772642,
    "dropsitcph": 7013772642,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18774",
    "droptype": "D",
    "dropname": "BOWDON",
    "dropdeladd": "212 WARRINGTON AVE",
    "dropdelcty": "BOWDON",
    "dropdelst": "ND",
    "dropdelzpp": 584189998,
    "dropphyadd": "212 WARRINGTON AVE",
    "dropphycty": "BOWDON",
    "dropphyst": "ND",
    "dropphyzpp": 584189998,
    "dropmaladd": "212 WARRINGTON AVE",
    "dropmalcty": "BOWDON",
    "dropmalst": "ND",
    "dropmalzpp": 584189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019623372,
    "dropsitcph": 7019623372,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18776",
    "droptype": "D",
    "dropname": "BOWMAN",
    "dropdeladd": "17 1ST AVE SE",
    "dropdelcty": "BOWMAN",
    "dropdelst": "ND",
    "dropdelzpp": 586239998,
    "dropphyadd": "17 1ST AVE SE",
    "dropphycty": "BOWMAN",
    "dropphyst": "ND",
    "dropphyzpp": 586239998,
    "dropmaladd": "17 1ST AVE SE",
    "dropmalcty": "BOWMAN",
    "dropmalst": "ND",
    "dropmalzpp": 586239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016950578,
    "dropsitcph": 7016950578,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18785",
    "droptype": "D",
    "dropname": "BROCKET",
    "dropdeladd": "211 MAIN ST E",
    "dropdelcty": "BROCKET",
    "dropdelst": "ND",
    "dropdelzpp": 583219998,
    "dropphyadd": "211 MAIN ST E",
    "dropphycty": "BROCKET",
    "dropphyst": "ND",
    "dropphyzpp": 583219998,
    "dropmaladd": "211 MAIN ST E",
    "dropmalcty": "BROCKET",
    "dropmalst": "ND",
    "dropmalzpp": 583219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016553833,
    "dropsitcph": 7016553833,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18786",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "ND",
    "dropdelzpp": 584209998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "BUCHANAN",
    "dropphyst": "ND",
    "dropphyzpp": 584209998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "ND",
    "dropmalzpp": 584209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012529354,
    "dropsitcph": 7012529354,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18788",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "ND",
    "dropdelzpp": 580119998,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "ND",
    "dropphyzpp": 580119998,
    "dropmaladd": "305 MAIN ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "ND",
    "dropmalzpp": 580119998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016335298,
    "dropsitcph": 8778549585,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18791",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "129 COLTON AVE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "ND",
    "dropdelzpp": 587229998,
    "dropphyadd": "129 COLTON AVE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "ND",
    "dropphyzpp": 587229998,
    "dropmaladd": "129 COLTON AVE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "ND",
    "dropmalzpp": 587229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018398659,
    "dropsitcph": 7018398659,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18794",
    "droptype": "D",
    "dropname": "BUTTE",
    "dropdeladd": "301 MAIN ST E",
    "dropdelcty": "BUTTE",
    "dropdelst": "ND",
    "dropdelzpp": 587239998,
    "dropphyadd": "301 MAIN ST E",
    "dropphycty": "BUTTE",
    "dropphyst": "ND",
    "dropphyzpp": 587239998,
    "dropmaladd": "301 MAIN ST E",
    "dropmalcty": "BUTTE",
    "dropmalst": "ND",
    "dropmalzpp": 587239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016267639,
    "dropsitcph": 7014041124,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18795",
    "droptype": "D",
    "dropname": "BUXTON",
    "dropdeladd": "309 BROADWAY",
    "dropdelcty": "BUXTON",
    "dropdelst": "ND",
    "dropdelzpp": 582189998,
    "dropphyadd": "309 BROADWAY",
    "dropphycty": "BUXTON",
    "dropphyst": "ND",
    "dropphyzpp": 582189998,
    "dropmaladd": "309 BROADWAY",
    "dropmalcty": "BUXTON",
    "dropmalst": "ND",
    "dropmalzpp": 582189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018472328,
    "dropsitcph": 7018472328,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18799",
    "droptype": "D",
    "dropname": "CANDO",
    "dropdeladd": "403 5TH AVE",
    "dropdelcty": "CANDO",
    "dropdelst": "ND",
    "dropdelzpp": 583249998,
    "dropphyadd": "403 5TH AVE",
    "dropphycty": "CANDO",
    "dropphyst": "ND",
    "dropphyzpp": 583249998,
    "dropmaladd": "403 5TH AVE",
    "dropmalcty": "CANDO",
    "dropmalst": "ND",
    "dropmalzpp": 583249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019683997,
    "dropsitcph": 7017470428,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18803",
    "droptype": "D",
    "dropname": "CARPIO",
    "dropdeladd": "520 MAIN ST",
    "dropdelcty": "CARPIO",
    "dropdelst": "ND",
    "dropdelzpp": 587259998,
    "dropphyadd": "520 MAIN ST",
    "dropphycty": "CARPIO",
    "dropphyst": "ND",
    "dropphyzpp": 587259998,
    "dropmaladd": "520 MAIN ST",
    "dropmalcty": "CARPIO",
    "dropmalst": "ND",
    "dropmalzpp": 587259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014685480,
    "dropsitcph": 7013538745,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18804",
    "droptype": "D",
    "dropname": "CARRINGTON",
    "dropdeladd": "87 9TH AVE N",
    "dropdelcty": "CARRINGTON",
    "dropdelst": "ND",
    "dropdelzpp": 584219998,
    "dropphyadd": "87 9TH AVE N",
    "dropphycty": "CARRINGTON",
    "dropphyst": "ND",
    "dropphyzpp": 584219998,
    "dropmaladd": "87 9TH AVE N",
    "dropmalcty": "CARRINGTON",
    "dropmalst": "ND",
    "dropmalzpp": 584219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016522122,
    "dropsitcph": 8778544855,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18805",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "217 N MAIN ST",
    "dropdelcty": "CARSON",
    "dropdelst": "ND",
    "dropdelzpp": 585299998,
    "dropphyadd": "217 N MAIN ST",
    "dropphycty": "CARSON",
    "dropphyst": "ND",
    "dropphyzpp": 585299998,
    "dropmaladd": "217 N MAIN ST",
    "dropmalcty": "CARSON",
    "dropmalst": "ND",
    "dropmalzpp": 585299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016223313,
    "dropsitcph": 7016950608,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18806",
    "droptype": "D",
    "dropname": "CARTWRIGHT",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "CARTWRIGHT",
    "dropdelst": "ND",
    "dropdelzpp": 588389998,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "CARTWRIGHT",
    "dropphyst": "ND",
    "dropphyzpp": 588389998,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "CARTWRIGHT",
    "dropmalst": "ND",
    "dropmalzpp": 588389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017445837,
    "dropsitcph": 7017445837,
    "dropfax": 7017449049
  },
  {
    "dcode": "D",
    "dropkey": "PW18807",
    "droptype": "D",
    "dropname": "CASSELTON",
    "dropdeladd": "840 FRONT ST",
    "dropdelcty": "CASSELTON",
    "dropdelst": "ND",
    "dropdelzpp": 580129998,
    "dropphyadd": "840 FRONT ST",
    "dropphycty": "CASSELTON",
    "dropphyst": "ND",
    "dropphyzpp": 580129998,
    "dropmaladd": "840 FRONT ST",
    "dropmalcty": "CASSELTON",
    "dropmalst": "ND",
    "dropmalzpp": 580129998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013474243,
    "dropsitcph": 7013474243,
    "dropfax": 7013474243
  },
  {
    "dcode": "D",
    "dropkey": "PW18809",
    "droptype": "D",
    "dropname": "CAVALIER",
    "dropdeladd": "306 MAIN ST W",
    "dropdelcty": "CAVALIER",
    "dropdelst": "ND",
    "dropdelzpp": 582209998,
    "dropphyadd": "306 MAIN ST W",
    "dropphycty": "CAVALIER",
    "dropphyst": "ND",
    "dropphyzpp": 582209998,
    "dropmaladd": "306 MAIN ST W",
    "dropmalcty": "CAVALIER",
    "dropmalst": "ND",
    "dropmalzpp": 582209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013352044,
    "dropsitcph": 7012654270,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18811",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "115 S CENTER AVE",
    "dropdelcty": "CENTER",
    "dropdelst": "ND",
    "dropdelzpp": 585309998,
    "dropphyadd": "115 S CENTER AVE",
    "dropphycty": "CENTER",
    "dropphyst": "ND",
    "dropphyzpp": 585309998,
    "dropmaladd": "115 S CENTER AVE",
    "dropmalcty": "CENTER",
    "dropmalst": "ND",
    "dropmalzpp": 585309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017943358,
    "dropsitcph": 7016950686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18816",
    "droptype": "D",
    "dropname": "CHRISTINE",
    "dropdeladd": "209 MAINE ST",
    "dropdelcty": "CHRISTINE",
    "dropdelst": "ND",
    "dropdelzpp": 580159998,
    "dropphyadd": "209 MAINE ST",
    "dropphycty": "CHRISTINE",
    "dropphyst": "ND",
    "dropphyzpp": 580159998,
    "dropmaladd": "209 MAINE ST",
    "dropmalcty": "CHRISTINE",
    "dropmalst": "ND",
    "dropmalzpp": 580159998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019982152,
    "dropsitcph": 7019982152,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18819",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "420 5TH AVE N",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "ND",
    "dropdelzpp": 584249998,
    "dropphyadd": "420 5TH AVE N",
    "dropphycty": "CLEVELAND",
    "dropphyst": "ND",
    "dropphyzpp": 584249998,
    "dropmaladd": "420 5TH AVE N",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "ND",
    "dropmalzpp": 584249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017636122,
    "dropsitcph": 7017636122,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18820",
    "droptype": "D",
    "dropname": "CLIFFORD",
    "dropdeladd": "100 GARFIELD AVE W",
    "dropdelcty": "CLIFFORD",
    "dropdelst": "ND",
    "dropdelzpp": 580169998,
    "dropphyadd": "100 GARFIELD AVE W",
    "dropphycty": "CLIFFORD",
    "dropphyst": "ND",
    "dropphyzpp": 580169998,
    "dropmaladd": "100 GARFIELD AVE W",
    "dropmalcty": "CLIFFORD",
    "dropmalst": "ND",
    "dropmalzpp": 580169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014882555,
    "dropsitcph": 7014882555,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18823",
    "droptype": "D",
    "dropname": "COGSWELL",
    "dropdeladd": "299 4TH AVE",
    "dropdelcty": "COGSWELL",
    "dropdelst": "ND",
    "dropdelzpp": 580179998,
    "dropphyadd": "299 4TH AVE",
    "dropphycty": "COGSWELL",
    "dropphyst": "ND",
    "dropphyzpp": 580179998,
    "dropmaladd": "299 4TH AVE",
    "dropmalcty": "COGSWELL",
    "dropmalst": "ND",
    "dropmalzpp": 580179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017243048,
    "dropsitcph": 7017243048,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18824",
    "droptype": "D",
    "dropname": "COLEHARBOR",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "COLEHARBOR",
    "dropdelst": "ND",
    "dropdelzpp": 585319998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "COLEHARBOR",
    "dropphyst": "ND",
    "dropphyzpp": 585319998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "COLEHARBOR",
    "dropmalst": "ND",
    "dropmalzpp": 585319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014425233,
    "dropsitcph": 7015060937,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18825",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "206 MAIN AVE",
    "dropdelcty": "COLFAX",
    "dropdelst": "ND",
    "dropdelzpp": 580189998,
    "dropphyadd": "206 MAIN AVE",
    "dropphycty": "COLFAX",
    "dropphyst": "ND",
    "dropphyzpp": 580189998,
    "dropmaladd": "206 MAIN AVE",
    "dropmalcty": "COLFAX",
    "dropmalst": "ND",
    "dropmalzpp": 580189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013723711,
    "dropsitcph": 7013695891,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18828",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "206 MAIN ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "ND",
    "dropdelzpp": 587279998,
    "dropphyadd": "206 MAIN ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "ND",
    "dropphyzpp": 587279998,
    "dropmaladd": "206 MAIN ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "ND",
    "dropmalzpp": 587279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013538760,
    "dropsitcph": 7013538760,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18831",
    "droptype": "D",
    "dropname": "COOPERSTOWN",
    "dropdeladd": "608 8TH ST NW",
    "dropdelcty": "COOPERSTOWN",
    "dropdelst": "ND",
    "dropdelzpp": 584259998,
    "dropphyadd": "608 8TH ST NW",
    "dropphycty": "COOPERSTOWN",
    "dropphyst": "ND",
    "dropphyzpp": 584259998,
    "dropmaladd": "608 8TH ST NW",
    "dropmalcty": "COOPERSTOWN",
    "dropmalst": "ND",
    "dropmalzpp": 584259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017972622,
    "dropsitcph": 7014103110,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18840",
    "droptype": "D",
    "dropname": "CROSBY",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "CROSBY",
    "dropdelst": "ND",
    "dropdelzpp": 587309998,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "CROSBY",
    "dropphyst": "ND",
    "dropphyzpp": 587309998,
    "dropmaladd": "202 N MAIN ST",
    "dropmalcty": "CROSBY",
    "dropmalst": "ND",
    "dropmalzpp": 587309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019656365,
    "dropsitcph": 7013433016,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18841",
    "droptype": "D",
    "dropname": "CRYSTAL",
    "dropdeladd": "332 3RD ST",
    "dropdelcty": "CRYSTAL",
    "dropdelst": "ND",
    "dropdelzpp": 582229998,
    "dropphyadd": "332 3RD ST",
    "dropphycty": "CRYSTAL",
    "dropphyst": "ND",
    "dropphyzpp": 582229998,
    "dropmaladd": "332 3RD ST",
    "dropmalcty": "CRYSTAL",
    "dropmalst": "ND",
    "dropmalzpp": 582229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016572351,
    "dropsitcph": 7016572351,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18846",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "50 1ST AVE",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "ND",
    "dropdelzpp": 580219998,
    "dropphyadd": "50 1ST AVE",
    "dropphycty": "DAVENPORT",
    "dropphyst": "ND",
    "dropphyzpp": 580219998,
    "dropmaladd": "50 1ST AVE",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "ND",
    "dropmalzpp": 580219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014283416,
    "dropsitcph": 7014283416,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18847",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "118 HIGHWAY 3 S",
    "dropdelcty": "DAWSON",
    "dropdelst": "ND",
    "dropdelzpp": 584289998,
    "dropphyadd": "118 HIGHWAY 3 S",
    "dropphycty": "DAWSON",
    "dropphyst": "ND",
    "dropphyzpp": 584289998,
    "dropmaladd": "118 HIGHWAY 3 S",
    "dropmalcty": "DAWSON",
    "dropmalst": "ND",
    "dropmalzpp": 584289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013278305,
    "dropsitcph": 7015816474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18848",
    "droptype": "D",
    "dropname": "DAZEY",
    "dropdeladd": "411 4TH AVE",
    "dropdelcty": "DAZEY",
    "dropdelst": "ND",
    "dropdelzpp": 584299998,
    "dropphyadd": "411 4TH AVE",
    "dropphycty": "DAZEY",
    "dropphyst": "ND",
    "dropphyzpp": 584299998,
    "dropmaladd": "411 4TH AVE",
    "dropmalcty": "DAZEY",
    "dropmalst": "ND",
    "dropmalzpp": 584299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017332102,
    "dropsitcph": 7017332102,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18853",
    "droptype": "D",
    "dropname": "DES LACS",
    "dropdeladd": "130 MAIN ST S",
    "dropdelcty": "DES LACS",
    "dropdelst": "ND",
    "dropdelzpp": 587339998,
    "dropphyadd": "130 MAIN ST S",
    "dropphycty": "DES LACS",
    "dropphyst": "ND",
    "dropphyzpp": 587339998,
    "dropmaladd": "130 MAIN ST S",
    "dropmalcty": "DES LACS",
    "dropmalst": "ND",
    "dropmalzpp": 587339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017254494,
    "dropsitcph": 7017254494,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18855",
    "droptype": "D",
    "dropname": "DEVILS LAKE",
    "dropdeladd": "502 3RD ST NE",
    "dropdelcty": "DEVILS LAKE",
    "dropdelst": "ND",
    "dropdelzpp": 583019998,
    "dropphyadd": "502 3RD ST NE",
    "dropphycty": "DEVILS LAKE",
    "dropphyst": "ND",
    "dropphyzpp": 583019998,
    "dropmaladd": "502 3RD ST NE",
    "dropmalcty": "DEVILS LAKE",
    "dropmalst": "ND",
    "dropmalzpp": 583019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016627132,
    "dropsitcph": 7016627132,
    "dropfax": 7016621126
  },
  {
    "dcode": "D",
    "dropkey": "PW18859",
    "droptype": "D",
    "dropname": "DICKINSON",
    "dropdeladd": "15 1ST ST E",
    "dropdelcty": "DICKINSON",
    "dropdelst": "ND",
    "dropdelzpp": 586019998,
    "dropphyadd": "15 1ST ST E",
    "dropphycty": "DICKINSON",
    "dropphyst": "ND",
    "dropphyzpp": 586019998,
    "dropmaladd": "15 1ST ST E",
    "dropmalcty": "DICKINSON",
    "dropmalst": "ND",
    "dropmalzpp": 586019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012251487,
    "dropsitcph": 7012251487,
    "dropfax": 7012258178
  },
  {
    "dcode": "D",
    "dropkey": "PW18860",
    "droptype": "D",
    "dropname": "DODGE",
    "dropdeladd": "105 CENTRAL AVE",
    "dropdelcty": "DODGE",
    "dropdelst": "ND",
    "dropdelzpp": 586259998,
    "dropphyadd": "105 CENTRAL AVE",
    "dropphycty": "DODGE",
    "dropphyst": "ND",
    "dropphyzpp": 586259998,
    "dropmaladd": "105 CENTRAL AVE",
    "dropmalcty": "DODGE",
    "dropmalst": "ND",
    "dropmalzpp": 586259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018467405,
    "dropsitcph": 7018467405,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18866",
    "droptype": "D",
    "dropname": "DRAKE",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "DRAKE",
    "dropdelst": "ND",
    "dropdelzpp": 587369998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "DRAKE",
    "dropphyst": "ND",
    "dropphyzpp": 587369998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "DRAKE",
    "dropmalst": "ND",
    "dropmalzpp": 587369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014653615,
    "dropsitcph": 7014653615,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18867",
    "droptype": "D",
    "dropname": "DRAYTON",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "DRAYTON",
    "dropdelst": "ND",
    "dropdelzpp": 582259998,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "DRAYTON",
    "dropphyst": "ND",
    "dropphyzpp": 582259998,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "DRAYTON",
    "dropmalst": "ND",
    "dropmalzpp": 582259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013527329,
    "dropsitcph": 7013527329,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18872",
    "droptype": "D",
    "dropname": "DUNSEITH",
    "dropdeladd": "100 PEACE GARDEN AVE E",
    "dropdelcty": "DUNSEITH",
    "dropdelst": "ND",
    "dropdelzpp": 583299998,
    "dropphyadd": "100 PEACE GARDEN AVE E",
    "dropphycty": "DUNSEITH",
    "dropphyst": "ND",
    "dropphyzpp": 583299998,
    "dropmaladd": "100 PEACE GARDEN AVE E",
    "dropmalcty": "DUNSEITH",
    "dropmalst": "ND",
    "dropmalzpp": 583299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012445848,
    "dropsitcph": 7016952703,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18878",
    "droptype": "D",
    "dropname": "EDGELEY",
    "dropdeladd": "511 MAIN ST",
    "dropdelcty": "EDGELEY",
    "dropdelst": "ND",
    "dropdelzpp": 584339998,
    "dropphyadd": "511 MAIN ST",
    "dropphycty": "EDGELEY",
    "dropphyst": "ND",
    "dropphyzpp": 584339998,
    "dropmaladd": "511 MAIN ST",
    "dropmalcty": "EDGELEY",
    "dropmalst": "ND",
    "dropmalzpp": 584339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014932831,
    "dropsitcph": 7015873541,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18879",
    "droptype": "D",
    "dropname": "EDINBURG",
    "dropdeladd": "250 MAIN AVE",
    "dropdelcty": "EDINBURG",
    "dropdelst": "ND",
    "dropdelzpp": 582279998,
    "dropphyadd": "250 MAIN AVE",
    "dropphycty": "EDINBURG",
    "dropphyst": "ND",
    "dropphyzpp": 582279998,
    "dropmaladd": "250 MAIN AVE",
    "dropmalcty": "EDINBURG",
    "dropmalst": "ND",
    "dropmalzpp": 582279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019938577,
    "dropsitcph": 7015102666,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18880",
    "droptype": "D",
    "dropname": "EDMORE",
    "dropdeladd": "315 S MAIN ST",
    "dropdelcty": "EDMORE",
    "dropdelst": "ND",
    "dropdelzpp": 583309998,
    "dropphyadd": "315 S MAIN ST",
    "dropphycty": "EDMORE",
    "dropphyst": "ND",
    "dropphyzpp": 583309998,
    "dropmaladd": "315 S MAIN ST",
    "dropmalcty": "EDMORE",
    "dropmalst": "ND",
    "dropmalzpp": 583309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016442303,
    "dropsitcph": 7015058385,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18882",
    "droptype": "D",
    "dropname": "EGELAND",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "EGELAND",
    "dropdelst": "ND",
    "dropdelzpp": 583319998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "EGELAND",
    "dropphyst": "ND",
    "dropphyzpp": 583319998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "EGELAND",
    "dropmalst": "ND",
    "dropmalzpp": 583319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012665241,
    "dropsitcph": 7012665241,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18884",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "213 N MAIN ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "ND",
    "dropdelzpp": 585339998,
    "dropphyadd": "213 N MAIN ST",
    "dropphycty": "ELGIN",
    "dropphyst": "ND",
    "dropphyzpp": 585339998,
    "dropmaladd": "213 N MAIN ST",
    "dropmalcty": "ELGIN",
    "dropmalst": "ND",
    "dropmalzpp": 585339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015842922,
    "dropsitcph": 7016950694,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18885",
    "droptype": "D",
    "dropname": "ELLENDALE",
    "dropdeladd": "111 1ST ST N",
    "dropdelcty": "ELLENDALE",
    "dropdelst": "ND",
    "dropdelzpp": 584369998,
    "dropphyadd": "111 1ST ST N",
    "dropphycty": "ELLENDALE",
    "dropphyst": "ND",
    "dropphyzpp": 584369998,
    "dropmaladd": "111 1ST ST N",
    "dropmalcty": "ELLENDALE",
    "dropmalst": "ND",
    "dropmalzpp": 584369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013493465,
    "dropsitcph": 7013493465,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18888",
    "droptype": "D",
    "dropname": "EMERADO",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "EMERADO",
    "dropdelst": "ND",
    "dropdelzpp": 582289998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "EMERADO",
    "dropphyst": "ND",
    "dropphyzpp": 582289998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "EMERADO",
    "dropmalst": "ND",
    "dropmalzpp": 582289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015945241,
    "dropsitcph": 7015945241,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18891",
    "droptype": "D",
    "dropname": "ENDERLIN",
    "dropdeladd": "309 RAILWAY ST",
    "dropdelcty": "ENDERLIN",
    "dropdelst": "ND",
    "dropdelzpp": 580279998,
    "dropphyadd": "309 RAILWAY ST",
    "dropphycty": "ENDERLIN",
    "dropphyst": "ND",
    "dropphyzpp": 580279998,
    "dropmaladd": "309 RAILWAY ST",
    "dropmalcty": "ENDERLIN",
    "dropmalst": "ND",
    "dropmalzpp": 580279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014372057,
    "dropsitcph": 7014372057,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18893",
    "droptype": "D",
    "dropname": "EPPING",
    "dropdeladd": "109 MAIN AVE",
    "dropdelcty": "EPPING",
    "dropdelst": "ND",
    "dropdelzpp": 588439998,
    "dropphyadd": "109 MAIN AVE",
    "dropphycty": "EPPING",
    "dropphyst": "ND",
    "dropphyzpp": 588439998,
    "dropmaladd": "109 MAIN AVE",
    "dropmalcty": "EPPING",
    "dropmalst": "ND",
    "dropmalzpp": 588439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018593441,
    "dropsitcph": 7016605984,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18894",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "406 MAIN AVE",
    "dropdelcty": "ERIE",
    "dropdelst": "ND",
    "dropdelzpp": 580299998,
    "dropphyadd": "406 MAIN AVE",
    "dropphycty": "ERIE",
    "dropphyst": "ND",
    "dropphyzpp": 580299998,
    "dropmaladd": "406 MAIN AVE",
    "dropmalcty": "ERIE",
    "dropmalst": "ND",
    "dropmalzpp": 580299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016682406,
    "dropsitcph": 7016682406,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18895",
    "droptype": "D",
    "dropname": "ESMOND",
    "dropdeladd": "117 1ST AVE N",
    "dropdelcty": "ESMOND",
    "dropdelst": "ND",
    "dropdelzpp": 583329998,
    "dropphyadd": "117 1ST AVE N",
    "dropphycty": "ESMOND",
    "dropphyst": "ND",
    "dropphyzpp": 583329998,
    "dropmaladd": "117 1ST AVE N",
    "dropmalcty": "ESMOND",
    "dropmalst": "ND",
    "dropmalzpp": 583329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012493411,
    "dropsitcph": 7014041167,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18896",
    "droptype": "D",
    "dropname": "FAIRDALE",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "FAIRDALE",
    "dropdelst": "ND",
    "dropdelzpp": 582299998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "FAIRDALE",
    "dropphyst": "ND",
    "dropphyzpp": 582299998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "FAIRDALE",
    "dropmalst": "ND",
    "dropmalzpp": 582299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019662243,
    "dropsitcph": 7019662243,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18898",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "202 MAIN AVE",
    "dropdelcty": "FAIRMOUNT",
    "dropdelst": "ND",
    "dropdelzpp": 580309998,
    "dropphyadd": "202 MAIN AVE",
    "dropphycty": "FAIRMOUNT",
    "dropphyst": "ND",
    "dropphyzpp": 580309998,
    "dropmaladd": "202 MAIN AVE",
    "dropmalcty": "FAIRMOUNT",
    "dropmalst": "ND",
    "dropmalzpp": 580309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014745993,
    "dropsitcph": 7016420175,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18903",
    "droptype": "D",
    "dropname": "FARGO",
    "dropdeladd": "657 2ND AVE N RM 104",
    "dropdelcty": "FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 581029001,
    "dropphyadd": "657 2ND AVE N RM 104",
    "dropphycty": "FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 581029001,
    "dropmaladd": "657 2ND AVE N RM 104",
    "dropmalcty": "FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 581029001,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012416115,
    "dropsitcph": 7012416115,
    "dropfax": 7012716211
  },
  {
    "dcode": "D",
    "dropkey": "PW18905",
    "droptype": "D",
    "dropname": "FESSENDEN",
    "dropdeladd": "82 MAIN AVE S",
    "dropdelcty": "FESSENDEN",
    "dropdelst": "ND",
    "dropdelzpp": 584389998,
    "dropphyadd": "82 MAIN AVE S",
    "dropphycty": "FESSENDEN",
    "dropphyst": "ND",
    "dropphyzpp": 584389998,
    "dropmaladd": "82 MAIN AVE S",
    "dropmalcty": "FESSENDEN",
    "dropmalst": "ND",
    "dropmalzpp": 584389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015473421,
    "dropsitcph": 7016952618,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18907",
    "droptype": "D",
    "dropname": "FINGAL",
    "dropdeladd": "406 3RD ST",
    "dropdelcty": "FINGAL",
    "dropdelst": "ND",
    "dropdelzpp": 580319998,
    "dropphyadd": "406 3RD ST",
    "dropphycty": "FINGAL",
    "dropphyst": "ND",
    "dropphyzpp": 580319998,
    "dropmaladd": "406 3RD ST",
    "dropmalcty": "FINGAL",
    "dropmalst": "ND",
    "dropmalzpp": 580319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014071137,
    "dropsitcph": 7014071137,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18908",
    "droptype": "D",
    "dropname": "FINLEY",
    "dropdeladd": "207 4TH ST W",
    "dropdelcty": "FINLEY",
    "dropdelst": "ND",
    "dropdelzpp": 582309998,
    "dropphyadd": "207 4TH ST W",
    "dropphycty": "FINLEY",
    "dropphyst": "ND",
    "dropphyzpp": 582309998,
    "dropmaladd": "207 4TH ST W",
    "dropmalcty": "FINLEY",
    "dropmalst": "ND",
    "dropmalzpp": 582309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015241661,
    "dropsitcph": 7012916103,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18911",
    "droptype": "D",
    "dropname": "FLASHER",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "FLASHER",
    "dropdelst": "ND",
    "dropdelzpp": 585359998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "FLASHER",
    "dropphyst": "ND",
    "dropphyzpp": 585359998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "FLASHER",
    "dropmalst": "ND",
    "dropmalzpp": 585359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015973381,
    "dropsitcph": 7016950610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW18915",
    "droptype": "D",
    "dropname": "FORBES",
    "dropdeladd": "2 N MAIN ST",
    "dropdelcty": "FORBES",
    "dropdelst": "ND",
    "dropdelzpp": 584399998,
    "dropphyadd": "2 N MAIN ST",
    "dropphycty": "FORBES",
    "dropphyst": "ND",
    "dropphyzpp": 584399998,
    "dropmaladd": "2 N MAIN ST",
    "dropmalcty": "FORBES",
    "dropmalst": "ND",
    "dropmalzpp": 584399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013493465,
    "dropsitcph": 7013493465,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18916",
    "droptype": "D",
    "dropname": "FORDVILLE",
    "dropdeladd": "104 MAIN ST N",
    "dropdelcty": "FORDVILLE",
    "dropdelst": "ND",
    "dropdelzpp": 582319998,
    "dropphyadd": "104 MAIN ST N",
    "dropphycty": "FORDVILLE",
    "dropphyst": "ND",
    "dropphyzpp": 582319998,
    "dropmaladd": "104 MAIN ST N",
    "dropmalcty": "FORDVILLE",
    "dropmalst": "ND",
    "dropmalzpp": 582319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012293644,
    "dropsitcph": 7015102111,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18917",
    "droptype": "D",
    "dropname": "FOREST RIVER",
    "dropdeladd": "106 FRONT ST",
    "dropdelcty": "FOREST RIVER",
    "dropdelst": "ND",
    "dropdelzpp": 582339998,
    "dropphyadd": "106 FRONT ST",
    "dropphycty": "FOREST RIVER",
    "dropphyst": "ND",
    "dropphyzpp": 582339998,
    "dropmaladd": "106 FRONT ST",
    "dropmalcty": "FOREST RIVER",
    "dropmalst": "ND",
    "dropmalzpp": 582339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012483777,
    "dropsitcph": 7012483777,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18918",
    "droptype": "D",
    "dropname": "FORMAN",
    "dropdeladd": "333 MAIN ST S",
    "dropdelcty": "FORMAN",
    "dropdelst": "ND",
    "dropdelzpp": 580329998,
    "dropphyadd": "333 MAIN ST S",
    "dropphycty": "FORMAN",
    "dropphyst": "ND",
    "dropphyzpp": 580329998,
    "dropmaladd": "333 MAIN ST S",
    "dropmalcty": "FORMAN",
    "dropmalst": "ND",
    "dropmalzpp": 580329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017243030,
    "dropsitcph": 7015813584,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18920",
    "droptype": "D",
    "dropname": "FORT RANSOM",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "FORT RANSOM",
    "dropdelst": "ND",
    "dropdelzpp": 580339998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "FORT RANSOM",
    "dropphyst": "ND",
    "dropphyzpp": 580339998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "FORT RANSOM",
    "dropmalst": "ND",
    "dropmalzpp": 580339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019732471,
    "dropsitcph": 7015060277,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18922",
    "droptype": "D",
    "dropname": "FORT TOTTEN",
    "dropdeladd": "816 3RD AVE N",
    "dropdelcty": "FORT TOTTEN",
    "dropdelst": "ND",
    "dropdelzpp": 583359998,
    "dropphyadd": "816 3RD AVE N",
    "dropphycty": "FORT TOTTEN",
    "dropphyst": "ND",
    "dropphyzpp": 583359998,
    "dropmaladd": "816 3RD AVE N",
    "dropmalcty": "FORT TOTTEN",
    "dropmalst": "ND",
    "dropmalzpp": 583359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017664262,
    "dropsitcph": 7017470028,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18923",
    "droptype": "D",
    "dropname": "FORT YATES",
    "dropdeladd": "110 S RIVER RD",
    "dropdelcty": "FORT YATES",
    "dropdelst": "ND",
    "dropdelzpp": 585389998,
    "dropphyadd": "110 S RIVER RD",
    "dropphycty": "FORT YATES",
    "dropphyst": "ND",
    "dropphyzpp": 585389998,
    "dropmaladd": "110 S RIVER RD",
    "dropmalcty": "FORT YATES",
    "dropmalst": "ND",
    "dropmalzpp": 585389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018547412,
    "dropsitcph": 7016950590,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18924",
    "droptype": "D",
    "dropname": "FORTUNA",
    "dropdeladd": "190 N MAIN ST",
    "dropdelcty": "FORTUNA",
    "dropdelst": "ND",
    "dropdelzpp": 588449998,
    "dropphyadd": "190 N MAIN ST",
    "dropphycty": "FORTUNA",
    "dropphyst": "ND",
    "dropphyzpp": 588449998,
    "dropmaladd": "190 N MAIN ST",
    "dropmalcty": "FORTUNA",
    "dropmalst": "ND",
    "dropmalzpp": 588449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018342266,
    "dropsitcph": 7013538648,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18937",
    "droptype": "D",
    "dropname": "FULLERTON",
    "dropdeladd": "109 N MONROE ST",
    "dropdelcty": "FULLERTON",
    "dropdelst": "ND",
    "dropdelzpp": 584419998,
    "dropphyadd": "109 N MONROE ST",
    "dropphycty": "FULLERTON",
    "dropphyst": "ND",
    "dropphyzpp": 584419998,
    "dropmaladd": "109 N MONROE ST",
    "dropmalcty": "FULLERTON",
    "dropmalst": "ND",
    "dropmalzpp": 584419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013757381,
    "dropsitcph": 7013684230,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18938",
    "droptype": "D",
    "dropname": "GACKLE",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "GACKLE",
    "dropdelst": "ND",
    "dropdelzpp": 584429998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "GACKLE",
    "dropphyst": "ND",
    "dropphyzpp": 584429998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "GACKLE",
    "dropmalst": "ND",
    "dropmalzpp": 584429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014853704,
    "dropsitcph": 7015816850,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18940",
    "droptype": "D",
    "dropname": "GALESBURG",
    "dropdeladd": "102 DAKOTA AVE E",
    "dropdelcty": "GALESBURG",
    "dropdelst": "ND",
    "dropdelzpp": 580359998,
    "dropphyadd": "102 DAKOTA AVE E",
    "dropphycty": "GALESBURG",
    "dropphyst": "ND",
    "dropphyzpp": 580359998,
    "dropmaladd": "102 DAKOTA AVE E",
    "dropmalcty": "GALESBURG",
    "dropmalst": "ND",
    "dropmalzpp": 580359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014882737,
    "dropsitcph": 7014144006,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18944",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "33 1ST AVE NW",
    "dropdelcty": "GARRISON",
    "dropdelst": "ND",
    "dropdelzpp": 585409998,
    "dropphyadd": "33 1ST AVE NW",
    "dropphycty": "GARRISON",
    "dropphyst": "ND",
    "dropphyzpp": 585409998,
    "dropmaladd": "33 1ST AVE NW",
    "dropmalcty": "GARRISON",
    "dropmalst": "ND",
    "dropmalzpp": 585409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014632510,
    "dropsitcph": 7017470408,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18950",
    "droptype": "D",
    "dropname": "GILBY",
    "dropdeladd": "209 MAIN AVE",
    "dropdelcty": "GILBY",
    "dropdelst": "ND",
    "dropdelzpp": 582359998,
    "dropphyadd": "209 MAIN AVE",
    "dropphycty": "GILBY",
    "dropphyst": "ND",
    "dropphyzpp": 582359998,
    "dropmaladd": "209 MAIN AVE",
    "dropmalcty": "GILBY",
    "dropmalst": "ND",
    "dropmalzpp": 582359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018692380,
    "dropsitcph": 7015102040,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18951",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "114 5TH AVE",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "ND",
    "dropdelzpp": 586309998,
    "dropphyadd": "114 5TH AVE",
    "dropphycty": "GLADSTONE",
    "dropphyst": "ND",
    "dropphyzpp": 586309998,
    "dropmaladd": "114 5TH AVE",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "ND",
    "dropmalzpp": 586309998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012270025,
    "dropsitcph": 7012270025,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18953",
    "droptype": "D",
    "dropname": "GLEN ULLIN",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "GLEN ULLIN",
    "dropdelst": "ND",
    "dropdelzpp": 586319998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "GLEN ULLIN",
    "dropphyst": "ND",
    "dropphyzpp": 586319998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "GLEN ULLIN",
    "dropmalst": "ND",
    "dropmalzpp": 586319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013483661,
    "dropsitcph": 7016950697,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18954",
    "droptype": "D",
    "dropname": "GLENBURN",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "GLENBURN",
    "dropdelst": "ND",
    "dropdelzpp": 587409998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "GLENBURN",
    "dropphyst": "ND",
    "dropphyzpp": 587409998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "GLENBURN",
    "dropmalst": "ND",
    "dropmalzpp": 587409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013627406,
    "dropsitcph": 7013627406,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18955",
    "droptype": "D",
    "dropname": "GLENFIELD",
    "dropdeladd": "161 GLENFIELD ST",
    "dropdelcty": "GLENFIELD",
    "dropdelst": "ND",
    "dropdelzpp": 584439998,
    "dropphyadd": "161 GLENFIELD ST",
    "dropphycty": "GLENFIELD",
    "dropphyst": "ND",
    "dropphyzpp": 584439998,
    "dropmaladd": "161 GLENFIELD ST",
    "dropmalcty": "GLENFIELD",
    "dropmalst": "ND",
    "dropmalzpp": 584439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017852188,
    "dropsitcph": 7014041180,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18957",
    "droptype": "D",
    "dropname": "GOLDEN VALLEY",
    "dropdeladd": "13 MAIN ST W",
    "dropdelcty": "GOLDEN VALLEY",
    "dropdelst": "ND",
    "dropdelzpp": 585419998,
    "dropphyadd": "13 MAIN ST W",
    "dropphycty": "GOLDEN VALLEY",
    "dropphyst": "ND",
    "dropphyzpp": 585419998,
    "dropmaladd": "13 MAIN ST W",
    "dropmalcty": "GOLDEN VALLEY",
    "dropmalst": "ND",
    "dropmalzpp": 585419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019834216,
    "dropsitcph": 7016605930,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18960",
    "droptype": "D",
    "dropname": "GOLVA",
    "dropdeladd": "405 TERRELL AVE",
    "dropdelcty": "GOLVA",
    "dropdelst": "ND",
    "dropdelzpp": 586329998,
    "dropphyadd": "405 TERRELL AVE",
    "dropphycty": "GOLVA",
    "dropphyst": "ND",
    "dropphyzpp": 586329998,
    "dropmaladd": "405 TERRELL AVE",
    "dropmalcty": "GOLVA",
    "dropmalst": "ND",
    "dropmalzpp": 586329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016605936,
    "dropsitcph": 7016605936,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18961",
    "droptype": "D",
    "dropname": "GOODRICH",
    "dropdeladd": "204 CLARK AVE",
    "dropdelcty": "GOODRICH",
    "dropdelst": "ND",
    "dropdelzpp": 584449998,
    "dropphyadd": "204 CLARK AVE",
    "dropphycty": "GOODRICH",
    "dropphyst": "ND",
    "dropphyzpp": 584449998,
    "dropmaladd": "204 CLARK AVE",
    "dropmalcty": "GOODRICH",
    "dropmalst": "ND",
    "dropmalzpp": 584449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018842465,
    "dropsitcph": 7018854007,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18963",
    "droptype": "D",
    "dropname": "GRACE CITY",
    "dropdeladd": "128 CITY ST",
    "dropdelcty": "GRACE CITY",
    "dropdelst": "ND",
    "dropdelzpp": 584459998,
    "dropphyadd": "128 CITY ST",
    "dropphycty": "GRACE CITY",
    "dropphyst": "ND",
    "dropphyzpp": 584459998,
    "dropmaladd": "128 CITY ST",
    "dropmalcty": "GRACE CITY",
    "dropmalst": "ND",
    "dropmalzpp": 584459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016743216,
    "dropsitcph": 7014041093,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18965",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "506 GRIGGS AVE",
    "dropdelcty": "GRAFTON",
    "dropdelst": "ND",
    "dropdelzpp": 582379998,
    "dropphyadd": "506 GRIGGS AVE",
    "dropphycty": "GRAFTON",
    "dropphyst": "ND",
    "dropphyzpp": 582379998,
    "dropmaladd": "506 GRIGGS AVE",
    "dropmalcty": "GRAFTON",
    "dropmalst": "ND",
    "dropmalzpp": 582379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013520910,
    "dropsitcph": 7013520910,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18967",
    "droptype": "D",
    "dropname": "GRAND FORKS",
    "dropdeladd": "2501 28TH AVE S",
    "dropdelcty": "GRAND FORKS",
    "dropdelst": "ND",
    "dropdelzpp": 582019998,
    "dropphyadd": "2501 28TH AVE S",
    "dropphycty": "GRAND FORKS",
    "dropphyst": "ND",
    "dropphyzpp": 582019998,
    "dropmaladd": "2501 28TH AVE S",
    "dropmalcty": "GRAND FORKS",
    "dropmalst": "ND",
    "dropmalzpp": 582019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013352050,
    "dropsitcph": 7013352001,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18971",
    "droptype": "D",
    "dropname": "GRANDIN",
    "dropdeladd": "301 3RD ST",
    "dropdelcty": "GRANDIN",
    "dropdelst": "ND",
    "dropdelzpp": 580389998,
    "dropphyadd": "301 3RD ST",
    "dropphycty": "GRANDIN",
    "dropphyst": "ND",
    "dropphyzpp": 580389998,
    "dropmaladd": "301 3RD ST",
    "dropmalcty": "GRANDIN",
    "dropmalst": "ND",
    "dropmalzpp": 580389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014845229,
    "dropsitcph": 7014845229,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18973",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "106 1ST ST SW",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "ND",
    "dropdelzpp": 587419998,
    "dropphyadd": "106 1ST ST SW",
    "dropphycty": "GRANVILLE",
    "dropphyst": "ND",
    "dropphyzpp": 587419998,
    "dropmaladd": "106 1ST ST SW",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "ND",
    "dropmalzpp": 587419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017286406,
    "dropsitcph": 7017470594,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18974",
    "droptype": "D",
    "dropname": "GRASSY BUTTE",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "GRASSY BUTTE",
    "dropdelst": "ND",
    "dropdelzpp": 586349998,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "GRASSY BUTTE",
    "dropphyst": "ND",
    "dropphyzpp": 586349998,
    "dropmaladd": "409 MAIN ST",
    "dropmalcty": "GRASSY BUTTE",
    "dropmalst": "ND",
    "dropmalzpp": 586349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018636570,
    "dropsitcph": 7016969312,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18977",
    "droptype": "D",
    "dropname": "GRENORA",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "GRENORA",
    "dropdelst": "ND",
    "dropdelzpp": 588459998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "GRENORA",
    "dropphyst": "ND",
    "dropphyzpp": 588459998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "GRENORA",
    "dropmalst": "ND",
    "dropmalzpp": 588459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016942612,
    "dropsitcph": 7016942612,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18981",
    "droptype": "D",
    "dropname": "GWINNER",
    "dropdeladd": "21 S MAIN ST",
    "dropdelcty": "GWINNER",
    "dropdelst": "ND",
    "dropdelzpp": 580409998,
    "dropphyadd": "21 S MAIN ST",
    "dropphycty": "GWINNER",
    "dropphyst": "ND",
    "dropphyzpp": 580409998,
    "dropmaladd": "21 S MAIN ST",
    "dropmalcty": "GWINNER",
    "dropmalst": "ND",
    "dropmalzpp": 580409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016782679,
    "dropsitcph": 7016782679,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18982",
    "droptype": "D",
    "dropname": "HAGUE",
    "dropdeladd": "215 MAIN AVE W",
    "dropdelcty": "HAGUE",
    "dropdelst": "ND",
    "dropdelzpp": 585429998,
    "dropphyadd": "215 MAIN AVE W",
    "dropphycty": "HAGUE",
    "dropphyst": "ND",
    "dropphyzpp": 585429998,
    "dropmaladd": "215 MAIN AVE W",
    "dropmalcty": "HAGUE",
    "dropmalst": "ND",
    "dropmalzpp": 585429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013367310,
    "dropsitcph": 7013367310,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18984",
    "droptype": "D",
    "dropname": "HALLIDAY",
    "dropdeladd": "113 E MAIN ST",
    "dropdelcty": "HALLIDAY",
    "dropdelst": "ND",
    "dropdelzpp": 586369998,
    "dropphyadd": "113 E MAIN ST",
    "dropphycty": "HALLIDAY",
    "dropphyst": "ND",
    "dropphyzpp": 586369998,
    "dropmaladd": "113 E MAIN ST",
    "dropmalcty": "HALLIDAY",
    "dropmalst": "ND",
    "dropmalzpp": 586369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019384659,
    "dropsitcph": 7019384659,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18988",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "402 PAGE AVE STE A",
    "dropdelcty": "HAMILTON",
    "dropdelst": "ND",
    "dropdelzpp": 582389998,
    "dropphyadd": "402 PAGE AVE STE A",
    "dropphycty": "HAMILTON",
    "dropphyst": "ND",
    "dropphyzpp": 582389998,
    "dropmaladd": "402 PAGE AVE STE A",
    "dropmalcty": "HAMILTON",
    "dropmalst": "ND",
    "dropmalzpp": 582389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012658276,
    "dropsitcph": 7012658276,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18990",
    "droptype": "D",
    "dropname": "HAMPDEN",
    "dropdeladd": "213 MAIN ST W",
    "dropdelcty": "HAMPDEN",
    "dropdelst": "ND",
    "dropdelzpp": 583389998,
    "dropphyadd": "213 MAIN ST W",
    "dropphycty": "HAMPDEN",
    "dropphyst": "ND",
    "dropphyzpp": 583389998,
    "dropmaladd": "213 MAIN ST W",
    "dropmalcty": "HAMPDEN",
    "dropmalst": "ND",
    "dropmalzpp": 583389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018683111,
    "dropsitcph": 7015058203,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18991",
    "droptype": "D",
    "dropname": "HANKINSON",
    "dropdeladd": "345 MAIN AVE S",
    "dropdelcty": "HANKINSON",
    "dropdelst": "ND",
    "dropdelzpp": 580419998,
    "dropphyadd": "345 MAIN AVE S",
    "dropphycty": "HANKINSON",
    "dropphyst": "ND",
    "dropphyzpp": 580419998,
    "dropmaladd": "345 MAIN AVE S",
    "dropmalcty": "HANKINSON",
    "dropmalst": "ND",
    "dropmalzpp": 580419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014031750,
    "dropsitcph": 7014031750,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18993",
    "droptype": "D",
    "dropname": "HANNAFORD",
    "dropdeladd": "286 BRIDGE AVE",
    "dropdelcty": "HANNAFORD",
    "dropdelst": "ND",
    "dropdelzpp": 584489998,
    "dropphyadd": "286 BRIDGE AVE",
    "dropphycty": "HANNAFORD",
    "dropphyst": "ND",
    "dropphyzpp": 584489998,
    "dropmaladd": "286 BRIDGE AVE",
    "dropmalcty": "HANNAFORD",
    "dropmalst": "ND",
    "dropmalzpp": 584489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017692405,
    "dropsitcph": 7017692405,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW18999",
    "droptype": "D",
    "dropname": "HARVEY",
    "dropdeladd": "708 ADAMS AVE",
    "dropdelcty": "HARVEY",
    "dropdelst": "ND",
    "dropdelzpp": 583419998,
    "dropphyadd": "708 ADAMS AVE",
    "dropphycty": "HARVEY",
    "dropphyst": "ND",
    "dropphyzpp": 583419998,
    "dropmaladd": "708 ADAMS AVE",
    "dropmalcty": "HARVEY",
    "dropmalst": "ND",
    "dropmalzpp": 583419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013244150,
    "dropsitcph": 7013179143,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19000",
    "droptype": "D",
    "dropname": "HARWOOD",
    "dropdeladd": "521 DAKOTA AVE",
    "dropdelcty": "HARWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 580429998,
    "dropphyadd": "521 DAKOTA AVE",
    "dropphycty": "HARWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 580429998,
    "dropmaladd": "521 DAKOTA AVE",
    "dropmalcty": "HARWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 580429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012824800,
    "dropsitcph": 7012824800,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19002",
    "droptype": "D",
    "dropname": "HATTON",
    "dropdeladd": "611 RAILROAD AVE E",
    "dropdelcty": "HATTON",
    "dropdelst": "ND",
    "dropdelzpp": 582409998,
    "dropphyadd": "611 RAILROAD AVE E",
    "dropphycty": "HATTON",
    "dropphyst": "ND",
    "dropphyzpp": 582409998,
    "dropmaladd": "611 RAILROAD AVE E",
    "dropmalcty": "HATTON",
    "dropmalst": "ND",
    "dropmalzpp": 582409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015433633,
    "dropsitcph": 7015433633,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19003",
    "droptype": "D",
    "dropname": "HAVANA",
    "dropdeladd": "112 SARGENT AVE W",
    "dropdelcty": "HAVANA",
    "dropdelst": "ND",
    "dropdelzpp": 580439998,
    "dropphyadd": "112 SARGENT AVE W",
    "dropphycty": "HAVANA",
    "dropphyst": "ND",
    "dropphyzpp": 580439998,
    "dropmaladd": "112 SARGENT AVE W",
    "dropmalcty": "HAVANA",
    "dropmalst": "ND",
    "dropmalzpp": 580439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017243078,
    "dropsitcph": 7017243078,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19007",
    "droptype": "D",
    "dropname": "HAZELTON",
    "dropdeladd": "345 MAIN ST",
    "dropdelcty": "HAZELTON",
    "dropdelst": "ND",
    "dropdelzpp": 585449998,
    "dropphyadd": "345 MAIN ST",
    "dropphycty": "HAZELTON",
    "dropphyst": "ND",
    "dropphyzpp": 585449998,
    "dropmaladd": "345 MAIN ST",
    "dropmalcty": "HAZELTON",
    "dropmalst": "ND",
    "dropmalzpp": 585449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015817720,
    "dropsitcph": 7015817720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19008",
    "droptype": "D",
    "dropname": "HAZEN",
    "dropdeladd": "13 1ST AVE SW",
    "dropdelcty": "HAZEN",
    "dropdelst": "ND",
    "dropdelzpp": 585459998,
    "dropphyadd": "13 1ST AVE SW",
    "dropphycty": "HAZEN",
    "dropphyst": "ND",
    "dropphyzpp": 585459998,
    "dropmaladd": "13 1ST AVE SW",
    "dropmalcty": "HAZEN",
    "dropmalst": "ND",
    "dropmalzpp": 585459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017482727,
    "dropsitcph": 7016950682,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19010",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "111 S PARK ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "ND",
    "dropdelzpp": 586389998,
    "dropphyadd": "111 S PARK ST",
    "dropphycty": "HEBRON",
    "dropphyst": "ND",
    "dropphyzpp": 586389998,
    "dropmaladd": "111 S PARK ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "ND",
    "dropmalzpp": 586389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018784555,
    "dropsitcph": 7016950684,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19013",
    "droptype": "D",
    "dropname": "HENSEL",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "HENSEL",
    "dropdelst": "ND",
    "dropdelzpp": 582419998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "HENSEL",
    "dropphyst": "ND",
    "dropphyzpp": 582419998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "HENSEL",
    "dropmalst": "ND",
    "dropmalzpp": 582419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016572155,
    "dropsitcph": 7016572155,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19016",
    "droptype": "D",
    "dropname": "HETTINGER",
    "dropdeladd": "502 ADAMS AVE",
    "dropdelcty": "HETTINGER",
    "dropdelst": "ND",
    "dropdelzpp": 586399998,
    "dropphyadd": "502 ADAMS AVE",
    "dropphycty": "HETTINGER",
    "dropphyst": "ND",
    "dropphyzpp": 586399998,
    "dropmaladd": "502 ADAMS AVE",
    "dropmalcty": "HETTINGER",
    "dropmalst": "ND",
    "dropmalzpp": 586399998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016950582,
    "dropsitcph": 7016950582,
    "dropfax": 7015676515
  },
  {
    "dcode": "D",
    "dropkey": "PW19018",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "16 1ST ST NW",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "ND",
    "dropdelzpp": 580459998,
    "dropphyadd": "16 1ST ST NW",
    "dropphycty": "HILLSBORO",
    "dropphyst": "ND",
    "dropphyzpp": 580459998,
    "dropmaladd": "16 1ST ST NW",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "ND",
    "dropmalzpp": 580459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014364221,
    "dropsitcph": 7014364221,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19021",
    "droptype": "D",
    "dropname": "HOOPLE",
    "dropdeladd": "236 2ND ST",
    "dropdelcty": "HOOPLE",
    "dropdelst": "ND",
    "dropdelzpp": 582439998,
    "dropphyadd": "236 2ND ST",
    "dropphycty": "HOOPLE",
    "dropphyst": "ND",
    "dropphyzpp": 582439998,
    "dropmaladd": "236 2ND ST",
    "dropmalcty": "HOOPLE",
    "dropmalst": "ND",
    "dropmalzpp": 582439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018946525,
    "dropsitcph": 7015102299,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19022",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "206 STEELE AVE",
    "dropdelcty": "HOPE",
    "dropdelst": "ND",
    "dropdelzpp": 580469998,
    "dropphyadd": "206 STEELE AVE",
    "dropphycty": "HOPE",
    "dropphyst": "ND",
    "dropphyzpp": 580469998,
    "dropmaladd": "206 STEELE AVE",
    "dropmalcty": "HOPE",
    "dropmalst": "ND",
    "dropmalzpp": 580469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019452559,
    "dropsitcph": 7019452559,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19023",
    "droptype": "D",
    "dropname": "HORACE",
    "dropdeladd": "91 MAIN ST N",
    "dropdelcty": "HORACE",
    "dropdelst": "ND",
    "dropdelzpp": 580479998,
    "dropphyadd": "91 MAIN ST N",
    "dropphycty": "HORACE",
    "dropphyst": "ND",
    "dropphyzpp": 580479998,
    "dropmaladd": "91 MAIN ST N",
    "dropmalcty": "HORACE",
    "dropmalst": "ND",
    "dropmalzpp": 580479998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012826565,
    "dropsitcph": 7012826565,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19025",
    "droptype": "D",
    "dropname": "HUNTER",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "HUNTER",
    "dropdelst": "ND",
    "dropdelzpp": 580489998,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "HUNTER",
    "dropphyst": "ND",
    "dropphyzpp": 580489998,
    "dropmaladd": "107 MAIN ST",
    "dropmalcty": "HUNTER",
    "dropmalst": "ND",
    "dropmalzpp": 580489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018742388,
    "dropsitcph": 7018742388,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19026",
    "droptype": "D",
    "dropname": "HURDSFIELD",
    "dropdeladd": "103 MAIN ST W",
    "dropdelcty": "HURDSFIELD",
    "dropdelst": "ND",
    "dropdelzpp": 584519998,
    "dropphyadd": "103 MAIN ST W",
    "dropphycty": "HURDSFIELD",
    "dropphyst": "ND",
    "dropphyzpp": 584519998,
    "dropmaladd": "103 MAIN ST W",
    "dropmalcty": "HURDSFIELD",
    "dropmalst": "ND",
    "dropmalzpp": 584519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019623666,
    "dropsitcph": 8779072560,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19029",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "212 2ND ST SW",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "ND",
    "dropdelzpp": 584019998,
    "dropphyadd": "212 2ND ST SW",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "ND",
    "dropphyzpp": 584019998,
    "dropmaladd": "212 2ND ST SW",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "ND",
    "dropmalzpp": 584019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012523855,
    "dropsitcph": 7012523855,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19038",
    "droptype": "D",
    "dropname": "JUD",
    "dropdeladd": "524 LOGIE ST",
    "dropdelcty": "JUD",
    "dropdelst": "ND",
    "dropdelzpp": 584549998,
    "dropphyadd": "524 LOGIE ST",
    "dropphycty": "JUD",
    "dropphyst": "ND",
    "dropphyzpp": 584549998,
    "dropmaladd": "524 LOGIE ST",
    "dropmalcty": "JUD",
    "dropmalst": "ND",
    "dropmalzpp": 584549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016852661,
    "dropsitcph": 7016852661,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19040",
    "droptype": "D",
    "dropname": "KARLSRUHE",
    "dropdeladd": "101 MAIN ST N",
    "dropdelcty": "KARLSRUHE",
    "dropdelst": "ND",
    "dropdelzpp": 587449998,
    "dropphyadd": "101 MAIN ST N",
    "dropphycty": "KARLSRUHE",
    "dropphyst": "ND",
    "dropphyzpp": 587449998,
    "dropmaladd": "101 MAIN ST N",
    "dropmalcty": "KARLSRUHE",
    "dropmalst": "ND",
    "dropmalzpp": 587449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015256658,
    "dropsitcph": 7014041148,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19042",
    "droptype": "D",
    "dropname": "KATHRYN",
    "dropdeladd": "307 1ST AVE",
    "dropdelcty": "KATHRYN",
    "dropdelst": "ND",
    "dropdelzpp": 580499998,
    "dropphyadd": "307 1ST AVE",
    "dropphycty": "KATHRYN",
    "dropphyst": "ND",
    "dropphyzpp": 580499998,
    "dropmaladd": "307 1ST AVE",
    "dropmalcty": "KATHRYN",
    "dropmalst": "ND",
    "dropmalzpp": 580499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014903655,
    "dropsitcph": 7014903655,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19047",
    "droptype": "D",
    "dropname": "KENMARE",
    "dropdeladd": "22 2ND ST NW",
    "dropdelcty": "KENMARE",
    "dropdelst": "ND",
    "dropdelzpp": 587469998,
    "dropphyadd": "22 2ND ST NW",
    "dropphycty": "KENMARE",
    "dropphyst": "ND",
    "dropphyzpp": 587469998,
    "dropmaladd": "22 2ND ST NW",
    "dropmalcty": "KENMARE",
    "dropmalst": "ND",
    "dropmalzpp": 587469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013854855,
    "dropsitcph": 7016605969,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19048",
    "droptype": "D",
    "dropname": "KENSAL",
    "dropdeladd": "402 MAIN",
    "dropdelcty": "KENSAL",
    "dropdelst": "ND",
    "dropdelzpp": 584559998,
    "dropphyadd": "402 MAIN",
    "dropphycty": "KENSAL",
    "dropphyst": "ND",
    "dropphyzpp": 584559998,
    "dropmaladd": "402 MAIN",
    "dropmalcty": "KENSAL",
    "dropmalst": "ND",
    "dropmalzpp": 584559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014352413,
    "dropsitcph": 7014352413,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19050",
    "droptype": "D",
    "dropname": "KILLDEER",
    "dropdeladd": "48 CENTRAL AVE S",
    "dropdelcty": "KILLDEER",
    "dropdelst": "ND",
    "dropdelzpp": 586409998,
    "dropphyadd": "48 CENTRAL AVE S",
    "dropphycty": "KILLDEER",
    "dropphyst": "ND",
    "dropphyzpp": 586409998,
    "dropmaladd": "48 CENTRAL AVE S",
    "dropmalcty": "KILLDEER",
    "dropmalst": "ND",
    "dropmalzpp": 586409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017645367,
    "dropsitcph": 8773646454,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19051",
    "droptype": "D",
    "dropname": "KINDRED",
    "dropdeladd": "472 ELM ST",
    "dropdelcty": "KINDRED",
    "dropdelst": "ND",
    "dropdelzpp": 580519998,
    "dropphyadd": "472 ELM ST",
    "dropphycty": "KINDRED",
    "dropphyst": "ND",
    "dropphyzpp": 580519998,
    "dropmaladd": "472 ELM ST",
    "dropmalcty": "KINDRED",
    "dropmalst": "ND",
    "dropmalzpp": 580519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014283240,
    "dropsitcph": 7014283240,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19057",
    "droptype": "D",
    "dropname": "KRAMER",
    "dropdeladd": "175 MAIN ST",
    "dropdelcty": "KRAMER",
    "dropdelst": "ND",
    "dropdelzpp": 587489998,
    "dropphyadd": "175 MAIN ST",
    "dropphycty": "KRAMER",
    "dropphyst": "ND",
    "dropphyzpp": 587489998,
    "dropmaladd": "175 MAIN ST",
    "dropmalcty": "KRAMER",
    "dropmalst": "ND",
    "dropmalzpp": 587489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013594302,
    "dropsitcph": 7013538547,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19058",
    "droptype": "D",
    "dropname": "KULM",
    "dropdeladd": "11 MAIN AVE S",
    "dropdelcty": "KULM",
    "dropdelst": "ND",
    "dropdelzpp": 584569998,
    "dropphyadd": "11 MAIN AVE S",
    "dropphycty": "KULM",
    "dropphyst": "ND",
    "dropphyzpp": 584569998,
    "dropmaladd": "11 MAIN AVE S",
    "dropmalcty": "KULM",
    "dropmalst": "ND",
    "dropmalzpp": 584569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016472786,
    "dropsitcph": 7016472786,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19064",
    "droptype": "D",
    "dropname": "LAKOTA",
    "dropdeladd": "209 MAIN ST N",
    "dropdelcty": "LAKOTA",
    "dropdelst": "ND",
    "dropdelzpp": 583449998,
    "dropphyadd": "209 MAIN ST N",
    "dropphycty": "LAKOTA",
    "dropphyst": "ND",
    "dropphyzpp": 583449998,
    "dropmaladd": "209 MAIN ST N",
    "dropmalcty": "LAKOTA",
    "dropmalst": "ND",
    "dropmalzpp": 583449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015058362,
    "dropsitcph": 7015058362,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19065",
    "droptype": "D",
    "dropname": "LAMOURE",
    "dropdeladd": "23 CENTER AVE E",
    "dropdelcty": "LAMOURE",
    "dropdelst": "ND",
    "dropdelzpp": 584589998,
    "dropphyadd": "23 CENTER AVE E",
    "dropphycty": "LAMOURE",
    "dropphyst": "ND",
    "dropphyzpp": 584589998,
    "dropmaladd": "23 CENTER AVE E",
    "dropmalcty": "LAMOURE",
    "dropmalst": "ND",
    "dropmalzpp": 584589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018835258,
    "dropsitcph": 7018854008,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19067",
    "droptype": "D",
    "dropname": "LANGDON",
    "dropdeladd": "323 8TH AVE",
    "dropdelcty": "LANGDON",
    "dropdelst": "ND",
    "dropdelzpp": 582499998,
    "dropphyadd": "323 8TH AVE",
    "dropphycty": "LANGDON",
    "dropphyst": "ND",
    "dropphyzpp": 582499998,
    "dropmaladd": "323 8TH AVE",
    "dropmalcty": "LANGDON",
    "dropmalst": "ND",
    "dropmalzpp": 582499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012562189,
    "dropsitcph": 7015818055,
    "dropfax": 7012565009
  },
  {
    "dcode": "D",
    "dropkey": "PW19068",
    "droptype": "D",
    "dropname": "LANKIN",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "LANKIN",
    "dropdelst": "ND",
    "dropdelzpp": 582509998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "LANKIN",
    "dropphyst": "ND",
    "dropphyzpp": 582509998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "LANKIN",
    "dropmalst": "ND",
    "dropmalzpp": 582509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015936242,
    "dropsitcph": 7016950667,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19069",
    "droptype": "D",
    "dropname": "LANSFORD",
    "dropdeladd": "706 MAIN ST",
    "dropdelcty": "LANSFORD",
    "dropdelst": "ND",
    "dropdelzpp": 587509998,
    "dropphyadd": "706 MAIN ST",
    "dropphycty": "LANSFORD",
    "dropphyst": "ND",
    "dropphyzpp": 587509998,
    "dropmaladd": "706 MAIN ST",
    "dropmalcty": "LANSFORD",
    "dropmalst": "ND",
    "dropmalzpp": 587509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017845949,
    "dropsitcph": 7017845949,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19070",
    "droptype": "D",
    "dropname": "LARIMORE",
    "dropdeladd": "208 E FRONT ST",
    "dropdelcty": "LARIMORE",
    "dropdelst": "ND",
    "dropdelzpp": 582519998,
    "dropphyadd": "208 E FRONT ST",
    "dropphycty": "LARIMORE",
    "dropphyst": "ND",
    "dropphyzpp": 582519998,
    "dropmaladd": "208 E FRONT ST",
    "dropmalcty": "LARIMORE",
    "dropmalst": "ND",
    "dropmalzpp": 582519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013432941,
    "dropsitcph": 7013432941,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19073",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "ND",
    "dropdelzpp": 583459998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "LAWTON",
    "dropphyst": "ND",
    "dropphyzpp": 583459998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "LAWTON",
    "dropmalst": "ND",
    "dropmalzpp": 583459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015058422,
    "dropsitcph": 7015058422,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19075",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "150 MAIN ST W",
    "dropdelcty": "LEEDS",
    "dropdelst": "ND",
    "dropdelzpp": 583469998,
    "dropphyadd": "150 MAIN ST W",
    "dropphycty": "LEEDS",
    "dropphyst": "ND",
    "dropphyzpp": 583469998,
    "dropmaladd": "150 MAIN ST W",
    "dropmalcty": "LEEDS",
    "dropmalst": "ND",
    "dropmalzpp": 583469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014662611,
    "dropsitcph": 7014662611,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19078",
    "droptype": "D",
    "dropname": "LEHR",
    "dropdeladd": "200 MAIN ST S",
    "dropdelcty": "LEHR",
    "dropdelst": "ND",
    "dropdelzpp": 584609998,
    "dropphyadd": "200 MAIN ST S",
    "dropphycty": "LEHR",
    "dropphyst": "ND",
    "dropphyzpp": 584609998,
    "dropmaladd": "200 MAIN ST S",
    "dropmalcty": "LEHR",
    "dropmalst": "ND",
    "dropmalzpp": 584609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013782231,
    "dropsitcph": 7016381264,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19080",
    "droptype": "D",
    "dropname": "LEONARD",
    "dropdeladd": "406 RAILROAD AVE S",
    "dropdelcty": "LEONARD",
    "dropdelst": "ND",
    "dropdelzpp": 580529998,
    "dropphyadd": "406 RAILROAD AVE S",
    "dropphycty": "LEONARD",
    "dropphyst": "ND",
    "dropphyzpp": 580529998,
    "dropmaladd": "406 RAILROAD AVE S",
    "dropmalcty": "LEONARD",
    "dropmalst": "ND",
    "dropmalzpp": 580529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016452323,
    "dropsitcph": 7016452323,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19082",
    "droptype": "D",
    "dropname": "LIDGERWOOD",
    "dropdeladd": "34 WILEY AVE S",
    "dropdelcty": "LIDGERWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 580539998,
    "dropphyadd": "34 WILEY AVE S",
    "dropphycty": "LIDGERWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 580539998,
    "dropmaladd": "34 WILEY AVE S",
    "dropmalcty": "LIDGERWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 580539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015384151,
    "dropsitcph": 7016605768,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19083",
    "droptype": "D",
    "dropname": "LIGNITE",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "LIGNITE",
    "dropdelst": "ND",
    "dropdelzpp": 587529998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "LIGNITE",
    "dropphyst": "ND",
    "dropphyzpp": 587529998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "LIGNITE",
    "dropmalst": "ND",
    "dropmalzpp": 587529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013538682,
    "dropsitcph": 7013538682,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19085",
    "droptype": "D",
    "dropname": "LINTON",
    "dropdeladd": "115 NW 1ST ST",
    "dropdelcty": "LINTON",
    "dropdelst": "ND",
    "dropdelzpp": 585529998,
    "dropphyadd": "115 NW 1ST ST",
    "dropphycty": "LINTON",
    "dropphyst": "ND",
    "dropphyzpp": 585529998,
    "dropmaladd": "115 NW 1ST ST",
    "dropmalcty": "LINTON",
    "dropmalst": "ND",
    "dropmalzpp": 585529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014098312,
    "dropsitcph": 7014098312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19087",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "17 4TH AVE W",
    "dropdelcty": "LISBON",
    "dropdelst": "ND",
    "dropdelzpp": 580549998,
    "dropphyadd": "17 4TH AVE W",
    "dropphycty": "LISBON",
    "dropphyst": "ND",
    "dropphyzpp": 580549998,
    "dropmaladd": "17 4TH AVE W",
    "dropmalcty": "LISBON",
    "dropmalst": "ND",
    "dropmalzpp": 580549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016835655,
    "dropsitcph": 7013358313,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19088",
    "droptype": "D",
    "dropname": "LITCHVILLE",
    "dropdeladd": "508 3RD AVE",
    "dropdelcty": "LITCHVILLE",
    "dropdelst": "ND",
    "dropdelzpp": 584619998,
    "dropphyadd": "508 3RD AVE",
    "dropphycty": "LITCHVILLE",
    "dropphyst": "ND",
    "dropphyzpp": 584619998,
    "dropmaladd": "508 3RD AVE",
    "dropmalcty": "LITCHVILLE",
    "dropmalst": "ND",
    "dropmalzpp": 584619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017624269,
    "dropsitcph": 8778541234,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19099",
    "droptype": "D",
    "dropname": "MADDOCK",
    "dropdeladd": "202 CENTRAL AVE",
    "dropdelcty": "MADDOCK",
    "dropdelst": "ND",
    "dropdelzpp": 583489998,
    "dropphyadd": "202 CENTRAL AVE",
    "dropphycty": "MADDOCK",
    "dropphyst": "ND",
    "dropphyzpp": 583489998,
    "dropmaladd": "202 CENTRAL AVE",
    "dropmalcty": "MADDOCK",
    "dropmalst": "ND",
    "dropmalzpp": 583489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014382612,
    "dropsitcph": 7016952733,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19102",
    "droptype": "D",
    "dropname": "MAKOTI",
    "dropdeladd": "220 MAIN ST N",
    "dropdelcty": "MAKOTI",
    "dropdelst": "ND",
    "dropdelzpp": 587569998,
    "dropphyadd": "220 MAIN ST N",
    "dropphycty": "MAKOTI",
    "dropphyst": "ND",
    "dropphyzpp": 587569998,
    "dropmaladd": "220 MAIN ST N",
    "dropmalcty": "MAKOTI",
    "dropmalst": "ND",
    "dropmalzpp": 587569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017265516,
    "dropsitcph": 7017470679,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19103",
    "droptype": "D",
    "dropname": "MANDAN",
    "dropdeladd": "300 COLLINS AVE",
    "dropdelcty": "MANDAN",
    "dropdelst": "ND",
    "dropdelzpp": 585549998,
    "dropphyadd": "300 COLLINS AVE",
    "dropphycty": "MANDAN",
    "dropphyst": "ND",
    "dropphyzpp": 585549998,
    "dropmaladd": "300 COLLINS AVE",
    "dropmalcty": "MANDAN",
    "dropmalst": "ND",
    "dropmalzpp": 585549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016637534,
    "dropsitcph": 7016637534,
    "dropfax": 7016638256
  },
  {
    "dcode": "D",
    "dropkey": "PW19104",
    "droptype": "D",
    "dropname": "MANDAREE",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "MANDAREE",
    "dropdelst": "ND",
    "dropdelzpp": 587578018,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "MANDAREE",
    "dropphyst": "ND",
    "dropphyzpp": 587578018,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "MANDAREE",
    "dropmalst": "ND",
    "dropmalzpp": 587578018,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017593370,
    "dropsitcph": 7014041091,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19109",
    "droptype": "D",
    "dropname": "MANTADOR",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "MANTADOR",
    "dropdelst": "ND",
    "dropdelzpp": 580589998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "MANTADOR",
    "dropphyst": "ND",
    "dropphyzpp": 580589998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "MANTADOR",
    "dropmalst": "ND",
    "dropmalzpp": 580589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012427203,
    "dropsitcph": 7016420160,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19110",
    "droptype": "D",
    "dropname": "MANVEL",
    "dropdeladd": "502 OLDHAM AVE",
    "dropdelcty": "MANVEL",
    "dropdelst": "ND",
    "dropdelzpp": 582569998,
    "dropphyadd": "502 OLDHAM AVE",
    "dropphycty": "MANVEL",
    "dropphyst": "ND",
    "dropphyzpp": 582569998,
    "dropmaladd": "502 OLDHAM AVE",
    "dropmalcty": "MANVEL",
    "dropmalst": "ND",
    "dropmalzpp": 582569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016962368,
    "dropsitcph": 7016962368,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19113",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "651 2ND ST",
    "dropdelcty": "MAPLETON",
    "dropdelst": "ND",
    "dropdelzpp": 580599998,
    "dropphyadd": "651 2ND ST",
    "dropphycty": "MAPLETON",
    "dropphyst": "ND",
    "dropphyzpp": 580599998,
    "dropmaladd": "651 2ND ST",
    "dropmalcty": "MAPLETON",
    "dropmalst": "ND",
    "dropmalzpp": 580599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012823754,
    "dropsitcph": 7012823754,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19114",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "308 MAIN AVE",
    "dropdelcty": "MARION",
    "dropdelst": "ND",
    "dropdelzpp": 584669998,
    "dropphyadd": "308 MAIN AVE",
    "dropphycty": "MARION",
    "dropphyst": "ND",
    "dropphyzpp": 584669998,
    "dropmaladd": "308 MAIN AVE",
    "dropmalcty": "MARION",
    "dropmalst": "ND",
    "dropmalzpp": 584669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016692339,
    "dropsitcph": 7016605759,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19119",
    "droptype": "D",
    "dropname": "MAX",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "MAX",
    "dropdelst": "ND",
    "dropdelzpp": 587599998,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "MAX",
    "dropphyst": "ND",
    "dropphyzpp": 587599998,
    "dropmaladd": "211 MAIN ST",
    "dropmalcty": "MAX",
    "dropmalst": "ND",
    "dropmalzpp": 587599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016792636,
    "dropsitcph": 7014041079,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19120",
    "droptype": "D",
    "dropname": "MAXBASS",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "MAXBASS",
    "dropdelst": "ND",
    "dropdelzpp": 587609998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "MAXBASS",
    "dropphyst": "ND",
    "dropphyzpp": 587609998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "MAXBASS",
    "dropmalst": "ND",
    "dropmalzpp": 587609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012683381,
    "dropsitcph": 7012683381,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19121",
    "droptype": "D",
    "dropname": "MAYVILLE",
    "dropdeladd": "37 1ST AVE NE",
    "dropdelcty": "MAYVILLE",
    "dropdelst": "ND",
    "dropdelzpp": 582579998,
    "dropphyadd": "37 1ST AVE NE",
    "dropphycty": "MAYVILLE",
    "dropphyst": "ND",
    "dropphyzpp": 582579998,
    "dropmaladd": "37 1ST AVE NE",
    "dropmalcty": "MAYVILLE",
    "dropmalst": "ND",
    "dropmalzpp": 582579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017863205,
    "dropsitcph": 7017863205,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19128",
    "droptype": "D",
    "dropname": "MCCLUSKY",
    "dropdeladd": "220 MAIN ST S",
    "dropdelcty": "MCCLUSKY",
    "dropdelst": "ND",
    "dropdelzpp": 584639998,
    "dropphyadd": "220 MAIN ST S",
    "dropphycty": "MCCLUSKY",
    "dropphyst": "ND",
    "dropphyzpp": 584639998,
    "dropmaladd": "220 MAIN ST S",
    "dropmalcty": "MCCLUSKY",
    "dropmalst": "ND",
    "dropmalzpp": 584639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013632533,
    "dropsitcph": 7018854007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19129",
    "droptype": "D",
    "dropname": "MCGREGOR",
    "dropdeladd": "18 N MADISON ST",
    "dropdelcty": "MCGREGOR",
    "dropdelst": "ND",
    "dropdelzpp": 587559998,
    "dropphyadd": "18 N MADISON ST",
    "dropphycty": "MCGREGOR",
    "dropphyst": "ND",
    "dropphyzpp": 587559998,
    "dropmaladd": "18 N MADISON ST",
    "dropmalcty": "MCGREGOR",
    "dropmalst": "ND",
    "dropmalzpp": 587559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015464181,
    "dropsitcph": 7014041151,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19130",
    "droptype": "D",
    "dropname": "MCHENRY",
    "dropdeladd": "322 JOHNSTON ST",
    "dropdelcty": "MCHENRY",
    "dropdelst": "ND",
    "dropdelzpp": 584649998,
    "dropphyadd": "322 JOHNSTON ST",
    "dropphycty": "MCHENRY",
    "dropphyst": "ND",
    "dropphyzpp": 584649998,
    "dropmaladd": "322 JOHNSTON ST",
    "dropmalcty": "MCHENRY",
    "dropmalst": "ND",
    "dropmalzpp": 584649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017852193,
    "dropsitcph": 7017866134,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19133",
    "droptype": "D",
    "dropname": "MCVILLE",
    "dropdeladd": "109 N MAIN ST",
    "dropdelcty": "MCVILLE",
    "dropdelst": "ND",
    "dropdelzpp": 582549998,
    "dropphyadd": "109 N MAIN ST",
    "dropphycty": "MCVILLE",
    "dropphyst": "ND",
    "dropphyzpp": 582549998,
    "dropmaladd": "109 N MAIN ST",
    "dropmalcty": "MCVILLE",
    "dropmalst": "ND",
    "dropmalzpp": 582549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015058645,
    "dropsitcph": 7015058645,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19134",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "102 2ND AVE SW",
    "dropdelcty": "MEDINA",
    "dropdelst": "ND",
    "dropdelzpp": 584679998,
    "dropphyadd": "102 2ND AVE SW",
    "dropphycty": "MEDINA",
    "dropphyst": "ND",
    "dropphyzpp": 584679998,
    "dropmaladd": "102 2ND AVE SW",
    "dropmalcty": "MEDINA",
    "dropmalst": "ND",
    "dropmalzpp": 584679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014863125,
    "dropsitcph": 7015816584,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19135",
    "droptype": "D",
    "dropname": "MEDORA",
    "dropdeladd": "355 3RD AVE",
    "dropdelcty": "MEDORA",
    "dropdelst": "ND",
    "dropdelzpp": 586459998,
    "dropphyadd": "355 3RD AVE",
    "dropphycty": "MEDORA",
    "dropphyst": "ND",
    "dropphyzpp": 586459998,
    "dropmaladd": "355 3RD AVE",
    "dropmalcty": "MEDORA",
    "dropmalst": "ND",
    "dropmalzpp": 586459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016234385,
    "dropsitcph": 7016950666,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19136",
    "droptype": "D",
    "dropname": "MEKINOCK",
    "dropdeladd": "150 MAIN ST",
    "dropdelcty": "MEKINOCK",
    "dropdelst": "ND",
    "dropdelzpp": 582589998,
    "dropphyadd": "150 MAIN ST",
    "dropphycty": "MEKINOCK",
    "dropphyst": "ND",
    "dropphyzpp": 582589998,
    "dropmaladd": "150 MAIN ST",
    "dropmalcty": "MEKINOCK",
    "dropmalst": "ND",
    "dropmalzpp": 582589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015942998,
    "dropsitcph": 7015942998,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19139",
    "droptype": "D",
    "dropname": "MERCER",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "MERCER",
    "dropdelst": "ND",
    "dropdelzpp": 585599998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "MERCER",
    "dropphyst": "ND",
    "dropphyzpp": 585599998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "MERCER",
    "dropmalst": "ND",
    "dropmalzpp": 585599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014472261,
    "dropsitcph": 7015068077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19142",
    "droptype": "D",
    "dropname": "MICHIGAN",
    "dropdeladd": "105 1ST ST E STE 4",
    "dropdelcty": "MICHIGAN",
    "dropdelst": "ND",
    "dropdelzpp": 582599998,
    "dropphyadd": "105 1ST ST E STE 4",
    "dropphycty": "MICHIGAN",
    "dropphyst": "ND",
    "dropphyzpp": 582599998,
    "dropmaladd": "105 1ST ST E STE 4",
    "dropmalcty": "MICHIGAN",
    "dropmalst": "ND",
    "dropmalzpp": 582599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012592422,
    "dropsitcph": 7018070012,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19144",
    "droptype": "D",
    "dropname": "MILNOR",
    "dropdeladd": "420 MAIN ST",
    "dropdelcty": "MILNOR",
    "dropdelst": "ND",
    "dropdelzpp": 580609998,
    "dropphyadd": "420 MAIN ST",
    "dropphycty": "MILNOR",
    "dropphyst": "ND",
    "dropphyzpp": 580609998,
    "dropmaladd": "420 MAIN ST",
    "dropmalcty": "MILNOR",
    "dropmalst": "ND",
    "dropmalzpp": 580609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014275319,
    "dropsitcph": 7016600937,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19146",
    "droptype": "D",
    "dropname": "MINNEWAUKAN",
    "dropdeladd": "151 MAIN ST E",
    "dropdelcty": "MINNEWAUKAN",
    "dropdelst": "ND",
    "dropdelzpp": 583519998,
    "dropphyadd": "151 MAIN ST E",
    "dropphycty": "MINNEWAUKAN",
    "dropphyst": "ND",
    "dropphyzpp": 583519998,
    "dropmaladd": "151 MAIN ST E",
    "dropmalcty": "MINNEWAUKAN",
    "dropmalst": "ND",
    "dropmalzpp": 583519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014735687,
    "dropsitcph": 7015058358,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19148",
    "droptype": "D",
    "dropname": "MINOT",
    "dropdeladd": "117 5TH AVE SW",
    "dropdelcty": "MINOT",
    "dropdelst": "ND",
    "dropdelzpp": 587019998,
    "dropphyadd": "117 5TH AVE SW",
    "dropphycty": "MINOT",
    "dropphyst": "ND",
    "dropphyzpp": 587019998,
    "dropmaladd": "117 5TH AVE SW",
    "dropmalcty": "MINOT",
    "dropmalst": "ND",
    "dropmalzpp": 587019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018576155,
    "dropsitcph": 7018576155,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19153",
    "droptype": "D",
    "dropname": "MINTO",
    "dropdeladd": "221 HARVEY AVE",
    "dropdelcty": "MINTO",
    "dropdelst": "ND",
    "dropdelzpp": 582619998,
    "dropphyadd": "221 HARVEY AVE",
    "dropphycty": "MINTO",
    "dropphyst": "ND",
    "dropphyzpp": 582619998,
    "dropmaladd": "221 HARVEY AVE",
    "dropmalcty": "MINTO",
    "dropmalst": "ND",
    "dropmalzpp": 582619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012483813,
    "dropsitcph": 7012483813,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19154",
    "droptype": "D",
    "dropname": "MOFFIT",
    "dropdeladd": "206 MAIN ST N",
    "dropdelcty": "MOFFIT",
    "dropdelst": "ND",
    "dropdelzpp": 585609998,
    "dropphyadd": "206 MAIN ST N",
    "dropphycty": "MOFFIT",
    "dropphyst": "ND",
    "dropphyzpp": 585609998,
    "dropmaladd": "206 MAIN ST N",
    "dropmalcty": "MOFFIT",
    "dropmalst": "ND",
    "dropmalzpp": 585609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013874758,
    "dropsitcph": 7013874758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19155",
    "droptype": "D",
    "dropname": "MOHALL",
    "dropdeladd": "107 MAIN ST E",
    "dropdelcty": "MOHALL",
    "dropdelst": "ND",
    "dropdelzpp": 587619998,
    "dropphyadd": "107 MAIN ST E",
    "dropphycty": "MOHALL",
    "dropphyst": "ND",
    "dropphyzpp": 587619998,
    "dropmaladd": "107 MAIN ST E",
    "dropmalcty": "MOHALL",
    "dropmalst": "ND",
    "dropmalzpp": 587619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017566354,
    "dropsitcph": 7017566354,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19157",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "106 4TH AVE",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "ND",
    "dropdelzpp": 584729998,
    "dropphyadd": "106 4TH AVE",
    "dropphycty": "MONTPELIER",
    "dropphyst": "ND",
    "dropphyzpp": 584729998,
    "dropmaladd": "106 4TH AVE",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "ND",
    "dropmalzpp": 584729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014893312,
    "dropsitcph": 8778541867,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19158",
    "droptype": "D",
    "dropname": "MOORETON",
    "dropdeladd": "105 MOORETON AVE S",
    "dropdelcty": "MOORETON",
    "dropdelst": "ND",
    "dropdelzpp": 580619998,
    "dropphyadd": "105 MOORETON AVE S",
    "dropphycty": "MOORETON",
    "dropphyst": "ND",
    "dropphyzpp": 580619998,
    "dropmaladd": "105 MOORETON AVE S",
    "dropmalcty": "MOORETON",
    "dropmalst": "ND",
    "dropmalzpp": 580619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012748824,
    "dropsitcph": 7016420184,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19160",
    "droptype": "D",
    "dropname": "MOTT",
    "dropdeladd": "123 BROWN AVE",
    "dropdelcty": "MOTT",
    "dropdelst": "ND",
    "dropdelzpp": 586469998,
    "dropphyadd": "123 BROWN AVE",
    "dropphycty": "MOTT",
    "dropphyst": "ND",
    "dropphyzpp": 586469998,
    "dropmaladd": "123 BROWN AVE",
    "dropmalcty": "MOTT",
    "dropmalst": "ND",
    "dropmalzpp": 586469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018242020,
    "dropsitcph": 7016950671,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19161",
    "droptype": "D",
    "dropname": "MOUNTAIN",
    "dropdeladd": "286 2ND AVE STE B",
    "dropdelcty": "MOUNTAIN",
    "dropdelst": "ND",
    "dropdelzpp": 582627718,
    "dropphyadd": "286 2ND AVE STE B",
    "dropphycty": "MOUNTAIN",
    "dropphyst": "ND",
    "dropphyzpp": 582627718,
    "dropmaladd": "286 2ND AVE STE B",
    "dropmalcty": "MOUNTAIN",
    "dropmalst": "ND",
    "dropmalzpp": 582627718,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019938552,
    "dropsitcph": 7019938200,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19162",
    "droptype": "D",
    "dropname": "MUNICH",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "MUNICH",
    "dropdelst": "ND",
    "dropdelzpp": 583529998,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "MUNICH",
    "dropphyst": "ND",
    "dropphyzpp": 583529998,
    "dropmaladd": "410 MAIN ST",
    "dropmalcty": "MUNICH",
    "dropmalst": "ND",
    "dropmalzpp": 583529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016825578,
    "dropsitcph": 7015058857,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19166",
    "droptype": "D",
    "dropname": "NAPOLEON",
    "dropdeladd": "104 BROADWAY",
    "dropdelcty": "NAPOLEON",
    "dropdelst": "ND",
    "dropdelzpp": 585619998,
    "dropphyadd": "104 BROADWAY",
    "dropphycty": "NAPOLEON",
    "dropphyst": "ND",
    "dropphyzpp": 585619998,
    "dropmaladd": "104 BROADWAY",
    "dropmalcty": "NAPOLEON",
    "dropmalst": "ND",
    "dropmalzpp": 585619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017542841,
    "dropsitcph": 7015818046,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19168",
    "droptype": "D",
    "dropname": "NECHE",
    "dropdeladd": "434 MAIN AVE",
    "dropdelcty": "NECHE",
    "dropdelst": "ND",
    "dropdelzpp": 582659998,
    "dropphyadd": "434 MAIN AVE",
    "dropphycty": "NECHE",
    "dropphyst": "ND",
    "dropphyzpp": 582659998,
    "dropmaladd": "434 MAIN AVE",
    "dropmalcty": "NECHE",
    "dropmalst": "ND",
    "dropmalzpp": 582659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018867692,
    "dropsitcph": 7018150163,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19171",
    "droptype": "D",
    "dropname": "NEW ENGLAND",
    "dropdeladd": "826 MCKENZIE ST",
    "dropdelcty": "NEW ENGLAND",
    "dropdelst": "ND",
    "dropdelzpp": 586479998,
    "dropphyadd": "826 MCKENZIE ST",
    "dropphycty": "NEW ENGLAND",
    "dropphyst": "ND",
    "dropphyzpp": 586479998,
    "dropmaladd": "826 MCKENZIE ST",
    "dropmalcty": "NEW ENGLAND",
    "dropmalst": "ND",
    "dropmalzpp": 586479998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015794240,
    "dropsitcph": 7015794240,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19173",
    "droptype": "D",
    "dropname": "NEW LEIPZIG",
    "dropdeladd": "115 MAIN AVE",
    "dropdelcty": "NEW LEIPZIG",
    "dropdelst": "ND",
    "dropdelzpp": 585629998,
    "dropphyadd": "115 MAIN AVE",
    "dropphycty": "NEW LEIPZIG",
    "dropphyst": "ND",
    "dropphyzpp": 585629998,
    "dropmaladd": "115 MAIN AVE",
    "dropmalcty": "NEW LEIPZIG",
    "dropmalst": "ND",
    "dropmalzpp": 585629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015842335,
    "dropsitcph": 7015842335,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19174",
    "droptype": "D",
    "dropname": "NEW ROCKFORD",
    "dropdeladd": "827 1ST AVE N",
    "dropdelcty": "NEW ROCKFORD",
    "dropdelst": "ND",
    "dropdelzpp": 583569998,
    "dropphyadd": "827 1ST AVE N",
    "dropphycty": "NEW ROCKFORD",
    "dropphyst": "ND",
    "dropphyzpp": 583569998,
    "dropmaladd": "827 1ST AVE N",
    "dropmalcty": "NEW ROCKFORD",
    "dropmalst": "ND",
    "dropmalzpp": 583569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015058842,
    "dropsitcph": 7015058842,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19176",
    "droptype": "D",
    "dropname": "NEW SALEM",
    "dropdeladd": "110 N 4TH ST",
    "dropdelcty": "NEW SALEM",
    "dropdelst": "ND",
    "dropdelzpp": 585639998,
    "dropphyadd": "110 N 4TH ST",
    "dropphycty": "NEW SALEM",
    "dropphyst": "ND",
    "dropphyzpp": 585639998,
    "dropmaladd": "110 N 4TH ST",
    "dropmalcty": "NEW SALEM",
    "dropmalst": "ND",
    "dropmalzpp": 585639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018437353,
    "dropsitcph": 7016952024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19177",
    "droptype": "D",
    "dropname": "NEW TOWN",
    "dropdeladd": "361 MAIN ST",
    "dropdelcty": "NEW TOWN",
    "dropdelst": "ND",
    "dropdelzpp": 587639998,
    "dropphyadd": "361 MAIN ST",
    "dropphycty": "NEW TOWN",
    "dropphyst": "ND",
    "dropphyzpp": 587639998,
    "dropmaladd": "361 MAIN ST",
    "dropmalcty": "NEW TOWN",
    "dropmalst": "ND",
    "dropmalzpp": 587639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016274698,
    "dropsitcph": 7013538812,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19179",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "380 MAIN ST",
    "dropdelcty": "NEWBURG",
    "dropdelst": "ND",
    "dropdelzpp": 587629998,
    "dropphyadd": "380 MAIN ST",
    "dropphycty": "NEWBURG",
    "dropphyst": "ND",
    "dropphyzpp": 587629998,
    "dropmaladd": "380 MAIN ST",
    "dropmalcty": "NEWBURG",
    "dropmalst": "ND",
    "dropmalzpp": 587629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012726131,
    "dropsitcph": 7012726131,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19181",
    "droptype": "D",
    "dropname": "NIAGARA",
    "dropdeladd": "107 N 2ND ST",
    "dropdelcty": "NIAGARA",
    "dropdelst": "ND",
    "dropdelzpp": 582669998,
    "dropphyadd": "107 N 2ND ST",
    "dropphycty": "NIAGARA",
    "dropphyst": "ND",
    "dropphyzpp": 582669998,
    "dropmaladd": "107 N 2ND ST",
    "dropmalcty": "NIAGARA",
    "dropmalst": "ND",
    "dropmalzpp": 582669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013975816,
    "dropsitcph": 7013975816,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19183",
    "droptype": "D",
    "dropname": "NOME",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "NOME",
    "dropdelst": "ND",
    "dropdelzpp": 580629998,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "NOME",
    "dropphyst": "ND",
    "dropphyzpp": 580629998,
    "dropmaladd": "408 MAIN ST",
    "dropmalcty": "NOME",
    "dropmalst": "ND",
    "dropmalzpp": 580629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019248264,
    "dropsitcph": 7014908200,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19184",
    "droptype": "D",
    "dropname": "NOONAN",
    "dropdeladd": "209 S MAIN ST",
    "dropdelcty": "NOONAN",
    "dropdelst": "ND",
    "dropdelzpp": 587659998,
    "dropphyadd": "209 S MAIN ST",
    "dropphycty": "NOONAN",
    "dropphyst": "ND",
    "dropphyzpp": 587659998,
    "dropmaladd": "209 S MAIN ST",
    "dropmalcty": "NOONAN",
    "dropmalst": "ND",
    "dropmalzpp": 587659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019255647,
    "dropsitcph": 7013538528,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19190",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "4 N RAYMOND ST",
    "dropdelcty": "NORTHWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 582679998,
    "dropphyadd": "4 N RAYMOND ST",
    "dropphycty": "NORTHWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 582679998,
    "dropmaladd": "4 N RAYMOND ST",
    "dropmalcty": "NORTHWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 582679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015876370,
    "dropsitcph": 7015876370,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19194",
    "droptype": "D",
    "dropname": "OAKES",
    "dropdeladd": "611 MAIN AVE",
    "dropdelcty": "OAKES",
    "dropdelst": "ND",
    "dropdelzpp": 584749998,
    "dropphyadd": "611 MAIN AVE",
    "dropphycty": "OAKES",
    "dropphyst": "ND",
    "dropphyzpp": 584749998,
    "dropmaladd": "611 MAIN AVE",
    "dropmalcty": "OAKES",
    "dropmalst": "ND",
    "dropmalzpp": 584749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017422733,
    "dropsitcph": 7015813579,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19195",
    "droptype": "D",
    "dropname": "OBERON",
    "dropdeladd": "110 MAIN AVE E",
    "dropdelcty": "OBERON",
    "dropdelst": "ND",
    "dropdelzpp": 583579998,
    "dropphyadd": "110 MAIN AVE E",
    "dropphycty": "OBERON",
    "dropphyst": "ND",
    "dropphyzpp": 583579998,
    "dropmaladd": "110 MAIN AVE E",
    "dropmalcty": "OBERON",
    "dropmalst": "ND",
    "dropmalzpp": 583579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014041125,
    "dropsitcph": 7014041125,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19198",
    "droptype": "D",
    "dropname": "ORISKA",
    "dropdeladd": "311 5TH ST",
    "dropdelcty": "ORISKA",
    "dropdelst": "ND",
    "dropdelzpp": 580639998,
    "dropphyadd": "311 5TH ST",
    "dropphycty": "ORISKA",
    "dropphyst": "ND",
    "dropphyzpp": 580639998,
    "dropmaladd": "311 5TH ST",
    "dropmalcty": "ORISKA",
    "dropmalst": "ND",
    "dropmalzpp": 580639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018452404,
    "dropsitcph": 7018452404,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19201",
    "droptype": "D",
    "dropname": "OSNABROCK",
    "dropdeladd": "326 BROADWAY",
    "dropdelcty": "OSNABROCK",
    "dropdelst": "ND",
    "dropdelzpp": 582699998,
    "dropphyadd": "326 BROADWAY",
    "dropphycty": "OSNABROCK",
    "dropphyst": "ND",
    "dropphyzpp": 582699998,
    "dropmaladd": "326 BROADWAY",
    "dropmalcty": "OSNABROCK",
    "dropmalst": "ND",
    "dropmalzpp": 582699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014963189,
    "dropsitcph": 7015058352,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19205",
    "droptype": "D",
    "dropname": "PAGE",
    "dropdeladd": "137 MORTON AVE",
    "dropdelcty": "PAGE",
    "dropdelst": "ND",
    "dropdelzpp": 580649998,
    "dropphyadd": "137 MORTON AVE",
    "dropphycty": "PAGE",
    "dropphyst": "ND",
    "dropphyzpp": 580649998,
    "dropmaladd": "137 MORTON AVE",
    "dropmalcty": "PAGE",
    "dropmalst": "ND",
    "dropmalzpp": 580649998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016682341,
    "dropsitcph": 7018901126,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19207",
    "droptype": "D",
    "dropname": "PARK RIVER",
    "dropdeladd": "309 BRIGGS AVE S",
    "dropdelcty": "PARK RIVER",
    "dropdelst": "ND",
    "dropdelzpp": 582709998,
    "dropphyadd": "309 BRIGGS AVE S",
    "dropphycty": "PARK RIVER",
    "dropphyst": "ND",
    "dropphyzpp": 582709998,
    "dropmaladd": "309 BRIGGS AVE S",
    "dropmalcty": "PARK RIVER",
    "dropmalst": "ND",
    "dropmalzpp": 582709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012846106,
    "dropsitcph": 7013527199,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19208",
    "droptype": "D",
    "dropname": "PARSHALL",
    "dropdeladd": "107 MAIN ST S",
    "dropdelcty": "PARSHALL",
    "dropdelst": "ND",
    "dropdelzpp": 587709998,
    "dropphyadd": "107 MAIN ST S",
    "dropphycty": "PARSHALL",
    "dropphyst": "ND",
    "dropphyzpp": 587709998,
    "dropmaladd": "107 MAIN ST S",
    "dropmalcty": "PARSHALL",
    "dropmalst": "ND",
    "dropmalzpp": 587709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018623338,
    "dropsitcph": 7018623338,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19209",
    "droptype": "D",
    "dropname": "PEKIN",
    "dropdeladd": "223 MAIN ST N",
    "dropdelcty": "PEKIN",
    "dropdelst": "ND",
    "dropdelzpp": 583619998,
    "dropphyadd": "223 MAIN ST N",
    "dropphycty": "PEKIN",
    "dropphyst": "ND",
    "dropphyzpp": 583619998,
    "dropmaladd": "223 MAIN ST N",
    "dropmalcty": "PEKIN",
    "dropmalst": "ND",
    "dropmalzpp": 583619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014841446,
    "dropsitcph": 7014841446,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19210",
    "droptype": "D",
    "dropname": "PEMBINA",
    "dropdeladd": "554 W ROLETTE ST",
    "dropdelcty": "PEMBINA",
    "dropdelst": "ND",
    "dropdelzpp": 582719998,
    "dropphyadd": "554 W ROLETTE ST",
    "dropphycty": "PEMBINA",
    "dropphyst": "ND",
    "dropphyzpp": 582719998,
    "dropmaladd": "554 W ROLETTE ST",
    "dropmalcty": "PEMBINA",
    "dropmalst": "ND",
    "dropmalzpp": 582719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015813582,
    "dropsitcph": 7014103073,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19213",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "214 5TH ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "ND",
    "dropdelzpp": 582729998,
    "dropphyadd": "214 5TH ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "ND",
    "dropphyzpp": 582729998,
    "dropmaladd": "214 5TH ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "ND",
    "dropmalzpp": 582729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013458584,
    "dropsitcph": 7013458584,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19214",
    "droptype": "D",
    "dropname": "PETTIBONE",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "PETTIBONE",
    "dropdelst": "ND",
    "dropdelzpp": 584759998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "PETTIBONE",
    "dropphyst": "ND",
    "dropphyzpp": 584759998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "PETTIBONE",
    "dropmalst": "ND",
    "dropmalzpp": 584759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012736621,
    "dropsitcph": 7012736621,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19219",
    "droptype": "D",
    "dropname": "PISEK",
    "dropdeladd": "68 LOVICK AVE",
    "dropdelcty": "PISEK",
    "dropdelst": "ND",
    "dropdelzpp": 582739998,
    "dropphyadd": "68 LOVICK AVE",
    "dropphycty": "PISEK",
    "dropphyst": "ND",
    "dropphyzpp": 582739998,
    "dropmaladd": "68 LOVICK AVE",
    "dropmalcty": "PISEK",
    "dropmalst": "ND",
    "dropmalzpp": 582739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012847341,
    "dropsitcph": 7015102810,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19220",
    "droptype": "D",
    "dropname": "PLAZA",
    "dropdeladd": "10 E PLAZA ST",
    "dropdelcty": "PLAZA",
    "dropdelst": "ND",
    "dropdelzpp": 587719998,
    "dropphyadd": "10 E PLAZA ST",
    "dropphycty": "PLAZA",
    "dropphyst": "ND",
    "dropphyzpp": 587719998,
    "dropmaladd": "10 E PLAZA ST",
    "dropmalcty": "PLAZA",
    "dropmalst": "ND",
    "dropmalzpp": 587719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014973327,
    "dropsitcph": 7014041097,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19223",
    "droptype": "D",
    "dropname": "PORTAL",
    "dropdeladd": "15 W RAILWAY AVE",
    "dropdelcty": "PORTAL",
    "dropdelst": "ND",
    "dropdelzpp": 587729998,
    "dropphyadd": "15 W RAILWAY AVE",
    "dropphycty": "PORTAL",
    "dropphyst": "ND",
    "dropphyzpp": 587729998,
    "dropmaladd": "15 W RAILWAY AVE",
    "dropmalcty": "PORTAL",
    "dropmalst": "ND",
    "dropmalzpp": 587729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019264521,
    "dropsitcph": 7019264521,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19224",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "629 PARKE AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "ND",
    "dropdelzpp": 582749998,
    "dropphyadd": "629 PARKE AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "ND",
    "dropphyzpp": 582749998,
    "dropmaladd": "629 PARKE AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "ND",
    "dropmalzpp": 582749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017863710,
    "dropsitcph": 7017863710,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19225",
    "droptype": "D",
    "dropname": "POWERS LAKE",
    "dropdeladd": "207 MAIN ST",
    "dropdelcty": "POWERS LAKE",
    "dropdelst": "ND",
    "dropdelzpp": 587739998,
    "dropphyadd": "207 MAIN ST",
    "dropphycty": "POWERS LAKE",
    "dropphyst": "ND",
    "dropphyzpp": 587739998,
    "dropmaladd": "207 MAIN ST",
    "dropmalcty": "POWERS LAKE",
    "dropmalst": "ND",
    "dropmalzpp": 587739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014645691,
    "dropsitcph": 7013538710,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19235",
    "droptype": "D",
    "dropname": "RAY",
    "dropdeladd": "6 MAIN ST",
    "dropdelcty": "RAY",
    "dropdelst": "ND",
    "dropdelzpp": 588499998,
    "dropphyadd": "6 MAIN ST",
    "dropphycty": "RAY",
    "dropphyst": "ND",
    "dropphyzpp": 588499998,
    "dropmaladd": "6 MAIN ST",
    "dropmalcty": "RAY",
    "dropmalst": "ND",
    "dropmalzpp": 588499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015683631,
    "dropsitcph": 7015683631,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19236",
    "droptype": "D",
    "dropname": "REEDER",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "REEDER",
    "dropdelst": "ND",
    "dropdelzpp": 586499998,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "REEDER",
    "dropphyst": "ND",
    "dropphyzpp": 586499998,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "REEDER",
    "dropmalst": "ND",
    "dropmalzpp": 586499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018532338,
    "dropsitcph": 7018532338,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19238",
    "droptype": "D",
    "dropname": "REGENT",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "REGENT",
    "dropdelst": "ND",
    "dropdelzpp": 586509998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "REGENT",
    "dropphyst": "ND",
    "dropphyzpp": 586509998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "REGENT",
    "dropmalst": "ND",
    "dropmalzpp": 586509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015634554,
    "dropsitcph": 7016950664,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19241",
    "droptype": "D",
    "dropname": "REYNOLDS",
    "dropdeladd": "321 4TH AVE",
    "dropdelcty": "REYNOLDS",
    "dropdelst": "ND",
    "dropdelzpp": 582759998,
    "dropphyadd": "321 4TH AVE",
    "dropphycty": "REYNOLDS",
    "dropphyst": "ND",
    "dropphyzpp": 582759998,
    "dropmaladd": "321 4TH AVE",
    "dropmalcty": "REYNOLDS",
    "dropmalst": "ND",
    "dropmalzpp": 582759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018472255,
    "dropsitcph": 7018472255,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19242",
    "droptype": "D",
    "dropname": "RHAME",
    "dropdeladd": "53 MAIN ST",
    "dropdelcty": "RHAME",
    "dropdelst": "ND",
    "dropdelzpp": 586519998,
    "dropphyadd": "53 MAIN ST",
    "dropphycty": "RHAME",
    "dropphyst": "ND",
    "dropphyzpp": 586519998,
    "dropmaladd": "53 MAIN ST",
    "dropmalcty": "RHAME",
    "dropmalst": "ND",
    "dropmalzpp": 586519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016950587,
    "dropsitcph": 7016950587,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19244",
    "droptype": "D",
    "dropname": "RICHARDTON",
    "dropdeladd": "111 B ST N",
    "dropdelcty": "RICHARDTON",
    "dropdelst": "ND",
    "dropdelzpp": 586529998,
    "dropphyadd": "111 B ST N",
    "dropphycty": "RICHARDTON",
    "dropphyst": "ND",
    "dropphyzpp": 586529998,
    "dropmaladd": "111 B ST N",
    "dropmalcty": "RICHARDTON",
    "dropmalst": "ND",
    "dropmalzpp": 586529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019743403,
    "dropsitcph": 7016950681,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19245",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "302 2ND ST",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "ND",
    "dropdelzpp": 585659998,
    "dropphyadd": "302 2ND ST",
    "dropphycty": "RIVERDALE",
    "dropphyst": "ND",
    "dropphyzpp": 585659998,
    "dropmaladd": "302 2ND ST",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "ND",
    "dropmalzpp": 585659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016547531,
    "dropsitcph": 7015060910,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19247",
    "droptype": "D",
    "dropname": "ROBINSON",
    "dropdeladd": "116 1ST AVE E",
    "dropdelcty": "ROBINSON",
    "dropdelst": "ND",
    "dropdelzpp": 584789998,
    "dropphyadd": "116 1ST AVE E",
    "dropphycty": "ROBINSON",
    "dropphyst": "ND",
    "dropphyzpp": 584789998,
    "dropmaladd": "116 1ST AVE E",
    "dropmalcty": "ROBINSON",
    "dropmalst": "ND",
    "dropmalzpp": 584789998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013925201,
    "dropsitcph": 7015060872,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19249",
    "droptype": "D",
    "dropname": "ROCKLAKE",
    "dropdeladd": "44 MAIN ST",
    "dropdelcty": "ROCKLAKE",
    "dropdelst": "ND",
    "dropdelzpp": 583659998,
    "dropphyadd": "44 MAIN ST",
    "dropphycty": "ROCKLAKE",
    "dropphyst": "ND",
    "dropphyzpp": 583659998,
    "dropmaladd": "44 MAIN ST",
    "dropmalcty": "ROCKLAKE",
    "dropmalst": "ND",
    "dropmalzpp": 583659998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012665210,
    "dropsitcph": 7018290533,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19251",
    "droptype": "D",
    "dropname": "ROLETTE",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "ROLETTE",
    "dropdelst": "ND",
    "dropdelzpp": 583669998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "ROLETTE",
    "dropphyst": "ND",
    "dropphyzpp": 583669998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "ROLETTE",
    "dropmalst": "ND",
    "dropmalzpp": 583669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012463633,
    "dropsitcph": 7015058881,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19252",
    "droptype": "D",
    "dropname": "ROLLA",
    "dropdeladd": "119 1ST AVE SE",
    "dropdelcty": "ROLLA",
    "dropdelst": "ND",
    "dropdelzpp": 583679998,
    "dropphyadd": "119 1ST AVE SE",
    "dropphycty": "ROLLA",
    "dropphyst": "ND",
    "dropphyzpp": 583679998,
    "dropmaladd": "119 1ST AVE SE",
    "dropmalcty": "ROLLA",
    "dropmalst": "ND",
    "dropmalzpp": 583679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014773295,
    "dropsitcph": 7015058414,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19254",
    "droptype": "D",
    "dropname": "ROSEGLEN",
    "dropdeladd": "209 5TH ST",
    "dropdelcty": "ROSEGLEN",
    "dropdelst": "ND",
    "dropdelzpp": 587759998,
    "dropphyadd": "209 5TH ST",
    "dropphycty": "ROSEGLEN",
    "dropphyst": "ND",
    "dropphyzpp": 587759998,
    "dropmaladd": "209 5TH ST",
    "dropmalcty": "ROSEGLEN",
    "dropmalst": "ND",
    "dropmalzpp": 587759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017434240,
    "dropsitcph": 7017434240,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19255",
    "droptype": "D",
    "dropname": "ROSS",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "ROSS",
    "dropdelst": "ND",
    "dropdelzpp": 587769998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "ROSS",
    "dropphyst": "ND",
    "dropphyzpp": 587769998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "ROSS",
    "dropmalst": "ND",
    "dropmalzpp": 587769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017553266,
    "dropsitcph": 7014041123,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19258",
    "droptype": "D",
    "dropname": "RUGBY",
    "dropdeladd": "205 2ND ST SE",
    "dropdelcty": "RUGBY",
    "dropdelst": "ND",
    "dropdelzpp": 583689998,
    "dropphyadd": "205 2ND ST SE",
    "dropphycty": "RUGBY",
    "dropphyst": "ND",
    "dropphyzpp": 583689998,
    "dropmaladd": "205 2ND ST SE",
    "dropmalcty": "RUGBY",
    "dropmalst": "ND",
    "dropmalzpp": 583689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017766342,
    "dropsitcph": 7015058658,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19262",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "113 1ST ST",
    "dropdelcty": "RUTLAND",
    "dropdelst": "ND",
    "dropdelzpp": 580679998,
    "dropphyadd": "113 1ST ST",
    "dropphycty": "RUTLAND",
    "dropphyst": "ND",
    "dropphyzpp": 580679998,
    "dropmaladd": "113 1ST ST",
    "dropmalcty": "RUTLAND",
    "dropmalst": "ND",
    "dropmalzpp": 580679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017246466,
    "dropsitcph": 7017246466,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19263",
    "droptype": "D",
    "dropname": "RYDER",
    "dropdeladd": "280 N MAIN ST",
    "dropdelcty": "RYDER",
    "dropdelst": "ND",
    "dropdelzpp": 587799998,
    "dropphyadd": "280 N MAIN ST",
    "dropphycty": "RYDER",
    "dropphyst": "ND",
    "dropphyzpp": 587799998,
    "dropmaladd": "280 N MAIN ST",
    "dropmalcty": "RYDER",
    "dropmalst": "ND",
    "dropmalzpp": 587799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017582264,
    "dropsitcph": 7017582264,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19266",
    "droptype": "D",
    "dropname": "SAINT JOHN",
    "dropdeladd": "101 FOUSSARD AVE SE",
    "dropdelcty": "SAINT JOHN",
    "dropdelst": "ND",
    "dropdelzpp": 583699998,
    "dropphyadd": "101 FOUSSARD AVE SE",
    "dropphycty": "SAINT JOHN",
    "dropphyst": "ND",
    "dropphyzpp": 583699998,
    "dropmaladd": "101 FOUSSARD AVE SE",
    "dropmalcty": "SAINT JOHN",
    "dropmalst": "ND",
    "dropmalzpp": 583699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014775724,
    "dropsitcph": 7015058697,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19268",
    "droptype": "D",
    "dropname": "SAINT THOMAS",
    "dropdeladd": "340 MAIN ST",
    "dropdelcty": "SAINT THOMAS",
    "dropdelst": "ND",
    "dropdelzpp": 582769998,
    "dropphyadd": "340 MAIN ST",
    "dropphycty": "SAINT THOMAS",
    "dropphyst": "ND",
    "dropphyzpp": 582769998,
    "dropmaladd": "340 MAIN ST",
    "dropmalcty": "SAINT THOMAS",
    "dropmalst": "ND",
    "dropmalzpp": 582769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012576472,
    "dropsitcph": 7015102415,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19270",
    "droptype": "D",
    "dropname": "SANBORN",
    "dropdeladd": "405 4TH ST",
    "dropdelcty": "SANBORN",
    "dropdelst": "ND",
    "dropdelzpp": 584809998,
    "dropphyadd": "405 4TH ST",
    "dropphycty": "SANBORN",
    "dropphyst": "ND",
    "dropphyzpp": 584809998,
    "dropmaladd": "405 4TH ST",
    "dropmalcty": "SANBORN",
    "dropmalst": "ND",
    "dropmalzpp": 584809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016466244,
    "dropsitcph": 8873641335,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19273",
    "droptype": "D",
    "dropname": "SARLES",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "SARLES",
    "dropdelst": "ND",
    "dropdelzpp": 583729998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "SARLES",
    "dropphyst": "ND",
    "dropphyzpp": 583729998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "SARLES",
    "dropmalst": "ND",
    "dropmalzpp": 583729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016975189,
    "dropsitcph": 7016975189,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19275",
    "droptype": "D",
    "dropname": "SAWYER",
    "dropdeladd": "20 MAIN ST S",
    "dropdelcty": "SAWYER",
    "dropdelst": "ND",
    "dropdelzpp": 587819998,
    "dropphyadd": "20 MAIN ST S",
    "dropphycty": "SAWYER",
    "dropphyst": "ND",
    "dropphyzpp": 587819998,
    "dropmaladd": "20 MAIN ST S",
    "dropmalcty": "SAWYER",
    "dropmalst": "ND",
    "dropmalzpp": 587819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016245201,
    "dropsitcph": 7016245201,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19277",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "205 2ND AVE N",
    "dropdelcty": "SCRANTON",
    "dropdelst": "ND",
    "dropdelzpp": 586539998,
    "dropphyadd": "205 2ND AVE N",
    "dropphycty": "SCRANTON",
    "dropphyst": "ND",
    "dropphyzpp": 586539998,
    "dropmaladd": "205 2ND AVE N",
    "dropmalcty": "SCRANTON",
    "dropmalst": "ND",
    "dropmalzpp": 586539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016950623,
    "dropsitcph": 7016950623,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19278",
    "droptype": "D",
    "dropname": "SELFRIDGE",
    "dropdeladd": "70 S MAIN ST",
    "dropdelcty": "SELFRIDGE",
    "dropdelst": "ND",
    "dropdelzpp": 585689998,
    "dropphyadd": "70 S MAIN ST",
    "dropphycty": "SELFRIDGE",
    "dropphyst": "ND",
    "dropphyzpp": 585689998,
    "dropmaladd": "70 S MAIN ST",
    "dropmalcty": "SELFRIDGE",
    "dropmalst": "ND",
    "dropmalzpp": 585689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014223355,
    "dropsitcph": 7014223355,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19283",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "307 MAIN ST",
    "dropdelcty": "SHARON",
    "dropdelst": "ND",
    "dropdelzpp": 582779998,
    "dropphyadd": "307 MAIN ST",
    "dropphycty": "SHARON",
    "dropphyst": "ND",
    "dropphyzpp": 582779998,
    "dropmaladd": "307 MAIN ST",
    "dropmalcty": "SHARON",
    "dropmalst": "ND",
    "dropmalzpp": 582779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015242209,
    "dropsitcph": 7015242209,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19284",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "216 FRONT ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "ND",
    "dropdelzpp": 580689998,
    "dropphyadd": "216 FRONT ST",
    "dropphycty": "SHELDON",
    "dropphyst": "ND",
    "dropphyzpp": 580689998,
    "dropmaladd": "216 FRONT ST",
    "dropmalcty": "SHELDON",
    "dropmalst": "ND",
    "dropmalzpp": 580689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018823203,
    "dropsitcph": 8773641434,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19286",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "144 MAIN ST",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 587829998,
    "dropphyadd": "144 MAIN ST",
    "dropphycty": "SHERWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 587829998,
    "dropmaladd": "144 MAIN ST",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 587829998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014592405,
    "dropsitcph": 7013538776,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19287",
    "droptype": "D",
    "dropname": "SHEYENNE",
    "dropdeladd": "106 RICHTER AVE",
    "dropdelcty": "SHEYENNE",
    "dropdelst": "ND",
    "dropdelzpp": 583749998,
    "dropphyadd": "106 RICHTER AVE",
    "dropphycty": "SHEYENNE",
    "dropphyst": "ND",
    "dropphyzpp": 583749998,
    "dropmaladd": "106 RICHTER AVE",
    "dropmalcty": "SHEYENNE",
    "dropmalst": "ND",
    "dropmalzpp": 583749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014041149,
    "dropsitcph": 7014041149,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19292",
    "droptype": "D",
    "dropname": "SOLEN",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "SOLEN",
    "dropdelst": "ND",
    "dropdelzpp": 585709998,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "SOLEN",
    "dropphyst": "ND",
    "dropphyzpp": 585709998,
    "dropmaladd": "202 N MAIN ST",
    "dropmalcty": "SOLEN",
    "dropmalst": "ND",
    "dropmalzpp": 585709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014453345,
    "dropsitcph": 7014453345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19293",
    "droptype": "D",
    "dropname": "SOURIS",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "SOURIS",
    "dropdelst": "ND",
    "dropdelzpp": 587839998,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "SOURIS",
    "dropphyst": "ND",
    "dropphyzpp": 587839998,
    "dropmaladd": "105 MAIN ST",
    "dropmalcty": "SOURIS",
    "dropmalst": "ND",
    "dropmalzpp": 587839998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012436353,
    "dropsitcph": 7013538529,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19294",
    "droptype": "D",
    "dropname": "SOUTH HEART",
    "dropdeladd": "401 RUDOLPH AVE NW",
    "dropdelcty": "SOUTH HEART",
    "dropdelst": "ND",
    "dropdelzpp": 586559998,
    "dropphyadd": "401 RUDOLPH AVE NW",
    "dropphycty": "SOUTH HEART",
    "dropphyst": "ND",
    "dropphyzpp": 586559998,
    "dropmaladd": "401 RUDOLPH AVE NW",
    "dropmalcty": "SOUTH HEART",
    "dropmalst": "ND",
    "dropmalzpp": 586559998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016775870,
    "dropsitcph": 7016775870,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19298",
    "droptype": "D",
    "dropname": "SPIRITWOOD",
    "dropdeladd": "313 MAIN ST",
    "dropdelcty": "SPIRITWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 584819998,
    "dropphyadd": "313 MAIN ST",
    "dropphycty": "SPIRITWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 584819998,
    "dropmaladd": "313 MAIN ST",
    "dropmalcty": "SPIRITWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 584819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012526122,
    "dropsitcph": 7012526122,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19337",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "902 JARARD ST SE",
    "dropdelcty": "STANLEY",
    "dropdelst": "ND",
    "dropdelzpp": 587849998,
    "dropphyadd": "902 JARARD ST SE",
    "dropphycty": "STANLEY",
    "dropphyst": "ND",
    "dropphyzpp": 587849998,
    "dropmaladd": "902 JARARD ST SE",
    "dropmalcty": "STANLEY",
    "dropmalst": "ND",
    "dropmalzpp": 587849998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016282501,
    "dropsitcph": 7016282501,
    "dropfax": 7016281417
  },
  {
    "dcode": "D",
    "dropkey": "PW19338",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "119 HARMON AVE",
    "dropdelcty": "STANTON",
    "dropdelst": "ND",
    "dropdelzpp": 585719998,
    "dropphyadd": "119 HARMON AVE",
    "dropphycty": "STANTON",
    "dropphyst": "ND",
    "dropphyzpp": 585719998,
    "dropmaladd": "119 HARMON AVE",
    "dropmalcty": "STANTON",
    "dropmalst": "ND",
    "dropmalzpp": 585719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017453501,
    "dropsitcph": 7017321161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19339",
    "droptype": "D",
    "dropname": "STARKWEATHER",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "STARKWEATHER",
    "dropdelst": "ND",
    "dropdelzpp": 583779998,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "STARKWEATHER",
    "dropphyst": "ND",
    "dropphyzpp": 583779998,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "STARKWEATHER",
    "dropmalst": "ND",
    "dropmalzpp": 583779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012924551,
    "dropsitcph": 7015058482,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19340",
    "droptype": "D",
    "dropname": "STEELE",
    "dropdeladd": "101 1ST AVE SE",
    "dropdelcty": "STEELE",
    "dropdelst": "ND",
    "dropdelzpp": 584829998,
    "dropphyadd": "101 1ST AVE SE",
    "dropphycty": "STEELE",
    "dropphyst": "ND",
    "dropphyzpp": 584829998,
    "dropmaladd": "101 1ST AVE SE",
    "dropmalcty": "STEELE",
    "dropmalst": "ND",
    "dropmalzpp": 584829998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014752880,
    "dropsitcph": 7016952469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19341",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "108 MAIN AVE",
    "dropdelcty": "STERLING",
    "dropdelst": "ND",
    "dropdelzpp": 585729998,
    "dropphyadd": "108 MAIN AVE",
    "dropphycty": "STERLING",
    "dropphyst": "ND",
    "dropphyzpp": 585729998,
    "dropmaladd": "108 MAIN AVE",
    "dropmalcty": "STERLING",
    "dropmalst": "ND",
    "dropmalzpp": 585729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013874377,
    "dropsitcph": 7016952482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19343",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "604 MAIN ST",
    "dropdelcty": "STRASBURG",
    "dropdelst": "ND",
    "dropdelzpp": 585739998,
    "dropphyadd": "604 MAIN ST",
    "dropphycty": "STRASBURG",
    "dropphyst": "ND",
    "dropphyzpp": 585739998,
    "dropmaladd": "604 MAIN ST",
    "dropmalcty": "STRASBURG",
    "dropmalst": "ND",
    "dropmalzpp": 585739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015818038,
    "dropsitcph": 7015818038,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19345",
    "droptype": "D",
    "dropname": "STREETER",
    "dropdeladd": "107 FLORENCE ST N",
    "dropdelcty": "STREETER",
    "dropdelst": "ND",
    "dropdelzpp": 584839998,
    "dropphyadd": "107 FLORENCE ST N",
    "dropphycty": "STREETER",
    "dropphyst": "ND",
    "dropphyzpp": 584839998,
    "dropmaladd": "107 FLORENCE ST N",
    "dropmalcty": "STREETER",
    "dropmalst": "ND",
    "dropmalzpp": 584839998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015058476,
    "dropsitcph": 7015058476,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19346",
    "droptype": "D",
    "dropname": "SURREY",
    "dropdeladd": "116 PLEASANT AVE N",
    "dropdelcty": "SURREY",
    "dropdelst": "ND",
    "dropdelzpp": 587859998,
    "dropphyadd": "116 PLEASANT AVE N",
    "dropphycty": "SURREY",
    "dropphyst": "ND",
    "dropphyzpp": 587859998,
    "dropmaladd": "116 PLEASANT AVE N",
    "dropmalcty": "SURREY",
    "dropmalst": "ND",
    "dropmalzpp": 587859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018383504,
    "dropsitcph": 7018383504,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19349",
    "droptype": "D",
    "dropname": "SYKESTON",
    "dropdeladd": "34 MAIN AVE N",
    "dropdelcty": "SYKESTON",
    "dropdelst": "ND",
    "dropdelzpp": 584869998,
    "dropphyadd": "34 MAIN AVE N",
    "dropphycty": "SYKESTON",
    "dropphyst": "ND",
    "dropphyzpp": 584869998,
    "dropmaladd": "34 MAIN AVE N",
    "dropmalcty": "SYKESTON",
    "dropmalst": "ND",
    "dropmalzpp": 584869998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019842278,
    "dropsitcph": 7015060313,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19351",
    "droptype": "D",
    "dropname": "TAPPEN",
    "dropdeladd": "112 N MAIN",
    "dropdelcty": "TAPPEN",
    "dropdelst": "ND",
    "dropdelzpp": 584879998,
    "dropphyadd": "112 N MAIN",
    "dropphycty": "TAPPEN",
    "dropphyst": "ND",
    "dropphyzpp": 584879998,
    "dropmaladd": "112 N MAIN",
    "dropmalcty": "TAPPEN",
    "dropmalst": "ND",
    "dropmalzpp": 584879998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013278306,
    "dropsitcph": 7015058662,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19352",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "ND",
    "dropdelzpp": 586569998,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "ND",
    "dropphyzpp": 586569998,
    "dropmaladd": "111 W MAIN ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "ND",
    "dropmalzpp": 586569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019743939,
    "dropsitcph": 7016605926,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19355",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "205 3RD ST",
    "dropdelcty": "THOMPSON",
    "dropdelst": "ND",
    "dropdelzpp": 582789998,
    "dropphyadd": "205 3RD ST",
    "dropphycty": "THOMPSON",
    "dropphyst": "ND",
    "dropphyzpp": 582789998,
    "dropmaladd": "205 3RD ST",
    "dropmalcty": "THOMPSON",
    "dropmalst": "ND",
    "dropmalzpp": 582789998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015992727,
    "dropsitcph": 7015992727,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19358",
    "droptype": "D",
    "dropname": "TIOGA",
    "dropdeladd": "24 N MAIN ST",
    "dropdelcty": "TIOGA",
    "dropdelst": "ND",
    "dropdelzpp": 588529998,
    "dropphyadd": "24 N MAIN ST",
    "dropphycty": "TIOGA",
    "dropphyst": "ND",
    "dropphyzpp": 588529998,
    "dropmaladd": "24 N MAIN ST",
    "dropmalcty": "TIOGA",
    "dropmalst": "ND",
    "dropmalzpp": 588529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016646659,
    "dropsitcph": 7016646659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19359",
    "droptype": "D",
    "dropname": "TOKIO",
    "dropdeladd": "413 3RD AVE",
    "dropdelcty": "TOKIO",
    "dropdelst": "ND",
    "dropdelzpp": 583799998,
    "dropphyadd": "413 3RD AVE",
    "dropphycty": "TOKIO",
    "dropphyst": "ND",
    "dropphyzpp": 583799998,
    "dropmaladd": "413 3RD AVE",
    "dropmalcty": "TOKIO",
    "dropmalst": "ND",
    "dropmalzpp": 583799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012943001,
    "dropsitcph": 7012943001,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19360",
    "droptype": "D",
    "dropname": "TOLLEY",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "TOLLEY",
    "dropdelst": "ND",
    "dropdelzpp": 587879998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "TOLLEY",
    "dropphyst": "ND",
    "dropphyzpp": 587879998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "TOLLEY",
    "dropmalst": "ND",
    "dropmalzpp": 587879998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013862247,
    "dropsitcph": 7013862247,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19361",
    "droptype": "D",
    "dropname": "TOLNA",
    "dropdeladd": "105 MAIN ST N",
    "dropdelcty": "TOLNA",
    "dropdelst": "ND",
    "dropdelzpp": 583809998,
    "dropphyadd": "105 MAIN ST N",
    "dropphycty": "TOLNA",
    "dropphyst": "ND",
    "dropphyzpp": 583809998,
    "dropmaladd": "105 MAIN ST N",
    "dropmalcty": "TOLNA",
    "dropmalst": "ND",
    "dropmalzpp": 583809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014843202,
    "dropsitcph": 7014843202,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19362",
    "droptype": "D",
    "dropname": "TOWER CITY",
    "dropdeladd": "505 BROADWAY ST",
    "dropdelcty": "TOWER CITY",
    "dropdelst": "ND",
    "dropdelzpp": 580719998,
    "dropphyadd": "505 BROADWAY ST",
    "dropphycty": "TOWER CITY",
    "dropphyst": "ND",
    "dropphyzpp": 580719998,
    "dropmaladd": "505 BROADWAY ST",
    "dropmalcty": "TOWER CITY",
    "dropmalst": "ND",
    "dropmalzpp": 580719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014908428,
    "dropsitcph": 7014908428,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19363",
    "droptype": "D",
    "dropname": "TOWNER",
    "dropdeladd": "205 MAIN ST S",
    "dropdelcty": "TOWNER",
    "dropdelst": "ND",
    "dropdelzpp": 587889998,
    "dropphyadd": "205 MAIN ST S",
    "dropphycty": "TOWNER",
    "dropphyst": "ND",
    "dropphyzpp": 587889998,
    "dropmaladd": "205 MAIN ST S",
    "dropmalcty": "TOWNER",
    "dropmalst": "ND",
    "dropmalzpp": 587889998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015375110,
    "dropsitcph": 7015375110,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19364",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "331 4TH AVE E RM 18",
    "dropdelcty": "TRENTON",
    "dropdelst": "ND",
    "dropdelzpp": 588539998,
    "dropphyadd": "331 4TH AVE E RM 18",
    "dropphycty": "TRENTON",
    "dropphyst": "ND",
    "dropphyzpp": 588539998,
    "dropmaladd": "331 4TH AVE E RM 18",
    "dropmalcty": "TRENTON",
    "dropmalst": "ND",
    "dropmalzpp": 588539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017741355,
    "dropsitcph": 7016951151,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19366",
    "droptype": "D",
    "dropname": "TURTLE LAKE",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "TURTLE LAKE",
    "dropdelst": "ND",
    "dropdelzpp": 585759998,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "TURTLE LAKE",
    "dropphyst": "ND",
    "dropphyzpp": 585759998,
    "dropmaladd": "113 MAIN ST",
    "dropmalcty": "TURTLE LAKE",
    "dropmalst": "ND",
    "dropmalzpp": 585759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014482654,
    "dropsitcph": 7016952407,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19368",
    "droptype": "D",
    "dropname": "TUTTLE",
    "dropdeladd": "208 N MAIN ST",
    "dropdelcty": "TUTTLE",
    "dropdelst": "ND",
    "dropdelzpp": 584889998,
    "dropphyadd": "208 N MAIN ST",
    "dropphycty": "TUTTLE",
    "dropphyst": "ND",
    "dropphyzpp": 584889998,
    "dropmaladd": "208 N MAIN ST",
    "dropmalcty": "TUTTLE",
    "dropmalst": "ND",
    "dropmalzpp": 584889998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018672872,
    "dropsitcph": 7016600068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19370",
    "droptype": "D",
    "dropname": "UNDERWOOD",
    "dropdeladd": "301 1ST ST",
    "dropdelcty": "UNDERWOOD",
    "dropdelst": "ND",
    "dropdelzpp": 585769998,
    "dropphyadd": "301 1ST ST",
    "dropphycty": "UNDERWOOD",
    "dropphyst": "ND",
    "dropphyzpp": 585769998,
    "dropmaladd": "301 1ST ST",
    "dropmalcty": "UNDERWOOD",
    "dropmalst": "ND",
    "dropmalzpp": 585769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014425441,
    "dropsitcph": 7016952094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19375",
    "droptype": "D",
    "dropname": "VALLEY CITY",
    "dropdeladd": "149 3RD ST NE",
    "dropdelcty": "VALLEY CITY",
    "dropdelst": "ND",
    "dropdelzpp": 580729998,
    "dropphyadd": "149 3RD ST NE",
    "dropphycty": "VALLEY CITY",
    "dropphyst": "ND",
    "dropphyzpp": 580729998,
    "dropmaladd": "149 3RD ST NE",
    "dropmalcty": "VALLEY CITY",
    "dropmalst": "ND",
    "dropmalzpp": 580729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018459723,
    "dropsitcph": 7018459723,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19376",
    "droptype": "D",
    "dropname": "VELVA",
    "dropdeladd": "105 MAIN ST N",
    "dropdelcty": "VELVA",
    "dropdelst": "ND",
    "dropdelzpp": 587909998,
    "dropphyadd": "105 MAIN ST N",
    "dropphycty": "VELVA",
    "dropphyst": "ND",
    "dropphyzpp": 587909998,
    "dropmaladd": "105 MAIN ST N",
    "dropmalcty": "VELVA",
    "dropmalst": "ND",
    "dropmalzpp": 587909998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013382900,
    "dropsitcph": 7013382900,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19378",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "212 4TH ST",
    "dropdelcty": "VERONA",
    "dropdelst": "ND",
    "dropdelzpp": 584909998,
    "dropphyadd": "212 4TH ST",
    "dropphycty": "VERONA",
    "dropphyst": "ND",
    "dropphyzpp": 584909998,
    "dropmaladd": "212 4TH ST",
    "dropmalcty": "VERONA",
    "dropmalst": "ND",
    "dropmalzpp": 584909998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014325534,
    "dropsitcph": 7015060215,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19379",
    "droptype": "D",
    "dropname": "VOLTAIRE",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "VOLTAIRE",
    "dropdelst": "ND",
    "dropdelzpp": 587929998,
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "VOLTAIRE",
    "dropphyst": "ND",
    "dropphyzpp": 587929998,
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "VOLTAIRE",
    "dropmalst": "ND",
    "dropmalzpp": 587929998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013382735,
    "dropsitcph": 7013382735,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19382",
    "droptype": "D",
    "dropname": "WAHPETON",
    "dropdeladd": "926 2ND AVE N",
    "dropdelcty": "WAHPETON",
    "dropdelst": "ND",
    "dropdelzpp": 580759998,
    "dropphyadd": "926 2ND AVE N",
    "dropphycty": "WAHPETON",
    "dropphyst": "ND",
    "dropphyzpp": 580759998,
    "dropmaladd": "926 2ND AVE N",
    "dropmalcty": "WAHPETON",
    "dropmalst": "ND",
    "dropmalzpp": 580759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016422347,
    "dropsitcph": 7016422347,
    "dropfax": 7016422326
  },
  {
    "dcode": "D",
    "dropkey": "PW19383",
    "droptype": "D",
    "dropname": "WALCOTT",
    "dropdeladd": "472 MAIN AVE",
    "dropdelcty": "WALCOTT",
    "dropdelst": "ND",
    "dropdelzpp": 580779998,
    "dropphyadd": "472 MAIN AVE",
    "dropphycty": "WALCOTT",
    "dropphyst": "ND",
    "dropphyzpp": 580779998,
    "dropmaladd": "472 MAIN AVE",
    "dropmalcty": "WALCOTT",
    "dropmalst": "ND",
    "dropmalzpp": 580779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014692257,
    "dropsitcph": 8773641524,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19385",
    "droptype": "D",
    "dropname": "WALHALLA",
    "dropdeladd": "408 10TH ST",
    "dropdelcty": "WALHALLA",
    "dropdelst": "ND",
    "dropdelzpp": 582829998,
    "dropphyadd": "408 10TH ST",
    "dropphycty": "WALHALLA",
    "dropphyst": "ND",
    "dropphyzpp": 582829998,
    "dropmaladd": "408 10TH ST",
    "dropmalcty": "WALHALLA",
    "dropmalst": "ND",
    "dropmalzpp": 582829998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014282384,
    "dropsitcph": 7014282384,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19391",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "721 MAIN AVE",
    "dropdelcty": "WASHBURN",
    "dropdelst": "ND",
    "dropdelzpp": 585779998,
    "dropphyadd": "721 MAIN AVE",
    "dropphycty": "WASHBURN",
    "dropphyst": "ND",
    "dropphyzpp": 585779998,
    "dropmaladd": "721 MAIN AVE",
    "dropmalcty": "WASHBURN",
    "dropmalst": "ND",
    "dropmalzpp": 585779998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014623773,
    "dropsitcph": 7815058971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19392",
    "droptype": "D",
    "dropname": "WATFORD CITY",
    "dropdeladd": "1204 4TH AVE NE",
    "dropdelcty": "WATFORD CITY",
    "dropdelst": "ND",
    "dropdelzpp": 588549998,
    "dropphyadd": "1204 4TH AVE NE",
    "dropphycty": "WATFORD CITY",
    "dropphyst": "ND",
    "dropphyzpp": 588549998,
    "dropmaladd": "1204 4TH AVE NE",
    "dropmalcty": "WATFORD CITY",
    "dropmalst": "ND",
    "dropmalzpp": 588549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7018422213,
    "dropsitcph": 7014442119,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19398",
    "droptype": "D",
    "dropname": "WEST FARGO",
    "dropdeladd": "415 MAIN AVE E",
    "dropdelcty": "WEST FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 580789998,
    "dropphyadd": "415 MAIN AVE E",
    "dropphycty": "WEST FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 580789998,
    "dropmaladd": "415 MAIN AVE E",
    "dropmalcty": "WEST FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 580789998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012823158,
    "dropsitcph": 7012823158,
    "dropfax": 7012812825
  },
  {
    "dcode": "D",
    "dropkey": "PW19401",
    "droptype": "D",
    "dropname": "WESTHOPE",
    "dropdeladd": "180 MAIN ST",
    "dropdelcty": "WESTHOPE",
    "dropdelst": "ND",
    "dropdelzpp": 587939998,
    "dropphyadd": "180 MAIN ST",
    "dropphycty": "WESTHOPE",
    "dropphyst": "ND",
    "dropphyzpp": 587939998,
    "dropmaladd": "180 MAIN ST",
    "dropmalcty": "WESTHOPE",
    "dropmalst": "ND",
    "dropmalzpp": 587939998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7012456101,
    "dropsitcph": 7012456101,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19408",
    "droptype": "D",
    "dropname": "WILDROSE",
    "dropdeladd": "507 MAIN ST",
    "dropdelcty": "WILDROSE",
    "dropdelst": "ND",
    "dropdelzpp": 587959998,
    "dropphyadd": "507 MAIN ST",
    "dropphycty": "WILDROSE",
    "dropphyst": "ND",
    "dropphyzpp": 587959998,
    "dropmaladd": "507 MAIN ST",
    "dropmalcty": "WILDROSE",
    "dropmalst": "ND",
    "dropmalzpp": 587959998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015392288,
    "dropsitcph": 7015392288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19410",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "120 E BROADWAY",
    "dropdelcty": "WILLISTON",
    "dropdelst": "ND",
    "dropdelzpp": 588019998,
    "dropphyadd": "120 E BROADWAY",
    "dropphycty": "WILLISTON",
    "dropphyst": "ND",
    "dropphyzpp": 588019998,
    "dropmaladd": "120 E BROADWAY",
    "dropmalcty": "WILLISTON",
    "dropmalst": "ND",
    "dropmalzpp": 588019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015722408,
    "dropsitcph": 7015722408,
    "dropfax": 7015729502
  },
  {
    "dcode": "D",
    "dropkey": "PW19411",
    "droptype": "D",
    "dropname": "WILLOW CITY",
    "dropdeladd": "259 MAIN ST",
    "dropdelcty": "WILLOW CITY",
    "dropdelst": "ND",
    "dropdelzpp": 583849998,
    "dropphyadd": "259 MAIN ST",
    "dropphycty": "WILLOW CITY",
    "dropphyst": "ND",
    "dropphyzpp": 583849998,
    "dropmaladd": "259 MAIN ST",
    "dropmalcty": "WILLOW CITY",
    "dropmalst": "ND",
    "dropmalzpp": 583849998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013664488,
    "dropsitcph": 7013538739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19412",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "25 DAKOTA AVE",
    "dropdelcty": "WILTON",
    "dropdelst": "ND",
    "dropdelzpp": 585799998,
    "dropphyadd": "25 DAKOTA AVE",
    "dropphycty": "WILTON",
    "dropphyst": "ND",
    "dropphyzpp": 585799998,
    "dropmaladd": "25 DAKOTA AVE",
    "dropmalcty": "WILTON",
    "dropmalst": "ND",
    "dropmalzpp": 585799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017346515,
    "dropsitcph": 7016950705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19413",
    "droptype": "D",
    "dropname": "WIMBLEDON",
    "dropdeladd": "118 3RD AVE",
    "dropdelcty": "WIMBLEDON",
    "dropdelst": "ND",
    "dropdelzpp": 584929998,
    "dropphyadd": "118 3RD AVE",
    "dropphycty": "WIMBLEDON",
    "dropphyst": "ND",
    "dropphyzpp": 584929998,
    "dropmaladd": "118 3RD AVE",
    "dropmalcty": "WIMBLEDON",
    "dropmalst": "ND",
    "dropmalzpp": 584929998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7013687207,
    "dropsitcph": 7013687207,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19415",
    "droptype": "D",
    "dropname": "WING",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "WING",
    "dropdelst": "ND",
    "dropdelzpp": 584949998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "WING",
    "dropphyst": "ND",
    "dropphyzpp": 584949998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "WING",
    "dropmalst": "ND",
    "dropmalzpp": 584949998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019432364,
    "dropsitcph": 7016952461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19416",
    "droptype": "D",
    "dropname": "WISHEK",
    "dropdeladd": "14 N 5TH ST",
    "dropdelcty": "WISHEK",
    "dropdelst": "ND",
    "dropdelzpp": 584959998,
    "dropphyadd": "14 N 5TH ST",
    "dropphycty": "WISHEK",
    "dropphyst": "ND",
    "dropphyzpp": 584959998,
    "dropmaladd": "14 N 5TH ST",
    "dropmalcty": "WISHEK",
    "dropmalst": "ND",
    "dropmalzpp": 584959998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014522475,
    "dropsitcph": 7014522475,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19417",
    "droptype": "D",
    "dropname": "WOLFORD",
    "dropdeladd": "201 3RD AVE N",
    "dropdelcty": "WOLFORD",
    "dropdelst": "ND",
    "dropdelzpp": 583859998,
    "dropphyadd": "201 3RD AVE N",
    "dropphycty": "WOLFORD",
    "dropphyst": "ND",
    "dropphyzpp": 583859998,
    "dropmaladd": "201 3RD AVE N",
    "dropmalcty": "WOLFORD",
    "dropmalst": "ND",
    "dropmalzpp": 583859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015832375,
    "dropsitcph": 7013538715,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19421",
    "droptype": "D",
    "dropname": "WOODWORTH",
    "dropdeladd": "120 MAIN ST N",
    "dropdelcty": "WOODWORTH",
    "dropdelst": "ND",
    "dropdelzpp": 584969998,
    "dropphyadd": "120 MAIN ST N",
    "dropphycty": "WOODWORTH",
    "dropphyst": "ND",
    "dropphyzpp": 584969998,
    "dropmaladd": "120 MAIN ST N",
    "dropmalcty": "WOODWORTH",
    "dropmalst": "ND",
    "dropmalzpp": 584969998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7017524202,
    "dropsitcph": 7016950226,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19422",
    "droptype": "D",
    "dropname": "WYNDMERE",
    "dropdeladd": "455 4TH ST",
    "dropdelcty": "WYNDMERE",
    "dropdelst": "ND",
    "dropdelzpp": 580819998,
    "dropphyadd": "455 4TH ST",
    "dropphycty": "WYNDMERE",
    "dropphyst": "ND",
    "dropphyzpp": 580819998,
    "dropmaladd": "455 4TH ST",
    "dropmalcty": "WYNDMERE",
    "dropmalst": "ND",
    "dropmalzpp": 580819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014392500,
    "dropsitcph": 7014071099,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19424",
    "droptype": "D",
    "dropname": "YPSILANTI",
    "dropdeladd": "218 1ST ST",
    "dropdelcty": "YPSILANTI",
    "dropdelst": "ND",
    "dropdelzpp": 584979998,
    "dropphyadd": "218 1ST ST",
    "dropphycty": "YPSILANTI",
    "dropphyst": "ND",
    "dropphyzpp": 584979998,
    "dropmaladd": "218 1ST ST",
    "dropmalcty": "YPSILANTI",
    "dropmalst": "ND",
    "dropmalzpp": 584979998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014893135,
    "dropsitcph": 7014893135,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19425",
    "droptype": "D",
    "dropname": "ZAHL",
    "dropdeladd": "207 MAIN ST OFC",
    "dropdelcty": "ZAHL",
    "dropdelst": "ND",
    "dropdelzpp": 588569998,
    "dropphyadd": "207 MAIN ST OFC",
    "dropphycty": "ZAHL",
    "dropphyst": "ND",
    "dropphyzpp": 588569998,
    "dropmaladd": "207 MAIN ST OFC",
    "dropmalcty": "ZAHL",
    "dropmalst": "ND",
    "dropmalzpp": 588569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7016944315,
    "dropsitcph": 7016944315,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19426",
    "droptype": "D",
    "dropname": "ZAP",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "ZAP",
    "dropdelst": "ND",
    "dropdelzpp": 585809998,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "ZAP",
    "dropphyst": "ND",
    "dropphyzpp": 585809998,
    "dropmaladd": "113 MAIN ST",
    "dropmalcty": "ZAP",
    "dropmalst": "ND",
    "dropmalzpp": 585809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019482247,
    "dropsitcph": 7016600378,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19427",
    "droptype": "D",
    "dropname": "ZEELAND",
    "dropdeladd": "108 S MAIN",
    "dropdelcty": "ZEELAND",
    "dropdelst": "ND",
    "dropdelzpp": 585819998,
    "dropphyadd": "108 S MAIN",
    "dropphycty": "ZEELAND",
    "dropphyst": "ND",
    "dropphyzpp": 585819998,
    "dropmaladd": "108 S MAIN",
    "dropmalcty": "ZEELAND",
    "dropmalst": "ND",
    "dropmalzpp": 585819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 7014235467,
    "dropsitcph": 7014235467,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PW19432",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "615 MAIN ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "NE",
    "dropdelzpp": 683019805,
    "dropphyadd": "615 MAIN ST",
    "dropphycty": "ADAMS",
    "dropphyst": "NE",
    "dropphyzpp": 683019805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMS",
    "dropmalst": "NE",
    "dropmalzpp": 683019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029884975,
    "dropsitcph": 4029884975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19434",
    "droptype": "D",
    "dropname": "AINSWORTH",
    "dropdeladd": "375 N MAIN ST",
    "dropdelcty": "AINSWORTH",
    "dropdelst": "NE",
    "dropdelzpp": 692109998,
    "dropphyadd": "375 N MAIN ST",
    "dropphycty": "AINSWORTH",
    "dropphyst": "NE",
    "dropphyzpp": 692109998,
    "dropmaladd": "375 N MAIN ST",
    "dropmalcty": "AINSWORTH",
    "dropmalst": "NE",
    "dropmalzpp": 692109998,
    "dropsitphn": 4023872182,
    "dropsitlph": 4023872182,
    "dropsitcph": 4023872182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19439",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "310 W CHURCH ST",
    "dropdelcty": "ALBION",
    "dropdelst": "NE",
    "dropdelzpp": 686209998,
    "dropphyadd": "310 W CHURCH ST",
    "dropphycty": "ALBION",
    "dropphyst": "NE",
    "dropphyzpp": 686209998,
    "dropmaladd": "310 W CHURCH ST",
    "dropmalcty": "ALBION",
    "dropmalst": "NE",
    "dropmalzpp": 686209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023952047,
    "dropsitcph": 4023952047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19440",
    "droptype": "D",
    "dropname": "ALDA",
    "dropdeladd": "102 E FRONT ST",
    "dropdelcty": "ALDA",
    "dropdelst": "NE",
    "dropdelzpp": 688109733,
    "dropphyadd": "102 E FRONT ST",
    "dropphycty": "ALDA",
    "dropphyst": "NE",
    "dropphyzpp": 688109733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALDA",
    "dropmalst": "NE",
    "dropmalzpp": 688109998,
    "dropsitphn": 3083843119,
    "dropsitlph": 3083843119,
    "dropsitcph": 3083843119,
    "dropfax": 3083843119
  },
  {
    "dcode": "D",
    "dropkey": "PW19441",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "302 HARBINE ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "NE",
    "dropdelzpp": 683039760,
    "dropphyadd": "302 HARBINE ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "NE",
    "dropphyzpp": 683039760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "NE",
    "dropmalzpp": 683039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027495030,
    "dropsitcph": 4027495030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19443",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "104 E 2ND ST",
    "dropdelcty": "ALLEN",
    "dropdelst": "NE",
    "dropdelzpp": 687109800,
    "dropphyadd": "104 E 2ND ST",
    "dropphycty": "ALLEN",
    "dropphyst": "NE",
    "dropphyzpp": 687109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLEN",
    "dropmalst": "NE",
    "dropmalzpp": 687109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026352065,
    "dropsitcph": 4026352065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19445",
    "droptype": "D",
    "dropname": "ALLIANCE",
    "dropdeladd": "401 BOX BUTTE AVE",
    "dropdelcty": "ALLIANCE",
    "dropdelst": "NE",
    "dropdelzpp": 693013343,
    "dropphyadd": "401 BOX BUTTE AVE",
    "dropphycty": "ALLIANCE",
    "dropphyst": "NE",
    "dropphyzpp": 693013343,
    "dropmaladd": "401 BOX BUTTE AVE",
    "dropmalcty": "ALLIANCE",
    "dropmalst": "NE",
    "dropmalzpp": 693013343,
    "dropsitphn": 3087623212,
    "dropsitlph": 3087623212,
    "dropsitcph": 3087623212,
    "dropfax": 3087625343
  },
  {
    "dcode": "D",
    "dropkey": "PW19446",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "711 1ST ST",
    "dropdelcty": "ALMA",
    "dropdelst": "NE",
    "dropdelzpp": 689202103,
    "dropphyadd": "711 1ST ST",
    "dropphycty": "ALMA",
    "dropphyst": "NE",
    "dropphyzpp": 689202103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMA",
    "dropmalst": "NE",
    "dropmalzpp": 689209998,
    "dropsitphn": 3089282134,
    "dropsitlph": 3089282134,
    "dropsitcph": 3089282134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19452",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "119 N MAIN ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "NE",
    "dropdelzpp": 688124522,
    "dropphyadd": "119 N MAIN ST",
    "dropphycty": "AMHERST",
    "dropphyst": "NE",
    "dropphyzpp": 688124522,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMHERST",
    "dropmalst": "NE",
    "dropmalzpp": 688129998,
    "dropsitphn": 3088263545,
    "dropsitlph": 3088263545,
    "dropsitcph": 3088263545,
    "dropfax": 3088263545
  },
  {
    "dcode": "D",
    "dropkey": "PW19455",
    "droptype": "D",
    "dropname": "ANGORA",
    "dropdeladd": "100 ROAD 118",
    "dropdelcty": "ANGORA",
    "dropdelst": "NE",
    "dropdelzpp": 693319725,
    "dropphyadd": "100 ROAD 118",
    "dropphycty": "ANGORA",
    "dropphyst": "NE",
    "dropphyzpp": 693319725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANGORA",
    "dropmalst": "NE",
    "dropmalzpp": 693319998,
    "dropsitphn": 3082620876,
    "dropsitlph": 3082620876,
    "dropsitcph": 3082620876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19456",
    "droptype": "D",
    "dropname": "ANSELMO",
    "dropdeladd": "114 E SMITH AVE",
    "dropdelcty": "ANSELMO",
    "dropdelst": "NE",
    "dropdelzpp": 688137107,
    "dropphyadd": "114 E SMITH AVE",
    "dropphycty": "ANSELMO",
    "dropphyst": "NE",
    "dropphyzpp": 688137107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANSELMO",
    "dropmalst": "NE",
    "dropmalzpp": 688139998,
    "dropsitphn": 3087492203,
    "dropsitlph": 3087492203,
    "dropsitcph": 3087492203,
    "dropfax": 3087492203
  },
  {
    "dcode": "D",
    "dropkey": "PW19457",
    "droptype": "D",
    "dropname": "ANSLEY",
    "dropdeladd": "806 MAIN ST",
    "dropdelcty": "ANSLEY",
    "dropdelst": "NE",
    "dropdelzpp": 688142427,
    "dropphyadd": "806 MAIN ST",
    "dropphycty": "ANSLEY",
    "dropphyst": "NE",
    "dropphyzpp": 688142427,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANSLEY",
    "dropmalst": "NE",
    "dropmalzpp": 688149998,
    "dropsitphn": 3089351553,
    "dropsitlph": 3089351553,
    "dropsitcph": 3089351553,
    "dropfax": 3089351553
  },
  {
    "dcode": "D",
    "dropkey": "PW19462",
    "droptype": "D",
    "dropname": "ARAPAHOE",
    "dropdeladd": "416 NEBRASKA AVE",
    "dropdelcty": "ARAPAHOE",
    "dropdelst": "NE",
    "dropdelzpp": 689222762,
    "dropphyadd": "416 NEBRASKA AVE",
    "dropphycty": "ARAPAHOE",
    "dropphyst": "NE",
    "dropphyzpp": 689222762,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARAPAHOE",
    "dropmalst": "NE",
    "dropmalzpp": 689229998,
    "dropsitphn": 3089627213,
    "dropsitlph": 3089627213,
    "dropsitcph": 3089627213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19463",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "125 W BRIDGE ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "NE",
    "dropdelzpp": 688159760,
    "dropphyadd": "125 W BRIDGE ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "NE",
    "dropphyzpp": 688159760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "NE",
    "dropmalzpp": 688159998,
    "dropsitphn": 3087896119,
    "dropsitlph": 3087896119,
    "dropsitcph": 3087896119,
    "dropfax": 3087896119
  },
  {
    "dcode": "D",
    "dropkey": "PW19465",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "237 N 2ND ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "NE",
    "dropdelzpp": 680023106,
    "dropphyadd": "237 N 2ND ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "NE",
    "dropphyzpp": 680023106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "NE",
    "dropmalzpp": 680029998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3087430224,
    "dropsitcph": 3087430224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19467",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "214 S WALNUT ST",
    "dropdelcty": "ARNOLD",
    "dropdelst": "NE",
    "dropdelzpp": 691209788,
    "dropphyadd": "214 S WALNUT ST",
    "dropphycty": "ARNOLD",
    "dropphyst": "NE",
    "dropphyzpp": 691209788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARNOLD",
    "dropmalst": "NE",
    "dropmalzpp": 691209998,
    "dropsitphn": 3088482210,
    "dropsitlph": 3088482210,
    "dropsitcph": 3088482210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19468",
    "droptype": "D",
    "dropname": "ARTHUR",
    "dropdeladd": "309 FIR ST",
    "dropdelcty": "ARTHUR",
    "dropdelst": "NE",
    "dropdelzpp": 691219700,
    "dropphyadd": "309 FIR ST",
    "dropphycty": "ARTHUR",
    "dropphyst": "NE",
    "dropphyzpp": 691219700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARTHUR",
    "dropmalst": "NE",
    "dropmalzpp": 691219998,
    "dropsitphn": 3087642273,
    "dropsitlph": 3087642273,
    "dropsitcph": 3087642273,
    "dropfax": 3087642273
  },
  {
    "dcode": "D",
    "dropkey": "PW19470",
    "droptype": "D",
    "dropname": "ASHBY",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "ASHBY",
    "dropdelst": "NE",
    "dropdelzpp": 693339703,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "ASHBY",
    "dropphyst": "NE",
    "dropphyzpp": 693339703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHBY",
    "dropmalst": "NE",
    "dropmalzpp": 693339998,
    "dropsitphn": 3085776359,
    "dropsitlph": 3085776359,
    "dropsitcph": 3085776359,
    "dropfax": 3085776359
  },
  {
    "dcode": "D",
    "dropkey": "PW19471",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "1542 SILVER ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "NE",
    "dropdelzpp": 680039998,
    "dropphyadd": "1542 SILVER ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "NE",
    "dropphyzpp": 680039998,
    "dropmaladd": "1542 SILVER ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "NE",
    "dropmalzpp": 680039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029443338,
    "dropsitcph": 4029443338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19472",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "301 CENTER AVE",
    "dropdelcty": "ASHTON",
    "dropdelst": "NE",
    "dropdelzpp": 688179706,
    "dropphyadd": "301 CENTER AVE",
    "dropphycty": "ASHTON",
    "dropphyst": "NE",
    "dropphyzpp": 688179706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHTON",
    "dropmalst": "NE",
    "dropmalzpp": 688179998,
    "dropsitphn": 3087382122,
    "dropsitlph": 3087382122,
    "dropsitcph": 3087382122,
    "dropfax": 3087382191
  },
  {
    "dcode": "D",
    "dropkey": "PW19474",
    "droptype": "D",
    "dropname": "ATKINSON",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "ATKINSON",
    "dropdelst": "NE",
    "dropdelzpp": 687134947,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "ATKINSON",
    "dropphyst": "NE",
    "dropphyzpp": 687134947,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATKINSON",
    "dropmalst": "NE",
    "dropmalzpp": 687139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029252772,
    "dropsitcph": 4029252772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19476",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "1320 COURTHOUSE AVE",
    "dropdelcty": "AUBURN",
    "dropdelst": "NE",
    "dropdelzpp": 683059998,
    "dropphyadd": "1320 COURTHOUSE AVE",
    "dropphycty": "AUBURN",
    "dropphyst": "NE",
    "dropphyzpp": 683059998,
    "dropmaladd": "1320 COURTHOUSE AVE",
    "dropmalcty": "AUBURN",
    "dropmalst": "NE",
    "dropmalzpp": 683059998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022743809,
    "dropsitcph": 4022743809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19477",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "1105 L ST",
    "dropdelcty": "AURORA",
    "dropdelst": "NE",
    "dropdelzpp": 688189998,
    "dropphyadd": "1105 L ST",
    "dropphycty": "AURORA",
    "dropphyst": "NE",
    "dropphyzpp": 688189998,
    "dropmaladd": "1105 L ST",
    "dropmalcty": "AURORA",
    "dropmalst": "NE",
    "dropmalzpp": 688189998,
    "dropsitphn": 4026942503,
    "dropsitlph": 4026942503,
    "dropsitcph": 4026942503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19478",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "624 HOUSE ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "NE",
    "dropdelzpp": 683073000,
    "dropphyadd": "624 HOUSE ST",
    "dropphycty": "AVOCA",
    "dropphyst": "NE",
    "dropphyzpp": 683073000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVOCA",
    "dropmalst": "NE",
    "dropmalzpp": 683079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022753270,
    "dropsitcph": 4022753270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19479",
    "droptype": "D",
    "dropname": "AXTELL",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "AXTELL",
    "dropdelst": "NE",
    "dropdelzpp": 689242428,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "AXTELL",
    "dropphyst": "NE",
    "dropphyzpp": 689242428,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AXTELL",
    "dropmalst": "NE",
    "dropmalzpp": 689249998,
    "dropsitphn": 3087432353,
    "dropsitlph": 3087432353,
    "dropsitcph": 3087432353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19480",
    "droptype": "D",
    "dropname": "AYR",
    "dropdeladd": "4075 W LINCOLN AVE",
    "dropdelcty": "AYR",
    "dropdelst": "NE",
    "dropdelzpp": 689259700,
    "dropphyadd": "4075 W LINCOLN AVE",
    "dropphycty": "AYR",
    "dropphyst": "NE",
    "dropphyzpp": 689259700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AYR",
    "dropmalst": "NE",
    "dropmalzpp": 689259998,
    "dropsitphn": 4024638895,
    "dropsitlph": 4024638895,
    "dropsitcph": 4024638895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19482",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "203 W POPLAR ST",
    "dropdelcty": "BANCROFT",
    "dropdelst": "NE",
    "dropdelzpp": 680049700,
    "dropphyadd": "203 W POPLAR ST",
    "dropphycty": "BANCROFT",
    "dropphyst": "NE",
    "dropphyzpp": 680049700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANCROFT",
    "dropmalst": "NE",
    "dropmalzpp": 680049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026487432,
    "dropsitcph": 4026487432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19487",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "300 3RD ST",
    "dropdelcty": "BARTLETT",
    "dropdelst": "NE",
    "dropdelzpp": 686229751,
    "dropphyadd": "300 3RD ST",
    "dropphycty": "BARTLETT",
    "dropphyst": "NE",
    "dropphyzpp": 686229751,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARTLETT",
    "dropmalst": "NE",
    "dropmalzpp": 686229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3086543279,
    "dropsitcph": 3086543279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19488",
    "droptype": "D",
    "dropname": "BARTLEY",
    "dropdeladd": "401 COMMERCIAL ST",
    "dropdelcty": "BARTLEY",
    "dropdelst": "NE",
    "dropdelzpp": 690209750,
    "dropphyadd": "401 COMMERCIAL ST",
    "dropphycty": "BARTLEY",
    "dropphyst": "NE",
    "dropphyzpp": 690209750,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARTLEY",
    "dropmalst": "NE",
    "dropmalzpp": 690209998,
    "dropsitphn": 3086923341,
    "dropsitlph": 3086923341,
    "dropsitcph": 3086923341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19489",
    "droptype": "D",
    "dropname": "BASSETT",
    "dropdeladd": "201 S CLARK ST",
    "dropdelcty": "BASSETT",
    "dropdelst": "NE",
    "dropdelzpp": 687146042,
    "dropphyadd": "201 S CLARK ST",
    "dropphycty": "BASSETT",
    "dropphyst": "NE",
    "dropphyzpp": 687146042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BASSETT",
    "dropmalst": "NE",
    "dropmalzpp": 687149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026843941,
    "dropsitcph": 4026843941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19490",
    "droptype": "D",
    "dropname": "BATTLE CREEK",
    "dropdeladd": "106 S 2ND ST",
    "dropdelcty": "BATTLE CREEK",
    "dropdelst": "NE",
    "dropdelzpp": 687159799,
    "dropphyadd": "106 S 2ND ST",
    "dropphycty": "BATTLE CREEK",
    "dropphyst": "NE",
    "dropphyzpp": 687159799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATTLE CREEK",
    "dropmalst": "NE",
    "dropmalzpp": 687159998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026755145,
    "dropsitcph": 4026755145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19492",
    "droptype": "D",
    "dropname": "BAYARD",
    "dropdeladd": "517 MAIN ST",
    "dropdelcty": "BAYARD",
    "dropdelst": "NE",
    "dropdelzpp": 693341400,
    "dropphyadd": "517 MAIN ST",
    "dropphycty": "BAYARD",
    "dropphyst": "NE",
    "dropphyzpp": 693341400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYARD",
    "dropmalst": "NE",
    "dropmalzpp": 693349998,
    "dropsitphn": 3085861314,
    "dropsitlph": 3085861314,
    "dropsitcph": 3085861314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19493",
    "droptype": "D",
    "dropname": "BEATRICE",
    "dropdeladd": "425 N 6TH ST",
    "dropdelcty": "BEATRICE",
    "dropdelst": "NE",
    "dropdelzpp": 683109998,
    "dropphyadd": "425 N 6TH ST",
    "dropphycty": "BEATRICE",
    "dropphyst": "NE",
    "dropphyzpp": 683109998,
    "dropmaladd": "425 N 6TH ST",
    "dropmalcty": "BEATRICE",
    "dropmalst": "NE",
    "dropmalzpp": 683109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022283361,
    "dropsitcph": 4022283361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19494",
    "droptype": "D",
    "dropname": "BEAVER CITY",
    "dropdeladd": "417 9TH ST",
    "dropdelcty": "BEAVER CITY",
    "dropdelst": "NE",
    "dropdelzpp": 689262745,
    "dropphyadd": "417 9TH ST",
    "dropphycty": "BEAVER CITY",
    "dropphyst": "NE",
    "dropphyzpp": 689262745,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER CITY",
    "dropmalst": "NE",
    "dropmalzpp": 689269998,
    "dropsitphn": 3082683783,
    "dropsitlph": 3082683783,
    "dropsitcph": 3082683783,
    "dropfax": 3082683783
  },
  {
    "dcode": "D",
    "dropkey": "PW19495",
    "droptype": "D",
    "dropname": "BEAVER CROSSING",
    "dropdeladd": "823 DIMERY AVE",
    "dropdelcty": "BEAVER CROSSING",
    "dropdelst": "NE",
    "dropdelzpp": 683139561,
    "dropphyadd": "823 DIMERY AVE",
    "dropphycty": "BEAVER CROSSING",
    "dropphyst": "NE",
    "dropphyzpp": 683139561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER CROSSING",
    "dropmalst": "NE",
    "dropmalzpp": 683139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025322135,
    "dropsitcph": 4025322135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19498",
    "droptype": "D",
    "dropname": "BEE",
    "dropdeladd": "185 ELM ST",
    "dropdelcty": "BEE",
    "dropdelst": "NE",
    "dropdelzpp": 683149701,
    "dropphyadd": "185 ELM ST",
    "dropphycty": "BEE",
    "dropphyst": "NE",
    "dropphyzpp": 683149701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEE",
    "dropmalst": "NE",
    "dropmalzpp": 683149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026432312,
    "dropsitcph": 4026432312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19499",
    "droptype": "D",
    "dropname": "BEEMER",
    "dropdeladd": "314 MAIN ST",
    "dropdelcty": "BEEMER",
    "dropdelst": "NE",
    "dropdelzpp": 687164215,
    "dropphyadd": "314 MAIN ST",
    "dropphycty": "BEEMER",
    "dropphyst": "NE",
    "dropphyzpp": 687164215,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEEMER",
    "dropmalst": "NE",
    "dropmalzpp": 687169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025283401,
    "dropsitcph": 4025283401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19500",
    "droptype": "D",
    "dropname": "BELDEN",
    "dropdeladd": "204 NEBRASKA ST",
    "dropdelcty": "BELDEN",
    "dropdelst": "NE",
    "dropdelzpp": 687178751,
    "dropphyadd": "204 NEBRASKA ST",
    "dropphycty": "BELDEN",
    "dropphyst": "NE",
    "dropphyzpp": 687178751,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELDEN",
    "dropmalst": "NE",
    "dropmalzpp": 687179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029852226,
    "dropsitcph": 4029852226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19503",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "2609 VICTORIA AVE",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "NE",
    "dropdelzpp": 680059998,
    "dropphyadd": "2609 VICTORIA AVE",
    "dropphycty": "BELLEVUE",
    "dropphyst": "NE",
    "dropphyzpp": 680059998,
    "dropmaladd": "2609 VICTORIA AVE",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "NE",
    "dropmalzpp": 680059998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022911167,
    "dropsitcph": 4022911167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19505",
    "droptype": "D",
    "dropname": "BELLWOOD",
    "dropdeladd": "502 ESPLANADE ST",
    "dropdelcty": "BELLWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 686243035,
    "dropphyadd": "502 ESPLANADE ST",
    "dropphycty": "BELLWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 686243035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 686249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025385575,
    "dropsitcph": 4025385575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19509",
    "droptype": "D",
    "dropname": "BENEDICT",
    "dropdeladd": "214 SHERMAN ST",
    "dropdelcty": "BENEDICT",
    "dropdelst": "NE",
    "dropdelzpp": 683169700,
    "dropphyadd": "214 SHERMAN ST",
    "dropphycty": "BENEDICT",
    "dropphyst": "NE",
    "dropphyzpp": 683169700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENEDICT",
    "dropmalst": "NE",
    "dropmalzpp": 683169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027326897,
    "dropsitcph": 4027326897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19510",
    "droptype": "D",
    "dropname": "BENKELMAN",
    "dropdeladd": "505 CHIEF ST",
    "dropdelcty": "BENKELMAN",
    "dropdelst": "NE",
    "dropdelzpp": 690213065,
    "dropphyadd": "505 CHIEF ST",
    "dropphycty": "BENKELMAN",
    "dropphyst": "NE",
    "dropphyzpp": 690213065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENKELMAN",
    "dropmalst": "NE",
    "dropmalzpp": 690219998,
    "dropsitphn": 3084232660,
    "dropsitlph": 3084232660,
    "dropsitcph": 3084232660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19511",
    "droptype": "D",
    "dropname": "BENNET",
    "dropdeladd": "605 MADISON ST",
    "dropdelcty": "BENNET",
    "dropdelst": "NE",
    "dropdelzpp": 683172378,
    "dropphyadd": "605 MADISON ST",
    "dropphycty": "BENNET",
    "dropphyst": "NE",
    "dropphyzpp": 683172378,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENNET",
    "dropmalst": "NE",
    "dropmalzpp": 683179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027826745,
    "dropsitcph": 4027826745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19512",
    "droptype": "D",
    "dropname": "BENNINGTON",
    "dropdeladd": "124 S STARK ST",
    "dropdelcty": "BENNINGTON",
    "dropdelst": "NE",
    "dropdelzpp": 680075158,
    "dropphyadd": "124 S STARK ST",
    "dropphycty": "BENNINGTON",
    "dropphyst": "NE",
    "dropphyzpp": 680075158,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENNINGTON",
    "dropmalst": "NE",
    "dropmalzpp": 680079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022383275,
    "dropsitcph": 4022383275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19516",
    "droptype": "D",
    "dropname": "BERTRAND",
    "dropdeladd": "701 MINOR AVE",
    "dropdelcty": "BERTRAND",
    "dropdelst": "NE",
    "dropdelzpp": 689271242,
    "dropphyadd": "701 MINOR AVE",
    "dropphycty": "BERTRAND",
    "dropphyst": "NE",
    "dropphyzpp": 689271242,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERTRAND",
    "dropmalst": "NE",
    "dropmalzpp": 689279998,
    "dropsitphn": 3084723319,
    "dropsitlph": 3084723319,
    "dropsitcph": 3084723319,
    "dropfax": 3084723319
  },
  {
    "dcode": "D",
    "dropkey": "PW19521",
    "droptype": "D",
    "dropname": "BIG SPRINGS",
    "dropdeladd": "307 PINE ST",
    "dropdelcty": "BIG SPRINGS",
    "dropdelst": "NE",
    "dropdelzpp": 691229900,
    "dropphyadd": "307 PINE ST",
    "dropphycty": "BIG SPRINGS",
    "dropphyst": "NE",
    "dropphyzpp": 691229900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG SPRINGS",
    "dropmalst": "NE",
    "dropmalzpp": 691229998,
    "dropsitphn": 3088893100,
    "dropsitlph": 3088893100,
    "dropsitcph": 3088893100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19525",
    "droptype": "D",
    "dropname": "BLADEN",
    "dropdeladd": "300 N MAIN ST",
    "dropdelcty": "BLADEN",
    "dropdelst": "NE",
    "dropdelzpp": 689287363,
    "dropphyadd": "300 N MAIN ST",
    "dropphycty": "BLADEN",
    "dropphyst": "NE",
    "dropphyzpp": 689287363,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLADEN",
    "dropmalst": "NE",
    "dropmalzpp": 689289998,
    "dropsitphn": 4027561291,
    "dropsitlph": 4027561291,
    "dropsitcph": 4027561291,
    "dropfax": 4027561291
  },
  {
    "dcode": "D",
    "dropkey": "PW19528",
    "droptype": "D",
    "dropname": "BLAIR",
    "dropdeladd": "201 N 16TH ST",
    "dropdelcty": "BLAIR",
    "dropdelst": "NE",
    "dropdelzpp": 680089998,
    "dropphyadd": "201 N 16TH ST",
    "dropphycty": "BLAIR",
    "dropphyst": "NE",
    "dropphyzpp": 680089998,
    "dropmaladd": "201 N 16TH ST",
    "dropmalcty": "BLAIR",
    "dropmalst": "NE",
    "dropmalzpp": 680089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024263100,
    "dropsitcph": 4024263100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19529",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 687183152,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 687183152,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 687189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023734726,
    "dropsitcph": 4023734726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19530",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "607 CENTRAL AVE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "NE",
    "dropdelzpp": 689295159,
    "dropphyadd": "607 CENTRAL AVE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "NE",
    "dropphyzpp": 689295159,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "NE",
    "dropmalzpp": 689299998,
    "dropsitphn": 3087752565,
    "dropsitlph": 3087752565,
    "dropsitcph": 3087752565,
    "dropfax": 3087752565
  },
  {
    "dcode": "D",
    "dropkey": "PW19532",
    "droptype": "D",
    "dropname": "BLUE HILL",
    "dropdeladd": "437 W GAGE ST",
    "dropdelcty": "BLUE HILL",
    "dropdelst": "NE",
    "dropdelzpp": 689308014,
    "dropphyadd": "437 W GAGE ST",
    "dropphycty": "BLUE HILL",
    "dropphyst": "NE",
    "dropphyzpp": 689308014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE HILL",
    "dropmalst": "NE",
    "dropmalzpp": 689309998,
    "dropsitphn": 4027562511,
    "dropsitlph": 4027562511,
    "dropsitcph": 4027562511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19535",
    "droptype": "D",
    "dropname": "BLUE SPRINGS",
    "dropdeladd": "204 E BROAD ST",
    "dropdelcty": "BLUE SPRINGS",
    "dropdelst": "NE",
    "dropdelzpp": 683183533,
    "dropphyadd": "204 E BROAD ST",
    "dropphycty": "BLUE SPRINGS",
    "dropphyst": "NE",
    "dropphyzpp": 683183533,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE SPRINGS",
    "dropmalst": "NE",
    "dropmalzpp": 683189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026453600,
    "dropsitcph": 4026453600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19536",
    "droptype": "D",
    "dropname": "BOELUS",
    "dropdeladd": "520 DELAWARE ST",
    "dropdelcty": "BOELUS",
    "dropdelst": "NE",
    "dropdelzpp": 688202030,
    "dropphyadd": "520 DELAWARE ST",
    "dropphycty": "BOELUS",
    "dropphyst": "NE",
    "dropphyzpp": 688202030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOELUS",
    "dropmalst": "NE",
    "dropmalzpp": 688209998,
    "dropsitphn": 3089964474,
    "dropsitlph": 3089964474,
    "dropsitcph": 3089964474,
    "dropfax": 3089964474
  },
  {
    "dcode": "D",
    "dropkey": "PW19539",
    "droptype": "D",
    "dropname": "BOYS TOWN",
    "dropdeladd": "139 S 144TH ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681545300,
    "dropphyadd": "139 S 144TH ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681545300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYS TOWN",
    "dropmalst": "NE",
    "dropmalzpp": 680109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024454637,
    "dropsitcph": 4024452884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19541",
    "droptype": "D",
    "dropname": "BRADSHAW",
    "dropdeladd": "565 LINCOLN ST",
    "dropdelcty": "BRADSHAW",
    "dropdelst": "NE",
    "dropdelzpp": 683193039,
    "dropphyadd": "565 LINCOLN ST",
    "dropphycty": "BRADSHAW",
    "dropphyst": "NE",
    "dropphyzpp": 683193039,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADSHAW",
    "dropmalst": "NE",
    "dropmalzpp": 683199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027364377,
    "dropsitcph": 4027364377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19542",
    "droptype": "D",
    "dropname": "BRADY",
    "dropdeladd": "103 E COMMERCIAL ST",
    "dropdelcty": "BRADY",
    "dropdelst": "NE",
    "dropdelzpp": 691232730,
    "dropphyadd": "103 E COMMERCIAL ST",
    "dropphycty": "BRADY",
    "dropphyst": "NE",
    "dropphyzpp": 691232730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADY",
    "dropmalst": "NE",
    "dropmalzpp": 691239998,
    "dropsitphn": 3085323144,
    "dropsitlph": 4023482736,
    "dropsitcph": 3085843518,
    "dropfax": 3085843518
  },
  {
    "dcode": "D",
    "dropkey": "PW19543",
    "droptype": "D",
    "dropname": "BRAINARD",
    "dropdeladd": "100 N MADISON ST",
    "dropdelcty": "BRAINARD",
    "dropdelst": "NE",
    "dropdelzpp": 686263511,
    "dropphyadd": "100 N MADISON ST",
    "dropphycty": "BRAINARD",
    "dropphyst": "NE",
    "dropphyzpp": 686263511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRAINARD",
    "dropmalst": "NE",
    "dropmalzpp": 686269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027354003,
    "dropsitcph": 4027354003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19547",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "114 W 10TH ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "NE",
    "dropdelzpp": 693362559,
    "dropphyadd": "114 W 10TH ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "NE",
    "dropphyzpp": 693362559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "NE",
    "dropmalzpp": 693369998,
    "dropsitphn": 3082620468,
    "dropsitlph": 3082620468,
    "dropsitcph": 3082620468,
    "dropfax": 3082620468
  },
  {
    "dcode": "D",
    "dropkey": "PW19549",
    "droptype": "D",
    "dropname": "BRISTOW",
    "dropdeladd": "211 PRAIRIE ST",
    "dropdelcty": "BRISTOW",
    "dropdelst": "NE",
    "dropdelzpp": 687193517,
    "dropphyadd": "211 PRAIRIE ST",
    "dropphycty": "BRISTOW",
    "dropphyst": "NE",
    "dropphyzpp": 687193517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRISTOW",
    "dropmalst": "NE",
    "dropmalzpp": 687199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025830099,
    "dropsitcph": 4025830099,
    "dropfax": 4025830099
  },
  {
    "dcode": "D",
    "dropkey": "PW19550",
    "droptype": "D",
    "dropname": "BROADWATER",
    "dropdeladd": "197 MAIN ST",
    "dropdelcty": "BROADWATER",
    "dropdelst": "NE",
    "dropdelzpp": 691259735,
    "dropphyadd": "197 MAIN ST",
    "dropphycty": "BROADWATER",
    "dropphyst": "NE",
    "dropphyzpp": 691259735,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROADWATER",
    "dropmalst": "NE",
    "dropmalzpp": 691259998,
    "dropsitphn": 3084895615,
    "dropsitlph": 3084895615,
    "dropsitcph": 3084895615,
    "dropfax": 3084895615
  },
  {
    "dcode": "D",
    "dropkey": "PW19552",
    "droptype": "D",
    "dropname": "BROKEN BOW",
    "dropdeladd": "741 S D ST",
    "dropdelcty": "BROKEN BOW",
    "dropdelst": "NE",
    "dropdelzpp": 688229998,
    "dropphyadd": "741 S D ST",
    "dropphycty": "BROKEN BOW",
    "dropphyst": "NE",
    "dropphyzpp": 688229998,
    "dropmaladd": "741 S D ST",
    "dropmalcty": "BROKEN BOW",
    "dropmalst": "NE",
    "dropmalzpp": 688229998,
    "dropsitphn": 3088722211,
    "dropsitlph": 3088722211,
    "dropsitcph": 3088722211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19555",
    "droptype": "D",
    "dropname": "BROWNVILLE",
    "dropdeladd": "217 MAIN ST",
    "dropdelcty": "BROWNVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 683216059,
    "dropphyadd": "217 MAIN ST",
    "dropphycty": "BROWNVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 683216059,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 683219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028253281,
    "dropsitcph": 4028253281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19556",
    "droptype": "D",
    "dropname": "BRULE",
    "dropdeladd": "118 STATE ST",
    "dropdelcty": "BRULE",
    "dropdelst": "NE",
    "dropdelzpp": 691273466,
    "dropphyadd": "118 STATE ST",
    "dropphycty": "BRULE",
    "dropphyst": "NE",
    "dropphyzpp": 691273466,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRULE",
    "dropmalst": "NE",
    "dropmalzpp": 691279998,
    "dropsitphn": 3082872443,
    "dropsitlph": 3082872443,
    "dropsitcph": 3082872443,
    "dropfax": 3082872443
  },
  {
    "dcode": "D",
    "dropkey": "PW19557",
    "droptype": "D",
    "dropname": "BRUNING",
    "dropdeladd": "144 E MAIN ST",
    "dropdelcty": "BRUNING",
    "dropdelst": "NE",
    "dropdelzpp": 683224037,
    "dropphyadd": "144 E MAIN ST",
    "dropphycty": "BRUNING",
    "dropphyst": "NE",
    "dropphyzpp": 683224037,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUNING",
    "dropmalst": "NE",
    "dropmalzpp": 683229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023532105,
    "dropsitcph": 4023532105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19558",
    "droptype": "D",
    "dropname": "BRUNO",
    "dropdeladd": "205 2ND ST",
    "dropdelcty": "BRUNO",
    "dropdelst": "NE",
    "dropdelzpp": 680149700,
    "dropphyadd": "205 2ND ST",
    "dropphycty": "BRUNO",
    "dropphyst": "NE",
    "dropphyzpp": 680149700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUNO",
    "dropmalst": "NE",
    "dropmalzpp": 680149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025432224,
    "dropsitcph": 4025432224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19559",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "222 2ND ST",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "NE",
    "dropdelzpp": 687203072,
    "dropphyadd": "222 2ND ST",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "NE",
    "dropphyzpp": 687203072,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "NE",
    "dropmalzpp": 687209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028423085,
    "dropsitcph": 4028423085,
    "dropfax": 4028423085
  },
  {
    "dcode": "D",
    "dropkey": "PW19563",
    "droptype": "D",
    "dropname": "BURCHARD",
    "dropdeladd": "206 2ND ST",
    "dropdelcty": "BURCHARD",
    "dropdelst": "NE",
    "dropdelzpp": 683239722,
    "dropphyadd": "206 2ND ST",
    "dropphycty": "BURCHARD",
    "dropphyst": "NE",
    "dropphyzpp": 683239722,
    "dropmaladd": "206 2ND ST",
    "dropmalcty": "BURCHARD",
    "dropmalst": "NE",
    "dropmalzpp": 683239722,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028654315,
    "dropsitcph": 4028654315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19568",
    "droptype": "D",
    "dropname": "BURWELL",
    "dropdeladd": "188 S 8TH AVE",
    "dropdelcty": "BURWELL",
    "dropdelst": "NE",
    "dropdelzpp": 688236003,
    "dropphyadd": "188 S 8TH AVE",
    "dropphycty": "BURWELL",
    "dropphyst": "NE",
    "dropphyzpp": 688236003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURWELL",
    "dropmalst": "NE",
    "dropmalzpp": 688239998,
    "dropsitphn": 3084004005,
    "dropsitlph": 8778541136,
    "dropsitcph": 8778541136,
    "dropfax": 3083465090
  },
  {
    "dcode": "D",
    "dropkey": "PW19569",
    "droptype": "D",
    "dropname": "BUSHNELL",
    "dropdeladd": "116 ELM ST",
    "dropdelcty": "BUSHNELL",
    "dropdelst": "NE",
    "dropdelzpp": 691289716,
    "dropphyadd": "116 ELM ST",
    "dropphycty": "BUSHNELL",
    "dropphyst": "NE",
    "dropphyzpp": 691289716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUSHNELL",
    "dropmalst": "NE",
    "dropmalzpp": 691289998,
    "dropsitphn": 3086735226,
    "dropsitlph": 3086735226,
    "dropsitcph": 3086735226,
    "dropfax": 3086735226
  },
  {
    "dcode": "D",
    "dropkey": "PW19571",
    "droptype": "D",
    "dropname": "BUTTE",
    "dropdeladd": "518 THAYER ST",
    "dropdelcty": "BUTTE",
    "dropdelst": "NE",
    "dropdelzpp": 687223525,
    "dropphyadd": "518 THAYER ST",
    "dropphycty": "BUTTE",
    "dropphyst": "NE",
    "dropphyzpp": 687223525,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUTTE",
    "dropmalst": "NE",
    "dropmalzpp": 687229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027752429,
    "dropsitcph": 4027752429,
    "dropfax": 4027752429
  },
  {
    "dcode": "D",
    "dropkey": "PW19572",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "118 KANSAS AVE",
    "dropdelcty": "BYRON",
    "dropdelst": "NE",
    "dropdelzpp": 683259714,
    "dropphyadd": "118 KANSAS AVE",
    "dropphycty": "BYRON",
    "dropphyst": "NE",
    "dropphyzpp": 683259714,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYRON",
    "dropmalst": "NE",
    "dropmalzpp": 683259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022368851,
    "dropsitcph": 4022368851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19576",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "108 E MEDINA ST",
    "dropdelcty": "CAIRO",
    "dropdelst": "NE",
    "dropdelzpp": 688249616,
    "dropphyadd": "108 E MEDINA ST",
    "dropphycty": "CAIRO",
    "dropphyst": "NE",
    "dropphyzpp": 688249616,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAIRO",
    "dropmalst": "NE",
    "dropmalzpp": 688249998,
    "dropsitphn": 3084854332,
    "dropsitlph": 3084854332,
    "dropsitcph": 3084854332,
    "dropfax": 3084854332
  },
  {
    "dcode": "D",
    "dropkey": "PW19577",
    "droptype": "D",
    "dropname": "CALLAWAY",
    "dropdeladd": "104 N GRAND AVE",
    "dropdelcty": "CALLAWAY",
    "dropdelst": "NE",
    "dropdelzpp": 688259806,
    "dropphyadd": "104 N GRAND AVE",
    "dropphycty": "CALLAWAY",
    "dropphyst": "NE",
    "dropphyzpp": 688259806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALLAWAY",
    "dropmalst": "NE",
    "dropmalzpp": 688259998,
    "dropsitphn": 3088362600,
    "dropsitlph": 3088362600,
    "dropsitcph": 3088362600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19578",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "710 PATTERSON ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "NE",
    "dropdelzpp": 690226621,
    "dropphyadd": "710 PATTERSON ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "NE",
    "dropphyzpp": 690226621,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "NE",
    "dropmalzpp": 690229998,
    "dropsitphn": 3086974234,
    "dropsitlph": 3086974234,
    "dropsitcph": 3086974234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19580",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "710 BROAD ST",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "NE",
    "dropdelzpp": 689322611,
    "dropphyadd": "710 BROAD ST",
    "dropphycty": "CAMPBELL",
    "dropphyst": "NE",
    "dropphyzpp": 689322611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "NE",
    "dropmalzpp": 689329998,
    "dropsitphn": 4027568446,
    "dropsitlph": 4027568446,
    "dropsitcph": 4027568446,
    "dropfax": 4027568446
  },
  {
    "dcode": "D",
    "dropkey": "PW19582",
    "droptype": "D",
    "dropname": "CARLETON",
    "dropdeladd": "320 D ST",
    "dropdelcty": "CARLETON",
    "dropdelst": "NE",
    "dropdelzpp": 683269743,
    "dropphyadd": "320 D ST",
    "dropphycty": "CARLETON",
    "dropphyst": "NE",
    "dropphyzpp": 683269743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLETON",
    "dropmalst": "NE",
    "dropmalzpp": 683269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023562341,
    "dropsitcph": 4023562341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19583",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "520 MAIN ST",
    "dropdelcty": "CARROLL",
    "dropdelst": "NE",
    "dropdelzpp": 687239800,
    "dropphyadd": "520 MAIN ST",
    "dropphycty": "CARROLL",
    "dropphyst": "NE",
    "dropphyzpp": 687239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARROLL",
    "dropmalst": "NE",
    "dropmalzpp": 687239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027490999,
    "dropsitcph": 4027490999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19585",
    "droptype": "D",
    "dropname": "CEDAR BLUFFS",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "CEDAR BLUFFS",
    "dropdelst": "NE",
    "dropdelzpp": 680153110,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "CEDAR BLUFFS",
    "dropphyst": "NE",
    "dropphyzpp": 680153110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR BLUFFS",
    "dropmalst": "NE",
    "dropmalzpp": 680159998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026283545,
    "dropsitcph": 4026283545,
    "dropfax": 4026283545
  },
  {
    "dcode": "D",
    "dropkey": "PW19586",
    "droptype": "D",
    "dropname": "CEDAR CREEK",
    "dropdeladd": "104 PARSON DR",
    "dropdelcty": "CEDAR CREEK",
    "dropdelst": "NE",
    "dropdelzpp": 680169700,
    "dropphyadd": "104 PARSON DR",
    "dropphycty": "CEDAR CREEK",
    "dropphyst": "NE",
    "dropphyzpp": 680169700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR CREEK",
    "dropmalst": "NE",
    "dropmalzpp": 680169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022345262,
    "dropsitcph": 4022345262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19587",
    "droptype": "D",
    "dropname": "CEDAR RAPIDS",
    "dropdeladd": "214 W MAIN ST",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "NE",
    "dropdelzpp": 686275600,
    "dropphyadd": "214 W MAIN ST",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "NE",
    "dropphyzpp": 686275600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "NE",
    "dropmalzpp": 686279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3083580166,
    "dropsitcph": 3083580166,
    "dropfax": 3083580166
  },
  {
    "dcode": "D",
    "dropkey": "PW19589",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "CENTER",
    "dropdelst": "NE",
    "dropdelzpp": 687249705,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "CENTER",
    "dropphyst": "NE",
    "dropphyzpp": 687249705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER",
    "dropmalst": "NE",
    "dropmalzpp": 687249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022052579,
    "dropsitcph": 4022052579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19592",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "1512 16TH ST",
    "dropdelcty": "CENTRAL CITY",
    "dropdelst": "NE",
    "dropdelzpp": 688269998,
    "dropphyadd": "1512 16TH ST",
    "dropphycty": "CENTRAL CITY",
    "dropphyst": "NE",
    "dropphyzpp": 688269998,
    "dropmaladd": "1512 16TH ST",
    "dropmalcty": "CENTRAL CITY",
    "dropmalst": "NE",
    "dropmalzpp": 688269998,
    "dropsitphn": 3089463272,
    "dropsitlph": 3089463272,
    "dropsitcph": 3089463272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19596",
    "droptype": "D",
    "dropname": "CERESCO",
    "dropdeladd": "313 2ND ST",
    "dropdelcty": "CERESCO",
    "dropdelst": "NE",
    "dropdelzpp": 680179700,
    "dropphyadd": "313 2ND ST",
    "dropphycty": "CERESCO",
    "dropphyst": "NE",
    "dropphyzpp": 680179700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CERESCO",
    "dropmalst": "NE",
    "dropmalzpp": 680179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026653001,
    "dropsitcph": 4026653001,
    "dropfax": 4026652304
  },
  {
    "dcode": "D",
    "dropkey": "PW19597",
    "droptype": "D",
    "dropname": "CHADRON",
    "dropdeladd": "278 MAIN ST",
    "dropdelcty": "CHADRON",
    "dropdelst": "NE",
    "dropdelzpp": 693379998,
    "dropphyadd": "278 MAIN ST",
    "dropphycty": "CHADRON",
    "dropphyst": "NE",
    "dropphyzpp": 693379998,
    "dropmaladd": "278 MAIN ST",
    "dropmalcty": "CHADRON",
    "dropmalst": "NE",
    "dropmalzpp": 693379998,
    "dropsitphn": 3084322817,
    "dropsitlph": 3084322817,
    "dropsitcph": 3084322817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19598",
    "droptype": "D",
    "dropname": "CHAMBERS",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "CHAMBERS",
    "dropdelst": "NE",
    "dropdelzpp": 687259725,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "CHAMBERS",
    "dropphyst": "NE",
    "dropphyzpp": 687259725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMBERS",
    "dropmalst": "NE",
    "dropmalzpp": 687259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024825730,
    "dropsitcph": 4024825730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19599",
    "droptype": "D",
    "dropname": "CHAMPION",
    "dropdeladd": "380 MAIN ST",
    "dropdelcty": "CHAMPION",
    "dropdelst": "NE",
    "dropdelzpp": 690239747,
    "dropphyadd": "380 MAIN ST",
    "dropphycty": "CHAMPION",
    "dropphyst": "NE",
    "dropphyzpp": 690239747,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMPION",
    "dropmalst": "NE",
    "dropmalzpp": 690239998,
    "dropsitphn": 3088825786,
    "dropsitlph": 3088825786,
    "dropsitcph": 3088825786,
    "dropfax": 3088825786
  },
  {
    "dcode": "D",
    "dropkey": "PW19600",
    "droptype": "D",
    "dropname": "CHAPMAN",
    "dropdeladd": "204 9TH ST",
    "dropdelcty": "CHAPMAN",
    "dropdelst": "NE",
    "dropdelzpp": 688272756,
    "dropphyadd": "204 9TH ST",
    "dropphycty": "CHAPMAN",
    "dropphyst": "NE",
    "dropphyzpp": 688272756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAPMAN",
    "dropmalst": "NE",
    "dropmalzpp": 688279998,
    "dropsitphn": 3089862499,
    "dropsitlph": 3089862499,
    "dropsitcph": 3089862499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19601",
    "droptype": "D",
    "dropname": "CHAPPELL",
    "dropdeladd": "190 VINCENT AVE",
    "dropdelcty": "CHAPPELL",
    "dropdelst": "NE",
    "dropdelzpp": 691299700,
    "dropphyadd": "190 VINCENT AVE",
    "dropphycty": "CHAPPELL",
    "dropphyst": "NE",
    "dropphyzpp": 691299700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAPPELL",
    "dropmalst": "NE",
    "dropmalzpp": 691299998,
    "dropsitphn": 3088743321,
    "dropsitlph": 3088743321,
    "dropsitcph": 3088743321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19604",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "511 THAYER AVE",
    "dropdelcty": "CHESTER",
    "dropdelst": "NE",
    "dropdelzpp": 683277049,
    "dropphyadd": "511 THAYER AVE",
    "dropphycty": "CHESTER",
    "dropphyst": "NE",
    "dropphyzpp": 683277049,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTER",
    "dropmalst": "NE",
    "dropmalzpp": 683279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023248755,
    "dropsitcph": 4023248755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19605",
    "droptype": "D",
    "dropname": "CLARKS",
    "dropdeladd": "303 N GREEN ST",
    "dropdelcty": "CLARKS",
    "dropdelst": "NE",
    "dropdelzpp": 686282758,
    "dropphyadd": "303 N GREEN ST",
    "dropphycty": "CLARKS",
    "dropphyst": "NE",
    "dropphyzpp": 686282758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKS",
    "dropmalst": "NE",
    "dropmalzpp": 686289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3085482851,
    "dropsitcph": 3085482851,
    "dropfax": 3085482851
  },
  {
    "dcode": "D",
    "dropkey": "PW19606",
    "droptype": "D",
    "dropname": "CLARKSON",
    "dropdeladd": "321 PINE ST",
    "dropdelcty": "CLARKSON",
    "dropdelst": "NE",
    "dropdelzpp": 686294094,
    "dropphyadd": "321 PINE ST",
    "dropphycty": "CLARKSON",
    "dropphyst": "NE",
    "dropphyzpp": 686294094,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSON",
    "dropmalst": "NE",
    "dropmalzpp": 686299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028923222,
    "dropsitcph": 4028923222,
    "dropfax": 4028923222
  },
  {
    "dcode": "D",
    "dropkey": "PW19607",
    "droptype": "D",
    "dropname": "CLATONIA",
    "dropdeladd": "140 WASHINGTON ST",
    "dropdelcty": "CLATONIA",
    "dropdelst": "NE",
    "dropdelzpp": 683285013,
    "dropphyadd": "140 WASHINGTON ST",
    "dropphycty": "CLATONIA",
    "dropphyst": "NE",
    "dropphyzpp": 683285013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLATONIA",
    "dropmalst": "NE",
    "dropmalzpp": 683289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029895835,
    "dropsitcph": 4029895835,
    "dropfax": 4029895835
  },
  {
    "dcode": "D",
    "dropkey": "PW19609",
    "droptype": "D",
    "dropname": "CLAY CENTER",
    "dropdeladd": "120 S ALEXANDER AVE",
    "dropdelcty": "CLAY CENTER",
    "dropdelst": "NE",
    "dropdelzpp": 689339998,
    "dropphyadd": "120 S ALEXANDER AVE",
    "dropphycty": "CLAY CENTER",
    "dropphyst": "NE",
    "dropphyzpp": 689339998,
    "dropmaladd": "120 S ALEXANDER AVE",
    "dropmalcty": "CLAY CENTER",
    "dropmalst": "NE",
    "dropmalzpp": 689339998,
    "dropsitphn": 4027623869,
    "dropsitlph": 4027032072,
    "dropsitcph": 4027032072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19611",
    "droptype": "D",
    "dropname": "CLEARWATER",
    "dropdeladd": "517 MAIN ST",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "NE",
    "dropdelzpp": 687265425,
    "dropphyadd": "517 MAIN ST",
    "dropphycty": "CLEARWATER",
    "dropphyst": "NE",
    "dropphyzpp": 687265425,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "NE",
    "dropmalzpp": 687269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024852465,
    "dropsitcph": 4024852465,
    "dropfax": 4024852465
  },
  {
    "dcode": "D",
    "dropkey": "PW19614",
    "droptype": "D",
    "dropname": "CODY",
    "dropdeladd": "111 E NEBRASKA AVE",
    "dropdelcty": "CODY",
    "dropdelst": "NE",
    "dropdelzpp": 692119900,
    "dropphyadd": "111 E NEBRASKA AVE",
    "dropphycty": "CODY",
    "dropphyst": "NE",
    "dropphyzpp": 692119900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CODY",
    "dropmalst": "NE",
    "dropmalzpp": 692119998,
    "dropsitphn": 4028234330,
    "dropsitlph": 4028234330,
    "dropsitcph": 4028234330,
    "dropfax": 4028234333
  },
  {
    "dcode": "D",
    "dropkey": "PW19615",
    "droptype": "D",
    "dropname": "COLERIDGE",
    "dropdeladd": "114 E BROADWAY ST",
    "dropdelcty": "COLERIDGE",
    "dropdelst": "NE",
    "dropdelzpp": 687272335,
    "dropphyadd": "114 E BROADWAY ST",
    "dropphycty": "COLERIDGE",
    "dropphyst": "NE",
    "dropphyzpp": 687272335,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLERIDGE",
    "dropmalst": "NE",
    "dropmalzpp": 687279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022834505,
    "dropsitcph": 4022834505,
    "dropfax": 4022834505
  },
  {
    "dcode": "D",
    "dropkey": "PW19618",
    "droptype": "D",
    "dropname": "COLON",
    "dropdeladd": "108 N SPRUCE ST",
    "dropdelcty": "COLON",
    "dropdelst": "NE",
    "dropdelzpp": 680189700,
    "dropphyadd": "108 N SPRUCE ST",
    "dropphycty": "COLON",
    "dropphyst": "NE",
    "dropphyzpp": 680189700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLON",
    "dropmalst": "NE",
    "dropmalzpp": 680189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026472125,
    "dropsitcph": 4026472125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19620",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "1555 24TH AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "NE",
    "dropdelzpp": 686019998,
    "dropphyadd": "1555 24TH AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "NE",
    "dropphyzpp": 686019998,
    "dropmaladd": "1555 24TH AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "NE",
    "dropmalzpp": 686019998,
    "dropsitphn": 4025643208,
    "dropsitlph": 4025643208,
    "dropsitcph": 4025643208,
    "dropfax": 4025626610
  },
  {
    "dcode": "D",
    "dropkey": "PW19621",
    "droptype": "D",
    "dropname": "COMSTOCK",
    "dropdeladd": "101 E MAIN",
    "dropdelcty": "COMSTOCK",
    "dropdelst": "NE",
    "dropdelzpp": 688289754,
    "dropphyadd": "101 E MAIN",
    "dropphycty": "COMSTOCK",
    "dropphyst": "NE",
    "dropphyzpp": 688289754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMSTOCK",
    "dropmalst": "NE",
    "dropmalzpp": 688289998,
    "dropsitphn": 3086284234,
    "dropsitlph": "",
    "dropsitcph": 3086284234,
    "dropfax": 3086284234
  },
  {
    "dcode": "D",
    "dropkey": "PW19622",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "207 LINCOLN ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "NE",
    "dropdelzpp": 687282845,
    "dropphyadd": "207 LINCOLN ST",
    "dropphycty": "CONCORD",
    "dropphyst": "NE",
    "dropphyzpp": 687282845,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONCORD",
    "dropmalst": "NE",
    "dropmalzpp": 687289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025842259,
    "dropsitcph": 4025842259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19624",
    "droptype": "D",
    "dropname": "COOK",
    "dropdeladd": "214 W MAIN ST",
    "dropdelcty": "COOK",
    "dropdelst": "NE",
    "dropdelzpp": 683299743,
    "dropphyadd": "214 W MAIN ST",
    "dropphycty": "COOK",
    "dropphyst": "NE",
    "dropphyzpp": 683299743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOK",
    "dropmalst": "NE",
    "dropmalzpp": 683299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028645701,
    "dropsitcph": 4028645701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19625",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "360 HECTOR ST",
    "dropdelcty": "CORDOVA",
    "dropdelst": "NE",
    "dropdelzpp": 683303000,
    "dropphyadd": "360 HECTOR ST",
    "dropphycty": "CORDOVA",
    "dropphyst": "NE",
    "dropphyzpp": 683303000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORDOVA",
    "dropmalst": "NE",
    "dropmalzpp": 683309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025763110,
    "dropsitcph": 4025763110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19627",
    "droptype": "D",
    "dropname": "CORTLAND",
    "dropdeladd": "335 W 4TH ST",
    "dropdelcty": "CORTLAND",
    "dropdelst": "NE",
    "dropdelzpp": 683313000,
    "dropphyadd": "335 W 4TH ST",
    "dropphycty": "CORTLAND",
    "dropphyst": "NE",
    "dropphyzpp": 683313000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORTLAND",
    "dropmalst": "NE",
    "dropmalzpp": 683319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027987676,
    "dropsitcph": 4027987676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19633",
    "droptype": "D",
    "dropname": "COZAD",
    "dropdeladd": "102 E 9TH ST",
    "dropdelcty": "COZAD",
    "dropdelst": "NE",
    "dropdelzpp": 691309998,
    "dropphyadd": "102 E 9TH ST",
    "dropphycty": "COZAD",
    "dropphyst": "NE",
    "dropphyzpp": 691309998,
    "dropmaladd": "102 E 9TH ST",
    "dropmalcty": "COZAD",
    "dropmalst": "NE",
    "dropmalzpp": 691309998,
    "dropsitphn": 3087843400,
    "dropsitlph": 3087843400,
    "dropsitcph": 3087843400,
    "dropfax": 3087843452
  },
  {
    "dcode": "D",
    "dropkey": "PW19635",
    "droptype": "D",
    "dropname": "CRAB ORCHARD",
    "dropdeladd": "60829 725 RD",
    "dropdelcty": "CRAB ORCHARD",
    "dropdelst": "NE",
    "dropdelzpp": 683325109,
    "dropphyadd": "60829 725 RD",
    "dropphycty": "CRAB ORCHARD",
    "dropphyst": "NE",
    "dropphyzpp": 683325109,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRAB ORCHARD",
    "dropmalst": "NE",
    "dropmalzpp": 683329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028765568,
    "dropsitcph": 4028765568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19636",
    "droptype": "D",
    "dropname": "CRAIG",
    "dropdeladd": "149 N MAIN ST",
    "dropdelcty": "CRAIG",
    "dropdelst": "NE",
    "dropdelzpp": 680194542,
    "dropphyadd": "149 N MAIN ST",
    "dropphycty": "CRAIG",
    "dropphyst": "NE",
    "dropphyzpp": 680194542,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRAIG",
    "dropmalst": "NE",
    "dropmalzpp": 680199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023772655,
    "dropsitcph": 4023772655,
    "dropfax": 4023772655
  },
  {
    "dcode": "D",
    "dropkey": "PW19637",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "144 MAIN ST",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "NE",
    "dropdelzpp": 693399998,
    "dropphyadd": "144 MAIN ST",
    "dropphycty": "CRAWFORD",
    "dropphyst": "NE",
    "dropphyzpp": 693399998,
    "dropmaladd": "144 MAIN ST",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "NE",
    "dropmalzpp": 693399998,
    "dropsitphn": 3086651488,
    "dropsitlph": 3086651488,
    "dropsitcph": 3086651488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19638",
    "droptype": "D",
    "dropname": "CREIGHTON",
    "dropdeladd": "819 MAIN ST",
    "dropdelcty": "CREIGHTON",
    "dropdelst": "NE",
    "dropdelzpp": 687294003,
    "dropphyadd": "819 MAIN ST",
    "dropphycty": "CREIGHTON",
    "dropphyst": "NE",
    "dropphyzpp": 687294003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CREIGHTON",
    "dropmalst": "NE",
    "dropmalzpp": 687299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023585311,
    "dropsitcph": 4023585311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19640",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "215 PINE ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "NE",
    "dropdelzpp": 686314079,
    "dropphyadd": "215 PINE ST",
    "dropphycty": "CRESTON",
    "dropphyst": "NE",
    "dropphyzpp": 686314079,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESTON",
    "dropmalst": "NE",
    "dropmalzpp": 686319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022850227,
    "dropsitcph": 4022850227,
    "dropfax": 4022850227
  },
  {
    "dcode": "D",
    "dropkey": "PW19641",
    "droptype": "D",
    "dropname": "CRETE",
    "dropdeladd": "1242 LINDEN AVE",
    "dropdelcty": "CRETE",
    "dropdelst": "NE",
    "dropdelzpp": 683339998,
    "dropphyadd": "1242 LINDEN AVE",
    "dropphycty": "CRETE",
    "dropphyst": "NE",
    "dropphyzpp": 683339998,
    "dropmaladd": "1242 LINDEN AVE",
    "dropmalcty": "CRETE",
    "dropmalst": "NE",
    "dropmalzpp": 683339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028262247,
    "dropsitcph": 4028262247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19642",
    "droptype": "D",
    "dropname": "CROFTON",
    "dropdeladd": "1116 W 2ND ST",
    "dropdelcty": "CROFTON",
    "dropdelst": "NE",
    "dropdelzpp": 687304115,
    "dropphyadd": "1116 W 2ND ST",
    "dropphycty": "CROFTON",
    "dropphyst": "NE",
    "dropphyzpp": 687304115,
    "dropmaladd": "1116 W 2ND ST",
    "dropmalcty": "CROFTON",
    "dropmalst": "NE",
    "dropmalzpp": 687304115,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023884800,
    "dropsitcph": 4023884800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19643",
    "droptype": "D",
    "dropname": "CROOKSTON",
    "dropdeladd": "100 E 2ND ST",
    "dropdelcty": "CROOKSTON",
    "dropdelst": "NE",
    "dropdelzpp": 692129718,
    "dropphyadd": "100 E 2ND ST",
    "dropphycty": "CROOKSTON",
    "dropphyst": "NE",
    "dropphyzpp": 692129718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROOKSTON",
    "dropmalst": "NE",
    "dropmalzpp": 692129998,
    "dropsitphn": 4024253222,
    "dropsitlph": 4024253222,
    "dropsitcph": 4024253222,
    "dropfax": 4024253222
  },
  {
    "dcode": "D",
    "dropkey": "PW19645",
    "droptype": "D",
    "dropname": "CULBERTSON",
    "dropdeladd": "407 WYOMING ST",
    "dropdelcty": "CULBERTSON",
    "dropdelst": "NE",
    "dropdelzpp": 690244015,
    "dropphyadd": "407 WYOMING ST",
    "dropphycty": "CULBERTSON",
    "dropphyst": "NE",
    "dropphyzpp": 690244015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CULBERTSON",
    "dropmalst": "NE",
    "dropmalzpp": 690249998,
    "dropsitphn": 3082782254,
    "dropsitlph": 3082782254,
    "dropsitcph": 3082782254,
    "dropfax": 3082782254
  },
  {
    "dcode": "D",
    "dropkey": "PW19646",
    "droptype": "D",
    "dropname": "CURTIS",
    "dropdeladd": "302 CENTER AVE",
    "dropdelcty": "CURTIS",
    "dropdelst": "NE",
    "dropdelzpp": 690253002,
    "dropphyadd": "302 CENTER AVE",
    "dropphycty": "CURTIS",
    "dropphyst": "NE",
    "dropphyzpp": 690253002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURTIS",
    "dropmalst": "NE",
    "dropmalzpp": 690259998,
    "dropsitphn": 3083674167,
    "dropsitlph": 3083674167,
    "dropsitcph": 3083674167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19649",
    "droptype": "D",
    "dropname": "DAKOTA CITY",
    "dropdeladd": "110 N 16TH ST",
    "dropdelcty": "DAKOTA CITY",
    "dropdelst": "NE",
    "dropdelzpp": 687315078,
    "dropphyadd": "110 N 16TH ST",
    "dropphycty": "DAKOTA CITY",
    "dropphyst": "NE",
    "dropphyzpp": 687315078,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAKOTA CITY",
    "dropmalst": "NE",
    "dropmalzpp": 687319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029873322,
    "dropsitcph": 4029873322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19652",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "314 MAIN ST",
    "dropdelcty": "DALTON",
    "dropdelst": "NE",
    "dropdelzpp": 691317709,
    "dropphyadd": "314 MAIN ST",
    "dropphycty": "DALTON",
    "dropphyst": "NE",
    "dropphyzpp": 691317709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALTON",
    "dropmalst": "NE",
    "dropmalzpp": 691319998,
    "dropsitphn": 3083772514,
    "dropsitlph": 3083772514,
    "dropsitcph": 3083772514,
    "dropfax": 3083772514
  },
  {
    "dcode": "D",
    "dropkey": "PW19653",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "205 GRANDVILLE AVE",
    "dropdelcty": "DANBURY",
    "dropdelst": "NE",
    "dropdelzpp": 690269726,
    "dropphyadd": "205 GRANDVILLE AVE",
    "dropphycty": "DANBURY",
    "dropphyst": "NE",
    "dropphyzpp": 690269726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANBURY",
    "dropmalst": "NE",
    "dropmalzpp": 690269998,
    "dropsitphn": 3083456590,
    "dropsitlph": "",
    "dropsitcph": 3088952452,
    "dropfax": 3088952452
  },
  {
    "dcode": "D",
    "dropkey": "PW19654",
    "droptype": "D",
    "dropname": "DANNEBROG",
    "dropdeladd": "118 MILL ST S",
    "dropdelcty": "DANNEBROG",
    "dropdelst": "NE",
    "dropdelzpp": 688313182,
    "dropphyadd": "118 MILL ST S",
    "dropphycty": "DANNEBROG",
    "dropphyst": "NE",
    "dropphyzpp": 688313182,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANNEBROG",
    "dropmalst": "NE",
    "dropmalzpp": 688319998,
    "dropsitphn": 3082262526,
    "dropsitlph": 3082262526,
    "dropsitcph": 3082262526,
    "dropfax": 3082262526
  },
  {
    "dcode": "D",
    "dropkey": "PW19657",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "101 S MAPLE AVE",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "NE",
    "dropdelzpp": 683359787,
    "dropphyadd": "101 S MAPLE AVE",
    "dropphycty": "DAVENPORT",
    "dropphyst": "NE",
    "dropphyzpp": 683359787,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "NE",
    "dropmalzpp": 683359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023642134,
    "dropsitcph": 4023642134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19658",
    "droptype": "D",
    "dropname": "DAVEY",
    "dropdeladd": "17755 N 2ND ST",
    "dropdelcty": "DAVEY",
    "dropdelst": "NE",
    "dropdelzpp": 683369800,
    "dropphyadd": "17755 N 2ND ST",
    "dropphycty": "DAVEY",
    "dropphyst": "NE",
    "dropphyzpp": 683369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVEY",
    "dropmalst": "NE",
    "dropmalzpp": 683369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027853125,
    "dropsitcph": 4027853125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19659",
    "droptype": "D",
    "dropname": "DAVID CITY",
    "dropdeladd": "411 N 4TH ST",
    "dropdelcty": "DAVID CITY",
    "dropdelst": "NE",
    "dropdelzpp": 686329998,
    "dropphyadd": "411 N 4TH ST",
    "dropphycty": "DAVID CITY",
    "dropphyst": "NE",
    "dropphyzpp": 686329998,
    "dropmaladd": "411 N 4TH ST",
    "dropmalcty": "DAVID CITY",
    "dropmalst": "NE",
    "dropmalzpp": 686329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023673875,
    "dropsitcph": 4023673875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19663",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "516 RIDGE ST",
    "dropdelcty": "DAWSON",
    "dropdelst": "NE",
    "dropdelzpp": 683374035,
    "dropphyadd": "516 RIDGE ST",
    "dropphycty": "DAWSON",
    "dropphyst": "NE",
    "dropphyzpp": 683374035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWSON",
    "dropmalst": "NE",
    "dropmalzpp": 683379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028552555,
    "dropsitcph": 4028552555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19664",
    "droptype": "D",
    "dropname": "DAYKIN",
    "dropdeladd": "312 JEFFERSON ST",
    "dropdelcty": "DAYKIN",
    "dropdelst": "NE",
    "dropdelzpp": 683383042,
    "dropphyadd": "312 JEFFERSON ST",
    "dropphycty": "DAYKIN",
    "dropphyst": "NE",
    "dropphyzpp": 683383042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAYKIN",
    "dropmalst": "NE",
    "dropmalzpp": 683389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026837030,
    "dropsitcph": 4026837030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19665",
    "droptype": "D",
    "dropname": "DE WITT",
    "dropdeladd": "304 E FILMORE AVE",
    "dropdelcty": "DE WITT",
    "dropdelst": "NE",
    "dropdelzpp": 683419701,
    "dropphyadd": "304 E FILMORE AVE",
    "dropphycty": "DE WITT",
    "dropphyst": "NE",
    "dropphyzpp": 683419701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE WITT",
    "dropmalst": "NE",
    "dropmalzpp": 683419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026835125,
    "dropsitcph": 4026835125,
    "dropfax": 4026835125
  },
  {
    "dcode": "D",
    "dropkey": "PW19666",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "833 S BROADWAY ST",
    "dropdelcty": "DECATUR",
    "dropdelst": "NE",
    "dropdelzpp": 680202000,
    "dropphyadd": "833 S BROADWAY ST",
    "dropphycty": "DECATUR",
    "dropphyst": "NE",
    "dropphyzpp": 680202000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DECATUR",
    "dropmalst": "NE",
    "dropmalzpp": 680209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023495212,
    "dropsitcph": 4023495212,
    "dropfax": 4023495212
  },
  {
    "dcode": "D",
    "dropkey": "PW19669",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "9345 W 3RD ST",
    "dropdelcty": "DENTON",
    "dropdelst": "NE",
    "dropdelzpp": 683393175,
    "dropphyadd": "9345 W 3RD ST",
    "dropphycty": "DENTON",
    "dropphyst": "NE",
    "dropphyzpp": 683393175,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENTON",
    "dropmalst": "NE",
    "dropmalzpp": 683399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027973355,
    "dropsitcph": 4027973355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19671",
    "droptype": "D",
    "dropname": "DESHLER",
    "dropdeladd": "513 4TH ST",
    "dropdelcty": "DESHLER",
    "dropdelst": "NE",
    "dropdelzpp": 683409626,
    "dropphyadd": "513 4TH ST",
    "dropphycty": "DESHLER",
    "dropphyst": "NE",
    "dropphyzpp": 683409626,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DESHLER",
    "dropmalst": "NE",
    "dropmalzpp": 683409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023654323,
    "dropsitcph": 4023654323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19672",
    "droptype": "D",
    "dropname": "DEWEESE",
    "dropdeladd": "303 S DEWEESE AVE",
    "dropdelcty": "DEWEESE",
    "dropdelst": "NE",
    "dropdelzpp": 689343421,
    "dropphyadd": "303 S DEWEESE AVE",
    "dropphycty": "DEWEESE",
    "dropphyst": "NE",
    "dropphyzpp": 689343421,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEWEESE",
    "dropmalst": "NE",
    "dropmalzpp": 689349998,
    "dropsitphn": 4022622281,
    "dropsitlph": 4022622281,
    "dropsitcph": 4022622281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19675",
    "droptype": "D",
    "dropname": "DILLER",
    "dropdeladd": "408 COMMERCIAL ST",
    "dropdelcty": "DILLER",
    "dropdelst": "NE",
    "dropdelzpp": 683424095,
    "dropphyadd": "408 COMMERCIAL ST",
    "dropphycty": "DILLER",
    "dropphyst": "NE",
    "dropphyzpp": 683424095,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DILLER",
    "dropmalst": "NE",
    "dropmalzpp": 683429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027935555,
    "dropsitcph": 4027935555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19678",
    "droptype": "D",
    "dropname": "DIX",
    "dropdeladd": "115 MYRTLE ST",
    "dropdelcty": "DIX",
    "dropdelst": "NE",
    "dropdelzpp": 691338980,
    "dropphyadd": "115 MYRTLE ST",
    "dropphycty": "DIX",
    "dropphyst": "NE",
    "dropphyzpp": 691338980,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIX",
    "dropmalst": "NE",
    "dropmalzpp": 691339998,
    "dropsitphn": 3086825010,
    "dropsitlph": 3086825010,
    "dropsitcph": 3086825010,
    "dropfax": 3086825010
  },
  {
    "dcode": "D",
    "dropkey": "PW19679",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "302 2ND ST",
    "dropdelcty": "DIXON",
    "dropdelst": "NE",
    "dropdelzpp": 687329723,
    "dropphyadd": "302 2ND ST",
    "dropphycty": "DIXON",
    "dropphyst": "NE",
    "dropphyzpp": 687329723,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIXON",
    "dropmalst": "NE",
    "dropmalzpp": 687329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025842496,
    "dropsitcph": 4025842496,
    "dropfax": 4025842496
  },
  {
    "dcode": "D",
    "dropkey": "PW19681",
    "droptype": "D",
    "dropname": "DODGE",
    "dropdeladd": "246 2ND ST",
    "dropdelcty": "DODGE",
    "dropdelst": "NE",
    "dropdelzpp": 686333095,
    "dropphyadd": "246 2ND ST",
    "dropphycty": "DODGE",
    "dropphyst": "NE",
    "dropphyzpp": 686333095,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DODGE",
    "dropmalst": "NE",
    "dropmalzpp": 686339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026932762,
    "dropsitcph": 4026932762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19682",
    "droptype": "D",
    "dropname": "DONIPHAN",
    "dropdeladd": "108 S 1ST ST",
    "dropdelcty": "DONIPHAN",
    "dropdelst": "NE",
    "dropdelzpp": 688321708,
    "dropphyadd": "108 S 1ST ST",
    "dropphycty": "DONIPHAN",
    "dropphyst": "NE",
    "dropphyzpp": 688321708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONIPHAN",
    "dropmalst": "NE",
    "dropmalzpp": 688329998,
    "dropsitphn": 4028456631,
    "dropsitlph": 4028456631,
    "dropsitcph": 4028456631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19684",
    "droptype": "D",
    "dropname": "DORCHESTER",
    "dropdeladd": "713 WASHINGTON AVE",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "NE",
    "dropdelzpp": 683432346,
    "dropphyadd": "713 WASHINGTON AVE",
    "dropphycty": "DORCHESTER",
    "dropphyst": "NE",
    "dropphyzpp": 683432346,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "NE",
    "dropmalzpp": 683439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029462411,
    "dropsitcph": 4029462411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19685",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "NE",
    "dropdelzpp": 683443040,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "NE",
    "dropphyzpp": 683443040,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "NE",
    "dropmalzpp": 683449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027991160,
    "dropsitcph": 4027991160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19688",
    "droptype": "D",
    "dropname": "DU BOIS",
    "dropdeladd": "304 MINER ST",
    "dropdelcty": "DU BOIS",
    "dropdelst": "NE",
    "dropdelzpp": 683459800,
    "dropphyadd": "304 MINER ST",
    "dropphycty": "DU BOIS",
    "dropphyst": "NE",
    "dropphyzpp": 683459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DU BOIS",
    "dropmalst": "NE",
    "dropmalzpp": 683459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028594545,
    "dropsitcph": 4028594545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19690",
    "droptype": "D",
    "dropname": "DUNBAR",
    "dropdeladd": "104 E NEBRASKA ST",
    "dropdelcty": "DUNBAR",
    "dropdelst": "NE",
    "dropdelzpp": 683463018,
    "dropphyadd": "104 E NEBRASKA ST",
    "dropphycty": "DUNBAR",
    "dropphyst": "NE",
    "dropphyzpp": 683463018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNBAR",
    "dropmalst": "NE",
    "dropmalzpp": 683469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022592795,
    "dropsitcph": 4022592795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19691",
    "droptype": "D",
    "dropname": "DUNCAN",
    "dropdeladd": "902 8TH ST",
    "dropdelcty": "DUNCAN",
    "dropdelst": "NE",
    "dropdelzpp": 686349700,
    "dropphyadd": "902 8TH ST",
    "dropphycty": "DUNCAN",
    "dropphyst": "NE",
    "dropphyzpp": 686349700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNCAN",
    "dropmalst": "NE",
    "dropmalzpp": 686349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028974555,
    "dropsitcph": 4028974555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19693",
    "droptype": "D",
    "dropname": "DUNNING",
    "dropdeladd": "403 JEWETT AVE",
    "dropdelcty": "DUNNING",
    "dropdelst": "NE",
    "dropdelzpp": 688339802,
    "dropphyadd": "403 JEWETT AVE",
    "dropphycty": "DUNNING",
    "dropphyst": "NE",
    "dropphyzpp": 688339802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNNING",
    "dropmalst": "NE",
    "dropmalzpp": 688339998,
    "dropsitphn": 3085382214,
    "dropsitlph": 3085382214,
    "dropsitcph": 3085382214,
    "dropfax": 3085382214
  },
  {
    "dcode": "D",
    "dropkey": "PW19694",
    "droptype": "D",
    "dropname": "DWIGHT",
    "dropdeladd": "147 N 2ND ST",
    "dropdelcty": "DWIGHT",
    "dropdelst": "NE",
    "dropdelzpp": 686359756,
    "dropphyadd": "147 N 2ND ST",
    "dropphycty": "DWIGHT",
    "dropphyst": "NE",
    "dropphyzpp": 686359756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DWIGHT",
    "dropmalst": "NE",
    "dropmalzpp": 686359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025662125,
    "dropsitcph": 4025662125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19695",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "445 S 4TH ST",
    "dropdelcty": "EAGLE",
    "dropdelst": "NE",
    "dropdelzpp": 683475093,
    "dropphyadd": "445 S 4TH ST",
    "dropphycty": "EAGLE",
    "dropphyst": "NE",
    "dropphyzpp": 683475093,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE",
    "dropmalst": "NE",
    "dropmalzpp": 683479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027812881,
    "dropsitcph": 4027812881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19699",
    "droptype": "D",
    "dropname": "EDGAR",
    "dropdeladd": "312 N C ST",
    "dropdelcty": "EDGAR",
    "dropdelst": "NE",
    "dropdelzpp": 689353194,
    "dropphyadd": "312 N C ST",
    "dropphycty": "EDGAR",
    "dropphyst": "NE",
    "dropphyzpp": 689353194,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGAR",
    "dropmalst": "NE",
    "dropmalzpp": 689359998,
    "dropsitphn": 4022245250,
    "dropsitlph": 4022245250,
    "dropsitcph": 4022245250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19700",
    "droptype": "D",
    "dropname": "EDISON",
    "dropdeladd": "310 OXFORD ST",
    "dropdelcty": "EDISON",
    "dropdelst": "NE",
    "dropdelzpp": 689369734,
    "dropphyadd": "310 OXFORD ST",
    "dropphycty": "EDISON",
    "dropphyst": "NE",
    "dropphyzpp": 689369734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDISON",
    "dropmalst": "NE",
    "dropmalzpp": 689369998,
    "dropsitphn": 3089273895,
    "dropsitlph": 3089273895,
    "dropsitcph": 3089273895,
    "dropfax": 3089273895
  },
  {
    "dcode": "D",
    "dropkey": "PW19701",
    "droptype": "D",
    "dropname": "ELBA",
    "dropdeladd": "608 PEARL ST",
    "dropdelcty": "ELBA",
    "dropdelst": "NE",
    "dropdelzpp": 688353046,
    "dropphyadd": "608 PEARL ST",
    "dropphycty": "ELBA",
    "dropphyst": "NE",
    "dropphyzpp": 688353046,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBA",
    "dropmalst": "NE",
    "dropmalzpp": 688359998,
    "dropsitphn": 3088632100,
    "dropsitlph": 3088632100,
    "dropsitcph": 3088632100,
    "dropfax": 3088632100
  },
  {
    "dcode": "D",
    "dropkey": "PW19704",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "103 PINE ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "NE",
    "dropdelzpp": 686364458,
    "dropphyadd": "103 PINE ST",
    "dropphycty": "ELGIN",
    "dropphyst": "NE",
    "dropphyzpp": 686364458,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELGIN",
    "dropmalst": "NE",
    "dropmalzpp": 686369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022751391,
    "dropsitcph": 4022751391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19707",
    "droptype": "D",
    "dropname": "ELK CREEK",
    "dropdeladd": "369 MAIN ST",
    "dropdelcty": "ELK CREEK",
    "dropdelst": "NE",
    "dropdelzpp": 683489746,
    "dropphyadd": "369 MAIN ST",
    "dropphycty": "ELK CREEK",
    "dropphyst": "NE",
    "dropphyzpp": 683489746,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK CREEK",
    "dropmalst": "NE",
    "dropmalzpp": 683489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028774545,
    "dropsitcph": 4028774545,
    "dropfax": 4028774545
  },
  {
    "dcode": "D",
    "dropkey": "PW19710",
    "droptype": "D",
    "dropname": "ELKHORN",
    "dropdeladd": "20284 WIRT ST",
    "dropdelcty": "ELKHORN",
    "dropdelst": "NE",
    "dropdelzpp": 680221461,
    "dropphyadd": "20284 WIRT ST",
    "dropphycty": "ELKHORN",
    "dropphyst": "NE",
    "dropphyzpp": 680221461,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKHORN",
    "dropmalst": "NE",
    "dropmalzpp": 680229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022895501,
    "dropsitcph": 4022895453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19712",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "NE",
    "dropdelzpp": 693409721,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "NE",
    "dropphyzpp": 693409721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "NE",
    "dropmalzpp": 693409998,
    "dropsitphn": 3087626032,
    "dropsitlph": 3087626032,
    "dropsitcph": 3087626032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19714",
    "droptype": "D",
    "dropname": "ELM CREEK",
    "dropdeladd": "100 E FRONT ST",
    "dropdelcty": "ELM CREEK",
    "dropdelst": "NE",
    "dropdelzpp": 688367704,
    "dropphyadd": "100 E FRONT ST",
    "dropphycty": "ELM CREEK",
    "dropphyst": "NE",
    "dropphyzpp": 688367704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELM CREEK",
    "dropmalst": "NE",
    "dropmalzpp": 688369998,
    "dropsitphn": 3088564481,
    "dropsitlph": 3088564481,
    "dropsitcph": 3088564481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19716",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "116 W D ST",
    "dropdelcty": "ELMWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 683495000,
    "dropphyadd": "116 W D ST",
    "dropphycty": "ELMWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 683495000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 683499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029943495,
    "dropsitcph": 4029943495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19718",
    "droptype": "D",
    "dropname": "ELSIE",
    "dropdeladd": "105 PERKINS AVE",
    "dropdelcty": "ELSIE",
    "dropdelst": "NE",
    "dropdelzpp": 691342026,
    "dropphyadd": "105 PERKINS AVE",
    "dropphycty": "ELSIE",
    "dropphyst": "NE",
    "dropphyzpp": 691342026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELSIE",
    "dropmalst": "NE",
    "dropmalzpp": 691349998,
    "dropsitphn": 3082282344,
    "dropsitlph": 3082282344,
    "dropsitcph": 3082282344,
    "dropfax": 3082282344
  },
  {
    "dcode": "D",
    "dropkey": "PW19721",
    "droptype": "D",
    "dropname": "ELWOOD",
    "dropdeladd": "203 SMITH AVE",
    "dropdelcty": "ELWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 689375247,
    "dropphyadd": "203 SMITH AVE",
    "dropphycty": "ELWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 689375247,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 689379998,
    "dropsitphn": 3087852214,
    "dropsitlph": 3087852214,
    "dropsitcph": 3087852214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19724",
    "droptype": "D",
    "dropname": "EMERSON",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "EMERSON",
    "dropdelst": "NE",
    "dropdelzpp": 687333659,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "EMERSON",
    "dropphyst": "NE",
    "dropphyzpp": 687333659,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMERSON",
    "dropmalst": "NE",
    "dropmalzpp": 687339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026952462,
    "dropsitcph": 4026952462,
    "dropfax": 4026952462
  },
  {
    "dcode": "D",
    "dropkey": "PW19727",
    "droptype": "D",
    "dropname": "ENDERS",
    "dropdeladd": "580 PIONEER ST",
    "dropdelcty": "ENDERS",
    "dropdelst": "NE",
    "dropdelzpp": 690279700,
    "dropphyadd": "580 PIONEER ST",
    "dropphycty": "ENDERS",
    "dropphyst": "NE",
    "dropphyzpp": 690279700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENDERS",
    "dropmalst": "NE",
    "dropmalzpp": 690279998,
    "dropsitphn": 3088825844,
    "dropsitlph": 3088825844,
    "dropsitcph": 3088825844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19728",
    "droptype": "D",
    "dropname": "ENDICOTT",
    "dropdeladd": "206 N SCRIBNER ST",
    "dropdelcty": "ENDICOTT",
    "dropdelst": "NE",
    "dropdelzpp": 683502534,
    "dropphyadd": "206 N SCRIBNER ST",
    "dropphycty": "ENDICOTT",
    "dropphyst": "NE",
    "dropphyzpp": 683502534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENDICOTT",
    "dropmalst": "NE",
    "dropmalzpp": 683509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027296480,
    "dropsitcph": 4027296480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19730",
    "droptype": "D",
    "dropname": "ERICSON",
    "dropdeladd": "605 CENTRAL AVE",
    "dropdelcty": "ERICSON",
    "dropdelst": "NE",
    "dropdelzpp": 686378055,
    "dropphyadd": "605 CENTRAL AVE",
    "dropphycty": "ERICSON",
    "dropphyst": "NE",
    "dropphyzpp": 686378055,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ERICSON",
    "dropmalst": "NE",
    "dropmalzpp": 686379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3086532090,
    "dropsitcph": 3086532090,
    "dropfax": 3086532090
  },
  {
    "dcode": "D",
    "dropkey": "PW19732",
    "droptype": "D",
    "dropname": "EUSTIS",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "EUSTIS",
    "dropdelst": "NE",
    "dropdelzpp": 690283537,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "EUSTIS",
    "dropphyst": "NE",
    "dropphyzpp": 690283537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EUSTIS",
    "dropmalst": "NE",
    "dropmalzpp": 690289998,
    "dropsitphn": 3084862071,
    "dropsitlph": 3084862071,
    "dropsitcph": 3084862071,
    "dropfax": 3084862071
  },
  {
    "dcode": "D",
    "dropkey": "PW19733",
    "droptype": "D",
    "dropname": "EWING",
    "dropdeladd": "120 E NEBRASKA ST",
    "dropdelcty": "EWING",
    "dropdelst": "NE",
    "dropdelzpp": 687359757,
    "dropphyadd": "120 E NEBRASKA ST",
    "dropphycty": "EWING",
    "dropphyst": "NE",
    "dropphyzpp": 687359757,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EWING",
    "dropmalst": "NE",
    "dropmalzpp": 687359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026267259,
    "dropsitcph": 4026267259,
    "dropfax": 4026267259
  },
  {
    "dcode": "D",
    "dropkey": "PW19734",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "189 E SENECA ST",
    "dropdelcty": "EXETER",
    "dropdelst": "NE",
    "dropdelzpp": 683519700,
    "dropphyadd": "189 E SENECA ST",
    "dropphycty": "EXETER",
    "dropphyst": "NE",
    "dropphyzpp": 683519700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXETER",
    "dropmalst": "NE",
    "dropmalzpp": 683519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022665171,
    "dropsitcph": 4022665171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19735",
    "droptype": "D",
    "dropname": "FAIRBURY",
    "dropdeladd": "501 D ST",
    "dropdelcty": "FAIRBURY",
    "dropdelst": "NE",
    "dropdelzpp": 683529998,
    "dropphyadd": "501 D ST",
    "dropphycty": "FAIRBURY",
    "dropphyst": "NE",
    "dropphyzpp": 683529998,
    "dropmaladd": "501 D ST",
    "dropmalcty": "FAIRBURY",
    "dropmalst": "NE",
    "dropmalzpp": 683529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027292828,
    "dropsitcph": 4027292828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19736",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "410 N D ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 689389701,
    "dropphyadd": "410 N D ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 689389701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 689389998,
    "dropsitphn": 4027262201,
    "dropsitlph": 4027262201,
    "dropsitcph": 4027262201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19738",
    "droptype": "D",
    "dropname": "FAIRMONT",
    "dropdeladd": "455 6TH AVE",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "NE",
    "dropdelzpp": 683549600,
    "dropphyadd": "455 6TH AVE",
    "dropphycty": "FAIRMONT",
    "dropphyst": "NE",
    "dropphyzpp": 683549600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "NE",
    "dropmalzpp": 683549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022684981,
    "dropsitcph": 4022684981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19739",
    "droptype": "D",
    "dropname": "FALLS CITY",
    "dropdeladd": "1520 HARLAN ST",
    "dropdelcty": "FALLS CITY",
    "dropdelst": "NE",
    "dropdelzpp": 683552678,
    "dropphyadd": "1520 HARLAN ST",
    "dropphycty": "FALLS CITY",
    "dropphyst": "NE",
    "dropphyzpp": 683552678,
    "dropmaladd": "1520 HARLAN ST",
    "dropmalcty": "FALLS CITY",
    "dropmalst": "NE",
    "dropmalzpp": 683552678,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022452523,
    "dropsitcph": 4022452523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19743",
    "droptype": "D",
    "dropname": "FARNAM",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "FARNAM",
    "dropdelst": "NE",
    "dropdelzpp": 690297040,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "FARNAM",
    "dropphyst": "NE",
    "dropphyzpp": 690297040,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARNAM",
    "dropmalst": "NE",
    "dropmalzpp": 690299998,
    "dropsitphn": 3085692588,
    "dropsitlph": 3085692588,
    "dropsitcph": 3085692588,
    "dropfax": 3085692376
  },
  {
    "dcode": "D",
    "dropkey": "PW19744",
    "droptype": "D",
    "dropname": "FARWELL",
    "dropdeladd": "302 LANDER AVE",
    "dropdelcty": "FARWELL",
    "dropdelst": "NE",
    "dropdelzpp": 688381640,
    "dropphyadd": "302 LANDER AVE",
    "dropphycty": "FARWELL",
    "dropphyst": "NE",
    "dropphyzpp": 688381640,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARWELL",
    "dropmalst": "NE",
    "dropmalzpp": 688389998,
    "dropsitphn": 3083363373,
    "dropsitlph": 3083363373,
    "dropsitcph": 3083363373,
    "dropfax": 3083363373
  },
  {
    "dcode": "D",
    "dropkey": "PW19745",
    "droptype": "D",
    "dropname": "FILLEY",
    "dropdeladd": "208 LIVINGSTON ST",
    "dropdelcty": "FILLEY",
    "dropdelst": "NE",
    "dropdelzpp": 683573000,
    "dropphyadd": "208 LIVINGSTON ST",
    "dropphycty": "FILLEY",
    "dropphyst": "NE",
    "dropphyzpp": 683573000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FILLEY",
    "dropmalst": "NE",
    "dropmalzpp": 683579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026624220,
    "dropsitcph": 4026624220,
    "dropfax": 4026624220
  },
  {
    "dcode": "D",
    "dropkey": "PW19746",
    "droptype": "D",
    "dropname": "FIRTH",
    "dropdeladd": "104 W 3RD ST",
    "dropdelcty": "FIRTH",
    "dropdelst": "NE",
    "dropdelzpp": 683586025,
    "dropphyadd": "104 W 3RD ST",
    "dropphycty": "FIRTH",
    "dropphyst": "NE",
    "dropphyzpp": 683586025,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FIRTH",
    "dropmalst": "NE",
    "dropmalzpp": 683589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027915577,
    "dropsitcph": 4027915577,
    "dropfax": 4027915577
  },
  {
    "dcode": "D",
    "dropkey": "PW19750",
    "droptype": "D",
    "dropname": "FORDYCE",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "FORDYCE",
    "dropdelst": "NE",
    "dropdelzpp": 687369701,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "FORDYCE",
    "dropphyst": "NE",
    "dropphyzpp": 687369701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORDYCE",
    "dropmalst": "NE",
    "dropmalzpp": 687369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023573358,
    "dropsitcph": 4023573358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19751",
    "droptype": "D",
    "dropname": "FORT CALHOUN",
    "dropdeladd": "406 N 14TH ST",
    "dropdelcty": "FORT CALHOUN",
    "dropdelst": "NE",
    "dropdelzpp": 680232034,
    "dropphyadd": "406 N 14TH ST",
    "dropphycty": "FORT CALHOUN",
    "dropphyst": "NE",
    "dropphyzpp": 680232034,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT CALHOUN",
    "dropmalst": "NE",
    "dropmalzpp": 680239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024685665,
    "dropsitcph": 4024685665,
    "dropfax": 4024685088
  },
  {
    "dcode": "D",
    "dropkey": "PW19754",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "1402 L ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NE",
    "dropdelzpp": 689399998,
    "dropphyadd": "1402 L ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NE",
    "dropphyzpp": 689399998,
    "dropmaladd": "1402 L ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NE",
    "dropmalzpp": 689399998,
    "dropsitphn": 3084253447,
    "dropsitlph": 3084253447,
    "dropsitcph": 3084704007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19755",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "348 E 6TH ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "NE",
    "dropdelzpp": 680259998,
    "dropphyadd": "348 E 6TH ST",
    "dropphycty": "FREMONT",
    "dropphyst": "NE",
    "dropphyzpp": 680259998,
    "dropmaladd": "348 E 6TH ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "NE",
    "dropmalzpp": 680259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027211913,
    "dropsitcph": 4027211913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19756",
    "droptype": "D",
    "dropname": "FRIEND",
    "dropdeladd": "119 S CHESTNUT ST",
    "dropdelcty": "FRIEND",
    "dropdelst": "NE",
    "dropdelzpp": 683591020,
    "dropphyadd": "119 S CHESTNUT ST",
    "dropphycty": "FRIEND",
    "dropphyst": "NE",
    "dropphyzpp": 683591020,
    "dropmaladd": "119 S CHESTNUT ST",
    "dropmalcty": "FRIEND",
    "dropmalst": "NE",
    "dropmalzpp": 683591020,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029473361,
    "dropsitcph": 4029473361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19757",
    "droptype": "D",
    "dropname": "FULLERTON",
    "dropdeladd": "420 BROADWAY ST",
    "dropdelcty": "FULLERTON",
    "dropdelst": "NE",
    "dropdelzpp": 686383155,
    "dropphyadd": "420 BROADWAY ST",
    "dropphycty": "FULLERTON",
    "dropphyst": "NE",
    "dropphyzpp": 686383155,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULLERTON",
    "dropmalst": "NE",
    "dropmalzpp": 686389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3085362212,
    "dropsitcph": 3085362212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19758",
    "droptype": "D",
    "dropname": "FUNK",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "FUNK",
    "dropdelst": "NE",
    "dropdelzpp": 689409700,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "FUNK",
    "dropphyst": "NE",
    "dropphyzpp": 689409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FUNK",
    "dropmalst": "NE",
    "dropmalzpp": 689409998,
    "dropsitphn": 3082632301,
    "dropsitlph": 3082632301,
    "dropsitcph": 3082632301,
    "dropfax": 3082632301
  },
  {
    "dcode": "D",
    "dropkey": "PW19765",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "117 4TH ST",
    "dropdelcty": "GARLAND",
    "dropdelst": "NE",
    "dropdelzpp": 683609355,
    "dropphyadd": "117 4TH ST",
    "dropphycty": "GARLAND",
    "dropphyst": "NE",
    "dropphyzpp": 683609355,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARLAND",
    "dropmalst": "NE",
    "dropmalzpp": 683609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025882401,
    "dropsitcph": 4025882401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19768",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "212 N 9TH ST",
    "dropdelcty": "GENEVA",
    "dropdelst": "NE",
    "dropdelzpp": 683619998,
    "dropphyadd": "212 N 9TH ST",
    "dropphycty": "GENEVA",
    "dropphyst": "NE",
    "dropphyzpp": 683619998,
    "dropmaladd": "212 N 9TH ST",
    "dropmalcty": "GENEVA",
    "dropmalst": "NE",
    "dropmalzpp": 683619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027593317,
    "dropsitcph": 4027593317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19769",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "509 WILLARD AVE",
    "dropdelcty": "GENOA",
    "dropdelst": "NE",
    "dropdelzpp": 686403039,
    "dropphyadd": "509 WILLARD AVE",
    "dropphycty": "GENOA",
    "dropphyst": "NE",
    "dropphyzpp": 686403039,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENOA",
    "dropmalst": "NE",
    "dropmalzpp": 686409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029932401,
    "dropsitcph": 4029932401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19771",
    "droptype": "D",
    "dropname": "GERING",
    "dropdeladd": "1050 P ST",
    "dropdelcty": "GERING",
    "dropdelst": "NE",
    "dropdelzpp": 693412827,
    "dropphyadd": "1050 P ST",
    "dropphycty": "GERING",
    "dropphyst": "NE",
    "dropphyzpp": 693412827,
    "dropmaladd": "1050 P ST",
    "dropmalcty": "GERING",
    "dropmalst": "NE",
    "dropmalzpp": 693412827,
    "dropsitphn": 3084364733,
    "dropsitlph": 3084364733,
    "dropsitcph": 3084364733,
    "dropfax": 3084367747
  },
  {
    "dcode": "D",
    "dropkey": "PW19772",
    "droptype": "D",
    "dropname": "GIBBON",
    "dropdeladd": "29 LABARRE ST",
    "dropdelcty": "GIBBON",
    "dropdelst": "NE",
    "dropdelzpp": 688409700,
    "dropphyadd": "29 LABARRE ST",
    "dropphycty": "GIBBON",
    "dropphyst": "NE",
    "dropphyzpp": 688409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIBBON",
    "dropmalst": "NE",
    "dropmalzpp": 688409998,
    "dropsitphn": 3084685846,
    "dropsitlph": 3084685846,
    "dropsitcph": 3084685846,
    "dropfax": 3084685846
  },
  {
    "dcode": "D",
    "dropkey": "PW19774",
    "droptype": "D",
    "dropname": "GILTNER",
    "dropdeladd": "3013 N COMMERCIAL AVE",
    "dropdelcty": "GILTNER",
    "dropdelst": "NE",
    "dropdelzpp": 688419700,
    "dropphyadd": "3013 N COMMERCIAL AVE",
    "dropphycty": "GILTNER",
    "dropphyst": "NE",
    "dropphyzpp": 688419700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILTNER",
    "dropmalst": "NE",
    "dropmalzpp": 688419998,
    "dropsitphn": 4028492977,
    "dropsitlph": 4028492977,
    "dropsitcph": 4028492977,
    "dropfax": 4028492977
  },
  {
    "dcode": "D",
    "dropkey": "PW19779",
    "droptype": "D",
    "dropname": "GLENVIL",
    "dropdeladd": "204 WINTERS AVE",
    "dropdelcty": "GLENVIL",
    "dropdelst": "NE",
    "dropdelzpp": 689412779,
    "dropphyadd": "204 WINTERS AVE",
    "dropphycty": "GLENVIL",
    "dropphyst": "NE",
    "dropphyzpp": 689412779,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENVIL",
    "dropmalst": "NE",
    "dropmalzpp": 689419998,
    "dropsitphn": 4027712528,
    "dropsitlph": 4027712528,
    "dropsitcph": 4027712528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19780",
    "droptype": "D",
    "dropname": "GOEHNER",
    "dropdeladd": "1254 MAY ST",
    "dropdelcty": "GOEHNER",
    "dropdelst": "NE",
    "dropdelzpp": 683640200,
    "dropphyadd": "1254 MAY ST",
    "dropphycty": "GOEHNER",
    "dropphyst": "NE",
    "dropphyzpp": 683640200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOEHNER",
    "dropmalst": "NE",
    "dropmalzpp": 683649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025234165,
    "dropsitcph": 4025234165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19782",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "112 E 3RD ST",
    "dropdelcty": "GORDON",
    "dropdelst": "NE",
    "dropdelzpp": 693439998,
    "dropphyadd": "112 E 3RD ST",
    "dropphycty": "GORDON",
    "dropphyst": "NE",
    "dropphyzpp": 693439998,
    "dropmaladd": "112 E 3RD ST",
    "dropmalcty": "GORDON",
    "dropmalst": "NE",
    "dropmalzpp": 693439998,
    "dropsitphn": 3082821233,
    "dropsitlph": 3082821233,
    "dropsitcph": 3082821233,
    "dropfax": 3082821233
  },
  {
    "dcode": "D",
    "dropkey": "PW19783",
    "droptype": "D",
    "dropname": "GOTHENBURG",
    "dropdeladd": "1021 LAKE AVE",
    "dropdelcty": "GOTHENBURG",
    "dropdelst": "NE",
    "dropdelzpp": 691389998,
    "dropphyadd": "1021 LAKE AVE",
    "dropphycty": "GOTHENBURG",
    "dropphyst": "NE",
    "dropphyzpp": 691389998,
    "dropmaladd": "1021 LAKE AVE",
    "dropmalcty": "GOTHENBURG",
    "dropmalst": "NE",
    "dropmalzpp": 691389998,
    "dropsitphn": 3085372121,
    "dropsitlph": 3085372121,
    "dropsitcph": 3085372121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19785",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "275 N WASHINGTON AVE",
    "dropdelcty": "GRAFTON",
    "dropdelst": "NE",
    "dropdelzpp": 683653001,
    "dropphyadd": "275 N WASHINGTON AVE",
    "dropphycty": "GRAFTON",
    "dropphyst": "NE",
    "dropphyzpp": 683653001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAFTON",
    "dropmalst": "NE",
    "dropmalzpp": 683659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022827208,
    "dropsitcph": 4022827208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19789",
    "droptype": "D",
    "dropname": "GRAND ISLAND",
    "dropdeladd": "3835 W OLD POTASH HWY",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "NE",
    "dropdelzpp": 688034909,
    "dropphyadd": "3835 W OLD POTASH HWY",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "NE",
    "dropphyzpp": 688034909,
    "dropmaladd": "3835 W OLD POTASH HWY",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "NE",
    "dropmalzpp": 688034909,
    "dropsitphn": 3083923034,
    "dropsitlph": 3083923034,
    "dropsitcph": 3083923033,
    "dropfax": 3083856584
  },
  {
    "dcode": "D",
    "dropkey": "PW19792",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "417 CENTRAL AVE",
    "dropdelcty": "GRANT",
    "dropdelst": "NE",
    "dropdelzpp": 691403007,
    "dropphyadd": "417 CENTRAL AVE",
    "dropphycty": "GRANT",
    "dropphyst": "NE",
    "dropphyzpp": 691403007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANT",
    "dropmalst": "NE",
    "dropmalzpp": 691409998,
    "dropsitphn": 3083524409,
    "dropsitlph": 3083524409,
    "dropsitcph": 3083524409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19796",
    "droptype": "D",
    "dropname": "GREELEY",
    "dropdeladd": "208 W ONEILL AVE",
    "dropdelcty": "GREELEY",
    "dropdelst": "NE",
    "dropdelzpp": 688424231,
    "dropphyadd": "208 W ONEILL AVE",
    "dropphycty": "GREELEY",
    "dropphyst": "NE",
    "dropphyzpp": 688424231,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREELEY",
    "dropmalst": "NE",
    "dropmalzpp": 688429998,
    "dropsitphn": 3084285005,
    "dropsitlph": 3084285005,
    "dropsitcph": 3084285005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19797",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "614 MAIN ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 683662617,
    "dropphyadd": "614 MAIN ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 683662617,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 683669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027895445,
    "dropsitcph": 4027895445,
    "dropfax": 4027895445
  },
  {
    "dcode": "D",
    "dropkey": "PW19798",
    "droptype": "D",
    "dropname": "GRESHAM",
    "dropdeladd": "350 ELM ST",
    "dropdelcty": "GRESHAM",
    "dropdelst": "NE",
    "dropdelzpp": 683679700,
    "dropphyadd": "350 ELM ST",
    "dropphycty": "GRESHAM",
    "dropphyst": "NE",
    "dropphyzpp": 683679700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRESHAM",
    "dropmalst": "NE",
    "dropmalzpp": 683679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027357225,
    "dropsitcph": 4027357225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19799",
    "droptype": "D",
    "dropname": "GRETNA",
    "dropdeladd": "104 E ENTERPRISE DR",
    "dropdelcty": "GRETNA",
    "dropdelst": "NE",
    "dropdelzpp": 680287972,
    "dropphyadd": "104 E ENTERPRISE DR",
    "dropphycty": "GRETNA",
    "dropphyst": "NE",
    "dropphyzpp": 680287972,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRETNA",
    "dropmalst": "NE",
    "dropmalzpp": 680289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023325479,
    "dropsitcph": 4023322726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19802",
    "droptype": "D",
    "dropname": "GUIDE ROCK",
    "dropdeladd": "400 UNIVERSITY AVE",
    "dropdelcty": "GUIDE ROCK",
    "dropdelst": "NE",
    "dropdelzpp": 689428029,
    "dropphyadd": "400 UNIVERSITY AVE",
    "dropphycty": "GUIDE ROCK",
    "dropphyst": "NE",
    "dropphyzpp": 689428029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUIDE ROCK",
    "dropmalst": "NE",
    "dropmalzpp": 689429998,
    "dropsitphn": 4022573705,
    "dropsitlph": 4022573705,
    "dropsitcph": 4022573705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19803",
    "droptype": "D",
    "dropname": "GURLEY",
    "dropdeladd": "743 3RD ST",
    "dropdelcty": "GURLEY",
    "dropdelst": "NE",
    "dropdelzpp": 691419700,
    "dropphyadd": "743 3RD ST",
    "dropphycty": "GURLEY",
    "dropphyst": "NE",
    "dropphyzpp": 691419700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GURLEY",
    "dropmalst": "NE",
    "dropmalzpp": 691419998,
    "dropsitphn": 3088842342,
    "dropsitlph": 3088842342,
    "dropsitcph": 3088842342,
    "dropfax": 3088842342
  },
  {
    "dcode": "D",
    "dropkey": "PW19806",
    "droptype": "D",
    "dropname": "HAIGLER",
    "dropdeladd": "149 N PORTER AVE",
    "dropdelcty": "HAIGLER",
    "dropdelst": "NE",
    "dropdelzpp": 690304525,
    "dropphyadd": "149 N PORTER AVE",
    "dropphycty": "HAIGLER",
    "dropphyst": "NE",
    "dropphyzpp": 690304525,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAIGLER",
    "dropmalst": "NE",
    "dropmalzpp": 690309998,
    "dropsitphn": 4026740435,
    "dropsitlph": 4026740435,
    "dropsitcph": 4026740582,
    "dropfax": 3082973455
  },
  {
    "dcode": "D",
    "dropkey": "PW19808",
    "droptype": "D",
    "dropname": "HALLAM",
    "dropdeladd": "336 MAIN ST",
    "dropdelcty": "HALLAM",
    "dropdelst": "NE",
    "dropdelzpp": 683687892,
    "dropphyadd": "336 MAIN ST",
    "dropphycty": "HALLAM",
    "dropphyst": "NE",
    "dropphyzpp": 683687892,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALLAM",
    "dropmalst": "NE",
    "dropmalzpp": 683689998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027873535,
    "dropsitcph": 4027873535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19809",
    "droptype": "D",
    "dropname": "HALSEY",
    "dropdeladd": "508 HIGHWAY 2",
    "dropdelcty": "HALSEY",
    "dropdelst": "NE",
    "dropdelzpp": 691429706,
    "dropphyadd": "508 HIGHWAY 2",
    "dropphycty": "HALSEY",
    "dropphyst": "NE",
    "dropphyzpp": 691429706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALSEY",
    "dropmalst": "NE",
    "dropmalzpp": 691429998,
    "dropsitphn": 3085332285,
    "dropsitlph": 4022305049,
    "dropsitcph": 4022305049,
    "dropfax": 3085332285
  },
  {
    "dcode": "D",
    "dropkey": "PW19812",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "107 N 3RD ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "NE",
    "dropdelzpp": 688439232,
    "dropphyadd": "107 N 3RD ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "NE",
    "dropphyzpp": 688439232,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMPTON",
    "dropmalst": "NE",
    "dropmalzpp": 688439998,
    "dropsitphn": 4027253455,
    "dropsitlph": 4027253455,
    "dropsitcph": 4027253455,
    "dropfax": 4027253455
  },
  {
    "dcode": "D",
    "dropkey": "PW19816",
    "droptype": "D",
    "dropname": "HARDY",
    "dropdeladd": "307 MAIN ST",
    "dropdelcty": "HARDY",
    "dropdelst": "NE",
    "dropdelzpp": 689434311,
    "dropphyadd": "307 MAIN ST",
    "dropphycty": "HARDY",
    "dropphyst": "NE",
    "dropphyzpp": 689434311,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARDY",
    "dropmalst": "NE",
    "dropmalzpp": 689439998,
    "dropsitphn": 4022793355,
    "dropsitlph": 4022793355,
    "dropsitcph": 4022793355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19817",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "306 STATE ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "NE",
    "dropdelzpp": 693455000,
    "dropphyadd": "306 STATE ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "NE",
    "dropphyzpp": 693455000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "NE",
    "dropmalzpp": 693459998,
    "dropsitphn": 3084367466,
    "dropsitlph": 3084367466,
    "dropsitcph": 3084367466,
    "dropfax": 3084367466
  },
  {
    "dcode": "D",
    "dropkey": "PW19818",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "267 MAIN ST",
    "dropdelcty": "HARRISON",
    "dropdelst": "NE",
    "dropdelzpp": 693461750,
    "dropphyadd": "267 MAIN ST",
    "dropphycty": "HARRISON",
    "dropphyst": "NE",
    "dropphyzpp": 693461750,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISON",
    "dropmalst": "NE",
    "dropmalzpp": 693469998,
    "dropsitphn": 3086682449,
    "dropsitlph": 3086682449,
    "dropsitcph": 3086682449,
    "dropfax": 3086682449
  },
  {
    "dcode": "D",
    "dropkey": "PW19822",
    "droptype": "D",
    "dropname": "HARTINGTON",
    "dropdeladd": "105 W STATE ST",
    "dropdelcty": "HARTINGTON",
    "dropdelst": "NE",
    "dropdelzpp": 687395712,
    "dropphyadd": "105 W STATE ST",
    "dropphycty": "HARTINGTON",
    "dropphyst": "NE",
    "dropphyzpp": 687395712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTINGTON",
    "dropmalst": "NE",
    "dropmalzpp": 687399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022546341,
    "dropsitcph": 4022546341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19823",
    "droptype": "D",
    "dropname": "HARVARD",
    "dropdeladd": "315 N CLAY AVE",
    "dropdelcty": "HARVARD",
    "dropdelst": "NE",
    "dropdelzpp": 689442149,
    "dropphyadd": "315 N CLAY AVE",
    "dropphycty": "HARVARD",
    "dropphyst": "NE",
    "dropphyzpp": 689442149,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARVARD",
    "dropmalst": "NE",
    "dropmalzpp": 689449998,
    "dropsitphn": 4027725811,
    "dropsitlph": 4027725811,
    "dropsitcph": 4027725811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19824",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "300 N KANSAS AVE",
    "dropdelcty": "HASTINGS",
    "dropdelst": "NE",
    "dropdelzpp": 689019998,
    "dropphyadd": "300 N KANSAS AVE",
    "dropphycty": "HASTINGS",
    "dropphyst": "NE",
    "dropphyzpp": 689019998,
    "dropmaladd": "300 N KANSAS AVE",
    "dropmalcty": "HASTINGS",
    "dropmalst": "NE",
    "dropmalzpp": 689019998,
    "dropsitphn": 4024633107,
    "dropsitlph": 4024633107,
    "dropsitcph": 4024633107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19830",
    "droptype": "D",
    "dropname": "HAY SPRINGS",
    "dropdeladd": "240 N MAIN ST",
    "dropdelcty": "HAY SPRINGS",
    "dropdelst": "NE",
    "dropdelzpp": 693479781,
    "dropphyadd": "240 N MAIN ST",
    "dropphycty": "HAY SPRINGS",
    "dropphyst": "NE",
    "dropphyzpp": 693479781,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAY SPRINGS",
    "dropmalst": "NE",
    "dropmalzpp": 693479998,
    "dropsitphn": 3086387121,
    "dropsitlph": 4022751288,
    "dropsitcph": 4022751288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19833",
    "droptype": "D",
    "dropname": "HAYES CENTER",
    "dropdeladd": "600 TATE AVE",
    "dropdelcty": "HAYES CENTER",
    "dropdelst": "NE",
    "dropdelzpp": 690329750,
    "dropphyadd": "600 TATE AVE",
    "dropphycty": "HAYES CENTER",
    "dropphyst": "NE",
    "dropphyzpp": 690329750,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYES CENTER",
    "dropmalst": "NE",
    "dropmalzpp": 690329998,
    "dropsitphn": 3082863497,
    "dropsitlph": 3082863497,
    "dropsitcph": 3082863497,
    "dropfax": 3082863497
  },
  {
    "dcode": "D",
    "dropkey": "PW19837",
    "droptype": "D",
    "dropname": "HEARTWELL",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "HEARTWELL",
    "dropdelst": "NE",
    "dropdelzpp": 689452059,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "HEARTWELL",
    "dropphyst": "NE",
    "dropphyzpp": 689452059,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEARTWELL",
    "dropmalst": "NE",
    "dropmalzpp": 689459998,
    "dropsitphn": 3085632541,
    "dropsitlph": "",
    "dropsitcph": 3085632541,
    "dropfax": 3085632541
  },
  {
    "dcode": "D",
    "dropkey": "PW19838",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "145 N 5TH ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "NE",
    "dropdelzpp": 683701513,
    "dropphyadd": "145 N 5TH ST",
    "dropphycty": "HEBRON",
    "dropphyst": "NE",
    "dropphyzpp": 683701513,
    "dropmaladd": "145 N 5TH ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "NE",
    "dropmalzpp": 683709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027686127,
    "dropsitcph": 4027686127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19839",
    "droptype": "D",
    "dropname": "HEMINGFORD",
    "dropdeladd": "805 BOX BUTTE AVE",
    "dropdelcty": "HEMINGFORD",
    "dropdelst": "NE",
    "dropdelzpp": 693489700,
    "dropphyadd": "805 BOX BUTTE AVE",
    "dropphycty": "HEMINGFORD",
    "dropphyst": "NE",
    "dropphyzpp": 693489700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEMINGFORD",
    "dropmalst": "NE",
    "dropmalzpp": 693489998,
    "dropsitphn": 3084873628,
    "dropsitlph": 3084873628,
    "dropsitcph": 3084873628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19840",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "1049 N MAIN ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NE",
    "dropdelzpp": 683719798,
    "dropphyadd": "1049 N MAIN ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "NE",
    "dropphyzpp": 683719798,
    "dropmaladd": "1049 N MAIN ST",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NE",
    "dropmalzpp": 683719798,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027235735,
    "dropsitcph": 4027235735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19843",
    "droptype": "D",
    "dropname": "HERMAN",
    "dropdeladd": "108 W 5TH ST",
    "dropdelcty": "HERMAN",
    "dropdelst": "NE",
    "dropdelzpp": 680299700,
    "dropphyadd": "108 W 5TH ST",
    "dropphycty": "HERMAN",
    "dropphyst": "NE",
    "dropphyzpp": 680299700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERMAN",
    "dropmalst": "NE",
    "dropmalzpp": 680299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024567332,
    "dropsitcph": 4024567332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19844",
    "droptype": "D",
    "dropname": "HERSHEY",
    "dropdeladd": "120 S LINCOLN AVE",
    "dropdelcty": "HERSHEY",
    "dropdelst": "NE",
    "dropdelzpp": 691434508,
    "dropphyadd": "120 S LINCOLN AVE",
    "dropphycty": "HERSHEY",
    "dropphyst": "NE",
    "dropphyzpp": 691434508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERSHEY",
    "dropmalst": "NE",
    "dropmalzpp": 691439998,
    "dropsitphn": 3083685501,
    "dropsitlph": 3083685501,
    "dropsitcph": 3083685501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19845",
    "droptype": "D",
    "dropname": "HICKMAN",
    "dropdeladd": "116 LOCUST ST",
    "dropdelcty": "HICKMAN",
    "dropdelst": "NE",
    "dropdelzpp": 683729900,
    "dropphyadd": "116 LOCUST ST",
    "dropphycty": "HICKMAN",
    "dropphyst": "NE",
    "dropphyzpp": 683729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKMAN",
    "dropmalst": "NE",
    "dropmalzpp": 683729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027922045,
    "dropsitcph": 4027922045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19848",
    "droptype": "D",
    "dropname": "HILDRETH",
    "dropdeladd": "209 COMMERCIAL AVE",
    "dropdelcty": "HILDRETH",
    "dropdelst": "NE",
    "dropdelzpp": 689475173,
    "dropphyadd": "209 COMMERCIAL AVE",
    "dropphycty": "HILDRETH",
    "dropphyst": "NE",
    "dropphyzpp": 689475173,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILDRETH",
    "dropmalst": "NE",
    "dropmalzpp": 689479998,
    "dropsitphn": 3089383875,
    "dropsitlph": 3089383875,
    "dropsitcph": 3089383875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19850",
    "droptype": "D",
    "dropname": "HOLBROOK",
    "dropdeladd": "220 CENTER AVE",
    "dropdelcty": "HOLBROOK",
    "dropdelst": "NE",
    "dropdelzpp": 689489900,
    "dropphyadd": "220 CENTER AVE",
    "dropphycty": "HOLBROOK",
    "dropphyst": "NE",
    "dropphyzpp": 689489900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLBROOK",
    "dropmalst": "NE",
    "dropmalzpp": 689489998,
    "dropsitphn": 3084935349,
    "dropsitlph": "",
    "dropsitcph": 3084935349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19851",
    "droptype": "D",
    "dropname": "HOLDREGE",
    "dropdeladd": "420 EAST AVE",
    "dropdelcty": "HOLDREGE",
    "dropdelst": "NE",
    "dropdelzpp": 689499998,
    "dropphyadd": "420 EAST AVE",
    "dropphycty": "HOLDREGE",
    "dropphyst": "NE",
    "dropphyzpp": 689499998,
    "dropmaladd": "420 EAST AVE",
    "dropmalcty": "HOLDREGE",
    "dropmalst": "NE",
    "dropmalzpp": 689499998,
    "dropsitphn": 3089955791,
    "dropsitlph": 3089955791,
    "dropsitcph": 3089955791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19859",
    "droptype": "D",
    "dropname": "HOLSTEIN",
    "dropdeladd": "9710 S MAIN AVE",
    "dropdelcty": "HOLSTEIN",
    "dropdelst": "NE",
    "dropdelzpp": 689505065,
    "dropphyadd": "9710 S MAIN AVE",
    "dropphycty": "HOLSTEIN",
    "dropphyst": "NE",
    "dropphyzpp": 689505065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLSTEIN",
    "dropmalst": "NE",
    "dropmalzpp": 689509998,
    "dropsitphn": 4027565030,
    "dropsitlph": 4027565030,
    "dropsitcph": 4027565030,
    "dropfax": 4027565030
  },
  {
    "dcode": "D",
    "dropkey": "PW19860",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "113 JOHN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "NE",
    "dropdelzpp": 680309700,
    "dropphyadd": "113 JOHN ST",
    "dropphycty": "HOMER",
    "dropphyst": "NE",
    "dropphyzpp": 680309700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOMER",
    "dropmalst": "NE",
    "dropmalzpp": 680309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026982476,
    "dropsitcph": 4026982476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19862",
    "droptype": "D",
    "dropname": "HOOPER",
    "dropdeladd": "211 N MAIN ST",
    "dropdelcty": "HOOPER",
    "dropdelst": "NE",
    "dropdelzpp": 680313064,
    "dropphyadd": "211 N MAIN ST",
    "dropphycty": "HOOPER",
    "dropphyst": "NE",
    "dropphyzpp": 680313064,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOOPER",
    "dropmalst": "NE",
    "dropmalzpp": 680319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026542388,
    "dropsitcph": 4026542388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19864",
    "droptype": "D",
    "dropname": "HORDVILLE",
    "dropdeladd": "112 1/2 MAIN ST",
    "dropdelcty": "HORDVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 688469700,
    "dropphyadd": "112 1/2 MAIN ST",
    "dropphycty": "HORDVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 688469700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HORDVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 688469998,
    "dropsitphn": 4027573382,
    "dropsitlph": 4027573382,
    "dropsitcph": 4027573382,
    "dropfax": 4027573382
  },
  {
    "dcode": "D",
    "dropkey": "PW19865",
    "droptype": "D",
    "dropname": "HOSKINS",
    "dropdeladd": "107 S MAIN ST",
    "dropdelcty": "HOSKINS",
    "dropdelst": "NE",
    "dropdelzpp": 687404121,
    "dropphyadd": "107 S MAIN ST",
    "dropphycty": "HOSKINS",
    "dropphyst": "NE",
    "dropphyzpp": 687404121,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOSKINS",
    "dropmalst": "NE",
    "dropmalzpp": 687409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025654213,
    "dropsitcph": 4025654213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19867",
    "droptype": "D",
    "dropname": "HOWELLS",
    "dropdeladd": "120 N 3RD ST",
    "dropdelcty": "HOWELLS",
    "dropdelst": "NE",
    "dropdelzpp": 686413087,
    "dropphyadd": "120 N 3RD ST",
    "dropphycty": "HOWELLS",
    "dropphyst": "NE",
    "dropphyzpp": 686413087,
    "dropmaladd": "120 N 3RD ST",
    "dropmalcty": "HOWELLS",
    "dropmalst": "NE",
    "dropmalzpp": 686413087,
    "dropsitphn": 4023482736,
    "dropsitlph": 4029861242,
    "dropsitcph": 4029861242,
    "dropfax": 4029861242
  },
  {
    "dcode": "D",
    "dropkey": "PW19868",
    "droptype": "D",
    "dropname": "HUBBARD",
    "dropdeladd": "211 CHERRY ST",
    "dropdelcty": "HUBBARD",
    "dropdelst": "NE",
    "dropdelzpp": 687419700,
    "dropphyadd": "211 CHERRY ST",
    "dropphycty": "HUBBARD",
    "dropphyst": "NE",
    "dropphyzpp": 687419700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBARD",
    "dropmalst": "NE",
    "dropmalzpp": 687419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026324271,
    "dropsitcph": 4026324271,
    "dropfax": 4026324271
  },
  {
    "dcode": "D",
    "dropkey": "PW19870",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "335 W SQUARE ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "NE",
    "dropdelzpp": 683769788,
    "dropphyadd": "335 W SQUARE ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "NE",
    "dropphyzpp": 683769788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "NE",
    "dropmalzpp": 683769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028622013,
    "dropsitcph": 4028622013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19871",
    "droptype": "D",
    "dropname": "HUMPHREY",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "HUMPHREY",
    "dropdelst": "NE",
    "dropdelzpp": 686423155,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "HUMPHREY",
    "dropphyst": "NE",
    "dropphyzpp": 686423155,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMPHREY",
    "dropmalst": "NE",
    "dropmalzpp": 686429998,
    "dropsitphn": 4029230911,
    "dropsitlph": 4029230911,
    "dropsitcph": 4029230911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19873",
    "droptype": "D",
    "dropname": "HYANNIS",
    "dropdeladd": "116 S MAIN AVE",
    "dropdelcty": "HYANNIS",
    "dropdelst": "NE",
    "dropdelzpp": 693509700,
    "dropphyadd": "116 S MAIN AVE",
    "dropphycty": "HYANNIS",
    "dropphyst": "NE",
    "dropphyzpp": 693509700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYANNIS",
    "dropmalst": "NE",
    "dropmalzpp": 693509998,
    "dropsitphn": 3084582792,
    "dropsitlph": 3084582792,
    "dropsitcph": 3084582792,
    "dropfax": 3084582792
  },
  {
    "dcode": "D",
    "dropkey": "PW19874",
    "droptype": "D",
    "dropname": "IMPERIAL",
    "dropdeladd": "523 WELLINGTON ST",
    "dropdelcty": "IMPERIAL",
    "dropdelst": "NE",
    "dropdelzpp": 690339903,
    "dropphyadd": "523 WELLINGTON ST",
    "dropphycty": "IMPERIAL",
    "dropphyst": "NE",
    "dropphyzpp": 690339903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IMPERIAL",
    "dropmalst": "NE",
    "dropmalzpp": 690339998,
    "dropsitphn": 3088825313,
    "dropsitlph": 3088825313,
    "dropsitcph": 3088825313,
    "dropfax": 3088825313
  },
  {
    "dcode": "D",
    "dropkey": "PW19878",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "202 N 4TH ST",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "NE",
    "dropdelzpp": 690343416,
    "dropphyadd": "202 N 4TH ST",
    "dropphycty": "INDIANOLA",
    "dropphyst": "NE",
    "dropphyzpp": 690343416,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "NE",
    "dropmalzpp": 690349998,
    "dropsitphn": 3083642219,
    "dropsitlph": 3083642219,
    "dropsitcph": 3083642219,
    "dropfax": 3083642219
  },
  {
    "dcode": "D",
    "dropkey": "PW19883",
    "droptype": "D",
    "dropname": "INMAN",
    "dropdeladd": "190 MAIN ST",
    "dropdelcty": "INMAN",
    "dropdelst": "NE",
    "dropdelzpp": 687425208,
    "dropphyadd": "190 MAIN ST",
    "dropphycty": "INMAN",
    "dropphyst": "NE",
    "dropphyzpp": 687425208,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INMAN",
    "dropmalst": "NE",
    "dropmalzpp": 687429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023945401,
    "dropsitcph": 4023945401,
    "dropfax": 4023945401
  },
  {
    "dcode": "D",
    "dropkey": "PW19884",
    "droptype": "D",
    "dropname": "ITHACA",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "ITHACA",
    "dropdelst": "NE",
    "dropdelzpp": 680339700,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "ITHACA",
    "dropphyst": "NE",
    "dropphyzpp": 680339700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ITHACA",
    "dropmalst": "NE",
    "dropmalzpp": 680339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026234251,
    "dropsitcph": 4026234251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19886",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "112 W ELK ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "NE",
    "dropdelzpp": 687439708,
    "dropphyadd": "112 W ELK ST",
    "dropphycty": "JACKSON",
    "dropphyst": "NE",
    "dropphyzpp": 687439708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSON",
    "dropmalst": "NE",
    "dropmalzpp": 687439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026324439,
    "dropsitcph": 4026324439,
    "dropfax": 4026324439
  },
  {
    "dcode": "D",
    "dropkey": "PW19888",
    "droptype": "D",
    "dropname": "JANSEN",
    "dropdeladd": "305 BROAD ST",
    "dropdelcty": "JANSEN",
    "dropdelst": "NE",
    "dropdelzpp": 683779700,
    "dropphyadd": "305 BROAD ST",
    "dropphycty": "JANSEN",
    "dropphyst": "NE",
    "dropphyzpp": 683779700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JANSEN",
    "dropmalst": "NE",
    "dropmalzpp": 683779998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026568734,
    "dropsitcph": 4026568734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19889",
    "droptype": "D",
    "dropname": "JOHNSON",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "JOHNSON",
    "dropdelst": "NE",
    "dropdelzpp": 683783580,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "JOHNSON",
    "dropphyst": "NE",
    "dropphyzpp": 683783580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHNSON",
    "dropmalst": "NE",
    "dropmalzpp": 683789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028683685,
    "dropsitcph": 4028683685,
    "dropfax": 4028683685
  },
  {
    "dcode": "D",
    "dropkey": "PW19891",
    "droptype": "D",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "NE",
    "dropdelzpp": 692149741,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "NE",
    "dropphyzpp": 692149741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "NE",
    "dropmalzpp": 692149998,
    "dropsitphn": 4027224438,
    "dropsitlph": 4027224438,
    "dropsitcph": 4027224438,
    "dropfax": 4027224438
  },
  {
    "dcode": "D",
    "dropkey": "PW19894",
    "droptype": "D",
    "dropname": "JUNIATA",
    "dropdeladd": "1000 N JUNIATA AVE",
    "dropdelcty": "JUNIATA",
    "dropdelst": "NE",
    "dropdelzpp": 689555530,
    "dropphyadd": "1000 N JUNIATA AVE",
    "dropphycty": "JUNIATA",
    "dropphyst": "NE",
    "dropphyzpp": 689555530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JUNIATA",
    "dropmalst": "NE",
    "dropmalzpp": 689559998,
    "dropsitphn": 4027510389,
    "dropsitlph": 4027510389,
    "dropsitcph": 4027510389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19895",
    "droptype": "D",
    "dropname": "KEARNEY",
    "dropdeladd": "2401 E AVE",
    "dropdelcty": "KEARNEY",
    "dropdelst": "NE",
    "dropdelzpp": 688479998,
    "dropphyadd": "2401 E AVE",
    "dropphycty": "KEARNEY",
    "dropphyst": "NE",
    "dropphyzpp": 688479998,
    "dropmaladd": "2401 E AVE",
    "dropmalcty": "KEARNEY",
    "dropmalst": "NE",
    "dropmalzpp": 688479998,
    "dropsitphn": 3082342051,
    "dropsitlph": 3082342051,
    "dropsitcph": 3082342051,
    "dropfax": 3082374309
  },
  {
    "dcode": "D",
    "dropkey": "PW19898",
    "droptype": "D",
    "dropname": "KENESAW",
    "dropdeladd": "205 N SMITH AVE",
    "dropdelcty": "KENESAW",
    "dropdelst": "NE",
    "dropdelzpp": 689561552,
    "dropphyadd": "205 N SMITH AVE",
    "dropphycty": "KENESAW",
    "dropphyst": "NE",
    "dropphyzpp": 689561552,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENESAW",
    "dropmalst": "NE",
    "dropmalzpp": 689569998,
    "dropsitphn": 4027523214,
    "dropsitlph": 4027523214,
    "dropsitcph": 4027523214,
    "dropfax": 4027523214
  },
  {
    "dcode": "D",
    "dropkey": "PW19899",
    "droptype": "D",
    "dropname": "KENNARD",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "KENNARD",
    "dropdelst": "NE",
    "dropdelzpp": 680343000,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "KENNARD",
    "dropphyst": "NE",
    "dropphyzpp": 680343000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNARD",
    "dropmalst": "NE",
    "dropmalzpp": 680349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024277334,
    "dropsitcph": 4024277334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19900",
    "droptype": "D",
    "dropname": "KEYSTONE",
    "dropdeladd": "325 FENWICK ST",
    "dropdelcty": "KEYSTONE",
    "dropdelst": "NE",
    "dropdelzpp": 691442508,
    "dropphyadd": "325 FENWICK ST",
    "dropphycty": "KEYSTONE",
    "dropphyst": "NE",
    "dropphyzpp": 691442508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEYSTONE",
    "dropmalst": "NE",
    "dropmalzpp": 691449998,
    "dropsitphn": 3087262651,
    "dropsitlph": "",
    "dropsitcph": 3087262651,
    "dropfax": 3087262651
  },
  {
    "dcode": "D",
    "dropkey": "PW19902",
    "droptype": "D",
    "dropname": "KILGORE",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "KILGORE",
    "dropdelst": "NE",
    "dropdelzpp": 692169700,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "KILGORE",
    "dropphyst": "NE",
    "dropphyzpp": 692169700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KILGORE",
    "dropmalst": "NE",
    "dropmalzpp": 692169998,
    "dropsitphn": 4029662601,
    "dropsitlph": 4029662601,
    "dropsitcph": 4029662601,
    "dropfax": 4029662601
  },
  {
    "dcode": "D",
    "dropkey": "PW19903",
    "droptype": "D",
    "dropname": "KIMBALL",
    "dropdeladd": "201 W 2ND ST",
    "dropdelcty": "KIMBALL",
    "dropdelst": "NE",
    "dropdelzpp": 691459998,
    "dropphyadd": "201 W 2ND ST",
    "dropphycty": "KIMBALL",
    "dropphyst": "NE",
    "dropphyzpp": 691459998,
    "dropmaladd": "201 W 2ND ST",
    "dropmalcty": "KIMBALL",
    "dropmalst": "NE",
    "dropmalzpp": 691459998,
    "dropsitphn": 3082353318,
    "dropsitlph": 3082353318,
    "dropsitcph": 3082353318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19912",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "1331 STATE HIGHWAY 250",
    "dropdelcty": "LAKESIDE",
    "dropdelst": "NE",
    "dropdelzpp": 693519700,
    "dropphyadd": "1331 STATE HIGHWAY 250",
    "dropphycty": "LAKESIDE",
    "dropphyst": "NE",
    "dropphyzpp": 693519700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKESIDE",
    "dropmalst": "NE",
    "dropmalzpp": 693519998,
    "dropsitphn": 3087628430,
    "dropsitlph": 3087628430,
    "dropsitcph": 3087628430,
    "dropfax": 3087628430
  },
  {
    "dcode": "D",
    "dropkey": "PW19915",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "205 E 2ND ST",
    "dropdelcty": "LAUREL",
    "dropdelst": "NE",
    "dropdelzpp": 687451989,
    "dropphyadd": "205 E 2ND ST",
    "dropphycty": "LAUREL",
    "dropphyst": "NE",
    "dropphyzpp": 687451989,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUREL",
    "dropmalst": "NE",
    "dropmalzpp": 687459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022563877,
    "dropsitcph": 4022563877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19917",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "140 N CALVERT ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "NE",
    "dropdelzpp": 689579731,
    "dropphyadd": "140 N CALVERT ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "NE",
    "dropphyzpp": 689579731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "NE",
    "dropmalzpp": 689579998,
    "dropsitphn": 4027567050,
    "dropsitlph": 4027567050,
    "dropsitcph": 4027567050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19921",
    "droptype": "D",
    "dropname": "LEIGH",
    "dropdeladd": "167 N MAIN ST",
    "dropdelcty": "LEIGH",
    "dropdelst": "NE",
    "dropdelzpp": 686434528,
    "dropphyadd": "167 N MAIN ST",
    "dropphycty": "LEIGH",
    "dropphyst": "NE",
    "dropphyzpp": 686434528,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEIGH",
    "dropmalst": "NE",
    "dropmalzpp": 686439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024872723,
    "dropsitcph": 4024872723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19922",
    "droptype": "D",
    "dropname": "LEMOYNE",
    "dropdeladd": "721 HIGHWAY 92 W",
    "dropdelcty": "LEMOYNE",
    "dropdelst": "NE",
    "dropdelzpp": 691462901,
    "dropphyadd": "721 HIGHWAY 92 W",
    "dropphycty": "LEMOYNE",
    "dropphyst": "NE",
    "dropphyzpp": 691462901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEMOYNE",
    "dropmalst": "NE",
    "dropmalzpp": 691469998,
    "dropsitphn": 3083552322,
    "dropsitlph": 3083552322,
    "dropsitcph": 3083552322,
    "dropfax": 3083552322
  },
  {
    "dcode": "D",
    "dropkey": "PW19924",
    "droptype": "D",
    "dropname": "LEWELLEN",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "LEWELLEN",
    "dropdelst": "NE",
    "dropdelzpp": 691473064,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "LEWELLEN",
    "dropphyst": "NE",
    "dropphyzpp": 691473064,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWELLEN",
    "dropmalst": "NE",
    "dropmalzpp": 691479998,
    "dropsitphn": 3087785444,
    "dropsitlph": 3087785444,
    "dropsitcph": 3087785444,
    "dropfax": 3087785444
  },
  {
    "dcode": "D",
    "dropkey": "PW19927",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "203 E 6TH ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "NE",
    "dropdelzpp": 688509998,
    "dropphyadd": "203 E 6TH ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "NE",
    "dropphyzpp": 688509998,
    "dropmaladd": "203 E 6TH ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "NE",
    "dropmalzpp": 688509998,
    "dropsitphn": 3083242069,
    "dropsitlph": 3083242069,
    "dropsitcph": 3083242069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19933",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "700 R ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685019998,
    "dropphyadd": "700 R ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685019998,
    "dropmaladd": "700 R ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685019998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024731668,
    "dropsitcph": 4024581844,
    "dropfax": 4024731738
  },
  {
    "dcode": "D",
    "dropkey": "PW19935",
    "droptype": "D",
    "dropname": "LINDSAY",
    "dropdeladd": "105 PINE ST",
    "dropdelcty": "LINDSAY",
    "dropdelst": "NE",
    "dropdelzpp": 686444623,
    "dropphyadd": "105 PINE ST",
    "dropphycty": "LINDSAY",
    "dropphyst": "NE",
    "dropphyzpp": 686444623,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINDSAY",
    "dropmalst": "NE",
    "dropmalzpp": 686449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024284400,
    "dropsitcph": 4024284400,
    "dropfax": 4024284400
  },
  {
    "dcode": "D",
    "dropkey": "PW19937",
    "droptype": "D",
    "dropname": "LISCO",
    "dropdeladd": "119 COLDWATER ST",
    "dropdelcty": "LISCO",
    "dropdelst": "NE",
    "dropdelzpp": 691487800,
    "dropphyadd": "119 COLDWATER ST",
    "dropphycty": "LISCO",
    "dropphyst": "NE",
    "dropphyzpp": 691487800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LISCO",
    "dropmalst": "NE",
    "dropmalzpp": 691489998,
    "dropsitphn": 3087723045,
    "dropsitlph": 3087723045,
    "dropsitcph": 3087723045,
    "dropfax": 3087723045
  },
  {
    "dcode": "D",
    "dropkey": "PW19938",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "211 N MAIN ST",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "NE",
    "dropdelzpp": 688527501,
    "dropphyadd": "211 N MAIN ST",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "NE",
    "dropphyzpp": 688527501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "NE",
    "dropmalzpp": 688529998,
    "dropsitphn": 3084462452,
    "dropsitlph": 3084462452,
    "dropsitcph": 3084462452,
    "dropfax": 3084462452
  },
  {
    "dcode": "D",
    "dropkey": "PW19940",
    "droptype": "D",
    "dropname": "LODGEPOLE",
    "dropdeladd": "724 SHELDON ST",
    "dropdelcty": "LODGEPOLE",
    "dropdelst": "NE",
    "dropdelzpp": 691499700,
    "dropphyadd": "724 SHELDON ST",
    "dropphycty": "LODGEPOLE",
    "dropphyst": "NE",
    "dropphyzpp": 691499700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LODGEPOLE",
    "dropmalst": "NE",
    "dropmalzpp": 691499998,
    "dropsitphn": 3084835576,
    "dropsitlph": 3084835576,
    "dropsitcph": 3084835576,
    "dropfax": 3084835576
  },
  {
    "dcode": "D",
    "dropkey": "PW19948",
    "droptype": "D",
    "dropname": "LONG PINE",
    "dropdeladd": "421 N MAIN ST",
    "dropdelcty": "LONG PINE",
    "dropdelst": "NE",
    "dropdelzpp": 692179739,
    "dropphyadd": "421 N MAIN ST",
    "dropphycty": "LONG PINE",
    "dropphyst": "NE",
    "dropphyzpp": 692179739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG PINE",
    "dropmalst": "NE",
    "dropmalzpp": 692179998,
    "dropsitphn": 4022734261,
    "dropsitlph": 4022734261,
    "dropsitcph": 4022734261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19949",
    "droptype": "D",
    "dropname": "LOOMIS",
    "dropdeladd": "306 COMMERCIAL ST",
    "dropdelcty": "LOOMIS",
    "dropdelst": "NE",
    "dropdelzpp": 689581820,
    "dropphyadd": "306 COMMERCIAL ST",
    "dropphycty": "LOOMIS",
    "dropphyst": "NE",
    "dropphyzpp": 689581820,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOOMIS",
    "dropmalst": "NE",
    "dropmalzpp": 689589998,
    "dropsitphn": 3088762332,
    "dropsitlph": 3088762332,
    "dropsitcph": 3088762332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19952",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "202 CHERRY ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "NE",
    "dropdelzpp": 680379998,
    "dropphyadd": "202 CHERRY ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "NE",
    "dropphyzpp": 680379998,
    "dropmaladd": "202 CHERRY ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "NE",
    "dropmalzpp": 680379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022345595,
    "dropsitcph": 4022345595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19956",
    "droptype": "D",
    "dropname": "LOUP CITY",
    "dropdeladd": "137 S 7TH ST",
    "dropdelcty": "LOUP CITY",
    "dropdelst": "NE",
    "dropdelzpp": 688538019,
    "dropphyadd": "137 S 7TH ST",
    "dropphycty": "LOUP CITY",
    "dropphyst": "NE",
    "dropphyzpp": 688538019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOUP CITY",
    "dropmalst": "NE",
    "dropmalzpp": 688539998,
    "dropsitphn": 3087450672,
    "dropsitlph": 3087450672,
    "dropsitcph": 3087450672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19960",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "314 JEFFERS AVE",
    "dropdelcty": "LYMAN",
    "dropdelst": "NE",
    "dropdelzpp": 693529700,
    "dropphyadd": "314 JEFFERS AVE",
    "dropphycty": "LYMAN",
    "dropphyst": "NE",
    "dropphyzpp": 693529700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYMAN",
    "dropmalst": "NE",
    "dropmalzpp": 693529998,
    "dropsitphn": 3087871978,
    "dropsitlph": 3087871978,
    "dropsitcph": 3087871978,
    "dropfax": 3087871978
  },
  {
    "dcode": "D",
    "dropkey": "PW19961",
    "droptype": "D",
    "dropname": "LYNCH",
    "dropdeladd": "203 N FOURTH ST",
    "dropdelcty": "LYNCH",
    "dropdelst": "NE",
    "dropdelzpp": 687469770,
    "dropphyadd": "203 N FOURTH ST",
    "dropphycty": "LYNCH",
    "dropphyst": "NE",
    "dropphyzpp": 687469770,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNCH",
    "dropmalst": "NE",
    "dropmalzpp": 687469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025693977,
    "dropsitcph": 4025693977,
    "dropfax": 4025693977
  },
  {
    "dcode": "D",
    "dropkey": "PW19963",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "165 MAIN ST",
    "dropdelcty": "LYONS",
    "dropdelst": "NE",
    "dropdelzpp": 680389701,
    "dropphyadd": "165 MAIN ST",
    "dropphycty": "LYONS",
    "dropphyst": "NE",
    "dropphyzpp": 680389701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYONS",
    "dropmalst": "NE",
    "dropmalzpp": 680389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026872494,
    "dropsitcph": 4026872494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19965",
    "droptype": "D",
    "dropname": "MACY",
    "dropdeladd": "665 SUNRISE DR",
    "dropdelcty": "MACY",
    "dropdelst": "NE",
    "dropdelzpp": 680399700,
    "dropphyadd": "665 SUNRISE DR",
    "dropphycty": "MACY",
    "dropphyst": "NE",
    "dropphyzpp": 680399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACY",
    "dropmalst": "NE",
    "dropmalzpp": 680399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028375532,
    "dropsitcph": 4028375532,
    "dropfax": 4028375532
  },
  {
    "dcode": "D",
    "dropkey": "PW19966",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "103 W 6TH ST N",
    "dropdelcty": "MADISON",
    "dropdelst": "NE",
    "dropdelzpp": 687486050,
    "dropphyadd": "103 W 6TH ST N",
    "dropphycty": "MADISON",
    "dropphyst": "NE",
    "dropphyzpp": 687486050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADISON",
    "dropmalst": "NE",
    "dropmalzpp": 687489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024542434,
    "dropsitcph": 4024542434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19967",
    "droptype": "D",
    "dropname": "MADRID",
    "dropdeladd": "119 S PERKINS AVE",
    "dropdelcty": "MADRID",
    "dropdelst": "NE",
    "dropdelzpp": 691509802,
    "dropphyadd": "119 S PERKINS AVE",
    "dropphycty": "MADRID",
    "dropphyst": "NE",
    "dropphyzpp": 691509802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADRID",
    "dropmalst": "NE",
    "dropmalzpp": 691509998,
    "dropsitphn": 3083264350,
    "dropsitlph": 3083264350,
    "dropsitcph": 3083264350,
    "dropfax": 3083264350
  },
  {
    "dcode": "D",
    "dropkey": "PW19968",
    "droptype": "D",
    "dropname": "MAGNET",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "MAGNET",
    "dropdelst": "NE",
    "dropdelzpp": 687499700,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "MAGNET",
    "dropphyst": "NE",
    "dropphyzpp": 687499700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGNET",
    "dropmalst": "NE",
    "dropmalzpp": 687499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025862200,
    "dropsitcph": 4025862200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19971",
    "droptype": "D",
    "dropname": "MALCOLM",
    "dropdeladd": "226 S LINCOLN ST",
    "dropdelcty": "MALCOLM",
    "dropdelst": "NE",
    "dropdelzpp": 684029822,
    "dropphyadd": "226 S LINCOLN ST",
    "dropphycty": "MALCOLM",
    "dropphyst": "NE",
    "dropphyzpp": 684029822,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALCOLM",
    "dropmalst": "NE",
    "dropmalzpp": 684029998,
    "dropsitphn": 4027961148,
    "dropsitlph": 4027961148,
    "dropsitcph": 4027961148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19972",
    "droptype": "D",
    "dropname": "MALMO",
    "dropdeladd": "158 CENTER AVE",
    "dropdelcty": "MALMO",
    "dropdelst": "NE",
    "dropdelzpp": 680409700,
    "dropphyadd": "158 CENTER AVE",
    "dropphycty": "MALMO",
    "dropphyst": "NE",
    "dropphyzpp": 680409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALMO",
    "dropmalst": "NE",
    "dropmalzpp": 680409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4026425413,
    "dropsitcph": 4026425413,
    "dropfax": 4026425413
  },
  {
    "dcode": "D",
    "dropkey": "PW19973",
    "droptype": "D",
    "dropname": "MANLEY",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "MANLEY",
    "dropdelst": "NE",
    "dropdelzpp": 684033000,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "MANLEY",
    "dropphyst": "NE",
    "dropphyzpp": 684033000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANLEY",
    "dropmalst": "NE",
    "dropmalzpp": 684039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4022343795,
    "dropsitcph": 4022343795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19976",
    "droptype": "D",
    "dropname": "MARQUETTE",
    "dropdeladd": "404 RAILROAD ST",
    "dropdelcty": "MARQUETTE",
    "dropdelst": "NE",
    "dropdelzpp": 688549532,
    "dropphyadd": "404 RAILROAD ST",
    "dropphycty": "MARQUETTE",
    "dropphyst": "NE",
    "dropphyzpp": 688549532,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARQUETTE",
    "dropmalst": "NE",
    "dropmalzpp": 688549998,
    "dropsitphn": 4028542598,
    "dropsitlph": 4028542598,
    "dropsitcph": 4028542598,
    "dropfax": 4028542598
  },
  {
    "dcode": "D",
    "dropkey": "PW19979",
    "droptype": "D",
    "dropname": "MARTELL",
    "dropdeladd": "17615 SW 25TH ST",
    "dropdelcty": "MARTELL",
    "dropdelst": "NE",
    "dropdelzpp": 684046185,
    "dropphyadd": "17615 SW 25TH ST",
    "dropphycty": "MARTELL",
    "dropphyst": "NE",
    "dropphyzpp": 684046185,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTELL",
    "dropmalst": "NE",
    "dropmalzpp": 684049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027946131,
    "dropsitcph": 4027946131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19983",
    "droptype": "D",
    "dropname": "MASON CITY",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MASON CITY",
    "dropdelst": "NE",
    "dropdelzpp": 688559736,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MASON CITY",
    "dropphyst": "NE",
    "dropphyzpp": 688559736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASON CITY",
    "dropmalst": "NE",
    "dropmalzpp": 688559998,
    "dropsitphn": 3087323464,
    "dropsitlph": 3087323464,
    "dropsitcph": 3087323464,
    "dropfax": 3087323464
  },
  {
    "dcode": "D",
    "dropkey": "PW19987",
    "droptype": "D",
    "dropname": "MAX",
    "dropdeladd": "240 MAIN ST",
    "dropdelcty": "MAX",
    "dropdelst": "NE",
    "dropdelzpp": 690379900,
    "dropphyadd": "240 MAIN ST",
    "dropphycty": "MAX",
    "dropphyst": "NE",
    "dropphyzpp": 690379900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAX",
    "dropmalst": "NE",
    "dropmalzpp": 690379998,
    "dropsitphn": 3084235234,
    "dropsitlph": 3084235234,
    "dropsitcph": 3084235234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19988",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "201 S PINE ST",
    "dropdelcty": "MAXWELL",
    "dropdelst": "NE",
    "dropdelzpp": 691519700,
    "dropphyadd": "201 S PINE ST",
    "dropphycty": "MAXWELL",
    "dropphyst": "NE",
    "dropphyzpp": 691519700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAXWELL",
    "dropmalst": "NE",
    "dropmalzpp": 691519998,
    "dropsitphn": 3085824612,
    "dropsitlph": 3085824612,
    "dropsitcph": 3085824612,
    "dropfax": 3085824612
  },
  {
    "dcode": "D",
    "dropkey": "PW19991",
    "droptype": "D",
    "dropname": "MAYWOOD",
    "dropdeladd": "113 S COMMERCIAL ST",
    "dropdelcty": "MAYWOOD",
    "dropdelst": "NE",
    "dropdelzpp": 690389700,
    "dropphyadd": "113 S COMMERCIAL ST",
    "dropphycty": "MAYWOOD",
    "dropphyst": "NE",
    "dropphyzpp": 690389700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYWOOD",
    "dropmalst": "NE",
    "dropmalzpp": 690389998,
    "dropsitphn": 3083624209,
    "dropsitlph": 3083624209,
    "dropsitcph": 3083624209,
    "dropfax": 3083624209
  },
  {
    "dcode": "D",
    "dropkey": "PW19993",
    "droptype": "D",
    "dropname": "MC COOK",
    "dropdeladd": "411 W 3RD ST",
    "dropdelcty": "MC COOK",
    "dropdelst": "NE",
    "dropdelzpp": 690019998,
    "dropphyadd": "411 W 3RD ST",
    "dropphycty": "MC COOK",
    "dropphyst": "NE",
    "dropphyzpp": 690019998,
    "dropmaladd": "411 W 3RD ST",
    "dropmalcty": "MC COOK",
    "dropmalst": "NE",
    "dropmalzpp": 690019998,
    "dropsitphn": 3083456590,
    "dropsitlph": 3083456590,
    "dropsitcph": 3083456590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW19995",
    "droptype": "D",
    "dropname": "MC COOL JUNCTION",
    "dropdeladd": "403 E M ST",
    "dropdelcty": "MC COOL JUNCTION",
    "dropdelst": "NE",
    "dropdelzpp": 684013013,
    "dropphyadd": "403 E M ST",
    "dropphycty": "MC COOL JUNCTION",
    "dropphyst": "NE",
    "dropphyzpp": 684013013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC COOL JUNCTION",
    "dropmalst": "NE",
    "dropmalzpp": 684019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027242333,
    "dropsitcph": 4027242333,
    "dropfax": 4027242333
  },
  {
    "dcode": "D",
    "dropkey": "PW20002",
    "droptype": "D",
    "dropname": "ABBYVILLE",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "ABBYVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 675109998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "ABBYVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 675109998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "ABBYVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 675109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202865504,
    "dropsitcph": 6202865504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20003",
    "droptype": "D",
    "dropname": "ABILENE",
    "dropdeladd": "217 N BUCKEYE AVE",
    "dropdelcty": "ABILENE",
    "dropdelst": "KS",
    "dropdelzpp": 674109998,
    "dropphyadd": "217 N BUCKEYE AVE",
    "dropphycty": "ABILENE",
    "dropphyst": "KS",
    "dropphyzpp": 674109998,
    "dropmaladd": "217 N BUCKEYE AVE",
    "dropmalcty": "ABILENE",
    "dropmalst": "KS",
    "dropmalzpp": 674109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852632691,
    "dropsitcph": 7852632691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20009",
    "droptype": "D",
    "dropname": "ADMIRE",
    "dropdeladd": "107 W 5TH ST",
    "dropdelcty": "ADMIRE",
    "dropdelst": "KS",
    "dropdelzpp": 668309998,
    "dropphyadd": "107 W 5TH ST",
    "dropphycty": "ADMIRE",
    "dropphyst": "KS",
    "dropphyzpp": 668309998,
    "dropmaladd": "107 W 5TH ST",
    "dropmalcty": "ADMIRE",
    "dropmalst": "KS",
    "dropmalzpp": 668309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205283312,
    "dropsitcph": 6205283312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20013",
    "droptype": "D",
    "dropname": "AGRA",
    "dropdeladd": "317 MAIN ST",
    "dropdelcty": "AGRA",
    "dropdelst": "KS",
    "dropdelzpp": 676219998,
    "dropphyadd": "317 MAIN ST",
    "dropphycty": "AGRA",
    "dropphyst": "KS",
    "dropphyzpp": 676219998,
    "dropmaladd": "317 MAIN ST",
    "dropmalcty": "AGRA",
    "dropmalst": "KS",
    "dropmalzpp": 676219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856382885,
    "dropsitcph": 7856382885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20019",
    "droptype": "D",
    "dropname": "ALBERT",
    "dropdeladd": "2004 MAIN ST",
    "dropdelcty": "ALBERT",
    "dropdelst": "KS",
    "dropdelzpp": 675119700,
    "dropphyadd": "2004 MAIN ST",
    "dropphycty": "ALBERT",
    "dropphyst": "KS",
    "dropphyzpp": 675119700,
    "dropmaladd": "2004 MAIN ST",
    "dropmalcty": "ALBERT",
    "dropmalst": "KS",
    "dropmalzpp": 675119700,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209234699,
    "dropsitcph": 6209234699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20021",
    "droptype": "D",
    "dropname": "ALDEN",
    "dropdeladd": "204 PIONEER ST",
    "dropdelcty": "ALDEN",
    "dropdelst": "KS",
    "dropdelzpp": 675129998,
    "dropphyadd": "204 PIONEER ST",
    "dropphycty": "ALDEN",
    "dropphyst": "KS",
    "dropphyzpp": 675129998,
    "dropmaladd": "204 PIONEER ST",
    "dropmalcty": "ALDEN",
    "dropmalst": "KS",
    "dropmalzpp": 675129998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205343225,
    "dropsitcph": 6205343225,
    "dropfax": 6205343225
  },
  {
    "dcode": "D",
    "dropkey": "PW20024",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "103 MAIN ST",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "KS",
    "dropdelzpp": 675139998,
    "dropphyadd": "103 MAIN ST",
    "dropphycty": "ALEXANDER",
    "dropphyst": "KS",
    "dropphyzpp": 675139998,
    "dropmaladd": "103 MAIN ST",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "KS",
    "dropmalzpp": 675139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853432291,
    "dropsitcph": 7853432291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20026",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "ALLEN",
    "dropdelst": "KS",
    "dropdelzpp": 668339998,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "ALLEN",
    "dropphyst": "KS",
    "dropphyzpp": 668339998,
    "dropmaladd": "402 MAIN ST",
    "dropmalcty": "ALLEN",
    "dropmalst": "KS",
    "dropmalzpp": 668339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205283212,
    "dropsitcph": 6205283212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20028",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "320 MISSOURI AVE",
    "dropdelcty": "ALMA",
    "dropdelst": "KS",
    "dropdelzpp": 664019998,
    "dropphyadd": "320 MISSOURI AVE",
    "dropphycty": "ALMA",
    "dropphyst": "KS",
    "dropphyzpp": 664019998,
    "dropmaladd": "320 MISSOURI AVE",
    "dropmalcty": "ALMA",
    "dropmalst": "KS",
    "dropmalzpp": 664019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857653423,
    "dropsitcph": 7857653423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20030",
    "droptype": "D",
    "dropname": "ALMENA",
    "dropdeladd": "503 MAIN ST",
    "dropdelcty": "ALMENA",
    "dropdelst": "KS",
    "dropdelzpp": 676229998,
    "dropphyadd": "503 MAIN ST",
    "dropphycty": "ALMENA",
    "dropphyst": "KS",
    "dropphyzpp": 676229998,
    "dropmaladd": "503 MAIN ST",
    "dropmalcty": "ALMENA",
    "dropmalst": "KS",
    "dropmalzpp": 676229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856692567,
    "dropsitcph": 7856692567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20032",
    "droptype": "D",
    "dropname": "ALTA VISTA",
    "dropdeladd": "618 MAIN ST",
    "dropdelcty": "ALTA VISTA",
    "dropdelst": "KS",
    "dropdelzpp": 668349998,
    "dropphyadd": "618 MAIN ST",
    "dropphycty": "ALTA VISTA",
    "dropphyst": "KS",
    "dropphyzpp": 668349998,
    "dropmaladd": "618 MAIN ST",
    "dropmalcty": "ALTA VISTA",
    "dropmalst": "KS",
    "dropmalzpp": 668349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854996342,
    "dropsitcph": 7854996342,
    "dropfax": 7854996342
  },
  {
    "dcode": "D",
    "dropkey": "PW20033",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "410 S HUSTON ST",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "KS",
    "dropdelzpp": 673309998,
    "dropphyadd": "410 S HUSTON ST",
    "dropphycty": "ALTAMONT",
    "dropphyst": "KS",
    "dropphyzpp": 673309998,
    "dropmaladd": "410 S HUSTON ST",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "KS",
    "dropmalzpp": 673309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207845831,
    "dropsitcph": 6207845831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20034",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "703 MILL ST STE B",
    "dropdelcty": "ALTON",
    "dropdelst": "KS",
    "dropdelzpp": 676239748,
    "dropphyadd": "703 MILL ST STE B",
    "dropphycty": "ALTON",
    "dropphyst": "KS",
    "dropphyzpp": 676239748,
    "dropmaladd": "703 MILL ST STE B",
    "dropmalcty": "ALTON",
    "dropmalst": "KS",
    "dropmalzpp": 676239748,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859842202,
    "dropsitcph": 7859842202,
    "dropfax": 7859842202
  },
  {
    "dcode": "D",
    "dropkey": "PW20035",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "732 MAIN ST",
    "dropdelcty": "ALTOONA",
    "dropdelst": "KS",
    "dropdelzpp": 667109998,
    "dropphyadd": "732 MAIN ST",
    "dropphycty": "ALTOONA",
    "dropphyst": "KS",
    "dropphyzpp": 667109998,
    "dropmaladd": "732 MAIN ST",
    "dropmalcty": "ALTOONA",
    "dropmalst": "KS",
    "dropmalzpp": 667109998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6205682645,
    "dropsitcph": 6205682645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20037",
    "droptype": "D",
    "dropname": "AMERICUS",
    "dropdeladd": "611 MAIN ST",
    "dropdelcty": "AMERICUS",
    "dropdelst": "KS",
    "dropdelzpp": 668359998,
    "dropphyadd": "611 MAIN ST",
    "dropphycty": "AMERICUS",
    "dropphyst": "KS",
    "dropphyzpp": 668359998,
    "dropmaladd": "611 MAIN ST",
    "dropmalcty": "AMERICUS",
    "dropmalst": "KS",
    "dropmalzpp": 668359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204435333,
    "dropsitcph": 6204435333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20041",
    "droptype": "D",
    "dropname": "ANDALE",
    "dropdeladd": "318 N MAIN ST",
    "dropdelcty": "ANDALE",
    "dropdelst": "KS",
    "dropdelzpp": 670019998,
    "dropphyadd": "318 N MAIN ST",
    "dropphycty": "ANDALE",
    "dropphyst": "KS",
    "dropphyzpp": 670019998,
    "dropmaladd": "318 N MAIN ST",
    "dropmalcty": "ANDALE",
    "dropmalst": "KS",
    "dropmalzpp": 670019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3164452561,
    "dropsitcph": 3164452561,
    "dropfax": 3164452561
  },
  {
    "dcode": "D",
    "dropkey": "PW20042",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "211 N ANDOVER RD",
    "dropdelcty": "ANDOVER",
    "dropdelst": "KS",
    "dropdelzpp": 670029998,
    "dropphyadd": "211 N ANDOVER RD",
    "dropphycty": "ANDOVER",
    "dropphyst": "KS",
    "dropphyzpp": 670029998,
    "dropmaladd": "211 N ANDOVER RD",
    "dropmalcty": "ANDOVER",
    "dropmalst": "KS",
    "dropmalzpp": 670029998,
    "dropsitphn": 3163470617,
    "dropsitlph": 3163472987,
    "dropsitcph": 3167330617,
    "dropfax": 3167332989
  },
  {
    "dcode": "D",
    "dropkey": "PW20049",
    "droptype": "D",
    "dropname": "ANTHONY",
    "dropdeladd": "121 W STEADMAN ST",
    "dropdelcty": "ANTHONY",
    "dropdelst": "KS",
    "dropdelzpp": 670039998,
    "dropphyadd": "121 W STEADMAN ST",
    "dropphycty": "ANTHONY",
    "dropphyst": "KS",
    "dropphyzpp": 670039998,
    "dropmaladd": "121 W STEADMAN ST",
    "dropmalcty": "ANTHONY",
    "dropmalst": "KS",
    "dropmalzpp": 670039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208425239,
    "dropsitcph": 6208425239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20051",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "209 E RACE ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "KS",
    "dropdelzpp": 667119998,
    "dropphyadd": "209 E RACE ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "KS",
    "dropphyzpp": 667119998,
    "dropmaladd": "209 E RACE ST",
    "dropmalcty": "ARCADIA",
    "dropmalst": "KS",
    "dropmalzpp": 667119998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6206384293,
    "dropsitcph": 6206384293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20055",
    "droptype": "D",
    "dropname": "ARGONIA",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "ARGONIA",
    "dropdelst": "KS",
    "dropdelzpp": 670049998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "ARGONIA",
    "dropphyst": "KS",
    "dropphyzpp": 670049998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "ARGONIA",
    "dropmalst": "KS",
    "dropmalzpp": 670049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204356872,
    "dropsitcph": 6204356872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20058",
    "droptype": "D",
    "dropname": "ARKANSAS CITY",
    "dropdeladd": "210 E WASHINGTON AVE",
    "dropdelcty": "ARKANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 670059998,
    "dropphyadd": "210 E WASHINGTON AVE",
    "dropphycty": "ARKANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 670059998,
    "dropmaladd": "210 E WASHINGTON AVE",
    "dropmalcty": "ARKANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 670059998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204421080,
    "dropsitcph": 6204421080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20061",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 675149998,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 675149998,
    "dropmaladd": "111 W MAIN ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 675149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205382016,
    "dropsitcph": 6205382016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20062",
    "droptype": "D",
    "dropname": "ARMA",
    "dropdeladd": "606 E WASHINGTON ST",
    "dropdelcty": "ARMA",
    "dropdelst": "KS",
    "dropdelzpp": 667129998,
    "dropphyadd": "606 E WASHINGTON ST",
    "dropphycty": "ARMA",
    "dropphyst": "KS",
    "dropphyzpp": 667129998,
    "dropmaladd": "606 E WASHINGTON ST",
    "dropmalcty": "ARMA",
    "dropmalst": "KS",
    "dropmalzpp": 667129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203474160,
    "dropsitcph": 6203474160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20069",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "710 MAIN ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "KS",
    "dropdelzpp": 678319998,
    "dropphyadd": "710 MAIN ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "KS",
    "dropphyzpp": 678319998,
    "dropmaladd": "710 MAIN ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "KS",
    "dropmalzpp": 678319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206352616,
    "dropsitcph": 6206352616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20073",
    "droptype": "D",
    "dropname": "ASSARIA",
    "dropdeladd": "116 S CENTER ST",
    "dropdelcty": "ASSARIA",
    "dropdelst": "KS",
    "dropdelzpp": 674169998,
    "dropphyadd": "116 S CENTER ST",
    "dropphycty": "ASSARIA",
    "dropphyst": "KS",
    "dropphyzpp": 674169998,
    "dropmaladd": "116 S CENTER ST",
    "dropmalcty": "ASSARIA",
    "dropmalst": "KS",
    "dropmalzpp": 674169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856673455,
    "dropsitcph": 7856673455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20074",
    "droptype": "D",
    "dropname": "ATCHISON",
    "dropdeladd": "621 KANSAS AVE",
    "dropdelcty": "ATCHISON",
    "dropdelst": "KS",
    "dropdelzpp": 660029998,
    "dropphyadd": "621 KANSAS AVE",
    "dropphycty": "ATCHISON",
    "dropphyst": "KS",
    "dropphyzpp": 660029998,
    "dropmaladd": "621 KANSAS AVE",
    "dropmalcty": "ATCHISON",
    "dropmalst": "KS",
    "dropmalzpp": 660029998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9133676303,
    "dropsitcph": 9133676303,
    "dropfax": 6505784260
  },
  {
    "dcode": "D",
    "dropkey": "PW20079",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "KS",
    "dropdelzpp": 670089998,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "KS",
    "dropphyzpp": 670089998,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "KS",
    "dropmalzpp": 670089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203942306,
    "dropsitcph": 6203942306,
    "dropfax": 6203942306
  },
  {
    "dcode": "D",
    "dropkey": "PW20080",
    "droptype": "D",
    "dropname": "ATTICA",
    "dropdeladd": "136 N MAIN ST",
    "dropdelcty": "ATTICA",
    "dropdelst": "KS",
    "dropdelzpp": 670099998,
    "dropphyadd": "136 N MAIN ST",
    "dropphycty": "ATTICA",
    "dropphyst": "KS",
    "dropphyzpp": 670099998,
    "dropmaladd": "136 N MAIN ST",
    "dropmalcty": "ATTICA",
    "dropmalst": "KS",
    "dropmalzpp": 670099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202547908,
    "dropsitcph": 6202547908,
    "dropfax": 6202547908
  },
  {
    "dcode": "D",
    "dropkey": "PW20081",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "ATWOOD",
    "dropdelst": "KS",
    "dropdelzpp": 677309998,
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "ATWOOD",
    "dropphyst": "KS",
    "dropphyzpp": 677309998,
    "dropmaladd": "501 MAIN ST",
    "dropmalcty": "ATWOOD",
    "dropmalst": "KS",
    "dropmalzpp": 677309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856263841,
    "dropsitcph": 7856263841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20083",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "110 W 9TH ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "KS",
    "dropdelzpp": 664029998,
    "dropphyadd": "110 W 9TH ST",
    "dropphycty": "AUBURN",
    "dropphyst": "KS",
    "dropphyzpp": 664029998,
    "dropmaladd": "110 W 9TH ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "KS",
    "dropmalzpp": 664029998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852562793,
    "dropsitcph": 7852562793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20084",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "119 E 5TH AVE",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "KS",
    "dropdelzpp": 670109998,
    "dropphyadd": "119 E 5TH AVE",
    "dropphycty": "AUGUSTA",
    "dropphyst": "KS",
    "dropphyzpp": 670109998,
    "dropmaladd": "119 E 5TH AVE",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "KS",
    "dropmalzpp": 670109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167756141,
    "dropsitcph": 3167756141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20087",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "AURORA",
    "dropdelst": "KS",
    "dropdelzpp": 674179998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "AURORA",
    "dropphyst": "KS",
    "dropphyzpp": 674179998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "AURORA",
    "dropmalst": "KS",
    "dropmalzpp": 674179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854643604,
    "dropsitcph": 7854643604,
    "dropfax": 7854643604
  },
  {
    "dcode": "D",
    "dropkey": "PW20090",
    "droptype": "D",
    "dropname": "AXTELL",
    "dropdeladd": "206 5TH ST",
    "dropdelcty": "AXTELL",
    "dropdelst": "KS",
    "dropdelzpp": 664039998,
    "dropphyadd": "206 5TH ST",
    "dropphycty": "AXTELL",
    "dropphyst": "KS",
    "dropphyzpp": 664039998,
    "dropmaladd": "206 5TH ST",
    "dropmalcty": "AXTELL",
    "dropmalst": "KS",
    "dropmalzpp": 664039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857362726,
    "dropsitcph": 7857362726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20092",
    "droptype": "D",
    "dropname": "BAILEYVILLE",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "BAILEYVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 664049412,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "BAILEYVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 664049412,
    "dropmaladd": "215 MAIN ST",
    "dropmalcty": "BAILEYVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 664049412,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853366652,
    "dropsitcph": 7853366652,
    "dropfax": 7853366652
  },
  {
    "dcode": "D",
    "dropkey": "PW20097",
    "droptype": "D",
    "dropname": "BALDWIN CITY",
    "dropdeladd": "702 HIGH ST",
    "dropdelcty": "BALDWIN CITY",
    "dropdelst": "KS",
    "dropdelzpp": 660069998,
    "dropphyadd": "702 HIGH ST",
    "dropphycty": "BALDWIN CITY",
    "dropphyst": "KS",
    "dropphyzpp": 660069998,
    "dropmaladd": "702 HIGH ST",
    "dropmalcty": "BALDWIN CITY",
    "dropmalst": "KS",
    "dropmalzpp": 660069998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855946561,
    "dropsitcph": 7855946561,
    "dropfax": 7855946584
  },
  {
    "dcode": "D",
    "dropkey": "PW20106",
    "droptype": "D",
    "dropname": "BARNARD",
    "dropdeladd": "316 MAIN ST",
    "dropdelcty": "BARNARD",
    "dropdelst": "KS",
    "dropdelzpp": 674189998,
    "dropphyadd": "316 MAIN ST",
    "dropphycty": "BARNARD",
    "dropphyst": "KS",
    "dropphyzpp": 674189998,
    "dropmaladd": "316 MAIN ST",
    "dropmalcty": "BARNARD",
    "dropmalst": "KS",
    "dropmalzpp": 674189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857926266,
    "dropsitcph": 7857926266,
    "dropfax": 7857926266
  },
  {
    "dcode": "D",
    "dropkey": "PW20107",
    "droptype": "D",
    "dropname": "BARNES",
    "dropdeladd": "20 N CENTER ST",
    "dropdelcty": "BARNES",
    "dropdelst": "KS",
    "dropdelzpp": 669334109,
    "dropphyadd": "20 N CENTER ST",
    "dropphycty": "BARNES",
    "dropphyst": "KS",
    "dropphyzpp": 669334109,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNES",
    "dropmalst": "KS",
    "dropmalzpp": 669339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857634321,
    "dropsitcph": 7857634321,
    "dropfax": 7857634321
  },
  {
    "dcode": "D",
    "dropkey": "PW20112",
    "droptype": "D",
    "dropname": "BASEHOR",
    "dropdeladd": "2402 N 155TH ST",
    "dropdelcty": "BASEHOR",
    "dropdelst": "KS",
    "dropdelzpp": 660079998,
    "dropphyadd": "2402 N 155TH ST",
    "dropphycty": "BASEHOR",
    "dropphyst": "KS",
    "dropphyzpp": 660079998,
    "dropmaladd": "2402 N 155TH ST",
    "dropmalcty": "BASEHOR",
    "dropmalst": "KS",
    "dropmalzpp": 660079998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137242248,
    "dropsitcph": 9137242248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20119",
    "droptype": "D",
    "dropname": "BAXTER SPRINGS",
    "dropdeladd": "1115 PARK AVE",
    "dropdelcty": "BAXTER SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 667139998,
    "dropphyadd": "1115 PARK AVE",
    "dropphycty": "BAXTER SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 667139998,
    "dropmaladd": "1115 PARK AVE",
    "dropmalcty": "BAXTER SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 667139998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6208565814,
    "dropsitcph": 6208565800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20125",
    "droptype": "D",
    "dropname": "BAZINE",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "BAZINE",
    "dropdelst": "KS",
    "dropdelzpp": 675169633,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "BAZINE",
    "dropphyst": "KS",
    "dropphyzpp": 675169633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAZINE",
    "dropmalst": "KS",
    "dropmalzpp": 675169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853982461,
    "dropsitcph": 7853982461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20126",
    "droptype": "D",
    "dropname": "BEATTIE",
    "dropdeladd": "302 CENTER ST",
    "dropdelcty": "BEATTIE",
    "dropdelst": "KS",
    "dropdelzpp": 664069998,
    "dropphyadd": "302 CENTER ST",
    "dropphycty": "BEATTIE",
    "dropphyst": "KS",
    "dropphyzpp": 664069998,
    "dropmaladd": "302 CENTER ST",
    "dropmalcty": "BEATTIE",
    "dropmalst": "KS",
    "dropmalzpp": 664069998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853532341,
    "dropsitcph": 7853532341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20136",
    "droptype": "D",
    "dropname": "BELLE PLAINE",
    "dropdeladd": "434 N MERCHANT ST",
    "dropdelcty": "BELLE PLAINE",
    "dropdelst": "KS",
    "dropdelzpp": 670139998,
    "dropphyadd": "434 N MERCHANT ST",
    "dropphycty": "BELLE PLAINE",
    "dropphyst": "KS",
    "dropphyzpp": 670139998,
    "dropmaladd": "434 N MERCHANT ST",
    "dropmalcty": "BELLE PLAINE",
    "dropmalst": "KS",
    "dropmalzpp": 670139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204883528,
    "dropsitcph": 6204883528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20139",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "1119 18TH ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 669359998,
    "dropphyadd": "1119 18TH ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 669359998,
    "dropmaladd": "1119 18TH ST",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 669359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855272421,
    "dropsitcph": 7855272421,
    "dropfax": 7855272421
  },
  {
    "dcode": "D",
    "dropkey": "PW20141",
    "droptype": "D",
    "dropname": "BELOIT",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "BELOIT",
    "dropdelst": "KS",
    "dropdelzpp": 674209998,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "BELOIT",
    "dropphyst": "KS",
    "dropphyzpp": 674209998,
    "dropmaladd": "201 E MAIN ST",
    "dropmalcty": "BELOIT",
    "dropmalst": "KS",
    "dropmalzpp": 674209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857385151,
    "dropsitcph": 7857385151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20142",
    "droptype": "D",
    "dropname": "BELPRE",
    "dropdeladd": "506 DUDLEY ST",
    "dropdelcty": "BELPRE",
    "dropdelst": "KS",
    "dropdelzpp": 675199500,
    "dropphyadd": "506 DUDLEY ST",
    "dropphycty": "BELPRE",
    "dropphyst": "KS",
    "dropphyzpp": 675199500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELPRE",
    "dropmalst": "KS",
    "dropmalzpp": 675199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209954921,
    "dropsitcph": 6209954921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20144",
    "droptype": "D",
    "dropname": "BELVUE",
    "dropdeladd": "307 3RD ST",
    "dropdelcty": "BELVUE",
    "dropdelst": "KS",
    "dropdelzpp": 664079998,
    "dropphyadd": "307 3RD ST",
    "dropphycty": "BELVUE",
    "dropphyst": "KS",
    "dropphyzpp": 664079998,
    "dropmaladd": "307 3RD ST",
    "dropmalcty": "BELVUE",
    "dropmalst": "KS",
    "dropmalzpp": 664079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854567940,
    "dropsitcph": 7854567940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20145",
    "droptype": "D",
    "dropname": "BENDENA",
    "dropdeladd": "206 COMMERCIAL ST",
    "dropdelcty": "BENDENA",
    "dropdelst": "KS",
    "dropdelzpp": 660089998,
    "dropphyadd": "206 COMMERCIAL ST",
    "dropphycty": "BENDENA",
    "dropphyst": "KS",
    "dropphyzpp": 660089998,
    "dropmaladd": "206 COMMERCIAL ST",
    "dropmalcty": "BENDENA",
    "dropmalst": "KS",
    "dropmalzpp": 660089998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855719601,
    "dropsitcph": 7855719601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20147",
    "droptype": "D",
    "dropname": "BENEDICT",
    "dropdeladd": "505 MAIN ST",
    "dropdelcty": "BENEDICT",
    "dropdelst": "KS",
    "dropdelzpp": 667149998,
    "dropphyadd": "505 MAIN ST",
    "dropphycty": "BENEDICT",
    "dropphyst": "KS",
    "dropphyzpp": 667149998,
    "dropmaladd": "505 MAIN ST",
    "dropmalcty": "BENEDICT",
    "dropmalst": "KS",
    "dropmalzpp": 667149998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6206983941,
    "dropsitcph": 6206983941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20149",
    "droptype": "D",
    "dropname": "BENNINGTON",
    "dropdeladd": "116 N NELSON ST",
    "dropdelcty": "BENNINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 674229998,
    "dropphyadd": "116 N NELSON ST",
    "dropphycty": "BENNINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 674229998,
    "dropmaladd": "116 N NELSON ST",
    "dropmalcty": "BENNINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 674229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854882244,
    "dropsitcph": 7854882244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20150",
    "droptype": "D",
    "dropname": "BENTLEY",
    "dropdeladd": "140 S WICHITA ST",
    "dropdelcty": "BENTLEY",
    "dropdelst": "KS",
    "dropdelzpp": 670169998,
    "dropphyadd": "140 S WICHITA ST",
    "dropphycty": "BENTLEY",
    "dropphyst": "KS",
    "dropphyzpp": 670169998,
    "dropmaladd": "140 S WICHITA ST",
    "dropmalcty": "BENTLEY",
    "dropmalst": "KS",
    "dropmalzpp": 670169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167960222,
    "dropsitcph": 3167960222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20151",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "135 S MAIN ST",
    "dropdelcty": "BENTON",
    "dropdelst": "KS",
    "dropdelzpp": 670179998,
    "dropphyadd": "135 S MAIN ST",
    "dropphycty": "BENTON",
    "dropphyst": "KS",
    "dropphyzpp": 670179998,
    "dropmaladd": "135 S MAIN ST",
    "dropmalcty": "BENTON",
    "dropmalst": "KS",
    "dropmalzpp": 670179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167781071,
    "dropsitcph": 3167781071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20152",
    "droptype": "D",
    "dropname": "BERN",
    "dropdeladd": "403 MAIN ST",
    "dropdelcty": "BERN",
    "dropdelst": "KS",
    "dropdelzpp": 664089998,
    "dropphyadd": "403 MAIN ST",
    "dropphycty": "BERN",
    "dropphyst": "KS",
    "dropphyzpp": 664089998,
    "dropmaladd": "403 MAIN ST",
    "dropmalcty": "BERN",
    "dropmalst": "KS",
    "dropmalzpp": 664089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853366160,
    "dropsitcph": 7853366160,
    "dropfax": 7853366160
  },
  {
    "dcode": "D",
    "dropkey": "PW20153",
    "droptype": "D",
    "dropname": "BERRYTON",
    "dropdeladd": "7049 SE BERRYTON RD",
    "dropdelcty": "BERRYTON",
    "dropdelst": "KS",
    "dropdelzpp": 664099998,
    "dropphyadd": "7049 SE BERRYTON RD",
    "dropphycty": "BERRYTON",
    "dropphyst": "KS",
    "dropphyzpp": 664099998,
    "dropmaladd": "7049 SE BERRYTON RD",
    "dropmalcty": "BERRYTON",
    "dropmalst": "KS",
    "dropmalzpp": 664099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858621038,
    "dropsitcph": 7858621038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20158",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "KS",
    "dropdelzpp": 674239998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "KS",
    "dropphyzpp": 674239998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "BEVERLY",
    "dropmalst": "KS",
    "dropmalzpp": 674239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854362474,
    "dropsitcph": 7854362474,
    "dropfax": 7854362474
  },
  {
    "dcode": "D",
    "dropkey": "PW20164",
    "droptype": "D",
    "dropname": "BIRD CITY",
    "dropdeladd": "117 W BRESSLER",
    "dropdelcty": "BIRD CITY",
    "dropdelst": "KS",
    "dropdelzpp": 677319796,
    "dropphyadd": "117 W BRESSLER",
    "dropphycty": "BIRD CITY",
    "dropphyst": "KS",
    "dropphyzpp": 677319796,
    "dropmaladd": "117 W BRESSLER",
    "dropmalcty": "BIRD CITY",
    "dropmalst": "KS",
    "dropmalzpp": 677319796,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857342251,
    "dropsitcph": 7857342251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20165",
    "droptype": "D",
    "dropname": "BISON",
    "dropdeladd": "219 MAIN ST",
    "dropdelcty": "BISON",
    "dropdelst": "KS",
    "dropdelzpp": 675209998,
    "dropphyadd": "219 MAIN ST",
    "dropphycty": "BISON",
    "dropphyst": "KS",
    "dropphyzpp": 675209998,
    "dropmaladd": "219 MAIN ST",
    "dropmalcty": "BISON",
    "dropmalst": "KS",
    "dropmalzpp": 675209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853562135,
    "dropsitcph": 7853562135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20183",
    "droptype": "D",
    "dropname": "BLUE MOUND",
    "dropdeladd": "409 E MAIN ST",
    "dropdelcty": "BLUE MOUND",
    "dropdelst": "KS",
    "dropdelzpp": 660109998,
    "dropphyadd": "409 E MAIN ST",
    "dropphycty": "BLUE MOUND",
    "dropphyst": "KS",
    "dropphyzpp": 660109998,
    "dropmaladd": "409 E MAIN ST",
    "dropmalcty": "BLUE MOUND",
    "dropmalst": "KS",
    "dropmalzpp": 660109998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137562240,
    "dropsitcph": 9137562240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20184",
    "droptype": "D",
    "dropname": "BLUE RAPIDS",
    "dropdeladd": "22 PUBLIC SQ",
    "dropdelcty": "BLUE RAPIDS",
    "dropdelst": "KS",
    "dropdelzpp": 664119998,
    "dropphyadd": "22 PUBLIC SQ",
    "dropphycty": "BLUE RAPIDS",
    "dropphyst": "KS",
    "dropphyzpp": 664119998,
    "dropmaladd": "22 PUBLIC SQ",
    "dropmalcty": "BLUE RAPIDS",
    "dropmalst": "KS",
    "dropmalzpp": 664119998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853637921,
    "dropsitcph": 7853637921,
    "dropfax": 7853637921
  },
  {
    "dcode": "D",
    "dropkey": "PW20187",
    "droptype": "D",
    "dropname": "BLUFF CITY",
    "dropdeladd": "621 CENTRAL AVE",
    "dropdelcty": "BLUFF CITY",
    "dropdelst": "KS",
    "dropdelzpp": 670189998,
    "dropphyadd": "621 CENTRAL AVE",
    "dropphycty": "BLUFF CITY",
    "dropphyst": "KS",
    "dropphyzpp": 670189998,
    "dropmaladd": "621 CENTRAL AVE",
    "dropmalcty": "BLUFF CITY",
    "dropmalst": "KS",
    "dropmalzpp": 670189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209674421,
    "dropsitcph": 6209674421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20191",
    "droptype": "D",
    "dropname": "BOGUE",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "BOGUE",
    "dropdelst": "KS",
    "dropdelzpp": 676259998,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "BOGUE",
    "dropphyst": "KS",
    "dropphyzpp": 676259998,
    "dropmaladd": "410 MAIN ST",
    "dropmalcty": "BOGUE",
    "dropmalst": "KS",
    "dropmalzpp": 676259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854212579,
    "dropsitcph": 7854212579,
    "dropfax": 7854212579
  },
  {
    "dcode": "D",
    "dropkey": "PW20193",
    "droptype": "D",
    "dropname": "BONNER SPRINGS",
    "dropdeladd": "135 CEDAR AVE",
    "dropdelcty": "BONNER SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 660129998,
    "dropphyadd": "135 CEDAR AVE",
    "dropphycty": "BONNER SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 660129998,
    "dropmaladd": "135 CEDAR AVE",
    "dropmalcty": "BONNER SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 660129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9134415265,
    "dropsitcph": 9134412199,
    "dropfax": 9134416389
  },
  {
    "dcode": "D",
    "dropkey": "PW20214",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "107 BRENNEKE",
    "dropdelcty": "BREMEN",
    "dropdelst": "KS",
    "dropdelzpp": 664129998,
    "dropphyadd": "107 BRENNEKE",
    "dropphycty": "BREMEN",
    "dropphyst": "KS",
    "dropphyzpp": 664129998,
    "dropmaladd": "107 BRENNEKE",
    "dropmalcty": "BREMEN",
    "dropmalst": "KS",
    "dropmalzpp": 664129998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853372602,
    "dropsitcph": 7853372602,
    "dropfax": 7853372602
  },
  {
    "dcode": "D",
    "dropkey": "PW20216",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "329 KANSAS AVE",
    "dropdelcty": "BREWSTER",
    "dropdelst": "KS",
    "dropdelzpp": 677329998,
    "dropphyadd": "329 KANSAS AVE",
    "dropphycty": "BREWSTER",
    "dropphyst": "KS",
    "dropphyzpp": 677329998,
    "dropmaladd": "329 KANSAS AVE",
    "dropmalcty": "BREWSTER",
    "dropmalst": "KS",
    "dropmalzpp": 677329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856942703,
    "dropsitcph": 7856942703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20220",
    "droptype": "D",
    "dropname": "BRONSON",
    "dropdeladd": "520 CLAY ST",
    "dropdelcty": "BRONSON",
    "dropdelst": "KS",
    "dropdelzpp": 667169998,
    "dropphyadd": "520 CLAY ST",
    "dropphycty": "BRONSON",
    "dropphyst": "KS",
    "dropphyzpp": 667169998,
    "dropmaladd": "520 CLAY ST",
    "dropmalcty": "BRONSON",
    "dropmalst": "KS",
    "dropmalzpp": 667169998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6209394733,
    "dropsitcph": 6209394733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20222",
    "droptype": "D",
    "dropname": "BROOKVILLE",
    "dropdeladd": "112 E ANDERSON ST",
    "dropdelcty": "BROOKVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 674259998,
    "dropphyadd": "112 E ANDERSON ST",
    "dropphycty": "BROOKVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 674259998,
    "dropmaladd": "112 E ANDERSON ST",
    "dropmalcty": "BROOKVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 674259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852256717,
    "dropsitcph": 7852256717,
    "dropfax": 7852256717
  },
  {
    "dcode": "D",
    "dropkey": "PW20225",
    "droptype": "D",
    "dropname": "BROWNELL",
    "dropdeladd": "100 W STATE ROAD 4",
    "dropdelcty": "BROWNELL",
    "dropdelst": "KS",
    "dropdelzpp": 675219500,
    "dropphyadd": "100 W STATE ROAD 4",
    "dropphycty": "BROWNELL",
    "dropphyst": "KS",
    "dropphyzpp": 675219500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNELL",
    "dropmalst": "KS",
    "dropmalzpp": 675219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854812211,
    "dropsitcph": 7854812211,
    "dropfax": 7854812211
  },
  {
    "dcode": "D",
    "dropkey": "PW20231",
    "droptype": "D",
    "dropname": "BUCKLIN",
    "dropdeladd": "107 S MAIN ST",
    "dropdelcty": "BUCKLIN",
    "dropdelst": "KS",
    "dropdelzpp": 678349998,
    "dropphyadd": "107 S MAIN ST",
    "dropphycty": "BUCKLIN",
    "dropphyst": "KS",
    "dropphyzpp": 678349998,
    "dropmaladd": "107 S MAIN ST",
    "dropmalcty": "BUCKLIN",
    "dropmalst": "KS",
    "dropmalzpp": 678349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208263516,
    "dropsitcph": 6208263516,
    "dropfax": 6208263516
  },
  {
    "dcode": "D",
    "dropkey": "PW20232",
    "droptype": "D",
    "dropname": "BUCYRUS",
    "dropdeladd": "112 4TH AVE",
    "dropdelcty": "BUCYRUS",
    "dropdelst": "KS",
    "dropdelzpp": 660139998,
    "dropphyadd": "112 4TH AVE",
    "dropphycty": "BUCYRUS",
    "dropphyst": "KS",
    "dropphyzpp": 660139998,
    "dropmaladd": "112 4TH AVE",
    "dropmalcty": "BUCYRUS",
    "dropmalst": "KS",
    "dropmalzpp": 660139998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138792307,
    "dropsitcph": 9138792307,
    "dropfax": 9138792377
  },
  {
    "dcode": "D",
    "dropkey": "PW20233",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "308 N MAIN ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "KS",
    "dropdelzpp": 667179998,
    "dropphyadd": "308 N MAIN ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "KS",
    "dropphyzpp": 667179998,
    "dropmaladd": "308 N MAIN ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "KS",
    "dropmalzpp": 667179998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6205372705,
    "dropsitcph": 6205372705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20236",
    "droptype": "D",
    "dropname": "BUHLER",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "BUHLER",
    "dropdelst": "KS",
    "dropdelzpp": 675229998,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "BUHLER",
    "dropphyst": "KS",
    "dropphyzpp": 675229998,
    "dropmaladd": "106 N MAIN ST",
    "dropmalcty": "BUHLER",
    "dropmalst": "KS",
    "dropmalzpp": 675229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205432703,
    "dropsitcph": 6205432703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20237",
    "droptype": "D",
    "dropname": "BUNKER HILL",
    "dropdeladd": "563 ELM ST",
    "dropdelcty": "BUNKER HILL",
    "dropdelst": "KS",
    "dropdelzpp": 676269445,
    "dropphyadd": "563 ELM ST",
    "dropphycty": "BUNKER HILL",
    "dropphyst": "KS",
    "dropphyzpp": 676269445,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUNKER HILL",
    "dropmalst": "KS",
    "dropmalzpp": 676269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854836816,
    "dropsitcph": 7854836816,
    "dropfax": 7854836816
  },
  {
    "dcode": "D",
    "dropkey": "PW20239",
    "droptype": "D",
    "dropname": "BURDEN",
    "dropdeladd": "417 N MAIN ST",
    "dropdelcty": "BURDEN",
    "dropdelst": "KS",
    "dropdelzpp": 670198806,
    "dropphyadd": "417 N MAIN ST",
    "dropphycty": "BURDEN",
    "dropphyst": "KS",
    "dropphyzpp": 670198806,
    "dropmaladd": "417 N MAIN ST",
    "dropmalcty": "BURDEN",
    "dropmalst": "KS",
    "dropmalzpp": 670198806,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204382585,
    "dropsitcph": 6204382585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20240",
    "droptype": "D",
    "dropname": "BURDETT",
    "dropdeladd": "202 ELM ST",
    "dropdelcty": "BURDETT",
    "dropdelst": "KS",
    "dropdelzpp": 675239500,
    "dropphyadd": "202 ELM ST",
    "dropphycty": "BURDETT",
    "dropphyst": "KS",
    "dropphyzpp": 675239500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURDETT",
    "dropmalst": "KS",
    "dropmalzpp": 675239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205256631,
    "dropsitcph": 6205256631,
    "dropfax": 6205256631
  },
  {
    "dcode": "D",
    "dropkey": "PW20241",
    "droptype": "D",
    "dropname": "BURDICK",
    "dropdeladd": "526 MAIN ST",
    "dropdelcty": "BURDICK",
    "dropdelst": "KS",
    "dropdelzpp": 668389998,
    "dropphyadd": "526 MAIN ST",
    "dropphycty": "BURDICK",
    "dropphyst": "KS",
    "dropphyzpp": 668389998,
    "dropmaladd": "526 MAIN ST",
    "dropmalcty": "BURDICK",
    "dropmalst": "KS",
    "dropmalzpp": 668389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859834445,
    "dropsitcph": 7859834445,
    "dropfax": 7859834445
  },
  {
    "dcode": "D",
    "dropkey": "PW20243",
    "droptype": "D",
    "dropname": "BURLINGAME",
    "dropdeladd": "123 S TOPEKA AVE",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "KS",
    "dropdelzpp": 664139998,
    "dropphyadd": "123 S TOPEKA AVE",
    "dropphycty": "BURLINGAME",
    "dropphyst": "KS",
    "dropphyzpp": 664139998,
    "dropmaladd": "123 S TOPEKA AVE",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "KS",
    "dropmalzpp": 664139998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856543823,
    "dropsitcph": 7856543823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20245",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "118 S 4TH ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 668399998,
    "dropphyadd": "118 S 4TH ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 668399998,
    "dropmaladd": "118 S 4TH ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 668399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203642215,
    "dropsitcph": 6203642215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20247",
    "droptype": "D",
    "dropname": "BURNS",
    "dropdeladd": "111 N WASHINGTON AVE",
    "dropdelcty": "BURNS",
    "dropdelst": "KS",
    "dropdelzpp": 668409998,
    "dropphyadd": "111 N WASHINGTON AVE",
    "dropphycty": "BURNS",
    "dropphyst": "KS",
    "dropphyzpp": 668409998,
    "dropmaladd": "111 N WASHINGTON AVE",
    "dropmalcty": "BURNS",
    "dropmalst": "KS",
    "dropmalzpp": 668409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207265217,
    "dropsitcph": 6207265217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20248",
    "droptype": "D",
    "dropname": "BURR OAK",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "BURR OAK",
    "dropdelst": "KS",
    "dropdelzpp": 669369760,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "BURR OAK",
    "dropphyst": "KS",
    "dropphyzpp": 669369760,
    "dropmaladd": "117 S MAIN ST",
    "dropmalcty": "BURR OAK",
    "dropmalst": "KS",
    "dropmalzpp": 669369760,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856475261,
    "dropsitcph": 7856475261,
    "dropfax": 7856475261
  },
  {
    "dcode": "D",
    "dropkey": "PW20249",
    "droptype": "D",
    "dropname": "BURRTON",
    "dropdeladd": "106 E ADAMS ST",
    "dropdelcty": "BURRTON",
    "dropdelst": "KS",
    "dropdelzpp": 670209998,
    "dropphyadd": "106 E ADAMS ST",
    "dropphycty": "BURRTON",
    "dropphyst": "KS",
    "dropphyzpp": 670209998,
    "dropmaladd": "106 E ADAMS ST",
    "dropmalcty": "BURRTON",
    "dropmalst": "KS",
    "dropmalzpp": 670209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202078023,
    "dropsitcph": 6202078023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20253",
    "droptype": "D",
    "dropname": "BUSHTON",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "BUSHTON",
    "dropdelst": "KS",
    "dropdelzpp": 674279998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "BUSHTON",
    "dropphyst": "KS",
    "dropphyzpp": 674279998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "BUSHTON",
    "dropmalst": "KS",
    "dropmalzpp": 674279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205623274,
    "dropsitcph": 6205623274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20260",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "14 N MAIN ST",
    "dropdelcty": "CALDWELL",
    "dropdelst": "KS",
    "dropdelzpp": 670229998,
    "dropphyadd": "14 N MAIN ST",
    "dropphycty": "CALDWELL",
    "dropphyst": "KS",
    "dropphyzpp": 670229998,
    "dropmaladd": "14 N MAIN ST",
    "dropmalcty": "CALDWELL",
    "dropmalst": "KS",
    "dropmalzpp": 670229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208452525,
    "dropsitcph": 6208452525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20264",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "208 W MAIN ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "KS",
    "dropdelzpp": 670239998,
    "dropphyadd": "208 W MAIN ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "KS",
    "dropphyzpp": 670239998,
    "dropmaladd": "208 W MAIN ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "KS",
    "dropmalzpp": 670239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204672801,
    "dropsitcph": 6204672801,
    "dropfax": 6204672801
  },
  {
    "dcode": "D",
    "dropkey": "PW20267",
    "droptype": "D",
    "dropname": "CANEY",
    "dropdeladd": "201 W 5TH AVE",
    "dropdelcty": "CANEY",
    "dropdelst": "KS",
    "dropdelzpp": 673339998,
    "dropphyadd": "201 W 5TH AVE",
    "dropphycty": "CANEY",
    "dropphyst": "KS",
    "dropphyzpp": 673339998,
    "dropmaladd": "201 W 5TH AVE",
    "dropmalcty": "CANEY",
    "dropmalst": "KS",
    "dropmalzpp": 673339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208795210,
    "dropsitcph": 6208795210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20268",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "CANTON",
    "dropdelst": "KS",
    "dropdelzpp": 674289998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "CANTON",
    "dropphyst": "KS",
    "dropphyzpp": 674289998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "CANTON",
    "dropmalst": "KS",
    "dropmalzpp": 674289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206284622,
    "dropsitcph": 6206284622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20270",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "KS",
    "dropdelzpp": 664149635,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "KS",
    "dropphyzpp": 664149635,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "KS",
    "dropmalzpp": 664149635,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858367682,
    "dropsitcph": 7858367682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20279",
    "droptype": "D",
    "dropname": "CASSODAY",
    "dropdeladd": "308 E MAIN ST",
    "dropdelcty": "CASSODAY",
    "dropdelst": "KS",
    "dropdelzpp": 668429998,
    "dropphyadd": "308 E MAIN ST",
    "dropphycty": "CASSODAY",
    "dropphyst": "KS",
    "dropphyzpp": 668429998,
    "dropmaladd": "308 E MAIN ST",
    "dropmalcty": "CASSODAY",
    "dropmalst": "KS",
    "dropmalzpp": 668429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207354471,
    "dropsitcph": 6207354471,
    "dropfax": 6207354471
  },
  {
    "dcode": "D",
    "dropkey": "PW20286",
    "droptype": "D",
    "dropname": "CAWKER CITY",
    "dropdeladd": "702 WISCONSIN ST",
    "dropdelcty": "CAWKER CITY",
    "dropdelst": "KS",
    "dropdelzpp": 674309998,
    "dropphyadd": "702 WISCONSIN ST",
    "dropphycty": "CAWKER CITY",
    "dropphyst": "KS",
    "dropphyzpp": 674309998,
    "dropmaladd": "702 WISCONSIN ST",
    "dropmalcty": "CAWKER CITY",
    "dropmalst": "KS",
    "dropmalzpp": 674309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857814484,
    "dropsitcph": 7857814484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20289",
    "droptype": "D",
    "dropname": "CEDAR",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "CEDAR",
    "dropdelst": "KS",
    "dropdelzpp": 676289998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "CEDAR",
    "dropphyst": "KS",
    "dropphyzpp": 676289998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "CEDAR",
    "dropmalst": "KS",
    "dropmalzpp": 676289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856972282,
    "dropsitcph": 7856972282,
    "dropfax": 7856972282
  },
  {
    "dcode": "D",
    "dropkey": "PW20292",
    "droptype": "D",
    "dropname": "CEDAR POINT",
    "dropdeladd": "417 WALNUT ST",
    "dropdelcty": "CEDAR POINT",
    "dropdelst": "KS",
    "dropdelzpp": 668439591,
    "dropphyadd": "417 WALNUT ST",
    "dropphycty": "CEDAR POINT",
    "dropphyst": "KS",
    "dropphyzpp": 668439591,
    "dropmaladd": "417 WALNUT ST",
    "dropmalcty": "CEDAR POINT",
    "dropmalst": "KS",
    "dropmalzpp": 668439591,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202744008,
    "dropsitcph": 6202744008,
    "dropfax": 6202744471
  },
  {
    "dcode": "D",
    "dropkey": "PW20294",
    "droptype": "D",
    "dropname": "CEDAR VALE",
    "dropdeladd": "706 CEDAR ST",
    "dropdelcty": "CEDAR VALE",
    "dropdelst": "KS",
    "dropdelzpp": 670249998,
    "dropphyadd": "706 CEDAR ST",
    "dropphycty": "CEDAR VALE",
    "dropphyst": "KS",
    "dropphyzpp": 670249998,
    "dropmaladd": "706 CEDAR ST",
    "dropmalcty": "CEDAR VALE",
    "dropmalst": "KS",
    "dropmalzpp": 670249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207582296,
    "dropsitcph": 6207582296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20302",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "206 E MARKET ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 660149998,
    "dropphyadd": "206 E MARKET ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 660149998,
    "dropmaladd": "206 E MARKET ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 660149998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138983895,
    "dropsitcph": 9138983895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20306",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "505 4TH ST",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "KS",
    "dropdelzpp": 664159998,
    "dropphyadd": "505 4TH ST",
    "dropphycty": "CENTRALIA",
    "dropphyst": "KS",
    "dropphyzpp": 664159998,
    "dropmaladd": "505 4TH ST",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "KS",
    "dropmalzpp": 664159998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858573580,
    "dropsitcph": 7858573580,
    "dropfax": 7858573580
  },
  {
    "dcode": "D",
    "dropkey": "PW20307",
    "droptype": "D",
    "dropname": "CHANUTE",
    "dropdeladd": "102 N LINCOLN AVE",
    "dropdelcty": "CHANUTE",
    "dropdelst": "KS",
    "dropdelzpp": 667209998,
    "dropphyadd": "102 N LINCOLN AVE",
    "dropphycty": "CHANUTE",
    "dropphyst": "KS",
    "dropphyzpp": 667209998,
    "dropmaladd": "102 N LINCOLN AVE",
    "dropmalcty": "CHANUTE",
    "dropmalst": "KS",
    "dropmalzpp": 667209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204319530,
    "dropsitcph": 6204314070,
    "dropfax": 6204316316
  },
  {
    "dcode": "D",
    "dropkey": "PW20309",
    "droptype": "D",
    "dropname": "CHAPMAN",
    "dropdeladd": "102 E 5TH ST",
    "dropdelcty": "CHAPMAN",
    "dropdelst": "KS",
    "dropdelzpp": 674319998,
    "dropphyadd": "102 E 5TH ST",
    "dropphycty": "CHAPMAN",
    "dropphyst": "KS",
    "dropphyzpp": 674319998,
    "dropmaladd": "102 E 5TH ST",
    "dropmalcty": "CHAPMAN",
    "dropmalst": "KS",
    "dropmalzpp": 674319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859226487,
    "dropsitcph": 7859226487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20314",
    "droptype": "D",
    "dropname": "CHASE",
    "dropdeladd": "513 MAIN ST",
    "dropdelcty": "CHASE",
    "dropdelst": "KS",
    "dropdelzpp": 675249998,
    "dropphyadd": "513 MAIN ST",
    "dropphycty": "CHASE",
    "dropphyst": "KS",
    "dropphyzpp": 675249998,
    "dropmaladd": "513 MAIN ST",
    "dropmalcty": "CHASE",
    "dropmalst": "KS",
    "dropmalzpp": 675249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209382936,
    "dropsitcph": 6209382936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20315",
    "droptype": "D",
    "dropname": "CHAUTAUQUA",
    "dropdeladd": "100 E LAUREL ST",
    "dropdelcty": "CHAUTAUQUA",
    "dropdelst": "KS",
    "dropdelzpp": 673349500,
    "dropphyadd": "100 E LAUREL ST",
    "dropphycty": "CHAUTAUQUA",
    "dropphyst": "KS",
    "dropphyzpp": 673349500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAUTAUQUA",
    "dropmalst": "KS",
    "dropmalzpp": 673349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207255150,
    "dropsitcph": 6207255150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20317",
    "droptype": "D",
    "dropname": "CHENEY",
    "dropdeladd": "215 N MAIN ST",
    "dropdelcty": "CHENEY",
    "dropdelst": "KS",
    "dropdelzpp": 670259998,
    "dropphyadd": "215 N MAIN ST",
    "dropphycty": "CHENEY",
    "dropphyst": "KS",
    "dropphyzpp": 670259998,
    "dropmaladd": "215 N MAIN ST",
    "dropmalcty": "CHENEY",
    "dropmalst": "KS",
    "dropmalzpp": 670259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165423321,
    "dropsitcph": 3165423321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20318",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "108 S VINE ST",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "KS",
    "dropdelzpp": 667249998,
    "dropphyadd": "108 S VINE ST",
    "dropphycty": "CHEROKEE",
    "dropphyst": "KS",
    "dropphyzpp": 667249998,
    "dropmaladd": "108 S VINE ST",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "KS",
    "dropmalzpp": 667249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204578750,
    "dropsitcph": 6204578750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20319",
    "droptype": "D",
    "dropname": "CHERRYVALE",
    "dropdeladd": "205 N NEOSHO ST",
    "dropdelcty": "CHERRYVALE",
    "dropdelst": "KS",
    "dropdelzpp": 673359998,
    "dropphyadd": "205 N NEOSHO ST",
    "dropphycty": "CHERRYVALE",
    "dropphyst": "KS",
    "dropphyzpp": 673359998,
    "dropmaladd": "205 N NEOSHO ST",
    "dropmalcty": "CHERRYVALE",
    "dropmalst": "KS",
    "dropmalzpp": 673359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203362781,
    "dropsitcph": 6203362781,
    "dropfax": 6203362635
  },
  {
    "dcode": "D",
    "dropkey": "PW20320",
    "droptype": "D",
    "dropname": "CHETOPA",
    "dropdeladd": "519 MAPLE ST",
    "dropdelcty": "CHETOPA",
    "dropdelst": "KS",
    "dropdelzpp": 673369900,
    "dropphyadd": "519 MAPLE ST",
    "dropphycty": "CHETOPA",
    "dropphyst": "KS",
    "dropphyzpp": 673369900,
    "dropmaladd": "519 MAPLE ST",
    "dropmalcty": "CHETOPA",
    "dropmalst": "KS",
    "dropmalzpp": 673369900,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202367830,
    "dropsitcph": 6202367830,
    "dropfax": 6202367830
  },
  {
    "dcode": "D",
    "dropkey": "PW20324",
    "droptype": "D",
    "dropname": "CIMARRON",
    "dropdeladd": "207 N MAIN ST",
    "dropdelcty": "CIMARRON",
    "dropdelst": "KS",
    "dropdelzpp": 678359998,
    "dropphyadd": "207 N MAIN ST",
    "dropphycty": "CIMARRON",
    "dropphyst": "KS",
    "dropphyzpp": 678359998,
    "dropmaladd": "207 N MAIN ST",
    "dropmalcty": "CIMARRON",
    "dropmalst": "KS",
    "dropmalzpp": 678359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208552280,
    "dropsitcph": 6208552280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20325",
    "droptype": "D",
    "dropname": "CIRCLEVILLE",
    "dropdeladd": "203 LINCOLN ST",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 664169406,
    "dropphyadd": "203 LINCOLN ST",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 664169406,
    "dropmaladd": "203 LINCOLN ST",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 664169406,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859243726,
    "dropsitcph": 7859243726,
    "dropfax": 7859243726
  },
  {
    "dcode": "D",
    "dropkey": "PW20330",
    "droptype": "D",
    "dropname": "CLAFLIN",
    "dropdeladd": "218 MAIN ST",
    "dropdelcty": "CLAFLIN",
    "dropdelst": "KS",
    "dropdelzpp": 675259998,
    "dropphyadd": "218 MAIN ST",
    "dropphycty": "CLAFLIN",
    "dropphyst": "KS",
    "dropphyzpp": 675259998,
    "dropmaladd": "218 MAIN ST",
    "dropmalcty": "CLAFLIN",
    "dropmalst": "KS",
    "dropmalzpp": 675259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205873935,
    "dropsitcph": 6205873935,
    "dropfax": 6205873935
  },
  {
    "dcode": "D",
    "dropkey": "PW20333",
    "droptype": "D",
    "dropname": "CLAY CENTER",
    "dropdeladd": "806 6TH ST",
    "dropdelcty": "CLAY CENTER",
    "dropdelst": "KS",
    "dropdelzpp": 674329998,
    "dropphyadd": "806 6TH ST",
    "dropphycty": "CLAY CENTER",
    "dropphyst": "KS",
    "dropphyzpp": 674329998,
    "dropmaladd": "806 6TH ST",
    "dropmalcty": "CLAY CENTER",
    "dropmalst": "KS",
    "dropmalzpp": 674329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856323755,
    "dropsitcph": 7856323755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20339",
    "droptype": "D",
    "dropname": "CLEARWATER",
    "dropdeladd": "640 N 4TH ST",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "KS",
    "dropdelzpp": 670269998,
    "dropphyadd": "640 N 4TH ST",
    "dropphycty": "CLEARWATER",
    "dropphyst": "KS",
    "dropphyzpp": 670269998,
    "dropmaladd": "640 N 4TH ST",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "KS",
    "dropmalzpp": 670269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205846766,
    "dropsitcph": 6205846766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20342",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "101 E PARALLEL ST",
    "dropdelcty": "CLIFTON",
    "dropdelst": "KS",
    "dropdelzpp": 669379998,
    "dropphyadd": "101 E PARALLEL ST",
    "dropphycty": "CLIFTON",
    "dropphyst": "KS",
    "dropphyzpp": 669379998,
    "dropmaladd": "101 E PARALLEL ST",
    "dropmalcty": "CLIFTON",
    "dropmalst": "KS",
    "dropmalzpp": 669379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854553418,
    "dropsitcph": 7854553418,
    "dropfax": 7854553418
  },
  {
    "dcode": "D",
    "dropkey": "PW20345",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "308 WASHINGTON ST",
    "dropdelcty": "CLYDE",
    "dropdelst": "KS",
    "dropdelzpp": 669389998,
    "dropphyadd": "308 WASHINGTON ST",
    "dropphycty": "CLYDE",
    "dropphyst": "KS",
    "dropphyzpp": 669389998,
    "dropmaladd": "308 WASHINGTON ST",
    "dropmalcty": "CLYDE",
    "dropmalst": "KS",
    "dropmalzpp": 669389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854462826,
    "dropsitcph": 7854462826,
    "dropfax": 7854462826
  },
  {
    "dcode": "D",
    "dropkey": "PW20350",
    "droptype": "D",
    "dropname": "COFFEYVILLE",
    "dropdeladd": "232 W 8TH ST",
    "dropdelcty": "COFFEYVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 673379998,
    "dropphyadd": "232 W 8TH ST",
    "dropphycty": "COFFEYVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 673379998,
    "dropmaladd": "232 W 8TH ST",
    "dropmalcty": "COFFEYVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 673379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202514570,
    "dropsitcph": 6202514570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20354",
    "droptype": "D",
    "dropname": "COLBY",
    "dropdeladd": "535 N COURT AVE",
    "dropdelcty": "COLBY",
    "dropdelst": "KS",
    "dropdelzpp": 677019998,
    "dropphyadd": "535 N COURT AVE",
    "dropphycty": "COLBY",
    "dropphyst": "KS",
    "dropphyzpp": 677019998,
    "dropmaladd": "535 N COURT AVE",
    "dropmalcty": "COLBY",
    "dropmalst": "KS",
    "dropmalzpp": 677019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854627904,
    "dropsitcph": 7854627904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20355",
    "droptype": "D",
    "dropname": "COLDWATER",
    "dropdeladd": "212 E MAIN ST",
    "dropdelcty": "COLDWATER",
    "dropdelst": "KS",
    "dropdelzpp": 670299998,
    "dropphyadd": "212 E MAIN ST",
    "dropphycty": "COLDWATER",
    "dropphyst": "KS",
    "dropphyzpp": 670299998,
    "dropmaladd": "212 E MAIN ST",
    "dropmalcty": "COLDWATER",
    "dropmalst": "KS",
    "dropmalzpp": 670299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205822174,
    "dropsitcph": 6205822174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20360",
    "droptype": "D",
    "dropname": "COLLYER",
    "dropdeladd": "313 AINSLIE AVE",
    "dropdelcty": "COLLYER",
    "dropdelst": "KS",
    "dropdelzpp": 676319998,
    "dropphyadd": "313 AINSLIE AVE",
    "dropphycty": "COLLYER",
    "dropphyst": "KS",
    "dropphyzpp": 676319998,
    "dropmaladd": "313 AINSLIE AVE",
    "dropmalcty": "COLLYER",
    "dropmalst": "KS",
    "dropmalzpp": 676319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857695344,
    "dropsitcph": 7857695344,
    "dropfax": 7857695344
  },
  {
    "dcode": "D",
    "dropkey": "PW20361",
    "droptype": "D",
    "dropname": "COLONY",
    "dropdeladd": "206 E BROAD ST",
    "dropdelcty": "COLONY",
    "dropdelst": "KS",
    "dropdelzpp": 660159998,
    "dropphyadd": "206 E BROAD ST",
    "dropphycty": "COLONY",
    "dropphyst": "KS",
    "dropphyzpp": 660159998,
    "dropmaladd": "206 E BROAD ST",
    "dropmalcty": "COLONY",
    "dropmalst": "KS",
    "dropmalzpp": 660159998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6208523470,
    "dropsitcph": 6208523470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20363",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "223 S PENNSYLVANIA AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "KS",
    "dropdelzpp": 667259998,
    "dropphyadd": "223 S PENNSYLVANIA AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "KS",
    "dropphyzpp": 667259998,
    "dropmaladd": "223 S PENNSYLVANIA AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "KS",
    "dropmalzpp": 667259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202024813,
    "dropsitcph": 6202024813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20364",
    "droptype": "D",
    "dropname": "COLWICH",
    "dropdeladd": "417 W WICHITA AVE",
    "dropdelcty": "COLWICH",
    "dropdelst": "KS",
    "dropdelzpp": 670309998,
    "dropphyadd": "417 W WICHITA AVE",
    "dropphycty": "COLWICH",
    "dropphyst": "KS",
    "dropphyzpp": 670309998,
    "dropmaladd": "417 W WICHITA AVE",
    "dropmalcty": "COLWICH",
    "dropmalst": "KS",
    "dropmalzpp": 670309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167960519,
    "dropsitcph": 3167960519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20366",
    "droptype": "D",
    "dropname": "CONCORDIA",
    "dropdeladd": "622 WASHINGTON ST",
    "dropdelcty": "CONCORDIA",
    "dropdelst": "KS",
    "dropdelzpp": 669019998,
    "dropphyadd": "622 WASHINGTON ST",
    "dropphycty": "CONCORDIA",
    "dropphyst": "KS",
    "dropphyzpp": 669019998,
    "dropmaladd": "622 WASHINGTON ST",
    "dropmalcty": "CONCORDIA",
    "dropmalst": "KS",
    "dropmalzpp": 669019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852432599,
    "dropsitcph": 7852432599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20368",
    "droptype": "D",
    "dropname": "CONWAY SPRINGS",
    "dropdeladd": "212 W SPRING AVE",
    "dropdelcty": "CONWAY SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 670319998,
    "dropphyadd": "212 W SPRING AVE",
    "dropphycty": "CONWAY SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 670319998,
    "dropmaladd": "212 W SPRING AVE",
    "dropmalcty": "CONWAY SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 670319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204562280,
    "dropsitcph": 6204562280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20369",
    "droptype": "D",
    "dropname": "COOLIDGE",
    "dropdeladd": "100 STATE ROAD 50",
    "dropdelcty": "COOLIDGE",
    "dropdelst": "KS",
    "dropdelzpp": 678369500,
    "dropphyadd": "100 STATE ROAD 50",
    "dropphycty": "COOLIDGE",
    "dropphyst": "KS",
    "dropphyzpp": 678369500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOLIDGE",
    "dropmalst": "KS",
    "dropmalzpp": 678369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203728271,
    "dropsitcph": 6203728271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20370",
    "droptype": "D",
    "dropname": "COPELAND",
    "dropdeladd": "107 SANTA FE ST",
    "dropdelcty": "COPELAND",
    "dropdelst": "KS",
    "dropdelzpp": 678379998,
    "dropphyadd": "107 SANTA FE ST",
    "dropphycty": "COPELAND",
    "dropphyst": "KS",
    "dropphyzpp": 678379998,
    "dropmaladd": "107 SANTA FE ST",
    "dropmalcty": "COPELAND",
    "dropmalst": "KS",
    "dropmalzpp": 678379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206685550,
    "dropsitcph": 6206685550,
    "dropfax": 6206685550
  },
  {
    "dcode": "D",
    "dropkey": "PW20379",
    "droptype": "D",
    "dropname": "COTTONWOOD FALLS",
    "dropdeladd": "206 BROADWAY ST",
    "dropdelcty": "COTTONWOOD FALLS",
    "dropdelst": "KS",
    "dropdelzpp": 668459998,
    "dropphyadd": "206 BROADWAY ST",
    "dropphycty": "COTTONWOOD FALLS",
    "dropphyst": "KS",
    "dropphyzpp": 668459998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTONWOOD FALLS",
    "dropmalst": "KS",
    "dropmalzpp": 668450998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202736930,
    "dropsitcph": 6202736930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20380",
    "droptype": "D",
    "dropname": "COUNCIL GROVE",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "COUNCIL GROVE",
    "dropdelst": "KS",
    "dropdelzpp": 668469998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "COUNCIL GROVE",
    "dropphyst": "KS",
    "dropphyzpp": 668469998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "COUNCIL GROVE",
    "dropmalst": "KS",
    "dropmalzpp": 668469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207676219,
    "dropsitcph": 6207676219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20383",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "416 MAIN ST",
    "dropdelcty": "COURTLAND",
    "dropdelst": "KS",
    "dropdelzpp": 669399712,
    "dropphyadd": "416 MAIN ST",
    "dropphycty": "COURTLAND",
    "dropphyst": "KS",
    "dropphyzpp": 669399712,
    "dropmaladd": "416 MAIN ST",
    "dropmalcty": "COURTLAND",
    "dropmalst": "KS",
    "dropmalzpp": 669399712,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853744298,
    "dropsitcph": 7853744298,
    "dropfax": 7853744298
  },
  {
    "dcode": "D",
    "dropkey": "PW20392",
    "droptype": "D",
    "dropname": "CRESTLINE",
    "dropdeladd": "653 SE HIGHWAY ALTERNATE 69",
    "dropdelcty": "CRESTLINE",
    "dropdelst": "KS",
    "dropdelzpp": 667289998,
    "dropphyadd": "653 SE HIGHWAY ALTERNATE 69",
    "dropphycty": "CRESTLINE",
    "dropphyst": "KS",
    "dropphyzpp": 667289998,
    "dropmaladd": "653 SE HIGHWAY ALTERNATE 69",
    "dropmalcty": "CRESTLINE",
    "dropmalst": "KS",
    "dropmalzpp": 667289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202231410,
    "dropsitcph": 6203892222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20397",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "309 BAIRD ST",
    "dropdelcty": "CUBA",
    "dropdelst": "KS",
    "dropdelzpp": 669409998,
    "dropphyadd": "309 BAIRD ST",
    "dropphycty": "CUBA",
    "dropphyst": "KS",
    "dropphyzpp": 669409998,
    "dropmaladd": "309 BAIRD ST",
    "dropmalcty": "CUBA",
    "dropmalst": "KS",
    "dropmalzpp": 669409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857293830,
    "dropsitcph": 7857293830,
    "dropfax": 7857293830
  },
  {
    "dcode": "D",
    "dropkey": "PW20400",
    "droptype": "D",
    "dropname": "CUMMINGS",
    "dropdeladd": "13906 FRONT ST",
    "dropdelcty": "CUMMINGS",
    "dropdelst": "KS",
    "dropdelzpp": 660169998,
    "dropphyadd": "13906 FRONT ST",
    "dropphycty": "CUMMINGS",
    "dropphyst": "KS",
    "dropphyzpp": 660169998,
    "dropmaladd": "13906 FRONT ST",
    "dropmalcty": "CUMMINGS",
    "dropmalst": "KS",
    "dropmalzpp": 660169998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138866623,
    "dropsitcph": 9138866623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20401",
    "droptype": "D",
    "dropname": "CUNNINGHAM",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "CUNNINGHAM",
    "dropdelst": "KS",
    "dropdelzpp": 670359998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "CUNNINGHAM",
    "dropphyst": "KS",
    "dropphyzpp": 670359998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "CUNNINGHAM",
    "dropmalst": "KS",
    "dropmalzpp": 670359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202982455,
    "dropsitcph": 6202982455,
    "dropfax": 6202982455
  },
  {
    "dcode": "D",
    "dropkey": "PW20406",
    "droptype": "D",
    "dropname": "DAMAR",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "DAMAR",
    "dropdelst": "KS",
    "dropdelzpp": 676329998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "DAMAR",
    "dropphyst": "KS",
    "dropphyzpp": 676329998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "DAMAR",
    "dropmalst": "KS",
    "dropmalzpp": 676329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858394252,
    "dropsitcph": 7858394252,
    "dropfax": 7858394252
  },
  {
    "dcode": "D",
    "dropkey": "PW20407",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "104 RYAN AVE",
    "dropdelcty": "DANVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 670368739,
    "dropphyadd": "104 RYAN AVE",
    "dropphycty": "DANVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 670368739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 670369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209625483,
    "dropsitcph": 6209625483,
    "dropfax": 6209625483
  },
  {
    "dcode": "D",
    "dropkey": "PW20413",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "33155 W 83RD ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "KS",
    "dropdelzpp": 660189998,
    "dropphyadd": "33155 W 83RD ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "KS",
    "dropphyzpp": 660189998,
    "dropmaladd": "33155 W 83RD ST",
    "dropmalcty": "DE SOTO",
    "dropmalst": "KS",
    "dropmalzpp": 660189998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9135831543,
    "dropsitcph": 9135831543,
    "dropfax": 9135851976
  },
  {
    "dcode": "D",
    "dropkey": "PW20414",
    "droptype": "D",
    "dropname": "DEARING",
    "dropdeladd": "312 S INDEPENDENCE ST",
    "dropdelcty": "DEARING",
    "dropdelst": "KS",
    "dropdelzpp": 673409500,
    "dropphyadd": "312 S INDEPENDENCE ST",
    "dropphycty": "DEARING",
    "dropphyst": "KS",
    "dropphyzpp": 673409500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEARING",
    "dropmalst": "KS",
    "dropmalzpp": 673409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209483401,
    "dropsitcph": 6209483401,
    "dropfax": 6209483401
  },
  {
    "dcode": "D",
    "dropkey": "PW20416",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "514 MAIN ST",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 678389998,
    "dropphyadd": "514 MAIN ST",
    "dropphycty": "DEERFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 678389998,
    "dropmaladd": "514 MAIN ST",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 678389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204262211,
    "dropsitcph": 6204262211,
    "dropfax": 6204262211
  },
  {
    "dcode": "D",
    "dropkey": "PW20421",
    "droptype": "D",
    "dropname": "DELPHOS",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "DELPHOS",
    "dropdelst": "KS",
    "dropdelzpp": 674369998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "DELPHOS",
    "dropphyst": "KS",
    "dropphyzpp": 674369998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "DELPHOS",
    "dropmalst": "KS",
    "dropmalzpp": 674369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855234259,
    "dropsitcph": 7855234259,
    "dropfax": 7855234259
  },
  {
    "dcode": "D",
    "dropkey": "PW20422",
    "droptype": "D",
    "dropname": "DENISON",
    "dropdeladd": "201 CENTRAL AVE",
    "dropdelcty": "DENISON",
    "dropdelst": "KS",
    "dropdelzpp": 664199998,
    "dropphyadd": "201 CENTRAL AVE",
    "dropphycty": "DENISON",
    "dropphyst": "KS",
    "dropphyzpp": 664199998,
    "dropmaladd": "201 CENTRAL AVE",
    "dropmalcty": "DENISON",
    "dropmalst": "KS",
    "dropmalzpp": 664199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859352341,
    "dropsitcph": 7859352341,
    "dropfax": 7859352341
  },
  {
    "dcode": "D",
    "dropkey": "PW20424",
    "droptype": "D",
    "dropname": "DENNIS",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "DENNIS",
    "dropdelst": "KS",
    "dropdelzpp": 673419998,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "DENNIS",
    "dropphyst": "KS",
    "dropphyzpp": 673419998,
    "dropmaladd": "103 S MAIN ST",
    "dropmalcty": "DENNIS",
    "dropmalst": "KS",
    "dropmalzpp": 673419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204213210,
    "dropsitcph": 6204213210,
    "dropfax": 6204213210
  },
  {
    "dcode": "D",
    "dropkey": "PW20426",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "506 MAIN ST",
    "dropdelcty": "DENTON",
    "dropdelst": "KS",
    "dropdelzpp": 660179998,
    "dropphyadd": "506 MAIN ST",
    "dropphycty": "DENTON",
    "dropphyst": "KS",
    "dropphyzpp": 660179998,
    "dropmaladd": "506 MAIN ST",
    "dropmalcty": "DENTON",
    "dropmalst": "KS",
    "dropmalzpp": 660179998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855769344,
    "dropsitcph": 7855769344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20427",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "201 W GREENWAY ST",
    "dropdelcty": "DERBY",
    "dropdelst": "KS",
    "dropdelzpp": 670379998,
    "dropphyadd": "201 W GREENWAY ST",
    "dropphycty": "DERBY",
    "dropphyst": "KS",
    "dropphyzpp": 670379998,
    "dropmaladd": "201 W GREENWAY ST",
    "dropmalcty": "DERBY",
    "dropmalst": "KS",
    "dropmalzpp": 670379998,
    "dropsitphn": 3167883718,
    "dropsitlph": 3167883718,
    "dropsitcph": 3167883718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20432",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "118 N MAIN ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "KS",
    "dropdelzpp": 670389998,
    "dropphyadd": "118 N MAIN ST",
    "dropphycty": "DEXTER",
    "dropphyst": "KS",
    "dropphyzpp": 670389998,
    "dropmaladd": "118 N MAIN ST",
    "dropmalcty": "DEXTER",
    "dropmalst": "KS",
    "dropmalzpp": 670389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208765665,
    "dropsitcph": 6208765665,
    "dropfax": 6208765665
  },
  {
    "dcode": "D",
    "dropkey": "PW20433",
    "droptype": "D",
    "dropname": "DIGHTON",
    "dropdeladd": "205 S LANE ST",
    "dropdelcty": "DIGHTON",
    "dropdelst": "KS",
    "dropdelzpp": 678399998,
    "dropphyadd": "205 S LANE ST",
    "dropphycty": "DIGHTON",
    "dropphyst": "KS",
    "dropphyzpp": 678399998,
    "dropmaladd": "205 S LANE ST",
    "dropmalcty": "DIGHTON",
    "dropmalst": "KS",
    "dropmalzpp": 678399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203972434,
    "dropsitcph": 6203972434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20439",
    "droptype": "D",
    "dropname": "DODGE CITY",
    "dropdeladd": "700 CENTRAL AVE",
    "dropdelcty": "DODGE CITY",
    "dropdelst": "KS",
    "dropdelzpp": 678019998,
    "dropphyadd": "700 CENTRAL AVE",
    "dropphycty": "DODGE CITY",
    "dropphyst": "KS",
    "dropphyzpp": 678019998,
    "dropmaladd": "700 CENTRAL AVE",
    "dropmalcty": "DODGE CITY",
    "dropmalst": "KS",
    "dropmalzpp": 678019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202278619,
    "dropsitcph": 6202278618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20441",
    "droptype": "D",
    "dropname": "DORRANCE",
    "dropdeladd": "521 MAIN ST",
    "dropdelcty": "DORRANCE",
    "dropdelst": "KS",
    "dropdelzpp": 676349998,
    "dropphyadd": "521 MAIN ST",
    "dropphycty": "DORRANCE",
    "dropphyst": "KS",
    "dropphyzpp": 676349998,
    "dropmaladd": "521 MAIN ST",
    "dropmalcty": "DORRANCE",
    "dropmalst": "KS",
    "dropmalzpp": 676349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856664463,
    "dropsitcph": 7856664463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20442",
    "droptype": "D",
    "dropname": "DOUGLASS",
    "dropdeladd": "315 S FORREST ST",
    "dropdelcty": "DOUGLASS",
    "dropdelst": "KS",
    "dropdelzpp": 670399998,
    "dropphyadd": "315 S FORREST ST",
    "dropphycty": "DOUGLASS",
    "dropphyst": "KS",
    "dropphyzpp": 670399998,
    "dropmaladd": "315 S FORREST ST",
    "dropmalcty": "DOUGLASS",
    "dropmalst": "KS",
    "dropmalzpp": 670399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167462691,
    "dropsitcph": 3167462691,
    "dropfax": 3167462691
  },
  {
    "dcode": "D",
    "dropkey": "PW20443",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "13538 SW 57TH ST",
    "dropdelcty": "DOVER",
    "dropdelst": "KS",
    "dropdelzpp": 664209998,
    "dropphyadd": "13538 SW 57TH ST",
    "dropphycty": "DOVER",
    "dropphyst": "KS",
    "dropphyzpp": 664209998,
    "dropmaladd": "13538 SW 57TH ST",
    "dropmalcty": "DOVER",
    "dropmalst": "KS",
    "dropmalzpp": 664209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852566130,
    "dropsitcph": 7852566130,
    "dropfax": 7852566130
  },
  {
    "dcode": "D",
    "dropkey": "PW20445",
    "droptype": "D",
    "dropname": "DOWNS",
    "dropdeladd": "808 MORGAN AVE",
    "dropdelcty": "DOWNS",
    "dropdelst": "KS",
    "dropdelzpp": 674379998,
    "dropphyadd": "808 MORGAN AVE",
    "dropphycty": "DOWNS",
    "dropphyst": "KS",
    "dropphyzpp": 674379998,
    "dropmaladd": "808 MORGAN AVE",
    "dropmalcty": "DOWNS",
    "dropmalst": "KS",
    "dropmalzpp": 674379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854543328,
    "dropsitcph": 7854543328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20459",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "508 DOUGLAS",
    "dropdelcty": "DURHAM",
    "dropdelst": "KS",
    "dropdelzpp": 674389753,
    "dropphyadd": "508 DOUGLAS",
    "dropphycty": "DURHAM",
    "dropphyst": "KS",
    "dropphyzpp": 674389753,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DURHAM",
    "dropmalst": "KS",
    "dropmalzpp": 674389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207323411,
    "dropsitcph": 6207323411,
    "dropfax": 6207323411
  },
  {
    "dcode": "D",
    "dropkey": "PW20462",
    "droptype": "D",
    "dropname": "DWIGHT",
    "dropdeladd": "608 E MAIN ST",
    "dropdelcty": "DWIGHT",
    "dropdelst": "KS",
    "dropdelzpp": 668499998,
    "dropphyadd": "608 E MAIN ST",
    "dropphycty": "DWIGHT",
    "dropphyst": "KS",
    "dropphyzpp": 668499998,
    "dropmaladd": "608 E MAIN ST",
    "dropmalcty": "DWIGHT",
    "dropmalst": "KS",
    "dropmalzpp": 668499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854823895,
    "dropsitcph": 7854823895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20467",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "220 W RILEY ST",
    "dropdelcty": "EASTON",
    "dropdelst": "KS",
    "dropdelzpp": 660209998,
    "dropphyadd": "220 W RILEY ST",
    "dropphycty": "EASTON",
    "dropphyst": "KS",
    "dropphyzpp": 660209998,
    "dropmaladd": "220 W RILEY ST",
    "dropmalcty": "EASTON",
    "dropmalst": "KS",
    "dropmalzpp": 660209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137735797,
    "dropsitcph": 9137735797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20470",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "328 E NELSON ST",
    "dropdelcty": "EDGERTON",
    "dropdelst": "KS",
    "dropdelzpp": 660219998,
    "dropphyadd": "328 E NELSON ST",
    "dropphycty": "EDGERTON",
    "dropphyst": "KS",
    "dropphyzpp": 660219998,
    "dropmaladd": "328 E NELSON ST",
    "dropmalcty": "EDGERTON",
    "dropmalst": "KS",
    "dropmalzpp": 660219998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138936784,
    "dropsitcph": 9138936784,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20473",
    "droptype": "D",
    "dropname": "EDNA",
    "dropdeladd": "109 N DELAWARE ST",
    "dropdelcty": "EDNA",
    "dropdelst": "KS",
    "dropdelzpp": 673429998,
    "dropphyadd": "109 N DELAWARE ST",
    "dropphycty": "EDNA",
    "dropphyst": "KS",
    "dropphyzpp": 673429998,
    "dropmaladd": "109 N DELAWARE ST",
    "dropmalcty": "EDNA",
    "dropmalst": "KS",
    "dropmalzpp": 673429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209227461,
    "dropsitcph": 6209227461,
    "dropfax": 6209227461
  },
  {
    "dcode": "D",
    "dropkey": "PW20474",
    "droptype": "D",
    "dropname": "EDSON",
    "dropdeladd": "6419 MAIN ST",
    "dropdelcty": "EDSON",
    "dropdelst": "KS",
    "dropdelzpp": 677339201,
    "dropphyadd": "6419 MAIN ST",
    "dropphycty": "EDSON",
    "dropphyst": "KS",
    "dropphyzpp": 677339201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDSON",
    "dropmalst": "KS",
    "dropmalzpp": 677339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858995890,
    "dropsitcph": 7858995890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20477",
    "droptype": "D",
    "dropname": "EFFINGHAM",
    "dropdeladd": "407 MAIN ST",
    "dropdelcty": "EFFINGHAM",
    "dropdelst": "KS",
    "dropdelzpp": 660239998,
    "dropphyadd": "407 MAIN ST",
    "dropphycty": "EFFINGHAM",
    "dropphyst": "KS",
    "dropphyzpp": 660239998,
    "dropmaladd": "407 MAIN ST",
    "dropmalcty": "EFFINGHAM",
    "dropmalst": "KS",
    "dropmalzpp": 660239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138335825,
    "dropsitcph": 9138335825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20478",
    "droptype": "D",
    "dropname": "EL DORADO",
    "dropdeladd": "131 E CENTRAL AVE",
    "dropdelcty": "EL DORADO",
    "dropdelst": "KS",
    "dropdelzpp": 670429998,
    "dropphyadd": "131 E CENTRAL AVE",
    "dropphycty": "EL DORADO",
    "dropphyst": "KS",
    "dropphyzpp": 670429998,
    "dropmaladd": "131 E CENTRAL AVE",
    "dropmalcty": "EL DORADO",
    "dropmalst": "KS",
    "dropmalzpp": 670429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3163215950,
    "dropsitcph": 3163215950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20479",
    "droptype": "D",
    "dropname": "ELBING",
    "dropdeladd": "225 N MAIN ST",
    "dropdelcty": "ELBING",
    "dropdelst": "KS",
    "dropdelzpp": 670418807,
    "dropphyadd": "225 N MAIN ST",
    "dropphycty": "ELBING",
    "dropphyst": "KS",
    "dropphyzpp": 670418807,
    "dropmaladd": "225 N MAIN ST",
    "dropmalcty": "ELBING",
    "dropmalst": "KS",
    "dropmalzpp": 670418807,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167992681,
    "dropsitcph": 3167992681,
    "dropfax": 3167992681
  },
  {
    "dcode": "D",
    "dropkey": "PW20481",
    "droptype": "D",
    "dropname": "ELK CITY",
    "dropdeladd": "123 E HICKORY ST",
    "dropdelcty": "ELK CITY",
    "dropdelst": "KS",
    "dropdelzpp": 673449998,
    "dropphyadd": "123 E HICKORY ST",
    "dropphycty": "ELK CITY",
    "dropphyst": "KS",
    "dropphyzpp": 673449998,
    "dropmaladd": "123 E HICKORY ST",
    "dropmalcty": "ELK CITY",
    "dropmalst": "KS",
    "dropmalzpp": 673449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206272500,
    "dropsitcph": 6206272500,
    "dropfax": 6206272500
  },
  {
    "dcode": "D",
    "dropkey": "PW20484",
    "droptype": "D",
    "dropname": "ELK FALLS",
    "dropdeladd": "712 7TH ST",
    "dropdelcty": "ELK FALLS",
    "dropdelst": "KS",
    "dropdelzpp": 673459998,
    "dropphyadd": "712 7TH ST",
    "dropphycty": "ELK FALLS",
    "dropphyst": "KS",
    "dropphyzpp": 673459998,
    "dropmaladd": "712 7TH ST",
    "dropmalcty": "ELK FALLS",
    "dropmalst": "KS",
    "dropmalzpp": 673459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203294413,
    "dropsitcph": 6203294413,
    "dropfax": 6203294413
  },
  {
    "dcode": "D",
    "dropkey": "PW20486",
    "droptype": "D",
    "dropname": "ELKHART",
    "dropdeladd": "336 MORTON ST",
    "dropdelcty": "ELKHART",
    "dropdelst": "KS",
    "dropdelzpp": 679509998,
    "dropphyadd": "336 MORTON ST",
    "dropphycty": "ELKHART",
    "dropphyst": "KS",
    "dropphyzpp": 679509998,
    "dropmaladd": "336 MORTON ST",
    "dropmalcty": "ELKHART",
    "dropmalst": "KS",
    "dropmalzpp": 679509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206974421,
    "dropsitcph": 6206974421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20488",
    "droptype": "D",
    "dropname": "ELLINWOOD",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "ELLINWOOD",
    "dropdelst": "KS",
    "dropdelzpp": 675269998,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "ELLINWOOD",
    "dropphyst": "KS",
    "dropphyzpp": 675269998,
    "dropmaladd": "200 N MAIN ST",
    "dropmalcty": "ELLINWOOD",
    "dropmalst": "KS",
    "dropmalzpp": 675269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205642840,
    "dropsitcph": 6205642840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20489",
    "droptype": "D",
    "dropname": "ELLIS",
    "dropdeladd": "807 JEFFERSON ST",
    "dropdelcty": "ELLIS",
    "dropdelst": "KS",
    "dropdelzpp": 676379998,
    "dropphyadd": "807 JEFFERSON ST",
    "dropphycty": "ELLIS",
    "dropphyst": "KS",
    "dropphyzpp": 676379998,
    "dropmaladd": "807 JEFFERSON ST",
    "dropmalcty": "ELLIS",
    "dropmalst": "KS",
    "dropmalzpp": 676379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857264900,
    "dropsitcph": 7857264900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20490",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "123 W 2ND ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "KS",
    "dropdelzpp": 674399998,
    "dropphyadd": "123 W 2ND ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "KS",
    "dropphyzpp": 674399998,
    "dropmaladd": "123 W 2ND ST",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "KS",
    "dropmalzpp": 674399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854724001,
    "dropsitcph": 7854724001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20491",
    "droptype": "D",
    "dropname": "ELMDALE",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "ELMDALE",
    "dropdelst": "KS",
    "dropdelzpp": 668509998,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "ELMDALE",
    "dropphyst": "KS",
    "dropphyzpp": 668509998,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "ELMDALE",
    "dropmalst": "KS",
    "dropmalzpp": 668509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202738671,
    "dropsitcph": 6202738671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20496",
    "droptype": "D",
    "dropname": "ELWOOD",
    "dropdeladd": "607 VERMONT ST",
    "dropdelcty": "ELWOOD",
    "dropdelst": "KS",
    "dropdelzpp": 660249998,
    "dropphyadd": "607 VERMONT ST",
    "dropphycty": "ELWOOD",
    "dropphyst": "KS",
    "dropphyzpp": 660249998,
    "dropmaladd": "607 VERMONT ST",
    "dropmalcty": "ELWOOD",
    "dropmalst": "KS",
    "dropmalzpp": 660249998,
    "dropsitphn": 8165043362,
    "dropsitlph": 3163652077,
    "dropsitcph": 9133652077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20498",
    "droptype": "D",
    "dropname": "EMMETT",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "EMMETT",
    "dropdelst": "KS",
    "dropdelzpp": 664229998,
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "EMMETT",
    "dropphyst": "KS",
    "dropphyzpp": 664229998,
    "dropmaladd": "501 MAIN ST",
    "dropmalcty": "EMMETT",
    "dropmalst": "KS",
    "dropmalzpp": 664229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855358202,
    "dropsitcph": 7855358202,
    "dropfax": 7855358202
  },
  {
    "dcode": "D",
    "dropkey": "PW20500",
    "droptype": "D",
    "dropname": "EMPORIA",
    "dropdeladd": "625 MERCHANT ST",
    "dropdelcty": "EMPORIA",
    "dropdelst": "KS",
    "dropdelzpp": 668019998,
    "dropphyadd": "625 MERCHANT ST",
    "dropphycty": "EMPORIA",
    "dropphyst": "KS",
    "dropphyzpp": 668019998,
    "dropmaladd": "625 MERCHANT ST",
    "dropmalcty": "EMPORIA",
    "dropmalst": "KS",
    "dropmalzpp": 668019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203422372,
    "dropsitcph": 6203422372,
    "dropfax": 6203426016
  },
  {
    "dcode": "D",
    "dropkey": "PW20501",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "100 N STATE ROAD 283",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "KS",
    "dropdelzpp": 678409500,
    "dropphyadd": "100 N STATE ROAD 283",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "KS",
    "dropphyzpp": 678409500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "KS",
    "dropmalzpp": 678409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205392465,
    "dropsitcph": 6205392465,
    "dropfax": 6205392465
  },
  {
    "dcode": "D",
    "dropkey": "PW20502",
    "droptype": "D",
    "dropname": "ENSIGN",
    "dropdeladd": "306 AUBREY ST",
    "dropdelcty": "ENSIGN",
    "dropdelst": "KS",
    "dropdelzpp": 678419998,
    "dropphyadd": "306 AUBREY ST",
    "dropphycty": "ENSIGN",
    "dropphyst": "KS",
    "dropphyzpp": 678419998,
    "dropmaladd": "306 AUBREY ST",
    "dropmalcty": "ENSIGN",
    "dropmalst": "KS",
    "dropmalzpp": 678419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208654444,
    "dropsitcph": 6208654444,
    "dropfax": 6208654444
  },
  {
    "dcode": "D",
    "dropkey": "PW20503",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "113 S FACTORY",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "KS",
    "dropdelzpp": 674419998,
    "dropphyadd": "113 S FACTORY",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "KS",
    "dropphyzpp": 674419998,
    "dropmaladd": "113 S FACTORY",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "KS",
    "dropmalzpp": 674419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852638513,
    "dropsitcph": 7852638513,
    "dropfax": 7852638513
  },
  {
    "dcode": "D",
    "dropkey": "PW20504",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "115 W 2ND ST",
    "dropdelcty": "ERIE",
    "dropdelst": "KS",
    "dropdelzpp": 667339998,
    "dropphyadd": "115 W 2ND ST",
    "dropphycty": "ERIE",
    "dropphyst": "KS",
    "dropphyzpp": 667339998,
    "dropmaladd": "115 W 2ND ST",
    "dropmalcty": "ERIE",
    "dropmalst": "KS",
    "dropmalzpp": 667339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202443261,
    "dropsitcph": 6202443261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20505",
    "droptype": "D",
    "dropname": "ESBON",
    "dropdeladd": "315 GRAND AVE",
    "dropdelcty": "ESBON",
    "dropdelst": "KS",
    "dropdelzpp": 669419998,
    "dropphyadd": "315 GRAND AVE",
    "dropphycty": "ESBON",
    "dropphyst": "KS",
    "dropphyzpp": 669419998,
    "dropmaladd": "315 GRAND AVE",
    "dropmalcty": "ESBON",
    "dropmalst": "KS",
    "dropmalzpp": 669419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857253595,
    "dropsitcph": 7857253595,
    "dropfax": 7857253595
  },
  {
    "dcode": "D",
    "dropkey": "PW20506",
    "droptype": "D",
    "dropname": "ESKRIDGE",
    "dropdeladd": "122 S MAIN ST",
    "dropdelcty": "ESKRIDGE",
    "dropdelst": "KS",
    "dropdelzpp": 664239998,
    "dropphyadd": "122 S MAIN ST",
    "dropphycty": "ESKRIDGE",
    "dropphyst": "KS",
    "dropphyzpp": 664239998,
    "dropmaladd": "122 S MAIN ST",
    "dropmalcty": "ESKRIDGE",
    "dropmalst": "KS",
    "dropmalzpp": 664239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854492280,
    "dropsitcph": 7854492280,
    "dropfax": 7854492280
  },
  {
    "dcode": "D",
    "dropkey": "PW20509",
    "droptype": "D",
    "dropname": "EUDORA",
    "dropdeladd": "709 MAIN ST",
    "dropdelcty": "EUDORA",
    "dropdelst": "KS",
    "dropdelzpp": 660259998,
    "dropphyadd": "709 MAIN ST",
    "dropphycty": "EUDORA",
    "dropphyst": "KS",
    "dropphyzpp": 660259998,
    "dropmaladd": "709 MAIN ST",
    "dropmalcty": "EUDORA",
    "dropmalst": "KS",
    "dropmalzpp": 660259998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855422663,
    "dropsitcph": 7855422663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20512",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "301 N OAK ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "KS",
    "dropdelzpp": 670459998,
    "dropphyadd": "301 N OAK ST",
    "dropphycty": "EUREKA",
    "dropphyst": "KS",
    "dropphyzpp": 670459998,
    "dropmaladd": "301 N OAK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "KS",
    "dropmalzpp": 670459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205835451,
    "dropsitcph": 6205835451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20513",
    "droptype": "D",
    "dropname": "EVEREST",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "EVEREST",
    "dropdelst": "KS",
    "dropdelzpp": 664249998,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "EVEREST",
    "dropphyst": "KS",
    "dropphyzpp": 664249998,
    "dropmaladd": "601 MAIN ST",
    "dropmalcty": "EVEREST",
    "dropmalst": "KS",
    "dropmalzpp": 664249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855487556,
    "dropsitcph": 7855487556,
    "dropfax": 7855487556
  },
  {
    "dcode": "D",
    "dropkey": "PW20517",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "210 S WALNUT ST",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "KS",
    "dropdelzpp": 664259998,
    "dropphyadd": "210 S WALNUT ST",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "KS",
    "dropphyzpp": 664259998,
    "dropmaladd": "210 S WALNUT ST",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "KS",
    "dropmalzpp": 664259998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853369106,
    "dropsitcph": 7853369106,
    "dropfax": 7854673900
  },
  {
    "dcode": "D",
    "dropkey": "PW20523",
    "droptype": "D",
    "dropname": "FALL RIVER",
    "dropdeladd": "412 MERCHANTS AVE",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "KS",
    "dropdelzpp": 670479527,
    "dropphyadd": "412 MERCHANTS AVE",
    "dropphycty": "FALL RIVER",
    "dropphyst": "KS",
    "dropphyzpp": 670479527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "KS",
    "dropmalzpp": 670479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206584670,
    "dropsitcph": 6206584670,
    "dropfax": 6206584670
  },
  {
    "dcode": "D",
    "dropkey": "PW20526",
    "droptype": "D",
    "dropname": "FALUN",
    "dropdeladd": "209 S MAIN ST",
    "dropdelcty": "FALUN",
    "dropdelst": "KS",
    "dropdelzpp": 674429998,
    "dropphyadd": "209 S MAIN ST",
    "dropphycty": "FALUN",
    "dropphyst": "KS",
    "dropphyzpp": 674429998,
    "dropmaladd": "209 S MAIN ST",
    "dropmalcty": "FALUN",
    "dropmalst": "KS",
    "dropmalzpp": 674429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856682311,
    "dropsitcph": 7856682311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20538",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "KS",
    "dropdelzpp": 668519998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "KS",
    "dropphyzpp": 668519998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "KS",
    "dropmalzpp": 668519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208784447,
    "dropsitcph": 6208784447,
    "dropfax": 6208784447
  },
  {
    "dcode": "D",
    "dropkey": "PW20539",
    "droptype": "D",
    "dropname": "FONTANA",
    "dropdeladd": "108 N OSAGE ST",
    "dropdelcty": "FONTANA",
    "dropdelst": "KS",
    "dropdelzpp": 660269998,
    "dropphyadd": "108 N OSAGE ST",
    "dropphycty": "FONTANA",
    "dropphyst": "KS",
    "dropphyzpp": 660269998,
    "dropmaladd": "108 N OSAGE ST",
    "dropmalcty": "FONTANA",
    "dropmalst": "KS",
    "dropmalzpp": 660269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138493150,
    "dropsitcph": 9138493150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20543",
    "droptype": "D",
    "dropname": "FORD",
    "dropdeladd": "601 N MAIN ST",
    "dropdelcty": "FORD",
    "dropdelst": "KS",
    "dropdelzpp": 678429998,
    "dropphyadd": "601 N MAIN ST",
    "dropphycty": "FORD",
    "dropphyst": "KS",
    "dropphyzpp": 678429998,
    "dropmaladd": "601 N MAIN ST",
    "dropmalcty": "FORD",
    "dropmalst": "KS",
    "dropmalzpp": 678429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203692228,
    "dropsitcph": 6203692228,
    "dropfax": 6203692228
  },
  {
    "dcode": "D",
    "dropkey": "PW20544",
    "droptype": "D",
    "dropname": "FORMOSO",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "FORMOSO",
    "dropdelst": "KS",
    "dropdelzpp": 669429795,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "FORMOSO",
    "dropphyst": "KS",
    "dropphyzpp": 669429795,
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "FORMOSO",
    "dropmalst": "KS",
    "dropmalzpp": 669429795,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857942336,
    "dropsitcph": 7857942336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20551",
    "droptype": "D",
    "dropname": "FORT SCOTT",
    "dropdeladd": "120 S NATIONAL AVE",
    "dropdelcty": "FORT SCOTT",
    "dropdelst": "KS",
    "dropdelzpp": 667019998,
    "dropphyadd": "120 S NATIONAL AVE",
    "dropphycty": "FORT SCOTT",
    "dropphyst": "KS",
    "dropphyzpp": 667019998,
    "dropmaladd": "120 S NATIONAL AVE",
    "dropmalcty": "FORT SCOTT",
    "dropmalst": "KS",
    "dropmalzpp": 667019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202231410,
    "dropsitcph": 6202231410,
    "dropfax": 6505784613
  },
  {
    "dcode": "D",
    "dropkey": "PW20554",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "410 N MAIN ST",
    "dropdelcty": "FOWLER",
    "dropdelst": "KS",
    "dropdelzpp": 678449998,
    "dropphyadd": "410 N MAIN ST",
    "dropphycty": "FOWLER",
    "dropphyst": "KS",
    "dropphyzpp": 678449998,
    "dropmaladd": "410 N MAIN ST",
    "dropmalcty": "FOWLER",
    "dropmalst": "KS",
    "dropmalzpp": 678449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206465292,
    "dropsitcph": 6206465292,
    "dropfax": 6206465292
  },
  {
    "dcode": "D",
    "dropkey": "PW20556",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "137 W 2ND ST",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "KS",
    "dropdelzpp": 664279998,
    "dropphyadd": "137 W 2ND ST",
    "dropphycty": "FRANKFORT",
    "dropphyst": "KS",
    "dropphyzpp": 664279998,
    "dropmaladd": "137 W 2ND ST",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "KS",
    "dropmalzpp": 664279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852924834,
    "dropsitcph": 7852924834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20563",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "428 MADISON ST",
    "dropdelcty": "FREDONIA",
    "dropdelst": "KS",
    "dropdelzpp": 667369998,
    "dropphyadd": "428 MADISON ST",
    "dropphycty": "FREDONIA",
    "dropphyst": "KS",
    "dropphyzpp": 667369998,
    "dropmaladd": "428 MADISON ST",
    "dropmalcty": "FREDONIA",
    "dropmalst": "KS",
    "dropmalzpp": 667369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203783721,
    "dropsitcph": 6203783721,
    "dropfax": 6203783281
  },
  {
    "dcode": "D",
    "dropkey": "PW20583",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "119 E 5TH ST",
    "dropdelcty": "GALENA",
    "dropdelst": "KS",
    "dropdelzpp": 667399998,
    "dropphyadd": "119 E 5TH ST",
    "dropphycty": "GALENA",
    "dropphyst": "KS",
    "dropphyzpp": 667399998,
    "dropmaladd": "119 E 5TH ST",
    "dropmalcty": "GALENA",
    "dropmalst": "KS",
    "dropmalzpp": 667399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207831775,
    "dropsitcph": 6207831775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20584",
    "droptype": "D",
    "dropname": "GALESBURG",
    "dropdeladd": "119 CENTER ST",
    "dropdelcty": "GALESBURG",
    "dropdelst": "KS",
    "dropdelzpp": 667409998,
    "dropphyadd": "119 CENTER ST",
    "dropphycty": "GALESBURG",
    "dropphyst": "KS",
    "dropphyzpp": 667409998,
    "dropmaladd": "119 CENTER ST",
    "dropmalcty": "GALESBURG",
    "dropmalst": "KS",
    "dropmalzpp": 667409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207632344,
    "dropsitcph": 6207632344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20585",
    "droptype": "D",
    "dropname": "GALVA",
    "dropdeladd": "216 S MAIN ST",
    "dropdelcty": "GALVA",
    "dropdelst": "KS",
    "dropdelzpp": 674439998,
    "dropphyadd": "216 S MAIN ST",
    "dropphycty": "GALVA",
    "dropphyst": "KS",
    "dropphyzpp": 674439998,
    "dropmaladd": "216 S MAIN ST",
    "dropmalcty": "GALVA",
    "dropmalst": "KS",
    "dropmalzpp": 674439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206543661,
    "dropsitcph": 6206543661,
    "dropfax": 6206543661
  },
  {
    "dcode": "D",
    "dropkey": "PW20586",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "410 N 6TH ST",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "KS",
    "dropdelzpp": 678469998,
    "dropphyadd": "410 N 6TH ST",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "KS",
    "dropphyzpp": 678469998,
    "dropmaladd": "410 N 6TH ST",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "KS",
    "dropmalzpp": 678469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202763432,
    "dropsitcph": 6202763432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20587",
    "droptype": "D",
    "dropname": "GARDEN PLAIN",
    "dropdeladd": "412 N MAIN ST",
    "dropdelcty": "GARDEN PLAIN",
    "dropdelst": "KS",
    "dropdelzpp": 670509998,
    "dropphyadd": "412 N MAIN ST",
    "dropphycty": "GARDEN PLAIN",
    "dropphyst": "KS",
    "dropphyzpp": 670509998,
    "dropmaladd": "412 N MAIN ST",
    "dropmalcty": "GARDEN PLAIN",
    "dropmalst": "KS",
    "dropmalzpp": 670509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165352573,
    "dropsitcph": 3165352573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20588",
    "droptype": "D",
    "dropname": "GARDNER",
    "dropdeladd": "18325 S GARDNER RD",
    "dropdelcty": "GARDNER",
    "dropdelst": "KS",
    "dropdelzpp": 660309998,
    "dropphyadd": "18325 S GARDNER RD",
    "dropphycty": "GARDNER",
    "dropphyst": "KS",
    "dropphyzpp": 660309998,
    "dropmaladd": "18325 S GARDNER RD",
    "dropmalcty": "GARDNER",
    "dropmalst": "KS",
    "dropmalzpp": 660309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138567275,
    "dropsitcph": 9138567275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20590",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "213 3RD ST",
    "dropdelcty": "GARFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 675299600,
    "dropphyadd": "213 3RD ST",
    "dropphycty": "GARFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 675299600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 675299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205692210,
    "dropsitcph": 6205692210,
    "dropfax": 6205692210
  },
  {
    "dcode": "D",
    "dropkey": "PW20592",
    "droptype": "D",
    "dropname": "GARNETT",
    "dropdeladd": "304 S OAK ST",
    "dropdelcty": "GARNETT",
    "dropdelst": "KS",
    "dropdelzpp": 660329998,
    "dropphyadd": "304 S OAK ST",
    "dropphycty": "GARNETT",
    "dropphyst": "KS",
    "dropphyzpp": 660329998,
    "dropmaladd": "304 S OAK ST",
    "dropmalcty": "GARNETT",
    "dropmalst": "KS",
    "dropmalzpp": 660329998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7854486731,
    "dropsitcph": 7854483312,
    "dropfax": 7854486731
  },
  {
    "dcode": "D",
    "dropkey": "PW20594",
    "droptype": "D",
    "dropname": "GAS",
    "dropdeladd": "102 W 1ST ST",
    "dropdelcty": "GAS",
    "dropdelst": "KS",
    "dropdelzpp": 667429998,
    "dropphyadd": "102 W 1ST ST",
    "dropphycty": "GAS",
    "dropphyst": "KS",
    "dropphyzpp": 667429998,
    "dropmaladd": "102 W 1ST ST",
    "dropmalcty": "GAS",
    "dropmalst": "KS",
    "dropmalzpp": 667429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203657251,
    "dropsitcph": 6203657251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20596",
    "droptype": "D",
    "dropname": "GAYLORD",
    "dropdeladd": "600 5TH ST",
    "dropdelcty": "GAYLORD",
    "dropdelst": "KS",
    "dropdelzpp": 676383891,
    "dropphyadd": "600 5TH ST",
    "dropphycty": "GAYLORD",
    "dropphyst": "KS",
    "dropphyzpp": 676383891,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAYLORD",
    "dropmalst": "KS",
    "dropmalzpp": 676389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856972699,
    "dropsitcph": 7856972699,
    "dropfax": 7856972699
  },
  {
    "dcode": "D",
    "dropkey": "PW20599",
    "droptype": "D",
    "dropname": "GENESEO",
    "dropdeladd": "715 MAIN ST",
    "dropdelcty": "GENESEO",
    "dropdelst": "KS",
    "dropdelzpp": 674449998,
    "dropphyadd": "715 MAIN ST",
    "dropphycty": "GENESEO",
    "dropphyst": "KS",
    "dropphyzpp": 674449998,
    "dropmaladd": "715 MAIN ST",
    "dropmalcty": "GENESEO",
    "dropmalst": "KS",
    "dropmalzpp": 674449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202042025,
    "dropsitcph": 6202042025,
    "dropfax": 6208246214
  },
  {
    "dcode": "D",
    "dropkey": "PW20601",
    "droptype": "D",
    "dropname": "GEUDA SPRINGS",
    "dropdeladd": "117 S 1ST ST",
    "dropdelcty": "GEUDA SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 670518042,
    "dropphyadd": "117 S 1ST ST",
    "dropphycty": "GEUDA SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 670518042,
    "dropmaladd": "117 S 1ST ST",
    "dropmalcty": "GEUDA SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 670518042,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204473210,
    "dropsitcph": 6204473210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20605",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "115 N SUMMIT ST",
    "dropdelcty": "GIRARD",
    "dropdelst": "KS",
    "dropdelzpp": 667439998,
    "dropphyadd": "115 N SUMMIT ST",
    "dropphycty": "GIRARD",
    "dropphyst": "KS",
    "dropphyzpp": 667439998,
    "dropmaladd": "115 N SUMMIT ST",
    "dropmalcty": "GIRARD",
    "dropmalst": "KS",
    "dropmalzpp": 667439998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202245042,
    "dropsitcph": 6202245042,
    "dropfax": 6202245041
  },
  {
    "dcode": "D",
    "dropkey": "PW20608",
    "droptype": "D",
    "dropname": "GLASCO",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "GLASCO",
    "dropdelst": "KS",
    "dropdelzpp": 674459998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "GLASCO",
    "dropphyst": "KS",
    "dropphyzpp": 674459998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "GLASCO",
    "dropmalst": "KS",
    "dropmalzpp": 674459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854074543,
    "dropsitcph": 7854074543,
    "dropfax": 7855682751
  },
  {
    "dcode": "D",
    "dropkey": "PW20609",
    "droptype": "D",
    "dropname": "GLEN ELDER",
    "dropdeladd": "228 W MAIN ST",
    "dropdelcty": "GLEN ELDER",
    "dropdelst": "KS",
    "dropdelzpp": 674469998,
    "dropphyadd": "228 W MAIN ST",
    "dropphycty": "GLEN ELDER",
    "dropphyst": "KS",
    "dropphyzpp": 674469998,
    "dropmaladd": "228 W MAIN ST",
    "dropmalcty": "GLEN ELDER",
    "dropmalst": "KS",
    "dropmalzpp": 674469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855453562,
    "dropsitcph": 7855453562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20610",
    "droptype": "D",
    "dropname": "GODDARD",
    "dropdeladd": "328 N MAIN ST",
    "dropdelcty": "GODDARD",
    "dropdelst": "KS",
    "dropdelzpp": 670529998,
    "dropphyadd": "328 N MAIN ST",
    "dropphycty": "GODDARD",
    "dropphyst": "KS",
    "dropphyzpp": 670529998,
    "dropmaladd": "328 N MAIN ST",
    "dropmalcty": "GODDARD",
    "dropmalst": "KS",
    "dropmalzpp": 670529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167948123,
    "dropsitcph": 3167947647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20611",
    "droptype": "D",
    "dropname": "GOESSEL",
    "dropdeladd": "207 E MAIN ST",
    "dropdelcty": "GOESSEL",
    "dropdelst": "KS",
    "dropdelzpp": 670539000,
    "dropphyadd": "207 E MAIN ST",
    "dropphycty": "GOESSEL",
    "dropphyst": "KS",
    "dropphyzpp": 670539000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOESSEL",
    "dropmalst": "KS",
    "dropmalzpp": 670539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203678401,
    "dropsitcph": 6203678401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20612",
    "droptype": "D",
    "dropname": "GOFF",
    "dropdeladd": "1737 STATE HIGHWAY 9",
    "dropdelcty": "GOFF",
    "dropdelst": "KS",
    "dropdelzpp": 664288700,
    "dropphyadd": "1737 STATE HIGHWAY 9",
    "dropphycty": "GOFF",
    "dropphyst": "KS",
    "dropphyzpp": 664288700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOFF",
    "dropmalst": "KS",
    "dropmalzpp": 664289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859392580,
    "dropsitcph": 7859392580,
    "dropfax": 7859392580
  },
  {
    "dcode": "D",
    "dropkey": "PW20613",
    "droptype": "D",
    "dropname": "GOODLAND",
    "dropdeladd": "124 E 11TH ST",
    "dropdelcty": "GOODLAND",
    "dropdelst": "KS",
    "dropdelzpp": 677359998,
    "dropphyadd": "124 E 11TH ST",
    "dropphycty": "GOODLAND",
    "dropphyst": "KS",
    "dropphyzpp": 677359998,
    "dropmaladd": "124 E 11TH ST",
    "dropmalcty": "GOODLAND",
    "dropmalst": "KS",
    "dropmalzpp": 677359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858997212,
    "dropsitcph": 7858997212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20615",
    "droptype": "D",
    "dropname": "GORHAM",
    "dropdeladd": "119 E US HIGHWAY 40",
    "dropdelcty": "GORHAM",
    "dropdelst": "KS",
    "dropdelzpp": 676409602,
    "dropphyadd": "119 E US HIGHWAY 40",
    "dropphycty": "GORHAM",
    "dropphyst": "KS",
    "dropphyzpp": 676409602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GORHAM",
    "dropmalst": "KS",
    "dropmalzpp": 676409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856375324,
    "dropsitcph": 7856375324,
    "dropfax": 7856375324
  },
  {
    "dcode": "D",
    "dropkey": "PW20616",
    "droptype": "D",
    "dropname": "GOVE",
    "dropdeladd": "402 BROAD ST",
    "dropdelcty": "GOVE",
    "dropdelst": "KS",
    "dropdelzpp": 677369998,
    "dropphyadd": "402 BROAD ST",
    "dropphycty": "GOVE",
    "dropphyst": "KS",
    "dropphyzpp": 677369998,
    "dropmaladd": "402 BROAD ST",
    "dropmalcty": "GOVE",
    "dropmalst": "KS",
    "dropmalzpp": 677369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859382265,
    "dropsitcph": 7859382265,
    "dropfax": 7859382265
  },
  {
    "dcode": "D",
    "dropkey": "PW20618",
    "droptype": "D",
    "dropname": "GRAINFIELD",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "GRAINFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 677379998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "GRAINFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 677379998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "GRAINFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 677379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856734686,
    "dropsitcph": 7856734686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20623",
    "droptype": "D",
    "dropname": "GRANTVILLE",
    "dropdeladd": "2123 WASHINGTON ST",
    "dropdelcty": "GRANTVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 664299998,
    "dropphyadd": "2123 WASHINGTON ST",
    "dropphycty": "GRANTVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 664299998,
    "dropmaladd": "2123 WASHINGTON ST",
    "dropmalcty": "GRANTVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 664299998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852463099,
    "dropsitcph": 7852463099,
    "dropfax": 7852463099
  },
  {
    "dcode": "D",
    "dropkey": "PW20626",
    "droptype": "D",
    "dropname": "GREAT BEND",
    "dropdeladd": "2100 16TH ST",
    "dropdelcty": "GREAT BEND",
    "dropdelst": "KS",
    "dropdelzpp": 675309998,
    "dropphyadd": "2100 16TH ST",
    "dropphycty": "GREAT BEND",
    "dropphyst": "KS",
    "dropphyzpp": 675309998,
    "dropmaladd": "2100 16TH ST",
    "dropmalcty": "GREAT BEND",
    "dropmalst": "KS",
    "dropmalzpp": 675309998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207924381,
    "dropsitcph": 6207924381,
    "dropfax": 6207927442
  },
  {
    "dcode": "D",
    "dropkey": "PW20627",
    "droptype": "D",
    "dropname": "GREELEY",
    "dropdeladd": "114 W BROWN ST",
    "dropdelcty": "GREELEY",
    "dropdelst": "KS",
    "dropdelzpp": 660339998,
    "dropphyadd": "114 W BROWN ST",
    "dropphycty": "GREELEY",
    "dropphyst": "KS",
    "dropphyzpp": 660339998,
    "dropmaladd": "114 W BROWN ST",
    "dropmalcty": "GREELEY",
    "dropmalst": "KS",
    "dropmalzpp": 660339998,
    "dropsitphn": 8165043362,
    "dropsitlph": 3913867223,
    "dropsitcph": 7858672230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20628",
    "droptype": "D",
    "dropname": "GREEN",
    "dropdeladd": "110 DIXON AVE",
    "dropdelcty": "GREEN",
    "dropdelst": "KS",
    "dropdelzpp": 674479998,
    "dropphyadd": "110 DIXON AVE",
    "dropphycty": "GREEN",
    "dropphyst": "KS",
    "dropphyzpp": 674479998,
    "dropmaladd": "110 DIXON AVE",
    "dropmalcty": "GREEN",
    "dropmalst": "KS",
    "dropmalzpp": 674479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859443441,
    "dropsitcph": 7859443441,
    "dropfax": 7859443441
  },
  {
    "dcode": "D",
    "dropkey": "PW20631",
    "droptype": "D",
    "dropname": "GREENLEAF",
    "dropdeladd": "418 COMMERCIAL ST",
    "dropdelcty": "GREENLEAF",
    "dropdelst": "KS",
    "dropdelzpp": 669439998,
    "dropphyadd": "418 COMMERCIAL ST",
    "dropphycty": "GREENLEAF",
    "dropphyst": "KS",
    "dropphyzpp": 669439998,
    "dropmaladd": "418 COMMERCIAL ST",
    "dropmalcty": "GREENLEAF",
    "dropmalst": "KS",
    "dropmalzpp": 669439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857472625,
    "dropsitcph": 7857472625,
    "dropfax": 7857472625
  },
  {
    "dcode": "D",
    "dropkey": "PW20632",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "KS",
    "dropdelzpp": 670541724,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "GREENSBURG",
    "dropphyst": "KS",
    "dropphyzpp": 670541724,
    "dropmaladd": "116 S MAIN ST",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "KS",
    "dropmalzpp": 670541724,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207232341,
    "dropsitcph": 6207232341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20634",
    "droptype": "D",
    "dropname": "GRENOLA",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "GRENOLA",
    "dropdelst": "KS",
    "dropdelzpp": 673469998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "GRENOLA",
    "dropphyst": "KS",
    "dropphyzpp": 673469998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "GRENOLA",
    "dropmalst": "KS",
    "dropmalzpp": 673469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203582501,
    "dropsitcph": 6203582501,
    "dropfax": 6203582501
  },
  {
    "dcode": "D",
    "dropkey": "PW20636",
    "droptype": "D",
    "dropname": "GRIDLEY",
    "dropdeladd": "423 MAIN ST",
    "dropdelcty": "GRIDLEY",
    "dropdelst": "KS",
    "dropdelzpp": 668529998,
    "dropphyadd": "423 MAIN ST",
    "dropphycty": "GRIDLEY",
    "dropphyst": "KS",
    "dropphyzpp": 668529998,
    "dropmaladd": "423 MAIN ST",
    "dropmalcty": "GRIDLEY",
    "dropmalst": "KS",
    "dropmalzpp": 668529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208364522,
    "dropsitcph": 6208364522,
    "dropfax": 6208364522
  },
  {
    "dcode": "D",
    "dropkey": "PW20638",
    "droptype": "D",
    "dropname": "GRINNELL",
    "dropdeladd": "93 S ADAMS ST",
    "dropdelcty": "GRINNELL",
    "dropdelst": "KS",
    "dropdelzpp": 677389998,
    "dropphyadd": "93 S ADAMS ST",
    "dropphycty": "GRINNELL",
    "dropphyst": "KS",
    "dropphyzpp": 677389998,
    "dropmaladd": "93 S ADAMS ST",
    "dropmalcty": "GRINNELL",
    "dropmalst": "KS",
    "dropmalzpp": 677389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858243242,
    "dropsitcph": 7858243242,
    "dropfax": 7858243242
  },
  {
    "dcode": "D",
    "dropkey": "PW20642",
    "droptype": "D",
    "dropname": "GYPSUM",
    "dropdeladd": "520 MAPLE ST",
    "dropdelcty": "GYPSUM",
    "dropdelst": "KS",
    "dropdelzpp": 674489998,
    "dropphyadd": "520 MAPLE ST",
    "dropphycty": "GYPSUM",
    "dropphyst": "KS",
    "dropphyzpp": 674489998,
    "dropmaladd": "520 MAPLE ST",
    "dropmalcty": "GYPSUM",
    "dropmalst": "KS",
    "dropmalzpp": 674489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855364388,
    "dropsitcph": 7855364388,
    "dropfax": 7855364388
  },
  {
    "dcode": "D",
    "dropkey": "PW20644",
    "droptype": "D",
    "dropname": "HADDAM",
    "dropdeladd": "503 MAIN ST",
    "dropdelcty": "HADDAM",
    "dropdelst": "KS",
    "dropdelzpp": 669449998,
    "dropphyadd": "503 MAIN ST",
    "dropphycty": "HADDAM",
    "dropphyst": "KS",
    "dropphyzpp": 669449998,
    "dropmaladd": "503 MAIN ST",
    "dropmalcty": "HADDAM",
    "dropmalst": "KS",
    "dropmalzpp": 669449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857783331,
    "dropsitcph": 7857783331,
    "dropfax": 7857783331
  },
  {
    "dcode": "D",
    "dropkey": "PW20649",
    "droptype": "D",
    "dropname": "HALSTEAD",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "HALSTEAD",
    "dropdelst": "KS",
    "dropdelzpp": 670569998,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "HALSTEAD",
    "dropphyst": "KS",
    "dropphyzpp": 670569998,
    "dropmaladd": "319 MAIN ST",
    "dropmalcty": "HALSTEAD",
    "dropmalst": "KS",
    "dropmalzpp": 670569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3168350460,
    "dropsitcph": 3168350460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20650",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "29 E MAIN ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "KS",
    "dropdelzpp": 668539998,
    "dropphyadd": "29 E MAIN ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "KS",
    "dropphyzpp": 668539998,
    "dropmaladd": "29 E MAIN ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "KS",
    "dropmalzpp": 668539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206783831,
    "dropsitcph": 6206783831,
    "dropfax": 6206783831
  },
  {
    "dcode": "D",
    "dropkey": "PW20655",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "101 E NORTH ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "KS",
    "dropdelzpp": 669459998,
    "dropphyadd": "101 E NORTH ST",
    "dropphycty": "HANOVER",
    "dropphyst": "KS",
    "dropphyzpp": 669459998,
    "dropmaladd": "101 E NORTH ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "KS",
    "dropmalzpp": 669459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853372262,
    "dropsitcph": 7853372262,
    "dropfax": 7853372262
  },
  {
    "dcode": "D",
    "dropkey": "PW20656",
    "droptype": "D",
    "dropname": "HANSTON",
    "dropdeladd": "104 N LOGAN ST",
    "dropdelcty": "HANSTON",
    "dropdelst": "KS",
    "dropdelzpp": 678499800,
    "dropphyadd": "104 N LOGAN ST",
    "dropphycty": "HANSTON",
    "dropphyst": "KS",
    "dropphyzpp": 678499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANSTON",
    "dropmalst": "KS",
    "dropmalzpp": 678499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206234491,
    "dropsitcph": 6206234491,
    "dropfax": 6206234491
  },
  {
    "dcode": "D",
    "dropkey": "PW20658",
    "droptype": "D",
    "dropname": "HARDTNER",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "HARDTNER",
    "dropdelst": "KS",
    "dropdelzpp": 670579998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "HARDTNER",
    "dropphyst": "KS",
    "dropphyzpp": 670579998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "HARDTNER",
    "dropmalst": "KS",
    "dropmalzpp": 670579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202964684,
    "dropsitcph": 6202964684,
    "dropfax": 6202964684
  },
  {
    "dcode": "D",
    "dropkey": "PW20662",
    "droptype": "D",
    "dropname": "HARPER",
    "dropdeladd": "901 CENTRAL ST",
    "dropdelcty": "HARPER",
    "dropdelst": "KS",
    "dropdelzpp": 670589998,
    "dropphyadd": "901 CENTRAL ST",
    "dropphycty": "HARPER",
    "dropphyst": "KS",
    "dropphyzpp": 670589998,
    "dropmaladd": "901 CENTRAL ST",
    "dropmalcty": "HARPER",
    "dropmalst": "KS",
    "dropmalzpp": 670589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208967557,
    "dropsitcph": 6208967557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20664",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "212 COMMERCIAL ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "KS",
    "dropdelzpp": 668549998,
    "dropphyadd": "212 COMMERCIAL ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "KS",
    "dropphyzpp": 668549998,
    "dropmaladd": "212 COMMERCIAL ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "KS",
    "dropmalzpp": 668549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203925529,
    "dropsitcph": 6203925529,
    "dropfax": 6203925529
  },
  {
    "dcode": "D",
    "dropkey": "PW20668",
    "droptype": "D",
    "dropname": "HARVEYVILLE",
    "dropdeladd": "185 MAIN ST",
    "dropdelcty": "HARVEYVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 664319246,
    "dropphyadd": "185 MAIN ST",
    "dropphycty": "HARVEYVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 664319246,
    "dropmaladd": "185 MAIN ST",
    "dropmalcty": "HARVEYVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 664319246,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855892472,
    "dropsitcph": 7855892472,
    "dropfax": 7855892472
  },
  {
    "dcode": "D",
    "dropkey": "PW20671",
    "droptype": "D",
    "dropname": "HAVANA",
    "dropdeladd": "505 E MARY ST",
    "dropdelcty": "HAVANA",
    "dropdelst": "KS",
    "dropdelzpp": 673479997,
    "dropphyadd": "505 E MARY ST",
    "dropphycty": "HAVANA",
    "dropphyst": "KS",
    "dropphyzpp": 673479997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAVANA",
    "dropmalst": "KS",
    "dropmalzpp": 673479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206734092,
    "dropsitcph": 6206734092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20672",
    "droptype": "D",
    "dropname": "HAVEN",
    "dropdeladd": "106 N KANSAS ST",
    "dropdelcty": "HAVEN",
    "dropdelst": "KS",
    "dropdelzpp": 675439998,
    "dropphyadd": "106 N KANSAS ST",
    "dropphycty": "HAVEN",
    "dropphyst": "KS",
    "dropphyzpp": 675439998,
    "dropmaladd": "106 N KANSAS ST",
    "dropmalcty": "HAVEN",
    "dropmalst": "KS",
    "dropmalzpp": 675439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202078020,
    "dropsitcph": 6202078020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20677",
    "droptype": "D",
    "dropname": "HAVILAND",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "HAVILAND",
    "dropdelst": "KS",
    "dropdelzpp": 670599500,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "HAVILAND",
    "dropphyst": "KS",
    "dropphyzpp": 670599500,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "HAVILAND",
    "dropmalst": "KS",
    "dropmalzpp": 670599500,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208625477,
    "dropsitcph": 6208625477,
    "dropfax": 6208625477
  },
  {
    "dcode": "D",
    "dropkey": "PW20679",
    "droptype": "D",
    "dropname": "HAYS",
    "dropdeladd": "706 FORT ST",
    "dropdelcty": "HAYS",
    "dropdelst": "KS",
    "dropdelzpp": 676019998,
    "dropphyadd": "706 FORT ST",
    "dropphycty": "HAYS",
    "dropphyst": "KS",
    "dropphyzpp": 676019998,
    "dropmaladd": "706 FORT ST",
    "dropmalcty": "HAYS",
    "dropmalst": "KS",
    "dropmalzpp": 676019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856253112,
    "dropsitcph": 7856252012,
    "dropfax": 7856254728
  },
  {
    "dcode": "D",
    "dropkey": "PW20680",
    "droptype": "D",
    "dropname": "HAYSVILLE",
    "dropdeladd": "224 W GRAND AVE",
    "dropdelcty": "HAYSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 670609998,
    "dropphyadd": "224 W GRAND AVE",
    "dropphycty": "HAYSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 670609998,
    "dropmaladd": "224 W GRAND AVE",
    "dropmalcty": "HAYSVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 670609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165245097,
    "dropsitcph": 3165245064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20682",
    "droptype": "D",
    "dropname": "HEALY",
    "dropdeladd": "1001 S ELM ST",
    "dropdelcty": "HEALY",
    "dropdelst": "KS",
    "dropdelzpp": 678509500,
    "dropphyadd": "1001 S ELM ST",
    "dropphycty": "HEALY",
    "dropphyst": "KS",
    "dropphyzpp": 678509500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEALY",
    "dropmalst": "KS",
    "dropmalzpp": 678509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203982242,
    "dropsitcph": 6203982242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20685",
    "droptype": "D",
    "dropname": "HEPLER",
    "dropdeladd": "213 N PRAIRIE AVE",
    "dropdelcty": "HEPLER",
    "dropdelst": "KS",
    "dropdelzpp": 667469998,
    "dropphyadd": "213 N PRAIRIE AVE",
    "dropphycty": "HEPLER",
    "dropphyst": "KS",
    "dropphyzpp": 667469998,
    "dropmaladd": "213 N PRAIRIE AVE",
    "dropmalcty": "HEPLER",
    "dropmalst": "KS",
    "dropmalzpp": 667469998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203684313,
    "dropsitcph": 6203684313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20686",
    "droptype": "D",
    "dropname": "HERINGTON",
    "dropdeladd": "17 E MAIN ST",
    "dropdelcty": "HERINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 674499998,
    "dropphyadd": "17 E MAIN ST",
    "dropphycty": "HERINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 674499998,
    "dropmaladd": "17 E MAIN ST",
    "dropmalcty": "HERINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 674499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852583542,
    "dropsitcph": 7852583542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20688",
    "droptype": "D",
    "dropname": "HERNDON",
    "dropdeladd": "306 S QUINCY AVE",
    "dropdelcty": "HERNDON",
    "dropdelst": "KS",
    "dropdelzpp": 677399731,
    "dropphyadd": "306 S QUINCY AVE",
    "dropphycty": "HERNDON",
    "dropphyst": "KS",
    "dropphyzpp": 677399731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERNDON",
    "dropmalst": "KS",
    "dropmalzpp": 677399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853225241,
    "dropsitcph": 7853225241,
    "dropfax": 7853225241
  },
  {
    "dcode": "D",
    "dropkey": "PW20689",
    "droptype": "D",
    "dropname": "HESSTON",
    "dropdeladd": "120 W KNOTT ST",
    "dropdelcty": "HESSTON",
    "dropdelst": "KS",
    "dropdelzpp": 670629998,
    "dropphyadd": "120 W KNOTT ST",
    "dropphycty": "HESSTON",
    "dropphyst": "KS",
    "dropphyzpp": 670629998,
    "dropmaladd": "120 W KNOTT ST",
    "dropmalcty": "HESSTON",
    "dropmalst": "KS",
    "dropmalzpp": 670629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203274131,
    "dropsitcph": 6203274131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20692",
    "droptype": "D",
    "dropname": "HIAWATHA",
    "dropdeladd": "613 UTAH ST",
    "dropdelcty": "HIAWATHA",
    "dropdelst": "KS",
    "dropdelzpp": 664349998,
    "dropphyadd": "613 UTAH ST",
    "dropphycty": "HIAWATHA",
    "dropphyst": "KS",
    "dropphyzpp": 664349998,
    "dropmaladd": "613 UTAH ST",
    "dropmalcty": "HIAWATHA",
    "dropmalst": "KS",
    "dropmalzpp": 664349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857422921,
    "dropsitcph": 7857422921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20696",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "KS",
    "dropdelzpp": 660359998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "HIGHLAND",
    "dropphyst": "KS",
    "dropphyzpp": 660359998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "KS",
    "dropmalzpp": 660359998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7854423495,
    "dropsitcph": 7854423495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20701",
    "droptype": "D",
    "dropname": "HILL CITY",
    "dropdeladd": "112 E MAIN ST",
    "dropdelcty": "HILL CITY",
    "dropdelst": "KS",
    "dropdelzpp": 676429998,
    "dropphyadd": "112 E MAIN ST",
    "dropphycty": "HILL CITY",
    "dropphyst": "KS",
    "dropphyzpp": 676429998,
    "dropmaladd": "112 E MAIN ST",
    "dropmalcty": "HILL CITY",
    "dropmalst": "KS",
    "dropmalzpp": 676429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854212351,
    "dropsitcph": 7854212351,
    "dropfax": 7854215425
  },
  {
    "dcode": "D",
    "dropkey": "PW20704",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "KS",
    "dropdelzpp": 670639998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "KS",
    "dropphyzpp": 670639998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "KS",
    "dropmalzpp": 670639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202508829,
    "dropsitcph": 6202508829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20706",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "206 CENTRAL ST",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "KS",
    "dropdelzpp": 660369998,
    "dropphyadd": "206 CENTRAL ST",
    "dropphycty": "HILLSDALE",
    "dropphyst": "KS",
    "dropphyzpp": 660369998,
    "dropmaladd": "206 CENTRAL ST",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "KS",
    "dropmalzpp": 660369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137834840,
    "dropsitcph": 9137834840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20711",
    "droptype": "D",
    "dropname": "HOISINGTON",
    "dropdeladd": "121 E 2ND ST",
    "dropdelcty": "HOISINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 675449998,
    "dropphyadd": "121 E 2ND ST",
    "dropphycty": "HOISINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 675449998,
    "dropmaladd": "121 E 2ND ST",
    "dropmalcty": "HOISINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 675449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206532838,
    "dropsitcph": 6206532838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20712",
    "droptype": "D",
    "dropname": "HOLCOMB",
    "dropdeladd": "304 N JONES AVE",
    "dropdelcty": "HOLCOMB",
    "dropdelst": "KS",
    "dropdelzpp": 678519998,
    "dropphyadd": "304 N JONES AVE",
    "dropphycty": "HOLCOMB",
    "dropphyst": "KS",
    "dropphyzpp": 678518600,
    "dropmaladd": "304 N JONES AVE",
    "dropmalcty": "HOLCOMB",
    "dropmalst": "KS",
    "dropmalzpp": 678518600,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202772163,
    "dropsitcph": 6202772163,
    "dropfax": 6202772163
  },
  {
    "dcode": "D",
    "dropkey": "PW20713",
    "droptype": "D",
    "dropname": "HOLLENBERG",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "HOLLENBERG",
    "dropdelst": "KS",
    "dropdelzpp": 669469215,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "HOLLENBERG",
    "dropphyst": "KS",
    "dropphyzpp": 669469215,
    "dropmaladd": "113 MAIN ST",
    "dropmalcty": "HOLLENBERG",
    "dropmalst": "KS",
    "dropmalzpp": 669469215,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853372302,
    "dropsitcph": 7853372302,
    "dropfax": 7853372302
  },
  {
    "dcode": "D",
    "dropkey": "PW20717",
    "droptype": "D",
    "dropname": "HOLTON",
    "dropdeladd": "328 PENNSYLVANIA AVE",
    "dropdelcty": "HOLTON",
    "dropdelst": "KS",
    "dropdelzpp": 664369998,
    "dropphyadd": "328 PENNSYLVANIA AVE",
    "dropphycty": "HOLTON",
    "dropphyst": "KS",
    "dropphyzpp": 664369998,
    "dropmaladd": "328 PENNSYLVANIA AVE",
    "dropmalcty": "HOLTON",
    "dropmalst": "KS",
    "dropmalzpp": 664369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853642212,
    "dropsitcph": 7853642212,
    "dropfax": 7853643724
  },
  {
    "dcode": "D",
    "dropkey": "PW20718",
    "droptype": "D",
    "dropname": "HOLYROOD",
    "dropdeladd": "111 W SANTA FE AVE",
    "dropdelcty": "HOLYROOD",
    "dropdelst": "KS",
    "dropdelzpp": 674509998,
    "dropphyadd": "111 W SANTA FE AVE",
    "dropphycty": "HOLYROOD",
    "dropphyst": "KS",
    "dropphyzpp": 674509998,
    "dropmaladd": "111 W SANTA FE AVE",
    "dropmalcty": "HOLYROOD",
    "dropmalst": "KS",
    "dropmalzpp": 674509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852523674,
    "dropsitcph": 7852523674,
    "dropfax": 7852523674
  },
  {
    "dcode": "D",
    "dropkey": "PW20719",
    "droptype": "D",
    "dropname": "HOME",
    "dropdeladd": "213 2ND ST",
    "dropdelcty": "HOME",
    "dropdelst": "KS",
    "dropdelzpp": 664389998,
    "dropphyadd": "213 2ND ST",
    "dropphycty": "HOME",
    "dropphyst": "KS",
    "dropphyzpp": 664389998,
    "dropmaladd": "213 2ND ST",
    "dropmalcty": "HOME",
    "dropmalst": "KS",
    "dropmalzpp": 664389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857993550,
    "dropsitcph": 7857993550,
    "dropfax": 7857993550
  },
  {
    "dcode": "D",
    "dropkey": "PW20723",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "109 N MAIN ST",
    "dropdelcty": "HOPE",
    "dropdelst": "KS",
    "dropdelzpp": 674519998,
    "dropphyadd": "109 N MAIN ST",
    "dropphycty": "HOPE",
    "dropphyst": "KS",
    "dropphyzpp": 674519998,
    "dropmaladd": "109 N MAIN ST",
    "dropmalcty": "HOPE",
    "dropmalst": "KS",
    "dropmalzpp": 674519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853667317,
    "dropsitcph": 7853667317,
    "dropfax": 7853667317
  },
  {
    "dcode": "D",
    "dropkey": "PW20726",
    "droptype": "D",
    "dropname": "HORTON",
    "dropdeladd": "825 1ST AVE E",
    "dropdelcty": "HORTON",
    "dropdelst": "KS",
    "dropdelzpp": 664399998,
    "dropphyadd": "825 1ST AVE E",
    "dropphycty": "HORTON",
    "dropphyst": "KS",
    "dropphyzpp": 664399998,
    "dropmaladd": "825 1ST AVE E",
    "dropmalcty": "HORTON",
    "dropmalst": "KS",
    "dropmalzpp": 664399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854863561,
    "dropsitcph": 7854863561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20727",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "135 E RANDOLPH ST",
    "dropdelcty": "HOWARD",
    "dropdelst": "KS",
    "dropdelzpp": 673499998,
    "dropphyadd": "135 E RANDOLPH ST",
    "dropphycty": "HOWARD",
    "dropphyst": "KS",
    "dropphyzpp": 673499998,
    "dropmaladd": "135 E RANDOLPH ST",
    "dropmalcty": "HOWARD",
    "dropmalst": "KS",
    "dropmalzpp": 673499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203742281,
    "dropsitcph": 6203742281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20729",
    "droptype": "D",
    "dropname": "HOXIE",
    "dropdeladd": "733 MAIN ST",
    "dropdelcty": "HOXIE",
    "dropdelst": "KS",
    "dropdelzpp": 677409900,
    "dropphyadd": "733 MAIN ST",
    "dropphycty": "HOXIE",
    "dropphyst": "KS",
    "dropphyzpp": 677409900,
    "dropmaladd": "733 MAIN ST",
    "dropmalcty": "HOXIE",
    "dropmalst": "KS",
    "dropmalzpp": 677409900,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856753181,
    "dropsitcph": 7856753181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20730",
    "droptype": "D",
    "dropname": "HOYT",
    "dropdeladd": "109 E 4TH ST",
    "dropdelcty": "HOYT",
    "dropdelst": "KS",
    "dropdelzpp": 664409998,
    "dropphyadd": "109 E 4TH ST",
    "dropphycty": "HOYT",
    "dropphyst": "KS",
    "dropphyzpp": 664409998,
    "dropmaladd": "109 E 4TH ST",
    "dropmalcty": "HOYT",
    "dropmalst": "KS",
    "dropmalzpp": 664409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859866386,
    "dropsitcph": 7859866386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20732",
    "droptype": "D",
    "dropname": "HUGOTON",
    "dropdeladd": "512 S JACKSON ST",
    "dropdelcty": "HUGOTON",
    "dropdelst": "KS",
    "dropdelzpp": 679519998,
    "dropphyadd": "512 S JACKSON ST",
    "dropphycty": "HUGOTON",
    "dropphyst": "KS",
    "dropphyzpp": 679519998,
    "dropmaladd": "512 S JACKSON ST",
    "dropmalcty": "HUGOTON",
    "dropmalst": "KS",
    "dropmalzpp": 679519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205442665,
    "dropsitcph": 6205442665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20733",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "811 NEW YORK ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "KS",
    "dropdelzpp": 667489998,
    "dropphyadd": "811 NEW YORK ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "KS",
    "dropphyzpp": 667489998,
    "dropmaladd": "811 NEW YORK ST",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "KS",
    "dropmalzpp": 667489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204732301,
    "dropsitcph": 6204732301,
    "dropfax": 6204733462
  },
  {
    "dcode": "D",
    "dropkey": "PW20735",
    "droptype": "D",
    "dropname": "HUNTER",
    "dropdeladd": "201 E 1ST ST",
    "dropdelcty": "HUNTER",
    "dropdelst": "KS",
    "dropdelzpp": 674529998,
    "dropphyadd": "201 E 1ST ST",
    "dropphycty": "HUNTER",
    "dropphyst": "KS",
    "dropphyzpp": 674529998,
    "dropmaladd": "201 E 1ST ST",
    "dropmalcty": "HUNTER",
    "dropmalst": "KS",
    "dropmalzpp": 674529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855292345,
    "dropsitcph": 7855292345,
    "dropfax": 7855292345
  },
  {
    "dcode": "D",
    "dropkey": "PW20739",
    "droptype": "D",
    "dropname": "HUTCHINSON",
    "dropdeladd": "128 E 1ST AVE",
    "dropdelcty": "HUTCHINSON",
    "dropdelst": "KS",
    "dropdelzpp": 675019998,
    "dropphyadd": "128 E 1ST AVE",
    "dropphycty": "HUTCHINSON",
    "dropphyst": "KS",
    "dropphyzpp": 675019998,
    "dropmaladd": "128 E 1ST AVE",
    "dropmalcty": "HUTCHINSON",
    "dropmalst": "KS",
    "dropmalzpp": 675019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206621295,
    "dropsitcph": 6206621295,
    "dropfax": 6206626156
  },
  {
    "dcode": "D",
    "dropkey": "PW20744",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "116 E LAUREL ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "KS",
    "dropdelzpp": 673019998,
    "dropphyadd": "116 E LAUREL ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "KS",
    "dropphyzpp": 673019998,
    "dropmaladd": "116 E LAUREL ST",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "KS",
    "dropmalzpp": 673019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203310320,
    "dropsitcph": 6203310320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20751",
    "droptype": "D",
    "dropname": "INGALLS",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "INGALLS",
    "dropdelst": "KS",
    "dropdelzpp": 678539000,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "INGALLS",
    "dropphyst": "KS",
    "dropphyzpp": 678539000,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "INGALLS",
    "dropmalst": "KS",
    "dropmalzpp": 678539000,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203355128,
    "dropsitcph": 6203355128,
    "dropfax": 6203355128
  },
  {
    "dcode": "D",
    "dropkey": "PW20752",
    "droptype": "D",
    "dropname": "INMAN",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "INMAN",
    "dropdelst": "KS",
    "dropdelzpp": 675469998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "INMAN",
    "dropphyst": "KS",
    "dropphyzpp": 675469998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "INMAN",
    "dropmalst": "KS",
    "dropmalzpp": 675469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205856868,
    "dropsitcph": 6205856868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20753",
    "droptype": "D",
    "dropname": "IOLA",
    "dropdeladd": "120 WEST ST",
    "dropdelcty": "IOLA",
    "dropdelst": "KS",
    "dropdelzpp": 667499998,
    "dropphyadd": "120 WEST ST",
    "dropphycty": "IOLA",
    "dropphyst": "KS",
    "dropphyzpp": 667499998,
    "dropmaladd": "120 WEST ST",
    "dropmalcty": "IOLA",
    "dropmalst": "KS",
    "dropmalzpp": 667499998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203655622,
    "dropsitcph": 6203655622,
    "dropfax": 6203656819
  },
  {
    "dcode": "D",
    "dropkey": "PW20756",
    "droptype": "D",
    "dropname": "ISABEL",
    "dropdeladd": "122 N MAIN ST",
    "dropdelcty": "ISABEL",
    "dropdelst": "KS",
    "dropdelzpp": 670659997,
    "dropphyadd": "122 N MAIN ST",
    "dropphycty": "ISABEL",
    "dropphyst": "KS",
    "dropphyzpp": 670659997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISABEL",
    "dropmalst": "KS",
    "dropmalzpp": 670659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207394357,
    "dropsitcph": 6207394357,
    "dropfax": 6207394357
  },
  {
    "dcode": "D",
    "dropkey": "PW20757",
    "droptype": "D",
    "dropname": "IUKA",
    "dropdeladd": "204 N MAIN ST",
    "dropdelcty": "IUKA",
    "dropdelst": "KS",
    "dropdelzpp": 670669500,
    "dropphyadd": "204 N MAIN ST",
    "dropphycty": "IUKA",
    "dropphyst": "KS",
    "dropphyzpp": 670669500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IUKA",
    "dropmalst": "KS",
    "dropmalzpp": 670669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205462272,
    "dropsitcph": 6205462272,
    "dropfax": 6205462272
  },
  {
    "dcode": "D",
    "dropkey": "PW20760",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "304 WALNUT ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "KS",
    "dropdelzpp": 669489998,
    "dropphyadd": "304 WALNUT ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "KS",
    "dropphyzpp": 669489998,
    "dropmaladd": "304 WALNUT ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "KS",
    "dropmalzpp": 669489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854396217,
    "dropsitcph": 7854396217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20768",
    "droptype": "D",
    "dropname": "JENNINGS",
    "dropdeladd": "123 S KANSAS AVE",
    "dropdelcty": "JENNINGS",
    "dropdelst": "KS",
    "dropdelzpp": 676439998,
    "dropphyadd": "123 S KANSAS AVE",
    "dropphycty": "JENNINGS",
    "dropphyst": "KS",
    "dropphyzpp": 676439998,
    "dropmaladd": "123 S KANSAS AVE",
    "dropmalcty": "JENNINGS",
    "dropmalst": "KS",
    "dropmalzpp": 676439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856782283,
    "dropsitcph": 7856782283,
    "dropfax": 7856782283
  },
  {
    "dcode": "D",
    "dropkey": "PW20770",
    "droptype": "D",
    "dropname": "JETMORE",
    "dropdeladd": "320 BOWLUS ST",
    "dropdelcty": "JETMORE",
    "dropdelst": "KS",
    "dropdelzpp": 678549323,
    "dropphyadd": "320 BOWLUS ST",
    "dropphycty": "JETMORE",
    "dropphyst": "KS",
    "dropphyzpp": 678549323,
    "dropmaladd": "320 BOWLUS ST",
    "dropmalcty": "JETMORE",
    "dropmalst": "KS",
    "dropmalzpp": 678549323,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203578338,
    "dropsitcph": 6203578338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20771",
    "droptype": "D",
    "dropname": "JEWELL",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "JEWELL",
    "dropdelst": "KS",
    "dropdelzpp": 669499763,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "JEWELL",
    "dropphyst": "KS",
    "dropphyzpp": 669499763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEWELL",
    "dropmalst": "KS",
    "dropmalzpp": 669499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854283240,
    "dropsitcph": 7854283240,
    "dropfax": 7854283240
  },
  {
    "dcode": "D",
    "dropkey": "PW20772",
    "droptype": "D",
    "dropname": "JOHNSON",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "JOHNSON",
    "dropdelst": "KS",
    "dropdelzpp": 678559998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "JOHNSON",
    "dropphyst": "KS",
    "dropphyzpp": 678559998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "JOHNSON",
    "dropmalst": "KS",
    "dropmalzpp": 678559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204922188,
    "dropsitcph": 6204922188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20774",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "302 W 7TH ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "KS",
    "dropdelzpp": 664419998,
    "dropphyadd": "302 W 7TH ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "KS",
    "dropphyzpp": 664419998,
    "dropmaladd": "302 W 7TH ST",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "KS",
    "dropmalzpp": 664419998,
    "dropsitphn": 7857622101,
    "dropsitlph": 7857622101,
    "dropsitcph": 7857622101,
    "dropfax": 7857622267
  },
  {
    "dcode": "D",
    "dropkey": "PW20781",
    "droptype": "D",
    "dropname": "KANOPOLIS",
    "dropdeladd": "101 N KANSAS AVE",
    "dropdelcty": "KANOPOLIS",
    "dropdelst": "KS",
    "dropdelzpp": 674549998,
    "dropphyadd": "101 N KANSAS AVE",
    "dropphycty": "KANOPOLIS",
    "dropphyst": "KS",
    "dropphyzpp": 674549998,
    "dropmaladd": "101 N KANSAS AVE",
    "dropmalcty": "KANOPOLIS",
    "dropmalst": "KS",
    "dropmalzpp": 674549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854724797,
    "dropsitcph": 7854724797,
    "dropfax": 7854724797
  },
  {
    "dcode": "D",
    "dropkey": "PW20782",
    "droptype": "D",
    "dropname": "KANORADO",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "KANORADO",
    "dropdelst": "KS",
    "dropdelzpp": 677419998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "KANORADO",
    "dropphyst": "KS",
    "dropphyzpp": 677419998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "KANORADO",
    "dropmalst": "KS",
    "dropmalzpp": 677419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853992790,
    "dropsitcph": 7853992790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20788",
    "droptype": "D",
    "dropname": "KANSAS CITY",
    "dropdeladd": "550 NEBRASKA AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661012206,
    "dropphyadd": "550 NEBRASKA AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661012206,
    "dropmaladd": "550 NEBRASKA AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661012206,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 9133210482,
    "dropfax": 9133215244
  },
  {
    "dcode": "D",
    "dropkey": "PW20797",
    "droptype": "D",
    "dropname": "KECHI",
    "dropdeladd": "307 E KECHI RD",
    "dropdelcty": "KECHI",
    "dropdelst": "KS",
    "dropdelzpp": 670679998,
    "dropphyadd": "307 E KECHI RD",
    "dropphycty": "KECHI",
    "dropphyst": "KS",
    "dropphyzpp": 670679998,
    "dropmaladd": "307 E KECHI RD",
    "dropmalcty": "KECHI",
    "dropmalst": "KS",
    "dropmalzpp": 670679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167441822,
    "dropsitcph": 3167441822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20800",
    "droptype": "D",
    "dropname": "KENDALL",
    "dropdeladd": "102 W B ST",
    "dropdelcty": "KENDALL",
    "dropdelst": "KS",
    "dropdelzpp": 678579500,
    "dropphyadd": "102 W B ST",
    "dropphycty": "KENDALL",
    "dropphyst": "KS",
    "dropphyzpp": 678579500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENDALL",
    "dropmalst": "KS",
    "dropmalzpp": 678579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203732441,
    "dropsitcph": 6203732441,
    "dropfax": 6203732241
  },
  {
    "dcode": "D",
    "dropkey": "PW20803",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "KENSINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 669519998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "KENSINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 669519998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "KENSINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 669519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854762806,
    "dropsitcph": 7854762806,
    "dropfax": 7854762806
  },
  {
    "dcode": "D",
    "dropkey": "PW20806",
    "droptype": "D",
    "dropname": "KINCAID",
    "dropdeladd": "100 N COMMERCIAL ST",
    "dropdelcty": "KINCAID",
    "dropdelst": "KS",
    "dropdelzpp": 660399998,
    "dropphyadd": "100 N COMMERCIAL ST",
    "dropphycty": "KINCAID",
    "dropphyst": "KS",
    "dropphyzpp": 660399998,
    "dropmaladd": "100 N COMMERCIAL ST",
    "dropmalcty": "KINCAID",
    "dropmalst": "KS",
    "dropmalzpp": 660399998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204395585,
    "dropsitcph": 6204395585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20808",
    "droptype": "D",
    "dropname": "KINGMAN",
    "dropdeladd": "425 N MAIN ST",
    "dropdelcty": "KINGMAN",
    "dropdelst": "KS",
    "dropdelzpp": 670689998,
    "dropphyadd": "425 N MAIN ST",
    "dropphycty": "KINGMAN",
    "dropphyst": "KS",
    "dropphyzpp": 670689998,
    "dropmaladd": "425 N MAIN ST",
    "dropmalcty": "KINGMAN",
    "dropmalst": "KS",
    "dropmalzpp": 670689998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205322321,
    "dropsitcph": 6205322321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20810",
    "droptype": "D",
    "dropname": "KINSLEY",
    "dropdeladd": "717 MARSH AVE",
    "dropdelcty": "KINSLEY",
    "dropdelst": "KS",
    "dropdelzpp": 675479998,
    "dropphyadd": "717 MARSH AVE",
    "dropphycty": "KINSLEY",
    "dropphyst": "KS",
    "dropphyzpp": 675479998,
    "dropmaladd": "717 MARSH AVE",
    "dropmalcty": "KINSLEY",
    "dropmalst": "KS",
    "dropmalzpp": 675479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206592541,
    "dropsitcph": 6206592541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20811",
    "droptype": "D",
    "dropname": "KIOWA",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "KIOWA",
    "dropdelst": "KS",
    "dropdelzpp": 670709998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "KIOWA",
    "dropphyst": "KS",
    "dropphyzpp": 670709998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "KIOWA",
    "dropmalst": "KS",
    "dropmalzpp": 670709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208254644,
    "dropsitcph": 6208254644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20813",
    "droptype": "D",
    "dropname": "KIRWIN",
    "dropdeladd": "9 SQUARE ST",
    "dropdelcty": "KIRWIN",
    "dropdelst": "KS",
    "dropdelzpp": 676449604,
    "dropphyadd": "9 SQUARE ST",
    "dropphycty": "KIRWIN",
    "dropphyst": "KS",
    "dropphyzpp": 676449604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRWIN",
    "dropmalst": "KS",
    "dropmalzpp": 676449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855436645,
    "dropsitcph": 7855436645,
    "dropfax": 7855436645
  },
  {
    "dcode": "D",
    "dropkey": "PW20814",
    "droptype": "D",
    "dropname": "KISMET",
    "dropdeladd": "506 MAIN ST",
    "dropdelcty": "KISMET",
    "dropdelst": "KS",
    "dropdelzpp": 678599998,
    "dropphyadd": "506 MAIN ST",
    "dropphycty": "KISMET",
    "dropphyst": "KS",
    "dropphyzpp": 678599998,
    "dropmaladd": "506 MAIN ST",
    "dropmalcty": "KISMET",
    "dropmalst": "KS",
    "dropmalzpp": 678599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205637771,
    "dropsitcph": 6205637771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20820",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "122 E 8TH ST",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "KS",
    "dropdelzpp": 675489998,
    "dropphyadd": "122 E 8TH ST",
    "dropphycty": "LA CROSSE",
    "dropphyst": "KS",
    "dropphyzpp": 675489998,
    "dropmaladd": "122 E 8TH ST",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "KS",
    "dropmalzpp": 675489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852222611,
    "dropsitcph": 7852222611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20821",
    "droptype": "D",
    "dropname": "LA CYGNE",
    "dropdeladd": "521 E MARKET ST",
    "dropdelcty": "LA CYGNE",
    "dropdelst": "KS",
    "dropdelzpp": 660409998,
    "dropphyadd": "521 E MARKET ST",
    "dropphycty": "LA CYGNE",
    "dropphyst": "KS",
    "dropphyzpp": 660409998,
    "dropmaladd": "521 E MARKET ST",
    "dropmalcty": "LA CYGNE",
    "dropmalst": "KS",
    "dropmalzpp": 660409998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855719626,
    "dropsitcph": 7855719626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20822",
    "droptype": "D",
    "dropname": "LA HARPE",
    "dropdeladd": "802 S MAIN ST",
    "dropdelcty": "LA HARPE",
    "dropdelst": "KS",
    "dropdelzpp": 667519998,
    "dropphyadd": "802 S MAIN ST",
    "dropphycty": "LA HARPE",
    "dropphyst": "KS",
    "dropphyzpp": 667519998,
    "dropmaladd": "802 S MAIN ST",
    "dropmalcty": "LA HARPE",
    "dropmalst": "KS",
    "dropmalzpp": 667519998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204962235,
    "dropsitcph": 6204962235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20840",
    "droptype": "D",
    "dropname": "LAKIN",
    "dropdeladd": "108 E LINCOLN AVE",
    "dropdelcty": "LAKIN",
    "dropdelst": "KS",
    "dropdelzpp": 678609998,
    "dropphyadd": "108 E LINCOLN AVE",
    "dropphycty": "LAKIN",
    "dropphyst": "KS",
    "dropphyzpp": 678609998,
    "dropmaladd": "108 E LINCOLN AVE",
    "dropmalcty": "LAKIN",
    "dropmalst": "KS",
    "dropmalzpp": 678609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203556760,
    "dropsitcph": 6203556760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20842",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "101 N BROADWAY ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "KS",
    "dropdelzpp": 660419998,
    "dropphyadd": "101 N BROADWAY ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "KS",
    "dropphyzpp": 660419998,
    "dropmaladd": "101 N BROADWAY ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "KS",
    "dropmalzpp": 660419998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138742141,
    "dropsitcph": 9138742141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20844",
    "droptype": "D",
    "dropname": "LANE",
    "dropdeladd": "416 KANSAS AVE",
    "dropdelcty": "LANE",
    "dropdelst": "KS",
    "dropdelzpp": 660429998,
    "dropphyadd": "416 KANSAS AVE",
    "dropphycty": "LANE",
    "dropphyst": "KS",
    "dropphyzpp": 660429998,
    "dropmaladd": "416 KANSAS AVE",
    "dropmalcty": "LANE",
    "dropmalst": "KS",
    "dropmalzpp": 660429998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 7858692570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20849",
    "droptype": "D",
    "dropname": "LARNED",
    "dropdeladd": "803 BROADWAY ST",
    "dropdelcty": "LARNED",
    "dropdelst": "KS",
    "dropdelzpp": 675509998,
    "dropphyadd": "803 BROADWAY ST",
    "dropphycty": "LARNED",
    "dropphyst": "KS",
    "dropphyzpp": 675509998,
    "dropmaladd": "803 BROADWAY ST",
    "dropmalcty": "LARNED",
    "dropmalst": "KS",
    "dropmalzpp": 675509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202852791,
    "dropsitcph": 6202852791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20850",
    "droptype": "D",
    "dropname": "LATHAM",
    "dropdeladd": "209 W BLAINE ST",
    "dropdelcty": "LATHAM",
    "dropdelst": "KS",
    "dropdelzpp": 670729998,
    "dropphyadd": "209 W BLAINE ST",
    "dropphycty": "LATHAM",
    "dropphyst": "KS",
    "dropphyzpp": 670729998,
    "dropmaladd": "209 W BLAINE ST",
    "dropmalcty": "LATHAM",
    "dropmalst": "KS",
    "dropmalzpp": 670729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209652495,
    "dropsitcph": 6209652495,
    "dropfax": 6209652495
  },
  {
    "dcode": "D",
    "dropkey": "PW20853",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "645 VERMONT ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "KS",
    "dropdelzpp": 660449998,
    "dropphyadd": "645 VERMONT ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "KS",
    "dropphyzpp": 660449998,
    "dropmaladd": "645 VERMONT ST",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "KS",
    "dropmalzpp": 660449998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858438777,
    "dropsitcph": 7858431681,
    "dropfax": 6505784533
  },
  {
    "dcode": "D",
    "dropkey": "PW20856",
    "droptype": "D",
    "dropname": "LE ROY",
    "dropdeladd": "418 E 6TH ST",
    "dropdelcty": "LE ROY",
    "dropdelst": "KS",
    "dropdelzpp": 668579998,
    "dropphyadd": "418 E 6TH ST",
    "dropphycty": "LE ROY",
    "dropphyst": "KS",
    "dropphyzpp": 668579998,
    "dropmaladd": "418 E 6TH ST",
    "dropmalcty": "LE ROY",
    "dropmalst": "KS",
    "dropmalzpp": 668579998,
    "dropsitphn": 3169460613,
    "dropsitlph": 6209642556,
    "dropsitcph": 6209642556,
    "dropfax": 6209642556
  },
  {
    "dcode": "D",
    "dropkey": "PW20858",
    "droptype": "D",
    "dropname": "LEAVENWORTH",
    "dropdeladd": "330 SHAWNEE ST",
    "dropdelcty": "LEAVENWORTH",
    "dropdelst": "KS",
    "dropdelzpp": 660489998,
    "dropphyadd": "330 SHAWNEE ST",
    "dropphycty": "LEAVENWORTH",
    "dropphyst": "KS",
    "dropphyzpp": 660489998,
    "dropmaladd": "330 SHAWNEE ST",
    "dropmalcty": "LEAVENWORTH",
    "dropmalst": "KS",
    "dropmalzpp": 660489998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137720935,
    "dropsitcph": 9137720935,
    "dropfax": 6505784535
  },
  {
    "dcode": "D",
    "dropkey": "PW20862",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "416 MAIN ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "KS",
    "dropdelzpp": 669529721,
    "dropphyadd": "416 MAIN ST",
    "dropphycty": "LEBANON",
    "dropphyst": "KS",
    "dropphyzpp": 669529721,
    "dropmaladd": "416 MAIN ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "KS",
    "dropmalzpp": 669529721,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853898801,
    "dropsitcph": 7853898801,
    "dropfax": 7853898801
  },
  {
    "dcode": "D",
    "dropkey": "PW20863",
    "droptype": "D",
    "dropname": "LEBO",
    "dropdeladd": "4 W BROADWAY ST",
    "dropdelcty": "LEBO",
    "dropdelst": "KS",
    "dropdelzpp": 668569998,
    "dropphyadd": "4 W BROADWAY ST",
    "dropphycty": "LEBO",
    "dropphyst": "KS",
    "dropphyzpp": 668569998,
    "dropmaladd": "4 W BROADWAY ST",
    "dropmalcty": "LEBO",
    "dropmalst": "KS",
    "dropmalzpp": 668569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202566544,
    "dropsitcph": 6202566544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20864",
    "droptype": "D",
    "dropname": "LECOMPTON",
    "dropdeladd": "525 E WOODSON AVE",
    "dropdelcty": "LECOMPTON",
    "dropdelst": "KS",
    "dropdelzpp": 660509998,
    "dropphyadd": "525 E WOODSON AVE",
    "dropphycty": "LECOMPTON",
    "dropphyst": "KS",
    "dropphyzpp": 660509998,
    "dropmaladd": "525 E WOODSON AVE",
    "dropmalcty": "LECOMPTON",
    "dropmalst": "KS",
    "dropmalzpp": 660509998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858876494,
    "dropsitcph": 7858876494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20865",
    "droptype": "D",
    "dropname": "LEHIGH",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "LEHIGH",
    "dropdelst": "KS",
    "dropdelzpp": 670738836,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "LEHIGH",
    "dropphyst": "KS",
    "dropphyzpp": 670738836,
    "dropmaladd": "112 W MAIN ST",
    "dropmalcty": "LEHIGH",
    "dropmalst": "KS",
    "dropmalzpp": 670738836,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202508817,
    "dropsitcph": 6202508817,
    "dropfax": 6204833592
  },
  {
    "dcode": "D",
    "dropkey": "PW20868",
    "droptype": "D",
    "dropname": "LENORA",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "LENORA",
    "dropdelst": "KS",
    "dropdelzpp": 676459998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "LENORA",
    "dropphyst": "KS",
    "dropphyzpp": 676459998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "LENORA",
    "dropmalst": "KS",
    "dropmalzpp": 676459998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855674550,
    "dropsitcph": 7855674550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20869",
    "droptype": "D",
    "dropname": "LEON",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "LEON",
    "dropdelst": "KS",
    "dropdelzpp": 670749998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "LEON",
    "dropphyst": "KS",
    "dropphyzpp": 670749998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "LEON",
    "dropmalst": "KS",
    "dropmalzpp": 670749998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167453547,
    "dropsitcph": 3167453547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20871",
    "droptype": "D",
    "dropname": "LEONARDVILLE",
    "dropdeladd": "103 W BARTON RD",
    "dropdelcty": "LEONARDVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 664499998,
    "dropphyadd": "103 W BARTON RD",
    "dropphycty": "LEONARDVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 664499998,
    "dropmaladd": "103 W BARTON RD",
    "dropmalcty": "LEONARDVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 664499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852935249,
    "dropsitcph": 7852935249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20874",
    "droptype": "D",
    "dropname": "LEOTI",
    "dropdeladd": "209 N 4TH ST",
    "dropdelcty": "LEOTI",
    "dropdelst": "KS",
    "dropdelzpp": 678619998,
    "dropphyadd": "209 N 4TH ST",
    "dropphycty": "LEOTI",
    "dropphyst": "KS",
    "dropphyzpp": 678619998,
    "dropmaladd": "209 N 4TH ST",
    "dropmalcty": "LEOTI",
    "dropmalst": "KS",
    "dropmalzpp": 678619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855762192,
    "dropsitcph": 7855762192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20878",
    "droptype": "D",
    "dropname": "LEWIS",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "LEWIS",
    "dropdelst": "KS",
    "dropdelzpp": 675529998,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "LEWIS",
    "dropphyst": "KS",
    "dropphyzpp": 675529998,
    "dropmaladd": "123 MAIN ST",
    "dropmalcty": "LEWIS",
    "dropmalst": "KS",
    "dropmalzpp": 675529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203245314,
    "dropsitcph": 6203245314,
    "dropfax": 6203245314
  },
  {
    "dcode": "D",
    "dropkey": "PW20880",
    "droptype": "D",
    "dropname": "LIBERAL",
    "dropdeladd": "25 E 5TH ST",
    "dropdelcty": "LIBERAL",
    "dropdelst": "KS",
    "dropdelzpp": 679019998,
    "dropphyadd": "25 E 5TH ST",
    "dropphycty": "LIBERAL",
    "dropphyst": "KS",
    "dropphyzpp": 679019998,
    "dropmaladd": "25 E 5TH ST",
    "dropmalcty": "LIBERAL",
    "dropmalst": "KS",
    "dropmalzpp": 679019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206244031,
    "dropsitcph": 6206244031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20881",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "KS",
    "dropdelzpp": 673519500,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "KS",
    "dropphyzpp": 673519500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTY",
    "dropmalst": "KS",
    "dropmalzpp": 673519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204853375,
    "dropsitcph": 6204853375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20885",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "114 S 3RD ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "KS",
    "dropdelzpp": 674559998,
    "dropphyadd": "114 S 3RD ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "KS",
    "dropphyzpp": 674559998,
    "dropmaladd": "114 S 3RD ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "KS",
    "dropmalzpp": 674559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855244486,
    "dropsitcph": 7855244486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20887",
    "droptype": "D",
    "dropname": "LINCOLNVILLE",
    "dropdeladd": "319 ADAMS ST",
    "dropdelcty": "LINCOLNVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 668589998,
    "dropphyadd": "319 ADAMS ST",
    "dropphycty": "LINCOLNVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 668589998,
    "dropmaladd": "319 ADAMS ST",
    "dropmalcty": "LINCOLNVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 668589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209245225,
    "dropsitcph": 6209245225,
    "dropfax": 6209245225
  },
  {
    "dcode": "D",
    "dropkey": "PW20890",
    "droptype": "D",
    "dropname": "LINDSBORG",
    "dropdeladd": "125 E LINCOLN ST",
    "dropdelcty": "LINDSBORG",
    "dropdelst": "KS",
    "dropdelzpp": 674569998,
    "dropphyadd": "125 E LINCOLN ST",
    "dropphycty": "LINDSBORG",
    "dropphyst": "KS",
    "dropphyzpp": 674569998,
    "dropmaladd": "125 E LINCOLN ST",
    "dropmalcty": "LINDSBORG",
    "dropmalst": "KS",
    "dropmalzpp": 674569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852272441,
    "dropsitcph": 7852272441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20891",
    "droptype": "D",
    "dropname": "LINN",
    "dropdeladd": "501 S OAK ST",
    "dropdelcty": "LINN",
    "dropdelst": "KS",
    "dropdelzpp": 669539998,
    "dropphyadd": "501 S OAK ST",
    "dropphycty": "LINN",
    "dropphyst": "KS",
    "dropphyzpp": 669539998,
    "dropmaladd": "501 S OAK ST",
    "dropmalcty": "LINN",
    "dropmalst": "KS",
    "dropmalzpp": 669539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853485863,
    "dropsitcph": 7853485863,
    "dropfax": 7853485863
  },
  {
    "dcode": "D",
    "dropkey": "PW20893",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "113 E 4TH ST",
    "dropdelcty": "LINWOOD",
    "dropdelst": "KS",
    "dropdelzpp": 660529998,
    "dropphyadd": "113 E 4TH ST",
    "dropphycty": "LINWOOD",
    "dropphyst": "KS",
    "dropphyzpp": 660529998,
    "dropmaladd": "113 E 4TH ST",
    "dropmalcty": "LINWOOD",
    "dropmalst": "KS",
    "dropmalzpp": 660529998,
    "dropsitphn": 8163749109,
    "dropsitlph": 9137233429,
    "dropsitcph": 9137233429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20896",
    "droptype": "D",
    "dropname": "LITTLE RIVER",
    "dropdeladd": "280 MAIN ST",
    "dropdelcty": "LITTLE RIVER",
    "dropdelst": "KS",
    "dropdelzpp": 674579998,
    "dropphyadd": "280 MAIN ST",
    "dropphycty": "LITTLE RIVER",
    "dropphyst": "KS",
    "dropphyzpp": 674579998,
    "dropmaladd": "280 MAIN ST",
    "dropmalcty": "LITTLE RIVER",
    "dropmalst": "KS",
    "dropmalzpp": 674579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208976238,
    "dropsitcph": 6208976238,
    "dropfax": 6208976238
  },
  {
    "dcode": "D",
    "dropkey": "PW20903",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "206 W MAIN ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "KS",
    "dropdelzpp": 676469998,
    "dropphyadd": "206 W MAIN ST",
    "dropphycty": "LOGAN",
    "dropphyst": "KS",
    "dropphyzpp": 676469998,
    "dropmaladd": "206 W MAIN ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "KS",
    "dropmalzpp": 676469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854252062,
    "dropsitcph": 7854252063,
    "dropfax": 7856894240
  },
  {
    "dcode": "D",
    "dropkey": "PW20907",
    "droptype": "D",
    "dropname": "LONG ISLAND",
    "dropdeladd": "335 WASHINGTON AVE",
    "dropdelcty": "LONG ISLAND",
    "dropdelst": "KS",
    "dropdelzpp": 676474053,
    "dropphyadd": "335 WASHINGTON AVE",
    "dropphycty": "LONG ISLAND",
    "dropphyst": "KS",
    "dropphyzpp": 676474053,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG ISLAND",
    "dropmalst": "KS",
    "dropmalzpp": 676479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858547600,
    "dropsitcph": 7858547600,
    "dropfax": 7858547600
  },
  {
    "dcode": "D",
    "dropkey": "PW20908",
    "droptype": "D",
    "dropname": "LONGFORD",
    "dropdeladd": "115 WEDA ST",
    "dropdelcty": "LONGFORD",
    "dropdelst": "KS",
    "dropdelzpp": 674589750,
    "dropphyadd": "115 WEDA ST",
    "dropphycty": "LONGFORD",
    "dropphyst": "KS",
    "dropphyzpp": 674589750,
    "dropmaladd": "115 WEDA ST",
    "dropmalcty": "LONGFORD",
    "dropmalst": "KS",
    "dropmalzpp": 674589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853882434,
    "dropsitcph": 7853882434,
    "dropfax": 7853882434
  },
  {
    "dcode": "D",
    "dropkey": "PW20909",
    "droptype": "D",
    "dropname": "LONGTON",
    "dropdeladd": "416 KANSAS",
    "dropdelcty": "LONGTON",
    "dropdelst": "KS",
    "dropdelzpp": 673529900,
    "dropphyadd": "416 KANSAS",
    "dropphycty": "LONGTON",
    "dropphyst": "KS",
    "dropphyzpp": 673529900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONGTON",
    "dropmalst": "KS",
    "dropmalzpp": 673529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206426695,
    "dropsitcph": 6206426695,
    "dropfax": 6206426695
  },
  {
    "dcode": "D",
    "dropkey": "PW20913",
    "droptype": "D",
    "dropname": "LOST SPRINGS",
    "dropdeladd": "125 BERRY ST",
    "dropdelcty": "LOST SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 668599998,
    "dropphyadd": "125 BERRY ST",
    "dropphycty": "LOST SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 668599998,
    "dropmaladd": "125 BERRY ST",
    "dropmalcty": "LOST SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 668599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859834813,
    "dropsitcph": 7859834813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20914",
    "droptype": "D",
    "dropname": "LOUISBURG",
    "dropdeladd": "214 HARVEST DR",
    "dropdelcty": "LOUISBURG",
    "dropdelst": "KS",
    "dropdelzpp": 660539998,
    "dropphyadd": "214 HARVEST DR",
    "dropphycty": "LOUISBURG",
    "dropphyst": "KS",
    "dropphyzpp": 660539998,
    "dropmaladd": "214 HARVEST DR",
    "dropmalcty": "LOUISBURG",
    "dropmalst": "KS",
    "dropmalzpp": 660539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138372118,
    "dropsitcph": 9138372118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20922",
    "droptype": "D",
    "dropname": "LUCAS",
    "dropdeladd": "218 S MAIN ST",
    "dropdelcty": "LUCAS",
    "dropdelst": "KS",
    "dropdelzpp": 676489718,
    "dropphyadd": "218 S MAIN ST",
    "dropphycty": "LUCAS",
    "dropphyst": "KS",
    "dropphyzpp": 676489718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCAS",
    "dropmalst": "KS",
    "dropmalzpp": 676489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855256420,
    "dropsitcph": 7855256420,
    "dropfax": 7855256420
  },
  {
    "dcode": "D",
    "dropkey": "PW20924",
    "droptype": "D",
    "dropname": "LURAY",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "LURAY",
    "dropdelst": "KS",
    "dropdelzpp": 676499998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "LURAY",
    "dropphyst": "KS",
    "dropphyzpp": 676499998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "LURAY",
    "dropmalst": "KS",
    "dropmalzpp": 676499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856982300,
    "dropsitcph": 7856982300,
    "dropfax": 7856982300
  },
  {
    "dcode": "D",
    "dropkey": "PW20928",
    "droptype": "D",
    "dropname": "LYNDON",
    "dropdeladd": "712 TOPEKA AVE",
    "dropdelcty": "LYNDON",
    "dropdelst": "KS",
    "dropdelzpp": 664519998,
    "dropphyadd": "712 TOPEKA AVE",
    "dropphycty": "LYNDON",
    "dropphyst": "KS",
    "dropphyzpp": 664519998,
    "dropmaladd": "712 TOPEKA AVE",
    "dropmalcty": "LYNDON",
    "dropmalst": "KS",
    "dropmalzpp": 664519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858284441,
    "dropsitcph": 7858284441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20931",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "121 EAST AVE N",
    "dropdelcty": "LYONS",
    "dropdelst": "KS",
    "dropdelzpp": 675549998,
    "dropphyadd": "121 EAST AVE N",
    "dropphycty": "LYONS",
    "dropphyst": "KS",
    "dropphyzpp": 675549998,
    "dropmaladd": "121 EAST AVE N",
    "dropmalcty": "LYONS",
    "dropmalst": "KS",
    "dropmalzpp": 675549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202573361,
    "dropsitcph": 6202573361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20932",
    "droptype": "D",
    "dropname": "MACKSVILLE",
    "dropdeladd": "214 N MAIN ST",
    "dropdelcty": "MACKSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 675579998,
    "dropphyadd": "214 N MAIN ST",
    "dropphycty": "MACKSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 675579998,
    "dropmaladd": "214 N MAIN ST",
    "dropmalcty": "MACKSVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 675579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203484415,
    "dropsitcph": 6203484415,
    "dropfax": 6203484415
  },
  {
    "dcode": "D",
    "dropkey": "PW20933",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "115 S 3RD ST",
    "dropdelcty": "MADISON",
    "dropdelst": "KS",
    "dropdelzpp": 668609998,
    "dropphyadd": "115 S 3RD ST",
    "dropphycty": "MADISON",
    "dropphyst": "KS",
    "dropphyzpp": 668609998,
    "dropmaladd": "115 S 3RD ST",
    "dropmalcty": "MADISON",
    "dropmalst": "KS",
    "dropmalzpp": 668609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204372222,
    "dropsitcph": 6204372222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20934",
    "droptype": "D",
    "dropname": "MAHASKA",
    "dropdeladd": "212 N MAIN ST",
    "dropdelcty": "MAHASKA",
    "dropdelst": "KS",
    "dropdelzpp": 669559998,
    "dropphyadd": "212 N MAIN ST",
    "dropphycty": "MAHASKA",
    "dropphyst": "KS",
    "dropphyzpp": 669559998,
    "dropmaladd": "212 N MAIN ST",
    "dropmalcty": "MAHASKA",
    "dropmalst": "KS",
    "dropmalzpp": 669559998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852453258,
    "dropsitcph": 7852453258,
    "dropfax": 7852453258
  },
  {
    "dcode": "D",
    "dropkey": "PW20936",
    "droptype": "D",
    "dropname": "MAIZE",
    "dropdeladd": "115 E ALBERT ST",
    "dropdelcty": "MAIZE",
    "dropdelst": "KS",
    "dropdelzpp": 671019998,
    "dropphyadd": "115 E ALBERT ST",
    "dropphycty": "MAIZE",
    "dropphyst": "KS",
    "dropphyzpp": 671019998,
    "dropmaladd": "115 E ALBERT ST",
    "dropmalcty": "MAIZE",
    "dropmalst": "KS",
    "dropmalzpp": 671019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167220531,
    "dropsitcph": 3167220531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20939",
    "droptype": "D",
    "dropname": "MANHATTAN",
    "dropdeladd": "500 LEAVENWORTH ST",
    "dropdelcty": "MANHATTAN",
    "dropdelst": "KS",
    "dropdelzpp": 665029998,
    "dropphyadd": "500 LEAVENWORTH ST",
    "dropphycty": "MANHATTAN",
    "dropphyst": "KS",
    "dropphyzpp": 665029998,
    "dropmaladd": "500 LEAVENWORTH ST",
    "dropmalcty": "MANHATTAN",
    "dropmalst": "KS",
    "dropmalzpp": 665029998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855394450,
    "dropsitcph": 7855394450,
    "dropfax": 7855378214
  },
  {
    "dcode": "D",
    "dropkey": "PW20940",
    "droptype": "D",
    "dropname": "MANKATO",
    "dropdeladd": "109 S COMMERCIAL ST",
    "dropdelcty": "MANKATO",
    "dropdelst": "KS",
    "dropdelzpp": 669569998,
    "dropphyadd": "109 S COMMERCIAL ST",
    "dropphycty": "MANKATO",
    "dropphyst": "KS",
    "dropphyzpp": 669569998,
    "dropmaladd": "109 S COMMERCIAL ST",
    "dropmalcty": "MANKATO",
    "dropmalst": "KS",
    "dropmalzpp": 669569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853783711,
    "dropsitcph": 7853783711,
    "dropfax": 7853483711
  },
  {
    "dcode": "D",
    "dropkey": "PW20942",
    "droptype": "D",
    "dropname": "MANTER",
    "dropdeladd": "216 N MAIN ST",
    "dropdelcty": "MANTER",
    "dropdelst": "KS",
    "dropdelzpp": 678629500,
    "dropphyadd": "216 N MAIN ST",
    "dropphycty": "MANTER",
    "dropphyst": "KS",
    "dropphyzpp": 678629500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANTER",
    "dropmalst": "KS",
    "dropmalzpp": 678629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204933835,
    "dropsitcph": 6204933835,
    "dropfax": 6204933835
  },
  {
    "dcode": "D",
    "dropkey": "PW20947",
    "droptype": "D",
    "dropname": "MAPLE HILL",
    "dropdeladd": "213 MAIN ST",
    "dropdelcty": "MAPLE HILL",
    "dropdelst": "KS",
    "dropdelzpp": 665079998,
    "dropphyadd": "213 MAIN ST",
    "dropphycty": "MAPLE HILL",
    "dropphyst": "KS",
    "dropphyzpp": 665079998,
    "dropmaladd": "213 MAIN ST",
    "dropmalcty": "MAPLE HILL",
    "dropmalst": "KS",
    "dropmalzpp": 665079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852564480,
    "dropsitcph": 7852564480,
    "dropfax": 7852564480
  },
  {
    "dcode": "D",
    "dropkey": "PW20949",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "108 W 6TH ST",
    "dropdelcty": "MAPLETON",
    "dropdelst": "KS",
    "dropdelzpp": 667549998,
    "dropphyadd": "108 W 6TH ST",
    "dropphycty": "MAPLETON",
    "dropphyst": "KS",
    "dropphyzpp": 667549998,
    "dropmaladd": "108 W 6TH ST",
    "dropmalcty": "MAPLETON",
    "dropmalst": "KS",
    "dropmalzpp": 667549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207434501,
    "dropsitcph": 6207434501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20953",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "423 E MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "KS",
    "dropdelzpp": 668619998,
    "dropphyadd": "423 E MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "KS",
    "dropphyzpp": 668619998,
    "dropmaladd": "423 E MAIN ST",
    "dropmalcty": "MARION",
    "dropmalst": "KS",
    "dropmalzpp": 668619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203822363,
    "dropsitcph": 6203822363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20955",
    "droptype": "D",
    "dropname": "MARQUETTE",
    "dropdeladd": "212 N WASHINGTON ST",
    "dropdelcty": "MARQUETTE",
    "dropdelst": "KS",
    "dropdelzpp": 674649998,
    "dropphyadd": "212 N WASHINGTON ST",
    "dropphycty": "MARQUETTE",
    "dropphyst": "KS",
    "dropphyzpp": 674649998,
    "dropmaladd": "212 N WASHINGTON ST",
    "dropmalcty": "MARQUETTE",
    "dropmalst": "KS",
    "dropmalzpp": 674649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855462749,
    "dropsitcph": 7855462749,
    "dropfax": 7855462749
  },
  {
    "dcode": "D",
    "dropkey": "PW20957",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "109 S 9TH ST",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 665089998,
    "dropphyadd": "109 S 9TH ST",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 665089998,
    "dropmaladd": "109 S 9TH ST",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 665089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855623236,
    "dropsitcph": 7855623236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20965",
    "droptype": "D",
    "dropname": "MAYETTA",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "MAYETTA",
    "dropdelst": "KS",
    "dropdelzpp": 665099998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "MAYETTA",
    "dropphyst": "KS",
    "dropphyzpp": 665099998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "MAYETTA",
    "dropmalst": "KS",
    "dropmalzpp": 665099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859662650,
    "dropsitcph": 7859662650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20966",
    "droptype": "D",
    "dropname": "MAYFIELD",
    "dropdeladd": "116 N OSBORN ST",
    "dropdelcty": "MAYFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 671039998,
    "dropphyadd": "116 N OSBORN ST",
    "dropphycty": "MAYFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 671039998,
    "dropmaladd": "116 N OSBORN ST",
    "dropmalcty": "MAYFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 671039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204345411,
    "dropsitcph": 6204345411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20969",
    "droptype": "D",
    "dropname": "MC CRACKEN",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "MC CRACKEN",
    "dropdelst": "KS",
    "dropdelzpp": 675569515,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "MC CRACKEN",
    "dropphyst": "KS",
    "dropphyzpp": 675569515,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "MC CRACKEN",
    "dropmalst": "KS",
    "dropmalzpp": 675569515,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853942678,
    "dropsitcph": 7853942678,
    "dropfax": 7853942504
  },
  {
    "dcode": "D",
    "dropkey": "PW20970",
    "droptype": "D",
    "dropname": "MC CUNE",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "MC CUNE",
    "dropdelst": "KS",
    "dropdelzpp": 667539998,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "MC CUNE",
    "dropphyst": "KS",
    "dropphyzpp": 667539998,
    "dropmaladd": "601 MAIN ST",
    "dropmalcty": "MC CUNE",
    "dropmalst": "KS",
    "dropmalzpp": 667539998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6206324979,
    "dropsitcph": 6206324979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20971",
    "droptype": "D",
    "dropname": "MC DONALD",
    "dropdeladd": "218 RAWLINS AVE",
    "dropdelcty": "MC DONALD",
    "dropdelst": "KS",
    "dropdelzpp": 677459753,
    "dropphyadd": "218 RAWLINS AVE",
    "dropphycty": "MC DONALD",
    "dropphyst": "KS",
    "dropphyzpp": 677459753,
    "dropmaladd": "218 RAWLINS AVE",
    "dropmalcty": "MC DONALD",
    "dropmalst": "KS",
    "dropmalzpp": 677459753,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855382301,
    "dropsitcph": 7855382301,
    "dropfax": 7855382301
  },
  {
    "dcode": "D",
    "dropkey": "PW20973",
    "droptype": "D",
    "dropname": "MC LOUTH",
    "dropdeladd": "301 S UNION ST",
    "dropdelcty": "MC LOUTH",
    "dropdelst": "KS",
    "dropdelzpp": 660549998,
    "dropphyadd": "301 S UNION ST",
    "dropphycty": "MC LOUTH",
    "dropphyst": "KS",
    "dropphyzpp": 660549998,
    "dropmaladd": "301 S UNION ST",
    "dropmalcty": "MC LOUTH",
    "dropmalst": "KS",
    "dropmalzpp": 660549998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137966311,
    "dropsitcph": 9137966311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20974",
    "droptype": "D",
    "dropname": "MCPHERSON",
    "dropdeladd": "115 E KANSAS AVE",
    "dropdelcty": "MCPHERSON",
    "dropdelst": "KS",
    "dropdelzpp": 674609998,
    "dropphyadd": "115 E KANSAS AVE",
    "dropphycty": "MCPHERSON",
    "dropphyst": "KS",
    "dropphyzpp": 674609998,
    "dropmaladd": "115 E KANSAS AVE",
    "dropmalcty": "MCPHERSON",
    "dropmalst": "KS",
    "dropmalzpp": 674609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202411532,
    "dropsitcph": 6202411532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20984",
    "droptype": "D",
    "dropname": "MEADE",
    "dropdeladd": "101 E WEST PLAINS ST",
    "dropdelcty": "MEADE",
    "dropdelst": "KS",
    "dropdelzpp": 678649998,
    "dropphyadd": "101 E WEST PLAINS ST",
    "dropphycty": "MEADE",
    "dropphyst": "KS",
    "dropphyzpp": 678649998,
    "dropmaladd": "101 E WEST PLAINS ST",
    "dropmalcty": "MEADE",
    "dropmalst": "KS",
    "dropmalzpp": 678649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208732601,
    "dropsitcph": 6208732601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20985",
    "droptype": "D",
    "dropname": "MEDICINE LODGE",
    "dropdeladd": "108 W KANSAS AVE",
    "dropdelcty": "MEDICINE LODGE",
    "dropdelst": "KS",
    "dropdelzpp": 671049998,
    "dropphyadd": "108 W KANSAS AVE",
    "dropphycty": "MEDICINE LODGE",
    "dropphyst": "KS",
    "dropphyzpp": 671049998,
    "dropmaladd": "108 W KANSAS AVE",
    "dropmalcty": "MEDICINE LODGE",
    "dropmalst": "KS",
    "dropmalzpp": 671049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208863233,
    "dropsitcph": 6208863233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW20990",
    "droptype": "D",
    "dropname": "MELVERN",
    "dropdeladd": "118 NE EMPORIA ST",
    "dropdelcty": "MELVERN",
    "dropdelst": "KS",
    "dropdelzpp": 665109998,
    "dropphyadd": "118 NE EMPORIA ST",
    "dropphycty": "MELVERN",
    "dropphyst": "KS",
    "dropphyzpp": 665109998,
    "dropmaladd": "118 NE EMPORIA ST",
    "dropmalcty": "MELVERN",
    "dropmalst": "KS",
    "dropmalzpp": 665109998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855493631,
    "dropsitcph": 7855493631,
    "dropfax": 7855493631
  },
  {
    "dcode": "D",
    "dropkey": "PW20997",
    "droptype": "D",
    "dropname": "MERIDEN",
    "dropdeladd": "101 N PALMBERG ST",
    "dropdelcty": "MERIDEN",
    "dropdelst": "KS",
    "dropdelzpp": 665129998,
    "dropphyadd": "101 N PALMBERG ST",
    "dropphycty": "MERIDEN",
    "dropphyst": "KS",
    "dropphyzpp": 665129998,
    "dropmaladd": "101 N PALMBERG ST",
    "dropmalcty": "MERIDEN",
    "dropmalst": "KS",
    "dropmalzpp": 665129998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854842363,
    "dropsitcph": 7854842363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21006",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "106 WHITING ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "KS",
    "dropdelzpp": 665149998,
    "dropphyadd": "106 WHITING ST",
    "dropphycty": "MILFORD",
    "dropphyst": "KS",
    "dropphyzpp": 665149998,
    "dropmaladd": "106 WHITING ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "KS",
    "dropmalzpp": 665149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854635519,
    "dropsitcph": 7854635519,
    "dropfax": 7854635519
  },
  {
    "dcode": "D",
    "dropkey": "PW21012",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "1211 N WALNUT ST",
    "dropdelcty": "MILTON",
    "dropdelst": "KS",
    "dropdelzpp": 671069517,
    "dropphyadd": "1211 N WALNUT ST",
    "dropphycty": "MILTON",
    "dropphyst": "KS",
    "dropphyzpp": 671069517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILTON",
    "dropmalst": "KS",
    "dropmalzpp": 671069998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204782412,
    "dropsitcph": 6204782412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21013",
    "droptype": "D",
    "dropname": "MILTONVALE",
    "dropdeladd": "123 STARR AVE",
    "dropdelcty": "MILTONVALE",
    "dropdelst": "KS",
    "dropdelzpp": 674669998,
    "dropphyadd": "123 STARR AVE",
    "dropphycty": "MILTONVALE",
    "dropphyst": "KS",
    "dropphyzpp": 674669998,
    "dropmaladd": "123 STARR AVE",
    "dropmalcty": "MILTONVALE",
    "dropmalst": "KS",
    "dropmalzpp": 674669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854273160,
    "dropsitcph": 7854273160,
    "dropfax": 7854273160
  },
  {
    "dcode": "D",
    "dropkey": "PW21016",
    "droptype": "D",
    "dropname": "MINNEAPOLIS",
    "dropdeladd": "112 W 2ND ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "KS",
    "dropdelzpp": 674679998,
    "dropphyadd": "112 W 2ND ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "KS",
    "dropphyzpp": 674679998,
    "dropmaladd": "112 W 2ND ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "KS",
    "dropmalzpp": 674679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853922201,
    "dropsitcph": 7853922201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21017",
    "droptype": "D",
    "dropname": "MINNEOLA",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "MINNEOLA",
    "dropdelst": "KS",
    "dropdelzpp": 678659998,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "MINNEOLA",
    "dropphyst": "KS",
    "dropphyzpp": 678659998,
    "dropmaladd": "116 S MAIN ST",
    "dropmalcty": "MINNEOLA",
    "dropmalst": "KS",
    "dropmalzpp": 678659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208854510,
    "dropsitcph": 6208854510,
    "dropfax": 6208854510
  },
  {
    "dcode": "D",
    "dropkey": "PW21027",
    "droptype": "D",
    "dropname": "MOLINE",
    "dropdeladd": "112 N MAIN ST",
    "dropdelcty": "MOLINE",
    "dropdelst": "KS",
    "dropdelzpp": 673539998,
    "dropphyadd": "112 N MAIN ST",
    "dropphycty": "MOLINE",
    "dropphyst": "KS",
    "dropphyzpp": 673539998,
    "dropmaladd": "112 N MAIN ST",
    "dropmalcty": "MOLINE",
    "dropmalst": "KS",
    "dropmalzpp": 673539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206473322,
    "dropsitcph": 6206473322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21030",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "207 N AZTEC ST",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "KS",
    "dropdelzpp": 678679500,
    "dropphyadd": "207 N AZTEC ST",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "KS",
    "dropphyzpp": 678679500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "KS",
    "dropmalzpp": 678679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208462206,
    "dropsitcph": 6208462206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21035",
    "droptype": "D",
    "dropname": "MORAN",
    "dropdeladd": "226 N CEDAR ST",
    "dropdelcty": "MORAN",
    "dropdelst": "KS",
    "dropdelzpp": 667559998,
    "dropphyadd": "226 N CEDAR ST",
    "dropphycty": "MORAN",
    "dropphyst": "KS",
    "dropphyzpp": 667559998,
    "dropmaladd": "226 N CEDAR ST",
    "dropmalcty": "MORAN",
    "dropmalst": "KS",
    "dropmalzpp": 667559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202374235,
    "dropsitcph": 6202374235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21037",
    "droptype": "D",
    "dropname": "MORGANVILLE",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "MORGANVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 674689998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "MORGANVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 674689998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "MORGANVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 674689998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859264183,
    "dropsitcph": 7859264183,
    "dropfax": 7859264183
  },
  {
    "dcode": "D",
    "dropkey": "PW21038",
    "droptype": "D",
    "dropname": "MORLAND",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "MORLAND",
    "dropdelst": "KS",
    "dropdelzpp": 676509998,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "MORLAND",
    "dropphyst": "KS",
    "dropphyzpp": 676509998,
    "dropmaladd": "409 MAIN ST",
    "dropmalcty": "MORLAND",
    "dropmalst": "KS",
    "dropmalzpp": 676509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856273791,
    "dropsitcph": 7856273791,
    "dropfax": 7856273791
  },
  {
    "dcode": "D",
    "dropkey": "PW21039",
    "droptype": "D",
    "dropname": "MORRILL",
    "dropdeladd": "616 ROXANNA ST",
    "dropdelcty": "MORRILL",
    "dropdelst": "KS",
    "dropdelzpp": 665159725,
    "dropphyadd": "616 ROXANNA ST",
    "dropphycty": "MORRILL",
    "dropphyst": "KS",
    "dropphyzpp": 665159725,
    "dropmaladd": "616 ROXANNA ST",
    "dropmalcty": "MORRILL",
    "dropmalst": "KS",
    "dropmalzpp": 665159725,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853369107,
    "dropsitcph": 7853369107,
    "dropfax": 7854592811
  },
  {
    "dcode": "D",
    "dropkey": "PW21042",
    "droptype": "D",
    "dropname": "MORROWVILLE",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "MORROWVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 669589998,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "MORROWVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 669589998,
    "dropmaladd": "116 S MAIN ST",
    "dropmalcty": "MORROWVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 669589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852654411,
    "dropsitcph": 7852654411,
    "dropfax": 7852654411
  },
  {
    "dcode": "D",
    "dropkey": "PW21047",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "311 W CIMARRON ST",
    "dropdelcty": "MOSCOW",
    "dropdelst": "KS",
    "dropdelzpp": 679529500,
    "dropphyadd": "311 W CIMARRON ST",
    "dropphycty": "MOSCOW",
    "dropphyst": "KS",
    "dropphyzpp": 679529500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSCOW",
    "dropmalst": "KS",
    "dropmalzpp": 679529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205982289,
    "dropsitcph": 6205982289,
    "dropfax": 6205982289
  },
  {
    "dcode": "D",
    "dropkey": "PW21048",
    "droptype": "D",
    "dropname": "MOUND CITY",
    "dropdeladd": "504 MAIN ST",
    "dropdelcty": "MOUND CITY",
    "dropdelst": "KS",
    "dropdelzpp": 660569998,
    "dropphyadd": "504 MAIN ST",
    "dropphycty": "MOUND CITY",
    "dropphyst": "KS",
    "dropphyzpp": 660569998,
    "dropmaladd": "504 MAIN ST",
    "dropmalcty": "MOUND CITY",
    "dropmalst": "KS",
    "dropmalzpp": 660569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137952910,
    "dropsitcph": 9137952910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21051",
    "droptype": "D",
    "dropname": "MOUND VALLEY",
    "dropdeladd": "413 HICKORY ST",
    "dropdelcty": "MOUND VALLEY",
    "dropdelst": "KS",
    "dropdelzpp": 673549998,
    "dropphyadd": "413 HICKORY ST",
    "dropphycty": "MOUND VALLEY",
    "dropphyst": "KS",
    "dropphyzpp": 673549998,
    "dropmaladd": "413 HICKORY ST",
    "dropmalcty": "MOUND VALLEY",
    "dropmalst": "KS",
    "dropmalzpp": 673549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203284711,
    "dropsitcph": 6203284711,
    "dropfax": 6203284711
  },
  {
    "dcode": "D",
    "dropkey": "PW21054",
    "droptype": "D",
    "dropname": "MOUNDRIDGE",
    "dropdeladd": "111 S CHRISTIAN AVE",
    "dropdelcty": "MOUNDRIDGE",
    "dropdelst": "KS",
    "dropdelzpp": 671079998,
    "dropphyadd": "111 S CHRISTIAN AVE",
    "dropphycty": "MOUNDRIDGE",
    "dropphyst": "KS",
    "dropphyzpp": 671079998,
    "dropmaladd": "111 S CHRISTIAN AVE",
    "dropmalcty": "MOUNDRIDGE",
    "dropmalst": "KS",
    "dropmalzpp": 671079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202508837,
    "dropsitcph": 6202508837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21055",
    "droptype": "D",
    "dropname": "MOUNT HOPE",
    "dropdeladd": "125 W MAIN ST",
    "dropdelcty": "MOUNT HOPE",
    "dropdelst": "KS",
    "dropdelzpp": 671089998,
    "dropphyadd": "125 W MAIN ST",
    "dropphycty": "MOUNT HOPE",
    "dropphyst": "KS",
    "dropphyzpp": 671089998,
    "dropmaladd": "125 W MAIN ST",
    "dropmalcty": "MOUNT HOPE",
    "dropmalst": "KS",
    "dropmalzpp": 671089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3166672370,
    "dropsitcph": 3166672370,
    "dropfax": 3166672370
  },
  {
    "dcode": "D",
    "dropkey": "PW21061",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "306 S MILITARY AVE",
    "dropdelcty": "MULBERRY",
    "dropdelst": "KS",
    "dropdelzpp": 667569998,
    "dropphyadd": "306 S MILITARY AVE",
    "dropphycty": "MULBERRY",
    "dropphyst": "KS",
    "dropphyzpp": 667569998,
    "dropmaladd": "306 S MILITARY AVE",
    "dropmalcty": "MULBERRY",
    "dropmalst": "KS",
    "dropmalzpp": 667569998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207643300,
    "dropsitcph": 6207643300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21062",
    "droptype": "D",
    "dropname": "MULLINVILLE",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "MULLINVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 671099500,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "MULLINVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 671099500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MULLINVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 671099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205482581,
    "dropsitcph": 6205482581,
    "dropfax": 6205482581
  },
  {
    "dcode": "D",
    "dropkey": "PW21065",
    "droptype": "D",
    "dropname": "MULVANE",
    "dropdeladd": "116 W MAIN ST",
    "dropdelcty": "MULVANE",
    "dropdelst": "KS",
    "dropdelzpp": 671101758,
    "dropphyadd": "116 W MAIN ST",
    "dropphycty": "MULVANE",
    "dropphyst": "KS",
    "dropphyzpp": 671101758,
    "dropmaladd": "116 W MAIN ST",
    "dropmalcty": "MULVANE",
    "dropmalst": "KS",
    "dropmalzpp": 671101758,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167774011,
    "dropsitcph": 3167774011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21068",
    "droptype": "D",
    "dropname": "MUNDEN",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "MUNDEN",
    "dropdelst": "KS",
    "dropdelzpp": 669599998,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "MUNDEN",
    "dropphyst": "KS",
    "dropphyzpp": 669599998,
    "dropmaladd": "106 S MAIN ST",
    "dropmalcty": "MUNDEN",
    "dropmalst": "KS",
    "dropmalzpp": 669599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859875455,
    "dropsitcph": 7859875455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21071",
    "droptype": "D",
    "dropname": "MURDOCK",
    "dropdeladd": "2624 SE MURDOCK AVE",
    "dropdelcty": "MURDOCK",
    "dropdelst": "KS",
    "dropdelzpp": 671119998,
    "dropphyadd": "2624 SE MURDOCK AVE",
    "dropphycty": "MURDOCK",
    "dropphyst": "KS",
    "dropphyzpp": 671119998,
    "dropmaladd": "2624 SE MURDOCK AVE",
    "dropmalcty": "MURDOCK",
    "dropmalst": "KS",
    "dropmalzpp": 671119998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202973465,
    "dropsitcph": 6202973465,
    "dropfax": 6202973465
  },
  {
    "dcode": "D",
    "dropkey": "PW21072",
    "droptype": "D",
    "dropname": "MUSCOTAH",
    "dropdeladd": "116 E 1ST ST",
    "dropdelcty": "MUSCOTAH",
    "dropdelst": "KS",
    "dropdelzpp": 660589998,
    "dropphyadd": "116 E 1ST ST",
    "dropphycty": "MUSCOTAH",
    "dropphyst": "KS",
    "dropphyzpp": 660589998,
    "dropmaladd": "116 E 1ST ST",
    "dropmalcty": "MUSCOTAH",
    "dropmalst": "KS",
    "dropmalzpp": 660589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858723440,
    "dropsitcph": 7858723440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21074",
    "droptype": "D",
    "dropname": "NARKA",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "NARKA",
    "dropdelst": "KS",
    "dropdelzpp": 669608083,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "NARKA",
    "dropphyst": "KS",
    "dropphyzpp": 669608083,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NARKA",
    "dropmalst": "KS",
    "dropmalzpp": 669609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853582390,
    "dropsitcph": 7853582390,
    "dropfax": 7853582390
  },
  {
    "dcode": "D",
    "dropkey": "PW21075",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "118 S MAIN ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 671129997,
    "dropphyadd": "118 S MAIN ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 671129997,
    "dropmaladd": "118 S MAIN ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 671129500,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202465302,
    "dropsitcph": 6202465302,
    "dropfax": 6202465302
  },
  {
    "dcode": "D",
    "dropkey": "PW21076",
    "droptype": "D",
    "dropname": "NATOMA",
    "dropdeladd": "402 ELM ST",
    "dropdelcty": "NATOMA",
    "dropdelst": "KS",
    "dropdelzpp": 676519998,
    "dropphyadd": "402 ELM ST",
    "dropphycty": "NATOMA",
    "dropphyst": "KS",
    "dropphyzpp": 676519998,
    "dropmaladd": "402 ELM ST",
    "dropmalcty": "NATOMA",
    "dropmalst": "KS",
    "dropmalzpp": 676519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858854553,
    "dropsitcph": 7858854553,
    "dropfax": 7858854553
  },
  {
    "dcode": "D",
    "dropkey": "PW21078",
    "droptype": "D",
    "dropname": "NEAL",
    "dropdeladd": "1567 AA30 RD",
    "dropdelcty": "NEAL",
    "dropdelst": "KS",
    "dropdelzpp": 668639800,
    "dropphyadd": "1567 AA30 RD",
    "dropphycty": "NEAL",
    "dropphyst": "KS",
    "dropphyzpp": 668639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEAL",
    "dropmalst": "KS",
    "dropmalzpp": 668639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206372776,
    "dropsitcph": 6206372776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21081",
    "droptype": "D",
    "dropname": "NEODESHA",
    "dropdeladd": "123 N 5TH ST",
    "dropdelcty": "NEODESHA",
    "dropdelst": "KS",
    "dropdelzpp": 667579998,
    "dropphyadd": "123 N 5TH ST",
    "dropphycty": "NEODESHA",
    "dropphyst": "KS",
    "dropphyzpp": 667579998,
    "dropmaladd": "123 N 5TH ST",
    "dropmalcty": "NEODESHA",
    "dropmalst": "KS",
    "dropmalzpp": 667579998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203253610,
    "dropsitcph": 6203253610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21083",
    "droptype": "D",
    "dropname": "NEOSHO FALLS",
    "dropdeladd": "1102 MAIN ST",
    "dropdelcty": "NEOSHO FALLS",
    "dropdelst": "KS",
    "dropdelzpp": 667589998,
    "dropphyadd": "1102 MAIN ST",
    "dropphycty": "NEOSHO FALLS",
    "dropphyst": "KS",
    "dropphyzpp": 667589998,
    "dropmaladd": "1102 MAIN ST",
    "dropmalcty": "NEOSHO FALLS",
    "dropmalst": "KS",
    "dropmalzpp": 667589998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6209637101,
    "dropsitcph": 6209637101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21085",
    "droptype": "D",
    "dropname": "NEOSHO RAPIDS",
    "dropdeladd": "516 MAIN ST",
    "dropdelcty": "NEOSHO RAPIDS",
    "dropdelst": "KS",
    "dropdelzpp": 668649998,
    "dropphyadd": "516 MAIN ST",
    "dropphycty": "NEOSHO RAPIDS",
    "dropphyst": "KS",
    "dropphyzpp": 668649998,
    "dropmaladd": "516 MAIN ST",
    "dropmalcty": "NEOSHO RAPIDS",
    "dropmalst": "KS",
    "dropmalzpp": 668649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203433917,
    "dropsitcph": 6203433917,
    "dropfax": 6203433917
  },
  {
    "dcode": "D",
    "dropkey": "PW21087",
    "droptype": "D",
    "dropname": "NESS CITY",
    "dropdeladd": "108 S KANSAS AVE",
    "dropdelcty": "NESS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 675609998,
    "dropphyadd": "108 S KANSAS AVE",
    "dropphycty": "NESS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 675609998,
    "dropmaladd": "108 S KANSAS AVE",
    "dropmalcty": "NESS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 675609998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857983352,
    "dropsitcph": 7857983352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21088",
    "droptype": "D",
    "dropname": "NETAWAKA",
    "dropdeladd": "412 COMMERCIAL ST",
    "dropdelcty": "NETAWAKA",
    "dropdelst": "KS",
    "dropdelzpp": 665169998,
    "dropphyadd": "412 COMMERCIAL ST",
    "dropphycty": "NETAWAKA",
    "dropphyst": "KS",
    "dropphyzpp": 665169998,
    "dropmaladd": "412 COMMERCIAL ST",
    "dropmalcty": "NETAWAKA",
    "dropmalst": "KS",
    "dropmalzpp": 665169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859333000,
    "dropsitcph": 7859333000,
    "dropfax": 7859333000
  },
  {
    "dcode": "D",
    "dropkey": "PW21093",
    "droptype": "D",
    "dropname": "NEW CAMBRIA",
    "dropdeladd": "101 S CENTER ST",
    "dropdelcty": "NEW CAMBRIA",
    "dropdelst": "KS",
    "dropdelzpp": 674709998,
    "dropphyadd": "101 S CENTER ST",
    "dropphycty": "NEW CAMBRIA",
    "dropphyst": "KS",
    "dropphyzpp": 674709998,
    "dropmaladd": "101 S CENTER ST",
    "dropmalcty": "NEW CAMBRIA",
    "dropmalst": "KS",
    "dropmalzpp": 674709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858255490,
    "dropsitcph": 7858255490,
    "dropfax": 7858255490
  },
  {
    "dcode": "D",
    "dropkey": "PW21097",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "400 N POPLAR ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "KS",
    "dropdelzpp": 671149998,
    "dropphyadd": "400 N POPLAR ST",
    "dropphycty": "NEWTON",
    "dropphyst": "KS",
    "dropphyzpp": 671149998,
    "dropmaladd": "400 N POPLAR ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "KS",
    "dropmalzpp": 671149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3162836290,
    "dropsitcph": 3162836290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21099",
    "droptype": "D",
    "dropname": "NICKERSON",
    "dropdeladd": "6 N NICKERSON ST",
    "dropdelcty": "NICKERSON",
    "dropdelst": "KS",
    "dropdelzpp": 675619998,
    "dropphyadd": "6 N NICKERSON ST",
    "dropphycty": "NICKERSON",
    "dropphyst": "KS",
    "dropphyzpp": 675619998,
    "dropmaladd": "6 N NICKERSON ST",
    "dropmalcty": "NICKERSON",
    "dropmalst": "KS",
    "dropmalzpp": 675619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204223758,
    "dropsitcph": 6204223758,
    "dropfax": 6204223758
  },
  {
    "dcode": "D",
    "dropkey": "PW21103",
    "droptype": "D",
    "dropname": "NIOTAZE",
    "dropdeladd": "113 W NORTH 2ND ST",
    "dropdelcty": "NIOTAZE",
    "dropdelst": "KS",
    "dropdelzpp": 673555800,
    "dropphyadd": "113 W NORTH 2ND ST",
    "dropphycty": "NIOTAZE",
    "dropphyst": "KS",
    "dropphyzpp": 673555800,
    "dropmaladd": "113 W NORTH 2ND ST",
    "dropmalcty": "NIOTAZE",
    "dropmalst": "KS",
    "dropmalzpp": 673555800,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206739981,
    "dropsitcph": 6206739981,
    "dropfax": 6206739981
  },
  {
    "dcode": "D",
    "dropkey": "PW21108",
    "droptype": "D",
    "dropname": "NORCATUR",
    "dropdeladd": "106 S DECATUR AVE",
    "dropdelcty": "NORCATUR",
    "dropdelst": "KS",
    "dropdelzpp": 676539998,
    "dropphyadd": "106 S DECATUR AVE",
    "dropphycty": "NORCATUR",
    "dropphyst": "KS",
    "dropphyzpp": 676539998,
    "dropmaladd": "106 S DECATUR AVE",
    "dropmalcty": "NORCATUR",
    "dropmalst": "KS",
    "dropmalzpp": 676539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856934231,
    "dropsitcph": 7856934231,
    "dropfax": 7856934231
  },
  {
    "dcode": "D",
    "dropkey": "PW21111",
    "droptype": "D",
    "dropname": "NORTH NEWTON",
    "dropdeladd": "2509 N MAIN ST",
    "dropdelcty": "NORTH NEWTON",
    "dropdelst": "KS",
    "dropdelzpp": 671179998,
    "dropphyadd": "2509 N MAIN ST",
    "dropphycty": "NORTH NEWTON",
    "dropphyst": "KS",
    "dropphyzpp": 671179998,
    "dropmaladd": "2509 N MAIN ST",
    "dropmalcty": "NORTH NEWTON",
    "dropmalst": "KS",
    "dropmalzpp": 671179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3162836350,
    "dropsitcph": 3162836350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21117",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "302 E WASHINGTON ST",
    "dropdelcty": "NORTON",
    "dropdelst": "KS",
    "dropdelzpp": 676549998,
    "dropphyadd": "302 E WASHINGTON ST",
    "dropphycty": "NORTON",
    "dropphyst": "KS",
    "dropphyzpp": 676549998,
    "dropmaladd": "302 E WASHINGTON ST",
    "dropmalcty": "NORTON",
    "dropmalst": "KS",
    "dropmalzpp": 676549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858773212,
    "dropsitcph": 7858773212,
    "dropfax": 7858772316
  },
  {
    "dcode": "D",
    "dropkey": "PW21119",
    "droptype": "D",
    "dropname": "NORTONVILLE",
    "dropdeladd": "220 RAILROAD ST",
    "dropdelcty": "NORTONVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 660609998,
    "dropphyadd": "220 RAILROAD ST",
    "dropphycty": "NORTONVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 660609998,
    "dropmaladd": "220 RAILROAD ST",
    "dropmalcty": "NORTONVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 660609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138866060,
    "dropsitcph": 9138866060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21134",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "200 HUDSON AVE",
    "dropdelcty": "OAKLEY",
    "dropdelst": "KS",
    "dropdelzpp": 677489998,
    "dropphyadd": "200 HUDSON AVE",
    "dropphycty": "OAKLEY",
    "dropphyst": "KS",
    "dropphyzpp": 677489998,
    "dropmaladd": "200 HUDSON AVE",
    "dropmalcty": "OAKLEY",
    "dropmalst": "KS",
    "dropmalzpp": 677489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856724116,
    "dropsitcph": 7856724116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21136",
    "droptype": "D",
    "dropname": "OBERLIN",
    "dropdeladd": "135 E HALL ST",
    "dropdelcty": "OBERLIN",
    "dropdelst": "KS",
    "dropdelzpp": 677499998,
    "dropphyadd": "135 E HALL ST",
    "dropphycty": "OBERLIN",
    "dropphyst": "KS",
    "dropphyzpp": 677499998,
    "dropmaladd": "135 E HALL ST",
    "dropmalcty": "OBERLIN",
    "dropmalst": "KS",
    "dropmalzpp": 677499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854752011,
    "dropsitcph": 7854752011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21140",
    "droptype": "D",
    "dropname": "OGDEN",
    "dropdeladd": "310 RILEY AVE",
    "dropdelcty": "OGDEN",
    "dropdelst": "KS",
    "dropdelzpp": 665179998,
    "dropphyadd": "310 RILEY AVE",
    "dropphycty": "OGDEN",
    "dropphyst": "KS",
    "dropphyzpp": 665179998,
    "dropmaladd": "310 RILEY AVE",
    "dropmalcty": "OGDEN",
    "dropmalst": "KS",
    "dropmalzpp": 665179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855878968,
    "dropsitcph": 7855878968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21141",
    "droptype": "D",
    "dropname": "OKETO",
    "dropdeladd": "121 E CENTER ST",
    "dropdelcty": "OKETO",
    "dropdelst": "KS",
    "dropdelzpp": 665189998,
    "dropphyadd": "121 E CENTER ST",
    "dropphycty": "OKETO",
    "dropphyst": "KS",
    "dropphyzpp": 665189998,
    "dropmaladd": "121 E CENTER ST",
    "dropmalcty": "OKETO",
    "dropmalst": "KS",
    "dropmalzpp": 665189998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857443511,
    "dropsitcph": 7857443511,
    "dropfax": 7857443511
  },
  {
    "dcode": "D",
    "dropkey": "PW21142",
    "droptype": "D",
    "dropname": "OLATHE",
    "dropdeladd": "110 N CHESTNUT ST",
    "dropdelcty": "OLATHE",
    "dropdelst": "KS",
    "dropdelzpp": 660619998,
    "dropphyadd": "110 N CHESTNUT ST",
    "dropphycty": "OLATHE",
    "dropphyst": "KS",
    "dropphyzpp": 660619998,
    "dropmaladd": "110 N CHESTNUT ST",
    "dropmalcty": "OLATHE",
    "dropmalst": "KS",
    "dropmalzpp": 660619998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138290445,
    "dropsitcph": 9137823765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21146",
    "droptype": "D",
    "dropname": "OLMITZ",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "OLMITZ",
    "dropdelst": "KS",
    "dropdelzpp": 675649998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "OLMITZ",
    "dropphyst": "KS",
    "dropphyzpp": 675649998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "OLMITZ",
    "dropmalst": "KS",
    "dropmalzpp": 675649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205863319,
    "dropsitcph": 6205863319,
    "dropfax": 6205863319
  },
  {
    "dcode": "D",
    "dropkey": "PW21147",
    "droptype": "D",
    "dropname": "OLPE",
    "dropdeladd": "118 WESTPHALIA ST",
    "dropdelcty": "OLPE",
    "dropdelst": "KS",
    "dropdelzpp": 668659998,
    "dropphyadd": "118 WESTPHALIA ST",
    "dropphycty": "OLPE",
    "dropphyst": "KS",
    "dropphyzpp": 668659998,
    "dropmaladd": "118 WESTPHALIA ST",
    "dropmalcty": "OLPE",
    "dropmalst": "KS",
    "dropmalzpp": 668659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204753534,
    "dropsitcph": 6204753534,
    "dropfax": 6204753534
  },
  {
    "dcode": "D",
    "dropkey": "PW21148",
    "droptype": "D",
    "dropname": "OLSBURG",
    "dropdeladd": "319 2ND ST",
    "dropdelcty": "OLSBURG",
    "dropdelst": "KS",
    "dropdelzpp": 665209998,
    "dropphyadd": "319 2ND ST",
    "dropphycty": "OLSBURG",
    "dropphyst": "KS",
    "dropphyzpp": 665209998,
    "dropmaladd": "319 2ND ST",
    "dropmalcty": "OLSBURG",
    "dropmalst": "KS",
    "dropmalzpp": 665209998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854683686,
    "dropsitcph": 7854683686,
    "dropfax": 7854683686
  },
  {
    "dcode": "D",
    "dropkey": "PW21150",
    "droptype": "D",
    "dropname": "ONAGA",
    "dropdeladd": "300 LUCIEN ST",
    "dropdelcty": "ONAGA",
    "dropdelst": "KS",
    "dropdelzpp": 665219998,
    "dropphyadd": "300 LUCIEN ST",
    "dropphycty": "ONAGA",
    "dropphyst": "KS",
    "dropphyzpp": 665219998,
    "dropmaladd": "300 LUCIEN ST",
    "dropmalcty": "ONAGA",
    "dropmalst": "KS",
    "dropmalzpp": 665219998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855721097,
    "dropsitcph": 7855721097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21154",
    "droptype": "D",
    "dropname": "OPOLIS",
    "dropdeladd": "207 CENTER ST",
    "dropdelcty": "OPOLIS",
    "dropdelst": "KS",
    "dropdelzpp": 667609998,
    "dropphyadd": "207 CENTER ST",
    "dropphycty": "OPOLIS",
    "dropphyst": "KS",
    "dropphyzpp": 667609998,
    "dropmaladd": "207 CENTER ST",
    "dropmalcty": "OPOLIS",
    "dropmalst": "KS",
    "dropmalzpp": 667609998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202231410,
    "dropsitcph": 6202318087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21155",
    "droptype": "D",
    "dropname": "OSAGE CITY",
    "dropdeladd": "123 S 6TH ST",
    "dropdelcty": "OSAGE CITY",
    "dropdelst": "KS",
    "dropdelzpp": 665239998,
    "dropphyadd": "123 S 6TH ST",
    "dropphycty": "OSAGE CITY",
    "dropphyst": "KS",
    "dropphyzpp": 665239998,
    "dropmaladd": "123 S 6TH ST",
    "dropmalcty": "OSAGE CITY",
    "dropmalst": "KS",
    "dropmalzpp": 665239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855284431,
    "dropsitcph": 7855284431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21158",
    "droptype": "D",
    "dropname": "OSAWATOMIE",
    "dropdeladd": "404 5TH ST",
    "dropdelcty": "OSAWATOMIE",
    "dropdelst": "KS",
    "dropdelzpp": 660649998,
    "dropphyadd": "404 5TH ST",
    "dropphycty": "OSAWATOMIE",
    "dropphyst": "KS",
    "dropphyzpp": 660649998,
    "dropmaladd": "404 5TH ST",
    "dropmalcty": "OSAWATOMIE",
    "dropmalst": "KS",
    "dropmalzpp": 660649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137554626,
    "dropsitcph": 9137554626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21159",
    "droptype": "D",
    "dropname": "OSBORNE",
    "dropdeladd": "233 W MAIN ST",
    "dropdelcty": "OSBORNE",
    "dropdelst": "KS",
    "dropdelzpp": 674739998,
    "dropphyadd": "233 W MAIN ST",
    "dropphycty": "OSBORNE",
    "dropphyst": "KS",
    "dropphyzpp": 674739998,
    "dropmaladd": "233 W MAIN ST",
    "dropmalcty": "OSBORNE",
    "dropmalst": "KS",
    "dropmalzpp": 674739998,
    "dropsitphn": 6268843534,
    "dropsitlph": 6208843534,
    "dropsitcph": 6204983882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21161",
    "droptype": "D",
    "dropname": "OSKALOOSA",
    "dropdeladd": "302 WASHINGTON ST",
    "dropdelcty": "OSKALOOSA",
    "dropdelst": "KS",
    "dropdelzpp": 660669998,
    "dropphyadd": "302 WASHINGTON ST",
    "dropphycty": "OSKALOOSA",
    "dropphyst": "KS",
    "dropphyzpp": 660669998,
    "dropmaladd": "302 WASHINGTON ST",
    "dropmalcty": "OSKALOOSA",
    "dropmalst": "KS",
    "dropmalzpp": 660669998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858632400,
    "dropsitcph": 7858632400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21163",
    "droptype": "D",
    "dropname": "OSWEGO",
    "dropdeladd": "819 4TH ST",
    "dropdelcty": "OSWEGO",
    "dropdelst": "KS",
    "dropdelzpp": 673569998,
    "dropphyadd": "819 4TH ST",
    "dropphycty": "OSWEGO",
    "dropphyst": "KS",
    "dropphyzpp": 673569998,
    "dropmaladd": "819 4TH ST",
    "dropmalcty": "OSWEGO",
    "dropmalst": "KS",
    "dropmalzpp": 673569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202103026,
    "dropsitcph": 6202103026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21165",
    "droptype": "D",
    "dropname": "OTIS",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "OTIS",
    "dropdelst": "KS",
    "dropdelzpp": 675659500,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "OTIS",
    "dropphyst": "KS",
    "dropphyzpp": 675659500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTIS",
    "dropmalst": "KS",
    "dropmalzpp": 675659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853872480,
    "dropsitcph": 7853872480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21166",
    "droptype": "D",
    "dropname": "OTTAWA",
    "dropdeladd": "401 S HICKORY ST",
    "dropdelcty": "OTTAWA",
    "dropdelst": "KS",
    "dropdelzpp": 660679998,
    "dropphyadd": "401 S HICKORY ST",
    "dropphycty": "OTTAWA",
    "dropphyst": "KS",
    "dropphyzpp": 660679998,
    "dropmaladd": "401 S HICKORY ST",
    "dropmalcty": "OTTAWA",
    "dropmalst": "KS",
    "dropmalzpp": 660679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7852422002,
    "dropsitcph": 7852422000,
    "dropfax": 7852420811
  },
  {
    "dcode": "D",
    "dropkey": "PW21170",
    "droptype": "D",
    "dropname": "OVERBROOK",
    "dropdeladd": "320 MAPLE ST",
    "dropdelcty": "OVERBROOK",
    "dropdelst": "KS",
    "dropdelzpp": 665249998,
    "dropphyadd": "320 MAPLE ST",
    "dropphycty": "OVERBROOK",
    "dropphyst": "KS",
    "dropphyzpp": 665249998,
    "dropmaladd": "320 MAPLE ST",
    "dropmalcty": "OVERBROOK",
    "dropmalst": "KS",
    "dropmalzpp": 665249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856657712,
    "dropsitcph": 7856657712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21173",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "120 N SUMNER ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "KS",
    "dropdelzpp": 671199998,
    "dropphyadd": "120 N SUMNER ST",
    "dropphycty": "OXFORD",
    "dropphyst": "KS",
    "dropphyzpp": 671199998,
    "dropmaladd": "120 N SUMNER ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "KS",
    "dropmalzpp": 671199998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204552233,
    "dropsitcph": 6204552233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21174",
    "droptype": "D",
    "dropname": "OZAWKIE",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "OZAWKIE",
    "dropdelst": "KS",
    "dropdelzpp": 660709998,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "OZAWKIE",
    "dropphyst": "KS",
    "dropphyzpp": 660709998,
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "OZAWKIE",
    "dropmalst": "KS",
    "dropmalzpp": 660709998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749109,
    "dropsitcph": 7858762499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21179",
    "droptype": "D",
    "dropname": "PALCO",
    "dropdeladd": "411 MAIN ST",
    "dropdelcty": "PALCO",
    "dropdelst": "KS",
    "dropdelzpp": 676579998,
    "dropphyadd": "411 MAIN ST",
    "dropphycty": "PALCO",
    "dropphyst": "KS",
    "dropphyzpp": 676579998,
    "dropmaladd": "411 MAIN ST",
    "dropmalcty": "PALCO",
    "dropmalst": "KS",
    "dropmalzpp": 676579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854252074,
    "dropsitcph": 7854252074,
    "dropfax": 7857375106
  },
  {
    "dcode": "D",
    "dropkey": "PW21181",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "101 E 2ND ST",
    "dropdelcty": "PALMER",
    "dropdelst": "KS",
    "dropdelzpp": 669629701,
    "dropphyadd": "101 E 2ND ST",
    "dropphycty": "PALMER",
    "dropphyst": "KS",
    "dropphyzpp": 669629701,
    "dropmaladd": "101 E 2ND ST",
    "dropmalcty": "PALMER",
    "dropmalst": "KS",
    "dropmalzpp": 669629701,
    "dropsitphn": 4023482736,
    "dropsitlph": "",
    "dropsitcph": 7856924347,
    "dropfax": 7856924347
  },
  {
    "dcode": "D",
    "dropkey": "PW21182",
    "droptype": "D",
    "dropname": "PAOLA",
    "dropdeladd": "19 E WEA ST",
    "dropdelcty": "PAOLA",
    "dropdelst": "KS",
    "dropdelzpp": 660719998,
    "dropphyadd": "19 E WEA ST",
    "dropphycty": "PAOLA",
    "dropphyst": "KS",
    "dropphyzpp": 660719998,
    "dropmaladd": "19 E WEA ST",
    "dropmalcty": "PAOLA",
    "dropmalst": "KS",
    "dropmalzpp": 660719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9135573116,
    "dropsitcph": 9132949296,
    "dropfax": 9132949387
  },
  {
    "dcode": "D",
    "dropkey": "PW21183",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "PARADISE",
    "dropdelst": "KS",
    "dropdelzpp": 676585800,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "PARADISE",
    "dropphyst": "KS",
    "dropphyzpp": 676585800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARADISE",
    "dropmalst": "KS",
    "dropmalzpp": 676589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859984373,
    "dropsitcph": 7859984373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21187",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "102 N CENTER AVE",
    "dropdelcty": "PARKER",
    "dropdelst": "KS",
    "dropdelzpp": 660729998,
    "dropphyadd": "102 N CENTER AVE",
    "dropphycty": "PARKER",
    "dropphyst": "KS",
    "dropphyzpp": 660729998,
    "dropmaladd": "102 N CENTER AVE",
    "dropmalcty": "PARKER",
    "dropmalst": "KS",
    "dropmalzpp": 660729998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138982895,
    "dropsitcph": 9138982895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21191",
    "droptype": "D",
    "dropname": "PARSONS",
    "dropdeladd": "1700 MAIN ST",
    "dropdelcty": "PARSONS",
    "dropdelst": "KS",
    "dropdelzpp": 673579998,
    "dropphyadd": "1700 MAIN ST",
    "dropphycty": "PARSONS",
    "dropphyst": "KS",
    "dropphyzpp": 673579998,
    "dropmaladd": "1700 MAIN ST",
    "dropmalcty": "PARSONS",
    "dropmalst": "KS",
    "dropmalzpp": 673579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204213900,
    "dropsitcph": 6204213900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21192",
    "droptype": "D",
    "dropname": "PARTRIDGE",
    "dropdeladd": "24 S MAIN ST",
    "dropdelcty": "PARTRIDGE",
    "dropdelst": "KS",
    "dropdelzpp": 675669998,
    "dropphyadd": "24 S MAIN ST",
    "dropphycty": "PARTRIDGE",
    "dropphyst": "KS",
    "dropphyzpp": 675669998,
    "dropmaladd": "24 S MAIN ST",
    "dropmalcty": "PARTRIDGE",
    "dropmalst": "KS",
    "dropmalzpp": 675669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205672240,
    "dropsitcph": 6205672240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21197",
    "droptype": "D",
    "dropname": "PAWNEE ROCK",
    "dropdeladd": "501 CENTRE ST",
    "dropdelcty": "PAWNEE ROCK",
    "dropdelst": "KS",
    "dropdelzpp": 675679700,
    "dropphyadd": "501 CENTRE ST",
    "dropphycty": "PAWNEE ROCK",
    "dropphyst": "KS",
    "dropphyzpp": 675679700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAWNEE ROCK",
    "dropmalst": "KS",
    "dropmalzpp": 675679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209824308,
    "dropsitcph": 6209824308,
    "dropfax": 6209824308
  },
  {
    "dcode": "D",
    "dropkey": "PW21199",
    "droptype": "D",
    "dropname": "PAXICO",
    "dropdeladd": "201 NEWBURY AVE",
    "dropdelcty": "PAXICO",
    "dropdelst": "KS",
    "dropdelzpp": 665269998,
    "dropphyadd": "201 NEWBURY AVE",
    "dropphycty": "PAXICO",
    "dropphyst": "KS",
    "dropphyzpp": 665269998,
    "dropmaladd": "201 NEWBURY AVE",
    "dropmalcty": "PAXICO",
    "dropmalst": "KS",
    "dropmalzpp": 665269998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856365441,
    "dropsitcph": 7856365441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21202",
    "droptype": "D",
    "dropname": "PEABODY",
    "dropdeladd": "105 W 2ND ST",
    "dropdelcty": "PEABODY",
    "dropdelst": "KS",
    "dropdelzpp": 668669998,
    "dropphyadd": "105 W 2ND ST",
    "dropphycty": "PEABODY",
    "dropphyst": "KS",
    "dropphyzpp": 668669998,
    "dropmaladd": "105 W 2ND ST",
    "dropmalcty": "PEABODY",
    "dropmalst": "KS",
    "dropmalzpp": 668669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209832404,
    "dropsitcph": 6209832404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21203",
    "droptype": "D",
    "dropname": "PECK",
    "dropdeladd": "328 W 7TH ST",
    "dropdelcty": "PECK",
    "dropdelst": "KS",
    "dropdelzpp": 671209008,
    "dropphyadd": "328 W 7TH ST",
    "dropphycty": "PECK",
    "dropphyst": "KS",
    "dropphyzpp": 671209008,
    "dropmaladd": "328 W 7TH ST",
    "dropmalcty": "PECK",
    "dropmalst": "KS",
    "dropmalzpp": 671209008,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165241151,
    "dropsitcph": 3165241151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21208",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "209 N ELM ST",
    "dropdelcty": "PERRY",
    "dropdelst": "KS",
    "dropdelzpp": 660739998,
    "dropphyadd": "209 N ELM ST",
    "dropphycty": "PERRY",
    "dropphyst": "KS",
    "dropphyzpp": 660739998,
    "dropmaladd": "209 N ELM ST",
    "dropmalcty": "PERRY",
    "dropmalst": "KS",
    "dropmalzpp": 660739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855975336,
    "dropsitcph": 7855975336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21210",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "101 E 6TH ST",
    "dropdelcty": "PERU",
    "dropdelst": "KS",
    "dropdelzpp": 673609800,
    "dropphyadd": "101 E 6TH ST",
    "dropphycty": "PERU",
    "dropphyst": "KS",
    "dropphyzpp": 673609800,
    "dropmaladd": "101 E 6TH ST",
    "dropmalcty": "PERU",
    "dropmalst": "KS",
    "dropmalzpp": 673609800,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207255548,
    "dropsitcph": 6207255548,
    "dropfax": 6207255548
  },
  {
    "dcode": "D",
    "dropkey": "PW21214",
    "droptype": "D",
    "dropname": "PHILLIPSBURG",
    "dropdeladd": "888 2ND ST",
    "dropdelcty": "PHILLIPSBURG",
    "dropdelst": "KS",
    "dropdelzpp": 676619998,
    "dropphyadd": "888 2ND ST",
    "dropphycty": "PHILLIPSBURG",
    "dropphyst": "KS",
    "dropphyzpp": 676619998,
    "dropmaladd": "888 2ND ST",
    "dropmalcty": "PHILLIPSBURG",
    "dropmalst": "KS",
    "dropmalzpp": 676619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855432915,
    "dropsitcph": 7855432915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21216",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "107 J80 RD",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "KS",
    "dropdelzpp": 671222203,
    "dropphyadd": "107 J80 RD",
    "dropphycty": "PIEDMONT",
    "dropphyst": "KS",
    "dropphyzpp": 671222203,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "KS",
    "dropmalzpp": 671229998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203748016,
    "dropsitcph": 6203748016,
    "dropfax": 6208642226
  },
  {
    "dcode": "D",
    "dropkey": "PW21222",
    "droptype": "D",
    "dropname": "PIQUA",
    "dropdeladd": "108 W 2ND ST",
    "dropdelcty": "PIQUA",
    "dropdelst": "KS",
    "dropdelzpp": 667611601,
    "dropphyadd": "108 W 2ND ST",
    "dropphycty": "PIQUA",
    "dropphyst": "KS",
    "dropphyzpp": 667611601,
    "dropmaladd": "108 W 2ND ST",
    "dropmalcty": "PIQUA",
    "dropmalst": "KS",
    "dropmalzpp": 667611601,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204682791,
    "dropsitcph": 6204682791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21224",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "702 N LOCUST ST",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "KS",
    "dropdelzpp": 667629998,
    "dropphyadd": "702 N LOCUST ST",
    "dropphycty": "PITTSBURG",
    "dropphyst": "KS",
    "dropphyzpp": 667629998,
    "dropmaladd": "702 N LOCUST ST",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "KS",
    "dropmalzpp": 667629998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202316000,
    "dropsitcph": 6202316000,
    "dropfax": 6202327507
  },
  {
    "dcode": "D",
    "dropkey": "PW21226",
    "droptype": "D",
    "dropname": "PLAINS",
    "dropdeladd": "416 GRAND AVE",
    "dropdelcty": "PLAINS",
    "dropdelst": "KS",
    "dropdelzpp": 678699998,
    "dropphyadd": "416 GRAND AVE",
    "dropphycty": "PLAINS",
    "dropphyst": "KS",
    "dropphyzpp": 678699998,
    "dropmaladd": "416 GRAND AVE",
    "dropmalcty": "PLAINS",
    "dropmalst": "KS",
    "dropmalzpp": 678699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205637202,
    "dropsitcph": 6205637202,
    "dropfax": 6205637202
  },
  {
    "dcode": "D",
    "dropkey": "PW21227",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 676639998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 676639998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 676639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854342245,
    "dropsitcph": 7854342245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21230",
    "droptype": "D",
    "dropname": "PLEASANTON",
    "dropdeladd": "1004 MAIN ST",
    "dropdelcty": "PLEASANTON",
    "dropdelst": "KS",
    "dropdelzpp": 660759998,
    "dropphyadd": "1004 MAIN ST",
    "dropphycty": "PLEASANTON",
    "dropphyst": "KS",
    "dropphyzpp": 660759998,
    "dropmaladd": "1004 MAIN ST",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "KS",
    "dropmalzpp": 660759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9133526154,
    "dropsitcph": 9133526154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21235",
    "droptype": "D",
    "dropname": "POMONA",
    "dropdeladd": "230 MADISON ST",
    "dropdelcty": "POMONA",
    "dropdelst": "KS",
    "dropdelzpp": 660769998,
    "dropphyadd": "230 MADISON ST",
    "dropphycty": "POMONA",
    "dropphyst": "KS",
    "dropphyzpp": 660769998,
    "dropmaladd": "230 MADISON ST",
    "dropmalcty": "POMONA",
    "dropmalst": "KS",
    "dropmalzpp": 660769998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855663632,
    "dropsitcph": 7855663632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21238",
    "droptype": "D",
    "dropname": "PORTIS",
    "dropdeladd": "411 MARKET ST",
    "dropdelcty": "PORTIS",
    "dropdelst": "KS",
    "dropdelzpp": 674749998,
    "dropphyadd": "411 MARKET ST",
    "dropphycty": "PORTIS",
    "dropphyst": "KS",
    "dropphyzpp": 674749998,
    "dropmaladd": "411 MARKET ST",
    "dropmalcty": "PORTIS",
    "dropmalst": "KS",
    "dropmalzpp": 674749998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853465731,
    "dropsitcph": 7853465731,
    "dropfax": 7553465731
  },
  {
    "dcode": "D",
    "dropkey": "PW21242",
    "droptype": "D",
    "dropname": "POTWIN",
    "dropdeladd": "103 E MARSHALL AVE",
    "dropdelcty": "POTWIN",
    "dropdelst": "KS",
    "dropdelzpp": 671239998,
    "dropphyadd": "103 E MARSHALL AVE",
    "dropphycty": "POTWIN",
    "dropphyst": "KS",
    "dropphyzpp": 671239998,
    "dropmaladd": "103 E MARSHALL AVE",
    "dropmalcty": "POTWIN",
    "dropmalst": "KS",
    "dropmalzpp": 671239998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207523268,
    "dropsitcph": 6207523268,
    "dropfax": 6207523268
  },
  {
    "dcode": "D",
    "dropkey": "PW21243",
    "droptype": "D",
    "dropname": "POWHATTAN",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "POWHATTAN",
    "dropdelst": "KS",
    "dropdelzpp": 665279998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "POWHATTAN",
    "dropphyst": "KS",
    "dropphyzpp": 665279998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "POWHATTAN",
    "dropmalst": "KS",
    "dropmalzpp": 665279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854743537,
    "dropsitcph": 7854743537,
    "dropfax": 7854743537
  },
  {
    "dcode": "D",
    "dropkey": "PW21246",
    "droptype": "D",
    "dropname": "PRAIRIE VIEW",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "PRAIRIE VIEW",
    "dropdelst": "KS",
    "dropdelzpp": 676649998,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "PRAIRIE VIEW",
    "dropphyst": "KS",
    "dropphyzpp": 676649998,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "PRAIRIE VIEW",
    "dropmalst": "KS",
    "dropmalzpp": 676649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859732395,
    "dropsitcph": 7859732395,
    "dropfax": 7859732395
  },
  {
    "dcode": "D",
    "dropkey": "PW21250",
    "droptype": "D",
    "dropname": "PRATT",
    "dropdeladd": "202 E 3RD ST",
    "dropdelcty": "PRATT",
    "dropdelst": "KS",
    "dropdelzpp": 671249998,
    "dropphyadd": "202 E 3RD ST",
    "dropphycty": "PRATT",
    "dropphyst": "KS",
    "dropphyzpp": 671249998,
    "dropmaladd": "202 E 3RD ST",
    "dropmalcty": "PRATT",
    "dropmalst": "KS",
    "dropmalzpp": 671249998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3169464620,
    "dropsitcph": 6206727559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21251",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "317 MAIN ST",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "KS",
    "dropdelzpp": 667679998,
    "dropphyadd": "317 MAIN ST",
    "dropphycty": "PRESCOTT",
    "dropphyst": "KS",
    "dropphyzpp": 667679998,
    "dropmaladd": "317 MAIN ST",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "KS",
    "dropmalzpp": 667679998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9134714341,
    "dropsitcph": 9134714341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21253",
    "droptype": "D",
    "dropname": "PRETTY PRAIRIE",
    "dropdeladd": "114 W MAIN ST",
    "dropdelcty": "PRETTY PRAIRIE",
    "dropdelst": "KS",
    "dropdelzpp": 675709998,
    "dropphyadd": "114 W MAIN ST",
    "dropphycty": "PRETTY PRAIRIE",
    "dropphyst": "KS",
    "dropphyzpp": 675709998,
    "dropmaladd": "114 W MAIN ST",
    "dropmalcty": "PRETTY PRAIRIE",
    "dropmalst": "KS",
    "dropmalzpp": 675709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204596605,
    "dropsitcph": 6204596605,
    "dropfax": 6204596605
  },
  {
    "dcode": "D",
    "dropkey": "PW21255",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "314 GALVESTON ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "KS",
    "dropdelzpp": 660789998,
    "dropphyadd": "314 GALVESTON ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "KS",
    "dropphyzpp": 660789998,
    "dropmaladd": "314 GALVESTON ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "KS",
    "dropmalzpp": 660789998,
    "dropsitphn": 8163749109,
    "dropsitlph": 7859372200,
    "dropsitcph": 7859372200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21256",
    "droptype": "D",
    "dropname": "PROTECTION",
    "dropdeladd": "107 W WALNUT ST",
    "dropdelcty": "PROTECTION",
    "dropdelst": "KS",
    "dropdelzpp": 671279998,
    "dropphyadd": "107 W WALNUT ST",
    "dropphycty": "PROTECTION",
    "dropphyst": "KS",
    "dropphyzpp": 671279998,
    "dropmaladd": "107 W WALNUT ST",
    "dropmalcty": "PROTECTION",
    "dropmalst": "KS",
    "dropmalzpp": 671279998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206224451,
    "dropsitcph": 6206224451,
    "dropfax": 6206224451
  },
  {
    "dcode": "D",
    "dropkey": "PW21260",
    "droptype": "D",
    "dropname": "QUENEMO",
    "dropdeladd": "121 N 5TH ST",
    "dropdelcty": "QUENEMO",
    "dropdelst": "KS",
    "dropdelzpp": 665289998,
    "dropphyadd": "121 N 5TH ST",
    "dropphycty": "QUENEMO",
    "dropphyst": "KS",
    "dropphyzpp": 665289998,
    "dropmaladd": "121 N 5TH ST",
    "dropmalcty": "QUENEMO",
    "dropmalst": "KS",
    "dropmalzpp": 665289998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857593312,
    "dropsitcph": 7857593312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21262",
    "droptype": "D",
    "dropname": "QUINTER",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "QUINTER",
    "dropdelst": "KS",
    "dropdelzpp": 677529998,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "QUINTER",
    "dropphyst": "KS",
    "dropphyzpp": 677529998,
    "dropmaladd": "315 MAIN ST",
    "dropmalcty": "QUINTER",
    "dropmalst": "KS",
    "dropmalzpp": 677529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857543920,
    "dropsitcph": 7857543920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21267",
    "droptype": "D",
    "dropname": "RAMONA",
    "dropdeladd": "215 N D ST",
    "dropdelcty": "RAMONA",
    "dropdelst": "KS",
    "dropdelzpp": 674759998,
    "dropphyadd": "215 N D ST",
    "dropphycty": "RAMONA",
    "dropphyst": "KS",
    "dropphyzpp": 674759998,
    "dropmaladd": "215 N D ST",
    "dropmalcty": "RAMONA",
    "dropmalst": "KS",
    "dropmalzpp": 674759998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859657171,
    "dropsitcph": 7859657171,
    "dropfax": 7859657171
  },
  {
    "dcode": "D",
    "dropkey": "PW21269",
    "droptype": "D",
    "dropname": "RANDALL",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "RANDALL",
    "dropdelst": "KS",
    "dropdelzpp": 669639700,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "RANDALL",
    "dropphyst": "KS",
    "dropphyzpp": 669639700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDALL",
    "dropmalst": "KS",
    "dropmalzpp": 669639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857392249,
    "dropsitcph": 7857392249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21270",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "117 W RANDOLPH ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "KS",
    "dropdelzpp": 665549998,
    "dropphyadd": "117 W RANDOLPH ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "KS",
    "dropphyzpp": 665549998,
    "dropmaladd": "117 W RANDOLPH ST",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "KS",
    "dropmalzpp": 665549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852935261,
    "dropsitcph": 7852935261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21271",
    "droptype": "D",
    "dropname": "RANSOM",
    "dropdeladd": "417 S VERMONT AVE",
    "dropdelcty": "RANSOM",
    "dropdelst": "KS",
    "dropdelzpp": 675729599,
    "dropphyadd": "417 S VERMONT AVE",
    "dropphycty": "RANSOM",
    "dropphyst": "KS",
    "dropphyzpp": 675729599,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANSOM",
    "dropmalst": "KS",
    "dropmalzpp": 675729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857312242,
    "dropsitcph": 7857312242,
    "dropfax": 7857312242
  },
  {
    "dcode": "D",
    "dropkey": "PW21272",
    "droptype": "D",
    "dropname": "RANTOUL",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "RANTOUL",
    "dropdelst": "KS",
    "dropdelzpp": 660799998,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "RANTOUL",
    "dropphyst": "KS",
    "dropphyzpp": 660799998,
    "dropmaladd": "106 E MAIN ST",
    "dropmalcty": "RANTOUL",
    "dropmalst": "KS",
    "dropmalzpp": 660799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138783415,
    "dropsitcph": 9138783415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21273",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "KS",
    "dropdelzpp": 675739509,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "KS",
    "dropphyzpp": 675739509,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "RAYMOND",
    "dropmalst": "KS",
    "dropmalzpp": 675739509,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205342049,
    "dropsitcph": 6205342049,
    "dropfax": 6205342049
  },
  {
    "dcode": "D",
    "dropkey": "PW21274",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "413 1ST ST",
    "dropdelcty": "READING",
    "dropdelst": "KS",
    "dropdelzpp": 668689998,
    "dropphyadd": "413 1ST ST",
    "dropphycty": "READING",
    "dropphyst": "KS",
    "dropphyzpp": 668689998,
    "dropmaladd": "413 1ST ST",
    "dropmalcty": "READING",
    "dropmalst": "KS",
    "dropmalzpp": 668689998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206993350,
    "dropsitcph": 6206993350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21277",
    "droptype": "D",
    "dropname": "REDFIELD",
    "dropdeladd": "205 PINE ST",
    "dropdelcty": "REDFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 667699998,
    "dropphyadd": "205 PINE ST",
    "dropphycty": "REDFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 667699998,
    "dropmaladd": "205 PINE ST",
    "dropmalcty": "REDFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 667699998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207564575,
    "dropsitcph": 6207564575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21283",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "KS",
    "dropdelzpp": 669649998,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "KS",
    "dropphyzpp": 669649998,
    "dropmaladd": "413 MAIN ST",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "KS",
    "dropmalzpp": 669649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853612744,
    "dropsitcph": 7853612744,
    "dropfax": 7853612744
  },
  {
    "dcode": "D",
    "dropkey": "PW21285",
    "droptype": "D",
    "dropname": "REXFORD",
    "dropdeladd": "245 MAIN ST",
    "dropdelcty": "REXFORD",
    "dropdelst": "KS",
    "dropdelzpp": 677539646,
    "dropphyadd": "245 MAIN ST",
    "dropphycty": "REXFORD",
    "dropphyst": "KS",
    "dropphyzpp": 677539646,
    "dropmaladd": "245 MAIN ST",
    "dropmalcty": "REXFORD",
    "dropmalst": "KS",
    "dropmalzpp": 677539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856873665,
    "dropsitcph": 7856873665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21287",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "223 7TH ST",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 679539500,
    "dropphyadd": "223 7TH ST",
    "dropphycty": "RICHFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 679539500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 679539998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205922181,
    "dropsitcph": 6205922181,
    "dropfax": 6205922181
  },
  {
    "dcode": "D",
    "dropkey": "PW21293",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "117 E CENTRAL ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "KS",
    "dropdelzpp": 660809998,
    "dropphyadd": "117 E CENTRAL ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "KS",
    "dropphyzpp": 660809998,
    "dropmaladd": "117 E CENTRAL ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "KS",
    "dropmalzpp": 660809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858356320,
    "dropsitcph": 7858356320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21295",
    "droptype": "D",
    "dropname": "RILEY",
    "dropdeladd": "122 S BROADWAY ST",
    "dropdelcty": "RILEY",
    "dropdelst": "KS",
    "dropdelzpp": 665319998,
    "dropphyadd": "122 S BROADWAY ST",
    "dropphycty": "RILEY",
    "dropphyst": "KS",
    "dropphyzpp": 665319998,
    "dropmaladd": "122 S BROADWAY ST",
    "dropmalcty": "RILEY",
    "dropmalst": "KS",
    "dropmalzpp": 665319998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854852534,
    "dropsitcph": 7854852534,
    "dropfax": 7854852534
  },
  {
    "dcode": "D",
    "dropkey": "PW21300",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "7018 SE NIGHTHAWK LN",
    "dropdelcty": "RIVERTON",
    "dropdelst": "KS",
    "dropdelzpp": 667709998,
    "dropphyadd": "7018 SE NIGHTHAWK LN",
    "dropphycty": "RIVERTON",
    "dropphyst": "KS",
    "dropphyzpp": 667709998,
    "dropmaladd": "7018 SE NIGHTHAWK LN",
    "dropmalcty": "RIVERTON",
    "dropmalst": "KS",
    "dropmalzpp": 667709998,
    "dropsitphn": 8163749109,
    "dropsitlph": 6208483141,
    "dropsitcph": 6208483141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21302",
    "droptype": "D",
    "dropname": "ROBINSON",
    "dropdeladd": "117 PARSONS ST",
    "dropdelcty": "ROBINSON",
    "dropdelst": "KS",
    "dropdelzpp": 665329998,
    "dropphyadd": "117 PARSONS ST",
    "dropphycty": "ROBINSON",
    "dropphyst": "KS",
    "dropphyzpp": 665329998,
    "dropmaladd": "117 PARSONS ST",
    "dropmalcty": "ROBINSON",
    "dropmalst": "KS",
    "dropmalzpp": 665329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855081089,
    "dropsitcph": 7855081089,
    "dropfax": 7855446561
  },
  {
    "dcode": "D",
    "dropkey": "PW21304",
    "droptype": "D",
    "dropname": "ROCK",
    "dropdeladd": "333 WILLIAMS",
    "dropdelcty": "ROCK",
    "dropdelst": "KS",
    "dropdelzpp": 671319700,
    "dropphyadd": "333 WILLIAMS",
    "dropphycty": "ROCK",
    "dropphyst": "KS",
    "dropphyzpp": 671319700,
    "dropmaladd": "333 WILLIAMS",
    "dropmalcty": "ROCK",
    "dropmalst": "KS",
    "dropmalzpp": 671319700,
    "dropsitphn": 4023482736,
    "dropsitlph": 6209865415,
    "dropsitcph": 6209865415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21307",
    "droptype": "D",
    "dropname": "ROLLA",
    "dropdeladd": "301 S WASHINGTON ST",
    "dropdelcty": "ROLLA",
    "dropdelst": "KS",
    "dropdelzpp": 679549500,
    "dropphyadd": "301 S WASHINGTON ST",
    "dropphycty": "ROLLA",
    "dropphyst": "KS",
    "dropphyzpp": 679549500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROLLA",
    "dropmalst": "KS",
    "dropmalzpp": 679549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205934483,
    "dropsitcph": 6205934483,
    "dropfax": 6205934483
  },
  {
    "dcode": "D",
    "dropkey": "PW21311",
    "droptype": "D",
    "dropname": "ROSALIA",
    "dropdeladd": "616 SE ROSALIA RD",
    "dropdelcty": "ROSALIA",
    "dropdelst": "KS",
    "dropdelzpp": 671329998,
    "dropphyadd": "616 SE ROSALIA RD",
    "dropphycty": "ROSALIA",
    "dropphyst": "KS",
    "dropphyzpp": 671329998,
    "dropmaladd": "616 SE ROSALIA RD",
    "dropmalcty": "ROSALIA",
    "dropmalst": "KS",
    "dropmalzpp": 671329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204762282,
    "dropsitcph": 6204762282,
    "dropfax": 6204762282
  },
  {
    "dcode": "D",
    "dropkey": "PW21314",
    "droptype": "D",
    "dropname": "ROSE HILL",
    "dropdeladd": "401 N ROSE HILL RD",
    "dropdelcty": "ROSE HILL",
    "dropdelst": "KS",
    "dropdelzpp": 671339998,
    "dropphyadd": "401 N ROSE HILL RD",
    "dropphycty": "ROSE HILL",
    "dropphyst": "KS",
    "dropphyzpp": 671339998,
    "dropmaladd": "401 N ROSE HILL RD",
    "dropmalcty": "ROSE HILL",
    "dropmalst": "KS",
    "dropmalzpp": 671339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167762515,
    "dropsitcph": 3167762515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21320",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "436 MAIN ST",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 665339001,
    "dropphyadd": "436 MAIN ST",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 665339001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 665339998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855846417,
    "dropsitcph": 7855846417,
    "dropfax": 7855846417
  },
  {
    "dcode": "D",
    "dropkey": "PW21325",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "104 S MAIN ST",
    "dropdelcty": "ROXBURY",
    "dropdelst": "KS",
    "dropdelzpp": 674769998,
    "dropphyadd": "104 S MAIN ST",
    "dropphycty": "ROXBURY",
    "dropphyst": "KS",
    "dropphyzpp": 674769998,
    "dropmaladd": "104 S MAIN ST",
    "dropmalcty": "ROXBURY",
    "dropmalst": "KS",
    "dropmalzpp": 674769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852547622,
    "dropsitcph": 7852547622,
    "dropfax": 7852547622
  },
  {
    "dcode": "D",
    "dropkey": "PW21327",
    "droptype": "D",
    "dropname": "ROZEL",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "ROZEL",
    "dropdelst": "KS",
    "dropdelzpp": 675749998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "ROZEL",
    "dropphyst": "KS",
    "dropphyzpp": 675749998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "ROZEL",
    "dropmalst": "KS",
    "dropmalzpp": 675749998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205274229,
    "dropsitcph": 6205274229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21330",
    "droptype": "D",
    "dropname": "RUSH CENTER",
    "dropdeladd": "221 N MAIN ST",
    "dropdelcty": "RUSH CENTER",
    "dropdelst": "KS",
    "dropdelzpp": 675759500,
    "dropphyadd": "221 N MAIN ST",
    "dropphycty": "RUSH CENTER",
    "dropphyst": "KS",
    "dropphyzpp": 675759500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSH CENTER",
    "dropmalst": "KS",
    "dropmalzpp": 675759998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853724227,
    "dropsitcph": 7853724227,
    "dropfax": 7853724227
  },
  {
    "dcode": "D",
    "dropkey": "PW21333",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "135 W WISCONSIN ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "KS",
    "dropdelzpp": 676659998,
    "dropphyadd": "135 W WISCONSIN ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "KS",
    "dropphyzpp": 676659998,
    "dropmaladd": "135 W WISCONSIN ST",
    "dropmalcty": "RUSSELL",
    "dropmalst": "KS",
    "dropmalzpp": 676659998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854834971,
    "dropsitcph": 7854834971,
    "dropfax": 6513653130
  },
  {
    "dcode": "D",
    "dropkey": "PW21338",
    "droptype": "D",
    "dropname": "SABETHA",
    "dropdeladd": "122 S 9TH ST",
    "dropdelcty": "SABETHA",
    "dropdelst": "KS",
    "dropdelzpp": 665349998,
    "dropphyadd": "122 S 9TH ST",
    "dropphycty": "SABETHA",
    "dropphyst": "KS",
    "dropphyzpp": 665349998,
    "dropmaladd": "122 S 9TH ST",
    "dropmalcty": "SABETHA",
    "dropmalst": "KS",
    "dropmalzpp": 665349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852842960,
    "dropsitcph": 7853369473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21341",
    "droptype": "D",
    "dropname": "SAINT FRANCIS",
    "dropdeladd": "222 W WASHINGTON ST",
    "dropdelcty": "SAINT FRANCIS",
    "dropdelst": "KS",
    "dropdelzpp": 677569998,
    "dropphyadd": "222 W WASHINGTON ST",
    "dropphycty": "SAINT FRANCIS",
    "dropphyst": "KS",
    "dropphyzpp": 677569998,
    "dropmaladd": "222 W WASHINGTON ST",
    "dropmalcty": "SAINT FRANCIS",
    "dropmalst": "KS",
    "dropmalzpp": 677569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853322222,
    "dropsitcph": 7853322222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21342",
    "droptype": "D",
    "dropname": "SAINT GEORGE",
    "dropdeladd": "203 1ST ST",
    "dropdelcty": "SAINT GEORGE",
    "dropdelst": "KS",
    "dropdelzpp": 665359998,
    "dropphyadd": "203 1ST ST",
    "dropphycty": "SAINT GEORGE",
    "dropphyst": "KS",
    "dropphyzpp": 665359998,
    "dropmaladd": "203 1ST ST",
    "dropmalcty": "SAINT GEORGE",
    "dropmalst": "KS",
    "dropmalzpp": 665359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854942207,
    "dropsitcph": 7854942207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21343",
    "droptype": "D",
    "dropname": "ST JOHN",
    "dropdeladd": "320 N MAIN ST",
    "dropdelcty": "ST JOHN",
    "dropdelst": "KS",
    "dropdelzpp": 675769998,
    "dropphyadd": "320 N MAIN ST",
    "dropphycty": "ST JOHN",
    "dropphyst": "KS",
    "dropphyzpp": 675769998,
    "dropmaladd": "320 N MAIN ST",
    "dropmalcty": "ST JOHN",
    "dropmalst": "KS",
    "dropmalzpp": 675769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205493856,
    "dropsitcph": 6205493856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21345",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "118 S 6TH ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "KS",
    "dropdelzpp": 665369998,
    "dropphyadd": "118 S 6TH ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "KS",
    "dropphyzpp": 665369998,
    "dropmaladd": "118 S 6TH ST",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "KS",
    "dropmalzpp": 665369998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854372462,
    "dropsitcph": 7854372462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21347",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "719 CENTRAL ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "KS",
    "dropdelzpp": 667719998,
    "dropphyadd": "719 CENTRAL ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "KS",
    "dropphyzpp": 667719998,
    "dropmaladd": "719 CENTRAL ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "KS",
    "dropmalzpp": 667719998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204492349,
    "dropsitcph": 6204492349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21350",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "211 E ASH ST",
    "dropdelcty": "SALINA",
    "dropdelst": "KS",
    "dropdelzpp": 674019998,
    "dropphyadd": "211 E ASH ST",
    "dropphycty": "SALINA",
    "dropphyst": "KS",
    "dropphyzpp": 674019998,
    "dropmaladd": "211 E ASH ST",
    "dropmalcty": "SALINA",
    "dropmalst": "KS",
    "dropmalzpp": 674019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858273695,
    "dropsitcph": 7858273695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21356",
    "droptype": "D",
    "dropname": "SATANTA",
    "dropdeladd": "115 SEQUOYAH ST",
    "dropdelcty": "SATANTA",
    "dropdelst": "KS",
    "dropdelzpp": 678709998,
    "dropphyadd": "115 SEQUOYAH ST",
    "dropphycty": "SATANTA",
    "dropphyst": "KS",
    "dropphyzpp": 678709998,
    "dropmaladd": "115 SEQUOYAH ST",
    "dropmalcty": "SATANTA",
    "dropmalst": "KS",
    "dropmalzpp": 678709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206492909,
    "dropsitcph": 6206492909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21359",
    "droptype": "D",
    "dropname": "SAWYER",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "SAWYER",
    "dropdelst": "KS",
    "dropdelzpp": 671349580,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "SAWYER",
    "dropphyst": "KS",
    "dropphyzpp": 671349580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAWYER",
    "dropmalst": "KS",
    "dropmalzpp": 671349998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205942234,
    "dropsitcph": 6205942234,
    "dropfax": 6205942234
  },
  {
    "dcode": "D",
    "dropkey": "PW21361",
    "droptype": "D",
    "dropname": "SCAMMON",
    "dropdeladd": "303 E 3RD ST",
    "dropdelcty": "SCAMMON",
    "dropdelst": "KS",
    "dropdelzpp": 667739998,
    "dropphyadd": "303 E 3RD ST",
    "dropphycty": "SCAMMON",
    "dropphyst": "KS",
    "dropphyzpp": 667739998,
    "dropmaladd": "303 E 3RD ST",
    "dropmalcty": "SCAMMON",
    "dropmalst": "KS",
    "dropmalzpp": 667739998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6204796121,
    "dropsitcph": 6204796121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21362",
    "droptype": "D",
    "dropname": "SCANDIA",
    "dropdeladd": "300 4TH ST",
    "dropdelcty": "SCANDIA",
    "dropdelst": "KS",
    "dropdelzpp": 669669998,
    "dropphyadd": "300 4TH ST",
    "dropphycty": "SCANDIA",
    "dropphyst": "KS",
    "dropphyzpp": 669669998,
    "dropmaladd": "300 4TH ST",
    "dropmalcty": "SCANDIA",
    "dropmalst": "KS",
    "dropmalzpp": 669669998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853352390,
    "dropsitcph": 7853352390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21366",
    "droptype": "D",
    "dropname": "SCOTT CITY",
    "dropdeladd": "211 S MAIN ST",
    "dropdelcty": "SCOTT CITY",
    "dropdelst": "KS",
    "dropdelzpp": 678719998,
    "dropphyadd": "211 S MAIN ST",
    "dropphycty": "SCOTT CITY",
    "dropphyst": "KS",
    "dropphyzpp": 678719998,
    "dropmaladd": "211 S MAIN ST",
    "dropmalcty": "SCOTT CITY",
    "dropmalst": "KS",
    "dropmalzpp": 678719998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208722650,
    "dropsitcph": 6208722650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21368",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "324 S BROWNIE BLVD",
    "dropdelcty": "SCRANTON",
    "dropdelst": "KS",
    "dropdelzpp": 665379998,
    "dropphyadd": "324 S BROWNIE BLVD",
    "dropphycty": "SCRANTON",
    "dropphyst": "KS",
    "dropphyzpp": 665379998,
    "dropmaladd": "324 S BROWNIE BLVD",
    "dropmalcty": "SCRANTON",
    "dropmalst": "KS",
    "dropmalzpp": 665379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857932773,
    "dropsitcph": 7857932773,
    "dropfax": 7857932773
  },
  {
    "dcode": "D",
    "dropkey": "PW21371",
    "droptype": "D",
    "dropname": "SEDAN",
    "dropdeladd": "205 W MAIN ST",
    "dropdelcty": "SEDAN",
    "dropdelst": "KS",
    "dropdelzpp": 673619998,
    "dropphyadd": "205 W MAIN ST",
    "dropphycty": "SEDAN",
    "dropphyst": "KS",
    "dropphyzpp": 673619998,
    "dropmaladd": "205 W MAIN ST",
    "dropmalcty": "SEDAN",
    "dropmalst": "KS",
    "dropmalzpp": 673619998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207253277,
    "dropsitcph": 6207253277,
    "dropfax": 6207253277
  },
  {
    "dcode": "D",
    "dropkey": "PW21372",
    "droptype": "D",
    "dropname": "SEDGWICK",
    "dropdeladd": "415 N COMMERCIAL AVE",
    "dropdelcty": "SEDGWICK",
    "dropdelst": "KS",
    "dropdelzpp": 671359998,
    "dropphyadd": "415 N COMMERCIAL AVE",
    "dropphycty": "SEDGWICK",
    "dropphyst": "KS",
    "dropphyzpp": 671359998,
    "dropmaladd": "415 N COMMERCIAL AVE",
    "dropmalcty": "SEDGWICK",
    "dropmalst": "KS",
    "dropmalzpp": 671359998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167725611,
    "dropsitcph": 3167725611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21375",
    "droptype": "D",
    "dropname": "SELDEN",
    "dropdeladd": "102 S KANSAS AVE",
    "dropdelcty": "SELDEN",
    "dropdelst": "KS",
    "dropdelzpp": 677579998,
    "dropphyadd": "102 S KANSAS AVE",
    "dropphycty": "SELDEN",
    "dropphyst": "KS",
    "dropphyzpp": 677579998,
    "dropmaladd": "102 S KANSAS AVE",
    "dropmalcty": "SELDEN",
    "dropmalst": "KS",
    "dropmalzpp": 677579998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853864512,
    "dropsitcph": 7853864512,
    "dropfax": 7853864512
  },
  {
    "dcode": "D",
    "dropkey": "PW21378",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "607 MAIN ST",
    "dropdelcty": "SENECA",
    "dropdelst": "KS",
    "dropdelzpp": 665389998,
    "dropphyadd": "607 MAIN ST",
    "dropphycty": "SENECA",
    "dropphyst": "KS",
    "dropphyzpp": 665389998,
    "dropmaladd": "607 MAIN ST",
    "dropmalcty": "SENECA",
    "dropmalst": "KS",
    "dropmalzpp": 665389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853362366,
    "dropsitcph": 7853362366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21380",
    "droptype": "D",
    "dropname": "SEVERY",
    "dropdeladd": "115 W MAIN ST",
    "dropdelcty": "SEVERY",
    "dropdelst": "KS",
    "dropdelzpp": 671379998,
    "dropphyadd": "115 W MAIN ST",
    "dropphycty": "SEVERY",
    "dropphyst": "KS",
    "dropphyzpp": 671379998,
    "dropmaladd": "115 W MAIN ST",
    "dropmalcty": "SEVERY",
    "dropmalst": "KS",
    "dropmalzpp": 671379998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207362264,
    "dropsitcph": 6207362264,
    "dropfax": 6207362264
  },
  {
    "dcode": "D",
    "dropkey": "PW21385",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "108 S BROADWAY ST",
    "dropdelcty": "SHARON",
    "dropdelst": "KS",
    "dropdelzpp": 671389501,
    "dropphyadd": "108 S BROADWAY ST",
    "dropphycty": "SHARON",
    "dropphyst": "KS",
    "dropphyzpp": 671389501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARON",
    "dropmalst": "KS",
    "dropmalzpp": 671389998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202945555,
    "dropsitcph": 6202945555,
    "dropfax": 6202945555
  },
  {
    "dcode": "D",
    "dropkey": "PW21387",
    "droptype": "D",
    "dropname": "SHARON SPRINGS",
    "dropdeladd": "304 N MAIN ST",
    "dropdelcty": "SHARON SPRINGS",
    "dropdelst": "KS",
    "dropdelzpp": 677589998,
    "dropphyadd": "304 N MAIN ST",
    "dropphycty": "SHARON SPRINGS",
    "dropphyst": "KS",
    "dropphyzpp": 677589998,
    "dropmaladd": "304 N MAIN ST",
    "dropmalcty": "SHARON SPRINGS",
    "dropmalst": "KS",
    "dropmalzpp": 677589998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858524254,
    "dropsitcph": 7858524254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21390",
    "droptype": "D",
    "dropname": "SHAWNEE MISSION",
    "dropdeladd": "6029 BROADMOOR ST",
    "dropdelcty": "MISSION",
    "dropdelst": "KS",
    "dropdelzpp": 662029995,
    "dropphyadd": "6029 BROADMOOR ST",
    "dropphycty": "MISSION",
    "dropphyst": "KS",
    "dropphyzpp": 662029995,
    "dropmaladd": "6029 BROADMOOR ST",
    "dropmalcty": "MISSION",
    "dropmalst": "KS",
    "dropmalzpp": 662029995,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138315374,
    "dropsitcph": 9138315375,
    "dropfax": 9138315372
  },
  {
    "dcode": "D",
    "dropkey": "PW21401",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "102 BEAUBEIN AVE",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "KS",
    "dropdelzpp": 665399673,
    "dropphyadd": "102 BEAUBEIN AVE",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "KS",
    "dropphyzpp": 665399673,
    "dropmaladd": "102 BEAUBEIN AVE",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "KS",
    "dropmalzpp": 665399673,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855824304,
    "dropsitcph": 7855824304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21404",
    "droptype": "D",
    "dropname": "SIMPSON",
    "dropdeladd": "307 E FRONT ST",
    "dropdelcty": "SIMPSON",
    "dropdelst": "KS",
    "dropdelzpp": 674789998,
    "dropphyadd": "307 E FRONT ST",
    "dropphycty": "SIMPSON",
    "dropphyst": "KS",
    "dropphyzpp": 674789998,
    "dropmaladd": "307 E FRONT ST",
    "dropmalcty": "SIMPSON",
    "dropmalst": "KS",
    "dropmalzpp": 674789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855936873,
    "dropsitcph": 7855936873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21413",
    "droptype": "D",
    "dropname": "SMITH CENTER",
    "dropdeladd": "119 E COURT ST",
    "dropdelcty": "SMITH CENTER",
    "dropdelst": "KS",
    "dropdelzpp": 669679998,
    "dropphyadd": "119 E COURT ST",
    "dropphycty": "SMITH CENTER",
    "dropphyst": "KS",
    "dropphyzpp": 669679998,
    "dropmaladd": "119 E COURT ST",
    "dropmalcty": "SMITH CENTER",
    "dropmalst": "KS",
    "dropmalzpp": 669679998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852823781,
    "dropsitcph": 7852823781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21421",
    "droptype": "D",
    "dropname": "SOLDIER",
    "dropdeladd": "205 1ST ST",
    "dropdelcty": "SOLDIER",
    "dropdelst": "KS",
    "dropdelzpp": 665409998,
    "dropphyadd": "205 1ST ST",
    "dropphycty": "SOLDIER",
    "dropphyst": "KS",
    "dropphyzpp": 665409998,
    "dropmaladd": "205 1ST ST",
    "dropmalcty": "SOLDIER",
    "dropmalst": "KS",
    "dropmalzpp": 665409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858342411,
    "dropsitcph": 7858342411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21425",
    "droptype": "D",
    "dropname": "SOLOMON",
    "dropdeladd": "122 W MAIN ST",
    "dropdelcty": "SOLOMON",
    "dropdelst": "KS",
    "dropdelzpp": 674809998,
    "dropphyadd": "122 W MAIN ST",
    "dropphycty": "SOLOMON",
    "dropphyst": "KS",
    "dropphyzpp": 674809998,
    "dropmaladd": "122 W MAIN ST",
    "dropmalcty": "SOLOMON",
    "dropmalst": "KS",
    "dropmalzpp": 674809998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7856553977,
    "dropsitcph": 7856553977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21430",
    "droptype": "D",
    "dropname": "SOUTH HAVEN",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "SOUTH HAVEN",
    "dropdelst": "KS",
    "dropdelzpp": 671409998,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "SOUTH HAVEN",
    "dropphyst": "KS",
    "dropphyzpp": 671409998,
    "dropmaladd": "114 N MAIN ST",
    "dropmalcty": "SOUTH HAVEN",
    "dropmalst": "KS",
    "dropmalzpp": 671409998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208925551,
    "dropsitcph": 6208925551,
    "dropfax": 6208925551
  },
  {
    "dcode": "D",
    "dropkey": "PW21435",
    "droptype": "D",
    "dropname": "SPEARVILLE",
    "dropdeladd": "312 N MAIN ST",
    "dropdelcty": "SPEARVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 678769500,
    "dropphyadd": "312 N MAIN ST",
    "dropphycty": "SPEARVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 678769500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPEARVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 678769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203852493,
    "dropsitcph": 6203852493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21439",
    "droptype": "D",
    "dropname": "SPIVEY",
    "dropdeladd": "125 W STANLEY ST",
    "dropdelcty": "SPIVEY",
    "dropdelst": "KS",
    "dropdelzpp": 671429136,
    "dropphyadd": "125 W STANLEY ST",
    "dropphycty": "SPIVEY",
    "dropphyst": "KS",
    "dropphyzpp": 671429136,
    "dropmaladd": "125 W STANLEY ST",
    "dropmalcty": "SPIVEY",
    "dropmalst": "KS",
    "dropmalzpp": 671429136,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205323290,
    "dropsitcph": 6205323290,
    "dropfax": 6205323290
  },
  {
    "dcode": "D",
    "dropkey": "PW21442",
    "droptype": "D",
    "dropname": "SPRING HILL",
    "dropdeladd": "201 N RACE ST",
    "dropdelcty": "SPRING HILL",
    "dropdelst": "KS",
    "dropdelzpp": 660839998,
    "dropphyadd": "201 N RACE ST",
    "dropphycty": "SPRING HILL",
    "dropphyst": "KS",
    "dropphyzpp": 660839998,
    "dropmaladd": "201 N RACE ST",
    "dropmalcty": "SPRING HILL",
    "dropmalst": "KS",
    "dropmalzpp": 660839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9135923929,
    "dropsitcph": 9135923929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21554",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "STAFFORD",
    "dropdelst": "KS",
    "dropdelzpp": 675789998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "STAFFORD",
    "dropphyst": "KS",
    "dropphyzpp": 675789998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "STAFFORD",
    "dropmalst": "KS",
    "dropmalzpp": 675789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202345891,
    "dropsitcph": 6202345891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21556",
    "droptype": "D",
    "dropname": "STARK",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "STARK",
    "dropdelst": "KS",
    "dropdelzpp": 667759998,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "STARK",
    "dropphyst": "KS",
    "dropphyzpp": 667759998,
    "dropmaladd": "111 W MAIN ST",
    "dropmalcty": "STARK",
    "dropmalst": "KS",
    "dropmalzpp": 667759998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207543700,
    "dropsitcph": 6207543700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21561",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "116 S BROADWAY AVE",
    "dropdelcty": "STERLING",
    "dropdelst": "KS",
    "dropdelzpp": 675799998,
    "dropphyadd": "116 S BROADWAY AVE",
    "dropphycty": "STERLING",
    "dropphyst": "KS",
    "dropphyzpp": 675799998,
    "dropmaladd": "116 S BROADWAY AVE",
    "dropmalcty": "STERLING",
    "dropmalst": "KS",
    "dropmalzpp": 675799998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202783421,
    "dropsitcph": 6202783421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21563",
    "droptype": "D",
    "dropname": "STILWELL",
    "dropdeladd": "19800 METCALF AVE",
    "dropdelcty": "STILWELL",
    "dropdelst": "KS",
    "dropdelzpp": 660859998,
    "dropphyadd": "19800 METCALF AVE",
    "dropphycty": "STILWELL",
    "dropphyst": "KS",
    "dropphyzpp": 660859998,
    "dropmaladd": "19800 METCALF AVE",
    "dropmalcty": "STILWELL",
    "dropmalst": "KS",
    "dropmalzpp": 660859998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138972663,
    "dropsitcph": 9138972663,
    "dropfax": 6505784265
  },
  {
    "dcode": "D",
    "dropkey": "PW21565",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "124 S WALNUT ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "KS",
    "dropdelzpp": 676699998,
    "dropphyadd": "124 S WALNUT ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "KS",
    "dropphyzpp": 676699998,
    "dropmaladd": "124 S WALNUT ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "KS",
    "dropmalzpp": 676699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854256151,
    "dropsitcph": 7854256151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21572",
    "droptype": "D",
    "dropname": "STRONG CITY",
    "dropdeladd": "309 COTTONWOOD ST",
    "dropdelcty": "STRONG CITY",
    "dropdelst": "KS",
    "dropdelzpp": 668699998,
    "dropphyadd": "309 COTTONWOOD ST",
    "dropphycty": "STRONG CITY",
    "dropphyst": "KS",
    "dropphyzpp": 668699998,
    "dropmaladd": "309 COTTONWOOD ST",
    "dropmalcty": "STRONG CITY",
    "dropmalst": "KS",
    "dropmalzpp": 668699998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202736609,
    "dropsitcph": 6202736609,
    "dropfax": 6202736609
  },
  {
    "dcode": "D",
    "dropkey": "PW21580",
    "droptype": "D",
    "dropname": "SUBLETTE",
    "dropdeladd": "209 S INMAN ST",
    "dropdelcty": "SUBLETTE",
    "dropdelst": "KS",
    "dropdelzpp": 678779998,
    "dropphyadd": "209 S INMAN ST",
    "dropphycty": "SUBLETTE",
    "dropphyst": "KS",
    "dropphyzpp": 678779998,
    "dropmaladd": "209 S INMAN ST",
    "dropmalcty": "SUBLETTE",
    "dropmalst": "KS",
    "dropmalzpp": 678779998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206752382,
    "dropsitcph": 6206752382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21582",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 665419998,
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 665419998,
    "dropmaladd": "320 MAIN ST",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 665419998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852446289,
    "dropsitcph": 7852446289,
    "dropfax": 7852446289
  },
  {
    "dcode": "D",
    "dropkey": "PW21585",
    "droptype": "D",
    "dropname": "SUN CITY",
    "dropdeladd": "102 E WALNUT ST",
    "dropdelcty": "SUN CITY",
    "dropdelst": "KS",
    "dropdelzpp": 671439100,
    "dropphyadd": "102 E WALNUT ST",
    "dropphycty": "SUN CITY",
    "dropphyst": "KS",
    "dropphyzpp": 671439100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUN CITY",
    "dropmalst": "KS",
    "dropmalzpp": 671439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202483355,
    "dropsitcph": 6202483355,
    "dropfax": 6202483355
  },
  {
    "dcode": "D",
    "dropkey": "PW21591",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "102 E MAIN",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "KS",
    "dropdelzpp": 673639500,
    "dropphyadd": "102 E MAIN",
    "dropphycty": "SYCAMORE",
    "dropphyst": "KS",
    "dropphyzpp": 673639500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "KS",
    "dropmalzpp": 673639998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203317004,
    "dropsitcph": 6203317004,
    "dropfax": 6203317004
  },
  {
    "dcode": "D",
    "dropkey": "PW21592",
    "droptype": "D",
    "dropname": "SYLVAN GROVE",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "SYLVAN GROVE",
    "dropdelst": "KS",
    "dropdelzpp": 674818802,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "SYLVAN GROVE",
    "dropphyst": "KS",
    "dropphyzpp": 674818802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYLVAN GROVE",
    "dropmalst": "KS",
    "dropmalzpp": 674819998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7855267183,
    "dropsitcph": 7855267183,
    "dropfax": 7855267183
  },
  {
    "dcode": "D",
    "dropkey": "PW21594",
    "droptype": "D",
    "dropname": "SYLVIA",
    "dropdeladd": "119 S MAIN ST",
    "dropdelcty": "SYLVIA",
    "dropdelst": "KS",
    "dropdelzpp": 675819998,
    "dropphyadd": "119 S MAIN ST",
    "dropphycty": "SYLVIA",
    "dropphyst": "KS",
    "dropphyzpp": 675819998,
    "dropmaladd": "119 S MAIN ST",
    "dropmalcty": "SYLVIA",
    "dropmalst": "KS",
    "dropmalzpp": 675819998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204862425,
    "dropsitcph": 6204862425,
    "dropfax": 6204862425
  },
  {
    "dcode": "D",
    "dropkey": "PW21595",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "200 N GATES ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "KS",
    "dropdelzpp": 678789998,
    "dropphyadd": "200 N GATES ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "KS",
    "dropphyzpp": 678789998,
    "dropmaladd": "200 N GATES ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "KS",
    "dropmalzpp": 678789998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203846912,
    "dropsitcph": 6203846912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21596",
    "droptype": "D",
    "dropname": "TALMAGE",
    "dropdeladd": "2970 MAIN ST",
    "dropdelcty": "TALMAGE",
    "dropdelst": "KS",
    "dropdelzpp": 674829700,
    "dropphyadd": "2970 MAIN ST",
    "dropphycty": "TALMAGE",
    "dropphyst": "KS",
    "dropphyzpp": 674829700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALMAGE",
    "dropmalst": "KS",
    "dropmalzpp": 674829998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853882623,
    "dropsitcph": 7853882623,
    "dropfax": 7853882623
  },
  {
    "dcode": "D",
    "dropkey": "PW21599",
    "droptype": "D",
    "dropname": "TECUMSEH",
    "dropdeladd": "339 SE TECUMSEH RD",
    "dropdelcty": "TECUMSEH",
    "dropdelst": "KS",
    "dropdelzpp": 665429998,
    "dropphyadd": "339 SE TECUMSEH RD",
    "dropphycty": "TECUMSEH",
    "dropphyst": "KS",
    "dropphyzpp": 665429998,
    "dropmaladd": "339 SE TECUMSEH RD",
    "dropmalcty": "TECUMSEH",
    "dropmalst": "KS",
    "dropmalzpp": 665429998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853795001,
    "dropsitcph": 7853795001,
    "dropfax": 7853795001
  },
  {
    "dcode": "D",
    "dropkey": "PW21601",
    "droptype": "D",
    "dropname": "TESCOTT",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "TESCOTT",
    "dropdelst": "KS",
    "dropdelzpp": 674849998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "TESCOTT",
    "dropphyst": "KS",
    "dropphyzpp": 674849998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "TESCOTT",
    "dropmalst": "KS",
    "dropmalzpp": 674849998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852834421,
    "dropsitcph": 7852834421,
    "dropfax": 7852834421
  },
  {
    "dcode": "D",
    "dropkey": "PW21603",
    "droptype": "D",
    "dropname": "THAYER",
    "dropdeladd": "111 W NEOSHO AVE",
    "dropdelcty": "THAYER",
    "dropdelst": "KS",
    "dropdelzpp": 667769998,
    "dropphyadd": "111 W NEOSHO AVE",
    "dropphycty": "THAYER",
    "dropphyst": "KS",
    "dropphyzpp": 667769998,
    "dropmaladd": "111 W NEOSHO AVE",
    "dropmalcty": "THAYER",
    "dropmalst": "KS",
    "dropmalzpp": 667769998,
    "dropsitphn": 8163749109,
    "dropsitlph": 6208395372,
    "dropsitcph": 6208395372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21609",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "506 MAIN ST",
    "dropdelcty": "TIPTON",
    "dropdelst": "KS",
    "dropdelzpp": 674859700,
    "dropphyadd": "506 MAIN ST",
    "dropphycty": "TIPTON",
    "dropphyst": "KS",
    "dropphyzpp": 674859700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIPTON",
    "dropmalst": "KS",
    "dropmalzpp": 674859998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853735825,
    "dropsitcph": 7853735825,
    "dropfax": 7853735825
  },
  {
    "dcode": "D",
    "dropkey": "PW21612",
    "droptype": "D",
    "dropname": "TONGANOXIE",
    "dropdeladd": "1610 E WOODFIELD DR",
    "dropdelcty": "TONGANOXIE",
    "dropdelst": "KS",
    "dropdelzpp": 660869998,
    "dropphyadd": "1610 E WOODFIELD DR",
    "dropphycty": "TONGANOXIE",
    "dropphyst": "KS",
    "dropphyzpp": 660869998,
    "dropmaladd": "1610 E WOODFIELD DR",
    "dropmalcty": "TONGANOXIE",
    "dropmalst": "KS",
    "dropmalzpp": 660869998,
    "dropsitphn": 8163749109,
    "dropsitlph": "",
    "dropsitcph": 9138452230,
    "dropfax": 9138452473
  },
  {
    "dcode": "D",
    "dropkey": "PW21615",
    "droptype": "D",
    "dropname": "TOPEKA",
    "dropdeladd": "424 S KANSAS AVE STE 1",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666039998,
    "dropphyadd": "424 S KANSAS AVE STE 1",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666039998,
    "dropmaladd": "424 S KANSAS AVE STE 1",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666039998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852959139,
    "dropsitcph": 7852959160,
    "dropfax": 7852959112
  },
  {
    "dcode": "D",
    "dropkey": "PW21617",
    "droptype": "D",
    "dropname": "TORONTO",
    "dropdeladd": "110 W MAIN ST",
    "dropdelcty": "TORONTO",
    "dropdelst": "KS",
    "dropdelzpp": 667779998,
    "dropphyadd": "110 W MAIN ST",
    "dropphycty": "TORONTO",
    "dropphyst": "KS",
    "dropphyzpp": 667779998,
    "dropmaladd": "110 W MAIN ST",
    "dropmalcty": "TORONTO",
    "dropmalst": "KS",
    "dropmalzpp": 667779998,
    "dropsitphn": 8163749109,
    "dropsitlph": 6206372937,
    "dropsitcph": 6206372937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21618",
    "droptype": "D",
    "dropname": "TOWANDA",
    "dropdeladd": "550 MAIN ST",
    "dropdelcty": "TOWANDA",
    "dropdelst": "KS",
    "dropdelzpp": 671449998,
    "dropphyadd": "550 MAIN ST",
    "dropphycty": "TOWANDA",
    "dropphyst": "KS",
    "dropphyzpp": 671449998,
    "dropmaladd": "550 MAIN ST",
    "dropmalcty": "TOWANDA",
    "dropmalst": "KS",
    "dropmalzpp": 671449998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165362613,
    "dropsitcph": 3165362613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21625",
    "droptype": "D",
    "dropname": "TRIBUNE",
    "dropdeladd": "123 W GREELEY AVE",
    "dropdelcty": "TRIBUNE",
    "dropdelst": "KS",
    "dropdelzpp": 678799998,
    "dropphyadd": "123 W GREELEY AVE",
    "dropphycty": "TRIBUNE",
    "dropphyst": "KS",
    "dropphyzpp": 678799998,
    "dropmaladd": "123 W GREELEY AVE",
    "dropmalcty": "TRIBUNE",
    "dropmalst": "KS",
    "dropmalzpp": 678799998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202220171,
    "dropsitcph": 6202220144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21627",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "TROY",
    "dropdelst": "KS",
    "dropdelzpp": 660879998,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "TROY",
    "dropphyst": "KS",
    "dropphyzpp": 660879998,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "TROY",
    "dropmalst": "KS",
    "dropmalzpp": 660879998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855762851,
    "dropsitcph": 7855762851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21629",
    "droptype": "D",
    "dropname": "TURON",
    "dropdeladd": "108 N BURNS ST",
    "dropdelcty": "TURON",
    "dropdelst": "KS",
    "dropdelzpp": 675839998,
    "dropphyadd": "108 N BURNS ST",
    "dropphycty": "TURON",
    "dropphyst": "KS",
    "dropphyzpp": 675839998,
    "dropmaladd": "108 N BURNS ST",
    "dropmalcty": "TURON",
    "dropmalst": "KS",
    "dropmalzpp": 675839998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204976442,
    "dropsitcph": 6204976442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21631",
    "droptype": "D",
    "dropname": "TYRO",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "TYRO",
    "dropdelst": "KS",
    "dropdelzpp": 673649500,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "TYRO",
    "dropphyst": "KS",
    "dropphyzpp": 673649500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYRO",
    "dropmalst": "KS",
    "dropmalzpp": 673649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202894677,
    "dropsitcph": 6202894677,
    "dropfax": 6202894677
  },
  {
    "dcode": "D",
    "dropkey": "PW21632",
    "droptype": "D",
    "dropname": "UDALL",
    "dropdeladd": "507 S CLARK ST",
    "dropdelcty": "UDALL",
    "dropdelst": "KS",
    "dropdelzpp": 671469106,
    "dropphyadd": "507 S CLARK ST",
    "dropphycty": "UDALL",
    "dropphyst": "KS",
    "dropphyzpp": 671469106,
    "dropmaladd": "507 S CLARK ST",
    "dropmalcty": "UDALL",
    "dropmalst": "KS",
    "dropmalzpp": 671469106,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207823551,
    "dropsitcph": 6207823551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21633",
    "droptype": "D",
    "dropname": "ULYSSES",
    "dropdeladd": "208 S BAUGHMAN ST",
    "dropdelcty": "ULYSSES",
    "dropdelst": "KS",
    "dropdelzpp": 678809998,
    "dropphyadd": "208 S BAUGHMAN ST",
    "dropphycty": "ULYSSES",
    "dropphyst": "KS",
    "dropphyzpp": 678809998,
    "dropmaladd": "208 S BAUGHMAN ST",
    "dropmalcty": "ULYSSES",
    "dropmalst": "KS",
    "dropmalzpp": 678809998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203561293,
    "dropsitcph": 6203561293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21635",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "106 2ND ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "KS",
    "dropdelzpp": 667799998,
    "dropphyadd": "106 2ND ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "KS",
    "dropphyzpp": 667799998,
    "dropmaladd": "106 2ND ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "KS",
    "dropmalzpp": 667799998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6207564377,
    "dropsitcph": 6207564377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21643",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "142 S OHIO AVE",
    "dropdelcty": "UTICA",
    "dropdelst": "KS",
    "dropdelzpp": 675849998,
    "dropphyadd": "142 S OHIO AVE",
    "dropphycty": "UTICA",
    "dropphyst": "KS",
    "dropphyzpp": 675849998,
    "dropmaladd": "142 S OHIO AVE",
    "dropmalcty": "UTICA",
    "dropmalst": "KS",
    "dropmalzpp": 675849998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853912368,
    "dropsitcph": 7853912368,
    "dropfax": 7853912368
  },
  {
    "dcode": "D",
    "dropkey": "PW21655",
    "droptype": "D",
    "dropname": "VALLEY CENTER",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "VALLEY CENTER",
    "dropdelst": "KS",
    "dropdelzpp": 671479998,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "VALLEY CENTER",
    "dropphyst": "KS",
    "dropphyzpp": 671479998,
    "dropmaladd": "205 E MAIN ST",
    "dropmalcty": "VALLEY CENTER",
    "dropmalst": "KS",
    "dropmalzpp": 671479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167553074,
    "dropsitcph": 3167550838,
    "dropfax": 3167550838
  },
  {
    "dcode": "D",
    "dropkey": "PW21657",
    "droptype": "D",
    "dropname": "VALLEY FALLS",
    "dropdeladd": "405 SYCAMORE ST",
    "dropdelcty": "VALLEY FALLS",
    "dropdelst": "KS",
    "dropdelzpp": 660889998,
    "dropphyadd": "405 SYCAMORE ST",
    "dropphycty": "VALLEY FALLS",
    "dropphyst": "KS",
    "dropphyzpp": 660889998,
    "dropmaladd": "405 SYCAMORE ST",
    "dropmalcty": "VALLEY FALLS",
    "dropmalst": "KS",
    "dropmalzpp": 660889998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7859453238,
    "dropsitcph": 7859453238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21662",
    "droptype": "D",
    "dropname": "VASSAR",
    "dropdeladd": "130 TOPEKA ST",
    "dropdelcty": "VASSAR",
    "dropdelst": "KS",
    "dropdelzpp": 665439998,
    "dropphyadd": "130 TOPEKA ST",
    "dropphycty": "VASSAR",
    "dropphyst": "KS",
    "dropphyzpp": 665439998,
    "dropmaladd": "130 TOPEKA ST",
    "dropmalcty": "VASSAR",
    "dropmalst": "KS",
    "dropmalzpp": 665439998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858283362,
    "dropsitcph": 7858283362,
    "dropfax": 7858283362
  },
  {
    "dcode": "D",
    "dropkey": "PW21667",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "1003 4TH ST",
    "dropdelcty": "VICTORIA",
    "dropdelst": "KS",
    "dropdelzpp": 676717100,
    "dropphyadd": "1003 4TH ST",
    "dropphycty": "VICTORIA",
    "dropphyst": "KS",
    "dropphyzpp": 676717100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VICTORIA",
    "dropmalst": "KS",
    "dropmalzpp": 676719998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857352731,
    "dropsitcph": 7857352731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21672",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "KS",
    "dropdelzpp": 671499998,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "VIOLA",
    "dropphyst": "KS",
    "dropphyzpp": 671499998,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "VIOLA",
    "dropmalst": "KS",
    "dropmalzpp": 671499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6205846522,
    "dropsitcph": 6205846522,
    "dropfax": 6205846522
  },
  {
    "dcode": "D",
    "dropkey": "PW21673",
    "droptype": "D",
    "dropname": "VIRGIL",
    "dropdeladd": "206 S MAIN ST",
    "dropdelcty": "VIRGIL",
    "dropdelst": "KS",
    "dropdelzpp": 668709998,
    "dropphyadd": "206 S MAIN ST",
    "dropphycty": "VIRGIL",
    "dropphyst": "KS",
    "dropphyzpp": 668709998,
    "dropmaladd": "206 S MAIN ST",
    "dropmalcty": "VIRGIL",
    "dropmalst": "KS",
    "dropmalzpp": 668709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6206783460,
    "dropsitcph": 6206783460,
    "dropfax": 6206783460
  },
  {
    "dcode": "D",
    "dropkey": "PW21679",
    "droptype": "D",
    "dropname": "WAKEENEY",
    "dropdeladd": "407 RUSSELL AVE",
    "dropdelcty": "WAKEENEY",
    "dropdelst": "KS",
    "dropdelzpp": 676729998,
    "dropphyadd": "407 RUSSELL AVE",
    "dropphycty": "WAKEENEY",
    "dropphyst": "KS",
    "dropphyzpp": 676729998,
    "dropmaladd": "407 RUSSELL AVE",
    "dropmalcty": "WAKEENEY",
    "dropmalst": "KS",
    "dropmalzpp": 676729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857432571,
    "dropsitcph": 7857432571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21685",
    "droptype": "D",
    "dropname": "WAKARUSA",
    "dropdeladd": "10120 SW JORDAN RD",
    "dropdelcty": "WAKARUSA",
    "dropdelst": "KS",
    "dropdelzpp": 665469998,
    "dropphyadd": "10120 SW JORDAN RD",
    "dropphycty": "WAKARUSA",
    "dropphyst": "KS",
    "dropphyzpp": 665469998,
    "dropmaladd": "10120 SW JORDAN RD",
    "dropmalcty": "WAKARUSA",
    "dropmalst": "KS",
    "dropmalzpp": 665469998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858362498,
    "dropsitcph": 7858362498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21687",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "713 ELM ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 674879998,
    "dropphyadd": "713 ELM ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 674879998,
    "dropmaladd": "713 ELM ST",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 674879998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854615410,
    "dropsitcph": 7854615410,
    "dropfax": 7854615410
  },
  {
    "dcode": "D",
    "dropkey": "PW21689",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "422 MAIN ST",
    "dropdelcty": "WALDO",
    "dropdelst": "KS",
    "dropdelzpp": 676739998,
    "dropphyadd": "422 MAIN ST",
    "dropphycty": "WALDO",
    "dropphyst": "KS",
    "dropphyzpp": 676739998,
    "dropmaladd": "422 MAIN ST",
    "dropmalcty": "WALDO",
    "dropmalst": "KS",
    "dropmalzpp": 676739998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859423253,
    "dropsitcph": 7859423253,
    "dropfax": 7859423253
  },
  {
    "dcode": "D",
    "dropkey": "PW21694",
    "droptype": "D",
    "dropname": "WALNUT",
    "dropdeladd": "119 S MAIN ST",
    "dropdelcty": "WALNUT",
    "dropdelst": "KS",
    "dropdelzpp": 667809998,
    "dropphyadd": "119 S MAIN ST",
    "dropphycty": "WALNUT",
    "dropphyst": "KS",
    "dropphyzpp": 667809998,
    "dropmaladd": "119 S MAIN ST",
    "dropmalcty": "WALNUT",
    "dropmalst": "KS",
    "dropmalzpp": 667809998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203546450,
    "dropsitcph": 6203546450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21695",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "301 S 2ND AVE",
    "dropdelcty": "WALTON",
    "dropdelst": "KS",
    "dropdelzpp": 671519998,
    "dropphyadd": "301 S 2ND AVE",
    "dropphycty": "WALTON",
    "dropphyst": "KS",
    "dropphyzpp": 671519998,
    "dropmaladd": "301 S 2ND AVE",
    "dropmalcty": "WALTON",
    "dropmalst": "KS",
    "dropmalzpp": 671519998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6208373050,
    "dropsitcph": 6208373050,
    "dropfax": 6208373050
  },
  {
    "dcode": "D",
    "dropkey": "PW21696",
    "droptype": "D",
    "dropname": "WAMEGO",
    "dropdeladd": "807 5TH ST",
    "dropdelcty": "WAMEGO",
    "dropdelst": "KS",
    "dropdelzpp": 665479998,
    "dropphyadd": "807 5TH ST",
    "dropphycty": "WAMEGO",
    "dropphyst": "KS",
    "dropphyzpp": 665479998,
    "dropmaladd": "807 5TH ST",
    "dropmalcty": "WAMEGO",
    "dropmalst": "KS",
    "dropmalzpp": 665479998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854567749,
    "dropsitcph": 7854567749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21702",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "100 C ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 669689998,
    "dropphyadd": "100 C ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 669689998,
    "dropmaladd": "100 C ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 669689998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853252111,
    "dropsitcph": 7853252111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21704",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "102 S NEBRASKA ST",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 665489998,
    "dropphyadd": "102 S NEBRASKA ST",
    "dropphycty": "WATERVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 665489998,
    "dropmaladd": "102 S NEBRASKA ST",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 665489998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853632510,
    "dropsitcph": 7853632510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21707",
    "droptype": "D",
    "dropname": "WATHENA",
    "dropdeladd": "304 SAINT JOSEPH ST",
    "dropdelcty": "WATHENA",
    "dropdelst": "KS",
    "dropdelzpp": 660909998,
    "dropphyadd": "304 SAINT JOSEPH ST",
    "dropphycty": "WATHENA",
    "dropphyst": "KS",
    "dropphyzpp": 660909998,
    "dropmaladd": "304 SAINT JOSEPH ST",
    "dropmalcty": "WATHENA",
    "dropmalst": "KS",
    "dropmalzpp": 660909998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7859894623,
    "dropsitcph": 7859894623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21709",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "402 PEARSON AVE",
    "dropdelcty": "WAVERLY",
    "dropdelst": "KS",
    "dropdelzpp": 668719998,
    "dropphyadd": "402 PEARSON AVE",
    "dropphycty": "WAVERLY",
    "dropphyst": "KS",
    "dropphyzpp": 668719998,
    "dropmaladd": "402 PEARSON AVE",
    "dropmalcty": "WAVERLY",
    "dropmalst": "KS",
    "dropmalzpp": 668719998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857332251,
    "dropsitcph": 7857332251,
    "dropfax": 7857332251
  },
  {
    "dcode": "D",
    "dropkey": "PW21712",
    "droptype": "D",
    "dropname": "WEBBER",
    "dropdeladd": "202 LAMM ST",
    "dropdelcty": "WEBBER",
    "dropdelst": "KS",
    "dropdelzpp": 669709702,
    "dropphyadd": "202 LAMM ST",
    "dropphycty": "WEBBER",
    "dropphyst": "KS",
    "dropphyzpp": 669709702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBBER",
    "dropmalst": "KS",
    "dropmalzpp": 669709998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7857534495,
    "dropsitcph": 7857534495,
    "dropfax": 7857534495
  },
  {
    "dcode": "D",
    "dropkey": "PW21715",
    "droptype": "D",
    "dropname": "WEIR",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "WEIR",
    "dropdelst": "KS",
    "dropdelzpp": 667819998,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "WEIR",
    "dropphyst": "KS",
    "dropphyzpp": 667819998,
    "dropmaladd": "201 E MAIN ST",
    "dropmalcty": "WEIR",
    "dropmalst": "KS",
    "dropmalzpp": 667819998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6203968249,
    "dropsitcph": 6203968249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21716",
    "droptype": "D",
    "dropname": "WELDA",
    "dropdeladd": "104 KAUBLE ST",
    "dropdelcty": "WELDA",
    "dropdelst": "KS",
    "dropdelzpp": 660919998,
    "dropphyadd": "104 KAUBLE ST",
    "dropphycty": "WELDA",
    "dropphyst": "KS",
    "dropphyzpp": 660919998,
    "dropmaladd": "104 KAUBLE ST",
    "dropmalcty": "WELDA",
    "dropmalst": "KS",
    "dropmalzpp": 660919998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7854509377,
    "dropsitcph": 7854509377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21717",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "221 W HARVEY AVE OFC",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "KS",
    "dropdelzpp": 671529998,
    "dropphyadd": "221 W HARVEY AVE OFC",
    "dropphycty": "WELLINGTON",
    "dropphyst": "KS",
    "dropphyzpp": 671529998,
    "dropmaladd": "221 W HARVEY AVE OFC",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "KS",
    "dropmalzpp": 671529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6203262891,
    "dropsitcph": 6203262891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21722",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "422 MAIN ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "KS",
    "dropdelzpp": 660929998,
    "dropphyadd": "422 MAIN ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "KS",
    "dropphyzpp": 660929998,
    "dropmaladd": "422 MAIN ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "KS",
    "dropmalzpp": 660929998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7858832456,
    "dropsitcph": 7858832456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21725",
    "droptype": "D",
    "dropname": "WESKAN",
    "dropdeladd": "527 WESKAN AVE",
    "dropdelcty": "WESKAN",
    "dropdelst": "KS",
    "dropdelzpp": 677625000,
    "dropphyadd": "527 WESKAN AVE",
    "dropphycty": "WESKAN",
    "dropphyst": "KS",
    "dropphyzpp": 677625000,
    "dropmaladd": "527 WESKAN AVE",
    "dropmalcty": "WESKAN",
    "dropmalst": "KS",
    "dropmalzpp": 677629998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859435323,
    "dropsitcph": 7859435323,
    "dropfax": 7859435323
  },
  {
    "dcode": "D",
    "dropkey": "PW21727",
    "droptype": "D",
    "dropname": "WEST MINERAL",
    "dropdeladd": "102 JOPLIN ST",
    "dropdelcty": "WEST MINERAL",
    "dropdelst": "KS",
    "dropdelzpp": 667829998,
    "dropphyadd": "102 JOPLIN ST",
    "dropphycty": "WEST MINERAL",
    "dropphyst": "KS",
    "dropphyzpp": 667829998,
    "dropmaladd": "102 JOPLIN ST",
    "dropmalcty": "WEST MINERAL",
    "dropmalst": "KS",
    "dropmalzpp": 667829998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6202231410,
    "dropsitcph": 6208276138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21733",
    "droptype": "D",
    "dropname": "WESTMORELAND",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "WESTMORELAND",
    "dropdelst": "KS",
    "dropdelzpp": 665499998,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "WESTMORELAND",
    "dropphyst": "KS",
    "dropphyzpp": 665499998,
    "dropmaladd": "306 MAIN ST",
    "dropmalcty": "WESTMORELAND",
    "dropmalst": "KS",
    "dropmalzpp": 665499998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7854573533,
    "dropsitcph": 7854573533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21737",
    "droptype": "D",
    "dropname": "WESTPHALIA",
    "dropdeladd": "504 LINCOLN AVE",
    "dropdelcty": "WESTPHALIA",
    "dropdelst": "KS",
    "dropdelzpp": 660939998,
    "dropphyadd": "504 LINCOLN AVE",
    "dropphycty": "WESTPHALIA",
    "dropphyst": "KS",
    "dropphyzpp": 660939998,
    "dropmaladd": "504 LINCOLN AVE",
    "dropmalcty": "WESTPHALIA",
    "dropmalst": "KS",
    "dropmalzpp": 660939998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7854892575,
    "dropsitcph": 7854892575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21741",
    "droptype": "D",
    "dropname": "WETMORE",
    "dropdeladd": "321 2ND ST",
    "dropdelcty": "WETMORE",
    "dropdelst": "KS",
    "dropdelzpp": 665509998,
    "dropphyadd": "321 2ND ST",
    "dropphycty": "WETMORE",
    "dropphyst": "KS",
    "dropphyzpp": 665509998,
    "dropmaladd": "321 2ND ST",
    "dropmalcty": "WETMORE",
    "dropmalst": "KS",
    "dropmalzpp": 665509998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858665475,
    "dropsitcph": 7858665475,
    "dropfax": 7858665475
  },
  {
    "dcode": "D",
    "dropkey": "PW21746",
    "droptype": "D",
    "dropname": "WHITE CITY",
    "dropdeladd": "113 W MACKENZIE ST",
    "dropdelcty": "WHITE CITY",
    "dropdelst": "KS",
    "dropdelzpp": 668729998,
    "dropphyadd": "113 W MACKENZIE ST",
    "dropphycty": "WHITE CITY",
    "dropphyst": "KS",
    "dropphyzpp": 668729998,
    "dropmaladd": "113 W MACKENZIE ST",
    "dropmalcty": "WHITE CITY",
    "dropmalst": "KS",
    "dropmalzpp": 668729998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853492916,
    "dropsitcph": 7853492916,
    "dropfax": 7853492916
  },
  {
    "dcode": "D",
    "dropkey": "PW21747",
    "droptype": "D",
    "dropname": "WHITE CLOUD",
    "dropdeladd": "214 MAIN ST",
    "dropdelcty": "WHITE CLOUD",
    "dropdelst": "KS",
    "dropdelzpp": 660949998,
    "dropphyadd": "214 MAIN ST",
    "dropphycty": "WHITE CLOUD",
    "dropphyst": "KS",
    "dropphyzpp": 660949998,
    "dropmaladd": "214 MAIN ST",
    "dropmalcty": "WHITE CLOUD",
    "dropmalst": "KS",
    "dropmalzpp": 660949998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7855081085,
    "dropsitcph": 7855081085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21752",
    "droptype": "D",
    "dropname": "WHITEWATER",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "WHITEWATER",
    "dropdelst": "KS",
    "dropdelzpp": 671549998,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "WHITEWATER",
    "dropphyst": "KS",
    "dropphyzpp": 671549998,
    "dropmaladd": "117 S MAIN ST",
    "dropmalcty": "WHITEWATER",
    "dropmalst": "KS",
    "dropmalzpp": 671549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3167992301,
    "dropsitcph": 3167992301,
    "dropfax": 3167992301
  },
  {
    "dcode": "D",
    "dropkey": "PW21753",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "230 WHITING ST",
    "dropdelcty": "WHITING",
    "dropdelst": "KS",
    "dropdelzpp": 665529998,
    "dropphyadd": "230 WHITING ST",
    "dropphycty": "WHITING",
    "dropphyst": "KS",
    "dropphyzpp": 665529998,
    "dropmaladd": "230 WHITING ST",
    "dropmalcty": "WHITING",
    "dropmalst": "KS",
    "dropmalzpp": 665529998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858733241,
    "dropsitcph": 7858733241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21759",
    "droptype": "D",
    "dropname": "WICHITA",
    "dropdeladd": "7117 W HARRY ST",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672769998,
    "dropphyadd": "7117 W HARRY ST",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672769998,
    "dropmaladd": "7117 W HARRY ST",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672769998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3169464569,
    "dropsitcph": 3162194361,
    "dropfax": 3169459762
  },
  {
    "dcode": "D",
    "dropkey": "PW21769",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "100 W WILLIAM ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "KS",
    "dropdelzpp": 660959998,
    "dropphyadd": "100 W WILLIAM ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "KS",
    "dropphyzpp": 660959998,
    "dropmaladd": "100 W WILLIAM ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "KS",
    "dropmalzpp": 660959998,
    "dropsitphn": 8165043362,
    "dropsitlph": 7857468808,
    "dropsitcph": 7857468808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21773",
    "droptype": "D",
    "dropname": "WILMORE",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "WILMORE",
    "dropdelst": "KS",
    "dropdelzpp": 671555448,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "WILMORE",
    "dropphyst": "KS",
    "dropphyzpp": 671555448,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "WILMORE",
    "dropmalst": "KS",
    "dropmalzpp": 671555448,
    "dropsitphn": 4023482736,
    "dropsitlph": 6207384380,
    "dropsitcph": 6207384380,
    "dropfax": 6207384380
  },
  {
    "dcode": "D",
    "dropkey": "PW21776",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "2404 AVENUE E",
    "dropdelcty": "WILSON",
    "dropdelst": "KS",
    "dropdelzpp": 674909998,
    "dropphyadd": "2404 AVENUE E",
    "dropphycty": "WILSON",
    "dropphyst": "KS",
    "dropphyzpp": 674909998,
    "dropmaladd": "2404 AVENUE E",
    "dropmalcty": "WILSON",
    "dropmalst": "KS",
    "dropmalzpp": 674909998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853845021,
    "dropsitcph": 7853845021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21778",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "203 3RD ST",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "KS",
    "dropdelzpp": 660979998,
    "dropphyadd": "203 3RD ST",
    "dropphycty": "WINCHESTER",
    "dropphyst": "KS",
    "dropphyzpp": 660979998,
    "dropmaladd": "203 3RD ST",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "KS",
    "dropmalzpp": 660979998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9137744060,
    "dropsitcph": 9137744060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21781",
    "droptype": "D",
    "dropname": "WINDOM",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "WINDOM",
    "dropdelst": "KS",
    "dropdelzpp": 674919362,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "WINDOM",
    "dropphyst": "KS",
    "dropphyzpp": 674919362,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDOM",
    "dropmalst": "KS",
    "dropmalzpp": 674919998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204896638,
    "dropsitcph": 6204896638,
    "dropfax": 6204896638
  },
  {
    "dcode": "D",
    "dropkey": "PW21783",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "218 E 10TH AVE",
    "dropdelcty": "WINFIELD",
    "dropdelst": "KS",
    "dropdelzpp": 671569998,
    "dropphyadd": "218 E 10TH AVE",
    "dropphycty": "WINFIELD",
    "dropphyst": "KS",
    "dropphyzpp": 671569998,
    "dropmaladd": "218 E 10TH AVE",
    "dropmalcty": "WINFIELD",
    "dropmalst": "KS",
    "dropmalzpp": 671569998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202212390,
    "dropsitcph": 6202212390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21786",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "304 BELLVIEW AVE",
    "dropdelcty": "WINONA",
    "dropdelst": "KS",
    "dropdelzpp": 677649998,
    "dropphyadd": "304 BELLVIEW AVE",
    "dropphycty": "WINONA",
    "dropphyst": "KS",
    "dropphyzpp": 677649998,
    "dropmaladd": "304 BELLVIEW AVE",
    "dropmalcty": "WINONA",
    "dropmalst": "KS",
    "dropmalzpp": 677649998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858467703,
    "dropsitcph": 7858467703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21791",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "3 N BROADWAY",
    "dropdelcty": "WOODBINE",
    "dropdelst": "KS",
    "dropdelzpp": 674929998,
    "dropphyadd": "3 N BROADWAY",
    "dropphycty": "WOODBINE",
    "dropphyst": "KS",
    "dropphyzpp": 674929998,
    "dropmaladd": "3 N BROADWAY",
    "dropmalcty": "WOODBINE",
    "dropmalst": "KS",
    "dropmalzpp": 674929998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852573312,
    "dropsitcph": 7852573312,
    "dropfax": 7852573312
  },
  {
    "dcode": "D",
    "dropkey": "PW21794",
    "droptype": "D",
    "dropname": "WOODSTON",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "WOODSTON",
    "dropdelst": "KS",
    "dropdelzpp": 676759998,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "WOODSTON",
    "dropphyst": "KS",
    "dropphyzpp": 676759998,
    "dropmaladd": "508 MAIN ST",
    "dropmalcty": "WOODSTON",
    "dropmalst": "KS",
    "dropmalzpp": 676759998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7859946242,
    "dropsitcph": 7859946242,
    "dropfax": 7859946242
  },
  {
    "dcode": "D",
    "dropkey": "PW21796",
    "droptype": "D",
    "dropname": "WRIGHT",
    "dropdeladd": "10894 MAIN ST",
    "dropdelcty": "WRIGHT",
    "dropdelst": "KS",
    "dropdelzpp": 678829500,
    "dropphyadd": "10894 MAIN ST",
    "dropphycty": "WRIGHT",
    "dropphyst": "KS",
    "dropphyzpp": 678829500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WRIGHT",
    "dropmalst": "KS",
    "dropmalzpp": 678829998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202276609,
    "dropsitcph": 6202276609,
    "dropfax": 6202276609
  },
  {
    "dcode": "D",
    "dropkey": "PW21802",
    "droptype": "D",
    "dropname": "YATES CENTER",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "YATES CENTER",
    "dropdelst": "KS",
    "dropdelzpp": 667839998,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "YATES CENTER",
    "dropphyst": "KS",
    "dropphyzpp": 667839998,
    "dropmaladd": "200 N MAIN ST",
    "dropmalcty": "YATES CENTER",
    "dropmalst": "KS",
    "dropmalzpp": 667839998,
    "dropsitphn": 8165043362,
    "dropsitlph": 6206252491,
    "dropsitcph": 6206252491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21805",
    "droptype": "D",
    "dropname": "YODER",
    "dropdeladd": "9803 S MAIN ST",
    "dropdelcty": "YODER",
    "dropdelst": "KS",
    "dropdelzpp": 675859500,
    "dropphyadd": "9803 S MAIN ST",
    "dropphycty": "YODER",
    "dropphyst": "KS",
    "dropphyzpp": 675859500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YODER",
    "dropmalst": "KS",
    "dropmalzpp": 675859998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6204652383,
    "dropsitcph": 6204652383,
    "dropfax": 6204652383
  },
  {
    "dcode": "D",
    "dropkey": "PW21807",
    "droptype": "D",
    "dropname": "ZENDA",
    "dropdeladd": "210 N MAIN ST",
    "dropdelcty": "ZENDA",
    "dropdelst": "KS",
    "dropdelzpp": 671599998,
    "dropphyadd": "210 N MAIN ST",
    "dropphycty": "ZENDA",
    "dropphyst": "KS",
    "dropphyzpp": 671599998,
    "dropmaladd": "210 N MAIN ST",
    "dropmalcty": "ZENDA",
    "dropmalst": "KS",
    "dropmalzpp": 671599998,
    "dropsitphn": 4023482736,
    "dropsitlph": 6202435041,
    "dropsitcph": 6202435041,
    "dropfax": 6202435041
  },
  {
    "dcode": "D",
    "dropkey": "PW21814",
    "droptype": "D",
    "dropname": "ACHILLE",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "ACHILLE",
    "dropdelst": "OK",
    "dropdelzpp": 747209998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "ACHILLE",
    "dropphyst": "OK",
    "dropphyzpp": 747209998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "ACHILLE",
    "dropmalst": "OK",
    "dropmalzpp": 747209998,
    "dropsitphn": 5802962927,
    "dropsitlph": 5802962927,
    "dropsitcph": 5802833997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21815",
    "droptype": "D",
    "dropname": "ADA",
    "dropdeladd": "131 E 12TH ST",
    "dropdelcty": "ADA",
    "dropdelst": "OK",
    "dropdelzpp": 748209998,
    "dropphyadd": "131 E 12TH ST",
    "dropphycty": "ADA",
    "dropphyst": "OK",
    "dropphyzpp": 748209998,
    "dropmaladd": "131 E 12TH ST",
    "dropmalcty": "ADA",
    "dropmalst": "OK",
    "dropmalzpp": 748209998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803326124,
    "dropsitcph": 5803326118,
    "dropfax": 5803327628
  },
  {
    "dcode": "D",
    "dropkey": "PW21816",
    "droptype": "D",
    "dropname": "ADAIR",
    "dropdeladd": "103 S WILLIAM PENN",
    "dropdelcty": "ADAIR",
    "dropdelst": "OK",
    "dropdelzpp": 743309998,
    "dropphyadd": "103 S WILLIAM PENN",
    "dropphycty": "ADAIR",
    "dropphyst": "OK",
    "dropphyzpp": 743309998,
    "dropmaladd": "103 S WILLIAM PENN",
    "dropmalcty": "ADAIR",
    "dropmalst": "OK",
    "dropmalzpp": 743309998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187852234,
    "dropsitcph": 9187852234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21817",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "OK",
    "dropdelzpp": 739019801,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "ADAMS",
    "dropphyst": "OK",
    "dropphyzpp": 739019801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMS",
    "dropmalst": "OK",
    "dropmalzpp": 739019998,
    "dropsitphn": 5804470046,
    "dropsitlph": 5804470046,
    "dropsitcph": 5804470046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21818",
    "droptype": "D",
    "dropname": "ADDINGTON",
    "dropdeladd": "201 PARKER ST",
    "dropdelcty": "ADDINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 735209998,
    "dropphyadd": "201 PARKER ST",
    "dropphycty": "ADDINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 735209998,
    "dropmaladd": "201 PARKER ST",
    "dropmalcty": "ADDINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 735209998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804392248,
    "dropsitcph": 5804392248,
    "dropfax": 5804392248
  },
  {
    "dcode": "D",
    "dropkey": "PW21819",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "101 SW 1ST ST",
    "dropdelcty": "AFTON",
    "dropdelst": "OK",
    "dropdelzpp": 743319998,
    "dropphyadd": "101 SW 1ST ST",
    "dropphycty": "AFTON",
    "dropphyst": "OK",
    "dropphyzpp": 743319998,
    "dropmaladd": "101 SW 1ST ST",
    "dropmalcty": "AFTON",
    "dropmalst": "OK",
    "dropmalzpp": 743319998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182574042,
    "dropsitcph": 9182574042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21820",
    "droptype": "D",
    "dropname": "AGRA",
    "dropdeladd": "13 S MAIN ST",
    "dropdelcty": "AGRA",
    "dropdelst": "OK",
    "dropdelzpp": 748249998,
    "dropphyadd": "13 S MAIN ST",
    "dropphycty": "AGRA",
    "dropphyst": "OK",
    "dropphyzpp": 748249998,
    "dropmaladd": "13 S MAIN ST",
    "dropmalcty": "AGRA",
    "dropmalst": "OK",
    "dropmalzpp": 748249998,
    "dropsitphn": 4058152724,
    "dropsitlph": 9183752237,
    "dropsitcph": 9183752237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21823",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "109 N WADE ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "OK",
    "dropdelzpp": 747219998,
    "dropphyadd": "109 N WADE ST",
    "dropphycty": "ALBANY",
    "dropphyst": "OK",
    "dropphyzpp": 747219998,
    "dropmaladd": "109 N WADE ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "OK",
    "dropmalzpp": 747219998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5809243189,
    "dropsitcph": 5809243189,
    "dropfax": 5809243189
  },
  {
    "dcode": "D",
    "dropkey": "PW21824",
    "droptype": "D",
    "dropname": "ALBERT",
    "dropdeladd": "22180 STATE HIGHWAY 146",
    "dropdelcty": "ALBERT",
    "dropdelst": "OK",
    "dropdelzpp": 730019998,
    "dropphyadd": "22180 STATE HIGHWAY 146",
    "dropphycty": "ALBERT",
    "dropphyst": "OK",
    "dropphyzpp": 730019998,
    "dropmaladd": "22180 STATE HIGHWAY 146",
    "dropmalcty": "ALBERT",
    "dropmalst": "OK",
    "dropmalzpp": 730019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055536782,
    "dropsitcph": 4056432796,
    "dropfax": 4056472087
  },
  {
    "dcode": "D",
    "dropkey": "PW21825",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "110 S KENTUCKY ST",
    "dropdelcty": "ALBION",
    "dropdelst": "OK",
    "dropdelzpp": 745219998,
    "dropphyadd": "110 S KENTUCKY ST",
    "dropphycty": "ALBION",
    "dropphyst": "OK",
    "dropphyzpp": 745219998,
    "dropmaladd": "110 S KENTUCKY ST",
    "dropmalcty": "ALBION",
    "dropmalst": "OK",
    "dropmalzpp": 745219998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185634421,
    "dropsitcph": 9185634421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21826",
    "droptype": "D",
    "dropname": "ALDERSON",
    "dropdeladd": "49 W HIGHWAY 270",
    "dropdelcty": "ALDERSON",
    "dropdelst": "OK",
    "dropdelzpp": 745229998,
    "dropphyadd": "49 W HIGHWAY 270",
    "dropphycty": "ALDERSON",
    "dropphyst": "OK",
    "dropphyzpp": 745229998,
    "dropmaladd": "49 W HIGHWAY 270",
    "dropmalcty": "ALDERSON",
    "dropmalst": "OK",
    "dropmalzpp": 745229998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184237480,
    "dropsitcph": 9184237480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21827",
    "droptype": "D",
    "dropname": "ALEX",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "ALEX",
    "dropdelst": "OK",
    "dropdelzpp": 730029998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "ALEX",
    "dropphyst": "OK",
    "dropphyzpp": 730029998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "ALEX",
    "dropmalst": "OK",
    "dropmalzpp": 730029998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057852249,
    "dropsitcph": 4057852249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21828",
    "droptype": "D",
    "dropname": "ALINE",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "ALINE",
    "dropdelst": "OK",
    "dropdelzpp": 737169998,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "ALINE",
    "dropphyst": "OK",
    "dropphyzpp": 737169998,
    "dropmaladd": "104 N MAIN ST",
    "dropmalcty": "ALINE",
    "dropmalst": "OK",
    "dropmalzpp": 737169998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804632291,
    "dropsitcph": 5804632291,
    "dropfax": 5804632291
  },
  {
    "dcode": "D",
    "dropkey": "PW21829",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "107 S EASTON",
    "dropdelcty": "ALLEN",
    "dropdelst": "OK",
    "dropdelzpp": 748259998,
    "dropphyadd": "107 S EASTON",
    "dropphycty": "ALLEN",
    "dropphyst": "OK",
    "dropphyzpp": 748259998,
    "dropmaladd": "107 S EASTON",
    "dropmalcty": "ALLEN",
    "dropmalst": "OK",
    "dropmalzpp": 748259998,
    "dropsitphn": 5808572253,
    "dropsitlph": 5808572253,
    "dropsitcph": 5808572253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21830",
    "droptype": "D",
    "dropname": "ALTUS",
    "dropdeladd": "217 W CYPRESS ST",
    "dropdelcty": "ALTUS",
    "dropdelst": "OK",
    "dropdelzpp": 735219998,
    "dropphyadd": "217 W CYPRESS ST",
    "dropphycty": "ALTUS",
    "dropphyst": "OK",
    "dropphyzpp": 735219998,
    "dropmaladd": "217 W CYPRESS ST",
    "dropmalcty": "ALTUS",
    "dropmalst": "OK",
    "dropmalzpp": 735219998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804823339,
    "dropsitcph": 5804823339,
    "dropfax": 5804773967
  },
  {
    "dcode": "D",
    "dropkey": "PW21832",
    "droptype": "D",
    "dropname": "ALVA",
    "dropdeladd": "408 GOVERNMENT ST",
    "dropdelcty": "ALVA",
    "dropdelst": "OK",
    "dropdelzpp": 737179998,
    "dropphyadd": "408 GOVERNMENT ST",
    "dropphycty": "ALVA",
    "dropphyst": "OK",
    "dropphyzpp": 737179998,
    "dropmaladd": "408 GOVERNMENT ST",
    "dropmalcty": "ALVA",
    "dropmalst": "OK",
    "dropmalzpp": 737179998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803272400,
    "dropsitcph": 5803272400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21833",
    "droptype": "D",
    "dropname": "AMBER",
    "dropdeladd": "402 E MAIN ST",
    "dropdelcty": "AMBER",
    "dropdelst": "OK",
    "dropdelzpp": 730049998,
    "dropphyadd": "402 E MAIN ST",
    "dropphycty": "AMBER",
    "dropphyst": "OK",
    "dropphyzpp": 730049998,
    "dropmaladd": "402 E MAIN ST",
    "dropmalcty": "AMBER",
    "dropmalst": "OK",
    "dropmalzpp": 730049998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052221286,
    "dropsitcph": 4052221286,
    "dropfax": 4052221286
  },
  {
    "dcode": "D",
    "dropkey": "PW21834",
    "droptype": "D",
    "dropname": "AMES",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "AMES",
    "dropdelst": "OK",
    "dropdelzpp": 737189998,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "AMES",
    "dropphyst": "OK",
    "dropphyzpp": 737189998,
    "dropmaladd": "108 E MAIN ST",
    "dropmalcty": "AMES",
    "dropmalst": "OK",
    "dropmalzpp": 737189998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807534229,
    "dropsitcph": 5807534229,
    "dropfax": 5807534229
  },
  {
    "dcode": "D",
    "dropkey": "PW21835",
    "droptype": "D",
    "dropname": "AMORITA",
    "dropdeladd": "305 W CHESTNUT",
    "dropdelcty": "AMORITA",
    "dropdelst": "OK",
    "dropdelzpp": 737199998,
    "dropphyadd": "305 W CHESTNUT",
    "dropphycty": "AMORITA",
    "dropphyst": "OK",
    "dropphyzpp": 737199998,
    "dropmaladd": "305 W CHESTNUT",
    "dropmalcty": "AMORITA",
    "dropmalst": "OK",
    "dropmalzpp": 737199998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804742511,
    "dropsitcph": 5804742511,
    "dropfax": 5804742511
  },
  {
    "dcode": "D",
    "dropkey": "PW21836",
    "droptype": "D",
    "dropname": "ANADARKO",
    "dropdeladd": "120 S 1ST ST",
    "dropdelcty": "ANADARKO",
    "dropdelst": "OK",
    "dropdelzpp": 730059998,
    "dropphyadd": "120 S 1ST ST",
    "dropphycty": "ANADARKO",
    "dropphyst": "OK",
    "dropphyzpp": 730059998,
    "dropmaladd": "120 S 1ST ST",
    "dropmalcty": "ANADARKO",
    "dropmalst": "OK",
    "dropmalzpp": 730059998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052476461,
    "dropsitcph": 4052476461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21837",
    "droptype": "D",
    "dropname": "ANTLERS",
    "dropdeladd": "219 N HIGH ST",
    "dropdelcty": "ANTLERS",
    "dropdelst": "OK",
    "dropdelzpp": 745239998,
    "dropphyadd": "219 N HIGH ST",
    "dropphycty": "ANTLERS",
    "dropphyst": "OK",
    "dropphyzpp": 745239998,
    "dropmaladd": "219 N HIGH ST",
    "dropmalcty": "ANTLERS",
    "dropmalst": "OK",
    "dropmalzpp": 745239998,
    "dropsitphn": 5802985238,
    "dropsitlph": 9182982526,
    "dropsitcph": 5802982526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21838",
    "droptype": "D",
    "dropname": "APACHE",
    "dropdeladd": "302 E EVANS AVE",
    "dropdelcty": "APACHE",
    "dropdelst": "OK",
    "dropdelzpp": 730069998,
    "dropphyadd": "302 E EVANS AVE",
    "dropphycty": "APACHE",
    "dropphyst": "OK",
    "dropphyzpp": 730069998,
    "dropmaladd": "302 E EVANS AVE",
    "dropmalcty": "APACHE",
    "dropmalst": "OK",
    "dropmalzpp": 730069998,
    "dropsitphn": 5805883550,
    "dropsitlph": 5805883550,
    "dropsitcph": 5805883550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21839",
    "droptype": "D",
    "dropname": "ARAPAHO",
    "dropdeladd": "668 MAIN ST",
    "dropdelcty": "ARAPAHO",
    "dropdelst": "OK",
    "dropdelzpp": 736209998,
    "dropphyadd": "668 MAIN ST",
    "dropphycty": "ARAPAHO",
    "dropphyst": "OK",
    "dropphyzpp": 736209998,
    "dropmaladd": "668 MAIN ST",
    "dropmalcty": "ARAPAHO",
    "dropmalst": "OK",
    "dropmalzpp": 736209998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803232008,
    "dropsitcph": 5803232008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21840",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "205 N ODOR ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "OK",
    "dropdelzpp": 730079998,
    "dropphyadd": "205 N ODOR ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "OK",
    "dropphyzpp": 730079998,
    "dropmaladd": "205 N ODOR ST",
    "dropmalcty": "ARCADIA",
    "dropmalst": "OK",
    "dropmalzpp": 730079998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053962494,
    "dropsitcph": 4053962494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21842",
    "droptype": "D",
    "dropname": "ARDMORE",
    "dropdeladd": "208 1ST AVE SW",
    "dropdelcty": "ARDMORE",
    "dropdelst": "OK",
    "dropdelzpp": 734019998,
    "dropphyadd": "208 1ST AVE SW",
    "dropphycty": "ARDMORE",
    "dropphyst": "OK",
    "dropphyzpp": 734019998,
    "dropmaladd": "208 1ST AVE SW",
    "dropmalcty": "ARDMORE",
    "dropmalst": "OK",
    "dropmalzpp": 734019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802231583,
    "dropsitcph": 5802231583,
    "dropfax": 5802262830
  },
  {
    "dcode": "D",
    "dropkey": "PW21843",
    "droptype": "D",
    "dropname": "ARKOMA",
    "dropdeladd": "308 SICARD AVE",
    "dropdelcty": "ARKOMA",
    "dropdelst": "OK",
    "dropdelzpp": 749019998,
    "dropphyadd": "308 SICARD AVE",
    "dropphycty": "ARKOMA",
    "dropphyst": "OK",
    "dropphyzpp": 749019998,
    "dropmaladd": "308 SICARD AVE",
    "dropmalcty": "ARKOMA",
    "dropmalst": "OK",
    "dropmalzpp": 749019998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188753843,
    "dropsitcph": 9188753843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21844",
    "droptype": "D",
    "dropname": "ARNETT",
    "dropdeladd": "107 S WASHINGTON ST",
    "dropdelcty": "ARNETT",
    "dropdelst": "OK",
    "dropdelzpp": 738329998,
    "dropphyadd": "107 S WASHINGTON ST",
    "dropphycty": "ARNETT",
    "dropphyst": "OK",
    "dropphyzpp": 738329998,
    "dropmaladd": "107 S WASHINGTON ST",
    "dropmalcty": "ARNETT",
    "dropmalst": "OK",
    "dropmalzpp": 738329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808857433,
    "dropsitcph": 5808857433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21845",
    "droptype": "D",
    "dropname": "ASHER",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "ASHER",
    "dropdelst": "OK",
    "dropdelzpp": 748269998,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "ASHER",
    "dropphyst": "OK",
    "dropphyzpp": 748269998,
    "dropmaladd": "112 W MAIN ST",
    "dropmalcty": "ASHER",
    "dropmalst": "OK",
    "dropmalzpp": 748269998,
    "dropsitphn": 4057842231,
    "dropsitlph": 4057842231,
    "dropsitcph": 4057842231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21846",
    "droptype": "D",
    "dropname": "ATOKA",
    "dropdeladd": "409 E COURT ST",
    "dropdelcty": "ATOKA",
    "dropdelst": "OK",
    "dropdelzpp": 745259998,
    "dropphyadd": "409 E COURT ST",
    "dropphycty": "ATOKA",
    "dropphyst": "OK",
    "dropphyzpp": 745259998,
    "dropmaladd": "409 E COURT ST",
    "dropmalcty": "ATOKA",
    "dropmalst": "OK",
    "dropmalzpp": 745259998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188893589,
    "dropsitcph": 5808893589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21847",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "321 HIGHWAY 1",
    "dropdelcty": "ATWOOD",
    "dropdelst": "OK",
    "dropdelzpp": 748279998,
    "dropphyadd": "321 HIGHWAY 1",
    "dropphycty": "ATWOOD",
    "dropphyst": "OK",
    "dropphyzpp": 748279998,
    "dropmaladd": "321 HIGHWAY 1",
    "dropmalcty": "ATWOOD",
    "dropmalst": "OK",
    "dropmalzpp": 748279998,
    "dropsitphn": 5809862245,
    "dropsitlph": 5809862245,
    "dropsitcph": 5809862245,
    "dropfax": 5809862245
  },
  {
    "dcode": "D",
    "dropkey": "PW21848",
    "droptype": "D",
    "dropname": "AVANT",
    "dropdeladd": "514 E 3RD ST",
    "dropdelcty": "AVANT",
    "dropdelst": "OK",
    "dropdelzpp": 740019998,
    "dropphyadd": "514 E 3RD ST",
    "dropphycty": "AVANT",
    "dropphyst": "OK",
    "dropphyzpp": 740019998,
    "dropmaladd": "514 E 3RD ST",
    "dropmalcty": "AVANT",
    "dropmalst": "OK",
    "dropmalzpp": 740019998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182634895,
    "dropsitcph": 9182634895,
    "dropfax": 9182634895
  },
  {
    "dcode": "D",
    "dropkey": "PW21853",
    "droptype": "D",
    "dropname": "BALKO",
    "dropdeladd": "1 HIGHWAY 83",
    "dropdelcty": "BALKO",
    "dropdelst": "OK",
    "dropdelzpp": 739319500,
    "dropphyadd": "1 HIGHWAY 83",
    "dropphycty": "BALKO",
    "dropphyst": "OK",
    "dropphyzpp": 739319500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALKO",
    "dropmalst": "OK",
    "dropmalzpp": 739319998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5804472853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21854",
    "droptype": "D",
    "dropname": "BARNSDALL",
    "dropdeladd": "520 W MAIN ST",
    "dropdelcty": "BARNSDALL",
    "dropdelst": "OK",
    "dropdelzpp": 740029998,
    "dropphyadd": "520 W MAIN ST",
    "dropphycty": "BARNSDALL",
    "dropphyst": "OK",
    "dropphyzpp": 740029998,
    "dropmaladd": "520 W MAIN ST",
    "dropmalcty": "BARNSDALL",
    "dropmalst": "OK",
    "dropmalzpp": 740029998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188473125,
    "dropsitcph": 9188473125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21855",
    "droptype": "D",
    "dropname": "BARTLESVILLE",
    "dropdeladd": "615 SW JENNINGS AVE",
    "dropdelcty": "BARTLESVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 740039998,
    "dropphyadd": "615 SW JENNINGS AVE",
    "dropphycty": "BARTLESVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 740039998,
    "dropmaladd": "615 SW JENNINGS AVE",
    "dropmalcty": "BARTLESVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 740039998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183367152,
    "dropsitcph": 9183367152,
    "dropfax": 9183365059
  },
  {
    "dcode": "D",
    "dropkey": "PW21856",
    "droptype": "D",
    "dropname": "BATTIEST",
    "dropdeladd": "5502 BATTIEST PICKENS RD",
    "dropdelcty": "BATTIEST",
    "dropdelst": "OK",
    "dropdelzpp": 747229998,
    "dropphyadd": "5502 BATTIEST PICKENS RD",
    "dropphycty": "BATTIEST",
    "dropphyst": "OK",
    "dropphyzpp": 747229998,
    "dropmaladd": "5502 BATTIEST PICKENS RD",
    "dropmalcty": "BATTIEST",
    "dropmalst": "OK",
    "dropmalzpp": 747229998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802415562,
    "dropsitcph": 5802415562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21860",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "16 E 2ND ST",
    "dropdelcty": "BEAVER",
    "dropdelst": "OK",
    "dropdelzpp": 739329804,
    "dropphyadd": "16 E 2ND ST",
    "dropphycty": "BEAVER",
    "dropphyst": "OK",
    "dropphyzpp": 739329804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "OK",
    "dropmalzpp": 739329998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5806253362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21861",
    "droptype": "D",
    "dropname": "BEGGS",
    "dropdeladd": "106 N CHOCTAW ST",
    "dropdelcty": "BEGGS",
    "dropdelst": "OK",
    "dropdelzpp": 744219998,
    "dropphyadd": "106 N CHOCTAW ST",
    "dropphycty": "BEGGS",
    "dropphyst": "OK",
    "dropphyzpp": 744219998,
    "dropmaladd": "106 N CHOCTAW ST",
    "dropmalcty": "BEGGS",
    "dropmalst": "OK",
    "dropmalzpp": 744219998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182488349,
    "dropsitcph": 9182488349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21863",
    "droptype": "D",
    "dropname": "BENNINGTON",
    "dropdeladd": "310 N PERRY ST",
    "dropdelcty": "BENNINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 747239998,
    "dropphyadd": "310 N PERRY ST",
    "dropphycty": "BENNINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 747239998,
    "dropmaladd": "310 N PERRY ST",
    "dropmalcty": "BENNINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 747239998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808472302,
    "dropsitcph": 5808472302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21865",
    "droptype": "D",
    "dropname": "BESSIE",
    "dropdeladd": "709 MAIN ST",
    "dropdelcty": "BESSIE",
    "dropdelst": "OK",
    "dropdelzpp": 736229998,
    "dropphyadd": "709 MAIN ST",
    "dropphycty": "BESSIE",
    "dropphyst": "OK",
    "dropphyzpp": 736229998,
    "dropmaladd": "709 MAIN ST",
    "dropmalcty": "BESSIE",
    "dropmalst": "OK",
    "dropmalzpp": 736229998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803376316,
    "dropsitcph": 5803376316,
    "dropfax": 5803376316
  },
  {
    "dcode": "D",
    "dropkey": "PW21866",
    "droptype": "D",
    "dropname": "BETHANY",
    "dropdeladd": "6612 NW 38TH ST",
    "dropdelcty": "BETHANY",
    "dropdelst": "OK",
    "dropdelzpp": 730089998,
    "dropphyadd": "6612 NW 38TH ST",
    "dropphycty": "BETHANY",
    "dropphyst": "OK",
    "dropphyzpp": 730089998,
    "dropmaladd": "6612 NW 38TH ST",
    "dropmalcty": "BETHANY",
    "dropmalst": "OK",
    "dropmalzpp": 730089998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057898451,
    "dropsitcph": 4054911096,
    "dropfax": 4057899073
  },
  {
    "dcode": "D",
    "dropkey": "PW21867",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "1533 INDIAN HIGHWAY 144",
    "dropdelcty": "BETHEL",
    "dropdelst": "OK",
    "dropdelzpp": 747249998,
    "dropphyadd": "1533 INDIAN HIGHWAY 144",
    "dropphycty": "BETHEL",
    "dropphyst": "OK",
    "dropphyzpp": 747249998,
    "dropmaladd": "1533 INDIAN HIGHWAY 144",
    "dropmalcty": "BETHEL",
    "dropmalst": "OK",
    "dropmalzpp": 747249998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802417846,
    "dropsitcph": 5802417846,
    "dropfax": 5802415700
  },
  {
    "dcode": "D",
    "dropkey": "PW21868",
    "droptype": "D",
    "dropname": "BIG CABIN",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "BIG CABIN",
    "dropdelst": "OK",
    "dropdelzpp": 743329998,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "BIG CABIN",
    "dropphyst": "OK",
    "dropphyzpp": 743329998,
    "dropmaladd": "104 W MAIN ST",
    "dropmalcty": "BIG CABIN",
    "dropmalst": "OK",
    "dropmalzpp": 743329998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187835171,
    "dropsitcph": 9187835171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21869",
    "droptype": "D",
    "dropname": "BILLINGS",
    "dropdeladd": "113 W MAIN ST",
    "dropdelcty": "BILLINGS",
    "dropdelst": "OK",
    "dropdelzpp": 746309998,
    "dropphyadd": "113 W MAIN ST",
    "dropphycty": "BILLINGS",
    "dropphyst": "OK",
    "dropphyzpp": 746309998,
    "dropmaladd": "113 W MAIN ST",
    "dropmalcty": "BILLINGS",
    "dropmalst": "OK",
    "dropmalzpp": 746309998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5807253418,
    "dropsitcph": 5807253418,
    "dropfax": 5807253523
  },
  {
    "dcode": "D",
    "dropkey": "PW21870",
    "droptype": "D",
    "dropname": "BINGER",
    "dropdeladd": "224 W MAIN ST",
    "dropdelcty": "BINGER",
    "dropdelst": "OK",
    "dropdelzpp": 730099998,
    "dropphyadd": "224 W MAIN ST",
    "dropphycty": "BINGER",
    "dropphyst": "OK",
    "dropphyzpp": 730099998,
    "dropmaladd": "224 W MAIN ST",
    "dropmalcty": "BINGER",
    "dropmalst": "OK",
    "dropmalzpp": 730099998,
    "dropsitphn": 4056562562,
    "dropsitlph": 4056562562,
    "dropsitcph": 4056562562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21871",
    "droptype": "D",
    "dropname": "BISON",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "BISON",
    "dropdelst": "OK",
    "dropdelzpp": 737209998,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "BISON",
    "dropphyst": "OK",
    "dropphyzpp": 737209998,
    "dropmaladd": "200 W MAIN ST",
    "dropmalcty": "BISON",
    "dropmalst": "OK",
    "dropmalzpp": 737209998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807583697,
    "dropsitcph": 5807583697,
    "dropfax": 5807583697
  },
  {
    "dcode": "D",
    "dropkey": "PW21872",
    "droptype": "D",
    "dropname": "BIXBY",
    "dropdeladd": "16 S A AVE",
    "dropdelcty": "BIXBY",
    "dropdelst": "OK",
    "dropdelzpp": 740089998,
    "dropphyadd": "16 S A AVE",
    "dropphycty": "BIXBY",
    "dropphyst": "OK",
    "dropphyzpp": 740089998,
    "dropmaladd": "16 S A AVE",
    "dropmalcty": "BIXBY",
    "dropmalst": "OK",
    "dropmalzpp": 740089998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183663652,
    "dropsitcph": 9183663652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21873",
    "droptype": "D",
    "dropname": "BLACKWELL",
    "dropdeladd": "203 W BLACKWELL AVE",
    "dropdelcty": "BLACKWELL",
    "dropdelst": "OK",
    "dropdelzpp": 746319998,
    "dropphyadd": "203 W BLACKWELL AVE",
    "dropphycty": "BLACKWELL",
    "dropphyst": "OK",
    "dropphyzpp": 746319998,
    "dropmaladd": "203 W BLACKWELL AVE",
    "dropmalcty": "BLACKWELL",
    "dropmalst": "OK",
    "dropmalzpp": 746319998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803634646,
    "dropsitcph": 5803634646,
    "dropfax": 5803633952
  },
  {
    "dcode": "D",
    "dropkey": "PW21874",
    "droptype": "D",
    "dropname": "BLAIR",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "BLAIR",
    "dropdelst": "OK",
    "dropdelzpp": 735269998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "BLAIR",
    "dropphyst": "OK",
    "dropphyzpp": 735269998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "BLAIR",
    "dropmalst": "OK",
    "dropmalzpp": 735269998,
    "dropsitphn": 5805632200,
    "dropsitlph": 5805630066,
    "dropsitcph": 5805630066,
    "dropfax": 5805630065
  },
  {
    "dcode": "D",
    "dropkey": "PW21875",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "1200 N COUNCIL AVE",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "OK",
    "dropdelzpp": 730109998,
    "dropphyadd": "1200 N COUNCIL AVE",
    "dropphycty": "BLANCHARD",
    "dropphyst": "OK",
    "dropphyzpp": 730109998,
    "dropmaladd": "1200 N COUNCIL AVE",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "OK",
    "dropmalzpp": 730109998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054853034,
    "dropsitcph": 4054853034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21876",
    "droptype": "D",
    "dropname": "BLANCO",
    "dropdeladd": "8515 STATE HIGHWAY 63",
    "dropdelcty": "BLANCO",
    "dropdelst": "OK",
    "dropdelzpp": 745289998,
    "dropphyadd": "8515 STATE HIGHWAY 63",
    "dropphycty": "BLANCO",
    "dropphyst": "OK",
    "dropphyzpp": 745289998,
    "dropmaladd": "8515 STATE HIGHWAY 63",
    "dropmalcty": "BLANCO",
    "dropmalst": "OK",
    "dropmalzpp": 745289998,
    "dropsitphn": 9182476344,
    "dropsitlph": 9184325931,
    "dropsitcph": 9184325931,
    "dropfax": 9184325931
  },
  {
    "dcode": "D",
    "dropkey": "PW21878",
    "droptype": "D",
    "dropname": "BLUEJACKET",
    "dropdeladd": "255 E MAIN ST",
    "dropdelcty": "BLUEJACKET",
    "dropdelst": "OK",
    "dropdelzpp": 743339998,
    "dropphyadd": "255 E MAIN ST",
    "dropphycty": "BLUEJACKET",
    "dropphyst": "OK",
    "dropphyzpp": 743339998,
    "dropmaladd": "255 E MAIN ST",
    "dropmalcty": "BLUEJACKET",
    "dropmalst": "OK",
    "dropmalzpp": 743339998,
    "dropsitphn": 9187842555,
    "dropsitlph": 9187842555,
    "dropsitcph": 9187842555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21879",
    "droptype": "D",
    "dropname": "BOISE CITY",
    "dropdeladd": "114 N CIMARRON AVE",
    "dropdelcty": "BOISE CITY",
    "dropdelst": "OK",
    "dropdelzpp": 739339815,
    "dropphyadd": "114 N CIMARRON AVE",
    "dropphycty": "BOISE CITY",
    "dropphyst": "OK",
    "dropphyzpp": 739339815,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOISE CITY",
    "dropmalst": "OK",
    "dropmalzpp": 739339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 5805442941,
    "dropsitcph": 5805442941,
    "dropfax": 5805442943
  },
  {
    "dcode": "D",
    "dropkey": "PW21881",
    "droptype": "D",
    "dropname": "BOKCHITO",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "BOKCHITO",
    "dropdelst": "OK",
    "dropdelzpp": 747269998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "BOKCHITO",
    "dropphyst": "OK",
    "dropphyzpp": 747269998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "BOKCHITO",
    "dropmalst": "OK",
    "dropmalzpp": 747269998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802953889,
    "dropsitcph": 5802953889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21882",
    "droptype": "D",
    "dropname": "BOKOSHE",
    "dropdeladd": "100 HIGHWAY 31",
    "dropdelcty": "BOKOSHE",
    "dropdelst": "OK",
    "dropdelzpp": 749309998,
    "dropphyadd": "100 HIGHWAY 31",
    "dropphycty": "BOKOSHE",
    "dropphyst": "OK",
    "dropphyzpp": 749309998,
    "dropmaladd": "100 HIGHWAY 31",
    "dropmalcty": "BOKOSHE",
    "dropmalst": "OK",
    "dropmalzpp": 749309998,
    "dropsitphn": 9189693031,
    "dropsitlph": 9189693031,
    "dropsitcph": 9189693031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21883",
    "droptype": "D",
    "dropname": "BOLEY",
    "dropdeladd": "122 S PECAN ST",
    "dropdelcty": "BOLEY",
    "dropdelst": "OK",
    "dropdelzpp": 748299998,
    "dropphyadd": "122 S PECAN ST",
    "dropphycty": "BOLEY",
    "dropphyst": "OK",
    "dropphyzpp": 748299998,
    "dropmaladd": "122 S PECAN ST",
    "dropmalcty": "BOLEY",
    "dropmalst": "OK",
    "dropmalzpp": 748299998,
    "dropsitphn": 9186673722,
    "dropsitlph": 9186673722,
    "dropsitcph": 9186673722,
    "dropfax": 9186673722
  },
  {
    "dcode": "D",
    "dropkey": "PW21886",
    "droptype": "D",
    "dropname": "BOSWELL",
    "dropdeladd": "515 HUNTER AVE",
    "dropdelcty": "BOSWELL",
    "dropdelst": "OK",
    "dropdelzpp": 747279998,
    "dropphyadd": "515 HUNTER AVE",
    "dropphycty": "BOSWELL",
    "dropphyst": "OK",
    "dropphyzpp": 747279998,
    "dropmaladd": "515 HUNTER AVE",
    "dropmalcty": "BOSWELL",
    "dropmalst": "OK",
    "dropmalzpp": 747279998,
    "dropsitphn": 5805662845,
    "dropsitlph": 5805662845,
    "dropsitcph": 5805662845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21887",
    "droptype": "D",
    "dropname": "BOWLEGS",
    "dropdeladd": "126 S MAIN",
    "dropdelcty": "BOWLEGS",
    "dropdelst": "OK",
    "dropdelzpp": 748309998,
    "dropphyadd": "126 S MAIN",
    "dropphycty": "BOWLEGS",
    "dropphyst": "OK",
    "dropphyzpp": 748309998,
    "dropmaladd": "126 S MAIN",
    "dropmalcty": "BOWLEGS",
    "dropmalst": "OK",
    "dropmalzpp": 748309998,
    "dropsitphn": 4053984638,
    "dropsitlph": 4053984638,
    "dropsitcph": 4053984638,
    "dropfax": 4053984638
  },
  {
    "dcode": "D",
    "dropkey": "PW21889",
    "droptype": "D",
    "dropname": "BOYNTON",
    "dropdeladd": "201 S SEAMAN ST",
    "dropdelcty": "BOYNTON",
    "dropdelst": "OK",
    "dropdelzpp": 744229998,
    "dropphyadd": "201 S SEAMAN ST",
    "dropphycty": "BOYNTON",
    "dropphyst": "OK",
    "dropphyzpp": 744229998,
    "dropmaladd": "201 S SEAMAN ST",
    "dropmalcty": "BOYNTON",
    "dropmalst": "OK",
    "dropmalzpp": 744229998,
    "dropsitphn": 9184727252,
    "dropsitlph": 9184727252,
    "dropsitcph": 9184727252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21890",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "116 S MCKEE ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "OK",
    "dropdelzpp": 730119998,
    "dropphyadd": "116 S MCKEE ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "OK",
    "dropphyzpp": 730119998,
    "dropmaladd": "116 S MCKEE ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "OK",
    "dropmalzpp": 730119998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054627443,
    "dropsitcph": 4054627443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21891",
    "droptype": "D",
    "dropname": "BRAGGS",
    "dropdeladd": "300 N MADISON ST",
    "dropdelcty": "BRAGGS",
    "dropdelst": "OK",
    "dropdelzpp": 744239998,
    "dropphyadd": "300 N MADISON ST",
    "dropphycty": "BRAGGS",
    "dropphyst": "OK",
    "dropphyzpp": 744239998,
    "dropmaladd": "300 N MADISON ST",
    "dropmalcty": "BRAGGS",
    "dropmalst": "OK",
    "dropmalzpp": 744239998,
    "dropsitphn": 9184875561,
    "dropsitlph": 9184875561,
    "dropsitcph": 9184875561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21892",
    "droptype": "D",
    "dropname": "BRAMAN",
    "dropdeladd": "410 BROADWAY AVE",
    "dropdelcty": "BRAMAN",
    "dropdelst": "OK",
    "dropdelzpp": 746329998,
    "dropphyadd": "410 BROADWAY AVE",
    "dropphycty": "BRAMAN",
    "dropphyst": "OK",
    "dropphyzpp": 746329998,
    "dropmaladd": "410 BROADWAY AVE",
    "dropmalcty": "BRAMAN",
    "dropmalst": "OK",
    "dropmalzpp": 746329998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803852156,
    "dropsitcph": 5803852156,
    "dropfax": 5803852156
  },
  {
    "dcode": "D",
    "dropkey": "PW21894",
    "droptype": "D",
    "dropname": "BRISTOW",
    "dropdeladd": "124 W 6TH AVE",
    "dropdelcty": "BRISTOW",
    "dropdelst": "OK",
    "dropdelzpp": 740109998,
    "dropphyadd": "124 W 6TH AVE",
    "dropphycty": "BRISTOW",
    "dropphyst": "OK",
    "dropphyzpp": 740109998,
    "dropmaladd": "124 W 6TH AVE",
    "dropmalcty": "BRISTOW",
    "dropmalst": "OK",
    "dropmalzpp": 740109998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183673440,
    "dropsitcph": 9183673440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21896",
    "droptype": "D",
    "dropname": "BROKEN ARROW",
    "dropdeladd": "1701 S MAIN ST",
    "dropdelcty": "BROKEN ARROW",
    "dropdelst": "OK",
    "dropdelzpp": 740129998,
    "dropphyadd": "1701 S MAIN ST",
    "dropphycty": "BROKEN ARROW",
    "dropphyst": "OK",
    "dropphyzpp": 740129998,
    "dropmaladd": "1701 S MAIN ST",
    "dropmalcty": "BROKEN ARROW",
    "dropmalst": "OK",
    "dropmalzpp": 740129998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182585652,
    "dropsitcph": 9182585652,
    "dropfax": 9182510956
  },
  {
    "dcode": "D",
    "dropkey": "PW21897",
    "droptype": "D",
    "dropname": "BROKEN BOW",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "BROKEN BOW",
    "dropdelst": "OK",
    "dropdelzpp": 747289998,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "BROKEN BOW",
    "dropphyst": "OK",
    "dropphyzpp": 747289998,
    "dropmaladd": "405 MAIN ST",
    "dropmalcty": "BROKEN BOW",
    "dropmalst": "OK",
    "dropmalzpp": 747289998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5805846633,
    "dropsitcph": 5805846633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21898",
    "droptype": "D",
    "dropname": "BROMIDE",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "BROMIDE",
    "dropdelst": "OK",
    "dropdelzpp": 745309998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "BROMIDE",
    "dropphyst": "OK",
    "dropphyzpp": 745309998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "BROMIDE",
    "dropmalst": "OK",
    "dropmalzpp": 745309998,
    "dropsitphn": 5806382400,
    "dropsitlph": 5806382400,
    "dropsitcph": 5806382400,
    "dropfax": 5806382400
  },
  {
    "dcode": "D",
    "dropkey": "PW21901",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "103 E ELM ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "OK",
    "dropdelzpp": 738349998,
    "dropphyadd": "103 E ELM ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "OK",
    "dropphyzpp": 738349998,
    "dropmaladd": "103 E ELM ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "OK",
    "dropmalzpp": 738349998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807352420,
    "dropsitcph": 5807352420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21902",
    "droptype": "D",
    "dropname": "BUNCH",
    "dropdeladd": "3 E MAIN ST",
    "dropdelcty": "BUNCH",
    "dropdelst": "OK",
    "dropdelzpp": 749319998,
    "dropphyadd": "3 E MAIN ST",
    "dropphycty": "BUNCH",
    "dropphyst": "OK",
    "dropphyzpp": 749319998,
    "dropmaladd": "3 E MAIN ST",
    "dropmalcty": "BUNCH",
    "dropmalst": "OK",
    "dropmalzpp": 749319998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187755343,
    "dropsitcph": 9187755343,
    "dropfax": 9187755343
  },
  {
    "dcode": "D",
    "dropkey": "PW21903",
    "droptype": "D",
    "dropname": "BURBANK",
    "dropdeladd": "100 E MCCORKLE AVE",
    "dropdelcty": "BURBANK",
    "dropdelst": "OK",
    "dropdelzpp": 746339998,
    "dropphyadd": "100 E MCCORKLE AVE",
    "dropphycty": "BURBANK",
    "dropphyst": "OK",
    "dropphyzpp": 746339998,
    "dropmaladd": "100 E MCCORKLE AVE",
    "dropmalcty": "BURBANK",
    "dropmalst": "OK",
    "dropmalzpp": 746339998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186485330,
    "dropsitcph": 9186485330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21904",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "513 MAIN ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 737229998,
    "dropphyadd": "513 MAIN ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 737229998,
    "dropmaladd": "513 MAIN ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 737229998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804312515,
    "dropsitcph": 5804312515,
    "dropfax": 5804312515
  },
  {
    "dcode": "D",
    "dropkey": "PW21905",
    "droptype": "D",
    "dropname": "BURNEYVILLE",
    "dropdeladd": "11340 SPARROW RD",
    "dropdelcty": "BURNEYVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 734309998,
    "dropphyadd": "11340 SPARROW RD",
    "dropphycty": "BURNEYVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 734309998,
    "dropmaladd": "11340 SPARROW RD",
    "dropmalcty": "BURNEYVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 734309998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802762780,
    "dropsitcph": 5802762780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21906",
    "droptype": "D",
    "dropname": "BURNS FLAT",
    "dropdeladd": "100 SOONER DR",
    "dropdelcty": "BURNS FLAT",
    "dropdelst": "OK",
    "dropdelzpp": 736249998,
    "dropphyadd": "100 SOONER DR",
    "dropphycty": "BURNS FLAT",
    "dropphyst": "OK",
    "dropphyzpp": 736249998,
    "dropmaladd": "100 SOONER DR",
    "dropmalcty": "BURNS FLAT",
    "dropmalst": "OK",
    "dropmalzpp": 736249998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805623564,
    "dropsitcph": 5805623564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21908",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "103 N OLMSTEAD AVE",
    "dropdelcty": "BUTLER",
    "dropdelst": "OK",
    "dropdelzpp": 736259998,
    "dropphyadd": "103 N OLMSTEAD AVE",
    "dropphycty": "BUTLER",
    "dropphyst": "OK",
    "dropphyzpp": 736259998,
    "dropmaladd": "103 N OLMSTEAD AVE",
    "dropmalcty": "BUTLER",
    "dropmalst": "OK",
    "dropmalzpp": 736259998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806643451,
    "dropsitcph": 5806643451,
    "dropfax": 5806643451
  },
  {
    "dcode": "D",
    "dropkey": "PW21909",
    "droptype": "D",
    "dropname": "BYARS",
    "dropdeladd": "252 E RIPLEY ST",
    "dropdelcty": "BYARS",
    "dropdelst": "OK",
    "dropdelzpp": 748319998,
    "dropphyadd": "252 E RIPLEY ST",
    "dropphycty": "BYARS",
    "dropphyst": "OK",
    "dropphyzpp": 748319998,
    "dropmaladd": "252 E RIPLEY ST",
    "dropmalcty": "BYARS",
    "dropmalst": "OK",
    "dropmalzpp": 748319998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057834427,
    "dropsitcph": 4057834427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21910",
    "droptype": "D",
    "dropname": "CACHE",
    "dropdeladd": "601 S 8TH ST",
    "dropdelcty": "CACHE",
    "dropdelst": "OK",
    "dropdelzpp": 735279998,
    "dropphyadd": "601 S 8TH ST",
    "dropphycty": "CACHE",
    "dropphyst": "OK",
    "dropphyzpp": 735279998,
    "dropmaladd": "601 S 8TH ST",
    "dropmalcty": "CACHE",
    "dropmalst": "OK",
    "dropmalzpp": 735279998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804298100,
    "dropsitcph": 5804298100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21911",
    "droptype": "D",
    "dropname": "CADDO",
    "dropdeladd": "127 W BUFFALO ST",
    "dropdelcty": "CADDO",
    "dropdelst": "OK",
    "dropdelzpp": 747299998,
    "dropphyadd": "127 W BUFFALO ST",
    "dropphycty": "CADDO",
    "dropphyst": "OK",
    "dropphyzpp": 747299998,
    "dropmaladd": "127 W BUFFALO ST",
    "dropmalcty": "CADDO",
    "dropmalst": "OK",
    "dropmalzpp": 747299998,
    "dropsitphn": 5803672240,
    "dropsitlph": 5803672240,
    "dropsitcph": 5803672240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21912",
    "droptype": "D",
    "dropname": "CALERA",
    "dropdeladd": "410 N MCKINLEY AVE",
    "dropdelcty": "CALERA",
    "dropdelst": "OK",
    "dropdelzpp": 747309998,
    "dropphyadd": "410 N MCKINLEY AVE",
    "dropphycty": "CALERA",
    "dropphyst": "OK",
    "dropphyzpp": 747309998,
    "dropmaladd": "410 N MCKINLEY AVE",
    "dropmalcty": "CALERA",
    "dropmalst": "OK",
    "dropmalzpp": 747309998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5804345369,
    "dropsitcph": 5804345369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21913",
    "droptype": "D",
    "dropname": "CALUMET",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "CALUMET",
    "dropdelst": "OK",
    "dropdelzpp": 730149998,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "CALUMET",
    "dropphyst": "OK",
    "dropphyzpp": 730149998,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "CALUMET",
    "dropmalst": "OK",
    "dropmalzpp": 730149998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058932572,
    "dropsitcph": 4058932572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21914",
    "droptype": "D",
    "dropname": "CALVIN",
    "dropdeladd": "205 CANADIAN ST",
    "dropdelcty": "CALVIN",
    "dropdelst": "OK",
    "dropdelzpp": 745319998,
    "dropphyadd": "205 CANADIAN ST",
    "dropphycty": "CALVIN",
    "dropphyst": "OK",
    "dropphyzpp": 745319998,
    "dropmaladd": "205 CANADIAN ST",
    "dropmalcty": "CALVIN",
    "dropmalst": "OK",
    "dropmalzpp": 745319998,
    "dropsitphn": 4956452483,
    "dropsitlph": 4056452483,
    "dropsitcph": 4056452483,
    "dropfax": 4056452483
  },
  {
    "dcode": "D",
    "dropkey": "PW21915",
    "droptype": "D",
    "dropname": "CAMARGO",
    "dropdeladd": "68892 BROADWAY ST",
    "dropdelcty": "CAMARGO",
    "dropdelst": "OK",
    "dropdelzpp": 738359998,
    "dropphyadd": "68892 BROADWAY ST",
    "dropphycty": "CAMARGO",
    "dropphyst": "OK",
    "dropphyzpp": 738359998,
    "dropmaladd": "68892 BROADWAY ST",
    "dropmalcty": "CAMARGO",
    "dropmalst": "OK",
    "dropmalzpp": 738359998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809263360,
    "dropsitcph": 5809263360,
    "dropfax": 5809263360
  },
  {
    "dcode": "D",
    "dropkey": "PW21916",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "15818 CHURCH ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "OK",
    "dropdelzpp": 749329998,
    "dropphyadd": "15818 CHURCH ST",
    "dropphycty": "CAMERON",
    "dropphyst": "OK",
    "dropphyzpp": 749329998,
    "dropmaladd": "15818 CHURCH ST",
    "dropmalcty": "CAMERON",
    "dropmalst": "OK",
    "dropmalzpp": 749329998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186543316,
    "dropsitcph": 9186543316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21918",
    "droptype": "D",
    "dropname": "CANADIAN",
    "dropdeladd": "101 TIGNOR ST",
    "dropdelcty": "CANADIAN",
    "dropdelst": "OK",
    "dropdelzpp": 744259998,
    "dropphyadd": "101 TIGNOR ST",
    "dropphycty": "CANADIAN",
    "dropphyst": "OK",
    "dropphyzpp": 744259998,
    "dropmaladd": "101 TIGNOR ST",
    "dropmalcty": "CANADIAN",
    "dropmalst": "OK",
    "dropmalzpp": 744259998,
    "dropsitphn": 9183392545,
    "dropsitlph": 9183392545,
    "dropsitcph": 9183392545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21919",
    "droptype": "D",
    "dropname": "CANEY",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "CANEY",
    "dropdelst": "OK",
    "dropdelzpp": 745339998,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "CANEY",
    "dropphyst": "OK",
    "dropphyzpp": 745339998,
    "dropmaladd": "200 W MAIN ST",
    "dropmalcty": "CANEY",
    "dropmalst": "OK",
    "dropmalzpp": 745339998,
    "dropsitphn": 5808896097,
    "dropsitlph": 5808896097,
    "dropsitcph": 5808896097,
    "dropfax": 5808896097
  },
  {
    "dcode": "D",
    "dropkey": "PW21920",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "CANTON",
    "dropdelst": "OK",
    "dropdelzpp": 737249998,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "CANTON",
    "dropphyst": "OK",
    "dropphyzpp": 737249998,
    "dropmaladd": "202 W MAIN ST",
    "dropmalcty": "CANTON",
    "dropmalst": "OK",
    "dropmalzpp": 737249998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808862218,
    "dropsitcph": 5808862218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21921",
    "droptype": "D",
    "dropname": "CANUTE",
    "dropdeladd": "919 HIGHWAY 66",
    "dropdelcty": "CANUTE",
    "dropdelst": "OK",
    "dropdelzpp": 736269998,
    "dropphyadd": "919 HIGHWAY 66",
    "dropphycty": "CANUTE",
    "dropphyst": "OK",
    "dropphyzpp": 736269998,
    "dropmaladd": "919 HIGHWAY 66",
    "dropmalcty": "CANUTE",
    "dropmalst": "OK",
    "dropmalzpp": 736269998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804723261,
    "dropsitcph": 5804723261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21925",
    "droptype": "D",
    "dropname": "CARNEGIE",
    "dropdeladd": "14 N BROADWAY ST",
    "dropdelcty": "CARNEGIE",
    "dropdelst": "OK",
    "dropdelzpp": 730159998,
    "dropphyadd": "14 N BROADWAY ST",
    "dropphycty": "CARNEGIE",
    "dropphyst": "OK",
    "dropphyzpp": 730159998,
    "dropmaladd": "14 N BROADWAY ST",
    "dropmalcty": "CARNEGIE",
    "dropmalst": "OK",
    "dropmalzpp": 730159998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806542115,
    "dropsitcph": 5806542115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21926",
    "droptype": "D",
    "dropname": "CARNEY",
    "dropdeladd": "108 E SANTA FE ST",
    "dropdelcty": "CARNEY",
    "dropdelst": "OK",
    "dropdelzpp": 748329998,
    "dropphyadd": "108 E SANTA FE ST",
    "dropphycty": "CARNEY",
    "dropphyst": "OK",
    "dropphyzpp": 748329998,
    "dropmaladd": "108 E SANTA FE ST",
    "dropmalcty": "CARNEY",
    "dropmalst": "OK",
    "dropmalzpp": 748329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058652360,
    "dropsitcph": 4058652360,
    "dropfax": 4058652360
  },
  {
    "dcode": "D",
    "dropkey": "PW21927",
    "droptype": "D",
    "dropname": "CARRIER",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "CARRIER",
    "dropdelst": "OK",
    "dropdelzpp": 737279998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "CARRIER",
    "dropphyst": "OK",
    "dropphyzpp": 737279998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "CARRIER",
    "dropmalst": "OK",
    "dropmalzpp": 737279998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808552520,
    "dropsitcph": 5808552520,
    "dropfax": 5808552520
  },
  {
    "dcode": "D",
    "dropkey": "PW21928",
    "droptype": "D",
    "dropname": "CARTER",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "CARTER",
    "dropdelst": "OK",
    "dropdelzpp": 736279998,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "CARTER",
    "dropphyst": "OK",
    "dropphyzpp": 736279998,
    "dropmaladd": "108 E MAIN ST",
    "dropmalcty": "CARTER",
    "dropmalst": "OK",
    "dropmalzpp": 736279998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804863256,
    "dropsitcph": 5804863256,
    "dropfax": 5804863256
  },
  {
    "dcode": "D",
    "dropkey": "PW21930",
    "droptype": "D",
    "dropname": "CARTWRIGHT",
    "dropdeladd": "52 BOAT CLUB RD",
    "dropdelcty": "CARTWRIGHT",
    "dropdelst": "OK",
    "dropdelzpp": 747319998,
    "dropphyadd": "52 BOAT CLUB RD",
    "dropphycty": "CARTWRIGHT",
    "dropphyst": "OK",
    "dropphyzpp": 747319998,
    "dropmaladd": "52 BOAT CLUB RD",
    "dropmalcty": "CARTWRIGHT",
    "dropmalst": "OK",
    "dropmalzpp": 747319998,
    "dropsitphn": 5802962927,
    "dropsitlph": 5809654444,
    "dropsitcph": 5809654444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21931",
    "droptype": "D",
    "dropname": "CASHION",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "CASHION",
    "dropdelst": "OK",
    "dropdelzpp": 730169998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "CASHION",
    "dropphyst": "OK",
    "dropphyzpp": 730169998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "CASHION",
    "dropmalst": "OK",
    "dropmalzpp": 730169998,
    "dropsitphn": 4054332691,
    "dropsitlph": 4054332691,
    "dropsitcph": 4054332691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21932",
    "droptype": "D",
    "dropname": "CASTLE",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "CASTLE",
    "dropdelst": "OK",
    "dropdelzpp": 748339998,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "CASTLE",
    "dropphyst": "OK",
    "dropphyzpp": 748339998,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "CASTLE",
    "dropmalst": "OK",
    "dropmalzpp": 748339998,
    "dropsitphn": 4058152724,
    "dropsitlph": 9186683332,
    "dropsitcph": 9186683332,
    "dropfax": 9186683332
  },
  {
    "dcode": "D",
    "dropkey": "PW21933",
    "droptype": "D",
    "dropname": "CATOOSA",
    "dropdeladd": "1805 S CHEROKEE ST",
    "dropdelcty": "CATOOSA",
    "dropdelst": "OK",
    "dropdelzpp": 740159998,
    "dropphyadd": "1805 S CHEROKEE ST",
    "dropphycty": "CATOOSA",
    "dropphyst": "OK",
    "dropphyzpp": 740159998,
    "dropmaladd": "1805 S CHEROKEE ST",
    "dropmalcty": "CATOOSA",
    "dropmalst": "OK",
    "dropmalzpp": 740159998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182661920,
    "dropsitcph": 9182661920,
    "dropfax": 9182662589
  },
  {
    "dcode": "D",
    "dropkey": "PW21934",
    "droptype": "D",
    "dropname": "CEMENT",
    "dropdeladd": "406 N MAIN ST",
    "dropdelcty": "CEMENT",
    "dropdelst": "OK",
    "dropdelzpp": 730179998,
    "dropphyadd": "406 N MAIN ST",
    "dropphycty": "CEMENT",
    "dropphyst": "OK",
    "dropphyzpp": 730179998,
    "dropmaladd": "406 N MAIN ST",
    "dropmalcty": "CEMENT",
    "dropmalst": "OK",
    "dropmalzpp": 730179998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054893620,
    "dropsitcph": 4054893620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21939",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "123 W 9TH ST",
    "dropdelcty": "CHANDLER",
    "dropdelst": "OK",
    "dropdelzpp": 748349998,
    "dropphyadd": "123 W 9TH ST",
    "dropphycty": "CHANDLER",
    "dropphyst": "OK",
    "dropphyzpp": 748349998,
    "dropmaladd": "123 W 9TH ST",
    "dropmalcty": "CHANDLER",
    "dropmalst": "OK",
    "dropmalzpp": 748349998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052580187,
    "dropsitcph": 4052580187,
    "dropfax": 4052580188
  },
  {
    "dcode": "D",
    "dropkey": "PW21940",
    "droptype": "D",
    "dropname": "CHATTANOOGA",
    "dropdeladd": "307 MADISON AVE",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "OK",
    "dropdelzpp": 735289998,
    "dropphyadd": "307 MADISON AVE",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "OK",
    "dropphyzpp": 735289998,
    "dropmaladd": "307 MADISON AVE",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "OK",
    "dropmalzpp": 735289998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805972513,
    "dropsitcph": 5805972513,
    "dropfax": 5805972513
  },
  {
    "dcode": "D",
    "dropkey": "PW21941",
    "droptype": "D",
    "dropname": "CHECOTAH",
    "dropdeladd": "213 W SPAULDING ST",
    "dropdelcty": "CHECOTAH",
    "dropdelst": "OK",
    "dropdelzpp": 744269998,
    "dropphyadd": "213 W SPAULDING ST",
    "dropphycty": "CHECOTAH",
    "dropphyst": "OK",
    "dropphyzpp": 744269998,
    "dropmaladd": "213 W SPAULDING ST",
    "dropmalcty": "CHECOTAH",
    "dropmalst": "OK",
    "dropmalzpp": 744269998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184735606,
    "dropsitcph": 9184735606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21942",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "408 W 6TH ST",
    "dropdelcty": "CHELSEA",
    "dropdelst": "OK",
    "dropdelzpp": 740169998,
    "dropphyadd": "408 W 6TH ST",
    "dropphycty": "CHELSEA",
    "dropphyst": "OK",
    "dropphyzpp": 740169998,
    "dropmaladd": "408 W 6TH ST",
    "dropmalcty": "CHELSEA",
    "dropmalst": "OK",
    "dropmalzpp": 740169998,
    "dropsitphn": 9187892653,
    "dropsitlph": 9187892653,
    "dropsitcph": 9187892653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21943",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "1780 S GRAND AVE",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "OK",
    "dropdelzpp": 737289998,
    "dropphyadd": "1780 S GRAND AVE",
    "dropphycty": "CHEROKEE",
    "dropphyst": "OK",
    "dropphyzpp": 737289998,
    "dropmaladd": "1780 S GRAND AVE",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "OK",
    "dropmalzpp": 737289998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805962450,
    "dropsitcph": 5805962450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21945",
    "droptype": "D",
    "dropname": "CHEYENNE",
    "dropdeladd": "207 S LL MALES AVE",
    "dropdelcty": "CHEYENNE",
    "dropdelst": "OK",
    "dropdelzpp": 736289998,
    "dropphyadd": "207 S LL MALES AVE",
    "dropphycty": "CHEYENNE",
    "dropphyst": "OK",
    "dropphyzpp": 736289998,
    "dropmaladd": "207 S LL MALES AVE",
    "dropmalcty": "CHEYENNE",
    "dropmalst": "OK",
    "dropmalzpp": 736289998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804973995,
    "dropsitcph": 5804973995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21946",
    "droptype": "D",
    "dropname": "CHICKASHA",
    "dropdeladd": "702 W KANSAS AVE",
    "dropdelcty": "CHICKASHA",
    "dropdelst": "OK",
    "dropdelzpp": 730189998,
    "dropphyadd": "702 W KANSAS AVE",
    "dropphycty": "CHICKASHA",
    "dropphyst": "OK",
    "dropphyzpp": 730189998,
    "dropmaladd": "702 W KANSAS AVE",
    "dropmalcty": "CHICKASHA",
    "dropmalst": "OK",
    "dropmalzpp": 730189998,
    "dropsitphn": 4052241633,
    "dropsitlph": 4052241633,
    "dropsitcph": 4052241633,
    "dropfax": 4052249576
  },
  {
    "dcode": "D",
    "dropkey": "PW21947",
    "droptype": "D",
    "dropname": "CHOCTAW",
    "dropdeladd": "14500 GRAND AVE",
    "dropdelcty": "CHOCTAW",
    "dropdelst": "OK",
    "dropdelzpp": 730209998,
    "dropphyadd": "14500 GRAND AVE",
    "dropphycty": "CHOCTAW",
    "dropphyst": "OK",
    "dropphyzpp": 730209998,
    "dropmaladd": "14500 GRAND AVE",
    "dropmalcty": "CHOCTAW",
    "dropmalst": "OK",
    "dropmalzpp": 730209998,
    "dropsitphn": 4052817000,
    "dropsitlph": 4053900243,
    "dropsitcph": 4053900243,
    "dropfax": 4053908565
  },
  {
    "dcode": "D",
    "dropkey": "PW21949",
    "droptype": "D",
    "dropname": "CHOUTEAU",
    "dropdeladd": "125 RAILROAD ST",
    "dropdelcty": "CHOUTEAU",
    "dropdelst": "OK",
    "dropdelzpp": 743379998,
    "dropphyadd": "125 RAILROAD ST",
    "dropphycty": "CHOUTEAU",
    "dropphyst": "OK",
    "dropphyzpp": 743379998,
    "dropmaladd": "125 RAILROAD ST",
    "dropmalcty": "CHOUTEAU",
    "dropmalst": "OK",
    "dropmalzpp": 743379998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184768816,
    "dropsitcph": 9184768816,
    "dropfax": 6516751545
  },
  {
    "dcode": "D",
    "dropkey": "PW21950",
    "droptype": "D",
    "dropname": "CLAREMORE",
    "dropdeladd": "400 W 9TH ST",
    "dropdelcty": "CLAREMORE",
    "dropdelst": "OK",
    "dropdelzpp": 740179998,
    "dropphyadd": "400 W 9TH ST",
    "dropphycty": "CLAREMORE",
    "dropphyst": "OK",
    "dropphyzpp": 740179998,
    "dropmaladd": "400 W 9TH ST",
    "dropmalcty": "CLAREMORE",
    "dropmalst": "OK",
    "dropmalzpp": 740179998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183435912,
    "dropsitcph": 9183435912,
    "dropfax": 9183431296
  },
  {
    "dcode": "D",
    "dropkey": "PW21951",
    "droptype": "D",
    "dropname": "CLARITA",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "CLARITA",
    "dropdelst": "OK",
    "dropdelzpp": 745359998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "CLARITA",
    "dropphyst": "OK",
    "dropphyzpp": 745359998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "CLARITA",
    "dropmalst": "OK",
    "dropmalzpp": 745359998,
    "dropsitphn": 5804283303,
    "dropsitlph": 5804283303,
    "dropsitcph": 5804283303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21952",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "121 N LAWSON BLVD",
    "dropdelcty": "CLAYTON",
    "dropdelst": "OK",
    "dropdelzpp": 745369998,
    "dropphyadd": "121 N LAWSON BLVD",
    "dropphycty": "CLAYTON",
    "dropphyst": "OK",
    "dropphyzpp": 745369998,
    "dropmaladd": "121 N LAWSON BLVD",
    "dropmalcty": "CLAYTON",
    "dropmalst": "OK",
    "dropmalzpp": 745369998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183084599,
    "dropsitcph": 9183084599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21954",
    "droptype": "D",
    "dropname": "CLEO SPRINGS",
    "dropdeladd": "123 N SQUARE ST",
    "dropdelcty": "CLEO SPRINGS",
    "dropdelst": "OK",
    "dropdelzpp": 737299998,
    "dropphyadd": "123 N SQUARE ST",
    "dropphycty": "CLEO SPRINGS",
    "dropphyst": "OK",
    "dropphyzpp": 737299998,
    "dropmaladd": "123 N SQUARE ST",
    "dropmalcty": "CLEO SPRINGS",
    "dropmalst": "OK",
    "dropmalzpp": 737299998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804382244,
    "dropsitcph": 5804382244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21956",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "105 W PAWNEE ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OK",
    "dropdelzpp": 740209998,
    "dropphyadd": "105 W PAWNEE ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OK",
    "dropphyzpp": 740209998,
    "dropmaladd": "105 W PAWNEE ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OK",
    "dropmalzpp": 740209998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183582371,
    "dropsitcph": 9183582371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21958",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "212 S 11TH ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "OK",
    "dropdelzpp": 736019998,
    "dropphyadd": "212 S 11TH ST",
    "dropphycty": "CLINTON",
    "dropphyst": "OK",
    "dropphyzpp": 736019998,
    "dropmaladd": "212 S 11TH ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "OK",
    "dropmalzpp": 736019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055536782,
    "dropsitcph": 5803230712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21959",
    "droptype": "D",
    "dropname": "COALGATE",
    "dropdeladd": "38 N MAIN ST",
    "dropdelcty": "COALGATE",
    "dropdelst": "OK",
    "dropdelzpp": 745389998,
    "dropphyadd": "38 N MAIN ST",
    "dropphycty": "COALGATE",
    "dropphyst": "OK",
    "dropphyzpp": 745389998,
    "dropmaladd": "38 N MAIN ST",
    "dropmalcty": "COALGATE",
    "dropmalst": "OK",
    "dropmalzpp": 745389998,
    "dropsitphn": 5809272223,
    "dropsitlph": 5809272223,
    "dropsitcph": 5809272223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21961",
    "droptype": "D",
    "dropname": "COLBERT",
    "dropdeladd": "711 MOORE AVE",
    "dropdelcty": "COLBERT",
    "dropdelst": "OK",
    "dropdelzpp": 747339998,
    "dropphyadd": "711 MOORE AVE",
    "dropphycty": "COLBERT",
    "dropphyst": "OK",
    "dropphyzpp": 747339998,
    "dropmaladd": "711 MOORE AVE",
    "dropmalcty": "COLBERT",
    "dropmalst": "OK",
    "dropmalzpp": 747339998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802635073,
    "dropsitcph": 5802635073,
    "dropfax": 5802635058
  },
  {
    "dcode": "D",
    "dropkey": "PW21962",
    "droptype": "D",
    "dropname": "COLCORD",
    "dropdeladd": "367 W MAIN",
    "dropdelcty": "COLCORD",
    "dropdelst": "OK",
    "dropdelzpp": 743389998,
    "dropphyadd": "367 W MAIN",
    "dropphycty": "COLCORD",
    "dropphyst": "OK",
    "dropphyzpp": 743389998,
    "dropmaladd": "367 W MAIN",
    "dropmalcty": "COLCORD",
    "dropmalst": "OK",
    "dropmalzpp": 743389998,
    "dropsitphn": 9183264636,
    "dropsitlph": 9183264636,
    "dropsitcph": 9183264636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21963",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "12900 OK HIGHWAY 48A E",
    "dropdelcty": "COLEMAN",
    "dropdelst": "OK",
    "dropdelzpp": 734329998,
    "dropphyadd": "12900 OK HIGHWAY 48A E",
    "dropphycty": "COLEMAN",
    "dropphyst": "OK",
    "dropphyzpp": 734329998,
    "dropmaladd": "12900 OK HIGHWAY 48A E",
    "dropmalcty": "COLEMAN",
    "dropmalst": "OK",
    "dropmalzpp": 734329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809374544,
    "dropsitcph": 5809374544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21966",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "118 S 11TH ST",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 740219998,
    "dropphyadd": "118 S 11TH ST",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 740219998,
    "dropmaladd": "118 S 11TH ST",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 740219998,
    "dropsitphn": 9183716528,
    "dropsitlph": 9183716528,
    "dropsitcph": 9183716528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21967",
    "droptype": "D",
    "dropname": "COLONY",
    "dropdeladd": "50 N WATAN AVE",
    "dropdelcty": "COLONY",
    "dropdelst": "OK",
    "dropdelzpp": 730219998,
    "dropphyadd": "50 N WATAN AVE",
    "dropphycty": "COLONY",
    "dropphyst": "OK",
    "dropphyzpp": 730219998,
    "dropmaladd": "50 N WATAN AVE",
    "dropmalcty": "COLONY",
    "dropmalst": "OK",
    "dropmalzpp": 730219998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059297277,
    "dropsitcph": 4059297277,
    "dropfax": 4059297277
  },
  {
    "dcode": "D",
    "dropkey": "PW21968",
    "droptype": "D",
    "dropname": "COMANCHE",
    "dropdeladd": "121 S 2ND ST",
    "dropdelcty": "COMANCHE",
    "dropdelst": "OK",
    "dropdelzpp": 735299998,
    "dropphyadd": "121 S 2ND ST",
    "dropphycty": "COMANCHE",
    "dropphyst": "OK",
    "dropphyzpp": 735299998,
    "dropmaladd": "121 S 2ND ST",
    "dropmalcty": "COMANCHE",
    "dropmalst": "OK",
    "dropmalzpp": 735299998,
    "dropsitphn": 5804398830,
    "dropsitlph": 5804398830,
    "dropsitcph": 5804398830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21969",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "301 COMMERCE ST",
    "dropdelcty": "COMMERCE",
    "dropdelst": "OK",
    "dropdelzpp": 743399998,
    "dropphyadd": "301 COMMERCE ST",
    "dropphycty": "COMMERCE",
    "dropphyst": "OK",
    "dropphyzpp": 743399998,
    "dropmaladd": "301 COMMERCE ST",
    "dropmalcty": "COMMERCE",
    "dropmalst": "OK",
    "dropmalzpp": 743399998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186754617,
    "dropsitcph": 9186754617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21970",
    "droptype": "D",
    "dropname": "CONCHO",
    "dropdeladd": "200 S BLACK KETTLE BLVD",
    "dropdelcty": "CONCHO",
    "dropdelst": "OK",
    "dropdelzpp": 730229998,
    "dropphyadd": "200 S BLACK KETTLE BLVD",
    "dropphycty": "CONCHO",
    "dropphyst": "OK",
    "dropphyzpp": 730229998,
    "dropmaladd": "200 S BLACK KETTLE BLVD",
    "dropmalcty": "CONCHO",
    "dropmalst": "OK",
    "dropmalzpp": 730229998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052622786,
    "dropsitcph": 4052622786,
    "dropfax": 4052622786
  },
  {
    "dcode": "D",
    "dropkey": "PW21971",
    "droptype": "D",
    "dropname": "CONNERVILLE",
    "dropdeladd": "7121 N HIGHWAY 377",
    "dropdelcty": "CONNERVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 748369998,
    "dropphyadd": "7121 N HIGHWAY 377",
    "dropphycty": "CONNERVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 748369998,
    "dropmaladd": "7121 N HIGHWAY 377",
    "dropmalcty": "CONNERVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 748369998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808367911,
    "dropsitcph": 5808367911,
    "dropfax": 5808367911
  },
  {
    "dcode": "D",
    "dropkey": "PW21974",
    "droptype": "D",
    "dropname": "COOKSON",
    "dropdeladd": "32094 HIGHWAY 82",
    "dropdelcty": "COOKSON",
    "dropdelst": "OK",
    "dropdelzpp": 744279998,
    "dropphyadd": "32094 HIGHWAY 82",
    "dropphycty": "COOKSON",
    "dropphyst": "OK",
    "dropphyzpp": 744279998,
    "dropmaladd": "32094 HIGHWAY 82",
    "dropmalcty": "COOKSON",
    "dropmalst": "OK",
    "dropmalzpp": 744279998,
    "dropsitphn": 9184575471,
    "dropsitlph": 9184575471,
    "dropsitcph": 9184575471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21975",
    "droptype": "D",
    "dropname": "COPAN",
    "dropdeladd": "207 S CANEY ST",
    "dropdelcty": "COPAN",
    "dropdelst": "OK",
    "dropdelzpp": 740229998,
    "dropphyadd": "207 S CANEY ST",
    "dropphycty": "COPAN",
    "dropphyst": "OK",
    "dropphyzpp": 740229998,
    "dropmaladd": "207 S CANEY ST",
    "dropmalcty": "COPAN",
    "dropmalst": "OK",
    "dropmalzpp": 740229998,
    "dropsitphn": 9185324385,
    "dropsitlph": 9185324385,
    "dropsitcph": 9185324385,
    "dropfax": 9185324385
  },
  {
    "dcode": "D",
    "dropkey": "PW21976",
    "droptype": "D",
    "dropname": "CORDELL",
    "dropdeladd": "121 E 1ST ST",
    "dropdelcty": "CORDELL",
    "dropdelst": "OK",
    "dropdelzpp": 736329998,
    "dropphyadd": "121 E 1ST ST",
    "dropphycty": "CORDELL",
    "dropphyst": "OK",
    "dropphyzpp": 736329998,
    "dropmaladd": "121 E 1ST ST",
    "dropmalcty": "CORDELL",
    "dropmalst": "OK",
    "dropmalzpp": 736329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808322494,
    "dropsitcph": 5808322494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21977",
    "droptype": "D",
    "dropname": "CORN",
    "dropdeladd": "208 W MAIN",
    "dropdelcty": "CORN",
    "dropdelst": "OK",
    "dropdelzpp": 730249998,
    "dropphyadd": "208 W MAIN",
    "dropphycty": "CORN",
    "dropphyst": "OK",
    "dropphyzpp": 730249998,
    "dropmaladd": "208 W MAIN",
    "dropmalcty": "CORN",
    "dropmalst": "OK",
    "dropmalzpp": 730249998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803432311,
    "dropsitcph": 5803432311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21979",
    "droptype": "D",
    "dropname": "COUNCIL HILL",
    "dropdeladd": "115 S BROADWAY ST",
    "dropdelcty": "COUNCIL HILL",
    "dropdelst": "OK",
    "dropdelzpp": 744289998,
    "dropphyadd": "115 S BROADWAY ST",
    "dropphycty": "COUNCIL HILL",
    "dropphyst": "OK",
    "dropphyzpp": 744289998,
    "dropmaladd": "115 S BROADWAY ST",
    "dropmalcty": "COUNCIL HILL",
    "dropmalst": "OK",
    "dropmalzpp": 744289998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184743282,
    "dropsitcph": 9184743282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21980",
    "droptype": "D",
    "dropname": "COUNTYLINE",
    "dropdeladd": "304900 OLD HIGHWAY 7",
    "dropdelcty": "COUNTYLINE",
    "dropdelst": "OK",
    "dropdelzpp": 734259998,
    "dropphyadd": "304900 OLD HIGHWAY 7",
    "dropphycty": "COUNTYLINE",
    "dropphyst": "OK",
    "dropphyzpp": 734259998,
    "dropmaladd": "304900 OLD HIGHWAY 7",
    "dropmalcty": "COUNTYLINE",
    "dropmalst": "OK",
    "dropmalzpp": 734259998,
    "dropsitphn": 5808563425,
    "dropsitlph": 5808563425,
    "dropsitcph": 5808563425,
    "dropfax": 5808563425
  },
  {
    "dcode": "D",
    "dropkey": "PW21981",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "316 W MAIN ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 737309998,
    "dropphyadd": "316 W MAIN ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 737309998,
    "dropmaladd": "316 W MAIN ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 737309998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808647449,
    "dropsitcph": 5808647449,
    "dropfax": 5808647449
  },
  {
    "dcode": "D",
    "dropkey": "PW21982",
    "droptype": "D",
    "dropname": "COWETA",
    "dropdeladd": "215 W SYCAMORE ST",
    "dropdelcty": "COWETA",
    "dropdelst": "OK",
    "dropdelzpp": 744292026,
    "dropphyadd": "215 W SYCAMORE ST",
    "dropphycty": "COWETA",
    "dropphyst": "OK",
    "dropphyzpp": 744292026,
    "dropmaladd": "215 W SYCAMORE ST",
    "dropmalcty": "COWETA",
    "dropmalst": "OK",
    "dropmalzpp": 744292026,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184865634,
    "dropsitcph": 9184865634,
    "dropfax": 9184866164
  },
  {
    "dcode": "D",
    "dropkey": "PW21983",
    "droptype": "D",
    "dropname": "COYLE",
    "dropdeladd": "208 E MAIN ST",
    "dropdelcty": "COYLE",
    "dropdelst": "OK",
    "dropdelzpp": 730279998,
    "dropphyadd": "208 E MAIN ST",
    "dropphycty": "COYLE",
    "dropphyst": "OK",
    "dropphyzpp": 730279998,
    "dropmaladd": "208 E MAIN ST",
    "dropmalcty": "COYLE",
    "dropmalst": "OK",
    "dropmalzpp": 730279998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054662265,
    "dropsitcph": 4054662265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21985",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "115 N GRAND ST",
    "dropdelcty": "CRESCENT",
    "dropdelst": "OK",
    "dropdelzpp": 730289998,
    "dropphyadd": "115 N GRAND ST",
    "dropphycty": "CRESCENT",
    "dropphyst": "OK",
    "dropphyzpp": 730289998,
    "dropmaladd": "115 N GRAND ST",
    "dropmalcty": "CRESCENT",
    "dropmalst": "OK",
    "dropmalzpp": 730289998,
    "dropsitphn": 4059693314,
    "dropsitlph": 4059693314,
    "dropsitcph": 4059693314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21986",
    "droptype": "D",
    "dropname": "CROMWELL",
    "dropdeladd": "104 N SHAWNEE AVE",
    "dropdelcty": "CROMWELL",
    "dropdelst": "OK",
    "dropdelzpp": 748379998,
    "dropphyadd": "104 N SHAWNEE AVE",
    "dropphycty": "CROMWELL",
    "dropphyst": "OK",
    "dropphyzpp": 748379998,
    "dropmaladd": "104 N SHAWNEE AVE",
    "dropmalcty": "CROMWELL",
    "dropmalst": "OK",
    "dropmalzpp": 748379998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059445505,
    "dropsitcph": 4059445505,
    "dropfax": 4059445505
  },
  {
    "dcode": "D",
    "dropkey": "PW21988",
    "droptype": "D",
    "dropname": "CROWDER",
    "dropdeladd": "100 N B ST",
    "dropdelcty": "CROWDER",
    "dropdelst": "OK",
    "dropdelzpp": 744309998,
    "dropphyadd": "100 N B ST",
    "dropphycty": "CROWDER",
    "dropphyst": "OK",
    "dropphyzpp": 744309998,
    "dropmaladd": "100 N B ST",
    "dropmalcty": "CROWDER",
    "dropmalst": "OK",
    "dropmalzpp": 744309998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183343701,
    "dropsitcph": 9183343701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21989",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "116 S CLEVELAND AVE",
    "dropdelcty": "CUSHING",
    "dropdelst": "OK",
    "dropdelzpp": 740239998,
    "dropphyadd": "116 S CLEVELAND AVE",
    "dropphycty": "CUSHING",
    "dropphyst": "OK",
    "dropphyzpp": 740239998,
    "dropmaladd": "116 S CLEVELAND AVE",
    "dropmalcty": "CUSHING",
    "dropmalst": "OK",
    "dropmalzpp": 740239998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182254665,
    "dropsitcph": 9182254665,
    "dropfax": 4054332691
  },
  {
    "dcode": "D",
    "dropkey": "PW21991",
    "droptype": "D",
    "dropname": "CUSTER CITY",
    "dropdeladd": "630 S MAIN ST",
    "dropdelcty": "CUSTER CITY",
    "dropdelst": "OK",
    "dropdelzpp": 736399998,
    "dropphyadd": "630 S MAIN ST",
    "dropphycty": "CUSTER CITY",
    "dropphyst": "OK",
    "dropphyzpp": 736399998,
    "dropmaladd": "630 S MAIN ST",
    "dropmalcty": "CUSTER CITY",
    "dropmalst": "OK",
    "dropmalzpp": 736399998,
    "dropsitphn": 5805932915,
    "dropsitlph": 5805932915,
    "dropsitcph": 5805932915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21992",
    "droptype": "D",
    "dropname": "CYRIL",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "CYRIL",
    "dropdelst": "OK",
    "dropdelzpp": 730299998,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "CYRIL",
    "dropphyst": "OK",
    "dropphyzpp": 730299998,
    "dropmaladd": "112 W MAIN ST",
    "dropmalcty": "CYRIL",
    "dropmalst": "OK",
    "dropmalzpp": 730299998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804642288,
    "dropsitcph": 5804642288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW21993",
    "droptype": "D",
    "dropname": "DACOMA",
    "dropdeladd": "1023 MAIN ST",
    "dropdelcty": "DACOMA",
    "dropdelst": "OK",
    "dropdelzpp": 737319998,
    "dropphyadd": "1023 MAIN ST",
    "dropphycty": "DACOMA",
    "dropphyst": "OK",
    "dropphyzpp": 737319998,
    "dropmaladd": "1023 MAIN ST",
    "dropmalcty": "DACOMA",
    "dropmalst": "OK",
    "dropmalzpp": 737319998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808712291,
    "dropsitcph": 5808712291,
    "dropfax": 5808712291
  },
  {
    "dcode": "D",
    "dropkey": "PW21994",
    "droptype": "D",
    "dropname": "DAISY",
    "dropdeladd": "2401 E HIGHWAY 43",
    "dropdelcty": "DAISY",
    "dropdelst": "OK",
    "dropdelzpp": 745409998,
    "dropphyadd": "2401 E HIGHWAY 43",
    "dropphycty": "DAISY",
    "dropphyst": "OK",
    "dropphyzpp": 745409998,
    "dropmaladd": "2401 E HIGHWAY 43",
    "dropmalcty": "DAISY",
    "dropmalst": "OK",
    "dropmalzpp": 745409998,
    "dropsitphn": 5803467602,
    "dropsitlph": 5803467602,
    "dropsitcph": 5803467602,
    "dropfax": 5803467602
  },
  {
    "dcode": "D",
    "dropkey": "PW21996",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "313 BROADWAY ST",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "OK",
    "dropdelzpp": 740269998,
    "dropphyadd": "313 BROADWAY ST",
    "dropphycty": "DAVENPORT",
    "dropphyst": "OK",
    "dropphyzpp": 740269998,
    "dropmaladd": "313 BROADWAY ST",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "OK",
    "dropmalzpp": 740269998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183772301,
    "dropsitcph": 9183772301,
    "dropfax": 9183772301
  },
  {
    "dcode": "D",
    "dropkey": "PW21997",
    "droptype": "D",
    "dropname": "DAVIDSON",
    "dropdeladd": "110 W GRAND ST",
    "dropdelcty": "DAVIDSON",
    "dropdelst": "OK",
    "dropdelzpp": 735309998,
    "dropphyadd": "110 W GRAND ST",
    "dropphycty": "DAVIDSON",
    "dropphyst": "OK",
    "dropphyzpp": 735309998,
    "dropmaladd": "110 W GRAND ST",
    "dropmalcty": "DAVIDSON",
    "dropmalst": "OK",
    "dropmalzpp": 735309998,
    "dropsitphn": 5805682276,
    "dropsitlph": 5805682276,
    "dropsitcph": 5805682276,
    "dropfax": 5805682276
  },
  {
    "dcode": "D",
    "dropkey": "PW21998",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "900 E MAIN ST",
    "dropdelcty": "DAVIS",
    "dropdelst": "OK",
    "dropdelzpp": 730309998,
    "dropphyadd": "900 E MAIN ST",
    "dropphycty": "DAVIS",
    "dropphyst": "OK",
    "dropphyzpp": 730309998,
    "dropmaladd": "900 E MAIN ST",
    "dropmalcty": "DAVIS",
    "dropmalst": "OK",
    "dropmalzpp": 730309998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803692514,
    "dropsitcph": 5803692514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22001",
    "droptype": "D",
    "dropname": "DELAWARE",
    "dropdeladd": "117 ELEVATOR",
    "dropdelcty": "DELAWARE",
    "dropdelst": "OK",
    "dropdelzpp": 740279998,
    "dropphyadd": "117 ELEVATOR",
    "dropphycty": "DELAWARE",
    "dropphyst": "OK",
    "dropphyzpp": 740279998,
    "dropmaladd": "117 ELEVATOR",
    "dropmalcty": "DELAWARE",
    "dropmalst": "OK",
    "dropmalzpp": 740279998,
    "dropsitphn": 9184673231,
    "dropsitlph": 9184673231,
    "dropsitcph": 9184673231,
    "dropfax": 9184673231
  },
  {
    "dcode": "D",
    "dropkey": "PW22002",
    "droptype": "D",
    "dropname": "DEPEW",
    "dropdeladd": "316 W MAIN ST",
    "dropdelcty": "DEPEW",
    "dropdelst": "OK",
    "dropdelzpp": 740289998,
    "dropphyadd": "316 W MAIN ST",
    "dropphycty": "DEPEW",
    "dropphyst": "OK",
    "dropphyzpp": 740289998,
    "dropmaladd": "316 W MAIN ST",
    "dropmalcty": "DEPEW",
    "dropmalst": "OK",
    "dropmalzpp": 740289998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183245712,
    "dropsitcph": 9183245712,
    "dropfax": 9183245712
  },
  {
    "dcode": "D",
    "dropkey": "PW22004",
    "droptype": "D",
    "dropname": "DEVOL",
    "dropdeladd": "110 W MULBERRY ST",
    "dropdelcty": "DEVOL",
    "dropdelst": "OK",
    "dropdelzpp": 735319998,
    "dropphyadd": "110 W MULBERRY ST",
    "dropphycty": "DEVOL",
    "dropphyst": "OK",
    "dropphyzpp": 735319998,
    "dropmaladd": "110 W MULBERRY ST",
    "dropmalcty": "DEVOL",
    "dropmalst": "OK",
    "dropmalzpp": 735319998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802993234,
    "dropsitcph": 5802993234,
    "dropfax": 5802993234
  },
  {
    "dcode": "D",
    "dropkey": "PW22005",
    "droptype": "D",
    "dropname": "DEWAR",
    "dropdeladd": "104 N BROADWAY",
    "dropdelcty": "DEWAR",
    "dropdelst": "OK",
    "dropdelzpp": 744319998,
    "dropphyadd": "104 N BROADWAY",
    "dropphycty": "DEWAR",
    "dropphyst": "OK",
    "dropphyzpp": 744319998,
    "dropmaladd": "104 N BROADWAY",
    "dropmalcty": "DEWAR",
    "dropmalst": "OK",
    "dropmalzpp": 744319998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186528655,
    "dropsitcph": 9186528655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22006",
    "droptype": "D",
    "dropname": "DEWEY",
    "dropdeladd": "800 N SHAWNEE AVE",
    "dropdelcty": "DEWEY",
    "dropdelst": "OK",
    "dropdelzpp": 740299998,
    "dropphyadd": "800 N SHAWNEE AVE",
    "dropphycty": "DEWEY",
    "dropphyst": "OK",
    "dropphyzpp": 740299998,
    "dropmaladd": "800 N SHAWNEE AVE",
    "dropmalcty": "DEWEY",
    "dropmalst": "OK",
    "dropmalzpp": 740299998,
    "dropsitphn": 9185342101,
    "dropsitlph": 9185342101,
    "dropsitcph": 9185342101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22007",
    "droptype": "D",
    "dropname": "DIBBLE",
    "dropdeladd": "12252 STATE HIGHWAY 39",
    "dropdelcty": "DIBBLE",
    "dropdelst": "OK",
    "dropdelzpp": 730319998,
    "dropphyadd": "12252 STATE HIGHWAY 39",
    "dropphycty": "DIBBLE",
    "dropphyst": "OK",
    "dropphyzpp": 730319998,
    "dropmaladd": "12252 STATE HIGHWAY 39",
    "dropmalcty": "DIBBLE",
    "dropmalst": "OK",
    "dropmalzpp": 730319998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053446985,
    "dropsitcph": 4053446985,
    "dropfax": 4053446985
  },
  {
    "dcode": "D",
    "dropkey": "PW22008",
    "droptype": "D",
    "dropname": "DILL CITY",
    "dropdeladd": "606 S MCDONALD ST",
    "dropdelcty": "DILL CITY",
    "dropdelst": "OK",
    "dropdelzpp": 736419998,
    "dropphyadd": "606 S MCDONALD ST",
    "dropphycty": "DILL CITY",
    "dropphyst": "OK",
    "dropphyzpp": 736419998,
    "dropmaladd": "606 S MCDONALD ST",
    "dropmalcty": "DILL CITY",
    "dropmalst": "OK",
    "dropmalzpp": 736419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806743313,
    "dropsitcph": 5806743313,
    "dropfax": 5806743136
  },
  {
    "dcode": "D",
    "dropkey": "PW22009",
    "droptype": "D",
    "dropname": "DISNEY",
    "dropdeladd": "303 E MAIN ST",
    "dropdelcty": "DISNEY",
    "dropdelst": "OK",
    "dropdelzpp": 743409998,
    "dropphyadd": "303 E MAIN ST",
    "dropphycty": "DISNEY",
    "dropphyst": "OK",
    "dropphyzpp": 743409998,
    "dropmaladd": "303 E MAIN ST",
    "dropmalcty": "DISNEY",
    "dropmalst": "OK",
    "dropmalzpp": 743409998,
    "dropsitphn": 9184354247,
    "dropsitlph": 9184354247,
    "dropsitcph": 9184354247,
    "dropfax": 9184354247
  },
  {
    "dcode": "D",
    "dropkey": "PW22012",
    "droptype": "D",
    "dropname": "DOUGHERTY",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "DOUGHERTY",
    "dropdelst": "OK",
    "dropdelzpp": 730329998,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "DOUGHERTY",
    "dropphyst": "OK",
    "dropphyzpp": 730329998,
    "dropmaladd": "100 E MAIN ST",
    "dropmalcty": "DOUGHERTY",
    "dropmalst": "OK",
    "dropmalzpp": 730329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809932040,
    "dropsitcph": 5809932040,
    "dropfax": 5809932040
  },
  {
    "dcode": "D",
    "dropkey": "PW22014",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "120 N CHISHOLM TRL",
    "dropdelcty": "DOVER",
    "dropdelst": "OK",
    "dropdelzpp": 737349998,
    "dropphyadd": "120 N CHISHOLM TRL",
    "dropphycty": "DOVER",
    "dropphyst": "OK",
    "dropphyzpp": 737349998,
    "dropmaladd": "120 N CHISHOLM TRL",
    "dropmalcty": "DOVER",
    "dropmalst": "OK",
    "dropmalzpp": 737349998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058284636,
    "dropsitcph": 4058284636,
    "dropfax": 4058284636
  },
  {
    "dcode": "D",
    "dropkey": "PW22015",
    "droptype": "D",
    "dropname": "DRUMMOND",
    "dropdeladd": "319 N MAIN ST",
    "dropdelcty": "DRUMMOND",
    "dropdelst": "OK",
    "dropdelzpp": 737359998,
    "dropphyadd": "319 N MAIN ST",
    "dropphycty": "DRUMMOND",
    "dropphyst": "OK",
    "dropphyzpp": 737359998,
    "dropmaladd": "319 N MAIN ST",
    "dropmalcty": "DRUMMOND",
    "dropmalst": "OK",
    "dropmalzpp": 737359998,
    "dropsitphn": 5804932290,
    "dropsitlph": 5804932290,
    "dropsitcph": 5804932290,
    "dropfax": 5804932290
  },
  {
    "dcode": "D",
    "dropkey": "PW22016",
    "droptype": "D",
    "dropname": "DRUMRIGHT",
    "dropdeladd": "118 N OHIO AVE",
    "dropdelcty": "DRUMRIGHT",
    "dropdelst": "OK",
    "dropdelzpp": 740309998,
    "dropphyadd": "118 N OHIO AVE",
    "dropphycty": "DRUMRIGHT",
    "dropphyst": "OK",
    "dropphyzpp": 740309998,
    "dropmaladd": "118 N OHIO AVE",
    "dropmalcty": "DRUMRIGHT",
    "dropmalst": "OK",
    "dropmalzpp": 740309998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183523694,
    "dropsitcph": 9183523694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22017",
    "droptype": "D",
    "dropname": "DUKE",
    "dropdeladd": "106 E 2ND ST",
    "dropdelcty": "DUKE",
    "dropdelst": "OK",
    "dropdelzpp": 735329998,
    "dropphyadd": "106 E 2ND ST",
    "dropphycty": "DUKE",
    "dropphyst": "OK",
    "dropphyzpp": 735329998,
    "dropmaladd": "106 E 2ND ST",
    "dropmalcty": "DUKE",
    "dropmalst": "OK",
    "dropmalzpp": 735329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806793562,
    "dropsitcph": 5806793562,
    "dropfax": 5806793562
  },
  {
    "dcode": "D",
    "dropkey": "PW22018",
    "droptype": "D",
    "dropname": "DUNCAN",
    "dropdeladd": "802 W WILLOW AVE FL 100",
    "dropdelcty": "DUNCAN",
    "dropdelst": "OK",
    "dropdelzpp": 735339998,
    "dropphyadd": "802 W WILLOW AVE FL 100",
    "dropphycty": "DUNCAN",
    "dropphyst": "OK",
    "dropphyzpp": 735339998,
    "dropmaladd": "802 W WILLOW AVE FL 100",
    "dropmalcty": "DUNCAN",
    "dropmalst": "OK",
    "dropmalzpp": 735339998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802557226,
    "dropsitcph": 5802557226,
    "dropfax": 5802527859
  },
  {
    "dcode": "D",
    "dropkey": "PW22020",
    "droptype": "D",
    "dropname": "DURANT",
    "dropdeladd": "1223 W MAIN ST",
    "dropdelcty": "DURANT",
    "dropdelst": "OK",
    "dropdelzpp": 747019998,
    "dropphyadd": "1223 W MAIN ST",
    "dropphycty": "DURANT",
    "dropphyst": "OK",
    "dropphyzpp": 747019998,
    "dropmaladd": "1223 W MAIN ST",
    "dropmalcty": "DURANT",
    "dropmalst": "OK",
    "dropmalzpp": 747019998,
    "dropsitphn": 5809246464,
    "dropsitlph": 5809246464,
    "dropsitcph": 5809246464,
    "dropfax": 5809200738
  },
  {
    "dcode": "D",
    "dropkey": "PW22022",
    "droptype": "D",
    "dropname": "DUSTIN",
    "dropdeladd": "127 N BROADWAY ST",
    "dropdelcty": "DUSTIN",
    "dropdelst": "OK",
    "dropdelzpp": 748399998,
    "dropphyadd": "127 N BROADWAY ST",
    "dropphycty": "DUSTIN",
    "dropphyst": "OK",
    "dropphyzpp": 748399998,
    "dropmaladd": "127 N BROADWAY ST",
    "dropmalcty": "DUSTIN",
    "dropmalst": "OK",
    "dropmalzpp": 748399998,
    "dropsitphn": 9186563285,
    "dropsitlph": 9186563285,
    "dropsitcph": 9186563285,
    "dropfax": 9186563285
  },
  {
    "dcode": "D",
    "dropkey": "PW22025",
    "droptype": "D",
    "dropname": "EAGLETOWN",
    "dropdeladd": "8747 E US HIGHWAY 70",
    "dropdelcty": "EAGLETOWN",
    "dropdelst": "OK",
    "dropdelzpp": 747349998,
    "dropphyadd": "8747 E US HIGHWAY 70",
    "dropphycty": "EAGLETOWN",
    "dropphyst": "OK",
    "dropphyzpp": 747349998,
    "dropmaladd": "8747 E US HIGHWAY 70",
    "dropmalcty": "EAGLETOWN",
    "dropmalst": "OK",
    "dropmalzpp": 747349998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808352559,
    "dropsitcph": 5808352559,
    "dropfax": 5808352559
  },
  {
    "dcode": "D",
    "dropkey": "PW22026",
    "droptype": "D",
    "dropname": "EAKLY",
    "dropdeladd": "404 W MAIN ST",
    "dropdelcty": "EAKLY",
    "dropdelst": "OK",
    "dropdelzpp": 730339998,
    "dropphyadd": "404 W MAIN ST",
    "dropphycty": "EAKLY",
    "dropphyst": "OK",
    "dropphyzpp": 730339998,
    "dropmaladd": "404 W MAIN ST",
    "dropmalcty": "EAKLY",
    "dropmalst": "OK",
    "dropmalzpp": 730339998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057973353,
    "dropsitcph": 4057973353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22027",
    "droptype": "D",
    "dropname": "EARLSBORO",
    "dropdeladd": "220 W MAIN ST",
    "dropdelcty": "EARLSBORO",
    "dropdelst": "OK",
    "dropdelzpp": 748409998,
    "dropphyadd": "220 W MAIN ST",
    "dropphycty": "EARLSBORO",
    "dropphyst": "OK",
    "dropphyzpp": 748409998,
    "dropmaladd": "220 W MAIN ST",
    "dropmalcty": "EARLSBORO",
    "dropmalst": "OK",
    "dropmalzpp": 748409998,
    "dropsitphn": 4052797008,
    "dropsitlph": 4052797008,
    "dropsitcph": 4052797008,
    "dropfax": 4052797007
  },
  {
    "dcode": "D",
    "dropkey": "PW22033",
    "droptype": "D",
    "dropname": "EDMOND",
    "dropdeladd": "200 N BROADWAY",
    "dropdelcty": "EDMOND",
    "dropdelst": "OK",
    "dropdelzpp": 730349998,
    "dropphyadd": "200 N BROADWAY",
    "dropphycty": "EDMOND",
    "dropphyst": "OK",
    "dropphyzpp": 730349998,
    "dropmaladd": "200 N BROADWAY",
    "dropmalcty": "EDMOND",
    "dropmalst": "OK",
    "dropmalzpp": 730349998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053416991,
    "dropsitcph": 4053416991,
    "dropfax": 4053418940
  },
  {
    "dcode": "D",
    "dropkey": "PW22035",
    "droptype": "D",
    "dropname": "EL RENO",
    "dropdeladd": "203 N EVANS AVE",
    "dropdelcty": "EL RENO",
    "dropdelst": "OK",
    "dropdelzpp": 730369998,
    "dropphyadd": "203 N EVANS AVE",
    "dropphycty": "EL RENO",
    "dropphyst": "OK",
    "dropphyzpp": 730369998,
    "dropmaladd": "203 N EVANS AVE",
    "dropmalcty": "EL RENO",
    "dropmalst": "OK",
    "dropmalzpp": 730369998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052624988,
    "dropsitcph": 4052625095,
    "dropfax": 4052624682
  },
  {
    "dcode": "D",
    "dropkey": "PW22036",
    "droptype": "D",
    "dropname": "ELDORADO",
    "dropdeladd": "116 N 4TH ST",
    "dropdelcty": "ELDORADO",
    "dropdelst": "OK",
    "dropdelzpp": 735379998,
    "dropphyadd": "116 N 4TH ST",
    "dropphycty": "ELDORADO",
    "dropphyst": "OK",
    "dropphyzpp": 735379998,
    "dropmaladd": "116 N 4TH ST",
    "dropmalcty": "ELDORADO",
    "dropmalst": "OK",
    "dropmalzpp": 735379998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806332528,
    "dropsitcph": 5806332528,
    "dropfax": 5806332528
  },
  {
    "dcode": "D",
    "dropkey": "PW22037",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "8292 STATE HIGHWAY 17",
    "dropdelcty": "ELGIN",
    "dropdelst": "OK",
    "dropdelzpp": 735389998,
    "dropphyadd": "8292 STATE HIGHWAY 17",
    "dropphycty": "ELGIN",
    "dropphyst": "OK",
    "dropphyzpp": 735389998,
    "dropmaladd": "8292 STATE HIGHWAY 17",
    "dropmalcty": "ELGIN",
    "dropmalst": "OK",
    "dropmalzpp": 735389998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804924795,
    "dropsitcph": 5804924795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22038",
    "droptype": "D",
    "dropname": "ELK CITY",
    "dropdeladd": "101 S ADAMS AVE",
    "dropdelcty": "ELK CITY",
    "dropdelst": "OK",
    "dropdelzpp": 736449998,
    "dropphyadd": "101 S ADAMS AVE",
    "dropphycty": "ELK CITY",
    "dropphyst": "OK",
    "dropphyzpp": 736449998,
    "dropmaladd": "101 S ADAMS AVE",
    "dropmalcty": "ELK CITY",
    "dropmalst": "OK",
    "dropmalzpp": 736449998,
    "dropsitphn": 5802250294,
    "dropsitlph": 5802250294,
    "dropsitcph": 5802250294,
    "dropfax": 5802431625
  },
  {
    "dcode": "D",
    "dropkey": "PW22040",
    "droptype": "D",
    "dropname": "ELMER",
    "dropdeladd": "717 MAIN ST",
    "dropdelcty": "ELMER",
    "dropdelst": "OK",
    "dropdelzpp": 735399998,
    "dropphyadd": "717 MAIN ST",
    "dropphycty": "ELMER",
    "dropphyst": "OK",
    "dropphyzpp": 735399998,
    "dropmaladd": "717 MAIN ST",
    "dropmalcty": "ELMER",
    "dropmalst": "OK",
    "dropmalzpp": 735399998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806874460,
    "dropsitcph": 5806874460,
    "dropfax": 5806874460
  },
  {
    "dcode": "D",
    "dropkey": "PW22041",
    "droptype": "D",
    "dropname": "ELMORE CITY",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "ELMORE CITY",
    "dropdelst": "OK",
    "dropdelzpp": 734339998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "ELMORE CITY",
    "dropphyst": "OK",
    "dropphyzpp": 734339998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "ELMORE CITY",
    "dropmalst": "OK",
    "dropmalzpp": 734339998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807882597,
    "dropsitcph": 5807882597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22044",
    "droptype": "D",
    "dropname": "ENID",
    "dropdeladd": "115 W BROADWAY AVE FL 1",
    "dropdelcty": "ENID",
    "dropdelst": "OK",
    "dropdelzpp": 737019998,
    "dropphyadd": "115 W BROADWAY AVE FL 1",
    "dropphycty": "ENID",
    "dropphyst": "OK",
    "dropphyzpp": 737019998,
    "dropmaladd": "115 W BROADWAY AVE FL 1",
    "dropmalcty": "ENID",
    "dropmalst": "OK",
    "dropmalzpp": 737019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802374331,
    "dropsitcph": 5802374331,
    "dropfax": 5802376419
  },
  {
    "dcode": "D",
    "dropkey": "PW22046",
    "droptype": "D",
    "dropname": "ERICK",
    "dropdeladd": "119 W 3RD ST",
    "dropdelcty": "ERICK",
    "dropdelst": "OK",
    "dropdelzpp": 736459998,
    "dropphyadd": "119 W 3RD ST",
    "dropphycty": "ERICK",
    "dropphyst": "OK",
    "dropphyzpp": 736459998,
    "dropmaladd": "119 W 3RD ST",
    "dropmalcty": "ERICK",
    "dropmalst": "OK",
    "dropmalzpp": 736459998,
    "dropsitphn": 5805263254,
    "dropsitlph": 5805263254,
    "dropsitcph": 5805263254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22047",
    "droptype": "D",
    "dropname": "EUCHA",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "EUCHA",
    "dropdelst": "OK",
    "dropdelzpp": 743429998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "EUCHA",
    "dropphyst": "OK",
    "dropphyzpp": 743429998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "EUCHA",
    "dropmalst": "OK",
    "dropmalzpp": 743429998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182534956,
    "dropsitcph": 9182534956,
    "dropfax": 9182534956
  },
  {
    "dcode": "D",
    "dropkey": "PW22048",
    "droptype": "D",
    "dropname": "EUFAULA",
    "dropdeladd": "131 W FOLEY ST",
    "dropdelcty": "EUFAULA",
    "dropdelst": "OK",
    "dropdelzpp": 744329998,
    "dropphyadd": "131 W FOLEY ST",
    "dropphycty": "EUFAULA",
    "dropphyst": "OK",
    "dropphyzpp": 744329998,
    "dropmaladd": "131 W FOLEY ST",
    "dropmalcty": "EUFAULA",
    "dropmalst": "OK",
    "dropmalzpp": 744329998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186892622,
    "dropsitcph": 9186892622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22049",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "151 E ELM ST",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "OK",
    "dropdelzpp": 746379998,
    "dropphyadd": "151 E ELM ST",
    "dropphycty": "FAIRFAX",
    "dropphyst": "OK",
    "dropphyzpp": 746379998,
    "dropmaladd": "151 E ELM ST",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "OK",
    "dropmalzpp": 746379998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186423254,
    "dropsitcph": 9186423254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22050",
    "droptype": "D",
    "dropname": "FAIRLAND",
    "dropdeladd": "121 N OLIVER ST",
    "dropdelcty": "FAIRLAND",
    "dropdelst": "OK",
    "dropdelzpp": 743439998,
    "dropphyadd": "121 N OLIVER ST",
    "dropphycty": "FAIRLAND",
    "dropphyst": "OK",
    "dropphyzpp": 743439998,
    "dropmaladd": "121 N OLIVER ST",
    "dropmalcty": "FAIRLAND",
    "dropmalst": "OK",
    "dropmalzpp": 743439998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186763831,
    "dropsitcph": 9186763831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22051",
    "droptype": "D",
    "dropname": "FAIRMONT",
    "dropdeladd": "620 MAIN ST",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "OK",
    "dropdelzpp": 737369998,
    "dropphyadd": "620 MAIN ST",
    "dropphycty": "FAIRMONT",
    "dropphyst": "OK",
    "dropphyzpp": 737369998,
    "dropmaladd": "620 MAIN ST",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "OK",
    "dropmalzpp": 737369998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803582289,
    "dropsitcph": 5803582289,
    "dropfax": 5803582289
  },
  {
    "dcode": "D",
    "dropkey": "PW22052",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "115 W BROADWAY",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "OK",
    "dropdelzpp": 737379998,
    "dropphyadd": "115 W BROADWAY",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "OK",
    "dropphyzpp": 737379998,
    "dropmaladd": "115 W BROADWAY",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "OK",
    "dropmalzpp": 737379998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802274838,
    "dropsitcph": 5802274838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22053",
    "droptype": "D",
    "dropname": "FANSHAWE",
    "dropdeladd": "36968 US HIGHWAY 270",
    "dropdelcty": "FANSHAWE",
    "dropdelst": "OK",
    "dropdelzpp": 749359998,
    "dropphyadd": "36968 US HIGHWAY 270",
    "dropphycty": "FANSHAWE",
    "dropphyst": "OK",
    "dropphyzpp": 749359998,
    "dropmaladd": "36968 US HIGHWAY 270",
    "dropmalcty": "FANSHAWE",
    "dropmalst": "OK",
    "dropmalzpp": 749359998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182650144,
    "dropsitcph": 9182650144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22054",
    "droptype": "D",
    "dropname": "FARGO",
    "dropdeladd": "216 S MAIN ST",
    "dropdelcty": "FARGO",
    "dropdelst": "OK",
    "dropdelzpp": 738409998,
    "dropphyadd": "216 S MAIN ST",
    "dropphycty": "FARGO",
    "dropphyst": "OK",
    "dropphyzpp": 738409998,
    "dropmaladd": "216 S MAIN ST",
    "dropmalcty": "FARGO",
    "dropmalst": "OK",
    "dropmalzpp": 738409998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806982450,
    "dropsitcph": 5806982450,
    "dropfax": 5806982470
  },
  {
    "dcode": "D",
    "dropkey": "PW22058",
    "droptype": "D",
    "dropname": "FAY",
    "dropdeladd": "82880 CUSTER",
    "dropdelcty": "FAY",
    "dropdelst": "OK",
    "dropdelzpp": 736469998,
    "dropphyadd": "82880 CUSTER",
    "dropphycty": "FAY",
    "dropphyst": "OK",
    "dropphyzpp": 736469998,
    "dropmaladd": "82880 CUSTER",
    "dropmalcty": "FAY",
    "dropmalst": "OK",
    "dropmalzpp": 736469998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808873426,
    "dropsitcph": 5808873426,
    "dropfax": 5808873426
  },
  {
    "dcode": "D",
    "dropkey": "PW22059",
    "droptype": "D",
    "dropname": "FELT",
    "dropdeladd": "101 LINCOLN ST",
    "dropdelcty": "FELT",
    "dropdelst": "OK",
    "dropdelzpp": 739379800,
    "dropphyadd": "101 LINCOLN ST",
    "dropphycty": "FELT",
    "dropphyst": "OK",
    "dropphyzpp": 739379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FELT",
    "dropmalst": "OK",
    "dropmalzpp": 739379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 5804470366,
    "dropsitcph": 5804470366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22061",
    "droptype": "D",
    "dropname": "FINLEY",
    "dropdeladd": "185218 US HIGHWAY 271",
    "dropdelcty": "FINLEY",
    "dropdelst": "OK",
    "dropdelzpp": 745439998,
    "dropphyadd": "185218 US HIGHWAY 271",
    "dropphycty": "FINLEY",
    "dropphyst": "OK",
    "dropphyzpp": 745439998,
    "dropmaladd": "185218 US HIGHWAY 271",
    "dropmalcty": "FINLEY",
    "dropmalst": "OK",
    "dropmalzpp": 745439998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802982019,
    "dropsitcph": 5802982019,
    "dropfax": 5802982019
  },
  {
    "dcode": "D",
    "dropkey": "PW22064",
    "droptype": "D",
    "dropname": "FITTSTOWN",
    "dropdeladd": "101 US HIGHWAY 377",
    "dropdelcty": "FITTSTOWN",
    "dropdelst": "OK",
    "dropdelzpp": 748429998,
    "dropphyadd": "101 US HIGHWAY 377",
    "dropphycty": "FITTSTOWN",
    "dropphyst": "OK",
    "dropphyzpp": 748429998,
    "dropmaladd": "101 US HIGHWAY 377",
    "dropmalcty": "FITTSTOWN",
    "dropmalst": "OK",
    "dropmalzpp": 748429998,
    "dropsitphn": 5807772288,
    "dropsitlph": 5807772288,
    "dropsitcph": 5807772288,
    "dropfax": 5807772288
  },
  {
    "dcode": "D",
    "dropkey": "PW22065",
    "droptype": "D",
    "dropname": "FITZHUGH",
    "dropdeladd": "9935 COUNTY ROAD 1620",
    "dropdelcty": "FITZHUGH",
    "dropdelst": "OK",
    "dropdelzpp": 748439998,
    "dropphyadd": "9935 COUNTY ROAD 1620",
    "dropphycty": "FITZHUGH",
    "dropphyst": "OK",
    "dropphyzpp": 748439998,
    "dropmaladd": "9935 COUNTY ROAD 1620",
    "dropmalcty": "FITZHUGH",
    "dropmalst": "OK",
    "dropmalzpp": 748439998,
    "dropsitphn": 5804361425,
    "dropsitlph": 5804361425,
    "dropsitcph": 5804361425,
    "dropfax": 5804361425
  },
  {
    "dcode": "D",
    "dropkey": "PW22066",
    "droptype": "D",
    "dropname": "FLETCHER",
    "dropdeladd": "103 N SELBY",
    "dropdelcty": "FLETCHER",
    "dropdelst": "OK",
    "dropdelzpp": 735419998,
    "dropphyadd": "103 N SELBY",
    "dropphycty": "FLETCHER",
    "dropphyst": "OK",
    "dropphyzpp": 735419998,
    "dropmaladd": "103 N SELBY",
    "dropmalcty": "FLETCHER",
    "dropmalst": "OK",
    "dropmalzpp": 735419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805496257,
    "dropsitcph": 5805496257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22070",
    "droptype": "D",
    "dropname": "FORGAN",
    "dropdeladd": "115 S BROADWAY ST",
    "dropdelcty": "FORGAN",
    "dropdelst": "OK",
    "dropdelzpp": 739389800,
    "dropphyadd": "115 S BROADWAY ST",
    "dropphycty": "FORGAN",
    "dropphyst": "OK",
    "dropphyzpp": 739389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORGAN",
    "dropmalst": "OK",
    "dropmalzpp": 739389998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5804873722,
    "dropfax": 5804873719
  },
  {
    "dcode": "D",
    "dropkey": "PW22071",
    "droptype": "D",
    "dropname": "FORT COBB",
    "dropdeladd": "408 N HAZLETT ST",
    "dropdelcty": "FORT COBB",
    "dropdelst": "OK",
    "dropdelzpp": 730389998,
    "dropphyadd": "408 N HAZLETT ST",
    "dropphycty": "FORT COBB",
    "dropphyst": "OK",
    "dropphyzpp": 730389998,
    "dropmaladd": "408 N HAZLETT ST",
    "dropmalcty": "FORT COBB",
    "dropmalst": "OK",
    "dropmalzpp": 730389998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4056430184,
    "dropsitcph": 4056430184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22072",
    "droptype": "D",
    "dropname": "FORT GIBSON",
    "dropdeladd": "201 W POPLAR ST",
    "dropdelcty": "FORT GIBSON",
    "dropdelst": "OK",
    "dropdelzpp": 744349998,
    "dropphyadd": "201 W POPLAR ST",
    "dropphycty": "FORT GIBSON",
    "dropphyst": "OK",
    "dropphyzpp": 744349998,
    "dropmaladd": "201 W POPLAR ST",
    "dropmalcty": "FORT GIBSON",
    "dropmalst": "OK",
    "dropmalzpp": 744349998,
    "dropsitphn": 9184782181,
    "dropsitlph": 9184782181,
    "dropsitcph": 9184782181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22074",
    "droptype": "D",
    "dropname": "FORT SUPPLY",
    "dropdeladd": "229 BROADWAY ST",
    "dropdelcty": "FORT SUPPLY",
    "dropdelst": "OK",
    "dropdelzpp": 738419998,
    "dropphyadd": "229 BROADWAY ST",
    "dropphycty": "FORT SUPPLY",
    "dropphyst": "OK",
    "dropphyzpp": 738419998,
    "dropmaladd": "229 BROADWAY ST",
    "dropmalcty": "FORT SUPPLY",
    "dropmalst": "OK",
    "dropmalzpp": 738419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807663781,
    "dropsitcph": 5807663781,
    "dropfax": 5807663781
  },
  {
    "dcode": "D",
    "dropkey": "PW22075",
    "droptype": "D",
    "dropname": "FORT TOWSON",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "FORT TOWSON",
    "dropdelst": "OK",
    "dropdelzpp": 747359998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "FORT TOWSON",
    "dropphyst": "OK",
    "dropphyzpp": 747359998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "FORT TOWSON",
    "dropmalst": "OK",
    "dropmalzpp": 747359998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808732218,
    "dropsitcph": 5808732218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22076",
    "droptype": "D",
    "dropname": "FOSS",
    "dropdeladd": "302 E BROADWAY ST",
    "dropdelcty": "FOSS",
    "dropdelst": "OK",
    "dropdelzpp": 736479998,
    "dropphyadd": "302 E BROADWAY ST",
    "dropphycty": "FOSS",
    "dropphyst": "OK",
    "dropphyzpp": 736479998,
    "dropmaladd": "302 E BROADWAY ST",
    "dropmalcty": "FOSS",
    "dropmalst": "OK",
    "dropmalzpp": 736479998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805924733,
    "dropsitcph": 5805924733,
    "dropfax": 5805924733
  },
  {
    "dcode": "D",
    "dropkey": "PW22077",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "20188 E COUNTY ROAD 1655",
    "dropdelcty": "FOSTER",
    "dropdelst": "OK",
    "dropdelzpp": 734349998,
    "dropphyadd": "20188 E COUNTY ROAD 1655",
    "dropphycty": "FOSTER",
    "dropphyst": "OK",
    "dropphyzpp": 734349998,
    "dropmaladd": "20188 E COUNTY ROAD 1655",
    "dropmalcty": "FOSTER",
    "dropmalst": "OK",
    "dropmalzpp": 734349998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804325598,
    "dropsitcph": 5804325598,
    "dropfax": 5804325598
  },
  {
    "dcode": "D",
    "dropkey": "PW22078",
    "droptype": "D",
    "dropname": "FOX",
    "dropdeladd": "20378 STATE HIGHWAY 76",
    "dropdelcty": "FOX",
    "dropdelst": "OK",
    "dropdelzpp": 734359998,
    "dropphyadd": "20378 STATE HIGHWAY 76",
    "dropphycty": "FOX",
    "dropphyst": "OK",
    "dropphyzpp": 734359998,
    "dropmaladd": "20378 STATE HIGHWAY 76",
    "dropmalcty": "FOX",
    "dropmalst": "OK",
    "dropmalzpp": 734359998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806732022,
    "dropsitcph": 5806732022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22079",
    "droptype": "D",
    "dropname": "FOYIL",
    "dropdeladd": "17172 E 3RD ST",
    "dropdelcty": "FOYIL",
    "dropdelst": "OK",
    "dropdelzpp": 740319998,
    "dropphyadd": "17172 E 3RD ST",
    "dropphycty": "FOYIL",
    "dropphyst": "OK",
    "dropphyzpp": 740319998,
    "dropmaladd": "17172 E 3RD ST",
    "dropmalcty": "FOYIL",
    "dropmalst": "OK",
    "dropmalzpp": 740319998,
    "dropsitphn": 9183416229,
    "dropsitlph": 9183416229,
    "dropsitcph": 9183416229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22080",
    "droptype": "D",
    "dropname": "FRANCIS",
    "dropdeladd": "231 W MAIN ST",
    "dropdelcty": "FRANCIS",
    "dropdelst": "OK",
    "dropdelzpp": 748449998,
    "dropphyadd": "231 W MAIN ST",
    "dropphycty": "FRANCIS",
    "dropphyst": "OK",
    "dropphyzpp": 748449998,
    "dropmaladd": "231 W MAIN ST",
    "dropmalcty": "FRANCIS",
    "dropmalst": "OK",
    "dropmalzpp": 748449998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804363017,
    "dropsitcph": 5804363017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22081",
    "droptype": "D",
    "dropname": "FREDERICK",
    "dropdeladd": "120 E GRAND AVE",
    "dropdelcty": "FREDERICK",
    "dropdelst": "OK",
    "dropdelzpp": 735429998,
    "dropphyadd": "120 E GRAND AVE",
    "dropphycty": "FREDERICK",
    "dropphyst": "OK",
    "dropphyzpp": 735429998,
    "dropmaladd": "120 E GRAND AVE",
    "dropmalcty": "FREDERICK",
    "dropmalst": "OK",
    "dropmalzpp": 735429998,
    "dropsitphn": 5804183115,
    "dropsitlph": 5804183115,
    "dropsitcph": 5804183115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22082",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "1055 MAIN ST",
    "dropdelcty": "FREEDOM",
    "dropdelst": "OK",
    "dropdelzpp": 738429998,
    "dropphyadd": "1055 MAIN ST",
    "dropphycty": "FREEDOM",
    "dropphyst": "OK",
    "dropphyzpp": 738429998,
    "dropmaladd": "1055 MAIN ST",
    "dropmalcty": "FREEDOM",
    "dropmalst": "OK",
    "dropmalzpp": 738429998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806213501,
    "dropsitcph": 5806213501,
    "dropfax": 5806213501
  },
  {
    "dcode": "D",
    "dropkey": "PW22086",
    "droptype": "D",
    "dropname": "GAGE",
    "dropdeladd": "414 N MAIN ST",
    "dropdelcty": "GAGE",
    "dropdelst": "OK",
    "dropdelzpp": 738439998,
    "dropphyadd": "414 N MAIN ST",
    "dropphycty": "GAGE",
    "dropphyst": "OK",
    "dropphyzpp": 738439998,
    "dropmaladd": "414 N MAIN ST",
    "dropmalcty": "GAGE",
    "dropmalst": "OK",
    "dropmalzpp": 738439998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809237446,
    "dropsitcph": 5809237446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22087",
    "droptype": "D",
    "dropname": "GANS",
    "dropdeladd": "100 S STACY AVE",
    "dropdelcty": "GANS",
    "dropdelst": "OK",
    "dropdelzpp": 749369998,
    "dropphyadd": "100 S STACY AVE",
    "dropphycty": "GANS",
    "dropphyst": "OK",
    "dropphyzpp": 749369998,
    "dropmaladd": "100 S STACY AVE",
    "dropmalcty": "GANS",
    "dropmalst": "OK",
    "dropmalzpp": 749369998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187754982,
    "dropsitcph": 9187754982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22088",
    "droptype": "D",
    "dropname": "GARBER",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "GARBER",
    "dropdelst": "OK",
    "dropdelzpp": 737389998,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "GARBER",
    "dropphyst": "OK",
    "dropphyzpp": 737389998,
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "GARBER",
    "dropmalst": "OK",
    "dropmalzpp": 737389998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808632250,
    "dropsitcph": 5808632250,
    "dropfax": 5808632250
  },
  {
    "dcode": "D",
    "dropkey": "PW22089",
    "droptype": "D",
    "dropname": "GARVIN",
    "dropdeladd": "10 N LOVE ST",
    "dropdelcty": "GARVIN",
    "dropdelst": "OK",
    "dropdelzpp": 747369998,
    "dropphyadd": "10 N LOVE ST",
    "dropphycty": "GARVIN",
    "dropphyst": "OK",
    "dropphyzpp": 747369998,
    "dropmaladd": "10 N LOVE ST",
    "dropmalcty": "GARVIN",
    "dropmalst": "OK",
    "dropmalzpp": 747369998,
    "dropsitphn": 5802862149,
    "dropsitlph": 5802863103,
    "dropsitcph": 5802863103,
    "dropfax": 5802863103
  },
  {
    "dcode": "D",
    "dropkey": "PW22090",
    "droptype": "D",
    "dropname": "GATE",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "GATE",
    "dropdelst": "OK",
    "dropdelzpp": 738449997,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "GATE",
    "dropphyst": "OK",
    "dropphyzpp": 738449997,
    "dropmaladd": "402 MAIN ST",
    "dropmalcty": "GATE",
    "dropmalst": "OK",
    "dropmalzpp": 738449997,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809342651,
    "dropsitcph": 5809342651,
    "dropfax": 5809342652
  },
  {
    "dcode": "D",
    "dropkey": "PW22092",
    "droptype": "D",
    "dropname": "GEARY",
    "dropdeladd": "120 NW 1ST ST",
    "dropdelcty": "GEARY",
    "dropdelst": "OK",
    "dropdelzpp": 730409998,
    "dropphyadd": "120 NW 1ST ST",
    "dropphycty": "GEARY",
    "dropphyst": "OK",
    "dropphyzpp": 730409998,
    "dropmaladd": "120 NW 1ST ST",
    "dropmalcty": "GEARY",
    "dropmalst": "OK",
    "dropmalzpp": 730409998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058842771,
    "dropsitcph": 4058842771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22093",
    "droptype": "D",
    "dropname": "GENE AUTRY",
    "dropdeladd": "45 PRAIRIE ST",
    "dropdelcty": "GENE AUTRY",
    "dropdelst": "OK",
    "dropdelzpp": 734369998,
    "dropphyadd": "45 PRAIRIE ST",
    "dropphycty": "GENE AUTRY",
    "dropphyst": "OK",
    "dropphyzpp": 734369998,
    "dropmaladd": "45 PRAIRIE ST",
    "dropmalcty": "GENE AUTRY",
    "dropmalst": "OK",
    "dropmalzpp": 734369998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802943111,
    "dropsitcph": 5802943111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22094",
    "droptype": "D",
    "dropname": "GERONIMO",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "GERONIMO",
    "dropdelst": "OK",
    "dropdelzpp": 735439998,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "GERONIMO",
    "dropphyst": "OK",
    "dropphyzpp": 735439998,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "GERONIMO",
    "dropmalst": "OK",
    "dropmalzpp": 735439998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803530173,
    "dropsitcph": 5803530173,
    "dropfax": 5803530173
  },
  {
    "dcode": "D",
    "dropkey": "PW22096",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "313 W MAIN ST",
    "dropdelcty": "GLENCOE",
    "dropdelst": "OK",
    "dropdelzpp": 740329998,
    "dropphyadd": "313 W MAIN ST",
    "dropphycty": "GLENCOE",
    "dropphyst": "OK",
    "dropphyzpp": 740329998,
    "dropmaladd": "313 W MAIN ST",
    "dropmalcty": "GLENCOE",
    "dropmalst": "OK",
    "dropmalzpp": 740329998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5806692362,
    "dropsitcph": 5806692362,
    "dropfax": 5806692362
  },
  {
    "dcode": "D",
    "dropkey": "PW22098",
    "droptype": "D",
    "dropname": "GLENPOOL",
    "dropdeladd": "14169 S BROADWAY ST",
    "dropdelcty": "GLENPOOL",
    "dropdelst": "OK",
    "dropdelzpp": 740339998,
    "dropphyadd": "14169 S BROADWAY ST",
    "dropphycty": "GLENPOOL",
    "dropphyst": "OK",
    "dropphyzpp": 740339998,
    "dropmaladd": "14169 S BROADWAY ST",
    "dropmalcty": "GLENPOOL",
    "dropmalst": "OK",
    "dropmalzpp": 740339998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183223724,
    "dropsitcph": 9183223724,
    "dropfax": 9183229752
  },
  {
    "dcode": "D",
    "dropkey": "PW22101",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "100 LINE ST",
    "dropdelcty": "GOLDEN",
    "dropdelst": "OK",
    "dropdelzpp": 747379998,
    "dropphyadd": "100 LINE ST",
    "dropphycty": "GOLDEN",
    "dropphyst": "OK",
    "dropphyzpp": 747379998,
    "dropmaladd": "100 LINE ST",
    "dropmalcty": "GOLDEN",
    "dropmalst": "OK",
    "dropmalzpp": 747379998,
    "dropsitphn": 5809812725,
    "dropsitlph": 5809812725,
    "dropsitcph": 5804206505,
    "dropfax": 5804206505
  },
  {
    "dcode": "D",
    "dropkey": "PW22102",
    "droptype": "D",
    "dropname": "GOLTRY",
    "dropdeladd": "201 W MAIN",
    "dropdelcty": "GOLTRY",
    "dropdelst": "OK",
    "dropdelzpp": 737399998,
    "dropphyadd": "201 W MAIN",
    "dropphycty": "GOLTRY",
    "dropphyst": "OK",
    "dropphyzpp": 737399998,
    "dropmaladd": "201 W MAIN",
    "dropmalcty": "GOLTRY",
    "dropmalst": "OK",
    "dropmalzpp": 737399998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804962481,
    "dropsitcph": 5804962481,
    "dropfax": 5804962481
  },
  {
    "dcode": "D",
    "dropkey": "PW22103",
    "droptype": "D",
    "dropname": "GOODWELL",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "GOODWELL",
    "dropdelst": "OK",
    "dropdelzpp": 739399800,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "GOODWELL",
    "dropphyst": "OK",
    "dropphyzpp": 739399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODWELL",
    "dropmalst": "OK",
    "dropmalzpp": 739399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 6267704974,
    "dropsitcph": 6267704974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22104",
    "droptype": "D",
    "dropname": "GORE",
    "dropdeladd": "402 N MAIN ST",
    "dropdelcty": "GORE",
    "dropdelst": "OK",
    "dropdelzpp": 744359998,
    "dropphyadd": "402 N MAIN ST",
    "dropphycty": "GORE",
    "dropphyst": "OK",
    "dropphyzpp": 744359998,
    "dropmaladd": "402 N MAIN ST",
    "dropmalcty": "GORE",
    "dropmalst": "OK",
    "dropmalzpp": 744359998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184895603,
    "dropsitcph": 9184895603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22105",
    "droptype": "D",
    "dropname": "GOTEBO",
    "dropdeladd": "11 COMMERCIAL AVE",
    "dropdelcty": "GOTEBO",
    "dropdelst": "OK",
    "dropdelzpp": 730419998,
    "dropphyadd": "11 COMMERCIAL AVE",
    "dropphycty": "GOTEBO",
    "dropphyst": "OK",
    "dropphyzpp": 730419998,
    "dropmaladd": "11 COMMERCIAL AVE",
    "dropmalcty": "GOTEBO",
    "dropmalst": "OK",
    "dropmalzpp": 730419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805384611,
    "dropsitcph": 5805384611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22106",
    "droptype": "D",
    "dropname": "GOULD",
    "dropdeladd": "111 S KENNEDY ST",
    "dropdelcty": "GOULD",
    "dropdelst": "OK",
    "dropdelzpp": 735449998,
    "dropphyadd": "111 S KENNEDY ST",
    "dropphycty": "GOULD",
    "dropphyst": "OK",
    "dropphyzpp": 735449998,
    "dropmaladd": "111 S KENNEDY ST",
    "dropmalcty": "GOULD",
    "dropmalst": "OK",
    "dropmalzpp": 735449998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806763371,
    "dropsitcph": 5806763371,
    "dropfax": 5806763371
  },
  {
    "dcode": "D",
    "dropkey": "PW22107",
    "droptype": "D",
    "dropname": "GOWEN",
    "dropdeladd": "9231 SW GOWEN RD",
    "dropdelcty": "GOWEN",
    "dropdelst": "OK",
    "dropdelzpp": 745459998,
    "dropphyadd": "9231 SW GOWEN RD",
    "dropphycty": "GOWEN",
    "dropphyst": "OK",
    "dropphyzpp": 745459998,
    "dropmaladd": "9231 SW GOWEN RD",
    "dropmalcty": "GOWEN",
    "dropmalst": "OK",
    "dropmalzpp": 745459998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182977302,
    "dropsitcph": 9182977302,
    "dropfax": 9182977302
  },
  {
    "dcode": "D",
    "dropkey": "PW22108",
    "droptype": "D",
    "dropname": "GRACEMONT",
    "dropdeladd": "101 N 1ST ST",
    "dropdelcty": "GRACEMONT",
    "dropdelst": "OK",
    "dropdelzpp": 730429998,
    "dropphyadd": "101 N 1ST ST",
    "dropphycty": "GRACEMONT",
    "dropphyst": "OK",
    "dropphyzpp": 730429998,
    "dropmaladd": "101 N 1ST ST",
    "dropmalcty": "GRACEMONT",
    "dropmalst": "OK",
    "dropmalzpp": 730429998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059662367,
    "dropsitcph": 4059662367,
    "dropfax": 4059662367
  },
  {
    "dcode": "D",
    "dropkey": "PW22110",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "29173 STATE HIGHWAY 53",
    "dropdelcty": "GRAHAM",
    "dropdelst": "OK",
    "dropdelzpp": 734379998,
    "dropphyadd": "29173 STATE HIGHWAY 53",
    "dropphycty": "GRAHAM",
    "dropphyst": "OK",
    "dropphyzpp": 734379998,
    "dropmaladd": "29173 STATE HIGHWAY 53",
    "dropmalcty": "GRAHAM",
    "dropmalst": "OK",
    "dropmalzpp": 734379998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806732332,
    "dropsitcph": 5806732332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22111",
    "droptype": "D",
    "dropname": "GRANDFIELD",
    "dropdeladd": "123 E 2ND ST",
    "dropdelcty": "GRANDFIELD",
    "dropdelst": "OK",
    "dropdelzpp": 735469998,
    "dropphyadd": "123 E 2ND ST",
    "dropphycty": "GRANDFIELD",
    "dropphyst": "OK",
    "dropphyzpp": 735469998,
    "dropmaladd": "123 E 2ND ST",
    "dropmalcty": "GRANDFIELD",
    "dropmalst": "OK",
    "dropmalzpp": 735469998,
    "dropsitphn": 5804793155,
    "dropsitlph": 5804793155,
    "dropsitcph": 5804793155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22112",
    "droptype": "D",
    "dropname": "GRANITE",
    "dropdeladd": "402 N GRANITE ST",
    "dropdelcty": "GRANITE",
    "dropdelst": "OK",
    "dropdelzpp": 735479998,
    "dropphyadd": "402 N GRANITE ST",
    "dropphycty": "GRANITE",
    "dropphyst": "OK",
    "dropphyzpp": 735479998,
    "dropmaladd": "402 N GRANITE ST",
    "dropmalcty": "GRANITE",
    "dropmalst": "OK",
    "dropmalzpp": 735479998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805352352,
    "dropsitcph": 5805352352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22113",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "604 WALNUT ST",
    "dropdelcty": "GRANT",
    "dropdelst": "OK",
    "dropdelzpp": 747389998,
    "dropphyadd": "604 WALNUT ST",
    "dropphycty": "GRANT",
    "dropphyst": "OK",
    "dropphyzpp": 747389998,
    "dropmaladd": "604 WALNUT ST",
    "dropmalcty": "GRANT",
    "dropmalst": "OK",
    "dropmalzpp": 747389998,
    "dropsitphn": 5803262088,
    "dropsitlph": 5803262088,
    "dropsitcph": 5803262088,
    "dropfax": 5803262088
  },
  {
    "dcode": "D",
    "dropkey": "PW22115",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "100 MADISON ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "OK",
    "dropdelzpp": 730439998,
    "dropphyadd": "100 MADISON ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "OK",
    "dropphyzpp": 730439998,
    "dropmaladd": "100 MADISON ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "OK",
    "dropmalzpp": 730439998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806238631,
    "dropsitcph": 5806238631,
    "dropfax": 5806238631
  },
  {
    "dcode": "D",
    "dropkey": "PW22116",
    "droptype": "D",
    "dropname": "GROVE",
    "dropdeladd": "1200 S SHUNDI",
    "dropdelcty": "GROVE",
    "dropdelst": "OK",
    "dropdelzpp": 743449998,
    "dropphyadd": "1200 S SHUNDI",
    "dropphycty": "GROVE",
    "dropphyst": "OK",
    "dropphyzpp": 743449998,
    "dropmaladd": "1200 S SHUNDI",
    "dropmalcty": "GROVE",
    "dropmalst": "OK",
    "dropmalzpp": 743449998,
    "dropsitphn": 9187862266,
    "dropsitlph": 9187862266,
    "dropsitcph": 9187862266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22117",
    "droptype": "D",
    "dropname": "GUTHRIE",
    "dropdeladd": "201 W OKLAHOMA AVE",
    "dropdelcty": "GUTHRIE",
    "dropdelst": "OK",
    "dropdelzpp": 730449998,
    "dropphyadd": "201 W OKLAHOMA AVE",
    "dropphycty": "GUTHRIE",
    "dropphyst": "OK",
    "dropphyzpp": 730449998,
    "dropmaladd": "201 W OKLAHOMA AVE",
    "dropmalcty": "GUTHRIE",
    "dropmalst": "OK",
    "dropmalzpp": 730449998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052824736,
    "dropsitcph": 4052824736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22118",
    "droptype": "D",
    "dropname": "GUYMON",
    "dropdeladd": "302 N QUINN ST",
    "dropdelcty": "GUYMON",
    "dropdelst": "OK",
    "dropdelzpp": 739429998,
    "dropphyadd": "302 N QUINN ST",
    "dropphycty": "GUYMON",
    "dropphyst": "OK",
    "dropphyzpp": 739429998,
    "dropmaladd": "302 N QUINN ST",
    "dropmalcty": "GUYMON",
    "dropmalst": "OK",
    "dropmalzpp": 739429998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5803386422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22120",
    "droptype": "D",
    "dropname": "HAILEYVILLE",
    "dropdeladd": "509 PARKWAY AVE",
    "dropdelcty": "HAILEYVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 745469998,
    "dropphyadd": "509 PARKWAY AVE",
    "dropphycty": "HAILEYVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 745469998,
    "dropmaladd": "509 PARKWAY AVE",
    "dropmalcty": "HAILEYVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 745469998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182973221,
    "dropsitcph": 9182973221,
    "dropfax": 9182973221
  },
  {
    "dcode": "D",
    "dropkey": "PW22121",
    "droptype": "D",
    "dropname": "HALLETT",
    "dropdeladd": "501 5TH AVE",
    "dropdelcty": "HALLETT",
    "dropdelst": "OK",
    "dropdelzpp": 740349998,
    "dropphyadd": "501 5TH AVE",
    "dropphycty": "HALLETT",
    "dropphyst": "OK",
    "dropphyzpp": 740349998,
    "dropmaladd": "501 5TH AVE",
    "dropmalcty": "HALLETT",
    "dropmalst": "OK",
    "dropmalzpp": 740349998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183564365,
    "dropsitcph": 9183564365,
    "dropfax": 9183564365
  },
  {
    "dcode": "D",
    "dropkey": "PW22124",
    "droptype": "D",
    "dropname": "HAMMON",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "HAMMON",
    "dropdelst": "OK",
    "dropdelzpp": 736509998,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "HAMMON",
    "dropphyst": "OK",
    "dropphyzpp": 736509998,
    "dropmaladd": "701 MAIN ST",
    "dropmalcty": "HAMMON",
    "dropmalst": "OK",
    "dropmalzpp": 736509998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804732299,
    "dropsitcph": 5804732299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22125",
    "droptype": "D",
    "dropname": "HANNA",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "HANNA",
    "dropdelst": "OK",
    "dropdelzpp": 748459998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "HANNA",
    "dropphyst": "OK",
    "dropphyzpp": 748459998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "HANNA",
    "dropmalst": "OK",
    "dropmalzpp": 748459998,
    "dropsitphn": 9186572561,
    "dropsitlph": 9186572561,
    "dropsitcph": 9186572561,
    "dropfax": 9186572561
  },
  {
    "dcode": "D",
    "dropkey": "PW22127",
    "droptype": "D",
    "dropname": "HARDESTY",
    "dropdeladd": "107 S BROADWAY ST",
    "dropdelcty": "HARDESTY",
    "dropdelst": "OK",
    "dropdelzpp": 739449800,
    "dropphyadd": "107 S BROADWAY ST",
    "dropphycty": "HARDESTY",
    "dropphyst": "OK",
    "dropphyzpp": 739449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARDESTY",
    "dropmalst": "OK",
    "dropmalzpp": 739449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5808884515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22129",
    "droptype": "D",
    "dropname": "HARRAH",
    "dropdeladd": "19900 NE 23RD ST",
    "dropdelcty": "HARRAH",
    "dropdelst": "OK",
    "dropdelzpp": 730459998,
    "dropphyadd": "19900 NE 23RD ST",
    "dropphycty": "HARRAH",
    "dropphyst": "OK",
    "dropphyzpp": 730459998,
    "dropmaladd": "19900 NE 23RD ST",
    "dropmalcty": "HARRAH",
    "dropmalst": "OK",
    "dropmalzpp": 730459998,
    "dropsitphn": 4054541267,
    "dropsitlph": 4054541267,
    "dropsitcph": 4054541267,
    "dropfax": 4054546757
  },
  {
    "dcode": "D",
    "dropkey": "PW22130",
    "droptype": "D",
    "dropname": "HARTSHORNE",
    "dropdeladd": "1021 PENNSYLVANIA AVE",
    "dropdelcty": "HARTSHORNE",
    "dropdelst": "OK",
    "dropdelzpp": 745479998,
    "dropphyadd": "1021 PENNSYLVANIA AVE",
    "dropphycty": "HARTSHORNE",
    "dropphyst": "OK",
    "dropphyzpp": 745479998,
    "dropmaladd": "1021 PENNSYLVANIA AVE",
    "dropmalcty": "HARTSHORNE",
    "dropmalst": "OK",
    "dropmalzpp": 745479998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182972636,
    "dropsitcph": 9182972636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22131",
    "droptype": "D",
    "dropname": "HASKELL",
    "dropdeladd": "525 S BROADWAY AVE",
    "dropdelcty": "HASKELL",
    "dropdelst": "OK",
    "dropdelzpp": 744369998,
    "dropphyadd": "525 S BROADWAY AVE",
    "dropphycty": "HASKELL",
    "dropphyst": "OK",
    "dropphyzpp": 744369998,
    "dropmaladd": "525 S BROADWAY AVE",
    "dropmalcty": "HASKELL",
    "dropmalst": "OK",
    "dropmalzpp": 744369998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184823422,
    "dropsitcph": 9184823422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22132",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "HASTINGS",
    "dropdelst": "OK",
    "dropdelzpp": 735489998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "HASTINGS",
    "dropphyst": "OK",
    "dropphyzpp": 735489998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "HASTINGS",
    "dropmalst": "OK",
    "dropmalzpp": 735489998,
    "dropsitphn": 5809632961,
    "dropsitlph": 5809632961,
    "dropsitcph": 5809632961,
    "dropfax": 5809632961
  },
  {
    "dcode": "D",
    "dropkey": "PW22133",
    "droptype": "D",
    "dropname": "HAWORTH",
    "dropdeladd": "100 N ELM ST",
    "dropdelcty": "HAWORTH",
    "dropdelst": "OK",
    "dropdelzpp": 747409998,
    "dropphyadd": "100 N ELM ST",
    "dropphycty": "HAWORTH",
    "dropphyst": "OK",
    "dropphyzpp": 747409998,
    "dropmaladd": "100 N ELM ST",
    "dropmalcty": "HAWORTH",
    "dropmalst": "OK",
    "dropmalzpp": 747409998,
    "dropsitphn": 5802862149,
    "dropsitlph": 5802862149,
    "dropsitcph": 5802451992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22136",
    "droptype": "D",
    "dropname": "HEADRICK",
    "dropdeladd": "310 N BROADWAY ST",
    "dropdelcty": "HEADRICK",
    "dropdelst": "OK",
    "dropdelzpp": 735499998,
    "dropphyadd": "310 N BROADWAY ST",
    "dropphycty": "HEADRICK",
    "dropphyst": "OK",
    "dropphyzpp": 735499998,
    "dropmaladd": "310 N BROADWAY ST",
    "dropmalcty": "HEADRICK",
    "dropmalst": "OK",
    "dropmalzpp": 735499998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807385330,
    "dropsitcph": 5807385330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22137",
    "droptype": "D",
    "dropname": "HEALDTON",
    "dropdeladd": "186 FRANKLIN ST",
    "dropdelcty": "HEALDTON",
    "dropdelst": "OK",
    "dropdelzpp": 734389998,
    "dropphyadd": "186 FRANKLIN ST",
    "dropphycty": "HEALDTON",
    "dropphyst": "OK",
    "dropphyzpp": 734389998,
    "dropmaladd": "186 FRANKLIN ST",
    "dropmalcty": "HEALDTON",
    "dropmalst": "OK",
    "dropmalzpp": 734389998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802290450,
    "dropsitcph": 5802290450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22138",
    "droptype": "D",
    "dropname": "HEAVENER",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "HEAVENER",
    "dropdelst": "OK",
    "dropdelzpp": 749379998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "HEAVENER",
    "dropphyst": "OK",
    "dropphyzpp": 749379998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "HEAVENER",
    "dropmalst": "OK",
    "dropmalzpp": 749379998,
    "dropsitphn": 9186534873,
    "dropsitlph": 9186534873,
    "dropsitcph": 9186534873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22140",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "212 N MAIN ST",
    "dropdelcty": "HELENA",
    "dropdelst": "OK",
    "dropdelzpp": 737419998,
    "dropphyadd": "212 N MAIN ST",
    "dropphycty": "HELENA",
    "dropphyst": "OK",
    "dropphyzpp": 737419998,
    "dropmaladd": "212 N MAIN ST",
    "dropmalcty": "HELENA",
    "dropmalst": "OK",
    "dropmalzpp": 737419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808523269,
    "dropsitcph": 5808523269,
    "dropfax": 5808523269
  },
  {
    "dcode": "D",
    "dropkey": "PW22141",
    "droptype": "D",
    "dropname": "HENDRIX",
    "dropdeladd": "309 E MAIN ST",
    "dropdelcty": "HENDRIX",
    "dropdelst": "OK",
    "dropdelzpp": 747419998,
    "dropphyadd": "309 E MAIN ST",
    "dropphycty": "HENDRIX",
    "dropphyst": "OK",
    "dropphyzpp": 747419998,
    "dropmaladd": "309 E MAIN ST",
    "dropmalcty": "HENDRIX",
    "dropmalst": "OK",
    "dropmalzpp": 747419998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808382408,
    "dropsitcph": 5808382408,
    "dropfax": 5808382337
  },
  {
    "dcode": "D",
    "dropkey": "PW22142",
    "droptype": "D",
    "dropname": "HENNEPIN",
    "dropdeladd": "28240 HIGHWAY 7",
    "dropdelcty": "HENNEPIN",
    "dropdelst": "OK",
    "dropdelzpp": 734449998,
    "dropphyadd": "28240 HIGHWAY 7",
    "dropphycty": "HENNEPIN",
    "dropphyst": "OK",
    "dropphyzpp": 734449998,
    "dropmaladd": "28240 HIGHWAY 7",
    "dropmalcty": "HENNEPIN",
    "dropmalst": "OK",
    "dropmalzpp": 734449998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808683311,
    "dropsitcph": 5808683311,
    "dropfax": 5808683311
  },
  {
    "dcode": "D",
    "dropkey": "PW22143",
    "droptype": "D",
    "dropname": "HENNESSEY",
    "dropdeladd": "221 S MAIN ST",
    "dropdelcty": "HENNESSEY",
    "dropdelst": "OK",
    "dropdelzpp": 737429998,
    "dropphyadd": "221 S MAIN ST",
    "dropphycty": "HENNESSEY",
    "dropphyst": "OK",
    "dropphyzpp": 737429998,
    "dropmaladd": "221 S MAIN ST",
    "dropmalcty": "HENNESSEY",
    "dropmalst": "OK",
    "dropmalzpp": 737429998,
    "dropsitphn": 4058532928,
    "dropsitlph": 4058532928,
    "dropsitcph": 4058532928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22145",
    "droptype": "D",
    "dropname": "HENRYETTA",
    "dropdeladd": "201 N 5TH ST",
    "dropdelcty": "HENRYETTA",
    "dropdelst": "OK",
    "dropdelzpp": 744379998,
    "dropphyadd": "201 N 5TH ST",
    "dropphycty": "HENRYETTA",
    "dropphyst": "OK",
    "dropphyzpp": 744379998,
    "dropmaladd": "201 N 5TH ST",
    "dropmalcty": "HENRYETTA",
    "dropmalst": "OK",
    "dropmalzpp": 744379998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186527834,
    "dropsitcph": 9186527834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22148",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "OK",
    "dropdelzpp": 737439998,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "HILLSDALE",
    "dropphyst": "OK",
    "dropphyzpp": 737439998,
    "dropmaladd": "103 S MAIN ST",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "OK",
    "dropmalzpp": 737439998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806352331,
    "dropsitcph": 5806352331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22149",
    "droptype": "D",
    "dropname": "HINTON",
    "dropdeladd": "123 S NOBLE AVE",
    "dropdelcty": "HINTON",
    "dropdelst": "OK",
    "dropdelzpp": 730479998,
    "dropphyadd": "123 S NOBLE AVE",
    "dropphycty": "HINTON",
    "dropphyst": "OK",
    "dropphyzpp": 730479998,
    "dropmaladd": "123 S NOBLE AVE",
    "dropmalcty": "HINTON",
    "dropmalst": "OK",
    "dropmalzpp": 730479998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055423280,
    "dropsitcph": 4055423280,
    "dropfax": 4055423154
  },
  {
    "dcode": "D",
    "dropkey": "PW22150",
    "droptype": "D",
    "dropname": "HITCHCOCK",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "HITCHCOCK",
    "dropdelst": "OK",
    "dropdelzpp": 737449998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "HITCHCOCK",
    "dropphyst": "OK",
    "dropphyzpp": 737449998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "HITCHCOCK",
    "dropmalst": "OK",
    "dropmalzpp": 737449998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808253219,
    "dropsitcph": 5808253219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22151",
    "droptype": "D",
    "dropname": "HITCHITA",
    "dropdeladd": "1 BROADWAY ST",
    "dropdelcty": "HITCHITA",
    "dropdelst": "OK",
    "dropdelzpp": 744389998,
    "dropphyadd": "1 BROADWAY ST",
    "dropphycty": "HITCHITA",
    "dropphyst": "OK",
    "dropphyzpp": 744389998,
    "dropmaladd": "1 BROADWAY ST",
    "dropmalcty": "HITCHITA",
    "dropmalst": "OK",
    "dropmalzpp": 744389998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184663306,
    "dropsitcph": 9184663306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22152",
    "droptype": "D",
    "dropname": "HOBART",
    "dropdeladd": "229 S MAIN ST",
    "dropdelcty": "HOBART",
    "dropdelst": "OK",
    "dropdelzpp": 736519998,
    "dropphyadd": "229 S MAIN ST",
    "dropphycty": "HOBART",
    "dropphyst": "OK",
    "dropphyzpp": 736519998,
    "dropmaladd": "229 S MAIN ST",
    "dropmalcty": "HOBART",
    "dropmalst": "OK",
    "dropmalzpp": 736519998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807265258,
    "dropsitcph": 5807265258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22153",
    "droptype": "D",
    "dropname": "HODGEN",
    "dropdeladd": "47061 US HIGHWAY 59",
    "dropdelcty": "HODGEN",
    "dropdelst": "OK",
    "dropdelzpp": 749399998,
    "dropphyadd": "47061 US HIGHWAY 59",
    "dropphycty": "HODGEN",
    "dropphyst": "OK",
    "dropphyzpp": 749399998,
    "dropmaladd": "47061 US HIGHWAY 59",
    "dropmalcty": "HODGEN",
    "dropmalst": "OK",
    "dropmalzpp": 749399998,
    "dropsitphn": 9186532189,
    "dropsitlph": 9186532189,
    "dropsitcph": 9186532189,
    "dropfax": 9186532189
  },
  {
    "dcode": "D",
    "dropkey": "PW22156",
    "droptype": "D",
    "dropname": "HOLDENVILLE",
    "dropdeladd": "123 W 7TH ST",
    "dropdelcty": "HOLDENVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 748489998,
    "dropphyadd": "123 W 7TH ST",
    "dropphycty": "HOLDENVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 748489998,
    "dropmaladd": "123 W 7TH ST",
    "dropmalcty": "HOLDENVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 748489998,
    "dropsitphn": 4053795627,
    "dropsitlph": 4053795627,
    "dropsitcph": 4053795627,
    "dropfax": 4053796152
  },
  {
    "dcode": "D",
    "dropkey": "PW22157",
    "droptype": "D",
    "dropname": "HOLLIS",
    "dropdeladd": "120 N 2ND ST",
    "dropdelcty": "HOLLIS",
    "dropdelst": "OK",
    "dropdelzpp": 735509998,
    "dropphyadd": "120 N 2ND ST",
    "dropphycty": "HOLLIS",
    "dropphyst": "OK",
    "dropphyzpp": 735509998,
    "dropmaladd": "120 N 2ND ST",
    "dropmalcty": "HOLLIS",
    "dropmalst": "OK",
    "dropmalzpp": 735509998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806882366,
    "dropsitcph": 5806882366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22159",
    "droptype": "D",
    "dropname": "HOMINY",
    "dropdeladd": "402 W 1ST ST",
    "dropdelcty": "HOMINY",
    "dropdelst": "OK",
    "dropdelzpp": 740359998,
    "dropphyadd": "402 W 1ST ST",
    "dropphycty": "HOMINY",
    "dropphyst": "OK",
    "dropphyzpp": 740359998,
    "dropmaladd": "402 W 1ST ST",
    "dropmalcty": "HOMINY",
    "dropmalst": "OK",
    "dropmalzpp": 740359998,
    "dropsitphn": 9188852770,
    "dropsitlph": 9188852770,
    "dropsitcph": 9188852770,
    "dropfax": 9188854518
  },
  {
    "dcode": "D",
    "dropkey": "PW22161",
    "droptype": "D",
    "dropname": "HOOKER",
    "dropdeladd": "107 S SWEM ST",
    "dropdelcty": "HOOKER",
    "dropdelst": "OK",
    "dropdelzpp": 739459804,
    "dropphyadd": "107 S SWEM ST",
    "dropphycty": "HOOKER",
    "dropphyst": "OK",
    "dropphyzpp": 739459804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOOKER",
    "dropmalst": "OK",
    "dropmalzpp": 739459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5806522020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22162",
    "droptype": "D",
    "dropname": "HOPETON",
    "dropdeladd": "19405 COUNTY ROAD 440",
    "dropdelcty": "HOPETON",
    "dropdelst": "OK",
    "dropdelzpp": 737469998,
    "dropphyadd": "19405 COUNTY ROAD 440",
    "dropphycty": "HOPETON",
    "dropphyst": "OK",
    "dropphyzpp": 737469998,
    "dropmaladd": "19405 COUNTY ROAD 440",
    "dropmalcty": "HOPETON",
    "dropmalst": "OK",
    "dropmalzpp": 737469998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804352238,
    "dropsitcph": 5804352238,
    "dropfax": 5804352238
  },
  {
    "dcode": "D",
    "dropkey": "PW22163",
    "droptype": "D",
    "dropname": "HOWE",
    "dropdeladd": "21525 W MAIN ST",
    "dropdelcty": "HOWE",
    "dropdelst": "OK",
    "dropdelzpp": 749409998,
    "dropphyadd": "21525 W MAIN ST",
    "dropphycty": "HOWE",
    "dropphyst": "OK",
    "dropphyzpp": 749409998,
    "dropmaladd": "21525 W MAIN ST",
    "dropmalcty": "HOWE",
    "dropmalst": "OK",
    "dropmalzpp": 749409998,
    "dropsitphn": 5802862149,
    "dropsitlph": 9186534873,
    "dropsitcph": 5802862149,
    "dropfax": 9186583415
  },
  {
    "dcode": "D",
    "dropkey": "PW22165",
    "droptype": "D",
    "dropname": "HUGO",
    "dropdeladd": "207 N 4TH ST",
    "dropdelcty": "HUGO",
    "dropdelst": "OK",
    "dropdelzpp": 747439998,
    "dropphyadd": "207 N 4TH ST",
    "dropphycty": "HUGO",
    "dropphyst": "OK",
    "dropphyzpp": 747439998,
    "dropmaladd": "207 N 4TH ST",
    "dropmalcty": "HUGO",
    "dropmalst": "OK",
    "dropmalzpp": 747439998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803266696,
    "dropsitcph": 5803266696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22166",
    "droptype": "D",
    "dropname": "HULBERT",
    "dropdeladd": "402 E MAIN ST",
    "dropdelcty": "HULBERT",
    "dropdelst": "OK",
    "dropdelzpp": 744419998,
    "dropphyadd": "402 E MAIN ST",
    "dropphycty": "HULBERT",
    "dropphyst": "OK",
    "dropphyzpp": 744419998,
    "dropmaladd": "402 E MAIN ST",
    "dropmalcty": "HULBERT",
    "dropmalst": "OK",
    "dropmalzpp": 744419998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187722522,
    "dropsitcph": 9187722522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22167",
    "droptype": "D",
    "dropname": "HUNTER",
    "dropdeladd": "126 N MAINE ST",
    "dropdelcty": "HUNTER",
    "dropdelst": "OK",
    "dropdelzpp": 746409998,
    "dropphyadd": "126 N MAINE ST",
    "dropphycty": "HUNTER",
    "dropphyst": "OK",
    "dropphyzpp": 746409998,
    "dropmaladd": "126 N MAINE ST",
    "dropmalcty": "HUNTER",
    "dropmalst": "OK",
    "dropmalzpp": 746409998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5806847723,
    "dropsitcph": 5806847723,
    "dropfax": 5806847723
  },
  {
    "dcode": "D",
    "dropkey": "PW22168",
    "droptype": "D",
    "dropname": "HYDRO",
    "dropdeladd": "227 W MAIN ST",
    "dropdelcty": "HYDRO",
    "dropdelst": "OK",
    "dropdelzpp": 730489998,
    "dropphyadd": "227 W MAIN ST",
    "dropphycty": "HYDRO",
    "dropphyst": "OK",
    "dropphyzpp": 730489998,
    "dropmaladd": "227 W MAIN ST",
    "dropmalcty": "HYDRO",
    "dropmalst": "OK",
    "dropmalzpp": 730489998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4056632577,
    "dropsitcph": 4056632577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22169",
    "droptype": "D",
    "dropname": "IDABEL",
    "dropdeladd": "201 N CENTRAL AVE LBBY",
    "dropdelcty": "IDABEL",
    "dropdelst": "OK",
    "dropdelzpp": 747459998,
    "dropphyadd": "201 N CENTRAL AVE LBBY",
    "dropphycty": "IDABEL",
    "dropphyst": "OK",
    "dropphyzpp": 747459998,
    "dropmaladd": "201 N CENTRAL AVE LBBY",
    "dropmalcty": "IDABEL",
    "dropmalst": "OK",
    "dropmalzpp": 747459998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802862149,
    "dropsitcph": 5802862149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22170",
    "droptype": "D",
    "dropname": "INDIAHOMA",
    "dropdeladd": "308 MAIN ST",
    "dropdelcty": "INDIAHOMA",
    "dropdelst": "OK",
    "dropdelzpp": 735529998,
    "dropphyadd": "308 MAIN ST",
    "dropphycty": "INDIAHOMA",
    "dropphyst": "OK",
    "dropphyzpp": 735529998,
    "dropmaladd": "308 MAIN ST",
    "dropmalcty": "INDIAHOMA",
    "dropmalst": "OK",
    "dropmalzpp": 735529998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802463351,
    "dropsitcph": 5802463351,
    "dropfax": 5802463351
  },
  {
    "dcode": "D",
    "dropkey": "PW22171",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "OK",
    "dropdelzpp": 744429998,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "INDIANOLA",
    "dropphyst": "OK",
    "dropphyzpp": 744429998,
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "OK",
    "dropmalzpp": 744429998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188234514,
    "dropsitcph": 9188234514,
    "dropfax": 9188234514
  },
  {
    "dcode": "D",
    "dropkey": "PW22172",
    "droptype": "D",
    "dropname": "INOLA",
    "dropdeladd": "25 2ND ST SW",
    "dropdelcty": "INOLA",
    "dropdelst": "OK",
    "dropdelzpp": 740369998,
    "dropphyadd": "25 2ND ST SW",
    "dropphycty": "INOLA",
    "dropphyst": "OK",
    "dropphyzpp": 740369998,
    "dropmaladd": "25 2ND ST SW",
    "dropmalcty": "INOLA",
    "dropmalst": "OK",
    "dropmalzpp": 740369998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185434923,
    "dropsitcph": 9185434972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22173",
    "droptype": "D",
    "dropname": "ISABELLA",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "ISABELLA",
    "dropdelst": "OK",
    "dropdelzpp": 737479998,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "ISABELLA",
    "dropphyst": "OK",
    "dropphyzpp": 737479998,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "ISABELLA",
    "dropmalst": "OK",
    "dropmalzpp": 737479998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808223492,
    "dropsitcph": 5808223492,
    "dropfax": 5808223492
  },
  {
    "dcode": "D",
    "dropkey": "PW22174",
    "droptype": "D",
    "dropname": "JAY",
    "dropdeladd": "409 S 6TH ST",
    "dropdelcty": "JAY",
    "dropdelst": "OK",
    "dropdelzpp": 743469998,
    "dropphyadd": "409 S 6TH ST",
    "dropphycty": "JAY",
    "dropphyst": "OK",
    "dropphyzpp": 743469998,
    "dropmaladd": "409 S 6TH ST",
    "dropmalcty": "JAY",
    "dropmalst": "OK",
    "dropmalzpp": 743469998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182534988,
    "dropsitcph": 9182534988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22175",
    "droptype": "D",
    "dropname": "JENKS",
    "dropdeladd": "303 E A ST",
    "dropdelcty": "JENKS",
    "dropdelst": "OK",
    "dropdelzpp": 740379998,
    "dropphyadd": "303 E A ST",
    "dropphycty": "JENKS",
    "dropphyst": "OK",
    "dropphyzpp": 740379998,
    "dropmaladd": "303 E A ST",
    "dropmalcty": "JENKS",
    "dropmalst": "OK",
    "dropmalzpp": 740379998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182983193,
    "dropsitcph": 9182983193,
    "dropfax": 4052963751
  },
  {
    "dcode": "D",
    "dropkey": "PW22176",
    "droptype": "D",
    "dropname": "JENNINGS",
    "dropdeladd": "718 N MAIN ST",
    "dropdelcty": "JENNINGS",
    "dropdelst": "OK",
    "dropdelzpp": 740389998,
    "dropphyadd": "718 N MAIN ST",
    "dropphycty": "JENNINGS",
    "dropphyst": "OK",
    "dropphyzpp": 740389998,
    "dropmaladd": "718 N MAIN ST",
    "dropmalcty": "JENNINGS",
    "dropmalst": "OK",
    "dropmalzpp": 740389998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187572296,
    "dropsitcph": 9187572296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22177",
    "droptype": "D",
    "dropname": "JET",
    "dropdeladd": "418 MAIN ST",
    "dropdelcty": "JET",
    "dropdelst": "OK",
    "dropdelzpp": 737499998,
    "dropphyadd": "418 MAIN ST",
    "dropphycty": "JET",
    "dropphyst": "OK",
    "dropphyzpp": 737499998,
    "dropmaladd": "418 MAIN ST",
    "dropmalcty": "JET",
    "dropmalst": "OK",
    "dropmalzpp": 737499998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806264567,
    "dropsitcph": 5806264567,
    "dropfax": 5806264567
  },
  {
    "dcode": "D",
    "dropkey": "PW22179",
    "droptype": "D",
    "dropname": "JONES",
    "dropdeladd": "120 E MAIN ST",
    "dropdelcty": "JONES",
    "dropdelst": "OK",
    "dropdelzpp": 730499998,
    "dropphyadd": "120 E MAIN ST",
    "dropphycty": "JONES",
    "dropphyst": "OK",
    "dropphyzpp": 730499998,
    "dropmaladd": "120 E MAIN ST",
    "dropmalcty": "JONES",
    "dropmalst": "OK",
    "dropmalzpp": 730499998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053994724,
    "dropsitcph": 4053994724,
    "dropfax": 4053992869
  },
  {
    "dcode": "D",
    "dropkey": "PW22180",
    "droptype": "D",
    "dropname": "KANSAS",
    "dropdeladd": "491 W MAIN ST",
    "dropdelcty": "KANSAS",
    "dropdelst": "OK",
    "dropdelzpp": 743479998,
    "dropphyadd": "491 W MAIN ST",
    "dropphycty": "KANSAS",
    "dropphyst": "OK",
    "dropphyzpp": 743479998,
    "dropmaladd": "491 W MAIN ST",
    "dropmalcty": "KANSAS",
    "dropmalst": "OK",
    "dropmalzpp": 743479998,
    "dropsitphn": 9188682759,
    "dropsitlph": 9188682759,
    "dropsitcph": 9188682759,
    "dropfax": 9188682806
  },
  {
    "dcode": "D",
    "dropkey": "PW22183",
    "droptype": "D",
    "dropname": "KAW CITY",
    "dropdeladd": "701 MORGAN SQ",
    "dropdelcty": "KAW CITY",
    "dropdelst": "OK",
    "dropdelzpp": 746419998,
    "dropphyadd": "701 MORGAN SQ",
    "dropphycty": "KAW CITY",
    "dropphyst": "OK",
    "dropphyzpp": 746419998,
    "dropmaladd": "701 MORGAN SQ",
    "dropmalcty": "KAW CITY",
    "dropmalst": "OK",
    "dropmalzpp": 746419998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802692914,
    "dropsitcph": 5802692914,
    "dropfax": 5802692914
  },
  {
    "dcode": "D",
    "dropkey": "PW22185",
    "droptype": "D",
    "dropname": "KELLYVILLE",
    "dropdeladd": "218 E BUFFALO ST",
    "dropdelcty": "KELLYVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 740399998,
    "dropphyadd": "218 E BUFFALO ST",
    "dropphycty": "KELLYVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 740399998,
    "dropmaladd": "218 E BUFFALO ST",
    "dropmalcty": "KELLYVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 740399998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182476344,
    "dropsitcph": 9182476344,
    "dropfax": 9182476344
  },
  {
    "dcode": "D",
    "dropkey": "PW22188",
    "droptype": "D",
    "dropname": "KENEFIC",
    "dropdeladd": "117 MARY ST",
    "dropdelcty": "KENEFIC",
    "dropdelst": "OK",
    "dropdelzpp": 747489998,
    "dropphyadd": "117 MARY ST",
    "dropphycty": "KENEFIC",
    "dropphyst": "OK",
    "dropphyzpp": 747489998,
    "dropmaladd": "117 MARY ST",
    "dropmalcty": "KENEFIC",
    "dropmalst": "OK",
    "dropmalzpp": 747489998,
    "dropsitphn": 5803672428,
    "dropsitlph": 5803672428,
    "dropsitcph": 5803672428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22189",
    "droptype": "D",
    "dropname": "KENTON",
    "dropdeladd": "100 NEWBERT",
    "dropdelcty": "KENTON",
    "dropdelst": "OK",
    "dropdelzpp": 739469802,
    "dropphyadd": "100 NEWBERT",
    "dropphycty": "KENTON",
    "dropphyst": "OK",
    "dropphyzpp": 739469802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENTON",
    "dropmalst": "OK",
    "dropmalzpp": 739469998,
    "dropsitphn": 8173173658,
    "dropsitlph": 5802617474,
    "dropsitcph": 5802617474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22190",
    "droptype": "D",
    "dropname": "KEOTA",
    "dropdeladd": "307 SW MAIN ST",
    "dropdelcty": "KEOTA",
    "dropdelst": "OK",
    "dropdelzpp": 749419998,
    "dropphyadd": "307 SW MAIN ST",
    "dropphycty": "KEOTA",
    "dropphyst": "OK",
    "dropphyzpp": 749419998,
    "dropmaladd": "307 SW MAIN ST",
    "dropmalcty": "KEOTA",
    "dropmalst": "OK",
    "dropmalzpp": 749419998,
    "dropsitphn": 9182650215,
    "dropsitlph": 9182650215,
    "dropsitcph": 9182650215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22191",
    "droptype": "D",
    "dropname": "KETCHUM",
    "dropdeladd": "300 N MAIN ST",
    "dropdelcty": "KETCHUM",
    "dropdelst": "OK",
    "dropdelzpp": 743499998,
    "dropphyadd": "300 N MAIN ST",
    "dropphycty": "KETCHUM",
    "dropphyst": "OK",
    "dropphyzpp": 743499998,
    "dropmaladd": "300 N MAIN ST",
    "dropmalcty": "KETCHUM",
    "dropmalst": "OK",
    "dropmalzpp": 743499998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187822160,
    "dropsitcph": 9187822160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22192",
    "droptype": "D",
    "dropname": "KEYES",
    "dropdeladd": "513 POLK AVE",
    "dropdelcty": "KEYES",
    "dropdelst": "OK",
    "dropdelzpp": 739479800,
    "dropphyadd": "513 POLK AVE",
    "dropphycty": "KEYES",
    "dropphyst": "OK",
    "dropphyzpp": 739479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEYES",
    "dropmalst": "OK",
    "dropmalzpp": 739479998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5805467331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22193",
    "droptype": "D",
    "dropname": "KIEFER",
    "dropdeladd": "417 E INDIANA",
    "dropdelcty": "KIEFER",
    "dropdelst": "OK",
    "dropdelzpp": 740419998,
    "dropphyadd": "417 E INDIANA",
    "dropphycty": "KIEFER",
    "dropphyst": "OK",
    "dropphyzpp": 740419998,
    "dropmaladd": "417 E INDIANA",
    "dropmalcty": "KIEFER",
    "dropmalst": "OK",
    "dropmalzpp": 740419998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183219509,
    "dropsitcph": 9183219509,
    "dropfax": 9183219509
  },
  {
    "dcode": "D",
    "dropkey": "PW22194",
    "droptype": "D",
    "dropname": "KINGFISHER",
    "dropdeladd": "214 S MAIN ST",
    "dropdelcty": "KINGFISHER",
    "dropdelst": "OK",
    "dropdelzpp": 737509998,
    "dropphyadd": "214 S MAIN ST",
    "dropphycty": "KINGFISHER",
    "dropphyst": "OK",
    "dropphyzpp": 737509998,
    "dropmaladd": "214 S MAIN ST",
    "dropmalcty": "KINGFISHER",
    "dropmalst": "OK",
    "dropmalzpp": 737509998,
    "dropsitphn": 4053756686,
    "dropsitlph": 4053756686,
    "dropsitcph": 4053756686,
    "dropfax": 4053754234
  },
  {
    "dcode": "D",
    "dropkey": "PW22195",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "OK",
    "dropdelzpp": 734399998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "OK",
    "dropphyzpp": 734399998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "OK",
    "dropmalzpp": 734399998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805643325,
    "dropsitcph": 5805643325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22196",
    "droptype": "D",
    "dropname": "KINTA",
    "dropdeladd": "301 W BROADWAY ST",
    "dropdelcty": "KINTA",
    "dropdelst": "OK",
    "dropdelzpp": 745529998,
    "dropphyadd": "301 W BROADWAY ST",
    "dropphycty": "KINTA",
    "dropphyst": "OK",
    "dropphyzpp": 745529998,
    "dropmaladd": "301 W BROADWAY ST",
    "dropmalcty": "KINTA",
    "dropmalst": "OK",
    "dropmalzpp": 745529998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184692686,
    "dropsitcph": 9187683554,
    "dropfax": 9187683554
  },
  {
    "dcode": "D",
    "dropkey": "PW22197",
    "droptype": "D",
    "dropname": "KIOWA",
    "dropdeladd": "824 S HARRISON ST",
    "dropdelcty": "KIOWA",
    "dropdelst": "OK",
    "dropdelzpp": 745539998,
    "dropphyadd": "824 S HARRISON ST",
    "dropphycty": "KIOWA",
    "dropphyst": "OK",
    "dropphyzpp": 745539998,
    "dropmaladd": "824 S HARRISON ST",
    "dropmalcty": "KIOWA",
    "dropmalst": "OK",
    "dropmalzpp": 745539998,
    "dropsitphn": 9182476344,
    "dropsitlph": 9184325441,
    "dropsitcph": 9184325441,
    "dropfax": 9184325441
  },
  {
    "dcode": "D",
    "dropkey": "PW22199",
    "droptype": "D",
    "dropname": "KONAWA",
    "dropdeladd": "100 S BROADWAY ST",
    "dropdelcty": "KONAWA",
    "dropdelst": "OK",
    "dropdelzpp": 748499998,
    "dropphyadd": "100 S BROADWAY ST",
    "dropphycty": "KONAWA",
    "dropphyst": "OK",
    "dropphyzpp": 748499998,
    "dropmaladd": "100 S BROADWAY ST",
    "dropmalcty": "KONAWA",
    "dropmalst": "OK",
    "dropmalzpp": 748499998,
    "dropsitphn": 5809253656,
    "dropsitlph": 5809253656,
    "dropsitcph": 5809253656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22200",
    "droptype": "D",
    "dropname": "KREBS",
    "dropdeladd": "40 S MAIN ST",
    "dropdelcty": "KREBS",
    "dropdelst": "OK",
    "dropdelzpp": 745549998,
    "dropphyadd": "40 S MAIN ST",
    "dropphycty": "KREBS",
    "dropphyst": "OK",
    "dropphyzpp": 745549998,
    "dropmaladd": "40 S MAIN ST",
    "dropmalcty": "KREBS",
    "dropmalst": "OK",
    "dropmalzpp": 745549998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184236044,
    "dropsitcph": 9184236044,
    "dropfax": 9184236044
  },
  {
    "dcode": "D",
    "dropkey": "PW22201",
    "droptype": "D",
    "dropname": "KREMLIN",
    "dropdeladd": "3415 E KEOWEE RD",
    "dropdelcty": "KREMLIN",
    "dropdelst": "OK",
    "dropdelzpp": 737539998,
    "dropphyadd": "3415 E KEOWEE RD",
    "dropphycty": "KREMLIN",
    "dropphyst": "OK",
    "dropphyzpp": 737539998,
    "dropmaladd": "3415 E KEOWEE RD",
    "dropmalcty": "KREMLIN",
    "dropmalst": "OK",
    "dropmalzpp": 737539998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808742228,
    "dropsitcph": 5808742228,
    "dropfax": 5808742228
  },
  {
    "dcode": "D",
    "dropkey": "PW22204",
    "droptype": "D",
    "dropname": "LAHOMA",
    "dropdeladd": "535 MAIN ST",
    "dropdelcty": "LAHOMA",
    "dropdelst": "OK",
    "dropdelzpp": 737549998,
    "dropphyadd": "535 MAIN ST",
    "dropphycty": "LAHOMA",
    "dropphyst": "OK",
    "dropphyzpp": 737549998,
    "dropmaladd": "535 MAIN ST",
    "dropmalcty": "LAHOMA",
    "dropmalst": "OK",
    "dropmalzpp": 737549998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807962290,
    "dropsitcph": 5807962290,
    "dropfax": 5807962290
  },
  {
    "dcode": "D",
    "dropkey": "PW22206",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "LAMONT",
    "dropdelst": "OK",
    "dropdelzpp": 746439998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "LAMONT",
    "dropphyst": "OK",
    "dropphyzpp": 746439998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "LAMONT",
    "dropmalst": "OK",
    "dropmalzpp": 746439998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803886698,
    "dropsitcph": 5803886698,
    "dropfax": 5803886698
  },
  {
    "dcode": "D",
    "dropkey": "PW22207",
    "droptype": "D",
    "dropname": "LANE",
    "dropdeladd": "11820 E HIGHWAY 3",
    "dropdelcty": "LANE",
    "dropdelst": "OK",
    "dropdelzpp": 745559998,
    "dropphyadd": "11820 E HIGHWAY 3",
    "dropphycty": "LANE",
    "dropphyst": "OK",
    "dropphyzpp": 745559998,
    "dropmaladd": "11820 E HIGHWAY 3",
    "dropmalcty": "LANE",
    "dropmalst": "OK",
    "dropmalzpp": 745559998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808893861,
    "dropsitcph": 5808893861,
    "dropfax": 5808893861
  },
  {
    "dcode": "D",
    "dropkey": "PW22208",
    "droptype": "D",
    "dropname": "LANGLEY",
    "dropdeladd": "123 S THIRD ST",
    "dropdelcty": "LANGLEY",
    "dropdelst": "OK",
    "dropdelzpp": 743509998,
    "dropphyadd": "123 S THIRD ST",
    "dropphycty": "LANGLEY",
    "dropphyst": "OK",
    "dropphyzpp": 743509998,
    "dropmaladd": "123 S THIRD ST",
    "dropmalcty": "LANGLEY",
    "dropmalst": "OK",
    "dropmalzpp": 743509998,
    "dropsitphn": 9187829383,
    "dropsitlph": 9187829383,
    "dropsitcph": 9187829383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22209",
    "droptype": "D",
    "dropname": "LANGSTON",
    "dropdeladd": "100 WILEY JONES ST",
    "dropdelcty": "LANGSTON",
    "dropdelst": "OK",
    "dropdelzpp": 730509998,
    "dropphyadd": "100 WILEY JONES ST",
    "dropphycty": "LANGSTON",
    "dropphyst": "OK",
    "dropphyzpp": 730509998,
    "dropmaladd": "100 WILEY JONES ST",
    "dropmalcty": "LANGSTON",
    "dropmalst": "OK",
    "dropmalzpp": 730509998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054662106,
    "dropsitcph": 4054662106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22210",
    "droptype": "D",
    "dropname": "LAVERNE",
    "dropdeladd": "206 W JANE JAYROE BLVD",
    "dropdelcty": "LAVERNE",
    "dropdelst": "OK",
    "dropdelzpp": 738489998,
    "dropphyadd": "206 W JANE JAYROE BLVD",
    "dropphycty": "LAVERNE",
    "dropphyst": "OK",
    "dropphyzpp": 738489998,
    "dropmaladd": "206 W JANE JAYROE BLVD",
    "dropmalcty": "LAVERNE",
    "dropmalst": "OK",
    "dropmalzpp": 738489998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809215522,
    "dropsitcph": 5809215522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22212",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "501 SW 5TH ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "OK",
    "dropdelzpp": 735019998,
    "dropphyadd": "501 SW 5TH ST",
    "dropphycty": "LAWTON",
    "dropphyst": "OK",
    "dropphyzpp": 735019998,
    "dropmaladd": "501 SW 5TH ST",
    "dropmalcty": "LAWTON",
    "dropmalst": "OK",
    "dropmalzpp": 735019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803531500,
    "dropsitcph": 5803531500,
    "dropfax": 5803534082
  },
  {
    "dcode": "D",
    "dropkey": "PW22213",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "21601 HIGHWAY 32",
    "dropdelcty": "LEBANON",
    "dropdelst": "OK",
    "dropdelzpp": 734409998,
    "dropphyadd": "21601 HIGHWAY 32",
    "dropphycty": "LEBANON",
    "dropphyst": "OK",
    "dropphyzpp": 734409998,
    "dropmaladd": "21601 HIGHWAY 32",
    "dropmalcty": "LEBANON",
    "dropmalst": "OK",
    "dropmalzpp": 734409998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807952935,
    "dropsitcph": 5807952935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22214",
    "droptype": "D",
    "dropname": "LEEDEY",
    "dropdeladd": "515 S MAIN ST",
    "dropdelcty": "LEEDEY",
    "dropdelst": "OK",
    "dropdelzpp": 736549998,
    "dropphyadd": "515 S MAIN ST",
    "dropphycty": "LEEDEY",
    "dropphyst": "OK",
    "dropphyzpp": 736549998,
    "dropmaladd": "515 S MAIN ST",
    "dropmalcty": "LEEDEY",
    "dropmalst": "OK",
    "dropmalzpp": 736549998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804882925,
    "dropsitcph": 5804882925,
    "dropfax": 5804882925
  },
  {
    "dcode": "D",
    "dropkey": "PW22215",
    "droptype": "D",
    "dropname": "LEFLORE",
    "dropdeladd": "41165 E STATE ST",
    "dropdelcty": "LEFLORE",
    "dropdelst": "OK",
    "dropdelzpp": 749429998,
    "dropphyadd": "41165 E STATE ST",
    "dropphycty": "LEFLORE",
    "dropphyst": "OK",
    "dropphyzpp": 749429998,
    "dropmaladd": "41165 E STATE ST",
    "dropmalcty": "LEFLORE",
    "dropmalst": "OK",
    "dropmalzpp": 749429998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187532383,
    "dropsitcph": 9187532383,
    "dropfax": 9187532383
  },
  {
    "dcode": "D",
    "dropkey": "PW22216",
    "droptype": "D",
    "dropname": "LEHIGH",
    "dropdeladd": "105 N HIGHWAY 75",
    "dropdelcty": "LEHIGH",
    "dropdelst": "OK",
    "dropdelzpp": 745569998,
    "dropphyadd": "105 N HIGHWAY 75",
    "dropphycty": "LEHIGH",
    "dropphyst": "OK",
    "dropphyzpp": 745569998,
    "dropmaladd": "105 N HIGHWAY 75",
    "dropmalcty": "LEHIGH",
    "dropmalst": "OK",
    "dropmalzpp": 745569998,
    "dropsitphn": 5809272424,
    "dropsitlph": 5809272424,
    "dropsitcph": 5809272424,
    "dropfax": 5809272424
  },
  {
    "dcode": "D",
    "dropkey": "PW22218",
    "droptype": "D",
    "dropname": "LENAPAH",
    "dropdeladd": "400 SHAWNEE",
    "dropdelcty": "LENAPAH",
    "dropdelst": "OK",
    "dropdelzpp": 740429998,
    "dropphyadd": "400 SHAWNEE",
    "dropphycty": "LENAPAH",
    "dropphyst": "OK",
    "dropphyzpp": 740429998,
    "dropmaladd": "400 SHAWNEE",
    "dropmalcty": "LENAPAH",
    "dropmalst": "OK",
    "dropmalzpp": 740429998,
    "dropsitphn": 9122707512,
    "dropsitlph": 9184682470,
    "dropsitcph": 9184682470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22219",
    "droptype": "D",
    "dropname": "LEON",
    "dropdeladd": "27339 EASTRIDGE ST",
    "dropdelcty": "LEON",
    "dropdelst": "OK",
    "dropdelzpp": 734419998,
    "dropphyadd": "27339 EASTRIDGE ST",
    "dropphycty": "LEON",
    "dropphyst": "OK",
    "dropphyzpp": 734419998,
    "dropmaladd": "27339 EASTRIDGE ST",
    "dropmalcty": "LEON",
    "dropmalst": "OK",
    "dropmalzpp": 734419998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802765646,
    "dropsitcph": 5802765646,
    "dropfax": 5802765646
  },
  {
    "dcode": "D",
    "dropkey": "PW22221",
    "droptype": "D",
    "dropname": "LEQUIRE",
    "dropdeladd": "104 W FRONT ST",
    "dropdelcty": "LEQUIRE",
    "dropdelst": "OK",
    "dropdelzpp": 749439998,
    "dropphyadd": "104 W FRONT ST",
    "dropphycty": "LEQUIRE",
    "dropphyst": "OK",
    "dropphyzpp": 749439998,
    "dropmaladd": "104 W FRONT ST",
    "dropmalcty": "LEQUIRE",
    "dropmalst": "OK",
    "dropmalzpp": 749439998,
    "dropsitphn": 9189674201,
    "dropsitlph": 9189674201,
    "dropsitcph": 9189674201,
    "dropfax": 9189674201
  },
  {
    "dcode": "D",
    "dropkey": "PW22222",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "115 NE 2ND ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 730519998,
    "dropphyadd": "115 NE 2ND ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 730519998,
    "dropmaladd": "115 NE 2ND ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 730519998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055272003,
    "dropsitcph": 4055272003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22224",
    "droptype": "D",
    "dropname": "LINDSAY",
    "dropdeladd": "426 S MAIN ST",
    "dropdelcty": "LINDSAY",
    "dropdelst": "OK",
    "dropdelzpp": 730529998,
    "dropphyadd": "426 S MAIN ST",
    "dropphycty": "LINDSAY",
    "dropphyst": "OK",
    "dropphyzpp": 730529998,
    "dropmaladd": "426 S MAIN ST",
    "dropmalcty": "LINDSAY",
    "dropmalst": "OK",
    "dropmalzpp": 730529998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057562239,
    "dropsitcph": 4057562239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22225",
    "droptype": "D",
    "dropname": "LOCO",
    "dropdeladd": "308 2ND ST",
    "dropdelcty": "LOCO",
    "dropdelst": "OK",
    "dropdelzpp": 734429998,
    "dropphyadd": "308 2ND ST",
    "dropphycty": "LOCO",
    "dropphyst": "OK",
    "dropphyzpp": 734429998,
    "dropmaladd": "308 2ND ST",
    "dropmalcty": "LOCO",
    "dropmalst": "OK",
    "dropmalzpp": 734429998,
    "dropsitphn": 5805372382,
    "dropsitlph": 5805372382,
    "dropsitcph": 5805372382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22226",
    "droptype": "D",
    "dropname": "LOCUST GROVE",
    "dropdeladd": "700 ELORA ST",
    "dropdelcty": "LOCUST GROVE",
    "dropdelst": "OK",
    "dropdelzpp": 743529998,
    "dropphyadd": "700 ELORA ST",
    "dropphycty": "LOCUST GROVE",
    "dropphyst": "OK",
    "dropphyzpp": 743529998,
    "dropmaladd": "700 ELORA ST",
    "dropmalcty": "LOCUST GROVE",
    "dropmalst": "OK",
    "dropmalzpp": 743529998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184795693,
    "dropsitcph": 9184795693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22228",
    "droptype": "D",
    "dropname": "LONE GROVE",
    "dropdeladd": "25 HERITAGE ST",
    "dropdelcty": "LONE GROVE",
    "dropdelst": "OK",
    "dropdelzpp": 734439998,
    "dropphyadd": "25 HERITAGE ST",
    "dropphycty": "LONE GROVE",
    "dropphyst": "OK",
    "dropphyzpp": 734439998,
    "dropmaladd": "25 HERITAGE ST",
    "dropmalcty": "LONE GROVE",
    "dropmalst": "OK",
    "dropmalzpp": 734439998,
    "dropsitphn": 5806574730,
    "dropsitlph": 5806574730,
    "dropsitcph": 5806574730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22229",
    "droptype": "D",
    "dropname": "LONE WOLF",
    "dropdeladd": "1024 MAIN ST",
    "dropdelcty": "LONE WOLF",
    "dropdelst": "OK",
    "dropdelzpp": 736559998,
    "dropphyadd": "1024 MAIN ST",
    "dropphycty": "LONE WOLF",
    "dropphyst": "OK",
    "dropphyzpp": 736559998,
    "dropmaladd": "1024 MAIN ST",
    "dropmalcty": "LONE WOLF",
    "dropmalst": "OK",
    "dropmalzpp": 736559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808465530,
    "dropsitcph": 5808465530,
    "dropfax": 5808465530
  },
  {
    "dcode": "D",
    "dropkey": "PW22230",
    "droptype": "D",
    "dropname": "LONGDALE",
    "dropdeladd": "501 KEN MILLER BLVD",
    "dropdelcty": "LONGDALE",
    "dropdelst": "OK",
    "dropdelzpp": 737559998,
    "dropphyadd": "501 KEN MILLER BLVD",
    "dropphycty": "LONGDALE",
    "dropphyst": "OK",
    "dropphyzpp": 737559998,
    "dropmaladd": "501 KEN MILLER BLVD",
    "dropmalcty": "LONGDALE",
    "dropmalst": "OK",
    "dropmalzpp": 737559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802743240,
    "dropsitcph": 5802743240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22231",
    "droptype": "D",
    "dropname": "LOOKEBA",
    "dropdeladd": "203 W WICHITA AVE",
    "dropdelcty": "LOOKEBA",
    "dropdelst": "OK",
    "dropdelzpp": 730539998,
    "dropphyadd": "203 W WICHITA AVE",
    "dropphycty": "LOOKEBA",
    "dropphyst": "OK",
    "dropphyzpp": 730539998,
    "dropmaladd": "203 W WICHITA AVE",
    "dropmalcty": "LOOKEBA",
    "dropmalst": "OK",
    "dropmalzpp": 730539998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054576651,
    "dropsitcph": 4054576651,
    "dropfax": 4054576651
  },
  {
    "dcode": "D",
    "dropkey": "PW22234",
    "droptype": "D",
    "dropname": "LOYAL",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "LOYAL",
    "dropdelst": "OK",
    "dropdelzpp": 737569998,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "LOYAL",
    "dropphyst": "OK",
    "dropphyzpp": 737569998,
    "dropmaladd": "119 MAIN ST",
    "dropmalcty": "LOYAL",
    "dropmalst": "OK",
    "dropmalzpp": 737569998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057294290,
    "dropsitcph": 4057294290,
    "dropfax": 4057294290
  },
  {
    "dcode": "D",
    "dropkey": "PW22236",
    "droptype": "D",
    "dropname": "LUTHER",
    "dropdeladd": "506 S ASH ST",
    "dropdelcty": "LUTHER",
    "dropdelst": "OK",
    "dropdelzpp": 730549998,
    "dropphyadd": "506 S ASH ST",
    "dropphycty": "LUTHER",
    "dropphyst": "OK",
    "dropphyzpp": 730549998,
    "dropmaladd": "506 S ASH ST",
    "dropmalcty": "LUTHER",
    "dropmalst": "OK",
    "dropmalzpp": 730549998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052773292,
    "dropsitcph": 4052773292,
    "dropfax": 4052772163
  },
  {
    "dcode": "D",
    "dropkey": "PW22237",
    "droptype": "D",
    "dropname": "MACOMB",
    "dropdeladd": "36654 SECOND ST",
    "dropdelcty": "MACOMB",
    "dropdelst": "OK",
    "dropdelzpp": 748529998,
    "dropphyadd": "36654 SECOND ST",
    "dropphycty": "MACOMB",
    "dropphyst": "OK",
    "dropphyzpp": 748529998,
    "dropmaladd": "36654 SECOND ST",
    "dropmalcty": "MACOMB",
    "dropmalst": "OK",
    "dropmalzpp": 748529998,
    "dropsitphn": 4055987295,
    "dropsitlph": 4055987295,
    "dropsitcph": 4055987295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22238",
    "droptype": "D",
    "dropname": "MADILL",
    "dropdeladd": "223 W LILLIE BLVD",
    "dropdelcty": "MADILL",
    "dropdelst": "OK",
    "dropdelzpp": 734469998,
    "dropphyadd": "223 W LILLIE BLVD",
    "dropphycty": "MADILL",
    "dropphyst": "OK",
    "dropphyzpp": 734469998,
    "dropmaladd": "223 W LILLIE BLVD",
    "dropmalcty": "MADILL",
    "dropmalst": "OK",
    "dropmalzpp": 734469998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807952212,
    "dropsitcph": 5807952212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22241",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "1561 MAIN ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "OK",
    "dropdelzpp": 737589998,
    "dropphyadd": "1561 MAIN ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "OK",
    "dropphyzpp": 737589998,
    "dropmaladd": "1561 MAIN ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "OK",
    "dropmalzpp": 737589998,
    "dropsitphn": 5806942319,
    "dropsitlph": 5806942319,
    "dropsitcph": 5806942319,
    "dropfax": 5806942318
  },
  {
    "dcode": "D",
    "dropkey": "PW22242",
    "droptype": "D",
    "dropname": "MANGUM",
    "dropdeladd": "101 S PENNSYLVANIA AVE",
    "dropdelcty": "MANGUM",
    "dropdelst": "OK",
    "dropdelzpp": 735549998,
    "dropphyadd": "101 S PENNSYLVANIA AVE",
    "dropphycty": "MANGUM",
    "dropphyst": "OK",
    "dropphyzpp": 735549998,
    "dropmaladd": "101 S PENNSYLVANIA AVE",
    "dropmalcty": "MANGUM",
    "dropmalst": "OK",
    "dropmalzpp": 735549998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807822306,
    "dropsitcph": 5807822306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22243",
    "droptype": "D",
    "dropname": "MANITOU",
    "dropdeladd": "300 HIGHWAY 183",
    "dropdelcty": "MANITOU",
    "dropdelst": "OK",
    "dropdelzpp": 735559998,
    "dropphyadd": "300 HIGHWAY 183",
    "dropphycty": "MANITOU",
    "dropphyst": "OK",
    "dropphyzpp": 735559998,
    "dropmaladd": "300 HIGHWAY 183",
    "dropmalcty": "MANITOU",
    "dropmalst": "OK",
    "dropmalzpp": 735559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803972451,
    "dropsitcph": 5803972451,
    "dropfax": 5803972209
  },
  {
    "dcode": "D",
    "dropkey": "PW22244",
    "droptype": "D",
    "dropname": "MANNFORD",
    "dropdeladd": "165 COONROD AVE",
    "dropdelcty": "MANNFORD",
    "dropdelst": "OK",
    "dropdelzpp": 740449998,
    "dropphyadd": "165 COONROD AVE",
    "dropphycty": "MANNFORD",
    "dropphyst": "OK",
    "dropphyzpp": 740449998,
    "dropmaladd": "165 COONROD AVE",
    "dropmalcty": "MANNFORD",
    "dropmalst": "OK",
    "dropmalzpp": 740449998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188654087,
    "dropsitcph": 9188654087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22245",
    "droptype": "D",
    "dropname": "MANNSVILLE",
    "dropdeladd": "101 N 20TH ST",
    "dropdelcty": "MANNSVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 734479998,
    "dropphyadd": "101 N 20TH ST",
    "dropphycty": "MANNSVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 734479998,
    "dropmaladd": "101 N 20TH ST",
    "dropmalcty": "MANNSVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 734479998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803712024,
    "dropsitcph": 5803712024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22246",
    "droptype": "D",
    "dropname": "MARAMEC",
    "dropdeladd": "420 2ND ST",
    "dropdelcty": "MARAMEC",
    "dropdelst": "OK",
    "dropdelzpp": 740459998,
    "dropphyadd": "420 2ND ST",
    "dropphycty": "MARAMEC",
    "dropphyst": "OK",
    "dropphyzpp": 740459998,
    "dropmaladd": "420 2ND ST",
    "dropmalcty": "MARAMEC",
    "dropmalst": "OK",
    "dropmalzpp": 740459998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184542267,
    "dropsitcph": 9184542267,
    "dropfax": 9184542267
  },
  {
    "dcode": "D",
    "dropkey": "PW22247",
    "droptype": "D",
    "dropname": "MARBLE CITY",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "MARBLE CITY",
    "dropdelst": "OK",
    "dropdelzpp": 749459998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "MARBLE CITY",
    "dropphyst": "OK",
    "dropphyzpp": 749459998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "MARBLE CITY",
    "dropmalst": "OK",
    "dropmalzpp": 749459998,
    "dropsitphn": 9187757180,
    "dropsitlph": 9187757180,
    "dropsitcph": 9187757180,
    "dropfax": 9187757180
  },
  {
    "dcode": "D",
    "dropkey": "PW22248",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "MARIETTA",
    "dropdelst": "OK",
    "dropdelzpp": 734489998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "MARIETTA",
    "dropphyst": "OK",
    "dropphyzpp": 734489998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "MARIETTA",
    "dropmalst": "OK",
    "dropmalzpp": 734489998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802763122,
    "dropsitcph": 5802763122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22249",
    "droptype": "D",
    "dropname": "MARLAND",
    "dropdeladd": "375 N MAIN ST",
    "dropdelcty": "MARLAND",
    "dropdelst": "OK",
    "dropdelzpp": 746449998,
    "dropphyadd": "375 N MAIN ST",
    "dropphycty": "MARLAND",
    "dropphyst": "OK",
    "dropphyzpp": 746449998,
    "dropmaladd": "375 N MAIN ST",
    "dropmalcty": "MARLAND",
    "dropmalst": "OK",
    "dropmalzpp": 746449998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802683089,
    "dropsitcph": 5802683089,
    "dropfax": 5802683089
  },
  {
    "dcode": "D",
    "dropkey": "PW22250",
    "droptype": "D",
    "dropname": "MARLOW",
    "dropdeladd": "324 W MAIN ST",
    "dropdelcty": "MARLOW",
    "dropdelst": "OK",
    "dropdelzpp": 730559998,
    "dropphyadd": "324 W MAIN ST",
    "dropphycty": "MARLOW",
    "dropphyst": "OK",
    "dropphyzpp": 730559998,
    "dropmaladd": "324 W MAIN ST",
    "dropmalcty": "MARLOW",
    "dropmalst": "OK",
    "dropmalzpp": 730559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806583181,
    "dropsitcph": 5806583181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22251",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "221 E MAIN ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "OK",
    "dropdelzpp": 730569998,
    "dropphyadd": "221 E MAIN ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "OK",
    "dropphyzpp": 730569998,
    "dropmaladd": "221 E MAIN ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "OK",
    "dropmalzpp": 730569998,
    "dropsitphn": 5809356847,
    "dropsitlph": 5809356847,
    "dropsitcph": 5809356847,
    "dropfax": 5809356847
  },
  {
    "dcode": "D",
    "dropkey": "PW22252",
    "droptype": "D",
    "dropname": "MARTHA",
    "dropdeladd": "106 E CHURCH ST",
    "dropdelcty": "MARTHA",
    "dropdelst": "OK",
    "dropdelzpp": 735569998,
    "dropphyadd": "106 E CHURCH ST",
    "dropphycty": "MARTHA",
    "dropphyst": "OK",
    "dropphyzpp": 735569998,
    "dropmaladd": "106 E CHURCH ST",
    "dropmalcty": "MARTHA",
    "dropmalst": "OK",
    "dropmalzpp": 735569998,
    "dropsitphn": 5802663311,
    "dropsitlph": 5802663311,
    "dropsitcph": 5802663311,
    "dropfax": 5802663311
  },
  {
    "dcode": "D",
    "dropkey": "PW22256",
    "droptype": "D",
    "dropname": "MAUD",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "MAUD",
    "dropdelst": "OK",
    "dropdelzpp": 748549998,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "MAUD",
    "dropphyst": "OK",
    "dropphyzpp": 748549998,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "MAUD",
    "dropmalst": "OK",
    "dropmalzpp": 748549998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053742767,
    "dropsitcph": 4053742767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22257",
    "droptype": "D",
    "dropname": "MAY",
    "dropdeladd": "201 HIGHWAY 270",
    "dropdelcty": "MAY",
    "dropdelst": "OK",
    "dropdelzpp": 738519998,
    "dropphyadd": "201 HIGHWAY 270",
    "dropphycty": "MAY",
    "dropphyst": "OK",
    "dropphyzpp": 738519998,
    "dropmaladd": "201 HIGHWAY 270",
    "dropmalcty": "MAY",
    "dropmalst": "OK",
    "dropmalzpp": 738519998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806892322,
    "dropsitcph": 5806892322,
    "dropfax": 5806892322
  },
  {
    "dcode": "D",
    "dropkey": "PW22260",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "622 MAIN ST",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 730579998,
    "dropphyadd": "622 MAIN ST",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 730579998,
    "dropmaladd": "622 MAIN ST",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 730579998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058675350,
    "dropsitcph": 4058675350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22262",
    "droptype": "D",
    "dropname": "MCLOUD",
    "dropdeladd": "700 S 8TH ST",
    "dropdelcty": "MCLOUD",
    "dropdelst": "OK",
    "dropdelzpp": 748519998,
    "dropphyadd": "700 S 8TH ST",
    "dropphycty": "MCLOUD",
    "dropphyst": "OK",
    "dropphyzpp": 748519998,
    "dropmaladd": "700 S 8TH ST",
    "dropmalcty": "MCLOUD",
    "dropmalst": "OK",
    "dropmalzpp": 748519998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059647389,
    "dropsitcph": 4059647389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22265",
    "droptype": "D",
    "dropname": "MCALESTER",
    "dropdeladd": "500 E WASHINGTON AVE",
    "dropdelcty": "MCALESTER",
    "dropdelst": "OK",
    "dropdelzpp": 745019998,
    "dropphyadd": "500 E WASHINGTON AVE",
    "dropphycty": "MCALESTER",
    "dropphyst": "OK",
    "dropphyzpp": 745019998,
    "dropmaladd": "500 E WASHINGTON AVE",
    "dropmalcty": "MCALESTER",
    "dropmalst": "OK",
    "dropmalzpp": 745019998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184234048,
    "dropsitcph": 9184234048,
    "dropfax": 9184238640
  },
  {
    "dcode": "D",
    "dropkey": "PW22267",
    "droptype": "D",
    "dropname": "MCCURTAIN",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "MCCURTAIN",
    "dropdelst": "OK",
    "dropdelzpp": 749449998,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "MCCURTAIN",
    "dropphyst": "OK",
    "dropphyzpp": 749449998,
    "dropmaladd": "215 MAIN ST",
    "dropmalcty": "MCCURTAIN",
    "dropmalst": "OK",
    "dropmalzpp": 749449998,
    "dropsitphn": 9189457597,
    "dropsitlph": 9189457597,
    "dropsitcph": 9189457597,
    "dropfax": 9189457597
  },
  {
    "dcode": "D",
    "dropkey": "PW22269",
    "droptype": "D",
    "dropname": "MEAD",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "MEAD",
    "dropdelst": "OK",
    "dropdelzpp": 734499998,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "MEAD",
    "dropphyst": "OK",
    "dropphyzpp": 734499998,
    "dropmaladd": "105 MAIN ST",
    "dropmalcty": "MEAD",
    "dropmalst": "OK",
    "dropmalzpp": 734499998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809243548,
    "dropsitcph": 5809243548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22270",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "115 W CHEROKEE ST",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OK",
    "dropdelzpp": 737599998,
    "dropphyadd": "115 W CHEROKEE ST",
    "dropphycty": "MEDFORD",
    "dropphyst": "OK",
    "dropphyzpp": 737599998,
    "dropmaladd": "115 W CHEROKEE ST",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OK",
    "dropmalzpp": 737599998,
    "dropsitphn": 5803952250,
    "dropsitlph": 5803952250,
    "dropsitcph": 5803952250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22271",
    "droptype": "D",
    "dropname": "MEDICINE PARK",
    "dropdeladd": "18851 STATE HIGHWAY 49",
    "dropdelcty": "LAWTON",
    "dropdelst": "OK",
    "dropdelzpp": 735079997,
    "dropphyadd": "18851 STATE HIGHWAY 49",
    "dropphycty": "LAWTON",
    "dropphyst": "OK",
    "dropphyzpp": 735079997,
    "dropmaladd": "18851 STATE HIGHWAY 49",
    "dropmalcty": "LAWTON",
    "dropmalst": "OK",
    "dropmalzpp": 735079997,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805292734,
    "dropsitcph": 5805292734,
    "dropfax": 5805292734
  },
  {
    "dcode": "D",
    "dropkey": "PW22272",
    "droptype": "D",
    "dropname": "MEEKER",
    "dropdeladd": "220 W CARL HUBBELL BLVD",
    "dropdelcty": "MEEKER",
    "dropdelst": "OK",
    "dropdelzpp": 748559998,
    "dropphyadd": "220 W CARL HUBBELL BLVD",
    "dropphycty": "MEEKER",
    "dropphyst": "OK",
    "dropphyzpp": 748559998,
    "dropmaladd": "220 W CARL HUBBELL BLVD",
    "dropmalcty": "MEEKER",
    "dropmalst": "OK",
    "dropmalzpp": 748559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052792014,
    "dropsitcph": 4052792014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22274",
    "droptype": "D",
    "dropname": "MENO",
    "dropdeladd": "47134 HIGHWAY 412",
    "dropdelcty": "MENO",
    "dropdelst": "OK",
    "dropdelzpp": 737609998,
    "dropphyadd": "47134 HIGHWAY 412",
    "dropphycty": "MENO",
    "dropphyst": "OK",
    "dropphyzpp": 737609998,
    "dropmaladd": "47134 HIGHWAY 412",
    "dropmalcty": "MENO",
    "dropmalst": "OK",
    "dropmalzpp": 737609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807762290,
    "dropsitcph": 5807762290,
    "dropfax": 5807762290
  },
  {
    "dcode": "D",
    "dropkey": "PW22275",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "210 5TH ST",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "OK",
    "dropdelzpp": 730589998,
    "dropphyadd": "210 5TH ST",
    "dropphycty": "MERIDIAN",
    "dropphyst": "OK",
    "dropphyzpp": 730589998,
    "dropmaladd": "210 5TH ST",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "OK",
    "dropmalzpp": 730589998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055862222,
    "dropsitcph": 4055862222,
    "dropfax": 4055862222
  },
  {
    "dcode": "D",
    "dropkey": "PW22277",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "34 A ST NE",
    "dropdelcty": "MIAMI",
    "dropdelst": "OK",
    "dropdelzpp": 743549998,
    "dropphyadd": "34 A ST NE",
    "dropphycty": "MIAMI",
    "dropphyst": "OK",
    "dropphyzpp": 743549998,
    "dropmaladd": "34 A ST NE",
    "dropmalcty": "MIAMI",
    "dropmalst": "OK",
    "dropmalzpp": 743549998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185421018,
    "dropsitcph": 9185421018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22279",
    "droptype": "D",
    "dropname": "MILBURN",
    "dropdeladd": "201 E I AVE",
    "dropdelcty": "MILBURN",
    "dropdelst": "OK",
    "dropdelzpp": 734509998,
    "dropphyadd": "201 E I AVE",
    "dropphycty": "MILBURN",
    "dropphyst": "OK",
    "dropphyzpp": 734509998,
    "dropmaladd": "201 E I AVE",
    "dropmalcty": "MILBURN",
    "dropmalst": "OK",
    "dropmalzpp": 734509998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804435541,
    "dropsitcph": 5804435541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22280",
    "droptype": "D",
    "dropname": "MILFAY",
    "dropdeladd": "28110 S 513TH WEST AVE",
    "dropdelcty": "MILFAY",
    "dropdelst": "OK",
    "dropdelzpp": 740469998,
    "dropphyadd": "28110 S 513TH WEST AVE",
    "dropphycty": "MILFAY",
    "dropphyst": "OK",
    "dropphyzpp": 740469998,
    "dropmaladd": "28110 S 513TH WEST AVE",
    "dropmalcty": "MILFAY",
    "dropmalst": "OK",
    "dropmalzpp": 740469998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9189683675,
    "dropsitcph": 9189683675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22281",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "OK",
    "dropdelzpp": 748569998,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "MILL CREEK",
    "dropphyst": "OK",
    "dropphyzpp": 748569998,
    "dropmaladd": "100 W MAIN ST",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "OK",
    "dropmalzpp": 748569998,
    "dropsitphn": 5803845513,
    "dropsitlph": 5803845513,
    "dropsitcph": 5803845513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22282",
    "droptype": "D",
    "dropname": "MILLERTON",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "MILLERTON",
    "dropdelst": "OK",
    "dropdelzpp": 747509998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "MILLERTON",
    "dropphyst": "OK",
    "dropphyzpp": 747509998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "MILLERTON",
    "dropmalst": "OK",
    "dropmalzpp": 747509998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5807462741,
    "dropsitcph": 5807462741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22284",
    "droptype": "D",
    "dropname": "MINCO",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "MINCO",
    "dropdelst": "OK",
    "dropdelzpp": 730599998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "MINCO",
    "dropphyst": "OK",
    "dropphyzpp": 730599998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "MINCO",
    "dropmalst": "OK",
    "dropmalzpp": 730599998,
    "dropsitphn": 4053524850,
    "dropsitlph": 4053524850,
    "dropsitcph": 4053524850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22285",
    "droptype": "D",
    "dropname": "MOFFETT",
    "dropdeladd": "400 BELT AVE",
    "dropdelcty": "MOFFETT",
    "dropdelst": "OK",
    "dropdelzpp": 749469998,
    "dropphyadd": "400 BELT AVE",
    "dropphycty": "MOFFETT",
    "dropphyst": "OK",
    "dropphyzpp": 749469998,
    "dropmaladd": "400 BELT AVE",
    "dropmalcty": "MOFFETT",
    "dropmalst": "OK",
    "dropmalzpp": 749469998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188753918,
    "dropsitcph": 9188753918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22286",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "14577 HICKORY ST",
    "dropdelcty": "MONROE",
    "dropdelst": "OK",
    "dropdelzpp": 749479998,
    "dropphyadd": "14577 HICKORY ST",
    "dropphycty": "MONROE",
    "dropphyst": "OK",
    "dropphyzpp": 749479998,
    "dropmaladd": "14577 HICKORY ST",
    "dropmalcty": "MONROE",
    "dropmalst": "OK",
    "dropmalzpp": 749479998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186583360,
    "dropsitcph": 9186583360,
    "dropfax": 9186583360
  },
  {
    "dcode": "D",
    "dropkey": "PW22288",
    "droptype": "D",
    "dropname": "MOODYS",
    "dropdeladd": "9783 HIGHWAY 82A",
    "dropdelcty": "MOODYS",
    "dropdelst": "OK",
    "dropdelzpp": 744449998,
    "dropphyadd": "9783 HIGHWAY 82A",
    "dropphycty": "MOODYS",
    "dropphyst": "OK",
    "dropphyzpp": 744449998,
    "dropmaladd": "9783 HIGHWAY 82A",
    "dropmalcty": "MOODYS",
    "dropmalst": "OK",
    "dropmalzpp": 744449998,
    "dropsitphn": 9184562632,
    "dropsitlph": 9184562632,
    "dropsitcph": 9184562632,
    "dropfax": 9184562632
  },
  {
    "dcode": "D",
    "dropkey": "PW22290",
    "droptype": "D",
    "dropname": "MOORELAND",
    "dropdeladd": "302 S MAIN ST",
    "dropdelcty": "MOORELAND",
    "dropdelst": "OK",
    "dropdelzpp": 738529998,
    "dropphyadd": "302 S MAIN ST",
    "dropphycty": "MOORELAND",
    "dropphyst": "OK",
    "dropphyzpp": 738529998,
    "dropmaladd": "302 S MAIN ST",
    "dropmalcty": "MOORELAND",
    "dropmalst": "OK",
    "dropmalzpp": 738529998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809945482,
    "dropsitcph": 5809945482,
    "dropfax": 5809945482
  },
  {
    "dcode": "D",
    "dropkey": "PW22291",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "321 S 2ND ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "OK",
    "dropdelzpp": 744459998,
    "dropphyadd": "321 S 2ND ST",
    "dropphycty": "MORRIS",
    "dropphyst": "OK",
    "dropphyzpp": 744459998,
    "dropmaladd": "321 S 2ND ST",
    "dropmalcty": "MORRIS",
    "dropmalst": "OK",
    "dropmalzpp": 744459998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187332224,
    "dropsitcph": 9187332224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22292",
    "droptype": "D",
    "dropname": "MORRISON",
    "dropdeladd": "309 WOOLSEY AVE",
    "dropdelcty": "MORRISON",
    "dropdelst": "OK",
    "dropdelzpp": 730619998,
    "dropphyadd": "309 WOOLSEY AVE",
    "dropphycty": "MORRISON",
    "dropphyst": "OK",
    "dropphyzpp": 730619998,
    "dropmaladd": "309 WOOLSEY AVE",
    "dropmalcty": "MORRISON",
    "dropmalst": "OK",
    "dropmalzpp": 730619998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057243282,
    "dropsitcph": 5807243282,
    "dropfax": 5807243282
  },
  {
    "dcode": "D",
    "dropkey": "PW22293",
    "droptype": "D",
    "dropname": "MOUNDS",
    "dropdeladd": "1201 ROCKWOOD",
    "dropdelcty": "MOUNDS",
    "dropdelst": "OK",
    "dropdelzpp": 740479998,
    "dropphyadd": "1201 ROCKWOOD",
    "dropphycty": "MOUNDS",
    "dropphyst": "OK",
    "dropphyzpp": 740479998,
    "dropmaladd": "1201 ROCKWOOD",
    "dropmalcty": "MOUNDS",
    "dropmalst": "OK",
    "dropmalzpp": 740479998,
    "dropsitphn": 9188276567,
    "dropsitlph": 9188276567,
    "dropsitcph": 9188276567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22294",
    "droptype": "D",
    "dropname": "MOUNTAIN PARK",
    "dropdeladd": "204 SPRUCE ST",
    "dropdelcty": "MOUNTAIN PARK",
    "dropdelst": "OK",
    "dropdelzpp": 735599998,
    "dropphyadd": "204 SPRUCE ST",
    "dropphycty": "MOUNTAIN PARK",
    "dropphyst": "OK",
    "dropphyzpp": 735599998,
    "dropmaladd": "204 SPRUCE ST",
    "dropmalcty": "MOUNTAIN PARK",
    "dropmalst": "OK",
    "dropmalzpp": 735599998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805694155,
    "dropsitcph": 5805694155,
    "dropfax": 5805694155
  },
  {
    "dcode": "D",
    "dropkey": "PW22295",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "OK",
    "dropdelzpp": 730629998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "OK",
    "dropphyzpp": 730629998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "OK",
    "dropmalzpp": 730629998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803472197,
    "dropsitcph": 5803472197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22297",
    "droptype": "D",
    "dropname": "MOYERS",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MOYERS",
    "dropdelst": "OK",
    "dropdelzpp": 745579998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MOYERS",
    "dropphyst": "OK",
    "dropphyzpp": 745579998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "MOYERS",
    "dropmalst": "OK",
    "dropmalzpp": 745579998,
    "dropsitphn": 5802985693,
    "dropsitlph": 5802985693,
    "dropsitcph": 5802985693,
    "dropfax": 5802985693
  },
  {
    "dcode": "D",
    "dropkey": "PW22298",
    "droptype": "D",
    "dropname": "MULDROW",
    "dropdeladd": "600 E SHAWNTEL SMITH BLVD",
    "dropdelcty": "MULDROW",
    "dropdelst": "OK",
    "dropdelzpp": 749489998,
    "dropphyadd": "600 E SHAWNTEL SMITH BLVD",
    "dropphycty": "MULDROW",
    "dropphyst": "OK",
    "dropphyzpp": 749489998,
    "dropmaladd": "600 E SHAWNTEL SMITH BLVD",
    "dropmalcty": "MULDROW",
    "dropmalst": "OK",
    "dropmalzpp": 749489998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184273241,
    "dropsitcph": 9184273241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22299",
    "droptype": "D",
    "dropname": "MULHALL",
    "dropdeladd": "112 S LEWIS",
    "dropdelcty": "MULHALL",
    "dropdelst": "OK",
    "dropdelzpp": 730639998,
    "dropphyadd": "112 S LEWIS",
    "dropphycty": "MULHALL",
    "dropphyst": "OK",
    "dropphyzpp": 730639998,
    "dropmaladd": "112 S LEWIS",
    "dropmalcty": "MULHALL",
    "dropmalst": "OK",
    "dropmalzpp": 730639998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4056492219,
    "dropsitcph": 4056492219,
    "dropfax": 4056492219
  },
  {
    "dcode": "D",
    "dropkey": "PW22300",
    "droptype": "D",
    "dropname": "MUSE",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "MUSE",
    "dropdelst": "OK",
    "dropdelzpp": 749499998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "MUSE",
    "dropphyst": "OK",
    "dropphyzpp": 749499998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "MUSE",
    "dropmalst": "OK",
    "dropmalzpp": 749499998,
    "dropsitphn": 9186513369,
    "dropsitlph": 9186513369,
    "dropsitcph": 9186513369,
    "dropfax": 9186513369
  },
  {
    "dcode": "D",
    "dropkey": "PW22302",
    "droptype": "D",
    "dropname": "MUSKOGEE",
    "dropdeladd": "505 N MAIN ST",
    "dropdelcty": "MUSKOGEE",
    "dropdelst": "OK",
    "dropdelzpp": 744016346,
    "dropphyadd": "505 N MAIN ST",
    "dropphycty": "MUSKOGEE",
    "dropphyst": "OK",
    "dropphyzpp": 744016346,
    "dropmaladd": "505 N MAIN ST",
    "dropmalcty": "MUSKOGEE",
    "dropmalst": "OK",
    "dropmalzpp": 744016346,
    "dropsitphn": 9186865246,
    "dropsitlph": 9186865246,
    "dropsitcph": 9186865246,
    "dropfax": 9186827850
  },
  {
    "dcode": "D",
    "dropkey": "PW22303",
    "droptype": "D",
    "dropname": "MUSTANG",
    "dropdeladd": "600 N MUSTANG RD",
    "dropdelcty": "MUSTANG",
    "dropdelst": "OK",
    "dropdelzpp": 730649998,
    "dropphyadd": "600 N MUSTANG RD",
    "dropphycty": "MUSTANG",
    "dropphyst": "OK",
    "dropphyzpp": 730649998,
    "dropmaladd": "600 N MUSTANG RD",
    "dropmalcty": "MUSTANG",
    "dropmalst": "OK",
    "dropmalzpp": 730649998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053762681,
    "dropsitcph": 4053762681,
    "dropfax": 4053766896
  },
  {
    "dcode": "D",
    "dropkey": "PW22304",
    "droptype": "D",
    "dropname": "MUTUAL",
    "dropdeladd": "157 N BROADWAY AVE",
    "dropdelcty": "MUTUAL",
    "dropdelst": "OK",
    "dropdelzpp": 738539998,
    "dropphyadd": "157 N BROADWAY AVE",
    "dropphycty": "MUTUAL",
    "dropphyst": "OK",
    "dropphyzpp": 738539998,
    "dropmaladd": "157 N BROADWAY AVE",
    "dropmalcty": "MUTUAL",
    "dropmalst": "OK",
    "dropmalzpp": 738539998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809893344,
    "dropsitcph": 5809893344,
    "dropfax": 5809893344
  },
  {
    "dcode": "D",
    "dropkey": "PW22306",
    "droptype": "D",
    "dropname": "NASH",
    "dropdeladd": "1480 MAIN ST",
    "dropdelcty": "NASH",
    "dropdelst": "OK",
    "dropdelzpp": 737619998,
    "dropphyadd": "1480 MAIN ST",
    "dropphycty": "NASH",
    "dropphyst": "OK",
    "dropphyzpp": 737619998,
    "dropmaladd": "1480 MAIN ST",
    "dropmalcty": "NASH",
    "dropmalst": "OK",
    "dropmalzpp": 737619998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808392212,
    "dropsitcph": 5808392212,
    "dropfax": 5808392212
  },
  {
    "dcode": "D",
    "dropkey": "PW22307",
    "droptype": "D",
    "dropname": "NASHOBA",
    "dropdeladd": "439534 STATE HIGHWAY 144",
    "dropdelcty": "NASHOBA",
    "dropdelst": "OK",
    "dropdelzpp": 745589998,
    "dropphyadd": "439534 STATE HIGHWAY 144",
    "dropphycty": "NASHOBA",
    "dropphyst": "OK",
    "dropphyzpp": 745589998,
    "dropmaladd": "439534 STATE HIGHWAY 144",
    "dropmalcty": "NASHOBA",
    "dropmalst": "OK",
    "dropmalzpp": 745589998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183000084,
    "dropsitcph": 9183000084,
    "dropfax": 9187554580
  },
  {
    "dcode": "D",
    "dropkey": "PW22311",
    "droptype": "D",
    "dropname": "NEWALLA",
    "dropdeladd": "5900 S HARRAH RD",
    "dropdelcty": "NEWALLA",
    "dropdelst": "OK",
    "dropdelzpp": 748579998,
    "dropphyadd": "5900 S HARRAH RD",
    "dropphycty": "NEWALLA",
    "dropphyst": "OK",
    "dropphyzpp": 748579998,
    "dropmaladd": "5900 S HARRAH RD",
    "dropmalcty": "NEWALLA",
    "dropmalst": "OK",
    "dropmalzpp": 748579998,
    "dropsitphn": 4053915901,
    "dropsitlph": 4053915901,
    "dropsitcph": 4053915901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22313",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "220 N WRIGHT ST",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "OK",
    "dropdelzpp": 730659998,
    "dropphyadd": "220 N WRIGHT ST",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "OK",
    "dropphyzpp": 730659998,
    "dropmaladd": "220 N WRIGHT ST",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "OK",
    "dropmalzpp": 730659998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053875679,
    "dropsitcph": 4053875679,
    "dropfax": 4053875154
  },
  {
    "dcode": "D",
    "dropkey": "PW22314",
    "droptype": "D",
    "dropname": "NEWKIRK",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "NEWKIRK",
    "dropdelst": "OK",
    "dropdelzpp": 746479998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "NEWKIRK",
    "dropphyst": "OK",
    "dropphyzpp": 746479998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "NEWKIRK",
    "dropmalst": "OK",
    "dropmalzpp": 746479998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803623353,
    "dropsitcph": 5803623353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22316",
    "droptype": "D",
    "dropname": "NICOMA PARK",
    "dropdeladd": "2301 OVERHOLSER DR",
    "dropdelcty": "NICOMA PARK",
    "dropdelst": "OK",
    "dropdelzpp": 730669998,
    "dropphyadd": "2301 OVERHOLSER DR",
    "dropphycty": "NICOMA PARK",
    "dropphyst": "OK",
    "dropphyzpp": 730669998,
    "dropmaladd": "2301 OVERHOLSER DR",
    "dropmalcty": "NICOMA PARK",
    "dropmalst": "OK",
    "dropmalzpp": 730669998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057698813,
    "dropsitcph": 4057698813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22317",
    "droptype": "D",
    "dropname": "NINNEKAH",
    "dropdeladd": "905 WALNUT ST",
    "dropdelcty": "NINNEKAH",
    "dropdelst": "OK",
    "dropdelzpp": 730679998,
    "dropphyadd": "905 WALNUT ST",
    "dropphycty": "NINNEKAH",
    "dropphyst": "OK",
    "dropphyzpp": 730679998,
    "dropmaladd": "905 WALNUT ST",
    "dropmalcty": "NINNEKAH",
    "dropmalst": "OK",
    "dropmalzpp": 730679998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052240865,
    "dropsitcph": 4052240865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22318",
    "droptype": "D",
    "dropname": "NOBLE",
    "dropdeladd": "220 MAPLE ST",
    "dropdelcty": "NOBLE",
    "dropdelst": "OK",
    "dropdelzpp": 730689998,
    "dropphyadd": "220 MAPLE ST",
    "dropphycty": "NOBLE",
    "dropphyst": "OK",
    "dropphyzpp": 730689998,
    "dropmaladd": "220 MAPLE ST",
    "dropmalcty": "NOBLE",
    "dropmalst": "OK",
    "dropmalzpp": 730689998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058725126,
    "dropsitcph": 4058725126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22320",
    "droptype": "D",
    "dropname": "NORMAN",
    "dropdeladd": "129 W GRAY ST",
    "dropdelcty": "NORMAN",
    "dropdelst": "OK",
    "dropdelzpp": 730699998,
    "dropphyadd": "129 W GRAY ST",
    "dropphycty": "NORMAN",
    "dropphyst": "OK",
    "dropphyzpp": 730699998,
    "dropmaladd": "129 W GRAY ST",
    "dropmalcty": "NORMAN",
    "dropmalst": "OK",
    "dropmalzpp": 730699998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053210281,
    "dropsitcph": 4053210281,
    "dropfax": 4053649846
  },
  {
    "dcode": "D",
    "dropkey": "PW22321",
    "droptype": "D",
    "dropname": "NORTH MIAMI",
    "dropdeladd": "303 PINE ST",
    "dropdelcty": "NORTH MIAMI",
    "dropdelst": "OK",
    "dropdelzpp": 743589998,
    "dropphyadd": "303 PINE ST",
    "dropphycty": "NORTH MIAMI",
    "dropphyst": "OK",
    "dropphyzpp": 743589998,
    "dropmaladd": "303 PINE ST",
    "dropmalcty": "NORTH MIAMI",
    "dropmalst": "OK",
    "dropmalzpp": 743589998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185426097,
    "dropsitcph": 9185426097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22326",
    "droptype": "D",
    "dropname": "NOWATA",
    "dropdeladd": "109 N PINE ST",
    "dropdelcty": "NOWATA",
    "dropdelst": "OK",
    "dropdelzpp": 740489998,
    "dropphyadd": "109 N PINE ST",
    "dropphycty": "NOWATA",
    "dropphyst": "OK",
    "dropphyzpp": 740489998,
    "dropmaladd": "109 N PINE ST",
    "dropmalcty": "NOWATA",
    "dropmalst": "OK",
    "dropmalzpp": 740489998,
    "dropsitphn": 9182731681,
    "dropsitlph": 9182731681,
    "dropsitcph": 9182731681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22330",
    "droptype": "D",
    "dropname": "OAKHURST",
    "dropdeladd": "6403 W 60TH ST",
    "dropdelcty": "OAKHURST",
    "dropdelst": "OK",
    "dropdelzpp": 740509998,
    "dropphyadd": "6403 W 60TH ST",
    "dropphycty": "OAKHURST",
    "dropphyst": "OK",
    "dropphyzpp": 740509998,
    "dropmaladd": "6403 W 60TH ST",
    "dropmalcty": "OAKHURST",
    "dropmalst": "OK",
    "dropmalzpp": 740509998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184455535,
    "dropsitcph": 9184455535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22332",
    "droptype": "D",
    "dropname": "OAKS",
    "dropdeladd": "377 W MAIN",
    "dropdelcty": "OAKS",
    "dropdelst": "OK",
    "dropdelzpp": 743599998,
    "dropphyadd": "377 W MAIN",
    "dropphycty": "OAKS",
    "dropphyst": "OK",
    "dropphyzpp": 743599998,
    "dropmaladd": "377 W MAIN",
    "dropmalcty": "OAKS",
    "dropmalst": "OK",
    "dropmalzpp": 743599998,
    "dropsitphn": 9188682759,
    "dropsitlph": 9188682759,
    "dropsitcph": 9188682759,
    "dropfax": 9188682806
  },
  {
    "dcode": "D",
    "dropkey": "PW22333",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "102 S MISSOURI ST",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "OK",
    "dropdelzpp": 736589998,
    "dropphyadd": "102 S MISSOURI ST",
    "dropphycty": "OAKWOOD",
    "dropphyst": "OK",
    "dropphyzpp": 736589998,
    "dropmaladd": "102 S MISSOURI ST",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "OK",
    "dropmalzpp": 736589998,
    "dropsitphn": 5806612321,
    "dropsitlph": 5806612321,
    "dropsitcph": 5808913391,
    "dropfax": 5808913391
  },
  {
    "dcode": "D",
    "dropkey": "PW22335",
    "droptype": "D",
    "dropname": "OCHELATA",
    "dropdeladd": "300 N OCHELATA ST",
    "dropdelcty": "OCHELATA",
    "dropdelst": "OK",
    "dropdelzpp": 740519998,
    "dropphyadd": "300 N OCHELATA ST",
    "dropphycty": "OCHELATA",
    "dropphyst": "OK",
    "dropphyzpp": 740519998,
    "dropmaladd": "300 N OCHELATA ST",
    "dropmalcty": "OCHELATA",
    "dropmalst": "OK",
    "dropmalzpp": 740519998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185352892,
    "dropsitcph": 9185352892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22339",
    "droptype": "D",
    "dropname": "OILTON",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "OILTON",
    "dropdelst": "OK",
    "dropdelzpp": 740529998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "OILTON",
    "dropphyst": "OK",
    "dropphyzpp": 740529998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "OILTON",
    "dropmalst": "OK",
    "dropmalzpp": 740529998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188620234,
    "dropsitcph": 9188620234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22342",
    "droptype": "D",
    "dropname": "OKARCHE",
    "dropdeladd": "121 W OKLAHOMA ST",
    "dropdelcty": "OKARCHE",
    "dropdelst": "OK",
    "dropdelzpp": 737629998,
    "dropphyadd": "121 W OKLAHOMA ST",
    "dropphycty": "OKARCHE",
    "dropphyst": "OK",
    "dropphyzpp": 737629998,
    "dropmaladd": "121 W OKLAHOMA ST",
    "dropmalcty": "OKARCHE",
    "dropmalst": "OK",
    "dropmalzpp": 737629998,
    "dropsitphn": 4052634444,
    "dropsitlph": 4052634444,
    "dropsitcph": 4052634444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22343",
    "droptype": "D",
    "dropname": "OKAY",
    "dropdeladd": "3620 E 75TH ST N",
    "dropdelcty": "OKAY",
    "dropdelst": "OK",
    "dropdelzpp": 744469998,
    "dropphyadd": "3620 E 75TH ST N",
    "dropphycty": "OKAY",
    "dropphyst": "OK",
    "dropphyzpp": 744469998,
    "dropmaladd": "3620 E 75TH ST N",
    "dropmalcty": "OKAY",
    "dropmalst": "OK",
    "dropmalzpp": 744469998,
    "dropsitphn": 9186820179,
    "dropsitlph": 9186820179,
    "dropsitcph": 9186820179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22344",
    "droptype": "D",
    "dropname": "OKEENE",
    "dropdeladd": "201 N 5TH ST",
    "dropdelcty": "OKEENE",
    "dropdelst": "OK",
    "dropdelzpp": 737639998,
    "dropphyadd": "201 N 5TH ST",
    "dropphycty": "OKEENE",
    "dropphyst": "OK",
    "dropphyzpp": 737639998,
    "dropmaladd": "201 N 5TH ST",
    "dropmalcty": "OKEENE",
    "dropmalst": "OK",
    "dropmalzpp": 737639998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808223447,
    "dropsitcph": 5808223447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22345",
    "droptype": "D",
    "dropname": "OKEMAH",
    "dropdeladd": "418 W BROADWAY ST",
    "dropdelcty": "OKEMAH",
    "dropdelst": "OK",
    "dropdelzpp": 748599998,
    "dropphyadd": "418 W BROADWAY ST",
    "dropphycty": "OKEMAH",
    "dropphyst": "OK",
    "dropphyzpp": 748599998,
    "dropmaladd": "418 W BROADWAY ST",
    "dropmalcty": "OKEMAH",
    "dropmalst": "OK",
    "dropmalzpp": 748599998,
    "dropsitphn": 4058152724,
    "dropsitlph": 9186230112,
    "dropsitcph": 9186230112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22353",
    "droptype": "D",
    "dropname": "OKLAHOMA CITY",
    "dropdeladd": "4025 W RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731259807,
    "dropphyadd": "4025 W RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731259807,
    "dropmaladd": "4025 W RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731259807,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058152342,
    "dropsitcph": 4058152342,
    "dropfax": 4058152013
  },
  {
    "dcode": "D",
    "dropkey": "PW22356",
    "droptype": "D",
    "dropname": "OKMULGEE",
    "dropdeladd": "111 W 4TH ST",
    "dropdelcty": "OKMULGEE",
    "dropdelst": "OK",
    "dropdelzpp": 744479998,
    "dropphyadd": "111 W 4TH ST",
    "dropphycty": "OKMULGEE",
    "dropphyst": "OK",
    "dropphyzpp": 744479998,
    "dropmaladd": "111 W 4TH ST",
    "dropmalcty": "OKMULGEE",
    "dropmalst": "OK",
    "dropmalzpp": 744479998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187563747,
    "dropsitcph": 9187563747,
    "dropfax": 9187563044
  },
  {
    "dcode": "D",
    "dropkey": "PW22357",
    "droptype": "D",
    "dropname": "OKTAHA",
    "dropdeladd": "104 E PRAIRIE ST",
    "dropdelcty": "OKTAHA",
    "dropdelst": "OK",
    "dropdelzpp": 744509998,
    "dropphyadd": "104 E PRAIRIE ST",
    "dropphycty": "OKTAHA",
    "dropphyst": "OK",
    "dropphyzpp": 744509998,
    "dropmaladd": "104 E PRAIRIE ST",
    "dropmalcty": "OKTAHA",
    "dropmalst": "OK",
    "dropmalzpp": 744509998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186832733,
    "dropsitcph": 9186832733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22359",
    "droptype": "D",
    "dropname": "OLUSTEE",
    "dropdeladd": "104 E 4TH ST",
    "dropdelcty": "OLUSTEE",
    "dropdelst": "OK",
    "dropdelzpp": 735609998,
    "dropphyadd": "104 E 4TH ST",
    "dropphycty": "OLUSTEE",
    "dropphyst": "OK",
    "dropphyzpp": 735609998,
    "dropmaladd": "104 E 4TH ST",
    "dropmalcty": "OLUSTEE",
    "dropmalst": "OK",
    "dropmalzpp": 735609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806482301,
    "dropsitcph": 5806482301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22361",
    "droptype": "D",
    "dropname": "OOLOGAH",
    "dropdeladd": "150 W COOWEESCOOWEE AVE",
    "dropdelcty": "OOLOGAH",
    "dropdelst": "OK",
    "dropdelzpp": 740539998,
    "dropphyadd": "150 W COOWEESCOOWEE AVE",
    "dropphycty": "OOLOGAH",
    "dropphyst": "OK",
    "dropphyzpp": 740539998,
    "dropmaladd": "150 W COOWEESCOOWEE AVE",
    "dropmalcty": "OOLOGAH",
    "dropmalst": "OK",
    "dropmalzpp": 740539998,
    "dropsitphn": 9184432529,
    "dropsitlph": 9184432529,
    "dropsitcph": 9184432529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22365",
    "droptype": "D",
    "dropname": "ORLANDO",
    "dropdeladd": "100 HIGHWAY 77",
    "dropdelcty": "ORLANDO",
    "dropdelst": "OK",
    "dropdelzpp": 730739998,
    "dropphyadd": "100 HIGHWAY 77",
    "dropphycty": "ORLANDO",
    "dropphyst": "OK",
    "dropphyzpp": 730739998,
    "dropmaladd": "100 HIGHWAY 77",
    "dropmalcty": "ORLANDO",
    "dropmalst": "OK",
    "dropmalzpp": 730739998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804552228,
    "dropsitcph": 5804552228,
    "dropfax": 5804552228
  },
  {
    "dcode": "D",
    "dropkey": "PW22366",
    "droptype": "D",
    "dropname": "OSAGE",
    "dropdeladd": "101 S BROADWAY",
    "dropdelcty": "OSAGE",
    "dropdelst": "OK",
    "dropdelzpp": 740549998,
    "dropphyadd": "101 S BROADWAY",
    "dropphycty": "OSAGE",
    "dropphyst": "OK",
    "dropphyzpp": 740549998,
    "dropmaladd": "101 S BROADWAY",
    "dropmalcty": "OSAGE",
    "dropmalst": "OK",
    "dropmalzpp": 740549998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183542385,
    "dropsitcph": 9183542385,
    "dropfax": 9183542210
  },
  {
    "dcode": "D",
    "dropkey": "PW22370",
    "droptype": "D",
    "dropname": "OVERBROOK",
    "dropdeladd": "232 US HIGHWAY 77",
    "dropdelcty": "OVERBROOK",
    "dropdelst": "OK",
    "dropdelzpp": 734539998,
    "dropphyadd": "232 US HIGHWAY 77",
    "dropphycty": "OVERBROOK",
    "dropphyst": "OK",
    "dropphyzpp": 734539998,
    "dropmaladd": "232 US HIGHWAY 77",
    "dropmalcty": "OVERBROOK",
    "dropmalst": "OK",
    "dropmalzpp": 734539998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802232795,
    "dropsitcph": 5802232795,
    "dropfax": 5802232795
  },
  {
    "dcode": "D",
    "dropkey": "PW22371",
    "droptype": "D",
    "dropname": "OWASSO",
    "dropdeladd": "1233 N CEDAR ST",
    "dropdelcty": "OWASSO",
    "dropdelst": "OK",
    "dropdelzpp": 740559998,
    "dropphyadd": "1233 N CEDAR ST",
    "dropphycty": "OWASSO",
    "dropphyst": "OK",
    "dropphyzpp": 740559998,
    "dropmaladd": "1233 N CEDAR ST",
    "dropmalcty": "OWASSO",
    "dropmalst": "OK",
    "dropmalzpp": 740559998,
    "dropsitphn": 9182127010,
    "dropsitlph": 9182749376,
    "dropsitcph": 9182749376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22372",
    "droptype": "D",
    "dropname": "PADEN",
    "dropdeladd": "813 S MAIN ST",
    "dropdelcty": "PADEN",
    "dropdelst": "OK",
    "dropdelzpp": 748609998,
    "dropphyadd": "813 S MAIN ST",
    "dropphycty": "PADEN",
    "dropphyst": "OK",
    "dropphyzpp": 748609998,
    "dropmaladd": "813 S MAIN ST",
    "dropmalcty": "PADEN",
    "dropmalst": "OK",
    "dropmalzpp": 748609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059325171,
    "dropsitcph": 4059325171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22373",
    "droptype": "D",
    "dropname": "PANAMA",
    "dropdeladd": "901 N KENTUCKY ST",
    "dropdelcty": "PANAMA",
    "dropdelst": "OK",
    "dropdelzpp": 749519998,
    "dropphyadd": "901 N KENTUCKY ST",
    "dropphycty": "PANAMA",
    "dropphyst": "OK",
    "dropphyzpp": 749519998,
    "dropmaladd": "901 N KENTUCKY ST",
    "dropmalcty": "PANAMA",
    "dropmalst": "OK",
    "dropmalzpp": 749519998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182650352,
    "dropsitcph": 9182650325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22374",
    "droptype": "D",
    "dropname": "PANOLA",
    "dropdeladd": "5755 HIGHWAY 270 E",
    "dropdelcty": "PANOLA",
    "dropdelst": "OK",
    "dropdelzpp": 745599998,
    "dropphyadd": "5755 HIGHWAY 270 E",
    "dropphycty": "PANOLA",
    "dropphyst": "OK",
    "dropphyzpp": 745599998,
    "dropmaladd": "5755 HIGHWAY 270 E",
    "dropmalcty": "PANOLA",
    "dropmalst": "OK",
    "dropmalzpp": 745599998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184655064,
    "dropsitcph": 9184655064,
    "dropfax": 9184655064
  },
  {
    "dcode": "D",
    "dropkey": "PW22375",
    "droptype": "D",
    "dropname": "PAOLI",
    "dropdeladd": "307 S OKLAHOMA ST",
    "dropdelcty": "PAOLI",
    "dropdelst": "OK",
    "dropdelzpp": 730749998,
    "dropphyadd": "307 S OKLAHOMA ST",
    "dropphycty": "PAOLI",
    "dropphyst": "OK",
    "dropphyzpp": 730749998,
    "dropmaladd": "307 S OKLAHOMA ST",
    "dropmalcty": "PAOLI",
    "dropmalst": "OK",
    "dropmalzpp": 730749998,
    "dropsitphn": 4058152724,
    "dropsitlph": 8773541470,
    "dropsitcph": 8773541470,
    "dropfax": 8773541470
  },
  {
    "dcode": "D",
    "dropkey": "PW22376",
    "droptype": "D",
    "dropname": "PARK HILL",
    "dropdeladd": "21286 S KEELER DR",
    "dropdelcty": "PARK HILL",
    "dropdelst": "OK",
    "dropdelzpp": 744519998,
    "dropphyadd": "21286 S KEELER DR",
    "dropphycty": "PARK HILL",
    "dropphyst": "OK",
    "dropphyzpp": 744519998,
    "dropmaladd": "21286 S KEELER DR",
    "dropmalcty": "PARK HILL",
    "dropmalst": "OK",
    "dropmalzpp": 744519998,
    "dropsitphn": 9184560980,
    "dropsitlph": 9184560980,
    "dropsitcph": 9184560980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22377",
    "droptype": "D",
    "dropname": "PAULS VALLEY",
    "dropdeladd": "120 W PAUL AVE",
    "dropdelcty": "PAULS VALLEY",
    "dropdelst": "OK",
    "dropdelzpp": 730759998,
    "dropphyadd": "120 W PAUL AVE",
    "dropphycty": "PAULS VALLEY",
    "dropphyst": "OK",
    "dropphyzpp": 730759998,
    "dropmaladd": "120 W PAUL AVE",
    "dropmalcty": "PAULS VALLEY",
    "dropmalst": "OK",
    "dropmalzpp": 730759998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052383268,
    "dropsitcph": 4052383268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22378",
    "droptype": "D",
    "dropname": "PAWHUSKA",
    "dropdeladd": "137 E 6TH ST",
    "dropdelcty": "PAWHUSKA",
    "dropdelst": "OK",
    "dropdelzpp": 740569998,
    "dropphyadd": "137 E 6TH ST",
    "dropphycty": "PAWHUSKA",
    "dropphyst": "OK",
    "dropphyzpp": 740569998,
    "dropmaladd": "137 E 6TH ST",
    "dropmalcty": "PAWHUSKA",
    "dropmalst": "OK",
    "dropmalzpp": 740569998,
    "dropsitphn": 9182874482,
    "dropsitlph": 9182874482,
    "dropsitcph": 9182874482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22379",
    "droptype": "D",
    "dropname": "PAWNEE",
    "dropdeladd": "658 ILLINOIS ST",
    "dropdelcty": "PAWNEE",
    "dropdelst": "OK",
    "dropdelzpp": 740589998,
    "dropphyadd": "658 ILLINOIS ST",
    "dropphycty": "PAWNEE",
    "dropphyst": "OK",
    "dropphyzpp": 740589998,
    "dropmaladd": "658 ILLINOIS ST",
    "dropmalcty": "PAWNEE",
    "dropmalst": "OK",
    "dropmalzpp": 740589998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187623266,
    "dropsitcph": 9187623266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22382",
    "droptype": "D",
    "dropname": "PEGGS",
    "dropdeladd": "6580 N SYLVAN ST",
    "dropdelcty": "PEGGS",
    "dropdelst": "OK",
    "dropdelzpp": 744529998,
    "dropphyadd": "6580 N SYLVAN ST",
    "dropphycty": "PEGGS",
    "dropphyst": "OK",
    "dropphyzpp": 744529998,
    "dropmaladd": "6580 N SYLVAN ST",
    "dropmalcty": "PEGGS",
    "dropmalst": "OK",
    "dropmalzpp": 744529998,
    "dropsitphn": 9185983212,
    "dropsitlph": 9185983212,
    "dropsitcph": 9185983212,
    "dropfax": 9185983212
  },
  {
    "dcode": "D",
    "dropkey": "PW22386",
    "droptype": "D",
    "dropname": "PERKINS",
    "dropdeladd": "114 W STUMBO AVE",
    "dropdelcty": "PERKINS",
    "dropdelst": "OK",
    "dropdelzpp": 740599998,
    "dropphyadd": "114 W STUMBO AVE",
    "dropphycty": "PERKINS",
    "dropphyst": "OK",
    "dropphyzpp": 740599998,
    "dropmaladd": "114 W STUMBO AVE",
    "dropmalcty": "PERKINS",
    "dropmalst": "OK",
    "dropmalzpp": 740599998,
    "dropsitphn": 9182707512,
    "dropsitlph": 4055472922,
    "dropsitcph": 4055472922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22388",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "326 N 7TH ST",
    "dropdelcty": "PERRY",
    "dropdelst": "OK",
    "dropdelzpp": 730779998,
    "dropphyadd": "326 N 7TH ST",
    "dropphycty": "PERRY",
    "dropphyst": "OK",
    "dropphyzpp": 730779998,
    "dropmaladd": "326 N 7TH ST",
    "dropmalcty": "PERRY",
    "dropmalst": "OK",
    "dropmalzpp": 730779998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803362504,
    "dropsitcph": 5803362504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22395",
    "droptype": "D",
    "dropname": "PICKENS",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "PICKENS",
    "dropdelst": "OK",
    "dropdelzpp": 747529998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "PICKENS",
    "dropphyst": "OK",
    "dropphyzpp": 747529998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "PICKENS",
    "dropmalst": "OK",
    "dropmalzpp": 747529998,
    "dropsitphn": 5809812725,
    "dropsitlph": 5809812725,
    "dropsitcph": 5802415285,
    "dropfax": 5802415285
  },
  {
    "dcode": "D",
    "dropkey": "PW22396",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "112 JACKSON AVE NW",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "OK",
    "dropdelzpp": 730789998,
    "dropphyadd": "112 JACKSON AVE NW",
    "dropphycty": "PIEDMONT",
    "dropphyst": "OK",
    "dropphyzpp": 730789998,
    "dropmaladd": "112 JACKSON AVE NW",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "OK",
    "dropmalzpp": 730789998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053730251,
    "dropsitcph": 4053730251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22399",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "508 BROADWAY AVE",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "OK",
    "dropdelzpp": 745609998,
    "dropphyadd": "508 BROADWAY AVE",
    "dropphycty": "PITTSBURG",
    "dropphyst": "OK",
    "dropphyzpp": 745609998,
    "dropmaladd": "508 BROADWAY AVE",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "OK",
    "dropmalzpp": 745609998,
    "dropsitphn": 9182476344,
    "dropsitlph": 9184325441,
    "dropsitcph": 9184325293,
    "dropfax": 9184325293
  },
  {
    "dcode": "D",
    "dropkey": "PW22400",
    "droptype": "D",
    "dropname": "PLATTER",
    "dropdeladd": "313 2ND ST",
    "dropdelcty": "PLATTER",
    "dropdelst": "OK",
    "dropdelzpp": 747539998,
    "dropphyadd": "313 2ND ST",
    "dropphycty": "PLATTER",
    "dropphyst": "OK",
    "dropphyzpp": 747539998,
    "dropmaladd": "313 2ND ST",
    "dropmalcty": "PLATTER",
    "dropmalst": "OK",
    "dropmalzpp": 747539998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5809654781,
    "dropsitcph": 5809654781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22401",
    "droptype": "D",
    "dropname": "POCASSET",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "POCASSET",
    "dropdelst": "OK",
    "dropdelzpp": 730799998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "POCASSET",
    "dropphyst": "OK",
    "dropphyzpp": 730799998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "POCASSET",
    "dropmalst": "OK",
    "dropmalzpp": 730799998,
    "dropsitphn": 4054596767,
    "dropsitlph": 4054596767,
    "dropsitcph": 4054596767,
    "dropfax": 4054599186
  },
  {
    "dcode": "D",
    "dropkey": "PW22402",
    "droptype": "D",
    "dropname": "POCOLA",
    "dropdeladd": "101 E VICTOR LN",
    "dropdelcty": "POCOLA",
    "dropdelst": "OK",
    "dropdelzpp": 749029998,
    "dropphyadd": "101 E VICTOR LN",
    "dropphycty": "POCOLA",
    "dropphyst": "OK",
    "dropphyzpp": 749029998,
    "dropmaladd": "101 E VICTOR LN",
    "dropmalcty": "POCOLA",
    "dropmalst": "OK",
    "dropmalzpp": 749029998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184362780,
    "dropsitcph": 9184362780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22404",
    "droptype": "D",
    "dropname": "PONCA CITY",
    "dropdeladd": "402 E GRAND AVE",
    "dropdelcty": "PONCA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 746019998,
    "dropphyadd": "402 E GRAND AVE",
    "dropphycty": "PONCA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 746019998,
    "dropmaladd": "402 E GRAND AVE",
    "dropmalcty": "PONCA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 746019998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5807622870,
    "dropsitcph": 5807622870,
    "dropfax": 5807624532
  },
  {
    "dcode": "D",
    "dropkey": "PW22405",
    "droptype": "D",
    "dropname": "POND CREEK",
    "dropdeladd": "104 W BROADWAY ST",
    "dropdelcty": "POND CREEK",
    "dropdelst": "OK",
    "dropdelzpp": 737669998,
    "dropphyadd": "104 W BROADWAY ST",
    "dropphycty": "POND CREEK",
    "dropphyst": "OK",
    "dropphyzpp": 737669998,
    "dropmaladd": "104 W BROADWAY ST",
    "dropmalcty": "POND CREEK",
    "dropmalst": "OK",
    "dropmalzpp": 737669998,
    "dropsitphn": 5805326338,
    "dropsitlph": 5805326338,
    "dropsitcph": 5805326338,
    "dropfax": 5805326338
  },
  {
    "dcode": "D",
    "dropkey": "PW22407",
    "droptype": "D",
    "dropname": "PORTER",
    "dropdeladd": "530 S MAIN ST",
    "dropdelcty": "PORTER",
    "dropdelst": "OK",
    "dropdelzpp": 744549998,
    "dropphyadd": "530 S MAIN ST",
    "dropphycty": "PORTER",
    "dropphyst": "OK",
    "dropphyzpp": 744549998,
    "dropmaladd": "530 S MAIN ST",
    "dropmalcty": "PORTER",
    "dropmalst": "OK",
    "dropmalzpp": 744549998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182039334,
    "dropsitcph": 9182039330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22408",
    "droptype": "D",
    "dropname": "PORUM",
    "dropdeladd": "105 SEMINOLE ST",
    "dropdelcty": "PORUM",
    "dropdelst": "OK",
    "dropdelzpp": 744559998,
    "dropphyadd": "105 SEMINOLE ST",
    "dropphycty": "PORUM",
    "dropphyst": "OK",
    "dropphyzpp": 744559998,
    "dropmaladd": "105 SEMINOLE ST",
    "dropmalcty": "PORUM",
    "dropmalst": "OK",
    "dropmalzpp": 744559998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184845537,
    "dropsitcph": 9184845537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22410",
    "droptype": "D",
    "dropname": "POTEAU",
    "dropdeladd": "115 N WITTE ST",
    "dropdelcty": "POTEAU",
    "dropdelst": "OK",
    "dropdelzpp": 749539998,
    "dropphyadd": "115 N WITTE ST",
    "dropphycty": "POTEAU",
    "dropphyst": "OK",
    "dropphyzpp": 749539998,
    "dropmaladd": "115 N WITTE ST",
    "dropmalcty": "POTEAU",
    "dropmalst": "OK",
    "dropmalzpp": 749539998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186473410,
    "dropsitcph": 9186473410,
    "dropfax": 9186473813
  },
  {
    "dcode": "D",
    "dropkey": "PW22411",
    "droptype": "D",
    "dropname": "PRAGUE",
    "dropdeladd": "804 9TH ST",
    "dropdelcty": "PRAGUE",
    "dropdelst": "OK",
    "dropdelzpp": 748649998,
    "dropphyadd": "804 9TH ST",
    "dropphycty": "PRAGUE",
    "dropphyst": "OK",
    "dropphyzpp": 748649998,
    "dropmaladd": "804 9TH ST",
    "dropmalcty": "PRAGUE",
    "dropmalst": "OK",
    "dropmalzpp": 748649998,
    "dropsitphn": 4055673723,
    "dropsitlph": 4055673723,
    "dropsitcph": 4055673723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22413",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "10040 POLK AVE",
    "dropdelcty": "PRESTON",
    "dropdelst": "OK",
    "dropdelzpp": 744569998,
    "dropphyadd": "10040 POLK AVE",
    "dropphycty": "PRESTON",
    "dropphyst": "OK",
    "dropphyzpp": 744569998,
    "dropmaladd": "10040 POLK AVE",
    "dropmalcty": "PRESTON",
    "dropmalst": "OK",
    "dropmalzpp": 744569998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187561878,
    "dropsitcph": 9187561878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22414",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "100 HIGHWAY 62",
    "dropdelcty": "PROCTOR",
    "dropdelst": "OK",
    "dropdelzpp": 744579998,
    "dropphyadd": "100 HIGHWAY 62",
    "dropphycty": "PROCTOR",
    "dropphyst": "OK",
    "dropphyzpp": 744579998,
    "dropmaladd": "100 HIGHWAY 62",
    "dropmalcty": "PROCTOR",
    "dropmalst": "OK",
    "dropmalzpp": 744579998,
    "dropsitphn": 9187235828,
    "dropsitlph": 9187235828,
    "dropsitcph": 9187235828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22415",
    "droptype": "D",
    "dropname": "PRUE",
    "dropdeladd": "101 BROADWAY",
    "dropdelcty": "PRUE",
    "dropdelst": "OK",
    "dropdelzpp": 740609998,
    "dropphyadd": "101 BROADWAY",
    "dropphycty": "PRUE",
    "dropphyst": "OK",
    "dropphyzpp": 740609998,
    "dropmaladd": "101 BROADWAY",
    "dropmalcty": "PRUE",
    "dropmalst": "OK",
    "dropmalzpp": 740609998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182423220,
    "dropsitcph": 9182423220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22416",
    "droptype": "D",
    "dropname": "PRYOR",
    "dropdeladd": "111 S ADAIR ST",
    "dropdelcty": "PRYOR",
    "dropdelst": "OK",
    "dropdelzpp": 743619998,
    "dropphyadd": "111 S ADAIR ST",
    "dropphycty": "PRYOR",
    "dropphyst": "OK",
    "dropphyzpp": 743619998,
    "dropmaladd": "111 S ADAIR ST",
    "dropmalcty": "PRYOR",
    "dropmalst": "OK",
    "dropmalzpp": 743619998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188256562,
    "dropsitcph": 9188256562,
    "dropfax": 9188253088
  },
  {
    "dcode": "D",
    "dropkey": "PW22417",
    "droptype": "D",
    "dropname": "PURCELL",
    "dropdeladd": "228 W MAIN ST",
    "dropdelcty": "PURCELL",
    "dropdelst": "OK",
    "dropdelzpp": 730809998,
    "dropphyadd": "228 W MAIN ST",
    "dropphycty": "PURCELL",
    "dropphyst": "OK",
    "dropphyzpp": 730809998,
    "dropmaladd": "228 W MAIN ST",
    "dropmalcty": "PURCELL",
    "dropmalst": "OK",
    "dropmalzpp": 730809998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055277744,
    "dropsitcph": 4055277744,
    "dropfax": 4055276380
  },
  {
    "dcode": "D",
    "dropkey": "PW22422",
    "droptype": "D",
    "dropname": "QUAPAW",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "QUAPAW",
    "dropdelst": "OK",
    "dropdelzpp": 743639998,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "QUAPAW",
    "dropphyst": "OK",
    "dropphyzpp": 743639998,
    "dropmaladd": "601 MAIN ST",
    "dropmalcty": "QUAPAW",
    "dropmalst": "OK",
    "dropmalzpp": 743639998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186742511,
    "dropsitcph": 9186742511,
    "dropfax": 9186742511
  },
  {
    "dcode": "D",
    "dropkey": "PW22423",
    "droptype": "D",
    "dropname": "QUINTON",
    "dropdeladd": "911 E MAIN ST",
    "dropdelcty": "QUINTON",
    "dropdelst": "OK",
    "dropdelzpp": 745619998,
    "dropphyadd": "911 E MAIN ST",
    "dropphycty": "QUINTON",
    "dropphyst": "OK",
    "dropphyzpp": 745619998,
    "dropmaladd": "911 E MAIN ST",
    "dropmalcty": "QUINTON",
    "dropmalst": "OK",
    "dropmalzpp": 745619998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184692686,
    "dropsitcph": 9184692686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22424",
    "droptype": "D",
    "dropname": "RALSTON",
    "dropdeladd": "560 E MAIN ST",
    "dropdelcty": "RALSTON",
    "dropdelst": "OK",
    "dropdelzpp": 746509998,
    "dropphyadd": "560 E MAIN ST",
    "dropphycty": "RALSTON",
    "dropphyst": "OK",
    "dropphyzpp": 746509998,
    "dropmaladd": "560 E MAIN ST",
    "dropmalcty": "RALSTON",
    "dropmalst": "OK",
    "dropmalzpp": 746509998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187384310,
    "dropsitcph": 9187384310,
    "dropfax": 9187384310
  },
  {
    "dcode": "D",
    "dropkey": "PW22425",
    "droptype": "D",
    "dropname": "RAMONA",
    "dropdeladd": "585 WYANDOTTE AVE",
    "dropdelcty": "RAMONA",
    "dropdelst": "OK",
    "dropdelzpp": 740619998,
    "dropphyadd": "585 WYANDOTTE AVE",
    "dropphycty": "RAMONA",
    "dropphyst": "OK",
    "dropphyzpp": 740619998,
    "dropmaladd": "585 WYANDOTTE AVE",
    "dropmalcty": "RAMONA",
    "dropmalst": "OK",
    "dropmalzpp": 740619998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185364455,
    "dropsitcph": 9185364455,
    "dropfax": 9185364455
  },
  {
    "dcode": "D",
    "dropkey": "PW22426",
    "droptype": "D",
    "dropname": "RANDLETT",
    "dropdeladd": "101 S 6TH ST",
    "dropdelcty": "RANDLETT",
    "dropdelst": "OK",
    "dropdelzpp": 735629998,
    "dropphyadd": "101 S 6TH ST",
    "dropphycty": "RANDLETT",
    "dropphyst": "OK",
    "dropphyzpp": 735629998,
    "dropmaladd": "101 S 6TH ST",
    "dropmalcty": "RANDLETT",
    "dropmalst": "OK",
    "dropmalzpp": 735629998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802813471,
    "dropsitcph": 5802813471,
    "dropfax": 5802813471
  },
  {
    "dcode": "D",
    "dropkey": "PW22427",
    "droptype": "D",
    "dropname": "RATLIFF CITY",
    "dropdeladd": "57 CHURCH ST",
    "dropdelcty": "RATLIFF CITY",
    "dropdelst": "OK",
    "dropdelzpp": 734819998,
    "dropphyadd": "57 CHURCH ST",
    "dropphycty": "RATLIFF CITY",
    "dropphyst": "OK",
    "dropphyzpp": 734819998,
    "dropmaladd": "57 CHURCH ST",
    "dropmalcty": "RATLIFF CITY",
    "dropmalst": "OK",
    "dropmalzpp": 734819998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808563484,
    "dropsitcph": 5808563484,
    "dropfax": 5808563484
  },
  {
    "dcode": "D",
    "dropkey": "PW22428",
    "droptype": "D",
    "dropname": "RATTAN",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "RATTAN",
    "dropdelst": "OK",
    "dropdelzpp": 745629998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "RATTAN",
    "dropphyst": "OK",
    "dropphyzpp": 745629998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "RATTAN",
    "dropmalst": "OK",
    "dropmalzpp": 745629998,
    "dropsitphn": 5805872337,
    "dropsitlph": 5805872337,
    "dropsitcph": 5805872337,
    "dropfax": 5805872337
  },
  {
    "dcode": "D",
    "dropkey": "PW22429",
    "droptype": "D",
    "dropname": "RAVIA",
    "dropdeladd": "312 E GRAND ST",
    "dropdelcty": "RAVIA",
    "dropdelst": "OK",
    "dropdelzpp": 734559998,
    "dropphyadd": "312 E GRAND ST",
    "dropphycty": "RAVIA",
    "dropphyst": "OK",
    "dropphyzpp": 734559998,
    "dropmaladd": "312 E GRAND ST",
    "dropmalcty": "RAVIA",
    "dropmalst": "OK",
    "dropmalzpp": 734559998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803713966,
    "dropsitcph": 5803713966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22430",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "111 NE DIVISION ST",
    "dropdelcty": "RED OAK",
    "dropdelst": "OK",
    "dropdelzpp": 745639998,
    "dropphyadd": "111 NE DIVISION ST",
    "dropphycty": "RED OAK",
    "dropphyst": "OK",
    "dropphyzpp": 745639998,
    "dropmaladd": "111 NE DIVISION ST",
    "dropmalcty": "RED OAK",
    "dropmalst": "OK",
    "dropmalzpp": 745639998,
    "dropsitphn": 9187010013,
    "dropsitlph": 9187010013,
    "dropsitcph": 9187010013,
    "dropfax": 9187010013
  },
  {
    "dcode": "D",
    "dropkey": "PW22431",
    "droptype": "D",
    "dropname": "RED ROCK",
    "dropdeladd": "500 MCKINLEY ST",
    "dropdelcty": "RED ROCK",
    "dropdelst": "OK",
    "dropdelzpp": 746519998,
    "dropphyadd": "500 MCKINLEY ST",
    "dropphycty": "RED ROCK",
    "dropphyst": "OK",
    "dropphyzpp": 746519998,
    "dropmaladd": "500 MCKINLEY ST",
    "dropmalcty": "RED ROCK",
    "dropmalst": "OK",
    "dropmalzpp": 746519998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5807234292,
    "dropsitcph": 5807234292,
    "dropfax": 5807234292
  },
  {
    "dcode": "D",
    "dropkey": "PW22435",
    "droptype": "D",
    "dropname": "RENTIESVILLE",
    "dropdeladd": "200 MCINTOSH ST",
    "dropdelcty": "RENTIESVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 744599800,
    "dropphyadd": "200 MCINTOSH ST",
    "dropphycty": "RENTIESVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 744599800,
    "dropmaladd": "200 MCINTOSH ST",
    "dropmalcty": "RENTIESVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 744599800,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184735675,
    "dropsitcph": 9184735675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22436",
    "droptype": "D",
    "dropname": "REYDON",
    "dropdeladd": "202 2ND AVE",
    "dropdelcty": "REYDON",
    "dropdelst": "OK",
    "dropdelzpp": 736609998,
    "dropphyadd": "202 2ND AVE",
    "dropphycty": "REYDON",
    "dropphyst": "OK",
    "dropphyzpp": 736609998,
    "dropmaladd": "202 2ND AVE",
    "dropmalcty": "REYDON",
    "dropmalst": "OK",
    "dropmalzpp": 736609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806554595,
    "dropsitcph": 5806554595,
    "dropfax": 5806554595
  },
  {
    "dcode": "D",
    "dropkey": "PW22438",
    "droptype": "D",
    "dropname": "RINGLING",
    "dropdeladd": "204 N 4TH ST",
    "dropdelcty": "RINGLING",
    "dropdelst": "OK",
    "dropdelzpp": 734569998,
    "dropphyadd": "204 N 4TH ST",
    "dropphycty": "RINGLING",
    "dropphyst": "OK",
    "dropphyzpp": 734569998,
    "dropmaladd": "204 N 4TH ST",
    "dropmalcty": "RINGLING",
    "dropmalst": "OK",
    "dropmalzpp": 734569998,
    "dropsitphn": 5806622103,
    "dropsitlph": 5806622103,
    "dropsitcph": 5806622103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22439",
    "droptype": "D",
    "dropname": "RINGOLD",
    "dropdeladd": "23112 W STATE HIGHWAY 3",
    "dropdelcty": "RINGOLD",
    "dropdelst": "OK",
    "dropdelzpp": 747549998,
    "dropphyadd": "23112 W STATE HIGHWAY 3",
    "dropphycty": "RINGOLD",
    "dropphyst": "OK",
    "dropphyzpp": 747549998,
    "dropmaladd": "23112 W STATE HIGHWAY 3",
    "dropmalcty": "RINGOLD",
    "dropmalst": "OK",
    "dropmalzpp": 747549998,
    "dropsitphn": 5802032070,
    "dropsitlph": 5802032070,
    "dropsitcph": 5802032070,
    "dropfax": 5802032070
  },
  {
    "dcode": "D",
    "dropkey": "PW22440",
    "droptype": "D",
    "dropname": "RINGWOOD",
    "dropdeladd": "124 S MAIN ST",
    "dropdelcty": "RINGWOOD",
    "dropdelst": "OK",
    "dropdelzpp": 737689998,
    "dropphyadd": "124 S MAIN ST",
    "dropphycty": "RINGWOOD",
    "dropphyst": "OK",
    "dropphyzpp": 737689998,
    "dropmaladd": "124 S MAIN ST",
    "dropmalcty": "RINGWOOD",
    "dropmalst": "OK",
    "dropmalzpp": 737689998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808832290,
    "dropsitcph": 5808832290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22441",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "RIPLEY",
    "dropdelst": "OK",
    "dropdelzpp": 740629998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "RIPLEY",
    "dropphyst": "OK",
    "dropphyzpp": 740629998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "RIPLEY",
    "dropmalst": "OK",
    "dropmalzpp": 740629998,
    "dropsitphn": 9183724540,
    "dropsitlph": 9183724540,
    "dropsitcph": 9183724540,
    "dropfax": 9183724540
  },
  {
    "dcode": "D",
    "dropkey": "PW22442",
    "droptype": "D",
    "dropname": "ROCKY",
    "dropdeladd": "313 MAIN ST",
    "dropdelcty": "ROCKY",
    "dropdelst": "OK",
    "dropdelzpp": 736619998,
    "dropphyadd": "313 MAIN ST",
    "dropphycty": "ROCKY",
    "dropphyst": "OK",
    "dropphyzpp": 736619998,
    "dropmaladd": "313 MAIN ST",
    "dropmalcty": "ROCKY",
    "dropmalst": "OK",
    "dropmalzpp": 736619998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806662468,
    "dropsitcph": 5806662468,
    "dropfax": 5806662468
  },
  {
    "dcode": "D",
    "dropkey": "PW22443",
    "droptype": "D",
    "dropname": "ROFF",
    "dropdeladd": "204 W MAIN ST",
    "dropdelcty": "ROFF",
    "dropdelst": "OK",
    "dropdelzpp": 748659998,
    "dropphyadd": "204 W MAIN ST",
    "dropphycty": "ROFF",
    "dropphyst": "OK",
    "dropphyzpp": 748659998,
    "dropmaladd": "204 W MAIN ST",
    "dropmalcty": "ROFF",
    "dropmalst": "OK",
    "dropmalzpp": 748659998,
    "dropsitphn": 5804567661,
    "dropsitlph": 5804567661,
    "dropsitcph": 5804567661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22444",
    "droptype": "D",
    "dropname": "ROLAND",
    "dropdeladd": "101 DAVIS LN",
    "dropdelcty": "ROLAND",
    "dropdelst": "OK",
    "dropdelzpp": 749549998,
    "dropphyadd": "101 DAVIS LN",
    "dropphycty": "ROLAND",
    "dropphyst": "OK",
    "dropphyzpp": 749549998,
    "dropmaladd": "101 DAVIS LN",
    "dropmalcty": "ROLAND",
    "dropmalst": "OK",
    "dropmalzpp": 749549998,
    "dropsitphn": 9184273032,
    "dropsitlph": 9184273032,
    "dropsitcph": 9184273032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22445",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "526 S MAIN ST",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "OK",
    "dropdelzpp": 735649998,
    "dropphyadd": "526 S MAIN ST",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "OK",
    "dropphyzpp": 735649998,
    "dropmaladd": "526 S MAIN ST",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "OK",
    "dropmalzpp": 735649998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806392466,
    "dropsitcph": 5806392466,
    "dropfax": 5806392524
  },
  {
    "dcode": "D",
    "dropkey": "PW22446",
    "droptype": "D",
    "dropname": "ROSE",
    "dropdeladd": "5904 S 448 RD",
    "dropdelcty": "ROSE",
    "dropdelst": "OK",
    "dropdelzpp": 743649998,
    "dropphyadd": "5904 S 448 RD",
    "dropphycty": "ROSE",
    "dropphyst": "OK",
    "dropphyzpp": 743649998,
    "dropmaladd": "5904 S 448 RD",
    "dropmalcty": "ROSE",
    "dropmalst": "OK",
    "dropmalzpp": 743649998,
    "dropsitphn": 9184791192,
    "dropsitlph": 9184791192,
    "dropsitcph": 9184796713,
    "dropfax": 9184796713
  },
  {
    "dcode": "D",
    "dropkey": "PW22449",
    "droptype": "D",
    "dropname": "RUFE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "RUFE",
    "dropdelst": "OK",
    "dropdelzpp": 747559998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "RUFE",
    "dropphyst": "OK",
    "dropphyzpp": 747559998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "RUFE",
    "dropmalst": "OK",
    "dropmalzpp": 747559998,
    "dropsitphn": 5809812725,
    "dropsitlph": 5809812725,
    "dropsitcph": 5808763224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22450",
    "droptype": "D",
    "dropname": "RUSH SPRINGS",
    "dropdeladd": "317 W BLAKELY ST",
    "dropdelcty": "RUSH SPRINGS",
    "dropdelst": "OK",
    "dropdelzpp": 730829998,
    "dropphyadd": "317 W BLAKELY ST",
    "dropphycty": "RUSH SPRINGS",
    "dropphyst": "OK",
    "dropphyzpp": 730829998,
    "dropmaladd": "317 W BLAKELY ST",
    "dropmalcty": "RUSH SPRINGS",
    "dropmalst": "OK",
    "dropmalzpp": 730829998,
    "dropsitphn": 5804763897,
    "dropsitlph": 5804763897,
    "dropsitcph": 5804763897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22451",
    "droptype": "D",
    "dropname": "RYAN",
    "dropdeladd": "1114 5TH ST",
    "dropdelcty": "RYAN",
    "dropdelst": "OK",
    "dropdelzpp": 735659998,
    "dropphyadd": "1114 5TH ST",
    "dropphycty": "RYAN",
    "dropphyst": "OK",
    "dropphyzpp": 735659998,
    "dropmaladd": "1114 5TH ST",
    "dropmalcty": "RYAN",
    "dropmalst": "OK",
    "dropmalzpp": 735659998,
    "dropsitphn": 5807572238,
    "dropsitlph": 5807572238,
    "dropsitcph": 5807572238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22452",
    "droptype": "D",
    "dropname": "S COFFEYVILLE",
    "dropdeladd": "501 WILLOW ST",
    "dropdelcty": "S COFFEYVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 740729998,
    "dropphyadd": "501 WILLOW ST",
    "dropphycty": "S COFFEYVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 740729998,
    "dropmaladd": "501 WILLOW ST",
    "dropmalcty": "S COFFEYVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 740729998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182556344,
    "dropsitcph": 9182556344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22453",
    "droptype": "D",
    "dropname": "SAINT LOUIS",
    "dropdeladd": "34000 SAINT LOUIS RD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "OK",
    "dropdelzpp": 748669998,
    "dropphyadd": "34000 SAINT LOUIS RD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "OK",
    "dropphyzpp": 748669998,
    "dropmaladd": "34000 SAINT LOUIS RD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "OK",
    "dropmalzpp": 748669998,
    "dropsitphn": 4052893300,
    "dropsitlph": 4052893300,
    "dropsitcph": 4052893300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22455",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "200 S CHEROKEE ST",
    "dropdelcty": "SALINA",
    "dropdelst": "OK",
    "dropdelzpp": 743659998,
    "dropphyadd": "200 S CHEROKEE ST",
    "dropphycty": "SALINA",
    "dropphyst": "OK",
    "dropphyzpp": 743659998,
    "dropmaladd": "200 S CHEROKEE ST",
    "dropmalcty": "SALINA",
    "dropmalst": "OK",
    "dropmalzpp": 743659998,
    "dropsitphn": 9184342520,
    "dropsitlph": 9184342520,
    "dropsitcph": 9184342520,
    "dropfax": 9184342731
  },
  {
    "dcode": "D",
    "dropkey": "PW22456",
    "droptype": "D",
    "dropname": "SALLISAW",
    "dropdeladd": "111 S MCGEE DR",
    "dropdelcty": "SALLISAW",
    "dropdelst": "OK",
    "dropdelzpp": 749559998,
    "dropphyadd": "111 S MCGEE DR",
    "dropphycty": "SALLISAW",
    "dropphyst": "OK",
    "dropphyzpp": 749559998,
    "dropmaladd": "111 S MCGEE DR",
    "dropmalcty": "SALLISAW",
    "dropmalst": "OK",
    "dropmalzpp": 749559998,
    "dropsitphn": 9187756578,
    "dropsitlph": 9187756578,
    "dropsitcph": 9187756578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22457",
    "droptype": "D",
    "dropname": "SAND SPRINGS",
    "dropdeladd": "114 W 2ND ST",
    "dropdelcty": "SAND SPRINGS",
    "dropdelst": "OK",
    "dropdelzpp": 740639998,
    "dropphyadd": "114 W 2ND ST",
    "dropphycty": "SAND SPRINGS",
    "dropphyst": "OK",
    "dropphyzpp": 740639998,
    "dropmaladd": "114 W 2ND ST",
    "dropmalcty": "SAND SPRINGS",
    "dropmalst": "OK",
    "dropmalzpp": 740639998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182454402,
    "dropsitcph": 9182454402,
    "dropfax": 9182452143
  },
  {
    "dcode": "D",
    "dropkey": "PW22458",
    "droptype": "D",
    "dropname": "SAPULPA",
    "dropdeladd": "410 S MAIN ST",
    "dropdelcty": "SAPULPA",
    "dropdelst": "OK",
    "dropdelzpp": 740669998,
    "dropphyadd": "410 S MAIN ST",
    "dropphycty": "SAPULPA",
    "dropphyst": "OK",
    "dropphyzpp": 740669998,
    "dropmaladd": "410 S MAIN ST",
    "dropmalcty": "SAPULPA",
    "dropmalst": "OK",
    "dropmalzpp": 740669998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182243527,
    "dropsitcph": 9182243527,
    "dropfax": 9182241411
  },
  {
    "dcode": "D",
    "dropkey": "PW22459",
    "droptype": "D",
    "dropname": "SASAKWA",
    "dropdeladd": "101 S OLIVE ST",
    "dropdelcty": "SASAKWA",
    "dropdelst": "OK",
    "dropdelzpp": 748676761,
    "dropphyadd": "101 S OLIVE ST",
    "dropphycty": "SASAKWA",
    "dropphyst": "OK",
    "dropphyzpp": 748676761,
    "dropmaladd": "101 S OLIVE ST",
    "dropmalcty": "SASAKWA",
    "dropmalst": "OK",
    "dropmalzpp": 748676761,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059413679,
    "dropsitcph": 4059413679,
    "dropfax": 4059413679
  },
  {
    "dcode": "D",
    "dropkey": "PW22460",
    "droptype": "D",
    "dropname": "SAVANNA",
    "dropdeladd": "15 S MAIN ST",
    "dropdelcty": "SAVANNA",
    "dropdelst": "OK",
    "dropdelzpp": 745659998,
    "dropphyadd": "15 S MAIN ST",
    "dropphycty": "SAVANNA",
    "dropphyst": "OK",
    "dropphyzpp": 745659998,
    "dropmaladd": "15 S MAIN ST",
    "dropmalcty": "SAVANNA",
    "dropmalst": "OK",
    "dropmalzpp": 745659998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185483771,
    "dropsitcph": 9185483771,
    "dropfax": 9185483771
  },
  {
    "dcode": "D",
    "dropkey": "PW22461",
    "droptype": "D",
    "dropname": "SAWYER",
    "dropdeladd": "320 SAWYER DAM RD",
    "dropdelcty": "SAWYER",
    "dropdelst": "OK",
    "dropdelzpp": 747569998,
    "dropphyadd": "320 SAWYER DAM RD",
    "dropphycty": "SAWYER",
    "dropphyst": "OK",
    "dropphyzpp": 747569998,
    "dropmaladd": "320 SAWYER DAM RD",
    "dropmalcty": "SAWYER",
    "dropmalst": "OK",
    "dropmalzpp": 747569998,
    "dropsitphn": 5803262747,
    "dropsitlph": 5803262747,
    "dropsitcph": 5803262747,
    "dropfax": 5803262747
  },
  {
    "dcode": "D",
    "dropkey": "PW22462",
    "droptype": "D",
    "dropname": "SAYRE",
    "dropdeladd": "201 N 4TH ST",
    "dropdelcty": "SAYRE",
    "dropdelst": "OK",
    "dropdelzpp": 736629998,
    "dropphyadd": "201 N 4TH ST",
    "dropphycty": "SAYRE",
    "dropphyst": "OK",
    "dropphyzpp": 736629998,
    "dropmaladd": "201 N 4TH ST",
    "dropmalcty": "SAYRE",
    "dropmalst": "OK",
    "dropmalzpp": 736629998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809283489,
    "dropsitcph": 5809283489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22464",
    "droptype": "D",
    "dropname": "SCHULTER",
    "dropdeladd": "13445 GINGER ST",
    "dropdelcty": "SCHULTER",
    "dropdelst": "OK",
    "dropdelzpp": 744609998,
    "dropphyadd": "13445 GINGER ST",
    "dropphycty": "SCHULTER",
    "dropphyst": "OK",
    "dropphyzpp": 744609998,
    "dropmaladd": "13445 GINGER ST",
    "dropmalcty": "SCHULTER",
    "dropmalst": "OK",
    "dropmalzpp": 744609998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186527553,
    "dropsitcph": 9186527553,
    "dropfax": 9186509165
  },
  {
    "dcode": "D",
    "dropkey": "PW22466",
    "droptype": "D",
    "dropname": "SEILING",
    "dropdeladd": "209 N WALNUT ST",
    "dropdelcty": "SEILING",
    "dropdelst": "OK",
    "dropdelzpp": 736639998,
    "dropphyadd": "209 N WALNUT ST",
    "dropphycty": "SEILING",
    "dropphyst": "OK",
    "dropphyzpp": 736639998,
    "dropmaladd": "209 N WALNUT ST",
    "dropmalcty": "SEILING",
    "dropmalst": "OK",
    "dropmalzpp": 736639998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809223304,
    "dropsitcph": 5809223304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22468",
    "droptype": "D",
    "dropname": "SEMINOLE",
    "dropdeladd": "120 E OAK AVE",
    "dropdelcty": "SEMINOLE",
    "dropdelst": "OK",
    "dropdelzpp": 748689998,
    "dropphyadd": "120 E OAK AVE",
    "dropphycty": "SEMINOLE",
    "dropphyst": "OK",
    "dropphyzpp": 748689998,
    "dropmaladd": "120 E OAK AVE",
    "dropmalcty": "SEMINOLE",
    "dropmalst": "OK",
    "dropmalzpp": 748689998,
    "dropsitphn": 4053820152,
    "dropsitlph": 4053820152,
    "dropsitcph": 4053820152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22469",
    "droptype": "D",
    "dropname": "SENTINEL",
    "dropdeladd": "312 E MAIN ST",
    "dropdelcty": "SENTINEL",
    "dropdelst": "OK",
    "dropdelzpp": 736649998,
    "dropphyadd": "312 E MAIN ST",
    "dropphycty": "SENTINEL",
    "dropphyst": "OK",
    "dropphyzpp": 736649998,
    "dropmaladd": "312 E MAIN ST",
    "dropmalcty": "SENTINEL",
    "dropmalst": "OK",
    "dropmalzpp": 736649998,
    "dropsitphn": 5803932234,
    "dropsitlph": 5803932234,
    "dropsitcph": 5803932234,
    "dropfax": 5803932234
  },
  {
    "dcode": "D",
    "dropkey": "PW22470",
    "droptype": "D",
    "dropname": "SHADY POINT",
    "dropdeladd": "23067 WHEELUS ST",
    "dropdelcty": "SHADY POINT",
    "dropdelst": "OK",
    "dropdelzpp": 749569998,
    "dropphyadd": "23067 WHEELUS ST",
    "dropphycty": "SHADY POINT",
    "dropphyst": "OK",
    "dropphyzpp": 749569998,
    "dropmaladd": "23067 WHEELUS ST",
    "dropmalcty": "SHADY POINT",
    "dropmalst": "OK",
    "dropmalzpp": 749569998,
    "dropsitphn": 9182650416,
    "dropsitlph": 9182650416,
    "dropsitcph": 9182650416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22471",
    "droptype": "D",
    "dropname": "SHAMROCK",
    "dropdeladd": "108 E TIPPERARY RD",
    "dropdelcty": "SHAMROCK",
    "dropdelst": "OK",
    "dropdelzpp": 740689998,
    "dropphyadd": "108 E TIPPERARY RD",
    "dropphycty": "SHAMROCK",
    "dropphyst": "OK",
    "dropphyzpp": 740689998,
    "dropmaladd": "108 E TIPPERARY RD",
    "dropmalcty": "SHAMROCK",
    "dropmalst": "OK",
    "dropmalzpp": 740689998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183529628,
    "dropsitcph": 9183529628,
    "dropfax": 9183529628
  },
  {
    "dcode": "D",
    "dropkey": "PW22472",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "SHARON",
    "dropdelst": "OK",
    "dropdelzpp": 738579998,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "SHARON",
    "dropphyst": "OK",
    "dropphyzpp": 738579998,
    "dropmaladd": "114 N MAIN ST",
    "dropmalcty": "SHARON",
    "dropmalst": "OK",
    "dropmalzpp": 738579998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808663346,
    "dropsitcph": 5808663346,
    "dropfax": 5808663346
  },
  {
    "dcode": "D",
    "dropkey": "PW22474",
    "droptype": "D",
    "dropname": "SHATTUCK",
    "dropdeladd": "513 S MAIN ST",
    "dropdelcty": "SHATTUCK",
    "dropdelst": "OK",
    "dropdelzpp": 738589998,
    "dropphyadd": "513 S MAIN ST",
    "dropphycty": "SHATTUCK",
    "dropphyst": "OK",
    "dropphyzpp": 738589998,
    "dropmaladd": "513 S MAIN ST",
    "dropmalcty": "SHATTUCK",
    "dropmalst": "OK",
    "dropmalzpp": 738589998,
    "dropsitphn": 5809382355,
    "dropsitlph": 5809382355,
    "dropsitcph": 5809382355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22476",
    "droptype": "D",
    "dropname": "SHAWNEE",
    "dropdeladd": "116 E 9TH ST",
    "dropdelcty": "SHAWNEE",
    "dropdelst": "OK",
    "dropdelzpp": 748019998,
    "dropphyadd": "116 E 9TH ST",
    "dropphycty": "SHAWNEE",
    "dropphyst": "OK",
    "dropphyzpp": 748019998,
    "dropmaladd": "116 E 9TH ST",
    "dropmalcty": "SHAWNEE",
    "dropmalst": "OK",
    "dropmalzpp": 748019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058780184,
    "dropsitcph": 4058780184,
    "dropfax": 4052754685
  },
  {
    "dcode": "D",
    "dropkey": "PW22482",
    "droptype": "D",
    "dropname": "SHIDLER",
    "dropdeladd": "301 S COSDEN AVE",
    "dropdelcty": "SHIDLER",
    "dropdelst": "OK",
    "dropdelzpp": 746529998,
    "dropphyadd": "301 S COSDEN AVE",
    "dropphycty": "SHIDLER",
    "dropphyst": "OK",
    "dropphyzpp": 746529998,
    "dropmaladd": "301 S COSDEN AVE",
    "dropmalcty": "SHIDLER",
    "dropmalst": "OK",
    "dropmalzpp": 746529998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187934641,
    "dropsitcph": 9187934641,
    "dropfax": 9187934642
  },
  {
    "dcode": "D",
    "dropkey": "PW22485",
    "droptype": "D",
    "dropname": "SKIATOOK",
    "dropdeladd": "303 E 2ND ST",
    "dropdelcty": "SKIATOOK",
    "dropdelst": "OK",
    "dropdelzpp": 740709998,
    "dropphyadd": "303 E 2ND ST",
    "dropphycty": "SKIATOOK",
    "dropphyst": "OK",
    "dropphyzpp": 740709998,
    "dropmaladd": "303 E 2ND ST",
    "dropmalcty": "SKIATOOK",
    "dropmalst": "OK",
    "dropmalzpp": 740709998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183962495,
    "dropsitcph": 9183962495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22486",
    "droptype": "D",
    "dropname": "SLICK",
    "dropdeladd": "104 N COLUMBIA",
    "dropdelcty": "SLICK",
    "dropdelst": "OK",
    "dropdelzpp": 740719998,
    "dropphyadd": "104 N COLUMBIA",
    "dropphycty": "SLICK",
    "dropphyst": "OK",
    "dropphyzpp": 740719998,
    "dropmaladd": "104 N COLUMBIA",
    "dropmalcty": "SLICK",
    "dropmalst": "OK",
    "dropmalzpp": 740719998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183672401,
    "dropsitcph": 9183672401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22487",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "209 STATE HIGHWAY 4",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 749579998,
    "dropphyadd": "209 STATE HIGHWAY 4",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 749579998,
    "dropmaladd": "209 STATE HIGHWAY 4",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 749579998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802443330,
    "dropsitcph": 5802443330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22488",
    "droptype": "D",
    "dropname": "SNOW",
    "dropdeladd": "180411 US HIGHWAY 271",
    "dropdelcty": "SNOW",
    "dropdelst": "OK",
    "dropdelzpp": 745679998,
    "dropphyadd": "180411 US HIGHWAY 271",
    "dropphycty": "SNOW",
    "dropphyst": "OK",
    "dropphyzpp": 745679998,
    "dropmaladd": "180411 US HIGHWAY 271",
    "dropmalcty": "SNOW",
    "dropmalst": "OK",
    "dropmalzpp": 745679998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5802982875,
    "dropsitcph": 5802982875,
    "dropfax": 5802982875
  },
  {
    "dcode": "D",
    "dropkey": "PW22489",
    "droptype": "D",
    "dropname": "SNYDER",
    "dropdeladd": "401 7TH ST",
    "dropdelcty": "SNYDER",
    "dropdelst": "OK",
    "dropdelzpp": 735669998,
    "dropphyadd": "401 7TH ST",
    "dropphycty": "SNYDER",
    "dropphyst": "OK",
    "dropphyzpp": 735669998,
    "dropmaladd": "401 7TH ST",
    "dropmalcty": "SNYDER",
    "dropmalst": "OK",
    "dropmalzpp": 735669998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805692209,
    "dropsitcph": 5805692209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22492",
    "droptype": "D",
    "dropname": "SOPER",
    "dropdeladd": "300 PARIS AVE",
    "dropdelcty": "SOPER",
    "dropdelst": "OK",
    "dropdelzpp": 747599998,
    "dropphyadd": "300 PARIS AVE",
    "dropphycty": "SOPER",
    "dropphyst": "OK",
    "dropphyzpp": 747599998,
    "dropmaladd": "300 PARIS AVE",
    "dropmalcty": "SOPER",
    "dropmalst": "OK",
    "dropmalzpp": 747599998,
    "dropsitphn": 5803452600,
    "dropsitlph": 5803452600,
    "dropsitcph": 5803452600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22500",
    "droptype": "D",
    "dropname": "SPARKS",
    "dropdeladd": "316 BROADWAY ST",
    "dropdelcty": "SPARKS",
    "dropdelst": "OK",
    "dropdelzpp": 748699998,
    "dropphyadd": "316 BROADWAY ST",
    "dropphycty": "SPARKS",
    "dropphyst": "OK",
    "dropphyzpp": 748699998,
    "dropmaladd": "316 BROADWAY ST",
    "dropmalcty": "SPARKS",
    "dropmalst": "OK",
    "dropmalzpp": 748699998,
    "dropsitphn": 4058152724,
    "dropsitlph": 9188662271,
    "dropsitcph": 9188662271,
    "dropfax": 9188662271
  },
  {
    "dcode": "D",
    "dropkey": "PW22501",
    "droptype": "D",
    "dropname": "SPAVINAW",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "SPAVINAW",
    "dropdelst": "OK",
    "dropdelzpp": 743669998,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "SPAVINAW",
    "dropphyst": "OK",
    "dropphyzpp": 743669998,
    "dropmaladd": "125 N MAIN ST",
    "dropmalcty": "SPAVINAW",
    "dropmalst": "OK",
    "dropmalzpp": 743669998,
    "dropsitphn": 9185892217,
    "dropsitlph": 9185892217,
    "dropsitcph": 9185892217,
    "dropfax": 9185892217
  },
  {
    "dcode": "D",
    "dropkey": "PW22503",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "3601 SPENCER RD",
    "dropdelcty": "SPENCER",
    "dropdelst": "OK",
    "dropdelzpp": 730849998,
    "dropphyadd": "3601 SPENCER RD",
    "dropphycty": "SPENCER",
    "dropphyst": "OK",
    "dropphyzpp": 730849998,
    "dropmaladd": "3601 SPENCER RD",
    "dropmalcty": "SPENCER",
    "dropmalst": "OK",
    "dropmalzpp": 730849998,
    "dropsitphn": 4052462977,
    "dropsitlph": 4057714867,
    "dropsitcph": 4057714867,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22505",
    "droptype": "D",
    "dropname": "SPERRY",
    "dropdeladd": "117 N CINCINNATI AVE",
    "dropdelcty": "SPERRY",
    "dropdelst": "OK",
    "dropdelzpp": 740739998,
    "dropphyadd": "117 N CINCINNATI AVE",
    "dropphycty": "SPERRY",
    "dropphyst": "OK",
    "dropphyzpp": 740739998,
    "dropmaladd": "117 N CINCINNATI AVE",
    "dropmalcty": "SPERRY",
    "dropmalst": "OK",
    "dropmalzpp": 740739998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9182886289,
    "dropsitcph": 9182886289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22506",
    "droptype": "D",
    "dropname": "SPIRO",
    "dropdeladd": "123 N MAIN ST",
    "dropdelcty": "SPIRO",
    "dropdelst": "OK",
    "dropdelzpp": 749599998,
    "dropphyadd": "123 N MAIN ST",
    "dropphycty": "SPIRO",
    "dropphyst": "OK",
    "dropphyzpp": 749599998,
    "dropmaladd": "123 N MAIN ST",
    "dropmalcty": "SPIRO",
    "dropmalst": "OK",
    "dropmalzpp": 749599998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9189623247,
    "dropsitcph": 9189623247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22507",
    "droptype": "D",
    "dropname": "SPRINGER",
    "dropdeladd": "16625 US HIGHWAY 77",
    "dropdelcty": "SPRINGER",
    "dropdelst": "OK",
    "dropdelzpp": 734589998,
    "dropphyadd": "16625 US HIGHWAY 77",
    "dropphycty": "SPRINGER",
    "dropphyst": "OK",
    "dropphyzpp": 734589998,
    "dropmaladd": "16625 US HIGHWAY 77",
    "dropmalcty": "SPRINGER",
    "dropmalst": "OK",
    "dropmalzpp": 734589998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806532741,
    "dropsitcph": 5806532741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22518",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "210 W MAIN ST",
    "dropdelcty": "STERLING",
    "dropdelst": "OK",
    "dropdelzpp": 735679998,
    "dropphyadd": "210 W MAIN ST",
    "dropphycty": "STERLING",
    "dropphyst": "OK",
    "dropphyzpp": 735679998,
    "dropmaladd": "210 W MAIN ST",
    "dropmalcty": "STERLING",
    "dropmalst": "OK",
    "dropmalzpp": 735679998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803654320,
    "dropsitcph": 5803654320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22520",
    "droptype": "D",
    "dropname": "STIGLER",
    "dropdeladd": "120 N BROADWAY ST",
    "dropdelcty": "STIGLER",
    "dropdelst": "OK",
    "dropdelzpp": 744629998,
    "dropphyadd": "120 N BROADWAY ST",
    "dropphycty": "STIGLER",
    "dropphyst": "OK",
    "dropphyzpp": 744629998,
    "dropmaladd": "120 N BROADWAY ST",
    "dropmalcty": "STIGLER",
    "dropmalst": "OK",
    "dropmalzpp": 744629998,
    "dropsitphn": 9189678873,
    "dropsitlph": 9189678873,
    "dropsitcph": 9189678873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22521",
    "droptype": "D",
    "dropname": "STILLWATER",
    "dropdeladd": "809 S LEWIS ST",
    "dropdelcty": "STILLWATER",
    "dropdelst": "OK",
    "dropdelzpp": 740749998,
    "dropphyadd": "809 S LEWIS ST",
    "dropphycty": "STILLWATER",
    "dropphyst": "OK",
    "dropphyzpp": 740749998,
    "dropmaladd": "809 S LEWIS ST",
    "dropmalcty": "STILLWATER",
    "dropmalst": "OK",
    "dropmalzpp": 740749998,
    "dropsitphn": 9182707512,
    "dropsitlph": 4053773867,
    "dropsitcph": 4053773867,
    "dropfax": 4053728306
  },
  {
    "dcode": "D",
    "dropkey": "PW22522",
    "droptype": "D",
    "dropname": "STILWELL",
    "dropdeladd": "16 S 2ND ST",
    "dropdelcty": "STILWELL",
    "dropdelst": "OK",
    "dropdelzpp": 749609998,
    "dropphyadd": "16 S 2ND ST",
    "dropphycty": "STILWELL",
    "dropphyst": "OK",
    "dropphyzpp": 749609998,
    "dropmaladd": "16 S 2ND ST",
    "dropmalcty": "STILWELL",
    "dropmalst": "OK",
    "dropmalzpp": 749609998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186967173,
    "dropsitcph": 9186967173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22524",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "124 W MAIN ST",
    "dropdelcty": "STONEWALL",
    "dropdelst": "OK",
    "dropdelzpp": 748719998,
    "dropphyadd": "124 W MAIN ST",
    "dropphycty": "STONEWALL",
    "dropphyst": "OK",
    "dropphyzpp": 748719998,
    "dropmaladd": "124 W MAIN ST",
    "dropmalcty": "STONEWALL",
    "dropmalst": "OK",
    "dropmalzpp": 748719998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802654220,
    "dropsitcph": 5802654220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22525",
    "droptype": "D",
    "dropname": "STRANG",
    "dropdeladd": "104 E BROADWAY",
    "dropdelcty": "STRANG",
    "dropdelst": "OK",
    "dropdelzpp": 743679998,
    "dropphyadd": "104 E BROADWAY",
    "dropphycty": "STRANG",
    "dropphyst": "OK",
    "dropphyzpp": 743679998,
    "dropmaladd": "104 E BROADWAY",
    "dropmalcty": "STRANG",
    "dropmalst": "OK",
    "dropmalzpp": 743679998,
    "dropsitphn": 9187852234,
    "dropsitlph": 9187852234,
    "dropsitcph": 9185932390,
    "dropfax": 9185932390
  },
  {
    "dcode": "D",
    "dropkey": "PW22526",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "116 E MAIN ST",
    "dropdelcty": "STRATFORD",
    "dropdelst": "OK",
    "dropdelzpp": 748729998,
    "dropphyadd": "116 E MAIN ST",
    "dropphycty": "STRATFORD",
    "dropphyst": "OK",
    "dropphyzpp": 748729998,
    "dropmaladd": "116 E MAIN ST",
    "dropmalcty": "STRATFORD",
    "dropmalst": "OK",
    "dropmalzpp": 748729998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807592319,
    "dropsitcph": 5807592319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22527",
    "droptype": "D",
    "dropname": "STRINGTOWN",
    "dropdeladd": "164 E REBA MCENTIRE AVE",
    "dropdelcty": "STRINGTOWN",
    "dropdelst": "OK",
    "dropdelzpp": 745699801,
    "dropphyadd": "164 E REBA MCENTIRE AVE",
    "dropphycty": "STRINGTOWN",
    "dropphyst": "OK",
    "dropphyzpp": 745699801,
    "dropmaladd": "164 E REBA MCENTIRE AVE",
    "dropmalcty": "STRINGTOWN",
    "dropmalst": "OK",
    "dropmalzpp": 745699801,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803467733,
    "dropsitcph": 5803467733,
    "dropfax": 5803467733
  },
  {
    "dcode": "D",
    "dropkey": "PW22529",
    "droptype": "D",
    "dropname": "STROUD",
    "dropdeladd": "601 W MAIN ST",
    "dropdelcty": "STROUD",
    "dropdelst": "OK",
    "dropdelzpp": 740799998,
    "dropphyadd": "601 W MAIN ST",
    "dropphycty": "STROUD",
    "dropphyst": "OK",
    "dropphyzpp": 740799998,
    "dropmaladd": "601 W MAIN ST",
    "dropmalcty": "STROUD",
    "dropmalst": "OK",
    "dropmalzpp": 740799998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9189682626,
    "dropsitcph": 9189682626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22530",
    "droptype": "D",
    "dropname": "STUART",
    "dropdeladd": "619 ROOSEVELT AVE",
    "dropdelcty": "STUART",
    "dropdelst": "OK",
    "dropdelzpp": 745709998,
    "dropphyadd": "619 ROOSEVELT AVE",
    "dropphycty": "STUART",
    "dropphyst": "OK",
    "dropphyzpp": 745709998,
    "dropmaladd": "619 ROOSEVELT AVE",
    "dropmalcty": "STUART",
    "dropmalst": "OK",
    "dropmalzpp": 745709998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185462626,
    "dropsitcph": 9185462626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22531",
    "droptype": "D",
    "dropname": "SULPHUR",
    "dropdeladd": "1100 W 2ND ST",
    "dropdelcty": "SULPHUR",
    "dropdelst": "OK",
    "dropdelzpp": 730869998,
    "dropphyadd": "1100 W 2ND ST",
    "dropphycty": "SULPHUR",
    "dropphyst": "OK",
    "dropphyzpp": 730869998,
    "dropmaladd": "1100 W 2ND ST",
    "dropmalcty": "SULPHUR",
    "dropmalst": "OK",
    "dropmalzpp": 730869998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806223030,
    "dropsitcph": 5806223030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22535",
    "droptype": "D",
    "dropname": "SWINK",
    "dropdeladd": "100 FRONT ST",
    "dropdelcty": "SWINK",
    "dropdelst": "OK",
    "dropdelzpp": 747619998,
    "dropphyadd": "100 FRONT ST",
    "dropphycty": "SWINK",
    "dropphyst": "OK",
    "dropphyzpp": 747619998,
    "dropmaladd": "100 FRONT ST",
    "dropmalcty": "SWINK",
    "dropmalst": "OK",
    "dropmalzpp": 747619998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5808739226,
    "dropsitcph": 5808739226,
    "dropfax": 5808739226
  },
  {
    "dcode": "D",
    "dropkey": "PW22536",
    "droptype": "D",
    "dropname": "TAFT",
    "dropdeladd": "106 W CHEROKEE ST",
    "dropdelcty": "TAFT",
    "dropdelst": "OK",
    "dropdelzpp": 744639998,
    "dropphyadd": "106 W CHEROKEE ST",
    "dropphycty": "TAFT",
    "dropphyst": "OK",
    "dropphyzpp": 744639998,
    "dropmaladd": "106 W CHEROKEE ST",
    "dropmalcty": "TAFT",
    "dropmalst": "OK",
    "dropmalzpp": 744639998,
    "dropsitphn": 9186876701,
    "dropsitlph": 9186876701,
    "dropsitcph": 9186876701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22537",
    "droptype": "D",
    "dropname": "TAHLEQUAH",
    "dropdeladd": "1101 S MUSKOGEE AVE",
    "dropdelcty": "TAHLEQUAH",
    "dropdelst": "OK",
    "dropdelzpp": 744649998,
    "dropphyadd": "1101 S MUSKOGEE AVE",
    "dropphycty": "TAHLEQUAH",
    "dropphyst": "OK",
    "dropphyzpp": 744649998,
    "dropmaladd": "1101 S MUSKOGEE AVE",
    "dropmalcty": "TAHLEQUAH",
    "dropmalst": "OK",
    "dropmalzpp": 744649998,
    "dropsitphn": 9184562381,
    "dropsitlph": 9184562381,
    "dropsitcph": 9184562381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22538",
    "droptype": "D",
    "dropname": "TALALA",
    "dropdeladd": "112 N PINE ST",
    "dropdelcty": "TALALA",
    "dropdelst": "OK",
    "dropdelzpp": 740809998,
    "dropphyadd": "112 N PINE ST",
    "dropphycty": "TALALA",
    "dropphyst": "OK",
    "dropphyzpp": 740809998,
    "dropmaladd": "112 N PINE ST",
    "dropmalcty": "TALALA",
    "dropmalst": "OK",
    "dropmalzpp": 740809998,
    "dropsitphn": 9182754343,
    "dropsitlph": 9182754343,
    "dropsitcph": 9182754343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22539",
    "droptype": "D",
    "dropname": "TALIHINA",
    "dropdeladd": "403 DALLAS ST",
    "dropdelcty": "TALIHINA",
    "dropdelst": "OK",
    "dropdelzpp": 745719998,
    "dropphyadd": "403 DALLAS ST",
    "dropphycty": "TALIHINA",
    "dropphyst": "OK",
    "dropphyzpp": 745719998,
    "dropmaladd": "403 DALLAS ST",
    "dropmalcty": "TALIHINA",
    "dropmalst": "OK",
    "dropmalzpp": 745719998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185672924,
    "dropsitcph": 9185672924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22541",
    "droptype": "D",
    "dropname": "TALOGA",
    "dropdeladd": "119 S BROADWAY ST",
    "dropdelcty": "TALOGA",
    "dropdelst": "OK",
    "dropdelzpp": 736679998,
    "dropphyadd": "119 S BROADWAY ST",
    "dropphycty": "TALOGA",
    "dropphyst": "OK",
    "dropphyzpp": 736679998,
    "dropmaladd": "119 S BROADWAY ST",
    "dropmalcty": "TALOGA",
    "dropmalst": "OK",
    "dropmalzpp": 736679998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803285634,
    "dropsitcph": 5803285634,
    "dropfax": 5803285634
  },
  {
    "dcode": "D",
    "dropkey": "PW22543",
    "droptype": "D",
    "dropname": "TATUMS",
    "dropdeladd": "26 KING ST",
    "dropdelcty": "TATUMS",
    "dropdelst": "OK",
    "dropdelzpp": 734879998,
    "dropphyadd": "26 KING ST",
    "dropphycty": "TATUMS",
    "dropphyst": "OK",
    "dropphyzpp": 734879998,
    "dropmaladd": "26 KING ST",
    "dropmalcty": "TATUMS",
    "dropmalst": "OK",
    "dropmalzpp": 734879998,
    "dropsitphn": 5807882597,
    "dropsitlph": 5808563801,
    "dropsitcph": 5808563801,
    "dropfax": 5808563801
  },
  {
    "dcode": "D",
    "dropkey": "PW22544",
    "droptype": "D",
    "dropname": "TECUMSEH",
    "dropdeladd": "116 W PARK ST",
    "dropdelcty": "TECUMSEH",
    "dropdelst": "OK",
    "dropdelzpp": 748739998,
    "dropphyadd": "116 W PARK ST",
    "dropphycty": "TECUMSEH",
    "dropphyst": "OK",
    "dropphyzpp": 748739998,
    "dropmaladd": "116 W PARK ST",
    "dropmalcty": "TECUMSEH",
    "dropmalst": "OK",
    "dropmalzpp": 748739998,
    "dropsitphn": 4055986812,
    "dropsitlph": 4055986812,
    "dropsitcph": 4055986812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22545",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "209 S COMMERCIAL ST",
    "dropdelcty": "TEMPLE",
    "dropdelst": "OK",
    "dropdelzpp": 735689998,
    "dropphyadd": "209 S COMMERCIAL ST",
    "dropphycty": "TEMPLE",
    "dropphyst": "OK",
    "dropphyzpp": 735689998,
    "dropmaladd": "209 S COMMERCIAL ST",
    "dropmalcty": "TEMPLE",
    "dropmalst": "OK",
    "dropmalzpp": 735689998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803426864,
    "dropsitcph": 5803426864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22546",
    "droptype": "D",
    "dropname": "TERLTON",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "TERLTON",
    "dropdelst": "OK",
    "dropdelzpp": 740819998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "TERLTON",
    "dropphyst": "OK",
    "dropphyzpp": 740819998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "TERLTON",
    "dropmalst": "OK",
    "dropmalzpp": 740819998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187574215,
    "dropsitcph": 9187574215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22547",
    "droptype": "D",
    "dropname": "TERRAL",
    "dropdeladd": "309 E APACHE ST",
    "dropdelcty": "TERRAL",
    "dropdelst": "OK",
    "dropdelzpp": 735699998,
    "dropphyadd": "309 E APACHE ST",
    "dropphycty": "TERRAL",
    "dropphyst": "OK",
    "dropphyzpp": 735699998,
    "dropmaladd": "309 E APACHE ST",
    "dropmalcty": "TERRAL",
    "dropmalst": "OK",
    "dropmalzpp": 735699998,
    "dropsitphn": 5804372343,
    "dropsitlph": 5804372343,
    "dropsitcph": 5804372343,
    "dropfax": 5804372343
  },
  {
    "dcode": "D",
    "dropkey": "PW22549",
    "droptype": "D",
    "dropname": "TEXHOMA",
    "dropdeladd": "114 S 2ND ST",
    "dropdelcty": "TEXHOMA",
    "dropdelst": "OK",
    "dropdelzpp": 739499805,
    "dropphyadd": "114 S 2ND ST",
    "dropphycty": "TEXHOMA",
    "dropphyst": "OK",
    "dropphyzpp": 739499805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEXHOMA",
    "dropmalst": "OK",
    "dropmalzpp": 739499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5804237227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22551",
    "droptype": "D",
    "dropname": "THACKERVILLE",
    "dropdeladd": "19224 US HIGHWAY 77",
    "dropdelcty": "THACKERVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 734599998,
    "dropphyadd": "19224 US HIGHWAY 77",
    "dropphycty": "THACKERVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 734599998,
    "dropmaladd": "19224 US HIGHWAY 77",
    "dropmalcty": "THACKERVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 734599998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802763777,
    "dropsitcph": 5802763777,
    "dropfax": 5802763777
  },
  {
    "dcode": "D",
    "dropkey": "PW22554",
    "droptype": "D",
    "dropname": "THOMAS",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "THOMAS",
    "dropdelst": "OK",
    "dropdelzpp": 736699998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "THOMAS",
    "dropphyst": "OK",
    "dropphyzpp": 736699998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "THOMAS",
    "dropmalst": "OK",
    "dropmalzpp": 736699998,
    "dropsitphn": 5806612321,
    "dropsitlph": 5806612321,
    "dropsitcph": 5806612321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22557",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "TIPTON",
    "dropdelst": "OK",
    "dropdelzpp": 735709998,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "TIPTON",
    "dropphyst": "OK",
    "dropphyzpp": 735709998,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "TIPTON",
    "dropmalst": "OK",
    "dropmalzpp": 735709998,
    "dropsitphn": 5806675272,
    "dropsitlph": 5806675272,
    "dropsitcph": 5806675272,
    "dropfax": 9183742361
  },
  {
    "dcode": "D",
    "dropkey": "PW22558",
    "droptype": "D",
    "dropname": "TISHOMINGO",
    "dropdeladd": "108 N NESHOBA ST",
    "dropdelcty": "TISHOMINGO",
    "dropdelst": "OK",
    "dropdelzpp": 734609998,
    "dropphyadd": "108 N NESHOBA ST",
    "dropphycty": "TISHOMINGO",
    "dropphyst": "OK",
    "dropphyzpp": 734609998,
    "dropmaladd": "108 N NESHOBA ST",
    "dropmalcty": "TISHOMINGO",
    "dropmalst": "OK",
    "dropmalzpp": 734609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5803713225,
    "dropsitcph": 5803713225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22560",
    "droptype": "D",
    "dropname": "TONKAWA",
    "dropdeladd": "207 E TONKAWA AVE",
    "dropdelcty": "TONKAWA",
    "dropdelst": "OK",
    "dropdelzpp": 746539998,
    "dropphyadd": "207 E TONKAWA AVE",
    "dropphycty": "TONKAWA",
    "dropphyst": "OK",
    "dropphyzpp": 746539998,
    "dropmaladd": "207 E TONKAWA AVE",
    "dropmalcty": "TONKAWA",
    "dropmalst": "OK",
    "dropmalzpp": 746539998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5806283174,
    "dropsitcph": 5806283174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22562",
    "droptype": "D",
    "dropname": "TRYON",
    "dropdeladd": "10 S OKLAHOMA ST",
    "dropdelcty": "TRYON",
    "dropdelst": "OK",
    "dropdelzpp": 748759998,
    "dropphyadd": "10 S OKLAHOMA ST",
    "dropphycty": "TRYON",
    "dropphyst": "OK",
    "dropphyzpp": 748759998,
    "dropmaladd": "10 S OKLAHOMA ST",
    "dropmalcty": "TRYON",
    "dropmalst": "OK",
    "dropmalzpp": 748759998,
    "dropsitphn": 4058152724,
    "dropsitlph": 9183742361,
    "dropsitcph": 9183742361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22565",
    "droptype": "D",
    "dropname": "TULSA",
    "dropdeladd": "333 W 4TH ST",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741039998,
    "dropphyadd": "333 W 4TH ST",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741039998,
    "dropmaladd": "333 W 4TH ST",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741039998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185840493,
    "dropsitcph": 9185840489,
    "dropfax": 9185991136
  },
  {
    "dcode": "D",
    "dropkey": "PW22567",
    "droptype": "D",
    "dropname": "TUPELO",
    "dropdeladd": "403 MAIN ST",
    "dropdelcty": "TUPELO",
    "dropdelst": "OK",
    "dropdelzpp": 745729998,
    "dropphyadd": "403 MAIN ST",
    "dropphycty": "TUPELO",
    "dropphyst": "OK",
    "dropphyzpp": 745729998,
    "dropmaladd": "403 MAIN ST",
    "dropmalcty": "TUPELO",
    "dropmalst": "OK",
    "dropmalzpp": 745729998,
    "dropsitphn": 5808452486,
    "dropsitlph": 5808452486,
    "dropsitcph": 5808452486,
    "dropfax": 5808452486
  },
  {
    "dcode": "D",
    "dropkey": "PW22570",
    "droptype": "D",
    "dropname": "TURPIN",
    "dropdeladd": "419 S MAIN ST",
    "dropdelcty": "TURPIN",
    "dropdelst": "OK",
    "dropdelzpp": 739509803,
    "dropphyadd": "419 S MAIN ST",
    "dropphycty": "TURPIN",
    "dropphyst": "OK",
    "dropphyzpp": 739509803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURPIN",
    "dropmalst": "OK",
    "dropmalzpp": 739509998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5804955839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22571",
    "droptype": "D",
    "dropname": "TUSKAHOMA",
    "dropdeladd": "435689 E 1657 RD",
    "dropdelcty": "TUSKAHOMA",
    "dropdelst": "OK",
    "dropdelzpp": 745749998,
    "dropphyadd": "435689 E 1657 RD",
    "dropphycty": "TUSKAHOMA",
    "dropphyst": "OK",
    "dropphyzpp": 745749998,
    "dropmaladd": "435689 E 1657 RD",
    "dropmalcty": "TUSKAHOMA",
    "dropmalst": "OK",
    "dropmalzpp": 745749998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185694382,
    "dropsitcph": 9185694382,
    "dropfax": 9185694382
  },
  {
    "dcode": "D",
    "dropkey": "PW22574",
    "droptype": "D",
    "dropname": "TUTTLE",
    "dropdeladd": "407 E MAIN ST",
    "dropdelcty": "TUTTLE",
    "dropdelst": "OK",
    "dropdelzpp": 730899998,
    "dropphyadd": "407 E MAIN ST",
    "dropphycty": "TUTTLE",
    "dropphyst": "OK",
    "dropphyzpp": 730899998,
    "dropmaladd": "407 E MAIN ST",
    "dropmalcty": "TUTTLE",
    "dropmalst": "OK",
    "dropmalzpp": 730899998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053813817,
    "dropsitcph": 4053813859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22577",
    "droptype": "D",
    "dropname": "TYRONE",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "TYRONE",
    "dropdelst": "OK",
    "dropdelzpp": 739519802,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "TYRONE",
    "dropphyst": "OK",
    "dropphyzpp": 739519802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYRONE",
    "dropmalst": "OK",
    "dropmalzpp": 739519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 5804955578,
    "dropsitcph": 5804955789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22579",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "201 N MAIN",
    "dropdelcty": "UNION CITY",
    "dropdelst": "OK",
    "dropdelzpp": 730909998,
    "dropphyadd": "201 N MAIN",
    "dropphycty": "UNION CITY",
    "dropphyst": "OK",
    "dropphyzpp": 730909998,
    "dropmaladd": "201 N MAIN",
    "dropmalcty": "UNION CITY",
    "dropmalst": "OK",
    "dropmalzpp": 730909998,
    "dropsitphn": 4054835355,
    "dropsitlph": 4054835355,
    "dropsitcph": 4054835355,
    "dropfax": 4054835355
  },
  {
    "dcode": "D",
    "dropkey": "PW22584",
    "droptype": "D",
    "dropname": "VALLIANT",
    "dropdeladd": "501 N DALTON ST",
    "dropdelcty": "VALLIANT",
    "dropdelst": "OK",
    "dropdelzpp": 747649998,
    "dropphyadd": "501 N DALTON ST",
    "dropphycty": "VALLIANT",
    "dropphyst": "OK",
    "dropphyzpp": 747649998,
    "dropmaladd": "501 N DALTON ST",
    "dropmalcty": "VALLIANT",
    "dropmalst": "OK",
    "dropmalzpp": 747649998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5809337811,
    "dropsitcph": 5809337811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22587",
    "droptype": "D",
    "dropname": "VELMA",
    "dropdeladd": "503 MAIN ST",
    "dropdelcty": "VELMA",
    "dropdelst": "OK",
    "dropdelzpp": 734919998,
    "dropphyadd": "503 MAIN ST",
    "dropphycty": "VELMA",
    "dropphyst": "OK",
    "dropphyzpp": 734919998,
    "dropmaladd": "503 MAIN ST",
    "dropmalcty": "VELMA",
    "dropmalst": "OK",
    "dropmalzpp": 734919998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5804443321,
    "dropsitcph": 5804443321,
    "dropfax": 5804443321
  },
  {
    "dcode": "D",
    "dropkey": "PW22588",
    "droptype": "D",
    "dropname": "VERA",
    "dropdeladd": "100 S OSAGE ST",
    "dropdelcty": "VERA",
    "dropdelst": "OK",
    "dropdelzpp": 740829998,
    "dropphyadd": "100 S OSAGE ST",
    "dropphycty": "VERA",
    "dropphyst": "OK",
    "dropphyzpp": 740829998,
    "dropmaladd": "100 S OSAGE ST",
    "dropmalcty": "VERA",
    "dropmalst": "OK",
    "dropmalzpp": 740829998,
    "dropsitphn": 9183719313,
    "dropsitlph": 9183719313,
    "dropsitcph": 9183719313,
    "dropfax": 9183719313
  },
  {
    "dcode": "D",
    "dropkey": "PW22589",
    "droptype": "D",
    "dropname": "VERDEN",
    "dropdeladd": "100 MORRIS AVE",
    "dropdelcty": "VERDEN",
    "dropdelst": "OK",
    "dropdelzpp": 730929998,
    "dropphyadd": "100 MORRIS AVE",
    "dropphycty": "VERDEN",
    "dropphyst": "OK",
    "dropphyzpp": 730929998,
    "dropmaladd": "100 MORRIS AVE",
    "dropmalcty": "VERDEN",
    "dropmalst": "OK",
    "dropmalzpp": 730929998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054537575,
    "dropsitcph": 4054537575,
    "dropfax": 4054537575
  },
  {
    "dcode": "D",
    "dropkey": "PW22592",
    "droptype": "D",
    "dropname": "VIAN",
    "dropdeladd": "205 N THORNTON ST",
    "dropdelcty": "VIAN",
    "dropdelst": "OK",
    "dropdelzpp": 749629998,
    "dropphyadd": "205 N THORNTON ST",
    "dropphycty": "VIAN",
    "dropphyst": "OK",
    "dropphyzpp": 749629998,
    "dropmaladd": "205 N THORNTON ST",
    "dropmalcty": "VIAN",
    "dropmalst": "OK",
    "dropmalzpp": 749629998,
    "dropsitphn": 9187736081,
    "dropsitlph": 9187736081,
    "dropsitcph": 9187736081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22593",
    "droptype": "D",
    "dropname": "VICI",
    "dropdeladd": "706 N MAIN ST",
    "dropdelcty": "VICI",
    "dropdelst": "OK",
    "dropdelzpp": 738599998,
    "dropphyadd": "706 N MAIN ST",
    "dropphycty": "VICI",
    "dropphyst": "OK",
    "dropphyzpp": 738599998,
    "dropmaladd": "706 N MAIN ST",
    "dropmalcty": "VICI",
    "dropmalst": "OK",
    "dropmalzpp": 738599998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809953328,
    "dropsitcph": 5809953328,
    "dropfax": 5809953328
  },
  {
    "dcode": "D",
    "dropkey": "PW22595",
    "droptype": "D",
    "dropname": "VINITA",
    "dropdeladd": "120 E ILLINOIS AVE",
    "dropdelcty": "VINITA",
    "dropdelst": "OK",
    "dropdelzpp": 743019998,
    "dropphyadd": "120 E ILLINOIS AVE",
    "dropphycty": "VINITA",
    "dropphyst": "OK",
    "dropphyzpp": 743019998,
    "dropmaladd": "120 E ILLINOIS AVE",
    "dropmalcty": "VINITA",
    "dropmalst": "OK",
    "dropmalzpp": 743019998,
    "dropsitphn": 9182567548,
    "dropsitlph": 9182567548,
    "dropsitcph": 9182567548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22599",
    "droptype": "D",
    "dropname": "WAGONER",
    "dropdeladd": "233 E CHURCH ST",
    "dropdelcty": "WAGONER",
    "dropdelst": "OK",
    "dropdelzpp": 744679998,
    "dropphyadd": "233 E CHURCH ST",
    "dropphycty": "WAGONER",
    "dropphyst": "OK",
    "dropphyzpp": 744679998,
    "dropmaladd": "233 E CHURCH ST",
    "dropmalcty": "WAGONER",
    "dropmalst": "OK",
    "dropmalzpp": 744679998,
    "dropsitphn": 9184851043,
    "dropsitlph": 9184851043,
    "dropsitcph": 9184851043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22600",
    "droptype": "D",
    "dropname": "WAINWRIGHT",
    "dropdeladd": "103 MAIN ST",
    "dropdelcty": "WAINWRIGHT",
    "dropdelst": "OK",
    "dropdelzpp": 744689998,
    "dropphyadd": "103 MAIN ST",
    "dropphycty": "WAINWRIGHT",
    "dropphyst": "OK",
    "dropphyzpp": 744689998,
    "dropmaladd": "103 MAIN ST",
    "dropmalcty": "WAINWRIGHT",
    "dropmalst": "OK",
    "dropmalzpp": 744689998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184743214,
    "dropsitcph": 9184743214,
    "dropfax": 9184743214
  },
  {
    "dcode": "D",
    "dropkey": "PW22601",
    "droptype": "D",
    "dropname": "WAKITA",
    "dropdeladd": "1742 MAIN ST",
    "dropdelcty": "WAKITA",
    "dropdelst": "OK",
    "dropdelzpp": 737719998,
    "dropphyadd": "1742 MAIN ST",
    "dropphycty": "WAKITA",
    "dropphyst": "OK",
    "dropphyzpp": 737719998,
    "dropmaladd": "1742 MAIN ST",
    "dropmalcty": "WAKITA",
    "dropmalst": "OK",
    "dropmalzpp": 737719998,
    "dropsitphn": 5805942902,
    "dropsitlph": 5805942902,
    "dropsitcph": 5805942902,
    "dropfax": 5805942902
  },
  {
    "dcode": "D",
    "dropkey": "PW22602",
    "droptype": "D",
    "dropname": "WALTERS",
    "dropdeladd": "130 W COLORADO ST",
    "dropdelcty": "WALTERS",
    "dropdelst": "OK",
    "dropdelzpp": 735729998,
    "dropphyadd": "130 W COLORADO ST",
    "dropphycty": "WALTERS",
    "dropphyst": "OK",
    "dropphyzpp": 735729998,
    "dropmaladd": "130 W COLORADO ST",
    "dropmalcty": "WALTERS",
    "dropmalst": "OK",
    "dropmalzpp": 735729998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808753339,
    "dropsitcph": 5808753339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22603",
    "droptype": "D",
    "dropname": "WANETTE",
    "dropdeladd": "112 E MAIN ST",
    "dropdelcty": "WANETTE",
    "dropdelst": "OK",
    "dropdelzpp": 748789998,
    "dropphyadd": "112 E MAIN ST",
    "dropphycty": "WANETTE",
    "dropphyst": "OK",
    "dropphyzpp": 748789998,
    "dropmaladd": "112 E MAIN ST",
    "dropmalcty": "WANETTE",
    "dropmalst": "OK",
    "dropmalzpp": 748789998,
    "dropsitphn": 4053832673,
    "dropsitlph": 4053832673,
    "dropsitcph": 4053832673,
    "dropfax": 4053832673
  },
  {
    "dcode": "D",
    "dropkey": "PW22604",
    "droptype": "D",
    "dropname": "WANN",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "WANN",
    "dropdelst": "OK",
    "dropdelzpp": 740839998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "WANN",
    "dropphyst": "OK",
    "dropphyzpp": 740839998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "WANN",
    "dropmalst": "OK",
    "dropmalzpp": 740839998,
    "dropsitphn": 9185312255,
    "dropsitlph": 9185312255,
    "dropsitcph": 9185312255,
    "dropfax": 9185312255
  },
  {
    "dcode": "D",
    "dropkey": "PW22605",
    "droptype": "D",
    "dropname": "WAPANUCKA",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "WAPANUCKA",
    "dropdelst": "OK",
    "dropdelzpp": 734619998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "WAPANUCKA",
    "dropphyst": "OK",
    "dropphyzpp": 734619998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "WAPANUCKA",
    "dropmalst": "OK",
    "dropmalzpp": 734619998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5809374493,
    "dropsitcph": 5809374493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22607",
    "droptype": "D",
    "dropname": "WARNER",
    "dropdeladd": "805 2ND AVE",
    "dropdelcty": "WARNER",
    "dropdelst": "OK",
    "dropdelzpp": 744699998,
    "dropphyadd": "805 2ND AVE",
    "dropphycty": "WARNER",
    "dropphyst": "OK",
    "dropphyzpp": 744699998,
    "dropmaladd": "805 2ND AVE",
    "dropmalcty": "WARNER",
    "dropmalst": "OK",
    "dropmalzpp": 744699998,
    "dropsitphn": 9184632410,
    "dropsitlph": 9184632410,
    "dropsitcph": 9184632410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22609",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "214 N MAIN AVE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "OK",
    "dropdelzpp": 730939119,
    "dropphyadd": "214 N MAIN AVE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "OK",
    "dropphyzpp": 730939119,
    "dropmaladd": "214 N MAIN AVE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "OK",
    "dropmalzpp": 730939119,
    "dropsitphn": 4058152724,
    "dropsitlph": 4052880225,
    "dropsitcph": 4052880225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22611",
    "droptype": "D",
    "dropname": "WATONGA",
    "dropdeladd": "121 N NOBLE AVE",
    "dropdelcty": "WATONGA",
    "dropdelst": "OK",
    "dropdelzpp": 737729998,
    "dropphyadd": "121 N NOBLE AVE",
    "dropphycty": "WATONGA",
    "dropphyst": "OK",
    "dropphyzpp": 737729998,
    "dropmaladd": "121 N NOBLE AVE",
    "dropmalcty": "WATONGA",
    "dropmalst": "OK",
    "dropmalzpp": 737729998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806235095,
    "dropsitcph": 5806235095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22613",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "100 HIGHWAY 4",
    "dropdelcty": "WATSON",
    "dropdelst": "OK",
    "dropdelzpp": 749639998,
    "dropphyadd": "100 HIGHWAY 4",
    "dropphycty": "WATSON",
    "dropphyst": "OK",
    "dropphyzpp": 749639998,
    "dropmaladd": "100 HIGHWAY 4",
    "dropmalcty": "WATSON",
    "dropmalst": "OK",
    "dropmalzpp": 749639998,
    "dropsitphn": 9182707512,
    "dropsitlph": 5803440414,
    "dropsitcph": 5803440414,
    "dropfax": 5804470928
  },
  {
    "dcode": "D",
    "dropkey": "PW22614",
    "droptype": "D",
    "dropname": "WATTS",
    "dropdeladd": "601 E 6TH ST",
    "dropdelcty": "WATTS",
    "dropdelst": "OK",
    "dropdelzpp": 749649998,
    "dropphyadd": "601 E 6TH ST",
    "dropphycty": "WATTS",
    "dropphyst": "OK",
    "dropphyzpp": 749649998,
    "dropmaladd": "601 E 6TH ST",
    "dropmalcty": "WATTS",
    "dropmalst": "OK",
    "dropmalzpp": 749649998,
    "dropsitphn": 9184225986,
    "dropsitlph": 9184225986,
    "dropsitcph": 9184225986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22615",
    "droptype": "D",
    "dropname": "WAUKOMIS",
    "dropdeladd": "504 E EUCLID AVE",
    "dropdelcty": "WAUKOMIS",
    "dropdelst": "OK",
    "dropdelzpp": 737739800,
    "dropphyadd": "504 E EUCLID AVE",
    "dropphycty": "WAUKOMIS",
    "dropphyst": "OK",
    "dropphyzpp": 737739800,
    "dropmaladd": "504 E EUCLID AVE",
    "dropmalcty": "WAUKOMIS",
    "dropmalst": "OK",
    "dropmalzpp": 737739800,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807583274,
    "dropsitcph": 5807583274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22616",
    "droptype": "D",
    "dropname": "WAURIKA",
    "dropdeladd": "121 W BROADWAY AVE",
    "dropdelcty": "WAURIKA",
    "dropdelst": "OK",
    "dropdelzpp": 735739998,
    "dropphyadd": "121 W BROADWAY AVE",
    "dropphycty": "WAURIKA",
    "dropphyst": "OK",
    "dropphyzpp": 735739998,
    "dropmaladd": "121 W BROADWAY AVE",
    "dropmalcty": "WAURIKA",
    "dropmalst": "OK",
    "dropmalzpp": 735739998,
    "dropsitphn": 5802282991,
    "dropsitlph": 5802282991,
    "dropsitcph": 5802282991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22617",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "100 S SHANNON ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "OK",
    "dropdelzpp": 730959998,
    "dropphyadd": "100 S SHANNON ST",
    "dropphycty": "WAYNE",
    "dropphyst": "OK",
    "dropphyzpp": 730959998,
    "dropmaladd": "100 S SHANNON ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "OK",
    "dropmalzpp": 730959998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4054493517,
    "dropsitcph": 4054493517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22618",
    "droptype": "D",
    "dropname": "WAYNOKA",
    "dropdeladd": "1620 SANTA FE ST",
    "dropdelcty": "WAYNOKA",
    "dropdelst": "OK",
    "dropdelzpp": 738609998,
    "dropphyadd": "1620 SANTA FE ST",
    "dropphycty": "WAYNOKA",
    "dropphyst": "OK",
    "dropphyzpp": 738609998,
    "dropmaladd": "1620 SANTA FE ST",
    "dropmalcty": "WAYNOKA",
    "dropmalst": "OK",
    "dropmalzpp": 738609998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5808242702,
    "dropsitcph": 5808242702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22619",
    "droptype": "D",
    "dropname": "WEATHERFORD",
    "dropdeladd": "107 E FRANKLIN AVE",
    "dropdelcty": "WEATHERFORD",
    "dropdelst": "OK",
    "dropdelzpp": 730969998,
    "dropphyadd": "107 E FRANKLIN AVE",
    "dropphycty": "WEATHERFORD",
    "dropphyst": "OK",
    "dropphyzpp": 730969998,
    "dropmaladd": "107 E FRANKLIN AVE",
    "dropmalcty": "WEATHERFORD",
    "dropmalst": "OK",
    "dropmalzpp": 730969998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5807727813,
    "dropsitcph": 5807722412,
    "dropfax": 5807723449
  },
  {
    "dcode": "D",
    "dropkey": "PW22620",
    "droptype": "D",
    "dropname": "WEBBERS FALLS",
    "dropdeladd": "116 W COMMERCIAL ST",
    "dropdelcty": "WEBBERS FALLS",
    "dropdelst": "OK",
    "dropdelzpp": 744709998,
    "dropphyadd": "116 W COMMERCIAL ST",
    "dropphycty": "WEBBERS FALLS",
    "dropphyst": "OK",
    "dropphyzpp": 744709998,
    "dropmaladd": "116 W COMMERCIAL ST",
    "dropmalcty": "WEBBERS FALLS",
    "dropmalst": "OK",
    "dropmalzpp": 744709998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184642521,
    "dropsitcph": 9184642521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22621",
    "droptype": "D",
    "dropname": "WELCH",
    "dropdeladd": "369 S COMMERCIAL ST",
    "dropdelcty": "WELCH",
    "dropdelst": "OK",
    "dropdelzpp": 743699998,
    "dropphyadd": "369 S COMMERCIAL ST",
    "dropphycty": "WELCH",
    "dropphyst": "OK",
    "dropphyzpp": 743699998,
    "dropmaladd": "369 S COMMERCIAL ST",
    "dropmalcty": "WELCH",
    "dropmalst": "OK",
    "dropmalzpp": 743699998,
    "dropsitphn": 9187883623,
    "dropsitlph": 9187883623,
    "dropsitcph": 9187883623,
    "dropfax": 9187883111
  },
  {
    "dcode": "D",
    "dropkey": "PW22622",
    "droptype": "D",
    "dropname": "WELEETKA",
    "dropdeladd": "212 W 9TH ST",
    "dropdelcty": "WELEETKA",
    "dropdelst": "OK",
    "dropdelzpp": 748809998,
    "dropphyadd": "212 W 9TH ST",
    "dropphycty": "WELEETKA",
    "dropphyst": "OK",
    "dropphyzpp": 748809998,
    "dropmaladd": "212 W 9TH ST",
    "dropmalcty": "WELEETKA",
    "dropmalst": "OK",
    "dropmalzpp": 748809998,
    "dropsitphn": 4057862114,
    "dropsitlph": 4057862114,
    "dropsitcph": 4057862114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22623",
    "droptype": "D",
    "dropname": "WELLING",
    "dropdeladd": "20627 S WELLING RD",
    "dropdelcty": "WELLING",
    "dropdelst": "OK",
    "dropdelzpp": 744719998,
    "dropphyadd": "20627 S WELLING RD",
    "dropphycty": "WELLING",
    "dropphyst": "OK",
    "dropphyzpp": 744719998,
    "dropmaladd": "20627 S WELLING RD",
    "dropmalcty": "WELLING",
    "dropmalst": "OK",
    "dropmalzpp": 744719998,
    "dropsitphn": 9184565631,
    "dropsitlph": 9184565631,
    "dropsitcph": 9184565631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22624",
    "droptype": "D",
    "dropname": "WELLSTON",
    "dropdeladd": "401 2ND ST",
    "dropdelcty": "WELLSTON",
    "dropdelst": "OK",
    "dropdelzpp": 748819998,
    "dropphyadd": "401 2ND ST",
    "dropphycty": "WELLSTON",
    "dropphyst": "OK",
    "dropphyzpp": 748819998,
    "dropmaladd": "401 2ND ST",
    "dropmalcty": "WELLSTON",
    "dropmalst": "OK",
    "dropmalzpp": 748819998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053562750,
    "dropsitcph": 4053562750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22632",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "1240 S WILLIAMS AVE",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 749655535,
    "dropphyadd": "1240 S WILLIAMS AVE",
    "dropphycty": "WESTVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 749655535,
    "dropmaladd": "1240 S WILLIAMS AVE",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 749655535,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187233231,
    "dropsitcph": 9187233231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22633",
    "droptype": "D",
    "dropname": "WETUMKA",
    "dropdeladd": "119 N MAIN ST",
    "dropdelcty": "WETUMKA",
    "dropdelst": "OK",
    "dropdelzpp": 748839998,
    "dropphyadd": "119 N MAIN ST",
    "dropphycty": "WETUMKA",
    "dropphyst": "OK",
    "dropphyzpp": 748839998,
    "dropmaladd": "119 N MAIN ST",
    "dropmalcty": "WETUMKA",
    "dropmalst": "OK",
    "dropmalzpp": 748839998,
    "dropsitphn": 4054523391,
    "dropsitlph": 4054523391,
    "dropsitcph": 4054523391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22634",
    "droptype": "D",
    "dropname": "WEWOKA",
    "dropdeladd": "115 W 2ND ST",
    "dropdelcty": "WEWOKA",
    "dropdelst": "OK",
    "dropdelzpp": 748849998,
    "dropphyadd": "115 W 2ND ST",
    "dropphycty": "WEWOKA",
    "dropphyst": "OK",
    "dropphyzpp": 748849998,
    "dropmaladd": "115 W 2ND ST",
    "dropmalcty": "WEWOKA",
    "dropmalst": "OK",
    "dropmalzpp": 748849998,
    "dropsitphn": 4052573214,
    "dropsitlph": 4052573214,
    "dropsitcph": 4052573214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22636",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "6920 S MAIN ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "OK",
    "dropdelzpp": 730979998,
    "dropphyadd": "6920 S MAIN ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "OK",
    "dropphyzpp": 730979998,
    "dropmaladd": "6920 S MAIN ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "OK",
    "dropmalzpp": 730979998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057454874,
    "dropsitcph": 4057454874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22638",
    "droptype": "D",
    "dropname": "WHITEFIELD",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "WHITEFIELD",
    "dropdelst": "OK",
    "dropdelzpp": 744729998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "WHITEFIELD",
    "dropphyst": "OK",
    "dropphyzpp": 744729998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "WHITEFIELD",
    "dropmalst": "OK",
    "dropmalzpp": 744729998,
    "dropsitphn": 9189674482,
    "dropsitlph": 9189674482,
    "dropsitcph": 9189674482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22639",
    "droptype": "D",
    "dropname": "WHITESBORO",
    "dropdeladd": "57137 WHITE WOOD DR",
    "dropdelcty": "WHITESBORO",
    "dropdelst": "OK",
    "dropdelzpp": 745779998,
    "dropphyadd": "57137 WHITE WOOD DR",
    "dropphycty": "WHITESBORO",
    "dropphyst": "OK",
    "dropphyzpp": 745779998,
    "dropmaladd": "57137 WHITE WOOD DR",
    "dropmalcty": "WHITESBORO",
    "dropmalst": "OK",
    "dropmalzpp": 745779998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185672469,
    "dropsitcph": 9185672469,
    "dropfax": 9185672469
  },
  {
    "dcode": "D",
    "dropkey": "PW22641",
    "droptype": "D",
    "dropname": "WILBURTON",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "WILBURTON",
    "dropdelst": "OK",
    "dropdelzpp": 745789998,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "WILBURTON",
    "dropphyst": "OK",
    "dropphyzpp": 745789998,
    "dropmaladd": "205 E MAIN ST",
    "dropmalcty": "WILBURTON",
    "dropmalst": "OK",
    "dropmalzpp": 745789998,
    "dropsitphn": 9184652332,
    "dropsitlph": 9184652332,
    "dropsitcph": 9184652332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22643",
    "droptype": "D",
    "dropname": "WILLOW",
    "dropdeladd": "113 W MAIN ST",
    "dropdelcty": "WILLOW",
    "dropdelst": "OK",
    "dropdelzpp": 736739998,
    "dropphyadd": "113 W MAIN ST",
    "dropphycty": "WILLOW",
    "dropphyst": "OK",
    "dropphyzpp": 736739998,
    "dropmaladd": "113 W MAIN ST",
    "dropmalcty": "WILLOW",
    "dropmalst": "OK",
    "dropmalzpp": 736739998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5802873491,
    "dropsitcph": 5802873491,
    "dropfax": 5802873491
  },
  {
    "dcode": "D",
    "dropkey": "PW22644",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "1224 US HIGHWAY 70A",
    "dropdelcty": "WILSON",
    "dropdelst": "OK",
    "dropdelzpp": 734639998,
    "dropphyadd": "1224 US HIGHWAY 70A",
    "dropphycty": "WILSON",
    "dropphyst": "OK",
    "dropphyzpp": 734639998,
    "dropmaladd": "1224 US HIGHWAY 70A",
    "dropmalcty": "WILSON",
    "dropmalst": "OK",
    "dropmalzpp": 734639998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5806682434,
    "dropsitcph": 5806682434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22646",
    "droptype": "D",
    "dropname": "WISTER",
    "dropdeladd": "204 PLUM ST",
    "dropdelcty": "WISTER",
    "dropdelst": "OK",
    "dropdelzpp": 749669998,
    "dropphyadd": "204 PLUM ST",
    "dropphycty": "WISTER",
    "dropphyst": "OK",
    "dropphyzpp": 749669998,
    "dropmaladd": "204 PLUM ST",
    "dropmalcty": "WISTER",
    "dropmalst": "OK",
    "dropmalzpp": 749669998,
    "dropsitphn": 9182650452,
    "dropsitlph": 9182650452,
    "dropsitcph": 9182650452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22649",
    "droptype": "D",
    "dropname": "WOODWARD",
    "dropdeladd": "2020 WILLIAMS AVE",
    "dropdelcty": "WOODWARD",
    "dropdelst": "OK",
    "dropdelzpp": 738019998,
    "dropphyadd": "2020 WILLIAMS AVE",
    "dropphycty": "WOODWARD",
    "dropphyst": "OK",
    "dropphyzpp": 738019998,
    "dropmaladd": "2020 WILLIAMS AVE",
    "dropmalcty": "WOODWARD",
    "dropmalst": "OK",
    "dropmalzpp": 738019998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4055536782,
    "dropsitcph": 5802567138,
    "dropfax": 5802564404
  },
  {
    "dcode": "D",
    "dropkey": "PW22650",
    "droptype": "D",
    "dropname": "WRIGHT CITY",
    "dropdeladd": "301 W 10TH ST",
    "dropdelcty": "WRIGHT CITY",
    "dropdelst": "OK",
    "dropdelzpp": 747669998,
    "dropphyadd": "301 W 10TH ST",
    "dropphycty": "WRIGHT CITY",
    "dropphyst": "OK",
    "dropphyzpp": 747669998,
    "dropmaladd": "301 W 10TH ST",
    "dropmalcty": "WRIGHT CITY",
    "dropmalst": "OK",
    "dropmalzpp": 747669998,
    "dropsitphn": 5802033941,
    "dropsitlph": 5802033941,
    "dropsitcph": 5802033941,
    "dropfax": 5802033941
  },
  {
    "dcode": "D",
    "dropkey": "PW22651",
    "droptype": "D",
    "dropname": "WYANDOTTE",
    "dropdeladd": "12 N MAIN",
    "dropdelcty": "WYANDOTTE",
    "dropdelst": "OK",
    "dropdelzpp": 743709998,
    "dropphyadd": "12 N MAIN",
    "dropphycty": "WYANDOTTE",
    "dropphyst": "OK",
    "dropphyzpp": 743709998,
    "dropmaladd": "12 N MAIN",
    "dropmalcty": "WYANDOTTE",
    "dropmalst": "OK",
    "dropmalzpp": 743709998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9186782250,
    "dropsitcph": 9186782250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22653",
    "droptype": "D",
    "dropname": "WYNNEWOOD",
    "dropdeladd": "115 E ROBERT S KERR BLVD",
    "dropdelcty": "WYNNEWOOD",
    "dropdelst": "OK",
    "dropdelzpp": 730989998,
    "dropphyadd": "115 E ROBERT S KERR BLVD",
    "dropphycty": "WYNNEWOOD",
    "dropphyst": "OK",
    "dropphyzpp": 730989998,
    "dropmaladd": "115 E ROBERT S KERR BLVD",
    "dropmalcty": "WYNNEWOOD",
    "dropmalst": "OK",
    "dropmalzpp": 730989998,
    "dropsitphn": 4056654235,
    "dropsitlph": 4056654235,
    "dropsitcph": 4056654235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22654",
    "droptype": "D",
    "dropname": "WYNONA",
    "dropdeladd": "202 W 4TH ST",
    "dropdelcty": "WYNONA",
    "dropdelst": "OK",
    "dropdelzpp": 740849998,
    "dropphyadd": "202 W 4TH ST",
    "dropphycty": "WYNONA",
    "dropphyst": "OK",
    "dropphyzpp": 740849998,
    "dropmaladd": "202 W 4TH ST",
    "dropmalcty": "WYNONA",
    "dropmalst": "OK",
    "dropmalzpp": 740849998,
    "dropsitphn": 9182874482,
    "dropsitlph": 9188462780,
    "dropsitcph": 9188462780,
    "dropfax": 9188462780
  },
  {
    "dcode": "D",
    "dropkey": "PW22655",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "209 W BROADWAY AVE",
    "dropdelcty": "YALE",
    "dropdelst": "OK",
    "dropdelzpp": 740859998,
    "dropphyadd": "209 W BROADWAY AVE",
    "dropphycty": "YALE",
    "dropphyst": "OK",
    "dropphyzpp": 740859998,
    "dropmaladd": "209 W BROADWAY AVE",
    "dropmalcty": "YALE",
    "dropmalst": "OK",
    "dropmalzpp": 740859998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183872441,
    "dropsitcph": 9183872441,
    "dropfax": 9183872441
  },
  {
    "dcode": "D",
    "dropkey": "PW22657",
    "droptype": "D",
    "dropname": "YUKON",
    "dropdeladd": "900 GARTH BROOKS BLVD",
    "dropdelcty": "YUKON",
    "dropdelst": "OK",
    "dropdelzpp": 730999998,
    "dropphyadd": "900 GARTH BROOKS BLVD",
    "dropphycty": "YUKON",
    "dropphyst": "OK",
    "dropphyzpp": 730999998,
    "dropmaladd": "900 GARTH BROOKS BLVD",
    "dropmalcty": "YUKON",
    "dropmalst": "OK",
    "dropmalzpp": 730999998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053501474,
    "dropsitcph": 4053501474,
    "dropfax": 4053548086
  },
  {
    "dcode": "D",
    "dropkey": "PW22664",
    "droptype": "D",
    "dropname": "ABBOTT",
    "dropdeladd": "220 E WALNUT ST",
    "dropdelcty": "ABBOTT",
    "dropdelst": "TX",
    "dropdelzpp": 766219998,
    "dropphyadd": "220 E WALNUT ST",
    "dropphycty": "ABBOTT",
    "dropphyst": "TX",
    "dropphyzpp": 766219998,
    "dropmaladd": "220 E WALNUT ST",
    "dropmalcty": "ABBOTT",
    "dropmalst": "TX",
    "dropmalzpp": 766219998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545825024,
    "dropsitcph": 2545825024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22665",
    "droptype": "D",
    "dropname": "ABERNATHY",
    "dropdeladd": "801 AVENUE D",
    "dropdelcty": "ABERNATHY",
    "dropdelst": "TX",
    "dropdelzpp": 793119998,
    "dropphyadd": "801 AVENUE D",
    "dropphycty": "ABERNATHY",
    "dropphyst": "TX",
    "dropphyzpp": 793119998,
    "dropmaladd": "801 AVENUE D",
    "dropmalcty": "ABERNATHY",
    "dropmalst": "TX",
    "dropmalzpp": 793119998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062984111,
    "dropsitcph": 8062984111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22667",
    "droptype": "D",
    "dropname": "ABILENE",
    "dropdeladd": "341 PINE ST",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796019996,
    "dropphyadd": "341 PINE ST",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796019996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796049998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257382135,
    "dropsitcph": 3257382135,
    "dropfax": 3257382148
  },
  {
    "dcode": "D",
    "dropkey": "PW22674",
    "droptype": "D",
    "dropname": "ACE",
    "dropdeladd": "2038 HIGHWAY 2610",
    "dropdelcty": "ACE",
    "dropdelst": "TX",
    "dropdelzpp": 773260001,
    "dropphyadd": "2038 HIGHWAY 2610",
    "dropphycty": "ACE",
    "dropphyst": "TX",
    "dropphyzpp": 773260001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ACE",
    "dropmalst": "TX",
    "dropmalzpp": 773269998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9366857463,
    "dropsitcph": 9366857463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22675",
    "droptype": "D",
    "dropname": "ACKERLY",
    "dropdeladd": "303 W 5TH ST",
    "dropdelcty": "ACKERLY",
    "dropdelst": "TX",
    "dropdelzpp": 797139998,
    "dropphyadd": "303 W 5TH ST",
    "dropphycty": "ACKERLY",
    "dropphyst": "TX",
    "dropphyzpp": 797139998,
    "dropmaladd": "303 W 5TH ST",
    "dropmalcty": "ACKERLY",
    "dropmalst": "TX",
    "dropmalzpp": 797139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323534877,
    "dropsitcph": 4323534877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22681",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "4900 AIRPORT PKWY",
    "dropdelcty": "ADDISON",
    "dropdelst": "TX",
    "dropdelzpp": 750019998,
    "dropphyadd": "4900 AIRPORT PKWY",
    "dropphycty": "ADDISON",
    "dropphyst": "TX",
    "dropphyzpp": 750019998,
    "dropmaladd": "4900 AIRPORT PKWY",
    "dropmalcty": "ADDISON",
    "dropmalst": "TX",
    "dropmalzpp": 750019998,
    "dropsitphn": 2144675879,
    "dropsitlph": 2142421315,
    "dropsitcph": 9722335520,
    "dropfax": 9724048667
  },
  {
    "dcode": "D",
    "dropkey": "PW22682",
    "droptype": "D",
    "dropname": "ADKINS",
    "dropdeladd": "10190 US HIGHWAY 87 S",
    "dropdelcty": "ADKINS",
    "dropdelst": "TX",
    "dropdelzpp": 781019998,
    "dropphyadd": "10190 US HIGHWAY 87 S",
    "dropphycty": "ADKINS",
    "dropphyst": "TX",
    "dropphyzpp": 781019998,
    "dropmaladd": "10190 US HIGHWAY 87 S",
    "dropmalcty": "ADKINS",
    "dropmalst": "TX",
    "dropmalzpp": 781019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106494394,
    "dropsitcph": 2106491673,
    "dropfax": 2106493956
  },
  {
    "dcode": "D",
    "dropkey": "PW22683",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "201 HISTORIC ROUTE 66",
    "dropdelcty": "ADRIAN",
    "dropdelst": "TX",
    "dropdelzpp": 790019998,
    "dropphyadd": "201 HISTORIC ROUTE 66",
    "dropphycty": "ADRIAN",
    "dropphyst": "TX",
    "dropphyzpp": 790019998,
    "dropmaladd": "201 HISTORIC ROUTE 66",
    "dropmalcty": "ADRIAN",
    "dropmalst": "TX",
    "dropmalzpp": 790019998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065386260,
    "dropsitcph": 8065386260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22689",
    "droptype": "D",
    "dropname": "AGUA DULCE",
    "dropdeladd": "1518 2ND ST",
    "dropdelcty": "AGUA DULCE",
    "dropdelst": "TX",
    "dropdelzpp": 783309998,
    "dropphyadd": "1518 2ND ST",
    "dropphycty": "AGUA DULCE",
    "dropphyst": "TX",
    "dropphyzpp": 783309998,
    "dropmaladd": "1518 2ND ST",
    "dropmalcty": "AGUA DULCE",
    "dropmalst": "TX",
    "dropmalzpp": 783309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619982331,
    "dropsitcph": 3619982331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22698",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "423 LOS ALAMOS DR",
    "dropdelcty": "ALAMO",
    "dropdelst": "TX",
    "dropdelzpp": 785169998,
    "dropphyadd": "423 LOS ALAMOS DR",
    "dropphycty": "ALAMO",
    "dropphyst": "TX",
    "dropphyzpp": 785169998,
    "dropmaladd": "423 LOS ALAMOS DR",
    "dropmalcty": "ALAMO",
    "dropmalst": "TX",
    "dropmalzpp": 785169998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567874514,
    "dropsitcph": 9567874514,
    "dropfax": 9567830920
  },
  {
    "dcode": "D",
    "dropkey": "PW22701",
    "droptype": "D",
    "dropname": "ALANREED",
    "dropdeladd": "13100 INTERSTATE 40",
    "dropdelcty": "ALANREED",
    "dropdelst": "TX",
    "dropdelzpp": 790029998,
    "dropphyadd": "13100 INTERSTATE 40",
    "dropphycty": "ALANREED",
    "dropphyst": "TX",
    "dropphyzpp": 790029998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCLEAN",
    "dropmalst": "TX",
    "dropmalzpp": 790579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067792202,
    "dropsitcph": 8067792202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22703",
    "droptype": "D",
    "dropname": "ALBA",
    "dropdeladd": "240 W HOLLEY ST",
    "dropdelcty": "ALBA",
    "dropdelst": "TX",
    "dropdelzpp": 754109998,
    "dropphyadd": "240 W HOLLEY ST",
    "dropphycty": "ALBA",
    "dropphyst": "TX",
    "dropphyzpp": 754109998,
    "dropmaladd": "240 W HOLLEY ST",
    "dropmalcty": "ALBA",
    "dropmalst": "TX",
    "dropmalzpp": 754109998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037652390,
    "dropsitcph": 9037652390,
    "dropfax": 9037654453
  },
  {
    "dcode": "D",
    "dropkey": "PW22704",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "24 N JACOBS ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "TX",
    "dropdelzpp": 764305947,
    "dropphyadd": "24 N JACOBS ST",
    "dropphycty": "ALBANY",
    "dropphyst": "TX",
    "dropphyzpp": 764305947,
    "dropmaladd": "24 N JACOBS ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "TX",
    "dropmalzpp": 764305947,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257623067,
    "dropsitcph": 3257623067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22708",
    "droptype": "D",
    "dropname": "ALEDO",
    "dropdeladd": "412 OLD ANNETTA RD",
    "dropdelcty": "ALEDO",
    "dropdelst": "TX",
    "dropdelzpp": 760089998,
    "dropphyadd": "412 OLD ANNETTA RD",
    "dropphycty": "ALEDO",
    "dropphyst": "TX",
    "dropphyzpp": 760089998,
    "dropmaladd": "412 OLD ANNETTA RD",
    "dropmalcty": "ALEDO",
    "dropmalst": "TX",
    "dropmalzpp": 760089998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174417845,
    "dropsitcph": 8174418023,
    "dropfax": 8174417403
  },
  {
    "dcode": "D",
    "dropkey": "PW22715",
    "droptype": "D",
    "dropname": "ALICE",
    "dropdeladd": "401 E 2ND ST",
    "dropdelcty": "ALICE",
    "dropdelst": "TX",
    "dropdelzpp": 783329998,
    "dropphyadd": "401 E 2ND ST",
    "dropphycty": "ALICE",
    "dropphyst": "TX",
    "dropphyzpp": 783329998,
    "dropmaladd": "401 E 2ND ST",
    "dropmalcty": "ALICE",
    "dropmalst": "TX",
    "dropmalzpp": 783329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3616642116,
    "dropsitcph": 3616645541,
    "dropfax": 3616684848
  },
  {
    "dcode": "D",
    "dropkey": "PW22716",
    "droptype": "D",
    "dropname": "ALIEF",
    "dropdeladd": "11936 BELLAIRE BLVD",
    "dropdelcty": "ALIEF",
    "dropdelst": "TX",
    "dropdelzpp": 774110017,
    "dropphyadd": "11936 BELLAIRE BLVD",
    "dropphycty": "ALIEF",
    "dropphyst": "TX",
    "dropphyzpp": 774110017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALIEF",
    "dropmalst": "TX",
    "dropmalzpp": 774119998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814987356,
    "dropsitcph": 2814987356,
    "dropfax": 2814981803
  },
  {
    "dcode": "D",
    "dropkey": "PW22717",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "401 CENTURY PKWY",
    "dropdelcty": "ALLEN",
    "dropdelst": "TX",
    "dropdelzpp": 750138043,
    "dropphyadd": "401 CENTURY PKWY",
    "dropphycty": "ALLEN",
    "dropphyst": "TX",
    "dropphyzpp": 750138043,
    "dropmaladd": "401 CENTURY PKWY",
    "dropmalcty": "ALLEN",
    "dropmalst": "TX",
    "dropmalzpp": 750138043,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723907993,
    "dropsitcph": 9723907993,
    "dropfax": 9723968374
  },
  {
    "dcode": "D",
    "dropkey": "PW22719",
    "droptype": "D",
    "dropname": "ALLISON",
    "dropdeladd": "105 WHEELER AVE",
    "dropdelcty": "ALLISON",
    "dropdelst": "TX",
    "dropdelzpp": 790039800,
    "dropphyadd": "105 WHEELER AVE",
    "dropphycty": "ALLISON",
    "dropphyst": "TX",
    "dropphyzpp": 790039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLISON",
    "dropmalst": "TX",
    "dropmalzpp": 790039998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063752236,
    "dropsitcph": 8063752236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22721",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "901 W HOLLAND AVE",
    "dropdelcty": "ALPINE",
    "dropdelst": "TX",
    "dropdelzpp": 798309998,
    "dropphyadd": "901 W HOLLAND AVE",
    "dropphycty": "ALPINE",
    "dropphyst": "TX",
    "dropphyzpp": 798309998,
    "dropmaladd": "901 W HOLLAND AVE",
    "dropmalcty": "ALPINE",
    "dropmalst": "TX",
    "dropmalzpp": 798309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4328379576,
    "dropsitcph": 4328379565,
    "dropfax": 4328379538
  },
  {
    "dcode": "D",
    "dropkey": "PW22723",
    "droptype": "D",
    "dropname": "ALTAIR",
    "dropdeladd": "4159 US HIGHWAY 90A",
    "dropdelcty": "ALTAIR",
    "dropdelst": "TX",
    "dropdelzpp": 774120003,
    "dropphyadd": "4159 US HIGHWAY 90A",
    "dropphycty": "ALTAIR",
    "dropphyst": "TX",
    "dropphyzpp": 774120003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTAIR",
    "dropmalst": "TX",
    "dropmalzpp": 774129998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792342114,
    "dropsitcph": 9792342114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22724",
    "droptype": "D",
    "dropname": "ALTO",
    "dropdeladd": "201 COOPER ST",
    "dropdelcty": "ALTO",
    "dropdelst": "TX",
    "dropdelzpp": 759259998,
    "dropphyadd": "201 COOPER ST",
    "dropphycty": "ALTO",
    "dropphyst": "TX",
    "dropphyzpp": 759259998,
    "dropmaladd": "201 COOPER ST",
    "dropmalcty": "ALTO",
    "dropmalst": "TX",
    "dropmalzpp": 759259998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368584600,
    "dropsitcph": 9368584600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22727",
    "droptype": "D",
    "dropname": "ALVARADO",
    "dropdeladd": "300 E HIGHWAY 67",
    "dropdelcty": "ALVARADO",
    "dropdelst": "TX",
    "dropdelzpp": 760099998,
    "dropphyadd": "300 E HIGHWAY 67",
    "dropphycty": "ALVARADO",
    "dropphyst": "TX",
    "dropphyzpp": 760099998,
    "dropmaladd": "300 E HIGHWAY 67",
    "dropmalcty": "ALVARADO",
    "dropmalst": "TX",
    "dropmalzpp": 760099998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8177833384,
    "dropsitcph": 8177833384,
    "dropfax": 8177838016
  },
  {
    "dcode": "D",
    "dropkey": "PW22728",
    "droptype": "D",
    "dropname": "ALVIN",
    "dropdeladd": "455 E HOUSE ST",
    "dropdelcty": "ALVIN",
    "dropdelst": "TX",
    "dropdelzpp": 775119998,
    "dropphyadd": "455 E HOUSE ST",
    "dropphycty": "ALVIN",
    "dropphyst": "TX",
    "dropphyzpp": 775119998,
    "dropmaladd": "455 E HOUSE ST",
    "dropmalcty": "ALVIN",
    "dropmalst": "TX",
    "dropmalzpp": 775119998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813312225,
    "dropsitcph": 2813312220,
    "dropfax": 2813315861
  },
  {
    "dcode": "D",
    "dropkey": "PW22729",
    "droptype": "D",
    "dropname": "ALVORD",
    "dropdeladd": "105 N ONEIL ST",
    "dropdelcty": "ALVORD",
    "dropdelst": "TX",
    "dropdelzpp": 762251100,
    "dropphyadd": "105 N ONEIL ST",
    "dropphycty": "ALVORD",
    "dropphyst": "TX",
    "dropphyzpp": 762251100,
    "dropmaladd": "105 N ONEIL ST",
    "dropmalcty": "ALVORD",
    "dropmalst": "TX",
    "dropmalzpp": 762251100,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404272111,
    "dropsitcph": 9404272111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22731",
    "droptype": "D",
    "dropname": "AMARILLO",
    "dropdeladd": "2301 ROSS ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791209996,
    "dropphyadd": "2301 ROSS ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791209996,
    "dropmaladd": "2301 ROSS ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791209996,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064682101,
    "dropsitcph": 8064682101,
    "dropfax": 8064682196
  },
  {
    "dcode": "D",
    "dropkey": "PW22744",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "815 MAIN ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "TX",
    "dropdelzpp": 793129802,
    "dropphyadd": "815 MAIN ST",
    "dropphycty": "AMHERST",
    "dropphyst": "TX",
    "dropphyzpp": 793129802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMHERST",
    "dropmalst": "TX",
    "dropmalzpp": 793129998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062463600,
    "dropsitcph": 8062463600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22748",
    "droptype": "D",
    "dropname": "ANAHUAC",
    "dropdeladd": "411 S MAIN ST",
    "dropdelcty": "ANAHUAC",
    "dropdelst": "TX",
    "dropdelzpp": 775149800,
    "dropphyadd": "411 S MAIN ST",
    "dropphycty": "ANAHUAC",
    "dropphyst": "TX",
    "dropphyzpp": 775149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANAHUAC",
    "dropmalst": "TX",
    "dropmalzpp": 775149998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092676451,
    "dropsitcph": 4092676451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22751",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "1035 HIGHWAY 90 N",
    "dropdelcty": "ANDERSON",
    "dropdelst": "TX",
    "dropdelzpp": 778309998,
    "dropphyadd": "1035 HIGHWAY 90 N",
    "dropphycty": "ANDERSON",
    "dropphyst": "TX",
    "dropphyzpp": 778309998,
    "dropmaladd": "1035 HIGHWAY 90 N",
    "dropmalcty": "ANDERSON",
    "dropmalst": "TX",
    "dropmalzpp": 778309998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368732071,
    "dropsitcph": 9368732071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22753",
    "droptype": "D",
    "dropname": "ANDREWS",
    "dropdeladd": "110 NW AVENUE H",
    "dropdelcty": "ANDREWS",
    "dropdelst": "TX",
    "dropdelzpp": 797144200,
    "dropphyadd": "110 NW AVENUE H",
    "dropphycty": "ANDREWS",
    "dropphyst": "TX",
    "dropphyzpp": 797144200,
    "dropmaladd": "110 NW AVENUE H",
    "dropmalcty": "ANDREWS",
    "dropmalst": "TX",
    "dropmalzpp": 797144200,
    "dropsitphn": 2103688387,
    "dropsitlph": 4327757543,
    "dropsitcph": 4325233253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22756",
    "droptype": "D",
    "dropname": "ANGLETON",
    "dropdeladd": "100 CANNAN DR",
    "dropdelcty": "ANGLETON",
    "dropdelst": "TX",
    "dropdelzpp": 775159998,
    "dropphyadd": "100 CANNAN DR",
    "dropphycty": "ANGLETON",
    "dropphyst": "TX",
    "dropphyzpp": 775159998,
    "dropmaladd": "100 CANNAN DR",
    "dropmalcty": "ANGLETON",
    "dropmalst": "TX",
    "dropmalzpp": 775159998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798497500,
    "dropsitcph": 9798497500,
    "dropfax": 9798496659
  },
  {
    "dcode": "D",
    "dropkey": "PW22757",
    "droptype": "D",
    "dropname": "ANNA",
    "dropdeladd": "715 S POWELL PKWY",
    "dropdelcty": "ANNA",
    "dropdelst": "TX",
    "dropdelzpp": 754099998,
    "dropphyadd": "715 S POWELL PKWY",
    "dropphycty": "ANNA",
    "dropphyst": "TX",
    "dropphyzpp": 754099998,
    "dropmaladd": "715 S POWELL PKWY",
    "dropmalcty": "ANNA",
    "dropmalst": "TX",
    "dropmalzpp": 754099998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729243350,
    "dropsitcph": 9729243350,
    "dropfax": 9729243525
  },
  {
    "dcode": "D",
    "dropkey": "PW22758",
    "droptype": "D",
    "dropname": "ANNONA",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "ANNONA",
    "dropdelst": "TX",
    "dropdelzpp": 755509998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "ANNONA",
    "dropphyst": "TX",
    "dropphyzpp": 755509998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "ANNONA",
    "dropmalst": "TX",
    "dropmalzpp": 755509998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036973651,
    "dropsitcph": 9036973651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22759",
    "droptype": "D",
    "dropname": "ANSON",
    "dropdeladd": "1002 11TH ST",
    "dropdelcty": "ANSON",
    "dropdelst": "TX",
    "dropdelzpp": 795019998,
    "dropphyadd": "1002 11TH ST",
    "dropphycty": "ANSON",
    "dropphyst": "TX",
    "dropphyzpp": 795019998,
    "dropmaladd": "1002 11TH ST",
    "dropmalcty": "ANSON",
    "dropmalst": "TX",
    "dropmalzpp": 795019998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258232241,
    "dropsitcph": 3258232241,
    "dropfax": 3258232241
  },
  {
    "dcode": "D",
    "dropkey": "PW22769",
    "droptype": "D",
    "dropname": "ANTON",
    "dropdeladd": "306 LAWRENCE ST",
    "dropdelcty": "ANTON",
    "dropdelst": "TX",
    "dropdelzpp": 793139802,
    "dropphyadd": "306 LAWRENCE ST",
    "dropphycty": "ANTON",
    "dropphyst": "TX",
    "dropphyzpp": 793139802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANTON",
    "dropmalst": "TX",
    "dropmalzpp": 793139998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069975951,
    "dropsitcph": 8069975951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22770",
    "droptype": "D",
    "dropname": "APPLE SPRINGS",
    "dropdeladd": "15799 N STATE HIGHWAY 94",
    "dropdelcty": "APPLE SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 759269998,
    "dropphyadd": "15799 N STATE HIGHWAY 94",
    "dropphycty": "APPLE SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 759269998,
    "dropmaladd": "15799 N STATE HIGHWAY 94",
    "dropmalcty": "APPLE SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 759269998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368312737,
    "dropsitcph": 9368312737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22772",
    "droptype": "D",
    "dropname": "AQUILLA",
    "dropdeladd": "200 E TREADWELL",
    "dropdelcty": "AQUILLA",
    "dropdelst": "TX",
    "dropdelzpp": 766229998,
    "dropphyadd": "200 E TREADWELL",
    "dropphycty": "AQUILLA",
    "dropphyst": "TX",
    "dropphyzpp": 766229998,
    "dropmaladd": "200 E TREADWELL",
    "dropmalcty": "AQUILLA",
    "dropmalst": "TX",
    "dropmalzpp": 766229998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546942945,
    "dropsitcph": 2546942945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22773",
    "droptype": "D",
    "dropname": "ARANSAS PASS",
    "dropdeladd": "634 S COMMERCIAL ST",
    "dropdelcty": "ARANSAS PASS",
    "dropdelst": "TX",
    "dropdelzpp": 783369998,
    "dropphyadd": "634 S COMMERCIAL ST",
    "dropphycty": "ARANSAS PASS",
    "dropphyst": "TX",
    "dropphyzpp": 783369998,
    "dropmaladd": "634 S COMMERCIAL ST",
    "dropmalcty": "ARANSAS PASS",
    "dropmalst": "TX",
    "dropmalzpp": 783369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617586938,
    "dropsitcph": 3617586938,
    "dropfax": 3617582640
  },
  {
    "dcode": "D",
    "dropkey": "PW22776",
    "droptype": "D",
    "dropname": "ARCHER CITY",
    "dropdeladd": "500 N CENTER",
    "dropdelcty": "ARCHER CITY",
    "dropdelst": "TX",
    "dropdelzpp": 763519801,
    "dropphyadd": "500 N CENTER",
    "dropphycty": "ARCHER CITY",
    "dropphyst": "TX",
    "dropphyzpp": 763519801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCHER CITY",
    "dropmalst": "TX",
    "dropmalzpp": 763519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405744222,
    "dropsitcph": 9405744222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22780",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "440 HIGHWAY 377 N",
    "dropdelcty": "ARGYLE",
    "dropdelst": "TX",
    "dropdelzpp": 762269998,
    "dropphyadd": "440 HIGHWAY 377 N",
    "dropphycty": "ARGYLE",
    "dropphyst": "TX",
    "dropphyzpp": 762269998,
    "dropmaladd": "440 HIGHWAY 377 N",
    "dropmalcty": "ARGYLE",
    "dropmalst": "TX",
    "dropmalzpp": 762269998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404647626,
    "dropsitcph": 9404647626,
    "dropfax": 9404647110
  },
  {
    "dcode": "D",
    "dropkey": "PW22782",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "300 E SOUTH ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760049997,
    "dropphyadd": "300 E SOUTH ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760049997,
    "dropmaladd": "300 E SOUTH ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760049997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175438412,
    "dropsitcph": 8175438413,
    "dropfax": 8172776430
  },
  {
    "dcode": "D",
    "dropkey": "PW22787",
    "droptype": "D",
    "dropname": "ARP",
    "dropdeladd": "202 W FRONT ST",
    "dropdelcty": "ARP",
    "dropdelst": "TX",
    "dropdelzpp": 757509998,
    "dropphyadd": "202 W FRONT ST",
    "dropphycty": "ARP",
    "dropphyst": "TX",
    "dropphyzpp": 757509998,
    "dropmaladd": "202 W FRONT ST",
    "dropmalcty": "ARP",
    "dropmalst": "TX",
    "dropmalzpp": 757509998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038595641,
    "dropsitcph": 9038595641,
    "dropfax": 9038591572
  },
  {
    "dcode": "D",
    "dropkey": "PW22790",
    "droptype": "D",
    "dropname": "ART",
    "dropdeladd": "7866 E STATE HIGHWAY 29",
    "dropdelcty": "ART",
    "dropdelst": "TX",
    "dropdelzpp": 768209817,
    "dropphyadd": "7866 E STATE HIGHWAY 29",
    "dropphycty": "ART",
    "dropphyst": "TX",
    "dropphyzpp": 768209817,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ART",
    "dropmalst": "TX",
    "dropmalzpp": 768209998,
    "dropsitphn": 3253476595,
    "dropsitlph": 3253476595,
    "dropsitcph": 3253476595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22792",
    "droptype": "D",
    "dropname": "ARTHUR CITY",
    "dropdeladd": "12552 N US HIGHWAY 271",
    "dropdelcty": "ARTHUR CITY",
    "dropdelst": "TX",
    "dropdelzpp": 754119998,
    "dropphyadd": "12552 N US HIGHWAY 271",
    "dropphycty": "ARTHUR CITY",
    "dropphyst": "TX",
    "dropphyzpp": 754119998,
    "dropmaladd": "12552 N US HIGHWAY 271",
    "dropmalcty": "ARTHUR CITY",
    "dropmalst": "TX",
    "dropmalzpp": 754119998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037324517,
    "dropsitcph": 9037324517,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "PW22795",
    "droptype": "D",
    "dropname": "ASHERTON",
    "dropdeladd": "572 W CARTER ST",
    "dropdelcty": "ASHERTON",
    "dropdelst": "TX",
    "dropdelzpp": 788279998,
    "dropphyadd": "572 W CARTER ST",
    "dropphycty": "ASHERTON",
    "dropphyst": "TX",
    "dropphyzpp": 788279998,
    "dropmaladd": "572 W CARTER ST",
    "dropmalcty": "ASHERTON",
    "dropmalst": "TX",
    "dropmalzpp": 788279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304683376,
    "dropsitcph": 8304683376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22800",
    "droptype": "D",
    "dropname": "ASPERMONT",
    "dropdeladd": "704 S WASHINGTON AVE",
    "dropdelcty": "ASPERMONT",
    "dropdelst": "TX",
    "dropdelzpp": 795029998,
    "dropphyadd": "704 S WASHINGTON AVE",
    "dropphycty": "ASPERMONT",
    "dropphyst": "TX",
    "dropphyzpp": 795029998,
    "dropmaladd": "704 S WASHINGTON AVE",
    "dropmalcty": "ASPERMONT",
    "dropmalst": "TX",
    "dropmalzpp": 795029998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 9409892661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22807",
    "droptype": "D",
    "dropname": "ATASCOSA",
    "dropdeladd": "10850 PEARSALL RD",
    "dropdelcty": "ATASCOSA",
    "dropdelst": "TX",
    "dropdelzpp": 780029998,
    "dropphyadd": "10850 PEARSALL RD",
    "dropphycty": "ATASCOSA",
    "dropphyst": "TX",
    "dropphyzpp": 780029998,
    "dropmaladd": "10850 PEARSALL RD",
    "dropmalcty": "ATASCOSA",
    "dropmalst": "TX",
    "dropmalzpp": 780029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106229327,
    "dropsitcph": 2106228997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22809",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "409 E TYLER ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "TX",
    "dropdelzpp": 757519998,
    "dropphyadd": "409 E TYLER ST",
    "dropphycty": "ATHENS",
    "dropphyst": "TX",
    "dropphyzpp": 757519998,
    "dropmaladd": "409 E TYLER ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "TX",
    "dropmalzpp": 757519998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036755731,
    "dropsitcph": 9036755731,
    "dropfax": 9036758406
  },
  {
    "dcode": "D",
    "dropkey": "PW22810",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "101 E MILLER ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "TX",
    "dropdelzpp": 755519998,
    "dropphyadd": "101 E MILLER ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "TX",
    "dropphyzpp": 755519998,
    "dropmaladd": "101 E MILLER ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "TX",
    "dropmalzpp": 755519998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037963701,
    "dropsitcph": 9037963701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22812",
    "droptype": "D",
    "dropname": "AUBREY",
    "dropdeladd": "120 STANLEY DR",
    "dropdelcty": "AUBREY",
    "dropdelst": "TX",
    "dropdelzpp": 762279997,
    "dropphyadd": "120 STANLEY DR",
    "dropphycty": "AUBREY",
    "dropphyst": "TX",
    "dropphyzpp": 762279997,
    "dropmaladd": "120 STANLEY DR",
    "dropmalcty": "AUBREY",
    "dropmalst": "TX",
    "dropmalzpp": 762279997,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403659862,
    "dropsitcph": 9403652621,
    "dropfax": 9403652963
  },
  {
    "dcode": "D",
    "dropkey": "PW22815",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "8225 CROSS PARK DR",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787109998,
    "dropphyadd": "8225 CROSS PARK DR",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787109998,
    "dropmaladd": "8225 CROSS PARK DR",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123421271,
    "dropsitcph": 5123421259,
    "dropfax": 5123421298
  },
  {
    "dcode": "D",
    "dropkey": "PW22817",
    "droptype": "D",
    "dropname": "AUSTWELL",
    "dropdeladd": "611 VANDENBERGE ST",
    "dropdelcty": "AUSTWELL",
    "dropdelst": "TX",
    "dropdelzpp": 779509800,
    "dropphyadd": "611 VANDENBERGE ST",
    "dropphycty": "AUSTWELL",
    "dropphyst": "TX",
    "dropphyzpp": 779509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTWELL",
    "dropmalst": "TX",
    "dropmalzpp": 779509998,
    "dropsitphn": 2103868387,
    "dropsitlph": 3612863612,
    "dropsitcph": 3612863612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22818",
    "droptype": "D",
    "dropname": "AVALON",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "AVALON",
    "dropdelst": "TX",
    "dropdelzpp": 766239800,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "AVALON",
    "dropphyst": "TX",
    "dropphyzpp": 766239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVALON",
    "dropmalst": "TX",
    "dropmalzpp": 766239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9726273213,
    "dropsitcph": 9726273213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22819",
    "droptype": "D",
    "dropname": "AVERY",
    "dropdeladd": "340 FM 911 S",
    "dropdelcty": "AVERY",
    "dropdelst": "TX",
    "dropdelzpp": 755549998,
    "dropphyadd": "340 FM 911 S",
    "dropphycty": "AVERY",
    "dropphyst": "TX",
    "dropphyzpp": 755549998,
    "dropmaladd": "340 FM 911 S",
    "dropmalcty": "AVERY",
    "dropmalst": "TX",
    "dropmalzpp": 755549998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036843760,
    "dropsitcph": 9036843760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22820",
    "droptype": "D",
    "dropname": "AVINGER",
    "dropdeladd": "102 TEXAS HIGHWAY 155",
    "dropdelcty": "AVINGER",
    "dropdelst": "TX",
    "dropdelzpp": 756309998,
    "dropphyadd": "102 TEXAS HIGHWAY 155",
    "dropphycty": "AVINGER",
    "dropphyst": "TX",
    "dropphyzpp": 756309998,
    "dropmaladd": "102 TEXAS HIGHWAY 155",
    "dropmalcty": "AVINGER",
    "dropmalst": "TX",
    "dropmalzpp": 756309998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036047333,
    "dropsitcph": 9036047333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22823",
    "droptype": "D",
    "dropname": "AXTELL",
    "dropdeladd": "4521 E OLD AXTELL RD",
    "dropdelcty": "AXTELL",
    "dropdelst": "TX",
    "dropdelzpp": 766249998,
    "dropphyadd": "4521 E OLD AXTELL RD",
    "dropphycty": "AXTELL",
    "dropphyst": "TX",
    "dropphyzpp": 766249998,
    "dropmaladd": "4521 E OLD AXTELL RD",
    "dropmalcty": "AXTELL",
    "dropmalst": "TX",
    "dropmalzpp": 766249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548635449,
    "dropsitcph": 2548635449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22825",
    "droptype": "D",
    "dropname": "AZLE",
    "dropdeladd": "409 COMMERCE ST",
    "dropdelcty": "AZLE",
    "dropdelst": "TX",
    "dropdelzpp": 760209998,
    "dropphyadd": "409 COMMERCE ST",
    "dropphycty": "AZLE",
    "dropphyst": "TX",
    "dropphyzpp": 760209998,
    "dropmaladd": "409 COMMERCE ST",
    "dropmalcty": "AZLE",
    "dropmalst": "TX",
    "dropmalzpp": 760209998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174444903,
    "dropsitcph": 8174446332,
    "dropfax": 8174449445
  },
  {
    "dcode": "D",
    "dropkey": "PW22826",
    "droptype": "D",
    "dropname": "BACLIFF",
    "dropdeladd": "415 GRAND AVE",
    "dropdelcty": "BACLIFF",
    "dropdelst": "TX",
    "dropdelzpp": 775181542,
    "dropphyadd": "415 GRAND AVE",
    "dropphycty": "BACLIFF",
    "dropphyst": "TX",
    "dropphyzpp": 775181542,
    "dropmaladd": "415 GRAND AVE",
    "dropmalcty": "BACLIFF",
    "dropmalst": "TX",
    "dropmalzpp": 775181542,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813390562,
    "dropsitcph": 2813390946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22827",
    "droptype": "D",
    "dropname": "BAGWELL",
    "dropdeladd": "5294 FARM ROAD 2573",
    "dropdelcty": "BAGWELL",
    "dropdelst": "TX",
    "dropdelzpp": 754129998,
    "dropphyadd": "5294 FARM ROAD 2573",
    "dropphycty": "BAGWELL",
    "dropphyst": "TX",
    "dropphyzpp": 754129998,
    "dropmaladd": "5294 FARM ROAD 2573",
    "dropmalcty": "BAGWELL",
    "dropmalst": "TX",
    "dropmalzpp": 754129998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039252171,
    "dropsitcph": 9039252171,
    "dropfax": 9039252171
  },
  {
    "dcode": "D",
    "dropkey": "PW22829",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "BAILEY",
    "dropdelst": "TX",
    "dropdelzpp": 754139998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "BAILEY",
    "dropphyst": "TX",
    "dropphyzpp": 754139998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "BAILEY",
    "dropmalst": "TX",
    "dropmalzpp": 754139998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035833202,
    "dropsitcph": 9035833202,
    "dropfax": 9035835680
  },
  {
    "dcode": "D",
    "dropkey": "PW22832",
    "droptype": "D",
    "dropname": "BAIRD",
    "dropdeladd": "208 W 3RD ST",
    "dropdelcty": "BAIRD",
    "dropdelst": "TX",
    "dropdelzpp": 795049998,
    "dropphyadd": "208 W 3RD ST",
    "dropphycty": "BAIRD",
    "dropphyst": "TX",
    "dropphyzpp": 795049998,
    "dropmaladd": "208 W 3RD ST",
    "dropmalcty": "BAIRD",
    "dropmalst": "TX",
    "dropmalzpp": 795049998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258541229,
    "dropsitcph": 3258541229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22839",
    "droptype": "D",
    "dropname": "BALLINGER",
    "dropdeladd": "116 S 8TH ST",
    "dropdelcty": "BALLINGER",
    "dropdelst": "TX",
    "dropdelzpp": 768219998,
    "dropphyadd": "116 S 8TH ST",
    "dropphycty": "BALLINGER",
    "dropphyst": "TX",
    "dropphyzpp": 768219998,
    "dropmaladd": "116 S 8TH ST",
    "dropmalcty": "BALLINGER",
    "dropmalst": "TX",
    "dropmalzpp": 768219998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253652719,
    "dropfax": 3253652940
  },
  {
    "dcode": "D",
    "dropkey": "PW22840",
    "droptype": "D",
    "dropname": "BALMORHEA",
    "dropdeladd": "115 N FORT WORTH ST",
    "dropdelcty": "BALMORHEA",
    "dropdelst": "TX",
    "dropdelzpp": 797189998,
    "dropphyadd": "115 N FORT WORTH ST",
    "dropphycty": "BALMORHEA",
    "dropphyst": "TX",
    "dropphyzpp": 797189998,
    "dropmaladd": "115 N FORT WORTH ST",
    "dropmalcty": "BALMORHEA",
    "dropmalst": "TX",
    "dropmalzpp": 797189998,
    "dropsitphn": 4323755005,
    "dropsitlph": 4323755005,
    "dropsitcph": 4323755018,
    "dropfax": 4323752558
  },
  {
    "dcode": "D",
    "dropkey": "PW22842",
    "droptype": "D",
    "dropname": "BANDERA",
    "dropdeladd": "130 STATE HIGHWAY 173 N",
    "dropdelcty": "BANDERA",
    "dropdelst": "TX",
    "dropdelzpp": 780039998,
    "dropphyadd": "130 STATE HIGHWAY 173 N",
    "dropphycty": "BANDERA",
    "dropphyst": "TX",
    "dropphyzpp": 780039998,
    "dropmaladd": "130 STATE HIGHWAY 173 N",
    "dropmalcty": "BANDERA",
    "dropmalst": "TX",
    "dropmalzpp": 780039998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307964111,
    "dropsitcph": 8307964111,
    "dropfax": 8307963529
  },
  {
    "dcode": "D",
    "dropkey": "PW22843",
    "droptype": "D",
    "dropname": "BANGS",
    "dropdeladd": "300 E SANTA FE ST",
    "dropdelcty": "BANGS",
    "dropdelst": "TX",
    "dropdelzpp": 768239998,
    "dropphyadd": "300 E SANTA FE ST",
    "dropphycty": "BANGS",
    "dropphyst": "TX",
    "dropphyzpp": 768239998,
    "dropmaladd": "300 E SANTA FE ST",
    "dropmalcty": "BANGS",
    "dropmalst": "TX",
    "dropmalzpp": 768239998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3257526221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22846",
    "droptype": "D",
    "dropname": "BANQUETE",
    "dropdeladd": "4376 ELIA ST",
    "dropdelcty": "BANQUETE",
    "dropdelst": "TX",
    "dropdelzpp": 783399800,
    "dropphyadd": "4376 ELIA ST",
    "dropphycty": "BANQUETE",
    "dropphyst": "TX",
    "dropphyzpp": 783399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANQUETE",
    "dropmalst": "TX",
    "dropmalzpp": 783399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613873795,
    "dropsitcph": 3613873795,
    "dropfax": 3613871994
  },
  {
    "dcode": "D",
    "dropkey": "PW22849",
    "droptype": "D",
    "dropname": "BARDWELL",
    "dropdeladd": "100 ELLIS ST",
    "dropdelcty": "BARDWELL",
    "dropdelst": "TX",
    "dropdelzpp": 751019998,
    "dropphyadd": "100 ELLIS ST",
    "dropphycty": "BARDWELL",
    "dropphyst": "TX",
    "dropphyzpp": 751019998,
    "dropmaladd": "100 ELLIS ST",
    "dropmalcty": "BARDWELL",
    "dropmalst": "TX",
    "dropmalzpp": 751019998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726465275,
    "dropsitcph": 9726465275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22850",
    "droptype": "D",
    "dropname": "BARKER",
    "dropdeladd": "211 BAKER RD",
    "dropdelcty": "BARKER",
    "dropdelst": "TX",
    "dropdelzpp": 774139800,
    "dropphyadd": "211 BAKER RD",
    "dropphycty": "BARKER",
    "dropphyst": "TX",
    "dropphyzpp": 774139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARKER",
    "dropmalst": "TX",
    "dropmalzpp": 774139998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814922629,
    "dropsitcph": 2815990924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22852",
    "droptype": "D",
    "dropname": "BARKSDALE",
    "dropdeladd": "25594 S HIGHWAY 55",
    "dropdelcty": "BARKSDALE",
    "dropdelst": "TX",
    "dropdelzpp": 788289998,
    "dropphyadd": "25594 S HIGHWAY 55",
    "dropphycty": "BARKSDALE",
    "dropphyst": "TX",
    "dropphyzpp": 788289998,
    "dropmaladd": "25594 S HIGHWAY 55",
    "dropmalcty": "BARKSDALE",
    "dropmalst": "TX",
    "dropmalzpp": 788289998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302343617,
    "dropsitcph": 8302343617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22854",
    "droptype": "D",
    "dropname": "BARNHART",
    "dropdeladd": "133 MAIN ST",
    "dropdelcty": "BARNHART",
    "dropdelst": "TX",
    "dropdelzpp": 769309700,
    "dropphyadd": "133 MAIN ST",
    "dropphycty": "BARNHART",
    "dropphyst": "TX",
    "dropphyzpp": 769309700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNHART",
    "dropmalst": "TX",
    "dropmalzpp": 769309998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258765015,
    "dropsitcph": 3258765015,
    "dropfax": 3258765019
  },
  {
    "dcode": "D",
    "dropkey": "PW22857",
    "droptype": "D",
    "dropname": "BARRY",
    "dropdeladd": "103 HOUSTON ST",
    "dropdelcty": "BARRY",
    "dropdelst": "TX",
    "dropdelzpp": 751029998,
    "dropphyadd": "103 HOUSTON ST",
    "dropphycty": "BARRY",
    "dropphyst": "TX",
    "dropphyzpp": 751029998,
    "dropmaladd": "103 HOUSTON ST",
    "dropmalcty": "BARRY",
    "dropmalst": "TX",
    "dropmalzpp": 751029998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9036952696,
    "dropsitcph": 9036952696,
    "dropfax": 9036950592
  },
  {
    "dcode": "D",
    "dropkey": "PW22858",
    "droptype": "D",
    "dropname": "BARSTOW",
    "dropdeladd": "211 MACKEY AVE",
    "dropdelcty": "BARSTOW",
    "dropdelst": "TX",
    "dropdelzpp": 797199800,
    "dropphyadd": "211 MACKEY AVE",
    "dropphycty": "BARSTOW",
    "dropphyst": "TX",
    "dropphyzpp": 797199800,
    "dropmaladd": "PO BOX 75",
    "dropmalcty": "BARSTOW",
    "dropmalst": "TX",
    "dropmalzpp": 797190075,
    "dropsitphn": 2103688387,
    "dropsitlph": 4327807543,
    "dropsitcph": 4324456839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22859",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "131 N EVIE ST",
    "dropdelcty": "BARTLETT",
    "dropdelst": "TX",
    "dropdelzpp": 765119998,
    "dropphyadd": "131 N EVIE ST",
    "dropphycty": "BARTLETT",
    "dropphyst": "TX",
    "dropphyzpp": 765119998,
    "dropmaladd": "131 N EVIE ST",
    "dropmalcty": "BARTLETT",
    "dropmalst": "TX",
    "dropmalzpp": 765119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545273979,
    "dropsitcph": 2545273979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22865",
    "droptype": "D",
    "dropname": "BASTROP",
    "dropdeladd": "1106 MAIN ST",
    "dropdelcty": "BASTROP",
    "dropdelst": "TX",
    "dropdelzpp": 786029998,
    "dropphyadd": "1106 MAIN ST",
    "dropphycty": "BASTROP",
    "dropphyst": "TX",
    "dropphyzpp": 786029998,
    "dropmaladd": "1106 MAIN ST",
    "dropmalcty": "BASTROP",
    "dropmalst": "TX",
    "dropmalzpp": 786029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123210858,
    "dropsitcph": 5123031014,
    "dropfax": 5123214494
  },
  {
    "dcode": "D",
    "dropkey": "PW22866",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "1 NOPAL ALY",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 788299998,
    "dropphyadd": "1 NOPAL ALY",
    "dropphycty": "BATESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 788299998,
    "dropmaladd": "1 NOPAL ALY",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 788299998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303764286,
    "dropsitcph": 8303764286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22867",
    "droptype": "D",
    "dropname": "BATSON",
    "dropdeladd": "9117 MAIN ST",
    "dropdelcty": "BATSON",
    "dropdelst": "TX",
    "dropdelzpp": 775197938,
    "dropphyadd": "9117 MAIN ST",
    "dropphycty": "BATSON",
    "dropphyst": "TX",
    "dropphyzpp": 775197938,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATSON",
    "dropmalst": "TX",
    "dropmalzpp": 775199998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362628471,
    "dropsitcph": 9362628471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22870",
    "droptype": "D",
    "dropname": "BAY CITY",
    "dropdeladd": "1309 BAYWOOD DR",
    "dropdelcty": "BAY CITY",
    "dropdelst": "TX",
    "dropdelzpp": 774149998,
    "dropphyadd": "1309 BAYWOOD DR",
    "dropphycty": "BAY CITY",
    "dropphyst": "TX",
    "dropphyzpp": 774149998,
    "dropmaladd": "1309 BAYWOOD DR",
    "dropmalcty": "BAY CITY",
    "dropmalst": "TX",
    "dropmalzpp": 774149998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792452051,
    "dropsitcph": 9792452051,
    "dropfax": 9792457647
  },
  {
    "dcode": "D",
    "dropkey": "PW22874",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "715 THIRD ST",
    "dropdelcty": "BAYSIDE",
    "dropdelst": "TX",
    "dropdelzpp": 783403019,
    "dropphyadd": "715 THIRD ST",
    "dropphycty": "BAYSIDE",
    "dropphyst": "TX",
    "dropphyzpp": 783403019,
    "dropmaladd": "715 THIRD ST",
    "dropmalcty": "BAYSIDE",
    "dropmalst": "TX",
    "dropmalzpp": 783403019,
    "dropsitphn": 2103688387,
    "dropsitlph": 5125296511,
    "dropsitcph": 3615296511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22875",
    "droptype": "D",
    "dropname": "BAYTOWN",
    "dropdeladd": "601 W BAKER RD",
    "dropdelcty": "BAYTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 775212306,
    "dropphyadd": "601 W BAKER RD",
    "dropphycty": "BAYTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 775212306,
    "dropmaladd": "601 W BAKER RD",
    "dropmalcty": "BAYTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 775212306,
    "dropsitphn": 7132263055,
    "dropsitlph": 2818318577,
    "dropsitcph": 2814228218,
    "dropfax": 2818378880
  },
  {
    "dcode": "D",
    "dropkey": "PW22883",
    "droptype": "D",
    "dropname": "BEASLEY",
    "dropdeladd": "7031 LOOP 540",
    "dropdelcty": "BEASLEY",
    "dropdelst": "TX",
    "dropdelzpp": 774170079,
    "dropphyadd": "7031 LOOP 540",
    "dropphycty": "BEASLEY",
    "dropphyst": "TX",
    "dropphyzpp": 774170079,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEASLEY",
    "dropmalst": "TX",
    "dropmalzpp": 774179998,
    "dropsitphn": 9798722210,
    "dropsitlph": 9793872210,
    "dropsitcph": 9793872210,
    "dropfax": 9793872020
  },
  {
    "dcode": "D",
    "dropkey": "PW22886",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "5815 WALDEN RD",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777079998,
    "dropphyadd": "5815 WALDEN RD",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777079998,
    "dropmaladd": "5815 WALDEN RD",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777079998,
    "dropsitphn": 4099818730,
    "dropsitlph": 4099818637,
    "dropsitcph": 4099818600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22889",
    "droptype": "D",
    "dropname": "BECKVILLE",
    "dropdeladd": "125 S WASHINGTON ST",
    "dropdelcty": "BECKVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756319998,
    "dropphyadd": "125 S WASHINGTON ST",
    "dropphycty": "BECKVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756319998,
    "dropmaladd": "125 S WASHINGTON ST",
    "dropmalcty": "BECKVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756319998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9032919039,
    "dropsitcph": 9032919039,
    "dropfax": 9036782154
  },
  {
    "dcode": "D",
    "dropkey": "PW22890",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "1300 HARWOOD RD",
    "dropdelcty": "BEDFORD",
    "dropdelst": "TX",
    "dropdelzpp": 760214516,
    "dropphyadd": "1300 HARWOOD RD",
    "dropphycty": "BEDFORD",
    "dropphyst": "TX",
    "dropphyzpp": 760214516,
    "dropmaladd": "1300 HARWOOD RD",
    "dropmalcty": "BEDFORD",
    "dropmalst": "TX",
    "dropmalzpp": 760214516,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172834264,
    "dropsitcph": 8172830253,
    "dropfax": 8172830172
  },
  {
    "dcode": "D",
    "dropkey": "PW22891",
    "droptype": "D",
    "dropname": "BEDIAS",
    "dropdeladd": "3681 MAIN ST",
    "dropdelcty": "BEDIAS",
    "dropdelst": "TX",
    "dropdelzpp": 778319812,
    "dropphyadd": "3681 MAIN ST",
    "dropphycty": "BEDIAS",
    "dropphyst": "TX",
    "dropphyzpp": 778319812,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEDIAS",
    "dropmalst": "TX",
    "dropmalzpp": 778319998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362200007,
    "dropsitcph": 9362200009,
    "dropfax": 9363951669
  },
  {
    "dcode": "D",
    "dropkey": "PW22898",
    "droptype": "D",
    "dropname": "BEEVILLE",
    "dropdeladd": "111 N SAINT MARYS ST",
    "dropdelcty": "BEEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 781029998,
    "dropphyadd": "111 N SAINT MARYS ST",
    "dropphycty": "BEEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 781029998,
    "dropmaladd": "111 N SAINT MARYS ST",
    "dropmalcty": "BEEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 781029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613688384,
    "dropsitcph": 3613583727,
    "dropfax": 3613621633
  },
  {
    "dcode": "D",
    "dropkey": "PW22901",
    "droptype": "D",
    "dropname": "BELLAIRE",
    "dropdeladd": "5350 BELLAIRE BLVD",
    "dropdelcty": "BELLAIRE",
    "dropdelst": "TX",
    "dropdelzpp": 774019998,
    "dropphyadd": "5350 BELLAIRE BLVD",
    "dropphycty": "BELLAIRE",
    "dropphyst": "TX",
    "dropphyzpp": 774019998,
    "dropmaladd": "5350 BELLAIRE BLVD",
    "dropmalcty": "BELLAIRE",
    "dropmalst": "TX",
    "dropmalzpp": 774019998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136689521,
    "dropsitcph": 7136681004,
    "dropfax": 7132188159
  },
  {
    "dcode": "D",
    "dropkey": "PW22902",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "501 FRANKLIN ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "TX",
    "dropdelzpp": 762289998,
    "dropphyadd": "501 FRANKLIN ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "TX",
    "dropphyzpp": 762289998,
    "dropmaladd": "501 FRANKLIN ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "TX",
    "dropmalzpp": 762289998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9409282144,
    "dropsitcph": 9409282144,
    "dropfax": 6505783819
  },
  {
    "dcode": "D",
    "dropkey": "PW22904",
    "droptype": "D",
    "dropname": "BELLS",
    "dropdeladd": "710 W BELLS BLVD",
    "dropdelcty": "BELLS",
    "dropdelst": "TX",
    "dropdelzpp": 754149998,
    "dropphyadd": "710 W BELLS BLVD",
    "dropphycty": "BELLS",
    "dropphyst": "TX",
    "dropphyzpp": 754149998,
    "dropmaladd": "710 W BELLS BLVD",
    "dropmalcty": "BELLS",
    "dropmalst": "TX",
    "dropmalzpp": 754149998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039657774,
    "dropsitcph": 9039657774,
    "dropfax": 9039650106
  },
  {
    "dcode": "D",
    "dropkey": "PW22906",
    "droptype": "D",
    "dropname": "BELLVILLE",
    "dropdeladd": "229 E PALM ST",
    "dropdelcty": "BELLVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 774189998,
    "dropphyadd": "229 E PALM ST",
    "dropphycty": "BELLVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 774189998,
    "dropmaladd": "229 E PALM ST",
    "dropmalcty": "BELLVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 774189998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798653450,
    "dropsitcph": 9798653450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22910",
    "droptype": "D",
    "dropname": "BELTON",
    "dropdeladd": "111 N WALL ST",
    "dropdelcty": "BELTON",
    "dropdelst": "TX",
    "dropdelzpp": 765139998,
    "dropphyadd": "111 N WALL ST",
    "dropphycty": "BELTON",
    "dropphyst": "TX",
    "dropphyzpp": 765139998,
    "dropmaladd": "111 N WALL ST",
    "dropmalcty": "BELTON",
    "dropmalst": "TX",
    "dropmalzpp": 765139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549392421,
    "dropsitcph": 2549392421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22913",
    "droptype": "D",
    "dropname": "BEN FRANKLIN",
    "dropdeladd": "828 FARM ROAD 38",
    "dropdelcty": "BEN FRANKLIN",
    "dropdelst": "TX",
    "dropdelzpp": 754159998,
    "dropphyadd": "828 FARM ROAD 38",
    "dropphycty": "BEN FRANKLIN",
    "dropphyst": "TX",
    "dropphyzpp": 754159998,
    "dropmaladd": "828 FARM ROAD 38",
    "dropmalcty": "BEN FRANKLIN",
    "dropmalst": "TX",
    "dropmalzpp": 754159998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033254333,
    "dropsitcph": 9033254333,
    "dropfax": 9033254333
  },
  {
    "dcode": "D",
    "dropkey": "PW22915",
    "droptype": "D",
    "dropname": "BEN WHEELER",
    "dropdeladd": "13838 STATE HIGHWAY 64",
    "dropdelcty": "BEN WHEELER",
    "dropdelst": "TX",
    "dropdelzpp": 757549998,
    "dropphyadd": "13838 STATE HIGHWAY 64",
    "dropphycty": "BEN WHEELER",
    "dropphyst": "TX",
    "dropphyzpp": 757549998,
    "dropmaladd": "13838 STATE HIGHWAY 64",
    "dropmalcty": "BEN WHEELER",
    "dropmalst": "TX",
    "dropmalzpp": 757549998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038335361,
    "dropsitcph": 9038335361,
    "dropfax": 9038331055
  },
  {
    "dcode": "D",
    "dropkey": "PW22916",
    "droptype": "D",
    "dropname": "BENAVIDES",
    "dropdeladd": "404 E MAIN",
    "dropdelcty": "BENAVIDES",
    "dropdelst": "TX",
    "dropdelzpp": 783419800,
    "dropphyadd": "404 E MAIN",
    "dropphycty": "BENAVIDES",
    "dropphyst": "TX",
    "dropphyzpp": 783419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENAVIDES",
    "dropmalst": "TX",
    "dropmalzpp": 783419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612563512,
    "dropsitcph": 3612563512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22920",
    "droptype": "D",
    "dropname": "BEND",
    "dropdeladd": "22902 W FM 580",
    "dropdelcty": "BEND",
    "dropdelst": "TX",
    "dropdelzpp": 768243000,
    "dropphyadd": "22902 W FM 580",
    "dropphycty": "BEND",
    "dropphyst": "TX",
    "dropphyzpp": 768243000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEND",
    "dropmalst": "TX",
    "dropmalzpp": 768249998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256283358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22921",
    "droptype": "D",
    "dropname": "BENJAMIN",
    "dropdeladd": "105 S HINTON ST",
    "dropdelcty": "BENJAMIN",
    "dropdelst": "TX",
    "dropdelzpp": 795059998,
    "dropphyadd": "105 S HINTON ST",
    "dropphycty": "BENJAMIN",
    "dropphyst": "TX",
    "dropphyzpp": 795059998,
    "dropmaladd": "105 S HINTON ST",
    "dropmalcty": "BENJAMIN",
    "dropmalst": "TX",
    "dropmalzpp": 795059998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 9404593441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22923",
    "droptype": "D",
    "dropname": "BERCLAIR",
    "dropdeladd": "15864 US HIGHWAY 59 S",
    "dropdelcty": "BERCLAIR",
    "dropdelst": "TX",
    "dropdelzpp": 781079800,
    "dropphyadd": "15864 US HIGHWAY 59 S",
    "dropphycty": "BERCLAIR",
    "dropphyst": "TX",
    "dropphyzpp": 781079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERCLAIR",
    "dropmalst": "TX",
    "dropmalzpp": 781079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3614397222,
    "dropsitcph": 3614397222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22932",
    "droptype": "D",
    "dropname": "BERTRAM",
    "dropdeladd": "135 W FM 243",
    "dropdelcty": "BERTRAM",
    "dropdelst": "TX",
    "dropdelzpp": 786059998,
    "dropphyadd": "135 W FM 243",
    "dropphycty": "BERTRAM",
    "dropphyst": "TX",
    "dropphyzpp": 786059998,
    "dropmaladd": "135 W FM 243",
    "dropmalcty": "BERTRAM",
    "dropmalst": "TX",
    "dropmalzpp": 786059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123552094,
    "dropsitcph": 5123552144,
    "dropfax": 5123553040
  },
  {
    "dcode": "D",
    "dropkey": "PW22945",
    "droptype": "D",
    "dropname": "BIG BEND NATIONAL PARK",
    "dropdeladd": "1 HWY 385 PANTHER JCT",
    "dropdelcty": "BIG BEND NATIONAL PARK",
    "dropdelst": "TX",
    "dropdelzpp": 798341000,
    "dropphyadd": "1 HWY 385 PANTHER JCT",
    "dropphycty": "BIG BEND NATIONAL PARK",
    "dropphyst": "TX",
    "dropphyzpp": 798341000,
    "dropmaladd": "PO BOX 20",
    "dropmalcty": "BIG BEND NATIONAL PARK",
    "dropmalst": "TX",
    "dropmalzpp": 798349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4327807543,
    "dropsitcph": 4324772238,
    "dropfax": 4324772357
  },
  {
    "dcode": "D",
    "dropkey": "PW22946",
    "droptype": "D",
    "dropname": "BIG LAKE",
    "dropdeladd": "210 E 2ND ST",
    "dropdelcty": "BIG LAKE",
    "dropdelst": "TX",
    "dropdelzpp": 769329998,
    "dropphyadd": "210 E 2ND ST",
    "dropphycty": "BIG LAKE",
    "dropphyst": "TX",
    "dropphyzpp": 769329998,
    "dropmaladd": "210 E 2ND ST",
    "dropmalcty": "BIG LAKE",
    "dropmalst": "TX",
    "dropmalzpp": 769329998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258842823,
    "dropsitcph": 3258842823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22947",
    "droptype": "D",
    "dropname": "BIG SANDY",
    "dropdeladd": "210 E BROADWAY ST",
    "dropdelcty": "BIG SANDY",
    "dropdelst": "TX",
    "dropdelzpp": 757559998,
    "dropphyadd": "210 E BROADWAY ST",
    "dropphycty": "BIG SANDY",
    "dropphyst": "TX",
    "dropphyzpp": 757559998,
    "dropmaladd": "210 E BROADWAY ST",
    "dropmalcty": "BIG SANDY",
    "dropmalst": "TX",
    "dropmalzpp": 757559998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036364350,
    "dropsitcph": 9036364350,
    "dropfax": 9036365246
  },
  {
    "dcode": "D",
    "dropkey": "PW22948",
    "droptype": "D",
    "dropname": "BIG SPRING",
    "dropdeladd": "501 S MAIN ST",
    "dropdelcty": "BIG SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 797209998,
    "dropphyadd": "501 S MAIN ST",
    "dropphycty": "BIG SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 797209998,
    "dropmaladd": "501 S MAIN ST",
    "dropmalcty": "BIG SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 797209998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4322637391,
    "dropfax": 4322646810
  },
  {
    "dcode": "D",
    "dropkey": "PW22949",
    "droptype": "D",
    "dropname": "BIG WELLS",
    "dropdeladd": "1411 GRAND AVE",
    "dropdelcty": "BIG WELLS",
    "dropdelst": "TX",
    "dropdelzpp": 788309998,
    "dropphyadd": "1411 GRAND AVE",
    "dropphycty": "BIG WELLS",
    "dropphyst": "TX",
    "dropphyzpp": 788309998,
    "dropmaladd": "1411 GRAND AVE",
    "dropmalcty": "BIG WELLS",
    "dropmalst": "TX",
    "dropmalzpp": 788309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304572322,
    "dropsitcph": 8304572322,
    "dropfax": 8304572229
  },
  {
    "dcode": "D",
    "dropkey": "PW22950",
    "droptype": "D",
    "dropname": "BIGFOOT",
    "dropdeladd": "13855 FM 472",
    "dropdelcty": "BIGFOOT",
    "dropdelst": "TX",
    "dropdelzpp": 780059998,
    "dropphyadd": "13855 FM 472",
    "dropphycty": "BIGFOOT",
    "dropphyst": "TX",
    "dropphyzpp": 780059998,
    "dropmaladd": "13855 FM 472",
    "dropmalcty": "BIGFOOT",
    "dropmalst": "TX",
    "dropmalzpp": 780059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306634656,
    "dropsitcph": 8306634656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22956",
    "droptype": "D",
    "dropname": "BISHOP",
    "dropdeladd": "201 S ASH AVE",
    "dropdelcty": "BISHOP",
    "dropdelst": "TX",
    "dropdelzpp": 783439998,
    "dropphyadd": "201 S ASH AVE",
    "dropphycty": "BISHOP",
    "dropphyst": "TX",
    "dropphyzpp": 783439998,
    "dropmaladd": "201 S ASH AVE",
    "dropmalcty": "BISHOP",
    "dropmalst": "TX",
    "dropmalzpp": 783439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615842312,
    "dropsitcph": 3615842312,
    "dropfax": 3615843003
  },
  {
    "dcode": "D",
    "dropkey": "PW22957",
    "droptype": "D",
    "dropname": "BIVINS",
    "dropdeladd": "103 MORSE RD",
    "dropdelcty": "BIVINS",
    "dropdelst": "TX",
    "dropdelzpp": 755559998,
    "dropphyadd": "103 MORSE RD",
    "dropphycty": "BIVINS",
    "dropphyst": "TX",
    "dropphyzpp": 755559998,
    "dropmaladd": "103 MORSE RD",
    "dropmalcty": "BIVINS",
    "dropmalst": "TX",
    "dropmalzpp": 755559998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037969642,
    "dropsitcph": 9037969642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22961",
    "droptype": "D",
    "dropname": "BLACKWELL",
    "dropdeladd": "101 NUECES ST",
    "dropdelcty": "BLACKWELL",
    "dropdelst": "TX",
    "dropdelzpp": 795069998,
    "dropphyadd": "101 NUECES ST",
    "dropphycty": "BLACKWELL",
    "dropphyst": "TX",
    "dropphyzpp": 795069998,
    "dropmaladd": "101 NUECES ST",
    "dropmalcty": "BLACKWELL",
    "dropmalst": "TX",
    "dropmalzpp": 795069998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3252822051,
    "dropsitcph": 3252822051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22963",
    "droptype": "D",
    "dropname": "BLANCO",
    "dropdeladd": "402 4TH ST",
    "dropdelcty": "BLANCO",
    "dropdelst": "TX",
    "dropdelzpp": 786069998,
    "dropphyadd": "402 4TH ST",
    "dropphycty": "BLANCO",
    "dropphyst": "TX",
    "dropphyzpp": 786069998,
    "dropmaladd": "402 4TH ST",
    "dropmalcty": "BLANCO",
    "dropmalst": "TX",
    "dropmalzpp": 786069998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308334918,
    "dropsitcph": 8308334918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22965",
    "droptype": "D",
    "dropname": "BLANKET",
    "dropdeladd": "801 MAIN ST",
    "dropdelcty": "BLANKET",
    "dropdelst": "TX",
    "dropdelzpp": 764329998,
    "dropphyadd": "801 MAIN ST",
    "dropphycty": "BLANKET",
    "dropphyst": "TX",
    "dropphyzpp": 764329998,
    "dropmaladd": "801 MAIN ST",
    "dropmalcty": "BLANKET",
    "dropmalst": "TX",
    "dropmalzpp": 764329998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257482561,
    "dropsitcph": 3257482561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22969",
    "droptype": "D",
    "dropname": "BLEDSOE",
    "dropdeladd": "512 4TH ST",
    "dropdelcty": "BLEDSOE",
    "dropdelst": "TX",
    "dropdelzpp": 793143000,
    "dropphyadd": "512 4TH ST",
    "dropphycty": "BLEDSOE",
    "dropphyst": "TX",
    "dropphyzpp": 793143000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLEDSOE",
    "dropmalst": "TX",
    "dropmalzpp": 793149998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065254263,
    "dropsitcph": 8065254263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22970",
    "droptype": "D",
    "dropname": "BLEIBLERVILLE",
    "dropdeladd": "3945 FM 2502",
    "dropdelcty": "BLEIBLERVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 789319998,
    "dropphyadd": "3945 FM 2502",
    "dropphycty": "BLEIBLERVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 789319998,
    "dropmaladd": "3945 FM 2502",
    "dropmalcty": "BLEIBLERVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 789319998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9798365177,
    "dropsitcph": 9798365177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22971",
    "droptype": "D",
    "dropname": "BLESSING",
    "dropdeladd": "800 FM 616 W",
    "dropdelcty": "BLESSING",
    "dropdelst": "TX",
    "dropdelzpp": 774190015,
    "dropphyadd": "800 FM 616 W",
    "dropphycty": "BLESSING",
    "dropphyst": "TX",
    "dropphyzpp": 774190015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLESSING",
    "dropmalst": "TX",
    "dropmalzpp": 774199998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3615886270,
    "dropsitcph": 3615886270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22975",
    "droptype": "D",
    "dropname": "BLOOMBURG",
    "dropdeladd": "411 S ARKANSAS AVE",
    "dropdelcty": "BLOOMBURG",
    "dropdelst": "TX",
    "dropdelzpp": 755569998,
    "dropphyadd": "411 S ARKANSAS AVE",
    "dropphycty": "BLOOMBURG",
    "dropphyst": "TX",
    "dropphyzpp": 755569998,
    "dropmaladd": "411 S ARKANSAS AVE",
    "dropmalcty": "BLOOMBURG",
    "dropmalst": "TX",
    "dropmalzpp": 755569998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032601007,
    "dropsitcph": 9032601007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22976",
    "droptype": "D",
    "dropname": "BLOOMING GROVE",
    "dropdeladd": "100 S FORDYCE ST",
    "dropdelcty": "BLOOMING GROVE",
    "dropdelst": "TX",
    "dropdelzpp": 766269998,
    "dropphyadd": "100 S FORDYCE ST",
    "dropphycty": "BLOOMING GROVE",
    "dropphyst": "TX",
    "dropphyzpp": 766269998,
    "dropmaladd": "100 S FORDYCE ST",
    "dropmalcty": "BLOOMING GROVE",
    "dropmalst": "TX",
    "dropmalzpp": 766269998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9036952212,
    "dropsitcph": 9036952212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22978",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "41 E 2ND ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 779519800,
    "dropphyadd": "41 E 2ND ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 779519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 779519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618971122,
    "dropsitcph": 3618971122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22979",
    "droptype": "D",
    "dropname": "BLOSSOM",
    "dropdeladd": "215 N CENTER ST",
    "dropdelcty": "BLOSSOM",
    "dropdelst": "TX",
    "dropdelzpp": 754169998,
    "dropphyadd": "215 N CENTER ST",
    "dropphycty": "BLOSSOM",
    "dropphyst": "TX",
    "dropphyzpp": 754169998,
    "dropmaladd": "215 N CENTER ST",
    "dropmalcty": "BLOSSOM",
    "dropmalst": "TX",
    "dropmalzpp": 754169998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039825999,
    "dropsitcph": 9039825999,
    "dropfax": 9039825999
  },
  {
    "dcode": "D",
    "dropkey": "PW22982",
    "droptype": "D",
    "dropname": "BLUE RIDGE",
    "dropdeladd": "301 S BUSINESS HIGHWAY 78",
    "dropdelcty": "BLUE RIDGE",
    "dropdelst": "TX",
    "dropdelzpp": 754249998,
    "dropphyadd": "301 S BUSINESS HIGHWAY 78",
    "dropphycty": "BLUE RIDGE",
    "dropphyst": "TX",
    "dropphyzpp": 754249998,
    "dropmaladd": "301 S BUSINESS HIGHWAY 78",
    "dropmalcty": "BLUE RIDGE",
    "dropmalst": "TX",
    "dropmalzpp": 754249998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727525326,
    "dropsitcph": 9727525326,
    "dropfax": 9727524411
  },
  {
    "dcode": "D",
    "dropkey": "PW22984",
    "droptype": "D",
    "dropname": "BLUEGROVE",
    "dropdeladd": "1720 FM 172",
    "dropdelcty": "BLUEGROVE",
    "dropdelst": "TX",
    "dropdelzpp": 763529998,
    "dropphyadd": "1720 FM 172",
    "dropphycty": "BLUEGROVE",
    "dropphyst": "TX",
    "dropphyzpp": 763529998,
    "dropmaladd": "1720 FM 172",
    "dropmalcty": "BLUEGROVE",
    "dropmalst": "TX",
    "dropmalzpp": 763529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408953397,
    "dropsitcph": 9408953397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22986",
    "droptype": "D",
    "dropname": "BLUFF DALE",
    "dropdeladd": "28283 US HIGHWAY 377 N",
    "dropdelcty": "BLUFF DALE",
    "dropdelst": "TX",
    "dropdelzpp": 764339998,
    "dropphyadd": "28283 US HIGHWAY 377 N",
    "dropphycty": "BLUFF DALE",
    "dropphyst": "TX",
    "dropphyzpp": 764339998,
    "dropmaladd": "28283 US HIGHWAY 377 N",
    "dropmalcty": "BLUFF DALE",
    "dropmalst": "TX",
    "dropmalzpp": 764339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547283294,
    "dropsitcph": 2547283294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22988",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "11725 RANCH ROAD 2241",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "TX",
    "dropdelzpp": 786079998,
    "dropphyadd": "11725 RANCH ROAD 2241",
    "dropphycty": "BLUFFTON",
    "dropphyst": "TX",
    "dropphyzpp": 786079998,
    "dropmaladd": "11725 RANCH ROAD 2241",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "TX",
    "dropmalzpp": 786079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3253799876,
    "dropsitcph": 3253799876,
    "dropfax": 3253792008
  },
  {
    "dcode": "D",
    "dropkey": "PW22989",
    "droptype": "D",
    "dropname": "BLUM",
    "dropdeladd": "108 W 4TH ST",
    "dropdelcty": "BLUM",
    "dropdelst": "TX",
    "dropdelzpp": 766279998,
    "dropphyadd": "108 W 4TH ST",
    "dropphycty": "BLUM",
    "dropphyst": "TX",
    "dropphyzpp": 766279998,
    "dropmaladd": "108 W 4TH ST",
    "dropmalcty": "BLUM",
    "dropmalst": "TX",
    "dropmalzpp": 766279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548745366,
    "dropsitcph": 2548745366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW22996",
    "droptype": "D",
    "dropname": "BOERNE",
    "dropdeladd": "607 E BLANCO RD",
    "dropdelcty": "BOERNE",
    "dropdelst": "TX",
    "dropdelzpp": 780062011,
    "dropphyadd": "607 E BLANCO RD",
    "dropphycty": "BOERNE",
    "dropphyst": "TX",
    "dropphyzpp": 780069998,
    "dropmaladd": "607 E BLANCO RD",
    "dropmalcty": "BOERNE",
    "dropmalst": "TX",
    "dropmalzpp": 780069998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688384,
    "dropsitcph": 8302492414,
    "dropfax": 8302492906
  },
  {
    "dcode": "D",
    "dropkey": "PW22997",
    "droptype": "D",
    "dropname": "BOGATA",
    "dropdeladd": "141 N MAIN ST",
    "dropdelcty": "BOGATA",
    "dropdelst": "TX",
    "dropdelzpp": 754179998,
    "dropphyadd": "141 N MAIN ST",
    "dropphycty": "BOGATA",
    "dropphyst": "TX",
    "dropphyzpp": 754179998,
    "dropmaladd": "141 N MAIN ST",
    "dropmalcty": "BOGATA",
    "dropmalst": "TX",
    "dropmalzpp": 754179998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036324121,
    "dropsitcph": 9036324121,
    "dropfax": 9036324121
  },
  {
    "dcode": "D",
    "dropkey": "PW22998",
    "droptype": "D",
    "dropname": "BOLING",
    "dropdeladd": "7031 FM 442 RD",
    "dropdelcty": "BOLING",
    "dropdelst": "TX",
    "dropdelzpp": 774208716,
    "dropphyadd": "7031 FM 442 RD",
    "dropphycty": "BOLING",
    "dropphyst": "TX",
    "dropphyzpp": 774208716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOLING",
    "dropmalst": "TX",
    "dropmalzpp": 774209998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796572442,
    "dropsitcph": 9796572442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23001",
    "droptype": "D",
    "dropname": "BON WIER",
    "dropdeladd": "10735 US HIGHWAY 190 E",
    "dropdelcty": "BON WIER",
    "dropdelst": "TX",
    "dropdelzpp": 759289998,
    "dropphyadd": "10735 US HIGHWAY 190 E",
    "dropphycty": "BON WIER",
    "dropphyst": "TX",
    "dropphyzpp": 759289998,
    "dropmaladd": "10735 US HIGHWAY 190 E",
    "dropmalcty": "BON WIER",
    "dropmalst": "TX",
    "dropmalzpp": 759289998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092077002,
    "dropsitcph": 4092077077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23003",
    "droptype": "D",
    "dropname": "BONHAM",
    "dropdeladd": "300 N CENTER ST",
    "dropdelcty": "BONHAM",
    "dropdelst": "TX",
    "dropdelzpp": 754189998,
    "dropphyadd": "300 N CENTER ST",
    "dropphycty": "BONHAM",
    "dropphyst": "TX",
    "dropphyzpp": 754189998,
    "dropmaladd": "300 N CENTER ST",
    "dropmalcty": "BONHAM",
    "dropmalst": "TX",
    "dropmalzpp": 754189998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035834815,
    "dropsitcph": 9035834815,
    "dropfax": 9035831238
  },
  {
    "dcode": "D",
    "dropkey": "PW23007",
    "droptype": "D",
    "dropname": "BOOKER",
    "dropdeladd": "122 S AUSTIN ST",
    "dropdelcty": "BOOKER",
    "dropdelst": "TX",
    "dropdelzpp": 790059803,
    "dropphyadd": "122 S AUSTIN ST",
    "dropphycty": "BOOKER",
    "dropphyst": "TX",
    "dropphyzpp": 790059803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOOKER",
    "dropmalst": "TX",
    "dropmalzpp": 790059998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066582211,
    "dropsitcph": 8066582211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23011",
    "droptype": "D",
    "dropname": "BORGER",
    "dropdeladd": "500 S MCGEE ST",
    "dropdelcty": "BORGER",
    "dropdelst": "TX",
    "dropdelzpp": 790079998,
    "dropphyadd": "500 S MCGEE ST",
    "dropphycty": "BORGER",
    "dropphyst": "TX",
    "dropphyzpp": 790079998,
    "dropmaladd": "500 S MCGEE ST",
    "dropmalcty": "BORGER",
    "dropmalst": "TX",
    "dropmalzpp": 790079998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062733761,
    "dropsitcph": 8062733761,
    "dropfax": 8062742307
  },
  {
    "dcode": "D",
    "dropkey": "PW23014",
    "droptype": "D",
    "dropname": "BOVINA",
    "dropdeladd": "108 2ND ST",
    "dropdelcty": "BOVINA",
    "dropdelst": "TX",
    "dropdelzpp": 790099802,
    "dropphyadd": "108 2ND ST",
    "dropphycty": "BOVINA",
    "dropphyst": "TX",
    "dropphyzpp": 790099802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOVINA",
    "dropmalst": "TX",
    "dropmalzpp": 790099998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062511351,
    "dropsitcph": 8062511351,
    "dropfax": 8062511804
  },
  {
    "dcode": "D",
    "dropkey": "PW23015",
    "droptype": "D",
    "dropname": "BOWIE",
    "dropdeladd": "113 N MASON ST",
    "dropdelcty": "BOWIE",
    "dropdelst": "TX",
    "dropdelzpp": 762309998,
    "dropphyadd": "113 N MASON ST",
    "dropphycty": "BOWIE",
    "dropphyst": "TX",
    "dropphyzpp": 762309998,
    "dropmaladd": "113 N MASON ST",
    "dropmalcty": "BOWIE",
    "dropmalst": "TX",
    "dropmalzpp": 762309998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408721170,
    "dropsitcph": 9408721170,
    "dropfax": 8178726810
  },
  {
    "dcode": "D",
    "dropkey": "PW23017",
    "droptype": "D",
    "dropname": "BOYD",
    "dropdeladd": "121 N FM 730",
    "dropdelcty": "BOYD",
    "dropdelst": "TX",
    "dropdelzpp": 760239998,
    "dropphyadd": "121 N FM 730",
    "dropphycty": "BOYD",
    "dropphyst": "TX",
    "dropphyzpp": 760239998,
    "dropmaladd": "121 N FM 730",
    "dropmalcty": "BOYD",
    "dropmalst": "TX",
    "dropmalzpp": 760239998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404335325,
    "dropsitcph": 9404335325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23021",
    "droptype": "D",
    "dropname": "BRACKETTVILLE",
    "dropdeladd": "308 E SPRING ST",
    "dropdelcty": "BRACKETTVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 788329998,
    "dropphyadd": "308 E SPRING ST",
    "dropphycty": "BRACKETTVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 788329998,
    "dropmaladd": "308 E SPRING ST",
    "dropmalcty": "BRACKETTVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 788329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305632418,
    "dropsitcph": 8305632418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23024",
    "droptype": "D",
    "dropname": "BRADY",
    "dropdeladd": "229 S BLACKBURN ST",
    "dropdelcty": "BRADY",
    "dropdelst": "TX",
    "dropdelzpp": 768259998,
    "dropphyadd": "229 S BLACKBURN ST",
    "dropphycty": "BRADY",
    "dropphyst": "TX",
    "dropphyzpp": 768259998,
    "dropmaladd": "229 S BLACKBURN ST",
    "dropmalcty": "BRADY",
    "dropmalst": "TX",
    "dropmalzpp": 768259998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3255972298,
    "dropfax": 3255972176
  },
  {
    "dcode": "D",
    "dropkey": "PW23026",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "1601 FM 1243",
    "dropdelcty": "BRANDON",
    "dropdelst": "TX",
    "dropdelzpp": 766289800,
    "dropphyadd": "1601 FM 1243",
    "dropphycty": "BRANDON",
    "dropphyst": "TX",
    "dropphyzpp": 766289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANDON",
    "dropmalst": "TX",
    "dropmalzpp": 766289998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546324291,
    "dropsitcph": 2546324291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23027",
    "droptype": "D",
    "dropname": "BRASHEAR",
    "dropdeladd": "276 FARM ROAD 2653",
    "dropdelcty": "BRASHEAR",
    "dropdelst": "TX",
    "dropdelzpp": 754209998,
    "dropphyadd": "276 FARM ROAD 2653",
    "dropphycty": "BRASHEAR",
    "dropphyst": "TX",
    "dropphyzpp": 754209998,
    "dropmaladd": "276 FARM ROAD 2653",
    "dropmalcty": "BRASHEAR",
    "dropmalst": "TX",
    "dropmalzpp": 754209998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035825068,
    "dropsitcph": 9035825068,
    "dropfax": 9035820009
  },
  {
    "dcode": "D",
    "dropkey": "PW23028",
    "droptype": "D",
    "dropname": "BRAZORIA",
    "dropdeladd": "111 GAINES ST",
    "dropdelcty": "BRAZORIA",
    "dropdelst": "TX",
    "dropdelzpp": 774222119,
    "dropphyadd": "111 GAINES ST",
    "dropphycty": "BRAZORIA",
    "dropphyst": "TX",
    "dropphyzpp": 774222119,
    "dropmaladd": "111 GAINES ST",
    "dropmalcty": "BRAZORIA",
    "dropmalst": "TX",
    "dropmalzpp": 774222119,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797987676,
    "dropsitcph": 9797987676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23030",
    "droptype": "D",
    "dropname": "BRECKENRIDGE",
    "dropdeladd": "123 W WILLIAMS ST",
    "dropdelcty": "BRECKENRIDGE",
    "dropdelst": "TX",
    "dropdelzpp": 764249998,
    "dropphyadd": "123 W WILLIAMS ST",
    "dropphycty": "BRECKENRIDGE",
    "dropphyst": "TX",
    "dropphyzpp": 764249998,
    "dropmaladd": "123 W WILLIAMS ST",
    "dropmalcty": "BRECKENRIDGE",
    "dropmalst": "TX",
    "dropmalzpp": 764249998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2545592877,
    "dropsitcph": 2545592877,
    "dropfax": 2022680426
  },
  {
    "dcode": "D",
    "dropkey": "PW23031",
    "droptype": "D",
    "dropname": "BREMOND",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "BREMOND",
    "dropdelst": "TX",
    "dropdelzpp": 766299998,
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "BREMOND",
    "dropphyst": "TX",
    "dropphyzpp": 766299998,
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "BREMOND",
    "dropmalst": "TX",
    "dropmalzpp": 766299998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547467116,
    "dropsitcph": 2547467116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23032",
    "droptype": "D",
    "dropname": "BRENHAM",
    "dropdeladd": "309 N MARKET ST",
    "dropdelcty": "BRENHAM",
    "dropdelst": "TX",
    "dropdelzpp": 778339998,
    "dropphyadd": "309 N MARKET ST",
    "dropphycty": "BRENHAM",
    "dropphyst": "TX",
    "dropphyzpp": 778339998,
    "dropmaladd": "309 N MARKET ST",
    "dropmalcty": "BRENHAM",
    "dropmalst": "TX",
    "dropmalzpp": 778339998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798362652,
    "dropsitcph": 9798362652,
    "dropfax": 9798361034
  },
  {
    "dcode": "D",
    "dropkey": "PW23036",
    "droptype": "D",
    "dropname": "BRIDGE CITY",
    "dropdeladd": "900 TEXAS AVE",
    "dropdelcty": "BRIDGE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 776119998,
    "dropphyadd": "900 TEXAS AVE",
    "dropphycty": "BRIDGE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 776119998,
    "dropmaladd": "900 TEXAS AVE",
    "dropmalcty": "BRIDGE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 776119998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4096971881,
    "dropsitcph": 4096971883,
    "dropfax": 4097354854
  },
  {
    "dcode": "D",
    "dropkey": "PW23037",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "1305 HALSELL ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "TX",
    "dropdelzpp": 764269998,
    "dropphyadd": "1305 HALSELL ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "TX",
    "dropphyzpp": 764269998,
    "dropmaladd": "1305 HALSELL ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "TX",
    "dropmalzpp": 764269998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406832787,
    "dropsitcph": 9406832787,
    "dropfax": 9406835503
  },
  {
    "dcode": "D",
    "dropkey": "PW23038",
    "droptype": "D",
    "dropname": "BRIGGS",
    "dropdeladd": "140 LOOP 308",
    "dropdelcty": "BRIGGS",
    "dropdelst": "TX",
    "dropdelzpp": 786089998,
    "dropphyadd": "140 LOOP 308",
    "dropphycty": "BRIGGS",
    "dropphyst": "TX",
    "dropphyzpp": 786089998,
    "dropmaladd": "140 LOOP 308",
    "dropmalcty": "BRIGGS",
    "dropmalst": "TX",
    "dropmalzpp": 786089998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124892211,
    "dropsitcph": 5124892211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23040",
    "droptype": "D",
    "dropname": "BRISCOE",
    "dropdeladd": "15715 FM 1046",
    "dropdelcty": "BRISCOE",
    "dropdelst": "TX",
    "dropdelzpp": 790119802,
    "dropphyadd": "15715 FM 1046",
    "dropphycty": "BRISCOE",
    "dropphyst": "TX",
    "dropphyzpp": 790119802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRISCOE",
    "dropmalst": "TX",
    "dropmalzpp": 790119998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063752212,
    "dropsitcph": 8063752212,
    "dropfax": 8063752307
  },
  {
    "dcode": "D",
    "dropkey": "PW23041",
    "droptype": "D",
    "dropname": "BROADDUS",
    "dropdeladd": "506 STATE HIGHWAY 147",
    "dropdelcty": "BROADDUS",
    "dropdelst": "TX",
    "dropdelzpp": 759299998,
    "dropphyadd": "506 STATE HIGHWAY 147",
    "dropphycty": "BROADDUS",
    "dropphyst": "TX",
    "dropphyzpp": 759299998,
    "dropmaladd": "506 STATE HIGHWAY 147",
    "dropmalcty": "BROADDUS",
    "dropmalst": "TX",
    "dropmalzpp": 759299998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368723677,
    "dropsitcph": 9368723677,
    "dropfax": 9368723677
  },
  {
    "dcode": "D",
    "dropkey": "PW23043",
    "droptype": "D",
    "dropname": "BRONSON",
    "dropdeladd": "10850 US HIGHWAY 96 N",
    "dropdelcty": "BRONSON",
    "dropdelst": "TX",
    "dropdelzpp": 759309998,
    "dropphyadd": "10850 US HIGHWAY 96 N",
    "dropphycty": "BRONSON",
    "dropphyst": "TX",
    "dropphyzpp": 759309998,
    "dropmaladd": "10850 US HIGHWAY 96 N",
    "dropmalcty": "BRONSON",
    "dropmalst": "TX",
    "dropmalzpp": 759309998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4095863101,
    "dropsitcph": 4095863101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23044",
    "droptype": "D",
    "dropname": "BRONTE",
    "dropdeladd": "124 S WASHINGTON",
    "dropdelcty": "BRONTE",
    "dropdelst": "TX",
    "dropdelzpp": 769332152,
    "dropphyadd": "124 S WASHINGTON",
    "dropphycty": "BRONTE",
    "dropphyst": "TX",
    "dropphyzpp": 769332152,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRONTE",
    "dropmalst": "TX",
    "dropmalzpp": 769339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254735881,
    "dropsitcph": 3254735881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23045",
    "droptype": "D",
    "dropname": "BROOKELAND",
    "dropdeladd": "15674 US HIGHWAY 96 N",
    "dropdelcty": "BROOKELAND",
    "dropdelst": "TX",
    "dropdelzpp": 759319998,
    "dropphyadd": "15674 US HIGHWAY 96 N",
    "dropphycty": "BROOKELAND",
    "dropphyst": "TX",
    "dropphyzpp": 759319998,
    "dropmaladd": "15674 US HIGHWAY 96 N",
    "dropmalcty": "BROOKELAND",
    "dropmalst": "TX",
    "dropmalzpp": 759319998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4096982536,
    "dropsitcph": 4096982536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23046",
    "droptype": "D",
    "dropname": "BROOKESMITH",
    "dropdeladd": "13375 FM 586 S",
    "dropdelcty": "BROOKESMITH",
    "dropdelst": "TX",
    "dropdelzpp": 768279998,
    "dropphyadd": "13375 FM 586 S",
    "dropphycty": "BROOKESMITH",
    "dropphyst": "TX",
    "dropphyzpp": 768279998,
    "dropmaladd": "13375 FM 586 S",
    "dropmalcty": "BROOKESMITH",
    "dropmalst": "TX",
    "dropmalzpp": 768279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256434914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23050",
    "droptype": "D",
    "dropname": "BROOKSHIRE",
    "dropdeladd": "4115 5TH ST",
    "dropdelcty": "BROOKSHIRE",
    "dropdelst": "TX",
    "dropdelzpp": 774231586,
    "dropphyadd": "4115 5TH ST",
    "dropphycty": "BROOKSHIRE",
    "dropphyst": "TX",
    "dropphyzpp": 774231586,
    "dropmaladd": "4115 5TH ST",
    "dropmalcty": "BROOKSHIRE",
    "dropmalst": "TX",
    "dropmalzpp": 774231586,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813752266,
    "dropsitcph": 2813752266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23052",
    "droptype": "D",
    "dropname": "BROOKSTON",
    "dropdeladd": "100 N 1ST ST",
    "dropdelcty": "BROOKSTON",
    "dropdelst": "TX",
    "dropdelzpp": 754219998,
    "dropphyadd": "100 N 1ST ST",
    "dropphycty": "BROOKSTON",
    "dropphyst": "TX",
    "dropphyzpp": 754219998,
    "dropmaladd": "100 N 1ST ST",
    "dropmalcty": "BROOKSTON",
    "dropmalst": "TX",
    "dropmalzpp": 754219998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037852638,
    "dropsitcph": 9037852638,
    "dropfax": 9037855371
  },
  {
    "dcode": "D",
    "dropkey": "PW23054",
    "droptype": "D",
    "dropname": "BROWNFIELD",
    "dropdeladd": "301 W HILL ST",
    "dropdelcty": "BROWNFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 793163300,
    "dropphyadd": "301 W HILL ST",
    "dropphycty": "BROWNFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 793163300,
    "dropmaladd": "301 W HILL ST",
    "dropmalcty": "BROWNFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 793163300,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066373412,
    "dropsitcph": 8066373412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23055",
    "droptype": "D",
    "dropname": "BROWNSBORO",
    "dropdeladd": "14201 STATE HIGHWAY 31 E",
    "dropdelcty": "BROWNSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 757569998,
    "dropphyadd": "14201 STATE HIGHWAY 31 E",
    "dropphycty": "BROWNSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 757569998,
    "dropmaladd": "14201 STATE HIGHWAY 31 E",
    "dropmalcty": "BROWNSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 757569998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038523821,
    "dropsitcph": 9038523821,
    "dropfax": 9038523821
  },
  {
    "dcode": "D",
    "dropkey": "PW23057",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "1535 E LOS EBANOS BLVD",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 785209998,
    "dropphyadd": "1535 E LOS EBANOS BLVD",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 785209998,
    "dropmaladd": "1535 E LOS EBANOS BLVD",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 785209998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565462411,
    "dropsitcph": 9565462411,
    "dropfax": 9565464390
  },
  {
    "dcode": "D",
    "dropkey": "PW23059",
    "droptype": "D",
    "dropname": "BROWNWOOD",
    "dropdeladd": "600 CENTER AVE",
    "dropdelcty": "BROWNWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 768012800,
    "dropphyadd": "600 CENTER AVE",
    "dropphycty": "BROWNWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 768012800,
    "dropmaladd": "600 CENTER AVE",
    "dropmalcty": "BROWNWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 768012800,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256460656,
    "dropsitcph": 3256460656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23060",
    "droptype": "D",
    "dropname": "BRUCEVILLE",
    "dropdeladd": "201 FIRST ST",
    "dropdelcty": "BRUCEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 766309998,
    "dropphyadd": "201 FIRST ST",
    "dropphycty": "BRUCEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 766309998,
    "dropmaladd": "201 FIRST ST",
    "dropmalcty": "BRUCEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 766309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548595667,
    "dropsitcph": 2548595667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23067",
    "droptype": "D",
    "dropname": "BRUNI",
    "dropdeladd": "204 E 3RD ST",
    "dropdelcty": "BRUNI",
    "dropdelst": "TX",
    "dropdelzpp": 783449998,
    "dropphyadd": "204 E 3RD ST",
    "dropphycty": "BRUNI",
    "dropphyst": "TX",
    "dropphyzpp": 783449998,
    "dropmaladd": "204 E 3RD ST",
    "dropmalcty": "BRUNI",
    "dropmalst": "TX",
    "dropmalzpp": 783449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617475495,
    "dropsitcph": 3617475495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23070",
    "droptype": "D",
    "dropname": "BRYAN",
    "dropdeladd": "2121 E WM J BRYAN PKWY",
    "dropdelcty": "BRYAN",
    "dropdelst": "TX",
    "dropdelzpp": 778019998,
    "dropphyadd": "2121 E WM J BRYAN PKWY",
    "dropphycty": "BRYAN",
    "dropphyst": "TX",
    "dropphyzpp": 778019998,
    "dropmaladd": "2121 E WM J BRYAN PKWY",
    "dropmalcty": "BRYAN",
    "dropmalst": "TX",
    "dropmalzpp": 778019998,
    "dropsitphn": 9797747068,
    "dropsitlph": 9797747068,
    "dropsitcph": 9797747068,
    "dropfax": 9797747360
  },
  {
    "dcode": "D",
    "dropkey": "PW23073",
    "droptype": "D",
    "dropname": "BRYSON",
    "dropdeladd": "103 N DEPOT ST",
    "dropdelcty": "BRYSON",
    "dropdelst": "TX",
    "dropdelzpp": 764279998,
    "dropphyadd": "103 N DEPOT ST",
    "dropphycty": "BRYSON",
    "dropphyst": "TX",
    "dropphyzpp": 764279998,
    "dropmaladd": "103 N DEPOT ST",
    "dropmalcty": "BRYSON",
    "dropmalst": "TX",
    "dropmalzpp": 764279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403924851,
    "dropsitcph": 9403924851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23074",
    "droptype": "D",
    "dropname": "BUCHANAN DAM",
    "dropdeladd": "17727 E STATE HIGHWAY 29",
    "dropdelcty": "BUCHANAN DAM",
    "dropdelst": "TX",
    "dropdelzpp": 786099998,
    "dropphyadd": "17727 E STATE HIGHWAY 29",
    "dropphycty": "BUCHANAN DAM",
    "dropphyst": "TX",
    "dropphyzpp": 786099998,
    "dropmaladd": "17727 E STATE HIGHWAY 29",
    "dropmalcty": "BUCHANAN DAM",
    "dropmalst": "TX",
    "dropmalzpp": 786099998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5127932513,
    "dropsitcph": 5127932513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23076",
    "droptype": "D",
    "dropname": "BUCKHOLTS",
    "dropdeladd": "300 E HIGHWAY 190",
    "dropdelcty": "BUCKHOLTS",
    "dropdelst": "TX",
    "dropdelzpp": 765189998,
    "dropphyadd": "300 E HIGHWAY 190",
    "dropphycty": "BUCKHOLTS",
    "dropphyst": "TX",
    "dropphyzpp": 765189998,
    "dropmaladd": "300 E HIGHWAY 190",
    "dropmalcty": "BUCKHOLTS",
    "dropmalst": "TX",
    "dropmalzpp": 765189998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545932872,
    "dropsitcph": 2545932872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23079",
    "droptype": "D",
    "dropname": "BUDA",
    "dropdeladd": "1320 CABELAS DR",
    "dropdelcty": "BUDA",
    "dropdelst": "TX",
    "dropdelzpp": 786109998,
    "dropphyadd": "1320 CABELAS DR",
    "dropphycty": "BUDA",
    "dropphyst": "TX",
    "dropphyzpp": 786109998,
    "dropmaladd": "1320 CABELAS DR",
    "dropmalcty": "BUDA",
    "dropmalst": "TX",
    "dropmalzpp": 786109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123121893,
    "dropsitcph": 5122954241,
    "dropfax": 5122952895
  },
  {
    "dcode": "D",
    "dropkey": "PW23080",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "208 CENTER ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "TX",
    "dropdelzpp": 758319998,
    "dropphyadd": "208 CENTER ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "TX",
    "dropphyzpp": 758319998,
    "dropmaladd": "208 CENTER ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "TX",
    "dropmalzpp": 758319998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033224763,
    "dropsitcph": 9033224763,
    "dropfax": 9033223099
  },
  {
    "dcode": "D",
    "dropkey": "PW23081",
    "droptype": "D",
    "dropname": "BUFFALO GAP",
    "dropdeladd": "1218 LITEL ST",
    "dropdelcty": "BUFFALO GAP",
    "dropdelst": "TX",
    "dropdelzpp": 795089998,
    "dropphyadd": "1218 LITEL ST",
    "dropphycty": "BUFFALO GAP",
    "dropphyst": "TX",
    "dropphyzpp": 795089998,
    "dropmaladd": "1218 LITEL ST",
    "dropmalcty": "BUFFALO GAP",
    "dropmalst": "TX",
    "dropmalzpp": 795089998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255723589,
    "dropsitcph": 3255723589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23084",
    "droptype": "D",
    "dropname": "BULLARD",
    "dropdeladd": "409 E MAIN ST",
    "dropdelcty": "BULLARD",
    "dropdelst": "TX",
    "dropdelzpp": 757579997,
    "dropphyadd": "409 E MAIN ST",
    "dropphycty": "BULLARD",
    "dropphyst": "TX",
    "dropphyzpp": 757579997,
    "dropmaladd": "409 E MAIN ST",
    "dropmalcty": "BULLARD",
    "dropmalst": "TX",
    "dropmalzpp": 757579997,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038947211,
    "dropsitcph": 9038947211,
    "dropfax": 9038943801
  },
  {
    "dcode": "D",
    "dropkey": "PW23086",
    "droptype": "D",
    "dropname": "BUNA",
    "dropdeladd": "332 TX STATE HIGHWAY 62",
    "dropdelcty": "BUNA",
    "dropdelst": "TX",
    "dropdelzpp": 776120047,
    "dropphyadd": "332 TX STATE HIGHWAY 62",
    "dropphycty": "BUNA",
    "dropphyst": "TX",
    "dropphyzpp": 776120047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUNA",
    "dropmalst": "TX",
    "dropmalzpp": 776129998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099943731,
    "dropsitcph": 4099943731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23088",
    "droptype": "D",
    "dropname": "BURKBURNETT",
    "dropdeladd": "501 COUNTY RD",
    "dropdelcty": "BURKBURNETT",
    "dropdelst": "TX",
    "dropdelzpp": 763542673,
    "dropphyadd": "501 COUNTY RD",
    "dropphycty": "BURKBURNETT",
    "dropphyst": "TX",
    "dropphyzpp": 763542673,
    "dropmaladd": "501 COUNTY RD",
    "dropmalcty": "BURKBURNETT",
    "dropmalst": "TX",
    "dropmalzpp": 763542673,
    "dropsitphn": 8173713658,
    "dropsitlph": 9405692791,
    "dropsitcph": 9405692791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23089",
    "droptype": "D",
    "dropname": "BURKETT",
    "dropdeladd": "357 BAYOU ST",
    "dropdelcty": "BURKETT",
    "dropdelst": "TX",
    "dropdelzpp": 768289998,
    "dropphyadd": "357 BAYOU ST",
    "dropphycty": "BURKETT",
    "dropphyst": "TX",
    "dropphyzpp": 768289998,
    "dropmaladd": "357 BAYOU ST",
    "dropmalcty": "BURKETT",
    "dropmalst": "TX",
    "dropmalzpp": 768289998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256245268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23090",
    "droptype": "D",
    "dropname": "BURKEVILLE",
    "dropdeladd": "147 STATE HIGHWAY 63 E",
    "dropdelcty": "BURKEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 759329998,
    "dropphyadd": "147 STATE HIGHWAY 63 E",
    "dropphycty": "BURKEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 759329998,
    "dropmaladd": "147 STATE HIGHWAY 63 E",
    "dropmalcty": "BURKEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 759329998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092150227,
    "dropsitcph": 4092150227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23092",
    "droptype": "D",
    "dropname": "BURLESON",
    "dropdeladd": "232 SW JOHNSON AVE",
    "dropdelcty": "BURLESON",
    "dropdelst": "TX",
    "dropdelzpp": 760289998,
    "dropphyadd": "232 SW JOHNSON AVE",
    "dropphycty": "BURLESON",
    "dropphyst": "TX",
    "dropphyzpp": 760289998,
    "dropmaladd": "232 SW JOHNSON AVE",
    "dropmalcty": "BURLESON",
    "dropmalst": "TX",
    "dropmalzpp": 760289998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172951211,
    "dropsitcph": 8172950289,
    "dropfax": 8172952146
  },
  {
    "dcode": "D",
    "dropkey": "PW23094",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "14 CHURCH AVE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 765199998,
    "dropphyadd": "14 CHURCH AVE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 765199998,
    "dropmaladd": "14 CHURCH AVE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 765199998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548692891,
    "dropsitcph": 2548692891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23096",
    "droptype": "D",
    "dropname": "BURNET",
    "dropdeladd": "508 E JACKSON ST",
    "dropdelcty": "BURNET",
    "dropdelst": "TX",
    "dropdelzpp": 786119998,
    "dropphyadd": "508 E JACKSON ST",
    "dropphycty": "BURNET",
    "dropphyst": "TX",
    "dropphyzpp": 786119998,
    "dropmaladd": "508 E JACKSON ST",
    "dropmalcty": "BURNET",
    "dropmalst": "TX",
    "dropmalzpp": 786119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5127562773,
    "dropsitcph": 5127564241,
    "dropfax": 5127569466
  },
  {
    "dcode": "D",
    "dropkey": "PW23099",
    "droptype": "D",
    "dropname": "BURTON",
    "dropdeladd": "500 N RAILROAD ST",
    "dropdelcty": "BURTON",
    "dropdelst": "TX",
    "dropdelzpp": 778359202,
    "dropphyadd": "500 N RAILROAD ST",
    "dropphycty": "BURTON",
    "dropphyst": "TX",
    "dropphyzpp": 778359202,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURTON",
    "dropmalst": "TX",
    "dropmalzpp": 778359998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792894661,
    "dropsitcph": 9792894661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23100",
    "droptype": "D",
    "dropname": "BUSHLAND",
    "dropdeladd": "300 SIMMONS RD",
    "dropdelcty": "BUSHLAND",
    "dropdelst": "TX",
    "dropdelzpp": 790129800,
    "dropphyadd": "300 SIMMONS RD",
    "dropphycty": "BUSHLAND",
    "dropphyst": "TX",
    "dropphyzpp": 790129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUSHLAND",
    "dropmalst": "TX",
    "dropmalzpp": 790129998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063594201,
    "dropsitcph": 8063594201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23105",
    "droptype": "D",
    "dropname": "BYERS",
    "dropdeladd": "206 CENTRAL AVE",
    "dropdelcty": "BYERS",
    "dropdelst": "TX",
    "dropdelzpp": 763579998,
    "dropphyadd": "206 CENTRAL AVE",
    "dropphycty": "BYERS",
    "dropphyst": "TX",
    "dropphyzpp": 763579998,
    "dropmaladd": "206 CENTRAL AVE",
    "dropmalcty": "BYERS",
    "dropmalst": "TX",
    "dropmalzpp": 763579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9402153097,
    "dropsitcph": 9402153097,
    "dropfax": 9405296588
  },
  {
    "dcode": "D",
    "dropkey": "PW23106",
    "droptype": "D",
    "dropname": "BYNUM",
    "dropdeladd": "200 WHITE AVE",
    "dropdelcty": "BYNUM",
    "dropdelst": "TX",
    "dropdelzpp": 766319998,
    "dropphyadd": "200 WHITE AVE",
    "dropphycty": "BYNUM",
    "dropphyst": "TX",
    "dropphyzpp": 766319998,
    "dropmaladd": "200 WHITE AVE",
    "dropmalcty": "BYNUM",
    "dropmalst": "TX",
    "dropmalzpp": 766319998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546234376,
    "dropsitcph": 2546234376,
    "dropfax": 2546234376
  },
  {
    "dcode": "D",
    "dropkey": "PW23108",
    "droptype": "D",
    "dropname": "CACTUS",
    "dropdeladd": "103 NORTH DR",
    "dropdelcty": "CACTUS",
    "dropdelst": "TX",
    "dropdelzpp": 790139800,
    "dropphyadd": "103 NORTH DR",
    "dropphycty": "CACTUS",
    "dropphyst": "TX",
    "dropphyzpp": 790139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CACTUS",
    "dropmalst": "TX",
    "dropmalzpp": 790139998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069665455,
    "dropsitcph": 8069665455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23109",
    "droptype": "D",
    "dropname": "CADDO",
    "dropdeladd": "14075 LOOP 252",
    "dropdelcty": "CADDO",
    "dropdelst": "TX",
    "dropdelzpp": 764299998,
    "dropphyadd": "14075 LOOP 252",
    "dropphycty": "CADDO",
    "dropphyst": "TX",
    "dropphyzpp": 764299998,
    "dropmaladd": "14075 LOOP 252",
    "dropmalcty": "CADDO",
    "dropmalst": "TX",
    "dropmalzpp": 764299998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2545592974,
    "dropsitcph": 2545592974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23110",
    "droptype": "D",
    "dropname": "CADDO MILLS",
    "dropdeladd": "2109 STATE HIGHWAY 66",
    "dropdelcty": "CADDO MILLS",
    "dropdelst": "TX",
    "dropdelzpp": 751359998,
    "dropphyadd": "2109 STATE HIGHWAY 66",
    "dropphycty": "CADDO MILLS",
    "dropphyst": "TX",
    "dropphyzpp": 751359998,
    "dropmaladd": "2109 STATE HIGHWAY 66",
    "dropmalcty": "CADDO MILLS",
    "dropmalst": "TX",
    "dropmalzpp": 751359998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9035273295,
    "dropsitcph": 9035273295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23111",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "CALDWELL",
    "dropdelst": "TX",
    "dropdelzpp": 778369998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "CALDWELL",
    "dropphyst": "TX",
    "dropphyzpp": 778369998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "CALDWELL",
    "dropmalst": "TX",
    "dropmalzpp": 778369998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795674396,
    "dropsitcph": 9795674396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23114",
    "droptype": "D",
    "dropname": "CALL",
    "dropdeladd": "676 FM 1013 S",
    "dropdelcty": "CALL",
    "dropdelst": "TX",
    "dropdelzpp": 759339998,
    "dropphyadd": "676 FM 1013 S",
    "dropphycty": "CALL",
    "dropphyst": "TX",
    "dropphyzpp": 759339998,
    "dropmaladd": "676 FM 1013 S",
    "dropmalcty": "CALL",
    "dropmalst": "TX",
    "dropmalzpp": 759339998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4094232231,
    "dropsitcph": 4094232231,
    "dropfax": 4094235812
  },
  {
    "dcode": "D",
    "dropkey": "PW23115",
    "droptype": "D",
    "dropname": "CALLIHAM",
    "dropdeladd": "193 RECREATION ROAD 8",
    "dropdelcty": "CALLIHAM",
    "dropdelst": "TX",
    "dropdelzpp": 780079998,
    "dropphyadd": "193 RECREATION ROAD 8",
    "dropphycty": "CALLIHAM",
    "dropphyst": "TX",
    "dropphyzpp": 780079998,
    "dropmaladd": "193 RECREATION ROAD 8",
    "dropmalcty": "CALLIHAM",
    "dropmalst": "TX",
    "dropmalzpp": 780079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617864569,
    "dropsitcph": 3617864569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23116",
    "droptype": "D",
    "dropname": "CALVERT",
    "dropdeladd": "602 S CEDAR RD",
    "dropdelcty": "CALVERT",
    "dropdelst": "TX",
    "dropdelzpp": 778379800,
    "dropphyadd": "602 S CEDAR RD",
    "dropphycty": "CALVERT",
    "dropphyst": "TX",
    "dropphyzpp": 778379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALVERT",
    "dropmalst": "TX",
    "dropmalzpp": 778379998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9793642131,
    "dropsitcph": 9793642131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23118",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "242 POST OFFICE RD",
    "dropdelcty": "CAMDEN",
    "dropdelst": "TX",
    "dropdelzpp": 759349998,
    "dropphyadd": "242 POST OFFICE RD",
    "dropphycty": "CAMDEN",
    "dropphyst": "TX",
    "dropphyzpp": 759349998,
    "dropmaladd": "242 POST OFFICE RD",
    "dropmalcty": "CAMDEN",
    "dropmalst": "TX",
    "dropmalzpp": 759349998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9363982866,
    "dropsitcph": 9363982866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23119",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "202 W 2ND ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "TX",
    "dropdelzpp": 765209998,
    "dropphyadd": "202 W 2ND ST",
    "dropphycty": "CAMERON",
    "dropphyst": "TX",
    "dropphyzpp": 765209998,
    "dropmaladd": "202 W 2ND ST",
    "dropmalcty": "CAMERON",
    "dropmalst": "TX",
    "dropmalzpp": 765209998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546972662,
    "dropsitcph": 2546972662,
    "dropfax": 2546974177
  },
  {
    "dcode": "D",
    "dropkey": "PW23125",
    "droptype": "D",
    "dropname": "CAMP WOOD",
    "dropdeladd": "309 N NUECES",
    "dropdelcty": "CAMP WOOD",
    "dropdelst": "TX",
    "dropdelzpp": 788339998,
    "dropphyadd": "309 N NUECES",
    "dropphycty": "CAMP WOOD",
    "dropphyst": "TX",
    "dropphyzpp": 788339998,
    "dropmaladd": "309 N NUECES",
    "dropmalcty": "CAMP WOOD",
    "dropmalst": "TX",
    "dropmalzpp": 788339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3252382365,
    "dropsitcph": 3252382405,
    "dropfax": 3252382365
  },
  {
    "dcode": "D",
    "dropkey": "PW23126",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "609 W MAIN ST",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "TX",
    "dropdelzpp": 754229998,
    "dropphyadd": "609 W MAIN ST",
    "dropphycty": "CAMPBELL",
    "dropphyst": "TX",
    "dropphyzpp": 754229998,
    "dropmaladd": "609 W MAIN ST",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "TX",
    "dropmalzpp": 754229998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038623221,
    "dropsitcph": 9038623221,
    "dropfax": 9038622662
  },
  {
    "dcode": "D",
    "dropkey": "PW23127",
    "droptype": "D",
    "dropname": "CAMPBELLTON",
    "dropdeladd": "2905 COMMERCE ST",
    "dropdelcty": "CAMPBELLTON",
    "dropdelst": "TX",
    "dropdelzpp": 780089998,
    "dropphyadd": "2905 COMMERCE ST",
    "dropphycty": "CAMPBELLTON",
    "dropphyst": "TX",
    "dropphyzpp": 780089998,
    "dropmaladd": "2905 COMMERCE ST",
    "dropmalcty": "CAMPBELLTON",
    "dropmalst": "TX",
    "dropmalzpp": 780089998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305794711,
    "dropsitcph": 8305794711,
    "dropfax": 8305798521
  },
  {
    "dcode": "D",
    "dropkey": "PW23130",
    "droptype": "D",
    "dropname": "CANADIAN",
    "dropdeladd": "311 PURCELL AVE",
    "dropdelcty": "CANADIAN",
    "dropdelst": "TX",
    "dropdelzpp": 790149998,
    "dropphyadd": "311 PURCELL AVE",
    "dropphycty": "CANADIAN",
    "dropphyst": "TX",
    "dropphyzpp": 790149998,
    "dropmaladd": "311 PURCELL AVE",
    "dropmalcty": "CANADIAN",
    "dropmalst": "TX",
    "dropmalzpp": 790149998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063236272,
    "dropsitcph": 8063236272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23131",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "1001 W DALLAS ST",
    "dropdelcty": "CANTON",
    "dropdelst": "TX",
    "dropdelzpp": 751039998,
    "dropphyadd": "1001 W DALLAS ST",
    "dropphycty": "CANTON",
    "dropphyst": "TX",
    "dropphyzpp": 751039998,
    "dropmaladd": "1001 W DALLAS ST",
    "dropmalcty": "CANTON",
    "dropmalst": "TX",
    "dropmalzpp": 751039998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9035674126,
    "dropsitcph": 9035672371,
    "dropfax": 9035671853
  },
  {
    "dcode": "D",
    "dropkey": "PW23132",
    "droptype": "D",
    "dropname": "CANUTILLO",
    "dropdeladd": "7050 DONIPHAN DR",
    "dropdelcty": "CANUTILLO",
    "dropdelst": "TX",
    "dropdelzpp": 798355407,
    "dropphyadd": "7050 DONIPHAN DR",
    "dropphycty": "CANUTILLO",
    "dropphyst": "TX",
    "dropphyzpp": 798355407,
    "dropmaladd": "7050 DONIPHAN DR",
    "dropmalcty": "CANUTILLO",
    "dropmalst": "TX",
    "dropmalzpp": 798355407,
    "dropsitphn": 2103688387,
    "dropsitlph": 9158774309,
    "dropsitcph": 9158775455,
    "dropfax": 9158775097
  },
  {
    "dcode": "D",
    "dropkey": "PW23133",
    "droptype": "D",
    "dropname": "CANYON",
    "dropdeladd": "1304 4TH AVE",
    "dropdelcty": "CANYON",
    "dropdelst": "TX",
    "dropdelzpp": 790153739,
    "dropphyadd": "1304 4TH AVE",
    "dropphycty": "CANYON",
    "dropphyst": "TX",
    "dropphyzpp": 790153739,
    "dropmaladd": "1304 4TH AVE",
    "dropmalcty": "CANYON",
    "dropmalst": "TX",
    "dropmalzpp": 790153739,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066552507,
    "dropsitcph": 8066552507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23141",
    "droptype": "D",
    "dropname": "CARBON",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "CARBON",
    "dropdelst": "TX",
    "dropdelzpp": 764359802,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "CARBON",
    "dropphyst": "TX",
    "dropphyzpp": 764359802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARBON",
    "dropmalst": "TX",
    "dropmalzpp": 764359998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546392415,
    "dropsitcph": 2546392415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23149",
    "droptype": "D",
    "dropname": "CARLSBAD",
    "dropdeladd": "11794 FORT WORTH ST",
    "dropdelcty": "CARLSBAD",
    "dropdelst": "TX",
    "dropdelzpp": 769349802,
    "dropphyadd": "11794 FORT WORTH ST",
    "dropphycty": "CARLSBAD",
    "dropphyst": "TX",
    "dropphyzpp": 769349802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLSBAD",
    "dropmalst": "TX",
    "dropmalzpp": 769349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254654604,
    "dropsitcph": 3254654604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23151",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "139 S FM 1744",
    "dropdelcty": "CARLTON",
    "dropdelst": "TX",
    "dropdelzpp": 764369802,
    "dropphyadd": "139 S FM 1744",
    "dropphycty": "CARLTON",
    "dropphyst": "TX",
    "dropphyzpp": 764369802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLTON",
    "dropmalst": "TX",
    "dropmalzpp": 764369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547852388,
    "dropsitcph": 2547852388,
    "dropfax": 2547852389
  },
  {
    "dcode": "D",
    "dropkey": "PW23152",
    "droptype": "D",
    "dropname": "CARMINE",
    "dropdeladd": "201 W SYLVAN ST",
    "dropdelcty": "CARMINE",
    "dropdelst": "TX",
    "dropdelzpp": 789329998,
    "dropphyadd": "201 W SYLVAN ST",
    "dropphycty": "CARMINE",
    "dropphyst": "TX",
    "dropphyzpp": 789329998,
    "dropmaladd": "201 W SYLVAN ST",
    "dropmalcty": "CARMINE",
    "dropmalst": "TX",
    "dropmalzpp": 789329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792783278,
    "dropsitcph": 9792783278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23157",
    "droptype": "D",
    "dropname": "CARRIZO SPRINGS",
    "dropdeladd": "401 N 5TH ST",
    "dropdelcty": "CARRIZO SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 788349998,
    "dropphyadd": "401 N 5TH ST",
    "dropphycty": "CARRIZO SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 788349998,
    "dropmaladd": "401 N 5TH ST",
    "dropmalcty": "CARRIZO SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 788349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2108762612,
    "dropsitcph": 8308762612,
    "dropfax": 8308765682
  },
  {
    "dcode": "D",
    "dropkey": "PW23158",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "2030 E JACKSON RD",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "TX",
    "dropdelzpp": 750069998,
    "dropphyadd": "2030 E JACKSON RD",
    "dropphycty": "CARROLLTON",
    "dropphyst": "TX",
    "dropphyzpp": 750069998,
    "dropmaladd": "2030 E JACKSON RD",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "TX",
    "dropmalzpp": 750069998,
    "dropsitphn": 9722453512,
    "dropsitlph": 9722453512,
    "dropsitcph": 9722453512,
    "dropfax": 9722454924
  },
  {
    "dcode": "D",
    "dropkey": "PW23163",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "109 W WELLINGTON ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "TX",
    "dropdelzpp": 756339998,
    "dropphyadd": "109 W WELLINGTON ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "TX",
    "dropphyzpp": 756339998,
    "dropmaladd": "109 W WELLINGTON ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "TX",
    "dropmalzpp": 756339998,
    "dropsitphn": 9032656045,
    "dropsitlph": 9032656045,
    "dropsitcph": 9032656045,
    "dropfax": 9036932157
  },
  {
    "dcode": "D",
    "dropkey": "PW23165",
    "droptype": "D",
    "dropname": "CASON",
    "dropdeladd": "4334 TEXAS STATE HIGHWAY 11 W",
    "dropdelcty": "CASON",
    "dropdelst": "TX",
    "dropdelzpp": 756369998,
    "dropphyadd": "4334 TEXAS STATE HIGHWAY 11 W",
    "dropphycty": "CASON",
    "dropphyst": "TX",
    "dropphyzpp": 756369998,
    "dropmaladd": "4334 TEXAS STATE HIGHWAY 11 W",
    "dropmalcty": "CASON",
    "dropmalst": "TX",
    "dropmalzpp": 756369998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036452066,
    "dropsitcph": 9036452066,
    "dropfax": 9036452066
  },
  {
    "dcode": "D",
    "dropkey": "PW23166",
    "droptype": "D",
    "dropname": "CASTELL",
    "dropdeladd": "19479 RANCH ROAD 152",
    "dropdelcty": "CASTELL",
    "dropdelst": "TX",
    "dropdelzpp": 768313000,
    "dropphyadd": "19479 RANCH ROAD 152",
    "dropphycty": "CASTELL",
    "dropphyst": "TX",
    "dropphyzpp": 768313000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTELL",
    "dropmalst": "TX",
    "dropmalzpp": 768319998,
    "dropsitphn": 3252473117,
    "dropsitlph": 3252473117,
    "dropsitcph": 3252473117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23168",
    "droptype": "D",
    "dropname": "CASTROVILLE",
    "dropdeladd": "1305 US HIGHWAY 90 W",
    "dropdelcty": "CASTROVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 780099998,
    "dropphyadd": "1305 US HIGHWAY 90 W",
    "dropphycty": "CASTROVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 780099998,
    "dropmaladd": "1305 US HIGHWAY 90 W",
    "dropmalcty": "CASTROVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 780099998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305382251,
    "dropsitcph": 8305382251,
    "dropfax": 8305389181
  },
  {
    "dcode": "D",
    "dropkey": "PW23169",
    "droptype": "D",
    "dropname": "CAT SPRING",
    "dropdeladd": "182 N FRONT ST",
    "dropdelcty": "CAT SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 789339998,
    "dropphyadd": "182 N FRONT ST",
    "dropphycty": "CAT SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 789339998,
    "dropmaladd": "182 N FRONT ST",
    "dropmalcty": "CAT SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 789339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9798652763,
    "dropsitcph": 9798652763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23173",
    "droptype": "D",
    "dropname": "CAYUGA",
    "dropdeladd": "21649 N US HIGHWAY 287",
    "dropdelcty": "CAYUGA",
    "dropdelst": "TX",
    "dropdelzpp": 758329998,
    "dropphyadd": "21649 N US HIGHWAY 287",
    "dropphycty": "CAYUGA",
    "dropphyst": "TX",
    "dropphyzpp": 758329998,
    "dropmaladd": "21649 N US HIGHWAY 287",
    "dropmalcty": "CAYUGA",
    "dropmalst": "TX",
    "dropmalzpp": 758329998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034992851,
    "dropsitcph": 9034992851,
    "dropfax": 9034992851
  },
  {
    "dcode": "D",
    "dropkey": "PW23175",
    "droptype": "D",
    "dropname": "CEDAR CREEK",
    "dropdeladd": "1167 STATE HIGHWAY 21 W",
    "dropdelcty": "CEDAR CREEK",
    "dropdelst": "TX",
    "dropdelzpp": 786129998,
    "dropphyadd": "1167 STATE HIGHWAY 21 W",
    "dropphycty": "CEDAR CREEK",
    "dropphyst": "TX",
    "dropphyzpp": 786129998,
    "dropmaladd": "1167 STATE HIGHWAY 21 W",
    "dropmalcty": "CEDAR CREEK",
    "dropmalst": "TX",
    "dropmalzpp": 786129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123216270,
    "dropsitcph": 5123216270,
    "dropfax": 5123213276
  },
  {
    "dcode": "D",
    "dropkey": "PW23178",
    "droptype": "D",
    "dropname": "CEDAR HILL",
    "dropdeladd": "475 E FM 1382",
    "dropdelcty": "CEDAR HILL",
    "dropdelst": "TX",
    "dropdelzpp": 751049998,
    "dropphyadd": "475 E FM 1382",
    "dropphycty": "CEDAR HILL",
    "dropphyst": "TX",
    "dropphyzpp": 751049998,
    "dropmaladd": "475 E FM 1382",
    "dropmalcty": "CEDAR HILL",
    "dropmalst": "TX",
    "dropmalzpp": 751049998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722938216,
    "dropsitcph": 9722938216,
    "dropfax": 9722933181
  },
  {
    "dcode": "D",
    "dropkey": "PW23180",
    "droptype": "D",
    "dropname": "CEDAR LANE",
    "dropdeladd": "13412 FM 457",
    "dropdelcty": "CEDAR LANE",
    "dropdelst": "TX",
    "dropdelzpp": 774150177,
    "dropphyadd": "13412 FM 457",
    "dropphycty": "CEDAR LANE",
    "dropphyst": "TX",
    "dropphyzpp": 774150177,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR LANE",
    "dropmalst": "TX",
    "dropmalzpp": 774159998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792450139,
    "dropsitcph": 9792450139,
    "dropfax": 9792450018
  },
  {
    "dcode": "D",
    "dropkey": "PW23182",
    "droptype": "D",
    "dropname": "CEDAR PARK",
    "dropdeladd": "500 E WHITESTONE BLVD",
    "dropdelcty": "CEDAR PARK",
    "dropdelst": "TX",
    "dropdelzpp": 786139998,
    "dropphyadd": "500 E WHITESTONE BLVD",
    "dropphycty": "CEDAR PARK",
    "dropphyst": "TX",
    "dropphyzpp": 786139998,
    "dropmaladd": "500 E WHITESTONE BLVD",
    "dropmalcty": "CEDAR PARK",
    "dropmalst": "TX",
    "dropmalzpp": 786139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122607816,
    "dropsitcph": 5122607585,
    "dropfax": 5122591584
  },
  {
    "dcode": "D",
    "dropkey": "PW23188",
    "droptype": "D",
    "dropname": "CELESTE",
    "dropdeladd": "103 N US HIGHWAY 69",
    "dropdelcty": "CELESTE",
    "dropdelst": "TX",
    "dropdelzpp": 754239998,
    "dropphyadd": "103 N US HIGHWAY 69",
    "dropphycty": "CELESTE",
    "dropphyst": "TX",
    "dropphyzpp": 754239998,
    "dropmaladd": "103 N US HIGHWAY 69",
    "dropmalcty": "CELESTE",
    "dropmalst": "TX",
    "dropmalzpp": 754239998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035684311,
    "dropsitcph": 9035684311,
    "dropfax": 9035684311
  },
  {
    "dcode": "D",
    "dropkey": "PW23189",
    "droptype": "D",
    "dropname": "CELINA",
    "dropdeladd": "918 W WALNUT ST",
    "dropdelcty": "CELINA",
    "dropdelst": "TX",
    "dropdelzpp": 750099998,
    "dropphyadd": "918 W WALNUT ST",
    "dropphycty": "CELINA",
    "dropphyst": "TX",
    "dropphyzpp": 750099998,
    "dropmaladd": "918 W WALNUT ST",
    "dropmalcty": "CELINA",
    "dropmalst": "TX",
    "dropmalzpp": 750099998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723822951,
    "dropsitcph": 9723822951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23190",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "101 WEAVER ST",
    "dropdelcty": "CENTER",
    "dropdelst": "TX",
    "dropdelzpp": 759359998,
    "dropphyadd": "101 WEAVER ST",
    "dropphycty": "CENTER",
    "dropphyst": "TX",
    "dropphyzpp": 759359998,
    "dropmaladd": "101 WEAVER ST",
    "dropmalcty": "CENTER",
    "dropmalst": "TX",
    "dropmalzpp": 759359998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365982011,
    "dropsitcph": 9365982011,
    "dropfax": 9365910544
  },
  {
    "dcode": "D",
    "dropkey": "PW23192",
    "droptype": "D",
    "dropname": "CENTER POINT",
    "dropdeladd": "218 FM 480",
    "dropdelcty": "CENTER POINT",
    "dropdelst": "TX",
    "dropdelzpp": 780109998,
    "dropphyadd": "218 FM 480",
    "dropphycty": "CENTER POINT",
    "dropphyst": "TX",
    "dropphyzpp": 780109998,
    "dropmaladd": "218 FM 480",
    "dropmalcty": "CENTER POINT",
    "dropmalst": "TX",
    "dropmalzpp": 780109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306342431,
    "dropsitcph": 8306342431,
    "dropfax": 8306347140
  },
  {
    "dcode": "D",
    "dropkey": "PW23194",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "322 E SAINT MARYS ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 758339998,
    "dropphyadd": "322 E SAINT MARYS ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 758339998,
    "dropmaladd": "322 E SAINT MARYS ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 758339998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035362420,
    "dropsitcph": 9035362420,
    "dropfax": 9035362023
  },
  {
    "dcode": "D",
    "dropkey": "PW23208",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "326 STATE HIGHWAY 31 E",
    "dropdelcty": "CHANDLER",
    "dropdelst": "TX",
    "dropdelzpp": 757589998,
    "dropphyadd": "326 STATE HIGHWAY 31 E",
    "dropphycty": "CHANDLER",
    "dropphyst": "TX",
    "dropphyzpp": 757589998,
    "dropmaladd": "326 STATE HIGHWAY 31 E",
    "dropmalcty": "CHANDLER",
    "dropmalst": "TX",
    "dropmalzpp": 757589998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038496834,
    "dropsitcph": 9038496834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23209",
    "droptype": "D",
    "dropname": "CHANNELVIEW",
    "dropdeladd": "531 SHELDON RD",
    "dropdelcty": "CHANNELVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 775309998,
    "dropphyadd": "531 SHELDON RD",
    "dropphycty": "CHANNELVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 775309998,
    "dropmaladd": "531 SHELDON RD",
    "dropmalcty": "CHANNELVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 775309998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814575479,
    "dropsitcph": 2814575479,
    "dropfax": 2814527936
  },
  {
    "dcode": "D",
    "dropkey": "PW23210",
    "droptype": "D",
    "dropname": "CHANNING",
    "dropdeladd": "705 ROCK ISLAND ST",
    "dropdelcty": "CHANNING",
    "dropdelst": "TX",
    "dropdelzpp": 790189802,
    "dropphyadd": "705 ROCK ISLAND ST",
    "dropphycty": "CHANNING",
    "dropphyst": "TX",
    "dropphyzpp": 790189802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANNING",
    "dropmalst": "TX",
    "dropmalzpp": 790189998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062353852,
    "dropsitcph": 8062353852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23213",
    "droptype": "D",
    "dropname": "CHAPMAN RANCH",
    "dropdeladd": "1004 COUNTY ROAD 8A",
    "dropdelcty": "CHAPMAN RANCH",
    "dropdelst": "TX",
    "dropdelzpp": 783479800,
    "dropphyadd": "1004 COUNTY ROAD 8A",
    "dropphycty": "CHAPMAN RANCH",
    "dropphyst": "TX",
    "dropphyzpp": 783479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAPMAN RANCH",
    "dropmalst": "TX",
    "dropmalzpp": 783479998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612250916,
    "dropsitcph": 3618533256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23214",
    "droptype": "D",
    "dropname": "CHAPPELL HILL",
    "dropdeladd": "5110 MAIN ST",
    "dropdelcty": "CHAPPELL HILL",
    "dropdelst": "TX",
    "dropdelzpp": 774266246,
    "dropphyadd": "5110 MAIN ST",
    "dropphycty": "CHAPPELL HILL",
    "dropphyst": "TX",
    "dropphyzpp": 774266246,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAPPELL HILL",
    "dropmalst": "TX",
    "dropmalzpp": 774269998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798366844,
    "dropsitcph": 9798366844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23216",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "142 S YULE AVE",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "TX",
    "dropdelzpp": 780119998,
    "dropphyadd": "142 S YULE AVE",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "TX",
    "dropphyzpp": 780119998,
    "dropmaladd": "142 S YULE AVE",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "TX",
    "dropmalzpp": 780119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302771523,
    "dropsitcph": 8302771523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23219",
    "droptype": "D",
    "dropname": "CHATFIELD",
    "dropdeladd": "4857 FM 1603",
    "dropdelcty": "CHATFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 751059998,
    "dropphyadd": "4857 FM 1603",
    "dropphycty": "CHATFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 751059998,
    "dropmaladd": "4857 FM 1603",
    "dropmalcty": "CHATFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 751059998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9033456711,
    "dropsitcph": 9033456711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23222",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "206 N HIGHWAY 16",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "TX",
    "dropdelzpp": 768329998,
    "dropphyadd": "206 N HIGHWAY 16",
    "dropphycty": "CHEROKEE",
    "dropphyst": "TX",
    "dropphyzpp": 768329998,
    "dropmaladd": "206 N HIGHWAY 16",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "TX",
    "dropmalzpp": 768329998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256224566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23225",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "13884 MAIN ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "TX",
    "dropdelzpp": 759369998,
    "dropphyadd": "13884 MAIN ST",
    "dropphycty": "CHESTER",
    "dropphyst": "TX",
    "dropphyzpp": 759369998,
    "dropmaladd": "13884 MAIN ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "TX",
    "dropmalzpp": 759369998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9369692595,
    "dropsitcph": 9369692595,
    "dropfax": 9369692125
  },
  {
    "dcode": "D",
    "dropkey": "PW23227",
    "droptype": "D",
    "dropname": "CHICO",
    "dropdeladd": "100 S BUFFALO ST",
    "dropdelcty": "CHICO",
    "dropdelst": "TX",
    "dropdelzpp": 764319998,
    "dropphyadd": "100 S BUFFALO ST",
    "dropphycty": "CHICO",
    "dropphyst": "TX",
    "dropphyzpp": 764319998,
    "dropmaladd": "100 S BUFFALO ST",
    "dropmalcty": "CHICO",
    "dropmalst": "TX",
    "dropmalzpp": 764319998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406442470,
    "dropsitcph": 9406442470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23228",
    "droptype": "D",
    "dropname": "CHICOTA",
    "dropdeladd": "3696 FM 197",
    "dropdelcty": "CHICOTA",
    "dropdelst": "TX",
    "dropdelzpp": 754259998,
    "dropphyadd": "3696 FM 197",
    "dropphycty": "CHICOTA",
    "dropphyst": "TX",
    "dropphyzpp": 754259998,
    "dropmaladd": "3696 FM 197",
    "dropmalcty": "CHICOTA",
    "dropmalst": "TX",
    "dropmalzpp": 754259998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037324947,
    "dropsitcph": 9037324947,
    "dropfax": 9037324947
  },
  {
    "dcode": "D",
    "dropkey": "PW23231",
    "droptype": "D",
    "dropname": "CHILDRESS",
    "dropdeladd": "507 AVENUE F NW",
    "dropdelcty": "CHILDRESS",
    "dropdelst": "TX",
    "dropdelzpp": 792019998,
    "dropphyadd": "507 AVENUE F NW",
    "dropphycty": "CHILDRESS",
    "dropphyst": "TX",
    "dropphyzpp": 792019998,
    "dropmaladd": "507 AVENUE F NW",
    "dropmalcty": "CHILDRESS",
    "dropmalst": "TX",
    "dropmalzpp": 792019998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9409373741,
    "dropsitcph": 9409373741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23232",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "14125 US HIGHWAY 287 S",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "TX",
    "dropdelzpp": 792259804,
    "dropphyadd": "14125 US HIGHWAY 287 S",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "TX",
    "dropphyzpp": 792259804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "TX",
    "dropmalzpp": 792259998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408525221,
    "dropsitcph": 9408525221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23233",
    "droptype": "D",
    "dropname": "CHILTON",
    "dropdeladd": "2581 STATE HIGHWAY 7",
    "dropdelcty": "CHILTON",
    "dropdelst": "TX",
    "dropdelzpp": 766329998,
    "dropphyadd": "2581 STATE HIGHWAY 7",
    "dropphycty": "CHILTON",
    "dropphyst": "TX",
    "dropphyzpp": 766329998,
    "dropmaladd": "2581 STATE HIGHWAY 7",
    "dropmalcty": "CHILTON",
    "dropmalst": "TX",
    "dropmalzpp": 766329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545462421,
    "dropsitcph": 2545462421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23235",
    "droptype": "D",
    "dropname": "CHINA",
    "dropdeladd": "305 N BROADWAY ST",
    "dropdelcty": "CHINA",
    "dropdelst": "TX",
    "dropdelzpp": 776130016,
    "dropphyadd": "305 N BROADWAY ST",
    "dropphycty": "CHINA",
    "dropphyst": "TX",
    "dropphyzpp": 776130016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHINA",
    "dropmalst": "TX",
    "dropmalzpp": 776139998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097525310,
    "dropsitcph": 4097525310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23237",
    "droptype": "D",
    "dropname": "CHINA SPRING",
    "dropdeladd": "14038 CHINA SPRING RD",
    "dropdelcty": "CHINA SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 766339998,
    "dropphyadd": "14038 CHINA SPRING RD",
    "dropphycty": "CHINA SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 766339998,
    "dropmaladd": "14038 CHINA SPRING RD",
    "dropmalcty": "CHINA SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 766339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548364751,
    "dropsitcph": 2548364751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23238",
    "droptype": "D",
    "dropname": "CHIRENO",
    "dropdeladd": "691 MAIN ST",
    "dropdelcty": "CHIRENO",
    "dropdelst": "TX",
    "dropdelzpp": 759379998,
    "dropphyadd": "691 MAIN ST",
    "dropphycty": "CHIRENO",
    "dropphyst": "TX",
    "dropphyzpp": 759379998,
    "dropmaladd": "691 MAIN ST",
    "dropmalcty": "CHIRENO",
    "dropmalst": "TX",
    "dropmalzpp": 759379998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9363622335,
    "dropsitcph": 9363622335,
    "dropfax": 9363632384
  },
  {
    "dcode": "D",
    "dropkey": "PW23241",
    "droptype": "D",
    "dropname": "CHRIESMAN",
    "dropdeladd": "136 PRAIRIE ST",
    "dropdelcty": "CHRIESMAN",
    "dropdelst": "TX",
    "dropdelzpp": 778385000,
    "dropphyadd": "136 PRAIRIE ST",
    "dropphycty": "CHRIESMAN",
    "dropphyst": "TX",
    "dropphyzpp": 778385000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHRIESMAN",
    "dropmalst": "TX",
    "dropmalzpp": 778389998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263055,
    "dropsitcph": 9795677315,
    "dropfax": 9795677315
  },
  {
    "dcode": "D",
    "dropkey": "PW23242",
    "droptype": "D",
    "dropname": "CHRISTINE",
    "dropdeladd": "709 W AVENUE E",
    "dropdelcty": "CHRISTINE",
    "dropdelst": "TX",
    "dropdelzpp": 780129998,
    "dropphyadd": "709 W AVENUE E",
    "dropphycty": "CHRISTINE",
    "dropphyst": "TX",
    "dropphyzpp": 780129998,
    "dropmaladd": "709 W AVENUE E",
    "dropmalcty": "CHRISTINE",
    "dropmalst": "TX",
    "dropmalzpp": 780129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307843502,
    "dropsitcph": 8307843502,
    "dropfax": 8307843205
  },
  {
    "dcode": "D",
    "dropkey": "PW23243",
    "droptype": "D",
    "dropname": "CHRISTOVAL",
    "dropdeladd": "19919 MAIN ST",
    "dropdelcty": "CHRISTOVAL",
    "dropdelst": "TX",
    "dropdelzpp": 769355101,
    "dropphyadd": "19919 MAIN ST",
    "dropphycty": "CHRISTOVAL",
    "dropphyst": "TX",
    "dropphyzpp": 769355101,
    "dropmaladd": "19919 MAIN ST",
    "dropmalcty": "CHRISTOVAL",
    "dropmalst": "TX",
    "dropmalzpp": 769355101,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258962331,
    "dropsitcph": 3258962331,
    "dropfax": 3258962331
  },
  {
    "dcode": "D",
    "dropkey": "PW23245",
    "droptype": "D",
    "dropname": "CIBOLO",
    "dropdeladd": "725 FM 1103",
    "dropdelcty": "CIBOLO",
    "dropdelst": "TX",
    "dropdelzpp": 781089998,
    "dropphyadd": "725 FM 1103",
    "dropphycty": "CIBOLO",
    "dropphyst": "TX",
    "dropphyzpp": 781089998,
    "dropmaladd": "725 FM 1103",
    "dropmalcty": "CIBOLO",
    "dropmalst": "TX",
    "dropmalzpp": 781089998,
    "dropsitphn": 2106580637,
    "dropsitlph": 2106580637,
    "dropsitcph": 2106582631,
    "dropfax": 2106590354
  },
  {
    "dcode": "D",
    "dropkey": "PW23249",
    "droptype": "D",
    "dropname": "CISCO",
    "dropdeladd": "206 W 6TH ST",
    "dropdelcty": "CISCO",
    "dropdelst": "TX",
    "dropdelzpp": 764379998,
    "dropphyadd": "206 W 6TH ST",
    "dropphycty": "CISCO",
    "dropphyst": "TX",
    "dropphyzpp": 764379998,
    "dropmaladd": "206 W 6TH ST",
    "dropmalcty": "CISCO",
    "dropmalst": "TX",
    "dropmalzpp": 764379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2544422357,
    "dropsitcph": 2544422357,
    "dropfax": 2544423449
  },
  {
    "dcode": "D",
    "dropkey": "PW23260",
    "droptype": "D",
    "dropname": "CLARENDON",
    "dropdeladd": "101 W 4TH ST",
    "dropdelcty": "CLARENDON",
    "dropdelst": "TX",
    "dropdelzpp": 792269806,
    "dropphyadd": "101 W 4TH ST",
    "dropphycty": "CLARENDON",
    "dropphyst": "TX",
    "dropphyzpp": 792269806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARENDON",
    "dropmalst": "TX",
    "dropmalzpp": 792269998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068743353,
    "dropsitcph": 8068743353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23264",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "403 N WALNUT ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754269998,
    "dropphyadd": "403 N WALNUT ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754269998,
    "dropmaladd": "403 N WALNUT ST",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754269998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034272139,
    "dropsitcph": 9034272139,
    "dropfax": 9034272139
  },
  {
    "dcode": "D",
    "dropkey": "PW23266",
    "droptype": "D",
    "dropname": "CLAUDE",
    "dropdeladd": "302 TRICE ST",
    "dropdelcty": "CLAUDE",
    "dropdelst": "TX",
    "dropdelzpp": 790199802,
    "dropphyadd": "302 TRICE ST",
    "dropphycty": "CLAUDE",
    "dropphyst": "TX",
    "dropphyzpp": 790199802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAUDE",
    "dropmalst": "TX",
    "dropmalzpp": 790199998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062265931,
    "dropsitcph": 8062265931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23271",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "4535 W HIGHWAY 315",
    "dropdelcty": "CLAYTON",
    "dropdelst": "TX",
    "dropdelzpp": 756379998,
    "dropphyadd": "4535 W HIGHWAY 315",
    "dropphycty": "CLAYTON",
    "dropphyst": "TX",
    "dropphyzpp": 756379998,
    "dropmaladd": "4535 W HIGHWAY 315",
    "dropmalcty": "CLAYTON",
    "dropmalst": "TX",
    "dropmalzpp": 756379998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036935833,
    "dropsitcph": 9036935833,
    "dropfax": 9036935833
  },
  {
    "dcode": "D",
    "dropkey": "PW23277",
    "droptype": "D",
    "dropname": "CLEBURNE",
    "dropdeladd": "201 FAIRCREST DR",
    "dropdelcty": "CLEBURNE",
    "dropdelst": "TX",
    "dropdelzpp": 760334649,
    "dropphyadd": "201 FAIRCREST DR",
    "dropphycty": "CLEBURNE",
    "dropphyst": "TX",
    "dropphyzpp": 760334649,
    "dropmaladd": "201 FAIRCREST DR",
    "dropmalcty": "CLEBURNE",
    "dropmalst": "TX",
    "dropmalzpp": 760334649,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176453991,
    "dropsitcph": 8176453991,
    "dropfax": 8176451836
  },
  {
    "dcode": "D",
    "dropkey": "PW23279",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "1213 E HOUSTON ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "TX",
    "dropdelzpp": 773279998,
    "dropphyadd": "1213 E HOUSTON ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "TX",
    "dropphyzpp": 773279998,
    "dropmaladd": "1213 E HOUSTON ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "TX",
    "dropmalzpp": 773279998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815923951,
    "dropsitcph": 2815923951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23280",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "407 W 5TH ST",
    "dropdelcty": "CLIFTON",
    "dropdelst": "TX",
    "dropdelzpp": 766349998,
    "dropphyadd": "407 W 5TH ST",
    "dropphycty": "CLIFTON",
    "dropphyst": "TX",
    "dropphyzpp": 766349998,
    "dropmaladd": "407 W 5TH ST",
    "dropmalcty": "CLIFTON",
    "dropmalst": "TX",
    "dropmalzpp": 766349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546753116,
    "dropsitcph": 2546753116,
    "dropfax": 2546754392
  },
  {
    "dcode": "D",
    "dropkey": "PW23281",
    "droptype": "D",
    "dropname": "CLINT",
    "dropdeladd": "13001 ALAMEDA AVE",
    "dropdelcty": "CLINT",
    "dropdelst": "TX",
    "dropdelzpp": 798369998,
    "dropphyadd": "13001 ALAMEDA AVE",
    "dropphycty": "CLINT",
    "dropphyst": "TX",
    "dropphyzpp": 798369998,
    "dropmaladd": "13001 ALAMEDA AVE",
    "dropmalcty": "CLINT",
    "dropmalst": "TX",
    "dropmalzpp": 798369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9158514313,
    "dropsitcph": 9158518614,
    "dropfax": 9158516014
  },
  {
    "dcode": "D",
    "dropkey": "PW23286",
    "droptype": "D",
    "dropname": "CLUTE",
    "dropdeladd": "530 E MAIN ST",
    "dropdelcty": "CLUTE",
    "dropdelst": "TX",
    "dropdelzpp": 775319998,
    "dropphyadd": "530 E MAIN ST",
    "dropphycty": "CLUTE",
    "dropphyst": "TX",
    "dropphyzpp": 775319998,
    "dropmaladd": "530 E MAIN ST",
    "dropmalcty": "CLUTE",
    "dropmalst": "TX",
    "dropmalzpp": 775319998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792652611,
    "dropsitcph": 9792652611,
    "dropfax": 9792652642
  },
  {
    "dcode": "D",
    "dropkey": "PW23287",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "615 ELM ST",
    "dropdelcty": "CLYDE",
    "dropdelst": "TX",
    "dropdelzpp": 795109998,
    "dropphyadd": "615 ELM ST",
    "dropphycty": "CLYDE",
    "dropphyst": "TX",
    "dropphyzpp": 795109998,
    "dropmaladd": "615 ELM ST",
    "dropmalcty": "CLYDE",
    "dropmalst": "TX",
    "dropmalzpp": 795109998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258934921,
    "dropsitcph": 3258934921,
    "dropfax": 3258934973
  },
  {
    "dcode": "D",
    "dropkey": "PW23288",
    "droptype": "D",
    "dropname": "COAHOMA",
    "dropdeladd": "102 S 1ST ST",
    "dropdelcty": "COAHOMA",
    "dropdelst": "TX",
    "dropdelzpp": 795119998,
    "dropphyadd": "102 S 1ST ST",
    "dropphycty": "COAHOMA",
    "dropphyst": "TX",
    "dropphyzpp": 795119998,
    "dropmaladd": "102 S 1ST ST",
    "dropmalcty": "COAHOMA",
    "dropmalst": "TX",
    "dropmalzpp": 795119998,
    "dropsitphn": 8173173658,
    "dropsitlph": 4323944526,
    "dropsitcph": 4323944526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23294",
    "droptype": "D",
    "dropname": "COLDSPRING",
    "dropdeladd": "14231 STATE HIGHWAY 150 W",
    "dropdelcty": "COLDSPRING",
    "dropdelst": "TX",
    "dropdelzpp": 773319998,
    "dropphyadd": "14231 STATE HIGHWAY 150 W",
    "dropphycty": "COLDSPRING",
    "dropphyst": "TX",
    "dropphyzpp": 773319998,
    "dropmaladd": "14231 STATE HIGHWAY 150 W",
    "dropmalcty": "COLDSPRING",
    "dropmalst": "TX",
    "dropmalzpp": 773319998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9366532223,
    "dropsitcph": 9366532223,
    "dropfax": 9366533557
  },
  {
    "dcode": "D",
    "dropkey": "PW23295",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "201 W PECAN ST",
    "dropdelcty": "COLEMAN",
    "dropdelst": "TX",
    "dropdelzpp": 768349998,
    "dropphyadd": "201 W PECAN ST",
    "dropphycty": "COLEMAN",
    "dropphyst": "TX",
    "dropphyzpp": 768349998,
    "dropmaladd": "201 W PECAN ST",
    "dropmalcty": "COLEMAN",
    "dropmalst": "TX",
    "dropmalzpp": 768349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256254315,
    "dropfax": 3256251011
  },
  {
    "dcode": "D",
    "dropkey": "PW23297",
    "droptype": "D",
    "dropname": "COLLEGE STATION",
    "dropdeladd": "2130 HARVEY MITCHELL PKWY S",
    "dropdelcty": "COLLEGE STATION",
    "dropdelst": "TX",
    "dropdelzpp": 778409998,
    "dropphyadd": "2130 HARVEY MITCHELL PKWY S",
    "dropphycty": "COLLEGE STATION",
    "dropphyst": "TX",
    "dropphyzpp": 778409998,
    "dropmaladd": "2130 HARVEY MITCHELL PKWY S",
    "dropmalcty": "COLLEGE STATION",
    "dropmalst": "TX",
    "dropmalzpp": 778409998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796934152,
    "dropsitcph": 9796934152,
    "dropfax": 9797647530
  },
  {
    "dcode": "D",
    "dropkey": "PW23298",
    "droptype": "D",
    "dropname": "COLLEGEPORT",
    "dropdeladd": "15235 FM 1095",
    "dropdelcty": "COLLEGEPORT",
    "dropdelst": "TX",
    "dropdelzpp": 774280015,
    "dropphyadd": "15235 FM 1095",
    "dropphycty": "COLLEGEPORT",
    "dropphyst": "TX",
    "dropphyzpp": 774280015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLEGEPORT",
    "dropmalst": "TX",
    "dropmalzpp": 774289998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3619725506,
    "dropsitcph": 3619725506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23299",
    "droptype": "D",
    "dropname": "COLLEYVILLE",
    "dropdeladd": "1501 HALL JOHNSON RD",
    "dropdelcty": "COLLEYVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 760349998,
    "dropphyadd": "1501 HALL JOHNSON RD",
    "dropphycty": "COLLEYVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 760349998,
    "dropmaladd": "1501 HALL JOHNSON RD",
    "dropmalcty": "COLLEYVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 760349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176841950,
    "dropsitcph": 8176840812,
    "dropfax": 8172831764
  },
  {
    "dcode": "D",
    "dropkey": "PW23300",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 762339998,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 762339998,
    "dropmaladd": "200 N MAIN ST",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 762339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9034296127,
    "dropsitcph": 9034296127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23301",
    "droptype": "D",
    "dropname": "COLMESNEIL",
    "dropdeladd": "605 N WHEELER RD",
    "dropdelcty": "COLMESNEIL",
    "dropdelst": "TX",
    "dropdelzpp": 759389998,
    "dropphyadd": "605 N WHEELER RD",
    "dropphycty": "COLMESNEIL",
    "dropphyst": "TX",
    "dropphyzpp": 759389998,
    "dropmaladd": "605 N WHEELER RD",
    "dropmalcty": "COLMESNEIL",
    "dropmalst": "TX",
    "dropmalzpp": 759389998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4098375246,
    "dropsitcph": 4098375246,
    "dropfax": 4098372138
  },
  {
    "dcode": "D",
    "dropkey": "PW23305",
    "droptype": "D",
    "dropname": "COLORADO CITY",
    "dropdeladd": "116 W 3RD ST",
    "dropdelcty": "COLORADO CITY",
    "dropdelst": "TX",
    "dropdelzpp": 795129998,
    "dropphyadd": "116 W 3RD ST",
    "dropphycty": "COLORADO CITY",
    "dropphyst": "TX",
    "dropphyzpp": 795129998,
    "dropmaladd": "116 W 3RD ST",
    "dropmalcty": "COLORADO CITY",
    "dropmalst": "TX",
    "dropmalzpp": 795129998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257283612,
    "dropsitcph": 3257283612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23307",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "1221 WALNUT ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "TX",
    "dropdelzpp": 789349998,
    "dropphyadd": "1221 WALNUT ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "TX",
    "dropphyzpp": 789349998,
    "dropmaladd": "1221 WALNUT ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "TX",
    "dropmalzpp": 789349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9797325556,
    "dropsitcph": 9797325556,
    "dropfax": 9797325903
  },
  {
    "dcode": "D",
    "dropkey": "PW23308",
    "droptype": "D",
    "dropname": "COMANCHE",
    "dropdeladd": "410 W OAK AVE",
    "dropdelcty": "COMANCHE",
    "dropdelst": "TX",
    "dropdelzpp": 764429998,
    "dropphyadd": "410 W OAK AVE",
    "dropphycty": "COMANCHE",
    "dropphyst": "TX",
    "dropphyzpp": 764429998,
    "dropmaladd": "410 W OAK AVE",
    "dropmalcty": "COMANCHE",
    "dropmalst": "TX",
    "dropmalzpp": 764429998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3253563363,
    "dropsitcph": 3253563363,
    "dropfax": 3253565582
  },
  {
    "dcode": "D",
    "dropkey": "PW23309",
    "droptype": "D",
    "dropname": "COMBES",
    "dropdeladd": "21659 S BUSINESS HIGHWAY 77",
    "dropdelcty": "COMBES",
    "dropdelst": "TX",
    "dropdelzpp": 785359801,
    "dropphyadd": "21659 S BUSINESS HIGHWAY 77",
    "dropphycty": "COMBES",
    "dropphyst": "TX",
    "dropphyzpp": 785359801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMBES",
    "dropmalst": "TX",
    "dropmalzpp": 785359998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564253235,
    "dropsitcph": 9564253235,
    "dropfax": 9564252560
  },
  {
    "dcode": "D",
    "dropkey": "PW23311",
    "droptype": "D",
    "dropname": "COMFORT",
    "dropdeladd": "726 FRONT ST",
    "dropdelcty": "COMFORT",
    "dropdelst": "TX",
    "dropdelzpp": 780139998,
    "dropphyadd": "726 FRONT ST",
    "dropphycty": "COMFORT",
    "dropphyst": "TX",
    "dropphyzpp": 780139998,
    "dropmaladd": "726 FRONT ST",
    "dropmalcty": "COMFORT",
    "dropmalst": "TX",
    "dropmalzpp": 780139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309953603,
    "dropsitcph": 8302801082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23312",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "1300 PARK ST",
    "dropdelcty": "COMMERCE",
    "dropdelst": "TX",
    "dropdelzpp": 754289998,
    "dropphyadd": "1300 PARK ST",
    "dropphycty": "COMMERCE",
    "dropphyst": "TX",
    "dropphyzpp": 754289998,
    "dropmaladd": "1300 PARK ST",
    "dropmalcty": "COMMERCE",
    "dropmalst": "TX",
    "dropmalzpp": 754289998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038863986,
    "dropsitcph": 9038863986,
    "dropfax": 9038863930
  },
  {
    "dcode": "D",
    "dropkey": "PW23314",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "103 GASKINS ST",
    "dropdelcty": "COMO",
    "dropdelst": "TX",
    "dropdelzpp": 754319998,
    "dropphyadd": "103 GASKINS ST",
    "dropphycty": "COMO",
    "dropphyst": "TX",
    "dropphyzpp": 754319998,
    "dropmaladd": "103 GASKINS ST",
    "dropmalcty": "COMO",
    "dropmalst": "TX",
    "dropmalzpp": 754319998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034883754,
    "dropsitcph": 9034883754,
    "dropfax": 9034882000
  },
  {
    "dcode": "D",
    "dropkey": "PW23315",
    "droptype": "D",
    "dropname": "COMSTOCK",
    "dropdeladd": "32108 W US HIGHWAY 90",
    "dropdelcty": "COMSTOCK",
    "dropdelst": "TX",
    "dropdelzpp": 788379998,
    "dropphyadd": "32108 W US HIGHWAY 90",
    "dropphycty": "COMSTOCK",
    "dropphyst": "TX",
    "dropphyzpp": 788379998,
    "dropmaladd": "32108 W US HIGHWAY 90",
    "dropmalcty": "COMSTOCK",
    "dropmalst": "TX",
    "dropmalzpp": 788379998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4322924548,
    "dropsitcph": 4322924548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23316",
    "droptype": "D",
    "dropname": "CONCAN",
    "dropdeladd": "20948 US HIGHWAY 127",
    "dropdelcty": "CONCAN",
    "dropdelst": "TX",
    "dropdelzpp": 788389998,
    "dropphyadd": "20948 US HIGHWAY 127",
    "dropphycty": "CONCAN",
    "dropphyst": "TX",
    "dropphyzpp": 788389998,
    "dropmaladd": "20948 US HIGHWAY 127",
    "dropmalcty": "CONCAN",
    "dropmalst": "TX",
    "dropmalzpp": 788389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302326044,
    "dropsitcph": 8302326044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23317",
    "droptype": "D",
    "dropname": "CONCEPCION",
    "dropdeladd": "2239 FM 716",
    "dropdelcty": "CONCEPCION",
    "dropdelst": "TX",
    "dropdelzpp": 783499998,
    "dropphyadd": "2239 FM 716",
    "dropphycty": "CONCEPCION",
    "dropphyst": "TX",
    "dropphyzpp": 783499998,
    "dropmaladd": "2239 FM 716",
    "dropmalcty": "CONCEPCION",
    "dropmalst": "TX",
    "dropmalzpp": 783499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615394148,
    "dropsitcph": 3615394148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23318",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "1117 COUNTY ROAD 3481",
    "dropdelcty": "CONCORD",
    "dropdelst": "TX",
    "dropdelzpp": 778509801,
    "dropphyadd": "1117 COUNTY ROAD 3481",
    "dropphycty": "CONCORD",
    "dropphyst": "TX",
    "dropphyzpp": 778509801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONCORD",
    "dropmalst": "TX",
    "dropmalzpp": 778509998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263055,
    "dropsitcph": 9036265051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23323",
    "droptype": "D",
    "dropname": "CONROE",
    "dropdeladd": "809 W DALLAS ST",
    "dropdelcty": "CONROE",
    "dropdelst": "TX",
    "dropdelzpp": 773019998,
    "dropphyadd": "809 W DALLAS ST",
    "dropphycty": "CONROE",
    "dropphyst": "TX",
    "dropphyzpp": 773019998,
    "dropmaladd": "809 W DALLAS ST",
    "dropmalcty": "CONROE",
    "dropmalst": "TX",
    "dropmalzpp": 773019998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9364416055,
    "dropsitcph": 9364416055,
    "dropfax": 9367562428
  },
  {
    "dcode": "D",
    "dropkey": "PW23325",
    "droptype": "D",
    "dropname": "CONVERSE",
    "dropdeladd": "9155 SCHAEFER RD",
    "dropdelcty": "CONVERSE",
    "dropdelst": "TX",
    "dropdelzpp": 781099998,
    "dropphyadd": "9155 SCHAEFER RD",
    "dropphycty": "CONVERSE",
    "dropphyst": "TX",
    "dropphyzpp": 781099998,
    "dropmaladd": "9155 SCHAEFER RD",
    "dropmalcty": "CONVERSE",
    "dropmalst": "TX",
    "dropmalzpp": 781099998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106594503,
    "dropsitcph": 2106585129,
    "dropfax": 2109454139
  },
  {
    "dcode": "D",
    "dropkey": "PW23326",
    "droptype": "D",
    "dropname": "COOKVILLE",
    "dropdeladd": "6648 US HIGHWAY 67 E",
    "dropdelcty": "COOKVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 755589998,
    "dropphyadd": "6648 US HIGHWAY 67 E",
    "dropphycty": "COOKVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 755589998,
    "dropmaladd": "6648 US HIGHWAY 67 E",
    "dropmalcty": "COOKVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 755589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035724981,
    "dropsitcph": 9035724981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23327",
    "droptype": "D",
    "dropname": "COOLIDGE",
    "dropdeladd": "310 BELL ST",
    "dropdelcty": "COOLIDGE",
    "dropdelst": "TX",
    "dropdelzpp": 766359998,
    "dropphyadd": "310 BELL ST",
    "dropphycty": "COOLIDGE",
    "dropphyst": "TX",
    "dropphyzpp": 766359998,
    "dropmaladd": "310 BELL ST",
    "dropmalcty": "COOLIDGE",
    "dropmalst": "TX",
    "dropmalzpp": 766359998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547862226,
    "dropsitcph": 2547862226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23328",
    "droptype": "D",
    "dropname": "COOPER",
    "dropdeladd": "150 E DALLAS AVE",
    "dropdelcty": "COOPER",
    "dropdelst": "TX",
    "dropdelzpp": 754329998,
    "dropphyadd": "150 E DALLAS AVE",
    "dropphycty": "COOPER",
    "dropphyst": "TX",
    "dropphyzpp": 754329998,
    "dropmaladd": "150 E DALLAS AVE",
    "dropmalcty": "COOPER",
    "dropmalst": "TX",
    "dropmalzpp": 754329998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033952711,
    "dropsitcph": 9033952711,
    "dropfax": 9033950504
  },
  {
    "dcode": "D",
    "dropkey": "PW23330",
    "droptype": "D",
    "dropname": "COPEVILLE",
    "dropdeladd": "15104 COUNTY ROAD 549",
    "dropdelcty": "COPEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 751219998,
    "dropphyadd": "15104 COUNTY ROAD 549",
    "dropphycty": "COPEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 751219998,
    "dropmaladd": "15104 COUNTY ROAD 549",
    "dropmalcty": "COPEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 751219998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9728534501,
    "dropsitcph": 9728534501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23332",
    "droptype": "D",
    "dropname": "COPPELL",
    "dropdeladd": "450 S DENTON TAP RD",
    "dropdelcty": "COPPELL",
    "dropdelst": "TX",
    "dropdelzpp": 750199998,
    "dropphyadd": "450 S DENTON TAP RD",
    "dropphycty": "COPPELL",
    "dropphyst": "TX",
    "dropphyzpp": 750199998,
    "dropmaladd": "450 S DENTON TAP RD",
    "dropmalcty": "COPPELL",
    "dropmalst": "TX",
    "dropmalzpp": 750199998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727453221,
    "dropsitcph": 9727453221,
    "dropfax": 9723048482
  },
  {
    "dcode": "D",
    "dropkey": "PW23334",
    "droptype": "D",
    "dropname": "COPPERAS COVE",
    "dropdeladd": "802 E AVENUE D",
    "dropdelcty": "COPPERAS COVE",
    "dropdelst": "TX",
    "dropdelzpp": 765229998,
    "dropphyadd": "802 E AVENUE D",
    "dropphycty": "COPPERAS COVE",
    "dropphyst": "TX",
    "dropphyzpp": 765229998,
    "dropmaladd": "802 E AVENUE D",
    "dropmalcty": "COPPERAS COVE",
    "dropmalst": "TX",
    "dropmalzpp": 765229998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545473605,
    "dropsitcph": 2545473605,
    "dropfax": 2545474943
  },
  {
    "dcode": "D",
    "dropkey": "PW23344",
    "droptype": "D",
    "dropname": "CORPUS CHRISTI",
    "dropdeladd": "809 NUECES BAY BLVD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784699998,
    "dropphyadd": "809 NUECES BAY BLVD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784699998,
    "dropmaladd": "809 NUECES BAY BLVD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618862242,
    "dropsitcph": 3618862245,
    "dropfax": 3618862215
  },
  {
    "dcode": "D",
    "dropkey": "PW23348",
    "droptype": "D",
    "dropname": "CORRIGAN",
    "dropdeladd": "502 N HOME ST",
    "dropdelcty": "CORRIGAN",
    "dropdelst": "TX",
    "dropdelzpp": 759399998,
    "dropphyadd": "502 N HOME ST",
    "dropphycty": "CORRIGAN",
    "dropphyst": "TX",
    "dropphyzpp": 759399998,
    "dropmaladd": "502 N HOME ST",
    "dropmalcty": "CORRIGAN",
    "dropmalst": "TX",
    "dropmalzpp": 759399998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9363984555,
    "dropsitcph": 9363984555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23349",
    "droptype": "D",
    "dropname": "CORSICANA",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "CORSICANA",
    "dropdelst": "TX",
    "dropdelzpp": 751109998,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "CORSICANA",
    "dropphyst": "TX",
    "dropphyzpp": 751109998,
    "dropmaladd": "116 S MAIN ST",
    "dropmalcty": "CORSICANA",
    "dropmalst": "TX",
    "dropmalzpp": 751109998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9038744797,
    "dropsitcph": 9038744797,
    "dropfax": 9038740942
  },
  {
    "dcode": "D",
    "dropkey": "PW23350",
    "droptype": "D",
    "dropname": "COST",
    "dropdeladd": "136 S FM 466",
    "dropdelcty": "COST",
    "dropdelst": "TX",
    "dropdelzpp": 786144000,
    "dropphyadd": "136 S FM 466",
    "dropphycty": "COST",
    "dropphyst": "TX",
    "dropphyzpp": 786144000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COST",
    "dropmalst": "TX",
    "dropmalzpp": 786149998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304372280,
    "dropsitcph": 8304372280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23351",
    "droptype": "D",
    "dropname": "COTTON CENTER",
    "dropdeladd": "2359 FM 179",
    "dropdelcty": "COTTON CENTER",
    "dropdelst": "TX",
    "dropdelzpp": 790219800,
    "dropphyadd": "2359 FM 179",
    "dropphycty": "COTTON CENTER",
    "dropphyst": "TX",
    "dropphyzpp": 790219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTON CENTER",
    "dropmalst": "TX",
    "dropmalzpp": 790219998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8068794480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23355",
    "droptype": "D",
    "dropname": "COTULLA",
    "dropdeladd": "209 N FRONT",
    "dropdelcty": "COTULLA",
    "dropdelst": "TX",
    "dropdelzpp": 780149998,
    "dropphyadd": "209 N FRONT",
    "dropphycty": "COTULLA",
    "dropphyst": "TX",
    "dropphyzpp": 780149998,
    "dropmaladd": "209 N FRONT",
    "dropmalcty": "COTULLA",
    "dropmalst": "TX",
    "dropmalzpp": 780149998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308792434,
    "dropsitcph": 8308792434,
    "dropfax": 8308793876
  },
  {
    "dcode": "D",
    "dropkey": "PW23358",
    "droptype": "D",
    "dropname": "COUPLAND",
    "dropdeladd": "13701 S STATE HIGHWAY 95",
    "dropdelcty": "COUPLAND",
    "dropdelst": "TX",
    "dropdelzpp": 786159998,
    "dropphyadd": "13701 S STATE HIGHWAY 95",
    "dropphycty": "COUPLAND",
    "dropphyst": "TX",
    "dropphyzpp": 786159998,
    "dropmaladd": "13701 S STATE HIGHWAY 95",
    "dropmalcty": "COUPLAND",
    "dropmalst": "TX",
    "dropmalzpp": 786159998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128562454,
    "dropsitcph": 5128562454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23363",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "306 GATHINGS AVE",
    "dropdelcty": "COVINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 766369998,
    "dropphyadd": "306 GATHINGS AVE",
    "dropphycty": "COVINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 766369998,
    "dropmaladd": "306 GATHINGS AVE",
    "dropmalcty": "COVINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 766369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548544022,
    "dropsitcph": 2548544022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23366",
    "droptype": "D",
    "dropname": "COYANOSA",
    "dropdeladd": "2550 N HIGHWAY 1776",
    "dropdelcty": "COYANOSA",
    "dropdelst": "TX",
    "dropdelzpp": 797309998,
    "dropphyadd": "2550 N HIGHWAY 1776",
    "dropphycty": "COYANOSA",
    "dropphyst": "TX",
    "dropphyzpp": 797309998,
    "dropmaladd": "2550 N HIGHWAY 1776",
    "dropmalcty": "COYANOSA",
    "dropmalst": "TX",
    "dropmalzpp": 797309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157757543,
    "dropsitcph": 4323432271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23371",
    "droptype": "D",
    "dropname": "CRANDALL",
    "dropdeladd": "123 S MAIN ST",
    "dropdelcty": "CRANDALL",
    "dropdelst": "TX",
    "dropdelzpp": 751149998,
    "dropphyadd": "123 S MAIN ST",
    "dropphycty": "CRANDALL",
    "dropphyst": "TX",
    "dropphyzpp": 751149998,
    "dropmaladd": "123 S MAIN ST",
    "dropmalcty": "CRANDALL",
    "dropmalst": "TX",
    "dropmalzpp": 751149998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9724273825,
    "dropsitcph": 9724273825,
    "dropfax": 9724273825
  },
  {
    "dcode": "D",
    "dropkey": "PW23372",
    "droptype": "D",
    "dropname": "CRANE",
    "dropdeladd": "509 S ALFORD ST",
    "dropdelcty": "CRANE",
    "dropdelst": "TX",
    "dropdelzpp": 797319998,
    "dropphyadd": "509 S ALFORD ST",
    "dropphycty": "CRANE",
    "dropphyst": "TX",
    "dropphyzpp": 797319998,
    "dropmaladd": "509 S ALFORD ST",
    "dropmalcty": "CRANE",
    "dropmalst": "TX",
    "dropmalzpp": 797319998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157757543,
    "dropsitcph": 4325583709,
    "dropfax": 9155583107
  },
  {
    "dcode": "D",
    "dropkey": "PW23373",
    "droptype": "D",
    "dropname": "CRANFILLS GAP",
    "dropdeladd": "608 BRONSTAD ST",
    "dropdelcty": "CRANFILLS GAP",
    "dropdelst": "TX",
    "dropdelzpp": 766374101,
    "dropphyadd": "608 BRONSTAD ST",
    "dropphycty": "CRANFILLS GAP",
    "dropphyst": "TX",
    "dropphyzpp": 766374101,
    "dropmaladd": "608 BRONSTAD ST",
    "dropmalcty": "CRANFILLS GAP",
    "dropmalst": "TX",
    "dropmalzpp": 766374101,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545970298,
    "dropsitcph": 2545970298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23374",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "6835 N LONE STAR PKWY",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "TX",
    "dropdelzpp": 766389998,
    "dropphyadd": "6835 N LONE STAR PKWY",
    "dropphycty": "CRAWFORD",
    "dropphyst": "TX",
    "dropphyzpp": 766389998,
    "dropmaladd": "6835 N LONE STAR PKWY",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "TX",
    "dropmalzpp": 766389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544862526,
    "dropsitcph": 2544862526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23379",
    "droptype": "D",
    "dropname": "CRESSON",
    "dropdeladd": "9300 PITTSBURG ST",
    "dropdelcty": "CRESSON",
    "dropdelst": "TX",
    "dropdelzpp": 760359998,
    "dropphyadd": "9300 PITTSBURG ST",
    "dropphycty": "CRESSON",
    "dropphyst": "TX",
    "dropphyzpp": 760359998,
    "dropmaladd": "9300 PITTSBURG ST",
    "dropmalcty": "CRESSON",
    "dropmalst": "TX",
    "dropmalzpp": 760359998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175123148,
    "dropsitcph": 8175123148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23383",
    "droptype": "D",
    "dropname": "CROCKETT",
    "dropdeladd": "600 E GOLIAD AVE",
    "dropdelcty": "CROCKETT",
    "dropdelst": "TX",
    "dropdelzpp": 758359998,
    "dropphyadd": "600 E GOLIAD AVE",
    "dropphycty": "CROCKETT",
    "dropphyst": "TX",
    "dropphyzpp": 758359998,
    "dropmaladd": "600 E GOLIAD AVE",
    "dropmalcty": "CROCKETT",
    "dropmalst": "TX",
    "dropmalzpp": 758359998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365443254,
    "dropsitcph": 9365443254,
    "dropfax": 9365462402
  },
  {
    "dcode": "D",
    "dropkey": "PW23384",
    "droptype": "D",
    "dropname": "CROSBY",
    "dropdeladd": "133 HARE RD",
    "dropdelcty": "CROSBY",
    "dropdelst": "TX",
    "dropdelzpp": 775329998,
    "dropphyadd": "133 HARE RD",
    "dropphycty": "CROSBY",
    "dropphyst": "TX",
    "dropphyzpp": 775329998,
    "dropmaladd": "133 HARE RD",
    "dropmalcty": "CROSBY",
    "dropmalst": "TX",
    "dropmalzpp": 775329998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814622392,
    "dropsitcph": 2814628429,
    "dropfax": 2813284315
  },
  {
    "dcode": "D",
    "dropkey": "PW23385",
    "droptype": "D",
    "dropname": "CROSBYTON",
    "dropdeladd": "110 N BERKSHIRE ST",
    "dropdelcty": "CROSBYTON",
    "dropdelst": "TX",
    "dropdelzpp": 793222224,
    "dropphyadd": "110 N BERKSHIRE ST",
    "dropphycty": "CROSBYTON",
    "dropphyst": "TX",
    "dropphyzpp": 793222224,
    "dropmaladd": "110 N BERKSHIRE ST",
    "dropmalcty": "CROSBYTON",
    "dropmalst": "TX",
    "dropmalzpp": 793222224,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066752848,
    "dropsitcph": 8066752848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23386",
    "droptype": "D",
    "dropname": "CROSS PLAINS",
    "dropdeladd": "101 N AVENUE D",
    "dropdelcty": "CROSS PLAINS",
    "dropdelst": "TX",
    "dropdelzpp": 764439803,
    "dropphyadd": "101 N AVENUE D",
    "dropphycty": "CROSS PLAINS",
    "dropphyst": "TX",
    "dropphyzpp": 764439803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS PLAINS",
    "dropmalst": "TX",
    "dropmalzpp": 764439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547257261,
    "dropsitcph": 2547257261,
    "dropfax": 2547256326
  },
  {
    "dcode": "D",
    "dropkey": "PW23391",
    "droptype": "D",
    "dropname": "CROWELL",
    "dropdeladd": "121 N MAIN ST",
    "dropdelcty": "CROWELL",
    "dropdelst": "TX",
    "dropdelzpp": 792279802,
    "dropphyadd": "121 N MAIN ST",
    "dropphycty": "CROWELL",
    "dropphyst": "TX",
    "dropphyzpp": 792279802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWELL",
    "dropmalst": "TX",
    "dropmalzpp": 792279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406841811,
    "dropsitcph": 9406841811,
    "dropfax": 9406841811
  },
  {
    "dcode": "D",
    "dropkey": "PW23392",
    "droptype": "D",
    "dropname": "CROWLEY",
    "dropdeladd": "200 S CROWLEY RD",
    "dropdelcty": "CROWLEY",
    "dropdelst": "TX",
    "dropdelzpp": 760369998,
    "dropphyadd": "200 S CROWLEY RD",
    "dropphycty": "CROWLEY",
    "dropphyst": "TX",
    "dropphyzpp": 760369998,
    "dropmaladd": "200 S CROWLEY RD",
    "dropmalcty": "CROWLEY",
    "dropmalst": "TX",
    "dropmalzpp": 760369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172977135,
    "dropsitcph": 8172977584,
    "dropfax": 8172979204
  },
  {
    "dcode": "D",
    "dropkey": "PW23396",
    "droptype": "D",
    "dropname": "CRYSTAL CITY",
    "dropdeladd": "2277 N US HIGHWAY 83",
    "dropdelcty": "CRYSTAL CITY",
    "dropdelst": "TX",
    "dropdelzpp": 788399998,
    "dropphyadd": "2277 N US HIGHWAY 83",
    "dropphycty": "CRYSTAL CITY",
    "dropphyst": "TX",
    "dropphyzpp": 788399998,
    "dropmaladd": "2277 N US HIGHWAY 83",
    "dropmalcty": "CRYSTAL CITY",
    "dropmalst": "TX",
    "dropmalzpp": 788399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303743225,
    "dropsitcph": 8303743225,
    "dropfax": 8303749862
  },
  {
    "dcode": "D",
    "dropkey": "PW23397",
    "droptype": "D",
    "dropname": "CUERO",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "CUERO",
    "dropdelst": "TX",
    "dropdelzpp": 779549998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "CUERO",
    "dropphyst": "TX",
    "dropphyzpp": 779549998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "CUERO",
    "dropmalst": "TX",
    "dropmalzpp": 779549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612755323,
    "dropsitcph": 3612755323,
    "dropfax": 3612756586
  },
  {
    "dcode": "D",
    "dropkey": "PW23399",
    "droptype": "D",
    "dropname": "CUMBY",
    "dropdeladd": "200 DEPOT ST",
    "dropdelcty": "CUMBY",
    "dropdelst": "TX",
    "dropdelzpp": 754339998,
    "dropphyadd": "200 DEPOT ST",
    "dropphycty": "CUMBY",
    "dropphyst": "TX",
    "dropphyzpp": 754339998,
    "dropmaladd": "200 DEPOT ST",
    "dropmalcty": "CUMBY",
    "dropmalst": "TX",
    "dropmalzpp": 754339998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032240043,
    "dropsitcph": 9032240043,
    "dropfax": 9039942217
  },
  {
    "dcode": "D",
    "dropkey": "PW23400",
    "droptype": "D",
    "dropname": "CUNEY",
    "dropdeladd": "9455 US HIGHWAY 175 W",
    "dropdelcty": "CUNEY",
    "dropdelst": "TX",
    "dropdelzpp": 757599998,
    "dropphyadd": "9455 US HIGHWAY 175 W",
    "dropphycty": "CUNEY",
    "dropphyst": "TX",
    "dropphyzpp": 757599998,
    "dropmaladd": "9455 US HIGHWAY 175 W",
    "dropmalcty": "CUNEY",
    "dropmalst": "TX",
    "dropmalzpp": 757599998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038764180,
    "dropsitcph": 9038764180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23401",
    "droptype": "D",
    "dropname": "CUNNINGHAM",
    "dropdeladd": "12810 FM 196",
    "dropdelcty": "CUNNINGHAM",
    "dropdelst": "TX",
    "dropdelzpp": 754349998,
    "dropphyadd": "12810 FM 196",
    "dropphycty": "CUNNINGHAM",
    "dropphyst": "TX",
    "dropphyzpp": 754349998,
    "dropmaladd": "12810 FM 196",
    "dropmalcty": "CUNNINGHAM",
    "dropmalst": "TX",
    "dropmalzpp": 754349998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036524117,
    "dropsitcph": 9036524117,
    "dropfax": 9036524117
  },
  {
    "dcode": "D",
    "dropkey": "PW23405",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "602 7TH ST",
    "dropdelcty": "CUSHING",
    "dropdelst": "TX",
    "dropdelzpp": 757609998,
    "dropphyadd": "602 7TH ST",
    "dropphycty": "CUSHING",
    "dropphyst": "TX",
    "dropphyzpp": 757609998,
    "dropmaladd": "602 7TH ST",
    "dropmalcty": "CUSHING",
    "dropmalst": "TX",
    "dropmalzpp": 757609998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9363264662,
    "dropsitcph": 9363264662,
    "dropfax": 9363265174
  },
  {
    "dcode": "D",
    "dropkey": "PW23411",
    "droptype": "D",
    "dropname": "CYPRESS",
    "dropdeladd": "16635 SPRING CYPRESS RD",
    "dropdelcty": "CYPRESS",
    "dropdelst": "TX",
    "dropdelzpp": 774299998,
    "dropphyadd": "16635 SPRING CYPRESS RD",
    "dropphycty": "CYPRESS",
    "dropphyst": "TX",
    "dropphyzpp": 774299998,
    "dropmaladd": "16635 SPRING CYPRESS RD",
    "dropmalcty": "CYPRESS",
    "dropmalst": "TX",
    "dropmalzpp": 774299998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813733372,
    "dropsitcph": 2813739125,
    "dropfax": 2813739845
  },
  {
    "dcode": "D",
    "dropkey": "PW23415",
    "droptype": "D",
    "dropname": "D HANIS",
    "dropdeladd": "7370 COUNTY ROAD 525",
    "dropdelcty": "D HANIS",
    "dropdelst": "TX",
    "dropdelzpp": 788509998,
    "dropphyadd": "7370 COUNTY ROAD 525",
    "dropphycty": "D HANIS",
    "dropphyst": "TX",
    "dropphyzpp": 788509998,
    "dropmaladd": "7370 COUNTY ROAD 525",
    "dropmalcty": "D HANIS",
    "dropmalst": "TX",
    "dropmalzpp": 788509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303637424,
    "dropsitcph": 8303637424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23420",
    "droptype": "D",
    "dropname": "DAINGERFIELD",
    "dropdeladd": "214 W SCURRY ST",
    "dropdelcty": "DAINGERFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 756389998,
    "dropphyadd": "214 W SCURRY ST",
    "dropphycty": "DAINGERFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 756389998,
    "dropmaladd": "214 W SCURRY ST",
    "dropmalcty": "DAINGERFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 756389998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036452076,
    "dropsitcph": 9036452076,
    "dropfax": 9036457034
  },
  {
    "dcode": "D",
    "dropkey": "PW23421",
    "droptype": "D",
    "dropname": "DAISETTA",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "DAISETTA",
    "dropdelst": "TX",
    "dropdelzpp": 775339700,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "DAISETTA",
    "dropphyst": "TX",
    "dropphyzpp": 775339700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAISETTA",
    "dropmalst": "TX",
    "dropmalzpp": 775339998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365366000,
    "dropsitcph": 9365366000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23423",
    "droptype": "D",
    "dropname": "DALE",
    "dropdeladd": "1383 FM 1854",
    "dropdelcty": "DALE",
    "dropdelst": "TX",
    "dropdelzpp": 786169998,
    "dropphyadd": "1383 FM 1854",
    "dropphycty": "DALE",
    "dropphyst": "TX",
    "dropphyzpp": 786169998,
    "dropmaladd": "1383 FM 1854",
    "dropmalcty": "DALE",
    "dropmalst": "TX",
    "dropmalzpp": 786169998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5127642242,
    "dropsitcph": 5127642242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23424",
    "droptype": "D",
    "dropname": "DALHART",
    "dropdeladd": "702 W 7TH ST",
    "dropdelcty": "DALHART",
    "dropdelst": "TX",
    "dropdelzpp": 790229998,
    "dropphyadd": "702 W 7TH ST",
    "dropphycty": "DALHART",
    "dropphyst": "TX",
    "dropphyzpp": 790229998,
    "dropmaladd": "702 W 7TH ST",
    "dropmalcty": "DALHART",
    "dropmalst": "TX",
    "dropmalzpp": 790229998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062494731,
    "dropsitcph": 8062494731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23425",
    "droptype": "D",
    "dropname": "DALLARDSVILLE",
    "dropdeladd": "9030 FM 1276",
    "dropdelcty": "DALLARDSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 773320015,
    "dropphyadd": "9030 FM 1276",
    "dropphycty": "DALLARDSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 773320015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALLARDSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 773329998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365632313,
    "dropsitcph": 9365632313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23428",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "401 TOM LANDRY HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752609998,
    "dropphyadd": "401 TOM LANDRY HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752609998,
    "dropmaladd": "401 TOM LANDRY HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752609998,
    "dropsitphn": 2149482879,
    "dropsitlph": 2147604585,
    "dropsitcph": 2147604555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23433",
    "droptype": "D",
    "dropname": "DAMON",
    "dropdeladd": "502 MULCAHY ST",
    "dropdelcty": "DAMON",
    "dropdelst": "TX",
    "dropdelzpp": 774309800,
    "dropphyadd": "502 MULCAHY ST",
    "dropphycty": "DAMON",
    "dropphyst": "TX",
    "dropphyzpp": 774309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAMON",
    "dropmalst": "TX",
    "dropmalzpp": 774309998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797423239,
    "dropsitcph": 9792053149,
    "dropfax": 9792053148
  },
  {
    "dcode": "D",
    "dropkey": "PW23434",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "6003 5TH ST",
    "dropdelcty": "DANBURY",
    "dropdelst": "TX",
    "dropdelzpp": 775349998,
    "dropphyadd": "6003 5TH ST",
    "dropphycty": "DANBURY",
    "dropphyst": "TX",
    "dropphyzpp": 775349998,
    "dropmaladd": "6003 5TH ST",
    "dropmalcty": "DANBURY",
    "dropmalst": "TX",
    "dropmalzpp": 775349998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9799221531,
    "dropsitcph": 9799221531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23436",
    "droptype": "D",
    "dropname": "DANEVANG",
    "dropdeladd": "11294 S STATE HIGHWAY 71",
    "dropdelcty": "DANEVANG",
    "dropdelst": "TX",
    "dropdelzpp": 774329800,
    "dropphyadd": "11294 S STATE HIGHWAY 71",
    "dropphycty": "DANEVANG",
    "dropphyst": "TX",
    "dropphyzpp": 774329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANEVANG",
    "dropmalst": "TX",
    "dropmalzpp": 774329998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795432137,
    "dropsitcph": 9795432137,
    "dropfax": 9795438927
  },
  {
    "dcode": "D",
    "dropkey": "PW23439",
    "droptype": "D",
    "dropname": "DARROUZETT",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "DARROUZETT",
    "dropdelst": "TX",
    "dropdelzpp": 790249800,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "DARROUZETT",
    "dropphyst": "TX",
    "dropphyzpp": 790249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARROUZETT",
    "dropmalst": "TX",
    "dropmalzpp": 790249998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066243161,
    "dropsitcph": 8066243161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23441",
    "droptype": "D",
    "dropname": "DAVILLA",
    "dropdeladd": "20905 N FM 487",
    "dropdelcty": "DAVILLA",
    "dropdelst": "TX",
    "dropdelzpp": 765239800,
    "dropphyadd": "20905 N FM 487",
    "dropphycty": "DAVILLA",
    "dropphyst": "TX",
    "dropphyzpp": 765239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVILLA",
    "dropmalst": "TX",
    "dropmalzpp": 765239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545274546,
    "dropsitcph": 2545274546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23445",
    "droptype": "D",
    "dropname": "DAWN",
    "dropdeladd": "101 FRYE AVE",
    "dropdelcty": "DAWN",
    "dropdelst": "TX",
    "dropdelzpp": 790259801,
    "dropphyadd": "101 FRYE AVE",
    "dropphycty": "DAWN",
    "dropphyst": "TX",
    "dropphyzpp": 790259801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWN",
    "dropmalst": "TX",
    "dropmalzpp": 790259998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062587384,
    "dropsitcph": 8062587384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23446",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "DAWSON",
    "dropdelst": "TX",
    "dropdelzpp": 766399998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "DAWSON",
    "dropphyst": "TX",
    "dropphyzpp": 766399998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "DAWSON",
    "dropmalst": "TX",
    "dropmalzpp": 766399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545781006,
    "dropsitcph": 2545781006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23447",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "110 S MAIN ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "TX",
    "dropdelzpp": 775359998,
    "dropphyadd": "110 S MAIN ST",
    "dropphycty": "DAYTON",
    "dropphyst": "TX",
    "dropphyzpp": 775359998,
    "dropmaladd": "110 S MAIN ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "TX",
    "dropmalzpp": 775359998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362585301,
    "dropsitcph": 9362585301,
    "dropfax": 9362586796
  },
  {
    "dcode": "D",
    "dropkey": "PW23448",
    "droptype": "D",
    "dropname": "DE BERRY",
    "dropdeladd": "7132 US HIGHWAY 79 N",
    "dropdelcty": "DE BERRY",
    "dropdelst": "TX",
    "dropdelzpp": 756399998,
    "dropphyadd": "7132 US HIGHWAY 79 N",
    "dropphycty": "DE BERRY",
    "dropphyst": "TX",
    "dropphyzpp": 756399998,
    "dropmaladd": "7132 US HIGHWAY 79 N",
    "dropmalcty": "DE BERRY",
    "dropmalst": "TX",
    "dropmalzpp": 756399998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037663496,
    "dropsitcph": 9037663496,
    "dropfax": 9037662619
  },
  {
    "dcode": "D",
    "dropkey": "PW23449",
    "droptype": "D",
    "dropname": "DE KALB",
    "dropdeladd": "312 W FRONT ST",
    "dropdelcty": "DE KALB",
    "dropdelst": "TX",
    "dropdelzpp": 755599998,
    "dropphyadd": "312 W FRONT ST",
    "dropphycty": "DE KALB",
    "dropphyst": "TX",
    "dropphyzpp": 755599998,
    "dropmaladd": "312 W FRONT ST",
    "dropmalcty": "DE KALB",
    "dropmalst": "TX",
    "dropmalzpp": 755599998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036672293,
    "dropsitcph": 9036672293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23450",
    "droptype": "D",
    "dropname": "DE LEON",
    "dropdeladd": "540 W NAVARRO AVE",
    "dropdelcty": "DE LEON",
    "dropdelst": "TX",
    "dropdelzpp": 764449998,
    "dropphyadd": "540 W NAVARRO AVE",
    "dropphycty": "DE LEON",
    "dropphyst": "TX",
    "dropphyzpp": 764449998,
    "dropmaladd": "540 W NAVARRO AVE",
    "dropmalcty": "DE LEON",
    "dropmalst": "TX",
    "dropmalzpp": 764449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548936160,
    "dropsitcph": 2548936160,
    "dropfax": 2548935637
  },
  {
    "dcode": "D",
    "dropkey": "PW23452",
    "droptype": "D",
    "dropname": "DESOTO",
    "dropdeladd": "229 S HAMPTON RD",
    "dropdelcty": "DESOTO",
    "dropdelst": "TX",
    "dropdelzpp": 751159998,
    "dropphyadd": "229 S HAMPTON RD",
    "dropphycty": "DESOTO",
    "dropphyst": "TX",
    "dropphyzpp": 751159998,
    "dropmaladd": "229 S HAMPTON RD",
    "dropmalcty": "DESOTO",
    "dropmalst": "TX",
    "dropmalzpp": 751159998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722231011,
    "dropsitcph": 9722231011,
    "dropfax": 9722234260
  },
  {
    "dcode": "D",
    "dropkey": "PW23453",
    "droptype": "D",
    "dropname": "DEANVILLE",
    "dropdeladd": "6625 FM 111",
    "dropdelcty": "DEANVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 778524500,
    "dropphyadd": "6625 FM 111",
    "dropphycty": "DEANVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 778524500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEANVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 778529998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795354286,
    "dropsitcph": 9795354286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23455",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "206 E WALNUT ST",
    "dropdelcty": "DECATUR",
    "dropdelst": "TX",
    "dropdelzpp": 762349998,
    "dropphyadd": "206 E WALNUT ST",
    "dropphycty": "DECATUR",
    "dropphyst": "TX",
    "dropphyzpp": 762349998,
    "dropmaladd": "206 E WALNUT ST",
    "dropmalcty": "DECATUR",
    "dropmalst": "TX",
    "dropmalzpp": 762349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406273541,
    "dropsitcph": 9406273541,
    "dropfax": 9406264853
  },
  {
    "dcode": "D",
    "dropkey": "PW23457",
    "droptype": "D",
    "dropname": "DEER PARK",
    "dropdeladd": "200 E SAN AUGUSTINE ST",
    "dropdelcty": "DEER PARK",
    "dropdelst": "TX",
    "dropdelzpp": 775369998,
    "dropphyadd": "200 E SAN AUGUSTINE ST",
    "dropphycty": "DEER PARK",
    "dropphyst": "TX",
    "dropphyzpp": 775369998,
    "dropmaladd": "200 E SAN AUGUSTINE ST",
    "dropmalcty": "DEER PARK",
    "dropmalst": "TX",
    "dropmalzpp": 775369998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814798421,
    "dropsitcph": 2814798416,
    "dropfax": 2814792862
  },
  {
    "dcode": "D",
    "dropkey": "PW23458",
    "droptype": "D",
    "dropname": "DEL RIO",
    "dropdeladd": "2001 N BEDELL AVE",
    "dropdelcty": "DEL RIO",
    "dropdelst": "TX",
    "dropdelzpp": 788409998,
    "dropphyadd": "2001 N BEDELL AVE",
    "dropphycty": "DEL RIO",
    "dropphyst": "TX",
    "dropphyzpp": 788409998,
    "dropmaladd": "2001 N BEDELL AVE",
    "dropmalcty": "DEL RIO",
    "dropmalst": "TX",
    "dropmalzpp": 788409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307753571,
    "dropsitcph": 8307753571,
    "dropfax": 8307757522
  },
  {
    "dcode": "D",
    "dropkey": "PW23459",
    "droptype": "D",
    "dropname": "DEL VALLE",
    "dropdeladd": "2883 HIGHWAY 71 E",
    "dropdelcty": "DEL VALLE",
    "dropdelst": "TX",
    "dropdelzpp": 786179998,
    "dropphyadd": "2883 HIGHWAY 71 E",
    "dropphycty": "DEL VALLE",
    "dropphyst": "TX",
    "dropphyzpp": 786179998,
    "dropmaladd": "2883 HIGHWAY 71 E",
    "dropmalcty": "DEL VALLE",
    "dropmalst": "TX",
    "dropmalzpp": 786179998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123857902,
    "dropsitcph": 5123857902,
    "dropfax": 5123850566
  },
  {
    "dcode": "D",
    "dropkey": "PW23462",
    "droptype": "D",
    "dropname": "DELL CITY",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "DELL CITY",
    "dropdelst": "TX",
    "dropdelzpp": 798379998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "DELL CITY",
    "dropphyst": "TX",
    "dropphyzpp": 798379998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "DELL CITY",
    "dropmalst": "TX",
    "dropmalzpp": 798379998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 9159642626,
    "dropfax": 9157807503
  },
  {
    "dcode": "D",
    "dropkey": "PW23463",
    "droptype": "D",
    "dropname": "DELMITA",
    "dropdeladd": "124 DELMITA RD",
    "dropdelcty": "DELMITA",
    "dropdelst": "TX",
    "dropdelzpp": 785369998,
    "dropphyadd": "124 DELMITA RD",
    "dropphycty": "DELMITA",
    "dropphyst": "TX",
    "dropphyzpp": 785369998,
    "dropmaladd": "124 DELMITA RD",
    "dropmalcty": "DELMITA",
    "dropmalst": "TX",
    "dropmalzpp": 785369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564813629,
    "dropsitcph": 9564813629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23465",
    "droptype": "D",
    "dropname": "DENISON",
    "dropdeladd": "231 W WOODARD ST",
    "dropdelcty": "DENISON",
    "dropdelst": "TX",
    "dropdelzpp": 750209998,
    "dropphyadd": "231 W WOODARD ST",
    "dropphycty": "DENISON",
    "dropphyst": "TX",
    "dropphyzpp": 750209998,
    "dropmaladd": "231 W WOODARD ST",
    "dropmalcty": "DENISON",
    "dropmalst": "TX",
    "dropmalzpp": 750209998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034651464,
    "dropsitcph": 9034651464,
    "dropfax": 9034652294
  },
  {
    "dcode": "D",
    "dropkey": "PW23467",
    "droptype": "D",
    "dropname": "DENNIS",
    "dropdeladd": "6940 FM 1189",
    "dropdelcty": "DENNIS",
    "dropdelst": "TX",
    "dropdelzpp": 764399998,
    "dropphyadd": "6940 FM 1189",
    "dropphycty": "DENNIS",
    "dropphyst": "TX",
    "dropphyzpp": 764399998,
    "dropmaladd": "6940 FM 1189",
    "dropmalcty": "DENNIS",
    "dropmalst": "TX",
    "dropmalzpp": 764399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175945064,
    "dropsitcph": 8175945064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23470",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "101 E MCKINNEY ST",
    "dropdelcty": "DENTON",
    "dropdelst": "TX",
    "dropdelzpp": 762014255,
    "dropphyadd": "101 E MCKINNEY ST",
    "dropphycty": "DENTON",
    "dropphyst": "TX",
    "dropphyzpp": 762014255,
    "dropmaladd": "101 E MCKINNEY ST",
    "dropmalcty": "DENTON",
    "dropmalst": "TX",
    "dropmalzpp": 762014255,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403878555,
    "dropsitcph": 9403878555,
    "dropfax": 9408910032
  },
  {
    "dcode": "D",
    "dropkey": "PW23471",
    "droptype": "D",
    "dropname": "DENVER CITY",
    "dropdeladd": "107 E 4TH ST",
    "dropdelcty": "DENVER CITY",
    "dropdelst": "TX",
    "dropdelzpp": 793239998,
    "dropphyadd": "107 E 4TH ST",
    "dropphycty": "DENVER CITY",
    "dropphyst": "TX",
    "dropphyzpp": 793239998,
    "dropmaladd": "107 E 4TH ST",
    "dropmalcty": "DENVER CITY",
    "dropmalst": "TX",
    "dropmalzpp": 793239998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065096002,
    "dropsitcph": 8065096002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23473",
    "droptype": "D",
    "dropname": "DEPORT",
    "dropdeladd": "141 MONROE ST",
    "dropdelcty": "DEPORT",
    "dropdelst": "TX",
    "dropdelzpp": 754359998,
    "dropphyadd": "141 MONROE ST",
    "dropphycty": "DEPORT",
    "dropphyst": "TX",
    "dropphyzpp": 754359998,
    "dropmaladd": "141 MONROE ST",
    "dropmalcty": "DEPORT",
    "dropmalst": "TX",
    "dropmalzpp": 754359998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036525935,
    "dropsitcph": 9036525935,
    "dropfax": 9036522019
  },
  {
    "dcode": "D",
    "dropkey": "PW23477",
    "droptype": "D",
    "dropname": "DESDEMONA",
    "dropdeladd": "6016 HIGHWAY 8",
    "dropdelcty": "DESDEMONA",
    "dropdelst": "TX",
    "dropdelzpp": 764459998,
    "dropphyadd": "6016 HIGHWAY 8",
    "dropphycty": "DESDEMONA",
    "dropphyst": "TX",
    "dropphyzpp": 764459998,
    "dropmaladd": "6016 HIGHWAY 8",
    "dropmalcty": "DESDEMONA",
    "dropmalst": "TX",
    "dropmalzpp": 764459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547582255,
    "dropsitcph": 2547582255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23481",
    "droptype": "D",
    "dropname": "DETROIT",
    "dropdeladd": "215 W GARNER ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "TX",
    "dropdelzpp": 754369998,
    "dropphyadd": "215 W GARNER ST",
    "dropphycty": "DETROIT",
    "dropphyst": "TX",
    "dropphyzpp": 754369998,
    "dropmaladd": "215 W GARNER ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "TX",
    "dropmalzpp": 754369998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036745131,
    "dropsitcph": 9036745131,
    "dropfax": 9036742342
  },
  {
    "dcode": "D",
    "dropkey": "PW23482",
    "droptype": "D",
    "dropname": "DEVERS",
    "dropdeladd": "102 S GATES ST",
    "dropdelcty": "DEVERS",
    "dropdelst": "TX",
    "dropdelzpp": 775389800,
    "dropphyadd": "102 S GATES ST",
    "dropphycty": "DEVERS",
    "dropphyst": "TX",
    "dropphyzpp": 775389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEVERS",
    "dropmalst": "TX",
    "dropmalzpp": 775389998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365497400,
    "dropsitcph": 9365497400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23483",
    "droptype": "D",
    "dropname": "DEVINE",
    "dropdeladd": "111 W COLLEGE AVE",
    "dropdelcty": "DEVINE",
    "dropdelst": "TX",
    "dropdelzpp": 780169998,
    "dropphyadd": "111 W COLLEGE AVE",
    "dropphycty": "DEVINE",
    "dropphyst": "TX",
    "dropphyzpp": 780169998,
    "dropmaladd": "111 W COLLEGE AVE",
    "dropmalcty": "DEVINE",
    "dropmalst": "TX",
    "dropmalzpp": 780169998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306633168,
    "dropsitcph": 8306633168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23487",
    "droptype": "D",
    "dropname": "DEWEYVILLE",
    "dropdeladd": "680 TX STATE HIGHWAY 272",
    "dropdelcty": "DEWEYVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 776140001,
    "dropphyadd": "680 TX STATE HIGHWAY 272",
    "dropphycty": "DEWEYVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 776140001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEWEYVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 776149998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097462093,
    "dropsitcph": 4097462093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23490",
    "droptype": "D",
    "dropname": "DIANA",
    "dropdeladd": "2218 US HIGHWAY 259 S",
    "dropdelcty": "DIANA",
    "dropdelst": "TX",
    "dropdelzpp": 756409998,
    "dropphyadd": "2218 US HIGHWAY 259 S",
    "dropphycty": "DIANA",
    "dropphyst": "TX",
    "dropphyzpp": 756409998,
    "dropmaladd": "2218 US HIGHWAY 259 S",
    "dropmalcty": "DIANA",
    "dropmalst": "TX",
    "dropmalzpp": 756409998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036630897,
    "dropsitcph": 9036630897,
    "dropfax": 9036636801
  },
  {
    "dcode": "D",
    "dropkey": "PW23491",
    "droptype": "D",
    "dropname": "DIBOLL",
    "dropdeladd": "302 N HENDRIX AVE",
    "dropdelcty": "DIBOLL",
    "dropdelst": "TX",
    "dropdelzpp": 759419998,
    "dropphyadd": "302 N HENDRIX AVE",
    "dropphycty": "DIBOLL",
    "dropphyst": "TX",
    "dropphyzpp": 759419998,
    "dropmaladd": "302 N HENDRIX AVE",
    "dropmalcty": "DIBOLL",
    "dropmalst": "TX",
    "dropmalzpp": 759419998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368295412,
    "dropsitcph": 9368295412,
    "dropfax": 9368292635
  },
  {
    "dcode": "D",
    "dropkey": "PW23492",
    "droptype": "D",
    "dropname": "DICKENS",
    "dropdeladd": "921 5TH ST",
    "dropdelcty": "DICKENS",
    "dropdelst": "TX",
    "dropdelzpp": 792299803,
    "dropphyadd": "921 5TH ST",
    "dropphycty": "DICKENS",
    "dropphyst": "TX",
    "dropphyzpp": 792299803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DICKENS",
    "dropmalst": "TX",
    "dropmalzpp": 792299998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066235562,
    "dropsitcph": 8066235562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23493",
    "droptype": "D",
    "dropname": "DICKINSON",
    "dropdeladd": "2515 TERMINI ST",
    "dropdelcty": "DICKINSON",
    "dropdelst": "TX",
    "dropdelzpp": 775399998,
    "dropphyadd": "2515 TERMINI ST",
    "dropphycty": "DICKINSON",
    "dropphyst": "TX",
    "dropphyzpp": 775399998,
    "dropmaladd": "2515 TERMINI ST",
    "dropmalcty": "DICKINSON",
    "dropmalst": "TX",
    "dropmalzpp": 775399998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813377681,
    "dropsitcph": 2815343974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23495",
    "droptype": "D",
    "dropname": "DIKE",
    "dropdeladd": "6938 FARM ROAD 69 N",
    "dropdelcty": "DIKE",
    "dropdelst": "TX",
    "dropdelzpp": 754379998,
    "dropphyadd": "6938 FARM ROAD 69 N",
    "dropphycty": "DIKE",
    "dropphyst": "TX",
    "dropphyzpp": 754379998,
    "dropmaladd": "6938 FARM ROAD 69 N",
    "dropmalcty": "DIKE",
    "dropmalst": "TX",
    "dropmalzpp": 754379998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039452454,
    "dropsitcph": 9039452454,
    "dropfax": 9039453479
  },
  {
    "dcode": "D",
    "dropkey": "PW23496",
    "droptype": "D",
    "dropname": "DILLEY",
    "dropdeladd": "102 E MILLER ST",
    "dropdelcty": "DILLEY",
    "dropdelst": "TX",
    "dropdelzpp": 780179998,
    "dropphyadd": "102 E MILLER ST",
    "dropphycty": "DILLEY",
    "dropphyst": "TX",
    "dropphyzpp": 780179998,
    "dropmaladd": "102 E MILLER ST",
    "dropmalcty": "DILLEY",
    "dropmalst": "TX",
    "dropmalzpp": 780179998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309651322,
    "dropsitcph": 8309651322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23498",
    "droptype": "D",
    "dropname": "DIME BOX",
    "dropdeladd": "1017 STEPHEN F AUSTIN BLVD",
    "dropdelcty": "DIME BOX",
    "dropdelst": "TX",
    "dropdelzpp": 778535366,
    "dropphyadd": "1017 STEPHEN F AUSTIN BLVD",
    "dropphycty": "DIME BOX",
    "dropphyst": "TX",
    "dropphyzpp": 778535366,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIME BOX",
    "dropmalst": "TX",
    "dropmalzpp": 778539998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798843681,
    "dropsitcph": 9798843681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23499",
    "droptype": "D",
    "dropname": "DIMMITT",
    "dropdeladd": "217 SE 2ND ST",
    "dropdelcty": "DIMMITT",
    "dropdelst": "TX",
    "dropdelzpp": 790279998,
    "dropphyadd": "217 SE 2ND ST",
    "dropphycty": "DIMMITT",
    "dropphyst": "TX",
    "dropphyzpp": 790279998,
    "dropmaladd": "217 SE 2ND ST",
    "dropmalcty": "DIMMITT",
    "dropmalst": "TX",
    "dropmalzpp": 790279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066475326,
    "dropsitcph": 8066475326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23505",
    "droptype": "D",
    "dropname": "DOBBIN",
    "dropdeladd": "26087 W HIGHWAY 105",
    "dropdelcty": "DOBBIN",
    "dropdelst": "TX",
    "dropdelzpp": 773330015,
    "dropphyadd": "26087 W HIGHWAY 105",
    "dropphycty": "DOBBIN",
    "dropphyst": "TX",
    "dropphyzpp": 773330015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOBBIN",
    "dropmalst": "TX",
    "dropmalzpp": 773339998,
    "dropsitphn": 7132263055,
    "dropsitlph": "",
    "dropsitcph": 9365960137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23506",
    "droptype": "D",
    "dropname": "DODD CITY",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "DODD CITY",
    "dropdelst": "TX",
    "dropdelzpp": 754389998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "DODD CITY",
    "dropphyst": "TX",
    "dropphyzpp": 754389998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "DODD CITY",
    "dropmalst": "TX",
    "dropmalzpp": 754389998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035835324,
    "dropsitcph": 9035835324,
    "dropfax": 9035835324
  },
  {
    "dcode": "D",
    "dropkey": "PW23507",
    "droptype": "D",
    "dropname": "DODGE",
    "dropdeladd": "174 FM 405",
    "dropdelcty": "DODGE",
    "dropdelst": "TX",
    "dropdelzpp": 773349800,
    "dropphyadd": "174 FM 405",
    "dropphycty": "DODGE",
    "dropphyst": "TX",
    "dropphyzpp": 773349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DODGE",
    "dropmalst": "TX",
    "dropmalzpp": 773349998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362913635,
    "dropsitcph": 9362913635,
    "dropfax": 9362913635
  },
  {
    "dcode": "D",
    "dropkey": "PW23513",
    "droptype": "D",
    "dropname": "DONIE",
    "dropdeladd": "236 MAIN ST",
    "dropdelcty": "DONIE",
    "dropdelst": "TX",
    "dropdelzpp": 758389998,
    "dropphyadd": "236 MAIN ST",
    "dropphycty": "DONIE",
    "dropphyst": "TX",
    "dropphyzpp": 758389998,
    "dropmaladd": "236 MAIN ST",
    "dropmalcty": "DONIE",
    "dropmalst": "TX",
    "dropmalzpp": 758389998,
    "dropsitphn": 2144675879,
    "dropsitlph": 2543594238,
    "dropsitcph": 2543594238,
    "dropfax": 2543594238
  },
  {
    "dcode": "D",
    "dropkey": "PW23514",
    "droptype": "D",
    "dropname": "DONNA",
    "dropdeladd": "509 N SALINAS BLVD",
    "dropdelcty": "DONNA",
    "dropdelst": "TX",
    "dropdelzpp": 785379998,
    "dropphyadd": "509 N SALINAS BLVD",
    "dropphycty": "DONNA",
    "dropphyst": "TX",
    "dropphyzpp": 785379998,
    "dropmaladd": "509 N SALINAS BLVD",
    "dropmalcty": "DONNA",
    "dropmalst": "TX",
    "dropmalzpp": 785379998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564643443,
    "dropsitcph": 9564643443,
    "dropfax": 9564643443
  },
  {
    "dcode": "D",
    "dropkey": "PW23515",
    "droptype": "D",
    "dropname": "DOOLE",
    "dropdeladd": "6662 FM 503",
    "dropdelcty": "DOOLE",
    "dropdelst": "TX",
    "dropdelzpp": 768363000,
    "dropphyadd": "6662 FM 503",
    "dropphycty": "DOOLE",
    "dropphyst": "TX",
    "dropphyzpp": 768363000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOOLE",
    "dropmalst": "TX",
    "dropmalzpp": 768369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254835526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23517",
    "droptype": "D",
    "dropname": "DOSS",
    "dropdeladd": "14112 N RANCH ROAD 783",
    "dropdelcty": "DOSS",
    "dropdelst": "TX",
    "dropdelzpp": 786189998,
    "dropphyadd": "14112 N RANCH ROAD 783",
    "dropphycty": "DOSS",
    "dropphyst": "TX",
    "dropphyzpp": 786189998,
    "dropmaladd": "14112 N RANCH ROAD 783",
    "dropmalcty": "DOSS",
    "dropmalst": "TX",
    "dropmalzpp": 786189998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306692700,
    "dropsitcph": 8306692700,
    "dropfax": 8306692701
  },
  {
    "dcode": "D",
    "dropkey": "PW23522",
    "droptype": "D",
    "dropname": "DOUCETTE",
    "dropdeladd": "100 US HIGHWAY 69",
    "dropdelcty": "DOUCETTE",
    "dropdelst": "TX",
    "dropdelzpp": 759429998,
    "dropphyadd": "100 US HIGHWAY 69",
    "dropphycty": "DOUCETTE",
    "dropphyst": "TX",
    "dropphyzpp": 759429998,
    "dropmaladd": "100 US HIGHWAY 69",
    "dropmalcty": "DOUCETTE",
    "dropmalst": "TX",
    "dropmalzpp": 759429998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092832664,
    "dropsitcph": 4092832664,
    "dropfax": 4092832664
  },
  {
    "dcode": "D",
    "dropkey": "PW23523",
    "droptype": "D",
    "dropname": "DOUGHERTY",
    "dropdeladd": "611 TEXAS AVE",
    "dropdelcty": "DOUGHERTY",
    "dropdelst": "TX",
    "dropdelzpp": 792319800,
    "dropphyadd": "611 TEXAS AVE",
    "dropphycty": "DOUGHERTY",
    "dropphyst": "TX",
    "dropphyzpp": 792319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOUGHERTY",
    "dropmalst": "TX",
    "dropmalzpp": 792319998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069832628,
    "dropsitcph": 8069832628,
    "dropfax": 8069832493
  },
  {
    "dcode": "D",
    "dropkey": "PW23524",
    "droptype": "D",
    "dropname": "DOUGLASS",
    "dropdeladd": "15614 W STATE HIGHWAY 21",
    "dropdelcty": "DOUGLASS",
    "dropdelst": "TX",
    "dropdelzpp": 759439998,
    "dropphyadd": "15614 W STATE HIGHWAY 21",
    "dropphycty": "DOUGLASS",
    "dropphyst": "TX",
    "dropphyzpp": 759439998,
    "dropmaladd": "15614 W STATE HIGHWAY 21",
    "dropmalcty": "DOUGLASS",
    "dropmalst": "TX",
    "dropmalzpp": 759439998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365698178,
    "dropsitcph": 9365698178,
    "dropfax": 9365591252
  },
  {
    "dcode": "D",
    "dropkey": "PW23525",
    "droptype": "D",
    "dropname": "DOUGLASSVILLE",
    "dropdeladd": "105 W HIGHWAY 77",
    "dropdelcty": "DOUGLASSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 755609998,
    "dropphyadd": "105 W HIGHWAY 77",
    "dropphycty": "DOUGLASSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 755609998,
    "dropmaladd": "105 W HIGHWAY 77",
    "dropmalcty": "DOUGLASSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 755609998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038464681,
    "dropsitcph": 9038464681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23552",
    "droptype": "D",
    "dropname": "DRIFTWOOD",
    "dropdeladd": "100 ELDER HILL RD",
    "dropdelcty": "DRIFTWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 786199998,
    "dropphyadd": "100 ELDER HILL RD",
    "dropphycty": "DRIFTWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 786199998,
    "dropmaladd": "100 ELDER HILL RD",
    "dropmalcty": "DRIFTWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 786199998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128587847,
    "dropsitcph": 5128587847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23553",
    "droptype": "D",
    "dropname": "DRIPPING SPRINGS",
    "dropdeladd": "1450 W HIGHWAY 290",
    "dropdelcty": "DRIPPING SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 786209998,
    "dropphyadd": "1450 W HIGHWAY 290",
    "dropphycty": "DRIPPING SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 786209998,
    "dropmaladd": "1450 W HIGHWAY 290",
    "dropmalcty": "DRIPPING SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 786209998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128584651,
    "dropsitcph": 5128584651,
    "dropfax": 5128585622
  },
  {
    "dcode": "D",
    "dropkey": "PW23554",
    "droptype": "D",
    "dropname": "DRISCOLL",
    "dropdeladd": "201 W MAIN",
    "dropdelcty": "DRISCOLL",
    "dropdelst": "TX",
    "dropdelzpp": 783519800,
    "dropphyadd": "201 W MAIN",
    "dropphycty": "DRISCOLL",
    "dropphyst": "TX",
    "dropphyzpp": 783519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRISCOLL",
    "dropmalst": "TX",
    "dropmalzpp": 783519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613876734,
    "dropsitcph": 3613876753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23557",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "222 N PATRICK ST",
    "dropdelcty": "DUBLIN",
    "dropdelst": "TX",
    "dropdelzpp": 764469998,
    "dropphyadd": "222 N PATRICK ST",
    "dropphycty": "DUBLIN",
    "dropphyst": "TX",
    "dropphyzpp": 764469998,
    "dropmaladd": "222 N PATRICK ST",
    "dropmalcty": "DUBLIN",
    "dropmalst": "TX",
    "dropmalzpp": 764469998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2544547000,
    "dropsitcph": 2544547000,
    "dropfax": 2544547001
  },
  {
    "dcode": "D",
    "dropkey": "PW23560",
    "droptype": "D",
    "dropname": "DUMAS",
    "dropdeladd": "315 S BLISS AVE",
    "dropdelcty": "DUMAS",
    "dropdelst": "TX",
    "dropdelzpp": 790299998,
    "dropphyadd": "315 S BLISS AVE",
    "dropphycty": "DUMAS",
    "dropphyst": "TX",
    "dropphyzpp": 790299998,
    "dropmaladd": "315 S BLISS AVE",
    "dropmalcty": "DUMAS",
    "dropmalst": "TX",
    "dropmalzpp": 790299998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069352219,
    "dropsitcph": 8069352219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23562",
    "droptype": "D",
    "dropname": "DUNCANVILLE",
    "dropdeladd": "711 S CEDAR RIDGE DR",
    "dropdelcty": "DUNCANVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 751379998,
    "dropphyadd": "711 S CEDAR RIDGE DR",
    "dropphycty": "DUNCANVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 751379998,
    "dropmaladd": "711 S CEDAR RIDGE DR",
    "dropmalcty": "DUNCANVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 751379998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9727801695,
    "dropsitcph": 9727801695,
    "dropfax": 9722838630
  },
  {
    "dcode": "D",
    "dropkey": "PW23571",
    "droptype": "D",
    "dropname": "EAGLE LAKE",
    "dropdeladd": "100 E MAIN ST STE 1",
    "dropdelcty": "EAGLE LAKE",
    "dropdelst": "TX",
    "dropdelzpp": 774349998,
    "dropphyadd": "100 E MAIN ST STE 1",
    "dropphycty": "EAGLE LAKE",
    "dropphyst": "TX",
    "dropphyzpp": 774349998,
    "dropmaladd": "100 E MAIN ST STE 1",
    "dropmalcty": "EAGLE LAKE",
    "dropmalst": "TX",
    "dropmalzpp": 774349998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792342627,
    "dropsitcph": 9792342627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23572",
    "droptype": "D",
    "dropname": "EAGLE PASS",
    "dropdeladd": "410 S BIBB AVE",
    "dropdelcty": "EAGLE PASS",
    "dropdelst": "TX",
    "dropdelzpp": 788529998,
    "dropphyadd": "410 S BIBB AVE",
    "dropphycty": "EAGLE PASS",
    "dropphyst": "TX",
    "dropphyzpp": 788529998,
    "dropmaladd": "410 S BIBB AVE",
    "dropmalcty": "EAGLE PASS",
    "dropmalst": "TX",
    "dropmalzpp": 788529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307733210,
    "dropsitcph": 8307733210,
    "dropfax": 8307737616
  },
  {
    "dcode": "D",
    "dropkey": "PW23574",
    "droptype": "D",
    "dropname": "EARTH",
    "dropdeladd": "105 N AMHERST RD",
    "dropdelcty": "EARTH",
    "dropdelst": "TX",
    "dropdelzpp": 790319803,
    "dropphyadd": "105 N AMHERST RD",
    "dropphycty": "EARTH",
    "dropphyst": "TX",
    "dropphyzpp": 790319803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARTH",
    "dropmalst": "TX",
    "dropmalzpp": 790319998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062573322,
    "dropsitcph": 8062573322,
    "dropfax": 8062573962
  },
  {
    "dcode": "D",
    "dropkey": "PW23577",
    "droptype": "D",
    "dropname": "EAST BERNARD",
    "dropdeladd": "703 CHURCH ST",
    "dropdelcty": "EAST BERNARD",
    "dropdelst": "TX",
    "dropdelzpp": 774359998,
    "dropphyadd": "703 CHURCH ST",
    "dropphycty": "EAST BERNARD",
    "dropphyst": "TX",
    "dropphyzpp": 774359998,
    "dropmaladd": "703 CHURCH ST",
    "dropmalcty": "EAST BERNARD",
    "dropmalst": "TX",
    "dropmalzpp": 774359998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9793354235,
    "dropsitcph": 9793354235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23590",
    "droptype": "D",
    "dropname": "EASTLAND",
    "dropdeladd": "411 W MAIN ST",
    "dropdelcty": "EASTLAND",
    "dropdelst": "TX",
    "dropdelzpp": 764489998,
    "dropphyadd": "411 W MAIN ST",
    "dropphycty": "EASTLAND",
    "dropphyst": "TX",
    "dropphyzpp": 764489998,
    "dropmaladd": "411 W MAIN ST",
    "dropmalcty": "EASTLAND",
    "dropmalst": "TX",
    "dropmalzpp": 764489998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546292383,
    "dropsitcph": 2546292383,
    "dropfax": 2546292383
  },
  {
    "dcode": "D",
    "dropkey": "PW23598",
    "droptype": "D",
    "dropname": "ECTOR",
    "dropdeladd": "106 E SAM RAYBURN RD",
    "dropdelcty": "ECTOR",
    "dropdelst": "TX",
    "dropdelzpp": 754399998,
    "dropphyadd": "106 E SAM RAYBURN RD",
    "dropphycty": "ECTOR",
    "dropphyst": "TX",
    "dropphyzpp": 754399998,
    "dropmaladd": "106 E SAM RAYBURN RD",
    "dropmalcty": "ECTOR",
    "dropmalst": "TX",
    "dropmalzpp": 754399998,
    "dropsitphn": 9039614635,
    "dropsitlph": 9039614635,
    "dropsitcph": 9039614635,
    "dropfax": 9039610042
  },
  {
    "dcode": "D",
    "dropkey": "PW23600",
    "droptype": "D",
    "dropname": "EDCOUCH",
    "dropdeladd": "420 W SANTA ROSA AVE",
    "dropdelcty": "EDCOUCH",
    "dropdelst": "TX",
    "dropdelzpp": 785389998,
    "dropphyadd": "420 W SANTA ROSA AVE",
    "dropphycty": "EDCOUCH",
    "dropphyst": "TX",
    "dropphyzpp": 785389998,
    "dropmaladd": "420 W SANTA ROSA AVE",
    "dropmalcty": "EDCOUCH",
    "dropmalst": "TX",
    "dropmalzpp": 785389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562621261,
    "dropsitcph": 9562621261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23601",
    "droptype": "D",
    "dropname": "EDDY",
    "dropdeladd": "100 FRANKLIN RD",
    "dropdelcty": "EDDY",
    "dropdelst": "TX",
    "dropdelzpp": 765249998,
    "dropphyadd": "100 FRANKLIN RD",
    "dropphycty": "EDDY",
    "dropphyst": "TX",
    "dropphyzpp": 765249998,
    "dropmaladd": "100 FRANKLIN RD",
    "dropmalcty": "EDDY",
    "dropmalst": "TX",
    "dropmalzpp": 765249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548595301,
    "dropsitcph": 2548595301,
    "dropfax": 2548593958
  },
  {
    "dcode": "D",
    "dropkey": "PW23602",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "100 W BROADWAY ST",
    "dropdelcty": "EDEN",
    "dropdelst": "TX",
    "dropdelzpp": 768379998,
    "dropphyadd": "100 W BROADWAY ST",
    "dropphycty": "EDEN",
    "dropphyst": "TX",
    "dropphyzpp": 768379998,
    "dropmaladd": "100 W BROADWAY ST",
    "dropmalcty": "EDEN",
    "dropmalst": "TX",
    "dropmalzpp": 768379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3258693121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23606",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "EDGEWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 751179998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "EDGEWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 751179998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "EDGEWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 751179998,
    "dropsitphn": 9038966070,
    "dropsitlph": 9032240518,
    "dropsitcph": 9032240518,
    "dropfax": 9038966077
  },
  {
    "dcode": "D",
    "dropkey": "PW23608",
    "droptype": "D",
    "dropname": "EDINBURG",
    "dropdeladd": "410 S JACKSON RD",
    "dropdelcty": "EDINBURG",
    "dropdelst": "TX",
    "dropdelzpp": 785399998,
    "dropphyadd": "410 S JACKSON RD",
    "dropphycty": "EDINBURG",
    "dropphyst": "TX",
    "dropphyzpp": 785399998,
    "dropmaladd": "410 S JACKSON RD",
    "dropmalcty": "EDINBURG",
    "dropmalst": "TX",
    "dropmalzpp": 785399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563833866,
    "dropsitcph": 9563833866,
    "dropfax": 9563832055
  },
  {
    "dcode": "D",
    "dropkey": "PW23609",
    "droptype": "D",
    "dropname": "EDMONSON",
    "dropdeladd": "100 E 1ST ST",
    "dropdelcty": "EDMONSON",
    "dropdelst": "TX",
    "dropdelzpp": 790329800,
    "dropphyadd": "100 E 1ST ST",
    "dropphycty": "EDMONSON",
    "dropphyst": "TX",
    "dropphyzpp": 790329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDMONSON",
    "dropmalst": "TX",
    "dropmalzpp": 790329998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066843449,
    "dropsitcph": 8068643449,
    "dropfax": 8068643712
  },
  {
    "dcode": "D",
    "dropkey": "PW23610",
    "droptype": "D",
    "dropname": "EDNA",
    "dropdeladd": "603 ROSE ST",
    "dropdelcty": "EDNA",
    "dropdelst": "TX",
    "dropdelzpp": 779579998,
    "dropphyadd": "603 ROSE ST",
    "dropphycty": "EDNA",
    "dropphyst": "TX",
    "dropphyzpp": 779579998,
    "dropmaladd": "603 ROSE ST",
    "dropmalcty": "EDNA",
    "dropmalst": "TX",
    "dropmalzpp": 779579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617822160,
    "dropsitcph": 3617822160,
    "dropfax": 3617827144
  },
  {
    "dcode": "D",
    "dropkey": "PW23612",
    "droptype": "D",
    "dropname": "EDROY",
    "dropdeladd": "17916 HIGHWAY 234",
    "dropdelcty": "EDROY",
    "dropdelst": "TX",
    "dropdelzpp": 783529800,
    "dropphyadd": "17916 HIGHWAY 234",
    "dropphycty": "EDROY",
    "dropphyst": "TX",
    "dropphyzpp": 783529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDROY",
    "dropmalst": "TX",
    "dropmalzpp": 783529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613689123,
    "dropsitcph": 3613689123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23613",
    "droptype": "D",
    "dropname": "EGYPT",
    "dropdeladd": "10718 FM 1161 W",
    "dropdelcty": "EGYPT",
    "dropdelst": "TX",
    "dropdelzpp": 774360001,
    "dropphyadd": "10718 FM 1161 W",
    "dropphycty": "EGYPT",
    "dropphyst": "TX",
    "dropphyzpp": 774360001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EGYPT",
    "dropmalst": "TX",
    "dropmalzpp": 774369998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796773577,
    "dropsitcph": 9796773577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23614",
    "droptype": "D",
    "dropname": "EL CAMPO",
    "dropdeladd": "110 S MECHANIC ST",
    "dropdelcty": "EL CAMPO",
    "dropdelst": "TX",
    "dropdelzpp": 774379998,
    "dropphyadd": "110 S MECHANIC ST",
    "dropphycty": "EL CAMPO",
    "dropphyst": "TX",
    "dropphyzpp": 774379998,
    "dropmaladd": "110 S MECHANIC ST",
    "dropmalcty": "EL CAMPO",
    "dropmalst": "TX",
    "dropmalzpp": 774379998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795432581,
    "dropsitcph": 9795432581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23619",
    "droptype": "D",
    "dropname": "EL INDIO",
    "dropdeladd": "18496 FM 1021",
    "dropdelcty": "EL INDIO",
    "dropdelst": "TX",
    "dropdelzpp": 788609800,
    "dropphyadd": "18496 FM 1021",
    "dropphycty": "EL INDIO",
    "dropphyst": "TX",
    "dropphyzpp": 788609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EL INDIO",
    "dropmalst": "TX",
    "dropmalzpp": 788609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307576904,
    "dropsitcph": 8307576904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23624",
    "droptype": "D",
    "dropname": "EL PASO",
    "dropdeladd": "8401 BOEING DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799109998,
    "dropphyadd": "8401 BOEING DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799109998,
    "dropmaladd": "8401 BOEING DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807595,
    "dropsitcph": 9157807525,
    "dropfax": 9157807503
  },
  {
    "dcode": "D",
    "dropkey": "PW23632",
    "droptype": "D",
    "dropname": "ELDORADO",
    "dropdeladd": "100 COTTONWOOD",
    "dropdelcty": "ELDORADO",
    "dropdelst": "TX",
    "dropdelzpp": 769369800,
    "dropphyadd": "100 COTTONWOOD",
    "dropphycty": "ELDORADO",
    "dropphyst": "TX",
    "dropphyzpp": 769369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELDORADO",
    "dropmalst": "TX",
    "dropmalzpp": 769369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258532655,
    "dropsitcph": 3258532655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23633",
    "droptype": "D",
    "dropname": "ELECTRA",
    "dropdeladd": "200 W CLEVELAND AVE",
    "dropdelcty": "ELECTRA",
    "dropdelst": "TX",
    "dropdelzpp": 763609998,
    "dropphyadd": "200 W CLEVELAND AVE",
    "dropphycty": "ELECTRA",
    "dropphyst": "TX",
    "dropphyzpp": 763609998,
    "dropmaladd": "200 W CLEVELAND AVE",
    "dropmalcty": "ELECTRA",
    "dropmalst": "TX",
    "dropmalzpp": 763609998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403090017,
    "dropsitcph": 9403090017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23636",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "21 N AVENUE C",
    "dropdelcty": "ELGIN",
    "dropdelst": "TX",
    "dropdelzpp": 786219998,
    "dropphyadd": "21 N AVENUE C",
    "dropphycty": "ELGIN",
    "dropphyst": "TX",
    "dropphyzpp": 786219998,
    "dropmaladd": "21 N AVENUE C",
    "dropmalcty": "ELGIN",
    "dropmalst": "TX",
    "dropmalzpp": 786219998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122813978,
    "dropsitcph": 5122853189,
    "dropfax": 5122853201
  },
  {
    "dcode": "D",
    "dropkey": "PW23640",
    "droptype": "D",
    "dropname": "ELKHART",
    "dropdeladd": "100 SHERIDAN ST",
    "dropdelcty": "ELKHART",
    "dropdelst": "TX",
    "dropdelzpp": 758399998,
    "dropphyadd": "100 SHERIDAN ST",
    "dropphycty": "ELKHART",
    "dropphyst": "TX",
    "dropphyzpp": 758399998,
    "dropmaladd": "100 SHERIDAN ST",
    "dropmalcty": "ELKHART",
    "dropmalst": "TX",
    "dropmalzpp": 758399998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037642202,
    "dropsitcph": 9037642202,
    "dropfax": 9037642202
  },
  {
    "dcode": "D",
    "dropkey": "PW23641",
    "droptype": "D",
    "dropname": "ELLINGER",
    "dropdeladd": "706 FM 2503",
    "dropdelcty": "ELLINGER",
    "dropdelst": "TX",
    "dropdelzpp": 789389998,
    "dropphyadd": "706 FM 2503",
    "dropphycty": "ELLINGER",
    "dropphyst": "TX",
    "dropphyzpp": 789389998,
    "dropmaladd": "706 FM 2503",
    "dropmalcty": "ELLINGER",
    "dropmalst": "TX",
    "dropmalzpp": 789389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9793782304,
    "dropsitcph": 9793782304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23644",
    "droptype": "D",
    "dropname": "ELM MOTT",
    "dropdeladd": "252 W ELM MOTT DR",
    "dropdelcty": "ELM MOTT",
    "dropdelst": "TX",
    "dropdelzpp": 766409998,
    "dropphyadd": "252 W ELM MOTT DR",
    "dropphycty": "ELM MOTT",
    "dropphyst": "TX",
    "dropphyzpp": 766409998,
    "dropmaladd": "252 W ELM MOTT DR",
    "dropmalcty": "ELM MOTT",
    "dropmalst": "TX",
    "dropmalzpp": 766409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548291979,
    "dropsitcph": 2548291979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23645",
    "droptype": "D",
    "dropname": "ELMATON",
    "dropdeladd": "10430 HIGHWAY 35",
    "dropdelcty": "ELMATON",
    "dropdelst": "TX",
    "dropdelzpp": 774400077,
    "dropphyadd": "10430 HIGHWAY 35",
    "dropphycty": "ELMATON",
    "dropphyst": "TX",
    "dropphyzpp": 774400077,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMATON",
    "dropmalst": "TX",
    "dropmalzpp": 774409998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3615887275,
    "dropsitcph": 3615887275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23646",
    "droptype": "D",
    "dropname": "ELMENDORF",
    "dropdeladd": "8302 FM 327",
    "dropdelcty": "ELMENDORF",
    "dropdelst": "TX",
    "dropdelzpp": 781129998,
    "dropphyadd": "8302 FM 327",
    "dropphycty": "ELMENDORF",
    "dropphyst": "TX",
    "dropphyzpp": 781129998,
    "dropmaladd": "8302 FM 327",
    "dropmalcty": "ELMENDORF",
    "dropmalst": "TX",
    "dropmalzpp": 781129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106357069,
    "dropsitcph": 2106359258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23647",
    "droptype": "D",
    "dropname": "ELMO",
    "dropdeladd": "10482 COUNTY ROAD 376",
    "dropdelcty": "ELMO",
    "dropdelst": "TX",
    "dropdelzpp": 751189998,
    "dropphyadd": "10482 COUNTY ROAD 376",
    "dropphycty": "ELMO",
    "dropphyst": "TX",
    "dropphyzpp": 751189998,
    "dropmaladd": "10482 COUNTY ROAD 376",
    "dropmalcty": "ELMO",
    "dropmalst": "TX",
    "dropmalzpp": 751189998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9725630251,
    "dropsitcph": 9725630251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23651",
    "droptype": "D",
    "dropname": "ELSA",
    "dropdeladd": "706 E EDINBURG AVE",
    "dropdelcty": "ELSA",
    "dropdelst": "TX",
    "dropdelzpp": 785439800,
    "dropphyadd": "706 E EDINBURG AVE",
    "dropphycty": "ELSA",
    "dropphyst": "TX",
    "dropphyzpp": 785439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELSA",
    "dropmalst": "TX",
    "dropmalzpp": 785439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562621611,
    "dropsitcph": 9562621611,
    "dropfax": 9562625638
  },
  {
    "dcode": "D",
    "dropkey": "PW23653",
    "droptype": "D",
    "dropname": "ELYSIAN FIELDS",
    "dropdeladd": "18154 FM 31",
    "dropdelcty": "ELYSIAN FIELDS",
    "dropdelst": "TX",
    "dropdelzpp": 756429998,
    "dropphyadd": "18154 FM 31",
    "dropphycty": "ELYSIAN FIELDS",
    "dropphyst": "TX",
    "dropphyzpp": 756429998,
    "dropmaladd": "18154 FM 31",
    "dropmalcty": "ELYSIAN FIELDS",
    "dropmalst": "TX",
    "dropmalzpp": 756429998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036332423,
    "dropsitcph": 9036332423,
    "dropfax": 9036332423
  },
  {
    "dcode": "D",
    "dropkey": "PW23658",
    "droptype": "D",
    "dropname": "EMORY",
    "dropdeladd": "934 N TEXAS ST",
    "dropdelcty": "EMORY",
    "dropdelst": "TX",
    "dropdelzpp": 754402462,
    "dropphyadd": "934 N TEXAS ST",
    "dropphycty": "EMORY",
    "dropphyst": "TX",
    "dropphyzpp": 754402462,
    "dropmaladd": "934 N TEXAS ST",
    "dropmalcty": "EMORY",
    "dropmalst": "TX",
    "dropmalzpp": 754402462,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034732267,
    "dropsitcph": 9034732267,
    "dropfax": 9034734315
  },
  {
    "dcode": "D",
    "dropkey": "PW23659",
    "droptype": "D",
    "dropname": "ENCINAL",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "ENCINAL",
    "dropdelst": "TX",
    "dropdelzpp": 780199800,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "ENCINAL",
    "dropphyst": "TX",
    "dropphyzpp": 780199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENCINAL",
    "dropmalst": "TX",
    "dropmalzpp": 780199998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569485206,
    "dropsitcph": 9569485206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23660",
    "droptype": "D",
    "dropname": "ENCINO",
    "dropdeladd": "291 S BUSINESS HIGHWAY 281",
    "dropdelcty": "ENCINO",
    "dropdelst": "TX",
    "dropdelzpp": 783539998,
    "dropphyadd": "291 S BUSINESS HIGHWAY 281",
    "dropphycty": "ENCINO",
    "dropphyst": "TX",
    "dropphyzpp": 783539998,
    "dropmaladd": "291 S BUSINESS HIGHWAY 281",
    "dropmalcty": "ENCINO",
    "dropmalst": "TX",
    "dropmalzpp": 783539998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615683330,
    "dropsitcph": 3615683330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23662",
    "droptype": "D",
    "dropname": "ENERGY",
    "dropdeladd": "6951 FM 1702 S",
    "dropdelcty": "ENERGY",
    "dropdelst": "TX",
    "dropdelzpp": 764529900,
    "dropphyadd": "6951 FM 1702 S",
    "dropphycty": "ENERGY",
    "dropphyst": "TX",
    "dropphyzpp": 764529900,
    "dropmaladd": "6951 FM 1702 S",
    "dropmalcty": "ENERGY",
    "dropmalst": "TX",
    "dropmalzpp": 764529900,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258852062,
    "dropsitcph": 3258852062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23665",
    "droptype": "D",
    "dropname": "ENLOE",
    "dropdeladd": "1884 FARM ROAD 2949 S",
    "dropdelcty": "ENLOE",
    "dropdelst": "TX",
    "dropdelzpp": 754419998,
    "dropphyadd": "1884 FARM ROAD 2949 S",
    "dropphycty": "ENLOE",
    "dropphyst": "TX",
    "dropphyzpp": 754419998,
    "dropmaladd": "1884 FARM ROAD 2949 S",
    "dropmalcty": "ENLOE",
    "dropmalst": "TX",
    "dropmalzpp": 754419998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033954851,
    "dropsitcph": 9033954851,
    "dropfax": 9033954851
  },
  {
    "dcode": "D",
    "dropkey": "PW23666",
    "droptype": "D",
    "dropname": "ENNIS",
    "dropdeladd": "205 N MCKINNEY ST",
    "dropdelcty": "ENNIS",
    "dropdelst": "TX",
    "dropdelzpp": 751199998,
    "dropphyadd": "205 N MCKINNEY ST",
    "dropphycty": "ENNIS",
    "dropphyst": "TX",
    "dropphyzpp": 751199998,
    "dropmaladd": "205 N MCKINNEY ST",
    "dropmalcty": "ENNIS",
    "dropmalst": "TX",
    "dropmalzpp": 751199998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9728756701,
    "dropsitcph": 9728756701,
    "dropfax": 9728785203
  },
  {
    "dcode": "D",
    "dropkey": "PW23668",
    "droptype": "D",
    "dropname": "ENOCHS",
    "dropdeladd": "3010 STATE HIGHWAY 214",
    "dropdelcty": "ENOCHS",
    "dropdelst": "TX",
    "dropdelzpp": 793243000,
    "dropphyadd": "3010 STATE HIGHWAY 214",
    "dropphycty": "ENOCHS",
    "dropphyst": "TX",
    "dropphyzpp": 793243000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENOCHS",
    "dropmalst": "TX",
    "dropmalzpp": 793249998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069275313,
    "dropsitcph": 8069275313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23670",
    "droptype": "D",
    "dropname": "EOLA",
    "dropdeladd": "12436 COUNTY ROAD 5502",
    "dropdelcty": "EOLA",
    "dropdelst": "TX",
    "dropdelzpp": 769373010,
    "dropphyadd": "12436 COUNTY ROAD 5502",
    "dropphycty": "EOLA",
    "dropphyst": "TX",
    "dropphyzpp": 769373010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EOLA",
    "dropmalst": "TX",
    "dropmalzpp": 769379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254693744,
    "dropsitcph": 3254693744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23671",
    "droptype": "D",
    "dropname": "ERA",
    "dropdeladd": "7210 W FM 922",
    "dropdelcty": "ERA",
    "dropdelst": "TX",
    "dropdelzpp": 762389998,
    "dropphyadd": "7210 W FM 922",
    "dropphycty": "ERA",
    "dropphyst": "TX",
    "dropphyzpp": 762389998,
    "dropmaladd": "7210 W FM 922",
    "dropmalcty": "ERA",
    "dropmalst": "TX",
    "dropmalzpp": 762389998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406659964,
    "dropsitcph": 9406659964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23675",
    "droptype": "D",
    "dropname": "ESTELLINE",
    "dropdeladd": "710 CLEVELAND ST",
    "dropdelcty": "ESTELLINE",
    "dropdelst": "TX",
    "dropdelzpp": 792339800,
    "dropphyadd": "710 CLEVELAND ST",
    "dropphycty": "ESTELLINE",
    "dropphyst": "TX",
    "dropphyzpp": 792339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESTELLINE",
    "dropmalst": "TX",
    "dropmalzpp": 792339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068881751,
    "dropsitcph": 8068881751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23677",
    "droptype": "D",
    "dropname": "ETOILE",
    "dropdeladd": "2506 STATE HIGHWAY 103 STE A",
    "dropdelcty": "ETOILE",
    "dropdelst": "TX",
    "dropdelzpp": 759449998,
    "dropphyadd": "2506 STATE HIGHWAY 103 STE A",
    "dropphycty": "ETOILE",
    "dropphyst": "TX",
    "dropphyzpp": 759449998,
    "dropmaladd": "2506 STATE HIGHWAY 103 STE A",
    "dropmalcty": "ETOILE",
    "dropmalst": "TX",
    "dropmalzpp": 759449998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368519136,
    "dropsitcph": 9368519136,
    "dropfax": 9368542193
  },
  {
    "dcode": "D",
    "dropkey": "PW23680",
    "droptype": "D",
    "dropname": "EULESS",
    "dropdeladd": "210 N ECTOR DR",
    "dropdelcty": "EULESS",
    "dropdelst": "TX",
    "dropdelzpp": 760393651,
    "dropphyadd": "210 N ECTOR DR",
    "dropphycty": "EULESS",
    "dropphyst": "TX",
    "dropphyzpp": 760393651,
    "dropmaladd": "210 N ECTOR DR",
    "dropmalcty": "EULESS",
    "dropmalst": "TX",
    "dropmalzpp": 760393651,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178680936,
    "dropsitcph": 8176840063,
    "dropfax": 8172836506
  },
  {
    "dcode": "D",
    "dropkey": "PW23682",
    "droptype": "D",
    "dropname": "EUSTACE",
    "dropdeladd": "202 US HIGHWAY 175 W",
    "dropdelcty": "EUSTACE",
    "dropdelst": "TX",
    "dropdelzpp": 751249998,
    "dropphyadd": "202 US HIGHWAY 175 W",
    "dropphycty": "EUSTACE",
    "dropphyst": "TX",
    "dropphyzpp": 751249998,
    "dropmaladd": "202 US HIGHWAY 175 W",
    "dropmalcty": "EUSTACE",
    "dropmalst": "TX",
    "dropmalzpp": 751249998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9034256421,
    "dropsitcph": 9034256421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23683",
    "droptype": "D",
    "dropname": "EVADALE",
    "dropdeladd": "225 FM 105",
    "dropdelcty": "EVADALE",
    "dropdelst": "TX",
    "dropdelzpp": 776150105,
    "dropphyadd": "225 FM 105",
    "dropphycty": "EVADALE",
    "dropphyst": "TX",
    "dropphyzpp": 776150105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVADALE",
    "dropmalst": "TX",
    "dropmalzpp": 776159998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092760003,
    "dropsitcph": 4092760005,
    "dropfax": 4092760004
  },
  {
    "dcode": "D",
    "dropkey": "PW23684",
    "droptype": "D",
    "dropname": "EVANT",
    "dropdeladd": "153 N US HIGHWAY 281",
    "dropdelcty": "EVANT",
    "dropdelst": "TX",
    "dropdelzpp": 765259998,
    "dropphyadd": "153 N US HIGHWAY 281",
    "dropphycty": "EVANT",
    "dropphyst": "TX",
    "dropphyzpp": 765259998,
    "dropmaladd": "153 N US HIGHWAY 281",
    "dropmalcty": "EVANT",
    "dropmalst": "TX",
    "dropmalzpp": 765259998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544715822,
    "dropsitcph": 2544715822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23692",
    "droptype": "D",
    "dropname": "FABENS",
    "dropdeladd": "605 W MAIN ST",
    "dropdelcty": "FABENS",
    "dropdelst": "TX",
    "dropdelzpp": 798389998,
    "dropphyadd": "605 W MAIN ST",
    "dropphycty": "FABENS",
    "dropphyst": "TX",
    "dropphyzpp": 798389998,
    "dropmaladd": "605 W MAIN ST",
    "dropmalcty": "FABENS",
    "dropmalst": "TX",
    "dropmalzpp": 798389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 9157643712,
    "dropfax": 9157645901
  },
  {
    "dcode": "D",
    "dropkey": "PW23699",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "320 E COMMERCE ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 758409998,
    "dropphyadd": "320 E COMMERCE ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 758409998,
    "dropmaladd": "320 E COMMERCE ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 758409998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033893430,
    "dropsitcph": 9033893430,
    "dropfax": 9033892062
  },
  {
    "dcode": "D",
    "dropkey": "PW23706",
    "droptype": "D",
    "dropname": "FALCON HEIGHTS",
    "dropdeladd": "582 FM 2098",
    "dropdelcty": "FALCON HEIGHTS",
    "dropdelst": "TX",
    "dropdelzpp": 785459800,
    "dropphyadd": "582 FM 2098",
    "dropphycty": "FALCON HEIGHTS",
    "dropphyst": "TX",
    "dropphyzpp": 785459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALCON HEIGHTS",
    "dropmalst": "TX",
    "dropmalzpp": 785459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568485421,
    "dropsitcph": 9568485421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23708",
    "droptype": "D",
    "dropname": "FALFURRIAS",
    "dropdeladd": "218 E CHAPOTE ST",
    "dropdelcty": "FALFURRIAS",
    "dropdelst": "TX",
    "dropdelzpp": 783559998,
    "dropphyadd": "218 E CHAPOTE ST",
    "dropphycty": "FALFURRIAS",
    "dropphyst": "TX",
    "dropphyzpp": 783559998,
    "dropmaladd": "218 E CHAPOTE ST",
    "dropmalcty": "FALFURRIAS",
    "dropmalst": "TX",
    "dropmalzpp": 783559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613252868,
    "dropsitcph": 3613252868,
    "dropfax": 3613255873
  },
  {
    "dcode": "D",
    "dropkey": "PW23710",
    "droptype": "D",
    "dropname": "FALLS CITY",
    "dropdeladd": "200 N IRVIN ST",
    "dropdelcty": "FALLS CITY",
    "dropdelst": "TX",
    "dropdelzpp": 781139998,
    "dropphyadd": "200 N IRVIN ST",
    "dropphycty": "FALLS CITY",
    "dropphyst": "TX",
    "dropphyzpp": 781139998,
    "dropmaladd": "200 N IRVIN ST",
    "dropmalcty": "FALLS CITY",
    "dropmalst": "TX",
    "dropmalzpp": 781139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302544133,
    "dropsitcph": 8302544146,
    "dropfax": 8302544143
  },
  {
    "dcode": "D",
    "dropkey": "PW23712",
    "droptype": "D",
    "dropname": "FANNIN",
    "dropdeladd": "9931 US HIGHWAY 59 N",
    "dropdelcty": "FANNIN",
    "dropdelst": "TX",
    "dropdelzpp": 779609800,
    "dropphyadd": "9931 US HIGHWAY 59 N",
    "dropphycty": "FANNIN",
    "dropphyst": "TX",
    "dropphyzpp": 779609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FANNIN",
    "dropmalst": "TX",
    "dropmalzpp": 779609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3616452198,
    "dropsitcph": 3616452198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23715",
    "droptype": "D",
    "dropname": "FARMERSVILLE",
    "dropdeladd": "213 MCKINNEY ST",
    "dropdelcty": "FARMERSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754429998,
    "dropphyadd": "213 MCKINNEY ST",
    "dropphycty": "FARMERSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754429998,
    "dropmaladd": "213 MCKINNEY ST",
    "dropmalcty": "FARMERSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754429998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727827172,
    "dropsitcph": 9727827172,
    "dropfax": 9727826845
  },
  {
    "dcode": "D",
    "dropkey": "PW23716",
    "droptype": "D",
    "dropname": "FARNSWORTH",
    "dropdeladd": "200 FARNSWORTH ST",
    "dropdelcty": "FARNSWORTH",
    "dropdelst": "TX",
    "dropdelzpp": 790339998,
    "dropphyadd": "200 FARNSWORTH ST",
    "dropphycty": "FARNSWORTH",
    "dropphyst": "TX",
    "dropphyzpp": 790339998,
    "dropmaladd": "200 FARNSWORTH ST",
    "dropmalcty": "FARNSWORTH",
    "dropmalst": "TX",
    "dropmalzpp": 790339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064357758,
    "dropsitcph": 8064357758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23720",
    "droptype": "D",
    "dropname": "FARWELL",
    "dropdeladd": "120 4TH ST",
    "dropdelcty": "FARWELL",
    "dropdelst": "TX",
    "dropdelzpp": 793259802,
    "dropphyadd": "120 4TH ST",
    "dropphycty": "FARWELL",
    "dropphyst": "TX",
    "dropphyzpp": 793259802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARWELL",
    "dropmalst": "TX",
    "dropmalzpp": 793259998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064813601,
    "dropsitcph": 8064813601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23722",
    "droptype": "D",
    "dropname": "FATE",
    "dropdeladd": "909 W HOLIDAY DR",
    "dropdelcty": "FATE",
    "dropdelst": "TX",
    "dropdelzpp": 751329998,
    "dropphyadd": "909 W HOLIDAY DR",
    "dropphycty": "FATE",
    "dropphyst": "TX",
    "dropphyzpp": 751329998,
    "dropmaladd": "909 W HOLIDAY DR",
    "dropmalcty": "FATE",
    "dropmalst": "TX",
    "dropmalzpp": 751329998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9727225456,
    "dropsitcph": 9727225456,
    "dropfax": 9727225456
  },
  {
    "dcode": "D",
    "dropkey": "PW23723",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "212 E MAIN ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 789409998,
    "dropphyadd": "212 E MAIN ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 789409998,
    "dropmaladd": "212 E MAIN ST",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 789409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9793782513,
    "dropsitcph": 9793782513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23727",
    "droptype": "D",
    "dropname": "FENTRESS",
    "dropdeladd": "109 GONZALES AVE",
    "dropdelcty": "FENTRESS",
    "dropdelst": "TX",
    "dropdelzpp": 786229800,
    "dropphyadd": "109 GONZALES AVE",
    "dropphycty": "FENTRESS",
    "dropphyst": "TX",
    "dropphyzpp": 786229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENTRESS",
    "dropmalst": "TX",
    "dropmalzpp": 786229998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124882526,
    "dropsitcph": 5124882526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23728",
    "droptype": "D",
    "dropname": "FERRIS",
    "dropdeladd": "413 W 6TH ST",
    "dropdelcty": "FERRIS",
    "dropdelst": "TX",
    "dropdelzpp": 751259998,
    "dropphyadd": "413 W 6TH ST",
    "dropphycty": "FERRIS",
    "dropphyst": "TX",
    "dropphyzpp": 751259998,
    "dropmaladd": "413 W 6TH ST",
    "dropmalcty": "FERRIS",
    "dropmalst": "TX",
    "dropmalzpp": 751259998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9725443872,
    "dropsitcph": 9725443872,
    "dropfax": 9725442019
  },
  {
    "dcode": "D",
    "dropkey": "PW23740",
    "droptype": "D",
    "dropname": "FISCHER",
    "dropdeladd": "4050 FM 484",
    "dropdelcty": "FISCHER",
    "dropdelst": "TX",
    "dropdelzpp": 786239998,
    "dropphyadd": "4050 FM 484",
    "dropphycty": "FISCHER",
    "dropphyst": "TX",
    "dropphyzpp": 786239998,
    "dropmaladd": "4050 FM 484",
    "dropmalcty": "FISCHER",
    "dropmalst": "TX",
    "dropmalzpp": 786239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309352351,
    "dropsitcph": 8309352351,
    "dropfax": 8309352351
  },
  {
    "dcode": "D",
    "dropkey": "PW23744",
    "droptype": "D",
    "dropname": "FLAT",
    "dropdeladd": "10065 S STATE HIGHWAY 36",
    "dropdelcty": "FLAT",
    "dropdelst": "TX",
    "dropdelzpp": 765269800,
    "dropphyadd": "10065 S STATE HIGHWAY 36",
    "dropphycty": "FLAT",
    "dropphyst": "TX",
    "dropphyzpp": 765269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLAT",
    "dropmalst": "TX",
    "dropmalzpp": 765269998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544872302,
    "dropsitcph": 2544872302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23746",
    "droptype": "D",
    "dropname": "FLATONIA",
    "dropdeladd": "105 E SOUTH MAIN ST",
    "dropdelcty": "FLATONIA",
    "dropdelst": "TX",
    "dropdelzpp": 789419998,
    "dropphyadd": "105 E SOUTH MAIN ST",
    "dropphycty": "FLATONIA",
    "dropphyst": "TX",
    "dropphyzpp": 789419998,
    "dropmaladd": "105 E SOUTH MAIN ST",
    "dropmalcty": "FLATONIA",
    "dropmalst": "TX",
    "dropmalzpp": 789419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618653331,
    "dropsitcph": 3618653331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23749",
    "droptype": "D",
    "dropname": "FLINT",
    "dropdeladd": "10668 FM 346 W",
    "dropdelcty": "FLINT",
    "dropdelst": "TX",
    "dropdelzpp": 757629998,
    "dropphyadd": "10668 FM 346 W",
    "dropphycty": "FLINT",
    "dropphyst": "TX",
    "dropphyzpp": 757629998,
    "dropmaladd": "10668 FM 346 W",
    "dropmalcty": "FLINT",
    "dropmalst": "TX",
    "dropmalzpp": 757629998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038947288,
    "dropsitcph": 9038947288,
    "dropfax": 9038944263
  },
  {
    "dcode": "D",
    "dropkey": "PW23753",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "308 N PATTERSON AVE",
    "dropdelcty": "FLORENCE",
    "dropdelst": "TX",
    "dropdelzpp": 765279998,
    "dropphyadd": "308 N PATTERSON AVE",
    "dropphycty": "FLORENCE",
    "dropphyst": "TX",
    "dropphyzpp": 765279998,
    "dropmaladd": "308 N PATTERSON AVE",
    "dropmalcty": "FLORENCE",
    "dropmalst": "TX",
    "dropmalzpp": 765279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2542491004,
    "dropsitcph": 2542491004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23754",
    "droptype": "D",
    "dropname": "FLORESVILLE",
    "dropdeladd": "141 PALOMA DR",
    "dropdelcty": "FLORESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 781149998,
    "dropphyadd": "141 PALOMA DR",
    "dropphycty": "FLORESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 781149998,
    "dropmaladd": "141 PALOMA DR",
    "dropmalcty": "FLORESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 781149998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303932161,
    "dropsitcph": 8303932161,
    "dropfax": 8303934369
  },
  {
    "dcode": "D",
    "dropkey": "PW23762",
    "droptype": "D",
    "dropname": "FLOYDADA",
    "dropdeladd": "226 W MISSOURI ST",
    "dropdelcty": "FLOYDADA",
    "dropdelst": "TX",
    "dropdelzpp": 792359998,
    "dropphyadd": "226 W MISSOURI ST",
    "dropphycty": "FLOYDADA",
    "dropphyst": "TX",
    "dropphyzpp": 792359998,
    "dropmaladd": "226 W MISSOURI ST",
    "dropmalcty": "FLOYDADA",
    "dropmalst": "TX",
    "dropmalzpp": 792359998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069832410,
    "dropsitcph": 8069832410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23763",
    "droptype": "D",
    "dropname": "FLUVANNA",
    "dropdeladd": "930 10TH ST",
    "dropdelcty": "FLUVANNA",
    "dropdelst": "TX",
    "dropdelzpp": 795179998,
    "dropphyadd": "930 10TH ST",
    "dropphycty": "FLUVANNA",
    "dropphyst": "TX",
    "dropphyzpp": 795179998,
    "dropmaladd": "1701 24TH ST",
    "dropmalcty": "SNYDER",
    "dropmalst": "TX",
    "dropmalzpp": 795499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255735505,
    "dropsitcph": 3255735505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23764",
    "droptype": "D",
    "dropname": "FLYNN",
    "dropdeladd": "7782 FM 39 S",
    "dropdelcty": "FLYNN",
    "dropdelst": "TX",
    "dropdelzpp": 778559800,
    "dropphyadd": "7782 FM 39 S",
    "dropphycty": "FLYNN",
    "dropphyst": "TX",
    "dropphyzpp": 778559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLYNN",
    "dropmalst": "TX",
    "dropmalzpp": 778559998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363966862,
    "dropsitcph": 9363966862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23765",
    "droptype": "D",
    "dropname": "FOLLETT",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "FOLLETT",
    "dropdelst": "TX",
    "dropdelzpp": 790349802,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "FOLLETT",
    "dropphyst": "TX",
    "dropphyzpp": 790349802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOLLETT",
    "dropmalst": "TX",
    "dropmalzpp": 790349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066532311,
    "dropsitcph": 8066532311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23776",
    "droptype": "D",
    "dropname": "FORESTBURG",
    "dropdeladd": "16928 FM 455",
    "dropdelcty": "FORESTBURG",
    "dropdelst": "TX",
    "dropdelzpp": 762399998,
    "dropphyadd": "16928 FM 455",
    "dropphycty": "FORESTBURG",
    "dropphyst": "TX",
    "dropphyzpp": 762399998,
    "dropmaladd": "16928 FM 455",
    "dropmalcty": "FORESTBURG",
    "dropmalst": "TX",
    "dropmalzpp": 762399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9409642235,
    "dropsitcph": 9409642235,
    "dropfax": 6505783821
  },
  {
    "dcode": "D",
    "dropkey": "PW23777",
    "droptype": "D",
    "dropname": "FORNEY",
    "dropdeladd": "102 E BROAD ST",
    "dropdelcty": "FORNEY",
    "dropdelst": "TX",
    "dropdelzpp": 751269998,
    "dropphyadd": "102 E BROAD ST",
    "dropphycty": "FORNEY",
    "dropphyst": "TX",
    "dropphyzpp": 751269998,
    "dropmaladd": "102 E BROAD ST",
    "dropmalcty": "FORNEY",
    "dropmalst": "TX",
    "dropmalzpp": 751269998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9725529743,
    "dropsitcph": 9725529743,
    "dropfax": 9725529148
  },
  {
    "dcode": "D",
    "dropkey": "PW23778",
    "droptype": "D",
    "dropname": "FORRESTON",
    "dropdeladd": "406 CHERRY ST",
    "dropdelcty": "FORRESTON",
    "dropdelst": "TX",
    "dropdelzpp": 760411702,
    "dropphyadd": "406 CHERRY ST",
    "dropphycty": "FORRESTON",
    "dropphyst": "TX",
    "dropphyzpp": 760411702,
    "dropmaladd": "406 CHERRY ST",
    "dropmalcty": "FORRESTON",
    "dropmalst": "TX",
    "dropmalzpp": 760411702,
    "dropsitphn": 8173173658,
    "dropsitlph": 9724836968,
    "dropsitcph": 9724836968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23779",
    "droptype": "D",
    "dropname": "FORSAN",
    "dropdeladd": "109 W 4TH",
    "dropdelcty": "FORSAN",
    "dropdelst": "TX",
    "dropdelzpp": 797339800,
    "dropphyadd": "109 W 4TH",
    "dropphycty": "FORSAN",
    "dropphyst": "TX",
    "dropphyzpp": 797339800,
    "dropmaladd": "109 W 4TH",
    "dropmalcty": "FORSAN",
    "dropmalst": "TX",
    "dropmalzpp": 797339800,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4324572323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23782",
    "droptype": "D",
    "dropname": "FORT DAVIS",
    "dropdeladd": "500 SGT GONZALES",
    "dropdelcty": "FORT DAVIS",
    "dropdelst": "TX",
    "dropdelzpp": 797349800,
    "dropphyadd": "500 SGT GONZALES",
    "dropphycty": "FORT DAVIS",
    "dropphyst": "TX",
    "dropphyzpp": 797349800,
    "dropmaladd": "500 SGT GONZALES",
    "dropmalcty": "FORT DAVIS",
    "dropmalst": "TX",
    "dropmalzpp": 797349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4324263914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23784",
    "droptype": "D",
    "dropname": "FORT HANCOCK",
    "dropdeladd": "107 W TEXAS HIGHWAY 20",
    "dropdelcty": "FORT HANCOCK",
    "dropdelst": "TX",
    "dropdelzpp": 798399998,
    "dropphyadd": "107 W TEXAS HIGHWAY 20",
    "dropphycty": "FORT HANCOCK",
    "dropphyst": "TX",
    "dropphyzpp": 798399998,
    "dropmaladd": "107 W TEXAS HIGHWAY 20",
    "dropmalcty": "FORT HANCOCK",
    "dropmalst": "TX",
    "dropmalzpp": 798399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 9157693772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23791",
    "droptype": "D",
    "dropname": "FORT MC KAVETT",
    "dropdeladd": "6576 FM 864",
    "dropdelcty": "FORT MC KAVETT",
    "dropdelst": "TX",
    "dropdelzpp": 768419700,
    "dropphyadd": "6576 FM 864",
    "dropphycty": "FORT MC KAVETT",
    "dropphyst": "TX",
    "dropphyzpp": 768419700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT MC KAVETT",
    "dropmalst": "TX",
    "dropmalzpp": 768419998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253962662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23794",
    "droptype": "D",
    "dropname": "FORT STOCKTON",
    "dropdeladd": "106 E 4TH ST",
    "dropdelcty": "FORT STOCKTON",
    "dropdelst": "TX",
    "dropdelzpp": 797359998,
    "dropphyadd": "106 E 4TH ST",
    "dropphycty": "FORT STOCKTON",
    "dropphyst": "TX",
    "dropphyzpp": 797359998,
    "dropmaladd": "106 E 4TH ST",
    "dropmalcty": "FORT STOCKTON",
    "dropmalst": "TX",
    "dropmalzpp": 797359998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323362313,
    "dropfax": 4323362784
  },
  {
    "dcode": "D",
    "dropkey": "PW23796",
    "droptype": "D",
    "dropname": "FORT WORTH",
    "dropdeladd": "4600 MARK IV PKWY",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761619998,
    "dropphyadd": "4600 MARK IV PKWY",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761619998,
    "dropmaladd": "4600 MARK IV PKWY",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173701,
    "dropsitcph": 8173173701,
    "dropfax": 8173173838
  },
  {
    "dcode": "D",
    "dropkey": "PW23802",
    "droptype": "D",
    "dropname": "FRANCITAS",
    "dropdeladd": "66 BRYAN ST",
    "dropdelcty": "FRANCITAS",
    "dropdelst": "TX",
    "dropdelzpp": 779619800,
    "dropphyadd": "66 BRYAN ST",
    "dropphycty": "FRANCITAS",
    "dropphyst": "TX",
    "dropphyzpp": 779619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANCITAS",
    "dropmalst": "TX",
    "dropmalzpp": 779619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615887413,
    "dropsitcph": 3615887413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23803",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "216 E DECHERD ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "TX",
    "dropdelzpp": 778569803,
    "dropphyadd": "216 E DECHERD ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "TX",
    "dropphyzpp": 778569803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "TX",
    "dropmalzpp": 778569998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798283607,
    "dropsitcph": 9798283607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23804",
    "droptype": "D",
    "dropname": "FRANKSTON",
    "dropdeladd": "400 E MAIN ST",
    "dropdelcty": "FRANKSTON",
    "dropdelst": "TX",
    "dropdelzpp": 757639998,
    "dropphyadd": "400 E MAIN ST",
    "dropphycty": "FRANKSTON",
    "dropphyst": "TX",
    "dropphyzpp": 757639998,
    "dropmaladd": "400 E MAIN ST",
    "dropmalcty": "FRANKSTON",
    "dropmalst": "TX",
    "dropmalzpp": 757639998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038762978,
    "dropsitcph": 9038762978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23806",
    "droptype": "D",
    "dropname": "FRED",
    "dropdeladd": "20239 FM 92 S",
    "dropdelcty": "FRED",
    "dropdelst": "TX",
    "dropdelzpp": 776160017,
    "dropphyadd": "20239 FM 92 S",
    "dropphycty": "FRED",
    "dropphyst": "TX",
    "dropphyzpp": 776160017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRED",
    "dropmalst": "TX",
    "dropmalzpp": 776169998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4094295133,
    "dropsitcph": 4094295133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23808",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "1150 N US HIGHWAY 87",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "TX",
    "dropdelzpp": 786249998,
    "dropphyadd": "1150 N US HIGHWAY 87",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "TX",
    "dropphyzpp": 786249998,
    "dropmaladd": "1150 N US HIGHWAY 87",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "TX",
    "dropmalzpp": 786249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309973355,
    "dropsitcph": 8309973355,
    "dropfax": 8309978089
  },
  {
    "dcode": "D",
    "dropkey": "PW23813",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "924 N AVENUE F",
    "dropdelcty": "FREEPORT",
    "dropdelst": "TX",
    "dropdelzpp": 775419998,
    "dropphyadd": "924 N AVENUE F",
    "dropphycty": "FREEPORT",
    "dropphyst": "TX",
    "dropphyzpp": 775419998,
    "dropmaladd": "924 N AVENUE F",
    "dropmalcty": "FREEPORT",
    "dropmalst": "TX",
    "dropmalzpp": 775419998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792331884,
    "dropsitcph": 9792331884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23814",
    "droptype": "D",
    "dropname": "FREER",
    "dropdeladd": "320 S MAIN ST",
    "dropdelcty": "FREER",
    "dropdelst": "TX",
    "dropdelzpp": 783579998,
    "dropphyadd": "320 S MAIN ST",
    "dropphycty": "FREER",
    "dropphyst": "TX",
    "dropphyzpp": 783579998,
    "dropmaladd": "320 S MAIN ST",
    "dropmalcty": "FREER",
    "dropmalst": "TX",
    "dropmalzpp": 783579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613946875,
    "dropsitcph": 3613946875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23818",
    "droptype": "D",
    "dropname": "FRESNO",
    "dropdeladd": "4725 TEAL BEND BLVD",
    "dropdelcty": "FRESNO",
    "dropdelst": "TX",
    "dropdelzpp": 775459998,
    "dropphyadd": "4725 TEAL BEND BLVD",
    "dropphycty": "FRESNO",
    "dropphyst": "TX",
    "dropphyzpp": 775459998,
    "dropmaladd": "4725 TEAL BEND BLVD",
    "dropmalcty": "FRESNO",
    "dropmalst": "TX",
    "dropmalzpp": 775459998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814318756,
    "dropsitcph": 2814318748,
    "dropfax": 2814318754
  },
  {
    "dcode": "D",
    "dropkey": "PW23823",
    "droptype": "D",
    "dropname": "FRIENDSWOOD",
    "dropdeladd": "310 MORNINGSIDE DR",
    "dropdelcty": "FRIENDSWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 775469998,
    "dropphyadd": "310 MORNINGSIDE DR",
    "dropphycty": "FRIENDSWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 775469998,
    "dropmaladd": "310 MORNINGSIDE DR",
    "dropmalcty": "FRIENDSWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 775469998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814821503,
    "dropsitcph": 2819922832,
    "dropfax": 2814828949
  },
  {
    "dcode": "D",
    "dropkey": "PW23825",
    "droptype": "D",
    "dropname": "FRIONA",
    "dropdeladd": "1010 MAIN ST",
    "dropdelcty": "FRIONA",
    "dropdelst": "TX",
    "dropdelzpp": 790359998,
    "dropphyadd": "1010 MAIN ST",
    "dropphycty": "FRIONA",
    "dropphyst": "TX",
    "dropphyzpp": 790359998,
    "dropmaladd": "1010 MAIN ST",
    "dropmalcty": "FRIONA",
    "dropmalst": "TX",
    "dropmalzpp": 790359998,
    "dropsitphn": 8062503803,
    "dropsitlph": 8062503803,
    "dropsitcph": 8062503803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23826",
    "droptype": "D",
    "dropname": "FRISCO",
    "dropdeladd": "8700 STONEBROOK PKWY",
    "dropdelcty": "FRISCO",
    "dropdelst": "TX",
    "dropdelzpp": 750349998,
    "dropphyadd": "8700 STONEBROOK PKWY",
    "dropphycty": "FRISCO",
    "dropphyst": "TX",
    "dropphyzpp": 750349998,
    "dropmaladd": "8700 STONEBROOK PKWY",
    "dropmalcty": "FRISCO",
    "dropmalst": "TX",
    "dropmalzpp": 750349998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723357453,
    "dropsitcph": 9723357453,
    "dropfax": 9723353127
  },
  {
    "dcode": "D",
    "dropkey": "PW23827",
    "droptype": "D",
    "dropname": "FRITCH",
    "dropdeladd": "107 N HOYNE AVE",
    "dropdelcty": "FRITCH",
    "dropdelst": "TX",
    "dropdelzpp": 790369803,
    "dropphyadd": "107 N HOYNE AVE",
    "dropphycty": "FRITCH",
    "dropphyst": "TX",
    "dropphyzpp": 790369803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRITCH",
    "dropmalst": "TX",
    "dropmalzpp": 790369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068573562,
    "dropsitcph": 8068573562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23829",
    "droptype": "D",
    "dropname": "FROST",
    "dropdeladd": "301 N GARITTY ST",
    "dropdelcty": "FROST",
    "dropdelst": "TX",
    "dropdelzpp": 766419998,
    "dropphyadd": "301 N GARITTY ST",
    "dropphycty": "FROST",
    "dropphyst": "TX",
    "dropphyzpp": 766419998,
    "dropmaladd": "301 N GARITTY ST",
    "dropmalcty": "FROST",
    "dropmalst": "TX",
    "dropmalzpp": 766419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9036823661,
    "dropsitcph": 9036823661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23832",
    "droptype": "D",
    "dropname": "FRUITVALE",
    "dropdeladd": "121 VZ COUNTY ROAD 1910",
    "dropdelcty": "FRUITVALE",
    "dropdelst": "TX",
    "dropdelzpp": 751279998,
    "dropphyadd": "121 VZ COUNTY ROAD 1910",
    "dropphycty": "FRUITVALE",
    "dropphyst": "TX",
    "dropphyzpp": 751279998,
    "dropmaladd": "121 VZ COUNTY ROAD 1910",
    "dropmalcty": "FRUITVALE",
    "dropmalst": "TX",
    "dropmalzpp": 751279998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9038964031,
    "dropsitcph": 9038964031,
    "dropfax": 9038967562
  },
  {
    "dcode": "D",
    "dropkey": "PW23839",
    "droptype": "D",
    "dropname": "FULSHEAR",
    "dropdeladd": "8055 FM 359 RD S",
    "dropdelcty": "FULSHEAR",
    "dropdelst": "TX",
    "dropdelzpp": 774411512,
    "dropphyadd": "8055 FM 359 RD S",
    "dropphycty": "FULSHEAR",
    "dropphyst": "TX",
    "dropphyzpp": 774411512,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULSHEAR",
    "dropmalst": "TX",
    "dropmalzpp": 774419998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815339146,
    "dropsitcph": 2815339146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23840",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "301 CACTUS ST",
    "dropdelcty": "FULTON",
    "dropdelst": "TX",
    "dropdelzpp": 783589800,
    "dropphyadd": "301 CACTUS ST",
    "dropphycty": "FULTON",
    "dropphyst": "TX",
    "dropphyzpp": 783589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULTON",
    "dropmalst": "TX",
    "dropmalzpp": 783589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617295213,
    "dropsitcph": 3617295213,
    "dropfax": 3617294653
  },
  {
    "dcode": "D",
    "dropkey": "PW23845",
    "droptype": "D",
    "dropname": "GAIL",
    "dropdeladd": "108 S OAK ST",
    "dropdelcty": "GAIL",
    "dropdelst": "TX",
    "dropdelzpp": 797389998,
    "dropphyadd": "108 S OAK ST",
    "dropphycty": "GAIL",
    "dropphyst": "TX",
    "dropphyzpp": 797389998,
    "dropmaladd": "108 S OAK ST",
    "dropmalcty": "GAIL",
    "dropmalst": "TX",
    "dropmalzpp": 797389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8067564495,
    "dropsitcph": 8067564495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23846",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "321 E CALIFORNIA ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 762409998,
    "dropphyadd": "321 E CALIFORNIA ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 762409998,
    "dropmaladd": "321 E CALIFORNIA ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 762409998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406655811,
    "dropsitcph": 9406655811,
    "dropfax": 9406656860
  },
  {
    "dcode": "D",
    "dropkey": "PW23847",
    "droptype": "D",
    "dropname": "GALENA PARK",
    "dropdeladd": "1805 CLINTON DR",
    "dropdelcty": "GALENA PARK",
    "dropdelst": "TX",
    "dropdelzpp": 775479998,
    "dropphyadd": "1805 CLINTON DR",
    "dropphycty": "GALENA PARK",
    "dropphyst": "TX",
    "dropphyzpp": 775479998,
    "dropmaladd": "1805 CLINTON DR",
    "dropmalcty": "GALENA PARK",
    "dropmalst": "TX",
    "dropmalzpp": 775479998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136732336,
    "dropsitcph": 7136732336,
    "dropfax": 7136731627
  },
  {
    "dcode": "D",
    "dropkey": "PW23848",
    "droptype": "D",
    "dropname": "GALLATIN",
    "dropdeladd": "139 E FIRST AVE",
    "dropdelcty": "GALLATIN",
    "dropdelst": "TX",
    "dropdelzpp": 757649998,
    "dropphyadd": "139 E FIRST AVE",
    "dropphycty": "GALLATIN",
    "dropphyst": "TX",
    "dropphyzpp": 757649998,
    "dropmaladd": "139 E FIRST AVE",
    "dropmalcty": "GALLATIN",
    "dropmalst": "TX",
    "dropmalzpp": 757649998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036835957,
    "dropsitcph": 9036835957,
    "dropfax": 9036836045
  },
  {
    "dcode": "D",
    "dropkey": "PW23851",
    "droptype": "D",
    "dropname": "GALVESTON",
    "dropdeladd": "601 TREMONT ST",
    "dropdelcty": "GALVESTON",
    "dropdelst": "TX",
    "dropdelzpp": 775505490,
    "dropphyadd": "601 TREMONT ST",
    "dropphycty": "GALVESTON",
    "dropphyst": "TX",
    "dropphyzpp": 775505490,
    "dropmaladd": "601 TREMONT ST",
    "dropmalcty": "GALVESTON",
    "dropmalst": "TX",
    "dropmalzpp": 775505490,
    "dropsitphn": 4097400137,
    "dropsitlph": 4097400071,
    "dropsitcph": 4097400037,
    "dropfax": 4097621909
  },
  {
    "dcode": "D",
    "dropkey": "PW23852",
    "droptype": "D",
    "dropname": "GANADO",
    "dropdeladd": "101 W ROGERS ST",
    "dropdelcty": "GANADO",
    "dropdelst": "TX",
    "dropdelzpp": 779629998,
    "dropphyadd": "101 W ROGERS ST",
    "dropphycty": "GANADO",
    "dropphyst": "TX",
    "dropphyzpp": 779629998,
    "dropmaladd": "101 W ROGERS ST",
    "dropmalcty": "GANADO",
    "dropmalst": "TX",
    "dropmalzpp": 779629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617712536,
    "dropsitcph": 3617712536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23855",
    "droptype": "D",
    "dropname": "GARCIASVILLE",
    "dropdeladd": "6648 FM 1430",
    "dropdelcty": "GARCIASVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 785479800,
    "dropphyadd": "6648 FM 1430",
    "dropphycty": "GARCIASVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 785479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARCIASVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 785479998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564873575,
    "dropsitcph": 9564873575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23856",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "241 E CURRIE",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "TX",
    "dropdelzpp": 797399998,
    "dropphyadd": "241 E CURRIE",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "TX",
    "dropphyzpp": 797399998,
    "dropmaladd": "241 E CURRIE",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "TX",
    "dropmalzpp": 797399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323542241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23861",
    "droptype": "D",
    "dropname": "GARDENDALE",
    "dropdeladd": "4600 E US HIGHWAY 158",
    "dropdelcty": "GARDENDALE",
    "dropdelst": "TX",
    "dropdelzpp": 797589998,
    "dropphyadd": "4600 E US HIGHWAY 158",
    "dropphycty": "GARDENDALE",
    "dropphyst": "TX",
    "dropphyzpp": 797589998,
    "dropmaladd": "4600 E US HIGHWAY 158",
    "dropmalcty": "GARDENDALE",
    "dropmalst": "TX",
    "dropmalzpp": 797589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323668102,
    "dropsitcph": 4323668102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23863",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "1000 W WALNUT ST",
    "dropdelcty": "GARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 750409998,
    "dropphyadd": "1000 W WALNUT ST",
    "dropphycty": "GARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 750409998,
    "dropmaladd": "1000 W WALNUT ST",
    "dropmalcty": "GARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 750409998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722766541,
    "dropsitcph": 9722766541,
    "dropfax": 9722727652
  },
  {
    "dcode": "D",
    "dropkey": "PW23864",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "222 N B AVE",
    "dropdelcty": "GARRISON",
    "dropdelst": "TX",
    "dropdelzpp": 759469998,
    "dropphyadd": "222 N B AVE",
    "dropphycty": "GARRISON",
    "dropphyst": "TX",
    "dropphyzpp": 759469998,
    "dropmaladd": "222 N B AVE",
    "dropmalcty": "GARRISON",
    "dropmalst": "TX",
    "dropmalzpp": 759469998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9363472461,
    "dropsitcph": 9363472461,
    "dropfax": 9363472461
  },
  {
    "dcode": "D",
    "dropkey": "PW23866",
    "droptype": "D",
    "dropname": "GARWOOD",
    "dropdeladd": "506 ARTHUR ST",
    "dropdelcty": "GARWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 774429998,
    "dropphyadd": "506 ARTHUR ST",
    "dropphycty": "GARWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 774429998,
    "dropmaladd": "506 ARTHUR ST",
    "dropmalcty": "GARWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 774429998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797583616,
    "dropsitcph": 9797583616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23867",
    "droptype": "D",
    "dropname": "GARY",
    "dropdeladd": "2601 FM 999",
    "dropdelcty": "GARY",
    "dropdelst": "TX",
    "dropdelzpp": 756439998,
    "dropphyadd": "2601 FM 999",
    "dropphycty": "GARY",
    "dropphyst": "TX",
    "dropphyzpp": 756439998,
    "dropmaladd": "2601 FM 999",
    "dropmalcty": "GARY",
    "dropmalst": "TX",
    "dropmalzpp": 756439998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036852415,
    "dropsitcph": 9036852415,
    "dropfax": 9036852415
  },
  {
    "dcode": "D",
    "dropkey": "PW23869",
    "droptype": "D",
    "dropname": "GATESVILLE",
    "dropdeladd": "802 E LEON ST",
    "dropdelcty": "GATESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 765289998,
    "dropphyadd": "802 E LEON ST",
    "dropphycty": "GATESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 765289998,
    "dropmaladd": "802 E LEON ST",
    "dropmalcty": "GATESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 765289998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548655117,
    "dropsitcph": 2548655117,
    "dropfax": 2548655523
  },
  {
    "dcode": "D",
    "dropkey": "PW23874",
    "droptype": "D",
    "dropname": "GAUSE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "GAUSE",
    "dropdelst": "TX",
    "dropdelzpp": 778579800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "GAUSE",
    "dropphyst": "TX",
    "dropphyzpp": 778579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAUSE",
    "dropmalst": "TX",
    "dropmalzpp": 778579998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792792758,
    "dropsitcph": 9792792758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23882",
    "droptype": "D",
    "dropname": "GEORGE WEST",
    "dropdeladd": "606 FRIO ST",
    "dropdelcty": "GEORGE WEST",
    "dropdelst": "TX",
    "dropdelzpp": 780229998,
    "dropphyadd": "606 FRIO ST",
    "dropphycty": "GEORGE WEST",
    "dropphyst": "TX",
    "dropphyzpp": 780229998,
    "dropmaladd": "606 FRIO ST",
    "dropmalcty": "GEORGE WEST",
    "dropmalst": "TX",
    "dropmalzpp": 780229998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3614491442,
    "dropsitcph": 3614491442,
    "dropfax": 3614492761
  },
  {
    "dcode": "D",
    "dropkey": "PW23883",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "2300 SCENIC DR",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "TX",
    "dropdelzpp": 786269998,
    "dropphyadd": "2300 SCENIC DR",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "TX",
    "dropphyzpp": 786269998,
    "dropmaladd": "2300 SCENIC DR",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "TX",
    "dropmalzpp": 786269998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5129300346,
    "dropsitcph": 5128689925,
    "dropfax": 5129300805
  },
  {
    "dcode": "D",
    "dropkey": "PW23888",
    "droptype": "D",
    "dropname": "GIDDINGS",
    "dropdeladd": "279 E AUSTIN ST",
    "dropdelcty": "GIDDINGS",
    "dropdelst": "TX",
    "dropdelzpp": 789429998,
    "dropphyadd": "279 E AUSTIN ST",
    "dropphycty": "GIDDINGS",
    "dropphyst": "TX",
    "dropphyzpp": 789429998,
    "dropmaladd": "279 E AUSTIN ST",
    "dropmalcty": "GIDDINGS",
    "dropmalst": "TX",
    "dropmalzpp": 789429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9795422456,
    "dropsitcph": 9795422456,
    "dropfax": 9795424355
  },
  {
    "dcode": "D",
    "dropkey": "PW23892",
    "droptype": "D",
    "dropname": "GILLETT",
    "dropdeladd": "21694 FM 887",
    "dropdelcty": "GILLETT",
    "dropdelst": "TX",
    "dropdelzpp": 781169998,
    "dropphyadd": "21694 FM 887",
    "dropphycty": "GILLETT",
    "dropphyst": "TX",
    "dropphyzpp": 781169998,
    "dropmaladd": "21694 FM 887",
    "dropmalcty": "GILLETT",
    "dropmalst": "TX",
    "dropmalzpp": 781169998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307894122,
    "dropsitcph": 8307894122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23893",
    "droptype": "D",
    "dropname": "GILMER",
    "dropdeladd": "405 N CYPRESS ST",
    "dropdelcty": "GILMER",
    "dropdelst": "TX",
    "dropdelzpp": 756449998,
    "dropphyadd": "405 N CYPRESS ST",
    "dropphycty": "GILMER",
    "dropphyst": "TX",
    "dropphyzpp": 756449998,
    "dropmaladd": "405 N CYPRESS ST",
    "dropmalcty": "GILMER",
    "dropmalst": "TX",
    "dropmalzpp": 756449998,
    "dropsitphn": 9034028002,
    "dropsitlph": 9038432934,
    "dropsitcph": 9038432934,
    "dropfax": 9038436232
  },
  {
    "dcode": "D",
    "dropkey": "PW23894",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "1485 STATE HIGHWAY 70",
    "dropdelcty": "GIRARD",
    "dropdelst": "TX",
    "dropdelzpp": 795189998,
    "dropphyadd": "1485 STATE HIGHWAY 70",
    "dropphycty": "GIRARD",
    "dropphyst": "TX",
    "dropphyzpp": 795189998,
    "dropmaladd": "1485 STATE HIGHWAY 70",
    "dropmalcty": "GIRARD",
    "dropmalst": "TX",
    "dropmalzpp": 795189998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062842067,
    "dropsitcph": 8062842067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23896",
    "droptype": "D",
    "dropname": "GLADEWATER",
    "dropdeladd": "101 N DEAN ST",
    "dropdelcty": "GLADEWATER",
    "dropdelst": "TX",
    "dropdelzpp": 756479998,
    "dropphyadd": "101 N DEAN ST",
    "dropphycty": "GLADEWATER",
    "dropphyst": "TX",
    "dropphyzpp": 756479998,
    "dropmaladd": "101 N DEAN ST",
    "dropmalcty": "GLADEWATER",
    "dropmalst": "TX",
    "dropmalzpp": 756479998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038458334,
    "dropsitcph": 9038458334,
    "dropfax": 9038452513
  },
  {
    "dcode": "D",
    "dropkey": "PW23901",
    "droptype": "D",
    "dropname": "GLEN FLORA",
    "dropdeladd": "126 BRIDGE ST",
    "dropdelcty": "GLEN FLORA",
    "dropdelst": "TX",
    "dropdelzpp": 774430177,
    "dropphyadd": "126 BRIDGE ST",
    "dropphycty": "GLEN FLORA",
    "dropphyst": "TX",
    "dropphyzpp": 774430177,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN FLORA",
    "dropmalst": "TX",
    "dropmalzpp": 774439998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796773203,
    "dropsitcph": 9796773203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23902",
    "droptype": "D",
    "dropname": "GLEN ROSE",
    "dropdeladd": "500 NE BIG BEND TRL",
    "dropdelcty": "GLEN ROSE",
    "dropdelst": "TX",
    "dropdelzpp": 760439998,
    "dropphyadd": "500 NE BIG BEND TRL",
    "dropphycty": "GLEN ROSE",
    "dropphyst": "TX",
    "dropphyzpp": 760439998,
    "dropmaladd": "500 NE BIG BEND TRL",
    "dropmalcty": "GLEN ROSE",
    "dropmalst": "TX",
    "dropmalzpp": 760439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548979611,
    "dropsitcph": 2548979611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23908",
    "droptype": "D",
    "dropname": "GOBER",
    "dropdeladd": "4672 FM 68",
    "dropdelcty": "GOBER",
    "dropdelst": "TX",
    "dropdelzpp": 754439998,
    "dropphyadd": "4672 FM 68",
    "dropphycty": "GOBER",
    "dropphyst": "TX",
    "dropphyzpp": 754439998,
    "dropmaladd": "4672 FM 68",
    "dropmalcty": "GOBER",
    "dropmalst": "TX",
    "dropmalzpp": 754439998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035835604,
    "dropsitcph": 9035835604,
    "dropfax": 9035835820
  },
  {
    "dcode": "D",
    "dropkey": "PW23909",
    "droptype": "D",
    "dropname": "GODLEY",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "GODLEY",
    "dropdelst": "TX",
    "dropdelzpp": 760449998,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "GODLEY",
    "dropphyst": "TX",
    "dropphyzpp": 760449998,
    "dropmaladd": "100 S MAIN ST",
    "dropmalcty": "GODLEY",
    "dropmalst": "TX",
    "dropmalzpp": 760449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173093359,
    "dropsitcph": 8173093359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23911",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "5785 FM 779",
    "dropdelcty": "GOLDEN",
    "dropdelst": "TX",
    "dropdelzpp": 754449998,
    "dropphyadd": "5785 FM 779",
    "dropphycty": "GOLDEN",
    "dropphyst": "TX",
    "dropphyzpp": 754449998,
    "dropmaladd": "5785 FM 779",
    "dropmalcty": "GOLDEN",
    "dropmalst": "TX",
    "dropmalzpp": 754449998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037682678,
    "dropsitcph": 9037682678,
    "dropfax": 9037682517
  },
  {
    "dcode": "D",
    "dropkey": "PW23914",
    "droptype": "D",
    "dropname": "GOLDSBORO",
    "dropdeladd": "901 US HIGHWAY 84",
    "dropdelcty": "GOLDSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 795199998,
    "dropphyadd": "901 US HIGHWAY 84",
    "dropphycty": "GOLDSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 795199998,
    "dropmaladd": "901 US HIGHWAY 84",
    "dropmalcty": "GOLDSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 795199998,
    "dropsitphn": 3255832041,
    "dropsitlph": 3255832041,
    "dropsitcph": 3255832041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23915",
    "droptype": "D",
    "dropname": "GOLDSMITH",
    "dropdeladd": "310 E GULF",
    "dropdelcty": "GOLDSMITH",
    "dropdelst": "TX",
    "dropdelzpp": 797419997,
    "dropphyadd": "310 E GULF",
    "dropphycty": "GOLDSMITH",
    "dropphyst": "TX",
    "dropphyzpp": 797419997,
    "dropmaladd": "310 E GULF",
    "dropmalcty": "GOLDSMITH",
    "dropmalst": "TX",
    "dropmalzpp": 797419997,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4328273400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23916",
    "droptype": "D",
    "dropname": "GOLDTHWAITE",
    "dropdeladd": "1401 W FRONT ST",
    "dropdelcty": "GOLDTHWAITE",
    "dropdelst": "TX",
    "dropdelzpp": 768449998,
    "dropphyadd": "1401 W FRONT ST",
    "dropphycty": "GOLDTHWAITE",
    "dropphyst": "TX",
    "dropphyzpp": 768449998,
    "dropmaladd": "1401 W FRONT ST",
    "dropmalcty": "GOLDTHWAITE",
    "dropmalst": "TX",
    "dropmalzpp": 768449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256486403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23917",
    "droptype": "D",
    "dropname": "GOLIAD",
    "dropdeladd": "151 W END ST",
    "dropdelcty": "GOLIAD",
    "dropdelst": "TX",
    "dropdelzpp": 779639998,
    "dropphyadd": "151 W END ST",
    "dropphycty": "GOLIAD",
    "dropphyst": "TX",
    "dropphyzpp": 779639998,
    "dropmaladd": "151 W END ST",
    "dropmalcty": "GOLIAD",
    "dropmalst": "TX",
    "dropmalzpp": 779639998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3616453565,
    "dropsitcph": 3616453565,
    "dropfax": 3616453653
  },
  {
    "dcode": "D",
    "dropkey": "PW23919",
    "droptype": "D",
    "dropname": "GONZALES",
    "dropdeladd": "920 N SAINT JOSEPH ST STE 105",
    "dropdelcty": "GONZALES",
    "dropdelst": "TX",
    "dropdelzpp": 786299998,
    "dropphyadd": "920 N SAINT JOSEPH ST STE 105",
    "dropphycty": "GONZALES",
    "dropphyst": "TX",
    "dropphyzpp": 786299998,
    "dropmaladd": "920 N SAINT JOSEPH ST STE 105",
    "dropmalcty": "GONZALES",
    "dropmalst": "TX",
    "dropmalzpp": 786299998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306722629,
    "dropsitcph": 8306722629,
    "dropfax": 8306727527
  },
  {
    "dcode": "D",
    "dropkey": "PW23925",
    "droptype": "D",
    "dropname": "GOODRICH",
    "dropdeladd": "7440 US HIGHWAY 59 S",
    "dropdelcty": "GOODRICH",
    "dropdelst": "TX",
    "dropdelzpp": 773351410,
    "dropphyadd": "7440 US HIGHWAY 59 S",
    "dropphycty": "GOODRICH",
    "dropphyst": "TX",
    "dropphyzpp": 773351410,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODRICH",
    "dropmalst": "TX",
    "dropmalzpp": 773359998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363652134,
    "dropsitcph": 9363652134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23927",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "GORDON",
    "dropdelst": "TX",
    "dropdelzpp": 764539998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "GORDON",
    "dropphyst": "TX",
    "dropphyzpp": 764539998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "GORDON",
    "dropmalst": "TX",
    "dropmalzpp": 764539998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546935524,
    "dropsitcph": 2546935524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23928",
    "droptype": "D",
    "dropname": "GORDONVILLE",
    "dropdeladd": "17371 FM 901",
    "dropdelcty": "GORDONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 762459998,
    "dropphyadd": "17371 FM 901",
    "dropphycty": "GORDONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 762459998,
    "dropmaladd": "17371 FM 901",
    "dropmalcty": "GORDONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 762459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9035234015,
    "dropsitcph": 9035234015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23929",
    "droptype": "D",
    "dropname": "GOREE",
    "dropdeladd": "105 N 5TH ST",
    "dropdelcty": "GOREE",
    "dropdelst": "TX",
    "dropdelzpp": 763639998,
    "dropphyadd": "105 N 5TH ST",
    "dropphycty": "GOREE",
    "dropphyst": "TX",
    "dropphyzpp": 763639998,
    "dropmaladd": "105 N 5TH ST",
    "dropmalcty": "GOREE",
    "dropmalst": "TX",
    "dropmalzpp": 763639998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404225287,
    "dropsitcph": 9404225287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23930",
    "droptype": "D",
    "dropname": "GORMAN",
    "dropdeladd": "112 N KENT ST",
    "dropdelcty": "GORMAN",
    "dropdelst": "TX",
    "dropdelzpp": 764549998,
    "dropphyadd": "112 N KENT ST",
    "dropphycty": "GORMAN",
    "dropphyst": "TX",
    "dropphyzpp": 764549998,
    "dropmaladd": "112 N KENT ST",
    "dropmalcty": "GORMAN",
    "dropmalst": "TX",
    "dropmalzpp": 764549998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547342422,
    "dropsitcph": 2547342422,
    "dropfax": 2547342179
  },
  {
    "dcode": "D",
    "dropkey": "PW23931",
    "droptype": "D",
    "dropname": "GOULDBUSK",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "GOULDBUSK",
    "dropdelst": "TX",
    "dropdelzpp": 768459998,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "GOULDBUSK",
    "dropphyst": "TX",
    "dropphyzpp": 768459998,
    "dropmaladd": "500 MAIN ST",
    "dropmalcty": "GOULDBUSK",
    "dropmalst": "TX",
    "dropmalzpp": 768459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253574489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23934",
    "droptype": "D",
    "dropname": "GRAFORD",
    "dropdeladd": "118 N MAIN ST",
    "dropdelcty": "GRAFORD",
    "dropdelst": "TX",
    "dropdelzpp": 764499998,
    "dropphyadd": "118 N MAIN ST",
    "dropphycty": "GRAFORD",
    "dropphyst": "TX",
    "dropphyzpp": 764499998,
    "dropmaladd": "118 N MAIN ST",
    "dropmalcty": "GRAFORD",
    "dropmalst": "TX",
    "dropmalzpp": 764499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406643372,
    "dropsitcph": 9406643372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23935",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "100 TENNESSEE ST",
    "dropdelcty": "GRAHAM",
    "dropdelst": "TX",
    "dropdelzpp": 764502243,
    "dropphyadd": "100 TENNESSEE ST",
    "dropphycty": "GRAHAM",
    "dropphyst": "TX",
    "dropphyzpp": 764502243,
    "dropmaladd": "100 TENNESSEE ST",
    "dropmalcty": "GRAHAM",
    "dropmalst": "TX",
    "dropmalzpp": 764502243,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405491333,
    "dropsitcph": 9405491333,
    "dropfax": 9405490867
  },
  {
    "dcode": "D",
    "dropkey": "PW23936",
    "droptype": "D",
    "dropname": "GRANBURY",
    "dropdeladd": "530 N CROCKETT ST",
    "dropdelcty": "GRANBURY",
    "dropdelst": "TX",
    "dropdelzpp": 760489998,
    "dropphyadd": "530 N CROCKETT ST",
    "dropphycty": "GRANBURY",
    "dropphyst": "TX",
    "dropphyzpp": 760489998,
    "dropmaladd": "530 N CROCKETT ST",
    "dropmalcty": "GRANBURY",
    "dropmalst": "TX",
    "dropmalzpp": 760489998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175735515,
    "dropsitcph": 8175735515,
    "dropfax": 8172799998
  },
  {
    "dcode": "D",
    "dropkey": "PW23938",
    "droptype": "D",
    "dropname": "GRAND PRAIRIE",
    "dropdeladd": "802 S CARRIER PKWY",
    "dropdelcty": "GRAND PRAIRIE",
    "dropdelst": "TX",
    "dropdelzpp": 750519998,
    "dropphyadd": "802 S CARRIER PKWY",
    "dropphycty": "GRAND PRAIRIE",
    "dropphyst": "TX",
    "dropphyzpp": 750519998,
    "dropmaladd": "802 S CARRIER PKWY",
    "dropmalcty": "GRAND PRAIRIE",
    "dropmalst": "TX",
    "dropmalzpp": 750519998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722372645,
    "dropsitcph": 9722372645,
    "dropfax": 9722641374
  },
  {
    "dcode": "D",
    "dropkey": "PW23940",
    "droptype": "D",
    "dropname": "GRAND SALINE",
    "dropdeladd": "200 N GREEN ST",
    "dropdelcty": "GRAND SALINE",
    "dropdelst": "TX",
    "dropdelzpp": 751409998,
    "dropphyadd": "200 N GREEN ST",
    "dropphycty": "GRAND SALINE",
    "dropphyst": "TX",
    "dropphyzpp": 751409998,
    "dropmaladd": "200 N GREEN ST",
    "dropmalcty": "GRAND SALINE",
    "dropmalst": "TX",
    "dropmalzpp": 751409998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9039623326,
    "dropsitcph": 9039623326,
    "dropfax": 9039627248
  },
  {
    "dcode": "D",
    "dropkey": "PW23941",
    "droptype": "D",
    "dropname": "GRANDFALLS",
    "dropdeladd": "214 N AVENUE D",
    "dropdelcty": "GRANDFALLS",
    "dropdelst": "TX",
    "dropdelzpp": 797429800,
    "dropphyadd": "214 N AVENUE D",
    "dropphycty": "GRANDFALLS",
    "dropphyst": "TX",
    "dropphyzpp": 797429800,
    "dropmaladd": "PO BOX 20",
    "dropmalcty": "GRANDFALLS",
    "dropmalst": "TX",
    "dropmalzpp": 797429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4325472330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23942",
    "droptype": "D",
    "dropname": "GRANDVIEW",
    "dropdeladd": "900 E CRINER ST",
    "dropdelcty": "GRANDVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 760509998,
    "dropphyadd": "900 E CRINER ST",
    "dropphycty": "GRANDVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 760509998,
    "dropmaladd": "900 E CRINER ST",
    "dropmalcty": "GRANDVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 760509998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178663303,
    "dropsitcph": 8178663303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23945",
    "droptype": "D",
    "dropname": "GRANGER",
    "dropdeladd": "117 W DAVILLA ST",
    "dropdelcty": "GRANGER",
    "dropdelst": "TX",
    "dropdelzpp": 765309998,
    "dropphyadd": "117 W DAVILLA ST",
    "dropphycty": "GRANGER",
    "dropphyst": "TX",
    "dropphyzpp": 765309998,
    "dropmaladd": "117 W DAVILLA ST",
    "dropmalcty": "GRANGER",
    "dropmalst": "TX",
    "dropmalzpp": 765309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128592836,
    "dropsitcph": 5128592836,
    "dropfax": 5128592836
  },
  {
    "dcode": "D",
    "dropkey": "PW23951",
    "droptype": "D",
    "dropname": "GRAPELAND",
    "dropdeladd": "309 W CHESTNUT ST",
    "dropdelcty": "GRAPELAND",
    "dropdelst": "TX",
    "dropdelzpp": 758449998,
    "dropphyadd": "309 W CHESTNUT ST",
    "dropphycty": "GRAPELAND",
    "dropphyst": "TX",
    "dropphyzpp": 758449998,
    "dropmaladd": "309 W CHESTNUT ST",
    "dropmalcty": "GRAPELAND",
    "dropmalst": "TX",
    "dropmalzpp": 758449998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366872330,
    "dropsitcph": 9366872330,
    "dropfax": 9366872330
  },
  {
    "dcode": "D",
    "dropkey": "PW23952",
    "droptype": "D",
    "dropname": "GRAPEVINE",
    "dropdeladd": "1251 WILLIAM D TATE AVE",
    "dropdelcty": "GRAPEVINE",
    "dropdelst": "TX",
    "dropdelzpp": 760519998,
    "dropphyadd": "1251 WILLIAM D TATE AVE",
    "dropphycty": "GRAPEVINE",
    "dropphyst": "TX",
    "dropphyzpp": 760519998,
    "dropmaladd": "1251 WILLIAM D TATE AVE",
    "dropmalcty": "GRAPEVINE",
    "dropmalst": "TX",
    "dropmalzpp": 760519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174883343,
    "dropsitcph": 8174889402,
    "dropfax": 8172510909
  },
  {
    "dcode": "D",
    "dropkey": "PW23962",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "3701 STANFORD ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754019998,
    "dropphyadd": "3701 STANFORD ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754019998,
    "dropmaladd": "3701 STANFORD ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754019998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034555363,
    "dropsitcph": 9034555363,
    "dropfax": 9034540498
  },
  {
    "dcode": "D",
    "dropkey": "PW23969",
    "droptype": "D",
    "dropname": "GREGORY",
    "dropdeladd": "102 W 4TH ST",
    "dropdelcty": "GREGORY",
    "dropdelst": "TX",
    "dropdelzpp": 783599800,
    "dropphyadd": "102 W 4TH ST",
    "dropphycty": "GREGORY",
    "dropphyst": "TX",
    "dropphyzpp": 783599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREGORY",
    "dropmalst": "TX",
    "dropmalzpp": 783599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617773413,
    "dropsitcph": 3617773413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23980",
    "droptype": "D",
    "dropname": "GROESBECK",
    "dropdeladd": "112 S DR J B RIGGS DR",
    "dropdelcty": "GROESBECK",
    "dropdelst": "TX",
    "dropdelzpp": 766429998,
    "dropphyadd": "112 S DR J B RIGGS DR",
    "dropphycty": "GROESBECK",
    "dropphyst": "TX",
    "dropphyzpp": 766429998,
    "dropmaladd": "112 S DR J B RIGGS DR",
    "dropmalcty": "GROESBECK",
    "dropmalst": "TX",
    "dropmalzpp": 766429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547293304,
    "dropsitcph": 2547293304,
    "dropfax": 2547293001
  },
  {
    "dcode": "D",
    "dropkey": "PW23981",
    "droptype": "D",
    "dropname": "GROOM",
    "dropdeladd": "104 W 1ST ST",
    "dropdelcty": "GROOM",
    "dropdelst": "TX",
    "dropdelzpp": 790399802,
    "dropphyadd": "104 W 1ST ST",
    "dropphycty": "GROOM",
    "dropphyst": "TX",
    "dropphyzpp": 790399802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GROOM",
    "dropmalst": "TX",
    "dropmalzpp": 790399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062487988,
    "dropsitcph": 8062487988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23983",
    "droptype": "D",
    "dropname": "GROVES",
    "dropdeladd": "6230 39TH ST",
    "dropdelcty": "GROVES",
    "dropdelst": "TX",
    "dropdelzpp": 776199998,
    "dropphyadd": "6230 39TH ST",
    "dropphycty": "GROVES",
    "dropphyst": "TX",
    "dropphyzpp": 776199998,
    "dropmaladd": "6230 39TH ST",
    "dropmalcty": "GROVES",
    "dropmalst": "TX",
    "dropmalzpp": 776199998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099627490,
    "dropsitcph": 4099625361,
    "dropfax": 4099633538
  },
  {
    "dcode": "D",
    "dropkey": "PW23984",
    "droptype": "D",
    "dropname": "GROVETON",
    "dropdeladd": "147 E 2ND ST",
    "dropdelcty": "GROVETON",
    "dropdelst": "TX",
    "dropdelzpp": 758459998,
    "dropphyadd": "147 E 2ND ST",
    "dropphycty": "GROVETON",
    "dropphyst": "TX",
    "dropphyzpp": 758459998,
    "dropmaladd": "147 E 2ND ST",
    "dropmalcty": "GROVETON",
    "dropmalst": "TX",
    "dropmalzpp": 758459998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362155409,
    "dropsitcph": 9362155409,
    "dropfax": 9366422875
  },
  {
    "dcode": "D",
    "dropkey": "PW23985",
    "droptype": "D",
    "dropname": "GRULLA",
    "dropdeladd": "247 FM 2360",
    "dropdelcty": "GRULLA",
    "dropdelst": "TX",
    "dropdelzpp": 785489800,
    "dropphyadd": "247 FM 2360",
    "dropphycty": "GRULLA",
    "dropphyst": "TX",
    "dropphyzpp": 785489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRULLA",
    "dropmalst": "TX",
    "dropmalzpp": 785489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564876101,
    "dropsitcph": 9564876101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23986",
    "droptype": "D",
    "dropname": "GRUVER",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "GRUVER",
    "dropdelst": "TX",
    "dropdelzpp": 790409802,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "GRUVER",
    "dropphyst": "TX",
    "dropphyzpp": 790409802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRUVER",
    "dropmalst": "TX",
    "dropmalzpp": 790409998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067332841,
    "dropsitcph": 8067332841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23989",
    "droptype": "D",
    "dropname": "GUERRA",
    "dropdeladd": "502 N SMITH AVE",
    "dropdelcty": "HEBBRONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 783619998,
    "dropphyadd": "502 N SMITH AVE",
    "dropphycty": "HEBBRONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 783619997,
    "dropmaladd": "502 N SMITH AVE",
    "dropmalcty": "HEBBRONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 783619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564862356,
    "dropsitcph": 9564862356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23995",
    "droptype": "D",
    "dropname": "GUNTER",
    "dropdeladd": "500 W MAIN ST",
    "dropdelcty": "GUNTER",
    "dropdelst": "TX",
    "dropdelzpp": 750589998,
    "dropphyadd": "500 W MAIN ST",
    "dropphycty": "GUNTER",
    "dropphyst": "TX",
    "dropphyzpp": 750589998,
    "dropmaladd": "500 W MAIN ST",
    "dropmalcty": "GUNTER",
    "dropmalst": "TX",
    "dropmalzpp": 750589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034333725,
    "dropsitcph": 9034333725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23996",
    "droptype": "D",
    "dropname": "GUSTINE",
    "dropdeladd": "213 E MAIN ST",
    "dropdelcty": "GUSTINE",
    "dropdelst": "TX",
    "dropdelzpp": 764559802,
    "dropphyadd": "213 E MAIN ST",
    "dropphycty": "GUSTINE",
    "dropphyst": "TX",
    "dropphyzpp": 764559802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUSTINE",
    "dropmalst": "TX",
    "dropmalzpp": 764559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256677402,
    "dropsitcph": 3256677402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23997",
    "droptype": "D",
    "dropname": "GUTHRIE",
    "dropdeladd": "600 N HIGHWAY 83",
    "dropdelcty": "GUTHRIE",
    "dropdelst": "TX",
    "dropdelzpp": 792369800,
    "dropphyadd": "600 N HIGHWAY 83",
    "dropphycty": "GUTHRIE",
    "dropphyst": "TX",
    "dropphyzpp": 792369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUTHRIE",
    "dropmalst": "TX",
    "dropmalzpp": 792369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065964540,
    "dropsitcph": 8065964540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW23998",
    "droptype": "D",
    "dropname": "GUY",
    "dropdeladd": "18623 HIGHWAY 36",
    "dropdelcty": "GUY",
    "dropdelst": "TX",
    "dropdelzpp": 774448730,
    "dropphyadd": "18623 HIGHWAY 36",
    "dropphycty": "GUY",
    "dropphyst": "TX",
    "dropphyzpp": 774448730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUY",
    "dropmalst": "TX",
    "dropmalzpp": 774449998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797934651,
    "dropsitcph": 9797934651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24005",
    "droptype": "D",
    "dropname": "HALE CENTER",
    "dropdeladd": "203 W STEVENSON AVE",
    "dropdelcty": "HALE CENTER",
    "dropdelst": "TX",
    "dropdelzpp": 790419435,
    "dropphyadd": "203 W STEVENSON AVE",
    "dropphycty": "HALE CENTER",
    "dropphyst": "TX",
    "dropphyzpp": 790419435,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALE CENTER",
    "dropmalst": "TX",
    "dropmalzpp": 790419998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8068392331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24006",
    "droptype": "D",
    "dropname": "HALLETTSVILLE",
    "dropdeladd": "206 S LA GRANGE ST",
    "dropdelcty": "HALLETTSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 779649998,
    "dropphyadd": "206 S LA GRANGE ST",
    "dropphycty": "HALLETTSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 779649998,
    "dropmaladd": "206 S LA GRANGE ST",
    "dropmalcty": "HALLETTSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 779649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617982281,
    "dropsitcph": 3617982281,
    "dropfax": 3617983483
  },
  {
    "dcode": "D",
    "dropkey": "PW24009",
    "droptype": "D",
    "dropname": "HALLSVILLE",
    "dropdeladd": "208 E MAIN ST",
    "dropdelcty": "HALLSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756509998,
    "dropphyadd": "208 E MAIN ST",
    "dropphycty": "HALLSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756509998,
    "dropmaladd": "208 E MAIN ST",
    "dropmalcty": "HALLSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756509998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036682962,
    "dropsitcph": 9036682962,
    "dropfax": 9036603532
  },
  {
    "dcode": "D",
    "dropkey": "PW24013",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "120 S RICE ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "TX",
    "dropdelzpp": 765319998,
    "dropphyadd": "120 S RICE ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "TX",
    "dropphyzpp": 765319998,
    "dropmaladd": "120 S RICE ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "TX",
    "dropmalzpp": 765319998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543865115,
    "dropsitcph": 2543865115,
    "dropfax": 2543868328
  },
  {
    "dcode": "D",
    "dropkey": "PW24014",
    "droptype": "D",
    "dropname": "HAMLIN",
    "dropdeladd": "225 SE AVENUE A",
    "dropdelcty": "HAMLIN",
    "dropdelst": "TX",
    "dropdelzpp": 795209998,
    "dropphyadd": "225 SE AVENUE A",
    "dropphycty": "HAMLIN",
    "dropphyst": "TX",
    "dropphyzpp": 795209998,
    "dropmaladd": "225 SE AVENUE A",
    "dropmalcty": "HAMLIN",
    "dropmalst": "TX",
    "dropmalzpp": 795209998,
    "dropsitphn": 3255762291,
    "dropsitlph": 3255762291,
    "dropsitcph": 3255762291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24017",
    "droptype": "D",
    "dropname": "HAMSHIRE",
    "dropdeladd": "25142 HIGHWAY 124",
    "dropdelcty": "HAMSHIRE",
    "dropdelst": "TX",
    "dropdelzpp": 776220015,
    "dropphyadd": "25142 HIGHWAY 124",
    "dropphycty": "HAMSHIRE",
    "dropphyst": "TX",
    "dropphyzpp": 776220015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMSHIRE",
    "dropmalst": "TX",
    "dropmalzpp": 776229998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092432184,
    "dropsitcph": 4092432184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24019",
    "droptype": "D",
    "dropname": "HANKAMER",
    "dropdeladd": "9322 STATE HIGHWAY 61",
    "dropdelcty": "HANKAMER",
    "dropdelst": "TX",
    "dropdelzpp": 775609800,
    "dropphyadd": "9322 STATE HIGHWAY 61",
    "dropphycty": "HANKAMER",
    "dropphyst": "TX",
    "dropphyzpp": 775609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANKAMER",
    "dropmalst": "TX",
    "dropmalzpp": 775609998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4093742158,
    "dropsitcph": 4093742158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24021",
    "droptype": "D",
    "dropname": "HAPPY",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "HAPPY",
    "dropdelst": "TX",
    "dropdelzpp": 790429803,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "HAPPY",
    "dropphyst": "TX",
    "dropphyzpp": 790429803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAPPY",
    "dropmalst": "TX",
    "dropmalzpp": 790429998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065584051,
    "dropsitcph": 8065584051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24023",
    "droptype": "D",
    "dropname": "HARDIN",
    "dropdeladd": "11158 HIGHWAY 146 N",
    "dropdelcty": "HARDIN",
    "dropdelst": "TX",
    "dropdelzpp": 775619800,
    "dropphyadd": "11158 HIGHWAY 146 N",
    "dropphycty": "HARDIN",
    "dropphyst": "TX",
    "dropphyzpp": 775619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARDIN",
    "dropmalst": "TX",
    "dropmalzpp": 775619998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362982123,
    "dropsitcph": 9362982123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24027",
    "droptype": "D",
    "dropname": "HARGILL",
    "dropdeladd": "110 N FORBES",
    "dropdelcty": "HARGILL",
    "dropdelst": "TX",
    "dropdelzpp": 785499800,
    "dropphyadd": "110 N FORBES",
    "dropphycty": "HARGILL",
    "dropphyst": "TX",
    "dropphyzpp": 785499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARGILL",
    "dropmalst": "TX",
    "dropmalzpp": 785499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568456688,
    "dropsitcph": 9568456688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24032",
    "droptype": "D",
    "dropname": "HARLETON",
    "dropdeladd": "17017 STATE HIGHWAY 154",
    "dropdelcty": "HARLETON",
    "dropdelst": "TX",
    "dropdelzpp": 756519998,
    "dropphyadd": "17017 STATE HIGHWAY 154",
    "dropphycty": "HARLETON",
    "dropphyst": "TX",
    "dropphyzpp": 756519998,
    "dropmaladd": "17017 STATE HIGHWAY 154",
    "dropmalcty": "HARLETON",
    "dropmalst": "TX",
    "dropmalzpp": 756519998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037773062,
    "dropsitcph": 9037773062,
    "dropfax": 9037773062
  },
  {
    "dcode": "D",
    "dropkey": "PW24033",
    "droptype": "D",
    "dropname": "HARLINGEN",
    "dropdeladd": "1502 NEW COMBES HWY",
    "dropdelcty": "HARLINGEN",
    "dropdelst": "TX",
    "dropdelzpp": 785509998,
    "dropphyadd": "1502 NEW COMBES HWY",
    "dropphycty": "HARLINGEN",
    "dropphyst": "TX",
    "dropphyzpp": 785509998,
    "dropmaladd": "1502 NEW COMBES HWY",
    "dropmalcty": "HARLINGEN",
    "dropmalst": "TX",
    "dropmalzpp": 785509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564231464,
    "dropsitcph": 9564231464,
    "dropfax": 9564231117
  },
  {
    "dcode": "D",
    "dropkey": "PW24035",
    "droptype": "D",
    "dropname": "HARPER",
    "dropdeladd": "23557 W US HIGHWAY 290",
    "dropdelcty": "HARPER",
    "dropdelst": "TX",
    "dropdelzpp": 786314900,
    "dropphyadd": "23557 W US HIGHWAY 290",
    "dropphycty": "HARPER",
    "dropphyst": "TX",
    "dropphyzpp": 786314900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARPER",
    "dropmalst": "TX",
    "dropmalzpp": 786319997,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308644466,
    "dropsitcph": 8308644466,
    "dropfax": 8308644747
  },
  {
    "dcode": "D",
    "dropkey": "PW24039",
    "droptype": "D",
    "dropname": "HART",
    "dropdeladd": "600 BROADWAY ST",
    "dropdelcty": "HART",
    "dropdelst": "TX",
    "dropdelzpp": 790439804,
    "dropphyadd": "600 BROADWAY ST",
    "dropphycty": "HART",
    "dropphyst": "TX",
    "dropphyzpp": 790439804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HART",
    "dropmalst": "TX",
    "dropmalzpp": 790439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069382104,
    "dropsitcph": 8069382104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24040",
    "droptype": "D",
    "dropname": "HARTLEY",
    "dropdeladd": "210 WHITE ST",
    "dropdelcty": "HARTLEY",
    "dropdelst": "TX",
    "dropdelzpp": 790449800,
    "dropphyadd": "210 WHITE ST",
    "dropphycty": "HARTLEY",
    "dropphyst": "TX",
    "dropphyzpp": 790449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTLEY",
    "dropmalst": "TX",
    "dropmalzpp": 790449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063650065,
    "dropsitcph": 8063650065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24042",
    "droptype": "D",
    "dropname": "HARWOOD",
    "dropdeladd": "13078 US HIGHWAY 90 W",
    "dropdelcty": "HARWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 786324763,
    "dropphyadd": "13078 US HIGHWAY 90 W",
    "dropphycty": "HARWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 786324763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 786329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305404236,
    "dropsitcph": 8305404236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24043",
    "droptype": "D",
    "dropname": "HASKELL",
    "dropdeladd": "201 S 1ST ST",
    "dropdelcty": "HASKELL",
    "dropdelst": "TX",
    "dropdelzpp": 795215940,
    "dropphyadd": "201 S 1ST ST",
    "dropphycty": "HASKELL",
    "dropphyst": "TX",
    "dropphyzpp": 795215940,
    "dropmaladd": "201 S 1ST ST",
    "dropmalcty": "HASKELL",
    "dropmalst": "TX",
    "dropmalzpp": 795215940,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408642811,
    "dropsitcph": 9408642811,
    "dropfax": 9408643690
  },
  {
    "dcode": "D",
    "dropkey": "PW24045",
    "droptype": "D",
    "dropname": "HASLET",
    "dropdeladd": "1097 SCHOOLHOUSE RD",
    "dropdelcty": "HASLET",
    "dropdelst": "TX",
    "dropdelzpp": 760529998,
    "dropphyadd": "1097 SCHOOLHOUSE RD",
    "dropphycty": "HASLET",
    "dropphyst": "TX",
    "dropphyzpp": 760529998,
    "dropmaladd": "1097 SCHOOLHOUSE RD",
    "dropmalcty": "HASLET",
    "dropmalst": "TX",
    "dropmalzpp": 760529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174391364,
    "dropsitcph": 8174391594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24050",
    "droptype": "D",
    "dropname": "HAWKINS",
    "dropdeladd": "969 N BEAULAH ST",
    "dropdelcty": "HAWKINS",
    "dropdelst": "TX",
    "dropdelzpp": 757659998,
    "dropphyadd": "969 N BEAULAH ST",
    "dropphycty": "HAWKINS",
    "dropphyst": "TX",
    "dropphyzpp": 757659998,
    "dropmaladd": "969 N BEAULAH ST",
    "dropmalcty": "HAWKINS",
    "dropmalst": "TX",
    "dropmalzpp": 757659998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037692751,
    "dropsitcph": 9037692751,
    "dropfax": 9037692755
  },
  {
    "dcode": "D",
    "dropkey": "PW24051",
    "droptype": "D",
    "dropname": "HAWLEY",
    "dropdeladd": "525 E ACCESS RD",
    "dropdelcty": "HAWLEY",
    "dropdelst": "TX",
    "dropdelzpp": 795259998,
    "dropphyadd": "525 E ACCESS RD",
    "dropphycty": "HAWLEY",
    "dropphyst": "TX",
    "dropphyzpp": 795259998,
    "dropmaladd": "525 E ACCESS RD",
    "dropmalcty": "HAWLEY",
    "dropmalst": "TX",
    "dropmalzpp": 795259998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255372290,
    "dropsitcph": 3255372290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24053",
    "droptype": "D",
    "dropname": "HEARNE",
    "dropdeladd": "600 W 1ST ST",
    "dropdelcty": "HEARNE",
    "dropdelst": "TX",
    "dropdelzpp": 778599998,
    "dropphyadd": "600 W 1ST ST",
    "dropphycty": "HEARNE",
    "dropphyst": "TX",
    "dropphyzpp": 778599998,
    "dropmaladd": "600 W 1ST ST",
    "dropmalcty": "HEARNE",
    "dropmalst": "TX",
    "dropmalzpp": 778599998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792792452,
    "dropsitcph": 9792792452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24055",
    "droptype": "D",
    "dropname": "HEBBRONVILLE",
    "dropdeladd": "502 N SMITH AVE",
    "dropdelcty": "HEBBRONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 783619998,
    "dropphyadd": "502 N SMITH AVE",
    "dropphycty": "HEBBRONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 783619998,
    "dropmaladd": "502 N SMITH AVE",
    "dropmalcty": "HEBBRONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 783619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615273465,
    "dropsitcph": 3615273465,
    "dropfax": 3615273695
  },
  {
    "dcode": "D",
    "dropkey": "PW24056",
    "droptype": "D",
    "dropname": "HEDLEY",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "HEDLEY",
    "dropdelst": "TX",
    "dropdelzpp": 792379998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "HEDLEY",
    "dropphyst": "TX",
    "dropphyzpp": 792379998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "HEDLEY",
    "dropmalst": "TX",
    "dropmalzpp": 792379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068565221,
    "dropsitcph": 8068565221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24059",
    "droptype": "D",
    "dropname": "HEIDENHEIMER",
    "dropdeladd": "5720 E US HIGHWAY 190",
    "dropdelcty": "HEIDENHEIMER",
    "dropdelst": "TX",
    "dropdelzpp": 765339800,
    "dropphyadd": "5720 E US HIGHWAY 190",
    "dropphycty": "HEIDENHEIMER",
    "dropphyst": "TX",
    "dropphyzpp": 765339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEIDENHEIMER",
    "dropmalst": "TX",
    "dropmalzpp": 765339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549835131,
    "dropsitcph": 2549835131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24064",
    "droptype": "D",
    "dropname": "HELOTES",
    "dropdeladd": "12790 FM 1560 N",
    "dropdelcty": "HELOTES",
    "dropdelst": "TX",
    "dropdelzpp": 780239998,
    "dropphyadd": "12790 FM 1560 N",
    "dropphycty": "HELOTES",
    "dropphyst": "TX",
    "dropphyzpp": 780239998,
    "dropmaladd": "12790 FM 1560 N",
    "dropmalcty": "HELOTES",
    "dropmalst": "TX",
    "dropmalzpp": 780239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106955236,
    "dropsitcph": 2106955219,
    "dropfax": 2106958752
  },
  {
    "dcode": "D",
    "dropkey": "PW24065",
    "droptype": "D",
    "dropname": "HEMPHILL",
    "dropdeladd": "255 N TEXAS ST",
    "dropdelcty": "HEMPHILL",
    "dropdelst": "TX",
    "dropdelzpp": 759489998,
    "dropphyadd": "255 N TEXAS ST",
    "dropphycty": "HEMPHILL",
    "dropphyst": "TX",
    "dropphyzpp": 759489998,
    "dropmaladd": "255 N TEXAS ST",
    "dropmalcty": "HEMPHILL",
    "dropmalst": "TX",
    "dropmalzpp": 759489998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4097872565,
    "dropsitcph": 4097872565,
    "dropfax": 4097873152
  },
  {
    "dcode": "D",
    "dropkey": "PW24066",
    "droptype": "D",
    "dropname": "HEMPSTEAD",
    "dropdeladd": "901 12TH ST",
    "dropdelcty": "HEMPSTEAD",
    "dropdelst": "TX",
    "dropdelzpp": 774459998,
    "dropphyadd": "901 12TH ST",
    "dropphycty": "HEMPSTEAD",
    "dropphyst": "TX",
    "dropphyzpp": 774459998,
    "dropmaladd": "901 12TH ST",
    "dropmalcty": "HEMPSTEAD",
    "dropmalst": "TX",
    "dropmalzpp": 774459998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798262446,
    "dropsitcph": 9798262446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24067",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "505 S MAIN ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "TX",
    "dropdelzpp": 756549998,
    "dropphyadd": "505 S MAIN ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "TX",
    "dropphyzpp": 756549998,
    "dropmaladd": "505 S MAIN ST",
    "dropmalcty": "HENDERSON",
    "dropmalst": "TX",
    "dropmalzpp": 756549998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036571481,
    "dropsitcph": 9036571481,
    "dropfax": 9036556900
  },
  {
    "dcode": "D",
    "dropkey": "PW24071",
    "droptype": "D",
    "dropname": "HENRIETTA",
    "dropdeladd": "202 W IKARD ST",
    "dropdelcty": "HENRIETTA",
    "dropdelst": "TX",
    "dropdelzpp": 763659998,
    "dropphyadd": "202 W IKARD ST",
    "dropphycty": "HENRIETTA",
    "dropphyst": "TX",
    "dropphyzpp": 763659998,
    "dropmaladd": "202 W IKARD ST",
    "dropmalcty": "HENRIETTA",
    "dropmalst": "TX",
    "dropmalzpp": 763659998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405385051,
    "dropsitcph": 9405385051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24073",
    "droptype": "D",
    "dropname": "HEREFORD",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "HEREFORD",
    "dropdelst": "TX",
    "dropdelzpp": 790459998,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "HEREFORD",
    "dropphyst": "TX",
    "dropphyzpp": 790459998,
    "dropmaladd": "408 MAIN ST",
    "dropmalcty": "HEREFORD",
    "dropmalst": "TX",
    "dropmalzpp": 790459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063642054,
    "dropsitcph": 8063642054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24075",
    "droptype": "D",
    "dropname": "HERMLEIGH",
    "dropdeladd": "580 JAMES ST",
    "dropdelcty": "HERMLEIGH",
    "dropdelst": "TX",
    "dropdelzpp": 795269998,
    "dropphyadd": "580 JAMES ST",
    "dropphycty": "HERMLEIGH",
    "dropphyst": "TX",
    "dropphyzpp": 795269998,
    "dropmaladd": "580 JAMES ST",
    "dropmalcty": "HERMLEIGH",
    "dropmalst": "TX",
    "dropmalzpp": 795269998,
    "dropsitphn": 3258632411,
    "dropsitlph": 3258632411,
    "dropsitcph": 3258632411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24077",
    "droptype": "D",
    "dropname": "HEWITT",
    "dropdeladd": "901 S HEWITT DR",
    "dropdelcty": "HEWITT",
    "dropdelst": "TX",
    "dropdelzpp": 766433273,
    "dropphyadd": "901 S HEWITT DR",
    "dropphycty": "HEWITT",
    "dropphyst": "TX",
    "dropphyzpp": 766433273,
    "dropmaladd": "901 S HEWITT DR",
    "dropmalcty": "HEWITT",
    "dropmalst": "TX",
    "dropmalzpp": 766433273,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546667787,
    "dropsitcph": 2546667787,
    "dropfax": 2546661321
  },
  {
    "dcode": "D",
    "dropkey": "PW24078",
    "droptype": "D",
    "dropname": "HEXT",
    "dropdeladd": "15193 STATE HIGHWAY 29",
    "dropdelcty": "HEXT",
    "dropdelst": "TX",
    "dropdelzpp": 768489870,
    "dropphyadd": "15193 STATE HIGHWAY 29",
    "dropphycty": "HEXT",
    "dropphyst": "TX",
    "dropphyzpp": 768489870,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEXT",
    "dropmalst": "TX",
    "dropmalzpp": 768489998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253962050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24081",
    "droptype": "D",
    "dropname": "HICO",
    "dropdeladd": "112 E 1ST ST",
    "dropdelcty": "HICO",
    "dropdelst": "TX",
    "dropdelzpp": 764579998,
    "dropphyadd": "112 E 1ST ST",
    "dropphycty": "HICO",
    "dropphyst": "TX",
    "dropphyzpp": 764579998,
    "dropmaladd": "112 E 1ST ST",
    "dropmalcty": "HICO",
    "dropmalst": "TX",
    "dropmalzpp": 764579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2547964821,
    "dropsitcph": 2547964821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24082",
    "droptype": "D",
    "dropname": "HIDALGO",
    "dropdeladd": "920 E COMA AVE",
    "dropdelcty": "HIDALGO",
    "dropdelst": "TX",
    "dropdelzpp": 785579998,
    "dropphyadd": "920 E COMA AVE",
    "dropphycty": "HIDALGO",
    "dropphyst": "TX",
    "dropphyzpp": 785579998,
    "dropmaladd": "920 E COMA AVE",
    "dropmalcty": "HIDALGO",
    "dropmalst": "TX",
    "dropmalzpp": 785579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568438685,
    "dropsitcph": 9568438685,
    "dropfax": 9568432168
  },
  {
    "dcode": "D",
    "dropkey": "PW24085",
    "droptype": "D",
    "dropname": "HIGGINS",
    "dropdeladd": "116 N MAIN ST",
    "dropdelcty": "HIGGINS",
    "dropdelst": "TX",
    "dropdelzpp": 790469803,
    "dropphyadd": "116 N MAIN ST",
    "dropphycty": "HIGGINS",
    "dropphyst": "TX",
    "dropphyzpp": 790469803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGGINS",
    "dropmalst": "TX",
    "dropmalzpp": 790469998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068523171,
    "dropsitcph": 8068523171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24088",
    "droptype": "D",
    "dropname": "HIGH ISLAND",
    "dropdeladd": "2008 S 5TH ST",
    "dropdelcty": "HIGH ISLAND",
    "dropdelst": "TX",
    "dropdelzpp": 776230135,
    "dropphyadd": "2008 S 5TH ST",
    "dropphycty": "HIGH ISLAND",
    "dropphyst": "TX",
    "dropphyzpp": 776230135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGH ISLAND",
    "dropmalst": "TX",
    "dropmalzpp": 776239998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092865477,
    "dropsitcph": 4092865477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24093",
    "droptype": "D",
    "dropname": "HIGHLANDS",
    "dropdeladd": "608 S MAIN ST",
    "dropdelcty": "HIGHLANDS",
    "dropdelst": "TX",
    "dropdelzpp": 775629998,
    "dropphyadd": "608 S MAIN ST",
    "dropphycty": "HIGHLANDS",
    "dropphyst": "TX",
    "dropphyzpp": 775629998,
    "dropmaladd": "608 S MAIN ST",
    "dropmalcty": "HIGHLANDS",
    "dropmalst": "TX",
    "dropmalzpp": 775629998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815021902,
    "dropsitcph": 2815021901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24097",
    "droptype": "D",
    "dropname": "HILLISTER",
    "dropdeladd": "283 FM 1013 RD",
    "dropdelcty": "HILLISTER",
    "dropdelst": "TX",
    "dropdelzpp": 776240001,
    "dropphyadd": "283 FM 1013 RD",
    "dropphycty": "HILLISTER",
    "dropphyst": "TX",
    "dropphyzpp": 776240001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLISTER",
    "dropmalst": "TX",
    "dropmalzpp": 776249998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092835793,
    "dropsitcph": 4092835793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24100",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "100 W FRANKLIN ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 766459998,
    "dropphyadd": "100 W FRANKLIN ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 766459998,
    "dropmaladd": "100 W FRANKLIN ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 766459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545823572,
    "dropsitcph": 2545823572,
    "dropfax": 2545825339
  },
  {
    "dcode": "D",
    "dropkey": "PW24106",
    "droptype": "D",
    "dropname": "HITCHCOCK",
    "dropdeladd": "8210 HIGHWAY 6",
    "dropdelcty": "HITCHCOCK",
    "dropdelst": "TX",
    "dropdelzpp": 775639998,
    "dropphyadd": "8210 HIGHWAY 6",
    "dropphycty": "HITCHCOCK",
    "dropphyst": "TX",
    "dropphyzpp": 775639998,
    "dropmaladd": "8210 HIGHWAY 6",
    "dropmalcty": "HITCHCOCK",
    "dropmalst": "TX",
    "dropmalzpp": 775639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099867891,
    "dropsitcph": 4099869531,
    "dropfax": 4099867789
  },
  {
    "dcode": "D",
    "dropkey": "PW24110",
    "droptype": "D",
    "dropname": "HOCKLEY",
    "dropdeladd": "17210 WARREN RANCH RD",
    "dropdelcty": "HOCKLEY",
    "dropdelst": "TX",
    "dropdelzpp": 774479998,
    "dropphyadd": "17210 WARREN RANCH RD",
    "dropphycty": "HOCKLEY",
    "dropphyst": "TX",
    "dropphyzpp": 774479998,
    "dropmaladd": "17210 WARREN RANCH RD",
    "dropmalcty": "HOCKLEY",
    "dropmalst": "TX",
    "dropmalzpp": 774479998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363723261,
    "dropsitcph": 9363723261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24113",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "205 W TRAVIS ST",
    "dropdelcty": "HOLLAND",
    "dropdelst": "TX",
    "dropdelzpp": 765349998,
    "dropphyadd": "205 W TRAVIS ST",
    "dropphycty": "HOLLAND",
    "dropphyst": "TX",
    "dropphyzpp": 765349998,
    "dropmaladd": "205 W TRAVIS ST",
    "dropmalcty": "HOLLAND",
    "dropmalst": "TX",
    "dropmalzpp": 765349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546572421,
    "dropsitcph": 2546572421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24114",
    "droptype": "D",
    "dropname": "HOLLIDAY",
    "dropdeladd": "100 E CHESTNUT ST",
    "dropdelcty": "HOLLIDAY",
    "dropdelst": "TX",
    "dropdelzpp": 763669998,
    "dropphyadd": "100 E CHESTNUT ST",
    "dropphycty": "HOLLIDAY",
    "dropphyst": "TX",
    "dropphyzpp": 763669998,
    "dropmaladd": "100 E CHESTNUT ST",
    "dropmalcty": "HOLLIDAY",
    "dropmalst": "TX",
    "dropmalzpp": 763669998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405861623,
    "dropsitcph": 9405861623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24119",
    "droptype": "D",
    "dropname": "HONDO",
    "dropdeladd": "1108 17TH ST",
    "dropdelcty": "HONDO",
    "dropdelst": "TX",
    "dropdelzpp": 788619998,
    "dropphyadd": "1108 17TH ST",
    "dropphycty": "HONDO",
    "dropphyst": "TX",
    "dropphyzpp": 788619998,
    "dropmaladd": "1108 17TH ST",
    "dropmalcty": "HONDO",
    "dropmalst": "TX",
    "dropmalzpp": 788619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304262552,
    "dropsitcph": 8304262552,
    "dropfax": 8304267125
  },
  {
    "dcode": "D",
    "dropkey": "PW24120",
    "droptype": "D",
    "dropname": "HONEY GROVE",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "HONEY GROVE",
    "dropdelst": "TX",
    "dropdelzpp": 754469998,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "HONEY GROVE",
    "dropphyst": "TX",
    "dropphyzpp": 754469998,
    "dropmaladd": "100 E MAIN ST",
    "dropmalcty": "HONEY GROVE",
    "dropmalst": "TX",
    "dropmalzpp": 754469998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033787102,
    "dropsitcph": 9033787102,
    "dropfax": 9033782576
  },
  {
    "dcode": "D",
    "dropkey": "PW24122",
    "droptype": "D",
    "dropname": "HOOKS",
    "dropdeladd": "15 E AVENUE A",
    "dropdelcty": "HOOKS",
    "dropdelst": "TX",
    "dropdelzpp": 755619998,
    "dropphyadd": "15 E AVENUE A",
    "dropphycty": "HOOKS",
    "dropphyst": "TX",
    "dropphyzpp": 755619998,
    "dropmaladd": "15 E AVENUE A",
    "dropmalcty": "HOOKS",
    "dropmalst": "TX",
    "dropmalzpp": 755619998,
    "dropsitphn": 9034174199,
    "dropsitlph": 9035476201,
    "dropsitcph": 9035476201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24130",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "1500 HADLEY ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770029998,
    "dropphyadd": "1500 HADLEY ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770029998,
    "dropmaladd": "1500 HADLEY ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770029998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263071,
    "dropsitcph": 7137390013,
    "dropfax": 7132263289
  },
  {
    "dcode": "D",
    "dropkey": "PW24132",
    "droptype": "D",
    "dropname": "HOWE",
    "dropdeladd": "101 W HANING ST",
    "dropdelcty": "HOWE",
    "dropdelst": "TX",
    "dropdelzpp": 754599998,
    "dropphyadd": "101 W HANING ST",
    "dropphycty": "HOWE",
    "dropphyst": "TX",
    "dropphyzpp": 754599998,
    "dropmaladd": "101 W HANING ST",
    "dropmalcty": "HOWE",
    "dropmalst": "TX",
    "dropmalzpp": 754599998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035325431,
    "dropsitcph": 9035325431,
    "dropfax": 9035329545
  },
  {
    "dcode": "D",
    "dropkey": "PW24136",
    "droptype": "D",
    "dropname": "HUBBARD",
    "dropdeladd": "306 N MAGNOLIA AVE",
    "dropdelcty": "HUBBARD",
    "dropdelst": "TX",
    "dropdelzpp": 766489998,
    "dropphyadd": "306 N MAGNOLIA AVE",
    "dropphycty": "HUBBARD",
    "dropphyst": "TX",
    "dropphyzpp": 766489998,
    "dropmaladd": "306 N MAGNOLIA AVE",
    "dropmalcty": "HUBBARD",
    "dropmalst": "TX",
    "dropmalzpp": 766489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545762451,
    "dropsitcph": 2545762451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24141",
    "droptype": "D",
    "dropname": "HUFFMAN",
    "dropdeladd": "24936 FM 2100 RD",
    "dropdelcty": "HUFFMAN",
    "dropdelst": "TX",
    "dropdelzpp": 773369998,
    "dropphyadd": "24936 FM 2100 RD",
    "dropphycty": "HUFFMAN",
    "dropphyst": "TX",
    "dropphyzpp": 773369998,
    "dropmaladd": "24936 FM 2100 RD",
    "dropmalcty": "HUFFMAN",
    "dropmalst": "TX",
    "dropmalzpp": 773369998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813246754,
    "dropsitcph": 2813246934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24143",
    "droptype": "D",
    "dropname": "HUGHES SPRINGS",
    "dropdeladd": "104 E 2ND",
    "dropdelcty": "HUGHES SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 756569998,
    "dropphyadd": "104 E 2ND",
    "dropphycty": "HUGHES SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 756569998,
    "dropmaladd": "104 E 2ND",
    "dropmalcty": "HUGHES SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 756569998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036392741,
    "dropsitcph": 9036392741,
    "dropfax": 9036394076
  },
  {
    "dcode": "D",
    "dropkey": "PW24145",
    "droptype": "D",
    "dropname": "HULL",
    "dropdeladd": "7404 FM 834 E",
    "dropdelcty": "HULL",
    "dropdelst": "TX",
    "dropdelzpp": 775649800,
    "dropphyadd": "7404 FM 834 E",
    "dropphycty": "HULL",
    "dropphyst": "TX",
    "dropphyzpp": 775649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HULL",
    "dropmalst": "TX",
    "dropmalzpp": 775649998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365366160,
    "dropsitcph": 9365366160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24146",
    "droptype": "D",
    "dropname": "HUMBLE",
    "dropdeladd": "1202 E 1ST ST",
    "dropdelcty": "HUMBLE",
    "dropdelst": "TX",
    "dropdelzpp": 773389998,
    "dropphyadd": "1202 E 1ST ST",
    "dropphycty": "HUMBLE",
    "dropphyst": "TX",
    "dropphyzpp": 773389998,
    "dropmaladd": "1202 E 1ST ST",
    "dropmalcty": "HUMBLE",
    "dropmalst": "TX",
    "dropmalzpp": 773389998,
    "dropsitphn": 7134463812,
    "dropsitlph": 2814463812,
    "dropsitcph": 2815401775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24147",
    "droptype": "D",
    "dropname": "HUNGERFORD",
    "dropdeladd": "210 E LIVE OAK ST",
    "dropdelcty": "HUNGERFORD",
    "dropdelst": "TX",
    "dropdelzpp": 774480135,
    "dropphyadd": "210 E LIVE OAK ST",
    "dropphycty": "HUNGERFORD",
    "dropphyst": "TX",
    "dropphyzpp": 774480135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNGERFORD",
    "dropmalst": "TX",
    "dropmalzpp": 774489998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795328891,
    "dropsitcph": 9795328891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24148",
    "droptype": "D",
    "dropname": "HUNT",
    "dropdeladd": "1644 HIGHWAY 39",
    "dropdelcty": "HUNT",
    "dropdelst": "TX",
    "dropdelzpp": 780249998,
    "dropphyadd": "1644 HIGHWAY 39",
    "dropphycty": "HUNT",
    "dropphyst": "TX",
    "dropphyzpp": 780249998,
    "dropmaladd": "1644 HIGHWAY 39",
    "dropmalcty": "HUNT",
    "dropmalst": "TX",
    "dropmalzpp": 780249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302384845,
    "dropsitcph": 8302384845,
    "dropfax": 8302384845
  },
  {
    "dcode": "D",
    "dropkey": "PW24151",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "260 S US HIGHWAY 69",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 759499998,
    "dropphyadd": "260 S US HIGHWAY 69",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 759499998,
    "dropmaladd": "260 S US HIGHWAY 69",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 759499998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368765380,
    "dropsitcph": 9368765380,
    "dropfax": 9368762721
  },
  {
    "dcode": "D",
    "dropkey": "PW24152",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "3190 HIGHWAY 30 W",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 773406431,
    "dropphyadd": "3190 HIGHWAY 30 W",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 773406431,
    "dropmaladd": "3190 HIGHWAY 30 W",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 773406431,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362953313,
    "dropsitcph": 9362957741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24153",
    "droptype": "D",
    "dropname": "HURST",
    "dropdeladd": "825 PRECINCT LINE RD",
    "dropdelcty": "HURST",
    "dropdelst": "TX",
    "dropdelzpp": 760534974,
    "dropphyadd": "825 PRECINCT LINE RD",
    "dropphycty": "HURST",
    "dropphyst": "TX",
    "dropphyzpp": 760534974,
    "dropmaladd": "825 PRECINCT LINE RD",
    "dropmalcty": "HURST",
    "dropmalst": "TX",
    "dropmalzpp": 760534974,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172840925,
    "dropsitcph": 8175899797,
    "dropfax": 8175909327
  },
  {
    "dcode": "D",
    "dropkey": "PW24156",
    "droptype": "D",
    "dropname": "HUTCHINS",
    "dropdeladd": "720 LANCASTER HUTCHINS RD",
    "dropdelcty": "HUTCHINS",
    "dropdelst": "TX",
    "dropdelzpp": 751419998,
    "dropphyadd": "720 LANCASTER HUTCHINS RD",
    "dropphycty": "HUTCHINS",
    "dropphyst": "TX",
    "dropphyzpp": 751419998,
    "dropmaladd": "720 LANCASTER HUTCHINS RD",
    "dropmalcty": "HUTCHINS",
    "dropmalst": "TX",
    "dropmalzpp": 751419998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722251204,
    "dropsitcph": 9722251204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24157",
    "droptype": "D",
    "dropname": "HUTTO",
    "dropdeladd": "388 EXCHANGE BLVD",
    "dropdelcty": "HUTTO",
    "dropdelst": "TX",
    "dropdelzpp": 786349998,
    "dropphyadd": "388 EXCHANGE BLVD",
    "dropphycty": "HUTTO",
    "dropphyst": "TX",
    "dropphyzpp": 786349998,
    "dropmaladd": "388 EXCHANGE BLVD",
    "dropmalcty": "HUTTO",
    "dropmalst": "TX",
    "dropmalzpp": 786349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5127592966,
    "dropsitcph": 5127592966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24159",
    "droptype": "D",
    "dropname": "HYE",
    "dropdeladd": "10261 W US HIGHWAY 290",
    "dropdelcty": "HYE",
    "dropdelst": "TX",
    "dropdelzpp": 786359998,
    "dropphyadd": "10261 W US HIGHWAY 290",
    "dropphycty": "HYE",
    "dropphyst": "TX",
    "dropphyzpp": 786359998,
    "dropmaladd": "10261 W US HIGHWAY 290",
    "dropmalcty": "HYE",
    "dropmalst": "TX",
    "dropmalzpp": 786359998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306442465,
    "dropsitcph": 8306442465,
    "dropfax": 8306442465
  },
  {
    "dcode": "D",
    "dropkey": "PW24162",
    "droptype": "D",
    "dropname": "IDALOU",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "IDALOU",
    "dropdelst": "TX",
    "dropdelzpp": 793299800,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "IDALOU",
    "dropphyst": "TX",
    "dropphyzpp": 793299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IDALOU",
    "dropmalst": "TX",
    "dropmalzpp": 793299998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068922929,
    "dropsitcph": 8068922929,
    "dropfax": 8068922644
  },
  {
    "dcode": "D",
    "dropkey": "PW24164",
    "droptype": "D",
    "dropname": "IMPERIAL",
    "dropdeladd": "304 E STATE HIGHWAY 11",
    "dropdelcty": "IMPERIAL",
    "dropdelst": "TX",
    "dropdelzpp": 797439997,
    "dropphyadd": "304 E STATE HIGHWAY 11",
    "dropphycty": "IMPERIAL",
    "dropphyst": "TX",
    "dropphyzpp": 797439997,
    "dropmaladd": "304 E STATE HIGHWAY 11",
    "dropmalcty": "IMPERIAL",
    "dropmalst": "TX",
    "dropmalzpp": 797439997,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4325362302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24172",
    "droptype": "D",
    "dropname": "INDUSTRY",
    "dropdeladd": "7944 ERNST PKWY",
    "dropdelcty": "INDUSTRY",
    "dropdelst": "TX",
    "dropdelzpp": 789449998,
    "dropphyadd": "7944 ERNST PKWY",
    "dropphycty": "INDUSTRY",
    "dropphyst": "TX",
    "dropphyzpp": 789449998,
    "dropmaladd": "7944 ERNST PKWY",
    "dropmalcty": "INDUSTRY",
    "dropmalst": "TX",
    "dropmalzpp": 789449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9793574448,
    "dropsitcph": 9793574448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24173",
    "droptype": "D",
    "dropname": "INEZ",
    "dropdeladd": "126 CHURCH ST",
    "dropdelcty": "INEZ",
    "dropdelst": "TX",
    "dropdelzpp": 779689998,
    "dropphyadd": "126 CHURCH ST",
    "dropphycty": "INEZ",
    "dropphyst": "TX",
    "dropphyzpp": 779689998,
    "dropmaladd": "126 CHURCH ST",
    "dropmalcty": "INEZ",
    "dropmalst": "TX",
    "dropmalzpp": 779689998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617826406,
    "dropsitcph": 3617826406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24174",
    "droptype": "D",
    "dropname": "INGLESIDE",
    "dropdeladd": "2230 STATE HIGHWAY 361",
    "dropdelcty": "INGLESIDE",
    "dropdelst": "TX",
    "dropdelzpp": 783624139,
    "dropphyadd": "2230 STATE HIGHWAY 361",
    "dropphycty": "INGLESIDE",
    "dropphyst": "TX",
    "dropphyzpp": 783624139,
    "dropmaladd": "2230 STATE HIGHWAY 361",
    "dropmalcty": "INGLESIDE",
    "dropmalst": "TX",
    "dropmalzpp": 783624139,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617760824,
    "dropsitcph": 3617760835,
    "dropfax": 3617767800
  },
  {
    "dcode": "D",
    "dropkey": "PW24176",
    "droptype": "D",
    "dropname": "INGRAM",
    "dropdeladd": "3190 JUNCTION HWY",
    "dropdelcty": "INGRAM",
    "dropdelst": "TX",
    "dropdelzpp": 780259998,
    "dropphyadd": "3190 JUNCTION HWY",
    "dropphycty": "INGRAM",
    "dropphyst": "TX",
    "dropphyzpp": 780259998,
    "dropmaladd": "3190 JUNCTION HWY",
    "dropmalcty": "INGRAM",
    "dropmalst": "TX",
    "dropmalzpp": 780259998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303675943,
    "dropsitcph": 8303675943,
    "dropfax": 8303675878
  },
  {
    "dcode": "D",
    "dropkey": "PW24185",
    "droptype": "D",
    "dropname": "IOLA",
    "dropdeladd": "23329 FM 39",
    "dropdelcty": "IOLA",
    "dropdelst": "TX",
    "dropdelzpp": 778615367,
    "dropphyadd": "23329 FM 39",
    "dropphycty": "IOLA",
    "dropphyst": "TX",
    "dropphyzpp": 778615367,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IOLA",
    "dropmalst": "TX",
    "dropmalzpp": 778619998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363945201,
    "dropsitcph": 9363945201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24188",
    "droptype": "D",
    "dropname": "IOWA PARK",
    "dropdeladd": "211 E CASH ST",
    "dropdelcty": "IOWA PARK",
    "dropdelst": "TX",
    "dropdelzpp": 763679998,
    "dropphyadd": "211 E CASH ST",
    "dropphycty": "IOWA PARK",
    "dropphyst": "TX",
    "dropphyzpp": 763679998,
    "dropmaladd": "211 E CASH ST",
    "dropmalcty": "IOWA PARK",
    "dropmalst": "TX",
    "dropmalzpp": 763679998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405923121,
    "dropsitcph": 9405923121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24189",
    "droptype": "D",
    "dropname": "IRA",
    "dropdeladd": "6071 W FM 1606",
    "dropdelcty": "IRA",
    "dropdelst": "TX",
    "dropdelzpp": 795279998,
    "dropphyadd": "6071 W FM 1606",
    "dropphycty": "IRA",
    "dropphyst": "TX",
    "dropphyzpp": 795279998,
    "dropmaladd": "6071 W FM 1606",
    "dropmalcty": "IRA",
    "dropmalst": "TX",
    "dropmalzpp": 795279998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255737803,
    "dropsitcph": 3255737803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24190",
    "droptype": "D",
    "dropname": "IRAAN",
    "dropdeladd": "302 S DRAKE",
    "dropdelcty": "IRAAN",
    "dropdelst": "TX",
    "dropdelzpp": 797449801,
    "dropphyadd": "302 S DRAKE",
    "dropphycty": "IRAAN",
    "dropphyst": "TX",
    "dropphyzpp": 797449801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRAAN",
    "dropmalst": "TX",
    "dropmalzpp": 797449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4326392207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24191",
    "droptype": "D",
    "dropname": "IREDELL",
    "dropdeladd": "306 S EASTLAND",
    "dropdelcty": "IREDELL",
    "dropdelst": "TX",
    "dropdelzpp": 766499998,
    "dropphyadd": "306 S EASTLAND",
    "dropphycty": "IREDELL",
    "dropphyst": "TX",
    "dropphyzpp": 766499998,
    "dropmaladd": "306 S EASTLAND",
    "dropmalcty": "IREDELL",
    "dropmalst": "TX",
    "dropmalzpp": 766499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543642205,
    "dropsitcph": 2543642205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24194",
    "droptype": "D",
    "dropname": "IRENE",
    "dropdeladd": "116 1ST ST",
    "dropdelcty": "IRENE",
    "dropdelst": "TX",
    "dropdelzpp": 766509800,
    "dropphyadd": "116 1ST ST",
    "dropphycty": "IRENE",
    "dropphyst": "TX",
    "dropphyzpp": 766509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRENE",
    "dropmalst": "TX",
    "dropmalzpp": 766509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546783501,
    "dropsitcph": 2546783501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24197",
    "droptype": "D",
    "dropname": "IRVING",
    "dropdeladd": "2701 W IRVING BLVD",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750619998,
    "dropphyadd": "2701 W IRVING BLVD",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750619998,
    "dropmaladd": "2701 W IRVING BLVD",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750619998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729860122,
    "dropsitcph": 9729866997,
    "dropfax": 9729869724
  },
  {
    "dcode": "D",
    "dropkey": "PW24203",
    "droptype": "D",
    "dropname": "ITALY",
    "dropdeladd": "105 POPLAR ST",
    "dropdelcty": "ITALY",
    "dropdelst": "TX",
    "dropdelzpp": 766519998,
    "dropphyadd": "105 POPLAR ST",
    "dropphycty": "ITALY",
    "dropphyst": "TX",
    "dropphyzpp": 766519998,
    "dropmaladd": "105 POPLAR ST",
    "dropmalcty": "ITALY",
    "dropmalst": "TX",
    "dropmalzpp": 766519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9724836955,
    "dropsitcph": 9724836955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24204",
    "droptype": "D",
    "dropname": "ITASCA",
    "dropdeladd": "100 E ADAMS ST",
    "dropdelcty": "ITASCA",
    "dropdelst": "TX",
    "dropdelzpp": 760559998,
    "dropphyadd": "100 E ADAMS ST",
    "dropphycty": "ITASCA",
    "dropphyst": "TX",
    "dropphyzpp": 760559998,
    "dropmaladd": "100 E ADAMS ST",
    "dropmalcty": "ITASCA",
    "dropmalst": "TX",
    "dropmalzpp": 760559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546872350,
    "dropsitcph": 2546872350,
    "dropfax": 2546879788
  },
  {
    "dcode": "D",
    "dropkey": "PW24205",
    "droptype": "D",
    "dropname": "IVANHOE",
    "dropdeladd": "3876 N FM 273",
    "dropdelcty": "IVANHOE",
    "dropdelst": "TX",
    "dropdelzpp": 754479998,
    "dropphyadd": "3876 N FM 273",
    "dropphycty": "IVANHOE",
    "dropphyst": "TX",
    "dropphyzpp": 754479998,
    "dropmaladd": "3876 N FM 273",
    "dropmalcty": "IVANHOE",
    "dropmalst": "TX",
    "dropmalzpp": 754479998,
    "dropsitphn": 9035838641,
    "dropsitlph": 9035838641,
    "dropsitcph": 9035838641,
    "dropfax": 9035838641
  },
  {
    "dcode": "D",
    "dropkey": "PW24212",
    "droptype": "D",
    "dropname": "JACKSBORO",
    "dropdeladd": "100 E SOUTH ST",
    "dropdelcty": "JACKSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 764589998,
    "dropphyadd": "100 E SOUTH ST",
    "dropphycty": "JACKSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 764589998,
    "dropmaladd": "100 E SOUTH ST",
    "dropmalcty": "JACKSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 764589998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405076054,
    "dropsitcph": 9405076054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24215",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "400 W RUSK ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 757669998,
    "dropphyadd": "400 W RUSK ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 757669998,
    "dropmaladd": "400 W RUSK ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 757669998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035862011,
    "dropsitcph": 9035862011,
    "dropfax": 9035869737
  },
  {
    "dcode": "D",
    "dropkey": "PW24222",
    "droptype": "D",
    "dropname": "JARRELL",
    "dropdeladd": "12355 N INTERSTATE 35",
    "dropdelcty": "JARRELL",
    "dropdelst": "TX",
    "dropdelzpp": 765379998,
    "dropphyadd": "12355 N INTERSTATE 35",
    "dropphycty": "JARRELL",
    "dropphyst": "TX",
    "dropphyzpp": 765379998,
    "dropmaladd": "12355 N INTERSTATE 35",
    "dropmalcty": "JARRELL",
    "dropmalst": "TX",
    "dropmalzpp": 765379998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5127465606,
    "dropsitcph": 5127465606,
    "dropfax": 5127462686
  },
  {
    "dcode": "D",
    "dropkey": "PW24224",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "215 N BOWIE ST",
    "dropdelcty": "JASPER",
    "dropdelst": "TX",
    "dropdelzpp": 759519998,
    "dropphyadd": "215 N BOWIE ST",
    "dropphycty": "JASPER",
    "dropphyst": "TX",
    "dropphyzpp": 759519998,
    "dropmaladd": "215 N BOWIE ST",
    "dropmalcty": "JASPER",
    "dropmalst": "TX",
    "dropmalzpp": 759519998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4093846831,
    "dropsitcph": 4093846831,
    "dropfax": 4093846021
  },
  {
    "dcode": "D",
    "dropkey": "PW24225",
    "droptype": "D",
    "dropname": "JAYTON",
    "dropdeladd": "840 S MAIN ST",
    "dropdelcty": "JAYTON",
    "dropdelst": "TX",
    "dropdelzpp": 795289998,
    "dropphyadd": "840 S MAIN ST",
    "dropphycty": "JAYTON",
    "dropphyst": "TX",
    "dropphyzpp": 795289998,
    "dropmaladd": "840 S MAIN ST",
    "dropmalcty": "JAYTON",
    "dropmalst": "TX",
    "dropmalzpp": 795289998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8062374616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24228",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "214 W LAFAYETTE ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "TX",
    "dropdelzpp": 756579998,
    "dropphyadd": "214 W LAFAYETTE ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "TX",
    "dropphyzpp": 756579998,
    "dropmaladd": "214 W LAFAYETTE ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "TX",
    "dropmalzpp": 756579998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036652291,
    "dropsitcph": 9036652291,
    "dropfax": 9036656170
  },
  {
    "dcode": "D",
    "dropkey": "PW24232",
    "droptype": "D",
    "dropname": "JERMYN",
    "dropdeladd": "7664 STATE HIGHWAY 114",
    "dropdelcty": "JERMYN",
    "dropdelst": "TX",
    "dropdelzpp": 764599802,
    "dropphyadd": "7664 STATE HIGHWAY 114",
    "dropphycty": "JERMYN",
    "dropphyst": "TX",
    "dropphyzpp": 764599802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JERMYN",
    "dropmalst": "TX",
    "dropmalzpp": 764599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403422918,
    "dropsitcph": 9403422918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24235",
    "droptype": "D",
    "dropname": "JEWETT",
    "dropdeladd": "1001 N MAIN ST",
    "dropdelcty": "JEWETT",
    "dropdelst": "TX",
    "dropdelzpp": 758469998,
    "dropphyadd": "1001 N MAIN ST",
    "dropphycty": "JEWETT",
    "dropphyst": "TX",
    "dropphyzpp": 758469998,
    "dropmaladd": "1001 N MAIN ST",
    "dropmalcty": "JEWETT",
    "dropmalst": "TX",
    "dropmalzpp": 758469998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036264855,
    "dropsitcph": 9036264855,
    "dropfax": 9036264036
  },
  {
    "dcode": "D",
    "dropkey": "PW24237",
    "droptype": "D",
    "dropname": "JOAQUIN",
    "dropdeladd": "209 84TH ST",
    "dropdelcty": "JOAQUIN",
    "dropdelst": "TX",
    "dropdelzpp": 759549998,
    "dropphyadd": "209 84TH ST",
    "dropphycty": "JOAQUIN",
    "dropphyst": "TX",
    "dropphyzpp": 759549998,
    "dropmaladd": "209 84TH ST",
    "dropmalcty": "JOAQUIN",
    "dropmalst": "TX",
    "dropmalzpp": 759549998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362693491,
    "dropsitcph": 9362693491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24241",
    "droptype": "D",
    "dropname": "JOHNSON CITY",
    "dropdeladd": "201 S AVENUE G",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TX",
    "dropdelzpp": 786369998,
    "dropphyadd": "201 S AVENUE G",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TX",
    "dropphyzpp": 786369998,
    "dropmaladd": "201 S AVENUE G",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TX",
    "dropmalzpp": 786369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308687211,
    "dropsitcph": 8308687211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24242",
    "droptype": "D",
    "dropname": "JOINERVILLE",
    "dropdeladd": "7110 HIGHWAY 64 W",
    "dropdelcty": "JOINERVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756589998,
    "dropphyadd": "7110 HIGHWAY 64 W",
    "dropphycty": "JOINERVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756589998,
    "dropmaladd": "7110 HIGHWAY 64 W",
    "dropmalcty": "JOINERVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756589998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038474338,
    "dropsitcph": 9038474338,
    "dropfax": 9038474338
  },
  {
    "dcode": "D",
    "dropkey": "PW24249",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "11345 N STATE HIGHWAY 36",
    "dropdelcty": "JONESBORO",
    "dropdelst": "TX",
    "dropdelzpp": 765389998,
    "dropphyadd": "11345 N STATE HIGHWAY 36",
    "dropphycty": "JONESBORO",
    "dropphyst": "TX",
    "dropphyzpp": 765389998,
    "dropmaladd": "11345 N STATE HIGHWAY 36",
    "dropmalcty": "JONESBORO",
    "dropmalst": "TX",
    "dropmalzpp": 765389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544632970,
    "dropsitcph": 2544632970,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24251",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "2335 FM 134",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756599998,
    "dropphyadd": "2335 FM 134",
    "dropphycty": "JONESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756599998,
    "dropmaladd": "2335 FM 134",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756599998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036873215,
    "dropsitcph": 9036873215,
    "dropfax": 9036874177
  },
  {
    "dcode": "D",
    "dropkey": "PW24255",
    "droptype": "D",
    "dropname": "JOSEPHINE",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "JOSEPHINE",
    "dropdelst": "TX",
    "dropdelzpp": 751649998,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "JOSEPHINE",
    "dropphyst": "TX",
    "dropphyzpp": 751649998,
    "dropmaladd": "408 MAIN ST",
    "dropmalcty": "JOSEPHINE",
    "dropmalst": "TX",
    "dropmalzpp": 751649998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726942295,
    "dropsitcph": 9726942295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24256",
    "droptype": "D",
    "dropname": "JOSHUA",
    "dropdeladd": "306 N BROADWAY ST",
    "dropdelcty": "JOSHUA",
    "dropdelst": "TX",
    "dropdelzpp": 760583075,
    "dropphyadd": "306 N BROADWAY ST",
    "dropphycty": "JOSHUA",
    "dropphyst": "TX",
    "dropphyzpp": 760583075,
    "dropmaladd": "306 N BROADWAY ST",
    "dropmalcty": "JOSHUA",
    "dropmalst": "TX",
    "dropmalzpp": 760583075,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176450521,
    "dropsitcph": 8176450521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24258",
    "droptype": "D",
    "dropname": "JOURDANTON",
    "dropdeladd": "1002 OAK ST",
    "dropdelcty": "JOURDANTON",
    "dropdelst": "TX",
    "dropdelzpp": 780269998,
    "dropphyadd": "1002 OAK ST",
    "dropphycty": "JOURDANTON",
    "dropphyst": "TX",
    "dropphyzpp": 780269998,
    "dropmaladd": "1002 OAK ST",
    "dropmalcty": "JOURDANTON",
    "dropmalst": "TX",
    "dropmalzpp": 780269998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307693477,
    "dropsitcph": 8307693477,
    "dropfax": 8307694147
  },
  {
    "dcode": "D",
    "dropkey": "PW24262",
    "droptype": "D",
    "dropname": "JUDSON",
    "dropdeladd": "7526 TRYON RD",
    "dropdelcty": "JUDSON",
    "dropdelst": "TX",
    "dropdelzpp": 756605048,
    "dropphyadd": "7526 TRYON RD",
    "dropphycty": "JUDSON",
    "dropphyst": "TX",
    "dropphyzpp": 756605048,
    "dropmaladd": "7526 TRYON RD",
    "dropmalcty": "JUDSON",
    "dropmalst": "TX",
    "dropmalzpp": 756605048,
    "dropsitphn": 9033243018,
    "dropsitlph": 9033095300,
    "dropsitcph": 9033095300,
    "dropfax": 9036631655
  },
  {
    "dcode": "D",
    "dropkey": "PW24265",
    "droptype": "D",
    "dropname": "JUNCTION",
    "dropdeladd": "612 COLLEGE ST",
    "dropdelcty": "JUNCTION",
    "dropdelst": "TX",
    "dropdelzpp": 768499998,
    "dropphyadd": "612 COLLEGE ST",
    "dropphycty": "JUNCTION",
    "dropphyst": "TX",
    "dropphyzpp": 768499998,
    "dropmaladd": "612 COLLEGE ST",
    "dropmalcty": "JUNCTION",
    "dropmalst": "TX",
    "dropmalzpp": 768499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254462587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24269",
    "droptype": "D",
    "dropname": "JUSTIN",
    "dropdeladd": "120 W 5TH ST",
    "dropdelcty": "JUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 762479998,
    "dropphyadd": "120 W 5TH ST",
    "dropphycty": "JUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 762479998,
    "dropmaladd": "120 W 5TH ST",
    "dropmalcty": "JUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 762479998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406483184,
    "dropsitcph": 9406483184,
    "dropfax": 9406489118
  },
  {
    "dcode": "D",
    "dropkey": "PW24271",
    "droptype": "D",
    "dropname": "KAMAY",
    "dropdeladd": "8162 STATE HIGHWAY 258",
    "dropdelcty": "KAMAY",
    "dropdelst": "TX",
    "dropdelzpp": 763699801,
    "dropphyadd": "8162 STATE HIGHWAY 258",
    "dropphycty": "KAMAY",
    "dropphyst": "TX",
    "dropphyzpp": 763699801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAMAY",
    "dropmalst": "TX",
    "dropmalzpp": 763699998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404382423,
    "dropsitcph": 9404382423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24274",
    "droptype": "D",
    "dropname": "KARNACK",
    "dropdeladd": "15592 FM 134",
    "dropdelcty": "KARNACK",
    "dropdelst": "TX",
    "dropdelzpp": 756619998,
    "dropphyadd": "15592 FM 134",
    "dropphycty": "KARNACK",
    "dropphyst": "TX",
    "dropphyzpp": 756619998,
    "dropmaladd": "15592 FM 134",
    "dropmalcty": "KARNACK",
    "dropmalst": "TX",
    "dropmalzpp": 756619998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9034713296,
    "dropsitcph": 9034713296,
    "dropfax": 9036794284
  },
  {
    "dcode": "D",
    "dropkey": "PW24275",
    "droptype": "D",
    "dropname": "KARNES CITY",
    "dropdeladd": "404 E WALL ST",
    "dropdelcty": "KARNES CITY",
    "dropdelst": "TX",
    "dropdelzpp": 781189998,
    "dropphyadd": "404 E WALL ST",
    "dropphycty": "KARNES CITY",
    "dropphyst": "TX",
    "dropphyzpp": 781189998,
    "dropmaladd": "404 E WALL ST",
    "dropmalcty": "KARNES CITY",
    "dropmalst": "TX",
    "dropmalzpp": 781189998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307803355,
    "dropsitcph": 8307803355,
    "dropfax": 8307802350
  },
  {
    "dcode": "D",
    "dropkey": "PW24277",
    "droptype": "D",
    "dropname": "KATY",
    "dropdeladd": "20180 PARK ROW DR",
    "dropdelcty": "KATY",
    "dropdelst": "TX",
    "dropdelzpp": 774499998,
    "dropphyadd": "20180 PARK ROW DR",
    "dropphycty": "KATY",
    "dropphyst": "TX",
    "dropphyzpp": 774499998,
    "dropmaladd": "20180 PARK ROW DR",
    "dropmalcty": "KATY",
    "dropmalst": "TX",
    "dropmalzpp": 774499998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2816470673,
    "dropsitcph": 2818295062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24278",
    "droptype": "D",
    "dropname": "KAUFMAN",
    "dropdeladd": "2231 S WASHINGTON ST",
    "dropdelcty": "KAUFMAN",
    "dropdelst": "TX",
    "dropdelzpp": 751429998,
    "dropphyadd": "2231 S WASHINGTON ST",
    "dropphycty": "KAUFMAN",
    "dropphyst": "TX",
    "dropphyzpp": 751429998,
    "dropmaladd": "2231 S WASHINGTON ST",
    "dropmalcty": "KAUFMAN",
    "dropmalst": "TX",
    "dropmalzpp": 751429998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9729322215,
    "dropsitcph": 9729322215,
    "dropfax": 9729328534
  },
  {
    "dcode": "D",
    "dropkey": "PW24281",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "203 S OLD BETSY RD",
    "dropdelcty": "KEENE",
    "dropdelst": "TX",
    "dropdelzpp": 760599998,
    "dropphyadd": "203 S OLD BETSY RD",
    "dropphycty": "KEENE",
    "dropphyst": "TX",
    "dropphyzpp": 760599998,
    "dropmaladd": "203 S OLD BETSY RD",
    "dropmalcty": "KEENE",
    "dropmalst": "TX",
    "dropmalzpp": 760599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176455978,
    "dropsitcph": 8176455978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24282",
    "droptype": "D",
    "dropname": "KELLER",
    "dropdeladd": "520 E VINE ST",
    "dropdelcty": "KELLER",
    "dropdelst": "TX",
    "dropdelzpp": 762482300,
    "dropphyadd": "520 E VINE ST",
    "dropphycty": "KELLER",
    "dropphyst": "TX",
    "dropphyzpp": 762482300,
    "dropmaladd": "520 E VINE ST",
    "dropmalcty": "KELLER",
    "dropmalst": "TX",
    "dropmalzpp": 762482300,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174314922,
    "dropsitcph": 8174314922,
    "dropfax": 8174318757
  },
  {
    "dcode": "D",
    "dropkey": "PW24290",
    "droptype": "D",
    "dropname": "KEMAH",
    "dropdeladd": "1129 HIGHWAY 146",
    "dropdelcty": "KEMAH",
    "dropdelst": "TX",
    "dropdelzpp": 775651601,
    "dropphyadd": "1129 HIGHWAY 146",
    "dropphycty": "KEMAH",
    "dropphyst": "TX",
    "dropphyzpp": 775651601,
    "dropmaladd": "1129 HIGHWAY 146",
    "dropmalcty": "KEMAH",
    "dropmalst": "TX",
    "dropmalzpp": 775651601,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813344446,
    "dropsitcph": 2813343883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24291",
    "droptype": "D",
    "dropname": "KEMP",
    "dropdeladd": "101 W 9TH ST",
    "dropdelcty": "KEMP",
    "dropdelst": "TX",
    "dropdelzpp": 751439998,
    "dropphyadd": "101 W 9TH ST",
    "dropphycty": "KEMP",
    "dropphyst": "TX",
    "dropphyzpp": 751439998,
    "dropmaladd": "101 W 9TH ST",
    "dropmalcty": "KEMP",
    "dropmalst": "TX",
    "dropmalzpp": 751439998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9034982711,
    "dropsitcph": 9034982711,
    "dropfax": 9034987908
  },
  {
    "dcode": "D",
    "dropkey": "PW24292",
    "droptype": "D",
    "dropname": "KEMPNER",
    "dropdeladd": "379 PECAN ST",
    "dropdelcty": "KEMPNER",
    "dropdelst": "TX",
    "dropdelzpp": 765399998,
    "dropphyadd": "379 PECAN ST",
    "dropphycty": "KEMPNER",
    "dropphyst": "TX",
    "dropphyzpp": 765399998,
    "dropmaladd": "379 PECAN ST",
    "dropmalcty": "KEMPNER",
    "dropmalst": "TX",
    "dropmalzpp": 765399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5129323621,
    "dropsitcph": 5129323621,
    "dropfax": 5129322132
  },
  {
    "dcode": "D",
    "dropkey": "PW24293",
    "droptype": "D",
    "dropname": "KENDALIA",
    "dropdeladd": "2545 FM 473",
    "dropdelcty": "KENDALIA",
    "dropdelst": "TX",
    "dropdelzpp": 780279998,
    "dropphyadd": "2545 FM 473",
    "dropphycty": "KENDALIA",
    "dropphyst": "TX",
    "dropphyzpp": 780279998,
    "dropmaladd": "2545 FM 473",
    "dropmalcty": "KENDALIA",
    "dropmalst": "TX",
    "dropmalzpp": 780279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303363068,
    "dropsitcph": 8303363068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24294",
    "droptype": "D",
    "dropname": "KENDLETON",
    "dropdeladd": "13635 WILLIE MELTON BLVD",
    "dropdelcty": "KENDLETON",
    "dropdelst": "TX",
    "dropdelzpp": 774519800,
    "dropphyadd": "13635 WILLIE MELTON BLVD",
    "dropphycty": "KENDLETON",
    "dropphyst": "TX",
    "dropphyzpp": 774519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENDLETON",
    "dropmalst": "TX",
    "dropmalzpp": 774519998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795328434,
    "dropsitcph": 9795328434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24295",
    "droptype": "D",
    "dropname": "KENEDY",
    "dropdeladd": "223 S 2ND ST",
    "dropdelcty": "KENEDY",
    "dropdelst": "TX",
    "dropdelzpp": 781199998,
    "dropphyadd": "223 S 2ND ST",
    "dropphycty": "KENEDY",
    "dropphyst": "TX",
    "dropphyzpp": 781199998,
    "dropmaladd": "223 S 2ND ST",
    "dropmalcty": "KENEDY",
    "dropmalst": "TX",
    "dropmalzpp": 781199998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305832860,
    "dropsitcph": 8305832119,
    "dropfax": 8305839757
  },
  {
    "dcode": "D",
    "dropkey": "PW24297",
    "droptype": "D",
    "dropname": "KENNARD",
    "dropdeladd": "312 W MAIN ST",
    "dropdelcty": "KENNARD",
    "dropdelst": "TX",
    "dropdelzpp": 758479998,
    "dropphyadd": "312 W MAIN ST",
    "dropphycty": "KENNARD",
    "dropphyst": "TX",
    "dropphyzpp": 758479998,
    "dropmaladd": "312 W MAIN ST",
    "dropmalcty": "KENNARD",
    "dropmalst": "TX",
    "dropmalzpp": 758479998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366552693,
    "dropsitcph": 9366552693,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "PW24298",
    "droptype": "D",
    "dropname": "KENNEDALE",
    "dropdeladd": "317 E KENNEDALE PKWY",
    "dropdelcty": "KENNEDALE",
    "dropdelst": "TX",
    "dropdelzpp": 760603267,
    "dropphyadd": "317 E KENNEDALE PKWY",
    "dropphycty": "KENNEDALE",
    "dropphyst": "TX",
    "dropphyzpp": 760603267,
    "dropmaladd": "317 E KENNEDALE PKWY",
    "dropmalcty": "KENNEDALE",
    "dropmalst": "TX",
    "dropmalzpp": 760603267,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174832665,
    "dropsitcph": 8174834929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24301",
    "droptype": "D",
    "dropname": "KENNEY",
    "dropdeladd": "707 S LOOP 497",
    "dropdelcty": "KENNEY",
    "dropdelst": "TX",
    "dropdelzpp": 774529800,
    "dropphyadd": "707 S LOOP 497",
    "dropphycty": "KENNEY",
    "dropphyst": "TX",
    "dropphyzpp": 774529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNEY",
    "dropmalst": "TX",
    "dropmalzpp": 774529998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798650329,
    "dropsitcph": 9798650329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24303",
    "droptype": "D",
    "dropname": "KERENS",
    "dropdeladd": "106 S COLKET ST",
    "dropdelcty": "KERENS",
    "dropdelst": "TX",
    "dropdelzpp": 751449998,
    "dropphyadd": "106 S COLKET ST",
    "dropphycty": "KERENS",
    "dropphyst": "TX",
    "dropphyzpp": 751449998,
    "dropmaladd": "106 S COLKET ST",
    "dropmalcty": "KERENS",
    "dropmalst": "TX",
    "dropmalzpp": 751449998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9033967142,
    "dropsitcph": 9033967142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24304",
    "droptype": "D",
    "dropname": "KERMIT",
    "dropdeladd": "309 N OAK ST",
    "dropdelcty": "KERMIT",
    "dropdelst": "TX",
    "dropdelzpp": 797459998,
    "dropphyadd": "309 N OAK ST",
    "dropphycty": "KERMIT",
    "dropphyst": "TX",
    "dropphyzpp": 797459998,
    "dropmaladd": "309 N OAK ST",
    "dropmalcty": "KERMIT",
    "dropmalst": "TX",
    "dropmalzpp": 797459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4325863671,
    "dropfax": 4325862648
  },
  {
    "dcode": "D",
    "dropkey": "PW24306",
    "droptype": "D",
    "dropname": "KERRVILLE",
    "dropdeladd": "244 CULLY DR",
    "dropdelcty": "KERRVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 780285950,
    "dropphyadd": "244 CULLY DR",
    "dropphycty": "KERRVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 780289998,
    "dropmaladd": "244 CULLY DR",
    "dropmalcty": "KERRVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 780289998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302575040,
    "dropsitcph": 8302575040,
    "dropfax": 8308965157
  },
  {
    "dcode": "D",
    "dropkey": "PW24308",
    "droptype": "D",
    "dropname": "KILDARE",
    "dropdeladd": "1315 COUNTY ROAD 1894",
    "dropdelcty": "KILDARE",
    "dropdelst": "TX",
    "dropdelzpp": 755629998,
    "dropphyadd": "1315 COUNTY ROAD 1894",
    "dropphycty": "KILDARE",
    "dropphyst": "TX",
    "dropphyzpp": 755629998,
    "dropmaladd": "1315 COUNTY ROAD 1894",
    "dropmalcty": "KILDARE",
    "dropmalst": "TX",
    "dropmalzpp": 755629998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037968662,
    "dropsitcph": 9037968662,
    "dropfax": 9037967203
  },
  {
    "dcode": "D",
    "dropkey": "PW24309",
    "droptype": "D",
    "dropname": "KILGORE",
    "dropdeladd": "500 N KILGORE ST",
    "dropdelcty": "KILGORE",
    "dropdelst": "TX",
    "dropdelzpp": 756629998,
    "dropphyadd": "500 N KILGORE ST",
    "dropphycty": "KILGORE",
    "dropphyst": "TX",
    "dropphyzpp": 756629998,
    "dropmaladd": "500 N KILGORE ST",
    "dropmalcty": "KILGORE",
    "dropmalst": "TX",
    "dropmalzpp": 756629998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9039842313,
    "dropsitcph": 9039842313,
    "dropfax": 9039835329
  },
  {
    "dcode": "D",
    "dropkey": "PW24310",
    "droptype": "D",
    "dropname": "KILLEEN",
    "dropdeladd": "300 N 10TH ST",
    "dropdelcty": "KILLEEN",
    "dropdelst": "TX",
    "dropdelzpp": 765419998,
    "dropphyadd": "300 N 10TH ST",
    "dropphycty": "KILLEEN",
    "dropphyst": "TX",
    "dropphyzpp": 765419998,
    "dropmaladd": "300 N 10TH ST",
    "dropmalcty": "KILLEEN",
    "dropmalst": "TX",
    "dropmalzpp": 765419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546340283,
    "dropsitcph": 2546340281,
    "dropfax": 2546340969
  },
  {
    "dcode": "D",
    "dropkey": "PW24313",
    "droptype": "D",
    "dropname": "KINGSBURY",
    "dropdeladd": "10055 E HIGHWAY 90",
    "dropdelcty": "KINGSBURY",
    "dropdelst": "TX",
    "dropdelzpp": 786389998,
    "dropphyadd": "10055 E HIGHWAY 90",
    "dropphycty": "KINGSBURY",
    "dropphyst": "TX",
    "dropphyzpp": 786389998,
    "dropmaladd": "10055 E HIGHWAY 90",
    "dropmalcty": "KINGSBURY",
    "dropmalst": "TX",
    "dropmalzpp": 786389998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306394601,
    "dropsitcph": 8306394601,
    "dropfax": 8306394728
  },
  {
    "dcode": "D",
    "dropkey": "PW24314",
    "droptype": "D",
    "dropname": "KINGSLAND",
    "dropdeladd": "1901 W RANCH ROAD 1431",
    "dropdelcty": "KINGSLAND",
    "dropdelst": "TX",
    "dropdelzpp": 786399998,
    "dropphyadd": "1901 W RANCH ROAD 1431",
    "dropphycty": "KINGSLAND",
    "dropphyst": "TX",
    "dropphyzpp": 786399998,
    "dropmaladd": "1901 W RANCH ROAD 1431",
    "dropmalcty": "KINGSLAND",
    "dropmalst": "TX",
    "dropmalzpp": 786399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3253884275,
    "dropsitcph": 3253884275,
    "dropfax": 3253885719
  },
  {
    "dcode": "D",
    "dropkey": "PW24316",
    "droptype": "D",
    "dropname": "KINGSVILLE",
    "dropdeladd": "103 E KLEBERG AVE",
    "dropdelcty": "KINGSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 783634502,
    "dropphyadd": "103 E KLEBERG AVE",
    "dropphycty": "KINGSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 783634502,
    "dropmaladd": "103 E KLEBERG AVE",
    "dropmalcty": "KINGSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 783634502,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615922801,
    "dropsitcph": 3615922801,
    "dropfax": 3615951641
  },
  {
    "dcode": "D",
    "dropkey": "PW24323",
    "droptype": "D",
    "dropname": "KIRBYVILLE",
    "dropdeladd": "301 E LAVIELLE ST",
    "dropdelcty": "KIRBYVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 759569998,
    "dropphyadd": "301 E LAVIELLE ST",
    "dropphycty": "KIRBYVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 759569998,
    "dropmaladd": "301 E LAVIELLE ST",
    "dropmalcty": "KIRBYVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 759569998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4094234641,
    "dropsitcph": 4094234641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24333",
    "droptype": "D",
    "dropname": "KLONDIKE",
    "dropdeladd": "5548 FARM ROAD 1528",
    "dropdelcty": "KLONDIKE",
    "dropdelst": "TX",
    "dropdelzpp": 754489998,
    "dropphyadd": "5548 FARM ROAD 1528",
    "dropphycty": "KLONDIKE",
    "dropphyst": "TX",
    "dropphyzpp": 754489998,
    "dropmaladd": "5548 FARM ROAD 1528",
    "dropmalcty": "KLONDIKE",
    "dropmalst": "TX",
    "dropmalzpp": 754489998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033952978,
    "dropsitcph": 9033952978,
    "dropfax": 9033952978
  },
  {
    "dcode": "D",
    "dropkey": "PW24334",
    "droptype": "D",
    "dropname": "KNICKERBOCKER",
    "dropdeladd": "14553 FM 2335",
    "dropdelcty": "KNICKERBOCKER",
    "dropdelst": "TX",
    "dropdelzpp": 769399998,
    "dropphyadd": "14553 FM 2335",
    "dropphycty": "KNICKERBOCKER",
    "dropphyst": "TX",
    "dropphyzpp": 769399998,
    "dropmaladd": "14553 FM 2335",
    "dropmalcty": "KNICKERBOCKER",
    "dropmalst": "TX",
    "dropmalzpp": 769399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3259491201,
    "dropsitcph": 3259491201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24335",
    "droptype": "D",
    "dropname": "KNIPPA",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "KNIPPA",
    "dropdelst": "TX",
    "dropdelzpp": 788709998,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "KNIPPA",
    "dropphyst": "TX",
    "dropphyzpp": 788709998,
    "dropmaladd": "107 MAIN ST",
    "dropmalcty": "KNIPPA",
    "dropmalst": "TX",
    "dropmalzpp": 788709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309342266,
    "dropsitcph": 8309342266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24336",
    "droptype": "D",
    "dropname": "KNOTT",
    "dropdeladd": "5900 W FM 846",
    "dropdelcty": "KNOTT",
    "dropdelst": "TX",
    "dropdelzpp": 797489998,
    "dropphyadd": "5900 W FM 846",
    "dropphycty": "KNOTT",
    "dropphyst": "TX",
    "dropphyzpp": 797489998,
    "dropmaladd": "5900 W FM 846",
    "dropmalcty": "KNOTT",
    "dropmalst": "TX",
    "dropmalzpp": 797489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323534524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24337",
    "droptype": "D",
    "dropname": "KNOX CITY",
    "dropdeladd": "107 N AVENUE A",
    "dropdelcty": "KNOX CITY",
    "dropdelst": "TX",
    "dropdelzpp": 795299998,
    "dropphyadd": "107 N AVENUE A",
    "dropphycty": "KNOX CITY",
    "dropphyst": "TX",
    "dropphyzpp": 795299998,
    "dropmaladd": "107 N AVENUE A",
    "dropmalcty": "KNOX CITY",
    "dropmalst": "TX",
    "dropmalzpp": 795299998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406583412,
    "dropsitcph": 9406583412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24341",
    "droptype": "D",
    "dropname": "KOPPERL",
    "dropdeladd": "106 FM 1859",
    "dropdelcty": "KOPPERL",
    "dropdelst": "TX",
    "dropdelzpp": 766529998,
    "dropphyadd": "106 FM 1859",
    "dropphycty": "KOPPERL",
    "dropphyst": "TX",
    "dropphyzpp": 766529998,
    "dropmaladd": "106 FM 1859",
    "dropmalcty": "KOPPERL",
    "dropmalst": "TX",
    "dropmalzpp": 766529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548893593,
    "dropsitcph": 2548893593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24342",
    "droptype": "D",
    "dropname": "KOSSE",
    "dropdeladd": "107 W ADAMS ST",
    "dropdelcty": "KOSSE",
    "dropdelst": "TX",
    "dropdelzpp": 766539998,
    "dropphyadd": "107 W ADAMS ST",
    "dropphycty": "KOSSE",
    "dropphyst": "TX",
    "dropphyzpp": 766539998,
    "dropmaladd": "107 W ADAMS ST",
    "dropmalcty": "KOSSE",
    "dropmalst": "TX",
    "dropmalzpp": 766539998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543752620,
    "dropsitcph": 2543752620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24343",
    "droptype": "D",
    "dropname": "KOUNTZE",
    "dropdeladd": "1245 S PINE ST",
    "dropdelcty": "KOUNTZE",
    "dropdelst": "TX",
    "dropdelzpp": 776259998,
    "dropphyadd": "1245 S PINE ST",
    "dropphycty": "KOUNTZE",
    "dropphyst": "TX",
    "dropphyzpp": 776259998,
    "dropmaladd": "1245 S PINE ST",
    "dropmalcty": "KOUNTZE",
    "dropmalst": "TX",
    "dropmalzpp": 776259998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092463220,
    "dropsitcph": 4092463220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24345",
    "droptype": "D",
    "dropname": "KRESS",
    "dropdeladd": "400 SKIPWORTH ST",
    "dropdelcty": "KRESS",
    "dropdelst": "TX",
    "dropdelzpp": 790529804,
    "dropphyadd": "400 SKIPWORTH ST",
    "dropphycty": "KRESS",
    "dropphyst": "TX",
    "dropphyzpp": 790529804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KRESS",
    "dropmalst": "TX",
    "dropmalzpp": 790529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8066842253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24346",
    "droptype": "D",
    "dropname": "KRUM",
    "dropdeladd": "121 N 2ND ST",
    "dropdelcty": "KRUM",
    "dropdelst": "TX",
    "dropdelzpp": 762499998,
    "dropphyadd": "121 N 2ND ST",
    "dropphycty": "KRUM",
    "dropphyst": "TX",
    "dropphyzpp": 762499998,
    "dropmaladd": "121 N 2ND ST",
    "dropmalcty": "KRUM",
    "dropmalst": "TX",
    "dropmalzpp": 762499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404823967,
    "dropsitcph": 9404823967,
    "dropfax": 9404823838
  },
  {
    "dcode": "D",
    "dropkey": "PW24347",
    "droptype": "D",
    "dropname": "KURTEN",
    "dropdeladd": "12857 E SH HWY 21",
    "dropdelcty": "KURTEN",
    "dropdelst": "TX",
    "dropdelzpp": 778629700,
    "dropphyadd": "12857 E SH HWY 21",
    "dropphycty": "KURTEN",
    "dropphyst": "TX",
    "dropphyzpp": 778629700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KURTEN",
    "dropmalst": "TX",
    "dropmalzpp": 778629998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795893000,
    "dropsitcph": 9795893000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24348",
    "droptype": "D",
    "dropname": "KYLE",
    "dropdeladd": "555 VETERANS DR",
    "dropdelcty": "KYLE",
    "dropdelst": "TX",
    "dropdelzpp": 786409998,
    "dropphyadd": "555 VETERANS DR",
    "dropphycty": "KYLE",
    "dropphyst": "TX",
    "dropphyzpp": 786409998,
    "dropmaladd": "555 VETERANS DR",
    "dropmalcty": "KYLE",
    "dropmalst": "TX",
    "dropmalzpp": 786409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122681061,
    "dropsitcph": 5122685541,
    "dropfax": 5122681013
  },
  {
    "dcode": "D",
    "dropkey": "PW24350",
    "droptype": "D",
    "dropname": "LA BLANCA",
    "dropdeladd": "13306 HIGHWAY 107",
    "dropdelcty": "LA BLANCA",
    "dropdelst": "TX",
    "dropdelzpp": 785589800,
    "dropphyadd": "13306 HIGHWAY 107",
    "dropphycty": "LA BLANCA",
    "dropphyst": "TX",
    "dropphyzpp": 785589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA BLANCA",
    "dropmalst": "TX",
    "dropmalzpp": 785589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562623201,
    "dropsitcph": 9562623201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24352",
    "droptype": "D",
    "dropname": "LA COSTE",
    "dropdeladd": "15843 N FRONT ST",
    "dropdelcty": "LA COSTE",
    "dropdelst": "TX",
    "dropdelzpp": 780399998,
    "dropphyadd": "15843 N FRONT ST",
    "dropphycty": "LA COSTE",
    "dropphyst": "TX",
    "dropphyzpp": 780399998,
    "dropmaladd": "15843 N FRONT ST",
    "dropmalcty": "LA COSTE",
    "dropmalst": "TX",
    "dropmalzpp": 780399998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307623375,
    "dropsitcph": 8307623375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24353",
    "droptype": "D",
    "dropname": "LA FERIA",
    "dropdeladd": "201 W FIRST ST",
    "dropdelcty": "LA FERIA",
    "dropdelst": "TX",
    "dropdelzpp": 785599998,
    "dropphyadd": "201 W FIRST ST",
    "dropphycty": "LA FERIA",
    "dropphyst": "TX",
    "dropphyzpp": 785599998,
    "dropmaladd": "201 W FIRST ST",
    "dropmalcty": "LA FERIA",
    "dropmalst": "TX",
    "dropmalzpp": 785599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567971812,
    "dropsitcph": 9567971812,
    "dropfax": 9567973497
  },
  {
    "dcode": "D",
    "dropkey": "PW24355",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "113 E COLORADO ST",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "TX",
    "dropdelzpp": 789459998,
    "dropphyadd": "113 E COLORADO ST",
    "dropphycty": "LA GRANGE",
    "dropphyst": "TX",
    "dropphyzpp": 789459998,
    "dropmaladd": "113 E COLORADO ST",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "TX",
    "dropmalzpp": 789459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9799683253,
    "dropsitcph": 9799683253,
    "dropfax": 9799685810
  },
  {
    "dcode": "D",
    "dropkey": "PW24356",
    "droptype": "D",
    "dropname": "LA JOYA",
    "dropdeladd": "201 N LEO AVE",
    "dropdelcty": "LA JOYA",
    "dropdelst": "TX",
    "dropdelzpp": 785609998,
    "dropphyadd": "201 N LEO AVE",
    "dropphycty": "LA JOYA",
    "dropphyst": "TX",
    "dropphyzpp": 785609998,
    "dropmaladd": "201 N LEO AVE",
    "dropmalcty": "LA JOYA",
    "dropmalst": "TX",
    "dropmalzpp": 785609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565850142,
    "dropsitcph": 9565850142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24357",
    "droptype": "D",
    "dropname": "LA MARQUE",
    "dropdeladd": "509 LAUREL ST",
    "dropdelcty": "LA MARQUE",
    "dropdelst": "TX",
    "dropdelzpp": 775689998,
    "dropphyadd": "509 LAUREL ST",
    "dropphycty": "LA MARQUE",
    "dropphyst": "TX",
    "dropphyzpp": 775689998,
    "dropmaladd": "509 LAUREL ST",
    "dropmalcty": "LA MARQUE",
    "dropmalst": "TX",
    "dropmalzpp": 775689998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099388269,
    "dropsitcph": 4099352196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24359",
    "droptype": "D",
    "dropname": "LA PORTE",
    "dropdeladd": "801 W FAIRMONT PKWY",
    "dropdelcty": "LA PORTE",
    "dropdelst": "TX",
    "dropdelzpp": 775719998,
    "dropphyadd": "801 W FAIRMONT PKWY",
    "dropphycty": "LA PORTE",
    "dropphyst": "TX",
    "dropphyzpp": 775719998,
    "dropmaladd": "801 W FAIRMONT PKWY",
    "dropmalcty": "LA PORTE",
    "dropmalst": "TX",
    "dropmalzpp": 775719998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2818679934,
    "dropsitcph": 2818679928,
    "dropfax": 7134700712
  },
  {
    "dcode": "D",
    "dropkey": "PW24360",
    "droptype": "D",
    "dropname": "LA PRYOR",
    "dropdeladd": "189 W RUE ST",
    "dropdelcty": "LA PRYOR",
    "dropdelst": "TX",
    "dropdelzpp": 788729800,
    "dropphyadd": "189 W RUE ST",
    "dropphycty": "LA PRYOR",
    "dropphyst": "TX",
    "dropphyzpp": 788729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA PRYOR",
    "dropmalst": "TX",
    "dropmalzpp": 788729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303654505,
    "dropsitcph": 8303654505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24362",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "1999 FM 616",
    "dropdelcty": "LA SALLE",
    "dropdelst": "TX",
    "dropdelzpp": 779699800,
    "dropphyadd": "1999 FM 616",
    "dropphycty": "LA SALLE",
    "dropphyst": "TX",
    "dropphyzpp": 779699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA SALLE",
    "dropmalst": "TX",
    "dropmalzpp": 779699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612843055,
    "dropsitcph": 3612843055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24364",
    "droptype": "D",
    "dropname": "LA VERNIA",
    "dropdeladd": "2560 FM 775",
    "dropdelcty": "LA VERNIA",
    "dropdelst": "TX",
    "dropdelzpp": 781219998,
    "dropphyadd": "2560 FM 775",
    "dropphycty": "LA VERNIA",
    "dropphyst": "TX",
    "dropphyzpp": 781219998,
    "dropmaladd": "2560 FM 775",
    "dropmalcty": "LA VERNIA",
    "dropmalst": "TX",
    "dropmalzpp": 781219998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307794131,
    "dropsitcph": 8307794131,
    "dropfax": 8302531116
  },
  {
    "dcode": "D",
    "dropkey": "PW24365",
    "droptype": "D",
    "dropname": "LA VILLA",
    "dropdeladd": "852 S MIKE CHAPA DR",
    "dropdelcty": "LA VILLA",
    "dropdelst": "TX",
    "dropdelzpp": 785629800,
    "dropphyadd": "852 S MIKE CHAPA DR",
    "dropphycty": "LA VILLA",
    "dropphyst": "TX",
    "dropphyzpp": 785629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA VILLA",
    "dropmalst": "TX",
    "dropmalzpp": 785629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562623625,
    "dropsitcph": 9562623625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24367",
    "droptype": "D",
    "dropname": "LA WARD",
    "dropdeladd": "13059 STATE HIGHWAY 172",
    "dropdelcty": "LA WARD",
    "dropdelst": "TX",
    "dropdelzpp": 779709800,
    "dropphyadd": "13059 STATE HIGHWAY 172",
    "dropphycty": "LA WARD",
    "dropphyst": "TX",
    "dropphyzpp": 779709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA WARD",
    "dropmalst": "TX",
    "dropmalzpp": 779709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618722227,
    "dropsitcph": 3618722227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24371",
    "droptype": "D",
    "dropname": "LADONIA",
    "dropdeladd": "202 PARIS ST",
    "dropdelcty": "LADONIA",
    "dropdelst": "TX",
    "dropdelzpp": 754499998,
    "dropphyadd": "202 PARIS ST",
    "dropphycty": "LADONIA",
    "dropphyst": "TX",
    "dropphyzpp": 754499998,
    "dropmaladd": "202 PARIS ST",
    "dropmalcty": "LADONIA",
    "dropmalst": "TX",
    "dropmalzpp": 754499998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033677273,
    "dropsitcph": 9033677273,
    "dropfax": 9033677273
  },
  {
    "dcode": "D",
    "dropkey": "PW24379",
    "droptype": "D",
    "dropname": "LAIRD HILL",
    "dropdeladd": "10992 S STATE HIGHWAY 42",
    "dropdelcty": "LAIRD HILL",
    "dropdelst": "TX",
    "dropdelzpp": 756669702,
    "dropphyadd": "10992 S STATE HIGHWAY 42",
    "dropphycty": "LAIRD HILL",
    "dropphyst": "TX",
    "dropphyzpp": 756669702,
    "dropmaladd": "10992 S STATE HIGHWAY 42",
    "dropmalcty": "LAIRD HILL",
    "dropmalst": "TX",
    "dropmalzpp": 756669702,
    "dropsitphn": 9033243018,
    "dropsitlph": 9039847869,
    "dropsitcph": 9039847869,
    "dropfax": 9039848670
  },
  {
    "dcode": "D",
    "dropkey": "PW24382",
    "droptype": "D",
    "dropname": "LAKE CREEK",
    "dropdeladd": "2128 COUNTY ROAD 4620",
    "dropdelcty": "LAKE CREEK",
    "dropdelst": "TX",
    "dropdelzpp": 754509998,
    "dropphyadd": "2128 COUNTY ROAD 4620",
    "dropphycty": "LAKE CREEK",
    "dropphyst": "TX",
    "dropphyzpp": 754509998,
    "dropmaladd": "2128 COUNTY ROAD 4620",
    "dropmalcty": "LAKE CREEK",
    "dropmalst": "TX",
    "dropmalzpp": 754509998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033952867,
    "dropsitcph": 9033952867,
    "dropfax": 9033952867
  },
  {
    "dcode": "D",
    "dropkey": "PW24383",
    "droptype": "D",
    "dropname": "LAKE DALLAS",
    "dropdeladd": "201 S SHADY SHORES DR",
    "dropdelcty": "LAKE DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 750652980,
    "dropphyadd": "201 S SHADY SHORES DR",
    "dropphycty": "LAKE DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 750652980,
    "dropmaladd": "201 S SHADY SHORES DR",
    "dropmalcty": "LAKE DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 750652980,
    "dropsitphn": 2144675879,
    "dropsitlph": 9404976030,
    "dropsitcph": 9404976030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24385",
    "droptype": "D",
    "dropname": "LAKE JACKSON",
    "dropdeladd": "210 OAK DR S",
    "dropdelcty": "LAKE JACKSON",
    "dropdelst": "TX",
    "dropdelzpp": 775669998,
    "dropphyadd": "210 OAK DR S",
    "dropphycty": "LAKE JACKSON",
    "dropphyst": "TX",
    "dropphyzpp": 775669998,
    "dropmaladd": "210 OAK DR S",
    "dropmalcty": "LAKE JACKSON",
    "dropmalst": "TX",
    "dropmalzpp": 775669998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792972172,
    "dropsitcph": 9792972172,
    "dropfax": 9792991384
  },
  {
    "dcode": "D",
    "dropkey": "PW24401",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "13406 HIGHWAY 256",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 792399802,
    "dropphyadd": "13406 HIGHWAY 256",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 792399802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 792399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068672051,
    "dropsitcph": 8068672051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24416",
    "droptype": "D",
    "dropname": "LAMESA",
    "dropdeladd": "202 N AVENUE G",
    "dropdelcty": "LAMESA",
    "dropdelst": "TX",
    "dropdelzpp": 793319998,
    "dropphyadd": "202 N AVENUE G",
    "dropphycty": "LAMESA",
    "dropphyst": "TX",
    "dropphyzpp": 793319998,
    "dropmaladd": "202 N AVENUE G",
    "dropmalcty": "LAMESA",
    "dropmalst": "TX",
    "dropmalzpp": 793319998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068723132,
    "dropsitcph": 8068723132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24417",
    "droptype": "D",
    "dropname": "LAMPASAS",
    "dropdeladd": "1700 E 4TH ST",
    "dropdelcty": "LAMPASAS",
    "dropdelst": "TX",
    "dropdelzpp": 765509998,
    "dropphyadd": "1700 E 4TH ST",
    "dropphycty": "LAMPASAS",
    "dropphyst": "TX",
    "dropphyzpp": 765509998,
    "dropmaladd": "1700 E 4TH ST",
    "dropmalcty": "LAMPASAS",
    "dropmalst": "TX",
    "dropmalzpp": 765509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5125565131,
    "dropsitcph": 5125565131,
    "dropfax": 5125563741
  },
  {
    "dcode": "D",
    "dropkey": "PW24419",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "200 N STATE ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "TX",
    "dropdelzpp": 751469998,
    "dropphyadd": "200 N STATE ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "TX",
    "dropphyzpp": 751469998,
    "dropmaladd": "200 N STATE ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "TX",
    "dropmalzpp": 751469998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722276089,
    "dropsitcph": 9722276089,
    "dropfax": 9722187427
  },
  {
    "dcode": "D",
    "dropkey": "PW24421",
    "droptype": "D",
    "dropname": "LANE CITY",
    "dropdeladd": "110 LENERT ST",
    "dropdelcty": "LANE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 774539800,
    "dropphyadd": "110 LENERT ST",
    "dropphycty": "LANE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 774539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 774539998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795328999,
    "dropsitcph": 9795328999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24424",
    "droptype": "D",
    "dropname": "LANEVILLE",
    "dropdeladd": "13836 FM 225 S",
    "dropdelcty": "LANEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756679998,
    "dropphyadd": "13836 FM 225 S",
    "dropphycty": "LANEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756679998,
    "dropmaladd": "13836 FM 225 S",
    "dropmalcty": "LANEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756679998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038635314,
    "dropsitcph": 9038635314,
    "dropfax": 9038635362
  },
  {
    "dcode": "D",
    "dropkey": "PW24425",
    "droptype": "D",
    "dropname": "LANGTRY",
    "dropdeladd": "95 TORRES AVE",
    "dropdelcty": "LANGTRY",
    "dropdelst": "TX",
    "dropdelzpp": 788719800,
    "dropphyadd": "95 TORRES AVE",
    "dropphycty": "LANGTRY",
    "dropphyst": "TX",
    "dropphyzpp": 788719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANGTRY",
    "dropmalst": "TX",
    "dropmalzpp": 788719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9152913288,
    "dropsitcph": 9152913288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24428",
    "droptype": "D",
    "dropname": "LAREDO",
    "dropdeladd": "2700 E SAUNDERS ST",
    "dropdelcty": "LAREDO",
    "dropdelst": "TX",
    "dropdelzpp": 780419998,
    "dropphyadd": "2700 E SAUNDERS ST",
    "dropphycty": "LAREDO",
    "dropphyst": "TX",
    "dropphyzpp": 780419998,
    "dropmaladd": "2700 E SAUNDERS ST",
    "dropmalcty": "LAREDO",
    "dropmalst": "TX",
    "dropmalzpp": 780419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567232043,
    "dropsitcph": 9567232043,
    "dropfax": 9567231026
  },
  {
    "dcode": "D",
    "dropkey": "PW24429",
    "droptype": "D",
    "dropname": "LARUE",
    "dropdeladd": "11085 LOOP 60",
    "dropdelcty": "LARUE",
    "dropdelst": "TX",
    "dropdelzpp": 757709998,
    "dropphyadd": "11085 LOOP 60",
    "dropphycty": "LARUE",
    "dropphyst": "TX",
    "dropphyzpp": 757709998,
    "dropmaladd": "11085 LOOP 60",
    "dropmalcty": "LARUE",
    "dropmalst": "TX",
    "dropmalzpp": 757709998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036751460,
    "dropsitcph": 9036751460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24434",
    "droptype": "D",
    "dropname": "LASARA",
    "dropdeladd": "12056 FM 1015",
    "dropdelcty": "LASARA",
    "dropdelst": "TX",
    "dropdelzpp": 785619800,
    "dropphyadd": "12056 FM 1015",
    "dropphycty": "LASARA",
    "dropphyst": "TX",
    "dropphyzpp": 785619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LASARA",
    "dropmalst": "TX",
    "dropmalzpp": 785619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9566423622,
    "dropsitcph": 9566423622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24437",
    "droptype": "D",
    "dropname": "LATEXO",
    "dropdeladd": "3529 US HIGHWAY 287 N",
    "dropdelcty": "LATEXO",
    "dropdelst": "TX",
    "dropdelzpp": 758499998,
    "dropphyadd": "3529 US HIGHWAY 287 N",
    "dropphycty": "LATEXO",
    "dropphyst": "TX",
    "dropphyzpp": 758499998,
    "dropmaladd": "3529 US HIGHWAY 287 N",
    "dropmalcty": "LATEXO",
    "dropmalst": "TX",
    "dropmalzpp": 758499998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365442771,
    "dropsitcph": 9365442771,
    "dropfax": 9365442771
  },
  {
    "dcode": "D",
    "dropkey": "PW24442",
    "droptype": "D",
    "dropname": "LAVON",
    "dropdeladd": "609 MAIN ST",
    "dropdelcty": "LAVON",
    "dropdelst": "TX",
    "dropdelzpp": 751669998,
    "dropphyadd": "609 MAIN ST",
    "dropphycty": "LAVON",
    "dropphyst": "TX",
    "dropphyzpp": 751669998,
    "dropmaladd": "609 MAIN ST",
    "dropmalcty": "LAVON",
    "dropmalst": "TX",
    "dropmalzpp": 751669998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9728533871,
    "dropsitcph": 9728533871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24444",
    "droptype": "D",
    "dropname": "LAWN",
    "dropdeladd": "151 MAIN ST",
    "dropdelcty": "LAWN",
    "dropdelst": "TX",
    "dropdelzpp": 795309998,
    "dropphyadd": "151 MAIN ST",
    "dropphycty": "LAWN",
    "dropphyst": "TX",
    "dropphyzpp": 795309998,
    "dropmaladd": "151 MAIN ST",
    "dropmalcty": "LAWN",
    "dropmalst": "TX",
    "dropmalzpp": 795309998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255832210,
    "dropsitcph": 3255832210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24445",
    "droptype": "D",
    "dropname": "LAZBUDDIE",
    "dropdeladd": "610 FM 1172",
    "dropdelcty": "LAZBUDDIE",
    "dropdelst": "TX",
    "dropdelzpp": 790539800,
    "dropphyadd": "610 FM 1172",
    "dropphycty": "LAZBUDDIE",
    "dropphyst": "TX",
    "dropphyzpp": 790539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAZBUDDIE",
    "dropmalst": "TX",
    "dropmalzpp": 790539998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8069652623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24447",
    "droptype": "D",
    "dropname": "LEAGUE CITY",
    "dropdeladd": "240 W GALVESTON ST",
    "dropdelcty": "LEAGUE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 775739998,
    "dropphyadd": "240 W GALVESTON ST",
    "dropphycty": "LEAGUE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 775739998,
    "dropmaladd": "240 W GALVESTON ST",
    "dropmalcty": "LEAGUE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 775739998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813328203,
    "dropsitcph": 2815549219,
    "dropfax": 2813389355
  },
  {
    "dcode": "D",
    "dropkey": "PW24449",
    "droptype": "D",
    "dropname": "LEAKEY",
    "dropdeladd": "110 W RANCH ROAD 337",
    "dropdelcty": "LEAKEY",
    "dropdelst": "TX",
    "dropdelzpp": 788739998,
    "dropphyadd": "110 W RANCH ROAD 337",
    "dropphycty": "LEAKEY",
    "dropphyst": "TX",
    "dropphyzpp": 788739998,
    "dropmaladd": "110 W RANCH ROAD 337",
    "dropmalcty": "LEAKEY",
    "dropmalst": "TX",
    "dropmalzpp": 788739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302325239,
    "dropsitcph": 8302325239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24450",
    "droptype": "D",
    "dropname": "LEANDER",
    "dropdeladd": "801 S HIGHWAY 183",
    "dropdelcty": "LEANDER",
    "dropdelst": "TX",
    "dropdelzpp": 786419998,
    "dropphyadd": "801 S HIGHWAY 183",
    "dropphycty": "LEANDER",
    "dropphyst": "TX",
    "dropphyzpp": 786419998,
    "dropmaladd": "801 S HIGHWAY 183",
    "dropmalcty": "LEANDER",
    "dropmalst": "TX",
    "dropmalzpp": 786419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122590010,
    "dropsitcph": 5122599196,
    "dropfax": 5122601037
  },
  {
    "dcode": "D",
    "dropkey": "PW24453",
    "droptype": "D",
    "dropname": "LEDBETTER",
    "dropdeladd": "104 CHAPPEL ST",
    "dropdelcty": "LEDBETTER",
    "dropdelst": "TX",
    "dropdelzpp": 789469998,
    "dropphyadd": "104 CHAPPEL ST",
    "dropphycty": "LEDBETTER",
    "dropphyst": "TX",
    "dropphyzpp": 789469998,
    "dropmaladd": "104 CHAPPEL ST",
    "dropmalcty": "LEDBETTER",
    "dropmalst": "TX",
    "dropmalzpp": 789469998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792493442,
    "dropsitcph": 9792493442,
    "dropfax": 9792492536
  },
  {
    "dcode": "D",
    "dropkey": "PW24456",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "7666 STATE HIGHWAY 11 W",
    "dropdelcty": "LEESBURG",
    "dropdelst": "TX",
    "dropdelzpp": 754519998,
    "dropphyadd": "7666 STATE HIGHWAY 11 W",
    "dropphycty": "LEESBURG",
    "dropphyst": "TX",
    "dropphyzpp": 754519998,
    "dropmaladd": "7666 STATE HIGHWAY 11 W",
    "dropmalcty": "LEESBURG",
    "dropmalst": "TX",
    "dropmalzpp": 754519998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038562951,
    "dropsitcph": 9038562951,
    "dropfax": 9038562951
  },
  {
    "dcode": "D",
    "dropkey": "PW24457",
    "droptype": "D",
    "dropname": "LEESVILLE",
    "dropdeladd": "9606 N STATE HIGHWAY 80",
    "dropdelcty": "LEESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 781229998,
    "dropphyadd": "9606 N STATE HIGHWAY 80",
    "dropphycty": "LEESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 781229998,
    "dropmaladd": "9606 N STATE HIGHWAY 80",
    "dropmalcty": "LEESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 781229998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304243385,
    "dropsitcph": 8304243385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24458",
    "droptype": "D",
    "dropname": "LEFORS",
    "dropdeladd": "111 E 2ND ST",
    "dropdelcty": "LEFORS",
    "dropdelst": "TX",
    "dropdelzpp": 790549800,
    "dropphyadd": "111 E 2ND ST",
    "dropphycty": "LEFORS",
    "dropphyst": "TX",
    "dropphyzpp": 790549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEFORS",
    "dropmalst": "TX",
    "dropmalzpp": 790549998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068352221,
    "dropsitcph": 8068352221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24459",
    "droptype": "D",
    "dropname": "LEGGETT",
    "dropdeladd": "9381 US HIGHWAY 59 N",
    "dropdelcty": "LEGGETT",
    "dropdelst": "TX",
    "dropdelzpp": 773500173,
    "dropphyadd": "9381 US HIGHWAY 59 N",
    "dropphycty": "LEGGETT",
    "dropphyst": "TX",
    "dropphyzpp": 773500173,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEGGETT",
    "dropmalst": "TX",
    "dropmalzpp": 773509998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363982834,
    "dropsitcph": 9363982834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24463",
    "droptype": "D",
    "dropname": "LEMING",
    "dropdeladd": "7781 US HIGHWAY 281 N",
    "dropdelcty": "LEMING",
    "dropdelst": "TX",
    "dropdelzpp": 780509800,
    "dropphyadd": "7781 US HIGHWAY 281 N",
    "dropphycty": "LEMING",
    "dropphyst": "TX",
    "dropphyzpp": 780509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEMING",
    "dropmalst": "TX",
    "dropmalzpp": 780509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305694411,
    "dropsitcph": 8305694411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24465",
    "droptype": "D",
    "dropname": "LENORAH",
    "dropdeladd": "3298 STATE HIGHWAY 176",
    "dropdelcty": "LENORAH",
    "dropdelst": "TX",
    "dropdelzpp": 797499998,
    "dropphyadd": "3298 STATE HIGHWAY 176",
    "dropphycty": "LENORAH",
    "dropphyst": "TX",
    "dropphyzpp": 797499998,
    "dropmaladd": "3298 STATE HIGHWAY 176",
    "dropmalcty": "LENORAH",
    "dropmalst": "TX",
    "dropmalzpp": 797499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4324592410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24470",
    "droptype": "D",
    "dropname": "LEONA",
    "dropdeladd": "143 N LEONA BLVD",
    "dropdelcty": "LEONA",
    "dropdelst": "TX",
    "dropdelzpp": 758509998,
    "dropphyadd": "143 N LEONA BLVD",
    "dropphycty": "LEONA",
    "dropphyst": "TX",
    "dropphyzpp": 758509998,
    "dropmaladd": "143 N LEONA BLVD",
    "dropmalcty": "LEONA",
    "dropmalst": "TX",
    "dropmalzpp": 758509998,
    "dropsitphn": 9033443171,
    "dropsitlph": 9033443171,
    "dropsitcph": 9033443171,
    "dropfax": 9033441288
  },
  {
    "dcode": "D",
    "dropkey": "PW24471",
    "droptype": "D",
    "dropname": "LEONARD",
    "dropdeladd": "113 W COLLIN ST",
    "dropdelcty": "LEONARD",
    "dropdelst": "TX",
    "dropdelzpp": 754529998,
    "dropphyadd": "113 W COLLIN ST",
    "dropphycty": "LEONARD",
    "dropphyst": "TX",
    "dropphyzpp": 754529998,
    "dropmaladd": "113 W COLLIN ST",
    "dropmalcty": "LEONARD",
    "dropmalst": "TX",
    "dropmalzpp": 754529998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035873615,
    "dropsitcph": 9035873615,
    "dropfax": 9035872397
  },
  {
    "dcode": "D",
    "dropkey": "PW24472",
    "droptype": "D",
    "dropname": "LEROY",
    "dropdeladd": "115 W COMMERCE",
    "dropdelcty": "LEROY",
    "dropdelst": "TX",
    "dropdelzpp": 766549800,
    "dropphyadd": "115 W COMMERCE",
    "dropphycty": "LEROY",
    "dropphyst": "TX",
    "dropphyzpp": 766549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEROY",
    "dropmalst": "TX",
    "dropmalzpp": 766549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548221371,
    "dropsitcph": 2548221371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24473",
    "droptype": "D",
    "dropname": "LEVELLAND",
    "dropdeladd": "712 AVENUE G",
    "dropdelcty": "LEVELLAND",
    "dropdelst": "TX",
    "dropdelzpp": 793364515,
    "dropphyadd": "712 AVENUE G",
    "dropphycty": "LEVELLAND",
    "dropphyst": "TX",
    "dropphyzpp": 793364515,
    "dropmaladd": "712 AVENUE G",
    "dropmalcty": "LEVELLAND",
    "dropmalst": "TX",
    "dropmalzpp": 793364515,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068943250,
    "dropsitcph": 8068943250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24477",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "194 CIVIC CIR",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 750679998,
    "dropphyadd": "194 CIVIC CIR",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 750679998,
    "dropmaladd": "194 CIVIC CIR",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 750679998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723530056,
    "dropsitcph": 9723530056,
    "dropfax": 9724367230
  },
  {
    "dcode": "D",
    "dropkey": "PW24478",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "624 N ROCKDALE ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 789479998,
    "dropphyadd": "624 N ROCKDALE ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 789479998,
    "dropmaladd": "624 N ROCKDALE ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 789479998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9797732367,
    "dropsitcph": 9797732367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24481",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "1515 SAM HOUSTON ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "TX",
    "dropdelzpp": 775759998,
    "dropphyadd": "1515 SAM HOUSTON ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "TX",
    "dropphyzpp": 775759998,
    "dropmaladd": "1515 SAM HOUSTON ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "TX",
    "dropmalzpp": 775759998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363366182,
    "dropsitcph": 9363366182,
    "dropfax": 9363349823
  },
  {
    "dcode": "D",
    "dropkey": "PW24483",
    "droptype": "D",
    "dropname": "LIBERTY HILL",
    "dropdeladd": "2655 RANCH ROAD 1869",
    "dropdelcty": "LIBERTY HILL",
    "dropdelst": "TX",
    "dropdelzpp": 786429998,
    "dropphyadd": "2655 RANCH ROAD 1869",
    "dropphycty": "LIBERTY HILL",
    "dropphyst": "TX",
    "dropphyzpp": 786429998,
    "dropmaladd": "2655 RANCH ROAD 1869",
    "dropmalcty": "LIBERTY HILL",
    "dropmalst": "TX",
    "dropmalzpp": 786429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5125156293,
    "dropsitcph": 5125156293,
    "dropfax": 5127785837
  },
  {
    "dcode": "D",
    "dropkey": "PW24485",
    "droptype": "D",
    "dropname": "LILLIAN",
    "dropdeladd": "10061 E FM 917",
    "dropdelcty": "LILLIAN",
    "dropdelst": "TX",
    "dropdelzpp": 760619800,
    "dropphyadd": "10061 E FM 917",
    "dropphycty": "LILLIAN",
    "dropphyst": "TX",
    "dropphyzpp": 760619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LILLIAN",
    "dropmalst": "TX",
    "dropmalzpp": 760619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8177902033,
    "dropsitcph": 8177902033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24487",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "1243 MAIN AVE",
    "dropdelcty": "LINCOLN",
    "dropdelst": "TX",
    "dropdelzpp": 789489998,
    "dropphyadd": "1243 MAIN AVE",
    "dropphycty": "LINCOLN",
    "dropphyst": "TX",
    "dropphyzpp": 789489998,
    "dropmaladd": "1243 MAIN AVE",
    "dropmalcty": "LINCOLN",
    "dropmalst": "TX",
    "dropmalzpp": 789489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9795420869,
    "dropsitcph": 9795420869,
    "dropfax": 9795420869
  },
  {
    "dcode": "D",
    "dropkey": "PW24488",
    "droptype": "D",
    "dropname": "LINDALE",
    "dropdeladd": "507 S MAIN ST",
    "dropdelcty": "LINDALE",
    "dropdelst": "TX",
    "dropdelzpp": 757719998,
    "dropphyadd": "507 S MAIN ST",
    "dropphycty": "LINDALE",
    "dropphyst": "TX",
    "dropphyzpp": 757719998,
    "dropmaladd": "507 S MAIN ST",
    "dropmalcty": "LINDALE",
    "dropmalst": "TX",
    "dropmalzpp": 757719998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038823586,
    "dropsitcph": 9038823586,
    "dropfax": 9038829077
  },
  {
    "dcode": "D",
    "dropkey": "PW24489",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "200 E RUSH ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "TX",
    "dropdelzpp": 755639998,
    "dropphyadd": "200 E RUSH ST",
    "dropphycty": "LINDEN",
    "dropphyst": "TX",
    "dropphyzpp": 755639998,
    "dropmaladd": "200 E RUSH ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "TX",
    "dropmalzpp": 755639998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037565861,
    "dropsitcph": 9037565861,
    "dropfax": 9037567224
  },
  {
    "dcode": "D",
    "dropkey": "PW24491",
    "droptype": "D",
    "dropname": "LINDSAY",
    "dropdeladd": "625 N ASH ST",
    "dropdelcty": "LINDSAY",
    "dropdelst": "TX",
    "dropdelzpp": 762509998,
    "dropphyadd": "625 N ASH ST",
    "dropphycty": "LINDSAY",
    "dropphyst": "TX",
    "dropphyzpp": 762509998,
    "dropmaladd": "625 N ASH ST",
    "dropmalcty": "LINDSAY",
    "dropmalst": "TX",
    "dropmalzpp": 762509998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406650422,
    "dropsitcph": 9406650422,
    "dropfax": 9406680743
  },
  {
    "dcode": "D",
    "dropkey": "PW24492",
    "droptype": "D",
    "dropname": "LINGLEVILLE",
    "dropdeladd": "18999 W FM 8",
    "dropdelcty": "LINGLEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 764619801,
    "dropphyadd": "18999 W FM 8",
    "dropphycty": "LINGLEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 764619801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINGLEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 764619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2549683137,
    "dropsitcph": 2549683137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24493",
    "droptype": "D",
    "dropname": "LINN",
    "dropdeladd": "22005 FM 1017",
    "dropdelcty": "LINN",
    "dropdelst": "TX",
    "dropdelzpp": 785639998,
    "dropphyadd": "22005 FM 1017",
    "dropphycty": "LINN",
    "dropphyst": "TX",
    "dropphyzpp": 785639998,
    "dropmaladd": "22005 FM 1017",
    "dropmalcty": "LINN",
    "dropmalst": "TX",
    "dropmalzpp": 785639998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563832810,
    "dropsitcph": 9563832810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24495",
    "droptype": "D",
    "dropname": "LIPAN",
    "dropdeladd": "106 W LIPAN DR",
    "dropdelcty": "LIPAN",
    "dropdelst": "TX",
    "dropdelzpp": 764629803,
    "dropphyadd": "106 W LIPAN DR",
    "dropphycty": "LIPAN",
    "dropphyst": "TX",
    "dropphyzpp": 764629803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIPAN",
    "dropmalst": "TX",
    "dropmalzpp": 764629998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546462225,
    "dropsitcph": 2546462225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24496",
    "droptype": "D",
    "dropname": "LIPSCOMB",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "LIPSCOMB",
    "dropdelst": "TX",
    "dropdelzpp": 790569802,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "LIPSCOMB",
    "dropphyst": "TX",
    "dropphyzpp": 790569802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIPSCOMB",
    "dropmalst": "TX",
    "dropmalzpp": 790569998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068625463,
    "dropsitcph": 8068625463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24497",
    "droptype": "D",
    "dropname": "LISSIE",
    "dropdeladd": "213 RAYMOND AVE",
    "dropdelcty": "LISSIE",
    "dropdelst": "TX",
    "dropdelzpp": 774549800,
    "dropphyadd": "213 RAYMOND AVE",
    "dropphycty": "LISSIE",
    "dropphyst": "TX",
    "dropphyzpp": 774549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LISSIE",
    "dropmalst": "TX",
    "dropmalzpp": 774549998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792345389,
    "dropsitcph": 9792345389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24499",
    "droptype": "D",
    "dropname": "LITTLE ELM",
    "dropdeladd": "1012 W ELDORADO PKWY",
    "dropdelcty": "LITTLE ELM",
    "dropdelst": "TX",
    "dropdelzpp": 750689998,
    "dropphyadd": "1012 W ELDORADO PKWY",
    "dropphycty": "LITTLE ELM",
    "dropphyst": "TX",
    "dropphyzpp": 750689998,
    "dropmaladd": "1012 W ELDORADO PKWY",
    "dropmalcty": "LITTLE ELM",
    "dropmalst": "TX",
    "dropmalzpp": 750689998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722921864,
    "dropsitcph": 9722921864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24501",
    "droptype": "D",
    "dropname": "LITTLE RIVER ACADEMY",
    "dropdeladd": "106 N EVANS ST",
    "dropdelcty": "LITTLE RIVER ACADEMY",
    "dropdelst": "TX",
    "dropdelzpp": 765549998,
    "dropphyadd": "106 N EVANS ST",
    "dropphycty": "LITTLE RIVER ACADEMY",
    "dropphyst": "TX",
    "dropphyzpp": 765549998,
    "dropmaladd": "106 N EVANS ST",
    "dropmalcty": "LITTLE RIVER ACADEMY",
    "dropmalst": "TX",
    "dropmalzpp": 765549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549824411,
    "dropsitcph": 2549824411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24503",
    "droptype": "D",
    "dropname": "LITTLEFIELD",
    "dropdeladd": "801 PHELPS AVE",
    "dropdelcty": "LITTLEFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 793393800,
    "dropphyadd": "801 PHELPS AVE",
    "dropphycty": "LITTLEFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 793393800,
    "dropmaladd": "801 PHELPS AVE",
    "dropmalcty": "LITTLEFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 793393800,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063854030,
    "dropsitcph": 8063854030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24505",
    "droptype": "D",
    "dropname": "LIVERPOOL",
    "dropdeladd": "2320 MAIN ST",
    "dropdelcty": "LIVERPOOL",
    "dropdelst": "TX",
    "dropdelzpp": 775778744,
    "dropphyadd": "2320 MAIN ST",
    "dropphycty": "LIVERPOOL",
    "dropphyst": "TX",
    "dropphyzpp": 775778744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIVERPOOL",
    "dropmalst": "TX",
    "dropmalzpp": 775779998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815812270,
    "dropsitcph": 2815812270,
    "dropfax": 2815812739
  },
  {
    "dcode": "D",
    "dropkey": "PW24506",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "1325 W CHURCH ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "TX",
    "dropdelzpp": 773519998,
    "dropphyadd": "1325 W CHURCH ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "TX",
    "dropphyzpp": 773519998,
    "dropmaladd": "1325 W CHURCH ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "TX",
    "dropmalzpp": 773519998,
    "dropsitphn": 9363278713,
    "dropsitlph": 7132226305,
    "dropsitcph": 9363278713,
    "dropfax": 9363272118
  },
  {
    "dcode": "D",
    "dropkey": "PW24507",
    "droptype": "D",
    "dropname": "LLANO",
    "dropdeladd": "819 BERRY ST",
    "dropdelcty": "LLANO",
    "dropdelst": "TX",
    "dropdelzpp": 786439998,
    "dropphyadd": "819 BERRY ST",
    "dropphycty": "LLANO",
    "dropphyst": "TX",
    "dropphyzpp": 786439998,
    "dropmaladd": "819 BERRY ST",
    "dropmalcty": "LLANO",
    "dropmalst": "TX",
    "dropmalzpp": 786439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3252474547,
    "dropsitcph": 3252474547,
    "dropfax": 3252473506
  },
  {
    "dcode": "D",
    "dropkey": "PW24509",
    "droptype": "D",
    "dropname": "LOCKHART",
    "dropdeladd": "217 W MARKET ST",
    "dropdelcty": "LOCKHART",
    "dropdelst": "TX",
    "dropdelzpp": 786449998,
    "dropphyadd": "217 W MARKET ST",
    "dropphycty": "LOCKHART",
    "dropphyst": "TX",
    "dropphyzpp": 786449998,
    "dropmaladd": "217 W MARKET ST",
    "dropmalcty": "LOCKHART",
    "dropmalst": "TX",
    "dropmalzpp": 786449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123769620,
    "dropsitcph": 5123769620,
    "dropfax": 5123982382
  },
  {
    "dcode": "D",
    "dropkey": "PW24511",
    "droptype": "D",
    "dropname": "LOCKNEY",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "LOCKNEY",
    "dropdelst": "TX",
    "dropdelzpp": 792419802,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "LOCKNEY",
    "dropphyst": "TX",
    "dropphyzpp": 792419802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCKNEY",
    "dropmalst": "TX",
    "dropmalzpp": 792419998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066522384,
    "dropsitcph": 8066522384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24512",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "6819 FM 248 S",
    "dropdelcty": "LODI",
    "dropdelst": "TX",
    "dropdelzpp": 755649998,
    "dropphyadd": "6819 FM 248 S",
    "dropphycty": "LODI",
    "dropphyst": "TX",
    "dropphyzpp": 755649998,
    "dropmaladd": "6819 FM 248 S",
    "dropmalcty": "LODI",
    "dropmalst": "TX",
    "dropmalzpp": 755649998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036658901,
    "dropsitcph": 9036658901,
    "dropfax": 9036659576
  },
  {
    "dcode": "D",
    "dropkey": "PW24514",
    "droptype": "D",
    "dropname": "LOHN",
    "dropdeladd": "1156 FM 504",
    "dropdelcty": "LOHN",
    "dropdelst": "TX",
    "dropdelzpp": 768529801,
    "dropphyadd": "1156 FM 504",
    "dropphycty": "LOHN",
    "dropphyst": "TX",
    "dropphyzpp": 768529801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOHN",
    "dropmalst": "TX",
    "dropmalzpp": 768529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253445550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24515",
    "droptype": "D",
    "dropname": "LOLITA",
    "dropdeladd": "8966 FM 1593",
    "dropdelcty": "LOLITA",
    "dropdelst": "TX",
    "dropdelzpp": 779719998,
    "dropphyadd": "8966 FM 1593",
    "dropphycty": "LOLITA",
    "dropphyst": "TX",
    "dropphyzpp": 779719998,
    "dropmaladd": "8966 FM 1593",
    "dropmalcty": "LOLITA",
    "dropmalst": "TX",
    "dropmalzpp": 779719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618744469,
    "dropsitcph": 3618744469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24517",
    "droptype": "D",
    "dropname": "LOMETA",
    "dropdeladd": "116 E ELM ST",
    "dropdelcty": "LOMETA",
    "dropdelst": "TX",
    "dropdelzpp": 768539997,
    "dropphyadd": "116 E ELM ST",
    "dropphycty": "LOMETA",
    "dropphyst": "TX",
    "dropphyzpp": 768539997,
    "dropmaladd": "116 E ELM ST",
    "dropmalcty": "LOMETA",
    "dropmalst": "TX",
    "dropmalzpp": 768539997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 5125403160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24518",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "17295 N US HIGHWAY 377",
    "dropdelcty": "LONDON",
    "dropdelst": "TX",
    "dropdelzpp": 768549998,
    "dropphyadd": "17295 N US HIGHWAY 377",
    "dropphycty": "LONDON",
    "dropphyst": "TX",
    "dropphyzpp": 768549998,
    "dropmaladd": "17295 N US HIGHWAY 377",
    "dropmalcty": "LONDON",
    "dropmalst": "TX",
    "dropmalzpp": 768549998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254752254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24521",
    "droptype": "D",
    "dropname": "LONE OAK",
    "dropdeladd": "401 US HIGHWAY 69 N",
    "dropdelcty": "LONE OAK",
    "dropdelst": "TX",
    "dropdelzpp": 754539998,
    "dropphyadd": "401 US HIGHWAY 69 N",
    "dropphycty": "LONE OAK",
    "dropphyst": "TX",
    "dropphyzpp": 754539998,
    "dropmaladd": "401 US HIGHWAY 69 N",
    "dropmalcty": "LONE OAK",
    "dropmalst": "TX",
    "dropmalzpp": 754539998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036625315,
    "dropsitcph": 9036625315,
    "dropfax": 9036625065
  },
  {
    "dcode": "D",
    "dropkey": "PW24523",
    "droptype": "D",
    "dropname": "LONE STAR",
    "dropdeladd": "308 N MAIN ST",
    "dropdelcty": "LONE STAR",
    "dropdelst": "TX",
    "dropdelzpp": 756689998,
    "dropphyadd": "308 N MAIN ST",
    "dropphycty": "LONE STAR",
    "dropphyst": "TX",
    "dropphyzpp": 756689998,
    "dropmaladd": "308 N MAIN ST",
    "dropmalcty": "LONE STAR",
    "dropmalst": "TX",
    "dropmalzpp": 756689998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036563511,
    "dropsitcph": 9036563511,
    "dropfax": 9036562005
  },
  {
    "dcode": "D",
    "dropkey": "PW24526",
    "droptype": "D",
    "dropname": "LONG BRANCH",
    "dropdeladd": "671 FM 348",
    "dropdelcty": "LONG BRANCH",
    "dropdelst": "TX",
    "dropdelzpp": 756699998,
    "dropphyadd": "671 FM 348",
    "dropphycty": "LONG BRANCH",
    "dropphyst": "TX",
    "dropphyzpp": 756699998,
    "dropmaladd": "671 FM 348",
    "dropmalcty": "LONG BRANCH",
    "dropmalst": "TX",
    "dropmalzpp": 756699998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038892389,
    "dropsitcph": 9038892389,
    "dropfax": 9038892389
  },
  {
    "dcode": "D",
    "dropkey": "PW24532",
    "droptype": "D",
    "dropname": "LONGVIEW",
    "dropdeladd": "2336 S MOBBERLY AVE",
    "dropdelcty": "LONGVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 756029998,
    "dropphyadd": "2336 S MOBBERLY AVE",
    "dropphycty": "LONGVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 756029998,
    "dropmaladd": "2336 S MOBBERLY AVE",
    "dropmalcty": "LONGVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 756029998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037537644,
    "dropsitcph": 9037537644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24535",
    "droptype": "D",
    "dropname": "LOOP",
    "dropdeladd": "895 STATE HIGHWAY 83 E",
    "dropdelcty": "LOOP",
    "dropdelst": "TX",
    "dropdelzpp": 793429802,
    "dropphyadd": "895 STATE HIGHWAY 83 E",
    "dropphycty": "LOOP",
    "dropphyst": "TX",
    "dropphyzpp": 793429802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOOP",
    "dropmalst": "TX",
    "dropmalzpp": 793429998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064876696,
    "dropsitcph": 8064876696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24536",
    "droptype": "D",
    "dropname": "LOPENO",
    "dropdeladd": "305 1ST ST",
    "dropdelcty": "LOPENO",
    "dropdelst": "TX",
    "dropdelzpp": 785649998,
    "dropphyadd": "305 1ST ST",
    "dropphycty": "LOPENO",
    "dropphyst": "TX",
    "dropphyzpp": 785649998,
    "dropmaladd": "305 1ST ST",
    "dropmalcty": "LOPENO",
    "dropmalst": "TX",
    "dropmalzpp": 785649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568485201,
    "dropsitcph": 9568485201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24538",
    "droptype": "D",
    "dropname": "LORAINE",
    "dropdeladd": "118 S MAIN ST",
    "dropdelcty": "LORAINE",
    "dropdelst": "TX",
    "dropdelzpp": 795329998,
    "dropphyadd": "118 S MAIN ST",
    "dropphycty": "LORAINE",
    "dropphyst": "TX",
    "dropphyzpp": 795329998,
    "dropmaladd": "118 S MAIN ST",
    "dropmalcty": "LORAINE",
    "dropmalst": "TX",
    "dropmalzpp": 795329998,
    "dropsitphn": 3257372233,
    "dropsitlph": 3257372233,
    "dropsitcph": 3257372233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24539",
    "droptype": "D",
    "dropname": "LORENA",
    "dropdeladd": "1190 OLD LORENA RD",
    "dropdelcty": "LORENA",
    "dropdelst": "TX",
    "dropdelzpp": 766559998,
    "dropphyadd": "1190 OLD LORENA RD",
    "dropphycty": "LORENA",
    "dropphyst": "TX",
    "dropphyzpp": 766559998,
    "dropmaladd": "1190 OLD LORENA RD",
    "dropmalcty": "LORENA",
    "dropmalst": "TX",
    "dropmalzpp": 766559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548573248,
    "dropsitcph": 2548573248,
    "dropfax": 2548579322
  },
  {
    "dcode": "D",
    "dropkey": "PW24540",
    "droptype": "D",
    "dropname": "LORENZO",
    "dropdeladd": "225 US HIGHWAY 82",
    "dropdelcty": "LORENZO",
    "dropdelst": "TX",
    "dropdelzpp": 793432651,
    "dropphyadd": "225 US HIGHWAY 82",
    "dropphycty": "LORENZO",
    "dropphyst": "TX",
    "dropphyzpp": 793432651,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LORENZO",
    "dropmalst": "TX",
    "dropmalzpp": 793439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066345533,
    "dropsitcph": 8066345533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24544",
    "droptype": "D",
    "dropname": "LOS EBANOS",
    "dropdeladd": "185 ROSENDO BENAVIDEZ ST",
    "dropdelcty": "LOS EBANOS",
    "dropdelst": "TX",
    "dropdelzpp": 785655000,
    "dropphyadd": "185 ROSENDO BENAVIDEZ ST",
    "dropphycty": "LOS EBANOS",
    "dropphyst": "TX",
    "dropphyzpp": 785655000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOS EBANOS",
    "dropmalst": "TX",
    "dropmalzpp": 785659998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564852262,
    "dropsitcph": 9564852262,
    "dropfax": 9564859148
  },
  {
    "dcode": "D",
    "dropkey": "PW24545",
    "droptype": "D",
    "dropname": "LOS FRESNOS",
    "dropdeladd": "301 W OCEAN BLVD",
    "dropdelcty": "LOS FRESNOS",
    "dropdelst": "TX",
    "dropdelzpp": 785669998,
    "dropphyadd": "301 W OCEAN BLVD",
    "dropphycty": "LOS FRESNOS",
    "dropphyst": "TX",
    "dropphyzpp": 785669998,
    "dropmaladd": "301 W OCEAN BLVD",
    "dropmalcty": "LOS FRESNOS",
    "dropmalst": "TX",
    "dropmalzpp": 785669998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562335522,
    "dropsitcph": 9562335522,
    "dropfax": 9562339886
  },
  {
    "dcode": "D",
    "dropkey": "PW24546",
    "droptype": "D",
    "dropname": "LOS INDIOS",
    "dropdeladd": "810 E US HIGHWAY 281",
    "dropdelcty": "LOS INDIOS",
    "dropdelst": "TX",
    "dropdelzpp": 785679800,
    "dropphyadd": "810 E US HIGHWAY 281",
    "dropphycty": "LOS INDIOS",
    "dropphyst": "TX",
    "dropphyzpp": 785679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOS INDIOS",
    "dropmalst": "TX",
    "dropmalzpp": 785679998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563990470,
    "dropsitcph": 9563990470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24549",
    "droptype": "D",
    "dropname": "LOTT",
    "dropdeladd": "217 E GASSAWAY",
    "dropdelcty": "LOTT",
    "dropdelst": "TX",
    "dropdelzpp": 766569998,
    "dropphyadd": "217 E GASSAWAY",
    "dropphycty": "LOTT",
    "dropphyst": "TX",
    "dropphyzpp": 766569998,
    "dropmaladd": "217 E GASSAWAY",
    "dropmalcty": "LOTT",
    "dropmalst": "TX",
    "dropmalzpp": 766569998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2542390047,
    "dropsitcph": 2542390047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24550",
    "droptype": "D",
    "dropname": "LOUISE",
    "dropdeladd": "1000 N ST",
    "dropdelcty": "LOUISE",
    "dropdelst": "TX",
    "dropdelzpp": 774559800,
    "dropphyadd": "1000 N ST",
    "dropphycty": "LOUISE",
    "dropphyst": "TX",
    "dropphyzpp": 774559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOUISE",
    "dropmalst": "TX",
    "dropmalzpp": 774559998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792432658,
    "dropsitcph": 9792432658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24552",
    "droptype": "D",
    "dropname": "LOVELADY",
    "dropdeladd": "290 S COMMERCE ST",
    "dropdelcty": "LOVELADY",
    "dropdelst": "TX",
    "dropdelzpp": 758519998,
    "dropphyadd": "290 S COMMERCE ST",
    "dropphycty": "LOVELADY",
    "dropphyst": "TX",
    "dropphyzpp": 758519998,
    "dropmaladd": "290 S COMMERCE ST",
    "dropmalcty": "LOVELADY",
    "dropmalst": "TX",
    "dropmalzpp": 758519998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366367699,
    "dropsitcph": 9366367699,
    "dropfax": 9366367358
  },
  {
    "dcode": "D",
    "dropkey": "PW24553",
    "droptype": "D",
    "dropname": "LOVING",
    "dropdeladd": "401 HAWKINS ST",
    "dropdelcty": "LOVING",
    "dropdelst": "TX",
    "dropdelzpp": 764603000,
    "dropphyadd": "401 HAWKINS ST",
    "dropphycty": "LOVING",
    "dropphyst": "TX",
    "dropphyzpp": 764603000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOVING",
    "dropmalst": "TX",
    "dropmalzpp": 764609998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403782259,
    "dropsitcph": 9403782259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24556",
    "droptype": "D",
    "dropname": "LOZANO",
    "dropdeladd": "25698 E BROWN TRACT RD",
    "dropdelcty": "LOZANO",
    "dropdelst": "TX",
    "dropdelzpp": 785689800,
    "dropphyadd": "25698 E BROWN TRACT RD",
    "dropphycty": "LOZANO",
    "dropphyst": "TX",
    "dropphyzpp": 785689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOZANO",
    "dropmalst": "TX",
    "dropmalzpp": 785689998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567482218,
    "dropsitcph": 9567482218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24558",
    "droptype": "D",
    "dropname": "LUBBOCK",
    "dropdeladd": "1515 CRICKETS AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794029997,
    "dropphyadd": "1515 CRICKETS AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794029997,
    "dropmaladd": "1515 CRICKETS AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794029997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067627841,
    "dropsitcph": 8067627841,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "PW24561",
    "droptype": "D",
    "dropname": "LUEDERS",
    "dropdeladd": "125 E MAIN ST",
    "dropdelcty": "LUEDERS",
    "dropdelst": "TX",
    "dropdelzpp": 795339998,
    "dropphyadd": "125 E MAIN ST",
    "dropphycty": "LUEDERS",
    "dropphyst": "TX",
    "dropphyzpp": 795339998,
    "dropmaladd": "125 E MAIN ST",
    "dropmalcty": "LUEDERS",
    "dropmalst": "TX",
    "dropmalzpp": 795339998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3252284512,
    "dropsitcph": 3252284512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24563",
    "droptype": "D",
    "dropname": "LUFKIN",
    "dropdeladd": "800 S JOHN REDDITT DR",
    "dropdelcty": "LUFKIN",
    "dropdelst": "TX",
    "dropdelzpp": 759049998,
    "dropphyadd": "800 S JOHN REDDITT DR",
    "dropphycty": "LUFKIN",
    "dropphyst": "TX",
    "dropphyzpp": 759049998,
    "dropmaladd": "800 S JOHN REDDITT DR",
    "dropmalcty": "LUFKIN",
    "dropmalst": "TX",
    "dropmalzpp": 759049998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366347749,
    "dropsitcph": 9366347749,
    "dropfax": 9366392766
  },
  {
    "dcode": "D",
    "dropkey": "PW24564",
    "droptype": "D",
    "dropname": "LULING",
    "dropdeladd": "517 E CROCKETT ST",
    "dropdelcty": "LULING",
    "dropdelst": "TX",
    "dropdelzpp": 786489998,
    "dropphyadd": "517 E CROCKETT ST",
    "dropphycty": "LULING",
    "dropphyst": "TX",
    "dropphyzpp": 786489998,
    "dropmaladd": "517 E CROCKETT ST",
    "dropmalcty": "LULING",
    "dropmalst": "TX",
    "dropmalzpp": 786489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308752214,
    "dropsitcph": 8308752214,
    "dropfax": 8308759507
  },
  {
    "dcode": "D",
    "dropkey": "PW24568",
    "droptype": "D",
    "dropname": "LYFORD",
    "dropdeladd": "13461 W BROADWAY",
    "dropdelcty": "LYFORD",
    "dropdelst": "TX",
    "dropdelzpp": 785699998,
    "dropphyadd": "13461 W BROADWAY",
    "dropphycty": "LYFORD",
    "dropphyst": "TX",
    "dropphyzpp": 785699998,
    "dropmaladd": "13461 W BROADWAY",
    "dropmalcty": "LYFORD",
    "dropmalst": "TX",
    "dropmalzpp": 785699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563473537,
    "dropsitcph": 9563473537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24571",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "14030 HWY 36 S",
    "dropdelcty": "LYONS",
    "dropdelst": "TX",
    "dropdelzpp": 778639700,
    "dropphyadd": "14030 HWY 36 S",
    "dropphycty": "LYONS",
    "dropphyst": "TX",
    "dropphyzpp": 778639700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYONS",
    "dropmalst": "TX",
    "dropmalzpp": 778639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795961623,
    "dropsitcph": 9795961623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24572",
    "droptype": "D",
    "dropname": "LYTLE",
    "dropdeladd": "14841 MAIN ST",
    "dropdelcty": "LYTLE",
    "dropdelst": "TX",
    "dropdelzpp": 780529998,
    "dropphyadd": "14841 MAIN ST",
    "dropphycty": "LYTLE",
    "dropphyst": "TX",
    "dropphyzpp": 780529998,
    "dropmaladd": "14841 MAIN ST",
    "dropmalcty": "LYTLE",
    "dropmalst": "TX",
    "dropmalzpp": 780529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307723730,
    "dropsitcph": 8307723730,
    "dropfax": 8307725723
  },
  {
    "dcode": "D",
    "dropkey": "PW24576",
    "droptype": "D",
    "dropname": "MABANK",
    "dropdeladd": "1401 S 3RD ST",
    "dropdelcty": "MABANK",
    "dropdelst": "TX",
    "dropdelzpp": 751479998,
    "dropphyadd": "1401 S 3RD ST",
    "dropphycty": "MABANK",
    "dropphyst": "TX",
    "dropphyzpp": 751479998,
    "dropmaladd": "1401 S 3RD ST",
    "dropmalcty": "MABANK",
    "dropmalst": "TX",
    "dropmalzpp": 751479998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9038875171,
    "dropsitcph": 9038875171,
    "dropfax": 9038872867
  },
  {
    "dcode": "D",
    "dropkey": "PW24577",
    "droptype": "D",
    "dropname": "MACDONA",
    "dropdeladd": "9880 ALIANN",
    "dropdelcty": "MACDONA",
    "dropdelst": "TX",
    "dropdelzpp": 780549800,
    "dropphyadd": "9880 ALIANN",
    "dropphycty": "MACDONA",
    "dropphyst": "TX",
    "dropphyzpp": 780549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACDONA",
    "dropmalst": "TX",
    "dropmalzpp": 780549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106225209,
    "dropsitcph": 2106225126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24582",
    "droptype": "D",
    "dropname": "MADISONVILLE",
    "dropdeladd": "310 N COMMERCE ST",
    "dropdelcty": "MADISONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 778649998,
    "dropphyadd": "310 N COMMERCE ST",
    "dropphycty": "MADISONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 778649998,
    "dropmaladd": "310 N COMMERCE ST",
    "dropmalcty": "MADISONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 778649998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363482585,
    "dropsitcph": 9363482585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24585",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "815 GOODSON RD",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "TX",
    "dropdelzpp": 773559998,
    "dropphyadd": "815 GOODSON RD",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "TX",
    "dropphyzpp": 773559998,
    "dropmaladd": "815 GOODSON RD",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "TX",
    "dropmalzpp": 773559998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813568427,
    "dropsitcph": 2813568427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24593",
    "droptype": "D",
    "dropname": "MALAKOFF",
    "dropdeladd": "609 W ROYALL BLVD",
    "dropdelcty": "MALAKOFF",
    "dropdelst": "TX",
    "dropdelzpp": 751489998,
    "dropphyadd": "609 W ROYALL BLVD",
    "dropphycty": "MALAKOFF",
    "dropphyst": "TX",
    "dropphyzpp": 751489998,
    "dropmaladd": "609 W ROYALL BLVD",
    "dropmalcty": "MALAKOFF",
    "dropmalst": "TX",
    "dropmalzpp": 751489998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9034890818,
    "dropsitcph": 9034890818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24595",
    "droptype": "D",
    "dropname": "MALONE",
    "dropdeladd": "221 N PECAN",
    "dropdelcty": "MALONE",
    "dropdelst": "TX",
    "dropdelzpp": 766603090,
    "dropphyadd": "221 N PECAN",
    "dropphycty": "MALONE",
    "dropphyst": "TX",
    "dropphyzpp": 766603090,
    "dropmaladd": "221 N PECAN",
    "dropmalcty": "MALONE",
    "dropmalst": "TX",
    "dropmalzpp": 766603090,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545332255,
    "dropsitcph": 2545332255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24597",
    "droptype": "D",
    "dropname": "MANCHACA",
    "dropdeladd": "780 W FM 1626",
    "dropdelcty": "MANCHACA",
    "dropdelst": "TX",
    "dropdelzpp": 786529998,
    "dropphyadd": "780 W FM 1626",
    "dropphycty": "MANCHACA",
    "dropphyst": "TX",
    "dropphyzpp": 786529998,
    "dropmaladd": "780 W FM 1626",
    "dropmalcty": "MANCHACA",
    "dropmalst": "TX",
    "dropmalzpp": 786529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122821579,
    "dropsitcph": 5122821579,
    "dropfax": 5122911063
  },
  {
    "dcode": "D",
    "dropkey": "PW24601",
    "droptype": "D",
    "dropname": "MANOR",
    "dropdeladd": "11401 US HIGHWAY 290 E",
    "dropdelcty": "MANOR",
    "dropdelst": "TX",
    "dropdelzpp": 786539998,
    "dropphyadd": "11401 US HIGHWAY 290 E",
    "dropphycty": "MANOR",
    "dropphyst": "TX",
    "dropphyzpp": 786539998,
    "dropmaladd": "11401 US HIGHWAY 290 E",
    "dropmalcty": "MANOR",
    "dropmalst": "TX",
    "dropmalzpp": 786539998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122729186,
    "dropsitcph": 5122729268,
    "dropfax": 5122780120
  },
  {
    "dcode": "D",
    "dropkey": "PW24602",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "752 N MAIN ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 760633203,
    "dropphyadd": "752 N MAIN ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 760633203,
    "dropmaladd": "752 N MAIN ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 760633203,
    "dropsitphn": 8174731827,
    "dropsitlph": 8174732089,
    "dropsitcph": 8174731827,
    "dropfax": 8174730282
  },
  {
    "dcode": "D",
    "dropkey": "PW24603",
    "droptype": "D",
    "dropname": "MANVEL",
    "dropdeladd": "6925 MASTERS RD",
    "dropdelcty": "MANVEL",
    "dropdelst": "TX",
    "dropdelzpp": 775789998,
    "dropphyadd": "6925 MASTERS RD",
    "dropphycty": "MANVEL",
    "dropphyst": "TX",
    "dropphyzpp": 775789998,
    "dropmaladd": "6925 MASTERS RD",
    "dropmalcty": "MANVEL",
    "dropmalst": "TX",
    "dropmalzpp": 775789998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814892863,
    "dropsitcph": 2814892861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24606",
    "droptype": "D",
    "dropname": "MARATHON",
    "dropdeladd": "107 E US HIGHWAY 90",
    "dropdelcty": "MARATHON",
    "dropdelst": "TX",
    "dropdelzpp": 798429998,
    "dropphyadd": "107 E US HIGHWAY 90",
    "dropphycty": "MARATHON",
    "dropphyst": "TX",
    "dropphyzpp": 798429998,
    "dropmaladd": "107 E US HIGHWAY 90",
    "dropmalcty": "MARATHON",
    "dropmalst": "TX",
    "dropmalzpp": 798429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323864472,
    "dropfax": 4323864286
  },
  {
    "dcode": "D",
    "dropkey": "PW24607",
    "droptype": "D",
    "dropname": "MARBLE FALLS",
    "dropdeladd": "1212 N US HIGHWAY 281",
    "dropdelcty": "MARBLE FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 786549998,
    "dropphyadd": "1212 N US HIGHWAY 281",
    "dropphycty": "MARBLE FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 786549998,
    "dropmaladd": "1212 N US HIGHWAY 281",
    "dropmalcty": "MARBLE FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 786549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306933531,
    "dropsitcph": 8306933531,
    "dropfax": 8306938634
  },
  {
    "dcode": "D",
    "dropkey": "PW24608",
    "droptype": "D",
    "dropname": "MARFA",
    "dropdeladd": "100 N HIGHLAND AVE",
    "dropdelcty": "MARFA",
    "dropdelst": "TX",
    "dropdelzpp": 798439998,
    "dropphyadd": "100 N HIGHLAND AVE",
    "dropphycty": "MARFA",
    "dropphyst": "TX",
    "dropphyzpp": 798439998,
    "dropmaladd": "100 N HIGHLAND AVE",
    "dropmalcty": "MARFA",
    "dropmalst": "TX",
    "dropmalzpp": 798439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4327294001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24609",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "104 S CENTRAL AVE",
    "dropdelcty": "MARIETTA",
    "dropdelst": "TX",
    "dropdelzpp": 755669998,
    "dropphyadd": "104 S CENTRAL AVE",
    "dropphycty": "MARIETTA",
    "dropphyst": "TX",
    "dropphyzpp": 755669998,
    "dropmaladd": "104 S CENTRAL AVE",
    "dropmalcty": "MARIETTA",
    "dropmalst": "TX",
    "dropmalzpp": 755669998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038352911,
    "dropsitcph": 9038352911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24610",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "413 E SAN ANTONIO ST",
    "dropdelcty": "MARION",
    "dropdelst": "TX",
    "dropdelzpp": 781249998,
    "dropphyadd": "413 E SAN ANTONIO ST",
    "dropphycty": "MARION",
    "dropphyst": "TX",
    "dropphyzpp": 781249998,
    "dropmaladd": "413 E SAN ANTONIO ST",
    "dropmalcty": "MARION",
    "dropmalst": "TX",
    "dropmalzpp": 781249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309142250,
    "dropsitcph": 8309142250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24611",
    "droptype": "D",
    "dropname": "MARKHAM",
    "dropdeladd": "610 BROADWAY ST",
    "dropdelcty": "MARKHAM",
    "dropdelst": "TX",
    "dropdelzpp": 774569800,
    "dropphyadd": "610 BROADWAY ST",
    "dropphycty": "MARKHAM",
    "dropphyst": "TX",
    "dropphyzpp": 774569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARKHAM",
    "dropmalst": "TX",
    "dropmalzpp": 774569998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798435513,
    "dropsitcph": 9798435513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24612",
    "droptype": "D",
    "dropname": "MARLIN",
    "dropdeladd": "207 COLEMAN ST",
    "dropdelcty": "MARLIN",
    "dropdelst": "TX",
    "dropdelzpp": 766619998,
    "dropphyadd": "207 COLEMAN ST",
    "dropphycty": "MARLIN",
    "dropphyst": "TX",
    "dropphyzpp": 766619998,
    "dropmaladd": "207 COLEMAN ST",
    "dropmalcty": "MARLIN",
    "dropmalst": "TX",
    "dropmalzpp": 766619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548832922,
    "dropsitcph": 2548832922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24613",
    "droptype": "D",
    "dropname": "MARQUEZ",
    "dropdeladd": "208 VW GOODWIN BLVD N",
    "dropdelcty": "MARQUEZ",
    "dropdelst": "TX",
    "dropdelzpp": 778659998,
    "dropphyadd": "208 VW GOODWIN BLVD N",
    "dropphycty": "MARQUEZ",
    "dropphyst": "TX",
    "dropphyzpp": 778659998,
    "dropmaladd": "208 VW GOODWIN BLVD N",
    "dropmalcty": "MARQUEZ",
    "dropmalst": "TX",
    "dropmalzpp": 778659998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9035293141,
    "dropsitcph": 9036260336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24614",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "202 E TRAVIS ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "TX",
    "dropdelzpp": 756709998,
    "dropphyadd": "202 E TRAVIS ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "TX",
    "dropphyzpp": 756709998,
    "dropmaladd": "202 E TRAVIS ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "TX",
    "dropmalzpp": 756709998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9039384086,
    "dropsitcph": 9039384086,
    "dropfax": 9039271411
  },
  {
    "dcode": "D",
    "dropkey": "PW24616",
    "droptype": "D",
    "dropname": "MART",
    "dropdeladd": "301 E TEXAS AVE",
    "dropdelcty": "MART",
    "dropdelst": "TX",
    "dropdelzpp": 766649998,
    "dropphyadd": "301 E TEXAS AVE",
    "dropphycty": "MART",
    "dropphyst": "TX",
    "dropphyzpp": 766649998,
    "dropmaladd": "301 E TEXAS AVE",
    "dropmalcty": "MART",
    "dropmalst": "TX",
    "dropmalzpp": 766649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548762771,
    "dropsitcph": 2548762771,
    "dropfax": 2103685526
  },
  {
    "dcode": "D",
    "dropkey": "PW24618",
    "droptype": "D",
    "dropname": "MARTINDALE",
    "dropdeladd": "307 LOCKHART ST",
    "dropdelcty": "MARTINDALE",
    "dropdelst": "TX",
    "dropdelzpp": 786559998,
    "dropphyadd": "307 LOCKHART ST",
    "dropphycty": "MARTINDALE",
    "dropphyst": "TX",
    "dropphyzpp": 786559998,
    "dropmaladd": "307 LOCKHART ST",
    "dropmalcty": "MARTINDALE",
    "dropmalst": "TX",
    "dropmalzpp": 786559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123576467,
    "dropsitcph": 5123576467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24620",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "10990 FM 95",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 759589998,
    "dropphyadd": "10990 FM 95",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 759589998,
    "dropmaladd": "10990 FM 95",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 759589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365604430,
    "dropsitcph": 9365604430,
    "dropfax": 9365604430
  },
  {
    "dcode": "D",
    "dropkey": "PW24621",
    "droptype": "D",
    "dropname": "MARYNEAL",
    "dropdeladd": "11126 FM 608",
    "dropdelcty": "MARYNEAL",
    "dropdelst": "TX",
    "dropdelzpp": 795359998,
    "dropphyadd": "11126 FM 608",
    "dropphycty": "MARYNEAL",
    "dropphyst": "TX",
    "dropphyzpp": 795359998,
    "dropmaladd": "11126 FM 608",
    "dropmalcty": "MARYNEAL",
    "dropmalst": "TX",
    "dropmalzpp": 795359998,
    "dropsitphn": "",
    "dropsitlph": 3252884427,
    "dropsitcph": 3252884427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24622",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "704 WREN ST",
    "dropdelcty": "MASON",
    "dropdelst": "TX",
    "dropdelzpp": 768569998,
    "dropphyadd": "704 WREN ST",
    "dropphycty": "MASON",
    "dropphyst": "TX",
    "dropphyzpp": 768569998,
    "dropmaladd": "704 WREN ST",
    "dropmalcty": "MASON",
    "dropmalst": "TX",
    "dropmalzpp": 768569998,
    "dropsitphn": 3253475442,
    "dropsitlph": 3253475442,
    "dropsitcph": 3253475442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24626",
    "droptype": "D",
    "dropname": "MATADOR",
    "dropdeladd": "716 DUNDEE AVE",
    "dropdelcty": "MATADOR",
    "dropdelst": "TX",
    "dropdelzpp": 792449802,
    "dropphyadd": "716 DUNDEE AVE",
    "dropphycty": "MATADOR",
    "dropphyst": "TX",
    "dropphyzpp": 792449802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATADOR",
    "dropmalst": "TX",
    "dropmalzpp": 792449998,
    "dropsitphn": "",
    "dropsitlph": 4325381658,
    "dropsitcph": 8778541584,
    "dropfax": 4325384257
  },
  {
    "dcode": "D",
    "dropkey": "PW24627",
    "droptype": "D",
    "dropname": "MATAGORDA",
    "dropdeladd": "750 MARKET ST",
    "dropdelcty": "MATAGORDA",
    "dropdelst": "TX",
    "dropdelzpp": 774570062,
    "dropphyadd": "750 MARKET ST",
    "dropphycty": "MATAGORDA",
    "dropphyst": "TX",
    "dropphyzpp": 774570062,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATAGORDA",
    "dropmalst": "TX",
    "dropmalzpp": 774579998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798637551,
    "dropsitcph": 9798637551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24628",
    "droptype": "D",
    "dropname": "MATHIS",
    "dropdeladd": "121 S BEE ST",
    "dropdelcty": "MATHIS",
    "dropdelst": "TX",
    "dropdelzpp": 783689998,
    "dropphyadd": "121 S BEE ST",
    "dropphycty": "MATHIS",
    "dropphyst": "TX",
    "dropphyzpp": 783689998,
    "dropmaladd": "121 S BEE ST",
    "dropmalcty": "MATHIS",
    "dropmalst": "TX",
    "dropmalzpp": 783689998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615473061,
    "dropsitcph": 3615473061,
    "dropfax": 3615470068
  },
  {
    "dcode": "D",
    "dropkey": "PW24631",
    "droptype": "D",
    "dropname": "MAUD",
    "dropdeladd": "366 HOUSTON ST",
    "dropdelcty": "MAUD",
    "dropdelst": "TX",
    "dropdelzpp": 755679998,
    "dropphyadd": "366 HOUSTON ST",
    "dropphycty": "MAUD",
    "dropphyst": "TX",
    "dropphyzpp": 755679998,
    "dropmaladd": "366 HOUSTON ST",
    "dropmalcty": "MAUD",
    "dropmalst": "TX",
    "dropmalzpp": 755679998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035855420,
    "dropsitcph": 9035855420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24632",
    "droptype": "D",
    "dropname": "MAURICEVILLE",
    "dropdeladd": "11424 HIGHWAY 12",
    "dropdelcty": "MAURICEVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 776260016,
    "dropphyadd": "11424 HIGHWAY 12",
    "dropphycty": "MAURICEVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 776260016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAURICEVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 776269998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097451337,
    "dropsitcph": 4097451337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24635",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "32 FM 1966",
    "dropdelcty": "MAXWELL",
    "dropdelst": "TX",
    "dropdelzpp": 786569998,
    "dropphyadd": "32 FM 1966",
    "dropphycty": "MAXWELL",
    "dropphyst": "TX",
    "dropphyzpp": 786569998,
    "dropmaladd": "32 FM 1966",
    "dropmalcty": "MAXWELL",
    "dropmalst": "TX",
    "dropmalzpp": 786569998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123576452,
    "dropsitcph": 5123576452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24636",
    "droptype": "D",
    "dropname": "MAY",
    "dropdeladd": "18807 HIGHWAY 183 N",
    "dropdelcty": "MAY",
    "dropdelst": "TX",
    "dropdelzpp": 768579998,
    "dropphyadd": "18807 HIGHWAY 183 N",
    "dropphycty": "MAY",
    "dropphyst": "TX",
    "dropphyzpp": 768579998,
    "dropmaladd": "18807 HIGHWAY 183 N",
    "dropmalcty": "MAY",
    "dropmalst": "TX",
    "dropmalzpp": 768579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2542592665,
    "dropsitcph": 2542592665,
    "dropfax": 2542592288
  },
  {
    "dcode": "D",
    "dropkey": "PW24637",
    "droptype": "D",
    "dropname": "MAYDELLE",
    "dropdeladd": "156 COUNTY ROAD 1801",
    "dropdelcty": "MAYDELLE",
    "dropdelst": "TX",
    "dropdelzpp": 757729998,
    "dropphyadd": "156 COUNTY ROAD 1801",
    "dropphycty": "MAYDELLE",
    "dropphyst": "TX",
    "dropphyzpp": 757729998,
    "dropmaladd": "156 COUNTY ROAD 1801",
    "dropmalcty": "MAYDELLE",
    "dropmalst": "TX",
    "dropmalzpp": 757729998,
    "dropsitphn": 9033931345,
    "dropsitlph": 9037953334,
    "dropsitcph": 9037953334,
    "dropfax": 9037953774
  },
  {
    "dcode": "D",
    "dropkey": "PW24639",
    "droptype": "D",
    "dropname": "MAYPEARL",
    "dropdeladd": "80 MAIN ST",
    "dropdelcty": "MAYPEARL",
    "dropdelst": "TX",
    "dropdelzpp": 760649998,
    "dropphyadd": "80 MAIN ST",
    "dropphycty": "MAYPEARL",
    "dropphyst": "TX",
    "dropphyzpp": 760649998,
    "dropmaladd": "80 MAIN ST",
    "dropmalcty": "MAYPEARL",
    "dropmalst": "TX",
    "dropmalzpp": 760649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9724353322,
    "dropsitcph": 9724353322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24646",
    "droptype": "D",
    "dropname": "MC CAMEY",
    "dropdeladd": "103 W 3RD ST",
    "dropdelcty": "MC CAMEY",
    "dropdelst": "TX",
    "dropdelzpp": 797529998,
    "dropphyadd": "103 W 3RD ST",
    "dropphycty": "MC CAMEY",
    "dropphyst": "TX",
    "dropphyzpp": 797529998,
    "dropmaladd": "103 W 3RD ST",
    "dropmalcty": "MC CAMEY",
    "dropmalst": "TX",
    "dropmalzpp": 797529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326523041,
    "dropsitcph": 4326523041,
    "dropfax": 4326528841
  },
  {
    "dcode": "D",
    "dropkey": "PW24647",
    "droptype": "D",
    "dropname": "MC CAULLEY",
    "dropdeladd": "1238 COUNTY ROAD 764",
    "dropdelcty": "MC CAULLEY",
    "dropdelst": "TX",
    "dropdelzpp": 795349998,
    "dropphyadd": "1238 COUNTY ROAD 764",
    "dropphycty": "MC CAULLEY",
    "dropphyst": "TX",
    "dropphyzpp": 795349998,
    "dropmaladd": "1238 COUNTY ROAD 764",
    "dropmalcty": "MC CAULLEY",
    "dropmalst": "TX",
    "dropmalzpp": 795349998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3259625533,
    "dropsitcph": 3259625533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24650",
    "droptype": "D",
    "dropname": "MC DADE",
    "dropdeladd": "161 WACO ST",
    "dropdelcty": "MC DADE",
    "dropdelst": "TX",
    "dropdelzpp": 786509998,
    "dropphyadd": "161 WACO ST",
    "dropphycty": "MC DADE",
    "dropphyst": "TX",
    "dropphyzpp": 786509998,
    "dropmaladd": "161 WACO ST",
    "dropmalcty": "MC DADE",
    "dropmalst": "TX",
    "dropmalzpp": 786509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122732521,
    "dropsitcph": 5122732521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24652",
    "droptype": "D",
    "dropname": "MCGREGOR",
    "dropdeladd": "408 S MAIN ST",
    "dropdelcty": "MCGREGOR",
    "dropdelst": "TX",
    "dropdelzpp": 766579998,
    "dropphyadd": "408 S MAIN ST",
    "dropphycty": "MCGREGOR",
    "dropphyst": "TX",
    "dropphyzpp": 766579998,
    "dropmaladd": "408 S MAIN ST",
    "dropmalcty": "MCGREGOR",
    "dropmalst": "TX",
    "dropmalzpp": 766579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548403341,
    "dropsitcph": 2548403341,
    "dropfax": 2548403533
  },
  {
    "dcode": "D",
    "dropkey": "PW24653",
    "droptype": "D",
    "dropname": "MCKINNEY",
    "dropdeladd": "550 N CENTRAL EXPY",
    "dropdelcty": "MCKINNEY",
    "dropdelst": "TX",
    "dropdelzpp": 750709998,
    "dropphyadd": "550 N CENTRAL EXPY",
    "dropphycty": "MCKINNEY",
    "dropphyst": "TX",
    "dropphyzpp": 750709998,
    "dropmaladd": "550 N CENTRAL EXPY",
    "dropmalcty": "MCKINNEY",
    "dropmalst": "TX",
    "dropmalzpp": 750709998,
    "dropsitphn": 2144675872,
    "dropsitlph": 9725422931,
    "dropsitcph": 9725422931,
    "dropfax": 9725426596
  },
  {
    "dcode": "D",
    "dropkey": "PW24654",
    "droptype": "D",
    "dropname": "MC LEOD",
    "dropdeladd": "19641 FM 125 S",
    "dropdelcty": "MC LEOD",
    "dropdelst": "TX",
    "dropdelzpp": 755659998,
    "dropphyadd": "19641 FM 125 S",
    "dropphycty": "MC LEOD",
    "dropphyst": "TX",
    "dropphyzpp": 755659998,
    "dropmaladd": "19641 FM 125 S",
    "dropmalcty": "MC LEOD",
    "dropmalst": "TX",
    "dropmalzpp": 755659998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037969591,
    "dropsitcph": 9037969591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24657",
    "droptype": "D",
    "dropname": "MC NEIL",
    "dropdeladd": "14005 MCNEIL RD",
    "dropdelcty": "MC NEIL",
    "dropdelst": "TX",
    "dropdelzpp": 786519800,
    "dropphyadd": "14005 MCNEIL RD",
    "dropphycty": "MC NEIL",
    "dropphyst": "TX",
    "dropphyzpp": 786519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC NEIL",
    "dropmalst": "TX",
    "dropmalzpp": 786519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5129890609,
    "dropsitcph": 5122442778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24658",
    "droptype": "D",
    "dropname": "MC QUEENEY",
    "dropdeladd": "4000 FM 78",
    "dropdelcty": "MC QUEENEY",
    "dropdelst": "TX",
    "dropdelzpp": 781239998,
    "dropphyadd": "4000 FM 78",
    "dropphycty": "MC QUEENEY",
    "dropphyst": "TX",
    "dropphyzpp": 781239998,
    "dropmaladd": "4000 FM 78",
    "dropmalcty": "MC QUEENEY",
    "dropmalst": "TX",
    "dropmalzpp": 781239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305603131,
    "dropsitcph": 8305603131,
    "dropfax": 8305576606
  },
  {
    "dcode": "D",
    "dropkey": "PW24659",
    "droptype": "D",
    "dropname": "MCADOO",
    "dropdeladd": "104 S MAIN",
    "dropdelcty": "MCADOO",
    "dropdelst": "TX",
    "dropdelzpp": 792439801,
    "dropphyadd": "104 S MAIN",
    "dropphycty": "MCADOO",
    "dropphyst": "TX",
    "dropphyzpp": 792439801,
    "dropmaladd": "104 S MAIN",
    "dropmalcty": "MCADOO",
    "dropmalst": "TX",
    "dropmalzpp": 792439801,
    "dropsitphn": 2148511586,
    "dropsitlph": 2148511586,
    "dropsitcph": 2148511586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24661",
    "droptype": "D",
    "dropname": "MCALLEN",
    "dropdeladd": "620 E PECAN BLVD",
    "dropdelcty": "MCALLEN",
    "dropdelst": "TX",
    "dropdelzpp": 785019998,
    "dropphyadd": "620 E PECAN BLVD",
    "dropphycty": "MCALLEN",
    "dropphyst": "TX",
    "dropphyzpp": 785019998,
    "dropmaladd": "620 E PECAN BLVD",
    "dropmalcty": "MCALLEN",
    "dropmalst": "TX",
    "dropmalzpp": 785019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569711703,
    "dropsitcph": 9569711700,
    "dropfax": 9569711787
  },
  {
    "dcode": "D",
    "dropkey": "PW24666",
    "droptype": "D",
    "dropname": "MCFADDIN",
    "dropdeladd": "2207 FM 445",
    "dropdelcty": "MCFADDIN",
    "dropdelst": "TX",
    "dropdelzpp": 779739800,
    "dropphyadd": "2207 FM 445",
    "dropphycty": "MCFADDIN",
    "dropphyst": "TX",
    "dropphyzpp": 779739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCFADDIN",
    "dropmalst": "TX",
    "dropmalzpp": 779739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615735674,
    "dropsitcph": 3615735674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24669",
    "droptype": "D",
    "dropname": "MCLEAN",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "MCLEAN",
    "dropdelst": "TX",
    "dropdelzpp": 790579805,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "MCLEAN",
    "dropphyst": "TX",
    "dropphyzpp": 790579805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCLEAN",
    "dropmalst": "TX",
    "dropmalzpp": 790579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067792252,
    "dropsitcph": 8067792252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24678",
    "droptype": "D",
    "dropname": "MEADOW",
    "dropdeladd": "602 N RENFRO ST",
    "dropdelcty": "MEADOW",
    "dropdelst": "TX",
    "dropdelzpp": 793459802,
    "dropphyadd": "602 N RENFRO ST",
    "dropphycty": "MEADOW",
    "dropphyst": "TX",
    "dropphyzpp": 793459802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEADOW",
    "dropmalst": "TX",
    "dropmalzpp": 793459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065392315,
    "dropsitcph": 8065392315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24680",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "13876 STATE HIGHWAY 16 N",
    "dropdelcty": "MEDINA",
    "dropdelst": "TX",
    "dropdelzpp": 780559998,
    "dropphyadd": "13876 STATE HIGHWAY 16 N",
    "dropphycty": "MEDINA",
    "dropphyst": "TX",
    "dropphyzpp": 780559998,
    "dropmaladd": "13876 STATE HIGHWAY 16 N",
    "dropmalcty": "MEDINA",
    "dropmalst": "TX",
    "dropmalzpp": 780559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305892416,
    "dropsitcph": 8305892416,
    "dropfax": 8305892706
  },
  {
    "dcode": "D",
    "dropkey": "PW24684",
    "droptype": "D",
    "dropname": "MEGARGEL",
    "dropdeladd": "421 FM 210",
    "dropdelcty": "MEGARGEL",
    "dropdelst": "TX",
    "dropdelzpp": 763709801,
    "dropphyadd": "421 FM 210",
    "dropphycty": "MEGARGEL",
    "dropphyst": "TX",
    "dropphyzpp": 763709801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEGARGEL",
    "dropmalst": "TX",
    "dropmalzpp": 763709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405622091,
    "dropsitcph": 9405622091,
    "dropfax": 9405622015
  },
  {
    "dcode": "D",
    "dropkey": "PW24688",
    "droptype": "D",
    "dropname": "MELISSA",
    "dropdeladd": "1919 E MELISSA RD",
    "dropdelcty": "MELISSA",
    "dropdelst": "TX",
    "dropdelzpp": 754549998,
    "dropphyadd": "1919 E MELISSA RD",
    "dropphycty": "MELISSA",
    "dropphyst": "TX",
    "dropphyzpp": 754549998,
    "dropmaladd": "1919 E MELISSA RD",
    "dropmalcty": "MELISSA",
    "dropmalst": "TX",
    "dropmalzpp": 754549998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9728372392,
    "dropsitcph": 9728372392,
    "dropfax": 9728372015
  },
  {
    "dcode": "D",
    "dropkey": "PW24691",
    "droptype": "D",
    "dropname": "MELVIN",
    "dropdeladd": "105 E MESQUITE ST",
    "dropdelcty": "MELVIN",
    "dropdelst": "TX",
    "dropdelzpp": 768589901,
    "dropphyadd": "105 E MESQUITE ST",
    "dropphycty": "MELVIN",
    "dropphyst": "TX",
    "dropphyzpp": 768589901,
    "dropmaladd": "105 E MESQUITE ST",
    "dropmalcty": "MELVIN",
    "dropmalst": "TX",
    "dropmalzpp": 768589901,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3252864346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24694",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "700 W MAIN ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TX",
    "dropdelzpp": 792459998,
    "dropphyadd": "700 W MAIN ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TX",
    "dropphyzpp": 792459998,
    "dropmaladd": "700 W MAIN ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TX",
    "dropmalzpp": 792459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062592031,
    "dropsitcph": 8062592031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24695",
    "droptype": "D",
    "dropname": "MENARD",
    "dropdeladd": "911 FRISCO ST",
    "dropdelcty": "MENARD",
    "dropdelst": "TX",
    "dropdelzpp": 768599998,
    "dropphyadd": "911 FRISCO ST",
    "dropphycty": "MENARD",
    "dropphyst": "TX",
    "dropphyzpp": 768599998,
    "dropmaladd": "911 FRISCO ST",
    "dropmalcty": "MENARD",
    "dropmalst": "TX",
    "dropmalzpp": 768599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253964570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24698",
    "droptype": "D",
    "dropname": "MENTONE",
    "dropdeladd": "111 BELL ST",
    "dropdelcty": "MENTONE",
    "dropdelst": "TX",
    "dropdelzpp": 797549998,
    "dropphyadd": "111 BELL ST",
    "dropphycty": "MENTONE",
    "dropphyst": "TX",
    "dropphyzpp": 797549998,
    "dropmaladd": "111 BELL ST",
    "dropmalcty": "MENTONE",
    "dropmalst": "TX",
    "dropmalzpp": 797549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323772415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24700",
    "droptype": "D",
    "dropname": "MERCEDES",
    "dropdeladd": "307 STARR ST",
    "dropdelcty": "MERCEDES",
    "dropdelst": "TX",
    "dropdelzpp": 785709998,
    "dropphyadd": "307 STARR ST",
    "dropphycty": "MERCEDES",
    "dropphyst": "TX",
    "dropphyzpp": 785709998,
    "dropmaladd": "307 STARR ST",
    "dropmalcty": "MERCEDES",
    "dropmalst": "TX",
    "dropmalzpp": 785709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565651272,
    "dropsitcph": 9565651272,
    "dropfax": 9565650567
  },
  {
    "dcode": "D",
    "dropkey": "PW24702",
    "droptype": "D",
    "dropname": "MERETA",
    "dropdeladd": "997 BROADWAY ST",
    "dropdelcty": "MERETA",
    "dropdelst": "TX",
    "dropdelzpp": 769409803,
    "dropphyadd": "997 BROADWAY ST",
    "dropphycty": "MERETA",
    "dropphyst": "TX",
    "dropphyzpp": 769409803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERETA",
    "dropmalst": "TX",
    "dropmalzpp": 769409998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254682020,
    "dropsitcph": 3254682020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24703",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "512 E LIVE OAK",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "TX",
    "dropdelzpp": 766659998,
    "dropphyadd": "512 E LIVE OAK",
    "dropphycty": "MERIDIAN",
    "dropphyst": "TX",
    "dropphyzpp": 766659998,
    "dropmaladd": "512 E LIVE OAK",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "TX",
    "dropmalzpp": 766659998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544352261,
    "dropsitcph": 2544352261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24704",
    "droptype": "D",
    "dropname": "MERIT",
    "dropdeladd": "2584 FM 36 N",
    "dropdelcty": "MERIT",
    "dropdelst": "TX",
    "dropdelzpp": 754589998,
    "dropphyadd": "2584 FM 36 N",
    "dropphycty": "MERIT",
    "dropphyst": "TX",
    "dropphyzpp": 754589998,
    "dropmaladd": "2584 FM 36 N",
    "dropmalcty": "MERIT",
    "dropmalst": "TX",
    "dropmalzpp": 754589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037762128,
    "dropsitcph": 9037762128,
    "dropfax": 9037762128
  },
  {
    "dcode": "D",
    "dropkey": "PW24705",
    "droptype": "D",
    "dropname": "MERKEL",
    "dropdeladd": "222 EDWARDS",
    "dropdelcty": "MERKEL",
    "dropdelst": "TX",
    "dropdelzpp": 795369998,
    "dropphyadd": "222 EDWARDS",
    "dropphycty": "MERKEL",
    "dropphyst": "TX",
    "dropphyzpp": 795369998,
    "dropmaladd": "222 EDWARDS",
    "dropmalcty": "MERKEL",
    "dropmalst": "TX",
    "dropmalzpp": 795369998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3259285413,
    "dropsitcph": 3259285413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24706",
    "droptype": "D",
    "dropname": "MERTENS",
    "dropdeladd": "101 E HIGHWAY 22",
    "dropdelcty": "MERTENS",
    "dropdelst": "TX",
    "dropdelzpp": 766669998,
    "dropphyadd": "101 E HIGHWAY 22",
    "dropphycty": "MERTENS",
    "dropphyst": "TX",
    "dropphyzpp": 766669998,
    "dropmaladd": "101 E HIGHWAY 22",
    "dropmalcty": "MERTENS",
    "dropmalst": "TX",
    "dropmalzpp": 766669998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9036823691,
    "dropsitcph": 9036823691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24707",
    "droptype": "D",
    "dropname": "MERTZON",
    "dropdeladd": "303 W OAK AVE",
    "dropdelcty": "MERTZON",
    "dropdelst": "TX",
    "dropdelzpp": 769415900,
    "dropphyadd": "303 W OAK AVE",
    "dropphycty": "MERTZON",
    "dropphyst": "TX",
    "dropphyzpp": 769415900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERTZON",
    "dropmalst": "TX",
    "dropmalzpp": 769419998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258352941,
    "dropsitcph": 3258352941,
    "dropfax": 3258352258
  },
  {
    "dcode": "D",
    "dropkey": "PW24710",
    "droptype": "D",
    "dropname": "MESQUITE",
    "dropdeladd": "120 E GRUBB DR",
    "dropdelcty": "MESQUITE",
    "dropdelst": "TX",
    "dropdelzpp": 751499998,
    "dropphyadd": "120 E GRUBB DR",
    "dropphycty": "MESQUITE",
    "dropphyst": "TX",
    "dropphyzpp": 751499998,
    "dropmaladd": "120 E GRUBB DR",
    "dropmalcty": "MESQUITE",
    "dropmalst": "TX",
    "dropmalzpp": 751499998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722884477,
    "dropsitcph": 9722884477,
    "dropfax": 9722169627
  },
  {
    "dcode": "D",
    "dropkey": "PW24711",
    "droptype": "D",
    "dropname": "MEXIA",
    "dropdeladd": "100 N MCKINNEY ST",
    "dropdelcty": "MEXIA",
    "dropdelst": "TX",
    "dropdelzpp": 766679998,
    "dropphyadd": "100 N MCKINNEY ST",
    "dropphycty": "MEXIA",
    "dropphyst": "TX",
    "dropphyzpp": 766679998,
    "dropmaladd": "100 N MCKINNEY ST",
    "dropmalcty": "MEXIA",
    "dropmalst": "TX",
    "dropmalzpp": 766679998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545622401,
    "dropsitcph": 2545622401,
    "dropfax": 2545622507
  },
  {
    "dcode": "D",
    "dropkey": "PW24712",
    "droptype": "D",
    "dropname": "MEYERSVILLE",
    "dropdeladd": "2233 MEYERSVILLE RD",
    "dropdelcty": "MEYERSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 779749998,
    "dropphyadd": "2233 MEYERSVILLE RD",
    "dropphycty": "MEYERSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 779749998,
    "dropmaladd": "2233 MEYERSVILLE RD",
    "dropmalcty": "MEYERSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 779749998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612752050,
    "dropsitcph": 3612752050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24713",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "TX",
    "dropdelzpp": 790599803,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "MIAMI",
    "dropphyst": "TX",
    "dropphyzpp": 790599803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIAMI",
    "dropmalst": "TX",
    "dropmalzpp": 790599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068684411,
    "dropsitcph": 8068684411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24717",
    "droptype": "D",
    "dropname": "MIDFIELD",
    "dropdeladd": "275 JUNETTA AVE",
    "dropdelcty": "MIDFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 774589801,
    "dropphyadd": "275 JUNETTA AVE",
    "dropphycty": "MIDFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 774589801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 774589998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3615886979,
    "dropsitcph": 3615886979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24718",
    "droptype": "D",
    "dropname": "MIDKIFF",
    "dropdeladd": "1005 FM 3095",
    "dropdelcty": "MIDKIFF",
    "dropdelst": "TX",
    "dropdelzpp": 797559998,
    "dropphyadd": "1005 FM 3095",
    "dropphycty": "MIDKIFF",
    "dropphyst": "TX",
    "dropphyzpp": 797559998,
    "dropmaladd": "1005 FM 3095",
    "dropmalcty": "MIDKIFF",
    "dropmalst": "TX",
    "dropmalzpp": 797559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4327757543,
    "dropsitcph": 4325352231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24720",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "10000 LOOP 40",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797119998,
    "dropphyadd": "10000 LOOP 40",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797119996,
    "dropmaladd": "10000 LOOP 40",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4325605105,
    "dropsitcph": 4325605105,
    "dropfax": 4325605096
  },
  {
    "dcode": "D",
    "dropkey": "PW24722",
    "droptype": "D",
    "dropname": "MIDLOTHIAN",
    "dropdeladd": "211 E AVENUE G",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "TX",
    "dropdelzpp": 760653039,
    "dropphyadd": "211 E AVENUE G",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "TX",
    "dropphyzpp": 760653039,
    "dropmaladd": "211 E AVENUE G",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "TX",
    "dropmalzpp": 760653039,
    "dropsitphn": 8173173658,
    "dropsitlph": 9727755426,
    "dropsitcph": 9727755426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24725",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "11528 STATE HIGHWAY 21 E",
    "dropdelcty": "MIDWAY",
    "dropdelst": "TX",
    "dropdelzpp": 758529998,
    "dropphyadd": "11528 STATE HIGHWAY 21 E",
    "dropphycty": "MIDWAY",
    "dropphyst": "TX",
    "dropphyzpp": 758529998,
    "dropmaladd": "11528 STATE HIGHWAY 21 E",
    "dropmalcty": "MIDWAY",
    "dropmalst": "TX",
    "dropmalzpp": 758529998,
    "dropsitphn": 9363483154,
    "dropsitlph": 9363483154,
    "dropsitcph": 9363483154,
    "dropfax": 9363483195
  },
  {
    "dcode": "D",
    "dropkey": "PW24730",
    "droptype": "D",
    "dropname": "MILAM",
    "dropdeladd": "150 STATE HIGHWAY 21",
    "dropdelcty": "MILAM",
    "dropdelst": "TX",
    "dropdelzpp": 759599998,
    "dropphyadd": "150 STATE HIGHWAY 21",
    "dropphycty": "MILAM",
    "dropphyst": "TX",
    "dropphyzpp": 759599998,
    "dropmaladd": "150 STATE HIGHWAY 21",
    "dropmalcty": "MILAM",
    "dropmalst": "TX",
    "dropmalzpp": 759599998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092190611,
    "dropsitcph": 4092190611,
    "dropfax": 4096253770
  },
  {
    "dcode": "D",
    "dropkey": "PW24735",
    "droptype": "D",
    "dropname": "MILANO",
    "dropdeladd": "320 W AVENUE E",
    "dropdelcty": "MILANO",
    "dropdelst": "TX",
    "dropdelzpp": 765569998,
    "dropphyadd": "320 W AVENUE E",
    "dropphycty": "MILANO",
    "dropphyst": "TX",
    "dropphyzpp": 765569998,
    "dropmaladd": "320 W AVENUE E",
    "dropmalcty": "MILANO",
    "dropmalst": "TX",
    "dropmalzpp": 765569998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124552814,
    "dropsitcph": 5124552814,
    "dropfax": 5124552814
  },
  {
    "dcode": "D",
    "dropkey": "PW24738",
    "droptype": "D",
    "dropname": "MILES",
    "dropdeladd": "300 ROBINSON ST",
    "dropdelcty": "MILES",
    "dropdelst": "TX",
    "dropdelzpp": 768619998,
    "dropphyadd": "300 ROBINSON ST",
    "dropphycty": "MILES",
    "dropphyst": "TX",
    "dropphyzpp": 768619998,
    "dropmaladd": "300 ROBINSON ST",
    "dropmalcty": "MILES",
    "dropmalst": "TX",
    "dropmalzpp": 768619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254683911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24739",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "200 N MAIN",
    "dropdelcty": "MILFORD",
    "dropdelst": "TX",
    "dropdelzpp": 766709998,
    "dropphyadd": "200 N MAIN",
    "dropphycty": "MILFORD",
    "dropphyst": "TX",
    "dropphyzpp": 766709998,
    "dropmaladd": "200 N MAIN",
    "dropmalcty": "MILFORD",
    "dropmalst": "TX",
    "dropmalzpp": 766709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9724933988,
    "dropsitcph": 9724933988,
    "dropfax": 9724933988
  },
  {
    "dcode": "D",
    "dropkey": "PW24741",
    "droptype": "D",
    "dropname": "MILLERSVIEW",
    "dropdeladd": "8090 FM 765 E",
    "dropdelcty": "MILLERSVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 768629998,
    "dropphyadd": "8090 FM 765 E",
    "dropphycty": "MILLERSVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 768629998,
    "dropmaladd": "8090 FM 765 E",
    "dropmalcty": "MILLERSVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 768629998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254835454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24743",
    "droptype": "D",
    "dropname": "MILLICAN",
    "dropdeladd": "22200 FM 159",
    "dropdelcty": "MILLICAN",
    "dropdelst": "TX",
    "dropdelzpp": 778669700,
    "dropphyadd": "22200 FM 159",
    "dropphycty": "MILLICAN",
    "dropphyst": "TX",
    "dropphyzpp": 778669700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLICAN",
    "dropmalst": "TX",
    "dropmalzpp": 778669998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368250754,
    "dropsitcph": 9368250754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24744",
    "droptype": "D",
    "dropname": "MILLSAP",
    "dropdeladd": "103 FAIRVIEW RD",
    "dropdelcty": "MILLSAP",
    "dropdelst": "TX",
    "dropdelzpp": 760669998,
    "dropphyadd": "103 FAIRVIEW RD",
    "dropphycty": "MILLSAP",
    "dropphyst": "TX",
    "dropphyzpp": 760669998,
    "dropmaladd": "103 FAIRVIEW RD",
    "dropmalcty": "MILLSAP",
    "dropmalst": "TX",
    "dropmalzpp": 760669998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176827393,
    "dropsitcph": 9406827393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24746",
    "droptype": "D",
    "dropname": "MINEOLA",
    "dropdeladd": "630 E BROAD ST",
    "dropdelcty": "MINEOLA",
    "dropdelst": "TX",
    "dropdelzpp": 757739998,
    "dropphyadd": "630 E BROAD ST",
    "dropphycty": "MINEOLA",
    "dropphyst": "TX",
    "dropphyzpp": 757739998,
    "dropmaladd": "630 E BROAD ST",
    "dropmalcty": "MINEOLA",
    "dropmalst": "TX",
    "dropmalzpp": 757739998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035699616,
    "dropsitcph": 9035692054,
    "dropfax": 9035690489
  },
  {
    "dcode": "D",
    "dropkey": "PW24748",
    "droptype": "D",
    "dropname": "MINERAL WELLS",
    "dropdeladd": "200 SW 1ST AVE",
    "dropdelcty": "MINERAL WELLS",
    "dropdelst": "TX",
    "dropdelzpp": 760679998,
    "dropphyadd": "200 SW 1ST AVE",
    "dropphycty": "MINERAL WELLS",
    "dropphyst": "TX",
    "dropphyzpp": 760679998,
    "dropmaladd": "200 SW 1ST AVE",
    "dropmalcty": "MINERAL WELLS",
    "dropmalst": "TX",
    "dropmalzpp": 760679998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403252404,
    "dropsitcph": 9403252404,
    "dropfax": 9403256741
  },
  {
    "dcode": "D",
    "dropkey": "PW24751",
    "droptype": "D",
    "dropname": "MINGUS",
    "dropdeladd": "109 GORDON RD",
    "dropdelcty": "MINGUS",
    "dropdelst": "TX",
    "dropdelzpp": 764639998,
    "dropphyadd": "109 GORDON RD",
    "dropphycty": "MINGUS",
    "dropphyst": "TX",
    "dropphyzpp": 764639998,
    "dropmaladd": "109 GORDON RD",
    "dropmalcty": "MINGUS",
    "dropmalst": "TX",
    "dropmalzpp": 764639998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546725611,
    "dropsitcph": 2546725611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24753",
    "droptype": "D",
    "dropname": "MISSION",
    "dropdeladd": "901 N FRANCISCO AVE",
    "dropdelcty": "MISSION",
    "dropdelst": "TX",
    "dropdelzpp": 785729998,
    "dropphyadd": "901 N FRANCISCO AVE",
    "dropphycty": "MISSION",
    "dropphyst": "TX",
    "dropphyzpp": 785729998,
    "dropmaladd": "901 N FRANCISCO AVE",
    "dropmalcty": "MISSION",
    "dropmalst": "TX",
    "dropmalzpp": 785729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565851481,
    "dropsitcph": 9565851481,
    "dropfax": 9565198863
  },
  {
    "dcode": "D",
    "dropkey": "PW24755",
    "droptype": "D",
    "dropname": "MISSOURI CITY",
    "dropdeladd": "1902 TEXAS PKWY",
    "dropdelcty": "MISSOURI CITY",
    "dropdelst": "TX",
    "dropdelzpp": 774899998,
    "dropphyadd": "1902 TEXAS PKWY",
    "dropphycty": "MISSOURI CITY",
    "dropphyst": "TX",
    "dropphyzpp": 774899998,
    "dropmaladd": "1902 TEXAS PKWY",
    "dropmalcty": "MISSOURI CITY",
    "dropmalst": "TX",
    "dropmalzpp": 774899998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814994412,
    "dropsitcph": 2812080838,
    "dropfax": 2814995709
  },
  {
    "dcode": "D",
    "dropkey": "PW24758",
    "droptype": "D",
    "dropname": "MOBEETIE",
    "dropdeladd": "214 W 1ST ST",
    "dropdelcty": "MOBEETIE",
    "dropdelst": "TX",
    "dropdelzpp": 790619802,
    "dropphyadd": "214 W 1ST ST",
    "dropphycty": "MOBEETIE",
    "dropphyst": "TX",
    "dropphyzpp": 790619802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOBEETIE",
    "dropmalst": "TX",
    "dropmalzpp": 790619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068453461,
    "dropsitcph": 8068453461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24763",
    "droptype": "D",
    "dropname": "MONAHANS",
    "dropdeladd": "201 S BETTY AVE",
    "dropdelcty": "MONAHANS",
    "dropdelst": "TX",
    "dropdelzpp": 797569998,
    "dropphyadd": "201 S BETTY AVE",
    "dropphycty": "MONAHANS",
    "dropphyst": "TX",
    "dropphyzpp": 797569998,
    "dropmaladd": "201 S BETTY AVE",
    "dropmalcty": "MONAHANS",
    "dropmalst": "TX",
    "dropmalzpp": 797569998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4329432232,
    "dropfax": 4329436827
  },
  {
    "dcode": "D",
    "dropkey": "PW24768",
    "droptype": "D",
    "dropname": "MONT BELVIEU",
    "dropdeladd": "16043 EAGLE DR",
    "dropdelcty": "MONT BELVIEU",
    "dropdelst": "TX",
    "dropdelzpp": 775809700,
    "dropphyadd": "16043 EAGLE DR",
    "dropphycty": "MONT BELVIEU",
    "dropphyst": "TX",
    "dropphyzpp": 775809700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONT BELVIEU",
    "dropmalst": "TX",
    "dropmalzpp": 775809998,
    "dropsitphn": 2813851707,
    "dropsitlph": 2815762210,
    "dropsitcph": 2815762210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24769",
    "droptype": "D",
    "dropname": "MONTAGUE",
    "dropdeladd": "104 FRANKLIN ST",
    "dropdelcty": "MONTAGUE",
    "dropdelst": "TX",
    "dropdelzpp": 762519998,
    "dropphyadd": "104 FRANKLIN ST",
    "dropphycty": "MONTAGUE",
    "dropphyst": "TX",
    "dropphyzpp": 762519998,
    "dropmaladd": "104 FRANKLIN ST",
    "dropmalcty": "MONTAGUE",
    "dropmalst": "TX",
    "dropmalzpp": 762519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408946051,
    "dropsitcph": 9408946051,
    "dropfax": 6505783822
  },
  {
    "dcode": "D",
    "dropkey": "PW24772",
    "droptype": "D",
    "dropname": "MONTALBA",
    "dropdeladd": "200 E FM 321",
    "dropdelcty": "MONTALBA",
    "dropdelst": "TX",
    "dropdelzpp": 758539998,
    "dropphyadd": "200 E FM 321",
    "dropphycty": "MONTALBA",
    "dropphyst": "TX",
    "dropphyzpp": 758539998,
    "dropmaladd": "200 E FM 321",
    "dropmalcty": "MONTALBA",
    "dropmalst": "TX",
    "dropmalzpp": 758539998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035492514,
    "dropsitcph": 9035492514,
    "dropfax": 9035492514
  },
  {
    "dcode": "D",
    "dropkey": "PW24775",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "20821 EVA ST STE H",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "TX",
    "dropdelzpp": 773569998,
    "dropphyadd": "20821 EVA ST STE H",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "TX",
    "dropphyzpp": 773569998,
    "dropmaladd": "20821 EVA ST STE H",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "TX",
    "dropmalzpp": 773569998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365978107,
    "dropsitcph": 9365978099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24779",
    "droptype": "D",
    "dropname": "MOODY",
    "dropdeladd": "501 AVENUE E",
    "dropdelcty": "MOODY",
    "dropdelst": "TX",
    "dropdelzpp": 765579998,
    "dropphyadd": "501 AVENUE E",
    "dropphycty": "MOODY",
    "dropphyst": "TX",
    "dropphyzpp": 765579998,
    "dropmaladd": "501 AVENUE E",
    "dropmalcty": "MOODY",
    "dropmalst": "TX",
    "dropmalzpp": 765579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548532142,
    "dropsitcph": 2548532142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24780",
    "droptype": "D",
    "dropname": "MOORE",
    "dropdeladd": "198 W FM 462",
    "dropdelcty": "MOORE",
    "dropdelst": "TX",
    "dropdelzpp": 780579998,
    "dropphyadd": "198 W FM 462",
    "dropphycty": "MOORE",
    "dropphyst": "TX",
    "dropphyzpp": 780579998,
    "dropmaladd": "198 W FM 462",
    "dropmalcty": "MOORE",
    "dropmalst": "TX",
    "dropmalzpp": 780579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306632595,
    "dropsitcph": 8306632595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24785",
    "droptype": "D",
    "dropname": "MORAN",
    "dropdeladd": "340 WATERS ST",
    "dropdelcty": "MORAN",
    "dropdelst": "TX",
    "dropdelzpp": 764649998,
    "dropphyadd": "340 WATERS ST",
    "dropphycty": "MORAN",
    "dropphyst": "TX",
    "dropphyzpp": 764649998,
    "dropmaladd": "340 WATERS ST",
    "dropmalcty": "MORAN",
    "dropmalst": "TX",
    "dropmalzpp": 764649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3259452291,
    "dropsitcph": 3259452291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24787",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "1002 HARRIS",
    "dropdelcty": "MORGAN",
    "dropdelst": "TX",
    "dropdelzpp": 766719998,
    "dropphyadd": "1002 HARRIS",
    "dropphycty": "MORGAN",
    "dropphyst": "TX",
    "dropphyzpp": 766719998,
    "dropmaladd": "1002 HARRIS",
    "dropmalcty": "MORGAN",
    "dropmalst": "TX",
    "dropmalzpp": 766719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546354362,
    "dropsitcph": 2546354362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24788",
    "droptype": "D",
    "dropname": "MORGAN MILL",
    "dropdeladd": "20909 N US HIGHWAY 281",
    "dropdelcty": "MORGAN MILL",
    "dropdelst": "TX",
    "dropdelzpp": 764659801,
    "dropphyadd": "20909 N US HIGHWAY 281",
    "dropphycty": "MORGAN MILL",
    "dropphyst": "TX",
    "dropphyzpp": 764659801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORGAN MILL",
    "dropmalst": "TX",
    "dropmalzpp": 764659998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2549684848,
    "dropsitcph": 2549684848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24794",
    "droptype": "D",
    "dropname": "MORSE",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "MORSE",
    "dropdelst": "TX",
    "dropdelzpp": 790629800,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "MORSE",
    "dropphyst": "TX",
    "dropphyzpp": 790629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORSE",
    "dropmalst": "TX",
    "dropmalzpp": 790629998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067332241,
    "dropsitcph": 8067332241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24796",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "106 W TAYLOR AVE",
    "dropdelcty": "MORTON",
    "dropdelst": "TX",
    "dropdelzpp": 793469998,
    "dropphyadd": "106 W TAYLOR AVE",
    "dropphycty": "MORTON",
    "dropphyst": "TX",
    "dropphyzpp": 793469998,
    "dropmaladd": "106 W TAYLOR AVE",
    "dropmalcty": "MORTON",
    "dropmalst": "TX",
    "dropmalzpp": 793469998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062665432,
    "dropsitcph": 8062665432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24797",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "16281 US HIGHWAY 59 N",
    "dropdelcty": "MOSCOW",
    "dropdelst": "TX",
    "dropdelzpp": 759609998,
    "dropphyadd": "16281 US HIGHWAY 59 N",
    "dropphycty": "MOSCOW",
    "dropphyst": "TX",
    "dropphyzpp": 759609998,
    "dropmaladd": "16281 US HIGHWAY 59 N",
    "dropmalcty": "MOSCOW",
    "dropmalst": "TX",
    "dropmalzpp": 759609998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9363985103,
    "dropsitcph": 9363985103,
    "dropfax": 9363985103
  },
  {
    "dcode": "D",
    "dropkey": "PW24802",
    "droptype": "D",
    "dropname": "MOULTON",
    "dropdeladd": "206 S MAIN ST",
    "dropdelcty": "MOULTON",
    "dropdelst": "TX",
    "dropdelzpp": 779759998,
    "dropphyadd": "206 S MAIN ST",
    "dropphycty": "MOULTON",
    "dropphyst": "TX",
    "dropphyzpp": 779759998,
    "dropmaladd": "206 S MAIN ST",
    "dropmalcty": "MOULTON",
    "dropmalst": "TX",
    "dropmalzpp": 779759998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615967797,
    "dropsitcph": 3615967797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24803",
    "droptype": "D",
    "dropname": "MOUND",
    "dropdeladd": "5116 FM 1829",
    "dropdelcty": "MOUND",
    "dropdelst": "TX",
    "dropdelzpp": 765589800,
    "dropphyadd": "5116 FM 1829",
    "dropphycty": "MOUND",
    "dropphyst": "TX",
    "dropphyzpp": 765589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUND",
    "dropmalst": "TX",
    "dropmalzpp": 765589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548656469,
    "dropsitcph": 2548656469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24805",
    "droptype": "D",
    "dropname": "MOUNT CALM",
    "dropdeladd": "221 STATE HIGHWAY 31 BUSINESS",
    "dropdelcty": "MOUNT CALM",
    "dropdelst": "TX",
    "dropdelzpp": 766739998,
    "dropphyadd": "221 STATE HIGHWAY 31 BUSINESS",
    "dropphycty": "MOUNT CALM",
    "dropphyst": "TX",
    "dropphyzpp": 766739998,
    "dropmaladd": "221 STATE HIGHWAY 31 BUSINESS",
    "dropmalcty": "MOUNT CALM",
    "dropmalst": "TX",
    "dropmalzpp": 766739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549933521,
    "dropsitcph": 2549933521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24807",
    "droptype": "D",
    "dropname": "MOUNT ENTERPRISE",
    "dropdeladd": "211 E RUSK ST",
    "dropdelcty": "MOUNT ENTERPRISE",
    "dropdelst": "TX",
    "dropdelzpp": 756819998,
    "dropphyadd": "211 E RUSK ST",
    "dropphycty": "MOUNT ENTERPRISE",
    "dropphyst": "TX",
    "dropphyzpp": 756819998,
    "dropmaladd": "211 E RUSK ST",
    "dropmalcty": "MOUNT ENTERPRISE",
    "dropmalst": "TX",
    "dropmalzpp": 756819998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038223910,
    "dropsitcph": 9038223910,
    "dropfax": 9038223910
  },
  {
    "dcode": "D",
    "dropkey": "PW24810",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "201 W ALABAMA ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "TX",
    "dropdelzpp": 754559998,
    "dropphyadd": "201 W ALABAMA ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "TX",
    "dropphyzpp": 754559998,
    "dropmaladd": "201 W ALABAMA ST",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "TX",
    "dropmalzpp": 754559998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035728311,
    "dropsitcph": 9035728311,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "PW24814",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "207 KAUFMAN ST S",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "TX",
    "dropdelzpp": 754579998,
    "dropphyadd": "207 KAUFMAN ST S",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "TX",
    "dropphyzpp": 754579998,
    "dropmaladd": "207 KAUFMAN ST S",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "TX",
    "dropmalzpp": 754579998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035372515,
    "dropsitcph": 9035372515,
    "dropfax": 9035372083
  },
  {
    "dcode": "D",
    "dropkey": "PW24816",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME",
    "dropdeladd": "5586 JUNCTION HWY",
    "dropdelcty": "MOUNTAIN HOME",
    "dropdelst": "TX",
    "dropdelzpp": 780589998,
    "dropphyadd": "5586 JUNCTION HWY",
    "dropphycty": "MOUNTAIN HOME",
    "dropphyst": "TX",
    "dropphyzpp": 780589998,
    "dropmaladd": "5586 JUNCTION HWY",
    "dropmalcty": "MOUNTAIN HOME",
    "dropmalst": "TX",
    "dropmalzpp": 780589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308663331,
    "dropsitcph": 8308663331,
    "dropfax": 8308663751
  },
  {
    "dcode": "D",
    "dropkey": "PW24823",
    "droptype": "D",
    "dropname": "MUENSTER",
    "dropdeladd": "235 W 2ND ST",
    "dropdelcty": "MUENSTER",
    "dropdelst": "TX",
    "dropdelzpp": 762529998,
    "dropphyadd": "235 W 2ND ST",
    "dropphycty": "MUENSTER",
    "dropphyst": "TX",
    "dropphyzpp": 762529998,
    "dropmaladd": "235 W 2ND ST",
    "dropmalcty": "MUENSTER",
    "dropmalst": "TX",
    "dropmalzpp": 762529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407592231,
    "dropsitcph": 9407592231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24825",
    "droptype": "D",
    "dropname": "MULESHOE",
    "dropdeladd": "221 E 3RD ST",
    "dropdelcty": "MULESHOE",
    "dropdelst": "TX",
    "dropdelzpp": 793479998,
    "dropphyadd": "221 E 3RD ST",
    "dropphycty": "MULESHOE",
    "dropphyst": "TX",
    "dropphyzpp": 793479998,
    "dropmaladd": "221 E 3RD ST",
    "dropmalcty": "MULESHOE",
    "dropmalst": "TX",
    "dropmalzpp": 793479998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062723033,
    "dropsitcph": 8062723033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24826",
    "droptype": "D",
    "dropname": "MULLIN",
    "dropdeladd": "108 E SHERMAN ST",
    "dropdelcty": "MULLIN",
    "dropdelst": "TX",
    "dropdelzpp": 768649998,
    "dropphyadd": "108 E SHERMAN ST",
    "dropphycty": "MULLIN",
    "dropphyst": "TX",
    "dropphyzpp": 768649998,
    "dropmaladd": "108 E SHERMAN ST",
    "dropmalcty": "MULLIN",
    "dropmalst": "TX",
    "dropmalzpp": 768649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3259853789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24829",
    "droptype": "D",
    "dropname": "MUNDAY",
    "dropdeladd": "241 W B ST",
    "dropdelcty": "MUNDAY",
    "dropdelst": "TX",
    "dropdelzpp": 763719998,
    "dropphyadd": "241 W B ST",
    "dropphycty": "MUNDAY",
    "dropphyst": "TX",
    "dropphyzpp": 763719998,
    "dropmaladd": "241 W B ST",
    "dropmalcty": "MUNDAY",
    "dropmalst": "TX",
    "dropmalzpp": 763719998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403136000,
    "dropsitcph": 9403136000,
    "dropfax": 8173173658
  },
  {
    "dcode": "D",
    "dropkey": "PW24830",
    "droptype": "D",
    "dropname": "MURCHISON",
    "dropdeladd": "6684 STATE HIGHWAY 31",
    "dropdelcty": "MURCHISON",
    "dropdelst": "TX",
    "dropdelzpp": 757789998,
    "dropphyadd": "6684 STATE HIGHWAY 31",
    "dropphycty": "MURCHISON",
    "dropphyst": "TX",
    "dropphyzpp": 757789998,
    "dropmaladd": "6684 STATE HIGHWAY 31",
    "dropmalcty": "MURCHISON",
    "dropmalst": "TX",
    "dropmalzpp": 757789998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9034693110,
    "dropsitcph": 9034693110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24834",
    "droptype": "D",
    "dropname": "NACOGDOCHES",
    "dropdeladd": "3007 N UNIVERSITY DR",
    "dropdelcty": "NACOGDOCHES",
    "dropdelst": "TX",
    "dropdelzpp": 759659998,
    "dropphyadd": "3007 N UNIVERSITY DR",
    "dropphycty": "NACOGDOCHES",
    "dropphyst": "TX",
    "dropphyzpp": 759659998,
    "dropmaladd": "3007 N UNIVERSITY DR",
    "dropmalcty": "NACOGDOCHES",
    "dropmalst": "TX",
    "dropmalzpp": 759659998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365643737,
    "dropsitcph": 9365643737,
    "dropfax": 9365641782
  },
  {
    "dcode": "D",
    "dropkey": "PW24835",
    "droptype": "D",
    "dropname": "NADA",
    "dropdeladd": "8423 HIGHWAY 71 S",
    "dropdelcty": "NADA",
    "dropdelst": "TX",
    "dropdelzpp": 774600015,
    "dropphyadd": "8423 HIGHWAY 71 S",
    "dropphycty": "NADA",
    "dropphyst": "TX",
    "dropphyzpp": 774600015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NADA",
    "dropmalst": "TX",
    "dropmalzpp": 774609998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797583037,
    "dropsitcph": 9797583037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24837",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "NAPLES",
    "dropdelst": "TX",
    "dropdelzpp": 755689998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "NAPLES",
    "dropphyst": "TX",
    "dropphyzpp": 755689998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "NAPLES",
    "dropmalst": "TX",
    "dropmalzpp": 755689998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038975461,
    "dropsitcph": 9038975461,
    "dropfax": 9038972127
  },
  {
    "dcode": "D",
    "dropkey": "PW24840",
    "droptype": "D",
    "dropname": "NASH",
    "dropdeladd": "1910 N KINGS HWY",
    "dropdelcty": "NASH",
    "dropdelst": "TX",
    "dropdelzpp": 755692127,
    "dropphyadd": "1910 N KINGS HWY",
    "dropphycty": "NASH",
    "dropphyst": "TX",
    "dropphyzpp": 755692127,
    "dropmaladd": "1910 N KINGS HWY",
    "dropmalcty": "NASH",
    "dropmalst": "TX",
    "dropmalzpp": 755692127,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038387991,
    "dropsitcph": 9038387991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24844",
    "droptype": "D",
    "dropname": "NATALIA",
    "dropdeladd": "1910 STATE HIGHWAY 132 N",
    "dropdelcty": "NATALIA",
    "dropdelst": "TX",
    "dropdelzpp": 780599998,
    "dropphyadd": "1910 STATE HIGHWAY 132 N",
    "dropphycty": "NATALIA",
    "dropphyst": "TX",
    "dropphyzpp": 780599998,
    "dropmaladd": "1910 STATE HIGHWAY 132 N",
    "dropmalcty": "NATALIA",
    "dropmalst": "TX",
    "dropmalzpp": 780599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306634255,
    "dropsitcph": 8306634255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24851",
    "droptype": "D",
    "dropname": "NAVASOTA",
    "dropdeladd": "115 FARQUHAR ST",
    "dropdelcty": "NAVASOTA",
    "dropdelst": "TX",
    "dropdelzpp": 778689998,
    "dropphyadd": "115 FARQUHAR ST",
    "dropphycty": "NAVASOTA",
    "dropphyst": "TX",
    "dropphyzpp": 778689998,
    "dropmaladd": "115 FARQUHAR ST",
    "dropmalcty": "NAVASOTA",
    "dropmalst": "TX",
    "dropmalzpp": 778689998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368256812,
    "dropsitcph": 9368256812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24852",
    "droptype": "D",
    "dropname": "NAZARETH",
    "dropdeladd": "101 SAINT JOSEPH ST",
    "dropdelcty": "NAZARETH",
    "dropdelst": "TX",
    "dropdelzpp": 790639997,
    "dropphyadd": "101 SAINT JOSEPH ST",
    "dropphycty": "NAZARETH",
    "dropphyst": "TX",
    "dropphyzpp": 790639997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAZARETH",
    "dropmalst": "TX",
    "dropmalzpp": 790639998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8069452531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24855",
    "droptype": "D",
    "dropname": "NECHES",
    "dropdeladd": "100 FM 2574",
    "dropdelcty": "NECHES",
    "dropdelst": "TX",
    "dropdelzpp": 757799998,
    "dropphyadd": "100 FM 2574",
    "dropphycty": "NECHES",
    "dropphyst": "TX",
    "dropphyzpp": 757799998,
    "dropmaladd": "100 FM 2574",
    "dropmalcty": "NECHES",
    "dropmalst": "TX",
    "dropmalzpp": 757799998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035843368,
    "dropsitcph": 9035843368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24856",
    "droptype": "D",
    "dropname": "NEDERLAND",
    "dropdeladd": "223 N 14TH ST",
    "dropdelcty": "NEDERLAND",
    "dropdelst": "TX",
    "dropdelzpp": 776279998,
    "dropphyadd": "223 N 14TH ST",
    "dropphycty": "NEDERLAND",
    "dropphyst": "TX",
    "dropphyzpp": 776279998,
    "dropmaladd": "223 N 14TH ST",
    "dropmalcty": "NEDERLAND",
    "dropmalst": "TX",
    "dropmalzpp": 776279998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097298830,
    "dropsitcph": 4097298837,
    "dropfax": 4097272512
  },
  {
    "dcode": "D",
    "dropkey": "PW24858",
    "droptype": "D",
    "dropname": "NEEDVILLE",
    "dropdeladd": "3000 SCHOOL ST",
    "dropdelcty": "NEEDVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 774619998,
    "dropphyadd": "3000 SCHOOL ST",
    "dropphycty": "NEEDVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 774619998,
    "dropmaladd": "3000 SCHOOL ST",
    "dropmalcty": "NEEDVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 774619998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797934427,
    "dropsitcph": 9797934427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24860",
    "droptype": "D",
    "dropname": "NEMO",
    "dropdeladd": "1015 COUNTY ROAD 407",
    "dropdelcty": "NEMO",
    "dropdelst": "TX",
    "dropdelzpp": 760702092,
    "dropphyadd": "1015 COUNTY ROAD 407",
    "dropphycty": "NEMO",
    "dropphyst": "TX",
    "dropphyzpp": 760702092,
    "dropmaladd": "1015 COUNTY ROAD 407",
    "dropmalcty": "NEMO",
    "dropmalst": "TX",
    "dropmalzpp": 760702092,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548973879,
    "dropsitcph": 2548973879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24864",
    "droptype": "D",
    "dropname": "NEVADA",
    "dropdeladd": "102 S FM 1138",
    "dropdelcty": "NEVADA",
    "dropdelst": "TX",
    "dropdelzpp": 751739998,
    "dropphyadd": "102 S FM 1138",
    "dropphycty": "NEVADA",
    "dropphyst": "TX",
    "dropphyzpp": 751739998,
    "dropmaladd": "102 S FM 1138",
    "dropmalcty": "NEVADA",
    "dropmalst": "TX",
    "dropmalzpp": 751739998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9728533621,
    "dropsitcph": 9728533621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24865",
    "droptype": "D",
    "dropname": "NEW BADEN",
    "dropdeladd": "199 FM 1940",
    "dropdelcty": "NEW BADEN",
    "dropdelst": "TX",
    "dropdelzpp": 778704102,
    "dropphyadd": "199 FM 1940",
    "dropphycty": "NEW BADEN",
    "dropphyst": "TX",
    "dropphyzpp": 778704102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW BADEN",
    "dropmalst": "TX",
    "dropmalzpp": 778709998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798284390,
    "dropsitcph": 9798284390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24866",
    "droptype": "D",
    "dropname": "NEW BOSTON",
    "dropdeladd": "115 N WEST ST",
    "dropdelcty": "NEW BOSTON",
    "dropdelst": "TX",
    "dropdelzpp": 755709998,
    "dropphyadd": "115 N WEST ST",
    "dropphycty": "NEW BOSTON",
    "dropphyst": "TX",
    "dropphyzpp": 755709998,
    "dropmaladd": "115 N WEST ST",
    "dropmalcty": "NEW BOSTON",
    "dropmalst": "TX",
    "dropmalzpp": 755709998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036282751,
    "dropsitcph": 9036282751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24867",
    "droptype": "D",
    "dropname": "NEW BRAUNFELS",
    "dropdeladd": "651 N BUSINESS IH 35 STE 420",
    "dropdelcty": "NEW BRAUNFELS",
    "dropdelst": "TX",
    "dropdelzpp": 781309808,
    "dropphyadd": "651 N BUSINESS IH 35 STE 420",
    "dropphycty": "NEW BRAUNFELS",
    "dropphyst": "TX",
    "dropphyzpp": 781309808,
    "dropmaladd": "651 N BUSINESS IH 35 STE 420",
    "dropmalcty": "NEW BRAUNFELS",
    "dropmalst": "TX",
    "dropmalzpp": 781309808,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306257736,
    "dropsitcph": 8306088061,
    "dropfax": 8306088059
  },
  {
    "dcode": "D",
    "dropkey": "PW24868",
    "droptype": "D",
    "dropname": "NEW CANEY",
    "dropdeladd": "20811 US HIGHWAY 59",
    "dropdelcty": "NEW CANEY",
    "dropdelst": "TX",
    "dropdelzpp": 773572701,
    "dropphyadd": "20811 US HIGHWAY 59",
    "dropphycty": "NEW CANEY",
    "dropphyst": "TX",
    "dropphyzpp": 773572701,
    "dropmaladd": "20811 US HIGHWAY 59",
    "dropmalcty": "NEW CANEY",
    "dropmalst": "TX",
    "dropmalzpp": 773572701,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813991190,
    "dropsitcph": 2813991190,
    "dropfax": 2813998188
  },
  {
    "dcode": "D",
    "dropkey": "PW24872",
    "droptype": "D",
    "dropname": "NEW DEAL",
    "dropdeladd": "309 N MONROE ST",
    "dropdelcty": "NEW DEAL",
    "dropdelst": "TX",
    "dropdelzpp": 793509800,
    "dropphyadd": "309 N MONROE ST",
    "dropphycty": "NEW DEAL",
    "dropphyst": "TX",
    "dropphyzpp": 793509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW DEAL",
    "dropmalst": "TX",
    "dropmalzpp": 793509998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067465119,
    "dropsitcph": 8067465119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24880",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "10750 S MAIN ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "TX",
    "dropdelzpp": 756829998,
    "dropphyadd": "10750 S MAIN ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "TX",
    "dropphyzpp": 756829998,
    "dropmaladd": "10750 S MAIN ST",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "TX",
    "dropmalzpp": 756829998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038954874,
    "dropsitcph": 9038954874,
    "dropfax": 9038950072
  },
  {
    "dcode": "D",
    "dropkey": "PW24886",
    "droptype": "D",
    "dropname": "NEW SUMMERFIELD",
    "dropdeladd": "13460 STATE HIGHWAY 110 N",
    "dropdelcty": "NEW SUMMERFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 757809998,
    "dropphyadd": "13460 STATE HIGHWAY 110 N",
    "dropphycty": "NEW SUMMERFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 757809998,
    "dropmaladd": "13460 STATE HIGHWAY 110 N",
    "dropmalcty": "NEW SUMMERFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 757809998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037263241,
    "dropsitcph": 9037263241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24890",
    "droptype": "D",
    "dropname": "NEW ULM",
    "dropdeladd": "824 PECAN ST",
    "dropdelcty": "NEW ULM",
    "dropdelst": "TX",
    "dropdelzpp": 789509998,
    "dropphyadd": "824 PECAN ST",
    "dropphycty": "NEW ULM",
    "dropphyst": "TX",
    "dropphyzpp": 789509998,
    "dropmaladd": "824 PECAN ST",
    "dropmalcty": "NEW ULM",
    "dropmalst": "TX",
    "dropmalzpp": 789509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9799923386,
    "dropsitcph": 9799923386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24891",
    "droptype": "D",
    "dropname": "NEW WAVERLY",
    "dropdeladd": "9301 STATE HIGHWAY 75 S",
    "dropdelcty": "NEW WAVERLY",
    "dropdelst": "TX",
    "dropdelzpp": 773584225,
    "dropphyadd": "9301 STATE HIGHWAY 75 S",
    "dropphycty": "NEW WAVERLY",
    "dropphyst": "TX",
    "dropphyzpp": 773584225,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW WAVERLY",
    "dropmalst": "TX",
    "dropmalzpp": 773589998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363446259,
    "dropsitcph": 9363446259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24893",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "312 FM 718",
    "dropdelcty": "NEWARK",
    "dropdelst": "TX",
    "dropdelzpp": 760713855,
    "dropphyadd": "312 FM 718",
    "dropphycty": "NEWARK",
    "dropphyst": "TX",
    "dropphyzpp": 760713855,
    "dropmaladd": "312 FM 718",
    "dropmalcty": "NEWARK",
    "dropmalst": "TX",
    "dropmalzpp": 760713855,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174892145,
    "dropsitcph": 8174892136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24895",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "800 BROADWAY",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "TX",
    "dropdelzpp": 763729802,
    "dropphyadd": "800 BROADWAY",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "TX",
    "dropphyzpp": 763729802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "TX",
    "dropmalzpp": 763729998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408463266,
    "dropsitcph": 9408463266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24898",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "419 RUSK ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "TX",
    "dropdelzpp": 759669998,
    "dropphyadd": "419 RUSK ST",
    "dropphycty": "NEWTON",
    "dropphyst": "TX",
    "dropphyzpp": 759669998,
    "dropmaladd": "419 RUSK ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "TX",
    "dropmalzpp": 759669998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4093794088,
    "dropsitcph": 4093794088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24909",
    "droptype": "D",
    "dropname": "NIXON",
    "dropdeladd": "109 E 2ND ST",
    "dropdelcty": "NIXON",
    "dropdelst": "TX",
    "dropdelzpp": 781409998,
    "dropphyadd": "109 E 2ND ST",
    "dropphycty": "NIXON",
    "dropphyst": "TX",
    "dropphyzpp": 781409998,
    "dropmaladd": "109 E 2ND ST",
    "dropmalcty": "NIXON",
    "dropmalst": "TX",
    "dropmalzpp": 781409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305823939,
    "dropsitcph": 8305821722,
    "dropfax": 8305821381
  },
  {
    "dcode": "D",
    "dropkey": "PW24911",
    "droptype": "D",
    "dropname": "NOCONA",
    "dropdeladd": "400 CLAY ST",
    "dropdelcty": "NOCONA",
    "dropdelst": "TX",
    "dropdelzpp": 762559998,
    "dropphyadd": "400 CLAY ST",
    "dropphycty": "NOCONA",
    "dropphyst": "TX",
    "dropphyzpp": 762559998,
    "dropmaladd": "400 CLAY ST",
    "dropmalcty": "NOCONA",
    "dropmalst": "TX",
    "dropmalzpp": 762559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408259032,
    "dropsitcph": 9408259032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24913",
    "droptype": "D",
    "dropname": "NOLAN",
    "dropdeladd": "1745 FM 126",
    "dropdelcty": "NOLAN",
    "dropdelst": "TX",
    "dropdelzpp": 795379998,
    "dropphyadd": "1745 FM 126",
    "dropphycty": "NOLAN",
    "dropphyst": "TX",
    "dropphyzpp": 795379998,
    "dropmaladd": "1745 FM 126",
    "dropmalcty": "NOLAN",
    "dropmalst": "TX",
    "dropmalzpp": 795379998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257984361,
    "dropsitcph": 3257984361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24914",
    "droptype": "D",
    "dropname": "NOLANVILLE",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "NOLANVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 765599998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "NOLANVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 765599998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "NOLANVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 765599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546982626,
    "dropsitcph": 2546982626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24917",
    "droptype": "D",
    "dropname": "NOME",
    "dropdeladd": "2285 HIGHWAY 90",
    "dropdelcty": "NOME",
    "dropdelst": "TX",
    "dropdelzpp": 776290010,
    "dropphyadd": "2285 HIGHWAY 90",
    "dropphycty": "NOME",
    "dropphyst": "TX",
    "dropphyzpp": 776290010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOME",
    "dropmalst": "TX",
    "dropmalzpp": 776299998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092532287,
    "dropsitcph": 4092532287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24920",
    "droptype": "D",
    "dropname": "NORDHEIM",
    "dropdeladd": "301 BROADWAY",
    "dropdelcty": "NORDHEIM",
    "dropdelst": "TX",
    "dropdelzpp": 781419998,
    "dropphyadd": "301 BROADWAY",
    "dropphycty": "NORDHEIM",
    "dropphyst": "TX",
    "dropphyzpp": 781419998,
    "dropmaladd": "301 BROADWAY",
    "dropmalcty": "NORDHEIM",
    "dropmalst": "TX",
    "dropmalzpp": 781419998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619385552,
    "dropsitcph": 3619385552,
    "dropfax": 3619387078
  },
  {
    "dcode": "D",
    "dropkey": "PW24922",
    "droptype": "D",
    "dropname": "NORMANGEE",
    "dropdeladd": "201 HOLLIS ST",
    "dropdelcty": "NORMANGEE",
    "dropdelst": "TX",
    "dropdelzpp": 778719801,
    "dropphyadd": "201 HOLLIS ST",
    "dropphycty": "NORMANGEE",
    "dropphyst": "TX",
    "dropphyzpp": 778719801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORMANGEE",
    "dropmalst": "TX",
    "dropmalzpp": 778719998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363964422,
    "dropsitcph": 9363964422,
    "dropfax": 9363961157
  },
  {
    "dcode": "D",
    "dropkey": "PW24923",
    "droptype": "D",
    "dropname": "NORMANNA",
    "dropdeladd": "112 S BEE ST",
    "dropdelcty": "NORMANNA",
    "dropdelst": "TX",
    "dropdelzpp": 781429800,
    "dropphyadd": "112 S BEE ST",
    "dropphycty": "NORMANNA",
    "dropphyst": "TX",
    "dropphyzpp": 781429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORMANNA",
    "dropmalst": "TX",
    "dropmalzpp": 781429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613584893,
    "dropsitcph": 3613584893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24935",
    "droptype": "D",
    "dropname": "NORTH HOUSTON",
    "dropdeladd": "4600 ALDINE BENDER RD RM 224",
    "dropdelcty": "NORTH HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 773159998,
    "dropphyadd": "4600 ALDINE BENDER RD RM 224",
    "dropphycty": "NORTH HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 773159998,
    "dropmaladd": "4600 ALDINE BENDER RD RM 224",
    "dropmalcty": "NORTH HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 773159998,
    "dropsitphn": 7132263134,
    "dropsitlph": 7132263134,
    "dropsitcph": 7132263442,
    "dropfax": 2819854180
  },
  {
    "dcode": "D",
    "dropkey": "PW24950",
    "droptype": "D",
    "dropname": "NORTH ZULCH",
    "dropdeladd": "11337 5TH ST",
    "dropdelcty": "NORTH ZULCH",
    "dropdelst": "TX",
    "dropdelzpp": 778729800,
    "dropphyadd": "11337 5TH ST",
    "dropphycty": "NORTH ZULCH",
    "dropphyst": "TX",
    "dropphyzpp": 778729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH ZULCH",
    "dropmalst": "TX",
    "dropmalzpp": 778729998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363994832,
    "dropsitcph": 9363994832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24964",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "EASTLAND ST",
    "dropdelcty": "NORTON",
    "dropdelst": "TX",
    "dropdelzpp": 76865,
    "dropphyadd": "EASTLAND ST",
    "dropphycty": "NORTON",
    "dropphyst": "TX",
    "dropphyzpp": 76865,
    "dropmaladd": "116 S 8TH ST",
    "dropmalcty": "BALLINGER",
    "dropmalst": "TX",
    "dropmalzpp": 768215635,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3257862332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24966",
    "droptype": "D",
    "dropname": "NOTREES",
    "dropdeladd": "37 W HIGHWAY 302",
    "dropdelcty": "NOTREES",
    "dropdelst": "TX",
    "dropdelzpp": 797592002,
    "dropphyadd": "37 W HIGHWAY 302",
    "dropphycty": "NOTREES",
    "dropphyst": "TX",
    "dropphyzpp": 797592002,
    "dropmaladd": "PO BOX 1009",
    "dropmalcty": "NOTREES",
    "dropmalst": "TX",
    "dropmalzpp": 797599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4328273326,
    "dropfax": 4328273326
  },
  {
    "dcode": "D",
    "dropkey": "PW24967",
    "droptype": "D",
    "dropname": "NOVICE",
    "dropdeladd": "700 PARKER ST",
    "dropdelcty": "NOVICE",
    "dropdelst": "TX",
    "dropdelzpp": 795389704,
    "dropphyadd": "700 PARKER ST",
    "dropphycty": "NOVICE",
    "dropphyst": "TX",
    "dropphyzpp": 795389704,
    "dropmaladd": "700 PARKER ST",
    "dropmalcty": "NOVICE",
    "dropmalst": "TX",
    "dropmalzpp": 795389704,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256254977,
    "dropsitcph": 3256254977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24970",
    "droptype": "D",
    "dropname": "NURSERY",
    "dropdeladd": "12685 NURSERY DR",
    "dropdelcty": "NURSERY",
    "dropdelst": "TX",
    "dropdelzpp": 779769800,
    "dropphyadd": "12685 NURSERY DR",
    "dropphycty": "NURSERY",
    "dropphyst": "TX",
    "dropphyzpp": 779769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NURSERY",
    "dropmalst": "TX",
    "dropmalzpp": 779769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615731789,
    "dropsitcph": 3615731789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24971",
    "droptype": "D",
    "dropname": "O BRIEN",
    "dropdeladd": "601 9TH ST",
    "dropdelcty": "O BRIEN",
    "dropdelst": "TX",
    "dropdelzpp": 795399998,
    "dropphyadd": "601 9TH ST",
    "dropphycty": "O BRIEN",
    "dropphyst": "TX",
    "dropphyzpp": 795399998,
    "dropmaladd": "601 9TH ST",
    "dropmalcty": "O BRIEN",
    "dropmalst": "TX",
    "dropmalzpp": 795399998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406583108,
    "dropsitcph": 9406583108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24985",
    "droptype": "D",
    "dropname": "OAKHURST",
    "dropdeladd": "1100 HIGHWAY 190 W",
    "dropdelcty": "OAKHURST",
    "dropdelst": "TX",
    "dropdelzpp": 773599820,
    "dropphyadd": "1100 HIGHWAY 190 W",
    "dropphycty": "OAKHURST",
    "dropphyst": "TX",
    "dropphyzpp": 773599820,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKHURST",
    "dropmalst": "TX",
    "dropmalzpp": 773599998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363772360,
    "dropsitcph": 9363772360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24993",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "315 W BROAD ST",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 758559998,
    "dropphyadd": "315 W BROAD ST",
    "dropphycty": "OAKWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 758559998,
    "dropmaladd": "315 W BROAD ST",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 758559998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035452114,
    "dropsitcph": 9035452114,
    "dropfax": 9035452005
  },
  {
    "dcode": "D",
    "dropkey": "PW24998",
    "droptype": "D",
    "dropname": "ODEM",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "ODEM",
    "dropdelst": "TX",
    "dropdelzpp": 783709998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "ODEM",
    "dropphyst": "TX",
    "dropphyzpp": 783709998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "ODEM",
    "dropmalst": "TX",
    "dropmalzpp": 783709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613684981,
    "dropsitcph": 3613684981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW24999",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "200 N TEXAS AVE",
    "dropdelcty": "ODESSA",
    "dropdelst": "TX",
    "dropdelzpp": 797619998,
    "dropphyadd": "200 N TEXAS AVE",
    "dropphycty": "ODESSA",
    "dropphyst": "TX",
    "dropphyzpp": 797619998,
    "dropmaladd": "200 N TEXAS AVE",
    "dropmalcty": "ODESSA",
    "dropmalst": "TX",
    "dropmalzpp": 797619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4327757543,
    "dropsitcph": 4323326436,
    "dropfax": 4323326638
  },
  {
    "dcode": "D",
    "dropkey": "PW25000",
    "droptype": "D",
    "dropname": "ODONNELL",
    "dropdeladd": "819 DOAK ST",
    "dropdelcty": "ODONNELL",
    "dropdelst": "TX",
    "dropdelzpp": 793519800,
    "dropphyadd": "819 DOAK ST",
    "dropphycty": "ODONNELL",
    "dropphyst": "TX",
    "dropphyzpp": 793519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODONNELL",
    "dropmalst": "TX",
    "dropmalzpp": 793519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064283337,
    "dropsitcph": 8064283337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25003",
    "droptype": "D",
    "dropname": "OGLESBY",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "OGLESBY",
    "dropdelst": "TX",
    "dropdelzpp": 765619998,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "OGLESBY",
    "dropphyst": "TX",
    "dropphyzpp": 765619998,
    "dropmaladd": "108 MAIN ST",
    "dropmalcty": "OGLESBY",
    "dropmalst": "TX",
    "dropmalzpp": 765619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2544562311,
    "dropsitcph": 2544562311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25004",
    "droptype": "D",
    "dropname": "OILTON",
    "dropdeladd": "118 W LAREDO AVE",
    "dropdelcty": "OILTON",
    "dropdelst": "TX",
    "dropdelzpp": 783719800,
    "dropphyadd": "118 W LAREDO AVE",
    "dropphycty": "OILTON",
    "dropphyst": "TX",
    "dropphyzpp": 783719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OILTON",
    "dropmalst": "TX",
    "dropmalzpp": 783719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615864674,
    "dropsitcph": 3615864674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25006",
    "droptype": "D",
    "dropname": "OKLAUNION",
    "dropdeladd": "9172 1ST ST",
    "dropdelcty": "OKLAUNION",
    "dropdelst": "TX",
    "dropdelzpp": 763739998,
    "dropphyadd": "9172 1ST ST",
    "dropphycty": "OKLAUNION",
    "dropphyst": "TX",
    "dropphyzpp": 763739998,
    "dropmaladd": "9172 1ST ST",
    "dropmalcty": "OKLAUNION",
    "dropmalst": "TX",
    "dropmalzpp": 763739998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408862239,
    "dropsitcph": 9408862239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25009",
    "droptype": "D",
    "dropname": "OLD GLORY",
    "dropdeladd": "9080 FM 1835",
    "dropdelcty": "OLD GLORY",
    "dropdelst": "TX",
    "dropdelzpp": 795409998,
    "dropphyadd": "9080 FM 1835",
    "dropphycty": "OLD GLORY",
    "dropphyst": "TX",
    "dropphyzpp": 795409998,
    "dropmaladd": "9080 FM 1835",
    "dropmalcty": "OLD GLORY",
    "dropmalst": "TX",
    "dropmalzpp": 795409998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 9409892681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25015",
    "droptype": "D",
    "dropname": "OLD OCEAN",
    "dropdeladd": "21724 HIGHWAY 35",
    "dropdelcty": "OLD OCEAN",
    "dropdelst": "TX",
    "dropdelzpp": 774639800,
    "dropphyadd": "21724 HIGHWAY 35",
    "dropphycty": "OLD OCEAN",
    "dropphyst": "TX",
    "dropphyzpp": 774639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD OCEAN",
    "dropmalst": "TX",
    "dropmalzpp": 774639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796474920,
    "dropsitcph": 9796474920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25021",
    "droptype": "D",
    "dropname": "OLDEN",
    "dropdeladd": "526 FM 3363",
    "dropdelcty": "OLDEN",
    "dropdelst": "TX",
    "dropdelzpp": 764662102,
    "dropphyadd": "526 FM 3363",
    "dropphycty": "OLDEN",
    "dropphyst": "TX",
    "dropphyzpp": 764662102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLDEN",
    "dropmalst": "TX",
    "dropmalzpp": 764669998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546532493,
    "dropsitcph": 2546532493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25025",
    "droptype": "D",
    "dropname": "OLMITO",
    "dropdeladd": "7955 N EXPRESSWAY 77",
    "dropdelcty": "OLMITO",
    "dropdelst": "TX",
    "dropdelzpp": 785755270,
    "dropphyadd": "7955 N EXPRESSWAY 77",
    "dropphycty": "OLMITO",
    "dropphyst": "TX",
    "dropphyzpp": 785755270,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLMITO",
    "dropmalst": "TX",
    "dropmalzpp": 785759998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563504712,
    "dropsitcph": 9563504712,
    "dropfax": 9563503554
  },
  {
    "dcode": "D",
    "dropkey": "PW25028",
    "droptype": "D",
    "dropname": "OLNEY",
    "dropdeladd": "301 E ELM ST",
    "dropdelcty": "OLNEY",
    "dropdelst": "TX",
    "dropdelzpp": 763749998,
    "dropphyadd": "301 E ELM ST",
    "dropphycty": "OLNEY",
    "dropphyst": "TX",
    "dropphyzpp": 763749998,
    "dropmaladd": "301 E ELM ST",
    "dropmalcty": "OLNEY",
    "dropmalst": "TX",
    "dropmalzpp": 763749998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405642120,
    "dropsitcph": 9405642120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25029",
    "droptype": "D",
    "dropname": "OLTON",
    "dropdeladd": "416 8TH ST",
    "dropdelcty": "OLTON",
    "dropdelst": "TX",
    "dropdelzpp": 790649805,
    "dropphyadd": "416 8TH ST",
    "dropphycty": "OLTON",
    "dropphyst": "TX",
    "dropphyzpp": 790649805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLTON",
    "dropmalst": "TX",
    "dropmalzpp": 790649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8062852218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25030",
    "droptype": "D",
    "dropname": "OMAHA",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "TX",
    "dropdelzpp": 755719998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "OMAHA",
    "dropphyst": "TX",
    "dropphyzpp": 755719998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "TX",
    "dropmalzpp": 755719998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038842308,
    "dropsitcph": 9038842308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25032",
    "droptype": "D",
    "dropname": "ONALASKA",
    "dropdeladd": "203 N FM 356",
    "dropdelcty": "ONALASKA",
    "dropdelst": "TX",
    "dropdelzpp": 773607603,
    "dropphyadd": "203 N FM 356",
    "dropphycty": "ONALASKA",
    "dropphyst": "TX",
    "dropphyzpp": 773607603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONALASKA",
    "dropmalst": "TX",
    "dropmalzpp": 773609998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9366463313,
    "dropsitcph": 9366463313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25035",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "500 4TH ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "TX",
    "dropdelzpp": 776309998,
    "dropphyadd": "500 4TH ST",
    "dropphycty": "ORANGE",
    "dropphyst": "TX",
    "dropphyzpp": 776309998,
    "dropmaladd": "500 4TH ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "TX",
    "dropmalzpp": 776309998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4098830969,
    "dropsitcph": 4098836032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25036",
    "droptype": "D",
    "dropname": "ORANGE GROVE",
    "dropdeladd": "214 S EUGENIA ST",
    "dropdelcty": "ORANGE GROVE",
    "dropdelst": "TX",
    "dropdelzpp": 783729998,
    "dropphyadd": "214 S EUGENIA ST",
    "dropphycty": "ORANGE GROVE",
    "dropphyst": "TX",
    "dropphyzpp": 783729998,
    "dropmaladd": "214 S EUGENIA ST",
    "dropmalcty": "ORANGE GROVE",
    "dropmalst": "TX",
    "dropmalzpp": 783729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613842301,
    "dropsitcph": 3613842301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25037",
    "droptype": "D",
    "dropname": "ORANGEFIELD",
    "dropdeladd": "5481 FM 408",
    "dropdelcty": "ORANGEFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 776390197,
    "dropphyadd": "5481 FM 408",
    "dropphycty": "ORANGEFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 776390197,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORANGEFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 776399998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4096971880,
    "dropsitcph": 4096971880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25039",
    "droptype": "D",
    "dropname": "ORCHARD",
    "dropdeladd": "218 N MISSOURI",
    "dropdelcty": "ORCHARD",
    "dropdelst": "TX",
    "dropdelzpp": 774640010,
    "dropphyadd": "218 N MISSOURI",
    "dropphycty": "ORCHARD",
    "dropphyst": "TX",
    "dropphyzpp": 774640010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCHARD",
    "dropmalst": "TX",
    "dropmalzpp": 774649998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9794786243,
    "dropsitcph": 9794786243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25040",
    "droptype": "D",
    "dropname": "ORE CITY",
    "dropdeladd": "203 US HIGHWAY 259 S",
    "dropdelcty": "ORE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 756839998,
    "dropphyadd": "203 US HIGHWAY 259 S",
    "dropphycty": "ORE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 756839998,
    "dropmaladd": "203 US HIGHWAY 259 S",
    "dropmalcty": "ORE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 756839998,
    "dropsitphn": 9033243009,
    "dropsitlph": 9039682899,
    "dropsitcph": 9039682899,
    "dropfax": 9039684407
  },
  {
    "dcode": "D",
    "dropkey": "PW25041",
    "droptype": "D",
    "dropname": "ORLA",
    "dropdeladd": "3737 N HIGHWAY 285",
    "dropdelcty": "ORLA",
    "dropdelst": "TX",
    "dropdelzpp": 797709800,
    "dropphyadd": "3737 N HIGHWAY 285",
    "dropphycty": "ORLA",
    "dropphyst": "TX",
    "dropphyzpp": 797709800,
    "dropmaladd": "3737 N HIGHWAY 285",
    "dropmalcty": "ORLA",
    "dropmalst": "TX",
    "dropmalzpp": 797709800,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4322734300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25048",
    "droptype": "D",
    "dropname": "OVALO",
    "dropdeladd": "3010 FM 614",
    "dropdelcty": "OVALO",
    "dropdelst": "TX",
    "dropdelzpp": 795419998,
    "dropphyadd": "3010 FM 614",
    "dropphycty": "OVALO",
    "dropphyst": "TX",
    "dropphyzpp": 795419998,
    "dropmaladd": "3010 FM 614",
    "dropmalcty": "OVALO",
    "dropmalst": "TX",
    "dropmalzpp": 795419998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255547420,
    "dropsitcph": 3255547420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25049",
    "droptype": "D",
    "dropname": "OVERTON",
    "dropdeladd": "115 S RUSK ST",
    "dropdelcty": "OVERTON",
    "dropdelst": "TX",
    "dropdelzpp": 756849998,
    "dropphyadd": "115 S RUSK ST",
    "dropphycty": "OVERTON",
    "dropphyst": "TX",
    "dropphyzpp": 756849998,
    "dropmaladd": "115 S RUSK ST",
    "dropmalcty": "OVERTON",
    "dropmalst": "TX",
    "dropmalzpp": 756849998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038343641,
    "dropsitcph": 9038343641,
    "dropfax": 9038344176
  },
  {
    "dcode": "D",
    "dropkey": "PW25054",
    "droptype": "D",
    "dropname": "OZONA",
    "dropdeladd": "1106 AVE F",
    "dropdelcty": "OZONA",
    "dropdelst": "TX",
    "dropdelzpp": 769439803,
    "dropphyadd": "1106 AVE F",
    "dropphycty": "OZONA",
    "dropphyst": "TX",
    "dropphyzpp": 769439803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OZONA",
    "dropmalst": "TX",
    "dropmalzpp": 769439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3253923011,
    "dropsitcph": 3253923011,
    "dropfax": 3253923013
  },
  {
    "dcode": "D",
    "dropkey": "PW25056",
    "droptype": "D",
    "dropname": "PADUCAH",
    "dropdeladd": "718 10TH ST",
    "dropdelcty": "PADUCAH",
    "dropdelst": "TX",
    "dropdelzpp": 792489998,
    "dropphyadd": "718 10TH ST",
    "dropphycty": "PADUCAH",
    "dropphyst": "TX",
    "dropphyzpp": 792489998,
    "dropmaladd": "718 10TH ST",
    "dropmalcty": "PADUCAH",
    "dropmalst": "TX",
    "dropmalzpp": 792489998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064923323,
    "dropsitcph": 8064923323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25058",
    "droptype": "D",
    "dropname": "PAIGE",
    "dropdeladd": "114 GONZALES ST",
    "dropdelcty": "PAIGE",
    "dropdelst": "TX",
    "dropdelzpp": 786599998,
    "dropphyadd": "114 GONZALES ST",
    "dropphycty": "PAIGE",
    "dropphyst": "TX",
    "dropphyzpp": 786599998,
    "dropmaladd": "114 GONZALES ST",
    "dropmalcty": "PAIGE",
    "dropmalst": "TX",
    "dropmalzpp": 786599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122536531,
    "dropsitcph": 5122536531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25059",
    "droptype": "D",
    "dropname": "PAINT ROCK",
    "dropdeladd": "331 S ROBERTS AVE",
    "dropdelcty": "PAINT ROCK",
    "dropdelst": "TX",
    "dropdelzpp": 768669802,
    "dropphyadd": "331 S ROBERTS AVE",
    "dropphycty": "PAINT ROCK",
    "dropphyst": "TX",
    "dropphyzpp": 768669802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAINT ROCK",
    "dropmalst": "TX",
    "dropmalzpp": 768669998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3257324317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25060",
    "droptype": "D",
    "dropname": "PALACIOS",
    "dropdeladd": "700 HENDERSON AVE",
    "dropdelcty": "PALACIOS",
    "dropdelst": "TX",
    "dropdelzpp": 774659998,
    "dropphyadd": "700 HENDERSON AVE",
    "dropphycty": "PALACIOS",
    "dropphyst": "TX",
    "dropphyzpp": 774659998,
    "dropmaladd": "700 HENDERSON AVE",
    "dropmalcty": "PALACIOS",
    "dropmalst": "TX",
    "dropmalzpp": 774659998,
    "dropsitphn": 7132263055,
    "dropsitlph": 3619722213,
    "dropsitcph": 3619722213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25063",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "1213 N LINK ST",
    "dropdelcty": "PALESTINE",
    "dropdelst": "TX",
    "dropdelzpp": 758039998,
    "dropphyadd": "1213 N LINK ST",
    "dropphycty": "PALESTINE",
    "dropphyst": "TX",
    "dropphyzpp": 758039998,
    "dropmaladd": "1213 N LINK ST",
    "dropmalcty": "PALESTINE",
    "dropmalst": "TX",
    "dropmalzpp": 758039998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037231084,
    "dropsitcph": 9037231084,
    "dropfax": 9037291999
  },
  {
    "dcode": "D",
    "dropkey": "PW25066",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "310 E JEFFERSON ST",
    "dropdelcty": "PALMER",
    "dropdelst": "TX",
    "dropdelzpp": 751529998,
    "dropphyadd": "310 E JEFFERSON ST",
    "dropphycty": "PALMER",
    "dropphyst": "TX",
    "dropphyzpp": 751529998,
    "dropmaladd": "310 E JEFFERSON ST",
    "dropmalcty": "PALMER",
    "dropmalst": "TX",
    "dropmalzpp": 751529998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9728452104,
    "dropsitcph": 9728452104,
    "dropfax": 9728452104
  },
  {
    "dcode": "D",
    "dropkey": "PW25071",
    "droptype": "D",
    "dropname": "PALO PINTO",
    "dropdeladd": "106 N 5TH AVE",
    "dropdelcty": "PALO PINTO",
    "dropdelst": "TX",
    "dropdelzpp": 764849998,
    "dropphyadd": "106 N 5TH AVE",
    "dropphycty": "PALO PINTO",
    "dropphyst": "TX",
    "dropphyzpp": 764849998,
    "dropmaladd": "106 N 5TH AVE",
    "dropmalcty": "PALO PINTO",
    "dropmalst": "TX",
    "dropmalzpp": 764849998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406592125,
    "dropsitcph": 9406592125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25073",
    "droptype": "D",
    "dropname": "PAMPA",
    "dropdeladd": "120 E FOSTER AVE",
    "dropdelcty": "PAMPA",
    "dropdelst": "TX",
    "dropdelzpp": 790659998,
    "dropphyadd": "120 E FOSTER AVE",
    "dropphycty": "PAMPA",
    "dropphyst": "TX",
    "dropphyzpp": 790659998,
    "dropmaladd": "120 E FOSTER AVE",
    "dropmalcty": "PAMPA",
    "dropmalst": "TX",
    "dropmalzpp": 790659998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066654260,
    "dropsitcph": 8066654260,
    "dropfax": 8066690908
  },
  {
    "dcode": "D",
    "dropkey": "PW25075",
    "droptype": "D",
    "dropname": "PANDORA",
    "dropdeladd": "8547 FM 1107",
    "dropdelcty": "PANDORA",
    "dropdelst": "TX",
    "dropdelzpp": 781439800,
    "dropphyadd": "8547 FM 1107",
    "dropphycty": "PANDORA",
    "dropphyst": "TX",
    "dropphyzpp": 781439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANDORA",
    "dropmalst": "TX",
    "dropmalzpp": 781439998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305822210,
    "dropsitcph": 8305822210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25077",
    "droptype": "D",
    "dropname": "PANHANDLE",
    "dropdeladd": "402 MAIN ST",
    "dropdelcty": "PANHANDLE",
    "dropdelst": "TX",
    "dropdelzpp": 790683052,
    "dropphyadd": "402 MAIN ST",
    "dropphycty": "PANHANDLE",
    "dropphyst": "TX",
    "dropphyzpp": 790683052,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANHANDLE",
    "dropmalst": "TX",
    "dropmalzpp": 790689998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065373721,
    "dropsitcph": 8065373721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25078",
    "droptype": "D",
    "dropname": "PANNA MARIA",
    "dropdeladd": "13870 N FM 81",
    "dropdelcty": "PANNA MARIA",
    "dropdelst": "TX",
    "dropdelzpp": 781449800,
    "dropphyadd": "13870 N FM 81",
    "dropphycty": "PANNA MARIA",
    "dropphyst": "TX",
    "dropphyzpp": 781449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANNA MARIA",
    "dropmalst": "TX",
    "dropmalzpp": 781449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688384,
    "dropsitcph": 8307802294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25079",
    "droptype": "D",
    "dropname": "PANOLA",
    "dropdeladd": "175 S FM 9",
    "dropdelcty": "PANOLA",
    "dropdelst": "TX",
    "dropdelzpp": 756859998,
    "dropphyadd": "175 S FM 9",
    "dropphycty": "PANOLA",
    "dropphyst": "TX",
    "dropphyzpp": 756859998,
    "dropmaladd": "175 S FM 9",
    "dropmalcty": "PANOLA",
    "dropmalst": "TX",
    "dropmalzpp": 756859998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037663758,
    "dropsitcph": 9037663758,
    "dropfax": 9037663758
  },
  {
    "dcode": "D",
    "dropkey": "PW25084",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "217 MAIN ST",
    "dropdelcty": "PARADISE",
    "dropdelst": "TX",
    "dropdelzpp": 760739998,
    "dropphyadd": "217 MAIN ST",
    "dropphycty": "PARADISE",
    "dropphyst": "TX",
    "dropphyzpp": 760739998,
    "dropmaladd": "217 MAIN ST",
    "dropmalcty": "PARADISE",
    "dropmalst": "TX",
    "dropmalzpp": 760739998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9409693151,
    "dropsitcph": 9409693151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25085",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "500 CLARKSVILLE ST",
    "dropdelcty": "PARIS",
    "dropdelst": "TX",
    "dropdelzpp": 754609998,
    "dropphyadd": "500 CLARKSVILLE ST",
    "dropphycty": "PARIS",
    "dropphyst": "TX",
    "dropphyzpp": 754609998,
    "dropmaladd": "500 CLARKSVILLE ST",
    "dropmalcty": "PARIS",
    "dropmalst": "TX",
    "dropmalzpp": 754609998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037843381,
    "dropsitcph": 9037843381,
    "dropfax": 9037844865
  },
  {
    "dcode": "D",
    "dropkey": "PW25091",
    "droptype": "D",
    "dropname": "PASADENA",
    "dropdeladd": "1199 PASADENA BLVD",
    "dropdelcty": "PASADENA",
    "dropdelst": "TX",
    "dropdelzpp": 775019998,
    "dropphyadd": "1199 PASADENA BLVD",
    "dropphycty": "PASADENA",
    "dropphyst": "TX",
    "dropphyzpp": 775019998,
    "dropmaladd": "1199 PASADENA BLVD",
    "dropmalcty": "PASADENA",
    "dropmalst": "TX",
    "dropmalzpp": 775019998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7134759328,
    "dropsitcph": 7134750205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25093",
    "droptype": "D",
    "dropname": "PATTISON",
    "dropdeladd": "3637 2ND ST",
    "dropdelcty": "PATTISON",
    "dropdelst": "TX",
    "dropdelzpp": 774669800,
    "dropphyadd": "3637 2ND ST",
    "dropphycty": "PATTISON",
    "dropphyst": "TX",
    "dropphyzpp": 774669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATTISON",
    "dropmalst": "TX",
    "dropmalzpp": 774669998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2819342548,
    "dropsitcph": 2819342548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25095",
    "droptype": "D",
    "dropname": "PATTONVILLE",
    "dropdeladd": "6863 US HIGHWAY 271 S",
    "dropdelcty": "PATTONVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754689998,
    "dropphyadd": "6863 US HIGHWAY 271 S",
    "dropphycty": "PATTONVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754689998,
    "dropmaladd": "6863 US HIGHWAY 271 S",
    "dropmalcty": "PATTONVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754689998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036523661,
    "dropsitcph": 9036523661,
    "dropfax": 9036523661
  },
  {
    "dcode": "D",
    "dropkey": "PW25098",
    "droptype": "D",
    "dropname": "PAWNEE",
    "dropdeladd": "14132 FM 673",
    "dropdelcty": "PAWNEE",
    "dropdelst": "TX",
    "dropdelzpp": 781459800,
    "dropphyadd": "14132 FM 673",
    "dropphycty": "PAWNEE",
    "dropphyst": "TX",
    "dropphyzpp": 781459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAWNEE",
    "dropmalst": "TX",
    "dropmalzpp": 781459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3614567271,
    "dropsitcph": 3614567271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25104",
    "droptype": "D",
    "dropname": "PEARLAND",
    "dropdeladd": "3519 E WALNUT ST",
    "dropdelcty": "PEARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 775819998,
    "dropphyadd": "3519 E WALNUT ST",
    "dropphycty": "PEARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 775819998,
    "dropmaladd": "3519 E WALNUT ST",
    "dropmalcty": "PEARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 775819998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814857527,
    "dropsitcph": 2814852132,
    "dropfax": 2814856213
  },
  {
    "dcode": "D",
    "dropkey": "PW25105",
    "droptype": "D",
    "dropname": "PEARSALL",
    "dropdeladd": "411 E COLORADO ST",
    "dropdelcty": "PEARSALL",
    "dropdelst": "TX",
    "dropdelzpp": 780619998,
    "dropphyadd": "411 E COLORADO ST",
    "dropphycty": "PEARSALL",
    "dropphyst": "TX",
    "dropphyzpp": 780619998,
    "dropmaladd": "411 E COLORADO ST",
    "dropmalcty": "PEARSALL",
    "dropmalst": "TX",
    "dropmalzpp": 780619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8303343003,
    "dropsitcph": 8303343003,
    "dropfax": 8303348368
  },
  {
    "dcode": "D",
    "dropkey": "PW25106",
    "droptype": "D",
    "dropname": "PEASTER",
    "dropdeladd": "8616 FM 920",
    "dropdelcty": "PEASTER",
    "dropdelst": "TX",
    "dropdelzpp": 764859998,
    "dropphyadd": "8616 FM 920",
    "dropphycty": "PEASTER",
    "dropphyst": "TX",
    "dropphyzpp": 764859998,
    "dropmaladd": "8616 FM 920",
    "dropmalcty": "PEASTER",
    "dropmalst": "TX",
    "dropmalzpp": 764859998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175994911,
    "dropsitcph": 8175994911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25109",
    "droptype": "D",
    "dropname": "PECAN GAP",
    "dropdeladd": "112 3RD ST",
    "dropdelcty": "PECAN GAP",
    "dropdelst": "TX",
    "dropdelzpp": 754699998,
    "dropphyadd": "112 3RD ST",
    "dropphycty": "PECAN GAP",
    "dropphyst": "TX",
    "dropphyzpp": 754699998,
    "dropmaladd": "112 3RD ST",
    "dropmalcty": "PECAN GAP",
    "dropmalst": "TX",
    "dropmalzpp": 754699998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033596630,
    "dropsitcph": 9033596630,
    "dropfax": 9036523661
  },
  {
    "dcode": "D",
    "dropkey": "PW25111",
    "droptype": "D",
    "dropname": "PECOS",
    "dropdeladd": "106 W 4TH ST",
    "dropdelcty": "PECOS",
    "dropdelst": "TX",
    "dropdelzpp": 797729998,
    "dropphyadd": "106 W 4TH ST",
    "dropphycty": "PECOS",
    "dropphyst": "TX",
    "dropphyzpp": 797729998,
    "dropmaladd": "106 W 4TH ST",
    "dropmalcty": "PECOS",
    "dropmalst": "TX",
    "dropmalzpp": 797729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4324454415,
    "dropfax": 4324455517
  },
  {
    "dcode": "D",
    "dropkey": "PW25116",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "9765 PENDLETON TROY RD",
    "dropdelcty": "PENDLETON",
    "dropdelst": "TX",
    "dropdelzpp": 765649800,
    "dropphyadd": "9765 PENDLETON TROY RD",
    "dropphycty": "PENDLETON",
    "dropphyst": "TX",
    "dropphyzpp": 765649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENDLETON",
    "dropmalst": "TX",
    "dropmalzpp": 765649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547737143,
    "dropsitcph": 2547713433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25117",
    "droptype": "D",
    "dropname": "PENELOPE",
    "dropdeladd": "122 E COMMERCE",
    "dropdelcty": "PENELOPE",
    "dropdelst": "TX",
    "dropdelzpp": 766769998,
    "dropphyadd": "122 E COMMERCE",
    "dropphycty": "PENELOPE",
    "dropphyst": "TX",
    "dropphyzpp": 766769998,
    "dropmaladd": "122 E COMMERCE",
    "dropmalcty": "PENELOPE",
    "dropmalst": "TX",
    "dropmalzpp": 766769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545332232,
    "dropsitcph": 2545332232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25118",
    "droptype": "D",
    "dropname": "PENITAS",
    "dropdeladd": "500 TOM GILL RD",
    "dropdelcty": "PENITAS",
    "dropdelst": "TX",
    "dropdelzpp": 785769998,
    "dropphyadd": "500 TOM GILL RD",
    "dropphycty": "PENITAS",
    "dropphyst": "TX",
    "dropphyzpp": 785769998,
    "dropmaladd": "500 TOM GILL RD",
    "dropmalcty": "PENITAS",
    "dropmalst": "TX",
    "dropmalzpp": 785769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565854655,
    "dropsitcph": 9565854655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25119",
    "droptype": "D",
    "dropname": "PENNINGTON",
    "dropdeladd": "6552 FM 2781",
    "dropdelcty": "PENNINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 758569998,
    "dropphyadd": "6552 FM 2781",
    "dropphycty": "PENNINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 758569998,
    "dropmaladd": "6552 FM 2781",
    "dropmalcty": "PENNINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 758569998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366384362,
    "dropsitcph": 9366384362,
    "dropfax": 9366384210
  },
  {
    "dcode": "D",
    "dropkey": "PW25120",
    "droptype": "D",
    "dropname": "PENWELL",
    "dropdeladd": "157 S FM ROAD 1601",
    "dropdelcty": "PENWELL",
    "dropdelst": "TX",
    "dropdelzpp": 797769800,
    "dropphyadd": "157 S FM ROAD 1601",
    "dropphycty": "PENWELL",
    "dropphyst": "TX",
    "dropphyzpp": 797769800,
    "dropmaladd": "157 S FM ROAD 1601",
    "dropmalcty": "PENWELL",
    "dropmalst": "TX",
    "dropmalzpp": 797769800,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323331064,
    "dropsitcph": 4323331064,
    "dropfax": 4323331064
  },
  {
    "dcode": "D",
    "dropkey": "PW25122",
    "droptype": "D",
    "dropname": "PEP",
    "dropdeladd": "4282 N STATE ROAD 303",
    "dropdelcty": "PEP",
    "dropdelst": "TX",
    "dropdelzpp": 793539802,
    "dropphyadd": "4282 N STATE ROAD 303",
    "dropphycty": "PEP",
    "dropphyst": "TX",
    "dropphyzpp": 793539802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEP",
    "dropmalst": "TX",
    "dropmalzpp": 793539998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069334407,
    "dropsitcph": 8069334407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25126",
    "droptype": "D",
    "dropname": "PERRIN",
    "dropdeladd": "319 W HACKLEY ST",
    "dropdelcty": "PERRIN",
    "dropdelst": "TX",
    "dropdelzpp": 764869998,
    "dropphyadd": "319 W HACKLEY ST",
    "dropphycty": "PERRIN",
    "dropphyst": "TX",
    "dropphyzpp": 764869998,
    "dropmaladd": "319 W HACKLEY ST",
    "dropmalcty": "PERRIN",
    "dropmalst": "TX",
    "dropmalzpp": 764869998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407989933,
    "dropsitcph": 9407989933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25128",
    "droptype": "D",
    "dropname": "PERRYTON",
    "dropdeladd": "2722 S MAIN ST",
    "dropdelcty": "PERRYTON",
    "dropdelst": "TX",
    "dropdelzpp": 790709998,
    "dropphyadd": "2722 S MAIN ST",
    "dropphycty": "PERRYTON",
    "dropphyst": "TX",
    "dropphyzpp": 790709998,
    "dropmaladd": "2722 S MAIN ST",
    "dropmalcty": "PERRYTON",
    "dropmalst": "TX",
    "dropmalzpp": 790709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064352542,
    "dropsitcph": 8064352542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25134",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "1501 E 1ST ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "TX",
    "dropdelzpp": 792509802,
    "dropphyadd": "1501 E 1ST ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "TX",
    "dropphyzpp": 792509802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "TX",
    "dropmalzpp": 792509998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066672203,
    "dropsitcph": 8066672203,
    "dropfax": 8066673497
  },
  {
    "dcode": "D",
    "dropkey": "PW25136",
    "droptype": "D",
    "dropname": "PETROLIA",
    "dropdeladd": "108 W BENTON ST",
    "dropdelcty": "PETROLIA",
    "dropdelst": "TX",
    "dropdelzpp": 763779852,
    "dropphyadd": "108 W BENTON ST",
    "dropphycty": "PETROLIA",
    "dropphyst": "TX",
    "dropphyzpp": 763779852,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETROLIA",
    "dropmalst": "TX",
    "dropmalzpp": 763779998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405243511,
    "dropsitcph": 9405243511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25141",
    "droptype": "D",
    "dropname": "PETTUS",
    "dropdeladd": "114 FM 623 W",
    "dropdelcty": "PETTUS",
    "dropdelst": "TX",
    "dropdelzpp": 781469800,
    "dropphyadd": "114 FM 623 W",
    "dropphycty": "PETTUS",
    "dropphyst": "TX",
    "dropphyzpp": 781469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETTUS",
    "dropmalst": "TX",
    "dropmalzpp": 781469998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613752299,
    "dropsitcph": 3613752299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25142",
    "droptype": "D",
    "dropname": "PETTY",
    "dropdeladd": "306 FRONT ST",
    "dropdelcty": "PETTY",
    "dropdelst": "TX",
    "dropdelzpp": 754709998,
    "dropphyadd": "306 FRONT ST",
    "dropphycty": "PETTY",
    "dropphyst": "TX",
    "dropphyzpp": 754709998,
    "dropmaladd": "306 FRONT ST",
    "dropmalcty": "PETTY",
    "dropmalst": "TX",
    "dropmalzpp": 754709998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033782341,
    "dropsitcph": 9033782341,
    "dropfax": 9033782341
  },
  {
    "dcode": "D",
    "dropkey": "PW25143",
    "droptype": "D",
    "dropname": "PFLUGERVILLE",
    "dropdeladd": "301 S HEATHERWILDE BLVD",
    "dropdelcty": "PFLUGERVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 786609998,
    "dropphyadd": "301 S HEATHERWILDE BLVD",
    "dropphycty": "PFLUGERVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 786609998,
    "dropmaladd": "301 S HEATHERWILDE BLVD",
    "dropmalcty": "PFLUGERVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 786609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122512735,
    "dropsitcph": 5122511184,
    "dropfax": 5122511905
  },
  {
    "dcode": "D",
    "dropkey": "PW25144",
    "droptype": "D",
    "dropname": "PHARR",
    "dropdeladd": "301 W PARK AVE",
    "dropdelcty": "PHARR",
    "dropdelst": "TX",
    "dropdelzpp": 785779998,
    "dropphyadd": "301 W PARK AVE",
    "dropphycty": "PHARR",
    "dropphyst": "TX",
    "dropphyzpp": 785779998,
    "dropmaladd": "301 W PARK AVE",
    "dropmalcty": "PHARR",
    "dropmalst": "TX",
    "dropmalzpp": 785779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567872971,
    "dropsitcph": 9567872971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25147",
    "droptype": "D",
    "dropname": "PICKTON",
    "dropdeladd": "33 COUNTY ROAD 2419 N",
    "dropdelcty": "PICKTON",
    "dropdelst": "TX",
    "dropdelzpp": 754719998,
    "dropphyadd": "33 COUNTY ROAD 2419 N",
    "dropphycty": "PICKTON",
    "dropphyst": "TX",
    "dropphyzpp": 754719998,
    "dropmaladd": "33 COUNTY ROAD 2419 N",
    "dropmalcty": "PICKTON",
    "dropmalst": "TX",
    "dropmalzpp": 754719998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038662346,
    "dropsitcph": 9038662346,
    "dropfax": 9038662346
  },
  {
    "dcode": "D",
    "dropkey": "PW25149",
    "droptype": "D",
    "dropname": "PIERCE",
    "dropdeladd": "18566 LOOP 526 HWY",
    "dropdelcty": "PIERCE",
    "dropdelst": "TX",
    "dropdelzpp": 774670001,
    "dropphyadd": "18566 LOOP 526 HWY",
    "dropphycty": "PIERCE",
    "dropphyst": "TX",
    "dropphyzpp": 774670001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERCE",
    "dropmalst": "TX",
    "dropmalzpp": 774679998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795432055,
    "dropsitcph": 9795432055,
    "dropfax": 9795432055
  },
  {
    "dcode": "D",
    "dropkey": "PW25152",
    "droptype": "D",
    "dropname": "PILOT POINT",
    "dropdeladd": "401 N WASHINGTON ST",
    "dropdelcty": "PILOT POINT",
    "dropdelst": "TX",
    "dropdelzpp": 762589998,
    "dropphyadd": "401 N WASHINGTON ST",
    "dropphycty": "PILOT POINT",
    "dropphyst": "TX",
    "dropphyzpp": 762589998,
    "dropmaladd": "401 N WASHINGTON ST",
    "dropmalcty": "PILOT POINT",
    "dropmalst": "TX",
    "dropmalzpp": 762589998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406862924,
    "dropsitcph": 9406862924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25158",
    "droptype": "D",
    "dropname": "PINEHURST",
    "dropdeladd": "34635 WRIGHT RD",
    "dropdelcty": "PINEHURST",
    "dropdelst": "TX",
    "dropdelzpp": 773629998,
    "dropphyadd": "34635 WRIGHT RD",
    "dropphycty": "PINEHURST",
    "dropphyst": "TX",
    "dropphyzpp": 773629998,
    "dropmaladd": "34635 WRIGHT RD",
    "dropmalcty": "PINEHURST",
    "dropmalst": "TX",
    "dropmalzpp": 773629998,
    "dropsitphn": 2812590234,
    "dropsitlph": 2812590234,
    "dropsitcph": 2812590234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25159",
    "droptype": "D",
    "dropname": "PINELAND",
    "dropdeladd": "100 TIMBERLAND HWY",
    "dropdelcty": "PINELAND",
    "dropdelst": "TX",
    "dropdelzpp": 759684011,
    "dropphyadd": "100 TIMBERLAND HWY",
    "dropphycty": "PINELAND",
    "dropphyst": "TX",
    "dropphyzpp": 759684011,
    "dropmaladd": "100 TIMBERLAND HWY",
    "dropmalcty": "PINELAND",
    "dropmalst": "TX",
    "dropmalzpp": 759684011,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092190444,
    "dropsitcph": 4092190444,
    "dropfax": 4095841150
  },
  {
    "dcode": "D",
    "dropkey": "PW25163",
    "droptype": "D",
    "dropname": "PIPE CREEK",
    "dropdeladd": "10005 STATE HIGHWAY 16 S",
    "dropdelcty": "PIPE CREEK",
    "dropdelst": "TX",
    "dropdelzpp": 780639998,
    "dropphyadd": "10005 STATE HIGHWAY 16 S",
    "dropphycty": "PIPE CREEK",
    "dropphyst": "TX",
    "dropphyzpp": 780639998,
    "dropmaladd": "10005 STATE HIGHWAY 16 S",
    "dropmalcty": "PIPE CREEK",
    "dropmalst": "TX",
    "dropmalzpp": 780639998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688383,
    "dropsitcph": 8305354585,
    "dropfax": 8305356405
  },
  {
    "dcode": "D",
    "dropkey": "PW25167",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "151 E MARSHALL ST",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "TX",
    "dropdelzpp": 756869998,
    "dropphyadd": "151 E MARSHALL ST",
    "dropphycty": "PITTSBURG",
    "dropphyst": "TX",
    "dropphyzpp": 756869998,
    "dropmaladd": "151 E MARSHALL ST",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "TX",
    "dropmalzpp": 756869998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038563372,
    "dropsitcph": 9038563372,
    "dropfax": 9038566446
  },
  {
    "dcode": "D",
    "dropkey": "PW25168",
    "droptype": "D",
    "dropname": "PLACEDO",
    "dropdeladd": "5037 FM 616",
    "dropdelcty": "PLACEDO",
    "dropdelst": "TX",
    "dropdelzpp": 779779800,
    "dropphyadd": "5037 FM 616",
    "dropphycty": "PLACEDO",
    "dropphyst": "TX",
    "dropphyzpp": 779779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLACEDO",
    "dropmalst": "TX",
    "dropmalzpp": 779779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618971067,
    "dropsitcph": 3618971067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25169",
    "droptype": "D",
    "dropname": "PLAINS",
    "dropdeladd": "504 11TH ST",
    "dropdelcty": "PLAINS",
    "dropdelst": "TX",
    "dropdelzpp": 793559802,
    "dropphyadd": "504 11TH ST",
    "dropphycty": "PLAINS",
    "dropphyst": "TX",
    "dropphyzpp": 793559802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAINS",
    "dropmalst": "TX",
    "dropmalzpp": 793559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064568775,
    "dropsitcph": 8064568775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25170",
    "droptype": "D",
    "dropname": "PLAINVIEW",
    "dropdeladd": "725 ASH ST",
    "dropdelcty": "PLAINVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 790727308,
    "dropphyadd": "725 ASH ST",
    "dropphycty": "PLAINVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 790727308,
    "dropmaladd": "725 ASH ST",
    "dropmalcty": "PLAINVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 790727308,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8062962744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25171",
    "droptype": "D",
    "dropname": "PLANO",
    "dropdeladd": "1200 JUPITER RD",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750749998,
    "dropphyadd": "1200 JUPITER RD",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750749998,
    "dropmaladd": "1200 JUPITER RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750749998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9726339827,
    "dropsitcph": 9726335754,
    "dropfax": 9728815322
  },
  {
    "dcode": "D",
    "dropkey": "PW25172",
    "droptype": "D",
    "dropname": "PLANTERSVILLE",
    "dropdeladd": "8625 POST OFFICE RD",
    "dropdelcty": "PLANTERSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 773639800,
    "dropphyadd": "8625 POST OFFICE RD",
    "dropphycty": "PLANTERSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 773639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLANTERSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 773639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368942231,
    "dropsitcph": 9368942231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25181",
    "droptype": "D",
    "dropname": "PLEASANTON",
    "dropdeladd": "122 W GOODWIN ST",
    "dropdelcty": "PLEASANTON",
    "dropdelst": "TX",
    "dropdelzpp": 780649998,
    "dropphyadd": "122 W GOODWIN ST",
    "dropphycty": "PLEASANTON",
    "dropphyst": "TX",
    "dropphyzpp": 780649998,
    "dropmaladd": "122 W GOODWIN ST",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "TX",
    "dropmalzpp": 780649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302814566,
    "dropsitcph": 8305694452,
    "dropfax": 8302814566
  },
  {
    "dcode": "D",
    "dropkey": "PW25182",
    "droptype": "D",
    "dropname": "PLEDGER",
    "dropdeladd": "9463 FM 1728 RD",
    "dropdelcty": "PLEDGER",
    "dropdelst": "TX",
    "dropdelzpp": 774689802,
    "dropphyadd": "9463 FM 1728 RD",
    "dropphycty": "PLEDGER",
    "dropphyst": "TX",
    "dropphyzpp": 774689802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEDGER",
    "dropmalst": "TX",
    "dropmalzpp": 774689998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796572605,
    "dropsitcph": 9796572605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25184",
    "droptype": "D",
    "dropname": "PLUM",
    "dropdeladd": "240 PLUM CHURCH RD",
    "dropdelcty": "PLUM",
    "dropdelst": "TX",
    "dropdelzpp": 789529800,
    "dropphyadd": "240 PLUM CHURCH RD",
    "dropphycty": "PLUM",
    "dropphyst": "TX",
    "dropphyzpp": 789529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLUM",
    "dropmalst": "TX",
    "dropmalzpp": 789529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792423409,
    "dropsitcph": 9792423409,
    "dropfax": 9792423409
  },
  {
    "dcode": "D",
    "dropkey": "PW25188",
    "droptype": "D",
    "dropname": "POINT",
    "dropdeladd": "281 AVENUE C",
    "dropdelcty": "POINT",
    "dropdelst": "TX",
    "dropdelzpp": 754729998,
    "dropphyadd": "281 AVENUE C",
    "dropphycty": "POINT",
    "dropphyst": "TX",
    "dropphyzpp": 754729998,
    "dropmaladd": "281 AVENUE C",
    "dropmalcty": "POINT",
    "dropmalst": "TX",
    "dropmalzpp": 754729998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035983117,
    "dropsitcph": 9035983117,
    "dropfax": 9035982832
  },
  {
    "dcode": "D",
    "dropkey": "PW25189",
    "droptype": "D",
    "dropname": "POINT COMFORT",
    "dropdeladd": "3 LAMAR ST",
    "dropdelcty": "POINT COMFORT",
    "dropdelst": "TX",
    "dropdelzpp": 779789800,
    "dropphyadd": "3 LAMAR ST",
    "dropphycty": "POINT COMFORT",
    "dropphyst": "TX",
    "dropphyzpp": 779789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT COMFORT",
    "dropmalst": "TX",
    "dropmalzpp": 779789998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619872313,
    "dropsitcph": 3619872313,
    "dropfax": 3619872313
  },
  {
    "dcode": "D",
    "dropkey": "PW25192",
    "droptype": "D",
    "dropname": "POINTBLANK",
    "dropdeladd": "30 S COUNTS RD",
    "dropdelcty": "POINTBLANK",
    "dropdelst": "TX",
    "dropdelzpp": 773646623,
    "dropphyadd": "30 S COUNTS RD",
    "dropphycty": "POINTBLANK",
    "dropphyst": "TX",
    "dropphyzpp": 773646623,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINTBLANK",
    "dropmalst": "TX",
    "dropmalzpp": 773649998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363772369,
    "dropsitcph": 9363772369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25193",
    "droptype": "D",
    "dropname": "POLLOK",
    "dropdeladd": "533 W STATE HIGHWAY 7",
    "dropdelcty": "POLLOK",
    "dropdelst": "TX",
    "dropdelzpp": 759699998,
    "dropphyadd": "533 W STATE HIGHWAY 7",
    "dropphycty": "POLLOK",
    "dropphyst": "TX",
    "dropphyzpp": 759699998,
    "dropmaladd": "533 W STATE HIGHWAY 7",
    "dropmalcty": "POLLOK",
    "dropmalst": "TX",
    "dropmalzpp": 759699998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368532581,
    "dropsitcph": 9368532581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25195",
    "droptype": "D",
    "dropname": "PONDER",
    "dropdeladd": "201 W BAILEY ST",
    "dropdelcty": "PONDER",
    "dropdelst": "TX",
    "dropdelzpp": 762599998,
    "dropphyadd": "201 W BAILEY ST",
    "dropphycty": "PONDER",
    "dropphyst": "TX",
    "dropphyzpp": 762599998,
    "dropmaladd": "201 W BAILEY ST",
    "dropmalcty": "PONDER",
    "dropmalst": "TX",
    "dropmalzpp": 762599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404792643,
    "dropsitcph": 9404792643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25198",
    "droptype": "D",
    "dropname": "PONTOTOC",
    "dropdeladd": "17658 COLLEGE ST",
    "dropdelcty": "PONTOTOC",
    "dropdelst": "TX",
    "dropdelzpp": 768699814,
    "dropphyadd": "17658 COLLEGE ST",
    "dropphycty": "PONTOTOC",
    "dropphyst": "TX",
    "dropphyzpp": 768699814,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PONTOTOC",
    "dropmalst": "TX",
    "dropmalzpp": 768699998,
    "dropsitphn": 3252516667,
    "dropsitlph": 3252516667,
    "dropsitcph": 3252516667,
    "dropfax": 3252516695
  },
  {
    "dcode": "D",
    "dropkey": "PW25200",
    "droptype": "D",
    "dropname": "POOLVILLE",
    "dropdeladd": "104 WEST AVE",
    "dropdelcty": "POOLVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 764879998,
    "dropphyadd": "104 WEST AVE",
    "dropphycty": "POOLVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 764879998,
    "dropmaladd": "104 WEST AVE",
    "dropmalcty": "POOLVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 764879998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173419900,
    "dropsitcph": 8173419900,
    "dropfax": 8175990839
  },
  {
    "dcode": "D",
    "dropkey": "PW25204",
    "droptype": "D",
    "dropname": "PORT ARANSAS",
    "dropdeladd": "1211 STATE HIGHWAY 361",
    "dropdelcty": "PORT ARANSAS",
    "dropdelst": "TX",
    "dropdelzpp": 783739998,
    "dropphyadd": "1211 STATE HIGHWAY 361",
    "dropphycty": "PORT ARANSAS",
    "dropphyst": "TX",
    "dropphyzpp": 783739998,
    "dropmaladd": "1211 STATE HIGHWAY 361",
    "dropmalcty": "PORT ARANSAS",
    "dropmalst": "TX",
    "dropmalzpp": 783739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617495590,
    "dropsitcph": 3617495590,
    "dropfax": 3617493114
  },
  {
    "dcode": "D",
    "dropkey": "PW25205",
    "droptype": "D",
    "dropname": "PORT ARTHUR",
    "dropdeladd": "345 LAKESHORE DR",
    "dropdelcty": "PORT ARTHUR",
    "dropdelst": "TX",
    "dropdelzpp": 776409998,
    "dropphyadd": "345 LAKESHORE DR",
    "dropphycty": "PORT ARTHUR",
    "dropphyst": "TX",
    "dropphyzpp": 776409998,
    "dropmaladd": "345 LAKESHORE DR",
    "dropmalcty": "PORT ARTHUR",
    "dropmalst": "TX",
    "dropmalzpp": 776409998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099835483,
    "dropsitcph": 4099833423,
    "dropfax": 4099828777
  },
  {
    "dcode": "D",
    "dropkey": "PW25206",
    "droptype": "D",
    "dropname": "PORT BOLIVAR",
    "dropdeladd": "2500 BROADWAY AVE",
    "dropdelcty": "PORT BOLIVAR",
    "dropdelst": "TX",
    "dropdelzpp": 776500736,
    "dropphyadd": "2500 BROADWAY AVE",
    "dropphycty": "PORT BOLIVAR",
    "dropphyst": "TX",
    "dropphyzpp": 776500736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT BOLIVAR",
    "dropmalst": "TX",
    "dropmalzpp": 776509998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4096841075,
    "dropsitcph": 4096841075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25207",
    "droptype": "D",
    "dropname": "PORT ISABEL",
    "dropdeladd": "103 N MANAUTOU ST",
    "dropdelcty": "PORT ISABEL",
    "dropdelst": "TX",
    "dropdelzpp": 785789998,
    "dropphyadd": "103 N MANAUTOU ST",
    "dropphycty": "PORT ISABEL",
    "dropphyst": "TX",
    "dropphyzpp": 785789998,
    "dropmaladd": "103 N MANAUTOU ST",
    "dropmalcty": "PORT ISABEL",
    "dropmalst": "TX",
    "dropmalzpp": 785789998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569432212,
    "dropsitcph": 9569432212,
    "dropfax": 9569432640
  },
  {
    "dcode": "D",
    "dropkey": "PW25208",
    "droptype": "D",
    "dropname": "PORT LAVACA",
    "dropdeladd": "1201 HALF LEAGUE RD",
    "dropdelcty": "PORT LAVACA",
    "dropdelst": "TX",
    "dropdelzpp": 779799998,
    "dropphyadd": "1201 HALF LEAGUE RD",
    "dropphycty": "PORT LAVACA",
    "dropphyst": "TX",
    "dropphyzpp": 779799998,
    "dropmaladd": "1201 HALF LEAGUE RD",
    "dropmalcty": "PORT LAVACA",
    "dropmalst": "TX",
    "dropmalzpp": 779799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615523646,
    "dropsitcph": 3615523646,
    "dropfax": 3615521178
  },
  {
    "dcode": "D",
    "dropkey": "PW25211",
    "droptype": "D",
    "dropname": "PORT NECHES",
    "dropdeladd": "1324 PORT NECHES AVE",
    "dropdelcty": "PORT NECHES",
    "dropdelst": "TX",
    "dropdelzpp": 776519998,
    "dropphyadd": "1324 PORT NECHES AVE",
    "dropphycty": "PORT NECHES",
    "dropphyst": "TX",
    "dropphyzpp": 776519998,
    "dropmaladd": "1324 PORT NECHES AVE",
    "dropmalcty": "PORT NECHES",
    "dropmalst": "TX",
    "dropmalzpp": 776519998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097298894,
    "dropsitcph": 4097298894,
    "dropfax": 4097277651
  },
  {
    "dcode": "D",
    "dropkey": "PW25212",
    "droptype": "D",
    "dropname": "PORT O CONNOR",
    "dropdeladd": "611 W ADAMS ST",
    "dropdelcty": "PORT O CONNOR",
    "dropdelst": "TX",
    "dropdelzpp": 779829800,
    "dropphyadd": "611 W ADAMS ST",
    "dropphycty": "PORT O CONNOR",
    "dropphyst": "TX",
    "dropphyzpp": 779829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT O CONNOR",
    "dropmalst": "TX",
    "dropmalzpp": 779829998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619834377,
    "dropsitcph": 3619834377,
    "dropfax": 3619833013
  },
  {
    "dcode": "D",
    "dropkey": "PW25215",
    "droptype": "D",
    "dropname": "PORTER",
    "dropdeladd": "23550 PARTNERS WAY",
    "dropdelcty": "PORTER",
    "dropdelst": "TX",
    "dropdelzpp": 773659998,
    "dropphyadd": "23550 PARTNERS WAY",
    "dropphycty": "PORTER",
    "dropphyst": "TX",
    "dropphyzpp": 773659998,
    "dropmaladd": "23550 PARTNERS WAY",
    "dropmalcty": "PORTER",
    "dropmalst": "TX",
    "dropmalzpp": 773659998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263055,
    "dropsitcph": 2813541114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25217",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "120 LANG RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "TX",
    "dropdelzpp": 783742626,
    "dropphyadd": "120 LANG RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "TX",
    "dropphyzpp": 783742626,
    "dropmaladd": "120 LANG RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "TX",
    "dropmalzpp": 783742626,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617770844,
    "dropsitcph": 3617770845,
    "dropfax": 3616430839
  },
  {
    "dcode": "D",
    "dropkey": "PW25219",
    "droptype": "D",
    "dropname": "POST",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "POST",
    "dropdelst": "TX",
    "dropdelzpp": 793569998,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "POST",
    "dropphyst": "TX",
    "dropphyzpp": 793569998,
    "dropmaladd": "202 W MAIN ST",
    "dropmalcty": "POST",
    "dropmalst": "TX",
    "dropmalzpp": 793569998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064952330,
    "dropsitcph": 8064952330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25222",
    "droptype": "D",
    "dropname": "POTEET",
    "dropdeladd": "420 AVENUE I",
    "dropdelcty": "POTEET",
    "dropdelst": "TX",
    "dropdelzpp": 780659998,
    "dropphyadd": "420 AVENUE I",
    "dropphycty": "POTEET",
    "dropphyst": "TX",
    "dropphyzpp": 780659998,
    "dropmaladd": "420 AVENUE I",
    "dropmalcty": "POTEET",
    "dropmalst": "TX",
    "dropmalzpp": 780659998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307424004,
    "dropsitcph": 8307424004,
    "dropfax": 8307423353
  },
  {
    "dcode": "D",
    "dropkey": "PW25223",
    "droptype": "D",
    "dropname": "POTH",
    "dropdeladd": "1100 STORTS",
    "dropdelcty": "POTH",
    "dropdelst": "TX",
    "dropdelzpp": 781479800,
    "dropphyadd": "1100 STORTS",
    "dropphycty": "POTH",
    "dropphyst": "TX",
    "dropphyzpp": 781479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTH",
    "dropmalst": "TX",
    "dropmalzpp": 781479998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304844187,
    "dropsitcph": 8304844212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25225",
    "droptype": "D",
    "dropname": "POTTSBORO",
    "dropdeladd": "509 W FM 120",
    "dropdelcty": "POTTSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 750762600,
    "dropphyadd": "509 W FM 120",
    "dropphycty": "POTTSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 750762600,
    "dropmaladd": "509 W FM 120",
    "dropmalcty": "POTTSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 750762600,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037862522,
    "dropsitcph": 9037862522,
    "dropfax": 9037862938
  },
  {
    "dcode": "D",
    "dropkey": "PW25229",
    "droptype": "D",
    "dropname": "POWDERLY",
    "dropdeladd": "8500 US HIGHWAY 271 N",
    "dropdelcty": "POWDERLY",
    "dropdelst": "TX",
    "dropdelzpp": 754739998,
    "dropphyadd": "8500 US HIGHWAY 271 N",
    "dropphycty": "POWDERLY",
    "dropphyst": "TX",
    "dropphyzpp": 754739998,
    "dropmaladd": "8500 US HIGHWAY 271 N",
    "dropmalcty": "POWDERLY",
    "dropmalst": "TX",
    "dropmalzpp": 754739998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037323410,
    "dropsitcph": 9037323410,
    "dropfax": 9037324780
  },
  {
    "dcode": "D",
    "dropkey": "PW25230",
    "droptype": "D",
    "dropname": "POWELL",
    "dropdeladd": "101 BROOKSHIRE ST",
    "dropdelcty": "POWELL",
    "dropdelst": "TX",
    "dropdelzpp": 751538883,
    "dropphyadd": "101 BROOKSHIRE ST",
    "dropphycty": "POWELL",
    "dropphyst": "TX",
    "dropphyzpp": 751538883,
    "dropmaladd": "101 BROOKSHIRE ST",
    "dropmalcty": "POWELL",
    "dropmalst": "TX",
    "dropmalzpp": 751538883,
    "dropsitphn": 2147604376,
    "dropsitlph": 9033457544,
    "dropsitcph": 9033457544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25232",
    "droptype": "D",
    "dropname": "POYNOR",
    "dropdeladd": "15662 US HIGHWAY 175 E",
    "dropdelcty": "POYNOR",
    "dropdelst": "TX",
    "dropdelzpp": 757829998,
    "dropphyadd": "15662 US HIGHWAY 175 E",
    "dropphycty": "POYNOR",
    "dropphyst": "TX",
    "dropphyzpp": 757829998,
    "dropmaladd": "15662 US HIGHWAY 175 E",
    "dropmalcty": "POYNOR",
    "dropmalst": "TX",
    "dropmalzpp": 757829998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038764609,
    "dropsitcph": 9038764609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25239",
    "droptype": "D",
    "dropname": "PRAIRIE HILL",
    "dropdeladd": "4874 FM 73 W",
    "dropdelcty": "PRAIRIE HILL",
    "dropdelst": "TX",
    "dropdelzpp": 766789998,
    "dropphyadd": "4874 FM 73 W",
    "dropphycty": "PRAIRIE HILL",
    "dropphyst": "TX",
    "dropphyzpp": 766789998,
    "dropmaladd": "4874 FM 73 W",
    "dropmalcty": "PRAIRIE HILL",
    "dropmalst": "TX",
    "dropmalzpp": 766789998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543442255,
    "dropsitcph": 2543442255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25241",
    "droptype": "D",
    "dropname": "PRAIRIE LEA",
    "dropdeladd": "6855 SAN MARCOS HWY",
    "dropdelcty": "PRAIRIE LEA",
    "dropdelst": "TX",
    "dropdelzpp": 786619800,
    "dropphyadd": "6855 SAN MARCOS HWY",
    "dropphycty": "PRAIRIE LEA",
    "dropphyst": "TX",
    "dropphyzpp": 786619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAIRIE LEA",
    "dropmalst": "TX",
    "dropmalzpp": 786619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124882512,
    "dropsitcph": 5124882512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25242",
    "droptype": "D",
    "dropname": "PRAIRIE VIEW",
    "dropdeladd": "21212 FM 1098 LOOP",
    "dropdelcty": "PRAIRIE VIEW",
    "dropdelst": "TX",
    "dropdelzpp": 774464100,
    "dropphyadd": "21212 FM 1098 LOOP",
    "dropphycty": "PRAIRIE VIEW",
    "dropphyst": "TX",
    "dropphyzpp": 774464100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAIRIE VIEW",
    "dropmalst": "TX",
    "dropmalzpp": 774469998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368573570,
    "dropsitcph": 9368573570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25243",
    "droptype": "D",
    "dropname": "PREMONT",
    "dropdeladd": "305 S AGNES",
    "dropdelcty": "PREMONT",
    "dropdelst": "TX",
    "dropdelzpp": 783759998,
    "dropphyadd": "305 S AGNES",
    "dropphycty": "PREMONT",
    "dropphyst": "TX",
    "dropphyzpp": 783759998,
    "dropmaladd": "305 S AGNES",
    "dropmalcty": "PREMONT",
    "dropmalst": "TX",
    "dropmalzpp": 783759998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613483823,
    "dropsitcph": 3613483823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25244",
    "droptype": "D",
    "dropname": "PRESIDIO",
    "dropdeladd": "202 E OREILLY ST",
    "dropdelcty": "PRESIDIO",
    "dropdelst": "TX",
    "dropdelzpp": 798459800,
    "dropphyadd": "202 E OREILLY ST",
    "dropphycty": "PRESIDIO",
    "dropphyst": "TX",
    "dropphyzpp": 798459800,
    "dropmaladd": "202 E OREILLY ST",
    "dropmalcty": "PRESIDIO",
    "dropmalst": "TX",
    "dropmalzpp": 798459800,
    "dropsitphn": 2103688387,
    "dropsitlph": 4322293375,
    "dropsitcph": 4322293375,
    "dropfax": 4322294582
  },
  {
    "dcode": "D",
    "dropkey": "PW25247",
    "droptype": "D",
    "dropname": "PRICE",
    "dropdeladd": "9031 FM 13",
    "dropdelcty": "PRICE",
    "dropdelst": "TX",
    "dropdelzpp": 756879800,
    "dropphyadd": "9031 FM 13",
    "dropphycty": "PRICE",
    "dropphyst": "TX",
    "dropphyzpp": 756879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRICE",
    "dropmalst": "TX",
    "dropmalzpp": 756879998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038613171,
    "dropsitcph": 9038613171,
    "dropfax": 9038610007
  },
  {
    "dcode": "D",
    "dropkey": "PW25248",
    "droptype": "D",
    "dropname": "PRIDDY",
    "dropdeladd": "13420 HIGHWAY 16 N",
    "dropdelcty": "PRIDDY",
    "dropdelst": "TX",
    "dropdelzpp": 768709865,
    "dropphyadd": "13420 HIGHWAY 16 N",
    "dropphycty": "PRIDDY",
    "dropphyst": "TX",
    "dropphyzpp": 768709865,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRIDDY",
    "dropmalst": "TX",
    "dropmalzpp": 768709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3259663570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25251",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "621 E PRINCETON DR",
    "dropdelcty": "PRINCETON",
    "dropdelst": "TX",
    "dropdelzpp": 754079998,
    "dropphyadd": "621 E PRINCETON DR",
    "dropphycty": "PRINCETON",
    "dropphyst": "TX",
    "dropphyzpp": 754079998,
    "dropmaladd": "621 E PRINCETON DR",
    "dropmalcty": "PRINCETON",
    "dropmalst": "TX",
    "dropmalzpp": 754079998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727342521,
    "dropsitcph": 9727342521,
    "dropfax": 9727362872
  },
  {
    "dcode": "D",
    "dropkey": "PW25253",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "1270 HIGHWAY 1476",
    "dropdelcty": "PROCTOR",
    "dropdelst": "TX",
    "dropdelzpp": 764689801,
    "dropphyadd": "1270 HIGHWAY 1476",
    "dropphycty": "PROCTOR",
    "dropphyst": "TX",
    "dropphyzpp": 764689801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROCTOR",
    "dropmalst": "TX",
    "dropmalzpp": 764689998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 2548792460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25254",
    "droptype": "D",
    "dropname": "PROGRESO",
    "dropdeladd": "215 E US HIGHWAY 281",
    "dropdelcty": "PROGRESO",
    "dropdelst": "TX",
    "dropdelzpp": 785799800,
    "dropphyadd": "215 E US HIGHWAY 281",
    "dropphycty": "PROGRESO",
    "dropphyst": "TX",
    "dropphyzpp": 785799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROGRESO",
    "dropmalst": "TX",
    "dropmalzpp": 785799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565653841,
    "dropsitcph": 9565653841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25256",
    "droptype": "D",
    "dropname": "PROSPER",
    "dropdeladd": "941 N COLEMAN ST",
    "dropdelcty": "PROSPER",
    "dropdelst": "TX",
    "dropdelzpp": 750782301,
    "dropphyadd": "941 N COLEMAN ST",
    "dropphycty": "PROSPER",
    "dropphyst": "TX",
    "dropphyzpp": 750782301,
    "dropmaladd": "941 N COLEMAN ST",
    "dropmalcty": "PROSPER",
    "dropmalst": "TX",
    "dropmalzpp": 750782301,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723472543,
    "dropsitcph": 9723472543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25271",
    "droptype": "D",
    "dropname": "PURDON",
    "dropdeladd": "700 S BROWN ST",
    "dropdelcty": "PURDON",
    "dropdelst": "TX",
    "dropdelzpp": 766799998,
    "dropphyadd": "700 S BROWN ST",
    "dropphycty": "PURDON",
    "dropphyst": "TX",
    "dropphyzpp": 766799998,
    "dropmaladd": "700 S BROWN ST",
    "dropmalcty": "PURDON",
    "dropmalst": "TX",
    "dropmalzpp": 766799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9036732366,
    "dropsitcph": 9036732366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25272",
    "droptype": "D",
    "dropname": "PURMELA",
    "dropdeladd": "12250 W US HIGHWAY 84",
    "dropdelcty": "PURMELA",
    "dropdelst": "TX",
    "dropdelzpp": 765669998,
    "dropphyadd": "12250 W US HIGHWAY 84",
    "dropphycty": "PURMELA",
    "dropphyst": "TX",
    "dropphyzpp": 765669998,
    "dropmaladd": "12250 W US HIGHWAY 84",
    "dropmalcty": "PURMELA",
    "dropmalst": "TX",
    "dropmalzpp": 765669998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548656517,
    "dropsitcph": 2548656517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25274",
    "droptype": "D",
    "dropname": "PUTNAM",
    "dropdeladd": "104 W TRAVIS ST",
    "dropdelcty": "PUTNAM",
    "dropdelst": "TX",
    "dropdelzpp": 764699998,
    "dropphyadd": "104 W TRAVIS ST",
    "dropphycty": "PUTNAM",
    "dropphyst": "TX",
    "dropphyzpp": 764699998,
    "dropmaladd": "104 W TRAVIS ST",
    "dropmalcty": "PUTNAM",
    "dropmalst": "TX",
    "dropmalzpp": 764699998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256623806,
    "dropsitcph": 3256623806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25275",
    "droptype": "D",
    "dropname": "PYOTE",
    "dropdeladd": "211 N ROGERS",
    "dropdelcty": "PYOTE",
    "dropdelst": "TX",
    "dropdelzpp": 797779998,
    "dropphyadd": "211 N ROGERS",
    "dropphycty": "PYOTE",
    "dropphyst": "TX",
    "dropphyzpp": 797779998,
    "dropmaladd": "211 N ROGERS",
    "dropmalcty": "PYOTE",
    "dropmalst": "TX",
    "dropmalzpp": 797779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323895621,
    "dropfax": 4323895621
  },
  {
    "dcode": "D",
    "dropkey": "PW25278",
    "droptype": "D",
    "dropname": "QUANAH",
    "dropdeladd": "219 W 3RD ST",
    "dropdelcty": "QUANAH",
    "dropdelst": "TX",
    "dropdelzpp": 792529998,
    "dropphyadd": "219 W 3RD ST",
    "dropphycty": "QUANAH",
    "dropphyst": "TX",
    "dropphyzpp": 792529998,
    "dropmaladd": "219 W 3RD ST",
    "dropmalcty": "QUANAH",
    "dropmalst": "TX",
    "dropmalzpp": 792529998,
    "dropsitphn": 8173173709,
    "dropsitlph": 9406632221,
    "dropsitcph": 9406632221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25279",
    "droptype": "D",
    "dropname": "QUEEN CITY",
    "dropdeladd": "1014 HOUSTON ST",
    "dropdelcty": "QUEEN CITY",
    "dropdelst": "TX",
    "dropdelzpp": 755729998,
    "dropphyadd": "1014 HOUSTON ST",
    "dropphycty": "QUEEN CITY",
    "dropphyst": "TX",
    "dropphyzpp": 755729998,
    "dropmaladd": "1014 HOUSTON ST",
    "dropmalcty": "QUEEN CITY",
    "dropmalst": "TX",
    "dropmalzpp": 755729998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037967246,
    "dropsitcph": 9037967246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25280",
    "droptype": "D",
    "dropname": "QUEMADO",
    "dropdeladd": "20001 N HIGHWAY 277",
    "dropdelcty": "QUEMADO",
    "dropdelst": "TX",
    "dropdelzpp": 788779998,
    "dropphyadd": "20001 N HIGHWAY 277",
    "dropphycty": "QUEMADO",
    "dropphyst": "TX",
    "dropphyzpp": 788779998,
    "dropmaladd": "20001 N HIGHWAY 277",
    "dropmalcty": "QUEMADO",
    "dropmalst": "TX",
    "dropmalzpp": 788779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307571326,
    "dropsitcph": 8307571326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25281",
    "droptype": "D",
    "dropname": "QUINLAN",
    "dropdeladd": "8570 STATE HIGHWAY 34 S",
    "dropdelcty": "QUINLAN",
    "dropdelst": "TX",
    "dropdelzpp": 754749998,
    "dropphyadd": "8570 STATE HIGHWAY 34 S",
    "dropphycty": "QUINLAN",
    "dropphyst": "TX",
    "dropphyzpp": 754749998,
    "dropmaladd": "8570 STATE HIGHWAY 34 S",
    "dropmalcty": "QUINLAN",
    "dropmalst": "TX",
    "dropmalzpp": 754749998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033562122,
    "dropsitcph": 9033562122,
    "dropfax": 9033564476
  },
  {
    "dcode": "D",
    "dropkey": "PW25283",
    "droptype": "D",
    "dropname": "QUITAQUE",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "QUITAQUE",
    "dropdelst": "TX",
    "dropdelzpp": 792559803,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "QUITAQUE",
    "dropphyst": "TX",
    "dropphyzpp": 792559803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUITAQUE",
    "dropmalst": "TX",
    "dropmalzpp": 792559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064551205,
    "dropsitcph": 8064551205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25284",
    "droptype": "D",
    "dropname": "QUITMAN",
    "dropdeladd": "202 N SISSY SPACEK DR",
    "dropdelcty": "QUITMAN",
    "dropdelst": "TX",
    "dropdelzpp": 757839998,
    "dropphyadd": "202 N SISSY SPACEK DR",
    "dropphycty": "QUITMAN",
    "dropphyst": "TX",
    "dropphyzpp": 757839998,
    "dropmaladd": "202 N SISSY SPACEK DR",
    "dropmalcty": "QUITMAN",
    "dropmalst": "TX",
    "dropmalzpp": 757839998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037632247,
    "dropsitcph": 9037632247,
    "dropfax": 9037631800
  },
  {
    "dcode": "D",
    "dropkey": "PW25291",
    "droptype": "D",
    "dropname": "RAINBOW",
    "dropdeladd": "1683 N FM 200",
    "dropdelcty": "RAINBOW",
    "dropdelst": "TX",
    "dropdelzpp": 760779998,
    "dropphyadd": "1683 N FM 200",
    "dropphycty": "RAINBOW",
    "dropphyst": "TX",
    "dropphyzpp": 760779998,
    "dropmaladd": "1683 N FM 200",
    "dropmalcty": "RAINBOW",
    "dropmalst": "TX",
    "dropmalzpp": 760779998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548977851,
    "dropsitcph": 2548977851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25293",
    "droptype": "D",
    "dropname": "RALLS",
    "dropdeladd": "620 TILFORD AVE",
    "dropdelcty": "RALLS",
    "dropdelst": "TX",
    "dropdelzpp": 793579803,
    "dropphyadd": "620 TILFORD AVE",
    "dropphycty": "RALLS",
    "dropphyst": "TX",
    "dropphyzpp": 793579803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RALLS",
    "dropmalst": "TX",
    "dropmalzpp": 793579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062532014,
    "dropsitcph": 8062532014,
    "dropfax": 8062533024
  },
  {
    "dcode": "D",
    "dropkey": "PW25299",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "100 NW STATE HIGHWAY 11",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "TX",
    "dropdelzpp": 754759998,
    "dropphyadd": "100 NW STATE HIGHWAY 11",
    "dropphycty": "RANDOLPH",
    "dropphyst": "TX",
    "dropphyzpp": 754759998,
    "dropmaladd": "100 NW STATE HIGHWAY 11",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "TX",
    "dropmalzpp": 754759998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035835156,
    "dropsitcph": 9035835156,
    "dropfax": 9035830465
  },
  {
    "dcode": "D",
    "dropkey": "PW25302",
    "droptype": "D",
    "dropname": "RANGER",
    "dropdeladd": "202 N AUSTIN ST",
    "dropdelcty": "RANGER",
    "dropdelst": "TX",
    "dropdelzpp": 764709998,
    "dropphyadd": "202 N AUSTIN ST",
    "dropphycty": "RANGER",
    "dropphyst": "TX",
    "dropphyzpp": 764709998,
    "dropmaladd": "202 N AUSTIN ST",
    "dropmalcty": "RANGER",
    "dropmalst": "TX",
    "dropmalzpp": 764709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546471175,
    "dropsitcph": 2546471175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25304",
    "droptype": "D",
    "dropname": "RANKIN",
    "dropdeladd": "819 S GRAND ST",
    "dropdelcty": "RANKIN",
    "dropdelst": "TX",
    "dropdelzpp": 797789998,
    "dropphyadd": "819 S GRAND ST",
    "dropphycty": "RANKIN",
    "dropphyst": "TX",
    "dropphyzpp": 797789998,
    "dropmaladd": "819 S GRAND ST",
    "dropmalcty": "RANKIN",
    "dropmalst": "TX",
    "dropmalzpp": 797789998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326932214,
    "dropsitcph": 4326932214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25306",
    "droptype": "D",
    "dropname": "RATCLIFF",
    "dropdeladd": "100 STATE HIGHWAY 7",
    "dropdelcty": "RATCLIFF",
    "dropdelst": "TX",
    "dropdelzpp": 758589998,
    "dropphyadd": "100 STATE HIGHWAY 7",
    "dropphycty": "RATCLIFF",
    "dropphyst": "TX",
    "dropphyzpp": 758589998,
    "dropmaladd": "100 STATE HIGHWAY 7",
    "dropmalcty": "RATCLIFF",
    "dropmalst": "TX",
    "dropmalzpp": 758589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366552460,
    "dropsitcph": 9366552460,
    "dropfax": 9366552460
  },
  {
    "dcode": "D",
    "dropkey": "PW25309",
    "droptype": "D",
    "dropname": "RAVENNA",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "RAVENNA",
    "dropdelst": "TX",
    "dropdelzpp": 754769998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "RAVENNA",
    "dropphyst": "TX",
    "dropphyzpp": 754769998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "RAVENNA",
    "dropmalst": "TX",
    "dropmalzpp": 754769998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035832033,
    "dropsitcph": 9035832033,
    "dropfax": 9035835808
  },
  {
    "dcode": "D",
    "dropkey": "PW25312",
    "droptype": "D",
    "dropname": "RAYMONDVILLE",
    "dropdeladd": "705 E HIDALGO AVE",
    "dropdelcty": "RAYMONDVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 785809998,
    "dropphyadd": "705 E HIDALGO AVE",
    "dropphycty": "RAYMONDVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 785809998,
    "dropmaladd": "705 E HIDALGO AVE",
    "dropmalcty": "RAYMONDVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 785809998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9566892636,
    "dropsitcph": 9566892636,
    "dropfax": 9566892835
  },
  {
    "dcode": "D",
    "dropkey": "PW25314",
    "droptype": "D",
    "dropname": "RAYWOOD",
    "dropdeladd": "13615 HIGHWAY 90 E",
    "dropdelcty": "RAYWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 775829800,
    "dropphyadd": "13615 HIGHWAY 90 E",
    "dropphycty": "RAYWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 775829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 775829998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365874633,
    "dropsitcph": 9365874633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25316",
    "droptype": "D",
    "dropname": "REAGAN",
    "dropdeladd": "3700 FM 413",
    "dropdelcty": "REAGAN",
    "dropdelst": "TX",
    "dropdelzpp": 766809998,
    "dropphyadd": "3700 FM 413",
    "dropphycty": "REAGAN",
    "dropphyst": "TX",
    "dropphyzpp": 766809998,
    "dropmaladd": "3700 FM 413",
    "dropmalcty": "REAGAN",
    "dropmalst": "TX",
    "dropmalzpp": 766809998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8175872454,
    "dropsitcph": 8175872454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25317",
    "droptype": "D",
    "dropname": "REALITOS",
    "dropdeladd": "6417 HIGHWAY 359",
    "dropdelcty": "REALITOS",
    "dropdelst": "TX",
    "dropdelzpp": 783769998,
    "dropphyadd": "6417 HIGHWAY 359",
    "dropphycty": "REALITOS",
    "dropphyst": "TX",
    "dropphyzpp": 783769998,
    "dropmaladd": "6417 HIGHWAY 359",
    "dropmalcty": "REALITOS",
    "dropmalst": "TX",
    "dropmalzpp": 783769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615275125,
    "dropsitcph": 3615275125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25323",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "104 E OVILLA RD",
    "dropdelcty": "RED OAK",
    "dropdelst": "TX",
    "dropdelzpp": 751549998,
    "dropphyadd": "104 E OVILLA RD",
    "dropphycty": "RED OAK",
    "dropphyst": "TX",
    "dropphyzpp": 751549998,
    "dropmaladd": "104 E OVILLA RD",
    "dropmalcty": "RED OAK",
    "dropmalst": "TX",
    "dropmalzpp": 751549998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726179943,
    "dropsitcph": 9726179943,
    "dropfax": 9726178055
  },
  {
    "dcode": "D",
    "dropkey": "PW25326",
    "droptype": "D",
    "dropname": "RED ROCK",
    "dropdeladd": "105 LENTZ MAIN ST",
    "dropdelcty": "RED ROCK",
    "dropdelst": "TX",
    "dropdelzpp": 786629998,
    "dropphyadd": "105 LENTZ MAIN ST",
    "dropphycty": "RED ROCK",
    "dropphyst": "TX",
    "dropphyzpp": 786629998,
    "dropmaladd": "105 LENTZ MAIN ST",
    "dropmalcty": "RED ROCK",
    "dropmalst": "TX",
    "dropmalzpp": 786629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123213096,
    "dropsitcph": 5123213096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25340",
    "droptype": "D",
    "dropname": "REDWATER",
    "dropdeladd": "115 REDWATER BLVD W",
    "dropdelcty": "REDWATER",
    "dropdelst": "TX",
    "dropdelzpp": 755739998,
    "dropphyadd": "115 REDWATER BLVD W",
    "dropphycty": "REDWATER",
    "dropphyst": "TX",
    "dropphyzpp": 755739998,
    "dropmaladd": "115 REDWATER BLVD W",
    "dropmalcty": "REDWATER",
    "dropmalst": "TX",
    "dropmalzpp": 755739998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036712519,
    "dropsitcph": 9036712519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25345",
    "droptype": "D",
    "dropname": "REFUGIO",
    "dropdeladd": "507 OSAGE ST",
    "dropdelcty": "REFUGIO",
    "dropdelst": "TX",
    "dropdelzpp": 783779998,
    "dropphyadd": "507 OSAGE ST",
    "dropphycty": "REFUGIO",
    "dropphyst": "TX",
    "dropphyzpp": 783779998,
    "dropmaladd": "507 OSAGE ST",
    "dropmalcty": "REFUGIO",
    "dropmalst": "TX",
    "dropmalzpp": 783779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615264024,
    "dropsitcph": 3615264024,
    "dropfax": 3615264996
  },
  {
    "dcode": "D",
    "dropkey": "PW25347",
    "droptype": "D",
    "dropname": "REKLAW",
    "dropdeladd": "320 N MAIN ST",
    "dropdelcty": "REKLAW",
    "dropdelst": "TX",
    "dropdelzpp": 757849998,
    "dropphyadd": "320 N MAIN ST",
    "dropphycty": "REKLAW",
    "dropphyst": "TX",
    "dropphyzpp": 757849998,
    "dropmaladd": "320 N MAIN ST",
    "dropmalcty": "REKLAW",
    "dropmalst": "TX",
    "dropmalzpp": 757849998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9363694312,
    "dropsitcph": 9363694312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25354",
    "droptype": "D",
    "dropname": "RHOME",
    "dropdeladd": "500 S MAIN ST",
    "dropdelcty": "RHOME",
    "dropdelst": "TX",
    "dropdelzpp": 760789998,
    "dropphyadd": "500 S MAIN ST",
    "dropphycty": "RHOME",
    "dropphyst": "TX",
    "dropphyzpp": 760789998,
    "dropmaladd": "500 S MAIN ST",
    "dropmalcty": "RHOME",
    "dropmalst": "TX",
    "dropmalzpp": 760789998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176362287,
    "dropsitcph": 8176362287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25357",
    "droptype": "D",
    "dropname": "RICE",
    "dropdeladd": "300 E CALHOUN ST",
    "dropdelcty": "RICE",
    "dropdelst": "TX",
    "dropdelzpp": 751559705,
    "dropphyadd": "300 E CALHOUN ST",
    "dropphycty": "RICE",
    "dropphyst": "TX",
    "dropphyzpp": 751559705,
    "dropmaladd": "300 E CALHOUN ST",
    "dropmalcty": "RICE",
    "dropmalst": "TX",
    "dropmalzpp": 751559705,
    "dropsitphn": 2147604376,
    "dropsitlph": 9033265441,
    "dropsitcph": 9033265441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25360",
    "droptype": "D",
    "dropname": "RICHARDS",
    "dropdeladd": "11002 FM 149",
    "dropdelcty": "RICHARDS",
    "dropdelst": "TX",
    "dropdelzpp": 778732742,
    "dropphyadd": "11002 FM 149",
    "dropphycty": "RICHARDS",
    "dropphyst": "TX",
    "dropphyzpp": 778732742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHARDS",
    "dropmalst": "TX",
    "dropmalzpp": 778739998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368512387,
    "dropsitcph": 9368519105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25361",
    "droptype": "D",
    "dropname": "RICHARDSON",
    "dropdeladd": "433 BELLE GROVE DR",
    "dropdelcty": "RICHARDSON",
    "dropdelst": "TX",
    "dropdelzpp": 750809998,
    "dropphyadd": "433 BELLE GROVE DR",
    "dropphycty": "RICHARDSON",
    "dropphyst": "TX",
    "dropphyzpp": 750809998,
    "dropmaladd": "433 BELLE GROVE DR",
    "dropmalcty": "RICHARDSON",
    "dropmalst": "TX",
    "dropmalzpp": 750809998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722354695,
    "dropsitcph": 9722354695,
    "dropfax": 9726448521
  },
  {
    "dcode": "D",
    "dropkey": "PW25364",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "TX",
    "dropdelzpp": 766819998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "TX",
    "dropphyzpp": 766819998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "TX",
    "dropmalzpp": 766819998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9033623273,
    "dropsitcph": 9033623273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25366",
    "droptype": "D",
    "dropname": "RICHLAND SPRINGS",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "RICHLAND SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 768719802,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "RICHLAND SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 768719802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHLAND SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 768719998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254523232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25368",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "5560 FM 1640 RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "TX",
    "dropdelzpp": 774699998,
    "dropphyadd": "5560 FM 1640 RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "TX",
    "dropphyzpp": 774699998,
    "dropmaladd": "5560 FM 1640 RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "TX",
    "dropmalzpp": 774699998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813410445,
    "dropsitcph": 2816330386,
    "dropfax": 2812397316
  },
  {
    "dcode": "D",
    "dropkey": "PW25371",
    "droptype": "D",
    "dropname": "RIESEL",
    "dropdeladd": "202 E ALEXANDER ST",
    "dropdelcty": "RIESEL",
    "dropdelst": "TX",
    "dropdelzpp": 766829998,
    "dropphyadd": "202 E ALEXANDER ST",
    "dropphycty": "RIESEL",
    "dropphyst": "TX",
    "dropphyzpp": 766829998,
    "dropmaladd": "202 E ALEXANDER ST",
    "dropmalcty": "RIESEL",
    "dropmalst": "TX",
    "dropmalzpp": 766829998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2542181382,
    "dropsitcph": 2542181382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25375",
    "droptype": "D",
    "dropname": "RIO FRIO",
    "dropdeladd": "5615 RANCH ROAD 1120",
    "dropdelcty": "RIO FRIO",
    "dropdelst": "TX",
    "dropdelzpp": 788799998,
    "dropphyadd": "5615 RANCH ROAD 1120",
    "dropphycty": "RIO FRIO",
    "dropphyst": "TX",
    "dropphyzpp": 788799998,
    "dropmaladd": "5615 RANCH ROAD 1120",
    "dropmalcty": "RIO FRIO",
    "dropmalst": "TX",
    "dropmalzpp": 788799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302325262,
    "dropsitcph": 8302325262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25377",
    "droptype": "D",
    "dropname": "RIO GRANDE CITY",
    "dropdeladd": "100 W EISENHOWER ST",
    "dropdelcty": "RIO GRANDE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 785822547,
    "dropphyadd": "100 W EISENHOWER ST",
    "dropphycty": "RIO GRANDE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 785822547,
    "dropmaladd": "100 W EISENHOWER ST",
    "dropmalcty": "RIO GRANDE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 785822547,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564873315,
    "dropsitcph": 9564873315,
    "dropfax": 9564870809
  },
  {
    "dcode": "D",
    "dropkey": "PW25378",
    "droptype": "D",
    "dropname": "RIO HONDO",
    "dropdeladd": "109 E COLORADO ST",
    "dropdelcty": "RIO HONDO",
    "dropdelst": "TX",
    "dropdelzpp": 785839998,
    "dropphyadd": "109 E COLORADO ST",
    "dropphycty": "RIO HONDO",
    "dropphyst": "TX",
    "dropphyzpp": 785839998,
    "dropmaladd": "109 E COLORADO ST",
    "dropmalcty": "RIO HONDO",
    "dropmalst": "TX",
    "dropmalzpp": 785839998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567482545,
    "dropsitcph": 9567482545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25380",
    "droptype": "D",
    "dropname": "RIO VISTA",
    "dropdeladd": "205 HIGHWAY 174 S",
    "dropdelcty": "RIO VISTA",
    "dropdelst": "TX",
    "dropdelzpp": 760939998,
    "dropphyadd": "205 HIGHWAY 174 S",
    "dropphycty": "RIO VISTA",
    "dropphyst": "TX",
    "dropphyzpp": 760939998,
    "dropmaladd": "205 HIGHWAY 174 S",
    "dropmalcty": "RIO VISTA",
    "dropmalst": "TX",
    "dropmalzpp": 760939998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173732279,
    "dropsitcph": 8173732279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25381",
    "droptype": "D",
    "dropname": "RIO MEDINA",
    "dropdeladd": "3980 FM 471 N",
    "dropdelcty": "RIO MEDINA",
    "dropdelst": "TX",
    "dropdelzpp": 780669998,
    "dropphyadd": "3980 FM 471 N",
    "dropphycty": "RIO MEDINA",
    "dropphyst": "TX",
    "dropphyzpp": 780669998,
    "dropmaladd": "3980 FM 471 N",
    "dropmalcty": "RIO MEDINA",
    "dropmalst": "TX",
    "dropmalzpp": 780669998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305382562,
    "dropsitcph": 8305382562,
    "dropfax": 8305389349
  },
  {
    "dcode": "D",
    "dropkey": "PW25383",
    "droptype": "D",
    "dropname": "RISING STAR",
    "dropdeladd": "124 N MAIN ST",
    "dropdelcty": "RISING STAR",
    "dropdelst": "TX",
    "dropdelzpp": 764719803,
    "dropphyadd": "124 N MAIN ST",
    "dropphycty": "RISING STAR",
    "dropphyst": "TX",
    "dropphyzpp": 764719803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RISING STAR",
    "dropmalst": "TX",
    "dropmalzpp": 764719998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546432191,
    "dropsitcph": 2546432191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25388",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "3782B HIGHWAY 19",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "TX",
    "dropdelzpp": 773679800,
    "dropphyadd": "3782B HIGHWAY 19",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "TX",
    "dropphyzpp": 773679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "TX",
    "dropmalzpp": 773679998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365945890,
    "dropsitcph": 9365945890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25389",
    "droptype": "D",
    "dropname": "RIVIERA",
    "dropdeladd": "120 S 7TH ST",
    "dropdelcty": "RIVIERA",
    "dropdelst": "TX",
    "dropdelzpp": 783793623,
    "dropphyadd": "120 S 7TH ST",
    "dropphycty": "RIVIERA",
    "dropphyst": "TX",
    "dropphyzpp": 783793623,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVIERA",
    "dropmalst": "TX",
    "dropmalzpp": 783799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612963994,
    "dropsitcph": 3612963994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25391",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "516 E BYRON NELSON BLVD",
    "dropdelcty": "ROANOKE",
    "dropdelst": "TX",
    "dropdelzpp": 762629998,
    "dropphyadd": "516 E BYRON NELSON BLVD",
    "dropphycty": "ROANOKE",
    "dropphyst": "TX",
    "dropphyzpp": 762629998,
    "dropmaladd": "516 E BYRON NELSON BLVD",
    "dropmalcty": "ROANOKE",
    "dropmalst": "TX",
    "dropmalzpp": 762629998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174304285,
    "dropsitcph": 8174918215,
    "dropfax": 8174913595
  },
  {
    "dcode": "D",
    "dropkey": "PW25393",
    "droptype": "D",
    "dropname": "ROARING SPRINGS",
    "dropdeladd": "403 2ND ST",
    "dropdelcty": "ROARING SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 792569802,
    "dropphyadd": "403 2ND ST",
    "dropphycty": "ROARING SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 792569802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROARING SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 792569998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063487951,
    "dropsitcph": 8063487951,
    "dropfax": 8063487951
  },
  {
    "dcode": "D",
    "dropkey": "PW25395",
    "droptype": "D",
    "dropname": "ROBERT LEE",
    "dropdeladd": "722 HOUSTON ST",
    "dropdelcty": "ROBERT LEE",
    "dropdelst": "TX",
    "dropdelzpp": 769459804,
    "dropphyadd": "722 HOUSTON ST",
    "dropphycty": "ROBERT LEE",
    "dropphyst": "TX",
    "dropphyzpp": 769459804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBERT LEE",
    "dropmalst": "TX",
    "dropmalzpp": 769459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254532778,
    "dropsitcph": 3254532778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25399",
    "droptype": "D",
    "dropname": "ROBSTOWN",
    "dropdeladd": "313 E MAIN AVE",
    "dropdelcty": "ROBSTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 783803302,
    "dropphyadd": "313 E MAIN AVE",
    "dropphycty": "ROBSTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 783803302,
    "dropmaladd": "313 E MAIN AVE",
    "dropmalcty": "ROBSTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 783803302,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613874786,
    "dropsitcph": 3613877934,
    "dropfax": 3617671456
  },
  {
    "dcode": "D",
    "dropkey": "PW25400",
    "droptype": "D",
    "dropname": "ROBY",
    "dropdeladd": "117 E NORTH 1ST ST",
    "dropdelcty": "ROBY",
    "dropdelst": "TX",
    "dropdelzpp": 795439998,
    "dropphyadd": "117 E NORTH 1ST ST",
    "dropphycty": "ROBY",
    "dropphyst": "TX",
    "dropphyzpp": 795439998,
    "dropmaladd": "117 E NORTH 1ST ST",
    "dropmalcty": "ROBY",
    "dropmalst": "TX",
    "dropmalzpp": 795439998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257762667,
    "dropsitcph": 3257762667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25401",
    "droptype": "D",
    "dropname": "ROCHELLE",
    "dropdeladd": "5702 CREW AVE",
    "dropdelcty": "ROCHELLE",
    "dropdelst": "TX",
    "dropdelzpp": 768729802,
    "dropphyadd": "5702 CREW AVE",
    "dropphycty": "ROCHELLE",
    "dropphyst": "TX",
    "dropphyzpp": 768729802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCHELLE",
    "dropmalst": "TX",
    "dropmalzpp": 768729998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3252435280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25402",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "213 CAROTHERS ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "TX",
    "dropdelzpp": 795449998,
    "dropphyadd": "213 CAROTHERS ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "TX",
    "dropphyzpp": 795449998,
    "dropmaladd": "213 CAROTHERS ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "TX",
    "dropmalzpp": 795449998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407433214,
    "dropsitcph": 9407433214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25406",
    "droptype": "D",
    "dropname": "ROCK ISLAND",
    "dropdeladd": "2215 TUTTLE ST",
    "dropdelcty": "ROCK ISLAND",
    "dropdelst": "TX",
    "dropdelzpp": 774709800,
    "dropphyadd": "2215 TUTTLE ST",
    "dropphycty": "ROCK ISLAND",
    "dropphyst": "TX",
    "dropphyzpp": 774709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK ISLAND",
    "dropmalst": "TX",
    "dropmalzpp": 774709998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792345031,
    "dropsitcph": 9792345031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25407",
    "droptype": "D",
    "dropname": "ROCKDALE",
    "dropdeladd": "234 ACKERMAN ST",
    "dropdelcty": "ROCKDALE",
    "dropdelst": "TX",
    "dropdelzpp": 765679998,
    "dropphyadd": "234 ACKERMAN ST",
    "dropphycty": "ROCKDALE",
    "dropphyst": "TX",
    "dropphyzpp": 765679998,
    "dropmaladd": "234 ACKERMAN ST",
    "dropmalcty": "ROCKDALE",
    "dropmalst": "TX",
    "dropmalzpp": 765679998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124462071,
    "dropsitcph": 5124462071,
    "dropfax": 5124465590
  },
  {
    "dcode": "D",
    "dropkey": "PW25409",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "1550 FM 2165",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "TX",
    "dropdelzpp": 783829998,
    "dropphyadd": "1550 FM 2165",
    "dropphycty": "ROCKPORT",
    "dropphyst": "TX",
    "dropphyzpp": 783829998,
    "dropmaladd": "1550 FM 2165",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "TX",
    "dropmalzpp": 783829998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617298966,
    "dropsitcph": 3617298966,
    "dropfax": 3617296352
  },
  {
    "dcode": "D",
    "dropkey": "PW25410",
    "droptype": "D",
    "dropname": "ROCKSPRINGS",
    "dropdeladd": "102 W BANDERA ST",
    "dropdelcty": "ROCKSPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 788809998,
    "dropphyadd": "102 W BANDERA ST",
    "dropphycty": "ROCKSPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 788809998,
    "dropmaladd": "102 W BANDERA ST",
    "dropmalcty": "ROCKSPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 788809998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3253282377,
    "dropsitcph": 3253282406,
    "dropfax": 3252382378
  },
  {
    "dcode": "D",
    "dropkey": "PW25411",
    "droptype": "D",
    "dropname": "ROCKWALL",
    "dropdeladd": "609 S GOLIAD ST",
    "dropdelcty": "ROCKWALL",
    "dropdelst": "TX",
    "dropdelzpp": 750879998,
    "dropphyadd": "609 S GOLIAD ST",
    "dropphycty": "ROCKWALL",
    "dropphyst": "TX",
    "dropphyzpp": 750879998,
    "dropmaladd": "609 S GOLIAD ST",
    "dropmalcty": "ROCKWALL",
    "dropmalst": "TX",
    "dropmalzpp": 750879998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727711121,
    "dropsitcph": 9727711121,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "PW25412",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "135 POLK AVE",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 768739998,
    "dropphyadd": "135 POLK AVE",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 768739998,
    "dropmaladd": "135 POLK AVE",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 768739998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3257854461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25416",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "202 W MESQUITE AVE",
    "dropdelcty": "ROGERS",
    "dropdelst": "TX",
    "dropdelzpp": 765699998,
    "dropphyadd": "202 W MESQUITE AVE",
    "dropphycty": "ROGERS",
    "dropphyst": "TX",
    "dropphyzpp": 765699998,
    "dropmaladd": "202 W MESQUITE AVE",
    "dropmalcty": "ROGERS",
    "dropmalst": "TX",
    "dropmalzpp": 765699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546423284,
    "dropsitcph": 2546423284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25425",
    "droptype": "D",
    "dropname": "ROMA",
    "dropdeladd": "1724 E GRANT ST",
    "dropdelcty": "ROMA",
    "dropdelst": "TX",
    "dropdelzpp": 785849998,
    "dropphyadd": "1724 E GRANT ST",
    "dropphycty": "ROMA",
    "dropphyst": "TX",
    "dropphyzpp": 785849998,
    "dropmaladd": "1724 E GRANT ST",
    "dropmalcty": "ROMA",
    "dropmalst": "TX",
    "dropmalzpp": 785849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568491516,
    "dropsitcph": 9568491516,
    "dropfax": 9568471017
  },
  {
    "dcode": "D",
    "dropkey": "PW25426",
    "droptype": "D",
    "dropname": "ROMAYOR",
    "dropdeladd": "336 COUNTY ROAD 2150",
    "dropdelcty": "ROMAYOR",
    "dropdelst": "TX",
    "dropdelzpp": 773680561,
    "dropphyadd": "336 COUNTY ROAD 2150",
    "dropphycty": "ROMAYOR",
    "dropphyst": "TX",
    "dropphyzpp": 773680561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROMAYOR",
    "dropmalst": "TX",
    "dropmalzpp": 773689998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815925408,
    "dropsitcph": 2815925408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25427",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "3861 STATE LOOP 291",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "TX",
    "dropdelzpp": 768748900,
    "dropphyadd": "3861 STATE LOOP 291",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "TX",
    "dropphyzpp": 768748900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "TX",
    "dropmalzpp": 768749998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254462385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25428",
    "droptype": "D",
    "dropname": "ROPESVILLE",
    "dropdeladd": "403 TIMMONS AVE",
    "dropdelcty": "ROPESVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 793589802,
    "dropphyadd": "403 TIMMONS AVE",
    "dropphycty": "ROPESVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 793589802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROPESVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 793589998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065624481,
    "dropsitcph": 8065624481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25429",
    "droptype": "D",
    "dropname": "ROSANKY",
    "dropdeladd": "2024 FM 535",
    "dropdelcty": "ROSANKY",
    "dropdelst": "TX",
    "dropdelzpp": 789539998,
    "dropphyadd": "2024 FM 535",
    "dropphycty": "ROSANKY",
    "dropphyst": "TX",
    "dropphyzpp": 789539998,
    "dropmaladd": "2024 FM 535",
    "dropmalcty": "ROSANKY",
    "dropmalst": "TX",
    "dropmalzpp": 789539998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122372914,
    "dropsitcph": 5122372914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25430",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "TX",
    "dropdelzpp": 795459998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "TX",
    "dropphyzpp": 795459998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "TX",
    "dropmalzpp": 795459998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257663470,
    "dropsitcph": 3257663470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25433",
    "droptype": "D",
    "dropname": "ROSEBUD",
    "dropdeladd": "206 N 5TH ST",
    "dropdelcty": "ROSEBUD",
    "dropdelst": "TX",
    "dropdelzpp": 765709998,
    "dropphyadd": "206 N 5TH ST",
    "dropphycty": "ROSEBUD",
    "dropphyst": "TX",
    "dropphyzpp": 765709998,
    "dropmaladd": "206 N 5TH ST",
    "dropmalcty": "ROSEBUD",
    "dropmalst": "TX",
    "dropmalzpp": 765709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2542390062,
    "dropsitcph": 2542390062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25435",
    "droptype": "D",
    "dropname": "ROSENBERG",
    "dropdeladd": "2103 AVENUE G",
    "dropdelcty": "ROSENBERG",
    "dropdelst": "TX",
    "dropdelzpp": 774719998,
    "dropphyadd": "2103 AVENUE G",
    "dropphycty": "ROSENBERG",
    "dropphyst": "TX",
    "dropphyzpp": 774719998,
    "dropmaladd": "2103 AVENUE G",
    "dropmalcty": "ROSENBERG",
    "dropmalst": "TX",
    "dropmalzpp": 774719998,
    "dropsitphn": 8325867004,
    "dropsitlph": 8325867373,
    "dropsitcph": 2813423388,
    "dropfax": 2812398789
  },
  {
    "dcode": "D",
    "dropkey": "PW25439",
    "droptype": "D",
    "dropname": "ROSHARON",
    "dropdeladd": "1810 E FM 1462 RD",
    "dropdelcty": "ROSHARON",
    "dropdelst": "TX",
    "dropdelzpp": 775839998,
    "dropphyadd": "1810 E FM 1462 RD",
    "dropphycty": "ROSHARON",
    "dropphyst": "TX",
    "dropphyzpp": 775839998,
    "dropmaladd": "1810 E FM 1462 RD",
    "dropmalcty": "ROSHARON",
    "dropmalst": "TX",
    "dropmalzpp": 775839998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815953331,
    "dropsitcph": 2815953331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25442",
    "droptype": "D",
    "dropname": "ROSS",
    "dropdeladd": "1441 ROSS RD",
    "dropdelcty": "ROSS",
    "dropdelst": "TX",
    "dropdelzpp": 766849800,
    "dropphyadd": "1441 ROSS RD",
    "dropphycty": "ROSS",
    "dropphyst": "TX",
    "dropphyzpp": 766849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSS",
    "dropmalst": "TX",
    "dropmalzpp": 766849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548291002,
    "dropsitcph": 2548291002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25443",
    "droptype": "D",
    "dropname": "ROSSER",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "ROSSER",
    "dropdelst": "TX",
    "dropdelzpp": 751579998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "ROSSER",
    "dropphyst": "TX",
    "dropphyzpp": 751579998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "ROSSER",
    "dropmalst": "TX",
    "dropmalzpp": 751579998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9724863973,
    "dropsitcph": 9724863973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25446",
    "droptype": "D",
    "dropname": "ROTAN",
    "dropdeladd": "201 N GARFIELD AVE",
    "dropdelcty": "ROTAN",
    "dropdelst": "TX",
    "dropdelzpp": 795469998,
    "dropphyadd": "201 N GARFIELD AVE",
    "dropphycty": "ROTAN",
    "dropphyst": "TX",
    "dropphyzpp": 795469998,
    "dropmaladd": "201 N GARFIELD AVE",
    "dropmalcty": "ROTAN",
    "dropmalst": "TX",
    "dropmalzpp": 795469998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257353132,
    "dropsitcph": 3257353132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25447",
    "droptype": "D",
    "dropname": "ROUND MOUNTAIN",
    "dropdeladd": "10603 US HIGHWAY 281 N",
    "dropdelcty": "ROUND MOUNTAIN",
    "dropdelst": "TX",
    "dropdelzpp": 786639998,
    "dropphyadd": "10603 US HIGHWAY 281 N",
    "dropphycty": "ROUND MOUNTAIN",
    "dropphyst": "TX",
    "dropphyzpp": 786639998,
    "dropmaladd": "10603 US HIGHWAY 281 N",
    "dropmalcty": "ROUND MOUNTAIN",
    "dropmalst": "TX",
    "dropmalzpp": 786639998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308253421,
    "dropsitcph": 8308253421,
    "dropfax": 8308253537
  },
  {
    "dcode": "D",
    "dropkey": "PW25448",
    "droptype": "D",
    "dropname": "ROUND ROCK",
    "dropdeladd": "2250 DOUBLE CREEK DR",
    "dropdelcty": "ROUND ROCK",
    "dropdelst": "TX",
    "dropdelzpp": 786649998,
    "dropphyadd": "2250 DOUBLE CREEK DR",
    "dropphycty": "ROUND ROCK",
    "dropphyst": "TX",
    "dropphyzpp": 786649998,
    "dropmaladd": "2250 DOUBLE CREEK DR",
    "dropmalcty": "ROUND ROCK",
    "dropmalst": "TX",
    "dropmalzpp": 786649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122441121,
    "dropsitcph": 5122440065,
    "dropfax": 5122440060
  },
  {
    "dcode": "D",
    "dropkey": "PW25450",
    "droptype": "D",
    "dropname": "ROUND TOP",
    "dropdeladd": "395 E MILL ST",
    "dropdelcty": "ROUND TOP",
    "dropdelst": "TX",
    "dropdelzpp": 789549998,
    "dropphyadd": "395 E MILL ST",
    "dropphycty": "ROUND TOP",
    "dropphyst": "TX",
    "dropphyzpp": 789549998,
    "dropmaladd": "395 E MILL ST",
    "dropmalcty": "ROUND TOP",
    "dropmalst": "TX",
    "dropmalzpp": 789549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792493005,
    "dropsitcph": 9792493005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25451",
    "droptype": "D",
    "dropname": "ROWENA",
    "dropdeladd": "501 MARY ST",
    "dropdelcty": "ROWENA",
    "dropdelst": "TX",
    "dropdelzpp": 768759803,
    "dropphyadd": "501 MARY ST",
    "dropphycty": "ROWENA",
    "dropphyst": "TX",
    "dropphyzpp": 768759803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROWENA",
    "dropmalst": "TX",
    "dropmalzpp": 768759998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254424261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25452",
    "droptype": "D",
    "dropname": "ROWLETT",
    "dropdeladd": "3416 ENTERPRISE DR",
    "dropdelcty": "ROWLETT",
    "dropdelst": "TX",
    "dropdelzpp": 750889998,
    "dropphyadd": "3416 ENTERPRISE DR",
    "dropphycty": "ROWLETT",
    "dropphyst": "TX",
    "dropphyzpp": 750889998,
    "dropmaladd": "3416 ENTERPRISE DR",
    "dropmalcty": "ROWLETT",
    "dropmalst": "TX",
    "dropmalzpp": 750889998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724754473,
    "dropsitcph": 9724754473,
    "dropfax": 9724121838
  },
  {
    "dcode": "D",
    "dropkey": "PW25453",
    "droptype": "D",
    "dropname": "ROXTON",
    "dropdeladd": "208 HARRISON AVE",
    "dropdelcty": "ROXTON",
    "dropdelst": "TX",
    "dropdelzpp": 754779998,
    "dropphyadd": "208 HARRISON AVE",
    "dropphycty": "ROXTON",
    "dropphyst": "TX",
    "dropphyzpp": 754779998,
    "dropmaladd": "208 HARRISON AVE",
    "dropmalcty": "ROXTON",
    "dropmalst": "TX",
    "dropmalzpp": 754779998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033463432,
    "dropsitcph": 9033463432,
    "dropfax": 9033463432
  },
  {
    "dcode": "D",
    "dropkey": "PW25458",
    "droptype": "D",
    "dropname": "ROYSE CITY",
    "dropdeladd": "217 E MAIN ST",
    "dropdelcty": "ROYSE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 751899998,
    "dropphyadd": "217 E MAIN ST",
    "dropphycty": "ROYSE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 751899998,
    "dropmaladd": "217 E MAIN ST",
    "dropmalcty": "ROYSE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 751899998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726363310,
    "dropsitcph": 9726363310,
    "dropfax": 9726352001
  },
  {
    "dcode": "D",
    "dropkey": "PW25462",
    "droptype": "D",
    "dropname": "RULE",
    "dropdeladd": "503 6TH ST",
    "dropdelcty": "RULE",
    "dropdelst": "TX",
    "dropdelzpp": 795479998,
    "dropphyadd": "503 6TH ST",
    "dropphycty": "RULE",
    "dropphyst": "TX",
    "dropphyzpp": 795479998,
    "dropmaladd": "503 6TH ST",
    "dropmalcty": "RULE",
    "dropmalst": "TX",
    "dropmalzpp": 795479998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 9409970322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25464",
    "droptype": "D",
    "dropname": "RUNGE",
    "dropdeladd": "302 N HELENA",
    "dropdelcty": "RUNGE",
    "dropdelst": "TX",
    "dropdelzpp": 781519998,
    "dropphyadd": "302 N HELENA",
    "dropphycty": "RUNGE",
    "dropphyst": "TX",
    "dropphyzpp": 781519998,
    "dropmaladd": "302 N HELENA",
    "dropmalcty": "RUNGE",
    "dropmalst": "TX",
    "dropmalzpp": 781519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302394391,
    "dropsitcph": 8302394391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25465",
    "droptype": "D",
    "dropname": "RUSK",
    "dropdeladd": "112 W 5TH ST",
    "dropdelcty": "RUSK",
    "dropdelst": "TX",
    "dropdelzpp": 757859998,
    "dropphyadd": "112 W 5TH ST",
    "dropphycty": "RUSK",
    "dropphyst": "TX",
    "dropphyzpp": 757859998,
    "dropmaladd": "112 W 5TH ST",
    "dropmalcty": "RUSK",
    "dropmalst": "TX",
    "dropmalzpp": 757859998,
    "dropsitphn": 9032453336,
    "dropsitlph": 9036834741,
    "dropsitcph": 9036834741,
    "dropfax": 9036838201
  },
  {
    "dcode": "D",
    "dropkey": "PW25467",
    "droptype": "D",
    "dropname": "RYE",
    "dropdeladd": "31422 HIGHWAY 146 N",
    "dropdelcty": "RYE",
    "dropdelst": "TX",
    "dropdelzpp": 773690001,
    "dropphyadd": "31422 HIGHWAY 146 N",
    "dropphycty": "RYE",
    "dropphyst": "TX",
    "dropphyzpp": 773690001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RYE",
    "dropmalst": "TX",
    "dropmalzpp": 773699998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815925855,
    "dropsitcph": 2815925855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25477",
    "droptype": "D",
    "dropname": "SABINAL",
    "dropdeladd": "119 N FRONT ST",
    "dropdelcty": "SABINAL",
    "dropdelst": "TX",
    "dropdelzpp": 788819998,
    "dropphyadd": "119 N FRONT ST",
    "dropphycty": "SABINAL",
    "dropphyst": "TX",
    "dropphyzpp": 788819998,
    "dropmaladd": "119 N FRONT ST",
    "dropmalcty": "SABINAL",
    "dropmalst": "TX",
    "dropmalzpp": 788819998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309882227,
    "dropsitcph": 8309882227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25479",
    "droptype": "D",
    "dropname": "SABINE PASS",
    "dropdeladd": "5424 TREMONT ST",
    "dropdelcty": "SABINE PASS",
    "dropdelst": "TX",
    "dropdelzpp": 776550310,
    "dropphyadd": "5424 TREMONT ST",
    "dropphycty": "SABINE PASS",
    "dropphyst": "TX",
    "dropphyzpp": 776550310,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SABINE PASS",
    "dropmalst": "TX",
    "dropmalzpp": 776559998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099712500,
    "dropsitcph": 4099712500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25481",
    "droptype": "D",
    "dropname": "SACUL",
    "dropdeladd": "100 US HIGHWAY 204",
    "dropdelcty": "SACUL",
    "dropdelst": "TX",
    "dropdelzpp": 757889998,
    "dropphyadd": "100 US HIGHWAY 204",
    "dropphycty": "SACUL",
    "dropphyst": "TX",
    "dropphyzpp": 757889998,
    "dropmaladd": "100 US HIGHWAY 204",
    "dropmalcty": "SACUL",
    "dropmalst": "TX",
    "dropmalzpp": 757889998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9363264518,
    "dropsitcph": 9363264518,
    "dropfax": 9363264254
  },
  {
    "dcode": "D",
    "dropkey": "PW25482",
    "droptype": "D",
    "dropname": "SADLER",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "SADLER",
    "dropdelst": "TX",
    "dropdelzpp": 762649998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "SADLER",
    "dropphyst": "TX",
    "dropphyzpp": 762649998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "SADLER",
    "dropmalst": "TX",
    "dropmalzpp": 762649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9035646047,
    "dropsitcph": 9035646047,
    "dropfax": 6505783823
  },
  {
    "dcode": "D",
    "dropkey": "PW25487",
    "droptype": "D",
    "dropname": "SAINT HEDWIG",
    "dropdeladd": "1102 CHURCH VIEW DR",
    "dropdelcty": "SAINT HEDWIG",
    "dropdelst": "TX",
    "dropdelzpp": 781529998,
    "dropphyadd": "1102 CHURCH VIEW DR",
    "dropphycty": "SAINT HEDWIG",
    "dropphyst": "TX",
    "dropphyzpp": 781529998,
    "dropmaladd": "1102 CHURCH VIEW DR",
    "dropmalcty": "SAINT HEDWIG",
    "dropmalst": "TX",
    "dropmalzpp": 781529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106679655,
    "dropsitcph": 2106672092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25488",
    "droptype": "D",
    "dropname": "SAINT JO",
    "dropdeladd": "210 S BROAD ST",
    "dropdelcty": "SAINT JO",
    "dropdelst": "TX",
    "dropdelzpp": 762659998,
    "dropphyadd": "210 S BROAD ST",
    "dropphycty": "SAINT JO",
    "dropphyst": "TX",
    "dropphyzpp": 762659998,
    "dropmaladd": "210 S BROAD ST",
    "dropmalcty": "SAINT JO",
    "dropmalst": "TX",
    "dropmalzpp": 762659998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9409952511,
    "dropsitcph": 9409952511,
    "dropfax": 9409952511
  },
  {
    "dcode": "D",
    "dropkey": "PW25490",
    "droptype": "D",
    "dropname": "SALADO",
    "dropdeladd": "820 N MAIN ST",
    "dropdelcty": "SALADO",
    "dropdelst": "TX",
    "dropdelzpp": 765719998,
    "dropphyadd": "820 N MAIN ST",
    "dropphycty": "SALADO",
    "dropphyst": "TX",
    "dropphyzpp": 765719998,
    "dropmaladd": "820 N MAIN ST",
    "dropmalcty": "SALADO",
    "dropmalst": "TX",
    "dropmalzpp": 765719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549475322,
    "dropsitcph": 2549475322,
    "dropfax": 2549473936
  },
  {
    "dcode": "D",
    "dropkey": "PW25495",
    "droptype": "D",
    "dropname": "SALINENO",
    "dropdeladd": "488 POST OFFICE ST",
    "dropdelcty": "SALINENO",
    "dropdelst": "TX",
    "dropdelzpp": 785852500,
    "dropphyadd": "488 POST OFFICE ST",
    "dropphycty": "SALINENO",
    "dropphyst": "TX",
    "dropphyzpp": 785852500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALINENO",
    "dropmalst": "TX",
    "dropmalzpp": 785859998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9568485880,
    "dropsitcph": 9568485880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25498",
    "droptype": "D",
    "dropname": "SALTILLO",
    "dropdeladd": "13562 US HIGHWAY 67",
    "dropdelcty": "SALTILLO",
    "dropdelst": "TX",
    "dropdelzpp": 754789998,
    "dropphyadd": "13562 US HIGHWAY 67",
    "dropphycty": "SALTILLO",
    "dropphyst": "TX",
    "dropphyzpp": 754789998,
    "dropmaladd": "13562 US HIGHWAY 67",
    "dropmalcty": "SALTILLO",
    "dropmalst": "TX",
    "dropmalzpp": 754789998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035374810,
    "dropsitcph": 9035374810,
    "dropfax": 9035374810
  },
  {
    "dcode": "D",
    "dropkey": "PW25504",
    "droptype": "D",
    "dropname": "SAN ANGELO",
    "dropdeladd": "1 N ABE ST",
    "dropdelcty": "SAN ANGELO",
    "dropdelst": "TX",
    "dropdelzpp": 769029998,
    "dropphyadd": "1 N ABE ST",
    "dropphycty": "SAN ANGELO",
    "dropphyst": "TX",
    "dropphyzpp": 769029998,
    "dropmaladd": "1 N ABE ST",
    "dropmalcty": "SAN ANGELO",
    "dropmalst": "TX",
    "dropmalzpp": 769029998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256597792,
    "dropsitcph": 3256597792,
    "dropfax": 3256597754
  },
  {
    "dcode": "D",
    "dropkey": "PW25505",
    "droptype": "D",
    "dropname": "SAN ANTONIO",
    "dropdeladd": "10410 PERRIN BEITEL RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782849998,
    "dropphyadd": "10410 PERRIN BEITEL RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782849998,
    "dropmaladd": "10410 PERRIN BEITEL RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103681712,
    "dropsitcph": 2103681712,
    "dropfax": 2103688323
  },
  {
    "dcode": "D",
    "dropkey": "PW25506",
    "droptype": "D",
    "dropname": "SAN AUGUSTINE",
    "dropdeladd": "117 W MAIN ST",
    "dropdelcty": "SAN AUGUSTINE",
    "dropdelst": "TX",
    "dropdelzpp": 759729998,
    "dropphyadd": "117 W MAIN ST",
    "dropphycty": "SAN AUGUSTINE",
    "dropphyst": "TX",
    "dropphyzpp": 759729998,
    "dropmaladd": "117 W MAIN ST",
    "dropmalcty": "SAN AUGUSTINE",
    "dropmalst": "TX",
    "dropmalzpp": 759729998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362752175,
    "dropsitcph": 9362752175,
    "dropfax": 9362750750
  },
  {
    "dcode": "D",
    "dropkey": "PW25507",
    "droptype": "D",
    "dropname": "SAN BENITO",
    "dropdeladd": "200 W HICKS ST",
    "dropdelcty": "SAN BENITO",
    "dropdelst": "TX",
    "dropdelzpp": 785869998,
    "dropphyadd": "200 W HICKS ST",
    "dropphycty": "SAN BENITO",
    "dropphyst": "TX",
    "dropphyzpp": 785869998,
    "dropmaladd": "200 W HICKS ST",
    "dropmalcty": "SAN BENITO",
    "dropmalst": "TX",
    "dropmalzpp": 785869998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563993151,
    "dropsitcph": 9563993151,
    "dropfax": 9563610738
  },
  {
    "dcode": "D",
    "dropkey": "PW25509",
    "droptype": "D",
    "dropname": "SAN DIEGO",
    "dropdeladd": "111 N VICTORIA ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "TX",
    "dropdelzpp": 783841829,
    "dropphyadd": "111 N VICTORIA ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "TX",
    "dropphyzpp": 783841829,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "TX",
    "dropmalzpp": 783849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612793984,
    "dropsitcph": 3612793984,
    "dropfax": 3612792850
  },
  {
    "dcode": "D",
    "dropkey": "PW25510",
    "droptype": "D",
    "dropname": "SAN ELIZARIO",
    "dropdeladd": "1416 SAN ANTONIO RD",
    "dropdelcty": "SAN ELIZARIO",
    "dropdelst": "TX",
    "dropdelzpp": 798499998,
    "dropphyadd": "1416 SAN ANTONIO RD",
    "dropphycty": "SAN ELIZARIO",
    "dropphyst": "TX",
    "dropphyzpp": 798499998,
    "dropmaladd": "1416 SAN ANTONIO RD",
    "dropmalcty": "SAN ELIZARIO",
    "dropmalst": "TX",
    "dropmalzpp": 798499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9158518872,
    "dropsitcph": 9158518872,
    "dropfax": 9158516830
  },
  {
    "dcode": "D",
    "dropkey": "PW25511",
    "droptype": "D",
    "dropname": "SAN FELIPE",
    "dropdeladd": "15079 FM 1458",
    "dropdelcty": "SAN FELIPE",
    "dropdelst": "TX",
    "dropdelzpp": 774739801,
    "dropphyadd": "15079 FM 1458",
    "dropphycty": "SAN FELIPE",
    "dropphyst": "TX",
    "dropphyzpp": 774739801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN FELIPE",
    "dropmalst": "TX",
    "dropmalzpp": 774739998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798856880,
    "dropsitcph": 9798856880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25513",
    "droptype": "D",
    "dropname": "SAN ISIDRO",
    "dropdeladd": "5264 FM 1017",
    "dropdelcty": "SAN ISIDRO",
    "dropdelst": "TX",
    "dropdelzpp": 785889998,
    "dropphyadd": "5264 FM 1017",
    "dropphycty": "SAN ISIDRO",
    "dropphyst": "TX",
    "dropphyzpp": 785889998,
    "dropmaladd": "5264 FM 1017",
    "dropmalcty": "SAN ISIDRO",
    "dropmalst": "TX",
    "dropmalzpp": 785889998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564813414,
    "dropsitcph": 9564813414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25516",
    "droptype": "D",
    "dropname": "SAN JUAN",
    "dropdeladd": "100 W AMY DR",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "TX",
    "dropdelzpp": 785899998,
    "dropphyadd": "100 W AMY DR",
    "dropphycty": "SAN JUAN",
    "dropphyst": "TX",
    "dropphyzpp": 785899998,
    "dropmaladd": "100 W AMY DR",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "TX",
    "dropmalzpp": 785899998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567872491,
    "dropsitcph": 9567872491,
    "dropfax": 9567027167
  },
  {
    "dcode": "D",
    "dropkey": "PW25520",
    "droptype": "D",
    "dropname": "SAN MARCOS",
    "dropdeladd": "900 BUGG LN STE 110A",
    "dropdelcty": "SAN MARCOS",
    "dropdelst": "TX",
    "dropdelzpp": 786669807,
    "dropphyadd": "900 BUGG LN STE 110A",
    "dropphycty": "SAN MARCOS",
    "dropphyst": "TX",
    "dropphyzpp": 786669807,
    "dropmaladd": "900 BUGG LN STE 110A",
    "dropmalcty": "SAN MARCOS",
    "dropmalst": "TX",
    "dropmalzpp": 786669807,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123924835,
    "dropsitcph": 5123924831,
    "dropfax": 5123924842
  },
  {
    "dcode": "D",
    "dropkey": "PW25524",
    "droptype": "D",
    "dropname": "SAN PERLITA",
    "dropdeladd": "14264 FM 2209",
    "dropdelcty": "SAN PERLITA",
    "dropdelst": "TX",
    "dropdelzpp": 785909800,
    "dropphyadd": "14264 FM 2209",
    "dropphycty": "SAN PERLITA",
    "dropphyst": "TX",
    "dropphyzpp": 785909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN PERLITA",
    "dropmalst": "TX",
    "dropmalzpp": 785909998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9562485220,
    "dropsitcph": 9562485220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25525",
    "droptype": "D",
    "dropname": "SAN SABA",
    "dropdeladd": "603 S HIGH ST",
    "dropdelcty": "SAN SABA",
    "dropdelst": "TX",
    "dropdelzpp": 768779998,
    "dropphyadd": "603 S HIGH ST",
    "dropphycty": "SAN SABA",
    "dropphyst": "TX",
    "dropphyzpp": 768779998,
    "dropmaladd": "603 S HIGH ST",
    "dropmalcty": "SAN SABA",
    "dropmalst": "TX",
    "dropmalzpp": 768779998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253725022,
    "dropfax": 3253726092
  },
  {
    "dcode": "D",
    "dropkey": "PW25526",
    "droptype": "D",
    "dropname": "SAN YGNACIO",
    "dropdeladd": "4327 N US HIGHWAY 83",
    "dropdelcty": "SAN YGNACIO",
    "dropdelst": "TX",
    "dropdelzpp": 780679998,
    "dropphyadd": "4327 N US HIGHWAY 83",
    "dropphycty": "SAN YGNACIO",
    "dropphyst": "TX",
    "dropphyzpp": 780679998,
    "dropmaladd": "4327 N US HIGHWAY 83",
    "dropmalcty": "SAN YGNACIO",
    "dropmalst": "TX",
    "dropmalzpp": 780679998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567655711,
    "dropsitcph": 9567655711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25528",
    "droptype": "D",
    "dropname": "SANDERSON",
    "dropdeladd": "208 W DOWNIE ST",
    "dropdelcty": "SANDERSON",
    "dropdelst": "TX",
    "dropdelzpp": 798489800,
    "dropphyadd": "208 W DOWNIE ST",
    "dropphycty": "SANDERSON",
    "dropphyst": "TX",
    "dropphyzpp": 798489800,
    "dropmaladd": "208 W DOWNIE ST",
    "dropmalcty": "SANDERSON",
    "dropmalst": "TX",
    "dropmalzpp": 798489800,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 3612836739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25529",
    "droptype": "D",
    "dropname": "SANDIA",
    "dropdeladd": "12140 HIGHWAY 359",
    "dropdelcty": "SANDIA",
    "dropdelst": "TX",
    "dropdelzpp": 783839998,
    "dropphyadd": "12140 HIGHWAY 359",
    "dropphycty": "SANDIA",
    "dropphyst": "TX",
    "dropphyzpp": 783839998,
    "dropmaladd": "12140 HIGHWAY 359",
    "dropmalcty": "SANDIA",
    "dropmalst": "TX",
    "dropmalzpp": 783839998,
    "dropsitphn": 2103688387,
    "dropsitlph": "",
    "dropsitcph": 3615473270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25536",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "305 E MAIN ST",
    "dropdelcty": "SANFORD",
    "dropdelst": "TX",
    "dropdelzpp": 790789800,
    "dropphyadd": "305 E MAIN ST",
    "dropphycty": "SANFORD",
    "dropphyst": "TX",
    "dropphyzpp": 790789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANFORD",
    "dropmalst": "TX",
    "dropmalzpp": 790789998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068653621,
    "dropsitcph": 8068653621,
    "dropfax": 8068653842
  },
  {
    "dcode": "D",
    "dropkey": "PW25537",
    "droptype": "D",
    "dropname": "SANGER",
    "dropdeladd": "1008 N 5TH ST",
    "dropdelcty": "SANGER",
    "dropdelst": "TX",
    "dropdelzpp": 762663293,
    "dropphyadd": "1008 N 5TH ST",
    "dropphycty": "SANGER",
    "dropphyst": "TX",
    "dropphyzpp": 762663293,
    "dropmaladd": "1008 N 5TH ST",
    "dropmalcty": "SANGER",
    "dropmalst": "TX",
    "dropmalzpp": 762663293,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404583381,
    "dropsitcph": 9404583381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25539",
    "droptype": "D",
    "dropname": "SANTA ANNA",
    "dropdeladd": "207 N 1ST ST",
    "dropdelcty": "SANTA ANNA",
    "dropdelst": "TX",
    "dropdelzpp": 768789998,
    "dropphyadd": "207 N 1ST ST",
    "dropphycty": "SANTA ANNA",
    "dropphyst": "TX",
    "dropphyzpp": 768789998,
    "dropmaladd": "207 N 1ST ST",
    "dropmalcty": "SANTA ANNA",
    "dropmalst": "TX",
    "dropmalzpp": 768789998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253483781,
    "dropfax": 3253486759
  },
  {
    "dcode": "D",
    "dropkey": "PW25542",
    "droptype": "D",
    "dropname": "SANTA ELENA",
    "dropdeladd": "4753 FM 1017",
    "dropdelcty": "SANTA ELENA",
    "dropdelst": "TX",
    "dropdelzpp": 785919998,
    "dropphyadd": "4753 FM 1017",
    "dropphycty": "SANTA ELENA",
    "dropphyst": "TX",
    "dropphyzpp": 785919998,
    "dropmaladd": "4753 FM 1017",
    "dropmalcty": "SANTA ELENA",
    "dropmalst": "TX",
    "dropmalzpp": 785919998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564813774,
    "dropsitcph": 9564813774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25543",
    "droptype": "D",
    "dropname": "SANTA FE",
    "dropdeladd": "13002 HIGHWAY 6",
    "dropdelcty": "SANTA FE",
    "dropdelst": "TX",
    "dropdelzpp": 775109998,
    "dropphyadd": "13002 HIGHWAY 6",
    "dropphycty": "SANTA FE",
    "dropphyst": "TX",
    "dropphyzpp": 775109998,
    "dropmaladd": "13002 HIGHWAY 6",
    "dropmalcty": "SANTA FE",
    "dropmalst": "TX",
    "dropmalzpp": 775109998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099256313,
    "dropsitcph": 4099272677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25545",
    "droptype": "D",
    "dropname": "SANTA MARIA",
    "dropdeladd": "11175 MILITARY RD",
    "dropdelcty": "SANTA MARIA",
    "dropdelst": "TX",
    "dropdelzpp": 785929800,
    "dropphyadd": "11175 MILITARY RD",
    "dropphycty": "SANTA MARIA",
    "dropphyst": "TX",
    "dropphyzpp": 785929800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA MARIA",
    "dropmalst": "TX",
    "dropmalzpp": 785929998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565652380,
    "dropsitcph": 9565652380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25547",
    "droptype": "D",
    "dropname": "SANTA ROSA",
    "dropdeladd": "214 FM 506",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "TX",
    "dropdelzpp": 785939998,
    "dropphyadd": "214 FM 506",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "TX",
    "dropphyzpp": 785939998,
    "dropmaladd": "214 FM 506",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "TX",
    "dropmalzpp": 785939998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9566361333,
    "dropsitcph": 9566361333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25548",
    "droptype": "D",
    "dropname": "SANTO",
    "dropdeladd": "58 BELL ST",
    "dropdelcty": "SANTO",
    "dropdelst": "TX",
    "dropdelzpp": 764729998,
    "dropphyadd": "58 BELL ST",
    "dropphycty": "SANTO",
    "dropphyst": "TX",
    "dropphyzpp": 764729998,
    "dropmaladd": "58 BELL ST",
    "dropmalcty": "SANTO",
    "dropmalst": "TX",
    "dropmalzpp": 764729998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407692311,
    "dropsitcph": 9407692311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25549",
    "droptype": "D",
    "dropname": "SARAGOSA",
    "dropdeladd": "200 W MAIN",
    "dropdelcty": "SARAGOSA",
    "dropdelst": "TX",
    "dropdelzpp": 797809998,
    "dropphyadd": "200 W MAIN",
    "dropphycty": "SARAGOSA",
    "dropphyst": "TX",
    "dropphyzpp": 797809998,
    "dropmaladd": "200 W MAIN",
    "dropmalcty": "SARAGOSA",
    "dropmalst": "TX",
    "dropmalzpp": 797809998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323755004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25551",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "17019 FM 770",
    "dropdelcty": "SARATOGA",
    "dropdelst": "TX",
    "dropdelzpp": 775859702,
    "dropphyadd": "17019 FM 770",
    "dropphycty": "SARATOGA",
    "dropphyst": "TX",
    "dropphyzpp": 775859702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARATOGA",
    "dropmalst": "TX",
    "dropmalzpp": 775859998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362745421,
    "dropsitcph": 9362745421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25554",
    "droptype": "D",
    "dropname": "SARITA",
    "dropdeladd": "103 N MALLORY ST",
    "dropdelcty": "SARITA",
    "dropdelst": "TX",
    "dropdelzpp": 783859800,
    "dropphyadd": "103 N MALLORY ST",
    "dropphycty": "SARITA",
    "dropphyst": "TX",
    "dropphyzpp": 783859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARITA",
    "dropmalst": "TX",
    "dropmalzpp": 783859998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612945716,
    "dropsitcph": 3613033015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25561",
    "droptype": "D",
    "dropname": "SAVOY",
    "dropdeladd": "301 E HAYES ST",
    "dropdelcty": "SAVOY",
    "dropdelst": "TX",
    "dropdelzpp": 754799998,
    "dropphyadd": "301 E HAYES ST",
    "dropphycty": "SAVOY",
    "dropphyst": "TX",
    "dropphyzpp": 754799998,
    "dropmaladd": "301 E HAYES ST",
    "dropmalcty": "SAVOY",
    "dropmalst": "TX",
    "dropmalzpp": 754799998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039654949,
    "dropsitcph": 9039654949,
    "dropfax": 9039659901
  },
  {
    "dcode": "D",
    "dropkey": "PW25563",
    "droptype": "D",
    "dropname": "SCHERTZ",
    "dropdeladd": "1081 ELBEL RD",
    "dropdelcty": "SCHERTZ",
    "dropdelst": "TX",
    "dropdelzpp": 781549998,
    "dropphyadd": "1081 ELBEL RD",
    "dropphycty": "SCHERTZ",
    "dropphyst": "TX",
    "dropphyzpp": 781549998,
    "dropmaladd": "1081 ELBEL RD",
    "dropmalcty": "SCHERTZ",
    "dropmalst": "TX",
    "dropmalzpp": 781549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106583072,
    "dropsitcph": 2105667184,
    "dropfax": 2109454291
  },
  {
    "dcode": "D",
    "dropkey": "PW25565",
    "droptype": "D",
    "dropname": "SCHULENBURG",
    "dropdeladd": "622 ANDERSON ST",
    "dropdelcty": "SCHULENBURG",
    "dropdelst": "TX",
    "dropdelzpp": 789569998,
    "dropphyadd": "622 ANDERSON ST",
    "dropphycty": "SCHULENBURG",
    "dropphyst": "TX",
    "dropphyzpp": 789569998,
    "dropmaladd": "622 ANDERSON ST",
    "dropmalcty": "SCHULENBURG",
    "dropmalst": "TX",
    "dropmalzpp": 789569998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9797433049,
    "dropsitcph": 9797433049,
    "dropfax": 9797433530
  },
  {
    "dcode": "D",
    "dropkey": "PW25566",
    "droptype": "D",
    "dropname": "SCHWERTNER",
    "dropdeladd": "14775 FM 1105",
    "dropdelcty": "SCHWERTNER",
    "dropdelst": "TX",
    "dropdelzpp": 765739800,
    "dropphyadd": "14775 FM 1105",
    "dropphycty": "SCHWERTNER",
    "dropphyst": "TX",
    "dropphyzpp": 765739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHWERTNER",
    "dropmalst": "TX",
    "dropmalzpp": 765739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545274243,
    "dropsitcph": 2545274243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25567",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "562 7TH ST",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "TX",
    "dropdelzpp": 763799998,
    "dropphyadd": "562 7TH ST",
    "dropphycty": "SCOTLAND",
    "dropphyst": "TX",
    "dropphyzpp": 763799998,
    "dropmaladd": "562 7TH ST",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "TX",
    "dropmalzpp": 763799998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405412202,
    "dropsitcph": 9405412202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25570",
    "droptype": "D",
    "dropname": "SCOTTSVILLE",
    "dropdeladd": "8657 US HIGHWAY 80 E",
    "dropdelcty": "SCOTTSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 756889998,
    "dropphyadd": "8657 US HIGHWAY 80 E",
    "dropphycty": "SCOTTSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 756889998,
    "dropmaladd": "8657 US HIGHWAY 80 E",
    "dropmalcty": "SCOTTSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 756889998,
    "dropsitphn": 9039387189,
    "dropsitlph": 9039387189,
    "dropsitcph": 9039387189,
    "dropfax": 9039230189
  },
  {
    "dcode": "D",
    "dropkey": "PW25571",
    "droptype": "D",
    "dropname": "SCROGGINS",
    "dropdeladd": "14891 FARM ROAD 115",
    "dropdelcty": "SCROGGINS",
    "dropdelst": "TX",
    "dropdelzpp": 754809998,
    "dropphyadd": "14891 FARM ROAD 115",
    "dropphycty": "SCROGGINS",
    "dropphyst": "TX",
    "dropphyzpp": 754809998,
    "dropmaladd": "14891 FARM ROAD 115",
    "dropmalcty": "SCROGGINS",
    "dropmalst": "TX",
    "dropmalzpp": 754809998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033652533,
    "dropsitcph": 9033652533,
    "dropfax": 9033652533
  },
  {
    "dcode": "D",
    "dropkey": "PW25572",
    "droptype": "D",
    "dropname": "SCURRY",
    "dropdeladd": "8315 S STATE HIGHWAY 34",
    "dropdelcty": "SCURRY",
    "dropdelst": "TX",
    "dropdelzpp": 751589998,
    "dropphyadd": "8315 S STATE HIGHWAY 34",
    "dropphycty": "SCURRY",
    "dropphyst": "TX",
    "dropphyzpp": 751589998,
    "dropmaladd": "8315 S STATE HIGHWAY 34",
    "dropmalcty": "SCURRY",
    "dropmalst": "TX",
    "dropmalzpp": 751589998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724528842,
    "dropsitcph": 9724528842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25573",
    "droptype": "D",
    "dropname": "SEABROOK",
    "dropdeladd": "1600 MAIN ST",
    "dropdelcty": "SEABROOK",
    "dropdelst": "TX",
    "dropdelzpp": 775863515,
    "dropphyadd": "1600 MAIN ST",
    "dropphycty": "SEABROOK",
    "dropphyst": "TX",
    "dropphyzpp": 775863515,
    "dropmaladd": "1600 MAIN ST",
    "dropmalcty": "SEABROOK",
    "dropmalst": "TX",
    "dropmalzpp": 775863515,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814741115,
    "dropsitcph": 2814742679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25574",
    "droptype": "D",
    "dropname": "SEADRIFT",
    "dropdeladd": "518 S MAIN ST",
    "dropdelcty": "SEADRIFT",
    "dropdelst": "TX",
    "dropdelzpp": 779839998,
    "dropphyadd": "518 S MAIN ST",
    "dropphycty": "SEADRIFT",
    "dropphyst": "TX",
    "dropphyzpp": 779839998,
    "dropmaladd": "518 S MAIN ST",
    "dropmalcty": "SEADRIFT",
    "dropmalst": "TX",
    "dropmalzpp": 779839998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617855611,
    "dropsitcph": 3617855611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25575",
    "droptype": "D",
    "dropname": "SEAGOVILLE",
    "dropdeladd": "15300 SEAGOVILLE RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752539998,
    "dropphyadd": "15300 SEAGOVILLE RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752539998,
    "dropmaladd": "15300 SEAGOVILLE RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752539998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722874854,
    "dropsitcph": 9722869541,
    "dropfax": 9722877868
  },
  {
    "dcode": "D",
    "dropkey": "PW25576",
    "droptype": "D",
    "dropname": "SEAGRAVES",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "SEAGRAVES",
    "dropdelst": "TX",
    "dropdelzpp": 793599802,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "SEAGRAVES",
    "dropphyst": "TX",
    "dropphyzpp": 793599802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEAGRAVES",
    "dropmalst": "TX",
    "dropmalzpp": 793599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8065462436,
    "dropsitcph": 8065462436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25577",
    "droptype": "D",
    "dropname": "SEALY",
    "dropdeladd": "222 MOODY ST",
    "dropdelcty": "SEALY",
    "dropdelst": "TX",
    "dropdelzpp": 774749998,
    "dropphyadd": "222 MOODY ST",
    "dropphycty": "SEALY",
    "dropphyst": "TX",
    "dropphyzpp": 774749998,
    "dropmaladd": "222 MOODY ST",
    "dropmalcty": "SEALY",
    "dropmalst": "TX",
    "dropmalzpp": 774749998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798853439,
    "dropsitcph": 9798853439,
    "dropfax": 9798853262
  },
  {
    "dcode": "D",
    "dropkey": "PW25582",
    "droptype": "D",
    "dropname": "SEBASTIAN",
    "dropdeladd": "3476 BUSINESS 77",
    "dropdelcty": "SEBASTIAN",
    "dropdelst": "TX",
    "dropdelzpp": 785949800,
    "dropphyadd": "3476 BUSINESS 77",
    "dropphycty": "SEBASTIAN",
    "dropphyst": "TX",
    "dropphyzpp": 785949800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEBASTIAN",
    "dropmalst": "TX",
    "dropmalzpp": 785949998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9563475007,
    "dropsitcph": 9563475007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25588",
    "droptype": "D",
    "dropname": "SEGUIN",
    "dropdeladd": "531 W COURT ST",
    "dropdelcty": "SEGUIN",
    "dropdelst": "TX",
    "dropdelzpp": 781559998,
    "dropphyadd": "531 W COURT ST",
    "dropphycty": "SEGUIN",
    "dropphyst": "TX",
    "dropphyzpp": 781559998,
    "dropmaladd": "531 W COURT ST",
    "dropmalcty": "SEGUIN",
    "dropmalst": "TX",
    "dropmalzpp": 781559998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688386,
    "dropsitcph": 8303035141,
    "dropfax": 8303794080
  },
  {
    "dcode": "D",
    "dropkey": "PW25592",
    "droptype": "D",
    "dropname": "SELMAN CITY",
    "dropdeladd": "10310 HIGHWAY 64 W",
    "dropdelcty": "SELMAN CITY",
    "dropdelst": "TX",
    "dropdelzpp": 756899998,
    "dropphyadd": "10310 HIGHWAY 64 W",
    "dropphycty": "SELMAN CITY",
    "dropphyst": "TX",
    "dropphyzpp": 756899998,
    "dropmaladd": "10310 HIGHWAY 64 W",
    "dropmalcty": "SELMAN CITY",
    "dropmalst": "TX",
    "dropmalzpp": 756899998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038472831,
    "dropsitcph": 9038472831,
    "dropfax": 9038472831
  },
  {
    "dcode": "D",
    "dropkey": "PW25594",
    "droptype": "D",
    "dropname": "SEMINOLE",
    "dropdeladd": "201 SE 3RD ST",
    "dropdelcty": "SEMINOLE",
    "dropdelst": "TX",
    "dropdelzpp": 793609998,
    "dropphyadd": "201 SE 3RD ST",
    "dropphycty": "SEMINOLE",
    "dropphyst": "TX",
    "dropphyzpp": 793609998,
    "dropmaladd": "201 SE 3RD ST",
    "dropmalcty": "SEMINOLE",
    "dropmalst": "TX",
    "dropmalzpp": 793609998,
    "dropsitphn": 8173173658,
    "dropsitlph": 4327582141,
    "dropsitcph": 4327582141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25602",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "210 N WASHINGTON ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "TX",
    "dropdelzpp": 763809998,
    "dropphyadd": "210 N WASHINGTON ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "TX",
    "dropphyzpp": 763809998,
    "dropmaladd": "210 N WASHINGTON ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "TX",
    "dropmalzpp": 763809998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408893550,
    "dropsitcph": 9408893550,
    "dropfax": 9408893725
  },
  {
    "dcode": "D",
    "dropkey": "PW25610",
    "droptype": "D",
    "dropname": "SHALLOWATER",
    "dropdeladd": "105 CLOVIS RD",
    "dropdelcty": "SHALLOWATER",
    "dropdelst": "TX",
    "dropdelzpp": 793639998,
    "dropphyadd": "105 CLOVIS RD",
    "dropphycty": "SHALLOWATER",
    "dropphyst": "TX",
    "dropphyzpp": 793639998,
    "dropmaladd": "105 CLOVIS RD",
    "dropmalcty": "SHALLOWATER",
    "dropmalst": "TX",
    "dropmalzpp": 793639998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068324606,
    "dropsitcph": 8068324606,
    "dropfax": 8068324592
  },
  {
    "dcode": "D",
    "dropkey": "PW25611",
    "droptype": "D",
    "dropname": "SHAMROCK",
    "dropdeladd": "210 N MADDEN ST",
    "dropdelcty": "SHAMROCK",
    "dropdelst": "TX",
    "dropdelzpp": 790799998,
    "dropphyadd": "210 N MADDEN ST",
    "dropphycty": "SHAMROCK",
    "dropphyst": "TX",
    "dropphyzpp": 790799998,
    "dropmaladd": "210 N MADDEN ST",
    "dropmalcty": "SHAMROCK",
    "dropmalst": "TX",
    "dropmalzpp": 790799998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062563521,
    "dropsitcph": 8062563521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25618",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "9584 HIGHWAY 290",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 797819800,
    "dropphyadd": "9584 HIGHWAY 290",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 797819800,
    "dropmaladd": "9584 HIGHWAY 290",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 797819800,
    "dropsitphn": 2103688387,
    "dropsitlph": 4328364363,
    "dropsitcph": 4328364363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25620",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "5182 STATE HIGHWAY 87 S",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 759739998,
    "dropphyadd": "5182 STATE HIGHWAY 87 S",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 759739998,
    "dropmaladd": "5182 STATE HIGHWAY 87 S",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 759739998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365983772,
    "dropsitcph": 9365983772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25623",
    "droptype": "D",
    "dropname": "SHEPHERD",
    "dropdeladd": "1350 S BYRD AVE",
    "dropdelcty": "SHEPHERD",
    "dropdelst": "TX",
    "dropdelzpp": 773719998,
    "dropphyadd": "1350 S BYRD AVE",
    "dropphycty": "SHEPHERD",
    "dropphyst": "TX",
    "dropphyzpp": 773719998,
    "dropmaladd": "1350 S BYRD AVE",
    "dropmalcty": "SHEPHERD",
    "dropmalst": "TX",
    "dropmalzpp": 773719998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9366286922,
    "dropsitcph": 9366286922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25625",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "1402 U S HIGHWAY 90A",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "TX",
    "dropdelzpp": 774759800,
    "dropphyadd": "1402 U S HIGHWAY 90A",
    "dropphycty": "SHERIDAN",
    "dropphyst": "TX",
    "dropphyzpp": 774759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "TX",
    "dropmalzpp": 774759998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792343061,
    "dropsitcph": 9792343061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25626",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "701 E PEYTON ST",
    "dropdelcty": "SHERMAN",
    "dropdelst": "TX",
    "dropdelzpp": 750909998,
    "dropphyadd": "701 E PEYTON ST",
    "dropphycty": "SHERMAN",
    "dropphyst": "TX",
    "dropphyzpp": 750909998,
    "dropmaladd": "701 E PEYTON ST",
    "dropmalcty": "SHERMAN",
    "dropmalst": "TX",
    "dropmalzpp": 750909998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038929234,
    "dropsitcph": 9038929234,
    "dropfax": 9038922282
  },
  {
    "dcode": "D",
    "dropkey": "PW25630",
    "droptype": "D",
    "dropname": "SHINER",
    "dropdeladd": "217 W 7TH ST",
    "dropdelcty": "SHINER",
    "dropdelst": "TX",
    "dropdelzpp": 779849998,
    "dropphyadd": "217 W 7TH ST",
    "dropphycty": "SHINER",
    "dropphyst": "TX",
    "dropphyzpp": 779849998,
    "dropmaladd": "217 W 7TH ST",
    "dropmalcty": "SHINER",
    "dropmalst": "TX",
    "dropmalzpp": 779849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615942324,
    "dropsitcph": 3615942324,
    "dropfax": 3615943358
  },
  {
    "dcode": "D",
    "dropkey": "PW25631",
    "droptype": "D",
    "dropname": "SHIRO",
    "dropdeladd": "19431 HIGHWAY 30",
    "dropdelcty": "SHIRO",
    "dropdelst": "TX",
    "dropdelzpp": 778769800,
    "dropphyadd": "19431 HIGHWAY 30",
    "dropphycty": "SHIRO",
    "dropphyst": "TX",
    "dropphyzpp": 778769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIRO",
    "dropmalst": "TX",
    "dropmalzpp": 778769998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368742390,
    "dropsitcph": 9368742390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25635",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "2051 HIGHWAY 589",
    "dropdelcty": "SIDNEY",
    "dropdelst": "TX",
    "dropdelzpp": 764749802,
    "dropphyadd": "2051 HIGHWAY 589",
    "dropphycty": "SIDNEY",
    "dropphyst": "TX",
    "dropphyzpp": 764749802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIDNEY",
    "dropmalst": "TX",
    "dropmalzpp": 764749998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548425891,
    "dropsitcph": 2548425891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25636",
    "droptype": "D",
    "dropname": "SIERRA BLANCA",
    "dropdeladd": "1195 EL PASO ST",
    "dropdelcty": "SIERRA BLANCA",
    "dropdelst": "TX",
    "dropdelzpp": 798519800,
    "dropphyadd": "1195 EL PASO ST",
    "dropphycty": "SIERRA BLANCA",
    "dropphyst": "TX",
    "dropphyzpp": 798519800,
    "dropmaladd": "1195 EL PASO ST",
    "dropmalcty": "SIERRA BLANCA",
    "dropmalst": "TX",
    "dropmalzpp": 798519998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9153692121,
    "dropsitcph": 9153692121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25640",
    "droptype": "D",
    "dropname": "SILSBEE",
    "dropdeladd": "111 W AVENUE P",
    "dropdelcty": "SILSBEE",
    "dropdelst": "TX",
    "dropdelzpp": 776569998,
    "dropphyadd": "111 W AVENUE P",
    "dropphycty": "SILSBEE",
    "dropphyst": "TX",
    "dropphyzpp": 776569998,
    "dropmaladd": "111 W AVENUE P",
    "dropmalcty": "SILSBEE",
    "dropmalst": "TX",
    "dropmalzpp": 776569998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4093853776,
    "dropsitcph": 4093853776,
    "dropfax": 4093851331
  },
  {
    "dcode": "D",
    "dropkey": "PW25641",
    "droptype": "D",
    "dropname": "SILVER",
    "dropdeladd": "551 WILKES AVE",
    "dropdelcty": "SILVER",
    "dropdelst": "TX",
    "dropdelzpp": 769499802,
    "dropphyadd": "551 WILKES AVE",
    "dropphycty": "SILVER",
    "dropphyst": "TX",
    "dropphyzpp": 769499802,
    "dropmaladd": "551 WILKES AVE",
    "dropmalcty": "SILVER",
    "dropmalst": "TX",
    "dropmalzpp": 769499802,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254532050,
    "dropsitcph": 3254532050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25645",
    "droptype": "D",
    "dropname": "SILVERTON",
    "dropdeladd": "401 LONE STAR ST",
    "dropdelcty": "SILVERTON",
    "dropdelst": "TX",
    "dropdelzpp": 792579804,
    "dropphyadd": "401 LONE STAR ST",
    "dropphycty": "SILVERTON",
    "dropphyst": "TX",
    "dropphyzpp": 792579804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVERTON",
    "dropmalst": "TX",
    "dropmalzpp": 792579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068232118,
    "dropsitcph": 8068232118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25647",
    "droptype": "D",
    "dropname": "SIMMS",
    "dropdeladd": "7539 US HIGHWAY 67 W",
    "dropdelcty": "SIMMS",
    "dropdelst": "TX",
    "dropdelzpp": 755749997,
    "dropphyadd": "7539 US HIGHWAY 67 W",
    "dropphycty": "SIMMS",
    "dropphyst": "TX",
    "dropphyzpp": 755749997,
    "dropmaladd": "7539 US HIGHWAY 67 W",
    "dropmalcty": "SIMMS",
    "dropmalst": "TX",
    "dropmalzpp": 755749997,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035432768,
    "dropsitcph": 9035432768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25648",
    "droptype": "D",
    "dropname": "SIMONTON",
    "dropdeladd": "35608 FM 1093",
    "dropdelcty": "SIMONTON",
    "dropdelst": "TX",
    "dropdelzpp": 774769800,
    "dropphyadd": "35608 FM 1093",
    "dropphycty": "SIMONTON",
    "dropphyst": "TX",
    "dropphyzpp": 774769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIMONTON",
    "dropmalst": "TX",
    "dropmalzpp": 774769998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815339322,
    "dropsitcph": 2815339322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25653",
    "droptype": "D",
    "dropname": "SINTON",
    "dropdeladd": "104 S SAN PATRICIO ST",
    "dropdelcty": "SINTON",
    "dropdelst": "TX",
    "dropdelzpp": 783879998,
    "dropphyadd": "104 S SAN PATRICIO ST",
    "dropphycty": "SINTON",
    "dropphyst": "TX",
    "dropphyzpp": 783879998,
    "dropmaladd": "104 S SAN PATRICIO ST",
    "dropmalcty": "SINTON",
    "dropmalst": "TX",
    "dropmalzpp": 783879998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613642566,
    "dropsitcph": 3613642566,
    "dropfax": 3613645892
  },
  {
    "dcode": "D",
    "dropkey": "PW25656",
    "droptype": "D",
    "dropname": "SKELLYTOWN",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "SKELLYTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 790809802,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "SKELLYTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 790809802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKELLYTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 790809998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068482378,
    "dropsitcph": 8068482378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25657",
    "droptype": "D",
    "dropname": "SKIDMORE",
    "dropdeladd": "122 E PATRICIO ST",
    "dropdelcty": "SKIDMORE",
    "dropdelst": "TX",
    "dropdelzpp": 783899998,
    "dropphyadd": "122 E PATRICIO ST",
    "dropphycty": "SKIDMORE",
    "dropphyst": "TX",
    "dropphyzpp": 783899998,
    "dropmaladd": "122 E PATRICIO ST",
    "dropmalcty": "SKIDMORE",
    "dropmalst": "TX",
    "dropmalzpp": 783899998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612873479,
    "dropsitcph": 3612873479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25658",
    "droptype": "D",
    "dropname": "SLATON",
    "dropdeladd": "150 W LYNN ST",
    "dropdelcty": "SLATON",
    "dropdelst": "TX",
    "dropdelzpp": 793649998,
    "dropphyadd": "150 W LYNN ST",
    "dropphycty": "SLATON",
    "dropphyst": "TX",
    "dropphyzpp": 793649998,
    "dropmaladd": "150 W LYNN ST",
    "dropmalcty": "SLATON",
    "dropmalst": "TX",
    "dropmalzpp": 793649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068283707,
    "dropsitcph": 8068283707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25659",
    "droptype": "D",
    "dropname": "SLIDELL",
    "dropdeladd": "112 COUNTY ROAD 2820",
    "dropdelcty": "SLIDELL",
    "dropdelst": "TX",
    "dropdelzpp": 762679998,
    "dropphyadd": "112 COUNTY ROAD 2820",
    "dropphycty": "SLIDELL",
    "dropphyst": "TX",
    "dropphyzpp": 762679998,
    "dropmaladd": "112 COUNTY ROAD 2820",
    "dropmalcty": "SLIDELL",
    "dropmalst": "TX",
    "dropmalzpp": 762679998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404663231,
    "dropsitcph": 9404663231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25661",
    "droptype": "D",
    "dropname": "SMILEY",
    "dropdeladd": "401 W US HIGHWAY 87",
    "dropdelcty": "SMILEY",
    "dropdelst": "TX",
    "dropdelzpp": 781599998,
    "dropphyadd": "401 W US HIGHWAY 87",
    "dropphycty": "SMILEY",
    "dropphyst": "TX",
    "dropphyzpp": 781599998,
    "dropmaladd": "401 W US HIGHWAY 87",
    "dropmalcty": "SMILEY",
    "dropmalst": "TX",
    "dropmalzpp": 781599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8305876491,
    "dropsitcph": 8305876491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25665",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 789579998,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 789579998,
    "dropmaladd": "400 MAIN ST",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 789579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122372350,
    "dropsitcph": 5122372350,
    "dropfax": 5122379601
  },
  {
    "dcode": "D",
    "dropkey": "PW25666",
    "droptype": "D",
    "dropname": "SMYER",
    "dropdeladd": "1002 1ST ST",
    "dropdelcty": "SMYER",
    "dropdelst": "TX",
    "dropdelzpp": 793679802,
    "dropphyadd": "1002 1ST ST",
    "dropphycty": "SMYER",
    "dropphyst": "TX",
    "dropphyzpp": 793679802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMYER",
    "dropmalst": "TX",
    "dropmalzpp": 793679998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062342302,
    "dropsitcph": 8062342302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25668",
    "droptype": "D",
    "dropname": "SNOOK",
    "dropdeladd": "9999 FM 2155",
    "dropdelcty": "SNOOK",
    "dropdelst": "TX",
    "dropdelzpp": 778789800,
    "dropphyadd": "9999 FM 2155",
    "dropphycty": "SNOOK",
    "dropphyst": "TX",
    "dropphyzpp": 778789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNOOK",
    "dropmalst": "TX",
    "dropmalzpp": 778789998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792728007,
    "dropsitcph": 9792728007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25670",
    "droptype": "D",
    "dropname": "SNYDER",
    "dropdeladd": "1701 24TH ST",
    "dropdelcty": "SNYDER",
    "dropdelst": "TX",
    "dropdelzpp": 795499998,
    "dropphyadd": "1701 24TH ST",
    "dropphycty": "SNYDER",
    "dropphyst": "TX",
    "dropphyzpp": 795499998,
    "dropmaladd": "1701 24TH ST",
    "dropmalcty": "SNYDER",
    "dropmalst": "TX",
    "dropmalzpp": 795499998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255735505,
    "dropsitcph": 3255735505,
    "dropfax": 3255735342
  },
  {
    "dcode": "D",
    "dropkey": "PW25678",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "19608 SOMERSET RD",
    "dropdelcty": "SOMERSET",
    "dropdelst": "TX",
    "dropdelzpp": 780699998,
    "dropphyadd": "19608 SOMERSET RD",
    "dropphycty": "SOMERSET",
    "dropphyst": "TX",
    "dropphyzpp": 780699998,
    "dropmaladd": "19608 SOMERSET RD",
    "dropmalcty": "SOMERSET",
    "dropmalst": "TX",
    "dropmalzpp": 780699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304293576,
    "dropsitcph": 8304293576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25679",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "199 8TH ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 778799802,
    "dropphyadd": "199 8TH ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 778799802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 778799998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795961613,
    "dropsitcph": 9795961613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25680",
    "droptype": "D",
    "dropname": "SONORA",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "SONORA",
    "dropdelst": "TX",
    "dropdelzpp": 769509998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "SONORA",
    "dropphyst": "TX",
    "dropphyzpp": 769509998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "SONORA",
    "dropmalst": "TX",
    "dropmalzpp": 769509998,
    "dropsitphn": 3253873161,
    "dropsitlph": 3253873161,
    "dropsitcph": 3253873161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25683",
    "droptype": "D",
    "dropname": "SOUR LAKE",
    "dropdeladd": "665 6TH ST",
    "dropdelcty": "SOUR LAKE",
    "dropdelst": "TX",
    "dropdelzpp": 776590289,
    "dropphyadd": "665 6TH ST",
    "dropphycty": "SOUR LAKE",
    "dropphyst": "TX",
    "dropphyzpp": 776590289,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUR LAKE",
    "dropmalst": "TX",
    "dropmalzpp": 776599998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092873202,
    "dropsitcph": 4092873202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25687",
    "droptype": "D",
    "dropname": "SOUTH BEND",
    "dropdeladd": "313 S MAIN ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "TX",
    "dropdelzpp": 764819801,
    "dropphyadd": "313 S MAIN ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "TX",
    "dropphyzpp": 764819801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "TX",
    "dropmalzpp": 764819998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403624466,
    "dropsitcph": 9403624466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25690",
    "droptype": "D",
    "dropname": "SOUTH HOUSTON",
    "dropdeladd": "315 N ALLEN GENOA RD",
    "dropdelcty": "SOUTH HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 775879998,
    "dropphyadd": "315 N ALLEN GENOA RD",
    "dropphycty": "SOUTH HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 775879998,
    "dropmaladd": "315 N ALLEN GENOA RD",
    "dropmalcty": "SOUTH HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 775879998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139462784,
    "dropsitcph": 7139466217,
    "dropfax": 7139476909
  },
  {
    "dcode": "D",
    "dropkey": "PW25696",
    "droptype": "D",
    "dropname": "SOUTH PLAINS",
    "dropdeladd": "323 MAIN ST",
    "dropdelcty": "SOUTH PLAINS",
    "dropdelst": "TX",
    "dropdelzpp": 792583000,
    "dropphyadd": "323 MAIN ST",
    "dropphycty": "SOUTH PLAINS",
    "dropphyst": "TX",
    "dropphyzpp": 792583000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH PLAINS",
    "dropmalst": "TX",
    "dropmalzpp": 792589998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069832062,
    "dropsitcph": 8069832062,
    "dropfax": 8069832488
  },
  {
    "dcode": "D",
    "dropkey": "PW25713",
    "droptype": "D",
    "dropname": "SOUTHMAYD",
    "dropdeladd": "102 CHRISTI LN",
    "dropdelcty": "SOUTHMAYD",
    "dropdelst": "TX",
    "dropdelzpp": 762689998,
    "dropphyadd": "102 CHRISTI LN",
    "dropphycty": "SOUTHMAYD",
    "dropphyst": "TX",
    "dropphyzpp": 762689998,
    "dropmaladd": "102 CHRISTI LN",
    "dropmalcty": "SOUTHMAYD",
    "dropmalst": "TX",
    "dropmalzpp": 762689998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9038937438,
    "dropsitcph": 9038937438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25722",
    "droptype": "D",
    "dropname": "SPADE",
    "dropdeladd": "2756 FM 168",
    "dropdelcty": "SPADE",
    "dropdelst": "TX",
    "dropdelzpp": 793699800,
    "dropphyadd": "2756 FM 168",
    "dropphycty": "SPADE",
    "dropphyst": "TX",
    "dropphyzpp": 793699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPADE",
    "dropmalst": "TX",
    "dropmalzpp": 793699998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062332581,
    "dropsitcph": 8062332581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25726",
    "droptype": "D",
    "dropname": "SPEARMAN",
    "dropdeladd": "101 N BERNICE ST",
    "dropdelcty": "SPEARMAN",
    "dropdelst": "TX",
    "dropdelzpp": 790819998,
    "dropphyadd": "101 N BERNICE ST",
    "dropphycty": "SPEARMAN",
    "dropphyst": "TX",
    "dropphyzpp": 790819998,
    "dropmaladd": "101 N BERNICE ST",
    "dropmalcty": "SPEARMAN",
    "dropmalst": "TX",
    "dropmalzpp": 790819998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066593313,
    "dropsitcph": 8066593313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25728",
    "droptype": "D",
    "dropname": "SPICEWOOD",
    "dropdeladd": "121 SPUR 191",
    "dropdelcty": "SPICEWOOD",
    "dropdelst": "TX",
    "dropdelzpp": 786699998,
    "dropphyadd": "121 SPUR 191",
    "dropphycty": "SPICEWOOD",
    "dropphyst": "TX",
    "dropphyzpp": 786699998,
    "dropmaladd": "121 SPUR 191",
    "dropmalcty": "SPICEWOOD",
    "dropmalst": "TX",
    "dropmalzpp": 786699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306932377,
    "dropsitcph": 8306932377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25729",
    "droptype": "D",
    "dropname": "SPLENDORA",
    "dropdeladd": "26130 FM 2090 RD E",
    "dropdelcty": "SPLENDORA",
    "dropdelst": "TX",
    "dropdelzpp": 773729800,
    "dropphyadd": "26130 FM 2090 RD E",
    "dropphycty": "SPLENDORA",
    "dropphyst": "TX",
    "dropphyzpp": 773729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPLENDORA",
    "dropmalst": "TX",
    "dropmalzpp": 773729998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2816895540,
    "dropsitcph": 2816895540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25731",
    "droptype": "D",
    "dropname": "SPRING",
    "dropdeladd": "1411 WUNSCHE LOOP",
    "dropdelcty": "SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 773739998,
    "dropphyadd": "1411 WUNSCHE LOOP",
    "dropphycty": "SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 773739998,
    "dropmaladd": "1411 WUNSCHE LOOP",
    "dropmalcty": "SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 773739998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2816518841,
    "dropsitcph": 2812888465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25732",
    "droptype": "D",
    "dropname": "SPRING BRANCH",
    "dropdeladd": "132 BLAZING MEADOW RD",
    "dropdelcty": "SPRING BRANCH",
    "dropdelst": "TX",
    "dropdelzpp": 780709998,
    "dropphyadd": "132 BLAZING MEADOW RD",
    "dropphycty": "SPRING BRANCH",
    "dropphyst": "TX",
    "dropphyzpp": 780709998,
    "dropmaladd": "132 BLAZING MEADOW RD",
    "dropmalcty": "SPRING BRANCH",
    "dropmalst": "TX",
    "dropmalzpp": 780709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8308854508,
    "dropsitcph": 8308854508,
    "dropfax": 8308855218
  },
  {
    "dcode": "D",
    "dropkey": "PW25744",
    "droptype": "D",
    "dropname": "SPRINGLAKE",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "SPRINGLAKE",
    "dropdelst": "TX",
    "dropdelzpp": 790829804,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "SPRINGLAKE",
    "dropphyst": "TX",
    "dropphyzpp": 790829804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGLAKE",
    "dropmalst": "TX",
    "dropmalzpp": 790829998,
    "dropsitphn": 8069864273,
    "dropsitlph": 8173173658,
    "dropsitcph": 8173173635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25745",
    "droptype": "D",
    "dropname": "SPRINGTOWN",
    "dropdeladd": "225 BONNIE BELL LN",
    "dropdelcty": "SPRINGTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 760829998,
    "dropphyadd": "225 BONNIE BELL LN",
    "dropphycty": "SPRINGTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 760829998,
    "dropmaladd": "225 BONNIE BELL LN",
    "dropmalcty": "SPRINGTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 760829998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175237266,
    "dropsitcph": 8175237266,
    "dropfax": 8175235390
  },
  {
    "dcode": "D",
    "dropkey": "PW25747",
    "droptype": "D",
    "dropname": "SPUR",
    "dropdeladd": "210 W HARRIS ST",
    "dropdelcty": "SPUR",
    "dropdelst": "TX",
    "dropdelzpp": 793709998,
    "dropphyadd": "210 W HARRIS ST",
    "dropphycty": "SPUR",
    "dropphyst": "TX",
    "dropphyzpp": 793709998,
    "dropmaladd": "210 W HARRIS ST",
    "dropmalcty": "SPUR",
    "dropmalst": "TX",
    "dropmalzpp": 793709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062713132,
    "dropsitcph": 8062713132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25748",
    "droptype": "D",
    "dropname": "SPURGER",
    "dropdeladd": "12385 FM 92 RD S",
    "dropdelcty": "SPURGER",
    "dropdelst": "TX",
    "dropdelzpp": 776600008,
    "dropphyadd": "12385 FM 92 RD S",
    "dropphycty": "SPURGER",
    "dropphyst": "TX",
    "dropphyzpp": 776600008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPURGER",
    "dropmalst": "TX",
    "dropmalzpp": 776609998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4094293834,
    "dropsitcph": 4094293834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25854",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "4110 BLUEBONNET DR",
    "dropdelcty": "STAFFORD",
    "dropdelst": "TX",
    "dropdelzpp": 774779998,
    "dropphyadd": "4110 BLUEBONNET DR",
    "dropphycty": "STAFFORD",
    "dropphyst": "TX",
    "dropphyzpp": 774779998,
    "dropmaladd": "4110 BLUEBONNET DR",
    "dropmalcty": "STAFFORD",
    "dropmalst": "TX",
    "dropmalzpp": 774779998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2812404975,
    "dropsitcph": 2814942248,
    "dropfax": 2812404318
  },
  {
    "dcode": "D",
    "dropkey": "PW25856",
    "droptype": "D",
    "dropname": "STAMFORD",
    "dropdeladd": "115 S SWENSON ST",
    "dropdelcty": "STAMFORD",
    "dropdelst": "TX",
    "dropdelzpp": 795539998,
    "dropphyadd": "115 S SWENSON ST",
    "dropphycty": "STAMFORD",
    "dropphyst": "TX",
    "dropphyzpp": 795539998,
    "dropmaladd": "115 S SWENSON ST",
    "dropmalcty": "STAMFORD",
    "dropmalst": "TX",
    "dropmalzpp": 795539998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257732452,
    "dropsitcph": 3257732452,
    "dropfax": 3257732307
  },
  {
    "dcode": "D",
    "dropkey": "PW25859",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "101 N SAINT MARY",
    "dropdelcty": "STANTON",
    "dropdelst": "TX",
    "dropdelzpp": 797829998,
    "dropphyadd": "101 N SAINT MARY",
    "dropphycty": "STANTON",
    "dropphyst": "TX",
    "dropphyzpp": 797829998,
    "dropmaladd": "101 N SAINT MARY",
    "dropmalcty": "STANTON",
    "dropmalst": "TX",
    "dropmalzpp": 797829998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4327563340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25860",
    "droptype": "D",
    "dropname": "STAPLES",
    "dropdeladd": "2585 ALLISON RD",
    "dropdelcty": "STAPLES",
    "dropdelst": "TX",
    "dropdelzpp": 786709800,
    "dropphyadd": "2585 ALLISON RD",
    "dropphycty": "STAPLES",
    "dropphyst": "TX",
    "dropphyzpp": 786709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAPLES",
    "dropmalst": "TX",
    "dropmalzpp": 786709998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123576888,
    "dropsitcph": 5123576888,
    "dropfax": 5123572740
  },
  {
    "dcode": "D",
    "dropkey": "PW25861",
    "droptype": "D",
    "dropname": "STAR",
    "dropdeladd": "39 FM 1047 S",
    "dropdelcty": "STAR",
    "dropdelst": "TX",
    "dropdelzpp": 768809801,
    "dropphyadd": "39 FM 1047 S",
    "dropphycty": "STAR",
    "dropphyst": "TX",
    "dropphyzpp": 768809801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAR",
    "dropmalst": "TX",
    "dropmalzpp": 768809998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3259483826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25873",
    "droptype": "D",
    "dropname": "STEPHENVILLE",
    "dropdeladd": "431 N GRAHAM ST",
    "dropdelcty": "STEPHENVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 764019998,
    "dropphyadd": "431 N GRAHAM ST",
    "dropphycty": "STEPHENVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 764019998,
    "dropmaladd": "431 N GRAHAM ST",
    "dropmalcty": "STEPHENVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 764019998,
    "dropsitphn": 8173173863,
    "dropsitlph": 2549655078,
    "dropsitcph": 2549655078,
    "dropfax": 2549651077
  },
  {
    "dcode": "D",
    "dropkey": "PW25874",
    "droptype": "D",
    "dropname": "STERLING CITY",
    "dropdeladd": "410 ELM ST",
    "dropdelcty": "STERLING CITY",
    "dropdelst": "TX",
    "dropdelzpp": 769519803,
    "dropphyadd": "410 ELM ST",
    "dropphycty": "STERLING CITY",
    "dropphyst": "TX",
    "dropphyzpp": 769519803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STERLING CITY",
    "dropmalst": "TX",
    "dropmalzpp": 769519998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3253782301,
    "dropsitcph": 3253782301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25879",
    "droptype": "D",
    "dropname": "STINNETT",
    "dropdeladd": "431 S MAIN ST",
    "dropdelcty": "STINNETT",
    "dropdelst": "TX",
    "dropdelzpp": 790839803,
    "dropphyadd": "431 S MAIN ST",
    "dropphycty": "STINNETT",
    "dropphyst": "TX",
    "dropphyzpp": 790839803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STINNETT",
    "dropmalst": "TX",
    "dropmalzpp": 790839998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068783121,
    "dropsitcph": 8068783121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25881",
    "droptype": "D",
    "dropname": "STOCKDALE",
    "dropdeladd": "102 W SALMON ST",
    "dropdelcty": "STOCKDALE",
    "dropdelst": "TX",
    "dropdelzpp": 781609998,
    "dropphyadd": "102 W SALMON ST",
    "dropphycty": "STOCKDALE",
    "dropphyst": "TX",
    "dropphyzpp": 781609998,
    "dropmaladd": "102 W SALMON ST",
    "dropmalcty": "STOCKDALE",
    "dropmalst": "TX",
    "dropmalzpp": 781609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309963931,
    "dropsitcph": 8309963931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25887",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "14490 E US HIGHWAY 290",
    "dropdelcty": "STONEWALL",
    "dropdelst": "TX",
    "dropdelzpp": 786719998,
    "dropphyadd": "14490 E US HIGHWAY 290",
    "dropphycty": "STONEWALL",
    "dropphyst": "TX",
    "dropphyzpp": 786719998,
    "dropmaladd": "14490 E US HIGHWAY 290",
    "dropmalcty": "STONEWALL",
    "dropmalst": "TX",
    "dropmalzpp": 786719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306442663,
    "dropsitcph": 8306442663,
    "dropfax": 8306442663
  },
  {
    "dcode": "D",
    "dropkey": "PW25889",
    "droptype": "D",
    "dropname": "STOWELL",
    "dropdeladd": "3608 STATE HIGHWAY 124",
    "dropdelcty": "STOWELL",
    "dropdelst": "TX",
    "dropdelzpp": 776610045,
    "dropphyadd": "3608 STATE HIGHWAY 124",
    "dropphycty": "STOWELL",
    "dropphyst": "TX",
    "dropphyzpp": 776610045,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOWELL",
    "dropmalst": "TX",
    "dropmalzpp": 776619998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092962823,
    "dropsitcph": 4092962823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25890",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "STRATFORD",
    "dropdelst": "TX",
    "dropdelzpp": 790849803,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "STRATFORD",
    "dropphyst": "TX",
    "dropphyzpp": 790849803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATFORD",
    "dropmalst": "TX",
    "dropmalzpp": 790849998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063962010,
    "dropsitcph": 8063962010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25892",
    "droptype": "D",
    "dropname": "STRAWN",
    "dropdeladd": "203 E HOUSLEY ST",
    "dropdelcty": "STRAWN",
    "dropdelst": "TX",
    "dropdelzpp": 764759998,
    "dropphyadd": "203 E HOUSLEY ST",
    "dropphycty": "STRAWN",
    "dropphyst": "TX",
    "dropphyzpp": 764759998,
    "dropmaladd": "203 E HOUSLEY ST",
    "dropmalcty": "STRAWN",
    "dropmalst": "TX",
    "dropmalzpp": 764759998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2546723054,
    "dropsitcph": 2546723054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25894",
    "droptype": "D",
    "dropname": "STREETMAN",
    "dropdeladd": "223 E MAIN ST",
    "dropdelcty": "STREETMAN",
    "dropdelst": "TX",
    "dropdelzpp": 758599998,
    "dropphyadd": "223 E MAIN ST",
    "dropphycty": "STREETMAN",
    "dropphyst": "TX",
    "dropphyzpp": 758599998,
    "dropmaladd": "223 E MAIN ST",
    "dropmalcty": "STREETMAN",
    "dropmalst": "TX",
    "dropmalzpp": 758599998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032299007,
    "dropsitcph": 9032299007,
    "dropfax": 9035994037
  },
  {
    "dcode": "D",
    "dropkey": "PW25899",
    "droptype": "D",
    "dropname": "SUDAN",
    "dropdeladd": "105 HORNET DR",
    "dropdelcty": "SUDAN",
    "dropdelst": "TX",
    "dropdelzpp": 793719804,
    "dropphyadd": "105 HORNET DR",
    "dropphycty": "SUDAN",
    "dropphyst": "TX",
    "dropphyzpp": 793719804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUDAN",
    "dropmalst": "TX",
    "dropmalzpp": 793719998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062272157,
    "dropsitcph": 8062272157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25901",
    "droptype": "D",
    "dropname": "SUGAR LAND",
    "dropdeladd": "225 MATLAGE WAY",
    "dropdelcty": "SUGAR LAND",
    "dropdelst": "TX",
    "dropdelzpp": 774789998,
    "dropphyadd": "225 MATLAGE WAY",
    "dropphycty": "SUGAR LAND",
    "dropphyst": "TX",
    "dropphyzpp": 774789998,
    "dropmaladd": "225 MATLAGE WAY",
    "dropmalcty": "SUGAR LAND",
    "dropmalst": "TX",
    "dropmalzpp": 774789998,
    "dropsitphn": 2812263055,
    "dropsitlph": 2814940013,
    "dropsitcph": 2814942052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25904",
    "droptype": "D",
    "dropname": "SULLIVAN CITY",
    "dropdeladd": "200 CENIZOS DR",
    "dropdelcty": "SULLIVAN CITY",
    "dropdelst": "TX",
    "dropdelzpp": 785959998,
    "dropphyadd": "200 CENIZOS DR",
    "dropphycty": "SULLIVAN CITY",
    "dropphyst": "TX",
    "dropphyzpp": 785959998,
    "dropmaladd": "200 CENIZOS DR",
    "dropmalcty": "SULLIVAN CITY",
    "dropmalst": "TX",
    "dropmalzpp": 785959998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564852531,
    "dropsitcph": 9564852531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25905",
    "droptype": "D",
    "dropname": "SULPHUR BLUFF",
    "dropdeladd": "12060 FARM ROAD 71 E",
    "dropdelcty": "SULPHUR BLUFF",
    "dropdelst": "TX",
    "dropdelzpp": 754819998,
    "dropphyadd": "12060 FARM ROAD 71 E",
    "dropphycty": "SULPHUR BLUFF",
    "dropphyst": "TX",
    "dropphyzpp": 754819998,
    "dropmaladd": "12060 FARM ROAD 71 E",
    "dropmalcty": "SULPHUR BLUFF",
    "dropmalst": "TX",
    "dropmalzpp": 754819998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039452975,
    "dropsitcph": 9039452975,
    "dropfax": 9039453478
  },
  {
    "dcode": "D",
    "dropkey": "PW25906",
    "droptype": "D",
    "dropname": "SULPHUR SPRINGS",
    "dropdeladd": "320 CHURCH ST",
    "dropdelcty": "SULPHUR SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 754829998,
    "dropphyadd": "320 CHURCH ST",
    "dropphycty": "SULPHUR SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 754829998,
    "dropmaladd": "320 CHURCH ST",
    "dropmalcty": "SULPHUR SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 754829998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9038852771,
    "dropsitcph": 9038852771,
    "dropfax": 9038856246
  },
  {
    "dcode": "D",
    "dropkey": "PW25910",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "10182 FARM ROAD 79",
    "dropdelcty": "SUMNER",
    "dropdelst": "TX",
    "dropdelzpp": 754865541,
    "dropphyadd": "10182 FARM ROAD 79",
    "dropphycty": "SUMNER",
    "dropphyst": "TX",
    "dropphyzpp": 754865541,
    "dropmaladd": "10182 FARM ROAD 79",
    "dropmalcty": "SUMNER",
    "dropmalst": "TX",
    "dropmalzpp": 754865541,
    "dropsitphn": 2144675879,
    "dropsitlph": 9037852058,
    "dropsitcph": 9037852058,
    "dropfax": 9037852058
  },
  {
    "dcode": "D",
    "dropkey": "PW25912",
    "droptype": "D",
    "dropname": "SUNDOWN",
    "dropdeladd": "807 S SLAUGHTER AVE",
    "dropdelcty": "SUNDOWN",
    "dropdelst": "TX",
    "dropdelzpp": 793729800,
    "dropphyadd": "807 S SLAUGHTER AVE",
    "dropphycty": "SUNDOWN",
    "dropphyst": "TX",
    "dropphyzpp": 793729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNDOWN",
    "dropmalst": "TX",
    "dropmalzpp": 793729998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062292541,
    "dropsitcph": 8062292541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25916",
    "droptype": "D",
    "dropname": "SUNRAY",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "SUNRAY",
    "dropdelst": "TX",
    "dropdelzpp": 790869802,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "SUNRAY",
    "dropphyst": "TX",
    "dropphyzpp": 790869802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNRAY",
    "dropmalst": "TX",
    "dropmalzpp": 790869998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069485303,
    "dropsitcph": 8069485303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25921",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "107 HIGHWAY 101 W",
    "dropdelcty": "SUNSET",
    "dropdelst": "TX",
    "dropdelzpp": 762709998,
    "dropphyadd": "107 HIGHWAY 101 W",
    "dropphycty": "SUNSET",
    "dropphyst": "TX",
    "dropphyzpp": 762709998,
    "dropmaladd": "107 HIGHWAY 101 W",
    "dropmalcty": "SUNSET",
    "dropmalst": "TX",
    "dropmalzpp": 762709998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408451158,
    "dropsitcph": 9408451158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25926",
    "droptype": "D",
    "dropname": "SUTHERLAND SPRINGS",
    "dropdeladd": "6230 US HIGHWAY 87 W",
    "dropdelcty": "SUTHERLAND SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 781619998,
    "dropphyadd": "6230 US HIGHWAY 87 W",
    "dropphycty": "SUTHERLAND SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 781619998,
    "dropmaladd": "6230 US HIGHWAY 87 W",
    "dropmalcty": "SUTHERLAND SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 781619998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309473644,
    "dropsitcph": 8309473644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25930",
    "droptype": "D",
    "dropname": "SWEENY",
    "dropdeladd": "301 E 2ND ST",
    "dropdelcty": "SWEENY",
    "dropdelst": "TX",
    "dropdelzpp": 774809998,
    "dropphyadd": "301 E 2ND ST",
    "dropphycty": "SWEENY",
    "dropphyst": "TX",
    "dropphyzpp": 774809998,
    "dropmaladd": "301 E 2ND ST",
    "dropmalcty": "SWEENY",
    "dropmalst": "TX",
    "dropmalzpp": 774809998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795482690,
    "dropsitcph": 9795482690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25932",
    "droptype": "D",
    "dropname": "SWEET HOME",
    "dropdeladd": "22 COUNTY ROAD 391E",
    "dropdelcty": "SWEET HOME",
    "dropdelst": "TX",
    "dropdelzpp": 779879800,
    "dropphyadd": "22 COUNTY ROAD 391E",
    "dropphycty": "SWEET HOME",
    "dropphyst": "TX",
    "dropphyzpp": 779879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWEET HOME",
    "dropmalst": "TX",
    "dropmalzpp": 779879998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612933876,
    "dropsitcph": 3612933876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25933",
    "droptype": "D",
    "dropname": "SWEETWATER",
    "dropdeladd": "201 E 3RD ST",
    "dropdelcty": "SWEETWATER",
    "dropdelst": "TX",
    "dropdelzpp": 795569998,
    "dropphyadd": "201 E 3RD ST",
    "dropphycty": "SWEETWATER",
    "dropphyst": "TX",
    "dropphyzpp": 795569998,
    "dropmaladd": "201 E 3RD ST",
    "dropmalcty": "SWEETWATER",
    "dropmalst": "TX",
    "dropmalzpp": 795569998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3252352471,
    "dropsitcph": 3252352471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25938",
    "droptype": "D",
    "dropname": "SYLVESTER",
    "dropdeladd": "399 FM 57 S",
    "dropdelcty": "SYLVESTER",
    "dropdelst": "TX",
    "dropdelzpp": 795609998,
    "dropphyadd": "399 FM 57 S",
    "dropphycty": "SYLVESTER",
    "dropphyst": "TX",
    "dropphyzpp": 795609998,
    "dropmaladd": "399 FM 57 S",
    "dropmalcty": "SYLVESTER",
    "dropmalst": "TX",
    "dropmalzpp": 795609998,
    "dropsitphn": 3259934555,
    "dropsitlph": 3259934555,
    "dropsitcph": 3259934555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25943",
    "droptype": "D",
    "dropname": "TAFT",
    "dropdeladd": "110 VICTORIA AVE",
    "dropdelcty": "TAFT",
    "dropdelst": "TX",
    "dropdelzpp": 783909998,
    "dropphyadd": "110 VICTORIA AVE",
    "dropphycty": "TAFT",
    "dropphyst": "TX",
    "dropphyzpp": 783909998,
    "dropmaladd": "110 VICTORIA AVE",
    "dropmalcty": "TAFT",
    "dropmalst": "TX",
    "dropmalzpp": 783909998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615282844,
    "dropsitcph": 3615282844,
    "dropfax": 3615284028
  },
  {
    "dcode": "D",
    "dropkey": "PW25944",
    "droptype": "D",
    "dropname": "TAHOKA",
    "dropdeladd": "1525 CONWAY ST",
    "dropdelcty": "TAHOKA",
    "dropdelst": "TX",
    "dropdelzpp": 793739803,
    "dropphyadd": "1525 CONWAY ST",
    "dropphycty": "TAHOKA",
    "dropphyst": "TX",
    "dropphyzpp": 793739803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAHOKA",
    "dropmalst": "TX",
    "dropmalzpp": 793739998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069984322,
    "dropsitcph": 8069984322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25946",
    "droptype": "D",
    "dropname": "TALCO",
    "dropdeladd": "307 W BROAD ST",
    "dropdelcty": "TALCO",
    "dropdelst": "TX",
    "dropdelzpp": 754879998,
    "dropphyadd": "307 W BROAD ST",
    "dropphycty": "TALCO",
    "dropphyst": "TX",
    "dropphyzpp": 754879998,
    "dropmaladd": "307 W BROAD ST",
    "dropmalcty": "TALCO",
    "dropmalst": "TX",
    "dropmalzpp": 754879998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033794711,
    "dropsitcph": 9033794711,
    "dropfax": 9033799801
  },
  {
    "dcode": "D",
    "dropkey": "PW25947",
    "droptype": "D",
    "dropname": "TALPA",
    "dropdeladd": "110 2ND ST",
    "dropdelcty": "TALPA",
    "dropdelst": "TX",
    "dropdelzpp": 768829802,
    "dropphyadd": "110 2ND ST",
    "dropphycty": "TALPA",
    "dropphyst": "TX",
    "dropphyzpp": 768829802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALPA",
    "dropmalst": "TX",
    "dropmalzpp": 768829998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3253653123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25955",
    "droptype": "D",
    "dropname": "TARPLEY",
    "dropdeladd": "161 THOMAS CREEK RD",
    "dropdelcty": "TARPLEY",
    "dropdelst": "TX",
    "dropdelzpp": 788839998,
    "dropphyadd": "161 THOMAS CREEK RD",
    "dropphycty": "TARPLEY",
    "dropphyst": "TX",
    "dropphyzpp": 788839998,
    "dropmaladd": "161 THOMAS CREEK RD",
    "dropmalcty": "TARPLEY",
    "dropmalst": "TX",
    "dropmalzpp": 788839998,
    "dropsitphn": 8303688387,
    "dropsitlph": 8305623274,
    "dropsitcph": 8305623274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25958",
    "droptype": "D",
    "dropname": "TARZAN",
    "dropdeladd": "2764 STATE HIGHWAY 176",
    "dropdelcty": "TARZAN",
    "dropdelst": "TX",
    "dropdelzpp": 797839998,
    "dropphyadd": "2764 STATE HIGHWAY 176",
    "dropphycty": "TARZAN",
    "dropphyst": "TX",
    "dropphyzpp": 797839998,
    "dropmaladd": "2764 STATE HIGHWAY 176",
    "dropmalcty": "TARZAN",
    "dropmalst": "TX",
    "dropmalzpp": 797839998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4324592479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25960",
    "droptype": "D",
    "dropname": "TATUM",
    "dropdeladd": "165 N HOOD ST",
    "dropdelcty": "TATUM",
    "dropdelst": "TX",
    "dropdelzpp": 756919998,
    "dropphyadd": "165 N HOOD ST",
    "dropphycty": "TATUM",
    "dropphyst": "TX",
    "dropphyzpp": 756919998,
    "dropmaladd": "165 N HOOD ST",
    "dropmalcty": "TATUM",
    "dropmalst": "TX",
    "dropmalzpp": 756919998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9032919033,
    "dropsitcph": 9032919033,
    "dropfax": 9039472299
  },
  {
    "dcode": "D",
    "dropkey": "PW25962",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "202 W 4TH ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "TX",
    "dropdelzpp": 765749998,
    "dropphyadd": "202 W 4TH ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "TX",
    "dropphyzpp": 765749998,
    "dropmaladd": "202 W 4TH ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "TX",
    "dropmalzpp": 765749998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123523162,
    "dropsitcph": 5123523162,
    "dropfax": 5123526262
  },
  {
    "dcode": "D",
    "dropkey": "PW25964",
    "droptype": "D",
    "dropname": "TEAGUE",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "TEAGUE",
    "dropdelst": "TX",
    "dropdelzpp": 758609998,
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "TEAGUE",
    "dropphyst": "TX",
    "dropphyzpp": 758609998,
    "dropmaladd": "320 MAIN ST",
    "dropmalcty": "TEAGUE",
    "dropmalst": "TX",
    "dropmalzpp": 758609998,
    "dropsitphn": 2144675879,
    "dropsitlph": 2547392101,
    "dropsitcph": 2547392101,
    "dropfax": 2547395957
  },
  {
    "dcode": "D",
    "dropkey": "PW25967",
    "droptype": "D",
    "dropname": "TEHUACANA",
    "dropdeladd": "208 S RAILROAD ST",
    "dropdelcty": "TEHUACANA",
    "dropdelst": "TX",
    "dropdelzpp": 766869800,
    "dropphyadd": "208 S RAILROAD ST",
    "dropphycty": "TEHUACANA",
    "dropphyst": "TX",
    "dropphyzpp": 766869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEHUACANA",
    "dropmalst": "TX",
    "dropmalzpp": 766869998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543954469,
    "dropsitcph": 2543954469,
    "dropfax": 2543954469
  },
  {
    "dcode": "D",
    "dropkey": "PW25968",
    "droptype": "D",
    "dropname": "TELEGRAPH",
    "dropdeladd": "14188 US HIGHWAY 377 S",
    "dropdelcty": "TELEGRAPH",
    "dropdelst": "TX",
    "dropdelzpp": 768839816,
    "dropphyadd": "14188 US HIGHWAY 377 S",
    "dropphycty": "TELEGRAPH",
    "dropphyst": "TX",
    "dropphyzpp": 768839816,
    "dropmaladd": "14188 US HIGHWAY 377 S",
    "dropmalcty": "TELEGRAPH",
    "dropmalst": "TX",
    "dropmalzpp": 768839816,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3254468667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25969",
    "droptype": "D",
    "dropname": "TELEPHONE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "TELEPHONE",
    "dropdelst": "TX",
    "dropdelzpp": 754889998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "TELEPHONE",
    "dropphyst": "TX",
    "dropphyzpp": 754889998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "TELEPHONE",
    "dropmalst": "TX",
    "dropmalzpp": 754889998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036642888,
    "dropsitcph": 9036642888,
    "dropfax": 9036642888
  },
  {
    "dcode": "D",
    "dropkey": "PW25970",
    "droptype": "D",
    "dropname": "TELFERNER",
    "dropdeladd": "319 FM 1686",
    "dropdelcty": "TELFERNER",
    "dropdelst": "TX",
    "dropdelzpp": 779889800,
    "dropphyadd": "319 FM 1686",
    "dropphycty": "TELFERNER",
    "dropphyst": "TX",
    "dropphyzpp": 779889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TELFERNER",
    "dropmalst": "TX",
    "dropmalzpp": 779889998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615780335,
    "dropsitcph": 3615780335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25972",
    "droptype": "D",
    "dropname": "TELL",
    "dropdeladd": "14900 FM 2042",
    "dropdelcty": "TELL",
    "dropdelst": "TX",
    "dropdelzpp": 792593000,
    "dropphyadd": "14900 FM 2042",
    "dropphycty": "TELL",
    "dropphyst": "TX",
    "dropphyzpp": 792593000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TELL",
    "dropmalst": "TX",
    "dropmalzpp": 792599998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8179373741,
    "dropsitcph": 8179373741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25973",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "401 N MAIN ST",
    "dropdelcty": "TEMPLE",
    "dropdelst": "TX",
    "dropdelzpp": 765019998,
    "dropphyadd": "401 N MAIN ST",
    "dropphycty": "TEMPLE",
    "dropphyst": "TX",
    "dropphyzpp": 765019998,
    "dropmaladd": "401 N MAIN ST",
    "dropmalcty": "TEMPLE",
    "dropmalst": "TX",
    "dropmalzpp": 765019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547730792,
    "dropsitcph": 2547730792,
    "dropfax": 2547715866
  },
  {
    "dcode": "D",
    "dropkey": "PW25975",
    "droptype": "D",
    "dropname": "TENAHA",
    "dropdeladd": "152 S GEORGE BOWERS DR",
    "dropdelcty": "TENAHA",
    "dropdelst": "TX",
    "dropdelzpp": 759749998,
    "dropphyadd": "152 S GEORGE BOWERS DR",
    "dropphycty": "TENAHA",
    "dropphyst": "TX",
    "dropphyzpp": 759749998,
    "dropmaladd": "152 S GEORGE BOWERS DR",
    "dropmalcty": "TENAHA",
    "dropmalst": "TX",
    "dropmalzpp": 759749998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362483031,
    "dropsitcph": 9362483031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25978",
    "droptype": "D",
    "dropname": "TENNESSEE COLONY",
    "dropdeladd": "1816 FM 645",
    "dropdelcty": "TENNESSEE COLONY",
    "dropdelst": "TX",
    "dropdelzpp": 758619998,
    "dropphyadd": "1816 FM 645",
    "dropphycty": "TENNESSEE COLONY",
    "dropphyst": "TX",
    "dropphyzpp": 758619998,
    "dropmaladd": "1816 FM 645",
    "dropmalcty": "TENNESSEE COLONY",
    "dropmalst": "TX",
    "dropmalzpp": 758619998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039282626,
    "dropsitcph": 9039282626,
    "dropfax": 9039282470
  },
  {
    "dcode": "D",
    "dropkey": "PW25979",
    "droptype": "D",
    "dropname": "TENNYSON",
    "dropdeladd": "11301 HIGHWAY 277",
    "dropdelcty": "TENNYSON",
    "dropdelst": "TX",
    "dropdelzpp": 769539800,
    "dropphyadd": "11301 HIGHWAY 277",
    "dropphycty": "TENNYSON",
    "dropphyst": "TX",
    "dropphyzpp": 769539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TENNYSON",
    "dropmalst": "TX",
    "dropmalzpp": 769539998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254736002,
    "dropsitcph": 3254736002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25981",
    "droptype": "D",
    "dropname": "TERLINGUA",
    "dropdeladd": "53600 TX HIGHWAY 118",
    "dropdelcty": "TERLINGUA",
    "dropdelst": "TX",
    "dropdelzpp": 798529998,
    "dropphyadd": "53600 TX HIGHWAY 118",
    "dropphycty": "TERLINGUA",
    "dropphyst": "TX",
    "dropphyzpp": 798529998,
    "dropmaladd": "53600 TX HIGHWAY 118",
    "dropmalcty": "TERLINGUA",
    "dropmalst": "TX",
    "dropmalzpp": 798529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4323712269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW25982",
    "droptype": "D",
    "dropname": "TERRELL",
    "dropdeladd": "1250 STATE HIGHWAY 34 S",
    "dropdelcty": "TERRELL",
    "dropdelst": "TX",
    "dropdelzpp": 751609998,
    "dropphyadd": "1250 STATE HIGHWAY 34 S",
    "dropphycty": "TERRELL",
    "dropphyst": "TX",
    "dropphyzpp": 751609998,
    "dropmaladd": "1250 STATE HIGHWAY 34 S",
    "dropmalcty": "TERRELL",
    "dropmalst": "TX",
    "dropmalzpp": 751609998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9725632708,
    "dropsitcph": 9725632708,
    "dropfax": 9725633147
  },
  {
    "dcode": "D",
    "dropkey": "PW25988",
    "droptype": "D",
    "dropname": "TEXARKANA",
    "dropdeladd": "2211 N ROBISON RD",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "TX",
    "dropdelzpp": 755019998,
    "dropphyadd": "2211 N ROBISON RD",
    "dropphycty": "TEXARKANA",
    "dropphyst": "TX",
    "dropphyzpp": 755019998,
    "dropmaladd": "2211 N ROBISON RD",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "TX",
    "dropmalzpp": 755019998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032233823,
    "dropsitcph": 9032233800,
    "dropfax": 2144678145
  },
  {
    "dcode": "D",
    "dropkey": "PW25992",
    "droptype": "D",
    "dropname": "TEXAS CITY",
    "dropdeladd": "2002 11TH AVE N",
    "dropdelcty": "TEXAS CITY",
    "dropdelst": "TX",
    "dropdelzpp": 775909998,
    "dropphyadd": "2002 11TH AVE N",
    "dropphycty": "TEXAS CITY",
    "dropphyst": "TX",
    "dropphyzpp": 775909998,
    "dropmaladd": "2002 11TH AVE N",
    "dropmalcty": "TEXAS CITY",
    "dropmalst": "TX",
    "dropmalzpp": 775909998,
    "dropsitphn": 4099481578,
    "dropsitlph": 4099481578,
    "dropsitcph": 4099481578,
    "dropfax": 4099480045
  },
  {
    "dcode": "D",
    "dropkey": "PW26006",
    "droptype": "D",
    "dropname": "TEXLINE",
    "dropdeladd": "303 S 2ND ST",
    "dropdelcty": "TEXLINE",
    "dropdelst": "TX",
    "dropdelzpp": 790879802,
    "dropphyadd": "303 S 2ND ST",
    "dropphycty": "TEXLINE",
    "dropphyst": "TX",
    "dropphyzpp": 790879802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEXLINE",
    "dropmalst": "TX",
    "dropmalzpp": 790879998,
    "dropsitphn": 3252382148,
    "dropsitlph": 3252382148,
    "dropsitcph": 3252382155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26017",
    "droptype": "D",
    "dropname": "THICKET",
    "dropdeladd": "23394 FM 1293",
    "dropdelcty": "THICKET",
    "dropdelst": "TX",
    "dropdelzpp": 773740237,
    "dropphyadd": "23394 FM 1293",
    "dropphycty": "THICKET",
    "dropphyst": "TX",
    "dropphyzpp": 773740237,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THICKET",
    "dropmalst": "TX",
    "dropmalzpp": 773749998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362745860,
    "dropsitcph": 9362745860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26019",
    "droptype": "D",
    "dropname": "THOMASTON",
    "dropdeladd": "264 FORDTRAN RD",
    "dropdelcty": "THOMASTON",
    "dropdelst": "TX",
    "dropdelzpp": 779899800,
    "dropphyadd": "264 FORDTRAN RD",
    "dropphycty": "THOMASTON",
    "dropphyst": "TX",
    "dropphyzpp": 779899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMASTON",
    "dropmalst": "TX",
    "dropmalzpp": 779899998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612755550,
    "dropsitcph": 3612755550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26020",
    "droptype": "D",
    "dropname": "THOMPSONS",
    "dropdeladd": "222 OILFIELD RD",
    "dropdelcty": "THOMPSONS",
    "dropdelst": "TX",
    "dropdelzpp": 774819800,
    "dropphyadd": "222 OILFIELD RD",
    "dropphycty": "THOMPSONS",
    "dropphyst": "TX",
    "dropphyzpp": 774819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMPSONS",
    "dropmalst": "TX",
    "dropmalzpp": 774819998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813431021,
    "dropsitcph": 2813431021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26022",
    "droptype": "D",
    "dropname": "THORNDALE",
    "dropdeladd": "107 N 1ST ST",
    "dropdelcty": "THORNDALE",
    "dropdelst": "TX",
    "dropdelzpp": 765779998,
    "dropphyadd": "107 N 1ST ST",
    "dropphycty": "THORNDALE",
    "dropphyst": "TX",
    "dropphyzpp": 765779998,
    "dropmaladd": "107 N 1ST ST",
    "dropmalcty": "THORNDALE",
    "dropmalst": "TX",
    "dropmalzpp": 765779998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128982212,
    "dropsitcph": 5128982212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26023",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "1008 MARSHALL ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "TX",
    "dropdelzpp": 766879998,
    "dropphyadd": "1008 MARSHALL ST",
    "dropphycty": "THORNTON",
    "dropphyst": "TX",
    "dropphyzpp": 766879998,
    "dropmaladd": "1008 MARSHALL ST",
    "dropmalcty": "THORNTON",
    "dropmalst": "TX",
    "dropmalzpp": 766879998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543856548,
    "dropsitcph": 2543856548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26025",
    "droptype": "D",
    "dropname": "THRALL",
    "dropdeladd": "101 E SHELDON AVE",
    "dropdelcty": "THRALL",
    "dropdelst": "TX",
    "dropdelzpp": 765789998,
    "dropphyadd": "101 E SHELDON AVE",
    "dropphycty": "THRALL",
    "dropphyst": "TX",
    "dropphyzpp": 765789998,
    "dropmaladd": "101 E SHELDON AVE",
    "dropmalcty": "THRALL",
    "dropmalst": "TX",
    "dropmalzpp": 765789998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128982011,
    "dropsitcph": 5128982011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26027",
    "droptype": "D",
    "dropname": "THREE RIVERS",
    "dropdeladd": "110 E ALEXANDER",
    "dropdelcty": "THREE RIVERS",
    "dropdelst": "TX",
    "dropdelzpp": 780719998,
    "dropphyadd": "110 E ALEXANDER",
    "dropphycty": "THREE RIVERS",
    "dropphyst": "TX",
    "dropphyzpp": 780719998,
    "dropmaladd": "110 E ALEXANDER",
    "dropmalcty": "THREE RIVERS",
    "dropmalst": "TX",
    "dropmalzpp": 780719998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3617862639,
    "dropsitcph": 3617862639,
    "dropfax": 3617863549
  },
  {
    "dcode": "D",
    "dropkey": "PW26030",
    "droptype": "D",
    "dropname": "THROCKMORTON",
    "dropdeladd": "233 N MINTER AVE",
    "dropdelcty": "THROCKMORTON",
    "dropdelst": "TX",
    "dropdelzpp": 764839998,
    "dropphyadd": "233 N MINTER AVE",
    "dropphycty": "THROCKMORTON",
    "dropphyst": "TX",
    "dropphyzpp": 764839998,
    "dropmaladd": "233 N MINTER AVE",
    "dropmalcty": "THROCKMORTON",
    "dropmalst": "TX",
    "dropmalzpp": 764839998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9408494741,
    "dropsitcph": 9408494741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26033",
    "droptype": "D",
    "dropname": "TILDEN",
    "dropdeladd": "306 RIVER ST",
    "dropdelcty": "TILDEN",
    "dropdelst": "TX",
    "dropdelzpp": 780729998,
    "dropphyadd": "306 RIVER ST",
    "dropphycty": "TILDEN",
    "dropphyst": "TX",
    "dropphyzpp": 780729998,
    "dropmaladd": "306 RIVER ST",
    "dropmalcty": "TILDEN",
    "dropmalst": "TX",
    "dropmalzpp": 780729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122743222,
    "dropsitcph": 5122743222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26037",
    "droptype": "D",
    "dropname": "TIMPSON",
    "dropdeladd": "437 BEAR DR",
    "dropdelcty": "TIMPSON",
    "dropdelst": "TX",
    "dropdelzpp": 759759998,
    "dropphyadd": "437 BEAR DR",
    "dropphycty": "TIMPSON",
    "dropphyst": "TX",
    "dropphyzpp": 759759998,
    "dropmaladd": "437 BEAR DR",
    "dropmalcty": "TIMPSON",
    "dropmalst": "TX",
    "dropmalzpp": 759759998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362543180,
    "dropsitcph": 9362543180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26038",
    "droptype": "D",
    "dropname": "TIOGA",
    "dropdeladd": "301 N RAY ROBERTS PKWY",
    "dropdelcty": "TIOGA",
    "dropdelst": "TX",
    "dropdelzpp": 762719998,
    "dropphyadd": "301 N RAY ROBERTS PKWY",
    "dropphycty": "TIOGA",
    "dropphyst": "TX",
    "dropphyzpp": 762719998,
    "dropmaladd": "301 N RAY ROBERTS PKWY",
    "dropmalcty": "TIOGA",
    "dropmalst": "TX",
    "dropmalzpp": 762719998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404372412,
    "dropsitcph": 9404372412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26039",
    "droptype": "D",
    "dropname": "TIVOLI",
    "dropdeladd": "211 W SCOTT ST",
    "dropdelcty": "TIVOLI",
    "dropdelst": "TX",
    "dropdelzpp": 779909998,
    "dropphyadd": "211 W SCOTT ST",
    "dropphycty": "TIVOLI",
    "dropphyst": "TX",
    "dropphyzpp": 779909998,
    "dropmaladd": "211 W SCOTT ST",
    "dropmalcty": "TIVOLI",
    "dropmalst": "TX",
    "dropmalzpp": 779909998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612863577,
    "dropsitcph": 3612863577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26044",
    "droptype": "D",
    "dropname": "TOLAR",
    "dropdeladd": "9101 W US HIGHWAY 377",
    "dropdelcty": "TOLAR",
    "dropdelst": "TX",
    "dropdelzpp": 764769998,
    "dropphyadd": "9101 W US HIGHWAY 377",
    "dropphycty": "TOLAR",
    "dropphyst": "TX",
    "dropphyzpp": 764769998,
    "dropmaladd": "9101 W US HIGHWAY 377",
    "dropmalcty": "TOLAR",
    "dropmalst": "TX",
    "dropmalzpp": 764769998,
    "dropsitphn": 8173173658,
    "dropsitlph": 2548354540,
    "dropsitcph": 2548354540,
    "dropfax": 2548354940
  },
  {
    "dcode": "D",
    "dropkey": "PW26046",
    "droptype": "D",
    "dropname": "TOM BEAN",
    "dropdeladd": "105 BRITTON ST",
    "dropdelcty": "TOM BEAN",
    "dropdelst": "TX",
    "dropdelzpp": 754899700,
    "dropphyadd": "105 BRITTON ST",
    "dropphycty": "TOM BEAN",
    "dropphyst": "TX",
    "dropphyzpp": 754899700,
    "dropmaladd": "105 BRITTON ST",
    "dropmalcty": "TOM BEAN",
    "dropmalst": "TX",
    "dropmalzpp": 754899700,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035466711,
    "dropsitcph": 9035466711,
    "dropfax": 9035466711
  },
  {
    "dcode": "D",
    "dropkey": "PW26047",
    "droptype": "D",
    "dropname": "TOMBALL",
    "dropdeladd": "122 N HOLDERRIETH BLVD",
    "dropdelcty": "TOMBALL",
    "dropdelst": "TX",
    "dropdelzpp": 773759998,
    "dropphyadd": "122 N HOLDERRIETH BLVD",
    "dropphycty": "TOMBALL",
    "dropphyst": "TX",
    "dropphyzpp": 773759998,
    "dropmaladd": "122 N HOLDERRIETH BLVD",
    "dropmalcty": "TOMBALL",
    "dropmalst": "TX",
    "dropmalzpp": 773759998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2812900392,
    "dropsitcph": 2815160513,
    "dropfax": 2813511580
  },
  {
    "dcode": "D",
    "dropkey": "PW26049",
    "droptype": "D",
    "dropname": "TORNILLO",
    "dropdeladd": "19280 COBB ST",
    "dropdelcty": "TORNILLO",
    "dropdelst": "TX",
    "dropdelzpp": 798539998,
    "dropphyadd": "19280 COBB ST",
    "dropphycty": "TORNILLO",
    "dropphyst": "TX",
    "dropphyzpp": 798539998,
    "dropmaladd": "19280 COBB ST",
    "dropmalcty": "TORNILLO",
    "dropmalst": "TX",
    "dropmalzpp": 798539998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 9157643573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26051",
    "droptype": "D",
    "dropname": "TOW",
    "dropdeladd": "16910 RANCH ROAD 2241",
    "dropdelcty": "TOW",
    "dropdelst": "TX",
    "dropdelzpp": 786729998,
    "dropphyadd": "16910 RANCH ROAD 2241",
    "dropphycty": "TOW",
    "dropphyst": "TX",
    "dropphyzpp": 786729998,
    "dropmaladd": "16910 RANCH ROAD 2241",
    "dropmalcty": "TOW",
    "dropmalst": "TX",
    "dropmalzpp": 786729998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3253792281,
    "dropsitcph": 3253792281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26056",
    "droptype": "D",
    "dropname": "TOYAH",
    "dropdeladd": "1984 W FRONTAGE I 20",
    "dropdelcty": "TOYAH",
    "dropdelst": "TX",
    "dropdelzpp": 797859800,
    "dropphyadd": "1984 W FRONTAGE I 20",
    "dropphycty": "TOYAH",
    "dropphyst": "TX",
    "dropphyzpp": 797859800,
    "dropmaladd": "1984 W FRONTAGE I 20",
    "dropmalcty": "TOYAH",
    "dropmalst": "TX",
    "dropmalzpp": 797859800,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4322593420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26057",
    "droptype": "D",
    "dropname": "TOYAHVALE",
    "dropdeladd": "115 N FORT WORTH ST",
    "dropdelcty": "BALMORHEA",
    "dropdelst": "TX",
    "dropdelzpp": 797189998,
    "dropphyadd": "115 N FORT WORTH ST",
    "dropphycty": "BALMORHEA",
    "dropphyst": "TX",
    "dropphyzpp": 797189997,
    "dropmaladd": "115 N FORT WORTH ST",
    "dropmalcty": "BALMORHEA",
    "dropmalst": "TX",
    "dropmalzpp": 797189998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323752254,
    "dropsitcph": 4323752254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26063",
    "droptype": "D",
    "dropname": "TRENT",
    "dropdeladd": "141 N MAIN ST",
    "dropdelcty": "TRENT",
    "dropdelst": "TX",
    "dropdelzpp": 795619998,
    "dropphyadd": "141 N MAIN ST",
    "dropphycty": "TRENT",
    "dropphyst": "TX",
    "dropphyzpp": 795619998,
    "dropmaladd": "141 N MAIN ST",
    "dropmalcty": "TRENT",
    "dropmalst": "TX",
    "dropmalzpp": 795619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3258626241,
    "dropsitcph": 3258626241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26064",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "200 HAMILTON ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "TX",
    "dropdelzpp": 754909998,
    "dropphyadd": "200 HAMILTON ST",
    "dropphycty": "TRENTON",
    "dropphyst": "TX",
    "dropphyzpp": 754909998,
    "dropmaladd": "200 HAMILTON ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "TX",
    "dropmalzpp": 754909998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9039895561,
    "dropsitcph": 9039895561,
    "dropfax": 9039895151
  },
  {
    "dcode": "D",
    "dropkey": "PW26067",
    "droptype": "D",
    "dropname": "TRINIDAD",
    "dropdeladd": "206 PARK ST",
    "dropdelcty": "TRINIDAD",
    "dropdelst": "TX",
    "dropdelzpp": 751639998,
    "dropphyadd": "206 PARK ST",
    "dropphycty": "TRINIDAD",
    "dropphyst": "TX",
    "dropphyzpp": 751639998,
    "dropmaladd": "206 PARK ST",
    "dropmalcty": "TRINIDAD",
    "dropmalst": "TX",
    "dropmalzpp": 751639998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9037782666,
    "dropsitcph": 9037782666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26068",
    "droptype": "D",
    "dropname": "TRINITY",
    "dropdeladd": "116 W MAIN ST",
    "dropdelcty": "TRINITY",
    "dropdelst": "TX",
    "dropdelzpp": 758629998,
    "dropphyadd": "116 W MAIN ST",
    "dropphycty": "TRINITY",
    "dropphyst": "TX",
    "dropphyzpp": 758629998,
    "dropmaladd": "116 W MAIN ST",
    "dropmalcty": "TRINITY",
    "dropmalst": "TX",
    "dropmalzpp": 758629998,
    "dropsitphn": 9365942331,
    "dropsitlph": 9365942331,
    "dropsitcph": 9365942331,
    "dropfax": 9365942331
  },
  {
    "dcode": "D",
    "dropkey": "PW26071",
    "droptype": "D",
    "dropname": "TROUP",
    "dropdeladd": "104 E DUVAL ST",
    "dropdelcty": "TROUP",
    "dropdelst": "TX",
    "dropdelzpp": 757899998,
    "dropphyadd": "104 E DUVAL ST",
    "dropphycty": "TROUP",
    "dropphyst": "TX",
    "dropphyzpp": 757899998,
    "dropmaladd": "104 E DUVAL ST",
    "dropmalcty": "TROUP",
    "dropmalst": "TX",
    "dropmalzpp": 757899998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038424413,
    "dropsitcph": 9038424413,
    "dropfax": 9038423646
  },
  {
    "dcode": "D",
    "dropkey": "PW26073",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "10 FRONT ST",
    "dropdelcty": "TROY",
    "dropdelst": "TX",
    "dropdelzpp": 765799998,
    "dropphyadd": "10 FRONT ST",
    "dropphycty": "TROY",
    "dropphyst": "TX",
    "dropphyzpp": 765799998,
    "dropmaladd": "10 FRONT ST",
    "dropmalcty": "TROY",
    "dropmalst": "TX",
    "dropmalzpp": 765799998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549382641,
    "dropsitcph": 2549382641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26075",
    "droptype": "D",
    "dropname": "TULETA",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "TULETA",
    "dropdelst": "TX",
    "dropdelzpp": 781629800,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "TULETA",
    "dropphyst": "TX",
    "dropphyzpp": 781629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TULETA",
    "dropmalst": "TX",
    "dropmalzpp": 781629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3613752290,
    "dropsitcph": 3613752290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26076",
    "droptype": "D",
    "dropname": "TULIA",
    "dropdeladd": "129 N ARMSTRONG AVE",
    "dropdelcty": "TULIA",
    "dropdelst": "TX",
    "dropdelzpp": 790889998,
    "dropphyadd": "129 N ARMSTRONG AVE",
    "dropphycty": "TULIA",
    "dropphyst": "TX",
    "dropphyzpp": 790889998,
    "dropmaladd": "129 N ARMSTRONG AVE",
    "dropmalcty": "TULIA",
    "dropmalst": "TX",
    "dropmalzpp": 790889998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8069952812,
    "dropsitcph": 8069952812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26077",
    "droptype": "D",
    "dropname": "TURKEY",
    "dropdeladd": "505 MAIN ST",
    "dropdelcty": "TURKEY",
    "dropdelst": "TX",
    "dropdelzpp": 792619803,
    "dropphyadd": "505 MAIN ST",
    "dropphycty": "TURKEY",
    "dropphyst": "TX",
    "dropphyzpp": 792619803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURKEY",
    "dropmalst": "TX",
    "dropmalzpp": 792619998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064231188,
    "dropsitcph": 8064231188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26083",
    "droptype": "D",
    "dropname": "TUSCOLA",
    "dropdeladd": "742 GRAHAM ST",
    "dropdelcty": "TUSCOLA",
    "dropdelst": "TX",
    "dropdelzpp": 795629998,
    "dropphyadd": "742 GRAHAM ST",
    "dropphycty": "TUSCOLA",
    "dropphyst": "TX",
    "dropphyzpp": 795629998,
    "dropmaladd": "742 GRAHAM ST",
    "dropmalcty": "TUSCOLA",
    "dropmalst": "TX",
    "dropmalzpp": 795629998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3255547558,
    "dropsitcph": 3255547558,
    "dropfax": 3255547025
  },
  {
    "dcode": "D",
    "dropkey": "PW26088",
    "droptype": "D",
    "dropname": "TYE",
    "dropdeladd": "200 TAYLOR ST",
    "dropdelcty": "TYE",
    "dropdelst": "TX",
    "dropdelzpp": 795639998,
    "dropphyadd": "200 TAYLOR ST",
    "dropphycty": "TYE",
    "dropphyst": "TX",
    "dropphyzpp": 795639998,
    "dropmaladd": "200 TAYLOR ST",
    "dropmalcty": "TYE",
    "dropmalst": "TX",
    "dropmalzpp": 795639998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256984100,
    "dropsitcph": 3256984100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26091",
    "droptype": "D",
    "dropname": "TYLER",
    "dropdeladd": "2100 W MARTIN LUTHER KING JR BLVD",
    "dropdelcty": "TYLER",
    "dropdelst": "TX",
    "dropdelzpp": 757029998,
    "dropphyadd": "2100 W MARTIN LUTHER KING JR BLVD",
    "dropphycty": "TYLER",
    "dropphyst": "TX",
    "dropphyzpp": 757029998,
    "dropmaladd": "2100 W MARTIN LUTHER KING JR BLVD",
    "dropmalcty": "TYLER",
    "dropmalst": "TX",
    "dropmalzpp": 757029998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035798650,
    "dropsitcph": 9035798650,
    "dropfax": 9035798619
  },
  {
    "dcode": "D",
    "dropkey": "PW26093",
    "droptype": "D",
    "dropname": "TYNAN",
    "dropdeladd": "508 HIGHWAY 359",
    "dropdelcty": "TYNAN",
    "dropdelst": "TX",
    "dropdelzpp": 783919998,
    "dropphyadd": "508 HIGHWAY 359",
    "dropphycty": "TYNAN",
    "dropphyst": "TX",
    "dropphyzpp": 783919998,
    "dropmaladd": "508 HIGHWAY 359",
    "dropmalcty": "TYNAN",
    "dropmalst": "TX",
    "dropmalzpp": 783919998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615476352,
    "dropsitcph": 3615476352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26097",
    "droptype": "D",
    "dropname": "UMBARGER",
    "dropdeladd": "25380 STOREY ST",
    "dropdelcty": "UMBARGER",
    "dropdelst": "TX",
    "dropdelzpp": 790919900,
    "dropphyadd": "25380 STOREY ST",
    "dropphycty": "UMBARGER",
    "dropphyst": "TX",
    "dropphyzpp": 790919900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UMBARGER",
    "dropmalst": "TX",
    "dropmalzpp": 790919998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064993577,
    "dropsitcph": 8064993577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26113",
    "droptype": "D",
    "dropname": "UNIVERSAL CITY",
    "dropdeladd": "830 NORTH BLVD",
    "dropdelcty": "UNIVERSAL CITY",
    "dropdelst": "TX",
    "dropdelzpp": 781489998,
    "dropphyadd": "830 NORTH BLVD",
    "dropphycty": "UNIVERSAL CITY",
    "dropphyst": "TX",
    "dropphyzpp": 781489998,
    "dropmaladd": "830 NORTH BLVD",
    "dropmalcty": "UNIVERSAL CITY",
    "dropmalst": "TX",
    "dropmalzpp": 781489998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106584273,
    "dropsitcph": 2106588416,
    "dropfax": 2106583319
  },
  {
    "dcode": "D",
    "dropkey": "PW26130",
    "droptype": "D",
    "dropname": "UTOPIA",
    "dropdeladd": "700 N MAIN",
    "dropdelcty": "UTOPIA",
    "dropdelst": "TX",
    "dropdelzpp": 788849998,
    "dropphyadd": "700 N MAIN",
    "dropphycty": "UTOPIA",
    "dropphyst": "TX",
    "dropphyzpp": 788849998,
    "dropmaladd": "700 N MAIN",
    "dropmalcty": "UTOPIA",
    "dropmalst": "TX",
    "dropmalzpp": 788849998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309663667,
    "dropsitcph": 8309663667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26131",
    "droptype": "D",
    "dropname": "UVALDE",
    "dropdeladd": "103 S GETTY ST",
    "dropdelcty": "UVALDE",
    "dropdelst": "TX",
    "dropdelzpp": 788019998,
    "dropphyadd": "103 S GETTY ST",
    "dropphycty": "UVALDE",
    "dropphyst": "TX",
    "dropphyzpp": 788019998,
    "dropmaladd": "103 S GETTY ST",
    "dropmalcty": "UVALDE",
    "dropmalst": "TX",
    "dropmalzpp": 788019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302783911,
    "dropsitcph": 8302783911,
    "dropfax": 8302789312
  },
  {
    "dcode": "D",
    "dropkey": "PW26136",
    "droptype": "D",
    "dropname": "VALENTINE",
    "dropdeladd": "311 W CALIFORNIA AVE",
    "dropdelcty": "VALENTINE",
    "dropdelst": "TX",
    "dropdelzpp": 798549998,
    "dropphyadd": "311 W CALIFORNIA AVE",
    "dropphycty": "VALENTINE",
    "dropphyst": "TX",
    "dropphyzpp": 798549998,
    "dropmaladd": "311 W CALIFORNIA AVE",
    "dropmalcty": "VALENTINE",
    "dropmalst": "TX",
    "dropmalzpp": 798549998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4324672912,
    "dropsitcph": 4324672912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26137",
    "droptype": "D",
    "dropname": "VALERA",
    "dropdeladd": "10490 US HIGHWAY 67",
    "dropdelcty": "VALERA",
    "dropdelst": "TX",
    "dropdelzpp": 768849801,
    "dropphyadd": "10490 US HIGHWAY 67",
    "dropphycty": "VALERA",
    "dropphyst": "TX",
    "dropphyzpp": 768849801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALERA",
    "dropmalst": "TX",
    "dropmalzpp": 768849998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256364459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26141",
    "droptype": "D",
    "dropname": "VALLEY MILLS",
    "dropdeladd": "501 AVENUE D",
    "dropdelcty": "VALLEY MILLS",
    "dropdelst": "TX",
    "dropdelzpp": 766899998,
    "dropphyadd": "501 AVENUE D",
    "dropphycty": "VALLEY MILLS",
    "dropphyst": "TX",
    "dropphyzpp": 766899998,
    "dropmaladd": "501 AVENUE D",
    "dropmalcty": "VALLEY MILLS",
    "dropmalst": "TX",
    "dropmalzpp": 766899998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2549342593,
    "dropsitcph": 2549342593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26143",
    "droptype": "D",
    "dropname": "VALLEY SPRING",
    "dropdeladd": "11936 W STATE HIGHWAY 71",
    "dropdelcty": "VALLEY SPRING",
    "dropdelst": "TX",
    "dropdelzpp": 768859998,
    "dropphyadd": "11936 W STATE HIGHWAY 71",
    "dropphycty": "VALLEY SPRING",
    "dropphyst": "TX",
    "dropphyzpp": 768859998,
    "dropmaladd": "11936 W STATE HIGHWAY 71",
    "dropmalcty": "VALLEY SPRING",
    "dropmalst": "TX",
    "dropmalzpp": 768859998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3252474879,
    "dropsitcph": 3252474879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26148",
    "droptype": "D",
    "dropname": "VALLEY VIEW",
    "dropdeladd": "409 N FRONTAGE RD",
    "dropdelcty": "VALLEY VIEW",
    "dropdelst": "TX",
    "dropdelzpp": 762729998,
    "dropphyadd": "409 N FRONTAGE RD",
    "dropphycty": "VALLEY VIEW",
    "dropphyst": "TX",
    "dropphyzpp": 762729998,
    "dropmaladd": "409 N FRONTAGE RD",
    "dropmalcty": "VALLEY VIEW",
    "dropmalst": "TX",
    "dropmalzpp": 762729998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407263680,
    "dropsitcph": 9407263680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26149",
    "droptype": "D",
    "dropname": "VAN",
    "dropdeladd": "770 W MAIN ST",
    "dropdelcty": "VAN",
    "dropdelst": "TX",
    "dropdelzpp": 757909998,
    "dropphyadd": "770 W MAIN ST",
    "dropphycty": "VAN",
    "dropphyst": "TX",
    "dropphyzpp": 757909998,
    "dropmaladd": "770 W MAIN ST",
    "dropmalcty": "VAN",
    "dropmalst": "TX",
    "dropmalzpp": 757909998,
    "dropsitphn": 2149482879,
    "dropsitlph": 9039637346,
    "dropsitcph": 9039637346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26150",
    "droptype": "D",
    "dropname": "VAN ALSTYNE",
    "dropdeladd": "130 E JEFFERSON ST",
    "dropdelcty": "VAN ALSTYNE",
    "dropdelst": "TX",
    "dropdelzpp": 754959998,
    "dropphyadd": "130 E JEFFERSON ST",
    "dropphycty": "VAN ALSTYNE",
    "dropphyst": "TX",
    "dropphyzpp": 754959998,
    "dropmaladd": "130 E JEFFERSON ST",
    "dropmalcty": "VAN ALSTYNE",
    "dropmalst": "TX",
    "dropmalzpp": 754959998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034825221,
    "dropsitcph": 9034825221,
    "dropfax": 9034826359
  },
  {
    "dcode": "D",
    "dropkey": "PW26151",
    "droptype": "D",
    "dropname": "VAN HORN",
    "dropdeladd": "603 W BROADWAY ST",
    "dropdelcty": "VAN HORN",
    "dropdelst": "TX",
    "dropdelzpp": 798559800,
    "dropphyadd": "603 W BROADWAY ST",
    "dropphycty": "VAN HORN",
    "dropphyst": "TX",
    "dropphyzpp": 798559800,
    "dropmaladd": "603 W BROADWAY ST",
    "dropmalcty": "VAN HORN",
    "dropmalst": "TX",
    "dropmalzpp": 798559800,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4322832278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26152",
    "droptype": "D",
    "dropname": "VAN VLECK",
    "dropdeladd": "8901 STATE HIGHWAY 35 N",
    "dropdelcty": "VAN VLECK",
    "dropdelst": "TX",
    "dropdelzpp": 774829899,
    "dropphyadd": "8901 STATE HIGHWAY 35 N",
    "dropphycty": "VAN VLECK",
    "dropphyst": "TX",
    "dropphyzpp": 774829899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN VLECK",
    "dropmalst": "TX",
    "dropmalzpp": 774829998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792456421,
    "dropsitcph": 9792456421,
    "dropfax": 9792454137
  },
  {
    "dcode": "D",
    "dropkey": "PW26154",
    "droptype": "D",
    "dropname": "VANCOURT",
    "dropdeladd": "9538 YORK RD",
    "dropdelcty": "VANCOURT",
    "dropdelst": "TX",
    "dropdelzpp": 769559800,
    "dropphyadd": "9538 YORK RD",
    "dropphycty": "VANCOURT",
    "dropphyst": "TX",
    "dropphyzpp": 769559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANCOURT",
    "dropmalst": "TX",
    "dropmalzpp": 769559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254693747,
    "dropsitcph": 3254693747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26155",
    "droptype": "D",
    "dropname": "VANDERBILT",
    "dropdeladd": "5825 FM 616",
    "dropdelcty": "VANDERBILT",
    "dropdelst": "TX",
    "dropdelzpp": 779919800,
    "dropphyadd": "5825 FM 616",
    "dropphycty": "VANDERBILT",
    "dropphyst": "TX",
    "dropphyzpp": 779919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANDERBILT",
    "dropmalst": "TX",
    "dropmalzpp": 779919998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612843335,
    "dropsitcph": 3612843335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26156",
    "droptype": "D",
    "dropname": "VANDERPOOL",
    "dropdeladd": "32474 FM 187",
    "dropdelcty": "VANDERPOOL",
    "dropdelst": "TX",
    "dropdelzpp": 788859998,
    "dropphyadd": "32474 FM 187",
    "dropphycty": "VANDERPOOL",
    "dropphyst": "TX",
    "dropphyzpp": 788859998,
    "dropmaladd": "32474 FM 187",
    "dropmalcty": "VANDERPOOL",
    "dropmalst": "TX",
    "dropmalzpp": 788859998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309666152,
    "dropsitcph": 8309666152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26161",
    "droptype": "D",
    "dropname": "VEGA",
    "dropdeladd": "222 N MAIN ST",
    "dropdelcty": "VEGA",
    "dropdelst": "TX",
    "dropdelzpp": 790929802,
    "dropphyadd": "222 N MAIN ST",
    "dropphycty": "VEGA",
    "dropphyst": "TX",
    "dropphyzpp": 790929802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VEGA",
    "dropmalst": "TX",
    "dropmalzpp": 790929998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062672552,
    "dropsitcph": 8062672552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26162",
    "droptype": "D",
    "dropname": "VENUS",
    "dropdeladd": "101 W 8TH ST",
    "dropdelcty": "VENUS",
    "dropdelst": "TX",
    "dropdelzpp": 760849998,
    "dropphyadd": "101 W 8TH ST",
    "dropphycty": "VENUS",
    "dropphyst": "TX",
    "dropphyzpp": 760849998,
    "dropmaladd": "101 W 8TH ST",
    "dropmalcty": "VENUS",
    "dropmalst": "TX",
    "dropmalzpp": 760849998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9723663643,
    "dropsitcph": 9723663643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26165",
    "droptype": "D",
    "dropname": "VERIBEST",
    "dropdeladd": "10777 FM 380",
    "dropdelcty": "VERIBEST",
    "dropdelst": "TX",
    "dropdelzpp": 768869800,
    "dropphyadd": "10777 FM 380",
    "dropphycty": "VERIBEST",
    "dropphyst": "TX",
    "dropphyzpp": 768869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERIBEST",
    "dropmalst": "TX",
    "dropmalzpp": 768869998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256590054,
    "dropsitcph": 3256590054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26166",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "1701 TEXAS ST",
    "dropdelcty": "VERNON",
    "dropdelst": "TX",
    "dropdelzpp": 763849998,
    "dropphyadd": "1701 TEXAS ST",
    "dropphycty": "VERNON",
    "dropphyst": "TX",
    "dropphyzpp": 763849998,
    "dropmaladd": "1701 TEXAS ST",
    "dropmalcty": "VERNON",
    "dropmalst": "TX",
    "dropmalzpp": 763849998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9405529391,
    "dropsitcph": 9405529391,
    "dropfax": 9405525136
  },
  {
    "dcode": "D",
    "dropkey": "PW26171",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "312 S MAIN ST",
    "dropdelcty": "VICTORIA",
    "dropdelst": "TX",
    "dropdelzpp": 779019998,
    "dropphyadd": "312 S MAIN ST",
    "dropphycty": "VICTORIA",
    "dropphyst": "TX",
    "dropphyzpp": 779019998,
    "dropmaladd": "312 S MAIN ST",
    "dropmalcty": "VICTORIA",
    "dropmalst": "TX",
    "dropmalzpp": 779019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615752365,
    "dropsitcph": 3615751611,
    "dropfax": 3615754023
  },
  {
    "dcode": "D",
    "dropkey": "PW26173",
    "droptype": "D",
    "dropname": "VIDOR",
    "dropdeladd": "285 S ARCHIE ST",
    "dropdelcty": "VIDOR",
    "dropdelst": "TX",
    "dropdelzpp": 776629998,
    "dropphyadd": "285 S ARCHIE ST",
    "dropphycty": "VIDOR",
    "dropphyst": "TX",
    "dropphyzpp": 776629998,
    "dropmaladd": "285 S ARCHIE ST",
    "dropmalcty": "VIDOR",
    "dropmalst": "TX",
    "dropmalzpp": 776629998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4097699409,
    "dropsitcph": 4097832074,
    "dropfax": 4097697959
  },
  {
    "dcode": "D",
    "dropkey": "PW26181",
    "droptype": "D",
    "dropname": "VILLAGE MILLS",
    "dropdeladd": "4956 FM 3063",
    "dropdelcty": "VILLAGE MILLS",
    "dropdelst": "TX",
    "dropdelzpp": 776630016,
    "dropphyadd": "4956 FM 3063",
    "dropphycty": "VILLAGE MILLS",
    "dropphyst": "TX",
    "dropphyzpp": 776630016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILLAGE MILLS",
    "dropmalst": "TX",
    "dropmalzpp": 776639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4098342592,
    "dropsitcph": 4098342592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26187",
    "droptype": "D",
    "dropname": "VOCA",
    "dropdeladd": "255 N FM 1851",
    "dropdelcty": "VOCA",
    "dropdelst": "TX",
    "dropdelzpp": 768879814,
    "dropphyadd": "255 N FM 1851",
    "dropphycty": "VOCA",
    "dropphyst": "TX",
    "dropphyzpp": 768879814,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VOCA",
    "dropmalst": "TX",
    "dropmalzpp": 768879998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3252395522,
    "dropsitcph": 3252395522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26189",
    "droptype": "D",
    "dropname": "VON ORMY",
    "dropdeladd": "13636 INTERSTATE 35 S",
    "dropdelcty": "VON ORMY",
    "dropdelst": "TX",
    "dropdelzpp": 780739998,
    "dropphyadd": "13636 INTERSTATE 35 S",
    "dropphycty": "VON ORMY",
    "dropphyst": "TX",
    "dropphyzpp": 780739998,
    "dropmaladd": "13636 INTERSTATE 35 S",
    "dropmalcty": "VON ORMY",
    "dropmalst": "TX",
    "dropmalzpp": 780739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106228994,
    "dropsitcph": 2106228990,
    "dropfax": 2106229463
  },
  {
    "dcode": "D",
    "dropkey": "PW26191",
    "droptype": "D",
    "dropname": "VOTAW",
    "dropdeladd": "21598 OLD HWY",
    "dropdelcty": "VOTAW",
    "dropdelst": "TX",
    "dropdelzpp": 773760015,
    "dropphyadd": "21598 OLD HWY",
    "dropphycty": "VOTAW",
    "dropphyst": "TX",
    "dropphyzpp": 773760015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VOTAW",
    "dropmalst": "TX",
    "dropmalzpp": 773769998,
    "dropsitphn": 9362745900,
    "dropsitlph": 9362745900,
    "dropsitcph": 9362745900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26197",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "430 W STATE HIGHWAY 6",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767029998,
    "dropphyadd": "430 W STATE HIGHWAY 6",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767029998,
    "dropmaladd": "430 W STATE HIGHWAY 6",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543992296,
    "dropsitcph": 2543992201,
    "dropfax": 2543992287
  },
  {
    "dcode": "D",
    "dropkey": "PW26198",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "13622 HIGHWAY 60 S",
    "dropdelcty": "WADSWORTH",
    "dropdelst": "TX",
    "dropdelzpp": 774839800,
    "dropphyadd": "13622 HIGHWAY 60 S",
    "dropphycty": "WADSWORTH",
    "dropphyst": "TX",
    "dropphyzpp": 774839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADSWORTH",
    "dropmalst": "TX",
    "dropmalzpp": 774839998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9792454403,
    "dropsitcph": 9792454403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26199",
    "droptype": "D",
    "dropname": "WAELDER",
    "dropdeladd": "423 W US HIGHWAY 90",
    "dropdelcty": "WAELDER",
    "dropdelst": "TX",
    "dropdelzpp": 789599998,
    "dropphyadd": "423 W US HIGHWAY 90",
    "dropphycty": "WAELDER",
    "dropphyst": "TX",
    "dropphyzpp": 789599998,
    "dropmaladd": "423 W US HIGHWAY 90",
    "dropmalcty": "WAELDER",
    "dropmalst": "TX",
    "dropmalzpp": 789599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307887361,
    "dropsitcph": 8307887361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26204",
    "droptype": "D",
    "dropname": "WALBURG",
    "dropdeladd": "3745 FM 972",
    "dropdelcty": "WALBURG",
    "dropdelst": "TX",
    "dropdelzpp": 786739800,
    "dropphyadd": "3745 FM 972",
    "dropphycty": "WALBURG",
    "dropphyst": "TX",
    "dropphyzpp": 786739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALBURG",
    "dropmalst": "TX",
    "dropmalzpp": 786739998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128630729,
    "dropsitcph": 5128630729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26209",
    "droptype": "D",
    "dropname": "WALL",
    "dropdeladd": "7901 LOOP 570 S",
    "dropdelcty": "WALL",
    "dropdelst": "TX",
    "dropdelzpp": 769579802,
    "dropphyadd": "7901 LOOP 570 S",
    "dropphycty": "WALL",
    "dropphyst": "TX",
    "dropphyzpp": 769579802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALL",
    "dropmalst": "TX",
    "dropmalzpp": 769579998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256518694,
    "dropsitcph": 3256518694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26210",
    "droptype": "D",
    "dropname": "WALLER",
    "dropdeladd": "40090 HIGHWAY 290 BUSINESS",
    "dropdelcty": "WALLER",
    "dropdelst": "TX",
    "dropdelzpp": 774849998,
    "dropphyadd": "40090 HIGHWAY 290 BUSINESS",
    "dropphycty": "WALLER",
    "dropphyst": "TX",
    "dropphyzpp": 774849998,
    "dropmaladd": "40090 HIGHWAY 290 BUSINESS",
    "dropmalcty": "WALLER",
    "dropmalst": "TX",
    "dropmalzpp": 774849998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9363729232,
    "dropsitcph": 9363729232,
    "dropfax": 9363725880
  },
  {
    "dcode": "D",
    "dropkey": "PW26211",
    "droptype": "D",
    "dropname": "WALLIS",
    "dropdeladd": "6418 RAILROAD ST",
    "dropdelcty": "WALLIS",
    "dropdelst": "TX",
    "dropdelzpp": 774858008,
    "dropphyadd": "6418 RAILROAD ST",
    "dropphycty": "WALLIS",
    "dropphyst": "TX",
    "dropphyzpp": 774858008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLIS",
    "dropmalst": "TX",
    "dropmalzpp": 774859998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9794786733,
    "dropsitcph": 9794786733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26212",
    "droptype": "D",
    "dropname": "WALLISVILLE",
    "dropdeladd": "20142 INTERSTATE 10",
    "dropdelcty": "WALLISVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 775973024,
    "dropphyadd": "20142 INTERSTATE 10",
    "dropphycty": "WALLISVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 775973024,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLISVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 775979998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4093892288,
    "dropsitcph": 4093892288,
    "dropfax": 4093892788
  },
  {
    "dcode": "D",
    "dropkey": "PW26216",
    "droptype": "D",
    "dropname": "WALNUT SPRINGS",
    "dropdeladd": "4105 3RD ST",
    "dropdelcty": "WALNUT SPRINGS",
    "dropdelst": "TX",
    "dropdelzpp": 766909998,
    "dropphyadd": "4105 3RD ST",
    "dropphycty": "WALNUT SPRINGS",
    "dropphyst": "TX",
    "dropphyzpp": 766909998,
    "dropmaladd": "4105 3RD ST",
    "dropmalcty": "WALNUT SPRINGS",
    "dropmalst": "TX",
    "dropmalzpp": 766909998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547972269,
    "dropsitcph": 2547972269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26221",
    "droptype": "D",
    "dropname": "WARDA",
    "dropdeladd": "5621 S US HIGHWAY 77",
    "dropdelcty": "WARDA",
    "dropdelst": "TX",
    "dropdelzpp": 789609800,
    "dropphyadd": "5621 S US HIGHWAY 77",
    "dropphycty": "WARDA",
    "dropphyst": "TX",
    "dropphyzpp": 789609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARDA",
    "dropmalst": "TX",
    "dropmalzpp": 789609998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792425001,
    "dropsitcph": 9792425001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26223",
    "droptype": "D",
    "dropname": "WARING",
    "dropdeladd": "538 WARING WELFARE RD",
    "dropdelcty": "WARING",
    "dropdelst": "TX",
    "dropdelzpp": 780749800,
    "dropphyadd": "538 WARING WELFARE RD",
    "dropphycty": "WARING",
    "dropphyst": "TX",
    "dropphyzpp": 780749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARING",
    "dropmalst": "TX",
    "dropmalzpp": 780749998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8309953838,
    "dropsitcph": 8309953838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26225",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "120 COUNTY ROAD 1520",
    "dropdelcty": "WARREN",
    "dropdelst": "TX",
    "dropdelzpp": 776640015,
    "dropphyadd": "120 COUNTY ROAD 1520",
    "dropphycty": "WARREN",
    "dropphyst": "TX",
    "dropphyzpp": 776640015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARREN",
    "dropmalst": "TX",
    "dropmalzpp": 776649998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4095473619,
    "dropsitcph": 4095473619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26227",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "23295 FM 1155 E",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 778806037,
    "dropphyadd": "23295 FM 1155 E",
    "dropphycty": "WASHINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 778806037,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 778809998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368782324,
    "dropsitcph": 9368782324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26228",
    "droptype": "D",
    "dropname": "WASKOM",
    "dropdeladd": "265 SPUR 156",
    "dropdelcty": "WASKOM",
    "dropdelst": "TX",
    "dropdelzpp": 756929998,
    "dropphyadd": "265 SPUR 156",
    "dropphycty": "WASKOM",
    "dropphyst": "TX",
    "dropphyzpp": 756929998,
    "dropmaladd": "265 SPUR 156",
    "dropmalcty": "WASKOM",
    "dropmalst": "TX",
    "dropmalzpp": 756929998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036872202,
    "dropsitcph": 9036872202,
    "dropfax": 9036872096
  },
  {
    "dcode": "D",
    "dropkey": "PW26231",
    "droptype": "D",
    "dropname": "WATER VALLEY",
    "dropdeladd": "15949 SPRING AVE",
    "dropdelcty": "WATER VALLEY",
    "dropdelst": "TX",
    "dropdelzpp": 769589998,
    "dropphyadd": "15949 SPRING AVE",
    "dropphycty": "WATER VALLEY",
    "dropphyst": "TX",
    "dropphyzpp": 769589998,
    "dropmaladd": "15949 SPRING AVE",
    "dropmalcty": "WATER VALLEY",
    "dropmalst": "TX",
    "dropmalzpp": 769589998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3254843349,
    "dropsitcph": 3254843349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26238",
    "droptype": "D",
    "dropname": "WAXAHACHIE",
    "dropdeladd": "316 N COLLEGE ST",
    "dropdelcty": "WAXAHACHIE",
    "dropdelst": "TX",
    "dropdelzpp": 751659998,
    "dropphyadd": "316 N COLLEGE ST",
    "dropphycty": "WAXAHACHIE",
    "dropphyst": "TX",
    "dropphyzpp": 751659998,
    "dropmaladd": "316 N COLLEGE ST",
    "dropmalcty": "WAXAHACHIE",
    "dropmalst": "TX",
    "dropmalzpp": 751659998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9729374145,
    "dropsitcph": 9729374145,
    "dropfax": 9729379349
  },
  {
    "dcode": "D",
    "dropkey": "PW26241",
    "droptype": "D",
    "dropname": "WEATHERFORD",
    "dropdeladd": "1145 SANTA FE DR",
    "dropdelcty": "WEATHERFORD",
    "dropdelst": "TX",
    "dropdelzpp": 760865887,
    "dropphyadd": "1145 SANTA FE DR",
    "dropphycty": "WEATHERFORD",
    "dropphyst": "TX",
    "dropphyzpp": 760865887,
    "dropmaladd": "1145 SANTA FE DR",
    "dropmalcty": "WEATHERFORD",
    "dropmalst": "TX",
    "dropmalzpp": 760865887,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175943072,
    "dropsitcph": 8175943072,
    "dropfax": 8175980879
  },
  {
    "dcode": "D",
    "dropkey": "PW26243",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "17077 N TEXAS AVE",
    "dropdelcty": "WEBSTER",
    "dropdelst": "TX",
    "dropdelzpp": 775989998,
    "dropphyadd": "17077 N TEXAS AVE",
    "dropphycty": "WEBSTER",
    "dropphyst": "TX",
    "dropphyzpp": 775989998,
    "dropmaladd": "17077 N TEXAS AVE",
    "dropmalcty": "WEBSTER",
    "dropmalst": "TX",
    "dropmalzpp": 775989998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813160156,
    "dropsitcph": 2813160379,
    "dropfax": 2813389739
  },
  {
    "dcode": "D",
    "dropkey": "PW26247",
    "droptype": "D",
    "dropname": "WEESATCHE",
    "dropdeladd": "195 W FM 884",
    "dropdelcty": "WEESATCHE",
    "dropdelst": "TX",
    "dropdelzpp": 779939800,
    "dropphyadd": "195 W FM 884",
    "dropphycty": "WEESATCHE",
    "dropphyst": "TX",
    "dropphyzpp": 779939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEESATCHE",
    "dropmalst": "TX",
    "dropmalzpp": 779939998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615643756,
    "dropsitcph": 3615643756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26248",
    "droptype": "D",
    "dropname": "WEIMAR",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "WEIMAR",
    "dropdelst": "TX",
    "dropdelzpp": 789629998,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "WEIMAR",
    "dropphyst": "TX",
    "dropphyzpp": 789629998,
    "dropmaladd": "100 E MAIN ST",
    "dropmalcty": "WEIMAR",
    "dropmalst": "TX",
    "dropmalzpp": 789629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9797256711,
    "dropsitcph": 9797256711,
    "dropfax": 9797256012
  },
  {
    "dcode": "D",
    "dropkey": "PW26249",
    "droptype": "D",
    "dropname": "WEINERT",
    "dropdeladd": "105 S BREUSTEDT ST",
    "dropdelcty": "WEINERT",
    "dropdelst": "TX",
    "dropdelzpp": 763889700,
    "dropphyadd": "105 S BREUSTEDT ST",
    "dropphycty": "WEINERT",
    "dropphyst": "TX",
    "dropphyzpp": 763889700,
    "dropmaladd": "105 S BREUSTEDT ST",
    "dropmalcty": "WEINERT",
    "dropmalst": "TX",
    "dropmalzpp": 763889700,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406738311,
    "dropsitcph": 9406738311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26250",
    "droptype": "D",
    "dropname": "WEIR",
    "dropdeladd": "200 FM 1105",
    "dropdelcty": "WEIR",
    "dropdelst": "TX",
    "dropdelzpp": 786749998,
    "dropphyadd": "200 FM 1105",
    "dropphycty": "WEIR",
    "dropphyst": "TX",
    "dropphyzpp": 786749998,
    "dropmaladd": "200 FM 1105",
    "dropmalcty": "WEIR",
    "dropmalst": "TX",
    "dropmalzpp": 786749998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128630139,
    "dropsitcph": 5128630139,
    "dropfax": 5128632235
  },
  {
    "dcode": "D",
    "dropkey": "PW26251",
    "droptype": "D",
    "dropname": "WELCH",
    "dropdeladd": "218 JUNIPER ST",
    "dropdelcty": "WELCH",
    "dropdelst": "TX",
    "dropdelzpp": 793779802,
    "dropphyadd": "218 JUNIPER ST",
    "dropphycty": "WELCH",
    "dropphyst": "TX",
    "dropphyzpp": 793779802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELCH",
    "dropmalst": "TX",
    "dropmalzpp": 793779998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064897406,
    "dropsitcph": 8064897406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26253",
    "droptype": "D",
    "dropname": "WELLBORN",
    "dropdeladd": "14881 FM 2154",
    "dropdelcty": "WELLBORN",
    "dropdelst": "TX",
    "dropdelzpp": 778819800,
    "dropphyadd": "14881 FM 2154",
    "dropphycty": "WELLBORN",
    "dropphyst": "TX",
    "dropphyzpp": 778819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLBORN",
    "dropmalst": "TX",
    "dropmalzpp": 778819998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9796907660,
    "dropsitcph": 9796907660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26254",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "1000 WEST AVE",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 790959998,
    "dropphyadd": "1000 WEST AVE",
    "dropphycty": "WELLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 790959998,
    "dropmaladd": "1000 WEST AVE",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 790959998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 8064475129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26255",
    "droptype": "D",
    "dropname": "WELLMAN",
    "dropdeladd": "503 YOAKUM",
    "dropdelcty": "WELLMAN",
    "dropdelst": "TX",
    "dropdelzpp": 793789800,
    "dropphyadd": "503 YOAKUM",
    "dropphycty": "WELLMAN",
    "dropphyst": "TX",
    "dropphyzpp": 793789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLMAN",
    "dropmalst": "TX",
    "dropmalzpp": 793789998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066374950,
    "dropsitcph": 8066374950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26256",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "314 RUSK AVE",
    "dropdelcty": "WELLS",
    "dropdelst": "TX",
    "dropdelzpp": 759769998,
    "dropphyadd": "314 RUSK AVE",
    "dropphycty": "WELLS",
    "dropphyst": "TX",
    "dropphyzpp": 759769998,
    "dropmaladd": "314 RUSK AVE",
    "dropmalcty": "WELLS",
    "dropmalst": "TX",
    "dropmalzpp": 759769998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9362270068,
    "dropsitcph": 9362270068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26258",
    "droptype": "D",
    "dropname": "WESLACO",
    "dropdeladd": "109 N BORDER AVE",
    "dropdelcty": "WESLACO",
    "dropdelst": "TX",
    "dropdelzpp": 785969998,
    "dropphyadd": "109 N BORDER AVE",
    "dropphycty": "WESLACO",
    "dropphyst": "TX",
    "dropphyzpp": 785969998,
    "dropmaladd": "109 N BORDER AVE",
    "dropmalcty": "WESLACO",
    "dropmalst": "TX",
    "dropmalzpp": 785969998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569691779,
    "dropsitcph": 9569687412,
    "dropfax": 9569692993
  },
  {
    "dcode": "D",
    "dropkey": "PW26260",
    "droptype": "D",
    "dropname": "WEST",
    "dropdeladd": "301 W COLUMBUS ST",
    "dropdelcty": "WEST",
    "dropdelst": "TX",
    "dropdelzpp": 766919998,
    "dropphyadd": "301 W COLUMBUS ST",
    "dropphycty": "WEST",
    "dropphyst": "TX",
    "dropphyzpp": 766919998,
    "dropmaladd": "301 W COLUMBUS ST",
    "dropmalcty": "WEST",
    "dropmalst": "TX",
    "dropmalzpp": 766919998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2548265731,
    "dropsitcph": 2548265731,
    "dropfax": 2108264403
  },
  {
    "dcode": "D",
    "dropkey": "PW26262",
    "droptype": "D",
    "dropname": "WEST COLUMBIA",
    "dropdeladd": "350 W BRAZOS AVE",
    "dropdelcty": "WEST COLUMBIA",
    "dropdelst": "TX",
    "dropdelzpp": 774869998,
    "dropphyadd": "350 W BRAZOS AVE",
    "dropphycty": "WEST COLUMBIA",
    "dropphyst": "TX",
    "dropphyzpp": 774869998,
    "dropmaladd": "350 W BRAZOS AVE",
    "dropmalcty": "WEST COLUMBIA",
    "dropmalst": "TX",
    "dropmalzpp": 774869998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9793453242,
    "dropsitcph": 9793453242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26273",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "120 W POINT LOOP",
    "dropdelcty": "WEST POINT",
    "dropdelst": "TX",
    "dropdelzpp": 789639998,
    "dropphyadd": "120 W POINT LOOP",
    "dropphycty": "WEST POINT",
    "dropphyst": "TX",
    "dropphyzpp": 789639998,
    "dropmaladd": "120 W POINT LOOP",
    "dropmalcty": "WEST POINT",
    "dropmalst": "TX",
    "dropmalzpp": 789639998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9792423409,
    "dropsitcph": 9792423409,
    "dropfax": 9792423409
  },
  {
    "dcode": "D",
    "dropkey": "PW26281",
    "droptype": "D",
    "dropname": "WESTBROOK",
    "dropdeladd": "306 N MAIN ST",
    "dropdelcty": "WESTBROOK",
    "dropdelst": "TX",
    "dropdelzpp": 795659998,
    "dropphyadd": "306 N MAIN ST",
    "dropphycty": "WESTBROOK",
    "dropphyst": "TX",
    "dropphyzpp": 795659998,
    "dropmaladd": "306 N MAIN ST",
    "dropmalcty": "WESTBROOK",
    "dropmalst": "TX",
    "dropmalzpp": 795659998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3256442331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26286",
    "droptype": "D",
    "dropname": "WESTHOFF",
    "dropdeladd": "16 HOUSTON AVE",
    "dropdelcty": "WESTHOFF",
    "dropdelst": "TX",
    "dropdelzpp": 779949998,
    "dropphyadd": "16 HOUSTON AVE",
    "dropphycty": "WESTHOFF",
    "dropphyst": "TX",
    "dropphyzpp": 779949998,
    "dropmaladd": "16 HOUSTON AVE",
    "dropmalcty": "WESTHOFF",
    "dropmalst": "TX",
    "dropmalzpp": 779949998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8302365380,
    "dropsitcph": 8302365380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26290",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "701 W HOUSTON ST",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "TX",
    "dropdelzpp": 754859998,
    "dropphyadd": "701 W HOUSTON ST",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "TX",
    "dropphyzpp": 754859998,
    "dropmaladd": "701 W HOUSTON ST",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "TX",
    "dropmalzpp": 754859998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729242372,
    "dropsitcph": 9729242372,
    "dropfax": 9729242372
  },
  {
    "dcode": "D",
    "dropkey": "PW26291",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "WESTON",
    "dropdelst": "TX",
    "dropdelzpp": 750979998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "WESTON",
    "dropphyst": "TX",
    "dropphyzpp": 750979998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "WESTON",
    "dropmalst": "TX",
    "dropmalzpp": 750979998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723822167,
    "dropsitcph": 9723822167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26301",
    "droptype": "D",
    "dropname": "WHARTON",
    "dropdeladd": "141 E MILAM ST",
    "dropdelcty": "WHARTON",
    "dropdelst": "TX",
    "dropdelzpp": 774889998,
    "dropphyadd": "141 E MILAM ST",
    "dropphycty": "WHARTON",
    "dropphyst": "TX",
    "dropphyzpp": 774889998,
    "dropmaladd": "141 E MILAM ST",
    "dropmalcty": "WHARTON",
    "dropmalst": "TX",
    "dropmalzpp": 774889998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9795322802,
    "dropsitcph": 9795322802,
    "dropfax": 9795328147
  },
  {
    "dcode": "D",
    "dropkey": "PW26302",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "507 S CANADIAN ST",
    "dropdelcty": "WHEELER",
    "dropdelst": "TX",
    "dropdelzpp": 790969803,
    "dropphyadd": "507 S CANADIAN ST",
    "dropphycty": "WHEELER",
    "dropphyst": "TX",
    "dropphyzpp": 790969803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEELER",
    "dropmalst": "TX",
    "dropmalzpp": 790969998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068265554,
    "dropsitcph": 8068265554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26303",
    "droptype": "D",
    "dropname": "WHEELOCK",
    "dropdeladd": "11546 S FM 46",
    "dropdelcty": "WHEELOCK",
    "dropdelst": "TX",
    "dropdelzpp": 778829800,
    "dropphyadd": "11546 S FM 46",
    "dropphycty": "WHEELOCK",
    "dropphyst": "TX",
    "dropphyzpp": 778829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEELOCK",
    "dropmalst": "TX",
    "dropmalzpp": 778829998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798285115,
    "dropsitcph": 9798285115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26305",
    "droptype": "D",
    "dropname": "WHITE DEER",
    "dropdeladd": "110 E 3RD ST",
    "dropdelcty": "WHITE DEER",
    "dropdelst": "TX",
    "dropdelzpp": 790979802,
    "dropphyadd": "110 E 3RD ST",
    "dropphycty": "WHITE DEER",
    "dropphyst": "TX",
    "dropphyzpp": 790979802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE DEER",
    "dropmalst": "TX",
    "dropmalzpp": 790979998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068834821,
    "dropsitcph": 8068834821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26309",
    "droptype": "D",
    "dropname": "WHITE OAK",
    "dropdeladd": "1200 S WHITE OAK RD",
    "dropdelcty": "WHITE OAK",
    "dropdelst": "TX",
    "dropdelzpp": 756933519,
    "dropphyadd": "1200 S WHITE OAK RD",
    "dropphycty": "WHITE OAK",
    "dropphyst": "TX",
    "dropphyzpp": 756933519,
    "dropmaladd": "1200 S WHITE OAK RD",
    "dropmalcty": "WHITE OAK",
    "dropmalst": "TX",
    "dropmalzpp": 756933519,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037599818,
    "dropsitcph": 9037599818,
    "dropfax": 9037591897
  },
  {
    "dcode": "D",
    "dropkey": "PW26313",
    "droptype": "D",
    "dropname": "WHITEFACE",
    "dropdeladd": "208 W 2ND ST",
    "dropdelcty": "WHITEFACE",
    "dropdelst": "TX",
    "dropdelzpp": 793799800,
    "dropphyadd": "208 W 2ND ST",
    "dropphycty": "WHITEFACE",
    "dropphyst": "TX",
    "dropphyzpp": 793799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITEFACE",
    "dropmalst": "TX",
    "dropmalzpp": 793799998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062871221,
    "dropsitcph": 8062871221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26314",
    "droptype": "D",
    "dropname": "WHITEHOUSE",
    "dropdeladd": "1114 STATE HIGHWAY 110 N",
    "dropdelcty": "WHITEHOUSE",
    "dropdelst": "TX",
    "dropdelzpp": 757919998,
    "dropphyadd": "1114 STATE HIGHWAY 110 N",
    "dropphycty": "WHITEHOUSE",
    "dropphyst": "TX",
    "dropphyzpp": 757919998,
    "dropmaladd": "1114 STATE HIGHWAY 110 N",
    "dropmalcty": "WHITEHOUSE",
    "dropmalst": "TX",
    "dropmalzpp": 757919998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9038394927,
    "dropsitcph": 9038394927,
    "dropfax": 9038393609
  },
  {
    "dcode": "D",
    "dropkey": "PW26315",
    "droptype": "D",
    "dropname": "WHITESBORO",
    "dropdeladd": "110 W MAIN ST",
    "dropdelcty": "WHITESBORO",
    "dropdelst": "TX",
    "dropdelzpp": 762739998,
    "dropphyadd": "110 W MAIN ST",
    "dropphycty": "WHITESBORO",
    "dropphyst": "TX",
    "dropphyzpp": 762739998,
    "dropmaladd": "110 W MAIN ST",
    "dropmalcty": "WHITESBORO",
    "dropmalst": "TX",
    "dropmalzpp": 762739998,
    "dropsitphn": 8173173658,
    "dropsitlph": 4302706000,
    "dropsitcph": 4302706000,
    "dropfax": 4302706001
  },
  {
    "dcode": "D",
    "dropkey": "PW26317",
    "droptype": "D",
    "dropname": "WHITEWRIGHT",
    "dropdeladd": "125 W WALNUT ST",
    "dropdelcty": "WHITEWRIGHT",
    "dropdelst": "TX",
    "dropdelzpp": 754919998,
    "dropphyadd": "125 W WALNUT ST",
    "dropphycty": "WHITEWRIGHT",
    "dropphyst": "TX",
    "dropphyzpp": 754919998,
    "dropmaladd": "125 W WALNUT ST",
    "dropmalcty": "WHITEWRIGHT",
    "dropmalst": "TX",
    "dropmalzpp": 754919998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033642650,
    "dropsitcph": 9033642650,
    "dropfax": 9033645514
  },
  {
    "dcode": "D",
    "dropkey": "PW26318",
    "droptype": "D",
    "dropname": "WHITHARRAL",
    "dropdeladd": "201 BADGER",
    "dropdelcty": "WHITHARRAL",
    "dropdelst": "TX",
    "dropdelzpp": 793809800,
    "dropphyadd": "201 BADGER",
    "dropphycty": "WHITHARRAL",
    "dropphyst": "TX",
    "dropphyzpp": 793809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITHARRAL",
    "dropmalst": "TX",
    "dropmalzpp": 793809998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8062991247,
    "dropsitcph": 8062991247,
    "dropfax": 8062991134
  },
  {
    "dcode": "D",
    "dropkey": "PW26319",
    "droptype": "D",
    "dropname": "WHITNEY",
    "dropdeladd": "516 E JEFFERSON AVE",
    "dropdelcty": "WHITNEY",
    "dropdelst": "TX",
    "dropdelzpp": 766929998,
    "dropphyadd": "516 E JEFFERSON AVE",
    "dropphycty": "WHITNEY",
    "dropphyst": "TX",
    "dropphyzpp": 766929998,
    "dropmaladd": "516 E JEFFERSON AVE",
    "dropmalcty": "WHITNEY",
    "dropmalst": "TX",
    "dropmalzpp": 766929998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2546942860,
    "dropsitcph": 2546942860,
    "dropfax": 2546944992
  },
  {
    "dcode": "D",
    "dropkey": "PW26322",
    "droptype": "D",
    "dropname": "WHITT",
    "dropdeladd": "191 MAIN ST",
    "dropdelcty": "WHITT",
    "dropdelst": "TX",
    "dropdelzpp": 764909998,
    "dropphyadd": "191 MAIN ST",
    "dropphycty": "WHITT",
    "dropphyst": "TX",
    "dropphyzpp": 764909998,
    "dropmaladd": "191 MAIN ST",
    "dropmalcty": "WHITT",
    "dropmalst": "TX",
    "dropmalzpp": 764909998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407983303,
    "dropsitcph": 9407983303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26325",
    "droptype": "D",
    "dropname": "WICHITA FALLS",
    "dropdeladd": "1000 LAMAR ST",
    "dropdelcty": "WICHITA FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 763019998,
    "dropphyadd": "1000 LAMAR ST",
    "dropphycty": "WICHITA FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 763019998,
    "dropmaladd": "1000 LAMAR ST",
    "dropmalcty": "WICHITA FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 763019998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403975031,
    "dropsitcph": 9403975000,
    "dropfax": 9403975020
  },
  {
    "dcode": "D",
    "dropkey": "PW26326",
    "droptype": "D",
    "dropname": "WICKETT",
    "dropdeladd": "300 OBRIEN ST",
    "dropdelcty": "WICKETT",
    "dropdelst": "TX",
    "dropdelzpp": 797889998,
    "dropphyadd": "300 OBRIEN ST",
    "dropphycty": "WICKETT",
    "dropphyst": "TX",
    "dropphyzpp": 797889998,
    "dropmaladd": "300 OBRIEN ST",
    "dropmalcty": "WICKETT",
    "dropmalst": "TX",
    "dropmalzpp": 797889998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807543,
    "dropsitcph": 4329437349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26328",
    "droptype": "D",
    "dropname": "WIERGATE",
    "dropdeladd": "983 FM 1415",
    "dropdelcty": "WIERGATE",
    "dropdelst": "TX",
    "dropdelzpp": 759779998,
    "dropphyadd": "983 FM 1415",
    "dropphycty": "WIERGATE",
    "dropphyst": "TX",
    "dropphyzpp": 759779998,
    "dropmaladd": "983 FM 1415",
    "dropmalcty": "WIERGATE",
    "dropmalst": "TX",
    "dropmalzpp": 759779998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092022874,
    "dropsitcph": 4092022874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26333",
    "droptype": "D",
    "dropname": "WILDORADO",
    "dropdeladd": "306 N LOCUST ST",
    "dropdelcty": "WILDORADO",
    "dropdelst": "TX",
    "dropdelzpp": 790989802,
    "dropphyadd": "306 N LOCUST ST",
    "dropphycty": "WILDORADO",
    "dropphyst": "TX",
    "dropphyzpp": 790989802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILDORADO",
    "dropmalst": "TX",
    "dropmalzpp": 790989998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064263451,
    "dropsitcph": 8064263451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26342",
    "droptype": "D",
    "dropname": "WILLIS",
    "dropdeladd": "609 N CAMPBELL ST",
    "dropdelcty": "WILLIS",
    "dropdelst": "TX",
    "dropdelzpp": 773789998,
    "dropphyadd": "609 N CAMPBELL ST",
    "dropphycty": "WILLIS",
    "dropphyst": "TX",
    "dropphyzpp": 773789998,
    "dropmaladd": "609 N CAMPBELL ST",
    "dropmalcty": "WILLIS",
    "dropmalst": "TX",
    "dropmalzpp": 773789998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9368564981,
    "dropsitcph": 9368564981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26351",
    "droptype": "D",
    "dropname": "WILLS POINT",
    "dropdeladd": "415 N 4TH ST",
    "dropdelcty": "WILLS POINT",
    "dropdelst": "TX",
    "dropdelzpp": 751699998,
    "dropphyadd": "415 N 4TH ST",
    "dropphycty": "WILLS POINT",
    "dropphyst": "TX",
    "dropphyzpp": 751699998,
    "dropmaladd": "415 N 4TH ST",
    "dropmalcty": "WILLS POINT",
    "dropmalst": "TX",
    "dropmalzpp": 751699998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9038732651,
    "dropsitcph": 9038732651,
    "dropfax": 9038735311
  },
  {
    "dcode": "D",
    "dropkey": "PW26352",
    "droptype": "D",
    "dropname": "WILMER",
    "dropdeladd": "120 BLACKWELL BLVD",
    "dropdelcty": "WILMER",
    "dropdelst": "TX",
    "dropdelzpp": 751729998,
    "dropphyadd": "120 BLACKWELL BLVD",
    "dropphycty": "WILMER",
    "dropphyst": "TX",
    "dropphyzpp": 751729998,
    "dropmaladd": "120 BLACKWELL BLVD",
    "dropmalcty": "WILMER",
    "dropmalst": "TX",
    "dropmalzpp": 751729998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9724413310,
    "dropsitcph": 9724413310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26355",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "1011 HOUSTON AVE",
    "dropdelcty": "WILSON",
    "dropdelst": "TX",
    "dropdelzpp": 793819802,
    "dropphyadd": "1011 HOUSTON AVE",
    "dropphycty": "WILSON",
    "dropphyst": "TX",
    "dropphyzpp": 793819802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSON",
    "dropmalst": "TX",
    "dropmalzpp": 793819998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066286251,
    "dropsitcph": 8066286251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26356",
    "droptype": "D",
    "dropname": "WIMBERLEY",
    "dropdeladd": "111 JOE WIMBERLEY BLVD",
    "dropdelcty": "WIMBERLEY",
    "dropdelst": "TX",
    "dropdelzpp": 786769998,
    "dropphyadd": "111 JOE WIMBERLEY BLVD",
    "dropphycty": "WIMBERLEY",
    "dropphyst": "TX",
    "dropphyzpp": 786769998,
    "dropmaladd": "111 JOE WIMBERLEY BLVD",
    "dropmalcty": "WIMBERLEY",
    "dropmalst": "TX",
    "dropmalzpp": 786769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128472623,
    "dropsitcph": 5128472623,
    "dropfax": 5128471644
  },
  {
    "dcode": "D",
    "dropkey": "PW26360",
    "droptype": "D",
    "dropname": "WINDOM",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "WINDOM",
    "dropdelst": "TX",
    "dropdelzpp": 754929998,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "WINDOM",
    "dropphyst": "TX",
    "dropphyzpp": 754929998,
    "dropmaladd": "408 MAIN ST",
    "dropmalcty": "WINDOM",
    "dropmalst": "TX",
    "dropmalzpp": 754929998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9036232300,
    "dropsitcph": 9036232300,
    "dropfax": 9036232300
  },
  {
    "dcode": "D",
    "dropkey": "PW26362",
    "droptype": "D",
    "dropname": "WINDTHORST",
    "dropdeladd": "18504 US HIGHWAY 281",
    "dropdelcty": "WINDTHORST",
    "dropdelst": "TX",
    "dropdelzpp": 763899998,
    "dropphyadd": "18504 US HIGHWAY 281",
    "dropphycty": "WINDTHORST",
    "dropphyst": "TX",
    "dropphyzpp": 763899998,
    "dropmaladd": "18504 US HIGHWAY 281",
    "dropmalcty": "WINDTHORST",
    "dropmalst": "TX",
    "dropmalzpp": 763899998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9404236211,
    "dropsitcph": 9404236211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26363",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "WINFIELD",
    "dropdelst": "TX",
    "dropdelzpp": 754939998,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "WINFIELD",
    "dropphyst": "TX",
    "dropphyzpp": 754939998,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "WINFIELD",
    "dropmalst": "TX",
    "dropmalzpp": 754939998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9035243191,
    "dropsitcph": 9035243191,
    "dropfax": 9035244031
  },
  {
    "dcode": "D",
    "dropkey": "PW26365",
    "droptype": "D",
    "dropname": "WINGATE",
    "dropdeladd": "106 LYNN ST",
    "dropdelcty": "WINGATE",
    "dropdelst": "TX",
    "dropdelzpp": 795669998,
    "dropphyadd": "106 LYNN ST",
    "dropphycty": "WINGATE",
    "dropphyst": "TX",
    "dropphyzpp": 795669998,
    "dropmaladd": "106 LYNN ST",
    "dropmalcty": "WINGATE",
    "dropmalst": "TX",
    "dropmalzpp": 795669998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257436888,
    "dropsitcph": 3257436888,
    "dropfax": 3257432242
  },
  {
    "dcode": "D",
    "dropkey": "PW26366",
    "droptype": "D",
    "dropname": "WINK",
    "dropdeladd": "210 E HENDRICKS BLVD",
    "dropdelcty": "WINK",
    "dropdelst": "TX",
    "dropdelzpp": 797899800,
    "dropphyadd": "210 E HENDRICKS BLVD",
    "dropphycty": "WINK",
    "dropphyst": "TX",
    "dropphyzpp": 797899800,
    "dropmaladd": "210 E HENDRICKS BLVD",
    "dropmalcty": "WINK",
    "dropmalst": "TX",
    "dropmalzpp": 797899998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4325273480,
    "dropsitcph": 4325273480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26368",
    "droptype": "D",
    "dropname": "WINNIE",
    "dropdeladd": "324 HIGHWAY 124",
    "dropdelcty": "WINNIE",
    "dropdelst": "TX",
    "dropdelzpp": 776650190,
    "dropphyadd": "324 HIGHWAY 124",
    "dropphycty": "WINNIE",
    "dropphyst": "TX",
    "dropphyzpp": 776650190,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNIE",
    "dropmalst": "TX",
    "dropmalzpp": 776659998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092964475,
    "dropsitcph": 4092964475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26369",
    "droptype": "D",
    "dropname": "WINNSBORO",
    "dropdeladd": "210 LOCUST ST",
    "dropdelcty": "WINNSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 754949998,
    "dropphyadd": "210 LOCUST ST",
    "dropphycty": "WINNSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 754949998,
    "dropmaladd": "210 LOCUST ST",
    "dropmalcty": "WINNSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 754949998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033426114,
    "dropsitcph": 9033426114,
    "dropfax": 9033429500
  },
  {
    "dcode": "D",
    "dropkey": "PW26370",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "908 DALLAS ST",
    "dropdelcty": "WINONA",
    "dropdelst": "TX",
    "dropdelzpp": 757929998,
    "dropphyadd": "908 DALLAS ST",
    "dropphycty": "WINONA",
    "dropphyst": "TX",
    "dropphyzpp": 757929998,
    "dropmaladd": "908 DALLAS ST",
    "dropmalcty": "WINONA",
    "dropmalst": "TX",
    "dropmalzpp": 757929998,
    "dropsitphn": 2149482879,
    "dropsitlph": 9038779351,
    "dropsitcph": 9038779351,
    "dropfax": 9038773677
  },
  {
    "dcode": "D",
    "dropkey": "PW26372",
    "droptype": "D",
    "dropname": "WINTERS",
    "dropdeladd": "221 S MAIN ST",
    "dropdelcty": "WINTERS",
    "dropdelst": "TX",
    "dropdelzpp": 795679998,
    "dropphyadd": "221 S MAIN ST",
    "dropphycty": "WINTERS",
    "dropphyst": "TX",
    "dropphyzpp": 795679998,
    "dropmaladd": "221 S MAIN ST",
    "dropmalcty": "WINTERS",
    "dropmalst": "TX",
    "dropmalzpp": 795679998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257544718,
    "dropsitcph": 3257544718,
    "dropfax": 3257545352
  },
  {
    "dcode": "D",
    "dropkey": "PW26374",
    "droptype": "D",
    "dropname": "WODEN",
    "dropdeladd": "5148 FM 226",
    "dropdelcty": "WODEN",
    "dropdelst": "TX",
    "dropdelzpp": 759789998,
    "dropphyadd": "5148 FM 226",
    "dropphycty": "WODEN",
    "dropphyst": "TX",
    "dropphyzpp": 759789998,
    "dropmaladd": "5148 FM 226",
    "dropmalcty": "WODEN",
    "dropmalst": "TX",
    "dropmalzpp": 759789998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9365691296,
    "dropsitcph": 9365691296,
    "dropfax": 9365691296
  },
  {
    "dcode": "D",
    "dropkey": "PW26375",
    "droptype": "D",
    "dropname": "WOLFE CITY",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "WOLFE CITY",
    "dropdelst": "TX",
    "dropdelzpp": 754969998,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "WOLFE CITY",
    "dropphyst": "TX",
    "dropphyzpp": 754969998,
    "dropmaladd": "200 W MAIN ST",
    "dropmalcty": "WOLFE CITY",
    "dropmalst": "TX",
    "dropmalzpp": 754969998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034962592,
    "dropsitcph": 9034962592,
    "dropfax": 9034962592
  },
  {
    "dcode": "D",
    "dropkey": "PW26376",
    "droptype": "D",
    "dropname": "WOLFFORTH",
    "dropdeladd": "302 E HIGHWAY 62",
    "dropdelcty": "WOLFFORTH",
    "dropdelst": "TX",
    "dropdelzpp": 793829998,
    "dropphyadd": "302 E HIGHWAY 62",
    "dropphycty": "WOLFFORTH",
    "dropphyst": "TX",
    "dropphyzpp": 793829998,
    "dropmaladd": "302 E HIGHWAY 62",
    "dropmalcty": "WOLFFORTH",
    "dropmalst": "TX",
    "dropmalzpp": 793829998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8068664614,
    "dropsitcph": 8068664614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26382",
    "droptype": "D",
    "dropname": "WOODLAKE",
    "dropdeladd": "5923 E US HIGHWAY 287",
    "dropdelcty": "WOODLAKE",
    "dropdelst": "TX",
    "dropdelzpp": 758659998,
    "dropphyadd": "5923 E US HIGHWAY 287",
    "dropphycty": "WOODLAKE",
    "dropphyst": "TX",
    "dropphyzpp": 758659998,
    "dropmaladd": "5923 E US HIGHWAY 287",
    "dropmalcty": "WOODLAKE",
    "dropmalst": "TX",
    "dropmalzpp": 758659998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366423149,
    "dropsitcph": 9366423149,
    "dropfax": 9366422952
  },
  {
    "dcode": "D",
    "dropkey": "PW26384",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "9620 US HIGHWAY 59 N",
    "dropdelcty": "WOODLAWN",
    "dropdelst": "TX",
    "dropdelzpp": 756949998,
    "dropphyadd": "9620 US HIGHWAY 59 N",
    "dropphycty": "WOODLAWN",
    "dropphyst": "TX",
    "dropphyzpp": 756949998,
    "dropmaladd": "9620 US HIGHWAY 59 N",
    "dropmalcty": "WOODLAWN",
    "dropmalst": "TX",
    "dropmalzpp": 756949998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9039389098,
    "dropsitcph": 9039389098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26386",
    "droptype": "D",
    "dropname": "WOODSBORO",
    "dropdeladd": "501 FIRST ST",
    "dropdelcty": "WOODSBORO",
    "dropdelst": "TX",
    "dropdelzpp": 783939998,
    "dropphyadd": "501 FIRST ST",
    "dropphycty": "WOODSBORO",
    "dropphyst": "TX",
    "dropphyzpp": 783939998,
    "dropmaladd": "501 FIRST ST",
    "dropmalcty": "WOODSBORO",
    "dropmalst": "TX",
    "dropmalzpp": 783939998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615434142,
    "dropsitcph": 3615434142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26387",
    "droptype": "D",
    "dropname": "WOODSON",
    "dropdeladd": "105 HIGHWAY 183 N",
    "dropdelcty": "WOODSON",
    "dropdelst": "TX",
    "dropdelzpp": 764919998,
    "dropphyadd": "105 HIGHWAY 183 N",
    "dropphycty": "WOODSON",
    "dropphyst": "TX",
    "dropphyzpp": 764919998,
    "dropmaladd": "105 HIGHWAY 183 N",
    "dropmalcty": "WOODSON",
    "dropmalst": "TX",
    "dropmalzpp": 764919998,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403456563,
    "dropsitcph": 9403456563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26388",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "307 W WHEAT ST",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 759799998,
    "dropphyadd": "307 W WHEAT ST",
    "dropphycty": "WOODVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 759799998,
    "dropmaladd": "307 W WHEAT ST",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 759799998,
    "dropsitphn": 2144675879,
    "dropsitlph": 4092832191,
    "dropsitcph": 4092832191,
    "dropfax": 4092837041
  },
  {
    "dcode": "D",
    "dropkey": "PW26394",
    "droptype": "D",
    "dropname": "WORTHAM",
    "dropdeladd": "203 W MAIN ST",
    "dropdelcty": "WORTHAM",
    "dropdelst": "TX",
    "dropdelzpp": 766939998,
    "dropphyadd": "203 W MAIN ST",
    "dropphycty": "WORTHAM",
    "dropphyst": "TX",
    "dropphyzpp": 766939998,
    "dropmaladd": "203 W MAIN ST",
    "dropmalcty": "WORTHAM",
    "dropmalst": "TX",
    "dropmalzpp": 766939998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547653227,
    "dropsitcph": 2547653227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26399",
    "droptype": "D",
    "dropname": "WYLIE",
    "dropdeladd": "940 W FM 544",
    "dropdelcty": "WYLIE",
    "dropdelst": "TX",
    "dropdelzpp": 750985157,
    "dropphyadd": "940 W FM 544",
    "dropphycty": "WYLIE",
    "dropphyst": "TX",
    "dropphyzpp": 750985157,
    "dropmaladd": "940 W FM 544",
    "dropmalcty": "WYLIE",
    "dropmalst": "TX",
    "dropmalzpp": 750985157,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724423012,
    "dropsitcph": 9724423012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26400",
    "droptype": "D",
    "dropname": "YANCEY",
    "dropdeladd": "106 COUNTY ROAD 743",
    "dropdelcty": "YANCEY",
    "dropdelst": "TX",
    "dropdelzpp": 788869998,
    "dropphyadd": "106 COUNTY ROAD 743",
    "dropphycty": "YANCEY",
    "dropphyst": "TX",
    "dropphyzpp": 788869998,
    "dropmaladd": "106 COUNTY ROAD 743",
    "dropmalcty": "YANCEY",
    "dropmalst": "TX",
    "dropmalzpp": 788869998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8304264500,
    "dropsitcph": 8304264500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26401",
    "droptype": "D",
    "dropname": "YANTIS",
    "dropdeladd": "122 N MAIN ST",
    "dropdelcty": "YANTIS",
    "dropdelst": "TX",
    "dropdelzpp": 754979998,
    "dropphyadd": "122 N MAIN ST",
    "dropphycty": "YANTIS",
    "dropphyst": "TX",
    "dropphyzpp": 754979998,
    "dropmaladd": "122 N MAIN ST",
    "dropmalcty": "YANTIS",
    "dropmalst": "TX",
    "dropmalzpp": 754979998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9033072273,
    "dropsitcph": 9033072273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26405",
    "droptype": "D",
    "dropname": "YOAKUM",
    "dropdeladd": "112 NELSON ST",
    "dropdelcty": "YOAKUM",
    "dropdelst": "TX",
    "dropdelzpp": 779959998,
    "dropphyadd": "112 NELSON ST",
    "dropphycty": "YOAKUM",
    "dropphyst": "TX",
    "dropphyzpp": 779959998,
    "dropmaladd": "112 NELSON ST",
    "dropmalcty": "YOAKUM",
    "dropmalst": "TX",
    "dropmalzpp": 779959998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612932231,
    "dropsitcph": 3612932231,
    "dropfax": 3612935928
  },
  {
    "dcode": "D",
    "dropkey": "PW26406",
    "droptype": "D",
    "dropname": "YORKTOWN",
    "dropdeladd": "124 W MAIN ST",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 781649998,
    "dropphyadd": "124 W MAIN ST",
    "dropphycty": "YORKTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 781649998,
    "dropmaladd": "124 W MAIN ST",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 781649998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615642226,
    "dropsitcph": 3615642226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26411",
    "droptype": "D",
    "dropname": "ZAPATA",
    "dropdeladd": "810 N US HIGHWAY 83",
    "dropdelcty": "ZAPATA",
    "dropdelst": "TX",
    "dropdelzpp": 780769998,
    "dropphyadd": "810 N US HIGHWAY 83",
    "dropphycty": "ZAPATA",
    "dropphyst": "TX",
    "dropphyzpp": 780769998,
    "dropmaladd": "810 N US HIGHWAY 83",
    "dropmalcty": "ZAPATA",
    "dropmalst": "TX",
    "dropmalzpp": 780769998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567654666,
    "dropsitcph": 9567654666,
    "dropfax": 9567655213
  },
  {
    "dcode": "D",
    "dropkey": "PW26412",
    "droptype": "D",
    "dropname": "ZAVALLA",
    "dropdeladd": "247 E MAIN ST",
    "dropdelcty": "ZAVALLA",
    "dropdelst": "TX",
    "dropdelzpp": 759809998,
    "dropphyadd": "247 E MAIN ST",
    "dropphycty": "ZAVALLA",
    "dropphyst": "TX",
    "dropphyzpp": 759809998,
    "dropmaladd": "247 E MAIN ST",
    "dropmalcty": "ZAVALLA",
    "dropmalst": "TX",
    "dropmalzpp": 759809998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9368972136,
    "dropsitcph": 9368972136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PW26413",
    "droptype": "D",
    "dropname": "ZEPHYR",
    "dropdeladd": "11680 HIGHWAY 84 E",
    "dropdelcty": "ZEPHYR",
    "dropdelst": "TX",
    "dropdelzpp": 768903829,
    "dropphyadd": "11680 HIGHWAY 84 E",
    "dropphycty": "ZEPHYR",
    "dropphyst": "TX",
    "dropphyzpp": 768903829,
    "dropmaladd": "11680 HIGHWAY 84 E",
    "dropmalcty": "ZEPHYR",
    "dropmalst": "TX",
    "dropmalzpp": 768903829,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3257395741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A029",
    "droptype": "D",
    "dropname": "MUIR",
    "dropdeladd": "212 W WICONISCO ST OFC",
    "dropdelcty": "MUIR",
    "dropdelst": "PA",
    "dropdelzpp": 179579998,
    "dropphyadd": "212 W WICONISCO ST OFC",
    "dropphycty": "MUIR",
    "dropphyst": "PA",
    "dropphyzpp": 179579998,
    "dropmaladd": "212 W WICONISCO ST OFC",
    "dropmalcty": "MUIR",
    "dropmalst": "PA",
    "dropmalzpp": 179579998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176474555,
    "dropsitcph": 7176474555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A030",
    "droptype": "D",
    "dropname": "MUNCY",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "MUNCY",
    "dropdelst": "PA",
    "dropdelzpp": 177569998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "MUNCY",
    "dropphyst": "PA",
    "dropphyzpp": 177569998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "MUNCY",
    "dropmalst": "PA",
    "dropmalzpp": 177569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705463720,
    "dropfax": 5705466937
  },
  {
    "dcode": "D",
    "dropkey": "PX1A032",
    "droptype": "D",
    "dropname": "MUNCY VALLEY",
    "dropdeladd": "17 BENDERS RD",
    "dropdelcty": "MUNCY VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 177589998,
    "dropphyadd": "17 BENDERS RD",
    "dropphycty": "MUNCY VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 177589998,
    "dropmaladd": "17 BENDERS RD",
    "dropmalcty": "MUNCY VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 177589998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5704646281,
    "dropsitcph": 5704646281,
    "dropfax": 5704646269
  },
  {
    "dcode": "D",
    "dropkey": "PX1A036",
    "droptype": "D",
    "dropname": "MURRYSVILLE",
    "dropdeladd": "1 PRIORITY LN",
    "dropdelcty": "MURRYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 156689998,
    "dropphyadd": "1 PRIORITY LN",
    "dropphycty": "MURRYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 156689998,
    "dropmaladd": "1 PRIORITY LN",
    "dropmalcty": "MURRYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 156689998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243871772,
    "dropsitcph": 7243871772,
    "dropfax": 7247332667
  },
  {
    "dcode": "D",
    "dropkey": "PX1A039",
    "droptype": "D",
    "dropname": "MUSE",
    "dropdeladd": "184 MUSE BISHOP RD",
    "dropdelcty": "MUSE",
    "dropdelst": "PA",
    "dropdelzpp": 153501019,
    "dropphyadd": "184 MUSE BISHOP RD",
    "dropphycty": "MUSE",
    "dropphyst": "PA",
    "dropphyzpp": 153501019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MUSE",
    "dropmalst": "PA",
    "dropmalzpp": 153509998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247459370,
    "dropsitcph": 7247459370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A041",
    "droptype": "D",
    "dropname": "MYERSTOWN",
    "dropdeladd": "120 W JEFFERSON AVE",
    "dropdelcty": "MYERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170679998,
    "dropphyadd": "120 W JEFFERSON AVE",
    "dropphycty": "MYERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170679998,
    "dropmaladd": "120 W JEFFERSON AVE",
    "dropmalcty": "MYERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170679998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178662714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A058",
    "droptype": "D",
    "dropname": "NANTICOKE",
    "dropdeladd": "70 N MARKET ST",
    "dropdelcty": "NANTICOKE",
    "dropdelst": "PA",
    "dropdelzpp": 186349998,
    "dropphyadd": "70 N MARKET ST",
    "dropphycty": "NANTICOKE",
    "dropphyst": "PA",
    "dropphyzpp": 186349998,
    "dropmaladd": "70 N MARKET ST",
    "dropmalcty": "NANTICOKE",
    "dropmalst": "PA",
    "dropmalzpp": 186349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707356540,
    "dropfax": 5707359154
  },
  {
    "dcode": "D",
    "dropkey": "PX1A060",
    "droptype": "D",
    "dropname": "NANTY GLO",
    "dropdeladd": "950 CHESTNUT ST",
    "dropdelcty": "NANTY GLO",
    "dropdelst": "PA",
    "dropdelzpp": 159439998,
    "dropphyadd": "950 CHESTNUT ST",
    "dropphycty": "NANTY GLO",
    "dropphyst": "PA",
    "dropphyzpp": 159439998,
    "dropmaladd": "950 CHESTNUT ST",
    "dropmalcty": "NANTY GLO",
    "dropmalst": "PA",
    "dropmalzpp": 159439998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147499431,
    "dropsitcph": 8147499431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A062",
    "droptype": "D",
    "dropname": "NARBERTH",
    "dropdeladd": "144 N NARBERTH AVE",
    "dropdelcty": "NARBERTH",
    "dropdelst": "PA",
    "dropdelzpp": 190729998,
    "dropphyadd": "144 N NARBERTH AVE",
    "dropphycty": "NARBERTH",
    "dropphyst": "PA",
    "dropphyzpp": 190729998,
    "dropmaladd": "144 N NARBERTH AVE",
    "dropmalcty": "NARBERTH",
    "dropmalst": "PA",
    "dropmalzpp": 190729998,
    "dropsitphn": 6106170375,
    "dropsitlph": 6106681867,
    "dropsitcph": 6106170375,
    "dropfax": 6106608731
  },
  {
    "dcode": "D",
    "dropkey": "PX1A063",
    "droptype": "D",
    "dropname": "NARVON",
    "dropdeladd": "1125 NARVON RD",
    "dropdelcty": "NARVON",
    "dropdelst": "PA",
    "dropdelzpp": 175559998,
    "dropphyadd": "1125 NARVON RD",
    "dropphycty": "NARVON",
    "dropphyst": "PA",
    "dropphyzpp": 175559998,
    "dropmaladd": "1125 NARVON RD",
    "dropmalcty": "NARVON",
    "dropmalst": "PA",
    "dropmalzpp": 175559998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173545955,
    "dropsitcph": 7173545955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A072",
    "droptype": "D",
    "dropname": "NATRONA HEIGHTS",
    "dropdeladd": "1715 UNION AVE",
    "dropdelcty": "NATRONA HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 150659998,
    "dropphyadd": "1715 UNION AVE",
    "dropphycty": "NATRONA HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 150659998,
    "dropmaladd": "1715 UNION AVE",
    "dropmalcty": "NATRONA HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 150659998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242243809,
    "dropsitcph": 7242243809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A079",
    "droptype": "D",
    "dropname": "NAZARETH",
    "dropdeladd": "9 N MAIN ST",
    "dropdelcty": "NAZARETH",
    "dropdelst": "PA",
    "dropdelzpp": 180649998,
    "dropphyadd": "9 N MAIN ST",
    "dropphycty": "NAZARETH",
    "dropphyst": "PA",
    "dropphyzpp": 180649998,
    "dropmaladd": "9 N MAIN ST",
    "dropmalcty": "NAZARETH",
    "dropmalst": "PA",
    "dropmalzpp": 180649998,
    "dropsitphn": 6107593130,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107593075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A081",
    "droptype": "D",
    "dropname": "NEEDMORE",
    "dropdeladd": "7992 GREAT COVE RD",
    "dropdelcty": "NEEDMORE",
    "dropdelst": "PA",
    "dropdelzpp": 172389998,
    "dropphyadd": "7992 GREAT COVE RD",
    "dropphycty": "NEEDMORE",
    "dropphyst": "PA",
    "dropphyzpp": 172389998,
    "dropmaladd": "7992 GREAT COVE RD",
    "dropmalcty": "NEEDMORE",
    "dropmalst": "PA",
    "dropmalzpp": 172389998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175732270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A083",
    "droptype": "D",
    "dropname": "NEFFS",
    "dropdeladd": "5613 ROUTE 873",
    "dropdelcty": "NEFFS",
    "dropdelst": "PA",
    "dropdelzpp": 180659902,
    "dropphyadd": "5613 ROUTE 873",
    "dropphycty": "NEFFS",
    "dropphyst": "PA",
    "dropphyzpp": 180659902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEFFS",
    "dropmalst": "PA",
    "dropmalzpp": 180659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107677230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A088",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "1 VILLAGE DR",
    "dropdelcty": "NELSON",
    "dropdelst": "PA",
    "dropdelzpp": 169409998,
    "dropphyadd": "1 VILLAGE DR",
    "dropphycty": "NELSON",
    "dropphyst": "PA",
    "dropphyzpp": 169409998,
    "dropmaladd": "1 VILLAGE DR",
    "dropmalcty": "NELSON",
    "dropmalst": "PA",
    "dropmalzpp": 169409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5708272820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A089",
    "droptype": "D",
    "dropname": "NEMACOLIN",
    "dropdeladd": "1 PERSHING BLVD",
    "dropdelcty": "NEMACOLIN",
    "dropdelst": "PA",
    "dropdelzpp": 153511001,
    "dropphyadd": "1 PERSHING BLVD",
    "dropphycty": "NEMACOLIN",
    "dropphyst": "PA",
    "dropphyzpp": 153511001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEMACOLIN",
    "dropmalst": "PA",
    "dropmalzpp": 153519998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249667933,
    "dropsitcph": 7249667933,
    "dropfax": 7249667933
  },
  {
    "dcode": "D",
    "dropkey": "PX1A090",
    "droptype": "D",
    "dropname": "NESCOPECK",
    "dropdeladd": "311 BROAD ST",
    "dropdelcty": "NESCOPECK",
    "dropdelst": "PA",
    "dropdelzpp": 186359998,
    "dropphyadd": "311 BROAD ST",
    "dropphycty": "NESCOPECK",
    "dropphyst": "PA",
    "dropphyzpp": 186359998,
    "dropmaladd": "311 BROAD ST",
    "dropmalcty": "NESCOPECK",
    "dropmalst": "PA",
    "dropmalzpp": 186359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707598771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A092",
    "droptype": "D",
    "dropname": "NESQUEHONING",
    "dropdeladd": "300 W CATAWISSA ST",
    "dropdelcty": "NESQUEHONING",
    "dropdelst": "PA",
    "dropdelzpp": 182409998,
    "dropphyadd": "300 W CATAWISSA ST",
    "dropphycty": "NESQUEHONING",
    "dropphyst": "PA",
    "dropphyzpp": 182409998,
    "dropmaladd": "300 W CATAWISSA ST",
    "dropmalcty": "NESQUEHONING",
    "dropmalst": "PA",
    "dropmalzpp": 182409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706696621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A095",
    "droptype": "D",
    "dropname": "NEW ALBANY",
    "dropdeladd": "360 FRONT ST",
    "dropdelcty": "NEW ALBANY",
    "dropdelst": "PA",
    "dropdelzpp": 188339998,
    "dropphyadd": "360 FRONT ST",
    "dropphycty": "NEW ALBANY",
    "dropphyst": "PA",
    "dropphyzpp": 188339998,
    "dropmaladd": "360 FRONT ST",
    "dropmalcty": "NEW ALBANY",
    "dropmalst": "PA",
    "dropmalzpp": 188339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703632375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A096",
    "droptype": "D",
    "dropname": "NEW ALEXANDRIA",
    "dropdeladd": "198 W MAIN ST",
    "dropdelcty": "NEW ALEXANDRIA",
    "dropdelst": "PA",
    "dropdelzpp": 156709998,
    "dropphyadd": "198 W MAIN ST",
    "dropphycty": "NEW ALEXANDRIA",
    "dropphyst": "PA",
    "dropphyzpp": 156709998,
    "dropmaladd": "198 W MAIN ST",
    "dropmalcty": "NEW ALEXANDRIA",
    "dropmalst": "PA",
    "dropmalzpp": 156709998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246682470,
    "dropsitcph": 7246682470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A097",
    "droptype": "D",
    "dropname": "NEW BALTIMORE",
    "dropdeladd": "251 JUNIATA ST",
    "dropdelcty": "NEW BALTIMORE",
    "dropdelst": "PA",
    "dropdelzpp": 155539998,
    "dropphyadd": "251 JUNIATA ST",
    "dropphycty": "NEW BALTIMORE",
    "dropphyst": "PA",
    "dropphyzpp": 155539998,
    "dropmaladd": "251 JUNIATA ST",
    "dropmalcty": "NEW BALTIMORE",
    "dropmalst": "PA",
    "dropmalzpp": 155539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147334617,
    "dropsitcph": 8147334617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A098",
    "droptype": "D",
    "dropname": "NEW BEDFORD",
    "dropdeladd": "425 STATE ROUTE 208",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "PA",
    "dropdelzpp": 161409800,
    "dropphyadd": "425 STATE ROUTE 208",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "PA",
    "dropphyzpp": 161409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "PA",
    "dropmalzpp": 161409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249648828,
    "dropsitcph": 7249648828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A099",
    "droptype": "D",
    "dropname": "NEW BERLIN",
    "dropdeladd": "220 VINE ST",
    "dropdelcty": "NEW BERLIN",
    "dropdelst": "PA",
    "dropdelzpp": 178559998,
    "dropphyadd": "220 VINE ST",
    "dropphycty": "NEW BERLIN",
    "dropphyst": "PA",
    "dropphyzpp": 178559998,
    "dropmaladd": "220 VINE ST",
    "dropmalcty": "NEW BERLIN",
    "dropmalst": "PA",
    "dropmalzpp": 178559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709662139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A101",
    "droptype": "D",
    "dropname": "NEW BERLINVILLE",
    "dropdeladd": "721 N READING AVE",
    "dropdelcty": "NEW BERLINVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195459998,
    "dropphyadd": "721 N READING AVE",
    "dropphycty": "NEW BERLINVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195459998,
    "dropmaladd": "721 N READING AVE",
    "dropmalcty": "NEW BERLINVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195459998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103672756,
    "dropsitcph": 6103672756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A104",
    "droptype": "D",
    "dropname": "NEW BETHLEHEM",
    "dropdeladd": "451 BROAD ST",
    "dropdelcty": "NEW BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 162421100,
    "dropphyadd": "451 BROAD ST",
    "dropphycty": "NEW BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 162421100,
    "dropmaladd": "451 BROAD ST",
    "dropmalcty": "NEW BETHLEHEM",
    "dropmalst": "PA",
    "dropmalzpp": 162421100,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142753303,
    "dropsitcph": 8142753303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A105",
    "droptype": "D",
    "dropname": "NEW BLOOMFIELD",
    "dropdeladd": "21 E MCCLURE ST",
    "dropdelcty": "NEW BLOOMFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 170689998,
    "dropphyadd": "21 E MCCLURE ST",
    "dropphycty": "NEW BLOOMFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 170689998,
    "dropmaladd": "21 E MCCLURE ST",
    "dropmalcty": "NEW BLOOMFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 170689998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175822316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A108",
    "droptype": "D",
    "dropname": "NEW BRIGHTON",
    "dropdeladd": "510 11TH ST",
    "dropdelcty": "NEW BRIGHTON",
    "dropdelst": "PA",
    "dropdelzpp": 150669998,
    "dropphyadd": "510 11TH ST",
    "dropphycty": "NEW BRIGHTON",
    "dropphyst": "PA",
    "dropphyzpp": 150669998,
    "dropmaladd": "510 11TH ST",
    "dropmalcty": "NEW BRIGHTON",
    "dropmalst": "PA",
    "dropmalzpp": 150669998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248460458,
    "dropsitcph": 7248460458,
    "dropfax": 7248474368
  },
  {
    "dcode": "D",
    "dropkey": "PX1A110",
    "droptype": "D",
    "dropname": "NEW BUFFALO",
    "dropdeladd": "13 BUFFALO CREEK RD",
    "dropdelcty": "NEW BUFFALO",
    "dropdelst": "PA",
    "dropdelzpp": 170699998,
    "dropphyadd": "13 BUFFALO CREEK RD",
    "dropphycty": "NEW BUFFALO",
    "dropphyst": "PA",
    "dropphyzpp": 170699998,
    "dropmaladd": "13 BUFFALO CREEK RD",
    "dropmalcty": "NEW BUFFALO",
    "dropmalst": "PA",
    "dropmalzpp": 170699998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178345464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A112",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "435 S CASCADE ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161089998,
    "dropphyadd": "435 S CASCADE ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161089998,
    "dropmaladd": "435 S CASCADE ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161089998,
    "dropsitphn": 8148987318,
    "dropsitlph": 7246567221,
    "dropsitcph": 7246567221,
    "dropfax": 7246567205
  },
  {
    "dcode": "D",
    "dropkey": "PX1A118",
    "droptype": "D",
    "dropname": "NEW CUMBERLAND",
    "dropdeladd": "318 BRIDGE ST",
    "dropdelcty": "NEW CUMBERLAND",
    "dropdelst": "PA",
    "dropdelzpp": 170709998,
    "dropphyadd": "318 BRIDGE ST",
    "dropphycty": "NEW CUMBERLAND",
    "dropphyst": "PA",
    "dropphyzpp": 170709998,
    "dropmaladd": "318 BRIDGE ST",
    "dropmalcty": "NEW CUMBERLAND",
    "dropmalst": "PA",
    "dropmalzpp": 170709998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177747092,
    "dropfax": 7177745812
  },
  {
    "dcode": "D",
    "dropkey": "PX1A122",
    "droptype": "D",
    "dropname": "NEW DERRY",
    "dropdeladd": "5754 ROUTE 982",
    "dropdelcty": "NEW DERRY",
    "dropdelst": "PA",
    "dropdelzpp": 156711050,
    "dropphyadd": "5754 ROUTE 982",
    "dropphycty": "NEW DERRY",
    "dropphyst": "PA",
    "dropphyzpp": 156711050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW DERRY",
    "dropmalst": "PA",
    "dropmalzpp": 156719998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246942002,
    "dropsitcph": 7246942002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A123",
    "droptype": "D",
    "dropname": "NEW EAGLE",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "NEW EAGLE",
    "dropdelst": "PA",
    "dropdelzpp": 150679998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "NEW EAGLE",
    "dropphyst": "PA",
    "dropphyzpp": 150679998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "NEW EAGLE",
    "dropmalst": "PA",
    "dropmalzpp": 150679998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242583901,
    "dropsitcph": 7242583901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A124",
    "droptype": "D",
    "dropname": "NEW ENTERPRISE",
    "dropdeladd": "109 CHURCH ST",
    "dropdelcty": "NEW ENTERPRISE",
    "dropdelst": "PA",
    "dropdelzpp": 166649998,
    "dropphyadd": "109 CHURCH ST",
    "dropphycty": "NEW ENTERPRISE",
    "dropphyst": "PA",
    "dropphyzpp": 166649998,
    "dropmaladd": "109 CHURCH ST",
    "dropmalcty": "NEW ENTERPRISE",
    "dropmalst": "PA",
    "dropmalzpp": 166649998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147662984,
    "dropsitcph": 8147662984,
    "dropfax": 8147662831
  },
  {
    "dcode": "D",
    "dropkey": "PX1A125",
    "droptype": "D",
    "dropname": "NEW FLORENCE",
    "dropdeladd": "185 LIGONIER ST",
    "dropdelcty": "NEW FLORENCE",
    "dropdelst": "PA",
    "dropdelzpp": 159449998,
    "dropphyadd": "185 LIGONIER ST",
    "dropphycty": "NEW FLORENCE",
    "dropphyst": "PA",
    "dropphyzpp": 159449998,
    "dropmaladd": "185 LIGONIER ST",
    "dropmalcty": "NEW FLORENCE",
    "dropmalst": "PA",
    "dropmalzpp": 159449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242352301,
    "dropsitcph": 7242352301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A127",
    "droptype": "D",
    "dropname": "NEW FREEDOM",
    "dropdeladd": "5 S BROAD ST",
    "dropdelcty": "NEW FREEDOM",
    "dropdelst": "PA",
    "dropdelzpp": 173499998,
    "dropphyadd": "5 S BROAD ST",
    "dropphycty": "NEW FREEDOM",
    "dropphyst": "PA",
    "dropphyzpp": 173499998,
    "dropmaladd": "5 S BROAD ST",
    "dropmalcty": "NEW FREEDOM",
    "dropmalst": "PA",
    "dropmalzpp": 173499998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172352100,
    "dropsitcph": 7172352100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A128",
    "droptype": "D",
    "dropname": "NEW FREEPORT",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "NEW FREEPORT",
    "dropdelst": "PA",
    "dropdelzpp": 153529998,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "NEW FREEPORT",
    "dropphyst": "PA",
    "dropphyzpp": 153529998,
    "dropmaladd": "119 MAIN ST",
    "dropmalcty": "NEW FREEPORT",
    "dropmalst": "PA",
    "dropmalzpp": 153529998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244472792,
    "dropsitcph": 7244472792,
    "dropfax": 7244472848
  },
  {
    "dcode": "D",
    "dropkey": "PX1A130",
    "droptype": "D",
    "dropname": "NEW GALILEE",
    "dropdeladd": "801 WASHINGTON AVE",
    "dropdelcty": "NEW GALILEE",
    "dropdelst": "PA",
    "dropdelzpp": 161419800,
    "dropphyadd": "801 WASHINGTON AVE",
    "dropphycty": "NEW GALILEE",
    "dropphyst": "PA",
    "dropphyzpp": 161419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW GALILEE",
    "dropmalst": "PA",
    "dropmalzpp": 161419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243365013,
    "dropsitcph": 7243365013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A134",
    "droptype": "D",
    "dropname": "NEW HOLLAND",
    "dropdeladd": "150 DILLER AVE",
    "dropdelcty": "NEW HOLLAND",
    "dropdelst": "PA",
    "dropdelzpp": 175579998,
    "dropphyadd": "150 DILLER AVE",
    "dropphycty": "NEW HOLLAND",
    "dropphyst": "PA",
    "dropphyzpp": 175579998,
    "dropmaladd": "150 DILLER AVE",
    "dropmalcty": "NEW HOLLAND",
    "dropmalst": "PA",
    "dropmalzpp": 175579998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173542257,
    "dropsitcph": 7173542257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A135",
    "droptype": "D",
    "dropname": "NEW HOPE",
    "dropdeladd": "325 W BRIDGE ST",
    "dropdelcty": "NEW HOPE",
    "dropdelst": "PA",
    "dropdelzpp": 189389998,
    "dropphyadd": "325 W BRIDGE ST",
    "dropphycty": "NEW HOPE",
    "dropphyst": "PA",
    "dropphyzpp": 189389998,
    "dropmaladd": "325 W BRIDGE ST",
    "dropmalcty": "NEW HOPE",
    "dropmalst": "PA",
    "dropmalzpp": 189389998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158622445,
    "dropsitcph": 2158622445,
    "dropfax": 2158625265
  },
  {
    "dcode": "D",
    "dropkey": "PX1A137",
    "droptype": "D",
    "dropname": "NEW KENSINGTON",
    "dropdeladd": "501 11TH ST",
    "dropdelcty": "NEW KENSINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 150689998,
    "dropphyadd": "501 11TH ST",
    "dropphycty": "NEW KENSINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 150689998,
    "dropmaladd": "501 11TH ST",
    "dropmalcty": "NEW KENSINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 150689998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243358174,
    "dropsitcph": 7243358174,
    "dropfax": 7243351253
  },
  {
    "dcode": "D",
    "dropkey": "PX1A138",
    "droptype": "D",
    "dropname": "NEW KINGSTOWN",
    "dropdeladd": "31 E MAIN ST",
    "dropdelcty": "NEW KINGSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170729998,
    "dropphyadd": "31 E MAIN ST",
    "dropphycty": "NEW KINGSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170729998,
    "dropmaladd": "31 E MAIN ST",
    "dropmalcty": "NEW KINGSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177660172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A139",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "2050 NEWARK RD",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "PA",
    "dropdelzpp": 193609997,
    "dropphyadd": "2050 NEWARK RD",
    "dropphycty": "NEW LONDON",
    "dropphyst": "PA",
    "dropphyzpp": 193609997,
    "dropmaladd": "1 MUNICIPAL LN",
    "dropmalcty": "KEMBLESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193471000,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108693434,
    "dropsitcph": 6108693434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A141",
    "droptype": "D",
    "dropname": "NEW MILFORD",
    "dropdeladd": "667 MAIN ST",
    "dropdelcty": "NEW MILFORD",
    "dropdelst": "PA",
    "dropdelzpp": 188349998,
    "dropphyadd": "667 MAIN ST",
    "dropphycty": "NEW MILFORD",
    "dropphyst": "PA",
    "dropphyzpp": 188349998,
    "dropmaladd": "667 MAIN ST",
    "dropmalcty": "NEW MILFORD",
    "dropmalst": "PA",
    "dropmalzpp": 188349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704653700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A143",
    "droptype": "D",
    "dropname": "NEW MILLPORT",
    "dropdeladd": "7083 DOUGLAS RD",
    "dropdelcty": "NEW MILLPORT",
    "dropdelst": "PA",
    "dropdelzpp": 168619998,
    "dropphyadd": "7083 DOUGLAS RD",
    "dropphycty": "NEW MILLPORT",
    "dropphyst": "PA",
    "dropphyzpp": 168619998,
    "dropmaladd": "7083 DOUGLAS RD",
    "dropmalcty": "NEW MILLPORT",
    "dropmalst": "PA",
    "dropmalzpp": 168619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142363561,
    "dropsitcph": 8142363561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A146",
    "droptype": "D",
    "dropname": "NEW OXFORD",
    "dropdeladd": "4 CENTER SQ",
    "dropdelcty": "NEW OXFORD",
    "dropdelst": "PA",
    "dropdelzpp": 173509998,
    "dropphyadd": "4 CENTER SQ",
    "dropphycty": "NEW OXFORD",
    "dropphyst": "PA",
    "dropphyzpp": 173509998,
    "dropmaladd": "4 CENTER SQ",
    "dropmalcty": "NEW OXFORD",
    "dropmalst": "PA",
    "dropmalzpp": 173509998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176247451,
    "dropsitcph": 7176247451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A147",
    "droptype": "D",
    "dropname": "NEW PARIS",
    "dropdeladd": "3822 CORTLAND RD",
    "dropdelcty": "NEW PARIS",
    "dropdelst": "PA",
    "dropdelzpp": 155549998,
    "dropphyadd": "3822 CORTLAND RD",
    "dropphycty": "NEW PARIS",
    "dropphyst": "PA",
    "dropphyzpp": 155549998,
    "dropmaladd": "3822 CORTLAND RD",
    "dropmalcty": "NEW PARIS",
    "dropmalst": "PA",
    "dropmalzpp": 155549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148392414,
    "dropsitcph": 8148392414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A148",
    "droptype": "D",
    "dropname": "NEW PARK",
    "dropdeladd": "44 CAREA RD",
    "dropdelcty": "NEW PARK",
    "dropdelst": "PA",
    "dropdelzpp": 173529998,
    "dropphyadd": "44 CAREA RD",
    "dropphycty": "NEW PARK",
    "dropphyst": "PA",
    "dropphyzpp": 173529998,
    "dropmaladd": "44 CAREA RD",
    "dropmalcty": "NEW PARK",
    "dropmalst": "PA",
    "dropmalzpp": 173529998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173824112,
    "dropsitcph": 7173824112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A150",
    "droptype": "D",
    "dropname": "NEW PHILADELPHIA",
    "dropdeladd": "121 VALLEY ST",
    "dropdelcty": "NEW PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 179599998,
    "dropphyadd": "121 VALLEY ST",
    "dropphycty": "NEW PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 179599998,
    "dropmaladd": "121 VALLEY ST",
    "dropmalcty": "NEW PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 179599998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5702776342,
    "dropsitcph": 5702776342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A155",
    "droptype": "D",
    "dropname": "NEW PROVIDENCE",
    "dropdeladd": "69 MAIN ST",
    "dropdelcty": "NEW PROVIDENCE",
    "dropdelst": "PA",
    "dropdelzpp": 175609998,
    "dropphyadd": "69 MAIN ST",
    "dropphycty": "NEW PROVIDENCE",
    "dropphyst": "PA",
    "dropphyzpp": 175609998,
    "dropmaladd": "69 MAIN ST",
    "dropmalcty": "NEW PROVIDENCE",
    "dropmalst": "PA",
    "dropmalzpp": 175609998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177867111,
    "dropsitcph": 7177867111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A156",
    "droptype": "D",
    "dropname": "NEW RINGGOLD",
    "dropdeladd": "27 N RAILROAD ST",
    "dropdelcty": "NEW RINGGOLD",
    "dropdelst": "PA",
    "dropdelzpp": 179609998,
    "dropphyadd": "27 N RAILROAD ST",
    "dropphycty": "NEW RINGGOLD",
    "dropphyst": "PA",
    "dropphyzpp": 179609998,
    "dropmaladd": "27 N RAILROAD ST",
    "dropmalcty": "NEW RINGGOLD",
    "dropmalst": "PA",
    "dropmalzpp": 179609998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5709432470,
    "dropsitcph": 5709432470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A157",
    "droptype": "D",
    "dropname": "NEW SALEM",
    "dropdeladd": "9 W MAIN ST",
    "dropdelcty": "NEW SALEM",
    "dropdelst": "PA",
    "dropdelzpp": 154682111,
    "dropphyadd": "9 W MAIN ST",
    "dropphycty": "NEW SALEM",
    "dropphyst": "PA",
    "dropphyzpp": 154682111,
    "dropmaladd": "9 W MAIN ST",
    "dropmalcty": "NEW SALEM",
    "dropmalst": "PA",
    "dropmalzpp": 154682111,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242452284,
    "dropsitcph": 7242452284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A160",
    "droptype": "D",
    "dropname": "NEW STANTON",
    "dropdeladd": "135 W PENNSYLVANIA AVE",
    "dropdelcty": "NEW STANTON",
    "dropdelst": "PA",
    "dropdelzpp": 156729998,
    "dropphyadd": "135 W PENNSYLVANIA AVE",
    "dropphycty": "NEW STANTON",
    "dropphyst": "PA",
    "dropphyzpp": 156729998,
    "dropmaladd": "135 W PENNSYLVANIA AVE",
    "dropmalcty": "NEW STANTON",
    "dropmalst": "PA",
    "dropmalzpp": 156729998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249252335,
    "dropsitcph": 7249252335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A163",
    "droptype": "D",
    "dropname": "NEW TRIPOLI",
    "dropdeladd": "6736 MADISON ST",
    "dropdelcty": "NEW TRIPOLI",
    "dropdelst": "PA",
    "dropdelzpp": 180669800,
    "dropphyadd": "6736 MADISON ST",
    "dropphycty": "NEW TRIPOLI",
    "dropphyst": "PA",
    "dropphyzpp": 180669800,
    "dropmaladd": "6736 MADISON ST",
    "dropmalcty": "NEW TRIPOLI",
    "dropmalst": "PA",
    "dropmalzpp": 180669800,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102982550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A164",
    "droptype": "D",
    "dropname": "NEW WILMINGTON",
    "dropdeladd": "143 W NESHANNOCK AVE",
    "dropdelcty": "NEW WILMINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 161421190,
    "dropphyadd": "143 W NESHANNOCK AVE",
    "dropphycty": "NEW WILMINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 161421190,
    "dropmaladd": "143 W NESHANNOCK AVE",
    "dropmalcty": "NEW WILMINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 161421190,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249462581,
    "dropsitcph": 7249462581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A168",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "12 S WATER ST",
    "dropdelcty": "NEWBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172409998,
    "dropphyadd": "12 S WATER ST",
    "dropphycty": "NEWBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172409998,
    "dropmaladd": "12 S WATER ST",
    "dropmalcty": "NEWBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174236105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A170",
    "droptype": "D",
    "dropname": "NEWELL",
    "dropdeladd": "406 4TH ST",
    "dropdelcty": "NEWELL",
    "dropdelst": "PA",
    "dropdelzpp": 154661001,
    "dropphyadd": "406 4TH ST",
    "dropphycty": "NEWELL",
    "dropphyst": "PA",
    "dropphyzpp": 154661001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWELL",
    "dropmalst": "PA",
    "dropmalzpp": 154669998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249387185,
    "dropsitcph": 7249387185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A172",
    "droptype": "D",
    "dropname": "NEWFOUNDLAND",
    "dropdeladd": "8 PANTHER RD",
    "dropdelcty": "NEWFOUNDLAND",
    "dropdelst": "PA",
    "dropdelzpp": 184459998,
    "dropphyadd": "8 PANTHER RD",
    "dropphycty": "NEWFOUNDLAND",
    "dropphyst": "PA",
    "dropphyzpp": 184459998,
    "dropmaladd": "8 PANTHER RD",
    "dropmalcty": "NEWFOUNDLAND",
    "dropmalst": "PA",
    "dropmalzpp": 184459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706763341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A175",
    "droptype": "D",
    "dropname": "NEWMANSTOWN",
    "dropdeladd": "4 E MAIN ST",
    "dropdelcty": "NEWMANSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170739998,
    "dropphyadd": "4 E MAIN ST",
    "dropphycty": "NEWMANSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170739998,
    "dropmaladd": "4 E MAIN ST",
    "dropmalcty": "NEWMANSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170739998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 6105894742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A176",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "226 WALNUT ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "PA",
    "dropdelzpp": 170749998,
    "dropphyadd": "226 WALNUT ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "PA",
    "dropphyzpp": 170749998,
    "dropmaladd": "226 WALNUT ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "PA",
    "dropmalzpp": 170749998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175676622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A179",
    "droptype": "D",
    "dropname": "NEWRY",
    "dropdeladd": "825 PATRICK LN",
    "dropdelcty": "NEWRY",
    "dropdelst": "PA",
    "dropdelzpp": 166659998,
    "dropphyadd": "825 PATRICK LN",
    "dropphycty": "NEWRY",
    "dropphyst": "PA",
    "dropphyzpp": 166659998,
    "dropmaladd": "825 PATRICK LN",
    "dropmalcty": "NEWRY",
    "dropmalst": "PA",
    "dropmalzpp": 166659998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146957024,
    "dropsitcph": 8146957024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A181",
    "droptype": "D",
    "dropname": "NEWTON HAMILTON",
    "dropdeladd": "15 WAYNE ST",
    "dropdelcty": "NEWTON HAMILTON",
    "dropdelst": "PA",
    "dropdelzpp": 170759998,
    "dropphyadd": "15 WAYNE ST",
    "dropphycty": "NEWTON HAMILTON",
    "dropphyst": "PA",
    "dropphyzpp": 170759998,
    "dropmaladd": "15 WAYNE ST",
    "dropmalcty": "NEWTON HAMILTON",
    "dropmalst": "PA",
    "dropmalzpp": 170759998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8145424455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A182",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "20 TERRY DR",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189409998,
    "dropphyadd": "20 TERRY DR",
    "dropphycty": "NEWTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189409998,
    "dropmaladd": "20 TERRY DR",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189409998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2159686697,
    "dropsitcph": 2159686697,
    "dropfax": 2159689592
  },
  {
    "dcode": "D",
    "dropkey": "PX1A184",
    "droptype": "D",
    "dropname": "NEWTOWN SQUARE",
    "dropdeladd": "3576 W CHESTER PIKE",
    "dropdelcty": "NEWTOWN SQUARE",
    "dropdelst": "PA",
    "dropdelzpp": 190739997,
    "dropphyadd": "3576 W CHESTER PIKE",
    "dropphycty": "NEWTOWN SQUARE",
    "dropphyst": "PA",
    "dropphyzpp": 190739997,
    "dropmaladd": "3576 W CHESTER PIKE",
    "dropmalcty": "NEWTOWN SQUARE",
    "dropmalst": "PA",
    "dropmalzpp": 190739997,
    "dropsitphn": 6103550782,
    "dropsitlph": 6103550782,
    "dropsitcph": 6103550782,
    "dropfax": 6103563863
  },
  {
    "dcode": "D",
    "dropkey": "PX1A185",
    "droptype": "D",
    "dropname": "NEWVILLE",
    "dropdeladd": "57 WEST ST",
    "dropdelcty": "NEWVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 172419998,
    "dropphyadd": "57 WEST ST",
    "dropphycty": "NEWVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 172419998,
    "dropmaladd": "57 WEST ST",
    "dropmalcty": "NEWVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 172419998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173239665,
    "dropfax": 7177766264
  },
  {
    "dcode": "D",
    "dropkey": "PX1A189",
    "droptype": "D",
    "dropname": "NICHOLSON",
    "dropdeladd": "290 MAIN ST",
    "dropdelcty": "NICHOLSON",
    "dropdelst": "PA",
    "dropdelzpp": 184469998,
    "dropphyadd": "290 MAIN ST",
    "dropphycty": "NICHOLSON",
    "dropphyst": "PA",
    "dropphyzpp": 184469998,
    "dropmaladd": "290 MAIN ST",
    "dropmalcty": "NICHOLSON",
    "dropmalst": "PA",
    "dropmalzpp": 184469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709426325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A191",
    "droptype": "D",
    "dropname": "NICKTOWN",
    "dropdeladd": "3281 BLUE GOOSE RD",
    "dropdelcty": "NICKTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 157629998,
    "dropphyadd": "3281 BLUE GOOSE RD",
    "dropphycty": "NICKTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 157629998,
    "dropmaladd": "3281 BLUE GOOSE RD",
    "dropmalcty": "NICKTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 157629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149484049,
    "dropsitcph": 8149484049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A195",
    "droptype": "D",
    "dropname": "NINEVEH",
    "dropdeladd": "1750 BROWNS CREEK RD",
    "dropdelcty": "NINEVEH",
    "dropdelst": "PA",
    "dropdelzpp": 153531001,
    "dropphyadd": "1750 BROWNS CREEK RD",
    "dropphycty": "NINEVEH",
    "dropphyst": "PA",
    "dropphyzpp": 153531001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NINEVEH",
    "dropmalst": "PA",
    "dropmalzpp": 153539998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244284275,
    "dropsitcph": 7244284275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A205",
    "droptype": "D",
    "dropname": "NORMALVILLE",
    "dropdeladd": "3318 SPRINGFIELD PIKE",
    "dropdelcty": "NORMALVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 154692111,
    "dropphyadd": "3318 SPRINGFIELD PIKE",
    "dropphycty": "NORMALVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 154692111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORMALVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 154699998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244553200,
    "dropsitcph": 7244553200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A208",
    "droptype": "D",
    "dropname": "NORRISTOWN",
    "dropdeladd": "28 E AIRY ST",
    "dropdelcty": "NORRISTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194019998,
    "dropphyadd": "28 E AIRY ST",
    "dropphycty": "NORRISTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194019998,
    "dropmaladd": "28 E AIRY ST",
    "dropmalcty": "NORRISTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194019998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102750198,
    "dropsitcph": 6102750198,
    "dropfax": 6102928491
  },
  {
    "dcode": "D",
    "dropkey": "PX1A211",
    "droptype": "D",
    "dropname": "NORTH APOLLO",
    "dropdeladd": "312 16TH ST",
    "dropdelcty": "NORTH APOLLO",
    "dropdelst": "PA",
    "dropdelzpp": 156731001,
    "dropphyadd": "312 16TH ST",
    "dropphycty": "NORTH APOLLO",
    "dropphyst": "PA",
    "dropphyzpp": 156731001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH APOLLO",
    "dropmalst": "PA",
    "dropmalzpp": 156739998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244783072,
    "dropsitcph": 7244783072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A212",
    "droptype": "D",
    "dropname": "NORTH BEND",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "NORTH BEND",
    "dropdelst": "PA",
    "dropdelzpp": 177609998,
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "NORTH BEND",
    "dropphyst": "PA",
    "dropphyzpp": 177609998,
    "dropmaladd": "232 MAIN ST",
    "dropmalcty": "NORTH BEND",
    "dropmalst": "PA",
    "dropmalzpp": 177609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5709231643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A215",
    "droptype": "D",
    "dropname": "NORTH EAST",
    "dropdeladd": "38 S LAKE ST",
    "dropdelcty": "NORTH EAST",
    "dropdelst": "PA",
    "dropdelzpp": 164281200,
    "dropphyadd": "38 S LAKE ST",
    "dropphycty": "NORTH EAST",
    "dropphyst": "PA",
    "dropphyzpp": 164281200,
    "dropmaladd": "38 S LAKE ST",
    "dropmalcty": "NORTH EAST",
    "dropmalst": "PA",
    "dropmalzpp": 164281200,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147254009,
    "dropsitcph": 8147254009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A229",
    "droptype": "D",
    "dropname": "NORTH SPRINGFIELD",
    "dropdeladd": "1526 HOLLIDAY RD",
    "dropdelcty": "NORTH SPRINGFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 164301232,
    "dropphyadd": "1526 HOLLIDAY RD",
    "dropphycty": "NORTH SPRINGFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 164301232,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SPRINGFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 164119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149223939,
    "dropsitcph": 8149223939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A231",
    "droptype": "D",
    "dropname": "NORTH VERSAILLES",
    "dropdeladd": "353 LINCOLN HWY",
    "dropdelcty": "NORTH VERSAILLES",
    "dropdelst": "PA",
    "dropdelzpp": 151379998,
    "dropphyadd": "353 LINCOLN HWY",
    "dropphycty": "NORTH VERSAILLES",
    "dropphyst": "PA",
    "dropphyzpp": 151379998,
    "dropmaladd": "353 LINCOLN HWY",
    "dropmalcty": "NORTH VERSAILLES",
    "dropmalst": "PA",
    "dropmalzpp": 151379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128247686,
    "dropsitcph": 4128247686,
    "dropfax": 4128240271
  },
  {
    "dcode": "D",
    "dropkey": "PX1A232",
    "droptype": "D",
    "dropname": "NORTH WALES",
    "dropdeladd": "450 BEAVER ST",
    "dropdelcty": "NORTH WALES",
    "dropdelst": "PA",
    "dropdelzpp": 194549998,
    "dropphyadd": "450 BEAVER ST",
    "dropphycty": "NORTH WALES",
    "dropphyst": "PA",
    "dropphyzpp": 194549998,
    "dropmaladd": "450 BEAVER ST",
    "dropmalcty": "NORTH WALES",
    "dropmalst": "PA",
    "dropmalzpp": 194549998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2156610652,
    "dropsitcph": 2156610652,
    "dropfax": 2156996202
  },
  {
    "dcode": "D",
    "dropkey": "PX1A234",
    "droptype": "D",
    "dropname": "NORTH WASHINGTON",
    "dropdeladd": "739 FAIRVIEW RD",
    "dropdelcty": "NORTH WASHINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 160489800,
    "dropphyadd": "739 FAIRVIEW RD",
    "dropphycty": "NORTH WASHINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 160489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH WASHINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 160489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248942219,
    "dropsitcph": 7248942219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A235",
    "droptype": "D",
    "dropname": "NORTHAMPTON",
    "dropdeladd": "1701 WASHINGTON AVE",
    "dropdelcty": "NORTHAMPTON",
    "dropdelst": "PA",
    "dropdelzpp": 180679998,
    "dropphyadd": "1701 WASHINGTON AVE",
    "dropphycty": "NORTHAMPTON",
    "dropphyst": "PA",
    "dropphyzpp": 180679998,
    "dropmaladd": "1701 WASHINGTON AVE",
    "dropmalcty": "NORTHAMPTON",
    "dropmalst": "PA",
    "dropmalzpp": 180679998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102622676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A237",
    "droptype": "D",
    "dropname": "NORTHUMBERLAND",
    "dropdeladd": "75 QUEEN ST",
    "dropdelcty": "NORTHUMBERLAND",
    "dropdelst": "PA",
    "dropdelzpp": 178579800,
    "dropphyadd": "75 QUEEN ST",
    "dropphycty": "NORTHUMBERLAND",
    "dropphyst": "PA",
    "dropphyzpp": 178579800,
    "dropmaladd": "75 QUEEN ST",
    "dropmalcty": "NORTHUMBERLAND",
    "dropmalst": "PA",
    "dropmalzpp": 178579800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5704733581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A238",
    "droptype": "D",
    "dropname": "NORVELT",
    "dropdeladd": "2333 MOUNT PLEASANT RD",
    "dropdelcty": "NORVELT",
    "dropdelst": "PA",
    "dropdelzpp": 156741001,
    "dropphyadd": "2333 MOUNT PLEASANT RD",
    "dropphycty": "NORVELT",
    "dropphyst": "PA",
    "dropphyzpp": 156741001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORVELT",
    "dropmalst": "PA",
    "dropmalzpp": 156749998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244232734,
    "dropsitcph": 7244232734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A239",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "326 CHESTER PIKE",
    "dropdelcty": "NORWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 190749998,
    "dropphyadd": "326 CHESTER PIKE",
    "dropphycty": "NORWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 190749998,
    "dropmaladd": "326 CHESTER PIKE",
    "dropmalcty": "NORWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 190749998,
    "dropsitphn": 6104611708,
    "dropsitlph": 6105861250,
    "dropsitcph": 6104611708,
    "dropfax": 6105326010
  },
  {
    "dcode": "D",
    "dropkey": "PX1A241",
    "droptype": "D",
    "dropname": "NOTTINGHAM",
    "dropdeladd": "127 BALTIMORE PIKE",
    "dropdelcty": "NOTTINGHAM",
    "dropdelst": "PA",
    "dropdelzpp": 193629998,
    "dropphyadd": "127 BALTIMORE PIKE",
    "dropphycty": "NOTTINGHAM",
    "dropphyst": "PA",
    "dropphyzpp": 193629998,
    "dropmaladd": "127 BALTIMORE PIKE",
    "dropmalcty": "NOTTINGHAM",
    "dropmalst": "PA",
    "dropmalzpp": 193629998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109989254,
    "dropsitcph": 6109989254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A246",
    "droptype": "D",
    "dropname": "NU MINE",
    "dropdeladd": "1409 STATE ROUTE 1042",
    "dropdelcty": "NU MINE",
    "dropdelst": "PA",
    "dropdelzpp": 162449800,
    "dropphyadd": "1409 STATE ROUTE 1042",
    "dropphycty": "NU MINE",
    "dropphyst": "PA",
    "dropphyzpp": 162449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NU MINE",
    "dropmalst": "PA",
    "dropmalzpp": 162449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247836698,
    "dropsitcph": 7247836698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A249",
    "droptype": "D",
    "dropname": "NUMIDIA",
    "dropdeladd": "1114 NUMIDIA DR",
    "dropdelcty": "NUMIDIA",
    "dropdelst": "PA",
    "dropdelzpp": 178589998,
    "dropphyadd": "1114 NUMIDIA DR",
    "dropphycty": "NUMIDIA",
    "dropphyst": "PA",
    "dropphyzpp": 178589998,
    "dropmaladd": "1114 NUMIDIA DR",
    "dropmalcty": "NUMIDIA",
    "dropmalst": "PA",
    "dropmalzpp": 178589998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707995701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A250",
    "droptype": "D",
    "dropname": "NUREMBERG",
    "dropdeladd": "200 MAHANOY ST",
    "dropdelcty": "NUREMBERG",
    "dropdelst": "PA",
    "dropdelzpp": 182419998,
    "dropphyadd": "200 MAHANOY ST",
    "dropphycty": "NUREMBERG",
    "dropphyst": "PA",
    "dropphyzpp": 182419998,
    "dropmaladd": "200 MAHANOY ST",
    "dropmalcty": "NUREMBERG",
    "dropmalst": "PA",
    "dropmalzpp": 182419998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703843441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A275",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 162459800,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 162459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 162459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143652305,
    "dropsitcph": 8143652305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A278",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "101 UNION AVE",
    "dropdelcty": "OAKDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150719998,
    "dropphyadd": "101 UNION AVE",
    "dropphycty": "OAKDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150719998,
    "dropmaladd": "101 UNION AVE",
    "dropmalcty": "OAKDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150719998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246938280,
    "dropsitcph": 7246938280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A282",
    "droptype": "D",
    "dropname": "OAKLAND MILLS",
    "dropdeladd": "28442 ROUTE 35 N STE 1",
    "dropdelcty": "OAKLAND MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 170769998,
    "dropphyadd": "28442 ROUTE 35 N STE 1",
    "dropphycty": "OAKLAND MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 170769998,
    "dropmaladd": "28442 ROUTE 35 N STE 1",
    "dropmalcty": "OAKLAND MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 170769998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174632742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A285",
    "droptype": "D",
    "dropname": "OAKMONT",
    "dropdeladd": "530 ALLEGHENY RIVER BLVD",
    "dropdelcty": "OAKMONT",
    "dropdelst": "PA",
    "dropdelzpp": 151399998,
    "dropphyadd": "530 ALLEGHENY RIVER BLVD",
    "dropphycty": "OAKMONT",
    "dropphyst": "PA",
    "dropphyzpp": 151399998,
    "dropmaladd": "530 ALLEGHENY RIVER BLVD",
    "dropmalcty": "OAKMONT",
    "dropmalst": "PA",
    "dropmalzpp": 151399998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128289617,
    "dropsitcph": 4128289617,
    "dropfax": 4124269184
  },
  {
    "dcode": "D",
    "dropkey": "PX1A287",
    "droptype": "D",
    "dropname": "OAKS",
    "dropdeladd": "1310 EGYPT RD",
    "dropdelcty": "OAKS",
    "dropdelst": "PA",
    "dropdelzpp": 194569901,
    "dropphyadd": "1310 EGYPT RD",
    "dropphycty": "OAKS",
    "dropphyst": "PA",
    "dropphyzpp": 194569901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKS",
    "dropmalst": "PA",
    "dropmalzpp": 194569998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106665589,
    "dropsitcph": 6106665589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A303",
    "droptype": "D",
    "dropname": "OHIOPYLE",
    "dropdeladd": "122 GRANT ST",
    "dropdelcty": "OHIOPYLE",
    "dropdelst": "PA",
    "dropdelzpp": 154701111,
    "dropphyadd": "122 GRANT ST",
    "dropphycty": "OHIOPYLE",
    "dropphyst": "PA",
    "dropphyzpp": 154701111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OHIOPYLE",
    "dropmalst": "PA",
    "dropmalzpp": 154709998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243298605,
    "dropsitcph": 7243298605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A305",
    "droptype": "D",
    "dropname": "OIL CITY",
    "dropdeladd": "302 E 2ND ST",
    "dropdelcty": "OIL CITY",
    "dropdelst": "PA",
    "dropdelzpp": 163012300,
    "dropphyadd": "302 E 2ND ST",
    "dropphycty": "OIL CITY",
    "dropphyst": "PA",
    "dropphyzpp": 163012300,
    "dropmaladd": "302 E 2ND ST",
    "dropmalcty": "OIL CITY",
    "dropmalst": "PA",
    "dropmalzpp": 163012300,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146771266,
    "dropsitcph": 8146771266,
    "dropfax": 8146763279
  },
  {
    "dcode": "D",
    "dropkey": "PX1A309",
    "droptype": "D",
    "dropname": "OLANTA",
    "dropdeladd": "86 LITTLE CLEARFIELD CREEK RD",
    "dropdelcty": "OLANTA",
    "dropdelst": "PA",
    "dropdelzpp": 168639998,
    "dropphyadd": "86 LITTLE CLEARFIELD CREEK RD",
    "dropphycty": "OLANTA",
    "dropphyst": "PA",
    "dropphyzpp": 168639998,
    "dropmaladd": "86 LITTLE CLEARFIELD CREEK RD",
    "dropmalcty": "OLANTA",
    "dropmalst": "PA",
    "dropmalzpp": 168639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142363280,
    "dropsitcph": 8142363280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A316",
    "droptype": "D",
    "dropname": "OLD ZIONSVILLE",
    "dropdeladd": "5831 KINGS HWY S",
    "dropdelcty": "OLD ZIONSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180689998,
    "dropphyadd": "5831 KINGS HWY S",
    "dropphycty": "OLD ZIONSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180689998,
    "dropmaladd": "5831 KINGS HWY S",
    "dropmalcty": "OLD ZIONSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180689998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6109663106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A319",
    "droptype": "D",
    "dropname": "OLEY",
    "dropdeladd": "644 MAIN ST",
    "dropdelcty": "OLEY",
    "dropdelst": "PA",
    "dropdelzpp": 195479998,
    "dropphyadd": "644 MAIN ST",
    "dropphycty": "OLEY",
    "dropphyst": "PA",
    "dropphyzpp": 195479998,
    "dropmaladd": "644 MAIN ST",
    "dropmalcty": "OLEY",
    "dropmalst": "PA",
    "dropmalzpp": 195479998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109876054,
    "dropsitcph": 6109876054,
    "dropfax": 7179876075
  },
  {
    "dcode": "D",
    "dropkey": "PX1A325",
    "droptype": "D",
    "dropname": "OLIVER",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "OLIVER",
    "dropdelst": "PA",
    "dropdelzpp": 154721000,
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "OLIVER",
    "dropphyst": "PA",
    "dropphyzpp": 154721000,
    "dropmaladd": "232 MAIN ST",
    "dropmalcty": "OLIVER",
    "dropmalst": "PA",
    "dropmalzpp": 154721000,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244391540,
    "dropsitcph": 7244391540,
    "dropfax": 7244391540
  },
  {
    "dcode": "D",
    "dropkey": "PX1A328",
    "droptype": "D",
    "dropname": "OLYPHANT",
    "dropdeladd": "517 BURKE BYP",
    "dropdelcty": "OLYPHANT",
    "dropdelst": "PA",
    "dropdelzpp": 184479998,
    "dropphyadd": "517 BURKE BYP",
    "dropphycty": "OLYPHANT",
    "dropphyst": "PA",
    "dropphyzpp": 184479998,
    "dropmaladd": "517 BURKE BYP",
    "dropmalcty": "OLYPHANT",
    "dropmalst": "PA",
    "dropmalzpp": 184479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704893831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A329",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "172 FIRST ST",
    "dropdelcty": "ONEIDA",
    "dropdelst": "PA",
    "dropdelzpp": 182429998,
    "dropphyadd": "172 FIRST ST",
    "dropphycty": "ONEIDA",
    "dropphyst": "PA",
    "dropphyzpp": 182429998,
    "dropmaladd": "172 FIRST ST",
    "dropmalcty": "ONEIDA",
    "dropmalst": "PA",
    "dropmalzpp": 182429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703843391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A330",
    "droptype": "D",
    "dropname": "ONO",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "ONO",
    "dropdelst": "PA",
    "dropdelzpp": 170779998,
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "ONO",
    "dropphyst": "PA",
    "dropphyzpp": 170779998,
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "ONO",
    "dropmalst": "PA",
    "dropmalzpp": 170779998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178653397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A334",
    "droptype": "D",
    "dropname": "ORANGEVILLE",
    "dropdeladd": "410 MILL ST",
    "dropdelcty": "ORANGEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178599800,
    "dropphyadd": "410 MILL ST",
    "dropphycty": "ORANGEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178599800,
    "dropmaladd": "410 MILL ST",
    "dropmalcty": "ORANGEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178599998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706835126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A335",
    "droptype": "D",
    "dropname": "ORBISONIA",
    "dropdeladd": "655 WATER ST",
    "dropdelcty": "ORBISONIA",
    "dropdelst": "PA",
    "dropdelzpp": 172439998,
    "dropphyadd": "655 WATER ST",
    "dropphycty": "ORBISONIA",
    "dropphyst": "PA",
    "dropphyzpp": 172439998,
    "dropmaladd": "655 WATER ST",
    "dropmalcty": "ORBISONIA",
    "dropmalst": "PA",
    "dropmalzpp": 172439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8144475684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A337",
    "droptype": "D",
    "dropname": "OREFIELD",
    "dropdeladd": "4711 KERNSVILLE RD",
    "dropdelcty": "OREFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 180699998,
    "dropphyadd": "4711 KERNSVILLE RD",
    "dropphycty": "OREFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 180699998,
    "dropmaladd": "4711 KERNSVILLE RD",
    "dropmalcty": "OREFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 180699998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6103953922,
    "dropsitcph": 6103953922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A340",
    "droptype": "D",
    "dropname": "ORELAND",
    "dropdeladd": "1407 BRUCE RD",
    "dropdelcty": "ORELAND",
    "dropdelst": "PA",
    "dropdelzpp": 190759998,
    "dropphyadd": "1407 BRUCE RD",
    "dropphycty": "ORELAND",
    "dropphyst": "PA",
    "dropphyzpp": 190759998,
    "dropmaladd": "1407 BRUCE RD",
    "dropmalcty": "ORELAND",
    "dropmalst": "PA",
    "dropmalzpp": 190759998,
    "dropsitphn": 2158849896,
    "dropsitlph": 2158841965,
    "dropsitcph": 2158849896,
    "dropfax": 2158845556
  },
  {
    "dcode": "D",
    "dropkey": "PX1A345",
    "droptype": "D",
    "dropname": "ORRSTOWN",
    "dropdeladd": "3630 ORRSTOWN RD",
    "dropdelcty": "ORRSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 172449998,
    "dropphyadd": "3630 ORRSTOWN RD",
    "dropphycty": "ORRSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 172449998,
    "dropmaladd": "3630 ORRSTOWN RD",
    "dropmalcty": "ORRSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 172449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175328936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A347",
    "droptype": "D",
    "dropname": "ORSON",
    "dropdeladd": "3473 BELMONT TPKE",
    "dropdelcty": "ORSON",
    "dropdelst": "PA",
    "dropdelzpp": 184499800,
    "dropphyadd": "3473 BELMONT TPKE",
    "dropphycty": "ORSON",
    "dropphyst": "PA",
    "dropphyzpp": 184499800,
    "dropmaladd": "3473 BELMONT TPKE",
    "dropmalcty": "ORSON",
    "dropmalst": "PA",
    "dropmalzpp": 184499800,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707273730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A350",
    "droptype": "D",
    "dropname": "ORWIGSBURG",
    "dropdeladd": "700 W MARKET ST",
    "dropdelcty": "ORWIGSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 179619998,
    "dropphyadd": "700 W MARKET ST",
    "dropphycty": "ORWIGSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 179619998,
    "dropmaladd": "700 W MARKET ST",
    "dropmalcty": "ORWIGSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 179619998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703660633,
    "dropsitcph": 5703660633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A352",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "7570 ROUTE 49",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "PA",
    "dropdelzpp": 169429998,
    "dropphyadd": "7570 ROUTE 49",
    "dropphycty": "OSCEOLA",
    "dropphyst": "PA",
    "dropphyzpp": 169429998,
    "dropmaladd": "7570 ROUTE 49",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "PA",
    "dropmalzpp": 169429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 8142585103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A353",
    "droptype": "D",
    "dropname": "OSCEOLA MILLS",
    "dropdeladd": "602 LINGLE ST",
    "dropdelcty": "OSCEOLA MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 166669998,
    "dropphyadd": "602 LINGLE ST",
    "dropphycty": "OSCEOLA MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 166669998,
    "dropmaladd": "602 LINGLE ST",
    "dropmalcty": "OSCEOLA MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 166669998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143396701,
    "dropsitcph": 8143396701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A354",
    "droptype": "D",
    "dropname": "OSTERBURG",
    "dropdeladd": "166 HERITAGE RD",
    "dropdelcty": "OSTERBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166679998,
    "dropphyadd": "166 HERITAGE RD",
    "dropphycty": "OSTERBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166679998,
    "dropmaladd": "166 HERITAGE RD",
    "dropmalcty": "OSTERBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166679998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142763912,
    "dropsitcph": 8142763912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A357",
    "droptype": "D",
    "dropname": "OTTSVILLE",
    "dropdeladd": "7790 EASTON RD",
    "dropdelcty": "OTTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189429998,
    "dropphyadd": "7790 EASTON RD",
    "dropphycty": "OTTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189429998,
    "dropmaladd": "7790 EASTON RD",
    "dropmalcty": "OTTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189429998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108475343,
    "dropsitcph": 6108475343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A364",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "215 E LOCUST ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "PA",
    "dropdelzpp": 193639998,
    "dropphyadd": "215 E LOCUST ST",
    "dropphycty": "OXFORD",
    "dropphyst": "PA",
    "dropphyzpp": 193639998,
    "dropmaladd": "215 E LOCUST ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "PA",
    "dropmalzpp": 193639998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109989013,
    "dropsitcph": 6109989013,
    "dropfax": 6109320643
  },
  {
    "dcode": "D",
    "dropkey": "PX1A369",
    "droptype": "D",
    "dropname": "PALM",
    "dropdeladd": "801 GRAVEL PIKE",
    "dropdelcty": "PALM",
    "dropdelst": "PA",
    "dropdelzpp": 180709998,
    "dropphyadd": "801 GRAVEL PIKE",
    "dropphycty": "PALM",
    "dropphyst": "PA",
    "dropphyzpp": 180709998,
    "dropmaladd": "801 GRAVEL PIKE",
    "dropmalcty": "PALM",
    "dropmalst": "PA",
    "dropmalzpp": 180709998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2156799486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A374",
    "droptype": "D",
    "dropname": "PALMERTON",
    "dropdeladd": "128 DELAWARE AVE FRNT",
    "dropdelcty": "PALMERTON",
    "dropdelst": "PA",
    "dropdelzpp": 180719998,
    "dropphyadd": "128 DELAWARE AVE FRNT",
    "dropphycty": "PALMERTON",
    "dropphyst": "PA",
    "dropphyzpp": 180719998,
    "dropmaladd": "128 DELAWARE AVE FRNT",
    "dropmalcty": "PALMERTON",
    "dropmalst": "PA",
    "dropmalzpp": 180719998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108262286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A375",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "60 S RAILROAD ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "PA",
    "dropdelzpp": 170789998,
    "dropphyadd": "60 S RAILROAD ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "PA",
    "dropphyzpp": 170789998,
    "dropmaladd": "60 S RAILROAD ST",
    "dropmalcty": "PALMYRA",
    "dropmalst": "PA",
    "dropmalzpp": 170789998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178382651,
    "dropfax": 7178382483
  },
  {
    "dcode": "D",
    "dropkey": "PX1A377",
    "droptype": "D",
    "dropname": "PAOLI",
    "dropdeladd": "43 PAOLI PLZ",
    "dropdelcty": "PAOLI",
    "dropdelst": "PA",
    "dropdelzpp": 193019997,
    "dropphyadd": "43 PAOLI PLZ",
    "dropphycty": "PAOLI",
    "dropphyst": "PA",
    "dropphyzpp": 193019997,
    "dropmaladd": "43 PAOLI PLZ",
    "dropmalcty": "PAOLI",
    "dropmalst": "PA",
    "dropmalzpp": 193019997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102960648,
    "dropsitcph": 6102960648,
    "dropfax": 6106440850
  },
  {
    "dcode": "D",
    "dropkey": "PX1A378",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "1 LEACOCK RD",
    "dropdelcty": "PARADISE",
    "dropdelst": "PA",
    "dropdelzpp": 175629998,
    "dropphyadd": "1 LEACOCK RD",
    "dropphycty": "PARADISE",
    "dropphyst": "PA",
    "dropphyzpp": 175629998,
    "dropmaladd": "1 LEACOCK RD",
    "dropmalcty": "PARADISE",
    "dropmalst": "PA",
    "dropmalzpp": 175629998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176869300,
    "dropsitcph": 7176869300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A391",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "208 WASHINGTON ST",
    "dropdelcty": "PARKER",
    "dropdelst": "PA",
    "dropdelzpp": 160499800,
    "dropphyadd": "208 WASHINGTON ST",
    "dropphycty": "PARKER",
    "dropphyst": "PA",
    "dropphyzpp": 160499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKER",
    "dropmalst": "PA",
    "dropmalzpp": 160499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243992449,
    "dropsitcph": 7243992449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A392",
    "droptype": "D",
    "dropname": "PARKER FORD",
    "dropdeladd": "1355 OLD SCHUYLKILL RD",
    "dropdelcty": "PARKER FORD",
    "dropdelst": "PA",
    "dropdelzpp": 194579905,
    "dropphyadd": "1355 OLD SCHUYLKILL RD",
    "dropphycty": "PARKER FORD",
    "dropphyst": "PA",
    "dropphyzpp": 194579905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKER FORD",
    "dropmalst": "PA",
    "dropmalzpp": 194579998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104957958,
    "dropsitcph": 6104957958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A394",
    "droptype": "D",
    "dropname": "PARKESBURG",
    "dropdeladd": "167 BRANDT ST",
    "dropdelcty": "PARKESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 193659998,
    "dropphyadd": "167 BRANDT ST",
    "dropphycty": "PARKESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 193659998,
    "dropmaladd": "167 BRANDT ST",
    "dropmalcty": "PARKESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 193659998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108572973,
    "dropsitcph": 6108572973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A404",
    "droptype": "D",
    "dropname": "PARRYVILLE",
    "dropdeladd": "177 MAIN ST",
    "dropdelcty": "PARRYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 182449998,
    "dropphyadd": "177 MAIN ST",
    "dropphycty": "PARRYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 182449998,
    "dropmaladd": "177 MAIN ST",
    "dropmalcty": "PARRYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 182449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 6108522891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A415",
    "droptype": "D",
    "dropname": "PATTON",
    "dropdeladd": "434 MAGEE AVE",
    "dropdelcty": "PATTON",
    "dropdelst": "PA",
    "dropdelzpp": 166689998,
    "dropphyadd": "434 MAGEE AVE",
    "dropphycty": "PATTON",
    "dropphyst": "PA",
    "dropphyzpp": 166689998,
    "dropmaladd": "434 MAGEE AVE",
    "dropmalcty": "PATTON",
    "dropmalst": "PA",
    "dropmalzpp": 166689998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146748010,
    "dropsitcph": 8146748010,
    "dropfax": 8146742291
  },
  {
    "dcode": "D",
    "dropkey": "PX1A416",
    "droptype": "D",
    "dropname": "PAUPACK",
    "dropdeladd": "480 ROUTE 507",
    "dropdelcty": "PAUPACK",
    "dropdelst": "PA",
    "dropdelzpp": 184519998,
    "dropphyadd": "480 ROUTE 507",
    "dropphycty": "PAUPACK",
    "dropphyst": "PA",
    "dropphyzpp": 184519998,
    "dropmaladd": "480 ROUTE 507",
    "dropmalcty": "PAUPACK",
    "dropmalst": "PA",
    "dropmalzpp": 184519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702269371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A417",
    "droptype": "D",
    "dropname": "PAXINOS",
    "dropdeladd": "5317 STATE ROUTE 61",
    "dropdelcty": "PAXINOS",
    "dropdelst": "PA",
    "dropdelzpp": 178609998,
    "dropphyadd": "5317 STATE ROUTE 61",
    "dropphycty": "PAXINOS",
    "dropphyst": "PA",
    "dropphyzpp": 178609998,
    "dropmaladd": "5317 STATE ROUTE 61",
    "dropmalcty": "PAXINOS",
    "dropmalst": "PA",
    "dropmalzpp": 178609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706440253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A421",
    "droptype": "D",
    "dropname": "PAXTONVILLE",
    "dropdeladd": "1072 PAXTON ST STE 10",
    "dropdelcty": "PAXTONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178619998,
    "dropphyadd": "1072 PAXTON ST STE 10",
    "dropphycty": "PAXTONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178619998,
    "dropmaladd": "1072 PAXTON ST STE 10",
    "dropmalcty": "PAXTONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178619998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5708370135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A423",
    "droptype": "D",
    "dropname": "PEACH BOTTOM",
    "dropdeladd": "1842A LANCASTER PIKE",
    "dropdelcty": "PEACH BOTTOM",
    "dropdelst": "PA",
    "dropdelzpp": 175639998,
    "dropphyadd": "1842A LANCASTER PIKE",
    "dropphycty": "PEACH BOTTOM",
    "dropphyst": "PA",
    "dropphyzpp": 175639998,
    "dropmaladd": "1842A LANCASTER PIKE",
    "dropmalcty": "PEACH BOTTOM",
    "dropmalst": "PA",
    "dropmalzpp": 175639998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175482646,
    "dropsitcph": 7175482646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A427",
    "droptype": "D",
    "dropname": "PECKVILLE",
    "dropdeladd": "323 KEYSTONE AVE",
    "dropdelcty": "PECKVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 184529998,
    "dropphyadd": "323 KEYSTONE AVE",
    "dropphycty": "PECKVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 184529998,
    "dropmaladd": "323 KEYSTONE AVE",
    "dropmalcty": "PECKVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 184529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704899931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A431",
    "droptype": "D",
    "dropname": "PEN ARGYL",
    "dropdeladd": "7 S ROBINSON AVE",
    "dropdelcty": "PEN ARGYL",
    "dropdelst": "PA",
    "dropdelzpp": 180729998,
    "dropphyadd": "7 S ROBINSON AVE",
    "dropphycty": "PEN ARGYL",
    "dropphyst": "PA",
    "dropphyzpp": 180729998,
    "dropmaladd": "7 S ROBINSON AVE",
    "dropmalcty": "PEN ARGYL",
    "dropmalst": "PA",
    "dropmalzpp": 180729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108636678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A434",
    "droptype": "D",
    "dropname": "PENFIELD",
    "dropdeladd": "12336 BENNETTS VALLEY HWY",
    "dropdelcty": "PENFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 158499800,
    "dropphyadd": "12336 BENNETTS VALLEY HWY",
    "dropphycty": "PENFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 158499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 158499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146375414,
    "dropsitcph": 8146375414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A441",
    "droptype": "D",
    "dropname": "PENN",
    "dropdeladd": "500 COAL ST",
    "dropdelcty": "PENN",
    "dropdelst": "PA",
    "dropdelzpp": 156759998,
    "dropphyadd": "500 COAL ST",
    "dropphycty": "PENN",
    "dropphyst": "PA",
    "dropphyzpp": 156759998,
    "dropmaladd": "500 COAL ST",
    "dropmalcty": "PENN",
    "dropmalst": "PA",
    "dropmalzpp": 156759998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245235388,
    "dropsitcph": 7245235388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A449",
    "droptype": "D",
    "dropname": "PENN RUN",
    "dropdeladd": "1417 N HARMONY RD",
    "dropdelcty": "PENN RUN",
    "dropdelst": "PA",
    "dropdelzpp": 157659998,
    "dropphyadd": "1417 N HARMONY RD",
    "dropphycty": "PENN RUN",
    "dropphyst": "PA",
    "dropphyzpp": 157659998,
    "dropmaladd": "1417 N HARMONY RD",
    "dropmalcty": "PENN RUN",
    "dropmalst": "PA",
    "dropmalzpp": 157659998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244633972,
    "dropsitcph": 7244633972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A459",
    "droptype": "D",
    "dropname": "PENNS CREEK",
    "dropdeladd": "106 RASPBERRY ST",
    "dropdelcty": "PENNS CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 178629998,
    "dropphyadd": "106 RASPBERRY ST",
    "dropphycty": "PENNS CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 178629998,
    "dropmaladd": "106 RASPBERRY ST",
    "dropmalcty": "PENNS CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 178629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5708373254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A460",
    "droptype": "D",
    "dropname": "PENNS PARK",
    "dropdeladd": "842 DURHAM RD",
    "dropdelcty": "PENNS PARK",
    "dropdelst": "PA",
    "dropdelzpp": 189439998,
    "dropphyadd": "842 DURHAM RD",
    "dropphycty": "PENNS PARK",
    "dropphyst": "PA",
    "dropphyzpp": 189439998,
    "dropmaladd": "842 DURHAM RD",
    "dropmalcty": "PENNS PARK",
    "dropmalst": "PA",
    "dropmalzpp": 189439998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155987537,
    "dropsitcph": 2155987537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A466",
    "droptype": "D",
    "dropname": "PENNSYLVANIA FURNACE",
    "dropdeladd": "6890 W WHITEHALL RD",
    "dropdelcty": "PENNSYLVANIA FURNACE",
    "dropdelst": "PA",
    "dropdelzpp": 168659998,
    "dropphyadd": "6890 W WHITEHALL RD",
    "dropphycty": "PENNSYLVANIA FURNACE",
    "dropphyst": "PA",
    "dropphyzpp": 168659998,
    "dropmaladd": "6890 W WHITEHALL RD",
    "dropmalcty": "PENNSYLVANIA FURNACE",
    "dropmalst": "PA",
    "dropmalzpp": 168659998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146928749,
    "dropsitcph": 8146928749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A468",
    "droptype": "D",
    "dropname": "PENRYN",
    "dropdeladd": "1275 NEWPORT RD",
    "dropdelcty": "PENRYN",
    "dropdelst": "PA",
    "dropdelzpp": 175649998,
    "dropphyadd": "1275 NEWPORT RD",
    "dropphycty": "PENRYN",
    "dropphyst": "PA",
    "dropphyzpp": 175649998,
    "dropmaladd": "1275 NEWPORT RD",
    "dropmalcty": "PENRYN",
    "dropmalst": "PA",
    "dropmalzpp": 175649998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176657200,
    "dropsitcph": 7176657200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A470",
    "droptype": "D",
    "dropname": "PEQUEA",
    "dropdeladd": "735 MARTICVILLE RD",
    "dropdelcty": "PEQUEA",
    "dropdelst": "PA",
    "dropdelzpp": 175659998,
    "dropphyadd": "735 MARTICVILLE RD",
    "dropphycty": "PEQUEA",
    "dropphyst": "PA",
    "dropphyzpp": 175659998,
    "dropmaladd": "735 MARTICVILLE RD",
    "dropmalcty": "PEQUEA",
    "dropmalst": "PA",
    "dropmalzpp": 175659998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172844401,
    "dropsitcph": 7172844401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A472",
    "droptype": "D",
    "dropname": "PERKASIE",
    "dropdeladd": "300 N 7TH ST",
    "dropdelcty": "PERKASIE",
    "dropdelst": "PA",
    "dropdelzpp": 189449998,
    "dropphyadd": "300 N 7TH ST",
    "dropphycty": "PERKASIE",
    "dropphyst": "PA",
    "dropphyzpp": 189449998,
    "dropmaladd": "300 N 7TH ST",
    "dropmalcty": "PERKASIE",
    "dropmalst": "PA",
    "dropmalzpp": 189449998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152570923,
    "dropsitcph": 2152570923,
    "dropfax": 2152585467
  },
  {
    "dcode": "D",
    "dropkey": "PX1A473",
    "droptype": "D",
    "dropname": "PERKIOMENVILLE",
    "dropdeladd": "1463 GRAVEL PIKE",
    "dropdelcty": "PERKIOMENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180749998,
    "dropphyadd": "1463 GRAVEL PIKE",
    "dropphycty": "PERKIOMENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180749998,
    "dropmaladd": "1463 GRAVEL PIKE",
    "dropmalcty": "PERKIOMENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180749998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2152348408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A481",
    "droptype": "D",
    "dropname": "PERRYOPOLIS",
    "dropdeladd": "221 REPUBLICAN ST",
    "dropdelcty": "PERRYOPOLIS",
    "dropdelst": "PA",
    "dropdelzpp": 154739998,
    "dropphyadd": "221 REPUBLICAN ST",
    "dropphycty": "PERRYOPOLIS",
    "dropphyst": "PA",
    "dropphyzpp": 154739998,
    "dropmaladd": "221 REPUBLICAN ST",
    "dropmalcty": "PERRYOPOLIS",
    "dropmalst": "PA",
    "dropmalzpp": 154739998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247364070,
    "dropsitcph": 7247364070,
    "dropfax": 7247360583
  },
  {
    "dcode": "D",
    "dropkey": "PX1A486",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "461 KING ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166699998,
    "dropphyadd": "461 KING ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166699998,
    "dropmaladd": "461 KING ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166699998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146694767,
    "dropsitcph": 8146694767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A487",
    "droptype": "D",
    "dropname": "PETROLIA",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "PETROLIA",
    "dropdelst": "PA",
    "dropdelzpp": 160509800,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "PETROLIA",
    "dropphyst": "PA",
    "dropphyzpp": 160509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETROLIA",
    "dropmalst": "PA",
    "dropmalzpp": 160509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247565470,
    "dropsitcph": 7247565470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A496",
    "droptype": "D",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "3000 CHESTNUT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049998,
    "dropphyadd": "3000 CHESTNUT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049998,
    "dropmaladd": "3000 CHESTNUT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049998,
    "dropsitphn": 2158958828,
    "dropsitlph": 2158958828,
    "dropsitcph": 2158958828,
    "dropfax": 2158958843
  },
  {
    "dcode": "D",
    "dropkey": "PX1A500",
    "droptype": "D",
    "dropname": "PHILIPSBURG",
    "dropdeladd": "222 E LAUREL ST",
    "dropdelcty": "PHILIPSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168669998,
    "dropphyadd": "222 E LAUREL ST",
    "dropphycty": "PHILIPSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168669998,
    "dropmaladd": "222 E LAUREL ST",
    "dropmalcty": "PHILIPSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168669998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143423201,
    "dropsitcph": 8143423201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A503",
    "droptype": "D",
    "dropname": "PHOENIXVILLE",
    "dropdeladd": "116 GAY ST",
    "dropdelcty": "PHOENIXVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194609998,
    "dropphyadd": "116 GAY ST",
    "dropphycty": "PHOENIXVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194609998,
    "dropmaladd": "116 GAY ST",
    "dropmalcty": "PHOENIXVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194609998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104151340,
    "dropsitcph": 6104151340,
    "dropfax": 6109330205
  },
  {
    "dcode": "D",
    "dropkey": "PX1A505",
    "droptype": "D",
    "dropname": "PICTURE ROCKS",
    "dropdeladd": "21 LAUREL RUN RD",
    "dropdelcty": "PICTURE ROCKS",
    "dropdelst": "PA",
    "dropdelzpp": 177629998,
    "dropphyadd": "21 LAUREL RUN RD",
    "dropphycty": "PICTURE ROCKS",
    "dropphyst": "PA",
    "dropphyzpp": 177629998,
    "dropmaladd": "21 LAUREL RUN RD",
    "dropmalcty": "PICTURE ROCKS",
    "dropmalst": "PA",
    "dropmalzpp": 177629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5704646034,
    "dropsitcph": 5704646034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A512",
    "droptype": "D",
    "dropname": "PILLOW",
    "dropdeladd": "182 MARKET ST",
    "dropdelcty": "PILLOW",
    "dropdelst": "PA",
    "dropdelzpp": 170809998,
    "dropphyadd": "182 MARKET ST",
    "dropphycty": "PILLOW",
    "dropphyst": "PA",
    "dropphyzpp": 170809998,
    "dropmaladd": "182 MARKET ST",
    "dropmalcty": "PILLOW",
    "dropmalst": "PA",
    "dropmalzpp": 170809998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707588624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A518",
    "droptype": "D",
    "dropname": "PINE FORGE",
    "dropdeladd": "213 PINE FORGE RD",
    "dropdelcty": "PINE FORGE",
    "dropdelst": "PA",
    "dropdelzpp": 195489998,
    "dropphyadd": "213 PINE FORGE RD",
    "dropphycty": "PINE FORGE",
    "dropphyst": "PA",
    "dropphyzpp": 195489998,
    "dropmaladd": "213 PINE FORGE RD",
    "dropmalcty": "PINE FORGE",
    "dropmalst": "PA",
    "dropmalzpp": 195489998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103268308,
    "dropsitcph": 6103268308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A520",
    "droptype": "D",
    "dropname": "PINE GROVE",
    "dropdeladd": "103 SNYDER AVE",
    "dropdelcty": "PINE GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 179639998,
    "dropphyadd": "103 SNYDER AVE",
    "dropphycty": "PINE GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 179639998,
    "dropmaladd": "103 SNYDER AVE",
    "dropmalcty": "PINE GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 179639998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703454955,
    "dropsitcph": 5703454955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A522",
    "droptype": "D",
    "dropname": "PINE GROVE MILLS",
    "dropdeladd": "112 E PINE GROVE RD",
    "dropdelcty": "PINE GROVE MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 168689998,
    "dropphyadd": "112 E PINE GROVE RD",
    "dropphycty": "PINE GROVE MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 168689998,
    "dropmaladd": "112 E PINE GROVE RD",
    "dropmalcty": "PINE GROVE MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 168689998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142348427,
    "dropsitcph": 8142348427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A531",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "1089 DURHAM RD",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189469998,
    "dropphyadd": "1089 DURHAM RD",
    "dropphycty": "PINEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189469998,
    "dropmaladd": "1089 DURHAM RD",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189469998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155987222,
    "dropsitcph": 2155987222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A533",
    "droptype": "D",
    "dropname": "PIPERSVILLE",
    "dropdeladd": "6907 EASTON RD FRNT",
    "dropdelcty": "PIPERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189479998,
    "dropphyadd": "6907 EASTON RD FRNT",
    "dropphycty": "PIPERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189479998,
    "dropmaladd": "6907 EASTON RD FRNT",
    "dropmalcty": "PIPERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189479998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157660900,
    "dropsitcph": 2157660900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A535",
    "droptype": "D",
    "dropname": "PITMAN",
    "dropdeladd": "175 MAIN RD",
    "dropdelcty": "PITMAN",
    "dropdelst": "PA",
    "dropdelzpp": 179649998,
    "dropphyadd": "175 MAIN RD",
    "dropphycty": "PITMAN",
    "dropphyst": "PA",
    "dropphyzpp": 179649998,
    "dropmaladd": "175 MAIN RD",
    "dropmalcty": "PITMAN",
    "dropmalst": "PA",
    "dropmalzpp": 179649998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706483397,
    "dropsitcph": 5706483397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A543",
    "droptype": "D",
    "dropname": "PITTSBURGH",
    "dropdeladd": "1001 CALIFORNIA AVE RM 1002",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152909998,
    "dropphyadd": "1001 CALIFORNIA AVE RM 1002",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152909998,
    "dropmaladd": "1001 CALIFORNIA AVE RM 1002",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152909998,
    "dropsitphn": 4123597960,
    "dropsitlph": 4123597700,
    "dropsitcph": 4123597084,
    "dropfax": 4123591432
  },
  {
    "dcode": "D",
    "dropkey": "PX1A544",
    "droptype": "D",
    "dropname": "PITTSFIELD",
    "dropdeladd": "128 DALRYMPLE ST",
    "dropdelcty": "PITTSFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 163409800,
    "dropphyadd": "128 DALRYMPLE ST",
    "dropphycty": "PITTSFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 163409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PITTSFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 163409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145639435,
    "dropsitcph": 8145639435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A545",
    "droptype": "D",
    "dropname": "PITTSTON",
    "dropdeladd": "11 DOCK ST",
    "dropdelcty": "PITTSTON",
    "dropdelst": "PA",
    "dropdelzpp": 186409998,
    "dropphyadd": "11 DOCK ST",
    "dropphycty": "PITTSTON",
    "dropphyst": "PA",
    "dropphyzpp": 186409998,
    "dropmaladd": "11 DOCK ST",
    "dropmalcty": "PITTSTON",
    "dropmalst": "PA",
    "dropmalzpp": 186409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706543313,
    "dropfax": 5706548372
  },
  {
    "dcode": "D",
    "dropkey": "PX1A550",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "55 W MAIN ST",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 170819998,
    "dropphyadd": "55 W MAIN ST",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 170819998,
    "dropmaladd": "55 W MAIN ST",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 170819998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172496438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A560",
    "droptype": "D",
    "dropname": "PLEASANT HALL",
    "dropdeladd": "6535 UPPER STRASBURG RD",
    "dropdelcty": "PLEASANT HALL",
    "dropdelst": "PA",
    "dropdelzpp": 172469998,
    "dropphyadd": "6535 UPPER STRASBURG RD",
    "dropphycty": "PLEASANT HALL",
    "dropphyst": "PA",
    "dropphyzpp": 172469998,
    "dropmaladd": "6535 UPPER STRASBURG RD",
    "dropmalcty": "PLEASANT HALL",
    "dropmalst": "PA",
    "dropmalzpp": 172469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175325121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A567",
    "droptype": "D",
    "dropname": "PLEASANT UNITY",
    "dropdeladd": "2061 ROUTE 130",
    "dropdelcty": "PLEASANT UNITY",
    "dropdelst": "PA",
    "dropdelzpp": 156761001,
    "dropphyadd": "2061 ROUTE 130",
    "dropphycty": "PLEASANT UNITY",
    "dropphyst": "PA",
    "dropphyzpp": 156761001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT UNITY",
    "dropmalst": "PA",
    "dropmalzpp": 156769998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245728630,
    "dropsitcph": 7245728630,
    "dropfax": 7245728730
  },
  {
    "dcode": "D",
    "dropkey": "PX1A574",
    "droptype": "D",
    "dropname": "PLEASANTVILLE",
    "dropdeladd": "125 S MAIN ST",
    "dropdelcty": "PLEASANTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163419800,
    "dropphyadd": "125 S MAIN ST",
    "dropphycty": "PLEASANTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145897231,
    "dropsitcph": 8145897231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A578",
    "droptype": "D",
    "dropname": "PLUMSTEADVILLE",
    "dropdeladd": "5774 EASTON RD",
    "dropdelcty": "PLUMSTEADVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189499998,
    "dropphyadd": "5774 EASTON RD",
    "dropphycty": "PLUMSTEADVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189499998,
    "dropmaladd": "5774 EASTON RD",
    "dropmalcty": "PLUMSTEADVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189499998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157667690,
    "dropsitcph": 2157667690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A579",
    "droptype": "D",
    "dropname": "PLUMVILLE",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "PLUMVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162469800,
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "PLUMVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLUMVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243972850,
    "dropsitcph": 7243972850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A582",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "150 W MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "PA",
    "dropdelzpp": 186519998,
    "dropphyadd": "150 W MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "PA",
    "dropphyzpp": 186519998,
    "dropmaladd": "150 W MAIN ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "PA",
    "dropmalzpp": 186519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707799082,
    "dropfax": 5707795518
  },
  {
    "dcode": "D",
    "dropkey": "PX1A583",
    "droptype": "D",
    "dropname": "PLYMOUTH MEETING",
    "dropdeladd": "26 E GERMANTOWN PIKE",
    "dropdelcty": "PLYMOUTH MEETING",
    "dropdelst": "PA",
    "dropdelzpp": 194629998,
    "dropphyadd": "26 E GERMANTOWN PIKE",
    "dropphycty": "PLYMOUTH MEETING",
    "dropphyst": "PA",
    "dropphyzpp": 194629998,
    "dropmaladd": "26 E GERMANTOWN PIKE",
    "dropmalcty": "PLYMOUTH MEETING",
    "dropmalst": "PA",
    "dropmalzpp": 194629998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108347619,
    "dropsitcph": 6108347619,
    "dropfax": 6108285270
  },
  {
    "dcode": "D",
    "dropkey": "PX1A586",
    "droptype": "D",
    "dropname": "POCONO LAKE",
    "dropdeladd": "1 ROUTE 940",
    "dropdelcty": "POCONO LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 183479998,
    "dropphyadd": "1 ROUTE 940",
    "dropphycty": "POCONO LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 183479998,
    "dropmaladd": "1 ROUTE 940",
    "dropmalcty": "POCONO LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 183479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706463929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A590",
    "droptype": "D",
    "dropname": "POCONO MANOR",
    "dropdeladd": "1 MANOR DR",
    "dropdelcty": "POCONO MANOR",
    "dropdelst": "PA",
    "dropdelzpp": 183499998,
    "dropphyadd": "1 MANOR DR",
    "dropphycty": "POCONO MANOR",
    "dropphyst": "PA",
    "dropphyzpp": 183499998,
    "dropmaladd": "1 MANOR DR",
    "dropmalcty": "POCONO MANOR",
    "dropmalst": "PA",
    "dropmalzpp": 183499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708399100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A592",
    "droptype": "D",
    "dropname": "POCONO PINES",
    "dropdeladd": "1712 ROUTE 940 STE 102",
    "dropdelcty": "POCONO PINES",
    "dropdelst": "PA",
    "dropdelzpp": 183509989,
    "dropphyadd": "1712 ROUTE 940 STE 102",
    "dropphycty": "POCONO PINES",
    "dropphyst": "PA",
    "dropphyzpp": 183509989,
    "dropmaladd": "1712 ROUTE 940 STE 102",
    "dropmalcty": "POCONO PINES",
    "dropmalst": "PA",
    "dropmalzpp": 183509989,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706463181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A594",
    "droptype": "D",
    "dropname": "POCONO SUMMIT",
    "dropdeladd": "2657 ROUTE 940",
    "dropdelcty": "POCONO SUMMIT",
    "dropdelst": "PA",
    "dropdelzpp": 183469998,
    "dropphyadd": "2657 ROUTE 940",
    "dropphycty": "POCONO SUMMIT",
    "dropphyst": "PA",
    "dropphyzpp": 183469998,
    "dropmaladd": "2657 ROUTE 940",
    "dropmalcty": "POCONO SUMMIT",
    "dropmalst": "PA",
    "dropmalzpp": 183469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708398392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A595",
    "droptype": "D",
    "dropname": "POCOPSON",
    "dropdeladd": "1110 POCOPSON RD",
    "dropdelcty": "POCOPSON",
    "dropdelst": "PA",
    "dropdelzpp": 193669998,
    "dropphyadd": "1110 POCOPSON RD",
    "dropphycty": "POCOPSON",
    "dropphyst": "PA",
    "dropphyzpp": 193669998,
    "dropmaladd": "1110 POCOPSON RD",
    "dropmalcty": "POCOPSON",
    "dropmalst": "PA",
    "dropmalzpp": 193669998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107931493,
    "dropsitcph": 6107931493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A601",
    "droptype": "D",
    "dropname": "POINT MARION",
    "dropdeladd": "100 PENN ST",
    "dropdelcty": "POINT MARION",
    "dropdelst": "PA",
    "dropdelzpp": 154749998,
    "dropphyadd": "100 PENN ST",
    "dropphycty": "POINT MARION",
    "dropphyst": "PA",
    "dropphyzpp": 154749998,
    "dropmaladd": "100 PENN ST",
    "dropmalcty": "POINT MARION",
    "dropmalst": "PA",
    "dropmalzpp": 154749998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247259541,
    "dropsitcph": 7247259541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A602",
    "droptype": "D",
    "dropname": "POINT PLEASANT",
    "dropdeladd": "4977 RIVER RD",
    "dropdelcty": "POINT PLEASANT",
    "dropdelst": "PA",
    "dropdelzpp": 189509998,
    "dropphyadd": "4977 RIVER RD",
    "dropphycty": "POINT PLEASANT",
    "dropphyst": "PA",
    "dropphyzpp": 189509998,
    "dropmaladd": "4977 RIVER RD",
    "dropmalcty": "POINT PLEASANT",
    "dropmalst": "PA",
    "dropmalzpp": 189509998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152975551,
    "dropsitcph": 2152975551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A603",
    "droptype": "D",
    "dropname": "POLK",
    "dropdeladd": "710 MAIN ST",
    "dropdelcty": "POLK",
    "dropdelst": "PA",
    "dropdelzpp": 163429800,
    "dropphyadd": "710 MAIN ST",
    "dropphycty": "POLK",
    "dropphyst": "PA",
    "dropphyzpp": 163429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLK",
    "dropmalst": "PA",
    "dropmalzpp": 163429998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144323278,
    "dropsitcph": 8144323278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A605",
    "droptype": "D",
    "dropname": "POMEROY",
    "dropdeladd": "30-2 CHESTNUT ST",
    "dropdelcty": "POMEROY",
    "dropdelst": "PA",
    "dropdelzpp": 193679901,
    "dropphyadd": "30-2 CHESTNUT ST",
    "dropphycty": "POMEROY",
    "dropphyst": "PA",
    "dropphyzpp": 193679901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POMEROY",
    "dropmalst": "PA",
    "dropmalzpp": 193679998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108575255,
    "dropsitcph": 6108575255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A609",
    "droptype": "D",
    "dropname": "PORT ALLEGANY",
    "dropdeladd": "64 W MILL ST",
    "dropdelcty": "PORT ALLEGANY",
    "dropdelst": "PA",
    "dropdelzpp": 167431381,
    "dropphyadd": "64 W MILL ST",
    "dropphycty": "PORT ALLEGANY",
    "dropphyst": "PA",
    "dropphyzpp": 167431381,
    "dropmaladd": "64 W MILL ST",
    "dropmalcty": "PORT ALLEGANY",
    "dropmalst": "PA",
    "dropmalzpp": 167431381,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146422813,
    "dropsitcph": 8146422813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A611",
    "droptype": "D",
    "dropname": "PORT CARBON",
    "dropdeladd": "73 WASHINGTON ST",
    "dropdelcty": "PORT CARBON",
    "dropdelst": "PA",
    "dropdelzpp": 179659998,
    "dropphyadd": "73 WASHINGTON ST",
    "dropphycty": "PORT CARBON",
    "dropphyst": "PA",
    "dropphyzpp": 179659998,
    "dropmaladd": "73 WASHINGTON ST",
    "dropmalcty": "PORT CARBON",
    "dropmalst": "PA",
    "dropmalzpp": 179659998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706224217,
    "dropsitcph": 5706224217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A612",
    "droptype": "D",
    "dropname": "PORT CLINTON",
    "dropdeladd": "6 BROAD ST",
    "dropdelcty": "PORT CLINTON",
    "dropdelst": "PA",
    "dropdelzpp": 195499998,
    "dropphyadd": "6 BROAD ST",
    "dropphycty": "PORT CLINTON",
    "dropphyst": "PA",
    "dropphyzpp": 195499998,
    "dropmaladd": "6 BROAD ST",
    "dropmalcty": "PORT CLINTON",
    "dropmalst": "PA",
    "dropmalzpp": 195499998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217055,
    "dropsitcph": 6105623787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A614",
    "droptype": "D",
    "dropname": "PORT MATILDA",
    "dropdeladd": "109 N HIGH ST",
    "dropdelcty": "PORT MATILDA",
    "dropdelst": "PA",
    "dropdelzpp": 168709998,
    "dropphyadd": "109 N HIGH ST",
    "dropphycty": "PORT MATILDA",
    "dropphyst": "PA",
    "dropphyzpp": 168709998,
    "dropmaladd": "109 N HIGH ST",
    "dropmalcty": "PORT MATILDA",
    "dropmalst": "PA",
    "dropmalzpp": 168709998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146928100,
    "dropsitcph": 8146928100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A615",
    "droptype": "D",
    "dropname": "PORT ROYAL",
    "dropdeladd": "220 W 3RD ST",
    "dropdelcty": "PORT ROYAL",
    "dropdelst": "PA",
    "dropdelzpp": 170829998,
    "dropphyadd": "220 W 3RD ST",
    "dropphycty": "PORT ROYAL",
    "dropphyst": "PA",
    "dropphyzpp": 170829998,
    "dropmaladd": "220 W 3RD ST",
    "dropmalcty": "PORT ROYAL",
    "dropmalst": "PA",
    "dropmalzpp": 170829998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175272313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A616",
    "droptype": "D",
    "dropname": "PORT TREVORTON",
    "dropdeladd": "3934 S SUSQUEHANNA TRL STE 10",
    "dropdelcty": "PORT TREVORTON",
    "dropdelst": "PA",
    "dropdelzpp": 178649998,
    "dropphyadd": "3934 S SUSQUEHANNA TRL STE 10",
    "dropphycty": "PORT TREVORTON",
    "dropphyst": "PA",
    "dropphyzpp": 178649998,
    "dropmaladd": "3934 S SUSQUEHANNA TRL STE 10",
    "dropmalcty": "PORT TREVORTON",
    "dropmalst": "PA",
    "dropmalzpp": 178649998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703741084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A618",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "600 MAIN ST",
    "dropdelcty": "PORTAGE",
    "dropdelst": "PA",
    "dropdelzpp": 159469998,
    "dropphyadd": "600 MAIN ST",
    "dropphycty": "PORTAGE",
    "dropphyst": "PA",
    "dropphyzpp": 159469998,
    "dropmaladd": "600 MAIN ST",
    "dropmalcty": "PORTAGE",
    "dropmalst": "PA",
    "dropmalzpp": 159469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147364040,
    "dropsitcph": 8147364040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A623",
    "droptype": "D",
    "dropname": "PORTERSVILLE",
    "dropdeladd": "1272 PERRY HWY",
    "dropdelcty": "PORTERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 160519800,
    "dropphyadd": "1272 PERRY HWY",
    "dropphycty": "PORTERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 160519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 160519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243688011,
    "dropsitcph": 7243688011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A624",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "403 DELAWARE AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "PA",
    "dropdelzpp": 183519998,
    "dropphyadd": "403 DELAWARE AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "PA",
    "dropphyzpp": 183519998,
    "dropmaladd": "403 DELAWARE AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "PA",
    "dropmalzpp": 183519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708976370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A629",
    "droptype": "D",
    "dropname": "POTTS GROVE",
    "dropdeladd": "4365 STATE ROUTE 642",
    "dropdelcty": "POTTS GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 178659998,
    "dropphyadd": "4365 STATE ROUTE 642",
    "dropphycty": "POTTS GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 178659998,
    "dropmaladd": "4365 STATE ROUTE 642",
    "dropmalcty": "POTTS GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 178659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707428244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A630",
    "droptype": "D",
    "dropname": "POTTSTOWN",
    "dropdeladd": "770 E HIGH ST",
    "dropdelcty": "POTTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194649998,
    "dropphyadd": "770 E HIGH ST",
    "dropphycty": "POTTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194649998,
    "dropmaladd": "770 E HIGH ST",
    "dropmalcty": "POTTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194649998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107189086,
    "dropsitcph": 6107189086,
    "dropfax": 6107050101
  },
  {
    "dcode": "D",
    "dropkey": "PX1A631",
    "droptype": "D",
    "dropname": "POTTSVILLE",
    "dropdeladd": "450 N CENTRE ST",
    "dropdelcty": "POTTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 179019998,
    "dropphyadd": "450 N CENTRE ST",
    "dropphycty": "POTTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 179019998,
    "dropmaladd": "450 N CENTRE ST",
    "dropmalcty": "POTTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 179019998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706226744,
    "dropsitcph": 5706226744,
    "dropfax": 5706223952
  },
  {
    "dcode": "D",
    "dropkey": "PX1A636",
    "droptype": "D",
    "dropname": "POYNTELLE",
    "dropdeladd": "718 CROSSTOWN HWY",
    "dropdelcty": "POYNTELLE",
    "dropdelst": "PA",
    "dropdelzpp": 184549998,
    "dropphyadd": "718 CROSSTOWN HWY",
    "dropphycty": "POYNTELLE",
    "dropphyst": "PA",
    "dropphyzpp": 184549998,
    "dropmaladd": "718 CROSSTOWN HWY",
    "dropmalcty": "POYNTELLE",
    "dropmalst": "PA",
    "dropmalzpp": 184549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704482379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A638",
    "droptype": "D",
    "dropname": "PRESTO",
    "dropdeladd": "5234 THOMS RUN RD",
    "dropdelcty": "PRESTO",
    "dropdelst": "PA",
    "dropdelzpp": 151429998,
    "dropphyadd": "5234 THOMS RUN RD",
    "dropphycty": "PRESTO",
    "dropphyst": "PA",
    "dropphyzpp": 151429998,
    "dropmaladd": "5234 THOMS RUN RD",
    "dropmalcty": "PRESTO",
    "dropmalst": "PA",
    "dropmalzpp": 151429998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122216676,
    "dropsitcph": 4122216676,
    "dropfax": 4122214718
  },
  {
    "dcode": "D",
    "dropkey": "PX1A643",
    "droptype": "D",
    "dropname": "PRICEDALE",
    "dropdeladd": "133 MAIN ST",
    "dropdelcty": "PRICEDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150721001,
    "dropphyadd": "133 MAIN ST",
    "dropphycty": "PRICEDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150721001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRICEDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150729998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249293539,
    "dropsitcph": 7249293539,
    "dropfax": 7249290312
  },
  {
    "dcode": "D",
    "dropkey": "PX1A652",
    "droptype": "D",
    "dropname": "PROMPTON",
    "dropdeladd": "88 RIVER RD",
    "dropdelcty": "PROMPTON",
    "dropdelst": "PA",
    "dropdelzpp": 184569998,
    "dropphyadd": "88 RIVER RD",
    "dropphycty": "PROMPTON",
    "dropphyst": "PA",
    "dropphyzpp": 184569998,
    "dropmaladd": "88 RIVER RD",
    "dropmalcty": "PROMPTON",
    "dropmalst": "PA",
    "dropmalzpp": 184569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702532598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A653",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "106 S FRANKLIN ST",
    "dropdelcty": "PROSPECT",
    "dropdelst": "PA",
    "dropdelzpp": 160529800,
    "dropphyadd": "106 S FRANKLIN ST",
    "dropphycty": "PROSPECT",
    "dropphyst": "PA",
    "dropphyzpp": 160529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROSPECT",
    "dropmalst": "PA",
    "dropmalzpp": 160529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248652000,
    "dropsitcph": 7248652000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A654",
    "droptype": "D",
    "dropname": "PROSPECT PARK",
    "dropdeladd": "811 11TH AVE",
    "dropdelcty": "PROSPECT PARK",
    "dropdelst": "PA",
    "dropdelzpp": 190769998,
    "dropphyadd": "811 11TH AVE",
    "dropphycty": "PROSPECT PARK",
    "dropphyst": "PA",
    "dropphyzpp": 190769998,
    "dropmaladd": "811 11TH AVE",
    "dropmalcty": "PROSPECT PARK",
    "dropmalst": "PA",
    "dropmalzpp": 190769998,
    "dropsitphn": 6104612862,
    "dropsitlph": 6105324441,
    "dropsitcph": 6104612862,
    "dropfax": 6105326258
  },
  {
    "dcode": "D",
    "dropkey": "PX1A657",
    "droptype": "D",
    "dropname": "PROSPERITY",
    "dropdeladd": "4559 PROSPERITY PIKE",
    "dropdelcty": "PROSPERITY",
    "dropdelst": "PA",
    "dropdelzpp": 153291001,
    "dropphyadd": "4559 PROSPERITY PIKE",
    "dropphycty": "PROSPERITY",
    "dropphyst": "PA",
    "dropphyzpp": 153291001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROSPERITY",
    "dropmalst": "PA",
    "dropmalzpp": 153299998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242282842,
    "dropsitcph": 7242282842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A666",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "1930 STATE ROUTE 208",
    "dropdelcty": "PULASKI",
    "dropdelst": "PA",
    "dropdelzpp": 161439800,
    "dropphyadd": "1930 STATE ROUTE 208",
    "dropphycty": "PULASKI",
    "dropphyst": "PA",
    "dropphyzpp": 161439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULASKI",
    "dropmalst": "PA",
    "dropmalzpp": 161439998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246527620,
    "dropsitcph": 7246527620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A667",
    "droptype": "D",
    "dropname": "PUNXSUTAWNEY",
    "dropdeladd": "553 E MAHONING ST",
    "dropdelcty": "PUNXSUTAWNEY",
    "dropdelst": "PA",
    "dropdelzpp": 157679998,
    "dropphyadd": "553 E MAHONING ST",
    "dropphycty": "PUNXSUTAWNEY",
    "dropphyst": "PA",
    "dropphyzpp": 157679998,
    "dropmaladd": "553 E MAHONING ST",
    "dropmalcty": "PUNXSUTAWNEY",
    "dropmalst": "PA",
    "dropmalzpp": 157679998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149386120,
    "dropsitcph": 8149386120,
    "dropfax": 8149382138
  },
  {
    "dcode": "D",
    "dropkey": "PX1A669",
    "droptype": "D",
    "dropname": "QUAKAKE",
    "dropdeladd": "32 HECKMAN ST STE 1",
    "dropdelcty": "QUAKAKE",
    "dropdelst": "PA",
    "dropdelzpp": 182459998,
    "dropphyadd": "32 HECKMAN ST STE 1",
    "dropphycty": "QUAKAKE",
    "dropphyst": "PA",
    "dropphyzpp": 182459998,
    "dropmaladd": "32 HECKMAN ST STE 1",
    "dropmalcty": "QUAKAKE",
    "dropmalst": "PA",
    "dropmalzpp": 182459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704672940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A670",
    "droptype": "D",
    "dropname": "QUAKERTOWN",
    "dropdeladd": "165 CALIFORNIA RD",
    "dropdelcty": "QUAKERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189519998,
    "dropphyadd": "165 CALIFORNIA RD",
    "dropphycty": "QUAKERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189519998,
    "dropmaladd": "165 CALIFORNIA RD",
    "dropmalcty": "QUAKERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189519998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155366817,
    "dropsitcph": 2155366817,
    "dropfax": 2155364164
  },
  {
    "dcode": "D",
    "dropkey": "PX1A671",
    "droptype": "D",
    "dropname": "QUARRYVILLE",
    "dropdeladd": "220 W STATE ST",
    "dropdelcty": "QUARRYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175669998,
    "dropphyadd": "220 W STATE ST",
    "dropphycty": "QUARRYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175669998,
    "dropmaladd": "220 W STATE ST",
    "dropmalcty": "QUARRYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175669998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177862420,
    "dropsitcph": 7177862420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A679",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "6617 ORPHANAGE RD",
    "dropdelcty": "QUINCY",
    "dropdelst": "PA",
    "dropdelzpp": 172479998,
    "dropphyadd": "6617 ORPHANAGE RD",
    "dropphycty": "QUINCY",
    "dropphyst": "PA",
    "dropphyzpp": 172479998,
    "dropmaladd": "6617 ORPHANAGE RD",
    "dropmalcty": "QUINCY",
    "dropmalst": "PA",
    "dropmalzpp": 172479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177495818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A685",
    "droptype": "D",
    "dropname": "RAILROAD",
    "dropdeladd": "14 E MAIN ST OFC",
    "dropdelcty": "RAILROAD",
    "dropdelst": "PA",
    "dropdelzpp": 173559998,
    "dropphyadd": "14 E MAIN ST OFC",
    "dropphycty": "RAILROAD",
    "dropphyst": "PA",
    "dropphyzpp": 173559998,
    "dropmaladd": "14 E MAIN ST OFC",
    "dropmalcty": "RAILROAD",
    "dropmalst": "PA",
    "dropmalzpp": 173559998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172354421,
    "dropsitcph": 7172354421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A687",
    "droptype": "D",
    "dropname": "RALSTON",
    "dropdeladd": "10975 ROUTE 14",
    "dropdelcty": "RALSTON",
    "dropdelst": "PA",
    "dropdelzpp": 177639998,
    "dropphyadd": "10975 ROUTE 14",
    "dropphycty": "RALSTON",
    "dropphyst": "PA",
    "dropphyzpp": 177639998,
    "dropmaladd": "10975 ROUTE 14",
    "dropmalcty": "RALSTON",
    "dropmalst": "PA",
    "dropmalzpp": 177639998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5709959360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A688",
    "droptype": "D",
    "dropname": "RAMEY",
    "dropdeladd": "351 MAIN ST",
    "dropdelcty": "RAMEY",
    "dropdelst": "PA",
    "dropdelzpp": 166719998,
    "dropphyadd": "351 MAIN ST",
    "dropphycty": "RAMEY",
    "dropphyst": "PA",
    "dropphyzpp": 166719998,
    "dropmaladd": "351 MAIN ST",
    "dropmalcty": "RAMEY",
    "dropmalst": "PA",
    "dropmalzpp": 166719998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143786093,
    "dropsitcph": 8143786093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A693",
    "droptype": "D",
    "dropname": "RANSOM",
    "dropdeladd": "3063 MAIN ST",
    "dropdelcty": "RANSOM",
    "dropdelst": "PA",
    "dropdelzpp": 186539998,
    "dropphyadd": "3063 MAIN ST",
    "dropphycty": "RANSOM",
    "dropphyst": "PA",
    "dropphyzpp": 186539998,
    "dropmaladd": "3063 MAIN ST",
    "dropmalcty": "RANSOM",
    "dropmalst": "PA",
    "dropmalzpp": 186539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703882109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A699",
    "droptype": "D",
    "dropname": "RAVINE",
    "dropdeladd": "220 TREMONT RD",
    "dropdelcty": "RAVINE",
    "dropdelst": "PA",
    "dropdelzpp": 179669800,
    "dropphyadd": "220 TREMONT RD",
    "dropphycty": "RAVINE",
    "dropphyst": "PA",
    "dropphyzpp": 179669800,
    "dropmaladd": "220 TREMONT RD",
    "dropmalcty": "RAVINE",
    "dropmalst": "PA",
    "dropmalzpp": 179669800,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703458987,
    "dropsitcph": 5703458987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A705",
    "droptype": "D",
    "dropname": "REAMSTOWN",
    "dropdeladd": "14 N REAMSTOWN RD",
    "dropdelcty": "REAMSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 175679998,
    "dropphyadd": "14 N REAMSTOWN RD",
    "dropphycty": "REAMSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 175679998,
    "dropmaladd": "14 N REAMSTOWN RD",
    "dropmalcty": "REAMSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 175679998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173366101,
    "dropsitcph": 7173366101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A706",
    "droptype": "D",
    "dropname": "REBERSBURG",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "REBERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168729998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "REBERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168729998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "REBERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168729998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143498789,
    "dropsitcph": 8143498789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A708",
    "droptype": "D",
    "dropname": "RECTOR",
    "dropdeladd": "2587 RECTOR RD",
    "dropdelcty": "RECTOR",
    "dropdelst": "PA",
    "dropdelzpp": 156771001,
    "dropphyadd": "2587 RECTOR RD",
    "dropphycty": "RECTOR",
    "dropphyst": "PA",
    "dropphyzpp": 156771001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RECTOR",
    "dropmalst": "PA",
    "dropmalzpp": 156779998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242386450,
    "dropsitcph": 7242386450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A712",
    "droptype": "D",
    "dropname": "RED HILL",
    "dropdeladd": "427 MAIN ST OFC",
    "dropdelcty": "RED HILL",
    "dropdelst": "PA",
    "dropdelzpp": 180769998,
    "dropphyadd": "427 MAIN ST OFC",
    "dropphycty": "RED HILL",
    "dropphyst": "PA",
    "dropphyzpp": 180769998,
    "dropmaladd": "427 MAIN ST OFC",
    "dropmalcty": "RED HILL",
    "dropmalst": "PA",
    "dropmalzpp": 180769998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2156795647,
    "dropfax": 2155414545
  },
  {
    "dcode": "D",
    "dropkey": "PX1A714",
    "droptype": "D",
    "dropname": "RED LION",
    "dropdeladd": "500 N MAIN ST",
    "dropdelcty": "RED LION",
    "dropdelst": "PA",
    "dropdelzpp": 173569998,
    "dropphyadd": "500 N MAIN ST",
    "dropphycty": "RED LION",
    "dropphyst": "PA",
    "dropphyzpp": 173569998,
    "dropmaladd": "500 N MAIN ST",
    "dropmalcty": "RED LION",
    "dropmalst": "PA",
    "dropmalzpp": 173569998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172442525,
    "dropsitcph": 7172442525,
    "dropfax": 7172441586
  },
  {
    "dcode": "D",
    "dropkey": "PX1A719",
    "droptype": "D",
    "dropname": "REEDERS",
    "dropdeladd": "2162 ROUTE 715",
    "dropdelcty": "REEDERS",
    "dropdelst": "PA",
    "dropdelzpp": 183529998,
    "dropphyadd": "2162 ROUTE 715",
    "dropphycty": "REEDERS",
    "dropphyst": "PA",
    "dropphyzpp": 183529998,
    "dropmaladd": "2162 ROUTE 715",
    "dropmalcty": "REEDERS",
    "dropmalst": "PA",
    "dropmalzpp": 183529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706291903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A722",
    "droptype": "D",
    "dropname": "REEDSVILLE",
    "dropdeladd": "50 S MAIN ST",
    "dropdelcty": "REEDSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170849998,
    "dropphyadd": "50 S MAIN ST",
    "dropphycty": "REEDSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170849998,
    "dropmaladd": "50 S MAIN ST",
    "dropmalcty": "REEDSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170849998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176673494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A723",
    "droptype": "D",
    "dropname": "REFTON",
    "dropdeladd": "45 REFTON RD",
    "dropdelcty": "REFTON",
    "dropdelst": "PA",
    "dropdelzpp": 175689998,
    "dropphyadd": "45 REFTON RD",
    "dropphycty": "REFTON",
    "dropphyst": "PA",
    "dropphyzpp": 175689998,
    "dropmaladd": "45 REFTON RD",
    "dropmalcty": "REFTON",
    "dropmalst": "PA",
    "dropmalzpp": 175689998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177862707,
    "dropsitcph": 7177862707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A725",
    "droptype": "D",
    "dropname": "REHRERSBURG",
    "dropdeladd": "349 GODFREY ST",
    "dropdelcty": "REHRERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 195509998,
    "dropphyadd": "349 GODFREY ST",
    "dropphycty": "REHRERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 195509998,
    "dropmaladd": "349 GODFREY ST",
    "dropmalcty": "REHRERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 195509998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179335308,
    "dropsitcph": 7179335308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A729",
    "droptype": "D",
    "dropname": "REINHOLDS",
    "dropdeladd": "110B MECHANIC ST",
    "dropdelcty": "REINHOLDS",
    "dropdelst": "PA",
    "dropdelzpp": 175699998,
    "dropphyadd": "110B MECHANIC ST",
    "dropphycty": "REINHOLDS",
    "dropphyst": "PA",
    "dropphyzpp": 175699998,
    "dropmaladd": "110B MECHANIC ST",
    "dropmalcty": "REINHOLDS",
    "dropmalst": "PA",
    "dropmalzpp": 175699998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173362354,
    "dropsitcph": 7173362354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A731",
    "droptype": "D",
    "dropname": "RENFREW",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "RENFREW",
    "dropdelst": "PA",
    "dropdelzpp": 160539800,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "RENFREW",
    "dropphyst": "PA",
    "dropphyzpp": 160539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RENFREW",
    "dropmalst": "PA",
    "dropmalzpp": 160539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245867209,
    "dropsitcph": 7245867209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A732",
    "droptype": "D",
    "dropname": "RENO",
    "dropdeladd": "1891 ALLEGHENY BLVD",
    "dropdelcty": "RENO",
    "dropdelst": "PA",
    "dropdelzpp": 163439800,
    "dropphyadd": "1891 ALLEGHENY BLVD",
    "dropphycty": "RENO",
    "dropphyst": "PA",
    "dropphyzpp": 163439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RENO",
    "dropmalst": "PA",
    "dropmalzpp": 163439998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146760511,
    "dropsitcph": 8146760511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A733",
    "droptype": "D",
    "dropname": "RENOVO",
    "dropdeladd": "365 HURON AVE",
    "dropdelcty": "RENOVO",
    "dropdelst": "PA",
    "dropdelzpp": 177649998,
    "dropphyadd": "365 HURON AVE",
    "dropphycty": "RENOVO",
    "dropphyst": "PA",
    "dropphyzpp": 177649998,
    "dropmaladd": "365 HURON AVE",
    "dropmalcty": "RENOVO",
    "dropmalst": "PA",
    "dropmalzpp": 177649998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703203041,
    "dropsitcph": 5709233042,
    "dropfax": 5709231264
  },
  {
    "dcode": "D",
    "dropkey": "PX1A734",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "26 VAN KIRK ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "PA",
    "dropdelzpp": 154751001,
    "dropphyadd": "26 VAN KIRK ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "PA",
    "dropphyzpp": 154751001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "PA",
    "dropmalzpp": 154759998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242462035,
    "dropsitcph": 7242462035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A735",
    "droptype": "D",
    "dropname": "REVERE",
    "dropdeladd": "8793 EASTON RD",
    "dropdelcty": "REVERE",
    "dropdelst": "PA",
    "dropdelzpp": 189539998,
    "dropphyadd": "8793 EASTON RD",
    "dropphycty": "REVERE",
    "dropphyst": "PA",
    "dropphyzpp": 189539998,
    "dropmaladd": "8793 EASTON RD",
    "dropmalcty": "REVERE",
    "dropmalst": "PA",
    "dropmalzpp": 189539998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108475100,
    "dropsitcph": 6108475100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A736",
    "droptype": "D",
    "dropname": "REVLOC",
    "dropdeladd": "552 CAMBRIA AVE",
    "dropdelcty": "REVLOC",
    "dropdelst": "PA",
    "dropdelzpp": 159489998,
    "dropphyadd": "552 CAMBRIA AVE",
    "dropphycty": "REVLOC",
    "dropphyst": "PA",
    "dropphyzpp": 159489998,
    "dropmaladd": "552 CAMBRIA AVE",
    "dropmalcty": "REVLOC",
    "dropmalst": "PA",
    "dropmalzpp": 159489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144729431,
    "dropsitcph": 8144729431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A737",
    "droptype": "D",
    "dropname": "REW",
    "dropdeladd": "1141 SUMMIT RD",
    "dropdelcty": "REW",
    "dropdelst": "PA",
    "dropdelzpp": 167449800,
    "dropphyadd": "1141 SUMMIT RD",
    "dropphycty": "REW",
    "dropphyst": "PA",
    "dropphyzpp": 167449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REW",
    "dropmalst": "PA",
    "dropmalzpp": 167449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144653252,
    "dropsitcph": 8144653252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A740",
    "droptype": "D",
    "dropname": "REXMONT",
    "dropdeladd": "106 DOHNER RD",
    "dropdelcty": "REXMONT",
    "dropdelst": "PA",
    "dropdelzpp": 170859998,
    "dropphyadd": "106 DOHNER RD",
    "dropphycty": "REXMONT",
    "dropphyst": "PA",
    "dropphyzpp": 170859998,
    "dropmaladd": "106 DOHNER RD",
    "dropmalcty": "REXMONT",
    "dropmalst": "PA",
    "dropmalzpp": 170859998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172743771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A741",
    "droptype": "D",
    "dropname": "REYNOLDSVILLE",
    "dropdeladd": "350 E MAIN ST",
    "dropdelcty": "REYNOLDSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 158519997,
    "dropphyadd": "350 E MAIN ST",
    "dropphycty": "REYNOLDSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 158519997,
    "dropmaladd": "350 E MAIN ST",
    "dropmalcty": "REYNOLDSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 158519997,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146538352,
    "dropsitcph": 8146538352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A743",
    "droptype": "D",
    "dropname": "RHEEMS",
    "dropdeladd": "119 LIME ST",
    "dropdelcty": "RHEEMS",
    "dropdelst": "PA",
    "dropdelzpp": 175709998,
    "dropphyadd": "119 LIME ST",
    "dropphycty": "RHEEMS",
    "dropphyst": "PA",
    "dropphyzpp": 175709998,
    "dropmaladd": "119 LIME ST",
    "dropmalcty": "RHEEMS",
    "dropmalst": "PA",
    "dropmalzpp": 175709998,
    "dropsitphn": 7173966993,
    "dropsitlph": 7173674938,
    "dropsitcph": 7173674938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A745",
    "droptype": "D",
    "dropname": "RICES LANDING",
    "dropdeladd": "113 RICES LANDING RD",
    "dropdelcty": "RICES LANDING",
    "dropdelst": "PA",
    "dropdelzpp": 153571001,
    "dropphyadd": "113 RICES LANDING RD",
    "dropphycty": "RICES LANDING",
    "dropphyst": "PA",
    "dropphyzpp": 153571001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICES LANDING",
    "dropmalst": "PA",
    "dropmalzpp": 153579998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245925555,
    "dropsitcph": 7245925555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A749",
    "droptype": "D",
    "dropname": "RICHEYVILLE",
    "dropdeladd": "3147 NATIONAL PIKE",
    "dropdelcty": "RICHEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153581001,
    "dropphyadd": "3147 NATIONAL PIKE",
    "dropphycty": "RICHEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153581001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153589998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127693239,
    "dropsitcph": 7246323239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A752",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "683 MAIN ST",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 170869998,
    "dropphyadd": "683 MAIN ST",
    "dropphycty": "RICHFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 170869998,
    "dropmaladd": "683 MAIN ST",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 170869998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176943210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A753",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "PA",
    "dropdelzpp": 170879998,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "PA",
    "dropphyzpp": 170879998,
    "dropmaladd": "2 W MAIN ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "PA",
    "dropmalzpp": 170879998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178666120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A754",
    "droptype": "D",
    "dropname": "RICHLANDTOWN",
    "dropdeladd": "492 RICHLANDTOWN PIKE",
    "dropdelcty": "RICHLANDTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189559998,
    "dropphyadd": "492 RICHLANDTOWN PIKE",
    "dropphycty": "RICHLANDTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189559998,
    "dropmaladd": "492 RICHLANDTOWN PIKE",
    "dropmalcty": "RICHLANDTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189559998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155360840,
    "dropsitcph": 2155360840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A762",
    "droptype": "D",
    "dropname": "RIDDLESBURG",
    "dropdeladd": "124 NEWTOWN RD",
    "dropdelcty": "RIDDLESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166729998,
    "dropphyadd": "124 NEWTOWN RD",
    "dropphycty": "RIDDLESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166729998,
    "dropmaladd": "124 NEWTOWN RD",
    "dropmalcty": "RIDDLESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166729998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149284404,
    "dropsitcph": 8149284404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A766",
    "droptype": "D",
    "dropname": "RIDGWAY",
    "dropdeladd": "18 S MILL AVE",
    "dropdelcty": "RIDGWAY",
    "dropdelst": "PA",
    "dropdelzpp": 158531058,
    "dropphyadd": "18 S MILL AVE",
    "dropphycty": "RIDGWAY",
    "dropphyst": "PA",
    "dropphyzpp": 158531058,
    "dropmaladd": "18 S MILL AVE",
    "dropmalcty": "RIDGWAY",
    "dropmalst": "PA",
    "dropmalzpp": 158531058,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147734191,
    "dropsitcph": 8147734191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A767",
    "droptype": "D",
    "dropname": "RIDLEY PARK",
    "dropdeladd": "15 E FELTON ST",
    "dropdelcty": "RIDLEY PARK",
    "dropdelst": "PA",
    "dropdelzpp": 190789997,
    "dropphyadd": "15 E FELTON ST",
    "dropphycty": "RIDLEY PARK",
    "dropphyst": "PA",
    "dropphyzpp": 190789997,
    "dropmaladd": "15 E FELTON ST",
    "dropmalcty": "RIDLEY PARK",
    "dropmalst": "PA",
    "dropmalzpp": 190789997,
    "dropsitphn": 6105216107,
    "dropsitlph": 6105210322,
    "dropsitcph": 6105216107,
    "dropfax": 6105212543
  },
  {
    "dcode": "D",
    "dropkey": "PX1A769",
    "droptype": "D",
    "dropname": "RIEGELSVILLE",
    "dropdeladd": "114 DELAWARE RD",
    "dropdelcty": "RIEGELSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180779998,
    "dropphyadd": "114 DELAWARE RD",
    "dropphycty": "RIEGELSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180779998,
    "dropmaladd": "114 DELAWARE RD",
    "dropmalcty": "RIEGELSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180779998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107492591,
    "dropfax": 6107490387
  },
  {
    "dcode": "D",
    "dropkey": "PX1A773",
    "droptype": "D",
    "dropname": "RILLTON",
    "dropdeladd": "1 MARS HILL RD",
    "dropdelcty": "RILLTON",
    "dropdelst": "PA",
    "dropdelzpp": 156781001,
    "dropphyadd": "1 MARS HILL RD",
    "dropphycty": "RILLTON",
    "dropphyst": "PA",
    "dropphyzpp": 156781001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RILLTON",
    "dropmalst": "PA",
    "dropmalzpp": 156789998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244465064,
    "dropsitcph": 7244465064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A774",
    "droptype": "D",
    "dropname": "RIMERSBURG",
    "dropdeladd": "689 MAIN ST",
    "dropdelcty": "RIMERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 162489800,
    "dropphyadd": "689 MAIN ST",
    "dropphycty": "RIMERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 162489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIMERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 162489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144733115,
    "dropsitcph": 8144733115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A779",
    "droptype": "D",
    "dropname": "RINGTOWN",
    "dropdeladd": "10 S MARKET ST",
    "dropdelcty": "RINGTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 179679998,
    "dropphyadd": "10 S MARKET ST",
    "dropphycty": "RINGTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 179679998,
    "dropmaladd": "10 S MARKET ST",
    "dropmalcty": "RINGTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 179679998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708893125,
    "dropsitcph": 5708893125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A782",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "452 DEWART ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "PA",
    "dropdelzpp": 178689998,
    "dropphyadd": "452 DEWART ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "PA",
    "dropphyzpp": 178689998,
    "dropmaladd": "452 DEWART ST",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "PA",
    "dropmalzpp": 178689998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5702751047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A783",
    "droptype": "D",
    "dropname": "RIXFORD",
    "dropdeladd": "1102 LOOKER MOUNTAIN TRL",
    "dropdelcty": "RIXFORD",
    "dropdelst": "PA",
    "dropdelzpp": 167459800,
    "dropphyadd": "1102 LOOKER MOUNTAIN TRL",
    "dropphycty": "RIXFORD",
    "dropphyst": "PA",
    "dropphyzpp": 167459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIXFORD",
    "dropmalst": "PA",
    "dropmalzpp": 167459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144657718,
    "dropsitcph": 8144657718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A785",
    "droptype": "D",
    "dropname": "ROARING BRANCH",
    "dropdeladd": "986 ROUTE 14",
    "dropdelcty": "ROARING BRANCH",
    "dropdelst": "PA",
    "dropdelzpp": 177659998,
    "dropphyadd": "986 ROUTE 14",
    "dropphycty": "ROARING BRANCH",
    "dropphyst": "PA",
    "dropphyzpp": 177659998,
    "dropmaladd": "986 ROUTE 14",
    "dropmalcty": "ROARING BRANCH",
    "dropmalst": "PA",
    "dropmalzpp": 177659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706738385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A787",
    "droptype": "D",
    "dropname": "ROARING SPRING",
    "dropdeladd": "427 E MAIN ST",
    "dropdelcty": "ROARING SPRING",
    "dropdelst": "PA",
    "dropdelzpp": 166739998,
    "dropphyadd": "427 E MAIN ST",
    "dropphycty": "ROARING SPRING",
    "dropphyst": "PA",
    "dropphyzpp": 166739998,
    "dropmaladd": "427 E MAIN ST",
    "dropmalcty": "ROARING SPRING",
    "dropmalst": "PA",
    "dropmalzpp": 166739998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142242013,
    "dropsitcph": 8142242013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A788",
    "droptype": "D",
    "dropname": "ROBERTSDALE",
    "dropdeladd": "563 MAIN ST",
    "dropdelcty": "ROBERTSDALE",
    "dropdelst": "PA",
    "dropdelzpp": 166749998,
    "dropphyadd": "563 MAIN ST",
    "dropphycty": "ROBERTSDALE",
    "dropphyst": "PA",
    "dropphyzpp": 166749998,
    "dropmaladd": "563 MAIN ST",
    "dropmalcty": "ROBERTSDALE",
    "dropmalst": "PA",
    "dropmalzpp": 166749998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146353446,
    "dropsitcph": 8146353446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A790",
    "droptype": "D",
    "dropname": "ROBESONIA",
    "dropdeladd": "37 E PENN AVE",
    "dropdelcty": "ROBESONIA",
    "dropdelst": "PA",
    "dropdelzpp": 195519998,
    "dropphyadd": "37 E PENN AVE",
    "dropphycty": "ROBESONIA",
    "dropphyst": "PA",
    "dropphyzpp": 195519998,
    "dropmaladd": "37 E PENN AVE",
    "dropmalcty": "ROBESONIA",
    "dropmalst": "PA",
    "dropmalzpp": 195519998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106935541,
    "dropsitcph": 6106935541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A791",
    "droptype": "D",
    "dropname": "ROBINSON",
    "dropdeladd": "45 FRONT ST",
    "dropdelcty": "ROBINSON",
    "dropdelst": "PA",
    "dropdelzpp": 159499998,
    "dropphyadd": "45 FRONT ST",
    "dropphycty": "ROBINSON",
    "dropphyst": "PA",
    "dropphyzpp": 159499998,
    "dropmaladd": "45 FRONT ST",
    "dropmalcty": "ROBINSON",
    "dropmalst": "PA",
    "dropmalzpp": 159499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246765466,
    "dropsitcph": 7246765466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A793",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "257 CONNECTICUT AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 150749998,
    "dropphyadd": "257 CONNECTICUT AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 150749998,
    "dropmaladd": "257 CONNECTICUT AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 150749998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247746685,
    "dropsitcph": 7247746685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A794",
    "droptype": "D",
    "dropname": "ROCHESTER MILLS",
    "dropdeladd": "4941 RICHMOND RD",
    "dropdelcty": "ROCHESTER MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 157719998,
    "dropphyadd": "4941 RICHMOND RD",
    "dropphycty": "ROCHESTER MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 157719998,
    "dropmaladd": "4941 RICHMOND RD",
    "dropmalcty": "ROCHESTER MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 157719998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242869909,
    "dropsitcph": 7242869909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A796",
    "droptype": "D",
    "dropname": "ROCK GLEN",
    "dropdeladd": "1289 MOUNTAIN ST",
    "dropdelcty": "ROCK GLEN",
    "dropdelst": "PA",
    "dropdelzpp": 182469998,
    "dropphyadd": "1289 MOUNTAIN ST",
    "dropphycty": "ROCK GLEN",
    "dropphyst": "PA",
    "dropphyzpp": 182469998,
    "dropmaladd": "1289 MOUNTAIN ST",
    "dropmalcty": "ROCK GLEN",
    "dropmalst": "PA",
    "dropmalzpp": 182469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703843943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A799",
    "droptype": "D",
    "dropname": "ROCKHILL FURNACE",
    "dropdeladd": "444 MEADOW ST",
    "dropdelcty": "ROCKHILL FURNACE",
    "dropdelst": "PA",
    "dropdelzpp": 172499998,
    "dropphyadd": "444 MEADOW ST",
    "dropphycty": "ROCKHILL FURNACE",
    "dropphyst": "PA",
    "dropphyzpp": 172499998,
    "dropmaladd": "444 MEADOW ST",
    "dropmalcty": "ROCKHILL FURNACE",
    "dropmalst": "PA",
    "dropmalzpp": 172499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8144475641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A803",
    "droptype": "D",
    "dropname": "ROCKTON",
    "dropdeladd": "21 OLD DUBOIS RD",
    "dropdelcty": "ROCKTON",
    "dropdelst": "PA",
    "dropdelzpp": 158569800,
    "dropphyadd": "21 OLD DUBOIS RD",
    "dropphycty": "ROCKTON",
    "dropphyst": "PA",
    "dropphyzpp": 158569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKTON",
    "dropmalst": "PA",
    "dropmalzpp": 158569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145835116,
    "dropsitcph": 8145835116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A807",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "690 MAIN ST",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 155579998,
    "dropphyadd": "690 MAIN ST",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 155579998,
    "dropmaladd": "690 MAIN ST",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 155579998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149262553,
    "dropsitcph": 8149262553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A811",
    "droptype": "D",
    "dropname": "ROGERSVILLE",
    "dropdeladd": "140 CHURCH ST",
    "dropdelcty": "ROGERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153591001,
    "dropphyadd": "140 CHURCH ST",
    "dropphycty": "ROGERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153591001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROGERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153599998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244995752,
    "dropsitcph": 7244995752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A818",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "811 MAIN ST",
    "dropdelcty": "ROME",
    "dropdelst": "PA",
    "dropdelzpp": 188379998,
    "dropphyadd": "811 MAIN ST",
    "dropphycty": "ROME",
    "dropphyst": "PA",
    "dropphyzpp": 188379998,
    "dropmaladd": "811 MAIN ST",
    "dropmalcty": "ROME",
    "dropmalst": "PA",
    "dropmalzpp": 188379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702472552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A819",
    "droptype": "D",
    "dropname": "RONCO",
    "dropdeladd": "639 STEVENSON ST",
    "dropdelcty": "RONCO",
    "dropdelst": "PA",
    "dropdelzpp": 154761001,
    "dropphyadd": "639 STEVENSON ST",
    "dropphycty": "RONCO",
    "dropphyst": "PA",
    "dropphyzpp": 154761001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RONCO",
    "dropmalst": "PA",
    "dropmalzpp": 154769998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245832020,
    "dropsitcph": 7245832020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A820",
    "droptype": "D",
    "dropname": "RONKS",
    "dropdeladd": "9 N RONKS RD",
    "dropdelcty": "RONKS",
    "dropdelst": "PA",
    "dropdelzpp": 175729998,
    "dropphyadd": "9 N RONKS RD",
    "dropphycty": "RONKS",
    "dropphyst": "PA",
    "dropphyzpp": 175729998,
    "dropmaladd": "9 N RONKS RD",
    "dropmalcty": "RONKS",
    "dropmalst": "PA",
    "dropmalzpp": 175729998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176878201,
    "dropsitcph": 7176878201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A822",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "500 FURLONG AVE",
    "dropdelcty": "ROSCOE",
    "dropdelst": "PA",
    "dropdelzpp": 154771001,
    "dropphyadd": "500 FURLONG AVE",
    "dropphycty": "ROSCOE",
    "dropphyst": "PA",
    "dropphyzpp": 154771001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSCOE",
    "dropmalst": "PA",
    "dropmalzpp": 154779998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249388394,
    "dropsitcph": 7249388394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A838",
    "droptype": "D",
    "dropname": "ROSSITER",
    "dropdeladd": "384 CENTRAL ST",
    "dropdelcty": "ROSSITER",
    "dropdelst": "PA",
    "dropdelzpp": 157729998,
    "dropphyadd": "384 CENTRAL ST",
    "dropphycty": "ROSSITER",
    "dropphyst": "PA",
    "dropphyzpp": 157729998,
    "dropmaladd": "384 CENTRAL ST",
    "dropmalcty": "ROSSITER",
    "dropmalst": "PA",
    "dropmalzpp": 157729998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149387461,
    "dropsitcph": 8149387461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A840",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "7489A CARLISLE RD",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173589998,
    "dropphyadd": "7489A CARLISLE RD",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173589998,
    "dropmaladd": "7489A CARLISLE RD",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173589998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174323388,
    "dropsitcph": 7174323388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A847",
    "droptype": "D",
    "dropname": "ROULETTE",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "ROULETTE",
    "dropdelst": "PA",
    "dropdelzpp": 167469800,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "ROULETTE",
    "dropphyst": "PA",
    "dropphyzpp": 167469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROULETTE",
    "dropmalst": "PA",
    "dropmalzpp": 167469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145447501,
    "dropsitcph": 8145447501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A848",
    "droptype": "D",
    "dropname": "ROUSEVILLE",
    "dropdeladd": "114 CHERRY RUN RD",
    "dropdelcty": "ROUSEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163449800,
    "dropphyadd": "114 CHERRY RUN RD",
    "dropphycty": "ROUSEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROUSEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146761762,
    "dropsitcph": 8146761762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A849",
    "droptype": "D",
    "dropname": "ROUZERVILLE",
    "dropdeladd": "11738 PEN MAR RD",
    "dropdelcty": "ROUZERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 172509800,
    "dropphyadd": "11738 PEN MAR RD",
    "dropphycty": "ROUZERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 172509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROUZERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 172509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177695317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A850",
    "droptype": "D",
    "dropname": "ROWLAND",
    "dropdeladd": "102 SOLVERSON RD",
    "dropdelcty": "ROWLAND",
    "dropdelst": "PA",
    "dropdelzpp": 184579998,
    "dropphyadd": "102 SOLVERSON RD",
    "dropphycty": "ROWLAND",
    "dropphyst": "PA",
    "dropphyzpp": 184579998,
    "dropmaladd": "102 SOLVERSON RD",
    "dropmalcty": "ROWLAND",
    "dropmalst": "PA",
    "dropmalzpp": 184579998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706857080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A853",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "10970 ROXBURY RD",
    "dropdelcty": "ROXBURY",
    "dropdelst": "PA",
    "dropdelzpp": 172519998,
    "dropphyadd": "10970 ROXBURY RD",
    "dropphycty": "ROXBURY",
    "dropphyst": "PA",
    "dropphyzpp": 172519998,
    "dropmaladd": "10970 ROXBURY RD",
    "dropmalcty": "ROXBURY",
    "dropmalst": "PA",
    "dropmalzpp": 172519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175328370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A855",
    "droptype": "D",
    "dropname": "ROYERSFORD",
    "dropdeladd": "354 N LEWIS RD",
    "dropdelcty": "ROYERSFORD",
    "dropdelst": "PA",
    "dropdelzpp": 194689998,
    "dropphyadd": "354 N LEWIS RD",
    "dropphycty": "ROYERSFORD",
    "dropphyst": "PA",
    "dropphyzpp": 194689998,
    "dropmaladd": "354 N LEWIS RD",
    "dropmalcty": "ROYERSFORD",
    "dropmalst": "PA",
    "dropmalzpp": 194689998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107924758,
    "dropsitcph": 6107924758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A857",
    "droptype": "D",
    "dropname": "RUFFS DALE",
    "dropdeladd": "875 STATE ROUTE 31",
    "dropdelcty": "RUFFS DALE",
    "dropdelst": "PA",
    "dropdelzpp": 156791001,
    "dropphyadd": "875 STATE ROUTE 31",
    "dropphycty": "RUFFS DALE",
    "dropphyst": "PA",
    "dropphyzpp": 156791001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUFFS DALE",
    "dropmalst": "PA",
    "dropmalzpp": 156799998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246963252,
    "dropsitcph": 7246963252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A859",
    "droptype": "D",
    "dropname": "RURAL RIDGE",
    "dropdeladd": "165 LITTLE DEER CREEK RD",
    "dropdelcty": "RURAL RIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 150751001,
    "dropphyadd": "165 LITTLE DEER CREEK RD",
    "dropphycty": "RURAL RIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 150751001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RURAL RIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 150759998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242655170,
    "dropsitcph": 7242655170,
    "dropfax": 7242652162
  },
  {
    "dcode": "D",
    "dropkey": "PX1A860",
    "droptype": "D",
    "dropname": "RURAL VALLEY",
    "dropdeladd": "700 MIDDLE 1ST ST",
    "dropdelcty": "RURAL VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 162499800,
    "dropphyadd": "700 MIDDLE 1ST ST",
    "dropphycty": "RURAL VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 162499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RURAL VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 162499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247837351,
    "dropsitcph": 7247837351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A863",
    "droptype": "D",
    "dropname": "RUSHLAND",
    "dropdeladd": "1070 SWAMP RD",
    "dropdelcty": "RUSHLAND",
    "dropdelst": "PA",
    "dropdelzpp": 189569998,
    "dropphyadd": "1070 SWAMP RD",
    "dropphycty": "RUSHLAND",
    "dropphyst": "PA",
    "dropphyzpp": 189569998,
    "dropmaladd": "1070 SWAMP RD",
    "dropmalcty": "RUSHLAND",
    "dropmalst": "PA",
    "dropmalzpp": 189569998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155983498,
    "dropsitcph": 2155983498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A868",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "102 LIBERTY ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "PA",
    "dropdelzpp": 163459800,
    "dropphyadd": "102 LIBERTY ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "PA",
    "dropphyzpp": 163459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSELL",
    "dropmalst": "PA",
    "dropmalzpp": 163459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147578500,
    "dropsitcph": 8147578500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A869",
    "droptype": "D",
    "dropname": "RUSSELLTON",
    "dropdeladd": "733 LITTLE DEER CREEK VALLEY RD",
    "dropdelcty": "RUSSELLTON",
    "dropdelst": "PA",
    "dropdelzpp": 150769998,
    "dropphyadd": "733 LITTLE DEER CREEK VALLEY RD",
    "dropphycty": "RUSSELLTON",
    "dropphyst": "PA",
    "dropphyzpp": 150769998,
    "dropmaladd": "733 LITTLE DEER CREEK VALLEY RD",
    "dropmalcty": "RUSSELLTON",
    "dropmalst": "PA",
    "dropmalzpp": 150769998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242653666,
    "dropsitcph": 7242653666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A886",
    "droptype": "D",
    "dropname": "SABINSVILLE",
    "dropdeladd": "1056 SPRUCE ST",
    "dropdelcty": "SABINSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 169439998,
    "dropphyadd": "1056 SPRUCE ST",
    "dropphycty": "SABINSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 169439998,
    "dropmaladd": "1056 SPRUCE ST",
    "dropmalcty": "SABINSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 169439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8146283881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A887",
    "droptype": "D",
    "dropname": "SACRAMENTO",
    "dropdeladd": "2263 E MAIN ST",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "PA",
    "dropdelzpp": 179689998,
    "dropphyadd": "2263 E MAIN ST",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "PA",
    "dropphyzpp": 179689998,
    "dropmaladd": "2263 E MAIN ST",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "PA",
    "dropmalzpp": 179689998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706829870,
    "dropsitcph": 5706829870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A889",
    "droptype": "D",
    "dropname": "SADSBURYVILLE",
    "dropdeladd": "2969 W LINCOLN HWY",
    "dropdelcty": "SADSBURYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193699900,
    "dropphyadd": "2969 W LINCOLN HWY",
    "dropphycty": "SADSBURYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193699900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SADSBURYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193699998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108579261,
    "dropsitcph": 6108579261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A890",
    "droptype": "D",
    "dropname": "SAEGERTOWN",
    "dropdeladd": "521 MAIN ST",
    "dropdelcty": "SAEGERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 164339800,
    "dropphyadd": "521 MAIN ST",
    "dropphycty": "SAEGERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 164339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAEGERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 164339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147634205,
    "dropsitcph": 8147634205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A892",
    "droptype": "D",
    "dropname": "SAGAMORE",
    "dropdeladd": "333 POST OFFICE RD",
    "dropdelcty": "SAGAMORE",
    "dropdelst": "PA",
    "dropdelzpp": 162509800,
    "dropphyadd": "333 POST OFFICE RD",
    "dropphycty": "SAGAMORE",
    "dropphyst": "PA",
    "dropphyzpp": 162509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAGAMORE",
    "dropmalst": "PA",
    "dropmalzpp": 162509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247836384,
    "dropsitcph": 7247836384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A896",
    "droptype": "D",
    "dropname": "SAINT BENEDICT",
    "dropdeladd": "125 POST OFFICE RD",
    "dropdelcty": "SAINT BENEDICT",
    "dropdelst": "PA",
    "dropdelzpp": 157739998,
    "dropphyadd": "125 POST OFFICE RD",
    "dropphycty": "SAINT BENEDICT",
    "dropphyst": "PA",
    "dropphyzpp": 157739998,
    "dropmaladd": "125 POST OFFICE RD",
    "dropmalcty": "SAINT BENEDICT",
    "dropmalst": "PA",
    "dropmalzpp": 157739998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149484170,
    "dropsitcph": 8149484170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A898",
    "droptype": "D",
    "dropname": "SAINT CLAIR",
    "dropdeladd": "10 W CARROLL ST",
    "dropdelcty": "SAINT CLAIR",
    "dropdelst": "PA",
    "dropdelzpp": 179709998,
    "dropphyadd": "10 W CARROLL ST",
    "dropphycty": "SAINT CLAIR",
    "dropphyst": "PA",
    "dropphyzpp": 179709998,
    "dropmaladd": "10 W CARROLL ST",
    "dropmalcty": "SAINT CLAIR",
    "dropmalst": "PA",
    "dropmalzpp": 179709998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5704292130,
    "dropsitcph": 5704292130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A900",
    "droptype": "D",
    "dropname": "SAINT JOHNS",
    "dropdeladd": "784 SAINT JOHNS RD",
    "dropdelcty": "SAINT JOHNS",
    "dropdelst": "PA",
    "dropdelzpp": 182479998,
    "dropphyadd": "784 SAINT JOHNS RD",
    "dropphycty": "SAINT JOHNS",
    "dropphyst": "PA",
    "dropphyzpp": 182479998,
    "dropmaladd": "784 SAINT JOHNS RD",
    "dropmalcty": "SAINT JOHNS",
    "dropmalst": "PA",
    "dropmalzpp": 182479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707884228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A902",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "201 CHESTNUT ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "PA",
    "dropdelzpp": 158571790,
    "dropphyadd": "201 CHESTNUT ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "PA",
    "dropphyzpp": 158571790,
    "dropmaladd": "201 CHESTNUT ST",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "PA",
    "dropmalzpp": 158571790,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148343116,
    "dropsitcph": 8148343116,
    "dropfax": 8148343145
  },
  {
    "dcode": "D",
    "dropkey": "PX1A903",
    "droptype": "D",
    "dropname": "SAINT MICHAEL",
    "dropdeladd": "983 LOCUST ST",
    "dropdelcty": "SAINT MICHAEL",
    "dropdelst": "PA",
    "dropdelzpp": 159519998,
    "dropphyadd": "983 LOCUST ST",
    "dropphycty": "SAINT MICHAEL",
    "dropphyst": "PA",
    "dropphyzpp": 159519998,
    "dropmaladd": "983 LOCUST ST",
    "dropmalcty": "SAINT MICHAEL",
    "dropmalst": "PA",
    "dropmalzpp": 159519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144959440,
    "dropsitcph": 8144959440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A904",
    "droptype": "D",
    "dropname": "SAINT PETERS",
    "dropdeladd": "3300 SAINT PETERS RD",
    "dropdelcty": "SAINT PETERS",
    "dropdelst": "PA",
    "dropdelzpp": 194709901,
    "dropphyadd": "3300 SAINT PETERS RD",
    "dropphycty": "SAINT PETERS",
    "dropphyst": "PA",
    "dropphyzpp": 194709901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PETERS",
    "dropmalst": "PA",
    "dropmalzpp": 194709998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104696663,
    "dropsitcph": 6104696663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A905",
    "droptype": "D",
    "dropname": "SAINT PETERSBURG",
    "dropdeladd": "711 MAIN ST",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 160549800,
    "dropphyadd": "711 MAIN ST",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 160549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 160549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246593416,
    "dropsitcph": 7246593416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A906",
    "droptype": "D",
    "dropname": "SAINT THOMAS",
    "dropdeladd": "164 SAINT THOMAS WILLIAMSON RD",
    "dropdelcty": "SAINT THOMAS",
    "dropdelst": "PA",
    "dropdelzpp": 172529998,
    "dropphyadd": "164 SAINT THOMAS WILLIAMSON RD",
    "dropphycty": "SAINT THOMAS",
    "dropphyst": "PA",
    "dropphyzpp": 172529998,
    "dropmaladd": "164 SAINT THOMAS WILLIAMSON RD",
    "dropmalcty": "SAINT THOMAS",
    "dropmalst": "PA",
    "dropmalzpp": 172529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173694465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A909",
    "droptype": "D",
    "dropname": "SALFORD",
    "dropdeladd": "1623 SALFORD ST",
    "dropdelcty": "SALFORD",
    "dropdelst": "PA",
    "dropdelzpp": 189579998,
    "dropphyadd": "1623 SALFORD ST",
    "dropphycty": "SALFORD",
    "dropphyst": "PA",
    "dropphyzpp": 189579998,
    "dropmaladd": "1623 SALFORD ST",
    "dropmalcty": "SALFORD",
    "dropmalst": "PA",
    "dropmalzpp": 189579998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102876413,
    "dropsitcph": 6102876413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A910",
    "droptype": "D",
    "dropname": "SALFORDVILLE",
    "dropdeladd": "893 OLD SKIPPACK PIKE",
    "dropdelcty": "SALFORDVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189589998,
    "dropphyadd": "893 OLD SKIPPACK PIKE",
    "dropphycty": "SALFORDVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189589998,
    "dropmaladd": "893 OLD SKIPPACK PIKE",
    "dropmalcty": "SALFORDVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189589998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102876600,
    "dropsitcph": 6102876600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A911",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "194 MAIN ST",
    "dropdelcty": "SALINA",
    "dropdelst": "PA",
    "dropdelzpp": 156801001,
    "dropphyadd": "194 MAIN ST",
    "dropphycty": "SALINA",
    "dropphyst": "PA",
    "dropphyzpp": 156801001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALINA",
    "dropmalst": "PA",
    "dropmalzpp": 156809998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246975212,
    "dropsitcph": 7246975212,
    "dropfax": 7246975212
  },
  {
    "dcode": "D",
    "dropkey": "PX1A912",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "96 GRANT ST STE 1",
    "dropdelcty": "SALISBURY",
    "dropdelst": "PA",
    "dropdelzpp": 155589998,
    "dropphyadd": "96 GRANT ST STE 1",
    "dropphycty": "SALISBURY",
    "dropphyst": "PA",
    "dropphyzpp": 155589998,
    "dropmaladd": "96 GRANT ST STE 1",
    "dropmalcty": "SALISBURY",
    "dropmalst": "PA",
    "dropmalzpp": 155589998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146624266,
    "dropsitcph": 8146624266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A914",
    "droptype": "D",
    "dropname": "SALIX",
    "dropdeladd": "1108 FOREST HILLS DR",
    "dropdelcty": "SALIX",
    "dropdelst": "PA",
    "dropdelzpp": 159529998,
    "dropphyadd": "1108 FOREST HILLS DR",
    "dropphycty": "SALIX",
    "dropphyst": "PA",
    "dropphyzpp": 159529998,
    "dropmaladd": "1108 FOREST HILLS DR",
    "dropmalcty": "SALIX",
    "dropmalst": "PA",
    "dropmalzpp": 159529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144877311,
    "dropsitcph": 8144877311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A917",
    "droptype": "D",
    "dropname": "SALTILLO",
    "dropdeladd": "20548 S MAIN ST",
    "dropdelcty": "SALTILLO",
    "dropdelst": "PA",
    "dropdelzpp": 172539998,
    "dropphyadd": "20548 S MAIN ST",
    "dropphycty": "SALTILLO",
    "dropphyst": "PA",
    "dropphyzpp": 172539998,
    "dropmaladd": "20548 S MAIN ST",
    "dropmalcty": "SALTILLO",
    "dropmalst": "PA",
    "dropmalzpp": 172539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8144482830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A918",
    "droptype": "D",
    "dropname": "SALTSBURG",
    "dropdeladd": "207 POINT ST",
    "dropdelcty": "SALTSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156819998,
    "dropphyadd": "207 POINT ST",
    "dropphycty": "SALTSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156819998,
    "dropmaladd": "207 POINT ST",
    "dropmalcty": "SALTSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156819998,
    "dropsitphn": 4123597960,
    "dropsitlph": 7246393711,
    "dropsitcph": 7246393711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A923",
    "droptype": "D",
    "dropname": "SANDY LAKE",
    "dropdeladd": "3267 S MAIN ST",
    "dropdelcty": "SANDY LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 161459800,
    "dropphyadd": "3267 S MAIN ST",
    "dropphycty": "SANDY LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 161459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANDY LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 161459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243762354,
    "dropsitcph": 7243762354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A925",
    "droptype": "D",
    "dropname": "SARVER",
    "dropdeladd": "705 EKASTOWN RD",
    "dropdelcty": "SARVER",
    "dropdelst": "PA",
    "dropdelzpp": 160559800,
    "dropphyadd": "705 EKASTOWN RD",
    "dropphycty": "SARVER",
    "dropphyst": "PA",
    "dropphyzpp": 160559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARVER",
    "dropmalst": "PA",
    "dropmalzpp": 160559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243532340,
    "dropsitcph": 7243532340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A926",
    "droptype": "D",
    "dropname": "SASSAMANSVILLE",
    "dropdeladd": "140 HOFFMANSVILLE RD",
    "dropdelcty": "SASSAMANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194729900,
    "dropphyadd": "140 HOFFMANSVILLE RD",
    "dropphycty": "SASSAMANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SASSAMANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194729998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107547151,
    "dropsitcph": 6107547151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A928",
    "droptype": "D",
    "dropname": "SAXONBURG",
    "dropdeladd": "120 PITTSBURGH ST",
    "dropdelcty": "SAXONBURG",
    "dropdelst": "PA",
    "dropdelzpp": 160569800,
    "dropphyadd": "120 PITTSBURGH ST",
    "dropphycty": "SAXONBURG",
    "dropphyst": "PA",
    "dropphyzpp": 160569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAXONBURG",
    "dropmalst": "PA",
    "dropmalzpp": 160569998,
    "dropsitphn": 7243521777,
    "dropsitlph": 7243521777,
    "dropsitcph": 7243521777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A929",
    "droptype": "D",
    "dropname": "SAXTON",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "SAXTON",
    "dropdelst": "PA",
    "dropdelzpp": 166789998,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "SAXTON",
    "dropphyst": "PA",
    "dropphyzpp": 166789998,
    "dropmaladd": "508 MAIN ST",
    "dropmalcty": "SAXTON",
    "dropmalst": "PA",
    "dropmalzpp": 166789998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146352941,
    "dropsitcph": 8146352941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A931",
    "droptype": "D",
    "dropname": "SAYLORSBURG",
    "dropdeladd": "284 ANCHORAGE RD",
    "dropdelcty": "SAYLORSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 183539998,
    "dropphyadd": "284 ANCHORAGE RD",
    "dropphycty": "SAYLORSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 183539998,
    "dropmaladd": "284 ANCHORAGE RD",
    "dropmalcty": "SAYLORSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 183539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5709926575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A932",
    "droptype": "D",
    "dropname": "SAYRE",
    "dropdeladd": "240 DESMOND ST",
    "dropdelcty": "SAYRE",
    "dropdelst": "PA",
    "dropdelzpp": 188409998,
    "dropphyadd": "240 DESMOND ST",
    "dropphycty": "SAYRE",
    "dropphyst": "PA",
    "dropphyzpp": 188409998,
    "dropmaladd": "240 DESMOND ST",
    "dropmalcty": "SAYRE",
    "dropmalst": "PA",
    "dropmalzpp": 188409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708886608,
    "dropfax": 5708886608
  },
  {
    "dcode": "D",
    "dropkey": "PX1A934",
    "droptype": "D",
    "dropname": "SCENERY HILL",
    "dropdeladd": "1908 E NATIONAL PIKE",
    "dropdelcty": "SCENERY HILL",
    "dropdelst": "PA",
    "dropdelzpp": 153601029,
    "dropphyadd": "1908 E NATIONAL PIKE",
    "dropphycty": "SCENERY HILL",
    "dropphyst": "PA",
    "dropphyzpp": 153601029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCENERY HILL",
    "dropmalst": "PA",
    "dropmalzpp": 153609998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249456100,
    "dropsitcph": 7249456100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A936",
    "droptype": "D",
    "dropname": "SCHAEFFERSTOWN",
    "dropdeladd": "1179 HEIDELBERG AVE",
    "dropdelcty": "SCHAEFFERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170889998,
    "dropphyadd": "1179 HEIDELBERG AVE",
    "dropphycty": "SCHAEFFERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170889998,
    "dropmaladd": "1179 HEIDELBERG AVE",
    "dropmalcty": "SCHAEFFERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170889998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179493027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A937",
    "droptype": "D",
    "dropname": "SCHELLSBURG",
    "dropdeladd": "3771 PITT ST",
    "dropdelcty": "SCHELLSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 155599001,
    "dropphyadd": "3771 PITT ST",
    "dropphycty": "SCHELLSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 155599001,
    "dropmaladd": "3771 PITT ST",
    "dropmalcty": "SCHELLSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 155599001,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147334141,
    "dropsitcph": 8147334141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A938",
    "droptype": "D",
    "dropname": "SCHENLEY",
    "dropdeladd": "105 RAILROAD ST",
    "dropdelcty": "SCHENLEY",
    "dropdelst": "PA",
    "dropdelzpp": 156821001,
    "dropphyadd": "105 RAILROAD ST",
    "dropphycty": "SCHENLEY",
    "dropphyst": "PA",
    "dropphyzpp": 156821001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHENLEY",
    "dropmalst": "PA",
    "dropmalzpp": 156829998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242959805,
    "dropsitcph": 7242959805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A939",
    "droptype": "D",
    "dropname": "SCHNECKSVILLE",
    "dropdeladd": "4709 ROUTE 309",
    "dropdelcty": "SCHNECKSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180782460,
    "dropphyadd": "4709 ROUTE 309",
    "dropphycty": "SCHNECKSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180782460,
    "dropmaladd": "4709 ROUTE 309",
    "dropmalcty": "SCHNECKSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180782460,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107993320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A950",
    "droptype": "D",
    "dropname": "SCHUYLKILL HAVEN",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "SCHUYLKILL HAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 179729998,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "SCHUYLKILL HAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 179729998,
    "dropmaladd": "2 W MAIN ST",
    "dropmalcty": "SCHUYLKILL HAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 179729998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703853620,
    "dropsitcph": 5703853620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A952",
    "droptype": "D",
    "dropname": "SCIOTA",
    "dropdeladd": "134 BOSSARDSVILLE RD",
    "dropdelcty": "SCIOTA",
    "dropdelst": "PA",
    "dropdelzpp": 183549998,
    "dropphyadd": "134 BOSSARDSVILLE RD",
    "dropphycty": "SCIOTA",
    "dropphyst": "PA",
    "dropphyzpp": 183549998,
    "dropmaladd": "134 BOSSARDSVILLE RD",
    "dropmalcty": "SCIOTA",
    "dropmalst": "PA",
    "dropmalzpp": 183549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5709925558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A953",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "3735 SCOTLAND RD",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "PA",
    "dropdelzpp": 172549800,
    "dropphyadd": "3735 SCOTLAND RD",
    "dropphycty": "SCOTLAND",
    "dropphyst": "PA",
    "dropphyzpp": 172549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "PA",
    "dropmalzpp": 172549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172635599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A954",
    "droptype": "D",
    "dropname": "SCOTRUN",
    "dropdeladd": "338 SCOTRUN AVE OFC",
    "dropdelcty": "SCOTRUN",
    "dropdelst": "PA",
    "dropdelzpp": 183559998,
    "dropphyadd": "338 SCOTRUN AVE OFC",
    "dropphycty": "SCOTRUN",
    "dropphyst": "PA",
    "dropphyzpp": 183559998,
    "dropmaladd": "338 SCOTRUN AVE OFC",
    "dropmalcty": "SCOTRUN",
    "dropmalst": "PA",
    "dropmalzpp": 183559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706290221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A955",
    "droptype": "D",
    "dropname": "SCOTTDALE",
    "dropdeladd": "7 N CHESTNUT ST",
    "dropdelcty": "SCOTTDALE",
    "dropdelst": "PA",
    "dropdelzpp": 156839998,
    "dropphyadd": "7 N CHESTNUT ST",
    "dropphycty": "SCOTTDALE",
    "dropphyst": "PA",
    "dropphyzpp": 156839998,
    "dropmaladd": "7 N CHESTNUT ST",
    "dropmalcty": "SCOTTDALE",
    "dropmalst": "PA",
    "dropmalzpp": 156839998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248874624,
    "dropsitcph": 7248874624,
    "dropfax": 7248877984
  },
  {
    "dcode": "D",
    "dropkey": "PX1A957",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "2800 STAFFORD AVE",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185059998,
    "dropphyadd": "2800 STAFFORD AVE",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185059998,
    "dropmaladd": "2800 STAFFORD AVE",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185059998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709695128,
    "dropfax": 5709695151
  },
  {
    "dcode": "D",
    "dropkey": "PX1A966",
    "droptype": "D",
    "dropname": "SELINSGROVE",
    "dropdeladd": "100 S MARKET ST",
    "dropdelcty": "SELINSGROVE",
    "dropdelst": "PA",
    "dropdelzpp": 178709998,
    "dropphyadd": "100 S MARKET ST",
    "dropphycty": "SELINSGROVE",
    "dropphyst": "PA",
    "dropphyzpp": 178709998,
    "dropmaladd": "100 S MARKET ST",
    "dropmalcty": "SELINSGROVE",
    "dropmalst": "PA",
    "dropmalzpp": 178709998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703744821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A967",
    "droptype": "D",
    "dropname": "SELLERSVILLE",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "SELLERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189609998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "SELLERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189609998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "SELLERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189609998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152571574,
    "dropsitcph": 2152571574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A970",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "130 MEADOW RD",
    "dropdelcty": "SENECA",
    "dropdelst": "PA",
    "dropdelzpp": 163469800,
    "dropphyadd": "130 MEADOW RD",
    "dropphycty": "SENECA",
    "dropphyst": "PA",
    "dropphyzpp": 163469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECA",
    "dropmalst": "PA",
    "dropmalzpp": 163469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146772015,
    "dropsitcph": 8146772015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A975",
    "droptype": "D",
    "dropname": "SEVEN VALLEYS",
    "dropdeladd": "63 CHURCH ST",
    "dropdelcty": "SEVEN VALLEYS",
    "dropdelst": "PA",
    "dropdelzpp": 173609998,
    "dropphyadd": "63 CHURCH ST",
    "dropphycty": "SEVEN VALLEYS",
    "dropphyst": "PA",
    "dropphyzpp": 173609998,
    "dropmaladd": "63 CHURCH ST",
    "dropmalcty": "SEVEN VALLEYS",
    "dropmalst": "PA",
    "dropmalzpp": 173609998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174281607,
    "dropsitcph": 7174281607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A978",
    "droptype": "D",
    "dropname": "SEWARD",
    "dropdeladd": "224 INDIANA ST",
    "dropdelcty": "SEWARD",
    "dropdelst": "PA",
    "dropdelzpp": 159549998,
    "dropphyadd": "224 INDIANA ST",
    "dropphycty": "SEWARD",
    "dropphyst": "PA",
    "dropphyzpp": 159549998,
    "dropmaladd": "224 INDIANA ST",
    "dropmalcty": "SEWARD",
    "dropmalst": "PA",
    "dropmalzpp": 159549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144466215,
    "dropsitcph": 8144466215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A979",
    "droptype": "D",
    "dropname": "SEWICKLEY",
    "dropdeladd": "521 THORN ST",
    "dropdelcty": "SEWICKLEY",
    "dropdelst": "PA",
    "dropdelzpp": 151439998,
    "dropphyadd": "521 THORN ST",
    "dropphycty": "SEWICKLEY",
    "dropphyst": "PA",
    "dropphyzpp": 151439998,
    "dropmaladd": "521 THORN ST",
    "dropmalcty": "SEWICKLEY",
    "dropmalst": "PA",
    "dropmalzpp": 151439998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127411925,
    "dropsitcph": 4127411925,
    "dropfax": 4127411691
  },
  {
    "dcode": "D",
    "dropkey": "PX1A981",
    "droptype": "D",
    "dropname": "SHADE GAP",
    "dropdeladd": "21379 MAIN ST",
    "dropdelcty": "SHADE GAP",
    "dropdelst": "PA",
    "dropdelzpp": 172559998,
    "dropphyadd": "21379 MAIN ST",
    "dropphycty": "SHADE GAP",
    "dropphyst": "PA",
    "dropphyzpp": 172559998,
    "dropmaladd": "21379 MAIN ST",
    "dropmalcty": "SHADE GAP",
    "dropmalst": "PA",
    "dropmalzpp": 172559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8142593435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A983",
    "droptype": "D",
    "dropname": "SHADY GROVE",
    "dropdeladd": "1814 BUCHANAN TRL E",
    "dropdelcty": "SHADY GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 172569998,
    "dropphyadd": "1814 BUCHANAN TRL E",
    "dropphycty": "SHADY GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 172569998,
    "dropmaladd": "1814 BUCHANAN TRL E",
    "dropmalcty": "SHADY GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 172569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175978532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A987",
    "droptype": "D",
    "dropname": "SHAMOKIN",
    "dropdeladd": "201 E INDEPENDENCE ST",
    "dropdelcty": "SHAMOKIN",
    "dropdelst": "PA",
    "dropdelzpp": 178729998,
    "dropphyadd": "201 E INDEPENDENCE ST",
    "dropphycty": "SHAMOKIN",
    "dropphyst": "PA",
    "dropphyzpp": 178729998,
    "dropmaladd": "201 E INDEPENDENCE ST",
    "dropmalcty": "SHAMOKIN",
    "dropmalst": "PA",
    "dropmalzpp": 178729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706484686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A988",
    "droptype": "D",
    "dropname": "SHAMOKIN DAM",
    "dropdeladd": "3054 N SUSQUEHANNA TRL",
    "dropdelcty": "SHAMOKIN DAM",
    "dropdelst": "PA",
    "dropdelzpp": 178769998,
    "dropphyadd": "3054 N SUSQUEHANNA TRL",
    "dropphycty": "SHAMOKIN DAM",
    "dropphyst": "PA",
    "dropphyzpp": 178769998,
    "dropmaladd": "3054 N SUSQUEHANNA TRL",
    "dropmalcty": "SHAMOKIN DAM",
    "dropmalst": "PA",
    "dropmalzpp": 178769998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707437820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A992",
    "droptype": "D",
    "dropname": "SHANKSVILLE",
    "dropdeladd": "442 STUTZMANTOWN RD",
    "dropdelcty": "SHANKSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 155609998,
    "dropphyadd": "442 STUTZMANTOWN RD",
    "dropphycty": "SHANKSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 155609998,
    "dropmaladd": "442 STUTZMANTOWN RD",
    "dropmalcty": "SHANKSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 155609998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142675312,
    "dropsitcph": 8142675312,
    "dropfax": 8144448201
  },
  {
    "dcode": "D",
    "dropkey": "PX1A993",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "120 SHENANGO AVE",
    "dropdelcty": "SHARON",
    "dropdelst": "PA",
    "dropdelzpp": 161469998,
    "dropphyadd": "120 SHENANGO AVE",
    "dropphycty": "SHARON",
    "dropphyst": "PA",
    "dropphyzpp": 161469998,
    "dropmaladd": "120 SHENANGO AVE",
    "dropmalcty": "SHARON",
    "dropmalst": "PA",
    "dropmalzpp": 161469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243475535,
    "dropsitcph": 7243475535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A994",
    "droptype": "D",
    "dropname": "SHARON HILL",
    "dropdeladd": "1198 CHESTER PIKE STE 1",
    "dropdelcty": "SHARON HILL",
    "dropdelst": "PA",
    "dropdelzpp": 190799998,
    "dropphyadd": "1198 CHESTER PIKE STE 1",
    "dropphycty": "SHARON HILL",
    "dropphyst": "PA",
    "dropphyzpp": 190799998,
    "dropmaladd": "1198 CHESTER PIKE STE 1",
    "dropmalcty": "SHARON HILL",
    "dropmalst": "PA",
    "dropmalzpp": 190799998,
    "dropsitphn": 6104615897,
    "dropsitlph": 6104615897,
    "dropsitcph": 6104615897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A996",
    "droptype": "D",
    "dropname": "SHARPSVILLE",
    "dropdeladd": "108 E SHENANGO ST",
    "dropdelcty": "SHARPSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 161502200,
    "dropphyadd": "108 E SHENANGO ST",
    "dropphycty": "SHARPSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 161502200,
    "dropmaladd": "108 E SHENANGO ST",
    "dropmalcty": "SHARPSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 161502200,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249627877,
    "dropsitcph": 7249627877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1A997",
    "droptype": "D",
    "dropname": "SHARTLESVILLE",
    "dropdeladd": "11 N 1ST ST",
    "dropdelcty": "SHARTLESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195549998,
    "dropphyadd": "11 N 1ST ST",
    "dropphycty": "SHARTLESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195549998,
    "dropmaladd": "11 N 1ST ST",
    "dropmalcty": "SHARTLESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195549998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6104889265,
    "dropsitcph": 6104889265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B005",
    "droptype": "D",
    "dropname": "SHAWNEE ON DELAWARE",
    "dropdeladd": "107 SHAWNEE SQUARE DR SE",
    "dropdelcty": "SHAWNEE ON DELAWARE",
    "dropdelst": "PA",
    "dropdelzpp": 183569998,
    "dropphyadd": "107 SHAWNEE SQUARE DR SE",
    "dropphycty": "SHAWNEE ON DELAWARE",
    "dropphyst": "PA",
    "dropphyzpp": 183569998,
    "dropmaladd": "107 SHAWNEE SQUARE DR SE",
    "dropmalcty": "SHAWNEE ON DELAWARE",
    "dropmalst": "PA",
    "dropmalzpp": 183569998,
    "dropsitphn": 5704760194,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704760194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B006",
    "droptype": "D",
    "dropname": "SHAWVILLE",
    "dropdeladd": "23 TROUT RUN RD",
    "dropdelcty": "SHAWVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 168739998,
    "dropphyadd": "23 TROUT RUN RD",
    "dropphycty": "SHAWVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 168739998,
    "dropmaladd": "23 TROUT RUN RD",
    "dropmalcty": "SHAWVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 168739998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147656423,
    "dropsitcph": 8147656423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B007",
    "droptype": "D",
    "dropname": "SHEAKLEYVILLE",
    "dropdeladd": "3216 PERRY HWY",
    "dropdelcty": "SHEAKLEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 161519800,
    "dropphyadd": "3216 PERRY HWY",
    "dropphycty": "SHEAKLEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 161519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEAKLEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 161519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242534332,
    "dropsitcph": 7242534332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B009",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "90 S MAIN ST",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 163479800,
    "dropphyadd": "90 S MAIN ST",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 163479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 163479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145605011,
    "dropsitcph": 8145605011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B011",
    "droptype": "D",
    "dropname": "SHELOCTA",
    "dropdeladd": "30 MAIN ST",
    "dropdelcty": "SHELOCTA",
    "dropdelst": "PA",
    "dropdelzpp": 157749998,
    "dropphyadd": "30 MAIN ST",
    "dropphycty": "SHELOCTA",
    "dropphyst": "PA",
    "dropphyzpp": 157749998,
    "dropmaladd": "30 MAIN ST",
    "dropmalcty": "SHELOCTA",
    "dropmalst": "PA",
    "dropmalzpp": 157749998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243542571,
    "dropsitcph": 7243542571,
    "dropfax": 7243543109
  },
  {
    "dcode": "D",
    "dropkey": "PX1B012",
    "droptype": "D",
    "dropname": "SHENANDOAH",
    "dropdeladd": "119 N WHITE ST",
    "dropdelcty": "SHENANDOAH",
    "dropdelst": "PA",
    "dropdelzpp": 179769998,
    "dropphyadd": "119 N WHITE ST",
    "dropphycty": "SHENANDOAH",
    "dropphyst": "PA",
    "dropphyzpp": 179769998,
    "dropmaladd": "119 N WHITE ST",
    "dropmalcty": "SHENANDOAH",
    "dropmalst": "PA",
    "dropmalzpp": 179769998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5704621554,
    "dropsitcph": 5704621554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B018",
    "droptype": "D",
    "dropname": "SHEPPTON",
    "dropdeladd": "928 CENTER ST",
    "dropdelcty": "SHEPPTON",
    "dropdelst": "PA",
    "dropdelzpp": 182489998,
    "dropphyadd": "928 CENTER ST",
    "dropphycty": "SHEPPTON",
    "dropphyst": "PA",
    "dropphyzpp": 182489998,
    "dropmaladd": "928 CENTER ST",
    "dropmalcty": "SHEPPTON",
    "dropmalst": "PA",
    "dropmalzpp": 182489998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703843734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B021",
    "droptype": "D",
    "dropname": "SHERMANS DALE",
    "dropdeladd": "5201 SPRING RD STE 4",
    "dropdelcty": "SHERMANS DALE",
    "dropdelst": "PA",
    "dropdelzpp": 170909998,
    "dropphyadd": "5201 SPRING RD STE 4",
    "dropphycty": "SHERMANS DALE",
    "dropphyst": "PA",
    "dropphyzpp": 170909998,
    "dropmaladd": "5201 SPRING RD STE 4",
    "dropmalcty": "SHERMANS DALE",
    "dropmalst": "PA",
    "dropmalzpp": 170909998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175824855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B022",
    "droptype": "D",
    "dropname": "SHICKSHINNY",
    "dropdeladd": "40 N CANAL ST",
    "dropdelcty": "SHICKSHINNY",
    "dropdelst": "PA",
    "dropdelzpp": 186559998,
    "dropphyadd": "40 N CANAL ST",
    "dropphycty": "SHICKSHINNY",
    "dropphyst": "PA",
    "dropphyzpp": 186559998,
    "dropmaladd": "40 N CANAL ST",
    "dropmalcty": "SHICKSHINNY",
    "dropmalst": "PA",
    "dropmalzpp": 186559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5705424425,
    "dropfax": 5705425680
  },
  {
    "dcode": "D",
    "dropkey": "PX1B027",
    "droptype": "D",
    "dropname": "SHINGLEHOUSE",
    "dropdeladd": "214 W ACADEMY ST",
    "dropdelcty": "SHINGLEHOUSE",
    "dropdelst": "PA",
    "dropdelzpp": 167489800,
    "dropphyadd": "214 W ACADEMY ST",
    "dropphycty": "SHINGLEHOUSE",
    "dropphyst": "PA",
    "dropphyzpp": 167489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHINGLEHOUSE",
    "dropmalst": "PA",
    "dropmalzpp": 167489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146977230,
    "dropsitcph": 8146977230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B031",
    "droptype": "D",
    "dropname": "SHIPPENSBURG",
    "dropdeladd": "46 W KING ST",
    "dropdelcty": "SHIPPENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172579998,
    "dropphyadd": "46 W KING ST",
    "dropphycty": "SHIPPENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172579998,
    "dropmaladd": "46 W KING ST",
    "dropmalcty": "SHIPPENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172579998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175322314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B032",
    "droptype": "D",
    "dropname": "SHIPPENVILLE",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "SHIPPENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162549800,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "SHIPPENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIPPENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147823761,
    "dropsitcph": 8147823761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B033",
    "droptype": "D",
    "dropname": "SHIPPINGPORT",
    "dropdeladd": "162 STATE ROUTE 3016",
    "dropdelcty": "SHIPPINGPORT",
    "dropdelst": "PA",
    "dropdelzpp": 150771001,
    "dropphyadd": "162 STATE ROUTE 3016",
    "dropphycty": "SHIPPINGPORT",
    "dropphyst": "PA",
    "dropphyzpp": 150771001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIPPINGPORT",
    "dropmalst": "PA",
    "dropmalzpp": 150779998,
    "dropsitphn": 7243597568,
    "dropsitlph": 7246439498,
    "dropsitcph": 7246439498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B036",
    "droptype": "D",
    "dropname": "SHIRLEYSBURG",
    "dropdeladd": "17084 CROGHAN PIKE",
    "dropdelcty": "SHIRLEYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172609998,
    "dropphyadd": "17084 CROGHAN PIKE",
    "dropphycty": "SHIRLEYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172609998,
    "dropmaladd": "17084 CROGHAN PIKE",
    "dropmalcty": "SHIRLEYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8144475539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B039",
    "droptype": "D",
    "dropname": "SHOEMAKERSVILLE",
    "dropdeladd": "511 FRANKLIN ST",
    "dropdelcty": "SHOEMAKERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195559998,
    "dropphyadd": "511 FRANKLIN ST",
    "dropphycty": "SHOEMAKERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195559998,
    "dropmaladd": "511 FRANKLIN ST",
    "dropmalcty": "SHOEMAKERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195559998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105624716,
    "dropsitcph": 6105624716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B042",
    "droptype": "D",
    "dropname": "SHOHOLA",
    "dropdeladd": "118 RICHARDSON AVE",
    "dropdelcty": "SHOHOLA",
    "dropdelst": "PA",
    "dropdelzpp": 184589998,
    "dropphyadd": "118 RICHARDSON AVE",
    "dropphycty": "SHOHOLA",
    "dropphyst": "PA",
    "dropphyzpp": 184589998,
    "dropmaladd": "118 RICHARDSON AVE",
    "dropmalcty": "SHOHOLA",
    "dropmalst": "PA",
    "dropmalzpp": 184589998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705597475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B049",
    "droptype": "D",
    "dropname": "SHREWSBURY",
    "dropdeladd": "50 CONSTITUTION AVE",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "PA",
    "dropdelzpp": 173619998,
    "dropphyadd": "50 CONSTITUTION AVE",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "PA",
    "dropphyzpp": 173619998,
    "dropmaladd": "50 CONSTITUTION AVE",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "PA",
    "dropmalzpp": 173619998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172353012,
    "dropsitcph": 7172353012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B051",
    "droptype": "D",
    "dropname": "SHUNK",
    "dropdeladd": "9922 ROUTE 154 STE 2",
    "dropdelcty": "SHUNK",
    "dropdelst": "PA",
    "dropdelzpp": 177689998,
    "dropphyadd": "9922 ROUTE 154 STE 2",
    "dropphycty": "SHUNK",
    "dropphyst": "PA",
    "dropphyzpp": 177689998,
    "dropmaladd": "9922 ROUTE 154 STE 2",
    "dropmalcty": "SHUNK",
    "dropmalst": "PA",
    "dropmalzpp": 177689998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5709243419,
    "dropfax": 5709244831
  },
  {
    "dcode": "D",
    "dropkey": "PX1B053",
    "droptype": "D",
    "dropname": "SIDMAN",
    "dropdeladd": "367 LOCUST ST STE 101",
    "dropdelcty": "SIDMAN",
    "dropdelst": "PA",
    "dropdelzpp": 159559998,
    "dropphyadd": "367 LOCUST ST STE 101",
    "dropphycty": "SIDMAN",
    "dropphyst": "PA",
    "dropphyzpp": 159559998,
    "dropmaladd": "367 LOCUST ST STE 101",
    "dropmalcty": "SIDMAN",
    "dropmalst": "PA",
    "dropmalzpp": 159559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144877868,
    "dropsitcph": 8144877868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B054",
    "droptype": "D",
    "dropname": "SIGEL",
    "dropdeladd": "8517 ROUTE 949",
    "dropdelcty": "SIGEL",
    "dropdelst": "PA",
    "dropdelzpp": 158609800,
    "dropphyadd": "8517 ROUTE 949",
    "dropphycty": "SIGEL",
    "dropphyst": "PA",
    "dropphyzpp": 158609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIGEL",
    "dropmalst": "PA",
    "dropmalzpp": 158609998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147522801,
    "dropsitcph": 8147522801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B061",
    "droptype": "D",
    "dropname": "SILVER SPRING",
    "dropdeladd": "3672 MARIETTA AVE",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "PA",
    "dropdelzpp": 175759998,
    "dropphyadd": "3672 MARIETTA AVE",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "PA",
    "dropphyzpp": 175759998,
    "dropmaladd": "3672 MARIETTA AVE",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "PA",
    "dropmalzpp": 175759998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172854013,
    "dropsitcph": 7172854013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B062",
    "droptype": "D",
    "dropname": "SILVERDALE",
    "dropdeladd": "141 E MAIN ST",
    "dropdelcty": "SILVERDALE",
    "dropdelst": "PA",
    "dropdelzpp": 189629998,
    "dropphyadd": "141 E MAIN ST",
    "dropphycty": "SILVERDALE",
    "dropphyst": "PA",
    "dropphyzpp": 189629998,
    "dropmaladd": "141 E MAIN ST",
    "dropmalcty": "SILVERDALE",
    "dropmalst": "PA",
    "dropmalzpp": 189629998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152577718,
    "dropsitcph": 2152577718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B068",
    "droptype": "D",
    "dropname": "SINNAMAHONING",
    "dropdeladd": "186 RAILROAD ST UNIT 2",
    "dropdelcty": "SINNAMAHONING",
    "dropdelst": "PA",
    "dropdelzpp": 158619800,
    "dropphyadd": "186 RAILROAD ST UNIT 2",
    "dropphycty": "SINNAMAHONING",
    "dropphyst": "PA",
    "dropphyzpp": 158619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SINNAMAHONING",
    "dropmalst": "PA",
    "dropmalzpp": 158619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145462014,
    "dropsitcph": 8145462014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B071",
    "droptype": "D",
    "dropname": "SIPESVILLE",
    "dropdeladd": "601 SIPESVILLE RD",
    "dropdelcty": "SIPESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 155619998,
    "dropphyadd": "601 SIPESVILLE RD",
    "dropphycty": "SIPESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 155619998,
    "dropmaladd": "601 SIPESVILLE RD",
    "dropmalcty": "SIPESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 155619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144458218,
    "dropsitcph": 8144458218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B072",
    "droptype": "D",
    "dropname": "SIX MILE RUN",
    "dropdeladd": "1384 MAIN ST",
    "dropdelcty": "SIX MILE RUN",
    "dropdelst": "PA",
    "dropdelzpp": 166799998,
    "dropphyadd": "1384 MAIN ST",
    "dropphycty": "SIX MILE RUN",
    "dropphyst": "PA",
    "dropphyzpp": 166799998,
    "dropmaladd": "1384 MAIN ST",
    "dropmalcty": "SIX MILE RUN",
    "dropmalst": "PA",
    "dropmalzpp": 166799998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149285034,
    "dropsitcph": 8149285034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B073",
    "droptype": "D",
    "dropname": "SKIPPACK",
    "dropdeladd": "3801 SKIPPACK PIKE",
    "dropdelcty": "SKIPPACK",
    "dropdelst": "PA",
    "dropdelzpp": 194749914,
    "dropphyadd": "3801 SKIPPACK PIKE",
    "dropphycty": "SKIPPACK",
    "dropphyst": "PA",
    "dropphyzpp": 194749914,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKIPPACK",
    "dropmalst": "PA",
    "dropmalzpp": 194749998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6105846275,
    "dropsitcph": 6105846275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B075",
    "droptype": "D",
    "dropname": "SKYTOP",
    "dropdeladd": "0 SKYTOP LDG",
    "dropdelcty": "SKYTOP",
    "dropdelst": "PA",
    "dropdelzpp": 183579998,
    "dropphyadd": "0 SKYTOP LDG",
    "dropphycty": "SKYTOP",
    "dropphyst": "PA",
    "dropphyzpp": 183579998,
    "dropmaladd": "0 SKYTOP LDG",
    "dropmalcty": "SKYTOP",
    "dropmalst": "PA",
    "dropmalzpp": 183579998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705957761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B078",
    "droptype": "D",
    "dropname": "SLATE RUN",
    "dropdeladd": "14167 ROUTE 414 HWY",
    "dropdelcty": "SLATE RUN",
    "dropdelst": "PA",
    "dropdelzpp": 177699998,
    "dropphyadd": "14167 ROUTE 414 HWY",
    "dropphycty": "SLATE RUN",
    "dropphyst": "PA",
    "dropphyzpp": 177699998,
    "dropmaladd": "14167 ROUTE 414 HWY",
    "dropmalcty": "SLATE RUN",
    "dropmalst": "PA",
    "dropmalzpp": 177699998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707533249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B079",
    "droptype": "D",
    "dropname": "SLATEDALE",
    "dropdeladd": "4016 MAIN ST",
    "dropdelcty": "SLATEDALE",
    "dropdelst": "PA",
    "dropdelzpp": 180799998,
    "dropphyadd": "4016 MAIN ST",
    "dropphycty": "SLATEDALE",
    "dropphyst": "PA",
    "dropphyzpp": 180799998,
    "dropmaladd": "4016 MAIN ST",
    "dropmalcty": "SLATEDALE",
    "dropmalst": "PA",
    "dropmalzpp": 180799998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107676011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B081",
    "droptype": "D",
    "dropname": "SLATINGTON",
    "dropdeladd": "605 MAIN ST",
    "dropdelcty": "SLATINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 180809998,
    "dropphyadd": "605 MAIN ST",
    "dropphycty": "SLATINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 180809998,
    "dropmaladd": "605 MAIN ST",
    "dropmalcty": "SLATINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 180809998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107672182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B082",
    "droptype": "D",
    "dropname": "SLICKVILLE",
    "dropdeladd": "124 MAIN ST",
    "dropdelcty": "SLICKVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 156842000,
    "dropphyadd": "124 MAIN ST",
    "dropphycty": "SLICKVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 156842000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLICKVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 156849998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244684505,
    "dropsitcph": 7244684505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B085",
    "droptype": "D",
    "dropname": "SLIGO",
    "dropdeladd": "312 MADISON ST",
    "dropdelcty": "SLIGO",
    "dropdelst": "PA",
    "dropdelzpp": 162559800,
    "dropphyadd": "312 MADISON ST",
    "dropphycty": "SLIGO",
    "dropphyst": "PA",
    "dropphyzpp": 162559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLIGO",
    "dropmalst": "PA",
    "dropmalzpp": 162559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147452524,
    "dropsitcph": 8147452524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B086",
    "droptype": "D",
    "dropname": "SLIPPERY ROCK",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "SLIPPERY ROCK",
    "dropdelst": "PA",
    "dropdelzpp": 160571200,
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "SLIPPERY ROCK",
    "dropphyst": "PA",
    "dropphyzpp": 160571200,
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "SLIPPERY ROCK",
    "dropmalst": "PA",
    "dropmalzpp": 160571200,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247948760,
    "dropsitcph": 7247948760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B087",
    "droptype": "D",
    "dropname": "SLOVAN",
    "dropdeladd": "105 SMITH PARK DR",
    "dropdelcty": "SLOVAN",
    "dropdelst": "PA",
    "dropdelzpp": 150781002,
    "dropphyadd": "105 SMITH PARK DR",
    "dropphycty": "SLOVAN",
    "dropphyst": "PA",
    "dropphyzpp": 150781002,
    "dropmaladd": "105 SMITH PARK DR",
    "dropmalcty": "SLOVAN",
    "dropmalst": "PA",
    "dropmalzpp": 150781002,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249473180,
    "dropsitcph": 7249473180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B088",
    "droptype": "D",
    "dropname": "SMETHPORT",
    "dropdeladd": "200 N MECHANIC ST",
    "dropdelcty": "SMETHPORT",
    "dropdelst": "PA",
    "dropdelzpp": 167491286,
    "dropphyadd": "200 N MECHANIC ST",
    "dropphycty": "SMETHPORT",
    "dropphyst": "PA",
    "dropphyzpp": 167491286,
    "dropmaladd": "200 N MECHANIC ST",
    "dropmalcty": "SMETHPORT",
    "dropmalst": "PA",
    "dropmalzpp": 167491286,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148875518,
    "dropsitcph": 8148875518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B089",
    "droptype": "D",
    "dropname": "SMICKSBURG",
    "dropdeladd": "148 MILL ST",
    "dropdelcty": "SMICKSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 162569800,
    "dropphyadd": "148 MILL ST",
    "dropphycty": "SMICKSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 162569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMICKSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 162569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142578190,
    "dropsitcph": 8142578190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B090",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "91 MAIN ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 154789998,
    "dropphyadd": "91 MAIN ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 154789998,
    "dropmaladd": "91 MAIN ST",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 154789998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245699141,
    "dropsitcph": 7245699141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B091",
    "droptype": "D",
    "dropname": "SMITHMILL",
    "dropdeladd": "726 WALNUT ST",
    "dropdelcty": "SMITHMILL",
    "dropdelst": "PA",
    "dropdelzpp": 166809998,
    "dropphyadd": "726 WALNUT ST",
    "dropphycty": "SMITHMILL",
    "dropphyst": "PA",
    "dropphyzpp": 166809998,
    "dropmaladd": "726 WALNUT ST",
    "dropmalcty": "SMITHMILL",
    "dropmalst": "PA",
    "dropmalzpp": 166809998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143786077,
    "dropsitcph": 8143786077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B092",
    "droptype": "D",
    "dropname": "SMITHTON",
    "dropdeladd": "222 2ND ST",
    "dropdelcty": "SMITHTON",
    "dropdelst": "PA",
    "dropdelzpp": 154791001,
    "dropphyadd": "222 2ND ST",
    "dropphycty": "SMITHTON",
    "dropphyst": "PA",
    "dropphyzpp": 154791001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHTON",
    "dropmalst": "PA",
    "dropmalzpp": 154799998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248727050,
    "dropsitcph": 7248727050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B094",
    "droptype": "D",
    "dropname": "SMOCK",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "SMOCK",
    "dropdelst": "PA",
    "dropdelzpp": 154801047,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "SMOCK",
    "dropphyst": "PA",
    "dropphyzpp": 154801047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMOCK",
    "dropmalst": "PA",
    "dropmalzpp": 154809998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246772280,
    "dropsitcph": 7246772280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B095",
    "droptype": "D",
    "dropname": "SMOKERUN",
    "dropdeladd": "6302 CROSS ROADS BLVD",
    "dropdelcty": "SMOKERUN",
    "dropdelst": "PA",
    "dropdelzpp": 166819998,
    "dropphyadd": "6302 CROSS ROADS BLVD",
    "dropphycty": "SMOKERUN",
    "dropphyst": "PA",
    "dropphyzpp": 166819998,
    "dropmaladd": "6302 CROSS ROADS BLVD",
    "dropmalcty": "SMOKERUN",
    "dropmalst": "PA",
    "dropmalzpp": 166819998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143785556,
    "dropsitcph": 8143785556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B097",
    "droptype": "D",
    "dropname": "SMOKETOWN",
    "dropdeladd": "2433 OLD PHILADELPHIA PIKE STE E",
    "dropdelcty": "SMOKETOWN",
    "dropdelst": "PA",
    "dropdelzpp": 175769998,
    "dropphyadd": "2433 OLD PHILADELPHIA PIKE STE E",
    "dropphycty": "SMOKETOWN",
    "dropphyst": "PA",
    "dropphyzpp": 175769998,
    "dropmaladd": "2433 OLD PHILADELPHIA PIKE STE E",
    "dropmalcty": "SMOKETOWN",
    "dropmalst": "PA",
    "dropmalzpp": 175769998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173944841,
    "dropsitcph": 7173944841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B101",
    "droptype": "D",
    "dropname": "SNOW SHOE",
    "dropdeladd": "105 S MOSHANNON AVE",
    "dropdelcty": "SNOW SHOE",
    "dropdelst": "PA",
    "dropdelzpp": 168749998,
    "dropphyadd": "105 S MOSHANNON AVE",
    "dropphycty": "SNOW SHOE",
    "dropphyst": "PA",
    "dropphyzpp": 168749998,
    "dropmaladd": "105 S MOSHANNON AVE",
    "dropmalcty": "SNOW SHOE",
    "dropmalst": "PA",
    "dropmalzpp": 168749998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143874522,
    "dropsitcph": 8143874522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B119",
    "droptype": "D",
    "dropname": "SOLEBURY",
    "dropdeladd": "2996 SUGAN RD",
    "dropdelcty": "SOLEBURY",
    "dropdelst": "PA",
    "dropdelzpp": 189639998,
    "dropphyadd": "2996 SUGAN RD",
    "dropphycty": "SOLEBURY",
    "dropphyst": "PA",
    "dropphyzpp": 189639998,
    "dropmaladd": "2996 SUGAN RD",
    "dropmalcty": "SOLEBURY",
    "dropmalst": "PA",
    "dropmalzpp": 189639998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152975503,
    "dropsitcph": 2152975503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B121",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "201 N CENTER AVE",
    "dropdelcty": "SOMERSET",
    "dropdelst": "PA",
    "dropdelzpp": 155019998,
    "dropphyadd": "201 N CENTER AVE",
    "dropphycty": "SOMERSET",
    "dropphyst": "PA",
    "dropphyzpp": 155019998,
    "dropmaladd": "201 N CENTER AVE",
    "dropmalcty": "SOMERSET",
    "dropmalst": "PA",
    "dropmalzpp": 155019998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144455600,
    "dropsitcph": 8144455600,
    "dropfax": 6505775789
  },
  {
    "dcode": "D",
    "dropkey": "PX1B128",
    "droptype": "D",
    "dropname": "SOUDERTON",
    "dropdeladd": "111 E BROAD ST",
    "dropdelcty": "SOUDERTON",
    "dropdelst": "PA",
    "dropdelzpp": 189641259,
    "dropphyadd": "111 E BROAD ST",
    "dropphycty": "SOUDERTON",
    "dropphyst": "PA",
    "dropphyzpp": 189641259,
    "dropmaladd": "111 E BROAD ST",
    "dropmalcty": "SOUDERTON",
    "dropmalst": "PA",
    "dropmalzpp": 189641259,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157232551,
    "dropsitcph": 2157232551,
    "dropfax": 2157230370
  },
  {
    "dcode": "D",
    "dropkey": "PX1B129",
    "droptype": "D",
    "dropname": "SOUTH CANAAN",
    "dropdeladd": "2159 EASTON TPKE UNIT 1",
    "dropdelcty": "SOUTH CANAAN",
    "dropdelst": "PA",
    "dropdelzpp": 184599998,
    "dropphyadd": "2159 EASTON TPKE UNIT 1",
    "dropphycty": "SOUTH CANAAN",
    "dropphyst": "PA",
    "dropphyzpp": 184599998,
    "dropmaladd": "2159 EASTON TPKE UNIT 1",
    "dropmalcty": "SOUTH CANAAN",
    "dropmalst": "PA",
    "dropmalzpp": 184599998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709374450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B135",
    "droptype": "D",
    "dropname": "SOUTH FORK",
    "dropdeladd": "331 MAPLE ST",
    "dropdelcty": "SOUTH FORK",
    "dropdelst": "PA",
    "dropdelzpp": 159569998,
    "dropphyadd": "331 MAPLE ST",
    "dropphycty": "SOUTH FORK",
    "dropphyst": "PA",
    "dropphyzpp": 159569998,
    "dropmaladd": "331 MAPLE ST",
    "dropmalcty": "SOUTH FORK",
    "dropmalst": "PA",
    "dropmalzpp": 159569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144954031,
    "dropsitcph": 8144954031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B136",
    "droptype": "D",
    "dropname": "SOUTH GIBSON",
    "dropdeladd": "8917 ROUTE 92",
    "dropdelcty": "SOUTH GIBSON",
    "dropdelst": "PA",
    "dropdelzpp": 188429998,
    "dropphyadd": "8917 ROUTE 92",
    "dropphycty": "SOUTH GIBSON",
    "dropphyst": "PA",
    "dropphyzpp": 188429998,
    "dropmaladd": "8917 ROUTE 92",
    "dropmalcty": "SOUTH GIBSON",
    "dropmalst": "PA",
    "dropmalzpp": 188429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702224922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B138",
    "droptype": "D",
    "dropname": "SOUTH HEIGHTS",
    "dropdeladd": "3963 JORDAN ST",
    "dropdelcty": "SOUTH HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 150811001,
    "dropphyadd": "3963 JORDAN ST",
    "dropphycty": "SOUTH HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 150811001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 150819998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243750373,
    "dropsitcph": 7243750373,
    "dropfax": 7243757064
  },
  {
    "dcode": "D",
    "dropkey": "PX1B145",
    "droptype": "D",
    "dropname": "SOUTH MONTROSE",
    "dropdeladd": "11187 STATE ROUTE 29",
    "dropdelcty": "SOUTH MONTROSE",
    "dropdelst": "PA",
    "dropdelzpp": 188439998,
    "dropphyadd": "11187 STATE ROUTE 29",
    "dropphycty": "SOUTH MONTROSE",
    "dropphyst": "PA",
    "dropphyzpp": 188439998,
    "dropmaladd": "11187 STATE ROUTE 29",
    "dropmalcty": "SOUTH MONTROSE",
    "dropmalst": "PA",
    "dropmalzpp": 188439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702781617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B146",
    "droptype": "D",
    "dropname": "SOUTH MOUNTAIN",
    "dropdeladd": "10444 S MOUNTAIN RD",
    "dropdelcty": "SOUTH MOUNTAIN",
    "dropdelst": "PA",
    "dropdelzpp": 172619998,
    "dropphyadd": "10444 S MOUNTAIN RD",
    "dropphycty": "SOUTH MOUNTAIN",
    "dropphyst": "PA",
    "dropphyzpp": 172619998,
    "dropmaladd": "10444 S MOUNTAIN RD",
    "dropmalcty": "SOUTH MOUNTAIN",
    "dropmalst": "PA",
    "dropmalzpp": 172619998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177495833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B155",
    "droptype": "D",
    "dropname": "SOUTHAMPTON",
    "dropdeladd": "1050 STREET RD",
    "dropdelcty": "SOUTHAMPTON",
    "dropdelst": "PA",
    "dropdelzpp": 189669998,
    "dropphyadd": "1050 STREET RD",
    "dropphycty": "SOUTHAMPTON",
    "dropphyst": "PA",
    "dropphyzpp": 189669998,
    "dropmaladd": "1050 STREET RD",
    "dropmalcty": "SOUTHAMPTON",
    "dropmalst": "PA",
    "dropmalzpp": 189669998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153576457,
    "dropsitcph": 2153576457,
    "dropfax": 2153967107
  },
  {
    "dcode": "D",
    "dropkey": "PX1B157",
    "droptype": "D",
    "dropname": "SOUTHEASTERN",
    "dropdeladd": "1000 W VALLEY RD",
    "dropdelcty": "SOUTHEASTERN",
    "dropdelst": "PA",
    "dropdelzpp": 193999998,
    "dropphyadd": "1000 W VALLEY RD",
    "dropphycty": "SOUTHEASTERN",
    "dropphyst": "PA",
    "dropphyzpp": 193999998,
    "dropmaladd": "1000 W VALLEY RD",
    "dropmalcty": "SOUTHEASTERN",
    "dropmalst": "PA",
    "dropmalzpp": 193999998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109646448,
    "dropsitcph": 6109646448,
    "dropfax": 6109645467
  },
  {
    "dcode": "D",
    "dropkey": "PX1B162",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "536 HECLA RD",
    "dropdelcty": "SOUTHWEST",
    "dropdelst": "PA",
    "dropdelzpp": 156851001,
    "dropphyadd": "536 HECLA RD",
    "dropphycty": "SOUTHWEST",
    "dropphyst": "PA",
    "dropphyzpp": 156851001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTHWEST",
    "dropmalst": "PA",
    "dropmalzpp": 156859998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244234665,
    "dropsitcph": 7244234665,
    "dropfax": 7244234665
  },
  {
    "dcode": "D",
    "dropkey": "PX1B163",
    "droptype": "D",
    "dropname": "SPANGLER",
    "dropdeladd": "1904 BIGLER AVE STE 2",
    "dropdelcty": "SPANGLER",
    "dropdelst": "PA",
    "dropdelzpp": 157759998,
    "dropphyadd": "1904 BIGLER AVE STE 2",
    "dropphycty": "SPANGLER",
    "dropphyst": "PA",
    "dropphyzpp": 157759998,
    "dropmaladd": "1904 BIGLER AVE STE 2",
    "dropmalcty": "SPANGLER",
    "dropmalst": "PA",
    "dropmalzpp": 157759998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149486333,
    "dropsitcph": 8149486333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B165",
    "droptype": "D",
    "dropname": "SPARTANSBURG",
    "dropdeladd": "258 MAIN ST",
    "dropdelcty": "SPARTANSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 164349800,
    "dropphyadd": "258 MAIN ST",
    "dropphycty": "SPARTANSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 164349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPARTANSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 164349998,
    "dropsitphn": 8146644911,
    "dropsitlph": 8146547163,
    "dropsitcph": 8146547163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B173",
    "droptype": "D",
    "dropname": "SPINNERSTOWN",
    "dropdeladd": "2191 SPINNERSTOWN RD",
    "dropdelcty": "SPINNERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189689998,
    "dropphyadd": "2191 SPINNERSTOWN RD",
    "dropphycty": "SPINNERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189689998,
    "dropmaladd": "2191 SPINNERSTOWN RD",
    "dropmalcty": "SPINNERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189689998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155364188,
    "dropsitcph": 2155364188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B176",
    "droptype": "D",
    "dropname": "SPRAGGS",
    "dropdeladd": "115 SPRAGGS RD",
    "dropdelcty": "SPRAGGS",
    "dropdelst": "PA",
    "dropdelzpp": 153629998,
    "dropphyadd": "115 SPRAGGS RD",
    "dropphycty": "SPRAGGS",
    "dropphyst": "PA",
    "dropphyzpp": 153629998,
    "dropmaladd": "115 SPRAGGS RD",
    "dropmalcty": "SPRAGGS",
    "dropmalst": "PA",
    "dropmalzpp": 153629998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244357684,
    "dropsitcph": 7244357684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B180",
    "droptype": "D",
    "dropname": "SPRING CHURCH",
    "dropdeladd": "1759 STATE ROUTE 56",
    "dropdelcty": "SPRING CHURCH",
    "dropdelst": "PA",
    "dropdelzpp": 156861052,
    "dropphyadd": "1759 STATE ROUTE 56",
    "dropphycty": "SPRING CHURCH",
    "dropphyst": "PA",
    "dropphyzpp": 156861052,
    "dropmaladd": "1759 STATE ROUTE 56",
    "dropmalcty": "SPRING CHURCH",
    "dropmalst": "PA",
    "dropmalzpp": 156861052,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244783687,
    "dropsitcph": 7244783687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B181",
    "droptype": "D",
    "dropname": "SPRING CITY",
    "dropdeladd": "124 NEW ST",
    "dropdelcty": "SPRING CITY",
    "dropdelst": "PA",
    "dropdelzpp": 194759998,
    "dropphyadd": "124 NEW ST",
    "dropphycty": "SPRING CITY",
    "dropphyst": "PA",
    "dropphyzpp": 194759998,
    "dropmaladd": "124 NEW ST",
    "dropmalcty": "SPRING CITY",
    "dropmalst": "PA",
    "dropmalzpp": 194759998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107925493,
    "dropsitcph": 6107925493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B182",
    "droptype": "D",
    "dropname": "SPRING CREEK",
    "dropdeladd": "185 OLD ROUTE 77",
    "dropdelcty": "SPRING CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 164369800,
    "dropphyadd": "185 OLD ROUTE 77",
    "dropphycty": "SPRING CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 164369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 164369998,
    "dropsitphn": 8146644911,
    "dropsitlph": 8146652255,
    "dropsitcph": 8146652255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B188",
    "droptype": "D",
    "dropname": "SPRING GLEN",
    "dropdeladd": "2636 W MAIN ST",
    "dropdelcty": "SPRING GLEN",
    "dropdelst": "PA",
    "dropdelzpp": 179789998,
    "dropphyadd": "2636 W MAIN ST",
    "dropphycty": "SPRING GLEN",
    "dropphyst": "PA",
    "dropphyzpp": 179789998,
    "dropmaladd": "2636 W MAIN ST",
    "dropmalcty": "SPRING GLEN",
    "dropmalst": "PA",
    "dropmalzpp": 179789998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706828272,
    "dropsitcph": 5706828272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B189",
    "droptype": "D",
    "dropname": "SPRING GROVE",
    "dropdeladd": "55 W JACKSON ST",
    "dropdelcty": "SPRING GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 173629998,
    "dropphyadd": "55 W JACKSON ST",
    "dropphycty": "SPRING GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 173629998,
    "dropmaladd": "55 W JACKSON ST",
    "dropmalcty": "SPRING GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 173629998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172253666,
    "dropsitcph": 7172253666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B192",
    "droptype": "D",
    "dropname": "SPRING MILLS",
    "dropdeladd": "136 SCHOOL ST",
    "dropdelcty": "SPRING MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 168759998,
    "dropphyadd": "136 SCHOOL ST",
    "dropphycty": "SPRING MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 168759998,
    "dropmaladd": "136 SCHOOL ST",
    "dropmalcty": "SPRING MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 168759998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144228789,
    "dropsitcph": 8144228789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B193",
    "droptype": "D",
    "dropname": "SPRING MOUNT",
    "dropdeladd": "1204 N GRAVEL PIKE",
    "dropdelcty": "ZIEGLERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194929717,
    "dropphyadd": "1204 N GRAVEL PIKE",
    "dropphycty": "ZIEGLERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194929717,
    "dropmaladd": "1204 N GRAVEL PIKE",
    "dropmalcty": "ZIEGLERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194929717,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102879532,
    "dropsitcph": 6102879532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B194",
    "droptype": "D",
    "dropname": "SPRING RUN",
    "dropdeladd": "16363 PATH VALLEY RD",
    "dropdelcty": "SPRING RUN",
    "dropdelst": "PA",
    "dropdelzpp": 172629998,
    "dropphyadd": "16363 PATH VALLEY RD",
    "dropphycty": "SPRING RUN",
    "dropphyst": "PA",
    "dropphyzpp": 172629998,
    "dropmaladd": "16363 PATH VALLEY RD",
    "dropmalcty": "SPRING RUN",
    "dropmalst": "PA",
    "dropmalzpp": 172629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173497544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B198",
    "droptype": "D",
    "dropname": "SPRINGBORO",
    "dropdeladd": "111 BEAVER ST",
    "dropdelcty": "SPRINGBORO",
    "dropdelst": "PA",
    "dropdelzpp": 164359800,
    "dropphyadd": "111 BEAVER ST",
    "dropphycty": "SPRINGBORO",
    "dropphyst": "PA",
    "dropphyzpp": 164359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGBORO",
    "dropmalst": "PA",
    "dropmalzpp": 164359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145872010,
    "dropsitcph": 8145872010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B199",
    "droptype": "D",
    "dropname": "SPRINGDALE",
    "dropdeladd": "896 PITTSBURGH ST",
    "dropdelcty": "SPRINGDALE",
    "dropdelst": "PA",
    "dropdelzpp": 151449998,
    "dropphyadd": "896 PITTSBURGH ST",
    "dropphycty": "SPRINGDALE",
    "dropphyst": "PA",
    "dropphyzpp": 151449998,
    "dropmaladd": "896 PITTSBURGH ST",
    "dropmalcty": "SPRINGDALE",
    "dropmalst": "PA",
    "dropmalzpp": 151449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242749490,
    "dropsitcph": 7242749490,
    "dropfax": 7242747238
  },
  {
    "dcode": "D",
    "dropkey": "PX1B207",
    "droptype": "D",
    "dropname": "SPRINGS",
    "dropdeladd": "1740 SPRINGS RD",
    "dropdelcty": "SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 155629998,
    "dropphyadd": "1740 SPRINGS RD",
    "dropphycty": "SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 155629998,
    "dropmaladd": "1740 SPRINGS RD",
    "dropmalcty": "SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 155629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146622690,
    "dropsitcph": 8146622690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B209",
    "droptype": "D",
    "dropname": "SPRINGTOWN",
    "dropdeladd": "3147 ROUTE 212",
    "dropdelcty": "SPRINGTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180819998,
    "dropphyadd": "3147 ROUTE 212",
    "dropphycty": "SPRINGTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180819998,
    "dropmaladd": "3147 ROUTE 212",
    "dropmalcty": "SPRINGTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180819998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103468133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B214",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "12180 STATE ROUTE 3004",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 188449998,
    "dropphyadd": "12180 STATE ROUTE 3004",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 188449998,
    "dropmaladd": "12180 STATE ROUTE 3004",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 188449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709652017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B218",
    "droptype": "D",
    "dropname": "SPRUCE CREEK",
    "dropdeladd": "5448 ISETT RD",
    "dropdelcty": "SPRUCE CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 166839998,
    "dropphyadd": "5448 ISETT RD",
    "dropphycty": "SPRUCE CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 166839998,
    "dropmaladd": "5448 ISETT RD",
    "dropmalcty": "SPRUCE CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 166839998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146328440,
    "dropsitcph": 8146328440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B308",
    "droptype": "D",
    "dropname": "STAHLSTOWN",
    "dropdeladd": "4145 MAIN ST",
    "dropdelcty": "STAHLSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 156871001,
    "dropphyadd": "4145 MAIN ST",
    "dropphycty": "STAHLSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 156871001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAHLSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 156879998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245932351,
    "dropsitcph": 7245932351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B312",
    "droptype": "D",
    "dropname": "STAR JUNCTION",
    "dropdeladd": "115 TONY ROW RD",
    "dropdelcty": "STAR JUNCTION",
    "dropdelst": "PA",
    "dropdelzpp": 154821001,
    "dropphyadd": "115 TONY ROW RD",
    "dropphycty": "STAR JUNCTION",
    "dropphyst": "PA",
    "dropphyzpp": 154821001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAR JUNCTION",
    "dropmalst": "PA",
    "dropmalzpp": 154829998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247362061,
    "dropsitcph": 7247362061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B313",
    "droptype": "D",
    "dropname": "STARFORD",
    "dropdeladd": "4218 STARFORD RD",
    "dropdelcty": "STARFORD",
    "dropdelst": "PA",
    "dropdelzpp": 157779998,
    "dropphyadd": "4218 STARFORD RD",
    "dropphycty": "STARFORD",
    "dropphyst": "PA",
    "dropphyzpp": 157779998,
    "dropmaladd": "4218 STARFORD RD",
    "dropmalcty": "STARFORD",
    "dropmalst": "PA",
    "dropmalzpp": 157779998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242549760,
    "dropsitcph": 7242549760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B317",
    "droptype": "D",
    "dropname": "STARRUCCA",
    "dropdeladd": "327 STARRUCCA CREEK RD STE 101",
    "dropdelcty": "STARRUCCA",
    "dropdelst": "PA",
    "dropdelzpp": 184629998,
    "dropphyadd": "327 STARRUCCA CREEK RD STE 101",
    "dropphycty": "STARRUCCA",
    "dropphyst": "PA",
    "dropphyzpp": 184629998,
    "dropmaladd": "327 STARRUCCA CREEK RD STE 101",
    "dropmalcty": "STARRUCCA",
    "dropmalst": "PA",
    "dropmalzpp": 184629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707272964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B319",
    "droptype": "D",
    "dropname": "STATE COLLEGE",
    "dropdeladd": "237 S FRASER ST",
    "dropdelcty": "STATE COLLEGE",
    "dropdelst": "PA",
    "dropdelzpp": 168019998,
    "dropphyadd": "237 S FRASER ST",
    "dropphycty": "STATE COLLEGE",
    "dropphyst": "PA",
    "dropphyzpp": 168019998,
    "dropmaladd": "237 S FRASER ST",
    "dropmalcty": "STATE COLLEGE",
    "dropmalst": "PA",
    "dropmalzpp": 168019998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142382435,
    "dropsitcph": 8142382435,
    "dropfax": 8142383015
  },
  {
    "dcode": "D",
    "dropkey": "PX1B327",
    "droptype": "D",
    "dropname": "STATE LINE",
    "dropdeladd": "15753 PENNSYLVANIA AVE S",
    "dropdelcty": "STATE LINE",
    "dropdelst": "PA",
    "dropdelzpp": 172639800,
    "dropphyadd": "15753 PENNSYLVANIA AVE S",
    "dropphycty": "STATE LINE",
    "dropphyst": "PA",
    "dropphyzpp": 172639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STATE LINE",
    "dropmalst": "PA",
    "dropmalzpp": 172639998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175972240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B353",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "617 STERLING RD",
    "dropdelcty": "STERLING",
    "dropdelst": "PA",
    "dropdelzpp": 184639998,
    "dropphyadd": "617 STERLING RD",
    "dropphycty": "STERLING",
    "dropphyst": "PA",
    "dropphyzpp": 184639998,
    "dropmaladd": "617 STERLING RD",
    "dropmalcty": "STERLING",
    "dropmalst": "PA",
    "dropmalzpp": 184639998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706897510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B354",
    "droptype": "D",
    "dropname": "STEVENS",
    "dropdeladd": "16 S LINE RD",
    "dropdelcty": "STEVENS",
    "dropdelst": "PA",
    "dropdelzpp": 175789998,
    "dropphyadd": "16 S LINE RD",
    "dropphycty": "STEVENS",
    "dropphyst": "PA",
    "dropphyzpp": 175789998,
    "dropmaladd": "16 S LINE RD",
    "dropmalcty": "STEVENS",
    "dropmalst": "PA",
    "dropmalzpp": 175789998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173366724,
    "dropsitcph": 7173366724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B355",
    "droptype": "D",
    "dropname": "STEVENSVILLE",
    "dropdeladd": "8979 ROUTE 706",
    "dropdelcty": "STEVENSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 188459998,
    "dropphyadd": "8979 ROUTE 706",
    "dropphycty": "STEVENSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 188459998,
    "dropmaladd": "8979 ROUTE 706",
    "dropmalcty": "STEVENSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 188459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707461694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B358",
    "droptype": "D",
    "dropname": "STEWARTSTOWN",
    "dropdeladd": "18 N MAIN ST",
    "dropdelcty": "STEWARTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173639998,
    "dropphyadd": "18 N MAIN ST",
    "dropphycty": "STEWARTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173639998,
    "dropmaladd": "18 N MAIN ST",
    "dropmalcty": "STEWARTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173639998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179936288,
    "dropsitcph": 7179936288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B362",
    "droptype": "D",
    "dropname": "STOCKDALE",
    "dropdeladd": "398 RAILROAD ST",
    "dropdelcty": "STOCKDALE",
    "dropdelst": "PA",
    "dropdelzpp": 154831001,
    "dropphyadd": "398 RAILROAD ST",
    "dropphycty": "STOCKDALE",
    "dropphyst": "PA",
    "dropphyzpp": 154831001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKDALE",
    "dropmalst": "PA",
    "dropmalzpp": 154839998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249382422,
    "dropsitcph": 7249382422,
    "dropfax": 7249382422
  },
  {
    "dcode": "D",
    "dropkey": "PX1B363",
    "droptype": "D",
    "dropname": "STOCKERTOWN",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "STOCKERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180839900,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "STOCKERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180839900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180839998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107596278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B366",
    "droptype": "D",
    "dropname": "STONEBORO",
    "dropdeladd": "40 LINDEN ST",
    "dropdelcty": "STONEBORO",
    "dropdelst": "PA",
    "dropdelzpp": 161539800,
    "dropphyadd": "40 LINDEN ST",
    "dropphycty": "STONEBORO",
    "dropphyst": "PA",
    "dropphyzpp": 161539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONEBORO",
    "dropmalst": "PA",
    "dropmalzpp": 161539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243743532,
    "dropsitcph": 7243743532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B383",
    "droptype": "D",
    "dropname": "STOYSTOWN",
    "dropdeladd": "209 W MAIN ST",
    "dropdelcty": "STOYSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 155639998,
    "dropphyadd": "209 W MAIN ST",
    "dropphycty": "STOYSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 155639998,
    "dropmaladd": "209 W MAIN ST",
    "dropmalcty": "STOYSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 155639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148935007,
    "dropsitcph": 8148935007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B384",
    "droptype": "D",
    "dropname": "STRABANE",
    "dropdeladd": "218 LATIMER AVE",
    "dropdelcty": "STRABANE",
    "dropdelst": "PA",
    "dropdelzpp": 153631001,
    "dropphyadd": "218 LATIMER AVE",
    "dropphycty": "STRABANE",
    "dropphyst": "PA",
    "dropphyzpp": 153631001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRABANE",
    "dropmalst": "PA",
    "dropmalzpp": 153639998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247451530,
    "dropsitcph": 7247451530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B387",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "200 HISTORIC DR",
    "dropdelcty": "STRASBURG",
    "dropdelst": "PA",
    "dropdelzpp": 175799998,
    "dropphyadd": "200 HISTORIC DR",
    "dropphycty": "STRASBURG",
    "dropphyst": "PA",
    "dropphyzpp": 175799998,
    "dropmaladd": "200 HISTORIC DR",
    "dropmalcty": "STRASBURG",
    "dropmalst": "PA",
    "dropmalzpp": 175799998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176873942,
    "dropsitcph": 7176873942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B388",
    "droptype": "D",
    "dropname": "STRATTANVILLE",
    "dropdeladd": "361 WASHINGTON ST",
    "dropdelcty": "STRATTANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162589800,
    "dropphyadd": "361 WASHINGTON ST",
    "dropphycty": "STRATTANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATTANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162589998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147643718,
    "dropsitcph": 8147643718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B389",
    "droptype": "D",
    "dropname": "STRAUSSTOWN",
    "dropdeladd": "72 MAIN ST",
    "dropdelcty": "STRAUSSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195599998,
    "dropphyadd": "72 MAIN ST",
    "dropphycty": "STRAUSSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195599998,
    "dropmaladd": "72 MAIN ST",
    "dropmalcty": "STRAUSSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195599998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6104881009,
    "dropsitcph": 6104881009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B400",
    "droptype": "D",
    "dropname": "STROUDSBURG",
    "dropdeladd": "701 ANN ST",
    "dropdelcty": "STROUDSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 183609998,
    "dropphyadd": "701 ANN ST",
    "dropphycty": "STROUDSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 183609998,
    "dropmaladd": "701 ANN ST",
    "dropmalcty": "STROUDSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 183609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704214250,
    "dropfax": 5704212172
  },
  {
    "dcode": "D",
    "dropkey": "PX1B401",
    "droptype": "D",
    "dropname": "STUMP CREEK",
    "dropdeladd": "6871 ROUTE 119",
    "dropdelcty": "STUMP CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 158639800,
    "dropphyadd": "6871 ROUTE 119",
    "dropphycty": "STUMP CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 158639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STUMP CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 158639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144272962,
    "dropsitcph": 8144272962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B402",
    "droptype": "D",
    "dropname": "STURGEON",
    "dropdeladd": "507 MAIN ST",
    "dropdelcty": "STURGEON",
    "dropdelst": "PA",
    "dropdelzpp": 150821001,
    "dropphyadd": "507 MAIN ST",
    "dropphycty": "STURGEON",
    "dropphyst": "PA",
    "dropphyzpp": 150821001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STURGEON",
    "dropmalst": "PA",
    "dropmalzpp": 150829998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249262590,
    "dropsitcph": 7249262590,
    "dropfax": 7249262590
  },
  {
    "dcode": "D",
    "dropkey": "PX1B405",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "14 ABBOTT ST",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 163509800,
    "dropphyadd": "14 ABBOTT ST",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 163509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 163509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144897823,
    "dropsitcph": 8144897823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B407",
    "droptype": "D",
    "dropname": "SUGAR RUN",
    "dropdeladd": "4873 SR 187",
    "dropdelcty": "SUGAR RUN",
    "dropdelst": "PA",
    "dropdelzpp": 188469998,
    "dropphyadd": "4873 SR 187",
    "dropphycty": "SUGAR RUN",
    "dropphyst": "PA",
    "dropphyzpp": 188469998,
    "dropmaladd": "4873 SR 187",
    "dropmalcty": "SUGAR RUN",
    "dropmalst": "PA",
    "dropmalzpp": 188469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707461151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B409",
    "droptype": "D",
    "dropname": "SUGARLOAF",
    "dropdeladd": "627 TOMHICKEN RD",
    "dropdelcty": "SUGARLOAF",
    "dropdelst": "PA",
    "dropdelzpp": 182499998,
    "dropphyadd": "627 TOMHICKEN RD",
    "dropphycty": "SUGARLOAF",
    "dropphyst": "PA",
    "dropphyzpp": 182499998,
    "dropmaladd": "627 TOMHICKEN RD",
    "dropmalcty": "SUGARLOAF",
    "dropmalst": "PA",
    "dropmalzpp": 182499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707884585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B412",
    "droptype": "D",
    "dropname": "SUMMERDALE",
    "dropdeladd": "202 3RD ST",
    "dropdelcty": "SUMMERDALE",
    "dropdelst": "PA",
    "dropdelzpp": 170939998,
    "dropphyadd": "202 3RD ST",
    "dropphycty": "SUMMERDALE",
    "dropphyst": "PA",
    "dropphyzpp": 170939998,
    "dropmaladd": "202 3RD ST",
    "dropmalcty": "SUMMERDALE",
    "dropmalst": "PA",
    "dropmalzpp": 170939998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177323408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B413",
    "droptype": "D",
    "dropname": "SUMMERHILL",
    "dropdeladd": "1314 RAILROAD ST",
    "dropdelcty": "SUMMERHILL",
    "dropdelst": "PA",
    "dropdelzpp": 159589998,
    "dropphyadd": "1314 RAILROAD ST",
    "dropphycty": "SUMMERHILL",
    "dropphyst": "PA",
    "dropphyzpp": 159589998,
    "dropmaladd": "1314 RAILROAD ST",
    "dropmalcty": "SUMMERHILL",
    "dropmalst": "PA",
    "dropmalzpp": 159589998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144954911,
    "dropsitcph": 8144954911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B414",
    "droptype": "D",
    "dropname": "SUMMERVILLE",
    "dropdeladd": "170 STATE ST",
    "dropdelcty": "SUMMERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 158649800,
    "dropphyadd": "170 STATE ST",
    "dropphycty": "SUMMERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 158649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 158649998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148562213,
    "dropsitcph": 8148562213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B416",
    "droptype": "D",
    "dropname": "SUMMIT HILL",
    "dropdeladd": "200 N MARKET ST",
    "dropdelcty": "SUMMIT HILL",
    "dropdelst": "PA",
    "dropdelzpp": 182509998,
    "dropphyadd": "200 N MARKET ST",
    "dropphycty": "SUMMIT HILL",
    "dropphyst": "PA",
    "dropphyzpp": 182509998,
    "dropmaladd": "200 N MARKET ST",
    "dropmalcty": "SUMMIT HILL",
    "dropmalst": "PA",
    "dropmalzpp": 182509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706459655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B419",
    "droptype": "D",
    "dropname": "SUMMIT STATION",
    "dropdeladd": "5 SPRING RD",
    "dropdelcty": "SUMMIT STATION",
    "dropdelst": "PA",
    "dropdelzpp": 179799998,
    "dropphyadd": "5 SPRING RD",
    "dropphycty": "SUMMIT STATION",
    "dropphyst": "PA",
    "dropphyzpp": 179799998,
    "dropmaladd": "5 SPRING RD",
    "dropmalcty": "SUMMIT STATION",
    "dropmalst": "PA",
    "dropmalzpp": 179799998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5707547728,
    "dropsitcph": 5707547728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B420",
    "droptype": "D",
    "dropname": "SUMNEYTOWN",
    "dropdeladd": "3196 MAIN ST",
    "dropdelcty": "SUMNEYTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180849998,
    "dropphyadd": "3196 MAIN ST",
    "dropphycty": "SUMNEYTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180849998,
    "dropmaladd": "3196 MAIN ST",
    "dropmalcty": "SUMNEYTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180849998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2152348886,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B423",
    "droptype": "D",
    "dropname": "SUNBURY",
    "dropdeladd": "135 N 3RD ST",
    "dropdelcty": "SUNBURY",
    "dropdelst": "PA",
    "dropdelzpp": 178019998,
    "dropphyadd": "135 N 3RD ST",
    "dropphycty": "SUNBURY",
    "dropphyst": "PA",
    "dropphyzpp": 178019998,
    "dropmaladd": "135 N 3RD ST",
    "dropmalcty": "SUNBURY",
    "dropmalst": "PA",
    "dropmalzpp": 178019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5702867176,
    "dropfax": 5702862522
  },
  {
    "dcode": "D",
    "dropkey": "PX1B433",
    "droptype": "D",
    "dropname": "SUSQUEHANNA",
    "dropdeladd": "1186 MAIN ST",
    "dropdelcty": "SUSQUEHANNA",
    "dropdelst": "PA",
    "dropdelzpp": 188479998,
    "dropphyadd": "1186 MAIN ST",
    "dropphycty": "SUSQUEHANNA",
    "dropphyst": "PA",
    "dropphyzpp": 188479998,
    "dropmaladd": "1186 MAIN ST",
    "dropmalcty": "SUSQUEHANNA",
    "dropmalst": "PA",
    "dropmalzpp": 188479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708533168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B435",
    "droptype": "D",
    "dropname": "SUTERSVILLE",
    "dropdeladd": "141 3RD AVE",
    "dropdelcty": "SUTERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 150839998,
    "dropphyadd": "141 3RD AVE",
    "dropphycty": "SUTERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 150839998,
    "dropmaladd": "141 3RD AVE",
    "dropmalcty": "SUTERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 150839998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248729490,
    "dropsitcph": 7248729490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B440",
    "droptype": "D",
    "dropname": "SWARTHMORE",
    "dropdeladd": "105 RUTGERS AVE",
    "dropdelcty": "SWARTHMORE",
    "dropdelst": "PA",
    "dropdelzpp": 190819998,
    "dropphyadd": "105 RUTGERS AVE",
    "dropphycty": "SWARTHMORE",
    "dropphyst": "PA",
    "dropphyzpp": 190819998,
    "dropmaladd": "105 RUTGERS AVE",
    "dropmalcty": "SWARTHMORE",
    "dropmalst": "PA",
    "dropmalzpp": 190819998,
    "dropsitphn": 6105442133,
    "dropsitlph": 6105434420,
    "dropsitcph": 6105442133,
    "dropfax": 6105436925
  },
  {
    "dcode": "D",
    "dropkey": "PX1B449",
    "droptype": "D",
    "dropname": "SWEET VALLEY",
    "dropdeladd": "5319 MAIN RD",
    "dropdelcty": "SWEET VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 186569998,
    "dropphyadd": "5319 MAIN RD",
    "dropphycty": "SWEET VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 186569998,
    "dropmaladd": "5319 MAIN RD",
    "dropmalcty": "SWEET VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 186569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704775543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B451",
    "droptype": "D",
    "dropname": "SWENGEL",
    "dropdeladd": "1501 ORCHARD RD",
    "dropdelcty": "SWENGEL",
    "dropdelst": "PA",
    "dropdelzpp": 178809998,
    "dropphyadd": "1501 ORCHARD RD",
    "dropphycty": "SWENGEL",
    "dropphyst": "PA",
    "dropphyzpp": 178809998,
    "dropmaladd": "1501 ORCHARD RD",
    "dropmalcty": "SWENGEL",
    "dropmalst": "PA",
    "dropmalzpp": 178809998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709224600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B452",
    "droptype": "D",
    "dropname": "SWIFTWATER",
    "dropdeladd": "296 UPPER SWIFTWATER RD",
    "dropdelcty": "SWIFTWATER",
    "dropdelst": "PA",
    "dropdelzpp": 183709900,
    "dropphyadd": "296 UPPER SWIFTWATER RD",
    "dropphycty": "SWIFTWATER",
    "dropphyst": "PA",
    "dropphyzpp": 183709900,
    "dropmaladd": "296 UPPER SWIFTWATER RD",
    "dropmalcty": "SWIFTWATER",
    "dropmalst": "PA",
    "dropmalzpp": 183709900,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708398317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B462",
    "droptype": "D",
    "dropname": "SYBERTSVILLE",
    "dropdeladd": "41 N MAIN ST",
    "dropdelcty": "SYBERTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 182519998,
    "dropphyadd": "41 N MAIN ST",
    "dropphycty": "SYBERTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 182519998,
    "dropmaladd": "41 N MAIN ST",
    "dropmalcty": "SYBERTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 182519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707886259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B465",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "123 WW RAILROAD RD",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "PA",
    "dropdelzpp": 153641001,
    "dropphyadd": "123 WW RAILROAD RD",
    "dropphycty": "SYCAMORE",
    "dropphyst": "PA",
    "dropphyzpp": 153641001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "PA",
    "dropmalzpp": 153649998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246279744,
    "dropsitcph": 7246279744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B466",
    "droptype": "D",
    "dropname": "SYKESVILLE",
    "dropdeladd": "14 W MAIN ST",
    "dropdelcty": "SYKESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 158651080,
    "dropphyadd": "14 W MAIN ST",
    "dropphycty": "SYKESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 158651080,
    "dropmaladd": "14 W MAIN ST",
    "dropmalcty": "SYKESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 158651080,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148945471,
    "dropsitcph": 8148945471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B469",
    "droptype": "D",
    "dropname": "SYLVANIA",
    "dropdeladd": "2345 SYLVANIA RD",
    "dropdelcty": "SYLVANIA",
    "dropdelst": "PA",
    "dropdelzpp": 169459998,
    "dropphyadd": "2345 SYLVANIA RD",
    "dropphycty": "SYLVANIA",
    "dropphyst": "PA",
    "dropphyzpp": 169459998,
    "dropmaladd": "2345 SYLVANIA RD",
    "dropmalcty": "SYLVANIA",
    "dropmalst": "PA",
    "dropmalzpp": 169459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 7172974422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B477",
    "droptype": "D",
    "dropname": "TAFTON",
    "dropdeladd": "287 ROUTE 507",
    "dropdelcty": "TAFTON",
    "dropdelst": "PA",
    "dropdelzpp": 184649998,
    "dropphyadd": "287 ROUTE 507",
    "dropphycty": "TAFTON",
    "dropphyst": "PA",
    "dropphyzpp": 184649998,
    "dropmaladd": "287 ROUTE 507",
    "dropmalcty": "TAFTON",
    "dropmalst": "PA",
    "dropmalzpp": 184649998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702263085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B478",
    "droptype": "D",
    "dropname": "TALMAGE",
    "dropdeladd": "247 S STATE ST",
    "dropdelcty": "TALMAGE",
    "dropdelst": "PA",
    "dropdelzpp": 175809998,
    "dropphyadd": "247 S STATE ST",
    "dropphycty": "TALMAGE",
    "dropphyst": "PA",
    "dropphyzpp": 175809998,
    "dropmaladd": "247 S STATE ST",
    "dropmalcty": "TALMAGE",
    "dropmalst": "PA",
    "dropmalzpp": 175809998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176135131,
    "dropsitcph": 7176135131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B480",
    "droptype": "D",
    "dropname": "TAMAQUA",
    "dropdeladd": "399 E BROAD ST",
    "dropdelcty": "TAMAQUA",
    "dropdelst": "PA",
    "dropdelzpp": 182529998,
    "dropphyadd": "399 E BROAD ST",
    "dropphycty": "TAMAQUA",
    "dropphyst": "PA",
    "dropphyzpp": 182529998,
    "dropmaladd": "399 E BROAD ST",
    "dropmalcty": "TAMAQUA",
    "dropmalst": "PA",
    "dropmalzpp": 182529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706680770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B482",
    "droptype": "D",
    "dropname": "TANNERSVILLE",
    "dropdeladd": "2937 ROUTE 611",
    "dropdelcty": "TANNERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 183729998,
    "dropphyadd": "2937 ROUTE 611",
    "dropphycty": "TANNERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 183729998,
    "dropmaladd": "2937 ROUTE 611",
    "dropmalcty": "TANNERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 183729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706290351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B485",
    "droptype": "D",
    "dropname": "TARENTUM",
    "dropdeladd": "708 CORBET ST",
    "dropdelcty": "TARENTUM",
    "dropdelst": "PA",
    "dropdelzpp": 150849998,
    "dropphyadd": "708 CORBET ST",
    "dropphycty": "TARENTUM",
    "dropphyst": "PA",
    "dropphyzpp": 150849998,
    "dropmaladd": "708 CORBET ST",
    "dropmalcty": "TARENTUM",
    "dropmalst": "PA",
    "dropmalzpp": 150849998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242245087,
    "dropsitcph": 7242245087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B486",
    "droptype": "D",
    "dropname": "TARRS",
    "dropdeladd": "980 ROUTE 31",
    "dropdelcty": "TARRS",
    "dropdelst": "PA",
    "dropdelzpp": 156881001,
    "dropphyadd": "980 ROUTE 31",
    "dropphycty": "TARRS",
    "dropphyst": "PA",
    "dropphyzpp": 156881001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TARRS",
    "dropmalst": "PA",
    "dropmalzpp": 156889998,
    "dropsitphn": 4123597960,
    "dropsitlph": 7246964010,
    "dropsitcph": 7246964010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B487",
    "droptype": "D",
    "dropname": "TATAMY",
    "dropdeladd": "423 BROAD ST",
    "dropdelcty": "TATAMY",
    "dropdelst": "PA",
    "dropdelzpp": 180859998,
    "dropphyadd": "423 BROAD ST",
    "dropphycty": "TATAMY",
    "dropphyst": "PA",
    "dropphyzpp": 180859998,
    "dropmaladd": "423 BROAD ST",
    "dropmalcty": "TATAMY",
    "dropmalst": "PA",
    "dropmalzpp": 180859998,
    "dropsitphn": 6102582122,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102582122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B489",
    "droptype": "D",
    "dropname": "TAYLORSTOWN",
    "dropdeladd": "56 MAIN ST",
    "dropdelcty": "TAYLORSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 153651001,
    "dropphyadd": "56 MAIN ST",
    "dropphycty": "TAYLORSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 153651001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLORSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 153659998,
    "dropsitphn": 4123597960,
    "dropsitlph": 7249483530,
    "dropsitcph": 7249483530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B491",
    "droptype": "D",
    "dropname": "TELFORD",
    "dropdeladd": "99 S 4TH ST",
    "dropdelcty": "TELFORD",
    "dropdelst": "PA",
    "dropdelzpp": 189699998,
    "dropphyadd": "99 S 4TH ST",
    "dropphycty": "TELFORD",
    "dropphyst": "PA",
    "dropphyzpp": 189699998,
    "dropmaladd": "99 S 4TH ST",
    "dropmalcty": "TELFORD",
    "dropmalst": "PA",
    "dropmalzpp": 189699998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157232551,
    "dropsitcph": 2157232551,
    "dropfax": 2157230370
  },
  {
    "dcode": "D",
    "dropkey": "PX1B493",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "4917 KUTZTOWN RD",
    "dropdelcty": "TEMPLE",
    "dropdelst": "PA",
    "dropdelzpp": 195609998,
    "dropphyadd": "4917 KUTZTOWN RD",
    "dropphycty": "TEMPLE",
    "dropphyst": "PA",
    "dropphyzpp": 195609998,
    "dropmaladd": "4917 KUTZTOWN RD",
    "dropmalcty": "TEMPLE",
    "dropmalst": "PA",
    "dropmalzpp": 195609998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109291469,
    "dropsitcph": 6109291469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B494",
    "droptype": "D",
    "dropname": "TEMPLETON",
    "dropdeladd": "232 3RD ST STE 1",
    "dropdelcty": "TEMPLETON",
    "dropdelst": "PA",
    "dropdelzpp": 162599800,
    "dropphyadd": "232 3RD ST STE 1",
    "dropphycty": "TEMPLETON",
    "dropphyst": "PA",
    "dropphyzpp": 162599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEMPLETON",
    "dropmalst": "PA",
    "dropmalzpp": 162599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248682711,
    "dropsitcph": 7248682711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B496",
    "droptype": "D",
    "dropname": "TERRE HILL",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "TERRE HILL",
    "dropdelst": "PA",
    "dropdelzpp": 175819998,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "TERRE HILL",
    "dropphyst": "PA",
    "dropphyzpp": 175819998,
    "dropmaladd": "104 W MAIN ST",
    "dropmalcty": "TERRE HILL",
    "dropmalst": "PA",
    "dropmalzpp": 175819998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176856562,
    "dropsitcph": 7176856562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B501",
    "droptype": "D",
    "dropname": "THOMASVILLE",
    "dropdeladd": "5285 LINCOLN HWY W",
    "dropdelcty": "THOMASVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173649998,
    "dropphyadd": "5285 LINCOLN HWY W",
    "dropphycty": "THOMASVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173649998,
    "dropmaladd": "5285 LINCOLN HWY W",
    "dropmalcty": "THOMASVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173649998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177921471,
    "dropsitcph": 7177921471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B504",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "412 JACKSON ST",
    "dropdelcty": "THOMPSON",
    "dropdelst": "PA",
    "dropdelzpp": 184659998,
    "dropphyadd": "412 JACKSON ST",
    "dropphycty": "THOMPSON",
    "dropphyst": "PA",
    "dropphyzpp": 184659998,
    "dropmaladd": "412 JACKSON ST",
    "dropmalcty": "THOMPSON",
    "dropmalst": "PA",
    "dropmalzpp": 184659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707272522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B505",
    "droptype": "D",
    "dropname": "THOMPSONTOWN",
    "dropdeladd": "40 N MILL ST",
    "dropdelcty": "THOMPSONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170949998,
    "dropphyadd": "40 N MILL ST",
    "dropphycty": "THOMPSONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170949998,
    "dropmaladd": "40 N MILL ST",
    "dropmalcty": "THOMPSONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170949998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175355141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B510",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "378 GLEN MILLS RD",
    "dropdelcty": "THORNTON",
    "dropdelst": "PA",
    "dropdelzpp": 193739998,
    "dropphyadd": "378 GLEN MILLS RD",
    "dropphycty": "THORNTON",
    "dropphyst": "PA",
    "dropphyzpp": 193739998,
    "dropmaladd": "378 GLEN MILLS RD",
    "dropmalcty": "THORNTON",
    "dropmalst": "PA",
    "dropmalzpp": 193739998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104599548,
    "dropsitcph": 6104599548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B511",
    "droptype": "D",
    "dropname": "THREE SPRINGS",
    "dropdeladd": "20675 FREEDOM ST",
    "dropdelcty": "THREE SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 172649998,
    "dropphyadd": "20675 FREEDOM ST",
    "dropphycty": "THREE SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 172649998,
    "dropmaladd": "20675 FREEDOM ST",
    "dropmalcty": "THREE SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 172649998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8144482840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B513",
    "droptype": "D",
    "dropname": "TIDIOUTE",
    "dropdeladd": "160 MAIN ST",
    "dropdelcty": "TIDIOUTE",
    "dropdelst": "PA",
    "dropdelzpp": 163511000,
    "dropphyadd": "160 MAIN ST",
    "dropphycty": "TIDIOUTE",
    "dropphyst": "PA",
    "dropphyzpp": 163511000,
    "dropmaladd": "160 MAIN ST",
    "dropmalcty": "TIDIOUTE",
    "dropmalst": "PA",
    "dropmalzpp": 163511000,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144843477,
    "dropsitcph": 8144843477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B515",
    "droptype": "D",
    "dropname": "TIMBLIN",
    "dropdeladd": "9 E MARKET ST",
    "dropdelcty": "TIMBLIN",
    "dropdelst": "PA",
    "dropdelzpp": 157789998,
    "dropphyadd": "9 E MARKET ST",
    "dropphycty": "TIMBLIN",
    "dropphyst": "PA",
    "dropphyzpp": 157789998,
    "dropmaladd": "9 E MARKET ST",
    "dropmalcty": "TIMBLIN",
    "dropmalst": "PA",
    "dropmalzpp": 157789998,
    "dropsitphn": 8149386120,
    "dropsitlph": 8142563336,
    "dropsitcph": 8142563336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B519",
    "droptype": "D",
    "dropname": "TIOGA",
    "dropdeladd": "34 N MAIN ST",
    "dropdelcty": "TIOGA",
    "dropdelst": "PA",
    "dropdelzpp": 169469998,
    "dropphyadd": "34 N MAIN ST",
    "dropphycty": "TIOGA",
    "dropphyst": "PA",
    "dropphyzpp": 169469998,
    "dropmaladd": "34 N MAIN ST",
    "dropmalcty": "TIOGA",
    "dropmalst": "PA",
    "dropmalzpp": 169469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 5708355262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B520",
    "droptype": "D",
    "dropname": "TIONA",
    "dropdeladd": "25 6 MILE RD",
    "dropdelcty": "TIONA",
    "dropdelst": "PA",
    "dropdelzpp": 163529800,
    "dropphyadd": "25 6 MILE RD",
    "dropphycty": "TIONA",
    "dropphyst": "PA",
    "dropphyzpp": 163529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIONA",
    "dropmalst": "PA",
    "dropmalzpp": 163529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147263509,
    "dropsitcph": 8147263509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B521",
    "droptype": "D",
    "dropname": "TIONESTA",
    "dropdeladd": "115 FAULKNER DR",
    "dropdelcty": "TIONESTA",
    "dropdelst": "PA",
    "dropdelzpp": 163539800,
    "dropphyadd": "115 FAULKNER DR",
    "dropphycty": "TIONESTA",
    "dropphyst": "PA",
    "dropphyzpp": 163539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIONESTA",
    "dropmalst": "PA",
    "dropmalzpp": 163539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147553534,
    "dropsitcph": 8147553534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B522",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "663 FOREST ST",
    "dropdelcty": "TIPTON",
    "dropdelst": "PA",
    "dropdelzpp": 166849998,
    "dropphyadd": "663 FOREST ST",
    "dropphycty": "TIPTON",
    "dropphyst": "PA",
    "dropphyzpp": 166849998,
    "dropmaladd": "663 FOREST ST",
    "dropmalcty": "TIPTON",
    "dropmalst": "PA",
    "dropmalzpp": 166849998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146843527,
    "dropsitcph": 8146843527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B523",
    "droptype": "D",
    "dropname": "TIRE HILL",
    "dropdeladd": "1969 KRING ST",
    "dropdelcty": "TIRE HILL",
    "dropdelst": "PA",
    "dropdelzpp": 159599998,
    "dropphyadd": "1969 KRING ST",
    "dropphycty": "TIRE HILL",
    "dropphyst": "PA",
    "dropphyzpp": 159599998,
    "dropmaladd": "1969 KRING ST",
    "dropmalcty": "TIRE HILL",
    "dropmalst": "PA",
    "dropmalzpp": 159599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142885324,
    "dropsitcph": 8142885324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B524",
    "droptype": "D",
    "dropname": "TITUSVILLE",
    "dropdeladd": "135 W SPRING ST",
    "dropdelcty": "TITUSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163541700,
    "dropphyadd": "135 W SPRING ST",
    "dropphycty": "TITUSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163541700,
    "dropmaladd": "135 W SPRING ST",
    "dropmalcty": "TITUSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163541700,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148276114,
    "dropsitcph": 8148276114,
    "dropfax": 8148276158
  },
  {
    "dcode": "D",
    "dropkey": "PX1B527",
    "droptype": "D",
    "dropname": "TOBYHANNA",
    "dropdeladd": "659 MAIN ST",
    "dropdelcty": "TOBYHANNA",
    "dropdelst": "PA",
    "dropdelzpp": 184669998,
    "dropphyadd": "659 MAIN ST",
    "dropphycty": "TOBYHANNA",
    "dropphyst": "PA",
    "dropphyzpp": 184669998,
    "dropmaladd": "659 MAIN ST",
    "dropmalcty": "TOBYHANNA",
    "dropmalst": "PA",
    "dropmalzpp": 184669998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708948211,
    "dropfax": 5708940448
  },
  {
    "dcode": "D",
    "dropkey": "PX1B534",
    "droptype": "D",
    "dropname": "TOPTON",
    "dropdeladd": "33 S HOME AVE",
    "dropdelcty": "TOPTON",
    "dropdelst": "PA",
    "dropdelzpp": 195629998,
    "dropphyadd": "33 S HOME AVE",
    "dropphycty": "TOPTON",
    "dropphyst": "PA",
    "dropphyzpp": 195629998,
    "dropmaladd": "33 S HOME AVE",
    "dropmalcty": "TOPTON",
    "dropmalst": "PA",
    "dropmalzpp": 195629998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106822077,
    "dropsitcph": 6106822077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B535",
    "droptype": "D",
    "dropname": "TORRANCE",
    "dropdeladd": "565 TORRANCE RD",
    "dropdelcty": "TORRANCE",
    "dropdelst": "PA",
    "dropdelzpp": 157799998,
    "dropphyadd": "565 TORRANCE RD",
    "dropphycty": "TORRANCE",
    "dropphyst": "PA",
    "dropphyzpp": 157799998,
    "dropmaladd": "565 TORRANCE RD",
    "dropmalcty": "TORRANCE",
    "dropmalst": "PA",
    "dropmalzpp": 157799998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244598409,
    "dropsitcph": 7244598409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B539",
    "droptype": "D",
    "dropname": "TOUGHKENAMON",
    "dropdeladd": "155 CENTER ST",
    "dropdelcty": "TOUGHKENAMON",
    "dropdelst": "PA",
    "dropdelzpp": 193749998,
    "dropphyadd": "155 CENTER ST",
    "dropphycty": "TOUGHKENAMON",
    "dropphyst": "PA",
    "dropphyzpp": 193749998,
    "dropmaladd": "155 CENTER ST",
    "dropmalcty": "TOUGHKENAMON",
    "dropmalst": "PA",
    "dropmalzpp": 193749998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102682962,
    "dropsitcph": 6102682962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B540",
    "droptype": "D",
    "dropname": "TOWANDA",
    "dropdeladd": "700 MAIN ST",
    "dropdelcty": "TOWANDA",
    "dropdelst": "PA",
    "dropdelzpp": 188489998,
    "dropphyadd": "700 MAIN ST",
    "dropphycty": "TOWANDA",
    "dropphyst": "PA",
    "dropphyzpp": 188489998,
    "dropmaladd": "700 MAIN ST",
    "dropmalcty": "TOWANDA",
    "dropmalst": "PA",
    "dropmalzpp": 188489998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702655922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B541",
    "droptype": "D",
    "dropname": "TOWER CITY",
    "dropdeladd": "544 E GRAND AVE",
    "dropdelcty": "TOWER CITY",
    "dropdelst": "PA",
    "dropdelzpp": 179809998,
    "dropphyadd": "544 E GRAND AVE",
    "dropphycty": "TOWER CITY",
    "dropphyst": "PA",
    "dropphyzpp": 179809998,
    "dropmaladd": "544 E GRAND AVE",
    "dropmalcty": "TOWER CITY",
    "dropmalst": "PA",
    "dropmalzpp": 179809998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176479921,
    "dropsitcph": 7176479921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B545",
    "droptype": "D",
    "dropname": "TOWNVILLE",
    "dropdeladd": "33432 N MAIN ST",
    "dropdelcty": "TOWNVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163609800,
    "dropphyadd": "33432 N MAIN ST",
    "dropphycty": "TOWNVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163609800,
    "dropmaladd": "33432 N MAIN ST",
    "dropmalcty": "TOWNVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163609800,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149673232,
    "dropsitcph": 8149673232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B546",
    "droptype": "D",
    "dropname": "TRAFFORD",
    "dropdeladd": "411 CAVITT AVE",
    "dropdelcty": "TRAFFORD",
    "dropdelst": "PA",
    "dropdelzpp": 150859998,
    "dropphyadd": "411 CAVITT AVE",
    "dropphycty": "TRAFFORD",
    "dropphyst": "PA",
    "dropphyzpp": 150859998,
    "dropmaladd": "411 CAVITT AVE",
    "dropmalcty": "TRAFFORD",
    "dropmalst": "PA",
    "dropmalzpp": 150859998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123728560,
    "dropsitcph": 4123728560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B548",
    "droptype": "D",
    "dropname": "TRANSFER",
    "dropdeladd": "3676 N HERMITAGE RD STE 5",
    "dropdelcty": "TRANSFER",
    "dropdelst": "PA",
    "dropdelzpp": 161549800,
    "dropphyadd": "3676 N HERMITAGE RD STE 5",
    "dropphycty": "TRANSFER",
    "dropphyst": "PA",
    "dropphyzpp": 161549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRANSFER",
    "dropmalst": "PA",
    "dropmalzpp": 161549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246460177,
    "dropsitcph": 7246460177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B551",
    "droptype": "D",
    "dropname": "TREICHLERS",
    "dropdeladd": "331 E BREADFRUIT DR",
    "dropdelcty": "TREICHLERS",
    "dropdelst": "PA",
    "dropdelzpp": 180869900,
    "dropphyadd": "331 E BREADFRUIT DR",
    "dropphycty": "TREICHLERS",
    "dropphyst": "PA",
    "dropphyzpp": 180869900,
    "dropmaladd": "331 E BREADFRUIT DR",
    "dropmalcty": "TREICHLERS",
    "dropmalst": "PA",
    "dropmalzpp": 180869900,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107671831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B552",
    "droptype": "D",
    "dropname": "TREMONT",
    "dropdeladd": "11 W MAIN ST",
    "dropdelcty": "TREMONT",
    "dropdelst": "PA",
    "dropdelzpp": 179819998,
    "dropphyadd": "11 W MAIN ST",
    "dropphycty": "TREMONT",
    "dropphyst": "PA",
    "dropphyzpp": 179819998,
    "dropmaladd": "11 W MAIN ST",
    "dropmalcty": "TREMONT",
    "dropmalst": "PA",
    "dropmalzpp": 179819998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706953321,
    "dropsitcph": 5706953321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B554",
    "droptype": "D",
    "dropname": "TRESCKOW",
    "dropdeladd": "5 E MARKET ST",
    "dropdelcty": "TRESCKOW",
    "dropdelst": "PA",
    "dropdelzpp": 182549998,
    "dropphyadd": "5 E MARKET ST",
    "dropphycty": "TRESCKOW",
    "dropphyst": "PA",
    "dropphyzpp": 182549998,
    "dropmaladd": "5 E MARKET ST",
    "dropmalcty": "TRESCKOW",
    "dropmalst": "PA",
    "dropmalzpp": 182549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704592598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B555",
    "droptype": "D",
    "dropname": "TREVORTON",
    "dropdeladd": "801 W SHAMOKIN ST LOWR",
    "dropdelcty": "TREVORTON",
    "dropdelst": "PA",
    "dropdelzpp": 178819998,
    "dropphyadd": "801 W SHAMOKIN ST LOWR",
    "dropphycty": "TREVORTON",
    "dropphyst": "PA",
    "dropphyzpp": 178819998,
    "dropmaladd": "801 W SHAMOKIN ST LOWR",
    "dropmalcty": "TREVORTON",
    "dropmalst": "PA",
    "dropmalzpp": 178819998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707978482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B558",
    "droptype": "D",
    "dropname": "TREXLERTOWN",
    "dropdeladd": "7150 HAMILTON BLVD OFC",
    "dropdelcty": "TREXLERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180879998,
    "dropphyadd": "7150 HAMILTON BLVD OFC",
    "dropphycty": "TREXLERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180879998,
    "dropmaladd": "7150 HAMILTON BLVD OFC",
    "dropmalcty": "TREXLERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180879998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103955111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B562",
    "droptype": "D",
    "dropname": "TROUT RUN",
    "dropdeladd": "67 MAIN ST",
    "dropdelcty": "TROUT RUN",
    "dropdelst": "PA",
    "dropdelzpp": 177719998,
    "dropphyadd": "67 MAIN ST",
    "dropphycty": "TROUT RUN",
    "dropphyst": "PA",
    "dropphyzpp": 177719998,
    "dropmaladd": "67 MAIN ST",
    "dropmalcty": "TROUT RUN",
    "dropmalst": "PA",
    "dropmalzpp": 177719998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5709982896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B564",
    "droptype": "D",
    "dropname": "TROXELVILLE",
    "dropdeladd": "8891 ROUTE 235",
    "dropdelcty": "TROXELVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178829998,
    "dropphyadd": "8891 ROUTE 235",
    "dropphycty": "TROXELVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178829998,
    "dropmaladd": "8891 ROUTE 235",
    "dropmalcty": "TROXELVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178829998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706582121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B565",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "416 CANTON ST",
    "dropdelcty": "TROY",
    "dropdelst": "PA",
    "dropdelzpp": 169479998,
    "dropphyadd": "416 CANTON ST",
    "dropphycty": "TROY",
    "dropphyst": "PA",
    "dropphyzpp": 169479998,
    "dropmaladd": "416 CANTON ST",
    "dropmalcty": "TROY",
    "dropmalst": "PA",
    "dropmalzpp": 169479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5702973345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B570",
    "droptype": "D",
    "dropname": "TRUMBAUERSVILLE",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "TRUMBAUERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189709998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "TRUMBAUERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189709998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "TRUMBAUERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189709998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155360841,
    "dropsitcph": 2155360841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B575",
    "droptype": "D",
    "dropname": "TUNKHANNOCK",
    "dropdeladd": "109 BRIDGE ST",
    "dropdelcty": "TUNKHANNOCK",
    "dropdelst": "PA",
    "dropdelzpp": 186579998,
    "dropphyadd": "109 BRIDGE ST",
    "dropphycty": "TUNKHANNOCK",
    "dropphyst": "PA",
    "dropphyzpp": 186579998,
    "dropmaladd": "109 BRIDGE ST",
    "dropmalcty": "TUNKHANNOCK",
    "dropmalst": "PA",
    "dropmalzpp": 186579998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708362875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B577",
    "droptype": "D",
    "dropname": "TURBOTVILLE",
    "dropdeladd": "4745 STATE ROUTE 54",
    "dropdelcty": "TURBOTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177729998,
    "dropphyadd": "4745 STATE ROUTE 54",
    "dropphycty": "TURBOTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177729998,
    "dropmaladd": "4745 STATE ROUTE 54",
    "dropmalcty": "TURBOTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706495335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B578",
    "droptype": "D",
    "dropname": "TURKEY CITY",
    "dropdeladd": "1245 ROUTE 338 STE 2",
    "dropdelcty": "TURKEY CITY",
    "dropdelst": "PA",
    "dropdelzpp": 160589800,
    "dropphyadd": "1245 ROUTE 338 STE 2",
    "dropphycty": "TURKEY CITY",
    "dropphyst": "PA",
    "dropphyzpp": 160589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURKEY CITY",
    "dropmalst": "PA",
    "dropmalzpp": 160589998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147972094,
    "dropsitcph": 8147972094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B581",
    "droptype": "D",
    "dropname": "TURTLE CREEK",
    "dropdeladd": "116 GRANT ST",
    "dropdelcty": "TURTLE CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 151459998,
    "dropphyadd": "116 GRANT ST",
    "dropphycty": "TURTLE CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 151459998,
    "dropmaladd": "116 GRANT ST",
    "dropmalcty": "TURTLE CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 151459998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128242309,
    "dropsitcph": 4128242309,
    "dropfax": 4128240157
  },
  {
    "dcode": "D",
    "dropkey": "PX1B583",
    "droptype": "D",
    "dropname": "TURTLEPOINT",
    "dropdeladd": "1787 CHAMPLIN HILL RD UNIT 2",
    "dropdelcty": "TURTLEPOINT",
    "dropdelst": "PA",
    "dropdelzpp": 167509800,
    "dropphyadd": "1787 CHAMPLIN HILL RD UNIT 2",
    "dropphycty": "TURTLEPOINT",
    "dropphyst": "PA",
    "dropphyzpp": 167509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURTLEPOINT",
    "dropmalst": "PA",
    "dropmalzpp": 167509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146422096,
    "dropsitcph": 8146422096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B587",
    "droptype": "D",
    "dropname": "TUSCARORA",
    "dropdeladd": "505 STRAWBERRY ST",
    "dropdelcty": "TUSCARORA",
    "dropdelst": "PA",
    "dropdelzpp": 179829998,
    "dropphyadd": "505 STRAWBERRY ST",
    "dropphycty": "TUSCARORA",
    "dropphyst": "PA",
    "dropphyzpp": 179829998,
    "dropmaladd": "505 STRAWBERRY ST",
    "dropmalcty": "TUSCARORA",
    "dropmalst": "PA",
    "dropmalzpp": 179829998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706681884,
    "dropsitcph": 5706681884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B592",
    "droptype": "D",
    "dropname": "TWIN ROCKS",
    "dropdeladd": "997 STATION RD",
    "dropdelcty": "TWIN ROCKS",
    "dropdelst": "PA",
    "dropdelzpp": 159609998,
    "dropphyadd": "997 STATION RD",
    "dropphycty": "TWIN ROCKS",
    "dropphyst": "PA",
    "dropphyzpp": 159609998,
    "dropmaladd": "997 STATION RD",
    "dropmalcty": "TWIN ROCKS",
    "dropmalst": "PA",
    "dropmalzpp": 159609998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147497533,
    "dropsitcph": 8147497533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B593",
    "droptype": "D",
    "dropname": "TYLER HILL",
    "dropdeladd": "1080 COCHECTON TPKE",
    "dropdelcty": "TYLER HILL",
    "dropdelst": "PA",
    "dropdelzpp": 184699998,
    "dropphyadd": "1080 COCHECTON TPKE",
    "dropphycty": "TYLER HILL",
    "dropphyst": "PA",
    "dropphyzpp": 184699998,
    "dropmaladd": "1080 COCHECTON TPKE",
    "dropmalcty": "TYLER HILL",
    "dropmalst": "PA",
    "dropmalzpp": 184699998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702244739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B595",
    "droptype": "D",
    "dropname": "TYLERSBURG",
    "dropdeladd": "8206 ROUTE 36",
    "dropdelcty": "TYLERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 163619800,
    "dropphyadd": "8206 ROUTE 36",
    "dropphycty": "TYLERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 163619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYLERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 163619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147449281,
    "dropsitcph": 8147449281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B596",
    "droptype": "D",
    "dropname": "TYLERSPORT",
    "dropdeladd": "139 RIDGE RD",
    "dropdelcty": "TYLERSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 189719998,
    "dropphyadd": "139 RIDGE RD",
    "dropphycty": "TYLERSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 189719998,
    "dropmaladd": "139 RIDGE RD",
    "dropmalcty": "TYLERSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 189719998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152575261,
    "dropsitcph": 2152575261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B599",
    "droptype": "D",
    "dropname": "TYRONE",
    "dropdeladd": "1071 PENNSYLVANIA AVE",
    "dropdelcty": "TYRONE",
    "dropdelst": "PA",
    "dropdelzpp": 166869998,
    "dropphyadd": "1071 PENNSYLVANIA AVE",
    "dropphycty": "TYRONE",
    "dropphyst": "PA",
    "dropphyzpp": 166869998,
    "dropmaladd": "1071 PENNSYLVANIA AVE",
    "dropmalcty": "TYRONE",
    "dropmalst": "PA",
    "dropmalzpp": 166869998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146840330,
    "dropsitcph": 8146840330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B602",
    "droptype": "D",
    "dropname": "ULEDI",
    "dropdeladd": "100 RAINEY RD",
    "dropdelcty": "ULEDI",
    "dropdelst": "PA",
    "dropdelzpp": 154841001,
    "dropphyadd": "100 RAINEY RD",
    "dropphycty": "ULEDI",
    "dropphyst": "PA",
    "dropphyzpp": 154841001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ULEDI",
    "dropmalst": "PA",
    "dropmalzpp": 154849998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244392180,
    "dropsitcph": 7244392180,
    "dropfax": 7244392180
  },
  {
    "dcode": "D",
    "dropkey": "PX1B603",
    "droptype": "D",
    "dropname": "ULSTER",
    "dropdeladd": "23848 ROUTE 220",
    "dropdelcty": "ULSTER",
    "dropdelst": "PA",
    "dropdelzpp": 188509998,
    "dropphyadd": "23848 ROUTE 220",
    "dropphycty": "ULSTER",
    "dropphyst": "PA",
    "dropphyzpp": 188509998,
    "dropmaladd": "23848 ROUTE 220",
    "dropmalcty": "ULSTER",
    "dropmalst": "PA",
    "dropmalzpp": 188509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703583404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B604",
    "droptype": "D",
    "dropname": "ULYSSES",
    "dropdeladd": "408 N MAIN ST",
    "dropdelcty": "ULYSSES",
    "dropdelst": "PA",
    "dropdelzpp": 169489998,
    "dropphyadd": "408 N MAIN ST",
    "dropphycty": "ULYSSES",
    "dropphyst": "PA",
    "dropphyzpp": 169489998,
    "dropmaladd": "408 N MAIN ST",
    "dropmalcty": "ULYSSES",
    "dropmalst": "PA",
    "dropmalzpp": 169489998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8148487505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B615",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "90 N MAIN ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "PA",
    "dropdelzpp": 164381000,
    "dropphyadd": "90 N MAIN ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "PA",
    "dropphyzpp": 164381000,
    "dropmaladd": "90 N MAIN ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "PA",
    "dropmalzpp": 164381000,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144382611,
    "dropsitcph": 8144382611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B616",
    "droptype": "D",
    "dropname": "UNION DALE",
    "dropdeladd": "924 S MAIN ST",
    "dropdelcty": "UNION DALE",
    "dropdelst": "PA",
    "dropdelzpp": 184709998,
    "dropphyadd": "924 S MAIN ST",
    "dropphycty": "UNION DALE",
    "dropphyst": "PA",
    "dropphyzpp": 184709998,
    "dropmaladd": "924 S MAIN ST",
    "dropmalcty": "UNION DALE",
    "dropmalst": "PA",
    "dropmalzpp": 184709998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706792152,
    "dropfax": 5706799452
  },
  {
    "dcode": "D",
    "dropkey": "PX1B624",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "47 E FAYETTE ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154019998,
    "dropphyadd": "47 E FAYETTE ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154019998,
    "dropmaladd": "47 E FAYETTE ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154019998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244382523,
    "dropsitcph": 7244382523,
    "dropfax": 7244384927
  },
  {
    "dcode": "D",
    "dropkey": "PX1B626",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "1752 W DOE RUN RD",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193759998,
    "dropphyadd": "1752 W DOE RUN RD",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193759998,
    "dropmaladd": "1752 W DOE RUN RD",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193759998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103472067,
    "dropsitcph": 6103472067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B627",
    "droptype": "D",
    "dropname": "UNITED",
    "dropdeladd": "1103 UNITED WAY",
    "dropdelcty": "UNITED",
    "dropdelst": "PA",
    "dropdelzpp": 156891001,
    "dropphyadd": "1103 UNITED WAY",
    "dropphycty": "UNITED",
    "dropphyst": "PA",
    "dropphyzpp": 156891001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNITED",
    "dropmalst": "PA",
    "dropmalzpp": 156899998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244233147,
    "dropsitcph": 7244233147,
    "dropfax": 7244233147
  },
  {
    "dcode": "D",
    "dropkey": "PX1B629",
    "droptype": "D",
    "dropname": "UNITYVILLE",
    "dropdeladd": "215 TALMAR RD",
    "dropdelcty": "UNITYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177749998,
    "dropphyadd": "215 TALMAR RD",
    "dropphycty": "UNITYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177749998,
    "dropmaladd": "215 TALMAR RD",
    "dropmalcty": "UNITYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177749998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5704584692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B640",
    "droptype": "D",
    "dropname": "UPPER BLACK EDDY",
    "dropdeladd": "1704 FIREHOUSE LN",
    "dropdelcty": "UPPER BLACK EDDY",
    "dropdelst": "PA",
    "dropdelzpp": 189729998,
    "dropphyadd": "1704 FIREHOUSE LN",
    "dropphycty": "UPPER BLACK EDDY",
    "dropphyst": "PA",
    "dropphyzpp": 189729998,
    "dropmaladd": "1704 FIREHOUSE LN",
    "dropmalcty": "UPPER BLACK EDDY",
    "dropmalst": "PA",
    "dropmalzpp": 189729998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109825720,
    "dropsitcph": 6109825720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B642",
    "droptype": "D",
    "dropname": "UPPER DARBY",
    "dropdeladd": "201 BYWOOD AVE",
    "dropdelcty": "UPPER DARBY",
    "dropdelst": "PA",
    "dropdelzpp": 190829998,
    "dropphyadd": "201 BYWOOD AVE",
    "dropphycty": "UPPER DARBY",
    "dropphyst": "PA",
    "dropphyzpp": 190829998,
    "dropmaladd": "201 BYWOOD AVE",
    "dropmalcty": "UPPER DARBY",
    "dropmalst": "PA",
    "dropmalzpp": 190829998,
    "dropsitphn": 6103525490,
    "dropsitlph": 6103525490,
    "dropsitcph": 6103525490,
    "dropfax": 6103520705
  },
  {
    "dcode": "D",
    "dropkey": "PX1B658",
    "droptype": "D",
    "dropname": "UPPERSTRASBURG",
    "dropdeladd": "9808 UPPER STRASBURG RD",
    "dropdelcty": "UPPERSTRASBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172659998,
    "dropphyadd": "9808 UPPER STRASBURG RD",
    "dropphycty": "UPPERSTRASBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172659998,
    "dropmaladd": "9808 UPPER STRASBURG RD",
    "dropmalcty": "UPPERSTRASBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175302078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B671",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "3838 ACADEMY ST",
    "dropdelcty": "UTICA",
    "dropdelst": "PA",
    "dropdelzpp": 163629800,
    "dropphyadd": "3838 ACADEMY ST",
    "dropphycty": "UTICA",
    "dropphyst": "PA",
    "dropphyzpp": 163629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UTICA",
    "dropmalst": "PA",
    "dropmalzpp": 163629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144253498,
    "dropsitcph": 8144253498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B672",
    "droptype": "D",
    "dropname": "UWCHLAND",
    "dropdeladd": "101 FELLOWSHIP RD",
    "dropdelcty": "UWCHLAND",
    "dropdelst": "PA",
    "dropdelzpp": 194809998,
    "dropphyadd": "101 FELLOWSHIP RD",
    "dropphycty": "UWCHLAND",
    "dropphyst": "PA",
    "dropphyzpp": 194809998,
    "dropmaladd": "101 FELLOWSHIP RD",
    "dropmalcty": "UWCHLAND",
    "dropmalst": "PA",
    "dropmalzpp": 194809998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104585645,
    "dropsitcph": 6104585645,
    "dropfax": 6104580779
  },
  {
    "dcode": "D",
    "dropkey": "PX1B673",
    "droptype": "D",
    "dropname": "VALENCIA",
    "dropdeladd": "1324 PITTSBURGH RD",
    "dropdelcty": "VALENCIA",
    "dropdelst": "PA",
    "dropdelzpp": 160599800,
    "dropphyadd": "1324 PITTSBURGH RD",
    "dropphycty": "VALENCIA",
    "dropphyst": "PA",
    "dropphyzpp": 160599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALENCIA",
    "dropmalst": "PA",
    "dropmalzpp": 160599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248982450,
    "dropsitcph": 7248982450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B678",
    "droptype": "D",
    "dropname": "VALLEY FORGE",
    "dropdeladd": "1721 VALLEY FORGE RD",
    "dropdelcty": "VALLEY FORGE",
    "dropdelst": "PA",
    "dropdelzpp": 194819998,
    "dropphyadd": "1721 VALLEY FORGE RD",
    "dropphycty": "VALLEY FORGE",
    "dropphyst": "PA",
    "dropphyzpp": 194819998,
    "dropmaladd": "1721 VALLEY FORGE RD",
    "dropmalcty": "VALLEY FORGE",
    "dropmalst": "PA",
    "dropmalzpp": 194819998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107830232,
    "dropsitcph": 6107830232,
    "dropfax": 6107836686
  },
  {
    "dcode": "D",
    "dropkey": "PX1B684",
    "droptype": "D",
    "dropname": "VALLEY VIEW",
    "dropdeladd": "1124 W MAIN ST",
    "dropdelcty": "VALLEY VIEW",
    "dropdelst": "PA",
    "dropdelzpp": 179839998,
    "dropphyadd": "1124 W MAIN ST",
    "dropphycty": "VALLEY VIEW",
    "dropphyst": "PA",
    "dropphyzpp": 179839998,
    "dropmaladd": "1124 W MAIN ST",
    "dropmalcty": "VALLEY VIEW",
    "dropmalst": "PA",
    "dropmalzpp": 179839998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706829452,
    "dropsitcph": 5706829452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B687",
    "droptype": "D",
    "dropname": "VAN VOORHIS",
    "dropdeladd": "1275 BENTLEYVILLE RD",
    "dropdelcty": "VAN VOORHIS",
    "dropdelst": "PA",
    "dropdelzpp": 153661001,
    "dropphyadd": "1275 BENTLEYVILLE RD",
    "dropphycty": "VAN VOORHIS",
    "dropphyst": "PA",
    "dropphyzpp": 153661001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN VOORHIS",
    "dropmalst": "PA",
    "dropmalzpp": 153669998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242584558,
    "dropsitcph": 7242584558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B689",
    "droptype": "D",
    "dropname": "VANDERBILT",
    "dropdeladd": "262 LIBERTY ST",
    "dropdelcty": "VANDERBILT",
    "dropdelst": "PA",
    "dropdelzpp": 154865001,
    "dropphyadd": "262 LIBERTY ST",
    "dropphycty": "VANDERBILT",
    "dropphyst": "PA",
    "dropphyzpp": 154865001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANDERBILT",
    "dropmalst": "PA",
    "dropmalzpp": 154869998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243985801,
    "dropsitcph": 7243985801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B690",
    "droptype": "D",
    "dropname": "VANDERGRIFT",
    "dropdeladd": "142 FARRAGUT AVE",
    "dropdelcty": "VANDERGRIFT",
    "dropdelst": "PA",
    "dropdelzpp": 156909998,
    "dropphyadd": "142 FARRAGUT AVE",
    "dropphycty": "VANDERGRIFT",
    "dropphyst": "PA",
    "dropphyzpp": 156909998,
    "dropmaladd": "142 FARRAGUT AVE",
    "dropmalcty": "VANDERGRIFT",
    "dropmalst": "PA",
    "dropmalzpp": 156909998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245683521,
    "dropsitcph": 7245683521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B692",
    "droptype": "D",
    "dropname": "VENANGO",
    "dropdeladd": "21663 CUSSEWAGO ST",
    "dropdelcty": "VENANGO",
    "dropdelst": "PA",
    "dropdelzpp": 164409800,
    "dropphyadd": "21663 CUSSEWAGO ST",
    "dropphycty": "VENANGO",
    "dropphyst": "PA",
    "dropphyzpp": 164409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENANGO",
    "dropmalst": "PA",
    "dropmalzpp": 164409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143982630,
    "dropsitcph": 8143982630,
    "dropfax": 8143982630
  },
  {
    "dcode": "D",
    "dropkey": "PX1B693",
    "droptype": "D",
    "dropname": "VENETIA",
    "dropdeladd": "500 VENETIA RD",
    "dropdelcty": "VENETIA",
    "dropdelst": "PA",
    "dropdelzpp": 153679998,
    "dropphyadd": "500 VENETIA RD",
    "dropphycty": "VENETIA",
    "dropphyst": "PA",
    "dropphyzpp": 153679998,
    "dropmaladd": "500 VENETIA RD",
    "dropmalcty": "VENETIA",
    "dropmalst": "PA",
    "dropmalzpp": 153679998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243485819,
    "dropsitcph": 7243485819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B694",
    "droptype": "D",
    "dropname": "VENUS",
    "dropdeladd": "4650 STATE ROUTE 157",
    "dropdelcty": "VENUS",
    "dropdelst": "PA",
    "dropdelzpp": 163649800,
    "dropphyadd": "4650 STATE ROUTE 157",
    "dropphycty": "VENUS",
    "dropphyst": "PA",
    "dropphyzpp": 163649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENUS",
    "dropmalst": "PA",
    "dropmalzpp": 163649998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143542702,
    "dropsitcph": 8143542702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B698",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "620 ALLEGHENY RIVER BLVD",
    "dropdelcty": "VERONA",
    "dropdelst": "PA",
    "dropdelzpp": 151479998,
    "dropphyadd": "620 ALLEGHENY RIVER BLVD",
    "dropphycty": "VERONA",
    "dropphyst": "PA",
    "dropphyzpp": 151479998,
    "dropmaladd": "620 ALLEGHENY RIVER BLVD",
    "dropmalcty": "VERONA",
    "dropmalst": "PA",
    "dropmalzpp": 151479998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128284709,
    "dropsitcph": 4128284709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B699",
    "droptype": "D",
    "dropname": "VESTABURG",
    "dropdeladd": "301 COMMUNITY ST",
    "dropdelcty": "VESTABURG",
    "dropdelst": "PA",
    "dropdelzpp": 153681001,
    "dropphyadd": "301 COMMUNITY ST",
    "dropphycty": "VESTABURG",
    "dropphyst": "PA",
    "dropphyzpp": 153681001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VESTABURG",
    "dropmalst": "PA",
    "dropmalzpp": 153689998,
    "dropsitphn": 4123597568,
    "dropsitlph": 8773641962,
    "dropsitcph": 8773641962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B707",
    "droptype": "D",
    "dropname": "VILLA MARIA",
    "dropdeladd": "288 VILLA DR RM MH216",
    "dropdelcty": "VILLA MARIA",
    "dropdelst": "PA",
    "dropdelzpp": 161559800,
    "dropphyadd": "288 VILLA DR RM MH216",
    "dropphycty": "VILLA MARIA",
    "dropphyst": "PA",
    "dropphyzpp": 161559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILLA MARIA",
    "dropmalst": "PA",
    "dropmalzpp": 161559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249648601,
    "dropsitcph": 7249648601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B710",
    "droptype": "D",
    "dropname": "VILLANOVA",
    "dropdeladd": "789 E LANCASTER AVE STE 40",
    "dropdelcty": "VILLANOVA",
    "dropdelst": "PA",
    "dropdelzpp": 190859997,
    "dropphyadd": "789 E LANCASTER AVE STE 40",
    "dropphycty": "VILLANOVA",
    "dropphyst": "PA",
    "dropphyzpp": 190859997,
    "dropmaladd": "789 E LANCASTER AVE STE 40",
    "dropmalcty": "VILLANOVA",
    "dropmalst": "PA",
    "dropmalzpp": 190859997,
    "dropsitphn": 6106888879,
    "dropsitlph": 6105269607,
    "dropsitcph": 6105269607,
    "dropfax": 6105201049
  },
  {
    "dcode": "D",
    "dropkey": "PX1B713",
    "droptype": "D",
    "dropname": "VINTONDALE",
    "dropdeladd": "195 MAIN ST",
    "dropdelcty": "VINTONDALE",
    "dropdelst": "PA",
    "dropdelzpp": 159619998,
    "dropphyadd": "195 MAIN ST",
    "dropphycty": "VINTONDALE",
    "dropphyst": "PA",
    "dropphyzpp": 159619998,
    "dropmaladd": "195 MAIN ST",
    "dropmalcty": "VINTONDALE",
    "dropmalst": "PA",
    "dropmalzpp": 159619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147497313,
    "dropsitcph": 8147497313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B715",
    "droptype": "D",
    "dropname": "VIRGINVILLE",
    "dropdeladd": "475 MAIN ST",
    "dropdelcty": "VIRGINVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195649998,
    "dropphyadd": "475 MAIN ST",
    "dropphycty": "VIRGINVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195649998,
    "dropmaladd": "475 MAIN ST",
    "dropmalcty": "VIRGINVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195649998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105625577,
    "dropsitcph": 6105625577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B720",
    "droptype": "D",
    "dropname": "VOLANT",
    "dropdeladd": "100 HIGH ST",
    "dropdelcty": "VOLANT",
    "dropdelst": "PA",
    "dropdelzpp": 161569800,
    "dropphyadd": "100 HIGH ST",
    "dropphycty": "VOLANT",
    "dropphyst": "PA",
    "dropphyzpp": 161569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VOLANT",
    "dropmalst": "PA",
    "dropmalzpp": 161569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245333095,
    "dropsitcph": 7245333095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B766",
    "droptype": "D",
    "dropname": "WAGONTOWN",
    "dropdeladd": "418 W KINGS HWY",
    "dropdelcty": "WAGONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 193769902,
    "dropphyadd": "418 W KINGS HWY",
    "dropphycty": "WAGONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 193769902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAGONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 193769998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103835711,
    "dropsitcph": 6103835711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B771",
    "droptype": "D",
    "dropname": "WALLACETON",
    "dropdeladd": "445 CLEARFIELD ST",
    "dropdelcty": "WALLACETON",
    "dropdelst": "PA",
    "dropdelzpp": 168769998,
    "dropphyadd": "445 CLEARFIELD ST",
    "dropphycty": "WALLACETON",
    "dropphyst": "PA",
    "dropphyzpp": 168769998,
    "dropmaladd": "445 CLEARFIELD ST",
    "dropmalcty": "WALLACETON",
    "dropmalst": "PA",
    "dropmalzpp": 168769998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143426157,
    "dropsitcph": 8143426157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B778",
    "droptype": "D",
    "dropname": "WALNUT BOTTOM",
    "dropdeladd": "40 MAPLE AVE",
    "dropdelcty": "WALNUT BOTTOM",
    "dropdelst": "PA",
    "dropdelzpp": 172669998,
    "dropphyadd": "40 MAPLE AVE",
    "dropphycty": "WALNUT BOTTOM",
    "dropphyst": "PA",
    "dropphyzpp": 172669998,
    "dropmaladd": "40 MAPLE AVE",
    "dropmalcty": "WALNUT BOTTOM",
    "dropmalst": "PA",
    "dropmalzpp": 172669998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175328935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B780",
    "droptype": "D",
    "dropname": "WALNUTPORT",
    "dropdeladd": "249 LEHIGH GAP ST",
    "dropdelcty": "WALNUTPORT",
    "dropdelst": "PA",
    "dropdelzpp": 180889998,
    "dropphyadd": "249 LEHIGH GAP ST",
    "dropphycty": "WALNUTPORT",
    "dropphyst": "PA",
    "dropphyzpp": 180889998,
    "dropmaladd": "249 LEHIGH GAP ST",
    "dropmalcty": "WALNUTPORT",
    "dropmalst": "PA",
    "dropmalzpp": 180889998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107675191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B783",
    "droptype": "D",
    "dropname": "WALSTON",
    "dropdeladd": "1716 WALSTON RD",
    "dropdelcty": "WALSTON",
    "dropdelst": "PA",
    "dropdelzpp": 157819998,
    "dropphyadd": "1716 WALSTON RD",
    "dropphycty": "WALSTON",
    "dropphyst": "PA",
    "dropphyzpp": 157819998,
    "dropmaladd": "1716 WALSTON RD",
    "dropmalcty": "WALSTON",
    "dropmalst": "PA",
    "dropmalzpp": 157819998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149382709,
    "dropsitcph": 8149382709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B784",
    "droptype": "D",
    "dropname": "WALTERSBURG",
    "dropdeladd": "1829 PITTSBURGH RD",
    "dropdelcty": "WALTERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 154885001,
    "dropphyadd": "1829 PITTSBURGH RD",
    "dropphycty": "WALTERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 154885001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALTERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 154889998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244387747,
    "dropsitcph": 7244387747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B786",
    "droptype": "D",
    "dropname": "WAMPUM",
    "dropdeladd": "414 BEAVER ST",
    "dropdelcty": "WAMPUM",
    "dropdelst": "PA",
    "dropdelzpp": 161579800,
    "dropphyadd": "414 BEAVER ST",
    "dropphycty": "WAMPUM",
    "dropphyst": "PA",
    "dropphyzpp": 161579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAMPUM",
    "dropmalst": "PA",
    "dropmalzpp": 161579998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245354251,
    "dropsitcph": 7245354251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B789",
    "droptype": "D",
    "dropname": "WAPWALLOPEN",
    "dropdeladd": "435 S MAIN ST",
    "dropdelcty": "WAPWALLOPEN",
    "dropdelst": "PA",
    "dropdelzpp": 186609998,
    "dropphyadd": "435 S MAIN ST",
    "dropphycty": "WAPWALLOPEN",
    "dropphyst": "PA",
    "dropphyzpp": 186609998,
    "dropmaladd": "435 S MAIN ST",
    "dropmalcty": "WAPWALLOPEN",
    "dropmalst": "PA",
    "dropmalzpp": 186609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703793850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B791",
    "droptype": "D",
    "dropname": "WARFORDSBURG",
    "dropdeladd": "13363 BUCK VALLEY RD",
    "dropdelcty": "WARFORDSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172679998,
    "dropphyadd": "13363 BUCK VALLEY RD",
    "dropphycty": "WARFORDSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172679998,
    "dropmaladd": "13363 BUCK VALLEY RD",
    "dropmalcty": "WARFORDSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172679998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177489053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B792",
    "droptype": "D",
    "dropname": "WARMINSTER",
    "dropdeladd": "1135 MEARNS RD",
    "dropdelcty": "WARMINSTER",
    "dropdelst": "PA",
    "dropdelzpp": 189749998,
    "dropphyadd": "1135 MEARNS RD",
    "dropphycty": "WARMINSTER",
    "dropphyst": "PA",
    "dropphyzpp": 189749998,
    "dropmaladd": "1135 MEARNS RD",
    "dropmalcty": "WARMINSTER",
    "dropmalst": "PA",
    "dropmalzpp": 189749998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2156728874,
    "dropsitcph": 2156728874,
    "dropfax": 2156722285
  },
  {
    "dcode": "D",
    "dropkey": "PX1B794",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "210 W 3RD AVE STE 100",
    "dropdelcty": "WARREN",
    "dropdelst": "PA",
    "dropdelzpp": 163659998,
    "dropphyadd": "210 W 3RD AVE STE 100",
    "dropphycty": "WARREN",
    "dropphyst": "PA",
    "dropphyzpp": 163659998,
    "dropmaladd": "210 W 3RD AVE STE 100",
    "dropmalcty": "WARREN",
    "dropmalst": "PA",
    "dropmalzpp": 163659998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147231660,
    "dropsitcph": 8147231660,
    "dropfax": 8147233671
  },
  {
    "dcode": "D",
    "dropkey": "PX1B795",
    "droptype": "D",
    "dropname": "WARREN CENTER",
    "dropdeladd": "1 SCHOOL HOUSE RD",
    "dropdelcty": "WARREN CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 188519998,
    "dropphyadd": "1 SCHOOL HOUSE RD",
    "dropphycty": "WARREN CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 188519998,
    "dropmaladd": "1 SCHOOL HOUSE RD",
    "dropmalcty": "WARREN CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 188519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703953616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B800",
    "droptype": "D",
    "dropname": "WARRINGTON",
    "dropdeladd": "1380 EASTON RD STE 1",
    "dropdelcty": "WARRINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 189769998,
    "dropphyadd": "1380 EASTON RD STE 1",
    "dropphycty": "WARRINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 189769998,
    "dropmaladd": "1380 EASTON RD STE 1",
    "dropmalcty": "WARRINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 189769998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153431591,
    "dropsitcph": 2153431591,
    "dropfax": 2153431855
  },
  {
    "dcode": "D",
    "dropkey": "PX1B803",
    "droptype": "D",
    "dropname": "WARRIORS MARK",
    "dropdeladd": "1883 CENTRE LINE RD",
    "dropdelcty": "WARRIORS MARK",
    "dropdelst": "PA",
    "dropdelzpp": 168779998,
    "dropphyadd": "1883 CENTRE LINE RD",
    "dropphycty": "WARRIORS MARK",
    "dropphyst": "PA",
    "dropphyzpp": 168779998,
    "dropmaladd": "1883 CENTRE LINE RD",
    "dropmalcty": "WARRIORS MARK",
    "dropmalst": "PA",
    "dropmalzpp": 168779998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146328600,
    "dropsitcph": 8146328600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B810",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "153 JEFFERSON AVE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 153019998,
    "dropphyadd": "153 JEFFERSON AVE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 153019998,
    "dropmaladd": "153 JEFFERSON AVE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 153019998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242221709,
    "dropsitcph": 7242221709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B811",
    "droptype": "D",
    "dropname": "WASHINGTON BORO",
    "dropdeladd": "10 ELIZABETH ST",
    "dropdelcty": "WASHINGTON BORO",
    "dropdelst": "PA",
    "dropdelzpp": 175829998,
    "dropphyadd": "10 ELIZABETH ST",
    "dropphycty": "WASHINGTON BORO",
    "dropphyst": "PA",
    "dropphyzpp": 175829998,
    "dropmaladd": "10 ELIZABETH ST",
    "dropmalcty": "WASHINGTON BORO",
    "dropmalst": "PA",
    "dropmalzpp": 175829998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176845727,
    "dropsitcph": 7176845727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B813",
    "droptype": "D",
    "dropname": "WASHINGTON CROSSING",
    "dropdeladd": "1077 RIVER RD STE 1",
    "dropdelcty": "WASHINGTON CROSSING",
    "dropdelst": "PA",
    "dropdelzpp": 189779998,
    "dropphyadd": "1077 RIVER RD STE 1",
    "dropphycty": "WASHINGTON CROSSING",
    "dropphyst": "PA",
    "dropphyzpp": 189779998,
    "dropmaladd": "1077 RIVER RD STE 1",
    "dropmalcty": "WASHINGTON CROSSING",
    "dropmalst": "PA",
    "dropmalzpp": 189779998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2154935767,
    "dropsitcph": 2154935767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B816",
    "droptype": "D",
    "dropname": "WASHINGTONVILLE",
    "dropdeladd": "1229 WATER ST",
    "dropdelcty": "WASHINGTONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178849998,
    "dropphyadd": "1229 WATER ST",
    "dropphycty": "WASHINGTONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178849998,
    "dropmaladd": "1229 WATER ST",
    "dropmalcty": "WASHINGTONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178849998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5704372250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B818",
    "droptype": "D",
    "dropname": "WATERFALL",
    "dropdeladd": "965 WATERFALL RD",
    "dropdelcty": "WATERFALL",
    "dropdelst": "PA",
    "dropdelzpp": 166899998,
    "dropphyadd": "965 WATERFALL RD",
    "dropphycty": "WATERFALL",
    "dropphyst": "PA",
    "dropphyzpp": 166899998,
    "dropmaladd": "965 WATERFALL RD",
    "dropmalcty": "WATERFALL",
    "dropmalst": "PA",
    "dropmalzpp": 166899998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146853346,
    "dropsitcph": 8146853346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B819",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "101 HIGH ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "PA",
    "dropdelzpp": 164419800,
    "dropphyadd": "101 HIGH ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "PA",
    "dropphyzpp": 164419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERFORD",
    "dropmalst": "PA",
    "dropmalzpp": 164419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147962500,
    "dropsitcph": 8147962500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B822",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "10702 STATE ROUTE 44",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177769998,
    "dropphyadd": "10702 STATE ROUTE 44",
    "dropphycty": "WATERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177769998,
    "dropmaladd": "10702 STATE ROUTE 44",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177769998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707538832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B826",
    "droptype": "D",
    "dropname": "WATSONTOWN",
    "dropdeladd": "316 MAIN ST",
    "dropdelcty": "WATSONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 177779998,
    "dropphyadd": "316 MAIN ST",
    "dropphycty": "WATSONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 177779998,
    "dropmaladd": "316 MAIN ST",
    "dropmalcty": "WATSONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 177779998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705385330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B830",
    "droptype": "D",
    "dropname": "WATTSBURG",
    "dropdeladd": "14410 MAIN ST",
    "dropdelcty": "WATTSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 164429800,
    "dropphyadd": "14410 MAIN ST",
    "dropphycty": "WATTSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 164429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATTSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 164429998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147392250,
    "dropsitcph": 8147392250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B831",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "1115 N ABINGTON RD",
    "dropdelcty": "WAVERLY",
    "dropdelst": "PA",
    "dropdelzpp": 184719800,
    "dropphyadd": "1115 N ABINGTON RD",
    "dropphycty": "WAVERLY",
    "dropphyst": "PA",
    "dropphyzpp": 184719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAVERLY",
    "dropmalst": "PA",
    "dropmalzpp": 184719998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705862831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B834",
    "droptype": "D",
    "dropname": "WAYMART",
    "dropdeladd": "310 HONESDALE RD",
    "dropdelcty": "WAYMART",
    "dropdelst": "PA",
    "dropdelzpp": 184729998,
    "dropphyadd": "310 HONESDALE RD",
    "dropphycty": "WAYMART",
    "dropphyst": "PA",
    "dropphyzpp": 184729998,
    "dropmaladd": "310 HONESDALE RD",
    "dropmalcty": "WAYMART",
    "dropmalst": "PA",
    "dropmalzpp": 184729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704886510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B838",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "104 S WAYNE AVE",
    "dropdelcty": "WAYNE",
    "dropdelst": "PA",
    "dropdelzpp": 190879998,
    "dropphyadd": "104 S WAYNE AVE",
    "dropphycty": "WAYNE",
    "dropphyst": "PA",
    "dropphyzpp": 190879998,
    "dropmaladd": "104 S WAYNE AVE",
    "dropmalcty": "WAYNE",
    "dropmalst": "PA",
    "dropmalzpp": 190879998,
    "dropsitphn": 6106888879,
    "dropsitlph": 6106888879,
    "dropsitcph": 6109640208,
    "dropfax": 6106873277
  },
  {
    "dcode": "D",
    "dropkey": "PX1B841",
    "droptype": "D",
    "dropname": "WAYNESBORO",
    "dropdeladd": "118 E MAIN ST",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "PA",
    "dropdelzpp": 172689998,
    "dropphyadd": "118 E MAIN ST",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "PA",
    "dropphyzpp": 172689998,
    "dropmaladd": "118 E MAIN ST",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "PA",
    "dropmalzpp": 172689998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177621513,
    "dropfax": 7177625244
  },
  {
    "dcode": "D",
    "dropkey": "PX1B842",
    "droptype": "D",
    "dropname": "WAYNESBURG",
    "dropdeladd": "120 S MORRIS ST",
    "dropdelcty": "WAYNESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 153709998,
    "dropphyadd": "120 S MORRIS ST",
    "dropphycty": "WAYNESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 153709998,
    "dropmaladd": "120 S MORRIS ST",
    "dropmalcty": "WAYNESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 153709998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246270338,
    "dropsitcph": 7246270338,
    "dropfax": 7246279752
  },
  {
    "dcode": "D",
    "dropkey": "PX1B845",
    "droptype": "D",
    "dropname": "WEATHERLY",
    "dropdeladd": "5 CARBON ST",
    "dropdelcty": "WEATHERLY",
    "dropdelst": "PA",
    "dropdelzpp": 182559998,
    "dropphyadd": "5 CARBON ST",
    "dropphycty": "WEATHERLY",
    "dropphyst": "PA",
    "dropphyzpp": 182559998,
    "dropmaladd": "5 CARBON ST",
    "dropmalcty": "WEATHERLY",
    "dropmalst": "PA",
    "dropmalzpp": 182559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704278531,
    "dropfax": 5704278731
  },
  {
    "dcode": "D",
    "dropkey": "PX1B850",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "703 WALL ST",
    "dropdelcty": "WEBSTER",
    "dropdelst": "PA",
    "dropdelzpp": 150871001,
    "dropphyadd": "703 WALL ST",
    "dropphycty": "WEBSTER",
    "dropphyst": "PA",
    "dropphyzpp": 150871001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBSTER",
    "dropmalst": "PA",
    "dropmalzpp": 150879998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243796748,
    "dropsitcph": 7243796748,
    "dropfax": 7243796748
  },
  {
    "dcode": "D",
    "dropkey": "PX1B852",
    "droptype": "D",
    "dropname": "WEEDVILLE",
    "dropdeladd": "472 RIVER RD",
    "dropdelcty": "WEEDVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 158689800,
    "dropphyadd": "472 RIVER RD",
    "dropphycty": "WEEDVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 158689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEEDVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 158689998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147878015,
    "dropsitcph": 8147878015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B855",
    "droptype": "D",
    "dropname": "WEIKERT",
    "dropdeladd": "5540 WEIKERT RD",
    "dropdelcty": "WEIKERT",
    "dropdelst": "PA",
    "dropdelzpp": 178859998,
    "dropphyadd": "5540 WEIKERT RD",
    "dropphycty": "WEIKERT",
    "dropphyst": "PA",
    "dropphyzpp": 178859998,
    "dropmaladd": "5540 WEIKERT RD",
    "dropmalcty": "WEIKERT",
    "dropmalst": "PA",
    "dropmalzpp": 178859998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709224655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B862",
    "droptype": "D",
    "dropname": "WELLS TANNERY",
    "dropdeladd": "704 W TANNERY RD",
    "dropdelcty": "WELLS TANNERY",
    "dropdelst": "PA",
    "dropdelzpp": 166919998,
    "dropphyadd": "704 W TANNERY RD",
    "dropphycty": "WELLS TANNERY",
    "dropphyst": "PA",
    "dropphyzpp": 166919998,
    "dropmaladd": "704 W TANNERY RD",
    "dropmalcty": "WELLS TANNERY",
    "dropmalst": "PA",
    "dropmalzpp": 166919998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146853615,
    "dropsitcph": 8146853615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B863",
    "droptype": "D",
    "dropname": "WELLSBORO",
    "dropdeladd": "14 MAIN ST",
    "dropdelcty": "WELLSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 169019998,
    "dropphyadd": "14 MAIN ST",
    "dropphycty": "WELLSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 169019998,
    "dropmaladd": "14 MAIN ST",
    "dropmalcty": "WELLSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 169019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707241690,
    "dropfax": 5707247973
  },
  {
    "dcode": "D",
    "dropkey": "PX1B864",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "224 MAIN ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173659998,
    "dropphyadd": "224 MAIN ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173659998,
    "dropmaladd": "224 MAIN ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173659998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174329823,
    "dropsitcph": 7174329823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B869",
    "droptype": "D",
    "dropname": "WENDEL",
    "dropdeladd": "9 ATLANTIC AVE",
    "dropdelcty": "MANOR",
    "dropdelst": "PA",
    "dropdelzpp": 156659998,
    "dropphyadd": "9 ATLANTIC AVE",
    "dropphycty": "MANOR",
    "dropphyst": "PA",
    "dropphyzpp": 156659998,
    "dropmaladd": "9 ATLANTIC AVE",
    "dropmalcty": "MANOR",
    "dropmalst": "PA",
    "dropmalzpp": 156659998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248643300,
    "dropsitcph": 7248643300,
    "dropfax": 7248615509
  },
  {
    "dcode": "D",
    "dropkey": "PX1B870",
    "droptype": "D",
    "dropname": "WERNERSVILLE",
    "dropdeladd": "55 S CHURCH RD",
    "dropdelcty": "WERNERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195659998,
    "dropphyadd": "55 S CHURCH RD",
    "dropphycty": "WERNERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195659998,
    "dropmaladd": "55 S CHURCH RD",
    "dropmalcty": "WERNERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195659998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106787668,
    "dropsitcph": 6106787668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B882",
    "droptype": "D",
    "dropname": "WEST ALEXANDER",
    "dropdeladd": "35 N LIBERTY RD",
    "dropdelcty": "WEST ALEXANDER",
    "dropdelst": "PA",
    "dropdelzpp": 153761001,
    "dropphyadd": "35 N LIBERTY RD",
    "dropphycty": "WEST ALEXANDER",
    "dropphyst": "PA",
    "dropphyzpp": 153761001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST ALEXANDER",
    "dropmalst": "PA",
    "dropmalzpp": 153769998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244847372,
    "dropsitcph": 7244847372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B898",
    "droptype": "D",
    "dropname": "WEST CHESTER",
    "dropdeladd": "1050 AIRPORT RD",
    "dropdelcty": "WEST CHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 193809998,
    "dropphyadd": "1050 AIRPORT RD",
    "dropphycty": "WEST CHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 193809998,
    "dropmaladd": "1050 AIRPORT RD",
    "dropmalcty": "WEST CHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 193809998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107387638,
    "dropsitcph": 6107387638,
    "dropfax": 6107010640
  },
  {
    "dcode": "D",
    "dropkey": "PX1B902",
    "droptype": "D",
    "dropname": "WEST DECATUR",
    "dropdeladd": "105 BLUE BALL RD",
    "dropdelcty": "WEST DECATUR",
    "dropdelst": "PA",
    "dropdelzpp": 168789998,
    "dropphyadd": "105 BLUE BALL RD",
    "dropphycty": "WEST DECATUR",
    "dropphyst": "PA",
    "dropphyzpp": 168789998,
    "dropmaladd": "105 BLUE BALL RD",
    "dropmalcty": "WEST DECATUR",
    "dropmalst": "PA",
    "dropmalzpp": 168789998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143426934,
    "dropsitcph": 8143426934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B905",
    "droptype": "D",
    "dropname": "WEST ELIZABETH",
    "dropdeladd": "604 GRANT ST",
    "dropdelcty": "WEST ELIZABETH",
    "dropdelst": "PA",
    "dropdelzpp": 150881001,
    "dropphyadd": "604 GRANT ST",
    "dropphycty": "WEST ELIZABETH",
    "dropphyst": "PA",
    "dropphyzpp": 150881001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST ELIZABETH",
    "dropmalst": "PA",
    "dropmalzpp": 150889998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123847420,
    "dropsitcph": 4123847420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B909",
    "droptype": "D",
    "dropname": "WEST FINLEY",
    "dropdeladd": "487 W FINLEY RD",
    "dropdelcty": "WEST FINLEY",
    "dropdelst": "PA",
    "dropdelzpp": 153771001,
    "dropphyadd": "487 W FINLEY RD",
    "dropphycty": "WEST FINLEY",
    "dropphyst": "PA",
    "dropphyzpp": 153771001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST FINLEY",
    "dropmalst": "PA",
    "dropmalzpp": 153779998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244283866,
    "dropsitcph": 7244283866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B910",
    "droptype": "D",
    "dropname": "WEST GROVE",
    "dropdeladd": "5 PROSPECT AVE",
    "dropdelcty": "WEST GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 193909998,
    "dropphyadd": "5 PROSPECT AVE",
    "dropphycty": "WEST GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 193909998,
    "dropmaladd": "5 PROSPECT AVE",
    "dropmalcty": "WEST GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 193909998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108694176,
    "dropsitcph": 6108694176,
    "dropfax": 6108695873
  },
  {
    "dcode": "D",
    "dropkey": "PX1B916",
    "droptype": "D",
    "dropname": "WEST HICKORY",
    "dropdeladd": "3518 MAIN ST",
    "dropdelcty": "WEST HICKORY",
    "dropdelst": "PA",
    "dropdelzpp": 163709800,
    "dropphyadd": "3518 MAIN ST",
    "dropphycty": "WEST HICKORY",
    "dropphyst": "PA",
    "dropphyzpp": 163709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST HICKORY",
    "dropmalst": "PA",
    "dropmalzpp": 163709998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144639933,
    "dropsitcph": 8144639933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B922",
    "droptype": "D",
    "dropname": "WEST LEISENRING",
    "dropdeladd": "114 POSTAL WAY",
    "dropdelcty": "WEST LEISENRING",
    "dropdelst": "PA",
    "dropdelzpp": 154891001,
    "dropphyadd": "114 POSTAL WAY",
    "dropphycty": "WEST LEISENRING",
    "dropphyst": "PA",
    "dropphyzpp": 154891001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST LEISENRING",
    "dropmalst": "PA",
    "dropmalzpp": 154899998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244395660,
    "dropsitcph": 7244395660,
    "dropfax": 7244395660
  },
  {
    "dcode": "D",
    "dropkey": "PX1B926",
    "droptype": "D",
    "dropname": "WEST MIDDLESEX",
    "dropdeladd": "39 FAIR ST",
    "dropdelcty": "WEST MIDDLESEX",
    "dropdelst": "PA",
    "dropdelzpp": 161599800,
    "dropphyadd": "39 FAIR ST",
    "dropphycty": "WEST MIDDLESEX",
    "dropphyst": "PA",
    "dropphyzpp": 161599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST MIDDLESEX",
    "dropmalst": "PA",
    "dropmalzpp": 161599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245289771,
    "dropsitcph": 7245289771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B927",
    "droptype": "D",
    "dropname": "WEST MIDDLETOWN",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "WEST MIDDLETOWN",
    "dropdelst": "PA",
    "dropdelzpp": 153791001,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "WEST MIDDLETOWN",
    "dropphyst": "PA",
    "dropphyzpp": 153791001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST MIDDLETOWN",
    "dropmalst": "PA",
    "dropmalzpp": 153799998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242099001,
    "dropsitcph": 7242099001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B931",
    "droptype": "D",
    "dropname": "WEST MILTON",
    "dropdeladd": "505 BROAD ST",
    "dropdelcty": "WEST MILTON",
    "dropdelst": "PA",
    "dropdelzpp": 178869998,
    "dropphyadd": "505 BROAD ST",
    "dropphycty": "WEST MILTON",
    "dropphyst": "PA",
    "dropphyzpp": 178869998,
    "dropmaladd": "505 BROAD ST",
    "dropmalcty": "WEST MILTON",
    "dropmalst": "PA",
    "dropmalzpp": 178869998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705682021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B933",
    "droptype": "D",
    "dropname": "WEST NEWTON",
    "dropdeladd": "200 VINE ST",
    "dropdelcty": "WEST NEWTON",
    "dropdelst": "PA",
    "dropdelzpp": 150899998,
    "dropphyadd": "200 VINE ST",
    "dropphycty": "WEST NEWTON",
    "dropphyst": "PA",
    "dropphyzpp": 150899998,
    "dropmaladd": "200 VINE ST",
    "dropmalcty": "WEST NEWTON",
    "dropmalst": "PA",
    "dropmalzpp": 150899998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248726169,
    "dropsitcph": 7248726169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B942",
    "droptype": "D",
    "dropname": "WEST PITTSBURG",
    "dropdeladd": "341 CENTER AVE",
    "dropdelcty": "WEST PITTSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 161609800,
    "dropphyadd": "341 CENTER AVE",
    "dropphycty": "WEST PITTSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 161609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST PITTSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 161609998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245357222,
    "dropsitcph": 7245357222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B945",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "1851 W POINT PIKE",
    "dropdelcty": "WEST POINT",
    "dropdelst": "PA",
    "dropdelzpp": 194869998,
    "dropphyadd": "1851 W POINT PIKE",
    "dropphycty": "WEST POINT",
    "dropphyst": "PA",
    "dropphyzpp": 194869998,
    "dropmaladd": "1851 W POINT PIKE",
    "dropmalcty": "WEST POINT",
    "dropmalst": "PA",
    "dropmalzpp": 194869998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2156999056,
    "dropsitcph": 2156999056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B951",
    "droptype": "D",
    "dropname": "WEST SPRINGFIELD",
    "dropdeladd": "13788 RIDGE RD",
    "dropdelcty": "WEST SPRINGFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 164439800,
    "dropphyadd": "13788 RIDGE RD",
    "dropphycty": "WEST SPRINGFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 164439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST SPRINGFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 164439998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149223264,
    "dropsitcph": 8149223264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B952",
    "droptype": "D",
    "dropname": "WEST SUNBURY",
    "dropdeladd": "201 W STATE ST",
    "dropdelcty": "WEST SUNBURY",
    "dropdelst": "PA",
    "dropdelzpp": 160619800,
    "dropphyadd": "201 W STATE ST",
    "dropphycty": "WEST SUNBURY",
    "dropphyst": "PA",
    "dropphyzpp": 160619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST SUNBURY",
    "dropmalst": "PA",
    "dropmalzpp": 160619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246372000,
    "dropsitcph": 7246372000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B962",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 169509998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 169509998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 169509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8143672923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B966",
    "droptype": "D",
    "dropname": "WESTLAND",
    "dropdeladd": "428 WESTLAND RD",
    "dropdelcty": "WESTLAND",
    "dropdelst": "PA",
    "dropdelzpp": 153781001,
    "dropphyadd": "428 WESTLAND RD",
    "dropphycty": "WESTLAND",
    "dropphyst": "PA",
    "dropphyzpp": 153781001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTLAND",
    "dropmalst": "PA",
    "dropmalzpp": 153789998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247456630,
    "dropsitcph": 7247456630,
    "dropfax": 7247452207
  },
  {
    "dcode": "D",
    "dropkey": "PX1B969",
    "droptype": "D",
    "dropname": "WESTMORELAND CITY",
    "dropdeladd": "8880 WALNUT ST",
    "dropdelcty": "WESTMORELAND CITY",
    "dropdelst": "PA",
    "dropdelzpp": 156921001,
    "dropphyadd": "8880 WALNUT ST",
    "dropphycty": "WESTMORELAND CITY",
    "dropphyst": "PA",
    "dropphyzpp": 156921001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTMORELAND CITY",
    "dropmalst": "PA",
    "dropmalzpp": 156929998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248645940,
    "dropsitcph": 7248645940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B972",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "592 HAZLE ST STE 1",
    "dropdelcty": "WESTON",
    "dropdelst": "PA",
    "dropdelzpp": 182569998,
    "dropphyadd": "592 HAZLE ST STE 1",
    "dropphycty": "WESTON",
    "dropphyst": "PA",
    "dropphyzpp": 182569998,
    "dropmaladd": "592 HAZLE ST STE 1",
    "dropmalcty": "WESTON",
    "dropmalst": "PA",
    "dropmalzpp": 182569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703843060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B974",
    "droptype": "D",
    "dropname": "WESTOVER",
    "dropdeladd": "103 CHURCH ST",
    "dropdelcty": "WESTOVER",
    "dropdelst": "PA",
    "dropdelzpp": 166929998,
    "dropphyadd": "103 CHURCH ST",
    "dropphycty": "WESTOVER",
    "dropphyst": "PA",
    "dropphyzpp": 166929998,
    "dropmaladd": "103 CHURCH ST",
    "dropmalcty": "WESTOVER",
    "dropmalst": "PA",
    "dropmalzpp": 166929998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142479907,
    "dropsitcph": 8142479907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B975",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "56 SCHOOL LN",
    "dropdelcty": "WESTPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177789998,
    "dropphyadd": "56 SCHOOL LN",
    "dropphycty": "WESTPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177789998,
    "dropmaladd": "56 SCHOOL LN",
    "dropmalcty": "WESTPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177789998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5709231511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B977",
    "droptype": "D",
    "dropname": "WESTTOWN",
    "dropdeladd": "844 E STREET RD",
    "dropdelcty": "WESTTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 193959998,
    "dropphyadd": "844 E STREET RD",
    "dropphycty": "WESTTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 193959998,
    "dropmaladd": "844 E STREET RD",
    "dropmalcty": "WESTTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 193959998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103991356,
    "dropsitcph": 6103991356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B981",
    "droptype": "D",
    "dropname": "WEXFORD",
    "dropdeladd": "10675 PERRY HWY",
    "dropdelcty": "WEXFORD",
    "dropdelst": "PA",
    "dropdelzpp": 150909998,
    "dropphyadd": "10675 PERRY HWY",
    "dropphycty": "WEXFORD",
    "dropphyst": "PA",
    "dropphyzpp": 150909998,
    "dropmaladd": "10675 PERRY HWY",
    "dropmalcty": "WEXFORD",
    "dropmalst": "PA",
    "dropmalzpp": 150909998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249352120,
    "dropsitcph": 7249352120,
    "dropfax": 7249352309
  },
  {
    "dcode": "D",
    "dropkey": "PX1B984",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "101 COUNCIL AVE",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "PA",
    "dropdelzpp": 161619800,
    "dropphyadd": "101 COUNCIL AVE",
    "dropphycty": "WHEATLAND",
    "dropphyst": "PA",
    "dropphyzpp": 161619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "PA",
    "dropmalzpp": 161619998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243464501,
    "dropsitcph": 7243464501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B987",
    "droptype": "D",
    "dropname": "WHITE",
    "dropdeladd": "881 BUCHANAN RD",
    "dropdelcty": "WHITE",
    "dropdelst": "PA",
    "dropdelzpp": 154901075,
    "dropphyadd": "881 BUCHANAN RD",
    "dropphycty": "WHITE",
    "dropphyst": "PA",
    "dropphyzpp": 154901075,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE",
    "dropmalst": "PA",
    "dropmalzpp": 154909998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244552563,
    "dropsitcph": 7244552563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B989",
    "droptype": "D",
    "dropname": "WHITE DEER",
    "dropdeladd": "601 WHITE DEER PIKE",
    "dropdelcty": "WHITE DEER",
    "dropdelst": "PA",
    "dropdelzpp": 178879800,
    "dropphyadd": "601 WHITE DEER PIKE",
    "dropphycty": "WHITE DEER",
    "dropphyst": "PA",
    "dropphyzpp": 178879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE DEER",
    "dropmalst": "PA",
    "dropmalzpp": 178879998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705385346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B992",
    "droptype": "D",
    "dropname": "WHITE HAVEN",
    "dropdeladd": "425 TOWANDA ST",
    "dropdelcty": "WHITE HAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 186619998,
    "dropphyadd": "425 TOWANDA ST",
    "dropphycty": "WHITE HAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 186619998,
    "dropmaladd": "425 TOWANDA ST",
    "dropmalcty": "WHITE HAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 186619998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704438866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1B996",
    "droptype": "D",
    "dropname": "WHITE MILLS",
    "dropdeladd": "744 TEXAS PALMYRA HWY",
    "dropdelcty": "WHITE MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 184739800,
    "dropphyadd": "744 TEXAS PALMYRA HWY",
    "dropphycty": "WHITE MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 184739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 184739998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702535657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C003",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "1105 SCHADT AVE",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "PA",
    "dropdelzpp": 180529998,
    "dropphyadd": "1105 SCHADT AVE",
    "dropphycty": "WHITEHALL",
    "dropphyst": "PA",
    "dropphyzpp": 180529998,
    "dropmaladd": "1105 SCHADT AVE",
    "dropmalcty": "WHITEHALL",
    "dropmalst": "PA",
    "dropmalzpp": 180529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102645514,
    "dropfax": 6102667554
  },
  {
    "dcode": "D",
    "dropkey": "PX1C005",
    "droptype": "D",
    "dropname": "WHITNEY",
    "dropdeladd": "103 AUGUSTA LN",
    "dropdelcty": "WHITNEY",
    "dropdelst": "PA",
    "dropdelzpp": 156931001,
    "dropphyadd": "103 AUGUSTA LN",
    "dropphycty": "WHITNEY",
    "dropphyst": "PA",
    "dropphyzpp": 156931001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITNEY",
    "dropmalst": "PA",
    "dropmalzpp": 156939998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244235565,
    "dropsitcph": 7244235565,
    "dropfax": 7244238822
  },
  {
    "dcode": "D",
    "dropkey": "PX1C013",
    "droptype": "D",
    "dropname": "WICONISCO",
    "dropdeladd": "500 POTTSVILLE ST",
    "dropdelcty": "WICONISCO",
    "dropdelst": "PA",
    "dropdelzpp": 170979998,
    "dropphyadd": "500 POTTSVILLE ST",
    "dropphycty": "WICONISCO",
    "dropphyst": "PA",
    "dropphyzpp": 170979998,
    "dropmaladd": "500 POTTSVILLE ST",
    "dropmalcty": "WICONISCO",
    "dropmalst": "PA",
    "dropmalzpp": 170979998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174537270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C019",
    "droptype": "D",
    "dropname": "WILBURTON",
    "dropdeladd": "107 SMITH ST",
    "dropdelcty": "WILBURTON",
    "dropdelst": "PA",
    "dropdelzpp": 178889800,
    "dropphyadd": "107 SMITH ST",
    "dropphycty": "WILBURTON",
    "dropphyst": "PA",
    "dropphyzpp": 178889800,
    "dropmaladd": "107 SMITH ST",
    "dropmalcty": "WILBURTON",
    "dropmalst": "PA",
    "dropmalzpp": 178889800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703393857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C020",
    "droptype": "D",
    "dropname": "WILCOX",
    "dropdeladd": "553 MARVIN ST",
    "dropdelcty": "WILCOX",
    "dropdelst": "PA",
    "dropdelzpp": 158709800,
    "dropphyadd": "553 MARVIN ST",
    "dropphycty": "WILCOX",
    "dropphyst": "PA",
    "dropphyzpp": 158709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILCOX",
    "dropmalst": "PA",
    "dropmalzpp": 158709998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149295666,
    "dropsitcph": 8149295666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C021",
    "droptype": "D",
    "dropname": "WILDWOOD",
    "dropdeladd": "2507 WILDWOOD RD",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 150911001,
    "dropphyadd": "2507 WILDWOOD RD",
    "dropphycty": "WILDWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 150911001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 150919998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124861211,
    "dropsitcph": 4124861211,
    "dropfax": 4124879702
  },
  {
    "dcode": "D",
    "dropkey": "PX1C026",
    "droptype": "D",
    "dropname": "WILKES BARRE",
    "dropdeladd": "300 S MAIN ST",
    "dropdelcty": "WILKES BARRE",
    "dropdelst": "PA",
    "dropdelzpp": 187019990,
    "dropphyadd": "300 S MAIN ST",
    "dropphycty": "WILKES BARRE",
    "dropphyst": "PA",
    "dropphyzpp": 187019990,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019990,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708313400,
    "dropfax": 5708313403
  },
  {
    "dcode": "D",
    "dropkey": "PX1C039",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "234 HIGH ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166939998,
    "dropphyadd": "234 HIGH ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166939998,
    "dropmaladd": "234 HIGH ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166939998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148323214,
    "dropsitcph": 8148323214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C042",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "2901 REACH RD",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177019998,
    "dropphyadd": "2901 REACH RD",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177019998,
    "dropmaladd": "2901 REACH RD",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703204100,
    "dropfax": 5703204126
  },
  {
    "dcode": "D",
    "dropkey": "PX1C043",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "120 N WEST ST",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170989998,
    "dropphyadd": "120 N WEST ST",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170989998,
    "dropmaladd": "120 N WEST ST",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170989998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176479324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C046",
    "droptype": "D",
    "dropname": "WILLOW GROVE",
    "dropdeladd": "611 EASTON RD",
    "dropdelcty": "WILLOW GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 190909998,
    "dropphyadd": "611 EASTON RD",
    "dropphycty": "WILLOW GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 190909998,
    "dropmaladd": "611 EASTON RD",
    "dropmalcty": "WILLOW GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 190909998,
    "dropsitphn": 2156593424,
    "dropsitlph": 2156598180,
    "dropsitcph": 2156593424,
    "dropfax": 2156590870
  },
  {
    "dcode": "D",
    "dropkey": "PX1C049",
    "droptype": "D",
    "dropname": "WILLOW HILL",
    "dropdeladd": "14413 PATH VALLEY RD",
    "dropdelcty": "WILLOW HILL",
    "dropdelst": "PA",
    "dropdelzpp": 172719998,
    "dropphyadd": "14413 PATH VALLEY RD",
    "dropphycty": "WILLOW HILL",
    "dropphyst": "PA",
    "dropphyzpp": 172719998,
    "dropmaladd": "14413 PATH VALLEY RD",
    "dropmalcty": "WILLOW HILL",
    "dropmalst": "PA",
    "dropmalzpp": 172719998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173497856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C051",
    "droptype": "D",
    "dropname": "WILLOW STREET",
    "dropdeladd": "6 VIOLET AVE",
    "dropdelcty": "WILLOW STREET",
    "dropdelst": "PA",
    "dropdelzpp": 175849998,
    "dropphyadd": "6 VIOLET AVE",
    "dropphycty": "WILLOW STREET",
    "dropphyst": "PA",
    "dropphyzpp": 175849998,
    "dropmaladd": "6 VIOLET AVE",
    "dropmalcty": "WILLOW STREET",
    "dropmalst": "PA",
    "dropmalzpp": 175849998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174643540,
    "dropsitcph": 7174643540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C054",
    "droptype": "D",
    "dropname": "WILMERDING",
    "dropdeladd": "410 STATION ST",
    "dropdelcty": "WILMERDING",
    "dropdelst": "PA",
    "dropdelzpp": 151489998,
    "dropphyadd": "410 STATION ST",
    "dropphycty": "WILMERDING",
    "dropphyst": "PA",
    "dropphyzpp": 151489998,
    "dropmaladd": "410 STATION ST",
    "dropmalcty": "WILMERDING",
    "dropmalst": "PA",
    "dropmalzpp": 151489998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128236420,
    "dropsitcph": 4128236420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C055",
    "droptype": "D",
    "dropname": "WILMORE",
    "dropdeladd": "885 MAIN ST",
    "dropdelcty": "WILMORE",
    "dropdelst": "PA",
    "dropdelzpp": 159629998,
    "dropphyadd": "885 MAIN ST",
    "dropphycty": "WILMORE",
    "dropphyst": "PA",
    "dropphyzpp": 159629998,
    "dropmaladd": "885 MAIN ST",
    "dropmalcty": "WILMORE",
    "dropmalst": "PA",
    "dropmalzpp": 159629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144957238,
    "dropsitcph": 8144957238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C057",
    "droptype": "D",
    "dropname": "WINBURNE",
    "dropdeladd": "1208 MAIN ST",
    "dropdelcty": "WINBURNE",
    "dropdelst": "PA",
    "dropdelzpp": 168799998,
    "dropphyadd": "1208 MAIN ST",
    "dropphycty": "WINBURNE",
    "dropphyst": "PA",
    "dropphyzpp": 168799998,
    "dropmaladd": "1208 MAIN ST",
    "dropmalcty": "WINBURNE",
    "dropmalst": "PA",
    "dropmalzpp": 168799998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143456904,
    "dropsitcph": 8143456904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C058",
    "droptype": "D",
    "dropname": "WIND GAP",
    "dropdeladd": "138 N BROADWAY",
    "dropdelcty": "WIND GAP",
    "dropdelst": "PA",
    "dropdelzpp": 180919998,
    "dropphyadd": "138 N BROADWAY",
    "dropphycty": "WIND GAP",
    "dropphyst": "PA",
    "dropphyzpp": 180919998,
    "dropmaladd": "138 N BROADWAY",
    "dropmalcty": "WIND GAP",
    "dropmalst": "PA",
    "dropmalzpp": 180919998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108636206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C059",
    "droptype": "D",
    "dropname": "WIND RIDGE",
    "dropdeladd": "466 W ROY FURMAN HWY",
    "dropdelcty": "WIND RIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 153801109,
    "dropphyadd": "466 W ROY FURMAN HWY",
    "dropphycty": "WIND RIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 153801109,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WIND RIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 153809998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244283877,
    "dropsitcph": 7244283877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C060",
    "droptype": "D",
    "dropname": "WINDBER",
    "dropdeladd": "1600 GRAHAM AVE",
    "dropdelcty": "WINDBER",
    "dropdelst": "PA",
    "dropdelzpp": 159639998,
    "dropphyadd": "1600 GRAHAM AVE",
    "dropphycty": "WINDBER",
    "dropphyst": "PA",
    "dropphyzpp": 159639998,
    "dropmaladd": "1600 GRAHAM AVE",
    "dropmalcty": "WINDBER",
    "dropmalst": "PA",
    "dropmalzpp": 159639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144677558,
    "dropsitcph": 8144677558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C065",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "3 S CAMP ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "PA",
    "dropdelzpp": 173669998,
    "dropphyadd": "3 S CAMP ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "PA",
    "dropphyzpp": 173669998,
    "dropmaladd": "3 S CAMP ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "PA",
    "dropmalzpp": 173669998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172447411,
    "dropsitcph": 7172447411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C070",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "477 PARK RD",
    "dropdelcty": "WINFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 178899998,
    "dropphyadd": "477 PARK RD",
    "dropphycty": "WINFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 178899998,
    "dropmaladd": "477 PARK RD",
    "dropmalcty": "WINFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 178899998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705242626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C075",
    "droptype": "D",
    "dropname": "WITMER",
    "dropdeladd": "407 MOUNT SIDNEY RD",
    "dropdelcty": "WITMER",
    "dropdelst": "PA",
    "dropdelzpp": 175859998,
    "dropphyadd": "407 MOUNT SIDNEY RD",
    "dropphycty": "WITMER",
    "dropphyst": "PA",
    "dropphyzpp": 175859998,
    "dropmaladd": "407 MOUNT SIDNEY RD",
    "dropmalcty": "WITMER",
    "dropmalst": "PA",
    "dropmalzpp": 175859998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172993365,
    "dropsitcph": 7172993365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C083",
    "droptype": "D",
    "dropname": "WOMELSDORF",
    "dropdeladd": "37 N 3RD ST",
    "dropdelcty": "WOMELSDORF",
    "dropdelst": "PA",
    "dropdelzpp": 195679998,
    "dropphyadd": "37 N 3RD ST",
    "dropphycty": "WOMELSDORF",
    "dropphyst": "PA",
    "dropphyzpp": 195679998,
    "dropmaladd": "37 N 3RD ST",
    "dropmalcty": "WOMELSDORF",
    "dropmalst": "PA",
    "dropmalzpp": 195679998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105894541,
    "dropsitcph": 6105894541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C084",
    "droptype": "D",
    "dropname": "WOOD",
    "dropdeladd": "242 MAIN ST",
    "dropdelcty": "WOOD",
    "dropdelst": "PA",
    "dropdelzpp": 166949998,
    "dropphyadd": "242 MAIN ST",
    "dropphycty": "WOOD",
    "dropphyst": "PA",
    "dropphyzpp": 166949998,
    "dropmaladd": "242 MAIN ST",
    "dropmalcty": "WOOD",
    "dropmalst": "PA",
    "dropmalzpp": 166949998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146352391,
    "dropsitcph": 8146352391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C086",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "143 MAIN ST",
    "dropdelcty": "WOODBURY",
    "dropdelst": "PA",
    "dropdelzpp": 166959998,
    "dropphyadd": "143 MAIN ST",
    "dropphycty": "WOODBURY",
    "dropphyst": "PA",
    "dropphyzpp": 166959998,
    "dropmaladd": "143 MAIN ST",
    "dropmalcty": "WOODBURY",
    "dropmalst": "PA",
    "dropmalzpp": 166959998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147663295,
    "dropsitcph": 8147663295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C089",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "1374 SHAWVILLE HWY",
    "dropdelcty": "WOODLAND",
    "dropdelst": "PA",
    "dropdelzpp": 168819998,
    "dropphyadd": "1374 SHAWVILLE HWY",
    "dropphycty": "WOODLAND",
    "dropphyst": "PA",
    "dropphyzpp": 168819998,
    "dropmaladd": "1374 SHAWVILLE HWY",
    "dropmalcty": "WOODLAND",
    "dropmalst": "PA",
    "dropmalzpp": 168819998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148577766,
    "dropsitcph": 8148577766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C090",
    "droptype": "D",
    "dropname": "WOODLYN",
    "dropdeladd": "217 FAIRVIEW RD",
    "dropdelcty": "WOODLYN",
    "dropdelst": "PA",
    "dropdelzpp": 190949998,
    "dropphyadd": "217 FAIRVIEW RD",
    "dropphycty": "WOODLYN",
    "dropphyst": "PA",
    "dropphyzpp": 190949998,
    "dropmaladd": "217 FAIRVIEW RD",
    "dropmalcty": "WOODLYN",
    "dropmalst": "PA",
    "dropmalzpp": 190949998,
    "dropsitphn": 6108335439,
    "dropsitlph": 6108335764,
    "dropsitcph": 6108335439,
    "dropfax": 6108332573
  },
  {
    "dcode": "D",
    "dropkey": "PX1C092",
    "droptype": "D",
    "dropname": "WOODWARD",
    "dropdeladd": "107 MOUNTAIN AVE",
    "dropdelcty": "WOODWARD",
    "dropdelst": "PA",
    "dropdelzpp": 168829998,
    "dropphyadd": "107 MOUNTAIN AVE",
    "dropphycty": "WOODWARD",
    "dropphyst": "PA",
    "dropphyzpp": 168829998,
    "dropmaladd": "107 MOUNTAIN AVE",
    "dropmalcty": "WOODWARD",
    "dropmalst": "PA",
    "dropmalzpp": 168829998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143495228,
    "dropsitcph": 8143495228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C093",
    "droptype": "D",
    "dropname": "WOOLRICH",
    "dropdeladd": "1039 PARK AVE",
    "dropdelcty": "WOOLRICH",
    "dropdelst": "PA",
    "dropdelzpp": 177799998,
    "dropphyadd": "1039 PARK AVE",
    "dropphycty": "WOOLRICH",
    "dropphyst": "PA",
    "dropphyzpp": 177799998,
    "dropmaladd": "1039 PARK AVE",
    "dropmalcty": "WOOLRICH",
    "dropmalst": "PA",
    "dropmalzpp": 177799998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707696102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C094",
    "droptype": "D",
    "dropname": "WORCESTER",
    "dropdeladd": "1741 VALLEY FORGE RD",
    "dropdelcty": "WORCESTER",
    "dropdelst": "PA",
    "dropdelzpp": 194909998,
    "dropphyadd": "1741 VALLEY FORGE RD",
    "dropphycty": "WORCESTER",
    "dropphyst": "PA",
    "dropphyzpp": 194909998,
    "dropmaladd": "1741 VALLEY FORGE RD",
    "dropmalcty": "WORCESTER",
    "dropmalst": "PA",
    "dropmalzpp": 194909998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6105846226,
    "dropsitcph": 6105846226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C099",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "199 E MAIN ST",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 162629800,
    "dropphyadd": "199 E MAIN ST",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 162629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 162629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242975738,
    "dropsitcph": 7242988117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C101",
    "droptype": "D",
    "dropname": "WOXALL",
    "dropdeladd": "2040 OLD SKIPPACK PIKE",
    "dropdelcty": "WOXALL",
    "dropdelst": "PA",
    "dropdelzpp": 189799998,
    "dropphyadd": "2040 OLD SKIPPACK PIKE",
    "dropphycty": "WOXALL",
    "dropphyst": "PA",
    "dropphyzpp": 189799998,
    "dropmaladd": "2040 OLD SKIPPACK PIKE",
    "dropmalcty": "WOXALL",
    "dropmalst": "PA",
    "dropmalzpp": 189799998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152348484,
    "dropsitcph": 2152348484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C104",
    "droptype": "D",
    "dropname": "WRIGHTSVILLE",
    "dropdeladd": "307 HELLAM ST",
    "dropdelcty": "WRIGHTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173689998,
    "dropphyadd": "307 HELLAM ST",
    "dropphycty": "WRIGHTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173689998,
    "dropmaladd": "307 HELLAM ST",
    "dropmalcty": "WRIGHTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173689998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172523411,
    "dropsitcph": 7172523411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C107",
    "droptype": "D",
    "dropname": "WYALUSING",
    "dropdeladd": "58 CHURCH ST",
    "dropdelcty": "WYALUSING",
    "dropdelst": "PA",
    "dropdelzpp": 188539998,
    "dropphyadd": "58 CHURCH ST",
    "dropphycty": "WYALUSING",
    "dropphyst": "PA",
    "dropphyzpp": 188539998,
    "dropmaladd": "58 CHURCH ST",
    "dropmalcty": "WYALUSING",
    "dropmalst": "PA",
    "dropmalzpp": 188539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707461440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C108",
    "droptype": "D",
    "dropname": "WYANO",
    "dropdeladd": "2202 1ST ST",
    "dropdelcty": "WYANO",
    "dropdelst": "PA",
    "dropdelzpp": 156951001,
    "dropphyadd": "2202 1ST ST",
    "dropphycty": "WYANO",
    "dropphyst": "PA",
    "dropphyzpp": 156951001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYANO",
    "dropmalst": "PA",
    "dropmalzpp": 156959998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247223503,
    "dropsitcph": 7247223503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C109",
    "droptype": "D",
    "dropname": "WYCOMBE",
    "dropdeladd": "4122 TOWNSHIP LINE RD",
    "dropdelcty": "WYCOMBE",
    "dropdelst": "PA",
    "dropdelzpp": 189809998,
    "dropphyadd": "4122 TOWNSHIP LINE RD",
    "dropphycty": "WYCOMBE",
    "dropphyst": "PA",
    "dropphyzpp": 189809998,
    "dropmaladd": "4122 TOWNSHIP LINE RD",
    "dropmalcty": "WYCOMBE",
    "dropmalst": "PA",
    "dropmalzpp": 189809998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155983223,
    "dropsitcph": 2155983223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C112",
    "droptype": "D",
    "dropname": "WYNCOTE",
    "dropdeladd": "207 GLENSIDE AVE",
    "dropdelcty": "WYNCOTE",
    "dropdelst": "PA",
    "dropdelzpp": 190959998,
    "dropphyadd": "207 GLENSIDE AVE",
    "dropphycty": "WYNCOTE",
    "dropphyst": "PA",
    "dropphyzpp": 190959998,
    "dropmaladd": "207 GLENSIDE AVE",
    "dropmalcty": "WYNCOTE",
    "dropmalst": "PA",
    "dropmalzpp": 190959998,
    "dropsitphn": 2158846078,
    "dropsitlph": 2158845394,
    "dropsitcph": 2158846078,
    "dropfax": 2158841294
  },
  {
    "dcode": "D",
    "dropkey": "PX1C115",
    "droptype": "D",
    "dropname": "WYNNEWOOD",
    "dropdeladd": "50 E WYNNEWOOD RD STE 22",
    "dropdelcty": "WYNNEWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 190969998,
    "dropphyadd": "50 E WYNNEWOOD RD STE 22",
    "dropphycty": "WYNNEWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 190969998,
    "dropmaladd": "50 E WYNNEWOOD RD STE 22",
    "dropmalcty": "WYNNEWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 190969998,
    "dropsitphn": 6106426561,
    "dropsitlph": 6106421354,
    "dropsitcph": 6106426561,
    "dropfax": 6106423927
  },
  {
    "dcode": "D",
    "dropkey": "PX1C119",
    "droptype": "D",
    "dropname": "WYSOX",
    "dropdeladd": "1800 GOLDEN MILE RD",
    "dropdelcty": "WYSOX",
    "dropdelst": "PA",
    "dropdelzpp": 188549998,
    "dropphyadd": "1800 GOLDEN MILE RD",
    "dropphycty": "WYSOX",
    "dropphyst": "PA",
    "dropphyzpp": 188549998,
    "dropmaladd": "1800 GOLDEN MILE RD",
    "dropmalcty": "WYSOX",
    "dropmalst": "PA",
    "dropmalzpp": 188549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702653345,
    "dropfax": 5702653345
  },
  {
    "dcode": "D",
    "dropkey": "PX1C121",
    "droptype": "D",
    "dropname": "YATESBORO",
    "dropdeladd": "52 W MAIN ST",
    "dropdelcty": "YATESBORO",
    "dropdelst": "PA",
    "dropdelzpp": 162639800,
    "dropphyadd": "52 W MAIN ST",
    "dropphycty": "YATESBORO",
    "dropphyst": "PA",
    "dropphyzpp": 162639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YATESBORO",
    "dropmalst": "PA",
    "dropmalzpp": 162639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247836608,
    "dropsitcph": 7247836608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C125",
    "droptype": "D",
    "dropname": "YEAGERTOWN",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "YEAGERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170999998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "YEAGERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170999998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "YEAGERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170999998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172420080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C130",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "3435 CONCORD RD OFC",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174029998,
    "dropphyadd": "3435 CONCORD RD OFC",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174029998,
    "dropmaladd": "3435 CONCORD RD OFC",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174029998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7178482381,
    "dropsitcph": 7177514612,
    "dropfax": 7177514679
  },
  {
    "dcode": "D",
    "dropkey": "PX1C131",
    "droptype": "D",
    "dropname": "YORK HAVEN",
    "dropdeladd": "15 PENNSYLVANIA AVE",
    "dropdelcty": "YORK HAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 173709998,
    "dropphyadd": "15 PENNSYLVANIA AVE",
    "dropphycty": "YORK HAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 173709998,
    "dropmaladd": "15 PENNSYLVANIA AVE",
    "dropmalcty": "YORK HAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 173709998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172661517,
    "dropsitcph": 7172661517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C133",
    "droptype": "D",
    "dropname": "YORK NEW SALEM",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "YORK NEW SALEM",
    "dropdelst": "PA",
    "dropdelzpp": 173719998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "YORK NEW SALEM",
    "dropphyst": "PA",
    "dropphyzpp": 173719998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "YORK NEW SALEM",
    "dropmalst": "PA",
    "dropmalzpp": 173719998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177920931,
    "dropsitcph": 7177920931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C138",
    "droptype": "D",
    "dropname": "YORK SPRINGS",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "YORK SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 173729998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "YORK SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 173729998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "YORK SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 173729998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175284721,
    "dropsitcph": 7175284721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C143",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 156961001,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 156961001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 156969998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245378741,
    "dropsitcph": 7245378741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C144",
    "droptype": "D",
    "dropname": "YOUNGSVILLE",
    "dropdeladd": "39 RAILROAD ST",
    "dropdelcty": "YOUNGSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163711400,
    "dropphyadd": "39 RAILROAD ST",
    "dropphycty": "YOUNGSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163711400,
    "dropmaladd": "39 RAILROAD ST",
    "dropmalcty": "YOUNGSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163711400,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145634471,
    "dropsitcph": 8145634471,
    "dropfax": 8145634418
  },
  {
    "dcode": "D",
    "dropkey": "PX1C145",
    "droptype": "D",
    "dropname": "YOUNGWOOD",
    "dropdeladd": "26 S 3RD ST",
    "dropdelcty": "YOUNGWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 156979998,
    "dropphyadd": "26 S 3RD ST",
    "dropphycty": "YOUNGWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 156979998,
    "dropmaladd": "26 S 3RD ST",
    "dropmalcty": "YOUNGWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 156979998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249252360,
    "dropsitcph": 7249252360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C146",
    "droptype": "D",
    "dropname": "YUKON",
    "dropdeladd": "137 HIGHWAY ST",
    "dropdelcty": "YUKON",
    "dropdelst": "PA",
    "dropdelzpp": 156981111,
    "dropphyadd": "137 HIGHWAY ST",
    "dropphycty": "YUKON",
    "dropphyst": "PA",
    "dropphyzpp": 156981111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YUKON",
    "dropmalst": "PA",
    "dropmalzpp": 156989998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247223275,
    "dropsitcph": 7247223275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C147",
    "droptype": "D",
    "dropname": "ZELIENOPLE",
    "dropdeladd": "249 S MAIN ST",
    "dropdelcty": "ZELIENOPLE",
    "dropdelst": "PA",
    "dropdelzpp": 160632300,
    "dropphyadd": "249 S MAIN ST",
    "dropphycty": "ZELIENOPLE",
    "dropphyst": "PA",
    "dropphyzpp": 160632300,
    "dropmaladd": "249 S MAIN ST",
    "dropmalcty": "ZELIENOPLE",
    "dropmalst": "PA",
    "dropmalzpp": 160632300,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244527410,
    "dropsitcph": 7244527410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C150",
    "droptype": "D",
    "dropname": "ZIEGLERVILLE",
    "dropdeladd": "1204 N GRAVEL PIKE",
    "dropdelcty": "ZIEGLERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194929998,
    "dropphyadd": "1204 N GRAVEL PIKE",
    "dropphycty": "ZIEGLERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194929998,
    "dropmaladd": "1204 N GRAVEL PIKE",
    "dropmalcty": "ZIEGLERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194929998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102878524,
    "dropsitcph": 6102878524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C151",
    "droptype": "D",
    "dropname": "ZION GROVE",
    "dropdeladd": "731 RINGTOWN RD",
    "dropdelcty": "ZION GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 179859998,
    "dropphyadd": "731 RINGTOWN RD",
    "dropphycty": "ZION GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 179859998,
    "dropmaladd": "731 RINGTOWN RD",
    "dropmalcty": "ZION GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 179859998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708893236,
    "dropsitcph": 5708893236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C153",
    "droptype": "D",
    "dropname": "ZIONHILL",
    "dropdeladd": "2985B OLD BETHLEHEM PIKE",
    "dropdelcty": "ZIONHILL",
    "dropdelst": "PA",
    "dropdelzpp": 189819998,
    "dropphyadd": "2985B OLD BETHLEHEM PIKE",
    "dropphycty": "ZIONHILL",
    "dropphyst": "PA",
    "dropphyzpp": 189819998,
    "dropmaladd": "2985B OLD BETHLEHEM PIKE",
    "dropmalcty": "ZIONHILL",
    "dropmalst": "PA",
    "dropmalzpp": 189819998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155364197,
    "dropsitcph": 2155364197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C159",
    "droptype": "D",
    "dropname": "ZULLINGER",
    "dropdeladd": "5012 BUCHANAN TRL E",
    "dropdelcty": "ZULLINGER",
    "dropdelst": "PA",
    "dropdelzpp": 172729998,
    "dropphyadd": "5012 BUCHANAN TRL E",
    "dropphycty": "ZULLINGER",
    "dropphyst": "PA",
    "dropphyzpp": 172729998,
    "dropmaladd": "5012 BUCHANAN TRL E",
    "dropmalcty": "ZULLINGER",
    "dropmalst": "PA",
    "dropmalzpp": 172729998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177629644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX1C419",
    "droptype": "D",
    "dropname": "ELKINS PARK",
    "dropdeladd": "1800 ASHBOURNE RD",
    "dropdelcty": "ELKINS PARK",
    "dropdelst": "PA",
    "dropdelzpp": 190279998,
    "dropphyadd": "1800 ASHBOURNE RD",
    "dropphycty": "ELKINS PARK",
    "dropphyst": "PA",
    "dropphyzpp": 190279998,
    "dropmaladd": "1800 ASHBOURNE RD",
    "dropmalcty": "ELKINS PARK",
    "dropmalst": "PA",
    "dropmalzpp": 190279998,
    "dropsitphn": 2158875431,
    "dropsitlph": 2158871751,
    "dropsitcph": 2158871751,
    "dropfax": 2158871675
  },
  {
    "dcode": "D",
    "dropkey": "PX1C428",
    "droptype": "D",
    "dropname": "WEST COLLEGE CORNER",
    "dropdeladd": "18 LIBERTY AVE",
    "dropdelcty": "WEST COLLEGE CORNER",
    "dropdelst": "IN",
    "dropdelzpp": 470039998,
    "dropphyadd": "18 LIBERTY AVE",
    "dropphycty": "WEST COLLEGE CORNER",
    "dropphyst": "IN",
    "dropphyzpp": 470039998,
    "dropmaladd": "18 LIBERTY AVE",
    "dropmalcty": "COLLEGE CORNER",
    "dropmalst": "OH",
    "dropmalzpp": 450039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7657323556,
    "dropsitcph": 7657323556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10003",
    "droptype": "D",
    "dropname": "ABBEVILLE",
    "dropdeladd": "210 MAIN ST W",
    "dropdelcty": "ABBEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310019998,
    "dropphyadd": "210 MAIN ST W",
    "dropphycty": "ABBEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310019998,
    "dropmaladd": "210 MAIN ST W",
    "dropmalcty": "ABBEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2294672346,
    "dropsitcph": 2294672346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10004",
    "droptype": "D",
    "dropname": "ACWORTH",
    "dropdeladd": "4915 N MAIN ST",
    "dropdelcty": "ACWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 301019998,
    "dropphyadd": "4915 N MAIN ST",
    "dropphycty": "ACWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 301019998,
    "dropmaladd": "4915 N MAIN ST",
    "dropmalcty": "ACWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 301019998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709668133,
    "dropsitcph": 7709668133,
    "dropfax": 7709759847
  },
  {
    "dcode": "D",
    "dropkey": "PX10005",
    "droptype": "D",
    "dropname": "ADAIRSVILLE",
    "dropdeladd": "10 FINLEY ST",
    "dropdelcty": "ADAIRSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301039998,
    "dropphyadd": "10 FINLEY ST",
    "dropphycty": "ADAIRSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301039998,
    "dropmaladd": "10 FINLEY ST",
    "dropmalcty": "ADAIRSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301039998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707733474,
    "dropsitcph": 7707733848,
    "dropfax": 7707731599
  },
  {
    "dcode": "D",
    "dropkey": "PX10008",
    "droptype": "D",
    "dropname": "ADEL",
    "dropdeladd": "1009 S HUTCHINSON AVE",
    "dropdelcty": "ADEL",
    "dropdelst": "GA",
    "dropdelzpp": 316209998,
    "dropphyadd": "1009 S HUTCHINSON AVE",
    "dropphycty": "ADEL",
    "dropphyst": "GA",
    "dropphyzpp": 316209998,
    "dropmaladd": "1009 S HUTCHINSON AVE",
    "dropmalcty": "ADEL",
    "dropmalst": "GA",
    "dropmalzpp": 316209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298967742,
    "dropsitcph": 2298967742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10009",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "ADRIAN",
    "dropdelst": "GA",
    "dropdelzpp": 310029998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "ADRIAN",
    "dropphyst": "GA",
    "dropphyzpp": 310029998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "ADRIAN",
    "dropmalst": "GA",
    "dropmalzpp": 310029998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786683380,
    "dropsitcph": 4786683380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10012",
    "droptype": "D",
    "dropname": "AILEY",
    "dropdeladd": "129 RAILROAD ST",
    "dropdelcty": "AILEY",
    "dropdelst": "GA",
    "dropdelzpp": 304109998,
    "dropphyadd": "129 RAILROAD ST",
    "dropphycty": "AILEY",
    "dropphyst": "GA",
    "dropphyzpp": 304109998,
    "dropmaladd": "129 RAILROAD ST",
    "dropmalcty": "AILEY",
    "dropmalst": "GA",
    "dropmalzpp": 304109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125832252,
    "dropsitcph": 9125832252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10016",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "14 W RAILROAD AVE",
    "dropdelcty": "ALAMO",
    "dropdelst": "GA",
    "dropdelzpp": 304119998,
    "dropphyadd": "14 W RAILROAD AVE",
    "dropphycty": "ALAMO",
    "dropphyst": "GA",
    "dropphyzpp": 304119998,
    "dropmaladd": "14 W RAILROAD AVE",
    "dropmalcty": "ALAMO",
    "dropmalst": "GA",
    "dropmalzpp": 304119998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125687211,
    "dropsitcph": 9125687211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10017",
    "droptype": "D",
    "dropname": "ALAPAHA",
    "dropdeladd": "22261 MAIN ST",
    "dropdelcty": "ALAPAHA",
    "dropdelst": "GA",
    "dropdelzpp": 316229998,
    "dropphyadd": "22261 MAIN ST",
    "dropphycty": "ALAPAHA",
    "dropphyst": "GA",
    "dropphyzpp": 316229998,
    "dropmaladd": "22261 MAIN ST",
    "dropmalcty": "ALAPAHA",
    "dropmalst": "GA",
    "dropmalzpp": 316229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295322128,
    "dropsitcph": 2295322128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10019",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "1501 S SLAPPEY BLVD",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317019998,
    "dropphyadd": "1501 S SLAPPEY BLVD",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317019998,
    "dropmaladd": "1501 S SLAPPEY BLVD",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317019998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298892651,
    "dropsitcph": 2298892651,
    "dropfax": 2298892640
  },
  {
    "dcode": "D",
    "dropkey": "PX10021",
    "droptype": "D",
    "dropname": "ALLENHURST",
    "dropdeladd": "4282 W OGLETHORPE HWY",
    "dropdelcty": "ALLENHURST",
    "dropdelst": "GA",
    "dropdelzpp": 313019998,
    "dropphyadd": "4282 W OGLETHORPE HWY",
    "dropphycty": "ALLENHURST",
    "dropphyst": "GA",
    "dropphyzpp": 313019998,
    "dropmaladd": "4282 W OGLETHORPE HWY",
    "dropmalcty": "ALLENHURST",
    "dropmalst": "GA",
    "dropmalzpp": 313019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128767369,
    "dropsitcph": 9128767369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10022",
    "droptype": "D",
    "dropname": "ALLENTOWN",
    "dropdeladd": "61 1ST ST",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "GA",
    "dropdelzpp": 310039998,
    "dropphyadd": "61 1ST ST",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "GA",
    "dropphyzpp": 310039998,
    "dropmaladd": "61 1ST ST",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "GA",
    "dropmalzpp": 310039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789620203,
    "dropsitcph": 4789620203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10023",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "523 W 12TH ST",
    "dropdelcty": "ALMA",
    "dropdelst": "GA",
    "dropdelzpp": 315109998,
    "dropphyadd": "523 W 12TH ST",
    "dropphycty": "ALMA",
    "dropphyst": "GA",
    "dropphyzpp": 315109998,
    "dropmaladd": "523 W 12TH ST",
    "dropmalcty": "ALMA",
    "dropmalst": "GA",
    "dropmalzpp": 315109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126322756,
    "dropsitcph": 9126322756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10024",
    "droptype": "D",
    "dropname": "ALPHARETTA",
    "dropdeladd": "2400 OLD MILTON PKWY",
    "dropdelcty": "ALPHARETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300099998,
    "dropphyadd": "2400 OLD MILTON PKWY",
    "dropphycty": "ALPHARETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300099998,
    "dropmaladd": "2400 OLD MILTON PKWY",
    "dropmalcty": "ALPHARETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300099998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6783662660,
    "dropsitcph": 7704423893,
    "dropfax": 7707518888
  },
  {
    "dcode": "D",
    "dropkey": "PX10027",
    "droptype": "D",
    "dropname": "ALSTON",
    "dropdeladd": "5133 GA HIGHWAY 135",
    "dropdelcty": "ALSTON",
    "dropdelst": "GA",
    "dropdelzpp": 304129998,
    "dropphyadd": "5133 GA HIGHWAY 135",
    "dropphycty": "ALSTON",
    "dropphyst": "GA",
    "dropphyzpp": 304129998,
    "dropmaladd": "5133 GA HIGHWAY 135",
    "dropmalcty": "ALSTON",
    "dropmalst": "GA",
    "dropmalzpp": 304129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125946542,
    "dropsitcph": 9125946542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10030",
    "droptype": "D",
    "dropname": "ALTO",
    "dropdeladd": "3753 GAINESVILLE HWY",
    "dropdelcty": "ALTO",
    "dropdelst": "GA",
    "dropdelzpp": 305109998,
    "dropphyadd": "3753 GAINESVILLE HWY",
    "dropphycty": "ALTO",
    "dropphyst": "GA",
    "dropphyzpp": 305109998,
    "dropmaladd": "3753 GAINESVILLE HWY",
    "dropmalcty": "ALTO",
    "dropmalst": "GA",
    "dropmalzpp": 305109998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067787764,
    "dropsitcph": 7067787764,
    "dropfax": 7067763068
  },
  {
    "dcode": "D",
    "dropkey": "PX10032",
    "droptype": "D",
    "dropname": "AMBROSE",
    "dropdeladd": "17 PINE ST",
    "dropdelcty": "AMBROSE",
    "dropdelst": "GA",
    "dropdelzpp": 315129998,
    "dropphyadd": "17 PINE ST",
    "dropphycty": "AMBROSE",
    "dropphyst": "GA",
    "dropphyzpp": 315129998,
    "dropmaladd": "17 PINE ST",
    "dropmalcty": "AMBROSE",
    "dropmalst": "GA",
    "dropmalzpp": 315129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123592825,
    "dropsitcph": 9123592825,
    "dropfax": 9123592825
  },
  {
    "dcode": "D",
    "dropkey": "PX10035",
    "droptype": "D",
    "dropname": "AMERICUS",
    "dropdeladd": "128 E FORSYTH ST STE 100",
    "dropdelcty": "AMERICUS",
    "dropdelst": "GA",
    "dropdelzpp": 317099998,
    "dropphyadd": "128 E FORSYTH ST STE 100",
    "dropphycty": "AMERICUS",
    "dropphyst": "GA",
    "dropphyzpp": 317099998,
    "dropmaladd": "128 E FORSYTH ST STE 100",
    "dropmalcty": "AMERICUS",
    "dropmalst": "GA",
    "dropmalzpp": 317099998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2299248957,
    "dropsitcph": 2299248957,
    "dropfax": 2299240808
  },
  {
    "dcode": "D",
    "dropkey": "PX10037",
    "droptype": "D",
    "dropname": "ANDERSONVILLE",
    "dropdeladd": "113 E CHURCH ST",
    "dropdelcty": "ANDERSONVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 317119998,
    "dropphyadd": "113 E CHURCH ST",
    "dropphycty": "ANDERSONVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 317119998,
    "dropmaladd": "113 E CHURCH ST",
    "dropmalcty": "ANDERSONVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 317119998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2299315379,
    "dropsitcph": 2299315379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10038",
    "droptype": "D",
    "dropname": "APPLING",
    "dropdeladd": "1849 APPLING HARLEM RD",
    "dropdelcty": "APPLING",
    "dropdelst": "GA",
    "dropdelzpp": 308029998,
    "dropphyadd": "1849 APPLING HARLEM RD",
    "dropphycty": "APPLING",
    "dropphyst": "GA",
    "dropphyzpp": 308029998,
    "dropmaladd": "1849 APPLING HARLEM RD",
    "dropmalcty": "APPLING",
    "dropmalst": "GA",
    "dropmalzpp": 308029998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065411516,
    "dropsitcph": 7065411516,
    "dropfax": 7065412024
  },
  {
    "dcode": "D",
    "dropkey": "PX10039",
    "droptype": "D",
    "dropname": "ARABI",
    "dropdeladd": "4185 BEDGOOD AVE",
    "dropdelcty": "ARABI",
    "dropdelst": "GA",
    "dropdelzpp": 317129998,
    "dropphyadd": "4185 BEDGOOD AVE",
    "dropphycty": "ARABI",
    "dropphyst": "GA",
    "dropphyzpp": 317129998,
    "dropmaladd": "4185 BEDGOOD AVE",
    "dropmalcty": "ARABI",
    "dropmalst": "GA",
    "dropmalzpp": 317129998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2292760034,
    "dropsitcph": 2292760034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10040",
    "droptype": "D",
    "dropname": "ARAGON",
    "dropdeladd": "2646 ROME HWY",
    "dropdelcty": "ARAGON",
    "dropdelst": "GA",
    "dropdelzpp": 301049998,
    "dropphyadd": "2646 ROME HWY",
    "dropphycty": "ARAGON",
    "dropphyst": "GA",
    "dropphyzpp": 301049998,
    "dropmaladd": "2646 ROME HWY",
    "dropmalcty": "ARAGON",
    "dropmalst": "GA",
    "dropmalzpp": 301049998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706845700,
    "dropsitcph": 7706845700,
    "dropfax": 7706846271
  },
  {
    "dcode": "D",
    "dropkey": "PX10042",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "6427 MAIN ST",
    "dropdelcty": "ARGYLE",
    "dropdelst": "GA",
    "dropdelzpp": 316239998,
    "dropphyadd": "6427 MAIN ST",
    "dropphycty": "ARGYLE",
    "dropphyst": "GA",
    "dropphyzpp": 316239998,
    "dropmaladd": "6427 MAIN ST",
    "dropmalcty": "ARGYLE",
    "dropmalst": "GA",
    "dropmalzpp": 316239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124872527,
    "dropsitcph": 9124872527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10043",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "438 PIONEER RD NW",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 398139998,
    "dropphyadd": "438 PIONEER RD NW",
    "dropphycty": "ARLINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 398139998,
    "dropmaladd": "438 PIONEER RD NW",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 398139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297254208,
    "dropsitcph": 2297254208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10044",
    "droptype": "D",
    "dropname": "ARMUCHEE",
    "dropdeladd": "5345 MARTHA BERRY HWY NE",
    "dropdelcty": "ARMUCHEE",
    "dropdelst": "GA",
    "dropdelzpp": 301059998,
    "dropphyadd": "5345 MARTHA BERRY HWY NE",
    "dropphycty": "ARMUCHEE",
    "dropphyst": "GA",
    "dropphyzpp": 301059998,
    "dropmaladd": "5345 MARTHA BERRY HWY NE",
    "dropmalcty": "ARMUCHEE",
    "dropmalst": "GA",
    "dropmalzpp": 301059998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062347700,
    "dropsitcph": 7062347700,
    "dropfax": 7062340513
  },
  {
    "dcode": "D",
    "dropkey": "PX10045",
    "droptype": "D",
    "dropname": "ARNOLDSVILLE",
    "dropdeladd": "162 YANCEY RD",
    "dropdelcty": "ARNOLDSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 306199998,
    "dropphyadd": "162 YANCEY RD",
    "dropphycty": "ARNOLDSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 306199998,
    "dropmaladd": "162 YANCEY RD",
    "dropmalcty": "ARNOLDSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 306199998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067427464,
    "dropsitcph": 7067427464,
    "dropfax": 7067427464
  },
  {
    "dcode": "D",
    "dropkey": "PX10048",
    "droptype": "D",
    "dropname": "ASHBURN",
    "dropdeladd": "218 E COLLEGE AVE",
    "dropdelcty": "ASHBURN",
    "dropdelst": "GA",
    "dropdelzpp": 317149998,
    "dropphyadd": "218 E COLLEGE AVE",
    "dropphycty": "ASHBURN",
    "dropphyst": "GA",
    "dropphyzpp": 317149998,
    "dropmaladd": "218 E COLLEGE AVE",
    "dropmalcty": "ASHBURN",
    "dropmalst": "GA",
    "dropmalzpp": 317149998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295674804,
    "dropsitcph": 2295674804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10052",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "575 OLYMPIC DR",
    "dropdelcty": "ATHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306011653,
    "dropphyadd": "575 OLYMPIC DR",
    "dropphycty": "ATHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306011653,
    "dropmaladd": "PO BOX 80308",
    "dropmalcty": "ATHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306080308,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063693216,
    "dropsitcph": 7063693200,
    "dropfax": 7063693238
  },
  {
    "dcode": "D",
    "dropkey": "PX10056",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "3900 CROWN RD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303049998,
    "dropphyadd": "3900 CROWN RD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303049998,
    "dropmaladd": "3900 CROWN RD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303049998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047657578,
    "dropsitcph": 4047657570,
    "dropfax": 4047657299
  },
  {
    "dcode": "D",
    "dropkey": "PX10062",
    "droptype": "D",
    "dropname": "ATTAPULGUS",
    "dropdeladd": "208 E GRIFFIN AVE",
    "dropdelcty": "ATTAPULGUS",
    "dropdelst": "GA",
    "dropdelzpp": 398159998,
    "dropphyadd": "208 E GRIFFIN AVE",
    "dropphycty": "ATTAPULGUS",
    "dropphyst": "GA",
    "dropphyzpp": 398159998,
    "dropmaladd": "208 E GRIFFIN AVE",
    "dropmalcty": "ATTAPULGUS",
    "dropmalst": "GA",
    "dropmalzpp": 398159998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2294653311,
    "dropsitcph": 2294653311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10063",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "19 COLLEGE ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "GA",
    "dropdelzpp": 300119998,
    "dropphyadd": "19 COLLEGE ST",
    "dropphycty": "AUBURN",
    "dropphyst": "GA",
    "dropphyzpp": 300119998,
    "dropmaladd": "19 COLLEGE ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "GA",
    "dropmalzpp": 300119998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709636081,
    "dropsitcph": 7709636081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10065",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "525 8TH ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309019998,
    "dropphyadd": "525 8TH ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309019998,
    "dropmaladd": "525 8TH ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068233120,
    "dropsitcph": 7068233119,
    "dropfax": 7068231621
  },
  {
    "dcode": "D",
    "dropkey": "PX10066",
    "droptype": "D",
    "dropname": "AUSTELL",
    "dropdeladd": "2847 VETERANS MEMORIAL HWY SW",
    "dropdelcty": "AUSTELL",
    "dropdelst": "GA",
    "dropdelzpp": 301689998,
    "dropphyadd": "2847 VETERANS MEMORIAL HWY SW",
    "dropphycty": "AUSTELL",
    "dropphyst": "GA",
    "dropphyzpp": 301689998,
    "dropmaladd": "2847 VETERANS MEMORIAL HWY SW",
    "dropmalcty": "AUSTELL",
    "dropmalst": "GA",
    "dropmalzpp": 301689998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6789454792,
    "dropsitcph": 6789454792,
    "dropfax": 6789454793
  },
  {
    "dcode": "D",
    "dropkey": "PX10068",
    "droptype": "D",
    "dropname": "AVERA",
    "dropdeladd": "9448 BROAD ST",
    "dropdelcty": "AVERA",
    "dropdelst": "GA",
    "dropdelzpp": 308039998,
    "dropphyadd": "9448 BROAD ST",
    "dropphycty": "AVERA",
    "dropphyst": "GA",
    "dropphyzpp": 308039998,
    "dropmaladd": "9448 BROAD ST",
    "dropmalcty": "AVERA",
    "dropmalst": "GA",
    "dropmalzpp": 308039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065472250,
    "dropsitcph": 7065472250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10071",
    "droptype": "D",
    "dropname": "AVONDALE ESTATES",
    "dropdeladd": "15 FRANKLIN ST",
    "dropdelcty": "AVONDALE ESTATES",
    "dropdelst": "GA",
    "dropdelzpp": 300029998,
    "dropphyadd": "15 FRANKLIN ST",
    "dropphycty": "AVONDALE ESTATES",
    "dropphyst": "GA",
    "dropphyzpp": 300029998,
    "dropmaladd": "15 FRANKLIN ST",
    "dropmalcty": "AVONDALE ESTATES",
    "dropmalst": "GA",
    "dropmalzpp": 300029998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042986793,
    "dropsitcph": 4042997075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10072",
    "droptype": "D",
    "dropname": "AXSON",
    "dropdeladd": "7400 ATKINSON BLVD E",
    "dropdelcty": "AXSON",
    "dropdelst": "GA",
    "dropdelzpp": 316249997,
    "dropphyadd": "7400 ATKINSON BLVD E",
    "dropphycty": "AXSON",
    "dropphyst": "GA",
    "dropphyzpp": 316249997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AXSON",
    "dropmalst": "GA",
    "dropmalzpp": 316249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124227266,
    "dropsitcph": 9124227266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10073",
    "droptype": "D",
    "dropname": "BACONTON",
    "dropdeladd": "140 E WALTON ST",
    "dropdelcty": "BACONTON",
    "dropdelst": "GA",
    "dropdelzpp": 317169998,
    "dropphyadd": "140 E WALTON ST",
    "dropphycty": "BACONTON",
    "dropphyst": "GA",
    "dropphyzpp": 317169998,
    "dropmaladd": "140 E WALTON ST",
    "dropmalcty": "BACONTON",
    "dropmalst": "GA",
    "dropmalzpp": 317169998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297875151,
    "dropsitcph": 2297875151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10074",
    "droptype": "D",
    "dropname": "BAINBRIDGE",
    "dropdeladd": "401 N WEST ST",
    "dropdelcty": "BAINBRIDGE",
    "dropdelst": "GA",
    "dropdelzpp": 398179998,
    "dropphyadd": "401 N WEST ST",
    "dropphycty": "BAINBRIDGE",
    "dropphyst": "GA",
    "dropphyzpp": 398179998,
    "dropmaladd": "401 N WEST ST",
    "dropmalcty": "BAINBRIDGE",
    "dropmalst": "GA",
    "dropmalzpp": 398179998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292438141,
    "dropsitcph": 2292438141,
    "dropfax": 2292438681
  },
  {
    "dcode": "D",
    "dropkey": "PX10078",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "1090 WILLINGHAM AVE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "GA",
    "dropdelzpp": 305119998,
    "dropphyadd": "1090 WILLINGHAM AVE",
    "dropphycty": "BALDWIN",
    "dropphyst": "GA",
    "dropphyzpp": 305119998,
    "dropmaladd": "1090 WILLINGHAM AVE",
    "dropmalcty": "BALDWIN",
    "dropmalst": "GA",
    "dropmalzpp": 305119998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067782751,
    "dropsitcph": 7067782751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10079",
    "droptype": "D",
    "dropname": "BALL GROUND",
    "dropdeladd": "180 VALLEY ST",
    "dropdelcty": "BALL GROUND",
    "dropdelst": "GA",
    "dropdelzpp": 301079998,
    "dropphyadd": "180 VALLEY ST",
    "dropphycty": "BALL GROUND",
    "dropphyst": "GA",
    "dropphyzpp": 301079998,
    "dropmaladd": "180 VALLEY ST",
    "dropmalcty": "BALL GROUND",
    "dropmalst": "GA",
    "dropmalzpp": 301079998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707352990,
    "dropsitcph": 7707352990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10082",
    "droptype": "D",
    "dropname": "BARNESVILLE",
    "dropdeladd": "138 FORSYTH ST",
    "dropdelcty": "BARNESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302049998,
    "dropphyadd": "138 FORSYTH ST",
    "dropphycty": "BARNESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302049998,
    "dropmaladd": "138 FORSYTH ST",
    "dropmalcty": "BARNESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302049998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703580249,
    "dropsitcph": 7703580249,
    "dropfax": 7703587478
  },
  {
    "dcode": "D",
    "dropkey": "PX10086",
    "droptype": "D",
    "dropname": "BARNEY",
    "dropdeladd": "13841 GA HIGHWAY 122",
    "dropdelcty": "BARNEY",
    "dropdelst": "GA",
    "dropdelzpp": 316259998,
    "dropphyadd": "13841 GA HIGHWAY 122",
    "dropphycty": "BARNEY",
    "dropphyst": "GA",
    "dropphyzpp": 316259998,
    "dropmaladd": "13841 GA HIGHWAY 122",
    "dropmalcty": "BARNEY",
    "dropmalst": "GA",
    "dropmalzpp": 316259998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297752371,
    "dropsitcph": 2297752371,
    "dropfax": 2297752437
  },
  {
    "dcode": "D",
    "dropkey": "PX10089",
    "droptype": "D",
    "dropname": "BARTOW",
    "dropdeladd": "1031 N RAILROAD AVE",
    "dropdelcty": "BARTOW",
    "dropdelst": "GA",
    "dropdelzpp": 304139998,
    "dropphyadd": "1031 N RAILROAD AVE",
    "dropphycty": "BARTOW",
    "dropphyst": "GA",
    "dropphyzpp": 304139998,
    "dropmaladd": "1031 N RAILROAD AVE",
    "dropmalcty": "BARTOW",
    "dropmalst": "GA",
    "dropmalzpp": 304139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4783644151,
    "dropsitcph": 4783644151,
    "dropfax": 4783643464
  },
  {
    "dcode": "D",
    "dropkey": "PX10090",
    "droptype": "D",
    "dropname": "BARWICK",
    "dropdeladd": "2032 E MAIN ST",
    "dropdelcty": "BARWICK",
    "dropdelst": "GA",
    "dropdelzpp": 317209998,
    "dropphyadd": "2032 E MAIN ST",
    "dropphycty": "BARWICK",
    "dropphyst": "GA",
    "dropphyzpp": 317209998,
    "dropmaladd": "2032 E MAIN ST",
    "dropmalcty": "BARWICK",
    "dropmalst": "GA",
    "dropmalzpp": 317209998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297353305,
    "dropsitcph": 2297353305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10091",
    "droptype": "D",
    "dropname": "BAXLEY",
    "dropdeladd": "125 N OAK ST",
    "dropdelcty": "BAXLEY",
    "dropdelst": "GA",
    "dropdelzpp": 315139998,
    "dropphyadd": "125 N OAK ST",
    "dropphycty": "BAXLEY",
    "dropphyst": "GA",
    "dropphyzpp": 315139998,
    "dropmaladd": "125 N OAK ST",
    "dropmalcty": "BAXLEY",
    "dropmalst": "GA",
    "dropmalzpp": 315139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123672506,
    "dropsitcph": 9123672506,
    "dropfax": 9123674137
  },
  {
    "dcode": "D",
    "dropkey": "PX10103",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "293 N LANGFORD ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "GA",
    "dropdelzpp": 317229998,
    "dropphyadd": "293 N LANGFORD ST",
    "dropphycty": "BERLIN",
    "dropphyst": "GA",
    "dropphyzpp": 317229998,
    "dropmaladd": "293 N LANGFORD ST",
    "dropmalcty": "BERLIN",
    "dropmalst": "GA",
    "dropmalzpp": 317229998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293242749,
    "dropsitcph": 2293242749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10105",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "820 CHRISTMAS AVE",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "GA",
    "dropdelzpp": 306209998,
    "dropphyadd": "820 CHRISTMAS AVE",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "GA",
    "dropphyzpp": 306209998,
    "dropmaladd": "820 CHRISTMAS AVE",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "GA",
    "dropmalzpp": 306209998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708677621,
    "dropsitcph": 7708677620,
    "dropfax": 7708677622
  },
  {
    "dcode": "D",
    "dropkey": "PX10114",
    "droptype": "D",
    "dropname": "BISHOP",
    "dropdeladd": "4861 MACON HWY",
    "dropdelcty": "BISHOP",
    "dropdelst": "GA",
    "dropdelzpp": 306219998,
    "dropphyadd": "4861 MACON HWY",
    "dropphycty": "BISHOP",
    "dropphyst": "GA",
    "dropphyzpp": 306219998,
    "dropmaladd": "4861 MACON HWY",
    "dropmalcty": "BISHOP",
    "dropmalst": "GA",
    "dropmalzpp": 306219998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067695323,
    "dropsitcph": 7067695323,
    "dropfax": 7063100634
  },
  {
    "dcode": "D",
    "dropkey": "PX10115",
    "droptype": "D",
    "dropname": "BLACKSHEAR",
    "dropdeladd": "327 MAIN ST",
    "dropdelcty": "BLACKSHEAR",
    "dropdelst": "GA",
    "dropdelzpp": 315169998,
    "dropphyadd": "327 MAIN ST",
    "dropphycty": "BLACKSHEAR",
    "dropphyst": "GA",
    "dropphyzpp": 315169998,
    "dropmaladd": "327 MAIN ST",
    "dropmalcty": "BLACKSHEAR",
    "dropmalst": "GA",
    "dropmalzpp": 315169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124498348,
    "dropsitcph": 9124498348,
    "dropfax": 9124498557
  },
  {
    "dcode": "D",
    "dropkey": "PX10117",
    "droptype": "D",
    "dropname": "BLAIRSVILLE",
    "dropdeladd": "345 YOUNG HARRIS ST",
    "dropdelcty": "BLAIRSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305129998,
    "dropphyadd": "345 YOUNG HARRIS ST",
    "dropphycty": "BLAIRSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305129998,
    "dropmaladd": "345 YOUNG HARRIS ST",
    "dropmalcty": "BLAIRSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305129998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064876549,
    "dropsitcph": 7067454123,
    "dropfax": 7067455072
  },
  {
    "dcode": "D",
    "dropkey": "PX10120",
    "droptype": "D",
    "dropname": "BLAKELY",
    "dropdeladd": "2243 S MAIN ST",
    "dropdelcty": "BLAKELY",
    "dropdelst": "GA",
    "dropdelzpp": 398239998,
    "dropphyadd": "2243 S MAIN ST",
    "dropphycty": "BLAKELY",
    "dropphyst": "GA",
    "dropphyzpp": 398239998,
    "dropmaladd": "2243 S MAIN ST",
    "dropmalcty": "BLAKELY",
    "dropmalst": "GA",
    "dropmalzpp": 398239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297247243,
    "dropsitcph": 2297247243,
    "dropfax": 2297238850
  },
  {
    "dcode": "D",
    "dropkey": "PX10122",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "407 E US HIGHWAY 80",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "GA",
    "dropdelzpp": 313029998,
    "dropphyadd": "407 E US HIGHWAY 80",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "GA",
    "dropphyzpp": 313029998,
    "dropmaladd": "407 E US HIGHWAY 80",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "GA",
    "dropmalzpp": 313029998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127486929,
    "dropsitcph": 9127486929,
    "dropfax": 9127482028
  },
  {
    "dcode": "D",
    "dropkey": "PX10124",
    "droptype": "D",
    "dropname": "BLUE RIDGE",
    "dropdeladd": "273 ORVIN LANCE DR",
    "dropdelcty": "BLUE RIDGE",
    "dropdelst": "GA",
    "dropdelzpp": 305139998,
    "dropphyadd": "273 ORVIN LANCE DR",
    "dropphycty": "BLUE RIDGE",
    "dropphyst": "GA",
    "dropphyzpp": 305139998,
    "dropmaladd": "273 ORVIN LANCE DR",
    "dropmalcty": "BLUE RIDGE",
    "dropmalst": "GA",
    "dropmalzpp": 305139998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7622104024,
    "dropsitcph": 7062583337,
    "dropfax": 7702583236
  },
  {
    "dcode": "D",
    "dropkey": "PX10125",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "105 PINE ST N",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "GA",
    "dropdelzpp": 398249998,
    "dropphyadd": "105 PINE ST N",
    "dropphycty": "BLUFFTON",
    "dropphyst": "GA",
    "dropphyzpp": 398249998,
    "dropmaladd": "105 PINE ST N",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "GA",
    "dropmalzpp": 398249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296412155,
    "dropsitcph": 2296412155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10128",
    "droptype": "D",
    "dropname": "BLYTHE",
    "dropdeladd": "141 GIN HOUSE ST",
    "dropdelcty": "BLYTHE",
    "dropdelst": "GA",
    "dropdelzpp": 308059998,
    "dropphyadd": "141 GIN HOUSE ST",
    "dropphycty": "BLYTHE",
    "dropphyst": "GA",
    "dropphyzpp": 308059998,
    "dropmaladd": "141 GIN HOUSE ST",
    "dropmalcty": "BLYTHE",
    "dropmalst": "GA",
    "dropmalzpp": 308059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065923847,
    "dropsitcph": 7065923847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10130",
    "droptype": "D",
    "dropname": "BOGART",
    "dropdeladd": "1551 ATLANTA HWY",
    "dropdelcty": "BOGART",
    "dropdelst": "GA",
    "dropdelzpp": 306229998,
    "dropphyadd": "1551 ATLANTA HWY",
    "dropphycty": "BOGART",
    "dropphyst": "GA",
    "dropphyzpp": 306229998,
    "dropmaladd": "1551 ATLANTA HWY",
    "dropmalcty": "BOGART",
    "dropmalst": "GA",
    "dropmalzpp": 306229998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707257171,
    "dropsitcph": 7707257171,
    "dropfax": 7707250711
  },
  {
    "dcode": "D",
    "dropkey": "PX10131",
    "droptype": "D",
    "dropname": "BOLINGBROKE",
    "dropdeladd": "8043 RIVOLI RD",
    "dropdelcty": "BOLINGBROKE",
    "dropdelst": "GA",
    "dropdelzpp": 310049998,
    "dropphyadd": "8043 RIVOLI RD",
    "dropphycty": "BOLINGBROKE",
    "dropphyst": "GA",
    "dropphyzpp": 310049998,
    "dropmaladd": "8043 RIVOLI RD",
    "dropmalcty": "BOLINGBROKE",
    "dropmalst": "GA",
    "dropmalzpp": 310049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789948272,
    "dropsitcph": 4789948272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10133",
    "droptype": "D",
    "dropname": "BONAIRE",
    "dropdeladd": "604 GA HIGHWAY 247 S",
    "dropdelcty": "BONAIRE",
    "dropdelst": "GA",
    "dropdelzpp": 310059998,
    "dropphyadd": "604 GA HIGHWAY 247 S",
    "dropphycty": "BONAIRE",
    "dropphyst": "GA",
    "dropphyzpp": 310059998,
    "dropmaladd": "604 GA HIGHWAY 247 S",
    "dropmalcty": "BONAIRE",
    "dropmalst": "GA",
    "dropmalzpp": 310059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789232857,
    "dropsitcph": 4789232857,
    "dropfax": 4873290791
  },
  {
    "dcode": "D",
    "dropkey": "PX10135",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "126 N MAIN ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "GA",
    "dropdelzpp": 316269998,
    "dropphyadd": "126 N MAIN ST",
    "dropphycty": "BOSTON",
    "dropphyst": "GA",
    "dropphyzpp": 316269998,
    "dropmaladd": "126 N MAIN ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "GA",
    "dropmalzpp": 316269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292164023,
    "dropsitcph": 2292164023,
    "dropfax": 2294982291
  },
  {
    "dcode": "D",
    "dropkey": "PX10136",
    "droptype": "D",
    "dropname": "BOSTWICK",
    "dropdeladd": "5940 BOSTWICK RD",
    "dropdelcty": "BOSTWICK",
    "dropdelst": "GA",
    "dropdelzpp": 306239900,
    "dropphyadd": "5940 BOSTWICK RD",
    "dropphycty": "BOSTWICK",
    "dropphyst": "GA",
    "dropphyzpp": 306239900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOSTWICK",
    "dropmalst": "GA",
    "dropmalzpp": 306239998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063421893,
    "dropsitcph": 7063421893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10137",
    "droptype": "D",
    "dropname": "BOWDON",
    "dropdeladd": "210 W COLLEGE ST",
    "dropdelcty": "BOWDON",
    "dropdelst": "GA",
    "dropdelzpp": 301089998,
    "dropphyadd": "210 W COLLEGE ST",
    "dropphycty": "BOWDON",
    "dropphyst": "GA",
    "dropphyzpp": 301089998,
    "dropmaladd": "210 W COLLEGE ST",
    "dropmalcty": "BOWDON",
    "dropmalst": "GA",
    "dropmalzpp": 301089998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702582754,
    "dropsitcph": 7702582754,
    "dropfax": 7702583943
  },
  {
    "dcode": "D",
    "dropkey": "PX10139",
    "droptype": "D",
    "dropname": "BOWDON JUNCTION",
    "dropdeladd": "4363 HIGHWAY 27 N",
    "dropdelcty": "BOWDON JUNCTION",
    "dropdelst": "GA",
    "dropdelzpp": 301099997,
    "dropphyadd": "4363 HIGHWAY 27 N",
    "dropphycty": "BOWDON JUNCTION",
    "dropphyst": "GA",
    "dropphyzpp": 301099997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWDON JUNCTION",
    "dropmalst": "GA",
    "dropmalzpp": 301099998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708321712,
    "dropsitcph": 7708321712,
    "dropfax": 7708326093
  },
  {
    "dcode": "D",
    "dropkey": "PX10140",
    "droptype": "D",
    "dropname": "BOWERSVILLE",
    "dropdeladd": "1130 W MAIN ST",
    "dropdelcty": "BOWERSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305161220,
    "dropphyadd": "1130 W MAIN ST",
    "dropphycty": "BOWERSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305161220,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWERSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305169998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062456618,
    "dropsitcph": 7062456618,
    "dropfax": 7062454131
  },
  {
    "dcode": "D",
    "dropkey": "PX10143",
    "droptype": "D",
    "dropname": "BOWMAN",
    "dropdeladd": "21 W CHURCH ST",
    "dropdelcty": "BOWMAN",
    "dropdelst": "GA",
    "dropdelzpp": 306249998,
    "dropphyadd": "21 W CHURCH ST",
    "dropphycty": "BOWMAN",
    "dropphyst": "GA",
    "dropphyzpp": 306249998,
    "dropmaladd": "21 W CHURCH ST",
    "dropmalcty": "BOWMAN",
    "dropmalst": "GA",
    "dropmalzpp": 306249998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062455418,
    "dropsitcph": 7062455418,
    "dropfax": 7062455799
  },
  {
    "dcode": "D",
    "dropkey": "PX10144",
    "droptype": "D",
    "dropname": "BOX SPRINGS",
    "dropdeladd": "6150 COLUMBUS HWY",
    "dropdelcty": "BOX SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 318019998,
    "dropphyadd": "6150 COLUMBUS HWY",
    "dropphycty": "BOX SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 318019998,
    "dropmaladd": "6150 COLUMBUS HWY",
    "dropmalcty": "BOX SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 318019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7062693258,
    "dropsitcph": 7062693258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10152",
    "droptype": "D",
    "dropname": "BRASELTON",
    "dropdeladd": "5216 HIGHWAY 53",
    "dropdelcty": "BRASELTON",
    "dropdelst": "GA",
    "dropdelzpp": 305179998,
    "dropphyadd": "5216 HIGHWAY 53",
    "dropphycty": "BRASELTON",
    "dropphyst": "GA",
    "dropphyzpp": 305179998,
    "dropmaladd": "5216 HIGHWAY 53",
    "dropmalcty": "BRASELTON",
    "dropmalst": "GA",
    "dropmalzpp": 305179998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066543301,
    "dropsitcph": 7066543301,
    "dropfax": 7066541311
  },
  {
    "dcode": "D",
    "dropkey": "PX10153",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "101 TALLAPOOSA ST W",
    "dropdelcty": "BREMEN",
    "dropdelst": "GA",
    "dropdelzpp": 301109998,
    "dropphyadd": "101 TALLAPOOSA ST W",
    "dropphycty": "BREMEN",
    "dropphyst": "GA",
    "dropphyzpp": 301109998,
    "dropmaladd": "101 TALLAPOOSA ST W",
    "dropmalcty": "BREMEN",
    "dropmalst": "GA",
    "dropmalzpp": 301109998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705372459,
    "dropsitcph": 7705372459,
    "dropfax": 7705379888
  },
  {
    "dcode": "D",
    "dropkey": "PX10159",
    "droptype": "D",
    "dropname": "BRINSON",
    "dropdeladd": "122 RUTHERFORD ST",
    "dropdelcty": "BRINSON",
    "dropdelst": "GA",
    "dropdelzpp": 398259998,
    "dropphyadd": "122 RUTHERFORD ST",
    "dropphycty": "BRINSON",
    "dropphyst": "GA",
    "dropphyzpp": 398259998,
    "dropmaladd": "122 RUTHERFORD ST",
    "dropmalcty": "BRINSON",
    "dropmalst": "GA",
    "dropmalzpp": 398259998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292466440,
    "dropsitcph": 2292466440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10160",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "1983 GA HIGHWAY 121",
    "dropdelcty": "BRISTOL",
    "dropdelst": "GA",
    "dropdelzpp": 315189998,
    "dropphyadd": "1983 GA HIGHWAY 121",
    "dropphycty": "BRISTOL",
    "dropphyst": "GA",
    "dropphyzpp": 315189998,
    "dropmaladd": "1983 GA HIGHWAY 121",
    "dropmalcty": "BRISTOL",
    "dropmalst": "GA",
    "dropmalzpp": 315189998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126472177,
    "dropsitcph": 9126472177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10162",
    "droptype": "D",
    "dropname": "BRONWOOD",
    "dropdeladd": "122 GEISE ST S",
    "dropdelcty": "BRONWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 398269998,
    "dropphyadd": "122 GEISE ST S",
    "dropphycty": "BRONWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 398269998,
    "dropmaladd": "122 GEISE ST S",
    "dropmalcty": "BRONWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 398269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2299953555,
    "dropsitcph": 2299953555,
    "dropfax": 2299954768
  },
  {
    "dcode": "D",
    "dropkey": "PX10163",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "999 LOWER BROOKFIELD RD",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 317279998,
    "dropphyadd": "999 LOWER BROOKFIELD RD",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 317279998,
    "dropmaladd": "999 LOWER BROOKFIELD RD",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 317279998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293821977,
    "dropsitcph": 2293821977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10165",
    "droptype": "D",
    "dropname": "BROOKLET",
    "dropdeladd": "129 E LEE ST",
    "dropdelcty": "BROOKLET",
    "dropdelst": "GA",
    "dropdelzpp": 304159998,
    "dropphyadd": "129 E LEE ST",
    "dropphycty": "BROOKLET",
    "dropphyst": "GA",
    "dropphyzpp": 304159998,
    "dropmaladd": "129 E LEE ST",
    "dropmalcty": "BROOKLET",
    "dropmalst": "GA",
    "dropmalzpp": 304159998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124302002,
    "dropsitcph": 9124302007,
    "dropfax": 9128425478
  },
  {
    "dcode": "D",
    "dropkey": "PX10166",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "104 W MCINTOSH RD",
    "dropdelcty": "BROOKS",
    "dropdelst": "GA",
    "dropdelzpp": 302052110,
    "dropphyadd": "104 W MCINTOSH RD",
    "dropphycty": "BROOKS",
    "dropphyst": "GA",
    "dropphyzpp": 302052110,
    "dropmaladd": "104 W MCINTOSH RD",
    "dropmalcty": "BROOKS",
    "dropmalst": "GA",
    "dropmalzpp": 302052110,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707198122,
    "dropsitcph": 7707198122,
    "dropfax": 7707190065
  },
  {
    "dcode": "D",
    "dropkey": "PX10169",
    "droptype": "D",
    "dropname": "BROXTON",
    "dropdeladd": "200 OCMULGEE ST E",
    "dropdelcty": "BROXTON",
    "dropdelst": "GA",
    "dropdelzpp": 315199998,
    "dropphyadd": "200 OCMULGEE ST E",
    "dropphycty": "BROXTON",
    "dropphyst": "GA",
    "dropphyzpp": 315199998,
    "dropmaladd": "200 OCMULGEE ST E",
    "dropmalcty": "BROXTON",
    "dropmalst": "GA",
    "dropmalzpp": 315199998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123592113,
    "dropsitcph": 9123592113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10170",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "805 GLOUCESTER ST",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "GA",
    "dropdelzpp": 315209998,
    "dropphyadd": "805 GLOUCESTER ST",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "GA",
    "dropphyzpp": 315209998,
    "dropmaladd": "805 GLOUCESTER ST",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "GA",
    "dropmalzpp": 315209998,
    "dropsitphn": 4787528444,
    "dropsitlph": 9122801250,
    "dropsitcph": 9122801250,
    "dropfax": 9122801288
  },
  {
    "dcode": "D",
    "dropkey": "PX10171",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "368 CARROLLTON ST",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "GA",
    "dropdelzpp": 301139998,
    "dropphyadd": "368 CARROLLTON ST",
    "dropphycty": "BUCHANAN",
    "dropphyst": "GA",
    "dropphyzpp": 301139998,
    "dropmaladd": "368 CARROLLTON ST",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "GA",
    "dropmalzpp": 301139998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706463827,
    "dropsitcph": 7706463827,
    "dropfax": 7706460926
  },
  {
    "dcode": "D",
    "dropkey": "PX10172",
    "droptype": "D",
    "dropname": "BUCKHEAD",
    "dropdeladd": "1010 RAILROAD ST",
    "dropdelcty": "BUCKHEAD",
    "dropdelst": "GA",
    "dropdelzpp": 306259998,
    "dropphyadd": "1010 RAILROAD ST",
    "dropphycty": "BUCKHEAD",
    "dropphyst": "GA",
    "dropphyzpp": 306259998,
    "dropmaladd": "1010 RAILROAD ST",
    "dropmalcty": "BUCKHEAD",
    "dropmalst": "GA",
    "dropmalzpp": 306259998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063422386,
    "dropsitcph": 7063422386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10173",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "107 E 3RD AVE",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "GA",
    "dropdelzpp": 318039998,
    "dropphyadd": "107 E 3RD AVE",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "GA",
    "dropphyzpp": 318039998,
    "dropmaladd": "107 E 3RD AVE",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "GA",
    "dropmalzpp": 318039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296492757,
    "dropsitcph": 2296492757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10174",
    "droptype": "D",
    "dropname": "BUFORD",
    "dropdeladd": "2030 BUFORD HWY",
    "dropdelcty": "BUFORD",
    "dropdelst": "GA",
    "dropdelzpp": 305189998,
    "dropphyadd": "2030 BUFORD HWY",
    "dropphycty": "BUFORD",
    "dropphyst": "GA",
    "dropphyzpp": 305189998,
    "dropmaladd": "2030 BUFORD HWY",
    "dropmalcty": "BUFORD",
    "dropmalst": "GA",
    "dropmalzpp": 305189998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706141260,
    "dropsitcph": 7706141256,
    "dropfax": 7709453291
  },
  {
    "dcode": "D",
    "dropkey": "PX10178",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "12 E MAIN ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "GA",
    "dropdelzpp": 310069998,
    "dropphyadd": "12 E MAIN ST",
    "dropphycty": "BUTLER",
    "dropphyst": "GA",
    "dropphyzpp": 310069998,
    "dropmaladd": "12 E MAIN ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "GA",
    "dropmalzpp": 310069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788623398,
    "dropsitcph": 4788623398,
    "dropfax": 4788629290
  },
  {
    "dcode": "D",
    "dropkey": "PX10180",
    "droptype": "D",
    "dropname": "BYROMVILLE",
    "dropdeladd": "452 MAIN ST",
    "dropdelcty": "BYROMVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310079998,
    "dropphyadd": "452 MAIN ST",
    "dropphycty": "BYROMVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310079998,
    "dropmaladd": "452 MAIN ST",
    "dropmalcty": "BYROMVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310079998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784336475,
    "dropsitcph": 4784336475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10181",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "215 GA HIGHWAY 49 S",
    "dropdelcty": "BYRON",
    "dropdelst": "GA",
    "dropdelzpp": 310089998,
    "dropphyadd": "215 GA HIGHWAY 49 S",
    "dropphycty": "BYRON",
    "dropphyst": "GA",
    "dropphyzpp": 310089998,
    "dropmaladd": "215 GA HIGHWAY 49 S",
    "dropmalcty": "BYRON",
    "dropmalst": "GA",
    "dropmalzpp": 310089998,
    "dropsitphn": 4787528444,
    "dropsitlph": 4789564006,
    "dropsitcph": 4789564006,
    "dropfax": 4789563646
  },
  {
    "dcode": "D",
    "dropkey": "PX10183",
    "droptype": "D",
    "dropname": "CADWELL",
    "dropdeladd": "1010 COLEMAN ST",
    "dropdelcty": "CADWELL",
    "dropdelst": "GA",
    "dropdelzpp": 310099998,
    "dropphyadd": "1010 COLEMAN ST",
    "dropphycty": "CADWELL",
    "dropphyst": "GA",
    "dropphyzpp": 310099998,
    "dropmaladd": "1010 COLEMAN ST",
    "dropmalcty": "CADWELL",
    "dropmalst": "GA",
    "dropmalzpp": 310099998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786894192,
    "dropsitcph": 4786894192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10184",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "110 1ST ST SW",
    "dropdelcty": "CAIRO",
    "dropdelst": "GA",
    "dropdelzpp": 398289998,
    "dropphyadd": "110 1ST ST SW",
    "dropphycty": "CAIRO",
    "dropphyst": "GA",
    "dropphyzpp": 398289998,
    "dropmaladd": "110 1ST ST SW",
    "dropmalcty": "CAIRO",
    "dropmalst": "GA",
    "dropmalzpp": 398289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293778403,
    "dropsitcph": 2293778403,
    "dropfax": 2293776750
  },
  {
    "dcode": "D",
    "dropkey": "PX10185",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "401 COURT ST",
    "dropdelcty": "CALHOUN",
    "dropdelst": "GA",
    "dropdelzpp": 307019998,
    "dropphyadd": "401 COURT ST",
    "dropphycty": "CALHOUN",
    "dropphyst": "GA",
    "dropphyzpp": 307019998,
    "dropmaladd": "401 COURT ST",
    "dropmalcty": "CALHOUN",
    "dropmalst": "GA",
    "dropmalzpp": 307019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7622046248,
    "dropsitcph": 7066292722,
    "dropfax": 7066021512
  },
  {
    "dcode": "D",
    "dropkey": "PX10186",
    "droptype": "D",
    "dropname": "CALVARY",
    "dropdeladd": "6468 GA HIGHWAY 111 S",
    "dropdelcty": "CALVARY",
    "dropdelst": "GA",
    "dropdelzpp": 398299998,
    "dropphyadd": "6468 GA HIGHWAY 111 S",
    "dropphycty": "CALVARY",
    "dropphyst": "GA",
    "dropphyzpp": 398299998,
    "dropmaladd": "6468 GA HIGHWAY 111 S",
    "dropmalcty": "CALVARY",
    "dropmalst": "GA",
    "dropmalzpp": 398299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298723386,
    "dropsitcph": 2298723386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10187",
    "droptype": "D",
    "dropname": "CAMAK",
    "dropdeladd": "3374 GA HIGHWAY 80 N",
    "dropdelcty": "CAMAK",
    "dropdelst": "GA",
    "dropdelzpp": 308079998,
    "dropphyadd": "3374 GA HIGHWAY 80 N",
    "dropphycty": "CAMAK",
    "dropphyst": "GA",
    "dropphyzpp": 308079998,
    "dropmaladd": "3374 GA HIGHWAY 80 N",
    "dropmalcty": "CAMAK",
    "dropmalst": "GA",
    "dropmalzpp": 308079998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064653969,
    "dropsitcph": 7064653969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10188",
    "droptype": "D",
    "dropname": "CAMILLA",
    "dropdeladd": "13 E BROAD ST",
    "dropdelcty": "CAMILLA",
    "dropdelst": "GA",
    "dropdelzpp": 317309998,
    "dropphyadd": "13 E BROAD ST",
    "dropphycty": "CAMILLA",
    "dropphyst": "GA",
    "dropphyzpp": 317309998,
    "dropmaladd": "13 E BROAD ST",
    "dropmalcty": "CAMILLA",
    "dropmalst": "GA",
    "dropmalzpp": 317309998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293365658,
    "dropsitcph": 2293365658,
    "dropfax": 2293369826
  },
  {
    "dcode": "D",
    "dropkey": "PX10190",
    "droptype": "D",
    "dropname": "CANON",
    "dropdeladd": "46 DEPOT ST",
    "dropdelcty": "CANON",
    "dropdelst": "GA",
    "dropdelzpp": 305209997,
    "dropphyadd": "46 DEPOT ST",
    "dropphycty": "CANON",
    "dropphyst": "GA",
    "dropphyzpp": 305209997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANON",
    "dropmalst": "GA",
    "dropmalzpp": 305209998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063148356,
    "dropsitcph": 7063148356,
    "dropfax": 7062456424
  },
  {
    "dcode": "D",
    "dropkey": "PX10192",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "2400 RIVERSTONE BLVD",
    "dropdelcty": "CANTON",
    "dropdelst": "GA",
    "dropdelzpp": 301149998,
    "dropphyadd": "2400 RIVERSTONE BLVD",
    "dropphycty": "CANTON",
    "dropphyst": "GA",
    "dropphyzpp": 301149998,
    "dropmaladd": "2400 RIVERSTONE BLVD",
    "dropmalcty": "CANTON",
    "dropmalst": "GA",
    "dropmalzpp": 301149998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704795235,
    "dropsitcph": 7707208164,
    "dropfax": 7704792783
  },
  {
    "dcode": "D",
    "dropkey": "PX10197",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "5751 HIGHWAY 72 E",
    "dropdelcty": "CARLTON",
    "dropdelst": "GA",
    "dropdelzpp": 306279998,
    "dropphyadd": "5751 HIGHWAY 72 E",
    "dropphycty": "CARLTON",
    "dropphyst": "GA",
    "dropphyzpp": 306279998,
    "dropmaladd": "5751 HIGHWAY 72 E",
    "dropmalcty": "CARLTON",
    "dropmalst": "GA",
    "dropmalzpp": 306279998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067973244,
    "dropsitcph": 7067973244,
    "dropfax": 7067973512
  },
  {
    "dcode": "D",
    "dropkey": "PX10198",
    "droptype": "D",
    "dropname": "CARNESVILLE",
    "dropdeladd": "9581 LAVONIA RD",
    "dropdelcty": "CARNESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305219997,
    "dropphyadd": "9581 LAVONIA RD",
    "dropphycty": "CARNESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305219997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARNESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305219998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063844314,
    "dropsitcph": 7063844314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10202",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "110 THOMAS NEWELL WAY",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "GA",
    "dropdelzpp": 301179998,
    "dropphyadd": "110 THOMAS NEWELL WAY",
    "dropphycty": "CARROLLTON",
    "dropphyst": "GA",
    "dropphyzpp": 301179998,
    "dropmaladd": "110 THOMAS NEWELL WAY",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "GA",
    "dropmalzpp": 301179998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708344491,
    "dropsitcph": 7708344491,
    "dropfax": 7708340095
  },
  {
    "dcode": "D",
    "dropkey": "PX10204",
    "droptype": "D",
    "dropname": "CARTERSVILLE",
    "dropdeladd": "25 LIBERTY DR",
    "dropdelcty": "CARTERSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301219998,
    "dropphyadd": "25 LIBERTY DR",
    "dropphycty": "CARTERSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301219998,
    "dropmaladd": "25 LIBERTY DR",
    "dropmalcty": "CARTERSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301219998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703827728,
    "dropsitcph": 7703825121,
    "dropfax": 7706068131
  },
  {
    "dcode": "D",
    "dropkey": "PX10208",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "66 FIRE TOWER RD NW",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301239800,
    "dropphyadd": "66 FIRE TOWER RD NW",
    "dropphycty": "CASSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301239998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703822549,
    "dropsitcph": 7703822549,
    "dropfax": 7703865583
  },
  {
    "dcode": "D",
    "dropkey": "PX10212",
    "droptype": "D",
    "dropname": "CATAULA",
    "dropdeladd": "20 PRESTON RD",
    "dropdelcty": "CATAULA",
    "dropdelst": "GA",
    "dropdelzpp": 318049998,
    "dropphyadd": "20 PRESTON RD",
    "dropphycty": "CATAULA",
    "dropphyst": "GA",
    "dropphyzpp": 318049998,
    "dropmaladd": "20 PRESTON RD",
    "dropmalcty": "CATAULA",
    "dropmalst": "GA",
    "dropmalzpp": 318049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7063222032,
    "dropsitcph": 7063222032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10214",
    "droptype": "D",
    "dropname": "CAVE SPRING",
    "dropdeladd": "5 MILL ST SW",
    "dropdelcty": "CAVE SPRING",
    "dropdelst": "GA",
    "dropdelzpp": 301249998,
    "dropphyadd": "5 MILL ST SW",
    "dropphycty": "CAVE SPRING",
    "dropphyst": "GA",
    "dropphyzpp": 301249998,
    "dropmaladd": "5 MILL ST SW",
    "dropmalcty": "CAVE SPRING",
    "dropmalst": "GA",
    "dropmalzpp": 301249998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067778698,
    "dropsitcph": 7067778698,
    "dropfax": 7067771993
  },
  {
    "dcode": "D",
    "dropkey": "PX10215",
    "droptype": "D",
    "dropname": "CECIL",
    "dropdeladd": "51 MAIN ST",
    "dropdelcty": "CECIL",
    "dropdelst": "GA",
    "dropdelzpp": 316279998,
    "dropphyadd": "51 MAIN ST",
    "dropphycty": "CECIL",
    "dropphyst": "GA",
    "dropphyzpp": 316279998,
    "dropmaladd": "51 MAIN ST",
    "dropmalcty": "CECIL",
    "dropmalst": "GA",
    "dropmalzpp": 316279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297941164,
    "dropsitcph": 2297941164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10217",
    "droptype": "D",
    "dropname": "CEDAR SPRINGS",
    "dropdeladd": "21 SHEFFIELD ST",
    "dropdelcty": "CEDAR SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 398329998,
    "dropphyadd": "21 SHEFFIELD ST",
    "dropphycty": "CEDAR SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 398329998,
    "dropmaladd": "21 SHEFFIELD ST",
    "dropmalcty": "CEDAR SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 398329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293724530,
    "dropsitcph": 2293724530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10218",
    "droptype": "D",
    "dropname": "CEDARTOWN",
    "dropdeladd": "145 WEST AVE",
    "dropdelcty": "CEDARTOWN",
    "dropdelst": "GA",
    "dropdelzpp": 301259998,
    "dropphyadd": "145 WEST AVE",
    "dropphycty": "CEDARTOWN",
    "dropphyst": "GA",
    "dropphyzpp": 301259998,
    "dropmaladd": "145 WEST AVE",
    "dropmalcty": "CEDARTOWN",
    "dropmalst": "GA",
    "dropmalzpp": 301259998,
    "dropsitphn": 7707491009,
    "dropsitlph": 7707491009,
    "dropsitcph": 7707484023,
    "dropfax": 7707482922
  },
  {
    "dcode": "D",
    "dropkey": "PX10229",
    "droptype": "D",
    "dropname": "CHATSWORTH",
    "dropdeladd": "120 W FORT ST",
    "dropdelcty": "CHATSWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 307059998,
    "dropphyadd": "120 W FORT ST",
    "dropphycty": "CHATSWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 307059998,
    "dropmaladd": "120 W FORT ST",
    "dropmalcty": "CHATSWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 307059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066951082,
    "dropsitcph": 7066951109,
    "dropfax": 7065172344
  },
  {
    "dcode": "D",
    "dropkey": "PX10231",
    "droptype": "D",
    "dropname": "CHAUNCEY",
    "dropdeladd": "47 DURHAM ST",
    "dropdelcty": "CHAUNCEY",
    "dropdelst": "GA",
    "dropdelzpp": 310119998,
    "dropphyadd": "47 DURHAM ST",
    "dropphycty": "CHAUNCEY",
    "dropphyst": "GA",
    "dropphyzpp": 310119998,
    "dropmaladd": "47 DURHAM ST",
    "dropmalcty": "CHAUNCEY",
    "dropmalst": "GA",
    "dropmalzpp": 310119998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298682766,
    "dropsitcph": 2298682766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10232",
    "droptype": "D",
    "dropname": "CHERRY LOG",
    "dropdeladd": "300 CHERRY LOG ST",
    "dropdelcty": "CHERRY LOG",
    "dropdelst": "GA",
    "dropdelzpp": 305229998,
    "dropphyadd": "300 CHERRY LOG ST",
    "dropphycty": "CHERRY LOG",
    "dropphyst": "GA",
    "dropphyzpp": 305229998,
    "dropmaladd": "300 CHERRY LOG ST",
    "dropmalcty": "CHERRY LOG",
    "dropmalst": "GA",
    "dropmalzpp": 305229998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066352705,
    "dropsitcph": 7066352705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10233",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "220 MAIN ST W",
    "dropdelcty": "CHESTER",
    "dropdelst": "GA",
    "dropdelzpp": 310129998,
    "dropphyadd": "220 MAIN ST W",
    "dropphycty": "CHESTER",
    "dropphyst": "GA",
    "dropphyzpp": 310129998,
    "dropmaladd": "220 MAIN ST W",
    "dropmalcty": "CHESTER",
    "dropmalst": "GA",
    "dropmalzpp": 310129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4783584457,
    "dropsitcph": 4783584457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10236",
    "droptype": "D",
    "dropname": "CHICKAMAUGA",
    "dropdeladd": "207 W 10TH ST",
    "dropdelcty": "CHICKAMAUGA",
    "dropdelst": "GA",
    "dropdelzpp": 307079998,
    "dropphyadd": "207 W 10TH ST",
    "dropphycty": "CHICKAMAUGA",
    "dropphyst": "GA",
    "dropphyzpp": 307079998,
    "dropmaladd": "207 W 10TH ST",
    "dropmalcty": "CHICKAMAUGA",
    "dropmalst": "GA",
    "dropmalzpp": 307079998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7623156113,
    "dropsitcph": 7623156113,
    "dropfax": 7063757793
  },
  {
    "dcode": "D",
    "dropkey": "PX10237",
    "droptype": "D",
    "dropname": "CHULA",
    "dropdeladd": "3272 US HIGHWAY 41 N",
    "dropdelcty": "CHULA",
    "dropdelst": "GA",
    "dropdelzpp": 317339998,
    "dropphyadd": "3272 US HIGHWAY 41 N",
    "dropphycty": "CHULA",
    "dropphyst": "GA",
    "dropphyzpp": 317339998,
    "dropmaladd": "3272 US HIGHWAY 41 N",
    "dropmalcty": "CHULA",
    "dropmalst": "GA",
    "dropmalzpp": 317339998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293829369,
    "dropsitcph": 2293829369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10238",
    "droptype": "D",
    "dropname": "CISCO",
    "dropdeladd": "12539 HIGHWAY 411 N",
    "dropdelcty": "CISCO",
    "dropdelst": "GA",
    "dropdelzpp": 307089998,
    "dropphyadd": "12539 HIGHWAY 411 N",
    "dropphycty": "CISCO",
    "dropphyst": "GA",
    "dropphyzpp": 307089998,
    "dropmaladd": "12539 HIGHWAY 411 N",
    "dropmalcty": "CISCO",
    "dropmalst": "GA",
    "dropmalzpp": 307089998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066959252,
    "dropsitcph": 7066959252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10240",
    "droptype": "D",
    "dropname": "CLARKDALE",
    "dropdeladd": "5071 AUSTELL POWDER SPRINGS RD",
    "dropdelcty": "CLARKDALE",
    "dropdelst": "GA",
    "dropdelzpp": 301119997,
    "dropphyadd": "5071 AUSTELL POWDER SPRINGS RD",
    "dropphycty": "CLARKDALE",
    "dropphyst": "GA",
    "dropphyzpp": 301119997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKDALE",
    "dropmalst": "GA",
    "dropmalzpp": 301119998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709480039,
    "dropsitcph": 7709480039,
    "dropfax": 7709480039
  },
  {
    "dcode": "D",
    "dropkey": "PX10241",
    "droptype": "D",
    "dropname": "CLARKESVILLE",
    "dropdeladd": "250 WASHINGTON ST",
    "dropdelcty": "CLARKESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305239998,
    "dropphyadd": "250 WASHINGTON ST",
    "dropphycty": "CLARKESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305239998,
    "dropmaladd": "250 WASHINGTON ST",
    "dropmalcty": "CLARKESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305239998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067544614,
    "dropsitcph": 7067544614,
    "dropfax": 7067541544
  },
  {
    "dcode": "D",
    "dropkey": "PX10244",
    "droptype": "D",
    "dropname": "CLARKSTON",
    "dropdeladd": "977 MONTREAL RD",
    "dropdelcty": "CLARKSTON",
    "dropdelst": "GA",
    "dropdelzpp": 300219998,
    "dropphyadd": "977 MONTREAL RD",
    "dropphycty": "CLARKSTON",
    "dropphyst": "GA",
    "dropphyzpp": 300219998,
    "dropmaladd": "977 MONTREAL RD",
    "dropmalcty": "CLARKSTON",
    "dropmalst": "GA",
    "dropmalzpp": 300219998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042963169,
    "dropsitcph": 4042962505,
    "dropfax": 4042992251
  },
  {
    "dcode": "D",
    "dropkey": "PX10245",
    "droptype": "D",
    "dropname": "CLAXTON",
    "dropdeladd": "7 COURTHOUSE ST",
    "dropdelcty": "CLAXTON",
    "dropdelst": "GA",
    "dropdelzpp": 304179998,
    "dropphyadd": "7 COURTHOUSE ST",
    "dropphycty": "CLAXTON",
    "dropphyst": "GA",
    "dropphyzpp": 304179998,
    "dropmaladd": "7 COURTHOUSE ST",
    "dropmalcty": "CLAXTON",
    "dropmalst": "GA",
    "dropmalzpp": 304179998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127397188,
    "dropsitcph": 9127397188,
    "dropfax": 9127390988
  },
  {
    "dcode": "D",
    "dropkey": "PX10246",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "GA",
    "dropdelzpp": 305259998,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "GA",
    "dropphyzpp": 305259998,
    "dropmaladd": "125 N MAIN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "GA",
    "dropmalzpp": 305259998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067827859,
    "dropsitcph": 7067825795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10247",
    "droptype": "D",
    "dropname": "CLERMONT",
    "dropdeladd": "430 MAIN ST",
    "dropdelcty": "CLERMONT",
    "dropdelst": "GA",
    "dropdelzpp": 305279998,
    "dropphyadd": "430 MAIN ST",
    "dropphycty": "CLERMONT",
    "dropphyst": "GA",
    "dropphyzpp": 305279998,
    "dropmaladd": "430 MAIN ST",
    "dropmalcty": "CLERMONT",
    "dropmalst": "GA",
    "dropmalzpp": 305279998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709833251,
    "dropsitcph": 7709833251,
    "dropfax": 7709830588
  },
  {
    "dcode": "D",
    "dropkey": "PX10248",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "116 HELEN HWY",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "GA",
    "dropdelzpp": 305289998,
    "dropphyadd": "116 HELEN HWY",
    "dropphycty": "CLEVELAND",
    "dropphyst": "GA",
    "dropphyzpp": 305289998,
    "dropmaladd": "116 HELEN HWY",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "GA",
    "dropmalzpp": 305289998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068654994,
    "dropsitcph": 7068654511,
    "dropfax": 7068654725
  },
  {
    "dcode": "D",
    "dropkey": "PX10253",
    "droptype": "D",
    "dropname": "CLINCHFIELD",
    "dropdeladd": "2620 S US HIGHWAY 341",
    "dropdelcty": "CLINCHFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 310139998,
    "dropphyadd": "2620 S US HIGHWAY 341",
    "dropphycty": "CLINCHFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 310139998,
    "dropmaladd": "2620 S US HIGHWAY 341",
    "dropmalcty": "CLINCHFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 310139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789870107,
    "dropsitcph": 4789870107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10256",
    "droptype": "D",
    "dropname": "CLYO",
    "dropdeladd": "5662 GA HIGHWAY 119 N",
    "dropdelcty": "CLYO",
    "dropdelst": "GA",
    "dropdelzpp": 313039998,
    "dropphyadd": "5662 GA HIGHWAY 119 N",
    "dropphycty": "CLYO",
    "dropphyst": "GA",
    "dropphyzpp": 313039998,
    "dropmaladd": "5662 GA HIGHWAY 119 N",
    "dropmalcty": "CLYO",
    "dropmalst": "GA",
    "dropmalzpp": 313039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127549391,
    "dropsitcph": 9127549391,
    "dropfax": 9127549391
  },
  {
    "dcode": "D",
    "dropkey": "PX10257",
    "droptype": "D",
    "dropname": "COBB",
    "dropdeladd": "106 PRYOR COBB RD",
    "dropdelcty": "COBB",
    "dropdelst": "GA",
    "dropdelzpp": 317359998,
    "dropphyadd": "106 PRYOR COBB RD",
    "dropphycty": "COBB",
    "dropphyst": "GA",
    "dropphyzpp": 317359998,
    "dropmaladd": "106 PRYOR COBB RD",
    "dropmalcty": "COBB",
    "dropmalst": "GA",
    "dropmalzpp": 317359998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298535785,
    "dropsitcph": 2298535785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10258",
    "droptype": "D",
    "dropname": "COBBTOWN",
    "dropdeladd": "6888 MAIN ST",
    "dropdelcty": "COBBTOWN",
    "dropdelst": "GA",
    "dropdelzpp": 304209998,
    "dropphyadd": "6888 MAIN ST",
    "dropphycty": "COBBTOWN",
    "dropphyst": "GA",
    "dropphyzpp": 304209998,
    "dropmaladd": "6888 MAIN ST",
    "dropmalcty": "COBBTOWN",
    "dropmalst": "GA",
    "dropmalzpp": 304209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126845510,
    "dropsitcph": 9126845510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10259",
    "droptype": "D",
    "dropname": "COCHRAN",
    "dropdeladd": "105 N 2ND ST",
    "dropdelcty": "COCHRAN",
    "dropdelst": "GA",
    "dropdelzpp": 310149998,
    "dropphyadd": "105 N 2ND ST",
    "dropphycty": "COCHRAN",
    "dropphyst": "GA",
    "dropphyzpp": 310149998,
    "dropmaladd": "105 N 2ND ST",
    "dropmalcty": "COCHRAN",
    "dropmalst": "GA",
    "dropmalzpp": 310149998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789347587,
    "dropsitcph": 4789347587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10261",
    "droptype": "D",
    "dropname": "COHUTTA",
    "dropdeladd": "325 WOLFE ST",
    "dropdelcty": "COHUTTA",
    "dropdelst": "GA",
    "dropdelzpp": 307109998,
    "dropphyadd": "325 WOLFE ST",
    "dropphycty": "COHUTTA",
    "dropphyst": "GA",
    "dropphyzpp": 307109998,
    "dropmaladd": "325 WOLFE ST",
    "dropmalcty": "COHUTTA",
    "dropmalst": "GA",
    "dropmalzpp": 307109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066948385,
    "dropsitcph": 7066948385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10263",
    "droptype": "D",
    "dropname": "COLBERT",
    "dropdeladd": "85 S 4TH ST",
    "dropdelcty": "COLBERT",
    "dropdelst": "GA",
    "dropdelzpp": 306289998,
    "dropphyadd": "85 S 4TH ST",
    "dropphycty": "COLBERT",
    "dropphyst": "GA",
    "dropphyzpp": 306289998,
    "dropmaladd": "85 S 4TH ST",
    "dropmalcty": "COLBERT",
    "dropmalst": "GA",
    "dropmalzpp": 306289998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067882275,
    "dropsitcph": 7067882275,
    "dropfax": 7067882275
  },
  {
    "dcode": "D",
    "dropkey": "PX10264",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "2623 BAY ST",
    "dropdelcty": "COLEMAN",
    "dropdelst": "GA",
    "dropdelzpp": 398369997,
    "dropphyadd": "2623 BAY ST",
    "dropphycty": "COLEMAN",
    "dropphyst": "GA",
    "dropphyzpp": 398369997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLEMAN",
    "dropmalst": "GA",
    "dropmalzpp": 398369998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297323076,
    "dropsitcph": 2297323076,
    "dropfax": 2297323076
  },
  {
    "dcode": "D",
    "dropkey": "PX10271",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "225 S MAIN ST",
    "dropdelcty": "COLLINS",
    "dropdelst": "GA",
    "dropdelzpp": 304219998,
    "dropphyadd": "225 S MAIN ST",
    "dropphycty": "COLLINS",
    "dropphyst": "GA",
    "dropphyzpp": 304219998,
    "dropmaladd": "225 S MAIN ST",
    "dropmalcty": "COLLINS",
    "dropmalst": "GA",
    "dropmalzpp": 304219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126936249,
    "dropsitcph": 9126936249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10272",
    "droptype": "D",
    "dropname": "COLQUITT",
    "dropdeladd": "103 W COLLEGE ST",
    "dropdelcty": "COLQUITT",
    "dropdelst": "GA",
    "dropdelzpp": 398379998,
    "dropphyadd": "103 W COLLEGE ST",
    "dropphycty": "COLQUITT",
    "dropphyst": "GA",
    "dropphyzpp": 398379998,
    "dropmaladd": "103 W COLLEGE ST",
    "dropmalcty": "COLQUITT",
    "dropmalst": "GA",
    "dropmalzpp": 398379998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297582546,
    "dropsitcph": 2297582546,
    "dropfax": 2297583047
  },
  {
    "dcode": "D",
    "dropkey": "PX10274",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3916 MILGEN RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079998,
    "dropphyadd": "3916 MILGEN RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319079998,
    "dropmaladd": "3916 MILGEN RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319079998,
    "dropsitphn": 4787528444,
    "dropsitlph": 7065621782,
    "dropsitcph": 7065621782,
    "dropfax": 7065621784
  },
  {
    "dcode": "D",
    "dropkey": "PX10275",
    "droptype": "D",
    "dropname": "COMER",
    "dropdeladd": "10 HIGHWAY 72 E",
    "dropdelcty": "COMER",
    "dropdelst": "GA",
    "dropdelzpp": 306299998,
    "dropphyadd": "10 HIGHWAY 72 E",
    "dropphycty": "COMER",
    "dropphyst": "GA",
    "dropphyzpp": 306299998,
    "dropmaladd": "10 HIGHWAY 72 E",
    "dropmalcty": "COMER",
    "dropmalst": "GA",
    "dropmalzpp": 306299998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067834075,
    "dropsitcph": 7067834075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10276",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "424 LITTLE ST",
    "dropdelcty": "COMMERCE",
    "dropdelst": "GA",
    "dropdelzpp": 305299998,
    "dropphyadd": "424 LITTLE ST",
    "dropphycty": "COMMERCE",
    "dropphyst": "GA",
    "dropphyzpp": 305299998,
    "dropmaladd": "424 LITTLE ST",
    "dropmalcty": "COMMERCE",
    "dropmalst": "GA",
    "dropmalzpp": 305299998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063359584,
    "dropsitcph": 7063353566,
    "dropfax": 7063356895
  },
  {
    "dcode": "D",
    "dropkey": "PX10277",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "GA",
    "dropdelzpp": 302069998,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "CONCORD",
    "dropphyst": "GA",
    "dropphyzpp": 302069998,
    "dropmaladd": "12 MAIN ST",
    "dropmalcty": "CONCORD",
    "dropmalst": "GA",
    "dropmalzpp": 302069998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708845674,
    "dropsitcph": 7708845674,
    "dropfax": 7708845674
  },
  {
    "dcode": "D",
    "dropkey": "PX10279",
    "droptype": "D",
    "dropname": "CONLEY",
    "dropdeladd": "1333 CEDAR GROVE RD",
    "dropdelcty": "CONLEY",
    "dropdelst": "GA",
    "dropdelzpp": 302889998,
    "dropphyadd": "1333 CEDAR GROVE RD",
    "dropphycty": "CONLEY",
    "dropphyst": "GA",
    "dropphyzpp": 302889998,
    "dropmaladd": "1333 CEDAR GROVE RD",
    "dropmalcty": "CONLEY",
    "dropmalst": "GA",
    "dropmalzpp": 302889998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043633585,
    "dropsitcph": 4043633585,
    "dropfax": 4043630965
  },
  {
    "dcode": "D",
    "dropkey": "PX10280",
    "droptype": "D",
    "dropname": "CONYERS",
    "dropdeladd": "1705 HIGHWAY 138 SE",
    "dropdelcty": "CONYERS",
    "dropdelst": "GA",
    "dropdelzpp": 300139998,
    "dropphyadd": "1705 HIGHWAY 138 SE",
    "dropphycty": "CONYERS",
    "dropphyst": "GA",
    "dropphyzpp": 300139998,
    "dropmaladd": "1705 HIGHWAY 138 SE",
    "dropmalcty": "CONYERS",
    "dropmalst": "GA",
    "dropmalzpp": 300139998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709290569,
    "dropsitcph": 7709226515,
    "dropfax": 7709290346
  },
  {
    "dcode": "D",
    "dropkey": "PX10281",
    "droptype": "D",
    "dropname": "COOLIDGE",
    "dropdeladd": "1020 W STETSON AVE",
    "dropdelcty": "COOLIDGE",
    "dropdelst": "GA",
    "dropdelzpp": 317389998,
    "dropphyadd": "1020 W STETSON AVE",
    "dropphycty": "COOLIDGE",
    "dropphyst": "GA",
    "dropphyzpp": 317389998,
    "dropmaladd": "1020 W STETSON AVE",
    "dropmalcty": "COOLIDGE",
    "dropmalst": "GA",
    "dropmalzpp": 317389998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293463726,
    "dropsitcph": 2293463726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10283",
    "droptype": "D",
    "dropname": "COOSA",
    "dropdeladd": "4000 ALABAMA HWY NW",
    "dropdelcty": "COOSA",
    "dropdelst": "GA",
    "dropdelzpp": 301299800,
    "dropphyadd": "4000 ALABAMA HWY NW",
    "dropphycty": "COOSA",
    "dropphyst": "GA",
    "dropphyzpp": 301299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOSA",
    "dropmalst": "GA",
    "dropmalzpp": 301299998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062344562,
    "dropsitcph": 7062344562,
    "dropfax": 7068021473
  },
  {
    "dcode": "D",
    "dropkey": "PX10284",
    "droptype": "D",
    "dropname": "CORDELE",
    "dropdeladd": "102 S 6TH ST",
    "dropdelcty": "CORDELE",
    "dropdelst": "GA",
    "dropdelzpp": 310159998,
    "dropphyadd": "102 S 6TH ST",
    "dropphycty": "CORDELE",
    "dropphyst": "GA",
    "dropphyzpp": 310159998,
    "dropmaladd": "102 S 6TH ST",
    "dropmalcty": "CORDELE",
    "dropmalst": "GA",
    "dropmalzpp": 310159998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2292713768,
    "dropsitcph": 2292713768,
    "dropfax": 2292733599
  },
  {
    "dcode": "D",
    "dropkey": "PX10285",
    "droptype": "D",
    "dropname": "CORNELIA",
    "dropdeladd": "407 CORNELIA PLAZA DR",
    "dropdelcty": "CORNELIA",
    "dropdelst": "GA",
    "dropdelzpp": 305319998,
    "dropphyadd": "407 CORNELIA PLAZA DR",
    "dropphycty": "CORNELIA",
    "dropphyst": "GA",
    "dropphyzpp": 305319998,
    "dropmaladd": "407 CORNELIA PLAZA DR",
    "dropmalcty": "CORNELIA",
    "dropmalst": "GA",
    "dropmalzpp": 305319998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067765966,
    "dropsitcph": 7067784714,
    "dropfax": 7067766495
  },
  {
    "dcode": "D",
    "dropkey": "PX10289",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "2131 STALLINGS ST NW",
    "dropdelcty": "COVINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 300149998,
    "dropphyadd": "2131 STALLINGS ST NW",
    "dropphycty": "COVINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 300149998,
    "dropmaladd": "2131 STALLINGS ST NW",
    "dropmalcty": "COVINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 300149998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707862707,
    "dropsitcph": 7707862707,
    "dropfax": 7707863619
  },
  {
    "dcode": "D",
    "dropkey": "PX10293",
    "droptype": "D",
    "dropname": "CRANDALL",
    "dropdeladd": "6410 HIGHWAY 411 N",
    "dropdelcty": "CRANDALL",
    "dropdelst": "GA",
    "dropdelzpp": 307119998,
    "dropphyadd": "6410 HIGHWAY 411 N",
    "dropphycty": "CRANDALL",
    "dropphyst": "GA",
    "dropphyzpp": 307119998,
    "dropmaladd": "6410 HIGHWAY 411 N",
    "dropmalcty": "CRANDALL",
    "dropmalst": "GA",
    "dropmalzpp": 307119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066959307,
    "dropsitcph": 7066959307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10294",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "1089 ATHENS RD",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "GA",
    "dropdelzpp": 306309998,
    "dropphyadd": "1089 ATHENS RD",
    "dropphycty": "CRAWFORD",
    "dropphyst": "GA",
    "dropphyzpp": 306309998,
    "dropmaladd": "1089 ATHENS RD",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "GA",
    "dropmalzpp": 306309998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067435972,
    "dropsitcph": 7067435972,
    "dropfax": 7067437087
  },
  {
    "dcode": "D",
    "dropkey": "PX10295",
    "droptype": "D",
    "dropname": "CRAWFORDVILLE",
    "dropdeladd": "139 BROAD ST NE",
    "dropdelcty": "CRAWFORDVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 306319998,
    "dropphyadd": "139 BROAD ST NE",
    "dropphycty": "CRAWFORDVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 306319998,
    "dropmaladd": "139 BROAD ST NE",
    "dropmalcty": "CRAWFORDVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 306319998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064562281,
    "dropsitcph": 7064562281,
    "dropfax": 7064563015
  },
  {
    "dcode": "D",
    "dropkey": "PX10298",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "4236 GA HIGHWAY 99",
    "dropdelcty": "CRESCENT",
    "dropdelst": "GA",
    "dropdelzpp": 313049997,
    "dropphyadd": "4236 GA HIGHWAY 99",
    "dropphycty": "CRESCENT",
    "dropphyst": "GA",
    "dropphyzpp": 313049997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESCENT",
    "dropmalst": "GA",
    "dropmalzpp": 313049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128322039,
    "dropsitcph": 9128322039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10303",
    "droptype": "D",
    "dropname": "CULLODEN",
    "dropdeladd": "34 KNOXVILLE ST",
    "dropdelcty": "CULLODEN",
    "dropdelst": "GA",
    "dropdelzpp": 310169998,
    "dropphyadd": "34 KNOXVILLE ST",
    "dropphycty": "CULLODEN",
    "dropphyst": "GA",
    "dropphyzpp": 310169998,
    "dropmaladd": "34 KNOXVILLE ST",
    "dropmalcty": "CULLODEN",
    "dropmalst": "GA",
    "dropmalzpp": 310169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788852233,
    "dropsitcph": 4788852233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10308",
    "droptype": "D",
    "dropname": "CUMMING",
    "dropdeladd": "525 TRIBBLE GAP RD",
    "dropdelcty": "CUMMING",
    "dropdelst": "GA",
    "dropdelzpp": 300409998,
    "dropphyadd": "525 TRIBBLE GAP RD",
    "dropphycty": "CUMMING",
    "dropphyst": "GA",
    "dropphyzpp": 300409998,
    "dropmaladd": "525 TRIBBLE GAP RD",
    "dropmalcty": "CUMMING",
    "dropmalst": "GA",
    "dropmalzpp": 300409998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6789651096,
    "dropsitcph": 7708862388,
    "dropfax": 7708871828
  },
  {
    "dcode": "D",
    "dropkey": "PX10309",
    "droptype": "D",
    "dropname": "CUSSETA",
    "dropdeladd": "173 WELLS ST",
    "dropdelcty": "CUSSETA",
    "dropdelst": "GA",
    "dropdelzpp": 318059998,
    "dropphyadd": "173 WELLS ST",
    "dropphycty": "CUSSETA",
    "dropphyst": "GA",
    "dropphyzpp": 318059998,
    "dropmaladd": "173 WELLS ST",
    "dropmalcty": "CUSSETA",
    "dropmalst": "GA",
    "dropmalzpp": 318059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7069894101,
    "dropsitcph": 7069894101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10311",
    "droptype": "D",
    "dropname": "CUTHBERT",
    "dropdeladd": "23 COURT ST",
    "dropdelcty": "CUTHBERT",
    "dropdelst": "GA",
    "dropdelzpp": 398409998,
    "dropphyadd": "23 COURT ST",
    "dropphycty": "CUTHBERT",
    "dropphyst": "GA",
    "dropphyzpp": 398409998,
    "dropmaladd": "23 COURT ST",
    "dropmalcty": "CUTHBERT",
    "dropmalst": "GA",
    "dropmalzpp": 398409998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297323642,
    "dropsitcph": 2297323642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10312",
    "droptype": "D",
    "dropname": "DACULA",
    "dropdeladd": "470 DACULA RD",
    "dropdelcty": "DACULA",
    "dropdelst": "GA",
    "dropdelzpp": 300199998,
    "dropphyadd": "470 DACULA RD",
    "dropphycty": "DACULA",
    "dropphyst": "GA",
    "dropphyzpp": 300199998,
    "dropmaladd": "470 DACULA RD",
    "dropmalcty": "DACULA",
    "dropmalst": "GA",
    "dropmalzpp": 300199998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709951459,
    "dropsitcph": 7709624390,
    "dropfax": 7709956286
  },
  {
    "dcode": "D",
    "dropkey": "PX10313",
    "droptype": "D",
    "dropname": "DAHLONEGA",
    "dropdeladd": "72 ALICIA LN",
    "dropdelcty": "DAHLONEGA",
    "dropdelst": "GA",
    "dropdelzpp": 305339998,
    "dropphyadd": "72 ALICIA LN",
    "dropphycty": "DAHLONEGA",
    "dropphyst": "GA",
    "dropphyzpp": 305339998,
    "dropmaladd": "72 ALICIA LN",
    "dropmalcty": "DAHLONEGA",
    "dropmalst": "GA",
    "dropmalzpp": 305339998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068644738,
    "dropsitcph": 7068642517,
    "dropfax": 7068645276
  },
  {
    "dcode": "D",
    "dropkey": "PX10314",
    "droptype": "D",
    "dropname": "DAISY",
    "dropdeladd": "306 RAILROAD ST",
    "dropdelcty": "DAISY",
    "dropdelst": "GA",
    "dropdelzpp": 304239998,
    "dropphyadd": "306 RAILROAD ST",
    "dropphycty": "DAISY",
    "dropphyst": "GA",
    "dropphyzpp": 304239998,
    "dropmaladd": "306 RAILROAD ST",
    "dropmalcty": "DAISY",
    "dropmalst": "GA",
    "dropmalzpp": 304239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127391022,
    "dropsitcph": 9127391022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10315",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "280 MERCHANTS DR",
    "dropdelcty": "DALLAS",
    "dropdelst": "GA",
    "dropdelzpp": 301329998,
    "dropphyadd": "280 MERCHANTS DR",
    "dropphycty": "DALLAS",
    "dropphyst": "GA",
    "dropphyzpp": 301329998,
    "dropmaladd": "280 MERCHANTS DR",
    "dropmalcty": "DALLAS",
    "dropmalst": "GA",
    "dropmalzpp": 301329998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6783637633,
    "dropsitcph": 6783638416,
    "dropfax": 6783638231
  },
  {
    "dcode": "D",
    "dropkey": "PX10317",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "100 S THORNTON AVE",
    "dropdelcty": "DALTON",
    "dropdelst": "GA",
    "dropdelzpp": 307209998,
    "dropphyadd": "100 S THORNTON AVE",
    "dropphycty": "DALTON",
    "dropphyst": "GA",
    "dropphyzpp": 307209998,
    "dropmaladd": "100 S THORNTON AVE",
    "dropmalcty": "DALTON",
    "dropmalst": "GA",
    "dropmalzpp": 307209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7622095502,
    "dropsitcph": 7062790751,
    "dropfax": 7062756087
  },
  {
    "dcode": "D",
    "dropkey": "PX10318",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "1290 SAMMONS ST",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "GA",
    "dropdelzpp": 398419998,
    "dropphyadd": "1290 SAMMONS ST",
    "dropphycty": "DAMASCUS",
    "dropphyst": "GA",
    "dropphyzpp": 398419998,
    "dropmaladd": "1290 SAMMONS ST",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "GA",
    "dropmalzpp": 398419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297254158,
    "dropsitcph": 2297254158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10320",
    "droptype": "D",
    "dropname": "DANIELSVILLE",
    "dropdeladd": "44 GENERAL DANIEL AVE S",
    "dropdelcty": "DANIELSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 306339998,
    "dropphyadd": "44 GENERAL DANIEL AVE S",
    "dropphycty": "DANIELSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 306339998,
    "dropmaladd": "44 GENERAL DANIEL AVE S",
    "dropmalcty": "DANIELSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 306339998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067955888,
    "dropsitcph": 7067952763,
    "dropfax": 7067955502
  },
  {
    "dcode": "D",
    "dropkey": "PX10324",
    "droptype": "D",
    "dropname": "DARIEN",
    "dropdeladd": "501 NORTH WAY",
    "dropdelcty": "DARIEN",
    "dropdelst": "GA",
    "dropdelzpp": 313059998,
    "dropphyadd": "501 NORTH WAY",
    "dropphycty": "DARIEN",
    "dropphyst": "GA",
    "dropphyzpp": 313059998,
    "dropmaladd": "501 NORTH WAY",
    "dropmalcty": "DARIEN",
    "dropmalst": "GA",
    "dropmalzpp": 313059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124374001,
    "dropsitcph": 9124374001,
    "dropfax": 9124376331
  },
  {
    "dcode": "D",
    "dropkey": "PX10326",
    "droptype": "D",
    "dropname": "DAVISBORO",
    "dropdeladd": "118 N MAIN ST",
    "dropdelcty": "DAVISBORO",
    "dropdelst": "GA",
    "dropdelzpp": 310189998,
    "dropphyadd": "118 N MAIN ST",
    "dropphycty": "DAVISBORO",
    "dropphyst": "GA",
    "dropphyzpp": 310189998,
    "dropmaladd": "118 N MAIN ST",
    "dropmalcty": "DAVISBORO",
    "dropmalst": "GA",
    "dropmalzpp": 310189998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4783484096,
    "dropsitcph": 4783484096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10327",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "124 STONEWALL ST SE",
    "dropdelcty": "DAWSON",
    "dropdelst": "GA",
    "dropdelzpp": 398429998,
    "dropphyadd": "124 STONEWALL ST SE",
    "dropphycty": "DAWSON",
    "dropphyst": "GA",
    "dropphyzpp": 398429998,
    "dropmaladd": "124 STONEWALL ST SE",
    "dropmalcty": "DAWSON",
    "dropmalst": "GA",
    "dropmalzpp": 398429998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2299956193,
    "dropsitcph": 2299956193,
    "dropfax": 2299953799
  },
  {
    "dcode": "D",
    "dropkey": "PX10328",
    "droptype": "D",
    "dropname": "DAWSONVILLE",
    "dropdeladd": "452 HIGHWAY 53 E",
    "dropdelcty": "DAWSONVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305344047,
    "dropphyadd": "452 HIGHWAY 53 E",
    "dropphycty": "DAWSONVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305344047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWSONVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305349998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062651679,
    "dropsitcph": 7062652677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10331",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "360 BAGLEY ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "GA",
    "dropdelzpp": 317439998,
    "dropphyadd": "360 BAGLEY ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "GA",
    "dropphyzpp": 317439998,
    "dropmaladd": "360 BAGLEY ST",
    "dropmalcty": "DE SOTO",
    "dropmalst": "GA",
    "dropmalzpp": 317439998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298747176,
    "dropsitcph": 2298747176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10332",
    "droptype": "D",
    "dropname": "DEARING",
    "dropdeladd": "4479 AUGUSTA HWY",
    "dropdelcty": "DEARING",
    "dropdelst": "GA",
    "dropdelzpp": 308089998,
    "dropphyadd": "4479 AUGUSTA HWY",
    "dropphycty": "DEARING",
    "dropphyst": "GA",
    "dropphyzpp": 308089998,
    "dropmaladd": "4479 AUGUSTA HWY",
    "dropmalcty": "DEARING",
    "dropmalst": "GA",
    "dropmalzpp": 308089998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065560257,
    "dropsitcph": 7065560257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10333",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "520 W PONCE DE LEON AVE",
    "dropdelcty": "DECATUR",
    "dropdelst": "GA",
    "dropdelzpp": 300309998,
    "dropphyadd": "520 W PONCE DE LEON AVE",
    "dropphycty": "DECATUR",
    "dropphyst": "GA",
    "dropphyzpp": 300309998,
    "dropmaladd": "520 W PONCE DE LEON AVE",
    "dropmalcty": "DECATUR",
    "dropmalst": "GA",
    "dropmalzpp": 300309998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043708305,
    "dropsitcph": 4043708300,
    "dropfax": 4043708350
  },
  {
    "dcode": "D",
    "dropkey": "PX10337",
    "droptype": "D",
    "dropname": "DEMOREST",
    "dropdeladd": "550 GEORGIA ST",
    "dropdelcty": "DEMOREST",
    "dropdelst": "GA",
    "dropdelzpp": 305359998,
    "dropphyadd": "550 GEORGIA ST",
    "dropphycty": "DEMOREST",
    "dropphyst": "GA",
    "dropphyzpp": 305359998,
    "dropmaladd": "550 GEORGIA ST",
    "dropmalcty": "DEMOREST",
    "dropmalst": "GA",
    "dropmalzpp": 305359998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067788479,
    "dropsitcph": 7067788479,
    "dropfax": 7067761619
  },
  {
    "dcode": "D",
    "dropkey": "PX10339",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "5 E GEORGIA AVE",
    "dropdelcty": "DENTON",
    "dropdelst": "GA",
    "dropdelzpp": 315329998,
    "dropphyadd": "5 E GEORGIA AVE",
    "dropphycty": "DENTON",
    "dropphyst": "GA",
    "dropphyzpp": 315329998,
    "dropmaladd": "5 E GEORGIA AVE",
    "dropmalcty": "DENTON",
    "dropmalst": "GA",
    "dropmalzpp": 315329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123755971,
    "dropsitcph": 9123755971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10341",
    "droptype": "D",
    "dropname": "DEWY ROSE",
    "dropdeladd": "2189 BOWMAN HWY NW",
    "dropdelcty": "DEWY ROSE",
    "dropdelst": "GA",
    "dropdelzpp": 306349998,
    "dropphyadd": "2189 BOWMAN HWY NW",
    "dropphycty": "DEWY ROSE",
    "dropphyst": "GA",
    "dropphyzpp": 306349998,
    "dropmaladd": "2189 BOWMAN HWY NW",
    "dropmalcty": "DEWY ROSE",
    "dropmalst": "GA",
    "dropmalzpp": 306349998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062836613,
    "dropsitcph": 7062836613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10342",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "GA",
    "dropdelzpp": 310199998,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "DEXTER",
    "dropphyst": "GA",
    "dropphyzpp": 310199998,
    "dropmaladd": "202 E MAIN ST",
    "dropmalcty": "DEXTER",
    "dropmalst": "GA",
    "dropmalzpp": 310199998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788751567,
    "dropsitcph": 4788751567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10343",
    "droptype": "D",
    "dropname": "DILLARD",
    "dropdeladd": "6971 HIGHWAY 441 N",
    "dropdelcty": "DILLARD",
    "dropdelst": "GA",
    "dropdelzpp": 305379998,
    "dropphyadd": "6971 HIGHWAY 441 N",
    "dropphycty": "DILLARD",
    "dropphyst": "GA",
    "dropphyzpp": 305379998,
    "dropmaladd": "6971 HIGHWAY 441 N",
    "dropmalcty": "DILLARD",
    "dropmalst": "GA",
    "dropmalzpp": 305379998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067462519,
    "dropsitcph": 7067462519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10344",
    "droptype": "D",
    "dropname": "DIXIE",
    "dropdeladd": "5308 DIXIE RD",
    "dropdelcty": "DIXIE",
    "dropdelst": "GA",
    "dropdelzpp": 316299998,
    "dropphyadd": "5308 DIXIE RD",
    "dropphycty": "DIXIE",
    "dropphyst": "GA",
    "dropphyzpp": 316299998,
    "dropmaladd": "5308 DIXIE RD",
    "dropmalcty": "DIXIE",
    "dropmalst": "GA",
    "dropmalzpp": 316299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292352002,
    "dropsitcph": 2292352002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10352",
    "droptype": "D",
    "dropname": "DOERUN",
    "dropdeladd": "241 W BROAD AVE",
    "dropdelcty": "DOERUN",
    "dropdelst": "GA",
    "dropdelzpp": 317449998,
    "dropphyadd": "241 W BROAD AVE",
    "dropphycty": "DOERUN",
    "dropphyst": "GA",
    "dropphyzpp": 317449998,
    "dropmaladd": "241 W BROAD AVE",
    "dropmalcty": "DOERUN",
    "dropmalst": "GA",
    "dropmalzpp": 317449998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297825808,
    "dropsitcph": 2297825808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10354",
    "droptype": "D",
    "dropname": "DONALSONVILLE",
    "dropdeladd": "102 W 2ND ST",
    "dropdelcty": "DONALSONVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 398459998,
    "dropphyadd": "102 W 2ND ST",
    "dropphycty": "DONALSONVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 398459998,
    "dropmaladd": "102 W 2ND ST",
    "dropmalcty": "DONALSONVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 398459998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295248961,
    "dropsitcph": 2295248961,
    "dropfax": 2295242869
  },
  {
    "dcode": "D",
    "dropkey": "PX10359",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "600 MADISON AVE S",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "GA",
    "dropdelzpp": 315339998,
    "dropphyadd": "600 MADISON AVE S",
    "dropphycty": "DOUGLAS",
    "dropphyst": "GA",
    "dropphyzpp": 315339998,
    "dropmaladd": "600 MADISON AVE S",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "GA",
    "dropmalzpp": 315339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123891096,
    "dropsitcph": 9123891096,
    "dropfax": 9123848498
  },
  {
    "dcode": "D",
    "dropkey": "PX10360",
    "droptype": "D",
    "dropname": "DOUGLASVILLE",
    "dropdeladd": "6000 STEWART PKWY",
    "dropdelcty": "DOUGLASVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301359998,
    "dropphyadd": "6000 STEWART PKWY",
    "dropphycty": "DOUGLASVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301359998,
    "dropmaladd": "6000 STEWART PKWY",
    "dropmalcty": "DOUGLASVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301359998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705771235,
    "dropsitcph": 7705772196,
    "dropfax": 7705771236
  },
  {
    "dcode": "D",
    "dropkey": "PX10363",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "6516 STATESBORO HWY",
    "dropdelcty": "DOVER",
    "dropdelst": "GA",
    "dropdelzpp": 304249998,
    "dropphyadd": "6516 STATESBORO HWY",
    "dropphycty": "DOVER",
    "dropphyst": "GA",
    "dropphyzpp": 304249998,
    "dropmaladd": "6516 STATESBORO HWY",
    "dropmalcty": "DOVER",
    "dropmalst": "GA",
    "dropmalzpp": 304249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128634439,
    "dropsitcph": 9128634439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10370",
    "droptype": "D",
    "dropname": "DRY BRANCH",
    "dropdeladd": "5615 JEFFERSONVILLE RD",
    "dropdelcty": "DRY BRANCH",
    "dropdelst": "GA",
    "dropdelzpp": 310209998,
    "dropphyadd": "5615 JEFFERSONVILLE RD",
    "dropphycty": "DRY BRANCH",
    "dropphyst": "GA",
    "dropphyzpp": 310209998,
    "dropmaladd": "5615 JEFFERSONVILLE RD",
    "dropmalcty": "DRY BRANCH",
    "dropmalst": "GA",
    "dropmalzpp": 310209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787415170,
    "dropsitcph": 4787415170,
    "dropfax": 4787411428
  },
  {
    "dcode": "D",
    "dropkey": "PX10372",
    "droptype": "D",
    "dropname": "DU PONT",
    "dropdeladd": "8402 VALDOSTA HWY",
    "dropdelcty": "DU PONT",
    "dropdelst": "GA",
    "dropdelzpp": 316303225,
    "dropphyadd": "8402 VALDOSTA HWY",
    "dropphycty": "DU PONT",
    "dropphyst": "GA",
    "dropphyzpp": 316303225,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DU PONT",
    "dropmalst": "GA",
    "dropmalzpp": 316309900,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124872630,
    "dropsitcph": 9124872630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10373",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "514 BELLEVUE AVE",
    "dropdelcty": "DUBLIN",
    "dropdelst": "GA",
    "dropdelzpp": 310219998,
    "dropphyadd": "514 BELLEVUE AVE",
    "dropphycty": "DUBLIN",
    "dropphyst": "GA",
    "dropphyzpp": 310219998,
    "dropmaladd": "514 BELLEVUE AVE",
    "dropmalcty": "DUBLIN",
    "dropmalst": "GA",
    "dropmalzpp": 310219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782726832,
    "dropsitcph": 4782726832,
    "dropfax": 4782740950
  },
  {
    "dcode": "D",
    "dropkey": "PX10374",
    "droptype": "D",
    "dropname": "DUDLEY",
    "dropdeladd": "1443 2ND ST",
    "dropdelcty": "DUDLEY",
    "dropdelst": "GA",
    "dropdelzpp": 310229998,
    "dropphyadd": "1443 2ND ST",
    "dropphycty": "DUDLEY",
    "dropphyst": "GA",
    "dropphyzpp": 310229998,
    "dropmaladd": "1443 2ND ST",
    "dropmalcty": "DUDLEY",
    "dropmalst": "GA",
    "dropmalzpp": 310229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786762448,
    "dropsitcph": 4786762448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10375",
    "droptype": "D",
    "dropname": "DULUTH",
    "dropdeladd": "3470 MCCLURE BRIDGE RD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300969998,
    "dropphyadd": "3470 MCCLURE BRIDGE RD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300969998,
    "dropmaladd": "3470 MCCLURE BRIDGE RD",
    "dropmalcty": "DULUTH",
    "dropmalst": "GA",
    "dropmalzpp": 300969998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782802306,
    "dropsitcph": 7702322757,
    "dropfax": 7704767705
  },
  {
    "dcode": "D",
    "dropkey": "PX10387",
    "droptype": "D",
    "dropname": "EAST ELLIJAY",
    "dropdeladd": "230 OLD ORCHARD SQ",
    "dropdelcty": "EAST ELLIJAY",
    "dropdelst": "GA",
    "dropdelzpp": 305398173,
    "dropphyadd": "230 OLD ORCHARD SQ",
    "dropphycty": "EAST ELLIJAY",
    "dropphyst": "GA",
    "dropphyzpp": 305398173,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST ELLIJAY",
    "dropmalst": "GA",
    "dropmalzpp": 305399998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066354234,
    "dropsitcph": 7066354234,
    "dropfax": 7066364233
  },
  {
    "dcode": "D",
    "dropkey": "PX10393",
    "droptype": "D",
    "dropname": "EASTANOLLEE",
    "dropdeladd": "36 EASTANOLLEE SCHOOL RD",
    "dropdelcty": "EASTANOLLEE",
    "dropdelst": "GA",
    "dropdelzpp": 305382300,
    "dropphyadd": "36 EASTANOLLEE SCHOOL RD",
    "dropphycty": "EASTANOLLEE",
    "dropphyst": "GA",
    "dropphyzpp": 305382300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTANOLLEE",
    "dropmalst": "GA",
    "dropmalzpp": 305389998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067792321,
    "dropsitcph": 7067792321,
    "dropfax": 7067793288
  },
  {
    "dcode": "D",
    "dropkey": "PX10394",
    "droptype": "D",
    "dropname": "EASTMAN",
    "dropdeladd": "400 2ND AVE",
    "dropdelcty": "EASTMAN",
    "dropdelst": "GA",
    "dropdelzpp": 310239998,
    "dropphyadd": "400 2ND AVE",
    "dropphycty": "EASTMAN",
    "dropphyst": "GA",
    "dropphyzpp": 310239998,
    "dropmaladd": "400 2ND AVE",
    "dropmalcty": "EASTMAN",
    "dropmalst": "GA",
    "dropmalzpp": 310239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4783741928,
    "dropsitcph": 4783741928,
    "dropfax": 4783742002
  },
  {
    "dcode": "D",
    "dropkey": "PX10396",
    "droptype": "D",
    "dropname": "EATONTON",
    "dropdeladd": "410 E SUMTER ST",
    "dropdelcty": "EATONTON",
    "dropdelst": "GA",
    "dropdelzpp": 310249998,
    "dropphyadd": "410 E SUMTER ST",
    "dropphycty": "EATONTON",
    "dropphyst": "GA",
    "dropphyzpp": 310249998,
    "dropmaladd": "410 E SUMTER ST",
    "dropmalcty": "EATONTON",
    "dropmalst": "GA",
    "dropmalzpp": 310249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064855636,
    "dropsitcph": 7064855636,
    "dropfax": 7064840786
  },
  {
    "dcode": "D",
    "dropkey": "PX10397",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "1228 US HIGHWAY 80",
    "dropdelcty": "EDEN",
    "dropdelst": "GA",
    "dropdelzpp": 313079998,
    "dropphyadd": "1228 US HIGHWAY 80",
    "dropphycty": "EDEN",
    "dropphyst": "GA",
    "dropphyzpp": 313079998,
    "dropmaladd": "1228 US HIGHWAY 80",
    "dropmalcty": "EDEN",
    "dropmalst": "GA",
    "dropmalzpp": 313079998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127481975,
    "dropsitcph": 9127481975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10400",
    "droptype": "D",
    "dropname": "EDISON",
    "dropdeladd": "19372 HARTFORD ST",
    "dropdelcty": "EDISON",
    "dropdelst": "GA",
    "dropdelzpp": 398469998,
    "dropphyadd": "19372 HARTFORD ST",
    "dropphycty": "EDISON",
    "dropphyst": "GA",
    "dropphyzpp": 398469998,
    "dropmaladd": "19372 HARTFORD ST",
    "dropmalcty": "EDISON",
    "dropmalst": "GA",
    "dropmalzpp": 398469998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298352255,
    "dropsitcph": 2298352255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10402",
    "droptype": "D",
    "dropname": "ELBERTON",
    "dropdeladd": "204 HEARD ST",
    "dropdelcty": "ELBERTON",
    "dropdelst": "GA",
    "dropdelzpp": 306359998,
    "dropphyadd": "204 HEARD ST",
    "dropphycty": "ELBERTON",
    "dropphyst": "GA",
    "dropphyzpp": 306359998,
    "dropmaladd": "204 HEARD ST",
    "dropmalcty": "ELBERTON",
    "dropmalst": "GA",
    "dropmalzpp": 306359998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062839418,
    "dropsitcph": 7062832821,
    "dropfax": 7062137354
  },
  {
    "dcode": "D",
    "dropkey": "PX10404",
    "droptype": "D",
    "dropname": "ELKO",
    "dropdeladd": "2601 ELKO RD",
    "dropdelcty": "ELKO",
    "dropdelst": "GA",
    "dropdelzpp": 310259998,
    "dropphyadd": "2601 ELKO RD",
    "dropphycty": "ELKO",
    "dropphyst": "GA",
    "dropphyzpp": 310259998,
    "dropmaladd": "2601 ELKO RD",
    "dropmalcty": "ELKO",
    "dropmalst": "GA",
    "dropmalzpp": 310259998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789872012,
    "dropsitcph": 4789872012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10405",
    "droptype": "D",
    "dropname": "ELLABELL",
    "dropdeladd": "8745 US HIGHWAY 280 E",
    "dropdelcty": "ELLABELL",
    "dropdelst": "GA",
    "dropdelzpp": 313089998,
    "dropphyadd": "8745 US HIGHWAY 280 E",
    "dropphycty": "ELLABELL",
    "dropphyst": "GA",
    "dropphyzpp": 313089998,
    "dropmaladd": "8745 US HIGHWAY 280 E",
    "dropmalcty": "ELLABELL",
    "dropmalst": "GA",
    "dropmalzpp": 313089998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128584556,
    "dropsitcph": 9128584556,
    "dropfax": 9128582268
  },
  {
    "dcode": "D",
    "dropkey": "PX10406",
    "droptype": "D",
    "dropname": "ELLAVILLE",
    "dropdeladd": "38 S BROAD ST",
    "dropdelcty": "ELLAVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 318069998,
    "dropphyadd": "38 S BROAD ST",
    "dropphycty": "ELLAVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 318069998,
    "dropmaladd": "38 S BROAD ST",
    "dropmalcty": "ELLAVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 318069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2299372702,
    "dropsitcph": 2299372702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10407",
    "droptype": "D",
    "dropname": "ELLENTON",
    "dropdeladd": "158 BAKER ST",
    "dropdelcty": "ELLENTON",
    "dropdelst": "GA",
    "dropdelzpp": 317479998,
    "dropphyadd": "158 BAKER ST",
    "dropphycty": "ELLENTON",
    "dropphyst": "GA",
    "dropphyzpp": 317479998,
    "dropmaladd": "158 BAKER ST",
    "dropmalcty": "ELLENTON",
    "dropmalst": "GA",
    "dropmalzpp": 317479998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293242129,
    "dropsitcph": 2293242129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10408",
    "droptype": "D",
    "dropname": "ELLENWOOD",
    "dropdeladd": "5465 HIGHWAY 42",
    "dropdelcty": "ELLENWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 302943805,
    "dropphyadd": "5465 HIGHWAY 42",
    "dropphycty": "ELLENWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 302943805,
    "dropmaladd": "5465 HIGHWAY 42",
    "dropmalcty": "ELLENWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 302943805,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043615818,
    "dropsitcph": 4043614415,
    "dropfax": 4043668610
  },
  {
    "dcode": "D",
    "dropkey": "PX10409",
    "droptype": "D",
    "dropname": "ELLERSLIE",
    "dropdeladd": "3750 GA HIGHWAY 85",
    "dropdelcty": "ELLERSLIE",
    "dropdelst": "GA",
    "dropdelzpp": 318079998,
    "dropphyadd": "3750 GA HIGHWAY 85",
    "dropphycty": "ELLERSLIE",
    "dropphyst": "GA",
    "dropphyzpp": 318079998,
    "dropmaladd": "3750 GA HIGHWAY 85",
    "dropmalcty": "ELLERSLIE",
    "dropmalst": "GA",
    "dropmalzpp": 318079998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065618929,
    "dropsitcph": 7065618929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10410",
    "droptype": "D",
    "dropname": "ELLIJAY",
    "dropdeladd": "801 INDUSTRIAL BLVD",
    "dropdelcty": "ELLIJAY",
    "dropdelst": "GA",
    "dropdelzpp": 305409998,
    "dropphyadd": "801 INDUSTRIAL BLVD",
    "dropphycty": "ELLIJAY",
    "dropphyst": "GA",
    "dropphyzpp": 305409998,
    "dropmaladd": "801 INDUSTRIAL BLVD",
    "dropmalcty": "ELLIJAY",
    "dropmalst": "GA",
    "dropmalzpp": 305409998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062764356,
    "dropsitcph": 7066354356,
    "dropfax": 7062767216
  },
  {
    "dcode": "D",
    "dropkey": "PX10416",
    "droptype": "D",
    "dropname": "EMERSON",
    "dropdeladd": "86 GASTON WESTBROOK AVE",
    "dropdelcty": "EMERSON",
    "dropdelst": "GA",
    "dropdelzpp": 301379998,
    "dropphyadd": "86 GASTON WESTBROOK AVE",
    "dropphycty": "EMERSON",
    "dropphyst": "GA",
    "dropphyzpp": 301379998,
    "dropmaladd": "86 GASTON WESTBROOK AVE",
    "dropmalcty": "EMERSON",
    "dropmalst": "GA",
    "dropmalzpp": 301379998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703828020,
    "dropsitcph": 7703828020,
    "dropfax": 7703828393
  },
  {
    "dcode": "D",
    "dropkey": "PX10422",
    "droptype": "D",
    "dropname": "ENIGMA",
    "dropdeladd": "552 MAIN ST",
    "dropdelcty": "ENIGMA",
    "dropdelst": "GA",
    "dropdelzpp": 317499998,
    "dropphyadd": "552 MAIN ST",
    "dropphycty": "ENIGMA",
    "dropphyst": "GA",
    "dropphyzpp": 317499998,
    "dropmaladd": "552 MAIN ST",
    "dropmalcty": "ENIGMA",
    "dropmalst": "GA",
    "dropmalzpp": 317499998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295333095,
    "dropsitcph": 2295333095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10424",
    "droptype": "D",
    "dropname": "EPWORTH",
    "dropdeladd": "685 MADOLA RD",
    "dropdelcty": "EPWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 305419998,
    "dropphyadd": "685 MADOLA RD",
    "dropphycty": "EPWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 305419998,
    "dropmaladd": "685 MADOLA RD",
    "dropmalcty": "EPWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 305419998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064923588,
    "dropsitcph": 7064923588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10425",
    "droptype": "D",
    "dropname": "ESOM HILL",
    "dropdeladd": "215 HARDIN RD",
    "dropdelcty": "ESOM HILL",
    "dropdelst": "GA",
    "dropdelzpp": 301389800,
    "dropphyadd": "215 HARDIN RD",
    "dropphycty": "ESOM HILL",
    "dropphyst": "GA",
    "dropphyzpp": 301389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESOM HILL",
    "dropmalst": "GA",
    "dropmalzpp": 301389998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707490681,
    "dropsitcph": 7707490681,
    "dropfax": 7707490681
  },
  {
    "dcode": "D",
    "dropkey": "PX10427",
    "droptype": "D",
    "dropname": "ETON",
    "dropdeladd": "219 CCC CAMP RD",
    "dropdelcty": "ETON",
    "dropdelst": "GA",
    "dropdelzpp": 307249998,
    "dropphyadd": "219 CCC CAMP RD",
    "dropphycty": "ETON",
    "dropphyst": "GA",
    "dropphyzpp": 307249998,
    "dropmaladd": "219 CCC CAMP RD",
    "dropmalcty": "ETON",
    "dropmalst": "GA",
    "dropmalzpp": 307249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066955139,
    "dropsitcph": 7066955139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10429",
    "droptype": "D",
    "dropname": "EVANS",
    "dropdeladd": "607 RONALD REAGAN DR",
    "dropdelcty": "EVANS",
    "dropdelst": "GA",
    "dropdelzpp": 308099998,
    "dropphyadd": "607 RONALD REAGAN DR",
    "dropphycty": "EVANS",
    "dropphyst": "GA",
    "dropphyzpp": 308099998,
    "dropmaladd": "607 RONALD REAGAN DR",
    "dropmalcty": "EVANS",
    "dropmalst": "GA",
    "dropmalzpp": 308099998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7069415449,
    "dropsitcph": 7066510121,
    "dropfax": 7068636448
  },
  {
    "dcode": "D",
    "dropkey": "PX10434",
    "droptype": "D",
    "dropname": "EXPERIMENT",
    "dropdeladd": "1382 EXPERIMENT ST",
    "dropdelcty": "EXPERIMENT",
    "dropdelst": "GA",
    "dropdelzpp": 302121783,
    "dropphyadd": "1382 EXPERIMENT ST",
    "dropphycty": "EXPERIMENT",
    "dropphyst": "GA",
    "dropphyzpp": 302121783,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXPERIMENT",
    "dropmalst": "GA",
    "dropmalzpp": 302129998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702271101,
    "dropsitcph": 7702271101,
    "dropfax": 7704670060
  },
  {
    "dcode": "D",
    "dropkey": "PX10437",
    "droptype": "D",
    "dropname": "FAIRBURN",
    "dropdeladd": "75 WASHINGTON ST",
    "dropdelcty": "FAIRBURN",
    "dropdelst": "GA",
    "dropdelzpp": 302139998,
    "dropphyadd": "75 WASHINGTON ST",
    "dropphycty": "FAIRBURN",
    "dropphyst": "GA",
    "dropphyzpp": 302139998,
    "dropmaladd": "75 WASHINGTON ST",
    "dropmalcty": "FAIRBURN",
    "dropmalst": "GA",
    "dropmalzpp": 302139998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709695918,
    "dropsitcph": 7709647827,
    "dropfax": 7703062945
  },
  {
    "dcode": "D",
    "dropkey": "PX10439",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "2295 HIGHWAY 411 SE",
    "dropdelcty": "FAIRMOUNT",
    "dropdelst": "GA",
    "dropdelzpp": 301399998,
    "dropphyadd": "2295 HIGHWAY 411 SE",
    "dropphycty": "FAIRMOUNT",
    "dropphyst": "GA",
    "dropphyzpp": 301399998,
    "dropmaladd": "2295 HIGHWAY 411 SE",
    "dropmalcty": "FAIRMOUNT",
    "dropmalst": "GA",
    "dropmalzpp": 301399998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063372500,
    "dropsitcph": 7063372500,
    "dropfax": 7063374125
  },
  {
    "dcode": "D",
    "dropkey": "PX10442",
    "droptype": "D",
    "dropname": "FARGO",
    "dropdeladd": "700 US HIGHWAY 441",
    "dropdelcty": "FARGO",
    "dropdelst": "GA",
    "dropdelzpp": 316319998,
    "dropphyadd": "700 US HIGHWAY 441",
    "dropphycty": "FARGO",
    "dropphyst": "GA",
    "dropphyzpp": 316319998,
    "dropmaladd": "700 US HIGHWAY 441",
    "dropmalcty": "FARGO",
    "dropmalst": "GA",
    "dropmalzpp": 316319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126375243,
    "dropsitcph": 9126375243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10444",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "1011 SALEM RD",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 306389800,
    "dropphyadd": "1011 SALEM RD",
    "dropphycty": "FARMINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 306389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 306389998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067696307,
    "dropsitcph": 7067696307,
    "dropfax": 7067690279
  },
  {
    "dcode": "D",
    "dropkey": "PX10448",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "250 GEORGIA AVE E",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302149998,
    "dropphyadd": "250 GEORGIA AVE E",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302149998,
    "dropmaladd": "250 GEORGIA AVE E",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302149998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707193157,
    "dropsitcph": 7707193115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10455",
    "droptype": "D",
    "dropname": "FELTON",
    "dropdeladd": "7369 HIGHWAY 27",
    "dropdelcty": "FELTON",
    "dropdelst": "GA",
    "dropdelzpp": 301409800,
    "dropphyadd": "7369 HIGHWAY 27",
    "dropphycty": "FELTON",
    "dropphyst": "GA",
    "dropphyzpp": 301409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FELTON",
    "dropmalst": "GA",
    "dropmalzpp": 301409998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706465024,
    "dropsitcph": 7706465024,
    "dropfax": 7706460732
  },
  {
    "dcode": "D",
    "dropkey": "PX10457",
    "droptype": "D",
    "dropname": "FITZGERALD",
    "dropdeladd": "124 N MAIN ST",
    "dropdelcty": "FITZGERALD",
    "dropdelst": "GA",
    "dropdelzpp": 317509998,
    "dropphyadd": "124 N MAIN ST",
    "dropphycty": "FITZGERALD",
    "dropphyst": "GA",
    "dropphyzpp": 317509998,
    "dropmaladd": "124 N MAIN ST",
    "dropmalcty": "FITZGERALD",
    "dropmalst": "GA",
    "dropmalzpp": 317509998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2294249338,
    "dropsitcph": 2294249338,
    "dropfax": 2294236586
  },
  {
    "dcode": "D",
    "dropkey": "PX10460",
    "droptype": "D",
    "dropname": "FLINTSTONE",
    "dropdeladd": "4685 HAPPY VALLEY RD",
    "dropdelcty": "FLINTSTONE",
    "dropdelst": "GA",
    "dropdelzpp": 307259998,
    "dropphyadd": "4685 HAPPY VALLEY RD",
    "dropphycty": "FLINTSTONE",
    "dropphyst": "GA",
    "dropphyzpp": 307259998,
    "dropmaladd": "4685 HAPPY VALLEY RD",
    "dropmalcty": "FLINTSTONE",
    "dropmalst": "GA",
    "dropmalzpp": 307259998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068201901,
    "dropsitcph": 7068201901,
    "dropfax": 7068201933
  },
  {
    "dcode": "D",
    "dropkey": "PX10461",
    "droptype": "D",
    "dropname": "FLOVILLA",
    "dropdeladd": "340 HEARD ST",
    "dropdelcty": "FLOVILLA",
    "dropdelst": "GA",
    "dropdelzpp": 302169998,
    "dropphyadd": "340 HEARD ST",
    "dropphycty": "FLOVILLA",
    "dropphyst": "GA",
    "dropphyzpp": 302169998,
    "dropmaladd": "340 HEARD ST",
    "dropmalcty": "FLOVILLA",
    "dropmalst": "GA",
    "dropmalzpp": 302169998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705041763,
    "dropsitcph": 7705041763,
    "dropfax": 7705041453
  },
  {
    "dcode": "D",
    "dropkey": "PX10463",
    "droptype": "D",
    "dropname": "FLOWERY BRANCH",
    "dropdeladd": "4915 ATLANTA HWY",
    "dropdelcty": "FLOWERY BRANCH",
    "dropdelst": "GA",
    "dropdelzpp": 305423333,
    "dropphyadd": "4915 ATLANTA HWY",
    "dropphycty": "FLOWERY BRANCH",
    "dropphyst": "GA",
    "dropphyzpp": 305423333,
    "dropmaladd": "4915 ATLANTA HWY",
    "dropmalcty": "FLOWERY BRANCH",
    "dropmalst": "GA",
    "dropmalzpp": 305423333,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709679118,
    "dropsitcph": 7709676431,
    "dropfax": 7069678533
  },
  {
    "dcode": "D",
    "dropkey": "PX10466",
    "droptype": "D",
    "dropname": "FOLKSTON",
    "dropdeladd": "3845 MAIN ST",
    "dropdelcty": "FOLKSTON",
    "dropdelst": "GA",
    "dropdelzpp": 315379998,
    "dropphyadd": "3845 MAIN ST",
    "dropphycty": "FOLKSTON",
    "dropphyst": "GA",
    "dropphyzpp": 315379998,
    "dropmaladd": "3845 MAIN ST",
    "dropmalcty": "FOLKSTON",
    "dropmalst": "GA",
    "dropmalzpp": 315379998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124964804,
    "dropsitcph": 9124964804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10469",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "4989 COURTNEY DR",
    "dropdelcty": "FOREST PARK",
    "dropdelst": "GA",
    "dropdelzpp": 302979998,
    "dropphyadd": "4989 COURTNEY DR",
    "dropphycty": "FOREST PARK",
    "dropphyst": "GA",
    "dropphyzpp": 302979998,
    "dropmaladd": "4989 COURTNEY DR",
    "dropmalcty": "FOREST PARK",
    "dropmalst": "GA",
    "dropmalzpp": 302979998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047573218,
    "dropsitcph": 4043629696,
    "dropfax": 4043639089
  },
  {
    "dcode": "D",
    "dropkey": "PX10471",
    "droptype": "D",
    "dropname": "FORSYTH",
    "dropdeladd": "65 W JOHNSTON ST",
    "dropdelcty": "FORSYTH",
    "dropdelst": "GA",
    "dropdelzpp": 310299998,
    "dropphyadd": "65 W JOHNSTON ST",
    "dropphycty": "FORSYTH",
    "dropphyst": "GA",
    "dropphyzpp": 310299998,
    "dropmaladd": "65 W JOHNSTON ST",
    "dropmalcty": "FORSYTH",
    "dropmalst": "GA",
    "dropmalzpp": 310299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789740776,
    "dropsitcph": 4789740776,
    "dropfax": 4789742036
  },
  {
    "dcode": "D",
    "dropkey": "PX10474",
    "droptype": "D",
    "dropname": "FORT GAINES",
    "dropdeladd": "203 HANCOCK ST S",
    "dropdelcty": "FORT GAINES",
    "dropdelst": "GA",
    "dropdelzpp": 398519998,
    "dropphyadd": "203 HANCOCK ST S",
    "dropphycty": "FORT GAINES",
    "dropphyst": "GA",
    "dropphyzpp": 398519998,
    "dropmaladd": "203 HANCOCK ST S",
    "dropmalcty": "FORT GAINES",
    "dropmalst": "GA",
    "dropmalzpp": 398519998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297682413,
    "dropsitcph": 2295522033,
    "dropfax": 2297683049
  },
  {
    "dcode": "D",
    "dropkey": "PX10485",
    "droptype": "D",
    "dropname": "FORT VALLEY",
    "dropdeladd": "111 ANDERSON AVE",
    "dropdelcty": "FORT VALLEY",
    "dropdelst": "GA",
    "dropdelzpp": 310309998,
    "dropphyadd": "111 ANDERSON AVE",
    "dropphycty": "FORT VALLEY",
    "dropphyst": "GA",
    "dropphyzpp": 310309998,
    "dropmaladd": "111 ANDERSON AVE",
    "dropmalcty": "FORT VALLEY",
    "dropmalst": "GA",
    "dropmalzpp": 310309998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788257958,
    "dropsitcph": 4788257958,
    "dropfax": 4788257954
  },
  {
    "dcode": "D",
    "dropkey": "PX10486",
    "droptype": "D",
    "dropname": "FORTSON",
    "dropdeladd": "2511 DOUBLE CHURCHES RD",
    "dropdelcty": "FORTSON",
    "dropdelst": "GA",
    "dropdelzpp": 318089998,
    "dropphyadd": "2511 DOUBLE CHURCHES RD",
    "dropphycty": "FORTSON",
    "dropphyst": "GA",
    "dropphyzpp": 318089998,
    "dropmaladd": "2511 DOUBLE CHURCHES RD",
    "dropmalcty": "FORTSON",
    "dropmalst": "GA",
    "dropmalzpp": 318089998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7063230259,
    "dropsitcph": 7063230259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10490",
    "droptype": "D",
    "dropname": "FOWLSTOWN",
    "dropdeladd": "3408 FOWLSTOWN RD",
    "dropdelcty": "FOWLSTOWN",
    "dropdelst": "GA",
    "dropdelzpp": 398529998,
    "dropphyadd": "3408 FOWLSTOWN RD",
    "dropphycty": "FOWLSTOWN",
    "dropphyst": "GA",
    "dropphyzpp": 398529998,
    "dropmaladd": "3408 FOWLSTOWN RD",
    "dropmalcty": "FOWLSTOWN",
    "dropmalst": "GA",
    "dropmalzpp": 398529998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292465079,
    "dropsitcph": 2292465079,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10491",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "291 PARK AVE",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "GA",
    "dropdelzpp": 302179998,
    "dropphyadd": "291 PARK AVE",
    "dropphycty": "FRANKLIN",
    "dropphyst": "GA",
    "dropphyzpp": 302179998,
    "dropmaladd": "291 PARK AVE",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "GA",
    "dropmalzpp": 302179998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066753396,
    "dropsitcph": 7066753396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10493",
    "droptype": "D",
    "dropname": "FRANKLIN SPRINGS",
    "dropdeladd": "2391 W MAIN ST",
    "dropdelcty": "FRANKLIN SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 306397007,
    "dropphyadd": "2391 W MAIN ST",
    "dropphycty": "FRANKLIN SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 306397007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLIN SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 306399998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062456674,
    "dropsitcph": 7062456674,
    "dropfax": 7062450351
  },
  {
    "dcode": "D",
    "dropkey": "PX10498",
    "droptype": "D",
    "dropname": "FUNSTON",
    "dropdeladd": "126 W MULBERRY ST",
    "dropdelcty": "FUNSTON",
    "dropdelst": "GA",
    "dropdelzpp": 317539998,
    "dropphyadd": "126 W MULBERRY ST",
    "dropphycty": "FUNSTON",
    "dropphyst": "GA",
    "dropphyzpp": 317539998,
    "dropmaladd": "126 W MULBERRY ST",
    "dropmalcty": "FUNSTON",
    "dropmalst": "GA",
    "dropmalzpp": 317539998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2299412570,
    "dropsitcph": 2299412570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10503",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "364 GREEN ST NE",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305013310,
    "dropphyadd": "364 GREEN ST NE",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305013310,
    "dropmaladd": "364 GREEN ST NE",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305013310,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705365893,
    "dropsitcph": 7705365893,
    "dropfax": 7705329397
  },
  {
    "dcode": "D",
    "dropkey": "PX10510",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "213 MONROE ST",
    "dropdelcty": "GARFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 304259998,
    "dropphyadd": "213 MONROE ST",
    "dropphycty": "GARFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 304259998,
    "dropmaladd": "213 MONROE ST",
    "dropmalcty": "GARFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 304259998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787632666,
    "dropsitcph": 4787632666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10515",
    "droptype": "D",
    "dropname": "GAY",
    "dropdeladd": "18685 HIGHWAY 85",
    "dropdelcty": "GAY",
    "dropdelst": "GA",
    "dropdelzpp": 302189998,
    "dropphyadd": "18685 HIGHWAY 85",
    "dropphycty": "GAY",
    "dropphyst": "GA",
    "dropphyzpp": 302189998,
    "dropmaladd": "18685 HIGHWAY 85",
    "dropmalcty": "GAY",
    "dropmalst": "GA",
    "dropmalzpp": 302189998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7065386590,
    "dropsitcph": 7065386590,
    "dropfax": 7065381234
  },
  {
    "dcode": "D",
    "dropkey": "PX10518",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "446 COLUMBUS HWY",
    "dropdelcty": "GENEVA",
    "dropdelst": "GA",
    "dropdelzpp": 318109998,
    "dropphyadd": "446 COLUMBUS HWY",
    "dropphycty": "GENEVA",
    "dropphyst": "GA",
    "dropphyzpp": 318109998,
    "dropmaladd": "446 COLUMBUS HWY",
    "dropmalcty": "GENEVA",
    "dropmalst": "GA",
    "dropmalzpp": 318109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7062693572,
    "dropsitcph": 7062693572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10520",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "GA",
    "dropdelzpp": 398549998,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "GA",
    "dropphyzpp": 398549998,
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "GA",
    "dropmalzpp": 398549998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293349402,
    "dropsitcph": 2293349402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10532",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "21 W MAIN ST",
    "dropdelcty": "GIBSON",
    "dropdelst": "GA",
    "dropdelzpp": 308109998,
    "dropphyadd": "21 W MAIN ST",
    "dropphycty": "GIBSON",
    "dropphyst": "GA",
    "dropphyzpp": 308109998,
    "dropmaladd": "21 W MAIN ST",
    "dropmalcty": "GIBSON",
    "dropmalst": "GA",
    "dropmalzpp": 308109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065983171,
    "dropsitcph": 7065983171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10533",
    "droptype": "D",
    "dropname": "GILLSVILLE",
    "dropdeladd": "6310 HIGHWAY 52",
    "dropdelcty": "GILLSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305439998,
    "dropphyadd": "6310 HIGHWAY 52",
    "dropphycty": "GILLSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305439998,
    "dropmaladd": "6310 HIGHWAY 52",
    "dropmalcty": "GILLSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305439998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708697834,
    "dropsitcph": 7708697821,
    "dropfax": 7708697104
  },
  {
    "dcode": "D",
    "dropkey": "PX10536",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "10280 GA HIGHWAY 23 S",
    "dropdelcty": "GIRARD",
    "dropdelst": "GA",
    "dropdelzpp": 304269998,
    "dropphyadd": "10280 GA HIGHWAY 23 S",
    "dropphycty": "GIRARD",
    "dropphyst": "GA",
    "dropphyzpp": 304269998,
    "dropmaladd": "10280 GA HIGHWAY 23 S",
    "dropmalcty": "GIRARD",
    "dropmalst": "GA",
    "dropmalzpp": 304269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785694836,
    "dropsitcph": 4785694836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10539",
    "droptype": "D",
    "dropname": "GLENNVILLE",
    "dropdeladd": "206 S VETERANS BLVD",
    "dropdelcty": "GLENNVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 304279998,
    "dropphyadd": "206 S VETERANS BLVD",
    "dropphycty": "GLENNVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 304279998,
    "dropmaladd": "206 S VETERANS BLVD",
    "dropmalcty": "GLENNVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 304279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126549799,
    "dropsitcph": 9126549799,
    "dropfax": 9126541782
  },
  {
    "dcode": "D",
    "dropkey": "PX10541",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "5 N THIRD ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 304289998,
    "dropphyadd": "5 N THIRD ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 304289998,
    "dropmaladd": "5 N THIRD ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 304289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125232551,
    "dropsitcph": 9125232551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10545",
    "droptype": "D",
    "dropname": "GOOD HOPE",
    "dropdeladd": "110 W PLEASANT VALLEY RD",
    "dropdelcty": "GOOD HOPE",
    "dropdelst": "GA",
    "dropdelzpp": 306419998,
    "dropphyadd": "110 W PLEASANT VALLEY RD",
    "dropphycty": "GOOD HOPE",
    "dropphyst": "GA",
    "dropphyzpp": 306419998,
    "dropmaladd": "110 W PLEASANT VALLEY RD",
    "dropmalcty": "GOOD HOPE",
    "dropmalst": "GA",
    "dropmalzpp": 306419998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702679376,
    "dropsitcph": 7702679376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10546",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "290 MILLEDGEVILLE HWY",
    "dropdelcty": "GORDON",
    "dropdelst": "GA",
    "dropdelzpp": 310319998,
    "dropphyadd": "290 MILLEDGEVILLE HWY",
    "dropphycty": "GORDON",
    "dropphyst": "GA",
    "dropphyzpp": 310319998,
    "dropmaladd": "290 MILLEDGEVILLE HWY",
    "dropmalcty": "GORDON",
    "dropmalst": "GA",
    "dropmalzpp": 310319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786284016,
    "dropsitcph": 4786284016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10548",
    "droptype": "D",
    "dropname": "GRACEWOOD",
    "dropdeladd": "102 MYRTLE BLVD",
    "dropdelcty": "GRACEWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 308129998,
    "dropphyadd": "102 MYRTLE BLVD",
    "dropphycty": "GRACEWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 308129998,
    "dropmaladd": "102 MYRTLE BLVD",
    "dropmalcty": "GRACEWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 308129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 7067982266,
    "dropfax": 7067982266
  },
  {
    "dcode": "D",
    "dropkey": "PX10551",
    "droptype": "D",
    "dropname": "GRANTVILLE",
    "dropdeladd": "88 LAGRANGE ST",
    "dropdelcty": "GRANTVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302209998,
    "dropphyadd": "88 LAGRANGE ST",
    "dropphycty": "GRANTVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302209998,
    "dropmaladd": "88 LAGRANGE ST",
    "dropmalcty": "GRANTVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302209998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705832827,
    "dropsitcph": 7705832827,
    "dropfax": 7705832827
  },
  {
    "dcode": "D",
    "dropkey": "PX10555",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "235 W CLINTON ST",
    "dropdelcty": "GRAY",
    "dropdelst": "GA",
    "dropdelzpp": 310329998,
    "dropphyadd": "235 W CLINTON ST",
    "dropphycty": "GRAY",
    "dropphyst": "GA",
    "dropphyzpp": 310329998,
    "dropmaladd": "235 W CLINTON ST",
    "dropmalcty": "GRAY",
    "dropmalst": "GA",
    "dropmalzpp": 310329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789864085,
    "dropsitcph": 4789864085,
    "dropfax": 4789862527
  },
  {
    "dcode": "D",
    "dropkey": "PX10556",
    "droptype": "D",
    "dropname": "GRAYSON",
    "dropdeladd": "516 SOSEBEE FARM RD",
    "dropdelcty": "GRAYSON",
    "dropdelst": "GA",
    "dropdelzpp": 300179998,
    "dropphyadd": "516 SOSEBEE FARM RD",
    "dropphycty": "GRAYSON",
    "dropphyst": "GA",
    "dropphyzpp": 300179998,
    "dropmaladd": "516 SOSEBEE FARM RD",
    "dropmalcty": "GRAYSON",
    "dropmalst": "GA",
    "dropmalzpp": 300179998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708222342,
    "dropsitcph": 7708222421,
    "dropfax": 7708222718
  },
  {
    "dcode": "D",
    "dropkey": "PX10557",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "17 VAUGHN ST",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 307269998,
    "dropphyadd": "17 VAUGHN ST",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 307269998,
    "dropmaladd": "17 VAUGHN ST",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 307269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068919806,
    "dropsitcph": 7068910780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10561",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 306429998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 306429998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 306429998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064537328,
    "dropsitcph": 7064537328,
    "dropfax": 7064537174
  },
  {
    "dcode": "D",
    "dropkey": "PX10563",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "405 LAGRANGE ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302229998,
    "dropphyadd": "405 LAGRANGE ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302229998,
    "dropmaladd": "405 LAGRANGE ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302229998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066724945,
    "dropsitcph": 7066724945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10569",
    "droptype": "D",
    "dropname": "GRIFFIN",
    "dropdeladd": "101 N 8TH ST",
    "dropdelcty": "GRIFFIN",
    "dropdelst": "GA",
    "dropdelzpp": 302239998,
    "dropphyadd": "101 N 8TH ST",
    "dropphycty": "GRIFFIN",
    "dropphyst": "GA",
    "dropphyzpp": 302239998,
    "dropmaladd": "101 N 8TH ST",
    "dropmalcty": "GRIFFIN",
    "dropmalst": "GA",
    "dropmalzpp": 302239998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704128963,
    "dropsitcph": 7704128840,
    "dropfax": 7704121425
  },
  {
    "dcode": "D",
    "dropkey": "PX10572",
    "droptype": "D",
    "dropname": "GROVETOWN",
    "dropdeladd": "200 JOHN DEERE PKWY",
    "dropdelcty": "GROVETOWN",
    "dropdelst": "GA",
    "dropdelzpp": 308139998,
    "dropphyadd": "200 JOHN DEERE PKWY",
    "dropphycty": "GROVETOWN",
    "dropphyst": "GA",
    "dropphyzpp": 308139998,
    "dropmaladd": "200 JOHN DEERE PKWY",
    "dropmalcty": "GROVETOWN",
    "dropmalst": "GA",
    "dropmalzpp": 308139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068602791,
    "dropsitcph": 7068602791,
    "dropfax": 7068637386
  },
  {
    "dcode": "D",
    "dropkey": "PX10575",
    "droptype": "D",
    "dropname": "GUYTON",
    "dropdeladd": "711 W CENTRAL BLVD",
    "dropdelcty": "GUYTON",
    "dropdelst": "GA",
    "dropdelzpp": 313129998,
    "dropphyadd": "711 W CENTRAL BLVD",
    "dropphycty": "GUYTON",
    "dropphyst": "GA",
    "dropphyzpp": 313129998,
    "dropmaladd": "711 W CENTRAL BLVD",
    "dropmalcty": "GUYTON",
    "dropmalst": "GA",
    "dropmalzpp": 313129998,
    "dropsitphn": 4787528444,
    "dropsitlph": 9127726456,
    "dropsitcph": 9127726456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10581",
    "droptype": "D",
    "dropname": "HADDOCK",
    "dropdeladd": "1355 GA HIGHWAY 22 E",
    "dropdelcty": "HADDOCK",
    "dropdelst": "GA",
    "dropdelzpp": 310339998,
    "dropphyadd": "1355 GA HIGHWAY 22 E",
    "dropphycty": "HADDOCK",
    "dropphyst": "GA",
    "dropphyzpp": 310339998,
    "dropmaladd": "1355 GA HIGHWAY 22 E",
    "dropmalcty": "HADDOCK",
    "dropmalst": "GA",
    "dropmalzpp": 310339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789325790,
    "dropsitcph": 4789325790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10582",
    "droptype": "D",
    "dropname": "HAGAN",
    "dropdeladd": "5272 NW US HIGHWAY 280",
    "dropdelcty": "HAGAN",
    "dropdelst": "GA",
    "dropdelzpp": 304299998,
    "dropphyadd": "5272 NW US HIGHWAY 280",
    "dropphycty": "HAGAN",
    "dropphyst": "GA",
    "dropphyzpp": 304299998,
    "dropmaladd": "5272 NW US HIGHWAY 280",
    "dropmalcty": "HAGAN",
    "dropmalst": "GA",
    "dropmalzpp": 304299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127394246,
    "dropsitcph": 9127394246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10583",
    "droptype": "D",
    "dropname": "HAHIRA",
    "dropdeladd": "112 N CHURCH ST",
    "dropdelcty": "HAHIRA",
    "dropdelst": "GA",
    "dropdelzpp": 316329998,
    "dropphyadd": "112 N CHURCH ST",
    "dropphycty": "HAHIRA",
    "dropphyst": "GA",
    "dropphyzpp": 316329998,
    "dropmaladd": "112 N CHURCH ST",
    "dropmalcty": "HAHIRA",
    "dropmalst": "GA",
    "dropmalzpp": 316329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297948132,
    "dropsitcph": 2297948132,
    "dropfax": 2297943177
  },
  {
    "dcode": "D",
    "dropkey": "PX10584",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "9078 GA HIGHWAY 116 W",
    "dropdelcty": "HAMILTON",
    "dropdelst": "GA",
    "dropdelzpp": 318119998,
    "dropphyadd": "9078 GA HIGHWAY 116 W",
    "dropphycty": "HAMILTON",
    "dropphyst": "GA",
    "dropphyzpp": 318119998,
    "dropmaladd": "9078 GA HIGHWAY 116 W",
    "dropmalcty": "HAMILTON",
    "dropmalst": "GA",
    "dropmalzpp": 318119998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066289819,
    "dropsitcph": 7066289819,
    "dropfax": 7066289819
  },
  {
    "dcode": "D",
    "dropkey": "PX10585",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "998 HIGHWAY 19 41",
    "dropdelcty": "HAMPTON",
    "dropdelst": "GA",
    "dropdelzpp": 302289998,
    "dropphyadd": "998 HIGHWAY 19 41",
    "dropphycty": "HAMPTON",
    "dropphyst": "GA",
    "dropphyzpp": 302289998,
    "dropmaladd": "998 HIGHWAY 19 41",
    "dropmalcty": "HAMPTON",
    "dropmalst": "GA",
    "dropmalzpp": 302289998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709463385,
    "dropsitcph": 7709464669,
    "dropfax": 7709465275
  },
  {
    "dcode": "D",
    "dropkey": "PX10590",
    "droptype": "D",
    "dropname": "HARALSON",
    "dropdeladd": "214 HIGHWAY 85",
    "dropdelcty": "HARALSON",
    "dropdelst": "GA",
    "dropdelzpp": 302299900,
    "dropphyadd": "214 HIGHWAY 85",
    "dropphycty": "HARALSON",
    "dropphyst": "GA",
    "dropphyzpp": 302299900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARALSON",
    "dropmalst": "GA",
    "dropmalzpp": 302299998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705993665,
    "dropsitcph": 7705993665,
    "dropfax": 7705991425
  },
  {
    "dcode": "D",
    "dropkey": "PX10591",
    "droptype": "D",
    "dropname": "HARDWICK",
    "dropdeladd": "1870 IRWINTON RD",
    "dropdelcty": "HARDWICK",
    "dropdelst": "GA",
    "dropdelzpp": 310349998,
    "dropphyadd": "1870 IRWINTON RD",
    "dropphycty": "HARDWICK",
    "dropphyst": "GA",
    "dropphyzpp": 310349998,
    "dropmaladd": "1870 IRWINTON RD",
    "dropmalcty": "HARDWICK",
    "dropmalst": "GA",
    "dropmalzpp": 310349998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784549119,
    "dropsitcph": 4784549119,
    "dropfax": 4784539684
  },
  {
    "dcode": "D",
    "dropkey": "PX10592",
    "droptype": "D",
    "dropname": "HARLEM",
    "dropdeladd": "335 W MILLEDGEVILLE RD",
    "dropdelcty": "HARLEM",
    "dropdelst": "GA",
    "dropdelzpp": 308149998,
    "dropphyadd": "335 W MILLEDGEVILLE RD",
    "dropphycty": "HARLEM",
    "dropphyst": "GA",
    "dropphyzpp": 308149998,
    "dropmaladd": "335 W MILLEDGEVILLE RD",
    "dropmalcty": "HARLEM",
    "dropmalst": "GA",
    "dropmalzpp": 308149998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7626756000,
    "dropsitcph": 7065563101,
    "dropfax": 7065560896
  },
  {
    "dcode": "D",
    "dropkey": "PX10594",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "34 N RAILROAD AVE",
    "dropdelcty": "HARRISON",
    "dropdelst": "GA",
    "dropdelzpp": 310359998,
    "dropphyadd": "34 N RAILROAD AVE",
    "dropphycty": "HARRISON",
    "dropphyst": "GA",
    "dropphyzpp": 310359998,
    "dropmaladd": "34 N RAILROAD AVE",
    "dropmalcty": "HARRISON",
    "dropmalst": "GA",
    "dropmalzpp": 310359998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785520333,
    "dropsitcph": 4785520333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10595",
    "droptype": "D",
    "dropname": "HARTSFIELD",
    "dropdeladd": "7226 GA HIGHWAY 37 W",
    "dropdelcty": "HARTSFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 317569998,
    "dropphyadd": "7226 GA HIGHWAY 37 W",
    "dropphycty": "HARTSFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 317569998,
    "dropmaladd": "7226 GA HIGHWAY 37 W",
    "dropmalcty": "HARTSFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 317569998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2299412405,
    "dropsitcph": 2299412405,
    "dropfax": 4787528444
  },
  {
    "dcode": "D",
    "dropkey": "PX10597",
    "droptype": "D",
    "dropname": "HARTWELL",
    "dropdeladd": "184 W FRANKLIN ST",
    "dropdelcty": "HARTWELL",
    "dropdelst": "GA",
    "dropdelzpp": 306439998,
    "dropphyadd": "184 W FRANKLIN ST",
    "dropphycty": "HARTWELL",
    "dropphyst": "GA",
    "dropphyzpp": 306439998,
    "dropmaladd": "184 W FRANKLIN ST",
    "dropmalcty": "HARTWELL",
    "dropmalst": "GA",
    "dropmalzpp": 306439998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063769645,
    "dropsitcph": 7063764423,
    "dropfax": 7063764913
  },
  {
    "dcode": "D",
    "dropkey": "PX10598",
    "droptype": "D",
    "dropname": "HAWKINSVILLE",
    "dropdeladd": "148 COMMERCE ST",
    "dropdelcty": "HAWKINSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310369998,
    "dropphyadd": "148 COMMERCE ST",
    "dropphycty": "HAWKINSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310369998,
    "dropmaladd": "148 COMMERCE ST",
    "dropmalcty": "HAWKINSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788928499,
    "dropsitcph": 4788928499,
    "dropfax": 4787833049
  },
  {
    "dcode": "D",
    "dropkey": "PX10600",
    "droptype": "D",
    "dropname": "HAZLEHURST",
    "dropdeladd": "25 S CROMARTIE ST",
    "dropdelcty": "HAZLEHURST",
    "dropdelst": "GA",
    "dropdelzpp": 315399998,
    "dropphyadd": "25 S CROMARTIE ST",
    "dropphycty": "HAZLEHURST",
    "dropphyst": "GA",
    "dropphyzpp": 315399998,
    "dropmaladd": "25 S CROMARTIE ST",
    "dropmalcty": "HAZLEHURST",
    "dropmalst": "GA",
    "dropmalzpp": 315399998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123799044,
    "dropsitcph": 9123799044,
    "dropfax": 9123755954
  },
  {
    "dcode": "D",
    "dropkey": "PX10601",
    "droptype": "D",
    "dropname": "HELEN",
    "dropdeladd": "7976 S MAIN ST",
    "dropdelcty": "HELEN",
    "dropdelst": "GA",
    "dropdelzpp": 305459998,
    "dropphyadd": "7976 S MAIN ST",
    "dropphycty": "HELEN",
    "dropphyst": "GA",
    "dropphyzpp": 305459998,
    "dropmaladd": "7976 S MAIN ST",
    "dropmalcty": "HELEN",
    "dropmalst": "GA",
    "dropmalzpp": 305459998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068782422,
    "dropsitcph": 7068782422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10602",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "21 S FORSYTH AVE",
    "dropdelcty": "MC RAE HELENA",
    "dropdelst": "GA",
    "dropdelzpp": 310379998,
    "dropphyadd": "21 S FORSYTH AVE",
    "dropphycty": "MC RAE HELENA",
    "dropphyst": "GA",
    "dropphyzpp": 310379998,
    "dropmaladd": "21 S FORSYTH AVE",
    "dropmalcty": "MC RAE HELENA",
    "dropmalst": "GA",
    "dropmalzpp": 310379998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298686371,
    "dropsitcph": 2298686371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10604",
    "droptype": "D",
    "dropname": "HEPHZIBAH",
    "dropdeladd": "4902 WINDSOR SPRING RD",
    "dropdelcty": "HEPHZIBAH",
    "dropdelst": "GA",
    "dropdelzpp": 308159998,
    "dropphyadd": "4902 WINDSOR SPRING RD",
    "dropphycty": "HEPHZIBAH",
    "dropphyst": "GA",
    "dropphyzpp": 308159998,
    "dropmaladd": "4902 WINDSOR SPRING RD",
    "dropmalcty": "HEPHZIBAH",
    "dropmalst": "GA",
    "dropmalzpp": 308159998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065922570,
    "dropsitcph": 7065922570,
    "dropfax": 7065922570
  },
  {
    "dcode": "D",
    "dropkey": "PX10607",
    "droptype": "D",
    "dropname": "HIAWASSEE",
    "dropdeladd": "118 N MAIN ST",
    "dropdelcty": "HIAWASSEE",
    "dropdelst": "GA",
    "dropdelzpp": 305469998,
    "dropphyadd": "118 N MAIN ST",
    "dropphycty": "HIAWASSEE",
    "dropphyst": "GA",
    "dropphyzpp": 305469998,
    "dropmaladd": "118 N MAIN ST",
    "dropmalcty": "HIAWASSEE",
    "dropmalst": "GA",
    "dropmalzpp": 305469998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068963632,
    "dropsitcph": 7068963632,
    "dropfax": 7068965590
  },
  {
    "dcode": "D",
    "dropkey": "PX10612",
    "droptype": "D",
    "dropname": "HIGH SHOALS",
    "dropdeladd": "103 JEFFERSON RD",
    "dropdelcty": "HIGH SHOALS",
    "dropdelst": "GA",
    "dropdelzpp": 306451555,
    "dropphyadd": "103 JEFFERSON RD",
    "dropphycty": "HIGH SHOALS",
    "dropphyst": "GA",
    "dropphyzpp": 306451555,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGH SHOALS",
    "dropmalst": "GA",
    "dropmalzpp": 306459998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067697500,
    "dropsitcph": 7067697500,
    "dropfax": 7067697500
  },
  {
    "dcode": "D",
    "dropkey": "PX10618",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "1917 GA HIGHWAY 11 S",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 310389998,
    "dropphyadd": "1917 GA HIGHWAY 11 S",
    "dropphycty": "HILLSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 310389998,
    "dropmaladd": "1917 GA HIGHWAY 11 S",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 310389998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064685856,
    "dropsitcph": 7064685856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10621",
    "droptype": "D",
    "dropname": "HINESVILLE",
    "dropdeladd": "744 W OGLETHORPE HWY",
    "dropdelcty": "HINESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 313139998,
    "dropphyadd": "744 W OGLETHORPE HWY",
    "dropphycty": "HINESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 313139998,
    "dropmaladd": "744 W OGLETHORPE HWY",
    "dropmalcty": "HINESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 313139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128765086,
    "dropsitcph": 9128765086,
    "dropfax": 9123692090
  },
  {
    "dcode": "D",
    "dropkey": "PX10623",
    "droptype": "D",
    "dropname": "HIRAM",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "HIRAM",
    "dropdelst": "GA",
    "dropdelzpp": 301419998,
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "HIRAM",
    "dropphyst": "GA",
    "dropphyzpp": 301419998,
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "HIRAM",
    "dropmalst": "GA",
    "dropmalzpp": 301419998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702220426,
    "dropsitcph": 7702220425,
    "dropfax": 7709434713
  },
  {
    "dcode": "D",
    "dropkey": "PX10624",
    "droptype": "D",
    "dropname": "HOBOKEN",
    "dropdeladd": "4850 MAIN ST E",
    "dropdelcty": "HOBOKEN",
    "dropdelst": "GA",
    "dropdelzpp": 315429998,
    "dropphyadd": "4850 MAIN ST E",
    "dropphycty": "HOBOKEN",
    "dropphyst": "GA",
    "dropphyzpp": 315429998,
    "dropmaladd": "4850 MAIN ST E",
    "dropmalcty": "HOBOKEN",
    "dropmalst": "GA",
    "dropmalzpp": 315429998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124582288,
    "dropsitcph": 9124582288,
    "dropfax": 9124583520
  },
  {
    "dcode": "D",
    "dropkey": "PX10625",
    "droptype": "D",
    "dropname": "HOGANSVILLE",
    "dropdeladd": "113 HIGH ST",
    "dropdelcty": "HOGANSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302301543,
    "dropphyadd": "113 HIGH ST",
    "dropphycty": "HOGANSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302301543,
    "dropmaladd": "113 HIGH ST",
    "dropmalcty": "HOGANSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302301543,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066374564,
    "dropsitcph": 7066374344,
    "dropfax": 7066378251
  },
  {
    "dcode": "D",
    "dropkey": "PX10630",
    "droptype": "D",
    "dropname": "HOLLY SPRINGS",
    "dropdeladd": "2210 HOLLY SPRINGS PKWY",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 301429997,
    "dropphyadd": "2210 HOLLY SPRINGS PKWY",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 301429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 301429998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784935537,
    "dropsitcph": 6784935537,
    "dropfax": 6784937320
  },
  {
    "dcode": "D",
    "dropkey": "PX10633",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "106 GRIFFIN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "GA",
    "dropdelzpp": 305479998,
    "dropphyadd": "106 GRIFFIN ST",
    "dropphycty": "HOMER",
    "dropphyst": "GA",
    "dropphyzpp": 305479998,
    "dropmaladd": "106 GRIFFIN ST",
    "dropmalcty": "HOMER",
    "dropmalst": "GA",
    "dropmalzpp": 305479998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066772286,
    "dropsitcph": 7066772286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10634",
    "droptype": "D",
    "dropname": "HOMERVILLE",
    "dropdeladd": "57 E DAME AVE",
    "dropdelcty": "HOMERVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 316349998,
    "dropphyadd": "57 E DAME AVE",
    "dropphycty": "HOMERVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 316349998,
    "dropmaladd": "57 E DAME AVE",
    "dropmalcty": "HOMERVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 316349998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124873767,
    "dropsitcph": 9124873767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10636",
    "droptype": "D",
    "dropname": "HORTENSE",
    "dropdeladd": "4779 HIGHWAY 32 W",
    "dropdelcty": "HORTENSE",
    "dropdelst": "GA",
    "dropdelzpp": 315439997,
    "dropphyadd": "4779 HIGHWAY 32 W",
    "dropphycty": "HORTENSE",
    "dropphyst": "GA",
    "dropphyzpp": 315439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HORTENSE",
    "dropmalst": "GA",
    "dropmalzpp": 315439998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124732515,
    "dropsitcph": 9124732515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10637",
    "droptype": "D",
    "dropname": "HOSCHTON",
    "dropdeladd": "20 E JEFFERSON ST",
    "dropdelcty": "HOSCHTON",
    "dropdelst": "GA",
    "dropdelzpp": 305489998,
    "dropphyadd": "20 E JEFFERSON ST",
    "dropphycty": "HOSCHTON",
    "dropphyst": "GA",
    "dropphyzpp": 305489998,
    "dropmaladd": "20 E JEFFERSON ST",
    "dropmalcty": "HOSCHTON",
    "dropmalst": "GA",
    "dropmalzpp": 305489998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066543168,
    "dropsitcph": 7066543168,
    "dropfax": 7066543583
  },
  {
    "dcode": "D",
    "dropkey": "PX10638",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "336 BROWN RD",
    "dropdelcty": "HOWARD",
    "dropdelst": "GA",
    "dropdelzpp": 310399700,
    "dropphyadd": "336 BROWN RD",
    "dropphycty": "HOWARD",
    "dropphyst": "GA",
    "dropphyzpp": 310399700,
    "dropmaladd": "336 BROWN RD",
    "dropmalcty": "HOWARD",
    "dropmalst": "GA",
    "dropmalzpp": 310399700,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788623728,
    "dropsitcph": 4788623728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10642",
    "droptype": "D",
    "dropname": "HULL",
    "dropdeladd": "10310 HIGHWAY 72 W",
    "dropdelcty": "HULL",
    "dropdelst": "GA",
    "dropdelzpp": 306469998,
    "dropphyadd": "10310 HIGHWAY 72 W",
    "dropphycty": "HULL",
    "dropphyst": "GA",
    "dropphyzpp": 306469998,
    "dropmaladd": "10310 HIGHWAY 72 W",
    "dropmalcty": "HULL",
    "dropmalst": "GA",
    "dropmalzpp": 306469998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7065435050,
    "dropsitcph": 7065435050,
    "dropfax": 7062270457
  },
  {
    "dcode": "D",
    "dropkey": "PX10645",
    "droptype": "D",
    "dropname": "IDEAL",
    "dropdeladd": "603 TOM WATSON AVE",
    "dropdelcty": "IDEAL",
    "dropdelst": "GA",
    "dropdelzpp": 310419998,
    "dropphyadd": "603 TOM WATSON AVE",
    "dropphycty": "IDEAL",
    "dropphyst": "GA",
    "dropphyzpp": 310419998,
    "dropmaladd": "603 TOM WATSON AVE",
    "dropmalcty": "IDEAL",
    "dropmalst": "GA",
    "dropmalzpp": 310419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789492065,
    "dropsitcph": 4789492065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10646",
    "droptype": "D",
    "dropname": "ILA",
    "dropdeladd": "61 N MAIN ST",
    "dropdelcty": "ILA",
    "dropdelst": "GA",
    "dropdelzpp": 306474205,
    "dropphyadd": "61 N MAIN ST",
    "dropphycty": "ILA",
    "dropphyst": "GA",
    "dropphyzpp": 306474205,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ILA",
    "dropmalst": "GA",
    "dropmalzpp": 306479998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067893384,
    "dropsitcph": 7067893384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10652",
    "droptype": "D",
    "dropname": "IRON CITY",
    "dropdeladd": "150 S CHURCH ST",
    "dropdelcty": "IRON CITY",
    "dropdelst": "GA",
    "dropdelzpp": 398599998,
    "dropphyadd": "150 S CHURCH ST",
    "dropphycty": "IRON CITY",
    "dropphyst": "GA",
    "dropphyzpp": 398599998,
    "dropmaladd": "150 S CHURCH ST",
    "dropmalcty": "IRON CITY",
    "dropmalst": "GA",
    "dropmalzpp": 398599998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297742523,
    "dropsitcph": 2297742523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10654",
    "droptype": "D",
    "dropname": "IRWINTON",
    "dropdeladd": "113 ASBELL ST",
    "dropdelcty": "IRWINTON",
    "dropdelst": "GA",
    "dropdelzpp": 310429998,
    "dropphyadd": "113 ASBELL ST",
    "dropphycty": "IRWINTON",
    "dropphyst": "GA",
    "dropphyzpp": 310429998,
    "dropmaladd": "113 ASBELL ST",
    "dropmalcty": "IRWINTON",
    "dropmalst": "GA",
    "dropmalzpp": 310429998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789461107,
    "dropsitcph": 4789461107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10658",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "461 E 2ND ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "GA",
    "dropdelzpp": 302339998,
    "dropphyadd": "461 E 2ND ST",
    "dropphycty": "JACKSON",
    "dropphyst": "GA",
    "dropphyzpp": 302339998,
    "dropmaladd": "461 E 2ND ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "GA",
    "dropmalzpp": 302339998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707751654,
    "dropsitcph": 7705049024,
    "dropfax": 7707750364
  },
  {
    "dcode": "D",
    "dropkey": "PX10659",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "16 WATER TOWER RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 315449997,
    "dropphyadd": "16 WATER TOWER RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 315449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 315449998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298334240,
    "dropsitcph": 2298334240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10660",
    "droptype": "D",
    "dropname": "JAKIN",
    "dropdeladd": "1145 N PEARL ST",
    "dropdelcty": "JAKIN",
    "dropdelst": "GA",
    "dropdelzpp": 398619998,
    "dropphyadd": "1145 N PEARL ST",
    "dropphycty": "JAKIN",
    "dropphyst": "GA",
    "dropphyzpp": 398619998,
    "dropmaladd": "1145 N PEARL ST",
    "dropmalcty": "JAKIN",
    "dropmalst": "GA",
    "dropmalzpp": 398619998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297934341,
    "dropsitcph": 2297934341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10661",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "100 EAGLES LNDG",
    "dropdelcty": "JASPER",
    "dropdelst": "GA",
    "dropdelzpp": 301439998,
    "dropphyadd": "100 EAGLES LNDG",
    "dropphycty": "JASPER",
    "dropphyst": "GA",
    "dropphyzpp": 301439998,
    "dropmaladd": "100 EAGLES LNDG",
    "dropmalcty": "JASPER",
    "dropmalst": "GA",
    "dropmalzpp": 301439998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062534315,
    "dropsitcph": 7062534300,
    "dropfax": 7062534306
  },
  {
    "dcode": "D",
    "dropkey": "PX10662",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "216 LEE ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "GA",
    "dropdelzpp": 305499998,
    "dropphyadd": "216 LEE ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "GA",
    "dropphyzpp": 305499998,
    "dropmaladd": "216 LEE ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "GA",
    "dropmalzpp": 305499998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063679564,
    "dropsitcph": 7063678264,
    "dropfax": 7063672937
  },
  {
    "dcode": "D",
    "dropkey": "PX10663",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "13718 US HIGHWAY 80",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310449998,
    "dropphyadd": "13718 US HIGHWAY 80",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310449998,
    "dropmaladd": "13718 US HIGHWAY 80",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310449998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789453517,
    "dropsitcph": 4789453517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10667",
    "droptype": "D",
    "dropname": "JENKINSBURG",
    "dropdeladd": "2109 HIGHWAY 42 N",
    "dropdelcty": "JENKINSBURG",
    "dropdelst": "GA",
    "dropdelzpp": 302349998,
    "dropphyadd": "2109 HIGHWAY 42 N",
    "dropphycty": "JENKINSBURG",
    "dropphyst": "GA",
    "dropphyzpp": 302349998,
    "dropmaladd": "2109 HIGHWAY 42 N",
    "dropmalcty": "JENKINSBURG",
    "dropmalst": "GA",
    "dropmalzpp": 302349998,
    "dropsitphn": 7702686142,
    "dropsitlph": 7702686142,
    "dropsitcph": 7702686142,
    "dropfax": 7702686142
  },
  {
    "dcode": "D",
    "dropkey": "PX10668",
    "droptype": "D",
    "dropname": "JERSEY",
    "dropdeladd": "133 MAIN ST",
    "dropdelcty": "JERSEY",
    "dropdelst": "GA",
    "dropdelzpp": 300189900,
    "dropphyadd": "133 MAIN ST",
    "dropphycty": "JERSEY",
    "dropphyst": "GA",
    "dropphyzpp": 300189900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JERSEY",
    "dropmalst": "GA",
    "dropmalzpp": 300189998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704642283,
    "dropsitcph": 7704642283,
    "dropfax": 7704641971
  },
  {
    "dcode": "D",
    "dropkey": "PX10669",
    "droptype": "D",
    "dropname": "JESUP",
    "dropdeladd": "405 E WALNUT ST",
    "dropdelcty": "JESUP",
    "dropdelst": "GA",
    "dropdelzpp": 315469998,
    "dropphyadd": "405 E WALNUT ST",
    "dropphycty": "JESUP",
    "dropphyst": "GA",
    "dropphyzpp": 315469998,
    "dropmaladd": "405 E WALNUT ST",
    "dropmalcty": "JESUP",
    "dropmalst": "GA",
    "dropmalzpp": 315469998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124272267,
    "dropsitcph": 9124272267,
    "dropfax": 9124273736
  },
  {
    "dcode": "D",
    "dropkey": "PX10670",
    "droptype": "D",
    "dropname": "JEWELL",
    "dropdeladd": "10862 MACON HWY",
    "dropdelcty": "JEWELL",
    "dropdelst": "GA",
    "dropdelzpp": 310459998,
    "dropphyadd": "10862 MACON HWY",
    "dropphycty": "JEWELL",
    "dropphyst": "GA",
    "dropphyzpp": 310459998,
    "dropmaladd": "10862 MACON HWY",
    "dropmalcty": "JEWELL",
    "dropmalst": "GA",
    "dropmalzpp": 310459998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064651600,
    "dropsitcph": 7064651600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10673",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "255 N MAIN ST",
    "dropdelcty": "JONESBORO",
    "dropdelst": "GA",
    "dropdelzpp": 302369998,
    "dropphyadd": "255 N MAIN ST",
    "dropphycty": "JONESBORO",
    "dropphyst": "GA",
    "dropphyzpp": 302369998,
    "dropmaladd": "255 N MAIN ST",
    "dropmalcty": "JONESBORO",
    "dropmalst": "GA",
    "dropmalzpp": 302369998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702100783,
    "dropsitcph": 7702100763,
    "dropfax": 7704713081
  },
  {
    "dcode": "D",
    "dropkey": "PX10676",
    "droptype": "D",
    "dropname": "JULIETTE",
    "dropdeladd": "356 BOWDOIN RD",
    "dropdelcty": "JULIETTE",
    "dropdelst": "GA",
    "dropdelzpp": 310469998,
    "dropphyadd": "356 BOWDOIN RD",
    "dropphycty": "JULIETTE",
    "dropphyst": "GA",
    "dropphyzpp": 310469998,
    "dropmaladd": "356 BOWDOIN RD",
    "dropmalcty": "JULIETTE",
    "dropmalst": "GA",
    "dropmalzpp": 310469998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789946611,
    "dropsitcph": 4789946611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10677",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "65 BROAD ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "GA",
    "dropdelzpp": 318129998,
    "dropphyadd": "65 BROAD ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "GA",
    "dropphyzpp": 318129998,
    "dropmaladd": "65 BROAD ST",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "GA",
    "dropmalzpp": 318129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7062693837,
    "dropsitcph": 7062693837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10680",
    "droptype": "D",
    "dropname": "KATHLEEN",
    "dropdeladd": "1010 GA HIGHWAY 247 S",
    "dropdelcty": "KATHLEEN",
    "dropdelst": "GA",
    "dropdelzpp": 310479998,
    "dropphyadd": "1010 GA HIGHWAY 247 S",
    "dropphycty": "KATHLEEN",
    "dropphyst": "GA",
    "dropphyzpp": 310479998,
    "dropmaladd": "1010 GA HIGHWAY 247 S",
    "dropmalcty": "KATHLEEN",
    "dropmalst": "GA",
    "dropmalzpp": 310479998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782182888,
    "dropsitcph": 4782182888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10683",
    "droptype": "D",
    "dropname": "KENNESAW",
    "dropdeladd": "2001 DUNCAN DR NW",
    "dropdelcty": "KENNESAW",
    "dropdelst": "GA",
    "dropdelzpp": 301449998,
    "dropphyadd": "2001 DUNCAN DR NW",
    "dropphycty": "KENNESAW",
    "dropphyst": "GA",
    "dropphyzpp": 301449998,
    "dropmaladd": "2001 DUNCAN DR NW",
    "dropmalcty": "KENNESAW",
    "dropmalst": "GA",
    "dropmalzpp": 301449998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784245407,
    "dropsitcph": 7704224103,
    "dropfax": 7705907825
  },
  {
    "dcode": "D",
    "dropkey": "PX10685",
    "droptype": "D",
    "dropname": "KEYSVILLE",
    "dropdeladd": "118 OLD WAYNESBORO RD",
    "dropdelcty": "KEYSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 308169998,
    "dropphyadd": "118 OLD WAYNESBORO RD",
    "dropphycty": "KEYSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 308169998,
    "dropmaladd": "118 OLD WAYNESBORO RD",
    "dropmalcty": "KEYSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 308169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065473208,
    "dropsitcph": 7065473208,
    "dropfax": 7065477714
  },
  {
    "dcode": "D",
    "dropkey": "PX10688",
    "droptype": "D",
    "dropname": "KINGSLAND",
    "dropdeladd": "310 S GROVE BLVD",
    "dropdelcty": "KINGSLAND",
    "dropdelst": "GA",
    "dropdelzpp": 315489998,
    "dropphyadd": "310 S GROVE BLVD",
    "dropphycty": "KINGSLAND",
    "dropphyst": "GA",
    "dropphyzpp": 315489998,
    "dropmaladd": "310 S GROVE BLVD",
    "dropmalcty": "KINGSLAND",
    "dropmalst": "GA",
    "dropmalzpp": 315489998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127291486,
    "dropsitcph": 9127291486,
    "dropfax": 4787295511
  },
  {
    "dcode": "D",
    "dropkey": "PX10690",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "25 W MAIN ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "GA",
    "dropdelzpp": 301459998,
    "dropphyadd": "25 W MAIN ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "GA",
    "dropphyzpp": 301459998,
    "dropmaladd": "25 W MAIN ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "GA",
    "dropmalzpp": 301459998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703365179,
    "dropsitcph": 7703365179,
    "dropfax": 7703365448
  },
  {
    "dcode": "D",
    "dropkey": "PX10691",
    "droptype": "D",
    "dropname": "KITE",
    "dropdeladd": "1123 RAILROAD ST",
    "dropdelcty": "KITE",
    "dropdelst": "GA",
    "dropdelzpp": 310499998,
    "dropphyadd": "1123 RAILROAD ST",
    "dropphycty": "KITE",
    "dropphyst": "GA",
    "dropphyzpp": 310499998,
    "dropmaladd": "1123 RAILROAD ST",
    "dropmalcty": "KITE",
    "dropmalst": "GA",
    "dropmalzpp": 310499998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784695127,
    "dropsitcph": 4784695127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10696",
    "droptype": "D",
    "dropname": "LA FAYETTE",
    "dropdeladd": "220 FOSTER BLVD",
    "dropdelcty": "LA FAYETTE",
    "dropdelst": "GA",
    "dropdelzpp": 307289998,
    "dropphyadd": "220 FOSTER BLVD",
    "dropphycty": "LA FAYETTE",
    "dropphyst": "GA",
    "dropphyzpp": 307289998,
    "dropmaladd": "220 FOSTER BLVD",
    "dropmalcty": "LA FAYETTE",
    "dropmalst": "GA",
    "dropmalzpp": 307289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066206019,
    "dropsitcph": 7066399072,
    "dropfax": 7066387819
  },
  {
    "dcode": "D",
    "dropkey": "PX10697",
    "droptype": "D",
    "dropname": "LAGRANGE",
    "dropdeladd": "950 LAFAYETTE PKWY",
    "dropdelcty": "LAGRANGE",
    "dropdelst": "GA",
    "dropdelzpp": 302419998,
    "dropphyadd": "950 LAFAYETTE PKWY",
    "dropphycty": "LAGRANGE",
    "dropphyst": "GA",
    "dropphyzpp": 302419998,
    "dropmaladd": "950 LAFAYETTE PKWY",
    "dropmalcty": "LAGRANGE",
    "dropmalst": "GA",
    "dropmalzpp": 302419998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068836601,
    "dropsitcph": 7068837126,
    "dropfax": 7068825993
  },
  {
    "dcode": "D",
    "dropkey": "PX10707",
    "droptype": "D",
    "dropname": "LAKE PARK",
    "dropdeladd": "687 LAKES BLVD",
    "dropdelcty": "LAKE PARK",
    "dropdelst": "GA",
    "dropdelzpp": 316369998,
    "dropphyadd": "687 LAKES BLVD",
    "dropphycty": "LAKE PARK",
    "dropphyst": "GA",
    "dropphyzpp": 316369998,
    "dropmaladd": "687 LAKES BLVD",
    "dropmalcty": "LAKE PARK",
    "dropmalst": "GA",
    "dropmalzpp": 316369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295597843,
    "dropsitcph": 2295597843,
    "dropfax": 2295596727
  },
  {
    "dcode": "D",
    "dropkey": "PX10708",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "15 S VALDOSTA RD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "GA",
    "dropdelzpp": 316359998,
    "dropphyadd": "15 S VALDOSTA RD",
    "dropphycty": "LAKELAND",
    "dropphyst": "GA",
    "dropphyzpp": 316359998,
    "dropmaladd": "15 S VALDOSTA RD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "GA",
    "dropmalzpp": 316359998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2294823279,
    "dropsitcph": 2294823279,
    "dropfax": 2294829492
  },
  {
    "dcode": "D",
    "dropkey": "PX10709",
    "droptype": "D",
    "dropname": "LAKEMONT",
    "dropdeladd": "17 LAKEMONT INDUSTRIAL DR",
    "dropdelcty": "LAKEMONT",
    "dropdelst": "GA",
    "dropdelzpp": 305529998,
    "dropphyadd": "17 LAKEMONT INDUSTRIAL DR",
    "dropphycty": "LAKEMONT",
    "dropphyst": "GA",
    "dropphyzpp": 305529998,
    "dropmaladd": "17 LAKEMONT INDUSTRIAL DR",
    "dropmalcty": "LAKEMONT",
    "dropmalst": "GA",
    "dropmalzpp": 305529998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067825456,
    "dropsitcph": 7067825456,
    "dropfax": 7067829786
  },
  {
    "dcode": "D",
    "dropkey": "PX10711",
    "droptype": "D",
    "dropname": "LAVONIA",
    "dropdeladd": "5825 VICKERY ST",
    "dropdelcty": "LAVONIA",
    "dropdelst": "GA",
    "dropdelzpp": 305539998,
    "dropphyadd": "5825 VICKERY ST",
    "dropphycty": "LAVONIA",
    "dropphyst": "GA",
    "dropphyzpp": 305539998,
    "dropmaladd": "5825 VICKERY ST",
    "dropmalcty": "LAVONIA",
    "dropmalst": "GA",
    "dropmalzpp": 305539998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064202484,
    "dropsitcph": 7064202484,
    "dropfax": 7063567768
  },
  {
    "dcode": "D",
    "dropkey": "PX10712",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE",
    "dropdeladd": "35 PATTERSON RD",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300444717,
    "dropphyadd": "35 PATTERSON RD",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300444717,
    "dropmaladd": "35 PATTERSON RD",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300444717,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702378283,
    "dropsitcph": 7702378283,
    "dropfax": 7705134551
  },
  {
    "dcode": "D",
    "dropkey": "PX10716",
    "droptype": "D",
    "dropname": "LEARY",
    "dropdeladd": "59 COLLEY ST",
    "dropdelcty": "LEARY",
    "dropdelst": "GA",
    "dropdelzpp": 398629998,
    "dropphyadd": "59 COLLEY ST",
    "dropphycty": "LEARY",
    "dropphyst": "GA",
    "dropphyzpp": 398629998,
    "dropmaladd": "59 COLLEY ST",
    "dropmalcty": "LEARY",
    "dropmalst": "GA",
    "dropmalzpp": 398629998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297926112,
    "dropsitcph": 2297926112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10718",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "5101 OLD HIGHWAY 5",
    "dropdelcty": "LEBANON",
    "dropdelst": "GA",
    "dropdelzpp": 301469900,
    "dropphyadd": "5101 OLD HIGHWAY 5",
    "dropphycty": "LEBANON",
    "dropphyst": "GA",
    "dropphyzpp": 301469900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEBANON",
    "dropmalst": "GA",
    "dropmalzpp": 301469998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705919467,
    "dropsitcph": 7705919467,
    "dropfax": 7709265915
  },
  {
    "dcode": "D",
    "dropkey": "PX10720",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "152 ROBERT B LEE DR",
    "dropdelcty": "LEESBURG",
    "dropdelst": "GA",
    "dropdelzpp": 317639998,
    "dropphyadd": "152 ROBERT B LEE DR",
    "dropphycty": "LEESBURG",
    "dropphyst": "GA",
    "dropphyzpp": 317639998,
    "dropmaladd": "152 ROBERT B LEE DR",
    "dropmalcty": "LEESBURG",
    "dropmalst": "GA",
    "dropmalzpp": 317639998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297590929,
    "dropsitcph": 2297590929,
    "dropfax": 2297596323
  },
  {
    "dcode": "D",
    "dropkey": "PX10721",
    "droptype": "D",
    "dropname": "LENOX",
    "dropdeladd": "44 S DEPOT ST",
    "dropdelcty": "LENOX",
    "dropdelst": "GA",
    "dropdelzpp": 316379998,
    "dropphyadd": "44 S DEPOT ST",
    "dropphycty": "LENOX",
    "dropphyst": "GA",
    "dropphyzpp": 316379998,
    "dropmaladd": "44 S DEPOT ST",
    "dropmalcty": "LENOX",
    "dropmalst": "GA",
    "dropmalzpp": 316379998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295464289,
    "dropsitcph": 2295464289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10728",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "118 W BOGGS ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 306489998,
    "dropphyadd": "118 W BOGGS ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 306489998,
    "dropmaladd": "118 W BOGGS ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 306489998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067438251,
    "dropsitcph": 7067438251,
    "dropfax": 7067433717
  },
  {
    "dcode": "D",
    "dropkey": "PX10730",
    "droptype": "D",
    "dropname": "LILBURN",
    "dropdeladd": "4370 LAWRENCEVILLE HWY NW",
    "dropdelcty": "LILBURN",
    "dropdelst": "GA",
    "dropdelzpp": 300471100,
    "dropphyadd": "4370 LAWRENCEVILLE HWY NW",
    "dropphycty": "LILBURN",
    "dropphyst": "GA",
    "dropphyzpp": 300471100,
    "dropmaladd": "4370 LAWRENCEVILLE HWY NW",
    "dropmalcty": "LILBURN",
    "dropmalst": "GA",
    "dropmalzpp": 300471100,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707178762,
    "dropsitcph": 7709233391,
    "dropfax": 7709235772
  },
  {
    "dcode": "D",
    "dropkey": "PX10731",
    "droptype": "D",
    "dropname": "LILLY",
    "dropdeladd": "122 WADLEY ST",
    "dropdelcty": "LILLY",
    "dropdelst": "GA",
    "dropdelzpp": 310512500,
    "dropphyadd": "122 WADLEY ST",
    "dropphycty": "LILLY",
    "dropphyst": "GA",
    "dropphyzpp": 310512500,
    "dropmaladd": "122 WADLEY ST",
    "dropmalcty": "LILLY",
    "dropmalst": "GA",
    "dropmalzpp": 310512500,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292682044,
    "dropsitcph": 2292682044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10732",
    "droptype": "D",
    "dropname": "LINCOLNTON",
    "dropdeladd": "182 ELM ST",
    "dropdelcty": "LINCOLNTON",
    "dropdelst": "GA",
    "dropdelzpp": 308179998,
    "dropphyadd": "182 ELM ST",
    "dropphycty": "LINCOLNTON",
    "dropphyst": "GA",
    "dropphyzpp": 308179998,
    "dropmaladd": "182 ELM ST",
    "dropmalcty": "LINCOLNTON",
    "dropmalst": "GA",
    "dropmalzpp": 308179998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7063593258,
    "dropsitcph": 7063593258,
    "dropfax": 7063593147
  },
  {
    "dcode": "D",
    "dropkey": "PX10733",
    "droptype": "D",
    "dropname": "LINDALE",
    "dropdeladd": "502 PARK AVE SE",
    "dropdelcty": "LINDALE",
    "dropdelst": "GA",
    "dropdelzpp": 301479998,
    "dropphyadd": "502 PARK AVE SE",
    "dropphycty": "LINDALE",
    "dropphyst": "GA",
    "dropphyzpp": 301479998,
    "dropmaladd": "502 PARK AVE SE",
    "dropmalcty": "LINDALE",
    "dropmalst": "GA",
    "dropmalzpp": 301479998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062321624,
    "dropsitcph": 7062321624,
    "dropfax": 7062322500
  },
  {
    "dcode": "D",
    "dropkey": "PX10737",
    "droptype": "D",
    "dropname": "LITHIA SPRINGS",
    "dropdeladd": "2727 SKYVIEW DR",
    "dropdelcty": "LITHIA SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 301229998,
    "dropphyadd": "2727 SKYVIEW DR",
    "dropphycty": "LITHIA SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 301229998,
    "dropmaladd": "2727 SKYVIEW DR",
    "dropmalcty": "LITHIA SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 301229998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782552158,
    "dropsitcph": 6789459377,
    "dropfax": 6789459182
  },
  {
    "dcode": "D",
    "dropkey": "PX10738",
    "droptype": "D",
    "dropname": "LITHONIA",
    "dropdeladd": "3035 STONE MOUNTAIN ST",
    "dropdelcty": "LITHONIA",
    "dropdelst": "GA",
    "dropdelzpp": 300584412,
    "dropphyadd": "3035 STONE MOUNTAIN ST",
    "dropphycty": "LITHONIA",
    "dropphyst": "GA",
    "dropphyzpp": 300584412,
    "dropmaladd": "3035 STONE MOUNTAIN ST",
    "dropmalcty": "LITHONIA",
    "dropmalst": "GA",
    "dropmalzpp": 300584412,
    "dropsitphn": 4047657578,
    "dropsitlph": 6783360139,
    "dropsitcph": 7704840766,
    "dropfax": 7704841452
  },
  {
    "dcode": "D",
    "dropkey": "PX10740",
    "droptype": "D",
    "dropname": "LIZELLA",
    "dropdeladd": "2899 WILLIAMSON DR",
    "dropdelcty": "LIZELLA",
    "dropdelst": "GA",
    "dropdelzpp": 310529998,
    "dropphyadd": "2899 WILLIAMSON DR",
    "dropphycty": "LIZELLA",
    "dropphyst": "GA",
    "dropphyzpp": 310529998,
    "dropmaladd": "2899 WILLIAMSON DR",
    "dropmalcty": "LIZELLA",
    "dropmalst": "GA",
    "dropmalzpp": 310529998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789359984,
    "dropsitcph": 4789359984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10743",
    "droptype": "D",
    "dropname": "LOCUST GROVE",
    "dropdeladd": "4050 HIGHWAY 42 S",
    "dropdelcty": "LOCUST GROVE",
    "dropdelst": "GA",
    "dropdelzpp": 302489998,
    "dropphyadd": "4050 HIGHWAY 42 S",
    "dropphycty": "LOCUST GROVE",
    "dropphyst": "GA",
    "dropphyzpp": 302489998,
    "dropmaladd": "4050 HIGHWAY 42 S",
    "dropmalcty": "LOCUST GROVE",
    "dropmalst": "GA",
    "dropmalzpp": 302489998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708986042,
    "dropsitcph": 7708986042,
    "dropfax": 7708985382
  },
  {
    "dcode": "D",
    "dropkey": "PX10745",
    "droptype": "D",
    "dropname": "LOGANVILLE",
    "dropdeladd": "4160 LOGAN DR",
    "dropdelcty": "LOGANVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300529998,
    "dropphyadd": "4160 LOGAN DR",
    "dropphycty": "LOGANVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300529998,
    "dropmaladd": "4160 LOGAN DR",
    "dropmalcty": "LOGANVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300529998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704660782,
    "dropsitcph": 7705540435,
    "dropfax": 7705540949
  },
  {
    "dcode": "D",
    "dropkey": "PX10750",
    "droptype": "D",
    "dropname": "LOOKOUT MOUNTAIN",
    "dropdeladd": "824 SCENIC HWY",
    "dropdelcty": "LOOKOUT MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 307509998,
    "dropphyadd": "824 SCENIC HWY",
    "dropphycty": "LOOKOUT MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 307509998,
    "dropmaladd": "824 SCENIC HWY",
    "dropmalcty": "LOOKOUT MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 307509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238227527,
    "dropsitcph": 4238227165,
    "dropfax": 4238214435
  },
  {
    "dcode": "D",
    "dropkey": "PX10752",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "131 W BROAD ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 304349998,
    "dropphyadd": "131 W BROAD ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 304349998,
    "dropmaladd": "131 W BROAD ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 304349998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786250367,
    "dropsitcph": 4786250367,
    "dropfax": 4786257134
  },
  {
    "dcode": "D",
    "dropkey": "PX10754",
    "droptype": "D",
    "dropname": "LOVEJOY",
    "dropdeladd": "2261 TALMADGE RD",
    "dropdelcty": "LOVEJOY",
    "dropdelst": "GA",
    "dropdelzpp": 302509998,
    "dropphyadd": "2261 TALMADGE RD",
    "dropphycty": "LOVEJOY",
    "dropphyst": "GA",
    "dropphyzpp": 302509998,
    "dropmaladd": "2261 TALMADGE RD",
    "dropmalcty": "LOVEJOY",
    "dropmalst": "GA",
    "dropmalzpp": 302509998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702109141,
    "dropsitcph": 7704713935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10755",
    "droptype": "D",
    "dropname": "LUDOWICI",
    "dropdeladd": "40 E ACADEMY ST",
    "dropdelcty": "LUDOWICI",
    "dropdelst": "GA",
    "dropdelzpp": 313169998,
    "dropphyadd": "40 E ACADEMY ST",
    "dropphycty": "LUDOWICI",
    "dropphyst": "GA",
    "dropphyzpp": 313169998,
    "dropmaladd": "40 E ACADEMY ST",
    "dropmalcty": "LUDOWICI",
    "dropmalst": "GA",
    "dropmalzpp": 313169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125450002,
    "dropsitcph": 9125450002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10756",
    "droptype": "D",
    "dropname": "LULA",
    "dropdeladd": "5815 MCLEOD ST",
    "dropdelcty": "LULA",
    "dropdelst": "GA",
    "dropdelzpp": 305549998,
    "dropphyadd": "5815 MCLEOD ST",
    "dropphycty": "LULA",
    "dropphyst": "GA",
    "dropphyzpp": 305549998,
    "dropmaladd": "5815 MCLEOD ST",
    "dropmalcty": "LULA",
    "dropmalst": "GA",
    "dropmalzpp": 305549998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708693241,
    "dropsitcph": 7708693241,
    "dropfax": 7708699391
  },
  {
    "dcode": "D",
    "dropkey": "PX10758",
    "droptype": "D",
    "dropname": "LUMBER CITY",
    "dropdeladd": "68 N CHURCH ST",
    "dropdelcty": "LUMBER CITY",
    "dropdelst": "GA",
    "dropdelzpp": 315499998,
    "dropphyadd": "68 N CHURCH ST",
    "dropphycty": "LUMBER CITY",
    "dropphyst": "GA",
    "dropphyzpp": 315499998,
    "dropmaladd": "68 N CHURCH ST",
    "dropmalcty": "LUMBER CITY",
    "dropmalst": "GA",
    "dropmalzpp": 315499998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123634975,
    "dropsitcph": 9123634975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10759",
    "droptype": "D",
    "dropname": "LUMPKIN",
    "dropdeladd": "1688 BROAD ST",
    "dropdelcty": "LUMPKIN",
    "dropdelst": "GA",
    "dropdelzpp": 318159998,
    "dropphyadd": "1688 BROAD ST",
    "dropphycty": "LUMPKIN",
    "dropphyst": "GA",
    "dropphyzpp": 318159998,
    "dropmaladd": "1688 BROAD ST",
    "dropmalcty": "LUMPKIN",
    "dropmalst": "GA",
    "dropmalzpp": 318159998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298384875,
    "dropsitcph": 2298384875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10760",
    "droptype": "D",
    "dropname": "LUTHERSVILLE",
    "dropdeladd": "36 N MAIN ST",
    "dropdelcty": "LUTHERSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302519998,
    "dropphyadd": "36 N MAIN ST",
    "dropphycty": "LUTHERSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302519998,
    "dropmaladd": "36 N MAIN ST",
    "dropmalcty": "LUTHERSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302519998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709276356,
    "dropsitcph": 7709276356,
    "dropfax": 7709279488
  },
  {
    "dcode": "D",
    "dropkey": "PX10763",
    "droptype": "D",
    "dropname": "LYERLY",
    "dropdeladd": "111 ALPINE ST",
    "dropdelcty": "LYERLY",
    "dropdelst": "GA",
    "dropdelzpp": 307309998,
    "dropphyadd": "111 ALPINE ST",
    "dropphycty": "LYERLY",
    "dropphyst": "GA",
    "dropphyzpp": 307309998,
    "dropmaladd": "111 ALPINE ST",
    "dropmalcty": "LYERLY",
    "dropmalst": "GA",
    "dropmalzpp": 307309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068954444,
    "dropsitcph": 7068954444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10764",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "131 N STATE ST",
    "dropdelcty": "LYONS",
    "dropdelst": "GA",
    "dropdelzpp": 304369998,
    "dropphyadd": "131 N STATE ST",
    "dropphycty": "LYONS",
    "dropphyst": "GA",
    "dropphyzpp": 304369998,
    "dropmaladd": "131 N STATE ST",
    "dropmalcty": "LYONS",
    "dropmalst": "GA",
    "dropmalzpp": 304369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125267091,
    "dropsitcph": 9125267091,
    "dropfax": 9125268547
  },
  {
    "dcode": "D",
    "dropkey": "PX10766",
    "droptype": "D",
    "dropname": "MABLETON",
    "dropdeladd": "5284 FLOYD RD SW",
    "dropdelcty": "MABLETON",
    "dropdelst": "GA",
    "dropdelzpp": 301269998,
    "dropphyadd": "5284 FLOYD RD SW",
    "dropphycty": "MABLETON",
    "dropphyst": "GA",
    "dropphyzpp": 301269998,
    "dropmaladd": "5284 FLOYD RD SW",
    "dropmalcty": "MABLETON",
    "dropmalst": "GA",
    "dropmalzpp": 301269998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784331780,
    "dropsitcph": 7707454394,
    "dropfax": 7709483167
  },
  {
    "dcode": "D",
    "dropkey": "PX10768",
    "droptype": "D",
    "dropname": "MACON",
    "dropdeladd": "451 COLLEGE ST RM 130",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312139998,
    "dropphyadd": "451 COLLEGE ST RM 130",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312139998,
    "dropmaladd": "451 COLLEGE ST RM 130",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312139998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528432,
    "dropsitcph": 4787528432,
    "dropfax": 4787528601
  },
  {
    "dcode": "D",
    "dropkey": "PX10770",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "GA",
    "dropdelzpp": 306509998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "GA",
    "dropphyzpp": 306509998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "MADISON",
    "dropmalst": "GA",
    "dropmalzpp": 306509998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063427047,
    "dropsitcph": 7063421318,
    "dropfax": 7063424016
  },
  {
    "dcode": "D",
    "dropkey": "PX10775",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "415 W MAIN ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "GA",
    "dropdelzpp": 318169998,
    "dropphyadd": "415 W MAIN ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "GA",
    "dropphyzpp": 318169998,
    "dropmaladd": "415 W MAIN ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "GA",
    "dropmalzpp": 318169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068463768,
    "dropsitcph": 7068463768,
    "dropfax": 7068462865
  },
  {
    "dcode": "D",
    "dropkey": "PX10777",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "3 W 1ST ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 300559998,
    "dropphyadd": "3 W 1ST ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 300559998,
    "dropmaladd": "3 W 1ST ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 300559998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707867723,
    "dropsitcph": 7707867723,
    "dropfax": 7707862093
  },
  {
    "dcode": "D",
    "dropkey": "PX10779",
    "droptype": "D",
    "dropname": "MARBLE HILL",
    "dropdeladd": "12813 HIGHWAY 53",
    "dropdelcty": "MARBLE HILL",
    "dropdelst": "GA",
    "dropdelzpp": 301489998,
    "dropphyadd": "12813 HIGHWAY 53",
    "dropphycty": "MARBLE HILL",
    "dropphyst": "GA",
    "dropphyzpp": 301489998,
    "dropmaladd": "12813 HIGHWAY 53",
    "dropmalcty": "MARBLE HILL",
    "dropmalst": "GA",
    "dropmalzpp": 301489998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708630978,
    "dropsitcph": 7708630978,
    "dropfax": 7708933127
  },
  {
    "dcode": "D",
    "dropkey": "PX10781",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "257 LAWRENCE ST NE",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300609998,
    "dropphyadd": "257 LAWRENCE ST NE",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300609998,
    "dropmaladd": "257 LAWRENCE ST NE",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300609998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704263796,
    "dropsitcph": 7705909771,
    "dropfax": 7704241091
  },
  {
    "dcode": "D",
    "dropkey": "PX10786",
    "droptype": "D",
    "dropname": "MARSHALLVILLE",
    "dropdeladd": "118 CAMELLIA BLVD",
    "dropdelcty": "MARSHALLVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310579998,
    "dropphyadd": "118 CAMELLIA BLVD",
    "dropphycty": "MARSHALLVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310579998,
    "dropmaladd": "118 CAMELLIA BLVD",
    "dropmalcty": "MARSHALLVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310579998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789672071,
    "dropsitcph": 4789672071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10788",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "3819 HISTORIC HIGHWAY 17",
    "dropdelcty": "MARTIN",
    "dropdelst": "GA",
    "dropdelzpp": 305579998,
    "dropphyadd": "3819 HISTORIC HIGHWAY 17",
    "dropphycty": "MARTIN",
    "dropphyst": "GA",
    "dropphyzpp": 305579998,
    "dropmaladd": "3819 HISTORIC HIGHWAY 17",
    "dropmalcty": "MARTIN",
    "dropmalst": "GA",
    "dropmalzpp": 305579998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067792823,
    "dropsitcph": 7067792823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10791",
    "droptype": "D",
    "dropname": "MAUK",
    "dropdeladd": "7 GA HIGHWAY 127 W",
    "dropdelcty": "MAUK",
    "dropdelst": "GA",
    "dropdelzpp": 310589998,
    "dropphyadd": "7 GA HIGHWAY 127 W",
    "dropphycty": "MAUK",
    "dropphyst": "GA",
    "dropphyzpp": 310589998,
    "dropmaladd": "7 GA HIGHWAY 127 W",
    "dropmalcty": "MAUK",
    "dropmalst": "GA",
    "dropmalzpp": 310589998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788625459,
    "dropsitcph": 4788625459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10795",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "3 HOMER ST",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305589998,
    "dropphyadd": "3 HOMER ST",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305589998,
    "dropmaladd": "3 HOMER ST",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305589998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066522825,
    "dropsitcph": 7066522825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10798",
    "droptype": "D",
    "dropname": "MC CAYSVILLE",
    "dropdeladd": "175 BLUE RIDGE DR",
    "dropdelcty": "MC CAYSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305559998,
    "dropphyadd": "175 BLUE RIDGE DR",
    "dropphycty": "MC CAYSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305559998,
    "dropmaladd": "175 BLUE RIDGE DR",
    "dropmalcty": "MC CAYSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305559998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064922105,
    "dropsitcph": 7064922105,
    "dropfax": 7064922104
  },
  {
    "dcode": "D",
    "dropkey": "PX10801",
    "droptype": "D",
    "dropname": "MCDONOUGH",
    "dropdeladd": "100 POSTMASTER DR",
    "dropdelcty": "MCDONOUGH",
    "dropdelst": "GA",
    "dropdelzpp": 302539998,
    "dropphyadd": "100 POSTMASTER DR",
    "dropphycty": "MCDONOUGH",
    "dropphyst": "GA",
    "dropphyzpp": 302539998,
    "dropmaladd": "100 POSTMASTER DR",
    "dropmalcty": "MCDONOUGH",
    "dropmalst": "GA",
    "dropmalzpp": 302539998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702825371,
    "dropsitcph": 6784324319,
    "dropfax": 6784324406
  },
  {
    "dcode": "D",
    "dropkey": "PX10802",
    "droptype": "D",
    "dropname": "MC INTYRE",
    "dropdeladd": "106 RAILROAD ST",
    "dropdelcty": "MC INTYRE",
    "dropdelst": "GA",
    "dropdelzpp": 310549998,
    "dropphyadd": "106 RAILROAD ST",
    "dropphycty": "MC INTYRE",
    "dropphyst": "GA",
    "dropphyzpp": 310549998,
    "dropmaladd": "106 RAILROAD ST",
    "dropmalcty": "MC INTYRE",
    "dropmalst": "GA",
    "dropmalzpp": 310549998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 4789462777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10803",
    "droptype": "D",
    "dropname": "MC RAE",
    "dropdeladd": "23 S SECOND AVE",
    "dropdelcty": "MC RAE HELENA",
    "dropdelst": "GA",
    "dropdelzpp": 310559998,
    "dropphyadd": "23 S SECOND AVE",
    "dropphycty": "MC RAE HELENA",
    "dropphyst": "GA",
    "dropphyzpp": 310559998,
    "dropmaladd": "23 S SECOND AVE",
    "dropmalcty": "MC RAE HELENA",
    "dropmalst": "GA",
    "dropmalzpp": 310559998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298682304,
    "dropsitcph": 2298682304,
    "dropfax": 2298687346
  },
  {
    "dcode": "D",
    "dropkey": "PX10809",
    "droptype": "D",
    "dropname": "MEANSVILLE",
    "dropdeladd": "12570 GA HWY 109",
    "dropdelcty": "MEANSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302562367,
    "dropphyadd": "12570 GA HWY 109",
    "dropphycty": "MEANSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302562367,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEANSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302569998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705673676,
    "dropsitcph": 7705673676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10813",
    "droptype": "D",
    "dropname": "MEIGS",
    "dropdeladd": "2010 E DEPOT ST",
    "dropdelcty": "MEIGS",
    "dropdelst": "GA",
    "dropdelzpp": 317659998,
    "dropphyadd": "2010 E DEPOT ST",
    "dropphycty": "MEIGS",
    "dropphyst": "GA",
    "dropphyzpp": 317659998,
    "dropmaladd": "2010 E DEPOT ST",
    "dropmalcty": "MEIGS",
    "dropmalst": "GA",
    "dropmalzpp": 317659998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2296833554,
    "dropsitcph": 2296833554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10814",
    "droptype": "D",
    "dropname": "MELDRIM",
    "dropdeladd": "318 5TH ST",
    "dropdelcty": "MELDRIM",
    "dropdelst": "GA",
    "dropdelzpp": 313189998,
    "dropphyadd": "318 5TH ST",
    "dropphycty": "MELDRIM",
    "dropphyst": "GA",
    "dropphyzpp": 313189998,
    "dropmaladd": "318 5TH ST",
    "dropmalcty": "MELDRIM",
    "dropmalst": "GA",
    "dropmalzpp": 313189998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127485981,
    "dropsitcph": 9127485981,
    "dropfax": 9127489167
  },
  {
    "dcode": "D",
    "dropkey": "PX10818",
    "droptype": "D",
    "dropname": "MENLO",
    "dropdeladd": "2951 HIGHWAY 337",
    "dropdelcty": "MENLO",
    "dropdelst": "GA",
    "dropdelzpp": 307319998,
    "dropphyadd": "2951 HIGHWAY 337",
    "dropphycty": "MENLO",
    "dropphyst": "GA",
    "dropphyzpp": 307319998,
    "dropmaladd": "2951 HIGHWAY 337",
    "dropmalcty": "MENLO",
    "dropmalst": "GA",
    "dropmalzpp": 307319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068622691,
    "dropsitcph": 7068622691,
    "dropfax": 7068626416
  },
  {
    "dcode": "D",
    "dropkey": "PX10823",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "10034 GA HIGHWAY 99",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "GA",
    "dropdelzpp": 313199997,
    "dropphyadd": "10034 GA HIGHWAY 99",
    "dropphycty": "MERIDIAN",
    "dropphyst": "GA",
    "dropphyzpp": 313199997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "GA",
    "dropmalzpp": 313199998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124371299,
    "dropsitcph": 9124371299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10824",
    "droptype": "D",
    "dropname": "MERSHON",
    "dropdeladd": "2547 GA HIGHWAY 32",
    "dropdelcty": "MERSHON",
    "dropdelst": "GA",
    "dropdelzpp": 315518663,
    "dropphyadd": "2547 GA HIGHWAY 32",
    "dropphycty": "MERSHON",
    "dropphyst": "GA",
    "dropphyzpp": 315518663,
    "dropmaladd": "2547 GA HIGHWAY 32",
    "dropmalcty": "MERSHON",
    "dropmalst": "GA",
    "dropmalzpp": 315518663,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126472262,
    "dropsitcph": 9126472262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10825",
    "droptype": "D",
    "dropname": "MESENA",
    "dropdeladd": "10 E REESE RD",
    "dropdelcty": "MESENA",
    "dropdelst": "GA",
    "dropdelzpp": 308199998,
    "dropphyadd": "10 E REESE RD",
    "dropphycty": "MESENA",
    "dropphyst": "GA",
    "dropphyzpp": 308199998,
    "dropmaladd": "10 E REESE RD",
    "dropmalcty": "MESENA",
    "dropmalst": "GA",
    "dropmalzpp": 308199998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065951967,
    "dropsitcph": 7065951967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10826",
    "droptype": "D",
    "dropname": "METTER",
    "dropdeladd": "205 S ROUNTREE ST",
    "dropdelcty": "METTER",
    "dropdelst": "GA",
    "dropdelzpp": 304399998,
    "dropphyadd": "205 S ROUNTREE ST",
    "dropphycty": "METTER",
    "dropphyst": "GA",
    "dropphyzpp": 304399998,
    "dropmaladd": "205 S ROUNTREE ST",
    "dropmalcty": "METTER",
    "dropmalst": "GA",
    "dropmalzpp": 304399998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126854165,
    "dropsitcph": 9126854165,
    "dropfax": 9126855017
  },
  {
    "dcode": "D",
    "dropkey": "PX10827",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "9232 COUNTY LINE RD",
    "dropdelcty": "MIDLAND",
    "dropdelst": "GA",
    "dropdelzpp": 318209998,
    "dropphyadd": "9232 COUNTY LINE RD",
    "dropphycty": "MIDLAND",
    "dropphyst": "GA",
    "dropphyzpp": 318209998,
    "dropmaladd": "9232 COUNTY LINE RD",
    "dropmalcty": "MIDLAND",
    "dropmalst": "GA",
    "dropmalzpp": 318209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065689327,
    "dropsitcph": 7065689327,
    "dropfax": 7065681031
  },
  {
    "dcode": "D",
    "dropkey": "PX10829",
    "droptype": "D",
    "dropname": "MIDVILLE",
    "dropdeladd": "238 N RAILROAD ST",
    "dropdelcty": "MIDVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 304419998,
    "dropphyadd": "238 N RAILROAD ST",
    "dropphycty": "MIDVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 304419998,
    "dropmaladd": "238 N RAILROAD ST",
    "dropmalcty": "MIDVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 304419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785897270,
    "dropsitcph": 4785897270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10830",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "12 BUTLER ST",
    "dropdelcty": "MIDWAY",
    "dropdelst": "GA",
    "dropdelzpp": 313209998,
    "dropphyadd": "12 BUTLER ST",
    "dropphycty": "MIDWAY",
    "dropphyst": "GA",
    "dropphyzpp": 313209998,
    "dropmaladd": "12 BUTLER ST",
    "dropmalcty": "MIDWAY",
    "dropmalst": "GA",
    "dropmalzpp": 313209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128844588,
    "dropsitcph": 9128844588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10831",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "322 LEE ST",
    "dropdelcty": "MILAN",
    "dropdelst": "GA",
    "dropdelzpp": 310609998,
    "dropphyadd": "322 LEE ST",
    "dropphycty": "MILAN",
    "dropphyst": "GA",
    "dropphyzpp": 310609998,
    "dropmaladd": "322 LEE ST",
    "dropmalcty": "MILAN",
    "dropmalst": "GA",
    "dropmalzpp": 310609998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293624122,
    "dropsitcph": 2293624122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10832",
    "droptype": "D",
    "dropname": "MILLEDGEVILLE",
    "dropdeladd": "118 E HANCOCK ST LBBY",
    "dropdelcty": "MILLEDGEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310619998,
    "dropphyadd": "118 E HANCOCK ST LBBY",
    "dropphycty": "MILLEDGEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310619998,
    "dropmaladd": "118 E HANCOCK ST LBBY",
    "dropmalcty": "MILLEDGEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310619998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782235007,
    "dropsitcph": 4782235006,
    "dropfax": 4784524537
  },
  {
    "dcode": "D",
    "dropkey": "PX10833",
    "droptype": "D",
    "dropname": "MILLEN",
    "dropdeladd": "608 E WINTHROPE AVE",
    "dropdelcty": "MILLEN",
    "dropdelst": "GA",
    "dropdelzpp": 304429998,
    "dropphyadd": "608 E WINTHROPE AVE",
    "dropphycty": "MILLEN",
    "dropphyst": "GA",
    "dropphyzpp": 304429998,
    "dropmaladd": "608 E WINTHROPE AVE",
    "dropmalcty": "MILLEN",
    "dropmalst": "GA",
    "dropmalzpp": 304429998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789822719,
    "dropsitcph": 4789822719,
    "dropfax": 4789823849
  },
  {
    "dcode": "D",
    "dropkey": "PX10835",
    "droptype": "D",
    "dropname": "MILNER",
    "dropdeladd": "104 GREENWOOD ST",
    "dropdelcty": "MILNER",
    "dropdelst": "GA",
    "dropdelzpp": 302579998,
    "dropphyadd": "104 GREENWOOD ST",
    "dropphycty": "MILNER",
    "dropphyst": "GA",
    "dropphyzpp": 302579998,
    "dropmaladd": "104 GREENWOOD ST",
    "dropmalcty": "MILNER",
    "dropmalst": "GA",
    "dropmalzpp": 302579998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703586282,
    "dropsitcph": 7703584788,
    "dropfax": 7703586950
  },
  {
    "dcode": "D",
    "dropkey": "PX10838",
    "droptype": "D",
    "dropname": "MINERAL BLUFF",
    "dropdeladd": "8590 LAKEWOOD HWY",
    "dropdelcty": "MINERAL BLUFF",
    "dropdelst": "GA",
    "dropdelzpp": 305599998,
    "dropphyadd": "8590 LAKEWOOD HWY",
    "dropphycty": "MINERAL BLUFF",
    "dropphyst": "GA",
    "dropphyzpp": 305599998,
    "dropmaladd": "8590 LAKEWOOD HWY",
    "dropmalcty": "MINERAL BLUFF",
    "dropmalst": "GA",
    "dropmalzpp": 305599998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063742397,
    "dropsitcph": 7063745853,
    "dropfax": 7063744514
  },
  {
    "dcode": "D",
    "dropkey": "PX10839",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "6488 GA HIGHWAY 102 W",
    "dropdelcty": "MITCHELL",
    "dropdelst": "GA",
    "dropdelzpp": 308209998,
    "dropphyadd": "6488 GA HIGHWAY 102 W",
    "dropphycty": "MITCHELL",
    "dropphyst": "GA",
    "dropphyzpp": 308209998,
    "dropmaladd": "6488 GA HIGHWAY 102 W",
    "dropmalcty": "MITCHELL",
    "dropmalst": "GA",
    "dropmalzpp": 308209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065982143,
    "dropsitcph": 7065982143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10842",
    "droptype": "D",
    "dropname": "MOLENA",
    "dropdeladd": "2696 MAIN ST",
    "dropdelcty": "MOLENA",
    "dropdelst": "GA",
    "dropdelzpp": 302589998,
    "dropphyadd": "2696 MAIN ST",
    "dropphycty": "MOLENA",
    "dropphyst": "GA",
    "dropphyzpp": 302589998,
    "dropmaladd": "2696 MAIN ST",
    "dropmalcty": "MOLENA",
    "dropmalst": "GA",
    "dropmalzpp": 302589998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708845738,
    "dropsitcph": 7708845738,
    "dropfax": 7708840149
  },
  {
    "dcode": "D",
    "dropkey": "PX10843",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "302 E WASHINGTON ST",
    "dropdelcty": "MONROE",
    "dropdelst": "GA",
    "dropdelzpp": 306559998,
    "dropphyadd": "302 E WASHINGTON ST",
    "dropphycty": "MONROE",
    "dropphyst": "GA",
    "dropphyzpp": 306559998,
    "dropmaladd": "302 E WASHINGTON ST",
    "dropmalcty": "MONROE",
    "dropmalst": "GA",
    "dropmalzpp": 306559998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702679139,
    "dropsitcph": 7702675254,
    "dropfax": 7702678799
  },
  {
    "dcode": "D",
    "dropkey": "PX10844",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "110 CABOT ST",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "GA",
    "dropdelzpp": 310639998,
    "dropphyadd": "110 CABOT ST",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "GA",
    "dropphyzpp": 310639998,
    "dropmaladd": "110 CABOT ST",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "GA",
    "dropmalzpp": 310639998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784726788,
    "dropsitcph": 4784726788,
    "dropfax": 4784724621
  },
  {
    "dcode": "D",
    "dropkey": "PX10846",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "145 E WASHINGTON ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "GA",
    "dropdelzpp": 310649998,
    "dropphyadd": "145 E WASHINGTON ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "GA",
    "dropphyzpp": 310649998,
    "dropmaladd": "145 E WASHINGTON ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "GA",
    "dropmalzpp": 310649998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064681832,
    "dropsitcph": 7064681832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10847",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "4334 US HIGHWAY 80 W",
    "dropdelcty": "MONTROSE",
    "dropdelst": "GA",
    "dropdelzpp": 310659998,
    "dropphyadd": "4334 US HIGHWAY 80 W",
    "dropphycty": "MONTROSE",
    "dropphyst": "GA",
    "dropphyzpp": 310659998,
    "dropmaladd": "4334 US HIGHWAY 80 W",
    "dropmalcty": "MONTROSE",
    "dropmalst": "GA",
    "dropmalzpp": 310659998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4783764038,
    "dropsitcph": 4783764038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10850",
    "droptype": "D",
    "dropname": "MORELAND",
    "dropdeladd": "100 BALL ST",
    "dropdelcty": "MORELAND",
    "dropdelst": "GA",
    "dropdelzpp": 302599998,
    "dropphyadd": "100 BALL ST",
    "dropphycty": "MORELAND",
    "dropphyst": "GA",
    "dropphyzpp": 302599998,
    "dropmaladd": "100 BALL ST",
    "dropmalcty": "MORELAND",
    "dropmalst": "GA",
    "dropmalzpp": 302599998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784236382,
    "dropsitcph": 6784236386,
    "dropfax": 6784236383
  },
  {
    "dcode": "D",
    "dropkey": "PX10851",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "11017 DICKEY ST",
    "dropdelcty": "MORGAN",
    "dropdelst": "GA",
    "dropdelzpp": 398669998,
    "dropphyadd": "11017 DICKEY ST",
    "dropphycty": "MORGAN",
    "dropphyst": "GA",
    "dropphyzpp": 398669998,
    "dropmaladd": "11017 DICKEY ST",
    "dropmalcty": "MORGAN",
    "dropmalst": "GA",
    "dropmalzpp": 398669998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298490030,
    "dropsitcph": 2298490030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10852",
    "droptype": "D",
    "dropname": "MORGANTON",
    "dropdeladd": "12304 MORGANTON HWY",
    "dropdelcty": "MORGANTON",
    "dropdelst": "GA",
    "dropdelzpp": 305609998,
    "dropphyadd": "12304 MORGANTON HWY",
    "dropphycty": "MORGANTON",
    "dropphyst": "GA",
    "dropphyzpp": 305609998,
    "dropmaladd": "12304 MORGANTON HWY",
    "dropmalcty": "MORGANTON",
    "dropmalst": "GA",
    "dropmalzpp": 305609998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063745836,
    "dropsitcph": 7063745836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10855",
    "droptype": "D",
    "dropname": "MORROW",
    "dropdeladd": "1600 LAKE HARBIN RD",
    "dropdelcty": "MORROW",
    "dropdelst": "GA",
    "dropdelzpp": 302601742,
    "dropphyadd": "1600 LAKE HARBIN RD",
    "dropphycty": "MORROW",
    "dropphyst": "GA",
    "dropphyzpp": 302601742,
    "dropmaladd": "1600 LAKE HARBIN RD",
    "dropmalcty": "MORROW",
    "dropmalst": "GA",
    "dropmalzpp": 302601742,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709689685,
    "dropsitcph": 7709614308,
    "dropfax": 7709610781
  },
  {
    "dcode": "D",
    "dropkey": "PX10856",
    "droptype": "D",
    "dropname": "MORVEN",
    "dropdeladd": "100 GORDON ST",
    "dropdelcty": "MORVEN",
    "dropdelst": "GA",
    "dropdelzpp": 316389998,
    "dropphyadd": "100 GORDON ST",
    "dropphycty": "MORVEN",
    "dropphyst": "GA",
    "dropphyzpp": 316389998,
    "dropmaladd": "100 GORDON ST",
    "dropmalcty": "MORVEN",
    "dropmalst": "GA",
    "dropmalzpp": 316389998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297752611,
    "dropsitcph": 2297752611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10857",
    "droptype": "D",
    "dropname": "MOULTRIE",
    "dropdeladd": "215 N MAIN ST",
    "dropdelcty": "MOULTRIE",
    "dropdelst": "GA",
    "dropdelzpp": 317689998,
    "dropphyadd": "215 N MAIN ST",
    "dropphycty": "MOULTRIE",
    "dropphyst": "GA",
    "dropphyzpp": 317689998,
    "dropmaladd": "215 N MAIN ST",
    "dropmalcty": "MOULTRIE",
    "dropmalst": "GA",
    "dropmalzpp": 317689998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298909754,
    "dropsitcph": 2298909754,
    "dropfax": 2298907567
  },
  {
    "dcode": "D",
    "dropkey": "PX10859",
    "droptype": "D",
    "dropname": "MOUNT AIRY",
    "dropdeladd": "877 DICKS HILL PKWY",
    "dropdelcty": "MOUNT AIRY",
    "dropdelst": "GA",
    "dropdelzpp": 305639998,
    "dropphyadd": "877 DICKS HILL PKWY",
    "dropphycty": "MOUNT AIRY",
    "dropphyst": "GA",
    "dropphyzpp": 305639998,
    "dropmaladd": "877 DICKS HILL PKWY",
    "dropmalcty": "MOUNT AIRY",
    "dropmalst": "GA",
    "dropmalzpp": 305639998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067788323,
    "dropsitcph": 7067788323,
    "dropfax": 7067769604
  },
  {
    "dcode": "D",
    "dropkey": "PX10861",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "120 W CHURCH ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "GA",
    "dropdelzpp": 304459998,
    "dropphyadd": "120 W CHURCH ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "GA",
    "dropphyzpp": 304459998,
    "dropmaladd": "120 W CHURCH ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "GA",
    "dropmalzpp": 304459998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125832238,
    "dropsitcph": 9125832238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10862",
    "droptype": "D",
    "dropname": "MOUNT ZION",
    "dropdeladd": "11 MARTIN ST",
    "dropdelcty": "MOUNT ZION",
    "dropdelst": "GA",
    "dropdelzpp": 301509800,
    "dropphyadd": "11 MARTIN ST",
    "dropphycty": "MOUNT ZION",
    "dropphyst": "GA",
    "dropphyzpp": 301509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT ZION",
    "dropmalst": "GA",
    "dropmalzpp": 301509998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708348655,
    "dropsitcph": 7708348655,
    "dropfax": 7708367950
  },
  {
    "dcode": "D",
    "dropkey": "PX10863",
    "droptype": "D",
    "dropname": "MOUNTAIN CITY",
    "dropdeladd": "23 DOTSON ST",
    "dropdelcty": "MOUNTAIN CITY",
    "dropdelst": "GA",
    "dropdelzpp": 305622900,
    "dropphyadd": "23 DOTSON ST",
    "dropphycty": "MOUNTAIN CITY",
    "dropphyst": "GA",
    "dropphyzpp": 305622900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN CITY",
    "dropmalst": "GA",
    "dropmalzpp": 305629998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067462580,
    "dropsitcph": 7067462580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10877",
    "droptype": "D",
    "dropname": "MURRAYVILLE",
    "dropdeladd": "5341 THOMPSON BRIDGE RD",
    "dropdelcty": "MURRAYVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305649998,
    "dropphyadd": "5341 THOMPSON BRIDGE RD",
    "dropphycty": "MURRAYVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305649998,
    "dropmaladd": "5341 THOMPSON BRIDGE RD",
    "dropmalcty": "MURRAYVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305649998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705344743,
    "dropsitcph": 7705344743,
    "dropfax": 7705347433
  },
  {
    "dcode": "D",
    "dropkey": "PX10880",
    "droptype": "D",
    "dropname": "MUSELLA",
    "dropdeladd": "21 POST OFFICE ST",
    "dropdelcty": "MUSELLA",
    "dropdelst": "GA",
    "dropdelzpp": 310669998,
    "dropphyadd": "21 POST OFFICE ST",
    "dropphycty": "MUSELLA",
    "dropphyst": "GA",
    "dropphyzpp": 310669998,
    "dropmaladd": "21 POST OFFICE ST",
    "dropmalcty": "MUSELLA",
    "dropmalst": "GA",
    "dropmalzpp": 310669998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788363863,
    "dropsitcph": 4788363863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10881",
    "droptype": "D",
    "dropname": "MYSTIC",
    "dropdeladd": "224 JACKSON ST",
    "dropdelcty": "MYSTIC",
    "dropdelst": "GA",
    "dropdelzpp": 317699998,
    "dropphyadd": "224 JACKSON ST",
    "dropphycty": "MYSTIC",
    "dropphyst": "GA",
    "dropphyzpp": 317699998,
    "dropmaladd": "224 JACKSON ST",
    "dropmalcty": "MYSTIC",
    "dropmalst": "GA",
    "dropmalzpp": 317699998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2294684264,
    "dropsitcph": 2294684264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10883",
    "droptype": "D",
    "dropname": "NAHUNTA",
    "dropdeladd": "10119 MAIN ST N",
    "dropdelcty": "NAHUNTA",
    "dropdelst": "GA",
    "dropdelzpp": 315539998,
    "dropphyadd": "10119 MAIN ST N",
    "dropphycty": "NAHUNTA",
    "dropphyst": "GA",
    "dropphyzpp": 315539998,
    "dropmaladd": "10119 MAIN ST N",
    "dropmalcty": "NAHUNTA",
    "dropmalst": "GA",
    "dropmalzpp": 315539998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124628003,
    "dropsitcph": 9124628003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10884",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "301 S BARTOW ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 316399998,
    "dropphyadd": "301 S BARTOW ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 316399998,
    "dropmaladd": "301 S BARTOW ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 316399998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296865936,
    "dropsitcph": 2296865936,
    "dropfax": 2286865054
  },
  {
    "dcode": "D",
    "dropkey": "PX10888",
    "droptype": "D",
    "dropname": "NAYLOR",
    "dropdeladd": "6030 US HIGHWAY 84 E",
    "dropdelcty": "NAYLOR",
    "dropdelst": "GA",
    "dropdelzpp": 316419998,
    "dropphyadd": "6030 US HIGHWAY 84 E",
    "dropphycty": "NAYLOR",
    "dropphyst": "GA",
    "dropphyzpp": 316419998,
    "dropmaladd": "6030 US HIGHWAY 84 E",
    "dropmalcty": "NAYLOR",
    "dropmalst": "GA",
    "dropmalzpp": 316419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292441068,
    "dropsitcph": 2292441068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10889",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "199 DOGWOOD PASS",
    "dropdelcty": "NELSON",
    "dropdelst": "GA",
    "dropdelzpp": 301512500,
    "dropphyadd": "199 DOGWOOD PASS",
    "dropphycty": "NELSON",
    "dropphyst": "GA",
    "dropphyzpp": 301512500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELSON",
    "dropmalst": "GA",
    "dropmalzpp": 301519998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707353316,
    "dropsitcph": 7707353316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10892",
    "droptype": "D",
    "dropname": "NEWBORN",
    "dropdeladd": "103 N JOHNSON ST",
    "dropdelcty": "NEWBORN",
    "dropdelst": "GA",
    "dropdelzpp": 300569998,
    "dropphyadd": "103 N JOHNSON ST",
    "dropphycty": "NEWBORN",
    "dropphyst": "GA",
    "dropphyzpp": 300569998,
    "dropmaladd": "103 N JOHNSON ST",
    "dropmalcty": "NEWBORN",
    "dropmalst": "GA",
    "dropmalzpp": 300569998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707861719,
    "dropsitcph": 7707861719,
    "dropfax": 7707841477
  },
  {
    "dcode": "D",
    "dropkey": "PX10893",
    "droptype": "D",
    "dropname": "NEWINGTON",
    "dropdeladd": "120 OLIVER HWY",
    "dropdelcty": "NEWINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 304469998,
    "dropphyadd": "120 OLIVER HWY",
    "dropphycty": "NEWINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 304469998,
    "dropmaladd": "120 OLIVER HWY",
    "dropmalcty": "NEWINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 304469998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128573290,
    "dropsitcph": 9128573290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10894",
    "droptype": "D",
    "dropname": "NEWNAN",
    "dropdeladd": "60 POSTAL PKWY",
    "dropdelcty": "NEWNAN",
    "dropdelst": "GA",
    "dropdelzpp": 302639998,
    "dropphyadd": "60 POSTAL PKWY",
    "dropphycty": "NEWNAN",
    "dropphyst": "GA",
    "dropphyzpp": 302639998,
    "dropmaladd": "60 POSTAL PKWY",
    "dropmalcty": "NEWNAN",
    "dropmalst": "GA",
    "dropmalzpp": 302639998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702521601,
    "dropsitcph": 7702521580,
    "dropfax": 7702521526
  },
  {
    "dcode": "D",
    "dropkey": "PX10895",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "343 SUNSET AVE SW",
    "dropdelcty": "NEWTON",
    "dropdelst": "GA",
    "dropdelzpp": 398709998,
    "dropphyadd": "343 SUNSET AVE SW",
    "dropphycty": "NEWTON",
    "dropphyst": "GA",
    "dropphyzpp": 398709998,
    "dropmaladd": "343 SUNSET AVE SW",
    "dropmalcty": "NEWTON",
    "dropmalst": "GA",
    "dropmalzpp": 398709998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297345750,
    "dropsitcph": 2297345750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10896",
    "droptype": "D",
    "dropname": "NICHOLLS",
    "dropdeladd": "103 N LIBERTY ST",
    "dropdelcty": "NICHOLLS",
    "dropdelst": "GA",
    "dropdelzpp": 315549998,
    "dropphyadd": "103 N LIBERTY ST",
    "dropphycty": "NICHOLLS",
    "dropphyst": "GA",
    "dropphyzpp": 315549998,
    "dropmaladd": "103 N LIBERTY ST",
    "dropmalcty": "NICHOLLS",
    "dropmalst": "GA",
    "dropmalzpp": 315549998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123450412,
    "dropsitcph": 9123450412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10897",
    "droptype": "D",
    "dropname": "NICHOLSON",
    "dropdeladd": "156 LAKEVIEW DR",
    "dropdelcty": "NICHOLSON",
    "dropdelst": "GA",
    "dropdelzpp": 305659998,
    "dropphyadd": "156 LAKEVIEW DR",
    "dropphycty": "NICHOLSON",
    "dropphyst": "GA",
    "dropphyzpp": 305659998,
    "dropmaladd": "156 LAKEVIEW DR",
    "dropmalcty": "NICHOLSON",
    "dropmalst": "GA",
    "dropmalzpp": 305659998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067573363,
    "dropsitcph": 7067573363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10901",
    "droptype": "D",
    "dropname": "NORCROSS",
    "dropdeladd": "265 MITCHELL RD",
    "dropdelcty": "NORCROSS",
    "dropdelst": "GA",
    "dropdelzpp": 300712513,
    "dropphyadd": "265 MITCHELL RD",
    "dropphycty": "NORCROSS",
    "dropphyst": "GA",
    "dropphyzpp": 300712513,
    "dropmaladd": "265 MITCHELL RD",
    "dropmalcty": "NORCROSS",
    "dropmalst": "GA",
    "dropmalzpp": 300712513,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782599877,
    "dropsitcph": 7708490559,
    "dropfax": 7704097953
  },
  {
    "dcode": "D",
    "dropkey": "PX10902",
    "droptype": "D",
    "dropname": "NORMAN PARK",
    "dropdeladd": "113 E BROAD",
    "dropdelcty": "NORMAN PARK",
    "dropdelst": "GA",
    "dropdelzpp": 317719998,
    "dropphyadd": "113 E BROAD",
    "dropphycty": "NORMAN PARK",
    "dropphyst": "GA",
    "dropphyzpp": 317719998,
    "dropmaladd": "113 E BROAD",
    "dropmalcty": "NORMAN PARK",
    "dropmalst": "GA",
    "dropmalzpp": 317719998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297695510,
    "dropsitcph": 2297695510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10916",
    "droptype": "D",
    "dropname": "NORTH METRO",
    "dropdeladd": "1605 BOGGS RD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300968608,
    "dropphyadd": "1605 BOGGS RD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300968608,
    "dropmaladd": "PO BOX 599000",
    "dropmalcty": "NORTH METRO",
    "dropmalst": "GA",
    "dropmalzpp": 300269000,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707173700,
    "dropsitcph": 7707173700,
    "dropfax": 7707173452
  },
  {
    "dcode": "D",
    "dropkey": "PX10929",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "84 MASSENGALE ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 308219998,
    "dropphyadd": "84 MASSENGALE ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 308219998,
    "dropmaladd": "84 MASSENGALE ST",
    "dropmalcty": "NORWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 308219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064652377,
    "dropsitcph": 7064652377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10930",
    "droptype": "D",
    "dropname": "NUNEZ",
    "dropdeladd": "8451 GA HIGHWAY 297",
    "dropdelcty": "NUNEZ",
    "dropdelst": "GA",
    "dropdelzpp": 304489998,
    "dropphyadd": "8451 GA HIGHWAY 297",
    "dropphycty": "NUNEZ",
    "dropphyst": "GA",
    "dropphyzpp": 304489998,
    "dropmaladd": "8451 GA HIGHWAY 297",
    "dropmalcty": "NUNEZ",
    "dropmalst": "GA",
    "dropmalzpp": 304489998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125623778,
    "dropsitcph": 9125623778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10935",
    "droptype": "D",
    "dropname": "OAKFIELD",
    "dropdeladd": "408 WHITEHALL ST",
    "dropdelcty": "OAKFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 317729998,
    "dropphyadd": "408 WHITEHALL ST",
    "dropphycty": "OAKFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 317729998,
    "dropmaladd": "408 WHITEHALL ST",
    "dropmalcty": "OAKFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 317729998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295354366,
    "dropsitcph": 2295354366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10936",
    "droptype": "D",
    "dropname": "OAKMAN",
    "dropdeladd": "225 OAKMAN RD",
    "dropdelcty": "OAKMAN",
    "dropdelst": "GA",
    "dropdelzpp": 307329998,
    "dropphyadd": "225 OAKMAN RD",
    "dropphycty": "OAKMAN",
    "dropphyst": "GA",
    "dropphyzpp": 307329998,
    "dropmaladd": "225 OAKMAN RD",
    "dropmalcty": "OAKMAN",
    "dropmalst": "GA",
    "dropmalzpp": 307329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7063342531,
    "dropsitcph": 7063342531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10937",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "3803 MAIN ST",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 305663433,
    "dropphyadd": "3803 MAIN ST",
    "dropphycty": "OAKWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 305663433,
    "dropmaladd": "3803 MAIN ST",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 305663433,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705344135,
    "dropsitcph": 7705344135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10938",
    "droptype": "D",
    "dropname": "OCHLOCKNEE",
    "dropdeladd": "2065 SPENCE ST",
    "dropdelcty": "OCHLOCKNEE",
    "dropdelst": "GA",
    "dropdelzpp": 317739998,
    "dropphyadd": "2065 SPENCE ST",
    "dropphycty": "OCHLOCKNEE",
    "dropphyst": "GA",
    "dropphyzpp": 317739998,
    "dropmaladd": "2065 SPENCE ST",
    "dropmalcty": "OCHLOCKNEE",
    "dropmalst": "GA",
    "dropmalzpp": 317739998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295745388,
    "dropsitcph": 2295745388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10939",
    "droptype": "D",
    "dropname": "OCILLA",
    "dropdeladd": "210 S IRWIN AVE",
    "dropdelcty": "OCILLA",
    "dropdelst": "GA",
    "dropdelzpp": 317749998,
    "dropphyadd": "210 S IRWIN AVE",
    "dropphycty": "OCILLA",
    "dropphyst": "GA",
    "dropphyzpp": 317749998,
    "dropmaladd": "210 S IRWIN AVE",
    "dropmalcty": "OCILLA",
    "dropmalst": "GA",
    "dropmalzpp": 317749998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2294689928,
    "dropsitcph": 2294689928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10940",
    "droptype": "D",
    "dropname": "OCONEE",
    "dropdeladd": "104 FAIRBANKS ST",
    "dropdelcty": "OCONEE",
    "dropdelst": "GA",
    "dropdelzpp": 310679998,
    "dropphyadd": "104 FAIRBANKS ST",
    "dropphycty": "OCONEE",
    "dropphyst": "GA",
    "dropphyzpp": 310679998,
    "dropmaladd": "104 FAIRBANKS ST",
    "dropmalcty": "OCONEE",
    "dropmalst": "GA",
    "dropmalzpp": 310679998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785527603,
    "dropsitcph": 4785527603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10941",
    "droptype": "D",
    "dropname": "ODUM",
    "dropdeladd": "219 S CHURCH ST",
    "dropdelcty": "ODUM",
    "dropdelst": "GA",
    "dropdelzpp": 315559998,
    "dropphyadd": "219 S CHURCH ST",
    "dropphycty": "ODUM",
    "dropphyst": "GA",
    "dropphyzpp": 315559998,
    "dropmaladd": "219 S CHURCH ST",
    "dropmalcty": "ODUM",
    "dropmalst": "GA",
    "dropmalzpp": 315559998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125866217,
    "dropsitcph": 9125866217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10942",
    "droptype": "D",
    "dropname": "OFFERMAN",
    "dropdeladd": "7203 US HIGHWAY 84",
    "dropdelcty": "OFFERMAN",
    "dropdelst": "GA",
    "dropdelzpp": 315569700,
    "dropphyadd": "7203 US HIGHWAY 84",
    "dropphycty": "OFFERMAN",
    "dropphyst": "GA",
    "dropphyzpp": 315569700,
    "dropmaladd": "7203 US HIGHWAY 84",
    "dropmalcty": "OFFERMAN",
    "dropmalst": "GA",
    "dropmalzpp": 315569700,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126472268,
    "dropsitcph": 9126472268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10943",
    "droptype": "D",
    "dropname": "OGLETHORPE",
    "dropdeladd": "120 N SUMTER ST",
    "dropdelcty": "OGLETHORPE",
    "dropdelst": "GA",
    "dropdelzpp": 310689998,
    "dropphyadd": "120 N SUMTER ST",
    "dropphycty": "OGLETHORPE",
    "dropphyst": "GA",
    "dropphyzpp": 310689998,
    "dropmaladd": "120 N SUMTER ST",
    "dropmalcty": "OGLETHORPE",
    "dropmalst": "GA",
    "dropmalzpp": 310689998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784725039,
    "dropsitcph": 4784725039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10950",
    "droptype": "D",
    "dropname": "OLIVER",
    "dropdeladd": "6185 EFFINGHAM HWY",
    "dropdelcty": "OLIVER",
    "dropdelst": "GA",
    "dropdelzpp": 304499998,
    "dropphyadd": "6185 EFFINGHAM HWY",
    "dropphycty": "OLIVER",
    "dropphyst": "GA",
    "dropphyzpp": 304499998,
    "dropmaladd": "6185 EFFINGHAM HWY",
    "dropmalcty": "OLIVER",
    "dropmalst": "GA",
    "dropmalzpp": 304499998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128574750,
    "dropsitcph": 9128574750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10951",
    "droptype": "D",
    "dropname": "OMAHA",
    "dropdeladd": "206 2ND ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "GA",
    "dropdelzpp": 318219997,
    "dropphyadd": "206 2ND ST",
    "dropphycty": "OMAHA",
    "dropphyst": "GA",
    "dropphyzpp": 318219997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMAHA",
    "dropmalst": "GA",
    "dropmalzpp": 318219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298384518,
    "dropsitcph": 2298384518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10952",
    "droptype": "D",
    "dropname": "OMEGA",
    "dropdeladd": "5523 ALABAMA AVE",
    "dropdelcty": "OMEGA",
    "dropdelst": "GA",
    "dropdelzpp": 317759998,
    "dropphyadd": "5523 ALABAMA AVE",
    "dropphycty": "OMEGA",
    "dropphyst": "GA",
    "dropphyzpp": 317759998,
    "dropmaladd": "5523 ALABAMA AVE",
    "dropmalcty": "OMEGA",
    "dropmalst": "GA",
    "dropmalzpp": 317759998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295284515,
    "dropsitcph": 2295284515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10954",
    "droptype": "D",
    "dropname": "ORCHARD HILL",
    "dropdeladd": "2201 S MCDONOUGH RD",
    "dropdelcty": "ORCHARD HILL",
    "dropdelst": "GA",
    "dropdelzpp": 302667809,
    "dropphyadd": "2201 S MCDONOUGH RD",
    "dropphycty": "ORCHARD HILL",
    "dropphyst": "GA",
    "dropphyzpp": 302667809,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCHARD HILL",
    "dropmalst": "GA",
    "dropmalzpp": 302669998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702284412,
    "dropsitcph": 7702284412,
    "dropfax": 7702284412
  },
  {
    "dcode": "D",
    "dropkey": "PX10957",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "907 EMORY ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "GA",
    "dropdelzpp": 300549998,
    "dropphyadd": "907 EMORY ST",
    "dropphycty": "OXFORD",
    "dropphyst": "GA",
    "dropphyzpp": 300549998,
    "dropmaladd": "907 EMORY ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "GA",
    "dropmalzpp": 300549998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707864253,
    "dropsitcph": 7707864253,
    "dropfax": 7707860127
  },
  {
    "dcode": "D",
    "dropkey": "PX10959",
    "droptype": "D",
    "dropname": "PALMETTO",
    "dropdeladd": "502 WALNUT WAY",
    "dropdelcty": "PALMETTO",
    "dropdelst": "GA",
    "dropdelzpp": 302689998,
    "dropphyadd": "502 WALNUT WAY",
    "dropphycty": "PALMETTO",
    "dropphyst": "GA",
    "dropphyzpp": 302689998,
    "dropmaladd": "502 WALNUT WAY",
    "dropmalcty": "PALMETTO",
    "dropmalst": "GA",
    "dropmalzpp": 302689998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704630910,
    "dropsitcph": 7704633457,
    "dropfax": 7704632410
  },
  {
    "dcode": "D",
    "dropkey": "PX10963",
    "droptype": "D",
    "dropname": "PARROTT",
    "dropdeladd": "107 OLD DAWSON RD",
    "dropdelcty": "PARROTT",
    "dropdelst": "GA",
    "dropdelzpp": 398779998,
    "dropphyadd": "107 OLD DAWSON RD",
    "dropphycty": "PARROTT",
    "dropphyst": "GA",
    "dropphyzpp": 398779998,
    "dropmaladd": "107 OLD DAWSON RD",
    "dropmalcty": "PARROTT",
    "dropmalst": "GA",
    "dropmalzpp": 398779998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296232915,
    "dropsitcph": 2296232915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10964",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "6469 US HIGHWAY 84",
    "dropdelcty": "PATTERSON",
    "dropdelst": "GA",
    "dropdelzpp": 315579998,
    "dropphyadd": "6469 US HIGHWAY 84",
    "dropphycty": "PATTERSON",
    "dropphyst": "GA",
    "dropphyzpp": 315579998,
    "dropmaladd": "6469 US HIGHWAY 84",
    "dropmalcty": "PATTERSON",
    "dropmalst": "GA",
    "dropmalzpp": 315579998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126470575,
    "dropsitcph": 9126470575,
    "dropfax": 9126471471
  },
  {
    "dcode": "D",
    "dropkey": "PX10966",
    "droptype": "D",
    "dropname": "PAVO",
    "dropdeladd": "2028 E HARRIS ST",
    "dropdelcty": "PAVO",
    "dropdelst": "GA",
    "dropdelzpp": 317789998,
    "dropphyadd": "2028 E HARRIS ST",
    "dropphycty": "PAVO",
    "dropphyst": "GA",
    "dropphyzpp": 317789998,
    "dropmaladd": "2028 E HARRIS ST",
    "dropmalcty": "PAVO",
    "dropmalst": "GA",
    "dropmalzpp": 317789998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298592620,
    "dropsitcph": 2298592620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10975",
    "droptype": "D",
    "dropname": "PEARSON",
    "dropdeladd": "102 S CHURCH ST",
    "dropdelcty": "PEARSON",
    "dropdelst": "GA",
    "dropdelzpp": 316429998,
    "dropphyadd": "102 S CHURCH ST",
    "dropphycty": "PEARSON",
    "dropphyst": "GA",
    "dropphyzpp": 316429998,
    "dropmaladd": "102 S CHURCH ST",
    "dropmalcty": "PEARSON",
    "dropmalst": "GA",
    "dropmalzpp": 316429998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124227702,
    "dropsitcph": 9124227702,
    "dropfax": 9124223530
  },
  {
    "dcode": "D",
    "dropkey": "PX10976",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "160 MATHEWSON AVE SW",
    "dropdelcty": "PELHAM",
    "dropdelst": "GA",
    "dropdelzpp": 317799998,
    "dropphyadd": "160 MATHEWSON AVE SW",
    "dropphycty": "PELHAM",
    "dropphyst": "GA",
    "dropphyzpp": 317799998,
    "dropmaladd": "160 MATHEWSON AVE SW",
    "dropmalcty": "PELHAM",
    "dropmalst": "GA",
    "dropmalzpp": 317799998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2292942636,
    "dropsitcph": 2292942636,
    "dropfax": 2292945489
  },
  {
    "dcode": "D",
    "dropkey": "PX10977",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "298 LEDFORD ST",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "GA",
    "dropdelzpp": 313219998,
    "dropphyadd": "298 LEDFORD ST",
    "dropphycty": "PEMBROKE",
    "dropphyst": "GA",
    "dropphyzpp": 313219998,
    "dropmaladd": "298 LEDFORD ST",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "GA",
    "dropmalzpp": 313219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126533377,
    "dropsitcph": 9126533377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10978",
    "droptype": "D",
    "dropname": "PENDERGRASS",
    "dropdeladd": "12 RAILROAD ST",
    "dropdelcty": "PENDERGRASS",
    "dropdelst": "GA",
    "dropdelzpp": 305679998,
    "dropphyadd": "12 RAILROAD ST",
    "dropphycty": "PENDERGRASS",
    "dropphyst": "GA",
    "dropphyzpp": 305679998,
    "dropmaladd": "12 RAILROAD ST",
    "dropmalcty": "PENDERGRASS",
    "dropmalst": "GA",
    "dropmalzpp": 305679998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066932189,
    "dropsitcph": 7066932205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10983",
    "droptype": "D",
    "dropname": "PERKINS",
    "dropdeladd": "1664 PERKINS GREEN FORK RD",
    "dropdelcty": "PERKINS",
    "dropdelst": "GA",
    "dropdelzpp": 308225460,
    "dropphyadd": "1664 PERKINS GREEN FORK RD",
    "dropphycty": "PERKINS",
    "dropphyst": "GA",
    "dropphyzpp": 308225460,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERKINS",
    "dropmalst": "GA",
    "dropmalzpp": 308229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789821040,
    "dropsitcph": 4789821040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10984",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "1400 MACON RD",
    "dropdelcty": "PERRY",
    "dropdelst": "GA",
    "dropdelzpp": 310699998,
    "dropphyadd": "1400 MACON RD",
    "dropphycty": "PERRY",
    "dropphyst": "GA",
    "dropphyzpp": 310699998,
    "dropmaladd": "1400 MACON RD",
    "dropmalcty": "PERRY",
    "dropmalst": "GA",
    "dropmalzpp": 310699998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789881251,
    "dropsitcph": 4789881251,
    "dropfax": 4789879756
  },
  {
    "dcode": "D",
    "dropkey": "PX10989",
    "droptype": "D",
    "dropname": "PINE LAKE",
    "dropdeladd": "4567 ROCKBRIDGE RD",
    "dropdelcty": "PINE LAKE",
    "dropdelst": "GA",
    "dropdelzpp": 300724266,
    "dropphyadd": "4567 ROCKBRIDGE RD",
    "dropphycty": "PINE LAKE",
    "dropphyst": "GA",
    "dropphyzpp": 300724266,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE LAKE",
    "dropmalst": "GA",
    "dropmalzpp": 300729998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042929224,
    "dropsitcph": 4042929224,
    "dropfax": 4045089487
  },
  {
    "dcode": "D",
    "dropkey": "PX10992",
    "droptype": "D",
    "dropname": "PINE MOUNTAIN",
    "dropdeladd": "158 N MCDOUGALD AVE",
    "dropdelcty": "PINE MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 318229998,
    "dropphyadd": "158 N MCDOUGALD AVE",
    "dropphycty": "PINE MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 318229998,
    "dropmaladd": "158 N MCDOUGALD AVE",
    "dropmalcty": "PINE MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 318229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066638472,
    "dropsitcph": 7066638472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10993",
    "droptype": "D",
    "dropname": "PINE MOUNTAIN VALLEY",
    "dropdeladd": "13642 GA HIGHWAY 116",
    "dropdelcty": "PINE MOUNTAIN VALLEY",
    "dropdelst": "GA",
    "dropdelzpp": 318239998,
    "dropphyadd": "13642 GA HIGHWAY 116",
    "dropphycty": "PINE MOUNTAIN VALLEY",
    "dropphyst": "GA",
    "dropphyzpp": 318239998,
    "dropmaladd": "13642 GA HIGHWAY 116",
    "dropmalcty": "PINE MOUNTAIN VALLEY",
    "dropmalst": "GA",
    "dropmalzpp": 318239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066285252,
    "dropsitcph": 7066285252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10994",
    "droptype": "D",
    "dropname": "PINEHURST",
    "dropdeladd": "551 CYPRESS AVE",
    "dropdelcty": "PINEHURST",
    "dropdelst": "GA",
    "dropdelzpp": 310709998,
    "dropphyadd": "551 CYPRESS AVE",
    "dropphycty": "PINEHURST",
    "dropphyst": "GA",
    "dropphyzpp": 310709998,
    "dropmaladd": "551 CYPRESS AVE",
    "dropmalcty": "PINEHURST",
    "dropmalst": "GA",
    "dropmalzpp": 310709998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296453771,
    "dropsitcph": 2296453771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX10996",
    "droptype": "D",
    "dropname": "PINEVIEW",
    "dropdeladd": "135 COMMERCE ST E",
    "dropdelcty": "PINEVIEW",
    "dropdelst": "GA",
    "dropdelzpp": 310719998,
    "dropphyadd": "135 COMMERCE ST E",
    "dropphycty": "PINEVIEW",
    "dropphyst": "GA",
    "dropphyzpp": 310719998,
    "dropmaladd": "135 COMMERCE ST E",
    "dropmalcty": "PINEVIEW",
    "dropmalst": "GA",
    "dropmalzpp": 310719998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296242320,
    "dropsitcph": 2296242320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11000",
    "droptype": "D",
    "dropname": "PITTS",
    "dropdeladd": "109 8TH ST S",
    "dropdelcty": "PITTS",
    "dropdelst": "GA",
    "dropdelzpp": 310729998,
    "dropphyadd": "109 8TH ST S",
    "dropphycty": "PITTS",
    "dropphyst": "GA",
    "dropphyzpp": 310729998,
    "dropmaladd": "109 8TH ST S",
    "dropmalcty": "PITTS",
    "dropmalst": "GA",
    "dropmalzpp": 310729998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296486232,
    "dropsitcph": 2296486232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11002",
    "droptype": "D",
    "dropname": "PLAINS",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "PLAINS",
    "dropdelst": "GA",
    "dropdelzpp": 317809998,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "PLAINS",
    "dropphyst": "GA",
    "dropphyzpp": 317809998,
    "dropmaladd": "119 MAIN ST",
    "dropmalcty": "PLAINS",
    "dropmalst": "GA",
    "dropmalzpp": 317809998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298247476,
    "dropsitcph": 2298247476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11003",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "133 YORK DR SW",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 307339998,
    "dropphyadd": "133 YORK DR SW",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 307339998,
    "dropmaladd": "133 YORK DR SW",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 307339998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7062954766,
    "dropsitcph": 7062954766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11011",
    "droptype": "D",
    "dropname": "POOLER",
    "dropdeladd": "1030 US HIGHWAY 80 W",
    "dropdelcty": "POOLER",
    "dropdelst": "GA",
    "dropdelzpp": 313221608,
    "dropphyadd": "1030 US HIGHWAY 80 W",
    "dropphycty": "POOLER",
    "dropphyst": "GA",
    "dropphyzpp": 313221608,
    "dropmaladd": "1030 US HIGHWAY 80 W",
    "dropmalcty": "POOLER",
    "dropmalst": "GA",
    "dropmalzpp": 313221608,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127484927,
    "dropsitcph": 9127484927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11013",
    "droptype": "D",
    "dropname": "PORTAL",
    "dropdeladd": "27310 US HIGHWAY 80 W",
    "dropdelcty": "PORTAL",
    "dropdelst": "GA",
    "dropdelzpp": 304509998,
    "dropphyadd": "27310 US HIGHWAY 80 W",
    "dropphycty": "PORTAL",
    "dropphyst": "GA",
    "dropphyzpp": 304509998,
    "dropmaladd": "27310 US HIGHWAY 80 W",
    "dropmalcty": "PORTAL",
    "dropmalst": "GA",
    "dropmalzpp": 304509998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128652903,
    "dropsitcph": 9128654100,
    "dropfax": 9128654100
  },
  {
    "dcode": "D",
    "dropkey": "PX11014",
    "droptype": "D",
    "dropname": "PORTERDALE",
    "dropdeladd": "2600 MAIN ST",
    "dropdelcty": "PORTERDALE",
    "dropdelst": "GA",
    "dropdelzpp": 300700977,
    "dropphyadd": "2600 MAIN ST",
    "dropphycty": "PORTERDALE",
    "dropphyst": "GA",
    "dropphyzpp": 300700977,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTERDALE",
    "dropmalst": "GA",
    "dropmalzpp": 300709998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707862369,
    "dropsitcph": 7707862369,
    "dropfax": 7703857024
  },
  {
    "dcode": "D",
    "dropkey": "PX11016",
    "droptype": "D",
    "dropname": "POULAN",
    "dropdeladd": "120 BROAD ST SE",
    "dropdelcty": "POULAN",
    "dropdelst": "GA",
    "dropdelzpp": 317819998,
    "dropphyadd": "120 BROAD ST SE",
    "dropphycty": "POULAN",
    "dropphyst": "GA",
    "dropphyzpp": 317819998,
    "dropmaladd": "120 BROAD ST SE",
    "dropmalcty": "POULAN",
    "dropmalst": "GA",
    "dropmalzpp": 317819998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297766061,
    "dropsitcph": 2297766061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11018",
    "droptype": "D",
    "dropname": "POWDER SPRINGS",
    "dropdeladd": "4644 POWDER SPRINGS DALLAS RD",
    "dropdelcty": "POWDER SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 301279998,
    "dropphyadd": "4644 POWDER SPRINGS DALLAS RD",
    "dropphycty": "POWDER SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 301279998,
    "dropmaladd": "4644 POWDER SPRINGS DALLAS RD",
    "dropmalcty": "POWDER SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 301279998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784330187,
    "dropsitcph": 7704392771,
    "dropfax": 7704392791
  },
  {
    "dcode": "D",
    "dropkey": "PX11020",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "190 MONTGOMERY ST",
    "dropdelcty": "PRESTON",
    "dropdelst": "GA",
    "dropdelzpp": 318249998,
    "dropphyadd": "190 MONTGOMERY ST",
    "dropphycty": "PRESTON",
    "dropphyst": "GA",
    "dropphyzpp": 318249998,
    "dropmaladd": "190 MONTGOMERY ST",
    "dropmalcty": "PRESTON",
    "dropmalst": "GA",
    "dropmalzpp": 318249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298284210,
    "dropsitcph": 2298284210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11023",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "105 E RAILROAD ST",
    "dropdelcty": "PULASKI",
    "dropdelst": "GA",
    "dropdelzpp": 304519997,
    "dropphyadd": "105 E RAILROAD ST",
    "dropphycty": "PULASKI",
    "dropphyst": "GA",
    "dropphyzpp": 304519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULASKI",
    "dropmalst": "GA",
    "dropmalzpp": 304519998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126856497,
    "dropsitcph": 9126856497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11025",
    "droptype": "D",
    "dropname": "PUTNEY",
    "dropdeladd": "4314 RADIUM SPRINGS RD",
    "dropdelcty": "PUTNEY",
    "dropdelst": "GA",
    "dropdelzpp": 317829998,
    "dropphyadd": "4314 RADIUM SPRINGS RD",
    "dropphycty": "PUTNEY",
    "dropphyst": "GA",
    "dropphyzpp": 317829998,
    "dropmaladd": "4314 RADIUM SPRINGS RD",
    "dropmalcty": "PUTNEY",
    "dropmalst": "GA",
    "dropmalzpp": 317829998,
    "dropsitphn": 9127528444,
    "dropsitlph": 2298890123,
    "dropsitcph": 2298890123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11026",
    "droptype": "D",
    "dropname": "QUITMAN",
    "dropdeladd": "410 E SCREVEN ST",
    "dropdelcty": "QUITMAN",
    "dropdelst": "GA",
    "dropdelzpp": 316439998,
    "dropphyadd": "410 E SCREVEN ST",
    "dropphycty": "QUITMAN",
    "dropphyst": "GA",
    "dropphyzpp": 316439998,
    "dropmaladd": "410 E SCREVEN ST",
    "dropmalcty": "QUITMAN",
    "dropmalst": "GA",
    "dropmalzpp": 316439998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292637280,
    "dropsitcph": 2292637280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11027",
    "droptype": "D",
    "dropname": "RABUN GAP",
    "dropdeladd": "5664 HIGHWAY 441 N",
    "dropdelcty": "RABUN GAP",
    "dropdelst": "GA",
    "dropdelzpp": 305689998,
    "dropphyadd": "5664 HIGHWAY 441 N",
    "dropphycty": "RABUN GAP",
    "dropphyst": "GA",
    "dropphyzpp": 305689998,
    "dropmaladd": "5664 HIGHWAY 441 N",
    "dropmalcty": "RABUN GAP",
    "dropmalst": "GA",
    "dropmalzpp": 305689998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067465782,
    "dropsitcph": 7067465782,
    "dropfax": 7067467318
  },
  {
    "dcode": "D",
    "dropkey": "PX11030",
    "droptype": "D",
    "dropname": "RANGER",
    "dropdeladd": "121 US HIGHWAY 411 SE",
    "dropdelcty": "RANGER",
    "dropdelst": "GA",
    "dropdelzpp": 307349998,
    "dropphyadd": "121 US HIGHWAY 411 SE",
    "dropphycty": "RANGER",
    "dropphyst": "GA",
    "dropphyzpp": 307349998,
    "dropmaladd": "121 US HIGHWAY 411 SE",
    "dropmalcty": "RANGER",
    "dropmalst": "GA",
    "dropmalzpp": 307349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7063342295,
    "dropsitcph": 7063342295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11031",
    "droptype": "D",
    "dropname": "RAY CITY",
    "dropdeladd": "8122 MAIN ST",
    "dropdelcty": "RAY CITY",
    "dropdelst": "GA",
    "dropdelzpp": 316459998,
    "dropphyadd": "8122 MAIN ST",
    "dropphycty": "RAY CITY",
    "dropphyst": "GA",
    "dropphyzpp": 316459998,
    "dropmaladd": "8122 MAIN ST",
    "dropmalcty": "RAY CITY",
    "dropmalst": "GA",
    "dropmalzpp": 316459998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2294552022,
    "dropsitcph": 2294552022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11033",
    "droptype": "D",
    "dropname": "RAYLE",
    "dropdeladd": "5008 LEXINGTON RD",
    "dropdelcty": "RAYLE",
    "dropdelst": "GA",
    "dropdelzpp": 306609998,
    "dropphyadd": "5008 LEXINGTON RD",
    "dropphycty": "RAYLE",
    "dropphyst": "GA",
    "dropphyzpp": 306609998,
    "dropmaladd": "5008 LEXINGTON RD",
    "dropmalcty": "RAYLE",
    "dropmalst": "GA",
    "dropmalzpp": 306609998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062743430,
    "dropsitcph": 7062743430,
    "dropfax": 7062743600
  },
  {
    "dcode": "D",
    "dropkey": "PX11035",
    "droptype": "D",
    "dropname": "REBECCA",
    "dropdeladd": "41 N RAILROAD ST",
    "dropdelcty": "REBECCA",
    "dropdelst": "GA",
    "dropdelzpp": 317839998,
    "dropphyadd": "41 N RAILROAD ST",
    "dropphycty": "REBECCA",
    "dropphyst": "GA",
    "dropphyzpp": 317839998,
    "dropmaladd": "41 N RAILROAD ST",
    "dropmalcty": "REBECCA",
    "dropmalst": "GA",
    "dropmalzpp": 317839998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2296437771,
    "dropsitcph": 2296437771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11036",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "3435 ROOSEVELT HWY",
    "dropdelcty": "RED OAK",
    "dropdelst": "GA",
    "dropdelzpp": 302722312,
    "dropphyadd": "3435 ROOSEVELT HWY",
    "dropphycty": "RED OAK",
    "dropphyst": "GA",
    "dropphyzpp": 302722312,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED OAK",
    "dropmalst": "GA",
    "dropmalzpp": 302729998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047615870,
    "dropsitcph": 4047615870,
    "dropfax": 4043058836
  },
  {
    "dcode": "D",
    "dropkey": "PX11037",
    "droptype": "D",
    "dropname": "REDAN",
    "dropdeladd": "1544 WELLBORN RD STE 4",
    "dropdelcty": "LITHONIA",
    "dropdelst": "GA",
    "dropdelzpp": 300589997,
    "dropphyadd": "1544 WELLBORN RD STE 4",
    "dropphycty": "LITHONIA",
    "dropphyst": "GA",
    "dropphyzpp": 300589997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDAN",
    "dropmalst": "GA",
    "dropmalzpp": 300749998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704829820,
    "dropsitcph": 7704821219,
    "dropfax": 7704822060
  },
  {
    "dcode": "D",
    "dropkey": "PX11039",
    "droptype": "D",
    "dropname": "REGISTER",
    "dropdeladd": "2981 GA HIGHWAY 46",
    "dropdelcty": "REGISTER",
    "dropdelst": "GA",
    "dropdelzpp": 304529998,
    "dropphyadd": "2981 GA HIGHWAY 46",
    "dropphycty": "REGISTER",
    "dropphyst": "GA",
    "dropphyzpp": 304529998,
    "dropmaladd": "2981 GA HIGHWAY 46",
    "dropmalcty": "REGISTER",
    "dropmalst": "GA",
    "dropmalzpp": 304529998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124882352,
    "dropsitcph": 9124882352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11040",
    "droptype": "D",
    "dropname": "REIDSVILLE",
    "dropdeladd": "111 JAMES ST",
    "dropdelcty": "REIDSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 304539998,
    "dropphyadd": "111 JAMES ST",
    "dropphycty": "REIDSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 304539998,
    "dropmaladd": "111 JAMES ST",
    "dropmalcty": "REIDSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 304539998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125576374,
    "dropsitcph": 9125576374,
    "dropfax": 9125573816
  },
  {
    "dcode": "D",
    "dropkey": "PX11042",
    "droptype": "D",
    "dropname": "RENTZ",
    "dropdeladd": "2120 W RAILROAD ST",
    "dropdelcty": "RENTZ",
    "dropdelst": "GA",
    "dropdelzpp": 310759998,
    "dropphyadd": "2120 W RAILROAD ST",
    "dropphycty": "RENTZ",
    "dropphyst": "GA",
    "dropphyzpp": 310759998,
    "dropmaladd": "2120 W RAILROAD ST",
    "dropmalcty": "RENTZ",
    "dropmalst": "GA",
    "dropmalzpp": 310759998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789844310,
    "dropsitcph": 4789844310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11043",
    "droptype": "D",
    "dropname": "RESACA",
    "dropdeladd": "3073 BATTLEFIELD PKWY NE",
    "dropdelcty": "RESACA",
    "dropdelst": "GA",
    "dropdelzpp": 307359998,
    "dropphyadd": "3073 BATTLEFIELD PKWY NE",
    "dropphycty": "RESACA",
    "dropphyst": "GA",
    "dropphyzpp": 307359998,
    "dropmaladd": "3073 BATTLEFIELD PKWY NE",
    "dropmalcty": "RESACA",
    "dropmalst": "GA",
    "dropmalzpp": 307359998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066295331,
    "dropsitcph": 7066295331,
    "dropfax": 7066021413
  },
  {
    "dcode": "D",
    "dropkey": "PX11045",
    "droptype": "D",
    "dropname": "REX",
    "dropdeladd": "6450 EVANS DR",
    "dropdelcty": "REX",
    "dropdelst": "GA",
    "dropdelzpp": 302739998,
    "dropphyadd": "6450 EVANS DR",
    "dropphycty": "REX",
    "dropphyst": "GA",
    "dropphyzpp": 302739998,
    "dropmaladd": "6450 EVANS DR",
    "dropmalcty": "REX",
    "dropmalst": "GA",
    "dropmalzpp": 302739998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782896059,
    "dropsitcph": 7705074358,
    "dropfax": 6782896985
  },
  {
    "dcode": "D",
    "dropkey": "PX11046",
    "droptype": "D",
    "dropname": "REYNOLDS",
    "dropdeladd": "8 N CRAWFORD ST",
    "dropdelcty": "REYNOLDS",
    "dropdelst": "GA",
    "dropdelzpp": 310769998,
    "dropphyadd": "8 N CRAWFORD ST",
    "dropphycty": "REYNOLDS",
    "dropphyst": "GA",
    "dropphyzpp": 310769998,
    "dropmaladd": "8 N CRAWFORD ST",
    "dropmalcty": "REYNOLDS",
    "dropmalst": "GA",
    "dropmalzpp": 310769998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782760007,
    "dropsitcph": 4787951830,
    "dropfax": 4788472499
  },
  {
    "dcode": "D",
    "dropkey": "PX11048",
    "droptype": "D",
    "dropname": "RHINE",
    "dropdeladd": "111 1ST ST",
    "dropdelcty": "RHINE",
    "dropdelst": "GA",
    "dropdelzpp": 310779998,
    "dropphyadd": "111 1ST ST",
    "dropphycty": "RHINE",
    "dropphyst": "GA",
    "dropphyzpp": 310779998,
    "dropmaladd": "111 1ST ST",
    "dropmalcty": "RHINE",
    "dropmalst": "GA",
    "dropmalzpp": 310779998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293856435,
    "dropsitcph": 2293856435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11049",
    "droptype": "D",
    "dropname": "RICEBORO",
    "dropdeladd": "4705 S COASTAL HWY",
    "dropdelcty": "RICEBORO",
    "dropdelst": "GA",
    "dropdelzpp": 313239998,
    "dropphyadd": "4705 S COASTAL HWY",
    "dropphycty": "RICEBORO",
    "dropphyst": "GA",
    "dropphyzpp": 313239998,
    "dropmaladd": "4705 S COASTAL HWY",
    "dropmalcty": "RICEBORO",
    "dropmalst": "GA",
    "dropmalzpp": 313239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128843445,
    "dropsitcph": 9128843445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11050",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "46 DEPOT ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "GA",
    "dropdelzpp": 318259998,
    "dropphyadd": "46 DEPOT ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "GA",
    "dropphyzpp": 318259998,
    "dropmaladd": "46 DEPOT ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "GA",
    "dropmalzpp": 318259998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298872153,
    "dropsitcph": 2298872153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11051",
    "droptype": "D",
    "dropname": "RICHMOND HILL",
    "dropdeladd": "9664 FORD AVE",
    "dropdelcty": "RICHMOND HILL",
    "dropdelst": "GA",
    "dropdelzpp": 313249998,
    "dropphyadd": "9664 FORD AVE",
    "dropphycty": "RICHMOND HILL",
    "dropphyst": "GA",
    "dropphyzpp": 313249998,
    "dropmaladd": "9664 FORD AVE",
    "dropmalcty": "RICHMOND HILL",
    "dropmalst": "GA",
    "dropmalzpp": 313249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127566084,
    "dropsitcph": 9127566084,
    "dropfax": 9127564507
  },
  {
    "dcode": "D",
    "dropkey": "PX11053",
    "droptype": "D",
    "dropname": "RINCON",
    "dropdeladd": "503 N RIDGE ST",
    "dropdelcty": "RINCON",
    "dropdelst": "GA",
    "dropdelzpp": 313269998,
    "dropphyadd": "503 N RIDGE ST",
    "dropphycty": "RINCON",
    "dropphyst": "GA",
    "dropphyzpp": 313269998,
    "dropmaladd": "503 N RIDGE ST",
    "dropmalcty": "RINCON",
    "dropmalst": "GA",
    "dropmalzpp": 313269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128261772,
    "dropsitcph": 9128261772,
    "dropfax": 9128260280
  },
  {
    "dcode": "D",
    "dropkey": "PX11054",
    "droptype": "D",
    "dropname": "RINGGOLD",
    "dropdeladd": "862 LAFAYETTE ST",
    "dropdelcty": "RINGGOLD",
    "dropdelst": "GA",
    "dropdelzpp": 307369998,
    "dropphyadd": "862 LAFAYETTE ST",
    "dropphycty": "RINGGOLD",
    "dropphyst": "GA",
    "dropphyzpp": 307369998,
    "dropmaladd": "862 LAFAYETTE ST",
    "dropmalcty": "RINGGOLD",
    "dropmalst": "GA",
    "dropmalzpp": 307369998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7069359236,
    "dropsitcph": 7069359811,
    "dropfax": 7069654640
  },
  {
    "dcode": "D",
    "dropkey": "PX11055",
    "droptype": "D",
    "dropname": "RISING FAWN",
    "dropdeladd": "28 MASON RD",
    "dropdelcty": "RISING FAWN",
    "dropdelst": "GA",
    "dropdelzpp": 307389998,
    "dropphyadd": "28 MASON RD",
    "dropphycty": "RISING FAWN",
    "dropphyst": "GA",
    "dropphyzpp": 307389998,
    "dropmaladd": "28 MASON RD",
    "dropmalcty": "RISING FAWN",
    "dropmalst": "GA",
    "dropmalzpp": 307389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7064622338,
    "dropsitcph": 7064622338,
    "dropfax": 7064622075
  },
  {
    "dcode": "D",
    "dropkey": "PX11056",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "7139 HIGHWAY 85",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "GA",
    "dropdelzpp": 302749998,
    "dropphyadd": "7139 HIGHWAY 85",
    "dropphycty": "RIVERDALE",
    "dropphyst": "GA",
    "dropphyzpp": 302749998,
    "dropmaladd": "7139 HIGHWAY 85",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "GA",
    "dropmalzpp": 302749998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6789616513,
    "dropsitcph": 7709943536,
    "dropfax": 7702101747
  },
  {
    "dcode": "D",
    "dropkey": "PX11061",
    "droptype": "D",
    "dropname": "ROBERTA",
    "dropdeladd": "160 N DUGGER AVE",
    "dropdelcty": "ROBERTA",
    "dropdelst": "GA",
    "dropdelzpp": 310789998,
    "dropphyadd": "160 N DUGGER AVE",
    "dropphycty": "ROBERTA",
    "dropphyst": "GA",
    "dropphyzpp": 310789998,
    "dropmaladd": "160 N DUGGER AVE",
    "dropmalcty": "ROBERTA",
    "dropmalst": "GA",
    "dropmalzpp": 310789998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788362752,
    "dropsitcph": 4788362752,
    "dropfax": 4788365351
  },
  {
    "dcode": "D",
    "dropkey": "PX11065",
    "droptype": "D",
    "dropname": "ROCHELLE",
    "dropdeladd": "577 2ND AVE",
    "dropdelcty": "ROCHELLE",
    "dropdelst": "GA",
    "dropdelzpp": 310799998,
    "dropphyadd": "577 2ND AVE",
    "dropphycty": "ROCHELLE",
    "dropphyst": "GA",
    "dropphyzpp": 310799998,
    "dropmaladd": "577 2ND AVE",
    "dropmalcty": "ROCHELLE",
    "dropmalst": "GA",
    "dropmalzpp": 310799998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2293652332,
    "dropsitcph": 2293652332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11067",
    "droptype": "D",
    "dropname": "ROCK SPRING",
    "dropdeladd": "36 ROCK SPRING DR",
    "dropdelcty": "ROCK SPRING",
    "dropdelst": "GA",
    "dropdelzpp": 307399998,
    "dropphyadd": "36 ROCK SPRING DR",
    "dropphycty": "ROCK SPRING",
    "dropphyst": "GA",
    "dropphyzpp": 307399998,
    "dropmaladd": "36 ROCK SPRING DR",
    "dropmalcty": "ROCK SPRING",
    "dropmalst": "GA",
    "dropmalzpp": 307399998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7067642410,
    "dropsitcph": 7067642410,
    "dropfax": 7067641106
  },
  {
    "dcode": "D",
    "dropkey": "PX11071",
    "droptype": "D",
    "dropname": "ROCKLEDGE",
    "dropdeladd": "2155 ROCKLEDGE RD",
    "dropdelcty": "ROCKLEDGE",
    "dropdelst": "GA",
    "dropdelzpp": 304549998,
    "dropphyadd": "2155 ROCKLEDGE RD",
    "dropphycty": "ROCKLEDGE",
    "dropphyst": "GA",
    "dropphyzpp": 304549998,
    "dropmaladd": "2155 ROCKLEDGE RD",
    "dropmalcty": "ROCKLEDGE",
    "dropmalst": "GA",
    "dropmalzpp": 304549998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782730637,
    "dropsitcph": 4782730637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11072",
    "droptype": "D",
    "dropname": "ROCKMART",
    "dropdeladd": "130 E ELM ST",
    "dropdelcty": "ROCKMART",
    "dropdelst": "GA",
    "dropdelzpp": 301539998,
    "dropphyadd": "130 E ELM ST",
    "dropphycty": "ROCKMART",
    "dropphyst": "GA",
    "dropphyzpp": 301539998,
    "dropmaladd": "130 E ELM ST",
    "dropmalcty": "ROCKMART",
    "dropmalst": "GA",
    "dropmalzpp": 301539998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706844758,
    "dropsitcph": 7706843131,
    "dropfax": 7706843533
  },
  {
    "dcode": "D",
    "dropkey": "PX11073",
    "droptype": "D",
    "dropname": "ROCKY FACE",
    "dropdeladd": "2609 CHATTANOOGA RD",
    "dropdelcty": "ROCKY FACE",
    "dropdelst": "GA",
    "dropdelzpp": 307409998,
    "dropphyadd": "2609 CHATTANOOGA RD",
    "dropphycty": "ROCKY FACE",
    "dropphyst": "GA",
    "dropphyzpp": 307409998,
    "dropmaladd": "2609 CHATTANOOGA RD",
    "dropmalcty": "ROCKY FACE",
    "dropmalst": "GA",
    "dropmalzpp": 307409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7062263144,
    "dropsitcph": 7062263144,
    "dropfax": 7062264511
  },
  {
    "dcode": "D",
    "dropkey": "PX11074",
    "droptype": "D",
    "dropname": "ROCKY FORD",
    "dropdeladd": "151 MAIN ST",
    "dropdelcty": "ROCKY FORD",
    "dropdelst": "GA",
    "dropdelzpp": 304559998,
    "dropphyadd": "151 MAIN ST",
    "dropphycty": "ROCKY FORD",
    "dropphyst": "GA",
    "dropphyzpp": 304559998,
    "dropmaladd": "151 MAIN ST",
    "dropmalcty": "ROCKY FORD",
    "dropmalst": "GA",
    "dropmalzpp": 304559998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128634031,
    "dropsitcph": 9128634031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11075",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "1420 MARTHA BERRY BLVD NE",
    "dropdelcty": "ROME",
    "dropdelst": "GA",
    "dropdelzpp": 301659998,
    "dropphyadd": "1420 MARTHA BERRY BLVD NE",
    "dropphycty": "ROME",
    "dropphyst": "GA",
    "dropphyzpp": 301659998,
    "dropmaladd": "1420 MARTHA BERRY BLVD NE",
    "dropmalcty": "ROME",
    "dropmalst": "GA",
    "dropmalzpp": 301659998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062914923,
    "dropsitcph": 7067283326,
    "dropfax": 7062915987
  },
  {
    "dcode": "D",
    "dropkey": "PX11076",
    "droptype": "D",
    "dropname": "ROOPVILLE",
    "dropdeladd": "270 S HIGHWAY 27",
    "dropdelcty": "ROOPVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301709998,
    "dropphyadd": "270 S HIGHWAY 27",
    "dropphycty": "ROOPVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301709998,
    "dropmaladd": "270 S HIGHWAY 27",
    "dropmalcty": "ROOPVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301709998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708548205,
    "dropsitcph": 7708548205,
    "dropfax": 7708547517
  },
  {
    "dcode": "D",
    "dropkey": "PX11082",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "301 CHICKAMAUGA AVE",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 307419998,
    "dropphyadd": "301 CHICKAMAUGA AVE",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 307419998,
    "dropmaladd": "301 CHICKAMAUGA AVE",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 307419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068668203,
    "dropsitcph": 7068667668,
    "dropfax": 7068619196
  },
  {
    "dcode": "D",
    "dropkey": "PX11085",
    "droptype": "D",
    "dropname": "ROSWELL",
    "dropdeladd": "8920 EVES RD",
    "dropdelcty": "ROSWELL",
    "dropdelst": "GA",
    "dropdelzpp": 300769998,
    "dropphyadd": "8920 EVES RD",
    "dropphycty": "ROSWELL",
    "dropphyst": "GA",
    "dropphyzpp": 300769998,
    "dropmaladd": "8920 EVES RD",
    "dropmalcty": "ROSWELL",
    "dropmalst": "GA",
    "dropmalzpp": 300769998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706418763,
    "dropsitcph": 7706410372,
    "dropfax": 7705521622
  },
  {
    "dcode": "D",
    "dropkey": "PX11088",
    "droptype": "D",
    "dropname": "ROYSTON",
    "dropdeladd": "804 CHURCH ST",
    "dropdelcty": "ROYSTON",
    "dropdelst": "GA",
    "dropdelzpp": 306629998,
    "dropphyadd": "804 CHURCH ST",
    "dropphycty": "ROYSTON",
    "dropphyst": "GA",
    "dropphyzpp": 306629998,
    "dropmaladd": "804 CHURCH ST",
    "dropmalcty": "ROYSTON",
    "dropmalst": "GA",
    "dropmalzpp": 306629998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062455069,
    "dropsitcph": 7062458404,
    "dropfax": 7062458609
  },
  {
    "dcode": "D",
    "dropkey": "PX11090",
    "droptype": "D",
    "dropname": "RUPERT",
    "dropdeladd": "208 J RAN COOPER RD",
    "dropdelcty": "RUPERT",
    "dropdelst": "GA",
    "dropdelzpp": 310819998,
    "dropphyadd": "208 J RAN COOPER RD",
    "dropphycty": "RUPERT",
    "dropphyst": "GA",
    "dropphyzpp": 310819998,
    "dropmaladd": "208 J RAN COOPER RD",
    "dropmalcty": "RUPERT",
    "dropmalst": "GA",
    "dropmalzpp": 310819998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788623792,
    "dropsitcph": 4788623792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11091",
    "droptype": "D",
    "dropname": "RUTLEDGE",
    "dropdeladd": "131 NEWBORN RD",
    "dropdelcty": "RUTLEDGE",
    "dropdelst": "GA",
    "dropdelzpp": 306639998,
    "dropphyadd": "131 NEWBORN RD",
    "dropphycty": "RUTLEDGE",
    "dropphyst": "GA",
    "dropphyzpp": 306639998,
    "dropmaladd": "131 NEWBORN RD",
    "dropmalcty": "RUTLEDGE",
    "dropmalst": "GA",
    "dropmalzpp": 306639998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7065572737,
    "dropsitcph": 7065572737,
    "dropfax": 7065579545
  },
  {
    "dcode": "D",
    "dropkey": "PX11092",
    "droptype": "D",
    "dropname": "RYDAL",
    "dropdeladd": "11 POST OFFICE CIR NE",
    "dropdelcty": "RYDAL",
    "dropdelst": "GA",
    "dropdelzpp": 301719998,
    "dropphyadd": "11 POST OFFICE CIR NE",
    "dropphycty": "RYDAL",
    "dropphyst": "GA",
    "dropphyzpp": 301719998,
    "dropmaladd": "11 POST OFFICE CIR NE",
    "dropmalcty": "RYDAL",
    "dropmalst": "GA",
    "dropmalzpp": 301719998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703828996,
    "dropsitcph": 7703828996,
    "dropfax": 7703827147
  },
  {
    "dcode": "D",
    "dropkey": "PX11094",
    "droptype": "D",
    "dropname": "SAINT GEORGE",
    "dropdeladd": "12995 FLORIDA AVE STE A",
    "dropdelcty": "SAINT GEORGE",
    "dropdelst": "GA",
    "dropdelzpp": 315629998,
    "dropphyadd": "12995 FLORIDA AVE STE A",
    "dropphycty": "SAINT GEORGE",
    "dropphyst": "GA",
    "dropphyzpp": 315629998,
    "dropmaladd": "12995 FLORIDA AVE STE A",
    "dropmalcty": "SAINT GEORGE",
    "dropmalst": "GA",
    "dropmalzpp": 315629998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128432271,
    "dropsitcph": 9128432271,
    "dropfax": 9128432271
  },
  {
    "dcode": "D",
    "dropkey": "PX11095",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "724 CHARLIE SMITH SR HWY",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "GA",
    "dropdelzpp": 315589998,
    "dropphyadd": "724 CHARLIE SMITH SR HWY",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "GA",
    "dropphyzpp": 315589998,
    "dropmaladd": "724 CHARLIE SMITH SR HWY",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "GA",
    "dropmalzpp": 315589998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127293301,
    "dropsitcph": 9127293301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11097",
    "droptype": "D",
    "dropname": "SALE CITY",
    "dropdeladd": "166 S BARNES ST",
    "dropdelcty": "SALE CITY",
    "dropdelst": "GA",
    "dropdelzpp": 317849998,
    "dropphyadd": "166 S BARNES ST",
    "dropphycty": "SALE CITY",
    "dropphyst": "GA",
    "dropphyzpp": 317849998,
    "dropmaladd": "166 S BARNES ST",
    "dropmalcty": "SALE CITY",
    "dropmalst": "GA",
    "dropmalzpp": 317849998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293367157,
    "dropsitcph": 2293367157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11100",
    "droptype": "D",
    "dropname": "SANDERSVILLE",
    "dropdeladd": "205 W CHURCH ST",
    "dropdelcty": "SANDERSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310829998,
    "dropphyadd": "205 W CHURCH ST",
    "dropphycty": "SANDERSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310829998,
    "dropmaladd": "205 W CHURCH ST",
    "dropmalcty": "SANDERSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310829998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785526636,
    "dropsitcph": 4785526636,
    "dropfax": 4785525109
  },
  {
    "dcode": "D",
    "dropkey": "PX11107",
    "droptype": "D",
    "dropname": "SAPELO ISLAND",
    "dropdeladd": "1 LONG TABBY LN",
    "dropdelcty": "SAPELO ISLAND",
    "dropdelst": "GA",
    "dropdelzpp": 313279998,
    "dropphyadd": "1 LONG TABBY LN",
    "dropphycty": "SAPELO ISLAND",
    "dropphyst": "GA",
    "dropphyzpp": 313279998,
    "dropmaladd": "1 LONG TABBY LN",
    "dropmalcty": "SAPELO ISLAND",
    "dropmalst": "GA",
    "dropmalzpp": 313279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124852122,
    "dropsitcph": 9124852122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11108",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "932 PERRY AVE",
    "dropdelcty": "SARDIS",
    "dropdelst": "GA",
    "dropdelzpp": 304569998,
    "dropphyadd": "932 PERRY AVE",
    "dropphycty": "SARDIS",
    "dropphyst": "GA",
    "dropphyzpp": 304569998,
    "dropmaladd": "932 PERRY AVE",
    "dropmalcty": "SARDIS",
    "dropmalst": "GA",
    "dropmalzpp": 304569998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785694668,
    "dropsitcph": 4785694668,
    "dropfax": 4785694668
  },
  {
    "dcode": "D",
    "dropkey": "PX11109",
    "droptype": "D",
    "dropname": "SARGENT",
    "dropdeladd": "374 HENRY BRYANT RD",
    "dropdelcty": "SARGENT",
    "dropdelst": "GA",
    "dropdelzpp": 302753840,
    "dropphyadd": "374 HENRY BRYANT RD",
    "dropphycty": "SARGENT",
    "dropphyst": "GA",
    "dropphyzpp": 302753840,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARGENT",
    "dropmalst": "GA",
    "dropmalzpp": 302759998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702539734,
    "dropsitcph": 7702539734,
    "dropfax": 7702539734
  },
  {
    "dcode": "D",
    "dropkey": "PX11110",
    "droptype": "D",
    "dropname": "SASSER",
    "dropdeladd": "135 E MAIN ST",
    "dropdelcty": "SASSER",
    "dropdelst": "GA",
    "dropdelzpp": 398859998,
    "dropphyadd": "135 E MAIN ST",
    "dropphycty": "SASSER",
    "dropphyst": "GA",
    "dropphyzpp": 398859998,
    "dropmaladd": "135 E MAIN ST",
    "dropmalcty": "SASSER",
    "dropmalst": "GA",
    "dropmalzpp": 398859998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296983630,
    "dropsitcph": 2296983630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11112",
    "droptype": "D",
    "dropname": "SAUTEE NACOOCHEE",
    "dropdeladd": "93 HIGHWAY 255 N",
    "dropdelcty": "SAUTEE NACOOCHEE",
    "dropdelst": "GA",
    "dropdelzpp": 305719998,
    "dropphyadd": "93 HIGHWAY 255 N",
    "dropphycty": "SAUTEE NACOOCHEE",
    "dropphyst": "GA",
    "dropphyzpp": 305719998,
    "dropmaladd": "93 HIGHWAY 255 N",
    "dropmalcty": "SAUTEE NACOOCHEE",
    "dropmalst": "GA",
    "dropmalzpp": 305719998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068782712,
    "dropsitcph": 7068782712,
    "dropfax": 7068782633
  },
  {
    "dcode": "D",
    "dropkey": "PX11117",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "974 MAIN ST",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "GA",
    "dropdelzpp": 310839997,
    "dropphyadd": "974 MAIN ST",
    "dropphycty": "SCOTLAND",
    "dropphyst": "GA",
    "dropphyzpp": 310839997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "GA",
    "dropmalzpp": 310839998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298682973,
    "dropsitcph": 2298682973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11118",
    "droptype": "D",
    "dropname": "SCOTTDALE",
    "dropdeladd": "3328 E PONCE DE LEON AVE",
    "dropdelcty": "SCOTTDALE",
    "dropdelst": "GA",
    "dropdelzpp": 300799998,
    "dropphyadd": "3328 E PONCE DE LEON AVE",
    "dropphycty": "SCOTTDALE",
    "dropphyst": "GA",
    "dropphyzpp": 300799998,
    "dropmaladd": "3328 E PONCE DE LEON AVE",
    "dropmalcty": "SCOTTDALE",
    "dropmalst": "GA",
    "dropmalzpp": 300799998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042963259,
    "dropsitcph": 4042963045,
    "dropfax": 4045010679
  },
  {
    "dcode": "D",
    "dropkey": "PX11120",
    "droptype": "D",
    "dropname": "SCREVEN",
    "dropdeladd": "117 W JL TYRE ST",
    "dropdelcty": "SCREVEN",
    "dropdelst": "GA",
    "dropdelzpp": 315609998,
    "dropphyadd": "117 W JL TYRE ST",
    "dropphycty": "SCREVEN",
    "dropphyst": "GA",
    "dropphyzpp": 315609998,
    "dropmaladd": "117 W JL TYRE ST",
    "dropmalcty": "SCREVEN",
    "dropmalst": "GA",
    "dropmalzpp": 315609998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125792320,
    "dropsitcph": 9125792320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11123",
    "droptype": "D",
    "dropname": "SENOIA",
    "dropdeladd": "68 BROAD ST",
    "dropdelcty": "SENOIA",
    "dropdelst": "GA",
    "dropdelzpp": 302769998,
    "dropphyadd": "68 BROAD ST",
    "dropphycty": "SENOIA",
    "dropphyst": "GA",
    "dropphyzpp": 302769998,
    "dropmaladd": "68 BROAD ST",
    "dropmalcty": "SENOIA",
    "dropmalst": "GA",
    "dropmalzpp": 302769998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705993251,
    "dropsitcph": 7705993251,
    "dropfax": 7705993895
  },
  {
    "dcode": "D",
    "dropkey": "PX11126",
    "droptype": "D",
    "dropname": "SHADY DALE",
    "dropdeladd": "22591 N MAIN ST",
    "dropdelcty": "SHADY DALE",
    "dropdelst": "GA",
    "dropdelzpp": 310859998,
    "dropphyadd": "22591 N MAIN ST",
    "dropphycty": "SHADY DALE",
    "dropphyst": "GA",
    "dropphyzpp": 310859998,
    "dropmaladd": "22591 N MAIN ST",
    "dropmalcty": "SHADY DALE",
    "dropmalst": "GA",
    "dropmalzpp": 310859998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064685828,
    "dropsitcph": 7064685828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11127",
    "droptype": "D",
    "dropname": "SHANNON",
    "dropdeladd": "361 BURLINGTON DR",
    "dropdelcty": "SHANNON",
    "dropdelst": "GA",
    "dropdelzpp": 301729800,
    "dropphyadd": "361 BURLINGTON DR",
    "dropphycty": "SHANNON",
    "dropphyst": "GA",
    "dropphyzpp": 301729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHANNON",
    "dropmalst": "GA",
    "dropmalzpp": 301729998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062955594,
    "dropsitcph": 7062955594,
    "dropfax": 7062955414
  },
  {
    "dcode": "D",
    "dropkey": "PX11129",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "116 RAYTOWN RD NE",
    "dropdelcty": "SHARON",
    "dropdelst": "GA",
    "dropdelzpp": 306643601,
    "dropphyadd": "116 RAYTOWN RD NE",
    "dropphycty": "SHARON",
    "dropphyst": "GA",
    "dropphyzpp": 306643601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARON",
    "dropmalst": "GA",
    "dropmalzpp": 306649998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064562283,
    "dropsitcph": 7064562283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11131",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "6545 HIGHWAY 54",
    "dropdelcty": "SHARPSBURG",
    "dropdelst": "GA",
    "dropdelzpp": 302779998,
    "dropphyadd": "6545 HIGHWAY 54",
    "dropphycty": "SHARPSBURG",
    "dropphyst": "GA",
    "dropphyzpp": 302779998,
    "dropmaladd": "6545 HIGHWAY 54",
    "dropmalcty": "SHARPSBURG",
    "dropmalst": "GA",
    "dropmalzpp": 302779998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702527874,
    "dropsitcph": 7702523409,
    "dropfax": 7702524255
  },
  {
    "dcode": "D",
    "dropkey": "PX11133",
    "droptype": "D",
    "dropname": "SHELLMAN",
    "dropdeladd": "3247 PEARL ST",
    "dropdelcty": "SHELLMAN",
    "dropdelst": "GA",
    "dropdelzpp": 398869997,
    "dropphyadd": "3247 PEARL ST",
    "dropphycty": "SHELLMAN",
    "dropphyst": "GA",
    "dropphyzpp": 398869997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELLMAN",
    "dropmalst": "GA",
    "dropmalzpp": 398869998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2296795115,
    "dropsitcph": 2296795115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11135",
    "droptype": "D",
    "dropname": "SHILOH",
    "dropdeladd": "21901 GA HIGHWAY 116",
    "dropdelcty": "SHILOH",
    "dropdelst": "GA",
    "dropdelzpp": 318269998,
    "dropphyadd": "21901 GA HIGHWAY 116",
    "dropphycty": "SHILOH",
    "dropphyst": "GA",
    "dropphyzpp": 318269998,
    "dropmaladd": "21901 GA HIGHWAY 116",
    "dropmalcty": "SHILOH",
    "dropmalst": "GA",
    "dropmalzpp": 318269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7068462309,
    "dropsitcph": 7068462309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11139",
    "droptype": "D",
    "dropname": "SILOAM",
    "dropdeladd": "4490 HIGHWAY 15 S",
    "dropdelcty": "SILOAM",
    "dropdelst": "GA",
    "dropdelzpp": 306659800,
    "dropphyadd": "4490 HIGHWAY 15 S",
    "dropphycty": "SILOAM",
    "dropphyst": "GA",
    "dropphyzpp": 306659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILOAM",
    "dropmalst": "GA",
    "dropmalzpp": 306659998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064672322,
    "dropsitcph": 7064672322,
    "dropfax": 7064679304
  },
  {
    "dcode": "D",
    "dropkey": "PX11140",
    "droptype": "D",
    "dropname": "SILVER CREEK",
    "dropdeladd": "4565 ROCKMART RD SE",
    "dropdelcty": "SILVER CREEK",
    "dropdelst": "GA",
    "dropdelzpp": 301739998,
    "dropphyadd": "4565 ROCKMART RD SE",
    "dropphycty": "SILVER CREEK",
    "dropphyst": "GA",
    "dropphyzpp": 301739998,
    "dropmaladd": "4565 ROCKMART RD SE",
    "dropmalcty": "SILVER CREEK",
    "dropmalst": "GA",
    "dropmalzpp": 301739998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062351351,
    "dropsitcph": 7062350319,
    "dropfax": 7062351604
  },
  {
    "dcode": "D",
    "dropkey": "PX11149",
    "droptype": "D",
    "dropname": "SMARR",
    "dropdeladd": "2783 US HIGHWAY 41 S",
    "dropdelcty": "SMARR",
    "dropdelst": "GA",
    "dropdelzpp": 310869998,
    "dropphyadd": "2783 US HIGHWAY 41 S",
    "dropphycty": "SMARR",
    "dropphyst": "GA",
    "dropphyzpp": 310869998,
    "dropmaladd": "2783 US HIGHWAY 41 S",
    "dropmalcty": "SMARR",
    "dropmalst": "GA",
    "dropmalzpp": 310869998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789944284,
    "dropsitcph": 4789944284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11150",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "103 LE CONTE ST",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 317879998,
    "dropphyadd": "103 LE CONTE ST",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 317879998,
    "dropmaladd": "103 LE CONTE ST",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 317879998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298466603,
    "dropsitcph": 2298466603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11152",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "850 WINDY HILL RD SE",
    "dropdelcty": "SMYRNA",
    "dropdelst": "GA",
    "dropdelzpp": 300801910,
    "dropphyadd": "850 WINDY HILL RD SE",
    "dropphycty": "SMYRNA",
    "dropphyst": "GA",
    "dropphyzpp": 300801910,
    "dropmaladd": "850 WINDY HILL RD SE",
    "dropmalcty": "SMYRNA",
    "dropmalst": "GA",
    "dropmalzpp": 300801910,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704359905,
    "dropsitcph": 7704359508,
    "dropfax": 7704386506
  },
  {
    "dcode": "D",
    "dropkey": "PX11154",
    "droptype": "D",
    "dropname": "SNELLVILLE",
    "dropdeladd": "2440 WISTERIA DR",
    "dropdelcty": "SNELLVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300783326,
    "dropphyadd": "2440 WISTERIA DR",
    "dropphycty": "SNELLVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300783326,
    "dropmaladd": "2440 WISTERIA DR",
    "dropmalcty": "SNELLVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300783326,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702252271,
    "dropsitcph": 7702252271,
    "dropfax": 7709724799
  },
  {
    "dcode": "D",
    "dropkey": "PX11160",
    "droptype": "D",
    "dropname": "SOCIAL CIRCLE",
    "dropdeladd": "125 W HIGHTOWER TRL",
    "dropdelcty": "SOCIAL CIRCLE",
    "dropdelst": "GA",
    "dropdelzpp": 300259998,
    "dropphyadd": "125 W HIGHTOWER TRL",
    "dropphycty": "SOCIAL CIRCLE",
    "dropphyst": "GA",
    "dropphyzpp": 300259998,
    "dropmaladd": "125 W HIGHTOWER TRL",
    "dropmalcty": "SOCIAL CIRCLE",
    "dropmalst": "GA",
    "dropmalzpp": 300259998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704643783,
    "dropsitcph": 7704643783,
    "dropfax": 7704641403
  },
  {
    "dcode": "D",
    "dropkey": "PX11161",
    "droptype": "D",
    "dropname": "SOPERTON",
    "dropdeladd": "5059 S THIRD ST",
    "dropdelcty": "SOPERTON",
    "dropdelst": "GA",
    "dropdelzpp": 304579998,
    "dropphyadd": "5059 S THIRD ST",
    "dropphycty": "SOPERTON",
    "dropphyst": "GA",
    "dropphyzpp": 304579998,
    "dropmaladd": "5059 S THIRD ST",
    "dropmalcty": "SOPERTON",
    "dropmalst": "GA",
    "dropmalzpp": 304579998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123611018,
    "dropsitcph": 9123611018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11173",
    "droptype": "D",
    "dropname": "SPARKS",
    "dropdeladd": "102 S GOODMAN ST",
    "dropdelcty": "SPARKS",
    "dropdelst": "GA",
    "dropdelzpp": 316479998,
    "dropphyadd": "102 S GOODMAN ST",
    "dropphycty": "SPARKS",
    "dropphyst": "GA",
    "dropphyzpp": 316479998,
    "dropmaladd": "102 S GOODMAN ST",
    "dropmalcty": "SPARKS",
    "dropmalst": "GA",
    "dropmalzpp": 316479998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295497238,
    "dropsitcph": 2295497238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11174",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "12877 BROAD ST STE 102",
    "dropdelcty": "SPARTA",
    "dropdelst": "GA",
    "dropdelzpp": 310871742,
    "dropphyadd": "12877 BROAD ST STE 102",
    "dropphycty": "SPARTA",
    "dropphyst": "GA",
    "dropphyzpp": 310871742,
    "dropmaladd": "12877 BROAD ST STE 102",
    "dropmalcty": "SPARTA",
    "dropmalst": "GA",
    "dropmalzpp": 310871742,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064447788,
    "dropsitcph": 7064447788,
    "dropfax": 7064448076
  },
  {
    "dcode": "D",
    "dropkey": "PX11178",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "708 S LAUREL ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "GA",
    "dropdelzpp": 313299998,
    "dropphyadd": "708 S LAUREL ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "GA",
    "dropphyzpp": 313299998,
    "dropmaladd": "708 S LAUREL ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "GA",
    "dropmalzpp": 313299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127549810,
    "dropsitcph": 9127549810,
    "dropfax": 9127541123
  },
  {
    "dcode": "D",
    "dropkey": "PX11207",
    "droptype": "D",
    "dropname": "STAPLETON",
    "dropdeladd": "135 E MAIN ST",
    "dropdelcty": "STAPLETON",
    "dropdelst": "GA",
    "dropdelzpp": 308239998,
    "dropphyadd": "135 E MAIN ST",
    "dropphycty": "STAPLETON",
    "dropphyst": "GA",
    "dropphyzpp": 308239998,
    "dropmaladd": "135 E MAIN ST",
    "dropmalcty": "STAPLETON",
    "dropmalst": "GA",
    "dropmalzpp": 308239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065472121,
    "dropsitcph": 7065472121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11213",
    "droptype": "D",
    "dropname": "STATENVILLE",
    "dropdeladd": "113 GA HIGHWAY 94 E",
    "dropdelcty": "STATENVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 316489998,
    "dropphyadd": "113 GA HIGHWAY 94 E",
    "dropphycty": "STATENVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 316489998,
    "dropmaladd": "113 GA HIGHWAY 94 E",
    "dropmalcty": "STATENVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 316489998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2295597359,
    "dropsitcph": 2295597359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11214",
    "droptype": "D",
    "dropname": "STATESBORO",
    "dropdeladd": "1 S COLLEGE ST",
    "dropdelcty": "STATESBORO",
    "dropdelst": "GA",
    "dropdelzpp": 304589998,
    "dropphyadd": "1 S COLLEGE ST",
    "dropphycty": "STATESBORO",
    "dropphyst": "GA",
    "dropphyzpp": 304589998,
    "dropmaladd": "1 S COLLEGE ST",
    "dropmalcty": "STATESBORO",
    "dropmalst": "GA",
    "dropmalzpp": 304589998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124897592,
    "dropsitcph": 9124897592,
    "dropfax": 9124891859
  },
  {
    "dcode": "D",
    "dropkey": "PX11215",
    "droptype": "D",
    "dropname": "STATHAM",
    "dropdeladd": "1972 RAILROAD ST",
    "dropdelcty": "STATHAM",
    "dropdelst": "GA",
    "dropdelzpp": 306669998,
    "dropphyadd": "1972 RAILROAD ST",
    "dropphycty": "STATHAM",
    "dropphyst": "GA",
    "dropphyzpp": 306669998,
    "dropmaladd": "1972 RAILROAD ST",
    "dropmalcty": "STATHAM",
    "dropmalst": "GA",
    "dropmalzpp": 306669998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707257507,
    "dropsitcph": 7707258940,
    "dropfax": 7707259356
  },
  {
    "dcode": "D",
    "dropkey": "PX11216",
    "droptype": "D",
    "dropname": "STEPHENS",
    "dropdeladd": "187 RAILROAD RD",
    "dropdelcty": "STEPHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306679998,
    "dropphyadd": "187 RAILROAD RD",
    "dropphycty": "STEPHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306679998,
    "dropmaladd": "187 RAILROAD RD",
    "dropmalcty": "STEPHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306679998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067593309,
    "dropsitcph": 7067593309,
    "dropfax": 7067593974
  },
  {
    "dcode": "D",
    "dropkey": "PX11219",
    "droptype": "D",
    "dropname": "STILLMORE",
    "dropdeladd": "205 N 2ND ST",
    "dropdelcty": "STILLMORE",
    "dropdelst": "GA",
    "dropdelzpp": 304649998,
    "dropphyadd": "205 N 2ND ST",
    "dropphycty": "STILLMORE",
    "dropphyst": "GA",
    "dropphyzpp": 304649998,
    "dropmaladd": "205 N 2ND ST",
    "dropmalcty": "STILLMORE",
    "dropmalst": "GA",
    "dropmalzpp": 304649998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125623247,
    "dropsitcph": 9125623247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11223",
    "droptype": "D",
    "dropname": "STOCKBRIDGE",
    "dropdeladd": "110 WALTER WAY",
    "dropdelcty": "STOCKBRIDGE",
    "dropdelst": "GA",
    "dropdelzpp": 302819998,
    "dropphyadd": "110 WALTER WAY",
    "dropphycty": "STOCKBRIDGE",
    "dropphyst": "GA",
    "dropphyzpp": 302819998,
    "dropmaladd": "110 WALTER WAY",
    "dropmalcty": "STOCKBRIDGE",
    "dropmalst": "GA",
    "dropmalzpp": 302819998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703899896,
    "dropsitcph": 7705075483,
    "dropfax": 7704740246
  },
  {
    "dcode": "D",
    "dropkey": "PX11224",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "417 W HIGHWAY 84",
    "dropdelcty": "STOCKTON",
    "dropdelst": "GA",
    "dropdelzpp": 316499997,
    "dropphyadd": "417 W HIGHWAY 84",
    "dropphycty": "STOCKTON",
    "dropphyst": "GA",
    "dropphyzpp": 316499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKTON",
    "dropmalst": "GA",
    "dropmalzpp": 316499998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292444768,
    "dropsitcph": 2292444768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11225",
    "droptype": "D",
    "dropname": "STONE MOUNTAIN",
    "dropdeladd": "5181 W MOUNTAIN ST",
    "dropdelcty": "STONE MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 300839998,
    "dropphyadd": "5181 W MOUNTAIN ST",
    "dropphycty": "STONE MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 300839998,
    "dropmaladd": "5181 W MOUNTAIN ST",
    "dropmalcty": "STONE MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 300839998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704982828,
    "dropsitcph": 7704988405,
    "dropfax": 7704980013
  },
  {
    "dcode": "D",
    "dropkey": "PX11228",
    "droptype": "D",
    "dropname": "SUCHES",
    "dropdeladd": "2078 STATE HIGHWAY 60",
    "dropdelcty": "SUCHES",
    "dropdelst": "GA",
    "dropdelzpp": 305729998,
    "dropphyadd": "2078 STATE HIGHWAY 60",
    "dropphycty": "SUCHES",
    "dropphyst": "GA",
    "dropphyzpp": 305729998,
    "dropmaladd": "2078 STATE HIGHWAY 60",
    "dropmalcty": "SUCHES",
    "dropmalst": "GA",
    "dropmalzpp": 305729998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067472611,
    "dropsitcph": 7067472611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11231",
    "droptype": "D",
    "dropname": "SUGAR VALLEY",
    "dropdeladd": "155 MAIN ST NW",
    "dropdelcty": "SUGAR VALLEY",
    "dropdelst": "GA",
    "dropdelzpp": 307469998,
    "dropphyadd": "155 MAIN ST NW",
    "dropphycty": "SUGAR VALLEY",
    "dropphyst": "GA",
    "dropphyzpp": 307469998,
    "dropmaladd": "155 MAIN ST NW",
    "dropmalcty": "SUGAR VALLEY",
    "dropmalst": "GA",
    "dropmalzpp": 307469998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066299992,
    "dropsitcph": 7066299992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11234",
    "droptype": "D",
    "dropname": "SUMMERVILLE",
    "dropdeladd": "9922 COMMERCE ST",
    "dropdelcty": "SUMMERVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 307479998,
    "dropphyadd": "9922 COMMERCE ST",
    "dropphycty": "SUMMERVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 307479998,
    "dropmaladd": "9922 COMMERCE ST",
    "dropmalcty": "SUMMERVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 307479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068575178,
    "dropsitcph": 7068575178,
    "dropfax": 7068576832
  },
  {
    "dcode": "D",
    "dropkey": "PX11237",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "GA",
    "dropdelzpp": 317899998,
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "SUMNER",
    "dropphyst": "GA",
    "dropphyzpp": 317899998,
    "dropmaladd": "501 MAIN ST",
    "dropmalcty": "SUMNER",
    "dropmalst": "GA",
    "dropmalzpp": 317899998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297777820,
    "dropsitcph": 2297777820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11239",
    "droptype": "D",
    "dropname": "SUNNY SIDE",
    "dropdeladd": "3980 NORTH EXPY",
    "dropdelcty": "SUNNY SIDE",
    "dropdelst": "GA",
    "dropdelzpp": 302842539,
    "dropphyadd": "3980 NORTH EXPY",
    "dropphycty": "SUNNY SIDE",
    "dropphyst": "GA",
    "dropphyzpp": 302842539,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNNY SIDE",
    "dropmalst": "GA",
    "dropmalzpp": 302849998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702276747,
    "dropsitcph": 7702276747,
    "dropfax": 7702274799
  },
  {
    "dcode": "D",
    "dropkey": "PX11240",
    "droptype": "D",
    "dropname": "SURRENCY",
    "dropdeladd": "117 GA HIGHWAY 121 SE",
    "dropdelcty": "SURRENCY",
    "dropdelst": "GA",
    "dropdelzpp": 315639998,
    "dropphyadd": "117 GA HIGHWAY 121 SE",
    "dropphycty": "SURRENCY",
    "dropphyst": "GA",
    "dropphyzpp": 315639998,
    "dropmaladd": "117 GA HIGHWAY 121 SE",
    "dropmalcty": "SURRENCY",
    "dropmalst": "GA",
    "dropmalzpp": 315639998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123677704,
    "dropsitcph": 9123677704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11242",
    "droptype": "D",
    "dropname": "SUWANEE",
    "dropdeladd": "990 PEACHTREE INDUSTRIAL BLVD",
    "dropdelcty": "SUWANEE",
    "dropdelst": "GA",
    "dropdelzpp": 300249998,
    "dropphyadd": "990 PEACHTREE INDUSTRIAL BLVD",
    "dropphycty": "SUWANEE",
    "dropphyst": "GA",
    "dropphyzpp": 300249998,
    "dropmaladd": "990 PEACHTREE INDUSTRIAL BLVD",
    "dropmalcty": "SUWANEE",
    "dropmalst": "GA",
    "dropmalzpp": 300249998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784828391,
    "dropsitcph": 6784828421,
    "dropfax": 6784828467
  },
  {
    "dcode": "D",
    "dropkey": "PX11244",
    "droptype": "D",
    "dropname": "SWAINSBORO",
    "dropdeladd": "211 W MORING ST",
    "dropdelcty": "SWAINSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 304019998,
    "dropphyadd": "211 W MORING ST",
    "dropphycty": "SWAINSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 304019998,
    "dropmaladd": "211 W MORING ST",
    "dropmalcty": "SWAINSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 304019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782379689,
    "dropsitcph": 4782379689,
    "dropfax": 4782379070
  },
  {
    "dcode": "D",
    "dropkey": "PX11246",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "33 W JEWETT ST",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "GA",
    "dropdelzpp": 317909998,
    "dropphyadd": "33 W JEWETT ST",
    "dropphycty": "SYCAMORE",
    "dropphyst": "GA",
    "dropphyzpp": 317909998,
    "dropmaladd": "33 W JEWETT ST",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "GA",
    "dropmalzpp": 317909998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295673770,
    "dropsitcph": 2295673770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11247",
    "droptype": "D",
    "dropname": "SYLVANIA",
    "dropdeladd": "113 S MAIN ST",
    "dropdelcty": "SYLVANIA",
    "dropdelst": "GA",
    "dropdelzpp": 304679998,
    "dropphyadd": "113 S MAIN ST",
    "dropphycty": "SYLVANIA",
    "dropphyst": "GA",
    "dropphyzpp": 304679998,
    "dropmaladd": "113 S MAIN ST",
    "dropmalcty": "SYLVANIA",
    "dropmalst": "GA",
    "dropmalzpp": 304679998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125645887,
    "dropsitcph": 9125645887,
    "dropfax": 9125642942
  },
  {
    "dcode": "D",
    "dropkey": "PX11248",
    "droptype": "D",
    "dropname": "SYLVESTER",
    "dropdeladd": "404 HARDY ST",
    "dropdelcty": "SYLVESTER",
    "dropdelst": "GA",
    "dropdelzpp": 317919998,
    "dropphyadd": "404 HARDY ST",
    "dropphycty": "SYLVESTER",
    "dropphyst": "GA",
    "dropphyzpp": 317919998,
    "dropmaladd": "404 HARDY ST",
    "dropmalcty": "SYLVESTER",
    "dropmalst": "GA",
    "dropmalzpp": 317919998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2297763192,
    "dropsitcph": 2297763192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11249",
    "droptype": "D",
    "dropname": "TALBOTTON",
    "dropdeladd": "8 S JEFFERSON AVE",
    "dropdelcty": "TALBOTTON",
    "dropdelst": "GA",
    "dropdelzpp": 318279998,
    "dropphyadd": "8 S JEFFERSON AVE",
    "dropphycty": "TALBOTTON",
    "dropphyst": "GA",
    "dropphyzpp": 318279998,
    "dropmaladd": "8 S JEFFERSON AVE",
    "dropmalcty": "TALBOTTON",
    "dropmalst": "GA",
    "dropmalzpp": 318279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066658655,
    "dropsitcph": 7066658655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11251",
    "droptype": "D",
    "dropname": "TALKING ROCK",
    "dropdeladd": "100 ANTIOCH CHURCH RD",
    "dropdelcty": "TALKING ROCK",
    "dropdelst": "GA",
    "dropdelzpp": 301759998,
    "dropphyadd": "100 ANTIOCH CHURCH RD",
    "dropphycty": "TALKING ROCK",
    "dropphyst": "GA",
    "dropphyzpp": 301759998,
    "dropmaladd": "100 ANTIOCH CHURCH RD",
    "dropmalcty": "TALKING ROCK",
    "dropmalst": "GA",
    "dropmalzpp": 301759998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062764197,
    "dropsitcph": 7062764197,
    "dropfax": 7062534273
  },
  {
    "dcode": "D",
    "dropkey": "PX11252",
    "droptype": "D",
    "dropname": "TALLAPOOSA",
    "dropdeladd": "1919 US HIGHWAY 78",
    "dropdelcty": "TALLAPOOSA",
    "dropdelst": "GA",
    "dropdelzpp": 301769998,
    "dropphyadd": "1919 US HIGHWAY 78",
    "dropphycty": "TALLAPOOSA",
    "dropphyst": "GA",
    "dropphyzpp": 301769998,
    "dropmaladd": "1919 US HIGHWAY 78",
    "dropmalcty": "TALLAPOOSA",
    "dropmalst": "GA",
    "dropmalzpp": 301769998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705748755,
    "dropsitcph": 7705747095,
    "dropfax": 7705748927
  },
  {
    "dcode": "D",
    "dropkey": "PX11253",
    "droptype": "D",
    "dropname": "TALLULAH FALLS",
    "dropdeladd": "235 MAIN ST",
    "dropdelcty": "TALLULAH FALLS",
    "dropdelst": "GA",
    "dropdelzpp": 305739800,
    "dropphyadd": "235 MAIN ST",
    "dropphycty": "TALLULAH FALLS",
    "dropphyst": "GA",
    "dropphyzpp": 305739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALLULAH FALLS",
    "dropmalst": "GA",
    "dropmalzpp": 305739998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067546011,
    "dropsitcph": 7067546011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11255",
    "droptype": "D",
    "dropname": "TALMO",
    "dropdeladd": "526 MAIN ST",
    "dropdelcty": "TALMO",
    "dropdelst": "GA",
    "dropdelzpp": 305759998,
    "dropphyadd": "526 MAIN ST",
    "dropphycty": "TALMO",
    "dropphyst": "GA",
    "dropphyzpp": 305759998,
    "dropmaladd": "526 MAIN ST",
    "dropmalcty": "TALMO",
    "dropmalst": "GA",
    "dropmalzpp": 305759998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066932666,
    "dropsitcph": 7066932666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11256",
    "droptype": "D",
    "dropname": "TARRYTOWN",
    "dropdeladd": "431 MAIN ST",
    "dropdelcty": "TARRYTOWN",
    "dropdelst": "GA",
    "dropdelzpp": 304709998,
    "dropphyadd": "431 MAIN ST",
    "dropphycty": "TARRYTOWN",
    "dropphyst": "GA",
    "dropphyzpp": 304709998,
    "dropmaladd": "431 MAIN ST",
    "dropmalcty": "TARRYTOWN",
    "dropmalst": "GA",
    "dropmalzpp": 304709998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122990023,
    "dropsitcph": 9122990023,
    "dropfax": 9125294888
  },
  {
    "dcode": "D",
    "dropkey": "PX11257",
    "droptype": "D",
    "dropname": "TATE",
    "dropdeladd": "4817 HIGHWAY 53 E",
    "dropdelcty": "TATE",
    "dropdelst": "GA",
    "dropdelzpp": 301772533,
    "dropphyadd": "4817 HIGHWAY 53 E",
    "dropphycty": "TATE",
    "dropphyst": "GA",
    "dropphyzpp": 301772533,
    "dropmaladd": "4817 HIGHWAY 53 E STE E",
    "dropmalcty": "TATE",
    "dropmalst": "GA",
    "dropmalzpp": 301779998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707353527,
    "dropsitcph": 7707353527,
    "dropfax": 7707356649
  },
  {
    "dcode": "D",
    "dropkey": "PX11258",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "61 MADDEN ST",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301789998,
    "dropphyadd": "61 MADDEN ST",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301789998,
    "dropmaladd": "61 MADDEN ST",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301789998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706846083,
    "dropsitcph": 7706846083,
    "dropfax": 7706840939
  },
  {
    "dcode": "D",
    "dropkey": "PX11262",
    "droptype": "D",
    "dropname": "TEMPLE",
    "dropdeladd": "68 JAMES ST",
    "dropdelcty": "TEMPLE",
    "dropdelst": "GA",
    "dropdelzpp": 301799998,
    "dropphyadd": "68 JAMES ST",
    "dropphycty": "TEMPLE",
    "dropphyst": "GA",
    "dropphyzpp": 301799998,
    "dropmaladd": "68 JAMES ST",
    "dropmalcty": "TEMPLE",
    "dropmalst": "GA",
    "dropmalzpp": 301799998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705622760,
    "dropsitcph": 7705623156,
    "dropfax": 7705622133
  },
  {
    "dcode": "D",
    "dropkey": "PX11263",
    "droptype": "D",
    "dropname": "TENNGA",
    "dropdeladd": "57 TENNGA GREGORY RD",
    "dropdelcty": "TENNGA",
    "dropdelst": "GA",
    "dropdelzpp": 307519998,
    "dropphyadd": "57 TENNGA GREGORY RD",
    "dropphycty": "TENNGA",
    "dropphyst": "GA",
    "dropphyzpp": 307519998,
    "dropmaladd": "57 TENNGA GREGORY RD",
    "dropmalcty": "TENNGA",
    "dropmalst": "GA",
    "dropmalzpp": 307519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7063283054,
    "dropsitcph": 7063283054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11264",
    "droptype": "D",
    "dropname": "TENNILLE",
    "dropdeladd": "131 SMITH ST",
    "dropdelcty": "TENNILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310899998,
    "dropphyadd": "131 SMITH ST",
    "dropphycty": "TENNILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310899998,
    "dropmaladd": "131 SMITH ST",
    "dropmalcty": "TENNILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310899998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785520478,
    "dropsitcph": 4785520478,
    "dropfax": 4785539902
  },
  {
    "dcode": "D",
    "dropkey": "PX11267",
    "droptype": "D",
    "dropname": "THE ROCK",
    "dropdeladd": "4674 W MAIN ST",
    "dropdelcty": "THE ROCK",
    "dropdelst": "GA",
    "dropdelzpp": 302859800,
    "dropphyadd": "4674 W MAIN ST",
    "dropphycty": "THE ROCK",
    "dropphyst": "GA",
    "dropphyzpp": 302859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THE ROCK",
    "dropmalst": "GA",
    "dropmalzpp": 302859998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066474558,
    "dropsitcph": 7066474558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11268",
    "droptype": "D",
    "dropname": "THOMASTON",
    "dropdeladd": "103 E THOMPSON ST",
    "dropdelcty": "THOMASTON",
    "dropdelst": "GA",
    "dropdelzpp": 302869998,
    "dropphyadd": "103 E THOMPSON ST",
    "dropphycty": "THOMASTON",
    "dropphyst": "GA",
    "dropphyzpp": 302869998,
    "dropmaladd": "103 E THOMPSON ST",
    "dropmalcty": "THOMASTON",
    "dropmalst": "GA",
    "dropmalzpp": 302869998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066479633,
    "dropsitcph": 7066479633,
    "dropfax": 7066476752
  },
  {
    "dcode": "D",
    "dropkey": "PX11269",
    "droptype": "D",
    "dropname": "THOMASVILLE",
    "dropdeladd": "404 N BROAD ST STE 101",
    "dropdelcty": "THOMASVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 317929998,
    "dropphyadd": "404 N BROAD ST STE 101",
    "dropphycty": "THOMASVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 317929998,
    "dropmaladd": "404 N BROAD ST STE 101",
    "dropmalcty": "THOMASVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 317929998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2292270152,
    "dropsitcph": 2292270152,
    "dropfax": 2292260227
  },
  {
    "dcode": "D",
    "dropkey": "PX11270",
    "droptype": "D",
    "dropname": "THOMSON",
    "dropdeladd": "223 JACKSON ST",
    "dropdelcty": "THOMSON",
    "dropdelst": "GA",
    "dropdelzpp": 308249998,
    "dropphyadd": "223 JACKSON ST",
    "dropphycty": "THOMSON",
    "dropphyst": "GA",
    "dropphyzpp": 308249998,
    "dropmaladd": "223 JACKSON ST",
    "dropmalcty": "THOMSON",
    "dropmalst": "GA",
    "dropmalzpp": 308249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065952441,
    "dropsitcph": 7065952441,
    "dropfax": 7065952441
  },
  {
    "dcode": "D",
    "dropkey": "PX11274",
    "droptype": "D",
    "dropname": "TIFTON",
    "dropdeladd": "205 JOHN HOWARD WAY",
    "dropdelcty": "TIFTON",
    "dropdelst": "GA",
    "dropdelzpp": 317949998,
    "dropphyadd": "205 JOHN HOWARD WAY",
    "dropphycty": "TIFTON",
    "dropphyst": "GA",
    "dropphyzpp": 317949998,
    "dropmaladd": "205 JOHN HOWARD WAY",
    "dropmalcty": "TIFTON",
    "dropmalst": "GA",
    "dropmalzpp": 317949998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293821546,
    "dropsitcph": 2293821546,
    "dropfax": 2293820076
  },
  {
    "dcode": "D",
    "dropkey": "PX11275",
    "droptype": "D",
    "dropname": "TIGER",
    "dropdeladd": "3278 OLD 441 S",
    "dropdelcty": "TIGER",
    "dropdelst": "GA",
    "dropdelzpp": 305769998,
    "dropphyadd": "3278 OLD 441 S",
    "dropphycty": "TIGER",
    "dropphyst": "GA",
    "dropphyzpp": 305769998,
    "dropmaladd": "3278 OLD 441 S",
    "dropmalcty": "TIGER",
    "dropmalst": "GA",
    "dropmalzpp": 305769998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067825464,
    "dropsitcph": 7067825464,
    "dropfax": 7067829886
  },
  {
    "dcode": "D",
    "dropkey": "PX11276",
    "droptype": "D",
    "dropname": "TIGNALL",
    "dropdeladd": "128 S HULIN AVE",
    "dropdelcty": "TIGNALL",
    "dropdelst": "GA",
    "dropdelzpp": 306689998,
    "dropphyadd": "128 S HULIN AVE",
    "dropphycty": "TIGNALL",
    "dropphyst": "GA",
    "dropphyzpp": 306689998,
    "dropmaladd": "128 S HULIN AVE",
    "dropmalcty": "TIGNALL",
    "dropmalst": "GA",
    "dropmalzpp": 306689998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062852582,
    "dropsitcph": 7062852582,
    "dropfax": 7062853424
  },
  {
    "dcode": "D",
    "dropkey": "PX11278",
    "droptype": "D",
    "dropname": "TOCCOA",
    "dropdeladd": "41 FALLS RD STE 101",
    "dropdelcty": "TOCCOA",
    "dropdelst": "GA",
    "dropdelzpp": 305779998,
    "dropphyadd": "41 FALLS RD STE 101",
    "dropphycty": "TOCCOA",
    "dropphyst": "GA",
    "dropphyzpp": 305779998,
    "dropmaladd": "41 FALLS RD STE 101",
    "dropmalcty": "TOCCOA",
    "dropmalst": "GA",
    "dropmalzpp": 305779998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7068866404,
    "dropsitcph": 7068864058,
    "dropfax": 7068867474
  },
  {
    "dcode": "D",
    "dropkey": "PX11284",
    "droptype": "D",
    "dropname": "TOOMSBORO",
    "dropdeladd": "153 MAIN ST",
    "dropdelcty": "TOOMSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 310909998,
    "dropphyadd": "153 MAIN ST",
    "dropphycty": "TOOMSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 310909998,
    "dropmaladd": "153 MAIN ST",
    "dropmalcty": "TOOMSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 310909998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4789335957,
    "dropsitcph": 4789335957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11285",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "1219 GA HIGHWAY 57",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "GA",
    "dropdelzpp": 313319998,
    "dropphyadd": "1219 GA HIGHWAY 57",
    "dropphycty": "TOWNSEND",
    "dropphyst": "GA",
    "dropphyzpp": 313319998,
    "dropmaladd": "1219 GA HIGHWAY 57",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "GA",
    "dropmalzpp": 313319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128326149,
    "dropsitcph": 9128326149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11287",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "12441 N MAIN ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "GA",
    "dropdelzpp": 307529998,
    "dropphyadd": "12441 N MAIN ST",
    "dropphycty": "TRENTON",
    "dropphyst": "GA",
    "dropphyzpp": 307529998,
    "dropmaladd": "12441 N MAIN ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "GA",
    "dropmalzpp": 307529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066572917,
    "dropsitcph": 7066574751,
    "dropfax": 7066577436
  },
  {
    "dcode": "D",
    "dropkey": "PX11289",
    "droptype": "D",
    "dropname": "TRION",
    "dropdeladd": "14366 HIGHWAY 27",
    "dropdelcty": "TRION",
    "dropdelst": "GA",
    "dropdelzpp": 307539998,
    "dropphyadd": "14366 HIGHWAY 27",
    "dropphycty": "TRION",
    "dropphyst": "GA",
    "dropphyzpp": 307539998,
    "dropmaladd": "14366 HIGHWAY 27",
    "dropmalcty": "TRION",
    "dropmalst": "GA",
    "dropmalzpp": 307539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7067343786,
    "dropsitcph": 7067342441,
    "dropfax": 7067342707
  },
  {
    "dcode": "D",
    "dropkey": "PX11291",
    "droptype": "D",
    "dropname": "TUCKER",
    "dropdeladd": "4325 1ST AVE",
    "dropdelcty": "TUCKER",
    "dropdelst": "GA",
    "dropdelzpp": 300849998,
    "dropphyadd": "4325 1ST AVE",
    "dropphycty": "TUCKER",
    "dropphyst": "GA",
    "dropphyzpp": 300849998,
    "dropmaladd": "4325 1ST AVE",
    "dropmalcty": "TUCKER",
    "dropmalst": "GA",
    "dropmalzpp": 300849998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709345363,
    "dropsitcph": 7709342768,
    "dropfax": 7709345519
  },
  {
    "dcode": "D",
    "dropkey": "PX11293",
    "droptype": "D",
    "dropname": "TUNNEL HILL",
    "dropdeladd": "106 S VARNELL RD",
    "dropdelcty": "TUNNEL HILL",
    "dropdelst": "GA",
    "dropdelzpp": 307559998,
    "dropphyadd": "106 S VARNELL RD",
    "dropphycty": "TUNNEL HILL",
    "dropphyst": "GA",
    "dropphyzpp": 307559998,
    "dropmaladd": "106 S VARNELL RD",
    "dropmalcty": "TUNNEL HILL",
    "dropmalst": "GA",
    "dropmalzpp": 307559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066735112,
    "dropsitcph": 7066735112,
    "dropfax": 7066736659
  },
  {
    "dcode": "D",
    "dropkey": "PX11295",
    "droptype": "D",
    "dropname": "TURIN",
    "dropdeladd": "14 S HUNTER ST",
    "dropdelcty": "TURIN",
    "dropdelst": "GA",
    "dropdelzpp": 302893403,
    "dropphyadd": "14 S HUNTER ST",
    "dropphycty": "TURIN",
    "dropphyst": "GA",
    "dropphyzpp": 302893403,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURIN",
    "dropmalst": "GA",
    "dropmalzpp": 302899998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705996585,
    "dropsitcph": 7705996585,
    "dropfax": 7708996585
  },
  {
    "dcode": "D",
    "dropkey": "PX11296",
    "droptype": "D",
    "dropname": "TURNERVILLE",
    "dropdeladd": "1083 THACKER RD",
    "dropdelcty": "TURNERVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305802410,
    "dropphyadd": "1083 THACKER RD",
    "dropphycty": "TURNERVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305802410,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURNERVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305809998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067546162,
    "dropsitcph": 7067546162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11300",
    "droptype": "D",
    "dropname": "TWIN CITY",
    "dropdeladd": "227 OLD SWAINSBORO RD",
    "dropdelcty": "TWIN CITY",
    "dropdelst": "GA",
    "dropdelzpp": 304719998,
    "dropphyadd": "227 OLD SWAINSBORO RD",
    "dropphycty": "TWIN CITY",
    "dropphyst": "GA",
    "dropphyzpp": 304719998,
    "dropmaladd": "227 OLD SWAINSBORO RD",
    "dropmalcty": "TWIN CITY",
    "dropmalst": "GA",
    "dropmalzpp": 304719998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787632295,
    "dropsitcph": 4787632295,
    "dropfax": 4787633954
  },
  {
    "dcode": "D",
    "dropkey": "PX11301",
    "droptype": "D",
    "dropname": "TY TY",
    "dropdeladd": "103 N PICKETT ST",
    "dropdelcty": "TY TY",
    "dropdelst": "GA",
    "dropdelzpp": 317959998,
    "dropphyadd": "103 N PICKETT ST",
    "dropphycty": "TY TY",
    "dropphyst": "GA",
    "dropphyzpp": 317959998,
    "dropmaladd": "103 N PICKETT ST",
    "dropmalcty": "TY TY",
    "dropmalst": "GA",
    "dropmalzpp": 317959998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2293829950,
    "dropsitcph": 2293829950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11302",
    "droptype": "D",
    "dropname": "TYBEE ISLAND",
    "dropdeladd": "102 S CAMPBELL AVE",
    "dropdelcty": "TYBEE ISLAND",
    "dropdelst": "GA",
    "dropdelzpp": 313289998,
    "dropphyadd": "102 S CAMPBELL AVE",
    "dropphycty": "TYBEE ISLAND",
    "dropphyst": "GA",
    "dropphyzpp": 313289998,
    "dropmaladd": "102 S CAMPBELL AVE",
    "dropmalcty": "TYBEE ISLAND",
    "dropmalst": "GA",
    "dropmalzpp": 313289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127869632,
    "dropsitcph": 9127869632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11303",
    "droptype": "D",
    "dropname": "TYRONE",
    "dropdeladd": "100 COMMERCE DR",
    "dropdelcty": "TYRONE",
    "dropdelst": "GA",
    "dropdelzpp": 302908000,
    "dropphyadd": "100 COMMERCE DR",
    "dropphycty": "TYRONE",
    "dropphyst": "GA",
    "dropphyzpp": 302908000,
    "dropmaladd": "100 COMMERCE DR",
    "dropmalcty": "TYRONE",
    "dropmalst": "GA",
    "dropmalzpp": 302908000,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704866683,
    "dropsitcph": 7704866681,
    "dropfax": 7704869906
  },
  {
    "dcode": "D",
    "dropkey": "PX11305",
    "droptype": "D",
    "dropname": "UNADILLA",
    "dropdeladd": "1885 PINE ST",
    "dropdelcty": "UNADILLA",
    "dropdelst": "GA",
    "dropdelzpp": 310919998,
    "dropphyadd": "1885 PINE ST",
    "dropphycty": "UNADILLA",
    "dropphyst": "GA",
    "dropphyzpp": 310919998,
    "dropmaladd": "1885 PINE ST",
    "dropmalcty": "UNADILLA",
    "dropmalst": "GA",
    "dropmalzpp": 310919998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4786273420,
    "dropsitcph": 4786273420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11307",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "5050 UNION ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "GA",
    "dropdelzpp": 302919998,
    "dropphyadd": "5050 UNION ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "GA",
    "dropphyzpp": 302919998,
    "dropmaladd": "5050 UNION ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "GA",
    "dropmalzpp": 302919998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709640408,
    "dropsitcph": 7703062395,
    "dropfax": 7709641227
  },
  {
    "dcode": "D",
    "dropkey": "PX11310",
    "droptype": "D",
    "dropname": "UNION POINT",
    "dropdeladd": "103 FLUKER ST",
    "dropdelcty": "UNION POINT",
    "dropdelst": "GA",
    "dropdelzpp": 306699998,
    "dropphyadd": "103 FLUKER ST",
    "dropphycty": "UNION POINT",
    "dropphyst": "GA",
    "dropphyzpp": 306699998,
    "dropmaladd": "103 FLUKER ST",
    "dropmalcty": "UNION POINT",
    "dropmalst": "GA",
    "dropmalzpp": 306699998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064862508,
    "dropsitcph": 7064862508,
    "dropfax": 7064864150
  },
  {
    "dcode": "D",
    "dropkey": "PX11314",
    "droptype": "D",
    "dropname": "UVALDA",
    "dropdeladd": "121 N RAILROAD ST",
    "dropdelcty": "UVALDA",
    "dropdelst": "GA",
    "dropdelzpp": 304739998,
    "dropphyadd": "121 N RAILROAD ST",
    "dropphycty": "UVALDA",
    "dropphyst": "GA",
    "dropphyzpp": 304739998,
    "dropmaladd": "121 N RAILROAD ST",
    "dropmalcty": "UVALDA",
    "dropmalst": "GA",
    "dropmalzpp": 304739998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125946999,
    "dropsitcph": 9125946999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11316",
    "droptype": "D",
    "dropname": "VALDOSTA",
    "dropdeladd": "311 N PATTERSON ST STE C",
    "dropdelcty": "VALDOSTA",
    "dropdelst": "GA",
    "dropdelzpp": 316015695,
    "dropphyadd": "311 N PATTERSON ST STE C",
    "dropphycty": "VALDOSTA",
    "dropphyst": "GA",
    "dropphyzpp": 316015695,
    "dropmaladd": "311 N PATTERSON ST STE C",
    "dropmalcty": "VALDOSTA",
    "dropmalst": "GA",
    "dropmalzpp": 316015695,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292599994,
    "dropsitcph": 2292599994,
    "dropfax": 2292425185
  },
  {
    "dcode": "D",
    "dropkey": "PX11319",
    "droptype": "D",
    "dropname": "VARNELL",
    "dropdeladd": "103 E VARNELL MAIN ST",
    "dropdelcty": "VARNELL",
    "dropdelst": "GA",
    "dropdelzpp": 307569998,
    "dropphyadd": "103 E VARNELL MAIN ST",
    "dropphycty": "VARNELL",
    "dropphyst": "GA",
    "dropphyzpp": 307569998,
    "dropmaladd": "103 E VARNELL MAIN ST",
    "dropmalcty": "VARNELL",
    "dropmalst": "GA",
    "dropmalzpp": 307569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7066948033,
    "dropsitcph": 7066948033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11320",
    "droptype": "D",
    "dropname": "VIDALIA",
    "dropdeladd": "310 CHURCH ST",
    "dropdelcty": "VIDALIA",
    "dropdelst": "GA",
    "dropdelzpp": 304749998,
    "dropphyadd": "310 CHURCH ST",
    "dropphycty": "VIDALIA",
    "dropphyst": "GA",
    "dropphyzpp": 304749998,
    "dropmaladd": "310 CHURCH ST",
    "dropmalcty": "VIDALIA",
    "dropmalst": "GA",
    "dropmalzpp": 304749998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125371422,
    "dropsitcph": 9125371422,
    "dropfax": 9125372220
  },
  {
    "dcode": "D",
    "dropkey": "PX11322",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "107 W COTTON ST",
    "dropdelcty": "VIENNA",
    "dropdelst": "GA",
    "dropdelzpp": 310929998,
    "dropphyadd": "107 W COTTON ST",
    "dropphycty": "VIENNA",
    "dropphyst": "GA",
    "dropphyzpp": 310929998,
    "dropmaladd": "107 W COTTON ST",
    "dropmalcty": "VIENNA",
    "dropmalst": "GA",
    "dropmalzpp": 310929998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292682031,
    "dropsitcph": 2292682031,
    "dropfax": 2292686636
  },
  {
    "dcode": "D",
    "dropkey": "PX11323",
    "droptype": "D",
    "dropname": "VILLA RICA",
    "dropdeladd": "43 COMMUNITY SQUARE BLVD",
    "dropdelcty": "VILLA RICA",
    "dropdelst": "GA",
    "dropdelzpp": 301809998,
    "dropphyadd": "43 COMMUNITY SQUARE BLVD",
    "dropphycty": "VILLA RICA",
    "dropphyst": "GA",
    "dropphyzpp": 301809998,
    "dropmaladd": "43 COMMUNITY SQUARE BLVD",
    "dropmalcty": "VILLA RICA",
    "dropmalst": "GA",
    "dropmalzpp": 301809998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704598522,
    "dropsitcph": 7704593725,
    "dropfax": 7704590833
  },
  {
    "dcode": "D",
    "dropkey": "PX11332",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "86 ATLANTIC AVE",
    "dropdelcty": "WACO",
    "dropdelst": "GA",
    "dropdelzpp": 301829998,
    "dropphyadd": "86 ATLANTIC AVE",
    "dropphycty": "WACO",
    "dropphyst": "GA",
    "dropphyzpp": 301829998,
    "dropmaladd": "86 ATLANTIC AVE",
    "dropmalcty": "WACO",
    "dropmalst": "GA",
    "dropmalzpp": 301829998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705373785,
    "dropsitcph": 7705373785,
    "dropfax": 7705371189
  },
  {
    "dcode": "D",
    "dropkey": "PX11334",
    "droptype": "D",
    "dropname": "WADLEY",
    "dropdeladd": "113 RAILROAD AVE",
    "dropdelcty": "WADLEY",
    "dropdelst": "GA",
    "dropdelzpp": 304779998,
    "dropphyadd": "113 RAILROAD AVE",
    "dropphycty": "WADLEY",
    "dropphyst": "GA",
    "dropphyzpp": 304779998,
    "dropmaladd": "113 RAILROAD AVE",
    "dropmalcty": "WADLEY",
    "dropmalst": "GA",
    "dropmalzpp": 304779998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4782529192,
    "dropsitcph": 4782529192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11335",
    "droptype": "D",
    "dropname": "WALESKA",
    "dropdeladd": "7265 REINHARDT COLLEGE PKWY",
    "dropdelcty": "WALESKA",
    "dropdelst": "GA",
    "dropdelzpp": 301839998,
    "dropphyadd": "7265 REINHARDT COLLEGE PKWY",
    "dropphycty": "WALESKA",
    "dropphyst": "GA",
    "dropphyzpp": 301839998,
    "dropmaladd": "7265 REINHARDT COLLEGE PKWY",
    "dropmalcty": "WALESKA",
    "dropmalst": "GA",
    "dropmalzpp": 301839998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702136044,
    "dropsitcph": 7707202471,
    "dropfax": 7707202473
  },
  {
    "dcode": "D",
    "dropkey": "PX11338",
    "droptype": "D",
    "dropname": "WALTHOURVILLE",
    "dropdeladd": "52 TALMADGE RD",
    "dropdelcty": "WALTHOURVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 313339998,
    "dropphyadd": "52 TALMADGE RD",
    "dropphycty": "WALTHOURVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 313339998,
    "dropmaladd": "52 TALMADGE RD",
    "dropmalcty": "WALTHOURVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 313339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123687050,
    "dropsitcph": 9123687050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11341",
    "droptype": "D",
    "dropname": "WARESBORO",
    "dropdeladd": "4308 ALBANY AVE",
    "dropdelcty": "WARESBORO",
    "dropdelst": "GA",
    "dropdelzpp": 315649900,
    "dropphyadd": "4308 ALBANY AVE",
    "dropphycty": "WARESBORO",
    "dropphyst": "GA",
    "dropphyzpp": 315649900,
    "dropmaladd": "4308 ALBANY AVE",
    "dropmalcty": "WARESBORO",
    "dropmalst": "GA",
    "dropmalzpp": 315649900,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122837762,
    "dropsitcph": 9122837762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11342",
    "droptype": "D",
    "dropname": "WARM SPRINGS",
    "dropdeladd": "3795 WHITE HOUSE PKWY",
    "dropdelcty": "WARM SPRINGS",
    "dropdelst": "GA",
    "dropdelzpp": 318309998,
    "dropphyadd": "3795 WHITE HOUSE PKWY",
    "dropphycty": "WARM SPRINGS",
    "dropphyst": "GA",
    "dropphyzpp": 318309998,
    "dropmaladd": "3795 WHITE HOUSE PKWY",
    "dropmalcty": "WARM SPRINGS",
    "dropmalst": "GA",
    "dropmalzpp": 318309998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066553625,
    "dropsitcph": 7066553625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11343",
    "droptype": "D",
    "dropname": "WARNER ROBINS",
    "dropdeladd": "904 RUSSELL PKWY",
    "dropdelcty": "WARNER ROBINS",
    "dropdelst": "GA",
    "dropdelzpp": 310889998,
    "dropphyadd": "904 RUSSELL PKWY",
    "dropphycty": "WARNER ROBINS",
    "dropphyst": "GA",
    "dropphyzpp": 310889998,
    "dropmaladd": "904 RUSSELL PKWY",
    "dropmalcty": "WARNER ROBINS",
    "dropmalst": "GA",
    "dropmalzpp": 310889998,
    "dropsitphn": 4787528444,
    "dropsitlph": 4789222175,
    "dropsitcph": 4789222175,
    "dropfax": 4783283777
  },
  {
    "dcode": "D",
    "dropkey": "PX11344",
    "droptype": "D",
    "dropname": "WARRENTON",
    "dropdeladd": "615 MAIN ST",
    "dropdelcty": "WARRENTON",
    "dropdelst": "GA",
    "dropdelzpp": 308289998,
    "dropphyadd": "615 MAIN ST",
    "dropphycty": "WARRENTON",
    "dropphyst": "GA",
    "dropphyzpp": 308289998,
    "dropmaladd": "615 MAIN ST",
    "dropmalcty": "WARRENTON",
    "dropmalst": "GA",
    "dropmalzpp": 308289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064653322,
    "dropsitcph": 7064653322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11345",
    "droptype": "D",
    "dropname": "WARTHEN",
    "dropdeladd": "7753 GA HIGHWAY 15 N",
    "dropdelcty": "WARTHEN",
    "dropdelst": "GA",
    "dropdelzpp": 310949998,
    "dropphyadd": "7753 GA HIGHWAY 15 N",
    "dropphycty": "WARTHEN",
    "dropphyst": "GA",
    "dropphyzpp": 310949998,
    "dropmaladd": "7753 GA HIGHWAY 15 N",
    "dropmalcty": "WARTHEN",
    "dropmalst": "GA",
    "dropmalzpp": 310949998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4785523792,
    "dropsitcph": 4785523792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11346",
    "droptype": "D",
    "dropname": "WARWICK",
    "dropdeladd": "121 DOGWOOD ST SW",
    "dropdelcty": "WARWICK",
    "dropdelst": "GA",
    "dropdelzpp": 317969998,
    "dropphyadd": "121 DOGWOOD ST SW",
    "dropphycty": "WARWICK",
    "dropphyst": "GA",
    "dropphyzpp": 317969998,
    "dropmaladd": "121 DOGWOOD ST SW",
    "dropmalcty": "WARWICK",
    "dropmalst": "GA",
    "dropmalzpp": 317969998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2295354373,
    "dropsitcph": 2295354373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11347",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "215 E COURT ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 306739998,
    "dropphyadd": "215 E COURT ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 306739998,
    "dropmaladd": "215 E COURT ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 306739998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066782021,
    "dropsitcph": 7066782021,
    "dropfax": 7066781897
  },
  {
    "dcode": "D",
    "dropkey": "PX11348",
    "droptype": "D",
    "dropname": "WATKINSVILLE",
    "dropdeladd": "1090 EXPERIMENT STATION RD",
    "dropdelcty": "WATKINSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 306779998,
    "dropphyadd": "1090 EXPERIMENT STATION RD",
    "dropphycty": "WATKINSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 306779998,
    "dropmaladd": "1090 EXPERIMENT STATION RD",
    "dropmalcty": "WATKINSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 306779998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067694679,
    "dropsitcph": 7067696980,
    "dropfax": 7067692358
  },
  {
    "dcode": "D",
    "dropkey": "PX11351",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "24311 US HIGHWAY 17",
    "dropdelcty": "WAVERLY",
    "dropdelst": "GA",
    "dropdelzpp": 315659998,
    "dropphyadd": "24311 US HIGHWAY 17",
    "dropphycty": "WAVERLY",
    "dropphyst": "GA",
    "dropphyzpp": 315659998,
    "dropmaladd": "24311 US HIGHWAY 17",
    "dropmalcty": "WAVERLY",
    "dropmalst": "GA",
    "dropmalzpp": 315659998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125762474,
    "dropsitcph": 9125762474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11352",
    "droptype": "D",
    "dropname": "WAVERLY HALL",
    "dropdeladd": "99 RIDGEWAY RD",
    "dropdelcty": "WAVERLY HALL",
    "dropdelst": "GA",
    "dropdelzpp": 318319998,
    "dropphyadd": "99 RIDGEWAY RD",
    "dropphycty": "WAVERLY HALL",
    "dropphyst": "GA",
    "dropphyzpp": 318319998,
    "dropmaladd": "99 RIDGEWAY RD",
    "dropmalcty": "WAVERLY HALL",
    "dropmalst": "GA",
    "dropmalzpp": 318319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065822577,
    "dropsitcph": 7065822577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11354",
    "droptype": "D",
    "dropname": "WAYCROSS",
    "dropdeladd": "601 TEBEAU ST FL 1",
    "dropdelcty": "WAYCROSS",
    "dropdelst": "GA",
    "dropdelzpp": 315019998,
    "dropphyadd": "601 TEBEAU ST FL 1",
    "dropphycty": "WAYCROSS",
    "dropphyst": "GA",
    "dropphyzpp": 315019998,
    "dropmaladd": "601 TEBEAU ST FL 1",
    "dropmalcty": "WAYCROSS",
    "dropmalst": "GA",
    "dropmalzpp": 315019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122878110,
    "dropsitcph": 9122878110,
    "dropfax": 9122831810
  },
  {
    "dcode": "D",
    "dropkey": "PX11355",
    "droptype": "D",
    "dropname": "WAYNESBORO",
    "dropdeladd": "240 E 6TH ST",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "GA",
    "dropdelzpp": 308309998,
    "dropphyadd": "240 E 6TH ST",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "GA",
    "dropphyzpp": 308309998,
    "dropmaladd": "240 E 6TH ST",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "GA",
    "dropmalzpp": 308309998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065544790,
    "dropsitcph": 7065544790,
    "dropfax": 7065542403
  },
  {
    "dcode": "D",
    "dropkey": "PX11356",
    "droptype": "D",
    "dropname": "WAYNESVILLE",
    "dropdeladd": "25380 HIGHWAY 82",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 315669997,
    "dropphyadd": "25380 HIGHWAY 82",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 315669997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 315669998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127785331,
    "dropsitcph": 9127785331,
    "dropfax": 9127783024
  },
  {
    "dcode": "D",
    "dropkey": "PX11368",
    "droptype": "D",
    "dropname": "WEST GREEN",
    "dropdeladd": "9978 US HIGHWAY 221 N",
    "dropdelcty": "WEST GREEN",
    "dropdelst": "GA",
    "dropdelzpp": 315679998,
    "dropphyadd": "9978 US HIGHWAY 221 N",
    "dropphycty": "WEST GREEN",
    "dropphyst": "GA",
    "dropphyzpp": 315679998,
    "dropmaladd": "9978 US HIGHWAY 221 N",
    "dropmalcty": "WEST GREEN",
    "dropmalst": "GA",
    "dropmalzpp": 315679998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9123843944,
    "dropsitcph": 9123843944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11369",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "729 4TH AVE FL 1",
    "dropdelcty": "WEST POINT",
    "dropdelst": "GA",
    "dropdelzpp": 318339998,
    "dropphyadd": "729 4TH AVE FL 1",
    "dropphycty": "WEST POINT",
    "dropphyst": "GA",
    "dropphyzpp": 318339998,
    "dropmaladd": "729 4TH AVE FL 1",
    "dropmalcty": "WEST POINT",
    "dropmalst": "GA",
    "dropmalzpp": 318339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066451301,
    "dropsitcph": 7066451301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11372",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "3286 WESTON BLVD",
    "dropdelcty": "WESTON",
    "dropdelst": "GA",
    "dropdelzpp": 318329998,
    "dropphyadd": "3286 WESTON BLVD",
    "dropphycty": "WESTON",
    "dropphyst": "GA",
    "dropphyzpp": 318329998,
    "dropmaladd": "3286 WESTON BLVD",
    "dropmalcty": "WESTON",
    "dropmalst": "GA",
    "dropmalzpp": 318329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2298287691,
    "dropsitcph": 2298287691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11375",
    "droptype": "D",
    "dropname": "WHIGHAM",
    "dropdeladd": "115 W BROAD AVE",
    "dropdelcty": "WHIGHAM",
    "dropdelst": "GA",
    "dropdelzpp": 398979998,
    "dropphyadd": "115 W BROAD AVE",
    "dropphycty": "WHIGHAM",
    "dropphyst": "GA",
    "dropphyzpp": 398979998,
    "dropmaladd": "115 W BROAD AVE",
    "dropmalcty": "WHIGHAM",
    "dropmalst": "GA",
    "dropmalzpp": 398979998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297623267,
    "dropsitcph": 2297623267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11376",
    "droptype": "D",
    "dropname": "WHITE",
    "dropdeladd": "3172 HIGHWAY 411 NE",
    "dropdelcty": "WHITE",
    "dropdelst": "GA",
    "dropdelzpp": 301849998,
    "dropphyadd": "3172 HIGHWAY 411 NE",
    "dropphycty": "WHITE",
    "dropphyst": "GA",
    "dropphyzpp": 301849998,
    "dropmaladd": "3172 HIGHWAY 411 NE",
    "dropmalcty": "WHITE",
    "dropmalst": "GA",
    "dropmalzpp": 301849998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703822148,
    "dropsitcph": 7703822148,
    "dropfax": 7703827198
  },
  {
    "dcode": "D",
    "dropkey": "PX11377",
    "droptype": "D",
    "dropname": "WHITE OAK",
    "dropdeladd": "25 MCKINNON RD N",
    "dropdelcty": "WHITE OAK",
    "dropdelst": "GA",
    "dropdelzpp": 315689998,
    "dropphyadd": "25 MCKINNON RD N",
    "dropphycty": "WHITE OAK",
    "dropphyst": "GA",
    "dropphyzpp": 315689998,
    "dropmaladd": "25 MCKINNON RD N",
    "dropmalcty": "WHITE OAK",
    "dropmalst": "GA",
    "dropmalzpp": 315689998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128828968,
    "dropsitcph": 9128828968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11378",
    "droptype": "D",
    "dropname": "WHITE PLAINS",
    "dropdeladd": "7501 HIGHWAY 15 S",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "GA",
    "dropdelzpp": 306789998,
    "dropphyadd": "7501 HIGHWAY 15 S",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "GA",
    "dropphyzpp": 306789998,
    "dropmaladd": "7501 HIGHWAY 15 S",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "GA",
    "dropmalzpp": 306789998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064672255,
    "dropsitcph": 7064672255,
    "dropfax": 7064671303
  },
  {
    "dcode": "D",
    "dropkey": "PX11381",
    "droptype": "D",
    "dropname": "WHITESBURG",
    "dropdeladd": "710 MAIN ST",
    "dropdelcty": "WHITESBURG",
    "dropdelst": "GA",
    "dropdelzpp": 301859998,
    "dropphyadd": "710 MAIN ST",
    "dropphycty": "WHITESBURG",
    "dropphyst": "GA",
    "dropphyzpp": 301859998,
    "dropmaladd": "710 MAIN ST",
    "dropmalcty": "WHITESBURG",
    "dropmalst": "GA",
    "dropmalzpp": 301859998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708361449,
    "dropsitcph": 7708361449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11382",
    "droptype": "D",
    "dropname": "WILDWOOD",
    "dropdeladd": "20605 HIGHWAY 11",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "GA",
    "dropdelzpp": 307579998,
    "dropphyadd": "20605 HIGHWAY 11",
    "dropphycty": "WILDWOOD",
    "dropphyst": "GA",
    "dropphyzpp": 307579998,
    "dropmaladd": "20605 HIGHWAY 11",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "GA",
    "dropmalzpp": 307579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7068209304,
    "dropsitcph": 7068209304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11383",
    "droptype": "D",
    "dropname": "WILEY",
    "dropdeladd": "6089 HIGHWAY 441 S",
    "dropdelcty": "WILEY",
    "dropdelst": "GA",
    "dropdelzpp": 305811815,
    "dropphyadd": "6089 HIGHWAY 441 S",
    "dropphycty": "WILEY",
    "dropphyst": "GA",
    "dropphyzpp": 305811815,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILEY",
    "dropmalst": "GA",
    "dropmalzpp": 305819998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067824467,
    "dropsitcph": 7067824467,
    "dropfax": 7067826117
  },
  {
    "dcode": "D",
    "dropkey": "PX11384",
    "droptype": "D",
    "dropname": "WILLACOOCHEE",
    "dropdeladd": "801 MAIN ST E",
    "dropdelcty": "WILLACOOCHEE",
    "dropdelst": "GA",
    "dropdelzpp": 316509998,
    "dropphyadd": "801 MAIN ST E",
    "dropphycty": "WILLACOOCHEE",
    "dropphyst": "GA",
    "dropphyzpp": 316509998,
    "dropmaladd": "801 MAIN ST E",
    "dropmalcty": "WILLACOOCHEE",
    "dropmalst": "GA",
    "dropmalzpp": 316509998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9125346248,
    "dropsitcph": 9125346248,
    "dropfax": 9125345809
  },
  {
    "dcode": "D",
    "dropkey": "PX11385",
    "droptype": "D",
    "dropname": "WILLIAMSON",
    "dropdeladd": "421 HIGHWAY 362 W",
    "dropdelcty": "WILLIAMSON",
    "dropdelst": "GA",
    "dropdelzpp": 302929998,
    "dropphyadd": "421 HIGHWAY 362 W",
    "dropphycty": "WILLIAMSON",
    "dropphyst": "GA",
    "dropphyzpp": 302929998,
    "dropmaladd": "421 HIGHWAY 362 W",
    "dropmalcty": "WILLIAMSON",
    "dropmalst": "GA",
    "dropmalzpp": 302929998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702299851,
    "dropsitcph": 7704679519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11390",
    "droptype": "D",
    "dropname": "WINDER",
    "dropdeladd": "101 N BROAD ST STE 26",
    "dropdelcty": "WINDER",
    "dropdelst": "GA",
    "dropdelzpp": 306809998,
    "dropphyadd": "101 N BROAD ST STE 26",
    "dropphycty": "WINDER",
    "dropphyst": "GA",
    "dropphyzpp": 306809998,
    "dropmaladd": "101 N BROAD ST STE 26",
    "dropmalcty": "WINDER",
    "dropmalst": "GA",
    "dropmalzpp": 306809998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4704296019,
    "dropsitcph": 7708679266,
    "dropfax": 7703072071
  },
  {
    "dcode": "D",
    "dropkey": "PX11395",
    "droptype": "D",
    "dropname": "WINSTON",
    "dropdeladd": "2929 OLD POST RD",
    "dropdelcty": "WINSTON",
    "dropdelst": "GA",
    "dropdelzpp": 301879998,
    "dropphyadd": "2929 OLD POST RD",
    "dropphycty": "WINSTON",
    "dropphyst": "GA",
    "dropphyzpp": 301879998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINSTON",
    "dropmalst": "GA",
    "dropmalzpp": 301879997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709424812,
    "dropsitcph": 7709424812,
    "dropfax": 7704896986
  },
  {
    "dcode": "D",
    "dropkey": "PX11398",
    "droptype": "D",
    "dropname": "WINTERVILLE",
    "dropdeladd": "125 AVERY ST",
    "dropdelcty": "WINTERVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 306839998,
    "dropphyadd": "125 AVERY ST",
    "dropphycty": "WINTERVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 306839998,
    "dropmaladd": "125 AVERY ST",
    "dropmalcty": "WINTERVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 306839998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7067428875,
    "dropsitcph": 7067428875,
    "dropfax": 7067427033
  },
  {
    "dcode": "D",
    "dropkey": "PX11402",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "202 BEDELL AVE",
    "dropdelcty": "WOODBINE",
    "dropdelst": "GA",
    "dropdelzpp": 315699998,
    "dropphyadd": "202 BEDELL AVE",
    "dropphycty": "WOODBINE",
    "dropphyst": "GA",
    "dropphyzpp": 315699998,
    "dropmaladd": "202 BEDELL AVE",
    "dropmalcty": "WOODBINE",
    "dropmalst": "GA",
    "dropmalzpp": 315699998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9127292797,
    "dropsitcph": 9127292797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11403",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "40 JONES MILL RD",
    "dropdelcty": "WOODBURY",
    "dropdelst": "GA",
    "dropdelzpp": 302939998,
    "dropphyadd": "40 JONES MILL RD",
    "dropphycty": "WOODBURY",
    "dropphyst": "GA",
    "dropphyzpp": 302939998,
    "dropmaladd": "40 JONES MILL RD",
    "dropmalcty": "WOODBURY",
    "dropmalst": "GA",
    "dropmalzpp": 302939998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7065535059,
    "dropsitcph": 7065535059,
    "dropfax": 7065532637
  },
  {
    "dcode": "D",
    "dropkey": "PX11404",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "60 E MAIN ST",
    "dropdelcty": "WOODLAND",
    "dropdelst": "GA",
    "dropdelzpp": 318369998,
    "dropphyadd": "60 E MAIN ST",
    "dropphycty": "WOODLAND",
    "dropphyst": "GA",
    "dropphyzpp": 318369998,
    "dropmaladd": "60 E MAIN ST",
    "dropmalcty": "WOODLAND",
    "dropmalst": "GA",
    "dropmalzpp": 318369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066742666,
    "dropsitcph": 7066742666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11406",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "225 PARKWAY 575",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "GA",
    "dropdelzpp": 301889998,
    "dropphyadd": "225 PARKWAY 575",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "GA",
    "dropphyzpp": 301889998,
    "dropmaladd": "225 PARKWAY 575",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "GA",
    "dropmalzpp": 301889998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705911023,
    "dropsitcph": 7705910364,
    "dropfax": 7705160436
  },
  {
    "dcode": "D",
    "dropkey": "PX11408",
    "droptype": "D",
    "dropname": "WRAY",
    "dropdeladd": "1118 WRAY RD",
    "dropdelcty": "WRAY",
    "dropdelst": "GA",
    "dropdelzpp": 317989998,
    "dropphyadd": "1118 WRAY RD",
    "dropphycty": "WRAY",
    "dropphyst": "GA",
    "dropphyzpp": 317989998,
    "dropmaladd": "1118 WRAY RD",
    "dropmalcty": "WRAY",
    "dropmalst": "GA",
    "dropmalzpp": 317989998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2294235954,
    "dropsitcph": 2294235954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11409",
    "droptype": "D",
    "dropname": "WRENS",
    "dropdeladd": "101 ESTELLE ST",
    "dropdelcty": "WRENS",
    "dropdelst": "GA",
    "dropdelzpp": 308339998,
    "dropphyadd": "101 ESTELLE ST",
    "dropphycty": "WRENS",
    "dropphyst": "GA",
    "dropphyzpp": 308339998,
    "dropmaladd": "101 ESTELLE ST",
    "dropmalcty": "WRENS",
    "dropmalst": "GA",
    "dropmalzpp": 308339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065477710,
    "dropsitcph": 7065477710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11411",
    "droptype": "D",
    "dropname": "WRIGHTSVILLE",
    "dropdeladd": "8648 S MARCUS ST",
    "dropdelcty": "WRIGHTSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310969998,
    "dropphyadd": "8648 S MARCUS ST",
    "dropphycty": "WRIGHTSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310969998,
    "dropmaladd": "8648 S MARCUS ST",
    "dropmalcty": "WRIGHTSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310969998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4788648136,
    "dropsitcph": 4788648136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11414",
    "droptype": "D",
    "dropname": "YATESVILLE",
    "dropdeladd": "17 EMPIRE ST",
    "dropdelcty": "YATESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310979998,
    "dropphyadd": "17 EMPIRE ST",
    "dropphycty": "YATESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310979998,
    "dropmaladd": "17 EMPIRE ST",
    "dropmalcty": "YATESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310979998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7064723291,
    "dropsitcph": 7064723291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11415",
    "droptype": "D",
    "dropname": "YOUNG HARRIS",
    "dropdeladd": "5171 COLLEGE ST",
    "dropdelcty": "YOUNG HARRIS",
    "dropdelst": "GA",
    "dropdelzpp": 305829998,
    "dropphyadd": "5171 COLLEGE ST",
    "dropphycty": "YOUNG HARRIS",
    "dropphyst": "GA",
    "dropphyzpp": 305829998,
    "dropmaladd": "5171 COLLEGE ST",
    "dropmalcty": "YOUNG HARRIS",
    "dropmalst": "GA",
    "dropmalzpp": 305829998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063793240,
    "dropsitcph": 7063793240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11416",
    "droptype": "D",
    "dropname": "ZEBULON",
    "dropdeladd": "370 GRIFFIN ST",
    "dropdelcty": "ZEBULON",
    "dropdelst": "GA",
    "dropdelzpp": 302959998,
    "dropphyadd": "370 GRIFFIN ST",
    "dropphycty": "ZEBULON",
    "dropphyst": "GA",
    "dropphyzpp": 302959998,
    "dropmaladd": "370 GRIFFIN ST",
    "dropmalcty": "ZEBULON",
    "dropmalst": "GA",
    "dropmalzpp": 302959998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705671756,
    "dropsitcph": 7705675597,
    "dropfax": 7705678749
  },
  {
    "dcode": "D",
    "dropkey": "PX11427",
    "droptype": "D",
    "dropname": "ADVANCE",
    "dropdeladd": "110 N MAIN ST",
    "dropdelcty": "ADVANCE",
    "dropdelst": "IN",
    "dropdelzpp": 461029998,
    "dropphyadd": "110 N MAIN ST",
    "dropphycty": "ADVANCE",
    "dropphyst": "IN",
    "dropphyzpp": 461029998,
    "dropmaladd": "110 N MAIN ST",
    "dropmalcty": "ADVANCE",
    "dropmalst": "IN",
    "dropmalzpp": 461029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656766477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11430",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "120 W ROCHESTER ST",
    "dropdelcty": "AKRON",
    "dropdelst": "IN",
    "dropdelzpp": 469109998,
    "dropphyadd": "120 W ROCHESTER ST",
    "dropphycty": "AKRON",
    "dropphyst": "IN",
    "dropphyzpp": 469109998,
    "dropmaladd": "120 W ROCHESTER ST",
    "dropmalcty": "AKRON",
    "dropmalst": "IN",
    "dropmalzpp": 469109998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748937012,
    "dropfax": 5748937554
  },
  {
    "dcode": "D",
    "dropkey": "PX11431",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "101 N FRANKLIN ST",
    "dropdelcty": "ALAMO",
    "dropdelst": "IN",
    "dropdelzpp": 479169998,
    "dropphyadd": "101 N FRANKLIN ST",
    "dropphycty": "ALAMO",
    "dropphyst": "IN",
    "dropphyzpp": 479169998,
    "dropmaladd": "101 N FRANKLIN ST",
    "dropmalcty": "ALAMO",
    "dropmalst": "IN",
    "dropmalzpp": 479169998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658661635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11432",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "230 E STATE ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "IN",
    "dropdelzpp": 473209998,
    "dropphyadd": "230 E STATE ST",
    "dropphycty": "ALBANY",
    "dropphyst": "IN",
    "dropphyzpp": 473209998,
    "dropmaladd": "230 E STATE ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "IN",
    "dropmalzpp": 473209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657896332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11433",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "123 S ORANGE ST",
    "dropdelcty": "ALBION",
    "dropdelst": "IN",
    "dropdelzpp": 467019998,
    "dropphyadd": "123 S ORANGE ST",
    "dropphycty": "ALBION",
    "dropphyst": "IN",
    "dropphyzpp": 467019998,
    "dropmaladd": "123 S ORANGE ST",
    "dropmalcty": "ALBION",
    "dropmalst": "IN",
    "dropmalzpp": 467019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606362711,
    "dropfax": 2606362711
  },
  {
    "dcode": "D",
    "dropkey": "PX11435",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "205 W CHURCH ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "IN",
    "dropdelzpp": 460019998,
    "dropphyadd": "205 W CHURCH ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "IN",
    "dropphyzpp": 460019998,
    "dropmaladd": "205 W CHURCH ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "IN",
    "dropmalzpp": 460019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657243628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11448",
    "droptype": "D",
    "dropname": "AMBIA",
    "dropdeladd": "109 E OAK ST",
    "dropdelcty": "AMBIA",
    "dropdelst": "IN",
    "dropdelzpp": 479179998,
    "dropphyadd": "109 E OAK ST",
    "dropphycty": "AMBIA",
    "dropphyst": "IN",
    "dropphyzpp": 479179998,
    "dropmaladd": "109 E OAK ST",
    "dropmalcty": "AMBIA",
    "dropmalst": "IN",
    "dropmalzpp": 479179998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658695803,
    "dropfax": 7658695803
  },
  {
    "dcode": "D",
    "dropkey": "PX11449",
    "droptype": "D",
    "dropname": "AMBOY",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "AMBOY",
    "dropdelst": "IN",
    "dropdelzpp": 469119998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "AMBOY",
    "dropphyst": "IN",
    "dropphyzpp": 469119998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "AMBOY",
    "dropmalst": "IN",
    "dropmalzpp": 469119998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653957331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11452",
    "droptype": "D",
    "dropname": "AMO",
    "dropdeladd": "4925 PEARL ST",
    "dropdelcty": "AMO",
    "dropdelst": "IN",
    "dropdelzpp": 461039998,
    "dropphyadd": "4925 PEARL ST",
    "dropphycty": "AMO",
    "dropphyst": "IN",
    "dropphyzpp": 461039998,
    "dropmaladd": "4925 PEARL ST",
    "dropmalcty": "AMO",
    "dropmalst": "IN",
    "dropmalzpp": 461039998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3175392168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11453",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "1505 RAIBLE AVE",
    "dropdelcty": "ANDERSON",
    "dropdelst": "IN",
    "dropdelzpp": 460119998,
    "dropphyadd": "1505 RAIBLE AVE",
    "dropphycty": "ANDERSON",
    "dropphyst": "IN",
    "dropphyzpp": 460119998,
    "dropmaladd": "1505 RAIBLE AVE",
    "dropmalcty": "ANDERSON",
    "dropmalst": "IN",
    "dropmalzpp": 460119998,
    "dropsitphn": 3174646350,
    "dropsitlph": 7656431762,
    "dropsitcph": 7656436363,
    "dropfax": 7656430168
  },
  {
    "dcode": "D",
    "dropkey": "PX11457",
    "droptype": "D",
    "dropname": "ANDREWS",
    "dropdeladd": "55 W JEFFERSON ST",
    "dropdelcty": "ANDREWS",
    "dropdelst": "IN",
    "dropdelzpp": 467029998,
    "dropphyadd": "55 W JEFFERSON ST",
    "dropphycty": "ANDREWS",
    "dropphyst": "IN",
    "dropphyzpp": 467029998,
    "dropmaladd": "55 W JEFFERSON ST",
    "dropmalcty": "ANDREWS",
    "dropmalst": "IN",
    "dropmalzpp": 467029998,
    "dropsitphn": 2603560920,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607863268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11459",
    "droptype": "D",
    "dropname": "ANGOLA",
    "dropdeladd": "110 W HARCOURT RD",
    "dropdelcty": "ANGOLA",
    "dropdelst": "IN",
    "dropdelzpp": 467039998,
    "dropphyadd": "110 W HARCOURT RD",
    "dropphycty": "ANGOLA",
    "dropphyst": "IN",
    "dropphyzpp": 467039998,
    "dropmaladd": "110 W HARCOURT RD",
    "dropmalcty": "ANGOLA",
    "dropmalst": "IN",
    "dropmalzpp": 467039998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606652019,
    "dropfax": 2606651595
  },
  {
    "dcode": "D",
    "dropkey": "PX11469",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "104 N WASHINGTON ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "IN",
    "dropdelzpp": 460309998,
    "dropphyadd": "104 N WASHINGTON ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "IN",
    "dropphyzpp": 460309998,
    "dropmaladd": "104 N WASHINGTON ST",
    "dropmalcty": "ARCADIA",
    "dropmalst": "IN",
    "dropmalzpp": 460309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179843481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11470",
    "droptype": "D",
    "dropname": "ARCOLA",
    "dropdeladd": "11400 ARCOLA RD STE B1",
    "dropdelcty": "ARCOLA",
    "dropdelst": "IN",
    "dropdelzpp": 467049998,
    "dropphyadd": "11400 ARCOLA RD STE B1",
    "dropphycty": "ARCOLA",
    "dropphyst": "IN",
    "dropphyzpp": 467049998,
    "dropmaladd": "11400 ARCOLA RD STE B1",
    "dropmalcty": "ARCOLA",
    "dropmalst": "IN",
    "dropmalzpp": 467049998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606258029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11471",
    "droptype": "D",
    "dropname": "ARGOS",
    "dropdeladd": "140 W WALNUT ST",
    "dropdelcty": "ARGOS",
    "dropdelst": "IN",
    "dropdelzpp": 465019998,
    "dropphyadd": "140 W WALNUT ST",
    "dropphycty": "ARGOS",
    "dropphyst": "IN",
    "dropphyzpp": 465019998,
    "dropmaladd": "140 W WALNUT ST",
    "dropmalcty": "ARGOS",
    "dropmalst": "IN",
    "dropmalzpp": 465019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748925716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11474",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "2150 N 700 W",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 461049998,
    "dropphyadd": "2150 N 700 W",
    "dropphycty": "ARLINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 461049998,
    "dropmaladd": "2150 N 700 W",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 461049998,
    "dropsitphn": 7659323139,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656632649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11490",
    "droptype": "D",
    "dropname": "ASHLEY",
    "dropdeladd": "114 W STATE ST",
    "dropdelcty": "ASHLEY",
    "dropdelst": "IN",
    "dropdelzpp": 467059998,
    "dropphyadd": "114 W STATE ST",
    "dropphycty": "ASHLEY",
    "dropphyst": "IN",
    "dropphyzpp": 467059998,
    "dropmaladd": "114 W STATE ST",
    "dropmalcty": "ASHLEY",
    "dropmalst": "IN",
    "dropmalzpp": 467059998,
    "dropsitphn": 2605879273,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605879219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11495",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "150 W MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "IN",
    "dropdelzpp": 460319998,
    "dropphyadd": "150 W MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "IN",
    "dropphyzpp": 460319998,
    "dropmaladd": "150 W MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "IN",
    "dropmalzpp": 460319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652922152,
    "dropfax": 7652923022
  },
  {
    "dcode": "D",
    "dropkey": "PX11496",
    "droptype": "D",
    "dropname": "ATTICA",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "ATTICA",
    "dropdelst": "IN",
    "dropdelzpp": 479189998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "ATTICA",
    "dropphyst": "IN",
    "dropphyzpp": 479189998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "ATTICA",
    "dropmalst": "IN",
    "dropmalzpp": 479189998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657623360,
    "dropfax": 7657622343
  },
  {
    "dcode": "D",
    "dropkey": "PX11497",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "216 E MAIN ST",
    "dropdelcty": "ATWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 465029998,
    "dropphyadd": "216 E MAIN ST",
    "dropphycty": "ATWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 465029998,
    "dropmaladd": "216 E MAIN ST",
    "dropmalcty": "ATWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 465029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748582426,
    "dropfax": 5748582426
  },
  {
    "dcode": "D",
    "dropkey": "PX11498",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "201 S JACKSON ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "IN",
    "dropdelzpp": 467069998,
    "dropphyadd": "201 S JACKSON ST",
    "dropphycty": "AUBURN",
    "dropphyst": "IN",
    "dropphyzpp": 467069998,
    "dropmaladd": "201 S JACKSON ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "IN",
    "dropmalzpp": 467069998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2609254760,
    "dropfax": 2609259059
  },
  {
    "dcode": "D",
    "dropkey": "PX11501",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "501 3RD ST",
    "dropdelcty": "AURORA",
    "dropdelst": "IN",
    "dropdelzpp": 470019998,
    "dropphyadd": "501 3RD ST",
    "dropphycty": "AURORA",
    "dropphyst": "IN",
    "dropphyzpp": 470019998,
    "dropmaladd": "501 3RD ST",
    "dropmalcty": "AURORA",
    "dropmalst": "IN",
    "dropmalzpp": 470019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8129263898,
    "dropfax": 8129260598
  },
  {
    "dcode": "D",
    "dropkey": "PX11502",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "55 N 2ND ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "IN",
    "dropdelzpp": 471029998,
    "dropphyadd": "55 N 2ND ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "IN",
    "dropphyzpp": 471029998,
    "dropmaladd": "55 N 2ND ST",
    "dropmalcty": "AUSTIN",
    "dropmalst": "IN",
    "dropmalzpp": 471029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127942321,
    "dropfax": 8127943083
  },
  {
    "dcode": "D",
    "dropkey": "PX11503",
    "droptype": "D",
    "dropname": "AVILLA",
    "dropdeladd": "227 E ALBION ST",
    "dropdelcty": "AVILLA",
    "dropdelst": "IN",
    "dropdelzpp": 467109998,
    "dropphyadd": "227 E ALBION ST",
    "dropphycty": "AVILLA",
    "dropphyst": "IN",
    "dropphyzpp": 467109998,
    "dropmaladd": "227 E ALBION ST",
    "dropmalcty": "AVILLA",
    "dropmalst": "IN",
    "dropmalzpp": 467109998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608972221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11504",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "8464 STATE ROAD 54 W",
    "dropdelcty": "AVOCA",
    "dropdelst": "IN",
    "dropdelzpp": 474209998,
    "dropphyadd": "8464 STATE ROAD 54 W",
    "dropphycty": "AVOCA",
    "dropphyst": "IN",
    "dropphyzpp": 474209998,
    "dropmaladd": "8464 STATE ROAD 54 W",
    "dropmalcty": "AVOCA",
    "dropmalst": "IN",
    "dropmalzpp": 474209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122799344,
    "dropfax": 8122790375
  },
  {
    "dcode": "D",
    "dropkey": "PX11517",
    "droptype": "D",
    "dropname": "BAINBRIDGE",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "BAINBRIDGE",
    "dropdelst": "IN",
    "dropdelzpp": 461059998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "BAINBRIDGE",
    "dropphyst": "IN",
    "dropphyzpp": 461059998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "BAINBRIDGE",
    "dropmalst": "IN",
    "dropmalzpp": 461059998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655226720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11526",
    "droptype": "D",
    "dropname": "BARGERSVILLE",
    "dropdeladd": "71 E HARRIMAN AVE",
    "dropdelcty": "BARGERSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461065534,
    "dropphyadd": "71 E HARRIMAN AVE",
    "dropphycty": "BARGERSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461065534,
    "dropmaladd": "71 E HARRIMAN AVE",
    "dropmalcty": "BARGERSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461065534,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174225866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11539",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "3 W GEORGE ST",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 470069998,
    "dropphyadd": "3 W GEORGE ST",
    "dropphycty": "BATESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 470069998,
    "dropmaladd": "3 W GEORGE ST",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 470069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8129343301,
    "dropsitcph": 8129343301,
    "dropfax": 8129340421
  },
  {
    "dcode": "D",
    "dropkey": "PX11542",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "14201 SPRINGFIELD RD",
    "dropdelcty": "BATH",
    "dropdelst": "IN",
    "dropdelzpp": 470109998,
    "dropphyadd": "14201 SPRINGFIELD RD",
    "dropphycty": "BATH",
    "dropphyst": "IN",
    "dropphyzpp": 470109998,
    "dropmaladd": "14201 SPRINGFIELD RD",
    "dropmalcty": "BATH",
    "dropmalst": "IN",
    "dropmalzpp": 470109998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7657323207,
    "dropsitcph": 7657323207,
    "dropfax": 7657323207
  },
  {
    "dcode": "D",
    "dropkey": "PX11544",
    "droptype": "D",
    "dropname": "BATTLE GROUND",
    "dropdeladd": "107 NORTH ST",
    "dropdelcty": "BATTLE GROUND",
    "dropdelst": "IN",
    "dropdelzpp": 479209998,
    "dropphyadd": "107 NORTH ST",
    "dropphycty": "BATTLE GROUND",
    "dropphyst": "IN",
    "dropphyzpp": 479209998,
    "dropmaladd": "107 NORTH ST",
    "dropmalcty": "BATTLE GROUND",
    "dropmalst": "IN",
    "dropmalzpp": 479209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655672639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11550",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "1720 H ST",
    "dropdelcty": "BEDFORD",
    "dropdelst": "IN",
    "dropdelzpp": 474219998,
    "dropphyadd": "1720 H ST",
    "dropphycty": "BEDFORD",
    "dropphyst": "IN",
    "dropphyzpp": 474219998,
    "dropmaladd": "1720 H ST",
    "dropmalcty": "BEDFORD",
    "dropmalst": "IN",
    "dropmalzpp": 474219998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122794083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11555",
    "droptype": "D",
    "dropname": "BEECH GROVE",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "BEECH GROVE",
    "dropdelst": "IN",
    "dropdelzpp": 461079998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "BEECH GROVE",
    "dropphyst": "IN",
    "dropphyzpp": 461079998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "BEECH GROVE",
    "dropmalst": "IN",
    "dropmalzpp": 461079998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646807,
    "dropfax": 3174646811
  },
  {
    "dcode": "D",
    "dropkey": "PX11569",
    "droptype": "D",
    "dropname": "BENTONVILLE",
    "dropdeladd": "7029 N COUNTY ROAD 550 W",
    "dropdelcty": "BENTONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473229998,
    "dropphyadd": "7029 N COUNTY ROAD 550 W",
    "dropphycty": "BENTONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473229998,
    "dropmaladd": "7029 N COUNTY ROAD 550 W",
    "dropmalcty": "BENTONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654784949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11574",
    "droptype": "D",
    "dropname": "BERNE",
    "dropdeladd": "215 W MAIN ST",
    "dropdelcty": "BERNE",
    "dropdelst": "IN",
    "dropdelzpp": 467119998,
    "dropphyadd": "215 W MAIN ST",
    "dropphycty": "BERNE",
    "dropphyst": "IN",
    "dropphyzpp": 467119998,
    "dropmaladd": "215 W MAIN ST",
    "dropmalcty": "BERNE",
    "dropmalst": "IN",
    "dropmalzpp": 467119998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605892159,
    "dropfax": 2605892063
  },
  {
    "dcode": "D",
    "dropkey": "PX11577",
    "droptype": "D",
    "dropname": "BEVERLY SHORES",
    "dropdeladd": "165 E US HWY 12",
    "dropdelcty": "BEVERLY SHORES",
    "dropdelst": "IN",
    "dropdelzpp": 463019998,
    "dropphyadd": "165 E US HWY 12",
    "dropphycty": "BEVERLY SHORES",
    "dropphyst": "IN",
    "dropphyzpp": 463019998,
    "dropmaladd": "165 E US HWY 12",
    "dropmalcty": "BEVERLY SHORES",
    "dropmalst": "IN",
    "dropmalzpp": 463019998,
    "dropsitphn": 2198726010,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198726010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11579",
    "droptype": "D",
    "dropname": "BICKNELL",
    "dropdeladd": "117 E 3RD ST",
    "dropdelcty": "BICKNELL",
    "dropdelst": "IN",
    "dropdelzpp": 475129998,
    "dropphyadd": "117 E 3RD ST",
    "dropphycty": "BICKNELL",
    "dropphyst": "IN",
    "dropphyzpp": 475129998,
    "dropmaladd": "117 E 3RD ST",
    "dropmalcty": "BICKNELL",
    "dropmalst": "IN",
    "dropmalzpp": 475129998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127354557,
    "dropfax": 8127354603
  },
  {
    "dcode": "D",
    "dropkey": "PX11586",
    "droptype": "D",
    "dropname": "BIRDSEYE",
    "dropdeladd": "201 S STATE ROAD 145",
    "dropdelcty": "BIRDSEYE",
    "dropdelst": "IN",
    "dropdelzpp": 475139998,
    "dropphyadd": "201 S STATE ROAD 145",
    "dropphycty": "BIRDSEYE",
    "dropphyst": "IN",
    "dropphyzpp": 475139998,
    "dropmaladd": "201 S STATE ROAD 145",
    "dropmalcty": "BIRDSEYE",
    "dropmalst": "IN",
    "dropmalzpp": 475139998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123892300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11593",
    "droptype": "D",
    "dropname": "BLANFORD",
    "dropdeladd": "15008 S MAIN ST",
    "dropdelcty": "BLANFORD",
    "dropdelst": "IN",
    "dropdelzpp": 478319998,
    "dropphyadd": "15008 S MAIN ST",
    "dropphycty": "BLANFORD",
    "dropphyst": "IN",
    "dropphyzpp": 478319998,
    "dropmaladd": "15008 S MAIN ST",
    "dropmalcty": "BLANFORD",
    "dropmalst": "IN",
    "dropmalzpp": 478319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658323708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11597",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "55 N WASHINGTON ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 474249998,
    "dropphyadd": "55 N WASHINGTON ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 474249998,
    "dropmaladd": "55 N WASHINGTON ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 474249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123848195,
    "dropfax": 8123843638
  },
  {
    "dcode": "D",
    "dropkey": "PX11600",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "90 S MAIN ST",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "IN",
    "dropdelzpp": 478329998,
    "dropphyadd": "90 S MAIN ST",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "IN",
    "dropphyzpp": 478329998,
    "dropmaladd": "90 S MAIN ST",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "IN",
    "dropmalzpp": 478329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654982933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11606",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "520 S WALNUT ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474019901,
    "dropphyadd": "520 S WALNUT ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474019901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123347013,
    "dropfax": 8123345982
  },
  {
    "dcode": "D",
    "dropkey": "PX11612",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "IN",
    "dropdelzpp": 467149998,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "BLUFFTON",
    "dropphyst": "IN",
    "dropphyzpp": 467149998,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "IN",
    "dropmalzpp": 467149998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608240310,
    "dropfax": 2608249079
  },
  {
    "dcode": "D",
    "dropkey": "PX11622",
    "droptype": "D",
    "dropname": "BOONE GROVE",
    "dropdeladd": "348 W 550 S",
    "dropdelcty": "BOONE GROVE",
    "dropdelst": "IN",
    "dropdelzpp": 463029998,
    "dropphyadd": "348 W 550 S",
    "dropphycty": "BOONE GROVE",
    "dropphyst": "IN",
    "dropphyzpp": 463029998,
    "dropmaladd": "348 W 550 S",
    "dropmalcty": "BOONE GROVE",
    "dropmalst": "IN",
    "dropmalzpp": 463029998,
    "dropsitphn": 2194622623,
    "dropsitlph": 3174646350,
    "dropsitcph": 2194622623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11624",
    "droptype": "D",
    "dropname": "BOONVILLE",
    "dropdeladd": "214 W LOCUST ST",
    "dropdelcty": "BOONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 476019998,
    "dropphyadd": "214 W LOCUST ST",
    "dropphycty": "BOONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 476019998,
    "dropmaladd": "214 W LOCUST ST",
    "dropmalcty": "BOONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 476019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128970570,
    "dropfax": 8128974406
  },
  {
    "dcode": "D",
    "dropkey": "PX11627",
    "droptype": "D",
    "dropname": "BORDEN",
    "dropdeladd": "1042 E WATER ST",
    "dropdelcty": "BORDEN",
    "dropdelst": "IN",
    "dropdelzpp": 471069998,
    "dropphyadd": "1042 E WATER ST",
    "dropphycty": "BORDEN",
    "dropphyst": "IN",
    "dropphyzpp": 471069998,
    "dropmaladd": "1042 E WATER ST",
    "dropmalcty": "BORDEN",
    "dropmalst": "IN",
    "dropmalzpp": 471069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129672935,
    "dropfax": 8129672935
  },
  {
    "dcode": "D",
    "dropkey": "PX11628",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "103 S SALEM ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "IN",
    "dropdelzpp": 473249998,
    "dropphyadd": "103 S SALEM ST",
    "dropphycty": "BOSTON",
    "dropphyst": "IN",
    "dropphyzpp": 473249998,
    "dropmaladd": "103 S SALEM ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "IN",
    "dropmalzpp": 473249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659625145,
    "dropfax": 7659625145
  },
  {
    "dcode": "D",
    "dropkey": "PX11630",
    "droptype": "D",
    "dropname": "BOSWELL",
    "dropdeladd": "302 E SPIES ST",
    "dropdelcty": "BOSWELL",
    "dropdelst": "IN",
    "dropdelzpp": 479219998,
    "dropphyadd": "302 E SPIES ST",
    "dropphycty": "BOSWELL",
    "dropphyst": "IN",
    "dropphyzpp": 479219998,
    "dropmaladd": "302 E SPIES ST",
    "dropmalcty": "BOSWELL",
    "dropmalst": "IN",
    "dropmalzpp": 479219998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658695007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11633",
    "droptype": "D",
    "dropname": "BOURBON",
    "dropdeladd": "221 N MAIN ST",
    "dropdelcty": "BOURBON",
    "dropdelst": "IN",
    "dropdelzpp": 465049998,
    "dropphyadd": "221 N MAIN ST",
    "dropphycty": "BOURBON",
    "dropphyst": "IN",
    "dropphyzpp": 465049998,
    "dropmaladd": "221 N MAIN ST",
    "dropmalcty": "BOURBON",
    "dropmalst": "IN",
    "dropmalzpp": 465049998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5743423175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11635",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "5181 E STATE ROAD 46",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "IN",
    "dropdelzpp": 478339998,
    "dropphyadd": "5181 E STATE ROAD 46",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "IN",
    "dropphyzpp": 478339998,
    "dropmaladd": "5181 E STATE ROAD 46",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "IN",
    "dropmalzpp": 478339998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129862595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11650",
    "droptype": "D",
    "dropname": "BRAZIL",
    "dropdeladd": "227 W NATIONAL AVE",
    "dropdelcty": "BRAZIL",
    "dropdelst": "IN",
    "dropdelzpp": 478349998,
    "dropphyadd": "227 W NATIONAL AVE",
    "dropphycty": "BRAZIL",
    "dropphyst": "IN",
    "dropphyzpp": 478349998,
    "dropmaladd": "227 W NATIONAL AVE",
    "dropmalcty": "BRAZIL",
    "dropmalst": "IN",
    "dropmalzpp": 478349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124481293,
    "dropfax": 8124438447
  },
  {
    "dcode": "D",
    "dropkey": "PX11653",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "201 N CENTER ST",
    "dropdelcty": "BREMEN",
    "dropdelst": "IN",
    "dropdelzpp": 465069998,
    "dropphyadd": "201 N CENTER ST",
    "dropphycty": "BREMEN",
    "dropphyst": "IN",
    "dropphyzpp": 465069998,
    "dropmaladd": "201 N CENTER ST",
    "dropmalcty": "BREMEN",
    "dropmalst": "IN",
    "dropmalzpp": 465069998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745462717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11661",
    "droptype": "D",
    "dropname": "BRIDGETON",
    "dropdeladd": "8128 S BRIDGETON RD",
    "dropdelcty": "BRIDGETON",
    "dropdelst": "IN",
    "dropdelzpp": 478369998,
    "dropphyadd": "8128 S BRIDGETON RD",
    "dropphycty": "BRIDGETON",
    "dropphyst": "IN",
    "dropphyzpp": 478369998,
    "dropmaladd": "8128 S BRIDGETON RD",
    "dropmalcty": "BRIDGETON",
    "dropmalst": "IN",
    "dropmalzpp": 478369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655482974,
    "dropfax": 7655482974
  },
  {
    "dcode": "D",
    "dropkey": "PX11669",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "206 W VISTULA ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "IN",
    "dropdelzpp": 465079998,
    "dropphyadd": "206 W VISTULA ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "IN",
    "dropphyzpp": 465079998,
    "dropmaladd": "206 W VISTULA ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "IN",
    "dropmalzpp": 465079998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748484713,
    "dropfax": 5748485976
  },
  {
    "dcode": "D",
    "dropkey": "PX11670",
    "droptype": "D",
    "dropname": "BRISTOW",
    "dropdeladd": "4648 FIRST ST",
    "dropdelcty": "BRISTOW",
    "dropdelst": "IN",
    "dropdelzpp": 475159998,
    "dropphyadd": "4648 FIRST ST",
    "dropphycty": "BRISTOW",
    "dropphyst": "IN",
    "dropphyzpp": 475159998,
    "dropmaladd": "4648 FIRST ST",
    "dropmalcty": "BRISTOW",
    "dropmalst": "IN",
    "dropmalzpp": 475159998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128435434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11680",
    "droptype": "D",
    "dropname": "BROOK",
    "dropdeladd": "308 W MAIN ST",
    "dropdelcty": "BROOK",
    "dropdelst": "IN",
    "dropdelzpp": 479229998,
    "dropphyadd": "308 W MAIN ST",
    "dropphycty": "BROOK",
    "dropphyst": "IN",
    "dropphyzpp": 479229998,
    "dropmaladd": "308 W MAIN ST",
    "dropmalcty": "BROOK",
    "dropmalst": "IN",
    "dropmalzpp": 479229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 2194646305,
    "dropsitcph": 2192756555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11682",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "8 N MAIN ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "IN",
    "dropdelzpp": 461119998,
    "dropphyadd": "8 N MAIN ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "IN",
    "dropphyzpp": 461119998,
    "dropmaladd": "8 N MAIN ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "IN",
    "dropmalzpp": 461119998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178317142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11686",
    "droptype": "D",
    "dropname": "BROOKSTON",
    "dropdeladd": "205 S SOUTH ST",
    "dropdelcty": "BROOKSTON",
    "dropdelst": "IN",
    "dropdelzpp": 479239998,
    "dropphyadd": "205 S SOUTH ST",
    "dropphycty": "BROOKSTON",
    "dropphyst": "IN",
    "dropphyzpp": 479239998,
    "dropmaladd": "205 S SOUTH ST",
    "dropmalcty": "BROOKSTON",
    "dropmalst": "IN",
    "dropmalzpp": 479239998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655636466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11687",
    "droptype": "D",
    "dropname": "BROOKVILLE",
    "dropdeladd": "1019 MAIN ST",
    "dropdelcty": "BROOKVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 470129998,
    "dropphyadd": "1019 MAIN ST",
    "dropphycty": "BROOKVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 470129998,
    "dropmaladd": "1019 MAIN ST",
    "dropmalcty": "BROOKVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 470129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 7656470541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11695",
    "droptype": "D",
    "dropname": "BROWNSBURG",
    "dropdeladd": "411 E NORTHFIELD DR",
    "dropdelcty": "BROWNSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 461129998,
    "dropphyadd": "411 E NORTHFIELD DR",
    "dropphycty": "BROWNSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 461129998,
    "dropmaladd": "411 E NORTHFIELD DR",
    "dropmalcty": "BROWNSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 461129998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178523943,
    "dropfax": 3178588061
  },
  {
    "dcode": "D",
    "dropkey": "PX11696",
    "droptype": "D",
    "dropname": "BROWNSTOWN",
    "dropdeladd": "201 S SUGAR ST",
    "dropdelcty": "BROWNSTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 472209998,
    "dropphyadd": "201 S SUGAR ST",
    "dropphycty": "BROWNSTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 472209998,
    "dropmaladd": "201 S SUGAR ST",
    "dropmalcty": "BROWNSTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 472209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123583703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11699",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473259998,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473259998,
    "dropmaladd": "104 N MAIN ST",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654586812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11702",
    "droptype": "D",
    "dropname": "BRUCEVILLE",
    "dropdeladd": "501 W MAIN ST",
    "dropdelcty": "BRUCEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 475169998,
    "dropphyadd": "501 W MAIN ST",
    "dropphycty": "BRUCEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 475169998,
    "dropmaladd": "501 W MAIN ST",
    "dropmalcty": "BRUCEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 475169998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123242028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11709",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "BRYANT",
    "dropdelst": "IN",
    "dropdelzpp": 473269998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "BRYANT",
    "dropphyst": "IN",
    "dropphyzpp": 473269998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "BRYANT",
    "dropmalst": "IN",
    "dropmalzpp": 473269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2609976206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11715",
    "droptype": "D",
    "dropname": "BUCK CREEK",
    "dropdeladd": "7424 RAILROAD ST",
    "dropdelcty": "BUCK CREEK",
    "dropdelst": "IN",
    "dropdelzpp": 479249998,
    "dropphyadd": "7424 RAILROAD ST",
    "dropphycty": "BUCK CREEK",
    "dropphyst": "IN",
    "dropphyzpp": 479249998,
    "dropmaladd": "7424 RAILROAD ST",
    "dropmalcty": "BUCK CREEK",
    "dropmalst": "IN",
    "dropmalzpp": 479249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655898343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11722",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "104 S MIDDLE ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "IN",
    "dropdelzpp": 479259998,
    "dropphyadd": "104 S MIDDLE ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "IN",
    "dropphyzpp": 479259998,
    "dropmaladd": "104 S MIDDLE ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "IN",
    "dropmalzpp": 479259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742787189,
    "dropfax": 5742787120
  },
  {
    "dcode": "D",
    "dropkey": "PX11727",
    "droptype": "D",
    "dropname": "BUNKER HILL",
    "dropdeladd": "150 E BROADWAY",
    "dropdelcty": "BUNKER HILL",
    "dropdelst": "IN",
    "dropdelzpp": 469149998,
    "dropphyadd": "150 E BROADWAY",
    "dropphycty": "BUNKER HILL",
    "dropphyst": "IN",
    "dropphyzpp": 469149998,
    "dropmaladd": "150 E BROADWAY",
    "dropmalcty": "BUNKER HILL",
    "dropmalst": "IN",
    "dropmalzpp": 469149998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656899025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11734",
    "droptype": "D",
    "dropname": "BURKET",
    "dropdeladd": "122 E MAIN ST",
    "dropdelcty": "BURKET",
    "dropdelst": "IN",
    "dropdelzpp": 465089998,
    "dropphyadd": "122 E MAIN ST",
    "dropphycty": "BURKET",
    "dropphyst": "IN",
    "dropphyzpp": 465089998,
    "dropmaladd": "122 E MAIN ST",
    "dropmalcty": "BURKET",
    "dropmalst": "IN",
    "dropmalzpp": 465089998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5744913672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11736",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "809 MICHIGAN RD",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 469159998,
    "dropphyadd": "809 MICHIGAN RD",
    "dropphycty": "BURLINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 469159998,
    "dropmaladd": "809 MICHIGAN RD",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 469159998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655663551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11739",
    "droptype": "D",
    "dropname": "BURNETTSVILLE",
    "dropdeladd": "310 LOGAN ST",
    "dropdelcty": "BURNETTSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479269998,
    "dropphyadd": "310 LOGAN ST",
    "dropphycty": "BURNETTSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479269998,
    "dropmaladd": "310 LOGAN ST",
    "dropmalcty": "BURNETTSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748264280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11747",
    "droptype": "D",
    "dropname": "BURROWS",
    "dropdeladd": "1010 BURROWS RD",
    "dropdelcty": "BURROWS",
    "dropdelst": "IN",
    "dropdelzpp": 469169998,
    "dropphyadd": "1010 BURROWS RD",
    "dropphycty": "BURROWS",
    "dropphyst": "IN",
    "dropphyzpp": 469169998,
    "dropmaladd": "1010 BURROWS RD",
    "dropmalcty": "BURROWS",
    "dropmalst": "IN",
    "dropmalzpp": 469169998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746522472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11753",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "119 N BROADWAY ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "IN",
    "dropdelzpp": 467219998,
    "dropphyadd": "119 N BROADWAY ST",
    "dropphycty": "BUTLER",
    "dropphyst": "IN",
    "dropphyzpp": 467219998,
    "dropmaladd": "119 N BROADWAY ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "IN",
    "dropmalzpp": 467219998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608682179,
    "dropfax": 2608685402
  },
  {
    "dcode": "D",
    "dropkey": "PX11755",
    "droptype": "D",
    "dropname": "BUTLERVILLE",
    "dropdeladd": "5270 E US HIGHWAY 50",
    "dropdelcty": "BUTLERVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 472239998,
    "dropphyadd": "5270 E US HIGHWAY 50",
    "dropphycty": "BUTLERVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 472239998,
    "dropmaladd": "5270 E US HIGHWAY 50",
    "dropmalcty": "BUTLERVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 472239998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124586927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11763",
    "droptype": "D",
    "dropname": "CAMBRIDGE CITY",
    "dropdeladd": "227 W MAIN ST",
    "dropdelcty": "CAMBRIDGE CITY",
    "dropdelst": "IN",
    "dropdelzpp": 473279998,
    "dropphyadd": "227 W MAIN ST",
    "dropphycty": "CAMBRIDGE CITY",
    "dropphyst": "IN",
    "dropphyzpp": 473279998,
    "dropmaladd": "227 W MAIN ST",
    "dropmalcty": "CAMBRIDGE CITY",
    "dropmalst": "IN",
    "dropmalzpp": 473279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654783831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11766",
    "droptype": "D",
    "dropname": "CAMBY",
    "dropdeladd": "8255 CAMBY RD",
    "dropdelcty": "CAMBY",
    "dropdelst": "IN",
    "dropdelzpp": 461139998,
    "dropphyadd": "8255 CAMBY RD",
    "dropphycty": "CAMBY",
    "dropphyst": "IN",
    "dropphyzpp": 461139998,
    "dropmaladd": "8255 CAMBY RD",
    "dropmalcty": "CAMBY",
    "dropmalst": "IN",
    "dropmalzpp": 461139998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178563077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11767",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "IN",
    "dropdelzpp": 469179998,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "IN",
    "dropphyzpp": 469179998,
    "dropmaladd": "108 W MAIN ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "IN",
    "dropmalzpp": 469179998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746862464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11769",
    "droptype": "D",
    "dropname": "CAMPBELLSBURG",
    "dropdeladd": "55 W OAK ST",
    "dropdelcty": "CAMPBELLSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 471089998,
    "dropphyadd": "55 W OAK ST",
    "dropphycty": "CAMPBELLSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 471089998,
    "dropmaladd": "55 W OAK ST",
    "dropmalcty": "CAMPBELLSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 471089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127554635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11770",
    "droptype": "D",
    "dropname": "CANAAN",
    "dropdeladd": "8988 N MAIN ST",
    "dropdelcty": "CANAAN",
    "dropdelst": "IN",
    "dropdelzpp": 472249998,
    "dropphyadd": "8988 N MAIN ST",
    "dropphycty": "CANAAN",
    "dropphyst": "IN",
    "dropphyzpp": 472249998,
    "dropmaladd": "8988 N MAIN ST",
    "dropmalcty": "CANAAN",
    "dropmalst": "IN",
    "dropmalzpp": 472249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128394600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11772",
    "droptype": "D",
    "dropname": "CANNELTON",
    "dropdeladd": "217 WASHINGTON ST",
    "dropdelcty": "CANNELTON",
    "dropdelst": "IN",
    "dropdelzpp": 475209998,
    "dropphyadd": "217 WASHINGTON ST",
    "dropphycty": "CANNELTON",
    "dropphyst": "IN",
    "dropphyzpp": 475209998,
    "dropmaladd": "217 WASHINGTON ST",
    "dropmalcty": "CANNELTON",
    "dropmalst": "IN",
    "dropmalzpp": 475209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125474271,
    "dropfax": 8125477557
  },
  {
    "dcode": "D",
    "dropkey": "PX11777",
    "droptype": "D",
    "dropname": "CARBON",
    "dropdeladd": "14641 N POPLAR ST",
    "dropdelcty": "CARBON",
    "dropdelst": "IN",
    "dropdelzpp": 478379998,
    "dropphyadd": "14641 N POPLAR ST",
    "dropphycty": "CARBON",
    "dropphyst": "IN",
    "dropphyzpp": 478379998,
    "dropmaladd": "14641 N POPLAR ST",
    "dropmalcty": "CARBON",
    "dropmalst": "IN",
    "dropmalzpp": 478379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124483112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11780",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "119 N LEDGERWOOD ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "IN",
    "dropdelzpp": 478389998,
    "dropphyadd": "119 N LEDGERWOOD ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "IN",
    "dropphyzpp": 478389998,
    "dropmaladd": "119 N LEDGERWOOD ST",
    "dropmalcty": "CARLISLE",
    "dropmalst": "IN",
    "dropmalzpp": 478389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123984693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11782",
    "droptype": "D",
    "dropname": "CARMEL",
    "dropdeladd": "275 MEDICAL DR",
    "dropdelcty": "CARMEL",
    "dropdelst": "IN",
    "dropdelzpp": 460329998,
    "dropphyadd": "275 MEDICAL DR",
    "dropphycty": "CARMEL",
    "dropphyst": "IN",
    "dropphyzpp": 460329998,
    "dropmaladd": "275 MEDICAL DR",
    "dropmalcty": "CARMEL",
    "dropmalst": "IN",
    "dropmalzpp": 460329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178462489,
    "dropfax": 6513066813
  },
  {
    "dcode": "D",
    "dropkey": "PX11789",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "2 W MILL ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "IN",
    "dropdelzpp": 461159998,
    "dropphyadd": "2 W MILL ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "IN",
    "dropphyzpp": 461159998,
    "dropmaladd": "2 W MILL ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "IN",
    "dropmalzpp": 461159998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655656150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11802",
    "droptype": "D",
    "dropname": "CAYUGA",
    "dropdeladd": "200 W CURTIS ST",
    "dropdelcty": "CAYUGA",
    "dropdelst": "IN",
    "dropdelzpp": 479289998,
    "dropphyadd": "200 W CURTIS ST",
    "dropphycty": "CAYUGA",
    "dropphyst": "IN",
    "dropphyzpp": 479289998,
    "dropmaladd": "200 W CURTIS ST",
    "dropmalcty": "CAYUGA",
    "dropmalst": "IN",
    "dropmalzpp": 479289998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654924063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11805",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "204 CENTRAL AVE",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "IN",
    "dropdelzpp": 470169998,
    "dropphyadd": "204 CENTRAL AVE",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "IN",
    "dropphyzpp": 470169998,
    "dropmaladd": "204 CENTRAL AVE",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "IN",
    "dropmalzpp": 470169998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7656476122,
    "dropsitcph": 7656476122,
    "dropfax": 7656472307
  },
  {
    "dcode": "D",
    "dropkey": "PX11807",
    "droptype": "D",
    "dropname": "CEDAR LAKE",
    "dropdeladd": "9715 W 133RD AVE",
    "dropdelcty": "CEDAR LAKE",
    "dropdelst": "IN",
    "dropdelzpp": 463039998,
    "dropphyadd": "9715 W 133RD AVE",
    "dropphycty": "CEDAR LAKE",
    "dropphyst": "IN",
    "dropphyzpp": 463039998,
    "dropmaladd": "9715 W 133RD AVE",
    "dropmalcty": "CEDAR LAKE",
    "dropmalst": "IN",
    "dropmalzpp": 463039998,
    "dropsitphn": 2193747633,
    "dropsitlph": 2193747633,
    "dropsitcph": 2193747633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11811",
    "droptype": "D",
    "dropname": "CELESTINE",
    "dropdeladd": "365 N CELESTINE RD S",
    "dropdelcty": "CELESTINE",
    "dropdelst": "IN",
    "dropdelzpp": 475219998,
    "dropphyadd": "365 N CELESTINE RD S",
    "dropphycty": "CELESTINE",
    "dropphyst": "IN",
    "dropphyzpp": 475219998,
    "dropmaladd": "365 N CELESTINE RD S",
    "dropmalcty": "CELESTINE",
    "dropmalst": "IN",
    "dropmalzpp": 475219998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126341829,
    "dropfax": 8126340829
  },
  {
    "dcode": "D",
    "dropkey": "PX11819",
    "droptype": "D",
    "dropname": "CENTERPOINT",
    "dropdeladd": "504 E MAIN ST",
    "dropdelcty": "CENTERPOINT",
    "dropdelst": "IN",
    "dropdelzpp": 478409998,
    "dropphyadd": "504 E MAIN ST",
    "dropphycty": "CENTERPOINT",
    "dropphyst": "IN",
    "dropphyzpp": 478409998,
    "dropmaladd": "504 E MAIN ST",
    "dropmalcty": "CENTERPOINT",
    "dropmalst": "IN",
    "dropmalzpp": 478409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128355331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11822",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "300 E MAIN ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473309998,
    "dropphyadd": "300 E MAIN ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473309998,
    "dropmaladd": "300 E MAIN ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658555121,
    "dropfax": 7658555447
  },
  {
    "dcode": "D",
    "dropkey": "PX11828",
    "droptype": "D",
    "dropname": "CHALMERS",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "CHALMERS",
    "dropdelst": "IN",
    "dropdelzpp": 479299998,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "CHALMERS",
    "dropphyst": "IN",
    "dropphyzpp": 479299998,
    "dropmaladd": "108 E MAIN ST",
    "dropmalcty": "CHALMERS",
    "dropmalst": "IN",
    "dropmalzpp": 479299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2199845031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11831",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "211 W LINCOLN AVE",
    "dropdelcty": "CHANDLER",
    "dropdelst": "IN",
    "dropdelzpp": 476109998,
    "dropphyadd": "211 W LINCOLN AVE",
    "dropphycty": "CHANDLER",
    "dropphyst": "IN",
    "dropphyzpp": 476109998,
    "dropmaladd": "211 W LINCOLN AVE",
    "dropmalcty": "CHANDLER",
    "dropmalst": "IN",
    "dropmalzpp": 476109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129256816,
    "dropfax": 8129256990
  },
  {
    "dcode": "D",
    "dropkey": "PX11833",
    "droptype": "D",
    "dropname": "CHARLESTOWN",
    "dropdeladd": "361 MAIN CROSS ST",
    "dropdelcty": "CHARLESTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 471119998,
    "dropphyadd": "361 MAIN CROSS ST",
    "dropphycty": "CHARLESTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 471119998,
    "dropmaladd": "361 MAIN CROSS ST",
    "dropmalcty": "CHARLESTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 471119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122562124,
    "dropfax": 8122564574
  },
  {
    "dcode": "D",
    "dropkey": "PX11834",
    "droptype": "D",
    "dropname": "CHARLOTTESVILLE",
    "dropdeladd": "10372 E US HIGHWAY 40",
    "dropdelcty": "CHARLOTTESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461179998,
    "dropphyadd": "10372 E US HIGHWAY 40",
    "dropphycty": "CHARLOTTESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461179998,
    "dropmaladd": "10372 E US HIGHWAY 40",
    "dropmalcty": "CHARLOTTESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461179998,
    "dropsitphn": 7653455575,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179365793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11839",
    "droptype": "D",
    "dropname": "CHESTERTON",
    "dropdeladd": "1070 S CALUMET RD",
    "dropdelcty": "CHESTERTON",
    "dropdelst": "IN",
    "dropdelzpp": 463049998,
    "dropphyadd": "1070 S CALUMET RD",
    "dropphycty": "CHESTERTON",
    "dropphyst": "IN",
    "dropphyzpp": 463049998,
    "dropmaladd": "1070 S CALUMET RD",
    "dropmalcty": "CHESTERTON",
    "dropmalst": "IN",
    "dropmalzpp": 463049998,
    "dropsitphn": 3174646305,
    "dropsitlph": 3174646350,
    "dropsitcph": 2199261236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11843",
    "droptype": "D",
    "dropname": "CHRISNEY",
    "dropdeladd": "23 W MARKET ST",
    "dropdelcty": "CHRISNEY",
    "dropdelst": "IN",
    "dropdelzpp": 476119998,
    "dropphyadd": "23 W MARKET ST",
    "dropphycty": "CHRISNEY",
    "dropphyst": "IN",
    "dropphyzpp": 476119998,
    "dropmaladd": "23 W MARKET ST",
    "dropmalcty": "CHRISNEY",
    "dropmalst": "IN",
    "dropmalzpp": 476119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123628371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11850",
    "droptype": "D",
    "dropname": "CHURUBUSCO",
    "dropdeladd": "123 S MAIN ST",
    "dropdelcty": "CHURUBUSCO",
    "dropdelst": "IN",
    "dropdelzpp": 467239998,
    "dropphyadd": "123 S MAIN ST",
    "dropphycty": "CHURUBUSCO",
    "dropphyst": "IN",
    "dropphyzpp": 467239998,
    "dropmaladd": "123 S MAIN ST",
    "dropmalcty": "CHURUBUSCO",
    "dropmalst": "IN",
    "dropmalzpp": 467239998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606932709,
    "dropfax": 2606939591
  },
  {
    "dcode": "D",
    "dropkey": "PX11851",
    "droptype": "D",
    "dropname": "CICERO",
    "dropdeladd": "69 WASHINGTON AVE",
    "dropdelcty": "CICERO",
    "dropdelst": "IN",
    "dropdelzpp": 460349998,
    "dropphyadd": "69 WASHINGTON AVE",
    "dropphycty": "CICERO",
    "dropphyst": "IN",
    "dropphyzpp": 460349998,
    "dropmaladd": "69 WASHINGTON AVE",
    "dropmalcty": "CICERO",
    "dropmalst": "IN",
    "dropmalzpp": 460349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179844435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11857",
    "droptype": "D",
    "dropname": "CLARKS HILL",
    "dropdeladd": "11750 CLARK ST",
    "dropdelcty": "CLARKS HILL",
    "dropdelst": "IN",
    "dropdelzpp": 479309998,
    "dropphyadd": "11750 CLARK ST",
    "dropphycty": "CLARKS HILL",
    "dropphyst": "IN",
    "dropphyzpp": 479309998,
    "dropmaladd": "11750 CLARK ST",
    "dropmalcty": "CLARKS HILL",
    "dropmalst": "IN",
    "dropmalzpp": 479309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655232110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11861",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "6656 N COUNTY ROAD 700 E",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 472259998,
    "dropphyadd": "6656 N COUNTY ROAD 700 E",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 472259998,
    "dropmaladd": "6656 N COUNTY ROAD 700 E",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 472259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125272004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11866",
    "droptype": "D",
    "dropname": "CLAY CITY",
    "dropdeladd": "804 MAIN ST",
    "dropdelcty": "CLAY CITY",
    "dropdelst": "IN",
    "dropdelzpp": 478419998,
    "dropphyadd": "804 MAIN ST",
    "dropphycty": "CLAY CITY",
    "dropphyst": "IN",
    "dropphyzpp": 478419998,
    "dropmaladd": "804 MAIN ST",
    "dropmalcty": "CLAY CITY",
    "dropmalst": "IN",
    "dropmalzpp": 478419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129393111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11870",
    "droptype": "D",
    "dropname": "CLAYPOOL",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "CLAYPOOL",
    "dropdelst": "IN",
    "dropdelzpp": 465109998,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "CLAYPOOL",
    "dropphyst": "IN",
    "dropphyzpp": 465109998,
    "dropmaladd": "117 S MAIN ST",
    "dropmalcty": "CLAYPOOL",
    "dropmalst": "IN",
    "dropmalzpp": 465109998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745662234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11872",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "38 E KENTUCKY ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "IN",
    "dropdelzpp": 461189998,
    "dropphyadd": "38 E KENTUCKY ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "IN",
    "dropphyzpp": 461189998,
    "dropmaladd": "38 E KENTUCKY ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "IN",
    "dropmalzpp": 461189998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3175396624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11874",
    "droptype": "D",
    "dropname": "CLEAR CREEK",
    "dropdeladd": "4888 S ROGERS ST",
    "dropdelcty": "CLEAR CREEK",
    "dropdelst": "IN",
    "dropdelzpp": 474269998,
    "dropphyadd": "4888 S ROGERS ST",
    "dropphycty": "CLEAR CREEK",
    "dropphyst": "IN",
    "dropphyzpp": 474269998,
    "dropmaladd": "4888 S ROGERS ST",
    "dropmalcty": "CLEAR CREEK",
    "dropmalst": "IN",
    "dropmalzpp": 474269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128242896,
    "dropfax": 8128242896
  },
  {
    "dcode": "D",
    "dropkey": "PX11878",
    "droptype": "D",
    "dropname": "CLIFFORD",
    "dropdeladd": "4832 MILL ST",
    "dropdelcty": "CLIFFORD",
    "dropdelst": "IN",
    "dropdelzpp": 472269998,
    "dropphyadd": "4832 MILL ST",
    "dropphycty": "CLIFFORD",
    "dropphyst": "IN",
    "dropphyzpp": 472269998,
    "dropmaladd": "4832 MILL ST",
    "dropmalcty": "CLIFFORD",
    "dropmalst": "IN",
    "dropmalzpp": 472269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123721764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11879",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "405 VINE ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "IN",
    "dropdelzpp": 478429998,
    "dropphyadd": "405 VINE ST",
    "dropphycty": "CLINTON",
    "dropphyst": "IN",
    "dropphyzpp": 478429998,
    "dropmaladd": "405 VINE ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "IN",
    "dropmalzpp": 478429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658323441,
    "dropfax": 7653325933
  },
  {
    "dcode": "D",
    "dropkey": "PX11882",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "10 N MAIN ST STE 1",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "IN",
    "dropdelzpp": 461209998,
    "dropphyadd": "10 N MAIN ST STE 1",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "IN",
    "dropphyzpp": 461209998,
    "dropmaladd": "10 N MAIN ST STE 1",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "IN",
    "dropmalzpp": 461209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657954315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11888",
    "droptype": "D",
    "dropname": "COAL CITY",
    "dropdeladd": "4225 MAIN ST",
    "dropdelcty": "COAL CITY",
    "dropdelst": "IN",
    "dropdelzpp": 474279998,
    "dropphyadd": "4225 MAIN ST",
    "dropphycty": "COAL CITY",
    "dropphyst": "IN",
    "dropphyzpp": 474279998,
    "dropmaladd": "4225 MAIN ST",
    "dropmalcty": "COAL CITY",
    "dropmalst": "IN",
    "dropmalzpp": 474279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128594277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11891",
    "droptype": "D",
    "dropname": "COALMONT",
    "dropdeladd": "6457 W JASON ST",
    "dropdelcty": "COALMONT",
    "dropdelst": "IN",
    "dropdelzpp": 478459998,
    "dropphyadd": "6457 W JASON ST",
    "dropphycty": "COALMONT",
    "dropphyst": "IN",
    "dropphyzpp": 478459998,
    "dropmaladd": "6457 W JASON ST",
    "dropmalcty": "COALMONT",
    "dropmalst": "IN",
    "dropmalzpp": 478459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126653932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11892",
    "droptype": "D",
    "dropname": "COATESVILLE",
    "dropdeladd": "8041 MAIN ST",
    "dropdelcty": "COATESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461219998,
    "dropphyadd": "8041 MAIN ST",
    "dropphycty": "COATESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461219998,
    "dropmaladd": "8041 MAIN ST",
    "dropmalcty": "COATESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461219998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653867480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11901",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "114 W MAIN ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "IN",
    "dropdelzpp": 460359998,
    "dropphyadd": "114 W MAIN ST",
    "dropphycty": "COLFAX",
    "dropphyst": "IN",
    "dropphyzpp": 460359998,
    "dropmaladd": "114 W MAIN ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "IN",
    "dropmalzpp": 460359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653242560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11913",
    "droptype": "D",
    "dropname": "COLUMBIA CITY",
    "dropdeladd": "115 N CHAUNCEY ST",
    "dropdelcty": "COLUMBIA CITY",
    "dropdelst": "IN",
    "dropdelzpp": 467259998,
    "dropphyadd": "115 N CHAUNCEY ST",
    "dropphycty": "COLUMBIA CITY",
    "dropphyst": "IN",
    "dropphyzpp": 467259998,
    "dropmaladd": "115 N CHAUNCEY ST",
    "dropmalcty": "COLUMBIA CITY",
    "dropmalst": "IN",
    "dropmalzpp": 467259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2602445962,
    "dropfax": 2602444789
  },
  {
    "dcode": "D",
    "dropkey": "PX11921",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "450 JACKSON ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "IN",
    "dropdelzpp": 472019998,
    "dropphyadd": "450 JACKSON ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "IN",
    "dropphyzpp": 472019998,
    "dropmaladd": "450 JACKSON ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "IN",
    "dropmalzpp": 472019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123783521,
    "dropfax": 8123760278
  },
  {
    "dcode": "D",
    "dropkey": "PX11922",
    "droptype": "D",
    "dropname": "COMMISKEY",
    "dropdeladd": "1780 W COUNTY ROAD 850 S",
    "dropdelcty": "COMMISKEY",
    "dropdelst": "IN",
    "dropdelzpp": 472279998,
    "dropphyadd": "1780 W COUNTY ROAD 850 S",
    "dropphycty": "COMMISKEY",
    "dropphyst": "IN",
    "dropphyzpp": 472279998,
    "dropmaladd": "1780 W COUNTY ROAD 850 S",
    "dropmalcty": "COMMISKEY",
    "dropmalst": "IN",
    "dropmalzpp": 472279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123467937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11928",
    "droptype": "D",
    "dropname": "CONNERSVILLE",
    "dropdeladd": "801 N CENTRAL AVE",
    "dropdelcty": "CONNERSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473319998,
    "dropphyadd": "801 N CENTRAL AVE",
    "dropphycty": "CONNERSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473319998,
    "dropmaladd": "801 N CENTRAL AVE",
    "dropmalcty": "CONNERSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658251671,
    "dropfax": 6519943285
  },
  {
    "dcode": "D",
    "dropkey": "PX11931",
    "droptype": "D",
    "dropname": "CONVERSE",
    "dropdeladd": "107 S JEFFERSON ST",
    "dropdelcty": "CONVERSE",
    "dropdelst": "IN",
    "dropdelzpp": 469199998,
    "dropphyadd": "107 S JEFFERSON ST",
    "dropphycty": "CONVERSE",
    "dropphyst": "IN",
    "dropphyzpp": 469199998,
    "dropmaladd": "107 S JEFFERSON ST",
    "dropmalcty": "CONVERSE",
    "dropmalst": "IN",
    "dropmalzpp": 469199998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653953631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11937",
    "droptype": "D",
    "dropname": "CORTLAND",
    "dropdeladd": "3993 E STATE ROAD 258",
    "dropdelcty": "CORTLAND",
    "dropdelst": "IN",
    "dropdelzpp": 472289998,
    "dropphyadd": "3993 E STATE ROAD 258",
    "dropphycty": "CORTLAND",
    "dropphyst": "IN",
    "dropphyzpp": 472289998,
    "dropmaladd": "3993 E STATE ROAD 258",
    "dropmalcty": "CORTLAND",
    "dropmalst": "IN",
    "dropmalzpp": 472289998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125226096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11939",
    "droptype": "D",
    "dropname": "CORUNNA",
    "dropdeladd": "104 N BRIDGE ST",
    "dropdelcty": "CORUNNA",
    "dropdelst": "IN",
    "dropdelzpp": 467309998,
    "dropphyadd": "104 N BRIDGE ST",
    "dropphycty": "CORUNNA",
    "dropphyst": "IN",
    "dropphyzpp": 467309998,
    "dropmaladd": "104 N BRIDGE ST",
    "dropmalcty": "CORUNNA",
    "dropmalst": "IN",
    "dropmalzpp": 467309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2602812561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11940",
    "droptype": "D",
    "dropname": "CORY",
    "dropdeladd": "5160 W DEPOT ST",
    "dropdelcty": "CORY",
    "dropdelst": "IN",
    "dropdelzpp": 478469998,
    "dropphyadd": "5160 W DEPOT ST",
    "dropphycty": "CORY",
    "dropphyst": "IN",
    "dropphyzpp": 478469998,
    "dropmaladd": "5160 W DEPOT ST",
    "dropmalcty": "CORY",
    "dropmalst": "IN",
    "dropmalzpp": 478469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128642454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11941",
    "droptype": "D",
    "dropname": "CORYDON",
    "dropdeladd": "245 W HIGHWAY 62",
    "dropdelcty": "CORYDON",
    "dropdelst": "IN",
    "dropdelzpp": 471129998,
    "dropphyadd": "245 W HIGHWAY 62",
    "dropphycty": "CORYDON",
    "dropphyst": "IN",
    "dropphyzpp": 471129998,
    "dropmaladd": "245 W HIGHWAY 62",
    "dropmalcty": "CORYDON",
    "dropmalst": "IN",
    "dropmalzpp": 471129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127384229,
    "dropfax": 8127386315
  },
  {
    "dcode": "D",
    "dropkey": "PX11949",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "418 LIBERTY ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 479329998,
    "dropphyadd": "418 LIBERTY ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 479329998,
    "dropmaladd": "418 LIBERTY ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 479329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657932581,
    "dropfax": 7657930329
  },
  {
    "dcode": "D",
    "dropkey": "PX11953",
    "droptype": "D",
    "dropname": "CRAIGVILLE",
    "dropdeladd": "2381 N MAIN ST",
    "dropdelcty": "CRAIGVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467319998,
    "dropphyadd": "2381 N MAIN ST",
    "dropphycty": "CRAIGVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467319998,
    "dropmaladd": "2381 N MAIN ST",
    "dropmalcty": "CRAIGVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605653606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11957",
    "droptype": "D",
    "dropname": "CRANDALL",
    "dropdeladd": "6090 WALNUT ST NE",
    "dropdelcty": "CRANDALL",
    "dropdelst": "IN",
    "dropdelzpp": 471149998,
    "dropphyadd": "6090 WALNUT ST NE",
    "dropphycty": "CRANDALL",
    "dropphyst": "IN",
    "dropphyzpp": 471149998,
    "dropmaladd": "6090 WALNUT ST NE",
    "dropmalcty": "CRANDALL",
    "dropmalst": "IN",
    "dropmalzpp": 471149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123663902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11958",
    "droptype": "D",
    "dropname": "CRANE",
    "dropdeladd": "100 BLANDY ST",
    "dropdelcty": "CRANE",
    "dropdelst": "IN",
    "dropdelzpp": 475229998,
    "dropphyadd": "100 BLANDY ST",
    "dropphycty": "CRANE",
    "dropphyst": "IN",
    "dropphyzpp": 475229998,
    "dropmaladd": "100 BLANDY ST",
    "dropmalcty": "CRANE",
    "dropmalst": "IN",
    "dropmalzpp": 475229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128547856,
    "dropfax": 8128540169
  },
  {
    "dcode": "D",
    "dropkey": "PX11963",
    "droptype": "D",
    "dropname": "CRAWFORDSVILLE",
    "dropdeladd": "300 E MAIN ST",
    "dropdelcty": "CRAWFORDSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479339998,
    "dropphyadd": "300 E MAIN ST",
    "dropphycty": "CRAWFORDSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479339998,
    "dropmaladd": "300 E MAIN ST",
    "dropmalcty": "CRAWFORDSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479339998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653620203,
    "dropfax": 7653620363
  },
  {
    "dcode": "D",
    "dropkey": "PX11970",
    "droptype": "D",
    "dropname": "CROMWELL",
    "dropdeladd": "117 N JEFFERSON ST",
    "dropdelcty": "CROMWELL",
    "dropdelst": "IN",
    "dropdelzpp": 467329998,
    "dropphyadd": "117 N JEFFERSON ST",
    "dropphycty": "CROMWELL",
    "dropphyst": "IN",
    "dropphyzpp": 467329998,
    "dropmaladd": "117 N JEFFERSON ST",
    "dropmalcty": "CROMWELL",
    "dropmalst": "IN",
    "dropmalzpp": 467329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608562512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11972",
    "droptype": "D",
    "dropname": "CROSS PLAINS",
    "dropdeladd": "8911 S STATE ROAD 129",
    "dropdelcty": "CROSS PLAINS",
    "dropdelst": "IN",
    "dropdelzpp": 470179998,
    "dropphyadd": "8911 S STATE ROAD 129",
    "dropphycty": "CROSS PLAINS",
    "dropphyst": "IN",
    "dropphyzpp": 470179998,
    "dropmaladd": "8911 S STATE ROAD 129",
    "dropmalcty": "CROSS PLAINS",
    "dropmalst": "IN",
    "dropmalzpp": 470179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126675696,
    "dropsitcph": 8126675696,
    "dropfax": 8126676994
  },
  {
    "dcode": "D",
    "dropkey": "PX11976",
    "droptype": "D",
    "dropname": "CROTHERSVILLE",
    "dropdeladd": "302 E MAIN ST",
    "dropdelcty": "CROTHERSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 472299998,
    "dropphyadd": "302 E MAIN ST",
    "dropphycty": "CROTHERSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 472299998,
    "dropmaladd": "302 E MAIN ST",
    "dropmalcty": "CROTHERSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 472299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127932054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11979",
    "droptype": "D",
    "dropname": "CROWN POINT",
    "dropdeladd": "128 S EAST ST",
    "dropdelcty": "CROWN POINT",
    "dropdelst": "IN",
    "dropdelzpp": 463079920,
    "dropphyadd": "128 S EAST ST",
    "dropphycty": "CROWN POINT",
    "dropphyst": "IN",
    "dropphyzpp": 463079920,
    "dropmaladd": "128 S EAST ST",
    "dropmalcty": "CROWN POINT",
    "dropmalst": "IN",
    "dropmalzpp": 463079920,
    "dropsitphn": 2196630062,
    "dropsitlph": 2196630805,
    "dropsitcph": 2196630805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11987",
    "droptype": "D",
    "dropname": "CULVER",
    "dropdeladd": "115 W JEFFERSON ST",
    "dropdelcty": "CULVER",
    "dropdelst": "IN",
    "dropdelzpp": 465119998,
    "dropphyadd": "115 W JEFFERSON ST",
    "dropphycty": "CULVER",
    "dropphyst": "IN",
    "dropphyzpp": 465119998,
    "dropmaladd": "115 W JEFFERSON ST",
    "dropmalcty": "CULVER",
    "dropmalst": "IN",
    "dropmalzpp": 465119998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748422965,
    "dropfax": 5748422214
  },
  {
    "dcode": "D",
    "dropkey": "PX11996",
    "droptype": "D",
    "dropname": "CUTLER",
    "dropdeladd": "96 E 485 S",
    "dropdelcty": "CUTLER",
    "dropdelst": "IN",
    "dropdelzpp": 469209998,
    "dropphyadd": "96 E 485 S",
    "dropphycty": "CUTLER",
    "dropphyst": "IN",
    "dropphyzpp": 469209998,
    "dropmaladd": "96 E 485 S",
    "dropmalcty": "CUTLER",
    "dropmalst": "IN",
    "dropmalzpp": 469209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652682110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX11998",
    "droptype": "D",
    "dropname": "CYNTHIANA",
    "dropdeladd": "10864 MAIN ST",
    "dropdelcty": "CYNTHIANA",
    "dropdelst": "IN",
    "dropdelzpp": 476129998,
    "dropphyadd": "10864 MAIN ST",
    "dropphycty": "CYNTHIANA",
    "dropphyst": "IN",
    "dropphyzpp": 476129998,
    "dropmaladd": "10864 MAIN ST",
    "dropmalcty": "CYNTHIANA",
    "dropmalst": "IN",
    "dropmalzpp": 476129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128452734,
    "dropfax": 8128458004
  },
  {
    "dcode": "D",
    "dropkey": "PX12002",
    "droptype": "D",
    "dropname": "DALE",
    "dropdeladd": "4 E MEDCALF ST",
    "dropdelcty": "DALE",
    "dropdelst": "IN",
    "dropdelzpp": 475239998,
    "dropphyadd": "4 E MEDCALF ST",
    "dropphycty": "DALE",
    "dropphyst": "IN",
    "dropphyzpp": 475239998,
    "dropmaladd": "4 E MEDCALF ST",
    "dropmalcty": "DALE",
    "dropmalst": "IN",
    "dropmalzpp": 475239998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129372441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12003",
    "droptype": "D",
    "dropname": "DALEVILLE",
    "dropdeladd": "7924 S WALNUT ST",
    "dropdelcty": "DALEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473349998,
    "dropphyadd": "7924 S WALNUT ST",
    "dropphycty": "DALEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473349998,
    "dropmaladd": "7924 S WALNUT ST",
    "dropmalcty": "DALEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653787585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12008",
    "droptype": "D",
    "dropname": "DANA",
    "dropdeladd": "171 S MAPLE ST",
    "dropdelcty": "DANA",
    "dropdelst": "IN",
    "dropdelzpp": 478479998,
    "dropphyadd": "171 S MAPLE ST",
    "dropphycty": "DANA",
    "dropphyst": "IN",
    "dropphyzpp": 478479998,
    "dropmaladd": "171 S MAPLE ST",
    "dropmalcty": "DANA",
    "dropmalst": "IN",
    "dropmalzpp": 478479998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656653450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12009",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "1965 E MAIN ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461229998,
    "dropphyadd": "1965 E MAIN ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461229998,
    "dropmaladd": "1965 E MAIN ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3177452283,
    "dropfax": 3177181305
  },
  {
    "dcode": "D",
    "dropkey": "PX12014",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "215 W MAIN ST",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 479409998,
    "dropphyadd": "215 W MAIN ST",
    "dropphycty": "DARLINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 479409998,
    "dropmaladd": "215 W MAIN ST",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 479409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657944551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12017",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "726 WALNUT ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "IN",
    "dropdelzpp": 479419998,
    "dropphyadd": "726 WALNUT ST",
    "dropphycty": "DAYTON",
    "dropphyst": "IN",
    "dropphyzpp": 479419998,
    "dropmaladd": "726 WALNUT ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "IN",
    "dropmalzpp": 479419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652493494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12021",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "213 COURT ST",
    "dropdelcty": "DECATUR",
    "dropdelst": "IN",
    "dropdelzpp": 467339998,
    "dropphyadd": "213 COURT ST",
    "dropphycty": "DECATUR",
    "dropphyst": "IN",
    "dropphyzpp": 467339998,
    "dropmaladd": "213 COURT ST",
    "dropmalcty": "DECATUR",
    "dropmalst": "IN",
    "dropmalzpp": 467339998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607243205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12022",
    "droptype": "D",
    "dropname": "DECKER",
    "dropdeladd": "107 N 3RD ST",
    "dropdelcty": "DECKER",
    "dropdelst": "IN",
    "dropdelzpp": 475249998,
    "dropphyadd": "107 N 3RD ST",
    "dropphycty": "DECKER",
    "dropphyst": "IN",
    "dropphyzpp": 475249998,
    "dropmaladd": "107 N 3RD ST",
    "dropmalcty": "DECKER",
    "dropmalst": "IN",
    "dropmalzpp": 475249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127694512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12029",
    "droptype": "D",
    "dropname": "DELONG",
    "dropdeladd": "9067 OLSON RD",
    "dropdelcty": "DELONG",
    "dropdelst": "IN",
    "dropdelzpp": 469229998,
    "dropphyadd": "9067 OLSON RD",
    "dropphycty": "DELONG",
    "dropphyst": "IN",
    "dropphyzpp": 469229998,
    "dropmaladd": "9067 OLSON RD",
    "dropmalcty": "DELONG",
    "dropmalst": "IN",
    "dropmalzpp": 469229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745422689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12030",
    "droptype": "D",
    "dropname": "DELPHI",
    "dropdeladd": "201 W FRANKLIN ST",
    "dropdelcty": "DELPHI",
    "dropdelst": "IN",
    "dropdelzpp": 469239998,
    "dropphyadd": "201 W FRANKLIN ST",
    "dropphycty": "DELPHI",
    "dropphyst": "IN",
    "dropphyzpp": 469239998,
    "dropmaladd": "201 W FRANKLIN ST",
    "dropmalcty": "DELPHI",
    "dropmalst": "IN",
    "dropmalzpp": 469239998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655642315,
    "dropfax": 7655649928
  },
  {
    "dcode": "D",
    "dropkey": "PX12031",
    "droptype": "D",
    "dropname": "DEMOTTE",
    "dropdeladd": "825 S HALLECK ST",
    "dropdelcty": "DEMOTTE",
    "dropdelst": "IN",
    "dropdelzpp": 463108342,
    "dropphyadd": "825 S HALLECK ST",
    "dropphycty": "DEMOTTE",
    "dropphyst": "IN",
    "dropphyzpp": 463108342,
    "dropmaladd": "825 S HALLECK ST",
    "dropmalcty": "DEMOTTE",
    "dropmalst": "IN",
    "dropmalzpp": 463108342,
    "dropsitphn": 2199873293,
    "dropsitlph": 2199873293,
    "dropsitcph": 2199873293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12034",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "120 W HARRISON ST",
    "dropdelcty": "DENVER",
    "dropdelst": "IN",
    "dropdelzpp": 469269998,
    "dropphyadd": "120 W HARRISON ST",
    "dropphycty": "DENVER",
    "dropphyst": "IN",
    "dropphyzpp": 469269998,
    "dropmaladd": "120 W HARRISON ST",
    "dropmalcty": "DENVER",
    "dropmalst": "IN",
    "dropmalzpp": 469269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659853477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12035",
    "droptype": "D",
    "dropname": "DEPAUW",
    "dropdeladd": "9055 MAIN ST NW",
    "dropdelcty": "DEPAUW",
    "dropdelst": "IN",
    "dropdelzpp": 471159998,
    "dropphyadd": "9055 MAIN ST NW",
    "dropphycty": "DEPAUW",
    "dropphyst": "IN",
    "dropphyzpp": 471159998,
    "dropmaladd": "9055 MAIN ST NW",
    "dropmalcty": "DEPAUW",
    "dropmalst": "IN",
    "dropmalzpp": 471159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123473202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12036",
    "droptype": "D",
    "dropname": "DEPUTY",
    "dropdeladd": "14165 W MAIN ST",
    "dropdelcty": "DEPUTY",
    "dropdelst": "IN",
    "dropdelzpp": 472309998,
    "dropphyadd": "14165 W MAIN ST",
    "dropphycty": "DEPUTY",
    "dropphyst": "IN",
    "dropphyzpp": 472309998,
    "dropmaladd": "14165 W MAIN ST",
    "dropmalcty": "DEPUTY",
    "dropmalst": "IN",
    "dropmalzpp": 472309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128663129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12037",
    "droptype": "D",
    "dropname": "DERBY",
    "dropdeladd": "15291 OLD STATE ROAD 70",
    "dropdelcty": "DERBY",
    "dropdelst": "IN",
    "dropdelzpp": 475259998,
    "dropphyadd": "15291 OLD STATE ROAD 70",
    "dropphycty": "DERBY",
    "dropphyst": "IN",
    "dropphyzpp": 475259998,
    "dropmaladd": "15291 OLD STATE ROAD 70",
    "dropmalcty": "DERBY",
    "dropmalst": "IN",
    "dropmalzpp": 475259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128362873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12045",
    "droptype": "D",
    "dropname": "DILLSBORO",
    "dropdeladd": "12830 NORTH ST",
    "dropdelcty": "DILLSBORO",
    "dropdelst": "IN",
    "dropdelzpp": 470189998,
    "dropphyadd": "12830 NORTH ST",
    "dropphycty": "DILLSBORO",
    "dropphyst": "IN",
    "dropphyzpp": 470189998,
    "dropmaladd": "12830 NORTH ST",
    "dropmalcty": "DILLSBORO",
    "dropmalst": "IN",
    "dropmalzpp": 470189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8124325255,
    "dropsitcph": 8124325255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12057",
    "droptype": "D",
    "dropname": "DONALDSON",
    "dropdeladd": "7919 UNION RD",
    "dropdelcty": "DONALDSON",
    "dropdelst": "IN",
    "dropdelzpp": 465139998,
    "dropphyadd": "7919 UNION RD",
    "dropphycty": "DONALDSON",
    "dropphyst": "IN",
    "dropphyzpp": 465139998,
    "dropmaladd": "7919 UNION RD",
    "dropmalcty": "DONALDSON",
    "dropmalst": "IN",
    "dropmalzpp": 465139998,
    "dropsitphn": 5749366631,
    "dropsitlph": 5749366631,
    "dropsitcph": 5749366631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12069",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "2183 E CUMBERLAND ST",
    "dropdelcty": "DUBLIN",
    "dropdelst": "IN",
    "dropdelzpp": 473359998,
    "dropphyadd": "2183 E CUMBERLAND ST",
    "dropphycty": "DUBLIN",
    "dropphyst": "IN",
    "dropphyzpp": 473359998,
    "dropmaladd": "2183 E CUMBERLAND ST",
    "dropmalcty": "DUBLIN",
    "dropmalst": "IN",
    "dropmalzpp": 473359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654784525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12070",
    "droptype": "D",
    "dropname": "DUBOIS",
    "dropdeladd": "4533 N 2ND ST",
    "dropdelcty": "DUBOIS",
    "dropdelst": "IN",
    "dropdelzpp": 475279998,
    "dropphyadd": "4533 N 2ND ST",
    "dropphycty": "DUBOIS",
    "dropphyst": "IN",
    "dropphyzpp": 475279998,
    "dropmaladd": "4533 N 2ND ST",
    "dropmalcty": "DUBOIS",
    "dropmalst": "IN",
    "dropmalzpp": 475279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126782511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12076",
    "droptype": "D",
    "dropname": "DUGGER",
    "dropdeladd": "8182 E MAIN ST",
    "dropdelcty": "DUGGER",
    "dropdelst": "IN",
    "dropdelzpp": 478480009,
    "dropphyadd": "8182 E MAIN ST",
    "dropphycty": "DUGGER",
    "dropphyst": "IN",
    "dropphyzpp": 478480009,
    "dropmaladd": "8182 E MAIN ST",
    "dropmalcty": "DUGGER",
    "dropmalst": "IN",
    "dropmalzpp": 478480009,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126482191,
    "dropfax": 8126482863
  },
  {
    "dcode": "D",
    "dropkey": "PX12078",
    "droptype": "D",
    "dropname": "DUNKIRK",
    "dropdeladd": "123 W COMMERCE ST",
    "dropdelcty": "DUNKIRK",
    "dropdelst": "IN",
    "dropdelzpp": 473369998,
    "dropphyadd": "123 W COMMERCE ST",
    "dropphycty": "DUNKIRK",
    "dropphyst": "IN",
    "dropphyzpp": 473369998,
    "dropmaladd": "123 W COMMERCE ST",
    "dropmalcty": "DUNKIRK",
    "dropmalst": "IN",
    "dropmalzpp": 473369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657687241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12081",
    "droptype": "D",
    "dropname": "DUNREITH",
    "dropdeladd": "205 WASHINGTON ST",
    "dropdelcty": "DUNREITH",
    "dropdelst": "IN",
    "dropdelzpp": 473379998,
    "dropphyadd": "205 WASHINGTON ST",
    "dropphycty": "DUNREITH",
    "dropphyst": "IN",
    "dropphyzpp": 473379998,
    "dropmaladd": "205 WASHINGTON ST",
    "dropmalcty": "DUNREITH",
    "dropmalst": "IN",
    "dropmalzpp": 473379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659878286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12082",
    "droptype": "D",
    "dropname": "DUPONT",
    "dropdeladd": "10545 N WEST FRONT ST",
    "dropdelcty": "DUPONT",
    "dropdelst": "IN",
    "dropdelzpp": 472319998,
    "dropphyadd": "10545 N WEST FRONT ST",
    "dropphycty": "DUPONT",
    "dropphyst": "IN",
    "dropphyzpp": 472319998,
    "dropmaladd": "10545 N WEST FRONT ST",
    "dropmalcty": "DUPONT",
    "dropmalst": "IN",
    "dropmalzpp": 472319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122735614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12084",
    "droptype": "D",
    "dropname": "DYER",
    "dropdeladd": "2225 GREAT LAKES DR",
    "dropdelcty": "DYER",
    "dropdelst": "IN",
    "dropdelzpp": 463119998,
    "dropphyadd": "2225 GREAT LAKES DR",
    "dropphycty": "DYER",
    "dropphyst": "IN",
    "dropphyzpp": 463119998,
    "dropmaladd": "2225 GREAT LAKES DR",
    "dropmalcty": "DYER",
    "dropmalst": "IN",
    "dropmalzpp": 463119998,
    "dropsitphn": 2198651267,
    "dropsitlph": 2198651267,
    "dropsitcph": 2198651267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12091",
    "droptype": "D",
    "dropname": "EARL PARK",
    "dropdeladd": "106 W 5TH ST",
    "dropdelcty": "EARL PARK",
    "dropdelst": "IN",
    "dropdelzpp": 479428707,
    "dropphyadd": "106 W 5TH ST",
    "dropphycty": "EARL PARK",
    "dropphyst": "IN",
    "dropphyzpp": 479428707,
    "dropmaladd": "106 W 5TH ST",
    "dropmalcty": "EARL PARK",
    "dropmalst": "IN",
    "dropmalzpp": 479428707,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2194746201,
    "dropfax": 2194746201
  },
  {
    "dcode": "D",
    "dropkey": "PX12096",
    "droptype": "D",
    "dropname": "EAST CHICAGO",
    "dropdeladd": "901 E CHICAGO AVE",
    "dropdelcty": "EAST CHICAGO",
    "dropdelst": "IN",
    "dropdelzpp": 463129998,
    "dropphyadd": "901 E CHICAGO AVE",
    "dropphycty": "EAST CHICAGO",
    "dropphyst": "IN",
    "dropphyzpp": 463129998,
    "dropmaladd": "901 E CHICAGO AVE",
    "dropmalcty": "EAST CHICAGO",
    "dropmalst": "IN",
    "dropmalzpp": 463129998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2193972415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12098",
    "droptype": "D",
    "dropname": "EAST ENTERPRISE",
    "dropdeladd": "2114 US HIGHWAY 56",
    "dropdelcty": "EAST ENTERPRISE",
    "dropdelst": "IN",
    "dropdelzpp": 470199998,
    "dropphyadd": "2114 US HIGHWAY 56",
    "dropphycty": "EAST ENTERPRISE",
    "dropphyst": "IN",
    "dropphyzpp": 470199998,
    "dropmaladd": "2114 US HIGHWAY 56",
    "dropmalcty": "EAST ENTERPRISE",
    "dropmalst": "IN",
    "dropmalzpp": 470199998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8125343301,
    "dropsitcph": 8125343301,
    "dropfax": 8125342062
  },
  {
    "dcode": "D",
    "dropkey": "PX12108",
    "droptype": "D",
    "dropname": "EATON",
    "dropdeladd": "119 E HARRIS ST",
    "dropdelcty": "EATON",
    "dropdelst": "IN",
    "dropdelzpp": 473389998,
    "dropphyadd": "119 E HARRIS ST",
    "dropphycty": "EATON",
    "dropphyst": "IN",
    "dropphyzpp": 473389998,
    "dropmaladd": "119 E HARRIS ST",
    "dropmalcty": "EATON",
    "dropmalst": "IN",
    "dropmalzpp": 473389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653963706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12109",
    "droptype": "D",
    "dropname": "ECKERTY",
    "dropdeladd": "7440 W ECKERTY RD",
    "dropdelcty": "ECKERTY",
    "dropdelst": "IN",
    "dropdelzpp": 471169998,
    "dropphyadd": "7440 W ECKERTY RD",
    "dropphycty": "ECKERTY",
    "dropphyst": "IN",
    "dropphyzpp": 471169998,
    "dropmaladd": "7440 W ECKERTY RD",
    "dropmalcty": "ECKERTY",
    "dropmalst": "IN",
    "dropmalzpp": 471169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123382460,
    "dropfax": 8123382460
  },
  {
    "dcode": "D",
    "dropkey": "PX12110",
    "droptype": "D",
    "dropname": "ECONOMY",
    "dropdeladd": "218 MAIN ST",
    "dropdelcty": "ECONOMY",
    "dropdelst": "IN",
    "dropdelzpp": 473399998,
    "dropphyadd": "218 MAIN ST",
    "dropphycty": "ECONOMY",
    "dropphyst": "IN",
    "dropphyzpp": 473399998,
    "dropmaladd": "218 MAIN ST",
    "dropmalcty": "ECONOMY",
    "dropmalst": "IN",
    "dropmalzpp": 473399998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658865939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12116",
    "droptype": "D",
    "dropname": "EDINBURGH",
    "dropdeladd": "102 S WALNUT ST",
    "dropdelcty": "EDINBURGH",
    "dropdelst": "IN",
    "dropdelzpp": 461249998,
    "dropphyadd": "102 S WALNUT ST",
    "dropphycty": "EDINBURGH",
    "dropphyst": "IN",
    "dropphyzpp": 461249998,
    "dropmaladd": "102 S WALNUT ST",
    "dropmalcty": "EDINBURGH",
    "dropmalst": "IN",
    "dropmalzpp": 461249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125265400,
    "dropfax": 8125268159
  },
  {
    "dcode": "D",
    "dropkey": "PX12125",
    "droptype": "D",
    "dropname": "ELBERFELD",
    "dropdeladd": "155 W MAIN ST",
    "dropdelcty": "ELBERFELD",
    "dropdelst": "IN",
    "dropdelzpp": 476139998,
    "dropphyadd": "155 W MAIN ST",
    "dropphycty": "ELBERFELD",
    "dropphyst": "IN",
    "dropphyzpp": 476139998,
    "dropmaladd": "155 W MAIN ST",
    "dropmalcty": "ELBERFELD",
    "dropmalst": "IN",
    "dropmalzpp": 476139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129834419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12127",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "5465 MAIN ST SE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "IN",
    "dropdelzpp": 471179998,
    "dropphyadd": "5465 MAIN ST SE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "IN",
    "dropphyzpp": 471179998,
    "dropmaladd": "5465 MAIN ST SE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "IN",
    "dropmalzpp": 471179998,
    "dropsitphn": 8129691009,
    "dropsitlph": 8129691009,
    "dropsitcph": 8129691003,
    "dropfax": 8129691008
  },
  {
    "dcode": "D",
    "dropkey": "PX12128",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "102 SECOND ST",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 472329998,
    "dropphyadd": "102 SECOND ST",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 472329998,
    "dropmaladd": "102 SECOND ST",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 472329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125795519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12130",
    "droptype": "D",
    "dropname": "ELKHART",
    "dropdeladd": "601 S MAIN ST",
    "dropdelcty": "ELKHART",
    "dropdelst": "IN",
    "dropdelzpp": 465169998,
    "dropphyadd": "601 S MAIN ST",
    "dropphycty": "ELKHART",
    "dropphyst": "IN",
    "dropphyzpp": 465169998,
    "dropmaladd": "601 S MAIN ST",
    "dropmalcty": "ELKHART",
    "dropmalst": "IN",
    "dropmalzpp": 465169998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742935502,
    "dropfax": 5742935501
  },
  {
    "dcode": "D",
    "dropkey": "PX12132",
    "droptype": "D",
    "dropname": "ELLETTSVILLE",
    "dropdeladd": "104 N SALE ST",
    "dropdelcty": "ELLETTSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474299998,
    "dropphyadd": "104 N SALE ST",
    "dropphycty": "ELLETTSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474299998,
    "dropmaladd": "104 N SALE ST",
    "dropmalcty": "ELLETTSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128765435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12140",
    "droptype": "D",
    "dropname": "ELNORA",
    "dropdeladd": "118 N ODON ST",
    "dropdelcty": "ELNORA",
    "dropdelst": "IN",
    "dropdelzpp": 475299998,
    "dropphyadd": "118 N ODON ST",
    "dropphycty": "ELNORA",
    "dropphyst": "IN",
    "dropphyzpp": 475299998,
    "dropmaladd": "118 N ODON ST",
    "dropmalcty": "ELNORA",
    "dropmalst": "IN",
    "dropmalzpp": 475299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126925416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12142",
    "droptype": "D",
    "dropname": "ELWOOD",
    "dropdeladd": "119 N ANDERSON ST",
    "dropdelcty": "ELWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 460369998,
    "dropphyadd": "119 N ANDERSON ST",
    "dropphycty": "ELWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 460369998,
    "dropmaladd": "119 N ANDERSON ST",
    "dropmalcty": "ELWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 460369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655526322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12143",
    "droptype": "D",
    "dropname": "EMINENCE",
    "dropdeladd": "6543 STATE ROAD 42 N",
    "dropdelcty": "EMINENCE",
    "dropdelst": "IN",
    "dropdelzpp": 461259998,
    "dropphyadd": "6543 STATE ROAD 42 N",
    "dropphycty": "EMINENCE",
    "dropphyst": "IN",
    "dropphyzpp": 461259998,
    "dropmaladd": "6543 STATE ROAD 42 N",
    "dropmalcty": "EMINENCE",
    "dropmalst": "IN",
    "dropmalzpp": 461259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655282490,
    "dropfax": 7655282490
  },
  {
    "dcode": "D",
    "dropkey": "PX12149",
    "droptype": "D",
    "dropname": "ENGLISH",
    "dropdeladd": "111 S INDIANA AVE",
    "dropdelcty": "ENGLISH",
    "dropdelst": "IN",
    "dropdelzpp": 471189998,
    "dropphyadd": "111 S INDIANA AVE",
    "dropphycty": "ENGLISH",
    "dropphyst": "IN",
    "dropphyzpp": 471189998,
    "dropmaladd": "111 S INDIANA AVE",
    "dropmalcty": "ENGLISH",
    "dropmalst": "IN",
    "dropmalzpp": 471189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123382055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12155",
    "droptype": "D",
    "dropname": "ETNA GREEN",
    "dropdeladd": "103 N WALNUT ST",
    "dropdelcty": "ETNA GREEN",
    "dropdelst": "IN",
    "dropdelzpp": 465249998,
    "dropphyadd": "103 N WALNUT ST",
    "dropphycty": "ETNA GREEN",
    "dropphyst": "IN",
    "dropphyzpp": 465249998,
    "dropmaladd": "103 N WALNUT ST",
    "dropmalcty": "ETNA GREEN",
    "dropmalst": "IN",
    "dropmalzpp": 465249998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748589341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12162",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "800 SYCAMORE ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477081808,
    "dropphyadd": "800 SYCAMORE ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477081808,
    "dropmaladd": "800 SYCAMORE ST",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477081808,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124293411,
    "dropfax": 8124293486
  },
  {
    "dcode": "D",
    "dropkey": "PX12169",
    "droptype": "D",
    "dropname": "FAIR OAKS",
    "dropdeladd": "4250 KENT ST",
    "dropdelcty": "FAIR OAKS",
    "dropdelst": "IN",
    "dropdelzpp": 479439998,
    "dropphyadd": "4250 KENT ST",
    "dropphycty": "FAIR OAKS",
    "dropphyst": "IN",
    "dropphyzpp": 479439998,
    "dropmaladd": "4250 KENT ST",
    "dropmalcty": "FAIR OAKS",
    "dropmalst": "IN",
    "dropmalzpp": 479439998,
    "dropsitphn": 2192758100,
    "dropsitlph": 2192758100,
    "dropsitcph": 2192758126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12170",
    "droptype": "D",
    "dropname": "FAIRBANKS",
    "dropdeladd": "9236 N MAIN ST",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "IN",
    "dropdelzpp": 478499998,
    "dropphyadd": "9236 N MAIN ST",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "IN",
    "dropphyzpp": 478499998,
    "dropmaladd": "9236 N MAIN ST",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "IN",
    "dropmalzpp": 478499998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123942250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12175",
    "droptype": "D",
    "dropname": "FAIRLAND",
    "dropdeladd": "103 W WASHINGTON ST",
    "dropdelcty": "FAIRLAND",
    "dropdelst": "IN",
    "dropdelzpp": 461269998,
    "dropphyadd": "103 W WASHINGTON ST",
    "dropphycty": "FAIRLAND",
    "dropphyst": "IN",
    "dropphyzpp": 461269998,
    "dropmaladd": "103 W WASHINGTON ST",
    "dropmalcty": "FAIRLAND",
    "dropmalst": "IN",
    "dropmalzpp": 461269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178357514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12176",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "FAIRMOUNT",
    "dropdelst": "IN",
    "dropdelzpp": 469289998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "FAIRMOUNT",
    "dropphyst": "IN",
    "dropphyzpp": 469289998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "FAIRMOUNT",
    "dropmalst": "IN",
    "dropmalzpp": 469289998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659485357,
    "dropfax": 7659486214
  },
  {
    "dcode": "D",
    "dropkey": "PX12181",
    "droptype": "D",
    "dropname": "FALMOUTH",
    "dropdeladd": "5935 N 800 E",
    "dropdelcty": "FALMOUTH",
    "dropdelst": "IN",
    "dropdelzpp": 461279998,
    "dropphyadd": "5935 N 800 E",
    "dropphycty": "FALMOUTH",
    "dropphyst": "IN",
    "dropphyzpp": 461279998,
    "dropmaladd": "5935 N 800 E",
    "dropmalcty": "FALMOUTH",
    "dropmalst": "IN",
    "dropmalzpp": 461279998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656795911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12186",
    "droptype": "D",
    "dropname": "FARMERSBURG",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "FARMERSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 478509998,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "FARMERSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 478509998,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "FARMERSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 478509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126962330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12187",
    "droptype": "D",
    "dropname": "FARMLAND",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "FARMLAND",
    "dropdelst": "IN",
    "dropdelzpp": 473409998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "FARMLAND",
    "dropphyst": "IN",
    "dropphyzpp": 473409998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "FARMLAND",
    "dropmalst": "IN",
    "dropmalzpp": 473409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654687771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12192",
    "droptype": "D",
    "dropname": "FERDINAND",
    "dropdeladd": "805 MAIN ST",
    "dropdelcty": "FERDINAND",
    "dropdelst": "IN",
    "dropdelzpp": 475329998,
    "dropphyadd": "805 MAIN ST",
    "dropphycty": "FERDINAND",
    "dropphyst": "IN",
    "dropphyzpp": 475329998,
    "dropmaladd": "805 MAIN ST",
    "dropmalcty": "FERDINAND",
    "dropmalst": "IN",
    "dropmalzpp": 475329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123672451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12196",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "10 N MAIN ST",
    "dropdelcty": "FILLMORE",
    "dropdelst": "IN",
    "dropdelzpp": 461289223,
    "dropphyadd": "10 N MAIN ST",
    "dropphycty": "FILLMORE",
    "dropphyst": "IN",
    "dropphyzpp": 461289223,
    "dropmaladd": "10 N MAIN ST",
    "dropmalcty": "FILLMORE",
    "dropmalst": "IN",
    "dropmalzpp": 461289223,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652466131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12200",
    "droptype": "D",
    "dropname": "FISHERS",
    "dropdeladd": "8500 E 116TH ST",
    "dropdelcty": "FISHERS",
    "dropdelst": "IN",
    "dropdelzpp": 460389998,
    "dropphyadd": "8500 E 116TH ST",
    "dropphycty": "FISHERS",
    "dropphyst": "IN",
    "dropphyzpp": 460389998,
    "dropmaladd": "8500 E 116TH ST",
    "dropmalcty": "FISHERS",
    "dropmalst": "IN",
    "dropmalzpp": 460389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179137902,
    "dropfax": 3178494276
  },
  {
    "dcode": "D",
    "dropkey": "PX12205",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "2732 W STATE ROAD 252",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "IN",
    "dropdelzpp": 472349998,
    "dropphyadd": "2732 W STATE ROAD 252",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "IN",
    "dropphyzpp": 472349998,
    "dropmaladd": "2732 W STATE ROAD 252",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "IN",
    "dropmalzpp": 472349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125875266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12207",
    "droptype": "D",
    "dropname": "FLORA",
    "dropdeladd": "21 E MAIN ST",
    "dropdelcty": "FLORA",
    "dropdelst": "IN",
    "dropdelzpp": 469299998,
    "dropphyadd": "21 E MAIN ST",
    "dropphycty": "FLORA",
    "dropphyst": "IN",
    "dropphyzpp": 469299998,
    "dropmaladd": "21 E MAIN ST",
    "dropmalcty": "FLORA",
    "dropmalst": "IN",
    "dropmalzpp": 469299998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5749674311,
    "dropfax": 5749674735
  },
  {
    "dcode": "D",
    "dropkey": "PX12208",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "404 5TH ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "IN",
    "dropdelzpp": 470209998,
    "dropphyadd": "404 5TH ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "IN",
    "dropphyzpp": 470209998,
    "dropmaladd": "404 5TH ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "IN",
    "dropmalzpp": 470209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8125942830,
    "dropsitcph": 8125942830,
    "dropfax": 8125942800
  },
  {
    "dcode": "D",
    "dropkey": "PX12210",
    "droptype": "D",
    "dropname": "FLOYDS KNOBS",
    "dropdeladd": "3818 PAOLI PIKE",
    "dropdelcty": "FLOYDS KNOBS",
    "dropdelst": "IN",
    "dropdelzpp": 471199998,
    "dropphyadd": "3818 PAOLI PIKE",
    "dropphycty": "FLOYDS KNOBS",
    "dropphyst": "IN",
    "dropphyzpp": 471199998,
    "dropmaladd": "3818 PAOLI PIKE",
    "dropmalcty": "FLOYDS KNOBS",
    "dropmalst": "IN",
    "dropmalzpp": 471199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129238186,
    "dropfax": 8129237971
  },
  {
    "dcode": "D",
    "dropkey": "PX12214",
    "droptype": "D",
    "dropname": "FONTANET",
    "dropdeladd": "8878 N MAIN ST",
    "dropdelcty": "FONTANET",
    "dropdelst": "IN",
    "dropdelzpp": 478519998,
    "dropphyadd": "8878 N MAIN ST",
    "dropphycty": "FONTANET",
    "dropphyst": "IN",
    "dropphyzpp": 478519998,
    "dropmaladd": "8878 N MAIN ST",
    "dropmalcty": "FONTANET",
    "dropmalst": "IN",
    "dropmalzpp": 478519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128772389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12216",
    "droptype": "D",
    "dropname": "FOREST",
    "dropdeladd": "9333 E COUNTY ROAD 600 N",
    "dropdelcty": "FOREST",
    "dropdelst": "IN",
    "dropdelzpp": 460399998,
    "dropphyadd": "9333 E COUNTY ROAD 600 N",
    "dropphycty": "FOREST",
    "dropphyst": "IN",
    "dropphyzpp": 460399998,
    "dropmaladd": "9333 E COUNTY ROAD 600 N",
    "dropmalcty": "FOREST",
    "dropmalst": "IN",
    "dropmalzpp": 460399998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652492939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12222",
    "droptype": "D",
    "dropname": "FORT BRANCH",
    "dropdeladd": "105 E VINE ST",
    "dropdelcty": "FORT BRANCH",
    "dropdelst": "IN",
    "dropdelzpp": 476489998,
    "dropphyadd": "105 E VINE ST",
    "dropphycty": "FORT BRANCH",
    "dropphyst": "IN",
    "dropphyzpp": 476489998,
    "dropmaladd": "105 E VINE ST",
    "dropmalcty": "FORT BRANCH",
    "dropmalst": "IN",
    "dropmalzpp": 476489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127533337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12225",
    "droptype": "D",
    "dropname": "FORT WAYNE",
    "dropdeladd": "1501 S CLINTON ST",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468029998,
    "dropphyadd": "1501 S CLINTON ST",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468029998,
    "dropmaladd": "1501 S CLINTON ST",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277310,
    "dropfax": 2604277346
  },
  {
    "dcode": "D",
    "dropkey": "PX12226",
    "droptype": "D",
    "dropname": "FORTVILLE",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "FORTVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460409998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "FORTVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460409998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "FORTVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174856624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12229",
    "droptype": "D",
    "dropname": "FOUNTAIN CITY",
    "dropdeladd": "104 S WALNUT ST",
    "dropdelcty": "FOUNTAIN CITY",
    "dropdelst": "IN",
    "dropdelzpp": 473419998,
    "dropphyadd": "104 S WALNUT ST",
    "dropphycty": "FOUNTAIN CITY",
    "dropphyst": "IN",
    "dropphyzpp": 473419998,
    "dropmaladd": "104 S WALNUT ST",
    "dropmalcty": "FOUNTAIN CITY",
    "dropmalst": "IN",
    "dropmalzpp": 473419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658472320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12232",
    "droptype": "D",
    "dropname": "FOUNTAINTOWN",
    "dropdeladd": "11675 N DIVISION RD",
    "dropdelcty": "FOUNTAINTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 461309998,
    "dropphyadd": "11675 N DIVISION RD",
    "dropphycty": "FOUNTAINTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 461309998,
    "dropmaladd": "11675 N DIVISION RD",
    "dropmalcty": "FOUNTAINTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 461309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178615377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12234",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "114 S MADISON AVE",
    "dropdelcty": "FOWLER",
    "dropdelst": "IN",
    "dropdelzpp": 479449998,
    "dropphyadd": "114 S MADISON AVE",
    "dropphycty": "FOWLER",
    "dropphyst": "IN",
    "dropphyzpp": 479449998,
    "dropmaladd": "114 S MADISON AVE",
    "dropmalcty": "FOWLER",
    "dropmalst": "IN",
    "dropmalzpp": 479449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658841560,
    "dropfax": 7658841560
  },
  {
    "dcode": "D",
    "dropkey": "PX12238",
    "droptype": "D",
    "dropname": "FRANCESVILLE",
    "dropdeladd": "122 S BILL ST",
    "dropdelcty": "FRANCESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479469998,
    "dropphyadd": "122 S BILL ST",
    "dropphycty": "FRANCESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479469998,
    "dropmaladd": "122 S BILL ST",
    "dropmalcty": "FRANCESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 2195670222,
    "dropsitcph": 2193351013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12241",
    "droptype": "D",
    "dropname": "FRANCISCO",
    "dropdeladd": "308 W MAIN ST",
    "dropdelcty": "FRANCISCO",
    "dropdelst": "IN",
    "dropdelzpp": 476499998,
    "dropphyadd": "308 W MAIN ST",
    "dropphycty": "FRANCISCO",
    "dropphyst": "IN",
    "dropphyzpp": 476499998,
    "dropmaladd": "308 W MAIN ST",
    "dropmalcty": "FRANCISCO",
    "dropmalst": "IN",
    "dropmalzpp": 476499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127823764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12242",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "100 WASHINGTON AVE",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "IN",
    "dropdelzpp": 460419998,
    "dropphyadd": "100 WASHINGTON AVE",
    "dropphycty": "FRANKFORT",
    "dropphyst": "IN",
    "dropphyzpp": 460419998,
    "dropmaladd": "100 WASHINGTON AVE",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "IN",
    "dropmalzpp": 460419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656545553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12245",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "1265 N MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "IN",
    "dropdelzpp": 461319998,
    "dropphyadd": "1265 N MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "IN",
    "dropphyzpp": 461319998,
    "dropmaladd": "1265 N MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "IN",
    "dropmalzpp": 461319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3177366241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12250",
    "droptype": "D",
    "dropname": "FRANKTON",
    "dropdeladd": "106 E SIGLER ST",
    "dropdelcty": "FRANKTON",
    "dropdelst": "IN",
    "dropdelzpp": 460449998,
    "dropphyadd": "106 E SIGLER ST",
    "dropphycty": "FRANKTON",
    "dropphyst": "IN",
    "dropphyzpp": 460449998,
    "dropmaladd": "106 E SIGLER ST",
    "dropmalcty": "FRANKTON",
    "dropmalst": "IN",
    "dropmalzpp": 460449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657547821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12251",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "262 E US HIGHWAY 150",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 471209998,
    "dropphyadd": "262 E US HIGHWAY 150",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 471209998,
    "dropmaladd": "262 E US HIGHWAY 150",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 471209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124723148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12253",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "5634 MAIN ST",
    "dropdelcty": "FREEDOM",
    "dropdelst": "IN",
    "dropdelzpp": 474319998,
    "dropphyadd": "5634 MAIN ST",
    "dropphycty": "FREEDOM",
    "dropphyst": "IN",
    "dropphyzpp": 474319998,
    "dropmaladd": "5634 MAIN ST",
    "dropmalcty": "FREEDOM",
    "dropmalst": "IN",
    "dropmalzpp": 474319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128294224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12254",
    "droptype": "D",
    "dropname": "FREELANDVILLE",
    "dropdeladd": "5 W STATE ROAD 58",
    "dropdelcty": "FREELANDVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 475359998,
    "dropphyadd": "5 W STATE ROAD 58",
    "dropphycty": "FREELANDVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 475359998,
    "dropmaladd": "5 W STATE ROAD 58",
    "dropmalcty": "FREELANDVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 475359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123282311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12259",
    "droptype": "D",
    "dropname": "FREETOWN",
    "dropdeladd": "6683 N UNION ST",
    "dropdelcty": "FREETOWN",
    "dropdelst": "IN",
    "dropdelzpp": 472359998,
    "dropphyadd": "6683 N UNION ST",
    "dropphycty": "FREETOWN",
    "dropphyst": "IN",
    "dropphyzpp": 472359998,
    "dropmaladd": "6683 N UNION ST",
    "dropmalcty": "FREETOWN",
    "dropmalst": "IN",
    "dropmalzpp": 472359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124973800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12260",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "104 N COFFIN ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "IN",
    "dropdelzpp": 467371099,
    "dropphyadd": "104 N COFFIN ST",
    "dropphycty": "FREMONT",
    "dropphyst": "IN",
    "dropphyzpp": 467371099,
    "dropmaladd": "104 N COFFIN ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "IN",
    "dropmalzpp": 467371099,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604952235,
    "dropfax": 2604959658
  },
  {
    "dcode": "D",
    "dropkey": "PX12262",
    "droptype": "D",
    "dropname": "FRENCH LICK",
    "dropdeladd": "8617 W COLLEGE ST",
    "dropdelcty": "FRENCH LICK",
    "dropdelst": "IN",
    "dropdelzpp": 474329998,
    "dropphyadd": "8617 W COLLEGE ST",
    "dropphycty": "FRENCH LICK",
    "dropphyst": "IN",
    "dropphyzpp": 474329998,
    "dropmaladd": "8617 W COLLEGE ST",
    "dropmalcty": "FRENCH LICK",
    "dropmalst": "IN",
    "dropmalzpp": 474329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129369899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12264",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "5918 E MAIN ST",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "IN",
    "dropdelzpp": 470219998,
    "dropphyadd": "5918 E MAIN ST",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "IN",
    "dropphyzpp": 470219998,
    "dropmaladd": "5918 E MAIN ST",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "IN",
    "dropmalzpp": 470219998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126675752,
    "dropsitcph": 8126675752,
    "dropfax": 8126676978
  },
  {
    "dcode": "D",
    "dropkey": "PX12275",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "7382 LIBERTY AVE",
    "dropdelcty": "FULTON",
    "dropdelst": "IN",
    "dropdelzpp": 469319998,
    "dropphyadd": "7382 LIBERTY AVE",
    "dropphycty": "FULTON",
    "dropphyst": "IN",
    "dropphyzpp": 469319998,
    "dropmaladd": "7382 LIBERTY AVE",
    "dropmalcty": "FULTON",
    "dropmalst": "IN",
    "dropmalzpp": 469319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748574105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12278",
    "droptype": "D",
    "dropname": "GALVESTON",
    "dropdeladd": "102 W WASHINGTON ST",
    "dropdelcty": "GALVESTON",
    "dropdelst": "IN",
    "dropdelzpp": 469329998,
    "dropphyadd": "102 W WASHINGTON ST",
    "dropphycty": "GALVESTON",
    "dropphyst": "IN",
    "dropphyzpp": 469329998,
    "dropmaladd": "102 W WASHINGTON ST",
    "dropmalcty": "GALVESTON",
    "dropmalst": "IN",
    "dropmalzpp": 469329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746996921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12283",
    "droptype": "D",
    "dropname": "GARRETT",
    "dropdeladd": "115 W KEYSER ST",
    "dropdelcty": "GARRETT",
    "dropdelst": "IN",
    "dropdelzpp": 467389998,
    "dropphyadd": "115 W KEYSER ST",
    "dropphycty": "GARRETT",
    "dropphyst": "IN",
    "dropphyzpp": 467389998,
    "dropmaladd": "115 W KEYSER ST",
    "dropmalcty": "GARRETT",
    "dropmalst": "IN",
    "dropmalzpp": 467389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603574540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12285",
    "droptype": "D",
    "dropname": "GARY",
    "dropdeladd": "1499 MARTIN LUTHER KING DR",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464019998,
    "dropphyadd": "1499 MARTIN LUTHER KING DR",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464019998,
    "dropmaladd": "1499 MARTIN LUTHER KING DR",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464019998,
    "dropsitphn": 2198868000,
    "dropsitlph": 2198868051,
    "dropsitcph": 2198868000,
    "dropfax": 2198868211
  },
  {
    "dcode": "D",
    "dropkey": "PX12287",
    "droptype": "D",
    "dropname": "GAS CITY",
    "dropdeladd": "123 N 2ND ST",
    "dropdelcty": "GAS CITY",
    "dropdelst": "IN",
    "dropdelzpp": 469339998,
    "dropphyadd": "123 N 2ND ST",
    "dropphycty": "GAS CITY",
    "dropphyst": "IN",
    "dropphyzpp": 469339998,
    "dropmaladd": "123 N 2ND ST",
    "dropmalcty": "GAS CITY",
    "dropmalst": "IN",
    "dropmalzpp": 469339998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656741745,
    "dropfax": 7656771016
  },
  {
    "dcode": "D",
    "dropkey": "PX12290",
    "droptype": "D",
    "dropname": "GASTON",
    "dropdeladd": "111 W ELM ST",
    "dropdelcty": "GASTON",
    "dropdelst": "IN",
    "dropdelzpp": 473429998,
    "dropphyadd": "111 W ELM ST",
    "dropphycty": "GASTON",
    "dropphyst": "IN",
    "dropphyzpp": 473429998,
    "dropmaladd": "111 W ELM ST",
    "dropmalcty": "GASTON",
    "dropmalst": "IN",
    "dropmalzpp": 473429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653584886,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12295",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "414 E LINE ST",
    "dropdelcty": "GENEVA",
    "dropdelst": "IN",
    "dropdelzpp": 467409998,
    "dropphyadd": "414 E LINE ST",
    "dropphycty": "GENEVA",
    "dropphyst": "IN",
    "dropphyzpp": 467409998,
    "dropmaladd": "414 E LINE ST",
    "dropmalcty": "GENEVA",
    "dropmalst": "IN",
    "dropmalzpp": 467409998,
    "dropsitphn": 2605892159,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603687414,
    "dropfax": 2603687414
  },
  {
    "dcode": "D",
    "dropkey": "PX12296",
    "droptype": "D",
    "dropname": "GENTRYVILLE",
    "dropdeladd": "957 E COUNTY ROAD 1575 N",
    "dropdelcty": "GENTRYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 475379998,
    "dropphyadd": "957 E COUNTY ROAD 1575 N",
    "dropphycty": "GENTRYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 475379998,
    "dropmaladd": "957 E COUNTY ROAD 1575 N",
    "dropmalcty": "GENTRYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 475379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129372547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12301",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1095 MARCI LN",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "IN",
    "dropdelzpp": 471229998,
    "dropphyadd": "1095 MARCI LN",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "IN",
    "dropphyzpp": 471229998,
    "dropmaladd": "1095 MARCI LN",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "IN",
    "dropmalzpp": 471229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129512020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12312",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "214 N MAIN ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 461339998,
    "dropphyadd": "214 N MAIN ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 461339998,
    "dropmaladd": "214 N MAIN ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 461339998,
    "dropsitphn": 7659323139,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656795876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12320",
    "droptype": "D",
    "dropname": "GOODLAND",
    "dropdeladd": "122 W UNION ST",
    "dropdelcty": "GOODLAND",
    "dropdelst": "IN",
    "dropdelzpp": 479489998,
    "dropphyadd": "122 W UNION ST",
    "dropphycty": "GOODLAND",
    "dropphyst": "IN",
    "dropphyzpp": 479489998,
    "dropmaladd": "122 W UNION ST",
    "dropmalcty": "GOODLAND",
    "dropmalst": "IN",
    "dropmalzpp": 479489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2192974545,
    "dropfax": 2192973218
  },
  {
    "dcode": "D",
    "dropkey": "PX12322",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "415 W PIKE ST",
    "dropdelcty": "GOSHEN",
    "dropdelst": "IN",
    "dropdelzpp": 465269998,
    "dropphyadd": "415 W PIKE ST",
    "dropphycty": "GOSHEN",
    "dropphyst": "IN",
    "dropphyzpp": 465269998,
    "dropmaladd": "415 W PIKE ST",
    "dropmalcty": "GOSHEN",
    "dropmalst": "IN",
    "dropmalzpp": 465269998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745333915,
    "dropfax": 5745338077
  },
  {
    "dcode": "D",
    "dropkey": "PX12324",
    "droptype": "D",
    "dropname": "GOSPORT",
    "dropdeladd": "11 N 4TH ST",
    "dropdelcty": "GOSPORT",
    "dropdelst": "IN",
    "dropdelzpp": 474339998,
    "dropphyadd": "11 N 4TH ST",
    "dropphycty": "GOSPORT",
    "dropphyst": "IN",
    "dropphyzpp": 474339998,
    "dropmaladd": "11 N 4TH ST",
    "dropmalcty": "GOSPORT",
    "dropmalst": "IN",
    "dropmalzpp": 474339998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128794515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12325",
    "droptype": "D",
    "dropname": "GRABILL",
    "dropdeladd": "13716 3RD ST",
    "dropdelcty": "GRABILL",
    "dropdelst": "IN",
    "dropdelzpp": 467419998,
    "dropphyadd": "13716 3RD ST",
    "dropphycty": "GRABILL",
    "dropphyst": "IN",
    "dropphyzpp": 467419998,
    "dropmaladd": "13716 3RD ST",
    "dropmalcty": "GRABILL",
    "dropmalst": "IN",
    "dropmalzpp": 467419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606272343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12329",
    "droptype": "D",
    "dropname": "GRANDVIEW",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "GRANDVIEW",
    "dropdelst": "IN",
    "dropdelzpp": 476159998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "GRANDVIEW",
    "dropphyst": "IN",
    "dropphyzpp": 476159998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "GRANDVIEW",
    "dropmalst": "IN",
    "dropmalzpp": 476159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8126494046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12330",
    "droptype": "D",
    "dropname": "GRANGER",
    "dropdeladd": "12412 BITTERSWEET COMMONS BLVD W",
    "dropdelcty": "GRANGER",
    "dropdelst": "IN",
    "dropdelzpp": 465309998,
    "dropphyadd": "12412 BITTERSWEET COMMONS BLVD W",
    "dropphycty": "GRANGER",
    "dropphyst": "IN",
    "dropphyzpp": 465309998,
    "dropmaladd": "12412 BITTERSWEET COMMONS BLVD W",
    "dropmalcty": "GRANGER",
    "dropmalst": "IN",
    "dropmalzpp": 465309998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742723737,
    "dropfax": 5742721267
  },
  {
    "dcode": "D",
    "dropkey": "PX12339",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "2269 N STATE ROAD 63",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 478529998,
    "dropphyadd": "2269 N STATE ROAD 63",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 478529998,
    "dropmaladd": "2269 N STATE ROAD 63",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 478529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123824422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12347",
    "droptype": "D",
    "dropname": "GREENCASTLE",
    "dropdeladd": "8 E WALNUT ST",
    "dropdelcty": "GREENCASTLE",
    "dropdelst": "IN",
    "dropdelzpp": 461359998,
    "dropphyadd": "8 E WALNUT ST",
    "dropphycty": "GREENCASTLE",
    "dropphyst": "IN",
    "dropphyzpp": 461359998,
    "dropmaladd": "8 E WALNUT ST",
    "dropmalcty": "GREENCASTLE",
    "dropmalst": "IN",
    "dropmalzpp": 461359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656535618,
    "dropfax": 7656536514
  },
  {
    "dcode": "D",
    "dropkey": "PX12352",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "207 N STATE ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 461409998,
    "dropphyadd": "207 N STATE ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 461409998,
    "dropmaladd": "207 N STATE ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 461409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174625569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12353",
    "droptype": "D",
    "dropname": "GREENS FORK",
    "dropdeladd": "15 S MAIN ST",
    "dropdelcty": "GREENS FORK",
    "dropdelst": "IN",
    "dropdelzpp": 473459998,
    "dropphyadd": "15 S MAIN ST",
    "dropphycty": "GREENS FORK",
    "dropphyst": "IN",
    "dropphyzpp": 473459998,
    "dropmaladd": "15 S MAIN ST",
    "dropmalcty": "GREENS FORK",
    "dropmalst": "IN",
    "dropmalzpp": 473459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658865341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12356",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "260 N HIGH ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "IN",
    "dropdelzpp": 473449998,
    "dropphyadd": "260 N HIGH ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "IN",
    "dropphyzpp": 473449998,
    "dropmaladd": "260 N HIGH ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "IN",
    "dropmalzpp": 473449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659878465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12358",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "231 N FRANKLIN ST",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 472409998,
    "dropphyadd": "231 N FRANKLIN ST",
    "dropphycty": "GREENSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 472409998,
    "dropmaladd": "231 N FRANKLIN ST",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 472409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126638109,
    "dropfax": 8126626679
  },
  {
    "dcode": "D",
    "dropkey": "PX12360",
    "droptype": "D",
    "dropname": "GREENTOWN",
    "dropdeladd": "204 S MERIDIAN ST",
    "dropdelcty": "GREENTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 469369998,
    "dropphyadd": "204 S MERIDIAN ST",
    "dropphycty": "GREENTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 469369998,
    "dropmaladd": "204 S MERIDIAN ST",
    "dropmalcty": "GREENTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 469369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656287062,
    "dropfax": 7656287133
  },
  {
    "dcode": "D",
    "dropkey": "PX12362",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "9615 HIGHWAY 150",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471249998,
    "dropphyadd": "9615 HIGHWAY 150",
    "dropphycty": "GREENVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471249998,
    "dropmaladd": "9615 HIGHWAY 150",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129238034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12364",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "407 W SMITH VALLEY RD",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "IN",
    "dropdelzpp": 461429998,
    "dropphyadd": "407 W SMITH VALLEY RD",
    "dropphycty": "GREENWOOD",
    "dropphyst": "IN",
    "dropphyzpp": 461429998,
    "dropmaladd": "407 W SMITH VALLEY RD",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "IN",
    "dropmalzpp": 461429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646043,
    "dropfax": 3174646044
  },
  {
    "dcode": "D",
    "dropkey": "PX12366",
    "droptype": "D",
    "dropname": "GRIFFIN",
    "dropdeladd": "224 S MAIN ST",
    "dropdelcty": "GRIFFIN",
    "dropdelst": "IN",
    "dropdelzpp": 476169998,
    "dropphyadd": "224 S MAIN ST",
    "dropphycty": "GRIFFIN",
    "dropphyst": "IN",
    "dropphyzpp": 476169998,
    "dropmaladd": "224 S MAIN ST",
    "dropmalcty": "GRIFFIN",
    "dropmalst": "IN",
    "dropmalzpp": 476169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128513831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12367",
    "droptype": "D",
    "dropname": "GRIFFITH",
    "dropdeladd": "900 N BROAD ST",
    "dropdelcty": "GRIFFITH",
    "dropdelst": "IN",
    "dropdelzpp": 463199998,
    "dropphyadd": "900 N BROAD ST",
    "dropphycty": "GRIFFITH",
    "dropphyst": "IN",
    "dropphyzpp": 463199998,
    "dropmaladd": "900 N BROAD ST",
    "dropmalcty": "GRIFFITH",
    "dropmalst": "IN",
    "dropmalzpp": 463199998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198384140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12378",
    "droptype": "D",
    "dropname": "GROVERTOWN",
    "dropdeladd": "4840 N STATE ROAD 23",
    "dropdelcty": "GROVERTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 465319998,
    "dropphyadd": "4840 N STATE ROAD 23",
    "dropphycty": "GROVERTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 465319998,
    "dropmaladd": "4840 N STATE ROAD 23",
    "dropmalcty": "GROVERTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 465319998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748678388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12380",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "5026 MAIN ST",
    "dropdelcty": "GUILFORD",
    "dropdelst": "IN",
    "dropdelzpp": 470229998,
    "dropphyadd": "5026 MAIN ST",
    "dropphycty": "GUILFORD",
    "dropphyst": "IN",
    "dropphyzpp": 470229998,
    "dropmaladd": "5026 MAIN ST",
    "dropmalcty": "GUILFORD",
    "dropmalst": "IN",
    "dropmalzpp": 470229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8124872590,
    "dropsitcph": 8124872590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12384",
    "droptype": "D",
    "dropname": "GWYNNEVILLE",
    "dropdeladd": "7137 E US HIGHWAY 52",
    "dropdelcty": "GWYNNEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461449998,
    "dropphyadd": "7137 E US HIGHWAY 52",
    "dropphycty": "GWYNNEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461449998,
    "dropmaladd": "7137 E US HIGHWAY 52",
    "dropmalcty": "GWYNNEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657636756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12389",
    "droptype": "D",
    "dropname": "HAGERSTOWN",
    "dropdeladd": "10 W MAIN ST",
    "dropdelcty": "HAGERSTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 473469998,
    "dropphyadd": "10 W MAIN ST",
    "dropphycty": "HAGERSTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 473469998,
    "dropmaladd": "10 W MAIN ST",
    "dropmalcty": "HAGERSTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 473469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654895242,
    "dropfax": 7654894659
  },
  {
    "dcode": "D",
    "dropkey": "PX12394",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "3900 E BELLEFONTAINE RD",
    "dropdelcty": "HAMILTON",
    "dropdelst": "IN",
    "dropdelzpp": 467429998,
    "dropphyadd": "3900 E BELLEFONTAINE RD",
    "dropphycty": "HAMILTON",
    "dropphyst": "IN",
    "dropphyzpp": 467429998,
    "dropmaladd": "3900 E BELLEFONTAINE RD",
    "dropmalcty": "HAMILTON",
    "dropmalst": "IN",
    "dropmalzpp": 467429998,
    "dropsitphn": 2608682179,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604882812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12397",
    "droptype": "D",
    "dropname": "HAMLET",
    "dropdeladd": "1 STARKE ST",
    "dropdelcty": "HAMLET",
    "dropdelst": "IN",
    "dropdelzpp": 465329998,
    "dropphyadd": "1 STARKE ST",
    "dropphycty": "HAMLET",
    "dropphyst": "IN",
    "dropphyzpp": 465329998,
    "dropmaladd": "1 STARKE ST",
    "dropmalcty": "HAMLET",
    "dropmalst": "IN",
    "dropmalzpp": 465329998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748673201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12398",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "5530 SOHL AVE",
    "dropdelcty": "HAMMOND",
    "dropdelst": "IN",
    "dropdelzpp": 463209998,
    "dropphyadd": "5530 SOHL AVE",
    "dropphycty": "HAMMOND",
    "dropphyst": "IN",
    "dropphyzpp": 463209998,
    "dropmaladd": "5530 SOHL AVE",
    "dropmalcty": "HAMMOND",
    "dropmalst": "IN",
    "dropmalzpp": 463209998,
    "dropsitphn": 2199322757,
    "dropsitlph": 3174646350,
    "dropsitcph": 2199322757,
    "dropfax": 2199379470
  },
  {
    "dcode": "D",
    "dropkey": "PX12401",
    "droptype": "D",
    "dropname": "HANNA",
    "dropdeladd": "5 W YOUNG ST",
    "dropdelcty": "HANNA",
    "dropdelst": "IN",
    "dropdelzpp": 463409998,
    "dropphyadd": "5 W YOUNG ST",
    "dropphycty": "HANNA",
    "dropphyst": "IN",
    "dropphyzpp": 463409998,
    "dropmaladd": "5 W YOUNG ST",
    "dropmalcty": "HANNA",
    "dropmalst": "IN",
    "dropmalzpp": 463409998,
    "dropsitphn": 2197972985,
    "dropsitlph": 2197972985,
    "dropsitcph": 2197972985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12402",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "264 E MAIN ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "IN",
    "dropdelzpp": 472439998,
    "dropphyadd": "264 E MAIN ST",
    "dropphycty": "HANOVER",
    "dropphyst": "IN",
    "dropphyzpp": 472439998,
    "dropmaladd": "264 E MAIN ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "IN",
    "dropmalzpp": 472439998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128663522,
    "dropfax": 8128665452
  },
  {
    "dcode": "D",
    "dropkey": "PX12406",
    "droptype": "D",
    "dropname": "HARDINSBURG",
    "dropdeladd": "52 E US HIGHWAY 150",
    "dropdelcty": "HARDINSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 471259998,
    "dropphyadd": "52 E US HIGHWAY 150",
    "dropphycty": "HARDINSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 471259998,
    "dropmaladd": "52 E US HIGHWAY 150",
    "dropmalcty": "HARDINSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 471259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124723414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12407",
    "droptype": "D",
    "dropname": "HARLAN",
    "dropdeladd": "11927 WATER ST",
    "dropdelcty": "HARLAN",
    "dropdelst": "IN",
    "dropdelzpp": 467439998,
    "dropphyadd": "11927 WATER ST",
    "dropphycty": "HARLAN",
    "dropphyst": "IN",
    "dropphyzpp": 467439998,
    "dropmaladd": "11927 WATER ST",
    "dropmalcty": "HARLAN",
    "dropmalst": "IN",
    "dropmalzpp": 467439998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606575569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12409",
    "droptype": "D",
    "dropname": "HARMONY",
    "dropdeladd": "1875 E US HIGHWAY 40",
    "dropdelcty": "HARMONY",
    "dropdelst": "IN",
    "dropdelzpp": 478539998,
    "dropphyadd": "1875 E US HIGHWAY 40",
    "dropphycty": "HARMONY",
    "dropphyst": "IN",
    "dropphyzpp": 478539998,
    "dropmaladd": "1875 E US HIGHWAY 40",
    "dropmalcty": "HARMONY",
    "dropmalst": "IN",
    "dropmalzpp": 478539998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124483835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12421",
    "droptype": "D",
    "dropname": "HARRODSBURG",
    "dropdeladd": "9262 S HARRODSBURG RD",
    "dropdelcty": "HARRODSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 474349998,
    "dropphyadd": "9262 S HARRODSBURG RD",
    "dropphycty": "HARRODSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 474349998,
    "dropmaladd": "9262 S HARRODSBURG RD",
    "dropmalcty": "HARRODSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 474349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128246234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12423",
    "droptype": "D",
    "dropname": "HARTFORD CITY",
    "dropdeladd": "123 S HIGH ST",
    "dropdelcty": "HARTFORD CITY",
    "dropdelst": "IN",
    "dropdelzpp": 473489998,
    "dropphyadd": "123 S HIGH ST",
    "dropphycty": "HARTFORD CITY",
    "dropphyst": "IN",
    "dropphyzpp": 473489998,
    "dropmaladd": "123 S HIGH ST",
    "dropmalcty": "HARTFORD CITY",
    "dropmalst": "IN",
    "dropmalzpp": 473489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653480520,
    "dropfax": 7653480750
  },
  {
    "dcode": "D",
    "dropkey": "PX12427",
    "droptype": "D",
    "dropname": "HARTSVILLE",
    "dropdeladd": "110 N WASHINGTON ST",
    "dropdelcty": "HARTSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 472449998,
    "dropphyadd": "110 N WASHINGTON ST",
    "dropphycty": "HARTSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 472449998,
    "dropmaladd": "110 N WASHINGTON ST",
    "dropmalcty": "HARTSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 472449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125464068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12432",
    "droptype": "D",
    "dropname": "HATFIELD",
    "dropdeladd": "9129 W OLD STATE ROAD 66",
    "dropdelcty": "HATFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 476179998,
    "dropphyadd": "9129 W OLD STATE ROAD 66",
    "dropphycty": "HATFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 476179998,
    "dropmaladd": "9129 W OLD STATE ROAD 66",
    "dropmalcty": "HATFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 476179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123595356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12434",
    "droptype": "D",
    "dropname": "HAUBSTADT",
    "dropdeladd": "107 W HAUB ST",
    "dropdelcty": "HAUBSTADT",
    "dropdelst": "IN",
    "dropdelzpp": 476399998,
    "dropphyadd": "107 W HAUB ST",
    "dropphycty": "HAUBSTADT",
    "dropphyst": "IN",
    "dropphyzpp": 476399998,
    "dropmaladd": "107 W HAUB ST",
    "dropmalcty": "HAUBSTADT",
    "dropmalst": "IN",
    "dropmalzpp": 476399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127686745,
    "dropfax": 8127533253
  },
  {
    "dcode": "D",
    "dropkey": "PX12436",
    "droptype": "D",
    "dropname": "HAYDEN",
    "dropdeladd": "60 S COUNTY ROAD 675 W",
    "dropdelcty": "HAYDEN",
    "dropdelst": "IN",
    "dropdelzpp": 472459998,
    "dropphyadd": "60 S COUNTY ROAD 675 W",
    "dropphycty": "HAYDEN",
    "dropphyst": "IN",
    "dropphyzpp": 472459998,
    "dropmaladd": "60 S COUNTY ROAD 675 W",
    "dropmalcty": "HAYDEN",
    "dropmalst": "IN",
    "dropmalzpp": 472459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123465040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12445",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "107 N WASHINGTON ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "IN",
    "dropdelzpp": 463419998,
    "dropphyadd": "107 N WASHINGTON ST",
    "dropphycty": "HEBRON",
    "dropphyst": "IN",
    "dropphyzpp": 463419998,
    "dropmaladd": "107 N WASHINGTON ST",
    "dropmalcty": "HEBRON",
    "dropmalst": "IN",
    "dropmalzpp": 463419998,
    "dropsitphn": 2199966181,
    "dropsitlph": 2199966181,
    "dropsitcph": 2199966181,
    "dropfax": 2199966808
  },
  {
    "dcode": "D",
    "dropkey": "PX12450",
    "droptype": "D",
    "dropname": "HELMSBURG",
    "dropdeladd": "2401 NORTH ST",
    "dropdelcty": "HELMSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 474359998,
    "dropphyadd": "2401 NORTH ST",
    "dropphycty": "HELMSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 474359998,
    "dropmaladd": "2401 NORTH ST",
    "dropmalcty": "HELMSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 474359998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179886302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12452",
    "droptype": "D",
    "dropname": "HELTONVILLE",
    "dropdeladd": "6525 STATE ROAD 58 E",
    "dropdelcty": "HELTONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474369998,
    "dropphyadd": "6525 STATE ROAD 58 E",
    "dropphycty": "HELTONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474369998,
    "dropmaladd": "6525 STATE ROAD 58 E",
    "dropmalcty": "HELTONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128345842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12455",
    "droptype": "D",
    "dropname": "HEMLOCK",
    "dropdeladd": "4577 E 400 S",
    "dropdelcty": "HEMLOCK",
    "dropdelst": "IN",
    "dropdelzpp": 469379998,
    "dropphyadd": "4577 E 400 S",
    "dropphycty": "HEMLOCK",
    "dropphyst": "IN",
    "dropphyzpp": 469379998,
    "dropmaladd": "4577 E 400 S",
    "dropmalcty": "HEMLOCK",
    "dropmalst": "IN",
    "dropmalzpp": 469379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654533449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12459",
    "droptype": "D",
    "dropname": "HENRYVILLE",
    "dropdeladd": "102 S FERGUSON ST",
    "dropdelcty": "HENRYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471269998,
    "dropphyadd": "102 S FERGUSON ST",
    "dropphycty": "HENRYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471269998,
    "dropmaladd": "102 S FERGUSON ST",
    "dropmalcty": "HENRYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122944887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12480",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "IN",
    "dropdelzpp": 479499998,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "IN",
    "dropphyzpp": 479499998,
    "dropmaladd": "202 E MAIN ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "IN",
    "dropmalzpp": 479499998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657983135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12483",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "7267 S 1ST ST",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "IN",
    "dropdelzpp": 478549998,
    "dropphyadd": "7267 S 1ST ST",
    "dropphycty": "HILLSDALE",
    "dropphyst": "IN",
    "dropphyzpp": 478549998,
    "dropmaladd": "7267 S 1ST ST",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "IN",
    "dropmalzpp": 478549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652452064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12491",
    "droptype": "D",
    "dropname": "HOAGLAND",
    "dropdeladd": "10811 HOAGLAND RD",
    "dropdelcty": "HOAGLAND",
    "dropdelst": "IN",
    "dropdelzpp": 467459998,
    "dropphyadd": "10811 HOAGLAND RD",
    "dropphycty": "HOAGLAND",
    "dropphyst": "IN",
    "dropphyzpp": 467459998,
    "dropmaladd": "10811 HOAGLAND RD",
    "dropmalcty": "HOAGLAND",
    "dropmalst": "IN",
    "dropmalzpp": 467459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606393107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12492",
    "droptype": "D",
    "dropname": "HOBART",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "HOBART",
    "dropdelst": "IN",
    "dropdelzpp": 463429998,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "HOBART",
    "dropphyst": "IN",
    "dropphyzpp": 463429998,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "HOBART",
    "dropmalst": "IN",
    "dropmalzpp": 463429998,
    "dropsitphn": 2199422721,
    "dropsitlph": 2199422721,
    "dropsitcph": 2199422721,
    "dropfax": 2199421156
  },
  {
    "dcode": "D",
    "dropkey": "PX12494",
    "droptype": "D",
    "dropname": "HOBBS",
    "dropdeladd": "3484 E 150 S",
    "dropdelcty": "HOBBS",
    "dropdelst": "IN",
    "dropdelzpp": 460479998,
    "dropphyadd": "3484 E 150 S",
    "dropphycty": "HOBBS",
    "dropphyst": "IN",
    "dropphyzpp": 460479998,
    "dropmaladd": "3484 E 150 S",
    "dropmalcty": "HOBBS",
    "dropmalst": "IN",
    "dropmalzpp": 460479998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656752506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12496",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "403 W MAIN ST",
    "dropdelcty": "HOLLAND",
    "dropdelst": "IN",
    "dropdelzpp": 475419998,
    "dropphyadd": "403 W MAIN ST",
    "dropphycty": "HOLLAND",
    "dropphyst": "IN",
    "dropphyzpp": 475419998,
    "dropmaladd": "403 W MAIN ST",
    "dropmalcty": "HOLLAND",
    "dropmalst": "IN",
    "dropmalzpp": 475419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125363261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12501",
    "droptype": "D",
    "dropname": "HOLTON",
    "dropdeladd": "2 S MARION ST",
    "dropdelcty": "HOLTON",
    "dropdelst": "IN",
    "dropdelzpp": 470239998,
    "dropphyadd": "2 S MARION ST",
    "dropphycty": "HOLTON",
    "dropphyst": "IN",
    "dropphyzpp": 470239998,
    "dropmaladd": "2 S MARION ST",
    "dropmalcty": "HOLTON",
    "dropmalst": "IN",
    "dropmalzpp": 470239998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126896114,
    "dropsitcph": 8126896114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12513",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "739 MAIN ST",
    "dropdelcty": "HOPE",
    "dropdelst": "IN",
    "dropdelzpp": 472469998,
    "dropphyadd": "739 MAIN ST",
    "dropphycty": "HOPE",
    "dropphyst": "IN",
    "dropphyzpp": 472469998,
    "dropmaladd": "739 MAIN ST",
    "dropmalcty": "HOPE",
    "dropmalst": "IN",
    "dropmalzpp": 472469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125464241,
    "dropfax": 8125464241
  },
  {
    "dcode": "D",
    "dropkey": "PX12516",
    "droptype": "D",
    "dropname": "HOWE",
    "dropdeladd": "404 DEFIANCE ST",
    "dropdelcty": "HOWE",
    "dropdelst": "IN",
    "dropdelzpp": 467469998,
    "dropphyadd": "404 DEFIANCE ST",
    "dropphycty": "HOWE",
    "dropphyst": "IN",
    "dropphyzpp": 467469998,
    "dropmaladd": "404 DEFIANCE ST",
    "dropmalcty": "HOWE",
    "dropmalst": "IN",
    "dropmalzpp": 467469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605622191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12521",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "318 N MAIN ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "IN",
    "dropdelzpp": 467479998,
    "dropphyadd": "318 N MAIN ST",
    "dropphycty": "HUDSON",
    "dropphyst": "IN",
    "dropphyzpp": 467479998,
    "dropmaladd": "318 N MAIN ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "IN",
    "dropmalzpp": 467479998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605879273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12526",
    "droptype": "D",
    "dropname": "HUNTERTOWN",
    "dropdeladd": "15741 LIMA RD",
    "dropdelcty": "HUNTERTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 467489998,
    "dropphyadd": "15741 LIMA RD",
    "dropphycty": "HUNTERTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 467489998,
    "dropmaladd": "15741 LIMA RD",
    "dropmalcty": "HUNTERTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 467489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606376814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12529",
    "droptype": "D",
    "dropname": "HUNTINGBURG",
    "dropdeladd": "410 N JACKSON ST",
    "dropdelcty": "HUNTINGBURG",
    "dropdelst": "IN",
    "dropdelzpp": 475429998,
    "dropphyadd": "410 N JACKSON ST",
    "dropphycty": "HUNTINGBURG",
    "dropphyst": "IN",
    "dropphyzpp": 475429998,
    "dropmaladd": "410 N JACKSON ST",
    "dropmalcty": "HUNTINGBURG",
    "dropmalst": "IN",
    "dropmalzpp": 475429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646035,
    "dropsitcph": 8126832706,
    "dropfax": 8126835404
  },
  {
    "dcode": "D",
    "dropkey": "PX12531",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "330 W MARKET ST",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 467509998,
    "dropphyadd": "330 W MARKET ST",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 467509998,
    "dropmaladd": "330 W MARKET ST",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 467509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603560920,
    "dropfax": 2603565875
  },
  {
    "dcode": "D",
    "dropkey": "PX12533",
    "droptype": "D",
    "dropname": "HURON",
    "dropdeladd": "513 HURON PIKE",
    "dropdelcty": "HURON",
    "dropdelst": "IN",
    "dropdelzpp": 474379998,
    "dropphyadd": "513 HURON PIKE",
    "dropphycty": "HURON",
    "dropphyst": "IN",
    "dropphyzpp": 474379998,
    "dropmaladd": "513 HURON PIKE",
    "dropmalcty": "HURON",
    "dropmalst": "IN",
    "dropmalzpp": 474379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128494768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12536",
    "droptype": "D",
    "dropname": "HYMERA",
    "dropdeladd": "119 S MAIN ST",
    "dropdelcty": "HYMERA",
    "dropdelst": "IN",
    "dropdelzpp": 478559998,
    "dropphyadd": "119 S MAIN ST",
    "dropphycty": "HYMERA",
    "dropphyst": "IN",
    "dropphyzpp": 478559998,
    "dropmaladd": "119 S MAIN ST",
    "dropmalcty": "HYMERA",
    "dropmalst": "IN",
    "dropmalzpp": 478559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123839693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12540",
    "droptype": "D",
    "dropname": "IDAVILLE",
    "dropdeladd": "106 W US HIGHWAY 24",
    "dropdelcty": "IDAVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479509998,
    "dropphyadd": "106 W US HIGHWAY 24",
    "dropphycty": "IDAVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479509998,
    "dropmaladd": "106 W US HIGHWAY 24",
    "dropmalcty": "IDAVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479509998,
    "dropsitphn": 3714646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5749433503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12558",
    "droptype": "D",
    "dropname": "INDIANAPOLIS",
    "dropdeladd": "125 W SOUTH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462069998,
    "dropphyadd": "125 W SOUTH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462069998,
    "dropmaladd": "125 W SOUTH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462069998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646876,
    "dropfax": 3174646011
  },
  {
    "dcode": "D",
    "dropkey": "PX12564",
    "droptype": "D",
    "dropname": "INGALLS",
    "dropdeladd": "151 W BROADWAY ST",
    "dropdelcty": "INGALLS",
    "dropdelst": "IN",
    "dropdelzpp": 460489998,
    "dropphyadd": "151 W BROADWAY ST",
    "dropphycty": "INGALLS",
    "dropphyst": "IN",
    "dropphyzpp": 460489998,
    "dropmaladd": "151 W BROADWAY ST",
    "dropmalcty": "INGALLS",
    "dropmalst": "IN",
    "dropmalzpp": 460489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174854300,
    "dropfax": 3174854300
  },
  {
    "dcode": "D",
    "dropkey": "PX12565",
    "droptype": "D",
    "dropname": "INGLEFIELD",
    "dropdeladd": "13200 DARMSTADT RD",
    "dropdelcty": "INGLEFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 476189998,
    "dropphyadd": "13200 DARMSTADT RD",
    "dropphycty": "INGLEFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 476189998,
    "dropmaladd": "13200 DARMSTADT RD",
    "dropmalcty": "INGLEFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 476189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128672678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12567",
    "droptype": "D",
    "dropname": "IRELAND",
    "dropdeladd": "2423 N 500 W",
    "dropdelcty": "IRELAND",
    "dropdelst": "IN",
    "dropdelzpp": 475459998,
    "dropphyadd": "2423 N 500 W",
    "dropphycty": "IRELAND",
    "dropphyst": "IN",
    "dropphyzpp": 475459998,
    "dropmaladd": "2423 N 500 W",
    "dropmalcty": "IRELAND",
    "dropmalst": "IN",
    "dropmalzpp": 475459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124827118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12591",
    "droptype": "D",
    "dropname": "JASONVILLE",
    "dropdeladd": "325 W MAIN ST",
    "dropdelcty": "JASONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474389998,
    "dropphyadd": "325 W MAIN ST",
    "dropphycty": "JASONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474389998,
    "dropmaladd": "325 W MAIN ST",
    "dropmalcty": "JASONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126653537,
    "dropfax": 8126654076
  },
  {
    "dcode": "D",
    "dropkey": "PX12594",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "206 E 6TH ST",
    "dropdelcty": "JASPER",
    "dropdelst": "IN",
    "dropdelzpp": 475469998,
    "dropphyadd": "206 E 6TH ST",
    "dropphycty": "JASPER",
    "dropphyst": "IN",
    "dropphyzpp": 475469998,
    "dropmaladd": "206 E 6TH ST",
    "dropmalcty": "JASPER",
    "dropmalst": "IN",
    "dropmalzpp": 475469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126345050,
    "dropfax": 8126341947
  },
  {
    "dcode": "D",
    "dropkey": "PX12610",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "303 E COURT AVE",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471309998,
    "dropphyadd": "303 E COURT AVE",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471309998,
    "dropmaladd": "303 E COURT AVE",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122844834,
    "dropfax": 8122851202
  },
  {
    "dcode": "D",
    "dropkey": "PX12632",
    "droptype": "D",
    "dropname": "KEMPTON",
    "dropdeladd": "101 S WEST ST",
    "dropdelcty": "KEMPTON",
    "dropdelst": "IN",
    "dropdelzpp": 460499998,
    "dropphyadd": "101 S WEST ST",
    "dropphycty": "KEMPTON",
    "dropphyst": "IN",
    "dropphyzpp": 460499998,
    "dropmaladd": "101 S WEST ST",
    "dropmalcty": "KEMPTON",
    "dropmalst": "IN",
    "dropmalzpp": 460499998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659475165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12633",
    "droptype": "D",
    "dropname": "KENDALLVILLE",
    "dropdeladd": "695 FAIR ST",
    "dropdelcty": "KENDALLVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467559998,
    "dropphyadd": "695 FAIR ST",
    "dropphycty": "KENDALLVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467559998,
    "dropmaladd": "695 FAIR ST",
    "dropmalcty": "KENDALLVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603471152,
    "dropfax": 2603479508
  },
  {
    "dcode": "D",
    "dropkey": "PX12636",
    "droptype": "D",
    "dropname": "KENNARD",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "KENNARD",
    "dropdelst": "IN",
    "dropdelzpp": 473519700,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "KENNARD",
    "dropphyst": "IN",
    "dropphyzpp": 473519700,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "KENNARD",
    "dropmalst": "IN",
    "dropmalzpp": 473519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657852300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12638",
    "droptype": "D",
    "dropname": "KENTLAND",
    "dropdeladd": "309 E GRAHAM ST",
    "dropdelcty": "KENTLAND",
    "dropdelst": "IN",
    "dropdelzpp": 479519998,
    "dropphyadd": "309 E GRAHAM ST",
    "dropphycty": "KENTLAND",
    "dropphyst": "IN",
    "dropphyzpp": 479519998,
    "dropmaladd": "309 E GRAHAM ST",
    "dropmalcty": "KENTLAND",
    "dropmalst": "IN",
    "dropmalzpp": 479519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2194746313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12641",
    "droptype": "D",
    "dropname": "KEWANNA",
    "dropdeladd": "203 E MAIN ST",
    "dropdelcty": "KEWANNA",
    "dropdelst": "IN",
    "dropdelzpp": 469399998,
    "dropphyadd": "203 E MAIN ST",
    "dropphycty": "KEWANNA",
    "dropphyst": "IN",
    "dropphyzpp": 469399998,
    "dropmaladd": "203 E MAIN ST",
    "dropmalcty": "KEWANNA",
    "dropmalst": "IN",
    "dropmalzpp": 469399998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746532316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12643",
    "droptype": "D",
    "dropname": "KEYSTONE",
    "dropdeladd": "10016 S 200 W",
    "dropdelcty": "KEYSTONE",
    "dropdelst": "IN",
    "dropdelzpp": 467599998,
    "dropphyadd": "10016 S 200 W",
    "dropphycty": "KEYSTONE",
    "dropphyst": "IN",
    "dropphyzpp": 467599998,
    "dropmaladd": "10016 S 200 W",
    "dropmalcty": "KEYSTONE",
    "dropmalst": "IN",
    "dropmalzpp": 467599998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657282822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12646",
    "droptype": "D",
    "dropname": "KIMMELL",
    "dropdeladd": "6461 W NOE ST",
    "dropdelcty": "KIMMELL",
    "dropdelst": "IN",
    "dropdelzpp": 467609998,
    "dropphyadd": "6461 W NOE ST",
    "dropphycty": "KIMMELL",
    "dropphyst": "IN",
    "dropphyzpp": 467609998,
    "dropmaladd": "6461 W NOE ST",
    "dropmalcty": "KIMMELL",
    "dropmalst": "IN",
    "dropmalzpp": 467609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606352033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12647",
    "droptype": "D",
    "dropname": "KINGMAN",
    "dropdeladd": "119 E STATE ST",
    "dropdelcty": "KINGMAN",
    "dropdelst": "IN",
    "dropdelzpp": 479529998,
    "dropphyadd": "119 E STATE ST",
    "dropphycty": "KINGMAN",
    "dropphyst": "IN",
    "dropphyzpp": 479529998,
    "dropmaladd": "119 E STATE ST",
    "dropmalcty": "KINGMAN",
    "dropmalst": "IN",
    "dropmalzpp": 479529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174746305,
    "dropsitcph": 7653973903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12648",
    "droptype": "D",
    "dropname": "KINGSBURY",
    "dropdeladd": "5164 S US HIGHWAY 35",
    "dropdelcty": "KINGSBURY",
    "dropdelst": "IN",
    "dropdelzpp": 463459998,
    "dropphyadd": "5164 S US HIGHWAY 35",
    "dropphycty": "KINGSBURY",
    "dropphyst": "IN",
    "dropphyzpp": 463459998,
    "dropmaladd": "5164 S US HIGHWAY 35",
    "dropmalcty": "KINGSBURY",
    "dropmalst": "IN",
    "dropmalzpp": 463459998,
    "dropsitphn": 2193933239,
    "dropsitlph": 2193933239,
    "dropsitcph": 2193933239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12649",
    "droptype": "D",
    "dropname": "KINGSFORD HEIGHTS",
    "dropdeladd": "423 PARK RD",
    "dropdelcty": "KINGSFORD HEIGHTS",
    "dropdelst": "IN",
    "dropdelzpp": 463469998,
    "dropphyadd": "423 PARK RD",
    "dropphycty": "KINGSFORD HEIGHTS",
    "dropphyst": "IN",
    "dropphyzpp": 463469998,
    "dropmaladd": "423 PARK RD",
    "dropmalcty": "KINGSFORD HEIGHTS",
    "dropmalst": "IN",
    "dropmalzpp": 463469998,
    "dropsitphn": 2193933821,
    "dropsitlph": 2193933821,
    "dropsitcph": 2193933821,
    "dropfax": 2193933821
  },
  {
    "dcode": "D",
    "dropkey": "PX12656",
    "droptype": "D",
    "dropname": "KIRKLIN",
    "dropdeladd": "102 S OHIO ST",
    "dropdelcty": "KIRKLIN",
    "dropdelst": "IN",
    "dropdelzpp": 460509998,
    "dropphyadd": "102 S OHIO ST",
    "dropphycty": "KIRKLIN",
    "dropphyst": "IN",
    "dropphyzpp": 460509998,
    "dropmaladd": "102 S OHIO ST",
    "dropmalcty": "KIRKLIN",
    "dropmalst": "IN",
    "dropmalzpp": 460509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652798334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12663",
    "droptype": "D",
    "dropname": "KNIGHTSTOWN",
    "dropdeladd": "37 N JEFFERSON ST",
    "dropdelcty": "KNIGHTSTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 461489998,
    "dropphyadd": "37 N JEFFERSON ST",
    "dropphycty": "KNIGHTSTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 461489998,
    "dropmaladd": "37 N JEFFERSON ST",
    "dropmalcty": "KNIGHTSTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 461489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653455575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12665",
    "droptype": "D",
    "dropname": "KNIGHTSVILLE",
    "dropdeladd": "9737 N CRAWFORD ST",
    "dropdelcty": "KNIGHTSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 478579998,
    "dropphyadd": "9737 N CRAWFORD ST",
    "dropphycty": "KNIGHTSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 478579998,
    "dropmaladd": "9737 N CRAWFORD ST",
    "dropmalcty": "KNIGHTSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 478579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124488900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12668",
    "droptype": "D",
    "dropname": "KNOX",
    "dropdeladd": "205 W WASHINGTON ST",
    "dropdelcty": "KNOX",
    "dropdelst": "IN",
    "dropdelzpp": 465349998,
    "dropphyadd": "205 W WASHINGTON ST",
    "dropphycty": "KNOX",
    "dropphyst": "IN",
    "dropphyzpp": 465349998,
    "dropmaladd": "205 W WASHINGTON ST",
    "dropmalcty": "KNOX",
    "dropmalst": "IN",
    "dropmalzpp": 465349998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747723822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12669",
    "droptype": "D",
    "dropname": "KOKOMO",
    "dropdeladd": "2719 S WEBSTER ST",
    "dropdelcty": "KOKOMO",
    "dropdelst": "IN",
    "dropdelzpp": 469029998,
    "dropphyadd": "2719 S WEBSTER ST",
    "dropphycty": "KOKOMO",
    "dropphyst": "IN",
    "dropphyzpp": 469029998,
    "dropmaladd": "2719 S WEBSTER ST",
    "dropmalcty": "KOKOMO",
    "dropmalst": "IN",
    "dropmalzpp": 469029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 7654558322,
    "dropsitcph": 7654558326,
    "dropfax": 7654558350
  },
  {
    "dcode": "D",
    "dropkey": "PX12673",
    "droptype": "D",
    "dropname": "KOUTS",
    "dropdeladd": "107 E ELIZABETH ST",
    "dropdelcty": "KOUTS",
    "dropdelst": "IN",
    "dropdelzpp": 463479998,
    "dropphyadd": "107 E ELIZABETH ST",
    "dropphycty": "KOUTS",
    "dropphyst": "IN",
    "dropphyzpp": 463479998,
    "dropmaladd": "107 E ELIZABETH ST",
    "dropmalcty": "KOUTS",
    "dropmalst": "IN",
    "dropmalzpp": 463479998,
    "dropsitphn": 3174646350,
    "dropsitlph": 2197662461,
    "dropsitcph": 2197662461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12676",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "16 W MAIN ST",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "IN",
    "dropdelzpp": 463489998,
    "dropphyadd": "16 W MAIN ST",
    "dropphycty": "LA CROSSE",
    "dropphyst": "IN",
    "dropphyzpp": 463489998,
    "dropmaladd": "16 W MAIN ST",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "IN",
    "dropmalzpp": 463489998,
    "dropsitphn": 2197542211,
    "dropsitlph": 2197542211,
    "dropsitcph": 2197542211,
    "dropfax": 2197542211
  },
  {
    "dcode": "D",
    "dropkey": "PX12677",
    "droptype": "D",
    "dropname": "LA FONTAINE",
    "dropdeladd": "12 W BRANSON ST",
    "dropdelcty": "LA FONTAINE",
    "dropdelst": "IN",
    "dropdelzpp": 469409998,
    "dropphyadd": "12 W BRANSON ST",
    "dropphycty": "LA FONTAINE",
    "dropphyst": "IN",
    "dropphyzpp": 469409998,
    "dropmaladd": "12 W BRANSON ST",
    "dropmalcty": "LA FONTAINE",
    "dropmalst": "IN",
    "dropmalzpp": 469409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659814242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12678",
    "droptype": "D",
    "dropname": "LA PORTE",
    "dropdeladd": "1201 LINCOLNWAY",
    "dropdelcty": "LA PORTE",
    "dropdelst": "IN",
    "dropdelzpp": 463509998,
    "dropphyadd": "1201 LINCOLNWAY",
    "dropphycty": "LA PORTE",
    "dropphyst": "IN",
    "dropphyzpp": 463509998,
    "dropmaladd": "1201 LINCOLNWAY",
    "dropmalcty": "LA PORTE",
    "dropmalst": "IN",
    "dropmalzpp": 463509998,
    "dropsitphn": 2193629514,
    "dropsitlph": 3174646350,
    "dropsitcph": 2193629515,
    "dropfax": 2193250779
  },
  {
    "dcode": "D",
    "dropkey": "PX12679",
    "droptype": "D",
    "dropname": "LACONIA",
    "dropdeladd": "11525 MAIN ST SE",
    "dropdelcty": "LACONIA",
    "dropdelst": "IN",
    "dropdelzpp": 471359998,
    "dropphyadd": "11525 MAIN ST SE",
    "dropphycty": "LACONIA",
    "dropphyst": "IN",
    "dropphyzpp": 471359998,
    "dropmaladd": "11525 MAIN ST SE",
    "dropmalcty": "LACONIA",
    "dropmalst": "IN",
    "dropmalzpp": 471359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127372851,
    "dropfax": 8127372851
  },
  {
    "dcode": "D",
    "dropkey": "PX12680",
    "droptype": "D",
    "dropname": "LADOGA",
    "dropdeladd": "229 E MAIN ST",
    "dropdelcty": "LADOGA",
    "dropdelst": "IN",
    "dropdelzpp": 479549998,
    "dropphyadd": "229 E MAIN ST",
    "dropphycty": "LADOGA",
    "dropphyst": "IN",
    "dropphyzpp": 479549998,
    "dropmaladd": "229 E MAIN ST",
    "dropmalcty": "LADOGA",
    "dropmalst": "IN",
    "dropmalzpp": 479549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659422205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12683",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "3450 SOUTH ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479059998,
    "dropphyadd": "3450 SOUTH ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479059998,
    "dropmaladd": "3450 SOUTH ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479059998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489221,
    "dropfax": 7654489292
  },
  {
    "dcode": "D",
    "dropkey": "PX12686",
    "droptype": "D",
    "dropname": "LAGRANGE",
    "dropdeladd": "300 S DETROIT ST",
    "dropdelcty": "LAGRANGE",
    "dropdelst": "IN",
    "dropdelzpp": 467619998,
    "dropphyadd": "300 S DETROIT ST",
    "dropphycty": "LAGRANGE",
    "dropphyst": "IN",
    "dropphyzpp": 467619998,
    "dropmaladd": "300 S DETROIT ST",
    "dropmalcty": "LAGRANGE",
    "dropmalst": "IN",
    "dropmalzpp": 467619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604632844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12687",
    "droptype": "D",
    "dropname": "LAGRO",
    "dropdeladd": "830 MAIN ST",
    "dropdelcty": "LAGRO",
    "dropdelst": "IN",
    "dropdelzpp": 469419998,
    "dropphyadd": "830 MAIN ST",
    "dropphycty": "LAGRO",
    "dropphyst": "IN",
    "dropphyzpp": 469419998,
    "dropmaladd": "830 MAIN ST",
    "dropmalcty": "LAGRO",
    "dropmalst": "IN",
    "dropmalzpp": 469419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607822373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12688",
    "droptype": "D",
    "dropname": "LAKE CICOTT",
    "dropdeladd": "8080 W US HIGHWAY 24",
    "dropdelcty": "LAKE CICOTT",
    "dropdelst": "IN",
    "dropdelzpp": 469429998,
    "dropphyadd": "8080 W US HIGHWAY 24",
    "dropphycty": "LAKE CICOTT",
    "dropphyst": "IN",
    "dropphyzpp": 469429998,
    "dropmaladd": "8080 W US HIGHWAY 24",
    "dropmalcty": "LAKE CICOTT",
    "dropmalst": "IN",
    "dropmalzpp": 469429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747221358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12702",
    "droptype": "D",
    "dropname": "LAKE VILLAGE",
    "dropdeladd": "3041 W 950 N OFC",
    "dropdelcty": "LAKE VILLAGE",
    "dropdelst": "IN",
    "dropdelzpp": 463499998,
    "dropphyadd": "3041 W 950 N OFC",
    "dropphycty": "LAKE VILLAGE",
    "dropphyst": "IN",
    "dropphyzpp": 463499998,
    "dropmaladd": "3041 W 950 N OFC",
    "dropmalcty": "LAKE VILLAGE",
    "dropmalst": "IN",
    "dropmalzpp": 463499998,
    "dropsitphn": 2199923085,
    "dropsitlph": 2199923085,
    "dropsitcph": 2199923085,
    "dropfax": 2199923085
  },
  {
    "dcode": "D",
    "dropkey": "PX12710",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "115 N MICHIGAN ST",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 465369998,
    "dropphyadd": "115 N MICHIGAN ST",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 465369998,
    "dropmaladd": "115 N MICHIGAN ST",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 465369998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747848614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12714",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "12614 N STATE ROAD 245",
    "dropdelcty": "LAMAR",
    "dropdelst": "IN",
    "dropdelzpp": 475509998,
    "dropphyadd": "12614 N STATE ROAD 245",
    "dropphycty": "LAMAR",
    "dropphyst": "IN",
    "dropphyzpp": 475509998,
    "dropmaladd": "12614 N STATE ROAD 245",
    "dropmalcty": "LAMAR",
    "dropmalst": "IN",
    "dropmalzpp": 475509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125298447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12720",
    "droptype": "D",
    "dropname": "LANESVILLE",
    "dropdeladd": "2415 BARRON AVE NE",
    "dropdelcty": "LANESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471369998,
    "dropphyadd": "2415 BARRON AVE NE",
    "dropphycty": "LANESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471369998,
    "dropmaladd": "2415 BARRON AVE NE",
    "dropmalcty": "LANESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129523299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12721",
    "droptype": "D",
    "dropname": "LAOTTO",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "LAOTTO",
    "dropdelst": "IN",
    "dropdelzpp": 467639998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "LAOTTO",
    "dropphyst": "IN",
    "dropphyzpp": 467639998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "LAOTTO",
    "dropmalst": "IN",
    "dropmalzpp": 467639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608973054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12722",
    "droptype": "D",
    "dropname": "LAPAZ",
    "dropdeladd": "105 COURTLAND ST",
    "dropdelcty": "LAPAZ",
    "dropdelst": "IN",
    "dropdelzpp": 465379998,
    "dropphyadd": "105 COURTLAND ST",
    "dropphycty": "LAPAZ",
    "dropphyst": "IN",
    "dropphyzpp": 465379998,
    "dropmaladd": "105 COURTLAND ST",
    "dropmalcty": "LAPAZ",
    "dropmalst": "IN",
    "dropmalzpp": 465379998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747842432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12723",
    "droptype": "D",
    "dropname": "LAPEL",
    "dropdeladd": "803 N MAIN ST",
    "dropdelcty": "LAPEL",
    "dropdelst": "IN",
    "dropdelzpp": 460519998,
    "dropphyadd": "803 N MAIN ST",
    "dropphycty": "LAPEL",
    "dropphyst": "IN",
    "dropphyzpp": 460519998,
    "dropmaladd": "803 N MAIN ST",
    "dropmalcty": "LAPEL",
    "dropmalst": "IN",
    "dropmalzpp": 460519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655343173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12725",
    "droptype": "D",
    "dropname": "LARWILL",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "LARWILL",
    "dropdelst": "IN",
    "dropdelzpp": 467649998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "LARWILL",
    "dropphyst": "IN",
    "dropphyzpp": 467649998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "LARWILL",
    "dropmalst": "IN",
    "dropmalzpp": 467649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603273542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12727",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "123 W PEARL ST",
    "dropdelcty": "LAUREL",
    "dropdelst": "IN",
    "dropdelzpp": 470249998,
    "dropphyadd": "123 W PEARL ST",
    "dropphycty": "LAUREL",
    "dropphyst": "IN",
    "dropphyzpp": 470249998,
    "dropmaladd": "123 W PEARL ST",
    "dropmalcty": "LAUREL",
    "dropmalst": "IN",
    "dropmalzpp": 470249998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7656982357,
    "dropsitcph": 7656982357,
    "dropfax": 7656470154
  },
  {
    "dcode": "D",
    "dropkey": "PX12732",
    "droptype": "D",
    "dropname": "LAWRENCEBURG",
    "dropdeladd": "121 S TANNERS CREEK DR",
    "dropdelcty": "LAWRENCEBURG",
    "dropdelst": "IN",
    "dropdelzpp": 470250008,
    "dropphyadd": "121 S TANNERS CREEK DR",
    "dropphycty": "LAWRENCEBURG",
    "dropphyst": "IN",
    "dropphyzpp": 470250008,
    "dropmaladd": "121 S TANNERS CREEK DR",
    "dropmalcty": "LAWRENCEBURG",
    "dropmalst": "IN",
    "dropmalzpp": 470250008,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8125372626,
    "dropfax": 8125370143
  },
  {
    "dcode": "D",
    "dropkey": "PX12736",
    "droptype": "D",
    "dropname": "LEAVENWORTH",
    "dropdeladd": "176 N EAST ST",
    "dropdelcty": "LEAVENWORTH",
    "dropdelst": "IN",
    "dropdelzpp": 471379998,
    "dropphyadd": "176 N EAST ST",
    "dropphycty": "LEAVENWORTH",
    "dropphyst": "IN",
    "dropphyzpp": 471379998,
    "dropmaladd": "176 N EAST ST",
    "dropmalcty": "LEAVENWORTH",
    "dropmalst": "IN",
    "dropmalzpp": 471379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127392286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12737",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "304 W MAIN ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "IN",
    "dropdelzpp": 460529998,
    "dropphyadd": "304 W MAIN ST",
    "dropphycty": "LEBANON",
    "dropphyst": "IN",
    "dropphyzpp": 460529998,
    "dropmaladd": "304 W MAIN ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "IN",
    "dropmalzpp": 460529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654822630,
    "dropfax": 7654826297
  },
  {
    "dcode": "D",
    "dropkey": "PX12738",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "105 W VAN BUREN ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "IN",
    "dropdelzpp": 465389998,
    "dropphyadd": "105 W VAN BUREN ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "IN",
    "dropphyzpp": 465389998,
    "dropmaladd": "105 W VAN BUREN ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "IN",
    "dropmalzpp": 465389998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5744534800,
    "dropfax": 5744532192
  },
  {
    "dcode": "D",
    "dropkey": "PX12742",
    "droptype": "D",
    "dropname": "LEITERS FORD",
    "dropdeladd": "4510 SCHOOL ST",
    "dropdelcty": "LEITERS FORD",
    "dropdelst": "IN",
    "dropdelzpp": 469459998,
    "dropphyadd": "4510 SCHOOL ST",
    "dropphycty": "LEITERS FORD",
    "dropphyst": "IN",
    "dropphyzpp": 469459998,
    "dropmaladd": "4510 SCHOOL ST",
    "dropmalcty": "LEITERS FORD",
    "dropmalst": "IN",
    "dropmalzpp": 469459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745424821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12745",
    "droptype": "D",
    "dropname": "LEO",
    "dropdeladd": "14015 AMSTUTZ RD",
    "dropdelcty": "LEO",
    "dropdelst": "IN",
    "dropdelzpp": 467659998,
    "dropphyadd": "14015 AMSTUTZ RD",
    "dropphycty": "LEO",
    "dropphyst": "IN",
    "dropphyzpp": 467659998,
    "dropmaladd": "14015 AMSTUTZ RD",
    "dropmalcty": "LEO",
    "dropmalst": "IN",
    "dropmalzpp": 467659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606275619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12747",
    "droptype": "D",
    "dropname": "LEROY",
    "dropdeladd": "14120 ELKHART ST",
    "dropdelcty": "LEROY",
    "dropdelst": "IN",
    "dropdelzpp": 463559998,
    "dropphyadd": "14120 ELKHART ST",
    "dropphycty": "LEROY",
    "dropphyst": "IN",
    "dropphyzpp": 463559998,
    "dropmaladd": "14120 ELKHART ST",
    "dropmalcty": "LEROY",
    "dropmalst": "IN",
    "dropmalzpp": 463559998,
    "dropsitphn": 2196634223,
    "dropsitlph": 3174646350,
    "dropsitcph": 2196634223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12749",
    "droptype": "D",
    "dropname": "LEWIS",
    "dropdeladd": "10392 E STATE ROAD 246",
    "dropdelcty": "LEWIS",
    "dropdelst": "IN",
    "dropdelzpp": 478589998,
    "dropphyadd": "10392 E STATE ROAD 246",
    "dropphycty": "LEWIS",
    "dropphyst": "IN",
    "dropphyzpp": 478589998,
    "dropmaladd": "10392 E STATE ROAD 246",
    "dropmalcty": "LEWIS",
    "dropmalst": "IN",
    "dropmalzpp": 478589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124956130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12751",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "116 W MAIN ST",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473529998,
    "dropphyadd": "116 W MAIN ST",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473529998,
    "dropmaladd": "116 W MAIN ST",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659877247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12754",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "2765 S CHERRY ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 471389998,
    "dropphyadd": "2765 S CHERRY ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 471389998,
    "dropmaladd": "2765 S CHERRY ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 471389998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128892611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12756",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "29 E UNION ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "IN",
    "dropdelzpp": 473539998,
    "dropphyadd": "29 E UNION ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "IN",
    "dropphyzpp": 473539998,
    "dropmaladd": "29 E UNION ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "IN",
    "dropmalzpp": 473539998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654585733,
    "dropfax": 7654587691
  },
  {
    "dcode": "D",
    "dropkey": "PX12760",
    "droptype": "D",
    "dropname": "LIBERTY CENTER",
    "dropdeladd": "3010 S MAIN ST",
    "dropdelcty": "LIBERTY CENTER",
    "dropdelst": "IN",
    "dropdelzpp": 467669998,
    "dropphyadd": "3010 S MAIN ST",
    "dropphycty": "LIBERTY CENTER",
    "dropphyst": "IN",
    "dropphyzpp": 467669998,
    "dropmaladd": "3010 S MAIN ST",
    "dropmalcty": "LIBERTY CENTER",
    "dropmalst": "IN",
    "dropmalzpp": 467669998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606946500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12762",
    "droptype": "D",
    "dropname": "LIBERTY MILLS",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "LIBERTY MILLS",
    "dropdelst": "IN",
    "dropdelzpp": 469469998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "LIBERTY MILLS",
    "dropphyst": "IN",
    "dropphyzpp": 469469998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "LIBERTY MILLS",
    "dropmalst": "IN",
    "dropmalzpp": 469469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2609827730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12767",
    "droptype": "D",
    "dropname": "LIGONIER",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "LIGONIER",
    "dropdelst": "IN",
    "dropdelzpp": 467679998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "LIGONIER",
    "dropphyst": "IN",
    "dropphyzpp": 467679998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "LIGONIER",
    "dropmalst": "IN",
    "dropmalzpp": 467679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608943021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12773",
    "droptype": "D",
    "dropname": "LINCOLN CITY",
    "dropdeladd": "3029 E SOUTH ST",
    "dropdelcty": "LINCOLN CITY",
    "dropdelst": "IN",
    "dropdelzpp": 475529998,
    "dropphyadd": "3029 E SOUTH ST",
    "dropphycty": "LINCOLN CITY",
    "dropphyst": "IN",
    "dropphyzpp": 475529998,
    "dropmaladd": "3029 E SOUTH ST",
    "dropmalcty": "LINCOLN CITY",
    "dropmalst": "IN",
    "dropmalzpp": 475529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129374116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12776",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "IN",
    "dropdelzpp": 479559998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "IN",
    "dropphyzpp": 479559998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "IN",
    "dropmalzpp": 479559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653397292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12780",
    "droptype": "D",
    "dropname": "LINTON",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "LINTON",
    "dropdelst": "IN",
    "dropdelzpp": 474419998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "LINTON",
    "dropphyst": "IN",
    "dropphyzpp": 474419998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "LINTON",
    "dropmalst": "IN",
    "dropmalzpp": 474419998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128477419,
    "dropfax": 8128479712
  },
  {
    "dcode": "D",
    "dropkey": "PX12789",
    "droptype": "D",
    "dropname": "LIZTON",
    "dropdeladd": "407 N CHURCH ST",
    "dropdelcty": "LIZTON",
    "dropdelst": "IN",
    "dropdelzpp": 461499998,
    "dropphyadd": "407 N CHURCH ST",
    "dropphycty": "LIZTON",
    "dropphyst": "IN",
    "dropphyzpp": 461499998,
    "dropmaladd": "407 N CHURCH ST",
    "dropmalcty": "LIZTON",
    "dropmalst": "IN",
    "dropmalzpp": 461499998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179945900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12795",
    "droptype": "D",
    "dropname": "LOGANSPORT",
    "dropdeladd": "406 9TH ST",
    "dropdelcty": "LOGANSPORT",
    "dropdelst": "IN",
    "dropdelzpp": 469479998,
    "dropphyadd": "406 9TH ST",
    "dropphycty": "LOGANSPORT",
    "dropphyst": "IN",
    "dropphyzpp": 469479998,
    "dropmaladd": "406 9TH ST",
    "dropmalcty": "LOGANSPORT",
    "dropmalst": "IN",
    "dropmalzpp": 469479998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747533535,
    "dropfax": 5747534502
  },
  {
    "dcode": "D",
    "dropkey": "PX12799",
    "droptype": "D",
    "dropname": "LOOGOOTEE",
    "dropdeladd": "203 NW 1ST ST",
    "dropdelcty": "LOOGOOTEE",
    "dropdelst": "IN",
    "dropdelzpp": 475539998,
    "dropphyadd": "203 NW 1ST ST",
    "dropphycty": "LOOGOOTEE",
    "dropphyst": "IN",
    "dropphyzpp": 475539998,
    "dropmaladd": "203 NW 1ST ST",
    "dropmalcty": "LOOGOOTEE",
    "dropmalst": "IN",
    "dropmalzpp": 475539998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122952021,
    "dropfax": 8122953648
  },
  {
    "dcode": "D",
    "dropkey": "PX12802",
    "droptype": "D",
    "dropname": "LOSANTVILLE",
    "dropdeladd": "25 N MAIN ST",
    "dropdelcty": "LOSANTVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473549998,
    "dropphyadd": "25 N MAIN ST",
    "dropphycty": "LOSANTVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473549998,
    "dropmaladd": "25 N MAIN ST",
    "dropmalcty": "LOSANTVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658536056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12807",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "202 WASHINGTON ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "IN",
    "dropdelzpp": 463561719,
    "dropphyadd": "202 WASHINGTON ST",
    "dropphycty": "LOWELL",
    "dropphyst": "IN",
    "dropphyzpp": 463561719,
    "dropmaladd": "202 WASHINGTON ST",
    "dropmalcty": "LOWELL",
    "dropmalst": "IN",
    "dropmalzpp": 463561719,
    "dropsitphn": 2196968594,
    "dropsitlph": 3174646350,
    "dropsitcph": 2196968594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12808",
    "droptype": "D",
    "dropname": "LUCERNE",
    "dropdeladd": "1567 W FRUSHOUR ST",
    "dropdelcty": "LUCERNE",
    "dropdelst": "IN",
    "dropdelzpp": 469509998,
    "dropphyadd": "1567 W FRUSHOUR ST",
    "dropphycty": "LUCERNE",
    "dropphyst": "IN",
    "dropphyzpp": 469509998,
    "dropmaladd": "1567 W FRUSHOUR ST",
    "dropmalcty": "LUCERNE",
    "dropmalst": "IN",
    "dropmalzpp": 469509998,
    "dropsitphn": 5747533535,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748893815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12815",
    "droptype": "D",
    "dropname": "LYNN",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "LYNN",
    "dropdelst": "IN",
    "dropdelzpp": 473559998,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "LYNN",
    "dropphyst": "IN",
    "dropphyzpp": 473559998,
    "dropmaladd": "116 S MAIN ST",
    "dropmalcty": "LYNN",
    "dropmalst": "IN",
    "dropmalzpp": 473559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658742151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12816",
    "droptype": "D",
    "dropname": "LYNNVILLE",
    "dropdeladd": "216 N MAIN ST",
    "dropdelcty": "LYNNVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 476199998,
    "dropphyadd": "216 N MAIN ST",
    "dropphycty": "LYNNVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 476199998,
    "dropmaladd": "216 N MAIN ST",
    "dropmalcty": "LYNNVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 476199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129223249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12820",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "167 W BROAD ST",
    "dropdelcty": "LYONS",
    "dropdelst": "IN",
    "dropdelzpp": 474439998,
    "dropphyadd": "167 W BROAD ST",
    "dropphycty": "LYONS",
    "dropphyst": "IN",
    "dropphyzpp": 474439998,
    "dropmaladd": "167 W BROAD ST",
    "dropmalcty": "LYONS",
    "dropmalst": "IN",
    "dropmalzpp": 474439998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126592363,
    "dropfax": 8126592363
  },
  {
    "dcode": "D",
    "dropkey": "PX12822",
    "droptype": "D",
    "dropname": "MACKEY",
    "dropdeladd": "9500 E MAIN ST",
    "dropdelcty": "MACKEY",
    "dropdelst": "IN",
    "dropdelzpp": 476549998,
    "dropphyadd": "9500 E MAIN ST",
    "dropphycty": "MACKEY",
    "dropphyst": "IN",
    "dropphyzpp": 476549998,
    "dropmaladd": "9500 E MAIN ST",
    "dropmalcty": "MACKEY",
    "dropmalst": "IN",
    "dropmalzpp": 476549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127952785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12823",
    "droptype": "D",
    "dropname": "MACY",
    "dropdeladd": "180 E COMMERCE ST",
    "dropdelcty": "MACY",
    "dropdelst": "IN",
    "dropdelzpp": 469519998,
    "dropphyadd": "180 E COMMERCE ST",
    "dropphycty": "MACY",
    "dropphyst": "IN",
    "dropphyzpp": 469519998,
    "dropmaladd": "180 E COMMERCE ST",
    "dropmalcty": "MACY",
    "dropmalst": "IN",
    "dropmalzpp": 469519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5743823095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12826",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "207 JEFFERSON ST",
    "dropdelcty": "MADISON",
    "dropdelst": "IN",
    "dropdelzpp": 472509998,
    "dropphyadd": "207 JEFFERSON ST",
    "dropphycty": "MADISON",
    "dropphyst": "IN",
    "dropphyzpp": 472509998,
    "dropmaladd": "207 JEFFERSON ST",
    "dropmalcty": "MADISON",
    "dropmalst": "IN",
    "dropmalzpp": 472509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122655425,
    "dropfax": 8122735361
  },
  {
    "dcode": "D",
    "dropkey": "PX12835",
    "droptype": "D",
    "dropname": "MANILLA",
    "dropdeladd": "2971 S CROSS ST",
    "dropdelcty": "MANILLA",
    "dropdelst": "IN",
    "dropdelzpp": 461509998,
    "dropphyadd": "2971 S CROSS ST",
    "dropphycty": "MANILLA",
    "dropphyst": "IN",
    "dropphyzpp": 461509998,
    "dropmaladd": "2971 S CROSS ST",
    "dropmalcty": "MANILLA",
    "dropmalst": "IN",
    "dropmalzpp": 461509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655442525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12845",
    "droptype": "D",
    "dropname": "MARENGO",
    "dropdeladd": "168 E PLEASANT AVE",
    "dropdelcty": "MARENGO",
    "dropdelst": "IN",
    "dropdelzpp": 471409998,
    "dropphyadd": "168 E PLEASANT AVE",
    "dropphycty": "MARENGO",
    "dropphyst": "IN",
    "dropphyzpp": 471409998,
    "dropmaladd": "168 E PLEASANT AVE",
    "dropmalcty": "MARENGO",
    "dropmalst": "IN",
    "dropmalzpp": 471409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123652143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12849",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "202 W 3RD ST",
    "dropdelcty": "MARION",
    "dropdelst": "IN",
    "dropdelzpp": 469524031,
    "dropphyadd": "202 W 3RD ST",
    "dropphycty": "MARION",
    "dropphyst": "IN",
    "dropphyzpp": 469524031,
    "dropmaladd": "202 W 3RD ST",
    "dropmalcty": "MARION",
    "dropmalst": "IN",
    "dropmalzpp": 469524031,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656688191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12855",
    "droptype": "D",
    "dropname": "MARKLE",
    "dropdeladd": "165 N MILLER ST",
    "dropdelcty": "MARKLE",
    "dropdelst": "IN",
    "dropdelzpp": 467709998,
    "dropphyadd": "165 N MILLER ST",
    "dropphycty": "MARKLE",
    "dropphyst": "IN",
    "dropphyzpp": 467709998,
    "dropmaladd": "165 N MILLER ST",
    "dropmalcty": "MARKLE",
    "dropmalst": "IN",
    "dropmalzpp": 467709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607582218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12856",
    "droptype": "D",
    "dropname": "MARKLEVILLE",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "MARKLEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460569998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "MARKLEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460569998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "MARKLEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460569998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655332325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12864",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "61 E GUION ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "IN",
    "dropdelzpp": 478599998,
    "dropphyadd": "61 E GUION ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "IN",
    "dropphyzpp": 478599998,
    "dropmaladd": "61 E GUION ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "IN",
    "dropmalzpp": 478599998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655972643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12868",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "10 S MAIN ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461519998,
    "dropphyadd": "10 S MAIN ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461519998,
    "dropmaladd": "10 S MAIN ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653422245,
    "dropfax": 7653496103
  },
  {
    "dcode": "D",
    "dropkey": "PX12871",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "10110 HIGHWAY 3",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 471419998,
    "dropphyadd": "10110 HIGHWAY 3",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 471419998,
    "dropmaladd": "10110 HIGHWAY 3",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 471419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122933124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12876",
    "droptype": "D",
    "dropname": "MATTHEWS",
    "dropdeladd": "702 MASSACHUSETTS AVE",
    "dropdelcty": "MATTHEWS",
    "dropdelst": "IN",
    "dropdelzpp": 469579998,
    "dropphyadd": "702 MASSACHUSETTS AVE",
    "dropphycty": "MATTHEWS",
    "dropphyst": "IN",
    "dropphyzpp": 469579998,
    "dropmaladd": "702 MASSACHUSETTS AVE",
    "dropmalcty": "MATTHEWS",
    "dropmalst": "IN",
    "dropmalzpp": 469579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659987519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12877",
    "droptype": "D",
    "dropname": "MAUCKPORT",
    "dropdeladd": "12010 MAIN ST SW",
    "dropdelcty": "MAUCKPORT",
    "dropdelst": "IN",
    "dropdelzpp": 471429998,
    "dropphyadd": "12010 MAIN ST SW",
    "dropphycty": "MAUCKPORT",
    "dropphyst": "IN",
    "dropphyzpp": 471429998,
    "dropmaladd": "12010 MAIN ST SW",
    "dropmalcty": "MAUCKPORT",
    "dropmalst": "IN",
    "dropmalzpp": 471429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127324470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12880",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "9 S MAIN ST",
    "dropdelcty": "MAXWELL",
    "dropdelst": "IN",
    "dropdelzpp": 461549998,
    "dropphyadd": "9 S MAIN ST",
    "dropphycty": "MAXWELL",
    "dropphyst": "IN",
    "dropphyzpp": 461549998,
    "dropmaladd": "9 S MAIN ST",
    "dropmalcty": "MAXWELL",
    "dropmalst": "IN",
    "dropmalzpp": 461549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3173263154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12884",
    "droptype": "D",
    "dropname": "MCCORDSVILLE",
    "dropdeladd": "7397 N 600 W STE 1000",
    "dropdelcty": "MCCORDSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460559998,
    "dropphyadd": "7397 N 600 W STE 1000",
    "dropphycty": "MCCORDSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460559998,
    "dropmaladd": "7397 N 600 W STE 1000",
    "dropmalcty": "MCCORDSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3173366446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12899",
    "droptype": "D",
    "dropname": "MEDARYVILLE",
    "dropdeladd": "501 E MAIN ST",
    "dropdelcty": "MEDARYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479579998,
    "dropphyadd": "501 E MAIN ST",
    "dropphycty": "MEDARYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479579998,
    "dropmaladd": "501 E MAIN ST",
    "dropmalcty": "MEDARYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2198432071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12903",
    "droptype": "D",
    "dropname": "MEDORA",
    "dropdeladd": "17 S PERRY ST",
    "dropdelcty": "MEDORA",
    "dropdelst": "IN",
    "dropdelzpp": 472609998,
    "dropphyadd": "17 S PERRY ST",
    "dropphycty": "MEDORA",
    "dropphyst": "IN",
    "dropphyzpp": 472609998,
    "dropmaladd": "17 S PERRY ST",
    "dropmalcty": "MEDORA",
    "dropmalst": "IN",
    "dropmalzpp": 472609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129662239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12904",
    "droptype": "D",
    "dropname": "MELLOTT",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "MELLOTT",
    "dropdelst": "IN",
    "dropdelzpp": 479589998,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "MELLOTT",
    "dropphyst": "IN",
    "dropphyzpp": 479589998,
    "dropmaladd": "106 S MAIN ST",
    "dropmalcty": "MELLOTT",
    "dropmalst": "IN",
    "dropmalzpp": 479589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652952708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12905",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "1016 MILL LN",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "IN",
    "dropdelzpp": 471439998,
    "dropphyadd": "1016 MILL LN",
    "dropphycty": "MEMPHIS",
    "dropphyst": "IN",
    "dropphyzpp": 471439998,
    "dropmaladd": "1016 MILL LN",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "IN",
    "dropmalzpp": 471439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122941600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12906",
    "droptype": "D",
    "dropname": "MENTONE",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "MENTONE",
    "dropdelst": "IN",
    "dropdelzpp": 465399998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "MENTONE",
    "dropphyst": "IN",
    "dropphyzpp": 465399998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "MENTONE",
    "dropmalst": "IN",
    "dropmalzpp": 465399998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5743537333,
    "dropfax": 5743537333
  },
  {
    "dcode": "D",
    "dropkey": "PX12911",
    "droptype": "D",
    "dropname": "MEROM",
    "dropdeladd": "2066 S 3RD ST",
    "dropdelcty": "MEROM",
    "dropdelst": "IN",
    "dropdelzpp": 478619998,
    "dropphyadd": "2066 S 3RD ST",
    "dropphycty": "MEROM",
    "dropphyst": "IN",
    "dropphyzpp": 478619998,
    "dropmaladd": "2066 S 3RD ST",
    "dropmalcty": "MEROM",
    "dropmalst": "IN",
    "dropmalzpp": 478619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123564730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12919",
    "droptype": "D",
    "dropname": "METAMORA",
    "dropdeladd": "19048 S MAIN ST",
    "dropdelcty": "METAMORA",
    "dropdelst": "IN",
    "dropdelzpp": 470309998,
    "dropphyadd": "19048 S MAIN ST",
    "dropphycty": "METAMORA",
    "dropphyst": "IN",
    "dropphyzpp": 470309998,
    "dropmaladd": "19048 S MAIN ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "IN",
    "dropmalzpp": 470309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7656476766,
    "dropsitcph": 7656476766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12925",
    "droptype": "D",
    "dropname": "MEXICO",
    "dropdeladd": "3969 N MEXICO RD",
    "dropdelcty": "MEXICO",
    "dropdelst": "IN",
    "dropdelzpp": 469589998,
    "dropphyadd": "3969 N MEXICO RD",
    "dropphycty": "MEXICO",
    "dropphyst": "IN",
    "dropphyzpp": 469589998,
    "dropmaladd": "3969 N MEXICO RD",
    "dropmalcty": "MEXICO",
    "dropmalst": "IN",
    "dropmalzpp": 469589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659852494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12930",
    "droptype": "D",
    "dropname": "MICHIGAN CITY",
    "dropdeladd": "303 WASHINGTON ST",
    "dropdelcty": "MICHIGAN CITY",
    "dropdelst": "IN",
    "dropdelzpp": 463609998,
    "dropphyadd": "303 WASHINGTON ST",
    "dropphycty": "MICHIGAN CITY",
    "dropphyst": "IN",
    "dropphyzpp": 463609998,
    "dropmaladd": "303 WASHINGTON ST",
    "dropmalcty": "MICHIGAN CITY",
    "dropmalst": "IN",
    "dropmalzpp": 463609998,
    "dropsitphn": 2198729163,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198729163,
    "dropfax": 2198739158
  },
  {
    "dcode": "D",
    "dropkey": "PX12933",
    "droptype": "D",
    "dropname": "MICHIGANTOWN",
    "dropdeladd": "226 MAIN ST",
    "dropdelcty": "MICHIGANTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 460579998,
    "dropphyadd": "226 MAIN ST",
    "dropphycty": "MICHIGANTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 460579998,
    "dropmaladd": "226 MAIN ST",
    "dropmalcty": "MICHIGANTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 460579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652492316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12937",
    "droptype": "D",
    "dropname": "MIDDLEBURY",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "MIDDLEBURY",
    "dropdelst": "IN",
    "dropdelzpp": 465409998,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "MIDDLEBURY",
    "dropphyst": "IN",
    "dropphyzpp": 465409998,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "MIDDLEBURY",
    "dropmalst": "IN",
    "dropmalzpp": 465409998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748252505,
    "dropfax": 5748250012
  },
  {
    "dcode": "D",
    "dropkey": "PX12938",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "816 W MILL ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "IN",
    "dropdelzpp": 473569998,
    "dropphyadd": "816 W MILL ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "IN",
    "dropphyzpp": 473569998,
    "dropmaladd": "816 W MILL ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "IN",
    "dropmalzpp": 473569998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653542220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12940",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "13340 W FIRST ST",
    "dropdelcty": "MIDLAND",
    "dropdelst": "IN",
    "dropdelzpp": 474459998,
    "dropphyadd": "13340 W FIRST ST",
    "dropphycty": "MIDLAND",
    "dropphyst": "IN",
    "dropphyzpp": 474459998,
    "dropmaladd": "13340 W FIRST ST",
    "dropmalcty": "MIDLAND",
    "dropmalst": "IN",
    "dropmalzpp": 474459998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126654280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12944",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "300 W CARR ST",
    "dropdelcty": "MILAN",
    "dropdelst": "IN",
    "dropdelzpp": 470319998,
    "dropphyadd": "300 W CARR ST",
    "dropphycty": "MILAN",
    "dropphyst": "IN",
    "dropphyzpp": 470319998,
    "dropmaladd": "300 W CARR ST",
    "dropmalcty": "MILAN",
    "dropmalst": "IN",
    "dropmalzpp": 470319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126542548,
    "dropsitcph": 8126542548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12947",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "126 S MAIN ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "IN",
    "dropdelzpp": 465429998,
    "dropphyadd": "126 S MAIN ST",
    "dropphycty": "MILFORD",
    "dropphyst": "IN",
    "dropphyzpp": 465429998,
    "dropmaladd": "126 S MAIN ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "IN",
    "dropmalzpp": 465429998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746584887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12948",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "1618 S 875 E",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "IN",
    "dropdelzpp": 463659998,
    "dropphyadd": "1618 S 875 E",
    "dropphycty": "MILL CREEK",
    "dropphyst": "IN",
    "dropphyzpp": 463659998,
    "dropmaladd": "1618 S 875 E",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "IN",
    "dropmalzpp": 463659998,
    "dropsitphn": 2193699000,
    "dropsitlph": 2193699000,
    "dropsitcph": 2193699000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12953",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "214 E MAIN ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 465439998,
    "dropphyadd": "214 E MAIN ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 465439998,
    "dropmaladd": "214 E MAIN ST",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 465439998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746424695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12957",
    "droptype": "D",
    "dropname": "MILLTOWN",
    "dropdeladd": "301 W MAIN ST",
    "dropdelcty": "MILLTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 471459998,
    "dropphyadd": "301 W MAIN ST",
    "dropphycty": "MILLTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 471459998,
    "dropmaladd": "301 W MAIN ST",
    "dropmalcty": "MILLTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 471459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8126337701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12959",
    "droptype": "D",
    "dropname": "MILROY",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "MILROY",
    "dropdelst": "IN",
    "dropdelzpp": 461569998,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "MILROY",
    "dropphyst": "IN",
    "dropphyzpp": 461569998,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "MILROY",
    "dropmalst": "IN",
    "dropmalzpp": 461569998,
    "dropsitphn": 7659323139,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656292384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12961",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "307 S CENTRAL AVE",
    "dropdelcty": "MILTON",
    "dropdelst": "IN",
    "dropdelzpp": 473579998,
    "dropphyadd": "307 S CENTRAL AVE",
    "dropphycty": "MILTON",
    "dropphyst": "IN",
    "dropphyzpp": 473579998,
    "dropmaladd": "307 S CENTRAL AVE",
    "dropmalcty": "MILTON",
    "dropmalst": "IN",
    "dropmalzpp": 473579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654783777,
    "dropfax": 3174783777
  },
  {
    "dcode": "D",
    "dropkey": "PX12963",
    "droptype": "D",
    "dropname": "MISHAWAKA",
    "dropdeladd": "111 E 3RD ST",
    "dropdelcty": "MISHAWAKA",
    "dropdelst": "IN",
    "dropdelzpp": 465449998,
    "dropphyadd": "111 E 3RD ST",
    "dropphycty": "MISHAWAKA",
    "dropphyst": "IN",
    "dropphyzpp": 465449998,
    "dropmaladd": "111 E 3RD ST",
    "dropmalcty": "MISHAWAKA",
    "dropmalst": "IN",
    "dropmalzpp": 465449998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742559691,
    "dropfax": 5742591370
  },
  {
    "dcode": "D",
    "dropkey": "PX12964",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "118 N 7TH ST",
    "dropdelcty": "MITCHELL",
    "dropdelst": "IN",
    "dropdelzpp": 474469998,
    "dropphyadd": "118 N 7TH ST",
    "dropphycty": "MITCHELL",
    "dropphyst": "IN",
    "dropphyzpp": 474469998,
    "dropmaladd": "118 N 7TH ST",
    "dropmalcty": "MITCHELL",
    "dropmalst": "IN",
    "dropmalzpp": 474469998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128494337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12967",
    "droptype": "D",
    "dropname": "MODOC",
    "dropdeladd": "107 E CONLEY ST",
    "dropdelcty": "MODOC",
    "dropdelst": "IN",
    "dropdelzpp": 473589998,
    "dropphyadd": "107 E CONLEY ST",
    "dropphycty": "MODOC",
    "dropphyst": "IN",
    "dropphyzpp": 473589998,
    "dropmaladd": "107 E CONLEY ST",
    "dropmalcty": "MODOC",
    "dropmalst": "IN",
    "dropmalzpp": 473589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658535144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12968",
    "droptype": "D",
    "dropname": "MONGO",
    "dropdeladd": "3030 N STATE ROAD 3",
    "dropdelcty": "MONGO",
    "dropdelst": "IN",
    "dropdelzpp": 467719998,
    "dropphyadd": "3030 N STATE ROAD 3",
    "dropphycty": "MONGO",
    "dropphyst": "IN",
    "dropphyzpp": 467719998,
    "dropmaladd": "3030 N STATE ROAD 3",
    "dropmalcty": "MONGO",
    "dropmalst": "IN",
    "dropmalzpp": 467719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603672211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12969",
    "droptype": "D",
    "dropname": "MONON",
    "dropdeladd": "415 N MARKET ST",
    "dropdelcty": "MONON",
    "dropdelst": "IN",
    "dropdelzpp": 479599998,
    "dropphyadd": "415 N MARKET ST",
    "dropphycty": "MONON",
    "dropphyst": "IN",
    "dropphyzpp": 479599998,
    "dropmaladd": "415 N MARKET ST",
    "dropmalcty": "MONON",
    "dropmalst": "IN",
    "dropmalzpp": 479599998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2192536479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12970",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "113 E WASHINGTON ST",
    "dropdelcty": "MONROE",
    "dropdelst": "IN",
    "dropdelzpp": 467729998,
    "dropphyadd": "113 E WASHINGTON ST",
    "dropphycty": "MONROE",
    "dropphyst": "IN",
    "dropphyzpp": 467729998,
    "dropmaladd": "113 E WASHINGTON ST",
    "dropmalcty": "MONROE",
    "dropmalst": "IN",
    "dropmalzpp": 467729998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606926361,
    "dropfax": 2606926688
  },
  {
    "dcode": "D",
    "dropkey": "PX12972",
    "droptype": "D",
    "dropname": "MONROE CITY",
    "dropdeladd": "102 W 9TH ST",
    "dropdelcty": "MONROE CITY",
    "dropdelst": "IN",
    "dropdelzpp": 475579998,
    "dropphyadd": "102 W 9TH ST",
    "dropphycty": "MONROE CITY",
    "dropphyst": "IN",
    "dropphyzpp": 475579998,
    "dropmaladd": "102 W 9TH ST",
    "dropmalcty": "MONROE CITY",
    "dropmalst": "IN",
    "dropmalzpp": 475579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127435157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12975",
    "droptype": "D",
    "dropname": "MONROEVILLE",
    "dropdeladd": "103 ALLEN ST",
    "dropdelcty": "MONROEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467739998,
    "dropphyadd": "103 ALLEN ST",
    "dropphycty": "MONROEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467739998,
    "dropmaladd": "103 ALLEN ST",
    "dropmalcty": "MONROEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467739998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606236212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12978",
    "droptype": "D",
    "dropname": "MONROVIA",
    "dropdeladd": "55 W WASHINGTON ST",
    "dropdelcty": "MONROVIA",
    "dropdelst": "IN",
    "dropdelzpp": 461579998,
    "dropphyadd": "55 W WASHINGTON ST",
    "dropphycty": "MONROVIA",
    "dropphyst": "IN",
    "dropphyzpp": 461579998,
    "dropmaladd": "55 W WASHINGTON ST",
    "dropmalcty": "MONROVIA",
    "dropmalst": "IN",
    "dropmalzpp": 461579998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179962244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12979",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "6194 E MAIN ST STE B",
    "dropdelcty": "MONTEREY",
    "dropdelst": "IN",
    "dropdelzpp": 469609998,
    "dropphyadd": "6194 E MAIN ST STE B",
    "dropphycty": "MONTEREY",
    "dropphyst": "IN",
    "dropphyzpp": 469609998,
    "dropmaladd": "6194 E MAIN ST STE B",
    "dropmalcty": "MONTEREY",
    "dropmalst": "IN",
    "dropmalzpp": 469609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745424912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12980",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "982 N WASHINGTON ST",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "IN",
    "dropdelzpp": 478629998,
    "dropphyadd": "982 N WASHINGTON ST",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "IN",
    "dropphyzpp": 478629998,
    "dropmaladd": "982 N WASHINGTON ST",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "IN",
    "dropmalzpp": 478629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652452170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12982",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "496 N MAIN ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "IN",
    "dropdelzpp": 475589998,
    "dropphyadd": "496 N MAIN ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "IN",
    "dropphyzpp": 475589998,
    "dropmaladd": "496 N MAIN ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "IN",
    "dropmalzpp": 475589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124863230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12984",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "125 W BROADWAY ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "IN",
    "dropdelzpp": 479609998,
    "dropphyadd": "125 W BROADWAY ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "IN",
    "dropphyzpp": 479609998,
    "dropmaladd": "125 W BROADWAY ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "IN",
    "dropmalzpp": 479609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745835933,
    "dropfax": 5745832953
  },
  {
    "dcode": "D",
    "dropkey": "PX12986",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "215 S JEFFERSON ST",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "IN",
    "dropdelzpp": 473599998,
    "dropphyadd": "215 S JEFFERSON ST",
    "dropphycty": "MONTPELIER",
    "dropphyst": "IN",
    "dropphyzpp": 473599998,
    "dropmaladd": "215 S JEFFERSON ST",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "IN",
    "dropmalzpp": 473599998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657282162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12988",
    "droptype": "D",
    "dropname": "MOORELAND",
    "dropdeladd": "111 N BROAD ST",
    "dropdelcty": "MOORELAND",
    "dropdelst": "IN",
    "dropdelzpp": 473609998,
    "dropphyadd": "111 N BROAD ST",
    "dropphycty": "MOORELAND",
    "dropphyst": "IN",
    "dropphyzpp": 473609998,
    "dropmaladd": "111 N BROAD ST",
    "dropmalcty": "MOORELAND",
    "dropmalst": "IN",
    "dropmalzpp": 473609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657665575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12990",
    "droptype": "D",
    "dropname": "MOORES HILL",
    "dropdeladd": "14549 MAIN ST",
    "dropdelcty": "MOORES HILL",
    "dropdelst": "IN",
    "dropdelzpp": 470329998,
    "dropphyadd": "14549 MAIN ST",
    "dropphycty": "MOORES HILL",
    "dropphyst": "IN",
    "dropphyzpp": 470329998,
    "dropmaladd": "14549 MAIN ST",
    "dropmalcty": "MOORES HILL",
    "dropmalst": "IN",
    "dropmalzpp": 470329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8127443405,
    "dropsitcph": 8127443405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12992",
    "droptype": "D",
    "dropname": "MOORESVILLE",
    "dropdeladd": "345 W CARLISLE ST",
    "dropdelcty": "MOORESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461589998,
    "dropphyadd": "345 W CARLISLE ST",
    "dropphycty": "MOORESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461589998,
    "dropmaladd": "345 W CARLISLE ST",
    "dropmalcty": "MOORESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178311630,
    "dropfax": 3178316420
  },
  {
    "dcode": "D",
    "dropkey": "PX12997",
    "droptype": "D",
    "dropname": "MORGANTOWN",
    "dropdeladd": "300 W WASHINGTON ST",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 461609998,
    "dropphyadd": "300 W WASHINGTON ST",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 461609998,
    "dropmaladd": "300 W WASHINGTON ST",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 461609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125974012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX12999",
    "droptype": "D",
    "dropname": "MOROCCO",
    "dropdeladd": "109 S CLAY ST",
    "dropdelcty": "MOROCCO",
    "dropdelst": "IN",
    "dropdelzpp": 479639998,
    "dropphyadd": "109 S CLAY ST",
    "dropphycty": "MOROCCO",
    "dropphyst": "IN",
    "dropphyzpp": 479639998,
    "dropmaladd": "109 S CLAY ST",
    "dropmalcty": "MOROCCO",
    "dropmalst": "IN",
    "dropmalzpp": 479639998,
    "dropsitphn": 2192758111,
    "dropsitlph": 2192758111,
    "dropsitcph": 2192758188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13000",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "4728 E MORRIS MILL ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "IN",
    "dropdelzpp": 470339998,
    "dropphyadd": "4728 E MORRIS MILL ST",
    "dropphycty": "MORRIS",
    "dropphyst": "IN",
    "dropphyzpp": 470339998,
    "dropmaladd": "4728 E MORRIS MILL ST",
    "dropmalcty": "MORRIS",
    "dropmalst": "IN",
    "dropmalzpp": 470339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8129344924,
    "dropsitcph": 8129344924,
    "dropfax": 8129331176
  },
  {
    "dcode": "D",
    "dropkey": "PX13001",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 461619998,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 461619998,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 461619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657631245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13006",
    "droptype": "D",
    "dropname": "MOUNT AYR",
    "dropdeladd": "101 E RENSSELAER ST",
    "dropdelcty": "MOUNT AYR",
    "dropdelst": "IN",
    "dropdelzpp": 479649998,
    "dropphyadd": "101 E RENSSELAER ST",
    "dropphycty": "MOUNT AYR",
    "dropphyst": "IN",
    "dropphyzpp": 479649998,
    "dropmaladd": "101 E RENSSELAER ST",
    "dropmalcty": "MOUNT AYR",
    "dropmalst": "IN",
    "dropmalzpp": 479649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2193942122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13016",
    "droptype": "D",
    "dropname": "MOUNT SAINT FRANCIS",
    "dropdeladd": "102 SAINT FRANCIS BLVD",
    "dropdelcty": "MOUNT SAINT FRANCIS",
    "dropdelst": "IN",
    "dropdelzpp": 471469998,
    "dropphyadd": "102 SAINT FRANCIS BLVD",
    "dropphycty": "MOUNT SAINT FRANCIS",
    "dropphyst": "IN",
    "dropphyzpp": 471469998,
    "dropmaladd": "102 SAINT FRANCIS BLVD",
    "dropmalcty": "MOUNT SAINT FRANCIS",
    "dropmalst": "IN",
    "dropmalzpp": 471469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129239641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13017",
    "droptype": "D",
    "dropname": "MOUNT SUMMIT",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "MOUNT SUMMIT",
    "dropdelst": "IN",
    "dropdelzpp": 473619998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "MOUNT SUMMIT",
    "dropphyst": "IN",
    "dropphyzpp": 473619998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "MOUNT SUMMIT",
    "dropmalst": "IN",
    "dropmalzpp": 473619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658364285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13018",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "308 WALNUT ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "IN",
    "dropdelzpp": 476209998,
    "dropphyadd": "308 WALNUT ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "IN",
    "dropphyzpp": 476209998,
    "dropmaladd": "308 WALNUT ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "IN",
    "dropmalzpp": 476209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128383141,
    "dropfax": 8128381847
  },
  {
    "dcode": "D",
    "dropkey": "PX13026",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "120 E JACKSON ST",
    "dropdelcty": "MULBERRY",
    "dropdelst": "IN",
    "dropdelzpp": 460589998,
    "dropphyadd": "120 E JACKSON ST",
    "dropphycty": "MULBERRY",
    "dropphyst": "IN",
    "dropphyzpp": 460589998,
    "dropmaladd": "120 E JACKSON ST",
    "dropmalcty": "MULBERRY",
    "dropmalst": "IN",
    "dropmalzpp": 460589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652962727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13028",
    "droptype": "D",
    "dropname": "MUNCIE",
    "dropdeladd": "501 W MEMORIAL DR",
    "dropdelcty": "MUNCIE",
    "dropdelst": "IN",
    "dropdelzpp": 473029998,
    "dropphyadd": "501 W MEMORIAL DR",
    "dropphycty": "MUNCIE",
    "dropphyst": "IN",
    "dropphyzpp": 473029998,
    "dropmaladd": "501 W MEMORIAL DR",
    "dropmalcty": "MUNCIE",
    "dropmalst": "IN",
    "dropmalzpp": 473029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652869600,
    "dropfax": 7652869604
  },
  {
    "dcode": "D",
    "dropkey": "PX13041",
    "droptype": "D",
    "dropname": "NABB",
    "dropdeladd": "146 POSTAL DR",
    "dropdelcty": "NABB",
    "dropdelst": "IN",
    "dropdelzpp": 471479998,
    "dropphyadd": "146 POSTAL DR",
    "dropphycty": "NABB",
    "dropphyst": "IN",
    "dropphyzpp": 471479998,
    "dropmaladd": "146 POSTAL DR",
    "dropmalcty": "NABB",
    "dropmalst": "IN",
    "dropmalzpp": 471479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122933712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13042",
    "droptype": "D",
    "dropname": "NAPOLEON",
    "dropdeladd": "8949 N US HIGHWAY 421",
    "dropdelcty": "NAPOLEON",
    "dropdelst": "IN",
    "dropdelzpp": 470349998,
    "dropphyadd": "8949 N US HIGHWAY 421",
    "dropphycty": "NAPOLEON",
    "dropphyst": "IN",
    "dropphyzpp": 470349998,
    "dropmaladd": "8949 N US HIGHWAY 421",
    "dropmalcty": "NAPOLEON",
    "dropmalst": "IN",
    "dropmalzpp": 470349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8128524900,
    "dropsitcph": 8128524900,
    "dropfax": 8128525040
  },
  {
    "dcode": "D",
    "dropkey": "PX13043",
    "droptype": "D",
    "dropname": "NAPPANEE",
    "dropdeladd": "202 E MARKET ST",
    "dropdelcty": "NAPPANEE",
    "dropdelst": "IN",
    "dropdelzpp": 465509998,
    "dropphyadd": "202 E MARKET ST",
    "dropphycty": "NAPPANEE",
    "dropphyst": "IN",
    "dropphyzpp": 465509998,
    "dropmaladd": "202 E MARKET ST",
    "dropmalcty": "NAPPANEE",
    "dropmalst": "IN",
    "dropmalzpp": 465509998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5747734801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13044",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "200 E GOULD ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474489998,
    "dropphyadd": "200 E GOULD ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474489998,
    "dropmaladd": "200 E GOULD ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474489998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129882262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13055",
    "droptype": "D",
    "dropname": "NEW ALBANY",
    "dropdeladd": "145 E ELM ST",
    "dropdelcty": "NEW ALBANY",
    "dropdelst": "IN",
    "dropdelzpp": 471509998,
    "dropphyadd": "145 E ELM ST",
    "dropphycty": "NEW ALBANY",
    "dropphyst": "IN",
    "dropphyzpp": 471509998,
    "dropmaladd": "145 E ELM ST",
    "dropmalcty": "NEW ALBANY",
    "dropmalst": "IN",
    "dropmalzpp": 471509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129480649,
    "dropfax": 8129444493
  },
  {
    "dcode": "D",
    "dropkey": "PX13062",
    "droptype": "D",
    "dropname": "NEW CARLISLE",
    "dropdeladd": "121 E CHESTNUT ST",
    "dropdelcty": "NEW CARLISLE",
    "dropdelst": "IN",
    "dropdelzpp": 465529998,
    "dropphyadd": "121 E CHESTNUT ST",
    "dropphycty": "NEW CARLISLE",
    "dropphyst": "IN",
    "dropphyzpp": 465529998,
    "dropmaladd": "121 E CHESTNUT ST",
    "dropmalcty": "NEW CARLISLE",
    "dropmalst": "IN",
    "dropmalzpp": 465529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746543621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13063",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "305 S 14TH ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "IN",
    "dropdelzpp": 473629998,
    "dropphyadd": "305 S 14TH ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "IN",
    "dropphyzpp": 473629998,
    "dropmaladd": "305 S 14TH ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "IN",
    "dropmalzpp": 473629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655296270,
    "dropfax": 7655299188
  },
  {
    "dcode": "D",
    "dropkey": "PX13067",
    "droptype": "D",
    "dropname": "NEW GOSHEN",
    "dropdeladd": "2785 DURKEES FERRY RD",
    "dropdelcty": "NEW GOSHEN",
    "dropdelst": "IN",
    "dropdelzpp": 478639998,
    "dropphyadd": "2785 DURKEES FERRY RD",
    "dropphycty": "NEW GOSHEN",
    "dropphyst": "IN",
    "dropphyzpp": 478639998,
    "dropmaladd": "2785 DURKEES FERRY RD",
    "dropmalcty": "NEW GOSHEN",
    "dropmalst": "IN",
    "dropmalzpp": 478639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125353374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13068",
    "droptype": "D",
    "dropname": "NEW HARMONY",
    "dropdeladd": "534 CHURCH ST",
    "dropdelcty": "NEW HARMONY",
    "dropdelst": "IN",
    "dropdelzpp": 476319998,
    "dropphyadd": "534 CHURCH ST",
    "dropphycty": "NEW HARMONY",
    "dropphyst": "IN",
    "dropphyzpp": 476319998,
    "dropmaladd": "534 CHURCH ST",
    "dropmalcty": "NEW HARMONY",
    "dropmalst": "IN",
    "dropmalzpp": 476319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8126823256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13069",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "520 BROADWAY ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "IN",
    "dropdelzpp": 467749998,
    "dropphyadd": "520 BROADWAY ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "IN",
    "dropphyzpp": 467749998,
    "dropmaladd": "520 BROADWAY ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "IN",
    "dropmalzpp": 467749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607491217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13075",
    "droptype": "D",
    "dropname": "NEW LISBON",
    "dropdeladd": "6625 E COUNTY ROAD 500 S",
    "dropdelcty": "NEW LISBON",
    "dropdelst": "IN",
    "dropdelzpp": 473669998,
    "dropphyadd": "6625 E COUNTY ROAD 500 S",
    "dropphycty": "NEW LISBON",
    "dropphyst": "IN",
    "dropphyzpp": 473669998,
    "dropmaladd": "6625 E COUNTY ROAD 500 S",
    "dropmalcty": "NEW LISBON",
    "dropmalst": "IN",
    "dropmalzpp": 473669998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653322153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13078",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "109 W MAIN ST",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "IN",
    "dropdelzpp": 479659998,
    "dropphyadd": "109 W MAIN ST",
    "dropphycty": "NEW MARKET",
    "dropphyst": "IN",
    "dropphyzpp": 479659998,
    "dropmaladd": "109 W MAIN ST",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "IN",
    "dropmalzpp": 479659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658660062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13083",
    "droptype": "D",
    "dropname": "NEW PALESTINE",
    "dropdeladd": "17 S WESTSIDE DR",
    "dropdelcty": "NEW PALESTINE",
    "dropdelst": "IN",
    "dropdelzpp": 461639998,
    "dropphyadd": "17 S WESTSIDE DR",
    "dropphycty": "NEW PALESTINE",
    "dropphyst": "IN",
    "dropphyzpp": 461639998,
    "dropmaladd": "17 S WESTSIDE DR",
    "dropmalcty": "NEW PALESTINE",
    "dropmalst": "IN",
    "dropmalzpp": 461639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178616532,
    "dropfax": 3178610180
  },
  {
    "dcode": "D",
    "dropkey": "PX13084",
    "droptype": "D",
    "dropname": "NEW PARIS",
    "dropdeladd": "68354 MAIN ST",
    "dropdelcty": "NEW PARIS",
    "dropdelst": "IN",
    "dropdelzpp": 465539998,
    "dropphyadd": "68354 MAIN ST",
    "dropphycty": "NEW PARIS",
    "dropphyst": "IN",
    "dropphyzpp": 465539998,
    "dropmaladd": "68354 MAIN ST",
    "dropmalcty": "NEW PARIS",
    "dropmalst": "IN",
    "dropmalzpp": 465539998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748312622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13087",
    "droptype": "D",
    "dropname": "NEW POINT",
    "dropdeladd": "8348 E COUNTY ROAD 200 S",
    "dropdelcty": "NEW POINT",
    "dropdelst": "IN",
    "dropdelzpp": 472639998,
    "dropphyadd": "8348 E COUNTY ROAD 200 S",
    "dropphycty": "NEW POINT",
    "dropphyst": "IN",
    "dropphyzpp": 472639998,
    "dropmaladd": "8348 E COUNTY ROAD 200 S",
    "dropmalcty": "NEW POINT",
    "dropmalst": "IN",
    "dropmalzpp": 472639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126637114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13089",
    "droptype": "D",
    "dropname": "NEW RICHMOND",
    "dropdeladd": "113 E WASHINGTON ST",
    "dropdelcty": "NEW RICHMOND",
    "dropdelst": "IN",
    "dropdelzpp": 479679998,
    "dropphyadd": "113 E WASHINGTON ST",
    "dropphycty": "NEW RICHMOND",
    "dropphyst": "IN",
    "dropphyzpp": 479679998,
    "dropmaladd": "113 E WASHINGTON ST",
    "dropmalcty": "NEW RICHMOND",
    "dropmalst": "IN",
    "dropmalzpp": 479679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653394447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13090",
    "droptype": "D",
    "dropname": "NEW ROSS",
    "dropdeladd": "102 E STATE ST",
    "dropdelcty": "NEW ROSS",
    "dropdelst": "IN",
    "dropdelzpp": 479689998,
    "dropphyadd": "102 E STATE ST",
    "dropphycty": "NEW ROSS",
    "dropphyst": "IN",
    "dropphyzpp": 479689998,
    "dropmaladd": "102 E STATE ST",
    "dropmalcty": "NEW ROSS",
    "dropmalst": "IN",
    "dropmalzpp": 479689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657231132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13092",
    "droptype": "D",
    "dropname": "NEW SALISBURY",
    "dropdeladd": "7735 HIGHWAY 135 NE",
    "dropdelcty": "NEW SALISBURY",
    "dropdelst": "IN",
    "dropdelzpp": 471619998,
    "dropphyadd": "7735 HIGHWAY 135 NE",
    "dropphycty": "NEW SALISBURY",
    "dropphyst": "IN",
    "dropphyzpp": 471619998,
    "dropmaladd": "7735 HIGHWAY 135 NE",
    "dropmalcty": "NEW SALISBURY",
    "dropmalst": "IN",
    "dropmalzpp": 471619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123472616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13094",
    "droptype": "D",
    "dropname": "NEW WASHINGTON",
    "dropdeladd": "310 E MAIN ST",
    "dropdelcty": "NEW WASHINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 471629998,
    "dropphyadd": "310 E MAIN ST",
    "dropphycty": "NEW WASHINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 471629998,
    "dropmaladd": "310 E MAIN ST",
    "dropmalcty": "NEW WASHINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 471629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122934504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13100",
    "droptype": "D",
    "dropname": "NEWBERRY",
    "dropdeladd": "414 BROAD ST",
    "dropdelcty": "NEWBERRY",
    "dropdelst": "IN",
    "dropdelzpp": 474499997,
    "dropphyadd": "414 BROAD ST",
    "dropphycty": "NEWBERRY",
    "dropphyst": "IN",
    "dropphyzpp": 474499997,
    "dropmaladd": "414 BROAD ST",
    "dropmalcty": "NEWBERRY",
    "dropmalst": "IN",
    "dropmalzpp": 474499997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126592812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13101",
    "droptype": "D",
    "dropname": "NEWBURGH",
    "dropdeladd": "5411 STATE ROUTE 261",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "IN",
    "dropdelzpp": 476309998,
    "dropphyadd": "5411 STATE ROUTE 261",
    "dropphycty": "NEWBURGH",
    "dropphyst": "IN",
    "dropphyzpp": 476309998,
    "dropmaladd": "5411 STATE ROUTE 261",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "IN",
    "dropmalzpp": 476309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128533707,
    "dropfax": 8128580173
  },
  {
    "dcode": "D",
    "dropkey": "PX13102",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "205 W EXTENSION ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "IN",
    "dropdelzpp": 479669998,
    "dropphyadd": "205 W EXTENSION ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "IN",
    "dropphyzpp": 479669998,
    "dropmaladd": "205 W EXTENSION ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "IN",
    "dropmalzpp": 479669998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654923593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13105",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "115 W WASHINGTON ST",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 479699998,
    "dropphyadd": "115 W WASHINGTON ST",
    "dropphycty": "NEWTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 479699998,
    "dropmaladd": "115 W WASHINGTON ST",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 479699998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652952066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13111",
    "droptype": "D",
    "dropname": "NINEVEH",
    "dropdeladd": "7544 S NINEVEH RD",
    "dropdelcty": "NINEVEH",
    "dropdelst": "IN",
    "dropdelzpp": 461649998,
    "dropphyadd": "7544 S NINEVEH RD",
    "dropphycty": "NINEVEH",
    "dropphyst": "IN",
    "dropphyzpp": 461649998,
    "dropmaladd": "7544 S NINEVEH RD",
    "dropmalcty": "NINEVEH",
    "dropmalst": "IN",
    "dropmalzpp": 461649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3179307355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13121",
    "droptype": "D",
    "dropname": "NOBLESVILLE",
    "dropdeladd": "1900 PLEASANT ST",
    "dropdelcty": "NOBLESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460609998,
    "dropphyadd": "1900 PLEASANT ST",
    "dropphycty": "NOBLESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460609998,
    "dropmaladd": "1900 PLEASANT ST",
    "dropmalcty": "NOBLESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3177739775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13126",
    "droptype": "D",
    "dropname": "NORMAN",
    "dropdeladd": "12718 W STATE ROAD 58",
    "dropdelcty": "NORMAN",
    "dropdelst": "IN",
    "dropdelzpp": 472649998,
    "dropphyadd": "12718 W STATE ROAD 58",
    "dropphycty": "NORMAN",
    "dropphyst": "IN",
    "dropphyzpp": 472649998,
    "dropmaladd": "12718 W STATE ROAD 58",
    "dropmalcty": "NORMAN",
    "dropmalst": "IN",
    "dropmalzpp": 472649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129958692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13128",
    "droptype": "D",
    "dropname": "NORTH JUDSON",
    "dropdeladd": "305 KELLER AVE",
    "dropdelcty": "NORTH JUDSON",
    "dropdelst": "IN",
    "dropdelzpp": 463669998,
    "dropphyadd": "305 KELLER AVE",
    "dropphycty": "NORTH JUDSON",
    "dropphyst": "IN",
    "dropphyzpp": 463669998,
    "dropmaladd": "305 KELLER AVE",
    "dropmalcty": "NORTH JUDSON",
    "dropmalst": "IN",
    "dropmalzpp": 463669998,
    "dropsitphn": 5748962931,
    "dropsitlph": 3174646350,
    "dropsitcph": 5748962931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13129",
    "droptype": "D",
    "dropname": "NORTH LIBERTY",
    "dropdeladd": "209 W CENTER ST",
    "dropdelcty": "NORTH LIBERTY",
    "dropdelst": "IN",
    "dropdelzpp": 465549998,
    "dropphyadd": "209 W CENTER ST",
    "dropphycty": "NORTH LIBERTY",
    "dropphyst": "IN",
    "dropphyzpp": 465549998,
    "dropmaladd": "209 W CENTER ST",
    "dropmalcty": "NORTH LIBERTY",
    "dropmalst": "IN",
    "dropmalzpp": 465549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746568031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13132",
    "droptype": "D",
    "dropname": "NORTH MANCHESTER",
    "dropdeladd": "202 E 2ND ST",
    "dropdelcty": "NORTH MANCHESTER",
    "dropdelst": "IN",
    "dropdelzpp": 469629998,
    "dropphyadd": "202 E 2ND ST",
    "dropphycty": "NORTH MANCHESTER",
    "dropphyst": "IN",
    "dropphyzpp": 469629998,
    "dropmaladd": "202 E 2ND ST",
    "dropmalcty": "NORTH MANCHESTER",
    "dropmalst": "IN",
    "dropmalzpp": 469629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2609822313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13135",
    "droptype": "D",
    "dropname": "NORTH SALEM",
    "dropdeladd": "14 W PEARL ST",
    "dropdelcty": "NORTH SALEM",
    "dropdelst": "IN",
    "dropdelzpp": 461659998,
    "dropphyadd": "14 W PEARL ST",
    "dropphycty": "NORTH SALEM",
    "dropphyst": "IN",
    "dropphyzpp": 461659998,
    "dropmaladd": "14 W PEARL ST",
    "dropmalcty": "NORTH SALEM",
    "dropmalst": "IN",
    "dropmalzpp": 461659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656766749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13137",
    "droptype": "D",
    "dropname": "NORTH VERNON",
    "dropdeladd": "330 E O AND M AVE",
    "dropdelcty": "NORTH VERNON",
    "dropdelst": "IN",
    "dropdelzpp": 472659998,
    "dropphyadd": "330 E O AND M AVE",
    "dropphycty": "NORTH VERNON",
    "dropphyst": "IN",
    "dropphyzpp": 472659998,
    "dropmaladd": "330 E O AND M AVE",
    "dropmalcty": "NORTH VERNON",
    "dropmalst": "IN",
    "dropmalzpp": 472659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646350,
    "dropsitcph": 8123465148,
    "dropfax": 8123468208
  },
  {
    "dcode": "D",
    "dropkey": "PX13138",
    "droptype": "D",
    "dropname": "NORTH WEBSTER",
    "dropdeladd": "623 N MAIN ST",
    "dropdelcty": "NORTH WEBSTER",
    "dropdelst": "IN",
    "dropdelzpp": 465559116,
    "dropphyadd": "623 N MAIN ST",
    "dropphycty": "NORTH WEBSTER",
    "dropphyst": "IN",
    "dropphyzpp": 465559116,
    "dropmaladd": "623 N MAIN ST",
    "dropmalcty": "NORTH WEBSTER",
    "dropmalst": "IN",
    "dropmalzpp": 465559116,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748342707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13149",
    "droptype": "D",
    "dropname": "NOTRE DAME",
    "dropdeladd": "1 PO SECURITY BUILDING",
    "dropdelcty": "NOTRE DAME",
    "dropdelst": "IN",
    "dropdelzpp": 465569998,
    "dropphyadd": "1 PO SECURITY BUILDING",
    "dropphycty": "NOTRE DAME",
    "dropphyst": "IN",
    "dropphyzpp": 465564623,
    "dropmaladd": "1 PO SECURITY BUILDING",
    "dropmalcty": "NOTRE DAME",
    "dropmalst": "IN",
    "dropmalzpp": 465569998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746317304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13176",
    "droptype": "D",
    "dropname": "OAKFORD",
    "dropdeladd": "1184 E 400 S",
    "dropdelcty": "OAKFORD",
    "dropdelst": "IN",
    "dropdelzpp": 469659998,
    "dropphyadd": "1184 E 400 S",
    "dropphycty": "OAKFORD",
    "dropphyst": "IN",
    "dropphyzpp": 469659998,
    "dropmaladd": "1184 E 400 S",
    "dropmalcty": "OAKFORD",
    "dropmalst": "IN",
    "dropmalzpp": 469659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654538867,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13177",
    "droptype": "D",
    "dropname": "OAKLAND CITY",
    "dropdeladd": "130 W HARRISON ST",
    "dropdelcty": "OAKLAND CITY",
    "dropdelst": "IN",
    "dropdelzpp": 476609998,
    "dropphyadd": "130 W HARRISON ST",
    "dropphycty": "OAKLAND CITY",
    "dropphyst": "IN",
    "dropphyzpp": 476609998,
    "dropmaladd": "130 W HARRISON ST",
    "dropmalcty": "OAKLAND CITY",
    "dropmalst": "IN",
    "dropmalzpp": 476609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127493812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13181",
    "droptype": "D",
    "dropname": "OAKTOWN",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "OAKTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 475619998,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "OAKTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 475619998,
    "dropmaladd": "106 E MAIN ST",
    "dropmalcty": "OAKTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 475619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127455502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13182",
    "droptype": "D",
    "dropname": "OAKVILLE",
    "dropdeladd": "551 W OAKVILLE RD",
    "dropdelcty": "OAKVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473679998,
    "dropphyadd": "551 W OAKVILLE RD",
    "dropphycty": "OAKVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473679998,
    "dropmaladd": "551 W OAKVILLE RD",
    "dropmalcty": "OAKVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652880417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13189",
    "droptype": "D",
    "dropname": "ODON",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "ODON",
    "dropdelst": "IN",
    "dropdelzpp": 475629998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "ODON",
    "dropphyst": "IN",
    "dropphyzpp": 475629998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "ODON",
    "dropmalst": "IN",
    "dropmalzpp": 475629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126364447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13196",
    "droptype": "D",
    "dropname": "OLDENBURG",
    "dropdeladd": "22133 MAIN ST",
    "dropdelcty": "OLDENBURG",
    "dropdelst": "IN",
    "dropdelzpp": 470369998,
    "dropphyadd": "22133 MAIN ST",
    "dropphycty": "OLDENBURG",
    "dropphyst": "IN",
    "dropphyzpp": 470369998,
    "dropmaladd": "22133 MAIN ST",
    "dropmalcty": "OLDENBURG",
    "dropmalst": "IN",
    "dropmalzpp": 470369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8129344819,
    "dropsitcph": 8129344819,
    "dropfax": 8129331512
  },
  {
    "dcode": "D",
    "dropkey": "PX13200",
    "droptype": "D",
    "dropname": "OOLITIC",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "OOLITIC",
    "dropdelst": "IN",
    "dropdelzpp": 474519998,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "OOLITIC",
    "dropphyst": "IN",
    "dropphyzpp": 474519998,
    "dropmaladd": "113 MAIN ST",
    "dropmalcty": "OOLITIC",
    "dropmalst": "IN",
    "dropmalzpp": 474519998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122754002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13205",
    "droptype": "D",
    "dropname": "ORESTES",
    "dropdeladd": "15 S SUPERIOR ST",
    "dropdelcty": "ORESTES",
    "dropdelst": "IN",
    "dropdelzpp": 460639998,
    "dropphyadd": "15 S SUPERIOR ST",
    "dropphycty": "ORESTES",
    "dropphyst": "IN",
    "dropphyzpp": 460639998,
    "dropmaladd": "15 S SUPERIOR ST",
    "dropmalcty": "ORESTES",
    "dropmalst": "IN",
    "dropmalzpp": 460639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657548755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13207",
    "droptype": "D",
    "dropname": "ORLAND",
    "dropdeladd": "9462 W STATE ROAD 120",
    "dropdelcty": "ORLAND",
    "dropdelst": "IN",
    "dropdelzpp": 467769998,
    "dropphyadd": "9462 W STATE ROAD 120",
    "dropphycty": "ORLAND",
    "dropphyst": "IN",
    "dropphyzpp": 467769998,
    "dropmaladd": "9462 W STATE ROAD 120",
    "dropmalcty": "ORLAND",
    "dropmalst": "IN",
    "dropmalzpp": 467769998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608296435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13208",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "201 W WASHINGTON ST",
    "dropdelcty": "ORLEANS",
    "dropdelst": "IN",
    "dropdelzpp": 474529998,
    "dropphyadd": "201 W WASHINGTON ST",
    "dropphycty": "ORLEANS",
    "dropphyst": "IN",
    "dropphyzpp": 474529998,
    "dropmaladd": "201 W WASHINGTON ST",
    "dropmalcty": "ORLEANS",
    "dropmalst": "IN",
    "dropmalzpp": 474529998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128652488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13210",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "1712 LINCOLNWAY W STE X",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "IN",
    "dropdelzpp": 465619998,
    "dropphyadd": "1712 LINCOLNWAY W STE X",
    "dropphycty": "OSCEOLA",
    "dropphyst": "IN",
    "dropphyzpp": 465619998,
    "dropmaladd": "1712 LINCOLNWAY W STE X",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "IN",
    "dropmalzpp": 465619998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746794528,
    "dropfax": 5746750247
  },
  {
    "dcode": "D",
    "dropkey": "PX13211",
    "droptype": "D",
    "dropname": "OSGOOD",
    "dropdeladd": "201 N WALNUT ST",
    "dropdelcty": "OSGOOD",
    "dropdelst": "IN",
    "dropdelzpp": 470379998,
    "dropphyadd": "201 N WALNUT ST",
    "dropphycty": "OSGOOD",
    "dropphyst": "IN",
    "dropphyzpp": 470379998,
    "dropmaladd": "201 N WALNUT ST",
    "dropmalcty": "OSGOOD",
    "dropmalst": "IN",
    "dropmalzpp": 470379998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126895301,
    "dropsitcph": 8126895301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13212",
    "droptype": "D",
    "dropname": "OSSIAN",
    "dropdeladd": "106 S OGDEN ST",
    "dropdelcty": "OSSIAN",
    "dropdelst": "IN",
    "dropdelzpp": 467779998,
    "dropphyadd": "106 S OGDEN ST",
    "dropphycty": "OSSIAN",
    "dropphyst": "IN",
    "dropphyzpp": 467779998,
    "dropmaladd": "106 S OGDEN ST",
    "dropmalcty": "OSSIAN",
    "dropmalst": "IN",
    "dropmalzpp": 467779998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606224101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13215",
    "droptype": "D",
    "dropname": "OTISCO",
    "dropdeladd": "701 W RAILROAD ST",
    "dropdelcty": "OTISCO",
    "dropdelst": "IN",
    "dropdelzpp": 471639998,
    "dropphyadd": "701 W RAILROAD ST",
    "dropphycty": "OTISCO",
    "dropphyst": "IN",
    "dropphyzpp": 471639998,
    "dropmaladd": "701 W RAILROAD ST",
    "dropmalcty": "OTISCO",
    "dropmalst": "IN",
    "dropmalzpp": 471639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122565051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13221",
    "droptype": "D",
    "dropname": "OTTERBEIN",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "OTTERBEIN",
    "dropdelst": "IN",
    "dropdelzpp": 479709998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "OTTERBEIN",
    "dropphyst": "IN",
    "dropphyzpp": 479709998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "OTTERBEIN",
    "dropmalst": "IN",
    "dropmalzpp": 479709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655832220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13223",
    "droptype": "D",
    "dropname": "OTWELL",
    "dropdeladd": "2171 N STATE ROAD 257",
    "dropdelcty": "OTWELL",
    "dropdelst": "IN",
    "dropdelzpp": 475649998,
    "dropphyadd": "2171 N STATE ROAD 257",
    "dropphycty": "OTWELL",
    "dropphyst": "IN",
    "dropphyzpp": 475649998,
    "dropmaladd": "2171 N STATE ROAD 257",
    "dropmalcty": "OTWELL",
    "dropmalst": "IN",
    "dropmalzpp": 475649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123542700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13225",
    "droptype": "D",
    "dropname": "OWENSVILLE",
    "dropdeladd": "100 S MILL ST",
    "dropdelcty": "OWENSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 476659998,
    "dropphyadd": "100 S MILL ST",
    "dropphycty": "OWENSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 476659998,
    "dropmaladd": "100 S MILL ST",
    "dropmalcty": "OWENSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 476659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127243875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13228",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "209 S HOWARD ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "IN",
    "dropdelzpp": 479719998,
    "dropphyadd": "209 S HOWARD ST",
    "dropphycty": "OXFORD",
    "dropphyst": "IN",
    "dropphyzpp": 479719998,
    "dropmaladd": "209 S HOWARD ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "IN",
    "dropmalzpp": 479719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653852159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13233",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "805 MAIN ST NE",
    "dropdelcty": "PALMYRA",
    "dropdelst": "IN",
    "dropdelzpp": 471649998,
    "dropphyadd": "805 MAIN ST NE",
    "dropphycty": "PALMYRA",
    "dropphyst": "IN",
    "dropphyzpp": 471649998,
    "dropmaladd": "805 MAIN ST NE",
    "dropmalcty": "PALMYRA",
    "dropmalst": "IN",
    "dropmalzpp": 471649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123646455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13234",
    "droptype": "D",
    "dropname": "PAOLI",
    "dropdeladd": "202 N GOSPEL ST",
    "dropdelcty": "PAOLI",
    "dropdelst": "IN",
    "dropdelzpp": 474549998,
    "dropphyadd": "202 N GOSPEL ST",
    "dropphycty": "PAOLI",
    "dropphyst": "IN",
    "dropphyzpp": 474549998,
    "dropmaladd": "202 N GOSPEL ST",
    "dropmalcty": "PAOLI",
    "dropmalst": "IN",
    "dropmalzpp": 474549998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127233312,
    "dropfax": 8127235912
  },
  {
    "dcode": "D",
    "dropkey": "PX13237",
    "droptype": "D",
    "dropname": "PARAGON",
    "dropdeladd": "151 W UNION ST",
    "dropdelcty": "PARAGON",
    "dropdelst": "IN",
    "dropdelzpp": 461669998,
    "dropphyadd": "151 W UNION ST",
    "dropphycty": "PARAGON",
    "dropphyst": "IN",
    "dropphyzpp": 461669998,
    "dropmaladd": "151 W UNION ST",
    "dropmalcty": "PARAGON",
    "dropmalst": "IN",
    "dropmalzpp": 461669998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655372641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13238",
    "droptype": "D",
    "dropname": "PARIS CROSSING",
    "dropdeladd": "1975 W STATE HIGHWAY 250",
    "dropdelcty": "PARIS CROSSING",
    "dropdelst": "IN",
    "dropdelzpp": 472709998,
    "dropphyadd": "1975 W STATE HIGHWAY 250",
    "dropphycty": "PARIS CROSSING",
    "dropphyst": "IN",
    "dropphyzpp": 472709998,
    "dropmaladd": "1975 W STATE HIGHWAY 250",
    "dropmalcty": "PARIS CROSSING",
    "dropmalst": "IN",
    "dropmalzpp": 472709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123462516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13243",
    "droptype": "D",
    "dropname": "PARKER CITY",
    "dropdeladd": "220 S MAIN ST",
    "dropdelcty": "PARKER CITY",
    "dropdelst": "IN",
    "dropdelzpp": 473689998,
    "dropphyadd": "220 S MAIN ST",
    "dropphycty": "PARKER CITY",
    "dropphyst": "IN",
    "dropphyzpp": 473689998,
    "dropmaladd": "220 S MAIN ST",
    "dropmalcty": "PARKER CITY",
    "dropmalst": "IN",
    "dropmalzpp": 473689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654687755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13250",
    "droptype": "D",
    "dropname": "PATOKA",
    "dropdeladd": "110 S MAIN ST",
    "dropdelcty": "PATOKA",
    "dropdelst": "IN",
    "dropdelzpp": 476669998,
    "dropphyadd": "110 S MAIN ST",
    "dropphycty": "PATOKA",
    "dropphyst": "IN",
    "dropphyzpp": 476669998,
    "dropmaladd": "110 S MAIN ST",
    "dropmalcty": "PATOKA",
    "dropmalst": "IN",
    "dropmalzpp": 476669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127792571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13253",
    "droptype": "D",
    "dropname": "PATRICKSBURG",
    "dropdeladd": "10097 STATE HIGHWAY 246",
    "dropdelcty": "PATRICKSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 474559998,
    "dropphyadd": "10097 STATE HIGHWAY 246",
    "dropphycty": "PATRICKSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 474559998,
    "dropmaladd": "10097 STATE HIGHWAY 246",
    "dropmalcty": "PATRICKSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 474559998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128594200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13254",
    "droptype": "D",
    "dropname": "PATRIOT",
    "dropdeladd": "2797 MAIN ST",
    "dropdelcty": "PATRIOT",
    "dropdelst": "IN",
    "dropdelzpp": 470389998,
    "dropphyadd": "2797 MAIN ST",
    "dropphycty": "PATRIOT",
    "dropphyst": "IN",
    "dropphyzpp": 470389998,
    "dropmaladd": "2797 MAIN ST",
    "dropmalcty": "PATRIOT",
    "dropmalst": "IN",
    "dropmalzpp": 470389998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8125942607,
    "dropsitcph": 8125942607,
    "dropfax": 8125949877
  },
  {
    "dcode": "D",
    "dropkey": "PX13257",
    "droptype": "D",
    "dropname": "PAXTON",
    "dropdeladd": "4371 S COUNTY ROAD 100 E",
    "dropdelcty": "CARLISLE",
    "dropdelst": "IN",
    "dropdelzpp": 478388419,
    "dropphyadd": "4371 S COUNTY ROAD 100 E",
    "dropphycty": "CARLISLE",
    "dropphyst": "IN",
    "dropphyzpp": 478388419,
    "dropmaladd": "4371 S COUNTY ROAD 100 E",
    "dropmalcty": "CARLISLE",
    "dropmalst": "IN",
    "dropmalzpp": 478388419,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122686996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13262",
    "droptype": "D",
    "dropname": "PEKIN",
    "dropdeladd": "31 E MAIN ST",
    "dropdelcty": "PEKIN",
    "dropdelst": "IN",
    "dropdelzpp": 471659998,
    "dropphyadd": "31 E MAIN ST",
    "dropphycty": "PEKIN",
    "dropphyst": "IN",
    "dropphyzpp": 471659998,
    "dropmaladd": "31 E MAIN ST",
    "dropmalcty": "PEKIN",
    "dropmalst": "IN",
    "dropmalzpp": 471659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8129673224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13266",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "137 W STATE ST",
    "dropdelcty": "PENDLETON",
    "dropdelst": "IN",
    "dropdelzpp": 460649998,
    "dropphyadd": "137 W STATE ST",
    "dropphycty": "PENDLETON",
    "dropphyst": "IN",
    "dropphyzpp": 460649998,
    "dropmaladd": "137 W STATE ST",
    "dropmalcty": "PENDLETON",
    "dropmalst": "IN",
    "dropmalzpp": 460649998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657783565,
    "dropfax": 7657784147
  },
  {
    "dcode": "D",
    "dropkey": "PX13272",
    "droptype": "D",
    "dropname": "PENNVILLE",
    "dropdeladd": "125 S UNION ST",
    "dropdelcty": "PENNVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473699998,
    "dropphyadd": "125 S UNION ST",
    "dropphycty": "PENNVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473699998,
    "dropmaladd": "125 S UNION ST",
    "dropmalcty": "PENNVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473699998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607317771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13282",
    "droptype": "D",
    "dropname": "PERRYSVILLE",
    "dropdeladd": "159 E GREEN ST",
    "dropdelcty": "PERRYSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 479749998,
    "dropphyadd": "159 E GREEN ST",
    "dropphycty": "PERRYSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 479749998,
    "dropmaladd": "159 E GREEN ST",
    "dropmalcty": "PERRYSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 479749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657933996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13285",
    "droptype": "D",
    "dropname": "PERSHING",
    "dropdeladd": "401 E MAIN ST",
    "dropdelcty": "PERSHING",
    "dropdelst": "IN",
    "dropdelzpp": 473709998,
    "dropphyadd": "401 E MAIN ST",
    "dropphycty": "PERSHING",
    "dropphyst": "IN",
    "dropphyzpp": 473709998,
    "dropmaladd": "401 E MAIN ST",
    "dropmalcty": "PERSHING",
    "dropmalst": "IN",
    "dropmalzpp": 473709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654784415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13287",
    "droptype": "D",
    "dropname": "PERU",
    "dropdeladd": "101 S BROADWAY",
    "dropdelcty": "PERU",
    "dropdelst": "IN",
    "dropdelzpp": 469709998,
    "dropphyadd": "101 S BROADWAY",
    "dropphycty": "PERU",
    "dropphyst": "IN",
    "dropphyzpp": 469709998,
    "dropmaladd": "101 S BROADWAY",
    "dropmalcty": "PERU",
    "dropmalst": "IN",
    "dropmalzpp": 469709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654739480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13289",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "110 N 7TH ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 475679998,
    "dropphyadd": "110 N 7TH ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 475679998,
    "dropmaladd": "110 N 7TH ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 475679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123546090,
    "dropfax": 8123548927
  },
  {
    "dcode": "D",
    "dropkey": "PX13291",
    "droptype": "D",
    "dropname": "PETROLEUM",
    "dropdeladd": "3657 E MARKET ST",
    "dropdelcty": "PETROLEUM",
    "dropdelst": "IN",
    "dropdelzpp": 467789998,
    "dropphyadd": "3657 E MARKET ST",
    "dropphycty": "PETROLEUM",
    "dropphyst": "IN",
    "dropphyzpp": 467789998,
    "dropmaladd": "3657 E MARKET ST",
    "dropmalcty": "PETROLEUM",
    "dropmalst": "IN",
    "dropmalzpp": 467789998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603462140,
    "dropfax": 2603462141
  },
  {
    "dcode": "D",
    "dropkey": "PX13294",
    "droptype": "D",
    "dropname": "PIERCETON",
    "dropdeladd": "209 S FIRST ST",
    "dropdelcty": "PIERCETON",
    "dropdelst": "IN",
    "dropdelzpp": 465629998,
    "dropphyadd": "209 S FIRST ST",
    "dropphycty": "PIERCETON",
    "dropphyst": "IN",
    "dropphyzpp": 465629998,
    "dropmaladd": "209 S FIRST ST",
    "dropmalcty": "PIERCETON",
    "dropmalst": "IN",
    "dropmalzpp": 465629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745942627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13296",
    "droptype": "D",
    "dropname": "PIERCEVILLE",
    "dropdeladd": "4499 E STATE ROUTE 350",
    "dropdelcty": "PIERCEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 470399998,
    "dropphyadd": "4499 E STATE ROUTE 350",
    "dropphycty": "PIERCEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 470399998,
    "dropmaladd": "4499 E STATE ROUTE 350",
    "dropmalcty": "PIERCEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 470399998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126542540,
    "dropsitcph": 8126542540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13301",
    "droptype": "D",
    "dropname": "PIMENTO",
    "dropdeladd": "2378 E COTTOM DR",
    "dropdelcty": "PIMENTO",
    "dropdelst": "IN",
    "dropdelzpp": 478669998,
    "dropphyadd": "2378 E COTTOM DR",
    "dropphycty": "PIMENTO",
    "dropphyst": "IN",
    "dropphyzpp": 478669998,
    "dropmaladd": "2378 E COTTOM DR",
    "dropmalcty": "PIMENTO",
    "dropmalst": "IN",
    "dropmalzpp": 478669998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122999297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13305",
    "droptype": "D",
    "dropname": "PINE VILLAGE",
    "dropdeladd": "101 N JEFFERSON ST",
    "dropdelcty": "PINE VILLAGE",
    "dropdelst": "IN",
    "dropdelzpp": 479759998,
    "dropphyadd": "101 N JEFFERSON ST",
    "dropphycty": "PINE VILLAGE",
    "dropphyst": "IN",
    "dropphyzpp": 479759998,
    "dropmaladd": "101 N JEFFERSON ST",
    "dropmalcty": "PINE VILLAGE",
    "dropmalst": "IN",
    "dropmalzpp": 479759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653852472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13311",
    "droptype": "D",
    "dropname": "PITTSBORO",
    "dropdeladd": "29 W MAIN ST",
    "dropdelcty": "PITTSBORO",
    "dropdelst": "IN",
    "dropdelzpp": 461679998,
    "dropphyadd": "29 W MAIN ST",
    "dropphycty": "PITTSBORO",
    "dropphyst": "IN",
    "dropphyzpp": 461679998,
    "dropmaladd": "29 W MAIN ST",
    "dropmalcty": "PITTSBORO",
    "dropmalst": "IN",
    "dropmalzpp": 461679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178922024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13314",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "700 N CARR RD",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 461689998,
    "dropphyadd": "700 N CARR RD",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 461689998,
    "dropmaladd": "700 N CARR RD",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 461689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178394675,
    "dropfax": 3178395623
  },
  {
    "dcode": "D",
    "dropkey": "PX13316",
    "droptype": "D",
    "dropname": "PLAINVILLE",
    "dropdeladd": "868 2ND ST",
    "dropdelcty": "PLAINVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 475689998,
    "dropphyadd": "868 2ND ST",
    "dropphycty": "PLAINVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 475689998,
    "dropmaladd": "868 2ND ST",
    "dropmalcty": "PLAINVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 475689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126877529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13323",
    "droptype": "D",
    "dropname": "PLEASANT LAKE",
    "dropdeladd": "965 W MAIN ST",
    "dropdelcty": "PLEASANT LAKE",
    "dropdelst": "IN",
    "dropdelzpp": 467799998,
    "dropphyadd": "965 W MAIN ST",
    "dropphycty": "PLEASANT LAKE",
    "dropphyst": "IN",
    "dropphyzpp": 467799998,
    "dropmaladd": "965 W MAIN ST",
    "dropmalcty": "PLEASANT LAKE",
    "dropmalst": "IN",
    "dropmalzpp": 467799998,
    "dropsitphn": 2606652019,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604755535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13325",
    "droptype": "D",
    "dropname": "PLEASANT MILLS",
    "dropdeladd": "1995 N STATE ROAD 101",
    "dropdelcty": "PLEASANT MILLS",
    "dropdelst": "IN",
    "dropdelzpp": 467809998,
    "dropphyadd": "1995 N STATE ROAD 101",
    "dropphycty": "PLEASANT MILLS",
    "dropphyst": "IN",
    "dropphyzpp": 467809998,
    "dropmaladd": "1995 N STATE ROAD 101",
    "dropmalcty": "PLEASANT MILLS",
    "dropmalst": "IN",
    "dropmalzpp": 467809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605926744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13339",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "124 W GARRO ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "IN",
    "dropdelzpp": 465639998,
    "dropphyadd": "124 W GARRO ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "IN",
    "dropphyzpp": 465639998,
    "dropmaladd": "124 W GARRO ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "IN",
    "dropmalzpp": 465639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5749362629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13342",
    "droptype": "D",
    "dropname": "POLAND",
    "dropdeladd": "8460 E STATE ROAD 42",
    "dropdelcty": "POLAND",
    "dropdelst": "IN",
    "dropdelzpp": 478689998,
    "dropphyadd": "8460 E STATE ROAD 42",
    "dropphycty": "POLAND",
    "dropphyst": "IN",
    "dropphyzpp": 478689998,
    "dropmaladd": "8460 E STATE ROAD 42",
    "dropmalcty": "POLAND",
    "dropmalst": "IN",
    "dropmalzpp": 478689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129862339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13346",
    "droptype": "D",
    "dropname": "PONETO",
    "dropdeladd": "139 W WASHINGTON ST",
    "dropdelcty": "PONETO",
    "dropdelst": "IN",
    "dropdelzpp": 467819998,
    "dropphyadd": "139 W WASHINGTON ST",
    "dropphycty": "PONETO",
    "dropphyst": "IN",
    "dropphyzpp": 467819998,
    "dropmaladd": "139 W WASHINGTON ST",
    "dropmalcty": "PONETO",
    "dropmalst": "IN",
    "dropmalzpp": 467819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606946446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13350",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "2701 WILLOWCREEK RD",
    "dropdelcty": "PORTAGE",
    "dropdelst": "IN",
    "dropdelzpp": 463689998,
    "dropphyadd": "2701 WILLOWCREEK RD",
    "dropphycty": "PORTAGE",
    "dropphyst": "IN",
    "dropphyzpp": 463689998,
    "dropmaladd": "2701 WILLOWCREEK RD",
    "dropmalcty": "PORTAGE",
    "dropmalst": "IN",
    "dropmalzpp": 463689998,
    "dropsitphn": 2197626571,
    "dropsitlph": 3174646350,
    "dropsitcph": 2197626571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13353",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "119 S MERIDIAN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "IN",
    "dropdelzpp": 473719998,
    "dropphyadd": "119 S MERIDIAN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "IN",
    "dropphyzpp": 473719998,
    "dropmaladd": "119 S MERIDIAN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "IN",
    "dropmalzpp": 473719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607264315,
    "dropfax": 2607266588
  },
  {
    "dcode": "D",
    "dropkey": "PX13357",
    "droptype": "D",
    "dropname": "POSEYVILLE",
    "dropdeladd": "41 S LOCUST ST",
    "dropdelcty": "POSEYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 476339998,
    "dropphyadd": "41 S LOCUST ST",
    "dropphycty": "POSEYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 476339998,
    "dropmaladd": "41 S LOCUST ST",
    "dropmalcty": "POSEYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 476339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128742411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13365",
    "droptype": "D",
    "dropname": "PRAIRIE CREEK",
    "dropdeladd": "15907 STATE ROAD 63",
    "dropdelcty": "PRAIRIE CREEK",
    "dropdelst": "IN",
    "dropdelzpp": 478699998,
    "dropphyadd": "15907 STATE ROAD 63",
    "dropphycty": "PRAIRIE CREEK",
    "dropphyst": "IN",
    "dropphyzpp": 478699998,
    "dropmaladd": "15907 STATE ROAD 63",
    "dropmalcty": "PRAIRIE CREEK",
    "dropmalst": "IN",
    "dropmalzpp": 478699998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128982216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13369",
    "droptype": "D",
    "dropname": "PRAIRIETON",
    "dropdeladd": "3645 MURPHY RD",
    "dropdelcty": "PRAIRIETON",
    "dropdelst": "IN",
    "dropdelzpp": 478709998,
    "dropphyadd": "3645 MURPHY RD",
    "dropphycty": "PRAIRIETON",
    "dropphyst": "IN",
    "dropphyzpp": 478709998,
    "dropmaladd": "3645 MURPHY RD",
    "dropmalcty": "PRAIRIETON",
    "dropmalst": "IN",
    "dropmalzpp": 478709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122999237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13370",
    "droptype": "D",
    "dropname": "PREBLE",
    "dropdeladd": "3990 W US HIGHWAY 224 UNIT A",
    "dropdelcty": "PREBLE",
    "dropdelst": "IN",
    "dropdelzpp": 467829998,
    "dropphyadd": "3990 W US HIGHWAY 224 UNIT A",
    "dropphycty": "PREBLE",
    "dropphyst": "IN",
    "dropphyzpp": 467829998,
    "dropmaladd": "3990 W US HIGHWAY 224 UNIT A",
    "dropmalcty": "PREBLE",
    "dropmalst": "IN",
    "dropmalzpp": 467829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605474521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13373",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "129 E BROADWAY ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "IN",
    "dropdelzpp": 476709998,
    "dropphyadd": "129 E BROADWAY ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "IN",
    "dropphyzpp": 476709998,
    "dropmaladd": "129 E BROADWAY ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "IN",
    "dropmalzpp": 476709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123854889,
    "dropfax": 8123863294
  },
  {
    "dcode": "D",
    "dropkey": "PX13388",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "3218 SOUTH ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "IN",
    "dropdelzpp": 474569998,
    "dropphyadd": "3218 SOUTH ST",
    "dropphycty": "QUINCY",
    "dropphyst": "IN",
    "dropphyzpp": 474569998,
    "dropmaladd": "3218 SOUTH ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "IN",
    "dropmalzpp": 474569998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657956062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13397",
    "droptype": "D",
    "dropname": "RAMSEY",
    "dropdeladd": "1310 HIGHWAY 64 NW",
    "dropdelcty": "RAMSEY",
    "dropdelst": "IN",
    "dropdelzpp": 471669998,
    "dropphyadd": "1310 HIGHWAY 64 NW",
    "dropphycty": "RAMSEY",
    "dropphyst": "IN",
    "dropphyzpp": 471669998,
    "dropmaladd": "1310 HIGHWAY 64 NW",
    "dropmalcty": "RAMSEY",
    "dropmalst": "IN",
    "dropmalzpp": 471669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123472757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13403",
    "droptype": "D",
    "dropname": "REDKEY",
    "dropdeladd": "133 W HIGH ST",
    "dropdelcty": "REDKEY",
    "dropdelst": "IN",
    "dropdelzpp": 473739998,
    "dropphyadd": "133 W HIGH ST",
    "dropphycty": "REDKEY",
    "dropphyst": "IN",
    "dropphyzpp": 473739998,
    "dropmaladd": "133 W HIGH ST",
    "dropmalcty": "REDKEY",
    "dropmalst": "IN",
    "dropmalzpp": 473739998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653692112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13404",
    "droptype": "D",
    "dropname": "REELSVILLE",
    "dropdeladd": "6297 W COUNTY ROAD 750 S",
    "dropdelcty": "REELSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461719998,
    "dropphyadd": "6297 W COUNTY ROAD 750 S",
    "dropphycty": "REELSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461719998,
    "dropmaladd": "6297 W COUNTY ROAD 750 S",
    "dropmalcty": "REELSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656724749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13410",
    "droptype": "D",
    "dropname": "REMINGTON",
    "dropdeladd": "31 S OHIO ST",
    "dropdelcty": "REMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 479779998,
    "dropphyadd": "31 S OHIO ST",
    "dropphycty": "REMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 479779998,
    "dropmaladd": "31 S OHIO ST",
    "dropmalcty": "REMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 479779998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2192612420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13412",
    "droptype": "D",
    "dropname": "RENSSELAER",
    "dropdeladd": "225 S VAN RENSSELAER ST",
    "dropdelcty": "RENSSELAER",
    "dropdelst": "IN",
    "dropdelzpp": 479789998,
    "dropphyadd": "225 S VAN RENSSELAER ST",
    "dropphycty": "RENSSELAER",
    "dropphyst": "IN",
    "dropphyzpp": 479789998,
    "dropmaladd": "225 S VAN RENSSELAER ST",
    "dropmalcty": "RENSSELAER",
    "dropmalst": "IN",
    "dropmalzpp": 479789998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2198665322,
    "dropfax": 2198660784
  },
  {
    "dcode": "D",
    "dropkey": "PX13416",
    "droptype": "D",
    "dropname": "REYNOLDS",
    "dropdeladd": "801 E 2ND ST",
    "dropdelcty": "REYNOLDS",
    "dropdelst": "IN",
    "dropdelzpp": 479809998,
    "dropphyadd": "801 E 2ND ST",
    "dropphycty": "REYNOLDS",
    "dropphyst": "IN",
    "dropphyzpp": 479809998,
    "dropmaladd": "801 E 2ND ST",
    "dropmalcty": "REYNOLDS",
    "dropmalst": "IN",
    "dropmalzpp": 479809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2199845339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13421",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "4143 N STATE ROAD 161",
    "dropdelcty": "RICHLAND",
    "dropdelst": "IN",
    "dropdelzpp": 476349998,
    "dropphyadd": "4143 N STATE ROAD 161",
    "dropphycty": "RICHLAND",
    "dropphyst": "IN",
    "dropphyzpp": 476349998,
    "dropmaladd": "4143 N STATE ROAD 161",
    "dropmalcty": "RICHLAND",
    "dropmalst": "IN",
    "dropmalzpp": 476349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8123594236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13424",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "400 N A ST OFC",
    "dropdelcty": "RICHMOND",
    "dropdelst": "IN",
    "dropdelzpp": 473749998,
    "dropphyadd": "400 N A ST OFC",
    "dropphycty": "RICHMOND",
    "dropphyst": "IN",
    "dropphyzpp": 473749998,
    "dropmaladd": "400 N A ST OFC",
    "dropmalcty": "RICHMOND",
    "dropmalst": "IN",
    "dropmalzpp": 473749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659667631,
    "dropfax": 7659662481
  },
  {
    "dcode": "D",
    "dropkey": "PX13429",
    "droptype": "D",
    "dropname": "RIDGEVILLE",
    "dropdeladd": "301 S WALNUT ST",
    "dropdelcty": "RIDGEVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 473809998,
    "dropphyadd": "301 S WALNUT ST",
    "dropphycty": "RIDGEVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 473809998,
    "dropmaladd": "301 S WALNUT ST",
    "dropmalcty": "RIDGEVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 473809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658572041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13434",
    "droptype": "D",
    "dropname": "RILEY",
    "dropdeladd": "7800 STATE ROAD 46 E",
    "dropdelcty": "RILEY",
    "dropdelst": "IN",
    "dropdelzpp": 478719998,
    "dropphyadd": "7800 STATE ROAD 46 E",
    "dropphycty": "RILEY",
    "dropphyst": "IN",
    "dropphyzpp": 478719998,
    "dropmaladd": "7800 STATE ROAD 46 E",
    "dropmalcty": "RILEY",
    "dropmalst": "IN",
    "dropmalzpp": 478719998,
    "dropsitphn": 8128944127,
    "dropsitlph": 8128944127,
    "dropsitcph": 8128944197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13435",
    "droptype": "D",
    "dropname": "RISING SUN",
    "dropdeladd": "111 N WALNUT ST",
    "dropdelcty": "RISING SUN",
    "dropdelst": "IN",
    "dropdelzpp": 470409998,
    "dropphyadd": "111 N WALNUT ST",
    "dropphycty": "RISING SUN",
    "dropphyst": "IN",
    "dropphyzpp": 470409998,
    "dropmaladd": "111 N WALNUT ST",
    "dropmalcty": "RISING SUN",
    "dropmalst": "IN",
    "dropmalzpp": 470409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8124389352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13442",
    "droptype": "D",
    "dropname": "ROACHDALE",
    "dropdeladd": "104 N MERIDIAN ST",
    "dropdelcty": "ROACHDALE",
    "dropdelst": "IN",
    "dropdelzpp": 461729998,
    "dropphyadd": "104 N MERIDIAN ST",
    "dropphycty": "ROACHDALE",
    "dropphyst": "IN",
    "dropphyzpp": 461729998,
    "dropmaladd": "104 N MERIDIAN ST",
    "dropmalcty": "ROACHDALE",
    "dropmalst": "IN",
    "dropmalzpp": 461729998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655221318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13444",
    "droptype": "D",
    "dropname": "ROANN",
    "dropdeladd": "160 N CHIPPEWA ST",
    "dropdelcty": "ROANN",
    "dropdelst": "IN",
    "dropdelzpp": 469749998,
    "dropphyadd": "160 N CHIPPEWA ST",
    "dropphycty": "ROANN",
    "dropphyst": "IN",
    "dropphyzpp": 469749998,
    "dropmaladd": "160 N CHIPPEWA ST",
    "dropmalcty": "ROANN",
    "dropmalst": "IN",
    "dropmalzpp": 469749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658339911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13445",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "117 S MAIN ST",
    "dropdelcty": "ROANOKE",
    "dropdelst": "IN",
    "dropdelzpp": 467839998,
    "dropphyadd": "117 S MAIN ST",
    "dropphycty": "ROANOKE",
    "dropphyst": "IN",
    "dropphyzpp": 467839998,
    "dropmaladd": "117 S MAIN ST",
    "dropmalcty": "ROANOKE",
    "dropmalst": "IN",
    "dropmalzpp": 467839998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606723269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13447",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "601 E 9TH ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "IN",
    "dropdelzpp": 469759998,
    "dropphyadd": "601 E 9TH ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "IN",
    "dropphyzpp": 469759998,
    "dropmaladd": "601 E 9TH ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "IN",
    "dropmalzpp": 469759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174636305,
    "dropsitcph": 5742232610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13453",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "115 N 5TH ST",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "IN",
    "dropdelzpp": 476359998,
    "dropphyadd": "115 N 5TH ST",
    "dropphycty": "ROCKPORT",
    "dropphyst": "IN",
    "dropphyzpp": 476359998,
    "dropmaladd": "115 N 5TH ST",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "IN",
    "dropmalzpp": 476359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8126494483,
    "dropfax": 8126494260
  },
  {
    "dcode": "D",
    "dropkey": "PX13455",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "102 N MARKET ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 478729998,
    "dropphyadd": "102 N MARKET ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 478729998,
    "dropmaladd": "102 N MARKET ST",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 478729998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655695486,
    "dropfax": 7655690828
  },
  {
    "dcode": "D",
    "dropkey": "PX13462",
    "droptype": "D",
    "dropname": "ROLLING PRAIRIE",
    "dropdeladd": "3 S DEPOT ST",
    "dropdelcty": "ROLLING PRAIRIE",
    "dropdelst": "IN",
    "dropdelzpp": 463719998,
    "dropphyadd": "3 S DEPOT ST",
    "dropphycty": "ROLLING PRAIRIE",
    "dropphyst": "IN",
    "dropphyzpp": 463719998,
    "dropmaladd": "3 S DEPOT ST",
    "dropmalcty": "ROLLING PRAIRIE",
    "dropmalst": "IN",
    "dropmalzpp": 463719998,
    "dropsitphn": 2197782912,
    "dropsitlph": 3174646350,
    "dropsitcph": 2197782912,
    "dropfax": 2197782912
  },
  {
    "dcode": "D",
    "dropkey": "PX13465",
    "droptype": "D",
    "dropname": "ROME CITY",
    "dropdeladd": "125 KERR AVE",
    "dropdelcty": "ROME CITY",
    "dropdelst": "IN",
    "dropdelzpp": 467849998,
    "dropphyadd": "125 KERR AVE",
    "dropphycty": "ROME CITY",
    "dropphyst": "IN",
    "dropphyzpp": 467849998,
    "dropmaladd": "125 KERR AVE",
    "dropmalcty": "ROME CITY",
    "dropmalst": "IN",
    "dropmalzpp": 467849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608543700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13468",
    "droptype": "D",
    "dropname": "ROMNEY",
    "dropdeladd": "11440 US HIGHWAY 231 S",
    "dropdelcty": "ROMNEY",
    "dropdelst": "IN",
    "dropdelzpp": 479819998,
    "dropphyadd": "11440 US HIGHWAY 231 S",
    "dropphycty": "ROMNEY",
    "dropphyst": "IN",
    "dropphyzpp": 479819998,
    "dropmaladd": "11440 US HIGHWAY 231 S",
    "dropmalcty": "ROMNEY",
    "dropmalst": "IN",
    "dropmalzpp": 479819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655382860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13473",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "55 N MAIN ST",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "IN",
    "dropdelzpp": 478749998,
    "dropphyadd": "55 N MAIN ST",
    "dropphycty": "ROSEDALE",
    "dropphyst": "IN",
    "dropphyzpp": 478749998,
    "dropmaladd": "55 N MAIN ST",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "IN",
    "dropmalzpp": 478749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655482219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13475",
    "droptype": "D",
    "dropname": "ROSELAWN",
    "dropdeladd": "10060 N 600 E",
    "dropdelcty": "ROSELAWN",
    "dropdelst": "IN",
    "dropdelzpp": 463729998,
    "dropphyadd": "10060 N 600 E",
    "dropphycty": "ROSELAWN",
    "dropphyst": "IN",
    "dropphyzpp": 463729998,
    "dropmaladd": "10060 N 600 E",
    "dropmalcty": "ROSELAWN",
    "dropmalst": "IN",
    "dropmalzpp": 463729998,
    "dropsitphn": 3164646305,
    "dropsitlph": 3174646350,
    "dropsitcph": 2192758500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13477",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "27 W MAIN ST",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460659998,
    "dropphyadd": "27 W MAIN ST",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460659998,
    "dropmaladd": "27 W MAIN ST",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653792141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13481",
    "droptype": "D",
    "dropname": "ROYAL CENTER",
    "dropdeladd": "117 S CHICAGO ST",
    "dropdelcty": "ROYAL CENTER",
    "dropdelst": "IN",
    "dropdelzpp": 469789998,
    "dropphyadd": "117 S CHICAGO ST",
    "dropphycty": "ROYAL CENTER",
    "dropphyst": "IN",
    "dropphyzpp": 469789998,
    "dropmaladd": "117 S CHICAGO ST",
    "dropmalcty": "ROYAL CENTER",
    "dropmalst": "IN",
    "dropmalzpp": 469789998,
    "dropsitphn": 5747533535,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746435295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13488",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "230 W 3RD ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461739998,
    "dropphyadd": "230 W 3RD ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461739998,
    "dropmaladd": "230 W 3RD ST",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461739998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659323139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13491",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "201 E 1ST ST",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461759998,
    "dropphyadd": "201 E 1ST ST",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461759998,
    "dropmaladd": "201 E 1ST ST",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654352998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13495",
    "droptype": "D",
    "dropname": "RUSSIAVILLE",
    "dropdeladd": "225 N UNION ST",
    "dropdelcty": "RUSSIAVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 469799998,
    "dropphyadd": "225 N UNION ST",
    "dropphycty": "RUSSIAVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 469799998,
    "dropmaladd": "225 N UNION ST",
    "dropmalcty": "RUSSIAVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 469799998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658835756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13503",
    "droptype": "D",
    "dropname": "SAINT ANTHONY",
    "dropdeladd": "4531 S CROSS ST",
    "dropdelcty": "SAINT ANTHONY",
    "dropdelst": "IN",
    "dropdelzpp": 475759998,
    "dropphyadd": "4531 S CROSS ST",
    "dropphycty": "SAINT ANTHONY",
    "dropphyst": "IN",
    "dropphyzpp": 475759998,
    "dropmaladd": "4531 S CROSS ST",
    "dropmalcty": "SAINT ANTHONY",
    "dropmalst": "IN",
    "dropmalzpp": 475759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123262020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13504",
    "droptype": "D",
    "dropname": "SAINT BERNICE",
    "dropdeladd": "3039 W BROADWAY ST",
    "dropdelcty": "SAINT BERNICE",
    "dropdelst": "IN",
    "dropdelzpp": 478759998,
    "dropphyadd": "3039 W BROADWAY ST",
    "dropphycty": "SAINT BERNICE",
    "dropphyst": "IN",
    "dropphyzpp": 478759998,
    "dropmaladd": "3039 W BROADWAY ST",
    "dropmalcty": "SAINT BERNICE",
    "dropmalst": "IN",
    "dropmalzpp": 478759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658327295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13506",
    "droptype": "D",
    "dropname": "SAINT JOE",
    "dropdeladd": "104 THIRD ST",
    "dropdelcty": "SAINT JOE",
    "dropdelst": "IN",
    "dropdelzpp": 467859998,
    "dropphyadd": "104 THIRD ST",
    "dropphycty": "SAINT JOE",
    "dropphyst": "IN",
    "dropphyzpp": 467859998,
    "dropmaladd": "104 THIRD ST",
    "dropmalcty": "SAINT JOE",
    "dropmalst": "IN",
    "dropmalzpp": 467859998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603375595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13507",
    "droptype": "D",
    "dropname": "SAINT JOHN",
    "dropdeladd": "9200 THIEL ST",
    "dropdelcty": "SAINT JOHN",
    "dropdelst": "IN",
    "dropdelzpp": 463739998,
    "dropphyadd": "9200 THIEL ST",
    "dropphycty": "SAINT JOHN",
    "dropphyst": "IN",
    "dropphyzpp": 463739998,
    "dropmaladd": "9200 THIEL ST",
    "dropmalcty": "SAINT JOHN",
    "dropmalst": "IN",
    "dropmalzpp": 463739998,
    "dropsitphn": 2193654254,
    "dropsitlph": 2193654254,
    "dropsitcph": 2193654254,
    "dropfax": 2193654299
  },
  {
    "dcode": "D",
    "dropkey": "PX13510",
    "droptype": "D",
    "dropname": "SAINT MARY OF THE WOODS",
    "dropdeladd": "3678 N ARMS PL",
    "dropdelcty": "SAINT MARY OF THE WOODS",
    "dropdelst": "IN",
    "dropdelzpp": 478769998,
    "dropphyadd": "3678 N ARMS PL",
    "dropphycty": "SAINT MARY OF THE WOODS",
    "dropphyst": "IN",
    "dropphyzpp": 478769998,
    "dropmaladd": "3678 N ARMS PL",
    "dropmalcty": "SAINT MARY OF THE WOODS",
    "dropmalst": "IN",
    "dropmalzpp": 478769998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125353824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13515",
    "droptype": "D",
    "dropname": "SAINT MEINRAD",
    "dropdeladd": "19603 N STATE ROAD 545",
    "dropdelcty": "SAINT MEINRAD",
    "dropdelst": "IN",
    "dropdelzpp": 475779998,
    "dropphyadd": "19603 N STATE ROAD 545",
    "dropphycty": "SAINT MEINRAD",
    "dropphyst": "IN",
    "dropphyzpp": 475779998,
    "dropmaladd": "19603 N STATE ROAD 545",
    "dropmalcty": "SAINT MEINRAD",
    "dropmalst": "IN",
    "dropmalzpp": 475779998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123575685,
    "dropfax": 8123572762
  },
  {
    "dcode": "D",
    "dropkey": "PX13516",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "109 E WASHINGTON ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "IN",
    "dropdelzpp": 472729998,
    "dropphyadd": "109 E WASHINGTON ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "IN",
    "dropphyzpp": 472729998,
    "dropmaladd": "109 E WASHINGTON ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "IN",
    "dropmalzpp": 472729998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655256423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13522",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "118 E WALNUT ST",
    "dropdelcty": "SALEM",
    "dropdelst": "IN",
    "dropdelzpp": 471679998,
    "dropphyadd": "118 E WALNUT ST",
    "dropphycty": "SALEM",
    "dropphyst": "IN",
    "dropphyzpp": 471679998,
    "dropmaladd": "118 E WALNUT ST",
    "dropmalcty": "SALEM",
    "dropmalst": "IN",
    "dropmalzpp": 471679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8128832173,
    "dropfax": 8128836996
  },
  {
    "dcode": "D",
    "dropkey": "PX13530",
    "droptype": "D",
    "dropname": "SAN PIERRE",
    "dropdeladd": "104 ELIZA ST",
    "dropdelcty": "SAN PIERRE",
    "dropdelst": "IN",
    "dropdelzpp": 463749998,
    "dropphyadd": "104 ELIZA ST",
    "dropphycty": "SAN PIERRE",
    "dropphyst": "IN",
    "dropphyzpp": 463749998,
    "dropmaladd": "104 ELIZA ST",
    "dropmalcty": "SAN PIERRE",
    "dropmalst": "IN",
    "dropmalzpp": 463749998,
    "dropsitphn": 2198285671,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198285671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13531",
    "droptype": "D",
    "dropname": "SANDBORN",
    "dropdeladd": "103 N ANDERSON ST",
    "dropdelcty": "SANDBORN",
    "dropdelst": "IN",
    "dropdelzpp": 475789998,
    "dropphyadd": "103 N ANDERSON ST",
    "dropphycty": "SANDBORN",
    "dropphyst": "IN",
    "dropphyzpp": 475789998,
    "dropmaladd": "103 N ANDERSON ST",
    "dropmalcty": "SANDBORN",
    "dropmalst": "IN",
    "dropmalzpp": 475789998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126948999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13538",
    "droptype": "D",
    "dropname": "SANTA CLAUS",
    "dropdeladd": "45 N KRINGLE PL",
    "dropdelcty": "SANTA CLAUS",
    "dropdelst": "IN",
    "dropdelzpp": 475799998,
    "dropphyadd": "45 N KRINGLE PL",
    "dropphycty": "SANTA CLAUS",
    "dropphyst": "IN",
    "dropphyzpp": 475799998,
    "dropmaladd": "45 N KRINGLE PL",
    "dropmalcty": "SANTA CLAUS",
    "dropmalst": "IN",
    "dropmalzpp": 475799998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125488563,
    "dropfax": 8129374316
  },
  {
    "dcode": "D",
    "dropkey": "PX13539",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "209 E MAIN ST",
    "dropdelcty": "SARATOGA",
    "dropdelst": "IN",
    "dropdelzpp": 473829998,
    "dropphyadd": "209 E MAIN ST",
    "dropphycty": "SARATOGA",
    "dropphyst": "IN",
    "dropphyzpp": 473829998,
    "dropmaladd": "209 E MAIN ST",
    "dropmalcty": "SARATOGA",
    "dropmalst": "IN",
    "dropmalzpp": 473829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655840090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13544",
    "droptype": "D",
    "dropname": "SCHERERVILLE",
    "dropdeladd": "1200 EAGLE RIDGE DR",
    "dropdelcty": "SCHERERVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 463759998,
    "dropphyadd": "1200 EAGLE RIDGE DR",
    "dropphycty": "SCHERERVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 463759998,
    "dropmaladd": "1200 EAGLE RIDGE DR",
    "dropmalcty": "SCHERERVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 463759998,
    "dropsitphn": 2193224601,
    "dropsitlph": 2193224601,
    "dropsitcph": 2193224601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13547",
    "droptype": "D",
    "dropname": "SCHNEIDER",
    "dropdeladd": "23914 PARRISH AVE",
    "dropdelcty": "SCHNEIDER",
    "dropdelst": "IN",
    "dropdelzpp": 463769998,
    "dropphyadd": "23914 PARRISH AVE",
    "dropphycty": "SCHNEIDER",
    "dropphyst": "IN",
    "dropphyzpp": 463769998,
    "dropmaladd": "23914 PARRISH AVE",
    "dropmalcty": "SCHNEIDER",
    "dropmalst": "IN",
    "dropmalzpp": 463769998,
    "dropsitphn": 2195520700,
    "dropsitlph": 2195520700,
    "dropsitcph": 2195520700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13551",
    "droptype": "D",
    "dropname": "SCIPIO",
    "dropdeladd": "6545 N STATE HIGHWAY 7",
    "dropdelcty": "SCIPIO",
    "dropdelst": "IN",
    "dropdelzpp": 472739998,
    "dropphyadd": "6545 N STATE HIGHWAY 7",
    "dropphycty": "SCIPIO",
    "dropphyst": "IN",
    "dropphyzpp": 472739998,
    "dropmaladd": "6545 N STATE HIGHWAY 7",
    "dropmalcty": "SCIPIO",
    "dropmalst": "IN",
    "dropmalzpp": 472739998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123922271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13556",
    "droptype": "D",
    "dropname": "SCOTTSBURG",
    "dropdeladd": "202 W MCCLAIN AVE",
    "dropdelcty": "SCOTTSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 471709998,
    "dropphyadd": "202 W MCCLAIN AVE",
    "dropphycty": "SCOTTSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 471709998,
    "dropmaladd": "202 W MCCLAIN AVE",
    "dropmalcty": "SCOTTSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 471709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8127522591,
    "dropfax": 8127520391
  },
  {
    "dcode": "D",
    "dropkey": "PX13558",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "496 W STATE ROAD 26",
    "dropdelcty": "SEDALIA",
    "dropdelst": "IN",
    "dropdelzpp": 460679800,
    "dropphyadd": "496 W STATE ROAD 26",
    "dropphycty": "SEDALIA",
    "dropphyst": "IN",
    "dropphyzpp": 460679800,
    "dropmaladd": "496 W STATE ROAD 26",
    "dropmalcty": "SEDALIA",
    "dropmalst": "IN",
    "dropmalzpp": 460679800,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652583372,
    "dropfax": 7652583372
  },
  {
    "dcode": "D",
    "dropkey": "PX13560",
    "droptype": "D",
    "dropname": "SEELYVILLE",
    "dropdeladd": "9538 E US HIGHWAY 40",
    "dropdelcty": "SEELYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 478789998,
    "dropphyadd": "9538 E US HIGHWAY 40",
    "dropphycty": "SEELYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 478789998,
    "dropmaladd": "9538 E US HIGHWAY 40",
    "dropmalcty": "SEELYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 478789998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128773784,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13563",
    "droptype": "D",
    "dropname": "SELLERSBURG",
    "dropdeladd": "315 E UTICA ST",
    "dropdelcty": "SELLERSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 471729998,
    "dropphyadd": "315 E UTICA ST",
    "dropphycty": "SELLERSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 471729998,
    "dropmaladd": "315 E UTICA ST",
    "dropmalcty": "SELLERSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 471729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8122469031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13564",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "211 S ALBANY ST",
    "dropdelcty": "SELMA",
    "dropdelst": "IN",
    "dropdelzpp": 473839998,
    "dropphyadd": "211 S ALBANY ST",
    "dropphycty": "SELMA",
    "dropphyst": "IN",
    "dropphyzpp": 473839998,
    "dropmaladd": "211 S ALBANY ST",
    "dropmalcty": "SELMA",
    "dropmalst": "IN",
    "dropmalzpp": 473839998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652845067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13566",
    "droptype": "D",
    "dropname": "SERVIA",
    "dropdeladd": "190 S MAIN ST",
    "dropdelcty": "SERVIA",
    "dropdelst": "IN",
    "dropdelzpp": 469809998,
    "dropphyadd": "190 S MAIN ST",
    "dropphycty": "SERVIA",
    "dropphyst": "IN",
    "dropphyzpp": 469809998,
    "dropmaladd": "190 S MAIN ST",
    "dropmalcty": "SERVIA",
    "dropmalst": "IN",
    "dropmalzpp": 469809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2609822957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13567",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "321 N CHESTNUT ST",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "IN",
    "dropdelzpp": 472749998,
    "dropphyadd": "321 N CHESTNUT ST",
    "dropphycty": "SEYMOUR",
    "dropphyst": "IN",
    "dropphyzpp": 472749998,
    "dropmaladd": "321 N CHESTNUT ST",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "IN",
    "dropmalzpp": 472749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125222559,
    "dropfax": 8125236676
  },
  {
    "dcode": "D",
    "dropkey": "PX13571",
    "droptype": "D",
    "dropname": "SHARPSVILLE",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "SHARPSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460689998,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "SHARPSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460689998,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "SHARPSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659632400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13576",
    "droptype": "D",
    "dropname": "SHELBURN",
    "dropdeladd": "13 N RAILROAD ST",
    "dropdelcty": "SHELBURN",
    "dropdelst": "IN",
    "dropdelzpp": 478799998,
    "dropphyadd": "13 N RAILROAD ST",
    "dropphycty": "SHELBURN",
    "dropphyst": "IN",
    "dropphyzpp": 478799998,
    "dropmaladd": "13 N RAILROAD ST",
    "dropmalcty": "SHELBURN",
    "dropmalst": "IN",
    "dropmalzpp": 478799998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123972123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13577",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "23323 SHELBY RD",
    "dropdelcty": "SHELBY",
    "dropdelst": "IN",
    "dropdelzpp": 463779998,
    "dropphyadd": "23323 SHELBY RD",
    "dropphycty": "SHELBY",
    "dropphyst": "IN",
    "dropphyzpp": 463779998,
    "dropmaladd": "23323 SHELBY RD",
    "dropmalcty": "SHELBY",
    "dropmalst": "IN",
    "dropmalzpp": 463779998,
    "dropsitphn": 2195520122,
    "dropsitlph": 2195520122,
    "dropsitcph": 2195520122,
    "dropfax": 2195520122
  },
  {
    "dcode": "D",
    "dropkey": "PX13578",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "103 E WASHINGTON ST",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461769998,
    "dropphyadd": "103 E WASHINGTON ST",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461769998,
    "dropmaladd": "103 E WASHINGTON ST",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461769998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3173927958,
    "dropfax": 3173924059
  },
  {
    "dcode": "D",
    "dropkey": "PX13581",
    "droptype": "D",
    "dropname": "SHEPARDSVILLE",
    "dropdeladd": "90 E TRINITY AVE",
    "dropdelcty": "SHEPARDSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 478809998,
    "dropphyadd": "90 E TRINITY AVE",
    "dropphycty": "SHEPARDSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 478809998,
    "dropmaladd": "90 E TRINITY AVE",
    "dropmalcty": "SHEPARDSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 478809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658321765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13584",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "107 W 4TH ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "IN",
    "dropdelzpp": 460699998,
    "dropphyadd": "107 W 4TH ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "IN",
    "dropphyzpp": 460699998,
    "dropmaladd": "107 W 4TH ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "IN",
    "dropmalzpp": 460699998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3177584159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13586",
    "droptype": "D",
    "dropname": "SHIPSHEWANA",
    "dropdeladd": "355 MAIN ST",
    "dropdelcty": "SHIPSHEWANA",
    "dropdelst": "IN",
    "dropdelzpp": 465659998,
    "dropphyadd": "355 MAIN ST",
    "dropphycty": "SHIPSHEWANA",
    "dropphyst": "IN",
    "dropphyzpp": 465659998,
    "dropmaladd": "355 MAIN ST",
    "dropmalcty": "SHIPSHEWANA",
    "dropmalst": "IN",
    "dropmalzpp": 465659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607684172,
    "dropfax": 2607687588
  },
  {
    "dcode": "D",
    "dropkey": "PX13588",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "330 MAIN ST",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "IN",
    "dropdelzpp": 473849998,
    "dropphyadd": "330 MAIN ST",
    "dropphycty": "SHIRLEY",
    "dropphyst": "IN",
    "dropphyzpp": 473849998,
    "dropmaladd": "330 MAIN ST",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "IN",
    "dropmalzpp": 473849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657376335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13589",
    "droptype": "D",
    "dropname": "SHOALS",
    "dropdeladd": "212 2ND ST",
    "dropdelcty": "SHOALS",
    "dropdelst": "IN",
    "dropdelzpp": 475819998,
    "dropphyadd": "212 2ND ST",
    "dropphycty": "SHOALS",
    "dropphyst": "IN",
    "dropphyzpp": 475819998,
    "dropmaladd": "212 2ND ST",
    "dropmalcty": "SHOALS",
    "dropmalst": "IN",
    "dropmalzpp": 475819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122472020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13592",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "IN",
    "dropdelzpp": 469829998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "IN",
    "dropphyzpp": 469829998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "IN",
    "dropmalzpp": 469829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603522811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13602",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "7390 S STRAIN RIDGE RD",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474589998,
    "dropphyadd": "7390 S STRAIN RIDGE RD",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474589998,
    "dropmaladd": "7390 S STRAIN RIDGE RD",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474589998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128246010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13612",
    "droptype": "D",
    "dropname": "SOLSBERRY",
    "dropdeladd": "10023 E TULIP RD",
    "dropdelcty": "SOLSBERRY",
    "dropdelst": "IN",
    "dropdelzpp": 474599998,
    "dropphyadd": "10023 E TULIP RD",
    "dropphycty": "SOLSBERRY",
    "dropphyst": "IN",
    "dropphyzpp": 474599998,
    "dropmaladd": "10023 E TULIP RD",
    "dropmalcty": "SOLSBERRY",
    "dropmalst": "IN",
    "dropmalzpp": 474599998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8133379245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13613",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "1 SHOPPING CENTER RD",
    "dropdelcty": "SOMERSET",
    "dropdelst": "IN",
    "dropdelzpp": 469849998,
    "dropphyadd": "1 SHOPPING CENTER RD",
    "dropphycty": "SOMERSET",
    "dropphyst": "IN",
    "dropphyzpp": 469849998,
    "dropmaladd": "1 SHOPPING CENTER RD",
    "dropmalcty": "SOMERSET",
    "dropmalst": "IN",
    "dropmalzpp": 469849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659812384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13619",
    "droptype": "D",
    "dropname": "SOUTH BEND",
    "dropdeladd": "424 S MICHIGAN ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466019998,
    "dropphyadd": "424 S MICHIGAN ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466019998,
    "dropmaladd": "424 S MICHIGAN ST",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828450,
    "dropfax": 5742828463
  },
  {
    "dcode": "D",
    "dropkey": "PX13624",
    "droptype": "D",
    "dropname": "SOUTH MILFORD",
    "dropdeladd": "7470 S STATE ROAD 3",
    "dropdelcty": "SOUTH MILFORD",
    "dropdelst": "IN",
    "dropdelzpp": 467869998,
    "dropphyadd": "7470 S STATE ROAD 3",
    "dropphycty": "SOUTH MILFORD",
    "dropphyst": "IN",
    "dropphyzpp": 467869998,
    "dropmaladd": "7470 S STATE ROAD 3",
    "dropmalcty": "SOUTH MILFORD",
    "dropmalst": "IN",
    "dropmalzpp": 467869998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603513221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13628",
    "droptype": "D",
    "dropname": "SOUTH WHITLEY",
    "dropdeladd": "107 S MAPLE ST",
    "dropdelcty": "SOUTH WHITLEY",
    "dropdelst": "IN",
    "dropdelzpp": 467879998,
    "dropphyadd": "107 S MAPLE ST",
    "dropphycty": "SOUTH WHITLEY",
    "dropphyst": "IN",
    "dropphyzpp": 467879998,
    "dropmaladd": "107 S MAPLE ST",
    "dropmalcty": "SOUTH WHITLEY",
    "dropmalst": "IN",
    "dropmalzpp": 467879998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607234716,
    "dropfax": 2607235420
  },
  {
    "dcode": "D",
    "dropkey": "PX13644",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "30 S WASHINGTON ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "IN",
    "dropdelzpp": 474609998,
    "dropphyadd": "30 S WASHINGTON ST",
    "dropphycty": "SPENCER",
    "dropphyst": "IN",
    "dropphyzpp": 474609998,
    "dropmaladd": "30 S WASHINGTON ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "IN",
    "dropmalzpp": 474609998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128292819,
    "dropfax": 8128291190
  },
  {
    "dcode": "D",
    "dropkey": "PX13645",
    "droptype": "D",
    "dropname": "SPENCERVILLE",
    "dropdeladd": "6909 STATE ROAD 1",
    "dropdelcty": "SPENCERVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467889998,
    "dropphyadd": "6909 STATE ROAD 1",
    "dropphycty": "SPENCERVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467889998,
    "dropmaladd": "6909 STATE ROAD 1",
    "dropmalcty": "SPENCERVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467889998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2602384316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13648",
    "droptype": "D",
    "dropname": "SPICELAND",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "SPICELAND",
    "dropdelst": "IN",
    "dropdelzpp": 473859998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "SPICELAND",
    "dropphyst": "IN",
    "dropphyzpp": 473859998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "SPICELAND",
    "dropmalst": "IN",
    "dropmalzpp": 473859998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659878173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13657",
    "droptype": "D",
    "dropname": "SPRINGPORT",
    "dropdeladd": "312 W MAIN ST",
    "dropdelcty": "SPRINGPORT",
    "dropdelst": "IN",
    "dropdelzpp": 473869998,
    "dropphyadd": "312 W MAIN ST",
    "dropphycty": "SPRINGPORT",
    "dropphyst": "IN",
    "dropphyzpp": 473869998,
    "dropmaladd": "312 W MAIN ST",
    "dropmalcty": "SPRINGPORT",
    "dropmalst": "IN",
    "dropmalzpp": 473869998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657553500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13659",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "193 BRICK ST",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474629998,
    "dropphyadd": "193 BRICK ST",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474629998,
    "dropmaladd": "193 BRICK ST",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474629998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122791901,
    "dropfax": 8122771407
  },
  {
    "dcode": "D",
    "dropkey": "PX13663",
    "droptype": "D",
    "dropname": "SPURGEON",
    "dropdeladd": "11430 S STATE ROAD 61",
    "dropdelcty": "SPURGEON",
    "dropdelst": "IN",
    "dropdelzpp": 475849998,
    "dropphyadd": "11430 S STATE ROAD 61",
    "dropphycty": "SPURGEON",
    "dropphyst": "IN",
    "dropphyzpp": 475849998,
    "dropmaladd": "11430 S STATE ROAD 61",
    "dropmalcty": "SPURGEON",
    "dropmalst": "IN",
    "dropmalzpp": 475849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8127212600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13745",
    "droptype": "D",
    "dropname": "STANFORD",
    "dropdeladd": "9048 W STATE ROAD 45",
    "dropdelcty": "STANFORD",
    "dropdelst": "IN",
    "dropdelzpp": 474639998,
    "dropphyadd": "9048 W STATE ROAD 45",
    "dropphycty": "STANFORD",
    "dropphyst": "IN",
    "dropphyzpp": 474639998,
    "dropmaladd": "9048 W STATE ROAD 45",
    "dropmalcty": "STANFORD",
    "dropmalst": "IN",
    "dropmalzpp": 474639998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128252230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13746",
    "droptype": "D",
    "dropname": "STAR CITY",
    "dropdeladd": "5800 S JUDSON ST",
    "dropdelcty": "STAR CITY",
    "dropdelst": "IN",
    "dropdelzpp": 469859998,
    "dropphyadd": "5800 S JUDSON ST",
    "dropphycty": "STAR CITY",
    "dropphyst": "IN",
    "dropphyzpp": 469859998,
    "dropmaladd": "5800 S JUDSON ST",
    "dropmalcty": "STAR CITY",
    "dropmalst": "IN",
    "dropmalzpp": 469859998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745957117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13750",
    "droptype": "D",
    "dropname": "STATE LINE",
    "dropdeladd": "112 E WOODARD ST",
    "dropdelcty": "STATE LINE",
    "dropdelst": "IN",
    "dropdelzpp": 479829998,
    "dropphyadd": "112 E WOODARD ST",
    "dropphycty": "STATE LINE",
    "dropphyst": "IN",
    "dropphyzpp": 479829998,
    "dropmaladd": "112 E WOODARD ST",
    "dropmalcty": "STATE LINE",
    "dropmalst": "IN",
    "dropmalzpp": 479829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657932181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13752",
    "droptype": "D",
    "dropname": "STAUNTON",
    "dropdeladd": "103 E COLUMBUS ST",
    "dropdelcty": "STAUNTON",
    "dropdelst": "IN",
    "dropdelzpp": 478819998,
    "dropphyadd": "103 E COLUMBUS ST",
    "dropphycty": "STAUNTON",
    "dropphyst": "IN",
    "dropphyzpp": 478819998,
    "dropmaladd": "103 E COLUMBUS ST",
    "dropmalcty": "STAUNTON",
    "dropmalst": "IN",
    "dropmalzpp": 478819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8124482198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13758",
    "droptype": "D",
    "dropname": "STENDAL",
    "dropdeladd": "10530 S WARRICK ST",
    "dropdelcty": "STENDAL",
    "dropdelst": "IN",
    "dropdelzpp": 475859998,
    "dropphyadd": "10530 S WARRICK ST",
    "dropphycty": "STENDAL",
    "dropphyst": "IN",
    "dropphyzpp": 475859998,
    "dropmaladd": "10530 S WARRICK ST",
    "dropmalcty": "STENDAL",
    "dropmalst": "IN",
    "dropmalzpp": 475859998,
    "dropsitphn": 3174646350,
    "dropsitlph": 8125364474,
    "dropsitcph": 8125364474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13762",
    "droptype": "D",
    "dropname": "STILESVILLE",
    "dropdeladd": "6075 W US HIGHWAY 40",
    "dropdelcty": "STILESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 461809998,
    "dropphyadd": "6075 W US HIGHWAY 40",
    "dropphycty": "STILESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 461809998,
    "dropmaladd": "6075 W US HIGHWAY 40",
    "dropmalcty": "STILESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 461809998,
    "dropsitphn": 3175396624,
    "dropsitlph": 3174646305,
    "dropsitcph": 3175396957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13770",
    "droptype": "D",
    "dropname": "STOCKWELL",
    "dropdeladd": "9000 COMMERCIAL ST",
    "dropdelcty": "STOCKWELL",
    "dropdelst": "IN",
    "dropdelzpp": 479839998,
    "dropphyadd": "9000 COMMERCIAL ST",
    "dropphycty": "STOCKWELL",
    "dropphyst": "IN",
    "dropphyzpp": 479839998,
    "dropmaladd": "9000 COMMERCIAL ST",
    "dropmalcty": "STOCKWELL",
    "dropmalst": "IN",
    "dropmalzpp": 479839998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655232007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13775",
    "droptype": "D",
    "dropname": "STRAUGHN",
    "dropdeladd": "5004 E US HIGHWAY 40",
    "dropdelcty": "STRAUGHN",
    "dropdelst": "IN",
    "dropdelzpp": 473879998,
    "dropphyadd": "5004 E US HIGHWAY 40",
    "dropphycty": "STRAUGHN",
    "dropphyst": "IN",
    "dropphyzpp": 473879998,
    "dropmaladd": "5004 E US HIGHWAY 40",
    "dropmalcty": "STRAUGHN",
    "dropmalst": "IN",
    "dropmalzpp": 473879998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653322193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13777",
    "droptype": "D",
    "dropname": "STROH",
    "dropdeladd": "4120 S 1175 E",
    "dropdelcty": "STROH",
    "dropdelst": "IN",
    "dropdelzpp": 467899998,
    "dropphyadd": "4120 S 1175 E",
    "dropphycty": "STROH",
    "dropphyst": "IN",
    "dropphyzpp": 467899998,
    "dropmaladd": "4120 S 1175 E",
    "dropmalcty": "STROH",
    "dropmalst": "IN",
    "dropmalzpp": 467899998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603513812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13781",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "103 E WASHINGTON ST",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "IN",
    "dropdelzpp": 478829998,
    "dropphyadd": "103 E WASHINGTON ST",
    "dropphycty": "SULLIVAN",
    "dropphyst": "IN",
    "dropphyzpp": 478829998,
    "dropmaladd": "103 E WASHINGTON ST",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "IN",
    "dropmalzpp": 478829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122684091,
    "dropfax": 8122684779
  },
  {
    "dcode": "D",
    "dropkey": "PX13786",
    "droptype": "D",
    "dropname": "SULPHUR SPRINGS",
    "dropdeladd": "105 N MERIDIAN ST",
    "dropdelcty": "SULPHUR SPRINGS",
    "dropdelst": "IN",
    "dropdelzpp": 473889998,
    "dropphyadd": "105 N MERIDIAN ST",
    "dropphycty": "SULPHUR SPRINGS",
    "dropphyst": "IN",
    "dropphyzpp": 473889998,
    "dropmaladd": "105 N MERIDIAN ST",
    "dropmalcty": "SULPHUR SPRINGS",
    "dropmalst": "IN",
    "dropmalzpp": 473889998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655334184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13787",
    "droptype": "D",
    "dropname": "SUMAVA RESORTS",
    "dropdeladd": "11479 N 250 W",
    "dropdelcty": "SUMAVA RESORTS",
    "dropdelst": "IN",
    "dropdelzpp": 463799998,
    "dropphyadd": "11479 N 250 W",
    "dropphycty": "SUMAVA RESORTS",
    "dropphyst": "IN",
    "dropphyzpp": 463799998,
    "dropmaladd": "11479 N 250 W",
    "dropmalcty": "SUMAVA RESORTS",
    "dropmalst": "IN",
    "dropmalzpp": 463799998,
    "dropsitphn": 2199922520,
    "dropsitlph": 2199922520,
    "dropsitcph": 2199922520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13791",
    "droptype": "D",
    "dropname": "SUMMITVILLE",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "SUMMITVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460709998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "SUMMITVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460709998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "SUMMITVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655362818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13794",
    "droptype": "D",
    "dropname": "SUNMAN",
    "dropdeladd": "219 N MERIDIAN ST",
    "dropdelcty": "SUNMAN",
    "dropdelst": "IN",
    "dropdelzpp": 470419998,
    "dropphyadd": "219 N MERIDIAN ST",
    "dropphycty": "SUNMAN",
    "dropphyst": "IN",
    "dropphyzpp": 470419998,
    "dropmaladd": "219 N MERIDIAN ST",
    "dropmalcty": "SUNMAN",
    "dropmalst": "IN",
    "dropmalzpp": 470419998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8123088448,
    "dropsitcph": 8123088448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13801",
    "droptype": "D",
    "dropname": "SWAYZEE",
    "dropdeladd": "111 N WASHINGTON ST",
    "dropdelcty": "SWAYZEE",
    "dropdelst": "IN",
    "dropdelzpp": 469869998,
    "dropphyadd": "111 N WASHINGTON ST",
    "dropphycty": "SWAYZEE",
    "dropphyst": "IN",
    "dropphyzpp": 469869998,
    "dropmaladd": "111 N WASHINGTON ST",
    "dropmalcty": "SWAYZEE",
    "dropmalst": "IN",
    "dropmalzpp": 469869998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659224553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13802",
    "droptype": "D",
    "dropname": "SWEETSER",
    "dropdeladd": "111 W GREENBURG ST",
    "dropdelcty": "SWEETSER",
    "dropdelst": "IN",
    "dropdelzpp": 469879998,
    "dropphyadd": "111 W GREENBURG ST",
    "dropphycty": "SWEETSER",
    "dropphyst": "IN",
    "dropphyzpp": 469879998,
    "dropmaladd": "111 W GREENBURG ST",
    "dropmalcty": "SWEETSER",
    "dropmalst": "IN",
    "dropmalzpp": 469879998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7653845149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13803",
    "droptype": "D",
    "dropname": "SWITZ CITY",
    "dropdeladd": "230 CHARLOTTE AVE",
    "dropdelcty": "SWITZ CITY",
    "dropdelst": "IN",
    "dropdelzpp": 474659998,
    "dropphyadd": "230 CHARLOTTE AVE",
    "dropphycty": "SWITZ CITY",
    "dropphyst": "IN",
    "dropphyzpp": 474659998,
    "dropmaladd": "230 CHARLOTTE AVE",
    "dropmalcty": "SWITZ CITY",
    "dropmalst": "IN",
    "dropmalzpp": 474659998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8126593549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13809",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "1010 N INDIANA AVE",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "IN",
    "dropdelzpp": 465679998,
    "dropphyadd": "1010 N INDIANA AVE",
    "dropphycty": "SYRACUSE",
    "dropphyst": "IN",
    "dropphyzpp": 465679998,
    "dropmaladd": "1010 N INDIANA AVE",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "IN",
    "dropmalzpp": 465679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5744573424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13820",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "9427 MAIN ST",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 472809998,
    "dropphyadd": "9427 MAIN ST",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 472809998,
    "dropmaladd": "9427 MAIN ST",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 472809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125266775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13825",
    "droptype": "D",
    "dropname": "TELL CITY",
    "dropdeladd": "444 MAIN ST",
    "dropdelcty": "TELL CITY",
    "dropdelst": "IN",
    "dropdelzpp": 475869998,
    "dropphyadd": "444 MAIN ST",
    "dropphycty": "TELL CITY",
    "dropphyst": "IN",
    "dropphyzpp": 475869998,
    "dropmaladd": "444 MAIN ST",
    "dropmalcty": "TELL CITY",
    "dropmalst": "IN",
    "dropmalzpp": 475869998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125473831,
    "dropfax": 8125476141
  },
  {
    "dcode": "D",
    "dropkey": "PX13831",
    "droptype": "D",
    "dropname": "TENNYSON",
    "dropdeladd": "124 S MAIN ST",
    "dropdelcty": "TENNYSON",
    "dropdelst": "IN",
    "dropdelzpp": 476379998,
    "dropphyadd": "124 S MAIN ST",
    "dropphycty": "TENNYSON",
    "dropphyst": "IN",
    "dropphyzpp": 476379998,
    "dropmaladd": "124 S MAIN ST",
    "dropmalcty": "TENNYSON",
    "dropmalst": "IN",
    "dropmalzpp": 476379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8125674736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13834",
    "droptype": "D",
    "dropname": "TERRE HAUTE",
    "dropdeladd": "150 W MARGARET DR",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478029997,
    "dropphyadd": "150 W MARGARET DR",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478029998,
    "dropmaladd": "150 W MARGARET DR",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478029998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122314040,
    "dropfax": 8122314140
  },
  {
    "dcode": "D",
    "dropkey": "PX13838",
    "droptype": "D",
    "dropname": "THORNTOWN",
    "dropdeladd": "200 N MARKET ST",
    "dropdelcty": "THORNTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 460719998,
    "dropphyadd": "200 N MARKET ST",
    "dropphycty": "THORNTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 460719998,
    "dropmaladd": "200 N MARKET ST",
    "dropmalcty": "THORNTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 460719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654367241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13847",
    "droptype": "D",
    "dropname": "TIPPECANOE",
    "dropdeladd": "18436 STATE ROAD 331",
    "dropdelcty": "TIPPECANOE",
    "dropdelst": "IN",
    "dropdelzpp": 465709998,
    "dropphyadd": "18436 STATE ROAD 331",
    "dropphycty": "TIPPECANOE",
    "dropphyst": "IN",
    "dropphyzpp": 465709998,
    "dropmaladd": "18436 STATE ROAD 331",
    "dropmalcty": "TIPPECANOE",
    "dropmalst": "IN",
    "dropmalzpp": 465709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5744986622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13848",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "203 E JEFFERSON ST",
    "dropdelcty": "TIPTON",
    "dropdelst": "IN",
    "dropdelzpp": 460729998,
    "dropphyadd": "203 E JEFFERSON ST",
    "dropphycty": "TIPTON",
    "dropphyst": "IN",
    "dropphyzpp": 460729998,
    "dropmaladd": "203 E JEFFERSON ST",
    "dropmalcty": "TIPTON",
    "dropmalst": "IN",
    "dropmalzpp": 460729998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656754124,
    "dropfax": 7656752314
  },
  {
    "dcode": "D",
    "dropkey": "PX13858",
    "droptype": "D",
    "dropname": "TOPEKA",
    "dropdeladd": "129 E LAKE ST",
    "dropdelcty": "TOPEKA",
    "dropdelst": "IN",
    "dropdelzpp": 465719998,
    "dropphyadd": "129 E LAKE ST",
    "dropphycty": "TOPEKA",
    "dropphyst": "IN",
    "dropphyzpp": 465719998,
    "dropmaladd": "129 E LAKE ST",
    "dropmalcty": "TOPEKA",
    "dropmalst": "IN",
    "dropmalzpp": 465719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605932199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13862",
    "droptype": "D",
    "dropname": "TRAFALGAR",
    "dropdeladd": "105 E OHIO ST",
    "dropdelcty": "TRAFALGAR",
    "dropdelst": "IN",
    "dropdelzpp": 461819998,
    "dropphyadd": "105 E OHIO ST",
    "dropphycty": "TRAFALGAR",
    "dropphyst": "IN",
    "dropphyzpp": 461819998,
    "dropmaladd": "105 E OHIO ST",
    "dropmalcty": "TRAFALGAR",
    "dropmalst": "IN",
    "dropmalzpp": 461819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178784300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13872",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "335 MAIN ST",
    "dropdelcty": "TROY",
    "dropdelst": "IN",
    "dropdelzpp": 475889998,
    "dropphyadd": "335 MAIN ST",
    "dropphycty": "TROY",
    "dropphyst": "IN",
    "dropphyzpp": 475889998,
    "dropmaladd": "335 MAIN ST",
    "dropmalcty": "TROY",
    "dropmalst": "IN",
    "dropmalzpp": 475889998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125474758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13875",
    "droptype": "D",
    "dropname": "TUNNELTON",
    "dropdeladd": "45 SENECA ST",
    "dropdelcty": "TUNNELTON",
    "dropdelst": "IN",
    "dropdelzpp": 474679998,
    "dropphyadd": "45 SENECA ST",
    "dropphycty": "TUNNELTON",
    "dropphyst": "IN",
    "dropphyzpp": 474679998,
    "dropmaladd": "45 SENECA ST",
    "dropmalcty": "TUNNELTON",
    "dropmalst": "IN",
    "dropmalzpp": 474679998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128496405,
    "dropfax": 8128494570
  },
  {
    "dcode": "D",
    "dropkey": "PX13878",
    "droptype": "D",
    "dropname": "TWELVE MILE",
    "dropdeladd": "8051 E STATE ROAD 16",
    "dropdelcty": "TWELVE MILE",
    "dropdelst": "IN",
    "dropdelzpp": 469889998,
    "dropphyadd": "8051 E STATE ROAD 16",
    "dropphycty": "TWELVE MILE",
    "dropphyst": "IN",
    "dropphyzpp": 469889998,
    "dropmaladd": "8051 E STATE ROAD 16",
    "dropmalcty": "TWELVE MILE",
    "dropmalst": "IN",
    "dropmalzpp": 469889998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746643331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13888",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "102 W PEARL ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "IN",
    "dropdelzpp": 473909998,
    "dropphyadd": "102 W PEARL ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "IN",
    "dropphyzpp": 473909998,
    "dropmaladd": "102 W PEARL ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "IN",
    "dropmalzpp": 473909998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659645818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13891",
    "droptype": "D",
    "dropname": "UNION MILLS",
    "dropdeladd": "609 WATER ST",
    "dropdelcty": "UNION MILLS",
    "dropdelst": "IN",
    "dropdelzpp": 463829998,
    "dropphyadd": "609 WATER ST",
    "dropphycty": "UNION MILLS",
    "dropphyst": "IN",
    "dropphyzpp": 463829998,
    "dropmaladd": "609 WATER ST",
    "dropmalcty": "UNION MILLS",
    "dropmalst": "IN",
    "dropmalzpp": 463829998,
    "dropsitphn": 2197672952,
    "dropsitlph": 2197672952,
    "dropsitcph": 2197672952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13893",
    "droptype": "D",
    "dropname": "UNIONDALE",
    "dropdeladd": "5965 N MAIN ST",
    "dropdelcty": "UNIONDALE",
    "dropdelst": "IN",
    "dropdelzpp": 467919998,
    "dropphyadd": "5965 N MAIN ST",
    "dropphycty": "UNIONDALE",
    "dropphyst": "IN",
    "dropphyzpp": 467919998,
    "dropmaladd": "5965 N MAIN ST",
    "dropmalcty": "UNIONDALE",
    "dropmalst": "IN",
    "dropmalzpp": 467919998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605432255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13897",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "8031 E STATE ROAD 45",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 474689998,
    "dropphyadd": "8031 E STATE ROAD 45",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 474689998,
    "dropmaladd": "8031 E STATE ROAD 45",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 474689998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123340382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13900",
    "droptype": "D",
    "dropname": "UNIVERSAL",
    "dropdeladd": "552 E WOOD AVE",
    "dropdelcty": "UNIVERSAL",
    "dropdelst": "IN",
    "dropdelzpp": 478849998,
    "dropphyadd": "552 E WOOD AVE",
    "dropphycty": "UNIVERSAL",
    "dropphyst": "IN",
    "dropphyzpp": 478849998,
    "dropmaladd": "552 E WOOD AVE",
    "dropmalcty": "UNIVERSAL",
    "dropmalst": "IN",
    "dropmalzpp": 478849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658327626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13902",
    "droptype": "D",
    "dropname": "UPLAND",
    "dropdeladd": "222 N MAIN ST",
    "dropdelcty": "UPLAND",
    "dropdelst": "IN",
    "dropdelzpp": 469899998,
    "dropphyadd": "222 N MAIN ST",
    "dropphycty": "UPLAND",
    "dropphyst": "IN",
    "dropphyzpp": 469899998,
    "dropmaladd": "222 N MAIN ST",
    "dropmalcty": "UPLAND",
    "dropmalst": "IN",
    "dropmalzpp": 469899998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659982092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13905",
    "droptype": "D",
    "dropname": "URBANA",
    "dropdeladd": "80 E MILL ST",
    "dropdelcty": "URBANA",
    "dropdelst": "IN",
    "dropdelzpp": 469909998,
    "dropphyadd": "80 E MILL ST",
    "dropphycty": "URBANA",
    "dropphyst": "IN",
    "dropphyzpp": 469909998,
    "dropmaladd": "80 E MILL ST",
    "dropmalcty": "URBANA",
    "dropmalst": "IN",
    "dropmalzpp": 469909998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607743366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13911",
    "droptype": "D",
    "dropname": "VALLONIA",
    "dropdeladd": "2380 S MAIN ST",
    "dropdelcty": "VALLONIA",
    "dropdelst": "IN",
    "dropdelzpp": 472819998,
    "dropphyadd": "2380 S MAIN ST",
    "dropphycty": "VALLONIA",
    "dropphyst": "IN",
    "dropphyzpp": 472819998,
    "dropmaladd": "2380 S MAIN ST",
    "dropmalcty": "VALLONIA",
    "dropmalst": "IN",
    "dropmalzpp": 472819998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123583291,
    "dropfax": 6514566457
  },
  {
    "dcode": "D",
    "dropkey": "PX13912",
    "droptype": "D",
    "dropname": "VALPARAISO",
    "dropdeladd": "2700 VALPARAISO ST",
    "dropdelcty": "VALPARAISO",
    "dropdelst": "IN",
    "dropdelzpp": 463839998,
    "dropphyadd": "2700 VALPARAISO ST",
    "dropphycty": "VALPARAISO",
    "dropphyst": "IN",
    "dropphyzpp": 463839998,
    "dropmaladd": "2700 VALPARAISO ST",
    "dropmalcty": "VALPARAISO",
    "dropmalst": "IN",
    "dropmalzpp": 463839998,
    "dropsitphn": 2194622180,
    "dropsitlph": 3174646350,
    "dropsitcph": 2194622180,
    "dropfax": 2195315435
  },
  {
    "dcode": "D",
    "dropkey": "PX13918",
    "droptype": "D",
    "dropname": "VAN BUREN",
    "dropdeladd": "113 E MAIN ST",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "IN",
    "dropdelzpp": 469919998,
    "dropphyadd": "113 E MAIN ST",
    "dropphycty": "VAN BUREN",
    "dropphyst": "IN",
    "dropphyzpp": 469919998,
    "dropmaladd": "113 E MAIN ST",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "IN",
    "dropmalzpp": 469919998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659343381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13922",
    "droptype": "D",
    "dropname": "VEEDERSBURG",
    "dropdeladd": "220 N MAIN ST",
    "dropdelcty": "VEEDERSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 479879998,
    "dropphyadd": "220 N MAIN ST",
    "dropphycty": "VEEDERSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 479879998,
    "dropmaladd": "220 N MAIN ST",
    "dropmalcty": "VEEDERSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 479879998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652942239,
    "dropfax": 7652942302
  },
  {
    "dcode": "D",
    "dropkey": "PX13923",
    "droptype": "D",
    "dropname": "VELPEN",
    "dropdeladd": "4495 S THIRD ST",
    "dropdelcty": "VELPEN",
    "dropdelst": "IN",
    "dropdelzpp": 475909998,
    "dropphyadd": "4495 S THIRD ST",
    "dropphycty": "VELPEN",
    "dropphyst": "IN",
    "dropphyzpp": 475909998,
    "dropmaladd": "4495 S THIRD ST",
    "dropmalcty": "VELPEN",
    "dropmalst": "IN",
    "dropmalzpp": 475909998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123546031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13927",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "55 N PIKE ST",
    "dropdelcty": "VERNON",
    "dropdelst": "IN",
    "dropdelzpp": 472829998,
    "dropphyadd": "55 N PIKE ST",
    "dropphycty": "VERNON",
    "dropphyst": "IN",
    "dropphyzpp": 472829998,
    "dropmaladd": "55 N PIKE ST",
    "dropmalcty": "VERNON",
    "dropmalst": "IN",
    "dropmalzpp": 472829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123468020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13928",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "121 S WASHINGTON ST",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "IN",
    "dropdelzpp": 470429998,
    "dropphyadd": "121 S WASHINGTON ST",
    "dropphycty": "VERSAILLES",
    "dropphyst": "IN",
    "dropphyzpp": 470429998,
    "dropmaladd": "121 S WASHINGTON ST",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "IN",
    "dropmalzpp": 470429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8126896123,
    "dropsitcph": 8126896123,
    "dropfax": 8126896123
  },
  {
    "dcode": "D",
    "dropkey": "PX13929",
    "droptype": "D",
    "dropname": "VEVAY",
    "dropdeladd": "104 W PIKE ST",
    "dropdelcty": "VEVAY",
    "dropdelst": "IN",
    "dropdelzpp": 470439998,
    "dropphyadd": "104 W PIKE ST",
    "dropphycty": "VEVAY",
    "dropphyst": "IN",
    "dropphyzpp": 470439998,
    "dropmaladd": "104 W PIKE ST",
    "dropmalcty": "VEVAY",
    "dropmalst": "IN",
    "dropmalzpp": 470439998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8124279791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13937",
    "droptype": "D",
    "dropname": "VINCENNES",
    "dropdeladd": "420 BROADWAY ST",
    "dropdelcty": "VINCENNES",
    "dropdelst": "IN",
    "dropdelzpp": 475919998,
    "dropphyadd": "420 BROADWAY ST",
    "dropphycty": "VINCENNES",
    "dropphyst": "IN",
    "dropphyzpp": 475919998,
    "dropmaladd": "420 BROADWAY ST",
    "dropmalcty": "VINCENNES",
    "dropmalst": "IN",
    "dropmalzpp": 475919998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128822331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13949",
    "droptype": "D",
    "dropname": "WABASH",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "WABASH",
    "dropdelst": "IN",
    "dropdelzpp": 469929998,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "WABASH",
    "dropphyst": "IN",
    "dropphyzpp": 469929998,
    "dropmaladd": "111 W MAIN ST",
    "dropmalcty": "WABASH",
    "dropmalst": "IN",
    "dropmalzpp": 469929998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2605633258,
    "dropfax": 2605690308
  },
  {
    "dcode": "D",
    "dropkey": "PX13950",
    "droptype": "D",
    "dropname": "WADESVILLE",
    "dropdeladd": "7255 MAIN ST",
    "dropdelcty": "WADESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 476389998,
    "dropphyadd": "7255 MAIN ST",
    "dropphycty": "WADESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 476389998,
    "dropmaladd": "7255 MAIN ST",
    "dropmalcty": "WADESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 476389998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8126734681,
    "dropfax": 8126734860
  },
  {
    "dcode": "D",
    "dropkey": "PX13953",
    "droptype": "D",
    "dropname": "WAKARUSA",
    "dropdeladd": "111 S ELKHART ST",
    "dropdelcty": "WAKARUSA",
    "dropdelst": "IN",
    "dropdelzpp": 465739998,
    "dropphyadd": "111 S ELKHART ST",
    "dropphycty": "WAKARUSA",
    "dropphyst": "IN",
    "dropphyzpp": 465739998,
    "dropmaladd": "111 S ELKHART ST",
    "dropmalcty": "WAKARUSA",
    "dropmalst": "IN",
    "dropmalzpp": 465739998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5748622010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13956",
    "droptype": "D",
    "dropname": "WALDRON",
    "dropdeladd": "108 E WASHINGTON ST",
    "dropdelcty": "WALDRON",
    "dropdelst": "IN",
    "dropdelzpp": 461829998,
    "dropphyadd": "108 E WASHINGTON ST",
    "dropphycty": "WALDRON",
    "dropphyst": "IN",
    "dropphyzpp": 461829998,
    "dropmaladd": "108 E WASHINGTON ST",
    "dropmalcty": "WALDRON",
    "dropmalst": "IN",
    "dropmalzpp": 461829998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655256040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13959",
    "droptype": "D",
    "dropname": "WALKERTON",
    "dropdeladd": "620 VAN BUREN ST",
    "dropdelcty": "WALKERTON",
    "dropdelst": "IN",
    "dropdelzpp": 465749998,
    "dropphyadd": "620 VAN BUREN ST",
    "dropphycty": "WALKERTON",
    "dropphyst": "IN",
    "dropphyzpp": 465749998,
    "dropmaladd": "620 VAN BUREN ST",
    "dropmalcty": "WALKERTON",
    "dropmalst": "IN",
    "dropmalzpp": 465749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5745863213,
    "dropfax": 5745863216
  },
  {
    "dcode": "D",
    "dropkey": "PX13965",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "107 N DEPOT ST",
    "dropdelcty": "WALTON",
    "dropdelst": "IN",
    "dropdelzpp": 469949998,
    "dropphyadd": "107 N DEPOT ST",
    "dropphycty": "WALTON",
    "dropphyst": "IN",
    "dropphyzpp": 469949998,
    "dropmaladd": "107 N DEPOT ST",
    "dropmalcty": "WALTON",
    "dropmalst": "IN",
    "dropmalzpp": 469949998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746262742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13967",
    "droptype": "D",
    "dropname": "WANATAH",
    "dropdeladd": "104 S ILLINOIS ST",
    "dropdelcty": "WANATAH",
    "dropdelst": "IN",
    "dropdelzpp": 463909998,
    "dropphyadd": "104 S ILLINOIS ST",
    "dropphycty": "WANATAH",
    "dropphyst": "IN",
    "dropphyzpp": 463909998,
    "dropmaladd": "104 S ILLINOIS ST",
    "dropmalcty": "WANATAH",
    "dropmalst": "IN",
    "dropmalzpp": 463909998,
    "dropsitphn": 2197332211,
    "dropsitlph": 2197332211,
    "dropsitcph": 2197332211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13969",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "110 E 1ST ST",
    "dropdelcty": "WARREN",
    "dropdelst": "IN",
    "dropdelzpp": 467929998,
    "dropphyadd": "110 E 1ST ST",
    "dropphycty": "WARREN",
    "dropphyst": "IN",
    "dropphyzpp": 467929998,
    "dropmaladd": "110 E 1ST ST",
    "dropmalcty": "WARREN",
    "dropmalst": "IN",
    "dropmalzpp": 467929998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2603752422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13972",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "365 W MARKET ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "IN",
    "dropdelzpp": 465809998,
    "dropphyadd": "365 W MARKET ST",
    "dropphycty": "WARSAW",
    "dropphyst": "IN",
    "dropphyzpp": 465809998,
    "dropmaladd": "365 W MARKET ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "IN",
    "dropmalzpp": 465809998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742677321,
    "dropfax": 5742696931
  },
  {
    "dcode": "D",
    "dropkey": "PX13990",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "405 CENTER ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 475019998,
    "dropphyadd": "405 CENTER ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 475019998,
    "dropmaladd": "405 CENTER ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 475019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122540011,
    "dropfax": 8122546405
  },
  {
    "dcode": "D",
    "dropkey": "PX13993",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "180 W MARION ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "IN",
    "dropdelzpp": 467939998,
    "dropphyadd": "180 W MARION ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "IN",
    "dropphyzpp": 467939998,
    "dropmaladd": "180 W MARION ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "IN",
    "dropmalzpp": 467939998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608372981,
    "dropfax": 2608378916
  },
  {
    "dcode": "D",
    "dropkey": "PX13996",
    "droptype": "D",
    "dropname": "WAVELAND",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "WAVELAND",
    "dropdelst": "IN",
    "dropdelzpp": 479899998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "WAVELAND",
    "dropphyst": "IN",
    "dropphyzpp": 479899998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "WAVELAND",
    "dropmalst": "IN",
    "dropmalzpp": 479899998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654352090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX13998",
    "droptype": "D",
    "dropname": "WAWAKA",
    "dropdeladd": "7369 N ALBION ST",
    "dropdelcty": "WAWAKA",
    "dropdelst": "IN",
    "dropdelzpp": 467949998,
    "dropphyadd": "7369 N ALBION ST",
    "dropphycty": "WAWAKA",
    "dropphyst": "IN",
    "dropphyzpp": 467949998,
    "dropmaladd": "7369 N ALBION ST",
    "dropmalcty": "WAWAKA",
    "dropmalst": "IN",
    "dropmalzpp": 467949998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2607612601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14005",
    "droptype": "D",
    "dropname": "WAYNETOWN",
    "dropdeladd": "104 E WASHINGTON ST",
    "dropdelcty": "WAYNETOWN",
    "dropdelst": "IN",
    "dropdelzpp": 479909998,
    "dropphyadd": "104 E WASHINGTON ST",
    "dropphycty": "WAYNETOWN",
    "dropphyst": "IN",
    "dropphyzpp": 479909998,
    "dropmaladd": "104 E WASHINGTON ST",
    "dropmalcty": "WAYNETOWN",
    "dropmalst": "IN",
    "dropmalzpp": 479909998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652342070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14007",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "3231 WEBSTER RD",
    "dropdelcty": "WEBSTER",
    "dropdelst": "IN",
    "dropdelzpp": 473929998,
    "dropphyadd": "3231 WEBSTER RD",
    "dropphycty": "WEBSTER",
    "dropphyst": "IN",
    "dropphyzpp": 473929998,
    "dropmaladd": "3231 WEBSTER RD",
    "dropmalcty": "WEBSTER",
    "dropmalst": "IN",
    "dropmalzpp": 473929998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659664180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14012",
    "droptype": "D",
    "dropname": "WEST BADEN SPRINGS",
    "dropdeladd": "8182 W STATE ROAD 56",
    "dropdelcty": "WEST BADEN SPRINGS",
    "dropdelst": "IN",
    "dropdelzpp": 474699998,
    "dropphyadd": "8182 W STATE ROAD 56",
    "dropphycty": "WEST BADEN SPRINGS",
    "dropphyst": "IN",
    "dropphyzpp": 474699998,
    "dropmaladd": "8182 W STATE ROAD 56",
    "dropmalcty": "WEST BADEN SPRINGS",
    "dropmalst": "IN",
    "dropmalzpp": 474699998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8129369834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14016",
    "droptype": "D",
    "dropname": "WEST HARRISON",
    "dropdeladd": "420 S STATE ST",
    "dropdelcty": "HARRISON",
    "dropdelst": "OH",
    "dropdelzpp": 450309998,
    "dropphyadd": "420 S STATE ST",
    "dropphycty": "HARRISON",
    "dropphyst": "OH",
    "dropphyzpp": 450309998,
    "dropmaladd": "420 S STATE ST",
    "dropmalcty": "HARRISON",
    "dropmalst": "OH",
    "dropmalzpp": 450309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133674668,
    "dropsitcph": 5133674668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14020",
    "droptype": "D",
    "dropname": "WEST LEBANON",
    "dropdeladd": "106 HIGH ST",
    "dropdelcty": "WEST LEBANON",
    "dropdelst": "IN",
    "dropdelzpp": 479919998,
    "dropphyadd": "106 HIGH ST",
    "dropphycty": "WEST LEBANON",
    "dropphyst": "IN",
    "dropphyzpp": 479919998,
    "dropmaladd": "106 HIGH ST",
    "dropmalcty": "WEST LEBANON",
    "dropmalst": "IN",
    "dropmalzpp": 479919998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658934040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14025",
    "droptype": "D",
    "dropname": "WEST NEWTON",
    "dropdeladd": "7636 MOORESVILLE RD",
    "dropdelcty": "WEST NEWTON",
    "dropdelst": "IN",
    "dropdelzpp": 461839998,
    "dropphyadd": "7636 MOORESVILLE RD",
    "dropphycty": "WEST NEWTON",
    "dropphyst": "IN",
    "dropphyzpp": 461839998,
    "dropmaladd": "7636 MOORESVILLE RD",
    "dropmalcty": "WEST NEWTON",
    "dropmalst": "IN",
    "dropmalzpp": 461839998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178567036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14027",
    "droptype": "D",
    "dropname": "WEST TERRE HAUTE",
    "dropdeladd": "29 S 3RD ST",
    "dropdelcty": "WEST TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478859998,
    "dropphyadd": "29 S 3RD ST",
    "dropphycty": "WEST TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478859998,
    "dropmaladd": "29 S 3RD ST",
    "dropmalcty": "WEST TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478859998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125332040,
    "dropfax": 8125331969
  },
  {
    "dcode": "D",
    "dropkey": "PX14031",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "17520 DARTOWN RD",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 460749998,
    "dropphyadd": "17520 DARTOWN RD",
    "dropphycty": "WESTFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 460749998,
    "dropmaladd": "17520 DARTOWN RD",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 460749998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178962741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14033",
    "droptype": "D",
    "dropname": "WESTPHALIA",
    "dropdeladd": "12747 HIGHWAY 67",
    "dropdelcty": "WESTPHALIA",
    "dropdelst": "IN",
    "dropdelzpp": 475969998,
    "dropphyadd": "12747 HIGHWAY 67",
    "dropphycty": "WESTPHALIA",
    "dropphyst": "IN",
    "dropphyzpp": 475969998,
    "dropmaladd": "12747 HIGHWAY 67",
    "dropmalcty": "WESTPHALIA",
    "dropmalst": "IN",
    "dropmalzpp": 475969998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646405,
    "dropsitcph": 8126948407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14034",
    "droptype": "D",
    "dropname": "WESTPOINT",
    "dropdeladd": "4920 WASHINGTON ST",
    "dropdelcty": "WESTPOINT",
    "dropdelst": "IN",
    "dropdelzpp": 479929998,
    "dropphyadd": "4920 WASHINGTON ST",
    "dropphycty": "WESTPOINT",
    "dropphyst": "IN",
    "dropphyzpp": 479929998,
    "dropmaladd": "4920 WASHINGTON ST",
    "dropmalcty": "WESTPOINT",
    "dropmalst": "IN",
    "dropmalzpp": 479929998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655722434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14035",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "211 E MAIN ST",
    "dropdelcty": "WESTPORT",
    "dropdelst": "IN",
    "dropdelzpp": 472839998,
    "dropphyadd": "211 E MAIN ST",
    "dropphycty": "WESTPORT",
    "dropphyst": "IN",
    "dropphyzpp": 472839998,
    "dropmaladd": "211 E MAIN ST",
    "dropmalcty": "WESTPORT",
    "dropmalst": "IN",
    "dropmalzpp": 472839998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8125913310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14038",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "201 PLAIN ST",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 463910076,
    "dropphyadd": "201 PLAIN ST",
    "dropphycty": "WESTVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 463910076,
    "dropmaladd": "201 PLAIN ST",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 463910076,
    "dropsitphn": 2197852224,
    "dropsitlph": 2197852224,
    "dropsitcph": 2197852224,
    "dropfax": 2197852002
  },
  {
    "dcode": "D",
    "dropkey": "PX14043",
    "droptype": "D",
    "dropname": "WHEATFIELD",
    "dropdeladd": "497 S BIERMA ST",
    "dropdelcty": "WHEATFIELD",
    "dropdelst": "IN",
    "dropdelzpp": 463926005,
    "dropphyadd": "497 S BIERMA ST",
    "dropphycty": "WHEATFIELD",
    "dropphyst": "IN",
    "dropphyzpp": 463926005,
    "dropmaladd": "497 S BIERMA ST",
    "dropmalcty": "WHEATFIELD",
    "dropmalst": "IN",
    "dropmalzpp": 463926005,
    "dropsitphn": 2199563761,
    "dropsitlph": 2199563761,
    "dropsitcph": 2199563761,
    "dropfax": 2199563792
  },
  {
    "dcode": "D",
    "dropkey": "PX14045",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "123 W MAIN ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "IN",
    "dropdelzpp": 475979998,
    "dropphyadd": "123 W MAIN ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "IN",
    "dropphyzpp": 475979998,
    "dropmaladd": "123 W MAIN ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "IN",
    "dropmalzpp": 475979998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123213111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14047",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "305 RAILROAD AVE",
    "dropdelcty": "WHEELER",
    "dropdelst": "IN",
    "dropdelzpp": 463939998,
    "dropphyadd": "305 RAILROAD AVE",
    "dropphycty": "WHEELER",
    "dropphyst": "IN",
    "dropphyzpp": 463939998,
    "dropmaladd": "305 RAILROAD AVE",
    "dropmalcty": "WHEELER",
    "dropmalst": "IN",
    "dropmalzpp": 463939998,
    "dropsitphn": 2197594711,
    "dropsitlph": 3174646350,
    "dropsitcph": 2197594711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14057",
    "droptype": "D",
    "dropname": "WHITELAND",
    "dropdeladd": "510 E MAIN ST",
    "dropdelcty": "WHITELAND",
    "dropdelst": "IN",
    "dropdelzpp": 461849998,
    "dropphyadd": "510 E MAIN ST",
    "dropphycty": "WHITELAND",
    "dropphyst": "IN",
    "dropphyzpp": 461849998,
    "dropmaladd": "510 E MAIN ST",
    "dropmalcty": "WHITELAND",
    "dropmalst": "IN",
    "dropmalzpp": 461849998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3175357538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14061",
    "droptype": "D",
    "dropname": "WHITESTOWN",
    "dropdeladd": "110 PORTER AVE",
    "dropdelcty": "WHITESTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 460759998,
    "dropphyadd": "110 PORTER AVE",
    "dropphycty": "WHITESTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 460759998,
    "dropmaladd": "110 PORTER AVE",
    "dropmalcty": "WHITESTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 460759998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3177696430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14065",
    "droptype": "D",
    "dropname": "WHITING",
    "dropdeladd": "1501 119TH ST",
    "dropdelcty": "WHITING",
    "dropdelst": "IN",
    "dropdelzpp": 463949998,
    "dropphyadd": "1501 119TH ST",
    "dropphycty": "WHITING",
    "dropphyst": "IN",
    "dropphyzpp": 463949998,
    "dropmaladd": "1501 119TH ST",
    "dropmalcty": "WHITING",
    "dropmalst": "IN",
    "dropmalzpp": 463949998,
    "dropsitphn": 2196590593,
    "dropsitlph": 2196590593,
    "dropsitcph": 2196590593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14072",
    "droptype": "D",
    "dropname": "WILKINSON",
    "dropdeladd": "145 S MAIN ST",
    "dropdelcty": "WILKINSON",
    "dropdelst": "IN",
    "dropdelzpp": 461869998,
    "dropphyadd": "145 S MAIN ST",
    "dropphycty": "WILKINSON",
    "dropphyst": "IN",
    "dropphyzpp": 461869998,
    "dropmaladd": "145 S MAIN ST",
    "dropmalcty": "WILKINSON",
    "dropmalst": "IN",
    "dropmalzpp": 461869998,
    "dropsitphn": 7653455575,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657852206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14074",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "61 KERN ST",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "IN",
    "dropdelzpp": 474709998,
    "dropphyadd": "61 KERN ST",
    "dropphycty": "WILLIAMS",
    "dropphyst": "IN",
    "dropphyzpp": 474709998,
    "dropmaladd": "61 KERN ST",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "IN",
    "dropmalzpp": 474709998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123887181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14076",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "8293 MAIN ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "IN",
    "dropdelzpp": 473939998,
    "dropphyadd": "8293 MAIN ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "IN",
    "dropphyzpp": 473939998,
    "dropmaladd": "8293 MAIN ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "IN",
    "dropmalzpp": 473939998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7658866085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14077",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "115 E 2ND ST",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "IN",
    "dropdelzpp": 479939998,
    "dropphyadd": "115 E 2ND ST",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "IN",
    "dropphyzpp": 479939998,
    "dropmaladd": "115 E 2ND ST",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "IN",
    "dropmalzpp": 479939998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657623633,
    "dropfax": 7657620256
  },
  {
    "dcode": "D",
    "dropkey": "PX14088",
    "droptype": "D",
    "dropname": "WINAMAC",
    "dropdeladd": "209 E PEARL ST",
    "dropdelcty": "WINAMAC",
    "dropdelst": "IN",
    "dropdelzpp": 469969998,
    "dropphyadd": "209 E PEARL ST",
    "dropphycty": "WINAMAC",
    "dropphyst": "IN",
    "dropphyzpp": 469969998,
    "dropmaladd": "209 E PEARL ST",
    "dropmalcty": "WINAMAC",
    "dropmalst": "IN",
    "dropmalzpp": 469969998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5749463743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14089",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "130 N MERIDIAN ST",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "IN",
    "dropdelzpp": 473949998,
    "dropphyadd": "130 N MERIDIAN ST",
    "dropphycty": "WINCHESTER",
    "dropphyst": "IN",
    "dropphyzpp": 473949998,
    "dropmaladd": "130 N MERIDIAN ST",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "IN",
    "dropmalzpp": 473949998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7655842411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14092",
    "droptype": "D",
    "dropname": "WINDFALL",
    "dropdeladd": "106 MCCLELLAN ST",
    "dropdelcty": "WINDFALL",
    "dropdelst": "IN",
    "dropdelzpp": 460769998,
    "dropphyadd": "106 MCCLELLAN ST",
    "dropphycty": "WINDFALL",
    "dropphyst": "IN",
    "dropphyzpp": 460769998,
    "dropmaladd": "106 MCCLELLAN ST",
    "dropmalcty": "WINDFALL",
    "dropmalst": "IN",
    "dropmalzpp": 460769998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7659458345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14095",
    "droptype": "D",
    "dropname": "WINGATE",
    "dropdeladd": "110 W HIGH ST",
    "dropdelcty": "WINGATE",
    "dropdelst": "IN",
    "dropdelzpp": 479949998,
    "dropphyadd": "110 W HIGH ST",
    "dropphycty": "WINGATE",
    "dropphyst": "IN",
    "dropphyzpp": 479949998,
    "dropmaladd": "110 W HIGH ST",
    "dropmalcty": "WINGATE",
    "dropmalst": "IN",
    "dropmalzpp": 479949998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652752480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14096",
    "droptype": "D",
    "dropname": "WINONA LAKE",
    "dropdeladd": "710 PARK AVE",
    "dropdelcty": "WINONA LAKE",
    "dropdelst": "IN",
    "dropdelzpp": 465909998,
    "dropphyadd": "710 PARK AVE",
    "dropphycty": "WINONA LAKE",
    "dropphyst": "IN",
    "dropphyzpp": 465909998,
    "dropmaladd": "710 PARK AVE",
    "dropmalcty": "WINONA LAKE",
    "dropmalst": "IN",
    "dropmalzpp": 465909998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742676732,
    "dropfax": 5745496248
  },
  {
    "dcode": "D",
    "dropkey": "PX14098",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "501 N MAIN ST",
    "dropdelcty": "WINSLOW",
    "dropdelst": "IN",
    "dropdelzpp": 475989998,
    "dropphyadd": "501 N MAIN ST",
    "dropphycty": "WINSLOW",
    "dropphyst": "IN",
    "dropphyzpp": 475989998,
    "dropmaladd": "501 N MAIN ST",
    "dropmalcty": "WINSLOW",
    "dropmalst": "IN",
    "dropmalzpp": 475989998,
    "dropsitphn": 3174646350,
    "dropsitlph": 8127892880,
    "dropsitcph": 8127892880,
    "dropfax": 8127892880
  },
  {
    "dcode": "D",
    "dropkey": "PX14101",
    "droptype": "D",
    "dropname": "WOLCOTT",
    "dropdeladd": "131 W MARKET ST",
    "dropdelcty": "WOLCOTT",
    "dropdelst": "IN",
    "dropdelzpp": 479959998,
    "dropphyadd": "131 W MARKET ST",
    "dropphycty": "WOLCOTT",
    "dropphyst": "IN",
    "dropphyzpp": 479959998,
    "dropmaladd": "131 W MARKET ST",
    "dropmalcty": "WOLCOTT",
    "dropmalst": "IN",
    "dropmalzpp": 479959998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2192792189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14102",
    "droptype": "D",
    "dropname": "WOLCOTTVILLE",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "WOLCOTTVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467959998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "WOLCOTTVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467959998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "WOLCOTTVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467959998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2608542314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14106",
    "droptype": "D",
    "dropname": "WOLFLAKE",
    "dropdeladd": "1221 S US HIGHWAY 33 STE 2",
    "dropdelcty": "WOLFLAKE",
    "dropdelst": "IN",
    "dropdelzpp": 467969998,
    "dropphyadd": "1221 S US HIGHWAY 33 STE 2",
    "dropphycty": "WOLFLAKE",
    "dropphyst": "IN",
    "dropphyzpp": 467969998,
    "dropmaladd": "1221 S US HIGHWAY 33 STE 2",
    "dropmalcty": "WOLFLAKE",
    "dropmalst": "IN",
    "dropmalzpp": 467969998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606352339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14109",
    "droptype": "D",
    "dropname": "WOODBURN",
    "dropdeladd": "22133 MAIN ST STE A",
    "dropdelcty": "WOODBURN",
    "dropdelst": "IN",
    "dropdelzpp": 467979998,
    "dropphyadd": "22133 MAIN ST STE A",
    "dropphycty": "WOODBURN",
    "dropphyst": "IN",
    "dropphyzpp": 467979998,
    "dropmaladd": "22133 MAIN ST STE A",
    "dropmalcty": "WOODBURN",
    "dropmalst": "IN",
    "dropmalzpp": 467979998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606324333,
    "dropfax": 2606329024
  },
  {
    "dcode": "D",
    "dropkey": "PX14119",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "205 S COMMERCIAL ST",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474719998,
    "dropphyadd": "205 S COMMERCIAL ST",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474719998,
    "dropmaladd": "205 S COMMERCIAL ST",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474719998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8128753011,
    "dropfax": 8128753940
  },
  {
    "dcode": "D",
    "dropkey": "PX14123",
    "droptype": "D",
    "dropname": "WYATT",
    "dropdeladd": "66700 STATE ROAD 331",
    "dropdelcty": "WYATT",
    "dropdelst": "IN",
    "dropdelzpp": 465959998,
    "dropphyadd": "66700 STATE ROAD 331",
    "dropphycty": "WYATT",
    "dropphyst": "IN",
    "dropphyzpp": 465959998,
    "dropmaladd": "66700 STATE ROAD 331",
    "dropmalcty": "WYATT",
    "dropmalst": "IN",
    "dropmalzpp": 465959998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5746334109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14129",
    "droptype": "D",
    "dropname": "YODER",
    "dropdeladd": "3209 W YODER RD",
    "dropdelcty": "YODER",
    "dropdelst": "IN",
    "dropdelzpp": 467989998,
    "dropphyadd": "3209 W YODER RD",
    "dropphycty": "YODER",
    "dropphyst": "IN",
    "dropphyzpp": 467989998,
    "dropmaladd": "3209 W YODER RD",
    "dropmalcty": "YODER",
    "dropmalst": "IN",
    "dropmalzpp": 467989998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606227264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14131",
    "droptype": "D",
    "dropname": "YORKTOWN",
    "dropdeladd": "9301 W SMITH ST",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "IN",
    "dropdelzpp": 473969998,
    "dropphyadd": "9301 W SMITH ST",
    "dropphycty": "YORKTOWN",
    "dropphyst": "IN",
    "dropphyzpp": 473969998,
    "dropmaladd": "9301 W SMITH ST",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "IN",
    "dropmalzpp": 473969998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7657595855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14140",
    "droptype": "D",
    "dropname": "ZANESVILLE",
    "dropdeladd": "10917 WASHINGTON ST",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 467999998,
    "dropphyadd": "10917 WASHINGTON ST",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 467999998,
    "dropmaladd": "10917 WASHINGTON ST",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 467999998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2606384876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14143",
    "droptype": "D",
    "dropname": "ZIONSVILLE",
    "dropdeladd": "1475 W OAK ST",
    "dropdelcty": "ZIONSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 460779998,
    "dropphyadd": "1475 W OAK ST",
    "dropphycty": "ZIONSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 460779998,
    "dropmaladd": "1475 W OAK ST",
    "dropmalcty": "ZIONSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 460779998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3178731380,
    "dropfax": 3178739605
  },
  {
    "dcode": "D",
    "dropkey": "PX14152",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "2072 BEAVER DAM RD",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "KY",
    "dropdelzpp": 422019998,
    "dropphyadd": "2072 BEAVER DAM RD",
    "dropphycty": "ABERDEEN",
    "dropphyst": "KY",
    "dropphyzpp": 422019998,
    "dropmaladd": "2072 BEAVER DAM RD",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "KY",
    "dropmalzpp": 422019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705263123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14156",
    "droptype": "D",
    "dropname": "ADAIRVILLE",
    "dropdeladd": "300 S EWING ST",
    "dropdelcty": "ADAIRVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 422028461,
    "dropphyadd": "300 S EWING ST",
    "dropphycty": "ADAIRVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 422028461,
    "dropmaladd": "300 S EWING ST",
    "dropmalcty": "ADAIRVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 422028461,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705397152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14160",
    "droptype": "D",
    "dropname": "ADOLPHUS",
    "dropdeladd": "6422 NEW GALLATIN RD",
    "dropdelcty": "ADOLPHUS",
    "dropdelst": "KY",
    "dropdelzpp": 421209998,
    "dropphyadd": "6422 NEW GALLATIN RD",
    "dropphycty": "ADOLPHUS",
    "dropphyst": "KY",
    "dropphyzpp": 421209998,
    "dropmaladd": "6422 NEW GALLATIN RD",
    "dropmalcty": "ADOLPHUS",
    "dropmalst": "KY",
    "dropmalzpp": 421209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706224274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14167",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "401 N CROSS ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "KY",
    "dropdelzpp": 426029998,
    "dropphyadd": "401 N CROSS ST",
    "dropphycty": "ALBANY",
    "dropphyst": "KY",
    "dropphyzpp": 426029998,
    "dropmaladd": "401 N CROSS ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "KY",
    "dropmalzpp": 426029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063875951,
    "dropfax": 6063878590
  },
  {
    "dcode": "D",
    "dropkey": "PX14169",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "6933 ALEXANDRIA PIKE",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "KY",
    "dropdelzpp": 410019998,
    "dropphyadd": "6933 ALEXANDRIA PIKE",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "KY",
    "dropphyzpp": 410019998,
    "dropmaladd": "6933 ALEXANDRIA PIKE",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "KY",
    "dropmalzpp": 410019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596352957,
    "dropsitcph": 8596352957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14172",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "137 COURT ST",
    "dropdelcty": "ALLEN",
    "dropdelst": "KY",
    "dropdelzpp": 416019998,
    "dropphyadd": "137 COURT ST",
    "dropphycty": "ALLEN",
    "dropphyst": "KY",
    "dropphyzpp": 416019998,
    "dropmaladd": "137 COURT ST",
    "dropmalcty": "ALLEN",
    "dropmalst": "KY",
    "dropmalzpp": 416019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068742119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14176",
    "droptype": "D",
    "dropname": "ALLENSVILLE",
    "dropdeladd": "8738 ALLENSVILLE RD",
    "dropdelcty": "ALLENSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 422049998,
    "dropphyadd": "8738 ALLENSVILLE RD",
    "dropphycty": "ALLENSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 422049998,
    "dropmaladd": "8738 ALLENSVILLE RD",
    "dropmalcty": "ALLENSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 422049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702655940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14181",
    "droptype": "D",
    "dropname": "ALPHA",
    "dropdeladd": "234 OLD HAPPY TOP RD",
    "dropdelcty": "ALPHA",
    "dropdelst": "KY",
    "dropdelzpp": 426039998,
    "dropphyadd": "234 OLD HAPPY TOP RD",
    "dropphycty": "ALPHA",
    "dropphyst": "KY",
    "dropphyzpp": 426039998,
    "dropmaladd": "234 OLD HAPPY TOP RD",
    "dropmalcty": "ALPHA",
    "dropmalst": "KY",
    "dropmalzpp": 426039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063485734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14186",
    "droptype": "D",
    "dropname": "ALVATON",
    "dropdeladd": "10363 ALVATON RD",
    "dropdelcty": "ALVATON",
    "dropdelst": "KY",
    "dropdelzpp": 421229998,
    "dropphyadd": "10363 ALVATON RD",
    "dropphycty": "ALVATON",
    "dropphyst": "KY",
    "dropphyzpp": 421229998,
    "dropmaladd": "10363 ALVATON RD",
    "dropmalcty": "ALVATON",
    "dropmalst": "KY",
    "dropmalzpp": 421229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707823248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14199",
    "droptype": "D",
    "dropname": "ANNVILLE",
    "dropdeladd": "3560 HIGHWAY 3630",
    "dropdelcty": "ANNVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404029998,
    "dropphyadd": "3560 HIGHWAY 3630",
    "dropphycty": "ANNVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404029998,
    "dropmaladd": "3560 HIGHWAY 3630",
    "dropmalcty": "ANNVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063645107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14202",
    "droptype": "D",
    "dropname": "ARGILLITE",
    "dropdeladd": "5470 STATE ROUTE 1",
    "dropdelcty": "ARGILLITE",
    "dropdelst": "KY",
    "dropdelzpp": 411219997,
    "dropphyadd": "5470 STATE ROUTE 1",
    "dropphycty": "ARGILLITE",
    "dropphyst": "KY",
    "dropphyzpp": 411219997,
    "dropmaladd": "5470 STATE ROUTE 1",
    "dropmalcty": "ARGILLITE",
    "dropmalst": "KY",
    "dropmalzpp": 411219997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064736493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14205",
    "droptype": "D",
    "dropname": "ARJAY",
    "dropdeladd": "4658 HIGHWAY 66",
    "dropdelcty": "ARJAY",
    "dropdelst": "KY",
    "dropdelzpp": 409029998,
    "dropphyadd": "4658 HIGHWAY 66",
    "dropphycty": "ARJAY",
    "dropphyst": "KY",
    "dropphyzpp": 409029998,
    "dropmaladd": "4658 HIGHWAY 66",
    "dropmalcty": "ARJAY",
    "dropmalst": "KY",
    "dropmalzpp": 409029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063379084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14208",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "178 WALNUT ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 420219998,
    "dropphyadd": "178 WALNUT ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 420219998,
    "dropmaladd": "178 WALNUT ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 420219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706556201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14210",
    "droptype": "D",
    "dropname": "ARTEMUS",
    "dropdeladd": "3214 KY 225",
    "dropdelcty": "ARTEMUS",
    "dropdelst": "KY",
    "dropdelzpp": 409039998,
    "dropphyadd": "3214 KY 225",
    "dropphycty": "ARTEMUS",
    "dropphyst": "KY",
    "dropphyzpp": 409039998,
    "dropmaladd": "3214 KY 225",
    "dropmalcty": "ARTEMUS",
    "dropmalst": "KY",
    "dropmalzpp": 409039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065468742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14212",
    "droptype": "D",
    "dropname": "ARY",
    "dropdeladd": "14065 KY HIGHWAY 476 STE 102",
    "dropdelcty": "ARY",
    "dropdelst": "KY",
    "dropdelzpp": 417129998,
    "dropphyadd": "14065 KY HIGHWAY 476 STE 102",
    "dropphycty": "ARY",
    "dropphyst": "KY",
    "dropphyzpp": 417129998,
    "dropmaladd": "14065 KY HIGHWAY 476 STE 102",
    "dropmalcty": "ARY",
    "dropmalst": "KY",
    "dropmalzpp": 417129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063782181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14213",
    "droptype": "D",
    "dropname": "ASHCAMP",
    "dropdeladd": "6804 ELKHORN CRK",
    "dropdelcty": "ASHCAMP",
    "dropdelst": "KY",
    "dropdelzpp": 415129998,
    "dropphyadd": "6804 ELKHORN CRK",
    "dropphycty": "ASHCAMP",
    "dropphyst": "KY",
    "dropphyzpp": 415129998,
    "dropmaladd": "6804 ELKHORN CRK",
    "dropmalcty": "ASHCAMP",
    "dropmalst": "KY",
    "dropmalzpp": 415129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067544035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14214",
    "droptype": "D",
    "dropname": "ASHER",
    "dropdeladd": "25 MIDDLEFORK RD",
    "dropdelcty": "ASHER",
    "dropdelst": "KY",
    "dropdelzpp": 408039998,
    "dropphyadd": "25 MIDDLEFORK RD",
    "dropphycty": "ASHER",
    "dropphyst": "KY",
    "dropphyzpp": 408039998,
    "dropmaladd": "25 MIDDLEFORK RD",
    "dropmalcty": "ASHER",
    "dropmalst": "KY",
    "dropmalzpp": 408039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063748042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14216",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "1140 CARTER AVE",
    "dropdelcty": "ASHLAND",
    "dropdelst": "KY",
    "dropdelzpp": 411019998,
    "dropphyadd": "1140 CARTER AVE",
    "dropphycty": "ASHLAND",
    "dropphyst": "KY",
    "dropphyzpp": 411019998,
    "dropmaladd": "1140 CARTER AVE",
    "dropmalcty": "ASHLAND",
    "dropmalst": "KY",
    "dropmalzpp": 411019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063272139,
    "dropfax": 6063272137
  },
  {
    "dcode": "D",
    "dropkey": "PX14222",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "309 W MAIN ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "KY",
    "dropdelzpp": 422069998,
    "dropphyadd": "309 W MAIN ST",
    "dropphycty": "AUBURN",
    "dropphyst": "KY",
    "dropphyzpp": 422069998,
    "dropmaladd": "309 W MAIN ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "KY",
    "dropmalzpp": 422069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706330032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14223",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "103 W 4TH ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "KY",
    "dropdelzpp": 410029998,
    "dropphyadd": "103 W 4TH ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "KY",
    "dropphyzpp": 410029998,
    "dropmaladd": "103 W 4TH ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "KY",
    "dropmalzpp": 410029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067562354,
    "dropsitcph": 6067562354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14227",
    "droptype": "D",
    "dropname": "AUXIER",
    "dropdeladd": "11 W MARKET ST",
    "dropdelcty": "AUXIER",
    "dropdelst": "KY",
    "dropdelzpp": 416029998,
    "dropphyadd": "11 W MARKET ST",
    "dropphycty": "AUXIER",
    "dropphyst": "KY",
    "dropphyzpp": 416029998,
    "dropmaladd": "11 W MARKET ST",
    "dropmalcty": "AUXIER",
    "dropmalst": "KY",
    "dropmalzpp": 416029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068861810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14228",
    "droptype": "D",
    "dropname": "AVAWAM",
    "dropdeladd": "7201 W KY HIGHWAY 80",
    "dropdelcty": "AVAWAM",
    "dropdelst": "KY",
    "dropdelzpp": 417139998,
    "dropphyadd": "7201 W KY HIGHWAY 80",
    "dropphycty": "AVAWAM",
    "dropphyst": "KY",
    "dropphyzpp": 417139998,
    "dropmaladd": "7201 W KY HIGHWAY 80",
    "dropmalcty": "AVAWAM",
    "dropmalst": "KY",
    "dropmalzpp": 417139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064391859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14231",
    "droptype": "D",
    "dropname": "BAGDAD",
    "dropdeladd": "5811 ELMBURG RD",
    "dropdelcty": "BAGDAD",
    "dropdelst": "KY",
    "dropdelzpp": 400039998,
    "dropphyadd": "5811 ELMBURG RD",
    "dropphycty": "BAGDAD",
    "dropphyst": "KY",
    "dropphyzpp": 400039998,
    "dropmaladd": "5811 ELMBURG RD",
    "dropmalcty": "BAGDAD",
    "dropmalst": "KY",
    "dropmalzpp": 400039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5027478813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14241",
    "droptype": "D",
    "dropname": "BANDANA",
    "dropdeladd": "82 ALLEN ST",
    "dropdelcty": "BANDANA",
    "dropdelst": "KY",
    "dropdelzpp": 420229998,
    "dropphyadd": "82 ALLEN ST",
    "dropphycty": "BANDANA",
    "dropphyst": "KY",
    "dropphyzpp": 420229998,
    "dropmaladd": "82 ALLEN ST",
    "dropmalcty": "BANDANA",
    "dropmalst": "KY",
    "dropmalzpp": 420229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702242165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14243",
    "droptype": "D",
    "dropname": "BANNER",
    "dropdeladd": "54 HALL ADDITION",
    "dropdelcty": "BANNER",
    "dropdelst": "KY",
    "dropdelzpp": 416039998,
    "dropphyadd": "54 HALL ADDITION",
    "dropphycty": "BANNER",
    "dropphyst": "KY",
    "dropphyzpp": 416039998,
    "dropmaladd": "54 HALL ADDITION",
    "dropmalcty": "BANNER",
    "dropmalst": "KY",
    "dropmalzpp": 416039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068742871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14245",
    "droptype": "D",
    "dropname": "BARBOURVILLE",
    "dropdeladd": "122 N ALLISON AVE",
    "dropdelcty": "BARBOURVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 409069998,
    "dropphyadd": "122 N ALLISON AVE",
    "dropphycty": "BARBOURVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 409069998,
    "dropmaladd": "122 N ALLISON AVE",
    "dropmalcty": "BARBOURVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 409069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065463777,
    "dropfax": 6065457188
  },
  {
    "dcode": "D",
    "dropkey": "PX14246",
    "droptype": "D",
    "dropname": "BARDSTOWN",
    "dropdeladd": "510 W STEPHEN FOSTER AVE",
    "dropdelcty": "BARDSTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 400049997,
    "dropphyadd": "510 W STEPHEN FOSTER AVE",
    "dropphycty": "BARDSTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 400049997,
    "dropmaladd": "510 W STEPHEN FOSTER AVE",
    "dropmalcty": "BARDSTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 400049997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023488504,
    "dropfax": 5023485137
  },
  {
    "dcode": "D",
    "dropkey": "PX14248",
    "droptype": "D",
    "dropname": "BARDWELL",
    "dropdeladd": "125 ELM ST",
    "dropdelcty": "BARDWELL",
    "dropdelst": "KY",
    "dropdelzpp": 420239998,
    "dropphyadd": "125 ELM ST",
    "dropphycty": "BARDWELL",
    "dropphyst": "KY",
    "dropphyzpp": 420239998,
    "dropmaladd": "125 ELM ST",
    "dropmalcty": "BARDWELL",
    "dropmalst": "KY",
    "dropmalzpp": 420239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706283561,
    "dropfax": 2706289134
  },
  {
    "dcode": "D",
    "dropkey": "PX14251",
    "droptype": "D",
    "dropname": "BARLOW",
    "dropdeladd": "117 S 4TH ST",
    "dropdelcty": "BARLOW",
    "dropdelst": "KY",
    "dropdelzpp": 420249998,
    "dropphyadd": "117 S 4TH ST",
    "dropphycty": "BARLOW",
    "dropphyst": "KY",
    "dropphyzpp": 420249998,
    "dropmaladd": "117 S 4TH ST",
    "dropmalcty": "BARLOW",
    "dropmalst": "KY",
    "dropmalzpp": 420249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703343940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14259",
    "droptype": "D",
    "dropname": "BASKETT",
    "dropdeladd": "1015 2ND AVE",
    "dropdelcty": "BASKETT",
    "dropdelst": "KY",
    "dropdelzpp": 424029998,
    "dropphyadd": "1015 2ND AVE",
    "dropphycty": "BASKETT",
    "dropphyst": "KY",
    "dropphyzpp": 424029998,
    "dropmaladd": "1015 2ND AVE",
    "dropmalcty": "BASKETT",
    "dropmalst": "KY",
    "dropmalzpp": 424029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708300461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14262",
    "droptype": "D",
    "dropname": "BATTLETOWN",
    "dropdeladd": "8800 BATTLETOWN RD",
    "dropdelcty": "BATTLETOWN",
    "dropdelst": "KY",
    "dropdelzpp": 401049998,
    "dropphyadd": "8800 BATTLETOWN RD",
    "dropphycty": "BATTLETOWN",
    "dropphyst": "KY",
    "dropphyzpp": 401049998,
    "dropmaladd": "8800 BATTLETOWN RD",
    "dropmalcty": "BATTLETOWN",
    "dropmalst": "KY",
    "dropmalzpp": 401049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704974116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14265",
    "droptype": "D",
    "dropname": "BAXTER",
    "dropdeladd": "295 S HIGHWAY 413",
    "dropdelcty": "BAXTER",
    "dropdelst": "KY",
    "dropdelzpp": 408069998,
    "dropphyadd": "295 S HIGHWAY 413",
    "dropphycty": "BAXTER",
    "dropphyst": "KY",
    "dropphyzpp": 408069998,
    "dropmaladd": "295 S HIGHWAY 413",
    "dropmalcty": "BAXTER",
    "dropmalst": "KY",
    "dropmalzpp": 408069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065731927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14269",
    "droptype": "D",
    "dropname": "BEAR BRANCH",
    "dropdeladd": "35137 HIGHWAY 421",
    "dropdelcty": "BEAR BRANCH",
    "dropdelst": "KY",
    "dropdelzpp": 417149998,
    "dropphyadd": "35137 HIGHWAY 421",
    "dropphycty": "BEAR BRANCH",
    "dropphyst": "KY",
    "dropphyzpp": 417149998,
    "dropmaladd": "35137 HIGHWAY 421",
    "dropmalcty": "BEAR BRANCH",
    "dropmalst": "KY",
    "dropmalzpp": 417149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066722976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14272",
    "droptype": "D",
    "dropname": "BEATTYVILLE",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "BEATTYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 413119998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "BEATTYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 413119998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "BEATTYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 413119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064648320,
    "dropfax": 6064649077
  },
  {
    "dcode": "D",
    "dropkey": "PX14275",
    "droptype": "D",
    "dropname": "BEAUTY",
    "dropdeladd": "7815 BEAUTY RD",
    "dropdelcty": "BEAUTY",
    "dropdelst": "KY",
    "dropdelzpp": 412039998,
    "dropphyadd": "7815 BEAUTY RD",
    "dropphycty": "BEAUTY",
    "dropphyst": "KY",
    "dropphyzpp": 412039998,
    "dropmaladd": "7815 BEAUTY RD",
    "dropmalcty": "BEAUTY",
    "dropmalst": "KY",
    "dropmalzpp": 412039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063956570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14278",
    "droptype": "D",
    "dropname": "BEAVER DAM",
    "dropdeladd": "435 S MAIN ST",
    "dropdelcty": "BEAVER DAM",
    "dropdelst": "KY",
    "dropdelzpp": 423209998,
    "dropphyadd": "435 S MAIN ST",
    "dropphycty": "BEAVER DAM",
    "dropphyst": "KY",
    "dropphyzpp": 423209998,
    "dropmaladd": "435 S MAIN ST",
    "dropmalcty": "BEAVER DAM",
    "dropmalst": "KY",
    "dropmalzpp": 423209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702743548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14283",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "305 HIGHWAY 42 E",
    "dropdelcty": "BEDFORD",
    "dropdelst": "KY",
    "dropdelzpp": 400069998,
    "dropphyadd": "305 HIGHWAY 42 E",
    "dropphycty": "BEDFORD",
    "dropphyst": "KY",
    "dropphyzpp": 400069998,
    "dropmaladd": "305 HIGHWAY 42 E",
    "dropmalcty": "BEDFORD",
    "dropmalst": "KY",
    "dropmalzpp": 400069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022557330,
    "dropfax": 5022553645
  },
  {
    "dcode": "D",
    "dropkey": "PX14285",
    "droptype": "D",
    "dropname": "BEE SPRING",
    "dropdeladd": "7535 KY HIGHWAY 259 N",
    "dropdelcty": "BEE SPRING",
    "dropdelst": "KY",
    "dropdelzpp": 422079998,
    "dropphyadd": "7535 KY HIGHWAY 259 N",
    "dropphycty": "BEE SPRING",
    "dropphyst": "KY",
    "dropphyzpp": 422079998,
    "dropmaladd": "7535 KY HIGHWAY 259 N",
    "dropmalcty": "BEE SPRING",
    "dropmalst": "KY",
    "dropmalzpp": 422079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702868313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14289",
    "droptype": "D",
    "dropname": "BEECH GROVE",
    "dropdeladd": "435 MAIN ST",
    "dropdelcty": "BEECH GROVE",
    "dropdelst": "KY",
    "dropdelzpp": 423229998,
    "dropphyadd": "435 MAIN ST",
    "dropphycty": "BEECH GROVE",
    "dropphyst": "KY",
    "dropphyzpp": 423229998,
    "dropmaladd": "435 MAIN ST",
    "dropmalcty": "BEECH GROVE",
    "dropmalst": "KY",
    "dropmalzpp": 423229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702735427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14294",
    "droptype": "D",
    "dropname": "BEECHMONT",
    "dropdeladd": "3736 MERLE TRAVIS HWY",
    "dropdelcty": "BEECHMONT",
    "dropdelst": "KY",
    "dropdelzpp": 423239998,
    "dropphyadd": "3736 MERLE TRAVIS HWY",
    "dropphycty": "BEECHMONT",
    "dropphyst": "KY",
    "dropphyzpp": 423239998,
    "dropmaladd": "3736 MERLE TRAVIS HWY",
    "dropmalcty": "BEECHMONT",
    "dropmalst": "KY",
    "dropmalzpp": 423239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704768226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14298",
    "droptype": "D",
    "dropname": "BELCHER",
    "dropdeladd": "14857 REGINA BELCHER HWY",
    "dropdelcty": "BELCHER",
    "dropdelst": "KY",
    "dropdelzpp": 415139998,
    "dropphyadd": "14857 REGINA BELCHER HWY",
    "dropphycty": "BELCHER",
    "dropphyst": "KY",
    "dropphyzpp": 415139998,
    "dropmaladd": "14857 REGINA BELCHER HWY",
    "dropmalcty": "BELCHER",
    "dropmalst": "KY",
    "dropmalzpp": 415139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067459937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14299",
    "droptype": "D",
    "dropname": "BELFRY",
    "dropdeladd": "25320 US HIGHWAY 119 N STE 100",
    "dropdelcty": "BELFRY",
    "dropdelst": "KY",
    "dropdelzpp": 415149998,
    "dropphyadd": "25320 US HIGHWAY 119 N STE 100",
    "dropphycty": "BELFRY",
    "dropphyst": "KY",
    "dropphyzpp": 415149998,
    "dropmaladd": "25320 US HIGHWAY 119 N STE 100",
    "dropmalcty": "BELFRY",
    "dropmalst": "KY",
    "dropmalzpp": 415149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063534120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14308",
    "droptype": "D",
    "dropname": "BENHAM",
    "dropdeladd": "229 MAIN ST STE 1",
    "dropdelcty": "BENHAM",
    "dropdelst": "KY",
    "dropdelzpp": 408079998,
    "dropphyadd": "229 MAIN ST STE 1",
    "dropphycty": "BENHAM",
    "dropphyst": "KY",
    "dropphyzpp": 408079998,
    "dropmaladd": "229 MAIN ST STE 1",
    "dropmalcty": "BENHAM",
    "dropmalst": "KY",
    "dropmalzpp": 408079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068485983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14311",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "219 W 5TH ST",
    "dropdelcty": "BENTON",
    "dropdelst": "KY",
    "dropdelzpp": 420259998,
    "dropphyadd": "219 W 5TH ST",
    "dropphycty": "BENTON",
    "dropphyst": "KY",
    "dropphyzpp": 420259998,
    "dropmaladd": "219 W 5TH ST",
    "dropmalcty": "BENTON",
    "dropmalst": "KY",
    "dropmalzpp": 420259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705273933,
    "dropfax": 5025279559
  },
  {
    "dcode": "D",
    "dropkey": "PX14312",
    "droptype": "D",
    "dropname": "BEREA",
    "dropdeladd": "222 GLADES RD",
    "dropdelcty": "BEREA",
    "dropdelst": "KY",
    "dropdelzpp": 404039998,
    "dropphyadd": "222 GLADES RD",
    "dropphycty": "BEREA",
    "dropphyst": "KY",
    "dropphyzpp": 404039998,
    "dropmaladd": "222 GLADES RD",
    "dropmalcty": "BEREA",
    "dropmalst": "KY",
    "dropmalzpp": 404039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8599863941,
    "dropfax": 8599862131
  },
  {
    "dcode": "D",
    "dropkey": "PX14317",
    "droptype": "D",
    "dropname": "BERRY",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "BERRY",
    "dropdelst": "KY",
    "dropdelzpp": 410039998,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "BERRY",
    "dropphyst": "KY",
    "dropphyzpp": 410039998,
    "dropmaladd": "202 E MAIN ST",
    "dropmalcty": "BERRY",
    "dropmalst": "KY",
    "dropmalzpp": 410039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8592342063,
    "dropsitcph": 8592342063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14324",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "3946 BETHLEHEM RD",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "KY",
    "dropdelzpp": 400079998,
    "dropphyadd": "3946 BETHLEHEM RD",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "KY",
    "dropphyzpp": 400079998,
    "dropmaladd": "3946 BETHLEHEM RD",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "KY",
    "dropmalzpp": 400079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028450207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14326",
    "droptype": "D",
    "dropname": "BETSY LAYNE",
    "dropdeladd": "11105 US HIGHWAY 23 S STE 101",
    "dropdelcty": "BETSY LAYNE",
    "dropdelst": "KY",
    "dropdelzpp": 416059998,
    "dropphyadd": "11105 US HIGHWAY 23 S STE 101",
    "dropphycty": "BETSY LAYNE",
    "dropphyst": "KY",
    "dropphyzpp": 416059998,
    "dropmaladd": "11105 US HIGHWAY 23 S STE 101",
    "dropmalcty": "BETSY LAYNE",
    "dropmalst": "KY",
    "dropmalzpp": 416059998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064813325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14329",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "16464 HIGHWAY 66",
    "dropdelcty": "BEVERLY",
    "dropdelst": "KY",
    "dropdelzpp": 409139998,
    "dropphyadd": "16464 HIGHWAY 66",
    "dropphycty": "BEVERLY",
    "dropphyst": "KY",
    "dropphyzpp": 409139998,
    "dropmaladd": "16464 HIGHWAY 66",
    "dropmalcty": "BEVERLY",
    "dropmalst": "KY",
    "dropmalzpp": 409139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063379543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14330",
    "droptype": "D",
    "dropname": "BEVINSVILLE",
    "dropdeladd": "20311 KY ROUTE 122",
    "dropdelcty": "BEVINSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 416069998,
    "dropphyadd": "20311 KY ROUTE 122",
    "dropphycty": "BEVINSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 416069998,
    "dropmaladd": "20311 KY ROUTE 122",
    "dropmalcty": "BEVINSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 416069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064522146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14332",
    "droptype": "D",
    "dropname": "BIG CLIFTY",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "BIG CLIFTY",
    "dropdelst": "KY",
    "dropdelzpp": 427129998,
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "BIG CLIFTY",
    "dropphyst": "KY",
    "dropphyzpp": 427129998,
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "BIG CLIFTY",
    "dropmalst": "KY",
    "dropmalzpp": 427129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702424411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14333",
    "droptype": "D",
    "dropname": "BIG CREEK",
    "dropdeladd": "17231 S HIGHWAY 421",
    "dropdelcty": "BIG CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 409149998,
    "dropphyadd": "17231 S HIGHWAY 421",
    "dropphycty": "BIG CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 409149998,
    "dropmaladd": "17231 S HIGHWAY 421",
    "dropmalcty": "BIG CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 409149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065606303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14335",
    "droptype": "D",
    "dropname": "BIG LAUREL",
    "dropdeladd": "12564 E HIGHWAY 221",
    "dropdelcty": "BIG LAUREL",
    "dropdelst": "KY",
    "dropdelzpp": 408089998,
    "dropphyadd": "12564 E HIGHWAY 221",
    "dropphycty": "BIG LAUREL",
    "dropphyst": "KY",
    "dropphyzpp": 408089998,
    "dropmaladd": "12564 E HIGHWAY 221",
    "dropmalcty": "BIG LAUREL",
    "dropmalst": "KY",
    "dropmalzpp": 408089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065583472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14341",
    "droptype": "D",
    "dropname": "BIGHILL",
    "dropdeladd": "10050 BATTLEFIELD MEMORIAL HWY",
    "dropdelcty": "BIGHILL",
    "dropdelst": "KY",
    "dropdelzpp": 404059998,
    "dropphyadd": "10050 BATTLEFIELD MEMORIAL HWY",
    "dropphycty": "BIGHILL",
    "dropphyst": "KY",
    "dropphyzpp": 404059998,
    "dropmaladd": "10050 BATTLEFIELD MEMORIAL HWY",
    "dropmalcty": "BIGHILL",
    "dropmalst": "KY",
    "dropmalzpp": 404059998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8599861706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14342",
    "droptype": "D",
    "dropname": "BIMBLE",
    "dropdeladd": "187 KY 1304",
    "dropdelcty": "BIMBLE",
    "dropdelst": "KY",
    "dropdelzpp": 409159998,
    "dropphyadd": "187 KY 1304",
    "dropphycty": "BIMBLE",
    "dropphyst": "KY",
    "dropphyzpp": 409159998,
    "dropmaladd": "187 KY 1304",
    "dropmalcty": "BIMBLE",
    "dropmalst": "KY",
    "dropmalzpp": 409159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065466536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14347",
    "droptype": "D",
    "dropname": "BLACKEY",
    "dropdeladd": "8271 HIGHWAY 7 S",
    "dropdelcty": "BLACKEY",
    "dropdelst": "KY",
    "dropdelzpp": 418049998,
    "dropphyadd": "8271 HIGHWAY 7 S",
    "dropphycty": "BLACKEY",
    "dropphyst": "KY",
    "dropphyzpp": 418049998,
    "dropmaladd": "8271 HIGHWAY 7 S",
    "dropmalcty": "BLACKEY",
    "dropmalst": "KY",
    "dropmalzpp": 418049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066338677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14352",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "30 S HIGHWAY 201",
    "dropdelcty": "BLAINE",
    "dropdelst": "KY",
    "dropdelzpp": 411249998,
    "dropphyadd": "30 S HIGHWAY 201",
    "dropphycty": "BLAINE",
    "dropphyst": "KY",
    "dropphyzpp": 411249998,
    "dropmaladd": "30 S HIGHWAY 201",
    "dropmalcty": "BLAINE",
    "dropmalst": "KY",
    "dropmalzpp": 411249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066524257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14360",
    "droptype": "D",
    "dropname": "BLEDSOE",
    "dropdeladd": "33 W HIGHWAY 221",
    "dropdelcty": "BLEDSOE",
    "dropdelst": "KY",
    "dropdelzpp": 408109998,
    "dropphyadd": "33 W HIGHWAY 221",
    "dropphycty": "BLEDSOE",
    "dropphyst": "KY",
    "dropphyzpp": 408109998,
    "dropmaladd": "33 W HIGHWAY 221",
    "dropmalcty": "BLEDSOE",
    "dropmalst": "KY",
    "dropmalzpp": 408109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065583278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14364",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "131 TAYLORSVILLE RD",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 400089998,
    "dropphyadd": "131 TAYLORSVILLE RD",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 400089998,
    "dropmaladd": "131 TAYLORSVILLE RD",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 400089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022525004,
    "dropfax": 5022527048
  },
  {
    "dcode": "D",
    "dropkey": "PX14371",
    "droptype": "D",
    "dropname": "BLUE RIVER",
    "dropdeladd": "3563 KY ROUTE 404 STE 2",
    "dropdelcty": "BLUE RIVER",
    "dropdelst": "KY",
    "dropdelzpp": 416079998,
    "dropphyadd": "3563 KY ROUTE 404 STE 2",
    "dropphycty": "BLUE RIVER",
    "dropphyst": "KY",
    "dropphyzpp": 416079998,
    "dropmaladd": "3563 KY ROUTE 404 STE 2",
    "dropmalcty": "BLUE RIVER",
    "dropmalst": "KY",
    "dropmalzpp": 416079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068866967,
    "dropfax": 6068866967
  },
  {
    "dcode": "D",
    "dropkey": "PX14378",
    "droptype": "D",
    "dropname": "BOAZ",
    "dropdeladd": "1970 MCCRACKEN COUNTY RD",
    "dropdelcty": "BOAZ",
    "dropdelst": "KY",
    "dropdelzpp": 420279998,
    "dropphyadd": "1970 MCCRACKEN COUNTY RD",
    "dropphycty": "BOAZ",
    "dropphyst": "KY",
    "dropphyzpp": 420279998,
    "dropmaladd": "1970 MCCRACKEN COUNTY RD",
    "dropmalcty": "BOAZ",
    "dropmalst": "KY",
    "dropmalzpp": 420279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708452955,
    "dropfax": 2708563699
  },
  {
    "dcode": "D",
    "dropkey": "PX14387",
    "droptype": "D",
    "dropname": "BONNIEVILLE",
    "dropdeladd": "7692 N DIXIE HWY",
    "dropdelcty": "BONNIEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427139998,
    "dropphyadd": "7692 N DIXIE HWY",
    "dropphycty": "BONNIEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427139998,
    "dropmaladd": "7692 N DIXIE HWY",
    "dropmalcty": "BONNIEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705315151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14388",
    "droptype": "D",
    "dropname": "BONNYMAN",
    "dropdeladd": "112 BONNYMAN CIR",
    "dropdelcty": "BONNYMAN",
    "dropdelst": "KY",
    "dropdelzpp": 417199998,
    "dropphyadd": "112 BONNYMAN CIR",
    "dropphycty": "BONNYMAN",
    "dropphyst": "KY",
    "dropphyzpp": 417199998,
    "dropmaladd": "112 BONNYMAN CIR",
    "dropmalcty": "BONNYMAN",
    "dropmalst": "KY",
    "dropmalzpp": 417199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064392168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14391",
    "droptype": "D",
    "dropname": "BOONEVILLE",
    "dropdeladd": "830 KY 11 N",
    "dropdelcty": "BOONEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 413149997,
    "dropphyadd": "830 KY 11 N",
    "dropphycty": "BOONEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 413149997,
    "dropmaladd": "830 KY 11 N",
    "dropmalcty": "BOONEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 413149997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065935228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14392",
    "droptype": "D",
    "dropname": "BOONS CAMP",
    "dropdeladd": "10061 KY ROUTE 40 E",
    "dropdelcty": "BOONS CAMP",
    "dropdelst": "KY",
    "dropdelzpp": 412049998,
    "dropphyadd": "10061 KY ROUTE 40 E",
    "dropphycty": "BOONS CAMP",
    "dropphyst": "KY",
    "dropphyzpp": 412049998,
    "dropmaladd": "10061 KY ROUTE 40 E",
    "dropmalcty": "BOONS CAMP",
    "dropmalst": "KY",
    "dropmalzpp": 412049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067894912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14393",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "105 POST OFFICE CT",
    "dropdelcty": "BOSTON",
    "dropdelst": "KY",
    "dropdelzpp": 401079998,
    "dropphyadd": "105 POST OFFICE CT",
    "dropphycty": "BOSTON",
    "dropphyst": "KY",
    "dropphyzpp": 401079998,
    "dropmaladd": "105 POST OFFICE CT",
    "dropmalcty": "BOSTON",
    "dropmalst": "KY",
    "dropmalzpp": 401079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028332839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14399",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "5300 SCOTTSVILLE RD",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 421049998,
    "dropphyadd": "5300 SCOTTSVILLE RD",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 421049998,
    "dropmaladd": "5300 SCOTTSVILLE RD",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 421049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707964035,
    "dropfax": 2708435773
  },
  {
    "dcode": "D",
    "dropkey": "PX14408",
    "droptype": "D",
    "dropname": "BRADFORDSVILLE",
    "dropdeladd": "112 S 6TH ST",
    "dropdelcty": "BRADFORDSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400099998,
    "dropphyadd": "112 S 6TH ST",
    "dropphycty": "BRADFORDSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400099998,
    "dropmaladd": "112 S 6TH ST",
    "dropmalcty": "BRADFORDSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400099998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703374401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14410",
    "droptype": "D",
    "dropname": "BRANDENBURG",
    "dropdeladd": "636 HIGH ST",
    "dropdelcty": "BRANDENBURG",
    "dropdelst": "KY",
    "dropdelzpp": 401089998,
    "dropphyadd": "636 HIGH ST",
    "dropphycty": "BRANDENBURG",
    "dropphyst": "KY",
    "dropphyzpp": 401089998,
    "dropmaladd": "636 HIGH ST",
    "dropmalcty": "BRANDENBURG",
    "dropmalst": "KY",
    "dropmalzpp": 401089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704222511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14412",
    "droptype": "D",
    "dropname": "BREEDING",
    "dropdeladd": "35 POST OFFICE LN",
    "dropdelcty": "BREEDING",
    "dropdelst": "KY",
    "dropdelzpp": 427159998,
    "dropphyadd": "35 POST OFFICE LN",
    "dropphycty": "BREEDING",
    "dropphyst": "KY",
    "dropphyzpp": 427159998,
    "dropmaladd": "35 POST OFFICE LN",
    "dropmalcty": "BREEDING",
    "dropmalst": "KY",
    "dropmalzpp": 427159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703785956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14413",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "4710 MAIN ST",
    "dropdelcty": "BREMEN",
    "dropdelst": "KY",
    "dropdelzpp": 423259998,
    "dropphyadd": "4710 MAIN ST",
    "dropphycty": "BREMEN",
    "dropphyst": "KY",
    "dropphyzpp": 423259998,
    "dropmaladd": "4710 MAIN ST",
    "dropmalcty": "BREMEN",
    "dropmalst": "KY",
    "dropmalzpp": 423259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705256284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14424",
    "droptype": "D",
    "dropname": "BRODHEAD",
    "dropdeladd": "170 W MAIN ST",
    "dropdelcty": "BRODHEAD",
    "dropdelst": "KY",
    "dropdelzpp": 404099998,
    "dropphyadd": "170 W MAIN ST",
    "dropphycty": "BRODHEAD",
    "dropphyst": "KY",
    "dropphyzpp": 404099998,
    "dropmaladd": "170 W MAIN ST",
    "dropmalcty": "BRODHEAD",
    "dropmalst": "KY",
    "dropmalzpp": 404099998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067660209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14427",
    "droptype": "D",
    "dropname": "BRONSTON",
    "dropdeladd": "1801 HIGHWAY 90",
    "dropdelcty": "BRONSTON",
    "dropdelst": "KY",
    "dropdelzpp": 425189998,
    "dropphyadd": "1801 HIGHWAY 90",
    "dropphycty": "BRONSTON",
    "dropphyst": "KY",
    "dropphyzpp": 425189998,
    "dropmaladd": "1801 HIGHWAY 90",
    "dropmalcty": "BRONSTON",
    "dropmalst": "KY",
    "dropmalzpp": 425189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065615293,
    "dropfax": 6065610364
  },
  {
    "dcode": "D",
    "dropkey": "PX14429",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "3025 CORAL RIDGE RD",
    "dropdelcty": "BROOKS",
    "dropdelst": "KY",
    "dropdelzpp": 401099998,
    "dropphyadd": "3025 CORAL RIDGE RD",
    "dropphycty": "BROOKS",
    "dropphyst": "KY",
    "dropphyzpp": 401099998,
    "dropmaladd": "3025 CORAL RIDGE RD",
    "dropmalcty": "BROOKS",
    "dropmalst": "KY",
    "dropmalzpp": 401099998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029557604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14431",
    "droptype": "D",
    "dropname": "BROOKSVILLE",
    "dropdeladd": "208 MADISON ST",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 410049998,
    "dropphyadd": "208 MADISON ST",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 410049998,
    "dropmaladd": "208 MADISON ST",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410049998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067352311,
    "dropsitcph": 6067352311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14442",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "535 S MAIN ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 422109998,
    "dropphyadd": "535 S MAIN ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 422109998,
    "dropmaladd": "535 S MAIN ST",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 422109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705972121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14447",
    "droptype": "D",
    "dropname": "BRYANTS STORE",
    "dropdeladd": "2001 KY 1809",
    "dropdelcty": "BRYANTS STORE",
    "dropdelst": "KY",
    "dropdelzpp": 409219998,
    "dropphyadd": "2001 KY 1809",
    "dropphycty": "BRYANTS STORE",
    "dropphyst": "KY",
    "dropphyzpp": 409219998,
    "dropmaladd": "2001 KY 1809",
    "dropmalcty": "BRYANTS STORE",
    "dropmalst": "KY",
    "dropmalzpp": 409219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065462609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14448",
    "droptype": "D",
    "dropname": "BRYANTSVILLE",
    "dropdeladd": "302 BRYANTSVILLE RD",
    "dropdelcty": "BRYANTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404109998,
    "dropphyadd": "302 BRYANTSVILLE RD",
    "dropphycty": "BRYANTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404109998,
    "dropmaladd": "302 BRYANTSVILLE RD",
    "dropmalcty": "BRYANTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8595485034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14449",
    "droptype": "D",
    "dropname": "BUCKHORN",
    "dropdeladd": "18540 KY HIGHWAY 28 STE 102",
    "dropdelcty": "BUCKHORN",
    "dropdelst": "KY",
    "dropdelzpp": 417219998,
    "dropphyadd": "18540 KY HIGHWAY 28 STE 102",
    "dropphycty": "BUCKHORN",
    "dropphyst": "KY",
    "dropphyzpp": 417219998,
    "dropmaladd": "18540 KY HIGHWAY 28 STE 102",
    "dropmalcty": "BUCKHORN",
    "dropmalst": "KY",
    "dropmalzpp": 417219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063987786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14451",
    "droptype": "D",
    "dropname": "BUCKNER",
    "dropdeladd": "4725 W HIGHWAY 146",
    "dropdelcty": "BUCKNER",
    "dropdelst": "KY",
    "dropdelzpp": 400109998,
    "dropphyadd": "4725 W HIGHWAY 146",
    "dropphycty": "BUCKNER",
    "dropphyst": "KY",
    "dropphyzpp": 400109998,
    "dropmaladd": "4725 W HIGHWAY 146",
    "dropmalcty": "BUCKNER",
    "dropmalst": "KY",
    "dropmalzpp": 400109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022229840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14454",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "2159B GREENSBURG RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "KY",
    "dropdelzpp": 427169996,
    "dropphyadd": "2159B GREENSBURG RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "KY",
    "dropphyzpp": 427169996,
    "dropmaladd": "2159B GREENSBURG RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "KY",
    "dropmalzpp": 427169996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703300042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14458",
    "droptype": "D",
    "dropname": "BULAN",
    "dropdeladd": "4672 KY HIGHWAY 476",
    "dropdelcty": "BULAN",
    "dropdelst": "KY",
    "dropdelzpp": 417229998,
    "dropphyadd": "4672 KY HIGHWAY 476",
    "dropphycty": "BULAN",
    "dropphyst": "KY",
    "dropphyzpp": 417229998,
    "dropmaladd": "4672 KY HIGHWAY 476",
    "dropmalcty": "BULAN",
    "dropmalst": "KY",
    "dropmalzpp": 417229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064362992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14461",
    "droptype": "D",
    "dropname": "BURDINE",
    "dropdeladd": "11872 HIGHWAY 805",
    "dropdelcty": "BURDINE",
    "dropdelst": "KY",
    "dropdelzpp": 415179998,
    "dropphyadd": "11872 HIGHWAY 805",
    "dropphycty": "BURDINE",
    "dropphyst": "KY",
    "dropphyzpp": 415179998,
    "dropmaladd": "11872 HIGHWAY 805",
    "dropmalcty": "BURDINE",
    "dropmalst": "KY",
    "dropmalzpp": 415179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068322733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14462",
    "droptype": "D",
    "dropname": "BURGIN",
    "dropdeladd": "217 MAIN ST",
    "dropdelcty": "BURGIN",
    "dropdelst": "KY",
    "dropdelzpp": 403109998,
    "dropphyadd": "217 MAIN ST",
    "dropphycty": "BURGIN",
    "dropphyst": "KY",
    "dropphyzpp": 403109998,
    "dropmaladd": "217 MAIN ST",
    "dropmalcty": "BURGIN",
    "dropmalst": "KY",
    "dropmalzpp": 403109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8597489182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14464",
    "droptype": "D",
    "dropname": "BURKESVILLE",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "BURKESVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427179998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "BURKESVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427179998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "BURKESVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708644341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14467",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "2600 BURLINGTON PIKE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 410059998,
    "dropphyadd": "2600 BURLINGTON PIKE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 410059998,
    "dropmaladd": "2600 BURLINGTON PIKE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 410059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8595867082,
    "dropsitcph": 8596893042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14469",
    "droptype": "D",
    "dropname": "BURNA",
    "dropdeladd": "1499 US HIGHWAY 60 E",
    "dropdelcty": "BURNA",
    "dropdelst": "KY",
    "dropdelzpp": 420289998,
    "dropphyadd": "1499 US HIGHWAY 60 E",
    "dropphycty": "BURNA",
    "dropphyst": "KY",
    "dropphyzpp": 420289998,
    "dropmaladd": "1499 US HIGHWAY 60 E",
    "dropmalcty": "BURNA",
    "dropmalst": "KY",
    "dropmalzpp": 420289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709883211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14472",
    "droptype": "D",
    "dropname": "BURNSIDE",
    "dropdeladd": "8250 S HIGHWAY 27",
    "dropdelcty": "BURNSIDE",
    "dropdelst": "KY",
    "dropdelzpp": 425199998,
    "dropphyadd": "8250 S HIGHWAY 27",
    "dropphycty": "BURNSIDE",
    "dropphyst": "KY",
    "dropphyzpp": 425199998,
    "dropmaladd": "8250 S HIGHWAY 27",
    "dropmalcty": "BURNSIDE",
    "dropmalst": "KY",
    "dropmalzpp": 425199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065614193,
    "dropfax": 6065610238
  },
  {
    "dcode": "D",
    "dropkey": "PX14482",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "104 FRONT ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "KY",
    "dropdelzpp": 410069998,
    "dropphyadd": "104 FRONT ST",
    "dropphycty": "BUTLER",
    "dropphyst": "KY",
    "dropphyzpp": 410069998,
    "dropmaladd": "104 FRONT ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "KY",
    "dropmalzpp": 410069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594722895,
    "dropsitcph": 8594722895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14486",
    "droptype": "D",
    "dropname": "CADIZ",
    "dropdeladd": "72 LAKOTA DR",
    "dropdelcty": "CADIZ",
    "dropdelst": "KY",
    "dropdelzpp": 422119998,
    "dropphyadd": "72 LAKOTA DR",
    "dropphycty": "CADIZ",
    "dropphyst": "KY",
    "dropphyzpp": 422119998,
    "dropmaladd": "72 LAKOTA DR",
    "dropmalcty": "CADIZ",
    "dropmalst": "KY",
    "dropmalzpp": 422119998,
    "dropsitphn": 2705228112,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705228112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14489",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "310 W 2ND ST",
    "dropdelcty": "CALHOUN",
    "dropdelst": "KY",
    "dropdelzpp": 423279998,
    "dropphyadd": "310 W 2ND ST",
    "dropphycty": "CALHOUN",
    "dropphyst": "KY",
    "dropphyzpp": 423279998,
    "dropmaladd": "310 W 2ND ST",
    "dropmalcty": "CALHOUN",
    "dropmalst": "KY",
    "dropmalzpp": 423279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702733729,
    "dropfax": 2702733792
  },
  {
    "dcode": "D",
    "dropkey": "PX14491",
    "droptype": "D",
    "dropname": "CALIFORNIA",
    "dropdeladd": "4087 UNION ST",
    "dropdelcty": "CALIFORNIA",
    "dropdelst": "KY",
    "dropdelzpp": 410079998,
    "dropphyadd": "4087 UNION ST",
    "dropphycty": "CALIFORNIA",
    "dropphyst": "KY",
    "dropphyzpp": 410079998,
    "dropmaladd": "4087 UNION ST",
    "dropmalcty": "CALIFORNIA",
    "dropmalst": "KY",
    "dropmalzpp": 410079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596359920,
    "dropsitcph": 8596359920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14494",
    "droptype": "D",
    "dropname": "CALVERT CITY",
    "dropdeladd": "134 E 5TH AVE",
    "dropdelcty": "CALVERT CITY",
    "dropdelst": "KY",
    "dropdelzpp": 420299998,
    "dropphyadd": "134 E 5TH AVE",
    "dropphycty": "CALVERT CITY",
    "dropphyst": "KY",
    "dropphyzpp": 420299998,
    "dropmaladd": "134 E 5TH AVE",
    "dropmalcty": "CALVERT CITY",
    "dropmalst": "KY",
    "dropmalzpp": 420299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703954800,
    "dropfax": 2703958193
  },
  {
    "dcode": "D",
    "dropkey": "PX14497",
    "droptype": "D",
    "dropname": "CALVIN",
    "dropdeladd": "5501 US HIGHWAY 119",
    "dropdelcty": "CALVIN",
    "dropdelst": "KY",
    "dropdelzpp": 408139998,
    "dropphyadd": "5501 US HIGHWAY 119",
    "dropphycty": "CALVIN",
    "dropphyst": "KY",
    "dropphyzpp": 408139998,
    "dropmaladd": "5501 US HIGHWAY 119",
    "dropmalcty": "CALVIN",
    "dropmalst": "KY",
    "dropmalzpp": 408139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063375436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14502",
    "droptype": "D",
    "dropname": "CAMPBELLSBURG",
    "dropdeladd": "8130 MAIN ST",
    "dropdelcty": "CAMPBELLSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 400119998,
    "dropphyadd": "8130 MAIN ST",
    "dropphycty": "CAMPBELLSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 400119998,
    "dropmaladd": "8130 MAIN ST",
    "dropmalcty": "CAMPBELLSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 400119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025326094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14503",
    "droptype": "D",
    "dropname": "CAMPBELLSVILLE",
    "dropdeladd": "1410 E BROADWAY ST",
    "dropdelcty": "CAMPBELLSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427189998,
    "dropphyadd": "1410 E BROADWAY ST",
    "dropphycty": "CAMPBELLSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427189998,
    "dropmaladd": "1410 E BROADWAY ST",
    "dropmalcty": "CAMPBELLSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704654251,
    "dropfax": 2707899650
  },
  {
    "dcode": "D",
    "dropkey": "PX14506",
    "droptype": "D",
    "dropname": "CAMPTON",
    "dropdeladd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropdelcty": "CAMPTON",
    "dropdelst": "KY",
    "dropdelzpp": 413019998,
    "dropphyadd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropphycty": "CAMPTON",
    "dropphyst": "KY",
    "dropphyzpp": 413019998,
    "dropmaladd": "175 MOUNTAIN PARKWAY SPUR RD",
    "dropmalcty": "CAMPTON",
    "dropmalst": "KY",
    "dropmalzpp": 413019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066686395,
    "dropfax": 6066686398
  },
  {
    "dcode": "D",
    "dropkey": "PX14507",
    "droptype": "D",
    "dropname": "CANADA",
    "dropdeladd": "19245 E BIG CREEK RD",
    "dropdelcty": "CANADA",
    "dropdelst": "KY",
    "dropdelzpp": 415199998,
    "dropphyadd": "19245 E BIG CREEK RD",
    "dropphycty": "CANADA",
    "dropphyst": "KY",
    "dropphyzpp": 415199998,
    "dropmaladd": "19245 E BIG CREEK RD",
    "dropmalcty": "CANADA",
    "dropmalst": "KY",
    "dropmalzpp": 415199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063537324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14508",
    "droptype": "D",
    "dropname": "CANE VALLEY",
    "dropdeladd": "2303 CANE VALLEY RD",
    "dropdelcty": "CANE VALLEY",
    "dropdelst": "KY",
    "dropdelzpp": 427209998,
    "dropphyadd": "2303 CANE VALLEY RD",
    "dropphycty": "CANE VALLEY",
    "dropphyst": "KY",
    "dropphyzpp": 427209998,
    "dropmaladd": "2303 CANE VALLEY RD",
    "dropmalcty": "CANE VALLEY",
    "dropmalst": "KY",
    "dropmalzpp": 427209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703800001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14510",
    "droptype": "D",
    "dropname": "CANEYVILLE",
    "dropdeladd": "106 3RD ST",
    "dropdelcty": "CANEYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427219998,
    "dropphyadd": "106 3RD ST",
    "dropphycty": "CANEYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427219998,
    "dropmaladd": "106 3RD ST",
    "dropmalcty": "CANEYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708794020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14511",
    "droptype": "D",
    "dropname": "CANMER",
    "dropdeladd": "2698 N JACKSON HWY",
    "dropdelcty": "CANMER",
    "dropdelst": "KY",
    "dropdelzpp": 427228900,
    "dropphyadd": "2698 N JACKSON HWY",
    "dropphycty": "CANMER",
    "dropphyst": "KY",
    "dropphyzpp": 427228900,
    "dropmaladd": "2698 N JACKSON HWY",
    "dropmalcty": "CANMER",
    "dropmalst": "KY",
    "dropmalzpp": 427228900,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705283353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14512",
    "droptype": "D",
    "dropname": "CANNEL CITY",
    "dropdeladd": "9519 HIGHWAY 191",
    "dropdelcty": "CANNEL CITY",
    "dropdelst": "KY",
    "dropdelzpp": 414089998,
    "dropphyadd": "9519 HIGHWAY 191",
    "dropphycty": "CANNEL CITY",
    "dropphyst": "KY",
    "dropphyzpp": 414089998,
    "dropmaladd": "9519 HIGHWAY 191",
    "dropmalcty": "CANNEL CITY",
    "dropmalst": "KY",
    "dropmalzpp": 414089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067432990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14513",
    "droptype": "D",
    "dropname": "CANNON",
    "dropdeladd": "3387 N KY 11",
    "dropdelcty": "CANNON",
    "dropdelst": "KY",
    "dropdelzpp": 409239998,
    "dropphyadd": "3387 N KY 11",
    "dropphycty": "CANNON",
    "dropphyst": "KY",
    "dropphyzpp": 409239998,
    "dropmaladd": "3387 N KY 11",
    "dropmalcty": "CANNON",
    "dropmalst": "KY",
    "dropmalzpp": 409239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065468407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14524",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "231 W MAIN ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "KY",
    "dropdelzpp": 403119998,
    "dropphyadd": "231 W MAIN ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "KY",
    "dropphyzpp": 403119998,
    "dropmaladd": "231 W MAIN ST",
    "dropmalcty": "CARLISLE",
    "dropmalst": "KY",
    "dropmalzpp": 403119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592895291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14530",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "520 HIGHLAND AVE",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "KY",
    "dropdelzpp": 410089998,
    "dropphyadd": "520 HIGHLAND AVE",
    "dropphycty": "CARROLLTON",
    "dropphyst": "KY",
    "dropphyzpp": 410089998,
    "dropmaladd": "520 HIGHLAND AVE",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "KY",
    "dropmalzpp": 410089998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5027328862,
    "dropsitcph": 5027328862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14545",
    "droptype": "D",
    "dropname": "CATLETTSBURG",
    "dropdeladd": "3514 COURT ST",
    "dropdelcty": "CATLETTSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 411299997,
    "dropphyadd": "3514 COURT ST",
    "dropphycty": "CATLETTSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 411299997,
    "dropmaladd": "3514 COURT ST",
    "dropmalcty": "CATLETTSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 411299997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067394332,
    "dropfax": 6067398295
  },
  {
    "dcode": "D",
    "dropkey": "PX14547",
    "droptype": "D",
    "dropname": "CAVE CITY",
    "dropdeladd": "309 BROADWAY ST",
    "dropdelcty": "CAVE CITY",
    "dropdelst": "KY",
    "dropdelzpp": 421279998,
    "dropphyadd": "309 BROADWAY ST",
    "dropphycty": "CAVE CITY",
    "dropphyst": "KY",
    "dropphyzpp": 421279998,
    "dropmaladd": "309 BROADWAY ST",
    "dropmalcty": "CAVE CITY",
    "dropmalst": "KY",
    "dropmalzpp": 421279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707732820,
    "dropfax": 2707733887
  },
  {
    "dcode": "D",
    "dropkey": "PX14552",
    "droptype": "D",
    "dropname": "CAWOOD",
    "dropdeladd": "3679 S HIGHWAY 3001",
    "dropdelcty": "CAWOOD",
    "dropdelst": "KY",
    "dropdelzpp": 408159998,
    "dropphyadd": "3679 S HIGHWAY 3001",
    "dropphycty": "CAWOOD",
    "dropphyst": "KY",
    "dropphyzpp": 408159998,
    "dropmaladd": "3679 S HIGHWAY 3001",
    "dropmalcty": "CAWOOD",
    "dropmalst": "KY",
    "dropmalzpp": 408159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065734195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14554",
    "droptype": "D",
    "dropname": "CECILIA",
    "dropdeladd": "422 FEDERAL ST",
    "dropdelcty": "CECILIA",
    "dropdelst": "KY",
    "dropdelzpp": 427249998,
    "dropphyadd": "422 FEDERAL ST",
    "dropphycty": "CECILIA",
    "dropphyst": "KY",
    "dropphyzpp": 427249998,
    "dropmaladd": "422 FEDERAL ST",
    "dropmalcty": "CECILIA",
    "dropmalst": "KY",
    "dropmalzpp": 427249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708623811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14561",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "CENTER",
    "dropdelst": "KY",
    "dropdelzpp": 422149998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "CENTER",
    "dropphyst": "KY",
    "dropphyzpp": 422149998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "CENTER",
    "dropmalst": "KY",
    "dropmalzpp": 422149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705651131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14563",
    "droptype": "D",
    "dropname": "CENTERTOWN",
    "dropdeladd": "805 MAIN ST",
    "dropdelcty": "CENTERTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 423289998,
    "dropphyadd": "805 MAIN ST",
    "dropphycty": "CENTERTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 423289998,
    "dropmaladd": "805 MAIN ST",
    "dropmalcty": "CENTERTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 423289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702325124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14565",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "201 W BROAD ST",
    "dropdelcty": "CENTRAL CITY",
    "dropdelst": "KY",
    "dropdelzpp": 423309998,
    "dropphyadd": "201 W BROAD ST",
    "dropphycty": "CENTRAL CITY",
    "dropphyst": "KY",
    "dropphyzpp": 423309998,
    "dropmaladd": "201 W BROAD ST",
    "dropmalcty": "CENTRAL CITY",
    "dropmalst": "KY",
    "dropmalzpp": 423309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707544811,
    "dropfax": 2707549859
  },
  {
    "dcode": "D",
    "dropkey": "PX14568",
    "droptype": "D",
    "dropname": "CERULEAN",
    "dropdeladd": "417 MAIN ST",
    "dropdelcty": "CERULEAN",
    "dropdelst": "KY",
    "dropdelzpp": 422159998,
    "dropphyadd": "417 MAIN ST",
    "dropphycty": "CERULEAN",
    "dropphyst": "KY",
    "dropphyzpp": 422159998,
    "dropmaladd": "417 MAIN ST",
    "dropmalcty": "CERULEAN",
    "dropmalst": "KY",
    "dropmalzpp": 422159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702355204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14575",
    "droptype": "D",
    "dropname": "CHAPLIN",
    "dropdeladd": "24 OLD TUNNELL MILL RD",
    "dropdelcty": "CHAPLIN",
    "dropdelst": "KY",
    "dropdelzpp": 400129998,
    "dropphyadd": "24 OLD TUNNELL MILL RD",
    "dropphycty": "CHAPLIN",
    "dropphyst": "KY",
    "dropphyzpp": 400129998,
    "dropmaladd": "24 OLD TUNNELL MILL RD",
    "dropmalcty": "CHAPLIN",
    "dropmalst": "KY",
    "dropmalzpp": 400129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5026733580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14580",
    "droptype": "D",
    "dropname": "CHAVIES",
    "dropdeladd": "5876 KY HIGHWAY 28",
    "dropdelcty": "CHAVIES",
    "dropdelst": "KY",
    "dropdelzpp": 417279998,
    "dropphyadd": "5876 KY HIGHWAY 28",
    "dropphycty": "CHAVIES",
    "dropphyst": "KY",
    "dropphyzpp": 417279998,
    "dropmaladd": "5876 KY HIGHWAY 28",
    "dropmalcty": "CHAVIES",
    "dropmalst": "KY",
    "dropmalzpp": 417279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064394212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14599",
    "droptype": "D",
    "dropname": "CLARKSON",
    "dropdeladd": "211 MILLERSTOWN ST",
    "dropdelcty": "CLARKSON",
    "dropdelst": "KY",
    "dropdelzpp": 427269998,
    "dropphyadd": "211 MILLERSTOWN ST",
    "dropphycty": "CLARKSON",
    "dropphyst": "KY",
    "dropphyzpp": 427269998,
    "dropmaladd": "211 MILLERSTOWN ST",
    "dropmalcty": "CLARKSON",
    "dropmalst": "KY",
    "dropmalzpp": 427269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702427214,
    "dropfax": 2702429624
  },
  {
    "dcode": "D",
    "dropkey": "PX14601",
    "droptype": "D",
    "dropname": "CLAY",
    "dropdeladd": "39 E ELM ST",
    "dropdelcty": "CLAY",
    "dropdelst": "KY",
    "dropdelzpp": 424049998,
    "dropphyadd": "39 E ELM ST",
    "dropphycty": "CLAY",
    "dropphyst": "KY",
    "dropphyzpp": 424049998,
    "dropmaladd": "39 E ELM ST",
    "dropmalcty": "CLAY",
    "dropmalst": "KY",
    "dropmalzpp": 424049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706642791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14602",
    "droptype": "D",
    "dropname": "CLAY CITY",
    "dropdeladd": "70 RIVER ST",
    "dropdelcty": "CLAY CITY",
    "dropdelst": "KY",
    "dropdelzpp": 403129998,
    "dropphyadd": "70 RIVER ST",
    "dropphycty": "CLAY CITY",
    "dropphyst": "KY",
    "dropphyzpp": 403129998,
    "dropmaladd": "70 RIVER ST",
    "dropmalcty": "CLAY CITY",
    "dropmalst": "KY",
    "dropmalzpp": 403129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066635525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14604",
    "droptype": "D",
    "dropname": "CLAYHOLE",
    "dropdeladd": "3757 HIGHWAY 476",
    "dropdelcty": "CLAYHOLE",
    "dropdelst": "KY",
    "dropdelzpp": 413179998,
    "dropphyadd": "3757 HIGHWAY 476",
    "dropphycty": "CLAYHOLE",
    "dropphyst": "KY",
    "dropphyzpp": 413179998,
    "dropmaladd": "3757 HIGHWAY 476",
    "dropmalcty": "CLAYHOLE",
    "dropmalst": "KY",
    "dropmalzpp": 413179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066668784,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14610",
    "droptype": "D",
    "dropname": "CLEARFIELD",
    "dropdeladd": "519 KY HIGHWAY 519",
    "dropdelcty": "CLEARFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 403139998,
    "dropphyadd": "519 KY HIGHWAY 519",
    "dropphycty": "CLEARFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 403139998,
    "dropmaladd": "519 KY HIGHWAY 519",
    "dropmalcty": "CLEARFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 403139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067848544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14611",
    "droptype": "D",
    "dropname": "CLEATON",
    "dropdeladd": "36 MAIN ST",
    "dropdelcty": "CLEATON",
    "dropdelst": "KY",
    "dropdelzpp": 423329998,
    "dropphyadd": "36 MAIN ST",
    "dropphycty": "CLEATON",
    "dropphyst": "KY",
    "dropphyzpp": 423329998,
    "dropmaladd": "36 MAIN ST",
    "dropmalcty": "CLEATON",
    "dropmalst": "KY",
    "dropmalzpp": 423329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707544864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14613",
    "droptype": "D",
    "dropname": "CLERMONT",
    "dropdeladd": "243 HAPPY HOLLOW RD",
    "dropdelcty": "CLERMONT",
    "dropdelst": "KY",
    "dropdelzpp": 401109998,
    "dropphyadd": "243 HAPPY HOLLOW RD",
    "dropphycty": "CLERMONT",
    "dropphyst": "KY",
    "dropphyzpp": 401109998,
    "dropmaladd": "243 HAPPY HOLLOW RD",
    "dropmalcty": "CLERMONT",
    "dropmalst": "KY",
    "dropmalzpp": 401109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025434695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14616",
    "droptype": "D",
    "dropname": "CLIFTY",
    "dropdeladd": "13290 GREENVILLE RD",
    "dropdelcty": "CLIFTY",
    "dropdelst": "KY",
    "dropdelzpp": 422169998,
    "dropphyadd": "13290 GREENVILLE RD",
    "dropphycty": "CLIFTY",
    "dropphyst": "KY",
    "dropphyzpp": 422169998,
    "dropmaladd": "13290 GREENVILLE RD",
    "dropmalcty": "CLIFTY",
    "dropmalst": "KY",
    "dropmalzpp": 422169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702779143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14618",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "304 S WASHINGTON ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "KY",
    "dropdelzpp": 420319998,
    "dropphyadd": "304 S WASHINGTON ST",
    "dropphycty": "CLINTON",
    "dropphyst": "KY",
    "dropphyzpp": 420319998,
    "dropmaladd": "304 S WASHINGTON ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "KY",
    "dropmalzpp": 420319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706536046,
    "dropfax": 2706535733
  },
  {
    "dcode": "D",
    "dropkey": "PX14620",
    "droptype": "D",
    "dropname": "CLOSPLINT",
    "dropdeladd": "17857 HIGHWAY 38",
    "dropdelcty": "CLOSPLINT",
    "dropdelst": "KY",
    "dropdelzpp": 409279998,
    "dropphyadd": "17857 HIGHWAY 38",
    "dropphycty": "CLOSPLINT",
    "dropphyst": "KY",
    "dropphyzpp": 409279998,
    "dropmaladd": "17857 HIGHWAY 38",
    "dropmalcty": "CLOSPLINT",
    "dropmalst": "KY",
    "dropmalzpp": 409279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068373611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14623",
    "droptype": "D",
    "dropname": "CLOVERPORT",
    "dropdeladd": "218 POPLAR ST",
    "dropdelcty": "CLOVERPORT",
    "dropdelst": "KY",
    "dropdelzpp": 401119998,
    "dropphyadd": "218 POPLAR ST",
    "dropphycty": "CLOVERPORT",
    "dropphyst": "KY",
    "dropphyzpp": 401119998,
    "dropmaladd": "218 POPLAR ST",
    "dropmalcty": "CLOVERPORT",
    "dropmalst": "KY",
    "dropmalzpp": 401119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707883865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14639",
    "droptype": "D",
    "dropname": "COLDIRON",
    "dropdeladd": "329 HIGHWAY 2007",
    "dropdelcty": "COLDIRON",
    "dropdelst": "KY",
    "dropdelzpp": 408199998,
    "dropphyadd": "329 HIGHWAY 2007",
    "dropphycty": "COLDIRON",
    "dropphyst": "KY",
    "dropphyzpp": 408199998,
    "dropmaladd": "329 HIGHWAY 2007",
    "dropmalcty": "COLDIRON",
    "dropmalst": "KY",
    "dropmalzpp": 408199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066642591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14652",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "800 BURKESVILLE ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "KY",
    "dropdelzpp": 427289998,
    "dropphyadd": "800 BURKESVILLE ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "KY",
    "dropphyzpp": 427289998,
    "dropmaladd": "800 BURKESVILLE ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "KY",
    "dropmalzpp": 427289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703843206,
    "dropfax": 2703859336
  },
  {
    "dcode": "D",
    "dropkey": "PX14654",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "55 E HOOVER PKWY",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "KY",
    "dropdelzpp": 420329998,
    "dropphyadd": "55 E HOOVER PKWY",
    "dropphycty": "COLUMBUS",
    "dropphyst": "KY",
    "dropphyzpp": 420329998,
    "dropmaladd": "55 E HOOVER PKWY",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "KY",
    "dropmalzpp": 420329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706771746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14656",
    "droptype": "D",
    "dropname": "COMBS",
    "dropdeladd": "526 W KY HIGHWAY 80 STE 102",
    "dropdelcty": "COMBS",
    "dropdelst": "KY",
    "dropdelzpp": 417299998,
    "dropphyadd": "526 W KY HIGHWAY 80 STE 102",
    "dropphycty": "COMBS",
    "dropphyst": "KY",
    "dropphyzpp": 417299998,
    "dropmaladd": "526 W KY HIGHWAY 80 STE 102",
    "dropmalcty": "COMBS",
    "dropmalst": "KY",
    "dropmalzpp": 417299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064393354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14670",
    "droptype": "D",
    "dropname": "CORBIN",
    "dropdeladd": "301 ROY KIDD AVE",
    "dropdelcty": "CORBIN",
    "dropdelst": "KY",
    "dropdelzpp": 407019998,
    "dropphyadd": "301 ROY KIDD AVE",
    "dropphycty": "CORBIN",
    "dropphyst": "KY",
    "dropphyzpp": 407019998,
    "dropmaladd": "301 ROY KIDD AVE",
    "dropmalcty": "CORBIN",
    "dropmalst": "KY",
    "dropmalzpp": 407019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065283912,
    "dropfax": 6065282412
  },
  {
    "dcode": "D",
    "dropkey": "PX14672",
    "droptype": "D",
    "dropname": "CORINTH",
    "dropdeladd": "315 OWENTON RD",
    "dropdelcty": "CORINTH",
    "dropdelst": "KY",
    "dropdelzpp": 410109998,
    "dropphyadd": "315 OWENTON RD",
    "dropphycty": "CORINTH",
    "dropphyst": "KY",
    "dropphyzpp": 410109998,
    "dropmaladd": "315 OWENTON RD",
    "dropmalcty": "CORINTH",
    "dropmalst": "KY",
    "dropmalzpp": 410109998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8598231999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14677",
    "droptype": "D",
    "dropname": "CORNETTSVILLE",
    "dropdeladd": "11571 KY HIGHWAY 7",
    "dropdelcty": "CORNETTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 417319998,
    "dropphyadd": "11571 KY HIGHWAY 7",
    "dropphycty": "CORNETTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 417319998,
    "dropmaladd": "11571 KY HIGHWAY 7",
    "dropmalcty": "CORNETTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 417319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064762577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14679",
    "droptype": "D",
    "dropname": "CORYDON",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "CORYDON",
    "dropdelst": "KY",
    "dropdelzpp": 424069998,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "CORYDON",
    "dropphyst": "KY",
    "dropphyzpp": 424069998,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "CORYDON",
    "dropmalst": "KY",
    "dropmalzpp": 424069998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705336081,
    "dropfax": 2705331606
  },
  {
    "dcode": "D",
    "dropkey": "PX14687",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "700 SCOTT ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 410119998,
    "dropphyadd": "700 SCOTT ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 410119998,
    "dropmaladd": "700 SCOTT ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 410119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8592610809,
    "dropfax": 8592616815
  },
  {
    "dcode": "D",
    "dropkey": "PX14689",
    "droptype": "D",
    "dropname": "COXS CREEK",
    "dropdeladd": "6120 LOUISVILLE RD",
    "dropdelcty": "COXS CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 400139998,
    "dropphyadd": "6120 LOUISVILLE RD",
    "dropphycty": "COXS CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 400139998,
    "dropmaladd": "6120 LOUISVILLE RD",
    "dropmalcty": "COXS CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 400139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023485590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14691",
    "droptype": "D",
    "dropname": "CRAB ORCHARD",
    "dropdeladd": "41 MAIN ST",
    "dropdelcty": "CRAB ORCHARD",
    "dropdelst": "KY",
    "dropdelzpp": 404199998,
    "dropphyadd": "41 MAIN ST",
    "dropphycty": "CRAB ORCHARD",
    "dropphyst": "KY",
    "dropphyzpp": 404199998,
    "dropmaladd": "41 MAIN ST",
    "dropmalcty": "CRAB ORCHARD",
    "dropmalst": "KY",
    "dropmalzpp": 404199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063552337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14695",
    "droptype": "D",
    "dropname": "CRANKS",
    "dropdeladd": "14869 S US HIGHWAY 421",
    "dropdelcty": "CRANKS",
    "dropdelst": "KY",
    "dropdelzpp": 408209998,
    "dropphyadd": "14869 S US HIGHWAY 421",
    "dropphycty": "CRANKS",
    "dropphyst": "KY",
    "dropphyzpp": 408209998,
    "dropmaladd": "14869 S US HIGHWAY 421",
    "dropmalcty": "CRANKS",
    "dropmalst": "KY",
    "dropmalzpp": 408209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065732133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14698",
    "droptype": "D",
    "dropname": "CRAYNE",
    "dropdeladd": "4577 US HIGHWAY 641",
    "dropdelcty": "CRAYNE",
    "dropdelst": "KY",
    "dropdelzpp": 420339998,
    "dropphyadd": "4577 US HIGHWAY 641",
    "dropphycty": "CRAYNE",
    "dropphyst": "KY",
    "dropphyzpp": 420339998,
    "dropmaladd": "4577 US HIGHWAY 641",
    "dropmalcty": "CRAYNE",
    "dropmalst": "KY",
    "dropmalzpp": 420339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709654223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14712",
    "droptype": "D",
    "dropname": "CRESTWOOD",
    "dropdeladd": "6815 CENTRAL AVE",
    "dropdelcty": "CRESTWOOD",
    "dropdelst": "KY",
    "dropdelzpp": 400149998,
    "dropphyadd": "6815 CENTRAL AVE",
    "dropphycty": "CRESTWOOD",
    "dropphyst": "KY",
    "dropphyzpp": 400149998,
    "dropmaladd": "6815 CENTRAL AVE",
    "dropmalcty": "CRESTWOOD",
    "dropmalst": "KY",
    "dropmalzpp": 400149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022414111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14714",
    "droptype": "D",
    "dropname": "CRITTENDEN",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "CRITTENDEN",
    "dropdelst": "KY",
    "dropdelzpp": 410309998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "CRITTENDEN",
    "dropphyst": "KY",
    "dropphyzpp": 410309998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "CRITTENDEN",
    "dropmalst": "KY",
    "dropmalzpp": 410309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594280328,
    "dropsitcph": 8594280328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14715",
    "droptype": "D",
    "dropname": "CROCKETT",
    "dropdeladd": "18 HIGHWAY 706",
    "dropdelcty": "CROCKETT",
    "dropdelst": "KY",
    "dropdelzpp": 414139998,
    "dropphyadd": "18 HIGHWAY 706",
    "dropphycty": "CROCKETT",
    "dropphyst": "KY",
    "dropphyzpp": 414139998,
    "dropmaladd": "18 HIGHWAY 706",
    "dropmalcty": "CROCKETT",
    "dropmalst": "KY",
    "dropmalzpp": 414139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065224883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14717",
    "droptype": "D",
    "dropname": "CROFTON",
    "dropdeladd": "112 S MADISONVILLE ST",
    "dropdelcty": "CROFTON",
    "dropdelst": "KY",
    "dropdelzpp": 422179998,
    "dropphyadd": "112 S MADISONVILLE ST",
    "dropphycty": "CROFTON",
    "dropphyst": "KY",
    "dropphyzpp": 422179998,
    "dropmaladd": "112 S MADISONVILLE ST",
    "dropmalcty": "CROFTON",
    "dropmalst": "KY",
    "dropmalzpp": 422179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704248878,
    "dropfax": 2704240361
  },
  {
    "dcode": "D",
    "dropkey": "PX14719",
    "droptype": "D",
    "dropname": "CROMONA",
    "dropdeladd": "4761 HIGHWAY 805",
    "dropdelcty": "CROMONA",
    "dropdelst": "KY",
    "dropdelzpp": 418109998,
    "dropphyadd": "4761 HIGHWAY 805",
    "dropphycty": "CROMONA",
    "dropphyst": "KY",
    "dropphyzpp": 418109998,
    "dropmaladd": "4761 HIGHWAY 805",
    "dropmalcty": "CROMONA",
    "dropmalst": "KY",
    "dropmalzpp": 418109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068557308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14727",
    "droptype": "D",
    "dropname": "CUB RUN",
    "dropdeladd": "12753 CUB RUN HWY",
    "dropdelcty": "CUB RUN",
    "dropdelst": "KY",
    "dropdelzpp": 427299998,
    "dropphyadd": "12753 CUB RUN HWY",
    "dropphycty": "CUB RUN",
    "dropphyst": "KY",
    "dropphyzpp": 427299998,
    "dropmaladd": "12753 CUB RUN HWY",
    "dropmalcty": "CUB RUN",
    "dropmalst": "KY",
    "dropmalzpp": 427299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705241011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14730",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "1312 E MAIN ST",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "KY",
    "dropdelzpp": 408239998,
    "dropphyadd": "1312 E MAIN ST",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "KY",
    "dropphyzpp": 408239998,
    "dropmaladd": "1312 E MAIN ST",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "KY",
    "dropmalzpp": 408239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065892192,
    "dropfax": 6065892351
  },
  {
    "dcode": "D",
    "dropkey": "PX14737",
    "droptype": "D",
    "dropname": "CUNNINGHAM",
    "dropdeladd": "54 STATE ROUTE 1820",
    "dropdelcty": "CUNNINGHAM",
    "dropdelst": "KY",
    "dropdelzpp": 420359998,
    "dropphyadd": "54 STATE ROUTE 1820",
    "dropphycty": "CUNNINGHAM",
    "dropphyst": "KY",
    "dropphyzpp": 420359998,
    "dropmaladd": "54 STATE ROUTE 1820",
    "dropmalcty": "CUNNINGHAM",
    "dropmalst": "KY",
    "dropmalzpp": 420359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703011520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14742",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "6028 E HIGHWAY 86",
    "dropdelcty": "CUSTER",
    "dropdelst": "KY",
    "dropdelzpp": 401159998,
    "dropphyadd": "6028 E HIGHWAY 86",
    "dropphycty": "CUSTER",
    "dropphyst": "KY",
    "dropphyzpp": 401159998,
    "dropmaladd": "6028 E HIGHWAY 86",
    "dropmalcty": "CUSTER",
    "dropmalst": "KY",
    "dropmalzpp": 401159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705363627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14746",
    "droptype": "D",
    "dropname": "CYNTHIANA",
    "dropdeladd": "108 LADISH RD",
    "dropdelcty": "CYNTHIANA",
    "dropdelst": "KY",
    "dropdelzpp": 410319998,
    "dropphyadd": "108 LADISH RD",
    "dropphycty": "CYNTHIANA",
    "dropphyst": "KY",
    "dropphyzpp": 410319998,
    "dropmaladd": "108 LADISH RD",
    "dropmalcty": "CYNTHIANA",
    "dropmalst": "KY",
    "dropmalzpp": 410319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8592348741,
    "dropsitcph": 8592344632,
    "dropfax": 8592349800
  },
  {
    "dcode": "D",
    "dropkey": "PX14756",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404229998,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404229998,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592366334,
    "dropfax": 8592365264
  },
  {
    "dcode": "D",
    "dropkey": "PX14761",
    "droptype": "D",
    "dropname": "DAVID",
    "dropdeladd": "6693 KY ROUTE 404",
    "dropdelcty": "DAVID",
    "dropdelst": "KY",
    "dropdelzpp": 416169998,
    "dropphyadd": "6693 KY ROUTE 404",
    "dropphycty": "DAVID",
    "dropphyst": "KY",
    "dropphyzpp": 416169998,
    "dropmaladd": "6693 KY ROUTE 404",
    "dropmalcty": "DAVID",
    "dropmalst": "KY",
    "dropmalzpp": 416169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068861009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14766",
    "droptype": "D",
    "dropname": "DAWSON SPRINGS",
    "dropdeladd": "101 W RAMSEY ST",
    "dropdelcty": "DAWSON SPRINGS",
    "dropdelst": "KY",
    "dropdelzpp": 424089998,
    "dropphyadd": "101 W RAMSEY ST",
    "dropphycty": "DAWSON SPRINGS",
    "dropphyst": "KY",
    "dropphyzpp": 424089998,
    "dropmaladd": "101 W RAMSEY ST",
    "dropmalcty": "DAWSON SPRINGS",
    "dropmalst": "KY",
    "dropmalzpp": 424089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707975598,
    "dropfax": 2707975598
  },
  {
    "dcode": "D",
    "dropkey": "PX14771",
    "droptype": "D",
    "dropname": "DE MOSSVILLE",
    "dropdeladd": "7451 HIGHWAY 17 N",
    "dropdelcty": "DE MOSSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 410339998,
    "dropphyadd": "7451 HIGHWAY 17 N",
    "dropphycty": "DE MOSSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 410339998,
    "dropmaladd": "7451 HIGHWAY 17 N",
    "dropmalcty": "DE MOSSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594722557,
    "dropsitcph": 8594722557,
    "dropfax": 8594722557
  },
  {
    "dcode": "D",
    "dropkey": "PX14774",
    "droptype": "D",
    "dropname": "DEANE",
    "dropdeladd": "11125 HIGHWAY 7 N",
    "dropdelcty": "DEANE",
    "dropdelst": "KY",
    "dropdelzpp": 418129998,
    "dropphyadd": "11125 HIGHWAY 7 N",
    "dropphycty": "DEANE",
    "dropphyst": "KY",
    "dropphyzpp": 418129998,
    "dropmaladd": "11125 HIGHWAY 7 N",
    "dropmalcty": "DEANE",
    "dropmalst": "KY",
    "dropmalzpp": 418129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068554755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14786",
    "droptype": "D",
    "dropname": "DELPHIA",
    "dropdeladd": "3946 KY HIGHWAY 463 STE 102",
    "dropdelcty": "DELPHIA",
    "dropdelst": "KY",
    "dropdelzpp": 417359998,
    "dropphyadd": "3946 KY HIGHWAY 463 STE 102",
    "dropphycty": "DELPHIA",
    "dropphyst": "KY",
    "dropphyzpp": 417359998,
    "dropmaladd": "3946 KY HIGHWAY 463 STE 102",
    "dropmalcty": "DELPHIA",
    "dropmalst": "KY",
    "dropmalzpp": 417359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066757400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14795",
    "droptype": "D",
    "dropname": "DENNISTON",
    "dropdeladd": "6969 US HIGHWAY 460 E",
    "dropdelcty": "DENNISTON",
    "dropdelst": "KY",
    "dropdelzpp": 403169998,
    "dropphyadd": "6969 US HIGHWAY 460 E",
    "dropphycty": "DENNISTON",
    "dropphyst": "KY",
    "dropphyzpp": 403169998,
    "dropmaladd": "6969 US HIGHWAY 460 E",
    "dropmalcty": "DENNISTON",
    "dropmalst": "KY",
    "dropmalzpp": 403169998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067689886,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14801",
    "droptype": "D",
    "dropname": "DEWITT",
    "dropdeladd": "2956 KY 223",
    "dropdelcty": "DEWITT",
    "dropdelst": "KY",
    "dropdelzpp": 409309998,
    "dropphyadd": "2956 KY 223",
    "dropphycty": "DEWITT",
    "dropphyst": "KY",
    "dropphyzpp": 409309998,
    "dropmaladd": "2956 KY 223",
    "dropmalcty": "DEWITT",
    "dropmalst": "KY",
    "dropmalzpp": 409309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065424399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14802",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "4580 RADIO RD",
    "dropdelcty": "DEXTER",
    "dropdelst": "KY",
    "dropdelzpp": 420369998,
    "dropphyadd": "4580 RADIO RD",
    "dropphycty": "DEXTER",
    "dropphyst": "KY",
    "dropphyzpp": 420369998,
    "dropmaladd": "4580 RADIO RD",
    "dropmalcty": "DEXTER",
    "dropmalst": "KY",
    "dropmalzpp": 420369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704374769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14805",
    "droptype": "D",
    "dropname": "DICE",
    "dropdeladd": "4188 SIXTEENMILE CREEK RD STE 102",
    "dropdelcty": "DICE",
    "dropdelst": "KY",
    "dropdelzpp": 417369998,
    "dropphyadd": "4188 SIXTEENMILE CREEK RD STE 102",
    "dropphycty": "DICE",
    "dropphyst": "KY",
    "dropphyzpp": 417369998,
    "dropmaladd": "4188 SIXTEENMILE CREEK RD STE 102",
    "dropmalcty": "DICE",
    "dropmalst": "KY",
    "dropmalzpp": 417369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064393546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14813",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "73 US HIGHWAY 41A S",
    "dropdelcty": "DIXON",
    "dropdelst": "KY",
    "dropdelzpp": 424099998,
    "dropphyadd": "73 US HIGHWAY 41A S",
    "dropphycty": "DIXON",
    "dropphyst": "KY",
    "dropphyzpp": 424099998,
    "dropmaladd": "73 US HIGHWAY 41A S",
    "dropmalcty": "DIXON",
    "dropmalst": "KY",
    "dropmalzpp": 424099998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706395511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14826",
    "droptype": "D",
    "dropname": "DORTON",
    "dropdeladd": "87 DORTON JENKINS HWY",
    "dropdelcty": "DORTON",
    "dropdelst": "KY",
    "dropdelzpp": 415209998,
    "dropphyadd": "87 DORTON JENKINS HWY",
    "dropphycty": "DORTON",
    "dropphyst": "KY",
    "dropphyzpp": 415209998,
    "dropmaladd": "87 DORTON JENKINS HWY",
    "dropmalcty": "DORTON",
    "dropmalst": "KY",
    "dropmalzpp": 415209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066398162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14830",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "2047 MARKET ST",
    "dropdelcty": "DOVER",
    "dropdelst": "KY",
    "dropdelzpp": 410349998,
    "dropphyadd": "2047 MARKET ST",
    "dropphycty": "DOVER",
    "dropphyst": "KY",
    "dropphyzpp": 410349998,
    "dropmaladd": "2047 MARKET ST",
    "dropmalcty": "DOVER",
    "dropmalst": "KY",
    "dropmalzpp": 410349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6068822400,
    "dropsitcph": 6068822400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14838",
    "droptype": "D",
    "dropname": "DRAKESBORO",
    "dropdeladd": "111 W MOSE RAGER BLVD",
    "dropdelcty": "DRAKESBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423379998,
    "dropphyadd": "111 W MOSE RAGER BLVD",
    "dropphycty": "DRAKESBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423379998,
    "dropmaladd": "111 W MOSE RAGER BLVD",
    "dropmalcty": "DRAKESBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704768542,
    "dropfax": 2704768542
  },
  {
    "dcode": "D",
    "dropkey": "PX14846",
    "droptype": "D",
    "dropname": "DRY RIDGE",
    "dropdeladd": "80 S MAIN ST",
    "dropdelcty": "DRY RIDGE",
    "dropdelst": "KY",
    "dropdelzpp": 410359998,
    "dropphyadd": "80 S MAIN ST",
    "dropphycty": "DRY RIDGE",
    "dropphyst": "KY",
    "dropphyzpp": 410359998,
    "dropmaladd": "80 S MAIN ST",
    "dropmalcty": "DRY RIDGE",
    "dropmalst": "KY",
    "dropmalzpp": 410359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8598240485,
    "dropsitcph": 8598240485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14858",
    "droptype": "D",
    "dropname": "DUNMOR",
    "dropdeladd": "11230 US HIGHWAY 431 S",
    "dropdelcty": "DUNMOR",
    "dropdelst": "KY",
    "dropdelzpp": 423399998,
    "dropphyadd": "11230 US HIGHWAY 431 S",
    "dropphycty": "DUNMOR",
    "dropphyst": "KY",
    "dropphyzpp": 423399998,
    "dropmaladd": "11230 US HIGHWAY 431 S",
    "dropmalcty": "DUNMOR",
    "dropmalst": "KY",
    "dropmalzpp": 423399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8779074070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14859",
    "droptype": "D",
    "dropname": "DUNNVILLE",
    "dropdeladd": "10765 S US 127",
    "dropdelcty": "DUNNVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 425289998,
    "dropphyadd": "10765 S US 127",
    "dropphycty": "DUNNVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 425289998,
    "dropmaladd": "10765 S US 127",
    "dropmalcty": "DUNNVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 425289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067875024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14862",
    "droptype": "D",
    "dropname": "DWALE",
    "dropdeladd": "310 BEAVER JUNCTION RD",
    "dropdelcty": "DWALE",
    "dropdelst": "KY",
    "dropdelzpp": 416219998,
    "dropphyadd": "310 BEAVER JUNCTION RD",
    "dropphycty": "DWALE",
    "dropphyst": "KY",
    "dropphyzpp": 416219998,
    "dropmaladd": "310 BEAVER JUNCTION RD",
    "dropmalcty": "DWALE",
    "dropmalst": "KY",
    "dropmalzpp": 416219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068742982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14863",
    "droptype": "D",
    "dropname": "DWARF",
    "dropdeladd": "9325 KY HIGHWAY 476",
    "dropdelcty": "DWARF",
    "dropdelst": "KY",
    "dropdelzpp": 417399998,
    "dropphyadd": "9325 KY HIGHWAY 476",
    "dropphycty": "DWARF",
    "dropphyst": "KY",
    "dropphyzpp": 417399998,
    "dropmaladd": "9325 KY HIGHWAY 476",
    "dropmalcty": "DWARF",
    "dropmalst": "KY",
    "dropmalzpp": 417399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063787031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14864",
    "droptype": "D",
    "dropname": "DYCUSBURG",
    "dropdeladd": "9699 STATE ROUTE 70",
    "dropdelcty": "DYCUSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 420379998,
    "dropphyadd": "9699 STATE ROUTE 70",
    "dropphycty": "DYCUSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 420379998,
    "dropmaladd": "9699 STATE ROUTE 70",
    "dropmalcty": "DYCUSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 420379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709882020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14870",
    "droptype": "D",
    "dropname": "EARLINGTON",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "EARLINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 424109998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "EARLINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 424109998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "EARLINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 424109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703835554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14871",
    "droptype": "D",
    "dropname": "EAST BERNSTADT",
    "dropdeladd": "1066 HIGHWAY 490",
    "dropdelcty": "EAST BERNSTADT",
    "dropdelst": "KY",
    "dropdelzpp": 407299998,
    "dropphyadd": "1066 HIGHWAY 490",
    "dropphycty": "EAST BERNSTADT",
    "dropphyst": "KY",
    "dropphyzpp": 407299998,
    "dropmaladd": "1066 HIGHWAY 490",
    "dropmalcty": "EAST BERNSTADT",
    "dropmalst": "KY",
    "dropmalzpp": 407299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068436521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14877",
    "droptype": "D",
    "dropname": "EASTERN",
    "dropdeladd": "356 KY ROUTE 550",
    "dropdelcty": "EASTERN",
    "dropdelst": "KY",
    "dropdelzpp": 416229998,
    "dropphyadd": "356 KY ROUTE 550",
    "dropphycty": "EASTERN",
    "dropphyst": "KY",
    "dropphyzpp": 416229998,
    "dropmaladd": "356 KY ROUTE 550",
    "dropmalcty": "EASTERN",
    "dropmalst": "KY",
    "dropmalzpp": 416229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063589586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14879",
    "droptype": "D",
    "dropname": "EASTVIEW",
    "dropdeladd": "2885 EASTVIEW RD",
    "dropdelcty": "EASTVIEW",
    "dropdelst": "KY",
    "dropdelzpp": 427329998,
    "dropphyadd": "2885 EASTVIEW RD",
    "dropphycty": "EASTVIEW",
    "dropphyst": "KY",
    "dropphyzpp": 427329998,
    "dropmaladd": "2885 EASTVIEW RD",
    "dropmalcty": "EASTVIEW",
    "dropmalst": "KY",
    "dropmalzpp": 427329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708629449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14880",
    "droptype": "D",
    "dropname": "EASTWOOD",
    "dropdeladd": "16207 EASTWOOD CUT OFF RD",
    "dropdelcty": "EASTWOOD",
    "dropdelst": "KY",
    "dropdelzpp": 400189998,
    "dropphyadd": "16207 EASTWOOD CUT OFF RD",
    "dropphycty": "EASTWOOD",
    "dropphyst": "KY",
    "dropphyzpp": 400189998,
    "dropmaladd": "16207 EASTWOOD CUT OFF RD",
    "dropmalcty": "EASTWOOD",
    "dropmalst": "KY",
    "dropmalzpp": 400189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022362456,
    "dropfax": 5022450075
  },
  {
    "dcode": "D",
    "dropkey": "PX14886",
    "droptype": "D",
    "dropname": "EDDYVILLE",
    "dropdeladd": "144 COMMERCE ST",
    "dropdelcty": "EDDYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 420389998,
    "dropphyadd": "144 COMMERCE ST",
    "dropphycty": "EDDYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 420389998,
    "dropmaladd": "144 COMMERCE ST",
    "dropmalcty": "EDDYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 420389998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703887227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14891",
    "droptype": "D",
    "dropname": "EDMONTON",
    "dropdeladd": "202 HAMILTON ST",
    "dropdelcty": "EDMONTON",
    "dropdelst": "KY",
    "dropdelzpp": 421299998,
    "dropphyadd": "202 HAMILTON ST",
    "dropphycty": "EDMONTON",
    "dropphyst": "KY",
    "dropphyzpp": 421299998,
    "dropmaladd": "202 HAMILTON ST",
    "dropmalcty": "EDMONTON",
    "dropmalst": "KY",
    "dropmalzpp": 421299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704322421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14897",
    "droptype": "D",
    "dropname": "EKRON",
    "dropdeladd": "276 REESE AVE",
    "dropdelcty": "EKRON",
    "dropdelst": "KY",
    "dropdelzpp": 401179998,
    "dropphyadd": "276 REESE AVE",
    "dropphycty": "EKRON",
    "dropphyst": "KY",
    "dropphyzpp": 401179998,
    "dropmaladd": "276 REESE AVE",
    "dropmalcty": "EKRON",
    "dropmalst": "KY",
    "dropmalzpp": 401179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708275520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14905",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "2934 DOLPHIN DR",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 427019998,
    "dropphyadd": "2934 DOLPHIN DR",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 427019998,
    "dropmaladd": "2934 DOLPHIN DR",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 427019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705065010,
    "dropfax": 2701657230
  },
  {
    "dcode": "D",
    "dropkey": "PX14912",
    "droptype": "D",
    "dropname": "ELKHORN CITY",
    "dropdeladd": "145 W RUSSELL ST",
    "dropdelcty": "ELKHORN CITY",
    "dropdelst": "KY",
    "dropdelzpp": 415229998,
    "dropphyadd": "145 W RUSSELL ST",
    "dropphycty": "ELKHORN CITY",
    "dropphyst": "KY",
    "dropphyzpp": 415229998,
    "dropmaladd": "145 W RUSSELL ST",
    "dropmalcty": "ELKHORN CITY",
    "dropmalst": "KY",
    "dropmalzpp": 415229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067544685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14913",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "KY",
    "dropdelzpp": 422209998,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "ELKTON",
    "dropphyst": "KY",
    "dropphyzpp": 422209998,
    "dropmaladd": "102 W MAIN ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "KY",
    "dropmalzpp": 422209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702652294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14916",
    "droptype": "D",
    "dropname": "ELLIOTTVILLE",
    "dropdeladd": "8061 CHRISTY CREEK RD",
    "dropdelcty": "ELLIOTTVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 403179998,
    "dropphyadd": "8061 CHRISTY CREEK RD",
    "dropphycty": "ELLIOTTVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 403179998,
    "dropmaladd": "8061 CHRISTY CREEK RD",
    "dropmalcty": "ELLIOTTVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 403179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067849843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14925",
    "droptype": "D",
    "dropname": "EMINENCE",
    "dropdeladd": "4827 N MAIN ST",
    "dropdelcty": "EMINENCE",
    "dropdelst": "KY",
    "dropdelzpp": 400199998,
    "dropphyadd": "4827 N MAIN ST",
    "dropphycty": "EMINENCE",
    "dropphyst": "KY",
    "dropphyzpp": 400199998,
    "dropmaladd": "4827 N MAIN ST",
    "dropmalcty": "EMINENCE",
    "dropmalst": "KY",
    "dropmalzpp": 400199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028454124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14926",
    "droptype": "D",
    "dropname": "EMLYN",
    "dropdeladd": "3052 US HIGHWAY 25 W",
    "dropdelcty": "EMLYN",
    "dropdelst": "KY",
    "dropdelzpp": 407309998,
    "dropphyadd": "3052 US HIGHWAY 25 W",
    "dropphycty": "EMLYN",
    "dropphyst": "KY",
    "dropphyzpp": 407309998,
    "dropmaladd": "3052 US HIGHWAY 25 W",
    "dropmalcty": "EMLYN",
    "dropmalst": "KY",
    "dropmalzpp": 407309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065399392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14928",
    "droptype": "D",
    "dropname": "EMMALENA",
    "dropdeladd": "8334 HIGHWAY 550 W",
    "dropdelcty": "EMMALENA",
    "dropdelst": "KY",
    "dropdelzpp": 417409998,
    "dropphyadd": "8334 HIGHWAY 550 W",
    "dropphycty": "EMMALENA",
    "dropphyst": "KY",
    "dropphyzpp": 417409998,
    "dropmaladd": "8334 HIGHWAY 550 W",
    "dropmalcty": "EMMALENA",
    "dropmalst": "KY",
    "dropmalzpp": 417409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062513390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14934",
    "droptype": "D",
    "dropname": "EOLIA",
    "dropdeladd": "1364 HIGHWAY 806",
    "dropdelcty": "EOLIA",
    "dropdelst": "KY",
    "dropdelzpp": 408269998,
    "dropphyadd": "1364 HIGHWAY 806",
    "dropphycty": "EOLIA",
    "dropphyst": "KY",
    "dropphyzpp": 408269998,
    "dropmaladd": "1364 HIGHWAY 806",
    "dropmalcty": "EOLIA",
    "dropmalst": "KY",
    "dropmalzpp": 408269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066330655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14942",
    "droptype": "D",
    "dropname": "ESSIE",
    "dropdeladd": "5425 HIGHWAY 406",
    "dropdelcty": "ESSIE",
    "dropdelst": "KY",
    "dropdelzpp": 408279998,
    "dropphyadd": "5425 HIGHWAY 406",
    "dropphycty": "ESSIE",
    "dropphyst": "KY",
    "dropphyzpp": 408279998,
    "dropmaladd": "5425 HIGHWAY 406",
    "dropmalcty": "ESSIE",
    "dropmalst": "KY",
    "dropmalzpp": 408279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063745349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14947",
    "droptype": "D",
    "dropname": "EUBANK",
    "dropdeladd": "15058 N HIGHWAY 1247",
    "dropdelcty": "EUBANK",
    "dropdelst": "KY",
    "dropdelzpp": 425679998,
    "dropphyadd": "15058 N HIGHWAY 1247",
    "dropphycty": "EUBANK",
    "dropphyst": "KY",
    "dropphyzpp": 425679998,
    "dropmaladd": "15058 N HIGHWAY 1247",
    "dropmalcty": "EUBANK",
    "dropmalst": "KY",
    "dropmalzpp": 425679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063796500,
    "dropfax": 6063796500
  },
  {
    "dcode": "D",
    "dropkey": "PX14949",
    "droptype": "D",
    "dropname": "EVARTS",
    "dropdeladd": "138 MAIN ST",
    "dropdelcty": "EVARTS",
    "dropdelst": "KY",
    "dropdelzpp": 408289998,
    "dropphyadd": "138 MAIN ST",
    "dropphycty": "EVARTS",
    "dropphyst": "KY",
    "dropphyzpp": 408289998,
    "dropmaladd": "138 MAIN ST",
    "dropmalcty": "EVARTS",
    "dropmalst": "KY",
    "dropmalzpp": 408289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068373592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14952",
    "droptype": "D",
    "dropname": "EWING",
    "dropdeladd": "1533 EWING RD",
    "dropdelcty": "EWING",
    "dropdelst": "KY",
    "dropdelzpp": 410399998,
    "dropphyadd": "1533 EWING RD",
    "dropphycty": "EWING",
    "dropphyst": "KY",
    "dropphyzpp": 410399998,
    "dropmaladd": "1533 EWING RD",
    "dropmalcty": "EWING",
    "dropmalst": "KY",
    "dropmalzpp": 410399998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6062675101,
    "dropsitcph": 6062675101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14955",
    "droptype": "D",
    "dropname": "EZEL",
    "dropdeladd": "14269 HIGHWAY 460 W",
    "dropdelcty": "EZEL",
    "dropdelst": "KY",
    "dropdelzpp": 414259998,
    "dropphyadd": "14269 HIGHWAY 460 W",
    "dropphycty": "EZEL",
    "dropphyst": "KY",
    "dropphyzpp": 414259998,
    "dropmaladd": "14269 HIGHWAY 460 W",
    "dropmalcty": "EZEL",
    "dropmalst": "KY",
    "dropmalzpp": 414259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067254951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14957",
    "droptype": "D",
    "dropname": "FAIRDALE",
    "dropdeladd": "411 MOUNT HOLLY RD",
    "dropdelcty": "FAIRDALE",
    "dropdelst": "KY",
    "dropdelzpp": 401189998,
    "dropphyadd": "411 MOUNT HOLLY RD",
    "dropphycty": "FAIRDALE",
    "dropphyst": "KY",
    "dropphyzpp": 401189998,
    "dropmaladd": "411 MOUNT HOLLY RD",
    "dropmalcty": "FAIRDALE",
    "dropmalst": "KY",
    "dropmalzpp": 401189998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023677676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14959",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "104 LITTLE UNION RD",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 400209998,
    "dropphyadd": "104 LITTLE UNION RD",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 400209998,
    "dropmaladd": "104 LITTLE UNION RD",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 400209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022525418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14963",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "8489 JEFFERSON DAVIS HWY",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "KY",
    "dropdelzpp": 422219998,
    "dropphyadd": "8489 JEFFERSON DAVIS HWY",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "KY",
    "dropphyzpp": 422219998,
    "dropmaladd": "8489 JEFFERSON DAVIS HWY",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "KY",
    "dropmalzpp": 422219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708869843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14965",
    "droptype": "D",
    "dropname": "FALCON",
    "dropdeladd": "3891 FALCON RD",
    "dropdelcty": "FALCON",
    "dropdelst": "KY",
    "dropdelzpp": 414269997,
    "dropphyadd": "3891 FALCON RD",
    "dropphycty": "FALCON",
    "dropphyst": "KY",
    "dropphyzpp": 414269997,
    "dropmaladd": "3891 FALCON RD",
    "dropmalcty": "FALCON",
    "dropmalst": "KY",
    "dropmalzpp": 414269997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063495821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14966",
    "droptype": "D",
    "dropname": "FALL ROCK",
    "dropdeladd": "4833 N HIGHWAY 421 UNIT 2",
    "dropdelcty": "FALL ROCK",
    "dropdelst": "KY",
    "dropdelzpp": 409329998,
    "dropphyadd": "4833 N HIGHWAY 421 UNIT 2",
    "dropphycty": "FALL ROCK",
    "dropphyst": "KY",
    "dropphyzpp": 409329998,
    "dropmaladd": "4833 N HIGHWAY 421 UNIT 2",
    "dropmalcty": "FALL ROCK",
    "dropmalst": "KY",
    "dropmalzpp": 409329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065470670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14967",
    "droptype": "D",
    "dropname": "FALLS OF ROUGH",
    "dropdeladd": "13647 FALLS OF ROUGH RD",
    "dropdelcty": "FALLS OF ROUGH",
    "dropdelst": "KY",
    "dropdelzpp": 401199998,
    "dropphyadd": "13647 FALLS OF ROUGH RD",
    "dropphycty": "FALLS OF ROUGH",
    "dropphyst": "KY",
    "dropphyzpp": 401199998,
    "dropmaladd": "13647 FALLS OF ROUGH RD",
    "dropmalcty": "FALLS OF ROUGH",
    "dropmalst": "KY",
    "dropmalzpp": 401199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702578297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14970",
    "droptype": "D",
    "dropname": "FALMOUTH",
    "dropdeladd": "201 W SHELBY ST",
    "dropdelcty": "FALMOUTH",
    "dropdelst": "KY",
    "dropdelzpp": 410409998,
    "dropphyadd": "201 W SHELBY ST",
    "dropphycty": "FALMOUTH",
    "dropphyst": "KY",
    "dropphyzpp": 410409998,
    "dropmaladd": "201 W SHELBY ST",
    "dropmalcty": "FALMOUTH",
    "dropmalst": "KY",
    "dropmalzpp": 410409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596541431,
    "dropsitcph": 8596547009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14971",
    "droptype": "D",
    "dropname": "FANCY FARM",
    "dropdeladd": "23 STATE ROUTE 339 S",
    "dropdelcty": "FANCY FARM",
    "dropdelst": "KY",
    "dropdelzpp": 420399998,
    "dropphyadd": "23 STATE ROUTE 339 S",
    "dropphycty": "FANCY FARM",
    "dropphyst": "KY",
    "dropphyzpp": 420399998,
    "dropmaladd": "23 STATE ROUTE 339 S",
    "dropmalcty": "FANCY FARM",
    "dropmalst": "KY",
    "dropmalzpp": 420399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703011522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14975",
    "droptype": "D",
    "dropname": "FARMERS",
    "dropdeladd": "7355 US HIGHWAY 60 W",
    "dropdelcty": "FARMERS",
    "dropdelst": "KY",
    "dropdelzpp": 403199998,
    "dropphyadd": "7355 US HIGHWAY 60 W",
    "dropphycty": "FARMERS",
    "dropphyst": "KY",
    "dropphyzpp": 403199998,
    "dropmaladd": "7355 US HIGHWAY 60 W",
    "dropmalcty": "FARMERS",
    "dropmalst": "KY",
    "dropmalzpp": 403199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067845030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14978",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "8406 STATE ROUTE 121 S",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 420409998,
    "dropphyadd": "8406 STATE ROUTE 121 S",
    "dropphycty": "FARMINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 420409998,
    "dropmaladd": "8406 STATE ROUTE 121 S",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 420409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702601149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14983",
    "droptype": "D",
    "dropname": "FEDSCREEK",
    "dropdeladd": "500 FEDSCREEK RD",
    "dropdelcty": "FEDSCREEK",
    "dropdelst": "KY",
    "dropdelzpp": 415249998,
    "dropphyadd": "500 FEDSCREEK RD",
    "dropphycty": "FEDSCREEK",
    "dropphyst": "KY",
    "dropphyzpp": 415249998,
    "dropmaladd": "500 FEDSCREEK RD",
    "dropmalcty": "FEDSCREEK",
    "dropmalst": "KY",
    "dropmalzpp": 415249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068352789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14984",
    "droptype": "D",
    "dropname": "FERGUSON",
    "dropdeladd": "522 JACKSBORO ST",
    "dropdelcty": "FERGUSON",
    "dropdelst": "KY",
    "dropdelzpp": 425339998,
    "dropphyadd": "522 JACKSBORO ST",
    "dropphycty": "FERGUSON",
    "dropphyst": "KY",
    "dropphyzpp": 425339998,
    "dropmaladd": "522 JACKSBORO ST",
    "dropmalcty": "FERGUSON",
    "dropmalst": "KY",
    "dropmalzpp": 425339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066795686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14989",
    "droptype": "D",
    "dropname": "FINCHVILLE",
    "dropdeladd": "5655 TAYLORSVILLE RD",
    "dropdelcty": "FINCHVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400229998,
    "dropphyadd": "5655 TAYLORSVILLE RD",
    "dropphycty": "FINCHVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400229998,
    "dropmaladd": "5655 TAYLORSVILLE RD",
    "dropmalcty": "FINCHVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028347737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14994",
    "droptype": "D",
    "dropname": "FISHERVILLE",
    "dropdeladd": "15125 OLD TAYLORSVILLE RD",
    "dropdelcty": "FISHERVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400239998,
    "dropphyadd": "15125 OLD TAYLORSVILLE RD",
    "dropphycty": "FISHERVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400239998,
    "dropmaladd": "15125 OLD TAYLORSVILLE RD",
    "dropmalcty": "FISHERVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022674286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX14997",
    "droptype": "D",
    "dropname": "FISTY",
    "dropdeladd": "10573 HIGHWAY 550 W",
    "dropdelcty": "FISTY",
    "dropdelst": "KY",
    "dropdelzpp": 417439998,
    "dropphyadd": "10573 HIGHWAY 550 W",
    "dropphycty": "FISTY",
    "dropphyst": "KY",
    "dropphyzpp": 417439998,
    "dropmaladd": "10573 HIGHWAY 550 W",
    "dropmalcty": "FISTY",
    "dropmalst": "KY",
    "dropmalzpp": 417439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062513901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15005",
    "droptype": "D",
    "dropname": "FLAT LICK",
    "dropdeladd": "1131 KY 3085",
    "dropdelcty": "FLAT LICK",
    "dropdelst": "KY",
    "dropdelzpp": 409359998,
    "dropphyadd": "1131 KY 3085",
    "dropphycty": "FLAT LICK",
    "dropphyst": "KY",
    "dropphyzpp": 409359998,
    "dropmaladd": "1131 KY 3085",
    "dropmalcty": "FLAT LICK",
    "dropmalst": "KY",
    "dropmalzpp": 409359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065424113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15008",
    "droptype": "D",
    "dropname": "FLATGAP",
    "dropdeladd": "1145 KY ROUTE 689 E",
    "dropdelcty": "FLATGAP",
    "dropdelst": "KY",
    "dropdelzpp": 412199998,
    "dropphyadd": "1145 KY ROUTE 689 E",
    "dropphycty": "FLATGAP",
    "dropphyst": "KY",
    "dropphyzpp": 412199998,
    "dropmaladd": "1145 KY ROUTE 689 E",
    "dropmalcty": "FLATGAP",
    "dropmalst": "KY",
    "dropmalzpp": 412199998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062654244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15009",
    "droptype": "D",
    "dropname": "FLATWOODS",
    "dropdeladd": "2125 ARGILLITE RD",
    "dropdelcty": "FLATWOODS",
    "dropdelst": "KY",
    "dropdelzpp": 411399997,
    "dropphyadd": "2125 ARGILLITE RD",
    "dropphycty": "FLATWOODS",
    "dropphyst": "KY",
    "dropphyzpp": 411399997,
    "dropmaladd": "2125 ARGILLITE RD",
    "dropmalcty": "FLATWOODS",
    "dropmalst": "KY",
    "dropmalzpp": 411399997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068360171,
    "dropfax": 6068366140
  },
  {
    "dcode": "D",
    "dropkey": "PX15014",
    "droptype": "D",
    "dropname": "FLEMINGSBURG",
    "dropdeladd": "131 E WATER ST",
    "dropdelcty": "FLEMINGSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 410419998,
    "dropphyadd": "131 E WATER ST",
    "dropphycty": "FLEMINGSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 410419998,
    "dropmaladd": "131 E WATER ST",
    "dropmalcty": "FLEMINGSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 410419998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6068457601,
    "dropsitcph": 6068457601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15019",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "7101 TURFWAY RD",
    "dropdelcty": "FLORENCE",
    "dropdelst": "KY",
    "dropdelzpp": 410429998,
    "dropphyadd": "7101 TURFWAY RD",
    "dropphycty": "FLORENCE",
    "dropphyst": "KY",
    "dropphyzpp": 410429998,
    "dropmaladd": "7101 TURFWAY RD",
    "dropmalcty": "FLORENCE",
    "dropmalst": "KY",
    "dropmalzpp": 410429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596475484,
    "dropsitcph": 8596475484,
    "dropfax": 8596475486
  },
  {
    "dcode": "D",
    "dropkey": "PX15028",
    "droptype": "D",
    "dropname": "FORDS BRANCH",
    "dropdeladd": "2730 KEWANEE RD",
    "dropdelcty": "FORDS BRANCH",
    "dropdelst": "KY",
    "dropdelzpp": 415269998,
    "dropphyadd": "2730 KEWANEE RD",
    "dropphycty": "FORDS BRANCH",
    "dropphyst": "KY",
    "dropphyzpp": 415269998,
    "dropmaladd": "2730 KEWANEE RD",
    "dropmalcty": "FORDS BRANCH",
    "dropmalst": "KY",
    "dropmalzpp": 415269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064377284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15029",
    "droptype": "D",
    "dropname": "FORDSVILLE",
    "dropdeladd": "25 SMITH ST",
    "dropdelcty": "FORDSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 423439998,
    "dropphyadd": "25 SMITH ST",
    "dropphycty": "FORDSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 423439998,
    "dropmaladd": "25 SMITH ST",
    "dropmalcty": "FORDSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 423439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702765203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15032",
    "droptype": "D",
    "dropname": "FOREST HILLS",
    "dropdeladd": "1320 FOREST HILLS RD",
    "dropdelcty": "FOREST HILLS",
    "dropdelst": "KY",
    "dropdelzpp": 415279998,
    "dropphyadd": "1320 FOREST HILLS RD",
    "dropphycty": "FOREST HILLS",
    "dropphyst": "KY",
    "dropphyzpp": 415279998,
    "dropmaladd": "1320 FOREST HILLS RD",
    "dropmalcty": "FOREST HILLS",
    "dropmalst": "KY",
    "dropmalzpp": 415279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062377460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15034",
    "droptype": "D",
    "dropname": "FORT CAMPBELL",
    "dropdeladd": "91 MICHIGAN AVE",
    "dropdelcty": "FORT CAMPBELL",
    "dropdelst": "KY",
    "dropdelzpp": 422239998,
    "dropphyadd": "91 MICHIGAN AVE",
    "dropphycty": "FORT CAMPBELL",
    "dropphyst": "KY",
    "dropphyzpp": 422239998,
    "dropmaladd": "91 MICHIGAN AVE",
    "dropmalcty": "FORT CAMPBELL",
    "dropmalst": "KY",
    "dropmalzpp": 422239998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704394114,
    "dropfax": 2704394133
  },
  {
    "dcode": "D",
    "dropkey": "PX15035",
    "droptype": "D",
    "dropname": "FORT KNOX",
    "dropdeladd": "120 N KNOX ST FRNT",
    "dropdelcty": "FORT KNOX",
    "dropdelst": "KY",
    "dropdelzpp": 401219908,
    "dropphyadd": "120 N KNOX ST FRNT",
    "dropphycty": "FORT KNOX",
    "dropphyst": "KY",
    "dropphyzpp": 401219908,
    "dropmaladd": "120 N KNOX ST FRNT",
    "dropmalcty": "FORT KNOX",
    "dropmalst": "KY",
    "dropmalzpp": 401219908,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029421244,
    "dropfax": 5029426396
  },
  {
    "dcode": "D",
    "dropkey": "PX15039",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "138 3RD ST",
    "dropdelcty": "FOSTER",
    "dropdelst": "KY",
    "dropdelzpp": 410439998,
    "dropphyadd": "138 3RD ST",
    "dropphycty": "FOSTER",
    "dropphyst": "KY",
    "dropphyzpp": 410439998,
    "dropmaladd": "138 3RD ST",
    "dropmalcty": "FOSTER",
    "dropmalst": "KY",
    "dropmalzpp": 410439998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067475895,
    "dropsitcph": 6067475895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15041",
    "droptype": "D",
    "dropname": "FOUNTAIN RUN",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "FOUNTAIN RUN",
    "dropdelst": "KY",
    "dropdelzpp": 421339998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "FOUNTAIN RUN",
    "dropphyst": "KY",
    "dropphyzpp": 421339998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "FOUNTAIN RUN",
    "dropmalst": "KY",
    "dropmalzpp": 421339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704342562,
    "dropfax": 2704342563
  },
  {
    "dcode": "D",
    "dropkey": "PX15043",
    "droptype": "D",
    "dropname": "FOURMILE",
    "dropdeladd": "16073 US HIGHWAY 25 E",
    "dropdelcty": "FOURMILE",
    "dropdelst": "KY",
    "dropdelzpp": 409399998,
    "dropphyadd": "16073 US HIGHWAY 25 E",
    "dropphycty": "FOURMILE",
    "dropphyst": "KY",
    "dropphyzpp": 409399998,
    "dropmaladd": "16073 US HIGHWAY 25 E",
    "dropmalcty": "FOURMILE",
    "dropmalst": "KY",
    "dropmalzpp": 409399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063379450,
    "dropfax": 6063373687
  },
  {
    "dcode": "D",
    "dropkey": "PX15046",
    "droptype": "D",
    "dropname": "FRAKES",
    "dropdeladd": "17170 HIGHWAY 190",
    "dropdelcty": "FRAKES",
    "dropdelst": "KY",
    "dropdelzpp": 409409998,
    "dropphyadd": "17170 HIGHWAY 190",
    "dropphycty": "FRAKES",
    "dropphyst": "KY",
    "dropphyzpp": 409409998,
    "dropmaladd": "17170 HIGHWAY 190",
    "dropmalcty": "FRAKES",
    "dropmalst": "KY",
    "dropmalzpp": 409409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063371980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15049",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "1210 WILKINSON BLVD",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "KY",
    "dropdelzpp": 406019998,
    "dropphyadd": "1210 WILKINSON BLVD",
    "dropphycty": "FRANKFORT",
    "dropphyst": "KY",
    "dropphyzpp": 406019998,
    "dropmaladd": "1210 WILKINSON BLVD",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "KY",
    "dropmalzpp": 406019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022233447,
    "dropfax": 5028757088
  },
  {
    "dcode": "D",
    "dropkey": "PX15050",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "619 N MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "KY",
    "dropdelzpp": 421349998,
    "dropphyadd": "619 N MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "KY",
    "dropphyzpp": 421349998,
    "dropmaladd": "619 N MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "KY",
    "dropmalzpp": 421349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705863522,
    "dropfax": 2705861678
  },
  {
    "dcode": "D",
    "dropkey": "PX15054",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "513 CASSIDY AVE",
    "dropdelcty": "FREDONIA",
    "dropdelst": "KY",
    "dropdelzpp": 424119998,
    "dropphyadd": "513 CASSIDY AVE",
    "dropphycty": "FREDONIA",
    "dropphyst": "KY",
    "dropphyzpp": 424119998,
    "dropmaladd": "513 CASSIDY AVE",
    "dropmalcty": "FREDONIA",
    "dropmalst": "KY",
    "dropmalzpp": 424119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705453422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15056",
    "droptype": "D",
    "dropname": "FREEBURN",
    "dropdeladd": "43903 STATE HIGHWAY 194 E",
    "dropdelcty": "FREEBURN",
    "dropdelst": "KY",
    "dropdelzpp": 415289998,
    "dropphyadd": "43903 STATE HIGHWAY 194 E",
    "dropphycty": "FREEBURN",
    "dropphyst": "KY",
    "dropphyzpp": 415289998,
    "dropmaladd": "43903 STATE HIGHWAY 194 E",
    "dropmalcty": "FREEBURN",
    "dropmalst": "KY",
    "dropmalzpp": 415289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064568114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15061",
    "droptype": "D",
    "dropname": "FRENCHBURG",
    "dropdeladd": "835 MAIN ST",
    "dropdelcty": "FRENCHBURG",
    "dropdelst": "KY",
    "dropdelzpp": 403229998,
    "dropphyadd": "835 MAIN ST",
    "dropphycty": "FRENCHBURG",
    "dropphyst": "KY",
    "dropphyzpp": 403229998,
    "dropmaladd": "835 MAIN ST",
    "dropmalcty": "FRENCHBURG",
    "dropmalst": "KY",
    "dropmalzpp": 403229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067683571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15078",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "416 WALNUT ST",
    "dropdelcty": "FULTON",
    "dropdelst": "KY",
    "dropdelzpp": 420419998,
    "dropphyadd": "416 WALNUT ST",
    "dropphycty": "FULTON",
    "dropphyst": "KY",
    "dropphyzpp": 420419998,
    "dropmaladd": "416 WALNUT ST",
    "dropmalcty": "FULTON",
    "dropmalst": "KY",
    "dropmalzpp": 420419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704721836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15087",
    "droptype": "D",
    "dropname": "GAMALIEL",
    "dropdeladd": "106 FOUNTAIN RUN RD",
    "dropdelcty": "GAMALIEL",
    "dropdelst": "KY",
    "dropdelzpp": 421409998,
    "dropphyadd": "106 FOUNTAIN RUN RD",
    "dropphycty": "GAMALIEL",
    "dropphyst": "KY",
    "dropphyzpp": 421409998,
    "dropmaladd": "106 FOUNTAIN RUN RD",
    "dropmalcty": "GAMALIEL",
    "dropmalst": "KY",
    "dropmalzpp": 421409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8595685962,
    "dropfax": 2704574026
  },
  {
    "dcode": "D",
    "dropkey": "PX15093",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "6621 E HIGHWAY 60",
    "dropdelcty": "GARFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 401409998,
    "dropphyadd": "6621 E HIGHWAY 60",
    "dropphycty": "GARFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 401409998,
    "dropmaladd": "6621 E HIGHWAY 60",
    "dropmalcty": "GARFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 401409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707562061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15097",
    "droptype": "D",
    "dropname": "GARRARD",
    "dropdeladd": "2816 S HIGHWAY 421",
    "dropdelcty": "GARRARD",
    "dropdelst": "KY",
    "dropdelzpp": 409419998,
    "dropphyadd": "2816 S HIGHWAY 421",
    "dropphycty": "GARRARD",
    "dropphyst": "KY",
    "dropphyzpp": 409419998,
    "dropmaladd": "2816 S HIGHWAY 421",
    "dropmalcty": "GARRARD",
    "dropmalst": "KY",
    "dropmalzpp": 409419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065606082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15098",
    "droptype": "D",
    "dropname": "GARRETT",
    "dropdeladd": "430 FRONT ST",
    "dropdelcty": "GARRETT",
    "dropdelst": "KY",
    "dropdelzpp": 416309998,
    "dropphyadd": "430 FRONT ST",
    "dropphycty": "GARRETT",
    "dropphyst": "KY",
    "dropphyzpp": 416309998,
    "dropmaladd": "430 FRONT ST",
    "dropmalcty": "GARRETT",
    "dropmalst": "KY",
    "dropmalzpp": 416309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063584129,
    "dropfax": 6063589696
  },
  {
    "dcode": "D",
    "dropkey": "PX15100",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "9102 E KY 8",
    "dropdelcty": "GARRISON",
    "dropdelst": "KY",
    "dropdelzpp": 411419997,
    "dropphyadd": "9102 E KY 8",
    "dropphycty": "GARRISON",
    "dropphyst": "KY",
    "dropphyzpp": 411419997,
    "dropmaladd": "9102 E KY 8",
    "dropmalcty": "GARRISON",
    "dropmalst": "KY",
    "dropmalzpp": 411419997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067574224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15111",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "101 N BRADFORD LN",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "KY",
    "dropdelzpp": 403249998,
    "dropphyadd": "101 N BRADFORD LN",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "KY",
    "dropphyzpp": 403249998,
    "dropmaladd": "101 N BRADFORD LN",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "KY",
    "dropmalzpp": 403249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028633875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15112",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "6362 BROOKSVILLE GERMANTOWN RD",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 410449998,
    "dropphyadd": "6362 BROOKSVILLE GERMANTOWN RD",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 410449998,
    "dropmaladd": "6362 BROOKSVILLE GERMANTOWN RD",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 410449998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067285111,
    "dropsitcph": 6067285111,
    "dropfax": 6067289050
  },
  {
    "dcode": "D",
    "dropkey": "PX15118",
    "droptype": "D",
    "dropname": "GILBERTSVILLE",
    "dropdeladd": "119 ADMINISTRATION AVE",
    "dropdelcty": "GILBERTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 420449998,
    "dropphyadd": "119 ADMINISTRATION AVE",
    "dropphycty": "GILBERTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 420449998,
    "dropmaladd": "119 ADMINISTRATION AVE",
    "dropmalcty": "GILBERTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 420449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703628338,
    "dropfax": 2703627924
  },
  {
    "dcode": "D",
    "dropkey": "PX15129",
    "droptype": "D",
    "dropname": "GIRDLER",
    "dropdeladd": "5792 N KY 11",
    "dropdelcty": "GIRDLER",
    "dropdelst": "KY",
    "dropdelzpp": 409439998,
    "dropphyadd": "5792 N KY 11",
    "dropphycty": "GIRDLER",
    "dropphyst": "KY",
    "dropphyzpp": 409439998,
    "dropmaladd": "5792 N KY 11",
    "dropmalcty": "GIRDLER",
    "dropmalst": "KY",
    "dropmalzpp": 409439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065469276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15131",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "201 COLUMBIA AVE",
    "dropdelcty": "GLASGOW",
    "dropdelst": "KY",
    "dropdelzpp": 421419998,
    "dropphyadd": "201 COLUMBIA AVE",
    "dropphycty": "GLASGOW",
    "dropphyst": "KY",
    "dropphyzpp": 421419998,
    "dropmaladd": "201 COLUMBIA AVE",
    "dropmalcty": "GLASGOW",
    "dropmalst": "KY",
    "dropmalzpp": 421419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706518859,
    "dropfax": 2706512671
  },
  {
    "dcode": "D",
    "dropkey": "PX15136",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "GLENCOE",
    "dropdelst": "KY",
    "dropdelzpp": 410469998,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "GLENCOE",
    "dropphyst": "KY",
    "dropphyzpp": 410469998,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "GLENCOE",
    "dropmalst": "KY",
    "dropmalzpp": 410469998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596434941,
    "dropsitcph": 8596434941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15137",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "438 E MAIN ST",
    "dropdelcty": "GLENDALE",
    "dropdelst": "KY",
    "dropdelzpp": 427409998,
    "dropphyadd": "438 E MAIN ST",
    "dropphycty": "GLENDALE",
    "dropphyst": "KY",
    "dropphyzpp": 427409998,
    "dropmaladd": "438 E MAIN ST",
    "dropmalcty": "GLENDALE",
    "dropmalst": "KY",
    "dropmalzpp": 427409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703698377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15142",
    "droptype": "D",
    "dropname": "GLENVIEW",
    "dropdeladd": "4330 GLENVIEW AVE",
    "dropdelcty": "GLENVIEW",
    "dropdelst": "KY",
    "dropdelzpp": 400259998,
    "dropphyadd": "4330 GLENVIEW AVE",
    "dropphycty": "GLENVIEW",
    "dropphyst": "KY",
    "dropphyzpp": 400259998,
    "dropmaladd": "4330 GLENVIEW AVE",
    "dropmalcty": "GLENVIEW",
    "dropmalst": "KY",
    "dropmalzpp": 400259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028937645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15153",
    "droptype": "D",
    "dropname": "GOOSE ROCK",
    "dropdeladd": "73 HIGHWAY 1524",
    "dropdelcty": "GOOSE ROCK",
    "dropdelst": "KY",
    "dropdelzpp": 409449998,
    "dropphyadd": "73 HIGHWAY 1524",
    "dropphycty": "GOOSE ROCK",
    "dropphyst": "KY",
    "dropphyzpp": 409449998,
    "dropmaladd": "73 HIGHWAY 1524",
    "dropmalcty": "GOOSE ROCK",
    "dropmalst": "KY",
    "dropmalzpp": 409449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065470743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15156",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "12340 W HIGHWAY 42",
    "dropdelcty": "GOSHEN",
    "dropdelst": "KY",
    "dropdelzpp": 400269998,
    "dropphyadd": "12340 W HIGHWAY 42",
    "dropphycty": "GOSHEN",
    "dropphyst": "KY",
    "dropphyzpp": 400269998,
    "dropmaladd": "12340 W HIGHWAY 42",
    "dropmalcty": "GOSHEN",
    "dropmalst": "KY",
    "dropmalzpp": 400269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022280966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15160",
    "droptype": "D",
    "dropname": "GRACEY",
    "dropdeladd": "10600 TOBACCO RD",
    "dropdelcty": "GRACEY",
    "dropdelst": "KY",
    "dropdelzpp": 422329998,
    "dropphyadd": "10600 TOBACCO RD",
    "dropphycty": "GRACEY",
    "dropphyst": "KY",
    "dropphyzpp": 422329998,
    "dropmaladd": "10600 TOBACCO RD",
    "dropmalcty": "GRACEY",
    "dropmalst": "KY",
    "dropmalzpp": 422329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702355552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15162",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "4909 STATE ROUTE 175 S",
    "dropdelcty": "GRAHAM",
    "dropdelst": "KY",
    "dropdelzpp": 423449998,
    "dropphyadd": "4909 STATE ROUTE 175 S",
    "dropphycty": "GRAHAM",
    "dropphyst": "KY",
    "dropphyzpp": 423449998,
    "dropmaladd": "4909 STATE ROUTE 175 S",
    "dropmalcty": "GRAHAM",
    "dropmalst": "KY",
    "dropmalzpp": 423449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703385252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15164",
    "droptype": "D",
    "dropname": "GRAHN",
    "dropdeladd": "61 POST OFFICE AVE",
    "dropdelcty": "GRAHN",
    "dropdelst": "KY",
    "dropdelzpp": 411429998,
    "dropphyadd": "61 POST OFFICE AVE",
    "dropphycty": "GRAHN",
    "dropphyst": "KY",
    "dropphyzpp": 411429998,
    "dropmaladd": "61 POST OFFICE AVE",
    "dropmalcty": "GRAHN",
    "dropmalst": "KY",
    "dropmalzpp": 411429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062864314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15167",
    "droptype": "D",
    "dropname": "GRAND RIVERS",
    "dropdeladd": "1818 JH OBRYAN AVE",
    "dropdelcty": "GRAND RIVERS",
    "dropdelst": "KY",
    "dropdelzpp": 420459998,
    "dropphyadd": "1818 JH OBRYAN AVE",
    "dropphycty": "GRAND RIVERS",
    "dropphyst": "KY",
    "dropphyzpp": 420459998,
    "dropmaladd": "1818 JH OBRYAN AVE",
    "dropmalcty": "GRAND RIVERS",
    "dropmalst": "KY",
    "dropmalzpp": 420459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703628713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15174",
    "droptype": "D",
    "dropname": "GRAVEL SWITCH",
    "dropdeladd": "885 GRAVEL SWITCH RD",
    "dropdelcty": "GRAVEL SWITCH",
    "dropdelst": "KY",
    "dropdelzpp": 403289998,
    "dropphyadd": "885 GRAVEL SWITCH RD",
    "dropphycty": "GRAVEL SWITCH",
    "dropphyst": "KY",
    "dropphyzpp": 403289998,
    "dropmaladd": "885 GRAVEL SWITCH RD",
    "dropmalcty": "GRAVEL SWITCH",
    "dropmalst": "KY",
    "dropmalzpp": 403289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706926020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15176",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "280 S KY 233",
    "dropdelcty": "GRAY",
    "dropdelst": "KY",
    "dropdelzpp": 407349998,
    "dropphyadd": "280 S KY 233",
    "dropphycty": "GRAY",
    "dropphyst": "KY",
    "dropphyzpp": 407349998,
    "dropmaladd": "280 S KY 233",
    "dropmalcty": "GRAY",
    "dropmalst": "KY",
    "dropmalzpp": 407349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065282695,
    "dropfax": 6065261476
  },
  {
    "dcode": "D",
    "dropkey": "PX15177",
    "droptype": "D",
    "dropname": "GRAY HAWK",
    "dropdeladd": "811 US HIGHWAY 421 S",
    "dropdelcty": "GRAY HAWK",
    "dropdelst": "KY",
    "dropdelzpp": 404349998,
    "dropphyadd": "811 US HIGHWAY 421 S",
    "dropphycty": "GRAY HAWK",
    "dropphyst": "KY",
    "dropphyzpp": 404349998,
    "dropmaladd": "811 US HIGHWAY 421 S",
    "dropmalcty": "GRAY HAWK",
    "dropmalst": "KY",
    "dropmalzpp": 404349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062878255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15178",
    "droptype": "D",
    "dropname": "GRAYS KNOB",
    "dropdeladd": "63 JUDY DR",
    "dropdelcty": "GRAYS KNOB",
    "dropdelst": "KY",
    "dropdelzpp": 408299998,
    "dropphyadd": "63 JUDY DR",
    "dropphycty": "GRAYS KNOB",
    "dropphyst": "KY",
    "dropphyzpp": 408299998,
    "dropmaladd": "63 JUDY DR",
    "dropmalcty": "GRAYS KNOB",
    "dropmalst": "KY",
    "dropmalzpp": 408299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065735733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15179",
    "droptype": "D",
    "dropname": "GRAYSON",
    "dropdeladd": "390 S CAROL MALONE BLVD",
    "dropdelcty": "GRAYSON",
    "dropdelst": "KY",
    "dropdelzpp": 411439997,
    "dropphyadd": "390 S CAROL MALONE BLVD",
    "dropphycty": "GRAYSON",
    "dropphyst": "KY",
    "dropphyzpp": 411439997,
    "dropmaladd": "390 S CAROL MALONE BLVD",
    "dropmalcty": "GRAYSON",
    "dropmalst": "KY",
    "dropmalzpp": 411439997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064746366,
    "dropfax": 6064748723
  },
  {
    "dcode": "D",
    "dropkey": "PX15189",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "45 TUNNELL LN",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 427439997,
    "dropphyadd": "45 TUNNELL LN",
    "dropphycty": "GREENSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 427439997,
    "dropmaladd": "45 TUNNELL LN",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 427439997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709325371,
    "dropfax": 2709323055
  },
  {
    "dcode": "D",
    "dropkey": "PX15190",
    "droptype": "D",
    "dropname": "GREENUP",
    "dropdeladd": "1312 ASHLAND RD",
    "dropdelcty": "GREENUP",
    "dropdelst": "KY",
    "dropdelzpp": 411449995,
    "dropphyadd": "1312 ASHLAND RD",
    "dropphycty": "GREENUP",
    "dropphyst": "KY",
    "dropphyzpp": 411449995,
    "dropmaladd": "1312 ASHLAND RD",
    "dropmalcty": "GREENUP",
    "dropmalst": "KY",
    "dropmalzpp": 411449995,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064737251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15191",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "102 COURT ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 423459998,
    "dropphyadd": "102 COURT ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 423459998,
    "dropmaladd": "102 COURT ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 423459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703384900,
    "dropfax": 2703386585
  },
  {
    "dcode": "D",
    "dropkey": "PX15199",
    "droptype": "D",
    "dropname": "GRETHEL",
    "dropdeladd": "6789 KY ROUTE 979",
    "dropdelcty": "GRETHEL",
    "dropdelst": "KY",
    "dropdelzpp": 416319998,
    "dropphyadd": "6789 KY ROUTE 979",
    "dropphycty": "GRETHEL",
    "dropphyst": "KY",
    "dropphyzpp": 416319998,
    "dropmaladd": "6789 KY ROUTE 979",
    "dropmalcty": "GRETHEL",
    "dropmalst": "KY",
    "dropmalzpp": 416319998,
    "dropsitphn": 6065872931,
    "dropsitlph": 6065872931,
    "dropsitcph": 6065865013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15211",
    "droptype": "D",
    "dropname": "GUSTON",
    "dropdeladd": "835 GUSTON RD",
    "dropdelcty": "GUSTON",
    "dropdelst": "KY",
    "dropdelzpp": 401429998,
    "dropphyadd": "835 GUSTON RD",
    "dropphycty": "GUSTON",
    "dropphyst": "KY",
    "dropphyzpp": 401429998,
    "dropmaladd": "835 GUSTON RD",
    "dropmalcty": "GUSTON",
    "dropmalst": "KY",
    "dropmalzpp": 401429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705476524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15212",
    "droptype": "D",
    "dropname": "GUTHRIE",
    "dropdeladd": "202 W PARK ST",
    "dropdelcty": "GUTHRIE",
    "dropdelst": "KY",
    "dropdelzpp": 422349998,
    "dropphyadd": "202 W PARK ST",
    "dropphycty": "GUTHRIE",
    "dropphyst": "KY",
    "dropphyzpp": 422349998,
    "dropmaladd": "202 W PARK ST",
    "dropmalcty": "GUTHRIE",
    "dropmalst": "KY",
    "dropmalzpp": 422349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704832963,
    "dropfax": 2704832963
  },
  {
    "dcode": "D",
    "dropkey": "PX15220",
    "droptype": "D",
    "dropname": "HAGERHILL",
    "dropdeladd": "1344 KY ROUTE 1428",
    "dropdelcty": "HAGERHILL",
    "dropdelst": "KY",
    "dropdelzpp": 412229997,
    "dropphyadd": "1344 KY ROUTE 1428",
    "dropphycty": "HAGERHILL",
    "dropphyst": "KY",
    "dropphyzpp": 412229997,
    "dropmaladd": "1344 KY ROUTE 1428",
    "dropmalcty": "HAGERHILL",
    "dropmalst": "KY",
    "dropmalzpp": 412229997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067896729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15228",
    "droptype": "D",
    "dropname": "HALLIE",
    "dropdeladd": "3996 HIGHWAY 1103",
    "dropdelcty": "HALLIE",
    "dropdelst": "KY",
    "dropdelzpp": 418219998,
    "dropphyadd": "3996 HIGHWAY 1103",
    "dropphycty": "HALLIE",
    "dropphyst": "KY",
    "dropphyzpp": 418219998,
    "dropmaladd": "3996 HIGHWAY 1103",
    "dropmalcty": "HALLIE",
    "dropmalst": "KY",
    "dropmalzpp": 418219998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066331239,
    "dropfax": 6066332811
  },
  {
    "dcode": "D",
    "dropkey": "PX15236",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "724 MAIN ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "KY",
    "dropdelzpp": 420479998,
    "dropphyadd": "724 MAIN ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "KY",
    "dropphyzpp": 420479998,
    "dropmaladd": "724 MAIN ST",
    "dropmalcty": "HAMPTON",
    "dropmalst": "KY",
    "dropmalzpp": 420479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709884493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15240",
    "droptype": "D",
    "dropname": "HANSON",
    "dropdeladd": "50 SUNSET RD",
    "dropdelcty": "HANSON",
    "dropdelst": "KY",
    "dropdelzpp": 424139998,
    "dropphyadd": "50 SUNSET RD",
    "dropphycty": "HANSON",
    "dropphyst": "KY",
    "dropphyzpp": 424139998,
    "dropmaladd": "50 SUNSET RD",
    "dropmalcty": "HANSON",
    "dropmalst": "KY",
    "dropmalzpp": 424139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703228021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15241",
    "droptype": "D",
    "dropname": "HAPPY",
    "dropdeladd": "10028 S KY HIGHWAY 15",
    "dropdelcty": "HAPPY",
    "dropdelst": "KY",
    "dropdelzpp": 417469998,
    "dropphyadd": "10028 S KY HIGHWAY 15",
    "dropphycty": "HAPPY",
    "dropphyst": "KY",
    "dropphyzpp": 417469998,
    "dropmaladd": "10028 S KY HIGHWAY 15",
    "dropmalcty": "HAPPY",
    "dropmalst": "KY",
    "dropmalzpp": 417469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064768619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15244",
    "droptype": "D",
    "dropname": "HARDIN",
    "dropdeladd": "85 COMMERCE ST",
    "dropdelcty": "HARDIN",
    "dropdelst": "KY",
    "dropdelzpp": 420489998,
    "dropphyadd": "85 COMMERCE ST",
    "dropphycty": "HARDIN",
    "dropphyst": "KY",
    "dropphyzpp": 420489998,
    "dropmaladd": "85 COMMERCE ST",
    "dropmalcty": "HARDIN",
    "dropmalst": "KY",
    "dropmalzpp": 420489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704374762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15247",
    "droptype": "D",
    "dropname": "HARDINSBURG",
    "dropdeladd": "234 S MAIN ST",
    "dropdelcty": "HARDINSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 401439998,
    "dropphyadd": "234 S MAIN ST",
    "dropphycty": "HARDINSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 401439998,
    "dropmaladd": "234 S MAIN ST",
    "dropmalcty": "HARDINSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 401439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707562119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15250",
    "droptype": "D",
    "dropname": "HARDY",
    "dropdeladd": "2240 STATE HIGHWAY 319",
    "dropdelcty": "HARDY",
    "dropdelst": "KY",
    "dropdelzpp": 415319998,
    "dropphyadd": "2240 STATE HIGHWAY 319",
    "dropphycty": "HARDY",
    "dropphyst": "KY",
    "dropphyzpp": 415319998,
    "dropmaladd": "2240 STATE HIGHWAY 319",
    "dropmalcty": "HARDY",
    "dropmalst": "KY",
    "dropmalzpp": 415319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063537255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15251",
    "droptype": "D",
    "dropname": "HARDYVILLE",
    "dropdeladd": "62 N JACKSON HWY",
    "dropdelcty": "HARDYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427469998,
    "dropphyadd": "62 N JACKSON HWY",
    "dropphycty": "HARDYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427469998,
    "dropmaladd": "62 N JACKSON HWY",
    "dropmalcty": "HARDYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705511167,
    "dropfax": 2705284695
  },
  {
    "dcode": "D",
    "dropkey": "PX15252",
    "droptype": "D",
    "dropname": "HARLAN",
    "dropdeladd": "111 N 1ST ST",
    "dropdelcty": "HARLAN",
    "dropdelst": "KY",
    "dropdelzpp": 408319998,
    "dropphyadd": "111 N 1ST ST",
    "dropphycty": "HARLAN",
    "dropphyst": "KY",
    "dropphyzpp": 408319998,
    "dropmaladd": "111 N 1ST ST",
    "dropmalcty": "HARLAN",
    "dropmalst": "KY",
    "dropmalzpp": 408319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065732800,
    "dropfax": 6065735707
  },
  {
    "dcode": "D",
    "dropkey": "PX15255",
    "droptype": "D",
    "dropname": "HARNED",
    "dropdeladd": "48 S HIGHWAY 259",
    "dropdelcty": "HARNED",
    "dropdelst": "KY",
    "dropdelzpp": 401449998,
    "dropphyadd": "48 S HIGHWAY 259",
    "dropphycty": "HARNED",
    "dropphyst": "KY",
    "dropphyzpp": 401449998,
    "dropmaladd": "48 S HIGHWAY 259",
    "dropmalcty": "HARNED",
    "dropmalst": "KY",
    "dropmalzpp": 401449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702600117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15256",
    "droptype": "D",
    "dropname": "HAROLD",
    "dropdeladd": "107 LAYNESVILLE RD",
    "dropdelcty": "HAROLD",
    "dropdelst": "KY",
    "dropdelzpp": 416359998,
    "dropphyadd": "107 LAYNESVILLE RD",
    "dropphycty": "HAROLD",
    "dropphyst": "KY",
    "dropphyzpp": 416359998,
    "dropmaladd": "107 LAYNESVILLE RD",
    "dropmalcty": "HAROLD",
    "dropmalst": "KY",
    "dropmalzpp": 416359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065172764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15259",
    "droptype": "D",
    "dropname": "HARRODS CREEK",
    "dropdeladd": "6319 UPPER RIVER RD",
    "dropdelcty": "HARRODS CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 400279998,
    "dropphyadd": "6319 UPPER RIVER RD",
    "dropphycty": "HARRODS CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 400279998,
    "dropmaladd": "6319 UPPER RIVER RD",
    "dropmalcty": "HARRODS CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 400279998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022283513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15260",
    "droptype": "D",
    "dropname": "HARRODSBURG",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "HARRODSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 403309998,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "HARRODSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 403309998,
    "dropmaladd": "105 N MAIN ST",
    "dropmalcty": "HARRODSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 403309998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8597342568,
    "dropfax": 8597344042
  },
  {
    "dcode": "D",
    "dropkey": "PX15261",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "1101 S MAIN ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "KY",
    "dropdelzpp": 423479998,
    "dropphyadd": "1101 S MAIN ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "KY",
    "dropphyzpp": 423479998,
    "dropmaladd": "1101 S MAIN ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "KY",
    "dropmalzpp": 423479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702983550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15268",
    "droptype": "D",
    "dropname": "HAWESVILLE",
    "dropdeladd": "115 MAIN CROSS ST",
    "dropdelcty": "HAWESVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 423489998,
    "dropphyadd": "115 MAIN CROSS ST",
    "dropphycty": "HAWESVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 423489998,
    "dropmaladd": "115 MAIN CROSS ST",
    "dropmalcty": "HAWESVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 423489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709278054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15275",
    "droptype": "D",
    "dropname": "HAZARD",
    "dropdeladd": "201 BLACK GOLD BLVD",
    "dropdelcty": "HAZARD",
    "dropdelst": "KY",
    "dropdelzpp": 417019998,
    "dropphyadd": "201 BLACK GOLD BLVD",
    "dropphycty": "HAZARD",
    "dropphyst": "KY",
    "dropphyzpp": 417019998,
    "dropmaladd": "201 BLACK GOLD BLVD",
    "dropmalcty": "HAZARD",
    "dropmalst": "KY",
    "dropmalzpp": 417019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064363188,
    "dropfax": 6064393499
  },
  {
    "dcode": "D",
    "dropkey": "PX15276",
    "droptype": "D",
    "dropname": "HAZEL",
    "dropdeladd": "304 MAIN ST",
    "dropdelcty": "HAZEL",
    "dropdelst": "KY",
    "dropdelzpp": 420499998,
    "dropphyadd": "304 MAIN ST",
    "dropphycty": "HAZEL",
    "dropphyst": "KY",
    "dropphyzpp": 420499998,
    "dropmaladd": "304 MAIN ST",
    "dropmalcty": "HAZEL",
    "dropmalst": "KY",
    "dropmalzpp": 420499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704928845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15277",
    "droptype": "D",
    "dropname": "HAZEL GREEN",
    "dropdeladd": "10491 KY HIGHWAY 191",
    "dropdelcty": "HAZEL GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 413329998,
    "dropphyadd": "10491 KY HIGHWAY 191",
    "dropphycty": "HAZEL GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 413329998,
    "dropmaladd": "10491 KY HIGHWAY 191",
    "dropmalcty": "HAZEL GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 413329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066624945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15281",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "1684 PETERSBURG RD",
    "dropdelcty": "HEBRON",
    "dropdelst": "KY",
    "dropdelzpp": 410489998,
    "dropphyadd": "1684 PETERSBURG RD",
    "dropphycty": "HEBRON",
    "dropphyst": "KY",
    "dropphyzpp": 410489998,
    "dropmaladd": "1684 PETERSBURG RD",
    "dropmalcty": "HEBRON",
    "dropmalst": "KY",
    "dropmalzpp": 410489998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596895396,
    "dropsitcph": 8593714813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15286",
    "droptype": "D",
    "dropname": "HEIDRICK",
    "dropdeladd": "215 N KY 11 STE A",
    "dropdelcty": "HEIDRICK",
    "dropdelst": "KY",
    "dropdelzpp": 409499998,
    "dropphyadd": "215 N KY 11 STE A",
    "dropphycty": "HEIDRICK",
    "dropphyst": "KY",
    "dropphyzpp": 409499998,
    "dropmaladd": "215 N KY 11 STE A",
    "dropmalcty": "HEIDRICK",
    "dropmalst": "KY",
    "dropmalzpp": 409499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065469818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15290",
    "droptype": "D",
    "dropname": "HELLIER",
    "dropdeladd": "126 ALLEGHENY RD",
    "dropdelcty": "HELLIER",
    "dropdelst": "KY",
    "dropdelzpp": 415349998,
    "dropphyadd": "126 ALLEGHENY RD",
    "dropphycty": "HELLIER",
    "dropphyst": "KY",
    "dropphyzpp": 415349998,
    "dropmaladd": "126 ALLEGHENY RD",
    "dropmalcty": "HELLIER",
    "dropmalst": "KY",
    "dropmalzpp": 415349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067549761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15293",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "100 1ST ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "KY",
    "dropdelzpp": 424209998,
    "dropphyadd": "100 1ST ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "KY",
    "dropphyzpp": 424209998,
    "dropmaladd": "100 1ST ST",
    "dropmalcty": "HENDERSON",
    "dropmalst": "KY",
    "dropmalzpp": 424209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708279874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15301",
    "droptype": "D",
    "dropname": "HERNDON",
    "dropdeladd": "10825 LAFAYETTE RD",
    "dropdelcty": "HERNDON",
    "dropdelst": "KY",
    "dropdelzpp": 422369998,
    "dropphyadd": "10825 LAFAYETTE RD",
    "dropphycty": "HERNDON",
    "dropphyst": "KY",
    "dropphyzpp": 422369998,
    "dropmaladd": "10825 LAFAYETTE RD",
    "dropmalcty": "HERNDON",
    "dropmalst": "KY",
    "dropmalzpp": 422369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702712574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15304",
    "droptype": "D",
    "dropname": "HI HAT",
    "dropdeladd": "17460 KY ROUTE 122",
    "dropdelcty": "HI HAT",
    "dropdelst": "KY",
    "dropdelzpp": 416369998,
    "dropphyadd": "17460 KY ROUTE 122",
    "dropphycty": "HI HAT",
    "dropphyst": "KY",
    "dropphyzpp": 416369998,
    "dropmaladd": "17460 KY ROUTE 122",
    "dropmalcty": "HI HAT",
    "dropmalst": "KY",
    "dropmalzpp": 416369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063776096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15305",
    "droptype": "D",
    "dropname": "HICKMAN",
    "dropdeladd": "201 JACKSON ST",
    "dropdelcty": "HICKMAN",
    "dropdelst": "KY",
    "dropdelzpp": 420509998,
    "dropphyadd": "201 JACKSON ST",
    "dropphycty": "HICKMAN",
    "dropphyst": "KY",
    "dropphyzpp": 420509998,
    "dropmaladd": "201 JACKSON ST",
    "dropmalcty": "HICKMAN",
    "dropmalst": "KY",
    "dropmalzpp": 420509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702362095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15306",
    "droptype": "D",
    "dropname": "HICKORY",
    "dropdeladd": "1976 STATE ROUTE 1241",
    "dropdelcty": "HICKORY",
    "dropdelst": "KY",
    "dropdelzpp": 420519998,
    "dropphyadd": "1976 STATE ROUTE 1241",
    "dropphycty": "HICKORY",
    "dropphyst": "KY",
    "dropphyzpp": 420519998,
    "dropmaladd": "1976 STATE ROUTE 1241",
    "dropmalcty": "HICKORY",
    "dropmalst": "KY",
    "dropmalzpp": 420519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702475078,
    "dropfax": 2702475078
  },
  {
    "dcode": "D",
    "dropkey": "PX15321",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "5 SOUDER DR",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 410499998,
    "dropphyadd": "5 SOUDER DR",
    "dropphycty": "HILLSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 410499998,
    "dropmaladd": "5 SOUDER DR",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 410499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6068762861,
    "dropsitcph": 6068762861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15325",
    "droptype": "D",
    "dropname": "HIMA",
    "dropdeladd": "1579 HIGHWAY 80 E",
    "dropdelcty": "HIMA",
    "dropdelst": "KY",
    "dropdelzpp": 409519997,
    "dropphyadd": "1579 HIGHWAY 80 E",
    "dropphycty": "HIMA",
    "dropphyst": "KY",
    "dropphyzpp": 409519997,
    "dropmaladd": "1579 HIGHWAY 80 E",
    "dropmalcty": "HIMA",
    "dropmalst": "KY",
    "dropmalzpp": 409519997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065987452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15327",
    "droptype": "D",
    "dropname": "HINDMAN",
    "dropdeladd": "27 MAIN ST E",
    "dropdelcty": "HINDMAN",
    "dropdelst": "KY",
    "dropdelzpp": 418229998,
    "dropphyadd": "27 MAIN ST E",
    "dropphycty": "HINDMAN",
    "dropphyst": "KY",
    "dropphyzpp": 418229998,
    "dropmaladd": "27 MAIN ST E",
    "dropmalcty": "HINDMAN",
    "dropmalst": "KY",
    "dropmalzpp": 418229998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067855729,
    "dropfax": 6067853699
  },
  {
    "dcode": "D",
    "dropkey": "PX15331",
    "droptype": "D",
    "dropname": "HISEVILLE",
    "dropdeladd": "55 W HISEVILLE MAIN ST",
    "dropdelcty": "HISEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 421529998,
    "dropphyadd": "55 W HISEVILLE MAIN ST",
    "dropphycty": "HISEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 421529998,
    "dropmaladd": "55 W HISEVILLE MAIN ST",
    "dropmalcty": "HISEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 421529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704534244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15334",
    "droptype": "D",
    "dropname": "HITCHINS",
    "dropdeladd": "3625 S STATE HIGHWAY 1",
    "dropdelcty": "HITCHINS",
    "dropdelst": "KY",
    "dropdelzpp": 411469998,
    "dropphyadd": "3625 S STATE HIGHWAY 1",
    "dropphycty": "HITCHINS",
    "dropphyst": "KY",
    "dropphyzpp": 411469998,
    "dropmaladd": "3625 S STATE HIGHWAY 1",
    "dropmalcty": "HITCHINS",
    "dropmalst": "KY",
    "dropmalzpp": 411469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064747057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15338",
    "droptype": "D",
    "dropname": "HODGENVILLE",
    "dropdeladd": "102 S WALTERS AVE",
    "dropdelcty": "HODGENVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427489998,
    "dropphyadd": "102 S WALTERS AVE",
    "dropphycty": "HODGENVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427489998,
    "dropmaladd": "102 S WALTERS AVE",
    "dropmalcty": "HODGENVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703583254,
    "dropfax": 2703583254
  },
  {
    "dcode": "D",
    "dropkey": "PX15355",
    "droptype": "D",
    "dropname": "HOPKINSVILLE",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "HOPKINSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 422409998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "HOPKINSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 422409998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "HOPKINSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 422409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708865259,
    "dropfax": 2708869799
  },
  {
    "dcode": "D",
    "dropkey": "PX15359",
    "droptype": "D",
    "dropname": "HORSE CAVE",
    "dropdeladd": "117 WATER ST",
    "dropdelcty": "HORSE CAVE",
    "dropdelst": "KY",
    "dropdelzpp": 427499998,
    "dropphyadd": "117 WATER ST",
    "dropphycty": "HORSE CAVE",
    "dropphyst": "KY",
    "dropphyzpp": 427499998,
    "dropmaladd": "117 WATER ST",
    "dropmalcty": "HORSE CAVE",
    "dropmalst": "KY",
    "dropmalzpp": 427499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707862427,
    "dropfax": 2707862644
  },
  {
    "dcode": "D",
    "dropkey": "PX15361",
    "droptype": "D",
    "dropname": "HOSKINSTON",
    "dropdeladd": "13464 HIGHWAY 421",
    "dropdelcty": "HOSKINSTON",
    "dropdelst": "KY",
    "dropdelzpp": 408449998,
    "dropphyadd": "13464 HIGHWAY 421",
    "dropphycty": "HOSKINSTON",
    "dropphyst": "KY",
    "dropphyzpp": 408449998,
    "dropmaladd": "13464 HIGHWAY 421",
    "dropmalcty": "HOSKINSTON",
    "dropmalst": "KY",
    "dropmalzpp": 408449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063743067,
    "dropfax": 6063743970
  },
  {
    "dcode": "D",
    "dropkey": "PX15372",
    "droptype": "D",
    "dropname": "HUEYSVILLE",
    "dropdeladd": "85 SALT LICK CRK",
    "dropdelcty": "HUEYSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 416409998,
    "dropphyadd": "85 SALT LICK CRK",
    "dropphycty": "HUEYSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 416409998,
    "dropmaladd": "85 SALT LICK CRK",
    "dropmalcty": "HUEYSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 416409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063589477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15379",
    "droptype": "D",
    "dropname": "HUSTONVILLE",
    "dropdeladd": "31 DANVILLE PIKE",
    "dropdelcty": "HUSTONVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404379900,
    "dropphyadd": "31 DANVILLE PIKE",
    "dropphycty": "HUSTONVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404379900,
    "dropmaladd": "31 DANVILLE PIKE",
    "dropmalcty": "HUSTONVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404379900,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063700934,
    "dropfax": 6063465075
  },
  {
    "dcode": "D",
    "dropkey": "PX15380",
    "droptype": "D",
    "dropname": "HYDEN",
    "dropdeladd": "140 HIGHWAY 80",
    "dropdelcty": "HYDEN",
    "dropdelst": "KY",
    "dropdelzpp": 417499998,
    "dropphyadd": "140 HIGHWAY 80",
    "dropphycty": "HYDEN",
    "dropphyst": "KY",
    "dropphyzpp": 417499998,
    "dropmaladd": "140 HIGHWAY 80",
    "dropmalcty": "HYDEN",
    "dropmalst": "KY",
    "dropmalzpp": 417499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066722509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15385",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "5106 MADISON PIKE",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "KY",
    "dropdelzpp": 410519998,
    "dropphyadd": "5106 MADISON PIKE",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "KY",
    "dropphyzpp": 410519998,
    "dropmaladd": "5106 MADISON PIKE",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "KY",
    "dropmalzpp": 410519998,
    "dropsitphn": 5136845621,
    "dropsitlph": 8593563908,
    "dropsitcph": 8593563908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15389",
    "droptype": "D",
    "dropname": "INEZ",
    "dropdeladd": "33 PARK PL",
    "dropdelcty": "INEZ",
    "dropdelst": "KY",
    "dropdelzpp": 412249997,
    "dropphyadd": "33 PARK PL",
    "dropphycty": "INEZ",
    "dropphyst": "KY",
    "dropphyzpp": 412249997,
    "dropmaladd": "33 PARK PL",
    "dropmalcty": "INEZ",
    "dropmalst": "KY",
    "dropmalzpp": 412249997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062987135,
    "dropfax": 6062985996
  },
  {
    "dcode": "D",
    "dropkey": "PX15391",
    "droptype": "D",
    "dropname": "INGRAM",
    "dropdeladd": "3449 HIGHWAY 92",
    "dropdelcty": "INGRAM",
    "dropdelst": "KY",
    "dropdelzpp": 409559800,
    "dropphyadd": "3449 HIGHWAY 92",
    "dropphycty": "INGRAM",
    "dropphyst": "KY",
    "dropphyzpp": 409559800,
    "dropmaladd": "3449 HIGHWAY 92",
    "dropmalcty": "INGRAM",
    "dropmalst": "KY",
    "dropmalzpp": 409559800,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063379812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15398",
    "droptype": "D",
    "dropname": "IRVINE",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "IRVINE",
    "dropdelst": "KY",
    "dropdelzpp": 403369998,
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "IRVINE",
    "dropphyst": "KY",
    "dropphyzpp": 403369998,
    "dropmaladd": "230 MAIN ST",
    "dropmalcty": "IRVINE",
    "dropmalst": "KY",
    "dropmalzpp": 403369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067233838,
    "dropfax": 6067234246
  },
  {
    "dcode": "D",
    "dropkey": "PX15399",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "111 N 1ST ST",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 401469998,
    "dropphyadd": "111 N 1ST ST",
    "dropphycty": "IRVINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 401469998,
    "dropmaladd": "111 N 1ST ST",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 401469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705671031,
    "dropfax": 2705476328
  },
  {
    "dcode": "D",
    "dropkey": "PX15400",
    "droptype": "D",
    "dropname": "ISLAND",
    "dropdeladd": "120 S 1ST ST",
    "dropdelcty": "ISLAND",
    "dropdelst": "KY",
    "dropdelzpp": 423509998,
    "dropphyadd": "120 S 1ST ST",
    "dropphycty": "ISLAND",
    "dropphyst": "KY",
    "dropphyzpp": 423509998,
    "dropmaladd": "120 S 1ST ST",
    "dropmalcty": "ISLAND",
    "dropmalst": "KY",
    "dropmalzpp": 423509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704863326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15402",
    "droptype": "D",
    "dropname": "ISOM",
    "dropdeladd": "9305 HIGHWAY 15",
    "dropdelcty": "ISOM",
    "dropdelst": "KY",
    "dropdelzpp": 418249998,
    "dropphyadd": "9305 HIGHWAY 15",
    "dropphycty": "ISOM",
    "dropphyst": "KY",
    "dropphyzpp": 418249998,
    "dropmaladd": "9305 HIGHWAY 15",
    "dropmalcty": "ISOM",
    "dropmalst": "KY",
    "dropmalzpp": 418249998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066337548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15406",
    "droptype": "D",
    "dropname": "IVEL",
    "dropdeladd": "6367 US HIGHWAY 23 S STE 101",
    "dropdelcty": "IVEL",
    "dropdelst": "KY",
    "dropdelzpp": 416429998,
    "dropphyadd": "6367 US HIGHWAY 23 S STE 101",
    "dropphycty": "IVEL",
    "dropphyst": "KY",
    "dropphyzpp": 416429998,
    "dropmaladd": "6367 US HIGHWAY 23 S STE 101",
    "dropmalcty": "IVEL",
    "dropmalst": "KY",
    "dropmalzpp": 416429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064782223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15411",
    "droptype": "D",
    "dropname": "JACKHORN",
    "dropdeladd": "2636 HIGHWAY 317",
    "dropdelcty": "JACKHORN",
    "dropdelst": "KY",
    "dropdelzpp": 418259998,
    "dropphyadd": "2636 HIGHWAY 317",
    "dropphycty": "JACKHORN",
    "dropphyst": "KY",
    "dropphyzpp": 418259998,
    "dropmaladd": "2636 HIGHWAY 317",
    "dropmalcty": "JACKHORN",
    "dropmalst": "KY",
    "dropmalzpp": 418259998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068554090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15413",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "790 HIGHWAY 15 N",
    "dropdelcty": "JACKSON",
    "dropdelst": "KY",
    "dropdelzpp": 413399998,
    "dropphyadd": "790 HIGHWAY 15 N",
    "dropphycty": "JACKSON",
    "dropphyst": "KY",
    "dropphyzpp": 413399998,
    "dropmaladd": "790 HIGHWAY 15 N",
    "dropmalcty": "JACKSON",
    "dropmalst": "KY",
    "dropmalzpp": 413399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066662887,
    "dropfax": 6066668580
  },
  {
    "dcode": "D",
    "dropkey": "PX15416",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "66 FAIR OAKS DR",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 426299998,
    "dropphyadd": "66 FAIR OAKS DR",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 426299998,
    "dropmaladd": "66 FAIR OAKS DR",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 426299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703433980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15420",
    "droptype": "D",
    "dropname": "JEFF",
    "dropdeladd": "136 KY HIGHWAY 7 STE 101",
    "dropdelcty": "JEFF",
    "dropdelst": "KY",
    "dropdelzpp": 417519998,
    "dropphyadd": "136 KY HIGHWAY 7 STE 101",
    "dropphycty": "JEFF",
    "dropphyst": "KY",
    "dropphyzpp": 417519998,
    "dropmaladd": "136 KY HIGHWAY 7 STE 101",
    "dropmalcty": "JEFF",
    "dropmalst": "KY",
    "dropmalzpp": 417519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064393639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15422",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "8000 MAIN ST",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 403379998,
    "dropphyadd": "8000 MAIN ST",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 403379998,
    "dropmaladd": "8000 MAIN ST",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 403379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8594981461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15424",
    "droptype": "D",
    "dropname": "JENKINS",
    "dropdeladd": "9382 HIGHWAY 805 STE A",
    "dropdelcty": "JENKINS",
    "dropdelst": "KY",
    "dropdelzpp": 415379998,
    "dropphyadd": "9382 HIGHWAY 805 STE A",
    "dropphycty": "JENKINS",
    "dropphyst": "KY",
    "dropphyzpp": 415379998,
    "dropmaladd": "9382 HIGHWAY 805 STE A",
    "dropmalcty": "JENKINS",
    "dropmalst": "KY",
    "dropmalzpp": 415379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068322188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15426",
    "droptype": "D",
    "dropname": "JEREMIAH",
    "dropdeladd": "2563 HIGHWAY 7 S",
    "dropdelcty": "JEREMIAH",
    "dropdelst": "KY",
    "dropdelzpp": 418269998,
    "dropphyadd": "2563 HIGHWAY 7 S",
    "dropphycty": "JEREMIAH",
    "dropphyst": "KY",
    "dropphyzpp": 418269998,
    "dropmaladd": "2563 HIGHWAY 7 S",
    "dropmalcty": "JEREMIAH",
    "dropmalst": "KY",
    "dropmalzpp": 418269998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066330548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15431",
    "droptype": "D",
    "dropname": "JETSON",
    "dropdeladd": "10399 BROWNSVILLE RD",
    "dropdelcty": "JETSON",
    "dropdelst": "KY",
    "dropdelzpp": 422529998,
    "dropphyadd": "10399 BROWNSVILLE RD",
    "dropphycty": "JETSON",
    "dropphyst": "KY",
    "dropphyzpp": 422529998,
    "dropmaladd": "10399 BROWNSVILLE RD",
    "dropmalcty": "JETSON",
    "dropmalst": "KY",
    "dropmalzpp": 422529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706626007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15440",
    "droptype": "D",
    "dropname": "JONANCY",
    "dropdeladd": "3440 KY HIGHWAY 610 W",
    "dropdelcty": "JONANCY",
    "dropdelst": "KY",
    "dropdelzpp": 415389998,
    "dropphyadd": "3440 KY HIGHWAY 610 W",
    "dropphycty": "JONANCY",
    "dropphyst": "KY",
    "dropphyzpp": 415389998,
    "dropmaladd": "3440 KY HIGHWAY 610 W",
    "dropmalcty": "JONANCY",
    "dropmalst": "KY",
    "dropmalzpp": 415389998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066390609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15441",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "14780 JONESVILLE RD",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 410529998,
    "dropphyadd": "14780 JONESVILLE RD",
    "dropphycty": "JONESVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 410529998,
    "dropmaladd": "14780 JONESVILLE RD",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410529998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8598244124,
    "dropsitcph": 8598244124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15450",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "810 W SHELBY ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "KY",
    "dropdelzpp": 404409998,
    "dropphyadd": "810 W SHELBY ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "KY",
    "dropphyzpp": 404409998,
    "dropmaladd": "810 W SHELBY ST",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "KY",
    "dropmalzpp": 404409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598546016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15458",
    "droptype": "D",
    "dropname": "KEAVY",
    "dropdeladd": "356 W HIGHWAY 312",
    "dropdelcty": "KEAVY",
    "dropdelst": "KY",
    "dropdelzpp": 407379998,
    "dropphyadd": "356 W HIGHWAY 312",
    "dropphycty": "KEAVY",
    "dropphyst": "KY",
    "dropphyzpp": 407379998,
    "dropmaladd": "356 W HIGHWAY 312",
    "dropmalcty": "KEAVY",
    "dropmalst": "KY",
    "dropmalzpp": 407379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068645774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15459",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "106 KEENE SOUTH ELKHORN RD",
    "dropdelcty": "KEENE",
    "dropdelst": "KY",
    "dropdelzpp": 403399998,
    "dropphyadd": "106 KEENE SOUTH ELKHORN RD",
    "dropphycty": "KEENE",
    "dropphyst": "KY",
    "dropphyzpp": 403399998,
    "dropmaladd": "106 KEENE SOUTH ELKHORN RD",
    "dropmalcty": "KEENE",
    "dropmalst": "KY",
    "dropmalzpp": 403399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598851227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15472",
    "droptype": "D",
    "dropname": "KENVIR",
    "dropdeladd": "139 POST OFFICE DR",
    "dropdelcty": "KENVIR",
    "dropdelst": "KY",
    "dropdelzpp": 408479998,
    "dropphyadd": "139 POST OFFICE DR",
    "dropphycty": "KENVIR",
    "dropphyst": "KY",
    "dropphyzpp": 408479998,
    "dropmaladd": "139 POST OFFICE DR",
    "dropmalcty": "KENVIR",
    "dropmalst": "KY",
    "dropmalzpp": 408479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064460106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15477",
    "droptype": "D",
    "dropname": "KEVIL",
    "dropdeladd": "253 WALLACE AVE E",
    "dropdelcty": "KEVIL",
    "dropdelst": "KY",
    "dropdelzpp": 420539998,
    "dropphyadd": "253 WALLACE AVE E",
    "dropphycty": "KEVIL",
    "dropphyst": "KY",
    "dropphyzpp": 420539998,
    "dropmaladd": "253 WALLACE AVE E",
    "dropmalcty": "KEVIL",
    "dropmalst": "KY",
    "dropmalzpp": 420539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704623425,
    "dropfax": 2704622005
  },
  {
    "dcode": "D",
    "dropkey": "PX15481",
    "droptype": "D",
    "dropname": "KIMPER",
    "dropdeladd": "9414 STATE HIGHWAY 194 E",
    "dropdelcty": "KIMPER",
    "dropdelst": "KY",
    "dropdelzpp": 415399998,
    "dropphyadd": "9414 STATE HIGHWAY 194 E",
    "dropphycty": "KIMPER",
    "dropphyst": "KY",
    "dropphyzpp": 415399998,
    "dropmaladd": "9414 STATE HIGHWAY 194 E",
    "dropmalcty": "KIMPER",
    "dropmalst": "KY",
    "dropmalzpp": 415399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066313666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15484",
    "droptype": "D",
    "dropname": "KINGS MOUNTAIN",
    "dropdeladd": "2705 KY HIGHWAY 501",
    "dropdelcty": "KINGS MOUNTAIN",
    "dropdelst": "KY",
    "dropdelzpp": 404429998,
    "dropphyadd": "2705 KY HIGHWAY 501",
    "dropphycty": "KINGS MOUNTAIN",
    "dropphyst": "KY",
    "dropphyzpp": 404429998,
    "dropmaladd": "2705 KY HIGHWAY 501",
    "dropmalcty": "KINGS MOUNTAIN",
    "dropmalst": "KY",
    "dropmalzpp": 404429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063653058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15488",
    "droptype": "D",
    "dropname": "KIRKSEY",
    "dropdeladd": "55 BACKUSBURG RD",
    "dropdelcty": "KIRKSEY",
    "dropdelst": "KY",
    "dropdelzpp": 420549998,
    "dropphyadd": "55 BACKUSBURG RD",
    "dropphycty": "KIRKSEY",
    "dropphyst": "KY",
    "dropphyzpp": 420549998,
    "dropmaladd": "55 BACKUSBURG RD",
    "dropmalcty": "KIRKSEY",
    "dropmalst": "KY",
    "dropmalzpp": 420549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704892421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15489",
    "droptype": "D",
    "dropname": "KITE",
    "dropdeladd": "9069 HIGHWAY 7 S",
    "dropdelcty": "KITE",
    "dropdelst": "KY",
    "dropdelzpp": 418289998,
    "dropphyadd": "9069 HIGHWAY 7 S",
    "dropphycty": "KITE",
    "dropphyst": "KY",
    "dropphyzpp": 418289998,
    "dropmaladd": "9069 HIGHWAY 7 S",
    "dropmalcty": "KITE",
    "dropmalst": "KY",
    "dropmalzpp": 418289998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064472338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15492",
    "droptype": "D",
    "dropname": "KNOB LICK",
    "dropdeladd": "5260 SULPHUR WELL KNOB LICK RD",
    "dropdelcty": "KNOB LICK",
    "dropdelst": "KY",
    "dropdelzpp": 421549998,
    "dropphyadd": "5260 SULPHUR WELL KNOB LICK RD",
    "dropphycty": "KNOB LICK",
    "dropphyst": "KY",
    "dropphyzpp": 421549998,
    "dropmaladd": "5260 SULPHUR WELL KNOB LICK RD",
    "dropmalcty": "KNOB LICK",
    "dropmalst": "KY",
    "dropmalzpp": 421549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705654415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15497",
    "droptype": "D",
    "dropname": "KRYPTON",
    "dropdeladd": "239 KRYPTON NAPFOR RD",
    "dropdelcty": "KRYPTON",
    "dropdelst": "KY",
    "dropdelzpp": 417549998,
    "dropphyadd": "239 KRYPTON NAPFOR RD",
    "dropphycty": "KRYPTON",
    "dropphyst": "KY",
    "dropphyzpp": 417549998,
    "dropmaladd": "239 KRYPTON NAPFOR RD",
    "dropmalcty": "KRYPTON",
    "dropmalst": "KY",
    "dropmalzpp": 417549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064363669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15498",
    "droptype": "D",
    "dropname": "KUTTAWA",
    "dropdeladd": "67 BEECH ST",
    "dropdelcty": "KUTTAWA",
    "dropdelst": "KY",
    "dropdelzpp": 420559998,
    "dropphyadd": "67 BEECH ST",
    "dropphycty": "KUTTAWA",
    "dropphyst": "KY",
    "dropphyzpp": 420559998,
    "dropmaladd": "67 BEECH ST",
    "dropmalcty": "KUTTAWA",
    "dropmalst": "KY",
    "dropmalzpp": 420559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703887621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15506",
    "droptype": "D",
    "dropname": "LA CENTER",
    "dropdeladd": "348 BROADWAY",
    "dropdelcty": "LA CENTER",
    "dropdelst": "KY",
    "dropdelzpp": 420569998,
    "dropphyadd": "348 BROADWAY",
    "dropphycty": "LA CENTER",
    "dropphyst": "KY",
    "dropphyzpp": 420569998,
    "dropmaladd": "348 BROADWAY",
    "dropmalcty": "LA CENTER",
    "dropmalst": "KY",
    "dropmalzpp": 420569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706655508,
    "dropfax": 2706655512
  },
  {
    "dcode": "D",
    "dropkey": "PX15508",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "108 W CRYSTAL DR",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "KY",
    "dropdelzpp": 400319998,
    "dropphyadd": "108 W CRYSTAL DR",
    "dropphycty": "LA GRANGE",
    "dropphyst": "KY",
    "dropphyzpp": 400319998,
    "dropmaladd": "108 W CRYSTAL DR",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "KY",
    "dropmalzpp": 400319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022229625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15510",
    "droptype": "D",
    "dropname": "LACKEY",
    "dropdeladd": "235 KY ROUTE 7",
    "dropdelcty": "LACKEY",
    "dropdelst": "KY",
    "dropdelzpp": 416439998,
    "dropphyadd": "235 KY ROUTE 7",
    "dropphycty": "LACKEY",
    "dropphyst": "KY",
    "dropphyzpp": 416439998,
    "dropmaladd": "235 KY ROUTE 7",
    "dropmalcty": "LACKEY",
    "dropmalst": "KY",
    "dropmalzpp": 416439998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063584042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15522",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "107 DANVILLE ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "KY",
    "dropdelzpp": 404449998,
    "dropphyadd": "107 DANVILLE ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "KY",
    "dropphyzpp": 404449998,
    "dropmaladd": "107 DANVILLE ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "KY",
    "dropmalzpp": 404449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8597922941,
    "dropfax": 8597926535
  },
  {
    "dcode": "D",
    "dropkey": "PX15533",
    "droptype": "D",
    "dropname": "LAWRENCEBURG",
    "dropdeladd": "1269 FOX CREEK RD",
    "dropdelcty": "LAWRENCEBURG",
    "dropdelst": "KY",
    "dropdelzpp": 403429998,
    "dropphyadd": "1269 FOX CREEK RD",
    "dropphycty": "LAWRENCEBURG",
    "dropphyst": "KY",
    "dropphyzpp": 403429998,
    "dropmaladd": "1269 FOX CREEK RD",
    "dropmalcty": "LAWRENCEBURG",
    "dropmalst": "KY",
    "dropmalzpp": 403429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028393385,
    "dropfax": 5028398113
  },
  {
    "dcode": "D",
    "dropkey": "PX15541",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "KY",
    "dropdelzpp": 400339998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "LEBANON",
    "dropphyst": "KY",
    "dropphyzpp": 400339998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "KY",
    "dropmalzpp": 400339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706922270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15543",
    "droptype": "D",
    "dropname": "LEBANON JUNCTION",
    "dropdeladd": "11716 S PRESTON HWY",
    "dropdelcty": "LEBANON JUNCTION",
    "dropdelst": "KY",
    "dropdelzpp": 401509998,
    "dropphyadd": "11716 S PRESTON HWY",
    "dropphycty": "LEBANON JUNCTION",
    "dropphyst": "KY",
    "dropphyzpp": 401509998,
    "dropmaladd": "11716 S PRESTON HWY",
    "dropmalcty": "LEBANON JUNCTION",
    "dropmalst": "KY",
    "dropmalzpp": 401509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028334471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15544",
    "droptype": "D",
    "dropname": "LEBURN",
    "dropdeladd": "2028 HIGHWAY 550 E",
    "dropdelcty": "LEBURN",
    "dropdelst": "KY",
    "dropdelzpp": 418319998,
    "dropphyadd": "2028 HIGHWAY 550 E",
    "dropphycty": "LEBURN",
    "dropphyst": "KY",
    "dropphyzpp": 418319998,
    "dropmaladd": "2028 HIGHWAY 550 E",
    "dropmalcty": "LEBURN",
    "dropmalst": "KY",
    "dropmalzpp": 418319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067855344,
    "dropfax": 6067855344
  },
  {
    "dcode": "D",
    "dropkey": "PX15547",
    "droptype": "D",
    "dropname": "LEDBETTER",
    "dropdeladd": "1490 US HIGHWAY 60 W",
    "dropdelcty": "LEDBETTER",
    "dropdelst": "KY",
    "dropdelzpp": 420589998,
    "dropphyadd": "1490 US HIGHWAY 60 W",
    "dropphycty": "LEDBETTER",
    "dropphyst": "KY",
    "dropphyzpp": 420589998,
    "dropmaladd": "1490 US HIGHWAY 60 W",
    "dropmalcty": "LEDBETTER",
    "dropmalst": "KY",
    "dropmalzpp": 420589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708987200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15557",
    "droptype": "D",
    "dropname": "LEITCHFIELD",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "LEITCHFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 427549998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "LEITCHFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 427549998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "LEITCHFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 427549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702593087,
    "dropfax": 2702595621
  },
  {
    "dcode": "D",
    "dropkey": "PX15559",
    "droptype": "D",
    "dropname": "LEJUNIOR",
    "dropdeladd": "13161 HIGHWAY 38",
    "dropdelcty": "LEJUNIOR",
    "dropdelst": "KY",
    "dropdelzpp": 408499998,
    "dropphyadd": "13161 HIGHWAY 38",
    "dropphycty": "LEJUNIOR",
    "dropphyst": "KY",
    "dropphyzpp": 408499998,
    "dropmaladd": "13161 HIGHWAY 38",
    "dropmalcty": "LEJUNIOR",
    "dropmalst": "KY",
    "dropmalzpp": 408499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068378621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15570",
    "droptype": "D",
    "dropname": "LEWISBURG",
    "dropdeladd": "182 S 3RD ST",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "KY",
    "dropdelzpp": 422569998,
    "dropphyadd": "182 S 3RD ST",
    "dropphycty": "LEWISBURG",
    "dropphyst": "KY",
    "dropphyzpp": 422569998,
    "dropmaladd": "182 S 3RD ST",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "KY",
    "dropmalzpp": 422569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706330035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15572",
    "droptype": "D",
    "dropname": "LEWISPORT",
    "dropdeladd": "550 4TH ST",
    "dropdelcty": "LEWISPORT",
    "dropdelst": "KY",
    "dropdelzpp": 423519998,
    "dropphyadd": "550 4TH ST",
    "dropphycty": "LEWISPORT",
    "dropphyst": "KY",
    "dropphyzpp": 423519998,
    "dropmaladd": "550 4TH ST",
    "dropmalcty": "LEWISPORT",
    "dropmalst": "KY",
    "dropmalzpp": 423519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702956249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15574",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "1088 NANDINO BLVD",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405119998,
    "dropphyadd": "1088 NANDINO BLVD",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405119998,
    "dropmaladd": "1088 NANDINO BLVD",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592316700,
    "dropfax": 8592316703
  },
  {
    "dcode": "D",
    "dropkey": "PX15576",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "56 HUSTONVILLE ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "KY",
    "dropdelzpp": 425399998,
    "dropphyadd": "56 HUSTONVILLE ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "KY",
    "dropphyzpp": 425399998,
    "dropmaladd": "56 HUSTONVILLE ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "KY",
    "dropmalzpp": 425399998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067876561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15581",
    "droptype": "D",
    "dropname": "LICK CREEK",
    "dropdeladd": "1651 LICK CREEK RD",
    "dropdelcty": "LICK CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 415409998,
    "dropphyadd": "1651 LICK CREEK RD",
    "dropphycty": "LICK CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 415409998,
    "dropmaladd": "1651 LICK CREEK RD",
    "dropmalcty": "LICK CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 415409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068354005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15587",
    "droptype": "D",
    "dropname": "LILY",
    "dropdeladd": "4048 E HIGHWAY 552",
    "dropdelcty": "LILY",
    "dropdelst": "KY",
    "dropdelzpp": 407409998,
    "dropphyadd": "4048 E HIGHWAY 552",
    "dropphycty": "LILY",
    "dropphyst": "KY",
    "dropphyzpp": 407409998,
    "dropmaladd": "4048 E HIGHWAY 552",
    "dropmalcty": "LILY",
    "dropmalst": "KY",
    "dropmalzpp": 407409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068644035,
    "dropfax": 6068786767
  },
  {
    "dcode": "D",
    "dropkey": "PX15601",
    "droptype": "D",
    "dropname": "LITTCARR",
    "dropdeladd": "7351 HIGHWAY 160 S",
    "dropdelcty": "LITTCARR",
    "dropdelst": "KY",
    "dropdelzpp": 418349998,
    "dropphyadd": "7351 HIGHWAY 160 S",
    "dropphycty": "LITTCARR",
    "dropphyst": "KY",
    "dropphyzpp": 418349998,
    "dropmaladd": "7351 HIGHWAY 160 S",
    "dropmalcty": "LITTCARR",
    "dropmalst": "KY",
    "dropmalzpp": 418349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066423065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15608",
    "droptype": "D",
    "dropname": "LIVERMORE",
    "dropdeladd": "214 HILL ST",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "KY",
    "dropdelzpp": 423529998,
    "dropphyadd": "214 HILL ST",
    "dropphycty": "LIVERMORE",
    "dropphyst": "KY",
    "dropphyzpp": 423529998,
    "dropmaladd": "214 HILL ST",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "KY",
    "dropmalzpp": 423529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702782748,
    "dropfax": 2702782894
  },
  {
    "dcode": "D",
    "dropkey": "PX15609",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "9121 MAIN ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "KY",
    "dropdelzpp": 404459998,
    "dropphyadd": "9121 MAIN ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "KY",
    "dropphyzpp": 404459998,
    "dropmaladd": "9121 MAIN ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "KY",
    "dropmalzpp": 404459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064534821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15624",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "1760 HIGHWAY 192 W",
    "dropdelcty": "LONDON",
    "dropdelst": "KY",
    "dropdelzpp": 407419998,
    "dropphyadd": "1760 HIGHWAY 192 W",
    "dropphycty": "LONDON",
    "dropphyst": "KY",
    "dropphyzpp": 407419998,
    "dropmaladd": "1760 HIGHWAY 192 W",
    "dropmalcty": "LONDON",
    "dropmalst": "KY",
    "dropmalzpp": 407419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068641722,
    "dropfax": 6068641713
  },
  {
    "dcode": "D",
    "dropkey": "PX15633",
    "droptype": "D",
    "dropname": "LORETTO",
    "dropdeladd": "4800 HIGHWAY 52",
    "dropdelcty": "LORETTO",
    "dropdelst": "KY",
    "dropdelzpp": 400379998,
    "dropphyadd": "4800 HIGHWAY 52",
    "dropphycty": "LORETTO",
    "dropphyst": "KY",
    "dropphyzpp": 400379998,
    "dropmaladd": "4800 HIGHWAY 52",
    "dropmalcty": "LORETTO",
    "dropmalst": "KY",
    "dropmalzpp": 400379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708656411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15634",
    "droptype": "D",
    "dropname": "LOST CREEK",
    "dropdeladd": "9950 HIGHWAY 15 S",
    "dropdelcty": "LOST CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 413489998,
    "dropphyadd": "9950 HIGHWAY 15 S",
    "dropphycty": "LOST CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 413489998,
    "dropmaladd": "9950 HIGHWAY 15 S",
    "dropmalcty": "LOST CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 413489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066665868,
    "dropfax": 6066665433
  },
  {
    "dcode": "D",
    "dropkey": "PX15637",
    "droptype": "D",
    "dropname": "LOUISA",
    "dropdeladd": "108 E MADISON ST",
    "dropdelcty": "LOUISA",
    "dropdelst": "KY",
    "dropdelzpp": 412309997,
    "dropphyadd": "108 E MADISON ST",
    "dropphycty": "LOUISA",
    "dropphyst": "KY",
    "dropphyzpp": 412309997,
    "dropmaladd": "108 E MADISON ST",
    "dropmalcty": "LOUISA",
    "dropmalst": "KY",
    "dropmalzpp": 412309997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066384840,
    "dropfax": 6066383824
  },
  {
    "dcode": "D",
    "dropkey": "PX15639",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "1420 GARDINER LN",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402319989,
    "dropphyadd": "1420 GARDINER LN",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402319989,
    "dropmaladd": "PO BOX 31998",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024541763,
    "dropfax": 5024541609
  },
  {
    "dcode": "D",
    "dropkey": "PX15641",
    "droptype": "D",
    "dropname": "LOVELACEVILLE",
    "dropdeladd": "142 N BROADWAY ST",
    "dropdelcty": "LOVELACEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 420609900,
    "dropphyadd": "142 N BROADWAY ST",
    "dropphycty": "LOVELACEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 420609900,
    "dropmaladd": "142 N BROADWAY ST",
    "dropmalcty": "LOVELACEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 420609900,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708767203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15644",
    "droptype": "D",
    "dropname": "LOVELY",
    "dropdeladd": "1423 RIVER FRONT RD STE 100",
    "dropdelcty": "LOVELY",
    "dropdelst": "KY",
    "dropdelzpp": 412319998,
    "dropphyadd": "1423 RIVER FRONT RD STE 100",
    "dropphycty": "LOVELY",
    "dropphyst": "KY",
    "dropphyzpp": 412319998,
    "dropmaladd": "1423 RIVER FRONT RD STE 100",
    "dropmalcty": "LOVELY",
    "dropmalst": "KY",
    "dropmalzpp": 412319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063955848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15647",
    "droptype": "D",
    "dropname": "LOWES",
    "dropdeladd": "6899 STATE ROUTE 440",
    "dropdelcty": "LOWES",
    "dropdelst": "KY",
    "dropdelzpp": 420619998,
    "dropphyadd": "6899 STATE ROUTE 440",
    "dropphycty": "LOWES",
    "dropphyst": "KY",
    "dropphyzpp": 420619998,
    "dropmaladd": "6899 STATE ROUTE 440",
    "dropmalcty": "LOWES",
    "dropmalst": "KY",
    "dropmalzpp": 420619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702004894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15649",
    "droptype": "D",
    "dropname": "LOWMANSVILLE",
    "dropdeladd": "48 MAY LN",
    "dropdelcty": "LOWMANSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 412329998,
    "dropphyadd": "48 MAY LN",
    "dropphycty": "LOWMANSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 412329998,
    "dropmaladd": "48 MAY LN",
    "dropmalcty": "LOWMANSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 412329998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062973234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15650",
    "droptype": "D",
    "dropname": "LOYALL",
    "dropdeladd": "106 BAILEY ST",
    "dropdelcty": "LOYALL",
    "dropdelst": "KY",
    "dropdelzpp": 408549998,
    "dropphyadd": "106 BAILEY ST",
    "dropphycty": "LOYALL",
    "dropphyst": "KY",
    "dropphyzpp": 408549998,
    "dropmaladd": "106 BAILEY ST",
    "dropmalcty": "LOYALL",
    "dropmalst": "KY",
    "dropmalzpp": 408549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065731308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15654",
    "droptype": "D",
    "dropname": "LYNCH",
    "dropdeladd": "10 E MAIN ST",
    "dropdelcty": "LYNCH",
    "dropdelst": "KY",
    "dropdelzpp": 408559998,
    "dropphyadd": "10 E MAIN ST",
    "dropphycty": "LYNCH",
    "dropphyst": "KY",
    "dropphyzpp": 408559998,
    "dropmaladd": "10 E MAIN ST",
    "dropmalcty": "LYNCH",
    "dropmalst": "KY",
    "dropmalzpp": 408559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068482267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15659",
    "droptype": "D",
    "dropname": "LYNNVILLE",
    "dropdeladd": "3608 E STATE ROUTE 94",
    "dropdelcty": "LYNNVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 420639998,
    "dropphyadd": "3608 E STATE ROUTE 94",
    "dropphycty": "LYNNVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 420639998,
    "dropmaladd": "3608 E STATE ROUTE 94",
    "dropmalcty": "LYNNVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 420639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703822316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15664",
    "droptype": "D",
    "dropname": "MACEO",
    "dropdeladd": "10124 STATE ROUTE 405",
    "dropdelcty": "MACEO",
    "dropdelst": "KY",
    "dropdelzpp": 423559998,
    "dropphyadd": "10124 STATE ROUTE 405",
    "dropphycty": "MACEO",
    "dropphyst": "KY",
    "dropphyzpp": 423559998,
    "dropmaladd": "10124 STATE ROUTE 405",
    "dropmalcty": "MACEO",
    "dropmalst": "KY",
    "dropmalzpp": 423559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702641702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15665",
    "droptype": "D",
    "dropname": "MACKVILLE",
    "dropdeladd": "10696 MAIN ST",
    "dropdelcty": "MACKVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400409998,
    "dropphyadd": "10696 MAIN ST",
    "dropphycty": "MACKVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400409998,
    "dropmaladd": "10696 MAIN ST",
    "dropmalcty": "MACKVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592625156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15668",
    "droptype": "D",
    "dropname": "MADISONVILLE",
    "dropdeladd": "117 W CENTER ST",
    "dropdelcty": "MADISONVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 424319998,
    "dropphyadd": "117 W CENTER ST",
    "dropphycty": "MADISONVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 424319998,
    "dropmaladd": "117 W CENTER ST",
    "dropmalcty": "MADISONVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 424319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708216862,
    "dropfax": 2708258907
  },
  {
    "dcode": "D",
    "dropkey": "PX15673",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "4900 S L AND N TPKE",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "KY",
    "dropdelzpp": 427579998,
    "dropphyadd": "4900 S L AND N TPKE",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "KY",
    "dropphyzpp": 427579998,
    "dropmaladd": "4900 S L AND N TPKE",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "KY",
    "dropmalzpp": 427579998,
    "dropsitphn": 2703243434,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703300039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15676",
    "droptype": "D",
    "dropname": "MAJESTIC",
    "dropdeladd": "48789 STATE HIGHWAY 194 E",
    "dropdelcty": "MAJESTIC",
    "dropdelst": "KY",
    "dropdelzpp": 415479998,
    "dropphyadd": "48789 STATE HIGHWAY 194 E",
    "dropphycty": "MAJESTIC",
    "dropphyst": "KY",
    "dropphyzpp": 415479998,
    "dropmaladd": "48789 STATE HIGHWAY 194 E",
    "dropmalcty": "MAJESTIC",
    "dropmalst": "KY",
    "dropmalzpp": 415479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064568097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15677",
    "droptype": "D",
    "dropname": "MALLIE",
    "dropdeladd": "22 BRANHAMS CREEK RD",
    "dropdelcty": "MALLIE",
    "dropdelst": "KY",
    "dropdelzpp": 418369998,
    "dropphyadd": "22 BRANHAMS CREEK RD",
    "dropphycty": "MALLIE",
    "dropphyst": "KY",
    "dropphyzpp": 418369998,
    "dropmaladd": "22 BRANHAMS CREEK RD",
    "dropmalcty": "MALLIE",
    "dropmalst": "KY",
    "dropmalzpp": 418369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067855189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15678",
    "droptype": "D",
    "dropname": "MALONE",
    "dropdeladd": "2570 HIGHWAY 191",
    "dropdelcty": "MALONE",
    "dropdelst": "KY",
    "dropdelzpp": 414519998,
    "dropphyadd": "2570 HIGHWAY 191",
    "dropphycty": "MALONE",
    "dropphyst": "KY",
    "dropphyzpp": 414519998,
    "dropmaladd": "2570 HIGHWAY 191",
    "dropmalcty": "MALONE",
    "dropmalst": "KY",
    "dropmalzpp": 414519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067437032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15680",
    "droptype": "D",
    "dropname": "MAMMOTH CAVE",
    "dropdeladd": "2811 ENTRANCE RD",
    "dropdelcty": "MAMMOTH CAVE",
    "dropdelst": "KY",
    "dropdelzpp": 422599998,
    "dropphyadd": "2811 ENTRANCE RD",
    "dropphycty": "MAMMOTH CAVE",
    "dropphyst": "KY",
    "dropphyzpp": 422599998,
    "dropmaladd": "2811 ENTRANCE RD",
    "dropmalcty": "MAMMOTH CAVE",
    "dropmalst": "KY",
    "dropmalzpp": 422599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707582311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15682",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "309 CLAY COUNTY SHOPPING CTR",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "KY",
    "dropdelzpp": 409629998,
    "dropphyadd": "309 CLAY COUNTY SHOPPING CTR",
    "dropphycty": "MANCHESTER",
    "dropphyst": "KY",
    "dropphyzpp": 409629998,
    "dropmaladd": "309 CLAY COUNTY SHOPPING CTR",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "KY",
    "dropmalzpp": 409629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065983499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15684",
    "droptype": "D",
    "dropname": "MANITOU",
    "dropdeladd": "5270 NEBO RD",
    "dropdelcty": "MANITOU",
    "dropdelst": "KY",
    "dropdelzpp": 424369998,
    "dropphyadd": "5270 NEBO RD",
    "dropphycty": "MANITOU",
    "dropphyst": "KY",
    "dropphyzpp": 424369998,
    "dropmaladd": "5270 NEBO RD",
    "dropmalcty": "MANITOU",
    "dropmalst": "KY",
    "dropmalzpp": 424369998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702493777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15687",
    "droptype": "D",
    "dropname": "MANNSVILLE",
    "dropdeladd": "1 FERGUSON RD",
    "dropdelcty": "MANNSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427589998,
    "dropphyadd": "1 FERGUSON RD",
    "dropphycty": "MANNSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427589998,
    "dropmaladd": "1 FERGUSON RD",
    "dropmalcty": "MANNSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704657092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15695",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "128 E CARLISLE ST",
    "dropdelcty": "MARION",
    "dropdelst": "KY",
    "dropdelzpp": 420649998,
    "dropphyadd": "128 E CARLISLE ST",
    "dropphycty": "MARION",
    "dropphyst": "KY",
    "dropphyzpp": 420649998,
    "dropmaladd": "128 E CARLISLE ST",
    "dropmalcty": "MARION",
    "dropmalst": "KY",
    "dropmalzpp": 420649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709653811,
    "dropfax": 2709653798
  },
  {
    "dcode": "D",
    "dropkey": "PX15696",
    "droptype": "D",
    "dropname": "MARROWBONE",
    "dropdeladd": "9283 GLASGOW RD",
    "dropdelcty": "MARROWBONE",
    "dropdelst": "KY",
    "dropdelzpp": 427599997,
    "dropphyadd": "9283 GLASGOW RD",
    "dropphycty": "MARROWBONE",
    "dropphyst": "KY",
    "dropphyzpp": 427599997,
    "dropmaladd": "9283 GLASGOW RD",
    "dropmalcty": "MARROWBONE",
    "dropmalst": "KY",
    "dropmalzpp": 427599997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708645676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15698",
    "droptype": "D",
    "dropname": "MARSHES SIDING",
    "dropdeladd": "23 ALUM RD",
    "dropdelcty": "MARSHES SIDING",
    "dropdelst": "KY",
    "dropdelzpp": 426319998,
    "dropphyadd": "23 ALUM RD",
    "dropphycty": "MARSHES SIDING",
    "dropphyst": "KY",
    "dropphyzpp": 426319998,
    "dropmaladd": "23 ALUM RD",
    "dropmalcty": "MARSHES SIDING",
    "dropmalst": "KY",
    "dropmalzpp": 426319998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063762057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15699",
    "droptype": "D",
    "dropname": "MARTHA",
    "dropdeladd": "247 HIGHWAY 469",
    "dropdelcty": "MARTHA",
    "dropdelst": "KY",
    "dropdelzpp": 411599998,
    "dropphyadd": "247 HIGHWAY 469",
    "dropphycty": "MARTHA",
    "dropphyst": "KY",
    "dropphyzpp": 411599998,
    "dropmaladd": "247 HIGHWAY 469",
    "dropmalcty": "MARTHA",
    "dropmalst": "KY",
    "dropmalzpp": 411599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066523742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15701",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "11561 MAIN ST",
    "dropdelcty": "MARTIN",
    "dropdelst": "KY",
    "dropdelzpp": 416499998,
    "dropphyadd": "11561 MAIN ST",
    "dropphycty": "MARTIN",
    "dropphyst": "KY",
    "dropphyzpp": 416499998,
    "dropmaladd": "11561 MAIN ST",
    "dropmalcty": "MARTIN",
    "dropmalst": "KY",
    "dropmalzpp": 416499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062859160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15708",
    "droptype": "D",
    "dropname": "MASONIC HOME",
    "dropdeladd": "3761 JOHNSON HALL DR",
    "dropdelcty": "MASONIC HOME",
    "dropdelst": "KY",
    "dropdelzpp": 400419998,
    "dropphyadd": "3761 JOHNSON HALL DR",
    "dropphycty": "MASONIC HOME",
    "dropphyst": "KY",
    "dropphyzpp": 400419998,
    "dropmaladd": "3761 JOHNSON HALL DR",
    "dropmalcty": "MASONIC HOME",
    "dropmalst": "KY",
    "dropmalzpp": 400419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028937621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15719",
    "droptype": "D",
    "dropname": "MAYFIELD",
    "dropdeladd": "225 W BROADWAY",
    "dropdelcty": "MAYFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 420669998,
    "dropphyadd": "225 W BROADWAY",
    "dropphycty": "MAYFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 420669998,
    "dropmaladd": "225 W BROADWAY",
    "dropmalcty": "MAYFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 420669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702471305,
    "dropfax": 2702471914
  },
  {
    "dcode": "D",
    "dropkey": "PX15720",
    "droptype": "D",
    "dropname": "MAYKING",
    "dropdeladd": "3397 HIGHWAY 119 N",
    "dropdelcty": "MAYKING",
    "dropdelst": "KY",
    "dropdelzpp": 418379998,
    "dropphyadd": "3397 HIGHWAY 119 N",
    "dropphycty": "MAYKING",
    "dropphyst": "KY",
    "dropphyzpp": 418379998,
    "dropmaladd": "3397 HIGHWAY 119 N",
    "dropmalcty": "MAYKING",
    "dropmalst": "KY",
    "dropmalzpp": 418379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066332520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15722",
    "droptype": "D",
    "dropname": "MAYSLICK",
    "dropdeladd": "5014 MAIN ST",
    "dropdelcty": "MAYSLICK",
    "dropdelst": "KY",
    "dropdelzpp": 410559998,
    "dropphyadd": "5014 MAIN ST",
    "dropphycty": "MAYSLICK",
    "dropphyst": "KY",
    "dropphyzpp": 410559998,
    "dropmaladd": "5014 MAIN ST",
    "dropmalcty": "MAYSLICK",
    "dropmalst": "KY",
    "dropmalzpp": 410559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067636413,
    "dropsitcph": 6067636413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15723",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "131 E 3RD ST",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 410569998,
    "dropphyadd": "131 E 3RD ST",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 410569998,
    "dropmaladd": "131 E 3RD ST",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6065643461,
    "dropsitcph": 6065643461,
    "dropfax": 6065647829
  },
  {
    "dcode": "D",
    "dropkey": "PX15728",
    "droptype": "D",
    "dropname": "MC ANDREWS",
    "dropdeladd": "2330 POND CREEK RD STE 105",
    "dropdelcty": "MC ANDREWS",
    "dropdelst": "KY",
    "dropdelzpp": 415439997,
    "dropphyadd": "2330 POND CREEK RD STE 105",
    "dropphycty": "MC ANDREWS",
    "dropphyst": "KY",
    "dropphyzpp": 415439997,
    "dropmaladd": "2330 POND CREEK RD STE 105",
    "dropmalcty": "MC ANDREWS",
    "dropmalst": "KY",
    "dropmalzpp": 415439997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063539316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15729",
    "droptype": "D",
    "dropname": "MC CARR",
    "dropdeladd": "6884 STATE HIGHWAY 319",
    "dropdelcty": "MC CARR",
    "dropdelst": "KY",
    "dropdelzpp": 415449998,
    "dropphyadd": "6884 STATE HIGHWAY 319",
    "dropphycty": "MC CARR",
    "dropphyst": "KY",
    "dropphyzpp": 415449998,
    "dropmaladd": "6884 STATE HIGHWAY 319",
    "dropmalcty": "MC CARR",
    "dropmalst": "KY",
    "dropmalzpp": 415449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064277574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15731",
    "droptype": "D",
    "dropname": "MC DANIELS",
    "dropdeladd": "9501 S HIGHWAY 259",
    "dropdelcty": "MC DANIELS",
    "dropdelst": "KY",
    "dropdelzpp": 401529998,
    "dropphyadd": "9501 S HIGHWAY 259",
    "dropphycty": "MC DANIELS",
    "dropphyst": "KY",
    "dropphyzpp": 401529998,
    "dropmaladd": "9501 S HIGHWAY 259",
    "dropmalcty": "MC DANIELS",
    "dropmalst": "KY",
    "dropmalzpp": 401529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702578089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15732",
    "droptype": "D",
    "dropname": "MC DOWELL",
    "dropdeladd": "9571 KY ROUTE 122",
    "dropdelcty": "MC DOWELL",
    "dropdelst": "KY",
    "dropdelzpp": 416479998,
    "dropphyadd": "9571 KY ROUTE 122",
    "dropphycty": "MC DOWELL",
    "dropphyst": "KY",
    "dropphyzpp": 416479998,
    "dropmaladd": "9571 KY ROUTE 122",
    "dropmalcty": "MC DOWELL",
    "dropmalst": "KY",
    "dropmalzpp": 416479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063776038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15733",
    "droptype": "D",
    "dropname": "MC HENRY",
    "dropdeladd": "3156 US HIGHWAY 62 W",
    "dropdelcty": "MC HENRY",
    "dropdelst": "KY",
    "dropdelzpp": 423549998,
    "dropphyadd": "3156 US HIGHWAY 62 W",
    "dropphycty": "MC HENRY",
    "dropphyst": "KY",
    "dropphyzpp": 423549998,
    "dropmaladd": "3156 US HIGHWAY 62 W",
    "dropmalcty": "MC HENRY",
    "dropmalst": "KY",
    "dropmalzpp": 423549998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022743186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15734",
    "droptype": "D",
    "dropname": "MC KEE",
    "dropdeladd": "320 MAIN ST N",
    "dropdelcty": "MC KEE",
    "dropdelst": "KY",
    "dropdelzpp": 404479998,
    "dropphyadd": "320 MAIN ST N",
    "dropphycty": "MC KEE",
    "dropphyst": "KY",
    "dropphyzpp": 404479998,
    "dropmaladd": "320 MAIN ST N",
    "dropmalcty": "MC KEE",
    "dropmalst": "KY",
    "dropmalzpp": 404479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062877279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15735",
    "droptype": "D",
    "dropname": "MC KINNEY",
    "dropdeladd": "70 BUSY BEE ST",
    "dropdelcty": "MC KINNEY",
    "dropdelst": "KY",
    "dropdelzpp": 404489998,
    "dropphyadd": "70 BUSY BEE ST",
    "dropphycty": "MC KINNEY",
    "dropphyst": "KY",
    "dropphyzpp": 404489998,
    "dropmaladd": "70 BUSY BEE ST",
    "dropmalcty": "MC KINNEY",
    "dropmalst": "KY",
    "dropmalzpp": 404489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063469133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15736",
    "droptype": "D",
    "dropname": "MC QUADY",
    "dropdeladd": "6801 S HIGHWAY 261",
    "dropdelcty": "MC QUADY",
    "dropdelst": "KY",
    "dropdelzpp": 401539998,
    "dropphyadd": "6801 S HIGHWAY 261",
    "dropphycty": "MC QUADY",
    "dropphyst": "KY",
    "dropphyzpp": 401539998,
    "dropmaladd": "6801 S HIGHWAY 261",
    "dropmalcty": "MC QUADY",
    "dropmalst": "KY",
    "dropmalzpp": 401539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707562681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15737",
    "droptype": "D",
    "dropname": "MC ROBERTS",
    "dropdeladd": "2461 HIGHWAY 343",
    "dropdelcty": "MC ROBERTS",
    "dropdelst": "KY",
    "dropdelzpp": 418359998,
    "dropphyadd": "2461 HIGHWAY 343",
    "dropphycty": "MC ROBERTS",
    "dropphyst": "KY",
    "dropphyzpp": 418359998,
    "dropmaladd": "2461 HIGHWAY 343",
    "dropmalcty": "MC ROBERTS",
    "dropmalst": "KY",
    "dropmalzpp": 418359998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068324123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15752",
    "droptype": "D",
    "dropname": "MEALLY",
    "dropdeladd": "3699 KY ROUTE 40 E",
    "dropdelcty": "MEALLY",
    "dropdelst": "KY",
    "dropdelzpp": 412349998,
    "dropphyadd": "3699 KY ROUTE 40 E",
    "dropphycty": "MEALLY",
    "dropphyst": "KY",
    "dropphyzpp": 412349998,
    "dropmaladd": "3699 KY ROUTE 40 E",
    "dropmalcty": "MEALLY",
    "dropmalst": "KY",
    "dropmalzpp": 412349998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067897404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15753",
    "droptype": "D",
    "dropname": "MEANS",
    "dropdeladd": "8422 US HIGHWAY 460 W",
    "dropdelcty": "MEANS",
    "dropdelst": "KY",
    "dropdelzpp": 403469998,
    "dropphyadd": "8422 US HIGHWAY 460 W",
    "dropphycty": "MEANS",
    "dropphyst": "KY",
    "dropphyzpp": 403469998,
    "dropmaladd": "8422 US HIGHWAY 460 W",
    "dropmalcty": "MEANS",
    "dropmalst": "KY",
    "dropmalzpp": 403469998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067683004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15756",
    "droptype": "D",
    "dropname": "MELBER",
    "dropdeladd": "8650 CLINTON RD",
    "dropdelcty": "MELBER",
    "dropdelst": "KY",
    "dropdelzpp": 420699998,
    "dropphyadd": "8650 CLINTON RD",
    "dropphycty": "MELBER",
    "dropphyst": "KY",
    "dropphyzpp": 420699998,
    "dropmaladd": "8650 CLINTON RD",
    "dropmalcty": "MELBER",
    "dropmalst": "KY",
    "dropmalzpp": 420699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703923871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15757",
    "droptype": "D",
    "dropname": "MELBOURNE",
    "dropdeladd": "5642 MARY INGLES HWY",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "KY",
    "dropdelzpp": 410599998,
    "dropphyadd": "5642 MARY INGLES HWY",
    "dropphycty": "MELBOURNE",
    "dropphyst": "KY",
    "dropphyzpp": 410599998,
    "dropmaladd": "5642 MARY INGLES HWY",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "KY",
    "dropmalzpp": 410599998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8597814369,
    "dropsitcph": 8597814369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15759",
    "droptype": "D",
    "dropname": "MELVIN",
    "dropdeladd": "22944 KY ROUTE 122",
    "dropdelcty": "MELVIN",
    "dropdelst": "KY",
    "dropdelzpp": 416509998,
    "dropphyadd": "22944 KY ROUTE 122",
    "dropphycty": "MELVIN",
    "dropphyst": "KY",
    "dropphyzpp": 416509998,
    "dropmaladd": "22944 KY ROUTE 122",
    "dropmalcty": "MELVIN",
    "dropmalst": "KY",
    "dropmalzpp": 416509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064522448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15769",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "77 S COLLEGE ST",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "KY",
    "dropdelzpp": 425419998,
    "dropphyadd": "77 S COLLEGE ST",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "KY",
    "dropphyzpp": 425419998,
    "dropmaladd": "77 S COLLEGE ST",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "KY",
    "dropmalzpp": 425419998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067875267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15770",
    "droptype": "D",
    "dropname": "MIDDLESBORO",
    "dropdeladd": "201 N 20TH ST",
    "dropdelcty": "MIDDLESBORO",
    "dropdelst": "KY",
    "dropdelzpp": 409659998,
    "dropphyadd": "201 N 20TH ST",
    "dropphycty": "MIDDLESBORO",
    "dropphyst": "KY",
    "dropphyzpp": 409659998,
    "dropmaladd": "201 N 20TH ST",
    "dropmalcty": "MIDDLESBORO",
    "dropmalst": "KY",
    "dropmalzpp": 409659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062483690,
    "dropfax": 6062483691
  },
  {
    "dcode": "D",
    "dropkey": "PX15777",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "100 S WINTER ST",
    "dropdelcty": "MIDWAY",
    "dropdelst": "KY",
    "dropdelzpp": 403479998,
    "dropphyadd": "100 S WINTER ST",
    "dropphycty": "MIDWAY",
    "dropphyst": "KY",
    "dropphyzpp": 403479998,
    "dropmaladd": "100 S WINTER ST",
    "dropmalcty": "MIDWAY",
    "dropmalst": "KY",
    "dropmalzpp": 403479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598464115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15778",
    "droptype": "D",
    "dropname": "MILBURN",
    "dropdeladd": "1 STATE ROUTE 80",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 420219900,
    "dropphyadd": "1 STATE ROUTE 80",
    "dropphycty": "ARLINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 420219900,
    "dropmaladd": "1 STATE ROUTE 80",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 420219900,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706946121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15783",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "425 MAIN ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 403489998,
    "dropphyadd": "425 MAIN ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 403489998,
    "dropmaladd": "425 MAIN ST",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 403489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8594843356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15791",
    "droptype": "D",
    "dropname": "MILLWOOD",
    "dropdeladd": "6445 BEAVER DAM RD",
    "dropdelcty": "MILLWOOD",
    "dropdelst": "KY",
    "dropdelzpp": 427629998,
    "dropphyadd": "6445 BEAVER DAM RD",
    "dropphycty": "MILLWOOD",
    "dropphyst": "KY",
    "dropphyzpp": 427629998,
    "dropmaladd": "6445 BEAVER DAM RD",
    "dropmalcty": "MILLWOOD",
    "dropmalst": "KY",
    "dropmalzpp": 427629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708798093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15793",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "21 HIGH ST",
    "dropdelcty": "MILTON",
    "dropdelst": "KY",
    "dropdelzpp": 400459998,
    "dropphyadd": "21 HIGH ST",
    "dropphycty": "MILTON",
    "dropphyst": "KY",
    "dropphyzpp": 400459998,
    "dropmaladd": "21 HIGH ST",
    "dropmalcty": "MILTON",
    "dropmalst": "KY",
    "dropmalzpp": 400459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022685947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15800",
    "droptype": "D",
    "dropname": "MIRACLE",
    "dropdeladd": "10845 HIGHWAY 987 BROWNIES CRK",
    "dropdelcty": "MIRACLE",
    "dropdelst": "KY",
    "dropdelzpp": 408569998,
    "dropphyadd": "10845 HIGHWAY 987 BROWNIES CRK",
    "dropphycty": "MIRACLE",
    "dropphyst": "KY",
    "dropphyzpp": 408569998,
    "dropmaladd": "10845 HIGHWAY 987 BROWNIES CRK",
    "dropmalcty": "MIRACLE",
    "dropmalst": "KY",
    "dropmalzpp": 408569998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063373690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15803",
    "droptype": "D",
    "dropname": "MIZE",
    "dropdeladd": "8447 HIGHWAY 460 W",
    "dropdelcty": "MIZE",
    "dropdelst": "KY",
    "dropdelzpp": 413529998,
    "dropphyadd": "8447 HIGHWAY 460 W",
    "dropphycty": "MIZE",
    "dropphyst": "KY",
    "dropphyzpp": 413529998,
    "dropmaladd": "8447 HIGHWAY 460 W",
    "dropmalcty": "MIZE",
    "dropmalst": "KY",
    "dropmalzpp": 413529998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067434116,
    "dropfax": 6067439662
  },
  {
    "dcode": "D",
    "dropkey": "PX15814",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "65 BARNES DR",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "KY",
    "dropdelzpp": 426339998,
    "dropphyadd": "65 BARNES DR",
    "dropphycty": "MONTICELLO",
    "dropphyst": "KY",
    "dropphyzpp": 426339998,
    "dropmaladd": "65 BARNES DR",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "KY",
    "dropmalzpp": 426339998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063485291,
    "dropfax": 6063408884
  },
  {
    "dcode": "D",
    "dropkey": "PX15823",
    "droptype": "D",
    "dropname": "MOREHEAD",
    "dropdeladd": "700 W 1ST ST",
    "dropdelcty": "MOREHEAD",
    "dropdelst": "KY",
    "dropdelzpp": 403519998,
    "dropphyadd": "700 W 1ST ST",
    "dropphycty": "MOREHEAD",
    "dropphyst": "KY",
    "dropphyzpp": 403519998,
    "dropmaladd": "700 W 1ST ST",
    "dropmalcty": "MOREHEAD",
    "dropmalst": "KY",
    "dropmalzpp": 403519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067845556,
    "dropfax": 6067804007
  },
  {
    "dcode": "D",
    "dropkey": "PX15825",
    "droptype": "D",
    "dropname": "MORGANFIELD",
    "dropdeladd": "231 W MAIN ST",
    "dropdelcty": "MORGANFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 424379998,
    "dropphyadd": "231 W MAIN ST",
    "dropphycty": "MORGANFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 424379998,
    "dropmaladd": "231 W MAIN ST",
    "dropmalcty": "MORGANFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 424379998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703891291,
    "dropfax": 2703891291
  },
  {
    "dcode": "D",
    "dropkey": "PX15827",
    "droptype": "D",
    "dropname": "MORGANTOWN",
    "dropdeladd": "208 S MAIN ST",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 422619998,
    "dropphyadd": "208 S MAIN ST",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 422619998,
    "dropmaladd": "208 S MAIN ST",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 422619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705263625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15828",
    "droptype": "D",
    "dropname": "MORNING VIEW",
    "dropdeladd": "15000 DECOURSEY PIKE",
    "dropdelcty": "MORNING VIEW",
    "dropdelst": "KY",
    "dropdelzpp": 410639998,
    "dropphyadd": "15000 DECOURSEY PIKE",
    "dropphycty": "MORNING VIEW",
    "dropphyst": "KY",
    "dropphyzpp": 410639998,
    "dropmaladd": "15000 DECOURSEY PIKE",
    "dropmalcty": "MORNING VIEW",
    "dropmalst": "KY",
    "dropmalzpp": 410639998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8593568884,
    "dropsitcph": 8593568884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15834",
    "droptype": "D",
    "dropname": "MORTONS GAP",
    "dropdeladd": "140 CROSS ST",
    "dropdelcty": "MORTONS GAP",
    "dropdelst": "KY",
    "dropdelzpp": 424409998,
    "dropphyadd": "140 CROSS ST",
    "dropphycty": "MORTONS GAP",
    "dropphyst": "KY",
    "dropphyzpp": 424409998,
    "dropmaladd": "140 CROSS ST",
    "dropmalcty": "MORTONS GAP",
    "dropmalst": "KY",
    "dropmalzpp": 424409998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702585639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15848",
    "droptype": "D",
    "dropname": "MOUNT OLIVET",
    "dropdeladd": "7 N MAIN ST",
    "dropdelcty": "MOUNT OLIVET",
    "dropdelst": "KY",
    "dropdelzpp": 410649998,
    "dropphyadd": "7 N MAIN ST",
    "dropphycty": "MOUNT OLIVET",
    "dropphyst": "KY",
    "dropphyzpp": 410649998,
    "dropmaladd": "7 N MAIN ST",
    "dropmalcty": "MOUNT OLIVET",
    "dropmalst": "KY",
    "dropmalzpp": 410649998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067245612,
    "dropsitcph": 6067245612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15851",
    "droptype": "D",
    "dropname": "MOUNT SHERMAN",
    "dropdeladd": "7145 GREENSBURG RD",
    "dropdelcty": "MOUNT SHERMAN",
    "dropdelst": "KY",
    "dropdelzpp": 427649998,
    "dropphyadd": "7145 GREENSBURG RD",
    "dropphycty": "MOUNT SHERMAN",
    "dropphyst": "KY",
    "dropphyzpp": 427649998,
    "dropmaladd": "7145 GREENSBURG RD",
    "dropmalcty": "MOUNT SHERMAN",
    "dropmalst": "KY",
    "dropmalzpp": 427649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703557518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15852",
    "droptype": "D",
    "dropname": "MOUNT STERLING",
    "dropdeladd": "108 W LOCUST ST",
    "dropdelcty": "MOUNT STERLING",
    "dropdelst": "KY",
    "dropdelzpp": 403539998,
    "dropphyadd": "108 W LOCUST ST",
    "dropphycty": "MOUNT STERLING",
    "dropphyst": "KY",
    "dropphyzpp": 403539998,
    "dropmaladd": "108 W LOCUST ST",
    "dropmalcty": "MOUNT STERLING",
    "dropmalst": "KY",
    "dropmalzpp": 403539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8594982258,
    "dropfax": 8594987088
  },
  {
    "dcode": "D",
    "dropkey": "PX15856",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "380 RICHMOND ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "KY",
    "dropdelzpp": 404569998,
    "dropphyadd": "380 RICHMOND ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "KY",
    "dropphyzpp": 404569998,
    "dropmaladd": "380 RICHMOND ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "KY",
    "dropmalzpp": 404569998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6062562717,
    "dropfax": 6062569384
  },
  {
    "dcode": "D",
    "dropkey": "PX15858",
    "droptype": "D",
    "dropname": "MOUNT WASHINGTON",
    "dropdeladd": "645 N BARDSTOWN RD",
    "dropdelcty": "MOUNT WASHINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 400479998,
    "dropphyadd": "645 N BARDSTOWN RD",
    "dropphycty": "MOUNT WASHINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 400479998,
    "dropmaladd": "645 N BARDSTOWN RD",
    "dropmalcty": "MOUNT WASHINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 400479998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025386314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15861",
    "droptype": "D",
    "dropname": "MOUSIE",
    "dropdeladd": "9479 HIGHWAY 550 E",
    "dropdelcty": "MOUSIE",
    "dropdelst": "KY",
    "dropdelzpp": 418399998,
    "dropphyadd": "9479 HIGHWAY 550 E",
    "dropphycty": "MOUSIE",
    "dropphyst": "KY",
    "dropphyzpp": 418399998,
    "dropmaladd": "9479 HIGHWAY 550 E",
    "dropmalcty": "MOUSIE",
    "dropmalst": "KY",
    "dropmalzpp": 418399998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6069462448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15862",
    "droptype": "D",
    "dropname": "MOUTHCARD",
    "dropdeladd": "23590 S LEVISA RD",
    "dropdelcty": "MOUTHCARD",
    "dropdelst": "KY",
    "dropdelzpp": 415489998,
    "dropphyadd": "23590 S LEVISA RD",
    "dropphycty": "MOUTHCARD",
    "dropphyst": "KY",
    "dropphyzpp": 415489998,
    "dropmaladd": "23590 S LEVISA RD",
    "dropmalcty": "MOUTHCARD",
    "dropmalst": "KY",
    "dropmalzpp": 415489998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6068354383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15871",
    "droptype": "D",
    "dropname": "MULDRAUGH",
    "dropdeladd": "114 S MAIN ST",
    "dropdelcty": "MULDRAUGH",
    "dropdelst": "KY",
    "dropdelzpp": 401559998,
    "dropphyadd": "114 S MAIN ST",
    "dropphycty": "MULDRAUGH",
    "dropphyst": "KY",
    "dropphyzpp": 401559998,
    "dropmaladd": "114 S MAIN ST",
    "dropmalcty": "MULDRAUGH",
    "dropmalst": "KY",
    "dropmalzpp": 401559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029422730,
    "dropfax": 5029426861
  },
  {
    "dcode": "D",
    "dropkey": "PX15872",
    "droptype": "D",
    "dropname": "MUNFORDVILLE",
    "dropdeladd": "215 S WASHINGTON ST",
    "dropdelcty": "MUNFORDVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427659998,
    "dropphyadd": "215 S WASHINGTON ST",
    "dropphycty": "MUNFORDVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427659998,
    "dropmaladd": "215 S WASHINGTON ST",
    "dropmalcty": "MUNFORDVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705245500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15874",
    "droptype": "D",
    "dropname": "MURRAY",
    "dropdeladd": "1105 CHESTNUT ST",
    "dropdelcty": "MURRAY",
    "dropdelst": "KY",
    "dropdelzpp": 420719998,
    "dropphyadd": "1105 CHESTNUT ST",
    "dropphycty": "MURRAY",
    "dropphyst": "KY",
    "dropphyzpp": 420719998,
    "dropmaladd": "1105 CHESTNUT ST",
    "dropmalcty": "MURRAY",
    "dropmalst": "KY",
    "dropmalzpp": 420719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707531512,
    "dropfax": 2707599045
  },
  {
    "dcode": "D",
    "dropkey": "PX15879",
    "droptype": "D",
    "dropname": "NANCY",
    "dropdeladd": "9150 W HIGHWAY 80",
    "dropdelcty": "NANCY",
    "dropdelst": "KY",
    "dropdelzpp": 425449998,
    "dropphyadd": "9150 W HIGHWAY 80",
    "dropphycty": "NANCY",
    "dropphyst": "KY",
    "dropphyzpp": 425449998,
    "dropmaladd": "9150 W HIGHWAY 80",
    "dropmalcty": "NANCY",
    "dropmalst": "KY",
    "dropmalzpp": 425449998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066366521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15885",
    "droptype": "D",
    "dropname": "NAZARETH",
    "dropdeladd": "85 VILLAGE DR",
    "dropdelcty": "NAZARETH",
    "dropdelst": "KY",
    "dropdelzpp": 400489998,
    "dropphyadd": "85 VILLAGE DR",
    "dropphycty": "NAZARETH",
    "dropphyst": "KY",
    "dropphyzpp": 400489998,
    "dropmaladd": "85 VILLAGE DR",
    "dropmalcty": "NAZARETH",
    "dropmalst": "KY",
    "dropmalzpp": 400489998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023483751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15893",
    "droptype": "D",
    "dropname": "NEON",
    "dropdeladd": "71 HIGHWAY 343",
    "dropdelcty": "NEON",
    "dropdelst": "KY",
    "dropdelzpp": 418409998,
    "dropphyadd": "71 HIGHWAY 343",
    "dropphycty": "NEON",
    "dropphyst": "KY",
    "dropphyzpp": 418409998,
    "dropmaladd": "71 HIGHWAY 343",
    "dropmalcty": "NEON",
    "dropmalst": "KY",
    "dropmalzpp": 418409998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6068550223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15896",
    "droptype": "D",
    "dropname": "NERINX",
    "dropdeladd": "515 NERINX RD",
    "dropdelcty": "NERINX",
    "dropdelst": "KY",
    "dropdelzpp": 400499998,
    "dropphyadd": "515 NERINX RD",
    "dropphycty": "NERINX",
    "dropphyst": "KY",
    "dropphyzpp": 400499998,
    "dropmaladd": "515 NERINX RD",
    "dropmalcty": "NERINX",
    "dropmalst": "KY",
    "dropmalzpp": 400499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708652067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15900",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "50 COURT ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "KY",
    "dropdelzpp": 400509998,
    "dropphyadd": "50 COURT ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "KY",
    "dropphyzpp": 400509998,
    "dropmaladd": "50 COURT ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "KY",
    "dropmalzpp": 400509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028452794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15901",
    "droptype": "D",
    "dropname": "NEW CONCORD",
    "dropdeladd": "10389 STATE ROUTE 121 S",
    "dropdelcty": "NEW CONCORD",
    "dropdelst": "KY",
    "dropdelzpp": 420769998,
    "dropphyadd": "10389 STATE ROUTE 121 S",
    "dropphycty": "NEW CONCORD",
    "dropphyst": "KY",
    "dropphyzpp": 420769998,
    "dropmaladd": "10389 STATE ROUTE 121 S",
    "dropmalcty": "NEW CONCORD",
    "dropmalst": "KY",
    "dropmalzpp": 420769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704365878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15903",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "304 CENTER ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "KY",
    "dropdelzpp": 400519998,
    "dropphyadd": "304 CENTER ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "KY",
    "dropphyzpp": 400519998,
    "dropmaladd": "304 CENTER ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "KY",
    "dropmalzpp": 400519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025498021,
    "dropfax": 5025499139
  },
  {
    "dcode": "D",
    "dropkey": "PX15904",
    "droptype": "D",
    "dropname": "NEW HOPE",
    "dropdeladd": "100 CHURCH ST",
    "dropdelcty": "NEW HOPE",
    "dropdelst": "KY",
    "dropdelzpp": 400529998,
    "dropphyadd": "100 CHURCH ST",
    "dropphycty": "NEW HOPE",
    "dropphyst": "KY",
    "dropphyzpp": 400529998,
    "dropmaladd": "100 CHURCH ST",
    "dropmalcty": "NEW HOPE",
    "dropmalst": "KY",
    "dropmalzpp": 400529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025498321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15905",
    "droptype": "D",
    "dropname": "NEW LIBERTY",
    "dropdeladd": "345 HIGHWAY 227 N",
    "dropdelcty": "NEW LIBERTY",
    "dropdelst": "KY",
    "dropdelzpp": 403559998,
    "dropphyadd": "345 HIGHWAY 227 N",
    "dropphycty": "NEW LIBERTY",
    "dropphyst": "KY",
    "dropphyzpp": 403559998,
    "dropmaladd": "345 HIGHWAY 227 N",
    "dropmalcty": "NEW LIBERTY",
    "dropmalst": "KY",
    "dropmalzpp": 403559998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 5024632615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15912",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "420 COLUMBIA ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "KY",
    "dropdelzpp": 410719998,
    "dropphyadd": "420 COLUMBIA ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "KY",
    "dropphyzpp": 410719998,
    "dropmaladd": "420 COLUMBIA ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "KY",
    "dropmalzpp": 410719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8592915251,
    "dropsitcph": 8592915251,
    "dropfax": 8592914934
  },
  {
    "dcode": "D",
    "dropkey": "PX15915",
    "droptype": "D",
    "dropname": "NICHOLASVILLE",
    "dropdeladd": "410 S MAIN ST",
    "dropdelcty": "NICHOLASVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 403569998,
    "dropphyadd": "410 S MAIN ST",
    "dropphycty": "NICHOLASVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 403569998,
    "dropmaladd": "410 S MAIN ST",
    "dropmalcty": "NICHOLASVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 403569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598875666,
    "dropfax": 8598851820
  },
  {
    "dcode": "D",
    "dropkey": "PX15931",
    "droptype": "D",
    "dropname": "NORTH MIDDLETOWN",
    "dropdeladd": "216 E MAIN ST",
    "dropdelcty": "NORTH MIDDLETOWN",
    "dropdelst": "KY",
    "dropdelzpp": 403579998,
    "dropphyadd": "216 E MAIN ST",
    "dropphycty": "NORTH MIDDLETOWN",
    "dropphyst": "KY",
    "dropphyzpp": 403579998,
    "dropmaladd": "216 E MAIN ST",
    "dropmalcty": "NORTH MIDDLETOWN",
    "dropmalst": "KY",
    "dropmalzpp": 403579998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8593624466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15934",
    "droptype": "D",
    "dropname": "NORTONVILLE",
    "dropdeladd": "39 E WALNUT ST",
    "dropdelcty": "NORTONVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 424429998,
    "dropphyadd": "39 E WALNUT ST",
    "dropphycty": "NORTONVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 424429998,
    "dropmaladd": "39 E WALNUT ST",
    "dropmalcty": "NORTONVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 424429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706763711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15942",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "15124 FORT CAMPBELL BLVD",
    "dropdelcty": "OAK GROVE",
    "dropdelst": "KY",
    "dropdelzpp": 422629998,
    "dropphyadd": "15124 FORT CAMPBELL BLVD",
    "dropphycty": "OAK GROVE",
    "dropphyst": "KY",
    "dropphyzpp": 422629998,
    "dropmaladd": "15124 FORT CAMPBELL BLVD",
    "dropmalcty": "OAK GROVE",
    "dropmalst": "KY",
    "dropmalzpp": 422629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704393014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15945",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "KY",
    "dropdelzpp": 421599998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "KY",
    "dropphyzpp": 421599998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "KY",
    "dropmalzpp": 421599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705632101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15952",
    "droptype": "D",
    "dropname": "OIL SPRINGS",
    "dropdeladd": "8895 KY ROUTE 40 W",
    "dropdelcty": "OIL SPRINGS",
    "dropdelst": "KY",
    "dropdelzpp": 412389998,
    "dropphyadd": "8895 KY ROUTE 40 W",
    "dropphycty": "OIL SPRINGS",
    "dropphyst": "KY",
    "dropphyzpp": 412389998,
    "dropmaladd": "8895 KY ROUTE 40 W",
    "dropmalcty": "OIL SPRINGS",
    "dropmalst": "KY",
    "dropmalzpp": 412389998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6062976747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15964",
    "droptype": "D",
    "dropname": "OLIVE HILL",
    "dropdeladd": "215 W TOM T HALL BLVD",
    "dropdelcty": "OLIVE HILL",
    "dropdelst": "KY",
    "dropdelzpp": 411649997,
    "dropphyadd": "215 W TOM T HALL BLVD",
    "dropphycty": "OLIVE HILL",
    "dropphyst": "KY",
    "dropphyzpp": 411649997,
    "dropmaladd": "215 W TOM T HALL BLVD",
    "dropmalcty": "OLIVE HILL",
    "dropmalst": "KY",
    "dropmalzpp": 411649997,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6062864242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15967",
    "droptype": "D",
    "dropname": "OLYMPIA",
    "dropdeladd": "5724 E HIGHWAY 36",
    "dropdelcty": "OLYMPIA",
    "dropdelst": "KY",
    "dropdelzpp": 403589998,
    "dropphyadd": "5724 E HIGHWAY 36",
    "dropphycty": "OLYMPIA",
    "dropphyst": "KY",
    "dropphyzpp": 403589998,
    "dropmaladd": "5724 E HIGHWAY 36",
    "dropmalcty": "OLYMPIA",
    "dropmalst": "KY",
    "dropmalzpp": 403589998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066746336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15969",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "14963 N HIGHWAY 66",
    "dropdelcty": "ONEIDA",
    "dropdelst": "KY",
    "dropdelzpp": 409729998,
    "dropphyadd": "14963 N HIGHWAY 66",
    "dropphycty": "ONEIDA",
    "dropphyst": "KY",
    "dropphyzpp": 409729998,
    "dropmaladd": "14963 N HIGHWAY 66",
    "dropmalcty": "ONEIDA",
    "dropmalst": "KY",
    "dropmalzpp": 409729998,
    "dropsitphn": 6068474221,
    "dropsitlph": 5024541725,
    "dropsitcph": 6068474221,
    "dropfax": 6068479521
  },
  {
    "dcode": "D",
    "dropkey": "PX15982",
    "droptype": "D",
    "dropname": "OWENSBORO",
    "dropdeladd": "54 BON HARBOR HLS",
    "dropdelcty": "OWENSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423019998,
    "dropphyadd": "54 BON HARBOR HLS",
    "dropphycty": "OWENSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423019998,
    "dropmaladd": "54 BON HARBOR HLS",
    "dropmalcty": "OWENSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706891838,
    "dropfax": 2706868895
  },
  {
    "dcode": "D",
    "dropkey": "PX15984",
    "droptype": "D",
    "dropname": "OWENTON",
    "dropdeladd": "1065 HIGHWAY 127 N",
    "dropdelcty": "OWENTON",
    "dropdelst": "KY",
    "dropdelzpp": 403599998,
    "dropphyadd": "1065 HIGHWAY 127 N",
    "dropphycty": "OWENTON",
    "dropphyst": "KY",
    "dropphyzpp": 403599998,
    "dropmaladd": "1065 HIGHWAY 127 N",
    "dropmalcty": "OWENTON",
    "dropmalst": "KY",
    "dropmalzpp": 403599998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 5024842745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15985",
    "droptype": "D",
    "dropname": "OWINGSVILLE",
    "dropdeladd": "95 E MAIN ST",
    "dropdelcty": "OWINGSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 403609998,
    "dropphyadd": "95 E MAIN ST",
    "dropphycty": "OWINGSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 403609998,
    "dropmaladd": "95 E MAIN ST",
    "dropmalcty": "OWINGSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 403609998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066742821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15988",
    "droptype": "D",
    "dropname": "PADUCAH",
    "dropdeladd": "300 S 4TH ST",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420039998,
    "dropphyadd": "300 S 4TH ST",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420039998,
    "dropmaladd": "300 S 4TH ST",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704445348,
    "dropfax": 2704420154
  },
  {
    "dcode": "D",
    "dropkey": "PX15990",
    "droptype": "D",
    "dropname": "PAINT LICK",
    "dropdeladd": "11642 RICHMOND RD",
    "dropdelcty": "PAINT LICK",
    "dropdelst": "KY",
    "dropdelzpp": 404619998,
    "dropphyadd": "11642 RICHMOND RD",
    "dropphycty": "PAINT LICK",
    "dropphyst": "KY",
    "dropphyzpp": 404619998,
    "dropmaladd": "11642 RICHMOND RD",
    "dropmalcty": "PAINT LICK",
    "dropmalst": "KY",
    "dropmalzpp": 404619998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 8599252400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15991",
    "droptype": "D",
    "dropname": "PAINTSVILLE",
    "dropdeladd": "100 FEDERAL DR",
    "dropdelcty": "PAINTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 412409997,
    "dropphyadd": "100 FEDERAL DR",
    "dropphycty": "PAINTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 412409997,
    "dropmaladd": "100 FEDERAL DR",
    "dropmalcty": "PAINTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 412409997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067894266,
    "dropfax": 6067896857
  },
  {
    "dcode": "D",
    "dropkey": "PX15993",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "201 W 8TH ST STE 105",
    "dropdelcty": "PARIS",
    "dropdelst": "KY",
    "dropdelzpp": 403619998,
    "dropphyadd": "201 W 8TH ST STE 105",
    "dropphycty": "PARIS",
    "dropphyst": "KY",
    "dropphyzpp": 403619998,
    "dropmaladd": "201 W 8TH ST STE 105",
    "dropmalcty": "PARIS",
    "dropmalst": "KY",
    "dropmalzpp": 403619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8599874500,
    "dropfax": 8599874277
  },
  {
    "dcode": "D",
    "dropkey": "PX15995",
    "droptype": "D",
    "dropname": "PARK CITY",
    "dropdeladd": "24211 LOUISVILLE RD",
    "dropdelcty": "PARK CITY",
    "dropdelst": "KY",
    "dropdelzpp": 421609998,
    "dropphyadd": "24211 LOUISVILLE RD",
    "dropphycty": "PARK CITY",
    "dropphyst": "KY",
    "dropphyzpp": 421609998,
    "dropmaladd": "24211 LOUISVILLE RD",
    "dropmalcty": "PARK CITY",
    "dropmalst": "KY",
    "dropmalzpp": 421609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707498321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15997",
    "droptype": "D",
    "dropname": "PARKERS LAKE",
    "dropdeladd": "144 P P WALKER RD",
    "dropdelcty": "PARKERS LAKE",
    "dropdelst": "KY",
    "dropdelzpp": 426349998,
    "dropphyadd": "144 P P WALKER RD",
    "dropphycty": "PARKERS LAKE",
    "dropphyst": "KY",
    "dropphyzpp": 426349998,
    "dropmaladd": "144 P P WALKER RD",
    "dropmalcty": "PARKERS LAKE",
    "dropmalst": "KY",
    "dropmalzpp": 426349998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063762488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX15998",
    "droptype": "D",
    "dropname": "PARKSVILLE",
    "dropdeladd": "8355 LEBANON RD",
    "dropdelcty": "PARKSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404649998,
    "dropphyadd": "8355 LEBANON RD",
    "dropphycty": "PARKSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404649998,
    "dropmaladd": "8355 LEBANON RD",
    "dropmalcty": "PARKSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404649998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 8592360806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16001",
    "droptype": "D",
    "dropname": "PARTRIDGE",
    "dropdeladd": "469 HIGHWAY 3073",
    "dropdelcty": "PARTRIDGE",
    "dropdelst": "KY",
    "dropdelzpp": 408629998,
    "dropphyadd": "469 HIGHWAY 3073",
    "dropphycty": "PARTRIDGE",
    "dropphyst": "KY",
    "dropphyzpp": 408629998,
    "dropmaladd": "469 HIGHWAY 3073",
    "dropmalcty": "PARTRIDGE",
    "dropmalst": "KY",
    "dropmalzpp": 408629998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6065894630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16003",
    "droptype": "D",
    "dropname": "PATHFORK",
    "dropdeladd": "63 BUNCH ST",
    "dropdelcty": "PATHFORK",
    "dropdelst": "KY",
    "dropdelzpp": 408639998,
    "dropphyadd": "63 BUNCH ST",
    "dropphycty": "PATHFORK",
    "dropphyst": "KY",
    "dropphyzpp": 408639998,
    "dropmaladd": "63 BUNCH ST",
    "dropmalcty": "PATHFORK",
    "dropmalst": "KY",
    "dropmalzpp": 408639998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066642023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16008",
    "droptype": "D",
    "dropname": "PAYNEVILLE",
    "dropdeladd": "5335 PAYNEVILLE RD",
    "dropdelcty": "PAYNEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 401579998,
    "dropphyadd": "5335 PAYNEVILLE RD",
    "dropphycty": "PAYNEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 401579998,
    "dropmaladd": "5335 PAYNEVILLE RD",
    "dropmalcty": "PAYNEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 401579998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704964644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16020",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "KY",
    "dropdelzpp": 422669998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "PEMBROKE",
    "dropphyst": "KY",
    "dropphyzpp": 422669998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "KY",
    "dropmalzpp": 422669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704754448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16022",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "1025 PENDLETON RD",
    "dropdelcty": "PENDLETON",
    "dropdelst": "KY",
    "dropdelzpp": 400559998,
    "dropphyadd": "1025 PENDLETON RD",
    "dropphycty": "PENDLETON",
    "dropphyst": "KY",
    "dropphyzpp": 400559998,
    "dropmaladd": "1025 PENDLETON RD",
    "dropmalcty": "PENDLETON",
    "dropmalst": "KY",
    "dropmalzpp": 400559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5027435164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16026",
    "droptype": "D",
    "dropname": "PERRY PARK",
    "dropdeladd": "7020 SQUIRESVILLE RD",
    "dropdelcty": "PERRY PARK",
    "dropdelst": "KY",
    "dropdelzpp": 403639998,
    "dropphyadd": "7020 SQUIRESVILLE RD",
    "dropphycty": "PERRY PARK",
    "dropphyst": "KY",
    "dropphyzpp": 403639998,
    "dropmaladd": "7020 SQUIRESVILLE RD",
    "dropmalcty": "PERRY PARK",
    "dropmalst": "KY",
    "dropmalzpp": 403639998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 5024845194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16028",
    "droptype": "D",
    "dropname": "PERRYVILLE",
    "dropdeladd": "207 POLK ST",
    "dropdelcty": "PERRYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 404689998,
    "dropphyadd": "207 POLK ST",
    "dropphycty": "PERRYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 404689998,
    "dropmaladd": "207 POLK ST",
    "dropmalcty": "PERRYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 404689998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8593327567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16031",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "2978 1ST ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 410809998,
    "dropphyadd": "2978 1ST ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 410809998,
    "dropmaladd": "2978 1ST ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 410809998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8595867328,
    "dropsitcph": 8595867328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16037",
    "droptype": "D",
    "dropname": "PEWEE VALLEY",
    "dropdeladd": "313 LA GRANGE RD",
    "dropdelcty": "PEWEE VALLEY",
    "dropdelst": "KY",
    "dropdelzpp": 400569197,
    "dropphyadd": "313 LA GRANGE RD",
    "dropphycty": "PEWEE VALLEY",
    "dropphyst": "KY",
    "dropphyzpp": 400569197,
    "dropmaladd": "313 LA GRANGE RD",
    "dropmalcty": "PEWEE VALLEY",
    "dropmalst": "KY",
    "dropmalzpp": 400569197,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022411623,
    "dropfax": 5022416666
  },
  {
    "dcode": "D",
    "dropkey": "PX16039",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "2 W 2ND AVE FL 1",
    "dropdelcty": "WILLIAMSON",
    "dropdelst": "WV",
    "dropdelzpp": 256619998,
    "dropphyadd": "2 W 2ND AVE FL 1",
    "dropphycty": "WILLIAMSON",
    "dropphyst": "WV",
    "dropphyzpp": 256619998,
    "dropmaladd": "2 W 2ND AVE FL 1",
    "dropmalcty": "WILLIAMSON",
    "dropmalst": "WV",
    "dropmalzpp": 256619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042352240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16040",
    "droptype": "D",
    "dropname": "PHELPS",
    "dropdeladd": "37719 STATE HIGHWAY 194 E",
    "dropdelcty": "PHELPS",
    "dropdelst": "KY",
    "dropdelzpp": 415539998,
    "dropphyadd": "37719 STATE HIGHWAY 194 E",
    "dropphycty": "PHELPS",
    "dropphyst": "KY",
    "dropphyzpp": 415539998,
    "dropmaladd": "37719 STATE HIGHWAY 194 E",
    "dropmalcty": "PHELPS",
    "dropmalst": "KY",
    "dropmalzpp": 415539998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6064563513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16042",
    "droptype": "D",
    "dropname": "PHILPOT",
    "dropdeladd": "6028 STATE ROUTE 54",
    "dropdelcty": "PHILPOT",
    "dropdelst": "KY",
    "dropdelzpp": 423669998,
    "dropphyadd": "6028 STATE ROUTE 54",
    "dropphycty": "PHILPOT",
    "dropphyst": "KY",
    "dropphyzpp": 423669998,
    "dropmaladd": "6028 STATE ROUTE 54",
    "dropmalcty": "PHILPOT",
    "dropmalst": "KY",
    "dropmalzpp": 423669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707294301,
    "dropfax": 2707290596
  },
  {
    "dcode": "D",
    "dropkey": "PX16043",
    "droptype": "D",
    "dropname": "PHYLLIS",
    "dropdeladd": "16240 GRAPEVINE RD",
    "dropdelcty": "PHYLLIS",
    "dropdelst": "KY",
    "dropdelzpp": 415549998,
    "dropphyadd": "16240 GRAPEVINE RD",
    "dropphycty": "PHYLLIS",
    "dropphyst": "KY",
    "dropphyzpp": 415549998,
    "dropmaladd": "16240 GRAPEVINE RD",
    "dropmalcty": "PHYLLIS",
    "dropmalst": "KY",
    "dropmalzpp": 415549998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6068352612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16049",
    "droptype": "D",
    "dropname": "PIKEVILLE",
    "dropdeladd": "281 THOMPSON RD",
    "dropdelcty": "PIKEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 415019995,
    "dropphyadd": "281 THOMPSON RD",
    "dropphycty": "PIKEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 415019995,
    "dropmaladd": "281 THOMPSON RD",
    "dropmalcty": "PIKEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 415019995,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064322146,
    "dropfax": 6064323372
  },
  {
    "dcode": "D",
    "dropkey": "PX16050",
    "droptype": "D",
    "dropname": "PILGRIM",
    "dropdeladd": "75 EMILY CRK",
    "dropdelcty": "PILGRIM",
    "dropdelst": "KY",
    "dropdelzpp": 412509998,
    "dropphyadd": "75 EMILY CRK",
    "dropphycty": "PILGRIM",
    "dropphyst": "KY",
    "dropphyzpp": 412509998,
    "dropmaladd": "75 EMILY CRK",
    "dropmalcty": "PILGRIM",
    "dropmalst": "KY",
    "dropmalzpp": 412509998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063956464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16054",
    "droptype": "D",
    "dropname": "PINE KNOT",
    "dropdeladd": "625 E HIGHWAY 2792",
    "dropdelcty": "PINE KNOT",
    "dropdelst": "KY",
    "dropdelzpp": 426359998,
    "dropphyadd": "625 E HIGHWAY 2792",
    "dropphycty": "PINE KNOT",
    "dropphyst": "KY",
    "dropphyzpp": 426359998,
    "dropmaladd": "625 E HIGHWAY 2792",
    "dropmalcty": "PINE KNOT",
    "dropmalst": "KY",
    "dropmalzpp": 426359998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063543633,
    "dropfax": 6063544363
  },
  {
    "dcode": "D",
    "dropkey": "PX16057",
    "droptype": "D",
    "dropname": "PINE TOP",
    "dropdeladd": "3880 HIGHWAY 582",
    "dropdelcty": "PINE TOP",
    "dropdelst": "KY",
    "dropdelzpp": 418439998,
    "dropphyadd": "3880 HIGHWAY 582",
    "dropphycty": "PINE TOP",
    "dropphyst": "KY",
    "dropphyzpp": 418439998,
    "dropmaladd": "3880 HIGHWAY 582",
    "dropmalcty": "PINE TOP",
    "dropmalst": "KY",
    "dropmalzpp": 418439998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067855161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16059",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "111 S WALNUT ST",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 409779998,
    "dropphyadd": "111 S WALNUT ST",
    "dropphycty": "PINEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 409779998,
    "dropmaladd": "111 S WALNUT ST",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 409779998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063372650,
    "dropfax": 6505783895
  },
  {
    "dcode": "D",
    "dropkey": "PX16060",
    "droptype": "D",
    "dropname": "PINSONFORK",
    "dropdeladd": "3903 POND CREEK RD",
    "dropdelcty": "PINSONFORK",
    "dropdelst": "KY",
    "dropdelzpp": 415559998,
    "dropphyadd": "3903 POND CREEK RD",
    "dropphycty": "PINSONFORK",
    "dropphyst": "KY",
    "dropphyzpp": 415559998,
    "dropmaladd": "3903 POND CREEK RD",
    "dropmalcty": "PINSONFORK",
    "dropmalst": "KY",
    "dropmalzpp": 415559998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063539754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16064",
    "droptype": "D",
    "dropname": "PIPPA PASSES",
    "dropdeladd": "4982 HIGHWAY 899",
    "dropdelcty": "PIPPA PASSES",
    "dropdelst": "KY",
    "dropdelzpp": 418449998,
    "dropphyadd": "4982 HIGHWAY 899",
    "dropphycty": "PIPPA PASSES",
    "dropphyst": "KY",
    "dropphyzpp": 418449998,
    "dropmaladd": "4982 HIGHWAY 899",
    "dropmalcty": "PIPPA PASSES",
    "dropmalst": "KY",
    "dropmalzpp": 418449998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063683901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16067",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "741 N LAUREL RD",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 407559998,
    "dropphyadd": "741 N LAUREL RD",
    "dropphycty": "PITTSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 407559998,
    "dropmaladd": "741 N LAUREL RD",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 407559998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6068647265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16076",
    "droptype": "D",
    "dropname": "PLEASUREVILLE",
    "dropdeladd": "1009 MAIN ST",
    "dropdelcty": "PLEASUREVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400579998,
    "dropphyadd": "1009 MAIN ST",
    "dropphycty": "PLEASUREVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400579998,
    "dropmaladd": "1009 MAIN ST",
    "dropmalcty": "PLEASUREVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400579998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028784801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16088",
    "droptype": "D",
    "dropname": "POOLE",
    "dropdeladd": "9599 US HIGHWAY 41A N",
    "dropdelcty": "POOLE",
    "dropdelst": "KY",
    "dropdelzpp": 424449998,
    "dropphyadd": "9599 US HIGHWAY 41A N",
    "dropphycty": "POOLE",
    "dropphyst": "KY",
    "dropphyzpp": 424449998,
    "dropmaladd": "9599 US HIGHWAY 41A N",
    "dropmalcty": "POOLE",
    "dropmalst": "KY",
    "dropmalzpp": 424449998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706395611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16093",
    "droptype": "D",
    "dropname": "PORT ROYAL",
    "dropdeladd": "8240 PORT ROYAL RD",
    "dropdelcty": "PORT ROYAL",
    "dropdelst": "KY",
    "dropdelzpp": 400589998,
    "dropphyadd": "8240 PORT ROYAL RD",
    "dropphycty": "PORT ROYAL",
    "dropphyst": "KY",
    "dropphyzpp": 400589998,
    "dropmaladd": "8240 PORT ROYAL RD",
    "dropmalcty": "PORT ROYAL",
    "dropmalst": "KY",
    "dropmalzpp": 400589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029475335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16099",
    "droptype": "D",
    "dropname": "POWDERLY",
    "dropdeladd": "123 COPPER CREEK DR",
    "dropdelcty": "POWDERLY",
    "dropdelst": "KY",
    "dropdelzpp": 423679998,
    "dropphyadd": "123 COPPER CREEK DR",
    "dropphycty": "POWDERLY",
    "dropphyst": "KY",
    "dropphyzpp": 423679998,
    "dropmaladd": "123 COPPER CREEK DR",
    "dropmalcty": "POWDERLY",
    "dropmalst": "KY",
    "dropmalzpp": 423679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703384831,
    "dropfax": 2703380951
  },
  {
    "dcode": "D",
    "dropkey": "PX16104",
    "droptype": "D",
    "dropname": "PREMIUM",
    "dropdeladd": "3752 HIGHWAY 160",
    "dropdelcty": "PREMIUM",
    "dropdelst": "KY",
    "dropdelzpp": 418459998,
    "dropphyadd": "3752 HIGHWAY 160",
    "dropphycty": "PREMIUM",
    "dropphyst": "KY",
    "dropphyzpp": 418459998,
    "dropmaladd": "3752 HIGHWAY 160",
    "dropmalcty": "PREMIUM",
    "dropmalst": "KY",
    "dropmalzpp": 418459998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066331292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16107",
    "droptype": "D",
    "dropname": "PRESTONSBURG",
    "dropdeladd": "119 FRANKLIN COR",
    "dropdelcty": "PRESTONSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 416539998,
    "dropphyadd": "119 FRANKLIN COR",
    "dropphycty": "PRESTONSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 416539998,
    "dropmaladd": "119 FRANKLIN COR",
    "dropmalcty": "PRESTONSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 416539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068863080,
    "dropfax": 6068862287
  },
  {
    "dcode": "D",
    "dropkey": "PX16117",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "201 W WASHINGTON ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "KY",
    "dropdelzpp": 424459998,
    "dropphyadd": "201 W WASHINGTON ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "KY",
    "dropphyzpp": 424459998,
    "dropmaladd": "201 W WASHINGTON ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "KY",
    "dropmalzpp": 424459998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703656805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16118",
    "droptype": "D",
    "dropname": "PRINTER",
    "dropdeladd": "2928 KY ROUTE 122 STE 2",
    "dropdelcty": "PRINTER",
    "dropdelst": "KY",
    "dropdelzpp": 416559998,
    "dropphyadd": "2928 KY ROUTE 122 STE 2",
    "dropphycty": "PRINTER",
    "dropphyst": "KY",
    "dropphyzpp": 416559998,
    "dropmaladd": "2928 KY ROUTE 122 STE 2",
    "dropmalcty": "PRINTER",
    "dropmalst": "KY",
    "dropmalzpp": 416559998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6062859691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16120",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "9523 US HIGHWAY 42",
    "dropdelcty": "PROSPECT",
    "dropdelst": "KY",
    "dropdelzpp": 400599998,
    "dropphyadd": "9523 US HIGHWAY 42",
    "dropphycty": "PROSPECT",
    "dropphyst": "KY",
    "dropphyzpp": 400599998,
    "dropmaladd": "9523 US HIGHWAY 42",
    "dropmalcty": "PROSPECT",
    "dropmalst": "KY",
    "dropmalzpp": 400599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022281921,
    "dropfax": 5022286853
  },
  {
    "dcode": "D",
    "dropkey": "PX16123",
    "droptype": "D",
    "dropname": "PROVIDENCE",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "KY",
    "dropdelzpp": 424509998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "KY",
    "dropphyzpp": 424509998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "KY",
    "dropmalzpp": 424509998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706675105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16131",
    "droptype": "D",
    "dropname": "PUTNEY",
    "dropdeladd": "4416 HIGHWAY 522",
    "dropdelcty": "PUTNEY",
    "dropdelst": "KY",
    "dropdelzpp": 408659998,
    "dropphyadd": "4416 HIGHWAY 522",
    "dropphycty": "PUTNEY",
    "dropphyst": "KY",
    "dropphyzpp": 408659998,
    "dropmaladd": "4416 HIGHWAY 522",
    "dropmalcty": "PUTNEY",
    "dropmalst": "KY",
    "dropmalzpp": 408659998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6065734003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16137",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "11977 E KY 8",
    "dropdelcty": "QUINCY",
    "dropdelst": "KY",
    "dropdelzpp": 411669998,
    "dropphyadd": "11977 E KY 8",
    "dropphycty": "QUINCY",
    "dropphyst": "KY",
    "dropphyzpp": 411669998,
    "dropmaladd": "11977 E KY 8",
    "dropmalcty": "QUINCY",
    "dropmalst": "KY",
    "dropmalzpp": 411669998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067574875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16140",
    "droptype": "D",
    "dropname": "RACCOON",
    "dropdeladd": "68 GRASSY BR",
    "dropdelcty": "RACCOON",
    "dropdelst": "KY",
    "dropdelzpp": 415579998,
    "dropphyadd": "68 GRASSY BR",
    "dropphycty": "RACCOON",
    "dropphyst": "KY",
    "dropphyzpp": 415579998,
    "dropmaladd": "68 GRASSY BR",
    "dropmalcty": "RACCOON",
    "dropmalst": "KY",
    "dropmalzpp": 415579998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6064376039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16142",
    "droptype": "D",
    "dropname": "RADCLIFF",
    "dropdeladd": "590 W LINCOLN TRAIL BLVD",
    "dropdelcty": "RADCLIFF",
    "dropdelst": "KY",
    "dropdelzpp": 401609998,
    "dropphyadd": "590 W LINCOLN TRAIL BLVD",
    "dropphycty": "RADCLIFF",
    "dropphyst": "KY",
    "dropphyzpp": 401609998,
    "dropmaladd": "590 W LINCOLN TRAIL BLVD",
    "dropmalcty": "RADCLIFF",
    "dropmalst": "KY",
    "dropmalzpp": 401609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703513688,
    "dropfax": 2703519914
  },
  {
    "dcode": "D",
    "dropkey": "PX16151",
    "droptype": "D",
    "dropname": "RAYWICK",
    "dropdeladd": "5805 RAYWICK RD",
    "dropdelcty": "RAYWICK",
    "dropdelst": "KY",
    "dropdelzpp": 400609998,
    "dropphyadd": "5805 RAYWICK RD",
    "dropphycty": "RAYWICK",
    "dropphyst": "KY",
    "dropphyzpp": 400609998,
    "dropmaladd": "5805 RAYWICK RD",
    "dropmalcty": "RAYWICK",
    "dropmalst": "KY",
    "dropmalzpp": 400609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706929485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16160",
    "droptype": "D",
    "dropname": "REDFOX",
    "dropdeladd": "1915 REDFOX RD",
    "dropdelcty": "REDFOX",
    "dropdelst": "KY",
    "dropdelzpp": 418479998,
    "dropphyadd": "1915 REDFOX RD",
    "dropphycty": "REDFOX",
    "dropphyst": "KY",
    "dropphyzpp": 418479998,
    "dropmaladd": "1915 REDFOX RD",
    "dropmalcty": "REDFOX",
    "dropmalst": "KY",
    "dropmalzpp": 418479998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066423516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16163",
    "droptype": "D",
    "dropname": "REED",
    "dropdeladd": "16110 US HIGHWAY 60 E",
    "dropdelcty": "REED",
    "dropdelst": "KY",
    "dropdelzpp": 424519998,
    "dropphyadd": "16110 US HIGHWAY 60 E",
    "dropphycty": "REED",
    "dropphyst": "KY",
    "dropphyzpp": 424519998,
    "dropmaladd": "16110 US HIGHWAY 60 E",
    "dropmalcty": "REED",
    "dropmalst": "KY",
    "dropmalzpp": 424519998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707641077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16166",
    "droptype": "D",
    "dropname": "REGINA",
    "dropdeladd": "10051 REGINA BELCHER HWY",
    "dropdelcty": "REGINA",
    "dropdelst": "KY",
    "dropdelzpp": 415599998,
    "dropphyadd": "10051 REGINA BELCHER HWY",
    "dropphycty": "REGINA",
    "dropphyst": "KY",
    "dropphyzpp": 415599998,
    "dropmaladd": "10051 REGINA BELCHER HWY",
    "dropmalcty": "REGINA",
    "dropmalst": "KY",
    "dropmalzpp": 415599998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067549624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16175",
    "droptype": "D",
    "dropname": "REVELO",
    "dropdeladd": "3715 S HIGHWAY 1651",
    "dropdelcty": "REVELO",
    "dropdelst": "KY",
    "dropdelzpp": 426389998,
    "dropphyadd": "3715 S HIGHWAY 1651",
    "dropphycty": "REVELO",
    "dropphyst": "KY",
    "dropphyzpp": 426389998,
    "dropmaladd": "3715 S HIGHWAY 1651",
    "dropmalcty": "REVELO",
    "dropmalst": "KY",
    "dropmalzpp": 426389998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063762961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16180",
    "droptype": "D",
    "dropname": "RHODELIA",
    "dropdeladd": "11195 RHODELIA RD",
    "dropdelcty": "RHODELIA",
    "dropdelst": "KY",
    "dropdelzpp": 401619998,
    "dropphyadd": "11195 RHODELIA RD",
    "dropphycty": "RHODELIA",
    "dropphyst": "KY",
    "dropphyzpp": 401619998,
    "dropmaladd": "11195 RHODELIA RD",
    "dropmalcty": "RHODELIA",
    "dropmalst": "KY",
    "dropmalzpp": 401619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704964315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16190",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "140 N MADISON AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "KY",
    "dropdelzpp": 404759998,
    "dropphyadd": "140 N MADISON AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "KY",
    "dropphyzpp": 404759998,
    "dropmaladd": "140 N MADISON AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "KY",
    "dropmalzpp": 404759998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8596235449,
    "dropfax": 8596250453
  },
  {
    "dcode": "D",
    "dropkey": "PX16192",
    "droptype": "D",
    "dropname": "RINEYVILLE",
    "dropdeladd": "6127 RINEYVILLE RD",
    "dropdelcty": "RINEYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 401629998,
    "dropphyadd": "6127 RINEYVILLE RD",
    "dropphycty": "RINEYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 401629998,
    "dropmaladd": "6127 RINEYVILLE RD",
    "dropmalcty": "RINEYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 401629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707374500,
    "dropfax": 2707661960
  },
  {
    "dcode": "D",
    "dropkey": "PX16208",
    "droptype": "D",
    "dropname": "ROARK",
    "dropdeladd": "13060 HIGHWAY 406",
    "dropdelcty": "ROARK",
    "dropdelst": "KY",
    "dropdelzpp": 409799998,
    "dropphyadd": "13060 HIGHWAY 406",
    "dropphycty": "ROARK",
    "dropphyst": "KY",
    "dropphyzpp": 409799998,
    "dropmaladd": "13060 HIGHWAY 406",
    "dropmalcty": "ROARK",
    "dropmalst": "KY",
    "dropmalzpp": 409799998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6063743025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16209",
    "droptype": "D",
    "dropname": "ROBARDS",
    "dropdeladd": "1204 E RAILROAD ST",
    "dropdelcty": "ROBARDS",
    "dropdelst": "KY",
    "dropdelzpp": 424529998,
    "dropphyadd": "1204 E RAILROAD ST",
    "dropphycty": "ROBARDS",
    "dropphyst": "KY",
    "dropphyzpp": 424529998,
    "dropmaladd": "1204 E RAILROAD ST",
    "dropmalcty": "ROBARDS",
    "dropmalst": "KY",
    "dropmalzpp": 424529998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705217504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16211",
    "droptype": "D",
    "dropname": "ROBINSON CREEK",
    "dropdeladd": "6500 ROBINSON CREEK RD",
    "dropdelcty": "ROBINSON CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 415609998,
    "dropphyadd": "6500 ROBINSON CREEK RD",
    "dropphycty": "ROBINSON CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 415609998,
    "dropmaladd": "6500 ROBINSON CREEK RD",
    "dropmalcty": "ROBINSON CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 415609998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066399073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16212",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "KY",
    "dropdelzpp": 422739998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "KY",
    "dropphyzpp": 422739998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "KY",
    "dropmalzpp": 422739998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709348221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16217",
    "droptype": "D",
    "dropname": "ROCKFIELD",
    "dropdeladd": "135 RICHPOND ROCKFIELD RD",
    "dropdelcty": "ROCKFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 422749998,
    "dropphyadd": "135 RICHPOND ROCKFIELD RD",
    "dropphycty": "ROCKFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 422749998,
    "dropmaladd": "135 RICHPOND ROCKFIELD RD",
    "dropmalcty": "ROCKFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 422749998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707823994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16218",
    "droptype": "D",
    "dropname": "ROCKHOLDS",
    "dropdeladd": "31 TYES FERRY RD",
    "dropdelcty": "ROCKHOLDS",
    "dropdelst": "KY",
    "dropdelzpp": 407599998,
    "dropphyadd": "31 TYES FERRY RD",
    "dropphycty": "ROCKHOLDS",
    "dropphyst": "KY",
    "dropphyzpp": 407599998,
    "dropmaladd": "31 TYES FERRY RD",
    "dropmalcty": "ROCKHOLDS",
    "dropmalst": "KY",
    "dropmalzpp": 407599998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6065495876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16219",
    "droptype": "D",
    "dropname": "ROCKHOUSE",
    "dropdeladd": "4535 MARROWBONE CREEK RD",
    "dropdelcty": "ROCKHOUSE",
    "dropdelst": "KY",
    "dropdelzpp": 415619998,
    "dropphyadd": "4535 MARROWBONE CREEK RD",
    "dropphycty": "ROCKHOUSE",
    "dropphyst": "KY",
    "dropphyzpp": 415619998,
    "dropmaladd": "4535 MARROWBONE CREEK RD",
    "dropmalcty": "ROCKHOUSE",
    "dropmalst": "KY",
    "dropmalzpp": 415619998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6067547551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16221",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "KY",
    "dropdelzpp": 423699998,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "ROCKPORT",
    "dropphyst": "KY",
    "dropphyzpp": 423699998,
    "dropmaladd": "12 MAIN ST",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "KY",
    "dropmalzpp": 423699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702747792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16224",
    "droptype": "D",
    "dropname": "ROCKY HILL",
    "dropdeladd": "1793 ROCKY HILL RD",
    "dropdelcty": "ROCKY HILL",
    "dropdelst": "KY",
    "dropdelzpp": 421639998,
    "dropphyadd": "1793 ROCKY HILL RD",
    "dropphycty": "ROCKY HILL",
    "dropphyst": "KY",
    "dropphyzpp": 421639998,
    "dropmaladd": "1793 ROCKY HILL RD",
    "dropmalcty": "ROCKY HILL",
    "dropmalst": "KY",
    "dropmalzpp": 421639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707493213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16227",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "1660 KY 715",
    "dropdelcty": "ROGERS",
    "dropdelst": "KY",
    "dropdelzpp": 413659998,
    "dropphyadd": "1660 KY 715",
    "dropphycty": "ROGERS",
    "dropphyst": "KY",
    "dropphyzpp": 413659998,
    "dropmaladd": "1660 KY 715",
    "dropmalcty": "ROGERS",
    "dropmalst": "KY",
    "dropmalzpp": 413659998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066686256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16232",
    "droptype": "D",
    "dropname": "ROSINE",
    "dropdeladd": "25 MCHENRY ST",
    "dropdelcty": "ROSINE",
    "dropdelst": "KY",
    "dropdelzpp": 423709998,
    "dropphyadd": "25 MCHENRY ST",
    "dropphycty": "ROSINE",
    "dropphyst": "KY",
    "dropphyzpp": 423709998,
    "dropmaladd": "25 MCHENRY ST",
    "dropmalcty": "ROSINE",
    "dropmalst": "KY",
    "dropmalzpp": 423709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702749375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16245",
    "droptype": "D",
    "dropname": "ROXANA",
    "dropdeladd": "4115 HIGHWAY 2036",
    "dropdelcty": "ROXANA",
    "dropdelst": "KY",
    "dropdelzpp": 418489998,
    "dropphyadd": "4115 HIGHWAY 2036",
    "dropphycty": "ROXANA",
    "dropphyst": "KY",
    "dropphyzpp": 418489998,
    "dropmaladd": "4115 HIGHWAY 2036",
    "dropmalcty": "ROXANA",
    "dropmalst": "KY",
    "dropmalzpp": 418489998,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6066330371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16250",
    "droptype": "D",
    "dropname": "RUSH",
    "dropdeladd": "15100 STATE ROUTE 854",
    "dropdelcty": "RUSH",
    "dropdelst": "KY",
    "dropdelzpp": 411689996,
    "dropphyadd": "15100 STATE ROUTE 854",
    "dropphycty": "RUSH",
    "dropphyst": "KY",
    "dropphyzpp": 411689996,
    "dropmaladd": "15100 STATE ROUTE 854",
    "dropmalcty": "RUSH",
    "dropmalst": "KY",
    "dropmalzpp": 411689996,
    "dropsitphn": 5024541725,
    "dropsitlph": 5024541725,
    "dropsitcph": 6069284531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16251",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "517 BOYD ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "KY",
    "dropdelzpp": 411699998,
    "dropphyadd": "517 BOYD ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "KY",
    "dropphyzpp": 411699998,
    "dropmaladd": "517 BOYD ST",
    "dropmalcty": "RUSSELL",
    "dropmalst": "KY",
    "dropmalzpp": 411699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068363155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16252",
    "droptype": "D",
    "dropname": "RUSSELL SPRINGS",
    "dropdeladd": "414 MAIN ST",
    "dropdelcty": "RUSSELL SPRINGS",
    "dropdelst": "KY",
    "dropdelzpp": 426429998,
    "dropphyadd": "414 MAIN ST",
    "dropphycty": "RUSSELL SPRINGS",
    "dropphyst": "KY",
    "dropphyzpp": 426429998,
    "dropmaladd": "414 MAIN ST",
    "dropmalcty": "RUSSELL SPRINGS",
    "dropmalst": "KY",
    "dropmalzpp": 426429998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708665527,
    "dropfax": 2708665526
  },
  {
    "dcode": "D",
    "dropkey": "PX16253",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "205 W 4TH ST",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 422769998,
    "dropphyadd": "205 W 4TH ST",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 422769998,
    "dropmaladd": "205 W 4TH ST",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 422769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707266335,
    "dropfax": 2707266335
  },
  {
    "dcode": "D",
    "dropkey": "PX16266",
    "droptype": "D",
    "dropname": "SACRAMENTO",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "KY",
    "dropdelzpp": 423729998,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "KY",
    "dropphyzpp": 423729998,
    "dropmaladd": "315 MAIN ST",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "KY",
    "dropmalzpp": 423729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707365281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16267",
    "droptype": "D",
    "dropname": "SADIEVILLE",
    "dropdeladd": "131 MAIN ST",
    "dropdelcty": "SADIEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 403709998,
    "dropphyadd": "131 MAIN ST",
    "dropphycty": "SADIEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 403709998,
    "dropmaladd": "131 MAIN ST",
    "dropmalcty": "SADIEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 403709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028572129,
    "dropfax": 5028572729
  },
  {
    "dcode": "D",
    "dropkey": "PX16269",
    "droptype": "D",
    "dropname": "SAINT CATHARINE",
    "dropdeladd": "2645 BARDSTOWN RD",
    "dropdelcty": "SAINT CATHARINE",
    "dropdelst": "KY",
    "dropdelzpp": 400619998,
    "dropphyadd": "2645 BARDSTOWN RD",
    "dropphycty": "SAINT CATHARINE",
    "dropphyst": "KY",
    "dropphyzpp": 400619998,
    "dropmaladd": "2645 BARDSTOWN RD",
    "dropmalcty": "SAINT CATHARINE",
    "dropmalst": "KY",
    "dropmalzpp": 400619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592845572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16270",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "6205 NORTONVILLE RD",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "KY",
    "dropdelzpp": 424539998,
    "dropphyadd": "6205 NORTONVILLE RD",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "KY",
    "dropphyzpp": 424539998,
    "dropmaladd": "6205 NORTONVILLE RD",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "KY",
    "dropmalzpp": 424539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706602009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16272",
    "droptype": "D",
    "dropname": "SAINT HELENS",
    "dropdeladd": "92 HIGHWAY 2016",
    "dropdelcty": "SAINT HELENS",
    "dropdelst": "KY",
    "dropdelzpp": 413689998,
    "dropphyadd": "92 HIGHWAY 2016",
    "dropphycty": "SAINT HELENS",
    "dropphyst": "KY",
    "dropphyzpp": 413689998,
    "dropmaladd": "92 HIGHWAY 2016",
    "dropmalcty": "SAINT HELENS",
    "dropmalst": "KY",
    "dropmalzpp": 413689998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064640590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16275",
    "droptype": "D",
    "dropname": "SAINT MARY",
    "dropdeladd": "3880 SAINT MARY RD",
    "dropdelcty": "SAINT MARY",
    "dropdelst": "KY",
    "dropdelzpp": 400639998,
    "dropphyadd": "3880 SAINT MARY RD",
    "dropphycty": "SAINT MARY",
    "dropphyst": "KY",
    "dropphyzpp": 400639998,
    "dropmaladd": "3880 SAINT MARY RD",
    "dropmalcty": "SAINT MARY",
    "dropmalst": "KY",
    "dropmalzpp": 400639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706924890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16280",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "155 E MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "KY",
    "dropdelzpp": 420789998,
    "dropphyadd": "155 E MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "KY",
    "dropphyzpp": 420789998,
    "dropmaladd": "155 E MAIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "KY",
    "dropmalzpp": 420789998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709882800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16283",
    "droptype": "D",
    "dropname": "SALT LICK",
    "dropdeladd": "91 MAIN ST",
    "dropdelcty": "SALT LICK",
    "dropdelst": "KY",
    "dropdelzpp": 403719998,
    "dropphyadd": "91 MAIN ST",
    "dropphycty": "SALT LICK",
    "dropphyst": "KY",
    "dropphyzpp": 403719998,
    "dropmaladd": "91 MAIN ST",
    "dropmalcty": "SALT LICK",
    "dropmalst": "KY",
    "dropmalzpp": 403719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066832241,
    "dropfax": 6066833006
  },
  {
    "dcode": "D",
    "dropkey": "PX16284",
    "droptype": "D",
    "dropname": "SALVISA",
    "dropdeladd": "355 MAIN ST",
    "dropdelcty": "SALVISA",
    "dropdelst": "KY",
    "dropdelzpp": 403729998,
    "dropphyadd": "355 MAIN ST",
    "dropphycty": "SALVISA",
    "dropphyst": "KY",
    "dropphyzpp": 403729998,
    "dropmaladd": "355 MAIN ST",
    "dropmalcty": "SALVISA",
    "dropmalst": "KY",
    "dropmalzpp": 403729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598652524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16285",
    "droptype": "D",
    "dropname": "SALYERSVILLE",
    "dropdeladd": "330 E MAPLE ST",
    "dropdelcty": "SALYERSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 414659998,
    "dropphyadd": "330 E MAPLE ST",
    "dropphycty": "SALYERSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 414659998,
    "dropmaladd": "330 E MAPLE ST",
    "dropmalcty": "SALYERSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 414659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063493400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16290",
    "droptype": "D",
    "dropname": "SANDERS",
    "dropdeladd": "14150 KY HIGHWAY 36 E",
    "dropdelcty": "SANDERS",
    "dropdelst": "KY",
    "dropdelzpp": 410839998,
    "dropphyadd": "14150 KY HIGHWAY 36 E",
    "dropphycty": "SANDERS",
    "dropphyst": "KY",
    "dropphyzpp": 410839998,
    "dropmaladd": "14150 KY HIGHWAY 36 E",
    "dropmalcty": "SANDERS",
    "dropmalst": "KY",
    "dropmalzpp": 410839998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5023475614,
    "dropsitcph": 5023475614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16291",
    "droptype": "D",
    "dropname": "SANDGAP",
    "dropdeladd": "955 US HIGHWAY 421 N",
    "dropdelcty": "SANDGAP",
    "dropdelst": "KY",
    "dropdelzpp": 404819998,
    "dropphyadd": "955 US HIGHWAY 421 N",
    "dropphycty": "SANDGAP",
    "dropphyst": "KY",
    "dropphyzpp": 404819998,
    "dropmaladd": "955 US HIGHWAY 421 N",
    "dropmalcty": "SANDGAP",
    "dropmalst": "KY",
    "dropmalzpp": 404819998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6069653271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16293",
    "droptype": "D",
    "dropname": "SANDY HOOK",
    "dropdeladd": "200 S KY 7",
    "dropdelcty": "SANDY HOOK",
    "dropdelst": "KY",
    "dropdelzpp": 411719997,
    "dropphyadd": "200 S KY 7",
    "dropphycty": "SANDY HOOK",
    "dropphyst": "KY",
    "dropphyzpp": 411719997,
    "dropmaladd": "200 S KY 7",
    "dropmalcty": "SANDY HOOK",
    "dropmalst": "KY",
    "dropmalzpp": 411719997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067386501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16297",
    "droptype": "D",
    "dropname": "SASSAFRAS",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "SASSAFRAS",
    "dropdelst": "KY",
    "dropdelzpp": 417599998,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "SASSAFRAS",
    "dropphyst": "KY",
    "dropphyzpp": 417599998,
    "dropmaladd": "315 MAIN ST",
    "dropmalcty": "SASSAFRAS",
    "dropmalst": "KY",
    "dropmalzpp": 417599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064768713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16305",
    "droptype": "D",
    "dropname": "SCALF",
    "dropdeladd": "15581 KY 223",
    "dropdelcty": "SCALF",
    "dropdelst": "KY",
    "dropdelzpp": 409829998,
    "dropphyadd": "15581 KY 223",
    "dropphycty": "SCALF",
    "dropphyst": "KY",
    "dropphyzpp": 409829998,
    "dropmaladd": "15581 KY 223",
    "dropmalcty": "SCALF",
    "dropmalst": "KY",
    "dropmalzpp": 409829998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065425442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16308",
    "droptype": "D",
    "dropname": "SCIENCE HILL",
    "dropdeladd": "735 CENTRAL AVE",
    "dropdelcty": "SCIENCE HILL",
    "dropdelst": "KY",
    "dropdelzpp": 425539998,
    "dropphyadd": "735 CENTRAL AVE",
    "dropphycty": "SCIENCE HILL",
    "dropphyst": "KY",
    "dropphyzpp": 425539998,
    "dropmaladd": "735 CENTRAL AVE",
    "dropmalcty": "SCIENCE HILL",
    "dropmalst": "KY",
    "dropmalzpp": 425539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064233366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16310",
    "droptype": "D",
    "dropname": "SCOTTSVILLE",
    "dropdeladd": "405 E MAIN ST",
    "dropdelcty": "SCOTTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 421649998,
    "dropphyadd": "405 E MAIN ST",
    "dropphycty": "SCOTTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 421649998,
    "dropmaladd": "405 E MAIN ST",
    "dropmalcty": "SCOTTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 421649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702374056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16315",
    "droptype": "D",
    "dropname": "SEBREE",
    "dropdeladd": "32 WATKINS SEBREE RD",
    "dropdelcty": "SEBREE",
    "dropdelst": "KY",
    "dropdelzpp": 424559998,
    "dropphyadd": "32 WATKINS SEBREE RD",
    "dropphycty": "SEBREE",
    "dropphyst": "KY",
    "dropphyzpp": 424559998,
    "dropmaladd": "32 WATKINS SEBREE RD",
    "dropmalcty": "SEBREE",
    "dropmalst": "KY",
    "dropmalzpp": 424559998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708352383,
    "dropfax": 2708357663
  },
  {
    "dcode": "D",
    "dropkey": "PX16316",
    "droptype": "D",
    "dropname": "SECO",
    "dropdeladd": "131 SECO DR",
    "dropdelcty": "SECO",
    "dropdelst": "KY",
    "dropdelzpp": 418499998,
    "dropphyadd": "131 SECO DR",
    "dropphycty": "SECO",
    "dropphyst": "KY",
    "dropphyzpp": 418499998,
    "dropmaladd": "131 SECO DR",
    "dropmalcty": "SECO",
    "dropmalst": "KY",
    "dropmalzpp": 418499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064394447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16317",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "1549 STATE ROUTE 339 E",
    "dropdelcty": "SEDALIA",
    "dropdelst": "KY",
    "dropdelzpp": 420799998,
    "dropphyadd": "1549 STATE ROUTE 339 E",
    "dropphycty": "SEDALIA",
    "dropphyst": "KY",
    "dropphyzpp": 420799998,
    "dropmaladd": "1549 STATE ROUTE 339 E",
    "dropmalcty": "SEDALIA",
    "dropmalst": "KY",
    "dropmalzpp": 420799998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703300021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16328",
    "droptype": "D",
    "dropname": "SEXTONS CREEK",
    "dropdeladd": "4067 HIGHWAY 1350",
    "dropdelcty": "SEXTONS CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 409839998,
    "dropphyadd": "4067 HIGHWAY 1350",
    "dropphycty": "SEXTONS CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 409839998,
    "dropmaladd": "4067 HIGHWAY 1350",
    "dropmalcty": "SEXTONS CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 409839998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065990217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16342",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "581 MAIN ST",
    "dropdelcty": "SHARPSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 403749998,
    "dropphyadd": "581 MAIN ST",
    "dropphycty": "SHARPSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 403749998,
    "dropmaladd": "581 MAIN ST",
    "dropmalcty": "SHARPSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 403749998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062473011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16345",
    "droptype": "D",
    "dropname": "SHELBIANA",
    "dropdeladd": "147 LONGVIEW DR",
    "dropdelcty": "SHELBIANA",
    "dropdelst": "KY",
    "dropdelzpp": 415629998,
    "dropphyadd": "147 LONGVIEW DR",
    "dropphycty": "SHELBIANA",
    "dropphyst": "KY",
    "dropphyzpp": 415629998,
    "dropmaladd": "147 LONGVIEW DR",
    "dropmalcty": "SHELBIANA",
    "dropmalst": "KY",
    "dropmalzpp": 415629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064321756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16348",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "401 4TH ST",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400659998,
    "dropphyadd": "401 4TH ST",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400659998,
    "dropmaladd": "401 4TH ST",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5026331810,
    "dropfax": 5026339710
  },
  {
    "dcode": "D",
    "dropkey": "PX16349",
    "droptype": "D",
    "dropname": "SHEPHERDSVILLE",
    "dropdeladd": "921 N BUCKMAN ST",
    "dropdelcty": "SHEPHERDSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 401659998,
    "dropphyadd": "921 N BUCKMAN ST",
    "dropphycty": "SHEPHERDSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 401659998,
    "dropmaladd": "921 N BUCKMAN ST",
    "dropmalcty": "SHEPHERDSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 401659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025436417,
    "dropfax": 5029211252
  },
  {
    "dcode": "D",
    "dropkey": "PX16362",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "17340 E BIG CREEK RD",
    "dropdelcty": "SIDNEY",
    "dropdelst": "KY",
    "dropdelzpp": 415649998,
    "dropphyadd": "17340 E BIG CREEK RD",
    "dropphycty": "SIDNEY",
    "dropphyst": "KY",
    "dropphyzpp": 415649998,
    "dropmaladd": "17340 E BIG CREEK RD",
    "dropmalcty": "SIDNEY",
    "dropmalst": "KY",
    "dropmalzpp": 415649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063538104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16363",
    "droptype": "D",
    "dropname": "SILER",
    "dropdeladd": "15654 E HIGHWAY 92",
    "dropdelcty": "SILER",
    "dropdelst": "KY",
    "dropdelzpp": 407639998,
    "dropphyadd": "15654 E HIGHWAY 92",
    "dropphycty": "SILER",
    "dropphyst": "KY",
    "dropphyzpp": 407639998,
    "dropmaladd": "15654 E HIGHWAY 92",
    "dropmalcty": "SILER",
    "dropmalst": "KY",
    "dropmalzpp": 407639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065495144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16366",
    "droptype": "D",
    "dropname": "SILVER GROVE",
    "dropdeladd": "5081 4 MILE RD",
    "dropdelcty": "SILVER GROVE",
    "dropdelst": "KY",
    "dropdelzpp": 410859998,
    "dropphyadd": "5081 4 MILE RD",
    "dropphycty": "SILVER GROVE",
    "dropphyst": "KY",
    "dropphyzpp": 410859998,
    "dropmaladd": "5081 4 MILE RD",
    "dropmalcty": "SILVER GROVE",
    "dropmalst": "KY",
    "dropmalzpp": 410859998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594416463,
    "dropsitcph": 8594416463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16369",
    "droptype": "D",
    "dropname": "SIMPSONVILLE",
    "dropdeladd": "6990 SHELBYVILLE RD",
    "dropdelcty": "SIMPSONVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400679998,
    "dropphyadd": "6990 SHELBYVILLE RD",
    "dropphycty": "SIMPSONVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400679998,
    "dropmaladd": "6990 SHELBYVILLE RD",
    "dropmalcty": "SIMPSONVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5027228747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16377",
    "droptype": "D",
    "dropname": "SLAUGHTERS",
    "dropdeladd": "15452 STATE ROUTE 120 E",
    "dropdelcty": "SLAUGHTERS",
    "dropdelst": "KY",
    "dropdelzpp": 424569998,
    "dropphyadd": "15452 STATE ROUTE 120 E",
    "dropphycty": "SLAUGHTERS",
    "dropphyst": "KY",
    "dropphyzpp": 424569998,
    "dropmaladd": "15452 STATE ROUTE 120 E",
    "dropmalcty": "SLAUGHTERS",
    "dropmalst": "KY",
    "dropmalzpp": 424569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708847127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16379",
    "droptype": "D",
    "dropname": "SLEMP",
    "dropdeladd": "45 OWENS BRANCH RD",
    "dropdelcty": "SLEMP",
    "dropdelst": "KY",
    "dropdelzpp": 417639998,
    "dropphyadd": "45 OWENS BRANCH RD",
    "dropphycty": "SLEMP",
    "dropphyst": "KY",
    "dropphyzpp": 417639998,
    "dropmaladd": "45 OWENS BRANCH RD",
    "dropmalcty": "SLEMP",
    "dropmalst": "KY",
    "dropmalzpp": 417639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066753621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16385",
    "droptype": "D",
    "dropname": "SMILAX",
    "dropdeladd": "3624 CUTSHIN RD",
    "dropdelcty": "SMILAX",
    "dropdelst": "KY",
    "dropdelzpp": 417649998,
    "dropphyadd": "3624 CUTSHIN RD",
    "dropphycty": "SMILAX",
    "dropphyst": "KY",
    "dropphyzpp": 417649998,
    "dropmaladd": "3624 CUTSHIN RD",
    "dropmalcty": "SMILAX",
    "dropmalst": "KY",
    "dropmalzpp": 417649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062793135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16387",
    "droptype": "D",
    "dropname": "SMITH MILLS",
    "dropdeladd": "6161 STATE ROUTE 136 W",
    "dropdelcty": "SMITH MILLS",
    "dropdelst": "KY",
    "dropdelzpp": 424579998,
    "dropphyadd": "6161 STATE ROUTE 136 W",
    "dropphycty": "SMITH MILLS",
    "dropphyst": "KY",
    "dropphyzpp": 424579998,
    "dropmaladd": "6161 STATE ROUTE 136 W",
    "dropmalcty": "SMITH MILLS",
    "dropmalst": "KY",
    "dropmalzpp": 424579998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705336094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16389",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "3143 GILTNER RD",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 400689998,
    "dropphyadd": "3143 GILTNER RD",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 400689998,
    "dropmaladd": "3143 GILTNER RD",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 400689998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028457590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16390",
    "droptype": "D",
    "dropname": "SMITHLAND",
    "dropdeladd": "121 E ADAIR ST",
    "dropdelcty": "SMITHLAND",
    "dropdelst": "KY",
    "dropdelzpp": 420819998,
    "dropphyadd": "121 E ADAIR ST",
    "dropphycty": "SMITHLAND",
    "dropphyst": "KY",
    "dropphyzpp": 420819998,
    "dropmaladd": "121 E ADAIR ST",
    "dropmalcty": "SMITHLAND",
    "dropmalst": "KY",
    "dropmalzpp": 420819998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709282224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16393",
    "droptype": "D",
    "dropname": "SMITHS GROVE",
    "dropdeladd": "117 W 1ST ST",
    "dropdelcty": "SMITHS GROVE",
    "dropdelst": "KY",
    "dropdelzpp": 421719998,
    "dropphyadd": "117 W 1ST ST",
    "dropphycty": "SMITHS GROVE",
    "dropphyst": "KY",
    "dropphyzpp": 421719998,
    "dropmaladd": "117 W 1ST ST",
    "dropmalcty": "SMITHS GROVE",
    "dropmalst": "KY",
    "dropmalzpp": 421719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705636591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16405",
    "droptype": "D",
    "dropname": "SOLDIER",
    "dropdeladd": "8337 STATE HIGHWAY 174",
    "dropdelcty": "SOLDIER",
    "dropdelst": "KY",
    "dropdelzpp": 411739998,
    "dropphyadd": "8337 STATE HIGHWAY 174",
    "dropphycty": "SOLDIER",
    "dropphyst": "KY",
    "dropphyzpp": 411739998,
    "dropmaladd": "8337 STATE HIGHWAY 174",
    "dropmalcty": "SOLDIER",
    "dropmalst": "KY",
    "dropmalzpp": 411739998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062862353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16408",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "119 N MAPLE ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "KY",
    "dropdelzpp": 425019998,
    "dropphyadd": "119 N MAPLE ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "KY",
    "dropphyzpp": 425019998,
    "dropmaladd": "119 N MAPLE ST",
    "dropmalcty": "SOMERSET",
    "dropmalst": "KY",
    "dropmalzpp": 425019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066793549,
    "dropfax": 6066795430
  },
  {
    "dcode": "D",
    "dropkey": "PX16409",
    "droptype": "D",
    "dropname": "SONORA",
    "dropdeladd": "204 E WESTERN AVE",
    "dropdelcty": "SONORA",
    "dropdelst": "KY",
    "dropdelzpp": 427769998,
    "dropphyadd": "204 E WESTERN AVE",
    "dropphycty": "SONORA",
    "dropphyst": "KY",
    "dropphyzpp": 427769998,
    "dropmaladd": "204 E WESTERN AVE",
    "dropmalcty": "SONORA",
    "dropmalst": "KY",
    "dropmalzpp": 427769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703698232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16413",
    "droptype": "D",
    "dropname": "SOUTH CARROLLTON",
    "dropdeladd": "10719 US HIGHWAY 431 N",
    "dropdelcty": "SOUTH CARROLLTON",
    "dropdelst": "KY",
    "dropdelzpp": 423749998,
    "dropphyadd": "10719 US HIGHWAY 431 N",
    "dropphycty": "SOUTH CARROLLTON",
    "dropphyst": "KY",
    "dropphyzpp": 423749998,
    "dropmaladd": "10719 US HIGHWAY 431 N",
    "dropmalcty": "SOUTH CARROLLTON",
    "dropmalst": "KY",
    "dropmalzpp": 423749998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707545340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16420",
    "droptype": "D",
    "dropname": "SOUTH PORTSMOUTH",
    "dropdeladd": "2246 STATE ROUTE 8",
    "dropdelcty": "SOUTH PORTSMOUTH",
    "dropdelst": "KY",
    "dropdelzpp": 411749996,
    "dropphyadd": "2246 STATE ROUTE 8",
    "dropphycty": "SOUTH PORTSMOUTH",
    "dropphyst": "KY",
    "dropphyzpp": 411749996,
    "dropmaladd": "2246 STATE ROUTE 8",
    "dropmalcty": "SOUTH PORTSMOUTH",
    "dropmalst": "KY",
    "dropmalzpp": 411749996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6069324532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16421",
    "droptype": "D",
    "dropname": "SOUTH SHORE",
    "dropdeladd": "11 NARCO DR",
    "dropdelcty": "SOUTH SHORE",
    "dropdelst": "KY",
    "dropdelzpp": 411759996,
    "dropphyadd": "11 NARCO DR",
    "dropphycty": "SOUTH SHORE",
    "dropphyst": "KY",
    "dropphyzpp": 411759996,
    "dropmaladd": "11 NARCO DR",
    "dropmalcty": "SOUTH SHORE",
    "dropmalst": "KY",
    "dropmalzpp": 411759996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6069323054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16429",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "101 KY HIGHWAY 467 W",
    "dropdelcty": "SPARTA",
    "dropdelst": "KY",
    "dropdelzpp": 410869998,
    "dropphyadd": "101 KY HIGHWAY 467 W",
    "dropphycty": "SPARTA",
    "dropphyst": "KY",
    "dropphyzpp": 410869998,
    "dropmaladd": "101 KY HIGHWAY 467 W",
    "dropmalcty": "SPARTA",
    "dropmalst": "KY",
    "dropmalzpp": 410869998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596434361,
    "dropsitcph": 8596434361,
    "dropfax": 8596433187
  },
  {
    "dcode": "D",
    "dropkey": "PX16436",
    "droptype": "D",
    "dropname": "SPOTTSVILLE",
    "dropdeladd": "1003 RIVER RD",
    "dropdelcty": "SPOTTSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 424589998,
    "dropphyadd": "1003 RIVER RD",
    "dropphycty": "SPOTTSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 424589998,
    "dropmaladd": "1003 RIVER RD",
    "dropmalcty": "SPOTTSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 424589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708272435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16442",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 400699998,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 400699998,
    "dropmaladd": "202 E MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 400699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8593363681,
    "dropfax": 8593369670
  },
  {
    "dcode": "D",
    "dropkey": "PX16490",
    "droptype": "D",
    "dropname": "STAFFORDSVILLE",
    "dropdeladd": "1100 KY ROUTE 40 W",
    "dropdelcty": "STAFFORDSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 412569998,
    "dropphyadd": "1100 KY ROUTE 40 W",
    "dropphycty": "STAFFORDSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 412569998,
    "dropmaladd": "1100 KY ROUTE 40 W",
    "dropmalcty": "STAFFORDSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 412569998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064428607,
    "dropfax": 6064428603
  },
  {
    "dcode": "D",
    "dropkey": "PX16492",
    "droptype": "D",
    "dropname": "STAMPING GROUND",
    "dropdeladd": "3283 MAIN ST",
    "dropdelcty": "STAMPING GROUND",
    "dropdelst": "KY",
    "dropdelzpp": 403799998,
    "dropphyadd": "3283 MAIN ST",
    "dropphycty": "STAMPING GROUND",
    "dropphyst": "KY",
    "dropphyzpp": 403799998,
    "dropmaladd": "3283 MAIN ST",
    "dropmalcty": "STAMPING GROUND",
    "dropmalst": "KY",
    "dropmalzpp": 403799998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025356183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16495",
    "droptype": "D",
    "dropname": "STANFORD",
    "dropdeladd": "113 CANE RUN RD",
    "dropdelcty": "STANFORD",
    "dropdelst": "KY",
    "dropdelzpp": 404849998,
    "dropphyadd": "113 CANE RUN RD",
    "dropphycty": "STANFORD",
    "dropphyst": "KY",
    "dropphyzpp": 404849998,
    "dropmaladd": "113 CANE RUN RD",
    "dropmalcty": "STANFORD",
    "dropmalst": "KY",
    "dropmalzpp": 404849998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063652619,
    "dropfax": 6063653231
  },
  {
    "dcode": "D",
    "dropkey": "PX16497",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "165 S SIPPLE ST",
    "dropdelcty": "STANTON",
    "dropdelst": "KY",
    "dropdelzpp": 403809998,
    "dropphyadd": "165 S SIPPLE ST",
    "dropphycty": "STANTON",
    "dropphyst": "KY",
    "dropphyzpp": 403809998,
    "dropmaladd": "165 S SIPPLE ST",
    "dropmalcty": "STANTON",
    "dropmalst": "KY",
    "dropmalzpp": 403809998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066632544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16498",
    "droptype": "D",
    "dropname": "STANVILLE",
    "dropdeladd": "185 E MAIN ST",
    "dropdelcty": "STANVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 416599998,
    "dropphyadd": "185 E MAIN ST",
    "dropphycty": "STANVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 416599998,
    "dropmaladd": "185 E MAIN ST",
    "dropmalcty": "STANVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 416599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064789748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16503",
    "droptype": "D",
    "dropname": "STEARNS",
    "dropdeladd": "2539 S HIGHWAY 1651",
    "dropdelcty": "STEARNS",
    "dropdelst": "KY",
    "dropdelzpp": 426479997,
    "dropphyadd": "2539 S HIGHWAY 1651",
    "dropphycty": "STEARNS",
    "dropphyst": "KY",
    "dropphyzpp": 426479997,
    "dropmaladd": "2539 S HIGHWAY 1651",
    "dropmalcty": "STEARNS",
    "dropmalst": "KY",
    "dropmalzpp": 426479997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065886009,
    "dropfax": 6063761520
  },
  {
    "dcode": "D",
    "dropkey": "PX16504",
    "droptype": "D",
    "dropname": "STEELE",
    "dropdeladd": "2308 FEDSCREEK RD",
    "dropdelcty": "STEELE",
    "dropdelst": "KY",
    "dropdelzpp": 415669998,
    "dropphyadd": "2308 FEDSCREEK RD",
    "dropphycty": "STEELE",
    "dropphyst": "KY",
    "dropphyzpp": 415669998,
    "dropmaladd": "2308 FEDSCREEK RD",
    "dropmalcty": "STEELE",
    "dropmalst": "KY",
    "dropmalzpp": 415669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068354799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16510",
    "droptype": "D",
    "dropname": "STEPHENSPORT",
    "dropdeladd": "9757 E HIGHWAY 144",
    "dropdelcty": "STEPHENSPORT",
    "dropdelst": "KY",
    "dropdelzpp": 401709998,
    "dropphyadd": "9757 E HIGHWAY 144",
    "dropphycty": "STEPHENSPORT",
    "dropphyst": "KY",
    "dropphyzpp": 401709998,
    "dropmaladd": "9757 E HIGHWAY 144",
    "dropmalcty": "STEPHENSPORT",
    "dropmalst": "KY",
    "dropmalzpp": 401709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707886538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16514",
    "droptype": "D",
    "dropname": "STINNETT",
    "dropdeladd": "25 HIGHWAY 406",
    "dropdelcty": "STINNETT",
    "dropdelst": "KY",
    "dropdelzpp": 408689998,
    "dropphyadd": "25 HIGHWAY 406",
    "dropphycty": "STINNETT",
    "dropphyst": "KY",
    "dropphyzpp": 408689998,
    "dropmaladd": "25 HIGHWAY 406",
    "dropmalcty": "STINNETT",
    "dropmalst": "KY",
    "dropmalzpp": 408689998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063744291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16518",
    "droptype": "D",
    "dropname": "STONEY FORK",
    "dropdeladd": "100 STONEY FORK POST OFFICE LOOP",
    "dropdelcty": "STONEY FORK",
    "dropdelst": "KY",
    "dropdelzpp": 409889998,
    "dropphyadd": "100 STONEY FORK POST OFFICE LOOP",
    "dropphycty": "STONEY FORK",
    "dropphyst": "KY",
    "dropphyzpp": 409889998,
    "dropmaladd": "100 STONEY FORK POST OFFICE LOOP",
    "dropmalcty": "STONEY FORK",
    "dropmalst": "KY",
    "dropmalzpp": 409889998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063378068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16525",
    "droptype": "D",
    "dropname": "STRUNK",
    "dropdeladd": "271 STRUNK HWY",
    "dropdelcty": "STRUNK",
    "dropdelst": "KY",
    "dropdelzpp": 426499998,
    "dropphyadd": "271 STRUNK HWY",
    "dropphycty": "STRUNK",
    "dropphyst": "KY",
    "dropphyzpp": 426499998,
    "dropmaladd": "271 STRUNK HWY",
    "dropmalcty": "STRUNK",
    "dropmalst": "KY",
    "dropmalzpp": 426499998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063542386,
    "dropfax": 6063543415
  },
  {
    "dcode": "D",
    "dropkey": "PX16526",
    "droptype": "D",
    "dropname": "STURGIS",
    "dropdeladd": "409 N MAIN ST",
    "dropdelcty": "STURGIS",
    "dropdelst": "KY",
    "dropdelzpp": 424599998,
    "dropphyadd": "409 N MAIN ST",
    "dropphycty": "STURGIS",
    "dropphyst": "KY",
    "dropphyzpp": 424599998,
    "dropmaladd": "409 N MAIN ST",
    "dropmalcty": "STURGIS",
    "dropmalst": "KY",
    "dropmalzpp": 424599998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703334036,
    "dropfax": 2703336837
  },
  {
    "dcode": "D",
    "dropkey": "PX16532",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "16470 STATE ROUTE 109",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "KY",
    "dropdelzpp": 424609998,
    "dropphyadd": "16470 STATE ROUTE 109",
    "dropphycty": "SULLIVAN",
    "dropphyst": "KY",
    "dropphyzpp": 424609998,
    "dropmaladd": "16470 STATE ROUTE 109",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "KY",
    "dropmalzpp": 424609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703335529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16533",
    "droptype": "D",
    "dropname": "SULPHUR",
    "dropdeladd": "6225 FALLEN TIMBER RD",
    "dropdelcty": "SULPHUR",
    "dropdelst": "KY",
    "dropdelzpp": 400709998,
    "dropphyadd": "6225 FALLEN TIMBER RD",
    "dropphycty": "SULPHUR",
    "dropphyst": "KY",
    "dropphyzpp": 400709998,
    "dropmaladd": "6225 FALLEN TIMBER RD",
    "dropmalcty": "SULPHUR",
    "dropmalst": "KY",
    "dropmalzpp": 400709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5027435049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16537",
    "droptype": "D",
    "dropname": "SUMMER SHADE",
    "dropdeladd": "2653 SUMMER SHADE RD",
    "dropdelcty": "SUMMER SHADE",
    "dropdelst": "KY",
    "dropdelzpp": 421669998,
    "dropphyadd": "2653 SUMMER SHADE RD",
    "dropphycty": "SUMMER SHADE",
    "dropphyst": "KY",
    "dropphyzpp": 421669998,
    "dropmaladd": "2653 SUMMER SHADE RD",
    "dropmalcty": "SUMMER SHADE",
    "dropmalst": "KY",
    "dropmalzpp": 421669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704285353,
    "dropfax": 2704285353
  },
  {
    "dcode": "D",
    "dropkey": "PX16538",
    "droptype": "D",
    "dropname": "SUMMERSVILLE",
    "dropdeladd": "5160 HODGENVILLE RD",
    "dropdelcty": "SUMMERSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 427829998,
    "dropphyadd": "5160 HODGENVILLE RD",
    "dropphycty": "SUMMERSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 427829998,
    "dropmaladd": "5160 HODGENVILLE RD",
    "dropmalcty": "SUMMERSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 427829998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709323068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16557",
    "droptype": "D",
    "dropname": "SWEEDEN",
    "dropdeladd": "4960 KY HIGHWAY 259 N",
    "dropdelcty": "SWEEDEN",
    "dropdelst": "KY",
    "dropdelzpp": 422859998,
    "dropphyadd": "4960 KY HIGHWAY 259 N",
    "dropphycty": "SWEEDEN",
    "dropphyst": "KY",
    "dropphyzpp": 422859998,
    "dropmaladd": "4960 KY HIGHWAY 259 N",
    "dropmalcty": "SWEEDEN",
    "dropmalst": "KY",
    "dropmalzpp": 422859998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702864011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16559",
    "droptype": "D",
    "dropname": "SYMSONIA",
    "dropdeladd": "12022 STATE ROUTE 131",
    "dropdelcty": "SYMSONIA",
    "dropdelst": "KY",
    "dropdelzpp": 420829998,
    "dropphyadd": "12022 STATE ROUTE 131",
    "dropphycty": "SYMSONIA",
    "dropphyst": "KY",
    "dropphyzpp": 420829998,
    "dropmaladd": "12022 STATE ROUTE 131",
    "dropmalcty": "SYMSONIA",
    "dropmalst": "KY",
    "dropmalzpp": 420829998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708513766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16576",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "800 TAYLORSVILLE RD",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 400719998,
    "dropphyadd": "800 TAYLORSVILLE RD",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 400719998,
    "dropmaladd": "800 TAYLORSVILLE RD",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 400719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024778494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16577",
    "droptype": "D",
    "dropname": "TEABERRY",
    "dropdeladd": "11136 KY ROUTE 979",
    "dropdelcty": "TEABERRY",
    "dropdelst": "KY",
    "dropdelzpp": 416609998,
    "dropphyadd": "11136 KY ROUTE 979",
    "dropphycty": "TEABERRY",
    "dropphyst": "KY",
    "dropphyzpp": 416609998,
    "dropmaladd": "11136 KY ROUTE 979",
    "dropmalcty": "TEABERRY",
    "dropmalst": "KY",
    "dropmalzpp": 416609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065865010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16584",
    "droptype": "D",
    "dropname": "THELMA",
    "dropdeladd": "5490 MAIN ST",
    "dropdelcty": "THELMA",
    "dropdelst": "KY",
    "dropdelzpp": 412609998,
    "dropphyadd": "5490 MAIN ST",
    "dropphycty": "THELMA",
    "dropphyst": "KY",
    "dropphyzpp": 412609998,
    "dropmaladd": "5490 MAIN ST",
    "dropmalcty": "THELMA",
    "dropmalst": "KY",
    "dropmalzpp": 412609998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067897564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16597",
    "droptype": "D",
    "dropname": "TILINE",
    "dropdeladd": "1330 TILINE RD",
    "dropdelcty": "TILINE",
    "dropdelst": "KY",
    "dropdelzpp": 420839998,
    "dropphyadd": "1330 TILINE RD",
    "dropphycty": "TILINE",
    "dropphyst": "KY",
    "dropphyzpp": 420839998,
    "dropmaladd": "1330 TILINE RD",
    "dropmalcty": "TILINE",
    "dropmalst": "KY",
    "dropmalzpp": 420839998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2709282541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16604",
    "droptype": "D",
    "dropname": "TOLLESBORO",
    "dropdeladd": "3900 W KY 10",
    "dropdelcty": "TOLLESBORO",
    "dropdelst": "KY",
    "dropdelzpp": 411899997,
    "dropphyadd": "3900 W KY 10",
    "dropphycty": "TOLLESBORO",
    "dropphyst": "KY",
    "dropphyzpp": 411899997,
    "dropmaladd": "3900 W KY 10",
    "dropmalcty": "TOLLESBORO",
    "dropmalst": "KY",
    "dropmalzpp": 411899997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067984691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16608",
    "droptype": "D",
    "dropname": "TOMPKINSVILLE",
    "dropdeladd": "203 W PAIGE ST",
    "dropdelcty": "TOMPKINSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 421679998,
    "dropphyadd": "203 W PAIGE ST",
    "dropphycty": "TOMPKINSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 421679998,
    "dropmaladd": "203 W PAIGE ST",
    "dropmalcty": "TOMPKINSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 421679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704876534,
    "dropfax": 2704878606
  },
  {
    "dcode": "D",
    "dropkey": "PX16611",
    "droptype": "D",
    "dropname": "TOPMOST",
    "dropdeladd": "6100 HIGHWAY 7 S",
    "dropdelcty": "TOPMOST",
    "dropdelst": "KY",
    "dropdelzpp": 418629998,
    "dropphyadd": "6100 HIGHWAY 7 S",
    "dropphycty": "TOPMOST",
    "dropphyst": "KY",
    "dropphyzpp": 418629998,
    "dropmaladd": "6100 HIGHWAY 7 S",
    "dropmalcty": "TOPMOST",
    "dropmalst": "KY",
    "dropmalzpp": 418629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064472148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16613",
    "droptype": "D",
    "dropname": "TOTZ",
    "dropdeladd": "11036 HIGHWAY 522",
    "dropdelcty": "TOTZ",
    "dropdelst": "KY",
    "dropdelzpp": 408709998,
    "dropphyadd": "11036 HIGHWAY 522",
    "dropphycty": "TOTZ",
    "dropphyst": "KY",
    "dropphyzpp": 408709998,
    "dropmaladd": "11036 HIGHWAY 522",
    "dropmalcty": "TOTZ",
    "dropmalst": "KY",
    "dropmalzpp": 408709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065735588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16622",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "KY",
    "dropdelzpp": 422869998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "TRENTON",
    "dropphyst": "KY",
    "dropphyzpp": 422869998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "KY",
    "dropmalzpp": 422869998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704665609,
    "dropfax": 2704665609
  },
  {
    "dcode": "D",
    "dropkey": "PX16630",
    "droptype": "D",
    "dropname": "TROSPER",
    "dropdeladd": "7814 KY 225",
    "dropdelcty": "TROSPER",
    "dropdelst": "KY",
    "dropdelzpp": 409959998,
    "dropphyadd": "7814 KY 225",
    "dropphycty": "TROSPER",
    "dropphyst": "KY",
    "dropphyzpp": 409959998,
    "dropmaladd": "7814 KY 225",
    "dropmalcty": "TROSPER",
    "dropmalst": "KY",
    "dropmalzpp": 409959998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065468693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16641",
    "droptype": "D",
    "dropname": "TYNER",
    "dropdeladd": "11535 US HIGHWAY 421 S",
    "dropdelcty": "TYNER",
    "dropdelst": "KY",
    "dropdelzpp": 404869998,
    "dropphyadd": "11535 US HIGHWAY 421 S",
    "dropphycty": "TYNER",
    "dropphyst": "KY",
    "dropphyzpp": 404869998,
    "dropmaladd": "11535 US HIGHWAY 421 S",
    "dropmalcty": "TYNER",
    "dropmalst": "KY",
    "dropmalzpp": 404869998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063645048,
    "dropfax": 6063642914
  },
  {
    "dcode": "D",
    "dropkey": "PX16645",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "1664 FROGTOWN RD",
    "dropdelcty": "UNION",
    "dropdelst": "KY",
    "dropdelzpp": 410919998,
    "dropphyadd": "1664 FROGTOWN RD",
    "dropphycty": "UNION",
    "dropphyst": "KY",
    "dropphyzpp": 410919998,
    "dropmaladd": "1664 FROGTOWN RD",
    "dropmalcty": "UNION",
    "dropmalst": "KY",
    "dropmalzpp": 410919998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8593843715,
    "dropsitcph": 8593843715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16647",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 424619998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 424619998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 424619998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708224533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16662",
    "droptype": "D",
    "dropname": "UPTON",
    "dropdeladd": "111 N WALNUT ST",
    "dropdelcty": "UPTON",
    "dropdelst": "KY",
    "dropdelzpp": 427849998,
    "dropphyadd": "111 N WALNUT ST",
    "dropphycty": "UPTON",
    "dropphyst": "KY",
    "dropphyzpp": 427849998,
    "dropmaladd": "111 N WALNUT ST",
    "dropmalcty": "UPTON",
    "dropmalst": "KY",
    "dropmalzpp": 427849998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703698610,
    "dropfax": 2703697612
  },
  {
    "dcode": "D",
    "dropkey": "PX16664",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "10734 US HIGHWAY 431",
    "dropdelcty": "UTICA",
    "dropdelst": "KY",
    "dropdelzpp": 423769998,
    "dropphyadd": "10734 US HIGHWAY 431",
    "dropphycty": "UTICA",
    "dropphyst": "KY",
    "dropphyzpp": 423769998,
    "dropmaladd": "10734 US HIGHWAY 431",
    "dropmalcty": "UTICA",
    "dropmalst": "KY",
    "dropmalzpp": 423769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707334168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16670",
    "droptype": "D",
    "dropname": "VAN LEAR",
    "dropdeladd": "55 MILLERS CRK",
    "dropdelcty": "VAN LEAR",
    "dropdelst": "KY",
    "dropdelzpp": 412659998,
    "dropphyadd": "55 MILLERS CRK",
    "dropphycty": "VAN LEAR",
    "dropphyst": "KY",
    "dropphyzpp": 412659998,
    "dropmaladd": "55 MILLERS CRK",
    "dropmalcty": "VAN LEAR",
    "dropmalst": "KY",
    "dropmalzpp": 412659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067897094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16672",
    "droptype": "D",
    "dropname": "VANCEBURG",
    "dropdeladd": "15 THIRD ST",
    "dropdelcty": "VANCEBURG",
    "dropdelst": "KY",
    "dropdelzpp": 411799997,
    "dropphyadd": "15 THIRD ST",
    "dropphycty": "VANCEBURG",
    "dropphyst": "KY",
    "dropphyzpp": 411799997,
    "dropmaladd": "15 THIRD ST",
    "dropmalcty": "VANCEBURG",
    "dropmalst": "KY",
    "dropmalzpp": 411799997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067962816,
    "dropfax": 6067963656
  },
  {
    "dcode": "D",
    "dropkey": "PX16673",
    "droptype": "D",
    "dropname": "VANCLEVE",
    "dropdeladd": "6857 HIGHWAY 15 N",
    "dropdelcty": "VANCLEVE",
    "dropdelst": "KY",
    "dropdelzpp": 413859998,
    "dropphyadd": "6857 HIGHWAY 15 N",
    "dropphycty": "VANCLEVE",
    "dropphyst": "KY",
    "dropphyzpp": 413859998,
    "dropmaladd": "6857 HIGHWAY 15 N",
    "dropmalcty": "VANCLEVE",
    "dropmalst": "KY",
    "dropmalzpp": 413859998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066668106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16680",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "14928 WALTON VERONA RD",
    "dropdelcty": "VERONA",
    "dropdelst": "KY",
    "dropdelzpp": 410929998,
    "dropphyadd": "14928 WALTON VERONA RD",
    "dropphycty": "VERONA",
    "dropphyst": "KY",
    "dropphyzpp": 410929998,
    "dropmaladd": "14928 WALTON VERONA RD",
    "dropmalcty": "VERONA",
    "dropmalst": "KY",
    "dropmalzpp": 410929998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594854900,
    "dropsitcph": 8594854900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16681",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "149 FIELDVIEW DR",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "KY",
    "dropdelzpp": 403839998,
    "dropphyadd": "149 FIELDVIEW DR",
    "dropphycty": "VERSAILLES",
    "dropphyst": "KY",
    "dropphyzpp": 403839998,
    "dropmaladd": "149 FIELDVIEW DR",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "KY",
    "dropmalzpp": 403839998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598733241,
    "dropfax": 8598730875
  },
  {
    "dcode": "D",
    "dropkey": "PX16683",
    "droptype": "D",
    "dropname": "VEST",
    "dropdeladd": "47 VEST TALCUM RD",
    "dropdelcty": "VEST",
    "dropdelst": "KY",
    "dropdelzpp": 417729998,
    "dropphyadd": "47 VEST TALCUM RD",
    "dropphycty": "VEST",
    "dropphyst": "KY",
    "dropphyzpp": 417729998,
    "dropmaladd": "47 VEST TALCUM RD",
    "dropmalcty": "VEST",
    "dropmalst": "KY",
    "dropmalzpp": 417729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067853609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16685",
    "droptype": "D",
    "dropname": "VICCO",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "VICCO",
    "dropdelst": "KY",
    "dropdelzpp": 417739998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "VICCO",
    "dropphyst": "KY",
    "dropphyzpp": 417739998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "VICCO",
    "dropmalst": "KY",
    "dropmalzpp": 417739998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064762256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16689",
    "droptype": "D",
    "dropname": "VINCENT",
    "dropdeladd": "4474 KY 30 W",
    "dropdelcty": "VINCENT",
    "dropdelst": "KY",
    "dropdelzpp": 413869997,
    "dropphyadd": "4474 KY 30 W",
    "dropphycty": "VINCENT",
    "dropphyst": "KY",
    "dropphyzpp": 413869997,
    "dropmaladd": "4474 KY 30 W",
    "dropmalcty": "VINCENT",
    "dropmalst": "KY",
    "dropmalzpp": 413869997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065936220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16690",
    "droptype": "D",
    "dropname": "VINE GROVE",
    "dropdeladd": "414 1/2 HIGHLAND AVE",
    "dropdelcty": "VINE GROVE",
    "dropdelst": "KY",
    "dropdelzpp": 401759998,
    "dropphyadd": "414 1/2 HIGHLAND AVE",
    "dropphycty": "VINE GROVE",
    "dropphyst": "KY",
    "dropphyzpp": 401759998,
    "dropmaladd": "414 1/2 HIGHLAND AVE",
    "dropmalcty": "VINE GROVE",
    "dropmalst": "KY",
    "dropmalzpp": 401759998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708775537,
    "dropfax": 2708770303
  },
  {
    "dcode": "D",
    "dropkey": "PX16693",
    "droptype": "D",
    "dropname": "VIRGIE",
    "dropdeladd": "1070 KY HIGHWAY 610 W",
    "dropdelcty": "VIRGIE",
    "dropdelst": "KY",
    "dropdelzpp": 415729998,
    "dropphyadd": "1070 KY HIGHWAY 610 W",
    "dropphycty": "VIRGIE",
    "dropphyst": "KY",
    "dropphyzpp": 415729998,
    "dropmaladd": "1070 KY HIGHWAY 610 W",
    "dropmalcty": "VIRGIE",
    "dropmalst": "KY",
    "dropmalzpp": 415729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066394927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16699",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "4045 NEW IRVINE RD",
    "dropdelcty": "WACO",
    "dropdelst": "KY",
    "dropdelzpp": 403859998,
    "dropphyadd": "4045 NEW IRVINE RD",
    "dropphycty": "WACO",
    "dropphyst": "KY",
    "dropphyzpp": 403859998,
    "dropmaladd": "4045 NEW IRVINE RD",
    "dropmalcty": "WACO",
    "dropmalst": "KY",
    "dropmalzpp": 403859998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8593693904,
    "dropfax": 8593693904
  },
  {
    "dcode": "D",
    "dropkey": "PX16700",
    "droptype": "D",
    "dropname": "WADDY",
    "dropdeladd": "3100 WADDY RD",
    "dropdelcty": "WADDY",
    "dropdelst": "KY",
    "dropdelzpp": 400769998,
    "dropphyadd": "3100 WADDY RD",
    "dropphycty": "WADDY",
    "dropphyst": "KY",
    "dropphyzpp": 400769998,
    "dropmaladd": "3100 WADDY RD",
    "dropmalcty": "WADDY",
    "dropmalst": "KY",
    "dropmalzpp": 400769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5028295206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16707",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "7408 WALLINGFORD RD",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "KY",
    "dropdelzpp": 410939998,
    "dropphyadd": "7408 WALLINGFORD RD",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "KY",
    "dropphyzpp": 410939998,
    "dropmaladd": "7408 WALLINGFORD RD",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "KY",
    "dropmalzpp": 410939998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6068494177,
    "dropsitcph": 6068494177,
    "dropfax": 6068455082
  },
  {
    "dcode": "D",
    "dropkey": "PX16710",
    "droptype": "D",
    "dropname": "WALLINS CREEK",
    "dropdeladd": "854 HIGHWAY 219",
    "dropdelcty": "WALLINS CREEK",
    "dropdelst": "KY",
    "dropdelzpp": 408739998,
    "dropphyadd": "854 HIGHWAY 219",
    "dropphycty": "WALLINS CREEK",
    "dropphyst": "KY",
    "dropphyzpp": 408739998,
    "dropmaladd": "854 HIGHWAY 219",
    "dropmalcty": "WALLINS CREEK",
    "dropmalst": "KY",
    "dropmalzpp": 408739998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066643930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16717",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "52 S MAIN ST",
    "dropdelcty": "WALTON",
    "dropdelst": "KY",
    "dropdelzpp": 410949998,
    "dropphyadd": "52 S MAIN ST",
    "dropphycty": "WALTON",
    "dropphyst": "KY",
    "dropphyzpp": 410949998,
    "dropmaladd": "52 S MAIN ST",
    "dropmalcty": "WALTON",
    "dropmalst": "KY",
    "dropmalzpp": 410949998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8594854023,
    "dropsitcph": 8594854023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16721",
    "droptype": "D",
    "dropname": "WARFIELD",
    "dropdeladd": "82 FIREHOUSE LN",
    "dropdelcty": "WARFIELD",
    "dropdelst": "KY",
    "dropdelzpp": 412679998,
    "dropphyadd": "82 FIREHOUSE LN",
    "dropphycty": "WARFIELD",
    "dropphyst": "KY",
    "dropphyzpp": 412679998,
    "dropmaladd": "82 FIREHOUSE LN",
    "dropmalcty": "WARFIELD",
    "dropmalst": "KY",
    "dropmalzpp": 412679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063956410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16723",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "KY",
    "dropdelzpp": 410959998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "WARSAW",
    "dropphyst": "KY",
    "dropphyzpp": 410959998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "KY",
    "dropmalzpp": 410959998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 8595671469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16725",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "2200 OLD MAIN ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 410969998,
    "dropphyadd": "2200 OLD MAIN ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 410969998,
    "dropmaladd": "2200 OLD MAIN ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 410969998,
    "dropsitphn": 5136845763,
    "dropsitlph": 6067597448,
    "dropsitcph": 6067597448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16726",
    "droptype": "D",
    "dropname": "WATER VALLEY",
    "dropdeladd": "16846 STATE ROUTE 45 S",
    "dropdelcty": "WATER VALLEY",
    "dropdelst": "KY",
    "dropdelzpp": 420859998,
    "dropphyadd": "16846 STATE ROUTE 45 S",
    "dropphycty": "WATER VALLEY",
    "dropphyst": "KY",
    "dropphyzpp": 420859998,
    "dropmaladd": "16846 STATE ROUTE 45 S",
    "dropmalcty": "WATER VALLEY",
    "dropmalst": "KY",
    "dropmalzpp": 420859998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703552355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16730",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "124 N MAPLE ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "KY",
    "dropdelzpp": 424629998,
    "dropphyadd": "124 N MAPLE ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "KY",
    "dropphyzpp": 424629998,
    "dropmaladd": "124 N MAPLE ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "KY",
    "dropmalzpp": 424629998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703894321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16733",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "2617 KING KELLY COLEMAN HWY",
    "dropdelcty": "WAYLAND",
    "dropdelst": "KY",
    "dropdelzpp": 416669998,
    "dropphyadd": "2617 KING KELLY COLEMAN HWY",
    "dropphycty": "WAYLAND",
    "dropphyst": "KY",
    "dropphyzpp": 416669998,
    "dropmaladd": "2617 KING KELLY COLEMAN HWY",
    "dropmalcty": "WAYLAND",
    "dropmalst": "KY",
    "dropmalzpp": 416669998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063584344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16734",
    "droptype": "D",
    "dropname": "WAYNESBURG",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "WAYNESBURG",
    "dropdelst": "KY",
    "dropdelzpp": 404899998,
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "WAYNESBURG",
    "dropphyst": "KY",
    "dropphyzpp": 404899998,
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "WAYNESBURG",
    "dropmalst": "KY",
    "dropmalzpp": 404899998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063796614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16740",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "12321 N HIGHWAY 261",
    "dropdelcty": "WEBSTER",
    "dropdelst": "KY",
    "dropdelzpp": 401769998,
    "dropphyadd": "12321 N HIGHWAY 261",
    "dropphycty": "WEBSTER",
    "dropphyst": "KY",
    "dropphyzpp": 401769998,
    "dropmaladd": "12321 N HIGHWAY 261",
    "dropmalcty": "WEBSTER",
    "dropmalst": "KY",
    "dropmalzpp": 401769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705476797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16742",
    "droptype": "D",
    "dropname": "WEEKSBURY",
    "dropdeladd": "1905 KY ROUTE 466",
    "dropdelcty": "WEEKSBURY",
    "dropdelst": "KY",
    "dropdelzpp": 416679998,
    "dropphyadd": "1905 KY ROUTE 466",
    "dropphycty": "WEEKSBURY",
    "dropphyst": "KY",
    "dropphyzpp": 416679998,
    "dropmaladd": "1905 KY ROUTE 466",
    "dropmalcty": "WEEKSBURY",
    "dropmalst": "KY",
    "dropmalzpp": 416679998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064524125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16745",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "8483 US HIGHWAY 460 E",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 403879998,
    "dropphyadd": "8483 US HIGHWAY 460 E",
    "dropphycty": "WELLINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 403879998,
    "dropmaladd": "8483 US HIGHWAY 460 E",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 403879998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067686155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16754",
    "droptype": "D",
    "dropname": "WEST LIBERTY",
    "dropdeladd": "398 GLENN AVE",
    "dropdelcty": "WEST LIBERTY",
    "dropdelst": "KY",
    "dropdelzpp": 414729998,
    "dropphyadd": "398 GLENN AVE",
    "dropphycty": "WEST LIBERTY",
    "dropphyst": "KY",
    "dropphyzpp": 414729998,
    "dropmaladd": "398 GLENN AVE",
    "dropmalcty": "WEST LIBERTY",
    "dropmalst": "KY",
    "dropmalzpp": 414729998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067434380,
    "dropfax": 6067432777
  },
  {
    "dcode": "D",
    "dropkey": "PX16756",
    "droptype": "D",
    "dropname": "WEST PADUCAH",
    "dropdeladd": "7475 US HIGHWAY 60 W",
    "dropdelcty": "WEST PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420869998,
    "dropphyadd": "7475 US HIGHWAY 60 W",
    "dropphycty": "WEST PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420869998,
    "dropmaladd": "7475 US HIGHWAY 60 W",
    "dropmalcty": "WEST PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420869998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707446673,
    "dropfax": 2707446264
  },
  {
    "dcode": "D",
    "dropkey": "PX16757",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "KY",
    "dropdelzpp": 401779998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "KY",
    "dropphyzpp": 401779998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "KY",
    "dropmalzpp": 401779998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029224046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16762",
    "droptype": "D",
    "dropname": "WEST VAN LEAR",
    "dropdeladd": "797 KY ROUTE 302",
    "dropdelcty": "WEST VAN LEAR",
    "dropdelst": "KY",
    "dropdelzpp": 412689998,
    "dropphyadd": "797 KY ROUTE 302",
    "dropphycty": "WEST VAN LEAR",
    "dropphyst": "KY",
    "dropphyzpp": 412689998,
    "dropmaladd": "797 KY ROUTE 302",
    "dropmalcty": "WEST VAN LEAR",
    "dropmalst": "KY",
    "dropmalzpp": 412689998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067897421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16766",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "6915 MAIN ST",
    "dropdelcty": "WESTPORT",
    "dropdelst": "KY",
    "dropdelzpp": 400779998,
    "dropphyadd": "6915 MAIN ST",
    "dropphycty": "WESTPORT",
    "dropphyst": "KY",
    "dropphyzpp": 400779998,
    "dropmaladd": "6915 MAIN ST",
    "dropmalcty": "WESTPORT",
    "dropmalst": "KY",
    "dropmalzpp": 400779998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022220646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16769",
    "droptype": "D",
    "dropname": "WHEATCROFT",
    "dropdeladd": "18 E BROADWAY ST",
    "dropdelcty": "WHEATCROFT",
    "dropdelst": "KY",
    "dropdelzpp": 424639998,
    "dropphyadd": "18 E BROADWAY ST",
    "dropphycty": "WHEATCROFT",
    "dropphyst": "KY",
    "dropphyzpp": 424639998,
    "dropmaladd": "18 E BROADWAY ST",
    "dropmalcty": "WHEATCROFT",
    "dropmalst": "KY",
    "dropmalzpp": 424639998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706642332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16772",
    "droptype": "D",
    "dropname": "WHEELWRIGHT",
    "dropdeladd": "80 SHOP FORK ST",
    "dropdelcty": "WHEELWRIGHT",
    "dropdelst": "KY",
    "dropdelzpp": 416699998,
    "dropphyadd": "80 SHOP FORK ST",
    "dropphycty": "WHEELWRIGHT",
    "dropphyst": "KY",
    "dropphyzpp": 416699998,
    "dropmaladd": "80 SHOP FORK ST",
    "dropmalcty": "WHEELWRIGHT",
    "dropmalst": "KY",
    "dropmalzpp": 416699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064524448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16778",
    "droptype": "D",
    "dropname": "WHITE MILLS",
    "dropdeladd": "244 WHITE MILLS RD",
    "dropdelcty": "WHITE MILLS",
    "dropdelst": "KY",
    "dropdelzpp": 427889998,
    "dropphyadd": "244 WHITE MILLS RD",
    "dropphycty": "WHITE MILLS",
    "dropphyst": "KY",
    "dropphyzpp": 427889998,
    "dropmaladd": "244 WHITE MILLS RD",
    "dropmalcty": "WHITE MILLS",
    "dropmalst": "KY",
    "dropmalzpp": 427889998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703696357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16781",
    "droptype": "D",
    "dropname": "WHITE PLAINS",
    "dropdeladd": "123 S BOB BRUCE DR",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "KY",
    "dropdelzpp": 424649998,
    "dropphyadd": "123 S BOB BRUCE DR",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "KY",
    "dropphyzpp": 424649998,
    "dropmaladd": "123 S BOB BRUCE DR",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "KY",
    "dropmalzpp": 424649998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706768391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16786",
    "droptype": "D",
    "dropname": "WHITESBURG",
    "dropdeladd": "71 HIGHWAY 119 S",
    "dropdelcty": "WHITESBURG",
    "dropdelst": "KY",
    "dropdelzpp": 418589998,
    "dropphyadd": "71 HIGHWAY 119 S",
    "dropphycty": "WHITESBURG",
    "dropphyst": "KY",
    "dropphyzpp": 418589998,
    "dropmaladd": "71 HIGHWAY 119 S",
    "dropmalcty": "WHITESBURG",
    "dropmalst": "KY",
    "dropmalzpp": 418589998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066332955,
    "dropfax": 6066332958
  },
  {
    "dcode": "D",
    "dropkey": "PX16787",
    "droptype": "D",
    "dropname": "WHITESVILLE",
    "dropdeladd": "10575 MAIN CROSS ST",
    "dropdelcty": "WHITESVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 423789998,
    "dropphyadd": "10575 MAIN CROSS ST",
    "dropphycty": "WHITESVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 423789998,
    "dropmaladd": "10575 MAIN CROSS ST",
    "dropmalcty": "WHITESVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 423789998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2702335564,
    "dropfax": 2702335631
  },
  {
    "dcode": "D",
    "dropkey": "PX16791",
    "droptype": "D",
    "dropname": "WHITLEY CITY",
    "dropdeladd": "1387 N HIGHWAY 27",
    "dropdelcty": "WHITLEY CITY",
    "dropdelst": "KY",
    "dropdelzpp": 426539998,
    "dropphyadd": "1387 N HIGHWAY 27",
    "dropphycty": "WHITLEY CITY",
    "dropphyst": "KY",
    "dropphyzpp": 426539998,
    "dropmaladd": "1387 N HIGHWAY 27",
    "dropmalcty": "WHITLEY CITY",
    "dropmalst": "KY",
    "dropmalzpp": 426539998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6063765342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16794",
    "droptype": "D",
    "dropname": "WICKLIFFE",
    "dropdeladd": "330 COURT ST",
    "dropdelcty": "WICKLIFFE",
    "dropdelst": "KY",
    "dropdelzpp": 420879998,
    "dropphyadd": "330 COURT ST",
    "dropphycty": "WICKLIFFE",
    "dropphyst": "KY",
    "dropphyzpp": 420879998,
    "dropmaladd": "330 COURT ST",
    "dropmalcty": "WICKLIFFE",
    "dropmalst": "KY",
    "dropmalzpp": 420879998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2703353991,
    "dropfax": 2703355073
  },
  {
    "dcode": "D",
    "dropkey": "PX16799",
    "droptype": "D",
    "dropname": "WILDIE",
    "dropdeladd": "1419 WILDIE RD",
    "dropdelcty": "WILDIE",
    "dropdelst": "KY",
    "dropdelzpp": 404929998,
    "dropphyadd": "1419 WILDIE RD",
    "dropphycty": "WILDIE",
    "dropphyst": "KY",
    "dropphyzpp": 404929998,
    "dropmaladd": "1419 WILDIE RD",
    "dropmalcty": "WILDIE",
    "dropmalst": "KY",
    "dropmalzpp": 404929998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062561283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16801",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "8679 S STATE HIGHWAY 1",
    "dropdelcty": "WILLARD",
    "dropdelst": "KY",
    "dropdelzpp": 411819998,
    "dropphyadd": "8679 S STATE HIGHWAY 1",
    "dropphycty": "WILLARD",
    "dropphyst": "KY",
    "dropphyzpp": 411819998,
    "dropmaladd": "8679 S STATE HIGHWAY 1",
    "dropmalcty": "WILLARD",
    "dropmalst": "KY",
    "dropmalzpp": 411819998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064749038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16803",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "1000 N HIGHWAY 25 W",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "KY",
    "dropdelzpp": 407699998,
    "dropphyadd": "1000 N HIGHWAY 25 W",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "KY",
    "dropphyzpp": 407699998,
    "dropmaladd": "1000 N HIGHWAY 25 W",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "KY",
    "dropmalzpp": 407699998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065491250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16805",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "7540 KY ROUTE 40 E",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "KY",
    "dropdelzpp": 412719998,
    "dropphyadd": "7540 KY ROUTE 40 E",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "KY",
    "dropphyzpp": 412719998,
    "dropmaladd": "7540 KY ROUTE 40 E",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "KY",
    "dropmalzpp": 412719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6067891948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16806",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "205 N MAIN ST",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 410979998,
    "dropphyadd": "205 N MAIN ST",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 410979998,
    "dropmaladd": "205 N MAIN ST",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 410979998,
    "dropsitphn": 5136845763,
    "dropsitlph": 8598230868,
    "dropsitcph": 8598230868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16808",
    "droptype": "D",
    "dropname": "WILLISBURG",
    "dropdeladd": "6260 HIGHWAY 433",
    "dropdelcty": "WILLISBURG",
    "dropdelst": "KY",
    "dropdelzpp": 400789998,
    "dropphyadd": "6260 HIGHWAY 433",
    "dropphycty": "WILLISBURG",
    "dropphyst": "KY",
    "dropphyzpp": 400789998,
    "dropmaladd": "6260 HIGHWAY 433",
    "dropmalcty": "WILLISBURG",
    "dropmalst": "KY",
    "dropmalzpp": 400789998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8593792265,
    "dropfax": 8593752362
  },
  {
    "dcode": "D",
    "dropkey": "PX16812",
    "droptype": "D",
    "dropname": "WILMORE",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "WILMORE",
    "dropdelst": "KY",
    "dropdelzpp": 403909998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "WILMORE",
    "dropphyst": "KY",
    "dropphyzpp": 403909998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "WILMORE",
    "dropmalst": "KY",
    "dropmalzpp": 403909998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8598583548,
    "dropfax": 8598588041
  },
  {
    "dcode": "D",
    "dropkey": "PX16816",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "KY",
    "dropdelzpp": 403919998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "WINCHESTER",
    "dropphyst": "KY",
    "dropphyzpp": 403919998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "KY",
    "dropmalzpp": 403919998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8597446186,
    "dropfax": 8597440930
  },
  {
    "dcode": "D",
    "dropkey": "PX16818",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "3593 KY 80",
    "dropdelcty": "WINDSOR",
    "dropdelst": "KY",
    "dropdelzpp": 425659998,
    "dropphyadd": "3593 KY 80",
    "dropphycty": "WINDSOR",
    "dropphyst": "KY",
    "dropphyzpp": 425659998,
    "dropmaladd": "3593 KY 80",
    "dropmalcty": "WINDSOR",
    "dropmalst": "KY",
    "dropmalzpp": 425659998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2708665864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16821",
    "droptype": "D",
    "dropname": "WINGO",
    "dropdeladd": "93 LEBANON ST",
    "dropdelcty": "WINGO",
    "dropdelst": "KY",
    "dropdelzpp": 420889998,
    "dropphyadd": "93 LEBANON ST",
    "dropphycty": "WINGO",
    "dropphyst": "KY",
    "dropphyzpp": 420889998,
    "dropmaladd": "93 LEBANON ST",
    "dropmalcty": "WINGO",
    "dropmalst": "KY",
    "dropmalzpp": 420889998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706750749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16827",
    "droptype": "D",
    "dropname": "WITTENSVILLE",
    "dropdeladd": "3027 N US HIGHWAY 23",
    "dropdelcty": "WITTENSVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 412749998,
    "dropphyadd": "3027 N US HIGHWAY 23",
    "dropphycty": "WITTENSVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 412749998,
    "dropmaladd": "3027 N US HIGHWAY 23",
    "dropmalcty": "WITTENSVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 412749998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062973918,
    "dropfax": 6062976512
  },
  {
    "dcode": "D",
    "dropkey": "PX16835",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "34 N ARCHER ST",
    "dropdelcty": "WOODBINE",
    "dropdelst": "KY",
    "dropdelzpp": 407719998,
    "dropphyadd": "34 N ARCHER ST",
    "dropphycty": "WOODBINE",
    "dropphyst": "KY",
    "dropphyzpp": 407719998,
    "dropmaladd": "34 N ARCHER ST",
    "dropmalcty": "WOODBINE",
    "dropmalst": "KY",
    "dropmalzpp": 407719998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6065286591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16836",
    "droptype": "D",
    "dropname": "WOODBURN",
    "dropdeladd": "250 CLARK ST",
    "dropdelcty": "WOODBURN",
    "dropdelst": "KY",
    "dropdelzpp": 421709998,
    "dropphyadd": "250 CLARK ST",
    "dropphycty": "WOODBURN",
    "dropphyst": "KY",
    "dropphyzpp": 421709998,
    "dropmaladd": "250 CLARK ST",
    "dropmalcty": "WOODBURN",
    "dropmalst": "KY",
    "dropmalzpp": 421709998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705293311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16837",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "74 BARREN RIVER RD",
    "dropdelcty": "WOODBURY",
    "dropdelst": "KY",
    "dropdelzpp": 422889998,
    "dropphyadd": "74 BARREN RIVER RD",
    "dropphycty": "WOODBURY",
    "dropphyst": "KY",
    "dropphyzpp": 422889998,
    "dropmaladd": "74 BARREN RIVER RD",
    "dropmalcty": "WOODBURY",
    "dropmalst": "KY",
    "dropmalzpp": 422889998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2705264790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16848",
    "droptype": "D",
    "dropname": "WOOTON",
    "dropdeladd": "5275 HIGHWAY 80",
    "dropdelcty": "WOOTON",
    "dropdelst": "KY",
    "dropdelzpp": 417769998,
    "dropphyadd": "5275 HIGHWAY 80",
    "dropphycty": "WOOTON",
    "dropphyst": "KY",
    "dropphyzpp": 417769998,
    "dropmaladd": "5275 HIGHWAY 80",
    "dropmalcty": "WOOTON",
    "dropmalst": "KY",
    "dropmalzpp": 417769998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062794571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16850",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "605 FERRY AVE",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 411839997,
    "dropphyadd": "605 FERRY AVE",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 411839997,
    "dropmaladd": "605 FERRY AVE",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 411839997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6068366777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16851",
    "droptype": "D",
    "dropname": "WORTHVILLE",
    "dropdeladd": "481 US HIGHWAY 467",
    "dropdelcty": "WORTHVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 410989998,
    "dropphyadd": "481 US HIGHWAY 467",
    "dropphycty": "WORTHVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 410989998,
    "dropmaladd": "481 US HIGHWAY 467",
    "dropmalcty": "WORTHVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 410989998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5027328268,
    "dropsitcph": 5027328268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16858",
    "droptype": "D",
    "dropname": "YEADDISS",
    "dropdeladd": "11545 CUTSHIN RD",
    "dropdelcty": "YEADDISS",
    "dropdelst": "KY",
    "dropdelzpp": 417779998,
    "dropphyadd": "11545 CUTSHIN RD",
    "dropphycty": "YEADDISS",
    "dropphyst": "KY",
    "dropphyzpp": 417779998,
    "dropmaladd": "11545 CUTSHIN RD",
    "dropmalcty": "YEADDISS",
    "dropmalst": "KY",
    "dropmalzpp": 417779998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6062793130,
    "dropfax": 6062792826
  },
  {
    "dcode": "D",
    "dropkey": "PX16861",
    "droptype": "D",
    "dropname": "YERKES",
    "dropdeladd": "8550 KY HIGHWAY 451",
    "dropdelcty": "YERKES",
    "dropdelst": "KY",
    "dropdelzpp": 417789998,
    "dropphyadd": "8550 KY HIGHWAY 451",
    "dropphycty": "YERKES",
    "dropphyst": "KY",
    "dropphyzpp": 417789998,
    "dropmaladd": "8550 KY HIGHWAY 451",
    "dropmalcty": "YERKES",
    "dropmalst": "KY",
    "dropmalzpp": 417789998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064393000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16873",
    "droptype": "D",
    "dropname": "ZOE",
    "dropdeladd": "73 ZOE POST OFFICE RD",
    "dropdelcty": "ZOE",
    "dropdelst": "KY",
    "dropdelzpp": 413979998,
    "dropphyadd": "73 ZOE POST OFFICE RD",
    "dropphycty": "ZOE",
    "dropphyst": "KY",
    "dropphyzpp": 413979998,
    "dropmaladd": "73 ZOE POST OFFICE RD",
    "dropmalcty": "ZOE",
    "dropmalst": "KY",
    "dropmalzpp": 413979998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064648096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16877",
    "droptype": "D",
    "dropname": "AARONSBURG",
    "dropdeladd": "164 S RACHELS WAY",
    "dropdelcty": "AARONSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168209998,
    "dropphyadd": "164 S RACHELS WAY",
    "dropphycty": "AARONSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168209998,
    "dropmaladd": "164 S RACHELS WAY",
    "dropmalcty": "AARONSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143495261,
    "dropsitcph": 8143495261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16879",
    "droptype": "D",
    "dropname": "ABBOTTSTOWN",
    "dropdeladd": "680 W KING ST",
    "dropdelcty": "ABBOTTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173019998,
    "dropphyadd": "680 W KING ST",
    "dropphycty": "ABBOTTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173019998,
    "dropmaladd": "680 W KING ST",
    "dropmalcty": "ABBOTTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173019998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172599613,
    "dropsitcph": 7172599613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16881",
    "droptype": "D",
    "dropname": "ABINGTON",
    "dropdeladd": "1925 KEITH RD",
    "dropdelcty": "ABINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 190019998,
    "dropphyadd": "1925 KEITH RD",
    "dropphycty": "ABINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 190019998,
    "dropmaladd": "1925 KEITH RD",
    "dropmalcty": "ABINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 190019998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158872395,
    "dropsitcph": 2158872395,
    "dropfax": 2158870717
  },
  {
    "dcode": "D",
    "dropkey": "PX16889",
    "droptype": "D",
    "dropname": "ACME",
    "dropdeladd": "2930 STATE ROUTE 31",
    "dropdelcty": "ACME",
    "dropdelst": "PA",
    "dropdelzpp": 156101382,
    "dropphyadd": "2930 STATE ROUTE 31",
    "dropphycty": "ACME",
    "dropphyst": "PA",
    "dropphyzpp": 156101382,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ACME",
    "dropmalst": "PA",
    "dropmalzpp": 156109998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242040075,
    "dropsitcph": 7242040075,
    "dropfax": 7242040074
  },
  {
    "dcode": "D",
    "dropkey": "PX16890",
    "droptype": "D",
    "dropname": "ACOSTA",
    "dropdeladd": "121 5TH ST",
    "dropdelcty": "ACOSTA",
    "dropdelst": "PA",
    "dropdelzpp": 155209998,
    "dropphyadd": "121 5TH ST",
    "dropphycty": "ACOSTA",
    "dropphyst": "PA",
    "dropphyzpp": 155209998,
    "dropmaladd": "121 5TH ST",
    "dropmalcty": "ACOSTA",
    "dropmalst": "PA",
    "dropmalzpp": 155209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146299637,
    "dropsitcph": 8146299637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16892",
    "droptype": "D",
    "dropname": "ADAMSBURG",
    "dropdeladd": "184 MAIN ST",
    "dropdelcty": "ADAMSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156115001,
    "dropphyadd": "184 MAIN ST",
    "dropphycty": "ADAMSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156115001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156119998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245234582,
    "dropsitcph": 7245234582,
    "dropfax": 7245236261
  },
  {
    "dcode": "D",
    "dropkey": "PX16894",
    "droptype": "D",
    "dropname": "ADAMSTOWN",
    "dropdeladd": "128 W MAIN ST",
    "dropdelcty": "ADAMSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195019998,
    "dropphyadd": "128 W MAIN ST",
    "dropphycty": "ADAMSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195019998,
    "dropmaladd": "128 W MAIN ST",
    "dropmalcty": "ADAMSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195019998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174844224,
    "dropsitcph": 7174844224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16896",
    "droptype": "D",
    "dropname": "ADAMSVILLE",
    "dropdeladd": "3935 MAIN ST",
    "dropdelcty": "ADAMSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 161101001,
    "dropphyadd": "3935 MAIN ST",
    "dropphycty": "ADAMSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 161101001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 161109998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249323949,
    "dropsitcph": 7249323949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16897",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "7337 NATIONAL PIKE",
    "dropdelcty": "ADDISON",
    "dropdelst": "PA",
    "dropdelzpp": 154112167,
    "dropphyadd": "7337 NATIONAL PIKE",
    "dropphycty": "ADDISON",
    "dropphyst": "PA",
    "dropphyzpp": 154112167,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADDISON",
    "dropmalst": "PA",
    "dropmalzpp": 154119998,
    "dropsitphn": 4123597568,
    "dropsitlph": 8143955221,
    "dropsitcph": 8143955221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16898",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "593 REESEDALE RD",
    "dropdelcty": "ADRIAN",
    "dropdelst": "PA",
    "dropdelzpp": 162109800,
    "dropphyadd": "593 REESEDALE RD",
    "dropphycty": "ADRIAN",
    "dropphyst": "PA",
    "dropphyzpp": 162109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADRIAN",
    "dropmalst": "PA",
    "dropmalzpp": 162109998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245451912,
    "dropsitcph": 7245451912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16900",
    "droptype": "D",
    "dropname": "AIRVILLE",
    "dropdeladd": "3504 DELTA RD",
    "dropdelcty": "AIRVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173029998,
    "dropphyadd": "3504 DELTA RD",
    "dropphycty": "AIRVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173029998,
    "dropmaladd": "3504 DELTA RD",
    "dropmalcty": "AIRVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173029998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7178623849,
    "dropsitcph": 7178623849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16903",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "100 N 7TH ST",
    "dropdelcty": "AKRON",
    "dropdelst": "PA",
    "dropdelzpp": 175019998,
    "dropphyadd": "100 N 7TH ST",
    "dropphycty": "AKRON",
    "dropphyst": "PA",
    "dropphyzpp": 175019998,
    "dropmaladd": "100 N 7TH ST",
    "dropmalcty": "AKRON",
    "dropmalst": "PA",
    "dropmalzpp": 175019998,
    "dropsitphn": 7173968782,
    "dropsitlph": "",
    "dropsitcph": 7178595546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16907",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "35 E STATE ST",
    "dropdelcty": "ALBION",
    "dropdelst": "PA",
    "dropdelzpp": 164011100,
    "dropphyadd": "35 E STATE ST",
    "dropphycty": "ALBION",
    "dropphyst": "PA",
    "dropphyzpp": 164011100,
    "dropmaladd": "35 E STATE ST",
    "dropmalcty": "ALBION",
    "dropmalst": "PA",
    "dropmalzpp": 164011100,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147563211,
    "dropsitcph": 8147563211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16909",
    "droptype": "D",
    "dropname": "ALBRIGHTSVILLE",
    "dropdeladd": "7 PINE POINT DR STE 4",
    "dropdelcty": "ALBRIGHTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 182109998,
    "dropphyadd": "7 PINE POINT DR STE 4",
    "dropphycty": "ALBRIGHTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 182109998,
    "dropmaladd": "7 PINE POINT DR STE 4",
    "dropmalcty": "ALBRIGHTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 182109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707229493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16912",
    "droptype": "D",
    "dropname": "ALBURTIS",
    "dropdeladd": "302 S MAIN ST",
    "dropdelcty": "ALBURTIS",
    "dropdelst": "PA",
    "dropdelzpp": 180119900,
    "dropphyadd": "302 S MAIN ST",
    "dropphycty": "ALBURTIS",
    "dropphyst": "PA",
    "dropphyzpp": 180119900,
    "dropmaladd": "302 S MAIN ST",
    "dropmalcty": "ALBURTIS",
    "dropmalst": "PA",
    "dropmalzpp": 180119900,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6109665661,
    "dropfax": 6109664539
  },
  {
    "dcode": "D",
    "dropkey": "PX16919",
    "droptype": "D",
    "dropname": "ALEPPO",
    "dropdeladd": "1169 ALEPPO RD",
    "dropdelcty": "ALEPPO",
    "dropdelst": "PA",
    "dropdelzpp": 153101453,
    "dropphyadd": "1169 ALEPPO RD",
    "dropphycty": "ALEPPO",
    "dropphyst": "PA",
    "dropphyzpp": 153101453,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEPPO",
    "dropmalst": "PA",
    "dropmalzpp": 153109998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244285162,
    "dropsitcph": 7244285162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16922",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "703 CANAL ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "PA",
    "dropdelzpp": 166119998,
    "dropphyadd": "703 CANAL ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "PA",
    "dropphyzpp": 166119998,
    "dropmaladd": "703 CANAL ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "PA",
    "dropmalzpp": 166119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146694200,
    "dropsitcph": 8146694200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16927",
    "droptype": "D",
    "dropname": "ALIQUIPPA",
    "dropdeladd": "517 FRANKLIN AVE",
    "dropdelcty": "ALIQUIPPA",
    "dropdelst": "PA",
    "dropdelzpp": 150019998,
    "dropphyadd": "517 FRANKLIN AVE",
    "dropphycty": "ALIQUIPPA",
    "dropphyst": "PA",
    "dropphyzpp": 150019998,
    "dropmaladd": "517 FRANKLIN AVE",
    "dropmalcty": "ALIQUIPPA",
    "dropmalst": "PA",
    "dropmalzpp": 150019998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243780692,
    "dropsitcph": 7243780692,
    "dropfax": 7243783381
  },
  {
    "dcode": "D",
    "dropkey": "PX16933",
    "droptype": "D",
    "dropname": "ALLENPORT",
    "dropdeladd": "1908 MAIN ST",
    "dropdelcty": "ALLENPORT",
    "dropdelst": "PA",
    "dropdelzpp": 154121001,
    "dropphyadd": "1908 MAIN ST",
    "dropphycty": "ALLENPORT",
    "dropphyst": "PA",
    "dropphyzpp": 154121001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLENPORT",
    "dropmalst": "PA",
    "dropmalzpp": 154129998,
    "dropsitphn": 4123597457,
    "dropsitlph": 7243268335,
    "dropsitcph": 7243268335,
    "dropfax": 7243268335
  },
  {
    "dcode": "D",
    "dropkey": "PX16935",
    "droptype": "D",
    "dropname": "ALLENSVILLE",
    "dropdeladd": "173 W MAIN ST",
    "dropdelcty": "ALLENSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170029998,
    "dropphyadd": "173 W MAIN ST",
    "dropphycty": "ALLENSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170029998,
    "dropmaladd": "173 W MAIN ST",
    "dropmalcty": "ALLENSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170029998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174836411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16937",
    "droptype": "D",
    "dropname": "ALLENTOWN",
    "dropdeladd": "442 HAMILTON ST OFC",
    "dropdelcty": "ALLENTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 181019998,
    "dropphyadd": "442 HAMILTON ST OFC",
    "dropphycty": "ALLENTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 181019998,
    "dropmaladd": "1000 POSTAL RD SIDE",
    "dropmalcty": "ALLENTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 181098900,
    "dropsitphn": 6102665314,
    "dropsitlph": 6102665308,
    "dropsitcph": 6108218450,
    "dropfax": 6108215963
  },
  {
    "dcode": "D",
    "dropkey": "PX16939",
    "droptype": "D",
    "dropname": "ALLENWOOD",
    "dropdeladd": "16945 US ROUTE 15",
    "dropdelcty": "ALLENWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 178109998,
    "dropphyadd": "16945 US ROUTE 15",
    "dropphycty": "ALLENWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 178109998,
    "dropmaladd": "16945 US ROUTE 15",
    "dropmalcty": "ALLENWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 178109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5704646071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16940",
    "droptype": "D",
    "dropname": "ALLISON",
    "dropdeladd": "575 ALLISON AVE",
    "dropdelcty": "ALLISON",
    "dropdelst": "PA",
    "dropdelzpp": 154139614,
    "dropphyadd": "575 ALLISON AVE",
    "dropphycty": "ALLISON",
    "dropphyst": "PA",
    "dropphyzpp": 154139614,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLISON",
    "dropmalst": "PA",
    "dropmalzpp": 154139998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247854990,
    "dropsitcph": 7247854990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16942",
    "droptype": "D",
    "dropname": "ALLISON PARK",
    "dropdeladd": "4746 WILLIAM FLYNN HWY",
    "dropdelcty": "ALLISON PARK",
    "dropdelst": "PA",
    "dropdelzpp": 151019998,
    "dropphyadd": "4746 WILLIAM FLYNN HWY",
    "dropphycty": "ALLISON PARK",
    "dropphyst": "PA",
    "dropphyzpp": 151019998,
    "dropmaladd": "4746 WILLIAM FLYNN HWY",
    "dropmalcty": "ALLISON PARK",
    "dropmalst": "PA",
    "dropmalzpp": 151019998,
    "dropsitphn": 4123597960,
    "dropsitlph": 4124865729,
    "dropsitcph": 4124865729,
    "dropfax": 4124863715
  },
  {
    "dcode": "D",
    "dropkey": "PX16944",
    "droptype": "D",
    "dropname": "ALLPORT",
    "dropdeladd": "5695 MORRISDALE ALLPORT HWY",
    "dropdelcty": "ALLPORT",
    "dropdelst": "PA",
    "dropdelzpp": 168219998,
    "dropphyadd": "5695 MORRISDALE ALLPORT HWY",
    "dropphycty": "ALLPORT",
    "dropphyst": "PA",
    "dropphyzpp": 168219998,
    "dropmaladd": "5695 MORRISDALE ALLPORT HWY",
    "dropmalcty": "ALLPORT",
    "dropmalst": "PA",
    "dropmalzpp": 168219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143456490,
    "dropsitcph": 8143456490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16954",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "1201 11TH AVE",
    "dropdelcty": "ALTOONA",
    "dropdelst": "PA",
    "dropdelzpp": 166019998,
    "dropphyadd": "1201 11TH AVE",
    "dropphycty": "ALTOONA",
    "dropphyst": "PA",
    "dropphyzpp": 166019998,
    "dropmaladd": "1201 11TH AVE",
    "dropmalcty": "ALTOONA",
    "dropmalst": "PA",
    "dropmalzpp": 166019998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8149414720,
    "dropsitcph": 8149414720,
    "dropfax": 8149414715
  },
  {
    "dcode": "D",
    "dropkey": "PX16955",
    "droptype": "D",
    "dropname": "ALUM BANK",
    "dropdeladd": "113 FOLLMAR LN",
    "dropdelcty": "ALUM BANK",
    "dropdelst": "PA",
    "dropdelzpp": 155219998,
    "dropphyadd": "113 FOLLMAR LN",
    "dropphycty": "ALUM BANK",
    "dropphyst": "PA",
    "dropphyzpp": 155219998,
    "dropmaladd": "113 FOLLMAR LN",
    "dropmalcty": "ALUM BANK",
    "dropmalst": "PA",
    "dropmalzpp": 155219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148394511,
    "dropsitcph": 8148394511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16956",
    "droptype": "D",
    "dropname": "ALVERDA",
    "dropdeladd": "11089 ROUTE 553 HWY",
    "dropdelcty": "ALVERDA",
    "dropdelst": "PA",
    "dropdelzpp": 157109998,
    "dropphyadd": "11089 ROUTE 553 HWY",
    "dropphycty": "ALVERDA",
    "dropphyst": "PA",
    "dropphyzpp": 157109998,
    "dropmaladd": "11089 ROUTE 553 HWY",
    "dropmalcty": "ALVERDA",
    "dropmalst": "PA",
    "dropmalzpp": 157109998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149484373,
    "dropsitcph": 8149484373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16957",
    "droptype": "D",
    "dropname": "ALVERTON",
    "dropdeladd": "459 RUFFSDALE ALVERTON RD",
    "dropdelcty": "ALVERTON",
    "dropdelst": "PA",
    "dropdelzpp": 156121001,
    "dropphyadd": "459 RUFFSDALE ALVERTON RD",
    "dropphycty": "ALVERTON",
    "dropphyst": "PA",
    "dropphyzpp": 156121001,
    "dropmaladd": "459 RUFFSDALE ALVERTON RD",
    "dropmalcty": "ALVERTON",
    "dropmalst": "PA",
    "dropmalzpp": 156121001,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248874008,
    "dropsitcph": 7248874008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16959",
    "droptype": "D",
    "dropname": "AMBERSON",
    "dropdeladd": "19362 AMBERSON RD",
    "dropdelcty": "AMBERSON",
    "dropdelst": "PA",
    "dropdelzpp": 172109998,
    "dropphyadd": "19362 AMBERSON RD",
    "dropphycty": "AMBERSON",
    "dropphyst": "PA",
    "dropphyzpp": 172109998,
    "dropmaladd": "19362 AMBERSON RD",
    "dropmalcty": "AMBERSON",
    "dropmalst": "PA",
    "dropmalzpp": 172109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173492792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16960",
    "droptype": "D",
    "dropname": "AMBLER",
    "dropdeladd": "200 W BUTLER AVE",
    "dropdelcty": "AMBLER",
    "dropdelst": "PA",
    "dropdelzpp": 190029998,
    "dropphyadd": "200 W BUTLER AVE",
    "dropphycty": "AMBLER",
    "dropphyst": "PA",
    "dropphyzpp": 190029998,
    "dropmaladd": "200 W BUTLER AVE",
    "dropmalcty": "AMBLER",
    "dropmalst": "PA",
    "dropmalzpp": 190029998,
    "dropsitphn": 2156465982,
    "dropsitlph": 2156465982,
    "dropsitcph": 2156460378,
    "dropfax": 2156464577
  },
  {
    "dcode": "D",
    "dropkey": "PX16961",
    "droptype": "D",
    "dropname": "AMBRIDGE",
    "dropdeladd": "1020 MERCHANT ST",
    "dropdelcty": "AMBRIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 150039998,
    "dropphyadd": "1020 MERCHANT ST",
    "dropphycty": "AMBRIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 150039998,
    "dropmaladd": "1020 MERCHANT ST",
    "dropmalcty": "AMBRIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 150039998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242662891,
    "dropsitcph": 7242662891,
    "dropfax": 7242661395
  },
  {
    "dcode": "D",
    "dropkey": "PX16963",
    "droptype": "D",
    "dropname": "AMITY",
    "dropdeladd": "630 AMITY RIDGE RD",
    "dropdelcty": "AMITY",
    "dropdelst": "PA",
    "dropdelzpp": 153111344,
    "dropphyadd": "630 AMITY RIDGE RD",
    "dropphycty": "AMITY",
    "dropphyst": "PA",
    "dropphyzpp": 153111344,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMITY",
    "dropmalst": "PA",
    "dropmalzpp": 153119998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242287283,
    "dropsitcph": 7242287283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16965",
    "droptype": "D",
    "dropname": "ANALOMINK",
    "dropdeladd": "1635 CHERRY LANE RD",
    "dropdelcty": "ANALOMINK",
    "dropdelst": "PA",
    "dropdelzpp": 183209998,
    "dropphyadd": "1635 CHERRY LANE RD",
    "dropphycty": "ANALOMINK",
    "dropphyst": "PA",
    "dropphyzpp": 183209998,
    "dropmaladd": "1635 CHERRY LANE RD",
    "dropmalcty": "ANALOMINK",
    "dropmalst": "PA",
    "dropmalzpp": 183209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704242171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16971",
    "droptype": "D",
    "dropname": "ANDREAS",
    "dropdeladd": "820 LIZARD CREEK RD",
    "dropdelcty": "ANDREAS",
    "dropdelst": "PA",
    "dropdelzpp": 182119998,
    "dropphyadd": "820 LIZARD CREEK RD",
    "dropphycty": "ANDREAS",
    "dropphyst": "PA",
    "dropphyzpp": 182119998,
    "dropmaladd": "820 LIZARD CREEK RD",
    "dropmalcty": "ANDREAS",
    "dropmalst": "PA",
    "dropmalzpp": 182119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703865876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16974",
    "droptype": "D",
    "dropname": "ANITA",
    "dropdeladd": "222 MAIN ST",
    "dropdelcty": "ANITA",
    "dropdelst": "PA",
    "dropdelzpp": 157119998,
    "dropphyadd": "222 MAIN ST",
    "dropphycty": "ANITA",
    "dropphyst": "PA",
    "dropphyzpp": 157119998,
    "dropmaladd": "222 MAIN ST",
    "dropmalcty": "ANITA",
    "dropmalst": "PA",
    "dropmalzpp": 157119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149388124,
    "dropsitcph": 8149388124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16975",
    "droptype": "D",
    "dropname": "ANNVILLE",
    "dropdeladd": "51 N LANCASTER ST",
    "dropdelcty": "ANNVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170039998,
    "dropphyadd": "51 N LANCASTER ST",
    "dropphycty": "ANNVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170039998,
    "dropmaladd": "51 N LANCASTER ST",
    "dropmalcty": "ANNVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170039998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178674821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16977",
    "droptype": "D",
    "dropname": "ANTES FORT",
    "dropdeladd": "14 THIRD ST",
    "dropdelcty": "ANTES FORT",
    "dropdelst": "PA",
    "dropdelzpp": 177209998,
    "dropphyadd": "14 THIRD ST",
    "dropphycty": "ANTES FORT",
    "dropphyst": "PA",
    "dropphyzpp": 177209998,
    "dropmaladd": "14 THIRD ST",
    "dropmalcty": "ANTES FORT",
    "dropmalst": "PA",
    "dropmalzpp": 177209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703983018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16982",
    "droptype": "D",
    "dropname": "APOLLO",
    "dropdeladd": "118 NORTH PLZ",
    "dropdelcty": "APOLLO",
    "dropdelst": "PA",
    "dropdelzpp": 156139998,
    "dropphyadd": "118 NORTH PLZ",
    "dropphycty": "APOLLO",
    "dropphyst": "PA",
    "dropphyzpp": 156139998,
    "dropmaladd": "118 NORTH PLZ",
    "dropmalcty": "APOLLO",
    "dropmalst": "PA",
    "dropmalzpp": 156139998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244784707,
    "dropsitcph": 7244784707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16984",
    "droptype": "D",
    "dropname": "AQUASHICOLA",
    "dropdeladd": "100 LITTLE GAP RD",
    "dropdelcty": "AQUASHICOLA",
    "dropdelst": "PA",
    "dropdelzpp": 180129998,
    "dropphyadd": "100 LITTLE GAP RD",
    "dropphycty": "AQUASHICOLA",
    "dropphyst": "PA",
    "dropphyzpp": 180129998,
    "dropmaladd": "100 LITTLE GAP RD",
    "dropmalcty": "AQUASHICOLA",
    "dropmalst": "PA",
    "dropmalzpp": 180129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108267104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16985",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "21832 ROUTE 286 HWY E",
    "dropdelcty": "ARCADIA",
    "dropdelst": "PA",
    "dropdelzpp": 157129998,
    "dropphyadd": "21832 ROUTE 286 HWY E",
    "dropphycty": "ARCADIA",
    "dropphyst": "PA",
    "dropphyzpp": 157129998,
    "dropmaladd": "21832 ROUTE 286 HWY E",
    "dropmalcty": "ARCADIA",
    "dropmalst": "PA",
    "dropmalzpp": 157129998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148457669,
    "dropsitcph": 8148457669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16988",
    "droptype": "D",
    "dropname": "ARCHBALD",
    "dropdeladd": "1 KENNEDY DR",
    "dropdelcty": "ARCHBALD",
    "dropdelst": "PA",
    "dropdelzpp": 184039998,
    "dropphyadd": "1 KENNEDY DR",
    "dropphycty": "ARCHBALD",
    "dropphyst": "PA",
    "dropphyzpp": 184039998,
    "dropmaladd": "1 KENNEDY DR",
    "dropmalcty": "ARCHBALD",
    "dropmalst": "PA",
    "dropmalzpp": 184039998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708761640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16989",
    "droptype": "D",
    "dropname": "ARCOLA",
    "dropdeladd": "52 W THIRD AVE",
    "dropdelcty": "COLLEGEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194263618,
    "dropphyadd": "52 W THIRD AVE",
    "dropphycty": "COLLEGEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194263618,
    "dropmaladd": "52 W THIRD AVE",
    "dropmalcty": "COLLEGEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194263618,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104894311,
    "dropsitcph": 6104894311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16990",
    "droptype": "D",
    "dropname": "ARDARA",
    "dropdeladd": "12889 STATE ROUTE 993",
    "dropdelcty": "ARDARA",
    "dropdelst": "PA",
    "dropdelzpp": 156159736,
    "dropphyadd": "12889 STATE ROUTE 993",
    "dropphycty": "ARDARA",
    "dropphyst": "PA",
    "dropphyzpp": 156159736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARDARA",
    "dropmalst": "PA",
    "dropmalzpp": 156159998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248636790,
    "dropsitcph": 7248636790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16991",
    "droptype": "D",
    "dropname": "ARDMORE",
    "dropdeladd": "30 ARDMORE AVE",
    "dropdelcty": "ARDMORE",
    "dropdelst": "PA",
    "dropdelzpp": 190039998,
    "dropphyadd": "30 ARDMORE AVE",
    "dropphycty": "ARDMORE",
    "dropphyst": "PA",
    "dropphyzpp": 190039998,
    "dropmaladd": "30 ARDMORE AVE",
    "dropmalcty": "ARDMORE",
    "dropmalst": "PA",
    "dropmalzpp": 190039998,
    "dropsitphn": 6106495810,
    "dropsitlph": 6106495810,
    "dropsitcph": 6106495615,
    "dropfax": 6106428470
  },
  {
    "dcode": "D",
    "dropkey": "PX16993",
    "droptype": "D",
    "dropname": "ARENDTSVILLE",
    "dropdeladd": "26 S HIGH ST",
    "dropdelcty": "ARENDTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173039998,
    "dropphyadd": "26 S HIGH ST",
    "dropphycty": "ARENDTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173039998,
    "dropmaladd": "26 S HIGH ST",
    "dropmalcty": "ARENDTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173039998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176777083,
    "dropsitcph": 7176777083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16996",
    "droptype": "D",
    "dropname": "ARISTES",
    "dropdeladd": "90 S LEIBY ST",
    "dropdelcty": "ARISTES",
    "dropdelst": "PA",
    "dropdelzpp": 179209998,
    "dropphyadd": "90 S LEIBY ST",
    "dropphycty": "ARISTES",
    "dropphyst": "PA",
    "dropphyzpp": 179209998,
    "dropmaladd": "90 S LEIBY ST",
    "dropmalcty": "ARISTES",
    "dropmalst": "PA",
    "dropmalzpp": 179209998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708751641,
    "dropsitcph": 5708751641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16997",
    "droptype": "D",
    "dropname": "ARMAGH",
    "dropdeladd": "35 E PHILADELPHIA ST",
    "dropdelcty": "ARMAGH",
    "dropdelst": "PA",
    "dropdelzpp": 159209998,
    "dropphyadd": "35 E PHILADELPHIA ST",
    "dropphycty": "ARMAGH",
    "dropphyst": "PA",
    "dropphyzpp": 159209998,
    "dropmaladd": "35 E PHILADELPHIA ST",
    "dropmalcty": "ARMAGH",
    "dropmalst": "PA",
    "dropmalzpp": 159209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144465922,
    "dropsitcph": 8144465922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX16999",
    "droptype": "D",
    "dropname": "ARMBRUST",
    "dropdeladd": "7855 STATE ROUTE 819",
    "dropdelcty": "ARMBRUST",
    "dropdelst": "PA",
    "dropdelzpp": 156161000,
    "dropphyadd": "7855 STATE ROUTE 819",
    "dropphycty": "ARMBRUST",
    "dropphyst": "PA",
    "dropphyzpp": 156161000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARMBRUST",
    "dropmalst": "PA",
    "dropmalzpp": 156169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249256424,
    "dropsitcph": 7249256424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17002",
    "droptype": "D",
    "dropname": "ARNOT",
    "dropdeladd": "834 ARNOT RD",
    "dropdelcty": "ARNOT",
    "dropdelst": "PA",
    "dropdelzpp": 169119998,
    "dropphyadd": "834 ARNOT RD",
    "dropphycty": "ARNOT",
    "dropphyst": "PA",
    "dropphyzpp": 169119998,
    "dropmaladd": "834 ARNOT RD",
    "dropmalcty": "ARNOT",
    "dropmalst": "PA",
    "dropmalzpp": 169119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706382268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17004",
    "droptype": "D",
    "dropname": "ARONA",
    "dropdeladd": "2128 MAIN ST",
    "dropdelcty": "ARONA",
    "dropdelst": "PA",
    "dropdelzpp": 156171001,
    "dropphyadd": "2128 MAIN ST",
    "dropphycty": "ARONA",
    "dropphyst": "PA",
    "dropphyzpp": 156171001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARONA",
    "dropmalst": "PA",
    "dropmalzpp": 156179998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244467900,
    "dropsitcph": 7244467900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17010",
    "droptype": "D",
    "dropname": "ASHFIELD",
    "dropdeladd": "403 BLUE MOUNTAIN RD",
    "dropdelcty": "ASHFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 182129998,
    "dropphyadd": "403 BLUE MOUNTAIN RD",
    "dropphycty": "ASHFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 182129998,
    "dropmaladd": "403 BLUE MOUNTAIN RD",
    "dropmalcty": "ASHFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 182129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 6103775505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17012",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "901 RACE ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "PA",
    "dropdelzpp": 179219998,
    "dropphyadd": "901 RACE ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "PA",
    "dropphyzpp": 179219998,
    "dropmaladd": "901 RACE ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "PA",
    "dropmalzpp": 179219998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708753290,
    "dropsitcph": 5708753290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17015",
    "droptype": "D",
    "dropname": "ASHVILLE",
    "dropdeladd": "1657 LIBERTY ST",
    "dropdelcty": "ASHVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166139998,
    "dropphyadd": "1657 LIBERTY ST",
    "dropphycty": "ASHVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166139998,
    "dropmaladd": "1657 LIBERTY ST",
    "dropmalcty": "ASHVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166139998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149440160,
    "dropsitcph": 8149440160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17017",
    "droptype": "D",
    "dropname": "ASPERS",
    "dropdeladd": "420 ASPERS BENDERSVILLE RD",
    "dropdelcty": "ASPERS",
    "dropdelst": "PA",
    "dropdelzpp": 173049998,
    "dropphyadd": "420 ASPERS BENDERSVILLE RD",
    "dropphycty": "ASPERS",
    "dropphyst": "PA",
    "dropphyzpp": 173049998,
    "dropmaladd": "420 ASPERS BENDERSVILLE RD",
    "dropmalcty": "ASPERS",
    "dropmalst": "PA",
    "dropmalzpp": 173049998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176777541,
    "dropsitcph": 7176777541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17020",
    "droptype": "D",
    "dropname": "ATGLEN",
    "dropdeladd": "316 VALLEY AVE",
    "dropdelcty": "ATGLEN",
    "dropdelst": "PA",
    "dropdelzpp": 193109998,
    "dropphyadd": "316 VALLEY AVE",
    "dropphycty": "ATGLEN",
    "dropphyst": "PA",
    "dropphyzpp": 193109998,
    "dropmaladd": "316 VALLEY AVE",
    "dropmalcty": "ATGLEN",
    "dropmalst": "PA",
    "dropmalzpp": 193109998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6105935497,
    "dropsitcph": 6105935497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17021",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "301 S MAIN ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "PA",
    "dropdelzpp": 188109998,
    "dropphyadd": "301 S MAIN ST",
    "dropphycty": "ATHENS",
    "dropphyst": "PA",
    "dropphyzpp": 188109998,
    "dropmaladd": "301 S MAIN ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "PA",
    "dropmalzpp": 188109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708882252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17026",
    "droptype": "D",
    "dropname": "ATLANTIC",
    "dropdeladd": "3498 ATLANTIC LAKE RD",
    "dropdelcty": "ATLANTIC",
    "dropdelst": "PA",
    "dropdelzpp": 161119800,
    "dropphyadd": "3498 ATLANTIC LAKE RD",
    "dropphycty": "ATLANTIC",
    "dropphyst": "PA",
    "dropphyzpp": 161119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATLANTIC",
    "dropmalst": "PA",
    "dropmalzpp": 161119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143822007,
    "dropsitcph": 8143822007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17028",
    "droptype": "D",
    "dropname": "ATLASBURG",
    "dropdeladd": "1620 SMITH TWP STATE RD",
    "dropdelcty": "ATLASBURG",
    "dropdelst": "PA",
    "dropdelzpp": 150041001,
    "dropphyadd": "1620 SMITH TWP STATE RD",
    "dropphycty": "ATLASBURG",
    "dropphyst": "PA",
    "dropphyzpp": 150041001,
    "dropmaladd": "1620 SMITH TWP STATE RD",
    "dropmalcty": "ATLASBURG",
    "dropmalst": "PA",
    "dropmalzpp": 150041001,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249472562,
    "dropsitcph": 7249472562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17029",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "425 MARKET ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "PA",
    "dropdelzpp": 179229998,
    "dropphyadd": "425 MARKET ST",
    "dropphycty": "AUBURN",
    "dropphyst": "PA",
    "dropphyzpp": 179229998,
    "dropmaladd": "425 MARKET ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "PA",
    "dropmalzpp": 179229998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5707543731,
    "dropsitcph": 5707543731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17037",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "26 MAIN ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "PA",
    "dropdelzpp": 167209800,
    "dropphyadd": "26 MAIN ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "PA",
    "dropphyzpp": 167209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTIN",
    "dropmalst": "PA",
    "dropmalzpp": 167209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146478694,
    "dropsitcph": 8146478694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17041",
    "droptype": "D",
    "dropname": "AVELLA",
    "dropdeladd": "17 CAMPBELL ST",
    "dropdelcty": "AVELLA",
    "dropdelst": "PA",
    "dropdelzpp": 153122763,
    "dropphyadd": "17 CAMPBELL ST",
    "dropphycty": "AVELLA",
    "dropphyst": "PA",
    "dropphyzpp": 153122763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVELLA",
    "dropmalst": "PA",
    "dropmalzpp": 153129998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242099009,
    "dropsitcph": 7242099009,
    "dropfax": 7242099011
  },
  {
    "dcode": "D",
    "dropkey": "PX17042",
    "droptype": "D",
    "dropname": "AVIS",
    "dropdeladd": "14 W CENTRAL AVE",
    "dropdelcty": "AVIS",
    "dropdelst": "PA",
    "dropdelzpp": 177219998,
    "dropphyadd": "14 W CENTRAL AVE",
    "dropphycty": "AVIS",
    "dropphyst": "PA",
    "dropphyzpp": 177219998,
    "dropmaladd": "14 W CENTRAL AVE",
    "dropmalcty": "AVIS",
    "dropmalst": "PA",
    "dropmalzpp": 177219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707533100,
    "dropfax": 5704257003
  },
  {
    "dcode": "D",
    "dropkey": "PX17046",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "112 PENNSYLVANIA AVE",
    "dropdelcty": "AVONDALE",
    "dropdelst": "PA",
    "dropdelzpp": 193119998,
    "dropphyadd": "112 PENNSYLVANIA AVE",
    "dropphycty": "AVONDALE",
    "dropphyst": "PA",
    "dropphyzpp": 193119998,
    "dropmaladd": "112 PENNSYLVANIA AVE",
    "dropmalcty": "AVONDALE",
    "dropmalst": "PA",
    "dropmalzpp": 193119998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102680873,
    "dropsitcph": 6102680873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17047",
    "droptype": "D",
    "dropname": "AVONMORE",
    "dropdeladd": "516 WESTMORELAND AVE",
    "dropdelcty": "AVONMORE",
    "dropdelst": "PA",
    "dropdelzpp": 156189998,
    "dropphyadd": "516 WESTMORELAND AVE",
    "dropphycty": "AVONMORE",
    "dropphyst": "PA",
    "dropphyzpp": 156189998,
    "dropmaladd": "516 WESTMORELAND AVE",
    "dropmalcty": "AVONMORE",
    "dropmalst": "PA",
    "dropmalzpp": 156189998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246974324,
    "dropsitcph": 7246974324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17052",
    "droptype": "D",
    "dropname": "BADEN",
    "dropdeladd": "398 STATE ST",
    "dropdelcty": "BADEN",
    "dropdelst": "PA",
    "dropdelzpp": 150059998,
    "dropphyadd": "398 STATE ST",
    "dropphycty": "BADEN",
    "dropphyst": "PA",
    "dropphyzpp": 150059998,
    "dropmaladd": "398 STATE ST",
    "dropmalcty": "BADEN",
    "dropmalst": "PA",
    "dropmalzpp": 150059998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248692145,
    "dropsitcph": 7248692145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17056",
    "droptype": "D",
    "dropname": "BAINBRIDGE",
    "dropdeladd": "205 N 2ND ST",
    "dropdelcty": "BAINBRIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 175029998,
    "dropphyadd": "205 N 2ND ST",
    "dropphycty": "BAINBRIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 175029998,
    "dropmaladd": "205 N 2ND ST",
    "dropmalcty": "BAINBRIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 175029998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174261085,
    "dropsitcph": 7174261085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17057",
    "droptype": "D",
    "dropname": "BAIRDFORD",
    "dropdeladd": "453 BAIRDFORD RD",
    "dropdelcty": "BAIRDFORD",
    "dropdelst": "PA",
    "dropdelzpp": 150061001,
    "dropphyadd": "453 BAIRDFORD RD",
    "dropphycty": "BAIRDFORD",
    "dropphyst": "PA",
    "dropphyzpp": 150061001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAIRDFORD",
    "dropmalst": "PA",
    "dropmalzpp": 150069998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242652671,
    "dropsitcph": 7242652671,
    "dropfax": 7242650058
  },
  {
    "dcode": "D",
    "dropkey": "PX17059",
    "droptype": "D",
    "dropname": "BAKERSTOWN",
    "dropdeladd": "37 WINWOOD PLZ",
    "dropdelcty": "BAKERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 150079800,
    "dropphyadd": "37 WINWOOD PLZ",
    "dropphycty": "BAKERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 150079800,
    "dropmaladd": "37 WINWOOD PLZ",
    "dropmalcty": "BAKERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 150079800,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244432280,
    "dropsitcph": 7244432280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17061",
    "droptype": "D",
    "dropname": "BALA CYNWYD",
    "dropdeladd": "1 UNION AVE",
    "dropdelcty": "BALA CYNWYD",
    "dropdelst": "PA",
    "dropdelzpp": 190049998,
    "dropphyadd": "1 UNION AVE",
    "dropphycty": "BALA CYNWYD",
    "dropphyst": "PA",
    "dropphyzpp": 190049998,
    "dropmaladd": "1 UNION AVE",
    "dropmalcty": "BALA CYNWYD",
    "dropmalst": "PA",
    "dropmalzpp": 190049998,
    "dropsitphn": 2156640431,
    "dropsitlph": 6106640431,
    "dropsitcph": 6106678035,
    "dropfax": 6106642276
  },
  {
    "dcode": "D",
    "dropkey": "PX17066",
    "droptype": "D",
    "dropname": "BALLY",
    "dropdeladd": "9 S 7TH ST",
    "dropdelcty": "BALLY",
    "dropdelst": "PA",
    "dropdelzpp": 195039998,
    "dropphyadd": "9 S 7TH ST",
    "dropphycty": "BALLY",
    "dropphyst": "PA",
    "dropphyzpp": 195039998,
    "dropmaladd": "9 S 7TH ST",
    "dropmalcty": "BALLY",
    "dropmalst": "PA",
    "dropmalzpp": 195039998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6108452377,
    "dropsitcph": 6108452377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17068",
    "droptype": "D",
    "dropname": "BANGOR",
    "dropdeladd": "212 S 1ST ST",
    "dropdelcty": "BANGOR",
    "dropdelst": "PA",
    "dropdelzpp": 180132640,
    "dropphyadd": "212 S 1ST ST",
    "dropphycty": "BANGOR",
    "dropphyst": "PA",
    "dropphyzpp": 180132640,
    "dropmaladd": "212 S 1ST ST",
    "dropmalcty": "BANGOR",
    "dropmalst": "PA",
    "dropmalzpp": 180132640,
    "dropsitphn": 6105883495,
    "dropsitlph": 6108823244,
    "dropsitcph": 6105883495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17076",
    "droptype": "D",
    "dropname": "NORTHERN CAMBRIA",
    "dropdeladd": "4310 CRAWFORD AVE",
    "dropdelcty": "NORTHERN CAMBRIA",
    "dropdelst": "PA",
    "dropdelzpp": 157149998,
    "dropphyadd": "4310 CRAWFORD AVE",
    "dropphycty": "NORTHERN CAMBRIA",
    "dropphyst": "PA",
    "dropphyzpp": 157149998,
    "dropmaladd": "4310 CRAWFORD AVE",
    "dropmalcty": "NORTHERN CAMBRIA",
    "dropmalst": "PA",
    "dropmalzpp": 157149998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149488500,
    "dropsitcph": 8149488500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17078",
    "droptype": "D",
    "dropname": "BARNESVILLE",
    "dropdeladd": "2 GRIER AVE OFC",
    "dropdelcty": "BARNESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 182149998,
    "dropphyadd": "2 GRIER AVE OFC",
    "dropphycty": "BARNESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 182149998,
    "dropmaladd": "2 GRIER AVE OFC",
    "dropmalcty": "BARNESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 182149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704672535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17088",
    "droptype": "D",
    "dropname": "BART",
    "dropdeladd": "1093 GEORGETOWN RD",
    "dropdelcty": "BART",
    "dropdelst": "PA",
    "dropdelzpp": 175039998,
    "dropphyadd": "1093 GEORGETOWN RD",
    "dropphycty": "BART",
    "dropphyst": "PA",
    "dropphyzpp": 175039998,
    "dropmaladd": "1093 GEORGETOWN RD",
    "dropmalcty": "BART",
    "dropmalst": "PA",
    "dropmalzpp": 175039998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177862208,
    "dropsitcph": 7176135039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17089",
    "droptype": "D",
    "dropname": "BARTO",
    "dropdeladd": "2245 OLD ROUTE 100",
    "dropdelcty": "BARTO",
    "dropdelst": "PA",
    "dropdelzpp": 195049998,
    "dropphyadd": "2245 OLD ROUTE 100",
    "dropphycty": "BARTO",
    "dropphyst": "PA",
    "dropphyzpp": 195049998,
    "dropmaladd": "2245 OLD ROUTE 100",
    "dropmalcty": "BARTO",
    "dropmalst": "PA",
    "dropmalzpp": 195049998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6108457544,
    "dropsitcph": 6108457544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17090",
    "droptype": "D",
    "dropname": "BARTONSVILLE",
    "dropdeladd": "3400 ROUTE 611 STE 102",
    "dropdelcty": "BARTONSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 183219998,
    "dropphyadd": "3400 ROUTE 611 STE 102",
    "dropphycty": "BARTONSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 183219998,
    "dropmaladd": "3400 ROUTE 611 STE 102",
    "dropmalcty": "BARTONSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 183219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706292040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17096",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "175 N CHESTNUT ST",
    "dropdelcty": "BATH",
    "dropdelst": "PA",
    "dropdelzpp": 180149998,
    "dropphyadd": "175 N CHESTNUT ST",
    "dropphycty": "BATH",
    "dropphyst": "PA",
    "dropphyzpp": 180149998,
    "dropmaladd": "175 N CHESTNUT ST",
    "dropmalcty": "BATH",
    "dropmalst": "PA",
    "dropmalzpp": 180149998,
    "dropsitphn": 6108370411,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108370411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17099",
    "droptype": "D",
    "dropname": "BAUSMAN",
    "dropdeladd": "220 ROSEDALE AVE",
    "dropdelcty": "BAUSMAN",
    "dropdelst": "PA",
    "dropdelzpp": 175049998,
    "dropphyadd": "220 ROSEDALE AVE",
    "dropphycty": "BAUSMAN",
    "dropphyst": "PA",
    "dropphyzpp": 175049998,
    "dropmaladd": "220 ROSEDALE AVE",
    "dropmalcty": "BAUSMAN",
    "dropmalst": "PA",
    "dropmalzpp": 175049998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173976740,
    "dropsitcph": 7173976740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17101",
    "droptype": "D",
    "dropname": "BEACH HAVEN",
    "dropdeladd": "207 MAIN ST",
    "dropdelcty": "BEACH HAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 186019998,
    "dropphyadd": "207 MAIN ST",
    "dropphycty": "BEACH HAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 186019998,
    "dropmaladd": "207 MAIN ST",
    "dropmalcty": "BEACH HAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 186019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707527733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17103",
    "droptype": "D",
    "dropname": "BEACH LAKE",
    "dropdeladd": "1015 BEACH LAKE HWY",
    "dropdelcty": "BEACH LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 184059998,
    "dropphyadd": "1015 BEACH LAKE HWY",
    "dropphycty": "BEACH LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 184059998,
    "dropmaladd": "1015 BEACH LAKE HWY",
    "dropmalcty": "BEACH LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 184059998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7179695140,
    "dropsitcph": 5707297185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17106",
    "droptype": "D",
    "dropname": "BEALLSVILLE",
    "dropdeladd": "82B SOUTH ST",
    "dropdelcty": "BEALLSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153131001,
    "dropphyadd": "82B SOUTH ST",
    "dropphycty": "BEALLSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153131001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEALLSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153139998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246325630,
    "dropsitcph": 7246325630,
    "dropfax": 7246326618
  },
  {
    "dcode": "D",
    "dropkey": "PX17119",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "777 CORPORATION ST",
    "dropdelcty": "BEAVER",
    "dropdelst": "PA",
    "dropdelzpp": 150099998,
    "dropphyadd": "777 CORPORATION ST",
    "dropphycty": "BEAVER",
    "dropphyst": "PA",
    "dropphyzpp": 150099998,
    "dropmaladd": "777 CORPORATION ST",
    "dropmalcty": "BEAVER",
    "dropmalst": "PA",
    "dropmalzpp": 150099998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247754068,
    "dropsitcph": 7247754068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17122",
    "droptype": "D",
    "dropname": "BEAVER FALLS",
    "dropdeladd": "720 11TH ST",
    "dropdelcty": "BEAVER FALLS",
    "dropdelst": "PA",
    "dropdelzpp": 150104499,
    "dropphyadd": "720 11TH ST",
    "dropphycty": "BEAVER FALLS",
    "dropphyst": "PA",
    "dropphyzpp": 150104499,
    "dropmaladd": "720 11TH ST",
    "dropmalcty": "BEAVER FALLS",
    "dropmalst": "PA",
    "dropmalzpp": 150104499,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248460970,
    "dropsitcph": 7248460970,
    "dropfax": 7248433659
  },
  {
    "dcode": "D",
    "dropkey": "PX17126",
    "droptype": "D",
    "dropname": "BEAVER MEADOWS",
    "dropdeladd": "2 BROAD ST",
    "dropdelcty": "BEAVER MEADOWS",
    "dropdelst": "PA",
    "dropdelzpp": 182169998,
    "dropphyadd": "2 BROAD ST",
    "dropphycty": "BEAVER MEADOWS",
    "dropphyst": "PA",
    "dropphyzpp": 182169998,
    "dropmaladd": "2 BROAD ST",
    "dropmalcty": "BEAVER MEADOWS",
    "dropmalst": "PA",
    "dropmalzpp": 182169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704557071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17128",
    "droptype": "D",
    "dropname": "BEAVER SPRINGS",
    "dropdeladd": "85 PINE ST",
    "dropdelcty": "BEAVER SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 178129998,
    "dropphyadd": "85 PINE ST",
    "dropphycty": "BEAVER SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 178129998,
    "dropmaladd": "85 PINE ST",
    "dropmalcty": "BEAVER SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 178129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706587222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17129",
    "droptype": "D",
    "dropname": "BEAVERDALE",
    "dropdeladd": "316 CEDAR ST STE 100",
    "dropdelcty": "BEAVERDALE",
    "dropdelst": "PA",
    "dropdelzpp": 159219998,
    "dropphyadd": "316 CEDAR ST STE 100",
    "dropphycty": "BEAVERDALE",
    "dropphyst": "PA",
    "dropphyzpp": 159219998,
    "dropmaladd": "316 CEDAR ST STE 100",
    "dropmalcty": "BEAVERDALE",
    "dropmalst": "PA",
    "dropmalzpp": 159219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144875211,
    "dropsitcph": 8144875211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17131",
    "droptype": "D",
    "dropname": "BEAVERTOWN",
    "dropdeladd": "212 S SASSAFRAS ST",
    "dropdelcty": "BEAVERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 178139998,
    "dropphyadd": "212 S SASSAFRAS ST",
    "dropphycty": "BEAVERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 178139998,
    "dropmaladd": "212 S SASSAFRAS ST",
    "dropmalcty": "BEAVERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 178139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706587367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17134",
    "droptype": "D",
    "dropname": "BECHTELSVILLE",
    "dropdeladd": "1811 N MAIN ST",
    "dropdelcty": "BECHTELSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195059998,
    "dropphyadd": "1811 N MAIN ST",
    "dropphycty": "BECHTELSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195059998,
    "dropmaladd": "1811 N MAIN ST",
    "dropmalcty": "BECHTELSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195059998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103691904,
    "dropsitcph": 6103691904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17139",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "201 S JULIANA ST",
    "dropdelcty": "BEDFORD",
    "dropdelst": "PA",
    "dropdelzpp": 155229998,
    "dropphyadd": "201 S JULIANA ST",
    "dropphycty": "BEDFORD",
    "dropphyst": "PA",
    "dropphyzpp": 155229998,
    "dropmaladd": "201 S JULIANA ST",
    "dropmalcty": "BEDFORD",
    "dropmalst": "PA",
    "dropmalzpp": 155229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146239116,
    "dropsitcph": 8146239116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17140",
    "droptype": "D",
    "dropname": "BEDMINSTER",
    "dropdeladd": "3102 BEDMINSTER RD",
    "dropdelcty": "BEDMINSTER",
    "dropdelst": "PA",
    "dropdelzpp": 189109998,
    "dropphyadd": "3102 BEDMINSTER RD",
    "dropphycty": "BEDMINSTER",
    "dropphyst": "PA",
    "dropphyzpp": 189109998,
    "dropmaladd": "3102 BEDMINSTER RD",
    "dropmalcty": "BEDMINSTER",
    "dropmalst": "PA",
    "dropmalzpp": 189109998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157952961,
    "dropsitcph": 2157952961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17141",
    "droptype": "D",
    "dropname": "BEECH CREEK",
    "dropdeladd": "26 GRANT ST",
    "dropdelcty": "BEECH CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 168229998,
    "dropphyadd": "26 GRANT ST",
    "dropphycty": "BEECH CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 168229998,
    "dropmaladd": "26 GRANT ST",
    "dropmalcty": "BEECH CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 168229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 5709622993,
    "dropsitcph": 5709622993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17155",
    "droptype": "D",
    "dropname": "BELLE VERNON",
    "dropdeladd": "611 CIRCLE DR",
    "dropdelcty": "ROSTRAVER TOWNSHIP",
    "dropdelst": "PA",
    "dropdelzpp": 150129998,
    "dropphyadd": "611 CIRCLE DR",
    "dropphycty": "ROSTRAVER TOWNSHIP",
    "dropphyst": "PA",
    "dropphyzpp": 150129998,
    "dropmaladd": "611 CIRCLE DR",
    "dropmalcty": "ROSTRAVER TOWNSHIP",
    "dropmalst": "PA",
    "dropmalzpp": 150129998,
    "dropsitphn": 4123597864,
    "dropsitlph": 7249293641,
    "dropsitcph": 7249293641,
    "dropfax": 4129309122
  },
  {
    "dcode": "D",
    "dropkey": "PX17156",
    "droptype": "D",
    "dropname": "BELLEFONTE",
    "dropdeladd": "132 N ALLEGHENY ST",
    "dropdelcty": "BELLEFONTE",
    "dropdelst": "PA",
    "dropdelzpp": 168239998,
    "dropphyadd": "132 N ALLEGHENY ST",
    "dropphycty": "BELLEFONTE",
    "dropphyst": "PA",
    "dropphyzpp": 168239998,
    "dropmaladd": "132 N ALLEGHENY ST",
    "dropmalcty": "BELLEFONTE",
    "dropmalst": "PA",
    "dropmalzpp": 168239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143552821,
    "dropsitcph": 8143552821,
    "dropfax": 8143578335
  },
  {
    "dcode": "D",
    "dropkey": "PX17159",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "4242 E MAIN ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170049998,
    "dropphyadd": "4242 E MAIN ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170049998,
    "dropmaladd": "4242 E MAIN ST",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170049998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179352313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17163",
    "droptype": "D",
    "dropname": "BELLWOOD",
    "dropdeladd": "511 MAIN ST",
    "dropdelcty": "BELLWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 166179998,
    "dropphyadd": "511 MAIN ST",
    "dropphycty": "BELLWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 166179998,
    "dropmaladd": "511 MAIN ST",
    "dropmalcty": "BELLWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 166179998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147428972,
    "dropsitcph": 8147428972,
    "dropfax": 8147427463
  },
  {
    "dcode": "D",
    "dropkey": "PX17165",
    "droptype": "D",
    "dropname": "BELSANO",
    "dropdeladd": "3806 BEN FRANKLIN HWY STE 1",
    "dropdelcty": "BELSANO",
    "dropdelst": "PA",
    "dropdelzpp": 159229998,
    "dropphyadd": "3806 BEN FRANKLIN HWY STE 1",
    "dropphycty": "BELSANO",
    "dropphyst": "PA",
    "dropphyzpp": 159229998,
    "dropmaladd": "3806 BEN FRANKLIN HWY STE 1",
    "dropmalcty": "BELSANO",
    "dropmalst": "PA",
    "dropmalzpp": 159229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147499207,
    "dropsitcph": 8147499207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17168",
    "droptype": "D",
    "dropname": "BENDERSVILLE",
    "dropdeladd": "125 RAMPIKE HILL RD",
    "dropdelcty": "BENDERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173069998,
    "dropphyadd": "125 RAMPIKE HILL RD",
    "dropphycty": "BENDERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173069998,
    "dropmaladd": "125 RAMPIKE HILL RD",
    "dropmalcty": "BENDERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173069998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176777200,
    "dropsitcph": 7176777200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17172",
    "droptype": "D",
    "dropname": "BENEZETT",
    "dropdeladd": "9689 ROUTE 555",
    "dropdelcty": "BENEZETT",
    "dropdelst": "PA",
    "dropdelzpp": 158219800,
    "dropphyadd": "9689 ROUTE 555",
    "dropphycty": "BENEZETT",
    "dropphyst": "PA",
    "dropphyzpp": 158219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENEZETT",
    "dropmalst": "PA",
    "dropmalzpp": 158219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147874899,
    "dropsitcph": 8147874899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17175",
    "droptype": "D",
    "dropname": "BENSALEM",
    "dropdeladd": "1800 BYBERRY RD",
    "dropdelcty": "BENSALEM",
    "dropdelst": "PA",
    "dropdelzpp": 190209998,
    "dropphyadd": "1800 BYBERRY RD",
    "dropphycty": "BENSALEM",
    "dropphyst": "PA",
    "dropphyzpp": 190209998,
    "dropmaladd": "1800 BYBERRY RD",
    "dropmalcty": "BENSALEM",
    "dropmalst": "PA",
    "dropmalzpp": 190209998,
    "dropsitphn": 2156339436,
    "dropsitlph": 2156339436,
    "dropsitcph": 2156395051,
    "dropfax": 2156394990
  },
  {
    "dcode": "D",
    "dropkey": "PX17177",
    "droptype": "D",
    "dropname": "BENTLEYVILLE",
    "dropdeladd": "901 MAIN ST",
    "dropdelcty": "BENTLEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153149998,
    "dropphyadd": "901 MAIN ST",
    "dropphycty": "BENTLEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153149998,
    "dropmaladd": "901 MAIN ST",
    "dropmalcty": "BENTLEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153149998,
    "dropsitphn": 4123597564,
    "dropsitlph": 7242393186,
    "dropsitcph": 7242393186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17180",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "250 THIRD ST",
    "dropdelcty": "BENTON",
    "dropdelst": "PA",
    "dropdelzpp": 178149998,
    "dropphyadd": "250 THIRD ST",
    "dropphycty": "BENTON",
    "dropphyst": "PA",
    "dropphyzpp": 178149998,
    "dropmaladd": "250 THIRD ST",
    "dropmalcty": "BENTON",
    "dropmalst": "PA",
    "dropmalzpp": 178149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709252021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17184",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "531 MAIN ST STE 100",
    "dropdelcty": "BERLIN",
    "dropdelst": "PA",
    "dropdelzpp": 155309998,
    "dropphyadd": "531 MAIN ST STE 100",
    "dropphycty": "BERLIN",
    "dropphyst": "PA",
    "dropphyzpp": 155309998,
    "dropmaladd": "531 MAIN ST STE 100",
    "dropmalcty": "BERLIN",
    "dropmalst": "PA",
    "dropmalzpp": 155309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142675018,
    "dropsitcph": 8142675018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17188",
    "droptype": "D",
    "dropname": "BERNVILLE",
    "dropdeladd": "125 E 3RD ST",
    "dropdelcty": "BERNVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195069998,
    "dropphyadd": "125 E 3RD ST",
    "dropphycty": "BERNVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195069998,
    "dropmaladd": "125 E 3RD ST",
    "dropmalcty": "BERNVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195069998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6104881477,
    "dropsitcph": 6104881477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17191",
    "droptype": "D",
    "dropname": "BERRYSBURG",
    "dropdeladd": "137 N CHESTNUT ST",
    "dropdelcty": "BERRYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170059998,
    "dropphyadd": "137 N CHESTNUT ST",
    "dropphycty": "BERRYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170059998,
    "dropmaladd": "137 N CHESTNUT ST",
    "dropmalcty": "BERRYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170059998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173629700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17193",
    "droptype": "D",
    "dropname": "BERWICK",
    "dropdeladd": "330 PINE ST",
    "dropdelcty": "BERWICK",
    "dropdelst": "PA",
    "dropdelzpp": 186039998,
    "dropphyadd": "330 PINE ST",
    "dropphycty": "BERWICK",
    "dropphyst": "PA",
    "dropphyzpp": 186039998,
    "dropmaladd": "330 PINE ST",
    "dropmalcty": "BERWICK",
    "dropmalst": "PA",
    "dropmalzpp": 186039998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707524181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17194",
    "droptype": "D",
    "dropname": "BERWYN",
    "dropdeladd": "662 LANCASTER AVE",
    "dropdelcty": "BERWYN",
    "dropdelst": "PA",
    "dropdelzpp": 193129998,
    "dropphyadd": "662 LANCASTER AVE",
    "dropphycty": "BERWYN",
    "dropphyst": "PA",
    "dropphyzpp": 193129998,
    "dropmaladd": "662 LANCASTER AVE",
    "dropmalcty": "BERWYN",
    "dropmalst": "PA",
    "dropmalzpp": 193129998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106441311,
    "dropsitcph": 6106441311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17195",
    "droptype": "D",
    "dropname": "BESSEMER",
    "dropdeladd": "201 E POLAND AVE",
    "dropdelcty": "BESSEMER",
    "dropdelst": "PA",
    "dropdelzpp": 161129800,
    "dropphyadd": "201 E POLAND AVE",
    "dropphycty": "BESSEMER",
    "dropphyst": "PA",
    "dropphyzpp": 161129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BESSEMER",
    "dropmalst": "PA",
    "dropmalzpp": 161129998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246677131,
    "dropsitcph": 7246677131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17199",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "10 LEGION DR",
    "dropdelcty": "BETHEL",
    "dropdelst": "PA",
    "dropdelzpp": 195079998,
    "dropphyadd": "10 LEGION DR",
    "dropphycty": "BETHEL",
    "dropphyst": "PA",
    "dropphyzpp": 195079998,
    "dropmaladd": "10 LEGION DR",
    "dropmalcty": "BETHEL",
    "dropmalst": "PA",
    "dropmalzpp": 195079998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179338305,
    "dropsitcph": 7179338305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17203",
    "droptype": "D",
    "dropname": "BETHEL PARK",
    "dropdeladd": "2765 S PARK RD",
    "dropdelcty": "BETHEL PARK",
    "dropdelst": "PA",
    "dropdelzpp": 151029998,
    "dropphyadd": "2765 S PARK RD",
    "dropphycty": "BETHEL PARK",
    "dropphyst": "PA",
    "dropphyzpp": 151029998,
    "dropmaladd": "2765 S PARK RD",
    "dropmalcty": "BETHEL PARK",
    "dropmalst": "PA",
    "dropmalzpp": 151029998,
    "dropsitphn": 4123597864,
    "dropsitlph": 4128357129,
    "dropsitcph": 4128357129,
    "dropfax": 4128541691
  },
  {
    "dcode": "D",
    "dropkey": "PX17206",
    "droptype": "D",
    "dropname": "BETHLEHEM",
    "dropdeladd": "535 WOOD ST",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180169998,
    "dropphyadd": "535 WOOD ST",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180169998,
    "dropmaladd": "535 WOOD ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "PA",
    "dropmalzpp": 180169998,
    "dropsitphn": 6108660911,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108660911,
    "dropfax": 6108665926
  },
  {
    "dcode": "D",
    "dropkey": "PX17211",
    "droptype": "D",
    "dropname": "BEYER",
    "dropdeladd": "7389 ROUTE 85 HWY N",
    "dropdelcty": "BEYER",
    "dropdelst": "PA",
    "dropdelzpp": 162119800,
    "dropphyadd": "7389 ROUTE 85 HWY N",
    "dropphycty": "BEYER",
    "dropphyst": "PA",
    "dropphyzpp": 162119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEYER",
    "dropmalst": "PA",
    "dropmalzpp": 162119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247837923,
    "dropsitcph": 7247837923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17216",
    "droptype": "D",
    "dropname": "BIG RUN",
    "dropdeladd": "401 E MAIN ST",
    "dropdelcty": "BIG RUN",
    "dropdelst": "PA",
    "dropdelzpp": 157159998,
    "dropphyadd": "401 E MAIN ST",
    "dropphycty": "BIG RUN",
    "dropphyst": "PA",
    "dropphyzpp": 157159998,
    "dropmaladd": "401 E MAIN ST",
    "dropmalcty": "BIG RUN",
    "dropmalst": "PA",
    "dropmalzpp": 157159998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144272930,
    "dropsitcph": 8144272930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17219",
    "droptype": "D",
    "dropname": "BIGLER",
    "dropdeladd": "336 BIGLER RD",
    "dropdelcty": "BIGLER",
    "dropdelst": "PA",
    "dropdelzpp": 168259998,
    "dropphyadd": "336 BIGLER RD",
    "dropphycty": "BIGLER",
    "dropphyst": "PA",
    "dropphyzpp": 168259998,
    "dropmaladd": "336 BIGLER RD",
    "dropmalcty": "BIGLER",
    "dropmalst": "PA",
    "dropmalzpp": 168259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148577551,
    "dropsitcph": 8148577551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17220",
    "droptype": "D",
    "dropname": "BIGLERVILLE",
    "dropdeladd": "2 HIGH ST",
    "dropdelcty": "BIGLERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173079998,
    "dropphyadd": "2 HIGH ST",
    "dropphycty": "BIGLERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173079998,
    "dropmaladd": "2 HIGH ST",
    "dropmalcty": "BIGLERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173079998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176776300,
    "dropsitcph": 7176776300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17226",
    "droptype": "D",
    "dropname": "BIRCHRUNVILLE",
    "dropdeladd": "1405 HOLLOW RD",
    "dropdelcty": "BIRCHRUNVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194219902,
    "dropphyadd": "1405 HOLLOW RD",
    "dropphycty": "BIRCHRUNVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194219902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRCHRUNVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194219998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108279339,
    "dropsitcph": 6108279339,
    "dropfax": 6108270902
  },
  {
    "dcode": "D",
    "dropkey": "PX17227",
    "droptype": "D",
    "dropname": "BIRD IN HAND",
    "dropdeladd": "2694 OLD PHILADELPHIA PIKE",
    "dropdelcty": "BIRD IN HAND",
    "dropdelst": "PA",
    "dropdelzpp": 175059998,
    "dropphyadd": "2694 OLD PHILADELPHIA PIKE",
    "dropphycty": "BIRD IN HAND",
    "dropphyst": "PA",
    "dropphyzpp": 175059998,
    "dropmaladd": "2694 OLD PHILADELPHIA PIKE",
    "dropmalcty": "BIRD IN HAND",
    "dropmalst": "PA",
    "dropmalzpp": 175059998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173936191,
    "dropsitcph": 7173936191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17228",
    "droptype": "D",
    "dropname": "BIRDSBORO",
    "dropdeladd": "340 W MAIN ST",
    "dropdelcty": "BIRDSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 195089998,
    "dropphyadd": "340 W MAIN ST",
    "dropphycty": "BIRDSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 195089998,
    "dropmaladd": "340 W MAIN ST",
    "dropmalcty": "BIRDSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 195089998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105822301,
    "dropsitcph": 6105822301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17236",
    "droptype": "D",
    "dropname": "BLACK LICK",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "BLACK LICK",
    "dropdelst": "PA",
    "dropdelzpp": 157169998,
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "BLACK LICK",
    "dropphyst": "PA",
    "dropphyzpp": 157169998,
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "BLACK LICK",
    "dropmalst": "PA",
    "dropmalzpp": 157169998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242487110,
    "dropsitcph": 7242487110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17239",
    "droptype": "D",
    "dropname": "BLAIN",
    "dropdeladd": "14 E MAIN ST",
    "dropdelcty": "BLAIN",
    "dropdelst": "PA",
    "dropdelzpp": 170069998,
    "dropphyadd": "14 E MAIN ST",
    "dropphycty": "BLAIN",
    "dropphyst": "PA",
    "dropphyzpp": 170069998,
    "dropmaladd": "14 E MAIN ST",
    "dropmalcty": "BLAIN",
    "dropmalst": "PA",
    "dropmalzpp": 170069998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175363621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17241",
    "droptype": "D",
    "dropname": "BLAIRS MILLS",
    "dropdeladd": "17394 TUSCARORA CREEK RD",
    "dropdelcty": "BLAIRS MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 172139998,
    "dropphyadd": "17394 TUSCARORA CREEK RD",
    "dropphycty": "BLAIRS MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 172139998,
    "dropmaladd": "17394 TUSCARORA CREEK RD",
    "dropmalcty": "BLAIRS MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 172139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173492644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17242",
    "droptype": "D",
    "dropname": "BLAIRSVILLE",
    "dropdeladd": "24 S WALNUT ST",
    "dropdelcty": "BLAIRSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 157179998,
    "dropphyadd": "24 S WALNUT ST",
    "dropphycty": "BLAIRSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 157179998,
    "dropmaladd": "24 S WALNUT ST",
    "dropmalcty": "BLAIRSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 157179998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244596740,
    "dropsitcph": 7244596740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17245",
    "droptype": "D",
    "dropname": "BLAKESLEE",
    "dropdeladd": "5677 ROUTE 115",
    "dropdelcty": "BLAKESLEE",
    "dropdelst": "PA",
    "dropdelzpp": 186109998,
    "dropphyadd": "5677 ROUTE 115",
    "dropphycty": "BLAKESLEE",
    "dropphyst": "PA",
    "dropphyzpp": 186109998,
    "dropmaladd": "5677 ROUTE 115",
    "dropmalcty": "BLAKESLEE",
    "dropmalst": "PA",
    "dropmalzpp": 186109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706468997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17246",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "113 BEACH ST",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "PA",
    "dropdelzpp": 168269998,
    "dropphyadd": "113 BEACH ST",
    "dropphycty": "BLANCHARD",
    "dropphyst": "PA",
    "dropphyzpp": 168269998,
    "dropmaladd": "113 BEACH ST",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "PA",
    "dropmalzpp": 168269998,
    "dropsitphn": 8148367307,
    "dropsitlph": 5709622249,
    "dropsitcph": 5709622249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17247",
    "droptype": "D",
    "dropname": "BLANDBURG",
    "dropdeladd": "143 POST OFFICE AVE",
    "dropdelcty": "BLANDBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166199998,
    "dropphyadd": "143 POST OFFICE AVE",
    "dropphycty": "BLANDBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166199998,
    "dropmaladd": "143 POST OFFICE AVE",
    "dropmalcty": "BLANDBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166199998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146873685,
    "dropsitcph": 8146873685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17248",
    "droptype": "D",
    "dropname": "BLANDON",
    "dropdeladd": "120 E WESNER RD",
    "dropdelcty": "BLANDON",
    "dropdelst": "PA",
    "dropdelzpp": 195109998,
    "dropphyadd": "120 E WESNER RD",
    "dropphycty": "BLANDON",
    "dropphyst": "PA",
    "dropphyzpp": 195109998,
    "dropmaladd": "120 E WESNER RD",
    "dropmalcty": "BLANDON",
    "dropmalst": "PA",
    "dropmalzpp": 195109998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109264777,
    "dropsitcph": 6109264777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17252",
    "droptype": "D",
    "dropname": "BLOOMING GLEN",
    "dropdeladd": "818 BLOOMING GLEN RD",
    "dropdelcty": "BLOOMING GLEN",
    "dropdelst": "PA",
    "dropdelzpp": 189119900,
    "dropphyadd": "818 BLOOMING GLEN RD",
    "dropphycty": "BLOOMING GLEN",
    "dropphyst": "PA",
    "dropphyzpp": 189119900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMING GLEN",
    "dropmalst": "PA",
    "dropmalzpp": 189119998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152573967,
    "dropsitcph": 2152573967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17255",
    "droptype": "D",
    "dropname": "BLOOMSBURG",
    "dropdeladd": "230 MARKET ST",
    "dropdelcty": "BLOOMSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178159998,
    "dropphyadd": "230 MARKET ST",
    "dropphycty": "BLOOMSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178159998,
    "dropmaladd": "230 MARKET ST",
    "dropmalcty": "BLOOMSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178159998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707841077,
    "dropfax": 5703871912
  },
  {
    "dcode": "D",
    "dropkey": "PX17258",
    "droptype": "D",
    "dropname": "BLOSSBURG",
    "dropdeladd": "3 RIVERSIDE PLZ",
    "dropdelcty": "BLOSSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 169129998,
    "dropphyadd": "3 RIVERSIDE PLZ",
    "dropphycty": "BLOSSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 169129998,
    "dropmaladd": "3 RIVERSIDE PLZ",
    "dropmalcty": "BLOSSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 169129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706382063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17259",
    "droptype": "D",
    "dropname": "BLUE BALL",
    "dropdeladd": "1058 MAIN ST",
    "dropdelcty": "BLUE BALL",
    "dropdelst": "PA",
    "dropdelzpp": 175069998,
    "dropphyadd": "1058 MAIN ST",
    "dropphycty": "BLUE BALL",
    "dropphyst": "PA",
    "dropphyzpp": 175069998,
    "dropmaladd": "1058 MAIN ST",
    "dropmalcty": "BLUE BALL",
    "dropmalst": "PA",
    "dropmalzpp": 175069998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173545465,
    "dropsitcph": 7173545465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17260",
    "droptype": "D",
    "dropname": "BLUE BELL",
    "dropdeladd": "651 E TOWNSHIP LINE RD",
    "dropdelcty": "BLUE BELL",
    "dropdelst": "PA",
    "dropdelzpp": 194229998,
    "dropphyadd": "651 E TOWNSHIP LINE RD",
    "dropphycty": "BLUE BELL",
    "dropphyst": "PA",
    "dropphyzpp": 194229998,
    "dropmaladd": "651 E TOWNSHIP LINE RD",
    "dropmalcty": "BLUE BELL",
    "dropmalst": "PA",
    "dropmalzpp": 194229998,
    "dropsitphn": 2155910585,
    "dropsitlph": 2155910585,
    "dropsitcph": 2155910585,
    "dropfax": 2156462806
  },
  {
    "dcode": "D",
    "dropkey": "PX17264",
    "droptype": "D",
    "dropname": "BLUE RIDGE SUMMIT",
    "dropdeladd": "14959 BUCHANAN TRL E",
    "dropdelcty": "BLUE RIDGE SUMMIT",
    "dropdelst": "PA",
    "dropdelzpp": 172149998,
    "dropphyadd": "14959 BUCHANAN TRL E",
    "dropphycty": "BLUE RIDGE SUMMIT",
    "dropphyst": "PA",
    "dropphyzpp": 172149998,
    "dropmaladd": "14959 BUCHANAN TRL E",
    "dropmalcty": "BLUE RIDGE SUMMIT",
    "dropmalst": "PA",
    "dropmalzpp": 172149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177942335,
    "dropfax": 7172572335
  },
  {
    "dcode": "D",
    "dropkey": "PX17270",
    "droptype": "D",
    "dropname": "BOALSBURG",
    "dropdeladd": "110 W PINE ST",
    "dropdelcty": "BOALSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168279998,
    "dropphyadd": "110 W PINE ST",
    "dropphycty": "BOALSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168279998,
    "dropmaladd": "110 W PINE ST",
    "dropmalcty": "BOALSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144666326,
    "dropsitcph": 8144666326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17271",
    "droptype": "D",
    "dropname": "BOBTOWN",
    "dropdeladd": "778 LARIMER AVE",
    "dropdelcty": "BOBTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 153151001,
    "dropphyadd": "778 LARIMER AVE",
    "dropphycty": "BOBTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 153151001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOBTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 153159998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248397361,
    "dropsitcph": 7248397361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17276",
    "droptype": "D",
    "dropname": "BOILING SPRINGS",
    "dropdeladd": "3 E 1ST ST",
    "dropdelcty": "BOILING SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 170079998,
    "dropphyadd": "3 E 1ST ST",
    "dropphycty": "BOILING SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 170079998,
    "dropmaladd": "3 E 1ST ST",
    "dropmalcty": "BOILING SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 170079998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172586668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17277",
    "droptype": "D",
    "dropname": "BOLIVAR",
    "dropdeladd": "308 4TH ST",
    "dropdelcty": "BOLIVAR",
    "dropdelst": "PA",
    "dropdelzpp": 159239998,
    "dropphyadd": "308 4TH ST",
    "dropphycty": "BOLIVAR",
    "dropphyst": "PA",
    "dropphyzpp": 159239998,
    "dropmaladd": "308 4TH ST",
    "dropmalcty": "BOLIVAR",
    "dropmalst": "PA",
    "dropmalzpp": 159239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246765640,
    "dropsitcph": 7246765640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17289",
    "droptype": "D",
    "dropname": "BOSWELL",
    "dropdeladd": "908 ATKINSON WAY",
    "dropdelcty": "BOSWELL",
    "dropdelst": "PA",
    "dropdelzpp": 155319998,
    "dropphyadd": "908 ATKINSON WAY",
    "dropphycty": "BOSWELL",
    "dropphyst": "PA",
    "dropphyzpp": 155319998,
    "dropmaladd": "908 ATKINSON WAY",
    "dropmalcty": "BOSWELL",
    "dropmalst": "PA",
    "dropmalzpp": 155319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146295158,
    "dropsitcph": 8146295158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17293",
    "droptype": "D",
    "dropname": "BOVARD",
    "dropdeladd": "3 JEFFERSON ST",
    "dropdelcty": "BOVARD",
    "dropdelst": "PA",
    "dropdelzpp": 156191001,
    "dropphyadd": "3 JEFFERSON ST",
    "dropphycty": "BOVARD",
    "dropphyst": "PA",
    "dropphyzpp": 156191001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOVARD",
    "dropmalst": "PA",
    "dropmalzpp": 156199998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249252816,
    "dropsitcph": 7248360176,
    "dropfax": 7248360176
  },
  {
    "dcode": "D",
    "dropkey": "PX17294",
    "droptype": "D",
    "dropname": "BOWERS",
    "dropdeladd": "97 OLD BOWERS RD",
    "dropdelcty": "BOWERS",
    "dropdelst": "PA",
    "dropdelzpp": 195119998,
    "dropphyadd": "97 OLD BOWERS RD",
    "dropphycty": "BOWERS",
    "dropphyst": "PA",
    "dropphyzpp": 195119998,
    "dropmaladd": "97 OLD BOWERS RD",
    "dropmalcty": "BOWERS",
    "dropmalst": "PA",
    "dropmalzpp": 195119998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106826458,
    "dropsitcph": 6106826458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17298",
    "droptype": "D",
    "dropname": "BOWMANSTOWN",
    "dropdeladd": "600 RAILROAD ST",
    "dropdelcty": "BOWMANSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180309998,
    "dropphyadd": "600 RAILROAD ST",
    "dropphycty": "BOWMANSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180309998,
    "dropmaladd": "600 RAILROAD ST",
    "dropmalcty": "BOWMANSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108523211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17300",
    "droptype": "D",
    "dropname": "BOWMANSVILLE",
    "dropdeladd": "127 E MAPLE GROVE RD",
    "dropdelcty": "BOWMANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175079998,
    "dropphyadd": "127 E MAPLE GROVE RD",
    "dropphycty": "BOWMANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175079998,
    "dropmaladd": "127 E MAPLE GROVE RD",
    "dropmalcty": "BOWMANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175079998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174455821,
    "dropsitcph": 7174455821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17304",
    "droptype": "D",
    "dropname": "BOYERS",
    "dropdeladd": "1188 BOYERS RD",
    "dropdelcty": "BOYERS",
    "dropdelst": "PA",
    "dropdelzpp": 160209800,
    "dropphyadd": "1188 BOYERS RD",
    "dropphycty": "BOYERS",
    "dropphyst": "PA",
    "dropphyzpp": 160209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYERS",
    "dropmalst": "PA",
    "dropmalzpp": 160209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247352920,
    "dropsitcph": 7247352920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17306",
    "droptype": "D",
    "dropname": "BOYERTOWN",
    "dropdeladd": "128 S WASHINGTON ST",
    "dropdelcty": "BOYERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195129998,
    "dropphyadd": "128 S WASHINGTON ST",
    "dropphycty": "BOYERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195129998,
    "dropmaladd": "128 S WASHINGTON ST",
    "dropmalcty": "BOYERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195129998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103672262,
    "dropsitcph": 6103672262,
    "dropfax": 6103671574
  },
  {
    "dcode": "D",
    "dropkey": "PX17308",
    "droptype": "D",
    "dropname": "BOYNTON",
    "dropdeladd": "102 POST OFFICE ST",
    "dropdelcty": "BOYNTON",
    "dropdelst": "PA",
    "dropdelzpp": 155329998,
    "dropphyadd": "102 POST OFFICE ST",
    "dropphycty": "BOYNTON",
    "dropphyst": "PA",
    "dropphyzpp": 155329998,
    "dropmaladd": "102 POST OFFICE ST",
    "dropmalcty": "BOYNTON",
    "dropmalst": "PA",
    "dropmalzpp": 155329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146624592,
    "dropsitcph": 8146624592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17320",
    "droptype": "D",
    "dropname": "BRACKENRIDGE",
    "dropdeladd": "1101 BRACKENRIDGE AVE",
    "dropdelcty": "BRACKENRIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 150149998,
    "dropphyadd": "1101 BRACKENRIDGE AVE",
    "dropphycty": "BRACKENRIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 150149998,
    "dropmaladd": "1101 BRACKENRIDGE AVE",
    "dropmalcty": "BRACKENRIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 150149998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242246666,
    "dropsitcph": 7242246666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17321",
    "droptype": "D",
    "dropname": "BRACKNEY",
    "dropdeladd": "3566 QUAKER LAKE RD",
    "dropdelcty": "BRACKNEY",
    "dropdelst": "PA",
    "dropdelzpp": 188129998,
    "dropphyadd": "3566 QUAKER LAKE RD",
    "dropphycty": "BRACKNEY",
    "dropphyst": "PA",
    "dropphyzpp": 188129998,
    "dropmaladd": "3566 QUAKER LAKE RD",
    "dropmalcty": "BRACKNEY",
    "dropmalst": "PA",
    "dropmalzpp": 188129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706632612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17322",
    "droptype": "D",
    "dropname": "BRADDOCK",
    "dropdeladd": "1110 BRADDOCK AVE",
    "dropdelcty": "BRADDOCK",
    "dropdelst": "PA",
    "dropdelzpp": 151049998,
    "dropphyadd": "1110 BRADDOCK AVE",
    "dropphycty": "BRADDOCK",
    "dropphyst": "PA",
    "dropphyzpp": 151049998,
    "dropmaladd": "1110 BRADDOCK AVE",
    "dropmalcty": "BRADDOCK",
    "dropmalst": "PA",
    "dropmalzpp": 151049998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122714165,
    "dropsitcph": 4122714165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17323",
    "droptype": "D",
    "dropname": "BRADENVILLE",
    "dropdeladd": "1303 HIGH ST",
    "dropdelcty": "BRADENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 156205001,
    "dropphyadd": "1303 HIGH ST",
    "dropphycty": "BRADENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 156205001,
    "dropmaladd": "1303 HIGH ST",
    "dropmalcty": "BRADENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 156205001,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245393468,
    "dropsitcph": 7245393468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17327",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "115 BOYLSTON ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "PA",
    "dropdelzpp": 167012190,
    "dropphyadd": "115 BOYLSTON ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "PA",
    "dropphyzpp": 167012190,
    "dropmaladd": "115 BOYLSTON ST",
    "dropmalcty": "BRADFORD",
    "dropmalst": "PA",
    "dropmalzpp": 167012190,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143624576,
    "dropsitcph": 8143624576,
    "dropfax": 8143624611
  },
  {
    "dcode": "D",
    "dropkey": "PX17329",
    "droptype": "D",
    "dropname": "BRADFORDWOODS",
    "dropdeladd": "10 SELDOM SEEN RD",
    "dropdelcty": "BRADFORDWOODS",
    "dropdelst": "PA",
    "dropdelzpp": 150159998,
    "dropphyadd": "10 SELDOM SEEN RD",
    "dropphycty": "BRADFORDWOODS",
    "dropphyst": "PA",
    "dropphyzpp": 150159998,
    "dropmaladd": "10 SELDOM SEEN RD",
    "dropmalcty": "BRADFORDWOODS",
    "dropmalst": "PA",
    "dropmalzpp": 150159998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249353442,
    "dropsitcph": 7249353442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17334",
    "droptype": "D",
    "dropname": "BRANCHDALE",
    "dropdeladd": "105 S STATE RD",
    "dropdelcty": "BRANCHDALE",
    "dropdelst": "PA",
    "dropdelzpp": 179239998,
    "dropphyadd": "105 S STATE RD",
    "dropphycty": "BRANCHDALE",
    "dropphyst": "PA",
    "dropphyzpp": 179239998,
    "dropmaladd": "105 S STATE RD",
    "dropmalcty": "BRANCHDALE",
    "dropmalst": "PA",
    "dropmalzpp": 179239998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5705443223,
    "dropsitcph": 5705443223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17336",
    "droptype": "D",
    "dropname": "BRANDAMORE",
    "dropdeladd": "546 HIBERNIA RD STE 5",
    "dropdelcty": "BRANDAMORE",
    "dropdelst": "PA",
    "dropdelzpp": 193169998,
    "dropphyadd": "546 HIBERNIA RD STE 5",
    "dropphycty": "BRANDAMORE",
    "dropphyst": "PA",
    "dropphyzpp": 193169998,
    "dropmaladd": "546 HIBERNIA RD STE 5",
    "dropmalcty": "BRANDAMORE",
    "dropmalst": "PA",
    "dropmalzpp": 193169998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109423933,
    "dropsitcph": 6109423933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17341",
    "droptype": "D",
    "dropname": "BRAVE",
    "dropdeladd": "120 OAK FOREST RD",
    "dropdelcty": "BRAVE",
    "dropdelst": "PA",
    "dropdelzpp": 153161001,
    "dropphyadd": "120 OAK FOREST RD",
    "dropphycty": "BRAVE",
    "dropphyst": "PA",
    "dropphyzpp": 153161001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRAVE",
    "dropmalst": "PA",
    "dropmalzpp": 153169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244518384,
    "dropsitcph": 7244518384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17342",
    "droptype": "D",
    "dropname": "BREEZEWOOD",
    "dropdeladd": "166 N MAIN ST",
    "dropdelcty": "BREEZEWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 155339998,
    "dropphyadd": "166 N MAIN ST",
    "dropphycty": "BREEZEWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 155339998,
    "dropmaladd": "166 N MAIN ST",
    "dropmalcty": "BREEZEWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 155339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147354380,
    "dropsitcph": 8147354380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17344",
    "droptype": "D",
    "dropname": "BREINIGSVILLE",
    "dropdeladd": "8922 BREINIGSVILLE RD",
    "dropdelcty": "BREINIGSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180319998,
    "dropphyadd": "8922 BREINIGSVILLE RD",
    "dropphycty": "BREINIGSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180319998,
    "dropmaladd": "8922 BREINIGSVILLE RD",
    "dropmalcty": "BREINIGSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180319998,
    "dropsitphn": 6103955010,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103955010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17358",
    "droptype": "D",
    "dropname": "BRIDGEVILLE",
    "dropdeladd": "700 WASHINGTON AVE",
    "dropdelcty": "BRIDGEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 150179998,
    "dropphyadd": "700 WASHINGTON AVE",
    "dropphycty": "BRIDGEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 150179998,
    "dropmaladd": "700 WASHINGTON AVE",
    "dropmalcty": "BRIDGEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 150179998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122216186,
    "dropsitcph": 4122216186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17360",
    "droptype": "D",
    "dropname": "BRIER HILL",
    "dropdeladd": "6608 NATIONAL PIKE",
    "dropdelcty": "BRIER HILL",
    "dropdelst": "PA",
    "dropdelzpp": 154151001,
    "dropphyadd": "6608 NATIONAL PIKE",
    "dropphycty": "BRIER HILL",
    "dropphyst": "PA",
    "dropphyzpp": 154151001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIER HILL",
    "dropmalst": "PA",
    "dropmalzpp": 154159998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242466040,
    "dropsitcph": 7242466040,
    "dropfax": 7242466040
  },
  {
    "dcode": "D",
    "dropkey": "PX17362",
    "droptype": "D",
    "dropname": "BRISBIN",
    "dropdeladd": "181 SWOOPE ST",
    "dropdelcty": "BRISBIN",
    "dropdelst": "PA",
    "dropdelzpp": 166209998,
    "dropphyadd": "181 SWOOPE ST",
    "dropphycty": "BRISBIN",
    "dropphyst": "PA",
    "dropphyzpp": 166209998,
    "dropmaladd": "181 SWOOPE ST",
    "dropmalcty": "BRISBIN",
    "dropmalst": "PA",
    "dropmalzpp": 166209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143786111,
    "dropsitcph": 8143786111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17363",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "699 BEAVER ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "PA",
    "dropdelzpp": 190079998,
    "dropphyadd": "699 BEAVER ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "PA",
    "dropphyzpp": 190079998,
    "dropmaladd": "699 BEAVER ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "PA",
    "dropmalzpp": 190079998,
    "dropsitphn": 2157811506,
    "dropsitlph": 2157811506,
    "dropsitcph": 2157818135,
    "dropfax": 2157886883
  },
  {
    "dcode": "D",
    "dropkey": "PX17368",
    "droptype": "D",
    "dropname": "BROAD TOP",
    "dropdeladd": "3956 LOCUST ST",
    "dropdelcty": "BROAD TOP",
    "dropdelst": "PA",
    "dropdelzpp": 166219998,
    "dropphyadd": "3956 LOCUST ST",
    "dropphycty": "BROAD TOP",
    "dropphyst": "PA",
    "dropphyzpp": 166219998,
    "dropmaladd": "3956 LOCUST ST",
    "dropmalcty": "BROAD TOP",
    "dropmalst": "PA",
    "dropmalzpp": 166219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146352843,
    "dropsitcph": 8146352843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17369",
    "droptype": "D",
    "dropname": "BROCKPORT",
    "dropdeladd": "5139 ROUTE 219",
    "dropdelcty": "BROCKPORT",
    "dropdelst": "PA",
    "dropdelzpp": 158239800,
    "dropphyadd": "5139 ROUTE 219",
    "dropphycty": "BROCKPORT",
    "dropphyst": "PA",
    "dropphyzpp": 158239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROCKPORT",
    "dropmalst": "PA",
    "dropmalzpp": 158239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142651442,
    "dropsitcph": 8142651442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17370",
    "droptype": "D",
    "dropname": "BROCKTON",
    "dropdeladd": "199 MINE ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "PA",
    "dropdelzpp": 179259800,
    "dropphyadd": "199 MINE ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "PA",
    "dropphyzpp": 179259800,
    "dropmaladd": "199 MINE ST",
    "dropmalcty": "BROCKTON",
    "dropmalst": "PA",
    "dropmalzpp": 179259800,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706680319,
    "dropsitcph": 5706680319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17371",
    "droptype": "D",
    "dropname": "BROCKWAY",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "BROCKWAY",
    "dropdelst": "PA",
    "dropdelzpp": 158241300,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "BROCKWAY",
    "dropphyst": "PA",
    "dropphyzpp": 158241300,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "BROCKWAY",
    "dropmalst": "PA",
    "dropmalzpp": 158241300,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142656001,
    "dropsitcph": 8142656001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17373",
    "droptype": "D",
    "dropname": "BRODHEADSVILLE",
    "dropdeladd": "239 RODENBACH LN",
    "dropdelcty": "BRODHEADSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 183229998,
    "dropphyadd": "239 RODENBACH LN",
    "dropphycty": "BRODHEADSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 183229998,
    "dropmaladd": "239 RODENBACH LN",
    "dropmalcty": "BRODHEADSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 183229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5709927388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17376",
    "droptype": "D",
    "dropname": "BROGUE",
    "dropdeladd": "2224 DELTA RD",
    "dropdelcty": "BROGUE",
    "dropdelst": "PA",
    "dropdelzpp": 173099998,
    "dropphyadd": "2224 DELTA RD",
    "dropphycty": "BROGUE",
    "dropphyst": "PA",
    "dropphyzpp": 173099998,
    "dropmaladd": "2224 DELTA RD",
    "dropmalcty": "BROGUE",
    "dropmalst": "PA",
    "dropmalzpp": 173099998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179276506,
    "dropsitcph": 7179276506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17386",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "6924 MAPLE ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "PA",
    "dropdelzpp": 188139998,
    "dropphyadd": "6924 MAPLE ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "PA",
    "dropphyzpp": 188139998,
    "dropmaladd": "6924 MAPLE ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "PA",
    "dropmalzpp": 188139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702894452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17390",
    "droptype": "D",
    "dropname": "BROOKVILLE",
    "dropdeladd": "67 WHITE ST",
    "dropdelcty": "BROOKVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 158251279,
    "dropphyadd": "67 WHITE ST",
    "dropphycty": "BROOKVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 158251279,
    "dropmaladd": "67 WHITE ST",
    "dropmalcty": "BROOKVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 158251279,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148498359,
    "dropsitcph": 8148498359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17391",
    "droptype": "D",
    "dropname": "BROOMALL",
    "dropdeladd": "2628 W CHESTER PIKE",
    "dropdelcty": "BROOMALL",
    "dropdelst": "PA",
    "dropdelzpp": 190089998,
    "dropphyadd": "2628 W CHESTER PIKE",
    "dropphycty": "BROOMALL",
    "dropphyst": "PA",
    "dropphyzpp": 190089998,
    "dropmaladd": "2628 W CHESTER PIKE",
    "dropmalcty": "BROOMALL",
    "dropmalst": "PA",
    "dropmalzpp": 190089998,
    "dropsitphn": 2153254812,
    "dropsitlph": 6103254812,
    "dropsitcph": 6103254812,
    "dropfax": 6103539724
  },
  {
    "dcode": "D",
    "dropkey": "PX17396",
    "droptype": "D",
    "dropname": "BROWNFIELD",
    "dropdeladd": "212 2ND ST",
    "dropdelcty": "BROWNFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 154161001,
    "dropphyadd": "212 2ND ST",
    "dropphycty": "BROWNFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 154161001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 154169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244395360,
    "dropsitcph": 7244395360,
    "dropfax": 7244395360
  },
  {
    "dcode": "D",
    "dropkey": "PX17398",
    "droptype": "D",
    "dropname": "BROWNSTOWN",
    "dropdeladd": "3 CHARLES PL",
    "dropdelcty": "BROWNSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 175089998,
    "dropphyadd": "3 CHARLES PL",
    "dropphycty": "BROWNSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 175089998,
    "dropmaladd": "3 CHARLES PL",
    "dropmalcty": "BROWNSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 175089998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176567333,
    "dropsitcph": 7176567333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17399",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "100 CHARLES ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 154179998,
    "dropphyadd": "100 CHARLES ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 154179998,
    "dropmaladd": "100 CHARLES ST",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 154179998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247853023,
    "dropsitcph": 7247853023,
    "dropfax": 7247859495
  },
  {
    "dcode": "D",
    "dropkey": "PX17405",
    "droptype": "D",
    "dropname": "BRUIN",
    "dropdeladd": "105 WASHINGTON ST",
    "dropdelcty": "BRUIN",
    "dropdelst": "PA",
    "dropdelzpp": 160229800,
    "dropphyadd": "105 WASHINGTON ST",
    "dropphycty": "BRUIN",
    "dropphyst": "PA",
    "dropphyzpp": 160229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUIN",
    "dropmalst": "PA",
    "dropmalzpp": 160229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247532691,
    "dropsitcph": 7247532691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17409",
    "droptype": "D",
    "dropname": "BRUSH VALLEY",
    "dropdeladd": "5515 ROUTE 56 HWY E",
    "dropdelcty": "BRUSH VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 157209998,
    "dropphyadd": "5515 ROUTE 56 HWY E",
    "dropphycty": "BRUSH VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 157209998,
    "dropmaladd": "5515 ROUTE 56 HWY E",
    "dropmalcty": "BRUSH VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 157209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244799821,
    "dropsitcph": 7244799821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17414",
    "droptype": "D",
    "dropname": "BRYN ATHYN",
    "dropdeladd": "999 FETTERS MILL RD",
    "dropdelcty": "BRYN ATHYN",
    "dropdelst": "PA",
    "dropdelzpp": 190099900,
    "dropphyadd": "999 FETTERS MILL RD",
    "dropphycty": "BRYN ATHYN",
    "dropphyst": "PA",
    "dropphyzpp": 190099900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRYN ATHYN",
    "dropmalst": "PA",
    "dropmalzpp": 190099998,
    "dropsitphn": 2159471828,
    "dropsitlph": 2159471034,
    "dropsitcph": 2159471034,
    "dropfax": 2159472342
  },
  {
    "dcode": "D",
    "dropkey": "PX17416",
    "droptype": "D",
    "dropname": "BRYN MAWR",
    "dropdeladd": "16 N BRYN MAWR AVE",
    "dropdelcty": "BRYN MAWR",
    "dropdelst": "PA",
    "dropdelzpp": 190109998,
    "dropphyadd": "16 N BRYN MAWR AVE",
    "dropphycty": "BRYN MAWR",
    "dropphyst": "PA",
    "dropphyzpp": 190109998,
    "dropmaladd": "16 N BRYN MAWR AVE",
    "dropmalcty": "BRYN MAWR",
    "dropmalst": "PA",
    "dropmalzpp": 190109998,
    "dropsitphn": 2155207356,
    "dropsitlph": 6105207356,
    "dropsitcph": 6105252201,
    "dropfax": 6105259935
  },
  {
    "dcode": "D",
    "dropkey": "PX17419",
    "droptype": "D",
    "dropname": "BUCK HILL FALLS",
    "dropdeladd": "270 GOLF DR",
    "dropdelcty": "BUCK HILL FALLS",
    "dropdelst": "PA",
    "dropdelzpp": 183239998,
    "dropphyadd": "270 GOLF DR",
    "dropphycty": "BUCK HILL FALLS",
    "dropphyst": "PA",
    "dropphyzpp": 183239998,
    "dropmaladd": "270 GOLF DR",
    "dropmalcty": "BUCK HILL FALLS",
    "dropmalst": "PA",
    "dropmalzpp": 183239998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705953766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17425",
    "droptype": "D",
    "dropname": "BUCKINGHAM",
    "dropdeladd": "4657 YORK RD",
    "dropdelcty": "BUCKINGHAM",
    "dropdelst": "PA",
    "dropdelzpp": 189129998,
    "dropphyadd": "4657 YORK RD",
    "dropphycty": "BUCKINGHAM",
    "dropphyst": "PA",
    "dropphyzpp": 189129998,
    "dropmaladd": "4657 YORK RD",
    "dropmalcty": "BUCKINGHAM",
    "dropmalst": "PA",
    "dropmalzpp": 189129998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157947331,
    "dropsitcph": 2157947331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17427",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "125 CONROY ST",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "PA",
    "dropdelzpp": 150181001,
    "dropphyadd": "125 CONROY ST",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "PA",
    "dropphyzpp": 150181001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "PA",
    "dropmalzpp": 150189998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127518202,
    "dropsitcph": 4127518202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17432",
    "droptype": "D",
    "dropname": "BUFFALO MILLS",
    "dropdeladd": "8862 HYNDMAN RD",
    "dropdelcty": "BUFFALO MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 155349998,
    "dropphyadd": "8862 HYNDMAN RD",
    "dropphycty": "BUFFALO MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 155349998,
    "dropmaladd": "8862 HYNDMAN RD",
    "dropmalcty": "BUFFALO MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 155349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146238551,
    "dropsitcph": 8146238551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17436",
    "droptype": "D",
    "dropname": "BULGER",
    "dropdeladd": "1021 GRANT ST",
    "dropdelcty": "BULGER",
    "dropdelst": "PA",
    "dropdelzpp": 150191001,
    "dropphyadd": "1021 GRANT ST",
    "dropphycty": "BULGER",
    "dropphyst": "PA",
    "dropphyzpp": 150191001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BULGER",
    "dropmalst": "PA",
    "dropmalzpp": 150199998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247961676,
    "dropsitcph": 7247961676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17443",
    "droptype": "D",
    "dropname": "BUNOLA",
    "dropdeladd": "358 BUNOLA RIVER RD",
    "dropdelcty": "BUNOLA",
    "dropdelst": "PA",
    "dropdelzpp": 150201001,
    "dropphyadd": "358 BUNOLA RIVER RD",
    "dropphycty": "BUNOLA",
    "dropphyst": "PA",
    "dropphyzpp": 150201001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUNOLA",
    "dropmalst": "PA",
    "dropmalzpp": 150209998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123843532,
    "dropsitcph": 4123843532,
    "dropfax": 4123845074
  },
  {
    "dcode": "D",
    "dropkey": "PX17446",
    "droptype": "D",
    "dropname": "BURGETTSTOWN",
    "dropdeladd": "1602 MAIN ST",
    "dropdelcty": "BURGETTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 150219998,
    "dropphyadd": "1602 MAIN ST",
    "dropphycty": "BURGETTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 150219998,
    "dropmaladd": "1602 MAIN ST",
    "dropmalcty": "BURGETTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 150219998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249479519,
    "dropsitcph": 7249479519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17448",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "16658 ROUTE 6",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 188149998,
    "dropphyadd": "16658 ROUTE 6",
    "dropphycty": "BURLINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 188149998,
    "dropmaladd": "16658 ROUTE 6",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 188149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702972632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17450",
    "droptype": "D",
    "dropname": "BURNHAM",
    "dropdeladd": "229 N LOGAN BLVD",
    "dropdelcty": "BURNHAM",
    "dropdelst": "PA",
    "dropdelzpp": 170099998,
    "dropphyadd": "229 N LOGAN BLVD",
    "dropphycty": "BURNHAM",
    "dropphyst": "PA",
    "dropphyzpp": 170099998,
    "dropmaladd": "229 N LOGAN BLVD",
    "dropmalcty": "BURNHAM",
    "dropmalst": "PA",
    "dropmalzpp": 170099998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172482701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17453",
    "droptype": "D",
    "dropname": "BURNT CABINS",
    "dropdeladd": "233 GRIST MILL RD STE A",
    "dropdelcty": "BURNT CABINS",
    "dropdelst": "PA",
    "dropdelzpp": 172159998,
    "dropphyadd": "233 GRIST MILL RD STE A",
    "dropphycty": "BURNT CABINS",
    "dropphyst": "PA",
    "dropphyzpp": 172159998,
    "dropmaladd": "233 GRIST MILL RD STE A",
    "dropmalcty": "BURNT CABINS",
    "dropmalst": "PA",
    "dropmalzpp": 172159998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179873811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17454",
    "droptype": "D",
    "dropname": "BUSHKILL",
    "dropdeladd": "5527 BUSHKILL FALLS RD",
    "dropdelcty": "BUSHKILL",
    "dropdelst": "PA",
    "dropdelzpp": 183249998,
    "dropphyadd": "5527 BUSHKILL FALLS RD",
    "dropphycty": "BUSHKILL",
    "dropphyst": "PA",
    "dropphyzpp": 183249998,
    "dropmaladd": "5527 BUSHKILL FALLS RD",
    "dropmalcty": "BUSHKILL",
    "dropmalst": "PA",
    "dropmalzpp": 183249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705886514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17458",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "345 S MAIN ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "PA",
    "dropdelzpp": 160019998,
    "dropphyadd": "345 S MAIN ST",
    "dropphycty": "BUTLER",
    "dropphyst": "PA",
    "dropphyzpp": 160019998,
    "dropmaladd": "345 S MAIN ST",
    "dropmalcty": "BUTLER",
    "dropmalst": "PA",
    "dropmalzpp": 160019998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242871706,
    "dropsitcph": 7242146000,
    "dropfax": 7242146015
  },
  {
    "dcode": "D",
    "dropkey": "PX17463",
    "droptype": "D",
    "dropname": "BYRNEDALE",
    "dropdeladd": "19884 BENNETTS VALLEY HWY",
    "dropdelcty": "BYRNEDALE",
    "dropdelst": "PA",
    "dropdelzpp": 158279800,
    "dropphyadd": "19884 BENNETTS VALLEY HWY",
    "dropphycty": "BYRNEDALE",
    "dropphyst": "PA",
    "dropphyzpp": 158279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYRNEDALE",
    "dropmalst": "PA",
    "dropmalzpp": 158279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147878511,
    "dropsitcph": 8147878511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17467",
    "droptype": "D",
    "dropname": "CABOT",
    "dropdeladd": "452 WINFIELD RD",
    "dropdelcty": "CABOT",
    "dropdelst": "PA",
    "dropdelzpp": 160239800,
    "dropphyadd": "452 WINFIELD RD",
    "dropphycty": "CABOT",
    "dropphyst": "PA",
    "dropphyzpp": 160239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CABOT",
    "dropmalst": "PA",
    "dropmalzpp": 160239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243522113,
    "dropsitcph": 7243522113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17468",
    "droptype": "D",
    "dropname": "CADOGAN",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "CADOGAN",
    "dropdelst": "PA",
    "dropdelzpp": 162129800,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "CADOGAN",
    "dropphyst": "PA",
    "dropphyzpp": 162129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CADOGAN",
    "dropmalst": "PA",
    "dropmalzpp": 162129998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247638610,
    "dropsitcph": 7247638610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17470",
    "droptype": "D",
    "dropname": "CAIRNBROOK",
    "dropdeladd": "1 2ND ST",
    "dropdelcty": "CAIRNBROOK",
    "dropdelst": "PA",
    "dropdelzpp": 159249998,
    "dropphyadd": "1 2ND ST",
    "dropphycty": "CAIRNBROOK",
    "dropphyst": "PA",
    "dropphyzpp": 159249998,
    "dropmaladd": "1 2ND ST",
    "dropmalcty": "CAIRNBROOK",
    "dropmalst": "PA",
    "dropmalzpp": 159249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147544148,
    "dropsitcph": 8147544148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17474",
    "droptype": "D",
    "dropname": "CALIFORNIA",
    "dropdeladd": "430 2ND ST",
    "dropdelcty": "CALIFORNIA",
    "dropdelst": "PA",
    "dropdelzpp": 154199998,
    "dropphyadd": "430 2ND ST",
    "dropphycty": "CALIFORNIA",
    "dropphyst": "PA",
    "dropphyzpp": 154199998,
    "dropmaladd": "430 2ND ST",
    "dropmalcty": "CALIFORNIA",
    "dropmalst": "PA",
    "dropmalzpp": 154199998,
    "dropsitphn": 7249388100,
    "dropsitlph": 4123597568,
    "dropsitcph": 7249388100,
    "dropfax": 7249383599
  },
  {
    "dcode": "D",
    "dropkey": "PX17476",
    "droptype": "D",
    "dropname": "CALLENSBURG",
    "dropdeladd": "450A MAIN ST",
    "dropdelcty": "CALLENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 162139800,
    "dropphyadd": "450A MAIN ST",
    "dropphycty": "CALLENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 162139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALLENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 162139998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143582896,
    "dropsitcph": 8143582896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17477",
    "droptype": "D",
    "dropname": "CALLERY",
    "dropdeladd": "172 RAILROAD ST",
    "dropdelcty": "CALLERY",
    "dropdelst": "PA",
    "dropdelzpp": 160249800,
    "dropphyadd": "172 RAILROAD ST",
    "dropphycty": "CALLERY",
    "dropphyst": "PA",
    "dropphyzpp": 160249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALLERY",
    "dropmalst": "PA",
    "dropmalzpp": 160249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245383801,
    "dropsitcph": 7245383801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17480",
    "droptype": "D",
    "dropname": "CALVIN",
    "dropdeladd": "16281 TROUGH CREEK VALLEY PIKE",
    "dropdelcty": "CALVIN",
    "dropdelst": "PA",
    "dropdelzpp": 166229998,
    "dropphyadd": "16281 TROUGH CREEK VALLEY PIKE",
    "dropphycty": "CALVIN",
    "dropphyst": "PA",
    "dropphyzpp": 166229998,
    "dropmaladd": "16281 TROUGH CREEK VALLEY PIKE",
    "dropmalcty": "CALVIN",
    "dropmalst": "PA",
    "dropmalzpp": 166229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146434071,
    "dropsitcph": 8146434071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17482",
    "droptype": "D",
    "dropname": "CAMBRA",
    "dropdeladd": "1334 OLD TIOGA TPKE",
    "dropdelcty": "CAMBRA",
    "dropdelst": "PA",
    "dropdelzpp": 186119998,
    "dropphyadd": "1334 OLD TIOGA TPKE",
    "dropphycty": "CAMBRA",
    "dropphyst": "PA",
    "dropphyzpp": 186119998,
    "dropmaladd": "1334 OLD TIOGA TPKE",
    "dropmalcty": "CAMBRA",
    "dropmalst": "PA",
    "dropmalzpp": 186119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708642255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17483",
    "droptype": "D",
    "dropname": "CAMBRIDGE SPRINGS",
    "dropdeladd": "332 VENANGO AVE",
    "dropdelcty": "CAMBRIDGE SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 164031100,
    "dropphyadd": "332 VENANGO AVE",
    "dropphycty": "CAMBRIDGE SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 164031100,
    "dropmaladd": "332 VENANGO AVE",
    "dropmalcty": "CAMBRIDGE SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 164031100,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143982114,
    "dropsitcph": 8143982114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17487",
    "droptype": "D",
    "dropname": "CAMP HILL",
    "dropdeladd": "1675 CAMP HILL BYP",
    "dropdelcty": "CAMP HILL",
    "dropdelst": "PA",
    "dropdelzpp": 170119998,
    "dropphyadd": "1675 CAMP HILL BYP",
    "dropphycty": "CAMP HILL",
    "dropphyst": "PA",
    "dropphyzpp": 170119998,
    "dropmaladd": "1675 CAMP HILL BYP",
    "dropmalcty": "CAMP HILL",
    "dropmalst": "PA",
    "dropmalzpp": 170119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177371461,
    "dropfax": 7177370135
  },
  {
    "dcode": "D",
    "dropkey": "PX17488",
    "droptype": "D",
    "dropname": "CAMPBELLTOWN",
    "dropdeladd": "20 N PALMYRA RD",
    "dropdelcty": "CAMPBELLTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170109800,
    "dropphyadd": "20 N PALMYRA RD",
    "dropphycty": "CAMPBELLTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMPBELLTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178383021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17492",
    "droptype": "D",
    "dropname": "CANADENSIS",
    "dropdeladd": "4792 ROUTE 447",
    "dropdelcty": "CANADENSIS",
    "dropdelst": "PA",
    "dropdelzpp": 183259998,
    "dropphyadd": "4792 ROUTE 447",
    "dropphycty": "CANADENSIS",
    "dropphyst": "PA",
    "dropphyzpp": 183259998,
    "dropmaladd": "4792 ROUTE 447",
    "dropmalcty": "CANADENSIS",
    "dropmalst": "PA",
    "dropmalzpp": 183259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705952087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17495",
    "droptype": "D",
    "dropname": "CANONSBURG",
    "dropdeladd": "120 W PIKE ST",
    "dropdelcty": "CANONSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 153171316,
    "dropphyadd": "120 W PIKE ST",
    "dropphycty": "CANONSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 153171316,
    "dropmaladd": "120 W PIKE ST",
    "dropmalcty": "CANONSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 153171316,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248739067,
    "dropsitcph": 7247459042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17496",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "103 TROY ST",
    "dropdelcty": "CANTON",
    "dropdelst": "PA",
    "dropdelzpp": 177249998,
    "dropphyadd": "103 TROY ST",
    "dropphycty": "CANTON",
    "dropphyst": "PA",
    "dropphyzpp": 177249998,
    "dropmaladd": "103 TROY ST",
    "dropmalcty": "CANTON",
    "dropmalst": "PA",
    "dropmalzpp": 177249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706735697,
    "dropfax": 5709243061
  },
  {
    "dcode": "D",
    "dropkey": "PX17499",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "50 DUNDAFF ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "PA",
    "dropdelzpp": 184079998,
    "dropphyadd": "50 DUNDAFF ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "PA",
    "dropphyzpp": 184079998,
    "dropmaladd": "50 DUNDAFF ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "PA",
    "dropmalzpp": 184079998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702824260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17501",
    "droptype": "D",
    "dropname": "CARDALE",
    "dropdeladd": "258 FILBERT ORIENT RD",
    "dropdelcty": "CARDALE",
    "dropdelst": "PA",
    "dropdelzpp": 154201001,
    "dropphyadd": "258 FILBERT ORIENT RD",
    "dropphycty": "CARDALE",
    "dropphyst": "PA",
    "dropphyzpp": 154201001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARDALE",
    "dropmalst": "PA",
    "dropmalzpp": 154209998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242468730,
    "dropsitcph": 7242468730,
    "dropfax": 7242468730
  },
  {
    "dcode": "D",
    "dropkey": "PX17502",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "66 W LOUTHER ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "PA",
    "dropdelzpp": 170139998,
    "dropphyadd": "66 W LOUTHER ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "PA",
    "dropphyzpp": 170139998,
    "dropmaladd": "66 W LOUTHER ST",
    "dropmalcty": "CARLISLE",
    "dropmalst": "PA",
    "dropmalzpp": 170139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172433531,
    "dropfax": 7172435990
  },
  {
    "dcode": "D",
    "dropkey": "PX17506",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "1333 COCHRANTON RD",
    "dropdelcty": "CARLTON",
    "dropdelst": "PA",
    "dropdelzpp": 163119800,
    "dropphyadd": "1333 COCHRANTON RD",
    "dropphycty": "CARLTON",
    "dropphyst": "PA",
    "dropphyzpp": 163119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLTON",
    "dropmalst": "PA",
    "dropmalzpp": 163119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144252205,
    "dropsitcph": 8144252205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17507",
    "droptype": "D",
    "dropname": "CARMICHAELS",
    "dropdeladd": "111 N MARKET ST",
    "dropdelcty": "CARMICHAELS",
    "dropdelst": "PA",
    "dropdelzpp": 153209998,
    "dropphyadd": "111 N MARKET ST",
    "dropphycty": "CARMICHAELS",
    "dropphyst": "PA",
    "dropphyzpp": 153209998,
    "dropmaladd": "111 N MARKET ST",
    "dropmalcty": "CARMICHAELS",
    "dropmalst": "PA",
    "dropmalzpp": 153209998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249665231,
    "dropsitcph": 7249665231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17508",
    "droptype": "D",
    "dropname": "CARNEGIE",
    "dropdeladd": "139 E MAIN ST",
    "dropdelcty": "CARNEGIE",
    "dropdelst": "PA",
    "dropdelzpp": 151069998,
    "dropphyadd": "139 E MAIN ST",
    "dropphycty": "CARNEGIE",
    "dropphyst": "PA",
    "dropphyzpp": 151069998,
    "dropmaladd": "139 E MAIN ST",
    "dropmalcty": "CARNEGIE",
    "dropmalst": "PA",
    "dropmalzpp": 151069998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122762487,
    "dropsitcph": 4122762487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17513",
    "droptype": "D",
    "dropname": "CARROLLTOWN",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "CARROLLTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 157229998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "CARROLLTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 157229998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "CARROLLTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 157229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143448811,
    "dropsitcph": 8143448811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17519",
    "droptype": "D",
    "dropname": "CARVERSVILLE",
    "dropdeladd": "6208 FLEECY DALE RD",
    "dropdelcty": "CARVERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189139998,
    "dropphyadd": "6208 FLEECY DALE RD",
    "dropphycty": "CARVERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189139998,
    "dropmaladd": "6208 FLEECY DALE RD",
    "dropmalcty": "CARVERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189139998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152975222,
    "dropsitcph": 2152975222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17522",
    "droptype": "D",
    "dropname": "CASHTOWN",
    "dropdeladd": "372 HIGH ST",
    "dropdelcty": "CASHTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173109998,
    "dropphyadd": "372 HIGH ST",
    "dropphycty": "CASHTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173109998,
    "dropmaladd": "372 HIGH ST",
    "dropmalcty": "CASHTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173109998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173348515,
    "dropsitcph": 7173348515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17524",
    "droptype": "D",
    "dropname": "CASSANDRA",
    "dropdeladd": "156 MAIN ST STE 4",
    "dropdelcty": "CASSANDRA",
    "dropdelst": "PA",
    "dropdelzpp": 159259998,
    "dropphyadd": "156 MAIN ST STE 4",
    "dropphycty": "CASSANDRA",
    "dropphyst": "PA",
    "dropphyzpp": 159259998,
    "dropmaladd": "156 MAIN ST STE 4",
    "dropmalcty": "CASSANDRA",
    "dropmalst": "PA",
    "dropmalzpp": 159259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147363670,
    "dropsitcph": 8147363670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17525",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "211 CHERRY ST",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166239998,
    "dropphyadd": "211 CHERRY ST",
    "dropphycty": "CASSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166239998,
    "dropmaladd": "211 CHERRY ST",
    "dropmalcty": "CASSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144483905,
    "dropsitcph": 8144483905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17526",
    "droptype": "D",
    "dropname": "CASTANEA",
    "dropdeladd": "120 LOGAN AVE",
    "dropdelcty": "CASTANEA",
    "dropdelst": "PA",
    "dropdelzpp": 177269998,
    "dropphyadd": "120 LOGAN AVE",
    "dropphycty": "CASTANEA",
    "dropphyst": "PA",
    "dropphyzpp": 177269998,
    "dropmaladd": "120 LOGAN AVE",
    "dropmalcty": "CASTANEA",
    "dropmalst": "PA",
    "dropmalzpp": 177269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707482572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17535",
    "droptype": "D",
    "dropname": "CATASAUQUA",
    "dropdeladd": "205 BRIDGE ST",
    "dropdelcty": "CATASAUQUA",
    "dropdelst": "PA",
    "dropdelzpp": 180329998,
    "dropphyadd": "205 BRIDGE ST",
    "dropphycty": "CATASAUQUA",
    "dropphyst": "PA",
    "dropphyzpp": 180329998,
    "dropmaladd": "205 BRIDGE ST",
    "dropmalcty": "CATASAUQUA",
    "dropmalst": "PA",
    "dropmalzpp": 180329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102642681,
    "dropfax": 6102642630
  },
  {
    "dcode": "D",
    "dropkey": "PX17537",
    "droptype": "D",
    "dropname": "CATAWISSA",
    "dropdeladd": "121 N 3RD ST",
    "dropdelcty": "CATAWISSA",
    "dropdelst": "PA",
    "dropdelzpp": 178209998,
    "dropphyadd": "121 N 3RD ST",
    "dropphycty": "CATAWISSA",
    "dropphyst": "PA",
    "dropphyzpp": 178209998,
    "dropmaladd": "121 N 3RD ST",
    "dropmalcty": "CATAWISSA",
    "dropmalst": "PA",
    "dropmalzpp": 178209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703562319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17541",
    "droptype": "D",
    "dropname": "CECIL",
    "dropdeladd": "3333 MILLERS RUN RD",
    "dropdelcty": "CECIL",
    "dropdelst": "PA",
    "dropdelzpp": 153211001,
    "dropphyadd": "3333 MILLERS RUN RD",
    "dropphycty": "CECIL",
    "dropphyst": "PA",
    "dropphyzpp": 153211001,
    "dropmaladd": "3333 MILLERS RUN RD",
    "dropmalcty": "CECIL",
    "dropmalst": "PA",
    "dropmalzpp": 153211001,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122212337,
    "dropsitcph": 4122212337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17551",
    "droptype": "D",
    "dropname": "CEDARS",
    "dropdeladd": "3340 SKIPPACK PIKE",
    "dropdelcty": "CEDARS",
    "dropdelst": "PA",
    "dropdelzpp": 194239900,
    "dropphyadd": "3340 SKIPPACK PIKE",
    "dropphycty": "CEDARS",
    "dropphyst": "PA",
    "dropphyzpp": 194239900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDARS",
    "dropmalst": "PA",
    "dropmalzpp": 194239998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6105845098,
    "dropsitcph": 6105845098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17562",
    "droptype": "D",
    "dropname": "CENTER VALLEY",
    "dropdeladd": "5800 ROUTE 378",
    "dropdelcty": "CENTER VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 180349998,
    "dropphyadd": "5800 ROUTE 378",
    "dropphycty": "CENTER VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 180349998,
    "dropmaladd": "5800 ROUTE 378",
    "dropmalcty": "CENTER VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 180349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102823827,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17564",
    "droptype": "D",
    "dropname": "CENTERPORT",
    "dropdeladd": "106 E CHESTNUT ST",
    "dropdelcty": "CENTERPORT",
    "dropdelst": "PA",
    "dropdelzpp": 195169998,
    "dropphyadd": "106 E CHESTNUT ST",
    "dropphycty": "CENTERPORT",
    "dropphyst": "PA",
    "dropphyzpp": 195169998,
    "dropmaladd": "106 E CHESTNUT ST",
    "dropmalcty": "CENTERPORT",
    "dropmalst": "PA",
    "dropmalzpp": 195169998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109263586,
    "dropsitcph": 6109263586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17566",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "18599 ERIE ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 164049800,
    "dropphyadd": "18599 ERIE ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 164049800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 164049998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146547074,
    "dropsitcph": 8146547074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17573",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "1 SUNSHINE AVE",
    "dropdelcty": "CENTRAL CITY",
    "dropdelst": "PA",
    "dropdelzpp": 159269998,
    "dropphyadd": "1 SUNSHINE AVE",
    "dropphycty": "CENTRAL CITY",
    "dropphyst": "PA",
    "dropphyzpp": 159269998,
    "dropmaladd": "1 SUNSHINE AVE",
    "dropmalcty": "CENTRAL CITY",
    "dropmalst": "PA",
    "dropmalzpp": 159269998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147544011,
    "dropsitcph": 8147544011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17580",
    "droptype": "D",
    "dropname": "CENTRE HALL",
    "dropdeladd": "113 E CHURCH ST",
    "dropdelcty": "CENTRE HALL",
    "dropdelst": "PA",
    "dropdelzpp": 168289998,
    "dropphyadd": "113 E CHURCH ST",
    "dropphycty": "CENTRE HALL",
    "dropphyst": "PA",
    "dropphyzpp": 168289998,
    "dropmaladd": "113 E CHURCH ST",
    "dropmalcty": "CENTRE HALL",
    "dropmalst": "PA",
    "dropmalzpp": 168289998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143641895,
    "dropsitcph": 8143641895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17581",
    "droptype": "D",
    "dropname": "CHADDS FORD",
    "dropdeladd": "1620 BALTIMORE PIKE",
    "dropdelcty": "CHADDS FORD",
    "dropdelst": "PA",
    "dropdelzpp": 193179998,
    "dropphyadd": "1620 BALTIMORE PIKE",
    "dropphycty": "CHADDS FORD",
    "dropphyst": "PA",
    "dropphyzpp": 193179998,
    "dropmaladd": "1620 BALTIMORE PIKE",
    "dropmalcty": "CHADDS FORD",
    "dropmalst": "PA",
    "dropmalzpp": 193179998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103886284,
    "dropsitcph": 6103886284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17584",
    "droptype": "D",
    "dropname": "CHALFONT",
    "dropdeladd": "300 N MAIN ST",
    "dropdelcty": "CHALFONT",
    "dropdelst": "PA",
    "dropdelzpp": 189149998,
    "dropphyadd": "300 N MAIN ST",
    "dropphycty": "CHALFONT",
    "dropphyst": "PA",
    "dropphyzpp": 189149998,
    "dropmaladd": "300 N MAIN ST",
    "dropmalcty": "CHALFONT",
    "dropmalst": "PA",
    "dropmalzpp": 189149998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158220659,
    "dropsitcph": 2158220659,
    "dropfax": 2158229057
  },
  {
    "dcode": "D",
    "dropkey": "PX17585",
    "droptype": "D",
    "dropname": "CHALK HILL",
    "dropdeladd": "2963 NATIONAL PIKE",
    "dropdelcty": "CHALK HILL",
    "dropdelst": "PA",
    "dropdelzpp": 154211001,
    "dropphyadd": "2963 NATIONAL PIKE",
    "dropphycty": "CHALK HILL",
    "dropphyst": "PA",
    "dropphyzpp": 154211001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHALK HILL",
    "dropmalst": "PA",
    "dropmalzpp": 154219998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244392330,
    "dropsitcph": 7244392330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17587",
    "droptype": "D",
    "dropname": "CHAMBERSBURG",
    "dropdeladd": "308 LINCOLN WAY E",
    "dropdelcty": "CHAMBERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172019998,
    "dropphyadd": "308 LINCOLN WAY E",
    "dropphycty": "CHAMBERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172019998,
    "dropmaladd": "308 LINCOLN WAY E",
    "dropmalcty": "CHAMBERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172638581,
    "dropfax": 7172637940
  },
  {
    "dcode": "D",
    "dropkey": "PX17588",
    "droptype": "D",
    "dropname": "CHAMBERSVILLE",
    "dropdeladd": "3503 CHAMBERSVILLE RD",
    "dropdelcty": "CHAMBERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 157239998,
    "dropphyadd": "3503 CHAMBERSVILLE RD",
    "dropphycty": "CHAMBERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 157239998,
    "dropmaladd": "3503 CHAMBERSVILLE RD",
    "dropmalcty": "CHAMBERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 157239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244633230,
    "dropsitcph": 7244633230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17589",
    "droptype": "D",
    "dropname": "CHAMPION",
    "dropdeladd": "1410 COUNTY LINE RD",
    "dropdelcty": "CHAMPION",
    "dropdelst": "PA",
    "dropdelzpp": 156222046,
    "dropphyadd": "1410 COUNTY LINE RD",
    "dropphycty": "CHAMPION",
    "dropphyst": "PA",
    "dropphyzpp": 156222046,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMPION",
    "dropmalst": "PA",
    "dropmalzpp": 156229998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244553519,
    "dropsitcph": 7244553519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17590",
    "droptype": "D",
    "dropname": "CHANDLERS VALLEY",
    "dropdeladd": "9243 JACKSON RUN RD",
    "dropdelcty": "CHANDLERS VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 163129800,
    "dropphyadd": "9243 JACKSON RUN RD",
    "dropphycty": "CHANDLERS VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 163129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANDLERS VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 163129998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144895406,
    "dropsitcph": 8144895406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17593",
    "droptype": "D",
    "dropname": "CHARLEROI",
    "dropdeladd": "600 MCKEAN AVE",
    "dropdelcty": "CHARLEROI",
    "dropdelst": "PA",
    "dropdelzpp": 150229998,
    "dropphyadd": "600 MCKEAN AVE",
    "dropphycty": "CHARLEROI",
    "dropphyst": "PA",
    "dropphyzpp": 150229998,
    "dropmaladd": "600 MCKEAN AVE",
    "dropmalcty": "CHARLEROI",
    "dropmalst": "PA",
    "dropmalzpp": 150229998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244830381,
    "dropsitcph": 7244830381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17604",
    "droptype": "D",
    "dropname": "CHELTENHAM",
    "dropdeladd": "521 CENTRAL AVE",
    "dropdelcty": "CHELTENHAM",
    "dropdelst": "PA",
    "dropdelzpp": 190129998,
    "dropphyadd": "521 CENTRAL AVE",
    "dropphycty": "CHELTENHAM",
    "dropphyst": "PA",
    "dropphyzpp": 190129998,
    "dropmaladd": "521 CENTRAL AVE",
    "dropmalcty": "CHELTENHAM",
    "dropmalst": "PA",
    "dropmalzpp": 190129998,
    "dropsitphn": 2153798678,
    "dropsitlph": 2153798678,
    "dropsitcph": 2153798678,
    "dropfax": 2156630322
  },
  {
    "dcode": "D",
    "dropkey": "PX17610",
    "droptype": "D",
    "dropname": "CHERRY TREE",
    "dropdeladd": "550 S MAIN ST",
    "dropdelcty": "CHERRY TREE",
    "dropdelst": "PA",
    "dropdelzpp": 157249998,
    "dropphyadd": "550 S MAIN ST",
    "dropphycty": "CHERRY TREE",
    "dropphyst": "PA",
    "dropphyzpp": 157249998,
    "dropmaladd": "550 S MAIN ST",
    "dropmalcty": "CHERRY TREE",
    "dropmalst": "PA",
    "dropmalzpp": 157249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147439016,
    "dropsitcph": 8147439016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17611",
    "droptype": "D",
    "dropname": "CHERRYVILLE",
    "dropdeladd": "680 BLUE MOUNTAIN DR",
    "dropdelcty": "CHERRYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180359998,
    "dropphyadd": "680 BLUE MOUNTAIN DR",
    "dropphycty": "CHERRYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180359998,
    "dropmaladd": "680 BLUE MOUNTAIN DR",
    "dropmalcty": "CHERRYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107678811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17615",
    "droptype": "D",
    "dropname": "CHEST SPRINGS",
    "dropdeladd": "142 WASHINGTON ST",
    "dropdelcty": "CHEST SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 166249998,
    "dropphyadd": "142 WASHINGTON ST",
    "dropphycty": "CHEST SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 166249998,
    "dropmaladd": "142 WASHINGTON ST",
    "dropmalcty": "CHEST SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 166249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145234076,
    "dropsitcph": 8145234076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17616",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "400 EDGMONT AVE",
    "dropdelcty": "CHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 190139998,
    "dropphyadd": "400 EDGMONT AVE",
    "dropphycty": "CHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 190139998,
    "dropmaladd": "400 EDGMONT AVE",
    "dropmalcty": "CHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 190139998,
    "dropsitphn": 6108761265,
    "dropsitlph": 6108769823,
    "dropsitcph": 6108761265,
    "dropfax": 6108764070
  },
  {
    "dcode": "D",
    "dropkey": "PX17617",
    "droptype": "D",
    "dropname": "CHESTER HEIGHTS",
    "dropdeladd": "1 SMITHBRIDGE RD",
    "dropdelcty": "CHESTER HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 190179900,
    "dropphyadd": "1 SMITHBRIDGE RD",
    "dropphycty": "CHESTER HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 190179900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTER HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 190179998,
    "dropsitphn": 2154591937,
    "dropsitlph": 6104591937,
    "dropsitcph": 6104591937,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "PX17620",
    "droptype": "D",
    "dropname": "CHESTER SPRINGS",
    "dropdeladd": "1214 KIMBERTON RD",
    "dropdelcty": "CHESTER SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 194259998,
    "dropphyadd": "1214 KIMBERTON RD",
    "dropphycty": "CHESTER SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 194259998,
    "dropmaladd": "1214 KIMBERTON RD",
    "dropmalcty": "CHESTER SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 194259998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108279325,
    "dropsitcph": 6108279325,
    "dropfax": 6108273026
  },
  {
    "dcode": "D",
    "dropkey": "PX17626",
    "droptype": "D",
    "dropname": "CHESTNUT RIDGE",
    "dropdeladd": "402 3RD ST",
    "dropdelcty": "CHESTNUT RIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 154221001,
    "dropphyadd": "402 3RD ST",
    "dropphycty": "CHESTNUT RIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 154221001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTNUT RIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 154229998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246772840,
    "dropsitcph": 7246772840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17627",
    "droptype": "D",
    "dropname": "CHESWICK",
    "dropdeladd": "1601 PITTSBURGH ST",
    "dropdelcty": "CHESWICK",
    "dropdelst": "PA",
    "dropdelzpp": 150249998,
    "dropphyadd": "1601 PITTSBURGH ST",
    "dropphycty": "CHESWICK",
    "dropphyst": "PA",
    "dropphyzpp": 150249998,
    "dropmaladd": "1601 PITTSBURGH ST",
    "dropmalcty": "CHESWICK",
    "dropmalst": "PA",
    "dropmalzpp": 150249998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242745757,
    "dropsitcph": 7242745757,
    "dropfax": 7242744166
  },
  {
    "dcode": "D",
    "dropkey": "PX17628",
    "droptype": "D",
    "dropname": "CHEYNEY",
    "dropdeladd": "119 STATION RD",
    "dropdelcty": "CHEYNEY",
    "dropdelst": "PA",
    "dropdelzpp": 193199998,
    "dropphyadd": "119 STATION RD",
    "dropphycty": "CHEYNEY",
    "dropphyst": "PA",
    "dropphyzpp": 193199998,
    "dropmaladd": "119 STATION RD",
    "dropmalcty": "CHEYNEY",
    "dropmalst": "PA",
    "dropmalzpp": 193199998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103990239,
    "dropsitcph": 6103990239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17630",
    "droptype": "D",
    "dropname": "CHICORA",
    "dropdeladd": "132 W SLIPPERY ROCK ST",
    "dropdelcty": "CHICORA",
    "dropdelst": "PA",
    "dropdelzpp": 160259800,
    "dropphyadd": "132 W SLIPPERY ROCK ST",
    "dropphycty": "CHICORA",
    "dropphyst": "PA",
    "dropphyzpp": 160259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHICORA",
    "dropmalst": "PA",
    "dropmalzpp": 160259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244452011,
    "dropsitcph": 7244452011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17634",
    "droptype": "D",
    "dropname": "CHINCHILLA",
    "dropdeladd": "555 NORTHERN BLVD",
    "dropdelcty": "CHINCHILLA",
    "dropdelst": "PA",
    "dropdelzpp": 184109998,
    "dropphyadd": "555 NORTHERN BLVD",
    "dropphycty": "CHINCHILLA",
    "dropphyst": "PA",
    "dropphyzpp": 184109998,
    "dropmaladd": "555 NORTHERN BLVD",
    "dropmalcty": "CHINCHILLA",
    "dropmalst": "PA",
    "dropmalzpp": 184109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705860681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17635",
    "droptype": "D",
    "dropname": "CHRISTIANA",
    "dropdeladd": "19 N BRIDGE ST",
    "dropdelcty": "CHRISTIANA",
    "dropdelst": "PA",
    "dropdelzpp": 175099998,
    "dropphyadd": "19 N BRIDGE ST",
    "dropphycty": "CHRISTIANA",
    "dropphyst": "PA",
    "dropphyzpp": 175099998,
    "dropmaladd": "19 N BRIDGE ST",
    "dropmalcty": "CHRISTIANA",
    "dropmalst": "PA",
    "dropmalzpp": 175099998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105935050,
    "dropsitcph": 6105935050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17645",
    "droptype": "D",
    "dropname": "CLAIRTON",
    "dropdeladd": "445 SAINT CLAIR AVE",
    "dropdelcty": "CLAIRTON",
    "dropdelst": "PA",
    "dropdelzpp": 150259998,
    "dropphyadd": "445 SAINT CLAIR AVE",
    "dropphycty": "CLAIRTON",
    "dropphyst": "PA",
    "dropphyzpp": 150259998,
    "dropmaladd": "445 SAINT CLAIR AVE",
    "dropmalcty": "CLAIRTON",
    "dropmalst": "PA",
    "dropmalzpp": 150259998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122332754,
    "dropsitcph": 4122332754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17646",
    "droptype": "D",
    "dropname": "CLARENCE",
    "dropdeladd": "788 CLARENCE RD",
    "dropdelcty": "CLARENCE",
    "dropdelst": "PA",
    "dropdelzpp": 168299998,
    "dropphyadd": "788 CLARENCE RD",
    "dropphycty": "CLARENCE",
    "dropphyst": "PA",
    "dropphyzpp": 168299998,
    "dropmaladd": "788 CLARENCE RD",
    "dropmalcty": "CLARENCE",
    "dropmalst": "PA",
    "dropmalzpp": 168299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143876993,
    "dropsitcph": 8143876993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17647",
    "droptype": "D",
    "dropname": "CLARENDON",
    "dropdeladd": "11 S MAIN ST",
    "dropdelcty": "CLARENDON",
    "dropdelst": "PA",
    "dropdelzpp": 163139800,
    "dropphyadd": "11 S MAIN ST",
    "dropphycty": "CLARENDON",
    "dropphyst": "PA",
    "dropphyzpp": 163139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARENDON",
    "dropmalst": "PA",
    "dropmalzpp": 163139998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147232648,
    "dropsitcph": 8147232648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17648",
    "droptype": "D",
    "dropname": "CLARIDGE",
    "dropdeladd": "3162 MAIN ST",
    "dropdelcty": "CLARIDGE",
    "dropdelst": "PA",
    "dropdelzpp": 156231001,
    "dropphyadd": "3162 MAIN ST",
    "dropphycty": "CLARIDGE",
    "dropphyst": "PA",
    "dropphyzpp": 156231001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARIDGE",
    "dropmalst": "PA",
    "dropmalzpp": 156239998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247442002,
    "dropsitcph": 7247442002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17650",
    "droptype": "D",
    "dropname": "CLARION",
    "dropdeladd": "626 MAIN ST",
    "dropdelcty": "CLARION",
    "dropdelst": "PA",
    "dropdelzpp": 162141100,
    "dropphyadd": "626 MAIN ST",
    "dropphycty": "CLARION",
    "dropphyst": "PA",
    "dropphyzpp": 162141100,
    "dropmaladd": "626 MAIN ST",
    "dropmalcty": "CLARION",
    "dropmalst": "PA",
    "dropmalzpp": 162141100,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142269250,
    "dropsitcph": 8142269250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17651",
    "droptype": "D",
    "dropname": "CLARK",
    "dropdeladd": "6 CHARLES ST",
    "dropdelcty": "CLARK",
    "dropdelst": "PA",
    "dropdelzpp": 161139800,
    "dropphyadd": "6 CHARLES ST",
    "dropphycty": "CLARK",
    "dropphyst": "PA",
    "dropphyzpp": 161139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARK",
    "dropmalst": "PA",
    "dropmalzpp": 161139998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249625781,
    "dropsitcph": 7249625781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17654",
    "droptype": "D",
    "dropname": "CLARKS MILLS",
    "dropdeladd": "21 LAKE WILHELM RD",
    "dropdelcty": "CLARKS MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 161149800,
    "dropphyadd": "21 LAKE WILHELM RD",
    "dropphycty": "CLARKS MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 161149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKS MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 161149998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242534040,
    "dropsitcph": 7242534040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17656",
    "droptype": "D",
    "dropname": "CLARKS SUMMIT",
    "dropdeladd": "117 S STATE ST",
    "dropdelcty": "CLARKS SUMMIT",
    "dropdelst": "PA",
    "dropdelzpp": 184119998,
    "dropphyadd": "117 S STATE ST",
    "dropphycty": "CLARKS SUMMIT",
    "dropphyst": "PA",
    "dropphyzpp": 184119998,
    "dropmaladd": "117 S STATE ST",
    "dropmalcty": "CLARKS SUMMIT",
    "dropmalst": "PA",
    "dropmalzpp": 184119998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705860316,
    "dropfax": 5705866621
  },
  {
    "dcode": "D",
    "dropkey": "PX17658",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "15555 ROUTE 286 HWY W",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 157259998,
    "dropphyadd": "15555 ROUTE 286 HWY W",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 157259998,
    "dropmaladd": "15555 ROUTE 286 HWY W",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 157259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246393241,
    "dropsitcph": 7246393241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17660",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "541 CENTER ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153221001,
    "dropphyadd": "541 CENTER ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153221001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153229998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243452532,
    "dropsitcph": 7243452532,
    "dropfax": 7243452535
  },
  {
    "dcode": "D",
    "dropkey": "PX17667",
    "droptype": "D",
    "dropname": "CLAYSBURG",
    "dropdeladd": "806 BEDFORD ST",
    "dropdelcty": "CLAYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166257706,
    "dropphyadd": "806 BEDFORD ST",
    "dropphycty": "CLAYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166257706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142395440,
    "dropsitcph": 8142395440,
    "dropfax": 8142399236
  },
  {
    "dcode": "D",
    "dropkey": "PX17668",
    "droptype": "D",
    "dropname": "CLAYSVILLE",
    "dropdeladd": "146 MAIN ST",
    "dropdelcty": "CLAYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153239998,
    "dropphyadd": "146 MAIN ST",
    "dropphycty": "CLAYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153239998,
    "dropmaladd": "146 MAIN ST",
    "dropmalcty": "CLAYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153239998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246637716,
    "dropsitcph": 7246637716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17673",
    "droptype": "D",
    "dropname": "CLEARFIELD",
    "dropdeladd": "118 N 2ND ST",
    "dropdelcty": "CLEARFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 168309998,
    "dropphyadd": "118 N 2ND ST",
    "dropphycty": "CLEARFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 168309998,
    "dropmaladd": "118 N 2ND ST",
    "dropmalcty": "CLEARFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 168309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147655671,
    "dropsitcph": 8147655671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17674",
    "droptype": "D",
    "dropname": "CLEARVILLE",
    "dropdeladd": "8156 CLEAR RIDGE RD",
    "dropdelcty": "CLEARVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 155359998,
    "dropphyadd": "8156 CLEAR RIDGE RD",
    "dropphycty": "CLEARVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 155359998,
    "dropmaladd": "8156 CLEAR RIDGE RD",
    "dropmalcty": "CLEARVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 155359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147845438,
    "dropsitcph": 8147845438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17681",
    "droptype": "D",
    "dropname": "CLIFFORD",
    "dropdeladd": "1748 STATE ROUTE 106",
    "dropdelcty": "CLIFFORD",
    "dropdelst": "PA",
    "dropdelzpp": 184139998,
    "dropphyadd": "1748 STATE ROUTE 106",
    "dropphycty": "CLIFFORD",
    "dropphyst": "PA",
    "dropphyzpp": 184139998,
    "dropmaladd": "1748 STATE ROUTE 106",
    "dropmalcty": "CLIFFORD",
    "dropmalst": "PA",
    "dropmalzpp": 184139998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702224802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17682",
    "droptype": "D",
    "dropname": "CLIFTON HEIGHTS",
    "dropdeladd": "135 S SPRINGFIELD RD",
    "dropdelcty": "CLIFTON HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 190182325,
    "dropphyadd": "135 S SPRINGFIELD RD",
    "dropphycty": "CLIFTON HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 190189998,
    "dropmaladd": "135 S SPRINGFIELD RD",
    "dropmalcty": "CLIFTON HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 190189998,
    "dropsitphn": 6106235926,
    "dropsitlph": 6106221488,
    "dropsitcph": 6106225926,
    "dropfax": 6106230471
  },
  {
    "dcode": "D",
    "dropkey": "PX17686",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "3738 WASHINGTON RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "PA",
    "dropdelzpp": 150261001,
    "dropphyadd": "3738 WASHINGTON RD",
    "dropphycty": "CLINTON",
    "dropphyst": "PA",
    "dropphyzpp": 150261001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLINTON",
    "dropmalst": "PA",
    "dropmalzpp": 150269998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246950114,
    "dropsitcph": 7246950114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17689",
    "droptype": "D",
    "dropname": "CLINTONVILLE",
    "dropdeladd": "201 IRWIN ST",
    "dropdelcty": "CLINTONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163729800,
    "dropphyadd": "201 IRWIN ST",
    "dropphycty": "CLINTONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLINTONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163729998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143856623,
    "dropsitcph": 8143856623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17690",
    "droptype": "D",
    "dropname": "CLUNE",
    "dropdeladd": "2021 COAL RUN RD",
    "dropdelcty": "CLUNE",
    "dropdelst": "PA",
    "dropdelzpp": 157279998,
    "dropphyadd": "2021 COAL RUN RD",
    "dropphycty": "CLUNE",
    "dropphyst": "PA",
    "dropphyzpp": 157279998,
    "dropmaladd": "2021 COAL RUN RD",
    "dropmalcty": "CLUNE",
    "dropmalst": "PA",
    "dropmalzpp": 157279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247268040,
    "dropsitcph": 7247268040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17692",
    "droptype": "D",
    "dropname": "CLYMER",
    "dropdeladd": "735 FRANKLIN ST",
    "dropdelcty": "CLYMER",
    "dropdelst": "PA",
    "dropdelzpp": 157289998,
    "dropphyadd": "735 FRANKLIN ST",
    "dropphycty": "CLYMER",
    "dropphyst": "PA",
    "dropphyzpp": 157289998,
    "dropmaladd": "735 FRANKLIN ST",
    "dropmalcty": "CLYMER",
    "dropmalst": "PA",
    "dropmalzpp": 157289998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242542851,
    "dropsitcph": 7242542851,
    "dropfax": 7242541433
  },
  {
    "dcode": "D",
    "dropkey": "PX17697",
    "droptype": "D",
    "dropname": "COAL CENTER",
    "dropdeladd": "109 SPRING ST",
    "dropdelcty": "COAL CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 154231055,
    "dropphyadd": "109 SPRING ST",
    "dropphycty": "COAL CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 154231055,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COAL CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 154239998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249361466,
    "dropsitcph": 7249361466,
    "dropfax": 7249361467
  },
  {
    "dcode": "D",
    "dropkey": "PX17700",
    "droptype": "D",
    "dropname": "COALDALE",
    "dropdeladd": "145 3RD ST",
    "dropdelcty": "COALDALE",
    "dropdelst": "PA",
    "dropdelzpp": 182189998,
    "dropphyadd": "145 3RD ST",
    "dropphycty": "COALDALE",
    "dropphyst": "PA",
    "dropphyzpp": 182189998,
    "dropmaladd": "145 3RD ST",
    "dropmalcty": "COALDALE",
    "dropmalst": "PA",
    "dropmalzpp": 182189998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706459252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17702",
    "droptype": "D",
    "dropname": "COALPORT",
    "dropdeladd": "745 MAIN ST",
    "dropdelcty": "COALPORT",
    "dropdelst": "PA",
    "dropdelzpp": 166279998,
    "dropphyadd": "745 MAIN ST",
    "dropphycty": "COALPORT",
    "dropphyst": "PA",
    "dropphyzpp": 166279998,
    "dropmaladd": "745 MAIN ST",
    "dropmalcty": "COALPORT",
    "dropmalst": "PA",
    "dropmalzpp": 166279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146723777,
    "dropsitcph": 8146723777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17703",
    "droptype": "D",
    "dropname": "COATESVILLE",
    "dropdeladd": "230 E CHESTNUT ST",
    "dropdelcty": "COATESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193209998,
    "dropphyadd": "230 E CHESTNUT ST",
    "dropphycty": "COATESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193209998,
    "dropmaladd": "230 E CHESTNUT ST",
    "dropmalcty": "COATESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193209998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103845130,
    "dropsitcph": 6103845130,
    "dropfax": 6103848902
  },
  {
    "dcode": "D",
    "dropkey": "PX17705",
    "droptype": "D",
    "dropname": "COBURN",
    "dropdeladd": "124 B ALY",
    "dropdelcty": "COBURN",
    "dropdelst": "PA",
    "dropdelzpp": 168329998,
    "dropphyadd": "124 B ALY",
    "dropphycty": "COBURN",
    "dropphyst": "PA",
    "dropphyzpp": 168329998,
    "dropmaladd": "124 B ALY",
    "dropmalcty": "COBURN",
    "dropmalst": "PA",
    "dropmalzpp": 168329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143495009,
    "dropsitcph": 8143495009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17706",
    "droptype": "D",
    "dropname": "COCHRANTON",
    "dropdeladd": "107 N FRANKLIN ST",
    "dropdelcty": "COCHRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 163149800,
    "dropphyadd": "107 N FRANKLIN ST",
    "dropphycty": "COCHRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 163149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COCHRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 163149998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144253467,
    "dropsitcph": 8144253467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17707",
    "droptype": "D",
    "dropname": "COCHRANVILLE",
    "dropdeladd": "1030 GAP NEWPORT PIKE",
    "dropdelcty": "COCHRANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193309998,
    "dropphyadd": "1030 GAP NEWPORT PIKE",
    "dropphycty": "COCHRANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193309998,
    "dropmaladd": "1030 GAP NEWPORT PIKE",
    "dropmalcty": "COCHRANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193309998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6105936739,
    "dropsitcph": 6105936739,
    "dropfax": 6105933095
  },
  {
    "dcode": "D",
    "dropkey": "PX17708",
    "droptype": "D",
    "dropname": "COCOLAMUS",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "COCOLAMUS",
    "dropdelst": "PA",
    "dropdelzpp": 170149800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "COCOLAMUS",
    "dropphyst": "PA",
    "dropphyzpp": 170149800,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "COCOLAMUS",
    "dropmalst": "PA",
    "dropmalzpp": 170149800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174633834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17709",
    "droptype": "D",
    "dropname": "CODORUS",
    "dropdeladd": "11 BALTIMORE ST",
    "dropdelcty": "CODORUS",
    "dropdelst": "PA",
    "dropdelzpp": 173119998,
    "dropphyadd": "11 BALTIMORE ST",
    "dropphycty": "CODORUS",
    "dropphyst": "PA",
    "dropphyzpp": 173119998,
    "dropmaladd": "11 BALTIMORE ST",
    "dropmalcty": "CODORUS",
    "dropmalst": "PA",
    "dropmalzpp": 173119998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172292493,
    "dropsitcph": 7172292493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17712",
    "droptype": "D",
    "dropname": "COGAN STATION",
    "dropdeladd": "4772 LYCOMING CREEK RD",
    "dropdelcty": "COGAN STATION",
    "dropdelst": "PA",
    "dropdelzpp": 177289998,
    "dropphyadd": "4772 LYCOMING CREEK RD",
    "dropphycty": "COGAN STATION",
    "dropphyst": "PA",
    "dropphyzpp": 177289998,
    "dropmaladd": "4772 LYCOMING CREEK RD",
    "dropmalcty": "COGAN STATION",
    "dropmalst": "PA",
    "dropmalzpp": 177289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204100,
    "dropsitcph": 5704940291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17713",
    "droptype": "D",
    "dropname": "COKEBURG",
    "dropdeladd": "0 MADISON ST",
    "dropdelcty": "COKEBURG",
    "dropdelst": "PA",
    "dropdelzpp": 153241001,
    "dropphyadd": "0 MADISON ST",
    "dropphycty": "COKEBURG",
    "dropphyst": "PA",
    "dropphyzpp": 153241001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COKEBURG",
    "dropmalst": "PA",
    "dropmalzpp": 153249998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249455202,
    "dropsitcph": 7249455202,
    "dropfax": 7249455203
  },
  {
    "dcode": "D",
    "dropkey": "PX17729",
    "droptype": "D",
    "dropname": "COLLEGEVILLE",
    "dropdeladd": "52 W THIRD AVE",
    "dropdelcty": "COLLEGEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194269998,
    "dropphyadd": "52 W THIRD AVE",
    "dropphycty": "COLLEGEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194269998,
    "dropmaladd": "52 W THIRD AVE",
    "dropmalcty": "COLLEGEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194269998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104090572,
    "dropsitcph": 6104090572,
    "dropfax": 6104098104
  },
  {
    "dcode": "D",
    "dropkey": "PX17734",
    "droptype": "D",
    "dropname": "COLMAR",
    "dropdeladd": "104 BETHLEHEM PIKE",
    "dropdelcty": "COLMAR",
    "dropdelst": "PA",
    "dropdelzpp": 189159998,
    "dropphyadd": "104 BETHLEHEM PIKE",
    "dropphycty": "COLMAR",
    "dropphyst": "PA",
    "dropphyzpp": 189159998,
    "dropmaladd": "104 BETHLEHEM PIKE",
    "dropmalcty": "COLMAR",
    "dropmalst": "PA",
    "dropmalzpp": 189159998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158220342,
    "dropsitcph": 2158220342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17741",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "53 N 4TH ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "PA",
    "dropdelzpp": 175129998,
    "dropphyadd": "53 N 4TH ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "PA",
    "dropphyzpp": 175129998,
    "dropmaladd": "53 N 4TH ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "PA",
    "dropmalzpp": 175129998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176845391,
    "dropsitcph": 7176845391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17742",
    "droptype": "D",
    "dropname": "COLUMBIA CROSS ROADS",
    "dropdeladd": "6921 AUSTINVILLE RD",
    "dropdelcty": "COLUMBIA CROSS ROADS",
    "dropdelst": "PA",
    "dropdelzpp": 169149998,
    "dropphyadd": "6921 AUSTINVILLE RD",
    "dropphycty": "COLUMBIA CROSS ROADS",
    "dropphyst": "PA",
    "dropphyzpp": 169149998,
    "dropmaladd": "6921 AUSTINVILLE RD",
    "dropmalcty": "COLUMBIA CROSS ROADS",
    "dropmalst": "PA",
    "dropmalzpp": 169149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5702974225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17744",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "PA",
    "dropdelzpp": 164059800,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "PA",
    "dropphyzpp": 164059800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "PA",
    "dropmalzpp": 164059998,
    "dropsitphn": 8146644911,
    "dropsitlph": 8146642234,
    "dropsitcph": 8146642234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17745",
    "droptype": "D",
    "dropname": "COLVER",
    "dropdeladd": "43 REESE AVE STE 1",
    "dropdelcty": "COLVER",
    "dropdelst": "PA",
    "dropdelzpp": 159279998,
    "dropphyadd": "43 REESE AVE STE 1",
    "dropphycty": "COLVER",
    "dropphyst": "PA",
    "dropphyzpp": 159279998,
    "dropmaladd": "43 REESE AVE STE 1",
    "dropmalcty": "COLVER",
    "dropmalst": "PA",
    "dropmalzpp": 159279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147487200,
    "dropsitcph": 8147487200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17750",
    "droptype": "D",
    "dropname": "COMMODORE",
    "dropdeladd": "5 VANDERBILT ST",
    "dropdelcty": "COMMODORE",
    "dropdelst": "PA",
    "dropdelzpp": 157299998,
    "dropphyadd": "5 VANDERBILT ST",
    "dropphycty": "COMMODORE",
    "dropphyst": "PA",
    "dropphyzpp": 157299998,
    "dropmaladd": "5 VANDERBILT ST",
    "dropmalcty": "COMMODORE",
    "dropmalst": "PA",
    "dropmalzpp": 157299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242544142,
    "dropsitcph": 7242544142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17753",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "18204 PATH VALLEY RD",
    "dropdelcty": "DRY RUN",
    "dropdelst": "PA",
    "dropdelzpp": 172209800,
    "dropphyadd": "18204 PATH VALLEY RD",
    "dropphycty": "DRY RUN",
    "dropphyst": "PA",
    "dropphyzpp": 172209800,
    "dropmaladd": "18204 PATH VALLEY RD",
    "dropmalcty": "DRY RUN",
    "dropmalst": "PA",
    "dropmalzpp": 172209800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173492876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17755",
    "droptype": "D",
    "dropname": "CONCORDVILLE",
    "dropdeladd": "817 BALTIMORE PIKE",
    "dropdelcty": "CONCORDVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193319998,
    "dropphyadd": "817 BALTIMORE PIKE",
    "dropphycty": "CONCORDVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193319998,
    "dropmaladd": "99 ALDAN AVE FRNT",
    "dropmalcty": "GLEN MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 193422702,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104592113,
    "dropsitcph": 6104592113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17756",
    "droptype": "D",
    "dropname": "CONESTOGA",
    "dropdeladd": "1 RIVER CORNER RD",
    "dropdelcty": "CONESTOGA",
    "dropdelst": "PA",
    "dropdelzpp": 175169998,
    "dropphyadd": "1 RIVER CORNER RD",
    "dropphycty": "CONESTOGA",
    "dropphyst": "PA",
    "dropphyzpp": 175169998,
    "dropmaladd": "1 RIVER CORNER RD",
    "dropmalcty": "CONESTOGA",
    "dropmalst": "PA",
    "dropmalzpp": 175169998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7178725961,
    "dropsitcph": 7178725961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17759",
    "droptype": "D",
    "dropname": "CONFLUENCE",
    "dropdeladd": "512 HUGART ST",
    "dropdelcty": "CONFLUENCE",
    "dropdelst": "PA",
    "dropdelzpp": 154249998,
    "dropphyadd": "512 HUGART ST",
    "dropphycty": "CONFLUENCE",
    "dropphyst": "PA",
    "dropphyzpp": 154249998,
    "dropmaladd": "512 HUGART ST",
    "dropmalcty": "CONFLUENCE",
    "dropmalst": "PA",
    "dropmalzpp": 154249998,
    "dropsitphn": 4123597568,
    "dropsitlph": 8143955592,
    "dropsitcph": 8143955592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17761",
    "droptype": "D",
    "dropname": "CONNEAUT LAKE",
    "dropdeladd": "170 N 4TH ST",
    "dropdelcty": "CONNEAUT LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 163169800,
    "dropphyadd": "170 N 4TH ST",
    "dropphycty": "CONNEAUT LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 163169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONNEAUT LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 163169998,
    "dropsitphn": 8143823525,
    "dropsitlph": 8143823525,
    "dropsitcph": 8143823525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17763",
    "droptype": "D",
    "dropname": "CONNEAUTVILLE",
    "dropdeladd": "809 MAIN ST",
    "dropdelcty": "CONNEAUTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 164069800,
    "dropphyadd": "809 MAIN ST",
    "dropphycty": "CONNEAUTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 164069800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONNEAUTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 164069998,
    "dropsitphn": 8145873727,
    "dropsitlph": 8145873727,
    "dropsitcph": 8145873727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17764",
    "droptype": "D",
    "dropname": "CONNELLSVILLE",
    "dropdeladd": "115 N ARCH ST",
    "dropdelcty": "CONNELLSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 154259998,
    "dropphyadd": "115 N ARCH ST",
    "dropphycty": "CONNELLSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 154259998,
    "dropmaladd": "115 N ARCH ST",
    "dropmalcty": "CONNELLSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 154259998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246287296,
    "dropsitcph": 7246287296,
    "dropfax": 7246281699
  },
  {
    "dcode": "D",
    "dropkey": "PX17767",
    "droptype": "D",
    "dropname": "CONNOQUENESSING",
    "dropdeladd": "175 CONNOQUENESSING MAIN ST",
    "dropdelcty": "CONNOQUENESSING",
    "dropdelst": "PA",
    "dropdelzpp": 160279800,
    "dropphyadd": "175 CONNOQUENESSING MAIN ST",
    "dropphycty": "CONNOQUENESSING",
    "dropphyst": "PA",
    "dropphyzpp": 160279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONNOQUENESSING",
    "dropmalst": "PA",
    "dropmalzpp": 160279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247897440,
    "dropsitcph": 7247897440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17769",
    "droptype": "D",
    "dropname": "CONSHOHOCKEN",
    "dropdeladd": "425 FAYETTE ST",
    "dropdelcty": "CONSHOHOCKEN",
    "dropdelst": "PA",
    "dropdelzpp": 194289998,
    "dropphyadd": "425 FAYETTE ST",
    "dropphycty": "CONSHOHOCKEN",
    "dropphyst": "PA",
    "dropphyzpp": 194289998,
    "dropmaladd": "425 FAYETTE ST",
    "dropmalcty": "CONSHOHOCKEN",
    "dropmalst": "PA",
    "dropmalzpp": 194289998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108349025,
    "dropsitcph": 6108349025,
    "dropfax": 6102708898
  },
  {
    "dcode": "D",
    "dropkey": "PX17771",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "1216 3RD AVE",
    "dropdelcty": "CONWAY",
    "dropdelst": "PA",
    "dropdelzpp": 150279998,
    "dropphyadd": "1216 3RD AVE",
    "dropphycty": "CONWAY",
    "dropphyst": "PA",
    "dropphyzpp": 150279998,
    "dropmaladd": "1216 3RD AVE",
    "dropmalcty": "CONWAY",
    "dropmalst": "PA",
    "dropmalzpp": 150279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248692328,
    "dropsitcph": 7248692328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17773",
    "droptype": "D",
    "dropname": "CONYNGHAM",
    "dropdeladd": "366 MAIN ST",
    "dropdelcty": "CONYNGHAM",
    "dropdelst": "PA",
    "dropdelzpp": 182199998,
    "dropphyadd": "366 MAIN ST",
    "dropphycty": "CONYNGHAM",
    "dropphyst": "PA",
    "dropphyzpp": 182199998,
    "dropmaladd": "366 MAIN ST",
    "dropmalcty": "CONYNGHAM",
    "dropmalst": "PA",
    "dropmalzpp": 182199998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707882929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17776",
    "droptype": "D",
    "dropname": "COOKSBURG",
    "dropdeladd": "115 RIVERSIDE DR STE 1",
    "dropdelcty": "COOKSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 162179800,
    "dropphyadd": "115 RIVERSIDE DR STE 1",
    "dropphycty": "COOKSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 162179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOKSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 162179998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147448508,
    "dropsitcph": 8147448508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17780",
    "droptype": "D",
    "dropname": "COOPERSBURG",
    "dropdeladd": "400 E STATION AVE",
    "dropdelcty": "COOPERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 180369998,
    "dropphyadd": "400 E STATION AVE",
    "dropphycty": "COOPERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 180369998,
    "dropmaladd": "400 E STATION AVE",
    "dropmalcty": "COOPERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 180369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102821500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17781",
    "droptype": "D",
    "dropname": "COOPERSTOWN",
    "dropdeladd": "137 BRADLEYTOWN RD",
    "dropdelcty": "COOPERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 163179800,
    "dropphyadd": "137 BRADLEYTOWN RD",
    "dropphycty": "COOPERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 163179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOPERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 163179998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143744314,
    "dropsitcph": 8143744314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17783",
    "droptype": "D",
    "dropname": "COPLAY",
    "dropdeladd": "918 CHESTNUT ST",
    "dropdelcty": "COPLAY",
    "dropdelst": "PA",
    "dropdelzpp": 180379998,
    "dropphyadd": "918 CHESTNUT ST",
    "dropphycty": "COPLAY",
    "dropphyst": "PA",
    "dropphyzpp": 180379998,
    "dropmaladd": "918 CHESTNUT ST",
    "dropmalcty": "COPLAY",
    "dropmalst": "PA",
    "dropmalzpp": 180379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102624681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17784",
    "droptype": "D",
    "dropname": "CORAL",
    "dropdeladd": "525 1ST ST",
    "dropdelcty": "CORAL",
    "dropdelst": "PA",
    "dropdelzpp": 157319998,
    "dropphyadd": "525 1ST ST",
    "dropphycty": "CORAL",
    "dropphyst": "PA",
    "dropphyzpp": 157319998,
    "dropmaladd": "525 1ST ST",
    "dropmalcty": "CORAL",
    "dropmalst": "PA",
    "dropmalzpp": 157319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244798420,
    "dropsitcph": 7244798420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17785",
    "droptype": "D",
    "dropname": "CORAOPOLIS",
    "dropdeladd": "1140 THORN RUN RD",
    "dropdelcty": "CORAOPOLIS",
    "dropdelst": "PA",
    "dropdelzpp": 151089998,
    "dropphyadd": "1140 THORN RUN RD",
    "dropphycty": "CORAOPOLIS",
    "dropphyst": "PA",
    "dropphyzpp": 151089998,
    "dropmaladd": "1140 THORN RUN RD",
    "dropmalcty": "CORAOPOLIS",
    "dropmalst": "PA",
    "dropmalzpp": 151089998,
    "dropsitphn": 4122644629,
    "dropsitlph": 4122644629,
    "dropsitcph": 4122644629,
    "dropfax": 4122642216
  },
  {
    "dcode": "D",
    "dropkey": "PX17790",
    "droptype": "D",
    "dropname": "CORNWALL",
    "dropdeladd": "7 BOYD ST",
    "dropdelcty": "CORNWALL",
    "dropdelst": "PA",
    "dropdelzpp": 170169800,
    "dropphyadd": "7 BOYD ST",
    "dropphycty": "CORNWALL",
    "dropphyst": "PA",
    "dropphyzpp": 170169800,
    "dropmaladd": "7 BOYD ST",
    "dropmalcty": "CORNWALL",
    "dropmalst": "PA",
    "dropmalzpp": 170169800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172737961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17795",
    "droptype": "D",
    "dropname": "CORRY",
    "dropdeladd": "101 S CENTER ST",
    "dropdelcty": "CORRY",
    "dropdelst": "PA",
    "dropdelzpp": 164071900,
    "dropphyadd": "101 S CENTER ST",
    "dropphycty": "CORRY",
    "dropphyst": "PA",
    "dropphyzpp": 164071900,
    "dropmaladd": "101 S CENTER ST",
    "dropmalcty": "CORRY",
    "dropmalst": "PA",
    "dropmalzpp": 164071900,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146644911,
    "dropsitcph": 8146644911,
    "dropfax": 8146630608
  },
  {
    "dcode": "D",
    "dropkey": "PX17796",
    "droptype": "D",
    "dropname": "CORSICA",
    "dropdeladd": "446 OLEAN RD",
    "dropdelcty": "CORSICA",
    "dropdelst": "PA",
    "dropdelzpp": 158299800,
    "dropphyadd": "446 OLEAN RD",
    "dropphycty": "CORSICA",
    "dropphyst": "PA",
    "dropphyzpp": 158299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORSICA",
    "dropmalst": "PA",
    "dropmalzpp": 158299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143793219,
    "dropsitcph": 8143793219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17799",
    "droptype": "D",
    "dropname": "COUDERSPORT",
    "dropdeladd": "301 N MAIN ST",
    "dropdelcty": "COUDERSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 169159998,
    "dropphyadd": "301 N MAIN ST",
    "dropphycty": "COUDERSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 169159998,
    "dropmaladd": "301 N MAIN ST",
    "dropmalcty": "COUDERSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 169159998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 8142748420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17800",
    "droptype": "D",
    "dropname": "COULTERS",
    "dropdeladd": "211 TOURMAN ST",
    "dropdelcty": "COULTERS",
    "dropdelst": "PA",
    "dropdelzpp": 150281001,
    "dropphyadd": "211 TOURMAN ST",
    "dropphycty": "COULTERS",
    "dropphyst": "PA",
    "dropphyzpp": 150281001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COULTERS",
    "dropmalst": "PA",
    "dropmalzpp": 150289998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127512229,
    "dropsitcph": 4127512229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17809",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "2220 N WILLIAMSON RD",
    "dropdelcty": "COVINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 169179998,
    "dropphyadd": "2220 N WILLIAMSON RD",
    "dropphycty": "COVINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 169179998,
    "dropmaladd": "2220 N WILLIAMSON RD",
    "dropmalcty": "COVINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 169179998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706595481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17815",
    "droptype": "D",
    "dropname": "COWANSVILLE",
    "dropdeladd": "827 E BRADY RD",
    "dropdelcty": "COWANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162189800,
    "dropphyadd": "827 E BRADY RD",
    "dropphycty": "COWANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162189800,
    "dropmaladd": "827 E BRADY RD",
    "dropmalcty": "COWANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162189800,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245433232,
    "dropsitcph": 7245433232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17819",
    "droptype": "D",
    "dropname": "CRABTREE",
    "dropdeladd": "2573 STATE ROUTE 119",
    "dropdelcty": "CRABTREE",
    "dropdelst": "PA",
    "dropdelzpp": 156241001,
    "dropphyadd": "2573 STATE ROUTE 119",
    "dropphycty": "CRABTREE",
    "dropphyst": "PA",
    "dropphyzpp": 156241001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRABTREE",
    "dropmalst": "PA",
    "dropmalzpp": 156249998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248360260,
    "dropsitcph": 7248360260,
    "dropfax": 7248349102
  },
  {
    "dcode": "D",
    "dropkey": "PX17825",
    "droptype": "D",
    "dropname": "CRALEY",
    "dropdeladd": "86 NEW BRIDGEVILLE RD",
    "dropdelcty": "CRALEY",
    "dropdelst": "PA",
    "dropdelzpp": 173129998,
    "dropphyadd": "86 NEW BRIDGEVILLE RD",
    "dropphycty": "CRALEY",
    "dropphyst": "PA",
    "dropphyzpp": 173129998,
    "dropmaladd": "86 NEW BRIDGEVILLE RD",
    "dropmalcty": "CRALEY",
    "dropmalst": "PA",
    "dropmalzpp": 173129998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172446815,
    "dropsitcph": 7172446815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17829",
    "droptype": "D",
    "dropname": "CRANESVILLE",
    "dropdeladd": "10283 E CRANE ST",
    "dropdelcty": "CRANESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 164109800,
    "dropphyadd": "10283 E CRANE ST",
    "dropphycty": "CRANESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 164109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRANESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 164109998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147564168,
    "dropsitcph": 8147564168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17831",
    "droptype": "D",
    "dropname": "CREAMERY",
    "dropdeladd": "1117 BRIDGE RD",
    "dropdelcty": "CREAMERY",
    "dropdelst": "PA",
    "dropdelzpp": 194309900,
    "dropphyadd": "1117 BRIDGE RD",
    "dropphycty": "CREAMERY",
    "dropphyst": "PA",
    "dropphyzpp": 194309900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CREAMERY",
    "dropmalst": "PA",
    "dropmalzpp": 194309998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6104891373,
    "dropsitcph": 6104891373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17832",
    "droptype": "D",
    "dropname": "CREEKSIDE",
    "dropdeladd": "435 INDIANA RD",
    "dropdelcty": "CREEKSIDE",
    "dropdelst": "PA",
    "dropdelzpp": 157329998,
    "dropphyadd": "435 INDIANA RD",
    "dropphycty": "CREEKSIDE",
    "dropphyst": "PA",
    "dropphyzpp": 157329998,
    "dropmaladd": "435 INDIANA RD",
    "dropmalcty": "CREEKSIDE",
    "dropmalst": "PA",
    "dropmalzpp": 157329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244630111,
    "dropsitcph": 7244630111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17833",
    "droptype": "D",
    "dropname": "CREIGHTON",
    "dropdeladd": "1029 FREEPORT RD",
    "dropdelcty": "CREIGHTON",
    "dropdelst": "PA",
    "dropdelzpp": 150309998,
    "dropphyadd": "1029 FREEPORT RD",
    "dropphycty": "CREIGHTON",
    "dropphyst": "PA",
    "dropphyzpp": 150309998,
    "dropmaladd": "1029 FREEPORT RD",
    "dropmalcty": "CREIGHTON",
    "dropmalst": "PA",
    "dropmalzpp": 150309998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242261372,
    "dropsitcph": 7242261372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17834",
    "droptype": "D",
    "dropname": "CRESCO",
    "dropdeladd": "6535 ROUTE 191",
    "dropdelcty": "CRESCO",
    "dropdelst": "PA",
    "dropdelzpp": 183269800,
    "dropphyadd": "6535 ROUTE 191",
    "dropphycty": "CRESCO",
    "dropphyst": "PA",
    "dropphyzpp": 183269800,
    "dropmaladd": "6535 ROUTE 191",
    "dropmalcty": "CRESCO",
    "dropmalst": "PA",
    "dropmalzpp": 183269800,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705957102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17837",
    "droptype": "D",
    "dropname": "CRESSON",
    "dropdeladd": "832 KEYSTONE AVE",
    "dropdelcty": "CRESSON",
    "dropdelst": "PA",
    "dropdelzpp": 166309998,
    "dropphyadd": "832 KEYSTONE AVE",
    "dropphycty": "CRESSON",
    "dropphyst": "PA",
    "dropphyzpp": 166309998,
    "dropmaladd": "832 KEYSTONE AVE",
    "dropmalcty": "CRESSON",
    "dropmalst": "PA",
    "dropmalzpp": 166309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148862143,
    "dropsitcph": 8148862143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17839",
    "droptype": "D",
    "dropname": "CRESSONA",
    "dropdeladd": "17 N SILLYMAN ST",
    "dropdelcty": "CRESSONA",
    "dropdelst": "PA",
    "dropdelzpp": 179299998,
    "dropphyadd": "17 N SILLYMAN ST",
    "dropphycty": "CRESSONA",
    "dropphyst": "PA",
    "dropphyzpp": 179299998,
    "dropmaladd": "17 N SILLYMAN ST",
    "dropmalcty": "CRESSONA",
    "dropmalst": "PA",
    "dropmalzpp": 179299998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703852297,
    "dropsitcph": 5703852297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17843",
    "droptype": "D",
    "dropname": "CROSBY",
    "dropdeladd": "27 CHRISTIAN HOLLOW RD",
    "dropdelcty": "CROSBY",
    "dropdelst": "PA",
    "dropdelzpp": 167249800,
    "dropphyadd": "27 CHRISTIAN HOLLOW RD",
    "dropphycty": "CROSBY",
    "dropphyst": "PA",
    "dropphyzpp": 167249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSBY",
    "dropmalst": "PA",
    "dropmalzpp": 167249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148875482,
    "dropsitcph": 8148875482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17844",
    "droptype": "D",
    "dropname": "CROSS FORK",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "CROSS FORK",
    "dropdelst": "PA",
    "dropdelzpp": 177299998,
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "CROSS FORK",
    "dropphyst": "PA",
    "dropphyzpp": 177299998,
    "dropmaladd": "11 MAIN ST",
    "dropmalcty": "CROSS FORK",
    "dropmalst": "PA",
    "dropmalzpp": 177299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703223573,
    "dropsitcph": 5709231321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17851",
    "droptype": "D",
    "dropname": "CROWN",
    "dropdeladd": "36044 ROUTE 66",
    "dropdelcty": "CROWN",
    "dropdelst": "PA",
    "dropdelzpp": 162209800,
    "dropphyadd": "36044 ROUTE 66",
    "dropphycty": "CROWN",
    "dropphyst": "PA",
    "dropphyzpp": 162209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWN",
    "dropmalst": "PA",
    "dropmalzpp": 162209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147448041,
    "dropsitcph": 8147448041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17853",
    "droptype": "D",
    "dropname": "CRUCIBLE",
    "dropdeladd": "103B CRUCIBLE CARMICHAELS RD",
    "dropdelcty": "CRUCIBLE",
    "dropdelst": "PA",
    "dropdelzpp": 153251001,
    "dropphyadd": "103B CRUCIBLE CARMICHAELS RD",
    "dropphycty": "CRUCIBLE",
    "dropphyst": "PA",
    "dropphyzpp": 153251001,
    "dropmaladd": "103B CRUCIBLE CARMICHAELS RD",
    "dropmalcty": "CRUCIBLE",
    "dropmalst": "PA",
    "dropmalzpp": 153251001,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245925000,
    "dropsitcph": 7245925000,
    "dropfax": 7245925015
  },
  {
    "dcode": "D",
    "dropkey": "PX17855",
    "droptype": "D",
    "dropname": "CRYSTAL SPRING",
    "dropdeladd": "14457 OLD 126 STE B",
    "dropdelcty": "CRYSTAL SPRING",
    "dropdelst": "PA",
    "dropdelzpp": 155369998,
    "dropphyadd": "14457 OLD 126 STE B",
    "dropphycty": "CRYSTAL SPRING",
    "dropphyst": "PA",
    "dropphyzpp": 155369998,
    "dropmaladd": "14457 OLD 126 STE B",
    "dropmalcty": "CRYSTAL SPRING",
    "dropmalst": "PA",
    "dropmalzpp": 155369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147354819,
    "dropsitcph": 8147354819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17860",
    "droptype": "D",
    "dropname": "CUDDY",
    "dropdeladd": "615 MILLERS RUN RD",
    "dropdelcty": "CUDDY",
    "dropdelst": "PA",
    "dropdelzpp": 150319998,
    "dropphyadd": "615 MILLERS RUN RD",
    "dropphycty": "CUDDY",
    "dropphyst": "PA",
    "dropphyzpp": 150319998,
    "dropmaladd": "615 MILLERS RUN RD",
    "dropmalcty": "CUDDY",
    "dropmalst": "PA",
    "dropmalzpp": 150319998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122213587,
    "dropsitcph": 4122213587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17862",
    "droptype": "D",
    "dropname": "CUMBOLA",
    "dropdeladd": "119 COAL ST",
    "dropdelcty": "CUMBOLA",
    "dropdelst": "PA",
    "dropdelzpp": 179309998,
    "dropphyadd": "119 COAL ST",
    "dropphycty": "CUMBOLA",
    "dropphyst": "PA",
    "dropphyzpp": 179309998,
    "dropmaladd": "119 COAL ST",
    "dropmalcty": "CUMBOLA",
    "dropmalst": "PA",
    "dropmalzpp": 179309998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5702770507,
    "dropsitcph": 5702770507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17866",
    "droptype": "D",
    "dropname": "CURLLSVILLE",
    "dropdeladd": "19 HUCKLEBERRY RDG",
    "dropdelcty": "CURLLSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162219800,
    "dropphyadd": "19 HUCKLEBERRY RDG",
    "dropphycty": "CURLLSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURLLSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162219998,
    "dropsitphn": 8148367307,
    "dropsitlph": "",
    "dropsitcph": 8147453438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17867",
    "droptype": "D",
    "dropname": "CURRYVILLE",
    "dropdeladd": "1590 CURRYVILLE RD",
    "dropdelcty": "CURRYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166319998,
    "dropphyadd": "1590 CURRYVILLE RD",
    "dropphycty": "CURRYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166319998,
    "dropmaladd": "1590 CURRYVILLE RD",
    "dropmalcty": "CURRYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147934604,
    "dropsitcph": 8147934604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17868",
    "droptype": "D",
    "dropname": "CURTISVILLE",
    "dropdeladd": "1778 SAXONBURG BLVD",
    "dropdelcty": "CURTISVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 150321001,
    "dropphyadd": "1778 SAXONBURG BLVD",
    "dropphycty": "CURTISVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 150321001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURTISVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 150329998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242655000,
    "dropsitcph": 7242655000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17871",
    "droptype": "D",
    "dropname": "CURWENSVILLE",
    "dropdeladd": "525 STATE ST",
    "dropdelcty": "CURWENSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 168339998,
    "dropphyadd": "525 STATE ST",
    "dropphycty": "CURWENSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 168339998,
    "dropmaladd": "525 STATE ST",
    "dropmalcty": "CURWENSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 168339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142360461,
    "dropsitcph": 8142360461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17872",
    "droptype": "D",
    "dropname": "CUSTER CITY",
    "dropdeladd": "1 E WARREN RD",
    "dropdelcty": "CUSTER CITY",
    "dropdelst": "PA",
    "dropdelzpp": 167259800,
    "dropphyadd": "1 E WARREN RD",
    "dropphycty": "CUSTER CITY",
    "dropphyst": "PA",
    "dropphyzpp": 167259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSTER CITY",
    "dropmalst": "PA",
    "dropmalzpp": 167259998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143689933,
    "dropsitcph": 8143689933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17873",
    "droptype": "D",
    "dropname": "CYCLONE",
    "dropdeladd": "4241 ROUTE 646",
    "dropdelcty": "CYCLONE",
    "dropdelst": "PA",
    "dropdelzpp": 167269800,
    "dropphyadd": "4241 ROUTE 646",
    "dropphycty": "CYCLONE",
    "dropphyst": "PA",
    "dropphyzpp": 167269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CYCLONE",
    "dropmalst": "PA",
    "dropmalzpp": 167269998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144653243,
    "dropsitcph": 8144653243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17876",
    "droptype": "D",
    "dropname": "DAGUS MINES",
    "dropdeladd": "176 DAGUS MINES RD",
    "dropdelcty": "DAGUS MINES",
    "dropdelst": "PA",
    "dropdelzpp": 158319800,
    "dropphyadd": "176 DAGUS MINES RD",
    "dropphycty": "DAGUS MINES",
    "dropphyst": "PA",
    "dropphyzpp": 158319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAGUS MINES",
    "dropmalst": "PA",
    "dropmalzpp": 158319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148856207,
    "dropsitcph": 8148856207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17877",
    "droptype": "D",
    "dropname": "DAISYTOWN",
    "dropdeladd": "545 PIKE RUN DR",
    "dropdelcty": "DAISYTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154271099,
    "dropphyadd": "545 PIKE RUN DR",
    "dropphycty": "DAISYTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154271099,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAISYTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249382220,
    "dropsitcph": 7249382220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17879",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "2759 MEMORIAL HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "PA",
    "dropdelzpp": 186129998,
    "dropphyadd": "2759 MEMORIAL HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "PA",
    "dropphyzpp": 186129998,
    "dropmaladd": "2759 MEMORIAL HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "PA",
    "dropmalzpp": 186129998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706750131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17880",
    "droptype": "D",
    "dropname": "DALLASTOWN",
    "dropdeladd": "61 N WALNUT ST",
    "dropdelcty": "DALLASTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173139998,
    "dropphyadd": "61 N WALNUT ST",
    "dropphycty": "DALLASTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173139998,
    "dropmaladd": "61 N WALNUT ST",
    "dropmalcty": "DALLASTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173139998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172442555,
    "dropsitcph": 7172442555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17883",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "DALTON",
    "dropdelst": "PA",
    "dropdelzpp": 184149800,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "DALTON",
    "dropphyst": "PA",
    "dropphyzpp": 184149800,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "DALTON",
    "dropmalst": "PA",
    "dropmalzpp": 184149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705631550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17884",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "1676 COCHECTON TPKE",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "PA",
    "dropdelzpp": 184159998,
    "dropphyadd": "1676 COCHECTON TPKE",
    "dropphycty": "DAMASCUS",
    "dropphyst": "PA",
    "dropphyzpp": 184159998,
    "dropmaladd": "1676 COCHECTON TPKE",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "PA",
    "dropmalzpp": 184159998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702244074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17885",
    "droptype": "D",
    "dropname": "DANBORO",
    "dropdeladd": "4317 POINT PLEASANT PIKE",
    "dropdelcty": "DANBORO",
    "dropdelst": "PA",
    "dropdelzpp": 189169998,
    "dropphyadd": "4317 POINT PLEASANT PIKE",
    "dropphycty": "DANBORO",
    "dropphyst": "PA",
    "dropphyzpp": 189169998,
    "dropmaladd": "4317 POINT PLEASANT PIKE",
    "dropmalcty": "DANBORO",
    "dropmalst": "PA",
    "dropmalzpp": 189169998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153459088,
    "dropsitcph": 2153459088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17886",
    "droptype": "D",
    "dropname": "DANIELSVILLE",
    "dropdeladd": "3937 MOUNTAIN VIEW DR",
    "dropdelcty": "DANIELSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180389998,
    "dropphyadd": "3937 MOUNTAIN VIEW DR",
    "dropphycty": "DANIELSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180389998,
    "dropmaladd": "3937 MOUNTAIN VIEW DR",
    "dropmalcty": "DANIELSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180389998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107676882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17889",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "410 MILL ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178219998,
    "dropphyadd": "410 MILL ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178219998,
    "dropmaladd": "410 MILL ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5702752661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17891",
    "droptype": "D",
    "dropname": "DARBY",
    "dropdeladd": "801 MAIN ST",
    "dropdelcty": "DARBY",
    "dropdelst": "PA",
    "dropdelzpp": 190239998,
    "dropphyadd": "801 MAIN ST",
    "dropphycty": "DARBY",
    "dropphyst": "PA",
    "dropphyzpp": 190239998,
    "dropmaladd": "801 MAIN ST",
    "dropmalcty": "DARBY",
    "dropmalst": "PA",
    "dropmalzpp": 190239998,
    "dropsitphn": 6105831037,
    "dropsitlph": 6105833035,
    "dropsitcph": 6105831037,
    "dropfax": 6105835338
  },
  {
    "dcode": "D",
    "dropkey": "PX17894",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "708 MARKET ST",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 161159800,
    "dropphyadd": "708 MARKET ST",
    "dropphycty": "DARLINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 161159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 161159998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248272211,
    "dropsitcph": 7248272211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17896",
    "droptype": "D",
    "dropname": "DARRAGH",
    "dropdeladd": "3206 ROUTE 136",
    "dropdelcty": "DARRAGH",
    "dropdelst": "PA",
    "dropdelzpp": 156251001,
    "dropphyadd": "3206 ROUTE 136",
    "dropphycty": "DARRAGH",
    "dropphyst": "PA",
    "dropphyzpp": 156251001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARRAGH",
    "dropmalst": "PA",
    "dropmalzpp": 156259998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244467820,
    "dropsitcph": 7244467820,
    "dropfax": 7244460485
  },
  {
    "dcode": "D",
    "dropkey": "PX17900",
    "droptype": "D",
    "dropname": "DAUPHIN",
    "dropdeladd": "204 ALLEGHENY ST",
    "dropdelcty": "DAUPHIN",
    "dropdelst": "PA",
    "dropdelzpp": 170189998,
    "dropphyadd": "204 ALLEGHENY ST",
    "dropphycty": "DAUPHIN",
    "dropphyst": "PA",
    "dropphyzpp": 170189998,
    "dropmaladd": "204 ALLEGHENY ST",
    "dropmalcty": "DAUPHIN",
    "dropmalst": "PA",
    "dropmalzpp": 170189998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179212101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17903",
    "droptype": "D",
    "dropname": "DAVIDSVILLE",
    "dropdeladd": "113 S MAIN ST STE C",
    "dropdelcty": "DAVIDSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 159289998,
    "dropphyadd": "113 S MAIN ST STE C",
    "dropphycty": "DAVIDSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 159289998,
    "dropmaladd": "113 S MAIN ST STE C",
    "dropmalcty": "DAVIDSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 159289998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144797611,
    "dropsitcph": 8144797611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17905",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "101 RAILROAD ST",
    "dropdelcty": "DAWSON",
    "dropdelst": "PA",
    "dropdelzpp": 154282001,
    "dropphyadd": "101 RAILROAD ST",
    "dropphycty": "DAWSON",
    "dropphyst": "PA",
    "dropphyzpp": 154282001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWSON",
    "dropmalst": "PA",
    "dropmalzpp": 154289998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246189021,
    "dropsitcph": 7246189021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17906",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "PA",
    "dropdelzpp": 162229800,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "DAYTON",
    "dropphyst": "PA",
    "dropphyzpp": 162229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAYTON",
    "dropmalst": "PA",
    "dropmalzpp": 162229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142578100,
    "dropsitcph": 8142578100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17908",
    "droptype": "D",
    "dropname": "DE LANCEY",
    "dropdeladd": "493 ADRIAN RD",
    "dropdelcty": "DE LANCEY",
    "dropdelst": "PA",
    "dropdelzpp": 157339998,
    "dropphyadd": "493 ADRIAN RD",
    "dropphycty": "DE LANCEY",
    "dropphyst": "PA",
    "dropphyzpp": 157339998,
    "dropmaladd": "493 ADRIAN RD",
    "dropmalcty": "DE LANCEY",
    "dropmalst": "PA",
    "dropmalzpp": 157339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149384594,
    "dropsitcph": 8149384594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17915",
    "droptype": "D",
    "dropname": "DEFIANCE",
    "dropdeladd": "807 SIX MILE RUN RD",
    "dropdelcty": "DEFIANCE",
    "dropdelst": "PA",
    "dropdelzpp": 166339998,
    "dropphyadd": "807 SIX MILE RUN RD",
    "dropphycty": "DEFIANCE",
    "dropphyst": "PA",
    "dropphyzpp": 166339998,
    "dropmaladd": "807 SIX MILE RUN RD",
    "dropmalcty": "DEFIANCE",
    "dropmalst": "PA",
    "dropmalzpp": 166339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149284298,
    "dropsitcph": 8149284298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17919",
    "droptype": "D",
    "dropname": "DELANO",
    "dropdeladd": "150 HAZLE ST",
    "dropdelcty": "DELANO",
    "dropdelst": "PA",
    "dropdelzpp": 182209998,
    "dropphyadd": "150 HAZLE ST",
    "dropphycty": "DELANO",
    "dropphyst": "PA",
    "dropphyzpp": 182209998,
    "dropmaladd": "150 HAZLE ST",
    "dropmalcty": "DELANO",
    "dropmalst": "PA",
    "dropmalzpp": 182209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704673667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17924",
    "droptype": "D",
    "dropname": "DELAWARE WATER GAP",
    "dropdeladd": "12 SHEPARD AVE",
    "dropdelcty": "DELAWARE WATER GAP",
    "dropdelst": "PA",
    "dropdelzpp": 183279800,
    "dropphyadd": "12 SHEPARD AVE",
    "dropphycty": "DELAWARE WATER GAP",
    "dropphyst": "PA",
    "dropphyzpp": 183279800,
    "dropmaladd": "12 SHEPARD AVE",
    "dropmalcty": "DELAWARE WATER GAP",
    "dropmalst": "PA",
    "dropmalzpp": 183279800,
    "dropsitphn": 5704760304,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704760304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17927",
    "droptype": "D",
    "dropname": "DELMONT",
    "dropdeladd": "48 GREENSBURG ST",
    "dropdelcty": "DELMONT",
    "dropdelst": "PA",
    "dropdelzpp": 156269998,
    "dropphyadd": "48 GREENSBURG ST",
    "dropphycty": "DELMONT",
    "dropphyst": "PA",
    "dropphyzpp": 156269998,
    "dropmaladd": "48 GREENSBURG ST",
    "dropmalcty": "DELMONT",
    "dropmalst": "PA",
    "dropmalzpp": 156269998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244685236,
    "dropsitcph": 7244685236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17929",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "101 COLLEGE AVE",
    "dropdelcty": "DELTA",
    "dropdelst": "PA",
    "dropdelzpp": 173149998,
    "dropphyadd": "101 COLLEGE AVE",
    "dropphycty": "DELTA",
    "dropphyst": "PA",
    "dropphyzpp": 173149998,
    "dropmaladd": "101 COLLEGE AVE",
    "dropmalcty": "DELTA",
    "dropmalst": "PA",
    "dropmalzpp": 173149998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174565512,
    "dropsitcph": 7174565512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17932",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "101 SNYDER ST",
    "dropdelcty": "DENVER",
    "dropdelst": "PA",
    "dropdelzpp": 175179998,
    "dropphyadd": "101 SNYDER ST",
    "dropphycty": "DENVER",
    "dropphyst": "PA",
    "dropphyzpp": 175179998,
    "dropmaladd": "101 SNYDER ST",
    "dropmalcty": "DENVER",
    "dropmalst": "PA",
    "dropmalzpp": 175179998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173362230,
    "dropsitcph": 7173362230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17934",
    "droptype": "D",
    "dropname": "DERRICK CITY",
    "dropdeladd": "432 DERRICK RD",
    "dropdelcty": "DERRICK CITY",
    "dropdelst": "PA",
    "dropdelzpp": 167279800,
    "dropphyadd": "432 DERRICK RD",
    "dropphycty": "DERRICK CITY",
    "dropphyst": "PA",
    "dropphyzpp": 167279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DERRICK CITY",
    "dropmalst": "PA",
    "dropmalzpp": 167279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143689542,
    "dropsitcph": 8143689542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17937",
    "droptype": "D",
    "dropname": "DERRY",
    "dropdeladd": "101 E 1ST AVE",
    "dropdelcty": "DERRY",
    "dropdelst": "PA",
    "dropdelzpp": 156279998,
    "dropphyadd": "101 E 1ST AVE",
    "dropphycty": "DERRY",
    "dropphyst": "PA",
    "dropphyzpp": 156279998,
    "dropmaladd": "101 E 1ST AVE",
    "dropmalcty": "DERRY",
    "dropmalst": "PA",
    "dropmalzpp": 156279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246949241,
    "dropsitcph": 7246949241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17941",
    "droptype": "D",
    "dropname": "DEVAULT",
    "dropdeladd": "4030 S WHITEHORSE RD",
    "dropdelcty": "DEVAULT",
    "dropdelst": "PA",
    "dropdelzpp": 194329905,
    "dropphyadd": "4030 S WHITEHORSE RD",
    "dropphycty": "DEVAULT",
    "dropphyst": "PA",
    "dropphyzpp": 194329905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEVAULT",
    "dropmalst": "PA",
    "dropmalzpp": 194329998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106445210,
    "dropsitcph": 6106445210,
    "dropfax": 6106445210
  },
  {
    "dcode": "D",
    "dropkey": "PX17942",
    "droptype": "D",
    "dropname": "DEVON",
    "dropdeladd": "7 N WATERLOO RD",
    "dropdelcty": "DEVON",
    "dropdelst": "PA",
    "dropdelzpp": 193339998,
    "dropphyadd": "7 N WATERLOO RD",
    "dropphycty": "DEVON",
    "dropphyst": "PA",
    "dropphyzpp": 193339998,
    "dropmaladd": "7 N WATERLOO RD",
    "dropmalcty": "DEVON",
    "dropmalst": "PA",
    "dropmalzpp": 193339998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106881140,
    "dropsitcph": 6106881140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17945",
    "droptype": "D",
    "dropname": "DEWART",
    "dropdeladd": "2037 MAIN ST",
    "dropdelcty": "DEWART",
    "dropdelst": "PA",
    "dropdelzpp": 177309998,
    "dropphyadd": "2037 MAIN ST",
    "dropphycty": "DEWART",
    "dropphyst": "PA",
    "dropphyzpp": 177309998,
    "dropmaladd": "2037 MAIN ST",
    "dropmalcty": "DEWART",
    "dropmalst": "PA",
    "dropmalzpp": 177309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705385959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17948",
    "droptype": "D",
    "dropname": "DICKERSON RUN",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "DICKERSON RUN",
    "dropdelst": "PA",
    "dropdelzpp": 154301001,
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "DICKERSON RUN",
    "dropphyst": "PA",
    "dropphyzpp": 154301001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DICKERSON RUN",
    "dropmalst": "PA",
    "dropmalzpp": 154309998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245297401,
    "dropsitcph": 7245297401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17956",
    "droptype": "D",
    "dropname": "DILLINER",
    "dropdeladd": "2854 STATE ROUTE 88",
    "dropdelcty": "DILLINER",
    "dropdelst": "PA",
    "dropdelzpp": 153271001,
    "dropphyadd": "2854 STATE ROUTE 88",
    "dropphycty": "DILLINER",
    "dropphyst": "PA",
    "dropphyzpp": 153271001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DILLINER",
    "dropmalst": "PA",
    "dropmalzpp": 153279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249433725,
    "dropsitcph": 7249433725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17957",
    "droptype": "D",
    "dropname": "DILLSBURG",
    "dropdeladd": "28 N BALTIMORE ST",
    "dropdelcty": "DILLSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170199998,
    "dropphyadd": "28 N BALTIMORE ST",
    "dropphycty": "DILLSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170199998,
    "dropmaladd": "28 N BALTIMORE ST",
    "dropmalcty": "DILLSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170199998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174323035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17958",
    "droptype": "D",
    "dropname": "DILLTOWN",
    "dropdeladd": "7491 ROUTE 403 HWY S",
    "dropdelcty": "DILLTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 159299998,
    "dropphyadd": "7491 ROUTE 403 HWY S",
    "dropphycty": "DILLTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 159299998,
    "dropmaladd": "7491 ROUTE 403 HWY S",
    "dropmalcty": "DILLTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 159299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144466663,
    "dropsitcph": 8144466663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17959",
    "droptype": "D",
    "dropname": "DIMOCK",
    "dropdeladd": "7473 STATE ROUTE 29",
    "dropdelcty": "DIMOCK",
    "dropdelst": "PA",
    "dropdelzpp": 188169998,
    "dropphyadd": "7473 STATE ROUTE 29",
    "dropphycty": "DIMOCK",
    "dropphyst": "PA",
    "dropphyzpp": 188169998,
    "dropmaladd": "7473 STATE ROUTE 29",
    "dropmalcty": "DIMOCK",
    "dropmalst": "PA",
    "dropmalzpp": 188169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702782681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17960",
    "droptype": "D",
    "dropname": "DINGMANS FERRY",
    "dropdeladd": "103 NICHECRONK RD",
    "dropdelcty": "DINGMANS FERRY",
    "dropdelst": "PA",
    "dropdelzpp": 183288000,
    "dropphyadd": "103 NICHECRONK RD",
    "dropphycty": "DINGMANS FERRY",
    "dropphyst": "PA",
    "dropphyzpp": 183288000,
    "dropmaladd": "103 NICHECRONK RD",
    "dropmalcty": "DINGMANS FERRY",
    "dropmalst": "PA",
    "dropmalzpp": 183289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708282812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17961",
    "droptype": "D",
    "dropname": "DISTANT",
    "dropdeladd": "3273 STATE ROUTE 28 AND 66",
    "dropdelcty": "DISTANT",
    "dropdelst": "PA",
    "dropdelzpp": 162239800,
    "dropphyadd": "3273 STATE ROUTE 28 AND 66",
    "dropphycty": "DISTANT",
    "dropphyst": "PA",
    "dropphyzpp": 162239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DISTANT",
    "dropmalst": "PA",
    "dropmalzpp": 162239998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142753218,
    "dropsitcph": 8142753218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17963",
    "droptype": "D",
    "dropname": "DIXONVILLE",
    "dropdeladd": "18050 ROUTE 403 HWY N",
    "dropdelcty": "DIXONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 157349998,
    "dropphyadd": "18050 ROUTE 403 HWY N",
    "dropphycty": "DIXONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 157349998,
    "dropmaladd": "18050 ROUTE 403 HWY N",
    "dropmalcty": "DIXONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 157349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242542429,
    "dropsitcph": 7242542429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17967",
    "droptype": "D",
    "dropname": "DONEGAL",
    "dropdeladd": "154 MAIN ST",
    "dropdelcty": "DONEGAL",
    "dropdelst": "PA",
    "dropdelzpp": 156281001,
    "dropphyadd": "154 MAIN ST",
    "dropphycty": "DONEGAL",
    "dropphyst": "PA",
    "dropphyzpp": 156281001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONEGAL",
    "dropmalst": "PA",
    "dropmalzpp": 156289998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245937280,
    "dropsitcph": 7245937280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17973",
    "droptype": "D",
    "dropname": "DONORA",
    "dropdeladd": "599 MELDON AVE",
    "dropdelcty": "DONORA",
    "dropdelst": "PA",
    "dropdelzpp": 150339998,
    "dropphyadd": "599 MELDON AVE",
    "dropphycty": "DONORA",
    "dropphyst": "PA",
    "dropphyzpp": 150339998,
    "dropmaladd": "599 MELDON AVE",
    "dropmalcty": "DONORA",
    "dropmalst": "PA",
    "dropmalzpp": 150339998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243796858,
    "dropsitcph": 7243796858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17976",
    "droptype": "D",
    "dropname": "DORNSIFE",
    "dropdeladd": "123 CREEK RD",
    "dropdelcty": "DORNSIFE",
    "dropdelst": "PA",
    "dropdelzpp": 178239998,
    "dropphyadd": "123 CREEK RD",
    "dropphycty": "DORNSIFE",
    "dropphyst": "PA",
    "dropphyzpp": 178239998,
    "dropmaladd": "123 CREEK RD",
    "dropmalcty": "DORNSIFE",
    "dropmalst": "PA",
    "dropmalzpp": 178239998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707583844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17983",
    "droptype": "D",
    "dropname": "DOUGLASSVILLE",
    "dropdeladd": "197 OLD SWEDE RD",
    "dropdelcty": "DOUGLASSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195189998,
    "dropphyadd": "197 OLD SWEDE RD",
    "dropphycty": "DOUGLASSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195189998,
    "dropmaladd": "197 OLD SWEDE RD",
    "dropmalcty": "DOUGLASSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195189998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103853651,
    "dropsitcph": 6103853651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX17988",
    "droptype": "D",
    "dropname": "DOWNINGTOWN",
    "dropdeladd": "470 BOOT RD",
    "dropdelcty": "DOWNINGTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 193359998,
    "dropphyadd": "470 BOOT RD",
    "dropphycty": "DOWNINGTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 193359998,
    "dropmaladd": "470 BOOT RD",
    "dropmalcty": "DOWNINGTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 193359998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102696856,
    "dropsitcph": 6102696856,
    "dropfax": 6102691876
  },
  {
    "dcode": "D",
    "dropkey": "PX18000",
    "droptype": "D",
    "dropname": "DOYLESTOWN",
    "dropdeladd": "8 ATKINSON DR",
    "dropdelcty": "DOYLESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189019998,
    "dropphyadd": "8 ATKINSON DR",
    "dropphycty": "DOYLESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189019998,
    "dropmaladd": "8 ATKINSON DR",
    "dropmalcty": "DOYLESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189019998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2678803918,
    "dropsitcph": 2678803918,
    "dropfax": 2153489851
  },
  {
    "dcode": "D",
    "dropkey": "PX18002",
    "droptype": "D",
    "dropname": "DRAVOSBURG",
    "dropdeladd": "209 RICHLAND AVE STE 5",
    "dropdelcty": "DRAVOSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 150349998,
    "dropphyadd": "209 RICHLAND AVE STE 5",
    "dropphycty": "DRAVOSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 150349998,
    "dropmaladd": "209 RICHLAND AVE STE 5",
    "dropmalcty": "DRAVOSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 150349998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124661229,
    "dropsitcph": 4124661229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18005",
    "droptype": "D",
    "dropname": "DREXEL HILL",
    "dropdeladd": "698 BURMONT RD",
    "dropdelcty": "DREXEL HILL",
    "dropdelst": "PA",
    "dropdelzpp": 190269998,
    "dropphyadd": "698 BURMONT RD",
    "dropphycty": "DREXEL HILL",
    "dropphyst": "PA",
    "dropphyzpp": 190269998,
    "dropmaladd": "698 BURMONT RD",
    "dropmalcty": "DREXEL HILL",
    "dropmalst": "PA",
    "dropmalzpp": 190269998,
    "dropsitphn": 6102592587,
    "dropsitlph": 6102592587,
    "dropsitcph": 6106226428,
    "dropfax": 6102595981
  },
  {
    "dcode": "D",
    "dropkey": "PX18009",
    "droptype": "D",
    "dropname": "DRIFTING",
    "dropdeladd": "5433 KYLERTOWN DRIFTING HWY",
    "dropdelcty": "DRIFTING",
    "dropdelst": "PA",
    "dropdelzpp": 168349998,
    "dropphyadd": "5433 KYLERTOWN DRIFTING HWY",
    "dropphycty": "DRIFTING",
    "dropphyst": "PA",
    "dropphyzpp": 168349998,
    "dropmaladd": "5433 KYLERTOWN DRIFTING HWY",
    "dropmalcty": "DRIFTING",
    "dropmalst": "PA",
    "dropmalzpp": 168349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143456973,
    "dropsitcph": 8143456973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18010",
    "droptype": "D",
    "dropname": "DRIFTON",
    "dropdeladd": "2304 STATE ROUTE 940",
    "dropdelcty": "DRIFTON",
    "dropdelst": "PA",
    "dropdelzpp": 182219998,
    "dropphyadd": "2304 STATE ROUTE 940",
    "dropphycty": "DRIFTON",
    "dropphyst": "PA",
    "dropphyzpp": 182219998,
    "dropmaladd": "2304 STATE ROUTE 940",
    "dropmalcty": "DRIFTON",
    "dropmalst": "PA",
    "dropmalzpp": 182219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706361130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18011",
    "droptype": "D",
    "dropname": "DRIFTWOOD",
    "dropdeladd": "7298 3RD ST",
    "dropdelcty": "DRIFTWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 158329800,
    "dropphyadd": "7298 3RD ST",
    "dropphycty": "DRIFTWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 158329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRIFTWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 158329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145462641,
    "dropsitcph": 8145462641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18014",
    "droptype": "D",
    "dropname": "DRUMS",
    "dropdeladd": "4 RITTENHOUSE PL",
    "dropdelcty": "DRUMS",
    "dropdelst": "PA",
    "dropdelzpp": 182229998,
    "dropphyadd": "4 RITTENHOUSE PL",
    "dropphycty": "DRUMS",
    "dropphyst": "PA",
    "dropphyzpp": 182229998,
    "dropmaladd": "4 RITTENHOUSE PL",
    "dropmalcty": "DRUMS",
    "dropmalst": "PA",
    "dropmalzpp": 182229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707882501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18016",
    "droptype": "D",
    "dropname": "DRY RUN",
    "dropdeladd": "18204 PATH VALLEY RD",
    "dropdelcty": "DRY RUN",
    "dropdelst": "PA",
    "dropdelzpp": 172209998,
    "dropphyadd": "18204 PATH VALLEY RD",
    "dropphycty": "DRY RUN",
    "dropphyst": "PA",
    "dropphyzpp": 172209998,
    "dropmaladd": "18204 PATH VALLEY RD",
    "dropmalcty": "DRY RUN",
    "dropmalst": "PA",
    "dropmalzpp": 172209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173497256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18020",
    "droptype": "D",
    "dropname": "DU BOIS",
    "dropdeladd": "229 BEAVER DR",
    "dropdelcty": "DU BOIS",
    "dropdelst": "PA",
    "dropdelzpp": 158012500,
    "dropphyadd": "229 BEAVER DR",
    "dropphycty": "DU BOIS",
    "dropphyst": "PA",
    "dropphyzpp": 158012500,
    "dropmaladd": "229 BEAVER DR",
    "dropmalcty": "DU BOIS",
    "dropmalst": "PA",
    "dropmalzpp": 158012500,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143715530,
    "dropsitcph": 8143715530,
    "dropfax": 8143719209
  },
  {
    "dcode": "D",
    "dropkey": "PX18021",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "301 STATION DR STE 101",
    "dropdelcty": "DUBLIN",
    "dropdelst": "PA",
    "dropdelzpp": 189179996,
    "dropphyadd": "301 STATION DR STE 101",
    "dropphycty": "DUBLIN",
    "dropphyst": "PA",
    "dropphyzpp": 189179996,
    "dropmaladd": "301 STATION DR STE 101",
    "dropmalcty": "DUBLIN",
    "dropmalst": "PA",
    "dropmalzpp": 189179996,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152493085,
    "dropsitcph": 2678679001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18025",
    "droptype": "D",
    "dropname": "DUDLEY",
    "dropdeladd": "3878 BROAD TOP MOUNTAIN RD",
    "dropdelcty": "DUDLEY",
    "dropdelst": "PA",
    "dropdelzpp": 166349001,
    "dropphyadd": "3878 BROAD TOP MOUNTAIN RD",
    "dropphycty": "DUDLEY",
    "dropphyst": "PA",
    "dropphyzpp": 166349001,
    "dropmaladd": "3878 BROAD TOP MOUNTAIN RD",
    "dropmalcty": "DUDLEY",
    "dropmalst": "PA",
    "dropmalzpp": 166349001,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146352392,
    "dropsitcph": 8146352392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18028",
    "droptype": "D",
    "dropname": "DUKE CENTER",
    "dropdeladd": "691 MAIN ST",
    "dropdelcty": "DUKE CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 167299800,
    "dropphyadd": "691 MAIN ST",
    "dropphycty": "DUKE CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 167299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUKE CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 167299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149663946,
    "dropsitcph": 8149663946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18030",
    "droptype": "D",
    "dropname": "DUNBAR",
    "dropdeladd": "27 CHURCH ST",
    "dropdelcty": "DUNBAR",
    "dropdelst": "PA",
    "dropdelzpp": 154319998,
    "dropphyadd": "27 CHURCH ST",
    "dropphycty": "DUNBAR",
    "dropphyst": "PA",
    "dropphyzpp": 154319998,
    "dropmaladd": "27 CHURCH ST",
    "dropmalcty": "DUNBAR",
    "dropmalst": "PA",
    "dropmalzpp": 154319998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242778917,
    "dropsitcph": 7242778917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18032",
    "droptype": "D",
    "dropname": "DUNCANNON",
    "dropdeladd": "203 N MARKET ST",
    "dropdelcty": "DUNCANNON",
    "dropdelst": "PA",
    "dropdelzpp": 170209998,
    "dropphyadd": "203 N MARKET ST",
    "dropphycty": "DUNCANNON",
    "dropphyst": "PA",
    "dropphyzpp": 170209998,
    "dropmaladd": "203 N MARKET ST",
    "dropmalcty": "DUNCANNON",
    "dropmalst": "PA",
    "dropmalzpp": 170209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7178318085,
    "dropsitcph": 7178318204,
    "dropfax": 7178334108
  },
  {
    "dcode": "D",
    "dropkey": "PX18033",
    "droptype": "D",
    "dropname": "DUNCANSVILLE",
    "dropdeladd": "146 DEVILLE DR",
    "dropdelcty": "DUNCANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 166359998,
    "dropphyadd": "146 DEVILLE DR",
    "dropphycty": "DUNCANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 166359998,
    "dropmaladd": "146 DEVILLE DR",
    "dropmalcty": "DUNCANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 166359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146955221,
    "dropsitcph": 8146955221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18037",
    "droptype": "D",
    "dropname": "DUNLEVY",
    "dropdeladd": "2216 ROUTE 88",
    "dropdelcty": "DUNLEVY",
    "dropdelst": "PA",
    "dropdelzpp": 154321001,
    "dropphyadd": "2216 ROUTE 88",
    "dropphycty": "DUNLEVY",
    "dropphyst": "PA",
    "dropphyzpp": 154321001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNLEVY",
    "dropmalst": "PA",
    "dropmalzpp": 154329998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243268586,
    "dropsitcph": 7243268586,
    "dropfax": 7243268586
  },
  {
    "dcode": "D",
    "dropkey": "PX18038",
    "droptype": "D",
    "dropname": "DUNLO",
    "dropdeladd": "207 HUFF ST",
    "dropdelcty": "DUNLO",
    "dropdelst": "PA",
    "dropdelzpp": 159309998,
    "dropphyadd": "207 HUFF ST",
    "dropphycty": "DUNLO",
    "dropphyst": "PA",
    "dropphyzpp": 159309998,
    "dropmaladd": "207 HUFF ST",
    "dropmalcty": "DUNLO",
    "dropmalst": "PA",
    "dropmalzpp": 159309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144875336,
    "dropsitcph": 8144875336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18044",
    "droptype": "D",
    "dropname": "DUQUESNE",
    "dropdeladd": "11 S 1ST ST",
    "dropdelcty": "DUQUESNE",
    "dropdelst": "PA",
    "dropdelzpp": 151109998,
    "dropphyadd": "11 S 1ST ST",
    "dropphycty": "DUQUESNE",
    "dropphyst": "PA",
    "dropphyzpp": 151109998,
    "dropmaladd": "11 S 1ST ST",
    "dropmalcty": "DUQUESNE",
    "dropmalst": "PA",
    "dropmalzpp": 151109998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124692147,
    "dropsitcph": 4124692147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18047",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "955 DURHAM RD",
    "dropdelcty": "DURHAM",
    "dropdelst": "PA",
    "dropdelzpp": 180399998,
    "dropphyadd": "955 DURHAM RD",
    "dropphycty": "DURHAM",
    "dropphyst": "PA",
    "dropphyzpp": 180399998,
    "dropmaladd": "955 DURHAM RD",
    "dropmalcty": "DURHAM",
    "dropmalst": "PA",
    "dropmalzpp": 180399998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103468944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18050",
    "droptype": "D",
    "dropname": "DUSHORE",
    "dropdeladd": "205 CENTER ST",
    "dropdelcty": "DUSHORE",
    "dropdelst": "PA",
    "dropdelzpp": 186149998,
    "dropphyadd": "205 CENTER ST",
    "dropphycty": "DUSHORE",
    "dropphyst": "PA",
    "dropphyzpp": 186149998,
    "dropmaladd": "205 CENTER ST",
    "dropmalcty": "DUSHORE",
    "dropmalst": "PA",
    "dropmalzpp": 186149998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709289464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18051",
    "droptype": "D",
    "dropname": "DYSART",
    "dropdeladd": "1194 CLEARFIELD VALLEY BLVD",
    "dropdelcty": "DYSART",
    "dropdelst": "PA",
    "dropdelzpp": 166369998,
    "dropphyadd": "1194 CLEARFIELD VALLEY BLVD",
    "dropphycty": "DYSART",
    "dropphyst": "PA",
    "dropphyzpp": 166369998,
    "dropmaladd": "1194 CLEARFIELD VALLEY BLVD",
    "dropmalcty": "DYSART",
    "dropmalst": "PA",
    "dropmalzpp": 166369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142016500,
    "dropsitcph": 8142016500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18087",
    "droptype": "D",
    "dropname": "EAGLES MERE",
    "dropdeladd": "1 SULLIVAN AVE",
    "dropdelcty": "EAGLES MERE",
    "dropdelst": "PA",
    "dropdelzpp": 177319998,
    "dropphyadd": "1 SULLIVAN AVE",
    "dropphycty": "EAGLES MERE",
    "dropphyst": "PA",
    "dropphyzpp": 177319998,
    "dropmaladd": "1 SULLIVAN AVE",
    "dropmalcty": "EAGLES MERE",
    "dropmalst": "PA",
    "dropmalzpp": 177319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705253255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18092",
    "droptype": "D",
    "dropname": "EARLINGTON",
    "dropdeladd": "403 MORWOOD RD",
    "dropdelcty": "EARLINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 189189998,
    "dropphyadd": "403 MORWOOD RD",
    "dropphycty": "EARLINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 189189998,
    "dropmaladd": "403 MORWOOD RD",
    "dropmalcty": "EARLINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 189189998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157234536,
    "dropsitcph": 2157234536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18093",
    "droptype": "D",
    "dropname": "EARLVILLE",
    "dropdeladd": "7404 BOYERTOWN PIKE",
    "dropdelcty": "EARLVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195199998,
    "dropphyadd": "7404 BOYERTOWN PIKE",
    "dropphycty": "EARLVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195199998,
    "dropmaladd": "7404 BOYERTOWN PIKE",
    "dropmalcty": "EARLVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195199998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106899219,
    "dropsitcph": 6106899219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18099",
    "droptype": "D",
    "dropname": "EAST BERLIN",
    "dropdeladd": "214 3RD ST",
    "dropdelcty": "EAST BERLIN",
    "dropdelst": "PA",
    "dropdelzpp": 173169998,
    "dropphyadd": "214 3RD ST",
    "dropphycty": "EAST BERLIN",
    "dropphyst": "PA",
    "dropphyzpp": 173169998,
    "dropmaladd": "214 3RD ST",
    "dropmalcty": "EAST BERLIN",
    "dropmalst": "PA",
    "dropmalzpp": 173169998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172599724,
    "dropsitcph": 7172599724,
    "dropfax": 7172597682
  },
  {
    "dcode": "D",
    "dropkey": "PX18100",
    "droptype": "D",
    "dropname": "EAST BRADY",
    "dropdeladd": "422 KELLYS WAY",
    "dropdelcty": "EAST BRADY",
    "dropdelst": "PA",
    "dropdelzpp": 160289800,
    "dropphyadd": "422 KELLYS WAY",
    "dropphycty": "EAST BRADY",
    "dropphyst": "PA",
    "dropphyzpp": 160289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST BRADY",
    "dropmalst": "PA",
    "dropmalzpp": 160289998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245263381,
    "dropsitcph": 7245263381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18103",
    "droptype": "D",
    "dropname": "EAST BUTLER",
    "dropdeladd": "720 GRANT AVE",
    "dropdelcty": "EAST BUTLER",
    "dropdelst": "PA",
    "dropdelzpp": 160299800,
    "dropphyadd": "720 GRANT AVE",
    "dropphycty": "EAST BUTLER",
    "dropphyst": "PA",
    "dropphyzpp": 160299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST BUTLER",
    "dropmalst": "PA",
    "dropmalzpp": 160299998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242875169,
    "dropsitcph": 7242875169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18106",
    "droptype": "D",
    "dropname": "EAST EARL",
    "dropdeladd": "1238 E EARL RD",
    "dropdelcty": "EAST EARL",
    "dropdelst": "PA",
    "dropdelzpp": 175199998,
    "dropphyadd": "1238 E EARL RD",
    "dropphycty": "EAST EARL",
    "dropphyst": "PA",
    "dropphyzpp": 175199998,
    "dropmaladd": "1238 E EARL RD",
    "dropmalcty": "EAST EARL",
    "dropmalst": "PA",
    "dropmalzpp": 175199998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173547253,
    "dropsitcph": 7173547253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18110",
    "droptype": "D",
    "dropname": "EAST FREEDOM",
    "dropdeladd": "2801 EVERETT RD",
    "dropdelcty": "EAST FREEDOM",
    "dropdelst": "PA",
    "dropdelzpp": 166379998,
    "dropphyadd": "2801 EVERETT RD",
    "dropphycty": "EAST FREEDOM",
    "dropphyst": "PA",
    "dropphyzpp": 166379998,
    "dropmaladd": "2801 EVERETT RD",
    "dropmalcty": "EAST FREEDOM",
    "dropmalst": "PA",
    "dropmalzpp": 166379998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146950157,
    "dropsitcph": 8146950157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18113",
    "droptype": "D",
    "dropname": "EAST GREENVILLE",
    "dropdeladd": "357 MAIN ST OFC",
    "dropdelcty": "EAST GREENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180419998,
    "dropphyadd": "357 MAIN ST OFC",
    "dropphycty": "EAST GREENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180419998,
    "dropmaladd": "357 MAIN ST OFC",
    "dropmalcty": "EAST GREENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180419998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2156792081,
    "dropfax": 2156790806
  },
  {
    "dcode": "D",
    "dropkey": "PX18122",
    "droptype": "D",
    "dropname": "EAST MC KEESPORT",
    "dropdeladd": "985 JOSEPHINE ST",
    "dropdelcty": "EAST MC KEESPORT",
    "dropdelst": "PA",
    "dropdelzpp": 150359998,
    "dropphyadd": "985 JOSEPHINE ST",
    "dropphycty": "EAST MC KEESPORT",
    "dropphyst": "PA",
    "dropphyzpp": 150359998,
    "dropmaladd": "985 JOSEPHINE ST",
    "dropmalcty": "EAST MC KEESPORT",
    "dropmalst": "PA",
    "dropmalzpp": 150359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128236488,
    "dropsitcph": 4128236488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18124",
    "droptype": "D",
    "dropname": "EAST MILLSBORO",
    "dropdeladd": "326 MILLSBORO RD",
    "dropdelcty": "EAST MILLSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 154331001,
    "dropphyadd": "326 MILLSBORO RD",
    "dropphycty": "EAST MILLSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 154331001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST MILLSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 154339998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247853300,
    "dropsitcph": 7247853300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18129",
    "droptype": "D",
    "dropname": "EAST PETERSBURG",
    "dropdeladd": "2049 MILLER RD",
    "dropdelcty": "EAST PETERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 175209998,
    "dropphyadd": "2049 MILLER RD",
    "dropphycty": "EAST PETERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 175209998,
    "dropmaladd": "2049 MILLER RD",
    "dropmalcty": "EAST PETERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 175209998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175691621,
    "dropsitcph": 7175691621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18132",
    "droptype": "D",
    "dropname": "EAST PITTSBURGH",
    "dropdeladd": "701 LINDEN AVE",
    "dropdelcty": "EAST PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 151129998,
    "dropphyadd": "701 LINDEN AVE",
    "dropphycty": "EAST PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 151129998,
    "dropmaladd": "701 LINDEN AVE",
    "dropmalcty": "EAST PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 151129998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128233625,
    "dropsitcph": 4128233625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18133",
    "droptype": "D",
    "dropname": "EAST PROSPECT",
    "dropdeladd": "1 W RIDGE AVE",
    "dropdelcty": "EAST PROSPECT",
    "dropdelst": "PA",
    "dropdelzpp": 173179998,
    "dropphyadd": "1 W RIDGE AVE",
    "dropphycty": "EAST PROSPECT",
    "dropphyst": "PA",
    "dropphyzpp": 173179998,
    "dropmaladd": "1 W RIDGE AVE",
    "dropmalcty": "EAST PROSPECT",
    "dropmalst": "PA",
    "dropmalzpp": 173179998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172523814,
    "dropsitcph": 7172523814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18136",
    "droptype": "D",
    "dropname": "EAST SMETHPORT",
    "dropdeladd": "18253 ROUTE 6",
    "dropdelcty": "EAST SMETHPORT",
    "dropdelst": "PA",
    "dropdelzpp": 167309800,
    "dropphyadd": "18253 ROUTE 6",
    "dropphycty": "EAST SMETHPORT",
    "dropphyst": "PA",
    "dropphyzpp": 167309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SMETHPORT",
    "dropmalst": "PA",
    "dropmalzpp": 167309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148875758,
    "dropsitcph": 8148875758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18137",
    "droptype": "D",
    "dropname": "EAST SMITHFIELD",
    "dropdeladd": "30 VILLAGE GREEN WAY",
    "dropdelcty": "EAST SMITHFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 188179998,
    "dropphyadd": "30 VILLAGE GREEN WAY",
    "dropphycty": "EAST SMITHFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 188179998,
    "dropmaladd": "30 VILLAGE GREEN WAY",
    "dropmalcty": "EAST SMITHFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 188179998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705964090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18138",
    "droptype": "D",
    "dropname": "EAST SPRINGFIELD",
    "dropdeladd": "11932 MAIN ST STE A",
    "dropdelcty": "EAST SPRINGFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 164119800,
    "dropphyadd": "11932 MAIN ST STE A",
    "dropphycty": "EAST SPRINGFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 164119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SPRINGFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 164119998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149223939,
    "dropsitcph": 8149223939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18140",
    "droptype": "D",
    "dropname": "EAST STROUDSBURG",
    "dropdeladd": "200 S COURTLAND ST",
    "dropdelcty": "EAST STROUDSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 183019998,
    "dropphyadd": "200 S COURTLAND ST",
    "dropphycty": "EAST STROUDSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 183019998,
    "dropmaladd": "200 S COURTLAND ST",
    "dropmalcty": "EAST STROUDSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 183019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704213310,
    "dropfax": 5704209967
  },
  {
    "dcode": "D",
    "dropkey": "PX18141",
    "droptype": "D",
    "dropname": "EAST TEXAS",
    "dropdeladd": "5637 E TEXAS RD",
    "dropdelcty": "EAST TEXAS",
    "dropdelst": "PA",
    "dropdelzpp": 180469998,
    "dropphyadd": "5637 E TEXAS RD",
    "dropphycty": "EAST TEXAS",
    "dropphyst": "PA",
    "dropphyzpp": 180469998,
    "dropmaladd": "5637 E TEXAS RD",
    "dropmalcty": "EAST TEXAS",
    "dropmalst": "PA",
    "dropmalzpp": 180469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103954098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18143",
    "droptype": "D",
    "dropname": "EAST VANDERGRIFT",
    "dropdeladd": "252 MCKINLEY AVE",
    "dropdelcty": "EAST VANDERGRIFT",
    "dropdelst": "PA",
    "dropdelzpp": 156291001,
    "dropphyadd": "252 MCKINLEY AVE",
    "dropphycty": "EAST VANDERGRIFT",
    "dropphyst": "PA",
    "dropphyzpp": 156291001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST VANDERGRIFT",
    "dropmalst": "PA",
    "dropmalzpp": 156299998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245682195,
    "dropsitcph": 7245682195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18144",
    "droptype": "D",
    "dropname": "EAST WATERFORD",
    "dropdeladd": "9393 ROUTE 75 S",
    "dropdelcty": "EAST WATERFORD",
    "dropdelst": "PA",
    "dropdelzpp": 170219800,
    "dropphyadd": "9393 ROUTE 75 S",
    "dropphycty": "EAST WATERFORD",
    "dropphyst": "PA",
    "dropphyzpp": 170219800,
    "dropmaladd": "9393 ROUTE 75 S",
    "dropmalcty": "EAST WATERFORD",
    "dropmalst": "PA",
    "dropmalzpp": 170219800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177343585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18149",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "201 FERRY ST BLDG 1",
    "dropdelcty": "EASTON",
    "dropdelst": "PA",
    "dropdelzpp": 180429998,
    "dropphyadd": "201 FERRY ST BLDG 1",
    "dropphycty": "EASTON",
    "dropphyst": "PA",
    "dropphyzpp": 180429998,
    "dropmaladd": "201 FERRY ST BLDG 1",
    "dropmalcty": "EASTON",
    "dropmalst": "PA",
    "dropmalzpp": 180429998,
    "dropsitphn": 6102534151,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102534151,
    "dropfax": 6102520545
  },
  {
    "dcode": "D",
    "dropkey": "PX18153",
    "droptype": "D",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "205 S WASHINGTON ST",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "PA",
    "dropdelzpp": 160309800,
    "dropphyadd": "205 S WASHINGTON ST",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "PA",
    "dropphyzpp": 160309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "PA",
    "dropmalzpp": 160309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247912228,
    "dropsitcph": 7247912228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18155",
    "droptype": "D",
    "dropname": "EBENSBURG",
    "dropdeladd": "121 N CENTER ST",
    "dropdelcty": "EBENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 159319998,
    "dropphyadd": "121 N CENTER ST",
    "dropphycty": "EBENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 159319998,
    "dropmaladd": "121 N CENTER ST",
    "dropmalcty": "EBENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 159319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144727830,
    "dropsitcph": 8144727830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18157",
    "droptype": "D",
    "dropname": "EBERVALE",
    "dropdeladd": "102 OAKMONT DR",
    "dropdelcty": "EBERVALE",
    "dropdelst": "PA",
    "dropdelzpp": 182239800,
    "dropphyadd": "102 OAKMONT DR",
    "dropphycty": "EBERVALE",
    "dropphyst": "PA",
    "dropphyzpp": 182239800,
    "dropmaladd": "102 OAKMONT DR",
    "dropmalcty": "EBERVALE",
    "dropmalst": "PA",
    "dropmalzpp": 182239800,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704559833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18169",
    "droptype": "D",
    "dropname": "EDGEMONT",
    "dropdeladd": "5044 W CHESTER PIKE",
    "dropdelcty": "EDGEMONT",
    "dropdelst": "PA",
    "dropdelzpp": 190289901,
    "dropphyadd": "5044 W CHESTER PIKE",
    "dropphycty": "EDGEMONT",
    "dropphyst": "PA",
    "dropphyzpp": 190289901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGEMONT",
    "dropmalst": "PA",
    "dropmalzpp": 190289998,
    "dropsitphn": 6103563180,
    "dropsitlph": 6103563180,
    "dropsitcph": 6103563180,
    "dropfax": 6103563180
  },
  {
    "dcode": "D",
    "dropkey": "PX18176",
    "droptype": "D",
    "dropname": "EDINBORO",
    "dropdeladd": "300 WATERFORD ST",
    "dropdelcty": "EDINBORO",
    "dropdelst": "PA",
    "dropdelzpp": 164122300,
    "dropphyadd": "300 WATERFORD ST",
    "dropphycty": "EDINBORO",
    "dropphyst": "PA",
    "dropphyzpp": 164122300,
    "dropmaladd": "300 WATERFORD ST",
    "dropmalcty": "EDINBORO",
    "dropmalst": "PA",
    "dropmalzpp": 164122300,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147341711,
    "dropsitcph": 8147341711,
    "dropfax": 8147341711
  },
  {
    "dcode": "D",
    "dropkey": "PX18178",
    "droptype": "D",
    "dropname": "EDINBURG",
    "dropdeladd": "5412 ERIE ST",
    "dropdelcty": "EDINBURG",
    "dropdelst": "PA",
    "dropdelzpp": 161169800,
    "dropphyadd": "5412 ERIE ST",
    "dropphycty": "EDINBURG",
    "dropphyst": "PA",
    "dropphyzpp": 161169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDINBURG",
    "dropmalst": "PA",
    "dropmalzpp": 161169998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246678873,
    "dropsitcph": 7246678873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18187",
    "droptype": "D",
    "dropname": "EFFORT",
    "dropdeladd": "985 GILBERT RD",
    "dropdelcty": "EFFORT",
    "dropdelst": "PA",
    "dropdelzpp": 183309998,
    "dropphyadd": "985 GILBERT RD",
    "dropphycty": "EFFORT",
    "dropphyst": "PA",
    "dropphyzpp": 183309998,
    "dropmaladd": "985 GILBERT RD",
    "dropmalcty": "EFFORT",
    "dropmalst": "PA",
    "dropmalzpp": 183309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6106815656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18190",
    "droptype": "D",
    "dropname": "EIGHTY FOUR",
    "dropdeladd": "812 ROUTE 519",
    "dropdelcty": "EIGHTY FOUR",
    "dropdelst": "PA",
    "dropdelzpp": 153301001,
    "dropphyadd": "812 ROUTE 519",
    "dropphycty": "EIGHTY FOUR",
    "dropphyst": "PA",
    "dropphyzpp": 153301001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EIGHTY FOUR",
    "dropmalst": "PA",
    "dropmalzpp": 153309998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242224080,
    "dropsitcph": 7242224080,
    "dropfax": 7242293339
  },
  {
    "dcode": "D",
    "dropkey": "PX18195",
    "droptype": "D",
    "dropname": "ELDERTON",
    "dropdeladd": "201 E SALTWORK ST",
    "dropdelcty": "ELDERTON",
    "dropdelst": "PA",
    "dropdelzpp": 157369998,
    "dropphyadd": "201 E SALTWORK ST",
    "dropphycty": "ELDERTON",
    "dropphyst": "PA",
    "dropphyzpp": 157369998,
    "dropmaladd": "201 E SALTWORK ST",
    "dropmalcty": "ELDERTON",
    "dropmalst": "PA",
    "dropmalzpp": 157369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243542096,
    "dropsitcph": 7243542096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18197",
    "droptype": "D",
    "dropname": "ELDRED",
    "dropdeladd": "189 MAIN ST",
    "dropdelcty": "ELDRED",
    "dropdelst": "PA",
    "dropdelzpp": 167319800,
    "dropphyadd": "189 MAIN ST",
    "dropphycty": "ELDRED",
    "dropphyst": "PA",
    "dropphyzpp": 167319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELDRED",
    "dropmalst": "PA",
    "dropmalzpp": 167319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142254742,
    "dropsitcph": 8142254742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18202",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "18250 MAIN ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "PA",
    "dropdelzpp": 164139800,
    "dropphyadd": "18250 MAIN ST",
    "dropphycty": "ELGIN",
    "dropphyst": "PA",
    "dropphyzpp": 164139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELGIN",
    "dropmalst": "PA",
    "dropmalzpp": 164139998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146635641,
    "dropsitcph": 8146635641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18204",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "320 S 2ND AVE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "PA",
    "dropdelzpp": 150379998,
    "dropphyadd": "320 S 2ND AVE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "PA",
    "dropphyzpp": 150379998,
    "dropmaladd": "320 S 2ND AVE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "PA",
    "dropmalzpp": 150379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123842394,
    "dropsitcph": 4123842394,
    "dropfax": 4123843209
  },
  {
    "dcode": "D",
    "dropkey": "PX18206",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "137 S MARKET ST",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170229998,
    "dropphyadd": "137 S MARKET ST",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170229998,
    "dropmaladd": "137 S MARKET ST",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173671307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18207",
    "droptype": "D",
    "dropname": "ELIZABETHVILLE",
    "dropdeladd": "40 N COLLIER ST",
    "dropdelcty": "ELIZABETHVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170239998,
    "dropphyadd": "40 N COLLIER ST",
    "dropphycty": "ELIZABETHVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170239998,
    "dropmaladd": "40 N COLLIER ST",
    "dropmalcty": "ELIZABETHVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170239998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173628180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18214",
    "droptype": "D",
    "dropname": "ELKLAND",
    "dropdeladd": "104 S BUFFALO ST",
    "dropdelcty": "ELKLAND",
    "dropdelst": "PA",
    "dropdelzpp": 169209998,
    "dropphyadd": "104 S BUFFALO ST",
    "dropphycty": "ELKLAND",
    "dropphyst": "PA",
    "dropphyzpp": 169209998,
    "dropmaladd": "104 S BUFFALO ST",
    "dropmalcty": "ELKLAND",
    "dropmalst": "PA",
    "dropmalzpp": 169209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8142587196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18219",
    "droptype": "D",
    "dropname": "ELLIOTTSBURG",
    "dropdeladd": "50 VETERANS WAY",
    "dropdelcty": "ELLIOTTSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170249998,
    "dropphyadd": "50 VETERANS WAY",
    "dropphycty": "ELLIOTTSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170249998,
    "dropmaladd": "50 VETERANS WAY",
    "dropmalcty": "ELLIOTTSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177899693,
    "dropfax": 7177899693
  },
  {
    "dcode": "D",
    "dropkey": "PX18223",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "1002 ALMOND RD",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "PA",
    "dropdelzpp": 153311001,
    "dropphyadd": "1002 ALMOND RD",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "PA",
    "dropphyzpp": 153311001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "PA",
    "dropmalzpp": 153319998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242393185,
    "dropsitcph": 7242393185,
    "dropfax": 7242392443
  },
  {
    "dcode": "D",
    "dropkey": "PX18224",
    "droptype": "D",
    "dropname": "ELLWOOD CITY",
    "dropdeladd": "320 7TH ST",
    "dropdelcty": "ELLWOOD CITY",
    "dropdelst": "PA",
    "dropdelzpp": 161178500,
    "dropphyadd": "320 7TH ST",
    "dropphycty": "ELLWOOD CITY",
    "dropphyst": "PA",
    "dropphyzpp": 161178500,
    "dropmaladd": "320 7TH ST",
    "dropmalcty": "ELLWOOD CITY",
    "dropmalst": "PA",
    "dropmalzpp": 161178500,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247587531,
    "dropsitcph": 7247587531,
    "dropfax": 7247582152
  },
  {
    "dcode": "D",
    "dropkey": "PX18225",
    "droptype": "D",
    "dropname": "ELM",
    "dropdeladd": "656 W NEWPORT RD",
    "dropdelcty": "ELM",
    "dropdelst": "PA",
    "dropdelzpp": 175219998,
    "dropphyadd": "656 W NEWPORT RD",
    "dropphycty": "ELM",
    "dropphyst": "PA",
    "dropphyzpp": 175219998,
    "dropmaladd": "656 W NEWPORT RD",
    "dropmalcty": "ELM",
    "dropmalst": "PA",
    "dropmalzpp": 175219998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176657070,
    "dropsitcph": 7176657070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18229",
    "droptype": "D",
    "dropname": "ELMORA",
    "dropdeladd": "990 DEVEAUX ST",
    "dropdelcty": "ELMORA",
    "dropdelst": "PA",
    "dropdelzpp": 157379998,
    "dropphyadd": "990 DEVEAUX ST",
    "dropphycty": "ELMORA",
    "dropphyst": "PA",
    "dropphyzpp": 157379998,
    "dropmaladd": "990 DEVEAUX ST",
    "dropmalcty": "ELMORA",
    "dropmalst": "PA",
    "dropmalzpp": 157379998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149484225,
    "dropsitcph": 8149484225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18230",
    "droptype": "D",
    "dropname": "ELRAMA",
    "dropdeladd": "15 DAVIDSON AVE",
    "dropdelcty": "ELRAMA",
    "dropdelst": "PA",
    "dropdelzpp": 150381001,
    "dropphyadd": "15 DAVIDSON AVE",
    "dropphycty": "ELRAMA",
    "dropphyst": "PA",
    "dropphyzpp": 150381001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELRAMA",
    "dropmalst": "PA",
    "dropmalzpp": 150389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123847647,
    "dropsitcph": 4123847647,
    "dropfax": 4123847647
  },
  {
    "dcode": "D",
    "dropkey": "PX18232",
    "droptype": "D",
    "dropname": "ELTON",
    "dropdeladd": "4690 ELTON RD",
    "dropdelcty": "ELTON",
    "dropdelst": "PA",
    "dropdelzpp": 159349998,
    "dropphyadd": "4690 ELTON RD",
    "dropphycty": "ELTON",
    "dropphyst": "PA",
    "dropphyzpp": 159349998,
    "dropmaladd": "4690 ELTON RD",
    "dropmalcty": "ELTON",
    "dropmalst": "PA",
    "dropmalzpp": 159349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142661826,
    "dropsitcph": 8142661826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18233",
    "droptype": "D",
    "dropname": "ELVERSON",
    "dropdeladd": "24 S PINE ST",
    "dropdelcty": "ELVERSON",
    "dropdelst": "PA",
    "dropdelzpp": 195209998,
    "dropphyadd": "24 S PINE ST",
    "dropphycty": "ELVERSON",
    "dropphyst": "PA",
    "dropphyzpp": 195209998,
    "dropmaladd": "24 S PINE ST",
    "dropmalcty": "ELVERSON",
    "dropmalst": "PA",
    "dropmalzpp": 195209998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6102869393,
    "dropsitcph": 6102869393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18236",
    "droptype": "D",
    "dropname": "ELYSBURG",
    "dropdeladd": "5 E ROOSEVELT AVE",
    "dropdelcty": "ELYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178249800,
    "dropphyadd": "5 E ROOSEVELT AVE",
    "dropphycty": "ELYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178249800,
    "dropmaladd": "5 E ROOSEVELT AVE",
    "dropmalcty": "ELYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178249800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706722946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18238",
    "droptype": "D",
    "dropname": "EMEIGH",
    "dropdeladd": "871 MAIN ST",
    "dropdelcty": "EMEIGH",
    "dropdelst": "PA",
    "dropdelzpp": 157389998,
    "dropphyadd": "871 MAIN ST",
    "dropphycty": "EMEIGH",
    "dropphyst": "PA",
    "dropphyzpp": 157389998,
    "dropmaladd": "871 MAIN ST",
    "dropmalcty": "EMEIGH",
    "dropmalst": "PA",
    "dropmalzpp": 157389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149488466,
    "dropsitcph": 8149488466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18241",
    "droptype": "D",
    "dropname": "EMIGSVILLE",
    "dropdeladd": "2 EMIG RD",
    "dropdelcty": "EMIGSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173189998,
    "dropphyadd": "2 EMIG RD",
    "dropphycty": "EMIGSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173189998,
    "dropmaladd": "2 EMIG RD",
    "dropmalcty": "EMIGSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173189998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177648713,
    "dropsitcph": 7177648713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18244",
    "droptype": "D",
    "dropname": "EMLENTON",
    "dropdeladd": "714 MAIN ST",
    "dropdelcty": "EMLENTON",
    "dropdelst": "PA",
    "dropdelzpp": 163739800,
    "dropphyadd": "714 MAIN ST",
    "dropphycty": "EMLENTON",
    "dropphyst": "PA",
    "dropphyzpp": 163739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMLENTON",
    "dropmalst": "PA",
    "dropmalzpp": 163739998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248676421,
    "dropsitcph": 7248676421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18245",
    "droptype": "D",
    "dropname": "EMMAUS",
    "dropdeladd": "105 N 5TH ST",
    "dropdelcty": "EMMAUS",
    "dropdelst": "PA",
    "dropdelzpp": 180499998,
    "dropphyadd": "105 N 5TH ST",
    "dropphycty": "EMMAUS",
    "dropphyst": "PA",
    "dropphyzpp": 180499998,
    "dropmaladd": "105 N 5TH ST",
    "dropmalcty": "EMMAUS",
    "dropmalst": "PA",
    "dropmalzpp": 180499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6109652647,
    "dropfax": 6109653365
  },
  {
    "dcode": "D",
    "dropkey": "PX18246",
    "droptype": "D",
    "dropname": "EMPORIUM",
    "dropdeladd": "11 W 4TH ST",
    "dropdelcty": "EMPORIUM",
    "dropdelst": "PA",
    "dropdelzpp": 158341293,
    "dropphyadd": "11 W 4TH ST",
    "dropphycty": "EMPORIUM",
    "dropphyst": "PA",
    "dropphyzpp": 158341293,
    "dropmaladd": "11 W 4TH ST",
    "dropmalcty": "EMPORIUM",
    "dropmalst": "PA",
    "dropmalzpp": 158341293,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144863385,
    "dropsitcph": 8144863385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18248",
    "droptype": "D",
    "dropname": "ENDEAVOR",
    "dropdeladd": "17520 ROUTE 666",
    "dropdelcty": "ENDEAVOR",
    "dropdelst": "PA",
    "dropdelzpp": 163229800,
    "dropphyadd": "17520 ROUTE 666",
    "dropphycty": "ENDEAVOR",
    "dropphyst": "PA",
    "dropphyzpp": 163229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENDEAVOR",
    "dropmalst": "PA",
    "dropmalzpp": 163229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144639265,
    "dropsitcph": 8144639265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18254",
    "droptype": "D",
    "dropname": "ENOLA",
    "dropdeladd": "514 MAGARO RD",
    "dropdelcty": "ENOLA",
    "dropdelst": "PA",
    "dropdelzpp": 170259998,
    "dropphyadd": "514 MAGARO RD",
    "dropphycty": "ENOLA",
    "dropphyst": "PA",
    "dropphyzpp": 170259998,
    "dropmaladd": "514 MAGARO RD",
    "dropmalcty": "ENOLA",
    "dropmalst": "PA",
    "dropmalzpp": 170259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177322221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18255",
    "droptype": "D",
    "dropname": "ENON VALLEY",
    "dropdeladd": "7150 VINE ST",
    "dropdelcty": "ENON VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 161209800,
    "dropphyadd": "7150 VINE ST",
    "dropphycty": "ENON VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 161209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENON VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 161209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243365130,
    "dropsitcph": 7243365130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18259",
    "droptype": "D",
    "dropname": "EPHRATA",
    "dropdeladd": "129 E MAIN ST",
    "dropdelcty": "EPHRATA",
    "dropdelst": "PA",
    "dropdelzpp": 175229998,
    "dropphyadd": "129 E MAIN ST",
    "dropphycty": "EPHRATA",
    "dropphyst": "PA",
    "dropphyzpp": 175229998,
    "dropmaladd": "129 E MAIN ST",
    "dropmalcty": "EPHRATA",
    "dropmalst": "PA",
    "dropmalzpp": 175229998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177332390,
    "dropsitcph": 7177332390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18261",
    "droptype": "D",
    "dropname": "EQUINUNK",
    "dropdeladd": "4338 HANCOCK HWY BLDG B",
    "dropdelcty": "EQUINUNK",
    "dropdelst": "PA",
    "dropdelzpp": 184179998,
    "dropphyadd": "4338 HANCOCK HWY BLDG B",
    "dropphycty": "EQUINUNK",
    "dropphyst": "PA",
    "dropphyzpp": 184179998,
    "dropmaladd": "4338 HANCOCK HWY BLDG B",
    "dropmalcty": "EQUINUNK",
    "dropmalst": "PA",
    "dropmalzpp": 184179998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702244270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18265",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "2108 E 38TH ST",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165159998,
    "dropphyadd": "2108 E 38TH ST",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165159998,
    "dropmaladd": "2108 E 38TH ST",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165159998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148987332,
    "dropsitcph": 8148987300,
    "dropfax": 8148987303
  },
  {
    "dcode": "D",
    "dropkey": "PX18269",
    "droptype": "D",
    "dropname": "ERWINNA",
    "dropdeladd": "39 HEADQUARTERS RD",
    "dropdelcty": "ERWINNA",
    "dropdelst": "PA",
    "dropdelzpp": 189209998,
    "dropphyadd": "39 HEADQUARTERS RD",
    "dropphycty": "ERWINNA",
    "dropphyst": "PA",
    "dropphyzpp": 189209998,
    "dropmaladd": "39 HEADQUARTERS RD",
    "dropmalcty": "ERWINNA",
    "dropmalst": "PA",
    "dropmalzpp": 189209998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102949300,
    "dropsitcph": 6102949300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18274",
    "droptype": "D",
    "dropname": "ESSINGTON",
    "dropdeladd": "408 POWHATTAN AVE STE 2",
    "dropdelcty": "ESSINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 190299998,
    "dropphyadd": "408 POWHATTAN AVE STE 2",
    "dropphycty": "ESSINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 190299998,
    "dropmaladd": "408 POWHATTAN AVE STE 2",
    "dropmalcty": "ESSINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 190299998,
    "dropsitphn": 6105212135,
    "dropsitlph": 6105212135,
    "dropsitcph": 6105212135,
    "dropfax": 6105210889
  },
  {
    "dcode": "D",
    "dropkey": "PX18278",
    "droptype": "D",
    "dropname": "ETTERS",
    "dropdeladd": "53 S KISTER ST",
    "dropdelcty": "ETTERS",
    "dropdelst": "PA",
    "dropdelzpp": 173199998,
    "dropphyadd": "53 S KISTER ST",
    "dropphycty": "ETTERS",
    "dropphyst": "PA",
    "dropphyzpp": 173199998,
    "dropmaladd": "53 S KISTER ST",
    "dropmalcty": "ETTERS",
    "dropmalst": "PA",
    "dropmalzpp": 173199998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179386137,
    "dropsitcph": 7179386137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18280",
    "droptype": "D",
    "dropname": "EVANS CITY",
    "dropdeladd": "126 S JACKSON ST",
    "dropdelcty": "EVANS CITY",
    "dropdelst": "PA",
    "dropdelzpp": 160331100,
    "dropphyadd": "126 S JACKSON ST",
    "dropphycty": "EVANS CITY",
    "dropphyst": "PA",
    "dropphyzpp": 160331100,
    "dropmaladd": "126 S JACKSON ST",
    "dropmalcty": "EVANS CITY",
    "dropmalst": "PA",
    "dropmalzpp": 160331100,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245389640,
    "dropsitcph": 7245389640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18283",
    "droptype": "D",
    "dropname": "EVERETT",
    "dropdeladd": "17 E MAIN ST",
    "dropdelcty": "EVERETT",
    "dropdelst": "PA",
    "dropdelzpp": 155379998,
    "dropphyadd": "17 E MAIN ST",
    "dropphycty": "EVERETT",
    "dropphyst": "PA",
    "dropphyzpp": 155379998,
    "dropmaladd": "17 E MAIN ST",
    "dropmalcty": "EVERETT",
    "dropmalst": "PA",
    "dropmalzpp": 155379998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146522525,
    "dropsitcph": 8146522525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18285",
    "droptype": "D",
    "dropname": "EVERSON",
    "dropdeladd": "328 BROWN ST",
    "dropdelcty": "EVERSON",
    "dropdelst": "PA",
    "dropdelzpp": 156311003,
    "dropphyadd": "328 BROWN ST",
    "dropphycty": "EVERSON",
    "dropphyst": "PA",
    "dropphyzpp": 156311003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERSON",
    "dropmalst": "PA",
    "dropmalzpp": 156319998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248875630,
    "dropsitcph": 7248875630,
    "dropfax": 7248875630
  },
  {
    "dcode": "D",
    "dropkey": "PX18298",
    "droptype": "D",
    "dropname": "EXTON",
    "dropdeladd": "430 EXTON SQUARE PKWY",
    "dropdelcty": "EXTON",
    "dropdelst": "PA",
    "dropdelzpp": 193419998,
    "dropphyadd": "430 EXTON SQUARE PKWY",
    "dropphycty": "EXTON",
    "dropphyst": "PA",
    "dropphyzpp": 193419998,
    "dropmaladd": "430 EXTON SQUARE PKWY",
    "dropmalcty": "EXTON",
    "dropmalst": "PA",
    "dropmalzpp": 193419998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103631278,
    "dropsitcph": 6103631278,
    "dropfax": 6103638139
  },
  {
    "dcode": "D",
    "dropkey": "PX18301",
    "droptype": "D",
    "dropname": "FACTORYVILLE",
    "dropdeladd": "102 COLLEGE AVE",
    "dropdelcty": "FACTORYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 184199998,
    "dropphyadd": "102 COLLEGE AVE",
    "dropphycty": "FACTORYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 184199998,
    "dropmaladd": "102 COLLEGE AVE",
    "dropmalcty": "FACTORYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 184199998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709455812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18306",
    "droptype": "D",
    "dropname": "FAIRBANK",
    "dropdeladd": "650 FAIRBANK HERBERT RD",
    "dropdelcty": "FAIRBANK",
    "dropdelst": "PA",
    "dropdelzpp": 154351001,
    "dropphyadd": "650 FAIRBANK HERBERT RD",
    "dropphycty": "FAIRBANK",
    "dropphyst": "PA",
    "dropphyzpp": 154351001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRBANK",
    "dropmalst": "PA",
    "dropmalzpp": 154359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242456150,
    "dropsitcph": 7242456150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18307",
    "droptype": "D",
    "dropname": "FAIRCHANCE",
    "dropdeladd": "50 W CHURCH ST",
    "dropdelcty": "FAIRCHANCE",
    "dropdelst": "PA",
    "dropdelzpp": 154369998,
    "dropphyadd": "50 W CHURCH ST",
    "dropphycty": "FAIRCHANCE",
    "dropphyst": "PA",
    "dropphyzpp": 154369998,
    "dropmaladd": "50 W CHURCH ST",
    "dropmalcty": "FAIRCHANCE",
    "dropmalst": "PA",
    "dropmalzpp": 154369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245642900,
    "dropsitcph": 7245642900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18309",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "6 CARROLLS TRACT RD",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 173209800,
    "dropphyadd": "6 CARROLLS TRACT RD",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 173209800,
    "dropmaladd": "6 CARROLLS TRACT RD",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 173209800,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176425198,
    "dropsitcph": 7176425198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18315",
    "droptype": "D",
    "dropname": "FAIRHOPE",
    "dropdeladd": "1172 FAIRHOPE RD",
    "dropdelcty": "FAIRHOPE",
    "dropdelst": "PA",
    "dropdelzpp": 155389998,
    "dropphyadd": "1172 FAIRHOPE RD",
    "dropphycty": "FAIRHOPE",
    "dropphyst": "PA",
    "dropphyzpp": 155389998,
    "dropmaladd": "1172 FAIRHOPE RD",
    "dropmalcty": "FAIRHOPE",
    "dropmalst": "PA",
    "dropmalzpp": 155389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142673818,
    "dropsitcph": 8142673818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18319",
    "droptype": "D",
    "dropname": "FAIRLESS HILLS",
    "dropdeladd": "481 S OXFORD VALLEY RD",
    "dropdelcty": "FAIRLESS HILLS",
    "dropdelst": "PA",
    "dropdelzpp": 190309998,
    "dropphyadd": "481 S OXFORD VALLEY RD",
    "dropphycty": "FAIRLESS HILLS",
    "dropphyst": "PA",
    "dropphyzpp": 190309998,
    "dropmaladd": "481 S OXFORD VALLEY RD",
    "dropmalcty": "FAIRLESS HILLS",
    "dropmalst": "PA",
    "dropmalzpp": 190309998,
    "dropsitphn": 2159491777,
    "dropsitlph": 2159467146,
    "dropsitcph": 2159467146,
    "dropfax": 2159469902
  },
  {
    "dcode": "D",
    "dropkey": "PX18324",
    "droptype": "D",
    "dropname": "FAIRMOUNT CITY",
    "dropdeladd": "54 MAPLE AVE",
    "dropdelcty": "FAIRMOUNT CITY",
    "dropdelst": "PA",
    "dropdelzpp": 162249800,
    "dropphyadd": "54 MAPLE AVE",
    "dropphycty": "FAIRMOUNT CITY",
    "dropphyst": "PA",
    "dropphyzpp": 162249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRMOUNT CITY",
    "dropmalst": "PA",
    "dropmalzpp": 162249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142752331,
    "dropsitcph": 8142752331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18329",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "3856 AVONIA RD",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "PA",
    "dropdelzpp": 164159800,
    "dropphyadd": "3856 AVONIA RD",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "PA",
    "dropphyzpp": 164159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "PA",
    "dropmalzpp": 164159998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8144745119,
    "dropsitcph": 8144745119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18339",
    "droptype": "D",
    "dropname": "FALLENTIMBER",
    "dropdeladd": "1664 GLENDALE VALLEY BLVD",
    "dropdelcty": "FALLENTIMBER",
    "dropdelst": "PA",
    "dropdelzpp": 166399998,
    "dropphyadd": "1664 GLENDALE VALLEY BLVD",
    "dropphycty": "FALLENTIMBER",
    "dropphyst": "PA",
    "dropphyzpp": 166399998,
    "dropmaladd": "1664 GLENDALE VALLEY BLVD",
    "dropmalcty": "FALLENTIMBER",
    "dropmalst": "PA",
    "dropmalzpp": 166399998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146873215,
    "dropsitcph": 8146873215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18342",
    "droptype": "D",
    "dropname": "FALLS",
    "dropdeladd": "26 WOODSIDE DR",
    "dropdelcty": "FALLS",
    "dropdelst": "PA",
    "dropdelzpp": 186159998,
    "dropphyadd": "26 WOODSIDE DR",
    "dropphycty": "FALLS",
    "dropphyst": "PA",
    "dropphyzpp": 186159998,
    "dropmaladd": "26 WOODSIDE DR",
    "dropmalcty": "FALLS",
    "dropmalst": "PA",
    "dropmalzpp": 186159998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703886610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18344",
    "droptype": "D",
    "dropname": "FALLS CREEK",
    "dropdeladd": "65 MAIN ST",
    "dropdelcty": "FALLS CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 158409800,
    "dropphyadd": "65 MAIN ST",
    "dropphycty": "FALLS CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 158409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALLS CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 158409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143713433,
    "dropsitcph": 8143713433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18348",
    "droptype": "D",
    "dropname": "FANNETTSBURG",
    "dropdeladd": "10900 PATH VALLEY RD",
    "dropdelcty": "FANNETTSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172219998,
    "dropphyadd": "10900 PATH VALLEY RD",
    "dropphycty": "FANNETTSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172219998,
    "dropmaladd": "10900 PATH VALLEY RD",
    "dropmalcty": "FANNETTSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173497434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18351",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "103 FARMINGTON OHIOPYLE RD",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 154371302,
    "dropphyadd": "103 FARMINGTON OHIOPYLE RD",
    "dropphycty": "FARMINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 154371302,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 154379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243294765,
    "dropsitcph": 7243294765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18354",
    "droptype": "D",
    "dropname": "FARRELL",
    "dropdeladd": "700 SPEARMAN AVE",
    "dropdelcty": "FARRELL",
    "dropdelst": "PA",
    "dropdelzpp": 161219998,
    "dropphyadd": "700 SPEARMAN AVE",
    "dropphycty": "FARRELL",
    "dropphyst": "PA",
    "dropphyzpp": 161219998,
    "dropmaladd": "700 SPEARMAN AVE",
    "dropmalcty": "FARRELL",
    "dropmalst": "PA",
    "dropmalzpp": 161219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243463611,
    "dropsitcph": 7243463611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18358",
    "droptype": "D",
    "dropname": "FAWN GROVE",
    "dropdeladd": "119 S MARKET ST",
    "dropdelcty": "FAWN GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 173219998,
    "dropphyadd": "119 S MARKET ST",
    "dropphycty": "FAWN GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 173219998,
    "dropmaladd": "119 S MARKET ST",
    "dropmalcty": "FAWN GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 173219998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173824024,
    "dropsitcph": 7173824024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18362",
    "droptype": "D",
    "dropname": "FAYETTE CITY",
    "dropdeladd": "121 JOHNSON HOLLOW RD",
    "dropdelcty": "FAYETTE CITY",
    "dropdelst": "PA",
    "dropdelzpp": 154382111,
    "dropphyadd": "121 JOHNSON HOLLOW RD",
    "dropphycty": "FAYETTE CITY",
    "dropphyst": "PA",
    "dropphyzpp": 154382111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAYETTE CITY",
    "dropmalst": "PA",
    "dropmalzpp": 154389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243268888,
    "dropsitcph": 7243268888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18365",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "4025 LINCOLN WAY E",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 172229998,
    "dropphyadd": "4025 LINCOLN WAY E",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 172229998,
    "dropmaladd": "4025 LINCOLN WAY E",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 172229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173522022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18373",
    "droptype": "D",
    "dropname": "FELTON",
    "dropdeladd": "13 RIPPLING RUN RD",
    "dropdelcty": "FELTON",
    "dropdelst": "PA",
    "dropdelzpp": 173229998,
    "dropphyadd": "13 RIPPLING RUN RD",
    "dropphycty": "FELTON",
    "dropphyst": "PA",
    "dropphyzpp": 173229998,
    "dropmaladd": "13 RIPPLING RUN RD",
    "dropmalcty": "FELTON",
    "dropmalst": "PA",
    "dropmalzpp": 173229998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172445520,
    "dropsitcph": 7172445520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18375",
    "droptype": "D",
    "dropname": "FENELTON",
    "dropdeladd": "811 CLEARFIELD RD",
    "dropdelcty": "FENELTON",
    "dropdelst": "PA",
    "dropdelzpp": 160349800,
    "dropphyadd": "811 CLEARFIELD RD",
    "dropphycty": "FENELTON",
    "dropphyst": "PA",
    "dropphyzpp": 160349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENELTON",
    "dropmalst": "PA",
    "dropmalzpp": 160349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244452677,
    "dropsitcph": 7244452677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18379",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "9110 EASTON RD",
    "dropdelcty": "FERNDALE",
    "dropdelst": "PA",
    "dropdelzpp": 189219998,
    "dropphyadd": "9110 EASTON RD",
    "dropphycty": "FERNDALE",
    "dropphyst": "PA",
    "dropphyzpp": 189219998,
    "dropmaladd": "9110 EASTON RD",
    "dropmalcty": "FERNDALE",
    "dropmalst": "PA",
    "dropmalzpp": 189219998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108475779,
    "dropsitcph": 6108475779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18390",
    "droptype": "D",
    "dropname": "FINLEYVILLE",
    "dropdeladd": "3510 EXTENSION AVE",
    "dropdelcty": "FINLEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153329998,
    "dropphyadd": "3510 EXTENSION AVE",
    "dropphycty": "FINLEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153329998,
    "dropmaladd": "3510 EXTENSION AVE",
    "dropmalcty": "FINLEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153329998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243487277,
    "dropsitcph": 7243487277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18400",
    "droptype": "D",
    "dropname": "FISHERTOWN",
    "dropdeladd": "2240 QUAKER VALLEY RD",
    "dropdelcty": "FISHERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 155399998,
    "dropphyadd": "2240 QUAKER VALLEY RD",
    "dropphycty": "FISHERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 155399998,
    "dropmaladd": "2240 QUAKER VALLEY RD",
    "dropmalcty": "FISHERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 155399998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148394571,
    "dropsitcph": 8148394571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18408",
    "droptype": "D",
    "dropname": "FLEETVILLE",
    "dropdeladd": "16043 STATE ROUTE 407",
    "dropdelcty": "FLEETVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 184209998,
    "dropphyadd": "16043 STATE ROUTE 407",
    "dropphycty": "FLEETVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 184209998,
    "dropmaladd": "16043 STATE ROUTE 407",
    "dropmalcty": "FLEETVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 184209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709459100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18411",
    "droptype": "D",
    "dropname": "FLEETWOOD",
    "dropdeladd": "9 LENHART RD",
    "dropdelcty": "FLEETWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 195229998,
    "dropphyadd": "9 LENHART RD",
    "dropphycty": "FLEETWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 195229998,
    "dropmaladd": "9 LENHART RD",
    "dropmalcty": "FLEETWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 195229998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109449077,
    "dropsitcph": 6109449077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18412",
    "droptype": "D",
    "dropname": "FLEMING",
    "dropdeladd": "241 MAIN ST",
    "dropdelcty": "FLEMING",
    "dropdelst": "PA",
    "dropdelzpp": 168359998,
    "dropphyadd": "241 MAIN ST",
    "dropphycty": "FLEMING",
    "dropphyst": "PA",
    "dropphyzpp": 168359998,
    "dropmaladd": "241 MAIN ST",
    "dropmalcty": "FLEMING",
    "dropmalst": "PA",
    "dropmalzpp": 168359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143551526,
    "dropsitcph": 8143551526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18417",
    "droptype": "D",
    "dropname": "FLINTON",
    "dropdeladd": "2154 BEAVER VALLEY RD",
    "dropdelcty": "FLINTON",
    "dropdelst": "PA",
    "dropdelzpp": 166409998,
    "dropphyadd": "2154 BEAVER VALLEY RD",
    "dropphycty": "FLINTON",
    "dropphyst": "PA",
    "dropphyzpp": 166409998,
    "dropmaladd": "2154 BEAVER VALLEY RD",
    "dropmalcty": "FLINTON",
    "dropmalst": "PA",
    "dropmalzpp": 166409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146873643,
    "dropsitcph": 8146873643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18422",
    "droptype": "D",
    "dropname": "FLOURTOWN",
    "dropdeladd": "1818 BETHLEHEM PIKE",
    "dropdelcty": "FLOURTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190319998,
    "dropphyadd": "1818 BETHLEHEM PIKE",
    "dropphycty": "FLOURTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190319998,
    "dropmaladd": "1818 BETHLEHEM PIKE",
    "dropmalcty": "FLOURTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190319998,
    "dropsitphn": 2152338954,
    "dropsitlph": 2152331888,
    "dropsitcph": 2152338954,
    "dropfax": 2158364497
  },
  {
    "dcode": "D",
    "dropkey": "PX18423",
    "droptype": "D",
    "dropname": "FOGELSVILLE",
    "dropdeladd": "7918 MAIN ST OFC",
    "dropdelcty": "FOGELSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180519800,
    "dropphyadd": "7918 MAIN ST OFC",
    "dropphycty": "FOGELSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180519800,
    "dropmaladd": "7918 MAIN ST OFC",
    "dropmalcty": "FOGELSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180519800,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103952911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18426",
    "droptype": "D",
    "dropname": "FOLCROFT",
    "dropdeladd": "1836 DELMAR DR STE 1",
    "dropdelcty": "FOLCROFT",
    "dropdelst": "PA",
    "dropdelzpp": 190329998,
    "dropphyadd": "1836 DELMAR DR STE 1",
    "dropphycty": "FOLCROFT",
    "dropphyst": "PA",
    "dropphyzpp": 190329998,
    "dropmaladd": "1836 DELMAR DR STE 1",
    "dropmalcty": "FOLCROFT",
    "dropmalst": "PA",
    "dropmalzpp": 190329998,
    "dropsitphn": 6105835810,
    "dropsitlph": 6105835810,
    "dropsitcph": 6105835810,
    "dropfax": 6105323942
  },
  {
    "dcode": "D",
    "dropkey": "PX18427",
    "droptype": "D",
    "dropname": "FOLSOM",
    "dropdeladd": "1414 MACDADE BLVD",
    "dropdelcty": "FOLSOM",
    "dropdelst": "PA",
    "dropdelzpp": 190339998,
    "dropphyadd": "1414 MACDADE BLVD",
    "dropphycty": "FOLSOM",
    "dropphyst": "PA",
    "dropphyzpp": 190339998,
    "dropmaladd": "1414 MACDADE BLVD",
    "dropmalcty": "FOLSOM",
    "dropmalst": "PA",
    "dropmalzpp": 190339998,
    "dropsitphn": 2155343530,
    "dropsitlph": 6105347480,
    "dropsitcph": 6105343530,
    "dropfax": 6105348671
  },
  {
    "dcode": "D",
    "dropkey": "PX18433",
    "droptype": "D",
    "dropname": "FORBES ROAD",
    "dropdeladd": "344 FIRE STATION RD",
    "dropdelcty": "FORBES ROAD",
    "dropdelst": "PA",
    "dropdelzpp": 156331001,
    "dropphyadd": "344 FIRE STATION RD",
    "dropphycty": "FORBES ROAD",
    "dropphyst": "PA",
    "dropphyzpp": 156331001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORBES ROAD",
    "dropmalst": "PA",
    "dropmalzpp": 156339998,
    "dropsitphn": 4123597960,
    "dropsitlph": 7248341315,
    "dropsitcph": 7248341315,
    "dropfax": 7248341315
  },
  {
    "dcode": "D",
    "dropkey": "PX18434",
    "droptype": "D",
    "dropname": "FORCE",
    "dropdeladd": "17686 BENNETTS VALLEY HWY",
    "dropdelcty": "FORCE",
    "dropdelst": "PA",
    "dropdelzpp": 158419800,
    "dropphyadd": "17686 BENNETTS VALLEY HWY",
    "dropphycty": "FORCE",
    "dropphyst": "PA",
    "dropphyzpp": 158419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORCE",
    "dropmalst": "PA",
    "dropmalzpp": 158419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147878533,
    "dropsitcph": 8147878533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18435",
    "droptype": "D",
    "dropname": "FORD CITY",
    "dropdeladd": "824 4TH AVE",
    "dropdelcty": "FORD CITY",
    "dropdelst": "PA",
    "dropdelzpp": 162261177,
    "dropphyadd": "824 4TH AVE",
    "dropphycty": "FORD CITY",
    "dropphyst": "PA",
    "dropphyzpp": 162261177,
    "dropmaladd": "824 4TH AVE",
    "dropmalcty": "FORD CITY",
    "dropmalst": "PA",
    "dropmalzpp": 162261177,
    "dropsitphn": 7247638021,
    "dropsitlph": 7247638021,
    "dropsitcph": 7247638021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18438",
    "droptype": "D",
    "dropname": "FOREST CITY",
    "dropdeladd": "334 MAIN ST",
    "dropdelcty": "FOREST CITY",
    "dropdelst": "PA",
    "dropdelzpp": 184219998,
    "dropphyadd": "334 MAIN ST",
    "dropphycty": "FOREST CITY",
    "dropphyst": "PA",
    "dropphyzpp": 184219998,
    "dropmaladd": "334 MAIN ST",
    "dropmalcty": "FOREST CITY",
    "dropmalst": "PA",
    "dropmalzpp": 184219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707853053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18441",
    "droptype": "D",
    "dropname": "FOREST GROVE",
    "dropdeladd": "1809 FOREST GROVE RD",
    "dropdelcty": "FOREST GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 189229998,
    "dropphyadd": "1809 FOREST GROVE RD",
    "dropphycty": "FOREST GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 189229998,
    "dropmaladd": "1809 FOREST GROVE RD",
    "dropmalcty": "FOREST GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 189229998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157943346,
    "dropsitcph": 2157943346,
    "dropfax": 2157941429
  },
  {
    "dcode": "D",
    "dropkey": "PX18447",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "4114 WILLIAM FLYNN HWY",
    "dropdelcty": "FORESTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 160359800,
    "dropphyadd": "4114 WILLIAM FLYNN HWY",
    "dropphycty": "FORESTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 160359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORESTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 160359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247352327,
    "dropsitcph": 7247352327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18451",
    "droptype": "D",
    "dropname": "FORKSVILLE",
    "dropdeladd": "53 BRIDGE ST",
    "dropdelcty": "FORKSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 186169998,
    "dropphyadd": "53 BRIDGE ST",
    "dropphycty": "FORKSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 186169998,
    "dropmaladd": "53 BRIDGE ST",
    "dropmalcty": "FORKSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 186169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709243184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18455",
    "droptype": "D",
    "dropname": "FORT HILL",
    "dropdeladd": "414 FORT HILL RD",
    "dropdelcty": "FORT HILL",
    "dropdelst": "PA",
    "dropdelzpp": 155409998,
    "dropphyadd": "414 FORT HILL RD",
    "dropphycty": "FORT HILL",
    "dropphyst": "PA",
    "dropphyzpp": 155409998,
    "dropmaladd": "414 FORT HILL RD",
    "dropmalcty": "FORT HILL",
    "dropmalst": "PA",
    "dropmalzpp": 155409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143953451,
    "dropsitcph": 8143953451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18458",
    "droptype": "D",
    "dropname": "FORT LOUDON",
    "dropdeladd": "131 HAWBAKER DR N",
    "dropdelcty": "FORT LOUDON",
    "dropdelst": "PA",
    "dropdelzpp": 172249998,
    "dropphyadd": "131 HAWBAKER DR N",
    "dropphycty": "FORT LOUDON",
    "dropphyst": "PA",
    "dropphyzpp": 172249998,
    "dropmaladd": "131 HAWBAKER DR N",
    "dropmalcty": "FORT LOUDON",
    "dropmalst": "PA",
    "dropmalzpp": 172249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173693535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18461",
    "droptype": "D",
    "dropname": "FORT WASHINGTON",
    "dropdeladd": "575 PINETOWN RD",
    "dropdelcty": "FORT WASHINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 190349998,
    "dropphyadd": "575 PINETOWN RD",
    "dropphycty": "FORT WASHINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 190349998,
    "dropmaladd": "575 PINETOWN RD",
    "dropmalcty": "FORT WASHINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 190349998,
    "dropsitphn": 2156460952,
    "dropsitlph": 2156460164,
    "dropsitcph": 2156460952,
    "dropfax": 2156465964
  },
  {
    "dcode": "D",
    "dropkey": "PX18469",
    "droptype": "D",
    "dropname": "FOUNTAINVILLE",
    "dropdeladd": "5045 SWAMP RD STE 102",
    "dropdelcty": "FOUNTAINVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189239998,
    "dropphyadd": "5045 SWAMP RD STE 102",
    "dropphycty": "FOUNTAINVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189239998,
    "dropmaladd": "5045 SWAMP RD STE 102",
    "dropmalcty": "FOUNTAINVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189239998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153458415,
    "dropsitcph": 2153458415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18479",
    "droptype": "D",
    "dropname": "FOXBURG",
    "dropdeladd": "105 RAILROAD ST",
    "dropdelcty": "FOXBURG",
    "dropdelst": "PA",
    "dropdelzpp": 160369800,
    "dropphyadd": "105 RAILROAD ST",
    "dropphycty": "FOXBURG",
    "dropphyst": "PA",
    "dropphyzpp": 160369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOXBURG",
    "dropmalst": "PA",
    "dropmalzpp": 160369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246592971,
    "dropsitcph": 7246592971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18483",
    "droptype": "D",
    "dropname": "FRACKVILLE",
    "dropdeladd": "109 S LEHIGH AVE",
    "dropdelcty": "FRACKVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 179319998,
    "dropphyadd": "109 S LEHIGH AVE",
    "dropphycty": "FRACKVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 179319998,
    "dropmaladd": "109 S LEHIGH AVE",
    "dropmalcty": "FRACKVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 179319998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708743770,
    "dropsitcph": 5708743770,
    "dropfax": 5708741618
  },
  {
    "dcode": "D",
    "dropkey": "PX18491",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "1202 ELK ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "PA",
    "dropdelzpp": 163238800,
    "dropphyadd": "1202 ELK ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "PA",
    "dropphyzpp": 163238800,
    "dropmaladd": "1202 ELK ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "PA",
    "dropmalzpp": 163238800,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144324018,
    "dropsitcph": 8144324018,
    "dropfax": 8144325043
  },
  {
    "dcode": "D",
    "dropkey": "PX18500",
    "droptype": "D",
    "dropname": "FRANKLINTOWN",
    "dropdeladd": "2 S BALTIMORE ST",
    "dropdelcty": "FRANKLINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173239998,
    "dropphyadd": "2 S BALTIMORE ST",
    "dropphycty": "FRANKLINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173239998,
    "dropmaladd": "2 S BALTIMORE ST",
    "dropmalcty": "FRANKLINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173239998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174329833,
    "dropsitcph": 7174329833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18502",
    "droptype": "D",
    "dropname": "FREDERICK",
    "dropdeladd": "2581 BIG RD",
    "dropdelcty": "FREDERICK",
    "dropdelst": "PA",
    "dropdelzpp": 194359998,
    "dropphyadd": "2581 BIG RD",
    "dropphycty": "FREDERICK",
    "dropphyst": "PA",
    "dropphyzpp": 194359998,
    "dropmaladd": "2581 BIG RD",
    "dropmalcty": "FREDERICK",
    "dropmalst": "PA",
    "dropmalzpp": 194359998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107546260,
    "dropsitcph": 6107546260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18503",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "3024 S PINE GROVE ST",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170269998,
    "dropphyadd": "3024 S PINE GROVE ST",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170269998,
    "dropmaladd": "3024 S PINE GROVE ST",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178655459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18505",
    "droptype": "D",
    "dropname": "FREDERICKTOWN",
    "dropdeladd": "531 FRONT ST",
    "dropdelcty": "FREDERICKTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 153332197,
    "dropphyadd": "531 FRONT ST",
    "dropphycty": "FREDERICKTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 153332197,
    "dropmaladd": "531 FRONT ST",
    "dropmalcty": "FREDERICKTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 153332197,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243263110,
    "dropsitcph": 7243263110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18506",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "161 2ND ST",
    "dropdelcty": "FREDONIA",
    "dropdelst": "PA",
    "dropdelzpp": 161249800,
    "dropphyadd": "161 2ND ST",
    "dropphycty": "FREDONIA",
    "dropphyst": "PA",
    "dropphyzpp": 161249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDONIA",
    "dropmalst": "PA",
    "dropmalzpp": 161249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244752161,
    "dropsitcph": 7244752161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18507",
    "droptype": "D",
    "dropname": "FREEBURG",
    "dropdeladd": "12 E MARKET ST",
    "dropdelcty": "FREEBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178279998,
    "dropphyadd": "12 E MARKET ST",
    "dropphycty": "FREEBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178279998,
    "dropmaladd": "12 E MARKET ST",
    "dropmalcty": "FREEBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178279998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703746394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18508",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "601 8TH ST",
    "dropdelcty": "FREEDOM",
    "dropdelst": "PA",
    "dropdelzpp": 150429998,
    "dropphyadd": "601 8TH ST",
    "dropphycty": "FREEDOM",
    "dropphyst": "PA",
    "dropphyzpp": 150429998,
    "dropmaladd": "601 8TH ST",
    "dropmalcty": "FREEDOM",
    "dropmalst": "PA",
    "dropmalzpp": 150429998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247750484,
    "dropsitcph": 7247750484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18509",
    "droptype": "D",
    "dropname": "FREELAND",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "FREELAND",
    "dropdelst": "PA",
    "dropdelzpp": 182249998,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "FREELAND",
    "dropphyst": "PA",
    "dropphyzpp": 182249998,
    "dropmaladd": "701 MAIN ST",
    "dropmalcty": "FREELAND",
    "dropmalst": "PA",
    "dropmalzpp": 182249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706363210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18511",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "415 HIGH ST",
    "dropdelcty": "FREEPORT",
    "dropdelst": "PA",
    "dropdelzpp": 162291100,
    "dropphyadd": "415 HIGH ST",
    "dropphycty": "FREEPORT",
    "dropphyst": "PA",
    "dropphyzpp": 162291100,
    "dropmaladd": "415 HIGH ST",
    "dropmalcty": "FREEPORT",
    "dropmalst": "PA",
    "dropmalzpp": 162291100,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242952211,
    "dropsitcph": 7242952211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18512",
    "droptype": "D",
    "dropname": "FRENCHVILLE",
    "dropdeladd": "28478 FRENCHVILLE KARTHAUS HWY",
    "dropdelcty": "FRENCHVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 168369998,
    "dropphyadd": "28478 FRENCHVILLE KARTHAUS HWY",
    "dropphycty": "FRENCHVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 168369998,
    "dropmaladd": "28478 FRENCHVILLE KARTHAUS HWY",
    "dropmalcty": "FRENCHVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 168369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142634031,
    "dropsitcph": 8142634031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18514",
    "droptype": "D",
    "dropname": "FRIEDENS",
    "dropdeladd": "2247 STOYSTOWN RD",
    "dropdelcty": "FRIEDENS",
    "dropdelst": "PA",
    "dropdelzpp": 155419998,
    "dropphyadd": "2247 STOYSTOWN RD",
    "dropphycty": "FRIEDENS",
    "dropphyst": "PA",
    "dropphyzpp": 155419998,
    "dropmaladd": "2247 STOYSTOWN RD",
    "dropmalcty": "FRIEDENS",
    "dropmalst": "PA",
    "dropmalzpp": 155419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144454403,
    "dropsitcph": 8144454403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18516",
    "droptype": "D",
    "dropname": "FRIEDENSBURG",
    "dropdeladd": "1305 LONG RUN RD",
    "dropdelcty": "FRIEDENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 179339998,
    "dropphyadd": "1305 LONG RUN RD",
    "dropphycty": "FRIEDENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 179339998,
    "dropmaladd": "1305 LONG RUN RD",
    "dropmalcty": "FRIEDENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 179339998,
    "dropsitphn": 7173932668,
    "dropsitlph": 5707392944,
    "dropsitcph": 5707392944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18517",
    "droptype": "D",
    "dropname": "FRIENDSVILLE",
    "dropdeladd": "61 CROSS ST",
    "dropdelcty": "FRIENDSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 188189998,
    "dropphyadd": "61 CROSS ST",
    "dropphycty": "FRIENDSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 188189998,
    "dropmaladd": "61 CROSS ST",
    "dropmalcty": "FRIENDSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 188189998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5705534287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18527",
    "droptype": "D",
    "dropname": "FRYBURG",
    "dropdeladd": "5383 OLD FRYBURG RD",
    "dropdelcty": "FRYBURG",
    "dropdelst": "PA",
    "dropdelzpp": 163269800,
    "dropphyadd": "5383 OLD FRYBURG RD",
    "dropphycty": "FRYBURG",
    "dropphyst": "PA",
    "dropphyzpp": 163269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRYBURG",
    "dropmalst": "PA",
    "dropmalzpp": 163269998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143542678,
    "dropsitcph": 8143542678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18537",
    "droptype": "D",
    "dropname": "FURLONG",
    "dropdeladd": "720 EDISON FURLONG RD",
    "dropdelcty": "FURLONG",
    "dropdelst": "PA",
    "dropdelzpp": 189259998,
    "dropphyadd": "720 EDISON FURLONG RD",
    "dropphycty": "FURLONG",
    "dropphyst": "PA",
    "dropphyzpp": 189259998,
    "dropmaladd": "720 EDISON FURLONG RD",
    "dropmalcty": "FURLONG",
    "dropmalst": "PA",
    "dropmalzpp": 189259998,
    "dropsitphn": 2157947356,
    "dropsitlph": 2157947356,
    "dropsitcph": 2157947356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18540",
    "droptype": "D",
    "dropname": "GAINES",
    "dropdeladd": "1977 ROUTE 6",
    "dropdelcty": "GAINES",
    "dropdelst": "PA",
    "dropdelzpp": 169219998,
    "dropphyadd": "1977 ROUTE 6",
    "dropphycty": "GAINES",
    "dropphyst": "PA",
    "dropphyzpp": 169219998,
    "dropmaladd": "1977 ROUTE 6",
    "dropmalcty": "GAINES",
    "dropmalst": "PA",
    "dropmalzpp": 169219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8144358846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18541",
    "droptype": "D",
    "dropname": "GALETON",
    "dropdeladd": "28 BRIDGE ST",
    "dropdelcty": "GALETON",
    "dropdelst": "PA",
    "dropdelzpp": 169229998,
    "dropphyadd": "28 BRIDGE ST",
    "dropphycty": "GALETON",
    "dropphyst": "PA",
    "dropphyzpp": 169229998,
    "dropmaladd": "28 BRIDGE ST",
    "dropmalcty": "GALETON",
    "dropmalst": "PA",
    "dropmalzpp": 169229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8144352502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18544",
    "droptype": "D",
    "dropname": "GALLITZIN",
    "dropdeladd": "312 CHURCH ST",
    "dropdelcty": "GALLITZIN",
    "dropdelst": "PA",
    "dropdelzpp": 166419998,
    "dropphyadd": "312 CHURCH ST",
    "dropphycty": "GALLITZIN",
    "dropphyst": "PA",
    "dropphyzpp": 166419998,
    "dropmaladd": "312 CHURCH ST",
    "dropmalcty": "GALLITZIN",
    "dropmalst": "PA",
    "dropmalzpp": 166419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148868231,
    "dropsitcph": 8148868231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18549",
    "droptype": "D",
    "dropname": "GAP",
    "dropdeladd": "937 ROUTE 41",
    "dropdelcty": "GAP",
    "dropdelst": "PA",
    "dropdelzpp": 175279998,
    "dropphyadd": "937 ROUTE 41",
    "dropphycty": "GAP",
    "dropphyst": "PA",
    "dropphyzpp": 175279998,
    "dropmaladd": "937 ROUTE 41",
    "dropmalcty": "GAP",
    "dropmalst": "PA",
    "dropmalzpp": 175279998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174424004,
    "dropsitcph": 7174424004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18550",
    "droptype": "D",
    "dropname": "GARARDS FORT",
    "dropdeladd": "288 GARARDS FORT RD",
    "dropdelcty": "GARARDS FORT",
    "dropdelst": "PA",
    "dropdelzpp": 153341017,
    "dropphyadd": "288 GARARDS FORT RD",
    "dropphycty": "GARARDS FORT",
    "dropphyst": "PA",
    "dropphyzpp": 153341017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARARDS FORT",
    "dropmalst": "PA",
    "dropmalzpp": 153349998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249665746,
    "dropsitcph": 7249665746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18553",
    "droptype": "D",
    "dropname": "GARDENVILLE",
    "dropdeladd": "8 ATKINSON DR",
    "dropdelcty": "DOYLESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189013430,
    "dropphyadd": "8 ATKINSON DR",
    "dropphycty": "DOYLESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189013430,
    "dropmaladd": "8 ATKINSON DR",
    "dropmalcty": "DOYLESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189013430,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153459088,
    "dropsitcph": 2153459088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18556",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "55 EXTENSION RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "PA",
    "dropdelzpp": 164169800,
    "dropphyadd": "55 EXTENSION RD",
    "dropphycty": "GARLAND",
    "dropphyst": "PA",
    "dropphyzpp": 164169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARLAND",
    "dropmalst": "PA",
    "dropmalzpp": 164169998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145634321,
    "dropsitcph": 8145634321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18557",
    "droptype": "D",
    "dropname": "GARRETT",
    "dropdeladd": "419 JACKSON ST",
    "dropdelcty": "GARRETT",
    "dropdelst": "PA",
    "dropdelzpp": 155429998,
    "dropphyadd": "419 JACKSON ST",
    "dropphycty": "GARRETT",
    "dropphyst": "PA",
    "dropphyzpp": 155429998,
    "dropmaladd": "419 JACKSON ST",
    "dropmalcty": "GARRETT",
    "dropmalst": "PA",
    "dropmalzpp": 155429998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146348713,
    "dropsitcph": 8146348713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18558",
    "droptype": "D",
    "dropname": "GASTONVILLE",
    "dropdeladd": "3708 FINLEYVILLE ELRAMA RD",
    "dropdelcty": "GASTONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153361001,
    "dropphyadd": "3708 FINLEYVILLE ELRAMA RD",
    "dropphycty": "GASTONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153361001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GASTONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243485708,
    "dropsitcph": 7243485708,
    "dropfax": 7243487104
  },
  {
    "dcode": "D",
    "dropkey": "PX18568",
    "droptype": "D",
    "dropname": "GEIGERTOWN",
    "dropdeladd": "3291 HAYCREEK RD",
    "dropdelcty": "GEIGERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195239998,
    "dropphyadd": "3291 HAYCREEK RD",
    "dropphycty": "GEIGERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195239998,
    "dropmaladd": "3291 HAYCREEK RD",
    "dropmalcty": "GEIGERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195239998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6102869142,
    "dropsitcph": 6102869142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18574",
    "droptype": "D",
    "dropname": "GENESEE",
    "dropdeladd": "276 MAIN ST",
    "dropdelcty": "GENESEE",
    "dropdelst": "PA",
    "dropdelzpp": 169239998,
    "dropphyadd": "276 MAIN ST",
    "dropphycty": "GENESEE",
    "dropphyst": "PA",
    "dropphyzpp": 169239998,
    "dropmaladd": "276 MAIN ST",
    "dropmalcty": "GENESEE",
    "dropmalst": "PA",
    "dropmalzpp": 169239998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8142283237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18577",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "110 MARKET ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "PA",
    "dropdelzpp": 150432000,
    "dropphyadd": "110 MARKET ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "PA",
    "dropphyzpp": 150432000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "PA",
    "dropmalzpp": 150439998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245739551,
    "dropsitcph": 7245739551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18580",
    "droptype": "D",
    "dropname": "GERMANSVILLE",
    "dropdeladd": "6066 MEMORIAL RD",
    "dropdelcty": "GERMANSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 180539998,
    "dropphyadd": "6066 MEMORIAL RD",
    "dropphycty": "GERMANSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 180539998,
    "dropmaladd": "6066 MEMORIAL RD",
    "dropmalcty": "GERMANSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 180539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107673367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18588",
    "droptype": "D",
    "dropname": "GETTYSBURG",
    "dropdeladd": "115 BUFORD AVE",
    "dropdelcty": "GETTYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 173259998,
    "dropphyadd": "115 BUFORD AVE",
    "dropphycty": "GETTYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 173259998,
    "dropmaladd": "115 BUFORD AVE",
    "dropmalcty": "GETTYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 173259998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173373325,
    "dropsitcph": 7173373325,
    "dropfax": 7173371226
  },
  {
    "dcode": "D",
    "dropkey": "PX18589",
    "droptype": "D",
    "dropname": "GIBBON GLADE",
    "dropdeladd": "872 GIBBON GLADE RD",
    "dropdelcty": "GIBBON GLADE",
    "dropdelst": "PA",
    "dropdelzpp": 154401001,
    "dropphyadd": "872 GIBBON GLADE RD",
    "dropphycty": "GIBBON GLADE",
    "dropphyst": "PA",
    "dropphyzpp": 154401001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIBBON GLADE",
    "dropmalst": "PA",
    "dropmalzpp": 154409998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243290699,
    "dropsitcph": 7243290699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18591",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "7337 STATE ROUTE 547",
    "dropdelcty": "GIBSON",
    "dropdelst": "PA",
    "dropdelzpp": 188209998,
    "dropphyadd": "7337 STATE ROUTE 547",
    "dropphycty": "GIBSON",
    "dropphyst": "PA",
    "dropphyzpp": 188209998,
    "dropmaladd": "7337 STATE ROUTE 547",
    "dropmalcty": "GIBSON",
    "dropmalst": "PA",
    "dropmalzpp": 188209998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707563712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18592",
    "droptype": "D",
    "dropname": "GIBSONIA",
    "dropdeladd": "4098 GIBSONIA RD",
    "dropdelcty": "GIBSONIA",
    "dropdelst": "PA",
    "dropdelzpp": 150449998,
    "dropphyadd": "4098 GIBSONIA RD",
    "dropphycty": "GIBSONIA",
    "dropphyst": "PA",
    "dropphyzpp": 150449998,
    "dropmaladd": "4098 GIBSONIA RD",
    "dropmalcty": "GIBSONIA",
    "dropmalst": "PA",
    "dropmalzpp": 150449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244433999,
    "dropsitcph": 7244433999,
    "dropfax": 7244438546
  },
  {
    "dcode": "D",
    "dropkey": "PX18593",
    "droptype": "D",
    "dropname": "GIFFORD",
    "dropdeladd": "3444 ROUTE 646",
    "dropdelcty": "GIFFORD",
    "dropdelst": "PA",
    "dropdelzpp": 167329800,
    "dropphyadd": "3444 ROUTE 646",
    "dropphycty": "GIFFORD",
    "dropphyst": "PA",
    "dropphyzpp": 167329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIFFORD",
    "dropmalst": "PA",
    "dropmalzpp": 167329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144653263,
    "dropsitcph": 8144653263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18594",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "622 GILBERT RD",
    "dropdelcty": "GILBERT",
    "dropdelst": "PA",
    "dropdelzpp": 183319998,
    "dropphyadd": "622 GILBERT RD",
    "dropphycty": "GILBERT",
    "dropphyst": "PA",
    "dropphyzpp": 183319998,
    "dropmaladd": "622 GILBERT RD",
    "dropmalcty": "GILBERT",
    "dropmalst": "PA",
    "dropmalzpp": 183319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6106817028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18596",
    "droptype": "D",
    "dropname": "GILBERTSVILLE",
    "dropdeladd": "1516 SWAMP PIKE",
    "dropdelcty": "GILBERTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195259998,
    "dropphyadd": "1516 SWAMP PIKE",
    "dropphycty": "GILBERTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195259998,
    "dropmaladd": "1516 SWAMP PIKE",
    "dropmalcty": "GILBERTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195259998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103691477,
    "dropsitcph": 6103691477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18599",
    "droptype": "D",
    "dropname": "GILLETT",
    "dropdeladd": "33165 ROUTE 14",
    "dropdelcty": "GILLETT",
    "dropdelst": "PA",
    "dropdelzpp": 169259998,
    "dropphyadd": "33165 ROUTE 14",
    "dropphycty": "GILLETT",
    "dropphyst": "PA",
    "dropphyzpp": 169259998,
    "dropmaladd": "33165 ROUTE 14",
    "dropmalcty": "GILLETT",
    "dropmalst": "PA",
    "dropmalzpp": 169259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705963550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18600",
    "droptype": "D",
    "dropname": "GIPSY",
    "dropdeladd": "3885 GIPSY RD",
    "dropdelcty": "GIPSY",
    "dropdelst": "PA",
    "dropdelzpp": 157419998,
    "dropphyadd": "3885 GIPSY RD",
    "dropphycty": "GIPSY",
    "dropphyst": "PA",
    "dropphyzpp": 157419998,
    "dropmaladd": "3885 GIPSY RD",
    "dropmalcty": "GIPSY",
    "dropmalst": "PA",
    "dropmalzpp": 157419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148459007,
    "dropsitcph": 8148459007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18601",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "113 MAIN ST E",
    "dropdelcty": "GIRARD",
    "dropdelst": "PA",
    "dropdelzpp": 164171700,
    "dropphyadd": "113 MAIN ST E",
    "dropphycty": "GIRARD",
    "dropphyst": "PA",
    "dropphyzpp": 164171700,
    "dropmaladd": "113 MAIN ST E",
    "dropmalcty": "GIRARD",
    "dropmalst": "PA",
    "dropmalzpp": 164171700,
    "dropsitphn": 8148987318,
    "dropsitlph": 8147743807,
    "dropsitcph": 8147743807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18603",
    "droptype": "D",
    "dropname": "GIRARDVILLE",
    "dropdeladd": "210 W MAIN ST",
    "dropdelcty": "GIRARDVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 179359998,
    "dropphyadd": "210 W MAIN ST",
    "dropphycty": "GIRARDVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 179359998,
    "dropmaladd": "210 W MAIN ST",
    "dropmalcty": "GIRARDVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 179359998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5702766643,
    "dropsitcph": 5702766643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18608",
    "droptype": "D",
    "dropname": "GLADWYNE",
    "dropdeladd": "326 CONSHOHOCKEN STATE RD",
    "dropdelcty": "GLADWYNE",
    "dropdelst": "PA",
    "dropdelzpp": 190359998,
    "dropphyadd": "326 CONSHOHOCKEN STATE RD",
    "dropphycty": "GLADWYNE",
    "dropphyst": "PA",
    "dropphyzpp": 190359998,
    "dropmaladd": "326 CONSHOHOCKEN STATE RD",
    "dropmalcty": "GLADWYNE",
    "dropmalst": "PA",
    "dropmalzpp": 190359998,
    "dropsitphn": 6106493518,
    "dropsitlph": 6106425238,
    "dropsitcph": 6106493518,
    "dropfax": 6106422431
  },
  {
    "dcode": "D",
    "dropkey": "PX18609",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "2361 SKYLINE DR",
    "dropdelcty": "GLASGOW",
    "dropdelst": "PA",
    "dropdelzpp": 166449998,
    "dropphyadd": "2361 SKYLINE DR",
    "dropphycty": "GLASGOW",
    "dropphyst": "PA",
    "dropphyzpp": 166449998,
    "dropmaladd": "2361 SKYLINE DR",
    "dropmalcty": "GLASGOW",
    "dropmalst": "PA",
    "dropmalzpp": 166449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146874511,
    "dropsitcph": 8146874511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18610",
    "droptype": "D",
    "dropname": "GLASSPORT",
    "dropdeladd": "730 MONONGAHELA AVE",
    "dropdelcty": "GLASSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 150459998,
    "dropphyadd": "730 MONONGAHELA AVE",
    "dropphycty": "GLASSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 150459998,
    "dropmaladd": "730 MONONGAHELA AVE",
    "dropmalcty": "GLASSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 150459998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126722547,
    "dropsitcph": 4126722547,
    "dropfax": 4126722547
  },
  {
    "dcode": "D",
    "dropkey": "PX18613",
    "droptype": "D",
    "dropname": "GLEN CAMPBELL",
    "dropdeladd": "455 GLENWOOD AVE",
    "dropdelcty": "GLEN CAMPBELL",
    "dropdelst": "PA",
    "dropdelzpp": 157429998,
    "dropphyadd": "455 GLENWOOD AVE",
    "dropphycty": "GLEN CAMPBELL",
    "dropphyst": "PA",
    "dropphyzpp": 157429998,
    "dropmaladd": "455 GLENWOOD AVE",
    "dropmalcty": "GLEN CAMPBELL",
    "dropmalst": "PA",
    "dropmalzpp": 157429998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148457300,
    "dropsitcph": 8148457300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18618",
    "droptype": "D",
    "dropname": "GLEN LYON",
    "dropdeladd": "45 N MARKET ST",
    "dropdelcty": "GLEN LYON",
    "dropdelst": "PA",
    "dropdelzpp": 186179998,
    "dropphyadd": "45 N MARKET ST",
    "dropphycty": "GLEN LYON",
    "dropphyst": "PA",
    "dropphyzpp": 186179998,
    "dropmaladd": "45 N MARKET ST",
    "dropmalcty": "GLEN LYON",
    "dropmalst": "PA",
    "dropmalzpp": 186179998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707366431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18620",
    "droptype": "D",
    "dropname": "GLEN MILLS",
    "dropdeladd": "142 GLEN MILLS RD",
    "dropdelcty": "GLEN MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 193429998,
    "dropphyadd": "142 GLEN MILLS RD",
    "dropphycty": "GLEN MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 193429998,
    "dropmaladd": "142 GLEN MILLS RD",
    "dropmalcty": "GLEN MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 193429998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103611312,
    "dropsitcph": 6103611312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18627",
    "droptype": "D",
    "dropname": "GLEN ROCK",
    "dropdeladd": "201 CHURCH ST",
    "dropdelcty": "GLEN ROCK",
    "dropdelst": "PA",
    "dropdelzpp": 173279998,
    "dropphyadd": "201 CHURCH ST",
    "dropphycty": "GLEN ROCK",
    "dropphyst": "PA",
    "dropphyzpp": 173279998,
    "dropmaladd": "201 CHURCH ST",
    "dropmalcty": "GLEN ROCK",
    "dropmalst": "PA",
    "dropmalzpp": 173279998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172351546,
    "dropsitcph": 7172351546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18633",
    "droptype": "D",
    "dropname": "GLENMOORE",
    "dropdeladd": "560 FAIRVIEW RD",
    "dropdelcty": "GLENMOORE",
    "dropdelst": "PA",
    "dropdelzpp": 193439998,
    "dropphyadd": "560 FAIRVIEW RD",
    "dropphycty": "GLENMOORE",
    "dropphyst": "PA",
    "dropphyzpp": 193439998,
    "dropmaladd": "560 FAIRVIEW RD",
    "dropmalcty": "GLENMOORE",
    "dropmalst": "PA",
    "dropmalzpp": 193439998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109420313,
    "dropsitcph": 6109420313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18634",
    "droptype": "D",
    "dropname": "GLENOLDEN",
    "dropdeladd": "109 S MACDADE BLVD",
    "dropdelcty": "GLENOLDEN",
    "dropdelst": "PA",
    "dropdelzpp": 190369998,
    "dropphyadd": "109 S MACDADE BLVD",
    "dropphycty": "GLENOLDEN",
    "dropphyst": "PA",
    "dropphyzpp": 190369998,
    "dropmaladd": "109 S MACDADE BLVD",
    "dropmalcty": "GLENOLDEN",
    "dropmalst": "PA",
    "dropmalzpp": 190369998,
    "dropsitphn": 2155838292,
    "dropsitlph": 6105838292,
    "dropsitcph": 6105838292,
    "dropfax": 6105864546
  },
  {
    "dcode": "D",
    "dropkey": "PX18635",
    "droptype": "D",
    "dropname": "GLENSHAW",
    "dropdeladd": "1541 BUTLER PLANK RD",
    "dropdelcty": "GLENSHAW",
    "dropdelst": "PA",
    "dropdelzpp": 151169998,
    "dropphyadd": "1541 BUTLER PLANK RD",
    "dropphycty": "GLENSHAW",
    "dropphyst": "PA",
    "dropphyzpp": 151169998,
    "dropmaladd": "1541 BUTLER PLANK RD",
    "dropmalcty": "GLENSHAW",
    "dropmalst": "PA",
    "dropmalzpp": 151169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124863128,
    "dropsitcph": 4124863128,
    "dropfax": 4124866122
  },
  {
    "dcode": "D",
    "dropkey": "PX18636",
    "droptype": "D",
    "dropname": "GLENSIDE",
    "dropdeladd": "262 S EASTON RD",
    "dropdelcty": "GLENSIDE",
    "dropdelst": "PA",
    "dropdelzpp": 190389998,
    "dropphyadd": "262 S EASTON RD",
    "dropphycty": "GLENSIDE",
    "dropphyst": "PA",
    "dropphyzpp": 190389998,
    "dropmaladd": "262 S EASTON RD",
    "dropmalcty": "GLENSIDE",
    "dropmalst": "PA",
    "dropmalzpp": 190389998,
    "dropsitphn": 2158843059,
    "dropsitlph": 2158843059,
    "dropsitcph": 2158843059,
    "dropfax": 2158848408
  },
  {
    "dcode": "D",
    "dropkey": "PX18637",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "8142 BLOOMING GROVE RD",
    "dropdelcty": "GLENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173299998,
    "dropphyadd": "8142 BLOOMING GROVE RD",
    "dropphycty": "GLENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173299998,
    "dropmaladd": "8142 BLOOMING GROVE RD",
    "dropmalcty": "GLENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173299998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172354449,
    "dropsitcph": 7172354449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18640",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "105 MCGOVERN BLVD",
    "dropdelcty": "CRESCENT",
    "dropdelst": "PA",
    "dropdelzpp": 150461001,
    "dropphyadd": "105 MCGOVERN BLVD",
    "dropphycty": "CRESCENT",
    "dropphyst": "PA",
    "dropphyzpp": 150461001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESCENT",
    "dropmalst": "PA",
    "dropmalzpp": 150469998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244576170,
    "dropsitcph": 7244576170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18651",
    "droptype": "D",
    "dropname": "GOODVILLE",
    "dropdeladd": "1599 MAIN ST",
    "dropdelcty": "GOODVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175289998,
    "dropphyadd": "1599 MAIN ST",
    "dropphycty": "GOODVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175289998,
    "dropmaladd": "1599 MAIN ST",
    "dropmalcty": "GOODVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175289998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173404200,
    "dropsitcph": 7173404200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18657",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "130 E BIDDLE ST",
    "dropdelcty": "GORDON",
    "dropdelst": "PA",
    "dropdelzpp": 179369998,
    "dropphyadd": "130 E BIDDLE ST",
    "dropphycty": "GORDON",
    "dropphyst": "PA",
    "dropphyzpp": 179369998,
    "dropmaladd": "130 E BIDDLE ST",
    "dropmalcty": "GORDON",
    "dropmalst": "PA",
    "dropmalzpp": 179369998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708751764,
    "dropsitcph": 5708751764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18658",
    "droptype": "D",
    "dropname": "GORDONVILLE",
    "dropdeladd": "3197 IRISHTOWN RD",
    "dropdelcty": "GORDONVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175299998,
    "dropphyadd": "3197 IRISHTOWN RD",
    "dropphycty": "GORDONVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175299998,
    "dropmaladd": "3197 IRISHTOWN RD",
    "dropmalcty": "GORDONVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175299998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177683584,
    "dropsitcph": 7177683584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18662",
    "droptype": "D",
    "dropname": "GOULDSBORO",
    "dropdeladd": "546 MAIN ST",
    "dropdelcty": "GOULDSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 184249998,
    "dropphyadd": "546 MAIN ST",
    "dropphycty": "GOULDSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 184249998,
    "dropmaladd": "546 MAIN ST",
    "dropmalcty": "GOULDSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 184249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708427191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18667",
    "droptype": "D",
    "dropname": "GRADYVILLE",
    "dropdeladd": "1347 MIDDLETOWN RD",
    "dropdelcty": "GRADYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 190399900,
    "dropphyadd": "1347 MIDDLETOWN RD",
    "dropphycty": "GRADYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 190399900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRADYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 190399998,
    "dropsitphn": 2154595626,
    "dropsitlph": 6104595626,
    "dropsitcph": 6104595626,
    "dropfax": 6104593338
  },
  {
    "dcode": "D",
    "dropkey": "PX18668",
    "droptype": "D",
    "dropname": "GRAMPIAN",
    "dropdeladd": "273 MAIN ST",
    "dropdelcty": "GRAMPIAN",
    "dropdelst": "PA",
    "dropdelzpp": 168389998,
    "dropphyadd": "273 MAIN ST",
    "dropphycty": "GRAMPIAN",
    "dropphyst": "PA",
    "dropphyzpp": 168389998,
    "dropmaladd": "273 MAIN ST",
    "dropmalcty": "GRAMPIAN",
    "dropmalst": "PA",
    "dropmalzpp": 168389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142362374,
    "dropsitcph": 8142362374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18670",
    "droptype": "D",
    "dropname": "GRAND VALLEY",
    "dropdeladd": "76 ELDRED CENTER RD",
    "dropdelcty": "GRAND VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 164209800,
    "dropphyadd": "76 ELDRED CENTER RD",
    "dropphycty": "GRAND VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 164209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 164209998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144367421,
    "dropsitcph": 8144367421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18673",
    "droptype": "D",
    "dropname": "GRANTHAM",
    "dropdeladd": "1 S COLLEGE AVE",
    "dropdelcty": "GRANTHAM",
    "dropdelst": "PA",
    "dropdelzpp": 170279800,
    "dropphyadd": "1 S COLLEGE AVE",
    "dropphycty": "GRANTHAM",
    "dropphyst": "PA",
    "dropphyzpp": 170279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANTHAM",
    "dropmalst": "PA",
    "dropmalzpp": 170279998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177660953,
    "dropfax": 7176918464
  },
  {
    "dcode": "D",
    "dropkey": "PX18674",
    "droptype": "D",
    "dropname": "GRANTVILLE",
    "dropdeladd": "251 FIREHOUSE RD",
    "dropdelcty": "GRANTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170289998,
    "dropphyadd": "251 FIREHOUSE RD",
    "dropphycty": "GRANTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170289998,
    "dropmaladd": "251 FIREHOUSE RD",
    "dropmalcty": "GRANTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174690312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18675",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "324 GRANVILLE RD",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170299998,
    "dropphyadd": "324 GRANVILLE RD",
    "dropphycty": "GRANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170299998,
    "dropmaladd": "324 GRANVILLE RD",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172482126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18678",
    "droptype": "D",
    "dropname": "GRANVILLE SUMMIT",
    "dropdeladd": "543 HIGH BRIDGE RD",
    "dropdelcty": "GRANVILLE SUMMIT",
    "dropdelst": "PA",
    "dropdelzpp": 169269998,
    "dropphyadd": "543 HIGH BRIDGE RD",
    "dropphycty": "GRANVILLE SUMMIT",
    "dropphyst": "PA",
    "dropphyzpp": 169269998,
    "dropmaladd": "543 HIGH BRIDGE RD",
    "dropmalcty": "GRANVILLE SUMMIT",
    "dropmalst": "PA",
    "dropmalzpp": 169269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706738660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18679",
    "droptype": "D",
    "dropname": "GRAPEVILLE",
    "dropdeladd": "2526 NEWARK ST",
    "dropdelcty": "GRAPEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 156341100,
    "dropphyadd": "2526 NEWARK ST",
    "dropphycty": "GRAPEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 156341100,
    "dropmaladd": "2526 NEWARK ST",
    "dropmalcty": "GRAPEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 156341100,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245234600,
    "dropsitcph": 7245234600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18684",
    "droptype": "D",
    "dropname": "GRATZ",
    "dropdeladd": "102 S CENTER ST",
    "dropdelcty": "GRATZ",
    "dropdelst": "PA",
    "dropdelzpp": 170309998,
    "dropphyadd": "102 S CENTER ST",
    "dropphycty": "GRATZ",
    "dropphyst": "PA",
    "dropphyzpp": 170309998,
    "dropmaladd": "102 S CENTER ST",
    "dropmalcty": "GRATZ",
    "dropmalst": "PA",
    "dropmalzpp": 170309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173653126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18685",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "129 E 1ST ST",
    "dropdelcty": "GRAY",
    "dropdelst": "PA",
    "dropdelzpp": 155449900,
    "dropphyadd": "129 E 1ST ST",
    "dropphycty": "GRAY",
    "dropphyst": "PA",
    "dropphyzpp": 155449900,
    "dropmaladd": "129 E 1ST ST",
    "dropmalcty": "GRAY",
    "dropmalst": "PA",
    "dropmalzpp": 155449900,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146295588,
    "dropsitcph": 8146295588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18687",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "1167 W ROY FURMAN HWY",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 153371001,
    "dropphyadd": "1167 W ROY FURMAN HWY",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 153371001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 153379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244283842,
    "dropsitcph": 7244283842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18691",
    "droptype": "D",
    "dropname": "GREAT BEND",
    "dropdeladd": "260 MAIN ST",
    "dropdelcty": "GREAT BEND",
    "dropdelst": "PA",
    "dropdelzpp": 188219998,
    "dropphyadd": "260 MAIN ST",
    "dropphycty": "GREAT BEND",
    "dropphyst": "PA",
    "dropphyzpp": 188219998,
    "dropmaladd": "260 MAIN ST",
    "dropmalcty": "GREAT BEND",
    "dropmalst": "PA",
    "dropmalzpp": 188219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708794631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18695",
    "droptype": "D",
    "dropname": "GREELEY",
    "dropdeladd": "130 ROUTE 590",
    "dropdelcty": "GREELEY",
    "dropdelst": "PA",
    "dropdelzpp": 184259998,
    "dropphyadd": "130 ROUTE 590",
    "dropphycty": "GREELEY",
    "dropphyst": "PA",
    "dropphyzpp": 184259998,
    "dropmaladd": "130 ROUTE 590",
    "dropmalcty": "GREELEY",
    "dropmalst": "PA",
    "dropmalzpp": 184259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706854642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18698",
    "droptype": "D",
    "dropname": "GREEN LANE",
    "dropdeladd": "125 GRAVEL PIKE",
    "dropdelcty": "GREEN LANE",
    "dropdelst": "PA",
    "dropdelzpp": 180549998,
    "dropphyadd": "125 GRAVEL PIKE",
    "dropphycty": "GREEN LANE",
    "dropphyst": "PA",
    "dropphyzpp": 180549998,
    "dropmaladd": "125 GRAVEL PIKE",
    "dropmalcty": "GREEN LANE",
    "dropmalst": "PA",
    "dropmalzpp": 180549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2152344958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18710",
    "droptype": "D",
    "dropname": "GREENCASTLE",
    "dropdeladd": "2 N WASHINGTON ST",
    "dropdelcty": "GREENCASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 172259998,
    "dropphyadd": "2 N WASHINGTON ST",
    "dropphycty": "GREENCASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 172259998,
    "dropmaladd": "2 N WASHINGTON ST",
    "dropmalcty": "GREENCASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 172259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175973164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18715",
    "droptype": "D",
    "dropname": "GREENOCK",
    "dropdeladd": "710 ZIMMER LN",
    "dropdelcty": "GREENOCK",
    "dropdelst": "PA",
    "dropdelzpp": 150471001,
    "dropphyadd": "710 ZIMMER LN",
    "dropphycty": "GREENOCK",
    "dropphyst": "PA",
    "dropphyzpp": 150471001,
    "dropmaladd": "710 ZIMMER LN",
    "dropmalcty": "GREENOCK",
    "dropmalst": "PA",
    "dropmalzpp": 150471001,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127513375,
    "dropsitcph": 4127513375,
    "dropfax": 4127513375
  },
  {
    "dcode": "D",
    "dropkey": "PX18716",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "304 FRONT ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 153382001,
    "dropphyadd": "304 FRONT ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 153382001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 153389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249433319,
    "dropsitcph": 7249433319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18719",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "238 S PENNSYLVANIA AVE",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156019998,
    "dropphyadd": "238 S PENNSYLVANIA AVE",
    "dropphycty": "GREENSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156019998,
    "dropmaladd": "238 S PENNSYLVANIA AVE",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156019998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248374187,
    "dropsitcph": 7248374187,
    "dropfax": 7248376139
  },
  {
    "dcode": "D",
    "dropkey": "PX18722",
    "droptype": "D",
    "dropname": "GREENTOWN",
    "dropdeladd": "1340 ROUTE 507",
    "dropdelcty": "GREENTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 184269998,
    "dropphyadd": "1340 ROUTE 507",
    "dropphycty": "GREENTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 184269998,
    "dropmaladd": "1340 ROUTE 507",
    "dropmalcty": "GREENTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 184269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706763790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18726",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "55 CLINTON ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 161252230,
    "dropphyadd": "55 CLINTON ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 161252230,
    "dropmaladd": "55 CLINTON ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 161252230,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245885310,
    "dropsitcph": 7245885310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18737",
    "droptype": "D",
    "dropname": "GRINDSTONE",
    "dropdeladd": "565 GRINDSTONE RD",
    "dropdelcty": "GRINDSTONE",
    "dropdelst": "PA",
    "dropdelzpp": 154422007,
    "dropphyadd": "565 GRINDSTONE RD",
    "dropphycty": "GRINDSTONE",
    "dropphyst": "PA",
    "dropphyzpp": 154422007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRINDSTONE",
    "dropmalst": "PA",
    "dropmalzpp": 154429998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247856300,
    "dropsitcph": 7247856300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18742",
    "droptype": "D",
    "dropname": "GROVE CITY",
    "dropdeladd": "117 E PINE ST",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "PA",
    "dropdelzpp": 161272000,
    "dropphyadd": "117 E PINE ST",
    "dropphycty": "GROVE CITY",
    "dropphyst": "PA",
    "dropphyzpp": 161272000,
    "dropmaladd": "117 E PINE ST",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "PA",
    "dropmalzpp": 161272000,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244586140,
    "dropsitcph": 7244586140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18743",
    "droptype": "D",
    "dropname": "GROVER",
    "dropdeladd": "44 N WATER ST",
    "dropdelcty": "GROVER",
    "dropdelst": "PA",
    "dropdelzpp": 177359998,
    "dropphyadd": "44 N WATER ST",
    "dropphycty": "GROVER",
    "dropphyst": "PA",
    "dropphyzpp": 177359998,
    "dropmaladd": "44 N WATER ST",
    "dropmalcty": "GROVER",
    "dropmalst": "PA",
    "dropmalzpp": 177359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706734072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18750",
    "droptype": "D",
    "dropname": "GUYS MILLS",
    "dropdeladd": "11522 STATE HIGHWAY 198",
    "dropdelcty": "GUYS MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 163279800,
    "dropphyadd": "11522 STATE HIGHWAY 198",
    "dropphycty": "GUYS MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 163279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUYS MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 163279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147894261,
    "dropsitcph": 8147894261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18754",
    "droptype": "D",
    "dropname": "GWYNEDD VALLEY",
    "dropdeladd": "527 PLYMOUTH RD",
    "dropdelcty": "GWYNEDD VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 194379900,
    "dropphyadd": "527 PLYMOUTH RD",
    "dropphycty": "GWYNEDD VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 194379900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GWYNEDD VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 194379998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2156461209,
    "dropsitcph": 2156461209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18758",
    "droptype": "D",
    "dropname": "HADLEY",
    "dropdeladd": "1133 FREDONIA RD",
    "dropdelcty": "HADLEY",
    "dropdelst": "PA",
    "dropdelzpp": 161309800,
    "dropphyadd": "1133 FREDONIA RD",
    "dropphycty": "HADLEY",
    "dropphyst": "PA",
    "dropphyzpp": 161309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HADLEY",
    "dropmalst": "PA",
    "dropmalzpp": 161309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242532888,
    "dropsitcph": 7242532888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18762",
    "droptype": "D",
    "dropname": "HALIFAX",
    "dropdeladd": "201 ARMSTRONG ST",
    "dropdelcty": "HALIFAX",
    "dropdelst": "PA",
    "dropdelzpp": 170329998,
    "dropphyadd": "201 ARMSTRONG ST",
    "dropphycty": "HALIFAX",
    "dropphyst": "PA",
    "dropphyzpp": 170329998,
    "dropmaladd": "201 ARMSTRONG ST",
    "dropmalcty": "HALIFAX",
    "dropmalst": "PA",
    "dropmalzpp": 170329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178968432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18764",
    "droptype": "D",
    "dropname": "HALLSTEAD",
    "dropdeladd": "587 MAIN ST",
    "dropdelcty": "HALLSTEAD",
    "dropdelst": "PA",
    "dropdelzpp": 188229998,
    "dropphyadd": "587 MAIN ST",
    "dropphycty": "HALLSTEAD",
    "dropphyst": "PA",
    "dropphyzpp": 188229998,
    "dropmaladd": "587 MAIN ST",
    "dropmalcty": "HALLSTEAD",
    "dropmalst": "PA",
    "dropmalzpp": 188229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708792168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18765",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "50 N 3RD ST",
    "dropdelcty": "HAMBURG",
    "dropdelst": "PA",
    "dropdelzpp": 195269998,
    "dropphyadd": "50 N 3RD ST",
    "dropphycty": "HAMBURG",
    "dropphyst": "PA",
    "dropphyzpp": 195269998,
    "dropmaladd": "50 N 3RD ST",
    "dropmalcty": "HAMBURG",
    "dropmalst": "PA",
    "dropmalzpp": 195269998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105627812,
    "dropsitcph": 6105627812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18768",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "23 HAMILTON MARKTON RD",
    "dropdelcty": "HAMILTON",
    "dropdelst": "PA",
    "dropdelzpp": 157449998,
    "dropphyadd": "23 HAMILTON MARKTON RD",
    "dropphycty": "HAMILTON",
    "dropphyst": "PA",
    "dropphyzpp": 157449998,
    "dropmaladd": "23 HAMILTON MARKTON RD",
    "dropmalcty": "HAMILTON",
    "dropmalst": "PA",
    "dropmalzpp": 157449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149389730,
    "dropsitcph": 8149389730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18771",
    "droptype": "D",
    "dropname": "HAMLIN",
    "dropdeladd": "501 HAMLIN HWY STE A",
    "dropdelcty": "HAMLIN",
    "dropdelst": "PA",
    "dropdelzpp": 184279998,
    "dropphyadd": "501 HAMLIN HWY STE A",
    "dropphycty": "HAMLIN",
    "dropphyst": "PA",
    "dropphyzpp": 184279998,
    "dropmaladd": "501 HAMLIN HWY STE A",
    "dropmalcty": "HAMLIN",
    "dropmalst": "PA",
    "dropmalzpp": 184279998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706892503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18779",
    "droptype": "D",
    "dropname": "HANNASTOWN",
    "dropdeladd": "189 FRONT ST",
    "dropdelcty": "HANNASTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 156351001,
    "dropphyadd": "189 FRONT ST",
    "dropphycty": "HANNASTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 156351001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANNASTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 156359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248360525,
    "dropsitcph": 7248360525,
    "dropfax": 7248365590
  },
  {
    "dcode": "D",
    "dropkey": "PX18780",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "18 HIGH ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "PA",
    "dropdelzpp": 173319998,
    "dropphyadd": "18 HIGH ST",
    "dropphycty": "HANOVER",
    "dropphyst": "PA",
    "dropphyzpp": 173319998,
    "dropmaladd": "18 HIGH ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "PA",
    "dropmalzpp": 173319998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176375496,
    "dropsitcph": 7176375496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18787",
    "droptype": "D",
    "dropname": "HARBORCREEK",
    "dropdeladd": "7175 BUFFALO RD",
    "dropdelcty": "HARBORCREEK",
    "dropdelst": "PA",
    "dropdelzpp": 164219800,
    "dropphyadd": "7175 BUFFALO RD",
    "dropphycty": "HARBORCREEK",
    "dropphyst": "PA",
    "dropphyzpp": 164219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARBORCREEK",
    "dropmalst": "PA",
    "dropmalzpp": 164219998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148998636,
    "dropsitcph": 8148998636,
    "dropfax": 8148998636
  },
  {
    "dcode": "D",
    "dropkey": "PX18790",
    "droptype": "D",
    "dropname": "HARLEIGH",
    "dropdeladd": "1129 STATE ROUTE 940 STE 1",
    "dropdelcty": "HARLEIGH",
    "dropdelst": "PA",
    "dropdelzpp": 182259998,
    "dropphyadd": "1129 STATE ROUTE 940 STE 1",
    "dropphycty": "HARLEIGH",
    "dropphyst": "PA",
    "dropphyzpp": 182259998,
    "dropmaladd": "1129 STATE ROUTE 940 STE 1",
    "dropmalcty": "HARLEIGH",
    "dropmalst": "PA",
    "dropmalzpp": 182259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704546736,
    "dropfax": 5704542793
  },
  {
    "dcode": "D",
    "dropkey": "PX18792",
    "droptype": "D",
    "dropname": "HARLEYSVILLE",
    "dropdeladd": "600 OAK DR",
    "dropdelcty": "HARLEYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194389998,
    "dropphyadd": "600 OAK DR",
    "dropphycty": "HARLEYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194389998,
    "dropmaladd": "600 OAK DR",
    "dropmalcty": "HARLEYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194389998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155132957,
    "dropsitcph": 2155132957,
    "dropfax": 2155135198
  },
  {
    "dcode": "D",
    "dropkey": "PX18794",
    "droptype": "D",
    "dropname": "HARMONSBURG",
    "dropdeladd": "14238 LEXINGTON ST",
    "dropdelcty": "HARMONSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 164229800,
    "dropphyadd": "14238 LEXINGTON ST",
    "dropphycty": "HARMONSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 164229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARMONSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 164229998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143828518,
    "dropsitcph": 8143828518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18802",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "1425 CROOKED HILL RD",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171069998,
    "dropphyadd": "1425 CROOKED HILL RD",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171069998,
    "dropmaladd": "1425 CROOKED HILL RD",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171069998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172572301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18804",
    "droptype": "D",
    "dropname": "HARRISON CITY",
    "dropdeladd": "567 MANOR HARRISON CITY RD",
    "dropdelcty": "HARRISON CITY",
    "dropdelst": "PA",
    "dropdelzpp": 156361113,
    "dropphyadd": "567 MANOR HARRISON CITY RD",
    "dropphycty": "HARRISON CITY",
    "dropphyst": "PA",
    "dropphyzpp": 156361113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISON CITY",
    "dropmalst": "PA",
    "dropmalzpp": 156369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247442630,
    "dropsitcph": 7247442630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18810",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 160389800,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 160389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 160389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247352505,
    "dropsitcph": 7247352505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18811",
    "droptype": "D",
    "dropname": "HARTLETON",
    "dropdeladd": "109 COLD RUN RD",
    "dropdelcty": "HARTLETON",
    "dropdelst": "PA",
    "dropdelzpp": 178299998,
    "dropphyadd": "109 COLD RUN RD",
    "dropphycty": "HARTLETON",
    "dropphyst": "PA",
    "dropphyzpp": 178299998,
    "dropmaladd": "109 COLD RUN RD",
    "dropmalcty": "HARTLETON",
    "dropmalst": "PA",
    "dropmalzpp": 178299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709221363,
    "dropfax": 5709221363
  },
  {
    "dcode": "D",
    "dropkey": "PX18813",
    "droptype": "D",
    "dropname": "HARTSTOWN",
    "dropdeladd": "6768 CENTER ST",
    "dropdelcty": "HARTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 161319800,
    "dropphyadd": "6768 CENTER ST",
    "dropphycty": "HARTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 161319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 161319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143828254,
    "dropsitcph": 8143828254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18815",
    "droptype": "D",
    "dropname": "HARVEYS LAKE",
    "dropdeladd": "2115 LAKESIDE DR",
    "dropdelcty": "HARVEYS LAKE",
    "dropdelst": "PA",
    "dropdelzpp": 186189998,
    "dropphyadd": "2115 LAKESIDE DR",
    "dropphycty": "HARVEYS LAKE",
    "dropphyst": "PA",
    "dropphyzpp": 186189998,
    "dropmaladd": "2115 LAKESIDE DR",
    "dropmalcty": "HARVEYS LAKE",
    "dropmalst": "PA",
    "dropmalzpp": 186189998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706395704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18817",
    "droptype": "D",
    "dropname": "HARWICK",
    "dropdeladd": "1400 PILLOW AVE",
    "dropdelcty": "HARWICK",
    "dropdelst": "PA",
    "dropdelzpp": 150491001,
    "dropphyadd": "1400 PILLOW AVE",
    "dropphycty": "HARWICK",
    "dropphyst": "PA",
    "dropphyzpp": 150491001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARWICK",
    "dropmalst": "PA",
    "dropmalzpp": 150499998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242747171,
    "dropsitcph": 7242747171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18820",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "311 BEAVER ST",
    "dropdelcty": "HASTINGS",
    "dropdelst": "PA",
    "dropdelzpp": 166469998,
    "dropphyadd": "311 BEAVER ST",
    "dropphycty": "HASTINGS",
    "dropphyst": "PA",
    "dropphyzpp": 166469998,
    "dropmaladd": "311 BEAVER ST",
    "dropmalcty": "HASTINGS",
    "dropmalst": "PA",
    "dropmalzpp": 166469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142477233,
    "dropsitcph": 8142477233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18821",
    "droptype": "D",
    "dropname": "HATBORO",
    "dropdeladd": "12 N YORK RD",
    "dropdelcty": "HATBORO",
    "dropdelst": "PA",
    "dropdelzpp": 190409998,
    "dropphyadd": "12 N YORK RD",
    "dropphycty": "HATBORO",
    "dropphyst": "PA",
    "dropphyzpp": 190409998,
    "dropmaladd": "12 N YORK RD",
    "dropmalcty": "HATBORO",
    "dropmalst": "PA",
    "dropmalzpp": 190409998,
    "dropsitphn": 2156752963,
    "dropsitlph": 2156752963,
    "dropsitcph": 2156752963,
    "dropfax": 2156751413
  },
  {
    "dcode": "D",
    "dropkey": "PX18822",
    "droptype": "D",
    "dropname": "HATFIELD",
    "dropdeladd": "45 N MAIN ST",
    "dropdelcty": "HATFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 194409998,
    "dropphyadd": "45 N MAIN ST",
    "dropphycty": "HATFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 194409998,
    "dropmaladd": "45 N MAIN ST",
    "dropmalcty": "HATFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 194409998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153939272,
    "dropsitcph": 2153939272,
    "dropfax": 2153624538
  },
  {
    "dcode": "D",
    "dropkey": "PX18823",
    "droptype": "D",
    "dropname": "HAVERFORD",
    "dropdeladd": "387 W LANCASTER AVE",
    "dropdelcty": "HAVERFORD",
    "dropdelst": "PA",
    "dropdelzpp": 190419998,
    "dropphyadd": "387 W LANCASTER AVE",
    "dropphycty": "HAVERFORD",
    "dropphyst": "PA",
    "dropphyzpp": 190419998,
    "dropmaladd": "387 W LANCASTER AVE",
    "dropmalcty": "HAVERFORD",
    "dropmalst": "PA",
    "dropmalzpp": 190419998,
    "dropsitphn": 6106496065,
    "dropsitlph": 6106496065,
    "dropsitcph": 6106496065,
    "dropfax": 6108962194
  },
  {
    "dcode": "D",
    "dropkey": "PX18825",
    "droptype": "D",
    "dropname": "HAWK RUN",
    "dropdeladd": "398 POWELL ST",
    "dropdelcty": "HAWK RUN",
    "dropdelst": "PA",
    "dropdelzpp": 168409998,
    "dropphyadd": "398 POWELL ST",
    "dropphycty": "HAWK RUN",
    "dropphyst": "PA",
    "dropphyzpp": 168409998,
    "dropmaladd": "398 POWELL ST",
    "dropmalcty": "HAWK RUN",
    "dropmalst": "PA",
    "dropmalzpp": 168409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143425561,
    "dropsitcph": 8143425561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18827",
    "droptype": "D",
    "dropname": "HAWLEY",
    "dropdeladd": "100 MAIN AVE",
    "dropdelcty": "HAWLEY",
    "dropdelst": "PA",
    "dropdelzpp": 184289998,
    "dropphyadd": "100 MAIN AVE",
    "dropphycty": "HAWLEY",
    "dropphyst": "PA",
    "dropphyzpp": 184289998,
    "dropmaladd": "100 MAIN AVE",
    "dropmalcty": "HAWLEY",
    "dropmalst": "PA",
    "dropmalzpp": 184289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702264847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18829",
    "droptype": "D",
    "dropname": "HAWTHORN",
    "dropdeladd": "3977 BROOKVILLE ST",
    "dropdelcty": "HAWTHORN",
    "dropdelst": "PA",
    "dropdelzpp": 162309800,
    "dropphyadd": "3977 BROOKVILLE ST",
    "dropphycty": "HAWTHORN",
    "dropphyst": "PA",
    "dropphyzpp": 162309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWTHORN",
    "dropmalst": "PA",
    "dropmalzpp": 162309998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143655277,
    "dropsitcph": 8143655277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18832",
    "droptype": "D",
    "dropname": "HAZEL HURST",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "HAZEL HURST",
    "dropdelst": "PA",
    "dropdelzpp": 167339800,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "HAZEL HURST",
    "dropphyst": "PA",
    "dropphyzpp": 167339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAZEL HURST",
    "dropmalst": "PA",
    "dropmalzpp": 167339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147785026,
    "dropsitcph": 8147785026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18837",
    "droptype": "D",
    "dropname": "HAZLETON",
    "dropdeladd": "231 N WYOMING ST",
    "dropdelcty": "HAZLETON",
    "dropdelst": "PA",
    "dropdelzpp": 182019996,
    "dropphyadd": "231 N WYOMING ST",
    "dropphycty": "HAZLETON",
    "dropphyst": "PA",
    "dropphyzpp": 182019996,
    "dropmaladd": "231 N WYOMING ST",
    "dropmalcty": "HAZLETON",
    "dropmalst": "PA",
    "dropmalzpp": 182019996,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704555851,
    "dropfax": 5704555236
  },
  {
    "dcode": "D",
    "dropkey": "PX18851",
    "droptype": "D",
    "dropname": "HEGINS",
    "dropdeladd": "15 POST OFFICE RD",
    "dropdelcty": "HEGINS",
    "dropdelst": "PA",
    "dropdelzpp": 179389998,
    "dropphyadd": "15 POST OFFICE RD",
    "dropphycty": "HEGINS",
    "dropphyst": "PA",
    "dropphyzpp": 179389998,
    "dropmaladd": "15 POST OFFICE RD",
    "dropmalcty": "HEGINS",
    "dropmalst": "PA",
    "dropmalzpp": 179389998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706829605,
    "dropsitcph": 5706829605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18855",
    "droptype": "D",
    "dropname": "HEILWOOD",
    "dropdeladd": "6521 ROUTE 403 HWY N",
    "dropdelcty": "HEILWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 157459998,
    "dropphyadd": "6521 ROUTE 403 HWY N",
    "dropphycty": "HEILWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 157459998,
    "dropmaladd": "6521 ROUTE 403 HWY N",
    "dropmalcty": "HEILWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 157459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149484555,
    "dropsitcph": 8149484555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18859",
    "droptype": "D",
    "dropname": "HELLERTOWN",
    "dropdeladd": "660 DELAWARE AVE",
    "dropdelcty": "HELLERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180559998,
    "dropphyadd": "660 DELAWARE AVE",
    "dropphycty": "HELLERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180559998,
    "dropmaladd": "660 DELAWARE AVE",
    "dropmalcty": "HELLERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108389351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18866",
    "droptype": "D",
    "dropname": "HENRYVILLE",
    "dropdeladd": "5285 PARADISE VALLEY RD",
    "dropdelcty": "HENRYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 183329998,
    "dropphyadd": "5285 PARADISE VALLEY RD",
    "dropphycty": "HENRYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 183329998,
    "dropmaladd": "5285 PARADISE VALLEY RD",
    "dropmalcty": "HENRYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 183329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706291690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18874",
    "droptype": "D",
    "dropname": "HEREFORD",
    "dropdeladd": "1153 GRAVEL PIKE STE 1",
    "dropdelcty": "HEREFORD",
    "dropdelst": "PA",
    "dropdelzpp": 180561503,
    "dropphyadd": "1153 GRAVEL PIKE STE 1",
    "dropphycty": "HEREFORD",
    "dropphyst": "PA",
    "dropphyzpp": 180561503,
    "dropmaladd": "1153 GRAVEL PIKE STE 1",
    "dropmalcty": "HEREFORD",
    "dropmalst": "PA",
    "dropmalzpp": 180561503,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 2156795631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18875",
    "droptype": "D",
    "dropname": "HERMAN",
    "dropdeladd": "102 GEIBEL RD",
    "dropdelcty": "HERMAN",
    "dropdelst": "PA",
    "dropdelzpp": 160399800,
    "dropphyadd": "102 GEIBEL RD",
    "dropphycty": "HERMAN",
    "dropphyst": "PA",
    "dropphyzpp": 160399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERMAN",
    "dropmalst": "PA",
    "dropmalzpp": 160399998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242823439,
    "dropsitcph": 7242823439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18876",
    "droptype": "D",
    "dropname": "HERMINIE",
    "dropdeladd": "209 HIGHLAND AVE",
    "dropdelcty": "HERMINIE",
    "dropdelst": "PA",
    "dropdelzpp": 156379998,
    "dropphyadd": "209 HIGHLAND AVE",
    "dropphycty": "HERMINIE",
    "dropphyst": "PA",
    "dropphyzpp": 156379998,
    "dropmaladd": "209 HIGHLAND AVE",
    "dropmalcty": "HERMINIE",
    "dropmalst": "PA",
    "dropmalzpp": 156379998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244467100,
    "dropsitcph": 7244467100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18878",
    "droptype": "D",
    "dropname": "HERNDON",
    "dropdeladd": "127 POTTSVILLE ST",
    "dropdelcty": "HERNDON",
    "dropdelst": "PA",
    "dropdelzpp": 178309998,
    "dropphyadd": "127 POTTSVILLE ST",
    "dropphycty": "HERNDON",
    "dropphyst": "PA",
    "dropphyzpp": 178309998,
    "dropmaladd": "127 POTTSVILLE ST",
    "dropmalcty": "HERNDON",
    "dropmalst": "PA",
    "dropmalzpp": 178309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707589183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18882",
    "droptype": "D",
    "dropname": "HERSHEY",
    "dropdeladd": "151 W CHOCOLATE AVE STE 145",
    "dropdelcty": "HERSHEY",
    "dropdelst": "PA",
    "dropdelzpp": 170339803,
    "dropphyadd": "151 W CHOCOLATE AVE STE 145",
    "dropphycty": "HERSHEY",
    "dropphyst": "PA",
    "dropphyzpp": 170339803,
    "dropmaladd": "151 W CHOCOLATE AVE STE 145",
    "dropmalcty": "HERSHEY",
    "dropmalst": "PA",
    "dropmalzpp": 170339803,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175333356,
    "dropfax": 7175200236
  },
  {
    "dcode": "D",
    "dropkey": "PX18886",
    "droptype": "D",
    "dropname": "HESSTON",
    "dropdeladd": "12393 MAPLE LN",
    "dropdelcty": "HESSTON",
    "dropdelst": "PA",
    "dropdelzpp": 166479998,
    "dropphyadd": "12393 MAPLE LN",
    "dropphycty": "HESSTON",
    "dropphyst": "PA",
    "dropphyzpp": 166479998,
    "dropmaladd": "12393 MAPLE LN",
    "dropmalcty": "HESSTON",
    "dropmalst": "PA",
    "dropmalzpp": 166479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146583543,
    "dropsitcph": 8146583543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18887",
    "droptype": "D",
    "dropname": "HIBBS",
    "dropdeladd": "1006 RALPH NEW SALEM RD",
    "dropdelcty": "HIBBS",
    "dropdelst": "PA",
    "dropdelzpp": 154431001,
    "dropphyadd": "1006 RALPH NEW SALEM RD",
    "dropphycty": "HIBBS",
    "dropphyst": "PA",
    "dropphyzpp": 154431001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIBBS",
    "dropmalst": "PA",
    "dropmalzpp": 154439998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242467680,
    "dropsitcph": 7242467680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18888",
    "droptype": "D",
    "dropname": "HICKORY",
    "dropdeladd": "188 MAIN ST",
    "dropdelcty": "HICKORY",
    "dropdelst": "PA",
    "dropdelzpp": 153401001,
    "dropphyadd": "188 MAIN ST",
    "dropphycty": "HICKORY",
    "dropphyst": "PA",
    "dropphyzpp": 153401001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKORY",
    "dropmalst": "PA",
    "dropmalzpp": 153409998,
    "dropsitphn": 7243597568,
    "dropsitlph": 7243381094,
    "dropsitcph": 7243381094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18897",
    "droptype": "D",
    "dropname": "HIGHSPIRE",
    "dropdeladd": "315 2ND ST",
    "dropdelcty": "HIGHSPIRE",
    "dropdelst": "PA",
    "dropdelzpp": 170349998,
    "dropphyadd": "315 2ND ST",
    "dropphycty": "HIGHSPIRE",
    "dropphyst": "PA",
    "dropphyzpp": 170349998,
    "dropmaladd": "315 2ND ST",
    "dropmalcty": "HIGHSPIRE",
    "dropmalst": "PA",
    "dropmalzpp": 170349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179394902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18902",
    "droptype": "D",
    "dropname": "HILLER",
    "dropdeladd": "906 1ST ST",
    "dropdelcty": "HILLER",
    "dropdelst": "PA",
    "dropdelzpp": 154441001,
    "dropphyadd": "906 1ST ST",
    "dropphycty": "HILLER",
    "dropphyst": "PA",
    "dropphyzpp": 154441001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLER",
    "dropmalst": "PA",
    "dropmalzpp": 154449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247859270,
    "dropsitcph": 7247859270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18905",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "14 WILGUS RD",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "PA",
    "dropdelzpp": 157469998,
    "dropphyadd": "14 WILGUS RD",
    "dropphycty": "HILLSDALE",
    "dropphyst": "PA",
    "dropphyzpp": 157469998,
    "dropmaladd": "14 WILGUS RD",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "PA",
    "dropmalzpp": 157469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147439029,
    "dropsitcph": 8147439029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18906",
    "droptype": "D",
    "dropname": "HILLSGROVE",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "HILLSGROVE",
    "dropdelst": "PA",
    "dropdelzpp": 186199998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "HILLSGROVE",
    "dropphyst": "PA",
    "dropphyzpp": 186199998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "HILLSGROVE",
    "dropmalst": "PA",
    "dropmalzpp": 186199998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709243833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18908",
    "droptype": "D",
    "dropname": "HILLSVILLE",
    "dropdeladd": "2562 CHURCHILL RD",
    "dropdelcty": "HILLSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 161329800,
    "dropphyadd": "2562 CHURCHILL RD",
    "dropphycty": "HILLSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 161329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 161329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246679242,
    "dropsitcph": 7246679242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18909",
    "droptype": "D",
    "dropname": "HILLTOWN",
    "dropdeladd": "1912 HILLTOWN PIKE",
    "dropdelcty": "HILLTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 189279998,
    "dropphyadd": "1912 HILLTOWN PIKE",
    "dropphycty": "HILLTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 189279998,
    "dropmaladd": "1912 HILLTOWN PIKE",
    "dropmalcty": "HILLTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 189279998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158223788,
    "dropsitcph": 2158223788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18918",
    "droptype": "D",
    "dropname": "HOLBROOK",
    "dropdeladd": "2769 GOLDEN OAKS RD",
    "dropdelcty": "HOLBROOK",
    "dropdelst": "PA",
    "dropdelzpp": 153411062,
    "dropphyadd": "2769 GOLDEN OAKS RD",
    "dropphycty": "HOLBROOK",
    "dropphyst": "PA",
    "dropphyzpp": 153411062,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLBROOK",
    "dropmalst": "PA",
    "dropmalzpp": 153419998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244995106,
    "dropsitcph": 7244995106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18919",
    "droptype": "D",
    "dropname": "HOLICONG",
    "dropdeladd": "4950 YORK RD",
    "dropdelcty": "HOLICONG",
    "dropdelst": "PA",
    "dropdelzpp": 189289998,
    "dropphyadd": "4950 YORK RD",
    "dropphycty": "HOLICONG",
    "dropphyst": "PA",
    "dropphyzpp": 189289998,
    "dropmaladd": "4950 YORK RD",
    "dropmalcty": "HOLICONG",
    "dropmalst": "PA",
    "dropmalzpp": 189289998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157948157,
    "dropsitcph": 2157948157,
    "dropfax": 2157942196
  },
  {
    "dcode": "D",
    "dropkey": "PX18923",
    "droptype": "D",
    "dropname": "HOLLIDAYSBURG",
    "dropdeladd": "525 ALLEGHENY ST",
    "dropdelcty": "HOLLIDAYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166489998,
    "dropphyadd": "525 ALLEGHENY ST",
    "dropphycty": "HOLLIDAYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166489998,
    "dropmaladd": "525 ALLEGHENY ST",
    "dropmalcty": "HOLLIDAYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146950021,
    "dropsitcph": 8146950021,
    "dropfax": 8146967921
  },
  {
    "dcode": "D",
    "dropkey": "PX18924",
    "droptype": "D",
    "dropname": "HOLLSOPPLE",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "HOLLSOPPLE",
    "dropdelst": "PA",
    "dropdelzpp": 159359998,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "HOLLSOPPLE",
    "dropphyst": "PA",
    "dropphyzpp": 159359998,
    "dropmaladd": "121 MAIN ST",
    "dropmalcty": "HOLLSOPPLE",
    "dropmalst": "PA",
    "dropmalzpp": 159359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144797616,
    "dropsitcph": 8144797616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18927",
    "droptype": "D",
    "dropname": "HOLMES",
    "dropdeladd": "228 HOLMES RD",
    "dropdelcty": "HOLMES",
    "dropdelst": "PA",
    "dropdelzpp": 190439998,
    "dropphyadd": "228 HOLMES RD",
    "dropphycty": "HOLMES",
    "dropphyst": "PA",
    "dropphyzpp": 190439998,
    "dropmaladd": "228 HOLMES RD",
    "dropmalcty": "HOLMES",
    "dropmalst": "PA",
    "dropmalzpp": 190439998,
    "dropsitphn": 6105321701,
    "dropsitlph": 6105321701,
    "dropsitcph": 6105321701,
    "dropfax": 6105321701
  },
  {
    "dcode": "D",
    "dropkey": "PX18930",
    "droptype": "D",
    "dropname": "HOLTWOOD",
    "dropdeladd": "55 DRYTOWN RD",
    "dropdelcty": "HOLTWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 175329998,
    "dropphyadd": "55 DRYTOWN RD",
    "dropphycty": "HOLTWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 175329998,
    "dropmaladd": "55 DRYTOWN RD",
    "dropmalcty": "HOLTWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 175329998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172842850,
    "dropsitcph": 7172842850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18931",
    "droptype": "D",
    "dropname": "HOME",
    "dropdeladd": "51 ROUTE 85 HWY",
    "dropdelcty": "HOME",
    "dropdelst": "PA",
    "dropdelzpp": 157479998,
    "dropphyadd": "51 ROUTE 85 HWY",
    "dropphycty": "HOME",
    "dropphyst": "PA",
    "dropphyzpp": 157479998,
    "dropmaladd": "51 ROUTE 85 HWY",
    "dropmalcty": "HOME",
    "dropmalst": "PA",
    "dropmalzpp": 157479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243972780,
    "dropsitcph": 7243972780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18933",
    "droptype": "D",
    "dropname": "HOMER CITY",
    "dropdeladd": "25 N MAIN ST",
    "dropdelcty": "HOMER CITY",
    "dropdelst": "PA",
    "dropdelzpp": 157489998,
    "dropphyadd": "25 N MAIN ST",
    "dropphycty": "HOMER CITY",
    "dropphyst": "PA",
    "dropphyzpp": 157489998,
    "dropmaladd": "25 N MAIN ST",
    "dropmalcty": "HOMER CITY",
    "dropmalst": "PA",
    "dropmalzpp": 157489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244799303,
    "dropsitcph": 7244799303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18934",
    "droptype": "D",
    "dropname": "HOMESTEAD",
    "dropdeladd": "601 E 8TH AVE",
    "dropdelcty": "HOMESTEAD",
    "dropdelst": "PA",
    "dropdelzpp": 151209998,
    "dropphyadd": "601 E 8TH AVE",
    "dropphycty": "HOMESTEAD",
    "dropphyst": "PA",
    "dropphyzpp": 151209998,
    "dropmaladd": "601 E 8TH AVE",
    "dropmalcty": "HOMESTEAD",
    "dropmalst": "PA",
    "dropmalzpp": 151209998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124610452,
    "dropsitcph": 4124610452,
    "dropfax": 4124615822
  },
  {
    "dcode": "D",
    "dropkey": "PX18940",
    "droptype": "D",
    "dropname": "HONESDALE",
    "dropdeladd": "830 MAIN ST",
    "dropdelcty": "HONESDALE",
    "dropdelst": "PA",
    "dropdelzpp": 184319998,
    "dropphyadd": "830 MAIN ST",
    "dropphycty": "HONESDALE",
    "dropphyst": "PA",
    "dropphyzpp": 184319998,
    "dropmaladd": "830 MAIN ST",
    "dropmalcty": "HONESDALE",
    "dropmalst": "PA",
    "dropmalzpp": 184319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702533370,
    "dropfax": 5702538980
  },
  {
    "dcode": "D",
    "dropkey": "PX18941",
    "droptype": "D",
    "dropname": "HONEY BROOK",
    "dropdeladd": "51 PEQUEA AVE",
    "dropdelcty": "HONEY BROOK",
    "dropdelst": "PA",
    "dropdelzpp": 193449998,
    "dropphyadd": "51 PEQUEA AVE",
    "dropphycty": "HONEY BROOK",
    "dropphyst": "PA",
    "dropphyzpp": 193449998,
    "dropmaladd": "51 PEQUEA AVE",
    "dropmalcty": "HONEY BROOK",
    "dropmalst": "PA",
    "dropmalzpp": 193449998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102734347,
    "dropsitcph": 6102734347,
    "dropfax": 6102739318
  },
  {
    "dcode": "D",
    "dropkey": "PX18942",
    "droptype": "D",
    "dropname": "HONEY GROVE",
    "dropdeladd": "13134 ROUTE 75 S",
    "dropdelcty": "HONEY GROVE",
    "dropdelst": "PA",
    "dropdelzpp": 170359800,
    "dropphyadd": "13134 ROUTE 75 S",
    "dropphycty": "HONEY GROVE",
    "dropphyst": "PA",
    "dropphyzpp": 170359800,
    "dropmaladd": "13134 ROUTE 75 S",
    "dropmalcty": "HONEY GROVE",
    "dropmalst": "PA",
    "dropmalzpp": 170359800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175272313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18944",
    "droptype": "D",
    "dropname": "HOOKSTOWN",
    "dropdeladd": "114 MILL ST",
    "dropdelcty": "HOOKSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 150509998,
    "dropphyadd": "114 MILL ST",
    "dropphycty": "HOOKSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 150509998,
    "dropmaladd": "114 MILL ST",
    "dropmalcty": "HOOKSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 150509998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245734603,
    "dropsitcph": 7245734603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18945",
    "droptype": "D",
    "dropname": "HOOVERSVILLE",
    "dropdeladd": "964 BARN ST",
    "dropdelcty": "HOOVERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 159369998,
    "dropphyadd": "964 BARN ST",
    "dropphycty": "HOOVERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 159369998,
    "dropmaladd": "964 BARN ST",
    "dropmalcty": "HOOVERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 159369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147988241,
    "dropsitcph": 8147988241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18946",
    "droptype": "D",
    "dropname": "HOP BOTTOM",
    "dropdeladd": "84 MAIN ST",
    "dropdelcty": "HOP BOTTOM",
    "dropdelst": "PA",
    "dropdelzpp": 188249998,
    "dropphyadd": "84 MAIN ST",
    "dropphycty": "HOP BOTTOM",
    "dropphyst": "PA",
    "dropphyzpp": 188249998,
    "dropmaladd": "84 MAIN ST",
    "dropmalcty": "HOP BOTTOM",
    "dropmalst": "PA",
    "dropmalzpp": 188249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702894861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18947",
    "droptype": "D",
    "dropname": "HOPELAND",
    "dropdeladd": "482 N CLAY ST",
    "dropdelcty": "HOPELAND",
    "dropdelst": "PA",
    "dropdelzpp": 175339998,
    "dropphyadd": "482 N CLAY ST",
    "dropphycty": "HOPELAND",
    "dropphyst": "PA",
    "dropphyzpp": 175339998,
    "dropmaladd": "482 N CLAY ST",
    "dropmalcty": "HOPELAND",
    "dropmalst": "PA",
    "dropmalzpp": 175339998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177330151,
    "dropsitcph": 7177330151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18948",
    "droptype": "D",
    "dropname": "HOPEWELL",
    "dropdeladd": "211 FRONT ST",
    "dropdelcty": "HOPEWELL",
    "dropdelst": "PA",
    "dropdelzpp": 166509998,
    "dropphyadd": "211 FRONT ST",
    "dropphycty": "HOPEWELL",
    "dropphyst": "PA",
    "dropphyzpp": 166509998,
    "dropmaladd": "211 FRONT ST",
    "dropmalcty": "HOPEWELL",
    "dropmalst": "PA",
    "dropmalzpp": 166509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149284343,
    "dropsitcph": 8149284343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18950",
    "droptype": "D",
    "dropname": "HOPWOOD",
    "dropdeladd": "108 PAULL ST",
    "dropdelcty": "HOPWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 154453100,
    "dropphyadd": "108 PAULL ST",
    "dropphycty": "HOPWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 154453100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 154459998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244375106,
    "dropsitcph": 7244375106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18952",
    "droptype": "D",
    "dropname": "HORSHAM",
    "dropdeladd": "575 HORSHAM RD UNIT D38",
    "dropdelcty": "HORSHAM",
    "dropdelst": "PA",
    "dropdelzpp": 190449997,
    "dropphyadd": "575 HORSHAM RD UNIT D38",
    "dropphycty": "HORSHAM",
    "dropphyst": "PA",
    "dropphyzpp": 190449997,
    "dropmaladd": "575 HORSHAM RD UNIT D38",
    "dropmalcty": "HORSHAM",
    "dropmalst": "PA",
    "dropmalzpp": 190449997,
    "dropsitphn": 2156724780,
    "dropsitlph": 2156724780,
    "dropsitcph": 2156724780,
    "dropfax": 2156722940
  },
  {
    "dcode": "D",
    "dropkey": "PX18957",
    "droptype": "D",
    "dropname": "HOSTETTER",
    "dropdeladd": "126 SLOVAK CLUB RD",
    "dropdelcty": "HOSTETTER",
    "dropdelst": "PA",
    "dropdelzpp": 156381001,
    "dropphyadd": "126 SLOVAK CLUB RD",
    "dropphycty": "HOSTETTER",
    "dropphyst": "PA",
    "dropphyzpp": 156381001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOSTETTER",
    "dropmalst": "PA",
    "dropmalzpp": 156389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244235080,
    "dropsitcph": 7244235080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18958",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "123 S MAIN ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "PA",
    "dropdelzpp": 153429998,
    "dropphyadd": "123 S MAIN ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "PA",
    "dropphyzpp": 153429998,
    "dropmaladd": "123 S MAIN ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "PA",
    "dropmalzpp": 153429998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247451860,
    "dropsitcph": 7247451860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18960",
    "droptype": "D",
    "dropname": "HOUTZDALE",
    "dropdeladd": "721 MCATEER ST",
    "dropdelcty": "HOUTZDALE",
    "dropdelst": "PA",
    "dropdelzpp": 166519998,
    "dropphyadd": "721 MCATEER ST",
    "dropphycty": "HOUTZDALE",
    "dropphyst": "PA",
    "dropphyzpp": 166519998,
    "dropmaladd": "721 MCATEER ST",
    "dropmalcty": "HOUTZDALE",
    "dropmalst": "PA",
    "dropmalzpp": 166519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143788282,
    "dropsitcph": 8143788282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18961",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "324 WALNUT ST",
    "dropdelcty": "HOWARD",
    "dropdelst": "PA",
    "dropdelzpp": 168419998,
    "dropphyadd": "324 WALNUT ST",
    "dropphycty": "HOWARD",
    "dropphyst": "PA",
    "dropphyzpp": 168419998,
    "dropmaladd": "324 WALNUT ST",
    "dropmalcty": "HOWARD",
    "dropmalst": "PA",
    "dropmalzpp": 168419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146252823,
    "dropsitcph": 8146252823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18969",
    "droptype": "D",
    "dropname": "HUGHESVILLE",
    "dropdeladd": "44 N MAIN ST",
    "dropdelcty": "HUGHESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177379998,
    "dropphyadd": "44 N MAIN ST",
    "dropphycty": "HUGHESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177379998,
    "dropmaladd": "44 N MAIN ST",
    "dropmalcty": "HUGHESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5705842590,
    "dropsitcph": 5705842590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18972",
    "droptype": "D",
    "dropname": "HUMMELS WHARF",
    "dropdeladd": "1245 N SUSQUEHANNA TRL",
    "dropdelcty": "HUMMELS WHARF",
    "dropdelst": "PA",
    "dropdelzpp": 178319800,
    "dropphyadd": "1245 N SUSQUEHANNA TRL",
    "dropphycty": "HUMMELS WHARF",
    "dropphyst": "PA",
    "dropphyzpp": 178319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMMELS WHARF",
    "dropmalst": "PA",
    "dropmalzpp": 178319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707437412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18973",
    "droptype": "D",
    "dropname": "HUMMELSTOWN",
    "dropdeladd": "448 WALTON AVE",
    "dropdelcty": "HUMMELSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170369998,
    "dropphyadd": "448 WALTON AVE",
    "dropphycty": "HUMMELSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170369998,
    "dropmaladd": "448 WALTON AVE",
    "dropmalcty": "HUMMELSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175660811,
    "dropfax": 7175661118
  },
  {
    "dcode": "D",
    "dropkey": "PX18974",
    "droptype": "D",
    "dropname": "HUNKER",
    "dropdeladd": "331 DIVISION ST",
    "dropdelcty": "HUNKER",
    "dropdelst": "PA",
    "dropdelzpp": 156395001,
    "dropphyadd": "331 DIVISION ST",
    "dropphycty": "HUNKER",
    "dropphyst": "PA",
    "dropphyzpp": 156395001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNKER",
    "dropmalst": "PA",
    "dropmalzpp": 156399998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249256466,
    "dropsitcph": 7249256466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18975",
    "droptype": "D",
    "dropname": "HUNLOCK CREEK",
    "dropdeladd": "1623 MAIN RD",
    "dropdelcty": "HUNLOCK CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 186219998,
    "dropphyadd": "1623 MAIN RD",
    "dropphycty": "HUNLOCK CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 186219998,
    "dropmaladd": "1623 MAIN RD",
    "dropmalcty": "HUNLOCK CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 186219998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5702564313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18984",
    "droptype": "D",
    "dropname": "HUNTINGDON",
    "dropdeladd": "401 WASHINGTON ST",
    "dropdelcty": "HUNTINGDON",
    "dropdelst": "PA",
    "dropdelzpp": 166529998,
    "dropphyadd": "401 WASHINGTON ST",
    "dropphycty": "HUNTINGDON",
    "dropphyst": "PA",
    "dropphyzpp": 166529998,
    "dropmaladd": "401 WASHINGTON ST",
    "dropmalcty": "HUNTINGDON",
    "dropmalst": "PA",
    "dropmalzpp": 166529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146434430,
    "dropsitcph": 8146434430,
    "dropfax": 8146437192
  },
  {
    "dcode": "D",
    "dropkey": "PX18985",
    "droptype": "D",
    "dropname": "HUNTINGDON VALLEY",
    "dropdeladd": "830 WELSH RD",
    "dropdelcty": "HUNTINGDON VALLEY",
    "dropdelst": "PA",
    "dropdelzpp": 190069998,
    "dropphyadd": "830 WELSH RD",
    "dropphycty": "HUNTINGDON VALLEY",
    "dropphyst": "PA",
    "dropphyzpp": 190069998,
    "dropmaladd": "830 WELSH RD",
    "dropmalcty": "HUNTINGDON VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 190069998,
    "dropsitphn": 2159471828,
    "dropsitlph": 2159471828,
    "dropsitcph": 2159471828,
    "dropfax": 2159475785
  },
  {
    "dcode": "D",
    "dropkey": "PX18988",
    "droptype": "D",
    "dropname": "HUNTINGTON MILLS",
    "dropdeladd": "1059 STATE ROUTE 239",
    "dropdelcty": "HUNTINGTON MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 186229998,
    "dropphyadd": "1059 STATE ROUTE 239",
    "dropphycty": "HUNTINGTON MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 186229998,
    "dropmaladd": "1059 STATE ROUTE 239",
    "dropmalcty": "HUNTINGTON MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 186229998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708643258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18991",
    "droptype": "D",
    "dropname": "HUSTONTOWN",
    "dropdeladd": "313 PITT ST STE A",
    "dropdelcty": "HUSTONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 172299998,
    "dropphyadd": "313 PITT ST STE A",
    "dropphycty": "HUSTONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 172299998,
    "dropmaladd": "313 PITT ST STE A",
    "dropmalcty": "HUSTONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 172299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179873748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18993",
    "droptype": "D",
    "dropname": "HUTCHINSON",
    "dropdeladd": "116 HOOD ST",
    "dropdelcty": "HUTCHINSON",
    "dropdelst": "PA",
    "dropdelzpp": 156401002,
    "dropphyadd": "116 HOOD ST",
    "dropphycty": "HUTCHINSON",
    "dropphyst": "PA",
    "dropphyzpp": 156401002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUTCHINSON",
    "dropmalst": "PA",
    "dropmalzpp": 156409998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248724449,
    "dropsitcph": 7248724449,
    "dropfax": 7248722784
  },
  {
    "dcode": "D",
    "dropkey": "PX18994",
    "droptype": "D",
    "dropname": "HYDE",
    "dropdeladd": "1501 WASHINGTON AVE",
    "dropdelcty": "HYDE",
    "dropdelst": "PA",
    "dropdelzpp": 168439998,
    "dropphyadd": "1501 WASHINGTON AVE",
    "dropphycty": "HYDE",
    "dropphyst": "PA",
    "dropphyzpp": 168439998,
    "dropmaladd": "1501 WASHINGTON AVE",
    "dropmalcty": "HYDE",
    "dropmalst": "PA",
    "dropmalzpp": 168439998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147656773,
    "dropsitcph": 8147656773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18995",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "385 CHESTNUT ST",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "PA",
    "dropdelzpp": 156419998,
    "dropphyadd": "385 CHESTNUT ST",
    "dropphycty": "HYDE PARK",
    "dropphyst": "PA",
    "dropphyzpp": 156419998,
    "dropmaladd": "385 CHESTNUT ST",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "PA",
    "dropmalzpp": 156419998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248456640,
    "dropsitcph": 7248456640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX18998",
    "droptype": "D",
    "dropname": "HYNDMAN",
    "dropdeladd": "129 WASHINGTON ST",
    "dropdelcty": "HYNDMAN",
    "dropdelst": "PA",
    "dropdelzpp": 155459998,
    "dropphyadd": "129 WASHINGTON ST",
    "dropphycty": "HYNDMAN",
    "dropphyst": "PA",
    "dropphyzpp": 155459998,
    "dropmaladd": "129 WASHINGTON ST",
    "dropmalcty": "HYNDMAN",
    "dropmalst": "PA",
    "dropmalzpp": 155459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148426417,
    "dropsitcph": 8148426417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19002",
    "droptype": "D",
    "dropname": "ICKESBURG",
    "dropdeladd": "6978 VETERANS WAY",
    "dropdelcty": "ICKESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170379998,
    "dropphyadd": "6978 VETERANS WAY",
    "dropphycty": "ICKESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170379998,
    "dropmaladd": "6978 VETERANS WAY",
    "dropmalcty": "ICKESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174383646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19003",
    "droptype": "D",
    "dropname": "IDAVILLE",
    "dropdeladd": "3498 CARLISLE RD",
    "dropdelcty": "IDAVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173379998,
    "dropphyadd": "3498 CARLISLE RD",
    "dropphycty": "IDAVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173379998,
    "dropmaladd": "3498 CARLISLE RD",
    "dropmalcty": "IDAVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173379998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176774211,
    "dropsitcph": 7176774211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19006",
    "droptype": "D",
    "dropname": "IMLER",
    "dropdeladd": "1233 S IMLER VALLEY RD",
    "dropdelcty": "IMLER",
    "dropdelst": "PA",
    "dropdelzpp": 166559998,
    "dropphyadd": "1233 S IMLER VALLEY RD",
    "dropphycty": "IMLER",
    "dropphyst": "PA",
    "dropphyzpp": 166559998,
    "dropmaladd": "1233 S IMLER VALLEY RD",
    "dropmalcty": "IMLER",
    "dropmalst": "PA",
    "dropmalzpp": 166559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142763022,
    "dropsitcph": 8142763022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19008",
    "droptype": "D",
    "dropname": "IMPERIAL",
    "dropdeladd": "600 PENN LINCOLN DR",
    "dropdelcty": "IMPERIAL",
    "dropdelst": "PA",
    "dropdelzpp": 151269998,
    "dropphyadd": "600 PENN LINCOLN DR",
    "dropphycty": "IMPERIAL",
    "dropphyst": "PA",
    "dropphyzpp": 151269998,
    "dropmaladd": "600 PENN LINCOLN DR",
    "dropmalcty": "IMPERIAL",
    "dropmalst": "PA",
    "dropmalzpp": 151269998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246950698,
    "dropsitcph": 7246950698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19011",
    "droptype": "D",
    "dropname": "INDIAN HEAD",
    "dropdeladd": "2072 INDIAN HEAD RD",
    "dropdelcty": "INDIAN HEAD",
    "dropdelst": "PA",
    "dropdelzpp": 154461111,
    "dropphyadd": "2072 INDIAN HEAD RD",
    "dropphycty": "INDIAN HEAD",
    "dropphyst": "PA",
    "dropphyzpp": 154461111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIAN HEAD",
    "dropmalst": "PA",
    "dropmalzpp": 154469998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244552615,
    "dropsitcph": 7244552615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19012",
    "droptype": "D",
    "dropname": "INDIANA",
    "dropdeladd": "47 S 7TH ST",
    "dropdelcty": "INDIANA",
    "dropdelst": "PA",
    "dropdelzpp": 157019998,
    "dropphyadd": "47 S 7TH ST",
    "dropphycty": "INDIANA",
    "dropphyst": "PA",
    "dropphyzpp": 157019998,
    "dropmaladd": "47 S 7TH ST",
    "dropmalcty": "INDIANA",
    "dropmalst": "PA",
    "dropmalzpp": 157019998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244654771,
    "dropsitcph": 7244654771,
    "dropfax": 7244655043
  },
  {
    "dcode": "D",
    "dropkey": "PX19014",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "898 ROUTE 910 STE 2",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "PA",
    "dropdelzpp": 150511011,
    "dropphyadd": "898 ROUTE 910 STE 2",
    "dropphycty": "INDIANOLA",
    "dropphyst": "PA",
    "dropphyzpp": 150511011,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "PA",
    "dropmalzpp": 150519998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127674791,
    "dropsitcph": 4127674791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19015",
    "droptype": "D",
    "dropname": "INDUSTRY",
    "dropdeladd": "1620A MIDLAND BEAVER RD",
    "dropdelcty": "INDUSTRY",
    "dropdelst": "PA",
    "dropdelzpp": 150521001,
    "dropphyadd": "1620A MIDLAND BEAVER RD",
    "dropphycty": "INDUSTRY",
    "dropphyst": "PA",
    "dropphyzpp": 150521001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDUSTRY",
    "dropmalst": "PA",
    "dropmalzpp": 150529998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246434060,
    "dropsitcph": 7246434060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19019",
    "droptype": "D",
    "dropname": "INGOMAR",
    "dropdeladd": "736 W INGOMAR RD",
    "dropdelcty": "INGOMAR",
    "dropdelst": "PA",
    "dropdelzpp": 151272000,
    "dropphyadd": "736 W INGOMAR RD",
    "dropphycty": "INGOMAR",
    "dropphyst": "PA",
    "dropphyzpp": 151272000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INGOMAR",
    "dropmalst": "PA",
    "dropmalzpp": 151279998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123647325,
    "dropsitcph": 4123647325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19023",
    "droptype": "D",
    "dropname": "INTERCOURSE",
    "dropdeladd": "14J CENTER ST",
    "dropdelcty": "INTERCOURSE",
    "dropdelst": "PA",
    "dropdelzpp": 175349998,
    "dropphyadd": "14J CENTER ST",
    "dropphycty": "INTERCOURSE",
    "dropphyst": "PA",
    "dropphyzpp": 175349998,
    "dropmaladd": "14J CENTER ST",
    "dropmalcty": "INTERCOURSE",
    "dropmalst": "PA",
    "dropmalzpp": 175349998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177688431,
    "dropsitcph": 8002758777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19031",
    "droptype": "D",
    "dropname": "IRVINE",
    "dropdeladd": "853 NATIONAL FORGE RD",
    "dropdelcty": "IRVINE",
    "dropdelst": "PA",
    "dropdelzpp": 163299800,
    "dropphyadd": "853 NATIONAL FORGE RD",
    "dropphycty": "IRVINE",
    "dropphyst": "PA",
    "dropphyzpp": 163299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRVINE",
    "dropmalst": "PA",
    "dropmalzpp": 163299998,
    "dropsitphn": 4123597666,
    "dropsitlph": 8145637921,
    "dropsitcph": 8145637921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19033",
    "droptype": "D",
    "dropname": "IRVONA",
    "dropdeladd": "133 JULIA ST",
    "dropdelcty": "IRVONA",
    "dropdelst": "PA",
    "dropdelzpp": 166569998,
    "dropphyadd": "133 JULIA ST",
    "dropphycty": "IRVONA",
    "dropphyst": "PA",
    "dropphyzpp": 166569998,
    "dropmaladd": "133 JULIA ST",
    "dropmalcty": "IRVONA",
    "dropmalst": "PA",
    "dropmalzpp": 166569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146707021,
    "dropsitcph": 8146707021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19034",
    "droptype": "D",
    "dropname": "IRWIN",
    "dropdeladd": "140 MAIN ST",
    "dropdelcty": "IRWIN",
    "dropdelst": "PA",
    "dropdelzpp": 156427901,
    "dropphyadd": "140 MAIN ST",
    "dropphycty": "IRWIN",
    "dropphyst": "PA",
    "dropphyzpp": 156427901,
    "dropmaladd": "140 MAIN ST",
    "dropmalcty": "IRWIN",
    "dropmalst": "PA",
    "dropmalzpp": 156427901,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248639569,
    "dropsitcph": 7248646790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19035",
    "droptype": "D",
    "dropname": "ISABELLA",
    "dropdeladd": "506 1ST ST REAR",
    "dropdelcty": "ISABELLA",
    "dropdelst": "PA",
    "dropdelzpp": 154471000,
    "dropphyadd": "506 1ST ST REAR",
    "dropphycty": "ISABELLA",
    "dropphyst": "PA",
    "dropphyzpp": 154471000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISABELLA",
    "dropmalst": "PA",
    "dropmalzpp": 154479998,
    "dropsitphn": 4123597598,
    "dropsitlph": 7247859520,
    "dropsitcph": 7247859520,
    "dropfax": 7247859520
  },
  {
    "dcode": "D",
    "dropkey": "PX19044",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "362 OLD MILL RD",
    "dropdelcty": "JACKSON",
    "dropdelst": "PA",
    "dropdelzpp": 188259998,
    "dropphyadd": "362 OLD MILL RD",
    "dropphycty": "JACKSON",
    "dropphyst": "PA",
    "dropphyzpp": 188259998,
    "dropmaladd": "362 OLD MILL RD",
    "dropmalcty": "JACKSON",
    "dropmalst": "PA",
    "dropmalzpp": 188259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707562850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19048",
    "droptype": "D",
    "dropname": "JACKSON CENTER",
    "dropdeladd": "1163 FRANKLIN RD",
    "dropdelcty": "JACKSON CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 161339800,
    "dropphyadd": "1163 FRANKLIN RD",
    "dropphycty": "JACKSON CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 161339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSON CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 161339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246624071,
    "dropsitcph": 7246624071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19054",
    "droptype": "D",
    "dropname": "JACOBS CREEK",
    "dropdeladd": "178 MAIN ST",
    "dropdelcty": "JACOBS CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 154481001,
    "dropphyadd": "178 MAIN ST",
    "dropphycty": "JACOBS CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 154481001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACOBS CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 154489998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248724410,
    "dropsitcph": 7248724410,
    "dropfax": 7248722818
  },
  {
    "dcode": "D",
    "dropkey": "PX19059",
    "droptype": "D",
    "dropname": "JAMES CITY",
    "dropdeladd": "147 DELAWARE AVE",
    "dropdelcty": "JAMES CITY",
    "dropdelst": "PA",
    "dropdelzpp": 167349800,
    "dropphyadd": "147 DELAWARE AVE",
    "dropphycty": "JAMES CITY",
    "dropphyst": "PA",
    "dropphyzpp": 167349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAMES CITY",
    "dropmalst": "PA",
    "dropmalzpp": 167349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148379132,
    "dropsitcph": 8148379132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19060",
    "droptype": "D",
    "dropname": "JAMES CREEK",
    "dropdeladd": "3322 OLD MOUNTAIN RD STE A",
    "dropdelcty": "JAMES CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 166579998,
    "dropphyadd": "3322 OLD MOUNTAIN RD STE A",
    "dropphycty": "JAMES CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 166579998,
    "dropmaladd": "3322 OLD MOUNTAIN RD STE A",
    "dropmalcty": "JAMES CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 166579998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146583855,
    "dropsitcph": 8146583855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19061",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "119 LIBERTY ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 161349998,
    "dropphyadd": "119 LIBERTY ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 161349998,
    "dropmaladd": "119 LIBERTY ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 161349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7249325245,
    "dropsitcph": 7249325245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19062",
    "droptype": "D",
    "dropname": "JAMISON",
    "dropdeladd": "2370 YORK RD STE G1",
    "dropdelcty": "JAMISON",
    "dropdelst": "PA",
    "dropdelzpp": 189299998,
    "dropphyadd": "2370 YORK RD STE G1",
    "dropphycty": "JAMISON",
    "dropphyst": "PA",
    "dropphyzpp": 189299998,
    "dropmaladd": "2370 YORK RD STE G1",
    "dropmalcty": "JAMISON",
    "dropmalst": "PA",
    "dropmalzpp": 189299998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153433916,
    "dropsitcph": 2153433916,
    "dropfax": 2153431294
  },
  {
    "dcode": "D",
    "dropkey": "PX19067",
    "droptype": "D",
    "dropname": "JEANNETTE",
    "dropdeladd": "223 S 5TH ST",
    "dropdelcty": "JEANNETTE",
    "dropdelst": "PA",
    "dropdelzpp": 156449998,
    "dropphyadd": "223 S 5TH ST",
    "dropphycty": "JEANNETTE",
    "dropphyst": "PA",
    "dropphyzpp": 156449998,
    "dropmaladd": "223 S 5TH ST",
    "dropmalcty": "JEANNETTE",
    "dropmalst": "PA",
    "dropmalzpp": 156449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245239680,
    "dropsitcph": 7245239680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19071",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "1422 JEFFERSON RD",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "PA",
    "dropdelzpp": 153441001,
    "dropphyadd": "1422 JEFFERSON RD",
    "dropphycty": "JEFFERSON",
    "dropphyst": "PA",
    "dropphyzpp": 153441001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "PA",
    "dropmalzpp": 153449998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248832973,
    "dropsitcph": 7248832973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19076",
    "droptype": "D",
    "dropname": "JENKINTOWN",
    "dropdeladd": "601 WEST AVE",
    "dropdelcty": "JENKINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190469998,
    "dropphyadd": "601 WEST AVE",
    "dropphycty": "JENKINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190469998,
    "dropmaladd": "601 WEST AVE",
    "dropmalcty": "JENKINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190469998,
    "dropsitphn": 2158870936,
    "dropsitlph": 2158873112,
    "dropsitcph": 2158870936,
    "dropfax": 2158870753
  },
  {
    "dcode": "D",
    "dropkey": "PX19078",
    "droptype": "D",
    "dropname": "JENNERSTOWN",
    "dropdeladd": "1596 PITT ST",
    "dropdelcty": "JENNERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 155479998,
    "dropphyadd": "1596 PITT ST",
    "dropphycty": "JENNERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 155479998,
    "dropmaladd": "1596 PITT ST",
    "dropmalcty": "JENNERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 155479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146299669,
    "dropsitcph": 8146299669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19080",
    "droptype": "D",
    "dropname": "JERMYN",
    "dropdeladd": "551 WASHINGTON AVE",
    "dropdelcty": "JERMYN",
    "dropdelst": "PA",
    "dropdelzpp": 184339998,
    "dropphyadd": "551 WASHINGTON AVE",
    "dropphycty": "JERMYN",
    "dropphyst": "PA",
    "dropphyzpp": 184339998,
    "dropmaladd": "551 WASHINGTON AVE",
    "dropmalcty": "JERMYN",
    "dropmalst": "PA",
    "dropmalzpp": 184339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708761530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19081",
    "droptype": "D",
    "dropname": "JEROME",
    "dropdeladd": "1901 PENN AVE",
    "dropdelcty": "JEROME",
    "dropdelst": "PA",
    "dropdelzpp": 159379998,
    "dropphyadd": "1901 PENN AVE",
    "dropphycty": "JEROME",
    "dropphyst": "PA",
    "dropphyzpp": 159379998,
    "dropmaladd": "1901 PENN AVE",
    "dropmalcty": "JEROME",
    "dropmalst": "PA",
    "dropmalzpp": 159379998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144792470,
    "dropsitcph": 8144792470,
    "dropfax": 8144792540
  },
  {
    "dcode": "D",
    "dropkey": "PX19083",
    "droptype": "D",
    "dropname": "JERSEY SHORE",
    "dropdeladd": "234 ALLEGHENY ST",
    "dropdelcty": "JERSEY SHORE",
    "dropdelst": "PA",
    "dropdelzpp": 177409998,
    "dropphyadd": "234 ALLEGHENY ST",
    "dropphycty": "JERSEY SHORE",
    "dropphyst": "PA",
    "dropphyzpp": 177409998,
    "dropmaladd": "234 ALLEGHENY ST",
    "dropmalcty": "JERSEY SHORE",
    "dropmalst": "PA",
    "dropmalzpp": 177409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703981550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19085",
    "droptype": "D",
    "dropname": "JESSUP",
    "dropdeladd": "95 CHURCH ST",
    "dropdelcty": "JESSUP",
    "dropdelst": "PA",
    "dropdelzpp": 184349998,
    "dropphyadd": "95 CHURCH ST",
    "dropphycty": "JESSUP",
    "dropphyst": "PA",
    "dropphyzpp": 184349998,
    "dropmaladd": "95 CHURCH ST",
    "dropmalcty": "JESSUP",
    "dropmalst": "PA",
    "dropmalzpp": 184349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5704895911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19086",
    "droptype": "D",
    "dropname": "JIM THORPE",
    "dropdeladd": "3 LEHIGH AVE",
    "dropdelcty": "JIM THORPE",
    "dropdelst": "PA",
    "dropdelzpp": 182299998,
    "dropphyadd": "3 LEHIGH AVE",
    "dropphycty": "JIM THORPE",
    "dropphyst": "PA",
    "dropphyzpp": 182299998,
    "dropmaladd": "3 LEHIGH AVE",
    "dropmalcty": "JIM THORPE",
    "dropmalst": "PA",
    "dropmalzpp": 182299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703253951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19089",
    "droptype": "D",
    "dropname": "JOFFRE",
    "dropdeladd": "587 JOFFRE BULGER RD",
    "dropdelcty": "JOFFRE",
    "dropdelst": "PA",
    "dropdelzpp": 150531001,
    "dropphyadd": "587 JOFFRE BULGER RD",
    "dropphycty": "JOFFRE",
    "dropphyst": "PA",
    "dropphyzpp": 150531001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOFFRE",
    "dropmalst": "PA",
    "dropmalzpp": 150539998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249473861,
    "dropsitcph": 7249473861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19091",
    "droptype": "D",
    "dropname": "JOHNSONBURG",
    "dropdeladd": "420 MARKET ST",
    "dropdelcty": "JOHNSONBURG",
    "dropdelst": "PA",
    "dropdelzpp": 158451295,
    "dropphyadd": "420 MARKET ST",
    "dropphycty": "JOHNSONBURG",
    "dropphyst": "PA",
    "dropphyzpp": 158451295,
    "dropmaladd": "420 MARKET ST",
    "dropmalcty": "JOHNSONBURG",
    "dropmalst": "PA",
    "dropmalzpp": 158451295,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149652919,
    "dropsitcph": 8149652919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19093",
    "droptype": "D",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "111 FRANKLIN ST RM 105",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 159019998,
    "dropphyadd": "111 FRANKLIN ST RM 105",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 159019998,
    "dropmaladd": "111 FRANKLIN ST RM 105",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 159019998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8145336141,
    "dropsitcph": 8145336141,
    "dropfax": 8145334966
  },
  {
    "dcode": "D",
    "dropkey": "PX19097",
    "droptype": "D",
    "dropname": "JONES MILLS",
    "dropdeladd": "4124 STATE ROUTE 31",
    "dropdelcty": "JONES MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 156461001,
    "dropphyadd": "4124 STATE ROUTE 31",
    "dropphycty": "JONES MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 156461001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JONES MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 156469998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245937862,
    "dropsitcph": 7245937862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19099",
    "droptype": "D",
    "dropname": "JONESTOWN",
    "dropdeladd": "217 S LANCASTER ST",
    "dropdelcty": "JONESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170389998,
    "dropphyadd": "217 S LANCASTER ST",
    "dropphycty": "JONESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170389998,
    "dropmaladd": "217 S LANCASTER ST",
    "dropmalcty": "JONESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170389998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178655412,
    "dropfax": 7178654814
  },
  {
    "dcode": "D",
    "dropkey": "PX19107",
    "droptype": "D",
    "dropname": "JULIAN",
    "dropdeladd": "4848 S EAGLE VALLEY RD",
    "dropdelcty": "JULIAN",
    "dropdelst": "PA",
    "dropdelzpp": 168449998,
    "dropphyadd": "4848 S EAGLE VALLEY RD",
    "dropphycty": "JULIAN",
    "dropphyst": "PA",
    "dropphyzpp": 168449998,
    "dropmaladd": "4848 S EAGLE VALLEY RD",
    "dropmalcty": "JULIAN",
    "dropmalst": "PA",
    "dropmalzpp": 168449998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143550811,
    "dropsitcph": 8143550811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19109",
    "droptype": "D",
    "dropname": "JUNEDALE",
    "dropdeladd": "13 E MAIN ST",
    "dropdelcty": "JUNEDALE",
    "dropdelst": "PA",
    "dropdelzpp": 182309998,
    "dropphyadd": "13 E MAIN ST",
    "dropphycty": "JUNEDALE",
    "dropphyst": "PA",
    "dropphyzpp": 182309998,
    "dropmaladd": "13 E MAIN ST",
    "dropmalcty": "JUNEDALE",
    "dropmalst": "PA",
    "dropmalzpp": 182309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704592294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19113",
    "droptype": "D",
    "dropname": "KANE",
    "dropdeladd": "131 N FRALEY ST",
    "dropdelcty": "KANE",
    "dropdelst": "PA",
    "dropdelzpp": 167359997,
    "dropphyadd": "131 N FRALEY ST",
    "dropphycty": "KANE",
    "dropphyst": "PA",
    "dropphyzpp": 167359997,
    "dropmaladd": "131 N FRALEY ST",
    "dropmalcty": "KANE",
    "dropmalst": "PA",
    "dropmalzpp": 167359997,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148377580,
    "dropsitcph": 8148377580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19117",
    "droptype": "D",
    "dropname": "KARNS CITY",
    "dropdeladd": "108 PETROLIA ST",
    "dropdelcty": "KARNS CITY",
    "dropdelst": "PA",
    "dropdelzpp": 160419800,
    "dropphyadd": "108 PETROLIA ST",
    "dropphycty": "KARNS CITY",
    "dropphyst": "PA",
    "dropphyzpp": 160419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KARNS CITY",
    "dropmalst": "PA",
    "dropmalzpp": 160419998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247563150,
    "dropsitcph": 7247563150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19118",
    "droptype": "D",
    "dropname": "KARTHAUS",
    "dropdeladd": "48 SMITH ST",
    "dropdelcty": "KARTHAUS",
    "dropdelst": "PA",
    "dropdelzpp": 168459998,
    "dropphyadd": "48 SMITH ST",
    "dropphycty": "KARTHAUS",
    "dropphyst": "PA",
    "dropphyzpp": 168459998,
    "dropmaladd": "48 SMITH ST",
    "dropmalcty": "KARTHAUS",
    "dropmalst": "PA",
    "dropmalzpp": 168459998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142634399,
    "dropsitcph": 8142634399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19131",
    "droptype": "D",
    "dropname": "KEISTERVILLE",
    "dropdeladd": "831 MAIN ST",
    "dropdelcty": "KEISTERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 154491001,
    "dropphyadd": "831 MAIN ST",
    "dropphycty": "KEISTERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 154491001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEISTERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 154499998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244393220,
    "dropsitcph": 7244393220,
    "dropfax": 7244393220
  },
  {
    "dcode": "D",
    "dropkey": "PX19134",
    "droptype": "D",
    "dropname": "KELAYRES",
    "dropdeladd": "21 4TH ST",
    "dropdelcty": "KELAYRES",
    "dropdelst": "PA",
    "dropdelzpp": 182319998,
    "dropphyadd": "21 4TH ST",
    "dropphycty": "KELAYRES",
    "dropphyst": "PA",
    "dropphyzpp": 182319998,
    "dropmaladd": "21 4TH ST",
    "dropmalcty": "KELAYRES",
    "dropmalst": "PA",
    "dropmalzpp": 182319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709291565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19141",
    "droptype": "D",
    "dropname": "KELTON",
    "dropdeladd": "203 CORBY RD",
    "dropdelcty": "KELTON",
    "dropdelst": "PA",
    "dropdelzpp": 193469998,
    "dropphyadd": "203 CORBY RD",
    "dropphycty": "KELTON",
    "dropphyst": "PA",
    "dropphyzpp": 193469998,
    "dropmaladd": "203 CORBY RD",
    "dropmalcty": "KELTON",
    "dropmalst": "PA",
    "dropmalzpp": 193469998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108698803,
    "dropsitcph": 6108698803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19142",
    "droptype": "D",
    "dropname": "KEMBLESVILLE",
    "dropdeladd": "1 MUNICIPAL LN",
    "dropdelcty": "KEMBLESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193479998,
    "dropphyadd": "1 MUNICIPAL LN",
    "dropphycty": "KEMBLESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193479998,
    "dropmaladd": "1 MUNICIPAL LN",
    "dropmalcty": "KEMBLESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193479998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102554900,
    "dropsitcph": 6102554900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19143",
    "droptype": "D",
    "dropname": "KEMPTON",
    "dropdeladd": "3759 ROUTE 737",
    "dropdelcty": "KEMPTON",
    "dropdelst": "PA",
    "dropdelzpp": 195299998,
    "dropphyadd": "3759 ROUTE 737",
    "dropphycty": "KEMPTON",
    "dropphyst": "PA",
    "dropphyzpp": 195299998,
    "dropmaladd": "3759 ROUTE 737",
    "dropmalcty": "KEMPTON",
    "dropmalst": "PA",
    "dropmalzpp": 195299998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6107566180,
    "dropsitcph": 6107566180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19149",
    "droptype": "D",
    "dropname": "KENNERDELL",
    "dropdeladd": "240 MAIN ST",
    "dropdelcty": "KENNERDELL",
    "dropdelst": "PA",
    "dropdelzpp": 163749800,
    "dropphyadd": "240 MAIN ST",
    "dropphycty": "KENNERDELL",
    "dropphyst": "PA",
    "dropphyzpp": 163749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNERDELL",
    "dropmalst": "PA",
    "dropmalzpp": 163749998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143856584,
    "dropsitcph": 8143856584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19152",
    "droptype": "D",
    "dropname": "KENNETT SQUARE",
    "dropdeladd": "222 E STATE ST",
    "dropdelcty": "KENNETT SQUARE",
    "dropdelst": "PA",
    "dropdelzpp": 193489998,
    "dropphyadd": "222 E STATE ST",
    "dropphycty": "KENNETT SQUARE",
    "dropphyst": "PA",
    "dropphyzpp": 193489998,
    "dropmaladd": "222 E STATE ST",
    "dropmalcty": "KENNETT SQUARE",
    "dropmalst": "PA",
    "dropmalzpp": 193489998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109250659,
    "dropsitcph": 6109250659,
    "dropfax": 6104449809
  },
  {
    "dcode": "D",
    "dropkey": "PX19155",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "90 E JACKSON ST",
    "dropdelcty": "KENT",
    "dropdelst": "PA",
    "dropdelzpp": 157529998,
    "dropphyadd": "90 E JACKSON ST",
    "dropphycty": "KENT",
    "dropphyst": "PA",
    "dropphyzpp": 157529998,
    "dropmaladd": "90 E JACKSON ST",
    "dropmalcty": "KENT",
    "dropmalst": "PA",
    "dropmalzpp": 157529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247268856,
    "dropsitcph": 7247268856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19161",
    "droptype": "D",
    "dropname": "KERSEY",
    "dropdeladd": "377 MAIN ST",
    "dropdelcty": "KERSEY",
    "dropdelst": "PA",
    "dropdelzpp": 158469800,
    "dropphyadd": "377 MAIN ST",
    "dropphycty": "KERSEY",
    "dropphyst": "PA",
    "dropphyzpp": 158469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KERSEY",
    "dropmalst": "PA",
    "dropmalzpp": 158469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148856309,
    "dropsitcph": 8148856309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19167",
    "droptype": "D",
    "dropname": "KIMBERTON",
    "dropdeladd": "2102 KIMBERTON RD",
    "dropdelcty": "KIMBERTON",
    "dropdelst": "PA",
    "dropdelzpp": 194429912,
    "dropphyadd": "2102 KIMBERTON RD",
    "dropphycty": "KIMBERTON",
    "dropphyst": "PA",
    "dropphyzpp": 194429912,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIMBERTON",
    "dropmalst": "PA",
    "dropmalzpp": 194429998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109339533,
    "dropsitcph": 6109339533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19174",
    "droptype": "D",
    "dropname": "KINGSLEY",
    "dropdeladd": "9560 MAIN ST",
    "dropdelcty": "KINGSLEY",
    "dropdelst": "PA",
    "dropdelzpp": 188269998,
    "dropphyadd": "9560 MAIN ST",
    "dropphycty": "KINGSLEY",
    "dropphyst": "PA",
    "dropphyzpp": 188269998,
    "dropmaladd": "9560 MAIN ST",
    "dropmalcty": "KINGSLEY",
    "dropmalst": "PA",
    "dropmalzpp": 188269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702894970,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19179",
    "droptype": "D",
    "dropname": "KINTNERSVILLE",
    "dropdeladd": "9734 EASTON RD",
    "dropdelcty": "KINTNERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189309998,
    "dropphyadd": "9734 EASTON RD",
    "dropphycty": "KINTNERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189309998,
    "dropmaladd": "9734 EASTON RD",
    "dropmalcty": "KINTNERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189309998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109646414,
    "dropsitcph": 6108475800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19180",
    "droptype": "D",
    "dropname": "KINZERS",
    "dropdeladd": "3583 LINCOLN HWY E",
    "dropdelcty": "KINZERS",
    "dropdelst": "PA",
    "dropdelzpp": 175359998,
    "dropphyadd": "3583 LINCOLN HWY E",
    "dropphycty": "KINZERS",
    "dropphyst": "PA",
    "dropphyzpp": 175359998,
    "dropmaladd": "3583 LINCOLN HWY E",
    "dropmalcty": "KINZERS",
    "dropmalst": "PA",
    "dropmalzpp": 175359998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174424226,
    "dropsitcph": 7174424226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19182",
    "droptype": "D",
    "dropname": "KIRKWOOD",
    "dropdeladd": "1713 KIRKWOOD PIKE",
    "dropdelcty": "KIRKWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 175369998,
    "dropphyadd": "1713 KIRKWOOD PIKE",
    "dropphycty": "KIRKWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 175369998,
    "dropmaladd": "1713 KIRKWOOD PIKE",
    "dropmalcty": "KIRKWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 175369998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176135107,
    "dropsitcph": 7176135107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19187",
    "droptype": "D",
    "dropname": "KITTANNING",
    "dropdeladd": "201 N MCKEAN ST",
    "dropdelcty": "KITTANNING",
    "dropdelst": "PA",
    "dropdelzpp": 162011300,
    "dropphyadd": "201 N MCKEAN ST",
    "dropphycty": "KITTANNING",
    "dropphyst": "PA",
    "dropphyzpp": 162011300,
    "dropmaladd": "201 N MCKEAN ST",
    "dropmalcty": "KITTANNING",
    "dropmalst": "PA",
    "dropmalzpp": 162011300,
    "dropsitphn": 8148367307,
    "dropsitlph": 7245431959,
    "dropsitcph": 7245431959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19188",
    "droptype": "D",
    "dropname": "KLEINFELTERSVILLE",
    "dropdeladd": "2657 HEIDELBERG AVE",
    "dropdelcty": "KLEINFELTERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170399998,
    "dropphyadd": "2657 HEIDELBERG AVE",
    "dropphycty": "KLEINFELTERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170399998,
    "dropmaladd": "2657 HEIDELBERG AVE",
    "dropmalcty": "KLEINFELTERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170399998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179493919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19205",
    "droptype": "D",
    "dropname": "KNOX",
    "dropdeladd": "523 E RAILROAD ST",
    "dropdelcty": "KNOX",
    "dropdelst": "PA",
    "dropdelzpp": 162329800,
    "dropphyadd": "523 E RAILROAD ST",
    "dropphycty": "KNOX",
    "dropphyst": "PA",
    "dropphyzpp": 162329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KNOX",
    "dropmalst": "PA",
    "dropmalzpp": 162329998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147971541,
    "dropsitcph": 8147971541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19206",
    "droptype": "D",
    "dropname": "KNOX DALE",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "KNOX DALE",
    "dropdelst": "PA",
    "dropdelzpp": 158479800,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "KNOX DALE",
    "dropphyst": "PA",
    "dropphyzpp": 158479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KNOX DALE",
    "dropmalst": "PA",
    "dropmalzpp": 158479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148498258,
    "dropsitcph": 8148498258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19207",
    "droptype": "D",
    "dropname": "KNOXVILLE",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 169289800,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 169289800,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 169289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8143264176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19210",
    "droptype": "D",
    "dropname": "KOPPEL",
    "dropdeladd": "5502 5TH AVE",
    "dropdelcty": "KOPPEL",
    "dropdelst": "PA",
    "dropdelzpp": 161369800,
    "dropphyadd": "5502 5TH AVE",
    "dropphycty": "KOPPEL",
    "dropphyst": "PA",
    "dropphyzpp": 161369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOPPEL",
    "dropmalst": "PA",
    "dropmalzpp": 161369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7248438751,
    "dropsitcph": 7248438751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19212",
    "droptype": "D",
    "dropname": "KOSSUTH",
    "dropdeladd": "1787 ROUTE 322 STE 1",
    "dropdelcty": "KOSSUTH",
    "dropdelst": "PA",
    "dropdelzpp": 163319800,
    "dropphyadd": "1787 ROUTE 322 STE 1",
    "dropphycty": "KOSSUTH",
    "dropphyst": "PA",
    "dropphyzpp": 163319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOSSUTH",
    "dropmalst": "PA",
    "dropmalzpp": 163319998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147971868,
    "dropsitcph": 8147971868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19214",
    "droptype": "D",
    "dropname": "KREAMER",
    "dropdeladd": "515 KREAMER AVE",
    "dropdelcty": "KREAMER",
    "dropdelst": "PA",
    "dropdelzpp": 178339998,
    "dropphyadd": "515 KREAMER AVE",
    "dropphycty": "KREAMER",
    "dropphyst": "PA",
    "dropphyzpp": 178339998,
    "dropmaladd": "515 KREAMER AVE",
    "dropmalcty": "KREAMER",
    "dropmalst": "PA",
    "dropmalzpp": 178339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703741026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19215",
    "droptype": "D",
    "dropname": "KRESGEVILLE",
    "dropdeladd": "543 INTERCHANGE RD STE 103",
    "dropdelcty": "KRESGEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 183339998,
    "dropphyadd": "543 INTERCHANGE RD STE 103",
    "dropphycty": "KRESGEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 183339998,
    "dropmaladd": "543 INTERCHANGE RD STE 103",
    "dropmalcty": "KRESGEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 183339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6106816300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19221",
    "droptype": "D",
    "dropname": "KULPMONT",
    "dropdeladd": "901 CHESTNUT ST FRNT",
    "dropdelcty": "KULPMONT",
    "dropdelst": "PA",
    "dropdelzpp": 178349998,
    "dropphyadd": "901 CHESTNUT ST FRNT",
    "dropphycty": "KULPMONT",
    "dropphyst": "PA",
    "dropphyzpp": 178349998,
    "dropmaladd": "901 CHESTNUT ST FRNT",
    "dropmalcty": "KULPMONT",
    "dropmalst": "PA",
    "dropmalzpp": 178349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703731350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19223",
    "droptype": "D",
    "dropname": "KULPSVILLE",
    "dropdeladd": "1586 SUMNEYTOWN PIKE",
    "dropdelcty": "KULPSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194439991,
    "dropphyadd": "1586 SUMNEYTOWN PIKE",
    "dropphycty": "KULPSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194439991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KULPSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194439998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2153620668,
    "dropsitcph": 2153620668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19225",
    "droptype": "D",
    "dropname": "KUNKLETOWN",
    "dropdeladd": "490 KUNKLETOWN RD",
    "dropdelcty": "KUNKLETOWN",
    "dropdelst": "PA",
    "dropdelzpp": 180589998,
    "dropphyadd": "490 KUNKLETOWN RD",
    "dropphycty": "KUNKLETOWN",
    "dropphyst": "PA",
    "dropphyzpp": 180589998,
    "dropmaladd": "490 KUNKLETOWN RD",
    "dropmalcty": "KUNKLETOWN",
    "dropmalst": "PA",
    "dropmalzpp": 180589998,
    "dropsitphn": 6103813062,
    "dropsitlph": 6108823244,
    "dropsitcph": 6103813062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19227",
    "droptype": "D",
    "dropname": "KUTZTOWN",
    "dropdeladd": "235 GRIMLEY ST",
    "dropdelcty": "KUTZTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195309998,
    "dropphyadd": "235 GRIMLEY ST",
    "dropphycty": "KUTZTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195309998,
    "dropmaladd": "235 GRIMLEY ST",
    "dropmalcty": "KUTZTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195309998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106838331,
    "dropsitcph": 6106838331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19229",
    "droptype": "D",
    "dropname": "KYLERTOWN",
    "dropdeladd": "93 ROLLING STONE RD",
    "dropdelcty": "KYLERTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 168479998,
    "dropphyadd": "93 ROLLING STONE RD",
    "dropphycty": "KYLERTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 168479998,
    "dropmaladd": "93 ROLLING STONE RD",
    "dropmalcty": "KYLERTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 168479998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143456804,
    "dropsitcph": 8143456804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19231",
    "droptype": "D",
    "dropname": "LA BELLE",
    "dropdeladd": "1139 LABELLE RD",
    "dropdelcty": "LA BELLE",
    "dropdelst": "PA",
    "dropdelzpp": 154501012,
    "dropphyadd": "1139 LABELLE RD",
    "dropphycty": "LA BELLE",
    "dropphyst": "PA",
    "dropphyzpp": 154501012,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA BELLE",
    "dropmalst": "PA",
    "dropmalzpp": 154509998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247859671,
    "dropsitcph": 7247859671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19232",
    "droptype": "D",
    "dropname": "LA JOSE",
    "dropdeladd": "33 CECIL HURD HWY STE 1",
    "dropdelcty": "LA JOSE",
    "dropdelst": "PA",
    "dropdelzpp": 157539998,
    "dropphyadd": "33 CECIL HURD HWY STE 1",
    "dropphycty": "LA JOSE",
    "dropphyst": "PA",
    "dropphyzpp": 157539998,
    "dropmaladd": "33 CECIL HURD HWY STE 1",
    "dropmalcty": "LA JOSE",
    "dropmalst": "PA",
    "dropmalzpp": 157539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142778849,
    "dropsitcph": 8142778849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19233",
    "droptype": "D",
    "dropname": "LA PLUME",
    "dropdeladd": "2092 E LA PLUME RD",
    "dropdelcty": "LA PLUME",
    "dropdelst": "PA",
    "dropdelzpp": 184409998,
    "dropphyadd": "2092 E LA PLUME RD",
    "dropphycty": "LA PLUME",
    "dropphyst": "PA",
    "dropphyzpp": 184409998,
    "dropmaladd": "2092 E LA PLUME RD",
    "dropmalcty": "LA PLUME",
    "dropmalst": "PA",
    "dropmalzpp": 184409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709453310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19235",
    "droptype": "D",
    "dropname": "LACEYVILLE",
    "dropdeladd": "445 MAIN ST OFC",
    "dropdelcty": "LACEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 186239998,
    "dropphyadd": "445 MAIN ST OFC",
    "dropphycty": "LACEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 186239998,
    "dropmaladd": "445 MAIN ST OFC",
    "dropmalcty": "LACEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 186239998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708691437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19239",
    "droptype": "D",
    "dropname": "LACKAWAXEN",
    "dropdeladd": "178 SCENIC DR",
    "dropdelcty": "LACKAWAXEN",
    "dropdelst": "PA",
    "dropdelzpp": 184359998,
    "dropphyadd": "178 SCENIC DR",
    "dropphycty": "LACKAWAXEN",
    "dropphyst": "PA",
    "dropphyzpp": 184359998,
    "dropmaladd": "178 SCENIC DR",
    "dropmalcty": "LACKAWAXEN",
    "dropmalst": "PA",
    "dropmalzpp": 184359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706857352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19242",
    "droptype": "D",
    "dropname": "LAFAYETTE HILL",
    "dropdeladd": "446 GERMANTOWN PIKE",
    "dropdelcty": "LAFAYETTE HILL",
    "dropdelst": "PA",
    "dropdelzpp": 194449998,
    "dropphyadd": "446 GERMANTOWN PIKE",
    "dropphycty": "LAFAYETTE HILL",
    "dropphyst": "PA",
    "dropphyzpp": 194449998,
    "dropmaladd": "446 GERMANTOWN PIKE",
    "dropmalcty": "LAFAYETTE HILL",
    "dropmalst": "PA",
    "dropmalzpp": 194449998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6108348159,
    "dropsitcph": 6108348159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19246",
    "droptype": "D",
    "dropname": "LAHASKA",
    "dropdeladd": "168 PEDDLERS VLG",
    "dropdelcty": "LAHASKA",
    "dropdelst": "PA",
    "dropdelzpp": 189319998,
    "dropphyadd": "168 PEDDLERS VLG",
    "dropphycty": "LAHASKA",
    "dropphyst": "PA",
    "dropphyzpp": 189319998,
    "dropmaladd": "168 PEDDLERS VLG",
    "dropmalcty": "LAHASKA",
    "dropmalst": "PA",
    "dropmalzpp": 189319998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157948500,
    "dropsitcph": 2157948500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19247",
    "droptype": "D",
    "dropname": "LAIRDSVILLE",
    "dropdeladd": "6733 STATE ROUTE 118 OFC",
    "dropdelcty": "LAIRDSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177429998,
    "dropphyadd": "6733 STATE ROUTE 118 OFC",
    "dropphycty": "LAIRDSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177429998,
    "dropmaladd": "6733 STATE ROUTE 118 OFC",
    "dropmalcty": "LAIRDSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705842408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19248",
    "droptype": "D",
    "dropname": "LAKE ARIEL",
    "dropdeladd": "1446 LAKE ARIEL HWY",
    "dropdelcty": "LAKE ARIEL",
    "dropdelst": "PA",
    "dropdelzpp": 184369998,
    "dropphyadd": "1446 LAKE ARIEL HWY",
    "dropphycty": "LAKE ARIEL",
    "dropphyst": "PA",
    "dropphyzpp": 184369998,
    "dropmaladd": "1446 LAKE ARIEL HWY",
    "dropmalcty": "LAKE ARIEL",
    "dropmalst": "PA",
    "dropmalzpp": 184369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706985311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19250",
    "droptype": "D",
    "dropname": "LAKE COMO",
    "dropdeladd": "3177 CREAMTON DR",
    "dropdelcty": "LAKE COMO",
    "dropdelst": "PA",
    "dropdelzpp": 184379998,
    "dropphyadd": "3177 CREAMTON DR",
    "dropphycty": "LAKE COMO",
    "dropphyst": "PA",
    "dropphyzpp": 184379998,
    "dropmaladd": "3177 CREAMTON DR",
    "dropmalcty": "LAKE COMO",
    "dropmalst": "PA",
    "dropmalzpp": 184379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707982741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19251",
    "droptype": "D",
    "dropname": "LAKE HARMONY",
    "dropdeladd": "8 KIRK ST",
    "dropdelcty": "LAKE HARMONY",
    "dropdelst": "PA",
    "dropdelzpp": 186249998,
    "dropphyadd": "8 KIRK ST",
    "dropphycty": "LAKE HARMONY",
    "dropphyst": "PA",
    "dropphyzpp": 186249998,
    "dropmaladd": "8 KIRK ST",
    "dropmalcty": "LAKE HARMONY",
    "dropmalst": "PA",
    "dropmalzpp": 186249998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707228524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19254",
    "droptype": "D",
    "dropname": "LAKE WINOLA",
    "dropdeladd": "104 POST OFFICE LN",
    "dropdelcty": "LAKE WINOLA",
    "dropdelst": "PA",
    "dropdelzpp": 186259998,
    "dropphyadd": "104 POST OFFICE LN",
    "dropphycty": "LAKE WINOLA",
    "dropphyst": "PA",
    "dropphyzpp": 186259998,
    "dropmaladd": "104 POST OFFICE LN",
    "dropmalcty": "LAKE WINOLA",
    "dropmalst": "PA",
    "dropmalzpp": 186259998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703782822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19259",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "1436 CROSSTOWN HWY",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "PA",
    "dropdelzpp": 184399998,
    "dropphyadd": "1436 CROSSTOWN HWY",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "PA",
    "dropphyzpp": 184399998,
    "dropmaladd": "1436 CROSSTOWN HWY",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "PA",
    "dropmalzpp": 184399998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707982118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19260",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "5015 NITTANY VALLEY DR",
    "dropdelcty": "LAMAR",
    "dropdelst": "PA",
    "dropdelzpp": 168489998,
    "dropphyadd": "5015 NITTANY VALLEY DR",
    "dropphycty": "LAMAR",
    "dropphyst": "PA",
    "dropphyzpp": 168489998,
    "dropmaladd": "5015 NITTANY VALLEY DR",
    "dropmalcty": "LAMAR",
    "dropmalst": "PA",
    "dropmalzpp": 168489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 5707266263,
    "dropsitcph": 5707266263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19262",
    "droptype": "D",
    "dropname": "LAMARTINE",
    "dropdeladd": "1710 ROUTE 208",
    "dropdelcty": "LAMARTINE",
    "dropdelst": "PA",
    "dropdelzpp": 163759800,
    "dropphyadd": "1710 ROUTE 208",
    "dropphycty": "LAMARTINE",
    "dropphyst": "PA",
    "dropphyzpp": 163759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAMARTINE",
    "dropmalst": "PA",
    "dropmalzpp": 163759998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147972699,
    "dropsitcph": 8147972699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19266",
    "droptype": "D",
    "dropname": "LAMPETER",
    "dropdeladd": "1638 LAMPETER RD",
    "dropdelcty": "LAMPETER",
    "dropdelst": "PA",
    "dropdelzpp": 175379998,
    "dropphyadd": "1638 LAMPETER RD",
    "dropphycty": "LAMPETER",
    "dropphyst": "PA",
    "dropphyzpp": 175379998,
    "dropmaladd": "1638 LAMPETER RD",
    "dropmalcty": "LAMPETER",
    "dropmalst": "PA",
    "dropmalzpp": 175379998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174644031,
    "dropsitcph": 7174644031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19268",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "1400 HARRISBURG PIKE",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176049992,
    "dropphyadd": "1400 HARRISBURG PIKE",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176049992,
    "dropmaladd": "1301 MARSHALL AVE",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176019998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173966932,
    "dropsitcph": 7173966925,
    "dropfax": 7173966918
  },
  {
    "dcode": "D",
    "dropkey": "PX19271",
    "droptype": "D",
    "dropname": "LANDENBERG",
    "dropdeladd": "645 PENN GREEN RD",
    "dropdelcty": "LANDENBERG",
    "dropdelst": "PA",
    "dropdelzpp": 193509998,
    "dropphyadd": "645 PENN GREEN RD",
    "dropphycty": "LANDENBERG",
    "dropphyst": "PA",
    "dropphyzpp": 193509998,
    "dropmaladd": "645 PENN GREEN RD",
    "dropmalcty": "LANDENBERG",
    "dropmalst": "PA",
    "dropmalzpp": 193509998,
    "dropsitphn": 6102743543,
    "dropsitlph": 6102743543,
    "dropsitcph": 6102743543,
    "dropfax": 6102741560
  },
  {
    "dcode": "D",
    "dropkey": "PX19277",
    "droptype": "D",
    "dropname": "LANDISBURG",
    "dropdeladd": "101 N CARLISLE ST",
    "dropdelcty": "LANDISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170409998,
    "dropphyadd": "101 N CARLISLE ST",
    "dropphycty": "LANDISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170409998,
    "dropmaladd": "101 N CARLISLE ST",
    "dropmalcty": "LANDISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177893311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19278",
    "droptype": "D",
    "dropname": "LANDISVILLE",
    "dropdeladd": "241 ELIZABETH ST",
    "dropdelcty": "LANDISVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175389998,
    "dropphyadd": "241 ELIZABETH ST",
    "dropphycty": "LANDISVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175389998,
    "dropmaladd": "241 ELIZABETH ST",
    "dropmalcty": "LANDISVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175389998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7178988812,
    "dropsitcph": 7178988812,
    "dropfax": 7178981693
  },
  {
    "dcode": "D",
    "dropkey": "PX19281",
    "droptype": "D",
    "dropname": "LANESBORO",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "LANESBORO",
    "dropdelst": "PA",
    "dropdelzpp": 188279801,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "LANESBORO",
    "dropphyst": "PA",
    "dropphyzpp": 188279801,
    "dropmaladd": "408 MAIN ST",
    "dropmalcty": "LANESBORO",
    "dropmalst": "PA",
    "dropmalzpp": 188279801,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708534150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19283",
    "droptype": "D",
    "dropname": "LANGELOTH",
    "dropdeladd": "1450 LANGELOTH RD",
    "dropdelcty": "LANGELOTH",
    "dropdelst": "PA",
    "dropdelzpp": 150541001,
    "dropphyadd": "1450 LANGELOTH RD",
    "dropphycty": "LANGELOTH",
    "dropphyst": "PA",
    "dropphyzpp": 150541001,
    "dropmaladd": "1450 LANGELOTH RD",
    "dropmalcty": "LANGELOTH",
    "dropmalst": "PA",
    "dropmalzpp": 150541001,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249473888,
    "dropsitcph": 7249473888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19284",
    "droptype": "D",
    "dropname": "LANGHORNE",
    "dropdeladd": "980 WHEELER WAY",
    "dropdelcty": "LANGHORNE",
    "dropdelst": "PA",
    "dropdelzpp": 190479998,
    "dropphyadd": "980 WHEELER WAY",
    "dropphycty": "LANGHORNE",
    "dropphyst": "PA",
    "dropphyzpp": 190479998,
    "dropmaladd": "980 WHEELER WAY",
    "dropmalcty": "LANGHORNE",
    "dropmalst": "PA",
    "dropmalzpp": 190479998,
    "dropsitphn": 2157413796,
    "dropsitlph": 2157522560,
    "dropsitcph": 2157413796,
    "dropfax": 2157578327
  },
  {
    "dcode": "D",
    "dropkey": "PX19285",
    "droptype": "D",
    "dropname": "LANSDALE",
    "dropdeladd": "20 VINE ST",
    "dropdelcty": "LANSDALE",
    "dropdelst": "PA",
    "dropdelzpp": 194469998,
    "dropphyadd": "20 VINE ST",
    "dropphycty": "LANSDALE",
    "dropphyst": "PA",
    "dropphyzpp": 194469998,
    "dropmaladd": "20 VINE ST",
    "dropmalcty": "LANSDALE",
    "dropmalst": "PA",
    "dropmalzpp": 194469998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2154124983,
    "dropsitcph": 2154124983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19286",
    "droptype": "D",
    "dropname": "LANSDOWNE",
    "dropdeladd": "45 N UNION AVE",
    "dropdelcty": "LANSDOWNE",
    "dropdelst": "PA",
    "dropdelzpp": 190509998,
    "dropphyadd": "45 N UNION AVE",
    "dropphycty": "LANSDOWNE",
    "dropphyst": "PA",
    "dropphyzpp": 190509998,
    "dropmaladd": "45 N UNION AVE",
    "dropmalcty": "LANSDOWNE",
    "dropmalst": "PA",
    "dropmalzpp": 190509998,
    "dropsitphn": 6106227311,
    "dropsitlph": 6106239338,
    "dropsitcph": 6106227311,
    "dropfax": 6106238234
  },
  {
    "dcode": "D",
    "dropkey": "PX19287",
    "droptype": "D",
    "dropname": "LANSE",
    "dropdeladd": "977 MAPLE ST",
    "dropdelcty": "LANSE",
    "dropdelst": "PA",
    "dropdelzpp": 168499998,
    "dropphyadd": "977 MAPLE ST",
    "dropphycty": "LANSE",
    "dropphyst": "PA",
    "dropphyzpp": 168499998,
    "dropmaladd": "977 MAPLE ST",
    "dropmalcty": "LANSE",
    "dropmalst": "PA",
    "dropmalzpp": 168499998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143456741,
    "dropsitcph": 8143456741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19288",
    "droptype": "D",
    "dropname": "LANSFORD",
    "dropdeladd": "14 TUNNEL ST",
    "dropdelcty": "LANSFORD",
    "dropdelst": "PA",
    "dropdelzpp": 182329998,
    "dropphyadd": "14 TUNNEL ST",
    "dropphycty": "LANSFORD",
    "dropphyst": "PA",
    "dropphyzpp": 182329998,
    "dropmaladd": "14 TUNNEL ST",
    "dropmalcty": "LANSFORD",
    "dropmalst": "PA",
    "dropmalzpp": 182329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706452525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19290",
    "droptype": "D",
    "dropname": "LAPORTE",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "LAPORTE",
    "dropdelst": "PA",
    "dropdelzpp": 186269998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "LAPORTE",
    "dropphyst": "PA",
    "dropphyzpp": 186269998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "LAPORTE",
    "dropmalst": "PA",
    "dropmalzpp": 186269998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709465541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19293",
    "droptype": "D",
    "dropname": "LARIMER",
    "dropdeladd": "1370 BROWNSTOWN RD",
    "dropdelcty": "LARIMER",
    "dropdelst": "PA",
    "dropdelzpp": 156479998,
    "dropphyadd": "1370 BROWNSTOWN RD",
    "dropphycty": "LARIMER",
    "dropphyst": "PA",
    "dropphyzpp": 156479998,
    "dropmaladd": "1370 BROWNSTOWN RD",
    "dropmalcty": "LARIMER",
    "dropmalst": "PA",
    "dropmalzpp": 156479998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248631280,
    "dropsitcph": 7248631280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19301",
    "droptype": "D",
    "dropname": "LATROBE",
    "dropdeladd": "811 JEFFERSON ST",
    "dropdelcty": "LATROBE",
    "dropdelst": "PA",
    "dropdelzpp": 156509998,
    "dropphyadd": "811 JEFFERSON ST",
    "dropphycty": "LATROBE",
    "dropphyst": "PA",
    "dropphyzpp": 156509998,
    "dropmaladd": "811 JEFFERSON ST",
    "dropmalcty": "LATROBE",
    "dropmalst": "PA",
    "dropmalzpp": 156509998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245370892,
    "dropsitcph": 7245370892,
    "dropfax": 7245375406
  },
  {
    "dcode": "D",
    "dropkey": "PX19303",
    "droptype": "D",
    "dropname": "LATTIMER MINES",
    "dropdeladd": "850 LATTIMER RD",
    "dropdelcty": "LATTIMER MINES",
    "dropdelst": "PA",
    "dropdelzpp": 182349800,
    "dropphyadd": "850 LATTIMER RD",
    "dropphycty": "LATTIMER MINES",
    "dropphyst": "PA",
    "dropphyzpp": 182349800,
    "dropmaladd": "850 LATTIMER RD",
    "dropmalcty": "LATTIMER MINES",
    "dropmalst": "PA",
    "dropmalzpp": 182349800,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704559397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19306",
    "droptype": "D",
    "dropname": "LAUGHLINTOWN",
    "dropdeladd": "1392 ROUTE 30",
    "dropdelcty": "LAUGHLINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 156555001,
    "dropphyadd": "1392 ROUTE 30",
    "dropphycty": "LAUGHLINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 156555001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUGHLINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 156559998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242384560,
    "dropsitcph": 7242384560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19313",
    "droptype": "D",
    "dropname": "LAURELTON",
    "dropdeladd": "2495 LAUREL RD",
    "dropdelcty": "LAURELTON",
    "dropdelst": "PA",
    "dropdelzpp": 178359998,
    "dropphyadd": "2495 LAUREL RD",
    "dropphycty": "LAURELTON",
    "dropphyst": "PA",
    "dropphyzpp": 178359998,
    "dropmaladd": "2495 LAUREL RD",
    "dropmalcty": "LAURELTON",
    "dropmalst": "PA",
    "dropmalzpp": 178359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709221832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19316",
    "droptype": "D",
    "dropname": "LAURYS STATION",
    "dropdeladd": "1072 RISING SUN RD",
    "dropdelcty": "LAURYS STATION",
    "dropdelst": "PA",
    "dropdelzpp": 180599998,
    "dropphyadd": "1072 RISING SUN RD",
    "dropphycty": "LAURYS STATION",
    "dropphyst": "PA",
    "dropphyzpp": 180599998,
    "dropmaladd": "1072 RISING SUN RD",
    "dropmalcty": "LAURYS STATION",
    "dropmalst": "PA",
    "dropmalzpp": 180599998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102620589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19317",
    "droptype": "D",
    "dropname": "LAVELLE",
    "dropdeladd": "337 MAIN ST",
    "dropdelcty": "LAVELLE",
    "dropdelst": "PA",
    "dropdelzpp": 179439998,
    "dropphyadd": "337 MAIN ST",
    "dropphycty": "LAVELLE",
    "dropphyst": "PA",
    "dropphyzpp": 179439998,
    "dropmaladd": "337 MAIN ST",
    "dropmalcty": "LAVELLE",
    "dropmalst": "PA",
    "dropmalzpp": 179439998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708751144,
    "dropsitcph": 5708751144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19319",
    "droptype": "D",
    "dropname": "LAWN",
    "dropdeladd": "5575 ELIZABETHTOWN RD",
    "dropdelcty": "LAWN",
    "dropdelst": "PA",
    "dropdelzpp": 170419998,
    "dropphyadd": "5575 ELIZABETHTOWN RD",
    "dropphycty": "LAWN",
    "dropphyst": "PA",
    "dropphyzpp": 170419998,
    "dropmaladd": "5575 ELIZABETHTOWN RD",
    "dropmalcty": "LAWN",
    "dropmalst": "PA",
    "dropmalzpp": 170419998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179643783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19324",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "18 SCHOOL ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "PA",
    "dropdelzpp": 150551002,
    "dropphyadd": "18 SCHOOL ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "PA",
    "dropphyzpp": 150551002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "PA",
    "dropmalzpp": 150559998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249413360,
    "dropsitcph": 7249413360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19327",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 169299998,
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 169299998,
    "dropmaladd": "60 MAIN ST",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 169299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 5708272472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19328",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "10727 STATE ROUTE 267 OFC",
    "dropdelcty": "LAWTON",
    "dropdelst": "PA",
    "dropdelzpp": 188289998,
    "dropphyadd": "10727 STATE ROUTE 267 OFC",
    "dropphycty": "LAWTON",
    "dropphyst": "PA",
    "dropphyzpp": 188289998,
    "dropmaladd": "10727 STATE ROUTE 267 OFC",
    "dropmalcty": "LAWTON",
    "dropmalst": "PA",
    "dropmalzpp": 188289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709342143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19331",
    "droptype": "D",
    "dropname": "LE RAYSVILLE",
    "dropdeladd": "981 MAIN ST",
    "dropdelcty": "LE RAYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 188299998,
    "dropphyadd": "981 MAIN ST",
    "dropphycty": "LE RAYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 188299998,
    "dropmaladd": "981 MAIN ST",
    "dropmalcty": "LE RAYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 188299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707442591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19340",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "101 S 8TH ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "PA",
    "dropdelzpp": 170429998,
    "dropphyadd": "101 S 8TH ST",
    "dropphycty": "LEBANON",
    "dropphyst": "PA",
    "dropphyzpp": 170429998,
    "dropmaladd": "101 S 8TH ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "PA",
    "dropmalzpp": 170429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172742595,
    "dropfax": 7172280186
  },
  {
    "dcode": "D",
    "dropkey": "PX19344",
    "droptype": "D",
    "dropname": "LECKRONE",
    "dropdeladd": "348 LECKRONE HIGH HOUSE RD",
    "dropdelcty": "LECKRONE",
    "dropdelst": "PA",
    "dropdelzpp": 154541001,
    "dropphyadd": "348 LECKRONE HIGH HOUSE RD",
    "dropphycty": "LECKRONE",
    "dropphyst": "PA",
    "dropphyzpp": 154541001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LECKRONE",
    "dropmalst": "PA",
    "dropmalzpp": 154549998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247372290,
    "dropsitcph": 7247372290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19346",
    "droptype": "D",
    "dropname": "LEDERACH",
    "dropdeladd": "690 HARLEYSVILLE PIKE",
    "dropdelcty": "LEDERACH",
    "dropdelst": "PA",
    "dropdelzpp": 194509903,
    "dropphyadd": "690 HARLEYSVILLE PIKE",
    "dropphycty": "LEDERACH",
    "dropphyst": "PA",
    "dropphyzpp": 194509903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEDERACH",
    "dropmalst": "PA",
    "dropmalzpp": 194509998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152569010,
    "dropsitcph": 2152569010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19348",
    "droptype": "D",
    "dropname": "LEECHBURG",
    "dropdeladd": "23 MAIN ST",
    "dropdelcty": "LEECHBURG",
    "dropdelst": "PA",
    "dropdelzpp": 156569998,
    "dropphyadd": "23 MAIN ST",
    "dropphycty": "LEECHBURG",
    "dropphyst": "PA",
    "dropphyzpp": 156569998,
    "dropmaladd": "23 MAIN ST",
    "dropmalcty": "LEECHBURG",
    "dropmalst": "PA",
    "dropmalzpp": 156569998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248457203,
    "dropsitcph": 7248457203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19349",
    "droptype": "D",
    "dropname": "LEEPER",
    "dropdeladd": "6815 ROUTE 36",
    "dropdelcty": "LEEPER",
    "dropdelst": "PA",
    "dropdelzpp": 162339800,
    "dropphyadd": "6815 ROUTE 36",
    "dropphycty": "LEEPER",
    "dropphyst": "PA",
    "dropphyzpp": 162339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEEPER",
    "dropmalst": "PA",
    "dropmalzpp": 162339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147449618,
    "dropsitcph": 8147449618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19351",
    "droptype": "D",
    "dropname": "LEESPORT",
    "dropdeladd": "4 E WALL ST",
    "dropdelcty": "LEESPORT",
    "dropdelst": "PA",
    "dropdelzpp": 195339998,
    "dropphyadd": "4 E WALL ST",
    "dropphycty": "LEESPORT",
    "dropphyst": "PA",
    "dropphyzpp": 195339998,
    "dropmaladd": "4 E WALL ST",
    "dropmalcty": "LEESPORT",
    "dropmalst": "PA",
    "dropmalzpp": 195339998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109264326,
    "dropsitcph": 6109264326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19353",
    "droptype": "D",
    "dropname": "LEETSDALE",
    "dropdeladd": "18 QUAKER VILLAGE SHOPPING CTR",
    "dropdelcty": "LEETSDALE",
    "dropdelst": "PA",
    "dropdelzpp": 150569998,
    "dropphyadd": "18 QUAKER VILLAGE SHOPPING CTR",
    "dropphycty": "LEETSDALE",
    "dropphyst": "PA",
    "dropphyzpp": 150569998,
    "dropmaladd": "18 QUAKER VILLAGE SHOPPING CTR",
    "dropmalcty": "LEETSDALE",
    "dropmalst": "PA",
    "dropmalzpp": 150569998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4127414940,
    "dropsitcph": 4127414940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19356",
    "droptype": "D",
    "dropname": "LEHIGH VALLEY",
    "dropdeladd": "17 S COMMERCE WAY",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180179182,
    "dropphyadd": "17 S COMMERCE WAY",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180179182,
    "dropmaladd": "17 S COMMERCE WAY",
    "dropmalcty": "LEHIGH VALLEY",
    "dropmalst": "PA",
    "dropmalzpp": 180029000,
    "dropsitphn": 6108823244,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108823209,
    "dropfax": 6108823297
  },
  {
    "dcode": "D",
    "dropkey": "PX19359",
    "droptype": "D",
    "dropname": "LEHIGHTON",
    "dropdeladd": "118 NORTH ST",
    "dropdelcty": "LEHIGHTON",
    "dropdelst": "PA",
    "dropdelzpp": 182359998,
    "dropphyadd": "118 NORTH ST",
    "dropphycty": "LEHIGHTON",
    "dropphyst": "PA",
    "dropphyzpp": 182359998,
    "dropmaladd": "118 NORTH ST",
    "dropmalcty": "LEHIGHTON",
    "dropmalst": "PA",
    "dropmalzpp": 182359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 6103774470,
    "dropfax": 6103770697
  },
  {
    "dcode": "D",
    "dropkey": "PX19360",
    "droptype": "D",
    "dropname": "LEHMAN",
    "dropdeladd": "1010 MOUNTAINVIEW DR",
    "dropdelcty": "LEHMAN",
    "dropdelst": "PA",
    "dropdelzpp": 186279998,
    "dropphyadd": "1010 MOUNTAINVIEW DR",
    "dropphycty": "LEHMAN",
    "dropphyst": "PA",
    "dropphyzpp": 186279998,
    "dropmaladd": "1010 MOUNTAINVIEW DR",
    "dropmalcty": "LEHMAN",
    "dropmalst": "PA",
    "dropmalzpp": 186279998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5706754561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19363",
    "droptype": "D",
    "dropname": "LEISENRING",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "LEISENRING",
    "dropdelst": "PA",
    "dropdelzpp": 154551111,
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "LEISENRING",
    "dropphyst": "PA",
    "dropphyzpp": 154551111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEISENRING",
    "dropmalst": "PA",
    "dropmalzpp": 154559998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246281422,
    "dropsitcph": 7246281422,
    "dropfax": 7246281422
  },
  {
    "dcode": "D",
    "dropkey": "PX19364",
    "droptype": "D",
    "dropname": "LEMASTERS",
    "dropdeladd": "4729 STEELE AVE",
    "dropdelcty": "LEMASTERS",
    "dropdelst": "PA",
    "dropdelzpp": 172319800,
    "dropphyadd": "4729 STEELE AVE",
    "dropphycty": "LEMASTERS",
    "dropphyst": "PA",
    "dropphyzpp": 172319800,
    "dropmaladd": "4729 STEELE AVE",
    "dropmalcty": "LEMASTERS",
    "dropmalst": "PA",
    "dropmalzpp": 172319800,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173282442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19365",
    "droptype": "D",
    "dropname": "LEMONT",
    "dropdeladd": "141 MARY ST",
    "dropdelcty": "LEMONT",
    "dropdelst": "PA",
    "dropdelzpp": 168519998,
    "dropphyadd": "141 MARY ST",
    "dropphycty": "LEMONT",
    "dropphyst": "PA",
    "dropphyzpp": 168519998,
    "dropmaladd": "141 MARY ST",
    "dropmalcty": "LEMONT",
    "dropmalst": "PA",
    "dropmalzpp": 168519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142383965,
    "dropsitcph": 8142383965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19368",
    "droptype": "D",
    "dropname": "LEMONT FURNACE",
    "dropdeladd": "265 STARLITE RD",
    "dropdelcty": "LEMONT FURNACE",
    "dropdelst": "PA",
    "dropdelzpp": 154561161,
    "dropphyadd": "265 STARLITE RD",
    "dropphycty": "LEMONT FURNACE",
    "dropphyst": "PA",
    "dropphyzpp": 154561161,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEMONT FURNACE",
    "dropmalst": "PA",
    "dropmalzpp": 154569998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244153185,
    "dropsitcph": 7244153185,
    "dropfax": 7244153194
  },
  {
    "dcode": "D",
    "dropkey": "PX19369",
    "droptype": "D",
    "dropname": "LEMOYNE",
    "dropdeladd": "333 MARKET ST",
    "dropdelcty": "LEMOYNE",
    "dropdelst": "PA",
    "dropdelzpp": 170439998,
    "dropphyadd": "333 MARKET ST",
    "dropphycty": "LEMOYNE",
    "dropphyst": "PA",
    "dropphyzpp": 170439998,
    "dropmaladd": "333 MARKET ST",
    "dropmalcty": "LEMOYNE",
    "dropmalst": "PA",
    "dropmalzpp": 170439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177374129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19371",
    "droptype": "D",
    "dropname": "LENHARTSVILLE",
    "dropdeladd": "83 PENN ST",
    "dropdelcty": "LENHARTSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195349998,
    "dropphyadd": "83 PENN ST",
    "dropphycty": "LENHARTSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195349998,
    "dropmaladd": "83 PENN ST",
    "dropmalcty": "LENHARTSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195349998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6105625076,
    "dropsitcph": 6105625076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19376",
    "droptype": "D",
    "dropname": "LENNI",
    "dropdeladd": "417 LENNI RD",
    "dropdelcty": "LENNI",
    "dropdelst": "PA",
    "dropdelzpp": 190529900,
    "dropphyadd": "417 LENNI RD",
    "dropphycty": "LENNI",
    "dropphyst": "PA",
    "dropphyzpp": 190529900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LENNI",
    "dropmalst": "PA",
    "dropmalzpp": 190529998,
    "dropsitphn": 6104599679,
    "dropsitlph": 6104599679,
    "dropsitcph": 6104599679,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "PX19380",
    "droptype": "D",
    "dropname": "LEOLA",
    "dropdeladd": "10 E MAIN ST",
    "dropdelcty": "LEOLA",
    "dropdelst": "PA",
    "dropdelzpp": 175409998,
    "dropphyadd": "10 E MAIN ST",
    "dropphycty": "LEOLA",
    "dropphyst": "PA",
    "dropphyzpp": 175409998,
    "dropmaladd": "10 E MAIN ST",
    "dropmalcty": "LEOLA",
    "dropmalst": "PA",
    "dropmalzpp": 175409998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176562401,
    "dropsitcph": 7176562401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19391",
    "droptype": "D",
    "dropname": "LEVITTOWN",
    "dropdeladd": "7200 NEW FALLS RD",
    "dropdelcty": "LEVITTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190559998,
    "dropphyadd": "7200 NEW FALLS RD",
    "dropphycty": "LEVITTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190559998,
    "dropmaladd": "7200 NEW FALLS RD",
    "dropmalcty": "LEVITTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190559998,
    "dropsitphn": 2159494615,
    "dropsitlph": 2159491777,
    "dropsitcph": 2159494615,
    "dropfax": 2159491476
  },
  {
    "dcode": "D",
    "dropkey": "PX19395",
    "droptype": "D",
    "dropname": "LEWIS RUN",
    "dropdeladd": "59 MAIN ST",
    "dropdelcty": "LEWIS RUN",
    "dropdelst": "PA",
    "dropdelzpp": 167389800,
    "dropphyadd": "59 MAIN ST",
    "dropphycty": "LEWIS RUN",
    "dropphyst": "PA",
    "dropphyzpp": 167389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWIS RUN",
    "dropmalst": "PA",
    "dropmalzpp": 167389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143683508,
    "dropsitcph": 8143683508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19396",
    "droptype": "D",
    "dropname": "LEWISBERRY",
    "dropdeladd": "408 MARKET ST",
    "dropdelcty": "LEWISBERRY",
    "dropdelst": "PA",
    "dropdelzpp": 173399998,
    "dropphyadd": "408 MARKET ST",
    "dropphycty": "LEWISBERRY",
    "dropphyst": "PA",
    "dropphyzpp": 173399998,
    "dropmaladd": "408 MARKET ST",
    "dropmalcty": "LEWISBERRY",
    "dropmalst": "PA",
    "dropmalzpp": 173399998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179386690,
    "dropsitcph": 7179386690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19397",
    "droptype": "D",
    "dropname": "LEWISBURG",
    "dropdeladd": "301 MARKET ST",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178371549,
    "dropphyadd": "301 MARKET ST",
    "dropphycty": "LEWISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178371549,
    "dropmaladd": "301 MARKET ST",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178371549,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705240835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19398",
    "droptype": "D",
    "dropname": "LEWISTOWN",
    "dropdeladd": "100 W MARKET ST",
    "dropdelcty": "LEWISTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170449998,
    "dropphyadd": "100 W MARKET ST",
    "dropphycty": "LEWISTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170449998,
    "dropmaladd": "100 W MARKET ST",
    "dropmalcty": "LEWISTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172488312,
    "dropfax": 7172487036
  },
  {
    "dcode": "D",
    "dropkey": "PX19401",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "950 CHESTERVILLE RD",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 193519900,
    "dropphyadd": "950 CHESTERVILLE RD",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 193519900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 193519998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102554424,
    "dropsitcph": 6102554424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19405",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "4514 WILLIAMSON TRL",
    "dropdelcty": "LIBERTY",
    "dropdelst": "PA",
    "dropdelzpp": 169309998,
    "dropphyadd": "4514 WILLIAMSON TRL",
    "dropphycty": "LIBERTY",
    "dropphyst": "PA",
    "dropphyzpp": 169309998,
    "dropmaladd": "4514 WILLIAMSON TRL",
    "dropmalcty": "LIBERTY",
    "dropmalst": "PA",
    "dropmalzpp": 169309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703242803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19408",
    "droptype": "D",
    "dropname": "SOUTH PARK",
    "dropdeladd": "2560 BROWNSVILLE RD",
    "dropdelcty": "SOUTH PARK",
    "dropdelst": "PA",
    "dropdelzpp": 151299998,
    "dropphyadd": "2560 BROWNSVILLE RD",
    "dropphycty": "SOUTH PARK",
    "dropphyst": "PA",
    "dropphyzpp": 151299998,
    "dropmaladd": "2560 BROWNSVILLE RD",
    "dropmalcty": "SOUTH PARK",
    "dropmalst": "PA",
    "dropmalzpp": 151299998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4128350408,
    "dropsitcph": 4128350408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19413",
    "droptype": "D",
    "dropname": "LIGONIER",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "LIGONIER",
    "dropdelst": "PA",
    "dropdelzpp": 156589998,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "LIGONIER",
    "dropphyst": "PA",
    "dropphyzpp": 156589998,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "LIGONIER",
    "dropmalst": "PA",
    "dropmalzpp": 156589998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242386396,
    "dropsitcph": 7242386396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19414",
    "droptype": "D",
    "dropname": "LILLY",
    "dropdeladd": "513 CLEVELAND ST",
    "dropdelcty": "LILLY",
    "dropdelst": "PA",
    "dropdelzpp": 159389998,
    "dropphyadd": "513 CLEVELAND ST",
    "dropphycty": "LILLY",
    "dropphyst": "PA",
    "dropphyzpp": 159389998,
    "dropmaladd": "513 CLEVELAND ST",
    "dropmalcty": "LILLY",
    "dropmalst": "PA",
    "dropmalzpp": 159389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148867518,
    "dropsitcph": 8148867518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19419",
    "droptype": "D",
    "dropname": "LIMEKILN",
    "dropdeladd": "820 LIMEKILN RD",
    "dropdelcty": "LIMEKILN",
    "dropdelst": "PA",
    "dropdelzpp": 195359998,
    "dropphyadd": "820 LIMEKILN RD",
    "dropphycty": "LIMEKILN",
    "dropphyst": "PA",
    "dropphyzpp": 195359998,
    "dropmaladd": "820 LIMEKILN RD",
    "dropmalcty": "LIMEKILN",
    "dropmalst": "PA",
    "dropmalzpp": 195359998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106894404,
    "dropsitcph": 6106894404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19420",
    "droptype": "D",
    "dropname": "LIMEPORT",
    "dropdeladd": "1540 BLUE CHURCH RD",
    "dropdelcty": "LIMEPORT",
    "dropdelst": "PA",
    "dropdelzpp": 180609998,
    "dropphyadd": "1540 BLUE CHURCH RD",
    "dropphycty": "LIMEPORT",
    "dropphyst": "PA",
    "dropphyzpp": 180609998,
    "dropmaladd": "1540 BLUE CHURCH RD",
    "dropmalcty": "LIMEPORT",
    "dropmalst": "PA",
    "dropmalzpp": 180609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6109672251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19424",
    "droptype": "D",
    "dropname": "LIMESTONE",
    "dropdeladd": "97 LIMESTONE RD",
    "dropdelcty": "LIMESTONE",
    "dropdelst": "PA",
    "dropdelzpp": 162349800,
    "dropphyadd": "97 LIMESTONE RD",
    "dropphycty": "LIMESTONE",
    "dropphyst": "PA",
    "dropphyzpp": 162349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIMESTONE",
    "dropmalst": "PA",
    "dropmalzpp": 162349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147645633,
    "dropsitcph": 8147645633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19434",
    "droptype": "D",
    "dropname": "LINCOLN UNIVERSITY",
    "dropdeladd": "301 ASHMUN AVE",
    "dropdelcty": "LINCOLN UNIVERSITY",
    "dropdelst": "PA",
    "dropdelzpp": 193529998,
    "dropphyadd": "301 ASHMUN AVE",
    "dropphycty": "LINCOLN UNIVERSITY",
    "dropphyst": "PA",
    "dropphyzpp": 193529998,
    "dropmaladd": "301 ASHMUN AVE",
    "dropmalcty": "LINCOLN UNIVERSITY",
    "dropmalst": "PA",
    "dropmalzpp": 193529998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109981235,
    "dropsitcph": 6109981235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19435",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "224 FRONT ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "PA",
    "dropdelzpp": 177449998,
    "dropphyadd": "224 FRONT ST",
    "dropphycty": "LINDEN",
    "dropphyst": "PA",
    "dropphyzpp": 177449998,
    "dropmaladd": "224 FRONT ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "PA",
    "dropmalzpp": 177449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703233041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19437",
    "droptype": "D",
    "dropname": "LINE LEXINGTON",
    "dropdeladd": "4683 COUNTY LINE RD",
    "dropdelcty": "LINE LEXINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 189329998,
    "dropphyadd": "4683 COUNTY LINE RD",
    "dropphycty": "LINE LEXINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 189329998,
    "dropmaladd": "4683 COUNTY LINE RD",
    "dropmalcty": "LINE LEXINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 189329998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158221611,
    "dropsitcph": 2158221611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19439",
    "droptype": "D",
    "dropname": "LINESVILLE",
    "dropdeladd": "141 W ERIE ST",
    "dropdelcty": "LINESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 164249800,
    "dropphyadd": "141 W ERIE ST",
    "dropphycty": "LINESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 164249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 164249998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146835781,
    "dropsitcph": 8146835781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19451",
    "droptype": "D",
    "dropname": "LITITZ",
    "dropdeladd": "74 E MAIN ST",
    "dropdelcty": "LITITZ",
    "dropdelst": "PA",
    "dropdelzpp": 175439998,
    "dropphyadd": "74 E MAIN ST",
    "dropphycty": "LITITZ",
    "dropphyst": "PA",
    "dropphyzpp": 175439998,
    "dropmaladd": "74 E MAIN ST",
    "dropmalcty": "LITITZ",
    "dropmalst": "PA",
    "dropmalzpp": 175439998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176262329,
    "dropsitcph": 7176262329,
    "dropfax": 7176264102
  },
  {
    "dcode": "D",
    "dropkey": "PX19458",
    "droptype": "D",
    "dropname": "LITTLE MEADOWS",
    "dropdeladd": "1033 MAPLE ST STE 2",
    "dropdelcty": "LITTLE MEADOWS",
    "dropdelst": "PA",
    "dropdelzpp": 188309998,
    "dropphyadd": "1033 MAPLE ST STE 2",
    "dropphycty": "LITTLE MEADOWS",
    "dropphyst": "PA",
    "dropphyzpp": 188309998,
    "dropmaladd": "1033 MAPLE ST STE 2",
    "dropmalcty": "LITTLE MEADOWS",
    "dropmalst": "PA",
    "dropmalzpp": 188309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5706232159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19460",
    "droptype": "D",
    "dropname": "LITTLESTOWN",
    "dropdeladd": "24 W KING ST",
    "dropdelcty": "LITTLESTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173409998,
    "dropphyadd": "24 W KING ST",
    "dropphycty": "LITTLESTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173409998,
    "dropmaladd": "24 W KING ST",
    "dropmalcty": "LITTLESTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173409998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173594427,
    "dropsitcph": 7173594427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19461",
    "droptype": "D",
    "dropname": "LIVERPOOL",
    "dropdeladd": "102 RACE ST",
    "dropdelcty": "LIVERPOOL",
    "dropdelst": "PA",
    "dropdelzpp": 170459998,
    "dropphyadd": "102 RACE ST",
    "dropphycty": "LIVERPOOL",
    "dropphyst": "PA",
    "dropphyzpp": 170459998,
    "dropmaladd": "102 RACE ST",
    "dropmalcty": "LIVERPOOL",
    "dropmalst": "PA",
    "dropmalzpp": 170459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174443900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19467",
    "droptype": "D",
    "dropname": "LLEWELLYN",
    "dropdeladd": "9 SILVERTON RD",
    "dropdelcty": "LLEWELLYN",
    "dropdelst": "PA",
    "dropdelzpp": 179449998,
    "dropphyadd": "9 SILVERTON RD",
    "dropphycty": "LLEWELLYN",
    "dropphyst": "PA",
    "dropphyzpp": 179449998,
    "dropmaladd": "9 SILVERTON RD",
    "dropmalcty": "LLEWELLYN",
    "dropmalst": "PA",
    "dropmalzpp": 179449998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5705446377,
    "dropsitcph": 5705446377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19471",
    "droptype": "D",
    "dropname": "LOCK HAVEN",
    "dropdeladd": "15 W MAIN ST",
    "dropdelcty": "LOCK HAVEN",
    "dropdelst": "PA",
    "dropdelzpp": 177459998,
    "dropphyadd": "15 W MAIN ST",
    "dropphycty": "LOCK HAVEN",
    "dropphyst": "PA",
    "dropphyzpp": 177459998,
    "dropmaladd": "15 W MAIN ST",
    "dropmalcty": "LOCK HAVEN",
    "dropmalst": "PA",
    "dropmalzpp": 177459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707488055,
    "dropfax": 5707485961
  },
  {
    "dcode": "D",
    "dropkey": "PX19480",
    "droptype": "D",
    "dropname": "LOCUSTDALE",
    "dropdeladd": "3115 MAIN ST",
    "dropdelcty": "LOCUSTDALE",
    "dropdelst": "PA",
    "dropdelzpp": 179459998,
    "dropphyadd": "3115 MAIN ST",
    "dropphycty": "LOCUSTDALE",
    "dropphyst": "PA",
    "dropphyzpp": 179459998,
    "dropmaladd": "3115 MAIN ST",
    "dropmalcty": "LOCUSTDALE",
    "dropmalst": "PA",
    "dropmalzpp": 179459998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5708750115,
    "dropsitcph": 5708750115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19486",
    "droptype": "D",
    "dropname": "LOGANTON",
    "dropdeladd": "83 W MAIN ST",
    "dropdelcty": "LOGANTON",
    "dropdelst": "PA",
    "dropdelzpp": 177479998,
    "dropphyadd": "83 W MAIN ST",
    "dropphycty": "LOGANTON",
    "dropphyst": "PA",
    "dropphyzpp": 177479998,
    "dropmaladd": "83 W MAIN ST",
    "dropmalcty": "LOGANTON",
    "dropmalst": "PA",
    "dropmalzpp": 177479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5705086505,
    "dropsitcph": 5705086505,
    "dropfax": 5705086434
  },
  {
    "dcode": "D",
    "dropkey": "PX19487",
    "droptype": "D",
    "dropname": "LOGANVILLE",
    "dropdeladd": "107 W ORE ST",
    "dropdelcty": "LOGANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 173429998,
    "dropphyadd": "107 W ORE ST",
    "dropphycty": "LOGANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 173429998,
    "dropmaladd": "107 W ORE ST",
    "dropmalcty": "LOGANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 173429998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174282293,
    "dropsitcph": 7174282293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19491",
    "droptype": "D",
    "dropname": "LONG POND",
    "dropdeladd": "1557 LONG POND RD",
    "dropdelcty": "LONG POND",
    "dropdelst": "PA",
    "dropdelzpp": 183349998,
    "dropphyadd": "1557 LONG POND RD",
    "dropphycty": "LONG POND",
    "dropphyst": "PA",
    "dropphyzpp": 183349998,
    "dropmaladd": "1557 LONG POND RD",
    "dropmalcty": "LONG POND",
    "dropmalst": "PA",
    "dropmalzpp": 183349998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5706467704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19498",
    "droptype": "D",
    "dropname": "LOPEZ",
    "dropdeladd": "61 MAIN ST",
    "dropdelcty": "LOPEZ",
    "dropdelst": "PA",
    "dropdelzpp": 186289998,
    "dropphyadd": "61 MAIN ST",
    "dropphycty": "LOPEZ",
    "dropphyst": "PA",
    "dropphyzpp": 186289998,
    "dropmaladd": "61 MAIN ST",
    "dropmalcty": "LOPEZ",
    "dropmalst": "PA",
    "dropmalzpp": 186289998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709288001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19503",
    "droptype": "D",
    "dropname": "LORETTO",
    "dropdeladd": "245 SAINT MARY ST",
    "dropdelcty": "LORETTO",
    "dropdelst": "PA",
    "dropdelzpp": 159409998,
    "dropphyadd": "245 SAINT MARY ST",
    "dropphycty": "LORETTO",
    "dropphyst": "PA",
    "dropphyzpp": 159409998,
    "dropmaladd": "245 SAINT MARY ST",
    "dropmalcty": "LORETTO",
    "dropmalst": "PA",
    "dropmalzpp": 159409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144729717,
    "dropsitcph": 8144729717,
    "dropfax": 8144195102
  },
  {
    "dcode": "D",
    "dropkey": "PX19504",
    "droptype": "D",
    "dropname": "LOST CREEK",
    "dropdeladd": "43 CONVENT RD",
    "dropdelcty": "LOST CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 179469998,
    "dropphyadd": "43 CONVENT RD",
    "dropphycty": "LOST CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 179469998,
    "dropmaladd": "43 CONVENT RD",
    "dropmalcty": "LOST CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 179469998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5703932398,
    "dropsitcph": 5703932398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19519",
    "droptype": "D",
    "dropname": "LOYALHANNA",
    "dropdeladd": "1302 LATROBE DERRY RD",
    "dropdelcty": "LOYALHANNA",
    "dropdelst": "PA",
    "dropdelzpp": 156611030,
    "dropphyadd": "1302 LATROBE DERRY RD",
    "dropphycty": "LOYALHANNA",
    "dropphyst": "PA",
    "dropphyzpp": 156611030,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOYALHANNA",
    "dropmalst": "PA",
    "dropmalzpp": 156619998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245393934,
    "dropsitcph": 7245393934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19524",
    "droptype": "D",
    "dropname": "LOYSVILLE",
    "dropdeladd": "3555 SHERMANS VALLEY RD",
    "dropdelcty": "LOYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170479998,
    "dropphyadd": "3555 SHERMANS VALLEY RD",
    "dropphycty": "LOYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170479998,
    "dropmaladd": "3555 SHERMANS VALLEY RD",
    "dropmalcty": "LOYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173239659,
    "dropsitcph": 7173239648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19526",
    "droptype": "D",
    "dropname": "LUCERNEMINES",
    "dropdeladd": "161 6TH ST",
    "dropdelcty": "LUCERNEMINES",
    "dropdelst": "PA",
    "dropdelzpp": 157549998,
    "dropphyadd": "161 6TH ST",
    "dropphycty": "LUCERNEMINES",
    "dropphyst": "PA",
    "dropphyzpp": 157549998,
    "dropmaladd": "161 6TH ST",
    "dropmalcty": "LUCERNEMINES",
    "dropmalst": "PA",
    "dropmalzpp": 157549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7244793010,
    "dropsitcph": 7244793010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19527",
    "droptype": "D",
    "dropname": "LUCINDA",
    "dropdeladd": "454 MAPLE DR",
    "dropdelcty": "LUCINDA",
    "dropdelst": "PA",
    "dropdelzpp": 162359800,
    "dropphyadd": "454 MAPLE DR",
    "dropphycty": "LUCINDA",
    "dropphyst": "PA",
    "dropphyzpp": 162359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCINDA",
    "dropmalst": "PA",
    "dropmalzpp": 162359998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142269190,
    "dropsitcph": 8142269190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19531",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "1 LINCOLN AVE",
    "dropdelcty": "LUDLOW",
    "dropdelst": "PA",
    "dropdelzpp": 163339800,
    "dropphyadd": "1 LINCOLN AVE",
    "dropphycty": "LUDLOW",
    "dropphyst": "PA",
    "dropphyzpp": 163339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUDLOW",
    "dropmalst": "PA",
    "dropmalzpp": 163339998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149456552,
    "dropsitcph": 8149456552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19537",
    "droptype": "D",
    "dropname": "LURGAN",
    "dropdeladd": "8406 ROXBURY RD",
    "dropdelcty": "LURGAN",
    "dropdelst": "PA",
    "dropdelzpp": 172329998,
    "dropphyadd": "8406 ROXBURY RD",
    "dropphycty": "LURGAN",
    "dropphyst": "PA",
    "dropphyzpp": 172329998,
    "dropmaladd": "8406 ROXBURY RD",
    "dropmalcty": "LURGAN",
    "dropmalst": "PA",
    "dropmalzpp": 172329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175309263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19538",
    "droptype": "D",
    "dropname": "LUTHERSBURG",
    "dropdeladd": "79 CHURCH ST",
    "dropdelcty": "LUTHERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 158489800,
    "dropphyadd": "79 CHURCH ST",
    "dropphycty": "LUTHERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 158489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUTHERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 158489998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145835115,
    "dropsitcph": 8145835115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19540",
    "droptype": "D",
    "dropname": "LUXOR",
    "dropdeladd": "470 BOVARD LUXOR RD",
    "dropdelcty": "LUXOR",
    "dropdelst": "PA",
    "dropdelzpp": 156621001,
    "dropphyadd": "470 BOVARD LUXOR RD",
    "dropphycty": "LUXOR",
    "dropphyst": "PA",
    "dropphyzpp": 156621001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUXOR",
    "dropmalst": "PA",
    "dropmalzpp": 156629998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249252816,
    "dropsitcph": 7248360629,
    "dropfax": 7248362866
  },
  {
    "dcode": "D",
    "dropkey": "PX19544",
    "droptype": "D",
    "dropname": "LYKENS",
    "dropdeladd": "668 MAIN ST",
    "dropdelcty": "LYKENS",
    "dropdelst": "PA",
    "dropdelzpp": 170489998,
    "dropphyadd": "668 MAIN ST",
    "dropphycty": "LYKENS",
    "dropphyst": "PA",
    "dropphyzpp": 170489998,
    "dropmaladd": "668 MAIN ST",
    "dropmalcty": "LYKENS",
    "dropmalst": "PA",
    "dropmalzpp": 170489998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174537595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19546",
    "droptype": "D",
    "dropname": "LYNDELL",
    "dropdeladd": "2 LYNDELL RD",
    "dropdelcty": "LYNDELL",
    "dropdelst": "PA",
    "dropdelzpp": 193549998,
    "dropphyadd": "2 LYNDELL RD",
    "dropphycty": "LYNDELL",
    "dropphyst": "PA",
    "dropphyzpp": 193549998,
    "dropmaladd": "2 LYNDELL RD",
    "dropmalcty": "LYNDELL",
    "dropmalst": "PA",
    "dropmalzpp": 193549998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6109424165,
    "dropsitcph": 6109424165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19548",
    "droptype": "D",
    "dropname": "LYNDORA",
    "dropdeladd": "110 WHITESTOWN RD",
    "dropdelcty": "LYNDORA",
    "dropdelst": "PA",
    "dropdelzpp": 160451100,
    "dropphyadd": "110 WHITESTOWN RD",
    "dropphycty": "LYNDORA",
    "dropphyst": "PA",
    "dropphyzpp": 160451100,
    "dropmaladd": "110 WHITESTOWN RD",
    "dropmalcty": "LYNDORA",
    "dropmalst": "PA",
    "dropmalzpp": 160451100,
    "dropsitphn": 8148367307,
    "dropsitlph": 7242856650,
    "dropsitcph": 7242856650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19555",
    "droptype": "D",
    "dropname": "LYON STATION",
    "dropdeladd": "104 S KEMP ST",
    "dropdelcty": "LYON STATION",
    "dropdelst": "PA",
    "dropdelzpp": 195369998,
    "dropphyadd": "104 S KEMP ST",
    "dropphycty": "LYON STATION",
    "dropphyst": "PA",
    "dropphyzpp": 195369998,
    "dropmaladd": "104 S KEMP ST",
    "dropmalcty": "LYON STATION",
    "dropmalst": "PA",
    "dropmalzpp": 195369998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106822516,
    "dropsitcph": 6106822516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19561",
    "droptype": "D",
    "dropname": "MACKEYVILLE",
    "dropdeladd": "191 MACKEYVILLE RD",
    "dropdelcty": "MACKEYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177509998,
    "dropphyadd": "191 MACKEYVILLE RD",
    "dropphycty": "MACKEYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177509998,
    "dropmaladd": "191 MACKEYVILLE RD",
    "dropmalcty": "MACKEYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707263999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19562",
    "droptype": "D",
    "dropname": "MACUNGIE",
    "dropdeladd": "51 W END TRL",
    "dropdelcty": "MACUNGIE",
    "dropdelst": "PA",
    "dropdelzpp": 180629998,
    "dropphyadd": "51 W END TRL",
    "dropphycty": "MACUNGIE",
    "dropphyst": "PA",
    "dropphyzpp": 180629998,
    "dropmaladd": "51 W END TRL",
    "dropmalcty": "MACUNGIE",
    "dropmalst": "PA",
    "dropmalzpp": 180629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6109663672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19565",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "232 MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "PA",
    "dropdelzpp": 156631100,
    "dropphyadd": "232 MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "PA",
    "dropphyzpp": 156631100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADISON",
    "dropmalst": "PA",
    "dropmalzpp": 156639998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244469313,
    "dropsitcph": 7244469313,
    "dropfax": 7244460577
  },
  {
    "dcode": "D",
    "dropkey": "PX19567",
    "droptype": "D",
    "dropname": "MADISONBURG",
    "dropdeladd": "4694 BRUSH VALLEY RD",
    "dropdelcty": "MADISONBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168528011,
    "dropphyadd": "4694 BRUSH VALLEY RD",
    "dropphycty": "MADISONBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168528011,
    "dropmaladd": "4694 BRUSH VALLEY RD",
    "dropmalcty": "MADISONBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168528011,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143498940,
    "dropsitcph": 8143498940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19568",
    "droptype": "D",
    "dropname": "MAHAFFEY",
    "dropdeladd": "10 E MAIN ST",
    "dropdelcty": "MAHAFFEY",
    "dropdelst": "PA",
    "dropdelzpp": 157579998,
    "dropphyadd": "10 E MAIN ST",
    "dropphycty": "MAHAFFEY",
    "dropphyst": "PA",
    "dropphyzpp": 157579998,
    "dropmaladd": "10 E MAIN ST",
    "dropmalcty": "MAHAFFEY",
    "dropmalst": "PA",
    "dropmalzpp": 157579998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8142776069,
    "dropsitcph": 8142776069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19570",
    "droptype": "D",
    "dropname": "MAHANOY CITY",
    "dropdeladd": "39 E PINE ST",
    "dropdelcty": "MAHANOY CITY",
    "dropdelst": "PA",
    "dropdelzpp": 179489998,
    "dropphyadd": "39 E PINE ST",
    "dropphycty": "MAHANOY CITY",
    "dropphyst": "PA",
    "dropphyzpp": 179489998,
    "dropmaladd": "39 E PINE ST",
    "dropmalcty": "MAHANOY CITY",
    "dropmalst": "PA",
    "dropmalzpp": 179489998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5707732190,
    "dropsitcph": 5707732190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19576",
    "droptype": "D",
    "dropname": "MAINESBURG",
    "dropdeladd": "121 MAINESBURG RD",
    "dropdelcty": "MAINESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 169329998,
    "dropphyadd": "121 MAINESBURG RD",
    "dropphycty": "MAINESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 169329998,
    "dropmaladd": "121 MAINESBURG RD",
    "dropmalcty": "MAINESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 169329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705493480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19577",
    "droptype": "D",
    "dropname": "MAINLAND",
    "dropdeladd": "600 OAK DR",
    "dropdelcty": "HARLEYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 194382258,
    "dropphyadd": "600 OAK DR",
    "dropphycty": "HARLEYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 194382258,
    "dropmaladd": "600 OAK DR",
    "dropmalcty": "HARLEYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 194382258,
    "dropsitphn": 6109646414,
    "dropsitlph": 2152569662,
    "dropsitcph": 2152569662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19583",
    "droptype": "D",
    "dropname": "MALVERN",
    "dropdeladd": "33 W KING ST",
    "dropdelcty": "MALVERN",
    "dropdelst": "PA",
    "dropdelzpp": 193559998,
    "dropphyadd": "33 W KING ST",
    "dropphycty": "MALVERN",
    "dropphyst": "PA",
    "dropphyzpp": 193559998,
    "dropmaladd": "33 W KING ST",
    "dropmalcty": "MALVERN",
    "dropmalst": "PA",
    "dropmalzpp": 193559998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102960862,
    "dropsitcph": 6102960862,
    "dropfax": 6102512308
  },
  {
    "dcode": "D",
    "dropkey": "PX19584",
    "droptype": "D",
    "dropname": "MAMMOTH",
    "dropdeladd": "2688 ROUTE 982",
    "dropdelcty": "MAMMOTH",
    "dropdelst": "PA",
    "dropdelzpp": 156641001,
    "dropphyadd": "2688 ROUTE 982",
    "dropphycty": "MAMMOTH",
    "dropphyst": "PA",
    "dropphyzpp": 156641001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAMMOTH",
    "dropmalst": "PA",
    "dropmalzpp": 156649998,
    "dropsitphn": 7242217360,
    "dropsitlph": 7242217360,
    "dropsitcph": 7242217360,
    "dropfax": 7245727663
  },
  {
    "dcode": "D",
    "dropkey": "PX19589",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "15 MANCHESTER ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 173459998,
    "dropphyadd": "15 MANCHESTER ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 173459998,
    "dropmaladd": "15 MANCHESTER ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 173459998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172662466,
    "dropsitcph": 7172662466,
    "dropfax": 7172666080
  },
  {
    "dcode": "D",
    "dropkey": "PX19592",
    "droptype": "D",
    "dropname": "MANHEIM",
    "dropdeladd": "47 S MAIN ST",
    "dropdelcty": "MANHEIM",
    "dropdelst": "PA",
    "dropdelzpp": 175459998,
    "dropphyadd": "47 S MAIN ST",
    "dropphycty": "MANHEIM",
    "dropphyst": "PA",
    "dropphyzpp": 175459998,
    "dropmaladd": "47 S MAIN ST",
    "dropmalcty": "MANHEIM",
    "dropmalst": "PA",
    "dropmalzpp": 175459998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176652122,
    "dropsitcph": 7176652122,
    "dropfax": 7176654924
  },
  {
    "dcode": "D",
    "dropkey": "PX19594",
    "droptype": "D",
    "dropname": "MANNS CHOICE",
    "dropdeladd": "1 DOGWOOD LN",
    "dropdelcty": "MANNS CHOICE",
    "dropdelst": "PA",
    "dropdelzpp": 155509998,
    "dropphyadd": "1 DOGWOOD LN",
    "dropphycty": "MANNS CHOICE",
    "dropphyst": "PA",
    "dropphyzpp": 155509998,
    "dropmaladd": "1 DOGWOOD LN",
    "dropmalcty": "MANNS CHOICE",
    "dropmalst": "PA",
    "dropmalzpp": 155509998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146239543,
    "dropsitcph": 8146239543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19598",
    "droptype": "D",
    "dropname": "MANOR",
    "dropdeladd": "9 ATLANTIC AVE",
    "dropdelcty": "MANOR",
    "dropdelst": "PA",
    "dropdelzpp": 156651001,
    "dropphyadd": "9 ATLANTIC AVE",
    "dropphycty": "MANOR",
    "dropphyst": "PA",
    "dropphyzpp": 156651001,
    "dropmaladd": "9 ATLANTIC AVE",
    "dropmalcty": "MANOR",
    "dropmalst": "PA",
    "dropmalzpp": 156659998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248632152,
    "dropsitcph": 7248632152,
    "dropfax": 7248631177
  },
  {
    "dcode": "D",
    "dropkey": "PX19601",
    "droptype": "D",
    "dropname": "MANORVILLE",
    "dropdeladd": "500 WATER ST",
    "dropdelcty": "MANORVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162389800,
    "dropphyadd": "500 WATER ST",
    "dropphycty": "MANORVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANORVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162389998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247632491,
    "dropsitcph": 7247632491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19602",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "320 S MAIN ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "PA",
    "dropdelzpp": 169339998,
    "dropphyadd": "320 S MAIN ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "PA",
    "dropphyzpp": 169339998,
    "dropmaladd": "320 S MAIN ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "PA",
    "dropmalzpp": 169339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706622401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19608",
    "droptype": "D",
    "dropname": "MAPLETON DEPOT",
    "dropdeladd": "617 MAIN ST",
    "dropdelcty": "MAPLETON DEPOT",
    "dropdelst": "PA",
    "dropdelzpp": 170529998,
    "dropphyadd": "617 MAIN ST",
    "dropphycty": "MAPLETON DEPOT",
    "dropphyst": "PA",
    "dropphyzpp": 170529998,
    "dropmaladd": "617 MAIN ST",
    "dropmalcty": "MAPLETON DEPOT",
    "dropmalst": "PA",
    "dropmalzpp": 170529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8145429837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19609",
    "droptype": "D",
    "dropname": "MAR LIN",
    "dropdeladd": "401 BEECHWOOD AVE",
    "dropdelcty": "MAR LIN",
    "dropdelst": "PA",
    "dropdelzpp": 179519998,
    "dropphyadd": "401 BEECHWOOD AVE",
    "dropphycty": "MAR LIN",
    "dropphyst": "PA",
    "dropphyzpp": 179519998,
    "dropmaladd": "401 BEECHWOOD AVE",
    "dropmalcty": "MAR LIN",
    "dropmalst": "PA",
    "dropmalzpp": 179519998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5705446785,
    "dropsitcph": 5705446785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19610",
    "droptype": "D",
    "dropname": "MARBLE",
    "dropdeladd": "18104 ROUTE 208",
    "dropdelcty": "MARBLE",
    "dropdelst": "PA",
    "dropdelzpp": 163349800,
    "dropphyadd": "18104 ROUTE 208",
    "dropphycty": "MARBLE",
    "dropphyst": "PA",
    "dropphyzpp": 163349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARBLE",
    "dropmalst": "PA",
    "dropmalzpp": 163349998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143542188,
    "dropsitcph": 8143542188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19613",
    "droptype": "D",
    "dropname": "MARCUS HOOK",
    "dropdeladd": "926 MARKET ST",
    "dropdelcty": "MARCUS HOOK",
    "dropdelst": "PA",
    "dropdelzpp": 190619997,
    "dropphyadd": "926 MARKET ST",
    "dropphycty": "MARCUS HOOK",
    "dropphyst": "PA",
    "dropphyzpp": 190619997,
    "dropmaladd": "926 MARKET ST",
    "dropmalcty": "MARCUS HOOK",
    "dropmalst": "PA",
    "dropmalzpp": 190619997,
    "dropsitphn": 6104852850,
    "dropsitlph": 6104851660,
    "dropsitcph": 6104851660,
    "dropfax": 6104859445
  },
  {
    "dcode": "D",
    "dropkey": "PX19614",
    "droptype": "D",
    "dropname": "MARIANNA",
    "dropdeladd": "1742 MAIN ST",
    "dropdelcty": "MARIANNA",
    "dropdelst": "PA",
    "dropdelzpp": 153452001,
    "dropphyadd": "1742 MAIN ST",
    "dropphycty": "MARIANNA",
    "dropphyst": "PA",
    "dropphyzpp": 153452001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARIANNA",
    "dropmalst": "PA",
    "dropmalzpp": 153459998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242674010,
    "dropsitcph": 7242674010,
    "dropfax": 7242674013
  },
  {
    "dcode": "D",
    "dropkey": "PX19615",
    "droptype": "D",
    "dropname": "MARIENVILLE",
    "dropdeladd": "107 S FOREST ST",
    "dropdelcty": "MARIENVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 162399800,
    "dropphyadd": "107 S FOREST ST",
    "dropphycty": "MARIENVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 162399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARIENVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 162399998,
    "dropsitphn": 8149273295,
    "dropsitlph": 8149273295,
    "dropsitcph": 8149273293,
    "dropfax": 8149273296
  },
  {
    "dcode": "D",
    "dropkey": "PX19616",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "16 N NEW HAVEN ST",
    "dropdelcty": "MARIETTA",
    "dropdelst": "PA",
    "dropdelzpp": 175479998,
    "dropphyadd": "16 N NEW HAVEN ST",
    "dropphycty": "MARIETTA",
    "dropphyst": "PA",
    "dropphyzpp": 175479998,
    "dropmaladd": "16 N NEW HAVEN ST",
    "dropmalcty": "MARIETTA",
    "dropmalst": "PA",
    "dropmalzpp": 175479998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174261106,
    "dropsitcph": 7174261106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19618",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "144 COLORADO ST",
    "dropdelcty": "MARION",
    "dropdelst": "PA",
    "dropdelzpp": 172359998,
    "dropphyadd": "144 COLORADO ST",
    "dropphycty": "MARION",
    "dropphyst": "PA",
    "dropphyzpp": 172359998,
    "dropmaladd": "144 COLORADO ST",
    "dropmalcty": "MARION",
    "dropmalst": "PA",
    "dropmalzpp": 172359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173754567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19620",
    "droptype": "D",
    "dropname": "MARION CENTER",
    "dropdeladd": "204 MANOR ST",
    "dropdelcty": "MARION CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 157599998,
    "dropphyadd": "204 MANOR ST",
    "dropphycty": "MARION CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 157599998,
    "dropmaladd": "204 MANOR ST",
    "dropmalcty": "MARION CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 157599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7243974955,
    "dropsitcph": 7243974955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19622",
    "droptype": "D",
    "dropname": "MARION HEIGHTS",
    "dropdeladd": "226 NORTH ST",
    "dropdelcty": "MARION HEIGHTS",
    "dropdelst": "PA",
    "dropdelzpp": 178329998,
    "dropphyadd": "226 NORTH ST",
    "dropphycty": "MARION HEIGHTS",
    "dropphyst": "PA",
    "dropphyzpp": 178329998,
    "dropmaladd": "226 NORTH ST",
    "dropmalcty": "MARION HEIGHTS",
    "dropmalst": "PA",
    "dropmalzpp": 178329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173733930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19627",
    "droptype": "D",
    "dropname": "MARKLETON",
    "dropdeladd": "1099 MARKLETON SCHOOL RD",
    "dropdelcty": "MARKLETON",
    "dropdelst": "PA",
    "dropdelzpp": 155519998,
    "dropphyadd": "1099 MARKLETON SCHOOL RD",
    "dropphycty": "MARKLETON",
    "dropphyst": "PA",
    "dropphyzpp": 155519998,
    "dropmaladd": "1099 MARKLETON SCHOOL RD",
    "dropmalcty": "MARKLETON",
    "dropmalst": "PA",
    "dropmalzpp": 155519998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8149262326,
    "dropsitcph": 8149262326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19628",
    "droptype": "D",
    "dropname": "MARKLEYSBURG",
    "dropdeladd": "173 MAIN ST",
    "dropdelcty": "MARKLEYSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 154591072,
    "dropphyadd": "173 MAIN ST",
    "dropphycty": "MARKLEYSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 154591072,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARKLEYSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 154599998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243294494,
    "dropsitcph": 7243294494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19631",
    "droptype": "D",
    "dropname": "MARS",
    "dropdeladd": "111 GRAND AVE",
    "dropdelcty": "MARS",
    "dropdelst": "PA",
    "dropdelzpp": 160469800,
    "dropphyadd": "111 GRAND AVE",
    "dropphycty": "MARS",
    "dropphyst": "PA",
    "dropphyzpp": 160469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARS",
    "dropmalst": "PA",
    "dropmalzpp": 160469998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246252950,
    "dropsitcph": 7246252950,
    "dropfax": 7246251266
  },
  {
    "dcode": "D",
    "dropkey": "PX19636",
    "droptype": "D",
    "dropname": "MARSHALLS CREEK",
    "dropdeladd": "315 DARTMOUTH DR",
    "dropdelcty": "MARSHALLS CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 183359900,
    "dropphyadd": "315 DARTMOUTH DR",
    "dropphycty": "MARSHALLS CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 183359900,
    "dropmaladd": "315 DARTMOUTH DR",
    "dropmalcty": "MARSHALLS CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 183359900,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5702238203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19645",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "107 NICHOLSON ST",
    "dropdelcty": "MARTIN",
    "dropdelst": "PA",
    "dropdelzpp": 154601001,
    "dropphyadd": "107 NICHOLSON ST",
    "dropphycty": "MARTIN",
    "dropphyst": "PA",
    "dropphyzpp": 154601001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTIN",
    "dropmalst": "PA",
    "dropmalzpp": 154609998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245832206,
    "dropsitcph": 7245832206,
    "dropfax": 7245832206
  },
  {
    "dcode": "D",
    "dropkey": "PX19649",
    "droptype": "D",
    "dropname": "MARTINS CREEK",
    "dropdeladd": "6564 S DELAWARE DR",
    "dropdelcty": "MARTINS CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 180639998,
    "dropphyadd": "6564 S DELAWARE DR",
    "dropphycty": "MARTINS CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 180639998,
    "dropmaladd": "6564 S DELAWARE DR",
    "dropmalcty": "MARTINS CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 180639998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6102525311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19651",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "101 E ALLEGHENY ST",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 166629998,
    "dropphyadd": "101 E ALLEGHENY ST",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 166629998,
    "dropmaladd": "101 E ALLEGHENY ST",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 166629998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147933114,
    "dropsitcph": 8147933114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19653",
    "droptype": "D",
    "dropname": "MARY D",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "MARY D",
    "dropdelst": "PA",
    "dropdelzpp": 179529998,
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "MARY D",
    "dropphyst": "PA",
    "dropphyzpp": 179529998,
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "MARY D",
    "dropmalst": "PA",
    "dropmalzpp": 179529998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5706684400,
    "dropsitcph": 5706684400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19654",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "309 CAMERON ST",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170539998,
    "dropphyadd": "309 CAMERON ST",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170539998,
    "dropmaladd": "309 CAMERON ST",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7179572111,
    "dropsitcph": 7179572111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19658",
    "droptype": "D",
    "dropname": "MASONTOWN",
    "dropdeladd": "11 E CHURCH AVE",
    "dropdelcty": "MASONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154619998,
    "dropphyadd": "11 E CHURCH AVE",
    "dropphycty": "MASONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154619998,
    "dropmaladd": "11 E CHURCH AVE",
    "dropmalcty": "MASONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154619998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7245837785,
    "dropsitcph": 7245837785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19661",
    "droptype": "D",
    "dropname": "MATAMORAS",
    "dropdeladd": "6 PENNSYLVANIA AVE",
    "dropdelcty": "MATAMORAS",
    "dropdelst": "PA",
    "dropdelzpp": 183369998,
    "dropphyadd": "6 PENNSYLVANIA AVE",
    "dropphycty": "MATAMORAS",
    "dropphyst": "PA",
    "dropphyzpp": 183369998,
    "dropmaladd": "6 PENNSYLVANIA AVE",
    "dropmalcty": "MATAMORAS",
    "dropmalst": "PA",
    "dropmalzpp": 183369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704914715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19662",
    "droptype": "D",
    "dropname": "MATHER",
    "dropdeladd": "319 3RD ST",
    "dropdelcty": "MATHER",
    "dropdelst": "PA",
    "dropdelzpp": 153461001,
    "dropphyadd": "319 3RD ST",
    "dropphycty": "MATHER",
    "dropphyst": "PA",
    "dropphyzpp": 153461001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATHER",
    "dropmalst": "PA",
    "dropmalzpp": 153469998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7248834600,
    "dropsitcph": 7248834600,
    "dropfax": 7248834600
  },
  {
    "dcode": "D",
    "dropkey": "PX19663",
    "droptype": "D",
    "dropname": "MATTAWANA",
    "dropdeladd": "86 STATE ROUTE 103 N",
    "dropdelcty": "MATTAWANA",
    "dropdelst": "PA",
    "dropdelzpp": 170549998,
    "dropphyadd": "86 STATE ROUTE 103 N",
    "dropphycty": "MATTAWANA",
    "dropphyst": "PA",
    "dropphyzpp": 170549998,
    "dropmaladd": "86 STATE ROUTE 103 N",
    "dropmalcty": "MATTAWANA",
    "dropmalst": "PA",
    "dropmalzpp": 170549998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178996702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19665",
    "droptype": "D",
    "dropname": "MAXATAWNY",
    "dropdeladd": "15881 KUTZTOWN RD",
    "dropdelcty": "MAXATAWNY",
    "dropdelst": "PA",
    "dropdelzpp": 195389998,
    "dropphyadd": "15881 KUTZTOWN RD",
    "dropphycty": "MAXATAWNY",
    "dropphyst": "PA",
    "dropphyzpp": 195389998,
    "dropmaladd": "15881 KUTZTOWN RD",
    "dropmalcty": "MAXATAWNY",
    "dropmalst": "PA",
    "dropmalzpp": 195389998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106838212,
    "dropsitcph": 6106838212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19670",
    "droptype": "D",
    "dropname": "MAYPORT",
    "dropdeladd": "395 MAYPORT RD",
    "dropdelcty": "MAYPORT",
    "dropdelst": "PA",
    "dropdelzpp": 162409800,
    "dropphyadd": "395 MAYPORT RD",
    "dropphycty": "MAYPORT",
    "dropphyst": "PA",
    "dropphyzpp": 162409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYPORT",
    "dropmalst": "PA",
    "dropmalzpp": 162409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143655326,
    "dropsitcph": 8143655326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19673",
    "droptype": "D",
    "dropname": "MAYTOWN",
    "dropdeladd": "1 W HIGH ST",
    "dropdelcty": "MAYTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 175509998,
    "dropphyadd": "1 W HIGH ST",
    "dropphycty": "MAYTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 175509998,
    "dropmaladd": "1 W HIGH ST",
    "dropmalcty": "MAYTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 175509998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7174261752,
    "dropsitcph": 7174261752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19676",
    "droptype": "D",
    "dropname": "MC ALISTERVILLE",
    "dropdeladd": "132 WESTFALL ST",
    "dropdelcty": "MC ALISTERVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 170499998,
    "dropphyadd": "132 WESTFALL ST",
    "dropphycty": "MC ALISTERVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 170499998,
    "dropmaladd": "132 WESTFALL ST",
    "dropmalcty": "MC ALISTERVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 170499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174632197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19679",
    "droptype": "D",
    "dropname": "MC CLELLANDTOWN",
    "dropdeladd": "109 MCKINLEY ST",
    "dropdelcty": "MC CLELLANDTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154581527,
    "dropphyadd": "109 MCKINLEY ST",
    "dropphycty": "MC CLELLANDTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154581527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CLELLANDTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154589998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247375971,
    "dropsitcph": 7247375971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19680",
    "droptype": "D",
    "dropname": "MC CLURE",
    "dropdeladd": "1 BROWN ST",
    "dropdelcty": "MC CLURE",
    "dropdelst": "PA",
    "dropdelzpp": 178419998,
    "dropphyadd": "1 BROWN ST",
    "dropphycty": "MC CLURE",
    "dropphyst": "PA",
    "dropphyzpp": 178419998,
    "dropmaladd": "1 BROWN ST",
    "dropmalcty": "MC CLURE",
    "dropmalst": "PA",
    "dropmalzpp": 178419998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5706587484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19681",
    "droptype": "D",
    "dropname": "MC CONNELLSBURG",
    "dropdeladd": "115 E MAPLE ST",
    "dropdelcty": "MC CONNELLSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172339998,
    "dropphyadd": "115 E MAPLE ST",
    "dropphycty": "MC CONNELLSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172339998,
    "dropmaladd": "115 E MAPLE ST",
    "dropmalcty": "MC CONNELLSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172339998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174853710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19682",
    "droptype": "D",
    "dropname": "MC CONNELLSTOWN",
    "dropdeladd": "11701 RAYSTOWN RD FL 1",
    "dropdelcty": "MC CONNELLSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 166609998,
    "dropphyadd": "11701 RAYSTOWN RD FL 1",
    "dropphycty": "MC CONNELLSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 166609998,
    "dropmaladd": "11701 RAYSTOWN RD FL 1",
    "dropmalcty": "MC CONNELLSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 166609998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146279511,
    "dropsitcph": 8146279511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19683",
    "droptype": "D",
    "dropname": "MC DONALD",
    "dropdeladd": "110 W BARR ST",
    "dropdelcty": "MC DONALD",
    "dropdelst": "PA",
    "dropdelzpp": 150579998,
    "dropphyadd": "110 W BARR ST",
    "dropphycty": "MC DONALD",
    "dropphyst": "PA",
    "dropphyzpp": 150579998,
    "dropmaladd": "110 W BARR ST",
    "dropmalcty": "MC DONALD",
    "dropmalst": "PA",
    "dropmalzpp": 150579998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7249268403,
    "dropsitcph": 7249268403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19684",
    "droptype": "D",
    "dropname": "MC ELHATTAN",
    "dropdeladd": "529 MC ELHATTAN DR",
    "dropdelcty": "MC ELHATTAN",
    "dropdelst": "PA",
    "dropdelzpp": 177489998,
    "dropphyadd": "529 MC ELHATTAN DR",
    "dropphycty": "MC ELHATTAN",
    "dropphyst": "PA",
    "dropphyzpp": 177489998,
    "dropmaladd": "529 MC ELHATTAN DR",
    "dropmalcty": "MC ELHATTAN",
    "dropmalst": "PA",
    "dropmalzpp": 177489998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707696023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19685",
    "droptype": "D",
    "dropname": "MC EWENSVILLE",
    "dropdeladd": "8 POTASH ST",
    "dropdelcty": "MC EWENSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177499998,
    "dropphyadd": "8 POTASH ST",
    "dropphycty": "MC EWENSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177499998,
    "dropmaladd": "8 POTASH ST",
    "dropmalcty": "MC EWENSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177499998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705389341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19687",
    "droptype": "D",
    "dropname": "MC GRANN",
    "dropdeladd": "207 BYRON ST",
    "dropdelcty": "MC GRANN",
    "dropdelst": "PA",
    "dropdelzpp": 162369800,
    "dropphyadd": "207 BYRON ST",
    "dropphycty": "MC GRANN",
    "dropphyst": "PA",
    "dropphyzpp": 162369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GRANN",
    "dropmalst": "PA",
    "dropmalzpp": 162369998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247638502,
    "dropsitcph": 7247638502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19688",
    "droptype": "D",
    "dropname": "MC INTYRE",
    "dropdeladd": "2576 MCINTYRE RD",
    "dropdelcty": "MC INTYRE",
    "dropdelst": "PA",
    "dropdelzpp": 157569998,
    "dropphyadd": "2576 MCINTYRE RD",
    "dropphycty": "MC INTYRE",
    "dropphyst": "PA",
    "dropphyzpp": 157569998,
    "dropmaladd": "2576 MCINTYRE RD",
    "dropmalcty": "MC INTYRE",
    "dropmalst": "PA",
    "dropmalzpp": 157569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7247269350,
    "dropsitcph": 7247269350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19689",
    "droptype": "D",
    "dropname": "MC KEAN",
    "dropdeladd": "8988 MAIN ST",
    "dropdelcty": "MC KEAN",
    "dropdelst": "PA",
    "dropdelzpp": 164269800,
    "dropphyadd": "8988 MAIN ST",
    "dropphycty": "MC KEAN",
    "dropphyst": "PA",
    "dropphyzpp": 164269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC KEAN",
    "dropmalst": "PA",
    "dropmalzpp": 164269998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8144767312,
    "dropsitcph": 8144767312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19690",
    "droptype": "D",
    "dropname": "MC KEES ROCKS",
    "dropdeladd": "807 CHARTIERS AVE",
    "dropdelcty": "MC KEES ROCKS",
    "dropdelst": "PA",
    "dropdelzpp": 151369998,
    "dropphyadd": "807 CHARTIERS AVE",
    "dropphycty": "MC KEES ROCKS",
    "dropphyst": "PA",
    "dropphyzpp": 151369998,
    "dropmaladd": "807 CHARTIERS AVE",
    "dropmalcty": "MC KEES ROCKS",
    "dropmalst": "PA",
    "dropmalzpp": 151369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123318172,
    "dropsitcph": 4123318172,
    "dropfax": 4123310407
  },
  {
    "dcode": "D",
    "dropkey": "PX19691",
    "droptype": "D",
    "dropname": "MCKEESPORT",
    "dropdeladd": "850 WALNUT ST",
    "dropdelcty": "MCKEESPORT",
    "dropdelst": "PA",
    "dropdelzpp": 151341101,
    "dropphyadd": "850 WALNUT ST",
    "dropphycty": "MCKEESPORT",
    "dropphyst": "PA",
    "dropphyzpp": 151341101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCKEESPORT",
    "dropmalst": "PA",
    "dropmalzpp": 151349998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126729722,
    "dropsitcph": 4126729722,
    "dropfax": 4126728935
  },
  {
    "dcode": "D",
    "dropkey": "PX19693",
    "droptype": "D",
    "dropname": "MC KNIGHTSTOWN",
    "dropdeladd": "245 OLD ROUTE 30",
    "dropdelcty": "MC KNIGHTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173439998,
    "dropphyadd": "245 OLD ROUTE 30",
    "dropphycty": "MC KNIGHTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173439998,
    "dropmaladd": "245 OLD ROUTE 30",
    "dropmalcty": "MC KNIGHTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173439998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173346813,
    "dropsitcph": 7173346813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19695",
    "droptype": "D",
    "dropname": "MC SHERRYSTOWN",
    "dropdeladd": "328 MAIN ST",
    "dropdelcty": "MC SHERRYSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 173449998,
    "dropphyadd": "328 MAIN ST",
    "dropphycty": "MC SHERRYSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 173449998,
    "dropmaladd": "328 MAIN ST",
    "dropmalcty": "MC SHERRYSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 173449998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176371450,
    "dropsitcph": 7176371450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19696",
    "droptype": "D",
    "dropname": "MC VEYTOWN",
    "dropdeladd": "1 E JOHN ST",
    "dropdelcty": "MC VEYTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170519998,
    "dropphyadd": "1 E JOHN ST",
    "dropphycty": "MC VEYTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170519998,
    "dropmaladd": "1 E JOHN ST",
    "dropmalcty": "MC VEYTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7178996721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19697",
    "droptype": "D",
    "dropname": "MCADOO",
    "dropdeladd": "126 W BLAINE ST",
    "dropdelcty": "MCADOO",
    "dropdelst": "PA",
    "dropdelzpp": 182379998,
    "dropphyadd": "126 W BLAINE ST",
    "dropphycty": "MCADOO",
    "dropphyst": "PA",
    "dropphyzpp": 182379998,
    "dropmaladd": "126 W BLAINE ST",
    "dropmalcty": "MCADOO",
    "dropmalst": "PA",
    "dropmalzpp": 182379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709291330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19734",
    "droptype": "D",
    "dropname": "MEADOW LANDS",
    "dropdeladd": "100 COUNTRY CLUB RD",
    "dropdelcty": "MEADOW LANDS",
    "dropdelst": "PA",
    "dropdelzpp": 153471001,
    "dropphyadd": "100 COUNTRY CLUB RD",
    "dropphycty": "MEADOW LANDS",
    "dropphyst": "PA",
    "dropphyzpp": 153471001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEADOW LANDS",
    "dropmalst": "PA",
    "dropmalzpp": 153479998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242258255,
    "dropsitcph": 7242258255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19737",
    "droptype": "D",
    "dropname": "MEADVILLE",
    "dropdeladd": "212 ARCH ST",
    "dropdelcty": "MEADVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 163353400,
    "dropphyadd": "212 ARCH ST",
    "dropphycty": "MEADVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 163353400,
    "dropmaladd": "212 ARCH ST",
    "dropmalcty": "MEADVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 163353400,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147245990,
    "dropsitcph": 8147245990,
    "dropfax": 8147245996
  },
  {
    "dcode": "D",
    "dropkey": "PX19741",
    "droptype": "D",
    "dropname": "MECHANICSBURG",
    "dropdeladd": "702 E SIMPSON ST",
    "dropdelcty": "MECHANICSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170559998,
    "dropphyadd": "702 E SIMPSON ST",
    "dropphycty": "MECHANICSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170559998,
    "dropmaladd": "702 E SIMPSON ST",
    "dropmalcty": "MECHANICSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170559998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176974641,
    "dropfax": 7177957896
  },
  {
    "dcode": "D",
    "dropkey": "PX19743",
    "droptype": "D",
    "dropname": "MECHANICSVILLE",
    "dropdeladd": "3295 DURHAM RD",
    "dropdelcty": "MECHANICSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189349998,
    "dropphyadd": "3295 DURHAM RD",
    "dropphycty": "MECHANICSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189349998,
    "dropmaladd": "3295 DURHAM RD",
    "dropmalcty": "MECHANICSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189349998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2157945846,
    "dropsitcph": 2157945846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19749",
    "droptype": "D",
    "dropname": "MEDIA",
    "dropdeladd": "101 E BALTIMORE AVE",
    "dropdelcty": "MEDIA",
    "dropdelst": "PA",
    "dropdelzpp": 190639998,
    "dropphyadd": "101 E BALTIMORE AVE",
    "dropphycty": "MEDIA",
    "dropphyst": "PA",
    "dropphyzpp": 190639998,
    "dropmaladd": "101 E BALTIMORE AVE",
    "dropmalcty": "MEDIA",
    "dropmalst": "PA",
    "dropmalzpp": 190639998,
    "dropsitphn": 6105662237,
    "dropsitlph": 6105662237,
    "dropsitcph": 6105662237,
    "dropfax": 6108920958
  },
  {
    "dcode": "D",
    "dropkey": "PX19751",
    "droptype": "D",
    "dropname": "MEHOOPANY",
    "dropdeladd": "1 PEARL RD",
    "dropdelcty": "MEHOOPANY",
    "dropdelst": "PA",
    "dropdelzpp": 186299998,
    "dropphyadd": "1 PEARL RD",
    "dropphycty": "MEHOOPANY",
    "dropphyst": "PA",
    "dropphyzpp": 186299998,
    "dropmaladd": "1 PEARL RD",
    "dropmalcty": "MEHOOPANY",
    "dropmalst": "PA",
    "dropmalzpp": 186299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708335095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19754",
    "droptype": "D",
    "dropname": "MELCROFT",
    "dropdeladd": "1334 INDIAN CREEK VALLEY RD",
    "dropdelcty": "MELCROFT",
    "dropdelst": "PA",
    "dropdelzpp": 154621026,
    "dropphyadd": "1334 INDIAN CREEK VALLEY RD",
    "dropphycty": "MELCROFT",
    "dropphyst": "PA",
    "dropphyzpp": 154621026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELCROFT",
    "dropmalst": "PA",
    "dropmalzpp": 154629998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244553180,
    "dropsitcph": 7244553180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19760",
    "droptype": "D",
    "dropname": "MENDENHALL",
    "dropdeladd": "330 KENNETT PIKE",
    "dropdelcty": "MENDENHALL",
    "dropdelst": "PA",
    "dropdelzpp": 193579998,
    "dropphyadd": "330 KENNETT PIKE",
    "dropphycty": "MENDENHALL",
    "dropphyst": "PA",
    "dropphyzpp": 193579998,
    "dropmaladd": "330 KENNETT PIKE",
    "dropmalcty": "MENDENHALL",
    "dropmalst": "PA",
    "dropmalzpp": 193579998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103886029,
    "dropsitcph": 6103886029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19765",
    "droptype": "D",
    "dropname": "MERCER",
    "dropdeladd": "109 E VENANGO ST",
    "dropdelcty": "MERCER",
    "dropdelst": "PA",
    "dropdelzpp": 161371153,
    "dropphyadd": "109 E VENANGO ST",
    "dropphycty": "MERCER",
    "dropphyst": "PA",
    "dropphyzpp": 161371153,
    "dropmaladd": "109 E VENANGO ST",
    "dropmalcty": "MERCER",
    "dropmalst": "PA",
    "dropmalzpp": 161371153,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246623590,
    "dropsitcph": 7246623590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19766",
    "droptype": "D",
    "dropname": "MERCERSBURG",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "MERCERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 172369998,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "MERCERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 172369998,
    "dropmaladd": "128 S MAIN ST",
    "dropmalcty": "MERCERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 172369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7173282612,
    "dropfax": 7173282632
  },
  {
    "dcode": "D",
    "dropkey": "PX19772",
    "droptype": "D",
    "dropname": "MERION STATION",
    "dropdeladd": "17 CIVIC CIR",
    "dropdelcty": "MERION STATION",
    "dropdelst": "PA",
    "dropdelzpp": 190669998,
    "dropphyadd": "17 CIVIC CIR",
    "dropphycty": "MERION STATION",
    "dropphyst": "PA",
    "dropphyzpp": 190669998,
    "dropmaladd": "17 CIVIC CIR",
    "dropmalcty": "MERION STATION",
    "dropmalst": "PA",
    "dropmalzpp": 190669998,
    "dropsitphn": 6106641484,
    "dropsitlph": 6106645386,
    "dropsitcph": 6106641484,
    "dropfax": 6106641839
  },
  {
    "dcode": "D",
    "dropkey": "PX19774",
    "droptype": "D",
    "dropname": "MERRITTSTOWN",
    "dropdeladd": "200 ACADEMY RD",
    "dropdelcty": "MERRITTSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154639998,
    "dropphyadd": "200 ACADEMY RD",
    "dropphycty": "MERRITTSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154639998,
    "dropmaladd": "200 ACADEMY RD",
    "dropmalcty": "MERRITTSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154639998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242466060,
    "dropsitcph": 7242466060,
    "dropfax": 7242466060
  },
  {
    "dcode": "D",
    "dropkey": "PX19775",
    "droptype": "D",
    "dropname": "MERTZTOWN",
    "dropdeladd": "1001 STATE ST",
    "dropdelcty": "MERTZTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195399998,
    "dropphyadd": "1001 STATE ST",
    "dropphycty": "MERTZTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195399998,
    "dropmaladd": "1001 STATE ST",
    "dropmalcty": "MERTZTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195399998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6106822222,
    "dropsitcph": 6106822222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19777",
    "droptype": "D",
    "dropname": "MESHOPPEN",
    "dropdeladd": "149 CANAL ST",
    "dropdelcty": "MESHOPPEN",
    "dropdelst": "PA",
    "dropdelzpp": 186309998,
    "dropphyadd": "149 CANAL ST",
    "dropphycty": "MESHOPPEN",
    "dropphyst": "PA",
    "dropphyzpp": 186309998,
    "dropmaladd": "149 CANAL ST",
    "dropmalcty": "MESHOPPEN",
    "dropmalst": "PA",
    "dropmalzpp": 186309998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708335854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19781",
    "droptype": "D",
    "dropname": "MEXICO",
    "dropdeladd": "6798 WILLIAM PENN HWY",
    "dropdelcty": "MEXICO",
    "dropdelst": "PA",
    "dropdelzpp": 170569998,
    "dropphyadd": "6798 WILLIAM PENN HWY",
    "dropphycty": "MEXICO",
    "dropphyst": "PA",
    "dropphyzpp": 170569998,
    "dropmaladd": "6798 WILLIAM PENN HWY",
    "dropmalcty": "MEXICO",
    "dropmalst": "PA",
    "dropmalzpp": 170569998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174362575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19782",
    "droptype": "D",
    "dropname": "MEYERSDALE",
    "dropdeladd": "239 CENTER ST",
    "dropdelcty": "MEYERSDALE",
    "dropdelst": "PA",
    "dropdelzpp": 155529998,
    "dropphyadd": "239 CENTER ST",
    "dropphycty": "MEYERSDALE",
    "dropphyst": "PA",
    "dropphyzpp": 155529998,
    "dropmaladd": "239 CENTER ST",
    "dropmalcty": "MEYERSDALE",
    "dropmalst": "PA",
    "dropmalzpp": 155529998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8146345114,
    "dropsitcph": 8146345114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19791",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "9 N MAIN ST",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178429998,
    "dropphyadd": "9 N MAIN ST",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178429998,
    "dropmaladd": "9 N MAIN ST",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5708372194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19793",
    "droptype": "D",
    "dropname": "MIDDLEBURY CENTER",
    "dropdeladd": "11660 ROUTE 287",
    "dropdelcty": "MIDDLEBURY CENTER",
    "dropdelst": "PA",
    "dropdelzpp": 169359998,
    "dropphyadd": "11660 ROUTE 287",
    "dropphycty": "MIDDLEBURY CENTER",
    "dropphyst": "PA",
    "dropphyzpp": 169359998,
    "dropmaladd": "11660 ROUTE 287",
    "dropmalcty": "MIDDLEBURY CENTER",
    "dropmalst": "PA",
    "dropmalzpp": 169359998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703763201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19794",
    "droptype": "D",
    "dropname": "MIDDLEPORT",
    "dropdeladd": "32 MAIN ST",
    "dropdelcty": "MIDDLEPORT",
    "dropdelst": "PA",
    "dropdelzpp": 179539998,
    "dropphyadd": "32 MAIN ST",
    "dropphycty": "MIDDLEPORT",
    "dropphyst": "PA",
    "dropphyzpp": 179539998,
    "dropmaladd": "32 MAIN ST",
    "dropmalcty": "MIDDLEPORT",
    "dropmalst": "PA",
    "dropmalzpp": 179539998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5702770465,
    "dropsitcph": 5702770465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19799",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "330 W MAIN ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170579998,
    "dropphyadd": "330 W MAIN ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170579998,
    "dropmaladd": "330 W MAIN ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170579998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179443911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19801",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "831 MIDLAND AVE",
    "dropdelcty": "MIDLAND",
    "dropdelst": "PA",
    "dropdelzpp": 150599998,
    "dropphyadd": "831 MIDLAND AVE",
    "dropphycty": "MIDLAND",
    "dropphyst": "PA",
    "dropphyzpp": 150599998,
    "dropmaladd": "831 MIDLAND AVE",
    "dropmalcty": "MIDLAND",
    "dropmalst": "PA",
    "dropmalzpp": 150599998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246439180,
    "dropsitcph": 7246439180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19804",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "100 JEFFERSON ST",
    "dropdelcty": "MIDWAY",
    "dropdelst": "PA",
    "dropdelzpp": 150601001,
    "dropphyadd": "100 JEFFERSON ST",
    "dropphycty": "MIDWAY",
    "dropphyst": "PA",
    "dropphyzpp": 150601001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDWAY",
    "dropmalst": "PA",
    "dropmalzpp": 150609998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247965121,
    "dropsitcph": 7247965121,
    "dropfax": 7247965548
  },
  {
    "dcode": "D",
    "dropkey": "PX19806",
    "droptype": "D",
    "dropname": "MIFFLIN",
    "dropdeladd": "112 MAIN ST",
    "dropdelcty": "MIFFLIN",
    "dropdelst": "PA",
    "dropdelzpp": 170589998,
    "dropphyadd": "112 MAIN ST",
    "dropphycty": "MIFFLIN",
    "dropphyst": "PA",
    "dropphyzpp": 170589998,
    "dropmaladd": "112 MAIN ST",
    "dropmalcty": "MIFFLIN",
    "dropmalst": "PA",
    "dropmalzpp": 170589998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174368389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19808",
    "droptype": "D",
    "dropname": "MIFFLINBURG",
    "dropdeladd": "10 N 4TH ST",
    "dropdelcty": "MIFFLINBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178449998,
    "dropphyadd": "10 N 4TH ST",
    "dropphycty": "MIFFLINBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178449998,
    "dropmaladd": "10 N 4TH ST",
    "dropmalcty": "MIFFLINBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709660501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19809",
    "droptype": "D",
    "dropname": "MIFFLINTOWN",
    "dropdeladd": "150 BRIDGE ST",
    "dropdelcty": "MIFFLINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170599998,
    "dropphyadd": "150 BRIDGE ST",
    "dropphycty": "MIFFLINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170599998,
    "dropmaladd": "150 BRIDGE ST",
    "dropmalcty": "MIFFLINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170599998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174362515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19810",
    "droptype": "D",
    "dropname": "MIFFLINVILLE",
    "dropdeladd": "206 MARKET ST",
    "dropdelcty": "MIFFLINVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 186319998,
    "dropphyadd": "206 MARKET ST",
    "dropphycty": "MIFFLINVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 186319998,
    "dropmaladd": "206 MARKET ST",
    "dropmalcty": "MIFFLINVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 186319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5707591318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19813",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "28364 ROUTE 220",
    "dropdelcty": "MILAN",
    "dropdelst": "PA",
    "dropdelzpp": 188319998,
    "dropphyadd": "28364 ROUTE 220",
    "dropphycty": "MILAN",
    "dropphyst": "PA",
    "dropphyzpp": 188319998,
    "dropmaladd": "28364 ROUTE 220",
    "dropmalcty": "MILAN",
    "dropmalst": "PA",
    "dropmalzpp": 188319998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708885089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19814",
    "droptype": "D",
    "dropname": "MILANVILLE",
    "dropdeladd": "1143 RIVER RD STE B",
    "dropdelcty": "MILANVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 184439998,
    "dropphyadd": "1143 RIVER RD STE B",
    "dropphycty": "MILANVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 184439998,
    "dropmaladd": "1143 RIVER RD STE B",
    "dropmalcty": "MILANVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 184439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5707297907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19817",
    "droptype": "D",
    "dropname": "MILDRED",
    "dropdeladd": "54 JACKSON ST",
    "dropdelcty": "MILDRED",
    "dropdelst": "PA",
    "dropdelzpp": 186329998,
    "dropphyadd": "54 JACKSON ST",
    "dropphycty": "MILDRED",
    "dropphyst": "PA",
    "dropphyzpp": 186329998,
    "dropmaladd": "54 JACKSON ST",
    "dropmalcty": "MILDRED",
    "dropmalst": "PA",
    "dropmalzpp": 186329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5709288238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19820",
    "droptype": "D",
    "dropname": "MILESBURG",
    "dropdeladd": "202 MILL ST",
    "dropdelcty": "MILESBURG",
    "dropdelst": "PA",
    "dropdelzpp": 168539998,
    "dropphyadd": "202 MILL ST",
    "dropphycty": "MILESBURG",
    "dropphyst": "PA",
    "dropphyzpp": 168539998,
    "dropmaladd": "202 MILL ST",
    "dropmalcty": "MILESBURG",
    "dropmalst": "PA",
    "dropmalzpp": 168539998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143555901,
    "dropsitcph": 8143555901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19822",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "200 W HARFORD ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "PA",
    "dropdelzpp": 183379998,
    "dropphyadd": "200 W HARFORD ST",
    "dropphycty": "MILFORD",
    "dropphyst": "PA",
    "dropphyzpp": 183379998,
    "dropmaladd": "200 W HARFORD ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "PA",
    "dropmalzpp": 183379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5702967411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19823",
    "droptype": "D",
    "dropname": "MILFORD SQUARE",
    "dropdeladd": "2112 ALLENTOWN RD",
    "dropdelcty": "MILFORD SQUARE",
    "dropdelst": "PA",
    "dropdelzpp": 189359998,
    "dropphyadd": "2112 ALLENTOWN RD",
    "dropphycty": "MILFORD SQUARE",
    "dropphyst": "PA",
    "dropphyzpp": 189359998,
    "dropmaladd": "2112 ALLENTOWN RD",
    "dropmalcty": "MILFORD SQUARE",
    "dropmalst": "PA",
    "dropmalzpp": 189359998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2155364666,
    "dropsitcph": 2155364666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19824",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "9787 MAIN ST",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "PA",
    "dropdelzpp": 170609998,
    "dropphyadd": "9787 MAIN ST",
    "dropphycty": "MILL CREEK",
    "dropphyst": "PA",
    "dropphyzpp": 170609998,
    "dropmaladd": "9787 MAIN ST",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "PA",
    "dropmalzpp": 170609998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8146432154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19829",
    "droptype": "D",
    "dropname": "MILL HALL",
    "dropdeladd": "15 PENNSYLVANIA AVE",
    "dropdelcty": "MILL HALL",
    "dropdelst": "PA",
    "dropdelzpp": 177519998,
    "dropphyadd": "15 PENNSYLVANIA AVE",
    "dropphycty": "MILL HALL",
    "dropphyst": "PA",
    "dropphyzpp": 177519998,
    "dropmaladd": "15 PENNSYLVANIA AVE",
    "dropmalcty": "MILL HALL",
    "dropmalst": "PA",
    "dropmalzpp": 177519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5707264717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19830",
    "droptype": "D",
    "dropname": "MILL RUN",
    "dropdeladd": "105 STEWARTON RD",
    "dropdelcty": "MILL RUN",
    "dropdelst": "PA",
    "dropdelzpp": 154641021,
    "dropphyadd": "105 STEWARTON RD",
    "dropphycty": "MILL RUN",
    "dropphyst": "PA",
    "dropphyzpp": 154641021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILL RUN",
    "dropmalst": "PA",
    "dropmalzpp": 154649998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244552305,
    "dropsitcph": 7244552305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19831",
    "droptype": "D",
    "dropname": "MILL VILLAGE",
    "dropdeladd": "14525 S MAIN ST",
    "dropdelcty": "MILL VILLAGE",
    "dropdelst": "PA",
    "dropdelzpp": 164279800,
    "dropphyadd": "14525 S MAIN ST",
    "dropphycty": "MILL VILLAGE",
    "dropphyst": "PA",
    "dropphyzpp": 164279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILL VILLAGE",
    "dropmalst": "PA",
    "dropmalzpp": 164279998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147962730,
    "dropsitcph": 8147962730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19838",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "225 UNION ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 170619998,
    "dropphyadd": "225 UNION ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 170619998,
    "dropmaladd": "225 UNION ST",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 170619998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176924145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19839",
    "droptype": "D",
    "dropname": "MILLERSTOWN",
    "dropdeladd": "12 N MARKET ST",
    "dropdelcty": "MILLERSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170629998,
    "dropphyadd": "12 N MARKET ST",
    "dropphycty": "MILLERSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170629998,
    "dropmaladd": "12 N MARKET ST",
    "dropmalcty": "MILLERSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170629998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7175893154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19840",
    "droptype": "D",
    "dropname": "MILLERSVILLE",
    "dropdeladd": "431 N GEORGE ST",
    "dropdelcty": "MILLERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175519998,
    "dropphyadd": "431 N GEORGE ST",
    "dropphycty": "MILLERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175519998,
    "dropmaladd": "431 N GEORGE ST",
    "dropmalcty": "MILLERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175519998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7178725011,
    "dropsitcph": 7178725011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19843",
    "droptype": "D",
    "dropname": "MILLERTON",
    "dropdeladd": "45 BACK ST",
    "dropdelcty": "MILLERTON",
    "dropdelst": "PA",
    "dropdelzpp": 169369998,
    "dropphyadd": "45 BACK ST",
    "dropphycty": "MILLERTON",
    "dropphyst": "PA",
    "dropphyzpp": 169369998,
    "dropmaladd": "45 BACK ST",
    "dropmalcty": "MILLERTON",
    "dropmalst": "PA",
    "dropmalzpp": 169369998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 5705372267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19844",
    "droptype": "D",
    "dropname": "MILLHEIM",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "MILLHEIM",
    "dropdelst": "PA",
    "dropdelzpp": 168549998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "MILLHEIM",
    "dropphyst": "PA",
    "dropphyzpp": 168549998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "MILLHEIM",
    "dropmalst": "PA",
    "dropmalzpp": 168549998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143495522,
    "dropsitcph": 8143495522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19845",
    "droptype": "D",
    "dropname": "MILLMONT",
    "dropdeladd": "1295 MILLMONT RD",
    "dropdelcty": "MILLMONT",
    "dropdelst": "PA",
    "dropdelzpp": 178459998,
    "dropphyadd": "1295 MILLMONT RD",
    "dropphycty": "MILLMONT",
    "dropphyst": "PA",
    "dropphyzpp": 178459998,
    "dropmaladd": "1295 MILLMONT RD",
    "dropmalcty": "MILLMONT",
    "dropmalst": "PA",
    "dropmalzpp": 178459998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5709221211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19848",
    "droptype": "D",
    "dropname": "MILLRIFT",
    "dropdeladd": "125 BLUESTONE BLVD",
    "dropdelcty": "MILLRIFT",
    "dropdelst": "PA",
    "dropdelzpp": 183409998,
    "dropphyadd": "125 BLUESTONE BLVD",
    "dropphycty": "MILLRIFT",
    "dropphyst": "PA",
    "dropphyzpp": 183409998,
    "dropmaladd": "125 BLUESTONE BLVD",
    "dropmalcty": "MILLRIFT",
    "dropmalst": "PA",
    "dropmalzpp": 183409998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704914605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19849",
    "droptype": "D",
    "dropname": "MILLS",
    "dropdeladd": "5021 STATE ROUTE 49 W",
    "dropdelcty": "MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 169379998,
    "dropphyadd": "5021 STATE ROUTE 49 W",
    "dropphycty": "MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 169379998,
    "dropmaladd": "5021 STATE ROUTE 49 W",
    "dropmalcty": "MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 169379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 8143345651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19850",
    "droptype": "D",
    "dropname": "MILLSBORO",
    "dropdeladd": "21 MILL ST",
    "dropdelcty": "MILLSBORO",
    "dropdelst": "PA",
    "dropdelzpp": 153481001,
    "dropphyadd": "21 MILL ST",
    "dropphycty": "MILLSBORO",
    "dropphyst": "PA",
    "dropphyzpp": 153481001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLSBORO",
    "dropmalst": "PA",
    "dropmalzpp": 153489998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243743718,
    "dropsitcph": 7243743718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19852",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "10 E MAIN ST",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 178469998,
    "dropphyadd": "10 E MAIN ST",
    "dropphycty": "MILLVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 178469998,
    "dropmaladd": "10 E MAIN ST",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 178469998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5704586637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19856",
    "droptype": "D",
    "dropname": "MILNESVILLE",
    "dropdeladd": "1620 N CHURCH ST",
    "dropdelcty": "MILNESVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 182399998,
    "dropphyadd": "1620 N CHURCH ST",
    "dropphycty": "MILNESVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 182399998,
    "dropmaladd": "1620 N CHURCH ST",
    "dropmalcty": "MILNESVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 182399998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704557857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19860",
    "droptype": "D",
    "dropname": "MILROY",
    "dropdeladd": "90 S MAIN ST",
    "dropdelcty": "MILROY",
    "dropdelst": "PA",
    "dropdelzpp": 170639998,
    "dropphyadd": "90 S MAIN ST",
    "dropphycty": "MILROY",
    "dropphyst": "PA",
    "dropphyzpp": 170639998,
    "dropmaladd": "90 S MAIN ST",
    "dropmalcty": "MILROY",
    "dropmalst": "PA",
    "dropmalzpp": 170639998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7176673489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19861",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "29 N FRONT ST",
    "dropdelcty": "MILTON",
    "dropdelst": "PA",
    "dropdelzpp": 178479998,
    "dropphyadd": "29 N FRONT ST",
    "dropphycty": "MILTON",
    "dropphyst": "PA",
    "dropphyzpp": 178479998,
    "dropmaladd": "29 N FRONT ST",
    "dropmalcty": "MILTON",
    "dropmalst": "PA",
    "dropmalzpp": 178479998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5707427301,
    "dropfax": 5707429811
  },
  {
    "dcode": "D",
    "dropkey": "PX19864",
    "droptype": "D",
    "dropname": "MINERAL POINT",
    "dropdeladd": "784 MINERAL POINT RD",
    "dropdelcty": "MINERAL POINT",
    "dropdelst": "PA",
    "dropdelzpp": 159429998,
    "dropphyadd": "784 MINERAL POINT RD",
    "dropphycty": "MINERAL POINT",
    "dropphyst": "PA",
    "dropphyzpp": 159429998,
    "dropmaladd": "784 MINERAL POINT RD",
    "dropmalcty": "MINERAL POINT",
    "dropmalst": "PA",
    "dropmalzpp": 159429998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143223223,
    "dropsitcph": 8143223223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19865",
    "droptype": "D",
    "dropname": "MINERAL SPRINGS",
    "dropdeladd": "244 POST OFFICE RD",
    "dropdelcty": "MINERAL SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 168559998,
    "dropphyadd": "244 POST OFFICE RD",
    "dropphycty": "MINERAL SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 168559998,
    "dropmaladd": "244 POST OFFICE RD",
    "dropmalcty": "MINERAL SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 168559998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8148577336,
    "dropsitcph": 8148577336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19867",
    "droptype": "D",
    "dropname": "MINERSVILLE",
    "dropdeladd": "407 SUNBURY ST",
    "dropdelcty": "MINERSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 179549998,
    "dropphyadd": "407 SUNBURY ST",
    "dropphycty": "MINERSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 179549998,
    "dropmaladd": "407 SUNBURY ST",
    "dropmalcty": "MINERSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 179549998,
    "dropsitphn": 7173968782,
    "dropsitlph": 5705443490,
    "dropsitcph": 5705443490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19870",
    "droptype": "D",
    "dropname": "MINGOVILLE",
    "dropdeladd": "101 HECLA RD",
    "dropdelcty": "MINGOVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 168569998,
    "dropphyadd": "101 HECLA RD",
    "dropphycty": "MINGOVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 168569998,
    "dropmaladd": "101 HECLA RD",
    "dropmalcty": "MINGOVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 168569998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143834811,
    "dropsitcph": 8143834811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19871",
    "droptype": "D",
    "dropname": "MINISINK HILLS",
    "dropdeladd": "0 RIVER RD",
    "dropdelcty": "MINISINK HILLS",
    "dropdelst": "PA",
    "dropdelzpp": 183419900,
    "dropphyadd": "0 RIVER RD",
    "dropphycty": "MINISINK HILLS",
    "dropphyst": "PA",
    "dropphyzpp": 183419900,
    "dropmaladd": "0 RIVER RD",
    "dropmalcty": "MINISINK HILLS",
    "dropmalst": "PA",
    "dropmalzpp": 183419900,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5704246423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19878",
    "droptype": "D",
    "dropname": "MODENA",
    "dropdeladd": "108 N BRANDYWINE AVE",
    "dropdelcty": "MODENA",
    "dropdelst": "PA",
    "dropdelzpp": 193589998,
    "dropphyadd": "108 N BRANDYWINE AVE",
    "dropphycty": "MODENA",
    "dropphyst": "PA",
    "dropphyzpp": 193589998,
    "dropmaladd": "108 N BRANDYWINE AVE",
    "dropmalcty": "MODENA",
    "dropmalst": "PA",
    "dropmalzpp": 193589998,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103849105,
    "dropsitcph": 6103849105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19881",
    "droptype": "D",
    "dropname": "MOHNTON",
    "dropdeladd": "328 E WYOMISSING AVE",
    "dropdelcty": "MOHNTON",
    "dropdelst": "PA",
    "dropdelzpp": 195409998,
    "dropphyadd": "328 E WYOMISSING AVE",
    "dropphycty": "MOHNTON",
    "dropphyst": "PA",
    "dropphyzpp": 195409998,
    "dropmaladd": "328 E WYOMISSING AVE",
    "dropmalcty": "MOHNTON",
    "dropmalst": "PA",
    "dropmalzpp": 195409998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6107771101,
    "dropsitcph": 6107771101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19882",
    "droptype": "D",
    "dropname": "MOHRSVILLE",
    "dropdeladd": "518 MAIN ST",
    "dropdelcty": "MOHRSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195419998,
    "dropphyadd": "518 MAIN ST",
    "dropphycty": "MOHRSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195419998,
    "dropmaladd": "518 MAIN ST",
    "dropmalcty": "MOHRSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195419998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109263498,
    "dropsitcph": 6109263498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19887",
    "droptype": "D",
    "dropname": "MONACA",
    "dropdeladd": "1015 PENNSYLVANIA AVE",
    "dropdelcty": "MONACA",
    "dropdelst": "PA",
    "dropdelzpp": 150619998,
    "dropphyadd": "1015 PENNSYLVANIA AVE",
    "dropphycty": "MONACA",
    "dropphyst": "PA",
    "dropphyzpp": 150619998,
    "dropmaladd": "1015 PENNSYLVANIA AVE",
    "dropmalcty": "MONACA",
    "dropmalst": "PA",
    "dropmalzpp": 150619998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7247742691,
    "dropsitcph": 7247742691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19888",
    "droptype": "D",
    "dropname": "MONESSEN",
    "dropdeladd": "821 DONNER AVE",
    "dropdelcty": "MONESSEN",
    "dropdelst": "PA",
    "dropdelzpp": 150629998,
    "dropphyadd": "821 DONNER AVE",
    "dropphycty": "MONESSEN",
    "dropphyst": "PA",
    "dropphyzpp": 150629998,
    "dropmaladd": "821 DONNER AVE",
    "dropmalcty": "MONESSEN",
    "dropmalst": "PA",
    "dropmalzpp": 150629998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7246846492,
    "dropsitcph": 7246846492,
    "dropfax": 7246846837
  },
  {
    "dcode": "D",
    "dropkey": "PX19892",
    "droptype": "D",
    "dropname": "MONOCACY STATION",
    "dropdeladd": "207 N MAIN ST",
    "dropdelcty": "DOUGLASSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 195187102,
    "dropphyadd": "207 N MAIN ST",
    "dropphycty": "DOUGLASSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 195187102,
    "dropmaladd": "207 N MAIN ST",
    "dropmalcty": "DOUGLASSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 195187102,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103856300,
    "dropsitcph": 6103856300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19893",
    "droptype": "D",
    "dropname": "MONONGAHELA",
    "dropdeladd": "312 CHESS ST",
    "dropdelcty": "MONONGAHELA",
    "dropdelst": "PA",
    "dropdelzpp": 150639998,
    "dropphyadd": "312 CHESS ST",
    "dropphycty": "MONONGAHELA",
    "dropphyst": "PA",
    "dropphyzpp": 150639998,
    "dropmaladd": "312 CHESS ST",
    "dropmalcty": "MONONGAHELA",
    "dropmalst": "PA",
    "dropmalzpp": 150639998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242580667,
    "dropsitcph": 7242580667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19895",
    "droptype": "D",
    "dropname": "MONROETON",
    "dropdeladd": "264 SHAW BLVD",
    "dropdelcty": "MONROETON",
    "dropdelst": "PA",
    "dropdelzpp": 188329998,
    "dropphyadd": "264 SHAW BLVD",
    "dropphycty": "MONROETON",
    "dropphyst": "PA",
    "dropphyzpp": 188329998,
    "dropmaladd": "264 SHAW BLVD",
    "dropmalcty": "MONROETON",
    "dropmalst": "PA",
    "dropmalzpp": 188329998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702652868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19898",
    "droptype": "D",
    "dropname": "MONT ALTO",
    "dropdeladd": "3 ASH ST",
    "dropdelcty": "MONT ALTO",
    "dropdelst": "PA",
    "dropdelzpp": 172379998,
    "dropphyadd": "3 ASH ST",
    "dropphycty": "MONT ALTO",
    "dropphyst": "PA",
    "dropphyzpp": 172379998,
    "dropmaladd": "3 ASH ST",
    "dropmalcty": "MONT ALTO",
    "dropmalst": "PA",
    "dropmalzpp": 172379998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7177493536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19900",
    "droptype": "D",
    "dropname": "MONTANDON",
    "dropdeladd": "97 MAIN ST",
    "dropdelcty": "MONTANDON",
    "dropdelst": "PA",
    "dropdelzpp": 178509998,
    "dropphyadd": "97 MAIN ST",
    "dropphycty": "MONTANDON",
    "dropphyst": "PA",
    "dropphyzpp": 178509998,
    "dropmaladd": "97 MAIN ST",
    "dropmalcty": "MONTANDON",
    "dropmalst": "PA",
    "dropmalzpp": 178509998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705249464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19905",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "1 HENRY HAND DR",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "PA",
    "dropdelzpp": 177529998,
    "dropphyadd": "1 HENRY HAND DR",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "PA",
    "dropphyzpp": 177529998,
    "dropmaladd": "1 HENRY HAND DR",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "PA",
    "dropmalzpp": 177529998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5705472551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19907",
    "droptype": "D",
    "dropname": "MONTGOMERYVILLE",
    "dropdeladd": "411 DOYLESTOWN RD",
    "dropdelcty": "MONTGOMERYVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 189369998,
    "dropphyadd": "411 DOYLESTOWN RD",
    "dropphycty": "MONTGOMERYVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 189369998,
    "dropmaladd": "411 DOYLESTOWN RD",
    "dropmalcty": "MONTGOMERYVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 189369998,
    "dropsitphn": 6109646414,
    "dropsitlph": 2158550166,
    "dropsitcph": 2158550166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19909",
    "droptype": "D",
    "dropname": "MONTOURSVILLE",
    "dropdeladd": "335 BROAD ST",
    "dropdelcty": "MONTOURSVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 177549800,
    "dropphyadd": "335 BROAD ST",
    "dropphycty": "MONTOURSVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 177549800,
    "dropmaladd": "335 BROAD ST",
    "dropmalcty": "MONTOURSVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 177549800,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703688601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19910",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "38 MONUMENT SQ",
    "dropdelcty": "MONTROSE",
    "dropdelst": "PA",
    "dropdelzpp": 188019998,
    "dropphyadd": "38 MONUMENT SQ",
    "dropphycty": "MONTROSE",
    "dropphyst": "PA",
    "dropphyzpp": 188019998,
    "dropmaladd": "38 MONUMENT SQ",
    "dropmalcty": "MONTROSE",
    "dropmalst": "PA",
    "dropmalzpp": 188019998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5702783871,
    "dropfax": 5702789009
  },
  {
    "dcode": "D",
    "dropkey": "PX19918",
    "droptype": "D",
    "dropname": "MORANN",
    "dropdeladd": "3492 GINTER MORANN HWY",
    "dropdelcty": "MORANN",
    "dropdelst": "PA",
    "dropdelzpp": 166639998,
    "dropphyadd": "3492 GINTER MORANN HWY",
    "dropphycty": "MORANN",
    "dropphyst": "PA",
    "dropphyzpp": 166639998,
    "dropmaladd": "3492 GINTER MORANN HWY",
    "dropmalcty": "MORANN",
    "dropmalst": "PA",
    "dropmalzpp": 166639998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143785270,
    "dropsitcph": 8143785270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19922",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "514 MILLERS RUN RD",
    "dropdelcty": "MORGAN",
    "dropdelst": "PA",
    "dropdelzpp": 150649998,
    "dropphyadd": "514 MILLERS RUN RD",
    "dropphycty": "MORGAN",
    "dropphyst": "PA",
    "dropphyzpp": 150649998,
    "dropmaladd": "514 MILLERS RUN RD",
    "dropmalcty": "MORGAN",
    "dropmalst": "PA",
    "dropmalzpp": 150649998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122213814,
    "dropsitcph": 4122213814,
    "dropfax": 4122215116
  },
  {
    "dcode": "D",
    "dropkey": "PX19923",
    "droptype": "D",
    "dropname": "MORGANTOWN",
    "dropdeladd": "101 N MULBERRY ST",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 195439998,
    "dropphyadd": "101 N MULBERRY ST",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 195439998,
    "dropmaladd": "101 N MULBERRY ST",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 195439998,
    "dropsitphn": 7173968782,
    "dropsitlph": 6102869100,
    "dropsitcph": 6102869100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19926",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "917 ROUTE 287",
    "dropdelcty": "MORRIS",
    "dropdelst": "PA",
    "dropdelzpp": 169389998,
    "dropphyadd": "917 ROUTE 287",
    "dropphycty": "MORRIS",
    "dropphyst": "PA",
    "dropphyzpp": 169389998,
    "dropmaladd": "917 ROUTE 287",
    "dropmalcty": "MORRIS",
    "dropmalst": "PA",
    "dropmalzpp": 169389998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 7173536001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19927",
    "droptype": "D",
    "dropname": "MORRIS RUN",
    "dropdeladd": "1043 MORRIS RUN RD",
    "dropdelcty": "MORRIS RUN",
    "dropdelst": "PA",
    "dropdelzpp": 169399998,
    "dropphyadd": "1043 MORRIS RUN RD",
    "dropphycty": "MORRIS RUN",
    "dropphyst": "PA",
    "dropphyzpp": 169399998,
    "dropmaladd": "1043 MORRIS RUN RD",
    "dropmalcty": "MORRIS RUN",
    "dropmalst": "PA",
    "dropmalzpp": 169399998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5706383033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19928",
    "droptype": "D",
    "dropname": "MORRISDALE",
    "dropdeladd": "52 CHURCH ST",
    "dropdelcty": "MORRISDALE",
    "dropdelst": "PA",
    "dropdelzpp": 168589998,
    "dropphyadd": "52 CHURCH ST",
    "dropphycty": "MORRISDALE",
    "dropphyst": "PA",
    "dropphyzpp": 168589998,
    "dropmaladd": "52 CHURCH ST",
    "dropmalcty": "MORRISDALE",
    "dropmalst": "PA",
    "dropmalzpp": 168589998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143421514,
    "dropsitcph": 8143421514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19929",
    "droptype": "D",
    "dropname": "MORRISVILLE",
    "dropdeladd": "950 W TRENTON AVE",
    "dropdelcty": "MORRISVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 190679998,
    "dropphyadd": "950 W TRENTON AVE",
    "dropphycty": "MORRISVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 190679998,
    "dropmaladd": "950 W TRENTON AVE",
    "dropmalcty": "MORRISVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 190679998,
    "dropsitphn": 2157360822,
    "dropsitlph": 2152956444,
    "dropsitcph": 2157360822,
    "dropfax": 2152952547
  },
  {
    "dcode": "D",
    "dropkey": "PX19930",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "128 YALE AVE",
    "dropdelcty": "MORTON",
    "dropdelst": "PA",
    "dropdelzpp": 190709998,
    "dropphyadd": "128 YALE AVE",
    "dropphycty": "MORTON",
    "dropphyst": "PA",
    "dropphyzpp": 190709998,
    "dropmaladd": "128 YALE AVE",
    "dropmalcty": "MORTON",
    "dropmalst": "PA",
    "dropmalzpp": 190709998,
    "dropsitphn": 6105431417,
    "dropsitlph": 6105431417,
    "dropsitcph": 6105431417,
    "dropfax": 6105434158
  },
  {
    "dcode": "D",
    "dropkey": "PX19934",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "331 N MAIN ST",
    "dropdelcty": "MOSCOW",
    "dropdelst": "PA",
    "dropdelzpp": 184449998,
    "dropphyadd": "331 N MAIN ST",
    "dropphycty": "MOSCOW",
    "dropphyst": "PA",
    "dropphyzpp": 184449998,
    "dropmaladd": "331 N MAIN ST",
    "dropmalcty": "MOSCOW",
    "dropmalst": "PA",
    "dropmalzpp": 184449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5708427212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19937",
    "droptype": "D",
    "dropname": "MOSHANNON",
    "dropdeladd": "1511 W SYCAMORE RD",
    "dropdelcty": "MOSHANNON",
    "dropdelst": "PA",
    "dropdelzpp": 168599998,
    "dropphyadd": "1511 W SYCAMORE RD",
    "dropphycty": "MOSHANNON",
    "dropphyst": "PA",
    "dropphyzpp": 168599998,
    "dropmaladd": "1511 W SYCAMORE RD",
    "dropmalcty": "MOSHANNON",
    "dropmalst": "PA",
    "dropmalzpp": 168599998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143874283,
    "dropsitcph": 8143874283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19940",
    "droptype": "D",
    "dropname": "MOUNT AETNA",
    "dropdeladd": "2 E MILL ST",
    "dropdelcty": "MOUNT AETNA",
    "dropdelst": "PA",
    "dropdelzpp": 195449998,
    "dropphyadd": "2 E MILL ST",
    "dropphycty": "MOUNT AETNA",
    "dropphyst": "PA",
    "dropphyzpp": 195449998,
    "dropmaladd": "2 E MILL ST",
    "dropmalcty": "MOUNT AETNA",
    "dropmalst": "PA",
    "dropmalzpp": 195449998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7179338656,
    "dropsitcph": 7179338656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19946",
    "droptype": "D",
    "dropname": "MOUNT BETHEL",
    "dropdeladd": "2 MOUNT BETHEL PLZ",
    "dropdelcty": "MOUNT BETHEL",
    "dropdelst": "PA",
    "dropdelzpp": 183439998,
    "dropphyadd": "2 MOUNT BETHEL PLZ",
    "dropphycty": "MOUNT BETHEL",
    "dropphyst": "PA",
    "dropphyzpp": 183439998,
    "dropmaladd": "2 MOUNT BETHEL PLZ",
    "dropmalcty": "MOUNT BETHEL",
    "dropmalst": "PA",
    "dropmalzpp": 183439998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708975131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19947",
    "droptype": "D",
    "dropname": "MOUNT BRADDOCK",
    "dropdeladd": "5 FERGUSON RD",
    "dropdelcty": "MOUNT BRADDOCK",
    "dropdelst": "PA",
    "dropdelzpp": 154651001,
    "dropphyadd": "5 FERGUSON RD",
    "dropphycty": "MOUNT BRADDOCK",
    "dropphyst": "PA",
    "dropphyzpp": 154651001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT BRADDOCK",
    "dropmalst": "PA",
    "dropmalzpp": 154659998,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242774400,
    "dropsitcph": 7242774400,
    "dropfax": 7242774400
  },
  {
    "dcode": "D",
    "dropkey": "PX19949",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "1 S HICKORY ST",
    "dropdelcty": "MOUNT CARMEL",
    "dropdelst": "PA",
    "dropdelzpp": 178519998,
    "dropphyadd": "1 S HICKORY ST",
    "dropphycty": "MOUNT CARMEL",
    "dropphyst": "PA",
    "dropphyzpp": 178519998,
    "dropmaladd": "1 S HICKORY ST",
    "dropmalcty": "MOUNT CARMEL",
    "dropmalst": "PA",
    "dropmalzpp": 178519998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5703391300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19950",
    "droptype": "D",
    "dropname": "MOUNT GRETNA",
    "dropdeladd": "101 PRINCETON AVE",
    "dropdelcty": "MOUNT GRETNA",
    "dropdelst": "PA",
    "dropdelzpp": 170649800,
    "dropphyadd": "101 PRINCETON AVE",
    "dropphycty": "MOUNT GRETNA",
    "dropphyst": "PA",
    "dropphyzpp": 170649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT GRETNA",
    "dropmalst": "PA",
    "dropmalzpp": 170649998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7179643804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19952",
    "droptype": "D",
    "dropname": "MOUNT HOLLY SPRINGS",
    "dropdeladd": "16 W PINE ST",
    "dropdelcty": "MOUNT HOLLY SPRINGS",
    "dropdelst": "PA",
    "dropdelzpp": 170659998,
    "dropphyadd": "16 W PINE ST",
    "dropphycty": "MOUNT HOLLY SPRINGS",
    "dropphyst": "PA",
    "dropphyzpp": 170659998,
    "dropmaladd": "16 W PINE ST",
    "dropmalcty": "MOUNT HOLLY SPRINGS",
    "dropmalst": "PA",
    "dropmalzpp": 170659998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174863468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19954",
    "droptype": "D",
    "dropname": "MOUNT JEWETT",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "MOUNT JEWETT",
    "dropdelst": "PA",
    "dropdelzpp": 167409800,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "MOUNT JEWETT",
    "dropphyst": "PA",
    "dropphyzpp": 167409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT JEWETT",
    "dropmalst": "PA",
    "dropmalzpp": 167409998,
    "dropsitphn": 8148367307,
    "dropsitlph": 8147785731,
    "dropsitcph": 8147785731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19956",
    "droptype": "D",
    "dropname": "MOUNT JOY",
    "dropdeladd": "1 E MAIN ST",
    "dropdelcty": "MOUNT JOY",
    "dropdelst": "PA",
    "dropdelzpp": 175529998,
    "dropphyadd": "1 E MAIN ST",
    "dropphycty": "MOUNT JOY",
    "dropphyst": "PA",
    "dropphyzpp": 175529998,
    "dropmaladd": "1 E MAIN ST",
    "dropmalcty": "MOUNT JOY",
    "dropmalst": "PA",
    "dropmalzpp": 175529998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176539429,
    "dropsitcph": 7176534231,
    "dropfax": 7176530015
  },
  {
    "dcode": "D",
    "dropkey": "PX19959",
    "droptype": "D",
    "dropname": "MOUNT MORRIS",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "MOUNT MORRIS",
    "dropdelst": "PA",
    "dropdelzpp": 153491001,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "MOUNT MORRIS",
    "dropphyst": "PA",
    "dropphyzpp": 153491001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT MORRIS",
    "dropmalst": "PA",
    "dropmalzpp": 153499998,
    "dropsitphn": 7249566000,
    "dropsitlph": 7249566000,
    "dropsitcph": 7249566000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19971",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "24 RUMBAUGH AVE",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "PA",
    "dropdelzpp": 156669998,
    "dropphyadd": "24 RUMBAUGH AVE",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "PA",
    "dropphyzpp": 156669998,
    "dropmaladd": "24 RUMBAUGH AVE",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "PA",
    "dropmalzpp": 156669998,
    "dropsitphn": 4123597568,
    "dropsitlph": "",
    "dropsitcph": 7245473409,
    "dropfax": 4125470688
  },
  {
    "dcode": "D",
    "dropkey": "PX19973",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT MILLS",
    "dropdeladd": "9116 ROUTE 35",
    "dropdelcty": "MOUNT PLEASANT MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 178539998,
    "dropphyadd": "9116 ROUTE 35",
    "dropphycty": "MOUNT PLEASANT MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 178539998,
    "dropmaladd": "9116 ROUTE 35",
    "dropmalcty": "MOUNT PLEASANT MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 178539998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 5705392922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19974",
    "droptype": "D",
    "dropname": "MOUNT POCONO",
    "dropdeladd": "11 PINE HILL RD",
    "dropdelcty": "MOUNT POCONO",
    "dropdelst": "PA",
    "dropdelzpp": 183449998,
    "dropphyadd": "11 PINE HILL RD",
    "dropphycty": "MOUNT POCONO",
    "dropphyst": "PA",
    "dropphyzpp": 183449998,
    "dropmaladd": "11 PINE HILL RD",
    "dropmalcty": "MOUNT POCONO",
    "dropmalst": "PA",
    "dropmalzpp": 183449998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5708397461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19979",
    "droptype": "D",
    "dropname": "MOUNT UNION",
    "dropdeladd": "35 W MARKET ST",
    "dropdelcty": "MOUNT UNION",
    "dropdelst": "PA",
    "dropdelzpp": 170669998,
    "dropphyadd": "35 W MARKET ST",
    "dropphycty": "MOUNT UNION",
    "dropphyst": "PA",
    "dropphyzpp": 170669998,
    "dropmaladd": "35 W MARKET ST",
    "dropmalcty": "MOUNT UNION",
    "dropmalst": "PA",
    "dropmalzpp": 170669998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 8145422566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19984",
    "droptype": "D",
    "dropname": "MOUNT WOLF",
    "dropdeladd": "94 S 4TH ST",
    "dropdelcty": "MOUNT WOLF",
    "dropdelst": "PA",
    "dropdelzpp": 173479998,
    "dropphyadd": "94 S 4TH ST",
    "dropphycty": "MOUNT WOLF",
    "dropphyst": "PA",
    "dropphyzpp": 173479998,
    "dropmaladd": "94 S 4TH ST",
    "dropmalcty": "MOUNT WOLF",
    "dropmalst": "PA",
    "dropmalzpp": 173479998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172661418,
    "dropsitcph": 7172661418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19990",
    "droptype": "D",
    "dropname": "MOUNTAINHOME",
    "dropdeladd": "1099 ROUTE 390 STE 102",
    "dropdelcty": "MOUNTAINHOME",
    "dropdelst": "PA",
    "dropdelzpp": 183429998,
    "dropphyadd": "1099 ROUTE 390 STE 102",
    "dropphycty": "MOUNTAINHOME",
    "dropphyst": "PA",
    "dropphyzpp": 183429998,
    "dropmaladd": "1099 ROUTE 390 STE 102",
    "dropmalcty": "MOUNTAINHOME",
    "dropmalst": "PA",
    "dropmalzpp": 183429998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 5705952204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX19994",
    "droptype": "D",
    "dropname": "MOUNTVILLE",
    "dropdeladd": "6 S BRIDGE ST",
    "dropdelcty": "MOUNTVILLE",
    "dropdelst": "PA",
    "dropdelzpp": 175549998,
    "dropphyadd": "6 S BRIDGE ST",
    "dropphycty": "MOUNTVILLE",
    "dropphyst": "PA",
    "dropphyzpp": 175549998,
    "dropmaladd": "6 S BRIDGE ST",
    "dropmalcty": "MOUNTVILLE",
    "dropmalst": "PA",
    "dropmalzpp": 175549998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7172857859,
    "dropsitcph": 7172857859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX2A581",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "15075 HIGHLAND DR",
    "dropdelcty": "MC KENZIE",
    "dropdelst": "TN",
    "dropdelzpp": 382012356,
    "dropphyadd": "15075 HIGHLAND DR",
    "dropphycty": "MC KENZIE",
    "dropphyst": "TN",
    "dropphyzpp": 382012356,
    "dropmaladd": "15075 HIGHLAND DR",
    "dropmalcty": "MC KENZIE",
    "dropmalst": "TN",
    "dropmalzpp": 382012356,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9013527977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20005",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "720 US HIGHWAY 52",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "OH",
    "dropdelzpp": 451019998,
    "dropphyadd": "720 US HIGHWAY 52",
    "dropphycty": "ABERDEEN",
    "dropphyst": "OH",
    "dropphyzpp": 451019998,
    "dropmaladd": "720 US HIGHWAY 52",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "OH",
    "dropmalzpp": 451019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137952531,
    "dropsitcph": 9377952531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20014",
    "droptype": "D",
    "dropname": "ADA",
    "dropdeladd": "131 S MAIN ST",
    "dropdelcty": "ADA",
    "dropdelst": "OH",
    "dropdelzpp": 458109998,
    "dropphyadd": "131 S MAIN ST",
    "dropphycty": "ADA",
    "dropphyst": "OH",
    "dropphyzpp": 458109998,
    "dropmaladd": "131 S MAIN ST",
    "dropmalcty": "ADA",
    "dropmalst": "OH",
    "dropmalzpp": 458109998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196345810,
    "dropsitcph": 4196345810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20020",
    "droptype": "D",
    "dropname": "ADAMSVILLE",
    "dropdeladd": "8125 EAST ST",
    "dropdelcty": "ADAMSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 438029998,
    "dropphyadd": "8125 EAST ST",
    "dropphycty": "ADAMSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 438029998,
    "dropmaladd": "8125 EAST ST",
    "dropmalcty": "ADAMSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 438029998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407964191,
    "dropsitcph": 7407964191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20022",
    "droptype": "D",
    "dropname": "ADDYSTON",
    "dropdeladd": "234 MAIN ST",
    "dropdelcty": "ADDYSTON",
    "dropdelst": "OH",
    "dropdelzpp": 450019998,
    "dropphyadd": "234 MAIN ST",
    "dropphycty": "ADDYSTON",
    "dropphyst": "OH",
    "dropphyzpp": 450019998,
    "dropmaladd": "234 MAIN ST",
    "dropmalcty": "ADDYSTON",
    "dropmalst": "OH",
    "dropmalzpp": 450019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139416702,
    "dropsitcph": 5139416702,
    "dropfax": 5139414038
  },
  {
    "dcode": "D",
    "dropkey": "PX20024",
    "droptype": "D",
    "dropname": "ADENA",
    "dropdeladd": "16 W MAIN ST",
    "dropdelcty": "ADENA",
    "dropdelst": "OH",
    "dropdelzpp": 439019800,
    "dropphyadd": "16 W MAIN ST",
    "dropphycty": "ADENA",
    "dropphyst": "OH",
    "dropphyzpp": 439019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADENA",
    "dropmalst": "OH",
    "dropmalzpp": 439019998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405464331,
    "dropsitcph": 7405464331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20035",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "675 WOLF LEDGES PKWY RM 104",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443099998,
    "dropphyadd": "675 WOLF LEDGES PKWY RM 104",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443099998,
    "dropmaladd": "675 WOLF LEDGES PKWY RM 104",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443099998,
    "dropsitphn": 3309969798,
    "dropsitlph": 3309969797,
    "dropsitcph": 3309969900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20041",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "5303 WASHINGTON RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "OH",
    "dropdelzpp": 457108732,
    "dropphyadd": "5303 WASHINGTON RD",
    "dropphycty": "ALBANY",
    "dropphyst": "OH",
    "dropphyzpp": 457108732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBANY",
    "dropmalst": "OH",
    "dropmalzpp": 457109998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406983241,
    "dropsitcph": 7406983241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20044",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "OH",
    "dropdelzpp": 430019622,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "OH",
    "dropphyzpp": 430019622,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "OH",
    "dropmalzpp": 430019998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409247511,
    "dropsitcph": 7409247511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20046",
    "droptype": "D",
    "dropname": "ALGER",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "ALGER",
    "dropdelst": "OH",
    "dropdelzpp": 458129998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "ALGER",
    "dropphyst": "OH",
    "dropphyzpp": 458129998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "ALGER",
    "dropmalst": "OH",
    "dropmalzpp": 458129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197574161,
    "dropsitcph": 4197574161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20051",
    "droptype": "D",
    "dropname": "ALLIANCE",
    "dropdeladd": "36 S ARCH AVE",
    "dropdelcty": "ALLIANCE",
    "dropdelst": "OH",
    "dropdelzpp": 446019998,
    "dropphyadd": "36 S ARCH AVE",
    "dropphycty": "ALLIANCE",
    "dropphyst": "OH",
    "dropphyzpp": 446019998,
    "dropmaladd": "36 S ARCH AVE",
    "dropmalcty": "ALLIANCE",
    "dropmalst": "OH",
    "dropmalzpp": 446019998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308213560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20055",
    "droptype": "D",
    "dropname": "ALPHA",
    "dropdeladd": "748 ALPHA RD",
    "dropdelcty": "ALPHA",
    "dropdelst": "OH",
    "dropdelzpp": 453019998,
    "dropphyadd": "748 ALPHA RD",
    "dropphycty": "ALPHA",
    "dropphyst": "OH",
    "dropphyzpp": 453019998,
    "dropmaladd": "748 ALPHA RD",
    "dropmalcty": "ALPHA",
    "dropmalst": "OH",
    "dropmalzpp": 453019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374267257,
    "dropsitcph": 9374267257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20058",
    "droptype": "D",
    "dropname": "ALVADA",
    "dropdeladd": "12125 W COUNTY ROAD 10",
    "dropdelcty": "ALVADA",
    "dropdelst": "OH",
    "dropdelzpp": 448029800,
    "dropphyadd": "12125 W COUNTY ROAD 10",
    "dropphycty": "ALVADA",
    "dropphyst": "OH",
    "dropphyzpp": 448029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALVADA",
    "dropmalst": "OH",
    "dropmalzpp": 448029998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195952744,
    "dropfax": 4195952428
  },
  {
    "dcode": "D",
    "dropkey": "PX20059",
    "droptype": "D",
    "dropname": "ALVORDTON",
    "dropdeladd": "119 E MAIN ST",
    "dropdelcty": "ALVORDTON",
    "dropdelst": "OH",
    "dropdelzpp": 435019998,
    "dropphyadd": "119 E MAIN ST",
    "dropphycty": "ALVORDTON",
    "dropphyst": "OH",
    "dropphyzpp": 435019998,
    "dropmaladd": "119 E MAIN ST",
    "dropmalcty": "ALVORDTON",
    "dropmalst": "OH",
    "dropmalzpp": 435019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199245013,
    "dropsitcph": 4199245013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20060",
    "droptype": "D",
    "dropname": "AMANDA",
    "dropdeladd": "144 E MAIN ST",
    "dropdelcty": "AMANDA",
    "dropdelst": "OH",
    "dropdelzpp": 431029900,
    "dropphyadd": "144 E MAIN ST",
    "dropphycty": "AMANDA",
    "dropphyst": "OH",
    "dropphyzpp": 431029900,
    "dropmaladd": "144 E MAIN ST",
    "dropmalcty": "AMANDA",
    "dropmalst": "OH",
    "dropmalzpp": 431029900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409692213,
    "dropsitcph": 7409692213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20062",
    "droptype": "D",
    "dropname": "AMELIA",
    "dropdeladd": "7 S KLINE AVE",
    "dropdelcty": "AMELIA",
    "dropdelst": "OH",
    "dropdelzpp": 451029998,
    "dropphyadd": "7 S KLINE AVE",
    "dropphycty": "AMELIA",
    "dropphyst": "OH",
    "dropphyzpp": 451029998,
    "dropmaladd": "7 S KLINE AVE",
    "dropmalcty": "AMELIA",
    "dropmalst": "OH",
    "dropmalzpp": 451029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137533267,
    "dropsitcph": 5137533267,
    "dropfax": 5137531558
  },
  {
    "dcode": "D",
    "dropkey": "PX20068",
    "droptype": "D",
    "dropname": "AMESVILLE",
    "dropdeladd": "20 STATE ST",
    "dropdelcty": "AMESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457119800,
    "dropphyadd": "20 STATE ST",
    "dropphycty": "AMESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457119800,
    "dropmaladd": "20 STATE ST",
    "dropmalcty": "AMESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457119800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404484591,
    "dropsitcph": 7404484591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20070",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "350 N LEAVITT RD",
    "dropdelcty": "AMHERST",
    "dropdelst": "OH",
    "dropdelzpp": 440019998,
    "dropphyadd": "350 N LEAVITT RD",
    "dropphycty": "AMHERST",
    "dropphyst": "OH",
    "dropphyzpp": 440019998,
    "dropmaladd": "350 N LEAVITT RD",
    "dropmalcty": "AMHERST",
    "dropmalst": "OH",
    "dropmalzpp": 440019998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409883421,
    "dropfax": 4409846027
  },
  {
    "dcode": "D",
    "dropkey": "PX20073",
    "droptype": "D",
    "dropname": "AMLIN",
    "dropdeladd": "6931 RINGS RD",
    "dropdelcty": "AMLIN",
    "dropdelst": "OH",
    "dropdelzpp": 430028000,
    "dropphyadd": "6931 RINGS RD",
    "dropphycty": "AMLIN",
    "dropphyst": "OH",
    "dropphyzpp": 430028000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMLIN",
    "dropmalst": "OH",
    "dropmalzpp": 430029998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148766922,
    "dropsitcph": 6148766922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20076",
    "droptype": "D",
    "dropname": "AMSTERDAM",
    "dropdeladd": "116 S MAIN ST",
    "dropdelcty": "AMSTERDAM",
    "dropdelst": "OH",
    "dropdelzpp": 439037947,
    "dropphyadd": "116 S MAIN ST",
    "dropphycty": "AMSTERDAM",
    "dropphyst": "OH",
    "dropphyzpp": 439037947,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMSTERDAM",
    "dropmalst": "OH",
    "dropmalzpp": 439039998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405433130,
    "dropsitcph": 7405433130,
    "dropfax": 7405433130
  },
  {
    "dcode": "D",
    "dropkey": "PX20079",
    "droptype": "D",
    "dropname": "ANDOVER",
    "dropdeladd": "275 E MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "OH",
    "dropdelzpp": 440039802,
    "dropphyadd": "275 E MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "OH",
    "dropphyzpp": 440039802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDOVER",
    "dropmalst": "OH",
    "dropmalzpp": 440039998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4406896020,
    "dropfax": 4406896021
  },
  {
    "dcode": "D",
    "dropkey": "PX20081",
    "droptype": "D",
    "dropname": "ANNA",
    "dropdeladd": "103 N 2ND ST",
    "dropdelcty": "ANNA",
    "dropdelst": "OH",
    "dropdelzpp": 453029998,
    "dropphyadd": "103 N 2ND ST",
    "dropphycty": "ANNA",
    "dropphyst": "OH",
    "dropphyzpp": 453029998,
    "dropmaladd": "103 N 2ND ST",
    "dropmalcty": "ANNA",
    "dropmalst": "OH",
    "dropmalzpp": 453029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373942141,
    "dropsitcph": 9373942141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20082",
    "droptype": "D",
    "dropname": "ANSONIA",
    "dropdeladd": "112 N MAIN ST",
    "dropdelcty": "ANSONIA",
    "dropdelst": "OH",
    "dropdelzpp": 453039998,
    "dropphyadd": "112 N MAIN ST",
    "dropphycty": "ANSONIA",
    "dropphyst": "OH",
    "dropphyzpp": 453039998,
    "dropmaladd": "112 N MAIN ST",
    "dropmalcty": "ANSONIA",
    "dropmalst": "OH",
    "dropmalzpp": 453039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373377571,
    "dropsitcph": 9373377571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20087",
    "droptype": "D",
    "dropname": "ANTWERP",
    "dropdeladd": "303 S MAIN ST",
    "dropdelcty": "ANTWERP",
    "dropdelst": "OH",
    "dropdelzpp": 458139998,
    "dropphyadd": "303 S MAIN ST",
    "dropphycty": "ANTWERP",
    "dropphyst": "OH",
    "dropphyzpp": 458139998,
    "dropmaladd": "303 S MAIN ST",
    "dropmalcty": "ANTWERP",
    "dropmalst": "OH",
    "dropmalzpp": 458139998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195672146,
    "dropsitcph": 4195672146,
    "dropfax": 4195672856
  },
  {
    "dcode": "D",
    "dropkey": "PX20088",
    "droptype": "D",
    "dropname": "APPLE CREEK",
    "dropdeladd": "33 MAPLE ST",
    "dropdelcty": "APPLE CREEK",
    "dropdelst": "OH",
    "dropdelzpp": 446069801,
    "dropphyadd": "33 MAPLE ST",
    "dropphycty": "APPLE CREEK",
    "dropphyst": "OH",
    "dropphyzpp": 446069801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "APPLE CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 446069998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306983171,
    "dropfax": 3306981513
  },
  {
    "dcode": "D",
    "dropkey": "PX20094",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "OH",
    "dropdelzpp": 448049800,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "OH",
    "dropphyzpp": 448049800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "OH",
    "dropmalzpp": 448049998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197921334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20095",
    "droptype": "D",
    "dropname": "ARCANUM",
    "dropdeladd": "10 S MAIN ST",
    "dropdelcty": "ARCANUM",
    "dropdelst": "OH",
    "dropdelzpp": 453041220,
    "dropphyadd": "10 S MAIN ST",
    "dropphycty": "ARCANUM",
    "dropphyst": "OH",
    "dropphyzpp": 453041220,
    "dropmaladd": "10 S MAIN ST",
    "dropmalcty": "ARCANUM",
    "dropmalst": "OH",
    "dropmalzpp": 453049998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376928640,
    "dropsitcph": 9376928640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20096",
    "droptype": "D",
    "dropname": "ARCHBOLD",
    "dropdeladd": "210 DITTO ST",
    "dropdelcty": "ARCHBOLD",
    "dropdelst": "OH",
    "dropdelzpp": 435027700,
    "dropphyadd": "210 DITTO ST",
    "dropphycty": "ARCHBOLD",
    "dropphyst": "OH",
    "dropphyzpp": 435027700,
    "dropmaladd": "210 DITTO ST",
    "dropmalcty": "ARCHBOLD",
    "dropmalst": "OH",
    "dropmalzpp": 435027700,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194455841,
    "dropsitcph": 4194455841,
    "dropfax": 4194457204
  },
  {
    "dcode": "D",
    "dropkey": "PX20100",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "120 W LIBERTY ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 458149998,
    "dropphyadd": "120 W LIBERTY ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 458149998,
    "dropmaladd": "120 W LIBERTY ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 458149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193655427,
    "dropsitcph": 4193655427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20107",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "530 CLAREMONT AVE",
    "dropdelcty": "ASHLAND",
    "dropdelst": "OH",
    "dropdelzpp": 448059998,
    "dropphyadd": "530 CLAREMONT AVE",
    "dropphycty": "ASHLAND",
    "dropphyst": "OH",
    "dropphyzpp": 448059998,
    "dropmaladd": "530 CLAREMONT AVE",
    "dropmalcty": "ASHLAND",
    "dropmalst": "OH",
    "dropmalzpp": 448059998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4192898307,
    "dropfax": 4192891119
  },
  {
    "dcode": "D",
    "dropkey": "PX20108",
    "droptype": "D",
    "dropname": "ASHLEY",
    "dropdeladd": "100 E HIGH ST",
    "dropdelcty": "ASHLEY",
    "dropdelst": "OH",
    "dropdelzpp": 430039002,
    "dropphyadd": "100 E HIGH ST",
    "dropphycty": "ASHLEY",
    "dropphyst": "OH",
    "dropphyzpp": 430039002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHLEY",
    "dropmalst": "OH",
    "dropmalzpp": 430039998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407472528,
    "dropsitcph": 7407472528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20110",
    "droptype": "D",
    "dropname": "ASHTABULA",
    "dropdeladd": "4307 STATION AVE",
    "dropdelcty": "ASHTABULA",
    "dropdelst": "OH",
    "dropdelzpp": 440049998,
    "dropphyadd": "4307 STATION AVE",
    "dropphycty": "ASHTABULA",
    "dropphyst": "OH",
    "dropphyzpp": 440049998,
    "dropmaladd": "4307 STATION AVE",
    "dropmalcty": "ASHTABULA",
    "dropmalst": "OH",
    "dropmalzpp": 440049998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409975268,
    "dropfax": 4409920884
  },
  {
    "dcode": "D",
    "dropkey": "PX20111",
    "droptype": "D",
    "dropname": "ASHVILLE",
    "dropdeladd": "3 MAIN ST E",
    "dropdelcty": "ASHVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431039998,
    "dropphyadd": "3 MAIN ST E",
    "dropphycty": "ASHVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431039998,
    "dropmaladd": "3 MAIN ST E",
    "dropmalcty": "ASHVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431039998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409832001,
    "dropsitcph": 7409832001,
    "dropfax": 7409832001
  },
  {
    "dcode": "D",
    "dropkey": "PX20114",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "5 W STIMSON AVE",
    "dropdelcty": "ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 457019998,
    "dropphyadd": "5 W STIMSON AVE",
    "dropphycty": "ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 457019998,
    "dropmaladd": "5 W STIMSON AVE",
    "dropmalcty": "ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 457019998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694535,
    "dropsitcph": 7405935578,
    "dropfax": 7405944601
  },
  {
    "dcode": "D",
    "dropkey": "PX20117",
    "droptype": "D",
    "dropname": "ATTICA",
    "dropdeladd": "7 S MAIN ST",
    "dropdelcty": "ATTICA",
    "dropdelst": "OH",
    "dropdelzpp": 448079800,
    "dropphyadd": "7 S MAIN ST",
    "dropphycty": "ATTICA",
    "dropphyst": "OH",
    "dropphyzpp": 448079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATTICA",
    "dropmalst": "OH",
    "dropmalzpp": 448079998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194264332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20119",
    "droptype": "D",
    "dropname": "ATWATER",
    "dropdeladd": "6713 WATERLOO RD",
    "dropdelcty": "ATWATER",
    "dropdelst": "OH",
    "dropdelzpp": 442019998,
    "dropphyadd": "6713 WATERLOO RD",
    "dropphycty": "ATWATER",
    "dropphyst": "OH",
    "dropphyzpp": 442019998,
    "dropmaladd": "6713 WATERLOO RD",
    "dropmalcty": "ATWATER",
    "dropmalst": "OH",
    "dropmalzpp": 442019998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309472660,
    "dropfax": 3309472660
  },
  {
    "dcode": "D",
    "dropkey": "PX20122",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "8081 KENSINGTON RD NE",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "OH",
    "dropdelzpp": 446079800,
    "dropphyadd": "8081 KENSINGTON RD NE",
    "dropphycty": "AUGUSTA",
    "dropphyst": "OH",
    "dropphyzpp": 446079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "OH",
    "dropmalzpp": 446079998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306275884,
    "dropfax": 3306275884
  },
  {
    "dcode": "D",
    "dropkey": "PX20123",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "400 AURORA COMMONS CIR",
    "dropdelcty": "AURORA",
    "dropdelst": "OH",
    "dropdelzpp": 442029998,
    "dropphyadd": "400 AURORA COMMONS CIR",
    "dropphycty": "AURORA",
    "dropphyst": "OH",
    "dropphyzpp": 442029998,
    "dropmaladd": "400 AURORA COMMONS CIR",
    "dropmalcty": "AURORA",
    "dropmalst": "OH",
    "dropmalzpp": 442029998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305627505,
    "dropfax": 3309545253
  },
  {
    "dcode": "D",
    "dropkey": "PX20125",
    "droptype": "D",
    "dropname": "AUSTINBURG",
    "dropdeladd": "2773 STATE ROUTE 307",
    "dropdelcty": "AUSTINBURG",
    "dropdelst": "OH",
    "dropdelzpp": 440109801,
    "dropphyadd": "2773 STATE ROUTE 307",
    "dropphycty": "AUSTINBURG",
    "dropphyst": "OH",
    "dropphyzpp": 440109801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTINBURG",
    "dropmalst": "OH",
    "dropmalzpp": 440109998,
    "dropsitphn": 2164434255,
    "dropsitlph": 4402943300,
    "dropsitcph": 4402943300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20127",
    "droptype": "D",
    "dropname": "AVA",
    "dropdeladd": "50614 STATE ROUTE 821",
    "dropdelcty": "AVA",
    "dropdelst": "OH",
    "dropdelzpp": 437119900,
    "dropphyadd": "50614 STATE ROUTE 821",
    "dropphycty": "AVA",
    "dropphyst": "OH",
    "dropphyzpp": 437119900,
    "dropmaladd": "50614 STATE ROUTE 821",
    "dropmalcty": "AVA",
    "dropmalst": "OH",
    "dropmalzpp": 437119900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407327126,
    "dropsitcph": 7407327126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20129",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "36225 DETROIT RD",
    "dropdelcty": "AVON",
    "dropdelst": "OH",
    "dropdelzpp": 440119998,
    "dropphyadd": "36225 DETROIT RD",
    "dropphycty": "AVON",
    "dropphyst": "OH",
    "dropphyzpp": 440119998,
    "dropmaladd": "36225 DETROIT RD",
    "dropmalcty": "AVON",
    "dropmalst": "OH",
    "dropmalzpp": 440119998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409347145,
    "dropfax": 4409341382
  },
  {
    "dcode": "D",
    "dropkey": "PX20130",
    "droptype": "D",
    "dropname": "AVON LAKE",
    "dropdeladd": "33501 LAKE RD STE B",
    "dropdelcty": "AVON LAKE",
    "dropdelst": "OH",
    "dropdelzpp": 440129998,
    "dropphyadd": "33501 LAKE RD STE B",
    "dropphycty": "AVON LAKE",
    "dropphyst": "OH",
    "dropphyzpp": 440129998,
    "dropmaladd": "33501 LAKE RD STE B",
    "dropmalcty": "AVON LAKE",
    "dropmalst": "OH",
    "dropmalzpp": 440129998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409334246,
    "dropfax": 4409339539
  },
  {
    "dcode": "D",
    "dropkey": "PX20140",
    "droptype": "D",
    "dropname": "BAINBRIDGE",
    "dropdeladd": "121 E MAIN ST",
    "dropdelcty": "BAINBRIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 456129963,
    "dropphyadd": "121 E MAIN ST",
    "dropphycty": "BAINBRIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 456129963,
    "dropmaladd": "121 E MAIN ST",
    "dropmalcty": "BAINBRIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 456129963,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404937022,
    "dropsitcph": 7404937022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20143",
    "droptype": "D",
    "dropname": "BALTIC",
    "dropdeladd": "105 N RAY ST",
    "dropdelcty": "BALTIC",
    "dropdelst": "OH",
    "dropdelzpp": 438049092,
    "dropphyadd": "105 N RAY ST",
    "dropphycty": "BALTIC",
    "dropphyst": "OH",
    "dropphyzpp": 438049092,
    "dropmaladd": "105 N RAY ST",
    "dropmalcty": "BALTIC",
    "dropmalst": "OH",
    "dropmalzpp": 438049092,
    "dropsitphn": 6144720674,
    "dropsitlph": 3308977401,
    "dropsitcph": 3308977401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20144",
    "droptype": "D",
    "dropname": "BALTIMORE",
    "dropdeladd": "432 W MARKET ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "OH",
    "dropdelzpp": 431059998,
    "dropphyadd": "432 W MARKET ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "OH",
    "dropphyzpp": 431059998,
    "dropmaladd": "432 W MARKET ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "OH",
    "dropmalzpp": 431059998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408624620,
    "dropsitcph": 7408624620,
    "dropfax": 7408625603
  },
  {
    "dcode": "D",
    "dropkey": "PX20151",
    "droptype": "D",
    "dropname": "BARBERTON",
    "dropdeladd": "531 WOOSTER RD W",
    "dropdelcty": "BARBERTON",
    "dropdelst": "OH",
    "dropdelzpp": 442039998,
    "dropphyadd": "531 WOOSTER RD W",
    "dropphycty": "BARBERTON",
    "dropphyst": "OH",
    "dropphyzpp": 442039998,
    "dropmaladd": "531 WOOSTER RD W",
    "dropmalcty": "BARBERTON",
    "dropmalst": "OH",
    "dropmalzpp": 442039998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308482838,
    "dropfax": 2346784526
  },
  {
    "dcode": "D",
    "dropkey": "PX20153",
    "droptype": "D",
    "dropname": "BARLOW",
    "dropdeladd": "CORNER OF STATE ROUTE 339 &  COUNTY ROAD 805",
    "dropdelcty": "VINCENT",
    "dropdelst": "OH",
    "dropdelzpp": 45784,
    "dropphyadd": "CORNER OF STATE ROUTE 339 &  COUNTY ROAD 805",
    "dropphycty": "VINCENT",
    "dropphyst": "OH",
    "dropphyzpp": 45784,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VINCENT",
    "dropmalst": "OH",
    "dropmalzpp": 457849998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406782945,
    "dropsitcph": 7406782945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20154",
    "droptype": "D",
    "dropname": "BARNESVILLE",
    "dropdeladd": "116 E CHURCH ST",
    "dropdelcty": "BARNESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437139998,
    "dropphyadd": "116 E CHURCH ST",
    "dropphycty": "BARNESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437139998,
    "dropmaladd": "116 E CHURCH ST",
    "dropmalcty": "BARNESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437139998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404252524,
    "dropsitcph": 7404252524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20156",
    "droptype": "D",
    "dropname": "BARTLETT",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "BARTLETT",
    "dropdelst": "OH",
    "dropdelzpp": 457139800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "BARTLETT",
    "dropphyst": "OH",
    "dropphyzpp": 457139800,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "BARTLETT",
    "dropmalst": "OH",
    "dropmalzpp": 457139800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405512220,
    "dropsitcph": 7405512220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20157",
    "droptype": "D",
    "dropname": "BARTON",
    "dropdeladd": "70659 MAIN ST",
    "dropdelcty": "BARTON",
    "dropdelst": "OH",
    "dropdelzpp": 439059800,
    "dropphyadd": "70659 MAIN ST",
    "dropphycty": "BARTON",
    "dropphyst": "OH",
    "dropphyzpp": 439059800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARTON",
    "dropmalst": "OH",
    "dropmalzpp": 439059998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406952514,
    "dropsitcph": 7406952514,
    "dropfax": 7406952514
  },
  {
    "dcode": "D",
    "dropkey": "PX20158",
    "droptype": "D",
    "dropname": "BASCOM",
    "dropdeladd": "5755 W TIFFIN ST",
    "dropdelcty": "BASCOM",
    "dropdelst": "OH",
    "dropdelzpp": 448099800,
    "dropphyadd": "5755 W TIFFIN ST",
    "dropphycty": "BASCOM",
    "dropphyst": "OH",
    "dropphyzpp": 448099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BASCOM",
    "dropmalst": "OH",
    "dropmalzpp": 448099998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199372616,
    "dropfax": 4199372612
  },
  {
    "dcode": "D",
    "dropkey": "PX20161",
    "droptype": "D",
    "dropname": "BATAVIA",
    "dropdeladd": "575 W MAIN ST",
    "dropdelcty": "BATAVIA",
    "dropdelst": "OH",
    "dropdelzpp": 451039998,
    "dropphyadd": "575 W MAIN ST",
    "dropphycty": "BATAVIA",
    "dropphyst": "OH",
    "dropphyzpp": 451039998,
    "dropmaladd": "575 W MAIN ST",
    "dropmalcty": "BATAVIA",
    "dropmalst": "OH",
    "dropmalzpp": 451039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137185301,
    "dropsitcph": 5137185301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20164",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "1970 N CLEVELAND MASSILLON RD",
    "dropdelcty": "BATH",
    "dropdelst": "OH",
    "dropdelzpp": 442109800,
    "dropphyadd": "1970 N CLEVELAND MASSILLON RD",
    "dropphycty": "BATH",
    "dropphyst": "OH",
    "dropphyzpp": 442109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATH",
    "dropmalst": "OH",
    "dropmalzpp": 442109998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306661323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20170",
    "droptype": "D",
    "dropname": "BEACH CITY",
    "dropdeladd": "130 E MAIN ST",
    "dropdelcty": "BEACH CITY",
    "dropdelst": "OH",
    "dropdelzpp": 446089800,
    "dropphyadd": "130 E MAIN ST",
    "dropphycty": "BEACH CITY",
    "dropphyst": "OH",
    "dropphyzpp": 446089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEACH CITY",
    "dropmalst": "OH",
    "dropmalzpp": 446089998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307562714,
    "dropfax": 3307562714
  },
  {
    "dcode": "D",
    "dropkey": "PX20173",
    "droptype": "D",
    "dropname": "BEALLSVILLE",
    "dropdeladd": "52731 OHIO AVE",
    "dropdelcty": "BEALLSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437169900,
    "dropphyadd": "52731 OHIO AVE",
    "dropphycty": "BEALLSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437169900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEALLSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437169998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409261510,
    "dropsitcph": 7409261510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20176",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "5610 BEAVER PIKE",
    "dropdelcty": "BEAVER",
    "dropdelst": "OH",
    "dropdelzpp": 456139800,
    "dropphyadd": "5610 BEAVER PIKE",
    "dropphycty": "BEAVER",
    "dropphyst": "OH",
    "dropphyzpp": 456139800,
    "dropmaladd": "5610 BEAVER PIKE",
    "dropmalcty": "BEAVER",
    "dropmalst": "OH",
    "dropmalzpp": 456139800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402265151,
    "dropsitcph": 7402265151,
    "dropfax": 7402264017
  },
  {
    "dcode": "D",
    "dropkey": "PX20191",
    "droptype": "D",
    "dropname": "BELLAIRE",
    "dropdeladd": "451 33RD ST",
    "dropdelcty": "BELLAIRE",
    "dropdelst": "OH",
    "dropdelzpp": 439069998,
    "dropphyadd": "451 33RD ST",
    "dropphycty": "BELLAIRE",
    "dropphyst": "OH",
    "dropphyzpp": 439069998,
    "dropmaladd": "451 33RD ST",
    "dropmalcty": "BELLAIRE",
    "dropmalst": "OH",
    "dropmalzpp": 439069998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406763816,
    "dropsitcph": 7406763816,
    "dropfax": 7406763010
  },
  {
    "dcode": "D",
    "dropkey": "PX20193",
    "droptype": "D",
    "dropname": "BELLBROOK",
    "dropdeladd": "22 N EAST ST",
    "dropdelcty": "BELLBROOK",
    "dropdelst": "OH",
    "dropdelzpp": 453059998,
    "dropphyadd": "22 N EAST ST",
    "dropphycty": "BELLBROOK",
    "dropphyst": "OH",
    "dropphyzpp": 453059998,
    "dropmaladd": "22 N EAST ST",
    "dropmalcty": "BELLBROOK",
    "dropmalst": "OH",
    "dropmalzpp": 453059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378482631,
    "dropsitcph": 9378482631,
    "dropfax": 9378482631
  },
  {
    "dcode": "D",
    "dropkey": "PX20195",
    "droptype": "D",
    "dropname": "BELLE CENTER",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "BELLE CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 433109699,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "BELLE CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 433109699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLE CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 433109998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9374644121,
    "dropsitcph": 9374644121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20197",
    "droptype": "D",
    "dropname": "BELLE VALLEY",
    "dropdeladd": "200 LIBERTY ST",
    "dropdelcty": "BELLE VALLEY",
    "dropdelst": "OH",
    "dropdelzpp": 437179900,
    "dropphyadd": "200 LIBERTY ST",
    "dropphycty": "BELLE VALLEY",
    "dropphyst": "OH",
    "dropphyzpp": 437179900,
    "dropmaladd": "200 LIBERTY ST",
    "dropmalcty": "BELLE VALLEY",
    "dropmalst": "OH",
    "dropmalzpp": 437179900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407322408,
    "dropsitcph": 7407322408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20199",
    "droptype": "D",
    "dropname": "BELLEFONTAINE",
    "dropdeladd": "132 S DETROIT ST",
    "dropdelcty": "BELLEFONTAINE",
    "dropdelst": "OH",
    "dropdelzpp": 433119997,
    "dropphyadd": "132 S DETROIT ST",
    "dropphycty": "BELLEFONTAINE",
    "dropphyst": "OH",
    "dropphyzpp": 433119997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLEFONTAINE",
    "dropmalst": "OH",
    "dropmalzpp": 433119998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375925771,
    "dropsitcph": 9375925771,
    "dropfax": 9375927360
  },
  {
    "dcode": "D",
    "dropkey": "PX20202",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "140 N SANDUSKY ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "OH",
    "dropdelzpp": 448119998,
    "dropphyadd": "140 N SANDUSKY ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "OH",
    "dropphyzpp": 448119998,
    "dropmaladd": "140 N SANDUSKY ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "OH",
    "dropmalzpp": 448119998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194833910,
    "dropfax": 4194832478
  },
  {
    "dcode": "D",
    "dropkey": "PX20204",
    "droptype": "D",
    "dropname": "BELLVILLE",
    "dropdeladd": "105 BELL ST",
    "dropdelcty": "BELLVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448139998,
    "dropphyadd": "105 BELL ST",
    "dropphycty": "BELLVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448139998,
    "dropmaladd": "105 BELL ST",
    "dropmalcty": "BELLVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448139998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198863845,
    "dropfax": 4198863845
  },
  {
    "dcode": "D",
    "dropkey": "PX20205",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "128 W MAIN ST",
    "dropdelcty": "BELMONT",
    "dropdelst": "OH",
    "dropdelzpp": 437189901,
    "dropphyadd": "128 W MAIN ST",
    "dropphycty": "BELMONT",
    "dropphyst": "OH",
    "dropphyzpp": 437189901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELMONT",
    "dropmalst": "OH",
    "dropmalzpp": 437189998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404844774,
    "dropsitcph": 7404844774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20207",
    "droptype": "D",
    "dropname": "BELOIT",
    "dropdeladd": "13666 S MAIN ST",
    "dropdelcty": "BELOIT",
    "dropdelst": "OH",
    "dropdelzpp": 446099998,
    "dropphyadd": "13666 S MAIN ST",
    "dropphycty": "BELOIT",
    "dropphyst": "OH",
    "dropphyzpp": 446099998,
    "dropmaladd": "13666 S MAIN ST",
    "dropmalcty": "BELOIT",
    "dropmalst": "OH",
    "dropmalzpp": 446099998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309388035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20208",
    "droptype": "D",
    "dropname": "BELPRE",
    "dropdeladd": "1105 WASHINGTON BLVD",
    "dropdelcty": "BELPRE",
    "dropdelst": "OH",
    "dropdelzpp": 457142275,
    "dropphyadd": "1105 WASHINGTON BLVD",
    "dropphycty": "BELPRE",
    "dropphyst": "OH",
    "dropphyzpp": 457142275,
    "dropmaladd": "1105 WASHINGTON BLVD",
    "dropmalcty": "BELPRE",
    "dropmalst": "OH",
    "dropmalzpp": 457142275,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404238913,
    "dropsitcph": 7404238913,
    "dropfax": 7404234442
  },
  {
    "dcode": "D",
    "dropkey": "PX20216",
    "droptype": "D",
    "dropname": "BENTONVILLE",
    "dropdeladd": "7785 STATE ROUTE 41",
    "dropdelcty": "BENTONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451059998,
    "dropphyadd": "7785 STATE ROUTE 41",
    "dropphycty": "BENTONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451059998,
    "dropmaladd": "7785 STATE ROUTE 41",
    "dropmalcty": "BENTONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375494529,
    "dropsitcph": 9375493360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20219",
    "droptype": "D",
    "dropname": "BEREA",
    "dropdeladd": "24 SEMINARY ST",
    "dropdelcty": "BEREA",
    "dropdelst": "OH",
    "dropdelzpp": 440179998,
    "dropphyadd": "24 SEMINARY ST",
    "dropphycty": "BEREA",
    "dropphyst": "OH",
    "dropphyzpp": 440179998,
    "dropmaladd": "24 SEMINARY ST",
    "dropmalcty": "BEREA",
    "dropmalst": "OH",
    "dropmalzpp": 440179998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402433131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20220",
    "droptype": "D",
    "dropname": "BERGHOLZ",
    "dropdeladd": "254 2ND ST",
    "dropdelcty": "BERGHOLZ",
    "dropdelst": "OH",
    "dropdelzpp": 439089800,
    "dropphyadd": "254 2ND ST",
    "dropphycty": "BERGHOLZ",
    "dropphyst": "OH",
    "dropphyzpp": 439089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERGHOLZ",
    "dropmalst": "OH",
    "dropmalzpp": 439089998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407682525,
    "dropsitcph": 7407682525,
    "dropfax": 7407682525
  },
  {
    "dcode": "D",
    "dropkey": "PX20221",
    "droptype": "D",
    "dropname": "BERKEY",
    "dropdeladd": "12353 SYLVANIA METAMORA RD",
    "dropdelcty": "BERKEY",
    "dropdelst": "OH",
    "dropdelzpp": 435049998,
    "dropphyadd": "12353 SYLVANIA METAMORA RD",
    "dropphycty": "BERKEY",
    "dropphyst": "OH",
    "dropphyzpp": 435049998,
    "dropmaladd": "12353 SYLVANIA METAMORA RD",
    "dropmalcty": "BERKEY",
    "dropmalst": "OH",
    "dropmalzpp": 435049998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198293721,
    "dropsitcph": 4198293721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20223",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "5520 OAK ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "OH",
    "dropdelzpp": 446109800,
    "dropphyadd": "5520 OAK ST",
    "dropphycty": "BERLIN",
    "dropphyst": "OH",
    "dropphyzpp": 446109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERLIN",
    "dropmalst": "OH",
    "dropmalzpp": 446109998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308932113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20224",
    "droptype": "D",
    "dropname": "BERLIN CENTER",
    "dropdeladd": "15401 W AKRON CANFIELD RD",
    "dropdelcty": "BERLIN CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 444019800,
    "dropphyadd": "15401 W AKRON CANFIELD RD",
    "dropphycty": "BERLIN CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 444019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERLIN CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 444019998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305472351,
    "dropsitcph": 3305472351,
    "dropfax": 3305472351
  },
  {
    "dcode": "D",
    "dropkey": "PX20225",
    "droptype": "D",
    "dropname": "BERLIN HEIGHTS",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "BERLIN HEIGHTS",
    "dropdelst": "OH",
    "dropdelzpp": 448149801,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "BERLIN HEIGHTS",
    "dropphyst": "OH",
    "dropphyzpp": 448149801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERLIN HEIGHTS",
    "dropmalst": "OH",
    "dropmalzpp": 448149998,
    "dropsitphn": 3309969797,
    "dropsitlph": 4197554619,
    "dropsitcph": 4195882367,
    "dropfax": 4195882367
  },
  {
    "dcode": "D",
    "dropkey": "PX20233",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "213 N EAST ST",
    "dropdelcty": "BETHEL",
    "dropdelst": "OH",
    "dropdelzpp": 451069998,
    "dropphyadd": "213 N EAST ST",
    "dropphycty": "BETHEL",
    "dropphyst": "OH",
    "dropphyzpp": 451069998,
    "dropmaladd": "213 N EAST ST",
    "dropmalcty": "BETHEL",
    "dropmalst": "OH",
    "dropmalzpp": 451069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132167011,
    "dropsitcph": 5132167011,
    "dropfax": 5137341617
  },
  {
    "dcode": "D",
    "dropkey": "PX20236",
    "droptype": "D",
    "dropname": "BETHESDA",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "BETHESDA",
    "dropdelst": "OH",
    "dropdelzpp": 437199901,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "BETHESDA",
    "dropphyst": "OH",
    "dropphyzpp": 437199901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHESDA",
    "dropmalst": "OH",
    "dropmalzpp": 437199998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404844444,
    "dropsitcph": 7404844444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20239",
    "droptype": "D",
    "dropname": "BETTSVILLE",
    "dropdeladd": "203 STATE ST",
    "dropdelcty": "BETTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448159998,
    "dropphyadd": "203 STATE ST",
    "dropphycty": "BETTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448159998,
    "dropmaladd": "203 STATE ST",
    "dropmalcty": "BETTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199865384,
    "dropfax": 4199866089
  },
  {
    "dcode": "D",
    "dropkey": "PX20241",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "409 1/2 5TH ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "OH",
    "dropdelzpp": 457158901,
    "dropphyadd": "409 1/2 5TH ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "OH",
    "dropphyzpp": 457158901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEVERLY",
    "dropmalst": "OH",
    "dropmalzpp": 457159998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409844263,
    "dropsitcph": 7409844263,
    "dropfax": 7409848319
  },
  {
    "dcode": "D",
    "dropkey": "PX20244",
    "droptype": "D",
    "dropname": "BIDWELL",
    "dropdeladd": "15070 STATE ROUTE 554",
    "dropdelcty": "BIDWELL",
    "dropdelst": "OH",
    "dropdelzpp": 456149998,
    "dropphyadd": "15070 STATE ROUTE 554",
    "dropphycty": "BIDWELL",
    "dropphyst": "OH",
    "dropphyzpp": 456149998,
    "dropmaladd": "15070 STATE ROUTE 554",
    "dropmalcty": "BIDWELL",
    "dropmalst": "OH",
    "dropmalzpp": 456149998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403888802,
    "dropsitcph": 7403888802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20246",
    "droptype": "D",
    "dropname": "BIG PRAIRIE",
    "dropdeladd": "13214 STATE ROUTE 226",
    "dropdelcty": "BIG PRAIRIE",
    "dropdelst": "OH",
    "dropdelzpp": 446119998,
    "dropphyadd": "13214 STATE ROUTE 226",
    "dropphycty": "BIG PRAIRIE",
    "dropphyst": "OH",
    "dropphyzpp": 446119998,
    "dropmaladd": "13214 STATE ROUTE 226",
    "dropmalcty": "BIG PRAIRIE",
    "dropmalst": "OH",
    "dropmalzpp": 446119998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304962411,
    "dropfax": 3304962412
  },
  {
    "dcode": "D",
    "dropkey": "PX20255",
    "droptype": "D",
    "dropname": "BLACKLICK",
    "dropdeladd": "450 N BRICE RD",
    "dropdelcty": "BLACKLICK",
    "dropdelst": "OH",
    "dropdelzpp": 430049366,
    "dropphyadd": "450 N BRICE RD",
    "dropphycty": "BLACKLICK",
    "dropphyst": "OH",
    "dropphyzpp": 430049366,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACKLICK",
    "dropmalst": "OH",
    "dropmalzpp": 430049998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148663031,
    "dropsitcph": 6148663031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20258",
    "droptype": "D",
    "dropname": "BLADENSBURG",
    "dropdeladd": "25941 NEW GUILFORD RD",
    "dropdelcty": "BLADENSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430058000,
    "dropphyadd": "25941 NEW GUILFORD RD",
    "dropphycty": "BLADENSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430058000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLADENSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430059998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406683333,
    "dropsitcph": 7406683333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20259",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "53739 NATIONAL RD",
    "dropdelcty": "BLAINE",
    "dropdelst": "OH",
    "dropdelzpp": 439099800,
    "dropphyadd": "53739 NATIONAL RD",
    "dropphycty": "BLAINE",
    "dropphyst": "OH",
    "dropphyzpp": 439099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAINE",
    "dropmalst": "OH",
    "dropmalzpp": 439099998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406359080,
    "dropsitcph": 7406359080,
    "dropfax": 7406359080
  },
  {
    "dcode": "D",
    "dropkey": "PX20262",
    "droptype": "D",
    "dropname": "BLAKESLEE",
    "dropdeladd": "514 WASHINGTON ST",
    "dropdelcty": "BLAKESLEE",
    "dropdelst": "OH",
    "dropdelzpp": 435059998,
    "dropphyadd": "514 WASHINGTON ST",
    "dropphycty": "BLAKESLEE",
    "dropphyst": "OH",
    "dropphyzpp": 435059998,
    "dropmaladd": "514 WASHINGTON ST",
    "dropmalcty": "BLAKESLEE",
    "dropmalst": "OH",
    "dropmalzpp": 435059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192722085,
    "dropsitcph": 4192722085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20263",
    "droptype": "D",
    "dropname": "BLANCHESTER",
    "dropdeladd": "115 S WRIGHT ST",
    "dropdelcty": "BLANCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 451079998,
    "dropphyadd": "115 S WRIGHT ST",
    "dropphycty": "BLANCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 451079998,
    "dropmaladd": "115 S WRIGHT ST",
    "dropmalcty": "BLANCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 451079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137838241,
    "dropsitcph": 9377838241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20268",
    "droptype": "D",
    "dropname": "BLOOMDALE",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "BLOOMDALE",
    "dropdelst": "OH",
    "dropdelzpp": 448179800,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "BLOOMDALE",
    "dropphyst": "OH",
    "dropphyzpp": 448179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMDALE",
    "dropmalst": "OH",
    "dropmalzpp": 448179998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194543431,
    "dropfax": 4194543431
  },
  {
    "dcode": "D",
    "dropkey": "PX20272",
    "droptype": "D",
    "dropname": "BLOOMINGBURG",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "BLOOMINGBURG",
    "dropdelst": "OH",
    "dropdelzpp": 431069900,
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "BLOOMINGBURG",
    "dropphyst": "OH",
    "dropphyzpp": 431069900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGBURG",
    "dropmalst": "OH",
    "dropmalzpp": 431069998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404377662,
    "dropsitcph": 7404377662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20273",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "111 HIGH ST",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "OH",
    "dropdelzpp": 439109800,
    "dropphyadd": "111 HIGH ST",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "OH",
    "dropphyzpp": 439109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "OH",
    "dropmalzpp": 439109998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409441753,
    "dropsitcph": 7404498833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20275",
    "droptype": "D",
    "dropname": "BLOOMVILLE",
    "dropdeladd": "10 S MARION ST",
    "dropdelcty": "BLOOMVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448189800,
    "dropphyadd": "10 S MARION ST",
    "dropphycty": "BLOOMVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448189998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199833101,
    "dropfax": 4199835301
  },
  {
    "dcode": "D",
    "dropkey": "PX20278",
    "droptype": "D",
    "dropname": "BLUE CREEK",
    "dropdeladd": "20805 STATE ROUTE 125",
    "dropdelcty": "BLUE CREEK",
    "dropdelst": "OH",
    "dropdelzpp": 456169065,
    "dropphyadd": "20805 STATE ROUTE 125",
    "dropphycty": "BLUE CREEK",
    "dropphyst": "OH",
    "dropphyzpp": 456169065,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 456169998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375443304,
    "dropsitcph": 9375443304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20280",
    "droptype": "D",
    "dropname": "BLUE ROCK",
    "dropdeladd": "8780 S RIVER RD",
    "dropdelcty": "BLUE ROCK",
    "dropdelst": "OH",
    "dropdelzpp": 437209900,
    "dropphyadd": "8780 S RIVER RD",
    "dropphycty": "BLUE ROCK",
    "dropphyst": "OH",
    "dropphyzpp": 437209900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE ROCK",
    "dropmalst": "OH",
    "dropmalzpp": 437209998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406746566,
    "dropsitcph": 7406746566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20281",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "132 S MAIN ST",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "OH",
    "dropdelzpp": 458179998,
    "dropphyadd": "132 S MAIN ST",
    "dropphycty": "BLUFFTON",
    "dropphyst": "OH",
    "dropphyzpp": 458179998,
    "dropmaladd": "132 S MAIN ST",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "OH",
    "dropmalzpp": 458179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 4193586096,
    "dropfax": 4193580661
  },
  {
    "dcode": "D",
    "dropkey": "PX20284",
    "droptype": "D",
    "dropname": "BOLIVAR",
    "dropdeladd": "164 CANAL ST SE",
    "dropdelcty": "BOLIVAR",
    "dropdelst": "OH",
    "dropdelzpp": 446129800,
    "dropphyadd": "164 CANAL ST SE",
    "dropphycty": "BOLIVAR",
    "dropphyst": "OH",
    "dropphyzpp": 446129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOLIVAR",
    "dropmalst": "OH",
    "dropmalzpp": 446129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308719286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20293",
    "droptype": "D",
    "dropname": "BOTKINS",
    "dropdeladd": "106 S MILL ST",
    "dropdelcty": "BOTKINS",
    "dropdelst": "OH",
    "dropdelzpp": 453069998,
    "dropphyadd": "106 S MILL ST",
    "dropphycty": "BOTKINS",
    "dropphyst": "OH",
    "dropphyzpp": 453069998,
    "dropmaladd": "106 S MILL ST",
    "dropmalcty": "BOTKINS",
    "dropmalst": "OH",
    "dropmalzpp": 453069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376933757,
    "dropsitcph": 9376933757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20295",
    "droptype": "D",
    "dropname": "BOURNEVILLE",
    "dropdeladd": "11684 US HIGHWAY 50 W",
    "dropdelcty": "BOURNEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 456179800,
    "dropphyadd": "11684 US HIGHWAY 50 W",
    "dropphycty": "BOURNEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 456179800,
    "dropmaladd": "11684 US HIGHWAY 50 W",
    "dropmalcty": "BOURNEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 456179800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406262891,
    "dropsitcph": 7406262891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20296",
    "droptype": "D",
    "dropname": "BOWERSTON",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "BOWERSTON",
    "dropdelst": "OH",
    "dropdelzpp": 446959800,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "BOWERSTON",
    "dropphyst": "OH",
    "dropphyzpp": 446959800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWERSTON",
    "dropmalst": "OH",
    "dropmalzpp": 446959998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7402696161,
    "dropfax": 7402697304
  },
  {
    "dcode": "D",
    "dropkey": "PX20297",
    "droptype": "D",
    "dropname": "BOWERSVILLE",
    "dropdeladd": "3180 MAYSVILLE ST",
    "dropdelcty": "BOWERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453079998,
    "dropphyadd": "3180 MAYSVILLE ST",
    "dropphycty": "BOWERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453079998,
    "dropmaladd": "3180 MAYSVILLE ST",
    "dropmalcty": "BOWERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374532295,
    "dropsitcph": 9374532295,
    "dropfax": 9374532402
  },
  {
    "dcode": "D",
    "dropkey": "PX20300",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "111 W WASHINGTON ST",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "OH",
    "dropdelzpp": 434022855,
    "dropphyadd": "111 W WASHINGTON ST",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "OH",
    "dropphyzpp": 434022855,
    "dropmaladd": "111 W WASHINGTON ST",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "OH",
    "dropmalzpp": 434022855,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193527545,
    "dropsitcph": 4193527545,
    "dropfax": 4193535706
  },
  {
    "dcode": "D",
    "dropkey": "PX20309",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "210 N MIAMI AVE",
    "dropdelcty": "BRADFORD",
    "dropdelst": "OH",
    "dropdelzpp": 453089998,
    "dropphyadd": "210 N MIAMI AVE",
    "dropphycty": "BRADFORD",
    "dropphyst": "OH",
    "dropphyzpp": 453089998,
    "dropmaladd": "210 N MIAMI AVE",
    "dropmalcty": "BRADFORD",
    "dropmalst": "OH",
    "dropmalzpp": 453089998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374482020,
    "dropsitcph": 9374482020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20311",
    "droptype": "D",
    "dropname": "BRADNER",
    "dropdeladd": "101 W CROCKER ST",
    "dropdelcty": "BRADNER",
    "dropdelst": "OH",
    "dropdelzpp": 434069998,
    "dropphyadd": "101 W CROCKER ST",
    "dropphycty": "BRADNER",
    "dropphyst": "OH",
    "dropphyzpp": 434069998,
    "dropmaladd": "101 W CROCKER ST",
    "dropmalcty": "BRADNER",
    "dropmalst": "OH",
    "dropmalzpp": 434069998,
    "dropsitphn": 4192882809,
    "dropsitlph": 4192882809,
    "dropsitcph": 4192882809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20319",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "BREMEN",
    "dropdelst": "OH",
    "dropdelzpp": 431079998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "BREMEN",
    "dropphyst": "OH",
    "dropphyzpp": 431079998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "BREMEN",
    "dropmalst": "OH",
    "dropmalzpp": 431079998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405697367,
    "dropsitcph": 7405697367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20320",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "120 MAIN ST SW",
    "dropdelcty": "BREWSTER",
    "dropdelst": "OH",
    "dropdelzpp": 446139998,
    "dropphyadd": "120 MAIN ST SW",
    "dropphycty": "BREWSTER",
    "dropphyst": "OH",
    "dropphyzpp": 446139998,
    "dropmaladd": "120 MAIN ST SW",
    "dropmalcty": "BREWSTER",
    "dropmalst": "OH",
    "dropmalzpp": 446139998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307673511,
    "dropfax": 3307673147
  },
  {
    "dcode": "D",
    "dropkey": "PX20322",
    "droptype": "D",
    "dropname": "BRICE",
    "dropdeladd": "3045 BRICE RD",
    "dropdelcty": "BRICE",
    "dropdelst": "OH",
    "dropdelzpp": 431099900,
    "dropphyadd": "3045 BRICE RD",
    "dropphycty": "BRICE",
    "dropphyst": "OH",
    "dropphyzpp": 431099900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRICE",
    "dropmalst": "OH",
    "dropmalzpp": 431099998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148617954,
    "dropsitcph": 6148617954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20323",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "300 S LINCOLN AVE",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "OH",
    "dropdelzpp": 439129998,
    "dropphyadd": "300 S LINCOLN AVE",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "OH",
    "dropphyzpp": 439129998,
    "dropmaladd": "300 S LINCOLN AVE",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "OH",
    "dropmalzpp": 439129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406351461,
    "dropsitcph": 7406351461,
    "dropfax": 7406351461
  },
  {
    "dcode": "D",
    "dropkey": "PX20327",
    "droptype": "D",
    "dropname": "BRILLIANT",
    "dropdeladd": "801 3RD ST",
    "dropdelcty": "BRILLIANT",
    "dropdelst": "OH",
    "dropdelzpp": 439139998,
    "dropphyadd": "801 3RD ST",
    "dropphycty": "BRILLIANT",
    "dropphyst": "OH",
    "dropphyzpp": 439139998,
    "dropmaladd": "801 3RD ST",
    "dropmalcty": "BRILLIANT",
    "dropmalst": "OH",
    "dropmalzpp": 439139998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405984906,
    "dropsitcph": 7405984906,
    "dropfax": 7405986009
  },
  {
    "dcode": "D",
    "dropkey": "PX20330",
    "droptype": "D",
    "dropname": "BRINKHAVEN",
    "dropdeladd": "204 HIGH ST",
    "dropdelcty": "BRINKHAVEN",
    "dropdelst": "OH",
    "dropdelzpp": 430068000,
    "dropphyadd": "204 HIGH ST",
    "dropphycty": "BRINKHAVEN",
    "dropphyst": "OH",
    "dropphyzpp": 430068000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRINKHAVEN",
    "dropmalst": "OH",
    "dropmalzpp": 430069998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6145996510,
    "dropsitcph": 6145996510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20332",
    "droptype": "D",
    "dropname": "BRISTOLVILLE",
    "dropdeladd": "1850 STATE ROUTE 88",
    "dropdelcty": "BRISTOLVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 444029998,
    "dropphyadd": "1850 STATE ROUTE 88",
    "dropphycty": "BRISTOLVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 444029998,
    "dropmaladd": "1850 STATE ROUTE 88",
    "dropmalcty": "BRISTOLVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 444029998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308892020,
    "dropsitcph": 3308892020,
    "dropfax": 3308892020
  },
  {
    "dcode": "D",
    "dropkey": "PX20340",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "6875 WARREN SHARON RD",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 444039800,
    "dropphyadd": "6875 WARREN SHARON RD",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 444039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 444039998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304486660,
    "dropsitcph": 3304486660,
    "dropfax": 3304486660
  },
  {
    "dcode": "D",
    "dropkey": "PX20346",
    "droptype": "D",
    "dropname": "BROOKVILLE",
    "dropdeladd": "22 MULBERRY ST",
    "dropdelcty": "BROOKVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453099998,
    "dropphyadd": "22 MULBERRY ST",
    "dropphycty": "BROOKVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453099998,
    "dropmaladd": "22 MULBERRY ST",
    "dropmalcty": "BROOKVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453099998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378332970,
    "dropsitcph": 9378332970,
    "dropfax": 9378333970
  },
  {
    "dcode": "D",
    "dropkey": "PX20358",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "3955 CENTER RD",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "OH",
    "dropdelzpp": 442129998,
    "dropphyadd": "3955 CENTER RD",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "OH",
    "dropphyzpp": 442129998,
    "dropmaladd": "3955 CENTER RD",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "OH",
    "dropmalzpp": 442129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302253115,
    "dropfax": 3302258925
  },
  {
    "dcode": "D",
    "dropkey": "PX20362",
    "droptype": "D",
    "dropname": "BRYAN",
    "dropdeladd": "142 N MAIN ST",
    "dropdelcty": "BRYAN",
    "dropdelst": "OH",
    "dropdelzpp": 435062349,
    "dropphyadd": "142 N MAIN ST",
    "dropphycty": "BRYAN",
    "dropphyst": "OH",
    "dropphyzpp": 435062349,
    "dropmaladd": "142 N MAIN ST",
    "dropmalcty": "BRYAN",
    "dropmalst": "OH",
    "dropmalzpp": 435062349,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196362755,
    "dropsitcph": 4196362755,
    "dropfax": 4196362571
  },
  {
    "dcode": "D",
    "dropkey": "PX20363",
    "droptype": "D",
    "dropname": "BUCHTEL",
    "dropdeladd": "17505 2ND ST",
    "dropdelcty": "BUCHTEL",
    "dropdelst": "OH",
    "dropdelzpp": 457169800,
    "dropphyadd": "17505 2ND ST",
    "dropphycty": "BUCHTEL",
    "dropphyst": "OH",
    "dropphyzpp": 457169800,
    "dropmaladd": "17505 2ND ST",
    "dropmalcty": "BUCHTEL",
    "dropmalst": "OH",
    "dropmalzpp": 457169800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407531274,
    "dropsitcph": 7407531274,
    "dropfax": 7407531274
  },
  {
    "dcode": "D",
    "dropkey": "PX20367",
    "droptype": "D",
    "dropname": "BUCKEYE LAKE",
    "dropdeladd": "4717 WALNUT RD",
    "dropdelcty": "BUCKEYE LAKE",
    "dropdelst": "OH",
    "dropdelzpp": 430088000,
    "dropphyadd": "4717 WALNUT RD",
    "dropphycty": "BUCKEYE LAKE",
    "dropphyst": "OH",
    "dropphyzpp": 430088000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCKEYE LAKE",
    "dropmalst": "OH",
    "dropmalzpp": 430089998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409283196,
    "dropsitcph": 7409283196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20374",
    "droptype": "D",
    "dropname": "BUCYRUS",
    "dropdeladd": "301 S POPLAR ST",
    "dropdelcty": "BUCYRUS",
    "dropdelst": "OH",
    "dropdelzpp": 448209998,
    "dropphyadd": "301 S POPLAR ST",
    "dropphycty": "BUCYRUS",
    "dropphyst": "OH",
    "dropphyzpp": 448209998,
    "dropmaladd": "301 S POPLAR ST",
    "dropmalcty": "BUCYRUS",
    "dropmalst": "OH",
    "dropmalzpp": 448209998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195626308,
    "dropfax": 4196173030
  },
  {
    "dcode": "D",
    "dropkey": "PX20377",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "11985 CLAY PIKE RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "OH",
    "dropdelzpp": 437229900,
    "dropphyadd": "11985 CLAY PIKE RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "OH",
    "dropphyzpp": 437229900,
    "dropmaladd": "11985 CLAY PIKE RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "OH",
    "dropmalzpp": 437229900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406856087,
    "dropsitcph": 7406856087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20386",
    "droptype": "D",
    "dropname": "BURGOON",
    "dropdeladd": "3189 MAIN ST",
    "dropdelcty": "BURGOON",
    "dropdelst": "OH",
    "dropdelzpp": 434079998,
    "dropphyadd": "3189 MAIN ST",
    "dropphycty": "BURGOON",
    "dropphyst": "OH",
    "dropphyzpp": 434079998,
    "dropmaladd": "3189 MAIN ST",
    "dropmalcty": "BURGOON",
    "dropmalst": "OH",
    "dropmalzpp": 434079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199865375,
    "dropsitcph": 4199865375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20387",
    "droptype": "D",
    "dropname": "BURKETTSVILLE",
    "dropdeladd": "25 W MAIN ST",
    "dropdelcty": "BURKETTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453109998,
    "dropphyadd": "25 W MAIN ST",
    "dropphycty": "BURKETTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453109998,
    "dropmaladd": "25 W MAIN ST",
    "dropmalcty": "BURKETTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453109998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193752741,
    "dropsitcph": 4193752741,
    "dropfax": 4193752924
  },
  {
    "dcode": "D",
    "dropkey": "PX20397",
    "droptype": "D",
    "dropname": "BURTON",
    "dropdeladd": "14519 N CHESHIRE ST",
    "dropdelcty": "BURTON",
    "dropdelst": "OH",
    "dropdelzpp": 440219803,
    "dropphyadd": "14519 N CHESHIRE ST",
    "dropphycty": "BURTON",
    "dropphyst": "OH",
    "dropphyzpp": 440219803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURTON",
    "dropmalst": "OH",
    "dropmalzpp": 440219998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408348656,
    "dropfax": 4403329309
  },
  {
    "dcode": "D",
    "dropkey": "PX20404",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "14 W ELM ST",
    "dropdelcty": "BUTLER",
    "dropdelst": "OH",
    "dropdelzpp": 448229802,
    "dropphyadd": "14 W ELM ST",
    "dropphycty": "BUTLER",
    "dropphyst": "OH",
    "dropphyzpp": 448229802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUTLER",
    "dropmalst": "OH",
    "dropmalzpp": 448229998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198833441,
    "dropfax": 4198833441
  },
  {
    "dcode": "D",
    "dropkey": "PX20408",
    "droptype": "D",
    "dropname": "BYESVILLE",
    "dropdeladd": "209 WATSON AVE",
    "dropdelcty": "BYESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437239998,
    "dropphyadd": "209 WATSON AVE",
    "dropphycty": "BYESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437239998,
    "dropmaladd": "209 WATSON AVE",
    "dropmalcty": "BYESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437239998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406852711,
    "dropsitcph": 7406852711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20415",
    "droptype": "D",
    "dropname": "CABLE",
    "dropdeladd": "3582 MAIN ST",
    "dropdelcty": "CABLE",
    "dropdelst": "OH",
    "dropdelzpp": 430099010,
    "dropphyadd": "3582 MAIN ST",
    "dropphycty": "CABLE",
    "dropphyst": "OH",
    "dropphyzpp": 430099010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CABLE",
    "dropmalst": "OH",
    "dropmalzpp": 430099998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376538887,
    "dropsitcph": 9376538887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20416",
    "droptype": "D",
    "dropname": "CADIZ",
    "dropdeladd": "82422 CADIZ JEWETT RD",
    "dropdelcty": "CADIZ",
    "dropdelst": "OH",
    "dropdelzpp": 439079802,
    "dropphyadd": "82422 CADIZ JEWETT RD",
    "dropphycty": "CADIZ",
    "dropphyst": "OH",
    "dropphyzpp": 439079802,
    "dropmaladd": "82422 CADIZ JEWETT RD",
    "dropmalcty": "CADIZ",
    "dropmalst": "OH",
    "dropmalzpp": 439079802,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409423601,
    "dropsitcph": 7409423601,
    "dropfax": 7409423601
  },
  {
    "dcode": "D",
    "dropkey": "PX20418",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "CAIRO",
    "dropdelst": "OH",
    "dropdelzpp": 458209998,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "CAIRO",
    "dropphyst": "OH",
    "dropphyzpp": 458209998,
    "dropmaladd": "104 W MAIN ST",
    "dropmalcty": "CAIRO",
    "dropmalst": "OH",
    "dropmalzpp": 458209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196414112,
    "dropsitcph": 4196414112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20422",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "601 WEST ST",
    "dropdelcty": "CALDWELL",
    "dropdelst": "OH",
    "dropdelzpp": 437249998,
    "dropphyadd": "601 WEST ST",
    "dropphycty": "CALDWELL",
    "dropphyst": "OH",
    "dropphyzpp": 437249998,
    "dropmaladd": "601 WEST ST",
    "dropmalcty": "CALDWELL",
    "dropmalst": "OH",
    "dropmalzpp": 437249998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407322451,
    "dropsitcph": 7407322451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20423",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "OH",
    "dropdelzpp": 433149718,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "CALEDONIA",
    "dropphyst": "OH",
    "dropphyzpp": 433149718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "OH",
    "dropmalzpp": 433149998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4198452018,
    "dropsitcph": 4198452018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20425",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "954 WHEELING AVE",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 437259998,
    "dropphyadd": "954 WHEELING AVE",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 437259998,
    "dropmaladd": "954 WHEELING AVE",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 437259998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404322351,
    "dropsitcph": 7404322351,
    "dropfax": 7404216095
  },
  {
    "dcode": "D",
    "dropkey": "PX20426",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "32 W CENTRAL AVE",
    "dropdelcty": "CAMDEN",
    "dropdelst": "OH",
    "dropdelzpp": 453119998,
    "dropphyadd": "32 W CENTRAL AVE",
    "dropphycty": "CAMDEN",
    "dropphyst": "OH",
    "dropphyzpp": 453119998,
    "dropmaladd": "32 W CENTRAL AVE",
    "dropmalcty": "CAMDEN",
    "dropmalst": "OH",
    "dropmalzpp": 453119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374523220,
    "dropsitcph": 9374523220,
    "dropfax": 9374529928
  },
  {
    "dcode": "D",
    "dropkey": "PX20427",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "48126 MAIN ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "OH",
    "dropdelzpp": 439149800,
    "dropphyadd": "48126 MAIN ST",
    "dropphycty": "CAMERON",
    "dropphyst": "OH",
    "dropphyzpp": 439149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMERON",
    "dropmalst": "OH",
    "dropmalzpp": 439149998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7404581017,
    "dropsitcph": 7404581017,
    "dropfax": 7404581017
  },
  {
    "dcode": "D",
    "dropkey": "PX20432",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "220 12TH ST",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "OH",
    "dropdelzpp": 444059998,
    "dropphyadd": "220 12TH ST",
    "dropphycty": "CAMPBELL",
    "dropphyst": "OH",
    "dropphyzpp": 444059998,
    "dropmaladd": "220 12TH ST",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "OH",
    "dropmalzpp": 444059998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307501361,
    "dropsitcph": 3307501361,
    "dropfax": 2347190255
  },
  {
    "dcode": "D",
    "dropkey": "PX20438",
    "droptype": "D",
    "dropname": "CANAL FULTON",
    "dropdeladd": "210 S CANAL ST",
    "dropdelcty": "CANAL FULTON",
    "dropdelst": "OH",
    "dropdelzpp": 446149998,
    "dropphyadd": "210 S CANAL ST",
    "dropphycty": "CANAL FULTON",
    "dropphyst": "OH",
    "dropphyzpp": 446149998,
    "dropmaladd": "210 S CANAL ST",
    "dropmalcty": "CANAL FULTON",
    "dropmalst": "OH",
    "dropmalzpp": 446149998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308542104,
    "dropfax": 3308542104
  },
  {
    "dcode": "D",
    "dropkey": "PX20441",
    "droptype": "D",
    "dropname": "CANAL WINCHESTER",
    "dropdeladd": "200 N HIGH ST",
    "dropdelcty": "CANAL WINCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 431109998,
    "dropphyadd": "200 N HIGH ST",
    "dropphycty": "CANAL WINCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 431109998,
    "dropmaladd": "200 N HIGH ST",
    "dropmalcty": "CANAL WINCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 431109998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148377953,
    "dropsitcph": 6148377953,
    "dropfax": 6148375187
  },
  {
    "dcode": "D",
    "dropkey": "PX20444",
    "droptype": "D",
    "dropname": "CANFIELD",
    "dropdeladd": "44 N BROAD ST",
    "dropdelcty": "CANFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 444069998,
    "dropphyadd": "44 N BROAD ST",
    "dropphycty": "CANFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 444069998,
    "dropmaladd": "44 N BROAD ST",
    "dropmalcty": "CANFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 444069998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305336884,
    "dropsitcph": 3305336884,
    "dropfax": 3305337623
  },
  {
    "dcode": "D",
    "dropkey": "PX20450",
    "droptype": "D",
    "dropname": "CARBON HILL",
    "dropdeladd": "41769 HAWK ST",
    "dropdelcty": "CARBON HILL",
    "dropdelst": "OH",
    "dropdelzpp": 431119900,
    "dropphyadd": "41769 HAWK ST",
    "dropphycty": "CARBON HILL",
    "dropphyst": "OH",
    "dropphyzpp": 431119900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARBON HILL",
    "dropmalst": "OH",
    "dropmalzpp": 431119998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407533003,
    "dropsitcph": 7407533003,
    "dropfax": 7407532670
  },
  {
    "dcode": "D",
    "dropkey": "PX20452",
    "droptype": "D",
    "dropname": "CARDINGTON",
    "dropdeladd": "201 S MARION ST",
    "dropdelcty": "CARDINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 433159998,
    "dropphyadd": "201 S MARION ST",
    "dropphycty": "CARDINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 433159998,
    "dropmaladd": "201 S MARION ST",
    "dropmalcty": "CARDINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 433159998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4198643926,
    "dropsitcph": 4198643926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20453",
    "droptype": "D",
    "dropname": "CAREY",
    "dropdeladd": "128 N VANCE ST",
    "dropdelcty": "CAREY",
    "dropdelst": "OH",
    "dropdelzpp": 433161081,
    "dropphyadd": "128 N VANCE ST",
    "dropphycty": "CAREY",
    "dropphyst": "OH",
    "dropphyzpp": 433161081,
    "dropmaladd": "128 N VANCE ST",
    "dropmalcty": "CAREY",
    "dropmalst": "OH",
    "dropmalzpp": 433161081,
    "dropsitphn": 6144720674,
    "dropsitlph": 4193966664,
    "dropsitcph": 4193966664,
    "dropfax": 4193963496
  },
  {
    "dcode": "D",
    "dropkey": "PX20459",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "53 LOCK ST",
    "dropdelcty": "CARROLL",
    "dropdelst": "OH",
    "dropdelzpp": 431129904,
    "dropphyadd": "53 LOCK ST",
    "dropphycty": "CARROLL",
    "dropphyst": "OH",
    "dropphyzpp": 431129904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARROLL",
    "dropmalst": "OH",
    "dropmalzpp": 431129998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407567726,
    "dropsitcph": 7407567726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20460",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "246 S LISBON ST",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "OH",
    "dropdelzpp": 446159998,
    "dropphyadd": "246 S LISBON ST",
    "dropphycty": "CARROLLTON",
    "dropphyst": "OH",
    "dropphyzpp": 446159998,
    "dropmaladd": "246 S LISBON ST",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "OH",
    "dropmalzpp": 446159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306272230,
    "dropfax": 3306275308
  },
  {
    "dcode": "D",
    "dropkey": "PX20467",
    "droptype": "D",
    "dropname": "CASSTOWN",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "CASSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 453129998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "CASSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 453129998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "CASSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 453129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373391441,
    "dropsitcph": 9373391441,
    "dropfax": 9373395077
  },
  {
    "dcode": "D",
    "dropkey": "PX20468",
    "droptype": "D",
    "dropname": "CASTALIA",
    "dropdeladd": "105 N WATER ST",
    "dropdelcty": "CASTALIA",
    "dropdelst": "OH",
    "dropdelzpp": 448249800,
    "dropphyadd": "105 N WATER ST",
    "dropphycty": "CASTALIA",
    "dropphyst": "OH",
    "dropphyzpp": 448249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTALIA",
    "dropmalst": "OH",
    "dropmalzpp": 448249998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196845977,
    "dropfax": 4196845157
  },
  {
    "dcode": "D",
    "dropkey": "PX20470",
    "droptype": "D",
    "dropname": "CATAWBA",
    "dropdeladd": "7 W PLEASANT ST",
    "dropdelcty": "CATAWBA",
    "dropdelst": "OH",
    "dropdelzpp": 430108000,
    "dropphyadd": "7 W PLEASANT ST",
    "dropphycty": "CATAWBA",
    "dropphyst": "OH",
    "dropphyzpp": 430108000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CATAWBA",
    "dropmalst": "OH",
    "dropmalzpp": 430109998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378281455,
    "dropsitcph": 9378281455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20475",
    "droptype": "D",
    "dropname": "CECIL",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "CECIL",
    "dropdelst": "OH",
    "dropdelzpp": 458219998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "CECIL",
    "dropphyst": "OH",
    "dropphyzpp": 458219998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "CECIL",
    "dropmalst": "OH",
    "dropmalzpp": 458219998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193994045,
    "dropsitcph": 4193994045,
    "dropfax": 4193993488
  },
  {
    "dcode": "D",
    "dropkey": "PX20476",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453149998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453149998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377665659,
    "dropsitcph": 9377665659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20480",
    "droptype": "D",
    "dropname": "CELINA",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "CELINA",
    "dropdelst": "OH",
    "dropdelzpp": 458229998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "CELINA",
    "dropphyst": "OH",
    "dropphyzpp": 458229998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "CELINA",
    "dropmalst": "OH",
    "dropmalzpp": 458229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195868042,
    "dropsitcph": 4195868042,
    "dropfax": 4195869588
  },
  {
    "dcode": "D",
    "dropkey": "PX20484",
    "droptype": "D",
    "dropname": "CENTERBURG",
    "dropdeladd": "55 N CLAYTON ST",
    "dropdelcty": "CENTERBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430119029,
    "dropphyadd": "55 N CLAYTON ST",
    "dropphycty": "CENTERBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430119029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430119998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406255225,
    "dropsitcph": 7406255225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20500",
    "droptype": "D",
    "dropname": "CHAGRIN FALLS",
    "dropdeladd": "160 E WASHINGTON ST",
    "dropdelcty": "CHAGRIN FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 440229998,
    "dropphyadd": "160 E WASHINGTON ST",
    "dropphycty": "CHAGRIN FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 440229998,
    "dropmaladd": "160 E WASHINGTON ST",
    "dropmalcty": "CHAGRIN FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 440229998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402479806,
    "dropfax": 4402477512
  },
  {
    "dcode": "D",
    "dropkey": "PX20508",
    "droptype": "D",
    "dropname": "CHANDLERSVILLE",
    "dropdeladd": "8875 CHANDLERSVILLE RD",
    "dropdelcty": "CHANDLERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437279900,
    "dropphyadd": "8875 CHANDLERSVILLE RD",
    "dropphycty": "CHANDLERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437279900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANDLERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437279998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406746117,
    "dropsitcph": 7406746117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20511",
    "droptype": "D",
    "dropname": "CHARDON",
    "dropdeladd": "150 CENTER ST",
    "dropdelcty": "CHARDON",
    "dropdelst": "OH",
    "dropdelzpp": 440249998,
    "dropphyadd": "150 CENTER ST",
    "dropphycty": "CHARDON",
    "dropphyst": "OH",
    "dropphyzpp": 440249998,
    "dropmaladd": "150 CENTER ST",
    "dropmalcty": "CHARDON",
    "dropmalst": "OH",
    "dropmalzpp": 440249998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402865601,
    "dropfax": 4402869084
  },
  {
    "dcode": "D",
    "dropkey": "PX20513",
    "droptype": "D",
    "dropname": "CHARM",
    "dropdeladd": "4440 STATE ROUTE 557",
    "dropdelcty": "CHARM",
    "dropdelst": "OH",
    "dropdelzpp": 446179800,
    "dropphyadd": "4440 STATE ROUTE 557",
    "dropphycty": "CHARM",
    "dropphyst": "OH",
    "dropphyzpp": 446179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHARM",
    "dropmalst": "OH",
    "dropmalzpp": 446179998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308932888,
    "dropfax": 3308933748
  },
  {
    "dcode": "D",
    "dropkey": "PX20516",
    "droptype": "D",
    "dropname": "CHATFIELD",
    "dropdeladd": "6890 SANDUSKY ST",
    "dropdelcty": "CHATFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 448259800,
    "dropphyadd": "6890 SANDUSKY ST",
    "dropphycty": "CHATFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 448259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHATFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 448259998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199882701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20520",
    "droptype": "D",
    "dropname": "CHAUNCEY",
    "dropdeladd": "23 SYCAMORE ST",
    "dropdelcty": "CHAUNCEY",
    "dropdelst": "OH",
    "dropdelzpp": 457199800,
    "dropphyadd": "23 SYCAMORE ST",
    "dropphycty": "CHAUNCEY",
    "dropphyst": "OH",
    "dropphyzpp": 457199800,
    "dropmaladd": "23 SYCAMORE ST",
    "dropmalcty": "CHAUNCEY",
    "dropmalst": "OH",
    "dropmalzpp": 457199800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407972551,
    "dropsitcph": 7407972551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20525",
    "droptype": "D",
    "dropname": "CHERRY FORK",
    "dropdeladd": "14536 STATE ROUTE 136",
    "dropdelcty": "CHERRY FORK",
    "dropdelst": "OH",
    "dropdelzpp": 456189800,
    "dropphyadd": "14536 STATE ROUTE 136",
    "dropphycty": "CHERRY FORK",
    "dropphyst": "OH",
    "dropphyzpp": 456189800,
    "dropmaladd": "14536 STATE ROUTE 136",
    "dropmalcty": "CHERRY FORK",
    "dropmalst": "OH",
    "dropmalzpp": 456189800,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376959945,
    "dropsitcph": 9376959945,
    "dropfax": 9376959945
  },
  {
    "dcode": "D",
    "dropkey": "PX20528",
    "droptype": "D",
    "dropname": "CHESAPEAKE",
    "dropdeladd": "607 3RD AVE",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "OH",
    "dropdelzpp": 456191082,
    "dropphyadd": "607 3RD AVE",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "OH",
    "dropphyzpp": 456191082,
    "dropmaladd": "607 3RD AVE",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "OH",
    "dropmalzpp": 456191082,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408675880,
    "dropsitcph": 7408675880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20529",
    "droptype": "D",
    "dropname": "CHESHIRE",
    "dropdeladd": "7976 STATE ROUTE 7 N",
    "dropdelcty": "CHESHIRE",
    "dropdelst": "OH",
    "dropdelzpp": 456209800,
    "dropphyadd": "7976 STATE ROUTE 7 N",
    "dropphycty": "CHESHIRE",
    "dropphyst": "OH",
    "dropphyzpp": 456209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESHIRE",
    "dropmalst": "OH",
    "dropmalzpp": 456209998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403677458,
    "dropsitcph": 7403677458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20530",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "46416 STATE ROUTE 248 UNIT B",
    "dropdelcty": "CHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 457209800,
    "dropphyadd": "46416 STATE ROUTE 248 UNIT B",
    "dropphycty": "CHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 457209800,
    "dropmaladd": "46416 STATE ROUTE 248 UNIT B",
    "dropmalcty": "CHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 457209800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409853388,
    "dropsitcph": 7409853388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20531",
    "droptype": "D",
    "dropname": "CHESTERHILL",
    "dropdeladd": "7402 MARION ST",
    "dropdelcty": "CHESTERHILL",
    "dropdelst": "OH",
    "dropdelzpp": 437289997,
    "dropphyadd": "7402 MARION ST",
    "dropphycty": "CHESTERHILL",
    "dropphyst": "OH",
    "dropphyzpp": 437289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTERHILL",
    "dropmalst": "OH",
    "dropmalzpp": 437289998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405545772,
    "dropsitcph": 7405545772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20532",
    "droptype": "D",
    "dropname": "CHESTERLAND",
    "dropdeladd": "12804 CHILLICOTHE RD",
    "dropdelcty": "CHESTERLAND",
    "dropdelst": "OH",
    "dropdelzpp": 440269998,
    "dropphyadd": "12804 CHILLICOTHE RD",
    "dropphycty": "CHESTERLAND",
    "dropphyst": "OH",
    "dropphyzpp": 440269998,
    "dropmaladd": "12804 CHILLICOTHE RD",
    "dropmalcty": "CHESTERLAND",
    "dropmalst": "OH",
    "dropmalzpp": 440269998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407290721,
    "dropfax": 4407292015
  },
  {
    "dcode": "D",
    "dropkey": "PX20533",
    "droptype": "D",
    "dropname": "CHESTERVILLE",
    "dropdeladd": "44 E SANDUSKY ST",
    "dropdelcty": "CHESTERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 433179700,
    "dropphyadd": "44 E SANDUSKY ST",
    "dropphycty": "CHESTERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 433179700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 433179998,
    "dropsitphn": 6144720672,
    "dropsitlph": 4197683861,
    "dropsitcph": 4197683861,
    "dropfax": 4197683861
  },
  {
    "dcode": "D",
    "dropkey": "PX20536",
    "droptype": "D",
    "dropname": "CHILLICOTHE",
    "dropdeladd": "40 S WALNUT ST",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "OH",
    "dropdelzpp": 456019997,
    "dropphyadd": "40 S WALNUT ST",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "OH",
    "dropphyzpp": 456019997,
    "dropmaladd": "40 S WALNUT ST",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "OH",
    "dropmalzpp": 456019997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407741181,
    "dropsitcph": 7407741181,
    "dropfax": 7407742354
  },
  {
    "dcode": "D",
    "dropkey": "PX20537",
    "droptype": "D",
    "dropname": "CHILO",
    "dropdeladd": "302 WASHINGTON ST",
    "dropdelcty": "CHILO",
    "dropdelst": "OH",
    "dropdelzpp": 451129998,
    "dropphyadd": "302 WASHINGTON ST",
    "dropphycty": "CHILO",
    "dropphyst": "OH",
    "dropphyzpp": 451129998,
    "dropmaladd": "302 WASHINGTON ST",
    "dropmalcty": "CHILO",
    "dropmalst": "OH",
    "dropmalzpp": 451129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138763588,
    "dropsitcph": 5138763588,
    "dropfax": 5138769072
  },
  {
    "dcode": "D",
    "dropkey": "PX20540",
    "droptype": "D",
    "dropname": "CHIPPEWA LAKE",
    "dropdeladd": "5825 HEATHERHEDGE DR",
    "dropdelcty": "CHIPPEWA LAKE",
    "dropdelst": "OH",
    "dropdelzpp": 442159998,
    "dropphyadd": "5825 HEATHERHEDGE DR",
    "dropphycty": "CHIPPEWA LAKE",
    "dropphyst": "OH",
    "dropphyzpp": 442159998,
    "dropmaladd": "5825 HEATHERHEDGE DR",
    "dropmalcty": "CHIPPEWA LAKE",
    "dropmalst": "OH",
    "dropmalzpp": 442159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307693514,
    "dropfax": 3307692367
  },
  {
    "dcode": "D",
    "dropkey": "PX20543",
    "droptype": "D",
    "dropname": "CHRISTIANSBURG",
    "dropdeladd": "6 E 1ST ST",
    "dropdelcty": "CHRISTIANSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453899998,
    "dropphyadd": "6 E 1ST ST",
    "dropphycty": "CHRISTIANSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453899998,
    "dropmaladd": "6 E 1ST ST",
    "dropmalcty": "CHRISTIANSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453899998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378579489,
    "dropsitcph": 9378579489,
    "dropfax": 9378579489
  },
  {
    "dcode": "D",
    "dropkey": "PX20549",
    "droptype": "D",
    "dropname": "CINCINNATI",
    "dropdeladd": "1623 DALTON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452349998,
    "dropphyadd": "1623 DALTON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452349998,
    "dropmaladd": "1623 DALTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5136845009,
    "dropfax": 5136845798
  },
  {
    "dcode": "D",
    "dropkey": "PX20553",
    "droptype": "D",
    "dropname": "CIRCLEVILLE",
    "dropdeladd": "224 S COURT ST",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431139998,
    "dropphyadd": "224 S COURT ST",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431139998,
    "dropmaladd": "224 S COURT ST",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431139998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404749982,
    "dropsitcph": 7404749982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20557",
    "droptype": "D",
    "dropname": "CLARINGTON",
    "dropdeladd": "506 MARKET ST",
    "dropdelcty": "CLARINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 439159800,
    "dropphyadd": "506 MARKET ST",
    "dropphycty": "CLARINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 439159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 439159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7404581655,
    "dropsitcph": 7404581655,
    "dropfax": 7404581655
  },
  {
    "dcode": "D",
    "dropkey": "PX20560",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "17343 HIGH ST",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 431159900,
    "dropphyadd": "17343 HIGH ST",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 431159900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 431159998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409934494,
    "dropsitcph": 7409934494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20563",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "75 SPRING HILL RD",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451139998,
    "dropphyadd": "75 SPRING HILL RD",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451139998,
    "dropmaladd": "75 SPRING HILL RD",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451139998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372892214,
    "dropsitcph": 9372892214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20569",
    "droptype": "D",
    "dropname": "CLAY CENTER",
    "dropdeladd": "440 MAIN ST",
    "dropdelcty": "CLAY CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 434089998,
    "dropphyadd": "440 MAIN ST",
    "dropphycty": "CLAY CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 434089998,
    "dropmaladd": "440 MAIN ST",
    "dropmalcty": "CLAY CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 434089998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198554395,
    "dropsitcph": 4198554395,
    "dropfax": 4198554395
  },
  {
    "dcode": "D",
    "dropkey": "PX20572",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "196 TALMADGE RD",
    "dropdelcty": "CLAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 453159998,
    "dropphyadd": "196 TALMADGE RD",
    "dropphycty": "CLAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 453159998,
    "dropmaladd": "196 TALMADGE RD",
    "dropmalcty": "CLAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 453159998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378361178,
    "dropsitcph": 9378361178,
    "dropfax": 9378368297
  },
  {
    "dcode": "D",
    "dropkey": "PX20578",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "2400 ORANGE AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441019003,
    "dropphyadd": "2400 ORANGE AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441019003,
    "dropmaladd": "2400 ORANGE AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441019003,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164434732,
    "dropfax": 2164434738
  },
  {
    "dcode": "D",
    "dropkey": "PX20585",
    "droptype": "D",
    "dropname": "CLEVES",
    "dropdeladd": "650 N MIAMI AVE",
    "dropdelcty": "CLEVES",
    "dropdelst": "OH",
    "dropdelzpp": 450029998,
    "dropphyadd": "650 N MIAMI AVE",
    "dropphycty": "CLEVES",
    "dropphyst": "OH",
    "dropphyzpp": 450029998,
    "dropmaladd": "650 N MIAMI AVE",
    "dropmalcty": "CLEVES",
    "dropmalst": "OH",
    "dropmalzpp": 450029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139412537,
    "dropsitcph": 5139412537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20594",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "17 CLINTON ST",
    "dropdelcty": "CLIFTON",
    "dropdelst": "OH",
    "dropdelzpp": 453169998,
    "dropphyadd": "17 CLINTON ST",
    "dropphycty": "CLIFTON",
    "dropphyst": "OH",
    "dropphyzpp": 453169998,
    "dropmaladd": "17 CLINTON ST",
    "dropmalcty": "CLIFTON",
    "dropmalst": "OH",
    "dropmalzpp": 453169998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377679366,
    "dropsitcph": 9377679366,
    "dropfax": 9377679376
  },
  {
    "dcode": "D",
    "dropkey": "PX20596",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "2733 W COMET RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "OH",
    "dropdelzpp": 442169998,
    "dropphyadd": "2733 W COMET RD",
    "dropphycty": "CLINTON",
    "dropphyst": "OH",
    "dropphyzpp": 442169998,
    "dropmaladd": "2733 W COMET RD",
    "dropmalcty": "CLINTON",
    "dropmalst": "OH",
    "dropmalzpp": 442169998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308823806,
    "dropfax": 3305292010
  },
  {
    "dcode": "D",
    "dropkey": "PX20602",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "117 MAHONING ST",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "OH",
    "dropdelzpp": 458279998,
    "dropphyadd": "117 MAHONING ST",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "OH",
    "dropphyzpp": 458279998,
    "dropmaladd": "117 MAHONING ST",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "OH",
    "dropmalzpp": 458279998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194882841,
    "dropsitcph": 4194882841,
    "dropfax": 4194882842
  },
  {
    "dcode": "D",
    "dropkey": "PX20605",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "131 W BUCKEYE ST",
    "dropdelcty": "CLYDE",
    "dropdelst": "OH",
    "dropdelzpp": 434101986,
    "dropphyadd": "131 W BUCKEYE ST",
    "dropphycty": "CLYDE",
    "dropphyst": "OH",
    "dropphyzpp": 434101986,
    "dropmaladd": "131 W BUCKEYE ST",
    "dropmalcty": "CLYDE",
    "dropmalst": "OH",
    "dropmalzpp": 434101986,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195477182,
    "dropsitcph": 4195477182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20614",
    "droptype": "D",
    "dropname": "COALTON",
    "dropdeladd": "11 S 2ND ST",
    "dropdelcty": "COALTON",
    "dropdelst": "OH",
    "dropdelzpp": 456219800,
    "dropphyadd": "11 S 2ND ST",
    "dropphycty": "COALTON",
    "dropphyst": "OH",
    "dropphyzpp": 456219800,
    "dropmaladd": "11 S 2ND ST",
    "dropmalcty": "COALTON",
    "dropmalst": "OH",
    "dropmalzpp": 456219800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402865808,
    "dropsitcph": 7402865808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20618",
    "droptype": "D",
    "dropname": "COLDWATER",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "COLDWATER",
    "dropdelst": "OH",
    "dropdelzpp": 458289998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "COLDWATER",
    "dropphyst": "OH",
    "dropphyzpp": 458289998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "COLDWATER",
    "dropmalst": "OH",
    "dropmalzpp": 458289998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196782711,
    "dropsitcph": 4196782711,
    "dropfax": 4196781093
  },
  {
    "dcode": "D",
    "dropkey": "PX20620",
    "droptype": "D",
    "dropname": "COLERAIN",
    "dropdeladd": "72120 STATE ROUTE 250",
    "dropdelcty": "COLERAIN",
    "dropdelst": "OH",
    "dropdelzpp": 439169800,
    "dropphyadd": "72120 STATE ROUTE 250",
    "dropphycty": "COLERAIN",
    "dropphyst": "OH",
    "dropphyzpp": 439169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLERAIN",
    "dropmalst": "OH",
    "dropmalzpp": 439169998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406330770,
    "dropsitcph": 7406330770,
    "dropfax": 7406330770
  },
  {
    "dcode": "D",
    "dropkey": "PX20623",
    "droptype": "D",
    "dropname": "COLLEGE CORNER",
    "dropdeladd": "18 LIBERTY AVE",
    "dropdelcty": "COLLEGE CORNER",
    "dropdelst": "OH",
    "dropdelzpp": 450039998,
    "dropphyadd": "18 LIBERTY AVE",
    "dropphycty": "COLLEGE CORNER",
    "dropphyst": "OH",
    "dropphyzpp": 450039998,
    "dropmaladd": "18 LIBERTY AVE",
    "dropmalcty": "COLLEGE CORNER",
    "dropmalst": "OH",
    "dropmalzpp": 450039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 7657323556,
    "dropsitcph": 7657323556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20626",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "2728 N RAILROAD ST",
    "dropdelcty": "COLLINS",
    "dropdelst": "OH",
    "dropdelzpp": 448269801,
    "dropphyadd": "2728 N RAILROAD ST",
    "dropphycty": "COLLINS",
    "dropphyst": "OH",
    "dropphyzpp": 448269801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLINS",
    "dropmalst": "OH",
    "dropmalzpp": 448269998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196685559,
    "dropfax": 4196685559
  },
  {
    "dcode": "D",
    "dropkey": "PX20635",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "637 HENRY ST",
    "dropdelcty": "COLTON",
    "dropdelst": "OH",
    "dropdelzpp": 435109998,
    "dropphyadd": "637 HENRY ST",
    "dropphycty": "COLTON",
    "dropphyst": "OH",
    "dropphyzpp": 435109998,
    "dropmaladd": "637 HENRY ST",
    "dropmalcty": "COLTON",
    "dropmalst": "OH",
    "dropmalzpp": 435109998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195332004,
    "dropsitcph": 4195332004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20640",
    "droptype": "D",
    "dropname": "COLUMBIA STATION",
    "dropdeladd": "26535 ROYALTON RD",
    "dropdelcty": "COLUMBIA STATION",
    "dropdelst": "OH",
    "dropdelzpp": 440289058,
    "dropphyadd": "26535 ROYALTON RD",
    "dropphycty": "COLUMBIA STATION",
    "dropphyst": "OH",
    "dropphyzpp": 440289058,
    "dropmaladd": "26535 ROYALTON RD",
    "dropmalcty": "COLUMBIA STATION",
    "dropmalst": "OH",
    "dropmalzpp": 440289058,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402365433,
    "dropfax": 4402363457
  },
  {
    "dcode": "D",
    "dropkey": "PX20641",
    "droptype": "D",
    "dropname": "COLUMBIANA",
    "dropdeladd": "149 S MAIN ST STE 2",
    "dropdelcty": "COLUMBIANA",
    "dropdelst": "OH",
    "dropdelzpp": 444089998,
    "dropphyadd": "149 S MAIN ST STE 2",
    "dropphycty": "COLUMBIANA",
    "dropphyst": "OH",
    "dropphyzpp": 444089998,
    "dropmaladd": "149 S MAIN ST STE 2",
    "dropmalcty": "COLUMBIANA",
    "dropmalst": "OH",
    "dropmalzpp": 444089998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304824111,
    "dropsitcph": 3304824111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20643",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "850 TWIN RIVERS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432169712,
    "dropphyadd": "850 TWIN RIVERS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432169712,
    "dropmaladd": "850 TWIN RIVERS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432169712,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694516,
    "dropsitcph": 6144694516,
    "dropfax": 6144694546
  },
  {
    "dcode": "D",
    "dropkey": "PX20644",
    "droptype": "D",
    "dropname": "COLUMBUS GROVE",
    "dropdeladd": "122 N HIGH ST",
    "dropdelcty": "COLUMBUS GROVE",
    "dropdelst": "OH",
    "dropdelzpp": 458309998,
    "dropphyadd": "122 N HIGH ST",
    "dropphycty": "COLUMBUS GROVE",
    "dropphyst": "OH",
    "dropphyzpp": 458309998,
    "dropmaladd": "122 N HIGH ST",
    "dropmalcty": "COLUMBUS GROVE",
    "dropmalst": "OH",
    "dropmalzpp": 458309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196592100,
    "dropsitcph": 4196592100,
    "dropfax": 4196592100
  },
  {
    "dcode": "D",
    "dropkey": "PX20648",
    "droptype": "D",
    "dropname": "COMMERCIAL POINT",
    "dropdeladd": "12 BELSHAZZAR ST",
    "dropdelcty": "COMMERCIAL POINT",
    "dropdelst": "OH",
    "dropdelzpp": 431169900,
    "dropphyadd": "12 BELSHAZZAR ST",
    "dropphycty": "COMMERCIAL POINT",
    "dropphyst": "OH",
    "dropphyzpp": 431169900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMMERCIAL POINT",
    "dropmalst": "OH",
    "dropmalzpp": 431169998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148774170,
    "dropsitcph": 6148774170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20654",
    "droptype": "D",
    "dropname": "CONESVILLE",
    "dropdeladd": "504 MARQUAND AVE",
    "dropdelcty": "CONESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 438119772,
    "dropphyadd": "504 MARQUAND AVE",
    "dropphycty": "CONESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 438119772,
    "dropmaladd": "504 MARQUAND AVE",
    "dropmalcty": "CONESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 438119772,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408292180,
    "dropsitcph": 7408292180,
    "dropfax": 7408292181
  },
  {
    "dcode": "D",
    "dropkey": "PX20658",
    "droptype": "D",
    "dropname": "CONNEAUT",
    "dropdeladd": "268 STATE ST",
    "dropdelcty": "CONNEAUT",
    "dropdelst": "OH",
    "dropdelzpp": 440309998,
    "dropphyadd": "268 STATE ST",
    "dropphycty": "CONNEAUT",
    "dropphyst": "OH",
    "dropphyzpp": 440309998,
    "dropmaladd": "268 STATE ST",
    "dropmalcty": "CONNEAUT",
    "dropmalst": "OH",
    "dropmalzpp": 440309998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405998111,
    "dropfax": 4405936078
  },
  {
    "dcode": "D",
    "dropkey": "PX20663",
    "droptype": "D",
    "dropname": "CONOVER",
    "dropdeladd": "7711 N ALCONY CONOVER RD",
    "dropdelcty": "CONOVER",
    "dropdelst": "OH",
    "dropdelzpp": 453179998,
    "dropphyadd": "7711 N ALCONY CONOVER RD",
    "dropphycty": "CONOVER",
    "dropphyst": "OH",
    "dropphyzpp": 453179998,
    "dropmaladd": "7711 N ALCONY CONOVER RD",
    "dropmalcty": "CONOVER",
    "dropmalst": "OH",
    "dropmalzpp": 453179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373683039,
    "dropsitcph": 9373683039,
    "dropfax": 9373683099
  },
  {
    "dcode": "D",
    "dropkey": "PX20665",
    "droptype": "D",
    "dropname": "CONTINENTAL",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "CONTINENTAL",
    "dropdelst": "OH",
    "dropdelzpp": 458319998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "CONTINENTAL",
    "dropphyst": "OH",
    "dropphyzpp": 458319998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "CONTINENTAL",
    "dropmalst": "OH",
    "dropmalzpp": 458319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195963505,
    "dropsitcph": 4195963505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20685",
    "droptype": "D",
    "dropname": "CONVOY",
    "dropdeladd": "116 W TULLY ST",
    "dropdelcty": "CONVOY",
    "dropdelst": "OH",
    "dropdelzpp": 458329998,
    "dropphyadd": "116 W TULLY ST",
    "dropphycty": "CONVOY",
    "dropphyst": "OH",
    "dropphyzpp": 458329998,
    "dropmaladd": "116 W TULLY ST",
    "dropmalcty": "CONVOY",
    "dropmalst": "OH",
    "dropmalzpp": 458329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197492015,
    "dropsitcph": 4197492015,
    "dropfax": 4197499802
  },
  {
    "dcode": "D",
    "dropkey": "PX20688",
    "droptype": "D",
    "dropname": "COOLVILLE",
    "dropdeladd": "26141 MAIN ST",
    "dropdelcty": "COOLVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457239582,
    "dropphyadd": "26141 MAIN ST",
    "dropphycty": "COOLVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457239582,
    "dropmaladd": "26141 MAIN ST",
    "dropmalcty": "COOLVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457239582,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406673928,
    "dropsitcph": 7406673928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20698",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "105 WASHINGTON ST",
    "dropdelcty": "CORNING",
    "dropdelst": "OH",
    "dropdelzpp": 437309900,
    "dropphyadd": "105 WASHINGTON ST",
    "dropphycty": "CORNING",
    "dropphyst": "OH",
    "dropphyzpp": 437309900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNING",
    "dropmalst": "OH",
    "dropmalzpp": 437309998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403474702,
    "dropsitcph": 7403474702,
    "dropfax": 7403474702
  },
  {
    "dcode": "D",
    "dropkey": "PX20701",
    "droptype": "D",
    "dropname": "CORTLAND",
    "dropdeladd": "307 S HIGH ST",
    "dropdelcty": "CORTLAND",
    "dropdelst": "OH",
    "dropdelzpp": 444109998,
    "dropphyadd": "307 S HIGH ST",
    "dropphycty": "CORTLAND",
    "dropphyst": "OH",
    "dropphyzpp": 444109998,
    "dropmaladd": "307 S HIGH ST",
    "dropmalcty": "CORTLAND",
    "dropmalst": "OH",
    "dropmalzpp": 444109998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306372981,
    "dropsitcph": 3306372981,
    "dropfax": 3306373162
  },
  {
    "dcode": "D",
    "dropkey": "PX20704",
    "droptype": "D",
    "dropname": "COSHOCTON",
    "dropdeladd": "516 CHESTNUT ST FRNT",
    "dropdelcty": "COSHOCTON",
    "dropdelst": "OH",
    "dropdelzpp": 438129998,
    "dropphyadd": "516 CHESTNUT ST FRNT",
    "dropphycty": "COSHOCTON",
    "dropphyst": "OH",
    "dropphyzpp": 438129998,
    "dropmaladd": "516 CHESTNUT ST FRNT",
    "dropmalcty": "COSHOCTON",
    "dropmalst": "OH",
    "dropmalzpp": 438129998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406224821,
    "dropsitcph": 7406224821,
    "dropfax": 7406226596
  },
  {
    "dcode": "D",
    "dropkey": "PX20713",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "8 E SPRING ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 453189998,
    "dropphyadd": "8 E SPRING ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 453189998,
    "dropmaladd": "8 E SPRING ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 453189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374733431,
    "dropsitcph": 9374733431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20727",
    "droptype": "D",
    "dropname": "CRESTLINE",
    "dropdeladd": "244 N SELTZER ST",
    "dropdelcty": "CRESTLINE",
    "dropdelst": "OH",
    "dropdelzpp": 448279998,
    "dropphyadd": "244 N SELTZER ST",
    "dropphycty": "CRESTLINE",
    "dropphyst": "OH",
    "dropphyzpp": 448279998,
    "dropmaladd": "244 N SELTZER ST",
    "dropmalcty": "CRESTLINE",
    "dropmalst": "OH",
    "dropmalzpp": 448279998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196833969,
    "dropfax": 4196832648
  },
  {
    "dcode": "D",
    "dropkey": "PX20728",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "122 S MAIN ST",
    "dropdelcty": "CRESTON",
    "dropdelst": "OH",
    "dropdelzpp": 442179998,
    "dropphyadd": "122 S MAIN ST",
    "dropphycty": "CRESTON",
    "dropphyst": "OH",
    "dropphyzpp": 442179998,
    "dropmaladd": "122 S MAIN ST",
    "dropmalcty": "CRESTON",
    "dropmalst": "OH",
    "dropmalzpp": 442179998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304853463,
    "dropfax": 3304356166
  },
  {
    "dcode": "D",
    "dropkey": "PX20734",
    "droptype": "D",
    "dropname": "CROOKSVILLE",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "CROOKSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437319902,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "CROOKSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437319902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROOKSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437319997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409823021,
    "dropsitcph": 7409823021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20738",
    "droptype": "D",
    "dropname": "CROTON",
    "dropdeladd": "14 S HIGH ST",
    "dropdelcty": "CROTON",
    "dropdelst": "OH",
    "dropdelzpp": 430138000,
    "dropphyadd": "14 S HIGH ST",
    "dropphycty": "CROTON",
    "dropphyst": "OH",
    "dropphyzpp": 430138000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROTON",
    "dropmalst": "OH",
    "dropmalzpp": 430139998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408933411,
    "dropsitcph": 7408933411,
    "dropfax": 7408933411
  },
  {
    "dcode": "D",
    "dropkey": "PX20739",
    "droptype": "D",
    "dropname": "CROWN CITY",
    "dropdeladd": "54 CHARLES ST",
    "dropdelcty": "CROWN CITY",
    "dropdelst": "OH",
    "dropdelzpp": 456239800,
    "dropphyadd": "54 CHARLES ST",
    "dropphycty": "CROWN CITY",
    "dropphyst": "OH",
    "dropphyzpp": 456239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWN CITY",
    "dropmalst": "OH",
    "dropmalzpp": 456239998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402561947,
    "dropsitcph": 7402561947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20741",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "301 MILL ST",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "OH",
    "dropdelzpp": 437329901,
    "dropphyadd": "301 MILL ST",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "OH",
    "dropphyzpp": 437329901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "OH",
    "dropmalzpp": 437329998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406385901,
    "dropsitcph": 7406385901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20744",
    "droptype": "D",
    "dropname": "CURTICE",
    "dropdeladd": "7160 N LAKE ST",
    "dropdelcty": "CURTICE",
    "dropdelst": "OH",
    "dropdelzpp": 434129998,
    "dropphyadd": "7160 N LAKE ST",
    "dropphycty": "CURTICE",
    "dropphyst": "OH",
    "dropphyzpp": 434129998,
    "dropmaladd": "7160 N LAKE ST",
    "dropmalcty": "CURTICE",
    "dropmalst": "OH",
    "dropmalzpp": 434129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198368006,
    "dropsitcph": 4198368006,
    "dropfax": 4198362427
  },
  {
    "dcode": "D",
    "dropkey": "PX20745",
    "droptype": "D",
    "dropname": "CUSTAR",
    "dropdeladd": "8906 CUSTAR RD",
    "dropdelcty": "CUSTAR",
    "dropdelst": "OH",
    "dropdelzpp": 435119998,
    "dropphyadd": "8906 CUSTAR RD",
    "dropphycty": "CUSTAR",
    "dropphyst": "OH",
    "dropphyzpp": 435119998,
    "dropmaladd": "8906 CUSTAR RD",
    "dropmalcty": "CUSTAR",
    "dropmalst": "OH",
    "dropmalzpp": 435119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196692896,
    "dropsitcph": 4196692896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20746",
    "droptype": "D",
    "dropname": "CUTLER",
    "dropdeladd": "9722 STATE ROUTE 555",
    "dropdelcty": "CUTLER",
    "dropdelst": "OH",
    "dropdelzpp": 457249810,
    "dropphyadd": "9722 STATE ROUTE 555",
    "dropphycty": "CUTLER",
    "dropphyst": "OH",
    "dropphyzpp": 457249810,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUTLER",
    "dropmalst": "OH",
    "dropmalzpp": 457249998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409892011,
    "dropsitcph": 7409892011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20747",
    "droptype": "D",
    "dropname": "CUYAHOGA FALLS",
    "dropdeladd": "2054 2ND ST",
    "dropdelcty": "CUYAHOGA FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 442219998,
    "dropphyadd": "2054 2ND ST",
    "dropphycty": "CUYAHOGA FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 442219998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUYAHOGA FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 442229998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309458091,
    "dropfax": 3309459077
  },
  {
    "dcode": "D",
    "dropkey": "PX20750",
    "droptype": "D",
    "dropname": "CYGNET",
    "dropdeladd": "335 FRONT ST",
    "dropdelcty": "CYGNET",
    "dropdelst": "OH",
    "dropdelzpp": 434139998,
    "dropphyadd": "335 FRONT ST",
    "dropphycty": "CYGNET",
    "dropphyst": "OH",
    "dropphyzpp": 434139998,
    "dropmaladd": "335 FRONT ST",
    "dropmalcty": "CYGNET",
    "dropmalst": "OH",
    "dropmalzpp": 434139998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196552065,
    "dropsitcph": 4196552065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20756",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "20 W MAIN ST",
    "dropdelcty": "DALTON",
    "dropdelst": "OH",
    "dropdelzpp": 446189801,
    "dropphyadd": "20 W MAIN ST",
    "dropphycty": "DALTON",
    "dropphyst": "OH",
    "dropphyzpp": 446189801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALTON",
    "dropmalst": "OH",
    "dropmalzpp": 446189998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308282004,
    "dropfax": 3308288225
  },
  {
    "dcode": "D",
    "dropkey": "PX20759",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "16098 W SALEM ALLIANCE RD",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "OH",
    "dropdelzpp": 446199800,
    "dropphyadd": "16098 W SALEM ALLIANCE RD",
    "dropphycty": "DAMASCUS",
    "dropphyst": "OH",
    "dropphyzpp": 446199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "OH",
    "dropmalzpp": 446199998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305373059,
    "dropfax": 3305373059
  },
  {
    "dcode": "D",
    "dropkey": "PX20760",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "414 S MARKET ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430149007,
    "dropphyadd": "414 S MARKET ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430149007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430149998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405997111,
    "dropsitcph": 7405997111,
    "dropfax": 7405999037
  },
  {
    "dcode": "D",
    "dropkey": "PX20776",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "1111 E 5TH ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454019998,
    "dropphyadd": "1111 E 5TH ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454019998,
    "dropmaladd": "1111 E 5TH ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 9372271120,
    "dropfax": 9372271169
  },
  {
    "dcode": "D",
    "dropkey": "PX20780",
    "droptype": "D",
    "dropname": "DE GRAFF",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "DE GRAFF",
    "dropdelst": "OH",
    "dropdelzpp": 433189432,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "DE GRAFF",
    "dropphyst": "OH",
    "dropphyzpp": 433189432,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE GRAFF",
    "dropmalst": "OH",
    "dropmalzpp": 433189998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375854621,
    "dropsitcph": 9375854621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20782",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "6471 HUFF HILL RD",
    "dropdelcty": "DECATUR",
    "dropdelst": "OH",
    "dropdelzpp": 451159998,
    "dropphyadd": "6471 HUFF HILL RD",
    "dropphycty": "DECATUR",
    "dropphyst": "OH",
    "dropphyzpp": 451159998,
    "dropmaladd": "6471 HUFF HILL RD",
    "dropmalcty": "DECATUR",
    "dropmalst": "OH",
    "dropmalzpp": 451159998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373733581,
    "dropsitcph": 9373733581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20786",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "1365 STATE ROUTE 14",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 444119800,
    "dropphyadd": "1365 STATE ROUTE 14",
    "dropphycty": "DEERFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 444119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 444119998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305845901,
    "dropsitcph": 3305845901,
    "dropfax": 3305845901
  },
  {
    "dcode": "D",
    "dropkey": "PX20791",
    "droptype": "D",
    "dropname": "DEFIANCE",
    "dropdeladd": "420 W 2ND ST",
    "dropdelcty": "DEFIANCE",
    "dropdelst": "OH",
    "dropdelzpp": 435129998,
    "dropphyadd": "420 W 2ND ST",
    "dropphycty": "DEFIANCE",
    "dropphyst": "OH",
    "dropphyzpp": 435129998,
    "dropmaladd": "420 W 2ND ST",
    "dropmalcty": "DEFIANCE",
    "dropmalst": "OH",
    "dropmalzpp": 435129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197822811,
    "dropsitcph": 4197822811,
    "dropfax": 4197706159
  },
  {
    "dcode": "D",
    "dropkey": "PX20793",
    "droptype": "D",
    "dropname": "DELAWARE",
    "dropdeladd": "35 S LIBERTY ST",
    "dropdelcty": "DELAWARE",
    "dropdelst": "OH",
    "dropdelzpp": 430152596,
    "dropphyadd": "35 S LIBERTY ST",
    "dropphycty": "DELAWARE",
    "dropphyst": "OH",
    "dropphyzpp": 430152596,
    "dropmaladd": "35 S LIBERTY ST",
    "dropmalcty": "DELAWARE",
    "dropmalst": "OH",
    "dropmalzpp": 430152596,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403631906,
    "dropsitcph": 7403631906,
    "dropfax": 7403633530
  },
  {
    "dcode": "D",
    "dropkey": "PX20795",
    "droptype": "D",
    "dropname": "DELLROY",
    "dropdeladd": "3 E MAIN ST",
    "dropdelcty": "DELLROY",
    "dropdelst": "OH",
    "dropdelzpp": 446209801,
    "dropphyadd": "3 E MAIN ST",
    "dropphycty": "DELLROY",
    "dropphyst": "OH",
    "dropphyzpp": 446209801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELLROY",
    "dropmalst": "OH",
    "dropmalzpp": 446209998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307352220,
    "dropfax": 3307352220
  },
  {
    "dcode": "D",
    "dropkey": "PX20798",
    "droptype": "D",
    "dropname": "DELPHOS",
    "dropdeladd": "127 N MAIN ST",
    "dropdelcty": "DELPHOS",
    "dropdelst": "OH",
    "dropdelzpp": 458339998,
    "dropphyadd": "127 N MAIN ST",
    "dropphycty": "DELPHOS",
    "dropphyst": "OH",
    "dropphyzpp": 458339998,
    "dropmaladd": "127 N MAIN ST",
    "dropmalcty": "DELPHOS",
    "dropmalst": "OH",
    "dropmalzpp": 458339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196952811,
    "dropsitcph": 4196952811,
    "dropfax": 4196952511
  },
  {
    "dcode": "D",
    "dropkey": "PX20799",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "6660 US HIGHWAY 20A",
    "dropdelcty": "DELTA",
    "dropdelst": "OH",
    "dropdelzpp": 435159370,
    "dropphyadd": "6660 US HIGHWAY 20A",
    "dropphycty": "DELTA",
    "dropphyst": "OH",
    "dropphyzpp": 435159370,
    "dropmaladd": "6660 US HIGHWAY 20A",
    "dropmalcty": "DELTA",
    "dropmalst": "OH",
    "dropmalzpp": 435159370,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198223117,
    "dropsitcph": 4198223117,
    "dropfax": 4198223946
  },
  {
    "dcode": "D",
    "dropkey": "PX20801",
    "droptype": "D",
    "dropname": "DENNISON",
    "dropdeladd": "115 N 3RD ST STE 2",
    "dropdelcty": "DENNISON",
    "dropdelst": "OH",
    "dropdelzpp": 446219998,
    "dropphyadd": "115 N 3RD ST STE 2",
    "dropphycty": "DENNISON",
    "dropphyst": "OH",
    "dropphyzpp": 446219998,
    "dropmaladd": "115 N 3RD ST STE 2",
    "dropmalcty": "DENNISON",
    "dropmalst": "OH",
    "dropmalzpp": 446219998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7409220912,
    "dropfax": 7409229397
  },
  {
    "dcode": "D",
    "dropkey": "PX20806",
    "droptype": "D",
    "dropname": "DERWENT",
    "dropdeladd": "10936 CLAY PIKE RD",
    "dropdelcty": "DERWENT",
    "dropdelst": "OH",
    "dropdelzpp": 437339900,
    "dropphyadd": "10936 CLAY PIKE RD",
    "dropphycty": "DERWENT",
    "dropphyst": "OH",
    "dropphyzpp": 437339900,
    "dropmaladd": "10936 CLAY PIKE RD",
    "dropmalcty": "DERWENT",
    "dropmalst": "OH",
    "dropmalzpp": 437339900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406855990,
    "dropsitcph": 7406855990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20807",
    "droptype": "D",
    "dropname": "DESHLER",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "DESHLER",
    "dropdelst": "OH",
    "dropdelzpp": 435161286,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "DESHLER",
    "dropphyst": "OH",
    "dropphyzpp": 435161286,
    "dropmaladd": "106 E MAIN ST",
    "dropmalcty": "DESHLER",
    "dropmalst": "OH",
    "dropmalzpp": 435161286,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192786447,
    "dropsitcph": 4192786447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20811",
    "droptype": "D",
    "dropname": "DEXTER CITY",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "DEXTER CITY",
    "dropdelst": "OH",
    "dropdelzpp": 457279800,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "DEXTER CITY",
    "dropphyst": "OH",
    "dropphyzpp": 457279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEXTER CITY",
    "dropmalst": "OH",
    "dropmalzpp": 457279998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407837715,
    "dropsitcph": 7407837715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20812",
    "droptype": "D",
    "dropname": "DIAMOND",
    "dropdeladd": "10096 TALLMADGE RD",
    "dropdelcty": "DIAMOND",
    "dropdelst": "OH",
    "dropdelzpp": 444129800,
    "dropphyadd": "10096 TALLMADGE RD",
    "dropphycty": "DIAMOND",
    "dropphyst": "OH",
    "dropphyzpp": 444129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIAMOND",
    "dropmalst": "OH",
    "dropmalzpp": 444129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306544111,
    "dropsitcph": 3306544111,
    "dropfax": 3306546014
  },
  {
    "dcode": "D",
    "dropkey": "PX20816",
    "droptype": "D",
    "dropname": "DILLONVALE",
    "dropdeladd": "132 SMITHFIELD ST",
    "dropdelcty": "DILLONVALE",
    "dropdelst": "OH",
    "dropdelzpp": 439179800,
    "dropphyadd": "132 SMITHFIELD ST",
    "dropphycty": "DILLONVALE",
    "dropphyst": "OH",
    "dropphyzpp": 439179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DILLONVALE",
    "dropmalst": "OH",
    "dropmalzpp": 439179998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407692200,
    "dropsitcph": 7407692200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20823",
    "droptype": "D",
    "dropname": "DOLA",
    "dropdeladd": "9924 FRANKLIN ST",
    "dropdelcty": "DOLA",
    "dropdelst": "OH",
    "dropdelzpp": 458359998,
    "dropphyadd": "9924 FRANKLIN ST",
    "dropphycty": "DOLA",
    "dropphyst": "OH",
    "dropphyzpp": 458359998,
    "dropmaladd": "9924 FRANKLIN ST",
    "dropmalcty": "DOLA",
    "dropmalst": "OH",
    "dropmalzpp": 458359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197592158,
    "dropsitcph": 4197592158,
    "dropfax": 4197592803
  },
  {
    "dcode": "D",
    "dropkey": "PX20825",
    "droptype": "D",
    "dropname": "DONNELSVILLE",
    "dropdeladd": "17 S HAMPTON RD",
    "dropdelcty": "DONNELSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453199998,
    "dropphyadd": "17 S HAMPTON RD",
    "dropphycty": "DONNELSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453199998,
    "dropmaladd": "17 S HAMPTON RD",
    "dropmalcty": "DONNELSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453199998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378826785,
    "dropsitcph": 9378826785,
    "dropfax": 9378820108
  },
  {
    "dcode": "D",
    "dropkey": "PX20829",
    "droptype": "D",
    "dropname": "DORSET",
    "dropdeladd": "2477 STATE ROUTE 193",
    "dropdelcty": "DORSET",
    "dropdelst": "OH",
    "dropdelzpp": 440329803,
    "dropphyadd": "2477 STATE ROUTE 193",
    "dropphycty": "DORSET",
    "dropphyst": "OH",
    "dropphyzpp": 440329803,
    "dropmaladd": "2477 STATE ROUTE 193",
    "dropmalcty": "DORSET",
    "dropmalst": "OH",
    "dropmalzpp": 440329803,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4408582801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20830",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "230 W 3RD ST",
    "dropdelcty": "DOVER",
    "dropdelst": "OH",
    "dropdelzpp": 446229998,
    "dropphyadd": "230 W 3RD ST",
    "dropphycty": "DOVER",
    "dropphyst": "OH",
    "dropphyzpp": 446229998,
    "dropmaladd": "230 W 3RD ST",
    "dropmalcty": "DOVER",
    "dropmalst": "OH",
    "dropmalzpp": 446229998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303433641,
    "dropfax": 3306023101
  },
  {
    "dcode": "D",
    "dropkey": "PX20834",
    "droptype": "D",
    "dropname": "DOYLESTOWN",
    "dropdeladd": "85 GATES ST",
    "dropdelcty": "DOYLESTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 442309998,
    "dropphyadd": "85 GATES ST",
    "dropphycty": "DOYLESTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 442309998,
    "dropmaladd": "85 GATES ST",
    "dropmalcty": "DOYLESTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 442309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306483164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20837",
    "droptype": "D",
    "dropname": "DRESDEN",
    "dropdeladd": "25 W 4TH ST",
    "dropdelcty": "DRESDEN",
    "dropdelst": "OH",
    "dropdelzpp": 438219046,
    "dropphyadd": "25 W 4TH ST",
    "dropphycty": "DRESDEN",
    "dropphyst": "OH",
    "dropphyzpp": 438219046,
    "dropmaladd": "25 W 4TH ST",
    "dropmalcty": "DRESDEN",
    "dropmalst": "OH",
    "dropmalzpp": 438219046,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407541059,
    "dropsitcph": 7407541059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20839",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "6400 EMERALD PKWY",
    "dropdelcty": "DUBLIN",
    "dropdelst": "OH",
    "dropdelzpp": 430169998,
    "dropphyadd": "6400 EMERALD PKWY",
    "dropphycty": "DUBLIN",
    "dropphyst": "OH",
    "dropphyzpp": 430169998,
    "dropmaladd": "6400 EMERALD PKWY",
    "dropmalcty": "DUBLIN",
    "dropmalst": "OH",
    "dropmalzpp": 430169998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720674,
    "dropsitcph": 6148890763,
    "dropfax": 6148890671
  },
  {
    "dcode": "D",
    "dropkey": "PX20845",
    "droptype": "D",
    "dropname": "DUNBRIDGE",
    "dropdeladd": "10951 MIDDLETON PIKE",
    "dropdelcty": "DUNBRIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 434149998,
    "dropphyadd": "10951 MIDDLETON PIKE",
    "dropphycty": "DUNBRIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 434149998,
    "dropmaladd": "10951 MIDDLETON PIKE",
    "dropmalcty": "DUNBRIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 434149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193529137,
    "dropsitcph": 4193529137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20846",
    "droptype": "D",
    "dropname": "DUNCAN FALLS",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "DUNCAN FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 437349900,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "DUNCAN FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 437349900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNCAN FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 437349998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406746425,
    "dropsitcph": 7406746425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20848",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "6759 STATE ROUTE 93 NW",
    "dropdelcty": "DUNDEE",
    "dropdelst": "OH",
    "dropdelzpp": 446249800,
    "dropphyadd": "6759 STATE ROUTE 93 NW",
    "dropphycty": "DUNDEE",
    "dropphyst": "OH",
    "dropphyzpp": 446249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNDEE",
    "dropmalst": "OH",
    "dropmalzpp": 446249998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308524416,
    "dropfax": 3308520621
  },
  {
    "dcode": "D",
    "dropkey": "PX20855",
    "droptype": "D",
    "dropname": "DUNKIRK",
    "dropdeladd": "250 N MAIN ST",
    "dropdelcty": "DUNKIRK",
    "dropdelst": "OH",
    "dropdelzpp": 458369998,
    "dropphyadd": "250 N MAIN ST",
    "dropphycty": "DUNKIRK",
    "dropphyst": "OH",
    "dropphyzpp": 458369998,
    "dropmaladd": "250 N MAIN ST",
    "dropmalcty": "DUNKIRK",
    "dropmalst": "OH",
    "dropmalzpp": 458369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197593535,
    "dropsitcph": 4197593535,
    "dropfax": 4197593535
  },
  {
    "dcode": "D",
    "dropkey": "PX20872",
    "droptype": "D",
    "dropname": "EAST CLARIDON",
    "dropdeladd": "12442 OLD STATE RD",
    "dropdelcty": "EAST CLARIDON",
    "dropdelst": "OH",
    "dropdelzpp": 440339800,
    "dropphyadd": "12442 OLD STATE RD",
    "dropphycty": "EAST CLARIDON",
    "dropphyst": "OH",
    "dropphyzpp": 440339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST CLARIDON",
    "dropmalst": "OH",
    "dropmalzpp": 440339998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4406351071,
    "dropfax": 4406351071
  },
  {
    "dcode": "D",
    "dropkey": "PX20880",
    "droptype": "D",
    "dropname": "EAST FULTONHAM",
    "dropdeladd": "6970 AXLINE AVE",
    "dropdelcty": "EAST FULTONHAM",
    "dropdelst": "OH",
    "dropdelzpp": 437359900,
    "dropphyadd": "6970 AXLINE AVE",
    "dropphycty": "EAST FULTONHAM",
    "dropphyst": "OH",
    "dropphyzpp": 437359900,
    "dropmaladd": "6970 AXLINE AVE",
    "dropmalcty": "EAST FULTONHAM",
    "dropmalst": "OH",
    "dropmalzpp": 437359900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408492523,
    "dropsitcph": 7408492523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20882",
    "droptype": "D",
    "dropname": "EAST LIBERTY",
    "dropdeladd": "3236 S MAIN ST",
    "dropdelcty": "EAST LIBERTY",
    "dropdelst": "OH",
    "dropdelzpp": 433199493,
    "dropphyadd": "3236 S MAIN ST",
    "dropphycty": "EAST LIBERTY",
    "dropphyst": "OH",
    "dropphyzpp": 433199493,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST LIBERTY",
    "dropmalst": "OH",
    "dropmalzpp": 433199998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376664292,
    "dropsitcph": 9376664292,
    "dropfax": 9376662610
  },
  {
    "dcode": "D",
    "dropkey": "PX20884",
    "droptype": "D",
    "dropname": "EAST LIVERPOOL",
    "dropdeladd": "515 WALNUT ST",
    "dropdelcty": "EAST LIVERPOOL",
    "dropdelst": "OH",
    "dropdelzpp": 439209800,
    "dropphyadd": "515 WALNUT ST",
    "dropphycty": "EAST LIVERPOOL",
    "dropphyst": "OH",
    "dropphyzpp": 439209800,
    "dropmaladd": "515 WALNUT ST",
    "dropmalcty": "EAST LIVERPOOL",
    "dropmalst": "OH",
    "dropmalzpp": 439209800,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303853100,
    "dropsitcph": 3303853100,
    "dropfax": 3303858064
  },
  {
    "dcode": "D",
    "dropkey": "PX20890",
    "droptype": "D",
    "dropname": "EAST PALESTINE",
    "dropdeladd": "269 N MARKET ST",
    "dropdelcty": "EAST PALESTINE",
    "dropdelst": "OH",
    "dropdelzpp": 444139998,
    "dropphyadd": "269 N MARKET ST",
    "dropphycty": "EAST PALESTINE",
    "dropphyst": "OH",
    "dropphyzpp": 444139998,
    "dropmaladd": "269 N MARKET ST",
    "dropmalcty": "EAST PALESTINE",
    "dropmalst": "OH",
    "dropmalzpp": 444139998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304269333,
    "dropsitcph": 3304269333,
    "dropfax": 3308861066
  },
  {
    "dcode": "D",
    "dropkey": "PX20891",
    "droptype": "D",
    "dropname": "EAST ROCHESTER",
    "dropdeladd": "24781 US ROUTE 30",
    "dropdelcty": "EAST ROCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 446259998,
    "dropphyadd": "24781 US ROUTE 30",
    "dropphycty": "EAST ROCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 446259998,
    "dropmaladd": "24781 US ROUTE 30",
    "dropmalcty": "EAST ROCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 446259998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308942160,
    "dropfax": 3308942160
  },
  {
    "dcode": "D",
    "dropkey": "PX20893",
    "droptype": "D",
    "dropname": "EAST SPARTA",
    "dropdeladd": "2039 WALNUT ST SE",
    "dropdelcty": "EAST SPARTA",
    "dropdelst": "OH",
    "dropdelzpp": 446269800,
    "dropphyadd": "2039 WALNUT ST SE",
    "dropphycty": "EAST SPARTA",
    "dropphyst": "OH",
    "dropphyzpp": 446269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SPARTA",
    "dropmalst": "OH",
    "dropmalzpp": 446269998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308665160,
    "dropfax": 3308665160
  },
  {
    "dcode": "D",
    "dropkey": "PX20894",
    "droptype": "D",
    "dropname": "EAST SPRINGFIELD",
    "dropdeladd": "9889 COUNTY ROAD 39",
    "dropdelcty": "EAST SPRINGFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 439259997,
    "dropphyadd": "9889 COUNTY ROAD 39",
    "dropphycty": "EAST SPRINGFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 439259997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SPRINGFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 439259998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405434130,
    "dropsitcph": 7405434130,
    "dropfax": 7405433908
  },
  {
    "dcode": "D",
    "dropkey": "PX20902",
    "droptype": "D",
    "dropname": "EATON",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "EATON",
    "dropdelst": "OH",
    "dropdelzpp": 453209998,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "EATON",
    "dropphyst": "OH",
    "dropphyzpp": 453209998,
    "dropmaladd": "111 W MAIN ST",
    "dropmalcty": "EATON",
    "dropmalst": "OH",
    "dropmalzpp": 453209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374565026,
    "dropsitcph": 9374565026,
    "dropfax": 9374569821
  },
  {
    "dcode": "D",
    "dropkey": "PX20911",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "207 N MICHIGAN AVE",
    "dropdelcty": "EDGERTON",
    "dropdelst": "OH",
    "dropdelzpp": 435179998,
    "dropphyadd": "207 N MICHIGAN AVE",
    "dropphycty": "EDGERTON",
    "dropphyst": "OH",
    "dropphyzpp": 435179998,
    "dropmaladd": "207 N MICHIGAN AVE",
    "dropmalcty": "EDGERTON",
    "dropmalst": "OH",
    "dropmalzpp": 435179998,
    "dropsitphn": 5675778206,
    "dropsitlph": 5136845763,
    "dropsitcph": 5675778206,
    "dropfax": 5675778117
  },
  {
    "dcode": "D",
    "dropkey": "PX20915",
    "droptype": "D",
    "dropname": "EDISON",
    "dropdeladd": "101 N BOUNDARY ST",
    "dropdelcty": "EDISON",
    "dropdelst": "OH",
    "dropdelzpp": 433209630,
    "dropphyadd": "101 N BOUNDARY ST",
    "dropphycty": "EDISON",
    "dropphyst": "OH",
    "dropphyzpp": 433209630,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDISON",
    "dropmalst": "OH",
    "dropmalzpp": 433209998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4199469166,
    "dropsitcph": 4199469166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20916",
    "droptype": "D",
    "dropname": "EDON",
    "dropdeladd": "102 N MICHIGAN ST",
    "dropdelcty": "EDON",
    "dropdelst": "OH",
    "dropdelzpp": 435189998,
    "dropphyadd": "102 N MICHIGAN ST",
    "dropphycty": "EDON",
    "dropphyst": "OH",
    "dropphyzpp": 435189998,
    "dropmaladd": "102 N MICHIGAN ST",
    "dropmalcty": "EDON",
    "dropmalst": "OH",
    "dropmalzpp": 435189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192722814,
    "dropsitcph": 4192722814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20922",
    "droptype": "D",
    "dropname": "ELDORADO",
    "dropdeladd": "100 N MAPLE ST",
    "dropdelcty": "ELDORADO",
    "dropdelst": "OH",
    "dropdelzpp": 453219998,
    "dropphyadd": "100 N MAPLE ST",
    "dropphycty": "ELDORADO",
    "dropphyst": "OH",
    "dropphyzpp": 453219998,
    "dropmaladd": "100 N MAPLE ST",
    "dropmalcty": "ELDORADO",
    "dropmalst": "OH",
    "dropmalzpp": 453219998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372734231,
    "dropsitcph": 9372734231,
    "dropfax": 9372734232
  },
  {
    "dcode": "D",
    "dropkey": "PX20928",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "42188 STATE ROUTE 154",
    "dropdelcty": "ELKTON",
    "dropdelst": "OH",
    "dropdelzpp": 444159800,
    "dropphyadd": "42188 STATE ROUTE 154",
    "dropphycty": "ELKTON",
    "dropphyst": "OH",
    "dropphyzpp": 444159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKTON",
    "dropmalst": "OH",
    "dropmalzpp": 444159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304247677,
    "dropsitcph": 3304247677,
    "dropfax": 3304247677
  },
  {
    "dcode": "D",
    "dropkey": "PX20935",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "6036 S SALEM WARREN RD",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "OH",
    "dropdelzpp": 444169997,
    "dropphyadd": "6036 S SALEM WARREN RD",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "OH",
    "dropphyzpp": 444169997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "OH",
    "dropmalzpp": 444169998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305382300,
    "dropsitcph": 3305382300,
    "dropfax": 3305382892
  },
  {
    "dcode": "D",
    "dropkey": "PX20937",
    "droptype": "D",
    "dropname": "ELMORE",
    "dropdeladd": "328 RICE ST",
    "dropdelcty": "ELMORE",
    "dropdelst": "OH",
    "dropdelzpp": 434169998,
    "dropphyadd": "328 RICE ST",
    "dropphycty": "ELMORE",
    "dropphyst": "OH",
    "dropphyzpp": 434169998,
    "dropmaladd": "328 RICE ST",
    "dropmalcty": "ELMORE",
    "dropmalst": "OH",
    "dropmalzpp": 434169998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198623272,
    "dropsitcph": 4198623272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20941",
    "droptype": "D",
    "dropname": "ELYRIA",
    "dropdeladd": "345 E BRIDGE ST",
    "dropdelcty": "ELYRIA",
    "dropdelst": "OH",
    "dropdelzpp": 440355254,
    "dropphyadd": "345 E BRIDGE ST",
    "dropphycty": "ELYRIA",
    "dropphyst": "OH",
    "dropphyzpp": 440355254,
    "dropmaladd": "345 E BRIDGE ST",
    "dropmalcty": "ELYRIA",
    "dropmalst": "OH",
    "dropmalzpp": 440355254,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403230263,
    "dropfax": 4402840338
  },
  {
    "dcode": "D",
    "dropkey": "PX20942",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "170 NESSLEY ST",
    "dropdelcty": "EMPIRE",
    "dropdelst": "OH",
    "dropdelzpp": 439269800,
    "dropphyadd": "170 NESSLEY ST",
    "dropphycty": "EMPIRE",
    "dropphyst": "OH",
    "dropphyzpp": 439269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMPIRE",
    "dropmalst": "OH",
    "dropmalzpp": 439269998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405373583,
    "dropsitcph": 7405373583,
    "dropfax": 7405371492
  },
  {
    "dcode": "D",
    "dropkey": "PX20944",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "116 W NATIONAL RD",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 453229998,
    "dropphyadd": "116 W NATIONAL RD",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 453229998,
    "dropmaladd": "116 W NATIONAL RD",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 453229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378366085,
    "dropsitcph": 9378366085,
    "dropfax": 9378367024
  },
  {
    "dcode": "D",
    "dropkey": "PX20945",
    "droptype": "D",
    "dropname": "ENON",
    "dropdeladd": "27 N XENIA DR",
    "dropdelcty": "ENON",
    "dropdelst": "OH",
    "dropdelzpp": 453239998,
    "dropphyadd": "27 N XENIA DR",
    "dropphycty": "ENON",
    "dropphyst": "OH",
    "dropphyzpp": 453239998,
    "dropmaladd": "27 N XENIA DR",
    "dropmalcty": "ENON",
    "dropmalst": "OH",
    "dropmalzpp": 453239998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378642731,
    "dropsitcph": 9378642731,
    "dropfax": 9378642392
  },
  {
    "dcode": "D",
    "dropkey": "PX20953",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "1045 PIKE ST SW",
    "dropdelcty": "ETNA",
    "dropdelst": "OH",
    "dropdelzpp": 430188000,
    "dropphyadd": "1045 PIKE ST SW",
    "dropphycty": "ETNA",
    "dropphyst": "OH",
    "dropphyzpp": 430188000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ETNA",
    "dropmalst": "OH",
    "dropmalzpp": 430189998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409275700,
    "dropsitcph": 7409275700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20965",
    "droptype": "D",
    "dropname": "FAIRBORN",
    "dropdeladd": "67 W HEBBLE AVE",
    "dropdelcty": "FAIRBORN",
    "dropdelst": "OH",
    "dropdelzpp": 453249998,
    "dropphyadd": "67 W HEBBLE AVE",
    "dropphycty": "FAIRBORN",
    "dropphyst": "OH",
    "dropphyzpp": 453249998,
    "dropmaladd": "67 W HEBBLE AVE",
    "dropmalcty": "FAIRBORN",
    "dropmalst": "OH",
    "dropmalzpp": 453249998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378784647,
    "dropsitcph": 9378784647,
    "dropfax": 9378787466
  },
  {
    "dcode": "D",
    "dropkey": "PX20992",
    "droptype": "D",
    "dropname": "FARMER",
    "dropdeladd": "3948 STATE ROUTE 2",
    "dropdelcty": "FARMER",
    "dropdelst": "OH",
    "dropdelzpp": 435209998,
    "dropphyadd": "3948 STATE ROUTE 2",
    "dropphycty": "FARMER",
    "dropphyst": "OH",
    "dropphyzpp": 435209998,
    "dropmaladd": "3948 STATE ROUTE 2",
    "dropmalcty": "FARMER",
    "dropmalst": "OH",
    "dropmalzpp": 435209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196582096,
    "dropsitcph": 4196582096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX20999",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "101 S CHERRY ST",
    "dropdelcty": "FAYETTE",
    "dropdelst": "OH",
    "dropdelzpp": 435219998,
    "dropphyadd": "101 S CHERRY ST",
    "dropphycty": "FAYETTE",
    "dropphyst": "OH",
    "dropphyzpp": 435219998,
    "dropmaladd": "101 S CHERRY ST",
    "dropmalcty": "FAYETTE",
    "dropmalst": "OH",
    "dropmalzpp": 435219998,
    "dropsitphn": 3309969797,
    "dropsitlph": 4192456870,
    "dropsitcph": 4192372213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21001",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "201 S APPLE ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451189998,
    "dropphyadd": "201 S APPLE ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451189998,
    "dropmaladd": "201 S APPLE ST",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451189998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138753740,
    "dropsitcph": 5138753740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21007",
    "droptype": "D",
    "dropname": "FEESBURG",
    "dropdeladd": "8696 STATE ROUTE 505",
    "dropdelcty": "FEESBURG",
    "dropdelst": "OH",
    "dropdelzpp": 451199998,
    "dropphyadd": "8696 STATE ROUTE 505",
    "dropphycty": "FEESBURG",
    "dropphyst": "OH",
    "dropphyzpp": 451199998,
    "dropmaladd": "8696 STATE ROUTE 505",
    "dropmalcty": "FEESBURG",
    "dropmalst": "OH",
    "dropmalzpp": 451199998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373791920,
    "dropsitcph": 9373791920,
    "dropfax": 9373792427
  },
  {
    "dcode": "D",
    "dropkey": "PX21008",
    "droptype": "D",
    "dropname": "FELICITY",
    "dropdeladd": "323 W WALNUT ST",
    "dropdelcty": "FELICITY",
    "dropdelst": "OH",
    "dropdelzpp": 451209998,
    "dropphyadd": "323 W WALNUT ST",
    "dropphycty": "FELICITY",
    "dropphyst": "OH",
    "dropphyzpp": 451209998,
    "dropmaladd": "323 W WALNUT ST",
    "dropmalcty": "FELICITY",
    "dropmalst": "OH",
    "dropmalzpp": 451209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138762521,
    "dropsitcph": 5138762521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21014",
    "droptype": "D",
    "dropname": "FINDLAY",
    "dropdeladd": "229 W MAIN CROSS ST",
    "dropdelcty": "FINDLAY",
    "dropdelst": "OH",
    "dropdelzpp": 458409998,
    "dropphyadd": "229 W MAIN CROSS ST",
    "dropphycty": "FINDLAY",
    "dropphyst": "OH",
    "dropphyzpp": 458409998,
    "dropmaladd": "229 W MAIN CROSS ST",
    "dropmalcty": "FINDLAY",
    "dropmalst": "OH",
    "dropmalzpp": 458409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194231264,
    "dropsitcph": 4194231264,
    "dropfax": 4194233514
  },
  {
    "dcode": "D",
    "dropkey": "PX21027",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "15909 JEFFERSON ST",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "OH",
    "dropdelzpp": 448289800,
    "dropphyadd": "15909 JEFFERSON ST",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "OH",
    "dropphyzpp": 448289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "OH",
    "dropmalzpp": 448289998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194836778,
    "dropfax": 4194836778
  },
  {
    "dcode": "D",
    "dropkey": "PX21041",
    "droptype": "D",
    "dropname": "FOREST",
    "dropdeladd": "108 E LIMA ST",
    "dropdelcty": "FOREST",
    "dropdelst": "OH",
    "dropdelzpp": 458439998,
    "dropphyadd": "108 E LIMA ST",
    "dropphycty": "FOREST",
    "dropphyst": "OH",
    "dropphyzpp": 458439998,
    "dropmaladd": "108 E LIMA ST",
    "dropmalcty": "FOREST",
    "dropmalst": "OH",
    "dropmalzpp": 458439998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192732561,
    "dropsitcph": 4192732561,
    "dropfax": 4192732561
  },
  {
    "dcode": "D",
    "dropkey": "PX21045",
    "droptype": "D",
    "dropname": "FORT JENNINGS",
    "dropdeladd": "20 S WATER ST",
    "dropdelcty": "FORT JENNINGS",
    "dropdelst": "OH",
    "dropdelzpp": 458449998,
    "dropphyadd": "20 S WATER ST",
    "dropphycty": "FORT JENNINGS",
    "dropphyst": "OH",
    "dropphyzpp": 458449998,
    "dropmaladd": "20 S WATER ST",
    "dropmalcty": "FORT JENNINGS",
    "dropmalst": "OH",
    "dropmalzpp": 458449998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192862874,
    "dropsitcph": 4192862874,
    "dropfax": 4192863874
  },
  {
    "dcode": "D",
    "dropkey": "PX21046",
    "droptype": "D",
    "dropname": "FORT LORAMIE",
    "dropdeladd": "13 E PARK ST",
    "dropdelcty": "FORT LORAMIE",
    "dropdelst": "OH",
    "dropdelzpp": 458459998,
    "dropphyadd": "13 E PARK ST",
    "dropphycty": "FORT LORAMIE",
    "dropphyst": "OH",
    "dropphyzpp": 458459998,
    "dropmaladd": "13 E PARK ST",
    "dropmalcty": "FORT LORAMIE",
    "dropmalst": "OH",
    "dropmalzpp": 458459998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372952100,
    "dropsitcph": 9372952100,
    "dropfax": 9372953178
  },
  {
    "dcode": "D",
    "dropkey": "PX21047",
    "droptype": "D",
    "dropname": "FORT RECOVERY",
    "dropdeladd": "206 SAINT CLAIR ST",
    "dropdelcty": "FORT RECOVERY",
    "dropdelst": "OH",
    "dropdelzpp": 458469998,
    "dropphyadd": "206 SAINT CLAIR ST",
    "dropphycty": "FORT RECOVERY",
    "dropphyst": "OH",
    "dropphyzpp": 458469998,
    "dropmaladd": "206 SAINT CLAIR ST",
    "dropmalcty": "FORT RECOVERY",
    "dropmalst": "OH",
    "dropmalzpp": 458469998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193752656,
    "dropsitcph": 4193752656,
    "dropfax": 4193752656
  },
  {
    "dcode": "D",
    "dropkey": "PX21051",
    "droptype": "D",
    "dropname": "FOSTORIA",
    "dropdeladd": "202 W CENTER ST",
    "dropdelcty": "FOSTORIA",
    "dropdelst": "OH",
    "dropdelzpp": 448309998,
    "dropphyadd": "202 W CENTER ST",
    "dropphycty": "FOSTORIA",
    "dropphyst": "OH",
    "dropphyzpp": 448309998,
    "dropmaladd": "202 W CENTER ST",
    "dropmalcty": "FOSTORIA",
    "dropmalst": "OH",
    "dropmalzpp": 448309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194356651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21055",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "3455 YOUNGSTOWN KINGSVILLE RD",
    "dropdelcty": "FOWLER",
    "dropdelst": "OH",
    "dropdelzpp": 444189800,
    "dropphyadd": "3455 YOUNGSTOWN KINGSVILLE RD",
    "dropphycty": "FOWLER",
    "dropphyst": "OH",
    "dropphyzpp": 444189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOWLER",
    "dropmalst": "OH",
    "dropmalzpp": 444189998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306385879,
    "dropsitcph": 3306385879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21058",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "32 N MAIN ST",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "OH",
    "dropdelzpp": 456289800,
    "dropphyadd": "32 N MAIN ST",
    "dropphycty": "FRANKFORT",
    "dropphyst": "OH",
    "dropphyzpp": 456289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "OH",
    "dropmalzpp": 456289998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404937006,
    "dropsitcph": 7404937006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21059",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "712 E 2ND ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "OH",
    "dropdelzpp": 450059998,
    "dropphyadd": "712 E 2ND ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "OH",
    "dropphyzpp": 450059998,
    "dropmaladd": "712 E 2ND ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "OH",
    "dropmalzpp": 450059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377460303,
    "dropsitcph": 9377460303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21063",
    "droptype": "D",
    "dropname": "FRANKLIN FURNACE",
    "dropdeladd": "4202 GALLIA PIKE",
    "dropdelcty": "FRANKLIN FURNACE",
    "dropdelst": "OH",
    "dropdelzpp": 456298610,
    "dropphyadd": "4202 GALLIA PIKE",
    "dropphycty": "FRANKLIN FURNACE",
    "dropphyst": "OH",
    "dropphyzpp": 456298610,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLIN FURNACE",
    "dropmalst": "OH",
    "dropmalzpp": 456299998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403549115,
    "dropsitcph": 7403549115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21066",
    "droptype": "D",
    "dropname": "FRAZEYSBURG",
    "dropdeladd": "24 N STATE ST",
    "dropdelcty": "FRAZEYSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 438229014,
    "dropphyadd": "24 N STATE ST",
    "dropphycty": "FRAZEYSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 438229014,
    "dropmaladd": "24 N STATE ST",
    "dropmalcty": "FRAZEYSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 438229014,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408282259,
    "dropsitcph": 7408282259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21070",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "147 WATER ST",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 446279801,
    "dropphyadd": "147 WATER ST",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 446279801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 446279998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306952722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21072",
    "droptype": "D",
    "dropname": "FREDERICKTOWN",
    "dropdeladd": "67 N PLEASANT ST",
    "dropdelcty": "FREDERICKTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 430191187,
    "dropphyadd": "67 N PLEASANT ST",
    "dropphycty": "FREDERICKTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 430191187,
    "dropmaladd": "67 N PLEASANT ST",
    "dropmalcty": "FREDERICKTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 430191187,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406946901,
    "dropsitcph": 7406946901,
    "dropfax": 7406944450
  },
  {
    "dcode": "D",
    "dropkey": "PX21077",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "101 S PHILADELPHIA ST",
    "dropdelcty": "FREEPORT",
    "dropdelst": "OH",
    "dropdelzpp": 439738941,
    "dropphyadd": "101 S PHILADELPHIA ST",
    "dropphycty": "FREEPORT",
    "dropphyst": "OH",
    "dropphyzpp": 439738941,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEPORT",
    "dropmalst": "OH",
    "dropmalzpp": 439739998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406583616,
    "dropsitcph": 7406583616,
    "dropfax": 7406584103
  },
  {
    "dcode": "D",
    "dropkey": "PX21078",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "2120 ENTERPRISE ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "OH",
    "dropdelzpp": 434209998,
    "dropphyadd": "2120 ENTERPRISE ST",
    "dropphycty": "FREMONT",
    "dropphyst": "OH",
    "dropphyzpp": 434209998,
    "dropmaladd": "2120 ENTERPRISE ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "OH",
    "dropmalzpp": 434209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193327396,
    "dropsitcph": 4193327396,
    "dropfax": 4193322402
  },
  {
    "dcode": "D",
    "dropkey": "PX21079",
    "droptype": "D",
    "dropname": "FRESNO",
    "dropdeladd": "54259 TOWNSHIP ROAD 172",
    "dropdelcty": "FRESNO",
    "dropdelst": "OH",
    "dropdelzpp": 438249064,
    "dropphyadd": "54259 TOWNSHIP ROAD 172",
    "dropphycty": "FRESNO",
    "dropphyst": "OH",
    "dropphyzpp": 438249064,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRESNO",
    "dropmalst": "OH",
    "dropmalzpp": 438249998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405459262,
    "dropsitcph": 7405459262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21080",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "13066 US HIGHWAY 52",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "OH",
    "dropdelzpp": 456309998,
    "dropphyadd": "13066 US HIGHWAY 52",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "OH",
    "dropphyzpp": 456309998,
    "dropmaladd": "13066 US HIGHWAY 52",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "OH",
    "dropmalzpp": 456309998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408584393,
    "dropsitcph": 7408584393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21089",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "114 E MAIN ST",
    "dropdelcty": "FULTON",
    "dropdelst": "OH",
    "dropdelzpp": 433219717,
    "dropphyadd": "114 E MAIN ST",
    "dropphycty": "FULTON",
    "dropphyst": "OH",
    "dropphyzpp": 433219717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULTON",
    "dropmalst": "OH",
    "dropmalzpp": 433219998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4198648739,
    "dropsitcph": 4198648739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21095",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "34 W PARK ST",
    "dropdelcty": "GALENA",
    "dropdelst": "OH",
    "dropdelzpp": 430219072,
    "dropphyadd": "34 W PARK ST",
    "dropphycty": "GALENA",
    "dropphyst": "OH",
    "dropphyzpp": 430219072,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALENA",
    "dropmalst": "OH",
    "dropmalzpp": 430219998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409652371,
    "dropsitcph": 7409652371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21096",
    "droptype": "D",
    "dropname": "GALION",
    "dropdeladd": "133 N COLUMBUS ST",
    "dropdelcty": "GALION",
    "dropdelst": "OH",
    "dropdelzpp": 448339998,
    "dropphyadd": "133 N COLUMBUS ST",
    "dropphycty": "GALION",
    "dropphyst": "OH",
    "dropphyzpp": 448339998,
    "dropmaladd": "133 N COLUMBUS ST",
    "dropmalcty": "GALION",
    "dropmalst": "OH",
    "dropmalzpp": 448339998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194681662,
    "dropfax": 4197772149
  },
  {
    "dcode": "D",
    "dropkey": "PX21098",
    "droptype": "D",
    "dropname": "GALLIPOLIS",
    "dropdeladd": "440 2ND AVE",
    "dropdelcty": "GALLIPOLIS",
    "dropdelst": "OH",
    "dropdelzpp": 456311191,
    "dropphyadd": "440 2ND AVE",
    "dropphycty": "GALLIPOLIS",
    "dropphyst": "OH",
    "dropphyzpp": 456311191,
    "dropmaladd": "440 2ND AVE",
    "dropmalcty": "GALLIPOLIS",
    "dropmalst": "OH",
    "dropmalzpp": 456319998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404460384,
    "dropsitcph": 7404460384,
    "dropfax": 7404460395
  },
  {
    "dcode": "D",
    "dropkey": "PX21099",
    "droptype": "D",
    "dropname": "GALLOWAY",
    "dropdeladd": "5820 SULLIVANT AVE",
    "dropdelcty": "GALLOWAY",
    "dropdelst": "OH",
    "dropdelzpp": 431199903,
    "dropphyadd": "5820 SULLIVANT AVE",
    "dropphycty": "GALLOWAY",
    "dropphyst": "OH",
    "dropphyzpp": 431199903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALLOWAY",
    "dropmalst": "OH",
    "dropmalzpp": 431199998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148782313,
    "dropsitcph": 6148782313,
    "dropfax": 6148785013
  },
  {
    "dcode": "D",
    "dropkey": "PX21100",
    "droptype": "D",
    "dropname": "GAMBIER",
    "dropdeladd": "107 CHASE AVE",
    "dropdelcty": "GAMBIER",
    "dropdelst": "OH",
    "dropdelzpp": 430229001,
    "dropphyadd": "107 CHASE AVE",
    "dropphycty": "GAMBIER",
    "dropphyst": "OH",
    "dropphyzpp": 430229001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAMBIER",
    "dropmalst": "OH",
    "dropmalzpp": 430229998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404272301,
    "dropsitcph": 7404272301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21107",
    "droptype": "D",
    "dropname": "GARRETTSVILLE",
    "dropdeladd": "10809 NORTH ST",
    "dropdelcty": "GARRETTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 442319998,
    "dropphyadd": "10809 NORTH ST",
    "dropphycty": "GARRETTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 442319998,
    "dropmaladd": "10809 NORTH ST",
    "dropmalcty": "GARRETTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 442319998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305272888,
    "dropfax": 3305275821
  },
  {
    "dcode": "D",
    "dropkey": "PX21108",
    "droptype": "D",
    "dropname": "GATES MILLS",
    "dropdeladd": "1500 CHAGRIN RIVER RD",
    "dropdelcty": "GATES MILLS",
    "dropdelst": "OH",
    "dropdelzpp": 440409378,
    "dropphyadd": "1500 CHAGRIN RIVER RD",
    "dropphycty": "GATES MILLS",
    "dropphyst": "OH",
    "dropphyzpp": 440409378,
    "dropmaladd": "1500 CHAGRIN RIVER RD",
    "dropmalcty": "GATES MILLS",
    "dropmalst": "OH",
    "dropmalzpp": 440409378,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404230428,
    "dropfax": 4404230419
  },
  {
    "dcode": "D",
    "dropkey": "PX21115",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "1041 S BROADWAY",
    "dropdelcty": "GENEVA",
    "dropdelst": "OH",
    "dropdelzpp": 440419998,
    "dropphyadd": "1041 S BROADWAY",
    "dropphycty": "GENEVA",
    "dropphyst": "OH",
    "dropphyzpp": 440419998,
    "dropmaladd": "1041 S BROADWAY",
    "dropmalcty": "GENEVA",
    "dropmalst": "OH",
    "dropmalzpp": 440419998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404661041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21117",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "606 WASHINGTON ST",
    "dropdelcty": "GENOA",
    "dropdelst": "OH",
    "dropdelzpp": 434301685,
    "dropphyadd": "606 WASHINGTON ST",
    "dropphycty": "GENOA",
    "dropphyst": "OH",
    "dropphyzpp": 434301685,
    "dropmaladd": "606 WASHINGTON ST",
    "dropmalcty": "GENOA",
    "dropmalst": "OH",
    "dropmalzpp": 434301685,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198553656,
    "dropsitcph": 4198553656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21120",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "201 E GRANT AVE",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "OH",
    "dropdelzpp": 451219998,
    "dropphyadd": "201 E GRANT AVE",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "OH",
    "dropphyzpp": 451219998,
    "dropmaladd": "201 E GRANT AVE",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "OH",
    "dropmalzpp": 451219998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373781055,
    "dropsitcph": 9373781055,
    "dropfax": 9373783296
  },
  {
    "dcode": "D",
    "dropkey": "PX21125",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "205 E MARKET ST",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 453279998,
    "dropphyadd": "205 E MARKET ST",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 453279998,
    "dropmaladd": "205 E MARKET ST",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 453279998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378552888,
    "dropsitcph": 9378552888,
    "dropfax": 9378552583
  },
  {
    "dcode": "D",
    "dropkey": "PX21130",
    "droptype": "D",
    "dropname": "GETTYSBURG",
    "dropdeladd": "105A CLAY ST",
    "dropdelcty": "GETTYSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453289998,
    "dropphyadd": "105A CLAY ST",
    "dropphycty": "GETTYSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453289998,
    "dropmaladd": "105A CLAY ST",
    "dropmalcty": "GETTYSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453289998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374474181,
    "dropsitcph": 9374474181,
    "dropfax": 9374478703
  },
  {
    "dcode": "D",
    "dropkey": "PX21133",
    "droptype": "D",
    "dropname": "GIBSONBURG",
    "dropdeladd": "112 N WEBSTER ST",
    "dropdelcty": "GIBSONBURG",
    "dropdelst": "OH",
    "dropdelzpp": 434311005,
    "dropphyadd": "112 N WEBSTER ST",
    "dropphycty": "GIBSONBURG",
    "dropphyst": "OH",
    "dropphyzpp": 434311005,
    "dropmaladd": "112 N WEBSTER ST",
    "dropmalcty": "GIBSONBURG",
    "dropmalst": "OH",
    "dropmalzpp": 434311005,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196372326,
    "dropsitcph": 4196372326,
    "dropfax": 4196372647
  },
  {
    "dcode": "D",
    "dropkey": "PX21136",
    "droptype": "D",
    "dropname": "GIRARD",
    "dropdeladd": "19 N MARKET ST",
    "dropdelcty": "GIRARD",
    "dropdelst": "OH",
    "dropdelzpp": 444209998,
    "dropphyadd": "19 N MARKET ST",
    "dropphycty": "GIRARD",
    "dropphyst": "OH",
    "dropphyzpp": 444209998,
    "dropmaladd": "19 N MARKET ST",
    "dropmalcty": "GIRARD",
    "dropmalst": "OH",
    "dropmalzpp": 444209998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305450253,
    "dropsitcph": 3305450253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21138",
    "droptype": "D",
    "dropname": "GLANDORF",
    "dropdeladd": "130 S MAIN ST",
    "dropdelcty": "GLANDORF",
    "dropdelst": "OH",
    "dropdelzpp": 458489998,
    "dropphyadd": "130 S MAIN ST",
    "dropphycty": "GLANDORF",
    "dropphyst": "OH",
    "dropphyzpp": 458489998,
    "dropmaladd": "130 S MAIN ST",
    "dropmalcty": "GLANDORF",
    "dropmalst": "OH",
    "dropmalzpp": 458489998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195386851,
    "dropsitcph": 4195386851,
    "dropfax": 4195387032
  },
  {
    "dcode": "D",
    "dropkey": "PX21146",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "50073 1ST ST",
    "dropdelcty": "GLENCOE",
    "dropdelst": "OH",
    "dropdelzpp": 439289800,
    "dropphyadd": "50073 1ST ST",
    "dropphycty": "GLENCOE",
    "dropphyst": "OH",
    "dropphyzpp": 439289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENCOE",
    "dropmalst": "OH",
    "dropmalzpp": 439289998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406762949,
    "dropsitcph": 7406762949,
    "dropfax": 7406762949
  },
  {
    "dcode": "D",
    "dropkey": "PX21148",
    "droptype": "D",
    "dropname": "GLENFORD",
    "dropdeladd": "4627 STATE ROUTE 204",
    "dropdelcty": "GLENFORD",
    "dropdelst": "OH",
    "dropdelzpp": 437399900,
    "dropphyadd": "4627 STATE ROUTE 204",
    "dropphycty": "GLENFORD",
    "dropphyst": "OH",
    "dropphyzpp": 437399900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENFORD",
    "dropmalst": "OH",
    "dropmalzpp": 437399998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406596024,
    "dropsitcph": 7406596024,
    "dropfax": 7406596023
  },
  {
    "dcode": "D",
    "dropkey": "PX21149",
    "droptype": "D",
    "dropname": "GLENMONT",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "GLENMONT",
    "dropdelst": "OH",
    "dropdelzpp": 446289800,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "GLENMONT",
    "dropphyst": "OH",
    "dropphyzpp": 446289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENMONT",
    "dropmalst": "OH",
    "dropmalzpp": 446289998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303774322,
    "dropfax": 3303774322
  },
  {
    "dcode": "D",
    "dropkey": "PX21153",
    "droptype": "D",
    "dropname": "GLOUSTER",
    "dropdeladd": "76 HIGH ST",
    "dropdelcty": "GLOUSTER",
    "dropdelst": "OH",
    "dropdelzpp": 457321028,
    "dropphyadd": "76 HIGH ST",
    "dropphycty": "GLOUSTER",
    "dropphyst": "OH",
    "dropphyzpp": 457321028,
    "dropmaladd": "76 HIGH ST",
    "dropmalcty": "GLOUSTER",
    "dropmalst": "OH",
    "dropmalzpp": 457321028,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407672540,
    "dropsitcph": 7407672540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21154",
    "droptype": "D",
    "dropname": "GNADENHUTTEN",
    "dropdeladd": "139 N WALNUT ST",
    "dropdelcty": "GNADENHUTTEN",
    "dropdelst": "OH",
    "dropdelzpp": 446299800,
    "dropphyadd": "139 N WALNUT ST",
    "dropphycty": "GNADENHUTTEN",
    "dropphyst": "OH",
    "dropphyzpp": 446299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GNADENHUTTEN",
    "dropmalst": "OH",
    "dropmalzpp": 446299998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7402544336,
    "dropfax": 7402544336
  },
  {
    "dcode": "D",
    "dropkey": "PX21164",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "1978 MAIN ST",
    "dropdelcty": "GOSHEN",
    "dropdelst": "OH",
    "dropdelzpp": 451229998,
    "dropphyadd": "1978 MAIN ST",
    "dropphycty": "GOSHEN",
    "dropphyst": "OH",
    "dropphyzpp": 451229998,
    "dropmaladd": "1978 MAIN ST",
    "dropmalcty": "GOSHEN",
    "dropmalst": "OH",
    "dropmalzpp": 451229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137223821,
    "dropsitcph": 5137223821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21168",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "926 N MAIN ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "OH",
    "dropdelzpp": 440441470,
    "dropphyadd": "926 N MAIN ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "OH",
    "dropphyzpp": 440441470,
    "dropmaladd": "926 N MAIN ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "OH",
    "dropmalzpp": 440441470,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409269065,
    "dropfax": 4409265007
  },
  {
    "dcode": "D",
    "dropkey": "PX21170",
    "droptype": "D",
    "dropname": "GRAND RAPIDS",
    "dropdeladd": "17565 WAPAKONETA RD",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "OH",
    "dropdelzpp": 435229998,
    "dropphyadd": "17565 WAPAKONETA RD",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "OH",
    "dropphyzpp": 435229998,
    "dropmaladd": "17565 WAPAKONETA RD",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "OH",
    "dropmalzpp": 435229998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198325002,
    "dropsitcph": 4198325002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21171",
    "droptype": "D",
    "dropname": "GRAND RIVER",
    "dropdeladd": "340 WETMORE AVE",
    "dropdelcty": "GRAND RIVER",
    "dropdelst": "OH",
    "dropdelzpp": 440459800,
    "dropphyadd": "340 WETMORE AVE",
    "dropphycty": "GRAND RIVER",
    "dropphyst": "OH",
    "dropphyzpp": 440459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RIVER",
    "dropmalst": "OH",
    "dropmalzpp": 440459998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403524389,
    "dropfax": 4403456015
  },
  {
    "dcode": "D",
    "dropkey": "PX21176",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "203 BROADWAY E",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430231544,
    "dropphyadd": "203 BROADWAY E",
    "dropphycty": "GRANVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430231544,
    "dropmaladd": "203 BROADWAY E",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430231544,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405870280,
    "dropsitcph": 7405870280,
    "dropfax": 7405871228
  },
  {
    "dcode": "D",
    "dropkey": "PX21177",
    "droptype": "D",
    "dropname": "GRATIOT",
    "dropdeladd": "349 MAIN ST",
    "dropdelcty": "GRATIOT",
    "dropdelst": "OH",
    "dropdelzpp": 437409900,
    "dropphyadd": "349 MAIN ST",
    "dropphycty": "GRATIOT",
    "dropphyst": "OH",
    "dropphyzpp": 437409900,
    "dropmaladd": "349 MAIN ST",
    "dropmalcty": "GRATIOT",
    "dropmalst": "OH",
    "dropmalzpp": 437409997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407872241,
    "dropsitcph": 7407872241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21178",
    "droptype": "D",
    "dropname": "GRATIS",
    "dropdeladd": "100 E FRANKLIN ST",
    "dropdelcty": "GRATIS",
    "dropdelst": "OH",
    "dropdelzpp": 453309998,
    "dropphyadd": "100 E FRANKLIN ST",
    "dropphycty": "GRATIS",
    "dropphyst": "OH",
    "dropphyzpp": 453309998,
    "dropmaladd": "100 E FRANKLIN ST",
    "dropmalcty": "GRATIS",
    "dropmalst": "OH",
    "dropmalzpp": 453309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377874309,
    "dropsitcph": 9377874309,
    "dropfax": 9377871389
  },
  {
    "dcode": "D",
    "dropkey": "PX21180",
    "droptype": "D",
    "dropname": "GRAYTOWN",
    "dropdeladd": "1778 N WALKER ST",
    "dropdelcty": "GRAYTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 434329998,
    "dropphyadd": "1778 N WALKER ST",
    "dropphycty": "GRAYTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 434329998,
    "dropmaladd": "1778 N WALKER ST",
    "dropmalcty": "GRAYTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 434329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198622217,
    "dropsitcph": 4198622217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21186",
    "droptype": "D",
    "dropname": "GREEN CAMP",
    "dropdeladd": "216 MARION ST",
    "dropdelcty": "GREEN CAMP",
    "dropdelst": "OH",
    "dropdelzpp": 433229700,
    "dropphyadd": "216 MARION ST",
    "dropphycty": "GREEN CAMP",
    "dropphyst": "OH",
    "dropphyzpp": 433229700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN CAMP",
    "dropmalst": "OH",
    "dropmalzpp": 433229998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405282122,
    "dropsitcph": 7405282122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21187",
    "droptype": "D",
    "dropname": "GREEN SPRINGS",
    "dropdeladd": "108 S BROADWAY ST",
    "dropdelcty": "GREEN SPRINGS",
    "dropdelst": "OH",
    "dropdelzpp": 448369998,
    "dropphyadd": "108 S BROADWAY ST",
    "dropphycty": "GREEN SPRINGS",
    "dropphyst": "OH",
    "dropphyzpp": 448369998,
    "dropmaladd": "108 S BROADWAY ST",
    "dropmalcty": "GREEN SPRINGS",
    "dropmalst": "OH",
    "dropmalzpp": 448369998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196392432,
    "dropfax": 4196392433
  },
  {
    "dcode": "D",
    "dropkey": "PX21193",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "233 JEFFERSON ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 451239998,
    "dropphyadd": "233 JEFFERSON ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 451239998,
    "dropmaladd": "233 JEFFERSON ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 451239998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 9379810955,
    "dropfax": 9379811844
  },
  {
    "dcode": "D",
    "dropkey": "PX21196",
    "droptype": "D",
    "dropname": "GREENFORD",
    "dropdeladd": "12184 LISBON RD",
    "dropdelcty": "GREENFORD",
    "dropdelst": "OH",
    "dropdelzpp": 444229800,
    "dropphyadd": "12184 LISBON RD",
    "dropphycty": "GREENFORD",
    "dropphyst": "OH",
    "dropphyzpp": 444229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENFORD",
    "dropmalst": "OH",
    "dropmalzpp": 444229998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305337134,
    "dropsitcph": 3305337134,
    "dropfax": 3305339464
  },
  {
    "dcode": "D",
    "dropkey": "PX21199",
    "droptype": "D",
    "dropname": "GREEN",
    "dropdeladd": "4735 MASSILLON RD",
    "dropdelcty": "GREEN",
    "dropdelst": "OH",
    "dropdelzpp": 442329800,
    "dropphyadd": "4735 MASSILLON RD",
    "dropphycty": "GREEN",
    "dropphyst": "OH",
    "dropphyzpp": 442329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN",
    "dropmalst": "OH",
    "dropmalzpp": 442329998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308964484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21200",
    "droptype": "D",
    "dropname": "GREENTOWN",
    "dropdeladd": "9635 CLEVELAND AVE NW",
    "dropdelcty": "GREENTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 446309800,
    "dropphyadd": "9635 CLEVELAND AVE NW",
    "dropphycty": "GREENTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 446309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 446309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304386446,
    "dropsitcph": 3304946101,
    "dropfax": 3303051754
  },
  {
    "dcode": "D",
    "dropkey": "PX21201",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453319998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453319998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375481310,
    "dropsitcph": 9375481310,
    "dropfax": 9375471678
  },
  {
    "dcode": "D",
    "dropkey": "PX21204",
    "droptype": "D",
    "dropname": "GREENWICH",
    "dropdeladd": "18 MAIN ST",
    "dropdelcty": "GREENWICH",
    "dropdelst": "OH",
    "dropdelzpp": 448379998,
    "dropphyadd": "18 MAIN ST",
    "dropphycty": "GREENWICH",
    "dropphyst": "OH",
    "dropphyzpp": 448379998,
    "dropmaladd": "18 MAIN ST",
    "dropmalcty": "GREENWICH",
    "dropmalst": "OH",
    "dropmalzpp": 448379998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197524233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21215",
    "droptype": "D",
    "dropname": "GROVE CITY",
    "dropdeladd": "2539 DARTMOOR RD",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "OH",
    "dropdelzpp": 431239998,
    "dropphyadd": "2539 DARTMOOR RD",
    "dropphycty": "GROVE CITY",
    "dropphyst": "OH",
    "dropphyzpp": 431239998,
    "dropmaladd": "2539 DARTMOOR RD",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "OH",
    "dropmalzpp": 431239998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148756327,
    "dropsitcph": 6148756327,
    "dropfax": 6148751373
  },
  {
    "dcode": "D",
    "dropkey": "PX21216",
    "droptype": "D",
    "dropname": "GROVEPORT",
    "dropdeladd": "189 MAIN ST",
    "dropdelcty": "GROVEPORT",
    "dropdelst": "OH",
    "dropdelzpp": 431259998,
    "dropphyadd": "189 MAIN ST",
    "dropphycty": "GROVEPORT",
    "dropphyst": "OH",
    "dropphyzpp": 431259998,
    "dropmaladd": "189 MAIN ST",
    "dropmalcty": "GROVEPORT",
    "dropmalst": "OH",
    "dropmalzpp": 431259998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148365452,
    "dropsitcph": 6148365452,
    "dropfax": 6148362513
  },
  {
    "dcode": "D",
    "dropkey": "PX21217",
    "droptype": "D",
    "dropname": "GROVER HILL",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "GROVER HILL",
    "dropdelst": "OH",
    "dropdelzpp": 458499998,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "GROVER HILL",
    "dropphyst": "OH",
    "dropphyzpp": 458499998,
    "dropmaladd": "100 S MAIN ST",
    "dropmalcty": "GROVER HILL",
    "dropmalst": "OH",
    "dropmalzpp": 458499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195873331,
    "dropsitcph": 4195873331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21225",
    "droptype": "D",
    "dropname": "GUYSVILLE",
    "dropdeladd": "6930 SAVANNAH ST",
    "dropdelcty": "GUYSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457359800,
    "dropphyadd": "6930 SAVANNAH ST",
    "dropphycty": "GUYSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUYSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457359998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406622965,
    "dropsitcph": 7406622965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21226",
    "droptype": "D",
    "dropname": "GYPSUM",
    "dropdeladd": "2 MACKEY LN",
    "dropdelcty": "GYPSUM",
    "dropdelst": "OH",
    "dropdelzpp": 434339998,
    "dropphyadd": "2 MACKEY LN",
    "dropphycty": "GYPSUM",
    "dropphyst": "OH",
    "dropphyzpp": 434339998,
    "dropmaladd": "2 MACKEY LN",
    "dropmalcty": "GYPSUM",
    "dropmalst": "OH",
    "dropmalzpp": 434339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197322336,
    "dropsitcph": 4197322336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21230",
    "droptype": "D",
    "dropname": "HAMDEN",
    "dropdeladd": "30 N MAIN ST",
    "dropdelcty": "HAMDEN",
    "dropdelst": "OH",
    "dropdelzpp": 456348749,
    "dropphyadd": "30 N MAIN ST",
    "dropphycty": "HAMDEN",
    "dropphyst": "OH",
    "dropphyzpp": 456348749,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMDEN",
    "dropmalst": "OH",
    "dropmalzpp": 456349998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403843495,
    "dropsitcph": 7403843495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21231",
    "droptype": "D",
    "dropname": "HAMERSVILLE",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "HAMERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451309998,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "HAMERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451309998,
    "dropmaladd": "202 W MAIN ST",
    "dropmalcty": "HAMERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373791411,
    "dropsitcph": 9373791411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21234",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "105 COURT ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "OH",
    "dropdelzpp": 450119998,
    "dropphyadd": "105 COURT ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "OH",
    "dropphyzpp": 450119998,
    "dropmaladd": "105 COURT ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "OH",
    "dropmalzpp": 450119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5138670517,
    "dropfax": 5138678879
  },
  {
    "dcode": "D",
    "dropkey": "PX21236",
    "droptype": "D",
    "dropname": "HAMLER",
    "dropdeladd": "335 RANDOLPH ST",
    "dropdelcty": "HAMLER",
    "dropdelst": "OH",
    "dropdelzpp": 435249998,
    "dropphyadd": "335 RANDOLPH ST",
    "dropphycty": "HAMLER",
    "dropphyst": "OH",
    "dropphyzpp": 435249998,
    "dropmaladd": "335 RANDOLPH ST",
    "dropmalcty": "HAMLER",
    "dropmalst": "OH",
    "dropmalzpp": 435249998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192742211,
    "dropsitcph": 4192742211,
    "dropfax": 4192744321
  },
  {
    "dcode": "D",
    "dropkey": "PX21238",
    "droptype": "D",
    "dropname": "HAMMONDSVILLE",
    "dropdeladd": "15481 STATE ROUTE 213",
    "dropdelcty": "HAMMONDSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439309800,
    "dropphyadd": "15481 STATE ROUTE 213",
    "dropphycty": "HAMMONDSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMMONDSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305324035,
    "dropsitcph": 3305324035,
    "dropfax": 3305324035
  },
  {
    "dcode": "D",
    "dropkey": "PX21241",
    "droptype": "D",
    "dropname": "HANNIBAL",
    "dropdeladd": "52758 BOSTON HILL RD",
    "dropdelcty": "HANNIBAL",
    "dropdelst": "OH",
    "dropdelzpp": 439319800,
    "dropphyadd": "52758 BOSTON HILL RD",
    "dropphycty": "HANNIBAL",
    "dropphyst": "OH",
    "dropphyzpp": 439319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANNIBAL",
    "dropmalst": "OH",
    "dropmalzpp": 439319998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7404832287,
    "dropsitcph": 7404832287,
    "dropfax": 7404831477
  },
  {
    "dcode": "D",
    "dropkey": "PX21243",
    "droptype": "D",
    "dropname": "HANOVERTON",
    "dropdeladd": "29959 MARKET ST",
    "dropdelcty": "HANOVERTON",
    "dropdelst": "OH",
    "dropdelzpp": 444239800,
    "dropphyadd": "29959 MARKET ST",
    "dropphycty": "HANOVERTON",
    "dropphyst": "OH",
    "dropphyzpp": 444239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANOVERTON",
    "dropmalst": "OH",
    "dropmalzpp": 444239998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3302231011,
    "dropsitcph": 3302231011,
    "dropfax": 3302231011
  },
  {
    "dcode": "D",
    "dropkey": "PX21248",
    "droptype": "D",
    "dropname": "HARBOR VIEW",
    "dropdeladd": "327 LAKEVIEW DR",
    "dropdelcty": "HARBOR VIEW",
    "dropdelst": "OH",
    "dropdelzpp": 434349998,
    "dropphyadd": "327 LAKEVIEW DR",
    "dropphycty": "HARBOR VIEW",
    "dropphyst": "OH",
    "dropphyzpp": 434349998,
    "dropmaladd": "327 LAKEVIEW DR",
    "dropmalcty": "HARBOR VIEW",
    "dropmalst": "OH",
    "dropmalzpp": 434349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196988199,
    "dropsitcph": 4196988199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21254",
    "droptype": "D",
    "dropname": "HARPSTER",
    "dropdeladd": "7272 WYANDOT ST",
    "dropdelcty": "HARPSTER",
    "dropdelst": "OH",
    "dropdelzpp": 433239704,
    "dropphyadd": "7272 WYANDOT ST",
    "dropphycty": "HARPSTER",
    "dropphyst": "OH",
    "dropphyzpp": 433239704,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARPSTER",
    "dropmalst": "OH",
    "dropmalzpp": 433239998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404963700,
    "dropsitcph": 7404963700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21259",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "1019 COLUMBUS ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "OH",
    "dropdelzpp": 431269900,
    "dropphyadd": "1019 COLUMBUS ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "OH",
    "dropphyzpp": 431269900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "OH",
    "dropmalzpp": 431269998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148774857,
    "dropsitcph": 6148774857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21263",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "420 S STATE ST",
    "dropdelcty": "HARRISON",
    "dropdelst": "OH",
    "dropdelzpp": 450309998,
    "dropphyadd": "420 S STATE ST",
    "dropphycty": "HARRISON",
    "dropphyst": "OH",
    "dropphyzpp": 450309998,
    "dropmaladd": "420 S STATE ST",
    "dropmalcty": "HARRISON",
    "dropmalst": "OH",
    "dropmalzpp": 450309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5133671734,
    "dropfax": 5133679608
  },
  {
    "dcode": "D",
    "dropkey": "PX21267",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "49364 MAIN ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439749800,
    "dropphyadd": "49364 MAIN ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439749998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405463124,
    "dropsitcph": 7405463124,
    "dropfax": 7405463124
  },
  {
    "dcode": "D",
    "dropkey": "PX21268",
    "droptype": "D",
    "dropname": "HARROD",
    "dropdeladd": "129 W 3RD ST",
    "dropdelcty": "HARROD",
    "dropdelst": "OH",
    "dropdelzpp": 458509998,
    "dropphyadd": "129 W 3RD ST",
    "dropphycty": "HARROD",
    "dropphyst": "OH",
    "dropphyzpp": 458509998,
    "dropmaladd": "129 W 3RD ST",
    "dropmalcty": "HARROD",
    "dropmalst": "OH",
    "dropmalzpp": 458509998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196485405,
    "dropsitcph": 4196485405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21270",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "6893 STATE ROUTE 305",
    "dropdelcty": "HARTFORD",
    "dropdelst": "OH",
    "dropdelzpp": 444249800,
    "dropphyadd": "6893 STATE ROUTE 305",
    "dropphycty": "HARTFORD",
    "dropphyst": "OH",
    "dropphyzpp": 444249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTFORD",
    "dropmalst": "OH",
    "dropmalzpp": 444249998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307726255,
    "dropsitcph": 3307726255,
    "dropfax": 3307726255
  },
  {
    "dcode": "D",
    "dropkey": "PX21275",
    "droptype": "D",
    "dropname": "HARTVILLE",
    "dropdeladd": "861 W MAPLE ST",
    "dropdelcty": "HARTVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446329998,
    "dropphyadd": "861 W MAPLE ST",
    "dropphycty": "HARTVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446329998,
    "dropmaladd": "861 W MAPLE ST",
    "dropmalcty": "HARTVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446329998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308779296,
    "dropfax": 3308771865
  },
  {
    "dcode": "D",
    "dropkey": "PX21276",
    "droptype": "D",
    "dropname": "HARVEYSBURG",
    "dropdeladd": "46 W MAIN ST",
    "dropdelcty": "HARVEYSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 450329998,
    "dropphyadd": "46 W MAIN ST",
    "dropphycty": "HARVEYSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 450329998,
    "dropmaladd": "46 W MAIN ST",
    "dropmalcty": "HARVEYSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 450329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138991924,
    "dropsitcph": 5138991924,
    "dropfax": 5138972536
  },
  {
    "dcode": "D",
    "dropkey": "PX21277",
    "droptype": "D",
    "dropname": "HASKINS",
    "dropdeladd": "100 N FINDLAY RD",
    "dropdelcty": "HASKINS",
    "dropdelst": "OH",
    "dropdelzpp": 435259998,
    "dropphyadd": "100 N FINDLAY RD",
    "dropphycty": "HASKINS",
    "dropphyst": "OH",
    "dropphyzpp": 435259998,
    "dropmaladd": "100 N FINDLAY RD",
    "dropmalcty": "HASKINS",
    "dropmalst": "OH",
    "dropmalzpp": 435259998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198231412,
    "dropsitcph": 4198231412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21281",
    "droptype": "D",
    "dropname": "HAVERHILL",
    "dropdeladd": "1540 GALLIA PIKE",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "OH",
    "dropdelzpp": 456369800,
    "dropphyadd": "1540 GALLIA PIKE",
    "dropphycty": "HAVERHILL",
    "dropphyst": "OH",
    "dropphyzpp": 456369800,
    "dropmaladd": "1540 GALLIA PIKE",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "OH",
    "dropmalzpp": 456369800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405327067,
    "dropsitcph": 7405327067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21282",
    "droptype": "D",
    "dropname": "HAVILAND",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "HAVILAND",
    "dropdelst": "OH",
    "dropdelzpp": 458519998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "HAVILAND",
    "dropphyst": "OH",
    "dropphyzpp": 458519998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "HAVILAND",
    "dropmalst": "OH",
    "dropmalzpp": 458519998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196225394,
    "dropsitcph": 4196225394,
    "dropfax": 4196220014
  },
  {
    "dcode": "D",
    "dropkey": "PX21283",
    "droptype": "D",
    "dropname": "HAYDENVILLE",
    "dropdeladd": "16966 HAYDENVILLE RD",
    "dropdelcty": "HAYDENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431279900,
    "dropphyadd": "16966 HAYDENVILLE RD",
    "dropphycty": "HAYDENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431279900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYDENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431279998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403854160,
    "dropsitcph": 7403854160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21284",
    "droptype": "D",
    "dropname": "HAYESVILLE",
    "dropdeladd": "1 E MAIN ST",
    "dropdelcty": "HAYESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448389800,
    "dropphyadd": "1 E MAIN ST",
    "dropphycty": "HAYESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448389998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4193687822,
    "dropfax": 4193684813
  },
  {
    "dcode": "D",
    "dropkey": "PX21293",
    "droptype": "D",
    "dropname": "HEBRON",
    "dropdeladd": "146 N HIGH ST",
    "dropdelcty": "HEBRON",
    "dropdelst": "OH",
    "dropdelzpp": 430259028,
    "dropphyadd": "146 N HIGH ST",
    "dropphycty": "HEBRON",
    "dropphyst": "OH",
    "dropphyzpp": 430259028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEBRON",
    "dropmalst": "OH",
    "dropmalzpp": 430259998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409282391,
    "dropsitcph": 7409282391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21296",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "247 MAIN ST",
    "dropdelcty": "HELENA",
    "dropdelst": "OH",
    "dropdelzpp": 434359998,
    "dropphyadd": "247 MAIN ST",
    "dropphycty": "HELENA",
    "dropphyst": "OH",
    "dropphyzpp": 434359998,
    "dropmaladd": "247 MAIN ST",
    "dropmalcty": "HELENA",
    "dropmalst": "OH",
    "dropmalzpp": 434359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196383651,
    "dropsitcph": 4196383651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21307",
    "droptype": "D",
    "dropname": "HICKSVILLE",
    "dropdeladd": "110 E EDGERTON ST",
    "dropdelcty": "HICKSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 435261484,
    "dropphyadd": "110 E EDGERTON ST",
    "dropphycty": "HICKSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 435261484,
    "dropmaladd": "110 E EDGERTON ST",
    "dropmalcty": "HICKSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 435261484,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195428430,
    "dropsitcph": 4195428430,
    "dropfax": 4195426702
  },
  {
    "dcode": "D",
    "dropkey": "PX21312",
    "droptype": "D",
    "dropname": "HIGGINSPORT",
    "dropdeladd": "400 WASHINGTON ST",
    "dropdelcty": "HIGGINSPORT",
    "dropdelst": "OH",
    "dropdelzpp": 451319998,
    "dropphyadd": "400 WASHINGTON ST",
    "dropphycty": "HIGGINSPORT",
    "dropphyst": "OH",
    "dropphyzpp": 451319998,
    "dropmaladd": "400 WASHINGTON ST",
    "dropmalcty": "HIGGINSPORT",
    "dropmalst": "OH",
    "dropmalzpp": 451319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373754495,
    "dropsitcph": 9373754495,
    "dropfax": 9373754495
  },
  {
    "dcode": "D",
    "dropkey": "PX21315",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "7914 W MAIN ST",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "OH",
    "dropdelzpp": 451329998,
    "dropphyadd": "7914 W MAIN ST",
    "dropphycty": "HIGHLAND",
    "dropphyst": "OH",
    "dropphyzpp": 451329998,
    "dropmaladd": "7914 W MAIN ST",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "OH",
    "dropmalzpp": 451329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377809005,
    "dropsitcph": 9377809005,
    "dropfax": 9377809005
  },
  {
    "dcode": "D",
    "dropkey": "PX21324",
    "droptype": "D",
    "dropname": "HILLIARD",
    "dropdeladd": "4000 LEAP RD",
    "dropdelcty": "HILLIARD",
    "dropdelst": "OH",
    "dropdelzpp": 430261278,
    "dropphyadd": "4000 LEAP RD",
    "dropphycty": "HILLIARD",
    "dropphyst": "OH",
    "dropphyzpp": 430261278,
    "dropmaladd": "4000 LEAP RD",
    "dropmalcty": "HILLIARD",
    "dropmalst": "OH",
    "dropmalzpp": 430261278,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148767021,
    "dropsitcph": 6148767021,
    "dropfax": 6148760368
  },
  {
    "dcode": "D",
    "dropkey": "PX21327",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "301 N HIGH ST SIDE",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "OH",
    "dropdelzpp": 451331167,
    "dropphyadd": "301 N HIGH ST SIDE",
    "dropphycty": "HILLSBORO",
    "dropphyst": "OH",
    "dropphyzpp": 451331167,
    "dropmaladd": "301 N HIGH ST SIDE",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "OH",
    "dropmalzpp": 451331167,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373939231,
    "dropsitcph": 9373939231,
    "dropfax": 9373930610
  },
  {
    "dcode": "D",
    "dropkey": "PX21331",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "1294 RIDGE RD",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "OH",
    "dropdelzpp": 442339998,
    "dropphyadd": "1294 RIDGE RD",
    "dropphycty": "HINCKLEY",
    "dropphyst": "OH",
    "dropphyzpp": 442339998,
    "dropmaladd": "1294 RIDGE RD",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "OH",
    "dropmalzpp": 442339998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302783201,
    "dropfax": 3302782349
  },
  {
    "dcode": "D",
    "dropkey": "PX21332",
    "droptype": "D",
    "dropname": "HIRAM",
    "dropdeladd": "11676 HAYDEN AVE",
    "dropdelcty": "HIRAM",
    "dropdelst": "OH",
    "dropdelzpp": 442349802,
    "dropphyadd": "11676 HAYDEN AVE",
    "dropphycty": "HIRAM",
    "dropphyst": "OH",
    "dropphyzpp": 442349802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIRAM",
    "dropmalst": "OH",
    "dropmalzpp": 442349998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305697881,
    "dropfax": 3305693219
  },
  {
    "dcode": "D",
    "dropkey": "PX21337",
    "droptype": "D",
    "dropname": "HOLGATE",
    "dropdeladd": "165 N WILHELM ST",
    "dropdelcty": "HOLGATE",
    "dropdelst": "OH",
    "dropdelzpp": 435279998,
    "dropphyadd": "165 N WILHELM ST",
    "dropphycty": "HOLGATE",
    "dropphyst": "OH",
    "dropphyzpp": 435279998,
    "dropmaladd": "165 N WILHELM ST",
    "dropmalcty": "HOLGATE",
    "dropmalst": "OH",
    "dropmalzpp": 435279998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198904154,
    "dropsitcph": 4198904154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21338",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "6923 ANGOLA RD",
    "dropdelcty": "HOLLAND",
    "dropdelst": "OH",
    "dropdelzpp": 435289998,
    "dropphyadd": "6923 ANGOLA RD",
    "dropphycty": "HOLLAND",
    "dropphyst": "OH",
    "dropphyzpp": 435289998,
    "dropmaladd": "6923 ANGOLA RD",
    "dropmalcty": "HOLLAND",
    "dropmalst": "OH",
    "dropmalzpp": 435289998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198652601,
    "dropsitcph": 4198652601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21340",
    "droptype": "D",
    "dropname": "HOLLANSBURG",
    "dropdeladd": "124 N MAIN ST",
    "dropdelcty": "HOLLANSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453329998,
    "dropphyadd": "124 N MAIN ST",
    "dropphycty": "HOLLANSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453329998,
    "dropmaladd": "124 N MAIN ST",
    "dropmalcty": "HOLLANSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379974051,
    "dropsitcph": 9379974051,
    "dropfax": 9379974071
  },
  {
    "dcode": "D",
    "dropkey": "PX21342",
    "droptype": "D",
    "dropname": "HOLLOWAY",
    "dropdeladd": "120 E MAIN ST",
    "dropdelcty": "HOLLOWAY",
    "dropdelst": "OH",
    "dropdelzpp": 439859800,
    "dropphyadd": "120 E MAIN ST",
    "dropphycty": "HOLLOWAY",
    "dropphyst": "OH",
    "dropphyzpp": 439859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLOWAY",
    "dropmalst": "OH",
    "dropmalzpp": 439859998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409684615,
    "dropsitcph": 7409423601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21343",
    "droptype": "D",
    "dropname": "HOLMESVILLE",
    "dropdeladd": "201 S MILLERSBURG ST",
    "dropdelcty": "HOLMESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446339801,
    "dropphyadd": "201 S MILLERSBURG ST",
    "dropphycty": "HOLMESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446339801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLMESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446339998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302792911,
    "dropfax": 3302792911
  },
  {
    "dcode": "D",
    "dropkey": "PX21344",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "1080 HOMER RD NW",
    "dropdelcty": "HOMER",
    "dropdelst": "OH",
    "dropdelzpp": 430278000,
    "dropphyadd": "1080 HOMER RD NW",
    "dropphycty": "HOMER",
    "dropphyst": "OH",
    "dropphyzpp": 430278000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOMER",
    "dropmalst": "OH",
    "dropmalzpp": 430279998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408923282,
    "dropsitcph": 7408923282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21345",
    "droptype": "D",
    "dropname": "HOMERVILLE",
    "dropdeladd": "12079 GREENWICH RD",
    "dropdelcty": "HOMERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 442359998,
    "dropphyadd": "12079 GREENWICH RD",
    "dropphycty": "HOMERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 442359998,
    "dropmaladd": "12079 GREENWICH RD",
    "dropmalcty": "HOMERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 442359998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306252043,
    "dropfax": 3306255906
  },
  {
    "dcode": "D",
    "dropkey": "PX21346",
    "droptype": "D",
    "dropname": "HOMEWORTH",
    "dropdeladd": "4434 MIDDLE ST",
    "dropdelcty": "HOMEWORTH",
    "dropdelst": "OH",
    "dropdelzpp": 446349801,
    "dropphyadd": "4434 MIDDLE ST",
    "dropphycty": "HOMEWORTH",
    "dropphyst": "OH",
    "dropphyzpp": 446349801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOMEWORTH",
    "dropmalst": "OH",
    "dropmalzpp": 446349998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305257844,
    "dropfax": 3305257844
  },
  {
    "dcode": "D",
    "dropkey": "PX21349",
    "droptype": "D",
    "dropname": "HOPEDALE",
    "dropdeladd": "165 MILLER STATION RD",
    "dropdelcty": "HOPEDALE",
    "dropdelst": "OH",
    "dropdelzpp": 439769800,
    "dropphyadd": "165 MILLER STATION RD",
    "dropphycty": "HOPEDALE",
    "dropphyst": "OH",
    "dropphyzpp": 439769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPEDALE",
    "dropmalst": "OH",
    "dropmalzpp": 439769998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409372222,
    "dropsitcph": 7409372222,
    "dropfax": 7409372222
  },
  {
    "dcode": "D",
    "dropkey": "PX21353",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "3733 STATE ROUTE 66",
    "dropdelcty": "HOUSTON",
    "dropdelst": "OH",
    "dropdelzpp": 453339998,
    "dropphyadd": "3733 STATE ROUTE 66",
    "dropphycty": "HOUSTON",
    "dropphyst": "OH",
    "dropphyzpp": 453339998,
    "dropmaladd": "3733 STATE ROUTE 66",
    "dropmalcty": "HOUSTON",
    "dropmalst": "OH",
    "dropmalzpp": 453339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372952959,
    "dropsitcph": 9372952959,
    "dropfax": 9372955245
  },
  {
    "dcode": "D",
    "dropkey": "PX21354",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "23359 COSHOCTON RD UPPR",
    "dropdelcty": "HOWARD",
    "dropdelst": "OH",
    "dropdelzpp": 430289016,
    "dropphyadd": "23359 COSHOCTON RD UPPR",
    "dropphycty": "HOWARD",
    "dropphyst": "OH",
    "dropphyzpp": 430289016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOWARD",
    "dropmalst": "OH",
    "dropmalzpp": 430289998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405997456,
    "dropsitcph": 7405997456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21357",
    "droptype": "D",
    "dropname": "HOYTVILLE",
    "dropdeladd": "2521 N MAIN ST",
    "dropdelcty": "HOYTVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 435299998,
    "dropphyadd": "2521 N MAIN ST",
    "dropphycty": "HOYTVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 435299998,
    "dropmaladd": "2521 N MAIN ST",
    "dropmalcty": "HOYTVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 435299998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192786117,
    "dropsitcph": 4192786117,
    "dropfax": 4192786117
  },
  {
    "dcode": "D",
    "dropkey": "PX21358",
    "droptype": "D",
    "dropname": "HUBBARD",
    "dropdeladd": "44 E LIBERTY ST",
    "dropdelcty": "HUBBARD",
    "dropdelst": "OH",
    "dropdelzpp": 444259998,
    "dropphyadd": "44 E LIBERTY ST",
    "dropphycty": "HUBBARD",
    "dropphyst": "OH",
    "dropphyzpp": 444259998,
    "dropmaladd": "44 E LIBERTY ST",
    "dropmalcty": "HUBBARD",
    "dropmalst": "OH",
    "dropmalzpp": 444259998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305348148,
    "dropsitcph": 3305348148,
    "dropfax": 3305347934
  },
  {
    "dcode": "D",
    "dropkey": "PX21363",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "68 RAVENNA ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "OH",
    "dropdelzpp": 442369998,
    "dropphyadd": "68 RAVENNA ST",
    "dropphycty": "HUDSON",
    "dropphyst": "OH",
    "dropphyzpp": 442369998,
    "dropmaladd": "68 RAVENNA ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "OH",
    "dropmalzpp": 442369998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306501993,
    "dropfax": 3303420600
  },
  {
    "dcode": "D",
    "dropkey": "PX21373",
    "droptype": "D",
    "dropname": "HUNTSBURG",
    "dropdeladd": "12341 MADISON RD",
    "dropdelcty": "HUNTSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 440469800,
    "dropphyadd": "12341 MADISON RD",
    "dropphycty": "HUNTSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 440469800,
    "dropmaladd": "12341 MADISON RD",
    "dropmalcty": "HUNTSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 440469800,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4406365212,
    "dropfax": 4406369848
  },
  {
    "dcode": "D",
    "dropkey": "PX21374",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "6493 LIMA ST",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 433249433,
    "dropphyadd": "6493 LIMA ST",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 433249433,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 433249998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376863681,
    "dropsitcph": 9376863681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21375",
    "droptype": "D",
    "dropname": "HURON",
    "dropdeladd": "378 MAIN ST",
    "dropdelcty": "HURON",
    "dropdelst": "OH",
    "dropdelzpp": 448399998,
    "dropphyadd": "378 MAIN ST",
    "dropphycty": "HURON",
    "dropphyst": "OH",
    "dropphyzpp": 448399998,
    "dropmaladd": "378 MAIN ST",
    "dropmalcty": "HURON",
    "dropmalst": "OH",
    "dropmalzpp": 448399998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194335630,
    "dropfax": 4194338340
  },
  {
    "dcode": "D",
    "dropkey": "PX21379",
    "droptype": "D",
    "dropname": "IBERIA",
    "dropdeladd": "3570 STATE ROUTE 309",
    "dropdelcty": "IBERIA",
    "dropdelst": "OH",
    "dropdelzpp": 433259700,
    "dropphyadd": "3570 STATE ROUTE 309",
    "dropphycty": "IBERIA",
    "dropphyst": "OH",
    "dropphyzpp": 433259700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IBERIA",
    "dropmalst": "OH",
    "dropmalzpp": 433259998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4194686515,
    "dropsitcph": 4194686515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21393",
    "droptype": "D",
    "dropname": "IRONDALE",
    "dropdeladd": "210 EAST AVE",
    "dropdelcty": "IRONDALE",
    "dropdelst": "OH",
    "dropdelzpp": 439329997,
    "dropphyadd": "210 EAST AVE",
    "dropphycty": "IRONDALE",
    "dropphyst": "OH",
    "dropphyzpp": 439329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRONDALE",
    "dropmalst": "OH",
    "dropmalzpp": 439329998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305324834,
    "dropsitcph": 3305324834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21395",
    "droptype": "D",
    "dropname": "IRONTON",
    "dropdeladd": "214 N 4TH ST",
    "dropdelcty": "IRONTON",
    "dropdelst": "OH",
    "dropdelzpp": 456389839,
    "dropphyadd": "214 N 4TH ST",
    "dropphycty": "IRONTON",
    "dropphyst": "OH",
    "dropphyzpp": 456389839,
    "dropmaladd": "214 N 4TH ST",
    "dropmalcty": "IRONTON",
    "dropmalst": "OH",
    "dropmalzpp": 456389839,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405327282,
    "dropsitcph": 7405327282,
    "dropfax": 7405320520
  },
  {
    "dcode": "D",
    "dropkey": "PX21398",
    "droptype": "D",
    "dropname": "IRWIN",
    "dropdeladd": "24176 STATE ROUTE 161",
    "dropdelcty": "IRWIN",
    "dropdelst": "OH",
    "dropdelzpp": 430298000,
    "dropphyadd": "24176 STATE ROUTE 161",
    "dropphycty": "IRWIN",
    "dropphyst": "OH",
    "dropphyzpp": 430298000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRWIN",
    "dropmalst": "OH",
    "dropmalzpp": 430299998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373492121,
    "dropsitcph": 9373492121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21408",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "360 E MAIN ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "OH",
    "dropdelzpp": 456409998,
    "dropphyadd": "360 E MAIN ST",
    "dropphycty": "JACKSON",
    "dropphyst": "OH",
    "dropphyzpp": 456409998,
    "dropmaladd": "360 E MAIN ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "OH",
    "dropmalzpp": 456409998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402861818,
    "dropsitcph": 7402861818,
    "dropfax": 7402865942
  },
  {
    "dcode": "D",
    "dropkey": "PX21413",
    "droptype": "D",
    "dropname": "JACKSON CENTER",
    "dropdeladd": "114 E PIKE ST",
    "dropdelcty": "JACKSON CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 453349998,
    "dropphyadd": "114 E PIKE ST",
    "dropphycty": "JACKSON CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 453349998,
    "dropmaladd": "114 E PIKE ST",
    "dropmalcty": "JACKSON CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 453349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375966511,
    "dropsitcph": 9375966511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21419",
    "droptype": "D",
    "dropname": "JACKSONTOWN",
    "dropdeladd": "6686 NATIONAL RD SE",
    "dropdelcty": "JACKSONTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 430308000,
    "dropphyadd": "6686 NATIONAL RD SE",
    "dropphycty": "JACKSONTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 430308000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 430309998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403232497,
    "dropsitcph": 7403232497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21420",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "35 S 6TH ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457409800,
    "dropphyadd": "35 S 6TH ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457409800,
    "dropmaladd": "35 S 6TH ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457409800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407673716,
    "dropsitcph": 7407673716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21422",
    "droptype": "D",
    "dropname": "JACOBSBURG",
    "dropdeladd": "60630 MAIN ST",
    "dropdelcty": "JACOBSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 439339800,
    "dropphyadd": "60630 MAIN ST",
    "dropphycty": "JACOBSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 439339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACOBSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 439339998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406862355,
    "dropsitcph": 7406862355,
    "dropfax": 7406869828
  },
  {
    "dcode": "D",
    "dropkey": "PX21424",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "37 N LIMESTONE ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 453359998,
    "dropphyadd": "37 N LIMESTONE ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 453359998,
    "dropmaladd": "37 N LIMESTONE ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 453359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376753111,
    "dropsitcph": 9376753111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21426",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "6618 STATE ROUTE 104",
    "dropdelcty": "JASPER",
    "dropdelst": "OH",
    "dropdelzpp": 456429800,
    "dropphyadd": "6618 STATE ROUTE 104",
    "dropphycty": "JASPER",
    "dropphyst": "OH",
    "dropphyzpp": 456429800,
    "dropmaladd": "6618 STATE ROUTE 104",
    "dropmalcty": "JASPER",
    "dropmalst": "OH",
    "dropmalzpp": 456429800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402892077,
    "dropsitcph": 7402892077,
    "dropfax": 7402892077
  },
  {
    "dcode": "D",
    "dropkey": "PX21433",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "37 W JEFFERSON ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "OH",
    "dropdelzpp": 440479998,
    "dropphyadd": "37 W JEFFERSON ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "OH",
    "dropphyzpp": 440479998,
    "dropmaladd": "37 W JEFFERSON ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "OH",
    "dropmalzpp": 440479998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405762956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21440",
    "droptype": "D",
    "dropname": "JEFFERSONVILLE",
    "dropdeladd": "12 S MAIN ST",
    "dropdelcty": "JEFFERSONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431289998,
    "dropphyadd": "12 S MAIN ST",
    "dropphycty": "JEFFERSONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431289998,
    "dropmaladd": "12 S MAIN ST",
    "dropmalcty": "JEFFERSONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431289998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404266311,
    "dropsitcph": 7404266311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21445",
    "droptype": "D",
    "dropname": "JEROMESVILLE",
    "dropdeladd": "21 S HIGH ST",
    "dropdelcty": "JEROMESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448409800,
    "dropphyadd": "21 S HIGH ST",
    "dropphycty": "JEROMESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEROMESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448409998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4193683171,
    "dropfax": 4193685017
  },
  {
    "dcode": "D",
    "dropkey": "PX21446",
    "droptype": "D",
    "dropname": "JERRY CITY",
    "dropdeladd": "460 MAIN ST",
    "dropdelcty": "JERRY CITY",
    "dropdelst": "OH",
    "dropdelzpp": 434379998,
    "dropphyadd": "460 MAIN ST",
    "dropphycty": "JERRY CITY",
    "dropphyst": "OH",
    "dropphyzpp": 434379998,
    "dropmaladd": "460 MAIN ST",
    "dropmalcty": "JERRY CITY",
    "dropmalst": "OH",
    "dropmalzpp": 434379998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196553297,
    "dropsitcph": 4196553297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21448",
    "droptype": "D",
    "dropname": "JERUSALEM",
    "dropdeladd": "51666 MAIN ST",
    "dropdelcty": "JERUSALEM",
    "dropdelst": "OH",
    "dropdelzpp": 437479900,
    "dropphyadd": "51666 MAIN ST",
    "dropphycty": "JERUSALEM",
    "dropphyst": "OH",
    "dropphyzpp": 437479900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JERUSALEM",
    "dropmalst": "OH",
    "dropmalzpp": 437479998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409261853,
    "dropsitcph": 7409261853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21450",
    "droptype": "D",
    "dropname": "JEWELL",
    "dropdeladd": "7852 INDEPENDENCE RD",
    "dropdelcty": "JEWELL",
    "dropdelst": "OH",
    "dropdelzpp": 435309998,
    "dropphyadd": "7852 INDEPENDENCE RD",
    "dropphycty": "JEWELL",
    "dropphyst": "OH",
    "dropphyzpp": 435309998,
    "dropmaladd": "7852 INDEPENDENCE RD",
    "dropmalcty": "JEWELL",
    "dropmalst": "OH",
    "dropmalzpp": 435309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194974111,
    "dropsitcph": 4194974111,
    "dropfax": 4194974112
  },
  {
    "dcode": "D",
    "dropkey": "PX21451",
    "droptype": "D",
    "dropname": "JEWETT",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "JEWETT",
    "dropdelst": "OH",
    "dropdelzpp": 439869800,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "JEWETT",
    "dropphyst": "OH",
    "dropphyzpp": 439869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEWETT",
    "dropmalst": "OH",
    "dropmalzpp": 439869998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409464391,
    "dropsitcph": 7409464391,
    "dropfax": 7409461500
  },
  {
    "dcode": "D",
    "dropkey": "PX21455",
    "droptype": "D",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "211 W COSHOCTON ST",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 430319998,
    "dropphyadd": "211 W COSHOCTON ST",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 430319998,
    "dropmaladd": "211 W COSHOCTON ST",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 430319998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409677021,
    "dropsitcph": 7409677021,
    "dropfax": 7409677036
  },
  {
    "dcode": "D",
    "dropkey": "PX21459",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "114 W MAIN ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "OH",
    "dropdelzpp": 437489900,
    "dropphyadd": "114 W MAIN ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "OH",
    "dropphyzpp": 437489900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "OH",
    "dropmalzpp": 437489998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409874951,
    "dropsitcph": 7409874951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21461",
    "droptype": "D",
    "dropname": "KALIDA",
    "dropdeladd": "114 W MAIN ST",
    "dropdelcty": "KALIDA",
    "dropdelst": "OH",
    "dropdelzpp": 458539998,
    "dropphyadd": "114 W MAIN ST",
    "dropphycty": "KALIDA",
    "dropphyst": "OH",
    "dropphyzpp": 458539998,
    "dropmaladd": "114 W MAIN ST",
    "dropmalcty": "KALIDA",
    "dropmalst": "OH",
    "dropmalzpp": 458539998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195323935,
    "dropsitcph": 4195323935,
    "dropfax": 4195323935
  },
  {
    "dcode": "D",
    "dropkey": "PX21464",
    "droptype": "D",
    "dropname": "KANSAS",
    "dropdeladd": "6047 MAIN ST",
    "dropdelcty": "KANSAS",
    "dropdelst": "OH",
    "dropdelzpp": 448419800,
    "dropphyadd": "6047 MAIN ST",
    "dropphycty": "KANSAS",
    "dropphyst": "OH",
    "dropphyzpp": 448419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KANSAS",
    "dropmalst": "OH",
    "dropmalzpp": 448419998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199865881,
    "dropfax": 4199865881
  },
  {
    "dcode": "D",
    "dropkey": "PX21468",
    "droptype": "D",
    "dropname": "KELLEYS ISLAND",
    "dropdeladd": "427 W LAKESHORE DR",
    "dropdelcty": "KELLEYS ISLAND",
    "dropdelst": "OH",
    "dropdelzpp": 434389998,
    "dropphyadd": "427 W LAKESHORE DR",
    "dropphycty": "KELLEYS ISLAND",
    "dropphyst": "OH",
    "dropphyzpp": 434389998,
    "dropmaladd": "427 W LAKESHORE DR",
    "dropmalcty": "KELLEYS ISLAND",
    "dropmalst": "OH",
    "dropmalzpp": 434389998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197462351,
    "dropsitcph": 4197462351,
    "dropfax": 4197462351
  },
  {
    "dcode": "D",
    "dropkey": "PX21476",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "11011 STATE ROUTE 644",
    "dropdelcty": "KENSINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 444279800,
    "dropphyadd": "11011 STATE ROUTE 644",
    "dropphycty": "KENSINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 444279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENSINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 444279998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3302232122,
    "dropsitcph": 3302232122,
    "dropfax": 3302232122
  },
  {
    "dcode": "D",
    "dropkey": "PX21477",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "626 FRANKLIN AVE",
    "dropdelcty": "KENT",
    "dropdelst": "OH",
    "dropdelzpp": 442409998,
    "dropphyadd": "626 FRANKLIN AVE",
    "dropphycty": "KENT",
    "dropphyst": "OH",
    "dropphyzpp": 442409998,
    "dropmaladd": "626 FRANKLIN AVE",
    "dropmalcty": "KENT",
    "dropmalst": "OH",
    "dropmalzpp": 442409998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306733511,
    "dropfax": 3305937428
  },
  {
    "dcode": "D",
    "dropkey": "PX21479",
    "droptype": "D",
    "dropname": "KENTON",
    "dropdeladd": "305 W FRANKLIN ST",
    "dropdelcty": "KENTON",
    "dropdelst": "OH",
    "dropdelzpp": 433269998,
    "dropphyadd": "305 W FRANKLIN ST",
    "dropphycty": "KENTON",
    "dropphyst": "OH",
    "dropphyzpp": 433269998,
    "dropmaladd": "305 W FRANKLIN ST",
    "dropmalcty": "KENTON",
    "dropmalst": "OH",
    "dropmalzpp": 433269998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4196751105,
    "dropsitcph": 4196751105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21482",
    "droptype": "D",
    "dropname": "KERR",
    "dropdeladd": "178 AMBLESIDE DR",
    "dropdelcty": "KERR",
    "dropdelst": "OH",
    "dropdelzpp": 456439800,
    "dropphyadd": "178 AMBLESIDE DR",
    "dropphycty": "KERR",
    "dropphyst": "OH",
    "dropphyzpp": 456439800,
    "dropmaladd": "178 AMBLESIDE DR",
    "dropmalcty": "KERR",
    "dropmalst": "OH",
    "dropmalzpp": 456439800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404462001,
    "dropsitcph": 7404462001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21486",
    "droptype": "D",
    "dropname": "KETTLERSVILLE",
    "dropdeladd": "16620 KETTLERSVILLE RD",
    "dropdelcty": "KETTLERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 453369998,
    "dropphyadd": "16620 KETTLERSVILLE RD",
    "dropphycty": "KETTLERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 453369998,
    "dropmaladd": "16620 KETTLERSVILLE RD",
    "dropmalcty": "KETTLERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 453369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376933226,
    "dropsitcph": 9376933226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21489",
    "droptype": "D",
    "dropname": "KIDRON",
    "dropdeladd": "4698 KIDRON RD",
    "dropdelcty": "KIDRON",
    "dropdelst": "OH",
    "dropdelzpp": 446369800,
    "dropphyadd": "4698 KIDRON RD",
    "dropphycty": "KIDRON",
    "dropphyst": "OH",
    "dropphyzpp": 446369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIDRON",
    "dropmalst": "OH",
    "dropmalzpp": 446369998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308577471,
    "dropfax": 3308571708
  },
  {
    "dcode": "D",
    "dropkey": "PX21490",
    "droptype": "D",
    "dropname": "KILBOURNE",
    "dropdeladd": "3922 MAIN ST",
    "dropdelcty": "DELAWARE",
    "dropdelst": "OH",
    "dropdelzpp": 430158037,
    "dropphyadd": "3922 MAIN ST",
    "dropphycty": "DELAWARE",
    "dropphyst": "OH",
    "dropphyzpp": 430158037,
    "dropmaladd": "3922 MAIN ST",
    "dropmalcty": "DELAWARE",
    "dropmalst": "OH",
    "dropmalzpp": 430158037,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405244831,
    "dropsitcph": 7405244831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21493",
    "droptype": "D",
    "dropname": "KILLBUCK",
    "dropdeladd": "182 W FRONT ST",
    "dropdelcty": "KILLBUCK",
    "dropdelst": "OH",
    "dropdelzpp": 446379800,
    "dropphyadd": "182 W FRONT ST",
    "dropphycty": "KILLBUCK",
    "dropphyst": "OH",
    "dropphyzpp": 446379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KILLBUCK",
    "dropmalst": "OH",
    "dropmalzpp": 446379998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302767511,
    "dropfax": 3302767511
  },
  {
    "dcode": "D",
    "dropkey": "PX21497",
    "droptype": "D",
    "dropname": "KIMBOLTON",
    "dropdeladd": "114 S MAIN ST",
    "dropdelcty": "KIMBOLTON",
    "dropdelst": "OH",
    "dropdelzpp": 437499900,
    "dropphyadd": "114 S MAIN ST",
    "dropphycty": "KIMBOLTON",
    "dropphyst": "OH",
    "dropphyzpp": 437499900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIMBOLTON",
    "dropmalst": "OH",
    "dropmalzpp": 437499998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404394122,
    "dropsitcph": 7404394122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21503",
    "droptype": "D",
    "dropname": "KINGS MILLS",
    "dropdeladd": "1985 KING AVE",
    "dropdelcty": "KINGS MILLS",
    "dropdelst": "OH",
    "dropdelzpp": 450349998,
    "dropphyadd": "1985 KING AVE",
    "dropphycty": "KINGS MILLS",
    "dropphyst": "OH",
    "dropphyzpp": 450349998,
    "dropmaladd": "1985 KING AVE",
    "dropmalcty": "KINGS MILLS",
    "dropmalst": "OH",
    "dropmalzpp": 450349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133980311,
    "dropsitcph": 5133980311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21505",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "4 W PICKAWAY ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "OH",
    "dropdelzpp": 456449678,
    "dropphyadd": "4 W PICKAWAY ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "OH",
    "dropphyzpp": 456449678,
    "dropmaladd": "4 W PICKAWAY ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "OH",
    "dropmalzpp": 456449678,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406423053,
    "dropsitcph": 7406423053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21506",
    "droptype": "D",
    "dropname": "KINGSVILLE",
    "dropdeladd": "3110 W MAIN ST",
    "dropdelcty": "KINGSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440489817,
    "dropphyadd": "3110 W MAIN ST",
    "dropphycty": "KINGSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440489817,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440489998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402240607,
    "dropfax": 4402240607
  },
  {
    "dcode": "D",
    "dropkey": "PX21509",
    "droptype": "D",
    "dropname": "KINSMAN",
    "dropdeladd": "8289 STATE ST",
    "dropdelcty": "KINSMAN",
    "dropdelst": "OH",
    "dropdelzpp": 444289800,
    "dropphyadd": "8289 STATE ST",
    "dropphycty": "KINSMAN",
    "dropphyst": "OH",
    "dropphyzpp": 444289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINSMAN",
    "dropmalst": "OH",
    "dropmalzpp": 444289998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308762805,
    "dropsitcph": 3308762805,
    "dropfax": 3308762805
  },
  {
    "dcode": "D",
    "dropkey": "PX21512",
    "droptype": "D",
    "dropname": "KIPTON",
    "dropdeladd": "206 STATE ST",
    "dropdelcty": "KIPTON",
    "dropdelst": "OH",
    "dropdelzpp": 440499800,
    "dropphyadd": "206 STATE ST",
    "dropphycty": "KIPTON",
    "dropphyst": "OH",
    "dropphyzpp": 440499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIPTON",
    "dropmalst": "OH",
    "dropmalzpp": 440499998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407748018,
    "dropfax": 4407741221
  },
  {
    "dcode": "D",
    "dropkey": "PX21514",
    "droptype": "D",
    "dropname": "KIRKERSVILLE",
    "dropdeladd": "145 W MAIN ST",
    "dropdelcty": "KIRKERSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430338000,
    "dropphyadd": "145 W MAIN ST",
    "dropphycty": "KIRKERSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430338000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRKERSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430339998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409273349,
    "dropsitcph": 7409273349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21523",
    "droptype": "D",
    "dropname": "KITTS HILL",
    "dropdeladd": "7480 STATE ROUTE 141",
    "dropdelcty": "KITTS HILL",
    "dropdelst": "OH",
    "dropdelzpp": 456458582,
    "dropphyadd": "7480 STATE ROUTE 141",
    "dropphycty": "KITTS HILL",
    "dropphyst": "OH",
    "dropphyzpp": 456458582,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KITTS HILL",
    "dropmalst": "OH",
    "dropmalzpp": 456459998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405327519,
    "dropsitcph": 7405327519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21529",
    "droptype": "D",
    "dropname": "KUNKLE",
    "dropdeladd": "104 E ANGOLA ST",
    "dropdelcty": "KUNKLE",
    "dropdelst": "OH",
    "dropdelzpp": 435319998,
    "dropphyadd": "104 E ANGOLA ST",
    "dropphycty": "KUNKLE",
    "dropphyst": "OH",
    "dropphyzpp": 435319998,
    "dropmaladd": "104 E ANGOLA ST",
    "dropmalcty": "KUNKLE",
    "dropmalst": "OH",
    "dropmalzpp": 435319998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197372020,
    "dropsitcph": 4197372020,
    "dropfax": 4197372020
  },
  {
    "dcode": "D",
    "dropkey": "PX21532",
    "droptype": "D",
    "dropname": "LA RUE",
    "dropdeladd": "65 S HIGH ST",
    "dropdelcty": "LA RUE",
    "dropdelst": "OH",
    "dropdelzpp": 433329997,
    "dropphyadd": "65 S HIGH ST",
    "dropphycty": "LA RUE",
    "dropphyst": "OH",
    "dropphyzpp": 433329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA RUE",
    "dropmalst": "OH",
    "dropmalzpp": 433329998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404992419,
    "dropsitcph": 7404992419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21533",
    "droptype": "D",
    "dropname": "LACARNE",
    "dropdeladd": "89 N MONROE ST",
    "dropdelcty": "LACARNE",
    "dropdelst": "OH",
    "dropdelzpp": 434399998,
    "dropphyadd": "89 N MONROE ST",
    "dropphycty": "LACARNE",
    "dropphyst": "OH",
    "dropphyzpp": 434399998,
    "dropmaladd": "89 N MONROE ST",
    "dropmalcty": "LACARNE",
    "dropmalst": "OH",
    "dropmalzpp": 434399998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196352663,
    "dropsitcph": 4196352663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21536",
    "droptype": "D",
    "dropname": "LAFFERTY",
    "dropdeladd": "43126 MOUNT HOPE RD",
    "dropdelcty": "LAFFERTY",
    "dropdelst": "OH",
    "dropdelzpp": 439519997,
    "dropphyadd": "43126 MOUNT HOPE RD",
    "dropphycty": "LAFFERTY",
    "dropphyst": "OH",
    "dropphyzpp": 439519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAFFERTY",
    "dropmalst": "OH",
    "dropmalzpp": 439519998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409686129,
    "dropsitcph": 7409686129,
    "dropfax": 7409686129
  },
  {
    "dcode": "D",
    "dropkey": "PX21537",
    "droptype": "D",
    "dropname": "LAGRANGE",
    "dropdeladd": "112 PUBLIC SQ",
    "dropdelcty": "LAGRANGE",
    "dropdelst": "OH",
    "dropdelzpp": 440509840,
    "dropphyadd": "112 PUBLIC SQ",
    "dropphycty": "LAGRANGE",
    "dropphyst": "OH",
    "dropphyzpp": 440509840,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAGRANGE",
    "dropmalst": "OH",
    "dropmalzpp": 440509998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403554673,
    "dropfax": 4403554796
  },
  {
    "dcode": "D",
    "dropkey": "PX21543",
    "droptype": "D",
    "dropname": "LAKE MILTON",
    "dropdeladd": "17839 MAHONING AVE",
    "dropdelcty": "LAKE MILTON",
    "dropdelst": "OH",
    "dropdelzpp": 444299800,
    "dropphyadd": "17839 MAHONING AVE",
    "dropphycty": "LAKE MILTON",
    "dropphyst": "OH",
    "dropphyzpp": 444299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE MILTON",
    "dropmalst": "OH",
    "dropmalzpp": 444299998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306544371,
    "dropsitcph": 3306544371,
    "dropfax": 3267321727
  },
  {
    "dcode": "D",
    "dropkey": "PX21547",
    "droptype": "D",
    "dropname": "LAKEMORE",
    "dropdeladd": "1370 MAIN ST",
    "dropdelcty": "LAKEMORE",
    "dropdelst": "OH",
    "dropdelzpp": 442509800,
    "dropphyadd": "1370 MAIN ST",
    "dropphycty": "LAKEMORE",
    "dropphyst": "OH",
    "dropphyzpp": 442509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEMORE",
    "dropmalst": "OH",
    "dropmalzpp": 442509998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307847830,
    "dropfax": 3307847830
  },
  {
    "dcode": "D",
    "dropkey": "PX21551",
    "droptype": "D",
    "dropname": "LAKESIDE MARBLEHEAD",
    "dropdeladd": "1306 W MAIN ST",
    "dropdelcty": "LAKESIDE MARBLEHEAD",
    "dropdelst": "OH",
    "dropdelzpp": 434402024,
    "dropphyadd": "1306 W MAIN ST",
    "dropphycty": "LAKESIDE MARBLEHEAD",
    "dropphyst": "OH",
    "dropphyzpp": 434402024,
    "dropmaladd": "1306 W MAIN ST",
    "dropmalcty": "LAKESIDE MARBLEHEAD",
    "dropmalst": "OH",
    "dropmalzpp": 434402024,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197984153,
    "dropsitcph": 4197984153,
    "dropfax": 4197984153
  },
  {
    "dcode": "D",
    "dropkey": "PX21553",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "160 S MAIN ST",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "OH",
    "dropdelzpp": 433319550,
    "dropphyadd": "160 S MAIN ST",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "OH",
    "dropphyzpp": 433319550,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "OH",
    "dropmalzpp": 433319998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378434331,
    "dropsitcph": 9378434331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21554",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "13989 STATE ROUTE 226",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446389998,
    "dropphyadd": "13989 STATE ROUTE 226",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446389998,
    "dropmaladd": "13989 STATE ROUTE 226",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446389998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198272212,
    "dropfax": 4198270011
  },
  {
    "dcode": "D",
    "dropkey": "PX21557",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "204 S BROAD ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "OH",
    "dropdelzpp": 431309996,
    "dropphyadd": "204 S BROAD ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "OH",
    "dropphyzpp": 431309996,
    "dropmaladd": "204 S BROAD ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "OH",
    "dropmalzpp": 431309996,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406543130,
    "dropsitcph": 7406543130,
    "dropfax": 7406548255
  },
  {
    "dcode": "D",
    "dropkey": "PX21560",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "55157 NATIONAL RD",
    "dropdelcty": "LANSING",
    "dropdelst": "OH",
    "dropdelzpp": 439349997,
    "dropphyadd": "55157 NATIONAL RD",
    "dropphycty": "LANSING",
    "dropphyst": "OH",
    "dropphyzpp": 439349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANSING",
    "dropmalst": "OH",
    "dropmalzpp": 439349998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406330629,
    "dropsitcph": 7406330629,
    "dropfax": 7406351586
  },
  {
    "dcode": "D",
    "dropkey": "PX21563",
    "droptype": "D",
    "dropname": "LATHAM",
    "dropdeladd": "8502 STATE ROUTE 124",
    "dropdelcty": "LATHAM",
    "dropdelst": "OH",
    "dropdelzpp": 456469800,
    "dropphyadd": "8502 STATE ROUTE 124",
    "dropphycty": "LATHAM",
    "dropphyst": "OH",
    "dropphyzpp": 456469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LATHAM",
    "dropmalst": "OH",
    "dropmalzpp": 456469998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404932161,
    "dropsitcph": 7404932161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21566",
    "droptype": "D",
    "dropname": "LATTY",
    "dropdeladd": "380 2ND ST",
    "dropdelcty": "LATTY",
    "dropdelst": "OH",
    "dropdelzpp": 458559998,
    "dropphyadd": "380 2ND ST",
    "dropphycty": "LATTY",
    "dropphyst": "OH",
    "dropphyzpp": 458559998,
    "dropmaladd": "380 2ND ST",
    "dropmalcty": "LATTY",
    "dropmalst": "OH",
    "dropmalzpp": 458559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193995078,
    "dropsitcph": 4193995078,
    "dropfax": 4193992469
  },
  {
    "dcode": "D",
    "dropkey": "PX21567",
    "droptype": "D",
    "dropname": "LAURA",
    "dropdeladd": "203 S MAIN ST",
    "dropdelcty": "LAURA",
    "dropdelst": "OH",
    "dropdelzpp": 453379998,
    "dropphyadd": "203 S MAIN ST",
    "dropphycty": "LAURA",
    "dropphyst": "OH",
    "dropphyzpp": 453379998,
    "dropmaladd": "203 S MAIN ST",
    "dropmalcty": "LAURA",
    "dropmalst": "OH",
    "dropmalzpp": 453379998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379471413,
    "dropsitcph": 9379471413,
    "dropfax": 9379479509
  },
  {
    "dcode": "D",
    "dropkey": "PX21570",
    "droptype": "D",
    "dropname": "LAURELVILLE",
    "dropdeladd": "16088 PIKE ST",
    "dropdelcty": "LAURELVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431359900,
    "dropphyadd": "16088 PIKE ST",
    "dropphycty": "LAURELVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431359900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAURELVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431359998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403323215,
    "dropsitcph": 7403323215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21576",
    "droptype": "D",
    "dropname": "LEAVITTSBURG",
    "dropdeladd": "3825 W MARKET ST",
    "dropdelcty": "LEAVITTSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 444309800,
    "dropphyadd": "3825 W MARKET ST",
    "dropphycty": "LEAVITTSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 444309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEAVITTSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 444309998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308983811,
    "dropsitcph": 3308983811,
    "dropfax": 3308989163
  },
  {
    "dcode": "D",
    "dropkey": "PX21577",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "230 NEW ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "OH",
    "dropdelzpp": 450369998,
    "dropphyadd": "230 NEW ST",
    "dropphycty": "LEBANON",
    "dropphyst": "OH",
    "dropphyzpp": 450369998,
    "dropmaladd": "230 NEW ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "OH",
    "dropmalzpp": 450369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139342199,
    "dropsitcph": 5139342199,
    "dropfax": 5139328568
  },
  {
    "dcode": "D",
    "dropkey": "PX21585",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "44 E MAIN ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "OH",
    "dropdelzpp": 451359998,
    "dropphyadd": "44 E MAIN ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "OH",
    "dropphyzpp": 451359998,
    "dropmaladd": "44 E MAIN ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "OH",
    "dropmalzpp": 451359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377802551,
    "dropsitcph": 9377802551,
    "dropfax": 9377805041
  },
  {
    "dcode": "D",
    "dropkey": "PX21586",
    "droptype": "D",
    "dropname": "LEESVILLE",
    "dropdeladd": "95 S WATER ST",
    "dropdelcty": "LEESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446399800,
    "dropphyadd": "95 S WATER ST",
    "dropphycty": "LEESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446399998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7402699040,
    "dropfax": 7402699040
  },
  {
    "dcode": "D",
    "dropkey": "PX21587",
    "droptype": "D",
    "dropname": "LEETONIA",
    "dropdeladd": "235 MAIN ST",
    "dropdelcty": "LEETONIA",
    "dropdelst": "OH",
    "dropdelzpp": 444319998,
    "dropphyadd": "235 MAIN ST",
    "dropphycty": "LEETONIA",
    "dropphyst": "OH",
    "dropphyzpp": 444319998,
    "dropmaladd": "235 MAIN ST",
    "dropmalcty": "LEETONIA",
    "dropmalst": "OH",
    "dropmalzpp": 444319998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304276655,
    "dropsitcph": 3304276655,
    "dropfax": 3304271937
  },
  {
    "dcode": "D",
    "dropkey": "PX21588",
    "droptype": "D",
    "dropname": "LEIPSIC",
    "dropdeladd": "321 S BELMORE ST",
    "dropdelcty": "LEIPSIC",
    "dropdelst": "OH",
    "dropdelzpp": 458569998,
    "dropphyadd": "321 S BELMORE ST",
    "dropphycty": "LEIPSIC",
    "dropphyst": "OH",
    "dropphyzpp": 458569998,
    "dropmaladd": "321 S BELMORE ST",
    "dropmalcty": "LEIPSIC",
    "dropmalst": "OH",
    "dropmalzpp": 458569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199433346,
    "dropsitcph": 4199433346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21591",
    "droptype": "D",
    "dropname": "LEMOYNE",
    "dropdeladd": "3930 FREMONT PIKE",
    "dropdelcty": "LEMOYNE",
    "dropdelst": "OH",
    "dropdelzpp": 434419998,
    "dropphyadd": "3930 FREMONT PIKE",
    "dropphycty": "LEMOYNE",
    "dropphyst": "OH",
    "dropphyzpp": 434419998,
    "dropmaladd": "3930 FREMONT PIKE",
    "dropmalcty": "LEMOYNE",
    "dropmalst": "OH",
    "dropmalzpp": 434419998,
    "dropsitphn": 4198375288,
    "dropsitlph": 4198375288,
    "dropsitcph": 4198375288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21599",
    "droptype": "D",
    "dropname": "LEWIS CENTER",
    "dropdeladd": "393 E ORANGE RD",
    "dropdelcty": "LEWIS CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 430359998,
    "dropphyadd": "393 E ORANGE RD",
    "dropphycty": "LEWIS CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 430359998,
    "dropmaladd": "393 E ORANGE RD",
    "dropmalcty": "LEWIS CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 430359998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405484532,
    "dropsitcph": 7405484532,
    "dropfax": 7405499967
  },
  {
    "dcode": "D",
    "dropkey": "PX21601",
    "droptype": "D",
    "dropname": "LEWISBURG",
    "dropdeladd": "723 N COMMERCE ST",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453389998,
    "dropphyadd": "723 N COMMERCE ST",
    "dropphycty": "LEWISBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453389998,
    "dropmaladd": "723 N COMMERCE ST",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453389998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379622103,
    "dropsitcph": 9379622103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21602",
    "droptype": "D",
    "dropname": "LEWISTOWN",
    "dropdeladd": "7670 COUNTY ROAD 91",
    "dropdelcty": "LEWISTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 433339797,
    "dropphyadd": "7670 COUNTY ROAD 91",
    "dropphycty": "LEWISTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 433339797,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 433339998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376868404,
    "dropsitcph": 9376868404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21603",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "33212 RAILROAD ST",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437549900,
    "dropphyadd": "33212 RAILROAD ST",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437549998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405673156,
    "dropsitcph": 7405673156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21608",
    "droptype": "D",
    "dropname": "LIBERTY CENTER",
    "dropdeladd": "109 EAST ST",
    "dropdelcty": "LIBERTY CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 435329998,
    "dropphyadd": "109 EAST ST",
    "dropphycty": "LIBERTY CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 435329998,
    "dropmaladd": "109 EAST ST",
    "dropmalcty": "LIBERTY CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 435329998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195334361,
    "dropsitcph": 4195334361,
    "dropfax": 4195334361
  },
  {
    "dcode": "D",
    "dropkey": "PX21617",
    "droptype": "D",
    "dropname": "LIMA",
    "dropdeladd": "350 W HIGH ST",
    "dropdelcty": "LIMA",
    "dropdelst": "OH",
    "dropdelzpp": 458019998,
    "dropphyadd": "350 W HIGH ST",
    "dropphycty": "LIMA",
    "dropphyst": "OH",
    "dropphyzpp": 458019998,
    "dropmaladd": "350 W HIGH ST",
    "dropmalcty": "LIMA",
    "dropmalst": "OH",
    "dropmalzpp": 458019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192277777,
    "dropsitcph": 4192277777,
    "dropfax": 4192289745
  },
  {
    "dcode": "D",
    "dropkey": "PX21619",
    "droptype": "D",
    "dropname": "LIMAVILLE",
    "dropdeladd": "25 E MAIN ST",
    "dropdelcty": "LIMAVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446409800,
    "dropphyadd": "25 E MAIN ST",
    "dropphycty": "LIMAVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIMAVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446409998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308234730,
    "dropfax": 3308236452
  },
  {
    "dcode": "D",
    "dropkey": "PX21634",
    "droptype": "D",
    "dropname": "LINDSEY",
    "dropdeladd": "224 S MAIN ST",
    "dropdelcty": "LINDSEY",
    "dropdelst": "OH",
    "dropdelzpp": 434429998,
    "dropphyadd": "224 S MAIN ST",
    "dropphycty": "LINDSEY",
    "dropphyst": "OH",
    "dropphyzpp": 434429998,
    "dropmaladd": "224 S MAIN ST",
    "dropmalcty": "LINDSEY",
    "dropmalst": "OH",
    "dropmalzpp": 434429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196652611,
    "dropsitcph": 4196651650,
    "dropfax": 4196652611
  },
  {
    "dcode": "D",
    "dropkey": "PX21640",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "7983 DICKEY DR",
    "dropdelcty": "LISBON",
    "dropdelst": "OH",
    "dropdelzpp": 444329998,
    "dropphyadd": "7983 DICKEY DR",
    "dropphycty": "LISBON",
    "dropphyst": "OH",
    "dropphyzpp": 444329998,
    "dropmaladd": "7983 DICKEY DR",
    "dropmalcty": "LISBON",
    "dropmalst": "OH",
    "dropmalzpp": 444329998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304247615,
    "dropsitcph": 3304247615,
    "dropfax": 3304247450
  },
  {
    "dcode": "D",
    "dropkey": "PX21642",
    "droptype": "D",
    "dropname": "LITHOPOLIS",
    "dropdeladd": "260 W COLUMBUS ST",
    "dropdelcty": "LITHOPOLIS",
    "dropdelst": "OH",
    "dropdelzpp": 431369907,
    "dropphyadd": "260 W COLUMBUS ST",
    "dropphycty": "LITHOPOLIS",
    "dropphyst": "OH",
    "dropphyzpp": 431369907,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITHOPOLIS",
    "dropmalst": "OH",
    "dropmalzpp": 431369998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148379030,
    "dropsitcph": 6148379030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21644",
    "droptype": "D",
    "dropname": "LITTLE HOCKING",
    "dropdeladd": "3985 NEWBURY RD",
    "dropdelcty": "LITTLE HOCKING",
    "dropdelst": "OH",
    "dropdelzpp": 457425386,
    "dropphyadd": "3985 NEWBURY RD",
    "dropphycty": "LITTLE HOCKING",
    "dropphyst": "OH",
    "dropphyzpp": 457425386,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE HOCKING",
    "dropmalst": "OH",
    "dropmalzpp": 457429998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409892085,
    "dropsitcph": 7409892085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21654",
    "droptype": "D",
    "dropname": "LOCKBOURNE",
    "dropdeladd": "1 MECHANICS ST",
    "dropdelcty": "LOCKBOURNE",
    "dropdelst": "OH",
    "dropdelzpp": 431379906,
    "dropphyadd": "1 MECHANICS ST",
    "dropphycty": "LOCKBOURNE",
    "dropphyst": "OH",
    "dropphyzpp": 431379906,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCKBOURNE",
    "dropmalst": "OH",
    "dropmalzpp": 431379998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144979482,
    "dropsitcph": 6144979482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21661",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "149 HARRIS ST",
    "dropdelcty": "LODI",
    "dropdelst": "OH",
    "dropdelzpp": 442549998,
    "dropphyadd": "149 HARRIS ST",
    "dropphycty": "LODI",
    "dropphyst": "OH",
    "dropphyzpp": 442549998,
    "dropmaladd": "149 HARRIS ST",
    "dropmalcty": "LODI",
    "dropmalst": "OH",
    "dropmalzpp": 442549998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305905552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21662",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "80 N MARKET ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "OH",
    "dropdelzpp": 431389998,
    "dropphyadd": "80 N MARKET ST",
    "dropphycty": "LOGAN",
    "dropphyst": "OH",
    "dropphyzpp": 431389998,
    "dropmaladd": "80 N MARKET ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "OH",
    "dropmalzpp": 431389998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403853864,
    "dropsitcph": 7403853864,
    "dropfax": 7403803467
  },
  {
    "dcode": "D",
    "dropkey": "PX21666",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "25 S OAK ST",
    "dropdelcty": "LONDON",
    "dropdelst": "OH",
    "dropdelzpp": 431409998,
    "dropphyadd": "25 S OAK ST",
    "dropphycty": "LONDON",
    "dropphyst": "OH",
    "dropphyzpp": 431409998,
    "dropmaladd": "25 S OAK ST",
    "dropmalcty": "LONDON",
    "dropmalst": "OH",
    "dropmalzpp": 431409998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408521881,
    "dropsitcph": 7408521881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21667",
    "droptype": "D",
    "dropname": "LONDONDERRY",
    "dropdeladd": "5055 VIGO RD",
    "dropdelcty": "LONDONDERRY",
    "dropdelst": "OH",
    "dropdelzpp": 456479785,
    "dropphyadd": "5055 VIGO RD",
    "dropphycty": "LONDONDERRY",
    "dropphyst": "OH",
    "dropphyzpp": 456479785,
    "dropmaladd": "5055 VIGO RD",
    "dropmalcty": "LONDONDERRY",
    "dropmalst": "OH",
    "dropmalzpp": 456479785,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408872451,
    "dropsitcph": 7408872451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21668",
    "droptype": "D",
    "dropname": "LONG BOTTOM",
    "dropdeladd": "61462 STATE ROUTE 124",
    "dropdelcty": "LONG BOTTOM",
    "dropdelst": "OH",
    "dropdelzpp": 457439804,
    "dropphyadd": "61462 STATE ROUTE 124",
    "dropphycty": "LONG BOTTOM",
    "dropphyst": "OH",
    "dropphyzpp": 457439804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG BOTTOM",
    "dropmalst": "OH",
    "dropmalzpp": 457439998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409854379,
    "dropsitcph": 7409854379,
    "dropfax": 6149854379
  },
  {
    "dcode": "D",
    "dropkey": "PX21672",
    "droptype": "D",
    "dropname": "LORAIN",
    "dropdeladd": "439 W 4TH ST",
    "dropdelcty": "LORAIN",
    "dropdelst": "OH",
    "dropdelzpp": 440521655,
    "dropphyadd": "439 W 4TH ST",
    "dropphycty": "LORAIN",
    "dropphyst": "OH",
    "dropphyzpp": 440521655,
    "dropmaladd": "439 W 4TH ST",
    "dropmalcty": "LORAIN",
    "dropmalst": "OH",
    "dropmalzpp": 440521655,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402888593,
    "dropfax": 4404346025
  },
  {
    "dcode": "D",
    "dropkey": "PX21675",
    "droptype": "D",
    "dropname": "LORE CITY",
    "dropdeladd": "200 MAIN ST NW",
    "dropdelcty": "LORE CITY",
    "dropdelst": "OH",
    "dropdelzpp": 437559901,
    "dropphyadd": "200 MAIN ST NW",
    "dropphycty": "LORE CITY",
    "dropphyst": "OH",
    "dropphyzpp": 437559901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LORE CITY",
    "dropmalst": "OH",
    "dropmalzpp": 437559998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406855474,
    "dropsitcph": 7406855474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21679",
    "droptype": "D",
    "dropname": "LOUDONVILLE",
    "dropdeladd": "124 S WATER ST",
    "dropdelcty": "LOUDONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448429998,
    "dropphyadd": "124 S WATER ST",
    "dropphycty": "LOUDONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448429998,
    "dropmaladd": "124 S WATER ST",
    "dropmalcty": "LOUDONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448429998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199944631,
    "dropfax": 4199944631
  },
  {
    "dcode": "D",
    "dropkey": "PX21680",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "1000 N CHAPEL ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446419998,
    "dropphyadd": "1000 N CHAPEL ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446419998,
    "dropmaladd": "1000 N CHAPEL ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446419998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308751423,
    "dropfax": 3308750823
  },
  {
    "dcode": "D",
    "dropkey": "PX21681",
    "droptype": "D",
    "dropname": "LOVELAND",
    "dropdeladd": "200 LOVELAND MADEIRA RD",
    "dropdelcty": "LOVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 451409998,
    "dropphyadd": "200 LOVELAND MADEIRA RD",
    "dropphycty": "LOVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 451409998,
    "dropmaladd": "200 LOVELAND MADEIRA RD",
    "dropmalcty": "LOVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 451409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136838052,
    "dropsitcph": 5136838052,
    "dropfax": 5136830206
  },
  {
    "dcode": "D",
    "dropkey": "PX21683",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "203 3RD ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "OH",
    "dropdelzpp": 457447800,
    "dropphyadd": "203 3RD ST",
    "dropphycty": "LOWELL",
    "dropphyst": "OH",
    "dropphyzpp": 457447800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWELL",
    "dropmalst": "OH",
    "dropmalzpp": 457449998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408962659,
    "dropsitcph": 7408962659,
    "dropfax": 6148962659
  },
  {
    "dcode": "D",
    "dropkey": "PX21685",
    "droptype": "D",
    "dropname": "LOWELLVILLE",
    "dropdeladd": "10 E LIBERTY ST",
    "dropdelcty": "LOWELLVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 444369998,
    "dropphyadd": "10 E LIBERTY ST",
    "dropphycty": "LOWELLVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 444369998,
    "dropmaladd": "10 E LIBERTY ST",
    "dropmalcty": "LOWELLVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 444369998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305368874,
    "dropsitcph": 3305368874,
    "dropfax": 3305366526
  },
  {
    "dcode": "D",
    "dropkey": "PX21687",
    "droptype": "D",
    "dropname": "LOWER SALEM",
    "dropdeladd": "103 MAIN ST",
    "dropdelcty": "LOWER SALEM",
    "dropdelst": "OH",
    "dropdelzpp": 457459800,
    "dropphyadd": "103 MAIN ST",
    "dropphycty": "LOWER SALEM",
    "dropphyst": "OH",
    "dropphyzpp": 457459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWER SALEM",
    "dropmalst": "OH",
    "dropmalzpp": 457459998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405852609,
    "dropsitcph": 7405852609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21688",
    "droptype": "D",
    "dropname": "LUCAS",
    "dropdeladd": "36 W MAIN ST",
    "dropdelcty": "LUCAS",
    "dropdelst": "OH",
    "dropdelzpp": 448439800,
    "dropphyadd": "36 W MAIN ST",
    "dropphycty": "LUCAS",
    "dropphyst": "OH",
    "dropphyzpp": 448439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCAS",
    "dropmalst": "OH",
    "dropmalzpp": 448439998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198922701,
    "dropfax": 4198922701
  },
  {
    "dcode": "D",
    "dropkey": "PX21689",
    "droptype": "D",
    "dropname": "LUCASVILLE",
    "dropdeladd": "38 ROBERT LUCAS RD",
    "dropdelcty": "LUCASVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 456489800,
    "dropphyadd": "38 ROBERT LUCAS RD",
    "dropphycty": "LUCASVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 456489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCASVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 456489998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402592422,
    "dropsitcph": 7402592422,
    "dropfax": 7402595842
  },
  {
    "dcode": "D",
    "dropkey": "PX21690",
    "droptype": "D",
    "dropname": "LUCKEY",
    "dropdeladd": "248 MAIN ST",
    "dropdelcty": "LUCKEY",
    "dropdelst": "OH",
    "dropdelzpp": 434439998,
    "dropphyadd": "248 MAIN ST",
    "dropphycty": "LUCKEY",
    "dropphyst": "OH",
    "dropphyzpp": 434439998,
    "dropmaladd": "248 MAIN ST",
    "dropmalcty": "LUCKEY",
    "dropmalst": "OH",
    "dropmalzpp": 434439998,
    "dropsitphn": 4198334031,
    "dropsitlph": 4198334031,
    "dropsitcph": 4198334031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21692",
    "droptype": "D",
    "dropname": "LUDLOW FALLS",
    "dropdeladd": "110 COVINGTON AVE",
    "dropdelcty": "LUDLOW FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 453399998,
    "dropphyadd": "110 COVINGTON AVE",
    "dropphycty": "LUDLOW FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 453399998,
    "dropmaladd": "110 COVINGTON AVE",
    "dropmalcty": "LUDLOW FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 453399998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376985037,
    "dropsitcph": 9376985037,
    "dropfax": 9376986265
  },
  {
    "dcode": "D",
    "dropkey": "PX21698",
    "droptype": "D",
    "dropname": "LYNCHBURG",
    "dropdeladd": "264 N MAIN ST",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "OH",
    "dropdelzpp": 451429998,
    "dropphyadd": "264 N MAIN ST",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "OH",
    "dropphyzpp": 451429998,
    "dropmaladd": "264 N MAIN ST",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "OH",
    "dropmalzpp": 451429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373642715,
    "dropsitcph": 9373642715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21704",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "105 N ADRIAN ST",
    "dropdelcty": "LYONS",
    "dropdelst": "OH",
    "dropdelzpp": 435339998,
    "dropphyadd": "105 N ADRIAN ST",
    "dropphycty": "LYONS",
    "dropphyst": "OH",
    "dropphyzpp": 435339998,
    "dropmaladd": "105 N ADRIAN ST",
    "dropmalcty": "LYONS",
    "dropmalst": "OH",
    "dropmalzpp": 435339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199234541,
    "dropsitcph": 4199234541,
    "dropfax": 4199235803
  },
  {
    "dcode": "D",
    "dropkey": "PX21709",
    "droptype": "D",
    "dropname": "MACKSBURG",
    "dropdeladd": "340 SCHOOL ST",
    "dropdelcty": "MACKSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 457469997,
    "dropphyadd": "340 SCHOOL ST",
    "dropphycty": "MACKSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 457469997,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "DEXTER CITY",
    "dropmalst": "OH",
    "dropmalzpp": 457279800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407837715,
    "dropsitcph": 7407837715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21713",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "375 N LAKE ST",
    "dropdelcty": "MADISON",
    "dropdelst": "OH",
    "dropdelzpp": 440579992,
    "dropphyadd": "375 N LAKE ST",
    "dropphycty": "MADISON",
    "dropphyst": "OH",
    "dropphyzpp": 440579992,
    "dropmaladd": "375 N LAKE ST",
    "dropmalcty": "MADISON",
    "dropmalst": "OH",
    "dropmalzpp": 440579992,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404285134,
    "dropfax": 4404280863
  },
  {
    "dcode": "D",
    "dropkey": "PX21726",
    "droptype": "D",
    "dropname": "MAGNETIC SPRINGS",
    "dropdeladd": "57 S MAIN ST",
    "dropdelcty": "MAGNETIC SPRINGS",
    "dropdelst": "OH",
    "dropdelzpp": 430368000,
    "dropphyadd": "57 S MAIN ST",
    "dropphycty": "MAGNETIC SPRINGS",
    "dropphyst": "OH",
    "dropphyzpp": 430368000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGNETIC SPRINGS",
    "dropmalst": "OH",
    "dropmalzpp": 430369998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373482222,
    "dropsitcph": 9373482222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21727",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "155 CANAL ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "OH",
    "dropdelzpp": 446439800,
    "dropphyadd": "155 CANAL ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "OH",
    "dropphyzpp": 446439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "OH",
    "dropmalzpp": 446439998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308660145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21731",
    "droptype": "D",
    "dropname": "MAINEVILLE",
    "dropdeladd": "7878 S STATE ROUTE 48",
    "dropdelcty": "MAINEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 450399998,
    "dropphyadd": "7878 S STATE ROUTE 48",
    "dropphycty": "MAINEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 450399998,
    "dropmaladd": "7878 S STATE ROUTE 48",
    "dropmalcty": "MAINEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 450399998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136838016,
    "dropsitcph": 5136838016,
    "dropfax": 5136837851
  },
  {
    "dcode": "D",
    "dropkey": "PX21736",
    "droptype": "D",
    "dropname": "MALINTA",
    "dropdeladd": "110 N TURKEYFOOT AVE",
    "dropdelcty": "MALINTA",
    "dropdelst": "OH",
    "dropdelzpp": 435359998,
    "dropphyadd": "110 N TURKEYFOOT AVE",
    "dropphycty": "MALINTA",
    "dropphyst": "OH",
    "dropphyzpp": 435359998,
    "dropmaladd": "110 N TURKEYFOOT AVE",
    "dropmalcty": "MALINTA",
    "dropmalst": "OH",
    "dropmalzpp": 435359998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192567052,
    "dropsitcph": 4192567052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21737",
    "droptype": "D",
    "dropname": "MALTA",
    "dropdeladd": "534 N MAIN ST",
    "dropdelcty": "MALTA",
    "dropdelst": "OH",
    "dropdelzpp": 437589900,
    "dropphyadd": "534 N MAIN ST",
    "dropphycty": "MALTA",
    "dropphyst": "OH",
    "dropphyzpp": 437589900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALTA",
    "dropmalst": "OH",
    "dropmalzpp": 437589998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409624633,
    "dropsitcph": 7409624633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21738",
    "droptype": "D",
    "dropname": "MALVERN",
    "dropdeladd": "116 E PORTER ST",
    "dropdelcty": "MALVERN",
    "dropdelst": "OH",
    "dropdelzpp": 446449800,
    "dropphyadd": "116 E PORTER ST",
    "dropphycty": "MALVERN",
    "dropphyst": "OH",
    "dropphyzpp": 446449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALVERN",
    "dropmalst": "OH",
    "dropmalzpp": 446449998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308630599,
    "dropfax": 3308630812
  },
  {
    "dcode": "D",
    "dropkey": "PX21739",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "301 PIKE ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 451449998,
    "dropphyadd": "301 PIKE ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 451449998,
    "dropmaladd": "301 PIKE ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 451449998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135491007,
    "dropsitcph": 9375491007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21745",
    "droptype": "D",
    "dropname": "MANTUA",
    "dropdeladd": "10748 N MAIN ST",
    "dropdelcty": "MANTUA",
    "dropdelst": "OH",
    "dropdelzpp": 442559800,
    "dropphyadd": "10748 N MAIN ST",
    "dropphycty": "MANTUA",
    "dropphyst": "OH",
    "dropphyzpp": 442559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANTUA",
    "dropmalst": "OH",
    "dropmalzpp": 442559998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302742110,
    "dropfax": 3302740941
  },
  {
    "dcode": "D",
    "dropkey": "PX21755",
    "droptype": "D",
    "dropname": "MAPLEWOOD",
    "dropdeladd": "21611 MAPLEWOOD RD",
    "dropdelcty": "MAPLEWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 453409998,
    "dropphyadd": "21611 MAPLEWOOD RD",
    "dropphycty": "MAPLEWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 453409998,
    "dropmaladd": "21611 MAPLEWOOD RD",
    "dropmalcty": "MAPLEWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 453409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375966991,
    "dropsitcph": 9375966991,
    "dropfax": 9375965176
  },
  {
    "dcode": "D",
    "dropkey": "PX21761",
    "droptype": "D",
    "dropname": "MARENGO",
    "dropdeladd": "97 S MAIN ST",
    "dropdelcty": "MARENGO",
    "dropdelst": "OH",
    "dropdelzpp": 433349598,
    "dropphyadd": "97 S MAIN ST",
    "dropphycty": "MARENGO",
    "dropphyst": "OH",
    "dropphyzpp": 433349598,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARENGO",
    "dropmalst": "OH",
    "dropmalzpp": 433349998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4192534411,
    "dropsitcph": 4192534411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21762",
    "droptype": "D",
    "dropname": "MARIA STEIN",
    "dropdeladd": "8629 STATE ROUTE 119",
    "dropdelcty": "MARIA STEIN",
    "dropdelst": "OH",
    "dropdelzpp": 458609998,
    "dropphyadd": "8629 STATE ROUTE 119",
    "dropphycty": "MARIA STEIN",
    "dropphyst": "OH",
    "dropphyzpp": 458609998,
    "dropmaladd": "8629 STATE ROUTE 119",
    "dropmalcty": "MARIA STEIN",
    "dropmalst": "OH",
    "dropmalzpp": 458609998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199254014,
    "dropsitcph": 4199254014,
    "dropfax": 4199251226
  },
  {
    "dcode": "D",
    "dropkey": "PX21764",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "275 FRONT ST",
    "dropdelcty": "MARIETTA",
    "dropdelst": "OH",
    "dropdelzpp": 457502937,
    "dropphyadd": "275 FRONT ST",
    "dropphycty": "MARIETTA",
    "dropphyst": "OH",
    "dropphyzpp": 457502937,
    "dropmaladd": "275 FRONT ST",
    "dropmalcty": "MARIETTA",
    "dropmalst": "OH",
    "dropmalzpp": 457502937,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403730737,
    "dropsitcph": 7403730737,
    "dropfax": 7403738161
  },
  {
    "dcode": "D",
    "dropkey": "PX21766",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "230 BARKS RD W",
    "dropdelcty": "MARION",
    "dropdelst": "OH",
    "dropdelzpp": 433029998,
    "dropphyadd": "230 BARKS RD W",
    "dropphycty": "MARION",
    "dropphyst": "OH",
    "dropphyzpp": 433029998,
    "dropmaladd": "230 BARKS RD W",
    "dropmalcty": "MARION",
    "dropmalst": "OH",
    "dropmalzpp": 433029998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403894621,
    "dropsitcph": 7403894621,
    "dropfax": 7403894142
  },
  {
    "dcode": "D",
    "dropkey": "PX21769",
    "droptype": "D",
    "dropname": "MARK CENTER",
    "dropdeladd": "10577 FARMER MARK RD",
    "dropdelcty": "MARK CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 435369998,
    "dropphyadd": "10577 FARMER MARK RD",
    "dropphycty": "MARK CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 435369998,
    "dropmaladd": "10577 FARMER MARK RD",
    "dropmalcty": "MARK CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 435369998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195428811,
    "dropsitcph": 4195428811,
    "dropfax": 4195428456
  },
  {
    "dcode": "D",
    "dropkey": "PX21775",
    "droptype": "D",
    "dropname": "MARSHALLVILLE",
    "dropdeladd": "3 N MAIN ST",
    "dropdelcty": "MARSHALLVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446459801,
    "dropphyadd": "3 N MAIN ST",
    "dropphycty": "MARSHALLVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446459801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHALLVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446459998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308553681,
    "dropfax": 3308553681
  },
  {
    "dcode": "D",
    "dropkey": "PX21777",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "2918 1ST ST",
    "dropdelcty": "MARTIN",
    "dropdelst": "OH",
    "dropdelzpp": 434459998,
    "dropphyadd": "2918 1ST ST",
    "dropphycty": "MARTIN",
    "dropphyst": "OH",
    "dropphyzpp": 434459998,
    "dropmaladd": "2918 1ST ST",
    "dropmalcty": "MARTIN",
    "dropmalst": "OH",
    "dropmalzpp": 434459998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198553285,
    "dropsitcph": 4198553285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21778",
    "droptype": "D",
    "dropname": "MARTINS FERRY",
    "dropdeladd": "101 N 5TH ST",
    "dropdelcty": "MARTINS FERRY",
    "dropdelst": "OH",
    "dropdelzpp": 439359998,
    "dropphyadd": "101 N 5TH ST",
    "dropphycty": "MARTINS FERRY",
    "dropphyst": "OH",
    "dropphyzpp": 439359998,
    "dropmaladd": "101 N 5TH ST",
    "dropmalcty": "MARTINS FERRY",
    "dropmalst": "OH",
    "dropmalzpp": 439359998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406331802,
    "dropsitcph": 7406331802,
    "dropfax": 7406331107
  },
  {
    "dcode": "D",
    "dropkey": "PX21779",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "110 E LIBERTY ST",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430378000,
    "dropphyadd": "110 E LIBERTY ST",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430378000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430379998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406684377,
    "dropsitcph": 7406684377,
    "dropfax": 7406685094
  },
  {
    "dcode": "D",
    "dropkey": "PX21780",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "33 HIGH ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451469998,
    "dropphyadd": "33 HIGH ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451469998,
    "dropmaladd": "33 HIGH ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451469998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376852495,
    "dropsitcph": 9376852495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21784",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430409998,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430409998,
    "dropmaladd": "202 N MAIN ST",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430409998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376421961,
    "dropsitcph": 9376421961,
    "dropfax": 9376422028
  },
  {
    "dcode": "D",
    "dropkey": "PX21785",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "6338 SNIDER RD",
    "dropdelcty": "MASON",
    "dropdelst": "OH",
    "dropdelzpp": 450409998,
    "dropphyadd": "6338 SNIDER RD",
    "dropphycty": "MASON",
    "dropphyst": "OH",
    "dropphyzpp": 450409998,
    "dropmaladd": "6338 SNIDER RD",
    "dropmalcty": "MASON",
    "dropmalst": "OH",
    "dropmalzpp": 450409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133988209,
    "dropsitcph": 5133988209,
    "dropfax": 5134597967
  },
  {
    "dcode": "D",
    "dropkey": "PX21788",
    "droptype": "D",
    "dropname": "MASSILLON",
    "dropdeladd": "333 ERIE ST S",
    "dropdelcty": "MASSILLON",
    "dropdelst": "OH",
    "dropdelzpp": 446469998,
    "dropphyadd": "333 ERIE ST S",
    "dropphycty": "MASSILLON",
    "dropphyst": "OH",
    "dropphyzpp": 446469998,
    "dropmaladd": "333 ERIE ST S",
    "dropmalcty": "MASSILLON",
    "dropmalst": "OH",
    "dropmalzpp": 446469998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308378323,
    "dropfax": 3308375880
  },
  {
    "dcode": "D",
    "dropkey": "PX21789",
    "droptype": "D",
    "dropname": "MASURY",
    "dropdeladd": "7835 ELM ST",
    "dropdelcty": "MASURY",
    "dropdelst": "OH",
    "dropdelzpp": 444389998,
    "dropphyadd": "7835 ELM ST",
    "dropphycty": "MASURY",
    "dropphyst": "OH",
    "dropphyzpp": 444389998,
    "dropmaladd": "7835 ELM ST",
    "dropmalcty": "MASURY",
    "dropmalst": "OH",
    "dropmalzpp": 444389998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304486467,
    "dropsitcph": 3304486467,
    "dropfax": 3304486467
  },
  {
    "dcode": "D",
    "dropkey": "PX21791",
    "droptype": "D",
    "dropname": "MAUMEE",
    "dropdeladd": "1375 FORD ST",
    "dropdelcty": "MAUMEE",
    "dropdelst": "OH",
    "dropdelzpp": 435371763,
    "dropphyadd": "1375 FORD ST",
    "dropphycty": "MAUMEE",
    "dropphyst": "OH",
    "dropphyzpp": 435371763,
    "dropmaladd": "1375 FORD ST",
    "dropmalcty": "MAUMEE",
    "dropmalst": "OH",
    "dropmalzpp": 435371763,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198932541,
    "dropsitcph": 4198932541,
    "dropfax": 4198934578
  },
  {
    "dcode": "D",
    "dropkey": "PX21792",
    "droptype": "D",
    "dropname": "MAXIMO",
    "dropdeladd": "6995 OAKHILL AVE NE",
    "dropdelcty": "MAXIMO",
    "dropdelst": "OH",
    "dropdelzpp": 446509800,
    "dropphyadd": "6995 OAKHILL AVE NE",
    "dropphycty": "MAXIMO",
    "dropphyst": "OH",
    "dropphyzpp": 446509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAXIMO",
    "dropmalst": "OH",
    "dropmalzpp": 446509998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308233289,
    "dropfax": 3308233289
  },
  {
    "dcode": "D",
    "dropkey": "PX21800",
    "droptype": "D",
    "dropname": "MAYNARD",
    "dropdeladd": "71480 HALL ST",
    "dropdelcty": "MAYNARD",
    "dropdelst": "OH",
    "dropdelzpp": 439379800,
    "dropphyadd": "71480 HALL ST",
    "dropphycty": "MAYNARD",
    "dropphyst": "OH",
    "dropphyzpp": 439379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYNARD",
    "dropmalst": "OH",
    "dropmalzpp": 439379998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406959792,
    "dropsitcph": 7406959792,
    "dropfax": 7406959792
  },
  {
    "dcode": "D",
    "dropkey": "PX21803",
    "droptype": "D",
    "dropname": "MC ARTHUR",
    "dropdeladd": "117 S MARKET ST",
    "dropdelcty": "MC ARTHUR",
    "dropdelst": "OH",
    "dropdelzpp": 456511274,
    "dropphyadd": "117 S MARKET ST",
    "dropphycty": "MC ARTHUR",
    "dropphyst": "OH",
    "dropphyzpp": 456511274,
    "dropmaladd": "117 S MARKET ST",
    "dropmalcty": "MC ARTHUR",
    "dropmalst": "OH",
    "dropmalzpp": 456511274,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405964163,
    "dropsitcph": 7405964163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21804",
    "droptype": "D",
    "dropname": "MC CLURE",
    "dropdeladd": "232 S EAST ST",
    "dropdelcty": "MC CLURE",
    "dropdelst": "OH",
    "dropdelzpp": 435349998,
    "dropphyadd": "232 S EAST ST",
    "dropphycty": "MC CLURE",
    "dropphyst": "OH",
    "dropphyzpp": 435349998,
    "dropmaladd": "232 S EAST ST",
    "dropmalcty": "MC CLURE",
    "dropmalst": "OH",
    "dropmalzpp": 435349998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197488130,
    "dropsitcph": 4197488130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21805",
    "droptype": "D",
    "dropname": "MC COMB",
    "dropdeladd": "116 W SOUTH ST",
    "dropdelcty": "MC COMB",
    "dropdelst": "OH",
    "dropdelzpp": 458589998,
    "dropphyadd": "116 W SOUTH ST",
    "dropphycty": "MC COMB",
    "dropphyst": "OH",
    "dropphyzpp": 458589998,
    "dropmaladd": "116 W SOUTH ST",
    "dropmalcty": "MC COMB",
    "dropmalst": "OH",
    "dropmalzpp": 458589998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192933011,
    "dropsitcph": 4192933011,
    "dropfax": 4192932419
  },
  {
    "dcode": "D",
    "dropkey": "PX21806",
    "droptype": "D",
    "dropname": "MCCONNELSVILLE",
    "dropdeladd": "83 S KENNEBEC AVE",
    "dropdelcty": "MCCONNELSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437569998,
    "dropphyadd": "83 S KENNEBEC AVE",
    "dropphycty": "MCCONNELSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437569998,
    "dropmaladd": "83 S KENNEBEC AVE",
    "dropmalcty": "MCCONNELSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437569998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409622912,
    "dropsitcph": 7409622912,
    "dropfax": 7409622912
  },
  {
    "dcode": "D",
    "dropkey": "PX21807",
    "droptype": "D",
    "dropname": "MC CUTCHENVILLE",
    "dropdeladd": "172 STATE HIGHWAY 53 N",
    "dropdelcty": "MC CUTCHENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448449800,
    "dropphyadd": "172 STATE HIGHWAY 53 N",
    "dropphycty": "MC CUTCHENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CUTCHENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448449998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199815111,
    "dropfax": 4199815111
  },
  {
    "dcode": "D",
    "dropkey": "PX21808",
    "droptype": "D",
    "dropname": "MC DERMOTT",
    "dropdeladd": "100 BARKER ST",
    "dropdelcty": "MC DERMOTT",
    "dropdelst": "OH",
    "dropdelzpp": 456529997,
    "dropphyadd": "100 BARKER ST",
    "dropphycty": "MC DERMOTT",
    "dropphyst": "OH",
    "dropphyzpp": 456529997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC DERMOTT",
    "dropmalst": "OH",
    "dropmalzpp": 456529998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402594559,
    "dropsitcph": 7402594559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21809",
    "droptype": "D",
    "dropname": "MC DONALD",
    "dropdeladd": "500 OHIO AVE",
    "dropdelcty": "MC DONALD",
    "dropdelst": "OH",
    "dropdelzpp": 444379998,
    "dropphyadd": "500 OHIO AVE",
    "dropphycty": "MC DONALD",
    "dropphyst": "OH",
    "dropphyzpp": 444379998,
    "dropmaladd": "500 OHIO AVE",
    "dropmalcty": "MC DONALD",
    "dropmalst": "OH",
    "dropmalzpp": 444379998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305302887,
    "dropsitcph": 3305302887,
    "dropfax": 3305302060
  },
  {
    "dcode": "D",
    "dropkey": "PX21810",
    "droptype": "D",
    "dropname": "MC GUFFEY",
    "dropdeladd": "402 COURTRIGHT ST",
    "dropdelcty": "MC GUFFEY",
    "dropdelst": "OH",
    "dropdelzpp": 458599998,
    "dropphyadd": "402 COURTRIGHT ST",
    "dropphycty": "MC GUFFEY",
    "dropphyst": "OH",
    "dropphyzpp": 458599998,
    "dropmaladd": "402 COURTRIGHT ST",
    "dropmalcty": "MC GUFFEY",
    "dropmalst": "OH",
    "dropmalzpp": 458599998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197574973,
    "dropsitcph": 4197574973,
    "dropfax": 4197574973
  },
  {
    "dcode": "D",
    "dropkey": "PX21834",
    "droptype": "D",
    "dropname": "MECHANICSBURG",
    "dropdeladd": "40 S MAIN ST",
    "dropdelcty": "MECHANICSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430441199,
    "dropphyadd": "40 S MAIN ST",
    "dropphycty": "MECHANICSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430441199,
    "dropmaladd": "40 S MAIN ST",
    "dropmalcty": "MECHANICSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430441199,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378342695,
    "dropsitcph": 9378342695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21835",
    "droptype": "D",
    "dropname": "MECHANICSTOWN",
    "dropdeladd": "7077 SALINEVILLE RD NE",
    "dropdelcty": "MECHANICSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 446519800,
    "dropphyadd": "7077 SALINEVILLE RD NE",
    "dropphycty": "MECHANICSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 446519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MECHANICSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 446519998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307383201,
    "dropfax": 3307383201
  },
  {
    "dcode": "D",
    "dropkey": "PX21836",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "303 N COURT ST",
    "dropdelcty": "MEDINA",
    "dropdelst": "OH",
    "dropdelzpp": 442569998,
    "dropphyadd": "303 N COURT ST",
    "dropphycty": "MEDINA",
    "dropphyst": "OH",
    "dropphyzpp": 442569998,
    "dropmaladd": "303 N COURT ST",
    "dropmalcty": "MEDINA",
    "dropmalst": "OH",
    "dropmalzpp": 442569998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307226511,
    "dropfax": 3307237362
  },
  {
    "dcode": "D",
    "dropkey": "PX21837",
    "droptype": "D",
    "dropname": "MEDWAY",
    "dropdeladd": "117 W MAIN ST",
    "dropdelcty": "MEDWAY",
    "dropdelst": "OH",
    "dropdelzpp": 453419998,
    "dropphyadd": "117 W MAIN ST",
    "dropphycty": "MEDWAY",
    "dropphyst": "OH",
    "dropphyzpp": 453419998,
    "dropmaladd": "117 W MAIN ST",
    "dropmalcty": "MEDWAY",
    "dropmalst": "OH",
    "dropmalzpp": 453419998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378491866,
    "dropsitcph": 9378491866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21844",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "519 STATE ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "OH",
    "dropdelzpp": 458619998,
    "dropphyadd": "519 STATE ST",
    "dropphycty": "MELROSE",
    "dropphyst": "OH",
    "dropphyzpp": 458619998,
    "dropmaladd": "519 STATE ST",
    "dropmalcty": "MELROSE",
    "dropmalst": "OH",
    "dropmalzpp": 458619998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195943318,
    "dropsitcph": 4195943318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21845",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "113 N MAIN ST",
    "dropdelcty": "MENDON",
    "dropdelst": "OH",
    "dropdelzpp": 458629998,
    "dropphyadd": "113 N MAIN ST",
    "dropphycty": "MENDON",
    "dropphyst": "OH",
    "dropphyzpp": 458629998,
    "dropmaladd": "113 N MAIN ST",
    "dropmalcty": "MENDON",
    "dropmalst": "OH",
    "dropmalzpp": 458629998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197955421,
    "dropsitcph": 4197955421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21846",
    "droptype": "D",
    "dropname": "MENTOR",
    "dropdeladd": "8600 TYLER BLVD",
    "dropdelcty": "MENTOR",
    "dropdelst": "OH",
    "dropdelzpp": 440609998,
    "dropphyadd": "8600 TYLER BLVD",
    "dropphycty": "MENTOR",
    "dropphyst": "OH",
    "dropphyzpp": 440609998,
    "dropmaladd": "8600 TYLER BLVD",
    "dropmalcty": "MENTOR",
    "dropmalst": "OH",
    "dropmalzpp": 440609998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402552798,
    "dropfax": 4407014707
  },
  {
    "dcode": "D",
    "dropkey": "PX21850",
    "droptype": "D",
    "dropname": "MESOPOTAMIA",
    "dropdeladd": "4370 KINSMAN RD",
    "dropdelcty": "MESOPOTAMIA",
    "dropdelst": "OH",
    "dropdelzpp": 444399800,
    "dropphyadd": "4370 KINSMAN RD",
    "dropphycty": "MESOPOTAMIA",
    "dropphyst": "OH",
    "dropphyzpp": 444399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESOPOTAMIA",
    "dropmalst": "OH",
    "dropmalzpp": 444399998,
    "dropsitphn": 3309969797,
    "dropsitlph": 4406934211,
    "dropsitcph": 4406934211,
    "dropfax": 4406934211
  },
  {
    "dcode": "D",
    "dropkey": "PX21852",
    "droptype": "D",
    "dropname": "METAMORA",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "METAMORA",
    "dropdelst": "OH",
    "dropdelzpp": 435409998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "METAMORA",
    "dropphyst": "OH",
    "dropphyzpp": 435409998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "OH",
    "dropmalzpp": 435409998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196442015,
    "dropsitcph": 4196442015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21862",
    "droptype": "D",
    "dropname": "MIAMISBURG",
    "dropdeladd": "240 S HEINCKE RD",
    "dropdelcty": "MIAMISBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453429998,
    "dropphyadd": "240 S HEINCKE RD",
    "dropphycty": "MIAMISBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453429998,
    "dropmaladd": "240 S HEINCKE RD",
    "dropmalcty": "MIAMISBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373887528,
    "dropsitcph": 9373887528,
    "dropfax": 9378662197
  },
  {
    "dcode": "D",
    "dropkey": "PX21863",
    "droptype": "D",
    "dropname": "MIAMITOWN",
    "dropdeladd": "6739 HAMILTON CLEVES RD",
    "dropdelcty": "MIAMITOWN",
    "dropdelst": "OH",
    "dropdelzpp": 450419998,
    "dropphyadd": "6739 HAMILTON CLEVES RD",
    "dropphycty": "MIAMITOWN",
    "dropphyst": "OH",
    "dropphyzpp": 450419998,
    "dropmaladd": "6739 HAMILTON CLEVES RD",
    "dropmalcty": "MIAMITOWN",
    "dropmalst": "OH",
    "dropmalzpp": 450419998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133531650,
    "dropsitcph": 5133531650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21865",
    "droptype": "D",
    "dropname": "MIAMIVILLE",
    "dropdeladd": "352 CENTER ST",
    "dropdelcty": "MIAMIVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451479998,
    "dropphyadd": "352 CENTER ST",
    "dropphycty": "MIAMIVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451479998,
    "dropmaladd": "352 CENTER ST",
    "dropmalcty": "MIAMIVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451479998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138318551,
    "dropsitcph": 5138318551,
    "dropfax": 5138314194
  },
  {
    "dcode": "D",
    "dropkey": "PX21870",
    "droptype": "D",
    "dropname": "MIDDLE POINT",
    "dropdeladd": "206 E JACKSON ST",
    "dropdelcty": "MIDDLE POINT",
    "dropdelst": "OH",
    "dropdelzpp": 458639998,
    "dropphyadd": "206 E JACKSON ST",
    "dropphycty": "MIDDLE POINT",
    "dropphyst": "OH",
    "dropphyzpp": 458639998,
    "dropmaladd": "206 E JACKSON ST",
    "dropmalcty": "MIDDLE POINT",
    "dropmalst": "OH",
    "dropmalzpp": 458639998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199682476,
    "dropsitcph": 4199682476,
    "dropfax": 4199682496
  },
  {
    "dcode": "D",
    "dropkey": "PX21873",
    "droptype": "D",
    "dropname": "MIDDLEBRANCH",
    "dropdeladd": "7940 MIDDLEBRANCH AVE NE",
    "dropdelcty": "MIDDLEBRANCH",
    "dropdelst": "OH",
    "dropdelzpp": 446529800,
    "dropphyadd": "7940 MIDDLEBRANCH AVE NE",
    "dropphycty": "MIDDLEBRANCH",
    "dropphyst": "OH",
    "dropphyzpp": 446529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEBRANCH",
    "dropmalst": "OH",
    "dropmalzpp": 446529998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304945358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21875",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "12020 GREEN ST",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "OH",
    "dropdelzpp": 433369700,
    "dropphyadd": "12020 GREEN ST",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "OH",
    "dropphyzpp": 433369700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "OH",
    "dropmalzpp": 433369998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376664643,
    "dropsitcph": 9376664643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21878",
    "droptype": "D",
    "dropname": "MIDDLEFIELD",
    "dropdeladd": "15993 E HIGH ST",
    "dropdelcty": "MIDDLEFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 440629800,
    "dropphyadd": "15993 E HIGH ST",
    "dropphycty": "MIDDLEFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 440629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 440629998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4406320192,
    "dropfax": 4406320021
  },
  {
    "dcode": "D",
    "dropkey": "PX21880",
    "droptype": "D",
    "dropname": "MIDDLEPORT",
    "dropdeladd": "320 MILL ST",
    "dropdelcty": "MIDDLEPORT",
    "dropdelst": "OH",
    "dropdelzpp": 457601181,
    "dropphyadd": "320 MILL ST",
    "dropphycty": "MIDDLEPORT",
    "dropphyst": "OH",
    "dropphyzpp": 457601181,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEPORT",
    "dropmalst": "OH",
    "dropmalzpp": 457609998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409925131,
    "dropsitcph": 7409925131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21882",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "320 N VERITY PKWY",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "OH",
    "dropdelzpp": 450429998,
    "dropphyadd": "320 N VERITY PKWY",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "OH",
    "dropphyzpp": 450429998,
    "dropmaladd": "320 N VERITY PKWY",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "OH",
    "dropmalzpp": 450429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5134226317,
    "dropsitcph": 5134226317,
    "dropfax": 5134225234
  },
  {
    "dcode": "D",
    "dropkey": "PX21890",
    "droptype": "D",
    "dropname": "MIDVALE",
    "dropdeladd": "3096 BARNHILL RD",
    "dropdelcty": "MIDVALE",
    "dropdelst": "OH",
    "dropdelzpp": 446539800,
    "dropphyadd": "3096 BARNHILL RD",
    "dropphycty": "MIDVALE",
    "dropphyst": "OH",
    "dropphyzpp": 446539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDVALE",
    "dropmalst": "OH",
    "dropmalzpp": 446539998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303391949,
    "dropfax": 3303391949
  },
  {
    "dcode": "D",
    "dropkey": "PX21894",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "11 E CHURCH ST",
    "dropdelcty": "MILAN",
    "dropdelst": "OH",
    "dropdelzpp": 448469801,
    "dropphyadd": "11 E CHURCH ST",
    "dropphycty": "MILAN",
    "dropphyst": "OH",
    "dropphyzpp": 448469801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILAN",
    "dropmalst": "OH",
    "dropmalzpp": 448469998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194992431,
    "dropfax": 4194992431
  },
  {
    "dcode": "D",
    "dropkey": "PX21895",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "100 CASTLEBERRY CT",
    "dropdelcty": "MILFORD",
    "dropdelst": "OH",
    "dropdelzpp": 451509998,
    "dropphyadd": "100 CASTLEBERRY CT",
    "dropphycty": "MILFORD",
    "dropphyst": "OH",
    "dropphyzpp": 451509998,
    "dropmaladd": "100 CASTLEBERRY CT",
    "dropmalcty": "MILFORD",
    "dropmalst": "OH",
    "dropmalzpp": 451509998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138332563,
    "dropsitcph": 5138332563,
    "dropfax": 5138312945
  },
  {
    "dcode": "D",
    "dropkey": "PX21896",
    "droptype": "D",
    "dropname": "MILFORD CENTER",
    "dropdeladd": "21 E STATE ST",
    "dropdelcty": "MILFORD CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 430459003,
    "dropphyadd": "21 E STATE ST",
    "dropphycty": "MILFORD CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 430459003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILFORD CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 430459998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373492061,
    "dropsitcph": 9373492061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21897",
    "droptype": "D",
    "dropname": "MILLBURY",
    "dropdeladd": "28506 MAIN ST",
    "dropdelcty": "MILLBURY",
    "dropdelst": "OH",
    "dropdelzpp": 434479998,
    "dropphyadd": "28506 MAIN ST",
    "dropphycty": "MILLBURY",
    "dropphyst": "OH",
    "dropphyzpp": 434479998,
    "dropmaladd": "28506 MAIN ST",
    "dropmalcty": "MILLBURY",
    "dropmalst": "OH",
    "dropmalzpp": 434479998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198369147,
    "dropsitcph": 4198369147,
    "dropfax": 4198368846
  },
  {
    "dcode": "D",
    "dropkey": "PX21898",
    "droptype": "D",
    "dropname": "MILLEDGEVILLE",
    "dropdeladd": "8118 CHURCH ST",
    "dropdelcty": "MILLEDGEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431429900,
    "dropphyadd": "8118 CHURCH ST",
    "dropphycty": "MILLEDGEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431429900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLEDGEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431429998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409482589,
    "dropsitcph": 7409482589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21900",
    "droptype": "D",
    "dropname": "MILLER CITY",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "MILLER CITY",
    "dropdelst": "OH",
    "dropdelzpp": 458649998,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "MILLER CITY",
    "dropphyst": "OH",
    "dropphyzpp": 458649998,
    "dropmaladd": "108 S MAIN ST",
    "dropmalcty": "MILLER CITY",
    "dropmalst": "OH",
    "dropmalzpp": 458649998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198763505,
    "dropsitcph": 4198763505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21902",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "56 S WASHINGTON ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 446549998,
    "dropphyadd": "56 S WASHINGTON ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 446549998,
    "dropmaladd": "56 S WASHINGTON ST",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 446549998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306745846,
    "dropfax": 3306745846
  },
  {
    "dcode": "D",
    "dropkey": "PX21903",
    "droptype": "D",
    "dropname": "MILLERSPORT",
    "dropdeladd": "12050 LANCASTER ST",
    "dropdelcty": "MILLERSPORT",
    "dropdelst": "OH",
    "dropdelzpp": 430469032,
    "dropphyadd": "12050 LANCASTER ST",
    "dropphycty": "MILLERSPORT",
    "dropphyst": "OH",
    "dropphyzpp": 430469032,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLERSPORT",
    "dropmalst": "OH",
    "dropmalzpp": 430469998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404672477,
    "dropsitcph": 7404672477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21907",
    "droptype": "D",
    "dropname": "MILLFIELD",
    "dropdeladd": "16099 MAIN ST",
    "dropdelcty": "MILLFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 457619998,
    "dropphyadd": "16099 MAIN ST",
    "dropphycty": "MILLFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 457619998,
    "dropmaladd": "16099 MAIN ST",
    "dropmalcty": "MILLFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 457619998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407972666,
    "dropsitcph": 7407972666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21919",
    "droptype": "D",
    "dropname": "MINERAL CITY",
    "dropdeladd": "8618 N HIGH ST",
    "dropdelcty": "MINERAL CITY",
    "dropdelst": "OH",
    "dropdelzpp": 446569800,
    "dropphyadd": "8618 N HIGH ST",
    "dropphycty": "MINERAL CITY",
    "dropphyst": "OH",
    "dropphyzpp": 446569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINERAL CITY",
    "dropmalst": "OH",
    "dropmalzpp": 446569998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308592114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21923",
    "droptype": "D",
    "dropname": "MINERVA",
    "dropdeladd": "112 W HIGH ST",
    "dropdelcty": "MINERVA",
    "dropdelst": "OH",
    "dropdelzpp": 446579998,
    "dropphyadd": "112 W HIGH ST",
    "dropphycty": "MINERVA",
    "dropphyst": "OH",
    "dropphyzpp": 446579998,
    "dropmaladd": "112 W HIGH ST",
    "dropmalcty": "MINERVA",
    "dropmalst": "OH",
    "dropmalzpp": 446579998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308685130,
    "dropfax": 3308684429
  },
  {
    "dcode": "D",
    "dropkey": "PX21925",
    "droptype": "D",
    "dropname": "MINFORD",
    "dropdeladd": "10623 STATE ROUTE 139",
    "dropdelcty": "MINFORD",
    "dropdelst": "OH",
    "dropdelzpp": 456538545,
    "dropphyadd": "10623 STATE ROUTE 139",
    "dropphycty": "MINFORD",
    "dropphyst": "OH",
    "dropphyzpp": 456538545,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINFORD",
    "dropmalst": "OH",
    "dropmalzpp": 456539998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408203704,
    "dropsitcph": 7408203704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21928",
    "droptype": "D",
    "dropname": "MINGO JUNCTION",
    "dropdeladd": "679 COMMERCIAL ST",
    "dropdelcty": "MINGO JUNCTION",
    "dropdelst": "OH",
    "dropdelzpp": 439389998,
    "dropphyadd": "679 COMMERCIAL ST",
    "dropphycty": "MINGO JUNCTION",
    "dropphyst": "OH",
    "dropphyzpp": 439389998,
    "dropmaladd": "679 COMMERCIAL ST",
    "dropmalcty": "MINGO JUNCTION",
    "dropmalst": "OH",
    "dropmalzpp": 439389998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405351259,
    "dropsitcph": 7405351259,
    "dropfax": 7405350411
  },
  {
    "dcode": "D",
    "dropkey": "PX21930",
    "droptype": "D",
    "dropname": "MINSTER",
    "dropdeladd": "62 E 4TH ST",
    "dropdelcty": "MINSTER",
    "dropdelst": "OH",
    "dropdelzpp": 458659998,
    "dropphyadd": "62 E 4TH ST",
    "dropphycty": "MINSTER",
    "dropphyst": "OH",
    "dropphyzpp": 458659998,
    "dropmaladd": "62 E 4TH ST",
    "dropmalcty": "MINSTER",
    "dropmalst": "OH",
    "dropmalzpp": 458659998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196283538,
    "dropsitcph": 4196283538,
    "dropfax": 4196283355
  },
  {
    "dcode": "D",
    "dropkey": "PX21933",
    "droptype": "D",
    "dropname": "MOGADORE",
    "dropdeladd": "3993 MOGADORE RD",
    "dropdelcty": "MOGADORE",
    "dropdelst": "OH",
    "dropdelzpp": 442609998,
    "dropphyadd": "3993 MOGADORE RD",
    "dropphycty": "MOGADORE",
    "dropphyst": "OH",
    "dropphyzpp": 442609998,
    "dropmaladd": "3993 MOGADORE RD",
    "dropmalcty": "MOGADORE",
    "dropmalst": "OH",
    "dropmalzpp": 442609998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306289642,
    "dropfax": 3306289642
  },
  {
    "dcode": "D",
    "dropkey": "PX21937",
    "droptype": "D",
    "dropname": "MONCLOVA",
    "dropdeladd": "7959 MONCLOVA RD",
    "dropdelcty": "MONCLOVA",
    "dropdelst": "OH",
    "dropdelzpp": 435429998,
    "dropphyadd": "7959 MONCLOVA RD",
    "dropphycty": "MONCLOVA",
    "dropphyst": "OH",
    "dropphyzpp": 435429998,
    "dropmaladd": "7959 MONCLOVA RD",
    "dropmalcty": "MONCLOVA",
    "dropmalst": "OH",
    "dropmalzpp": 435429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198657061,
    "dropsitcph": 4198657061,
    "dropfax": 4198637589
  },
  {
    "dcode": "D",
    "dropkey": "PX21944",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "301 S MAIN ST",
    "dropdelcty": "MONROE",
    "dropdelst": "OH",
    "dropdelzpp": 450509998,
    "dropphyadd": "301 S MAIN ST",
    "dropphycty": "MONROE",
    "dropphyst": "OH",
    "dropphyzpp": 450509998,
    "dropmaladd": "301 S MAIN ST",
    "dropmalcty": "MONROE",
    "dropmalst": "OH",
    "dropmalzpp": 450509998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135391086,
    "dropsitcph": 5135391086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21949",
    "droptype": "D",
    "dropname": "MONROEVILLE",
    "dropdeladd": "10 N MAIN ST",
    "dropdelcty": "MONROEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448479801,
    "dropphyadd": "10 N MAIN ST",
    "dropphycty": "MONROEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448479801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONROEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448479998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194652004,
    "dropfax": 4194652004
  },
  {
    "dcode": "D",
    "dropkey": "PX21950",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "99 W MAIN ST",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "OH",
    "dropdelzpp": 458669998,
    "dropphyadd": "99 W MAIN ST",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "OH",
    "dropphyzpp": 458669998,
    "dropmaladd": "99 W MAIN ST",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "OH",
    "dropmalzpp": 458669998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192682115,
    "dropsitcph": 4192682115,
    "dropfax": 4192680073
  },
  {
    "dcode": "D",
    "dropkey": "PX21953",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "209 EMPIRE ST",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "OH",
    "dropdelzpp": 435431366,
    "dropphyadd": "209 EMPIRE ST",
    "dropphycty": "MONTPELIER",
    "dropphyst": "OH",
    "dropphyzpp": 435431366,
    "dropmaladd": "209 EMPIRE ST",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "OH",
    "dropmalzpp": 435431366,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194853989,
    "dropsitcph": 4194853989,
    "dropfax": 4194853989
  },
  {
    "dcode": "D",
    "dropkey": "PX21954",
    "droptype": "D",
    "dropname": "MONTVILLE",
    "dropdeladd": "16576 GAR HWY",
    "dropdelcty": "MONTVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440648743,
    "dropphyadd": "16576 GAR HWY",
    "dropphycty": "MONTVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440648743,
    "dropmaladd": "16576 GAR HWY",
    "dropmalcty": "MONTVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440648743,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409683297,
    "dropfax": 4409683451
  },
  {
    "dcode": "D",
    "dropkey": "PX21965",
    "droptype": "D",
    "dropname": "MORRAL",
    "dropdeladd": "150 W NEFF ST",
    "dropdelcty": "MORRAL",
    "dropdelst": "OH",
    "dropdelzpp": 433379381,
    "dropphyadd": "150 W NEFF ST",
    "dropphycty": "MORRAL",
    "dropphyst": "OH",
    "dropphyzpp": 433379381,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRAL",
    "dropmalst": "OH",
    "dropmalzpp": 433379998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404652781,
    "dropsitcph": 7404652781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21967",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "126 E MAIN ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 437599900,
    "dropphyadd": "126 E MAIN ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 437599900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 437599998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407821080,
    "dropsitcph": 7407821080,
    "dropfax": 7407821619
  },
  {
    "dcode": "D",
    "dropkey": "PX21968",
    "droptype": "D",
    "dropname": "MORROW",
    "dropdeladd": "531 W PIKE ST",
    "dropdelcty": "MORROW",
    "dropdelst": "OH",
    "dropdelzpp": 451529998,
    "dropphyadd": "531 W PIKE ST",
    "dropphycty": "MORROW",
    "dropphyst": "OH",
    "dropphyzpp": 451529998,
    "dropmaladd": "531 W PIKE ST",
    "dropmalcty": "MORROW",
    "dropmalst": "OH",
    "dropmalzpp": 451529998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138993609,
    "dropsitcph": 5138993609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21969",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "30 WELLS ST",
    "dropdelcty": "MOSCOW",
    "dropdelst": "OH",
    "dropdelzpp": 451539998,
    "dropphyadd": "30 WELLS ST",
    "dropphycty": "MOSCOW",
    "dropphyst": "OH",
    "dropphyzpp": 451539998,
    "dropmaladd": "30 WELLS ST",
    "dropmalcty": "MOSCOW",
    "dropmalst": "OH",
    "dropmalzpp": 451539998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135533223,
    "dropsitcph": 5135533223,
    "dropfax": 5135533223
  },
  {
    "dcode": "D",
    "dropkey": "PX21977",
    "droptype": "D",
    "dropname": "MOUNT BLANCHARD",
    "dropdeladd": "121 N MAIN ST",
    "dropdelcty": "MOUNT BLANCHARD",
    "dropdelst": "OH",
    "dropdelzpp": 458679998,
    "dropphyadd": "121 N MAIN ST",
    "dropphycty": "MOUNT BLANCHARD",
    "dropphyst": "OH",
    "dropphyzpp": 458679998,
    "dropmaladd": "121 N MAIN ST",
    "dropmalcty": "MOUNT BLANCHARD",
    "dropmalst": "OH",
    "dropmalzpp": 458679998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196943505,
    "dropsitcph": 4196943505,
    "dropfax": 4196941305
  },
  {
    "dcode": "D",
    "dropkey": "PX21979",
    "droptype": "D",
    "dropname": "MOUNT CORY",
    "dropdeladd": "209 LINCOLN ST",
    "dropdelcty": "MOUNT CORY",
    "dropdelst": "OH",
    "dropdelzpp": 458689998,
    "dropphyadd": "209 LINCOLN ST",
    "dropphycty": "MOUNT CORY",
    "dropphyst": "OH",
    "dropphyzpp": 458689998,
    "dropmaladd": "209 LINCOLN ST",
    "dropmalcty": "MOUNT CORY",
    "dropmalst": "OH",
    "dropmalzpp": 458689998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194775336,
    "dropsitcph": 4194775336,
    "dropfax": 4194775337
  },
  {
    "dcode": "D",
    "dropkey": "PX21980",
    "droptype": "D",
    "dropname": "MOUNT EATON",
    "dropdeladd": "15924 MAIN ST",
    "dropdelcty": "MOUNT EATON",
    "dropdelst": "OH",
    "dropdelzpp": 446599800,
    "dropphyadd": "15924 MAIN ST",
    "dropphycty": "MOUNT EATON",
    "dropphyst": "OH",
    "dropphyzpp": 446599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT EATON",
    "dropmalst": "OH",
    "dropmalzpp": 446599998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303595514,
    "dropfax": 3303595514
  },
  {
    "dcode": "D",
    "dropkey": "PX21982",
    "droptype": "D",
    "dropname": "MOUNT GILEAD",
    "dropdeladd": "37 W HIGH ST",
    "dropdelcty": "MOUNT GILEAD",
    "dropdelst": "OH",
    "dropdelzpp": 433389998,
    "dropphyadd": "37 W HIGH ST",
    "dropphycty": "MOUNT GILEAD",
    "dropphyst": "OH",
    "dropphyzpp": 433389998,
    "dropmaladd": "37 W HIGH ST",
    "dropmalcty": "MOUNT GILEAD",
    "dropmalst": "OH",
    "dropmalzpp": 433389998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4199465846,
    "dropsitcph": 4199465846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21985",
    "droptype": "D",
    "dropname": "MOUNT HOPE",
    "dropdeladd": "7834 COUNTY ROAD 77",
    "dropdelcty": "MOUNT HOPE",
    "dropdelst": "OH",
    "dropdelzpp": 446609800,
    "dropphyadd": "7834 COUNTY ROAD 77",
    "dropphycty": "MOUNT HOPE",
    "dropphyst": "OH",
    "dropphyzpp": 446609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT HOPE",
    "dropmalst": "OH",
    "dropmalzpp": 446609998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306746168,
    "dropfax": 3306746168
  },
  {
    "dcode": "D",
    "dropkey": "PX21987",
    "droptype": "D",
    "dropname": "MOUNT LIBERTY",
    "dropdeladd": "7088 COLUMBUS RD",
    "dropdelcty": "MOUNT LIBERTY",
    "dropdelst": "OH",
    "dropdelzpp": 430488000,
    "dropphyadd": "7088 COLUMBUS RD",
    "dropphycty": "MOUNT LIBERTY",
    "dropphyst": "OH",
    "dropphyzpp": 430488000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT LIBERTY",
    "dropmalst": "OH",
    "dropmalzpp": 430489998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406255789,
    "dropsitcph": 7406255789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21990",
    "droptype": "D",
    "dropname": "MOUNT ORAB",
    "dropdeladd": "202 E MAIN ST",
    "dropdelcty": "MOUNT ORAB",
    "dropdelst": "OH",
    "dropdelzpp": 451549998,
    "dropphyadd": "202 E MAIN ST",
    "dropphycty": "MOUNT ORAB",
    "dropphyst": "OH",
    "dropphyzpp": 451549998,
    "dropmaladd": "202 E MAIN ST",
    "dropmalcty": "MOUNT ORAB",
    "dropmalst": "OH",
    "dropmalzpp": 451549998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5134449366,
    "dropsitcph": 9374449366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX21995",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "243 UNION ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "OH",
    "dropdelzpp": 439399800,
    "dropphyadd": "243 UNION ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "OH",
    "dropphyzpp": 439399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "OH",
    "dropmalzpp": 439399998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407697907,
    "dropsitcph": 7407697907,
    "dropfax": 7407697907
  },
  {
    "dcode": "D",
    "dropkey": "PX21999",
    "droptype": "D",
    "dropname": "MOUNT STERLING",
    "dropdeladd": "34 W COLUMBUS ST",
    "dropdelcty": "MOUNT STERLING",
    "dropdelst": "OH",
    "dropdelzpp": 431439998,
    "dropphyadd": "34 W COLUMBUS ST",
    "dropphycty": "MOUNT STERLING",
    "dropphyst": "OH",
    "dropphyzpp": 431439998,
    "dropmaladd": "34 W COLUMBUS ST",
    "dropmalcty": "MOUNT STERLING",
    "dropmalst": "OH",
    "dropmalzpp": 431439998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408692545,
    "dropsitcph": 7408692545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22002",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "101 W HIGH ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "OH",
    "dropdelzpp": 430502468,
    "dropphyadd": "101 W HIGH ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "OH",
    "dropphyzpp": 430502468,
    "dropmaladd": "101 W HIGH ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "OH",
    "dropmalzpp": 430502468,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403928006,
    "dropsitcph": 7403928006,
    "dropfax": 7403920674
  },
  {
    "dcode": "D",
    "dropkey": "PX22004",
    "droptype": "D",
    "dropname": "MOUNT VICTORY",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "MOUNT VICTORY",
    "dropdelst": "OH",
    "dropdelzpp": 433408936,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "MOUNT VICTORY",
    "dropphyst": "OH",
    "dropphyzpp": 433408936,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT VICTORY",
    "dropmalst": "OH",
    "dropmalzpp": 433409998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373544081,
    "dropsitcph": 9373544081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22008",
    "droptype": "D",
    "dropname": "MOWRYSTOWN",
    "dropdeladd": "2 W MAIN ST",
    "dropdelcty": "MOWRYSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 451559998,
    "dropphyadd": "2 W MAIN ST",
    "dropphycty": "MOWRYSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 451559998,
    "dropmaladd": "2 W MAIN ST",
    "dropmalcty": "MOWRYSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 451559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374422333,
    "dropsitcph": 9374422333,
    "dropfax": 9374421007
  },
  {
    "dcode": "D",
    "dropkey": "PX22010",
    "droptype": "D",
    "dropname": "MOXAHALA",
    "dropdeladd": "3310 STATE ROUTE 13 SE",
    "dropdelcty": "MOXAHALA",
    "dropdelst": "OH",
    "dropdelzpp": 437619900,
    "dropphyadd": "3310 STATE ROUTE 13 SE",
    "dropphycty": "MOXAHALA",
    "dropphyst": "OH",
    "dropphyzpp": 437619900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOXAHALA",
    "dropmalst": "OH",
    "dropmalzpp": 437619998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403424281,
    "dropsitcph": 7403424281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22029",
    "droptype": "D",
    "dropname": "MUNROE FALLS",
    "dropdeladd": "38 S MAIN ST",
    "dropdelcty": "MUNROE FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 442629998,
    "dropphyadd": "38 S MAIN ST",
    "dropphycty": "MUNROE FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 442629998,
    "dropmaladd": "38 S MAIN ST",
    "dropmalcty": "MUNROE FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 442629998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306881161,
    "dropfax": 3306881161
  },
  {
    "dcode": "D",
    "dropkey": "PX22032",
    "droptype": "D",
    "dropname": "MURRAY CITY",
    "dropdeladd": "13990 LOCUST ST",
    "dropdelcty": "MURRAY CITY",
    "dropdelst": "OH",
    "dropdelzpp": 431449900,
    "dropphyadd": "13990 LOCUST ST",
    "dropphycty": "MURRAY CITY",
    "dropphyst": "OH",
    "dropphyzpp": 431449900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURRAY CITY",
    "dropmalst": "OH",
    "dropmalzpp": 431449998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407622340,
    "dropsitcph": 7407622340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22051",
    "droptype": "D",
    "dropname": "NANKIN",
    "dropdeladd": "953 STATE ROUTE 58",
    "dropdelcty": "NANKIN",
    "dropdelst": "OH",
    "dropdelzpp": 448489800,
    "dropphyadd": "953 STATE ROUTE 58",
    "dropphycty": "NANKIN",
    "dropphyst": "OH",
    "dropphyzpp": 448489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NANKIN",
    "dropmalst": "OH",
    "dropmalzpp": 448489998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4192898984,
    "dropfax": 4192819534
  },
  {
    "dcode": "D",
    "dropkey": "PX22052",
    "droptype": "D",
    "dropname": "NAPOLEON",
    "dropdeladd": "206 W WASHINGTON ST",
    "dropdelcty": "NAPOLEON",
    "dropdelst": "OH",
    "dropdelzpp": 435451773,
    "dropphyadd": "206 W WASHINGTON ST",
    "dropphycty": "NAPOLEON",
    "dropphyst": "OH",
    "dropphyzpp": 435451773,
    "dropmaladd": "206 W WASHINGTON ST",
    "dropmalcty": "NAPOLEON",
    "dropmalst": "OH",
    "dropmalzpp": 435451773,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195921811,
    "dropsitcph": 4195921811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22053",
    "droptype": "D",
    "dropname": "NASHPORT",
    "dropdeladd": "7764 OBANNON RD",
    "dropdelcty": "NASHPORT",
    "dropdelst": "OH",
    "dropdelzpp": 438309418,
    "dropphyadd": "7764 OBANNON RD",
    "dropphycty": "NASHPORT",
    "dropphyst": "OH",
    "dropphyzpp": 438309418,
    "dropmaladd": "7764 OBANNON RD",
    "dropmalcty": "NASHPORT",
    "dropmalst": "OH",
    "dropmalzpp": 438309418,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 7408282784,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22054",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "111 W MILLERSBURG ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446619800,
    "dropphyadd": "111 W MILLERSBURG ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446619998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303782666,
    "dropfax": 3303782038
  },
  {
    "dcode": "D",
    "dropkey": "PX22057",
    "droptype": "D",
    "dropname": "NAVARRE",
    "dropdeladd": "33 CANAL ST W",
    "dropdelcty": "NAVARRE",
    "dropdelst": "OH",
    "dropdelzpp": 446629998,
    "dropphyadd": "33 CANAL ST W",
    "dropphycty": "NAVARRE",
    "dropphyst": "OH",
    "dropphyzpp": 446629998,
    "dropmaladd": "33 CANAL ST W",
    "dropmalcty": "NAVARRE",
    "dropmalst": "OH",
    "dropmalzpp": 446629998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308795050,
    "dropfax": 3308795601
  },
  {
    "dcode": "D",
    "dropkey": "PX22059",
    "droptype": "D",
    "dropname": "NEAPOLIS",
    "dropdeladd": "8250 MAIN ST",
    "dropdelcty": "NEAPOLIS",
    "dropdelst": "OH",
    "dropdelzpp": 435479998,
    "dropphyadd": "8250 MAIN ST",
    "dropphycty": "NEAPOLIS",
    "dropphyst": "OH",
    "dropphyzpp": 435479998,
    "dropmaladd": "8250 MAIN ST",
    "dropmalcty": "NEAPOLIS",
    "dropmalst": "OH",
    "dropmalzpp": 435479998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198756879,
    "dropsitcph": 4198756879,
    "dropfax": 4198756879
  },
  {
    "dcode": "D",
    "dropkey": "PX22061",
    "droptype": "D",
    "dropname": "NEFFS",
    "dropdeladd": "54061 PIKE ST",
    "dropdelcty": "NEFFS",
    "dropdelst": "OH",
    "dropdelzpp": 439409800,
    "dropphyadd": "54061 PIKE ST",
    "dropphycty": "NEFFS",
    "dropphyst": "OH",
    "dropphyzpp": 439409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEFFS",
    "dropmalst": "OH",
    "dropmalzpp": 439409998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406719161,
    "dropsitcph": 7406719161,
    "dropfax": 7406719161
  },
  {
    "dcode": "D",
    "dropkey": "PX22062",
    "droptype": "D",
    "dropname": "NEGLEY",
    "dropdeladd": "7560 COMMERCE ST",
    "dropdelcty": "NEGLEY",
    "dropdelst": "OH",
    "dropdelzpp": 444419800,
    "dropphyadd": "7560 COMMERCE ST",
    "dropphycty": "NEGLEY",
    "dropphyst": "OH",
    "dropphyzpp": 444419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEGLEY",
    "dropmalst": "OH",
    "dropmalzpp": 444419998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304264350,
    "dropsitcph": 3304264350,
    "dropfax": 3304260708
  },
  {
    "dcode": "D",
    "dropkey": "PX22066",
    "droptype": "D",
    "dropname": "NELSONVILLE",
    "dropdeladd": "110 W WASHINGTON ST",
    "dropdelcty": "NELSONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457641180,
    "dropphyadd": "110 W WASHINGTON ST",
    "dropphycty": "NELSONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457641180,
    "dropmaladd": "110 W WASHINGTON ST",
    "dropmalcty": "NELSONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457641180,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407533165,
    "dropsitcph": 7407533165,
    "dropfax": 7407539045
  },
  {
    "dcode": "D",
    "dropkey": "PX22068",
    "droptype": "D",
    "dropname": "NEVADA",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "NEVADA",
    "dropdelst": "OH",
    "dropdelzpp": 448499800,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "NEVADA",
    "dropphyst": "OH",
    "dropphyzpp": 448499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEVADA",
    "dropmalst": "OH",
    "dropmalzpp": 448499998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7404822020,
    "dropfax": 7404822020
  },
  {
    "dcode": "D",
    "dropkey": "PX22069",
    "droptype": "D",
    "dropname": "NEVILLE",
    "dropdeladd": "406 MAIN ST",
    "dropdelcty": "NEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451569998,
    "dropphyadd": "406 MAIN ST",
    "dropphycty": "NEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451569998,
    "dropmaladd": "406 MAIN ST",
    "dropmalcty": "NEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138764120,
    "dropsitcph": 5138764120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22072",
    "droptype": "D",
    "dropname": "NEW ALBANY",
    "dropdeladd": "102 W MAIN ST",
    "dropdelcty": "NEW ALBANY",
    "dropdelst": "OH",
    "dropdelzpp": 430549142,
    "dropphyadd": "102 W MAIN ST",
    "dropphycty": "NEW ALBANY",
    "dropphyst": "OH",
    "dropphyzpp": 430549142,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ALBANY",
    "dropmalst": "OH",
    "dropmalzpp": 430549998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148557139,
    "dropsitcph": 7406995001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22076",
    "droptype": "D",
    "dropname": "NEW ATHENS",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "NEW ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 439819800,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "NEW ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 439819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 439819998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409683993,
    "dropsitcph": 7409683993,
    "dropfax": 7409681423
  },
  {
    "dcode": "D",
    "dropkey": "PX22078",
    "droptype": "D",
    "dropname": "NEW BAVARIA",
    "dropdeladd": "867 WALNUT ST",
    "dropdelcty": "NEW BAVARIA",
    "dropdelst": "OH",
    "dropdelzpp": 435489998,
    "dropphyadd": "867 WALNUT ST",
    "dropphycty": "NEW BAVARIA",
    "dropphyst": "OH",
    "dropphyzpp": 435489998,
    "dropmaladd": "867 WALNUT ST",
    "dropmalcty": "NEW BAVARIA",
    "dropmalst": "OH",
    "dropmalzpp": 435489998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196551063,
    "dropsitcph": 4196551063,
    "dropfax": 4196551061
  },
  {
    "dcode": "D",
    "dropkey": "PX22081",
    "droptype": "D",
    "dropname": "NEW BLOOMINGTON",
    "dropdeladd": "160 S MAIN ST",
    "dropdelcty": "NEW BLOOMINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 433419582,
    "dropphyadd": "160 S MAIN ST",
    "dropphycty": "NEW BLOOMINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 433419582,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW BLOOMINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 433419998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404992801,
    "dropsitcph": 7404992801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22083",
    "droptype": "D",
    "dropname": "NEW BREMEN",
    "dropdeladd": "111 N MAIN ST",
    "dropdelcty": "NEW BREMEN",
    "dropdelst": "OH",
    "dropdelzpp": 458699998,
    "dropphyadd": "111 N MAIN ST",
    "dropphycty": "NEW BREMEN",
    "dropphyst": "OH",
    "dropphyzpp": 458699998,
    "dropmaladd": "111 N MAIN ST",
    "dropmalcty": "NEW BREMEN",
    "dropmalst": "OH",
    "dropmalzpp": 458699998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196293384,
    "dropsitcph": 4196293384,
    "dropfax": 4196290404
  },
  {
    "dcode": "D",
    "dropkey": "PX22085",
    "droptype": "D",
    "dropname": "NEW CARLISLE",
    "dropdeladd": "107 W LAKE AVE",
    "dropdelcty": "NEW CARLISLE",
    "dropdelst": "OH",
    "dropdelzpp": 453449998,
    "dropphyadd": "107 W LAKE AVE",
    "dropphycty": "NEW CARLISLE",
    "dropphyst": "OH",
    "dropphyzpp": 453449998,
    "dropmaladd": "107 W LAKE AVE",
    "dropmalcty": "NEW CARLISLE",
    "dropmalst": "OH",
    "dropmalzpp": 453449998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378453876,
    "dropsitcph": 9378453876,
    "dropfax": 9378453277
  },
  {
    "dcode": "D",
    "dropkey": "PX22088",
    "droptype": "D",
    "dropname": "NEW CONCORD",
    "dropdeladd": "61 W MAIN ST",
    "dropdelcty": "NEW CONCORD",
    "dropdelst": "OH",
    "dropdelzpp": 437629998,
    "dropphyadd": "61 W MAIN ST",
    "dropphycty": "NEW CONCORD",
    "dropphyst": "OH",
    "dropphyzpp": 437629998,
    "dropmaladd": "61 W MAIN ST",
    "dropmalcty": "NEW CONCORD",
    "dropmalst": "OH",
    "dropmalzpp": 437629998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408264354,
    "dropsitcph": 7408264354,
    "dropfax": 7408267421
  },
  {
    "dcode": "D",
    "dropkey": "PX22098",
    "droptype": "D",
    "dropname": "NEW HAMPSHIRE",
    "dropdeladd": "46 E MARKET ST",
    "dropdelcty": "NEW HAMPSHIRE",
    "dropdelst": "OH",
    "dropdelzpp": 458709998,
    "dropphyadd": "46 E MARKET ST",
    "dropphycty": "NEW HAMPSHIRE",
    "dropphyst": "OH",
    "dropphyzpp": 458709998,
    "dropmaladd": "46 E MARKET ST",
    "dropmalcty": "NEW HAMPSHIRE",
    "dropmalst": "OH",
    "dropmalzpp": 458709998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195685205,
    "dropsitcph": 4195685205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22102",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "3991 CENTER ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "OH",
    "dropdelzpp": 448509800,
    "dropphyadd": "3991 CENTER ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "OH",
    "dropphyzpp": 448509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "OH",
    "dropmalzpp": 448509998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199336021,
    "dropfax": 4199350264
  },
  {
    "dcode": "D",
    "dropkey": "PX22103",
    "droptype": "D",
    "dropname": "NEW HOLLAND",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "NEW HOLLAND",
    "dropdelst": "OH",
    "dropdelzpp": 431459900,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "NEW HOLLAND",
    "dropphyst": "OH",
    "dropphyzpp": 431459900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW HOLLAND",
    "dropmalst": "OH",
    "dropmalzpp": 431459998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404955446,
    "dropsitcph": 7404955446,
    "dropfax": 7404955446
  },
  {
    "dcode": "D",
    "dropkey": "PX22104",
    "droptype": "D",
    "dropname": "NEW KNOXVILLE",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "NEW KNOXVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 458719998,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "NEW KNOXVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 458719998,
    "dropmaladd": "105 S MAIN ST",
    "dropmalcty": "NEW KNOXVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 458719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197802053,
    "dropsitcph": 4197802053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22107",
    "droptype": "D",
    "dropname": "NEW LEBANON",
    "dropdeladd": "77 W MAIN ST",
    "dropdelcty": "NEW LEBANON",
    "dropdelst": "OH",
    "dropdelzpp": 453459998,
    "dropphyadd": "77 W MAIN ST",
    "dropphycty": "NEW LEBANON",
    "dropphyst": "OH",
    "dropphyzpp": 453459998,
    "dropmaladd": "77 W MAIN ST",
    "dropmalcty": "NEW LEBANON",
    "dropmalst": "OH",
    "dropmalzpp": 453459998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376871612,
    "dropsitcph": 9376871612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22108",
    "droptype": "D",
    "dropname": "NEW LEXINGTON",
    "dropdeladd": "200 W BROWN ST",
    "dropdelcty": "NEW LEXINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 437649998,
    "dropphyadd": "200 W BROWN ST",
    "dropphycty": "NEW LEXINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 437649998,
    "dropmaladd": "200 W BROWN ST",
    "dropmalcty": "NEW LEXINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 437649998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403421345,
    "dropsitcph": 7403421345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22109",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "86 E MAIN ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "OH",
    "dropdelzpp": 448519998,
    "dropphyadd": "86 E MAIN ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "OH",
    "dropphyzpp": 448519998,
    "dropmaladd": "86 E MAIN ST",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "OH",
    "dropmalzpp": 448519998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199290761,
    "dropfax": 4199292331
  },
  {
    "dcode": "D",
    "dropkey": "PX22112",
    "droptype": "D",
    "dropname": "NEW MADISON",
    "dropdeladd": "133 N HARRISON ST",
    "dropdelcty": "NEW MADISON",
    "dropdelst": "OH",
    "dropdelzpp": 453469998,
    "dropphyadd": "133 N HARRISON ST",
    "dropphycty": "NEW MADISON",
    "dropphyst": "OH",
    "dropphyzpp": 453469998,
    "dropmaladd": "133 N HARRISON ST",
    "dropmalcty": "NEW MADISON",
    "dropmalst": "OH",
    "dropmalzpp": 453469998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379966100,
    "dropsitcph": 9379966100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22116",
    "droptype": "D",
    "dropname": "NEW MARSHFIELD",
    "dropdeladd": "3996 OLD STATE ROUTE 56",
    "dropdelcty": "NEW MARSHFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 457669997,
    "dropphyadd": "3996 OLD STATE ROUTE 56",
    "dropphycty": "NEW MARSHFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 457669997,
    "dropmaladd": "3996 OLD STATE ROUTE 56",
    "dropmalcty": "NEW MARSHFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 457669997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406644981,
    "dropsitcph": 7406644981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22118",
    "droptype": "D",
    "dropname": "NEW MATAMORAS",
    "dropdeladd": "515 2ND ST",
    "dropdelcty": "NEW MATAMORAS",
    "dropdelst": "OH",
    "dropdelzpp": 457676381,
    "dropphyadd": "515 2ND ST",
    "dropphycty": "NEW MATAMORAS",
    "dropphyst": "OH",
    "dropphyzpp": 457676381,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MATAMORAS",
    "dropmalst": "OH",
    "dropmalzpp": 457679998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408655031,
    "dropsitcph": 7408655031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22120",
    "droptype": "D",
    "dropname": "NEW MIDDLETOWN",
    "dropdeladd": "10399 MAIN ST",
    "dropdelcty": "NEW MIDDLETOWN",
    "dropdelst": "OH",
    "dropdelzpp": 444429800,
    "dropphyadd": "10399 MAIN ST",
    "dropphycty": "NEW MIDDLETOWN",
    "dropphyst": "OH",
    "dropphyzpp": 444429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MIDDLETOWN",
    "dropmalst": "OH",
    "dropmalzpp": 444429998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305422320,
    "dropsitcph": 3305422320,
    "dropfax": 3305420279
  },
  {
    "dcode": "D",
    "dropkey": "PX22121",
    "droptype": "D",
    "dropname": "NEW PARIS",
    "dropdeladd": "306 S WASHINGTON ST",
    "dropdelcty": "NEW PARIS",
    "dropdelst": "OH",
    "dropdelzpp": 453479998,
    "dropphyadd": "306 S WASHINGTON ST",
    "dropphycty": "NEW PARIS",
    "dropphyst": "OH",
    "dropphyzpp": 453479998,
    "dropmaladd": "306 S WASHINGTON ST",
    "dropmalcty": "NEW PARIS",
    "dropmalst": "OH",
    "dropmalzpp": 453479998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374371561,
    "dropsitcph": 9374371561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22122",
    "droptype": "D",
    "dropname": "NEW PHILADELPHIA",
    "dropdeladd": "210 N BROADWAY ST",
    "dropdelcty": "NEW PHILADELPHIA",
    "dropdelst": "OH",
    "dropdelzpp": 446639998,
    "dropphyadd": "210 N BROADWAY ST",
    "dropphycty": "NEW PHILADELPHIA",
    "dropphyst": "OH",
    "dropphyzpp": 446639998,
    "dropmaladd": "210 N BROADWAY ST",
    "dropmalcty": "NEW PHILADELPHIA",
    "dropmalst": "OH",
    "dropmalzpp": 446639998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303433135,
    "dropfax": 3303644575
  },
  {
    "dcode": "D",
    "dropkey": "PX22124",
    "droptype": "D",
    "dropname": "NEW PLYMOUTH",
    "dropdeladd": "68197 STATE ROUTE 56",
    "dropdelcty": "NEW PLYMOUTH",
    "dropdelst": "OH",
    "dropdelzpp": 456548821,
    "dropphyadd": "68197 STATE ROUTE 56",
    "dropphycty": "NEW PLYMOUTH",
    "dropphyst": "OH",
    "dropphyzpp": 456548821,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW PLYMOUTH",
    "dropmalst": "OH",
    "dropmalzpp": 456549998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403858455,
    "dropsitcph": 7403858455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22127",
    "droptype": "D",
    "dropname": "NEW RICHMOND",
    "dropdeladd": "501 MARKET ST",
    "dropdelcty": "NEW RICHMOND",
    "dropdelst": "OH",
    "dropdelzpp": 451579998,
    "dropphyadd": "501 MARKET ST",
    "dropphycty": "NEW RICHMOND",
    "dropphyst": "OH",
    "dropphyzpp": 451579998,
    "dropmaladd": "501 MARKET ST",
    "dropmalcty": "NEW RICHMOND",
    "dropmalst": "OH",
    "dropmalzpp": 451579998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135530838,
    "dropsitcph": 5135530838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22128",
    "droptype": "D",
    "dropname": "NEW RIEGEL",
    "dropdeladd": "13 N PERRY ST",
    "dropdelcty": "NEW RIEGEL",
    "dropdelst": "OH",
    "dropdelzpp": 448539800,
    "dropphyadd": "13 N PERRY ST",
    "dropphycty": "NEW RIEGEL",
    "dropphyst": "OH",
    "dropphyzpp": 448539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW RIEGEL",
    "dropmalst": "OH",
    "dropmalzpp": 448539998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195952216,
    "dropfax": 4195952502
  },
  {
    "dcode": "D",
    "dropkey": "PX22132",
    "droptype": "D",
    "dropname": "NEW SPRINGFIELD",
    "dropdeladd": "13813 GRANT ST",
    "dropdelcty": "NEW SPRINGFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 444439800,
    "dropphyadd": "13813 GRANT ST",
    "dropphycty": "NEW SPRINGFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 444439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW SPRINGFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 444439998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305495209,
    "dropsitcph": 3305495209,
    "dropfax": 3305495209
  },
  {
    "dcode": "D",
    "dropkey": "PX22133",
    "droptype": "D",
    "dropname": "NEW STRAITSVILLE",
    "dropdeladd": "214 W MAIN ST",
    "dropdelcty": "NEW STRAITSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437669997,
    "dropphyadd": "214 W MAIN ST",
    "dropphycty": "NEW STRAITSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437669997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW STRAITSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437669998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403941280,
    "dropsitcph": 7403941280,
    "dropfax": 7403943053
  },
  {
    "dcode": "D",
    "dropkey": "PX22134",
    "droptype": "D",
    "dropname": "NEW VIENNA",
    "dropdeladd": "209 W MAIN ST",
    "dropdelcty": "NEW VIENNA",
    "dropdelst": "OH",
    "dropdelzpp": 451599998,
    "dropphyadd": "209 W MAIN ST",
    "dropphycty": "NEW VIENNA",
    "dropphyst": "OH",
    "dropphyzpp": 451599998,
    "dropmaladd": "209 W MAIN ST",
    "dropmalcty": "NEW VIENNA",
    "dropmalst": "OH",
    "dropmalzpp": 451599998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379872222,
    "dropsitcph": 9379872222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22135",
    "droptype": "D",
    "dropname": "NEW WASHINGTON",
    "dropdeladd": "214 W MANSFIELD ST",
    "dropdelcty": "NEW WASHINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 448549800,
    "dropphyadd": "214 W MANSFIELD ST",
    "dropphycty": "NEW WASHINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 448549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW WASHINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 448549998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194922449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22136",
    "droptype": "D",
    "dropname": "NEW WATERFORD",
    "dropdeladd": "3818 W MAIN ST",
    "dropdelcty": "NEW WATERFORD",
    "dropdelst": "OH",
    "dropdelzpp": 444459800,
    "dropphyadd": "3818 W MAIN ST",
    "dropphycty": "NEW WATERFORD",
    "dropphyst": "OH",
    "dropphyzpp": 444459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW WATERFORD",
    "dropmalst": "OH",
    "dropmalzpp": 444459998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304572992,
    "dropsitcph": 3304572992,
    "dropfax": 3304570209
  },
  {
    "dcode": "D",
    "dropkey": "PX22139",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "70 E CHURCH ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "OH",
    "dropdelzpp": 430559998,
    "dropphyadd": "70 E CHURCH ST",
    "dropphycty": "NEWARK",
    "dropphyst": "OH",
    "dropphyzpp": 430559998,
    "dropmaladd": "70 E CHURCH ST",
    "dropmalcty": "NEWARK",
    "dropmalst": "OH",
    "dropmalzpp": 430559998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403454021,
    "dropsitcph": 7403454021,
    "dropfax": 7403499144
  },
  {
    "dcode": "D",
    "dropkey": "PX22145",
    "droptype": "D",
    "dropname": "NEWBURY",
    "dropdeladd": "10756 KINSMAN RD",
    "dropdelcty": "NEWBURY",
    "dropdelst": "OH",
    "dropdelzpp": 440659800,
    "dropphyadd": "10756 KINSMAN RD",
    "dropphycty": "NEWBURY",
    "dropphyst": "OH",
    "dropphyzpp": 440659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWBURY",
    "dropmalst": "OH",
    "dropmalzpp": 440659998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405645844,
    "dropfax": 4405648177
  },
  {
    "dcode": "D",
    "dropkey": "PX22148",
    "droptype": "D",
    "dropname": "NEWCOMERSTOWN",
    "dropdeladd": "133 W CANAL ST",
    "dropdelcty": "NEWCOMERSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 438321197,
    "dropphyadd": "133 W CANAL ST",
    "dropphycty": "NEWCOMERSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 438321197,
    "dropmaladd": "133 W CANAL ST",
    "dropmalcty": "NEWCOMERSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 438321197,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404988166,
    "dropsitcph": 7404988166,
    "dropfax": 7404988166
  },
  {
    "dcode": "D",
    "dropkey": "PX22153",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "19 GREENE ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "OH",
    "dropdelzpp": 457689802,
    "dropphyadd": "19 GREENE ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "OH",
    "dropphyzpp": 457689802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWPORT",
    "dropmalst": "OH",
    "dropmalzpp": 457689998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404732261,
    "dropsitcph": 7404732261,
    "dropfax": 7404732261
  },
  {
    "dcode": "D",
    "dropkey": "PX22156",
    "droptype": "D",
    "dropname": "NEWTON FALLS",
    "dropdeladd": "112 RIDGE RD",
    "dropdelcty": "NEWTON FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 444449998,
    "dropphyadd": "112 RIDGE RD",
    "dropphycty": "NEWTON FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 444449998,
    "dropmaladd": "112 RIDGE RD",
    "dropmalcty": "NEWTON FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 444449998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308721072,
    "dropsitcph": 3308721072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22157",
    "droptype": "D",
    "dropname": "NEWTONSVILLE",
    "dropdeladd": "854 WRIGHT ST",
    "dropdelcty": "NEWTONSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451589998,
    "dropphyadd": "854 WRIGHT ST",
    "dropphycty": "NEWTONSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451589998,
    "dropmaladd": "854 WRIGHT ST",
    "dropmalcty": "NEWTONSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451589998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136256565,
    "dropsitcph": 5136256565,
    "dropfax": 5136256565
  },
  {
    "dcode": "D",
    "dropkey": "PX22162",
    "droptype": "D",
    "dropname": "NEY",
    "dropdeladd": "170 E MAIN ST",
    "dropdelcty": "NEY",
    "dropdelst": "OH",
    "dropdelzpp": 435499998,
    "dropphyadd": "170 E MAIN ST",
    "dropphycty": "NEY",
    "dropphyst": "OH",
    "dropphyzpp": 435499998,
    "dropmaladd": "170 E MAIN ST",
    "dropmalcty": "NEY",
    "dropmalst": "OH",
    "dropmalzpp": 435499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196582330,
    "dropsitcph": 4196582330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22163",
    "droptype": "D",
    "dropname": "NILES",
    "dropdeladd": "43 W PARK AVE",
    "dropdelcty": "NILES",
    "dropdelst": "OH",
    "dropdelzpp": 444469998,
    "dropphyadd": "43 W PARK AVE",
    "dropphycty": "NILES",
    "dropphyst": "OH",
    "dropphyzpp": 444469998,
    "dropmaladd": "43 W PARK AVE",
    "dropmalcty": "NILES",
    "dropmalst": "OH",
    "dropmalzpp": 444469998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306523731,
    "dropsitcph": 3306523731,
    "dropfax": 3306523570
  },
  {
    "dcode": "D",
    "dropkey": "PX22174",
    "droptype": "D",
    "dropname": "NORTH BALTIMORE",
    "dropdeladd": "115 E BROADWAY ST",
    "dropdelcty": "NORTH BALTIMORE",
    "dropdelst": "OH",
    "dropdelzpp": 458729998,
    "dropphyadd": "115 E BROADWAY ST",
    "dropphycty": "NORTH BALTIMORE",
    "dropphyst": "OH",
    "dropphyzpp": 458729998,
    "dropmaladd": "115 E BROADWAY ST",
    "dropmalcty": "NORTH BALTIMORE",
    "dropmalst": "OH",
    "dropmalzpp": 458729998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192572435,
    "dropsitcph": 4192572435,
    "dropfax": 4192573266
  },
  {
    "dcode": "D",
    "dropkey": "PX22175",
    "droptype": "D",
    "dropname": "NORTH BEND",
    "dropdeladd": "135 SYMMES AVE",
    "dropdelcty": "NORTH BEND",
    "dropdelst": "OH",
    "dropdelzpp": 450529998,
    "dropphyadd": "135 SYMMES AVE",
    "dropphycty": "NORTH BEND",
    "dropphyst": "OH",
    "dropphyzpp": 450529998,
    "dropmaladd": "135 SYMMES AVE",
    "dropmalcty": "NORTH BEND",
    "dropmalst": "OH",
    "dropmalzpp": 450529998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139416953,
    "dropsitcph": 5139416953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22176",
    "droptype": "D",
    "dropname": "NORTH BENTON",
    "dropdeladd": "9131 12TH ST",
    "dropdelcty": "NORTH BENTON",
    "dropdelst": "OH",
    "dropdelzpp": 444499800,
    "dropphyadd": "9131 12TH ST",
    "dropphycty": "NORTH BENTON",
    "dropphyst": "OH",
    "dropphyzpp": 444499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BENTON",
    "dropmalst": "OH",
    "dropmalzpp": 444499998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305845427,
    "dropsitcph": 3305845427,
    "dropfax": 3305845427
  },
  {
    "dcode": "D",
    "dropkey": "PX22177",
    "droptype": "D",
    "dropname": "NORTH BLOOMFIELD",
    "dropdeladd": "8829 STATE ROUTE 45",
    "dropdelcty": "NORTH BLOOMFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 444509800,
    "dropphyadd": "8829 STATE ROUTE 45",
    "dropphycty": "NORTH BLOOMFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 444509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BLOOMFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 444509998,
    "dropsitphn": 3309969797,
    "dropsitlph": 4406854443,
    "dropsitcph": 4406854443,
    "dropfax": 3306854302
  },
  {
    "dcode": "D",
    "dropkey": "PX22184",
    "droptype": "D",
    "dropname": "NORTH FAIRFIELD",
    "dropdeladd": "1 N MAIN ST",
    "dropdelcty": "NORTH FAIRFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 448559800,
    "dropphyadd": "1 N MAIN ST",
    "dropphycty": "NORTH FAIRFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 448559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH FAIRFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 448559998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197442300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22185",
    "droptype": "D",
    "dropname": "NORTH GEORGETOWN",
    "dropdeladd": "27416 MAIN ST",
    "dropdelcty": "NORTH GEORGETOWN",
    "dropdelst": "OH",
    "dropdelzpp": 446659800,
    "dropphyadd": "27416 MAIN ST",
    "dropphycty": "NORTH GEORGETOWN",
    "dropphyst": "OH",
    "dropphyzpp": 446659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH GEORGETOWN",
    "dropmalst": "OH",
    "dropmalzpp": 446659998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305257221,
    "dropfax": 3305257221
  },
  {
    "dcode": "D",
    "dropkey": "PX22187",
    "droptype": "D",
    "dropname": "NORTH HAMPTON",
    "dropdeladd": "23 N MAIN ST",
    "dropdelcty": "NORTH HAMPTON",
    "dropdelst": "OH",
    "dropdelzpp": 453499998,
    "dropphyadd": "23 N MAIN ST",
    "dropphycty": "NORTH HAMPTON",
    "dropphyst": "OH",
    "dropphyzpp": 453499998,
    "dropmaladd": "23 N MAIN ST",
    "dropmalcty": "NORTH HAMPTON",
    "dropmalst": "OH",
    "dropmalzpp": 453499998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379641207,
    "dropsitcph": 9379641207,
    "dropfax": 9379641762
  },
  {
    "dcode": "D",
    "dropkey": "PX22192",
    "droptype": "D",
    "dropname": "NORTH JACKSON",
    "dropdeladd": "263 S SALEM WARREN RD",
    "dropdelcty": "NORTH JACKSON",
    "dropdelst": "OH",
    "dropdelzpp": 444519800,
    "dropphyadd": "263 S SALEM WARREN RD",
    "dropphycty": "NORTH JACKSON",
    "dropphyst": "OH",
    "dropphyzpp": 444519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH JACKSON",
    "dropmalst": "OH",
    "dropmalzpp": 444519998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305383865,
    "dropsitcph": 3305383865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22194",
    "droptype": "D",
    "dropname": "NORTH KINGSVILLE",
    "dropdeladd": "2716 E CENTER",
    "dropdelcty": "NORTH KINGSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440689800,
    "dropphyadd": "2716 E CENTER",
    "dropphycty": "NORTH KINGSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH KINGSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440689998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402240430,
    "dropfax": 4402240499
  },
  {
    "dcode": "D",
    "dropkey": "PX22195",
    "droptype": "D",
    "dropname": "NORTH LAWRENCE",
    "dropdeladd": "3930 ALABAMA AVE NW",
    "dropdelcty": "NORTH LAWRENCE",
    "dropdelst": "OH",
    "dropdelzpp": 446669801,
    "dropphyadd": "3930 ALABAMA AVE NW",
    "dropphycty": "NORTH LAWRENCE",
    "dropphyst": "OH",
    "dropphyzpp": 446669801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LAWRENCE",
    "dropmalst": "OH",
    "dropmalzpp": 446669998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308320902,
    "dropfax": 3308320902
  },
  {
    "dcode": "D",
    "dropkey": "PX22196",
    "droptype": "D",
    "dropname": "NORTH LEWISBURG",
    "dropdeladd": "24 E MAPLE ST",
    "dropdelcty": "NORTH LEWISBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430609008,
    "dropphyadd": "24 E MAPLE ST",
    "dropphycty": "NORTH LEWISBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430609008,
    "dropmaladd": "24 E MAPLE ST",
    "dropmalcty": "NORTH LEWISBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430609008,
    "dropsitphn": 6144720674,
    "dropsitlph": 9377472218,
    "dropsitcph": 9377472218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22198",
    "droptype": "D",
    "dropname": "NORTH LIMA",
    "dropdeladd": "11675 SOUTH AVE",
    "dropdelcty": "NORTH LIMA",
    "dropdelst": "OH",
    "dropdelzpp": 444529800,
    "dropphyadd": "11675 SOUTH AVE",
    "dropphycty": "NORTH LIMA",
    "dropphyst": "OH",
    "dropphyzpp": 444529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LIMA",
    "dropmalst": "OH",
    "dropmalzpp": 444529998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305493662,
    "dropsitcph": 3305493662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22201",
    "droptype": "D",
    "dropname": "NORTH OLMSTED",
    "dropdeladd": "28475 LORAIN RD",
    "dropdelcty": "NORTH OLMSTED",
    "dropdelst": "OH",
    "dropdelzpp": 440709998,
    "dropphyadd": "28475 LORAIN RD",
    "dropphycty": "NORTH OLMSTED",
    "dropphyst": "OH",
    "dropphyzpp": 440709998,
    "dropmaladd": "28475 LORAIN RD",
    "dropmalcty": "NORTH OLMSTED",
    "dropmalst": "OH",
    "dropmalzpp": 440709998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407774225,
    "dropfax": 4407770601
  },
  {
    "dcode": "D",
    "dropkey": "PX22209",
    "droptype": "D",
    "dropname": "NORTH STAR",
    "dropdeladd": "4 S MAIN ST",
    "dropdelcty": "NORTH STAR",
    "dropdelst": "OH",
    "dropdelzpp": 453509998,
    "dropphyadd": "4 S MAIN ST",
    "dropphycty": "NORTH STAR",
    "dropphyst": "OH",
    "dropphyzpp": 453509998,
    "dropmaladd": "4 S MAIN ST",
    "dropmalcty": "NORTH STAR",
    "dropmalst": "OH",
    "dropmalzpp": 453509998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373365306,
    "dropsitcph": 4193365306,
    "dropfax": 4193361501
  },
  {
    "dcode": "D",
    "dropkey": "PX22215",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "10377 VALLEY VIEW RD",
    "dropdelcty": "MACEDONIA",
    "dropdelst": "OH",
    "dropdelzpp": 440569998,
    "dropphyadd": "10377 VALLEY VIEW RD",
    "dropphycty": "MACEDONIA",
    "dropphyst": "OH",
    "dropphyzpp": 440569998,
    "dropmaladd": "10377 VALLEY VIEW RD",
    "dropmalcty": "MACEDONIA",
    "dropmalst": "OH",
    "dropmalzpp": 440569998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 3304671076,
    "dropfax": 3304678173
  },
  {
    "dcode": "D",
    "dropkey": "PX22229",
    "droptype": "D",
    "dropname": "NORWALK",
    "dropdeladd": "16 WHITTLESEY AVE",
    "dropdelcty": "NORWALK",
    "dropdelst": "OH",
    "dropdelzpp": 448579998,
    "dropphyadd": "16 WHITTLESEY AVE",
    "dropphycty": "NORWALK",
    "dropphyst": "OH",
    "dropphyzpp": 448579998,
    "dropmaladd": "16 WHITTLESEY AVE",
    "dropmalcty": "NORWALK",
    "dropmalst": "OH",
    "dropmalzpp": 448579998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196686555,
    "dropfax": 4196632903
  },
  {
    "dcode": "D",
    "dropkey": "PX22230",
    "droptype": "D",
    "dropname": "NORWICH",
    "dropdeladd": "10445 MAIN ST",
    "dropdelcty": "NORWICH",
    "dropdelst": "OH",
    "dropdelzpp": 437679900,
    "dropphyadd": "10445 MAIN ST",
    "dropphycty": "NORWICH",
    "dropphyst": "OH",
    "dropphyzpp": 437679900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWICH",
    "dropmalst": "OH",
    "dropmalzpp": 437679998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408723532,
    "dropsitcph": 7408723532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22232",
    "droptype": "D",
    "dropname": "NOVA",
    "dropdeladd": "246 STATE ROUTE 511",
    "dropdelcty": "NOVA",
    "dropdelst": "OH",
    "dropdelzpp": 448599800,
    "dropphyadd": "246 STATE ROUTE 511",
    "dropphycty": "NOVA",
    "dropphyst": "OH",
    "dropphyzpp": 448599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOVA",
    "dropmalst": "OH",
    "dropmalzpp": 448599998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196523151,
    "dropfax": 4196523151
  },
  {
    "dcode": "D",
    "dropkey": "PX22233",
    "droptype": "D",
    "dropname": "NOVELTY",
    "dropdeladd": "14837 CHILLICOTHE RD",
    "dropdelcty": "NOVELTY",
    "dropdelst": "OH",
    "dropdelzpp": 440729998,
    "dropphyadd": "14837 CHILLICOTHE RD",
    "dropphycty": "NOVELTY",
    "dropphyst": "OH",
    "dropphyzpp": 440729998,
    "dropmaladd": "14837 CHILLICOTHE RD",
    "dropmalcty": "NOVELTY",
    "dropmalst": "OH",
    "dropmalzpp": 440729998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403383746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22248",
    "droptype": "D",
    "dropname": "OAK HARBOR",
    "dropdeladd": "126 N CHURCH ST",
    "dropdelcty": "OAK HARBOR",
    "dropdelst": "OH",
    "dropdelzpp": 434491353,
    "dropphyadd": "126 N CHURCH ST",
    "dropphycty": "OAK HARBOR",
    "dropphyst": "OH",
    "dropphyzpp": 434491353,
    "dropmaladd": "126 N CHURCH ST",
    "dropmalcty": "OAK HARBOR",
    "dropmalst": "OH",
    "dropmalzpp": 434491353,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198984501,
    "dropsitcph": 4198984501,
    "dropfax": 4198989077
  },
  {
    "dcode": "D",
    "dropkey": "PX22249",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "109 RAILROAD ST",
    "dropdelcty": "OAK HILL",
    "dropdelst": "OH",
    "dropdelzpp": 456569801,
    "dropphyadd": "109 RAILROAD ST",
    "dropphycty": "OAK HILL",
    "dropphyst": "OH",
    "dropphyzpp": 456569801,
    "dropmaladd": "109 RAILROAD ST",
    "dropmalcty": "OAK HILL",
    "dropmalst": "OH",
    "dropmalzpp": 456569801,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406826471,
    "dropsitcph": 7406826471,
    "dropfax": 7406826471
  },
  {
    "dcode": "D",
    "dropkey": "PX22260",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "223 N 1ST ST",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 458739998,
    "dropphyadd": "223 N 1ST ST",
    "dropphycty": "OAKWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 458739998,
    "dropmaladd": "223 N 1ST ST",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 458739998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195943369,
    "dropsitcph": 4195943369,
    "dropfax": 4195943369
  },
  {
    "dcode": "D",
    "dropkey": "PX22264",
    "droptype": "D",
    "dropname": "OBERLIN",
    "dropdeladd": "68 S MAIN ST",
    "dropdelcty": "OBERLIN",
    "dropdelst": "OH",
    "dropdelzpp": 440741645,
    "dropphyadd": "68 S MAIN ST",
    "dropphycty": "OBERLIN",
    "dropphyst": "OH",
    "dropphyzpp": 440741645,
    "dropmaladd": "68 S MAIN ST",
    "dropmalcty": "OBERLIN",
    "dropmalst": "OH",
    "dropmalzpp": 440741645,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4407769847,
    "dropfax": 4407751621
  },
  {
    "dcode": "D",
    "dropkey": "PX22266",
    "droptype": "D",
    "dropname": "OCEOLA",
    "dropdeladd": "3910 MARION MELMORE RD",
    "dropdelcty": "OCEOLA",
    "dropdelst": "OH",
    "dropdelzpp": 448609800,
    "dropphyadd": "3910 MARION MELMORE RD",
    "dropphycty": "OCEOLA",
    "dropphyst": "OH",
    "dropphyzpp": 448609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCEOLA",
    "dropmalst": "OH",
    "dropmalzpp": 448609998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195620898,
    "dropfax": 4195620898
  },
  {
    "dcode": "D",
    "dropkey": "PX22271",
    "droptype": "D",
    "dropname": "OHIO CITY",
    "dropdeladd": "118 S MAIN ST",
    "dropdelcty": "OHIO CITY",
    "dropdelst": "OH",
    "dropdelzpp": 458749998,
    "dropphyadd": "118 S MAIN ST",
    "dropphycty": "OHIO CITY",
    "dropphyst": "OH",
    "dropphyzpp": 458749998,
    "dropmaladd": "118 S MAIN ST",
    "dropmalcty": "OHIO CITY",
    "dropmalst": "OH",
    "dropmalzpp": 458749998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199652015,
    "dropsitcph": 4199652015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22280",
    "droptype": "D",
    "dropname": "OKEANA",
    "dropdeladd": "6179 CINCINNATI BROOKVILLE RD",
    "dropdelcty": "OKEANA",
    "dropdelst": "OH",
    "dropdelzpp": 450539998,
    "dropphyadd": "6179 CINCINNATI BROOKVILLE RD",
    "dropphycty": "OKEANA",
    "dropphyst": "OH",
    "dropphyzpp": 450539998,
    "dropmaladd": "6179 CINCINNATI BROOKVILLE RD",
    "dropmalcty": "OKEANA",
    "dropmalst": "OH",
    "dropmalzpp": 450539998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137385301,
    "dropsitcph": 5137385301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22283",
    "droptype": "D",
    "dropname": "OLD FORT",
    "dropdeladd": "8064 MAIN ST",
    "dropdelcty": "OLD FORT",
    "dropdelst": "OH",
    "dropdelzpp": 448619800,
    "dropphyadd": "8064 MAIN ST",
    "dropphycty": "OLD FORT",
    "dropphyst": "OH",
    "dropphyzpp": 448619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD FORT",
    "dropmalst": "OH",
    "dropmalzpp": 448619998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199924425,
    "dropfax": 4199924426
  },
  {
    "dcode": "D",
    "dropkey": "PX22289",
    "droptype": "D",
    "dropname": "OLD WASHINGTON",
    "dropdeladd": "204 OLD NATIONAL RD",
    "dropdelcty": "OLD WASHINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 437689901,
    "dropphyadd": "204 OLD NATIONAL RD",
    "dropphycty": "OLD WASHINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 437689901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD WASHINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 437689998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404895206,
    "dropsitcph": 7404895206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22301",
    "droptype": "D",
    "dropname": "ONTARIO",
    "dropdeladd": "3656 PARK AVE W",
    "dropdelcty": "ONTARIO",
    "dropdelst": "OH",
    "dropdelzpp": 448629800,
    "dropphyadd": "3656 PARK AVE W",
    "dropphycty": "ONTARIO",
    "dropphyst": "OH",
    "dropphyzpp": 448629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONTARIO",
    "dropmalst": "OH",
    "dropmalzpp": 448629998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195292409,
    "dropfax": 4195292409
  },
  {
    "dcode": "D",
    "dropkey": "PX22310",
    "droptype": "D",
    "dropname": "ORANGEVILLE",
    "dropdeladd": "7401 STATELINE RD",
    "dropdelcty": "ORANGEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 444539800,
    "dropphyadd": "7401 STATELINE RD",
    "dropphycty": "ORANGEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 444539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORANGEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 444539998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307725755,
    "dropsitcph": 3307725755,
    "dropfax": 3307725757
  },
  {
    "dcode": "D",
    "dropkey": "PX22317",
    "droptype": "D",
    "dropname": "ORIENT",
    "dropdeladd": "7820 STAHL RD",
    "dropdelcty": "ORIENT",
    "dropdelst": "OH",
    "dropdelzpp": 431469900,
    "dropphyadd": "7820 STAHL RD",
    "dropphycty": "ORIENT",
    "dropphyst": "OH",
    "dropphyzpp": 431469900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORIENT",
    "dropmalst": "OH",
    "dropmalzpp": 431469998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148773633,
    "dropsitcph": 6148773633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22319",
    "droptype": "D",
    "dropname": "ORRVILLE",
    "dropdeladd": "145 N VINE ST",
    "dropdelcty": "ORRVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446679998,
    "dropphyadd": "145 N VINE ST",
    "dropphycty": "ORRVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446679998,
    "dropmaladd": "145 N VINE ST",
    "dropmalcty": "ORRVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446679998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306827831,
    "dropfax": 3306832572
  },
  {
    "dcode": "D",
    "dropkey": "PX22320",
    "droptype": "D",
    "dropname": "ORWELL",
    "dropdeladd": "47 S MAPLE ST",
    "dropdelcty": "ORWELL",
    "dropdelst": "OH",
    "dropdelzpp": 440769998,
    "dropphyadd": "47 S MAPLE ST",
    "dropphycty": "ORWELL",
    "dropphyst": "OH",
    "dropphyzpp": 440769998,
    "dropmaladd": "47 S MAPLE ST",
    "dropmalcty": "ORWELL",
    "dropmalst": "OH",
    "dropmalzpp": 440769998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404376133,
    "dropfax": 4404376133
  },
  {
    "dcode": "D",
    "dropkey": "PX22321",
    "droptype": "D",
    "dropname": "OSGOOD",
    "dropdeladd": "24 W MAIN ST",
    "dropdelcty": "OSGOOD",
    "dropdelst": "OH",
    "dropdelzpp": 453519998,
    "dropphyadd": "24 W MAIN ST",
    "dropphycty": "OSGOOD",
    "dropphyst": "OH",
    "dropphyzpp": 453519998,
    "dropmaladd": "24 W MAIN ST",
    "dropmalcty": "OSGOOD",
    "dropmalst": "OH",
    "dropmalzpp": 453519998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195824261,
    "dropsitcph": 4195824261,
    "dropfax": 4195823023
  },
  {
    "dcode": "D",
    "dropkey": "PX22323",
    "droptype": "D",
    "dropname": "OSTRANDER",
    "dropdeladd": "420 W NORTH ST",
    "dropdelcty": "OSTRANDER",
    "dropdelst": "OH",
    "dropdelzpp": 430619014,
    "dropphyadd": "420 W NORTH ST",
    "dropphycty": "OSTRANDER",
    "dropphyst": "OH",
    "dropphyzpp": 430619014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSTRANDER",
    "dropmalst": "OH",
    "dropmalzpp": 430619998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406667345,
    "dropsitcph": 7406667345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22325",
    "droptype": "D",
    "dropname": "OTTAWA",
    "dropdeladd": "404 E MAIN ST",
    "dropdelcty": "OTTAWA",
    "dropdelst": "OH",
    "dropdelzpp": 458759998,
    "dropphyadd": "404 E MAIN ST",
    "dropphycty": "OTTAWA",
    "dropphyst": "OH",
    "dropphyzpp": 458759998,
    "dropmaladd": "404 E MAIN ST",
    "dropmalcty": "OTTAWA",
    "dropmalst": "OH",
    "dropmalzpp": 458759998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195233008,
    "dropsitcph": 4195233008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22328",
    "droptype": "D",
    "dropname": "OTTOVILLE",
    "dropdeladd": "103 E 3RD ST",
    "dropdelcty": "OTTOVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 458769998,
    "dropphyadd": "103 E 3RD ST",
    "dropphycty": "OTTOVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 458769998,
    "dropmaladd": "103 E 3RD ST",
    "dropmalcty": "OTTOVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 458769998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195973222,
    "dropsitcph": 4195973222,
    "dropfax": 4195973222
  },
  {
    "dcode": "D",
    "dropkey": "PX22331",
    "droptype": "D",
    "dropname": "OTWAY",
    "dropdeladd": "6969 STATE ROUTE 73",
    "dropdelcty": "OTWAY",
    "dropdelst": "OH",
    "dropdelzpp": 456579153,
    "dropphyadd": "6969 STATE ROUTE 73",
    "dropphycty": "OTWAY",
    "dropphyst": "OH",
    "dropphyzpp": 456579153,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTWAY",
    "dropmalst": "OH",
    "dropmalzpp": 456579998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403725565,
    "dropsitcph": 7403725565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22334",
    "droptype": "D",
    "dropname": "OVERPECK",
    "dropdeladd": "4212 TRENTON RD",
    "dropdelcty": "OVERPECK",
    "dropdelst": "OH",
    "dropdelzpp": 450559998,
    "dropphyadd": "4212 TRENTON RD",
    "dropphycty": "OVERPECK",
    "dropphyst": "OH",
    "dropphyzpp": 450559998,
    "dropmaladd": "4212 TRENTON RD",
    "dropmalcty": "OVERPECK",
    "dropmalst": "OH",
    "dropmalzpp": 450559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138671347,
    "dropsitcph": 5138671347,
    "dropfax": 5138670184
  },
  {
    "dcode": "D",
    "dropkey": "PX22338",
    "droptype": "D",
    "dropname": "OWENSVILLE",
    "dropdeladd": "285 W MAIN ST",
    "dropdelcty": "OWENSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451609998,
    "dropphyadd": "285 W MAIN ST",
    "dropphycty": "OWENSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451609998,
    "dropmaladd": "285 W MAIN ST",
    "dropmalcty": "OWENSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451609998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137322272,
    "dropsitcph": 5137322272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22342",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "5145 BROWN RD",
    "dropdelcty": "OXFORD",
    "dropdelst": "OH",
    "dropdelzpp": 450569998,
    "dropphyadd": "5145 BROWN RD",
    "dropphycty": "OXFORD",
    "dropphyst": "OH",
    "dropphyzpp": 450569998,
    "dropmaladd": "5145 BROWN RD",
    "dropmalcty": "OXFORD",
    "dropmalst": "OH",
    "dropmalzpp": 450569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5135232455,
    "dropsitcph": 5135232455,
    "dropfax": 5135240133
  },
  {
    "dcode": "D",
    "dropkey": "PX22350",
    "droptype": "D",
    "dropname": "PAINESVILLE",
    "dropdeladd": "215 E JACKSON ST",
    "dropdelcty": "PAINESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440779998,
    "dropphyadd": "215 E JACKSON ST",
    "dropphycty": "PAINESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440779998,
    "dropmaladd": "215 E JACKSON ST",
    "dropmalcty": "PAINESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440779998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403576081,
    "dropfax": 4403571426
  },
  {
    "dcode": "D",
    "dropkey": "PX22353",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "105 W CROSS ST",
    "dropdelcty": "PALESTINE",
    "dropdelst": "OH",
    "dropdelzpp": 453529998,
    "dropphyadd": "105 W CROSS ST",
    "dropphycty": "PALESTINE",
    "dropphyst": "OH",
    "dropphyzpp": 453529998,
    "dropmaladd": "105 W CROSS ST",
    "dropmalcty": "PALESTINE",
    "dropmalst": "OH",
    "dropmalzpp": 453529998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375471188,
    "dropsitcph": 9375471188,
    "dropfax": 9375471217
  },
  {
    "dcode": "D",
    "dropkey": "PX22359",
    "droptype": "D",
    "dropname": "PANDORA",
    "dropdeladd": "120 E MAIN ST",
    "dropdelcty": "PANDORA",
    "dropdelst": "OH",
    "dropdelzpp": 458779998,
    "dropphyadd": "120 E MAIN ST",
    "dropphycty": "PANDORA",
    "dropphyst": "OH",
    "dropphyzpp": 458779998,
    "dropmaladd": "120 E MAIN ST",
    "dropmalcty": "PANDORA",
    "dropmalst": "OH",
    "dropmalzpp": 458779998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193843401,
    "dropsitcph": 4193843401,
    "dropfax": 4193843402
  },
  {
    "dcode": "D",
    "dropkey": "PX22362",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "12550 LISBON ST SE",
    "dropdelcty": "PARIS",
    "dropdelst": "OH",
    "dropdelzpp": 446699998,
    "dropphyadd": "12550 LISBON ST SE",
    "dropphycty": "PARIS",
    "dropphyst": "OH",
    "dropphyzpp": 446699998,
    "dropmaladd": "12550 LISBON ST SE",
    "dropmalcty": "PARIS",
    "dropmalst": "OH",
    "dropmalzpp": 446699998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308622940,
    "dropfax": 3308622940
  },
  {
    "dcode": "D",
    "dropkey": "PX22365",
    "droptype": "D",
    "dropname": "PARKMAN",
    "dropdeladd": "18315 MAIN ST",
    "dropdelcty": "PARKMAN",
    "dropdelst": "OH",
    "dropdelzpp": 440809803,
    "dropphyadd": "18315 MAIN ST",
    "dropphycty": "PARKMAN",
    "dropphyst": "OH",
    "dropphyzpp": 440809803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKMAN",
    "dropmalst": "OH",
    "dropmalzpp": 440809998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405484951,
    "dropfax": 4405482471
  },
  {
    "dcode": "D",
    "dropkey": "PX22373",
    "droptype": "D",
    "dropname": "PATASKALA",
    "dropdeladd": "175 E BROAD ST",
    "dropdelcty": "PATASKALA",
    "dropdelst": "OH",
    "dropdelzpp": 430627873,
    "dropphyadd": "175 E BROAD ST",
    "dropphycty": "PATASKALA",
    "dropphyst": "OH",
    "dropphyzpp": 430627873,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATASKALA",
    "dropmalst": "OH",
    "dropmalzpp": 430629998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409274801,
    "dropsitcph": 7409274801,
    "dropfax": 7409279956
  },
  {
    "dcode": "D",
    "dropkey": "PX22375",
    "droptype": "D",
    "dropname": "PATRIOT",
    "dropdeladd": "1584 PATRIOT RD",
    "dropdelcty": "PATRIOT",
    "dropdelst": "OH",
    "dropdelzpp": 456589998,
    "dropphyadd": "1584 PATRIOT RD",
    "dropphycty": "PATRIOT",
    "dropphyst": "OH",
    "dropphyzpp": 456589998,
    "dropmaladd": "1584 PATRIOT RD",
    "dropmalcty": "PATRIOT",
    "dropmalst": "OH",
    "dropmalzpp": 456589998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403792803,
    "dropsitcph": 7403792803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22380",
    "droptype": "D",
    "dropname": "PAULDING",
    "dropdeladd": "121 W JACKSON ST",
    "dropdelcty": "PAULDING",
    "dropdelst": "OH",
    "dropdelzpp": 458799998,
    "dropphyadd": "121 W JACKSON ST",
    "dropphycty": "PAULDING",
    "dropphyst": "OH",
    "dropphyzpp": 458799998,
    "dropmaladd": "121 W JACKSON ST",
    "dropmalcty": "PAULDING",
    "dropmalst": "OH",
    "dropmalzpp": 458799998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193992761,
    "dropsitcph": 4193992761,
    "dropfax": 4193993942
  },
  {
    "dcode": "D",
    "dropkey": "PX22383",
    "droptype": "D",
    "dropname": "PAYNE",
    "dropdeladd": "101 S LAURA ST",
    "dropdelcty": "PAYNE",
    "dropdelst": "OH",
    "dropdelzpp": 458809998,
    "dropphyadd": "101 S LAURA ST",
    "dropphycty": "PAYNE",
    "dropphyst": "OH",
    "dropphyzpp": 458809998,
    "dropmaladd": "101 S LAURA ST",
    "dropmalcty": "PAYNE",
    "dropmalst": "OH",
    "dropmalzpp": 458809998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199102015,
    "dropsitcph": 4199102015,
    "dropfax": 4192631343
  },
  {
    "dcode": "D",
    "dropkey": "PX22386",
    "droptype": "D",
    "dropname": "PEDRO",
    "dropdeladd": "8284 STATE ROUTE 93",
    "dropdelcty": "PEDRO",
    "dropdelst": "OH",
    "dropdelzpp": 456598401,
    "dropphyadd": "8284 STATE ROUTE 93",
    "dropphycty": "PEDRO",
    "dropphyst": "OH",
    "dropphyzpp": 456598401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEDRO",
    "dropmalst": "OH",
    "dropmalzpp": 456599998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405320930,
    "dropsitcph": 7405320930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22387",
    "droptype": "D",
    "dropname": "PEEBLES",
    "dropdeladd": "184 N MAIN ST",
    "dropdelcty": "PEEBLES",
    "dropdelst": "OH",
    "dropdelzpp": 456601296,
    "dropphyadd": "184 N MAIN ST",
    "dropphycty": "PEEBLES",
    "dropphyst": "OH",
    "dropphyzpp": 456601296,
    "dropmaladd": "184 N MAIN ST",
    "dropmalcty": "PEEBLES",
    "dropmalst": "OH",
    "dropmalzpp": 456601296,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375870041,
    "dropsitcph": 9375870041,
    "dropfax": 9375870041
  },
  {
    "dcode": "D",
    "dropkey": "PX22389",
    "droptype": "D",
    "dropname": "PEMBERTON",
    "dropdeladd": "6673 PALESTINE ST",
    "dropdelcty": "PEMBERTON",
    "dropdelst": "OH",
    "dropdelzpp": 453539998,
    "dropphyadd": "6673 PALESTINE ST",
    "dropphycty": "PEMBERTON",
    "dropphyst": "OH",
    "dropphyzpp": 453539998,
    "dropmaladd": "6673 PALESTINE ST",
    "dropmalcty": "PEMBERTON",
    "dropmalst": "OH",
    "dropmalzpp": 453539998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374921362,
    "dropsitcph": 9374921362,
    "dropfax": 9374922061
  },
  {
    "dcode": "D",
    "dropkey": "PX22390",
    "droptype": "D",
    "dropname": "PEMBERVILLE",
    "dropdeladd": "130 CHERRY ST",
    "dropdelcty": "PEMBERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 434509998,
    "dropphyadd": "130 CHERRY ST",
    "dropphycty": "PEMBERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 434509998,
    "dropmaladd": "130 CHERRY ST",
    "dropmalcty": "PEMBERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 434509998,
    "dropsitphn": 4192873264,
    "dropsitlph": 4192873264,
    "dropsitcph": 4192873264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22392",
    "droptype": "D",
    "dropname": "PENINSULA",
    "dropdeladd": "1921 BRONSON ST",
    "dropdelcty": "PENINSULA",
    "dropdelst": "OH",
    "dropdelzpp": 442649998,
    "dropphyadd": "1921 BRONSON ST",
    "dropphycty": "PENINSULA",
    "dropphyst": "OH",
    "dropphyzpp": 442649998,
    "dropmaladd": "1921 BRONSON ST",
    "dropmalcty": "PENINSULA",
    "dropmalst": "OH",
    "dropmalzpp": 442649998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306572500,
    "dropfax": 3306572500
  },
  {
    "dcode": "D",
    "dropkey": "PX22404",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "3754 CENTER RD",
    "dropdelcty": "PERRY",
    "dropdelst": "OH",
    "dropdelzpp": 440819800,
    "dropphyadd": "3754 CENTER RD",
    "dropphycty": "PERRY",
    "dropphyst": "OH",
    "dropphyzpp": 440819800,
    "dropmaladd": "3754 CENTER RD",
    "dropmalcty": "PERRY",
    "dropmalst": "OH",
    "dropmalzpp": 440819800,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402592125,
    "dropfax": 4402592125
  },
  {
    "dcode": "D",
    "dropkey": "PX22408",
    "droptype": "D",
    "dropname": "PERRYSBURG",
    "dropdeladd": "1205 LOUISIANA AVE",
    "dropdelcty": "PERRYSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 435512354,
    "dropphyadd": "1205 LOUISIANA AVE",
    "dropphycty": "PERRYSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 435512354,
    "dropmaladd": "1205 LOUISIANA AVE",
    "dropmalcty": "PERRYSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 435512354,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198744440,
    "dropsitcph": 4198744440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22409",
    "droptype": "D",
    "dropname": "PERRYSVILLE",
    "dropdeladd": "112 W 1ST ST",
    "dropdelcty": "PERRYSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 448649801,
    "dropphyadd": "112 W 1ST ST",
    "dropphycty": "PERRYSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 448649801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERRYSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 448649998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199387832,
    "dropfax": 4199385010
  },
  {
    "dcode": "D",
    "dropkey": "PX22412",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "6363 E GARFIELD RD",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 444549800,
    "dropphyadd": "6363 E GARFIELD RD",
    "dropphycty": "PETERSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 444549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 444549998,
    "dropsitphn": 3309969798,
    "dropsitlph": 3309969797,
    "dropsitcph": 3305422121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22414",
    "droptype": "D",
    "dropname": "PETTISVILLE",
    "dropdeladd": "201 FRONT ST",
    "dropdelcty": "PETTISVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 435539998,
    "dropphyadd": "201 FRONT ST",
    "dropphycty": "PETTISVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 435539998,
    "dropmaladd": "201 FRONT ST",
    "dropmalcty": "PETTISVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 435539998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194462252,
    "dropsitcph": 4194036035,
    "dropfax": 4194036037
  },
  {
    "dcode": "D",
    "dropkey": "PX22419",
    "droptype": "D",
    "dropname": "PHILLIPSBURG",
    "dropdeladd": "15 E MAIN ST",
    "dropdelcty": "PHILLIPSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453549998,
    "dropphyadd": "15 E MAIN ST",
    "dropphycty": "PHILLIPSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453549998,
    "dropmaladd": "15 E MAIN ST",
    "dropmalcty": "PHILLIPSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453549998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378845675,
    "dropsitcph": 9378845675,
    "dropfax": 9378845789
  },
  {
    "dcode": "D",
    "dropkey": "PX22420",
    "droptype": "D",
    "dropname": "PHILO",
    "dropdeladd": "265 MAIN ST",
    "dropdelcty": "PHILO",
    "dropdelst": "OH",
    "dropdelzpp": 437719900,
    "dropphyadd": "265 MAIN ST",
    "dropphycty": "PHILO",
    "dropphyst": "OH",
    "dropphyzpp": 437719900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHILO",
    "dropmalst": "OH",
    "dropmalzpp": 437719998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406746432,
    "dropsitcph": 7406746432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22423",
    "droptype": "D",
    "dropname": "PICKERINGTON",
    "dropdeladd": "520 HILL RD N",
    "dropdelcty": "PICKERINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 431479998,
    "dropphyadd": "520 HILL RD N",
    "dropphycty": "PICKERINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 431479998,
    "dropmaladd": "520 HILL RD N",
    "dropmalcty": "PICKERINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 431479998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148375793,
    "dropsitcph": 6148375793,
    "dropfax": 6148378732
  },
  {
    "dcode": "D",
    "dropkey": "PX22426",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "33031 W MAIN ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "OH",
    "dropdelzpp": 439839800,
    "dropphyadd": "33031 W MAIN ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "OH",
    "dropphyzpp": 439839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "OH",
    "dropmalzpp": 439839998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409683411,
    "dropsitcph": 7409683411,
    "dropfax": 7409683411
  },
  {
    "dcode": "D",
    "dropkey": "PX22427",
    "droptype": "D",
    "dropname": "PIERPONT",
    "dropdeladd": "62 STATE ROUTE 7 S",
    "dropdelcty": "PIERPONT",
    "dropdelst": "OH",
    "dropdelzpp": 440829800,
    "dropphyadd": "62 STATE ROUTE 7 S",
    "dropphycty": "PIERPONT",
    "dropphyst": "OH",
    "dropphyzpp": 440829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERPONT",
    "dropmalst": "OH",
    "dropmalzpp": 440829998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405771349,
    "dropfax": 4405771349
  },
  {
    "dcode": "D",
    "dropkey": "PX22429",
    "droptype": "D",
    "dropname": "PIKETON",
    "dropdeladd": "114 S FORSYTHE ST",
    "dropdelcty": "PIKETON",
    "dropdelst": "OH",
    "dropdelzpp": 456618090,
    "dropphyadd": "114 S FORSYTHE ST",
    "dropphycty": "PIKETON",
    "dropphyst": "OH",
    "dropphyzpp": 456618090,
    "dropmaladd": "114 S FORSYTHE ST",
    "dropmalcty": "PIKETON",
    "dropmalst": "OH",
    "dropmalzpp": 456618090,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402892661,
    "dropsitcph": 7402892661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22432",
    "droptype": "D",
    "dropname": "PIONEER",
    "dropdeladd": "105 W 1ST ST",
    "dropdelcty": "PIONEER",
    "dropdelst": "OH",
    "dropdelzpp": 435549998,
    "dropphyadd": "105 W 1ST ST",
    "dropphycty": "PIONEER",
    "dropphyst": "OH",
    "dropphyzpp": 435549998,
    "dropmaladd": "105 W 1ST ST",
    "dropmalcty": "PIONEER",
    "dropmalst": "OH",
    "dropmalzpp": 435549998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197372410,
    "dropsitcph": 4197372410,
    "dropfax": 4197372410
  },
  {
    "dcode": "D",
    "dropkey": "PX22433",
    "droptype": "D",
    "dropname": "PIQUA",
    "dropdeladd": "220 N WAYNE ST",
    "dropdelcty": "PIQUA",
    "dropdelst": "OH",
    "dropdelzpp": 453569998,
    "dropphyadd": "220 N WAYNE ST",
    "dropphycty": "PIQUA",
    "dropphyst": "OH",
    "dropphyzpp": 453569998,
    "dropmaladd": "220 N WAYNE ST",
    "dropmalcty": "PIQUA",
    "dropmalst": "OH",
    "dropmalzpp": 453569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377736424,
    "dropsitcph": 9377736424,
    "dropfax": 9377733348
  },
  {
    "dcode": "D",
    "dropkey": "PX22435",
    "droptype": "D",
    "dropname": "PITSBURG",
    "dropdeladd": "100 JEFFERSON ST",
    "dropdelcty": "PITSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453589998,
    "dropphyadd": "100 JEFFERSON ST",
    "dropphycty": "PITSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453589998,
    "dropmaladd": "100 JEFFERSON ST",
    "dropmalcty": "PITSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453589998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376928351,
    "dropsitcph": 9376928351,
    "dropfax": 9376928442
  },
  {
    "dcode": "D",
    "dropkey": "PX22438",
    "droptype": "D",
    "dropname": "PLAIN CITY",
    "dropdeladd": "219 MAPLE ST",
    "dropdelcty": "PLAIN CITY",
    "dropdelst": "OH",
    "dropdelzpp": 430641293,
    "dropphyadd": "219 MAPLE ST",
    "dropphycty": "PLAIN CITY",
    "dropphyst": "OH",
    "dropphyzpp": 430641293,
    "dropmaladd": "219 MAPLE ST",
    "dropmalcty": "PLAIN CITY",
    "dropmalst": "OH",
    "dropmalzpp": 430641293,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148734004,
    "dropsitcph": 6148734004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22449",
    "droptype": "D",
    "dropname": "PLEASANT CITY",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "PLEASANT CITY",
    "dropdelst": "OH",
    "dropdelzpp": 437729900,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "PLEASANT CITY",
    "dropphyst": "OH",
    "dropphyzpp": 437729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT CITY",
    "dropmalst": "OH",
    "dropmalzpp": 437729998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406852488,
    "dropsitcph": 7406852488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22454",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "OH",
    "dropdelzpp": 453599998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "OH",
    "dropphyzpp": 453599998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "OH",
    "dropmalzpp": 453599998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376762101,
    "dropsitcph": 9376762101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22457",
    "droptype": "D",
    "dropname": "PLEASANT PLAIN",
    "dropdeladd": "10069 STATE ROUTE 132",
    "dropdelcty": "PLEASANT PLAIN",
    "dropdelst": "OH",
    "dropdelzpp": 451629998,
    "dropphyadd": "10069 STATE ROUTE 132",
    "dropphycty": "PLEASANT PLAIN",
    "dropphyst": "OH",
    "dropphyzpp": 451629998,
    "dropmaladd": "10069 STATE ROUTE 132",
    "dropmalcty": "PLEASANT PLAIN",
    "dropmalst": "OH",
    "dropmalzpp": 451629998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138772604,
    "dropsitcph": 5138772604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22466",
    "droptype": "D",
    "dropname": "PLEASANTVILLE",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "PLEASANTVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431489900,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "PLEASANTVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431489900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANTVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431489998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404682212,
    "dropsitcph": 7404682212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22475",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "27 PLYMOUTH ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "OH",
    "dropdelzpp": 448659998,
    "dropphyadd": "27 PLYMOUTH ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "OH",
    "dropphyzpp": 448659998,
    "dropmaladd": "27 PLYMOUTH ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "OH",
    "dropmalzpp": 448659998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196875731,
    "dropfax": 4196875731
  },
  {
    "dcode": "D",
    "dropkey": "PX22486",
    "droptype": "D",
    "dropname": "POLK",
    "dropdeladd": "103 W CONGRESS ST",
    "dropdelcty": "POLK",
    "dropdelst": "OH",
    "dropdelzpp": 448669800,
    "dropphyadd": "103 W CONGRESS ST",
    "dropphycty": "POLK",
    "dropphyst": "OH",
    "dropphyzpp": 448669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLK",
    "dropmalst": "OH",
    "dropmalzpp": 448669998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199452386,
    "dropfax": 4199451390
  },
  {
    "dcode": "D",
    "dropkey": "PX22488",
    "droptype": "D",
    "dropname": "POMEROY",
    "dropdeladd": "212 E 2ND ST",
    "dropdelcty": "POMEROY",
    "dropdelst": "OH",
    "dropdelzpp": 457699800,
    "dropphyadd": "212 E 2ND ST",
    "dropphycty": "POMEROY",
    "dropphyst": "OH",
    "dropphyzpp": 457699800,
    "dropmaladd": "212 E 2ND ST",
    "dropmalcty": "POMEROY",
    "dropmalst": "OH",
    "dropmalzpp": 457699800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409922235,
    "dropsitcph": 7409922235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22491",
    "droptype": "D",
    "dropname": "PORT CLINTON",
    "dropdeladd": "121 W 2ND ST",
    "dropdelcty": "PORT CLINTON",
    "dropdelst": "OH",
    "dropdelzpp": 434529998,
    "dropphyadd": "121 W 2ND ST",
    "dropphycty": "PORT CLINTON",
    "dropphyst": "OH",
    "dropphyzpp": 434529998,
    "dropmaladd": "121 W 2ND ST",
    "dropmalcty": "PORT CLINTON",
    "dropmalst": "OH",
    "dropmalzpp": 434529998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197323322,
    "dropsitcph": 4197323322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22493",
    "droptype": "D",
    "dropname": "PORT JEFFERSON",
    "dropdeladd": "109 E MAIN ST",
    "dropdelcty": "PORT JEFFERSON",
    "dropdelst": "OH",
    "dropdelzpp": 453609998,
    "dropphyadd": "109 E MAIN ST",
    "dropphycty": "PORT JEFFERSON",
    "dropphyst": "OH",
    "dropphyzpp": 453609998,
    "dropmaladd": "109 E MAIN ST",
    "dropmalcty": "PORT JEFFERSON",
    "dropmalst": "OH",
    "dropmalzpp": 453609998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374925034,
    "dropsitcph": 9374925034,
    "dropfax": 9374925084
  },
  {
    "dcode": "D",
    "dropkey": "PX22495",
    "droptype": "D",
    "dropname": "PORT WASHINGTON",
    "dropdeladd": "103 SAINT CLAIRSVILLE RD SW",
    "dropdelcty": "PORT WASHINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 438379719,
    "dropphyadd": "103 SAINT CLAIRSVILLE RD SW",
    "dropphycty": "PORT WASHINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 438379719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT WASHINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 438379998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404986453,
    "dropsitcph": 7404986453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22496",
    "droptype": "D",
    "dropname": "PORT WILLIAM",
    "dropdeladd": "227 MAIN ST",
    "dropdelcty": "PORT WILLIAM",
    "dropdelst": "OH",
    "dropdelzpp": 451649998,
    "dropphyadd": "227 MAIN ST",
    "dropphycty": "PORT WILLIAM",
    "dropphyst": "OH",
    "dropphyzpp": 451649998,
    "dropmaladd": "227 MAIN ST",
    "dropmalcty": "PORT WILLIAM",
    "dropmalst": "OH",
    "dropmalzpp": 451649998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374864375,
    "dropsitcph": 9374864375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22497",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "101 S FINDLAY PIKE",
    "dropdelcty": "PORTAGE",
    "dropdelst": "OH",
    "dropdelzpp": 434519998,
    "dropphyadd": "101 S FINDLAY PIKE",
    "dropphycty": "PORTAGE",
    "dropphyst": "OH",
    "dropphyzpp": 434519998,
    "dropmaladd": "101 S FINDLAY PIKE",
    "dropmalcty": "PORTAGE",
    "dropmalst": "OH",
    "dropmalzpp": 434519998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196862191,
    "dropsitcph": 4196862191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22503",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "30935 HIGH ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OH",
    "dropdelzpp": 457709997,
    "dropphyadd": "30935 HIGH ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OH",
    "dropphyzpp": 457709997,
    "dropmaladd": "30935 HIGH ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OH",
    "dropmalzpp": 457709997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408435109,
    "dropsitcph": 7408435109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22504",
    "droptype": "D",
    "dropname": "PORTSMOUTH",
    "dropdeladd": "610 GAY ST",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "OH",
    "dropdelzpp": 456629998,
    "dropphyadd": "610 GAY ST",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "OH",
    "dropphyzpp": 456629998,
    "dropmaladd": "610 GAY ST",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "OH",
    "dropmalzpp": 456629998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403532070,
    "dropsitcph": 7403532070,
    "dropfax": 7403546327
  },
  {
    "dcode": "D",
    "dropkey": "PX22505",
    "droptype": "D",
    "dropname": "POTSDAM",
    "dropdeladd": "2 W CROSS ST",
    "dropdelcty": "POTSDAM",
    "dropdelst": "OH",
    "dropdelzpp": 453619998,
    "dropphyadd": "2 W CROSS ST",
    "dropphycty": "POTSDAM",
    "dropphyst": "OH",
    "dropphyzpp": 453619998,
    "dropmaladd": "2 W CROSS ST",
    "dropmalcty": "POTSDAM",
    "dropmalst": "OH",
    "dropmalzpp": 453619998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379471919,
    "dropsitcph": 9379471919,
    "dropfax": 9379479017
  },
  {
    "dcode": "D",
    "dropkey": "PX22507",
    "droptype": "D",
    "dropname": "POWELL",
    "dropdeladd": "40 GRACE DR",
    "dropdelcty": "POWELL",
    "dropdelst": "OH",
    "dropdelzpp": 430659113,
    "dropphyadd": "40 GRACE DR",
    "dropphycty": "POWELL",
    "dropphyst": "OH",
    "dropphyzpp": 430659113,
    "dropmaladd": "40 GRACE DR",
    "dropmalcty": "POWELL",
    "dropmalst": "OH",
    "dropmalzpp": 430659113,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148466017,
    "dropsitcph": 6148466017,
    "dropfax": 6148462181
  },
  {
    "dcode": "D",
    "dropkey": "PX22509",
    "droptype": "D",
    "dropname": "POWHATAN POINT",
    "dropdeladd": "335 HIGHWAY 7 N",
    "dropdelcty": "POWHATAN POINT",
    "dropdelst": "OH",
    "dropdelzpp": 439421279,
    "dropphyadd": "335 HIGHWAY 7 N",
    "dropphycty": "POWHATAN POINT",
    "dropphyst": "OH",
    "dropphyzpp": 439421279,
    "dropmaladd": "335 HIGHWAY 7 N",
    "dropmalcty": "POWHATAN POINT",
    "dropmalst": "OH",
    "dropmalzpp": 439421279,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407954031,
    "dropsitcph": 7407954031,
    "dropfax": 7407954031
  },
  {
    "dcode": "D",
    "dropkey": "PX22517",
    "droptype": "D",
    "dropname": "PROCTORVILLE",
    "dropdeladd": "6200 COUNTY ROAD 107",
    "dropdelcty": "PROCTORVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 456699104,
    "dropphyadd": "6200 COUNTY ROAD 107",
    "dropphycty": "PROCTORVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 456699104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROCTORVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 456699998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408866310,
    "dropsitcph": 7408866310,
    "dropfax": 7408868662
  },
  {
    "dcode": "D",
    "dropkey": "PX22518",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "PROSPECT",
    "dropdelst": "OH",
    "dropdelzpp": 433429633,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "PROSPECT",
    "dropphyst": "OH",
    "dropphyzpp": 433429633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROSPECT",
    "dropmalst": "OH",
    "dropmalzpp": 433429998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404942829,
    "dropsitcph": 7404942829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22532",
    "droptype": "D",
    "dropname": "PUT IN BAY",
    "dropdeladd": "425 LANGRAM RD",
    "dropdelcty": "PUT IN BAY",
    "dropdelst": "OH",
    "dropdelzpp": 434569998,
    "dropphyadd": "425 LANGRAM RD",
    "dropphycty": "PUT IN BAY",
    "dropphyst": "OH",
    "dropphyzpp": 434569998,
    "dropmaladd": "425 LANGRAM RD",
    "dropmalcty": "PUT IN BAY",
    "dropmalst": "OH",
    "dropmalzpp": 434569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192854641,
    "dropsitcph": 4192854641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22537",
    "droptype": "D",
    "dropname": "QUAKER CITY",
    "dropdeladd": "151 SOUTH ST",
    "dropdelcty": "QUAKER CITY",
    "dropdelst": "OH",
    "dropdelzpp": 437739900,
    "dropphyadd": "151 SOUTH ST",
    "dropphycty": "QUAKER CITY",
    "dropphyst": "OH",
    "dropphyzpp": 437739900,
    "dropmaladd": "151 SOUTH ST",
    "dropmalcty": "QUAKER CITY",
    "dropmalst": "OH",
    "dropmalzpp": 437739900,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406792702,
    "dropsitcph": 7406792702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22539",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "103 S MIAMI ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "OH",
    "dropdelzpp": 433439624,
    "dropphyadd": "103 S MIAMI ST",
    "dropphycty": "QUINCY",
    "dropphyst": "OH",
    "dropphyzpp": 433439624,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUINCY",
    "dropmalst": "OH",
    "dropmalzpp": 433439998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375856020,
    "dropsitcph": 9375856020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22542",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "208 S 3RD ST",
    "dropdelcty": "RACINE",
    "dropdelst": "OH",
    "dropdelzpp": 457719804,
    "dropphyadd": "208 S 3RD ST",
    "dropphycty": "RACINE",
    "dropphyst": "OH",
    "dropphyzpp": 457719804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RACINE",
    "dropmalst": "OH",
    "dropmalzpp": 457719998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409492500,
    "dropsitcph": 7409492500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22544",
    "droptype": "D",
    "dropname": "RADNOR",
    "dropdeladd": "4355 STATE ROUTE 203",
    "dropdelcty": "RADNOR",
    "dropdelst": "OH",
    "dropdelzpp": 430667000,
    "dropphyadd": "4355 STATE ROUTE 203",
    "dropphycty": "RADNOR",
    "dropphyst": "OH",
    "dropphyzpp": 430667000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RADNOR",
    "dropmalst": "OH",
    "dropmalzpp": 430669998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405953315,
    "dropsitcph": 7405953315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22547",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "3984 WATERLOO RD",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "OH",
    "dropdelzpp": 442659800,
    "dropphyadd": "3984 WATERLOO RD",
    "dropphycty": "RANDOLPH",
    "dropphyst": "OH",
    "dropphyzpp": 442659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "OH",
    "dropmalzpp": 442659998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303251736,
    "dropfax": 3303251736
  },
  {
    "dcode": "D",
    "dropkey": "PX22550",
    "droptype": "D",
    "dropname": "RARDEN",
    "dropdeladd": "1586 MAIN ST",
    "dropdelcty": "RARDEN",
    "dropdelst": "OH",
    "dropdelzpp": 456719800,
    "dropphyadd": "1586 MAIN ST",
    "dropphycty": "RARDEN",
    "dropphyst": "OH",
    "dropphyzpp": 456719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RARDEN",
    "dropmalst": "OH",
    "dropmalzpp": 456719998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403725405,
    "dropsitcph": 7403725405,
    "dropfax": 7403725405
  },
  {
    "dcode": "D",
    "dropkey": "PX22553",
    "droptype": "D",
    "dropname": "RAVENNA",
    "dropdeladd": "150 N CHESTNUT ST",
    "dropdelcty": "RAVENNA",
    "dropdelst": "OH",
    "dropdelzpp": 442669998,
    "dropphyadd": "150 N CHESTNUT ST",
    "dropphycty": "RAVENNA",
    "dropphyst": "OH",
    "dropphyzpp": 442669998,
    "dropmaladd": "150 N CHESTNUT ST",
    "dropmalcty": "RAVENNA",
    "dropmalst": "OH",
    "dropmalzpp": 442669998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302977626,
    "dropfax": 3302977238
  },
  {
    "dcode": "D",
    "dropkey": "PX22554",
    "droptype": "D",
    "dropname": "RAWSON",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "RAWSON",
    "dropdelst": "OH",
    "dropdelzpp": 458819998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "RAWSON",
    "dropphyst": "OH",
    "dropphyzpp": 458819998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "RAWSON",
    "dropmalst": "OH",
    "dropmalzpp": 458819998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4199633515,
    "dropsitcph": 4199633515,
    "dropfax": 4199634012
  },
  {
    "dcode": "D",
    "dropkey": "PX22555",
    "droptype": "D",
    "dropname": "RAY",
    "dropdeladd": "36977 STATE ROUTE 327",
    "dropdelcty": "RAY",
    "dropdelst": "OH",
    "dropdelzpp": 456728890,
    "dropphyadd": "36977 STATE ROUTE 327",
    "dropphycty": "RAY",
    "dropphyst": "OH",
    "dropphyzpp": 456728890,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAY",
    "dropmalst": "OH",
    "dropmalzpp": 456729998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408875844,
    "dropsitcph": 7408875844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22556",
    "droptype": "D",
    "dropname": "RAYLAND",
    "dropdeladd": "140 MAIN ST",
    "dropdelcty": "RAYLAND",
    "dropdelst": "OH",
    "dropdelzpp": 439439800,
    "dropphyadd": "140 MAIN ST",
    "dropphycty": "RAYLAND",
    "dropphyst": "OH",
    "dropphyzpp": 439439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYLAND",
    "dropmalst": "OH",
    "dropmalzpp": 439439998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7408594684,
    "dropsitcph": 7408594684,
    "dropfax": 7408594684
  },
  {
    "dcode": "D",
    "dropkey": "PX22557",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "21655 MAIN ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "OH",
    "dropdelzpp": 430679004,
    "dropphyadd": "21655 MAIN ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "OH",
    "dropphyzpp": 430679004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYMOND",
    "dropmalst": "OH",
    "dropmalzpp": 430679998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9372462561,
    "dropsitcph": 9372462561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22568",
    "droptype": "D",
    "dropname": "REEDSVILLE",
    "dropdeladd": "55420 TOWNSHIP ROAD 1016",
    "dropdelcty": "REEDSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 457729801,
    "dropphyadd": "55420 TOWNSHIP ROAD 1016",
    "dropphycty": "REEDSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 457729801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REEDSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 457729998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403786188,
    "dropsitcph": 7403786188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22573",
    "droptype": "D",
    "dropname": "REESVILLE",
    "dropdeladd": "540 N STATE ROUTE 72",
    "dropdelcty": "REESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 451669998,
    "dropphyadd": "540 N STATE ROUTE 72",
    "dropphycty": "REESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 451669998,
    "dropmaladd": "540 N STATE ROUTE 72",
    "dropmalcty": "REESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 451669998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375844241,
    "dropsitcph": 9375844241,
    "dropfax": 9375849051
  },
  {
    "dcode": "D",
    "dropkey": "PX22583",
    "droptype": "D",
    "dropname": "RENO",
    "dropdeladd": "27630 STATE ROUTE 7",
    "dropdelcty": "RENO",
    "dropdelst": "OH",
    "dropdelzpp": 457739000,
    "dropphyadd": "27630 STATE ROUTE 7",
    "dropphycty": "RENO",
    "dropphyst": "OH",
    "dropphyzpp": 457739000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RENO",
    "dropmalst": "OH",
    "dropmalzpp": 457739998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403747216,
    "dropsitcph": 7403747216,
    "dropfax": 7403745649
  },
  {
    "dcode": "D",
    "dropkey": "PX22586",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "300 MADISON ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "OH",
    "dropdelzpp": 448679801,
    "dropphyadd": "300 MADISON ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "OH",
    "dropphyzpp": 448679801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "OH",
    "dropmalzpp": 448679998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195855901,
    "dropfax": 4195852507
  },
  {
    "dcode": "D",
    "dropkey": "PX22589",
    "droptype": "D",
    "dropname": "REYNOLDSBURG",
    "dropdeladd": "7185 E MAIN ST",
    "dropdelcty": "REYNOLDSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430689998,
    "dropphyadd": "7185 E MAIN ST",
    "dropphycty": "REYNOLDSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430689998,
    "dropmaladd": "7185 E MAIN ST",
    "dropmalcty": "REYNOLDSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430689998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148666049,
    "dropsitcph": 6148666049,
    "dropfax": 6148660479
  },
  {
    "dcode": "D",
    "dropkey": "PX22592",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "3900 BROADVIEW RD",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 442869998,
    "dropphyadd": "3900 BROADVIEW RD",
    "dropphycty": "RICHFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 442869998,
    "dropmaladd": "3900 BROADVIEW RD",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 442869998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306593561,
    "dropfax": 3306593463
  },
  {
    "dcode": "D",
    "dropkey": "PX22600",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "36 E MAIN ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "OH",
    "dropdelzpp": 439449800,
    "dropphyadd": "36 E MAIN ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "OH",
    "dropphyzpp": 439449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHMOND",
    "dropmalst": "OH",
    "dropmalzpp": 439449998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407654638,
    "dropsitcph": 7407654638,
    "dropfax": 7407654638
  },
  {
    "dcode": "D",
    "dropkey": "PX22602",
    "droptype": "D",
    "dropname": "RICHMOND DALE",
    "dropdeladd": "1024 MAIN ST",
    "dropdelcty": "RICHMOND DALE",
    "dropdelst": "OH",
    "dropdelzpp": 456739713,
    "dropphyadd": "1024 MAIN ST",
    "dropphycty": "RICHMOND DALE",
    "dropphyst": "OH",
    "dropphyzpp": 456739713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHMOND DALE",
    "dropmalst": "OH",
    "dropmalzpp": 456739998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408844193,
    "dropsitcph": 7408844193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22606",
    "droptype": "D",
    "dropname": "RICHWOOD",
    "dropdeladd": "12 E OTTAWA ST",
    "dropdelcty": "RICHWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 433449997,
    "dropphyadd": "12 E OTTAWA ST",
    "dropphycty": "RICHWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 433449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 433449998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409432033,
    "dropsitcph": 7409432033,
    "dropfax": 7409432033
  },
  {
    "dcode": "D",
    "dropkey": "PX22613",
    "droptype": "D",
    "dropname": "RIDGEVILLE CORNERS",
    "dropdeladd": "20348 COUNTY ROAD X",
    "dropdelcty": "RIDGEVILLE CORNERS",
    "dropdelst": "OH",
    "dropdelzpp": 435559998,
    "dropphyadd": "20348 COUNTY ROAD X",
    "dropphycty": "RIDGEVILLE CORNERS",
    "dropphyst": "OH",
    "dropphyzpp": 435559998,
    "dropmaladd": "20348 COUNTY ROAD X",
    "dropmalcty": "RIDGEVILLE CORNERS",
    "dropmalst": "OH",
    "dropmalzpp": 435559998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193700350,
    "dropsitcph": 4193700350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22614",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "114 E HALE ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "OH",
    "dropdelzpp": 433459561,
    "dropphyadd": "114 E HALE ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "OH",
    "dropphyzpp": 433459561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "OH",
    "dropmalzpp": 433459998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373632725,
    "dropsitcph": 9373632725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22620",
    "droptype": "D",
    "dropname": "RIO GRANDE",
    "dropdeladd": "408 W COLLEGE ST",
    "dropdelcty": "RIO GRANDE",
    "dropdelst": "OH",
    "dropdelzpp": 456749800,
    "dropphyadd": "408 W COLLEGE ST",
    "dropphycty": "RIO GRANDE",
    "dropphyst": "OH",
    "dropphyzpp": 456749800,
    "dropmaladd": "408 W COLLEGE ST",
    "dropmalcty": "RIO GRANDE",
    "dropmalst": "OH",
    "dropmalzpp": 456749800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402455655,
    "dropsitcph": 7402455655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22621",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "100 S 2ND ST",
    "dropdelcty": "RIPLEY",
    "dropdelst": "OH",
    "dropdelzpp": 451679998,
    "dropphyadd": "100 S 2ND ST",
    "dropphycty": "RIPLEY",
    "dropphyst": "OH",
    "dropphyzpp": 451679998,
    "dropmaladd": "100 S 2ND ST",
    "dropmalcty": "RIPLEY",
    "dropmalst": "OH",
    "dropmalzpp": 451679998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133920089,
    "dropsitcph": 9373920089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22624",
    "droptype": "D",
    "dropname": "RISINGSUN",
    "dropdeladd": "356 MAIN ST",
    "dropdelcty": "RISINGSUN",
    "dropdelst": "OH",
    "dropdelzpp": 434579998,
    "dropphyadd": "356 MAIN ST",
    "dropphycty": "RISINGSUN",
    "dropphyst": "OH",
    "dropphyzpp": 434579998,
    "dropmaladd": "356 MAIN ST",
    "dropmalcty": "RISINGSUN",
    "dropmalst": "OH",
    "dropmalzpp": 434579998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194574111,
    "dropsitcph": 4194574111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22626",
    "droptype": "D",
    "dropname": "RITTMAN",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "RITTMAN",
    "dropdelst": "OH",
    "dropdelzpp": 442709998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "RITTMAN",
    "dropphyst": "OH",
    "dropphyzpp": 442709998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "RITTMAN",
    "dropmalst": "OH",
    "dropmalzpp": 442709998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3305905871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22643",
    "droptype": "D",
    "dropname": "ROBERTSVILLE",
    "dropdeladd": "11315 LINCOLN ST SE",
    "dropdelcty": "ROBERTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446709800,
    "dropphyadd": "11315 LINCOLN ST SE",
    "dropphycty": "ROBERTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBERTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446709998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308622525,
    "dropfax": 3308622525
  },
  {
    "dcode": "D",
    "dropkey": "PX22647",
    "droptype": "D",
    "dropname": "ROCK CREEK",
    "dropdeladd": "3046 E WATER ST",
    "dropdelcty": "ROCK CREEK",
    "dropdelst": "OH",
    "dropdelzpp": 440849800,
    "dropphyadd": "3046 E WATER ST",
    "dropphycty": "ROCK CREEK",
    "dropphyst": "OH",
    "dropphyzpp": 440849800,
    "dropmaladd": "3046 E WATER ST",
    "dropmalcty": "ROCK CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 440849800,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405633810,
    "dropfax": 4405633387
  },
  {
    "dcode": "D",
    "dropkey": "PX22649",
    "droptype": "D",
    "dropname": "ROCKBRIDGE",
    "dropdeladd": "26707 MAIN ST",
    "dropdelcty": "ROCKBRIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 431499900,
    "dropphyadd": "26707 MAIN ST",
    "dropphycty": "ROCKBRIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 431499900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKBRIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 431499998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403853492,
    "dropsitcph": 7403853492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22651",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "OH",
    "dropdelzpp": 458829998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "OH",
    "dropphyzpp": 458829998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "OH",
    "dropmalzpp": 458829998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193632694,
    "dropsitcph": 4193632694,
    "dropfax": 4193625621
  },
  {
    "dcode": "D",
    "dropkey": "PX22654",
    "droptype": "D",
    "dropname": "ROCKY RIDGE",
    "dropdeladd": "14800 W 3RD ST",
    "dropdelcty": "ROCKY RIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 434589998,
    "dropphyadd": "14800 W 3RD ST",
    "dropphycty": "ROCKY RIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 434589998,
    "dropmaladd": "14800 W 3RD ST",
    "dropmalcty": "ROCKY RIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 434589998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198982214,
    "dropsitcph": 4198982214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22658",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "7529 DEPOT ST",
    "dropdelcty": "ROGERS",
    "dropdelst": "OH",
    "dropdelzpp": 444559800,
    "dropphyadd": "7529 DEPOT ST",
    "dropphycty": "ROGERS",
    "dropphyst": "OH",
    "dropphyzpp": 444559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROGERS",
    "dropmalst": "OH",
    "dropmalzpp": 444559998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3302273370,
    "dropsitcph": 3302273370,
    "dropfax": 3302270818
  },
  {
    "dcode": "D",
    "dropkey": "PX22661",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "3232 US HIGHWAY 6",
    "dropdelcty": "ROME",
    "dropdelst": "OH",
    "dropdelzpp": 440859688,
    "dropphyadd": "3232 US HIGHWAY 6",
    "dropphycty": "ROME",
    "dropphyst": "OH",
    "dropphyzpp": 440859688,
    "dropmaladd": "3232 US HIGHWAY 6",
    "dropmalcty": "ROME",
    "dropmalst": "OH",
    "dropmalzpp": 440859688,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4405633413,
    "dropfax": 4405633413
  },
  {
    "dcode": "D",
    "dropkey": "PX22664",
    "droptype": "D",
    "dropname": "ROOTSTOWN",
    "dropdeladd": "4865 TALLMADGE RD",
    "dropdelcty": "ROOTSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 442729998,
    "dropphyadd": "4865 TALLMADGE RD",
    "dropphycty": "ROOTSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 442729998,
    "dropmaladd": "4865 TALLMADGE RD",
    "dropmalcty": "ROOTSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 442729998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303257248,
    "dropfax": 3303258849
  },
  {
    "dcode": "D",
    "dropkey": "PX22670",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "226 N MAIN ST",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437779901,
    "dropphyadd": "226 N MAIN ST",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437779901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437779997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406977173,
    "dropsitcph": 7406977173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22671",
    "droptype": "D",
    "dropname": "ROSEWOOD",
    "dropdeladd": "6492 KISER LAKE RD",
    "dropdelcty": "ROSEWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 430708000,
    "dropphyadd": "6492 KISER LAKE RD",
    "dropphycty": "ROSEWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 430708000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSEWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 430709998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373622187,
    "dropsitcph": 9373622187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22672",
    "droptype": "D",
    "dropname": "ROSS",
    "dropdeladd": "4275 HAMILTON CLEVES HWY",
    "dropdelcty": "ROSS",
    "dropdelst": "OH",
    "dropdelzpp": 450619998,
    "dropphyadd": "4275 HAMILTON CLEVES HWY",
    "dropphycty": "ROSS",
    "dropphyst": "OH",
    "dropphyzpp": 450619998,
    "dropmaladd": "4275 HAMILTON CLEVES HWY",
    "dropmalcty": "ROSS",
    "dropmalst": "OH",
    "dropmalzpp": 450619998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137385751,
    "dropsitcph": 5137385751,
    "dropfax": 5138671347
  },
  {
    "dcode": "D",
    "dropkey": "PX22673",
    "droptype": "D",
    "dropname": "ROSSBURG",
    "dropdeladd": "201 N BROAD ST",
    "dropdelcty": "ROSSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 453629998,
    "dropphyadd": "201 N BROAD ST",
    "dropphycty": "ROSSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 453629998,
    "dropmaladd": "201 N BROAD ST",
    "dropmalcty": "ROSSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 453629998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373385701,
    "dropsitcph": 9373385701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22677",
    "droptype": "D",
    "dropname": "ROUNDHEAD",
    "dropdeladd": "17770 N MAIN ST",
    "dropdelcty": "ROUNDHEAD",
    "dropdelst": "OH",
    "dropdelzpp": 433469700,
    "dropphyadd": "17770 N MAIN ST",
    "dropphycty": "ROUNDHEAD",
    "dropphyst": "OH",
    "dropphyzpp": 433469700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROUNDHEAD",
    "dropmalst": "OH",
    "dropmalzpp": 433469998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9374642606,
    "dropsitcph": 9374642606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22684",
    "droptype": "D",
    "dropname": "RUDOLPH",
    "dropdeladd": "14018 MERMILL RD",
    "dropdelcty": "RUDOLPH",
    "dropdelst": "OH",
    "dropdelzpp": 434629998,
    "dropphyadd": "14018 MERMILL RD",
    "dropphycty": "RUDOLPH",
    "dropphyst": "OH",
    "dropphyzpp": 434629998,
    "dropmaladd": "14018 MERMILL RD",
    "dropmalcty": "RUDOLPH",
    "dropmalst": "OH",
    "dropmalzpp": 434629998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196864041,
    "dropsitcph": 4196864041,
    "dropfax": 4196864042
  },
  {
    "dcode": "D",
    "dropkey": "PX22691",
    "droptype": "D",
    "dropname": "RUSHSYLVANIA",
    "dropdeladd": "106 N SANDUSKY ST",
    "dropdelcty": "RUSHSYLVANIA",
    "dropdelst": "OH",
    "dropdelzpp": 433479788,
    "dropphyadd": "106 N SANDUSKY ST",
    "dropphycty": "RUSHSYLVANIA",
    "dropphyst": "OH",
    "dropphyzpp": 433479788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSHSYLVANIA",
    "dropmalst": "OH",
    "dropmalzpp": 433479998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9374687491,
    "dropsitcph": 9374687491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22693",
    "droptype": "D",
    "dropname": "RUSHVILLE",
    "dropdeladd": "8525 MAIN ST",
    "dropdelcty": "RUSHVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431509900,
    "dropphyadd": "8525 MAIN ST",
    "dropphycty": "RUSHVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431509900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSHVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431509998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405369042,
    "dropsitcph": 7405369042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22697",
    "droptype": "D",
    "dropname": "RUSSELLS POINT",
    "dropdeladd": "901 STATE ROUTE 708",
    "dropdelcty": "RUSSELLS POINT",
    "dropdelst": "OH",
    "dropdelzpp": 433489997,
    "dropphyadd": "901 STATE ROUTE 708",
    "dropphycty": "RUSSELLS POINT",
    "dropphyst": "OH",
    "dropphyzpp": 433489997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSELLS POINT",
    "dropmalst": "OH",
    "dropmalzpp": 433489998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378434090,
    "dropsitcph": 9378434090,
    "dropfax": 9378432448
  },
  {
    "dcode": "D",
    "dropkey": "PX22701",
    "droptype": "D",
    "dropname": "RUSSIA",
    "dropdeladd": "234 W MAIN ST",
    "dropdelcty": "RUSSIA",
    "dropdelst": "OH",
    "dropdelzpp": 453639998,
    "dropphyadd": "234 W MAIN ST",
    "dropphycty": "RUSSIA",
    "dropphyst": "OH",
    "dropphyzpp": 453639998,
    "dropmaladd": "234 W MAIN ST",
    "dropmalcty": "RUSSIA",
    "dropmalst": "OH",
    "dropmalzpp": 453639998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375263856,
    "dropsitcph": 9375263856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22702",
    "droptype": "D",
    "dropname": "RUTLAND",
    "dropdeladd": "108 SALEM ST",
    "dropdelcty": "RUTLAND",
    "dropdelst": "OH",
    "dropdelzpp": 457759997,
    "dropphyadd": "108 SALEM ST",
    "dropphycty": "RUTLAND",
    "dropphyst": "OH",
    "dropphyzpp": 457759997,
    "dropmaladd": "108 SALEM ST",
    "dropmalcty": "RUTLAND",
    "dropmalst": "OH",
    "dropmalzpp": 457759997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407422509,
    "dropsitcph": 7407422509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22709",
    "droptype": "D",
    "dropname": "SABINA",
    "dropdeladd": "39 N HOWARD ST",
    "dropdelcty": "SABINA",
    "dropdelst": "OH",
    "dropdelzpp": 451699998,
    "dropphyadd": "39 N HOWARD ST",
    "dropphycty": "SABINA",
    "dropphyst": "OH",
    "dropphyzpp": 451699998,
    "dropmaladd": "39 N HOWARD ST",
    "dropmalcty": "SABINA",
    "dropmalst": "OH",
    "dropmalzpp": 451699998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375842484,
    "dropsitcph": 9375842484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22713",
    "droptype": "D",
    "dropname": "SAINT CLAIRSVILLE",
    "dropdeladd": "2 RESERVOIR RD",
    "dropdelcty": "SAINT CLAIRSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439509998,
    "dropphyadd": "2 RESERVOIR RD",
    "dropphycty": "SAINT CLAIRSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439509998,
    "dropmaladd": "2 RESERVOIR RD",
    "dropmalcty": "SAINT CLAIRSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439509998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406951030,
    "dropsitcph": 7406951030,
    "dropfax": 7406950020
  },
  {
    "dcode": "D",
    "dropkey": "PX22714",
    "droptype": "D",
    "dropname": "SAINT HENRY",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "SAINT HENRY",
    "dropdelst": "OH",
    "dropdelzpp": 458839998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "SAINT HENRY",
    "dropphyst": "OH",
    "dropphyzpp": 458839998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "SAINT HENRY",
    "dropmalst": "OH",
    "dropmalzpp": 458839998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196784005,
    "dropsitcph": 4196784005,
    "dropfax": 4196784005
  },
  {
    "dcode": "D",
    "dropkey": "PX22715",
    "droptype": "D",
    "dropname": "SAINT JOHNS",
    "dropdeladd": "19210 CENTER ST",
    "dropdelcty": "SAINT JOHNS",
    "dropdelst": "OH",
    "dropdelzpp": 458849998,
    "dropphyadd": "19210 CENTER ST",
    "dropphycty": "SAINT JOHNS",
    "dropphyst": "OH",
    "dropphyzpp": 458849998,
    "dropmaladd": "19210 CENTER ST",
    "dropmalcty": "SAINT JOHNS",
    "dropmalst": "OH",
    "dropmalzpp": 458849998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197386530,
    "dropsitcph": 4197386530,
    "dropfax": 4197380720
  },
  {
    "dcode": "D",
    "dropkey": "PX22716",
    "droptype": "D",
    "dropname": "SAINT LOUISVILLE",
    "dropdeladd": "27 N SUGAR ST",
    "dropdelcty": "SAINT LOUISVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430718000,
    "dropphyadd": "27 N SUGAR ST",
    "dropphycty": "SAINT LOUISVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430718000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT LOUISVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430719998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407455792,
    "dropsitcph": 7407455792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22718",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "120 N CHESTNUT ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "OH",
    "dropdelzpp": 458859998,
    "dropphyadd": "120 N CHESTNUT ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "OH",
    "dropphyzpp": 458859998,
    "dropmaladd": "120 N CHESTNUT ST",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "OH",
    "dropmalzpp": 458859998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193944155,
    "dropsitcph": 4193944155,
    "dropfax": 4193940755
  },
  {
    "dcode": "D",
    "dropkey": "PX22719",
    "droptype": "D",
    "dropname": "SAINT PARIS",
    "dropdeladd": "131 E MAIN ST",
    "dropdelcty": "SAINT PARIS",
    "dropdelst": "OH",
    "dropdelzpp": 430729008,
    "dropphyadd": "131 E MAIN ST",
    "dropphycty": "SAINT PARIS",
    "dropphyst": "OH",
    "dropphyzpp": 430729008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PARIS",
    "dropmalst": "OH",
    "dropmalzpp": 430729998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376630205,
    "dropsitcph": 9376630205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22722",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "275 PENN AVE",
    "dropdelcty": "SALEM",
    "dropdelst": "OH",
    "dropdelzpp": 444609998,
    "dropphyadd": "275 PENN AVE",
    "dropphycty": "SALEM",
    "dropphyst": "OH",
    "dropphyzpp": 444609998,
    "dropmaladd": "275 PENN AVE",
    "dropmalcty": "SALEM",
    "dropmalst": "OH",
    "dropmalzpp": 444609998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303325362,
    "dropsitcph": 3303325362,
    "dropfax": 3303327020
  },
  {
    "dcode": "D",
    "dropkey": "PX22725",
    "droptype": "D",
    "dropname": "SALINEVILLE",
    "dropdeladd": "37 W MAIN ST",
    "dropdelcty": "SALINEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439459998,
    "dropphyadd": "37 W MAIN ST",
    "dropphycty": "SALINEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439459998,
    "dropmaladd": "37 W MAIN ST",
    "dropmalcty": "SALINEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439459998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3306792600,
    "dropsitcph": 3306792600,
    "dropfax": 3306792600
  },
  {
    "dcode": "D",
    "dropkey": "PX22734",
    "droptype": "D",
    "dropname": "SANDUSKY",
    "dropdeladd": "2220 CALDWELL ST",
    "dropdelcty": "SANDUSKY",
    "dropdelst": "OH",
    "dropdelzpp": 448709998,
    "dropphyadd": "2220 CALDWELL ST",
    "dropphycty": "SANDUSKY",
    "dropphyst": "OH",
    "dropphyzpp": 448709998,
    "dropmaladd": "2220 CALDWELL ST",
    "dropmalcty": "SANDUSKY",
    "dropmalst": "OH",
    "dropmalzpp": 448709998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4196265525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22736",
    "droptype": "D",
    "dropname": "SANDYVILLE",
    "dropdeladd": "11248 SANDYVILLE RD NE",
    "dropdelcty": "SANDYVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446719800,
    "dropphyadd": "11248 SANDYVILLE RD NE",
    "dropphycty": "SANDYVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANDYVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446719998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308669237,
    "dropfax": 3308664449
  },
  {
    "dcode": "D",
    "dropkey": "PX22738",
    "droptype": "D",
    "dropname": "SARAHSVILLE",
    "dropdeladd": "315A MAIN ST",
    "dropdelcty": "SARAHSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437799997,
    "dropphyadd": "315A MAIN ST",
    "dropphycty": "SARAHSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437799997,
    "dropmaladd": "315A MAIN ST",
    "dropmalcty": "SARAHSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437799997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407324644,
    "dropsitcph": 7407324644,
    "dropfax": 7407324644
  },
  {
    "dcode": "D",
    "dropkey": "PX22739",
    "droptype": "D",
    "dropname": "SARDINIA",
    "dropdeladd": "104 BROAD ST",
    "dropdelcty": "SARDINIA",
    "dropdelst": "OH",
    "dropdelzpp": 451719998,
    "dropphyadd": "104 BROAD ST",
    "dropphycty": "SARDINIA",
    "dropphyst": "OH",
    "dropphyzpp": 451719998,
    "dropmaladd": "104 BROAD ST",
    "dropmalcty": "SARDINIA",
    "dropmalst": "OH",
    "dropmalzpp": 451719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5134461557,
    "dropsitcph": 9374461557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22740",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "37296 5TH AVE",
    "dropdelcty": "SARDIS",
    "dropdelst": "OH",
    "dropdelzpp": 439469800,
    "dropphyadd": "37296 5TH AVE",
    "dropphycty": "SARDIS",
    "dropphyst": "OH",
    "dropphyzpp": 439469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARDIS",
    "dropmalst": "OH",
    "dropmalzpp": 439469998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7404832262,
    "dropsitcph": 7404832262,
    "dropfax": 7404839847
  },
  {
    "dcode": "D",
    "dropkey": "PX22742",
    "droptype": "D",
    "dropname": "SAVANNAH",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "OH",
    "dropdelzpp": 448749800,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "OH",
    "dropphyzpp": 448749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "OH",
    "dropmalzpp": 448749998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199624249,
    "dropfax": 4199624249
  },
  {
    "dcode": "D",
    "dropkey": "PX22749",
    "droptype": "D",
    "dropname": "SCIO",
    "dropdeladd": "114 E MAIN ST",
    "dropdelcty": "SCIO",
    "dropdelst": "OH",
    "dropdelzpp": 439889800,
    "dropphyadd": "114 E MAIN ST",
    "dropphycty": "SCIO",
    "dropphyst": "OH",
    "dropphyzpp": 439889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCIO",
    "dropmalst": "OH",
    "dropmalzpp": 439889998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7409453041,
    "dropsitcph": 7409453041,
    "dropfax": 7409453041
  },
  {
    "dcode": "D",
    "dropkey": "PX22750",
    "droptype": "D",
    "dropname": "SCIOTO FURNACE",
    "dropdeladd": "8276 STATE ROUTE 140",
    "dropdelcty": "SCIOTO FURNACE",
    "dropdelst": "OH",
    "dropdelzpp": 456779800,
    "dropphyadd": "8276 STATE ROUTE 140",
    "dropphycty": "SCIOTO FURNACE",
    "dropphyst": "OH",
    "dropphyzpp": 456779800,
    "dropmaladd": "8276 STATE ROUTE 140",
    "dropmalcty": "SCIOTO FURNACE",
    "dropmalst": "OH",
    "dropmalzpp": 456779800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407782459,
    "dropsitcph": 7407782459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22755",
    "droptype": "D",
    "dropname": "SCOTT",
    "dropdeladd": "12436 BLAINE ST",
    "dropdelcty": "SCOTT",
    "dropdelst": "OH",
    "dropdelzpp": 458869998,
    "dropphyadd": "12436 BLAINE ST",
    "dropphycty": "SCOTT",
    "dropphyst": "OH",
    "dropphyzpp": 458869998,
    "dropmaladd": "12436 BLAINE ST",
    "dropmalcty": "SCOTT",
    "dropmalst": "OH",
    "dropmalzpp": 458869998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196225461,
    "dropsitcph": 4196225461,
    "dropfax": 4196226020
  },
  {
    "dcode": "D",
    "dropkey": "PX22756",
    "droptype": "D",
    "dropname": "SCOTTOWN",
    "dropdeladd": "11168 STATE ROUTE 217",
    "dropdelcty": "SCOTTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 456788987,
    "dropphyadd": "11168 STATE ROUTE 217",
    "dropphycty": "SCOTTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 456788987,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCOTTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 456789998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408866012,
    "dropsitcph": 7408866012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22758",
    "droptype": "D",
    "dropname": "SEAMAN",
    "dropdeladd": "6886 TRI COUNTY RD",
    "dropdelcty": "SEAMAN",
    "dropdelst": "OH",
    "dropdelzpp": 456799028,
    "dropphyadd": "6886 TRI COUNTY RD",
    "dropphycty": "SEAMAN",
    "dropphyst": "OH",
    "dropphyzpp": 456799028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEAMAN",
    "dropmalst": "OH",
    "dropmalzpp": 456799998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373862611,
    "dropsitcph": 9373862611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22760",
    "droptype": "D",
    "dropname": "SEBRING",
    "dropdeladd": "196 W OHIO AVE",
    "dropdelcty": "SEBRING",
    "dropdelst": "OH",
    "dropdelzpp": 446729998,
    "dropphyadd": "196 W OHIO AVE",
    "dropphycty": "SEBRING",
    "dropphyst": "OH",
    "dropphyzpp": 446729998,
    "dropmaladd": "196 W OHIO AVE",
    "dropmalcty": "SEBRING",
    "dropmalst": "OH",
    "dropmalzpp": 446729998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309386424,
    "dropfax": 3309389328
  },
  {
    "dcode": "D",
    "dropkey": "PX22761",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "61 FEDERAL ST SW",
    "dropdelcty": "SEDALIA",
    "dropdelst": "OH",
    "dropdelzpp": 431519900,
    "dropphyadd": "61 FEDERAL ST SW",
    "dropphycty": "SEDALIA",
    "dropphyst": "OH",
    "dropphyzpp": 431519900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEDALIA",
    "dropmalst": "OH",
    "dropmalzpp": 431519998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408743377,
    "dropsitcph": 7408743377,
    "dropfax": 7408743377
  },
  {
    "dcode": "D",
    "dropkey": "PX22765",
    "droptype": "D",
    "dropname": "SENECAVILLE",
    "dropdeladd": "206 HIGH ST",
    "dropdelcty": "SENECAVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437809900,
    "dropphyadd": "206 HIGH ST",
    "dropphycty": "SENECAVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437809900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECAVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437809998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406855387,
    "dropsitcph": 7406855387,
    "dropfax": 7406855387
  },
  {
    "dcode": "D",
    "dropkey": "PX22767",
    "droptype": "D",
    "dropname": "SEVEN MILE",
    "dropdeladd": "400 N MAIN ST",
    "dropdelcty": "SEVEN MILE",
    "dropdelst": "OH",
    "dropdelzpp": 450629998,
    "dropphyadd": "400 N MAIN ST",
    "dropphycty": "SEVEN MILE",
    "dropphyst": "OH",
    "dropphyzpp": 450629998,
    "dropmaladd": "400 N MAIN ST",
    "dropmalcty": "SEVEN MILE",
    "dropmalst": "OH",
    "dropmalzpp": 450629998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137266449,
    "dropsitcph": 5137266449,
    "dropfax": 5137264304
  },
  {
    "dcode": "D",
    "dropkey": "PX22769",
    "droptype": "D",
    "dropname": "SEVILLE",
    "dropdeladd": "44 E MARKET ST",
    "dropdelcty": "SEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 442739998,
    "dropphyadd": "44 E MARKET ST",
    "dropphycty": "SEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 442739998,
    "dropmaladd": "44 E MARKET ST",
    "dropmalcty": "SEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 442739998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307693450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22774",
    "droptype": "D",
    "dropname": "SHADYSIDE",
    "dropdeladd": "3989 LINCOLN AVE",
    "dropdelcty": "SHADYSIDE",
    "dropdelst": "OH",
    "dropdelzpp": 439479998,
    "dropphyadd": "3989 LINCOLN AVE",
    "dropphycty": "SHADYSIDE",
    "dropphyst": "OH",
    "dropphyzpp": 439479998,
    "dropmaladd": "3989 LINCOLN AVE",
    "dropmalcty": "SHADYSIDE",
    "dropmalst": "OH",
    "dropmalzpp": 439479998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406761231,
    "dropsitcph": 7406761231,
    "dropfax": 7406767643
  },
  {
    "dcode": "D",
    "dropkey": "PX22779",
    "droptype": "D",
    "dropname": "SHANDON",
    "dropdeladd": "4801 CINCINNATI BROOKVILLE RD",
    "dropdelcty": "SHANDON",
    "dropdelst": "OH",
    "dropdelzpp": 450639998,
    "dropphyadd": "4801 CINCINNATI BROOKVILLE RD",
    "dropphycty": "SHANDON",
    "dropphyst": "OH",
    "dropphyzpp": 450639998,
    "dropmaladd": "4801 CINCINNATI BROOKVILLE RD",
    "dropmalcty": "SHANDON",
    "dropmalst": "OH",
    "dropmalzpp": 450639998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137383210,
    "dropsitcph": 5137383210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22785",
    "droptype": "D",
    "dropname": "SHARON CENTER",
    "dropdeladd": "1332 SHARON COPLEY RD",
    "dropdelcty": "SHARON CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 442749800,
    "dropphyadd": "1332 SHARON COPLEY RD",
    "dropphycty": "SHARON CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 442749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARON CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 442749998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302391081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22796",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "26 N GAMBLE ST",
    "dropdelcty": "SHELBY",
    "dropdelst": "OH",
    "dropdelzpp": 448759998,
    "dropphyadd": "26 N GAMBLE ST",
    "dropphycty": "SHELBY",
    "dropphyst": "OH",
    "dropphyzpp": 448759998,
    "dropmaladd": "26 N GAMBLE ST",
    "dropmalcty": "SHELBY",
    "dropmalst": "OH",
    "dropmalzpp": 448759998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4193423101,
    "dropfax": 5672162031
  },
  {
    "dcode": "D",
    "dropkey": "PX22803",
    "droptype": "D",
    "dropname": "SHERRODSVILLE",
    "dropdeladd": "27 S SHERROD AVE",
    "dropdelcty": "SHERRODSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446759800,
    "dropphyadd": "27 S SHERROD AVE",
    "dropphycty": "SHERRODSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERRODSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446759998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7402696101,
    "dropfax": 7402696101
  },
  {
    "dcode": "D",
    "dropkey": "PX22804",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "109 N HARRISON ST",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 435569998,
    "dropphyadd": "109 N HARRISON ST",
    "dropphycty": "SHERWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 435569998,
    "dropmaladd": "109 N HARRISON ST",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 435569998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198992175,
    "dropsitcph": 4198901355,
    "dropfax": 4198901576
  },
  {
    "dcode": "D",
    "dropkey": "PX22805",
    "droptype": "D",
    "dropname": "SHILOH",
    "dropdeladd": "9 W MAIN ST",
    "dropdelcty": "SHILOH",
    "dropdelst": "OH",
    "dropdelzpp": 448789800,
    "dropphyadd": "9 W MAIN ST",
    "dropphycty": "SHILOH",
    "dropphyst": "OH",
    "dropphyzpp": 448789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHILOH",
    "dropmalst": "OH",
    "dropmalzpp": 448789998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4198963822,
    "dropfax": 4198963822
  },
  {
    "dcode": "D",
    "dropkey": "PX22811",
    "droptype": "D",
    "dropname": "SHREVE",
    "dropdeladd": "229 JONES ST",
    "dropdelcty": "SHREVE",
    "dropdelst": "OH",
    "dropdelzpp": 446769800,
    "dropphyadd": "229 JONES ST",
    "dropphycty": "SHREVE",
    "dropphyst": "OH",
    "dropphyzpp": 446769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHREVE",
    "dropmalst": "OH",
    "dropmalzpp": 446769998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307892175,
    "dropfax": 3307892054
  },
  {
    "dcode": "D",
    "dropkey": "PX22813",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "135 N OHIO AVE",
    "dropdelcty": "SIDNEY",
    "dropdelst": "OH",
    "dropdelzpp": 453659998,
    "dropphyadd": "135 N OHIO AVE",
    "dropphycty": "SIDNEY",
    "dropphyst": "OH",
    "dropphyzpp": 453659998,
    "dropmaladd": "135 N OHIO AVE",
    "dropmalcty": "SIDNEY",
    "dropmalst": "OH",
    "dropmalzpp": 453659998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374923181,
    "dropsitcph": 9374923181,
    "dropfax": 9374926160
  },
  {
    "dcode": "D",
    "dropkey": "PX22818",
    "droptype": "D",
    "dropname": "SINKING SPRING",
    "dropdeladd": "103 S MAIN ST",
    "dropdelcty": "SINKING SPRING",
    "dropdelst": "OH",
    "dropdelzpp": 451729998,
    "dropphyadd": "103 S MAIN ST",
    "dropphycty": "SINKING SPRING",
    "dropphyst": "OH",
    "dropphyzpp": 451729998,
    "dropmaladd": "103 S MAIN ST",
    "dropmalcty": "SINKING SPRING",
    "dropmalst": "OH",
    "dropmalzpp": 451729998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375883215,
    "dropsitcph": 9375883215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22819",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "1303 MAIN ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 439489997,
    "dropphyadd": "1303 MAIN ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 439489997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 439489998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7407337924,
    "dropsitcph": 7407337924,
    "dropfax": 7407337924
  },
  {
    "dcode": "D",
    "dropkey": "PX22820",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "152 E MAIN ST",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446779998,
    "dropphyadd": "152 E MAIN ST",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446779998,
    "dropmaladd": "152 E MAIN ST",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446779998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306692621,
    "dropfax": 3306692621
  },
  {
    "dcode": "D",
    "dropkey": "PX22831",
    "droptype": "D",
    "dropname": "SOMERDALE",
    "dropdeladd": "6088 STATE ROUTE 212 NE STE A",
    "dropdelcty": "SOMERDALE",
    "dropdelst": "OH",
    "dropdelzpp": 446789800,
    "dropphyadd": "6088 STATE ROUTE 212 NE STE A",
    "dropphycty": "SOMERDALE",
    "dropphyst": "OH",
    "dropphyzpp": 446789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERDALE",
    "dropmalst": "OH",
    "dropmalzpp": 446789998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308592445,
    "dropfax": 3308599925
  },
  {
    "dcode": "D",
    "dropkey": "PX22832",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "320 S COLUMBUS ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "OH",
    "dropdelzpp": 437839900,
    "dropphyadd": "320 S COLUMBUS ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "OH",
    "dropphyzpp": 437839900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERSET",
    "dropmalst": "OH",
    "dropmalzpp": 437839998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407431962,
    "dropsitcph": 7407431962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22834",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "156 S MAIN ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 450649998,
    "dropphyadd": "156 S MAIN ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 450649998,
    "dropmaladd": "156 S MAIN ST",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 450649998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137265377,
    "dropsitcph": 5137265377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22843",
    "droptype": "D",
    "dropname": "SOUTH CHARLESTON",
    "dropdeladd": "125 S CHILLICOTHE ST",
    "dropdelcty": "SOUTH CHARLESTON",
    "dropdelst": "OH",
    "dropdelzpp": 453689998,
    "dropphyadd": "125 S CHILLICOTHE ST",
    "dropphycty": "SOUTH CHARLESTON",
    "dropphyst": "OH",
    "dropphyzpp": 453689998,
    "dropmaladd": "125 S CHILLICOTHE ST",
    "dropmalcty": "SOUTH CHARLESTON",
    "dropmalst": "OH",
    "dropmalzpp": 453689998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374628501,
    "dropsitcph": 9374628501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22849",
    "droptype": "D",
    "dropname": "SOUTH LEBANON",
    "dropdeladd": "219 E FOREST AVE",
    "dropdelcty": "SOUTH LEBANON",
    "dropdelst": "OH",
    "dropdelzpp": 450659998,
    "dropphyadd": "219 E FOREST AVE",
    "dropphycty": "SOUTH LEBANON",
    "dropphyst": "OH",
    "dropphyzpp": 450659998,
    "dropmaladd": "219 E FOREST AVE",
    "dropmalcty": "SOUTH LEBANON",
    "dropmalst": "OH",
    "dropmalzpp": 450659998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5134942238,
    "dropsitcph": 5134942238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22857",
    "droptype": "D",
    "dropname": "SOUTH POINT",
    "dropdeladd": "108 COLLINS AVE",
    "dropdelcty": "SOUTH POINT",
    "dropdelst": "OH",
    "dropdelzpp": 456808501,
    "dropphyadd": "108 COLLINS AVE",
    "dropphycty": "SOUTH POINT",
    "dropphyst": "OH",
    "dropphyzpp": 456808501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH POINT",
    "dropmalst": "OH",
    "dropmalzpp": 456809998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403774002,
    "dropsitcph": 7403774002,
    "dropfax": 7403774904
  },
  {
    "dcode": "D",
    "dropkey": "PX22859",
    "droptype": "D",
    "dropname": "SOUTH SALEM",
    "dropdeladd": "3067 STEWART ST",
    "dropdelcty": "SOUTH SALEM",
    "dropdelst": "OH",
    "dropdelzpp": 456819802,
    "dropphyadd": "3067 STEWART ST",
    "dropphycty": "SOUTH SALEM",
    "dropphyst": "OH",
    "dropphyzpp": 456819802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH SALEM",
    "dropmalst": "OH",
    "dropmalzpp": 456819998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9379814037,
    "dropsitcph": 9379814037,
    "dropfax": 9379814037
  },
  {
    "dcode": "D",
    "dropkey": "PX22861",
    "droptype": "D",
    "dropname": "SOUTH SOLON",
    "dropdeladd": "7230 E MAIN ST",
    "dropdelcty": "SOUTH SOLON",
    "dropdelst": "OH",
    "dropdelzpp": 431539900,
    "dropphyadd": "7230 E MAIN ST",
    "dropphycty": "SOUTH SOLON",
    "dropphyst": "OH",
    "dropphyzpp": 431539900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH SOLON",
    "dropmalst": "OH",
    "dropmalzpp": 431539998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378832283,
    "dropsitcph": 9378832283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22862",
    "droptype": "D",
    "dropname": "SOUTH VIENNA",
    "dropdeladd": "21 1/2 W MAIN ST",
    "dropdelcty": "SOUTH VIENNA",
    "dropdelst": "OH",
    "dropdelzpp": 453699998,
    "dropphyadd": "21 1/2 W MAIN ST",
    "dropphycty": "SOUTH VIENNA",
    "dropphyst": "OH",
    "dropphyzpp": 453699998,
    "dropmaladd": "21 1/2 W MAIN ST",
    "dropmalcty": "SOUTH VIENNA",
    "dropmalst": "OH",
    "dropmalzpp": 453699998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375684470,
    "dropsitcph": 9375684470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22863",
    "droptype": "D",
    "dropname": "SOUTH WEBSTER",
    "dropdeladd": "141 JACKSON ST",
    "dropdelcty": "SOUTH WEBSTER",
    "dropdelst": "OH",
    "dropdelzpp": 456829117,
    "dropphyadd": "141 JACKSON ST",
    "dropphycty": "SOUTH WEBSTER",
    "dropphyst": "OH",
    "dropphyzpp": 456829117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH WEBSTER",
    "dropmalst": "OH",
    "dropmalzpp": 456829998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407783243,
    "dropsitcph": 7407783243,
    "dropfax": 7407783243
  },
  {
    "dcode": "D",
    "dropkey": "PX22865",
    "droptype": "D",
    "dropname": "SOUTHINGTON",
    "dropdeladd": "3307 STATE ROUTE 534",
    "dropdelcty": "SOUTHINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 444709800,
    "dropphyadd": "3307 STATE ROUTE 534",
    "dropphycty": "SOUTHINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 444709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTHINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 444709998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308986788,
    "dropsitcph": 3308986788,
    "dropfax": 3308986788
  },
  {
    "dcode": "D",
    "dropkey": "PX22869",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "8 W MAIN ST",
    "dropdelcty": "SPARTA",
    "dropdelst": "OH",
    "dropdelzpp": 433509700,
    "dropphyadd": "8 W MAIN ST",
    "dropphycty": "SPARTA",
    "dropphyst": "OH",
    "dropphyzpp": 433509700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPARTA",
    "dropmalst": "OH",
    "dropmalzpp": 433509998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4197683135,
    "dropsitcph": 4197683135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22871",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "106 S JACKSON ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "OH",
    "dropdelzpp": 442759998,
    "dropphyadd": "106 S JACKSON ST",
    "dropphycty": "SPENCER",
    "dropphyst": "OH",
    "dropphyzpp": 442759998,
    "dropmaladd": "106 S JACKSON ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "OH",
    "dropmalzpp": 442759998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306482631,
    "dropfax": 3306481318
  },
  {
    "dcode": "D",
    "dropkey": "PX22872",
    "droptype": "D",
    "dropname": "SPENCERVILLE",
    "dropdeladd": "121 S BROADWAY ST",
    "dropdelcty": "SPENCERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 458879998,
    "dropphyadd": "121 S BROADWAY ST",
    "dropphycty": "SPENCERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 458879998,
    "dropmaladd": "121 S BROADWAY ST",
    "dropmalcty": "SPENCERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 458879998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196474640,
    "dropsitcph": 4196474640,
    "dropfax": 4196474640
  },
  {
    "dcode": "D",
    "dropkey": "PX22886",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "9 W MAIN ST",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "OH",
    "dropdelzpp": 453709998,
    "dropphyadd": "9 W MAIN ST",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "OH",
    "dropphyzpp": 453709998,
    "dropmaladd": "9 W MAIN ST",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "OH",
    "dropmalzpp": 453709998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378627511,
    "dropsitcph": 9378627511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22888",
    "droptype": "D",
    "dropname": "SPRINGBORO",
    "dropdeladd": "55 S PIONEER BLVD",
    "dropdelcty": "SPRINGBORO",
    "dropdelst": "OH",
    "dropdelzpp": 450669998,
    "dropphyadd": "55 S PIONEER BLVD",
    "dropphycty": "SPRINGBORO",
    "dropphyst": "OH",
    "dropphyzpp": 450669998,
    "dropmaladd": "55 S PIONEER BLVD",
    "dropmalcty": "SPRINGBORO",
    "dropmalst": "OH",
    "dropmalzpp": 450669998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 9377460340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22891",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "150 N LIMESTONE ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 455019998,
    "dropphyadd": "150 N LIMESTONE ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 455019998,
    "dropmaladd": "150 N LIMESTONE ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 455019998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373232876,
    "dropsitcph": 9373236497,
    "dropfax": 9373236566
  },
  {
    "dcode": "D",
    "dropkey": "PX22986",
    "droptype": "D",
    "dropname": "STEUBENVILLE",
    "dropdeladd": "150 N 3RD ST",
    "dropdelcty": "STEUBENVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439529998,
    "dropphyadd": "150 N 3RD ST",
    "dropphycty": "STEUBENVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439529998,
    "dropmaladd": "150 N 3RD ST",
    "dropmalcty": "STEUBENVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439529998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7402826221,
    "dropsitcph": 7402826221,
    "dropfax": 7402826681
  },
  {
    "dcode": "D",
    "dropkey": "PX22987",
    "droptype": "D",
    "dropname": "STEWART",
    "dropdeladd": "8125 STATE ROUTE 329",
    "dropdelcty": "STEWART",
    "dropdelst": "OH",
    "dropdelzpp": 457789800,
    "dropphyadd": "8125 STATE ROUTE 329",
    "dropphycty": "STEWART",
    "dropphyst": "OH",
    "dropphyzpp": 457789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEWART",
    "dropmalst": "OH",
    "dropmalzpp": 457789998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406624541,
    "dropsitcph": 7406624541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22995",
    "droptype": "D",
    "dropname": "STOCKPORT",
    "dropdeladd": "1975 MAIN ST",
    "dropdelcty": "STOCKPORT",
    "dropdelst": "OH",
    "dropdelzpp": 437879900,
    "dropphyadd": "1975 MAIN ST",
    "dropphycty": "STOCKPORT",
    "dropphyst": "OH",
    "dropphyzpp": 437879900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKPORT",
    "dropmalst": "OH",
    "dropmalzpp": 437879998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405592991,
    "dropsitcph": 7405592991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX22997",
    "droptype": "D",
    "dropname": "STONE CREEK",
    "dropdeladd": "107 W JEFFERSON ST",
    "dropdelcty": "STONE CREEK",
    "dropdelst": "OH",
    "dropdelzpp": 438409009,
    "dropphyadd": "107 W JEFFERSON ST",
    "dropphycty": "STONE CREEK",
    "dropphyst": "OH",
    "dropphyzpp": 438409009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONE CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 438409998,
    "dropsitphn": 6144720674,
    "dropsitlph": 3303395220,
    "dropsitcph": 3303395220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23000",
    "droptype": "D",
    "dropname": "STONY RIDGE",
    "dropdeladd": "5725 FREMONT PIKE",
    "dropdelcty": "STONY RIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 434639998,
    "dropphyadd": "5725 FREMONT PIKE",
    "dropphycty": "STONY RIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 434639998,
    "dropmaladd": "5725 FREMONT PIKE",
    "dropmalcty": "STONY RIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 434639998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198376688,
    "dropsitcph": 4198376688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23001",
    "droptype": "D",
    "dropname": "STOUT",
    "dropdeladd": "14 2ND ST",
    "dropdelcty": "STOUT",
    "dropdelst": "OH",
    "dropdelzpp": 456848977,
    "dropphyadd": "14 2ND ST",
    "dropphycty": "STOUT",
    "dropphyst": "OH",
    "dropphyzpp": 456848977,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOUT",
    "dropmalst": "OH",
    "dropmalzpp": 456849998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375492167,
    "dropsitcph": 9375492167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23002",
    "droptype": "D",
    "dropname": "STOUTSVILLE",
    "dropdeladd": "11438 MAIN ST",
    "dropdelcty": "STOUTSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431549900,
    "dropphyadd": "11438 MAIN ST",
    "dropphycty": "STOUTSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOUTSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431549998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404741664,
    "dropsitcph": 7404741664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23006",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "120 N WOOSTER AVE",
    "dropdelcty": "STRASBURG",
    "dropdelst": "OH",
    "dropdelzpp": 446809998,
    "dropphyadd": "120 N WOOSTER AVE",
    "dropphycty": "STRASBURG",
    "dropphyst": "OH",
    "dropphyzpp": 446809998,
    "dropmaladd": "120 N WOOSTER AVE",
    "dropmalcty": "STRASBURG",
    "dropmalst": "OH",
    "dropmalzpp": 446809998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308785631,
    "dropfax": 3308785631
  },
  {
    "dcode": "D",
    "dropkey": "PX23008",
    "droptype": "D",
    "dropname": "STRATTON",
    "dropdeladd": "107 2ND AVE",
    "dropdelcty": "STRATTON",
    "dropdelst": "OH",
    "dropdelzpp": 439619800,
    "dropphyadd": "107 2ND AVE",
    "dropphycty": "STRATTON",
    "dropphyst": "OH",
    "dropphyzpp": 439619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATTON",
    "dropmalst": "OH",
    "dropmalzpp": 439619998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405374402,
    "dropsitcph": 7405374402,
    "dropfax": 7405371846
  },
  {
    "dcode": "D",
    "dropkey": "PX23016",
    "droptype": "D",
    "dropname": "STRUTHERS",
    "dropdeladd": "195 S BRIDGE ST",
    "dropdelcty": "STRUTHERS",
    "dropdelst": "OH",
    "dropdelzpp": 444719998,
    "dropphyadd": "195 S BRIDGE ST",
    "dropphycty": "STRUTHERS",
    "dropphyst": "OH",
    "dropphyzpp": 444719998,
    "dropmaladd": "195 S BRIDGE ST",
    "dropmalcty": "STRUTHERS",
    "dropmalst": "OH",
    "dropmalzpp": 444719998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307501316,
    "dropsitcph": 3307501316,
    "dropfax": 3307501316
  },
  {
    "dcode": "D",
    "dropkey": "PX23017",
    "droptype": "D",
    "dropname": "STRYKER",
    "dropdeladd": "110 S DEFIANCE ST",
    "dropdelcty": "STRYKER",
    "dropdelst": "OH",
    "dropdelzpp": 435579998,
    "dropphyadd": "110 S DEFIANCE ST",
    "dropphycty": "STRYKER",
    "dropphyst": "OH",
    "dropphyzpp": 435579998,
    "dropmaladd": "110 S DEFIANCE ST",
    "dropmalcty": "STRYKER",
    "dropmalst": "OH",
    "dropmalzpp": 435579998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196823221,
    "dropsitcph": 4196823221,
    "dropfax": 4196823221
  },
  {
    "dcode": "D",
    "dropkey": "PX23019",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "201 S ELM ST",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "OH",
    "dropdelzpp": 431559900,
    "dropphyadd": "201 S ELM ST",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "OH",
    "dropphyzpp": 431559900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "OH",
    "dropmalzpp": 431559998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407468442,
    "dropsitcph": 7407468442,
    "dropfax": 7407468442
  },
  {
    "dcode": "D",
    "dropkey": "PX23022",
    "droptype": "D",
    "dropname": "SUGARCREEK",
    "dropdeladd": "210 FACTORY ST NE",
    "dropdelcty": "SUGARCREEK",
    "dropdelst": "OH",
    "dropdelzpp": 446819998,
    "dropphyadd": "210 FACTORY ST NE",
    "dropphycty": "SUGARCREEK",
    "dropphyst": "OH",
    "dropphyzpp": 446819998,
    "dropmaladd": "210 FACTORY ST NE",
    "dropmalcty": "SUGARCREEK",
    "dropmalst": "OH",
    "dropmalzpp": 446819998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308522722,
    "dropfax": 3308523429
  },
  {
    "dcode": "D",
    "dropkey": "PX23023",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "245 TOWNSHIP ROAD 481",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "OH",
    "dropdelzpp": 448809785,
    "dropphyadd": "245 TOWNSHIP ROAD 481",
    "dropphycty": "SULLIVAN",
    "dropphyst": "OH",
    "dropphyzpp": 448809785,
    "dropmaladd": "245 TOWNSHIP ROAD 481",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "OH",
    "dropmalzpp": 448809785,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197362081,
    "dropfax": 4197362542
  },
  {
    "dcode": "D",
    "dropkey": "PX23025",
    "droptype": "D",
    "dropname": "SULPHUR SPRINGS",
    "dropdeladd": "4861 ZEIGLER RD",
    "dropdelcty": "SULPHUR SPRINGS",
    "dropdelst": "OH",
    "dropdelzpp": 448819800,
    "dropphyadd": "4861 ZEIGLER RD",
    "dropphycty": "SULPHUR SPRINGS",
    "dropphyst": "OH",
    "dropphyzpp": 448819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SULPHUR SPRINGS",
    "dropmalst": "OH",
    "dropmalzpp": 448819998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195626269,
    "dropfax": 4195626269
  },
  {
    "dcode": "D",
    "dropkey": "PX23027",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "300 W CROSS ST",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 437889900,
    "dropphyadd": "300 W CROSS ST",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 437889900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 437889998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408384805,
    "dropsitcph": 7408384805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23032",
    "droptype": "D",
    "dropname": "SUMMIT STATION",
    "dropdeladd": "6396 SUMMIT RD SW",
    "dropdelcty": "SUMMIT STATION",
    "dropdelst": "OH",
    "dropdelzpp": 430738000,
    "dropphyadd": "6396 SUMMIT RD SW",
    "dropphycty": "SUMMIT STATION",
    "dropphyst": "OH",
    "dropphyzpp": 430738000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMIT STATION",
    "dropmalst": "OH",
    "dropmalzpp": 430739998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409270473,
    "dropsitcph": 7409270473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23033",
    "droptype": "D",
    "dropname": "SUMMITVILLE",
    "dropdeladd": "15521 STATE ROUTE 644",
    "dropdelcty": "SUMMITVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439629800,
    "dropphyadd": "15521 STATE ROUTE 644",
    "dropphycty": "SUMMITVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMITVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439629998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3302231211,
    "dropsitcph": 3302231211,
    "dropfax": 3302231211
  },
  {
    "dcode": "D",
    "dropkey": "PX23034",
    "droptype": "D",
    "dropname": "SUNBURY",
    "dropdeladd": "267 W GRANVILLE ST",
    "dropdelcty": "SUNBURY",
    "dropdelst": "OH",
    "dropdelzpp": 430749013,
    "dropphyadd": "267 W GRANVILLE ST",
    "dropphycty": "SUNBURY",
    "dropphyst": "OH",
    "dropphyzpp": 430749013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNBURY",
    "dropmalst": "OH",
    "dropmalzpp": 430749998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409652471,
    "dropsitcph": 7409652471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23039",
    "droptype": "D",
    "dropname": "SWANTON",
    "dropdeladd": "250 S HALLETT AVE",
    "dropdelcty": "SWANTON",
    "dropdelst": "OH",
    "dropdelzpp": 435581524,
    "dropphyadd": "250 S HALLETT AVE",
    "dropphycty": "SWANTON",
    "dropphyst": "OH",
    "dropphyzpp": 435581524,
    "dropmaladd": "250 S HALLETT AVE",
    "dropmalcty": "SWANTON",
    "dropmalst": "OH",
    "dropmalzpp": 435581524,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198251914,
    "dropsitcph": 4198251914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23042",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "201 S SYCAMORE AVE",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "OH",
    "dropdelzpp": 448829800,
    "dropphyadd": "201 S SYCAMORE AVE",
    "dropphycty": "SYCAMORE",
    "dropphyst": "OH",
    "dropphyzpp": 448829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "OH",
    "dropmalzpp": 448829998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199272244,
    "dropfax": 4199272244
  },
  {
    "dcode": "D",
    "dropkey": "PX23045",
    "droptype": "D",
    "dropname": "SYLVANIA",
    "dropdeladd": "5745 POST OFFICE WAY",
    "dropdelcty": "SYLVANIA",
    "dropdelst": "OH",
    "dropdelzpp": 435609998,
    "dropphyadd": "5745 POST OFFICE WAY",
    "dropphycty": "SYLVANIA",
    "dropphyst": "OH",
    "dropphyzpp": 435609998,
    "dropmaladd": "5745 POST OFFICE WAY",
    "dropmalcty": "SYLVANIA",
    "dropmalst": "OH",
    "dropmalzpp": 435609998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198822531,
    "dropsitcph": 4198822531,
    "dropfax": 4198852981
  },
  {
    "dcode": "D",
    "dropkey": "PX23048",
    "droptype": "D",
    "dropname": "SYRACUSE",
    "dropdeladd": "2391 3RD ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "OH",
    "dropdelzpp": 457799800,
    "dropphyadd": "2391 3RD ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "OH",
    "dropphyzpp": 457799800,
    "dropmaladd": "2391 3RD ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "OH",
    "dropmalzpp": 457799800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409925821,
    "dropsitcph": 7409925821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23051",
    "droptype": "D",
    "dropname": "TALLMADGE",
    "dropdeladd": "162 NORTHEAST AVE",
    "dropdelcty": "TALLMADGE",
    "dropdelst": "OH",
    "dropdelzpp": 442789998,
    "dropphyadd": "162 NORTHEAST AVE",
    "dropphycty": "TALLMADGE",
    "dropphyst": "OH",
    "dropphyzpp": 442789998,
    "dropmaladd": "162 NORTHEAST AVE",
    "dropmalcty": "TALLMADGE",
    "dropmalst": "OH",
    "dropmalzpp": 442789998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3306309063,
    "dropfax": 3306309839
  },
  {
    "dcode": "D",
    "dropkey": "PX23057",
    "droptype": "D",
    "dropname": "TERRACE PARK",
    "dropdeladd": "409 TERRACE PL",
    "dropdelcty": "TERRACE PARK",
    "dropdelst": "OH",
    "dropdelzpp": 451749998,
    "dropphyadd": "409 TERRACE PL",
    "dropphycty": "TERRACE PARK",
    "dropphyst": "OH",
    "dropphyzpp": 451749998,
    "dropmaladd": "409 TERRACE PL",
    "dropmalcty": "TERRACE PARK",
    "dropmalst": "OH",
    "dropmalzpp": 451749998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138315867,
    "dropsitcph": 5138315867,
    "dropfax": 5138315867
  },
  {
    "dcode": "D",
    "dropkey": "PX23067",
    "droptype": "D",
    "dropname": "THE PLAINS",
    "dropdeladd": "40 N PLAINS RD",
    "dropdelcty": "THE PLAINS",
    "dropdelst": "OH",
    "dropdelzpp": 457809800,
    "dropphyadd": "40 N PLAINS RD",
    "dropphycty": "THE PLAINS",
    "dropphyst": "OH",
    "dropphyzpp": 457809800,
    "dropmaladd": "40 N PLAINS RD",
    "dropmalcty": "THE PLAINS",
    "dropmalst": "OH",
    "dropmalzpp": 457809800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407974437,
    "dropsitcph": 7407974437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23069",
    "droptype": "D",
    "dropname": "THOMPSON",
    "dropdeladd": "6714 MADISON RD",
    "dropdelcty": "THOMPSON",
    "dropdelst": "OH",
    "dropdelzpp": 440868774,
    "dropphyadd": "6714 MADISON RD",
    "dropphycty": "THOMPSON",
    "dropphyst": "OH",
    "dropphyzpp": 440868774,
    "dropmaladd": "6714 MADISON RD",
    "dropmalcty": "THOMPSON",
    "dropmalst": "OH",
    "dropmalzpp": 440868774,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402983331,
    "dropfax": 4402983370
  },
  {
    "dcode": "D",
    "dropkey": "PX23070",
    "droptype": "D",
    "dropname": "THORNVILLE",
    "dropdeladd": "11 N MAIN ST",
    "dropdelcty": "THORNVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430769442,
    "dropphyadd": "11 N MAIN ST",
    "dropphycty": "THORNVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430769442,
    "dropmaladd": "11 N MAIN ST",
    "dropmalcty": "THORNVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430769998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402466155,
    "dropsitcph": 7402466155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23071",
    "droptype": "D",
    "dropname": "THURMAN",
    "dropdeladd": "315 STATE ROUTE 279",
    "dropdelcty": "THURMAN",
    "dropdelst": "OH",
    "dropdelzpp": 456859800,
    "dropphyadd": "315 STATE ROUTE 279",
    "dropphycty": "THURMAN",
    "dropphyst": "OH",
    "dropphyzpp": 456859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THURMAN",
    "dropmalst": "OH",
    "dropmalzpp": 456859998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7402459450,
    "dropsitcph": 7402459450,
    "dropfax": 7402451411
  },
  {
    "dcode": "D",
    "dropkey": "PX23072",
    "droptype": "D",
    "dropname": "THURSTON",
    "dropdeladd": "8053 HIGH ST",
    "dropdelcty": "THURSTON",
    "dropdelst": "OH",
    "dropdelzpp": 431579900,
    "dropphyadd": "8053 HIGH ST",
    "dropphycty": "THURSTON",
    "dropphyst": "OH",
    "dropphyzpp": 431579900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THURSTON",
    "dropmalst": "OH",
    "dropmalzpp": 431579998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408628825,
    "dropsitcph": 7408628825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23076",
    "droptype": "D",
    "dropname": "TIFFIN",
    "dropdeladd": "175 S MONROE ST",
    "dropdelcty": "TIFFIN",
    "dropdelst": "OH",
    "dropdelzpp": 448839998,
    "dropphyadd": "175 S MONROE ST",
    "dropphycty": "TIFFIN",
    "dropphyst": "OH",
    "dropphyzpp": 448839998,
    "dropmaladd": "175 S MONROE ST",
    "dropmalcty": "TIFFIN",
    "dropmalst": "OH",
    "dropmalzpp": 448839998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4194476323,
    "dropfax": 4194473176
  },
  {
    "dcode": "D",
    "dropkey": "PX23077",
    "droptype": "D",
    "dropname": "TILTONSVILLE",
    "dropdeladd": "218 GRANDVIEW AVE",
    "dropdelcty": "TILTONSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439639998,
    "dropphyadd": "218 GRANDVIEW AVE",
    "dropphycty": "TILTONSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439639998,
    "dropmaladd": "218 GRANDVIEW AVE",
    "dropmalcty": "TILTONSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439639998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7408594290,
    "dropsitcph": 7408594290,
    "dropfax": 7408594290
  },
  {
    "dcode": "D",
    "dropkey": "PX23080",
    "droptype": "D",
    "dropname": "TIPP CITY",
    "dropdeladd": "520 N HYATT ST",
    "dropdelcty": "TIPP CITY",
    "dropdelst": "OH",
    "dropdelzpp": 453719998,
    "dropphyadd": "520 N HYATT ST",
    "dropphycty": "TIPP CITY",
    "dropphyst": "OH",
    "dropphyzpp": 453719998,
    "dropmaladd": "520 N HYATT ST",
    "dropmalcty": "TIPP CITY",
    "dropmalst": "OH",
    "dropmalzpp": 453719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376673012,
    "dropsitcph": 9376673012,
    "dropfax": 9376671880
  },
  {
    "dcode": "D",
    "dropkey": "PX23084",
    "droptype": "D",
    "dropname": "TIRO",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "TIRO",
    "dropdelst": "OH",
    "dropdelzpp": 448879800,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "TIRO",
    "dropphyst": "OH",
    "dropphyzpp": 448879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIRO",
    "dropmalst": "OH",
    "dropmalzpp": 448879998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4193476755,
    "dropfax": 4193473814
  },
  {
    "dcode": "D",
    "dropkey": "PX23088",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "435 S SAINT CLAIR ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436019998,
    "dropphyadd": "435 S SAINT CLAIR ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436019998,
    "dropmaladd": "435 S SAINT CLAIR ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436019998,
    "dropsitphn": 4192456870,
    "dropsitlph": 4192456870,
    "dropsitcph": 4192456802,
    "dropfax": 4196845763
  },
  {
    "dcode": "D",
    "dropkey": "PX23091",
    "droptype": "D",
    "dropname": "TONTOGANY",
    "dropdeladd": "17666 KELLOGG RD",
    "dropdelcty": "TONTOGANY",
    "dropdelst": "OH",
    "dropdelzpp": 435659998,
    "dropphyadd": "17666 KELLOGG RD",
    "dropphycty": "TONTOGANY",
    "dropphyst": "OH",
    "dropphyzpp": 435659998,
    "dropmaladd": "17666 KELLOGG RD",
    "dropmalcty": "TONTOGANY",
    "dropmalst": "OH",
    "dropmalzpp": 435659998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198233187,
    "dropsitcph": 4198233187,
    "dropfax": 4198235054
  },
  {
    "dcode": "D",
    "dropkey": "PX23093",
    "droptype": "D",
    "dropname": "TORONTO",
    "dropdeladd": "106 S 4TH ST",
    "dropdelcty": "TORONTO",
    "dropdelst": "OH",
    "dropdelzpp": 439649998,
    "dropphyadd": "106 S 4TH ST",
    "dropphycty": "TORONTO",
    "dropphyst": "OH",
    "dropphyzpp": 439649998,
    "dropmaladd": "106 S 4TH ST",
    "dropmalcty": "TORONTO",
    "dropmalst": "OH",
    "dropmalzpp": 439649998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7405373222,
    "dropsitcph": 7405373222,
    "dropfax": 7405373222
  },
  {
    "dcode": "D",
    "dropkey": "PX23098",
    "droptype": "D",
    "dropname": "TREMONT CITY",
    "dropdeladd": "57 E MAIN",
    "dropdelcty": "TREMONT CITY",
    "dropdelst": "OH",
    "dropdelzpp": 453729998,
    "dropphyadd": "57 E MAIN",
    "dropphycty": "TREMONT CITY",
    "dropphyst": "OH",
    "dropphyzpp": 453729998,
    "dropmaladd": "57 E MAIN",
    "dropmalcty": "TREMONT CITY",
    "dropmalst": "OH",
    "dropmalzpp": 453729998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9379698646,
    "dropsitcph": 9379698646,
    "dropfax": 9379698646
  },
  {
    "dcode": "D",
    "dropkey": "PX23101",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "290 EDGEWOOD DR",
    "dropdelcty": "TRENTON",
    "dropdelst": "OH",
    "dropdelzpp": 450679998,
    "dropphyadd": "290 EDGEWOOD DR",
    "dropphycty": "TRENTON",
    "dropphyst": "OH",
    "dropphyzpp": 450679998,
    "dropmaladd": "290 EDGEWOOD DR",
    "dropmalcty": "TRENTON",
    "dropmalst": "OH",
    "dropmalzpp": 450679998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139885618,
    "dropsitcph": 5139885618,
    "dropfax": 5139885618
  },
  {
    "dcode": "D",
    "dropkey": "PX23107",
    "droptype": "D",
    "dropname": "TRINWAY",
    "dropdeladd": "12925 MAIN ST",
    "dropdelcty": "TRINWAY",
    "dropdelst": "OH",
    "dropdelzpp": 438429000,
    "dropphyadd": "12925 MAIN ST",
    "dropphycty": "TRINWAY",
    "dropphyst": "OH",
    "dropphyzpp": 438429000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRINWAY",
    "dropmalst": "OH",
    "dropmalzpp": 438429998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407542981,
    "dropsitcph": 7407542981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23111",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "305 S MARKET ST OFC",
    "dropdelcty": "TROY",
    "dropdelst": "OH",
    "dropdelzpp": 453739998,
    "dropphyadd": "305 S MARKET ST OFC",
    "dropphycty": "TROY",
    "dropphyst": "OH",
    "dropphyzpp": 453739998,
    "dropmaladd": "305 S MARKET ST OFC",
    "dropmalcty": "TROY",
    "dropmalst": "OH",
    "dropmalzpp": 453739998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373392697,
    "dropsitcph": 9373392697,
    "dropfax": 9373390343
  },
  {
    "dcode": "D",
    "dropkey": "PX23116",
    "droptype": "D",
    "dropname": "TUPPERS PLAINS",
    "dropdeladd": "42160 STATE ROUTE 7",
    "dropdelcty": "TUPPERS PLAINS",
    "dropdelst": "OH",
    "dropdelzpp": 457839800,
    "dropphyadd": "42160 STATE ROUTE 7",
    "dropphycty": "TUPPERS PLAINS",
    "dropphyst": "OH",
    "dropphyzpp": 457839800,
    "dropmaladd": "42160 STATE ROUTE 7",
    "dropmalcty": "TUPPERS PLAINS",
    "dropmalst": "OH",
    "dropmalzpp": 457839800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405935578,
    "dropsitcph": 7406676305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23118",
    "droptype": "D",
    "dropname": "TUSCARAWAS",
    "dropdeladd": "105 N MAIN ST",
    "dropdelcty": "TUSCARAWAS",
    "dropdelst": "OH",
    "dropdelzpp": 446829800,
    "dropphyadd": "105 N MAIN ST",
    "dropphycty": "TUSCARAWAS",
    "dropphyst": "OH",
    "dropphyzpp": 446829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUSCARAWAS",
    "dropmalst": "OH",
    "dropmalzpp": 446829998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7409225298,
    "dropfax": 7409229579
  },
  {
    "dcode": "D",
    "dropkey": "PX23122",
    "droptype": "D",
    "dropname": "TWINSBURG",
    "dropdeladd": "8935 DARROW RD",
    "dropdelcty": "TWINSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 440879998,
    "dropphyadd": "8935 DARROW RD",
    "dropphycty": "TWINSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 440879998,
    "dropmaladd": "8935 DARROW RD",
    "dropmalcty": "TWINSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 440879998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 3304258032,
    "dropfax": 3309636139
  },
  {
    "dcode": "D",
    "dropkey": "PX23126",
    "droptype": "D",
    "dropname": "UHRICHSVILLE",
    "dropdeladd": "305 E 3RD ST",
    "dropdelcty": "UHRICHSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 446839998,
    "dropphyadd": "305 E 3RD ST",
    "dropphycty": "UHRICHSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 446839998,
    "dropmaladd": "305 E 3RD ST",
    "dropmalcty": "UHRICHSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 446839998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 7409223051,
    "dropfax": 7409220098
  },
  {
    "dcode": "D",
    "dropkey": "PX23132",
    "droptype": "D",
    "dropname": "UNION FURNACE",
    "dropdeladd": "18006 MAIN ST",
    "dropdelcty": "UNION FURNACE",
    "dropdelst": "OH",
    "dropdelzpp": 431589900,
    "dropphyadd": "18006 MAIN ST",
    "dropphycty": "UNION FURNACE",
    "dropphyst": "OH",
    "dropphyzpp": 431589900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION FURNACE",
    "dropmalst": "OH",
    "dropmalzpp": 431589998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403854057,
    "dropsitcph": 7403854057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23137",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "11230 CLEVELAND AVE NW",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 446859998,
    "dropphyadd": "11230 CLEVELAND AVE NW",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 446859998,
    "dropmaladd": "11230 CLEVELAND AVE NW",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 446859998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309665100,
    "dropfax": 3304942601
  },
  {
    "dcode": "D",
    "dropkey": "PX23138",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "6887 S RIDGE RD",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 440889800,
    "dropphyadd": "6887 S RIDGE RD",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 440889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 440889998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4404282361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23139",
    "droptype": "D",
    "dropname": "UNIONVILLE CENTER",
    "dropdeladd": "110 W MAIN ST",
    "dropdelcty": "UNIONVILLE CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 430778000,
    "dropphyadd": "110 W MAIN ST",
    "dropphycty": "UNIONVILLE CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 430778000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONVILLE CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 430779998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148735153,
    "dropsitcph": 6148735153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23140",
    "droptype": "D",
    "dropname": "UNIOPOLIS",
    "dropdeladd": "7 N MAIN ST",
    "dropdelcty": "UNIOPOLIS",
    "dropdelst": "OH",
    "dropdelzpp": 458889998,
    "dropphyadd": "7 N MAIN ST",
    "dropphycty": "UNIOPOLIS",
    "dropphyst": "OH",
    "dropphyzpp": 458889998,
    "dropmaladd": "7 N MAIN ST",
    "dropmalcty": "UNIOPOLIS",
    "dropmalst": "OH",
    "dropmalzpp": 458889998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197388448,
    "dropsitcph": 4197388448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23158",
    "droptype": "D",
    "dropname": "UPPER SANDUSKY",
    "dropdeladd": "122 W WYANDOT AVE",
    "dropdelcty": "UPPER SANDUSKY",
    "dropdelst": "OH",
    "dropdelzpp": 433519998,
    "dropphyadd": "122 W WYANDOT AVE",
    "dropphycty": "UPPER SANDUSKY",
    "dropphyst": "OH",
    "dropphyzpp": 433519998,
    "dropmaladd": "122 W WYANDOT AVE",
    "dropmalcty": "UPPER SANDUSKY",
    "dropmalst": "OH",
    "dropmalzpp": 433519998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4192941911,
    "dropsitcph": 4192941911,
    "dropfax": 4192940890
  },
  {
    "dcode": "D",
    "dropkey": "PX23159",
    "droptype": "D",
    "dropname": "URBANA",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "URBANA",
    "dropdelst": "OH",
    "dropdelzpp": 430782188,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "URBANA",
    "dropphyst": "OH",
    "dropphyzpp": 430782188,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "URBANA",
    "dropmalst": "OH",
    "dropmalzpp": 430782188,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376533150,
    "dropsitcph": 9376533150,
    "dropfax": 9376533079
  },
  {
    "dcode": "D",
    "dropkey": "PX23161",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "20 N MAIN ST",
    "dropdelcty": "UTICA",
    "dropdelst": "OH",
    "dropdelzpp": 430807000,
    "dropphyadd": "20 N MAIN ST",
    "dropphycty": "UTICA",
    "dropphyst": "OH",
    "dropphyzpp": 430807000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UTICA",
    "dropmalst": "OH",
    "dropmalzpp": 430809998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408923310,
    "dropsitcph": 7408923310,
    "dropfax": 7408923348
  },
  {
    "dcode": "D",
    "dropkey": "PX23164",
    "droptype": "D",
    "dropname": "VALLEY CITY",
    "dropdeladd": "1409 BARN RUN DR",
    "dropdelcty": "VALLEY CITY",
    "dropdelst": "OH",
    "dropdelzpp": 442809998,
    "dropphyadd": "1409 BARN RUN DR",
    "dropphycty": "VALLEY CITY",
    "dropphyst": "OH",
    "dropphyzpp": 442809998,
    "dropmaladd": "1409 BARN RUN DR",
    "dropmalcty": "VALLEY CITY",
    "dropmalst": "OH",
    "dropmalzpp": 442809998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304833434,
    "dropfax": 3304833494
  },
  {
    "dcode": "D",
    "dropkey": "PX23169",
    "droptype": "D",
    "dropname": "VAN BUREN",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "OH",
    "dropdelzpp": 458899998,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "VAN BUREN",
    "dropphyst": "OH",
    "dropphyzpp": 458899998,
    "dropmaladd": "100 S MAIN ST",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "OH",
    "dropmalzpp": 458899998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192993397,
    "dropsitcph": 4192993397,
    "dropfax": 4192993397
  },
  {
    "dcode": "D",
    "dropkey": "PX23170",
    "droptype": "D",
    "dropname": "VAN WERT",
    "dropdeladd": "314 E MAIN ST",
    "dropdelcty": "VAN WERT",
    "dropdelst": "OH",
    "dropdelzpp": 458919998,
    "dropphyadd": "314 E MAIN ST",
    "dropphycty": "VAN WERT",
    "dropphyst": "OH",
    "dropphyzpp": 458919998,
    "dropmaladd": "314 E MAIN ST",
    "dropmalcty": "VAN WERT",
    "dropmalst": "OH",
    "dropmalzpp": 458919998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192381678,
    "dropsitcph": 4192381678,
    "dropfax": 4192386270
  },
  {
    "dcode": "D",
    "dropkey": "PX23173",
    "droptype": "D",
    "dropname": "VANDALIA",
    "dropdeladd": "323 JAMES BOHANAN DR",
    "dropdelcty": "VANDALIA",
    "dropdelst": "OH",
    "dropdelzpp": 453779998,
    "dropphyadd": "323 JAMES BOHANAN DR",
    "dropphycty": "VANDALIA",
    "dropphyst": "OH",
    "dropphyzpp": 453779998,
    "dropmaladd": "323 JAMES BOHANAN DR",
    "dropmalcty": "VANDALIA",
    "dropmalst": "OH",
    "dropmalzpp": 453779998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378984282,
    "dropsitcph": 9378984282,
    "dropfax": 9378988807
  },
  {
    "dcode": "D",
    "dropkey": "PX23174",
    "droptype": "D",
    "dropname": "VANLUE",
    "dropdeladd": "301 S BUFFALO ST",
    "dropdelcty": "VANLUE",
    "dropdelst": "OH",
    "dropdelzpp": 458909998,
    "dropphyadd": "301 S BUFFALO ST",
    "dropphycty": "VANLUE",
    "dropphyst": "OH",
    "dropphyzpp": 458909998,
    "dropmaladd": "301 S BUFFALO ST",
    "dropmalcty": "VANLUE",
    "dropmalst": "OH",
    "dropmalzpp": 458909998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193877716,
    "dropsitcph": 4193877716,
    "dropfax": 4193877715
  },
  {
    "dcode": "D",
    "dropkey": "PX23175",
    "droptype": "D",
    "dropname": "VAUGHNSVILLE",
    "dropdeladd": "342 W FINDLAY ST",
    "dropdelcty": "VAUGHNSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 458939998,
    "dropphyadd": "342 W FINDLAY ST",
    "dropphycty": "VAUGHNSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 458939998,
    "dropmaladd": "342 W FINDLAY ST",
    "dropmalcty": "VAUGHNSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 458939998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196463701,
    "dropsitcph": 4196463701,
    "dropfax": 4196463731
  },
  {
    "dcode": "D",
    "dropkey": "PX23177",
    "droptype": "D",
    "dropname": "VENEDOCIA",
    "dropdeladd": "15155 MAIN ST",
    "dropdelcty": "VENEDOCIA",
    "dropdelst": "OH",
    "dropdelzpp": 458949998,
    "dropphyadd": "15155 MAIN ST",
    "dropphycty": "VENEDOCIA",
    "dropphyst": "OH",
    "dropphyzpp": 458949998,
    "dropmaladd": "15155 MAIN ST",
    "dropmalcty": "VENEDOCIA",
    "dropmalst": "OH",
    "dropmalzpp": 458949998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196672981,
    "dropsitcph": 4196672981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23180",
    "droptype": "D",
    "dropname": "VERMILION",
    "dropdeladd": "4325 LIBERTY AVE",
    "dropdelcty": "VERMILION",
    "dropdelst": "OH",
    "dropdelzpp": 440899998,
    "dropphyadd": "4325 LIBERTY AVE",
    "dropphycty": "VERMILION",
    "dropphyst": "OH",
    "dropphyzpp": 440899998,
    "dropmaladd": "4325 LIBERTY AVE",
    "dropmalcty": "VERMILION",
    "dropmalst": "OH",
    "dropmalzpp": 440899998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409673767,
    "dropfax": 4409671096
  },
  {
    "dcode": "D",
    "dropkey": "PX23185",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "224 E MAIN ST",
    "dropdelcty": "VERONA",
    "dropdelst": "OH",
    "dropdelzpp": 453789998,
    "dropphyadd": "224 E MAIN ST",
    "dropphycty": "VERONA",
    "dropphyst": "OH",
    "dropphyzpp": 453789998,
    "dropmaladd": "224 E MAIN ST",
    "dropmalcty": "VERONA",
    "dropmalst": "OH",
    "dropmalzpp": 453789998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378845214,
    "dropsitcph": 9378845214,
    "dropfax": 9378847294
  },
  {
    "dcode": "D",
    "dropkey": "PX23186",
    "droptype": "D",
    "dropname": "VERSAILLES",
    "dropdeladd": "6 E WARD ST",
    "dropdelcty": "VERSAILLES",
    "dropdelst": "OH",
    "dropdelzpp": 453809998,
    "dropphyadd": "6 E WARD ST",
    "dropphycty": "VERSAILLES",
    "dropphyst": "OH",
    "dropphyzpp": 453809998,
    "dropmaladd": "6 E WARD ST",
    "dropmalcty": "VERSAILLES",
    "dropmalst": "OH",
    "dropmalzpp": 453809998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375264123,
    "dropsitcph": 9375264123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23191",
    "droptype": "D",
    "dropname": "VICKERY",
    "dropdeladd": "5110 COUNTY ROAD 247",
    "dropdelcty": "VICKERY",
    "dropdelst": "OH",
    "dropdelzpp": 434649998,
    "dropphyadd": "5110 COUNTY ROAD 247",
    "dropphycty": "VICKERY",
    "dropphyst": "OH",
    "dropphyzpp": 434649998,
    "dropmaladd": "5110 COUNTY ROAD 247",
    "dropmalcty": "VICKERY",
    "dropmalst": "OH",
    "dropmalzpp": 434649998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195478081,
    "dropsitcph": 4195478081,
    "dropfax": 4195479120
  },
  {
    "dcode": "D",
    "dropkey": "PX23195",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "4411 WARREN SHARON RD",
    "dropdelcty": "VIENNA",
    "dropdelst": "OH",
    "dropdelzpp": 444739800,
    "dropphyadd": "4411 WARREN SHARON RD",
    "dropphycty": "VIENNA",
    "dropphyst": "OH",
    "dropphyzpp": 444739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIENNA",
    "dropmalst": "OH",
    "dropmalzpp": 444739998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303942300,
    "dropsitcph": 3303942300,
    "dropfax": 3303942300
  },
  {
    "dcode": "D",
    "dropkey": "PX23198",
    "droptype": "D",
    "dropname": "VINCENT",
    "dropdeladd": "45 WARRIOR DR",
    "dropdelcty": "VINCENT",
    "dropdelst": "OH",
    "dropdelzpp": 457849800,
    "dropphyadd": "45 WARRIOR DR",
    "dropphycty": "VINCENT",
    "dropphyst": "OH",
    "dropphyzpp": 457849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VINCENT",
    "dropmalst": "OH",
    "dropmalzpp": 457849998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406782945,
    "dropsitcph": 7406782945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23199",
    "droptype": "D",
    "dropname": "VINTON",
    "dropdeladd": "137 MAIN ST",
    "dropdelcty": "VINTON",
    "dropdelst": "OH",
    "dropdelzpp": 456869800,
    "dropphyadd": "137 MAIN ST",
    "dropphycty": "VINTON",
    "dropphyst": "OH",
    "dropphyzpp": 456869800,
    "dropmaladd": "137 MAIN ST",
    "dropmalcty": "VINTON",
    "dropmalst": "OH",
    "dropmalzpp": 456869800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403889990,
    "dropsitcph": 7403889990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23220",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "165 BROAD ST",
    "dropdelcty": "WADSWORTH",
    "dropdelst": "OH",
    "dropdelzpp": 442812188,
    "dropphyadd": "165 BROAD ST",
    "dropphycty": "WADSWORTH",
    "dropphyst": "OH",
    "dropphyzpp": 442812188,
    "dropmaladd": "165 BROAD ST",
    "dropmalcty": "WADSWORTH",
    "dropmalst": "OH",
    "dropmalzpp": 442812188,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303341332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23226",
    "droptype": "D",
    "dropname": "WAKEMAN",
    "dropdeladd": "16 W MAIN ST",
    "dropdelcty": "WAKEMAN",
    "dropdelst": "OH",
    "dropdelzpp": 448899998,
    "dropphyadd": "16 W MAIN ST",
    "dropphycty": "WAKEMAN",
    "dropphyst": "OH",
    "dropphyzpp": 448899998,
    "dropmaladd": "16 W MAIN ST",
    "dropmalcty": "WAKEMAN",
    "dropmalst": "OH",
    "dropmalzpp": 448899998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4408392778,
    "dropfax": 7408392973
  },
  {
    "dcode": "D",
    "dropkey": "PX23227",
    "droptype": "D",
    "dropname": "WALBRIDGE",
    "dropdeladd": "419 N MAIN ST",
    "dropdelcty": "WALBRIDGE",
    "dropdelst": "OH",
    "dropdelzpp": 434651010,
    "dropphyadd": "419 N MAIN ST",
    "dropphycty": "WALBRIDGE",
    "dropphyst": "OH",
    "dropphyzpp": 434651010,
    "dropmaladd": "419 N MAIN ST",
    "dropmalcty": "WALBRIDGE",
    "dropmalst": "OH",
    "dropmalzpp": 434651010,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196662171,
    "dropsitcph": 4196662171,
    "dropfax": 4196662171
  },
  {
    "dcode": "D",
    "dropkey": "PX23228",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "117 S MARION ST",
    "dropdelcty": "WALDO",
    "dropdelst": "OH",
    "dropdelzpp": 433569169,
    "dropphyadd": "117 S MARION ST",
    "dropphycty": "WALDO",
    "dropphyst": "OH",
    "dropphyzpp": 433569169,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALDO",
    "dropmalst": "OH",
    "dropmalzpp": 433569998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407262505,
    "dropsitcph": 7407262505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23230",
    "droptype": "D",
    "dropname": "WALHONDING",
    "dropdeladd": "33118 STATE ROUTE 715",
    "dropdelcty": "WALHONDING",
    "dropdelst": "OH",
    "dropdelzpp": 438439701,
    "dropphyadd": "33118 STATE ROUTE 715",
    "dropphycty": "WALHONDING",
    "dropphyst": "OH",
    "dropphyzpp": 438439701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALHONDING",
    "dropmalst": "OH",
    "dropmalzpp": 438439998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408244015,
    "dropsitcph": 7408244015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23232",
    "droptype": "D",
    "dropname": "WALNUT CREEK",
    "dropdeladd": "4878 OLDE PUMP ST",
    "dropdelcty": "WALNUT CREEK",
    "dropdelst": "OH",
    "dropdelzpp": 446879800,
    "dropphyadd": "4878 OLDE PUMP ST",
    "dropphycty": "WALNUT CREEK",
    "dropphyst": "OH",
    "dropphyzpp": 446879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALNUT CREEK",
    "dropmalst": "OH",
    "dropmalzpp": 446879998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308932415,
    "dropfax": 3308932415
  },
  {
    "dcode": "D",
    "dropkey": "PX23241",
    "droptype": "D",
    "dropname": "WAPAKONETA",
    "dropdeladd": "12 WILLIPIE ST",
    "dropdelcty": "WAPAKONETA",
    "dropdelst": "OH",
    "dropdelzpp": 458959998,
    "dropphyadd": "12 WILLIPIE ST",
    "dropphycty": "WAPAKONETA",
    "dropphyst": "OH",
    "dropphyzpp": 458959998,
    "dropmaladd": "12 WILLIPIE ST",
    "dropmalcty": "WAPAKONETA",
    "dropmalst": "OH",
    "dropmalzpp": 458959998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197374177,
    "dropsitcph": 4197374177,
    "dropfax": 4197374172
  },
  {
    "dcode": "D",
    "dropkey": "PX23243",
    "droptype": "D",
    "dropname": "WARNOCK",
    "dropdeladd": "47590 W BROOKLYN ST",
    "dropdelcty": "WARNOCK",
    "dropdelst": "OH",
    "dropdelzpp": 439679800,
    "dropphyadd": "47590 W BROOKLYN ST",
    "dropphycty": "WARNOCK",
    "dropphyst": "OH",
    "dropphyzpp": 439679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARNOCK",
    "dropmalst": "OH",
    "dropmalzpp": 439679998,
    "dropsitphn": 3309969797,
    "dropsitlph": 7406951768,
    "dropsitcph": 7406951768,
    "dropfax": 7406951768
  },
  {
    "dcode": "D",
    "dropkey": "PX23244",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "201 HIGH ST NE",
    "dropdelcty": "WARREN",
    "dropdelst": "OH",
    "dropdelzpp": 444819998,
    "dropphyadd": "201 HIGH ST NE",
    "dropphycty": "WARREN",
    "dropphyst": "OH",
    "dropphyzpp": 444819998,
    "dropmaladd": "201 HIGH ST NE",
    "dropmalcty": "WARREN",
    "dropmalst": "OH",
    "dropmalzpp": 444819998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303921571,
    "dropsitcph": 3303921571,
    "dropfax": 3303929785
  },
  {
    "dcode": "D",
    "dropkey": "PX23251",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "803 E MAIN ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "OH",
    "dropdelzpp": 438449050,
    "dropphyadd": "803 E MAIN ST",
    "dropphycty": "WARSAW",
    "dropphyst": "OH",
    "dropphyzpp": 438449050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARSAW",
    "dropmalst": "OH",
    "dropmalzpp": 438449998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408243414,
    "dropsitcph": 7408243414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23266",
    "droptype": "D",
    "dropname": "WASHINGTON COURT HOUSE",
    "dropdeladd": "129 W MARKET ST",
    "dropdelcty": "WASHINGTON COURT HOUSE",
    "dropdelst": "OH",
    "dropdelzpp": 431609998,
    "dropphyadd": "129 W MARKET ST",
    "dropphycty": "WASHINGTON COURT HOUSE",
    "dropphyst": "OH",
    "dropphyzpp": 431609998,
    "dropmaladd": "129 W MARKET ST",
    "dropmalcty": "WASHINGTON COURT HOUSE",
    "dropmalst": "OH",
    "dropmalzpp": 431609998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403355540,
    "dropsitcph": 7403355540,
    "dropfax": 7403357333
  },
  {
    "dcode": "D",
    "dropkey": "PX23269",
    "droptype": "D",
    "dropname": "WASHINGTONVILLE",
    "dropdeladd": "195 E MAIN ST",
    "dropdelcty": "WASHINGTONVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 444909800,
    "dropphyadd": "195 E MAIN ST",
    "dropphycty": "WASHINGTONVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 444909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHINGTONVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 444909998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3304272384,
    "dropsitcph": 3304272384,
    "dropfax": 3304279901
  },
  {
    "dcode": "D",
    "dropkey": "PX23272",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "635 MAIN ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "OH",
    "dropdelzpp": 457869997,
    "dropphyadd": "635 MAIN ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "OH",
    "dropphyzpp": 457869997,
    "dropmaladd": "635 MAIN ST",
    "dropmalcty": "WATERFORD",
    "dropmalst": "OH",
    "dropmalzpp": 457869997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409842404,
    "dropsitcph": 7409842404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23274",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "23461 STATE ROUTE 141",
    "dropdelcty": "WATERLOO",
    "dropdelst": "OH",
    "dropdelzpp": 456889377,
    "dropphyadd": "23461 STATE ROUTE 141",
    "dropphycty": "WATERLOO",
    "dropphyst": "OH",
    "dropphyzpp": 456889377,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERLOO",
    "dropmalst": "OH",
    "dropmalzpp": 456889998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406430122,
    "dropsitcph": 7406430122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23276",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "12 S 3RD ST",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 435661534,
    "dropphyadd": "12 S 3RD ST",
    "dropphycty": "WATERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 435661534,
    "dropmaladd": "12 S 3RD ST",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 435661534,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198782936,
    "dropsitcph": 4198782936,
    "dropfax": 4198783962
  },
  {
    "dcode": "D",
    "dropkey": "PX23278",
    "droptype": "D",
    "dropname": "WAUSEON",
    "dropdeladd": "124 E ELM ST",
    "dropdelcty": "WAUSEON",
    "dropdelst": "OH",
    "dropdelzpp": 435671489,
    "dropphyadd": "124 E ELM ST",
    "dropphycty": "WAUSEON",
    "dropphyst": "OH",
    "dropphyzpp": 435671489,
    "dropmaladd": "124 E ELM ST",
    "dropmalcty": "WAUSEON",
    "dropmalst": "OH",
    "dropmalzpp": 435671489,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193355836,
    "dropsitcph": 4193355836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23279",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "125 E 2ND ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "OH",
    "dropdelzpp": 456901332,
    "dropphyadd": "125 E 2ND ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "OH",
    "dropphyzpp": 456901332,
    "dropmaladd": "125 E 2ND ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "OH",
    "dropmalzpp": 456901332,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409474333,
    "dropsitcph": 7409474333,
    "dropfax": 7409474333
  },
  {
    "dcode": "D",
    "dropkey": "PX23282",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "6243 WAYLAND RD",
    "dropdelcty": "WAYLAND",
    "dropdelst": "OH",
    "dropdelzpp": 442859800,
    "dropphyadd": "6243 WAYLAND RD",
    "dropphycty": "WAYLAND",
    "dropphyst": "OH",
    "dropphyzpp": 442859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYLAND",
    "dropmalst": "OH",
    "dropmalzpp": 442859998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303582007,
    "dropfax": 3303582007
  },
  {
    "dcode": "D",
    "dropkey": "PX23287",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "OH",
    "dropdelzpp": 434669998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "WAYNE",
    "dropphyst": "OH",
    "dropphyzpp": 434669998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "OH",
    "dropmalzpp": 434669998,
    "dropsitphn": 4192883234,
    "dropsitlph": 4192883234,
    "dropsitcph": 4192883234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23289",
    "droptype": "D",
    "dropname": "WAYNESBURG",
    "dropdeladd": "157 E LISBON ST",
    "dropdelcty": "WAYNESBURG",
    "dropdelst": "OH",
    "dropdelzpp": 446889800,
    "dropphyadd": "157 E LISBON ST",
    "dropphycty": "WAYNESBURG",
    "dropphyst": "OH",
    "dropphyzpp": 446889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYNESBURG",
    "dropmalst": "OH",
    "dropmalzpp": 446889998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308663539,
    "dropfax": 3308663539
  },
  {
    "dcode": "D",
    "dropkey": "PX23290",
    "droptype": "D",
    "dropname": "WAYNESFIELD",
    "dropdeladd": "109 N WESTMINSTER ST",
    "dropdelcty": "WAYNESFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 458969998,
    "dropphyadd": "109 N WESTMINSTER ST",
    "dropphycty": "WAYNESFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 458969998,
    "dropmaladd": "109 N WESTMINSTER ST",
    "dropmalcty": "WAYNESFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 458969998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4195683771,
    "dropsitcph": 4195683771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23291",
    "droptype": "D",
    "dropname": "WAYNESVILLE",
    "dropdeladd": "235 MIAMI ST",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 450689998,
    "dropphyadd": "235 MIAMI ST",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 450689998,
    "dropmaladd": "235 MIAMI ST",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 450689998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5138971282,
    "dropsitcph": 5138971282,
    "dropfax": 5138973583
  },
  {
    "dcode": "D",
    "dropkey": "PX23295",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "101 MCCORMICK ST",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 440909998,
    "dropphyadd": "101 MCCORMICK ST",
    "dropphycty": "WELLINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 440909998,
    "dropmaladd": "101 MCCORMICK ST",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 440909998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4406472122,
    "dropfax": 4406475857
  },
  {
    "dcode": "D",
    "dropkey": "PX23296",
    "droptype": "D",
    "dropname": "WELLSTON",
    "dropdeladd": "101 E BROADWAY ST",
    "dropdelcty": "WELLSTON",
    "dropdelst": "OH",
    "dropdelzpp": 456921273,
    "dropphyadd": "101 E BROADWAY ST",
    "dropphycty": "WELLSTON",
    "dropphyst": "OH",
    "dropphyzpp": 456921273,
    "dropmaladd": "101 E BROADWAY ST",
    "dropmalcty": "WELLSTON",
    "dropmalst": "OH",
    "dropmalzpp": 456921273,
    "dropsitphn": 6144720674,
    "dropsitlph": 7403842515,
    "dropsitcph": 7403842515,
    "dropfax": 7403846975
  },
  {
    "dcode": "D",
    "dropkey": "PX23297",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "1075 MAIN ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439681392,
    "dropphyadd": "1075 MAIN ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439681392,
    "dropmaladd": "1075 MAIN ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439681392,
    "dropsitphn": 3309969797,
    "dropsitlph": 3305323088,
    "dropsitcph": 3305323088,
    "dropfax": 3305322024
  },
  {
    "dcode": "D",
    "dropkey": "PX23302",
    "droptype": "D",
    "dropname": "WEST ALEXANDRIA",
    "dropdeladd": "15 W DAYTON ST",
    "dropdelcty": "WEST ALEXANDRIA",
    "dropdelst": "OH",
    "dropdelzpp": 453819998,
    "dropphyadd": "15 W DAYTON ST",
    "dropphycty": "WEST ALEXANDRIA",
    "dropphyst": "OH",
    "dropphyzpp": 453819998,
    "dropmaladd": "15 W DAYTON ST",
    "dropmalcty": "WEST ALEXANDRIA",
    "dropmalst": "OH",
    "dropmalzpp": 453819998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9378394000,
    "dropsitcph": 9378394000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23309",
    "droptype": "D",
    "dropname": "WEST CHESTER",
    "dropdeladd": "8730 CINCINNATI DAYTON RD",
    "dropdelcty": "WEST CHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 450699998,
    "dropphyadd": "8730 CINCINNATI DAYTON RD",
    "dropphycty": "WEST CHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 450699998,
    "dropmaladd": "8730 CINCINNATI DAYTON RD",
    "dropmalcty": "WEST CHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 450699998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137772381,
    "dropsitcph": 5137772381,
    "dropfax": 5137797245
  },
  {
    "dcode": "D",
    "dropkey": "PX23311",
    "droptype": "D",
    "dropname": "WEST ELKTON",
    "dropdeladd": "117 N MAIN ST",
    "dropdelcty": "WEST ELKTON",
    "dropdelst": "OH",
    "dropdelzpp": 450709998,
    "dropphyadd": "117 N MAIN ST",
    "dropphycty": "WEST ELKTON",
    "dropphyst": "OH",
    "dropphyzpp": 450709998,
    "dropmaladd": "117 N MAIN ST",
    "dropmalcty": "WEST ELKTON",
    "dropmalst": "OH",
    "dropmalzpp": 450709998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377874624,
    "dropsitcph": 9377874624,
    "dropfax": 9377874946
  },
  {
    "dcode": "D",
    "dropkey": "PX23313",
    "droptype": "D",
    "dropname": "WEST FARMINGTON",
    "dropdeladd": "226 E MAIN ST",
    "dropdelcty": "WEST FARMINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 444919998,
    "dropphyadd": "226 E MAIN ST",
    "dropphycty": "WEST FARMINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 444919998,
    "dropmaladd": "226 E MAIN ST",
    "dropmalcty": "WEST FARMINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 444919998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3308892450,
    "dropsitcph": 3308892450,
    "dropfax": 3308892450
  },
  {
    "dcode": "D",
    "dropkey": "PX23315",
    "droptype": "D",
    "dropname": "WEST JEFFERSON",
    "dropdeladd": "249 W MAIN ST",
    "dropdelcty": "WEST JEFFERSON",
    "dropdelst": "OH",
    "dropdelzpp": 431629998,
    "dropphyadd": "249 W MAIN ST",
    "dropphycty": "WEST JEFFERSON",
    "dropphyst": "OH",
    "dropphyzpp": 431629998,
    "dropmaladd": "249 W MAIN ST",
    "dropmalcty": "WEST JEFFERSON",
    "dropmalst": "OH",
    "dropmalzpp": 431629998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148799145,
    "dropsitcph": 6148799145,
    "dropfax": 6148797113
  },
  {
    "dcode": "D",
    "dropkey": "PX23316",
    "droptype": "D",
    "dropname": "WEST LAFAYETTE",
    "dropdeladd": "501 W MAIN ST",
    "dropdelcty": "WEST LAFAYETTE",
    "dropdelst": "OH",
    "dropdelzpp": 438451174,
    "dropphyadd": "501 W MAIN ST",
    "dropphycty": "WEST LAFAYETTE",
    "dropphyst": "OH",
    "dropphyzpp": 438451174,
    "dropmaladd": "501 W MAIN ST",
    "dropmalcty": "WEST LAFAYETTE",
    "dropmalst": "OH",
    "dropmalzpp": 438451174,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405457476,
    "dropsitcph": 7405457476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23320",
    "droptype": "D",
    "dropname": "WEST LIBERTY",
    "dropdeladd": "116 E BAIRD ST",
    "dropdelcty": "WEST LIBERTY",
    "dropdelst": "OH",
    "dropdelzpp": 433579229,
    "dropphyadd": "116 E BAIRD ST",
    "dropphycty": "WEST LIBERTY",
    "dropphyst": "OH",
    "dropphyzpp": 433579229,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST LIBERTY",
    "dropmalst": "OH",
    "dropmalzpp": 433579998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9374655453,
    "dropsitcph": 9374655453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23323",
    "droptype": "D",
    "dropname": "WEST MANCHESTER",
    "dropdeladd": "110 E SCOTT ST",
    "dropdelcty": "WEST MANCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 453829998,
    "dropphyadd": "110 E SCOTT ST",
    "dropphycty": "WEST MANCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 453829998,
    "dropmaladd": "110 E SCOTT ST",
    "dropmalcty": "WEST MANCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 453829998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376787441,
    "dropsitcph": 9376787441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23324",
    "droptype": "D",
    "dropname": "WEST MANSFIELD",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "WEST MANSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 433589998,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "WEST MANSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 433589998,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "WEST MANSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 433589998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9373554001,
    "dropsitcph": 9373554001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23327",
    "droptype": "D",
    "dropname": "WEST MILLGROVE",
    "dropdeladd": "6491 MAIN ST",
    "dropdelcty": "WEST MILLGROVE",
    "dropdelst": "OH",
    "dropdelzpp": 434679998,
    "dropphyadd": "6491 MAIN ST",
    "dropphycty": "WEST MILLGROVE",
    "dropphyst": "OH",
    "dropphyzpp": 434679998,
    "dropmaladd": "6491 MAIN ST",
    "dropmalcty": "WEST MILLGROVE",
    "dropmalst": "OH",
    "dropmalzpp": 434679998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192883242,
    "dropsitcph": 4192883242,
    "dropfax": 4192883242
  },
  {
    "dcode": "D",
    "dropkey": "PX23328",
    "droptype": "D",
    "dropname": "WEST MILTON",
    "dropdeladd": "30 N MAIN ST",
    "dropdelcty": "WEST MILTON",
    "dropdelst": "OH",
    "dropdelzpp": 453839998,
    "dropphyadd": "30 N MAIN ST",
    "dropphycty": "WEST MILTON",
    "dropphyst": "OH",
    "dropphyzpp": 453839998,
    "dropmaladd": "30 N MAIN ST",
    "dropmalcty": "WEST MILTON",
    "dropmalst": "OH",
    "dropmalzpp": 453839998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9376984641,
    "dropsitcph": 9376984641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23335",
    "droptype": "D",
    "dropname": "WEST SALEM",
    "dropdeladd": "7 S MAIN ST",
    "dropdelcty": "WEST SALEM",
    "dropdelst": "OH",
    "dropdelzpp": 442879998,
    "dropphyadd": "7 S MAIN ST",
    "dropphycty": "WEST SALEM",
    "dropphyst": "OH",
    "dropphyzpp": 442879998,
    "dropmaladd": "7 S MAIN ST",
    "dropmalcty": "WEST SALEM",
    "dropmalst": "OH",
    "dropmalzpp": 442879998,
    "dropsitphn": 2169969797,
    "dropsitlph": 2169969798,
    "dropsitcph": 4198534023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23339",
    "droptype": "D",
    "dropname": "WEST UNION",
    "dropdeladd": "117 E NORTH ST",
    "dropdelcty": "WEST UNION",
    "dropdelst": "OH",
    "dropdelzpp": 456931099,
    "dropphyadd": "117 E NORTH ST",
    "dropphycty": "WEST UNION",
    "dropphyst": "OH",
    "dropphyzpp": 456931099,
    "dropmaladd": "117 E NORTH ST",
    "dropmalcty": "WEST UNION",
    "dropmalst": "OH",
    "dropmalzpp": 456931099,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375443143,
    "dropsitcph": 9375443143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23341",
    "droptype": "D",
    "dropname": "WEST UNITY",
    "dropdeladd": "115 E JACKSON ST",
    "dropdelcty": "WEST UNITY",
    "dropdelst": "OH",
    "dropdelzpp": 435709998,
    "dropphyadd": "115 E JACKSON ST",
    "dropphycty": "WEST UNITY",
    "dropphyst": "OH",
    "dropphyzpp": 435709998,
    "dropmaladd": "115 E JACKSON ST",
    "dropmalcty": "WEST UNITY",
    "dropmalst": "OH",
    "dropmalzpp": 435709998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 4199245112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23348",
    "droptype": "D",
    "dropname": "WESTERVILLE",
    "dropdeladd": "617 MCCORKLE BLVD",
    "dropdelcty": "WESTERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430829640,
    "dropphyadd": "617 MCCORKLE BLVD",
    "dropphycty": "WESTERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430829640,
    "dropmaladd": "617 MCCORKLE BLVD",
    "dropmalcty": "WESTERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430829640,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148822243,
    "dropsitcph": 6148822243,
    "dropfax": 6148823850
  },
  {
    "dcode": "D",
    "dropkey": "PX23350",
    "droptype": "D",
    "dropname": "WESTFIELD CENTER",
    "dropdeladd": "6701 GREENWICH RD",
    "dropdelcty": "WESTFIELD CENTER",
    "dropdelst": "OH",
    "dropdelzpp": 442519800,
    "dropphyadd": "6701 GREENWICH RD",
    "dropphycty": "WESTFIELD CENTER",
    "dropphyst": "OH",
    "dropphyzpp": 442519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTFIELD CENTER",
    "dropmalst": "OH",
    "dropmalzpp": 442519998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308875010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23354",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "13172 MAIN ST",
    "dropdelcty": "WESTON",
    "dropdelst": "OH",
    "dropdelzpp": 435699998,
    "dropphyadd": "13172 MAIN ST",
    "dropphycty": "WESTON",
    "dropphyst": "OH",
    "dropphyzpp": 435699998,
    "dropmaladd": "13172 MAIN ST",
    "dropmalcty": "WESTON",
    "dropmalst": "OH",
    "dropmalzpp": 435699998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4196693099,
    "dropsitcph": 4196693099,
    "dropfax": 4196693148
  },
  {
    "dcode": "D",
    "dropkey": "PX23356",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "3987 W US HIGHWAY 36",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430838000,
    "dropphyadd": "3987 W US HIGHWAY 36",
    "dropphycty": "WESTVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430838000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430839998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376536941,
    "dropsitcph": 9376536941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23360",
    "droptype": "D",
    "dropname": "WHARTON",
    "dropdeladd": "124 W SANDUSKY ST",
    "dropdelcty": "WHARTON",
    "dropdelst": "OH",
    "dropdelzpp": 433599800,
    "dropphyadd": "124 W SANDUSKY ST",
    "dropphycty": "WHARTON",
    "dropphyst": "OH",
    "dropphyzpp": 433599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHARTON",
    "dropmalst": "OH",
    "dropmalzpp": 433599998,
    "dropsitphn": 6144720674,
    "dropsitlph": 4194583911,
    "dropsitcph": 4194583911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23361",
    "droptype": "D",
    "dropname": "WHEELERSBURG",
    "dropdeladd": "11687 GALLIA PIKE",
    "dropdelcty": "WHEELERSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 456948393,
    "dropphyadd": "11687 GALLIA PIKE",
    "dropphycty": "WHEELERSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 456948393,
    "dropmaladd": "11687 GALLIA PIKE",
    "dropmalcty": "WHEELERSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 456948393,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405742825,
    "dropsitcph": 7405742825,
    "dropfax": 7405749042
  },
  {
    "dcode": "D",
    "dropkey": "PX23366",
    "droptype": "D",
    "dropname": "WHITE COTTAGE",
    "dropdeladd": "3880 ROBERTS ADDITION",
    "dropdelcty": "WHITE COTTAGE",
    "dropdelst": "OH",
    "dropdelzpp": 437919900,
    "dropphyadd": "3880 ROBERTS ADDITION",
    "dropphycty": "WHITE COTTAGE",
    "dropphyst": "OH",
    "dropphyzpp": 437919900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE COTTAGE",
    "dropmalst": "OH",
    "dropmalzpp": 437919998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408492229,
    "dropsitcph": 7408492229,
    "dropfax": 7408492229
  },
  {
    "dcode": "D",
    "dropkey": "PX23370",
    "droptype": "D",
    "dropname": "WHITEHOUSE",
    "dropdeladd": "6822 PROVIDENCE ST",
    "dropdelcty": "WHITEHOUSE",
    "dropdelst": "OH",
    "dropdelzpp": 435719998,
    "dropphyadd": "6822 PROVIDENCE ST",
    "dropphycty": "WHITEHOUSE",
    "dropphyst": "OH",
    "dropphyzpp": 435719998,
    "dropmaladd": "6822 PROVIDENCE ST",
    "dropmalcty": "WHITEHOUSE",
    "dropmalst": "OH",
    "dropmalzpp": 435719998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198775733,
    "dropsitcph": 4198775733,
    "dropfax": 4198775733
  },
  {
    "dcode": "D",
    "dropkey": "PX23372",
    "droptype": "D",
    "dropname": "WICKLIFFE",
    "dropdeladd": "1400 LLOYD RD",
    "dropdelcty": "WICKLIFFE",
    "dropdelst": "OH",
    "dropdelzpp": 440922366,
    "dropphyadd": "1400 LLOYD RD",
    "dropphycty": "WICKLIFFE",
    "dropphyst": "OH",
    "dropphyzpp": 440922366,
    "dropmaladd": "1400 LLOYD RD",
    "dropmalcty": "WICKLIFFE",
    "dropmalst": "OH",
    "dropmalzpp": 440922366,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409432115,
    "dropfax": 4404949087
  },
  {
    "dcode": "D",
    "dropkey": "PX23374",
    "droptype": "D",
    "dropname": "WILBERFORCE",
    "dropdeladd": "1441 BRUSH ROW RD",
    "dropdelcty": "WILBERFORCE",
    "dropdelst": "OH",
    "dropdelzpp": 453849998,
    "dropphyadd": "1441 BRUSH ROW RD",
    "dropphycty": "WILBERFORCE",
    "dropphyst": "OH",
    "dropphyzpp": 453849998,
    "dropmaladd": "1441 BRUSH ROW RD",
    "dropmalcty": "WILBERFORCE",
    "dropmalst": "OH",
    "dropmalzpp": 453849998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373721811,
    "dropsitcph": 9373721811,
    "dropfax": 9373740329
  },
  {
    "dcode": "D",
    "dropkey": "PX23376",
    "droptype": "D",
    "dropname": "WILKESVILLE",
    "dropdeladd": "154 MAIN ST",
    "dropdelcty": "WILKESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 456959011,
    "dropphyadd": "154 MAIN ST",
    "dropphycty": "WILKESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 456959011,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILKESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 456959998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7406693410,
    "dropsitcph": 7406693410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23378",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "210 S MYRTLE AVE",
    "dropdelcty": "WILLARD",
    "dropdelst": "OH",
    "dropdelzpp": 448909998,
    "dropphyadd": "210 S MYRTLE AVE",
    "dropphycty": "WILLARD",
    "dropphyst": "OH",
    "dropphyzpp": 448909998,
    "dropmaladd": "210 S MYRTLE AVE",
    "dropmalcty": "WILLARD",
    "dropmalst": "OH",
    "dropmalzpp": 448909998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4199337051,
    "dropfax": 4199337413
  },
  {
    "dcode": "D",
    "dropkey": "PX23381",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "332 W MAIN ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 451769998,
    "dropphyadd": "332 W MAIN ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 451769998,
    "dropmaladd": "332 W MAIN ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 451769998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137242713,
    "dropsitcph": 5137242713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23382",
    "droptype": "D",
    "dropname": "WILLIAMSFIELD",
    "dropdeladd": "5911 US ROUTE 322",
    "dropdelcty": "WILLIAMSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 440939803,
    "dropphyadd": "5911 US ROUTE 322",
    "dropphycty": "WILLIAMSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 440939803,
    "dropmaladd": "5911 US ROUTE 322",
    "dropmalcty": "WILLIAMSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 440939803,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402938446,
    "dropfax": 4402938520
  },
  {
    "dcode": "D",
    "dropkey": "PX23385",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "109 S WATER ST",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "OH",
    "dropdelzpp": 431645009,
    "dropphyadd": "109 S WATER ST",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "OH",
    "dropphyzpp": 431645009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "OH",
    "dropmalzpp": 431649998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7409863665,
    "dropsitcph": 7409863665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23388",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "21062 W TOLEDO ST",
    "dropdelcty": "WILLISTON",
    "dropdelst": "OH",
    "dropdelzpp": 434689998,
    "dropphyadd": "21062 W TOLEDO ST",
    "dropphycty": "WILLISTON",
    "dropphyst": "OH",
    "dropphyzpp": 434689998,
    "dropmaladd": "21062 W TOLEDO ST",
    "dropmalcty": "WILLISTON",
    "dropmalst": "OH",
    "dropmalzpp": 434689998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198367522,
    "dropsitcph": 4198367522,
    "dropfax": 4198367522
  },
  {
    "dcode": "D",
    "dropkey": "PX23389",
    "droptype": "D",
    "dropname": "WILLOUGHBY",
    "dropdeladd": "4040 ERIE ST",
    "dropdelcty": "WILLOUGHBY",
    "dropdelst": "OH",
    "dropdelzpp": 440949998,
    "dropphyadd": "4040 ERIE ST",
    "dropphycty": "WILLOUGHBY",
    "dropphyst": "OH",
    "dropphyzpp": 440949998,
    "dropmaladd": "4040 ERIE ST",
    "dropmalcty": "WILLOUGHBY",
    "dropmalst": "OH",
    "dropmalzpp": 440949998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409510543,
    "dropfax": 4409429422
  },
  {
    "dcode": "D",
    "dropkey": "PX23395",
    "droptype": "D",
    "dropname": "WILLOW WOOD",
    "dropdeladd": "5491 STATE ROUTE 217",
    "dropdelcty": "WILLOW WOOD",
    "dropdelst": "OH",
    "dropdelzpp": 456969998,
    "dropphyadd": "5491 STATE ROUTE 217",
    "dropphycty": "WILLOW WOOD",
    "dropphyst": "OH",
    "dropphyzpp": 456969998,
    "dropmaladd": "5491 STATE ROUTE 217",
    "dropmalcty": "WILLOW WOOD",
    "dropmalst": "OH",
    "dropmalzpp": 456969998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7408673247,
    "dropsitcph": 7408673247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23400",
    "droptype": "D",
    "dropname": "WILLSHIRE",
    "dropdeladd": "110 WALCOTT ST",
    "dropdelcty": "WILLSHIRE",
    "dropdelst": "OH",
    "dropdelzpp": 458989998,
    "dropphyadd": "110 WALCOTT ST",
    "dropphycty": "WILLSHIRE",
    "dropphyst": "OH",
    "dropphyzpp": 458989998,
    "dropmaladd": "110 WALCOTT ST",
    "dropmalcty": "WILLSHIRE",
    "dropmalst": "OH",
    "dropmalzpp": 458989998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194952763,
    "dropsitcph": 4194952763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23402",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "1515 ALEX DR",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "OH",
    "dropdelzpp": 451779998,
    "dropphyadd": "1515 ALEX DR",
    "dropphycty": "WILMINGTON",
    "dropphyst": "OH",
    "dropphyzpp": 451779998,
    "dropmaladd": "1515 ALEX DR",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "OH",
    "dropmalzpp": 451779998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373822095,
    "dropsitcph": 9373822095,
    "dropfax": 9373826475
  },
  {
    "dcode": "D",
    "dropkey": "PX23403",
    "droptype": "D",
    "dropname": "WILMOT",
    "dropdeladd": "305 W MAIN ST",
    "dropdelcty": "WILMOT",
    "dropdelst": "OH",
    "dropdelzpp": 446899800,
    "dropphyadd": "305 W MAIN ST",
    "dropphycty": "WILMOT",
    "dropphyst": "OH",
    "dropphyzpp": 446899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILMOT",
    "dropmalst": "OH",
    "dropmalzpp": 446899998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303595513,
    "dropfax": 3303595513
  },
  {
    "dcode": "D",
    "dropkey": "PX23405",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "19138 STATE ROUTE 136",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "OH",
    "dropdelzpp": 456979800,
    "dropphyadd": "19138 STATE ROUTE 136",
    "dropphycty": "WINCHESTER",
    "dropphyst": "OH",
    "dropphyzpp": 456979800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "OH",
    "dropmalzpp": 456979998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9376950444,
    "dropsitcph": 9376950444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23406",
    "droptype": "D",
    "dropname": "WINDHAM",
    "dropdeladd": "9575 E CENTER ST",
    "dropdelcty": "WINDHAM",
    "dropdelst": "OH",
    "dropdelzpp": 442889998,
    "dropphyadd": "9575 E CENTER ST",
    "dropphycty": "WINDHAM",
    "dropphyst": "OH",
    "dropphyzpp": 442889998,
    "dropmaladd": "9575 E CENTER ST",
    "dropmalcty": "WINDHAM",
    "dropmalst": "OH",
    "dropmalzpp": 442889998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303263350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23409",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "5103 STATE ROUTE 322",
    "dropdelcty": "WINDSOR",
    "dropdelst": "OH",
    "dropdelzpp": 440999808,
    "dropphyadd": "5103 STATE ROUTE 322",
    "dropphycty": "WINDSOR",
    "dropphyst": "OH",
    "dropphyzpp": 440999808,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDSOR",
    "dropmalst": "OH",
    "dropmalzpp": 440999998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402725455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23411",
    "droptype": "D",
    "dropname": "WINESBURG",
    "dropdeladd": "2162 W MAIN ST",
    "dropdelcty": "WINESBURG",
    "dropdelst": "OH",
    "dropdelzpp": 446909800,
    "dropphyadd": "2162 W MAIN ST",
    "dropphycty": "WINESBURG",
    "dropphyst": "OH",
    "dropphyzpp": 446909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINESBURG",
    "dropmalst": "OH",
    "dropmalzpp": 446909998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303595512,
    "dropfax": 3303595512
  },
  {
    "dcode": "D",
    "dropkey": "PX23415",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "32036 WINONA RD",
    "dropdelcty": "WINONA",
    "dropdelst": "OH",
    "dropdelzpp": 444939800,
    "dropphyadd": "32036 WINONA RD",
    "dropphycty": "WINONA",
    "dropphyst": "OH",
    "dropphyzpp": 444939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINONA",
    "dropmalst": "OH",
    "dropmalzpp": 444939998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3302222333,
    "dropsitcph": 3302222333,
    "dropfax": 3302222333
  },
  {
    "dcode": "D",
    "dropkey": "PX23425",
    "droptype": "D",
    "dropname": "WOODSFIELD",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "WOODSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 437939998,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "WOODSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 437939998,
    "dropmaladd": "125 N MAIN ST",
    "dropmalcty": "WOODSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 437939998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404721711,
    "dropsitcph": 7404721711,
    "dropfax": 7404721711
  },
  {
    "dcode": "D",
    "dropkey": "PX23426",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "111 BURNWELL ST",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "OH",
    "dropdelzpp": 430849002,
    "dropphyadd": "111 BURNWELL ST",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "OH",
    "dropphyzpp": 430849002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "OH",
    "dropmalzpp": 430849998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9378264911,
    "dropsitcph": 9378264911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23427",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "108 W MAIN ST",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 434691105,
    "dropphyadd": "108 W MAIN ST",
    "dropphycty": "WOODVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 434691105,
    "dropmaladd": "108 W MAIN ST",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 434691105,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198493200,
    "dropsitcph": 4198493200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23428",
    "droptype": "D",
    "dropname": "WOOSTER",
    "dropdeladd": "153 E SOUTH ST",
    "dropdelcty": "WOOSTER",
    "dropdelst": "OH",
    "dropdelzpp": 446919998,
    "dropphyadd": "153 E SOUTH ST",
    "dropphycty": "WOOSTER",
    "dropphyst": "OH",
    "dropphyzpp": 446919998,
    "dropmaladd": "153 E SOUTH ST",
    "dropmalcty": "WOOSTER",
    "dropmalst": "OH",
    "dropmalzpp": 446919998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3302620861,
    "dropfax": 3302624361
  },
  {
    "dcode": "D",
    "dropkey": "PX23431",
    "droptype": "D",
    "dropname": "WREN",
    "dropdeladd": "119 STATE ROUTE 49",
    "dropdelcty": "WREN",
    "dropdelst": "OH",
    "dropdelzpp": 458999998,
    "dropphyadd": "119 STATE ROUTE 49",
    "dropphycty": "WREN",
    "dropphyst": "OH",
    "dropphyzpp": 458999998,
    "dropmaladd": "119 STATE ROUTE 49",
    "dropmalcty": "WREN",
    "dropmalst": "OH",
    "dropmalzpp": 458999998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194952908,
    "dropsitcph": 4194952908,
    "dropfax": 4194952022
  },
  {
    "dcode": "D",
    "dropkey": "PX23441",
    "droptype": "D",
    "dropname": "XENIA",
    "dropdeladd": "189 E MAIN ST",
    "dropdelcty": "XENIA",
    "dropdelst": "OH",
    "dropdelzpp": 453859998,
    "dropphyadd": "189 E MAIN ST",
    "dropphycty": "XENIA",
    "dropphyst": "OH",
    "dropphyzpp": 453859998,
    "dropmaladd": "189 E MAIN ST",
    "dropmalcty": "XENIA",
    "dropmalst": "OH",
    "dropmalzpp": 453859998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9373727627,
    "dropsitcph": 9373727627,
    "dropfax": 9373723748
  },
  {
    "dcode": "D",
    "dropkey": "PX23450",
    "droptype": "D",
    "dropname": "YELLOW SPRINGS",
    "dropdeladd": "120 CORRY ST",
    "dropdelcty": "YELLOW SPRINGS",
    "dropdelst": "OH",
    "dropdelzpp": 453879998,
    "dropphyadd": "120 CORRY ST",
    "dropphycty": "YELLOW SPRINGS",
    "dropphyst": "OH",
    "dropphyzpp": 453879998,
    "dropmaladd": "120 CORRY ST",
    "dropmalcty": "YELLOW SPRINGS",
    "dropmalst": "OH",
    "dropmalzpp": 453879998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9377677458,
    "dropsitcph": 9377677458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23455",
    "droptype": "D",
    "dropname": "YORKSHIRE",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "YORKSHIRE",
    "dropdelst": "OH",
    "dropdelzpp": 453889998,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "YORKSHIRE",
    "dropphyst": "OH",
    "dropphyzpp": 453889998,
    "dropmaladd": "104 W MAIN ST",
    "dropmalcty": "YORKSHIRE",
    "dropmalst": "OH",
    "dropmalzpp": 453889998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9375824353,
    "dropsitcph": 4195824353,
    "dropfax": 4195824017
  },
  {
    "dcode": "D",
    "dropkey": "PX23456",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "325 PUBLIC RD",
    "dropdelcty": "YORKVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 439711252,
    "dropphyadd": "325 PUBLIC RD",
    "dropphycty": "YORKVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 439711252,
    "dropmaladd": "325 PUBLIC RD",
    "dropmalcty": "YORKVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 439711252,
    "dropsitphn": 3309969797,
    "dropsitlph": 7408592219,
    "dropsitcph": 7408592219,
    "dropfax": 7408594398
  },
  {
    "dcode": "D",
    "dropkey": "PX23460",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "99 S WALNUT ST RM 203",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445019998,
    "dropphyadd": "99 S WALNUT ST RM 203",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445019998,
    "dropmaladd": "99 S WALNUT ST RM 203",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445019998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307408870,
    "dropsitcph": 3307408807,
    "dropfax": 3307408804
  },
  {
    "dcode": "D",
    "dropkey": "PX23463",
    "droptype": "D",
    "dropname": "ZALESKI",
    "dropdeladd": "101 S 1ST ST",
    "dropdelcty": "ZALESKI",
    "dropdelst": "OH",
    "dropdelzpp": 456989800,
    "dropphyadd": "101 S 1ST ST",
    "dropphycty": "ZALESKI",
    "dropphyst": "OH",
    "dropphyzpp": 456989800,
    "dropmaladd": "101 S 1ST ST",
    "dropmalcty": "ZALESKI",
    "dropmalst": "OH",
    "dropmalzpp": 456989800,
    "dropsitphn": 6144720674,
    "dropsitlph": 7405964652,
    "dropsitcph": 7405964652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23464",
    "droptype": "D",
    "dropname": "ZANESFIELD",
    "dropdeladd": "2856 SANDUSKY ST",
    "dropdelcty": "ZANESFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 433609802,
    "dropphyadd": "2856 SANDUSKY ST",
    "dropphycty": "ZANESFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 433609802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZANESFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 433609998,
    "dropsitphn": 6144720674,
    "dropsitlph": 9375996318,
    "dropsitcph": 9375996318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23465",
    "droptype": "D",
    "dropname": "ZANESVILLE",
    "dropdeladd": "900 MCINTIRE AVE",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437019998,
    "dropphyadd": "900 MCINTIRE AVE",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437019998,
    "dropmaladd": "900 MCINTIRE AVE",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437019998,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404552802,
    "dropsitcph": 7404552802,
    "dropfax": 7404552851
  },
  {
    "dcode": "D",
    "dropkey": "PX23468",
    "droptype": "D",
    "dropname": "ZOAR",
    "dropdeladd": "171 W 1ST ST",
    "dropdelcty": "ZOAR",
    "dropdelst": "OH",
    "dropdelzpp": 446979800,
    "dropphyadd": "171 W 1ST ST",
    "dropphycty": "ZOAR",
    "dropphyst": "OH",
    "dropphyzpp": 446979800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZOAR",
    "dropmalst": "OH",
    "dropmalzpp": 446979998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3308743311,
    "dropfax": 3308743311
  },
  {
    "dcode": "D",
    "dropkey": "PX23470",
    "droptype": "D",
    "dropname": "ABBEVILLE",
    "dropdeladd": "1503 N MAIN ST",
    "dropdelcty": "ABBEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296209998,
    "dropphyadd": "1503 N MAIN ST",
    "dropphycty": "ABBEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296209998,
    "dropmaladd": "1503 N MAIN ST",
    "dropmalcty": "ABBEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296209998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644594447,
    "dropfax": 8644591501
  },
  {
    "dcode": "D",
    "dropkey": "PX23472",
    "droptype": "D",
    "dropname": "ADAMS RUN",
    "dropdeladd": "5190 HIGHWAY 174",
    "dropdelcty": "ADAMS RUN",
    "dropdelst": "SC",
    "dropdelzpp": 294269998,
    "dropphyadd": "5190 HIGHWAY 174",
    "dropphycty": "ADAMS RUN",
    "dropphyst": "SC",
    "dropphyzpp": 294269998,
    "dropmaladd": "5190 HIGHWAY 174",
    "dropmalcty": "ADAMS RUN",
    "dropmalst": "SC",
    "dropmalzpp": 294269998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438898533,
    "dropsitcph": 8438898533,
    "dropfax": 8438898533
  },
  {
    "dcode": "D",
    "dropkey": "PX23477",
    "droptype": "D",
    "dropname": "AIKEN",
    "dropdeladd": "307 LAURENS ST NW",
    "dropdelcty": "AIKEN",
    "dropdelst": "SC",
    "dropdelzpp": 298019998,
    "dropphyadd": "307 LAURENS ST NW",
    "dropphycty": "AIKEN",
    "dropphyst": "SC",
    "dropphyzpp": 298019998,
    "dropmaladd": "307 LAURENS ST NW",
    "dropmalcty": "AIKEN",
    "dropmalst": "SC",
    "dropmalzpp": 298019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036499211,
    "dropsitcph": 8036499211,
    "dropfax": 8036483381
  },
  {
    "dcode": "D",
    "dropkey": "PX23480",
    "droptype": "D",
    "dropname": "ALCOLU",
    "dropdeladd": "1842 MAIN ST",
    "dropdelcty": "ALCOLU",
    "dropdelst": "SC",
    "dropdelzpp": 290018812,
    "dropphyadd": "1842 MAIN ST",
    "dropphycty": "ALCOLU",
    "dropphyst": "SC",
    "dropphyzpp": 290018812,
    "dropmaladd": "1842 MAIN ST",
    "dropmalcty": "ALCOLU",
    "dropmalst": "SC",
    "dropmalzpp": 290018812,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034733501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23482",
    "droptype": "D",
    "dropname": "ALLENDALE",
    "dropdeladd": "315 AUGUSTA HWY",
    "dropdelcty": "ALLENDALE",
    "dropdelst": "SC",
    "dropdelzpp": 298109998,
    "dropphyadd": "315 AUGUSTA HWY",
    "dropphycty": "ALLENDALE",
    "dropphyst": "SC",
    "dropphyzpp": 298109998,
    "dropmaladd": "315 AUGUSTA HWY",
    "dropmalcty": "ALLENDALE",
    "dropmalst": "SC",
    "dropmalzpp": 298109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035844413,
    "dropsitcph": 8035844413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23485",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "1900B N MAIN ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "SC",
    "dropdelzpp": 296219998,
    "dropphyadd": "1900B N MAIN ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "SC",
    "dropphyzpp": 296219998,
    "dropmaladd": "1900B N MAIN ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "SC",
    "dropmalzpp": 296219998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642261595,
    "dropfax": 8642220844
  },
  {
    "dcode": "D",
    "dropkey": "PX23486",
    "droptype": "D",
    "dropname": "ANDREWS",
    "dropdeladd": "102 N MORGAN AVE",
    "dropdelcty": "ANDREWS",
    "dropdelst": "SC",
    "dropdelzpp": 295109998,
    "dropphyadd": "102 N MORGAN AVE",
    "dropphycty": "ANDREWS",
    "dropphyst": "SC",
    "dropphyzpp": 295109998,
    "dropmaladd": "102 N MORGAN AVE",
    "dropmalcty": "ANDREWS",
    "dropmalst": "SC",
    "dropmalzpp": 295109998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432645506,
    "dropsitcph": 8432645506,
    "dropfax": 8432645628
  },
  {
    "dcode": "D",
    "dropkey": "PX23489",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "1893 HAYNE ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "SC",
    "dropdelzpp": 293209800,
    "dropphyadd": "1893 HAYNE ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "SC",
    "dropphyzpp": 293209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "SC",
    "dropmalzpp": 293209998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645742775,
    "dropfax": 8645742775
  },
  {
    "dcode": "D",
    "dropkey": "PX23504",
    "droptype": "D",
    "dropname": "AWENDAW",
    "dropdeladd": "6201 N HIGHWAY 17",
    "dropdelcty": "AWENDAW",
    "dropdelst": "SC",
    "dropdelzpp": 294299998,
    "dropphyadd": "6201 N HIGHWAY 17",
    "dropphycty": "AWENDAW",
    "dropphyst": "SC",
    "dropphyzpp": 294299998,
    "dropmaladd": "6201 N HIGHWAY 17",
    "dropmalcty": "AWENDAW",
    "dropmalst": "SC",
    "dropmalzpp": 294299998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8439283366,
    "dropsitcph": 8439283366,
    "dropfax": 8439283366
  },
  {
    "dcode": "D",
    "dropkey": "PX23505",
    "droptype": "D",
    "dropname": "AYNOR",
    "dropdeladd": "2945 HIGHWAY 501 E",
    "dropdelcty": "AYNOR",
    "dropdelst": "SC",
    "dropdelzpp": 295119998,
    "dropphyadd": "2945 HIGHWAY 501 E",
    "dropphycty": "AYNOR",
    "dropphyst": "SC",
    "dropphyzpp": 295119998,
    "dropmaladd": "2945 HIGHWAY 501 E",
    "dropmalcty": "AYNOR",
    "dropmalst": "SC",
    "dropmalzpp": 295119998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433583800,
    "dropsitcph": 8433583800,
    "dropfax": 8433581441
  },
  {
    "dcode": "D",
    "dropkey": "PX23507",
    "droptype": "D",
    "dropname": "BALLENTINE",
    "dropdeladd": "1720 DUTCH FORK RD STE A",
    "dropdelcty": "BALLENTINE",
    "dropdelst": "SC",
    "dropdelzpp": 290029803,
    "dropphyadd": "1720 DUTCH FORK RD STE A",
    "dropphycty": "BALLENTINE",
    "dropphyst": "SC",
    "dropphyzpp": 290029803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALLENTINE",
    "dropmalst": "SC",
    "dropmalzpp": 290029998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037811648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23508",
    "droptype": "D",
    "dropname": "BAMBERG",
    "dropdeladd": "11955 HERITAGE HWY",
    "dropdelcty": "BAMBERG",
    "dropdelst": "SC",
    "dropdelzpp": 290039998,
    "dropphyadd": "11955 HERITAGE HWY",
    "dropphycty": "BAMBERG",
    "dropphyst": "SC",
    "dropphyzpp": 290039998,
    "dropmaladd": "11955 HERITAGE HWY",
    "dropmalcty": "BAMBERG",
    "dropmalst": "SC",
    "dropmalzpp": 290039998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032452247,
    "dropfax": 8032457755
  },
  {
    "dcode": "D",
    "dropkey": "PX23512",
    "droptype": "D",
    "dropname": "BARNWELL",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "BARNWELL",
    "dropdelst": "SC",
    "dropdelzpp": 298129998,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "BARNWELL",
    "dropphyst": "SC",
    "dropphyzpp": 298129998,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "BARNWELL",
    "dropmalst": "SC",
    "dropmalzpp": 298129998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032593195,
    "dropsitcph": 8032593195,
    "dropfax": 8035410530
  },
  {
    "dcode": "D",
    "dropkey": "PX23519",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "3880 AUGUSTA RD",
    "dropdelcty": "BATH",
    "dropdelst": "SC",
    "dropdelzpp": 298169998,
    "dropphyadd": "3880 AUGUSTA RD",
    "dropphycty": "BATH",
    "dropphyst": "SC",
    "dropphyzpp": 298169998,
    "dropmaladd": "3880 AUGUSTA RD",
    "dropmalcty": "BATH",
    "dropmalst": "SC",
    "dropmalzpp": 298169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035933154,
    "dropsitcph": 8035933154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23524",
    "droptype": "D",
    "dropname": "BEAUFORT",
    "dropdeladd": "501 CHARLES ST",
    "dropdelcty": "BEAUFORT",
    "dropdelst": "SC",
    "dropdelzpp": 299029998,
    "dropphyadd": "501 CHARLES ST",
    "dropphycty": "BEAUFORT",
    "dropphyst": "SC",
    "dropphyzpp": 299029998,
    "dropmaladd": "501 CHARLES ST",
    "dropmalcty": "BEAUFORT",
    "dropmalst": "SC",
    "dropmalzpp": 299029998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8435259085,
    "dropsitcph": 8435259085,
    "dropfax": 8435241115
  },
  {
    "dcode": "D",
    "dropkey": "PX23531",
    "droptype": "D",
    "dropname": "BELTON",
    "dropdeladd": "103 BREAZEALE ST",
    "dropdelcty": "BELTON",
    "dropdelst": "SC",
    "dropdelzpp": 296279998,
    "dropphyadd": "103 BREAZEALE ST",
    "dropphycty": "BELTON",
    "dropphyst": "SC",
    "dropphyzpp": 296279998,
    "dropmaladd": "103 BREAZEALE ST",
    "dropmalcty": "BELTON",
    "dropmalst": "SC",
    "dropmalzpp": 296279998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643386802,
    "dropfax": 8643381599
  },
  {
    "dcode": "D",
    "dropkey": "PX23537",
    "droptype": "D",
    "dropname": "BENNETTSVILLE",
    "dropdeladd": "208 W MAIN ST",
    "dropdelcty": "BENNETTSVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 295129998,
    "dropphyadd": "208 W MAIN ST",
    "dropphycty": "BENNETTSVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 295129998,
    "dropmaladd": "208 W MAIN ST",
    "dropmalcty": "BENNETTSVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 295129998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434792351,
    "dropsitcph": 8434792351,
    "dropfax": 8434790760
  },
  {
    "dcode": "D",
    "dropkey": "PX23546",
    "droptype": "D",
    "dropname": "BETHUNE",
    "dropdeladd": "503 KING ST E",
    "dropdelcty": "BETHUNE",
    "dropdelst": "SC",
    "dropdelzpp": 290099735,
    "dropphyadd": "503 KING ST E",
    "dropphycty": "BETHUNE",
    "dropphyst": "SC",
    "dropphyzpp": 290099735,
    "dropmaladd": "503 KING ST E",
    "dropmalcty": "BETHUNE",
    "dropmalst": "SC",
    "dropmalzpp": 290099735,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433346229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23550",
    "droptype": "D",
    "dropname": "BISHOPVILLE",
    "dropdeladd": "451 N MAIN ST",
    "dropdelcty": "BISHOPVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 290101473,
    "dropphyadd": "451 N MAIN ST",
    "dropphycty": "BISHOPVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 290101473,
    "dropmaladd": "451 N MAIN ST",
    "dropmalcty": "BISHOPVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 290101473,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034830227,
    "dropfax": 8034830228
  },
  {
    "dcode": "D",
    "dropkey": "PX23552",
    "droptype": "D",
    "dropname": "BLACKSBURG",
    "dropdeladd": "202 W PINE ST",
    "dropdelcty": "BLACKSBURG",
    "dropdelst": "SC",
    "dropdelzpp": 297021546,
    "dropphyadd": "202 W PINE ST",
    "dropphycty": "BLACKSBURG",
    "dropphyst": "SC",
    "dropphyzpp": 297021546,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACKSBURG",
    "dropmalst": "SC",
    "dropmalzpp": 297029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8648396381,
    "dropsitcph": 8648396381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23553",
    "droptype": "D",
    "dropname": "BLACKSTOCK",
    "dropdeladd": "1083 DURHAM RD",
    "dropdelcty": "BLACKSTOCK",
    "dropdelst": "SC",
    "dropdelzpp": 290149998,
    "dropphyadd": "1083 DURHAM RD",
    "dropphycty": "BLACKSTOCK",
    "dropphyst": "SC",
    "dropphyzpp": 290149998,
    "dropmaladd": "1083 DURHAM RD",
    "dropmalcty": "BLACKSTOCK",
    "dropmalst": "SC",
    "dropmalzpp": 290149998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035811551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23554",
    "droptype": "D",
    "dropname": "BLACKVILLE",
    "dropdeladd": "476 MAIN ST",
    "dropdelcty": "BLACKVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 298179998,
    "dropphyadd": "476 MAIN ST",
    "dropphycty": "BLACKVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 298179998,
    "dropmaladd": "476 MAIN ST",
    "dropmalcty": "BLACKVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 298179998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032842752,
    "dropsitcph": 8032842752,
    "dropfax": 8032842752
  },
  {
    "dcode": "D",
    "dropkey": "PX23555",
    "droptype": "D",
    "dropname": "BLAIR",
    "dropdeladd": "96 GRANITE RD",
    "dropdelcty": "BLAIR",
    "dropdelst": "SC",
    "dropdelzpp": 290159998,
    "dropphyadd": "96 GRANITE RD",
    "dropphycty": "BLAIR",
    "dropphyst": "SC",
    "dropphyzpp": 290159998,
    "dropmaladd": "96 GRANITE RD",
    "dropmalcty": "BLAIR",
    "dropmalst": "SC",
    "dropmalzpp": 290159998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036354314,
    "dropfax": 8036354314
  },
  {
    "dcode": "D",
    "dropkey": "PX23558",
    "droptype": "D",
    "dropname": "BLENHEIM",
    "dropdeladd": "105 W HIGH ST",
    "dropdelcty": "BLENHEIM",
    "dropdelst": "SC",
    "dropdelzpp": 295169998,
    "dropphyadd": "105 W HIGH ST",
    "dropphycty": "BLENHEIM",
    "dropphyst": "SC",
    "dropphyzpp": 295169998,
    "dropmaladd": "105 W HIGH ST",
    "dropmalcty": "BLENHEIM",
    "dropmalst": "SC",
    "dropmalzpp": 295169998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435283861,
    "dropsitcph": 8435283861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23565",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "25 THURMOND WAY",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "SC",
    "dropdelzpp": 299109998,
    "dropphyadd": "25 THURMOND WAY",
    "dropphycty": "BLUFFTON",
    "dropphyst": "SC",
    "dropphyzpp": 299109998,
    "dropmaladd": "25 THURMOND WAY",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "SC",
    "dropmalzpp": 299109998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437575857,
    "dropsitcph": 8437575857,
    "dropfax": 8437578812
  },
  {
    "dcode": "D",
    "dropkey": "PX23567",
    "droptype": "D",
    "dropname": "BLYTHEWOOD",
    "dropdeladd": "401 MCNULTY ST",
    "dropdelcty": "BLYTHEWOOD",
    "dropdelst": "SC",
    "dropdelzpp": 290169998,
    "dropphyadd": "401 MCNULTY ST",
    "dropphycty": "BLYTHEWOOD",
    "dropphyst": "SC",
    "dropphyzpp": 290169998,
    "dropmaladd": "401 MCNULTY ST",
    "dropmalcty": "BLYTHEWOOD",
    "dropmalst": "SC",
    "dropmalzpp": 290169998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037542422,
    "dropfax": 8037546354
  },
  {
    "dcode": "D",
    "dropkey": "PX23575",
    "droptype": "D",
    "dropname": "BONNEAU",
    "dropdeladd": "104 CEDAR ST",
    "dropdelcty": "BONNEAU",
    "dropdelst": "SC",
    "dropdelzpp": 294319998,
    "dropphyadd": "104 CEDAR ST",
    "dropphycty": "BONNEAU",
    "dropphyst": "SC",
    "dropphyzpp": 294319998,
    "dropmaladd": "104 CEDAR ST",
    "dropmalcty": "BONNEAU",
    "dropmalst": "SC",
    "dropmalzpp": 294319998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438253345,
    "dropsitcph": 8438253345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23578",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "1771 N HIGHWAY 321",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "SC",
    "dropdelzpp": 297039798,
    "dropphyadd": "1771 N HIGHWAY 321",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "SC",
    "dropphyzpp": 297039798,
    "dropmaladd": "1771 N HIGHWAY 321",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "SC",
    "dropmalzpp": 297039798,
    "dropsitphn": 7043934581,
    "dropsitlph": 8032224070,
    "dropsitcph": 8032224070,
    "dropfax": 8032222350
  },
  {
    "dcode": "D",
    "dropkey": "PX23581",
    "droptype": "D",
    "dropname": "BOWMAN",
    "dropdeladd": "6902 CHARLESTON HWY",
    "dropdelcty": "BOWMAN",
    "dropdelst": "SC",
    "dropdelzpp": 290189998,
    "dropphyadd": "6902 CHARLESTON HWY",
    "dropphycty": "BOWMAN",
    "dropphyst": "SC",
    "dropphyzpp": 290189998,
    "dropmaladd": "6902 CHARLESTON HWY",
    "dropmalcty": "BOWMAN",
    "dropmalst": "SC",
    "dropmalzpp": 290189998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038290018,
    "dropfax": 8038292218
  },
  {
    "dcode": "D",
    "dropkey": "PX23584",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "103 MILL ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "SC",
    "dropdelzpp": 298199998,
    "dropphyadd": "103 MILL ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "SC",
    "dropphyzpp": 298199998,
    "dropmaladd": "103 MILL ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "SC",
    "dropmalzpp": 298199998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8647466310,
    "dropsitcph": 8647466310,
    "dropfax": 8647466310
  },
  {
    "dcode": "D",
    "dropkey": "PX23585",
    "droptype": "D",
    "dropname": "BRANCHVILLE",
    "dropdeladd": "250 EDWARD ST",
    "dropdelcty": "BRANCHVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294329998,
    "dropphyadd": "250 EDWARD ST",
    "dropphycty": "BRANCHVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294329998,
    "dropmaladd": "250 EDWARD ST",
    "dropmalcty": "BRANCHVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294329998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8032748825,
    "dropsitcph": 8032748825,
    "dropfax": 8032744107
  },
  {
    "dcode": "D",
    "dropkey": "PX23605",
    "droptype": "D",
    "dropname": "BRUNSON",
    "dropdeladd": "816 N RAILROAD AVE",
    "dropdelcty": "BRUNSON",
    "dropdelst": "SC",
    "dropdelzpp": 299119998,
    "dropphyadd": "816 N RAILROAD AVE",
    "dropphycty": "BRUNSON",
    "dropphyst": "SC",
    "dropphyzpp": 299119998,
    "dropmaladd": "816 N RAILROAD AVE",
    "dropmalcty": "BRUNSON",
    "dropmalst": "SC",
    "dropmalzpp": 299119998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036322382,
    "dropsitcph": 8036322382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23608",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "857 MAIN ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "SC",
    "dropdelzpp": 293219998,
    "dropphyadd": "857 MAIN ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "SC",
    "dropphyzpp": 293219998,
    "dropmaladd": "857 MAIN ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "SC",
    "dropmalzpp": 293219998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644274211,
    "dropfax": 8644295615
  },
  {
    "dcode": "D",
    "dropkey": "PX23617",
    "droptype": "D",
    "dropname": "CADES",
    "dropdeladd": "3116 N WILLIAMSBURG COUNTY HWY",
    "dropdelcty": "CADES",
    "dropdelst": "SC",
    "dropdelzpp": 295189998,
    "dropphyadd": "3116 N WILLIAMSBURG COUNTY HWY",
    "dropphycty": "CADES",
    "dropphyst": "SC",
    "dropphyzpp": 295189998,
    "dropmaladd": "3116 N WILLIAMSBURG COUNTY HWY",
    "dropmalcty": "CADES",
    "dropmalst": "SC",
    "dropmalzpp": 295189998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433897158,
    "dropsitcph": 8433897158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23620",
    "droptype": "D",
    "dropname": "CALHOUN FALLS",
    "dropdeladd": "200 E SAVANNAH ST",
    "dropdelcty": "CALHOUN FALLS",
    "dropdelst": "SC",
    "dropdelzpp": 296289998,
    "dropphyadd": "200 E SAVANNAH ST",
    "dropphycty": "CALHOUN FALLS",
    "dropphyst": "SC",
    "dropphyzpp": 296289998,
    "dropmaladd": "200 E SAVANNAH ST",
    "dropmalcty": "CALHOUN FALLS",
    "dropmalst": "SC",
    "dropmalzpp": 296289998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644478531,
    "dropfax": 8644478592
  },
  {
    "dcode": "D",
    "dropkey": "PX23622",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "542 E DEKALB ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "SC",
    "dropdelzpp": 290209998,
    "dropphyadd": "542 E DEKALB ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "SC",
    "dropphyzpp": 290209998,
    "dropmaladd": "542 E DEKALB ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "SC",
    "dropmalzpp": 290209998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034322215,
    "dropfax": 8034322092
  },
  {
    "dcode": "D",
    "dropkey": "PX23623",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "304 BOYCE LAWTON DR",
    "dropdelcty": "CAMERON",
    "dropdelst": "SC",
    "dropdelzpp": 290309998,
    "dropphyadd": "304 BOYCE LAWTON DR",
    "dropphycty": "CAMERON",
    "dropphyst": "SC",
    "dropphyzpp": 290309998,
    "dropmaladd": "304 BOYCE LAWTON DR",
    "dropmalcty": "CAMERON",
    "dropmalst": "SC",
    "dropmalzpp": 290309998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038232007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23627",
    "droptype": "D",
    "dropname": "CAMPOBELLO",
    "dropdeladd": "30 S MAIN ST",
    "dropdelcty": "CAMPOBELLO",
    "dropdelst": "SC",
    "dropdelzpp": 293229998,
    "dropphyadd": "30 S MAIN ST",
    "dropphycty": "CAMPOBELLO",
    "dropphyst": "SC",
    "dropphyzpp": 293229998,
    "dropmaladd": "30 S MAIN ST",
    "dropmalcty": "CAMPOBELLO",
    "dropmalst": "SC",
    "dropmalzpp": 293229998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644684585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23634",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "4512 KING KENNEDY ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "SC",
    "dropdelzpp": 290319998,
    "dropphyadd": "4512 KING KENNEDY ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "SC",
    "dropphyzpp": 290319998,
    "dropmaladd": "4512 KING KENNEDY ST",
    "dropmalcty": "CARLISLE",
    "dropmalst": "SC",
    "dropmalzpp": 290319998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8644273867,
    "dropfax": 8644294916
  },
  {
    "dcode": "D",
    "dropkey": "PX23639",
    "droptype": "D",
    "dropname": "CASSATT",
    "dropdeladd": "2589 HIGHWAY 1 N",
    "dropdelcty": "CASSATT",
    "dropdelst": "SC",
    "dropdelzpp": 290329389,
    "dropphyadd": "2589 HIGHWAY 1 N",
    "dropphycty": "CASSATT",
    "dropphyst": "SC",
    "dropphyzpp": 290329389,
    "dropmaladd": "2589 HIGHWAY 1 N",
    "dropmalcty": "CASSATT",
    "dropmalst": "SC",
    "dropmalzpp": 290329389,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034328208,
    "dropfax": 8034328208
  },
  {
    "dcode": "D",
    "dropkey": "PX23640",
    "droptype": "D",
    "dropname": "CATAWBA",
    "dropdeladd": "4795 CURETON FERRY RD",
    "dropdelcty": "CATAWBA",
    "dropdelst": "SC",
    "dropdelzpp": 297048794,
    "dropphyadd": "4795 CURETON FERRY RD",
    "dropphycty": "CATAWBA",
    "dropphyst": "SC",
    "dropphyzpp": 297048794,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CATAWBA",
    "dropmalst": "SC",
    "dropmalzpp": 297049998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8033293534,
    "dropsitcph": 8033293534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23651",
    "droptype": "D",
    "dropname": "CENTENARY",
    "dropdeladd": "4811 S HIGHWAY 41A",
    "dropdelcty": "CENTENARY",
    "dropdelst": "SC",
    "dropdelzpp": 295199998,
    "dropphyadd": "4811 S HIGHWAY 41A",
    "dropphycty": "CENTENARY",
    "dropphyst": "SC",
    "dropphyzpp": 295199998,
    "dropmaladd": "4811 S HIGHWAY 41A",
    "dropmalcty": "CENTENARY",
    "dropmalst": "SC",
    "dropmalzpp": 295199998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433622868,
    "dropsitcph": 8433622868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23652",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "1205 W MAIN ST",
    "dropdelcty": "CENTRAL",
    "dropdelst": "SC",
    "dropdelzpp": 296309998,
    "dropphyadd": "1205 W MAIN ST",
    "dropphycty": "CENTRAL",
    "dropphyst": "SC",
    "dropphyzpp": 296309998,
    "dropmaladd": "1205 W MAIN ST",
    "dropmalcty": "CENTRAL",
    "dropmalst": "SC",
    "dropmalzpp": 296309998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646392814,
    "dropfax": 8646392804
  },
  {
    "dcode": "D",
    "dropkey": "PX23658",
    "droptype": "D",
    "dropname": "CHAPIN",
    "dropdeladd": "1249 CHAPIN RD",
    "dropdelcty": "CHAPIN",
    "dropdelst": "SC",
    "dropdelzpp": 290367332,
    "dropphyadd": "1249 CHAPIN RD",
    "dropphycty": "CHAPIN",
    "dropphyst": "SC",
    "dropphyzpp": 290367332,
    "dropmaladd": "1249 CHAPIN RD",
    "dropmalcty": "CHAPIN",
    "dropmalst": "SC",
    "dropmalzpp": 290367332,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033455531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23660",
    "droptype": "D",
    "dropname": "CHAPPELLS",
    "dropdeladd": "390 SC HIGHWAY 39",
    "dropdelcty": "CHAPPELLS",
    "dropdelst": "SC",
    "dropdelzpp": 290379998,
    "dropphyadd": "390 SC HIGHWAY 39",
    "dropphycty": "CHAPPELLS",
    "dropphyst": "SC",
    "dropphyzpp": 290379998,
    "dropmaladd": "390 SC HIGHWAY 39",
    "dropmalcty": "CHAPPELLS",
    "dropmalst": "SC",
    "dropmalzpp": 290379998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8649954743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23663",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "83 BROAD ST",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294012202,
    "dropphyadd": "83 BROAD ST",
    "dropphycty": "CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294019998,
    "dropmaladd": "PO BOX 239998",
    "dropmalcty": "NORTH CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294239998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437605435,
    "dropsitcph": 8437271129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23676",
    "droptype": "D",
    "dropname": "CHERAW",
    "dropdeladd": "248 MARKET ST",
    "dropdelcty": "CHERAW",
    "dropdelst": "SC",
    "dropdelzpp": 295209997,
    "dropphyadd": "248 MARKET ST",
    "dropphycty": "CHERAW",
    "dropphyst": "SC",
    "dropphyzpp": 295209997,
    "dropmaladd": "248 MARKET ST",
    "dropmalcty": "CHERAW",
    "dropmalst": "SC",
    "dropmalzpp": 295209997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435373111,
    "dropsitcph": 8435373111,
    "dropfax": 8435372317
  },
  {
    "dcode": "D",
    "dropkey": "PX23686",
    "droptype": "D",
    "dropname": "CHESNEE",
    "dropdeladd": "103 E CHESTER ST",
    "dropdelcty": "CHESNEE",
    "dropdelst": "SC",
    "dropdelzpp": 293239998,
    "dropphyadd": "103 E CHESTER ST",
    "dropphycty": "CHESNEE",
    "dropphyst": "SC",
    "dropphyzpp": 293239998,
    "dropmaladd": "103 E CHESTER ST",
    "dropmalcty": "CHESNEE",
    "dropmalst": "SC",
    "dropmalzpp": 293239998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644612674,
    "dropfax": 8644613350
  },
  {
    "dcode": "D",
    "dropkey": "PX23687",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "131 SALUDA ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "SC",
    "dropdelzpp": 297061580,
    "dropphyadd": "131 SALUDA ST",
    "dropphycty": "CHESTER",
    "dropphyst": "SC",
    "dropphyzpp": 297061580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHESTER",
    "dropmalst": "SC",
    "dropmalzpp": 297069998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043778184,
    "dropsitcph": 8033778184,
    "dropfax": 8035817824
  },
  {
    "dcode": "D",
    "dropkey": "PX23688",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "SC",
    "dropdelzpp": 297091718,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "SC",
    "dropphyzpp": 297091718,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "SC",
    "dropmalzpp": 297091718,
    "dropsitphn": 7043934581,
    "dropsitlph": 8436232275,
    "dropsitcph": 8436232275,
    "dropfax": 8436232716
  },
  {
    "dcode": "D",
    "dropkey": "PX23698",
    "droptype": "D",
    "dropname": "CLARKS HILL",
    "dropdeladd": "13423 SC HIGHWAY 28",
    "dropdelcty": "CLARKS HILL",
    "dropdelst": "SC",
    "dropdelzpp": 298212831,
    "dropphyadd": "13423 SC HIGHWAY 28",
    "dropphycty": "CLARKS HILL",
    "dropphyst": "SC",
    "dropphyzpp": 298212831,
    "dropmaladd": "13423 SC HIGHWAY 28",
    "dropmalcty": "CLARKS HILL",
    "dropmalst": "SC",
    "dropmalzpp": 298219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8643335753,
    "dropsitcph": 8643335753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23701",
    "droptype": "D",
    "dropname": "CLEARWATER",
    "dropdeladd": "4425 JEFFERSON DAVIS HWY",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "SC",
    "dropdelzpp": 298229998,
    "dropphyadd": "4425 JEFFERSON DAVIS HWY",
    "dropphycty": "CLEARWATER",
    "dropphyst": "SC",
    "dropphyzpp": 298229998,
    "dropmaladd": "4425 JEFFERSON DAVIS HWY",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "SC",
    "dropmalzpp": 298229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035938522,
    "dropsitcph": 8035938522,
    "dropfax": 8035930187
  },
  {
    "dcode": "D",
    "dropkey": "PX23702",
    "droptype": "D",
    "dropname": "CLEMSON",
    "dropdeladd": "519 COLLEGE AVE",
    "dropdelcty": "CLEMSON",
    "dropdelst": "SC",
    "dropdelzpp": 296319998,
    "dropphyadd": "519 COLLEGE AVE",
    "dropphycty": "CLEMSON",
    "dropphyst": "SC",
    "dropphyzpp": 296319998,
    "dropmaladd": "519 COLLEGE AVE",
    "dropmalcty": "CLEMSON",
    "dropmalst": "SC",
    "dropmalzpp": 296319998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646542531,
    "dropfax": 8646540663
  },
  {
    "dcode": "D",
    "dropkey": "PX23706",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "4031 GEER HWY",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "SC",
    "dropdelzpp": 296359998,
    "dropphyadd": "4031 GEER HWY",
    "dropphycty": "CLEVELAND",
    "dropphyst": "SC",
    "dropphyzpp": 296359998,
    "dropmaladd": "4031 GEER HWY",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "SC",
    "dropmalzpp": 296359998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648368378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23707",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "1017 COWPENS CLIFTON RD",
    "dropdelcty": "CLIFTON",
    "dropdelst": "SC",
    "dropdelzpp": 293249800,
    "dropphyadd": "1017 COWPENS CLIFTON RD",
    "dropphycty": "CLIFTON",
    "dropphyst": "SC",
    "dropphyzpp": 293249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIFTON",
    "dropmalst": "SC",
    "dropmalzpp": 293249998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645791194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23708",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "202 ELIZABETH ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "SC",
    "dropdelzpp": 293259998,
    "dropphyadd": "202 ELIZABETH ST",
    "dropphycty": "CLINTON",
    "dropphyst": "SC",
    "dropphyzpp": 293259998,
    "dropmaladd": "202 ELIZABETH ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "SC",
    "dropmalzpp": 293259998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648332433,
    "dropfax": 8648337218
  },
  {
    "dcode": "D",
    "dropkey": "PX23709",
    "droptype": "D",
    "dropname": "CLIO",
    "dropdeladd": "117 RED BLUFF ST",
    "dropdelcty": "CLIO",
    "dropdelst": "SC",
    "dropdelzpp": 295259998,
    "dropphyadd": "117 RED BLUFF ST",
    "dropphycty": "CLIO",
    "dropphyst": "SC",
    "dropphyzpp": 295259998,
    "dropmaladd": "117 RED BLUFF ST",
    "dropmalcty": "CLIO",
    "dropmalst": "SC",
    "dropmalzpp": 295259998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435869356,
    "dropsitcph": 8435869356,
    "dropfax": 8435868675
  },
  {
    "dcode": "D",
    "dropkey": "PX23710",
    "droptype": "D",
    "dropname": "CLOVER",
    "dropdeladd": "913 BETHEL ST",
    "dropdelcty": "CLOVER",
    "dropdelst": "SC",
    "dropdelzpp": 297100019,
    "dropphyadd": "913 BETHEL ST",
    "dropphycty": "CLOVER",
    "dropphyst": "SC",
    "dropphyzpp": 297100019,
    "dropmaladd": "913 BETHEL ST",
    "dropmalcty": "CLOVER",
    "dropmalst": "SC",
    "dropmalzpp": 297100019,
    "dropsitphn": 7043934581,
    "dropsitlph": 8032224697,
    "dropsitcph": 8032224697,
    "dropfax": 8032221665
  },
  {
    "dcode": "D",
    "dropkey": "PX23727",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "1601 ASSEMBLY ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292019998,
    "dropphyadd": "1601 ASSEMBLY ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292019998,
    "dropmaladd": "1601 ASSEMBLY ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292019998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334626,
    "dropfax": 8037334656
  },
  {
    "dcode": "D",
    "dropkey": "PX23733",
    "droptype": "D",
    "dropname": "CONESTEE",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "CONESTEE",
    "dropdelst": "SC",
    "dropdelzpp": 296369800,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "CONESTEE",
    "dropphyst": "SC",
    "dropphyzpp": 296369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONESTEE",
    "dropmalst": "SC",
    "dropmalzpp": 296369998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642772016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23735",
    "droptype": "D",
    "dropname": "CONVERSE",
    "dropdeladd": "250 E MAIN ST",
    "dropdelcty": "CONVERSE",
    "dropdelst": "SC",
    "dropdelzpp": 293299800,
    "dropphyadd": "250 E MAIN ST",
    "dropphycty": "CONVERSE",
    "dropphyst": "SC",
    "dropphyzpp": 293299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONVERSE",
    "dropmalst": "SC",
    "dropmalzpp": 293299998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645791710,
    "dropfax": 8645791710
  },
  {
    "dcode": "D",
    "dropkey": "PX23736",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "2570 MAIN ST",
    "dropdelcty": "CONWAY",
    "dropdelst": "SC",
    "dropdelzpp": 295269998,
    "dropphyadd": "2570 MAIN ST",
    "dropphycty": "CONWAY",
    "dropphyst": "SC",
    "dropphyzpp": 295269998,
    "dropmaladd": "2570 MAIN ST",
    "dropmalcty": "CONWAY",
    "dropmalst": "SC",
    "dropmalzpp": 295269998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432486313,
    "dropsitcph": 8432486313,
    "dropfax": 8432489480
  },
  {
    "dcode": "D",
    "dropkey": "PX23742",
    "droptype": "D",
    "dropname": "COPE",
    "dropdeladd": "204 COTTON AVE",
    "dropdelcty": "COPE",
    "dropdelst": "SC",
    "dropdelzpp": 290389998,
    "dropphyadd": "204 COTTON AVE",
    "dropphycty": "COPE",
    "dropphyst": "SC",
    "dropphyzpp": 290389998,
    "dropmaladd": "204 COTTON AVE",
    "dropmalcty": "COPE",
    "dropmalst": "SC",
    "dropmalzpp": 290389998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035342649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23743",
    "droptype": "D",
    "dropname": "CORDESVILLE",
    "dropdeladd": "2732 HIGHWAY 402",
    "dropdelcty": "CORDESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294349998,
    "dropphyadd": "2732 HIGHWAY 402",
    "dropphycty": "CORDESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294349998,
    "dropmaladd": "2732 HIGHWAY 402",
    "dropmalcty": "CORDESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294349998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433363585,
    "dropsitcph": 8433363585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23746",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "2046 LEGRAND SMOAK ST",
    "dropdelcty": "CORDOVA",
    "dropdelst": "SC",
    "dropdelzpp": 290399998,
    "dropphyadd": "2046 LEGRAND SMOAK ST",
    "dropphycty": "CORDOVA",
    "dropphyst": "SC",
    "dropphyzpp": 290399998,
    "dropmaladd": "2046 LEGRAND SMOAK ST",
    "dropmalcty": "CORDOVA",
    "dropmalst": "SC",
    "dropmalzpp": 290399998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035341100,
    "dropfax": 8035341100
  },
  {
    "dcode": "D",
    "dropkey": "PX23748",
    "droptype": "D",
    "dropname": "COTTAGEVILLE",
    "dropdeladd": "10969 COTTAGEVILLE HWY",
    "dropdelcty": "COTTAGEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294359998,
    "dropphyadd": "10969 COTTAGEVILLE HWY",
    "dropphycty": "COTTAGEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294359998,
    "dropmaladd": "10969 COTTAGEVILLE HWY",
    "dropmalcty": "COTTAGEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294359998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438358290,
    "dropsitcph": 8036791207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23751",
    "droptype": "D",
    "dropname": "COWARD",
    "dropdeladd": "3701 US 52 HWY",
    "dropdelcty": "COWARD",
    "dropdelst": "SC",
    "dropdelzpp": 295309998,
    "dropphyadd": "3701 US 52 HWY",
    "dropphycty": "COWARD",
    "dropphyst": "SC",
    "dropphyzpp": 295309998,
    "dropmaladd": "3701 US 52 HWY",
    "dropmalcty": "COWARD",
    "dropmalst": "SC",
    "dropmalzpp": 295309998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433894214,
    "dropsitcph": 8433894214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23752",
    "droptype": "D",
    "dropname": "COWPENS",
    "dropdeladd": "106 W CHURCH ST",
    "dropdelcty": "COWPENS",
    "dropdelst": "SC",
    "dropdelzpp": 293309998,
    "dropphyadd": "106 W CHURCH ST",
    "dropphycty": "COWPENS",
    "dropphyst": "SC",
    "dropphyzpp": 293309998,
    "dropmaladd": "106 W CHURCH ST",
    "dropmalcty": "COWPENS",
    "dropmalst": "SC",
    "dropmalzpp": 293309998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644634592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23762",
    "droptype": "D",
    "dropname": "CROSS",
    "dropdeladd": "1836 RANGER DR",
    "dropdelcty": "CROSS",
    "dropdelst": "SC",
    "dropdelzpp": 294369998,
    "dropphyadd": "1836 RANGER DR",
    "dropphycty": "CROSS",
    "dropphyst": "SC",
    "dropphyzpp": 294369998,
    "dropmaladd": "1836 RANGER DR",
    "dropmalcty": "CROSS",
    "dropmalst": "SC",
    "dropmalzpp": 294369998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437532669,
    "dropsitcph": 8437532669,
    "dropfax": 8437532669
  },
  {
    "dcode": "D",
    "dropkey": "PX23763",
    "droptype": "D",
    "dropname": "CROSS ANCHOR",
    "dropdeladd": "635 UNION HWY",
    "dropdelcty": "CROSS ANCHOR",
    "dropdelst": "SC",
    "dropdelzpp": 293319800,
    "dropphyadd": "635 UNION HWY",
    "dropphycty": "CROSS ANCHOR",
    "dropphyst": "SC",
    "dropphyzpp": 293319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS ANCHOR",
    "dropmalst": "SC",
    "dropmalzpp": 293319998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649692567,
    "dropfax": 8649693053
  },
  {
    "dcode": "D",
    "dropkey": "PX23765",
    "droptype": "D",
    "dropname": "CROSS HILL",
    "dropdeladd": "968 N MAIN ST",
    "dropdelcty": "CROSS HILL",
    "dropdelst": "SC",
    "dropdelzpp": 293329998,
    "dropphyadd": "968 N MAIN ST",
    "dropphycty": "CROSS HILL",
    "dropphyst": "SC",
    "dropphyzpp": 293329998,
    "dropmaladd": "968 N MAIN ST",
    "dropmalcty": "CROSS HILL",
    "dropmalst": "SC",
    "dropmalzpp": 293329998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649983439,
    "dropfax": 8649983439
  },
  {
    "dcode": "D",
    "dropkey": "PX23773",
    "droptype": "D",
    "dropname": "DALZELL",
    "dropdeladd": "4235 CAMDEN HWY",
    "dropdelcty": "DALZELL",
    "dropdelst": "SC",
    "dropdelzpp": 290408362,
    "dropphyadd": "4235 CAMDEN HWY",
    "dropphycty": "DALZELL",
    "dropphyst": "SC",
    "dropphyzpp": 290408362,
    "dropmaladd": "4235 CAMDEN HWY",
    "dropmalcty": "DALZELL",
    "dropmalst": "SC",
    "dropmalzpp": 290408362,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034994060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23776",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "115 E SMITH AVE",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "SC",
    "dropdelzpp": 295329998,
    "dropphyadd": "115 E SMITH AVE",
    "dropphycty": "DARLINGTON",
    "dropphyst": "SC",
    "dropphyzpp": 295329998,
    "dropmaladd": "115 E SMITH AVE",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "SC",
    "dropmalzpp": 295329998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433933223,
    "dropsitcph": 8433933223,
    "dropfax": 8433939311
  },
  {
    "dcode": "D",
    "dropkey": "PX23780",
    "droptype": "D",
    "dropname": "DAVIS STATION",
    "dropdeladd": "5232 MOSES DINGLE RD",
    "dropdelcty": "DAVIS STATION",
    "dropdelst": "SC",
    "dropdelzpp": 290419800,
    "dropphyadd": "5232 MOSES DINGLE RD",
    "dropphycty": "DAVIS STATION",
    "dropphyst": "SC",
    "dropphyzpp": 290419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVIS STATION",
    "dropmalst": "SC",
    "dropmalzpp": 290419998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034784502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23785",
    "droptype": "D",
    "dropname": "DENMARK",
    "dropdeladd": "5022 CAROLINA HWY",
    "dropdelcty": "DENMARK",
    "dropdelst": "SC",
    "dropdelzpp": 290429998,
    "dropphyadd": "5022 CAROLINA HWY",
    "dropphycty": "DENMARK",
    "dropphyst": "SC",
    "dropphyzpp": 290429998,
    "dropmaladd": "5022 CAROLINA HWY",
    "dropmalcty": "DENMARK",
    "dropmalst": "SC",
    "dropmalzpp": 290429998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037933771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23789",
    "droptype": "D",
    "dropname": "DILLON",
    "dropdeladd": "300 W MAIN ST",
    "dropdelcty": "DILLON",
    "dropdelst": "SC",
    "dropdelzpp": 295369998,
    "dropphyadd": "300 W MAIN ST",
    "dropphycty": "DILLON",
    "dropphyst": "SC",
    "dropphyzpp": 295369998,
    "dropmaladd": "300 W MAIN ST",
    "dropmalcty": "DILLON",
    "dropmalst": "SC",
    "dropmalzpp": 295369998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437749481,
    "dropsitcph": 8437749481,
    "dropfax": 8438410218
  },
  {
    "dcode": "D",
    "dropkey": "PX23792",
    "droptype": "D",
    "dropname": "DONALDS",
    "dropdeladd": "119 W MAIN ST",
    "dropdelcty": "DONALDS",
    "dropdelst": "SC",
    "dropdelzpp": 296389998,
    "dropphyadd": "119 W MAIN ST",
    "dropphycty": "DONALDS",
    "dropphyst": "SC",
    "dropphyzpp": 296389998,
    "dropmaladd": "119 W MAIN ST",
    "dropmalcty": "DONALDS",
    "dropmalst": "SC",
    "dropmalzpp": 296389998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643792302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23795",
    "droptype": "D",
    "dropname": "DORCHESTER",
    "dropdeladd": "2650 HIGHWAY 78",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "SC",
    "dropdelzpp": 294379998,
    "dropphyadd": "2650 HIGHWAY 78",
    "dropphycty": "DORCHESTER",
    "dropphyst": "SC",
    "dropphyzpp": 294379998,
    "dropmaladd": "2650 HIGHWAY 78",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "SC",
    "dropmalzpp": 294379998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435632945,
    "dropsitcph": 8435632945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23804",
    "droptype": "D",
    "dropname": "DRAYTON",
    "dropdeladd": "1955 DRAYTON RD",
    "dropdelcty": "DRAYTON",
    "dropdelst": "SC",
    "dropdelzpp": 293339800,
    "dropphyadd": "1955 DRAYTON RD",
    "dropphycty": "DRAYTON",
    "dropphyst": "SC",
    "dropphyzpp": 293339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRAYTON",
    "dropmalst": "SC",
    "dropmalzpp": 293339998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645827138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23805",
    "droptype": "D",
    "dropname": "DUE WEST",
    "dropdeladd": "5 WASHINGTON ST",
    "dropdelcty": "DUE WEST",
    "dropdelst": "SC",
    "dropdelzpp": 296399998,
    "dropphyadd": "5 WASHINGTON ST",
    "dropphycty": "DUE WEST",
    "dropphyst": "SC",
    "dropphyzpp": 296399998,
    "dropmaladd": "5 WASHINGTON ST",
    "dropmalcty": "DUE WEST",
    "dropmalst": "SC",
    "dropmalzpp": 296399998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643792142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23810",
    "droptype": "D",
    "dropname": "DUNCAN",
    "dropdeladd": "131 W MAIN ST",
    "dropdelcty": "DUNCAN",
    "dropdelst": "SC",
    "dropdelzpp": 293349998,
    "dropphyadd": "131 W MAIN ST",
    "dropphycty": "DUNCAN",
    "dropphyst": "SC",
    "dropphyzpp": 293349998,
    "dropmaladd": "131 W MAIN ST",
    "dropmalcty": "DUNCAN",
    "dropmalst": "SC",
    "dropmalzpp": 293349998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644393920,
    "dropfax": 8644398125
  },
  {
    "dcode": "D",
    "dropkey": "PX23825",
    "droptype": "D",
    "dropname": "EARLY BRANCH",
    "dropdeladd": "34 FICKEN RD",
    "dropdelcty": "EARLY BRANCH",
    "dropdelst": "SC",
    "dropdelzpp": 299169998,
    "dropphyadd": "34 FICKEN RD",
    "dropphycty": "EARLY BRANCH",
    "dropphyst": "SC",
    "dropphyzpp": 299169998,
    "dropmaladd": "34 FICKEN RD",
    "dropmalcty": "EARLY BRANCH",
    "dropmalst": "SC",
    "dropmalzpp": 299169998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8435892702,
    "dropsitcph": 8435892702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23826",
    "droptype": "D",
    "dropname": "EASLEY",
    "dropdeladd": "810 S PENDLETON ST",
    "dropdelcty": "EASLEY",
    "dropdelst": "SC",
    "dropdelzpp": 296409998,
    "dropphyadd": "810 S PENDLETON ST",
    "dropphycty": "EASLEY",
    "dropphyst": "SC",
    "dropphyzpp": 296409998,
    "dropmaladd": "810 S PENDLETON ST",
    "dropmalcty": "EASLEY",
    "dropmalst": "SC",
    "dropmalzpp": 296409998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648599411,
    "dropfax": 8648559600
  },
  {
    "dcode": "D",
    "dropkey": "PX23832",
    "droptype": "D",
    "dropname": "EASTOVER",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "EASTOVER",
    "dropdelst": "SC",
    "dropdelzpp": 290449998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "EASTOVER",
    "dropphyst": "SC",
    "dropphyzpp": 290449998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "EASTOVER",
    "dropmalst": "SC",
    "dropmalzpp": 290449998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033538482,
    "dropfax": 8033532561
  },
  {
    "dcode": "D",
    "dropkey": "PX23837",
    "droptype": "D",
    "dropname": "EDGEFIELD",
    "dropdeladd": "325 BACON ST",
    "dropdelcty": "EDGEFIELD",
    "dropdelst": "SC",
    "dropdelzpp": 298249998,
    "dropphyadd": "325 BACON ST",
    "dropphycty": "EDGEFIELD",
    "dropphyst": "SC",
    "dropphyzpp": 298249998,
    "dropmaladd": "325 BACON ST",
    "dropmalcty": "EDGEFIELD",
    "dropmalst": "SC",
    "dropmalzpp": 298249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036371294,
    "dropsitcph": 8036371294,
    "dropfax": 8036375994
  },
  {
    "dcode": "D",
    "dropkey": "PX23838",
    "droptype": "D",
    "dropname": "EDGEMOOR",
    "dropdeladd": "4469 EDGELAND RD",
    "dropdelcty": "EDGEMOOR",
    "dropdelst": "SC",
    "dropdelzpp": 297128763,
    "dropphyadd": "4469 EDGELAND RD",
    "dropphycty": "EDGEMOOR",
    "dropphyst": "SC",
    "dropphyzpp": 297128763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGEMOOR",
    "dropmalst": "SC",
    "dropmalzpp": 297129998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8037895005,
    "dropsitcph": 8037895005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23843",
    "droptype": "D",
    "dropname": "EDISTO ISLAND",
    "dropdeladd": "539 HIGHWAY 174",
    "dropdelcty": "EDISTO ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 294389998,
    "dropphyadd": "539 HIGHWAY 174",
    "dropphycty": "EDISTO ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 294389998,
    "dropmaladd": "539 HIGHWAY 174",
    "dropmalcty": "EDISTO ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 294389998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436033718,
    "dropsitcph": 8436033718,
    "dropfax": 8438690418
  },
  {
    "dcode": "D",
    "dropkey": "PX23845",
    "droptype": "D",
    "dropname": "EFFINGHAM",
    "dropdeladd": "5913 S IRBY ST",
    "dropdelcty": "EFFINGHAM",
    "dropdelst": "SC",
    "dropdelzpp": 295419998,
    "dropphyadd": "5913 S IRBY ST",
    "dropphycty": "EFFINGHAM",
    "dropphyst": "SC",
    "dropphyzpp": 295419998,
    "dropmaladd": "5913 S IRBY ST",
    "dropmalcty": "EFFINGHAM",
    "dropmalst": "SC",
    "dropmalzpp": 295419998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436792451,
    "dropsitcph": 8436625854,
    "dropfax": 8436739641
  },
  {
    "dcode": "D",
    "dropkey": "PX23846",
    "droptype": "D",
    "dropname": "EHRHARDT",
    "dropdeladd": "13443 BROXTON BRIDGE RD",
    "dropdelcty": "EHRHARDT",
    "dropdelst": "SC",
    "dropdelzpp": 290819998,
    "dropphyadd": "13443 BROXTON BRIDGE RD",
    "dropphycty": "EHRHARDT",
    "dropphyst": "SC",
    "dropphyzpp": 290819998,
    "dropmaladd": "13443 BROXTON BRIDGE RD",
    "dropmalcty": "EHRHARDT",
    "dropmalst": "SC",
    "dropmalzpp": 290819998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032675075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23847",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "1100 CHURCH ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "SC",
    "dropdelzpp": 290458543,
    "dropphyadd": "1100 CHURCH ST",
    "dropphycty": "ELGIN",
    "dropphyst": "SC",
    "dropphyzpp": 290458543,
    "dropmaladd": "1100 CHURCH ST",
    "dropmalcty": "ELGIN",
    "dropmalst": "SC",
    "dropmalzpp": 290458543,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034383536,
    "dropfax": 8034381700
  },
  {
    "dcode": "D",
    "dropkey": "PX23849",
    "droptype": "D",
    "dropname": "ELKO",
    "dropdeladd": "10049 US HIGHWAY 78",
    "dropdelcty": "ELKO",
    "dropdelst": "SC",
    "dropdelzpp": 298269998,
    "dropphyadd": "10049 US HIGHWAY 78",
    "dropphycty": "ELKO",
    "dropphyst": "SC",
    "dropphyzpp": 298269998,
    "dropmaladd": "10049 US HIGHWAY 78",
    "dropmalcty": "ELKO",
    "dropmalst": "SC",
    "dropmalzpp": 298269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032663073,
    "dropsitcph": 8032663073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23850",
    "droptype": "D",
    "dropname": "ELLIOTT",
    "dropdeladd": "1783 ELLIOTT HWY",
    "dropdelcty": "ELLIOTT",
    "dropdelst": "SC",
    "dropdelzpp": 290469801,
    "dropphyadd": "1783 ELLIOTT HWY",
    "dropphycty": "ELLIOTT",
    "dropphyst": "SC",
    "dropphyzpp": 290469801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLIOTT",
    "dropmalst": "SC",
    "dropmalzpp": 290469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034285600,
    "dropfax": 8034285602
  },
  {
    "dcode": "D",
    "dropkey": "PX23851",
    "droptype": "D",
    "dropname": "ELLOREE",
    "dropdeladd": "6417 OLD NUMBER SIX HWY",
    "dropdelcty": "ELLOREE",
    "dropdelst": "SC",
    "dropdelzpp": 290479998,
    "dropphyadd": "6417 OLD NUMBER SIX HWY",
    "dropphycty": "ELLOREE",
    "dropphyst": "SC",
    "dropphyzpp": 290479998,
    "dropmaladd": "6417 OLD NUMBER SIX HWY",
    "dropmalcty": "ELLOREE",
    "dropmalst": "SC",
    "dropmalzpp": 290479998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038972333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23853",
    "droptype": "D",
    "dropname": "ENOREE",
    "dropdeladd": "1369 PARKER RD",
    "dropdelcty": "ENOREE",
    "dropdelst": "SC",
    "dropdelzpp": 293359998,
    "dropphyadd": "1369 PARKER RD",
    "dropphycty": "ENOREE",
    "dropphyst": "SC",
    "dropphyzpp": 293359998,
    "dropmaladd": "1369 PARKER RD",
    "dropmalcty": "ENOREE",
    "dropmalst": "SC",
    "dropmalzpp": 293359998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649693110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23854",
    "droptype": "D",
    "dropname": "ESTILL",
    "dropdeladd": "328 E RAILROAD AVE N",
    "dropdelcty": "ESTILL",
    "dropdelst": "SC",
    "dropdelzpp": 299189998,
    "dropphyadd": "328 E RAILROAD AVE N",
    "dropphycty": "ESTILL",
    "dropphyst": "SC",
    "dropphyzpp": 299189998,
    "dropmaladd": "328 E RAILROAD AVE N",
    "dropmalcty": "ESTILL",
    "dropmalst": "SC",
    "dropmalzpp": 299189998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036252636,
    "dropsitcph": 8036252636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23858",
    "droptype": "D",
    "dropname": "EUTAWVILLE",
    "dropdeladd": "313 PORCHER AVE",
    "dropdelcty": "EUTAWVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 290489998,
    "dropphyadd": "313 PORCHER AVE",
    "dropphycty": "EUTAWVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 290489998,
    "dropmaladd": "313 PORCHER AVE",
    "dropmalcty": "EUTAWVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 290489998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034927451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23861",
    "droptype": "D",
    "dropname": "FAIR PLAY",
    "dropdeladd": "805 E FAIRPLAY BLVD",
    "dropdelcty": "FAIR PLAY",
    "dropdelst": "SC",
    "dropdelzpp": 296439998,
    "dropphyadd": "805 E FAIRPLAY BLVD",
    "dropphycty": "FAIR PLAY",
    "dropphyst": "SC",
    "dropphyzpp": 296439998,
    "dropmaladd": "805 E FAIRPLAY BLVD",
    "dropmalcty": "FAIR PLAY",
    "dropmalst": "SC",
    "dropmalzpp": 296439998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649729300,
    "dropfax": 8649729499
  },
  {
    "dcode": "D",
    "dropkey": "PX23862",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "190 PICKENS AVE N",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "SC",
    "dropdelzpp": 298279998,
    "dropphyadd": "190 PICKENS AVE N",
    "dropphycty": "FAIRFAX",
    "dropphyst": "SC",
    "dropphyzpp": 298279998,
    "dropmaladd": "190 PICKENS AVE N",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "SC",
    "dropmalzpp": 298279998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036323910,
    "dropsitcph": 8036323910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23867",
    "droptype": "D",
    "dropname": "FAIRFOREST",
    "dropdeladd": "2435 FAIRFOREST CLEVEDALE RD",
    "dropdelcty": "FAIRFOREST",
    "dropdelst": "SC",
    "dropdelzpp": 293369800,
    "dropphyadd": "2435 FAIRFOREST CLEVEDALE RD",
    "dropphycty": "FAIRFOREST",
    "dropphyst": "SC",
    "dropphyzpp": 293369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRFOREST",
    "dropmalst": "SC",
    "dropmalzpp": 293369998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645743096,
    "dropfax": 8645768291
  },
  {
    "dcode": "D",
    "dropkey": "PX23880",
    "droptype": "D",
    "dropname": "FINGERVILLE",
    "dropdeladd": "10275 FRANKLIN ST",
    "dropdelcty": "FINGERVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 293389800,
    "dropphyadd": "10275 FRANKLIN ST",
    "dropphycty": "FINGERVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 293389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FINGERVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 293389998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645921184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23890",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "1901 W EVANS ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "SC",
    "dropdelzpp": 295019998,
    "dropphyadd": "1901 W EVANS ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "SC",
    "dropphyzpp": 295019998,
    "dropmaladd": "1901 W EVANS ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "SC",
    "dropmalzpp": 295019998,
    "dropsitphn": 8039266015,
    "dropsitlph": 8436792465,
    "dropsitcph": 8436792465,
    "dropfax": 8436656165
  },
  {
    "dcode": "D",
    "dropkey": "PX23894",
    "droptype": "D",
    "dropname": "FOLLY BEACH",
    "dropdeladd": "107 E INDIAN AVE",
    "dropdelcty": "FOLLY BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 294399800,
    "dropphyadd": "107 E INDIAN AVE",
    "dropphycty": "FOLLY BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 294399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOLLY BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 294399998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435882244,
    "dropsitcph": 8435882244,
    "dropfax": 8435880285
  },
  {
    "dcode": "D",
    "dropkey": "PX23901",
    "droptype": "D",
    "dropname": "FORK",
    "dropdeladd": "4114 HIGHWAY 57 S",
    "dropdelcty": "FORK",
    "dropdelst": "SC",
    "dropdelzpp": 295439998,
    "dropphyadd": "4114 HIGHWAY 57 S",
    "dropphycty": "FORK",
    "dropphyst": "SC",
    "dropphyzpp": 295439998,
    "dropmaladd": "4114 HIGHWAY 57 S",
    "dropmalcty": "FORK",
    "dropmalst": "SC",
    "dropmalzpp": 295439998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434647439,
    "dropsitcph": 8434647439,
    "dropfax": 8034648608
  },
  {
    "dcode": "D",
    "dropkey": "PX23904",
    "droptype": "D",
    "dropname": "FORT LAWN",
    "dropdeladd": "5915 LANCASTER HWY",
    "dropdelcty": "FORT LAWN",
    "dropdelst": "SC",
    "dropdelzpp": 297148669,
    "dropphyadd": "5915 LANCASTER HWY",
    "dropphycty": "FORT LAWN",
    "dropphyst": "SC",
    "dropphyzpp": 297148669,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT LAWN",
    "dropmalst": "SC",
    "dropmalzpp": 297149998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8038724472,
    "dropsitcph": 8038724472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23905",
    "droptype": "D",
    "dropname": "FORT MILL",
    "dropdeladd": "201 TOM HALL ST",
    "dropdelcty": "FORT MILL",
    "dropdelst": "SC",
    "dropdelzpp": 297152313,
    "dropphyadd": "201 TOM HALL ST",
    "dropphycty": "FORT MILL",
    "dropphyst": "SC",
    "dropphyzpp": 297152313,
    "dropmaladd": "201 TOM HALL ST",
    "dropmalcty": "FORT MILL",
    "dropmalst": "SC",
    "dropmalzpp": 297152313,
    "dropsitphn": 7043934581,
    "dropsitlph": 8035472771,
    "dropsitcph": 8035472771,
    "dropfax": 8035474123
  },
  {
    "dcode": "D",
    "dropkey": "PX23908",
    "droptype": "D",
    "dropname": "FOUNTAIN INN",
    "dropdeladd": "290 MCCARTER RD",
    "dropdelcty": "FOUNTAIN INN",
    "dropdelst": "SC",
    "dropdelzpp": 296449998,
    "dropphyadd": "290 MCCARTER RD",
    "dropphycty": "FOUNTAIN INN",
    "dropphyst": "SC",
    "dropphyzpp": 296449998,
    "dropmaladd": "290 MCCARTER RD",
    "dropmalcty": "FOUNTAIN INN",
    "dropmalst": "SC",
    "dropmalzpp": 296449998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648623383,
    "dropfax": 8648625672
  },
  {
    "dcode": "D",
    "dropkey": "PX23924",
    "droptype": "D",
    "dropname": "FURMAN",
    "dropdeladd": "81 JEFFERSON ST",
    "dropdelcty": "FURMAN",
    "dropdelst": "SC",
    "dropdelzpp": 299219998,
    "dropphyadd": "81 JEFFERSON ST",
    "dropphycty": "FURMAN",
    "dropphyst": "SC",
    "dropphyzpp": 299219998,
    "dropmaladd": "81 JEFFERSON ST",
    "dropmalcty": "FURMAN",
    "dropmalst": "SC",
    "dropmalzpp": 299219998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036253682,
    "dropsitcph": 8036253682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23926",
    "droptype": "D",
    "dropname": "GABLE",
    "dropdeladd": "12306 HWY 301",
    "dropdelcty": "GABLE",
    "dropdelst": "SC",
    "dropdelzpp": 290519679,
    "dropphyadd": "12306 HWY 301",
    "dropphycty": "GABLE",
    "dropphyst": "SC",
    "dropphyzpp": 290519679,
    "dropmaladd": "12306 HWY 301",
    "dropmalcty": "GABLE",
    "dropmalst": "SC",
    "dropmalzpp": 290519679,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034748021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23927",
    "droptype": "D",
    "dropname": "GADSDEN",
    "dropdeladd": "7731 BLUFF RD",
    "dropdelcty": "GADSDEN",
    "dropdelst": "SC",
    "dropdelzpp": 290529998,
    "dropphyadd": "7731 BLUFF RD",
    "dropphycty": "GADSDEN",
    "dropphyst": "SC",
    "dropphyzpp": 290529998,
    "dropmaladd": "7731 BLUFF RD",
    "dropmalcty": "GADSDEN",
    "dropmalst": "SC",
    "dropmalzpp": 290529998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033530995,
    "dropfax": 8033530397
  },
  {
    "dcode": "D",
    "dropkey": "PX23928",
    "droptype": "D",
    "dropname": "GAFFNEY",
    "dropdeladd": "1208 W FLOYD BAKER BLVD",
    "dropdelcty": "GAFFNEY",
    "dropdelst": "SC",
    "dropdelzpp": 293419998,
    "dropphyadd": "1208 W FLOYD BAKER BLVD",
    "dropphycty": "GAFFNEY",
    "dropphyst": "SC",
    "dropphyzpp": 293419998,
    "dropmaladd": "1208 W FLOYD BAKER BLVD",
    "dropmalcty": "GAFFNEY",
    "dropmalst": "SC",
    "dropmalzpp": 293419998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644897144,
    "dropfax": 8644898690
  },
  {
    "dcode": "D",
    "dropkey": "PX23940",
    "droptype": "D",
    "dropname": "GARNETT",
    "dropdeladd": "15 AUGUSTA STAGECOACH RD",
    "dropdelcty": "GARNETT",
    "dropdelst": "SC",
    "dropdelzpp": 299229998,
    "dropphyadd": "15 AUGUSTA STAGECOACH RD",
    "dropphycty": "GARNETT",
    "dropphyst": "SC",
    "dropphyzpp": 299229998,
    "dropmaladd": "15 AUGUSTA STAGECOACH RD",
    "dropmalcty": "GARNETT",
    "dropmalst": "SC",
    "dropmalzpp": 299229998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036252206,
    "dropsitcph": 8036252206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23941",
    "droptype": "D",
    "dropname": "GASTON",
    "dropdeladd": "220 S MAIN ST",
    "dropdelcty": "GASTON",
    "dropdelst": "SC",
    "dropdelzpp": 290539331,
    "dropphyadd": "220 S MAIN ST",
    "dropphycty": "GASTON",
    "dropphyst": "SC",
    "dropphyzpp": 290539331,
    "dropmaladd": "220 S MAIN ST",
    "dropmalcty": "GASTON",
    "dropmalst": "SC",
    "dropmalzpp": 290539331,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037967555,
    "dropfax": 8037968718
  },
  {
    "dcode": "D",
    "dropkey": "PX23943",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1101 CHARLOTTE ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "SC",
    "dropdelzpp": 294409998,
    "dropphyadd": "1101 CHARLOTTE ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "SC",
    "dropphyzpp": 294409998,
    "dropmaladd": "1101 CHARLOTTE ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "SC",
    "dropmalzpp": 294409998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435465515,
    "dropsitcph": 8435465515,
    "dropfax": 8435271132
  },
  {
    "dcode": "D",
    "dropkey": "PX23945",
    "droptype": "D",
    "dropname": "GIFFORD",
    "dropdeladd": "5944 COLUMBIA HWY",
    "dropdelcty": "GIFFORD",
    "dropdelst": "SC",
    "dropdelzpp": 299239998,
    "dropphyadd": "5944 COLUMBIA HWY",
    "dropphycty": "GIFFORD",
    "dropphyst": "SC",
    "dropphyzpp": 299239998,
    "dropmaladd": "5944 COLUMBIA HWY",
    "dropmalcty": "GIFFORD",
    "dropmalst": "SC",
    "dropmalzpp": 299239998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036252752,
    "dropsitcph": 8036252752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23946",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "401 BROAD ST",
    "dropdelcty": "GILBERT",
    "dropdelst": "SC",
    "dropdelzpp": 290548497,
    "dropphyadd": "401 BROAD ST",
    "dropphycty": "GILBERT",
    "dropphyst": "SC",
    "dropphyzpp": 290548497,
    "dropmaladd": "401 BROAD ST",
    "dropmalcty": "GILBERT",
    "dropmalst": "SC",
    "dropmalzpp": 290548497,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038922525,
    "dropfax": 8038924323
  },
  {
    "dcode": "D",
    "dropkey": "PX23952",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "350 BROADWAY ST",
    "dropdelcty": "GLENDALE",
    "dropdelst": "SC",
    "dropdelzpp": 293469800,
    "dropphyadd": "350 BROADWAY ST",
    "dropphycty": "GLENDALE",
    "dropphyst": "SC",
    "dropphyzpp": 293469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENDALE",
    "dropmalst": "SC",
    "dropmalzpp": 293469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645794845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23954",
    "droptype": "D",
    "dropname": "GLOVERVILLE",
    "dropdeladd": "2298 AUGUSTA RD",
    "dropdelcty": "GLOVERVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 298289998,
    "dropphyadd": "2298 AUGUSTA RD",
    "dropphycty": "GLOVERVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 298289998,
    "dropmaladd": "2298 AUGUSTA RD",
    "dropmalcty": "GLOVERVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 298289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035934964,
    "dropsitcph": 8035934964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23958",
    "droptype": "D",
    "dropname": "GOOSE CREEK",
    "dropdeladd": "307 N GOOSE CREEK BLVD",
    "dropdelcty": "GOOSE CREEK",
    "dropdelst": "SC",
    "dropdelzpp": 294459998,
    "dropphyadd": "307 N GOOSE CREEK BLVD",
    "dropphycty": "GOOSE CREEK",
    "dropphyst": "SC",
    "dropphyzpp": 294459998,
    "dropmaladd": "307 N GOOSE CREEK BLVD",
    "dropmalcty": "GOOSE CREEK",
    "dropmalst": "SC",
    "dropmalzpp": 294459998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435530321,
    "dropsitcph": 8435530321,
    "dropfax": 8435722398
  },
  {
    "dcode": "D",
    "dropkey": "PX23967",
    "droptype": "D",
    "dropname": "GRAMLING",
    "dropdeladd": "14921 ASHEVILLE HWY",
    "dropdelcty": "GRAMLING",
    "dropdelst": "SC",
    "dropdelzpp": 293489800,
    "dropphyadd": "14921 ASHEVILLE HWY",
    "dropphycty": "GRAMLING",
    "dropphyst": "SC",
    "dropphyzpp": 293489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAMLING",
    "dropmalst": "SC",
    "dropmalzpp": 293489998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644722435,
    "dropfax": 8644722596
  },
  {
    "dcode": "D",
    "dropkey": "PX23968",
    "droptype": "D",
    "dropname": "GRANITEVILLE",
    "dropdeladd": "50 CANAL ST STE 4",
    "dropdelcty": "GRANITEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 298299998,
    "dropphyadd": "50 CANAL ST STE 4",
    "dropphycty": "GRANITEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 298299998,
    "dropmaladd": "50 CANAL ST STE 4",
    "dropmalcty": "GRANITEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 298299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036634991,
    "dropsitcph": 8036634991,
    "dropfax": 8036634024
  },
  {
    "dcode": "D",
    "dropkey": "PX23970",
    "droptype": "D",
    "dropname": "GRAY COURT",
    "dropdeladd": "411 W MAIN ST",
    "dropdelcty": "GRAY COURT",
    "dropdelst": "SC",
    "dropdelzpp": 296459998,
    "dropphyadd": "411 W MAIN ST",
    "dropphycty": "GRAY COURT",
    "dropphyst": "SC",
    "dropphyzpp": 296459998,
    "dropmaladd": "411 W MAIN ST",
    "dropmalcty": "GRAY COURT",
    "dropmalst": "SC",
    "dropmalzpp": 296459998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648763276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23974",
    "droptype": "D",
    "dropname": "GREAT FALLS",
    "dropdeladd": "649 DEARBORN ST",
    "dropdelcty": "GREAT FALLS",
    "dropdelst": "SC",
    "dropdelzpp": 290551649,
    "dropphyadd": "649 DEARBORN ST",
    "dropphycty": "GREAT FALLS",
    "dropphyst": "SC",
    "dropphyzpp": 290551649,
    "dropmaladd": "649 DEARBORN ST",
    "dropmalcty": "GREAT FALLS",
    "dropmalst": "SC",
    "dropmalzpp": 290551649,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8397465485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23976",
    "droptype": "D",
    "dropname": "GREELEYVILLE",
    "dropdeladd": "24 C E MURRAY BLVD",
    "dropdelcty": "GREELEYVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 290569700,
    "dropphyadd": "24 C E MURRAY BLVD",
    "dropphycty": "GREELEYVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 290569700,
    "dropmaladd": "24 C E MURRAY BLVD",
    "dropmalcty": "GREELEYVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 290569700,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8434262500,
    "dropfax": 8434264840
  },
  {
    "dcode": "D",
    "dropkey": "PX23979",
    "droptype": "D",
    "dropname": "GREEN POND",
    "dropdeladd": "12225 GREEN POND HWY",
    "dropdelcty": "GREEN POND",
    "dropdelst": "SC",
    "dropdelzpp": 294469998,
    "dropphyadd": "12225 GREEN POND HWY",
    "dropphycty": "GREEN POND",
    "dropphyst": "SC",
    "dropphyzpp": 294469998,
    "dropmaladd": "12225 GREEN POND HWY",
    "dropmalcty": "GREEN POND",
    "dropmalst": "SC",
    "dropmalzpp": 294469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438442620,
    "dropsitcph": 8438442620,
    "dropfax": 8438448102
  },
  {
    "dcode": "D",
    "dropkey": "PX23980",
    "droptype": "D",
    "dropname": "GREEN SEA",
    "dropdeladd": "3720 MITCHELL SEA RD",
    "dropdelcty": "GREEN SEA",
    "dropdelst": "SC",
    "dropdelzpp": 295459998,
    "dropphyadd": "3720 MITCHELL SEA RD",
    "dropphycty": "GREEN SEA",
    "dropphyst": "SC",
    "dropphyzpp": 295459998,
    "dropmaladd": "3720 MITCHELL SEA RD",
    "dropmalcty": "GREEN SEA",
    "dropmalst": "SC",
    "dropmalzpp": 295459998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437567550,
    "dropsitcph": 8437567550,
    "dropfax": 8437567550
  },
  {
    "dcode": "D",
    "dropkey": "PX23985",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "600 W WASHINGTON ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296029998,
    "dropphyadd": "600 W WASHINGTON ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296029998,
    "dropmaladd": "600 W WASHINGTON ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296029998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8642828421,
    "dropsitcph": 8642828449,
    "dropfax": 8642828315
  },
  {
    "dcode": "D",
    "dropkey": "PX23987",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "240 N CREEK BLVD",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "SC",
    "dropdelzpp": 296499998,
    "dropphyadd": "240 N CREEK BLVD",
    "dropphycty": "GREENWOOD",
    "dropphyst": "SC",
    "dropphyzpp": 296499998,
    "dropmaladd": "240 N CREEK BLVD",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "SC",
    "dropmalzpp": 296499998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642296072,
    "dropfax": 8649414128
  },
  {
    "dcode": "D",
    "dropkey": "PX23988",
    "droptype": "D",
    "dropname": "GREER",
    "dropdeladd": "504 PENNSYLVANIA AVE",
    "dropdelcty": "GREER",
    "dropdelst": "SC",
    "dropdelzpp": 296509998,
    "dropphyadd": "504 PENNSYLVANIA AVE",
    "dropphycty": "GREER",
    "dropphyst": "SC",
    "dropphyzpp": 296509998,
    "dropmaladd": "504 PENNSYLVANIA AVE",
    "dropmalcty": "GREER",
    "dropmalst": "SC",
    "dropmalzpp": 296509998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648776423,
    "dropfax": 8648010405
  },
  {
    "dcode": "D",
    "dropkey": "PX23989",
    "droptype": "D",
    "dropname": "GRESHAM",
    "dropdeladd": "7027 HIGHWAY 908",
    "dropdelcty": "GRESHAM",
    "dropdelst": "SC",
    "dropdelzpp": 295469998,
    "dropphyadd": "7027 HIGHWAY 908",
    "dropphycty": "GRESHAM",
    "dropphyst": "SC",
    "dropphyzpp": 295469998,
    "dropmaladd": "7027 HIGHWAY 908",
    "dropmalcty": "GRESHAM",
    "dropmalst": "SC",
    "dropmalzpp": 295469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433622421,
    "dropsitcph": 8433622421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX23995",
    "droptype": "D",
    "dropname": "HAMER",
    "dropdeladd": "2809 HIGHWAY 301 N",
    "dropdelcty": "HAMER",
    "dropdelst": "SC",
    "dropdelzpp": 295479998,
    "dropphyadd": "2809 HIGHWAY 301 N",
    "dropphycty": "HAMER",
    "dropphyst": "SC",
    "dropphyzpp": 295479998,
    "dropmaladd": "2809 HIGHWAY 301 N",
    "dropmalcty": "HAMER",
    "dropmalst": "SC",
    "dropmalzpp": 295479998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437748233,
    "dropsitcph": 8437748233,
    "dropfax": 8437743767
  },
  {
    "dcode": "D",
    "dropkey": "PX23998",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "604 1ST ST W",
    "dropdelcty": "HAMPTON",
    "dropdelst": "SC",
    "dropdelzpp": 299249998,
    "dropphyadd": "604 1ST ST W",
    "dropphycty": "HAMPTON",
    "dropphyst": "SC",
    "dropphyzpp": 299249998,
    "dropmaladd": "604 1ST ST W",
    "dropmalcty": "HAMPTON",
    "dropmalst": "SC",
    "dropmalzpp": 299249998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8039435954,
    "dropsitcph": 8039435954,
    "dropfax": 8039432990
  },
  {
    "dcode": "D",
    "dropkey": "PX24009",
    "droptype": "D",
    "dropname": "HARDEEVILLE",
    "dropdeladd": "23848 WHYTE HARDEE BLVD",
    "dropdelcty": "HARDEEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 299279998,
    "dropphyadd": "23848 WHYTE HARDEE BLVD",
    "dropphycty": "HARDEEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 299279998,
    "dropmaladd": "23848 WHYTE HARDEE BLVD",
    "dropmalcty": "HARDEEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 299279998,
    "dropsitphn": 8437845406,
    "dropsitlph": 8437845406,
    "dropsitcph": 8437845406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24010",
    "droptype": "D",
    "dropname": "HARLEYVILLE",
    "dropdeladd": "130 E MAIN ST",
    "dropdelcty": "HARLEYVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294489998,
    "dropphyadd": "130 E MAIN ST",
    "dropphycty": "HARLEYVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294489998,
    "dropmaladd": "130 E MAIN ST",
    "dropmalcty": "HARLEYVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294489998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434627706,
    "dropsitcph": 8434627706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24014",
    "droptype": "D",
    "dropname": "HARTSVILLE",
    "dropdeladd": "500 S 4TH ST",
    "dropdelcty": "HARTSVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 295509998,
    "dropphyadd": "500 S 4TH ST",
    "dropphycty": "HARTSVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 295509998,
    "dropmaladd": "500 S 4TH ST",
    "dropmalcty": "HARTSVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 295509998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433329611,
    "dropsitcph": 8433329611,
    "dropfax": 8433834094
  },
  {
    "dcode": "D",
    "dropkey": "PX24022",
    "droptype": "D",
    "dropname": "HEATH SPRINGS",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "HEATH SPRINGS",
    "dropdelst": "SC",
    "dropdelzpp": 290589998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "HEATH SPRINGS",
    "dropphyst": "SC",
    "dropphyzpp": 290589998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "HEATH SPRINGS",
    "dropmalst": "SC",
    "dropmalzpp": 290589998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032734855,
    "dropfax": 8032734008
  },
  {
    "dcode": "D",
    "dropkey": "PX24024",
    "droptype": "D",
    "dropname": "HEMINGWAY",
    "dropdeladd": "301 E BROAD ST",
    "dropdelcty": "HEMINGWAY",
    "dropdelst": "SC",
    "dropdelzpp": 295549998,
    "dropphyadd": "301 E BROAD ST",
    "dropphycty": "HEMINGWAY",
    "dropphyst": "SC",
    "dropphyzpp": 295549998,
    "dropmaladd": "301 E BROAD ST",
    "dropmalcty": "HEMINGWAY",
    "dropmalst": "SC",
    "dropmalzpp": 295549998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435583141,
    "dropsitcph": 8435583141,
    "dropfax": 8435585100
  },
  {
    "dcode": "D",
    "dropkey": "PX24029",
    "droptype": "D",
    "dropname": "HICKORY GROVE",
    "dropdeladd": "6015 WYLIE AVE",
    "dropdelcty": "HICKORY GROVE",
    "dropdelst": "SC",
    "dropdelzpp": 297177759,
    "dropphyadd": "6015 WYLIE AVE",
    "dropphycty": "HICKORY GROVE",
    "dropphyst": "SC",
    "dropphyzpp": 297177759,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKORY GROVE",
    "dropmalst": "SC",
    "dropmalzpp": 297179998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8039252460,
    "dropsitcph": 8039252460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24035",
    "droptype": "D",
    "dropname": "HILTON HEAD ISLAND",
    "dropdeladd": "10 BOW CIR",
    "dropdelcty": "HILTON HEAD ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 299289998,
    "dropphyadd": "10 BOW CIR",
    "dropphycty": "HILTON HEAD ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 299289998,
    "dropmaladd": "10 BOW CIR",
    "dropmalcty": "HILTON HEAD ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 299289998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437857002,
    "dropsitcph": 8437857002,
    "dropfax": 8436868535
  },
  {
    "dcode": "D",
    "dropkey": "PX24037",
    "droptype": "D",
    "dropname": "HODGES",
    "dropdeladd": "115 ROBERTSON ST",
    "dropdelcty": "HODGES",
    "dropdelst": "SC",
    "dropdelzpp": 296539998,
    "dropphyadd": "115 ROBERTSON ST",
    "dropphycty": "HODGES",
    "dropphyst": "SC",
    "dropphyzpp": 296539998,
    "dropmaladd": "115 ROBERTSON ST",
    "dropmalcty": "HODGES",
    "dropmalst": "SC",
    "dropmalzpp": 296539998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643747515,
    "dropfax": 8643743481
  },
  {
    "dcode": "D",
    "dropkey": "PX24038",
    "droptype": "D",
    "dropname": "HOLLY HILL",
    "dropdeladd": "525 GARDNER BLVD",
    "dropdelcty": "HOLLY HILL",
    "dropdelst": "SC",
    "dropdelzpp": 290599998,
    "dropphyadd": "525 GARDNER BLVD",
    "dropphycty": "HOLLY HILL",
    "dropphyst": "SC",
    "dropphyzpp": 290599998,
    "dropmaladd": "525 GARDNER BLVD",
    "dropmalcty": "HOLLY HILL",
    "dropmalst": "SC",
    "dropmalzpp": 290599998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034963910,
    "dropfax": 8034965508
  },
  {
    "dcode": "D",
    "dropkey": "PX24042",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "6345 HIGHWAY 162",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "SC",
    "dropdelzpp": 294496734,
    "dropphyadd": "6345 HIGHWAY 162",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "SC",
    "dropphyzpp": 294496734,
    "dropmaladd": "PO BOX 294491",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "SC",
    "dropmalzpp": 294499990,
    "dropsitphn": 8039266014,
    "dropsitlph": 8439200435,
    "dropsitcph": 8439200435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24048",
    "droptype": "D",
    "dropname": "HONEA PATH",
    "dropdeladd": "312 N SHIRLEY AVE",
    "dropdelcty": "HONEA PATH",
    "dropdelst": "SC",
    "dropdelzpp": 296549998,
    "dropphyadd": "312 N SHIRLEY AVE",
    "dropphycty": "HONEA PATH",
    "dropphyst": "SC",
    "dropphyzpp": 296549998,
    "dropmaladd": "312 N SHIRLEY AVE",
    "dropmalcty": "HONEA PATH",
    "dropmalst": "SC",
    "dropmalzpp": 296549998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643697743,
    "dropfax": 8643696101
  },
  {
    "dcode": "D",
    "dropkey": "PX24049",
    "droptype": "D",
    "dropname": "HOPKINS",
    "dropdeladd": "6200 LOWER RICHLAND BLVD",
    "dropdelcty": "HOPKINS",
    "dropdelst": "SC",
    "dropdelzpp": 290618210,
    "dropphyadd": "6200 LOWER RICHLAND BLVD",
    "dropphycty": "HOPKINS",
    "dropphyst": "SC",
    "dropphyzpp": 290618210,
    "dropmaladd": "6200 LOWER RICHLAND BLVD",
    "dropmalcty": "HOPKINS",
    "dropmalst": "SC",
    "dropmalzpp": 290618210,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037765180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24050",
    "droptype": "D",
    "dropname": "HORATIO",
    "dropdeladd": "3240 HORATIO HAGOOD RD",
    "dropdelcty": "HORATIO",
    "dropdelst": "SC",
    "dropdelzpp": 290629800,
    "dropphyadd": "3240 HORATIO HAGOOD RD",
    "dropphycty": "HORATIO",
    "dropphyst": "SC",
    "dropphyzpp": 290629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HORATIO",
    "dropmalst": "SC",
    "dropmalzpp": 290629998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034996961,
    "dropfax": 8034996961
  },
  {
    "dcode": "D",
    "dropkey": "PX24055",
    "droptype": "D",
    "dropname": "HUGER",
    "dropdeladd": "3282 HIGHWAY 41",
    "dropdelcty": "HUGER",
    "dropdelst": "SC",
    "dropdelzpp": 294509998,
    "dropphyadd": "3282 HIGHWAY 41",
    "dropphycty": "HUGER",
    "dropphyst": "SC",
    "dropphyzpp": 294509998,
    "dropmaladd": "3282 HIGHWAY 41",
    "dropmalcty": "HUGER",
    "dropmalst": "SC",
    "dropmalzpp": 294509998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433363846,
    "dropsitcph": 8433363846,
    "dropfax": 8433364384
  },
  {
    "dcode": "D",
    "dropkey": "PX24058",
    "droptype": "D",
    "dropname": "INMAN",
    "dropdeladd": "14 BLACKSTOCK RD",
    "dropdelcty": "INMAN",
    "dropdelst": "SC",
    "dropdelzpp": 293499998,
    "dropphyadd": "14 BLACKSTOCK RD",
    "dropphycty": "INMAN",
    "dropphyst": "SC",
    "dropphyzpp": 293499998,
    "dropmaladd": "14 BLACKSTOCK RD",
    "dropmalcty": "INMAN",
    "dropmalst": "SC",
    "dropmalzpp": 293499998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644728401,
    "dropfax": 8644724046
  },
  {
    "dcode": "D",
    "dropkey": "PX24061",
    "droptype": "D",
    "dropname": "IRMO",
    "dropdeladd": "7821 SAINT ANDREWS RD",
    "dropdelcty": "IRMO",
    "dropdelst": "SC",
    "dropdelzpp": 290632867,
    "dropphyadd": "7821 SAINT ANDREWS RD",
    "dropphycty": "IRMO",
    "dropphyst": "SC",
    "dropphyzpp": 290632867,
    "dropmaladd": "7821 SAINT ANDREWS RD",
    "dropmalcty": "IRMO",
    "dropmalst": "SC",
    "dropmalzpp": 290632867,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037814024,
    "dropfax": 8037815822
  },
  {
    "dcode": "D",
    "dropkey": "PX24063",
    "droptype": "D",
    "dropname": "ISLANDTON",
    "dropdeladd": "14759 SNIDERS HWY",
    "dropdelcty": "ISLANDTON",
    "dropdelst": "SC",
    "dropdelzpp": 299299998,
    "dropphyadd": "14759 SNIDERS HWY",
    "dropphycty": "ISLANDTON",
    "dropphyst": "SC",
    "dropphyzpp": 299299998,
    "dropmaladd": "14759 SNIDERS HWY",
    "dropmalcty": "ISLANDTON",
    "dropmalst": "SC",
    "dropmalzpp": 299299998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8438662433,
    "dropsitcph": 8438662433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24064",
    "droptype": "D",
    "dropname": "ISLE OF PALMS",
    "dropdeladd": "1000 PALM BLVD",
    "dropdelcty": "ISLE OF PALMS",
    "dropdelst": "SC",
    "dropdelzpp": 294519998,
    "dropphyadd": "1000 PALM BLVD",
    "dropphycty": "ISLE OF PALMS",
    "dropphyst": "SC",
    "dropphyzpp": 294519998,
    "dropmaladd": "1000 PALM BLVD",
    "dropmalcty": "ISLE OF PALMS",
    "dropmalst": "SC",
    "dropmalzpp": 294519998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438866536,
    "dropsitcph": 8438866536,
    "dropfax": 8438866536
  },
  {
    "dcode": "D",
    "dropkey": "PX24066",
    "droptype": "D",
    "dropname": "IVA",
    "dropdeladd": "150 E GREEN ST",
    "dropdelcty": "IVA",
    "dropdelst": "SC",
    "dropdelzpp": 296559998,
    "dropphyadd": "150 E GREEN ST",
    "dropphycty": "IVA",
    "dropphyst": "SC",
    "dropphyzpp": 296559998,
    "dropmaladd": "150 E GREEN ST",
    "dropmalcty": "IVA",
    "dropmalst": "SC",
    "dropmalzpp": 296559998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643487555,
    "dropfax": 8643487337
  },
  {
    "dcode": "D",
    "dropkey": "PX24067",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "SC",
    "dropdelzpp": 298319998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "JACKSON",
    "dropphyst": "SC",
    "dropphyzpp": 298319998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "SC",
    "dropmalzpp": 298319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8034713294,
    "dropsitcph": 8034713294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24068",
    "droptype": "D",
    "dropname": "JACKSONBORO",
    "dropdeladd": "16534 ACE BASIN PKWY",
    "dropdelcty": "JACKSONBORO",
    "dropdelst": "SC",
    "dropdelzpp": 294529800,
    "dropphyadd": "16534 ACE BASIN PKWY",
    "dropphycty": "JACKSONBORO",
    "dropphyst": "SC",
    "dropphyzpp": 294529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONBORO",
    "dropmalst": "SC",
    "dropmalzpp": 294529998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438933490,
    "dropsitcph": 8438933490,
    "dropfax": 8438933490
  },
  {
    "dcode": "D",
    "dropkey": "PX24072",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "4354 N HIGHWAY 17A",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "SC",
    "dropdelzpp": 294539998,
    "dropphyadd": "4354 N HIGHWAY 17A",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "SC",
    "dropphyzpp": 294539998,
    "dropmaladd": "4354 N HIGHWAY 17A",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "SC",
    "dropmalzpp": 294539998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432572229,
    "dropsitcph": 8432572229,
    "dropfax": 8432574253
  },
  {
    "dcode": "D",
    "dropkey": "PX24076",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "SC",
    "dropdelzpp": 297189799,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "SC",
    "dropphyzpp": 297189799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "SC",
    "dropmalzpp": 297189998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8436583126,
    "dropsitcph": 8436583126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24077",
    "droptype": "D",
    "dropname": "JENKINSVILLE",
    "dropdeladd": "11298 STATE HIGHWAY 215 S",
    "dropdelcty": "JENKINSVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 290659722,
    "dropphyadd": "11298 STATE HIGHWAY 215 S",
    "dropphycty": "JENKINSVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 290659722,
    "dropmaladd": "11298 STATE HIGHWAY 215 S",
    "dropmalcty": "JENKINSVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 290659722,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033455010,
    "dropfax": 8033455010
  },
  {
    "dcode": "D",
    "dropkey": "PX24081",
    "droptype": "D",
    "dropname": "JOANNA",
    "dropdeladd": "106 REGNERY PLZ",
    "dropdelcty": "JOANNA",
    "dropdelst": "SC",
    "dropdelzpp": 293519998,
    "dropphyadd": "106 REGNERY PLZ",
    "dropphycty": "JOANNA",
    "dropphyst": "SC",
    "dropphyzpp": 293519998,
    "dropmaladd": "106 REGNERY PLZ",
    "dropmalcty": "JOANNA",
    "dropmalst": "SC",
    "dropmalzpp": 293519998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646976540,
    "dropfax": 8646976540
  },
  {
    "dcode": "D",
    "dropkey": "PX24084",
    "droptype": "D",
    "dropname": "JOHNS ISLAND",
    "dropdeladd": "2860 MAYBANK HWY",
    "dropdelcty": "JOHNS ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 294559998,
    "dropphyadd": "2860 MAYBANK HWY",
    "dropphycty": "JOHNS ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 294559998,
    "dropmaladd": "2860 MAYBANK HWY",
    "dropmalcty": "JOHNS ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 294559998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435590622,
    "dropsitcph": 8435590622,
    "dropfax": 8435592395
  },
  {
    "dcode": "D",
    "dropkey": "PX24086",
    "droptype": "D",
    "dropname": "JOHNSONVILLE",
    "dropdeladd": "417 N GEORGETOWN HWY",
    "dropdelcty": "JOHNSONVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 295559998,
    "dropphyadd": "417 N GEORGETOWN HWY",
    "dropphycty": "JOHNSONVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 295559998,
    "dropmaladd": "417 N GEORGETOWN HWY",
    "dropmalcty": "JOHNSONVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 295559998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433862031,
    "dropsitcph": 8433862031,
    "dropfax": 8433866115
  },
  {
    "dcode": "D",
    "dropkey": "PX24089",
    "droptype": "D",
    "dropname": "JOHNSTON",
    "dropdeladd": "519 CALHOUN ST",
    "dropdelcty": "JOHNSTON",
    "dropdelst": "SC",
    "dropdelzpp": 298329998,
    "dropphyadd": "519 CALHOUN ST",
    "dropphycty": "JOHNSTON",
    "dropphyst": "SC",
    "dropphyzpp": 298329998,
    "dropmaladd": "519 CALHOUN ST",
    "dropmalcty": "JOHNSTON",
    "dropmalst": "SC",
    "dropmalzpp": 298329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032750495,
    "dropsitcph": 8032750495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24093",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "2912 FURMAN L FENDLEY HWY",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 293539998,
    "dropphyadd": "2912 FURMAN L FENDLEY HWY",
    "dropphycty": "JONESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 293539998,
    "dropmaladd": "2912 FURMAN L FENDLEY HWY",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 293539998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646745600,
    "dropfax": 8646740430
  },
  {
    "dcode": "D",
    "dropkey": "PX24101",
    "droptype": "D",
    "dropname": "KERSHAW",
    "dropdeladd": "521 N MATSON ST",
    "dropdelcty": "KERSHAW",
    "dropdelst": "SC",
    "dropdelzpp": 290671000,
    "dropphyadd": "521 N MATSON ST",
    "dropphycty": "KERSHAW",
    "dropphyst": "SC",
    "dropphyzpp": 290671000,
    "dropmaladd": "521 N MATSON ST",
    "dropmalcty": "KERSHAW",
    "dropmalst": "SC",
    "dropmalzpp": 290671000,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034758525,
    "dropfax": 8034753075
  },
  {
    "dcode": "D",
    "dropkey": "PX24109",
    "droptype": "D",
    "dropname": "KINGSTREE",
    "dropdeladd": "129 W MILL ST",
    "dropdelcty": "KINGSTREE",
    "dropdelst": "SC",
    "dropdelzpp": 295569998,
    "dropphyadd": "129 W MILL ST",
    "dropphycty": "KINGSTREE",
    "dropphyst": "SC",
    "dropphyzpp": 295569998,
    "dropmaladd": "129 W MILL ST",
    "dropmalcty": "KINGSTREE",
    "dropmalst": "SC",
    "dropmalzpp": 295569998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433547076,
    "dropsitcph": 8433547076,
    "dropfax": 8433543033
  },
  {
    "dcode": "D",
    "dropkey": "PX24118",
    "droptype": "D",
    "dropname": "LA FRANCE",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "LA FRANCE",
    "dropdelst": "SC",
    "dropdelzpp": 296569800,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "LA FRANCE",
    "dropphyst": "SC",
    "dropphyzpp": 296569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA FRANCE",
    "dropmalst": "SC",
    "dropmalzpp": 296569998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646467645,
    "dropfax": 8646467645
  },
  {
    "dcode": "D",
    "dropkey": "PX24119",
    "droptype": "D",
    "dropname": "LADSON",
    "dropdeladd": "3213 LADSON RD",
    "dropdelcty": "LADSON",
    "dropdelst": "SC",
    "dropdelzpp": 294569998,
    "dropphyadd": "3213 LADSON RD",
    "dropphycty": "LADSON",
    "dropphyst": "SC",
    "dropphyzpp": 294569998,
    "dropmaladd": "3213 LADSON RD",
    "dropmalcty": "LADSON",
    "dropmalst": "SC",
    "dropmalzpp": 294569998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437971989,
    "dropsitcph": 8437971989,
    "dropfax": 8435697675
  },
  {
    "dcode": "D",
    "dropkey": "PX24121",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "226 W MAIN ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "SC",
    "dropdelzpp": 295609998,
    "dropphyadd": "226 W MAIN ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "SC",
    "dropphyzpp": 295609998,
    "dropmaladd": "226 W MAIN ST",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "SC",
    "dropmalzpp": 295609998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433942421,
    "dropsitcph": 8433942421,
    "dropfax": 8433947824
  },
  {
    "dcode": "D",
    "dropkey": "PX24126",
    "droptype": "D",
    "dropname": "LAKE VIEW",
    "dropdeladd": "211 RICHARD TEMPLE BLVD",
    "dropdelcty": "LAKE VIEW",
    "dropdelst": "SC",
    "dropdelzpp": 295639998,
    "dropphyadd": "211 RICHARD TEMPLE BLVD",
    "dropphycty": "LAKE VIEW",
    "dropphyst": "SC",
    "dropphyzpp": 295639998,
    "dropmaladd": "211 RICHARD TEMPLE BLVD",
    "dropmalcty": "LAKE VIEW",
    "dropmalst": "SC",
    "dropmalzpp": 295639998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437592681,
    "dropsitcph": 8437592681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24130",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "LAMAR",
    "dropdelst": "SC",
    "dropdelzpp": 290699755,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "LAMAR",
    "dropphyst": "SC",
    "dropphyzpp": 290699755,
    "dropmaladd": "110 MAIN ST",
    "dropmalcty": "LAMAR",
    "dropmalst": "SC",
    "dropmalzpp": 290699755,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433265211,
    "dropfax": 8433265972
  },
  {
    "dcode": "D",
    "dropkey": "PX24131",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "501 N MAIN ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "SC",
    "dropdelzpp": 297202135,
    "dropphyadd": "501 N MAIN ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "SC",
    "dropphyzpp": 297202135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANCASTER",
    "dropmalst": "SC",
    "dropmalzpp": 297209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 8032866202,
    "dropfax": 8032834675
  },
  {
    "dcode": "D",
    "dropkey": "PX24134",
    "droptype": "D",
    "dropname": "LANDRUM",
    "dropdeladd": "500 E RUTHERFORD ST",
    "dropdelcty": "LANDRUM",
    "dropdelst": "SC",
    "dropdelzpp": 293569998,
    "dropphyadd": "500 E RUTHERFORD ST",
    "dropphycty": "LANDRUM",
    "dropphyst": "SC",
    "dropphyzpp": 293569998,
    "dropmaladd": "500 E RUTHERFORD ST",
    "dropmalcty": "LANDRUM",
    "dropmalst": "SC",
    "dropmalzpp": 293569998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644572362,
    "dropfax": 8644577159
  },
  {
    "dcode": "D",
    "dropkey": "PX24135",
    "droptype": "D",
    "dropname": "LANE",
    "dropdeladd": "341 S LANE RD",
    "dropdelcty": "LANE",
    "dropdelst": "SC",
    "dropdelzpp": 295649998,
    "dropphyadd": "341 S LANE RD",
    "dropphycty": "LANE",
    "dropphyst": "SC",
    "dropphyzpp": 295649998,
    "dropmaladd": "341 S LANE RD",
    "dropmalcty": "LANE",
    "dropmalst": "SC",
    "dropmalzpp": 295649998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433875546,
    "dropsitcph": 8433875546,
    "dropfax": 8433875546
  },
  {
    "dcode": "D",
    "dropkey": "PX24136",
    "droptype": "D",
    "dropname": "LANGLEY",
    "dropdeladd": "2748 AUGUSTA RD",
    "dropdelcty": "LANGLEY",
    "dropdelst": "SC",
    "dropdelzpp": 298349998,
    "dropphyadd": "2748 AUGUSTA RD",
    "dropphycty": "LANGLEY",
    "dropphyst": "SC",
    "dropphyzpp": 298349998,
    "dropmaladd": "2748 AUGUSTA RD",
    "dropmalcty": "LANGLEY",
    "dropmalst": "SC",
    "dropmalzpp": 298349998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035935975,
    "dropsitcph": 8035935975,
    "dropfax": 8035941421
  },
  {
    "dcode": "D",
    "dropkey": "PX24137",
    "droptype": "D",
    "dropname": "LATTA",
    "dropdeladd": "115 W MAIN ST",
    "dropdelcty": "LATTA",
    "dropdelst": "SC",
    "dropdelzpp": 295659998,
    "dropphyadd": "115 W MAIN ST",
    "dropphycty": "LATTA",
    "dropphyst": "SC",
    "dropphyzpp": 295659998,
    "dropmaladd": "115 W MAIN ST",
    "dropmalcty": "LATTA",
    "dropmalst": "SC",
    "dropmalzpp": 295659998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437525781,
    "dropsitcph": 8437525781,
    "dropfax": 8437527110
  },
  {
    "dcode": "D",
    "dropkey": "PX24139",
    "droptype": "D",
    "dropname": "LAURENS",
    "dropdeladd": "302 N HARPER ST",
    "dropdelcty": "LAURENS",
    "dropdelst": "SC",
    "dropdelzpp": 293609998,
    "dropphyadd": "302 N HARPER ST",
    "dropphycty": "LAURENS",
    "dropphyst": "SC",
    "dropphyzpp": 293609998,
    "dropmaladd": "302 N HARPER ST",
    "dropmalcty": "LAURENS",
    "dropmalst": "SC",
    "dropmalzpp": 293609998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649843518,
    "dropfax": 8649843510
  },
  {
    "dcode": "D",
    "dropkey": "PX24147",
    "droptype": "D",
    "dropname": "BATESBURG LEESVILLE",
    "dropdeladd": "110 E CHURCH ST",
    "dropdelcty": "LEESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 290709998,
    "dropphyadd": "110 E CHURCH ST",
    "dropphycty": "LEESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 290709998,
    "dropmaladd": "110 E CHURCH ST",
    "dropmalcty": "LEESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 290709998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035323766,
    "dropfax": 8036043337
  },
  {
    "dcode": "D",
    "dropkey": "PX24156",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "1830 S LAKE DR",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "SC",
    "dropdelzpp": 290739998,
    "dropphyadd": "1830 S LAKE DR",
    "dropphycty": "LEXINGTON",
    "dropphyst": "SC",
    "dropphyzpp": 290739998,
    "dropmaladd": "1830 S LAKE DR",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "SC",
    "dropmalzpp": 290739998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033599355,
    "dropfax": 8039574520
  },
  {
    "dcode": "D",
    "dropkey": "PX24157",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "28 N COMMERCE ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "SC",
    "dropdelzpp": 296579998,
    "dropphyadd": "28 N COMMERCE ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "SC",
    "dropphyzpp": 296579998,
    "dropmaladd": "28 N COMMERCE ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "SC",
    "dropmalzpp": 296579998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648436060,
    "dropfax": 8648436069
  },
  {
    "dcode": "D",
    "dropkey": "PX24158",
    "droptype": "D",
    "dropname": "LIBERTY HILL",
    "dropdeladd": "4049 JOHN G RICHARDS RD",
    "dropdelcty": "LIBERTY HILL",
    "dropdelst": "SC",
    "dropdelzpp": 290749800,
    "dropphyadd": "4049 JOHN G RICHARDS RD",
    "dropphycty": "LIBERTY HILL",
    "dropphyst": "SC",
    "dropphyzpp": 290749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTY HILL",
    "dropmalst": "SC",
    "dropmalzpp": 290749998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8647841125,
    "dropsitcph": 8037841198,
    "dropfax": 8032739298
  },
  {
    "dcode": "D",
    "dropkey": "PX24167",
    "droptype": "D",
    "dropname": "LITTLE MOUNTAIN",
    "dropdeladd": "5953 WHEELAND RD",
    "dropdelcty": "LITTLE MOUNTAIN",
    "dropdelst": "SC",
    "dropdelzpp": 290759998,
    "dropphyadd": "5953 WHEELAND RD",
    "dropphycty": "LITTLE MOUNTAIN",
    "dropphyst": "SC",
    "dropphyzpp": 290759998,
    "dropmaladd": "5953 WHEELAND RD",
    "dropmalcty": "LITTLE MOUNTAIN",
    "dropmalst": "SC",
    "dropmalzpp": 290759998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8039457770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24170",
    "droptype": "D",
    "dropname": "LITTLE RIVER",
    "dropdeladd": "4299 HORSESHOE RD N",
    "dropdelcty": "LITTLE RIVER",
    "dropdelst": "SC",
    "dropdelzpp": 295669998,
    "dropphyadd": "4299 HORSESHOE RD N",
    "dropphycty": "LITTLE RIVER",
    "dropphyst": "SC",
    "dropphyzpp": 295669998,
    "dropmaladd": "4299 HORSESHOE RD N",
    "dropmalcty": "LITTLE RIVER",
    "dropmalst": "SC",
    "dropmalzpp": 295669998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432491260,
    "dropsitcph": 8432491260,
    "dropfax": 8432808531
  },
  {
    "dcode": "D",
    "dropkey": "PX24172",
    "droptype": "D",
    "dropname": "LITTLE ROCK",
    "dropdeladd": "1403 HARLLEES BRIDGE RD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "SC",
    "dropdelzpp": 295679998,
    "dropphyadd": "1403 HARLLEES BRIDGE RD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "SC",
    "dropphyzpp": 295679998,
    "dropmaladd": "1403 HARLLEES BRIDGE RD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "SC",
    "dropmalzpp": 295679998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437748750,
    "dropsitcph": 8437748750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24178",
    "droptype": "D",
    "dropname": "LOBECO",
    "dropdeladd": "1892 TRASK PKWY",
    "dropdelcty": "LOBECO",
    "dropdelst": "SC",
    "dropdelzpp": 299319998,
    "dropphyadd": "1892 TRASK PKWY",
    "dropphycty": "LOBECO",
    "dropphyst": "SC",
    "dropphyzpp": 299319998,
    "dropmaladd": "1892 TRASK PKWY",
    "dropmalcty": "LOBECO",
    "dropmalst": "SC",
    "dropmalzpp": 299319998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8438468719,
    "dropsitcph": 8438468719,
    "dropfax": 8438468719
  },
  {
    "dcode": "D",
    "dropkey": "PX24179",
    "droptype": "D",
    "dropname": "LOCKHART",
    "dropdeladd": "404 S 2ND ST",
    "dropdelcty": "LOCKHART",
    "dropdelst": "SC",
    "dropdelzpp": 293649800,
    "dropphyadd": "404 S 2ND ST",
    "dropphycty": "LOCKHART",
    "dropphyst": "SC",
    "dropphyzpp": 293649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCKHART",
    "dropmalst": "SC",
    "dropmalzpp": 293649998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645456878,
    "dropfax": 8645456884
  },
  {
    "dcode": "D",
    "dropkey": "PX24181",
    "droptype": "D",
    "dropname": "LODGE",
    "dropdeladd": "21080 BELLS HWY",
    "dropdelcty": "LODGE",
    "dropdelst": "SC",
    "dropdelzpp": 290829998,
    "dropphyadd": "21080 BELLS HWY",
    "dropphycty": "LODGE",
    "dropphyst": "SC",
    "dropphyzpp": 290829998,
    "dropmaladd": "21080 BELLS HWY",
    "dropmalcty": "LODGE",
    "dropmalst": "SC",
    "dropmalzpp": 290829998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8438667401,
    "dropfax": 8438667401
  },
  {
    "dcode": "D",
    "dropkey": "PX24183",
    "droptype": "D",
    "dropname": "LONG CREEK",
    "dropdeladd": "13851 LONG CREEK HWY",
    "dropdelcty": "LONG CREEK",
    "dropdelst": "SC",
    "dropdelzpp": 296589998,
    "dropphyadd": "13851 LONG CREEK HWY",
    "dropphycty": "LONG CREEK",
    "dropphyst": "SC",
    "dropphyzpp": 296589998,
    "dropmaladd": "13851 LONG CREEK HWY",
    "dropmalcty": "LONG CREEK",
    "dropmalst": "SC",
    "dropmalzpp": 296589998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646479905,
    "dropfax": 8646479905
  },
  {
    "dcode": "D",
    "dropkey": "PX24187",
    "droptype": "D",
    "dropname": "LONGS",
    "dropdeladd": "50 HIGHWAY 9 E",
    "dropdelcty": "LONGS",
    "dropdelst": "SC",
    "dropdelzpp": 295689998,
    "dropphyadd": "50 HIGHWAY 9 E",
    "dropphycty": "LONGS",
    "dropphyst": "SC",
    "dropphyzpp": 295689998,
    "dropmaladd": "50 HIGHWAY 9 E",
    "dropmalcty": "LONGS",
    "dropmalst": "SC",
    "dropmalzpp": 295689998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433996767,
    "dropsitcph": 8433996767,
    "dropfax": 8433999568
  },
  {
    "dcode": "D",
    "dropkey": "PX24189",
    "droptype": "D",
    "dropname": "LORIS",
    "dropdeladd": "3085 BROAD ST",
    "dropdelcty": "LORIS",
    "dropdelst": "SC",
    "dropdelzpp": 295699998,
    "dropphyadd": "3085 BROAD ST",
    "dropphycty": "LORIS",
    "dropphyst": "SC",
    "dropphyzpp": 295699998,
    "dropmaladd": "3085 BROAD ST",
    "dropmalcty": "LORIS",
    "dropmalst": "SC",
    "dropmalzpp": 295699998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437565343,
    "dropsitcph": 8437565343,
    "dropfax": 8437567336
  },
  {
    "dcode": "D",
    "dropkey": "PX24190",
    "droptype": "D",
    "dropname": "LOWNDESVILLE",
    "dropdeladd": "272 MAIN ST",
    "dropdelcty": "LOWNDESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296599800,
    "dropphyadd": "272 MAIN ST",
    "dropphycty": "LOWNDESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWNDESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296599998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643486758,
    "dropfax": 8643486759
  },
  {
    "dcode": "D",
    "dropkey": "PX24194",
    "droptype": "D",
    "dropname": "LUGOFF",
    "dropdeladd": "40 PLAZA DR",
    "dropdelcty": "LUGOFF",
    "dropdelst": "SC",
    "dropdelzpp": 290788637,
    "dropphyadd": "40 PLAZA DR",
    "dropphycty": "LUGOFF",
    "dropphyst": "SC",
    "dropphyzpp": 290788637,
    "dropmaladd": "40 PLAZA DR",
    "dropmalcty": "LUGOFF",
    "dropmalst": "SC",
    "dropmalzpp": 290788637,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034389618,
    "dropfax": 8034387860
  },
  {
    "dcode": "D",
    "dropkey": "PX24195",
    "droptype": "D",
    "dropname": "LURAY",
    "dropdeladd": "2902 COLUMBIA HWY N",
    "dropdelcty": "LURAY",
    "dropdelst": "SC",
    "dropdelzpp": 299329998,
    "dropphyadd": "2902 COLUMBIA HWY N",
    "dropphycty": "LURAY",
    "dropphyst": "SC",
    "dropphyzpp": 299329998,
    "dropmaladd": "2902 COLUMBIA HWY N",
    "dropmalcty": "LURAY",
    "dropmalst": "SC",
    "dropmalzpp": 299329998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036253429,
    "dropsitcph": 8036253429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24196",
    "droptype": "D",
    "dropname": "LYDIA",
    "dropdeladd": "5179 INDIAN BRANCH RD",
    "dropdelcty": "LYDIA",
    "dropdelst": "SC",
    "dropdelzpp": 290799800,
    "dropphyadd": "5179 INDIAN BRANCH RD",
    "dropphycty": "LYDIA",
    "dropphyst": "SC",
    "dropphyzpp": 290799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYDIA",
    "dropmalst": "SC",
    "dropmalzpp": 290799998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433324231,
    "dropfax": 8433325388
  },
  {
    "dcode": "D",
    "dropkey": "PX24198",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "12490 GREENVILLE HWY",
    "dropdelcty": "LYMAN",
    "dropdelst": "SC",
    "dropdelzpp": 293659998,
    "dropphyadd": "12490 GREENVILLE HWY",
    "dropphycty": "LYMAN",
    "dropphyst": "SC",
    "dropphyzpp": 293659998,
    "dropmaladd": "12490 GREENVILLE HWY",
    "dropmalcty": "LYMAN",
    "dropmalst": "SC",
    "dropmalzpp": 293659998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644392476,
    "dropfax": 8644392421
  },
  {
    "dcode": "D",
    "dropkey": "PX24200",
    "droptype": "D",
    "dropname": "LYNCHBURG",
    "dropdeladd": "85 MAGNOLIA ST",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "SC",
    "dropdelzpp": 290809998,
    "dropphyadd": "85 MAGNOLIA ST",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "SC",
    "dropphyzpp": 290809998,
    "dropmaladd": "85 MAGNOLIA ST",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "SC",
    "dropmalzpp": 290809998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034372502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24206",
    "droptype": "D",
    "dropname": "MANNING",
    "dropdeladd": "10 W KEITT ST",
    "dropdelcty": "MANNING",
    "dropdelst": "SC",
    "dropdelzpp": 291029998,
    "dropphyadd": "10 W KEITT ST",
    "dropphycty": "MANNING",
    "dropphyst": "SC",
    "dropphyzpp": 291029998,
    "dropmaladd": "10 W KEITT ST",
    "dropmalcty": "MANNING",
    "dropmalst": "SC",
    "dropmalzpp": 291029998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034358367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24209",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "3047 GEER HWY",
    "dropdelcty": "MARIETTA",
    "dropdelst": "SC",
    "dropdelzpp": 296619998,
    "dropphyadd": "3047 GEER HWY",
    "dropphycty": "MARIETTA",
    "dropphyst": "SC",
    "dropphyzpp": 296619998,
    "dropmaladd": "3047 GEER HWY",
    "dropmalcty": "MARIETTA",
    "dropmalst": "SC",
    "dropmalzpp": 296619998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648363531,
    "dropfax": 8648362082
  },
  {
    "dcode": "D",
    "dropkey": "PX24212",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "SC",
    "dropdelzpp": 295719998,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "SC",
    "dropphyzpp": 295719998,
    "dropmaladd": "201 S MAIN ST",
    "dropmalcty": "MARION",
    "dropmalst": "SC",
    "dropmalzpp": 295719998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434233522,
    "dropsitcph": 8434233522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24217",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "6545 AUGUSTA HWY",
    "dropdelcty": "MARTIN",
    "dropdelst": "SC",
    "dropdelzpp": 298369998,
    "dropphyadd": "6545 AUGUSTA HWY",
    "dropphycty": "MARTIN",
    "dropphyst": "SC",
    "dropphyzpp": 298369998,
    "dropmaladd": "6545 AUGUSTA HWY",
    "dropmalcty": "MARTIN",
    "dropmalst": "SC",
    "dropmalzpp": 298369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035844362,
    "dropsitcph": 8035844362,
    "dropfax": 8035844362
  },
  {
    "dcode": "D",
    "dropkey": "PX24223",
    "droptype": "D",
    "dropname": "MAULDIN",
    "dropdeladd": "498 N MAIN ST",
    "dropdelcty": "MAULDIN",
    "dropdelst": "SC",
    "dropdelzpp": 296629998,
    "dropphyadd": "498 N MAIN ST",
    "dropphycty": "MAULDIN",
    "dropphyst": "SC",
    "dropphyzpp": 296629998,
    "dropmaladd": "498 N MAIN ST",
    "dropmalcty": "MAULDIN",
    "dropmalst": "SC",
    "dropmalzpp": 296629998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642881831,
    "dropfax": 8642887118
  },
  {
    "dcode": "D",
    "dropkey": "PX24225",
    "droptype": "D",
    "dropname": "MAYESVILLE",
    "dropdeladd": "4650 FLORENCE HWY",
    "dropdelcty": "MAYESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 291049998,
    "dropphyadd": "4650 FLORENCE HWY",
    "dropphycty": "MAYESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 291049998,
    "dropmaladd": "4650 FLORENCE HWY",
    "dropmalcty": "MAYESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 291049998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034535634,
    "dropfax": 8034536153
  },
  {
    "dcode": "D",
    "dropkey": "PX24229",
    "droptype": "D",
    "dropname": "MAYO",
    "dropdeladd": "4496 CHESNEE HWY",
    "dropdelcty": "MAYO",
    "dropdelst": "SC",
    "dropdelzpp": 293689800,
    "dropphyadd": "4496 CHESNEE HWY",
    "dropphycty": "MAYO",
    "dropphyst": "SC",
    "dropphyzpp": 293689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYO",
    "dropmalst": "SC",
    "dropmalzpp": 293689998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644612990,
    "dropfax": 8644612990
  },
  {
    "dcode": "D",
    "dropkey": "PX24230",
    "droptype": "D",
    "dropname": "MC BEE",
    "dropdeladd": "56 W PINE AVE",
    "dropdelcty": "MC BEE",
    "dropdelst": "SC",
    "dropdelzpp": 291019223,
    "dropphyadd": "56 W PINE AVE",
    "dropphycty": "MC BEE",
    "dropphyst": "SC",
    "dropphyzpp": 291019223,
    "dropmaladd": "56 W PINE AVE",
    "dropmalcty": "MC BEE",
    "dropmalst": "SC",
    "dropmalzpp": 291019223,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433357734,
    "dropfax": 8433357418
  },
  {
    "dcode": "D",
    "dropkey": "PX24231",
    "droptype": "D",
    "dropname": "MC CLELLANVILLE",
    "dropdeladd": "959 S PINCKNEY ST",
    "dropdelcty": "MC CLELLANVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294589998,
    "dropphyadd": "959 S PINCKNEY ST",
    "dropphycty": "MC CLELLANVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294589998,
    "dropmaladd": "959 S PINCKNEY ST",
    "dropmalcty": "MC CLELLANVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294589998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438873687,
    "dropsitcph": 8438873687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24234",
    "droptype": "D",
    "dropname": "MC COLL",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "MC COLL",
    "dropdelst": "SC",
    "dropdelzpp": 295709998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "MC COLL",
    "dropphyst": "SC",
    "dropphyzpp": 295709998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "MC COLL",
    "dropmalst": "SC",
    "dropmalzpp": 295709998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435235165,
    "dropsitcph": 8435235165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24236",
    "droptype": "D",
    "dropname": "MC CONNELLS",
    "dropdeladd": "4182 CHESTER HWY",
    "dropdelcty": "MC CONNELLS",
    "dropdelst": "SC",
    "dropdelzpp": 297261502,
    "dropphyadd": "4182 CHESTER HWY",
    "dropphycty": "MC CONNELLS",
    "dropphyst": "SC",
    "dropphyzpp": 297261502,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CONNELLS",
    "dropmalst": "SC",
    "dropmalzpp": 297269998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 8036849170,
    "dropfax": 8036849170
  },
  {
    "dcode": "D",
    "dropkey": "PX24237",
    "droptype": "D",
    "dropname": "MC CORMICK",
    "dropdeladd": "201 N PINE ST",
    "dropdelcty": "MC CORMICK",
    "dropdelst": "SC",
    "dropdelzpp": 298359998,
    "dropphyadd": "201 N PINE ST",
    "dropphycty": "MC CORMICK",
    "dropphyst": "SC",
    "dropphyzpp": 298359998,
    "dropmaladd": "201 N PINE ST",
    "dropmalcty": "MC CORMICK",
    "dropmalst": "SC",
    "dropmalzpp": 298359998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8644653696,
    "dropsitcph": 8644653696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24260",
    "droptype": "D",
    "dropname": "MILEY",
    "dropdeladd": "21396 OLD SALKEHATCHIE HWY",
    "dropdelcty": "MILEY",
    "dropdelst": "SC",
    "dropdelzpp": 299339998,
    "dropphyadd": "21396 OLD SALKEHATCHIE HWY",
    "dropphycty": "MILEY",
    "dropphyst": "SC",
    "dropphyzpp": 299339998,
    "dropmaladd": "21396 OLD SALKEHATCHIE HWY",
    "dropmalcty": "MILEY",
    "dropmalst": "SC",
    "dropmalzpp": 299339998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8039433870,
    "dropsitcph": 8039433870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24270",
    "droptype": "D",
    "dropname": "MODOC",
    "dropdeladd": "11489 SC HIGHWAY 28",
    "dropdelcty": "MODOC",
    "dropdelst": "SC",
    "dropdelzpp": 298389998,
    "dropphyadd": "11489 SC HIGHWAY 28",
    "dropphycty": "MODOC",
    "dropphyst": "SC",
    "dropphyzpp": 298389998,
    "dropmaladd": "11489 SC HIGHWAY 28",
    "dropmalcty": "MODOC",
    "dropmalst": "SC",
    "dropmalzpp": 298389998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8643335540,
    "dropsitcph": 8643335540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24274",
    "droptype": "D",
    "dropname": "MONCKS CORNER",
    "dropdeladd": "117 N HIGHWAY 52",
    "dropdelcty": "MONCKS CORNER",
    "dropdelst": "SC",
    "dropdelzpp": 294619998,
    "dropphyadd": "117 N HIGHWAY 52",
    "dropphycty": "MONCKS CORNER",
    "dropphyst": "SC",
    "dropphyzpp": 294619998,
    "dropmaladd": "117 N HIGHWAY 52",
    "dropmalcty": "MONCKS CORNER",
    "dropmalst": "SC",
    "dropmalzpp": 294619998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437618455,
    "dropsitcph": 8437618455,
    "dropfax": 8438991046
  },
  {
    "dcode": "D",
    "dropkey": "PX24279",
    "droptype": "D",
    "dropname": "MONETTA",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "MONETTA",
    "dropdelst": "SC",
    "dropdelzpp": 291059998,
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "MONETTA",
    "dropphyst": "SC",
    "dropphyzpp": 291059998,
    "dropmaladd": "230 MAIN ST",
    "dropmalcty": "MONETTA",
    "dropmalst": "SC",
    "dropmalzpp": 291059998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036857614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24281",
    "droptype": "D",
    "dropname": "MONTMORENCI",
    "dropdeladd": "3053 CHARLESTON HWY",
    "dropdelcty": "MONTMORENCI",
    "dropdelst": "SC",
    "dropdelzpp": 298399998,
    "dropphyadd": "3053 CHARLESTON HWY",
    "dropphycty": "MONTMORENCI",
    "dropphyst": "SC",
    "dropphyzpp": 298399998,
    "dropmaladd": "3053 CHARLESTON HWY",
    "dropmalcty": "MONTMORENCI",
    "dropmalst": "SC",
    "dropmalzpp": 298399998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036480097,
    "dropsitcph": 8036480097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24283",
    "droptype": "D",
    "dropname": "MOORE",
    "dropdeladd": "1129 CENTER POINT DR",
    "dropdelcty": "MOORE",
    "dropdelst": "SC",
    "dropdelzpp": 293699998,
    "dropphyadd": "1129 CENTER POINT DR",
    "dropphycty": "MOORE",
    "dropphyst": "SC",
    "dropphyzpp": 293699998,
    "dropmaladd": "1129 CENTER POINT DR",
    "dropmalcty": "MOORE",
    "dropmalst": "SC",
    "dropmalzpp": 293699998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645743242,
    "dropfax": 8645740149
  },
  {
    "dcode": "D",
    "dropkey": "PX24289",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "102 DEPOT ST",
    "dropdelcty": "MOUNT CARMEL",
    "dropdelst": "SC",
    "dropdelzpp": 298409998,
    "dropphyadd": "102 DEPOT ST",
    "dropphycty": "MOUNT CARMEL",
    "dropphyst": "SC",
    "dropphyzpp": 298409998,
    "dropmaladd": "102 DEPOT ST",
    "dropmalcty": "MOUNT CARMEL",
    "dropmalst": "SC",
    "dropmalzpp": 298409998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8643913176,
    "dropsitcph": 8643913176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24290",
    "droptype": "D",
    "dropname": "MOUNT CROGHAN",
    "dropdeladd": "6 CAMDEN RD",
    "dropdelcty": "MOUNT CROGHAN",
    "dropdelst": "SC",
    "dropdelzpp": 297277697,
    "dropphyadd": "6 CAMDEN RD",
    "dropphycty": "MOUNT CROGHAN",
    "dropphyst": "SC",
    "dropphyzpp": 297277697,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT CROGHAN",
    "dropmalst": "SC",
    "dropmalzpp": 297279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8436346188,
    "dropsitcph": 8436346188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24293",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "1050 JOHNNIE DODDS BLVD",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "SC",
    "dropdelzpp": 294649998,
    "dropphyadd": "1050 JOHNNIE DODDS BLVD",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "SC",
    "dropphyzpp": 294649998,
    "dropmaladd": "1050 JOHNNIE DODDS BLVD",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "SC",
    "dropmalzpp": 294649998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438848221,
    "dropsitcph": 8438848221,
    "dropfax": 8438812256
  },
  {
    "dcode": "D",
    "dropkey": "PX24295",
    "droptype": "D",
    "dropname": "MOUNTAIN REST",
    "dropdeladd": "9601 HIGHLANDS HWY",
    "dropdelcty": "MOUNTAIN REST",
    "dropdelst": "SC",
    "dropdelzpp": 296649998,
    "dropphyadd": "9601 HIGHLANDS HWY",
    "dropphycty": "MOUNTAIN REST",
    "dropphyst": "SC",
    "dropphyzpp": 296649998,
    "dropmaladd": "9601 HIGHLANDS HWY",
    "dropmalcty": "MOUNTAIN REST",
    "dropmalst": "SC",
    "dropmalzpp": 296649998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646382767,
    "dropfax": 8646382767
  },
  {
    "dcode": "D",
    "dropkey": "PX24297",
    "droptype": "D",
    "dropname": "MOUNTVILLE",
    "dropdeladd": "1466 MOUNTVILLE RD",
    "dropdelcty": "MOUNTVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 293709998,
    "dropphyadd": "1466 MOUNTVILLE RD",
    "dropphycty": "MOUNTVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 293709998,
    "dropmaladd": "1466 MOUNTVILLE RD",
    "dropmalcty": "MOUNTVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 293709998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649943986,
    "dropfax": 8649943986
  },
  {
    "dcode": "D",
    "dropkey": "PX24302",
    "droptype": "D",
    "dropname": "MULLINS",
    "dropdeladd": "320 N MAIN ST",
    "dropdelcty": "MULLINS",
    "dropdelst": "SC",
    "dropdelzpp": 295749998,
    "dropphyadd": "320 N MAIN ST",
    "dropphycty": "MULLINS",
    "dropphyst": "SC",
    "dropphyzpp": 295749998,
    "dropmaladd": "320 N MAIN ST",
    "dropmalcty": "MULLINS",
    "dropmalst": "SC",
    "dropmalzpp": 295749998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434649751,
    "dropsitcph": 8434649751,
    "dropfax": 8434644056
  },
  {
    "dcode": "D",
    "dropkey": "PX24304",
    "droptype": "D",
    "dropname": "MURRELLS INLET",
    "dropdeladd": "654 BELLAMY AVE",
    "dropdelcty": "MURRELLS INLET",
    "dropdelst": "SC",
    "dropdelzpp": 295769998,
    "dropphyadd": "654 BELLAMY AVE",
    "dropphycty": "MURRELLS INLET",
    "dropphyst": "SC",
    "dropphyzpp": 295769998,
    "dropmaladd": "654 BELLAMY AVE",
    "dropmalcty": "MURRELLS INLET",
    "dropmalst": "SC",
    "dropmalzpp": 295769998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436512422,
    "dropsitcph": 8436512422,
    "dropfax": 8433579084
  },
  {
    "dcode": "D",
    "dropkey": "PX24309",
    "droptype": "D",
    "dropname": "MYRTLE BEACH",
    "dropdeladd": "505 N KINGS HWY",
    "dropdelcty": "MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295779998,
    "dropphyadd": "505 N KINGS HWY",
    "dropphycty": "MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295779998,
    "dropmaladd": "505 N KINGS HWY",
    "dropmalcty": "MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295779998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436269533,
    "dropsitcph": 8436269533,
    "dropfax": 8434489482
  },
  {
    "dcode": "D",
    "dropkey": "PX24322",
    "droptype": "D",
    "dropname": "NEESES",
    "dropdeladd": "323 RICE ST",
    "dropdelcty": "NEESES",
    "dropdelst": "SC",
    "dropdelzpp": 291079998,
    "dropphyadd": "323 RICE ST",
    "dropphycty": "NEESES",
    "dropphyst": "SC",
    "dropphyzpp": 291079998,
    "dropmaladd": "323 RICE ST",
    "dropmalcty": "NEESES",
    "dropmalst": "SC",
    "dropmalzpp": 291079998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032472164,
    "dropfax": 8032474388
  },
  {
    "dcode": "D",
    "dropkey": "PX24323",
    "droptype": "D",
    "dropname": "NESMITH",
    "dropdeladd": "11 MINGO CHANDLER RD",
    "dropdelcty": "NESMITH",
    "dropdelst": "SC",
    "dropdelzpp": 295809998,
    "dropphyadd": "11 MINGO CHANDLER RD",
    "dropphycty": "NESMITH",
    "dropphyst": "SC",
    "dropphyzpp": 295809998,
    "dropmaladd": "11 MINGO CHANDLER RD",
    "dropmalcty": "NESMITH",
    "dropmalst": "SC",
    "dropmalzpp": 295809998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433823854,
    "dropsitcph": 8433823854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24324",
    "droptype": "D",
    "dropname": "NEW ELLENTON",
    "dropdeladd": "518 MAIN ST N",
    "dropdelcty": "NEW ELLENTON",
    "dropdelst": "SC",
    "dropdelzpp": 298099998,
    "dropphyadd": "518 MAIN ST N",
    "dropphycty": "NEW ELLENTON",
    "dropphyst": "SC",
    "dropphyzpp": 298099998,
    "dropmaladd": "518 MAIN ST N",
    "dropmalcty": "NEW ELLENTON",
    "dropmalst": "SC",
    "dropmalzpp": 298099998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036522444,
    "dropsitcph": 8036522444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24329",
    "droptype": "D",
    "dropname": "NEW ZION",
    "dropdeladd": "6702 SALEM RD",
    "dropdelcty": "NEW ZION",
    "dropdelst": "SC",
    "dropdelzpp": 291119647,
    "dropphyadd": "6702 SALEM RD",
    "dropphycty": "NEW ZION",
    "dropphyst": "SC",
    "dropphyzpp": 291119998,
    "dropmaladd": "6702 SALEM RD",
    "dropmalcty": "NEW ZION",
    "dropmalst": "SC",
    "dropmalzpp": 291119998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8436540522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24330",
    "droptype": "D",
    "dropname": "NEWBERRY",
    "dropdeladd": "1321 COLLEGE ST",
    "dropdelcty": "NEWBERRY",
    "dropdelst": "SC",
    "dropdelzpp": 291082761,
    "dropphyadd": "1321 COLLEGE ST",
    "dropphycty": "NEWBERRY",
    "dropphyst": "SC",
    "dropphyzpp": 291082761,
    "dropmaladd": "1321 COLLEGE ST",
    "dropmalcty": "NEWBERRY",
    "dropmalst": "SC",
    "dropmalzpp": 291082761,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032763521,
    "dropfax": 8032763411
  },
  {
    "dcode": "D",
    "dropkey": "PX24331",
    "droptype": "D",
    "dropname": "NEWRY",
    "dropdeladd": "701A BROADWAY ST",
    "dropdelcty": "NEWRY",
    "dropdelst": "SC",
    "dropdelzpp": 296659800,
    "dropphyadd": "701A BROADWAY ST",
    "dropphycty": "NEWRY",
    "dropphyst": "SC",
    "dropphyzpp": 296659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWRY",
    "dropmalst": "SC",
    "dropmalzpp": 296659998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648827735,
    "dropfax": 8648827735
  },
  {
    "dcode": "D",
    "dropkey": "PX24332",
    "droptype": "D",
    "dropname": "NICHOLS",
    "dropdeladd": "206 S NICHOLS ST",
    "dropdelcty": "NICHOLS",
    "dropdelst": "SC",
    "dropdelzpp": 295819998,
    "dropphyadd": "206 S NICHOLS ST",
    "dropphycty": "NICHOLS",
    "dropphyst": "SC",
    "dropphyzpp": 295819998,
    "dropmaladd": "206 S NICHOLS ST",
    "dropmalcty": "NICHOLS",
    "dropmalst": "SC",
    "dropmalzpp": 295819998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435262331,
    "dropsitcph": 8435262331,
    "dropfax": 8435261676
  },
  {
    "dcode": "D",
    "dropkey": "PX24334",
    "droptype": "D",
    "dropname": "NINETY SIX",
    "dropdeladd": "201 N CAMBRIDGE ST",
    "dropdelcty": "NINETY SIX",
    "dropdelst": "SC",
    "dropdelzpp": 296669998,
    "dropphyadd": "201 N CAMBRIDGE ST",
    "dropphycty": "NINETY SIX",
    "dropphyst": "SC",
    "dropphyzpp": 296669998,
    "dropmaladd": "201 N CAMBRIDGE ST",
    "dropmalcty": "NINETY SIX",
    "dropmalst": "SC",
    "dropmalzpp": 296669998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645432920,
    "dropfax": 8645432615
  },
  {
    "dcode": "D",
    "dropkey": "PX24341",
    "droptype": "D",
    "dropname": "NORRIS",
    "dropdeladd": "201 S NORRIS DR",
    "dropdelcty": "NORRIS",
    "dropdelst": "SC",
    "dropdelzpp": 296679998,
    "dropphyadd": "201 S NORRIS DR",
    "dropphycty": "NORRIS",
    "dropphyst": "SC",
    "dropphyzpp": 296679998,
    "dropmaladd": "201 S NORRIS DR",
    "dropmalcty": "NORRIS",
    "dropmalst": "SC",
    "dropmalzpp": 296679998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646392257,
    "dropfax": 8646396795
  },
  {
    "dcode": "D",
    "dropkey": "PX24342",
    "droptype": "D",
    "dropname": "NORTH",
    "dropdeladd": "7903 SALLEY RD",
    "dropdelcty": "NORTH",
    "dropdelst": "SC",
    "dropdelzpp": 291129998,
    "dropphyadd": "7903 SALLEY RD",
    "dropphycty": "NORTH",
    "dropphyst": "SC",
    "dropphyzpp": 291129998,
    "dropmaladd": "7903 SALLEY RD",
    "dropmalcty": "NORTH",
    "dropmalst": "SC",
    "dropmalzpp": 291129998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032472521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24344",
    "droptype": "D",
    "dropname": "NORTH AUGUSTA",
    "dropdeladd": "1450 GEORGIA AVE",
    "dropdelcty": "NORTH AUGUSTA",
    "dropdelst": "SC",
    "dropdelzpp": 298419998,
    "dropphyadd": "1450 GEORGIA AVE",
    "dropphycty": "NORTH AUGUSTA",
    "dropphyst": "SC",
    "dropphyzpp": 298419998,
    "dropmaladd": "1450 GEORGIA AVE",
    "dropmalcty": "NORTH AUGUSTA",
    "dropmalst": "SC",
    "dropmalzpp": 298419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032790744,
    "dropsitcph": 8032790744,
    "dropfax": 8032790232
  },
  {
    "dcode": "D",
    "dropkey": "PX24353",
    "droptype": "D",
    "dropname": "NORTH MYRTLE BEACH",
    "dropdeladd": "621 6TH AVE S",
    "dropdelcty": "NORTH MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295829998,
    "dropphyadd": "621 6TH AVE S",
    "dropphycty": "NORTH MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295829998,
    "dropmaladd": "621 6TH AVE S",
    "dropmalcty": "NORTH MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295829998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432725864,
    "dropsitcph": 8432725864,
    "dropfax": 8432725954
  },
  {
    "dcode": "D",
    "dropkey": "PX24366",
    "droptype": "D",
    "dropname": "NORWAY",
    "dropdeladd": "8414 SAVANNAH HWY",
    "dropdelcty": "NORWAY",
    "dropdelst": "SC",
    "dropdelzpp": 291139998,
    "dropphyadd": "8414 SAVANNAH HWY",
    "dropphycty": "NORWAY",
    "dropphyst": "SC",
    "dropphyzpp": 291139998,
    "dropmaladd": "8414 SAVANNAH HWY",
    "dropmalcty": "NORWAY",
    "dropmalst": "SC",
    "dropmalzpp": 291139998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032634527,
    "dropfax": 8032634527
  },
  {
    "dcode": "D",
    "dropkey": "PX24381",
    "droptype": "D",
    "dropname": "OLANTA",
    "dropdeladd": "219 N JONES RD",
    "dropdelcty": "OLANTA",
    "dropdelst": "SC",
    "dropdelzpp": 291149998,
    "dropphyadd": "219 N JONES RD",
    "dropphycty": "OLANTA",
    "dropphyst": "SC",
    "dropphyzpp": 291149998,
    "dropmaladd": "219 N JONES RD",
    "dropmalcty": "OLANTA",
    "dropmalst": "SC",
    "dropmalzpp": 291149998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433964222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24382",
    "droptype": "D",
    "dropname": "OLAR",
    "dropdeladd": "15223 CAROLINA HWY",
    "dropdelcty": "OLAR",
    "dropdelst": "SC",
    "dropdelzpp": 298439998,
    "dropphyadd": "15223 CAROLINA HWY",
    "dropphycty": "OLAR",
    "dropphyst": "SC",
    "dropphyzpp": 298439998,
    "dropmaladd": "15223 CAROLINA HWY",
    "dropmalcty": "OLAR",
    "dropmalst": "SC",
    "dropmalzpp": 298439998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8033685020,
    "dropsitcph": 8033685020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24387",
    "droptype": "D",
    "dropname": "ORANGEBURG",
    "dropdeladd": "1550 MIDDLETON ST",
    "dropdelcty": "ORANGEBURG",
    "dropdelst": "SC",
    "dropdelzpp": 291159998,
    "dropphyadd": "1550 MIDDLETON ST",
    "dropphycty": "ORANGEBURG",
    "dropphyst": "SC",
    "dropphyzpp": 291159998,
    "dropmaladd": "1550 MIDDLETON ST",
    "dropmalcty": "ORANGEBURG",
    "dropmalst": "SC",
    "dropmalzpp": 291159998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035361720,
    "dropfax": 8035350738
  },
  {
    "dcode": "D",
    "dropkey": "PX24395",
    "droptype": "D",
    "dropname": "PACOLET",
    "dropdeladd": "250 W MAIN ST",
    "dropdelcty": "PACOLET",
    "dropdelst": "SC",
    "dropdelzpp": 293729998,
    "dropphyadd": "250 W MAIN ST",
    "dropphycty": "PACOLET",
    "dropphyst": "SC",
    "dropphyzpp": 293729998,
    "dropmaladd": "250 W MAIN ST",
    "dropmalcty": "PACOLET",
    "dropmalst": "SC",
    "dropmalzpp": 293729998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644743672,
    "dropfax": 8644743021
  },
  {
    "dcode": "D",
    "dropkey": "PX24396",
    "droptype": "D",
    "dropname": "PACOLET MILLS",
    "dropdeladd": "215 MONTGOMERY AVE",
    "dropdelcty": "PACOLET MILLS",
    "dropdelst": "SC",
    "dropdelzpp": 293739800,
    "dropphyadd": "215 MONTGOMERY AVE",
    "dropphycty": "PACOLET MILLS",
    "dropphyst": "SC",
    "dropphyzpp": 293739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACOLET MILLS",
    "dropmalst": "SC",
    "dropmalzpp": 293739998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644742927,
    "dropfax": 8644749163
  },
  {
    "dcode": "D",
    "dropkey": "PX24398",
    "droptype": "D",
    "dropname": "PAGELAND",
    "dropdeladd": "207 N PEARL ST",
    "dropdelcty": "PAGELAND",
    "dropdelst": "SC",
    "dropdelzpp": 297281942,
    "dropphyadd": "207 N PEARL ST",
    "dropphycty": "PAGELAND",
    "dropphyst": "SC",
    "dropphyzpp": 297281942,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAGELAND",
    "dropmalst": "SC",
    "dropmalzpp": 297289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8436727652,
    "dropsitcph": 8436727652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24403",
    "droptype": "D",
    "dropname": "PAMPLICO",
    "dropdeladd": "132 S TRADE ST",
    "dropdelcty": "PAMPLICO",
    "dropdelst": "SC",
    "dropdelzpp": 295839998,
    "dropphyadd": "132 S TRADE ST",
    "dropphycty": "PAMPLICO",
    "dropphyst": "SC",
    "dropphyzpp": 295839998,
    "dropmaladd": "132 S TRADE ST",
    "dropmalcty": "PAMPLICO",
    "dropmalst": "SC",
    "dropmalzpp": 295839998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434932931,
    "dropsitcph": 8434932931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24411",
    "droptype": "D",
    "dropname": "PARKSVILLE",
    "dropdeladd": "205 RAILROAD AVE",
    "dropdelcty": "PARKSVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 298449900,
    "dropphyadd": "205 RAILROAD AVE",
    "dropphycty": "PARKSVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 298449900,
    "dropmaladd": "205 RAILROAD AVE",
    "dropmalcty": "PARKSVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 298449900,
    "dropsitphn": 4787528466,
    "dropsitlph": 8643335546,
    "dropsitcph": 8643335546,
    "dropfax": 8643335546
  },
  {
    "dcode": "D",
    "dropkey": "PX24415",
    "droptype": "D",
    "dropname": "PATRICK",
    "dropdeladd": "215 S MAIN ST",
    "dropdelcty": "PATRICK",
    "dropdelst": "SC",
    "dropdelzpp": 295849998,
    "dropphyadd": "215 S MAIN ST",
    "dropphycty": "PATRICK",
    "dropphyst": "SC",
    "dropphyzpp": 295849998,
    "dropmaladd": "215 S MAIN ST",
    "dropmalcty": "PATRICK",
    "dropmalst": "SC",
    "dropmalzpp": 295849998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434986455,
    "dropsitcph": 8434986455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24416",
    "droptype": "D",
    "dropname": "PAULINE",
    "dropdeladd": "2990 HIGHWAY 56",
    "dropdelcty": "PAULINE",
    "dropdelst": "SC",
    "dropdelzpp": 293749998,
    "dropphyadd": "2990 HIGHWAY 56",
    "dropphycty": "PAULINE",
    "dropphyst": "SC",
    "dropphyzpp": 293749998,
    "dropmaladd": "2990 HIGHWAY 56",
    "dropmalcty": "PAULINE",
    "dropmalst": "SC",
    "dropmalzpp": 293749998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645838958,
    "dropfax": 8645855829
  },
  {
    "dcode": "D",
    "dropkey": "PX24418",
    "droptype": "D",
    "dropname": "PAWLEYS ISLAND",
    "dropdeladd": "10993 OCEAN HWY",
    "dropdelcty": "PAWLEYS ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 295859998,
    "dropphyadd": "10993 OCEAN HWY",
    "dropphycty": "PAWLEYS ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 295859998,
    "dropmaladd": "10993 OCEAN HWY",
    "dropmalcty": "PAWLEYS ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 295859998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432374232,
    "dropsitcph": 8432374232,
    "dropfax": 8432379694
  },
  {
    "dcode": "D",
    "dropkey": "PX24420",
    "droptype": "D",
    "dropname": "PEAK",
    "dropdeladd": "10 RIVER ST",
    "dropdelcty": "PEAK",
    "dropdelst": "SC",
    "dropdelzpp": 291229800,
    "dropphyadd": "10 RIVER ST",
    "dropphycty": "PEAK",
    "dropphyst": "SC",
    "dropphyzpp": 291229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEAK",
    "dropmalst": "SC",
    "dropmalzpp": 291229998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033457007,
    "dropfax": 8033457007
  },
  {
    "dcode": "D",
    "dropkey": "PX24423",
    "droptype": "D",
    "dropname": "PELION",
    "dropdeladd": "739 PINE ST",
    "dropdelcty": "PELION",
    "dropdelst": "SC",
    "dropdelzpp": 291238992,
    "dropphyadd": "739 PINE ST",
    "dropphycty": "PELION",
    "dropphyst": "SC",
    "dropphyzpp": 291238992,
    "dropmaladd": "739 PINE ST",
    "dropmalcty": "PELION",
    "dropmalst": "SC",
    "dropmalzpp": 291238992,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038943466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24424",
    "droptype": "D",
    "dropname": "PELZER",
    "dropdeladd": "185 LEBBY ST",
    "dropdelcty": "PELZER",
    "dropdelst": "SC",
    "dropdelzpp": 296699998,
    "dropphyadd": "185 LEBBY ST",
    "dropphycty": "PELZER",
    "dropphyst": "SC",
    "dropphyzpp": 296699998,
    "dropmaladd": "185 LEBBY ST",
    "dropmalcty": "PELZER",
    "dropmalst": "SC",
    "dropmalzpp": 296699998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649476347,
    "dropfax": 8649479295
  },
  {
    "dcode": "D",
    "dropkey": "PX24425",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "891 S MECHANIC ST",
    "dropdelcty": "PENDLETON",
    "dropdelst": "SC",
    "dropdelzpp": 296709998,
    "dropphyadd": "891 S MECHANIC ST",
    "dropphycty": "PENDLETON",
    "dropphyst": "SC",
    "dropphyzpp": 296709998,
    "dropmaladd": "891 S MECHANIC ST",
    "dropmalcty": "PENDLETON",
    "dropmalst": "SC",
    "dropmalzpp": 296709998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646463756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24429",
    "droptype": "D",
    "dropname": "PICKENS",
    "dropdeladd": "110 JOHNSON ST",
    "dropdelcty": "PICKENS",
    "dropdelst": "SC",
    "dropdelzpp": 296719998,
    "dropphyadd": "110 JOHNSON ST",
    "dropphycty": "PICKENS",
    "dropphyst": "SC",
    "dropphyzpp": 296719998,
    "dropmaladd": "110 JOHNSON ST",
    "dropmalcty": "PICKENS",
    "dropmalst": "SC",
    "dropmalzpp": 296719998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648789513,
    "dropfax": 8648789149
  },
  {
    "dcode": "D",
    "dropkey": "PX24430",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "912 ANDERSON ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "SC",
    "dropdelzpp": 296739998,
    "dropphyadd": "912 ANDERSON ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "SC",
    "dropphyzpp": 296739998,
    "dropmaladd": "912 ANDERSON ST",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "SC",
    "dropmalzpp": 296739998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648450277,
    "dropfax": 8648455218
  },
  {
    "dcode": "D",
    "dropkey": "PX24439",
    "droptype": "D",
    "dropname": "PINELAND",
    "dropdeladd": "3672 CYPRESS BRANCH RD",
    "dropdelcty": "PINELAND",
    "dropdelst": "SC",
    "dropdelzpp": 299349998,
    "dropphyadd": "3672 CYPRESS BRANCH RD",
    "dropphycty": "PINELAND",
    "dropphyst": "SC",
    "dropphyzpp": 299349998,
    "dropmaladd": "3672 CYPRESS BRANCH RD",
    "dropmalcty": "PINELAND",
    "dropmalst": "SC",
    "dropmalzpp": 299349998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437268297,
    "dropsitcph": 8437268297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24442",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "2080 HIGHWAY 45",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294689998,
    "dropphyadd": "2080 HIGHWAY 45",
    "dropphycty": "PINEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294689998,
    "dropmaladd": "2080 HIGHWAY 45",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294689998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435673719,
    "dropsitcph": 8435673719,
    "dropfax": 8435677497
  },
  {
    "dcode": "D",
    "dropkey": "PX24445",
    "droptype": "D",
    "dropname": "PINEWOOD",
    "dropdeladd": "20 E CLARK ST",
    "dropdelcty": "PINEWOOD",
    "dropdelst": "SC",
    "dropdelzpp": 291259998,
    "dropphyadd": "20 E CLARK ST",
    "dropphycty": "PINEWOOD",
    "dropphyst": "SC",
    "dropphyzpp": 291259998,
    "dropmaladd": "20 E CLARK ST",
    "dropmalcty": "PINEWOOD",
    "dropmalst": "SC",
    "dropmalzpp": 291259998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034525747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24447",
    "droptype": "D",
    "dropname": "PINOPOLIS",
    "dropdeladd": "1940 PINOPOLIS RD",
    "dropdelcty": "PINOPOLIS",
    "dropdelst": "SC",
    "dropdelzpp": 294699998,
    "dropphyadd": "1940 PINOPOLIS RD",
    "dropphycty": "PINOPOLIS",
    "dropphyst": "SC",
    "dropphyzpp": 294699998,
    "dropmaladd": "1940 PINOPOLIS RD",
    "dropmalcty": "PINOPOLIS",
    "dropmalst": "SC",
    "dropmalzpp": 294699998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438992975,
    "dropsitcph": 8438992975,
    "dropfax": 8438991438
  },
  {
    "dcode": "D",
    "dropkey": "PX24455",
    "droptype": "D",
    "dropname": "PLUM BRANCH",
    "dropdeladd": "102 DEPOT ST N",
    "dropdelcty": "PLUM BRANCH",
    "dropdelst": "SC",
    "dropdelzpp": 298459998,
    "dropphyadd": "102 DEPOT ST N",
    "dropphycty": "PLUM BRANCH",
    "dropphyst": "SC",
    "dropphyzpp": 298459998,
    "dropmaladd": "102 DEPOT ST N",
    "dropmalcty": "PLUM BRANCH",
    "dropmalst": "SC",
    "dropmalzpp": 298459998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8644432195,
    "dropsitcph": 8644432195,
    "dropfax": 8644432195
  },
  {
    "dcode": "D",
    "dropkey": "PX24457",
    "droptype": "D",
    "dropname": "POMARIA",
    "dropdeladd": "5375 US HIGHWAY 176",
    "dropdelcty": "POMARIA",
    "dropdelst": "SC",
    "dropdelzpp": 291269998,
    "dropphyadd": "5375 US HIGHWAY 176",
    "dropphycty": "POMARIA",
    "dropphyst": "SC",
    "dropphyzpp": 291269998,
    "dropmaladd": "5375 US HIGHWAY 176",
    "dropmalcty": "POMARIA",
    "dropmalst": "SC",
    "dropmalzpp": 291269998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032762841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24460",
    "droptype": "D",
    "dropname": "PORT ROYAL",
    "dropdeladd": "1625 PARIS AVE",
    "dropdelcty": "PORT ROYAL",
    "dropdelst": "SC",
    "dropdelzpp": 299359998,
    "dropphyadd": "1625 PARIS AVE",
    "dropphycty": "PORT ROYAL",
    "dropphyst": "SC",
    "dropphyzpp": 299359998,
    "dropmaladd": "1625 PARIS AVE",
    "dropmalcty": "PORT ROYAL",
    "dropmalst": "SC",
    "dropmalzpp": 299359998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8435247457,
    "dropsitcph": 8435247457,
    "dropfax": 8435245231
  },
  {
    "dcode": "D",
    "dropkey": "PX24467",
    "droptype": "D",
    "dropname": "PROSPERITY",
    "dropdeladd": "155 N MAIN ST",
    "dropdelcty": "PROSPERITY",
    "dropdelst": "SC",
    "dropdelzpp": 291279998,
    "dropphyadd": "155 N MAIN ST",
    "dropphycty": "PROSPERITY",
    "dropphyst": "SC",
    "dropphyzpp": 291279998,
    "dropmaladd": "155 N MAIN ST",
    "dropmalcty": "PROSPERITY",
    "dropmalst": "SC",
    "dropmalzpp": 291279998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033642325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24473",
    "droptype": "D",
    "dropname": "RAINS",
    "dropdeladd": "2677 TROY ATKINSON RD",
    "dropdelcty": "RAINS",
    "dropdelst": "SC",
    "dropdelzpp": 295899998,
    "dropphyadd": "2677 TROY ATKINSON RD",
    "dropphycty": "RAINS",
    "dropphyst": "SC",
    "dropphyzpp": 295899998,
    "dropmaladd": "2677 TROY ATKINSON RD",
    "dropmalcty": "RAINS",
    "dropmalst": "SC",
    "dropmalzpp": 295899998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8434234403,
    "dropsitcph": 8434234403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24476",
    "droptype": "D",
    "dropname": "RAVENEL",
    "dropdeladd": "6239 SAVANNAH HWY",
    "dropdelcty": "RAVENEL",
    "dropdelst": "SC",
    "dropdelzpp": 294709998,
    "dropphyadd": "6239 SAVANNAH HWY",
    "dropphycty": "RAVENEL",
    "dropphyst": "SC",
    "dropphyzpp": 294709998,
    "dropmaladd": "6239 SAVANNAH HWY",
    "dropmalcty": "RAVENEL",
    "dropmalst": "SC",
    "dropmalzpp": 294709998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438898990,
    "dropsitcph": 8438898990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24484",
    "droptype": "D",
    "dropname": "REEVESVILLE",
    "dropdeladd": "108 RIGBY ST",
    "dropdelcty": "REEVESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294719998,
    "dropphyadd": "108 RIGBY ST",
    "dropphycty": "REEVESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294719998,
    "dropmaladd": "108 RIGBY ST",
    "dropmalcty": "REEVESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294719998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435632111,
    "dropsitcph": 8435632111,
    "dropfax": 8435638411
  },
  {
    "dcode": "D",
    "dropkey": "PX24487",
    "droptype": "D",
    "dropname": "REIDVILLE",
    "dropdeladd": "7460 REIDVILLE RD",
    "dropdelcty": "REIDVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 293759800,
    "dropphyadd": "7460 REIDVILLE RD",
    "dropphycty": "REIDVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 293759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REIDVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 293759998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644330483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24488",
    "droptype": "D",
    "dropname": "REMBERT",
    "dropdeladd": "8335 CAMDEN HWY",
    "dropdelcty": "REMBERT",
    "dropdelst": "SC",
    "dropdelzpp": 291288202,
    "dropphyadd": "8335 CAMDEN HWY",
    "dropphycty": "REMBERT",
    "dropphyst": "SC",
    "dropphyzpp": 291288202,
    "dropmaladd": "8335 CAMDEN HWY",
    "dropmalcty": "REMBERT",
    "dropmalst": "SC",
    "dropmalzpp": 291288202,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034325350,
    "dropfax": 8037139888
  },
  {
    "dcode": "D",
    "dropkey": "PX24492",
    "droptype": "D",
    "dropname": "RICHBURG",
    "dropdeladd": "109 BROAD ST",
    "dropdelcty": "RICHBURG",
    "dropdelst": "SC",
    "dropdelzpp": 297299236,
    "dropphyadd": "109 BROAD ST",
    "dropphycty": "RICHBURG",
    "dropphyst": "SC",
    "dropphyzpp": 297299236,
    "dropmaladd": "109 BROAD ST",
    "dropmalcty": "RICHBURG",
    "dropmalst": "SC",
    "dropmalzpp": 297299236,
    "dropsitphn": 7043934581,
    "dropsitlph": 8037895102,
    "dropsitcph": 8037895102,
    "dropfax": 8037895102
  },
  {
    "dcode": "D",
    "dropkey": "PX24493",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "304 RICHLAND RD",
    "dropdelcty": "RICHLAND",
    "dropdelst": "SC",
    "dropdelzpp": 296759800,
    "dropphyadd": "304 RICHLAND RD",
    "dropphycty": "RICHLAND",
    "dropphyst": "SC",
    "dropphyzpp": 296759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHLAND",
    "dropmalst": "SC",
    "dropmalzpp": 296759998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648823999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24497",
    "droptype": "D",
    "dropname": "RIDGE SPRING",
    "dropdeladd": "610 E MAIN ST",
    "dropdelcty": "RIDGE SPRING",
    "dropdelst": "SC",
    "dropdelzpp": 291299998,
    "dropphyadd": "610 E MAIN ST",
    "dropphycty": "RIDGE SPRING",
    "dropphyst": "SC",
    "dropphyzpp": 291299998,
    "dropmaladd": "610 E MAIN ST",
    "dropmalcty": "RIDGE SPRING",
    "dropmalst": "SC",
    "dropmalzpp": 291299998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036857431,
    "dropfax": 8036857431
  },
  {
    "dcode": "D",
    "dropkey": "PX24498",
    "droptype": "D",
    "dropname": "RIDGELAND",
    "dropdeladd": "7554 W MAIN ST",
    "dropdelcty": "RIDGELAND",
    "dropdelst": "SC",
    "dropdelzpp": 299369998,
    "dropphyadd": "7554 W MAIN ST",
    "dropphycty": "RIDGELAND",
    "dropphyst": "SC",
    "dropphyzpp": 299369998,
    "dropmaladd": "7554 W MAIN ST",
    "dropmalcty": "RIDGELAND",
    "dropmalst": "SC",
    "dropmalzpp": 299369998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437266646,
    "dropsitcph": 8437266646,
    "dropfax": 8437265528
  },
  {
    "dcode": "D",
    "dropkey": "PX24499",
    "droptype": "D",
    "dropname": "RIDGEVILLE",
    "dropdeladd": "185 CHURCH ST",
    "dropdelcty": "RIDGEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294729998,
    "dropphyadd": "185 CHURCH ST",
    "dropphycty": "RIDGEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294729998,
    "dropmaladd": "185 CHURCH ST",
    "dropmalcty": "RIDGEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294729998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438733512,
    "dropsitcph": 8438733512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24502",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "290 S PALMER ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "SC",
    "dropdelzpp": 291309998,
    "dropphyadd": "290 S PALMER ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "SC",
    "dropphyzpp": 291309998,
    "dropmaladd": "290 S PALMER ST",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "SC",
    "dropmalzpp": 291309998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033372914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24517",
    "droptype": "D",
    "dropname": "ROCK HILL",
    "dropdeladd": "206 WILSON ST S",
    "dropdelcty": "ROCK HILL",
    "dropdelst": "SC",
    "dropdelzpp": 297304441,
    "dropphyadd": "206 WILSON ST S",
    "dropphycty": "ROCK HILL",
    "dropphyst": "SC",
    "dropphyzpp": 297304441,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK HILL",
    "dropmalst": "SC",
    "dropmalzpp": 297309998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8033271054,
    "dropsitcph": 8033271054,
    "dropfax": 8033285174
  },
  {
    "dcode": "D",
    "dropkey": "PX24523",
    "droptype": "D",
    "dropname": "ROEBUCK",
    "dropdeladd": "4301 S CHURCH STREET EXT",
    "dropdelcty": "ROEBUCK",
    "dropdelst": "SC",
    "dropdelzpp": 293769998,
    "dropphyadd": "4301 S CHURCH STREET EXT",
    "dropphycty": "ROEBUCK",
    "dropphyst": "SC",
    "dropphyzpp": 293769998,
    "dropmaladd": "4301 S CHURCH STREET EXT",
    "dropmalcty": "ROEBUCK",
    "dropmalst": "SC",
    "dropmalzpp": 293769998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645768299,
    "dropfax": 8645871043
  },
  {
    "dcode": "D",
    "dropkey": "PX24526",
    "droptype": "D",
    "dropname": "ROUND O",
    "dropdeladd": "11110 ROUND O RD",
    "dropdelcty": "ROUND O",
    "dropdelst": "SC",
    "dropdelzpp": 294749998,
    "dropphyadd": "11110 ROUND O RD",
    "dropphycty": "ROUND O",
    "dropphyst": "SC",
    "dropphyzpp": 294749998,
    "dropmaladd": "11110 ROUND O RD",
    "dropmalcty": "ROUND O",
    "dropmalst": "SC",
    "dropmalzpp": 294749998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438358526,
    "dropsitcph": 8438358526,
    "dropfax": 8438355712
  },
  {
    "dcode": "D",
    "dropkey": "PX24527",
    "droptype": "D",
    "dropname": "ROWESVILLE",
    "dropdeladd": "219 ROWES PUMP DR",
    "dropdelcty": "ROWESVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 291339998,
    "dropphyadd": "219 ROWES PUMP DR",
    "dropphycty": "ROWESVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 291339998,
    "dropmaladd": "219 ROWES PUMP DR",
    "dropmalcty": "ROWESVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 291339998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035363566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24530",
    "droptype": "D",
    "dropname": "RUBY",
    "dropdeladd": "367 MARKET ST",
    "dropdelcty": "RUBY",
    "dropdelst": "SC",
    "dropdelzpp": 297412901,
    "dropphyadd": "367 MARKET ST",
    "dropphycty": "RUBY",
    "dropphyst": "SC",
    "dropphyzpp": 297412901,
    "dropmaladd": "367 MARKET ST",
    "dropmalcty": "RUBY",
    "dropmalst": "SC",
    "dropmalzpp": 297412901,
    "dropsitphn": 7043934581,
    "dropsitlph": 8436346357,
    "dropsitcph": 8436346357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24531",
    "droptype": "D",
    "dropname": "RUFFIN",
    "dropdeladd": "21972 LOWCOUNTRY HWY",
    "dropdelcty": "RUFFIN",
    "dropdelst": "SC",
    "dropdelzpp": 294759998,
    "dropphyadd": "21972 LOWCOUNTRY HWY",
    "dropphycty": "RUFFIN",
    "dropphyst": "SC",
    "dropphyzpp": 294759998,
    "dropmaladd": "21972 LOWCOUNTRY HWY",
    "dropmalcty": "RUFFIN",
    "dropmalst": "SC",
    "dropmalzpp": 294759998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435622360,
    "dropsitcph": 8435622360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24532",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "1737 HIGHWAY 35",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294769800,
    "dropphyadd": "1737 HIGHWAY 35",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294769998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435672248,
    "dropsitcph": 8435672248,
    "dropfax": 8435672516
  },
  {
    "dcode": "D",
    "dropkey": "PX24544",
    "droptype": "D",
    "dropname": "SAINT GEORGE",
    "dropdeladd": "5988 W JIM BILTON BLVD",
    "dropdelcty": "SAINT GEORGE",
    "dropdelst": "SC",
    "dropdelzpp": 294779998,
    "dropphyadd": "5988 W JIM BILTON BLVD",
    "dropphycty": "SAINT GEORGE",
    "dropphyst": "SC",
    "dropphyzpp": 294779998,
    "dropmaladd": "5988 W JIM BILTON BLVD",
    "dropmalcty": "SAINT GEORGE",
    "dropmalst": "SC",
    "dropmalzpp": 294779998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435633551,
    "dropsitcph": 8435633551,
    "dropfax": 8435635545
  },
  {
    "dcode": "D",
    "dropkey": "PX24545",
    "droptype": "D",
    "dropname": "SAINT MATTHEWS",
    "dropdeladd": "616 F R HUFF DR",
    "dropdelcty": "SAINT MATTHEWS",
    "dropdelst": "SC",
    "dropdelzpp": 291351282,
    "dropphyadd": "616 F R HUFF DR",
    "dropphycty": "SAINT MATTHEWS",
    "dropphyst": "SC",
    "dropphyzpp": 291351282,
    "dropmaladd": "616 F R HUFF DR",
    "dropmalcty": "SAINT MATTHEWS",
    "dropmalst": "SC",
    "dropmalzpp": 291351282,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038743846,
    "dropfax": 8038741128
  },
  {
    "dcode": "D",
    "dropkey": "PX24546",
    "droptype": "D",
    "dropname": "SAINT STEPHEN",
    "dropdeladd": "3981 BYRNES DR",
    "dropdelcty": "SAINT STEPHEN",
    "dropdelst": "SC",
    "dropdelzpp": 294799998,
    "dropphyadd": "3981 BYRNES DR",
    "dropphycty": "SAINT STEPHEN",
    "dropphyst": "SC",
    "dropphyzpp": 294799998,
    "dropmaladd": "3981 BYRNES DR",
    "dropmalcty": "SAINT STEPHEN",
    "dropmalst": "SC",
    "dropmalzpp": 294799998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435672247,
    "dropsitcph": 8435672247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24547",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "467 E MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "SC",
    "dropdelzpp": 296769998,
    "dropphyadd": "467 E MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "SC",
    "dropphyzpp": 296769998,
    "dropmaladd": "467 E MAIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "SC",
    "dropmalzpp": 296769998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649440351,
    "dropfax": 8649446205
  },
  {
    "dcode": "D",
    "dropkey": "PX24549",
    "droptype": "D",
    "dropname": "SALLEY",
    "dropdeladd": "115 RAILROAD AVE N",
    "dropdelcty": "SALLEY",
    "dropdelst": "SC",
    "dropdelzpp": 291379476,
    "dropphyadd": "115 RAILROAD AVE N",
    "dropphycty": "SALLEY",
    "dropphyst": "SC",
    "dropphyzpp": 291379476,
    "dropmaladd": "115 RAILROAD AVE N",
    "dropmalcty": "SALLEY",
    "dropmalst": "SC",
    "dropmalzpp": 291379476,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032583680,
    "dropfax": 8032581880
  },
  {
    "dcode": "D",
    "dropkey": "PX24550",
    "droptype": "D",
    "dropname": "SALTERS",
    "dropdeladd": "33 DEPOT ST",
    "dropdelcty": "SALTERS",
    "dropdelst": "SC",
    "dropdelzpp": 295909998,
    "dropphyadd": "33 DEPOT ST",
    "dropphycty": "SALTERS",
    "dropphyst": "SC",
    "dropphyzpp": 295909998,
    "dropmaladd": "33 DEPOT ST",
    "dropmalcty": "SALTERS",
    "dropmalst": "SC",
    "dropmalzpp": 295909998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433875546,
    "dropsitcph": 8433875546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24551",
    "droptype": "D",
    "dropname": "SALUDA",
    "dropdeladd": "424 TRAVIS AVE",
    "dropdelcty": "SALUDA",
    "dropdelst": "SC",
    "dropdelzpp": 291389998,
    "dropphyadd": "424 TRAVIS AVE",
    "dropphycty": "SALUDA",
    "dropphyst": "SC",
    "dropphyzpp": 291389998,
    "dropmaladd": "424 TRAVIS AVE",
    "dropmalcty": "SALUDA",
    "dropmalst": "SC",
    "dropmalzpp": 291389998,
    "dropsitphn": 8649266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8644457411,
    "dropfax": 8644457432
  },
  {
    "dcode": "D",
    "dropkey": "PX24558",
    "droptype": "D",
    "dropname": "SANDY SPRINGS",
    "dropdeladd": "5410 HIGHWAY 76",
    "dropdelcty": "SANDY SPRINGS",
    "dropdelst": "SC",
    "dropdelzpp": 296779800,
    "dropphyadd": "5410 HIGHWAY 76",
    "dropphycty": "SANDY SPRINGS",
    "dropphyst": "SC",
    "dropphyzpp": 296779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANDY SPRINGS",
    "dropmalst": "SC",
    "dropmalzpp": 296779998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642618585,
    "dropfax": 8642618072
  },
  {
    "dcode": "D",
    "dropkey": "PX24561",
    "droptype": "D",
    "dropname": "SANTEE",
    "dropdeladd": "689 BASS DR",
    "dropdelcty": "SANTEE",
    "dropdelst": "SC",
    "dropdelzpp": 291429998,
    "dropphyadd": "689 BASS DR",
    "dropphycty": "SANTEE",
    "dropphyst": "SC",
    "dropphyzpp": 291429998,
    "dropmaladd": "689 BASS DR",
    "dropmalcty": "SANTEE",
    "dropmalst": "SC",
    "dropmalzpp": 291429998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8038542154,
    "dropfax": 8038542619
  },
  {
    "dcode": "D",
    "dropkey": "PX24573",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "1810 US 52 HWY",
    "dropdelcty": "SCRANTON",
    "dropdelst": "SC",
    "dropdelzpp": 295919998,
    "dropphyadd": "1810 US 52 HWY",
    "dropphycty": "SCRANTON",
    "dropphyst": "SC",
    "dropphyzpp": 295919998,
    "dropmaladd": "1810 US 52 HWY",
    "dropmalcty": "SCRANTON",
    "dropmalst": "SC",
    "dropmalzpp": 295919998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433894500,
    "dropsitcph": 8433894500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24576",
    "droptype": "D",
    "dropname": "SEABROOK",
    "dropdeladd": "219 SEABROOK RD",
    "dropdelcty": "SEABROOK",
    "dropdelst": "SC",
    "dropdelzpp": 299409998,
    "dropphyadd": "219 SEABROOK RD",
    "dropphycty": "SEABROOK",
    "dropphyst": "SC",
    "dropphyzpp": 299409998,
    "dropmaladd": "219 SEABROOK RD",
    "dropmalcty": "SEABROOK",
    "dropmalst": "SC",
    "dropmalzpp": 299409998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8438462775,
    "dropsitcph": 8438462775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24581",
    "droptype": "D",
    "dropname": "SELLERS",
    "dropdeladd": "2806 HIGHWAY 301",
    "dropdelcty": "SELLERS",
    "dropdelst": "SC",
    "dropdelzpp": 295929998,
    "dropphyadd": "2806 HIGHWAY 301",
    "dropphycty": "SELLERS",
    "dropphyst": "SC",
    "dropphyzpp": 295929998,
    "dropmaladd": "2806 HIGHWAY 301",
    "dropmalcty": "SELLERS",
    "dropmalst": "SC",
    "dropmalzpp": 295929998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437525583,
    "dropsitcph": 8437525583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24583",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "508 E MAIN ST",
    "dropdelcty": "SENECA",
    "dropdelst": "SC",
    "dropdelzpp": 296789998,
    "dropphyadd": "508 E MAIN ST",
    "dropphycty": "SENECA",
    "dropphyst": "SC",
    "dropphyzpp": 296789998,
    "dropmaladd": "508 E MAIN ST",
    "dropmalcty": "SENECA",
    "dropmalst": "SC",
    "dropmalzpp": 296789998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648828422,
    "dropfax": 8648850443
  },
  {
    "dcode": "D",
    "dropkey": "PX24587",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "3311 N YORK ST",
    "dropdelcty": "SHARON",
    "dropdelst": "SC",
    "dropdelzpp": 297428800,
    "dropphyadd": "3311 N YORK ST",
    "dropphycty": "SHARON",
    "dropphyst": "SC",
    "dropphyzpp": 297428800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARON",
    "dropmalst": "SC",
    "dropmalzpp": 297429998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8039277424,
    "dropsitcph": 8039277424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24591",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "21 PAIGE POINT BLF",
    "dropdelcty": "SHELDON",
    "dropdelst": "SC",
    "dropdelzpp": 299419998,
    "dropphyadd": "21 PAIGE POINT BLF",
    "dropphycty": "SHELDON",
    "dropphyst": "SC",
    "dropphyzpp": 299419998,
    "dropmaladd": "21 PAIGE POINT BLF",
    "dropmalcty": "SHELDON",
    "dropmalst": "SC",
    "dropmalzpp": 299419998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8438464778,
    "dropsitcph": 8438464778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24601",
    "droptype": "D",
    "dropname": "SILVERSTREET",
    "dropdeladd": "1195 MAIN ST",
    "dropdelcty": "SILVERSTREET",
    "dropdelst": "SC",
    "dropdelzpp": 291459998,
    "dropphyadd": "1195 MAIN ST",
    "dropphycty": "SILVERSTREET",
    "dropphyst": "SC",
    "dropphyzpp": 291459998,
    "dropmaladd": "1195 MAIN ST",
    "dropmalcty": "SILVERSTREET",
    "dropmalst": "SC",
    "dropmalzpp": 291459998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032767132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24603",
    "droptype": "D",
    "dropname": "SIMPSONVILLE",
    "dropdeladd": "634 NE MAIN ST",
    "dropdelcty": "SIMPSONVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296819998,
    "dropphyadd": "634 NE MAIN ST",
    "dropphycty": "SIMPSONVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296819998,
    "dropmaladd": "634 NE MAIN ST",
    "dropmalcty": "SIMPSONVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296819998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649635909,
    "dropfax": 8649637033
  },
  {
    "dcode": "D",
    "dropkey": "PX24605",
    "droptype": "D",
    "dropname": "SIX MILE",
    "dropdeladd": "515 N MAIN ST",
    "dropdelcty": "SIX MILE",
    "dropdelst": "SC",
    "dropdelzpp": 296829998,
    "dropphyadd": "515 N MAIN ST",
    "dropphycty": "SIX MILE",
    "dropphyst": "SC",
    "dropphyzpp": 296829998,
    "dropmaladd": "515 N MAIN ST",
    "dropmalcty": "SIX MILE",
    "dropmalst": "SC",
    "dropmalzpp": 296829998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648680312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24608",
    "droptype": "D",
    "dropname": "SLATER",
    "dropdeladd": "7 MAIN ST",
    "dropdelcty": "SLATER",
    "dropdelst": "SC",
    "dropdelzpp": 296839800,
    "dropphyadd": "7 MAIN ST",
    "dropphycty": "SLATER",
    "dropphyst": "SC",
    "dropphyzpp": 296839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLATER",
    "dropmalst": "SC",
    "dropmalzpp": 296839998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648363691,
    "dropfax": 8648363691
  },
  {
    "dcode": "D",
    "dropkey": "PX24613",
    "droptype": "D",
    "dropname": "SMOAKS",
    "dropdeladd": "27639 LOWCOUNTRY HWY",
    "dropdelcty": "SMOAKS",
    "dropdelst": "SC",
    "dropdelzpp": 294819998,
    "dropphyadd": "27639 LOWCOUNTRY HWY",
    "dropphycty": "SMOAKS",
    "dropphyst": "SC",
    "dropphyzpp": 294819998,
    "dropmaladd": "27639 LOWCOUNTRY HWY",
    "dropmalcty": "SMOAKS",
    "dropmalst": "SC",
    "dropmalzpp": 294819998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435622091,
    "dropsitcph": 8435622091,
    "dropfax": 8435622429
  },
  {
    "dcode": "D",
    "dropkey": "PX24614",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "1021 MAIN ST",
    "dropdelcty": "SMYRNA",
    "dropdelst": "SC",
    "dropdelzpp": 297439717,
    "dropphyadd": "1021 MAIN ST",
    "dropphycty": "SMYRNA",
    "dropphyst": "SC",
    "dropphyzpp": 297439717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SMYRNA",
    "dropmalst": "SC",
    "dropmalzpp": 297439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8039252173,
    "dropsitcph": 8039252173,
    "dropfax": 8039252173
  },
  {
    "dcode": "D",
    "dropkey": "PX24622",
    "droptype": "D",
    "dropname": "SOCIETY HILL",
    "dropdeladd": "269 S MAIN ST",
    "dropdelcty": "SOCIETY HILL",
    "dropdelst": "SC",
    "dropdelzpp": 295939998,
    "dropphyadd": "269 S MAIN ST",
    "dropphycty": "SOCIETY HILL",
    "dropphyst": "SC",
    "dropphyzpp": 295939998,
    "dropmaladd": "269 S MAIN ST",
    "dropmalcty": "SOCIETY HILL",
    "dropmalst": "SC",
    "dropmalzpp": 295939998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8433784731,
    "dropsitcph": 8433784731,
    "dropfax": 8433784731
  },
  {
    "dcode": "D",
    "dropkey": "PX24641",
    "droptype": "D",
    "dropname": "SPARTANBURG",
    "dropdeladd": "250 S CHURCH ST",
    "dropdelcty": "SPARTANBURG",
    "dropdelst": "SC",
    "dropdelzpp": 293069998,
    "dropphyadd": "250 S CHURCH ST",
    "dropphycty": "SPARTANBURG",
    "dropphyst": "SC",
    "dropphyzpp": 293069998,
    "dropmaladd": "250 S CHURCH ST",
    "dropmalcty": "SPARTANBURG",
    "dropmalst": "SC",
    "dropmalzpp": 293069998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645850301,
    "dropfax": 8645857719
  },
  {
    "dcode": "D",
    "dropkey": "PX24646",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "7220 FESTIVAL TRAIL RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "SC",
    "dropdelzpp": 291469998,
    "dropphyadd": "7220 FESTIVAL TRAIL RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "SC",
    "dropphyzpp": 291469998,
    "dropmaladd": "7220 FESTIVAL TRAIL RD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "SC",
    "dropmalzpp": 291469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8032583659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24653",
    "droptype": "D",
    "dropname": "SAINT HELENA ISLAND",
    "dropdeladd": "774 SEA ISLAND PKWY",
    "dropdelcty": "SAINT HELENA ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 299209998,
    "dropphyadd": "774 SEA ISLAND PKWY",
    "dropphycty": "SAINT HELENA ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 299209998,
    "dropmaladd": "774 SEA ISLAND PKWY",
    "dropmalcty": "SAINT HELENA ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 299209998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8438384426,
    "dropsitcph": 8438384426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24663",
    "droptype": "D",
    "dropname": "STARR",
    "dropdeladd": "7842 HIGHWAY 81 S",
    "dropdelcty": "STARR",
    "dropdelst": "SC",
    "dropdelzpp": 296849998,
    "dropphyadd": "7842 HIGHWAY 81 S",
    "dropphycty": "STARR",
    "dropphyst": "SC",
    "dropphyzpp": 296849998,
    "dropmaladd": "7842 HIGHWAY 81 S",
    "dropmalcty": "STARR",
    "dropmalst": "SC",
    "dropmalzpp": 296849998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8643526190,
    "dropfax": 8643526192
  },
  {
    "dcode": "D",
    "dropkey": "PX24664",
    "droptype": "D",
    "dropname": "STARTEX",
    "dropdeladd": "21 N MAIN ST",
    "dropdelcty": "STARTEX",
    "dropdelst": "SC",
    "dropdelzpp": 293779800,
    "dropphyadd": "21 N MAIN ST",
    "dropphycty": "STARTEX",
    "dropphyst": "SC",
    "dropphyzpp": 293779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STARTEX",
    "dropmalst": "SC",
    "dropmalzpp": 293779998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644397825,
    "dropfax": 8644397825
  },
  {
    "dcode": "D",
    "dropkey": "PX24667",
    "droptype": "D",
    "dropname": "STATE PARK",
    "dropdeladd": "20 HINTON ST",
    "dropdelcty": "STATE PARK",
    "dropdelst": "SC",
    "dropdelzpp": 291479800,
    "dropphyadd": "20 HINTON ST",
    "dropphycty": "STATE PARK",
    "dropphyst": "SC",
    "dropphyzpp": 291479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STATE PARK",
    "dropmalst": "SC",
    "dropmalzpp": 291479998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8039350209,
    "dropfax": 8039351030
  },
  {
    "dcode": "D",
    "dropkey": "PX24681",
    "droptype": "D",
    "dropname": "SULLIVANS ISLAND",
    "dropdeladd": "2061 MIDDLE ST",
    "dropdelcty": "SULLIVANS ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 294828802,
    "dropphyadd": "2061 MIDDLE ST",
    "dropphycty": "SULLIVANS ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 294828802,
    "dropmaladd": "2061 MIDDLE ST",
    "dropmalcty": "SULLIVANS ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 294828802,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438833461,
    "dropsitcph": 8438833461,
    "dropfax": 8438833978
  },
  {
    "dcode": "D",
    "dropkey": "PX24684",
    "droptype": "D",
    "dropname": "SUMMERTON",
    "dropdeladd": "4 LARRY KING HWY",
    "dropdelcty": "SUMMERTON",
    "dropdelst": "SC",
    "dropdelzpp": 291489998,
    "dropphyadd": "4 LARRY KING HWY",
    "dropphycty": "SUMMERTON",
    "dropphyst": "SC",
    "dropphyzpp": 291489998,
    "dropmaladd": "4 LARRY KING HWY",
    "dropmalcty": "SUMMERTON",
    "dropmalst": "SC",
    "dropmalzpp": 291489998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034854533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24686",
    "droptype": "D",
    "dropname": "SUMMERVILLE",
    "dropdeladd": "301 N GUM ST",
    "dropdelcty": "SUMMERVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294839998,
    "dropphyadd": "301 N GUM ST",
    "dropphycty": "SUMMERVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294839998,
    "dropmaladd": "301 N GUM ST",
    "dropmalcty": "SUMMERVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294839998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438733571,
    "dropsitcph": 8438733571,
    "dropfax": 8438210911
  },
  {
    "dcode": "D",
    "dropkey": "PX24690",
    "droptype": "D",
    "dropname": "SUMTER",
    "dropdeladd": "311 N MAIN ST",
    "dropdelcty": "SUMTER",
    "dropdelst": "SC",
    "dropdelzpp": 291509998,
    "dropphyadd": "311 N MAIN ST",
    "dropphycty": "SUMTER",
    "dropphyst": "SC",
    "dropphyzpp": 291509998,
    "dropmaladd": "311 N MAIN ST",
    "dropmalcty": "SUMTER",
    "dropmalst": "SC",
    "dropmalzpp": 291509998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037739311,
    "dropfax": 8037737132
  },
  {
    "dcode": "D",
    "dropkey": "PX24693",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "7149 HIGHWAY 11",
    "dropdelcty": "SUNSET",
    "dropdelst": "SC",
    "dropdelzpp": 296859998,
    "dropphyadd": "7149 HIGHWAY 11",
    "dropphycty": "SUNSET",
    "dropphyst": "SC",
    "dropphyzpp": 296859998,
    "dropmaladd": "7149 HIGHWAY 11",
    "dropmalcty": "SUNSET",
    "dropmalst": "SC",
    "dropmalzpp": 296859998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648784016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24700",
    "droptype": "D",
    "dropname": "SWANSEA",
    "dropdeladd": "295 S CHURCH ST",
    "dropdelcty": "SWANSEA",
    "dropdelst": "SC",
    "dropdelzpp": 291608511,
    "dropphyadd": "295 S CHURCH ST",
    "dropphycty": "SWANSEA",
    "dropphyst": "SC",
    "dropphyzpp": 291608511,
    "dropmaladd": "295 S CHURCH ST",
    "dropmalcty": "SWANSEA",
    "dropmalst": "SC",
    "dropmalzpp": 291608511,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8397465513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24703",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "345 MAIN ST W",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "SC",
    "dropdelzpp": 298469998,
    "dropphyadd": "345 MAIN ST W",
    "dropphycty": "SYCAMORE",
    "dropphyst": "SC",
    "dropphyzpp": 298469998,
    "dropmaladd": "345 MAIN ST W",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "SC",
    "dropmalzpp": 298469998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036322369,
    "dropsitcph": 8036322369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24706",
    "droptype": "D",
    "dropname": "TAMASSEE",
    "dropdeladd": "2655B CAIN DR",
    "dropdelcty": "TAMASSEE",
    "dropdelst": "SC",
    "dropdelzpp": 296869998,
    "dropphyadd": "2655B CAIN DR",
    "dropphycty": "TAMASSEE",
    "dropphyst": "SC",
    "dropphyzpp": 296869998,
    "dropmaladd": "2655B CAIN DR",
    "dropmalcty": "TAMASSEE",
    "dropmalst": "SC",
    "dropmalzpp": 296869998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649441804,
    "dropfax": 8649441804
  },
  {
    "dcode": "D",
    "dropkey": "PX24708",
    "droptype": "D",
    "dropname": "TATUM",
    "dropdeladd": "104 N STANTON ST",
    "dropdelcty": "TATUM",
    "dropdelst": "SC",
    "dropdelzpp": 295949800,
    "dropphyadd": "104 N STANTON ST",
    "dropphycty": "TATUM",
    "dropphyst": "SC",
    "dropphyzpp": 295949800,
    "dropmaladd": "104 N STANTON ST",
    "dropmalcty": "TATUM",
    "dropmalst": "SC",
    "dropmalzpp": 295949998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435235891,
    "dropsitcph": 8435235891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24710",
    "droptype": "D",
    "dropname": "TAYLORS",
    "dropdeladd": "4359 WADE HAMPTON BLVD",
    "dropdelcty": "TAYLORS",
    "dropdelst": "SC",
    "dropdelzpp": 296879998,
    "dropphyadd": "4359 WADE HAMPTON BLVD",
    "dropphycty": "TAYLORS",
    "dropphyst": "SC",
    "dropphyzpp": 296879998,
    "dropmaladd": "4359 WADE HAMPTON BLVD",
    "dropmalcty": "TAYLORS",
    "dropmalst": "SC",
    "dropmalzpp": 296879998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642441896,
    "dropfax": 8642683150
  },
  {
    "dcode": "D",
    "dropkey": "PX24721",
    "droptype": "D",
    "dropname": "TIGERVILLE",
    "dropdeladd": "7864 N TIGERVILLE RD",
    "dropdelcty": "TIGERVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296889800,
    "dropphyadd": "7864 N TIGERVILLE RD",
    "dropphycty": "TIGERVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIGERVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296889998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648953115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24723",
    "droptype": "D",
    "dropname": "TILLMAN",
    "dropdeladd": "28 COTTON HILL RD",
    "dropdelcty": "TILLMAN",
    "dropdelst": "SC",
    "dropdelzpp": 299439998,
    "dropphyadd": "28 COTTON HILL RD",
    "dropphycty": "TILLMAN",
    "dropphyst": "SC",
    "dropphyzpp": 299439998,
    "dropmaladd": "28 COTTON HILL RD",
    "dropmalcty": "TILLMAN",
    "dropmalst": "SC",
    "dropmalzpp": 299439998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437266422,
    "dropsitcph": 8437266422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24724",
    "droptype": "D",
    "dropname": "TIMMONSVILLE",
    "dropdeladd": "203 E MAIN ST",
    "dropdelcty": "TIMMONSVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 291611851,
    "dropphyadd": "203 E MAIN ST",
    "dropphycty": "TIMMONSVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 291611851,
    "dropmaladd": "203 E MAIN ST",
    "dropmalcty": "TIMMONSVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 291611851,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8433467581,
    "dropfax": 8433469604
  },
  {
    "dcode": "D",
    "dropkey": "PX24727",
    "droptype": "D",
    "dropname": "TOWNVILLE",
    "dropdeladd": "8923 HIGHWAY 24",
    "dropdelcty": "TOWNVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296899998,
    "dropphyadd": "8923 HIGHWAY 24",
    "dropphycty": "TOWNVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296899998,
    "dropmaladd": "8923 HIGHWAY 24",
    "dropmalcty": "TOWNVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296899998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648448037,
    "dropfax": 8648448051
  },
  {
    "dcode": "D",
    "dropkey": "PX24729",
    "droptype": "D",
    "dropname": "TRAVELERS REST",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "TRAVELERS REST",
    "dropdelst": "SC",
    "dropdelzpp": 296909998,
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "TRAVELERS REST",
    "dropphyst": "SC",
    "dropphyzpp": 296909998,
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "TRAVELERS REST",
    "dropmalst": "SC",
    "dropmalzpp": 296909998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648343227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24730",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "113 WATSON ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "SC",
    "dropdelzpp": 298479998,
    "dropphyadd": "113 WATSON ST",
    "dropphycty": "TRENTON",
    "dropphyst": "SC",
    "dropphyzpp": 298479998,
    "dropmaladd": "113 WATSON ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "SC",
    "dropmalzpp": 298479998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8032754727,
    "dropsitcph": 8032754727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24734",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "104 SLOAN ST",
    "dropdelcty": "TROY",
    "dropdelst": "SC",
    "dropdelzpp": 298489998,
    "dropphyadd": "104 SLOAN ST",
    "dropphycty": "TROY",
    "dropphyst": "SC",
    "dropphyzpp": 298489998,
    "dropmaladd": "104 SLOAN ST",
    "dropmalcty": "TROY",
    "dropmalst": "SC",
    "dropmalzpp": 298489998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8647466440,
    "dropsitcph": 8647466440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24736",
    "droptype": "D",
    "dropname": "TURBEVILLE",
    "dropdeladd": "1290 CLARENCE COKER HWY",
    "dropdelcty": "TURBEVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 291629507,
    "dropphyadd": "1290 CLARENCE COKER HWY",
    "dropphycty": "TURBEVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 291629507,
    "dropmaladd": "1290 CLARENCE COKER HWY",
    "dropmalcty": "TURBEVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 291629507,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8436990763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24740",
    "droptype": "D",
    "dropname": "ULMER",
    "dropdeladd": "219 BURTONS FERRY HWY",
    "dropdelcty": "ULMER",
    "dropdelst": "SC",
    "dropdelzpp": 298499998,
    "dropphyadd": "219 BURTONS FERRY HWY",
    "dropphycty": "ULMER",
    "dropphyst": "SC",
    "dropphyzpp": 298499998,
    "dropmaladd": "219 BURTONS FERRY HWY",
    "dropmalcty": "ULMER",
    "dropmalst": "SC",
    "dropmalzpp": 298499998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8035843963,
    "dropsitcph": 8035843963,
    "dropfax": 8035843810
  },
  {
    "dcode": "D",
    "dropkey": "PX24742",
    "droptype": "D",
    "dropname": "UNA",
    "dropdeladd": "331 SIBLEY ST",
    "dropdelcty": "UNA",
    "dropdelst": "SC",
    "dropdelzpp": 293789800,
    "dropphyadd": "331 SIBLEY ST",
    "dropphycty": "UNA",
    "dropphyst": "SC",
    "dropphyzpp": 293789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNA",
    "dropmalst": "SC",
    "dropmalzpp": 293789998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645764588,
    "dropfax": 8645768813
  },
  {
    "dcode": "D",
    "dropkey": "PX24743",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "804 INDUSTRIAL PARK RD",
    "dropdelcty": "UNION",
    "dropdelst": "SC",
    "dropdelzpp": 293799998,
    "dropphyadd": "804 INDUSTRIAL PARK RD",
    "dropphycty": "UNION",
    "dropphyst": "SC",
    "dropphyzpp": 293799998,
    "dropmaladd": "804 INDUSTRIAL PARK RD",
    "dropmalcty": "UNION",
    "dropmalst": "SC",
    "dropmalzpp": 293799998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644277638,
    "dropfax": 8644294936
  },
  {
    "dcode": "D",
    "dropkey": "PX24752",
    "droptype": "D",
    "dropname": "VAN WYCK",
    "dropdeladd": "5222 OLD HICKORY RD",
    "dropdelcty": "VAN WYCK",
    "dropdelst": "SC",
    "dropdelzpp": 297449600,
    "dropphyadd": "5222 OLD HICKORY RD",
    "dropphycty": "VAN WYCK",
    "dropphyst": "SC",
    "dropphyzpp": 297449600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN WYCK",
    "dropmalst": "SC",
    "dropmalzpp": 297449998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8032832135,
    "dropsitcph": 8032832135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24753",
    "droptype": "D",
    "dropname": "VANCE",
    "dropdeladd": "450 CAMDEN RD",
    "dropdelcty": "VANCE",
    "dropdelst": "SC",
    "dropdelzpp": 291639998,
    "dropphyadd": "450 CAMDEN RD",
    "dropphycty": "VANCE",
    "dropphyst": "SC",
    "dropphyzpp": 291639998,
    "dropmaladd": "450 CAMDEN RD",
    "dropmalcty": "VANCE",
    "dropmalst": "SC",
    "dropmalzpp": 291639998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035983313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24754",
    "droptype": "D",
    "dropname": "VARNVILLE",
    "dropdeladd": "81 MAIN ST",
    "dropdelcty": "VARNVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 299449998,
    "dropphyadd": "81 MAIN ST",
    "dropphycty": "VARNVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 299449998,
    "dropmaladd": "81 MAIN ST",
    "dropmalcty": "VARNVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 299449998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8039433161,
    "dropsitcph": 8039433161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24755",
    "droptype": "D",
    "dropname": "VAUCLUSE",
    "dropdeladd": "111 SENN ST",
    "dropdelcty": "VAUCLUSE",
    "dropdelst": "SC",
    "dropdelzpp": 298509998,
    "dropphyadd": "111 SENN ST",
    "dropphycty": "VAUCLUSE",
    "dropphyst": "SC",
    "dropphyzpp": 298509998,
    "dropmaladd": "111 SENN ST",
    "dropmalcty": "VAUCLUSE",
    "dropmalst": "SC",
    "dropmalzpp": 298509998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036637741,
    "dropsitcph": 8036637741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24760",
    "droptype": "D",
    "dropname": "WADMALAW ISLAND",
    "dropdeladd": "1917 LIBERIA RD",
    "dropdelcty": "WADMALAW ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 294879998,
    "dropphyadd": "1917 LIBERIA RD",
    "dropphycty": "WADMALAW ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 294879998,
    "dropmaladd": "1917 LIBERIA RD",
    "dropmalcty": "WADMALAW ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 294879998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8435590506,
    "dropfax": 8435592611
  },
  {
    "dcode": "D",
    "dropkey": "PX24761",
    "droptype": "D",
    "dropname": "WAGENER",
    "dropdeladd": "171 PARK ST NE",
    "dropdelcty": "WAGENER",
    "dropdelst": "SC",
    "dropdelzpp": 291649998,
    "dropphyadd": "171 PARK ST NE",
    "dropphycty": "WAGENER",
    "dropphyst": "SC",
    "dropphyzpp": 291649998,
    "dropmaladd": "171 PARK ST NE",
    "dropmalcty": "WAGENER",
    "dropmalst": "SC",
    "dropmalzpp": 291649998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8035645781,
    "dropfax": 8035643057
  },
  {
    "dcode": "D",
    "dropkey": "PX24762",
    "droptype": "D",
    "dropname": "WALHALLA",
    "dropdeladd": "208 W NORTH BROAD ST",
    "dropdelcty": "WALHALLA",
    "dropdelst": "SC",
    "dropdelzpp": 296919998,
    "dropphyadd": "208 W NORTH BROAD ST",
    "dropphycty": "WALHALLA",
    "dropphyst": "SC",
    "dropphyzpp": 296919998,
    "dropmaladd": "208 W NORTH BROAD ST",
    "dropmalcty": "WALHALLA",
    "dropmalst": "SC",
    "dropmalzpp": 296919998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646383523,
    "dropfax": 8646383167
  },
  {
    "dcode": "D",
    "dropkey": "PX24763",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "4130 POST OFFICE DR",
    "dropdelcty": "WALLACE",
    "dropdelst": "SC",
    "dropdelzpp": 295969998,
    "dropphyadd": "4130 POST OFFICE DR",
    "dropphycty": "WALLACE",
    "dropphyst": "SC",
    "dropphyzpp": 295969998,
    "dropmaladd": "4130 POST OFFICE DR",
    "dropmalcty": "WALLACE",
    "dropmalst": "SC",
    "dropmalzpp": 295969998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435372761,
    "dropsitcph": 8435372761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24765",
    "droptype": "D",
    "dropname": "WALTERBORO",
    "dropdeladd": "324 N LUCAS ST",
    "dropdelcty": "WALTERBORO",
    "dropdelst": "SC",
    "dropdelzpp": 294883984,
    "dropphyadd": "333 E WASHINGTON ST",
    "dropphycty": "WALTERBORO",
    "dropphyst": "SC",
    "dropphyzpp": 294889998,
    "dropmaladd": "333 E WASHINGTON ST",
    "dropmalcty": "WALTERBORO",
    "dropmalst": "SC",
    "dropmalzpp": 294889998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435492125,
    "dropsitcph": 8435492125,
    "dropfax": 8435499302
  },
  {
    "dcode": "D",
    "dropkey": "PX24768",
    "droptype": "D",
    "dropname": "WARD",
    "dropdeladd": "109 E FRONT ST",
    "dropdelcty": "WARD",
    "dropdelst": "SC",
    "dropdelzpp": 291669998,
    "dropphyadd": "109 E FRONT ST",
    "dropphycty": "WARD",
    "dropphyst": "SC",
    "dropphyzpp": 291669998,
    "dropmaladd": "109 E FRONT ST",
    "dropmalcty": "WARD",
    "dropmalst": "SC",
    "dropmalzpp": 291669998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036857176,
    "dropfax": 8036857176
  },
  {
    "dcode": "D",
    "dropkey": "PX24770",
    "droptype": "D",
    "dropname": "WARE SHOALS",
    "dropdeladd": "101 MCLANE AVE",
    "dropdelcty": "WARE SHOALS",
    "dropdelst": "SC",
    "dropdelzpp": 296929998,
    "dropphyadd": "101 MCLANE AVE",
    "dropphycty": "WARE SHOALS",
    "dropphyst": "SC",
    "dropphyzpp": 296929998,
    "dropmaladd": "101 MCLANE AVE",
    "dropmalcty": "WARE SHOALS",
    "dropmalst": "SC",
    "dropmalzpp": 296929998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644567521,
    "dropfax": 8644565859
  },
  {
    "dcode": "D",
    "dropkey": "PX24771",
    "droptype": "D",
    "dropname": "WARRENVILLE",
    "dropdeladd": "1341 AUGUSTA RD",
    "dropdelcty": "WARRENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 298519998,
    "dropphyadd": "1341 AUGUSTA RD",
    "dropphycty": "WARRENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 298519998,
    "dropmaladd": "1341 AUGUSTA RD",
    "dropmalcty": "WARRENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 298519998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036636250,
    "dropsitcph": 8036636250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24774",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "11219 HIGHWAY 221 S",
    "dropdelcty": "WATERLOO",
    "dropdelst": "SC",
    "dropdelzpp": 293849998,
    "dropphyadd": "11219 HIGHWAY 221 S",
    "dropphycty": "WATERLOO",
    "dropphyst": "SC",
    "dropphyzpp": 293849998,
    "dropmaladd": "11219 HIGHWAY 221 S",
    "dropmalcty": "WATERLOO",
    "dropmalst": "SC",
    "dropmalzpp": 293849998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646773155,
    "dropfax": 8646773155
  },
  {
    "dcode": "D",
    "dropkey": "PX24780",
    "droptype": "D",
    "dropname": "WEDGEFIELD",
    "dropdeladd": "2385 HIGHWAY 261 S",
    "dropdelcty": "WEDGEFIELD",
    "dropdelst": "SC",
    "dropdelzpp": 291689004,
    "dropphyadd": "2385 HIGHWAY 261 S",
    "dropphycty": "WEDGEFIELD",
    "dropphyst": "SC",
    "dropphyzpp": 291689004,
    "dropmaladd": "2385 HIGHWAY 261 S",
    "dropmalcty": "WEDGEFIELD",
    "dropmalst": "SC",
    "dropmalzpp": 291689004,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034949444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24781",
    "droptype": "D",
    "dropname": "WELLFORD",
    "dropdeladd": "1003 MAIN ST",
    "dropdelcty": "WELLFORD",
    "dropdelst": "SC",
    "dropdelzpp": 293859998,
    "dropphyadd": "1003 MAIN ST",
    "dropphycty": "WELLFORD",
    "dropphyst": "SC",
    "dropphyzpp": 293859998,
    "dropmaladd": "1003 MAIN ST",
    "dropmalcty": "WELLFORD",
    "dropmalst": "SC",
    "dropmalzpp": 293859998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644399214,
    "dropfax": 8649499301
  },
  {
    "dcode": "D",
    "dropkey": "PX24785",
    "droptype": "D",
    "dropname": "CAYCE WEST COLUMBIA",
    "dropdeladd": "1535 PLATT SPRINGS RD",
    "dropdelcty": "WEST COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 291699998,
    "dropphyadd": "1535 PLATT SPRINGS RD",
    "dropphycty": "WEST COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 291699998,
    "dropmaladd": "1535 PLATT SPRINGS RD",
    "dropmalcty": "WEST COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 291699998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037960542,
    "dropfax": 8037960985
  },
  {
    "dcode": "D",
    "dropkey": "PX24789",
    "droptype": "D",
    "dropname": "WEST UNION",
    "dropdeladd": "190 S HIGHWAY 11",
    "dropdelcty": "WEST UNION",
    "dropdelst": "SC",
    "dropdelzpp": 296969998,
    "dropphyadd": "190 S HIGHWAY 11",
    "dropphycty": "WEST UNION",
    "dropphyst": "SC",
    "dropphyzpp": 296969998,
    "dropmaladd": "190 S HIGHWAY 11",
    "dropmalcty": "WEST UNION",
    "dropmalst": "SC",
    "dropmalzpp": 296969998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646382311,
    "dropfax": 8646386770
  },
  {
    "dcode": "D",
    "dropkey": "PX24792",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "800 E MAIN ST",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "SC",
    "dropdelzpp": 296939998,
    "dropphyadd": "800 E MAIN ST",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "SC",
    "dropphyzpp": 296939998,
    "dropmaladd": "800 E MAIN ST",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "SC",
    "dropmalzpp": 296939998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8646472484,
    "dropfax": 8646472433
  },
  {
    "dcode": "D",
    "dropkey": "PX24796",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "3141 KERSHAW HWY",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 291759564,
    "dropphyadd": "3141 KERSHAW HWY",
    "dropphycty": "WESTVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 291759564,
    "dropmaladd": "3141 KERSHAW HWY",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 291759564,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034320039,
    "dropfax": 8034320039
  },
  {
    "dcode": "D",
    "dropkey": "PX24806",
    "droptype": "D",
    "dropname": "WHITE ROCK",
    "dropdeladd": "1947 DUTCH FORK RD",
    "dropdelcty": "WHITE ROCK",
    "dropdelst": "SC",
    "dropdelzpp": 291779900,
    "dropphyadd": "1947 DUTCH FORK RD",
    "dropphycty": "WHITE ROCK",
    "dropphyst": "SC",
    "dropphyzpp": 291779900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE ROCK",
    "dropmalst": "SC",
    "dropmalzpp": 291779998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037819380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24807",
    "droptype": "D",
    "dropname": "WHITE STONE",
    "dropdeladd": "3430 SOUTHPORT RD",
    "dropdelcty": "WHITE STONE",
    "dropdelst": "SC",
    "dropdelzpp": 293869800,
    "dropphyadd": "3430 SOUTHPORT RD",
    "dropphycty": "WHITE STONE",
    "dropphyst": "SC",
    "dropphyzpp": 293869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE STONE",
    "dropmalst": "SC",
    "dropmalzpp": 293869998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8645824749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24810",
    "droptype": "D",
    "dropname": "WHITMIRE",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "WHITMIRE",
    "dropdelst": "SC",
    "dropdelzpp": 291781367,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "WHITMIRE",
    "dropphyst": "SC",
    "dropphyzpp": 291781367,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "WHITMIRE",
    "dropmalst": "SC",
    "dropmalzpp": 291781367,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036943612,
    "dropfax": 8036944148
  },
  {
    "dcode": "D",
    "dropkey": "PX24814",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "1718 GEORGE WARREN DR",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "SC",
    "dropdelzpp": 294939800,
    "dropphyadd": "1718 GEORGE WARREN DR",
    "dropphycty": "WILLIAMS",
    "dropphyst": "SC",
    "dropphyzpp": 294939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "SC",
    "dropmalzpp": 294939998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435628320,
    "dropsitcph": 8435628320,
    "dropfax": 8435622154
  },
  {
    "dcode": "D",
    "dropkey": "PX24815",
    "droptype": "D",
    "dropname": "WILLIAMSTON",
    "dropdeladd": "101 MILL ST",
    "dropdelcty": "WILLIAMSTON",
    "dropdelst": "SC",
    "dropdelzpp": 296979998,
    "dropphyadd": "101 MILL ST",
    "dropphycty": "WILLIAMSTON",
    "dropphyst": "SC",
    "dropphyzpp": 296979998,
    "dropmaladd": "101 MILL ST",
    "dropmalcty": "WILLIAMSTON",
    "dropmalst": "SC",
    "dropmalzpp": 296979998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648479468,
    "dropfax": 8648476269
  },
  {
    "dcode": "D",
    "dropkey": "PX24817",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "12926 MAIN ST",
    "dropdelcty": "WILLISTON",
    "dropdelst": "SC",
    "dropdelzpp": 298539998,
    "dropphyadd": "12926 MAIN ST",
    "dropphycty": "WILLISTON",
    "dropphyst": "SC",
    "dropphyzpp": 298539998,
    "dropmaladd": "12926 MAIN ST",
    "dropmalcty": "WILLISTON",
    "dropmalst": "SC",
    "dropmalzpp": 298539998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8038662276,
    "dropsitcph": 8032662276,
    "dropfax": 8032665719
  },
  {
    "dcode": "D",
    "dropkey": "PX24820",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "559 MIDDLETON DR N",
    "dropdelcty": "WINDSOR",
    "dropdelst": "SC",
    "dropdelzpp": 298569998,
    "dropphyadd": "559 MIDDLETON DR N",
    "dropphycty": "WINDSOR",
    "dropphyst": "SC",
    "dropphyzpp": 298569998,
    "dropmaladd": "559 MIDDLETON DR N",
    "dropmalcty": "WINDSOR",
    "dropmalst": "SC",
    "dropmalzpp": 298569998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036486662,
    "dropsitcph": 8036486662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24825",
    "droptype": "D",
    "dropname": "WINNSBORO",
    "dropdeladd": "144 N CONGRESS ST",
    "dropdelcty": "WINNSBORO",
    "dropdelst": "SC",
    "dropdelzpp": 291801161,
    "dropphyadd": "144 N CONGRESS ST",
    "dropphycty": "WINNSBORO",
    "dropphyst": "SC",
    "dropphyzpp": 291801161,
    "dropmaladd": "144 N CONGRESS ST",
    "dropmalcty": "WINNSBORO",
    "dropmalst": "SC",
    "dropmalzpp": 291801161,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8036359486,
    "dropfax": 8036354634
  },
  {
    "dcode": "D",
    "dropkey": "PX24835",
    "droptype": "D",
    "dropname": "WOODRUFF",
    "dropdeladd": "955 N MAIN ST",
    "dropdelcty": "WOODRUFF",
    "dropdelst": "SC",
    "dropdelzpp": 293889998,
    "dropphyadd": "955 N MAIN ST",
    "dropphycty": "WOODRUFF",
    "dropphyst": "SC",
    "dropphyzpp": 293889998,
    "dropmaladd": "955 N MAIN ST",
    "dropmalcty": "WOODRUFF",
    "dropmalst": "SC",
    "dropmalzpp": 293889998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8644762221,
    "dropfax": 8644762836
  },
  {
    "dcode": "D",
    "dropkey": "PX24839",
    "droptype": "D",
    "dropname": "YEMASSEE",
    "dropdeladd": "27 SALKEHATCHIE RD",
    "dropdelcty": "YEMASSEE",
    "dropdelst": "SC",
    "dropdelzpp": 299459998,
    "dropphyadd": "27 SALKEHATCHIE RD",
    "dropphycty": "YEMASSEE",
    "dropphyst": "SC",
    "dropphyzpp": 299459998,
    "dropmaladd": "27 SALKEHATCHIE RD",
    "dropmalcty": "YEMASSEE",
    "dropmalst": "SC",
    "dropmalzpp": 299459998,
    "dropsitphn": "",
    "dropsitlph": 8039266014,
    "dropsitcph": 8435892831,
    "dropfax": 8435892832
  },
  {
    "dcode": "D",
    "dropkey": "PX24843",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "909 LIBERTY ST E",
    "dropdelcty": "YORK",
    "dropdelst": "SC",
    "dropdelzpp": 297452689,
    "dropphyadd": "909 LIBERTY ST E",
    "dropphycty": "YORK",
    "dropphyst": "SC",
    "dropphyzpp": 297452689,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YORK",
    "dropmalst": "SC",
    "dropmalzpp": 297459998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8036847865,
    "dropsitcph": 8036847865,
    "dropfax": 8036846298
  },
  {
    "dcode": "D",
    "dropkey": "PX24848",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "104 S CHURCH ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "TN",
    "dropdelzpp": 370109998,
    "dropphyadd": "104 S CHURCH ST",
    "dropphycty": "ADAMS",
    "dropphyst": "TN",
    "dropphyzpp": 370109998,
    "dropmaladd": "104 S CHURCH ST",
    "dropmalcty": "ADAMS",
    "dropmalst": "TN",
    "dropmalzpp": 370109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156962070,
    "dropsitcph": 6156964905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24849",
    "droptype": "D",
    "dropname": "ADAMSVILLE",
    "dropdeladd": "339 E MAIN ST",
    "dropdelcty": "ADAMSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383109998,
    "dropphyadd": "339 E MAIN ST",
    "dropphycty": "ADAMSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383109998,
    "dropmaladd": "339 E MAIN ST",
    "dropmalcty": "ADAMSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316324270,
    "dropsitcph": 7316324270,
    "dropfax": 7316324276
  },
  {
    "dcode": "D",
    "dropkey": "PX24853",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "432 AFTON RD",
    "dropdelcty": "AFTON",
    "dropdelst": "TN",
    "dropdelzpp": 376169998,
    "dropphyadd": "432 AFTON RD",
    "dropphycty": "AFTON",
    "dropphyst": "TN",
    "dropphyzpp": 376169998,
    "dropmaladd": "432 AFTON RD",
    "dropmalcty": "AFTON",
    "dropmalst": "TN",
    "dropmalzpp": 376169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236395822,
    "dropsitcph": 4236395822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24855",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "83 E PARK ST",
    "dropdelcty": "ALAMO",
    "dropdelst": "TN",
    "dropdelzpp": 380011795,
    "dropphyadd": "83 E PARK ST",
    "dropphycty": "ALAMO",
    "dropphyst": "TN",
    "dropphyzpp": 380011795,
    "dropmaladd": "83 E PARK ST",
    "dropmalcty": "ALAMO",
    "dropmalst": "TN",
    "dropmalzpp": 380011795,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316962355,
    "dropsitcph": 7316962355,
    "dropfax": 7316964912
  },
  {
    "dcode": "D",
    "dropkey": "PX24856",
    "droptype": "D",
    "dropname": "ALCOA",
    "dropdeladd": "108 S HALL RD",
    "dropdelcty": "ALCOA",
    "dropdelst": "TN",
    "dropdelzpp": 377019998,
    "dropphyadd": "108 S HALL RD",
    "dropphycty": "ALCOA",
    "dropphyst": "TN",
    "dropphyzpp": 377019998,
    "dropmaladd": "108 S HALL RD",
    "dropmalcty": "ALCOA",
    "dropmalst": "TN",
    "dropmalzpp": 377019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659821101,
    "dropsitcph": 8659824569,
    "dropfax": 8659823376
  },
  {
    "dcode": "D",
    "dropkey": "PX24857",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "100 HIGH ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "TN",
    "dropdelzpp": 370129998,
    "dropphyadd": "100 HIGH ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "TN",
    "dropphyzpp": 370129998,
    "dropmaladd": "100 HIGH ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "TN",
    "dropmalzpp": 370129998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155292139,
    "dropsitcph": 6155292139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24860",
    "droptype": "D",
    "dropname": "ALLARDT",
    "dropdeladd": "1716 PENNSYLVANIA ST",
    "dropdelcty": "ALLARDT",
    "dropdelst": "TN",
    "dropdelzpp": 385049998,
    "dropphyadd": "1716 PENNSYLVANIA ST",
    "dropphycty": "ALLARDT",
    "dropphyst": "TN",
    "dropphyzpp": 385049998,
    "dropmaladd": "1716 PENNSYLVANIA ST",
    "dropmalcty": "ALLARDT",
    "dropmalst": "TN",
    "dropmalzpp": 385049998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318799164,
    "dropsitcph": 9318799164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24862",
    "droptype": "D",
    "dropname": "ALLONS",
    "dropdeladd": "2415 CELINA HWY",
    "dropdelcty": "ALLONS",
    "dropdelst": "TN",
    "dropdelzpp": 385419998,
    "dropphyadd": "2415 CELINA HWY",
    "dropphycty": "ALLONS",
    "dropphyst": "TN",
    "dropphyzpp": 385419998,
    "dropmaladd": "2415 CELINA HWY",
    "dropmalcty": "ALLONS",
    "dropmalst": "TN",
    "dropmalzpp": 385419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318235054,
    "dropsitcph": 9318235054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24864",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "2311 JAMESTOWN HWY",
    "dropdelcty": "ALPINE",
    "dropdelst": "TN",
    "dropdelzpp": 385439998,
    "dropphyadd": "2311 JAMESTOWN HWY",
    "dropphycty": "ALPINE",
    "dropphyst": "TN",
    "dropphyzpp": 385439998,
    "dropmaladd": "2311 JAMESTOWN HWY",
    "dropmalcty": "ALPINE",
    "dropmalst": "TN",
    "dropmalzpp": 385439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318234111,
    "dropsitcph": 9318234111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24865",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "70 FITCHTOWN RD",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "TN",
    "dropdelzpp": 373019998,
    "dropphyadd": "70 FITCHTOWN RD",
    "dropphycty": "ALTAMONT",
    "dropphyst": "TN",
    "dropphyzpp": 373019998,
    "dropmaladd": "70 FITCHTOWN RD",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "TN",
    "dropmalzpp": 373019998,
    "dropsitphn": 9316923699,
    "dropsitlph": 9316923699,
    "dropsitcph": 9316923699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24868",
    "droptype": "D",
    "dropname": "ANDERSONVILLE",
    "dropdeladd": "4134 ANDERSONVILLE HWY",
    "dropdelcty": "ANDERSONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377059998,
    "dropphyadd": "4134 ANDERSONVILLE HWY",
    "dropphycty": "ANDERSONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377059998,
    "dropmaladd": "4134 ANDERSONVILLE HWY",
    "dropmalcty": "ANDERSONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654947180,
    "dropsitcph": 8654947180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24869",
    "droptype": "D",
    "dropname": "ANTIOCH",
    "dropdeladd": "5424 BELL FORGE LN E",
    "dropdelcty": "ANTIOCH",
    "dropdelst": "TN",
    "dropdelzpp": 370139998,
    "dropphyadd": "5424 BELL FORGE LN E",
    "dropphycty": "ANTIOCH",
    "dropphyst": "TN",
    "dropphyzpp": 370139998,
    "dropmaladd": "5424 BELL FORGE LN E",
    "dropmalcty": "ANTIOCH",
    "dropmalst": "TN",
    "dropmalzpp": 370139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157317795,
    "dropsitcph": 6157172954,
    "dropfax": 6157310135
  },
  {
    "dcode": "D",
    "dropkey": "PX24870",
    "droptype": "D",
    "dropname": "APISON",
    "dropdeladd": "4498 BILL JONES RD",
    "dropdelcty": "APISON",
    "dropdelst": "TN",
    "dropdelzpp": 373029604,
    "dropphyadd": "4498 BILL JONES RD",
    "dropphycty": "APISON",
    "dropphyst": "TN",
    "dropphyzpp": 373029604,
    "dropmaladd": "4498 BILL JONES RD",
    "dropmalcty": "APISON",
    "dropmalst": "TN",
    "dropmalzpp": 373029604,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232364717,
    "dropsitcph": 4232364717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24873",
    "droptype": "D",
    "dropname": "ARDMORE",
    "dropdeladd": "26050 MAIN ST",
    "dropdelcty": "ARDMORE",
    "dropdelst": "TN",
    "dropdelzpp": 384499998,
    "dropphyadd": "26050 MAIN ST",
    "dropphycty": "ARDMORE",
    "dropphyst": "TN",
    "dropphyzpp": 384499998,
    "dropmaladd": "26050 MAIN ST",
    "dropmalcty": "ARDMORE",
    "dropmalst": "TN",
    "dropmalzpp": 384499998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314273706,
    "dropsitcph": 9312264203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24877",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "5885 AIRLINE RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 380029998,
    "dropphyadd": "5885 AIRLINE RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 380029998,
    "dropmaladd": "5885 AIRLINE RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 380029998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018673963,
    "dropsitcph": 9018673963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24881",
    "droptype": "D",
    "dropname": "ARRINGTON",
    "dropdeladd": "4817 MURFREESBORO RD",
    "dropdelcty": "ARRINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 370149998,
    "dropphyadd": "4817 MURFREESBORO RD",
    "dropphycty": "ARRINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 370149998,
    "dropmaladd": "4817 MURFREESBORO RD",
    "dropmalcty": "ARRINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 370149998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153957259,
    "dropsitcph": 6153957259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24883",
    "droptype": "D",
    "dropname": "ASHLAND CITY",
    "dropdeladd": "102 N VINE ST",
    "dropdelcty": "ASHLAND CITY",
    "dropdelst": "TN",
    "dropdelzpp": 370159998,
    "dropphyadd": "102 N VINE ST",
    "dropphycty": "ASHLAND CITY",
    "dropphyst": "TN",
    "dropphyzpp": 370159998,
    "dropmaladd": "102 N VINE ST",
    "dropmalcty": "ASHLAND CITY",
    "dropmalst": "TN",
    "dropmalzpp": 370159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157926125,
    "dropsitcph": 6157929248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24886",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "202 S WHITE ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "TN",
    "dropdelzpp": 373039998,
    "dropphyadd": "202 S WHITE ST",
    "dropphycty": "ATHENS",
    "dropphyst": "TN",
    "dropphyzpp": 373039998,
    "dropmaladd": "202 S WHITE ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "TN",
    "dropmalzpp": 373039998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237449605,
    "dropsitcph": 4237464427,
    "dropfax": 4237469182
  },
  {
    "dcode": "D",
    "dropkey": "PX24887",
    "droptype": "D",
    "dropname": "ATOKA",
    "dropdeladd": "186 ATOKA MUNFORD RD",
    "dropdelcty": "ATOKA",
    "dropdelst": "TN",
    "dropdelzpp": 380044922,
    "dropphyadd": "186 ATOKA MUNFORD RD",
    "dropphycty": "ATOKA",
    "dropphyst": "TN",
    "dropphyzpp": 380044922,
    "dropmaladd": "186 ATOKA MUNFORD RD",
    "dropmalcty": "ATOKA",
    "dropmalst": "TN",
    "dropmalzpp": 380044922,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018378335,
    "dropsitcph": 9018378335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24888",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "1570 E MAIN ST",
    "dropdelcty": "ATWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 382209998,
    "dropphyadd": "1570 E MAIN ST",
    "dropphycty": "ATWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 382209998,
    "dropmaladd": "1570 E MAIN ST",
    "dropmalcty": "ATWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 382209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7316627428,
    "dropfax": 7316627906
  },
  {
    "dcode": "D",
    "dropkey": "PX24889",
    "droptype": "D",
    "dropname": "AUBURNTOWN",
    "dropdeladd": "42 E MAIN ST",
    "dropdelcty": "AUBURNTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 370169998,
    "dropphyadd": "42 E MAIN ST",
    "dropphycty": "AUBURNTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 370169998,
    "dropmaladd": "42 E MAIN ST",
    "dropmalcty": "AUBURNTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 370169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154644301,
    "dropsitcph": 6154644301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24901",
    "droptype": "D",
    "dropname": "BATH SPRINGS",
    "dropdeladd": "2744 HIGHWAY 114 W",
    "dropdelcty": "BATH SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 383119998,
    "dropphyadd": "2744 HIGHWAY 114 W",
    "dropphycty": "BATH SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 383119998,
    "dropmaladd": "2744 HIGHWAY 114 W",
    "dropmalcty": "BATH SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 383119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315499704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24902",
    "droptype": "D",
    "dropname": "BAXTER",
    "dropdeladd": "216 FOURTH AVE N",
    "dropdelcty": "BAXTER",
    "dropdelst": "TN",
    "dropdelzpp": 385449998,
    "dropphyadd": "216 FOURTH AVE N",
    "dropphycty": "BAXTER",
    "dropphyst": "TN",
    "dropphyzpp": 385449998,
    "dropmaladd": "216 FOURTH AVE N",
    "dropmalcty": "BAXTER",
    "dropmalst": "TN",
    "dropmalzpp": 385449998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313222209,
    "dropsitcph": 9313222318,
    "dropfax": 9313222280
  },
  {
    "dcode": "D",
    "dropkey": "PX24905",
    "droptype": "D",
    "dropname": "BEAN STATION",
    "dropdeladd": "340 MAIN ST",
    "dropdelcty": "BEAN STATION",
    "dropdelst": "TN",
    "dropdelzpp": 377089998,
    "dropphyadd": "340 MAIN ST",
    "dropphycty": "BEAN STATION",
    "dropphyst": "TN",
    "dropphyzpp": 377089998,
    "dropmaladd": "340 MAIN ST",
    "dropmalcty": "BEAN STATION",
    "dropmalst": "TN",
    "dropmalzpp": 377089998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659932599,
    "dropsitcph": 8659932599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24907",
    "droptype": "D",
    "dropname": "BEECH BLUFF",
    "dropdeladd": "4541 BEECH BLUFF RD",
    "dropdelcty": "BEECH BLUFF",
    "dropdelst": "TN",
    "dropdelzpp": 383139998,
    "dropphyadd": "4541 BEECH BLUFF RD",
    "dropphycty": "BEECH BLUFF",
    "dropphyst": "TN",
    "dropphyzpp": 383139998,
    "dropmaladd": "4541 BEECH BLUFF RD",
    "dropmalcty": "BEECH BLUFF",
    "dropmalst": "TN",
    "dropmalzpp": 383139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7314272946,
    "dropsitcph": 7314272946,
    "dropfax": 7314277158
  },
  {
    "dcode": "D",
    "dropkey": "PX24908",
    "droptype": "D",
    "dropname": "BEECHGROVE",
    "dropdeladd": "13975 MURFREESBORO HWY",
    "dropdelcty": "BEECHGROVE",
    "dropdelst": "TN",
    "dropdelzpp": 370189998,
    "dropphyadd": "13975 MURFREESBORO HWY",
    "dropphycty": "BEECHGROVE",
    "dropphyst": "TN",
    "dropphyzpp": 370189998,
    "dropmaladd": "13975 MURFREESBORO HWY",
    "dropmalcty": "BEECHGROVE",
    "dropmalst": "TN",
    "dropmalzpp": 370189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313942185,
    "dropsitcph": 9312254011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24911",
    "droptype": "D",
    "dropname": "BEERSHEBA SPRINGS",
    "dropdeladd": "19472 STATE ROUTE 56",
    "dropdelcty": "BEERSHEBA SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 373059998,
    "dropphyadd": "19472 STATE ROUTE 56",
    "dropphycty": "BEERSHEBA SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 373059998,
    "dropmaladd": "19472 STATE ROUTE 56",
    "dropmalcty": "BEERSHEBA SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 373059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316923701,
    "dropsitcph": 9316923701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24913",
    "droptype": "D",
    "dropname": "BELFAST",
    "dropdeladd": "2235 FAYETTEVILLE HWY",
    "dropdelcty": "BELFAST",
    "dropdelst": "TN",
    "dropdelzpp": 370199998,
    "dropphyadd": "2235 FAYETTEVILLE HWY",
    "dropphycty": "BELFAST",
    "dropphyst": "TN",
    "dropphyzpp": 370199998,
    "dropmaladd": "2235 FAYETTEVILLE HWY",
    "dropmalcty": "BELFAST",
    "dropmalst": "TN",
    "dropmalzpp": 370199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312762263,
    "dropsitcph": 9312762263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24914",
    "droptype": "D",
    "dropname": "BELL BUCKLE",
    "dropdeladd": "1 RAILROAD SQ E",
    "dropdelcty": "BELL BUCKLE",
    "dropdelst": "TN",
    "dropdelzpp": 370209998,
    "dropphyadd": "1 RAILROAD SQ E",
    "dropphycty": "BELL BUCKLE",
    "dropphyst": "TN",
    "dropphyzpp": 370209998,
    "dropmaladd": "1 RAILROAD SQ E",
    "dropmalcty": "BELL BUCKLE",
    "dropmalst": "TN",
    "dropmalzpp": 370209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313899312,
    "dropsitcph": 9313899312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24918",
    "droptype": "D",
    "dropname": "BELLS",
    "dropdeladd": "13065 HIGHWAY 79",
    "dropdelcty": "BELLS",
    "dropdelst": "TN",
    "dropdelzpp": 380063961,
    "dropphyadd": "13065 HIGHWAY 79",
    "dropphycty": "BELLS",
    "dropphyst": "TN",
    "dropphyzpp": 380063961,
    "dropmaladd": "13065 HIGHWAY 79",
    "dropmalcty": "BELLS",
    "dropmalst": "TN",
    "dropmalzpp": 380063961,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316632495,
    "dropsitcph": 7316632495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24920",
    "droptype": "D",
    "dropname": "BELVIDERE",
    "dropdeladd": "704 BELVIDERE RD",
    "dropdelcty": "BELVIDERE",
    "dropdelst": "TN",
    "dropdelzpp": 373069998,
    "dropphyadd": "704 BELVIDERE RD",
    "dropphycty": "BELVIDERE",
    "dropphyst": "TN",
    "dropphyzpp": 373069998,
    "dropmaladd": "704 BELVIDERE RD",
    "dropmalcty": "BELVIDERE",
    "dropmalst": "TN",
    "dropmalzpp": 373069998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319672946,
    "dropsitcph": 9319672946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24923",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "188 MAIN ST",
    "dropdelcty": "BENTON",
    "dropdelst": "TN",
    "dropdelzpp": 373079998,
    "dropphyadd": "188 MAIN ST",
    "dropphycty": "BENTON",
    "dropphyst": "TN",
    "dropphyzpp": 373079998,
    "dropmaladd": "188 MAIN ST",
    "dropmalcty": "BENTON",
    "dropmalst": "TN",
    "dropmalzpp": 373079998,
    "dropsitphn": 4233385021,
    "dropsitlph": 4233385021,
    "dropsitcph": 4233385021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24925",
    "droptype": "D",
    "dropname": "BETHEL SPRINGS",
    "dropdeladd": "4698 MAIN ST",
    "dropdelcty": "BETHEL SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 383159998,
    "dropphyadd": "4698 MAIN ST",
    "dropphycty": "BETHEL SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 383159998,
    "dropmaladd": "4698 MAIN ST",
    "dropmalcty": "BETHEL SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 383159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7319344318,
    "dropsitcph": 7319344318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24927",
    "droptype": "D",
    "dropname": "BETHPAGE",
    "dropdeladd": "516 OLD HIGHWAY 31 E 3",
    "dropdelcty": "BETHPAGE",
    "dropdelst": "TN",
    "dropdelzpp": 370229998,
    "dropphyadd": "516 OLD HIGHWAY 31 E 3",
    "dropphycty": "BETHPAGE",
    "dropphyst": "TN",
    "dropphyzpp": 370229998,
    "dropmaladd": "516 OLD HIGHWAY 31 E 3",
    "dropmalcty": "BETHPAGE",
    "dropmalst": "TN",
    "dropmalzpp": 370229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158413215,
    "dropsitcph": 6158413215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24928",
    "droptype": "D",
    "dropname": "BIG ROCK",
    "dropdeladd": "515 BIG ROCK RD",
    "dropdelcty": "BIG ROCK",
    "dropdelst": "TN",
    "dropdelzpp": 370239998,
    "dropphyadd": "515 BIG ROCK RD",
    "dropphycty": "BIG ROCK",
    "dropphyst": "TN",
    "dropphyzpp": 370239998,
    "dropmaladd": "515 BIG ROCK RD",
    "dropmalcty": "BIG ROCK",
    "dropmalst": "TN",
    "dropmalzpp": 370239998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312326323,
    "dropsitcph": 9312326323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24929",
    "droptype": "D",
    "dropname": "BIG SANDY",
    "dropdeladd": "45 DEPOT ST",
    "dropdelcty": "BIG SANDY",
    "dropdelst": "TN",
    "dropdelzpp": 382219998,
    "dropphyadd": "45 DEPOT ST",
    "dropphycty": "BIG SANDY",
    "dropphyst": "TN",
    "dropphyzpp": 382219998,
    "dropmaladd": "45 DEPOT ST",
    "dropmalcty": "BIG SANDY",
    "dropmalst": "TN",
    "dropmalzpp": 382219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315935184,
    "dropsitcph": 7315935184,
    "dropfax": 7315930310
  },
  {
    "dcode": "D",
    "dropkey": "PX24932",
    "droptype": "D",
    "dropname": "BIRCHWOOD",
    "dropdeladd": "5505 HIGHWAY 60",
    "dropdelcty": "BIRCHWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 373089998,
    "dropphyadd": "5505 HIGHWAY 60",
    "dropphycty": "BIRCHWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 373089998,
    "dropmaladd": "5505 HIGHWAY 60",
    "dropmalcty": "BIRCHWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 373089998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239612404,
    "dropsitcph": 4239612404,
    "dropfax": 4239610665
  },
  {
    "dcode": "D",
    "dropkey": "PX24933",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "1006 RUTLEDGE PIKE",
    "dropdelcty": "BLAINE",
    "dropdelst": "TN",
    "dropdelzpp": 377099998,
    "dropphyadd": "1006 RUTLEDGE PIKE",
    "dropphycty": "BLAINE",
    "dropphyst": "TN",
    "dropphyzpp": 377099998,
    "dropmaladd": "1006 RUTLEDGE PIKE",
    "dropmalcty": "BLAINE",
    "dropmalst": "TN",
    "dropmalzpp": 377099998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659336521,
    "dropsitcph": 8659336521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24935",
    "droptype": "D",
    "dropname": "BLOOMINGTON SPRINGS",
    "dropdeladd": "1685 GAINESBORO HWY",
    "dropdelcty": "BLOOMINGTON SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 385459998,
    "dropphyadd": "1685 GAINESBORO HWY",
    "dropphycty": "BLOOMINGTON SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 385459998,
    "dropmaladd": "1685 GAINESBORO HWY",
    "dropmalcty": "BLOOMINGTON SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 385459998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315261921,
    "dropsitcph": 9315261921,
    "dropfax": 9315201610
  },
  {
    "dcode": "D",
    "dropkey": "PX24936",
    "droptype": "D",
    "dropname": "BLOUNTVILLE",
    "dropdeladd": "169 FRANKLIN DR",
    "dropdelcty": "BLOUNTVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 376179998,
    "dropphyadd": "169 FRANKLIN DR",
    "dropphycty": "BLOUNTVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 376179998,
    "dropmaladd": "169 FRANKLIN DR",
    "dropmalcty": "BLOUNTVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 376179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233238401,
    "dropsitcph": 4233238401,
    "dropfax": 4233239211
  },
  {
    "dcode": "D",
    "dropkey": "PX24937",
    "droptype": "D",
    "dropname": "BLUFF CITY",
    "dropdeladd": "4326 BLUFF CITY HWY",
    "dropdelcty": "BLUFF CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376189998,
    "dropphyadd": "4326 BLUFF CITY HWY",
    "dropphycty": "BLUFF CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376189998,
    "dropmaladd": "4326 BLUFF CITY HWY",
    "dropmalcty": "BLUFF CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235387085,
    "dropsitcph": 4235387085,
    "dropfax": 4235384327
  },
  {
    "dcode": "D",
    "dropkey": "PX24938",
    "droptype": "D",
    "dropname": "BOGOTA",
    "dropdeladd": "9866 HIGHWAY 78",
    "dropdelcty": "BOGOTA",
    "dropdelst": "TN",
    "dropdelzpp": 380078001,
    "dropphyadd": "9866 HIGHWAY 78",
    "dropphycty": "BOGOTA",
    "dropphyst": "TN",
    "dropphyzpp": 380078001,
    "dropmaladd": "9866 HIGHWAY 78",
    "dropmalcty": "BOGOTA",
    "dropmalst": "TN",
    "dropmalzpp": 380078001,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312851412,
    "dropsitcph": 7312851412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24939",
    "droptype": "D",
    "dropname": "BOLIVAR",
    "dropdeladd": "118 E MARKET ST",
    "dropdelcty": "BOLIVAR",
    "dropdelst": "TN",
    "dropdelzpp": 380082366,
    "dropphyadd": "118 E MARKET ST",
    "dropphycty": "BOLIVAR",
    "dropphyst": "TN",
    "dropphyzpp": 380082366,
    "dropmaladd": "118 E MARKET ST",
    "dropmalcty": "BOLIVAR",
    "dropmalst": "TN",
    "dropmalzpp": 380082366,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316586652,
    "dropsitcph": 7316583231,
    "dropfax": 7316586652
  },
  {
    "dcode": "D",
    "dropkey": "PX24940",
    "droptype": "D",
    "dropname": "BON AQUA",
    "dropdeladd": "10076 HIGHWAY 46",
    "dropdelcty": "BON AQUA",
    "dropdelst": "TN",
    "dropdelzpp": 370259998,
    "dropphyadd": "10076 HIGHWAY 46",
    "dropphycty": "BON AQUA",
    "dropphyst": "TN",
    "dropphyzpp": 370259998,
    "dropmaladd": "10076 HIGHWAY 46",
    "dropmalcty": "BON AQUA",
    "dropmalst": "TN",
    "dropmalzpp": 370259998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316703541,
    "dropsitcph": 9316703541,
    "dropfax": 9316704043
  },
  {
    "dcode": "D",
    "dropkey": "PX24943",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "134 E MAIN ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "TN",
    "dropdelzpp": 383169998,
    "dropphyadd": "134 E MAIN ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "TN",
    "dropphyzpp": 383169998,
    "dropmaladd": "134 E MAIN ST",
    "dropmalcty": "BRADFORD",
    "dropmalst": "TN",
    "dropmalzpp": 383169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312370145,
    "dropsitcph": 7312370145,
    "dropfax": 7312370145
  },
  {
    "dcode": "D",
    "dropkey": "PX24945",
    "droptype": "D",
    "dropname": "BRADYVILLE",
    "dropdeladd": "5978 BRADYVILLE RD",
    "dropdelcty": "BRADYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370269998,
    "dropphyadd": "5978 BRADYVILLE RD",
    "dropphycty": "BRADYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370269998,
    "dropmaladd": "5978 BRADYVILLE RD",
    "dropmalcty": "BRADYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157655215,
    "dropsitcph": 6157655215,
    "dropfax": 6157657815
  },
  {
    "dcode": "D",
    "dropkey": "PX24950",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "8011 BROOKS CHAPEL RD",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 370279998,
    "dropphyadd": "8011 BROOKS CHAPEL RD",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 370279998,
    "dropmaladd": "8011 BROOKS CHAPEL RD",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 370279998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153773516,
    "dropsitcph": 6153773516,
    "dropfax": 6156616543
  },
  {
    "dcode": "D",
    "dropkey": "PX24951",
    "droptype": "D",
    "dropname": "BRICEVILLE",
    "dropdeladd": "1401 BRICEVILLE HWY",
    "dropdelcty": "BRICEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377109998,
    "dropphyadd": "1401 BRICEVILLE HWY",
    "dropphycty": "BRICEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377109998,
    "dropmaladd": "1401 BRICEVILLE HWY",
    "dropmalcty": "BRICEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654264115,
    "dropsitcph": 8654264115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24952",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "1600 OLD HIGHWAY 51 S",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "TN",
    "dropdelzpp": 380119998,
    "dropphyadd": "1600 OLD HIGHWAY 51 S",
    "dropphycty": "BRIGHTON",
    "dropphyst": "TN",
    "dropphyzpp": 380119998,
    "dropmaladd": "1600 OLD HIGHWAY 51 S",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "TN",
    "dropmalzpp": 380119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018377677,
    "dropsitcph": 9018377677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24953",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "111 6TH ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "TN",
    "dropdelzpp": 376219998,
    "dropphyadd": "111 6TH ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "TN",
    "dropphyzpp": 376219998,
    "dropmaladd": "111 6TH ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "TN",
    "dropmalzpp": 376219998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4232748010,
    "dropfax": 4236529162
  },
  {
    "dcode": "D",
    "dropkey": "PX24955",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "201 ANDERSON AVE",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380123257,
    "dropphyadd": "201 ANDERSON AVE",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380123257,
    "dropmaladd": "201 ANDERSON AVE",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380123257,
    "dropsitphn": 6158859336,
    "dropsitlph": 7317721182,
    "dropsitcph": 7317721182,
    "dropfax": 7317727869
  },
  {
    "dcode": "D",
    "dropkey": "PX24958",
    "droptype": "D",
    "dropname": "BRUCETON",
    "dropdeladd": "253 CHEATHAM ST",
    "dropdelcty": "BRUCETON",
    "dropdelst": "TN",
    "dropdelzpp": 383179998,
    "dropphyadd": "253 CHEATHAM ST",
    "dropphycty": "BRUCETON",
    "dropphyst": "TN",
    "dropphyzpp": 383179998,
    "dropmaladd": "253 CHEATHAM ST",
    "dropmalcty": "BRUCETON",
    "dropmalst": "TN",
    "dropmalzpp": 383179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315864412,
    "dropsitcph": 7315864412,
    "dropfax": 7315862238
  },
  {
    "dcode": "D",
    "dropkey": "PX24959",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "8756 CHAFFEE RD",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "TN",
    "dropdelzpp": 380148001,
    "dropphyadd": "8756 CHAFFEE RD",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "TN",
    "dropphyzpp": 380148001,
    "dropmaladd": "8756 CHAFFEE RD",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "TN",
    "dropmalzpp": 380148001,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013821972,
    "dropsitcph": 9013821972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24960",
    "droptype": "D",
    "dropname": "BRUSH CREEK",
    "dropdeladd": "407 ALEXANDRIA HWY",
    "dropdelcty": "BRUSH CREEK",
    "dropdelst": "TN",
    "dropdelzpp": 385479998,
    "dropphyadd": "407 ALEXANDRIA HWY",
    "dropphycty": "BRUSH CREEK",
    "dropphyst": "TN",
    "dropphyzpp": 385479998,
    "dropmaladd": "407 ALEXANDRIA HWY",
    "dropmalcty": "BRUSH CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 385479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156838582,
    "dropsitcph": 6156838582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24962",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "15 CLAYTONTOWN RD",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "TN",
    "dropdelzpp": 382229998,
    "dropphyadd": "15 CLAYTONTOWN RD",
    "dropphycty": "BUCHANAN",
    "dropphyst": "TN",
    "dropphyzpp": 382229998,
    "dropmaladd": "15 CLAYTONTOWN RD",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "TN",
    "dropmalzpp": 382229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316427622,
    "dropsitcph": 7316427622,
    "dropfax": 7316420312
  },
  {
    "dcode": "D",
    "dropkey": "PX24964",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "7240 BUENA VISTA RD",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "TN",
    "dropdelzpp": 383189998,
    "dropphyadd": "7240 BUENA VISTA RD",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "TN",
    "dropphyzpp": 383189998,
    "dropmaladd": "7240 BUENA VISTA RD",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "TN",
    "dropmalzpp": 383189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315867952,
    "dropsitcph": 7315867952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24965",
    "droptype": "D",
    "dropname": "BUFFALO VALLEY",
    "dropdeladd": "18545 BUFFALO VALLEY RD",
    "dropdelcty": "BUFFALO VALLEY",
    "dropdelst": "TN",
    "dropdelzpp": 385489998,
    "dropphyadd": "18545 BUFFALO VALLEY RD",
    "dropphycty": "BUFFALO VALLEY",
    "dropphyst": "TN",
    "dropphyzpp": 385489998,
    "dropmaladd": "18545 BUFFALO VALLEY RD",
    "dropmalcty": "BUFFALO VALLEY",
    "dropmalst": "TN",
    "dropmalzpp": 385489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318584812,
    "dropsitcph": 9318584812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24968",
    "droptype": "D",
    "dropname": "BULLS GAP",
    "dropdeladd": "410 HIGHWAY 11 E",
    "dropdelcty": "BULLS GAP",
    "dropdelst": "TN",
    "dropdelzpp": 377119998,
    "dropphyadd": "410 HIGHWAY 11 E",
    "dropphycty": "BULLS GAP",
    "dropphyst": "TN",
    "dropphyzpp": 377119998,
    "dropmaladd": "410 HIGHWAY 11 E",
    "dropmalcty": "BULLS GAP",
    "dropmalst": "TN",
    "dropmalzpp": 377119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232352100,
    "dropsitcph": 4232352100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24969",
    "droptype": "D",
    "dropname": "BUMPUS MILLS",
    "dropdeladd": "3035 HIGHWAY 120",
    "dropdelcty": "BUMPUS MILLS",
    "dropdelst": "TN",
    "dropdelzpp": 370289998,
    "dropphyadd": "3035 HIGHWAY 120",
    "dropphycty": "BUMPUS MILLS",
    "dropphyst": "TN",
    "dropphyzpp": 370289998,
    "dropmaladd": "3035 HIGHWAY 120",
    "dropmalcty": "BUMPUS MILLS",
    "dropmalst": "TN",
    "dropmalzpp": 370289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312328820,
    "dropsitcph": 9312328820,
    "dropfax": 9312328820
  },
  {
    "dcode": "D",
    "dropkey": "PX24972",
    "droptype": "D",
    "dropname": "BURLISON",
    "dropdeladd": "6379 HIGHWAY 59 W",
    "dropdelcty": "BURLISON",
    "dropdelst": "TN",
    "dropdelzpp": 380157496,
    "dropphyadd": "6379 HIGHWAY 59 W",
    "dropphycty": "BURLISON",
    "dropphyst": "TN",
    "dropphyzpp": 380157496,
    "dropmaladd": "6379 HIGHWAY 59 W",
    "dropmalcty": "BURLISON",
    "dropmalst": "TN",
    "dropmalzpp": 380157496,
    "dropsitphn": 6158859336,
    "dropsitlph": 9014763969,
    "dropsitcph": 9014763969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24973",
    "droptype": "D",
    "dropname": "BURNS",
    "dropdeladd": "2312 HIGHWAY 96",
    "dropdelcty": "BURNS",
    "dropdelst": "TN",
    "dropdelzpp": 370299998,
    "dropphyadd": "2312 HIGHWAY 96",
    "dropphycty": "BURNS",
    "dropphyst": "TN",
    "dropphyzpp": 370299998,
    "dropmaladd": "2312 HIGHWAY 96",
    "dropmalcty": "BURNS",
    "dropmalst": "TN",
    "dropmalzpp": 370299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154469029,
    "dropsitcph": 6154469029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24975",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "211 PIERCETOWN RD",
    "dropdelcty": "BUTLER",
    "dropdelst": "TN",
    "dropdelzpp": 376409998,
    "dropphyadd": "211 PIERCETOWN RD",
    "dropphycty": "BUTLER",
    "dropphyst": "TN",
    "dropphyzpp": 376409998,
    "dropmaladd": "211 PIERCETOWN RD",
    "dropmalcty": "BUTLER",
    "dropmalst": "TN",
    "dropmalzpp": 376409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237682376,
    "dropsitcph": 4237682376,
    "dropfax": 4237685285
  },
  {
    "dcode": "D",
    "dropkey": "PX24976",
    "droptype": "D",
    "dropname": "BYBEE",
    "dropdeladd": "1580 HIGHWAY 160",
    "dropdelcty": "BYBEE",
    "dropdelst": "TN",
    "dropdelzpp": 377139998,
    "dropphyadd": "1580 HIGHWAY 160",
    "dropphycty": "BYBEE",
    "dropphyst": "TN",
    "dropphyzpp": 377139998,
    "dropmaladd": "1580 HIGHWAY 160",
    "dropmalcty": "BYBEE",
    "dropmalst": "TN",
    "dropmalzpp": 377139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236235605,
    "dropsitcph": 4236235605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24977",
    "droptype": "D",
    "dropname": "BYRDSTOWN",
    "dropdeladd": "300 W MAIN ST",
    "dropdelcty": "BYRDSTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 385499998,
    "dropphyadd": "300 W MAIN ST",
    "dropphycty": "BYRDSTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 385499998,
    "dropmaladd": "300 W MAIN ST",
    "dropmalcty": "BYRDSTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 385499998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318643213,
    "dropsitcph": 9318643213,
    "dropfax": 9318647463
  },
  {
    "dcode": "D",
    "dropkey": "PX24978",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "748 HIGHWAY 163",
    "dropdelcty": "CALHOUN",
    "dropdelst": "TN",
    "dropdelzpp": 373099998,
    "dropphyadd": "748 HIGHWAY 163",
    "dropphycty": "CALHOUN",
    "dropphyst": "TN",
    "dropphyzpp": 373099998,
    "dropmaladd": "748 HIGHWAY 163",
    "dropmalcty": "CALHOUN",
    "dropmalst": "TN",
    "dropmalzpp": 373099998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233362331,
    "dropsitcph": 4233362331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24979",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "81 N FORREST AVE",
    "dropdelcty": "CAMDEN",
    "dropdelst": "TN",
    "dropdelzpp": 383209998,
    "dropphyadd": "81 N FORREST AVE",
    "dropphycty": "CAMDEN",
    "dropphyst": "TN",
    "dropphyzpp": 383209998,
    "dropmaladd": "81 N FORREST AVE",
    "dropmalcty": "CAMDEN",
    "dropmalst": "TN",
    "dropmalzpp": 383209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315847298,
    "dropsitcph": 7315847298,
    "dropfax": 7315845152
  },
  {
    "dcode": "D",
    "dropkey": "PX24980",
    "droptype": "D",
    "dropname": "CAMPAIGN",
    "dropdeladd": "379 PINE BLUFF RD",
    "dropdelcty": "CAMPAIGN",
    "dropdelst": "TN",
    "dropdelzpp": 385509998,
    "dropphyadd": "379 PINE BLUFF RD",
    "dropphycty": "CAMPAIGN",
    "dropphyst": "TN",
    "dropphyzpp": 385509998,
    "dropmaladd": "379 PINE BLUFF RD",
    "dropmalcty": "CAMPAIGN",
    "dropmalst": "TN",
    "dropmalzpp": 385509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316862139,
    "dropsitcph": 9316862139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24982",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "115 MAIN ST N FRNT",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "TN",
    "dropdelzpp": 370309998,
    "dropphyadd": "115 MAIN ST N FRNT",
    "dropphycty": "CARTHAGE",
    "dropphyst": "TN",
    "dropphyzpp": 370309998,
    "dropmaladd": "115 MAIN ST N FRNT",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "TN",
    "dropmalzpp": 370309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157352835,
    "dropsitcph": 6157350333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24983",
    "droptype": "D",
    "dropname": "CARYVILLE",
    "dropdeladd": "107 HILL LN",
    "dropdelcty": "CARYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377149998,
    "dropphyadd": "107 HILL LN",
    "dropphycty": "CARYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377149998,
    "dropmaladd": "107 HILL LN",
    "dropmalcty": "CARYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377149998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235623243,
    "dropsitcph": 4235623243,
    "dropfax": 4235666418
  },
  {
    "dcode": "D",
    "dropkey": "PX24985",
    "droptype": "D",
    "dropname": "CASTALIAN SPRINGS",
    "dropdeladd": "3070 HARTSVILLE PIKE",
    "dropdelcty": "CASTALIAN SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 370319998,
    "dropphyadd": "3070 HARTSVILLE PIKE",
    "dropphycty": "CASTALIAN SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 370319998,
    "dropmaladd": "3070 HARTSVILLE PIKE",
    "dropmalcty": "CASTALIAN SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 370319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154521162,
    "dropsitcph": 6154521162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24986",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "3490 HIGHWAY 70",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "TN",
    "dropdelzpp": 383219998,
    "dropphyadd": "3490 HIGHWAY 70",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "TN",
    "dropphyzpp": 383219998,
    "dropmaladd": "3490 HIGHWAY 70",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "TN",
    "dropmalzpp": 383219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319872423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24988",
    "droptype": "D",
    "dropname": "CEDAR HILL",
    "dropdeladd": "104 S MAIN ST",
    "dropdelcty": "CEDAR HILL",
    "dropdelst": "TN",
    "dropdelzpp": 370329998,
    "dropphyadd": "104 S MAIN ST",
    "dropphycty": "CEDAR HILL",
    "dropphyst": "TN",
    "dropphyzpp": 370329998,
    "dropmaladd": "104 S MAIN ST",
    "dropmalcty": "CEDAR HILL",
    "dropmalst": "TN",
    "dropmalzpp": 370329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156962000,
    "dropsitcph": 6156962000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24990",
    "droptype": "D",
    "dropname": "CELINA",
    "dropdeladd": "403 BROWN ST",
    "dropdelcty": "CELINA",
    "dropdelst": "TN",
    "dropdelzpp": 385519998,
    "dropphyadd": "403 BROWN ST",
    "dropphycty": "CELINA",
    "dropphyst": "TN",
    "dropphyzpp": 385519998,
    "dropmaladd": "403 BROWN ST",
    "dropmalcty": "CELINA",
    "dropmalst": "TN",
    "dropmalzpp": 385519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312432420,
    "dropsitcph": 9312432420,
    "dropfax": 9312433474
  },
  {
    "dcode": "D",
    "dropkey": "PX24991",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "100 BROWN JCT",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370339998,
    "dropphyadd": "100 BROWN JCT",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370339998,
    "dropmaladd": "100 BROWN JCT",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370339998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317292578,
    "dropsitcph": 9317292578,
    "dropfax": 9317290451
  },
  {
    "dcode": "D",
    "dropkey": "PX24994",
    "droptype": "D",
    "dropname": "CHAPEL HILL",
    "dropdeladd": "4680 NASHVILLE HWY",
    "dropdelcty": "CHAPEL HILL",
    "dropdelst": "TN",
    "dropdelzpp": 370349997,
    "dropphyadd": "4680 NASHVILLE HWY",
    "dropphycty": "CHAPEL HILL",
    "dropphyst": "TN",
    "dropphyzpp": 370349997,
    "dropmaladd": "4680 NASHVILLE HWY",
    "dropmalcty": "CHAPEL HILL",
    "dropmalst": "TN",
    "dropmalzpp": 370349997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313642681,
    "dropsitcph": 9313642681,
    "dropfax": 9313644111
  },
  {
    "dcode": "D",
    "dropkey": "PX24996",
    "droptype": "D",
    "dropname": "CHAPMANSBORO",
    "dropdeladd": "2900 HIGHWAY 12 N",
    "dropdelcty": "CHAPMANSBORO",
    "dropdelst": "TN",
    "dropdelzpp": 370359998,
    "dropphyadd": "2900 HIGHWAY 12 N",
    "dropphycty": "CHAPMANSBORO",
    "dropphyst": "TN",
    "dropphyzpp": 370359998,
    "dropmaladd": "2900 HIGHWAY 12 N",
    "dropmalcty": "CHAPMANSBORO",
    "dropmalst": "TN",
    "dropmalzpp": 370359998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157925237,
    "dropsitcph": 6157925237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX24998",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "8916 HIWASSEE ST NE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "TN",
    "dropdelzpp": 373109998,
    "dropphyadd": "8916 HIWASSEE ST NE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "TN",
    "dropphyzpp": 373109998,
    "dropmaladd": "8916 HIWASSEE ST NE",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "TN",
    "dropmalzpp": 373109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233363491,
    "dropsitcph": 4233363491,
    "dropfax": 4233363139
  },
  {
    "dcode": "D",
    "dropkey": "PX24999",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "7 COURT SQ",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "TN",
    "dropdelzpp": 370369998,
    "dropphyadd": "7 COURT SQ",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "TN",
    "dropphyzpp": 370369998,
    "dropmaladd": "7 COURT SQ",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "TN",
    "dropmalzpp": 370369998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157895350,
    "dropsitcph": 6157895350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25003",
    "droptype": "D",
    "dropname": "CHATTANOOGA",
    "dropdeladd": "6050 SHALLOWFORD RD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374219998,
    "dropphyadd": "6050 SHALLOWFORD RD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374219998,
    "dropmaladd": "6050 SHALLOWFORD RD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374219998,
    "dropsitphn": 4234998342,
    "dropsitlph": 4234998351,
    "dropsitcph": 4234998351,
    "dropfax": 4238999565
  },
  {
    "dcode": "D",
    "dropkey": "PX25005",
    "droptype": "D",
    "dropname": "CHESTNUT MOUND",
    "dropdeladd": "892 COOKEVILLE HWY",
    "dropdelcty": "CHESTNUT MOUND",
    "dropdelst": "TN",
    "dropdelzpp": 385529998,
    "dropphyadd": "892 COOKEVILLE HWY",
    "dropphycty": "CHESTNUT MOUND",
    "dropphyst": "TN",
    "dropphyzpp": 385529998,
    "dropmaladd": "892 COOKEVILLE HWY",
    "dropmalcty": "CHESTNUT MOUND",
    "dropmalst": "TN",
    "dropmalzpp": 385529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158972677,
    "dropsitcph": 6158972677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25006",
    "droptype": "D",
    "dropname": "CHEWALLA",
    "dropdeladd": "218 WENASOGA RD",
    "dropdelcty": "CHEWALLA",
    "dropdelst": "TN",
    "dropdelzpp": 383939998,
    "dropphyadd": "218 WENASOGA RD",
    "dropphycty": "CHEWALLA",
    "dropphyst": "TN",
    "dropphyzpp": 383939998,
    "dropmaladd": "218 WENASOGA RD",
    "dropmalcty": "CHEWALLA",
    "dropmalst": "TN",
    "dropmalzpp": 383939998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312395715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25009",
    "droptype": "D",
    "dropname": "CHRISTIANA",
    "dropdeladd": "1091 CHURCH ST",
    "dropdelcty": "CHRISTIANA",
    "dropdelst": "TN",
    "dropdelzpp": 370379998,
    "dropphyadd": "1091 CHURCH ST",
    "dropphycty": "CHRISTIANA",
    "dropphyst": "TN",
    "dropphyzpp": 370379998,
    "dropmaladd": "1091 CHURCH ST",
    "dropmalcty": "CHRISTIANA",
    "dropmalst": "TN",
    "dropmalzpp": 370379998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158931641,
    "dropsitcph": 6158931641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25010",
    "droptype": "D",
    "dropname": "CHUCKEY",
    "dropdeladd": "8140 E ANDREW JOHNSON HWY",
    "dropdelcty": "CHUCKEY",
    "dropdelst": "TN",
    "dropdelzpp": 376419998,
    "dropphyadd": "8140 E ANDREW JOHNSON HWY",
    "dropphycty": "CHUCKEY",
    "dropphyst": "TN",
    "dropphyzpp": 376419998,
    "dropmaladd": "8140 E ANDREW JOHNSON HWY",
    "dropmalcty": "CHUCKEY",
    "dropmalst": "TN",
    "dropmalzpp": 376419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232575325,
    "dropsitcph": 4232575325,
    "dropfax": 4232576555
  },
  {
    "dcode": "D",
    "dropkey": "PX25012",
    "droptype": "D",
    "dropname": "CHURCH HILL",
    "dropdeladd": "131 E MAIN BLVD",
    "dropdelcty": "CHURCH HILL",
    "dropdelst": "TN",
    "dropdelzpp": 376429998,
    "dropphyadd": "131 E MAIN BLVD",
    "dropphycty": "CHURCH HILL",
    "dropphyst": "TN",
    "dropphyzpp": 376429998,
    "dropmaladd": "131 E MAIN BLVD",
    "dropmalcty": "CHURCH HILL",
    "dropmalst": "TN",
    "dropmalzpp": 376429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233575239,
    "dropsitcph": 4233575239,
    "dropfax": 4233578595
  },
  {
    "dcode": "D",
    "dropkey": "PX25013",
    "droptype": "D",
    "dropname": "CLAIRFIELD",
    "dropdeladd": "5671 HIGHWAY 90",
    "dropdelcty": "CLAIRFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 377159998,
    "dropphyadd": "5671 HIGHWAY 90",
    "dropphycty": "CLAIRFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 377159998,
    "dropmaladd": "5671 HIGHWAY 90",
    "dropmalcty": "CLAIRFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 377159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237846773,
    "dropsitcph": 4237846773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25014",
    "droptype": "D",
    "dropname": "CLARKRANGE",
    "dropdeladd": "1105 CLARKRANGE MONTEREY HWY",
    "dropdelcty": "CLARKRANGE",
    "dropdelst": "TN",
    "dropdelzpp": 385539998,
    "dropphyadd": "1105 CLARKRANGE MONTEREY HWY",
    "dropphycty": "CLARKRANGE",
    "dropphyst": "TN",
    "dropphyzpp": 385539998,
    "dropmaladd": "1105 CLARKRANGE MONTEREY HWY",
    "dropmalcty": "CLARKRANGE",
    "dropmalst": "TN",
    "dropmalzpp": 385539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318633575,
    "dropsitcph": 9318633575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25016",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "3535 HIGHWAY 22",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "TN",
    "dropdelzpp": 383249998,
    "dropphyadd": "3535 HIGHWAY 22",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "TN",
    "dropphyzpp": 383249998,
    "dropmaladd": "3535 HIGHWAY 22",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "TN",
    "dropmalzpp": 383249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319863461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25017",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "2031 WILMA RUDOLPH BLVD",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370409998,
    "dropphyadd": "2031 WILMA RUDOLPH BLVD",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370409998,
    "dropmaladd": "2031 WILMA RUDOLPH BLVD",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319050927,
    "dropsitcph": 9319050927,
    "dropfax": 9319065693
  },
  {
    "dcode": "D",
    "dropkey": "PX25020",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "1981 KEITH ST NW",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "TN",
    "dropdelzpp": 373119998,
    "dropphyadd": "1981 KEITH ST NW",
    "dropphycty": "CLEVELAND",
    "dropphyst": "TN",
    "dropphyzpp": 373119998,
    "dropmaladd": "1981 KEITH ST NW",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "TN",
    "dropmalzpp": 373119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234739272,
    "dropsitcph": 4236145280,
    "dropfax": 4234727473
  },
  {
    "dcode": "D",
    "dropkey": "PX25024",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "CLIFTON",
    "dropdelst": "TN",
    "dropdelzpp": 384259998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "CLIFTON",
    "dropphyst": "TN",
    "dropphyzpp": 384259998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "CLIFTON",
    "dropmalst": "TN",
    "dropmalzpp": 384259998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316763417,
    "dropsitcph": 9316763417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25025",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "1121 N CHARLES G SEIVERS BLVD",
    "dropdelcty": "CLINTON",
    "dropdelst": "TN",
    "dropdelzpp": 377169998,
    "dropphyadd": "1121 N CHARLES G SEIVERS BLVD",
    "dropphycty": "CLINTON",
    "dropphyst": "TN",
    "dropphyzpp": 377169998,
    "dropmaladd": "1121 N CHARLES G SEIVERS BLVD",
    "dropmalcty": "CLINTON",
    "dropmalst": "TN",
    "dropmalzpp": 377169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654574915,
    "dropsitcph": 8654638601,
    "dropfax": 8654638213
  },
  {
    "dcode": "D",
    "dropkey": "PX25027",
    "droptype": "D",
    "dropname": "COALFIELD",
    "dropdeladd": "5707 KNOXVILLE HWY",
    "dropdelcty": "COALFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 377199998,
    "dropphyadd": "5707 KNOXVILLE HWY",
    "dropphycty": "COALFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 377199998,
    "dropmaladd": "5707 KNOXVILLE HWY",
    "dropmalcty": "COALFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 377199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654351293,
    "dropsitcph": 8654351293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25028",
    "droptype": "D",
    "dropname": "COALMONT",
    "dropdeladd": "655 HEIDENBURG ST",
    "dropdelcty": "COALMONT",
    "dropdelst": "TN",
    "dropdelzpp": 373139998,
    "dropphyadd": "655 HEIDENBURG ST",
    "dropphycty": "COALMONT",
    "dropphyst": "TN",
    "dropphyzpp": 373139998,
    "dropmaladd": "655 HEIDENBURG ST",
    "dropmalcty": "COALMONT",
    "dropmalst": "TN",
    "dropmalzpp": 373139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315929439,
    "dropsitcph": 9315929439,
    "dropfax": 9315922139
  },
  {
    "dcode": "D",
    "dropkey": "PX25032",
    "droptype": "D",
    "dropname": "COLLEGE GROVE",
    "dropdeladd": "8776 HORTON HWY",
    "dropdelcty": "COLLEGE GROVE",
    "dropdelst": "TN",
    "dropdelzpp": 370469998,
    "dropphyadd": "8776 HORTON HWY",
    "dropphycty": "COLLEGE GROVE",
    "dropphyst": "TN",
    "dropphyzpp": 370469998,
    "dropmaladd": "8776 HORTON HWY",
    "dropmalcty": "COLLEGE GROVE",
    "dropmalst": "TN",
    "dropmalzpp": 370469998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153687635,
    "dropsitcph": 6153687635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25034",
    "droptype": "D",
    "dropname": "COLLEGEDALE",
    "dropdeladd": "5006 UNIVERSITY DR W",
    "dropdelcty": "COLLEGEDALE",
    "dropdelst": "TN",
    "dropdelzpp": 373159998,
    "dropphyadd": "5006 UNIVERSITY DR W",
    "dropphycty": "COLLEGEDALE",
    "dropphyst": "TN",
    "dropphyzpp": 373159998,
    "dropmaladd": "5006 UNIVERSITY DR W",
    "dropmalcty": "COLLEGEDALE",
    "dropmalst": "TN",
    "dropmalzpp": 373159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233969165,
    "dropsitcph": 4233969498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25036",
    "droptype": "D",
    "dropname": "COLLIERVILLE",
    "dropdeladd": "131 S CENTER ST",
    "dropdelcty": "COLLIERVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380179998,
    "dropphyadd": "131 S CENTER ST",
    "dropphycty": "COLLIERVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380179998,
    "dropmaladd": "131 S CENTER ST",
    "dropmalcty": "COLLIERVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018534843,
    "dropsitcph": 9018530994,
    "dropfax": 9018534944
  },
  {
    "dcode": "D",
    "dropkey": "PX25039",
    "droptype": "D",
    "dropname": "COLLINWOOD",
    "dropdeladd": "101 4TH AVE S",
    "dropdelcty": "COLLINWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 384509998,
    "dropphyadd": "101 4TH AVE S",
    "dropphycty": "COLLINWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 384509998,
    "dropmaladd": "101 4TH AVE S",
    "dropmalcty": "COLLINWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 384509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317249128,
    "dropsitcph": 9317249128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25043",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "417 W 7TH ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "TN",
    "dropdelzpp": 384019998,
    "dropphyadd": "417 W 7TH ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "TN",
    "dropphyzpp": 384019998,
    "dropmaladd": "417 W 7TH ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "TN",
    "dropmalzpp": 384019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313817150,
    "dropsitcph": 9313886161,
    "dropfax": 9313812997
  },
  {
    "dcode": "D",
    "dropkey": "PX25044",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "10506 HIGHWAY 54",
    "dropdelcty": "COMO",
    "dropdelst": "TN",
    "dropdelzpp": 382239998,
    "dropphyadd": "10506 HIGHWAY 54",
    "dropphycty": "COMO",
    "dropphyst": "TN",
    "dropphyzpp": 382239998,
    "dropmaladd": "10506 HIGHWAY 54",
    "dropmalcty": "COMO",
    "dropmalst": "TN",
    "dropmalzpp": 382239998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7316442363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25050",
    "droptype": "D",
    "dropname": "COOKEVILLE",
    "dropdeladd": "900 S WILLOW AVE",
    "dropdelcty": "COOKEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385019998,
    "dropphyadd": "900 S WILLOW AVE",
    "dropphycty": "COOKEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385019998,
    "dropmaladd": "900 S WILLOW AVE",
    "dropmalcty": "COOKEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315262107,
    "dropsitcph": 9315267141,
    "dropfax": 9315262316
  },
  {
    "dcode": "D",
    "dropkey": "PX25054",
    "droptype": "D",
    "dropname": "COPPERHILL",
    "dropdeladd": "145 OCOEE ST",
    "dropdelcty": "COPPERHILL",
    "dropdelst": "TN",
    "dropdelzpp": 373174074,
    "dropphyadd": "145 OCOEE ST",
    "dropphycty": "COPPERHILL",
    "dropphyst": "TN",
    "dropphyzpp": 373174074,
    "dropmaladd": "145 OCOEE ST",
    "dropmalcty": "COPPERHILL",
    "dropmalst": "TN",
    "dropmalzpp": 373174074,
    "dropsitphn": 4234967712,
    "dropsitlph": 4234967712,
    "dropsitcph": 4234967712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25055",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "8255 MACON RD",
    "dropdelcty": "CORDOVA",
    "dropdelst": "TN",
    "dropdelzpp": 380189998,
    "dropphyadd": "8255 MACON RD",
    "dropphycty": "CORDOVA",
    "dropphyst": "TN",
    "dropphyzpp": 380189998,
    "dropmaladd": "8255 MACON RD",
    "dropmalcty": "CORDOVA",
    "dropmalst": "TN",
    "dropmalzpp": 380189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017554031,
    "dropsitcph": 9017542348,
    "dropfax": 9017525758
  },
  {
    "dcode": "D",
    "dropkey": "PX25056",
    "droptype": "D",
    "dropname": "CORNERSVILLE",
    "dropdeladd": "501 N MAIN ST",
    "dropdelcty": "CORNERSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370479998,
    "dropphyadd": "501 N MAIN ST",
    "dropphycty": "CORNERSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370479998,
    "dropmaladd": "501 N MAIN ST",
    "dropmalcty": "CORNERSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312932321,
    "dropsitcph": 9312932321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25059",
    "droptype": "D",
    "dropname": "CORRYTON",
    "dropdeladd": "7713 CORRYTON RD",
    "dropdelcty": "CORRYTON",
    "dropdelst": "TN",
    "dropdelzpp": 377219998,
    "dropphyadd": "7713 CORRYTON RD",
    "dropphycty": "CORRYTON",
    "dropphyst": "TN",
    "dropphyzpp": 377219998,
    "dropmaladd": "7713 CORRYTON RD",
    "dropmalcty": "CORRYTON",
    "dropmalst": "TN",
    "dropmalzpp": 377219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8656873652,
    "dropsitcph": 8656873652,
    "dropfax": 8656893535
  },
  {
    "dcode": "D",
    "dropkey": "PX25060",
    "droptype": "D",
    "dropname": "COSBY",
    "dropdeladd": "4402 HOOPER HWY",
    "dropdelcty": "COSBY",
    "dropdelst": "TN",
    "dropdelzpp": 377229998,
    "dropphyadd": "4402 HOOPER HWY",
    "dropphycty": "COSBY",
    "dropphyst": "TN",
    "dropphyzpp": 377229998,
    "dropmaladd": "4402 HOOPER HWY",
    "dropmalcty": "COSBY",
    "dropmalst": "TN",
    "dropmalzpp": 377229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234872421,
    "dropsitcph": 4234872421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25061",
    "droptype": "D",
    "dropname": "COTTAGE GROVE",
    "dropdeladd": "7100 MAIN ST",
    "dropdelcty": "COTTAGE GROVE",
    "dropdelst": "TN",
    "dropdelzpp": 382249998,
    "dropphyadd": "7100 MAIN ST",
    "dropphycty": "COTTAGE GROVE",
    "dropphyst": "TN",
    "dropphyzpp": 382249998,
    "dropmaladd": "7100 MAIN ST",
    "dropmalcty": "COTTAGE GROVE",
    "dropmalst": "TN",
    "dropmalzpp": 382249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7317823581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25063",
    "droptype": "D",
    "dropname": "COTTONTOWN",
    "dropdeladd": "2401 HIGHWAY 25",
    "dropdelcty": "COTTONTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 370489998,
    "dropphyadd": "2401 HIGHWAY 25",
    "dropphycty": "COTTONTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 370489998,
    "dropmaladd": "2401 HIGHWAY 25",
    "dropmalcty": "COTTONTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 370489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154525213,
    "dropsitcph": 6154525213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25064",
    "droptype": "D",
    "dropname": "COUNCE",
    "dropdeladd": "7095 HIGHWAY 57",
    "dropdelcty": "COUNCE",
    "dropdelst": "TN",
    "dropdelzpp": 383269998,
    "dropphyadd": "7095 HIGHWAY 57",
    "dropphycty": "COUNCE",
    "dropphyst": "TN",
    "dropphyzpp": 383269998,
    "dropmaladd": "7095 HIGHWAY 57",
    "dropmalcty": "COUNCE",
    "dropmalst": "TN",
    "dropmalzpp": 383269998,
    "dropsitphn": 6158859201,
    "dropsitlph": 7312448031,
    "dropsitcph": 7312448033,
    "dropfax": 7312448032
  },
  {
    "dcode": "D",
    "dropkey": "PX25066",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "220 S MAIN ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 380199998,
    "dropphyadd": "220 S MAIN ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 380199998,
    "dropmaladd": "220 S MAIN ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 380199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9014763375,
    "dropsitcph": 9014762413,
    "dropfax": 9014761378
  },
  {
    "dcode": "D",
    "dropkey": "PX25068",
    "droptype": "D",
    "dropname": "COWAN",
    "dropdeladd": "211 CUMBERLAND ST E",
    "dropdelcty": "COWAN",
    "dropdelst": "TN",
    "dropdelzpp": 373189998,
    "dropphyadd": "211 CUMBERLAND ST E",
    "dropphycty": "COWAN",
    "dropphyst": "TN",
    "dropphyzpp": 373189998,
    "dropmaladd": "211 CUMBERLAND ST E",
    "dropmalcty": "COWAN",
    "dropmalst": "TN",
    "dropmalzpp": 373189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319677775,
    "dropsitcph": 9319677775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25069",
    "droptype": "D",
    "dropname": "CRAB ORCHARD",
    "dropdeladd": "154 MAIN ST",
    "dropdelcty": "CRAB ORCHARD",
    "dropdelst": "TN",
    "dropdelzpp": 377239998,
    "dropphyadd": "154 MAIN ST",
    "dropphycty": "CRAB ORCHARD",
    "dropphyst": "TN",
    "dropphyzpp": 377239998,
    "dropmaladd": "154 MAIN ST",
    "dropmalcty": "CRAB ORCHARD",
    "dropmalst": "TN",
    "dropmalzpp": 377239998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314849418,
    "dropsitcph": 9314849418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25070",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "202 HONEY SPRINGS RD",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "TN",
    "dropdelzpp": 385549998,
    "dropphyadd": "202 HONEY SPRINGS RD",
    "dropphycty": "CRAWFORD",
    "dropphyst": "TN",
    "dropphyzpp": 385549998,
    "dropmaladd": "202 HONEY SPRINGS RD",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "TN",
    "dropmalzpp": 385549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314453004,
    "dropsitcph": 9314453004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25072",
    "droptype": "D",
    "dropname": "CROCKETT MILLS",
    "dropdeladd": "28 JACKSON STORE RD",
    "dropdelcty": "CROCKETT MILLS",
    "dropdelst": "TN",
    "dropdelzpp": 380219998,
    "dropphyadd": "28 JACKSON STORE RD",
    "dropphycty": "CROCKETT MILLS",
    "dropphyst": "TN",
    "dropphyzpp": 380219998,
    "dropmaladd": "28 JACKSON STORE RD",
    "dropmalcty": "CROCKETT MILLS",
    "dropmalst": "TN",
    "dropmalzpp": 380219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9016772452,
    "dropsitcph": 7316772452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25074",
    "droptype": "D",
    "dropname": "CROSS PLAINS",
    "dropdeladd": "7780 HIGHWAY 25 E",
    "dropdelcty": "CROSS PLAINS",
    "dropdelst": "TN",
    "dropdelzpp": 370499998,
    "dropphyadd": "7780 HIGHWAY 25 E",
    "dropphycty": "CROSS PLAINS",
    "dropphyst": "TN",
    "dropphyzpp": 370499998,
    "dropmaladd": "7780 HIGHWAY 25 E",
    "dropmalcty": "CROSS PLAINS",
    "dropmalst": "TN",
    "dropmalzpp": 370499998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156542134,
    "dropsitcph": 6156542134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25079",
    "droptype": "D",
    "dropname": "CROSSVILLE",
    "dropdeladd": "240 OLD JAMESTOWN HWY",
    "dropdelcty": "CROSSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385559998,
    "dropphyadd": "240 OLD JAMESTOWN HWY",
    "dropphycty": "CROSSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385559998,
    "dropmaladd": "240 OLD JAMESTOWN HWY",
    "dropmalcty": "CROSSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314844885,
    "dropsitcph": 9314569610,
    "dropfax": 9314563658
  },
  {
    "dcode": "D",
    "dropkey": "PX25082",
    "droptype": "D",
    "dropname": "CRUMP",
    "dropdeladd": "3170 US HIGHWAY 64",
    "dropdelcty": "CRUMP",
    "dropdelst": "TN",
    "dropdelzpp": 383279998,
    "dropphyadd": "3170 US HIGHWAY 64",
    "dropphycty": "CRUMP",
    "dropphyst": "TN",
    "dropphyzpp": 383279998,
    "dropmaladd": "3170 US HIGHWAY 64",
    "dropmalcty": "CRUMP",
    "dropmalst": "TN",
    "dropmalzpp": 383279998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316321140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25084",
    "droptype": "D",
    "dropname": "CULLEOKA",
    "dropdeladd": "2349 CULLEOKA HWY",
    "dropdelcty": "CULLEOKA",
    "dropdelst": "TN",
    "dropdelzpp": 384519998,
    "dropphyadd": "2349 CULLEOKA HWY",
    "dropphycty": "CULLEOKA",
    "dropphyst": "TN",
    "dropphyzpp": 384519998,
    "dropmaladd": "2349 CULLEOKA HWY",
    "dropmalcty": "CULLEOKA",
    "dropmalst": "TN",
    "dropmalzpp": 384519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319872286,
    "dropsitcph": 9319872286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25085",
    "droptype": "D",
    "dropname": "CUMBERLAND CITY",
    "dropdeladd": "201 BASS AVE",
    "dropdelcty": "CUMBERLAND CITY",
    "dropdelst": "TN",
    "dropdelzpp": 370509998,
    "dropphyadd": "201 BASS AVE",
    "dropphycty": "CUMBERLAND CITY",
    "dropphyst": "TN",
    "dropphyzpp": 370509998,
    "dropmaladd": "201 BASS AVE",
    "dropmalcty": "CUMBERLAND CITY",
    "dropmalst": "TN",
    "dropmalzpp": 370509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318272648,
    "dropsitcph": 9318272648,
    "dropfax": 9318272537
  },
  {
    "dcode": "D",
    "dropkey": "PX25088",
    "droptype": "D",
    "dropname": "CUMBERLAND FURNACE",
    "dropdeladd": "2985 NEW DRY HOLLOW RD",
    "dropdelcty": "CUMBERLAND FURNACE",
    "dropdelst": "TN",
    "dropdelzpp": 370519998,
    "dropphyadd": "2985 NEW DRY HOLLOW RD",
    "dropphycty": "CUMBERLAND FURNACE",
    "dropphyst": "TN",
    "dropphyzpp": 370519998,
    "dropmaladd": "2985 NEW DRY HOLLOW RD",
    "dropmalcty": "CUMBERLAND FURNACE",
    "dropmalst": "TN",
    "dropmalzpp": 370519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157894305,
    "dropsitcph": 6157894305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25089",
    "droptype": "D",
    "dropname": "CUMBERLAND GAP",
    "dropdeladd": "530 COLWYN AVE",
    "dropdelcty": "CUMBERLAND GAP",
    "dropdelst": "TN",
    "dropdelzpp": 377249998,
    "dropphyadd": "530 COLWYN AVE",
    "dropphycty": "CUMBERLAND GAP",
    "dropphyst": "TN",
    "dropphyzpp": 377249998,
    "dropmaladd": "530 COLWYN AVE",
    "dropmalcty": "CUMBERLAND GAP",
    "dropmalst": "TN",
    "dropmalzpp": 377249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238694238,
    "dropsitcph": 4238694238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25090",
    "droptype": "D",
    "dropname": "CUNNINGHAM",
    "dropdeladd": "160 HIGHWAY 13",
    "dropdelcty": "CUNNINGHAM",
    "dropdelst": "TN",
    "dropdelzpp": 370529998,
    "dropphyadd": "160 HIGHWAY 13",
    "dropphycty": "CUNNINGHAM",
    "dropphyst": "TN",
    "dropphyzpp": 370529998,
    "dropmaladd": "160 HIGHWAY 13",
    "dropmalcty": "CUNNINGHAM",
    "dropmalst": "TN",
    "dropmalzpp": 370529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153872052,
    "dropsitcph": 9313872052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25091",
    "droptype": "D",
    "dropname": "CYPRESS INN",
    "dropdeladd": "2825 BIG CYPRESS RD",
    "dropdelcty": "CYPRESS INN",
    "dropdelst": "TN",
    "dropdelzpp": 384529998,
    "dropphyadd": "2825 BIG CYPRESS RD",
    "dropphycty": "CYPRESS INN",
    "dropphyst": "TN",
    "dropphyzpp": 384529998,
    "dropmaladd": "2825 BIG CYPRESS RD",
    "dropmalcty": "CYPRESS INN",
    "dropmalst": "TN",
    "dropmalzpp": 384529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317244951,
    "dropsitcph": 9317244951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25092",
    "droptype": "D",
    "dropname": "DANDRIDGE",
    "dropdeladd": "1130 ACADEMY CIR",
    "dropdelcty": "DANDRIDGE",
    "dropdelst": "TN",
    "dropdelzpp": 377259998,
    "dropphyadd": "1130 ACADEMY CIR",
    "dropphycty": "DANDRIDGE",
    "dropphyst": "TN",
    "dropphyzpp": 377259998,
    "dropmaladd": "1130 ACADEMY CIR",
    "dropmalcty": "DANDRIDGE",
    "dropmalst": "TN",
    "dropmalzpp": 377259998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8653973176,
    "dropsitcph": 8653972150,
    "dropfax": 8653974877
  },
  {
    "dcode": "D",
    "dropkey": "PX25094",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "426 1ST AVE",
    "dropdelcty": "DAYTON",
    "dropdelst": "TN",
    "dropdelzpp": 373219998,
    "dropphyadd": "426 1ST AVE",
    "dropphycty": "DAYTON",
    "dropphyst": "TN",
    "dropphyzpp": 373219998,
    "dropmaladd": "426 1ST AVE",
    "dropmalcty": "DAYTON",
    "dropmalst": "TN",
    "dropmalzpp": 373219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235707295,
    "dropsitcph": 4235707265,
    "dropfax": 4237750061
  },
  {
    "dcode": "D",
    "dropkey": "PX25095",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "200 RIVER RD",
    "dropdelcty": "DECATUR",
    "dropdelst": "TN",
    "dropdelzpp": 373229998,
    "dropphyadd": "200 RIVER RD",
    "dropphycty": "DECATUR",
    "dropphyst": "TN",
    "dropphyzpp": 373229998,
    "dropmaladd": "200 RIVER RD",
    "dropmalcty": "DECATUR",
    "dropmalst": "TN",
    "dropmalzpp": 373229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233341369,
    "dropsitcph": 4233341369,
    "dropfax": 4233342669
  },
  {
    "dcode": "D",
    "dropkey": "PX25096",
    "droptype": "D",
    "dropname": "DECATURVILLE",
    "dropdeladd": "225 W MAIN ST",
    "dropdelcty": "DECATURVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383299998,
    "dropphyadd": "225 W MAIN ST",
    "dropphycty": "DECATURVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383299998,
    "dropmaladd": "225 W MAIN ST",
    "dropmalcty": "DECATURVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7318524517,
    "dropfax": 7318522402
  },
  {
    "dcode": "D",
    "dropkey": "PX25099",
    "droptype": "D",
    "dropname": "DECHERD",
    "dropdeladd": "305 E MAIN ST",
    "dropdelcty": "DECHERD",
    "dropdelst": "TN",
    "dropdelzpp": 373249998,
    "dropphyadd": "305 E MAIN ST",
    "dropphycty": "DECHERD",
    "dropphyst": "TN",
    "dropphyzpp": 373249998,
    "dropmaladd": "305 E MAIN ST",
    "dropmalcty": "DECHERD",
    "dropmalst": "TN",
    "dropmalzpp": 373249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319679410,
    "dropsitcph": 9319679289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25100",
    "droptype": "D",
    "dropname": "DEER LODGE",
    "dropdeladd": "2211 DEER LODGE HWY",
    "dropdelcty": "DEER LODGE",
    "dropdelst": "TN",
    "dropdelzpp": 377269998,
    "dropphyadd": "2211 DEER LODGE HWY",
    "dropphycty": "DEER LODGE",
    "dropphyst": "TN",
    "dropphyzpp": 377269998,
    "dropmaladd": "2211 DEER LODGE HWY",
    "dropmalcty": "DEER LODGE",
    "dropmalst": "TN",
    "dropmalzpp": 377269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239653575,
    "dropsitcph": 4239653575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25103",
    "droptype": "D",
    "dropname": "DEL RIO",
    "dropdeladd": "3105 HIGHWAY 25 70 E",
    "dropdelcty": "DEL RIO",
    "dropdelst": "TN",
    "dropdelzpp": 377279998,
    "dropphyadd": "3105 HIGHWAY 25 70 E",
    "dropphycty": "DEL RIO",
    "dropphyst": "TN",
    "dropphyzpp": 377279998,
    "dropmaladd": "3105 HIGHWAY 25 70 E",
    "dropmalcty": "DEL RIO",
    "dropmalst": "TN",
    "dropmalzpp": 377279998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236236082,
    "dropsitcph": 4236236082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25104",
    "droptype": "D",
    "dropname": "DELANO",
    "dropdeladd": "9673 HIGHWAY 411",
    "dropdelcty": "DELANO",
    "dropdelst": "TN",
    "dropdelzpp": 373259998,
    "dropphyadd": "9673 HIGHWAY 411",
    "dropphycty": "DELANO",
    "dropphyst": "TN",
    "dropphyzpp": 373259998,
    "dropmaladd": "9673 HIGHWAY 411",
    "dropmalcty": "DELANO",
    "dropmalst": "TN",
    "dropmalzpp": 373259998,
    "dropsitphn": 4232637282,
    "dropsitlph": 4232637282,
    "dropsitcph": 4232637282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25106",
    "droptype": "D",
    "dropname": "DENMARK",
    "dropdeladd": "2799 DENMARK JACKSON RD",
    "dropdelcty": "DENMARK",
    "dropdelst": "TN",
    "dropdelzpp": 383919998,
    "dropphyadd": "2799 DENMARK JACKSON RD",
    "dropphycty": "DENMARK",
    "dropphyst": "TN",
    "dropphyzpp": 383919998,
    "dropmaladd": "2799 DENMARK JACKSON RD",
    "dropmalcty": "DENMARK",
    "dropmalst": "TN",
    "dropmalzpp": 383919998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314276711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25110",
    "droptype": "D",
    "dropname": "DICKSON",
    "dropdeladd": "206 SKYLINE CIR",
    "dropdelcty": "DICKSON",
    "dropdelst": "TN",
    "dropdelzpp": 370559998,
    "dropphyadd": "206 SKYLINE CIR",
    "dropphycty": "DICKSON",
    "dropphyst": "TN",
    "dropphyzpp": 370559998,
    "dropmaladd": "206 SKYLINE CIR",
    "dropmalcty": "DICKSON",
    "dropmalst": "TN",
    "dropmalzpp": 370559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157407758,
    "dropsitcph": 6157407338,
    "dropfax": 6154461617
  },
  {
    "dcode": "D",
    "dropkey": "PX25112",
    "droptype": "D",
    "dropname": "DIXON SPRINGS",
    "dropdeladd": "4 HIGHERS DR",
    "dropdelcty": "DIXON SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 370579998,
    "dropphyadd": "4 HIGHERS DR",
    "dropphycty": "DIXON SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 370579998,
    "dropmaladd": "4 HIGHERS DR",
    "dropmalcty": "DIXON SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 370579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157352335,
    "dropsitcph": 6157352335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25116",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "326 SPRING ST",
    "dropdelcty": "DOVER",
    "dropdelst": "TN",
    "dropdelzpp": 370589998,
    "dropphyadd": "326 SPRING ST",
    "dropphycty": "DOVER",
    "dropphyst": "TN",
    "dropphyzpp": 370589998,
    "dropmaladd": "326 SPRING ST",
    "dropmalcty": "DOVER",
    "dropmalst": "TN",
    "dropmalzpp": 370589998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312327338,
    "dropsitcph": 9312327338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25117",
    "droptype": "D",
    "dropname": "DOWELLTOWN",
    "dropdeladd": "101 VILLAGE SQ",
    "dropdelcty": "DOWELLTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 370599998,
    "dropphyadd": "101 VILLAGE SQ",
    "dropphycty": "DOWELLTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 370599998,
    "dropmaladd": "101 VILLAGE SQ",
    "dropmalcty": "DOWELLTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 370599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155365200,
    "dropsitcph": 6155365200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25122",
    "droptype": "D",
    "dropname": "DOYLE",
    "dropdeladd": "5375 MCMINNVILLE HWY",
    "dropdelcty": "DOYLE",
    "dropdelst": "TN",
    "dropdelzpp": 385599998,
    "dropphyadd": "5375 MCMINNVILLE HWY",
    "dropphycty": "DOYLE",
    "dropphyst": "TN",
    "dropphyzpp": 385599998,
    "dropmaladd": "5375 MCMINNVILLE HWY",
    "dropmalcty": "DOYLE",
    "dropmalst": "TN",
    "dropmalzpp": 385599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316572942,
    "dropsitcph": 9316572942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25123",
    "droptype": "D",
    "dropname": "DRESDEN",
    "dropdeladd": "122 W MAPLE ST STE A",
    "dropdelcty": "DRESDEN",
    "dropdelst": "TN",
    "dropdelzpp": 382251182,
    "dropphyadd": "122 W MAPLE ST STE A",
    "dropphycty": "DRESDEN",
    "dropphyst": "TN",
    "dropphyzpp": 382251182,
    "dropmaladd": "122 W MAPLE ST STE A",
    "dropmalcty": "DRESDEN",
    "dropmalst": "TN",
    "dropmalzpp": 382251182,
    "dropsitphn": 6158859336,
    "dropsitlph": 7313645757,
    "dropsitcph": 7313642259,
    "dropfax": 7313645395
  },
  {
    "dcode": "D",
    "dropkey": "PX25124",
    "droptype": "D",
    "dropname": "DRUMMONDS",
    "dropdeladd": "5701 RICHARDSON LANDING RD",
    "dropdelcty": "DRUMMONDS",
    "dropdelst": "TN",
    "dropdelzpp": 380236266,
    "dropphyadd": "5701 RICHARDSON LANDING RD",
    "dropphycty": "DRUMMONDS",
    "dropphyst": "TN",
    "dropphyzpp": 380236266,
    "dropmaladd": "5701 RICHARDSON LANDING RD",
    "dropmalcty": "DRUMMONDS",
    "dropmalst": "TN",
    "dropmalzpp": 380236266,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018353131,
    "dropsitcph": 9018353131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25125",
    "droptype": "D",
    "dropname": "DUCK RIVER",
    "dropdeladd": "2017 HOOVERS RD",
    "dropdelcty": "DUCK RIVER",
    "dropdelst": "TN",
    "dropdelzpp": 384549998,
    "dropphyadd": "2017 HOOVERS RD",
    "dropphycty": "DUCK RIVER",
    "dropphyst": "TN",
    "dropphyzpp": 384549998,
    "dropmaladd": "2017 HOOVERS RD",
    "dropmalcty": "DUCK RIVER",
    "dropmalst": "TN",
    "dropmalzpp": 384549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315832497,
    "dropsitcph": 9315832497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25126",
    "droptype": "D",
    "dropname": "DUCKTOWN",
    "dropdeladd": "1656 N HIGHWAY 68",
    "dropdelcty": "DUCKTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 373269998,
    "dropphyadd": "1656 N HIGHWAY 68",
    "dropphycty": "DUCKTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 373269998,
    "dropmaladd": "1656 N HIGHWAY 68",
    "dropmalcty": "DUCKTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 373269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234965467,
    "dropsitcph": 4234965467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25128",
    "droptype": "D",
    "dropname": "DUKEDOM",
    "dropdeladd": "3640 STATE LINE RD",
    "dropdelcty": "DUKEDOM",
    "dropdelst": "TN",
    "dropdelzpp": 382269998,
    "dropphyadd": "3640 STATE LINE RD",
    "dropphycty": "DUKEDOM",
    "dropphyst": "TN",
    "dropphyzpp": 382269998,
    "dropmaladd": "3640 STATE LINE RD",
    "dropmalcty": "DUKEDOM",
    "dropmalst": "TN",
    "dropmalzpp": 382269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7314695452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25129",
    "droptype": "D",
    "dropname": "DUNLAP",
    "dropdeladd": "15198 RANKIN AVE",
    "dropdelcty": "DUNLAP",
    "dropdelst": "TN",
    "dropdelzpp": 373279998,
    "dropphyadd": "15198 RANKIN AVE",
    "dropphycty": "DUNLAP",
    "dropphyst": "TN",
    "dropphyzpp": 373279998,
    "dropmaladd": "15198 RANKIN AVE",
    "dropmalcty": "DUNLAP",
    "dropmalst": "TN",
    "dropmalzpp": 373279998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239497617,
    "dropsitcph": 4239499429,
    "dropfax": 4239495330
  },
  {
    "dcode": "D",
    "dropkey": "PX25130",
    "droptype": "D",
    "dropname": "DYER",
    "dropdeladd": "142 N MAIN ST",
    "dropdelcty": "DYER",
    "dropdelst": "TN",
    "dropdelzpp": 383309998,
    "dropphyadd": "142 N MAIN ST",
    "dropphycty": "DYER",
    "dropphyst": "TN",
    "dropphyzpp": 383309998,
    "dropmaladd": "142 N MAIN ST",
    "dropmalcty": "DYER",
    "dropmalst": "TN",
    "dropmalzpp": 383309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9025212208,
    "dropsitcph": 7316923698,
    "dropfax": 7316922097
  },
  {
    "dcode": "D",
    "dropkey": "PX25131",
    "droptype": "D",
    "dropname": "DYERSBURG",
    "dropdeladd": "309 N CHURCH AVE",
    "dropdelcty": "DYERSBURG",
    "dropdelst": "TN",
    "dropdelzpp": 380249998,
    "dropphyadd": "309 N CHURCH AVE",
    "dropphycty": "DYERSBURG",
    "dropphyst": "TN",
    "dropphyzpp": 380249998,
    "dropmaladd": "309 N CHURCH AVE",
    "dropmalcty": "DYERSBURG",
    "dropmalst": "TN",
    "dropmalzpp": 380249998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312856193,
    "dropsitcph": 7312855491,
    "dropfax": 7312852437
  },
  {
    "dcode": "D",
    "dropkey": "PX25134",
    "droptype": "D",
    "dropname": "EADS",
    "dropdeladd": "2824 JEFFERSON",
    "dropdelcty": "EADS",
    "dropdelst": "TN",
    "dropdelzpp": 380289399,
    "dropphyadd": "2824 JEFFERSON",
    "dropphycty": "EADS",
    "dropphyst": "TN",
    "dropphyzpp": 380289399,
    "dropmaladd": "2824 JEFFERSON",
    "dropmalcty": "EADS",
    "dropmalst": "TN",
    "dropmalzpp": 380289399,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018673194,
    "dropsitcph": 9018673194,
    "dropfax": 9018671082
  },
  {
    "dcode": "D",
    "dropkey": "PX25135",
    "droptype": "D",
    "dropname": "EAGAN",
    "dropdeladd": "4183 HIGHWAY 90",
    "dropdelcty": "EAGAN",
    "dropdelst": "TN",
    "dropdelzpp": 377309998,
    "dropphyadd": "4183 HIGHWAY 90",
    "dropphycty": "EAGAN",
    "dropphyst": "TN",
    "dropphyzpp": 377309998,
    "dropmaladd": "4183 HIGHWAY 90",
    "dropmalcty": "EAGAN",
    "dropmalst": "TN",
    "dropmalzpp": 377309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237842190,
    "dropsitcph": 4237842190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25136",
    "droptype": "D",
    "dropname": "EAGLEVILLE",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "EAGLEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370609998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "EAGLEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370609998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "EAGLEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152746259,
    "dropsitcph": 6152746259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25154",
    "droptype": "D",
    "dropname": "EATON",
    "dropdeladd": "220 ST RT 188",
    "dropdelcty": "EATON",
    "dropdelst": "TN",
    "dropdelzpp": 383319998,
    "dropphyadd": "220 ST RT 188",
    "dropphycty": "EATON",
    "dropphyst": "TN",
    "dropphyzpp": 383319998,
    "dropmaladd": "220 ST RT 188",
    "dropmalcty": "EATON",
    "dropmalst": "TN",
    "dropmalzpp": 383319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315594431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25155",
    "droptype": "D",
    "dropname": "EIDSON",
    "dropdeladd": "3867 HIGHWAY 70 N",
    "dropdelcty": "EIDSON",
    "dropdelst": "TN",
    "dropdelzpp": 377319998,
    "dropphyadd": "3867 HIGHWAY 70 N",
    "dropphycty": "EIDSON",
    "dropphyst": "TN",
    "dropphyzpp": 377319998,
    "dropmaladd": "3867 HIGHWAY 70 N",
    "dropmalcty": "EIDSON",
    "dropmalst": "TN",
    "dropmalzpp": 377319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232726769,
    "dropsitcph": 4232726769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25157",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "179 RUGBY HWY",
    "dropdelcty": "ELGIN",
    "dropdelst": "TN",
    "dropdelzpp": 377329998,
    "dropphyadd": "179 RUGBY HWY",
    "dropphycty": "ELGIN",
    "dropphyst": "TN",
    "dropphyzpp": 377329998,
    "dropmaladd": "179 RUGBY HWY",
    "dropmalcty": "ELGIN",
    "dropmalst": "TN",
    "dropmalzpp": 377329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236272390,
    "dropsitcph": 4236272390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25158",
    "droptype": "D",
    "dropname": "ELIZABETHTON",
    "dropdeladd": "901 W ELK AVE",
    "dropdelcty": "ELIZABETHTON",
    "dropdelst": "TN",
    "dropdelzpp": 376439998,
    "dropphyadd": "901 W ELK AVE",
    "dropphycty": "ELIZABETHTON",
    "dropphyst": "TN",
    "dropphyzpp": 376439998,
    "dropmaladd": "901 W ELK AVE",
    "dropmalcty": "ELIZABETHTON",
    "dropmalst": "TN",
    "dropmalzpp": 376439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235431224,
    "dropsitcph": 4235431224,
    "dropfax": 4235431955
  },
  {
    "dcode": "D",
    "dropkey": "PX25159",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "170 MAIN ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "TN",
    "dropdelzpp": 384559998,
    "dropphyadd": "170 MAIN ST",
    "dropphycty": "ELKTON",
    "dropphyst": "TN",
    "dropphyzpp": 384559998,
    "dropmaladd": "170 MAIN ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "TN",
    "dropmalzpp": 384559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314682564,
    "dropsitcph": 9314682564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25160",
    "droptype": "D",
    "dropname": "ELLENDALE",
    "dropdeladd": "7310 CENTRALIA RD",
    "dropdelcty": "ELLENDALE",
    "dropdelst": "TN",
    "dropdelzpp": 380299998,
    "dropphyadd": "7310 CENTRALIA RD",
    "dropphycty": "ELLENDALE",
    "dropphyst": "TN",
    "dropphyzpp": 380299998,
    "dropmaladd": "7310 CENTRALIA RD",
    "dropmalcty": "ELLENDALE",
    "dropmalst": "TN",
    "dropmalzpp": 380299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013824642,
    "dropsitcph": 9013824642,
    "dropfax": 9013829587
  },
  {
    "dcode": "D",
    "dropkey": "PX25161",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "500 COOKEVILLE HWY",
    "dropdelcty": "ELMWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 385609998,
    "dropphyadd": "500 COOKEVILLE HWY",
    "dropphycty": "ELMWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 385609998,
    "dropmaladd": "500 COOKEVILLE HWY",
    "dropmalcty": "ELMWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 385609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158972703,
    "dropsitcph": 6158972703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25162",
    "droptype": "D",
    "dropname": "ELORA",
    "dropdeladd": "68 OLD HUNTLAND RD",
    "dropdelcty": "ELORA",
    "dropdelst": "TN",
    "dropdelzpp": 373289998,
    "dropphyadd": "68 OLD HUNTLAND RD",
    "dropphycty": "ELORA",
    "dropphyst": "TN",
    "dropphyzpp": 373289998,
    "dropmaladd": "68 OLD HUNTLAND RD",
    "dropmalcty": "ELORA",
    "dropmalst": "TN",
    "dropmalzpp": 373289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319378883,
    "dropsitcph": 9319378883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25164",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "17 S NIOTA RD",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 373299998,
    "dropphyadd": "17 S NIOTA RD",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 373299998,
    "dropmaladd": "17 S NIOTA RD",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 373299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238877275,
    "dropsitcph": 4238877275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25165",
    "droptype": "D",
    "dropname": "ENVILLE",
    "dropdeladd": "8400 MAIN ST",
    "dropdelcty": "ENVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383329998,
    "dropphyadd": "8400 MAIN ST",
    "dropphycty": "ENVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383329998,
    "dropmaladd": "8400 MAIN ST",
    "dropmalcty": "ENVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316885250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25168",
    "droptype": "D",
    "dropname": "ERIN",
    "dropdeladd": "30 ARLINGTON ST",
    "dropdelcty": "ERIN",
    "dropdelst": "TN",
    "dropdelzpp": 370619998,
    "dropphyadd": "30 ARLINGTON ST",
    "dropphycty": "ERIN",
    "dropphyst": "TN",
    "dropphyzpp": 370619998,
    "dropmaladd": "30 ARLINGTON ST",
    "dropmalcty": "ERIN",
    "dropmalst": "TN",
    "dropmalzpp": 370619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312894540,
    "dropsitcph": 9312894540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25170",
    "droptype": "D",
    "dropname": "ERWIN",
    "dropdeladd": "201 N MAIN AVE",
    "dropdelcty": "ERWIN",
    "dropdelst": "TN",
    "dropdelzpp": 376509998,
    "dropphyadd": "201 N MAIN AVE",
    "dropphycty": "ERWIN",
    "dropphyst": "TN",
    "dropphyzpp": 376509998,
    "dropmaladd": "201 N MAIN AVE",
    "dropmalcty": "ERWIN",
    "dropmalst": "TN",
    "dropmalzpp": 376509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237439422,
    "dropsitcph": 4237439422,
    "dropfax": 4237432077
  },
  {
    "dcode": "D",
    "dropkey": "PX25174",
    "droptype": "D",
    "dropname": "ESTILL SPRINGS",
    "dropdeladd": "316 S MAIN ST",
    "dropdelcty": "ESTILL SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 373309998,
    "dropphyadd": "316 S MAIN ST",
    "dropphycty": "ESTILL SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 373309998,
    "dropmaladd": "316 S MAIN ST",
    "dropmalcty": "ESTILL SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 373309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316495293,
    "dropsitcph": 9316495293,
    "dropfax": 9316497955
  },
  {
    "dcode": "D",
    "dropkey": "PX25175",
    "droptype": "D",
    "dropname": "ETHRIDGE",
    "dropdeladd": "101 BROAD ST",
    "dropdelcty": "ETHRIDGE",
    "dropdelst": "TN",
    "dropdelzpp": 384569998,
    "dropphyadd": "101 BROAD ST",
    "dropphycty": "ETHRIDGE",
    "dropphyst": "TN",
    "dropphyzpp": 384569998,
    "dropmaladd": "101 BROAD ST",
    "dropmalcty": "ETHRIDGE",
    "dropmalst": "TN",
    "dropmalzpp": 384569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312236594,
    "dropsitcph": 9312236580,
    "dropfax": 9312236581
  },
  {
    "dcode": "D",
    "dropkey": "PX25176",
    "droptype": "D",
    "dropname": "ETOWAH",
    "dropdeladd": "517 TENNESSEE AVE",
    "dropdelcty": "ETOWAH",
    "dropdelst": "TN",
    "dropdelzpp": 373319998,
    "dropphyadd": "517 TENNESSEE AVE",
    "dropphycty": "ETOWAH",
    "dropphyst": "TN",
    "dropphyzpp": 373319998,
    "dropmaladd": "517 TENNESSEE AVE",
    "dropmalcty": "ETOWAH",
    "dropmalst": "TN",
    "dropmalzpp": 373319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232637339,
    "dropsitcph": 4232637339,
    "dropfax": 4232636452
  },
  {
    "dcode": "D",
    "dropkey": "PX25178",
    "droptype": "D",
    "dropname": "EVA",
    "dropdeladd": "28 EVA BEACH DR",
    "dropdelcty": "EVA",
    "dropdelst": "TN",
    "dropdelzpp": 383339998,
    "dropphyadd": "28 EVA BEACH DR",
    "dropphycty": "EVA",
    "dropphyst": "TN",
    "dropphyzpp": 383339998,
    "dropmaladd": "28 EVA BEACH DR",
    "dropmalcty": "EVA",
    "dropmalst": "TN",
    "dropmalzpp": 383339998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315843407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25179",
    "droptype": "D",
    "dropname": "EVENSVILLE",
    "dropdeladd": "13602 RHEA COUNTY HWY",
    "dropdelcty": "EVENSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373329998,
    "dropphyadd": "13602 RHEA COUNTY HWY",
    "dropphycty": "EVENSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373329998,
    "dropmaladd": "13602 RHEA COUNTY HWY",
    "dropmalcty": "EVENSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237751200,
    "dropsitcph": 4237751200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25185",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "1890 FAIRVIEW BLVD",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "TN",
    "dropdelzpp": 370629998,
    "dropphyadd": "1890 FAIRVIEW BLVD",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "TN",
    "dropphyzpp": 370629998,
    "dropmaladd": "1890 FAIRVIEW BLVD",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "TN",
    "dropmalzpp": 370629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157990226,
    "dropsitcph": 6157990226,
    "dropfax": 6157991587
  },
  {
    "dcode": "D",
    "dropkey": "PX25186",
    "droptype": "D",
    "dropname": "FALL BRANCH",
    "dropdeladd": "134 RURITAN RD",
    "dropdelcty": "FALL BRANCH",
    "dropdelst": "TN",
    "dropdelzpp": 376569998,
    "dropphyadd": "134 RURITAN RD",
    "dropphycty": "FALL BRANCH",
    "dropphyst": "TN",
    "dropphyzpp": 376569998,
    "dropmaladd": "134 RURITAN RD",
    "dropmalcty": "FALL BRANCH",
    "dropmalst": "TN",
    "dropmalzpp": 376569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233488777,
    "dropsitcph": 4233488777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25187",
    "droptype": "D",
    "dropname": "FARNER",
    "dropdeladd": "110 UNDERWOOD DR",
    "dropdelcty": "FARNER",
    "dropdelst": "TN",
    "dropdelzpp": 373339998,
    "dropphyadd": "110 UNDERWOOD DR",
    "dropphycty": "FARNER",
    "dropphyst": "TN",
    "dropphyzpp": 373339998,
    "dropmaladd": "110 UNDERWOOD DR",
    "dropmalcty": "FARNER",
    "dropmalst": "TN",
    "dropmalzpp": 373339998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234964564,
    "dropsitcph": 4234964564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25190",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "226 COLLEGE ST E",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373349998,
    "dropphyadd": "226 COLLEGE ST E",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373349998,
    "dropmaladd": "226 COLLEGE ST E",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314333797,
    "dropsitcph": 9314332154,
    "dropfax": 9314333058
  },
  {
    "dcode": "D",
    "dropkey": "PX25195",
    "droptype": "D",
    "dropname": "FINGER",
    "dropdeladd": "2048 FINGER LEAPWOOD RD",
    "dropdelcty": "FINGER",
    "dropdelst": "TN",
    "dropdelzpp": 383349998,
    "dropphyadd": "2048 FINGER LEAPWOOD RD",
    "dropphycty": "FINGER",
    "dropphyst": "TN",
    "dropphyzpp": 383349998,
    "dropmaladd": "2048 FINGER LEAPWOOD RD",
    "dropmalcty": "FINGER",
    "dropmalst": "TN",
    "dropmalzpp": 383349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319344710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25197",
    "droptype": "D",
    "dropname": "FINLEY",
    "dropdeladd": "5520 HIGHWAY 104 W",
    "dropdelcty": "FINLEY",
    "dropdelst": "TN",
    "dropdelzpp": 380304037,
    "dropphyadd": "5520 HIGHWAY 104 W",
    "dropphycty": "FINLEY",
    "dropphyst": "TN",
    "dropphyzpp": 380304037,
    "dropmaladd": "5520 HIGHWAY 104 W",
    "dropmalcty": "FINLEY",
    "dropmalst": "TN",
    "dropmalzpp": 380304037,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312858814,
    "dropsitcph": 7312858814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25205",
    "droptype": "D",
    "dropname": "FLAG POND",
    "dropdeladd": "1305 RICE CREEK RD",
    "dropdelcty": "FLAG POND",
    "dropdelst": "TN",
    "dropdelzpp": 376579998,
    "dropphyadd": "1305 RICE CREEK RD",
    "dropphycty": "FLAG POND",
    "dropphyst": "TN",
    "dropphyzpp": 376579998,
    "dropmaladd": "1305 RICE CREEK RD",
    "dropmalcty": "FLAG POND",
    "dropmalst": "TN",
    "dropmalzpp": 376579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237435431,
    "dropsitcph": 4237435431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25207",
    "droptype": "D",
    "dropname": "FLINTVILLE",
    "dropdeladd": "241 FLINTVILLE RD",
    "dropdelcty": "FLINTVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373359998,
    "dropphyadd": "241 FLINTVILLE RD",
    "dropphycty": "FLINTVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373359998,
    "dropmaladd": "241 FLINTVILLE RD",
    "dropmalcty": "FLINTVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373359998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319376153,
    "dropsitcph": 9319376153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25218",
    "droptype": "D",
    "dropname": "FRANKEWING",
    "dropdeladd": "8218 BEECH HILL RD",
    "dropdelcty": "FRANKEWING",
    "dropdelst": "TN",
    "dropdelzpp": 384599998,
    "dropphyadd": "8218 BEECH HILL RD",
    "dropphycty": "FRANKEWING",
    "dropphyst": "TN",
    "dropphyzpp": 384599998,
    "dropmaladd": "8218 BEECH HILL RD",
    "dropmalcty": "FRANKEWING",
    "dropmalst": "TN",
    "dropmalzpp": 384599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313636130,
    "dropsitcph": 9313636130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25219",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "810 OAK MEADOW DR",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "TN",
    "dropdelzpp": 370649998,
    "dropphyadd": "810 OAK MEADOW DR",
    "dropphycty": "FRANKLIN",
    "dropphyst": "TN",
    "dropphyzpp": 370649998,
    "dropmaladd": "810 OAK MEADOW DR",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "TN",
    "dropmalzpp": 370649998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157941712,
    "dropsitcph": 6155994840,
    "dropfax": 6157945501
  },
  {
    "dcode": "D",
    "dropkey": "PX25222",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "143 POPLAR ST",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "TN",
    "dropdelzpp": 380349998,
    "dropphyadd": "143 POPLAR ST",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "TN",
    "dropphyzpp": 380349998,
    "dropmaladd": "143 POPLAR ST",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "TN",
    "dropmalzpp": 380349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316772731,
    "dropsitcph": 7316772731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25223",
    "droptype": "D",
    "dropname": "FRIENDSVILLE",
    "dropdeladd": "105 S MORGAN ST",
    "dropdelcty": "FRIENDSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377379998,
    "dropphyadd": "105 S MORGAN ST",
    "dropphycty": "FRIENDSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377379998,
    "dropmaladd": "105 S MORGAN ST",
    "dropmalcty": "FRIENDSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377379998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659952317,
    "dropsitcph": 8659952317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25226",
    "droptype": "D",
    "dropname": "GADSDEN",
    "dropdeladd": "64 HUMBOLDT LAKE RD",
    "dropdelcty": "GADSDEN",
    "dropdelst": "TN",
    "dropdelzpp": 383379998,
    "dropphyadd": "64 HUMBOLDT LAKE RD",
    "dropphycty": "GADSDEN",
    "dropphyst": "TN",
    "dropphyzpp": 383379998,
    "dropmaladd": "64 HUMBOLDT LAKE RD",
    "dropmalcty": "GADSDEN",
    "dropmalst": "TN",
    "dropmalzpp": 383379998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317844521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25227",
    "droptype": "D",
    "dropname": "GAINESBORO",
    "dropdeladd": "103 W COX AVE",
    "dropdelcty": "GAINESBORO",
    "dropdelst": "TN",
    "dropdelzpp": 385628328,
    "dropphyadd": "103 W COX AVE",
    "dropphycty": "GAINESBORO",
    "dropphyst": "TN",
    "dropphyzpp": 385628328,
    "dropmaladd": "103 W COX AVE",
    "dropmalcty": "GAINESBORO",
    "dropmalst": "TN",
    "dropmalzpp": 385628328,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312680314,
    "dropsitcph": 9312680314,
    "dropfax": 9312685407
  },
  {
    "dcode": "D",
    "dropkey": "PX25228",
    "droptype": "D",
    "dropname": "GALLATIN",
    "dropdeladd": "380 MAPLE ST",
    "dropdelcty": "GALLATIN",
    "dropdelst": "TN",
    "dropdelzpp": 370669998,
    "dropphyadd": "380 MAPLE ST",
    "dropphycty": "GALLATIN",
    "dropphyst": "TN",
    "dropphyzpp": 370669998,
    "dropmaladd": "380 MAPLE ST",
    "dropmalcty": "GALLATIN",
    "dropmalst": "TN",
    "dropmalzpp": 370669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152309375,
    "dropsitcph": 6152305918,
    "dropfax": 6154519901
  },
  {
    "dcode": "D",
    "dropkey": "PX25229",
    "droptype": "D",
    "dropname": "GALLAWAY",
    "dropdeladd": "586 OLD BROWNSVILLE RD",
    "dropdelcty": "GALLAWAY",
    "dropdelst": "TN",
    "dropdelzpp": 380368001,
    "dropphyadd": "586 OLD BROWNSVILLE RD",
    "dropphycty": "GALLAWAY",
    "dropphyst": "TN",
    "dropphyzpp": 380368001,
    "dropmaladd": "586 OLD BROWNSVILLE RD",
    "dropmalcty": "GALLAWAY",
    "dropmalst": "TN",
    "dropmalzpp": 380368001,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9018673231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25231",
    "droptype": "D",
    "dropname": "GATES",
    "dropdeladd": "76 HENNING ST",
    "dropdelcty": "GATES",
    "dropdelst": "TN",
    "dropdelzpp": 380378001,
    "dropphyadd": "76 HENNING ST",
    "dropphycty": "GATES",
    "dropphyst": "TN",
    "dropphyzpp": 380378001,
    "dropmaladd": "76 HENNING ST",
    "dropmalcty": "GATES",
    "dropmalst": "TN",
    "dropmalzpp": 380378001,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7318365722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25232",
    "droptype": "D",
    "dropname": "GATLINBURG",
    "dropdeladd": "1216 E PARKWAY",
    "dropdelcty": "GATLINBURG",
    "dropdelst": "TN",
    "dropdelzpp": 377389998,
    "dropphyadd": "1216 E PARKWAY",
    "dropphycty": "GATLINBURG",
    "dropphyst": "TN",
    "dropphyzpp": 377389998,
    "dropmaladd": "1216 E PARKWAY",
    "dropmalcty": "GATLINBURG",
    "dropmalst": "TN",
    "dropmalzpp": 377389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654365464,
    "dropsitcph": 8654363229,
    "dropfax": 8654303218
  },
  {
    "dcode": "D",
    "dropkey": "PX25235",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "8405 HIGHWAY 60",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "TN",
    "dropdelzpp": 373369998,
    "dropphyadd": "8405 HIGHWAY 60",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "TN",
    "dropphyzpp": 373369998,
    "dropmaladd": "8405 HIGHWAY 60",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "TN",
    "dropmalzpp": 373369998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233392521,
    "dropsitcph": 4233392521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25239",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "GIBSON",
    "dropdelst": "TN",
    "dropdelzpp": 383389998,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "GIBSON",
    "dropphyst": "TN",
    "dropphyzpp": 383389998,
    "dropmaladd": "128 S MAIN ST",
    "dropmalcty": "GIBSON",
    "dropmalst": "TN",
    "dropmalzpp": 383389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317876745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25241",
    "droptype": "D",
    "dropname": "GLADEVILLE",
    "dropdeladd": "8736 STEWARTS FERRY PIKE",
    "dropdelcty": "GLADEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370719998,
    "dropphyadd": "8736 STEWARTS FERRY PIKE",
    "dropphycty": "GLADEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370719998,
    "dropmaladd": "8736 STEWARTS FERRY PIKE",
    "dropmalcty": "GLADEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370719998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154448942,
    "dropsitcph": 6154448942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25244",
    "droptype": "D",
    "dropname": "GLEASON",
    "dropdeladd": "100 N CEDAR ST",
    "dropdelcty": "GLEASON",
    "dropdelst": "TN",
    "dropdelzpp": 382299998,
    "dropphyadd": "100 N CEDAR ST",
    "dropphycty": "GLEASON",
    "dropphyst": "TN",
    "dropphyzpp": 382299998,
    "dropmaladd": "100 N CEDAR ST",
    "dropmalcty": "GLEASON",
    "dropmalst": "TN",
    "dropmalzpp": 382299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316485980,
    "dropsitcph": 7316485980,
    "dropfax": 7316481420
  },
  {
    "dcode": "D",
    "dropkey": "PX25250",
    "droptype": "D",
    "dropname": "GOODLETTSVILLE",
    "dropdeladd": "301 NORTHCREEK BLVD",
    "dropdelcty": "GOODLETTSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370729998,
    "dropphyadd": "301 NORTHCREEK BLVD",
    "dropphycty": "GOODLETTSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370729998,
    "dropmaladd": "301 NORTHCREEK BLVD",
    "dropmalcty": "GOODLETTSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370729998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158519796,
    "dropsitcph": 6158519346,
    "dropfax": 6158595099
  },
  {
    "dcode": "D",
    "dropkey": "PX25253",
    "droptype": "D",
    "dropname": "GOODSPRING",
    "dropdeladd": "184 OAK GROVE RD",
    "dropdelcty": "GOODSPRING",
    "dropdelst": "TN",
    "dropdelzpp": 384609998,
    "dropphyadd": "184 OAK GROVE RD",
    "dropphycty": "GOODSPRING",
    "dropphyst": "TN",
    "dropphyzpp": 384609998,
    "dropmaladd": "184 OAK GROVE RD",
    "dropmalcty": "GOODSPRING",
    "dropmalst": "TN",
    "dropmalzpp": 384609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313633705,
    "dropsitcph": 9313633705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25254",
    "droptype": "D",
    "dropname": "GORDONSVILLE",
    "dropdeladd": "25 HICKMAN HWY",
    "dropdelcty": "GORDONSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385639998,
    "dropphyadd": "25 HICKMAN HWY",
    "dropphycty": "GORDONSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385639998,
    "dropmaladd": "25 HICKMAN HWY",
    "dropmalcty": "GORDONSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156838347,
    "dropsitcph": 6156838347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25258",
    "droptype": "D",
    "dropname": "GRAND JUNCTION",
    "dropdeladd": "152 CHARLESTON ROW E",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "TN",
    "dropdelzpp": 380399998,
    "dropphyadd": "152 CHARLESTON ROW E",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "TN",
    "dropphyzpp": 380399998,
    "dropmaladd": "152 CHARLESTON ROW E",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "TN",
    "dropmalzpp": 380399998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317642204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25260",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "6788 GRANVILLE HWY",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385649998,
    "dropphyadd": "6788 GRANVILLE HWY",
    "dropphycty": "GRANVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385649998,
    "dropmaladd": "6788 GRANVILLE HWY",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385649998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316534370,
    "dropsitcph": 9316534370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25264",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "4397 DAYTON AVE",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373389998,
    "dropphyadd": "4397 DAYTON AVE",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373389998,
    "dropmaladd": "4397 DAYTON AVE",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237752696,
    "dropsitcph": 4237752696,
    "dropfax": 4235708047
  },
  {
    "dcode": "D",
    "dropkey": "PX25268",
    "droptype": "D",
    "dropname": "GREENBACK",
    "dropdeladd": "6726 MORGANTON RD",
    "dropdelcty": "GREENBACK",
    "dropdelst": "TN",
    "dropdelzpp": 377429998,
    "dropphyadd": "6726 MORGANTON RD",
    "dropphycty": "GREENBACK",
    "dropphyst": "TN",
    "dropphyzpp": 377429998,
    "dropmaladd": "6726 MORGANTON RD",
    "dropmalcty": "GREENBACK",
    "dropmalst": "TN",
    "dropmalzpp": 377429998,
    "dropsitphn": 8658859336,
    "dropsitlph": 8658563523,
    "dropsitcph": 8658563523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25269",
    "droptype": "D",
    "dropname": "GREENBRIER",
    "dropdeladd": "2278 HIGHWAY 41 S",
    "dropdelcty": "GREENBRIER",
    "dropdelst": "TN",
    "dropdelzpp": 370739998,
    "dropphyadd": "2278 HIGHWAY 41 S",
    "dropphycty": "GREENBRIER",
    "dropphyst": "TN",
    "dropphyzpp": 370739998,
    "dropmaladd": "2278 HIGHWAY 41 S",
    "dropmalcty": "GREENBRIER",
    "dropmalst": "TN",
    "dropmalzpp": 370739998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156430434,
    "dropsitcph": 6156430434,
    "dropfax": 6156435624
  },
  {
    "dcode": "D",
    "dropkey": "PX25270",
    "droptype": "D",
    "dropname": "GREENEVILLE",
    "dropdeladd": "220 W SUMMER ST",
    "dropdelcty": "GREENEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377439998,
    "dropphyadd": "220 W SUMMER ST",
    "dropphycty": "GREENEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377439998,
    "dropmaladd": "220 W SUMMER ST",
    "dropmalcty": "GREENEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237872177,
    "dropsitcph": 4237872177,
    "dropfax": 4236384357
  },
  {
    "dcode": "D",
    "dropkey": "PX25271",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "301 BROAD ST",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 382309998,
    "dropphyadd": "301 BROAD ST",
    "dropphycty": "GREENFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 382309998,
    "dropmaladd": "301 BROAD ST",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 382309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7312352221,
    "dropfax": 7312352609
  },
  {
    "dcode": "D",
    "dropkey": "PX25274",
    "droptype": "D",
    "dropname": "GRIMSLEY",
    "dropdeladd": "5100 S YORK HWY",
    "dropdelcty": "GRIMSLEY",
    "dropdelst": "TN",
    "dropdelzpp": 385659998,
    "dropphyadd": "5100 S YORK HWY",
    "dropphycty": "GRIMSLEY",
    "dropphyst": "TN",
    "dropphyzpp": 385659998,
    "dropmaladd": "5100 S YORK HWY",
    "dropmalcty": "GRIMSLEY",
    "dropmalst": "TN",
    "dropmalzpp": 385659998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318633306,
    "dropsitcph": 9318633306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25277",
    "droptype": "D",
    "dropname": "GRUETLI LAAGER",
    "dropdeladd": "29434 STATE ROUTE 108",
    "dropdelcty": "GRUETLI LAAGER",
    "dropdelst": "TN",
    "dropdelzpp": 373399998,
    "dropphyadd": "29434 STATE ROUTE 108",
    "dropphycty": "GRUETLI LAAGER",
    "dropphyst": "TN",
    "dropphyzpp": 373399998,
    "dropmaladd": "29434 STATE ROUTE 108",
    "dropmalcty": "GRUETLI LAAGER",
    "dropmalst": "TN",
    "dropmalzpp": 373399998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317793963,
    "dropsitcph": 9317793963,
    "dropfax": 9317793973
  },
  {
    "dcode": "D",
    "dropkey": "PX25278",
    "droptype": "D",
    "dropname": "GUILD",
    "dropdeladd": "11360 HIGHWAY 41",
    "dropdelcty": "GUILD",
    "dropdelst": "TN",
    "dropdelzpp": 373409998,
    "dropphyadd": "11360 HIGHWAY 41",
    "dropphycty": "GUILD",
    "dropphyst": "TN",
    "dropphyzpp": 373409998,
    "dropmaladd": "11360 HIGHWAY 41",
    "dropmalcty": "GUILD",
    "dropmalst": "TN",
    "dropmalzpp": 373409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239423599,
    "dropsitcph": 4239423599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25279",
    "droptype": "D",
    "dropname": "GUYS",
    "dropdeladd": "1845 GUYS CHEWALLA RD",
    "dropdelcty": "GUYS",
    "dropdelst": "TN",
    "dropdelzpp": 383399998,
    "dropphyadd": "1845 GUYS CHEWALLA RD",
    "dropphycty": "GUYS",
    "dropphyst": "TN",
    "dropphyzpp": 383399998,
    "dropmaladd": "1845 GUYS CHEWALLA RD",
    "dropmalcty": "GUYS",
    "dropmalst": "TN",
    "dropmalzpp": 383399998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312393749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25281",
    "droptype": "D",
    "dropname": "HALLS",
    "dropdeladd": "320 SHARP ST",
    "dropdelcty": "HALLS",
    "dropdelst": "TN",
    "dropdelzpp": 380401580,
    "dropphyadd": "320 SHARP ST",
    "dropphycty": "HALLS",
    "dropphyst": "TN",
    "dropphyzpp": 380401580,
    "dropmaladd": "320 SHARP ST",
    "dropmalcty": "HALLS",
    "dropmalst": "TN",
    "dropmalzpp": 380401580,
    "dropsitphn": 6158859336,
    "dropsitlph": 7318369960,
    "dropsitcph": 7318369960,
    "dropfax": 7318365358
  },
  {
    "dcode": "D",
    "dropkey": "PX25283",
    "droptype": "D",
    "dropname": "HAMPSHIRE",
    "dropdeladd": "4116 HAMPSHIRE PIKE",
    "dropdelcty": "HAMPSHIRE",
    "dropdelst": "TN",
    "dropdelzpp": 384619998,
    "dropphyadd": "4116 HAMPSHIRE PIKE",
    "dropphycty": "HAMPSHIRE",
    "dropphyst": "TN",
    "dropphyzpp": 384619998,
    "dropmaladd": "4116 HAMPSHIRE PIKE",
    "dropmalcty": "HAMPSHIRE",
    "dropmalst": "TN",
    "dropmalzpp": 384619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312852312,
    "dropsitcph": 9312852312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25284",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "433 HIGHWAY 321",
    "dropdelcty": "HAMPTON",
    "dropdelst": "TN",
    "dropdelzpp": 376589998,
    "dropphyadd": "433 HIGHWAY 321",
    "dropphycty": "HAMPTON",
    "dropphyst": "TN",
    "dropphyzpp": 376589998,
    "dropmaladd": "433 HIGHWAY 321",
    "dropmalcty": "HAMPTON",
    "dropmalst": "TN",
    "dropmalzpp": 376589998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237252177,
    "dropsitcph": 4237252177,
    "dropfax": 4237252047
  },
  {
    "dcode": "D",
    "dropkey": "PX25286",
    "droptype": "D",
    "dropname": "HARRIMAN",
    "dropdeladd": "1122 S ROANE ST",
    "dropdelcty": "HARRIMAN",
    "dropdelst": "TN",
    "dropdelzpp": 377489998,
    "dropphyadd": "1122 S ROANE ST",
    "dropphycty": "HARRIMAN",
    "dropphyst": "TN",
    "dropphyzpp": 377489998,
    "dropmaladd": "1122 S ROANE ST",
    "dropmalcty": "HARRIMAN",
    "dropmalst": "TN",
    "dropmalzpp": 377489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8658829841,
    "dropsitcph": 8658827126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25287",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "6301 HIGHWAY 58",
    "dropdelcty": "HARRISON",
    "dropdelst": "TN",
    "dropdelzpp": 373419998,
    "dropphyadd": "6301 HIGHWAY 58",
    "dropphycty": "HARRISON",
    "dropphyst": "TN",
    "dropphyzpp": 373419998,
    "dropmaladd": "6301 HIGHWAY 58",
    "dropmalcty": "HARRISON",
    "dropmalst": "TN",
    "dropmalzpp": 373419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233442542,
    "dropsitcph": 4233262928,
    "dropfax": 4233262099
  },
  {
    "dcode": "D",
    "dropkey": "PX25288",
    "droptype": "D",
    "dropname": "HARROGATE",
    "dropdeladd": "6690 CUMBERLAND GAP PKWY",
    "dropdelcty": "HARROGATE",
    "dropdelst": "TN",
    "dropdelzpp": 377529998,
    "dropphyadd": "6690 CUMBERLAND GAP PKWY",
    "dropphycty": "HARROGATE",
    "dropphyst": "TN",
    "dropphyzpp": 377529998,
    "dropmaladd": "6690 CUMBERLAND GAP PKWY",
    "dropmalcty": "HARROGATE",
    "dropmalst": "TN",
    "dropmalzpp": 377529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238692889,
    "dropsitcph": 4238692889,
    "dropfax": 4238695857
  },
  {
    "dcode": "D",
    "dropkey": "PX25289",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "3603 HARTFORD RD",
    "dropdelcty": "HARTFORD",
    "dropdelst": "TN",
    "dropdelzpp": 377539998,
    "dropphyadd": "3603 HARTFORD RD",
    "dropphycty": "HARTFORD",
    "dropphyst": "TN",
    "dropphyzpp": 377539998,
    "dropmaladd": "3603 HARTFORD RD",
    "dropmalcty": "HARTFORD",
    "dropmalst": "TN",
    "dropmalzpp": 377539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234872180,
    "dropsitcph": 4234872180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25290",
    "droptype": "D",
    "dropname": "HARTSVILLE",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "HARTSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370749998,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "HARTSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370749998,
    "dropmaladd": "200 W MAIN ST",
    "dropmalcty": "HARTSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153744662,
    "dropsitcph": 6153743468,
    "dropfax": 6153749455
  },
  {
    "dcode": "D",
    "dropkey": "PX25293",
    "droptype": "D",
    "dropname": "HEISKELL",
    "dropdeladd": "9437 HEISKELL RD",
    "dropdelcty": "HEISKELL",
    "dropdelst": "TN",
    "dropdelzpp": 377549998,
    "dropphyadd": "9437 HEISKELL RD",
    "dropphycty": "HEISKELL",
    "dropphyst": "TN",
    "dropphyzpp": 377549998,
    "dropmaladd": "9437 HEISKELL RD",
    "dropmalcty": "HEISKELL",
    "dropmalst": "TN",
    "dropmalzpp": 377549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659382170,
    "dropsitcph": 8659382170,
    "dropfax": 8653396086
  },
  {
    "dcode": "D",
    "dropkey": "PX25294",
    "droptype": "D",
    "dropname": "HELENWOOD",
    "dropdeladd": "13013 SCOTT HWY",
    "dropdelcty": "HELENWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 377559998,
    "dropphyadd": "13013 SCOTT HWY",
    "dropphycty": "HELENWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 377559998,
    "dropmaladd": "13013 SCOTT HWY",
    "dropmalcty": "HELENWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 377559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235694482,
    "dropsitcph": 4237174148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25295",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "205 CROOK AVE",
    "dropdelcty": "HENDERSON",
    "dropdelst": "TN",
    "dropdelzpp": 383409998,
    "dropphyadd": "205 CROOK AVE",
    "dropphycty": "HENDERSON",
    "dropphyst": "TN",
    "dropphyzpp": 383409998,
    "dropmaladd": "205 CROOK AVE",
    "dropmalcty": "HENDERSON",
    "dropmalst": "TN",
    "dropmalzpp": 383409998,
    "dropsitphn": 7319895712,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319895712,
    "dropfax": 7319899547
  },
  {
    "dcode": "D",
    "dropkey": "PX25296",
    "droptype": "D",
    "dropname": "HENDERSONVILLE",
    "dropdeladd": "105 IMPERIAL BLVD",
    "dropdelcty": "HENDERSONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370759998,
    "dropphyadd": "105 IMPERIAL BLVD",
    "dropphycty": "HENDERSONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370759998,
    "dropmaladd": "105 IMPERIAL BLVD",
    "dropmalcty": "HENDERSONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158243557,
    "dropsitcph": 6158243329,
    "dropfax": 6158246388
  },
  {
    "dcode": "D",
    "dropkey": "PX25299",
    "droptype": "D",
    "dropname": "HENNING",
    "dropdeladd": "415 N MAIN ST",
    "dropdelcty": "HENNING",
    "dropdelst": "TN",
    "dropdelzpp": 380419998,
    "dropphyadd": "415 N MAIN ST",
    "dropphycty": "HENNING",
    "dropphyst": "TN",
    "dropphyzpp": 380419998,
    "dropmaladd": "415 N MAIN ST",
    "dropmalcty": "HENNING",
    "dropmalst": "TN",
    "dropmalzpp": 380419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317385795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25300",
    "droptype": "D",
    "dropname": "HENRY",
    "dropdeladd": "191 ATLANTIC AVE",
    "dropdelcty": "HENRY",
    "dropdelst": "TN",
    "dropdelzpp": 382319998,
    "dropphyadd": "191 ATLANTIC AVE",
    "dropphycty": "HENRY",
    "dropphyst": "TN",
    "dropphyzpp": 382319998,
    "dropmaladd": "191 ATLANTIC AVE",
    "dropmalcty": "HENRY",
    "dropmalst": "TN",
    "dropmalzpp": 382319998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7312432241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25302",
    "droptype": "D",
    "dropname": "HERMITAGE",
    "dropdeladd": "3908 LEBANON PIKE",
    "dropdelcty": "HERMITAGE",
    "dropdelst": "TN",
    "dropdelzpp": 370769998,
    "dropphyadd": "3908 LEBANON PIKE",
    "dropphycty": "HERMITAGE",
    "dropphyst": "TN",
    "dropphyzpp": 370769998,
    "dropmaladd": "3908 LEBANON PIKE",
    "dropmalcty": "HERMITAGE",
    "dropmalst": "TN",
    "dropmalzpp": 370769998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158719755,
    "dropsitcph": 6158719755,
    "dropfax": 6158839153
  },
  {
    "dcode": "D",
    "dropkey": "PX25303",
    "droptype": "D",
    "dropname": "HICKMAN",
    "dropdeladd": "214 HICKMAN HWY",
    "dropdelcty": "HICKMAN",
    "dropdelst": "TN",
    "dropdelzpp": 385679998,
    "dropphyadd": "214 HICKMAN HWY",
    "dropphycty": "HICKMAN",
    "dropphyst": "TN",
    "dropphyzpp": 385679998,
    "dropmaladd": "214 HICKMAN HWY",
    "dropmalcty": "HICKMAN",
    "dropmalst": "TN",
    "dropmalzpp": 385679998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156838091,
    "dropsitcph": 6156838091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25306",
    "droptype": "D",
    "dropname": "HICKORY VALLEY",
    "dropdeladd": "7065 HIGHWAY 18 S",
    "dropdelcty": "HICKORY VALLEY",
    "dropdelst": "TN",
    "dropdelzpp": 380429998,
    "dropphyadd": "7065 HIGHWAY 18 S",
    "dropphycty": "HICKORY VALLEY",
    "dropphyst": "TN",
    "dropphyzpp": 380429998,
    "dropmaladd": "7065 HIGHWAY 18 S",
    "dropmalcty": "HICKORY VALLEY",
    "dropmalst": "TN",
    "dropmalzpp": 380429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317642743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25312",
    "droptype": "D",
    "dropname": "HILHAM",
    "dropdeladd": "2483 HILHAM HWY",
    "dropdelcty": "HILHAM",
    "dropdelst": "TN",
    "dropdelzpp": 385689998,
    "dropphyadd": "2483 HILHAM HWY",
    "dropphycty": "HILHAM",
    "dropphyst": "TN",
    "dropphyzpp": 385689998,
    "dropmaladd": "2483 HILHAM HWY",
    "dropmalcty": "HILHAM",
    "dropmalst": "TN",
    "dropmalzpp": 385689998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318232212,
    "dropsitcph": 9318232212,
    "dropfax": 9318232212
  },
  {
    "dcode": "D",
    "dropkey": "PX25315",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "7746 HILLSBORO HWY",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "TN",
    "dropdelzpp": 373429998,
    "dropphyadd": "7746 HILLSBORO HWY",
    "dropphycty": "HILLSBORO",
    "dropphyst": "TN",
    "dropphyzpp": 373429998,
    "dropmaladd": "7746 HILLSBORO HWY",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "TN",
    "dropmalzpp": 373429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315962301,
    "dropsitcph": 9315962301,
    "dropfax": 9315962301
  },
  {
    "dcode": "D",
    "dropkey": "PX25319",
    "droptype": "D",
    "dropname": "HIXSON",
    "dropdeladd": "302 NORTHGATE MALL DR",
    "dropdelcty": "HIXSON",
    "dropdelst": "TN",
    "dropdelzpp": 373439998,
    "dropphyadd": "302 NORTHGATE MALL DR",
    "dropphycty": "HIXSON",
    "dropphyst": "TN",
    "dropphyzpp": 373439998,
    "dropmaladd": "302 NORTHGATE MALL DR",
    "dropmalcty": "HIXSON",
    "dropmalst": "TN",
    "dropmalzpp": 373439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238755589,
    "dropsitcph": 4238755589,
    "dropfax": 4238701937
  },
  {
    "dcode": "D",
    "dropkey": "PX25320",
    "droptype": "D",
    "dropname": "HOHENWALD",
    "dropdeladd": "26 N COURT ST",
    "dropdelcty": "HOHENWALD",
    "dropdelst": "TN",
    "dropdelzpp": 384629998,
    "dropphyadd": "26 N COURT ST",
    "dropphycty": "HOHENWALD",
    "dropphyst": "TN",
    "dropphyzpp": 384629998,
    "dropmaladd": "26 N COURT ST",
    "dropmalcty": "HOHENWALD",
    "dropmalst": "TN",
    "dropmalzpp": 384629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317965411,
    "dropsitcph": 9317965411,
    "dropfax": 9317961944
  },
  {
    "dcode": "D",
    "dropkey": "PX25324",
    "droptype": "D",
    "dropname": "HOLLADAY",
    "dropdeladd": "7005 HIGHWAY 192",
    "dropdelcty": "HOLLADAY",
    "dropdelst": "TN",
    "dropdelzpp": 383419998,
    "dropphyadd": "7005 HIGHWAY 192",
    "dropphycty": "HOLLADAY",
    "dropphyst": "TN",
    "dropphyzpp": 383419998,
    "dropmaladd": "7005 HIGHWAY 192",
    "dropmalcty": "HOLLADAY",
    "dropmalst": "TN",
    "dropmalzpp": 383419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315846332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25326",
    "droptype": "D",
    "dropname": "HOLLOW ROCK",
    "dropdeladd": "20780 SEMINARY ST",
    "dropdelcty": "HOLLOW ROCK",
    "dropdelst": "TN",
    "dropdelzpp": 383429998,
    "dropphyadd": "20780 SEMINARY ST",
    "dropphycty": "HOLLOW ROCK",
    "dropphyst": "TN",
    "dropphyzpp": 383429998,
    "dropmaladd": "20780 SEMINARY ST",
    "dropmalcty": "HOLLOW ROCK",
    "dropmalst": "TN",
    "dropmalzpp": 383429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315862181,
    "dropfax": 7315863769
  },
  {
    "dcode": "D",
    "dropkey": "PX25328",
    "droptype": "D",
    "dropname": "HORNBEAK",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "HORNBEAK",
    "dropdelst": "TN",
    "dropdelzpp": 382329998,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "HORNBEAK",
    "dropphyst": "TN",
    "dropphyzpp": 382329998,
    "dropmaladd": "207 S MAIN ST",
    "dropmalcty": "HORNBEAK",
    "dropmalst": "TN",
    "dropmalzpp": 382329998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315382501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25329",
    "droptype": "D",
    "dropname": "HORNSBY",
    "dropdeladd": "475 MAIN ST",
    "dropdelcty": "HORNSBY",
    "dropdelst": "TN",
    "dropdelzpp": 380444449,
    "dropphyadd": "475 MAIN ST",
    "dropphycty": "HORNSBY",
    "dropphyst": "TN",
    "dropphyzpp": 380444449,
    "dropmaladd": "475 MAIN ST",
    "dropmalcty": "HORNSBY",
    "dropmalst": "TN",
    "dropmalzpp": 380444449,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316589365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25331",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "1420 OSBORNE ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "TN",
    "dropdelzpp": 383439998,
    "dropphyadd": "1420 OSBORNE ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "TN",
    "dropphyzpp": 383439998,
    "dropmaladd": "1420 OSBORNE ST",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "TN",
    "dropmalzpp": 383439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7317848294,
    "dropsitcph": 7317843383,
    "dropfax": 7317846377
  },
  {
    "dcode": "D",
    "dropkey": "PX25334",
    "droptype": "D",
    "dropname": "HUNTINGDON",
    "dropdeladd": "543 HIGH ST",
    "dropdelcty": "HUNTINGDON",
    "dropdelst": "TN",
    "dropdelzpp": 383449998,
    "dropphyadd": "543 HIGH ST",
    "dropphycty": "HUNTINGDON",
    "dropphyst": "TN",
    "dropphyzpp": 383449998,
    "dropmaladd": "543 HIGH ST",
    "dropmalcty": "HUNTINGDON",
    "dropmalst": "TN",
    "dropmalzpp": 383449998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7319862467,
    "dropsitcph": 7319863664,
    "dropfax": 7319864485
  },
  {
    "dcode": "D",
    "dropkey": "PX25335",
    "droptype": "D",
    "dropname": "HUNTLAND",
    "dropdeladd": "104 ALABAMA ST",
    "dropdelcty": "HUNTLAND",
    "dropdelst": "TN",
    "dropdelzpp": 373459998,
    "dropphyadd": "104 ALABAMA ST",
    "dropphycty": "HUNTLAND",
    "dropphyst": "TN",
    "dropphyzpp": 373459998,
    "dropmaladd": "104 ALABAMA ST",
    "dropmalcty": "HUNTLAND",
    "dropmalst": "TN",
    "dropmalzpp": 373459998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314697615,
    "dropsitcph": 9314697615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25336",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "215 HUNTSVILLE DR",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377569998,
    "dropphyadd": "215 HUNTSVILLE DR",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377569998,
    "dropmaladd": "215 HUNTSVILLE DR",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236632229,
    "dropsitcph": 4236632229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25338",
    "droptype": "D",
    "dropname": "HURRICANE MILLS",
    "dropdeladd": "1855 HURRICANE MILLS RD",
    "dropdelcty": "HURRICANE MILLS",
    "dropdelst": "TN",
    "dropdelzpp": 370789998,
    "dropphyadd": "1855 HURRICANE MILLS RD",
    "dropphycty": "HURRICANE MILLS",
    "dropphyst": "TN",
    "dropphyzpp": 370789998,
    "dropmaladd": "1855 HURRICANE MILLS RD",
    "dropmalcty": "HURRICANE MILLS",
    "dropmalst": "TN",
    "dropmalzpp": 370789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312967510,
    "dropsitcph": 9312967510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25342",
    "droptype": "D",
    "dropname": "IDLEWILD",
    "dropdeladd": "26 IDLEWILD HOLLYLEAF RD",
    "dropdelcty": "IDLEWILD",
    "dropdelst": "TN",
    "dropdelzpp": 383469998,
    "dropphyadd": "26 IDLEWILD HOLLYLEAF RD",
    "dropphycty": "IDLEWILD",
    "dropphyst": "TN",
    "dropphyzpp": 383469998,
    "dropmaladd": "26 IDLEWILD HOLLYLEAF RD",
    "dropmalcty": "IDLEWILD",
    "dropmalst": "TN",
    "dropmalzpp": 383469998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317410004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25343",
    "droptype": "D",
    "dropname": "INDIAN MOUND",
    "dropdeladd": "1207 HIGHWAY 46",
    "dropdelcty": "INDIAN MOUND",
    "dropdelst": "TN",
    "dropdelzpp": 370799998,
    "dropphyadd": "1207 HIGHWAY 46",
    "dropphycty": "INDIAN MOUND",
    "dropphyst": "TN",
    "dropphyzpp": 370799998,
    "dropmaladd": "1207 HIGHWAY 46",
    "dropmalcty": "INDIAN MOUND",
    "dropmalst": "TN",
    "dropmalzpp": 370799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312327088,
    "dropsitcph": 9312327088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25346",
    "droptype": "D",
    "dropname": "IRON CITY",
    "dropdeladd": "33 W 2ND ST",
    "dropdelcty": "IRON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 384639998,
    "dropphyadd": "33 W 2ND ST",
    "dropphycty": "IRON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 384639998,
    "dropmaladd": "33 W 2ND ST",
    "dropmalcty": "IRON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 384639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318454631,
    "dropsitcph": 9318454631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25349",
    "droptype": "D",
    "dropname": "JACKS CREEK",
    "dropdeladd": "7185 STATE ROUTE 100 E",
    "dropdelcty": "JACKS CREEK",
    "dropdelst": "TN",
    "dropdelzpp": 383479998,
    "dropphyadd": "7185 STATE ROUTE 100 E",
    "dropphycty": "JACKS CREEK",
    "dropphyst": "TN",
    "dropphyzpp": 383479998,
    "dropmaladd": "7185 STATE ROUTE 100 E",
    "dropmalcty": "JACKS CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 383479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319892808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25351",
    "droptype": "D",
    "dropname": "JACKSBORO",
    "dropdeladd": "424 MAIN ST STE 100",
    "dropdelcty": "JACKSBORO",
    "dropdelst": "TN",
    "dropdelzpp": 377579998,
    "dropphyadd": "424 MAIN ST STE 100",
    "dropphycty": "JACKSBORO",
    "dropphyst": "TN",
    "dropphyzpp": 377579998,
    "dropmaladd": "424 MAIN ST STE 100",
    "dropmalcty": "JACKSBORO",
    "dropmalst": "TN",
    "dropmalzpp": 377579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235629661,
    "dropsitcph": 4235629661,
    "dropfax": 4235666648
  },
  {
    "dcode": "D",
    "dropkey": "PX25353",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383019998,
    "dropphyadd": "200 DR MARTIN LUTHER KING JR DR",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383019998,
    "dropmaladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7314232596,
    "dropsitcph": 7314232596,
    "dropfax": 7314244025
  },
  {
    "dcode": "D",
    "dropkey": "PX25355",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "124 N MAIN ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 385569998,
    "dropphyadd": "124 N MAIN ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 385569998,
    "dropmaladd": "124 N MAIN ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 385569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318796330,
    "dropsitcph": 9318797517,
    "dropfax": 9318791812
  },
  {
    "dcode": "D",
    "dropkey": "PX25357",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "3739 MAIN ST",
    "dropdelcty": "JASPER",
    "dropdelst": "TN",
    "dropdelzpp": 373479998,
    "dropphyadd": "3739 MAIN ST",
    "dropphycty": "JASPER",
    "dropphyst": "TN",
    "dropphyzpp": 373479998,
    "dropmaladd": "3739 MAIN ST",
    "dropmalcty": "JASPER",
    "dropmalst": "TN",
    "dropmalzpp": 373479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239422107,
    "dropsitcph": 4239422107,
    "dropfax": 4239421561
  },
  {
    "dcode": "D",
    "dropkey": "PX25360",
    "droptype": "D",
    "dropname": "JEFFERSON CITY",
    "dropdeladd": "101 E OLD ANDREW JOHNSON HWY",
    "dropdelcty": "JEFFERSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 377609998,
    "dropphyadd": "101 E OLD ANDREW JOHNSON HWY",
    "dropphycty": "JEFFERSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 377609998,
    "dropmaladd": "101 E OLD ANDREW JOHNSON HWY",
    "dropmalcty": "JEFFERSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 377609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654758065,
    "dropsitcph": 8654752955,
    "dropfax": 8654750869
  },
  {
    "dcode": "D",
    "dropkey": "PX25361",
    "droptype": "D",
    "dropname": "JELLICO",
    "dropdeladd": "368 N MAIN ST",
    "dropdelcty": "JELLICO",
    "dropdelst": "TN",
    "dropdelzpp": 377629998,
    "dropphyadd": "368 N MAIN ST",
    "dropphycty": "JELLICO",
    "dropphyst": "TN",
    "dropphyzpp": 377629998,
    "dropmaladd": "368 N MAIN ST",
    "dropmalcty": "JELLICO",
    "dropmalst": "TN",
    "dropmalzpp": 377629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237846555,
    "dropsitcph": 4237846555,
    "dropfax": 4237844514
  },
  {
    "dcode": "D",
    "dropkey": "PX25364",
    "droptype": "D",
    "dropname": "JOELTON",
    "dropdeladd": "3340 UNION HILL RD",
    "dropdelcty": "JOELTON",
    "dropdelst": "TN",
    "dropdelzpp": 370809998,
    "dropphyadd": "3340 UNION HILL RD",
    "dropphycty": "JOELTON",
    "dropphyst": "TN",
    "dropphyzpp": 370809998,
    "dropmaladd": "3340 UNION HILL RD",
    "dropmalcty": "JOELTON",
    "dropmalst": "TN",
    "dropmalzpp": 370809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158762542,
    "dropsitcph": 6158762542,
    "dropfax": 6158761350
  },
  {
    "dcode": "D",
    "dropkey": "PX25367",
    "droptype": "D",
    "dropname": "JOHNSON CITY",
    "dropdeladd": "530 E MAIN ST",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376019998,
    "dropphyadd": "530 E MAIN ST",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376019998,
    "dropmaladd": "530 E MAIN ST",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232325805,
    "dropsitcph": 4232325840,
    "dropfax": 4232325860
  },
  {
    "dcode": "D",
    "dropkey": "PX25369",
    "droptype": "D",
    "dropname": "JONESBOROUGH",
    "dropdeladd": "121 BOONE ST",
    "dropdelcty": "JONESBOROUGH",
    "dropdelst": "TN",
    "dropdelzpp": 376599998,
    "dropphyadd": "121 BOONE ST",
    "dropphycty": "JONESBOROUGH",
    "dropphyst": "TN",
    "dropphyzpp": 376599998,
    "dropmaladd": "121 BOONE ST",
    "dropmalcty": "JONESBOROUGH",
    "dropmalst": "TN",
    "dropmalzpp": 376599998,
    "dropsitphn": 4237536391,
    "dropsitlph": 4237537048,
    "dropsitcph": 4237537048,
    "dropfax": 4237532766
  },
  {
    "dcode": "D",
    "dropkey": "PX25371",
    "droptype": "D",
    "dropname": "KELSO",
    "dropdeladd": "36 TEAL HOLLOW RD",
    "dropdelcty": "KELSO",
    "dropdelst": "TN",
    "dropdelzpp": 373489998,
    "dropphyadd": "36 TEAL HOLLOW RD",
    "dropphycty": "KELSO",
    "dropphyst": "TN",
    "dropphyzpp": 373489998,
    "dropmaladd": "36 TEAL HOLLOW RD",
    "dropmalcty": "KELSO",
    "dropmalst": "TN",
    "dropmalzpp": 373489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314337099,
    "dropsitcph": 9314337099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25372",
    "droptype": "D",
    "dropname": "KENTON",
    "dropdeladd": "200 E CARROLL ST",
    "dropdelcty": "KENTON",
    "dropdelst": "TN",
    "dropdelzpp": 382339998,
    "dropphyadd": "200 E CARROLL ST",
    "dropphycty": "KENTON",
    "dropphyst": "TN",
    "dropphyzpp": 382339998,
    "dropmaladd": "200 E CARROLL ST",
    "dropmalcty": "KENTON",
    "dropmalst": "TN",
    "dropmalzpp": 382339998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7317495212,
    "dropfax": 7317495371
  },
  {
    "dcode": "D",
    "dropkey": "PX25378",
    "droptype": "D",
    "dropname": "KINGSPORT",
    "dropdeladd": "1001 N EASTMAN RD",
    "dropdelcty": "KINGSPORT",
    "dropdelst": "TN",
    "dropdelzpp": 376649998,
    "dropphyadd": "1001 N EASTMAN RD",
    "dropphycty": "KINGSPORT",
    "dropphyst": "TN",
    "dropphyzpp": 376649998,
    "dropmaladd": "1001 N EASTMAN RD",
    "dropmalcty": "KINGSPORT",
    "dropmalst": "TN",
    "dropmalzpp": 376649998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232306305,
    "dropsitcph": 4232306305,
    "dropfax": 4232461600
  },
  {
    "dcode": "D",
    "dropkey": "PX25380",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "424 N KENTUCKY ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "TN",
    "dropdelzpp": 377639998,
    "dropphyadd": "424 N KENTUCKY ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "TN",
    "dropphyzpp": 377639998,
    "dropmaladd": "424 N KENTUCKY ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "TN",
    "dropmalzpp": 377639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8657170644,
    "dropsitcph": 8657170644,
    "dropfax": 8653760872
  },
  {
    "dcode": "D",
    "dropkey": "PX25382",
    "droptype": "D",
    "dropname": "KINGSTON SPRINGS",
    "dropdeladd": "110 LUYBEN HILLS RD",
    "dropdelcty": "KINGSTON SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 370829998,
    "dropphyadd": "110 LUYBEN HILLS RD",
    "dropphycty": "KINGSTON SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 370829998,
    "dropmaladd": "110 LUYBEN HILLS RD",
    "dropmalcty": "KINGSTON SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 370829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6159522734,
    "dropsitcph": 6159523953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25385",
    "droptype": "D",
    "dropname": "KNOXVILLE",
    "dropdeladd": "1237 E WEISGARBER RD",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379509998,
    "dropphyadd": "1237 E WEISGARBER RD",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379509998,
    "dropmaladd": "1237 E WEISGARBER RD",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655584544,
    "dropsitcph": 8655584544,
    "dropfax": 8655584521
  },
  {
    "dcode": "D",
    "dropkey": "PX25387",
    "droptype": "D",
    "dropname": "KODAK",
    "dropdeladd": "2849 WINFIELD DUNN PKWY",
    "dropdelcty": "KODAK",
    "dropdelst": "TN",
    "dropdelzpp": 377649998,
    "dropphyadd": "2849 WINFIELD DUNN PKWY",
    "dropphycty": "KODAK",
    "dropphyst": "TN",
    "dropphyzpp": 377649998,
    "dropmaladd": "2849 WINFIELD DUNN PKWY",
    "dropmalcty": "KODAK",
    "dropmalst": "TN",
    "dropmalzpp": 377649998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659323362,
    "dropsitcph": 8659323362,
    "dropfax": 8659326039
  },
  {
    "dcode": "D",
    "dropkey": "PX25389",
    "droptype": "D",
    "dropname": "LA FOLLETTE",
    "dropdeladd": "1221 E CENTRAL AVE",
    "dropdelcty": "LA FOLLETTE",
    "dropdelst": "TN",
    "dropdelzpp": 377669998,
    "dropphyadd": "1221 E CENTRAL AVE",
    "dropphycty": "LA FOLLETTE",
    "dropphyst": "TN",
    "dropphyzpp": 377669998,
    "dropmaladd": "1221 E CENTRAL AVE",
    "dropmalcty": "LA FOLLETTE",
    "dropmalst": "TN",
    "dropmalzpp": 377669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235622431,
    "dropsitcph": 4235622431,
    "dropfax": 4235666645
  },
  {
    "dcode": "D",
    "dropkey": "PX25390",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "30 MAIN ST",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "TN",
    "dropdelzpp": 380465000,
    "dropphyadd": "30 MAIN ST",
    "dropphycty": "LA GRANGE",
    "dropphyst": "TN",
    "dropphyzpp": 380465000,
    "dropmaladd": "30 MAIN ST",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "TN",
    "dropmalzpp": 380465000,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9018781136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25391",
    "droptype": "D",
    "dropname": "LA VERGNE",
    "dropdeladd": "5309 MURFREESBORO RD",
    "dropdelcty": "LA VERGNE",
    "dropdelst": "TN",
    "dropdelzpp": 370869998,
    "dropphyadd": "5309 MURFREESBORO RD",
    "dropphycty": "LA VERGNE",
    "dropphyst": "TN",
    "dropphyzpp": 370869998,
    "dropmaladd": "5309 MURFREESBORO RD",
    "dropmalcty": "LA VERGNE",
    "dropmalst": "TN",
    "dropmalzpp": 370869998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6159033739,
    "dropsitcph": 6159033739,
    "dropfax": 6157937398
  },
  {
    "dcode": "D",
    "dropkey": "PX25393",
    "droptype": "D",
    "dropname": "LACONIA",
    "dropdeladd": "2430 LACONIA RD",
    "dropdelcty": "LACONIA",
    "dropdelst": "TN",
    "dropdelzpp": 380455000,
    "dropphyadd": "2430 LACONIA RD",
    "dropphycty": "LACONIA",
    "dropphyst": "TN",
    "dropphyzpp": 380455000,
    "dropmaladd": "2430 LACONIA RD",
    "dropmalcty": "LACONIA",
    "dropmalst": "TN",
    "dropmalzpp": 380455000,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9014652529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25394",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "506 ELLINGTON DR",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "TN",
    "dropdelzpp": 370839998,
    "dropphyadd": "506 ELLINGTON DR",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "TN",
    "dropphyzpp": 370839998,
    "dropmaladd": "506 ELLINGTON DR",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "TN",
    "dropmalzpp": 370839998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156662420,
    "dropsitcph": 6156662420,
    "dropfax": 6156663202
  },
  {
    "dcode": "D",
    "dropkey": "PX25396",
    "droptype": "D",
    "dropname": "ROCKY TOP",
    "dropdeladd": "220 2ND ST",
    "dropdelcty": "ROCKY TOP",
    "dropdelst": "TN",
    "dropdelzpp": 377699998,
    "dropphyadd": "220 2ND ST",
    "dropphycty": "ROCKY TOP",
    "dropphyst": "TN",
    "dropphyzpp": 377699998,
    "dropmaladd": "220 2ND ST",
    "dropmalcty": "ROCKY TOP",
    "dropmalst": "TN",
    "dropmalzpp": 377699998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654262453,
    "dropsitcph": 8654262453,
    "dropfax": 8654268198
  },
  {
    "dcode": "D",
    "dropkey": "PX25400",
    "droptype": "D",
    "dropname": "LANCING",
    "dropdeladd": "1206 NASHVILLE HWY",
    "dropdelcty": "LANCING",
    "dropdelst": "TN",
    "dropdelzpp": 377709998,
    "dropphyadd": "1206 NASHVILLE HWY",
    "dropphycty": "LANCING",
    "dropphyst": "TN",
    "dropphyzpp": 377709998,
    "dropmaladd": "1206 NASHVILLE HWY",
    "dropmalcty": "LANCING",
    "dropmalst": "TN",
    "dropmalzpp": 377709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233466467,
    "dropsitcph": 4233466467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25402",
    "droptype": "D",
    "dropname": "LASCASSAS",
    "dropdeladd": "4682 E JEFFERSON PIKE",
    "dropdelcty": "LASCASSAS",
    "dropdelst": "TN",
    "dropdelzpp": 370859998,
    "dropphyadd": "4682 E JEFFERSON PIKE",
    "dropphycty": "LASCASSAS",
    "dropphyst": "TN",
    "dropphyzpp": 370859998,
    "dropmaladd": "4682 E JEFFERSON PIKE",
    "dropmalcty": "LASCASSAS",
    "dropmalst": "TN",
    "dropmalzpp": 370859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158932881,
    "dropsitcph": 6158932881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25404",
    "droptype": "D",
    "dropname": "LAVINIA",
    "dropdeladd": "4710 HIGHWAY 220",
    "dropdelcty": "LAVINIA",
    "dropdelst": "TN",
    "dropdelzpp": 383489998,
    "dropphyadd": "4710 HIGHWAY 220",
    "dropphycty": "LAVINIA",
    "dropphyst": "TN",
    "dropphyzpp": 383489998,
    "dropmaladd": "4710 HIGHWAY 220",
    "dropmalcty": "LAVINIA",
    "dropmalst": "TN",
    "dropmalzpp": 383489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317833312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25406",
    "droptype": "D",
    "dropname": "LAWRENCEBURG",
    "dropdeladd": "218 N MILITARY AVE",
    "dropdelcty": "LAWRENCEBURG",
    "dropdelst": "TN",
    "dropdelzpp": 384649998,
    "dropphyadd": "218 N MILITARY AVE",
    "dropphycty": "LAWRENCEBURG",
    "dropphyst": "TN",
    "dropphyzpp": 384649998,
    "dropmaladd": "218 N MILITARY AVE",
    "dropmalcty": "LAWRENCEBURG",
    "dropmalst": "TN",
    "dropmalzpp": 384649998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317622528,
    "dropsitcph": 9317627535,
    "dropfax": 9317662029
  },
  {
    "dcode": "D",
    "dropkey": "PX25409",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "226 E GAY ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "TN",
    "dropdelzpp": 370879998,
    "dropphyadd": "226 E GAY ST",
    "dropphycty": "LEBANON",
    "dropphyst": "TN",
    "dropphyzpp": 370879998,
    "dropmaladd": "226 E GAY ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "TN",
    "dropmalzpp": 370879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154538925,
    "dropsitcph": 6154534758,
    "dropfax": 6154496874
  },
  {
    "dcode": "D",
    "dropkey": "PX25413",
    "droptype": "D",
    "dropname": "LENOIR CITY",
    "dropdeladd": "217 E BROADWAY ST",
    "dropdelcty": "LENOIR CITY",
    "dropdelst": "TN",
    "dropdelzpp": 377719998,
    "dropphyadd": "217 E BROADWAY ST",
    "dropphycty": "LENOIR CITY",
    "dropphyst": "TN",
    "dropphyzpp": 377719998,
    "dropmaladd": "217 E BROADWAY ST",
    "dropmalcty": "LENOIR CITY",
    "dropmalst": "TN",
    "dropmalzpp": 377719998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659869257,
    "dropsitcph": 8659869257,
    "dropfax": 8659886321
  },
  {
    "dcode": "D",
    "dropkey": "PX25414",
    "droptype": "D",
    "dropname": "LENOX",
    "dropdeladd": "22 STALLINGS ST",
    "dropdelcty": "LENOX",
    "dropdelst": "TN",
    "dropdelzpp": 380479998,
    "dropphyadd": "22 STALLINGS ST",
    "dropphycty": "LENOX",
    "dropphyst": "TN",
    "dropphyzpp": 380479998,
    "dropmaladd": "22 STALLINGS ST",
    "dropmalcty": "LENOX",
    "dropmalst": "TN",
    "dropmalzpp": 380479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312878060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25415",
    "droptype": "D",
    "dropname": "LEOMA",
    "dropdeladd": "1 RABBIT TRAIL RD",
    "dropdelcty": "LEOMA",
    "dropdelst": "TN",
    "dropdelzpp": 384689998,
    "dropphyadd": "1 RABBIT TRAIL RD",
    "dropphycty": "LEOMA",
    "dropphyst": "TN",
    "dropphyzpp": 384689998,
    "dropmaladd": "1 RABBIT TRAIL RD",
    "dropmalcty": "LEOMA",
    "dropmalst": "TN",
    "dropmalzpp": 384689998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318524111,
    "dropsitcph": 9318524111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25417",
    "droptype": "D",
    "dropname": "LEWISBURG",
    "dropdeladd": "557 E COMMERCE ST",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "TN",
    "dropdelzpp": 370919998,
    "dropphyadd": "557 E COMMERCE ST",
    "dropphycty": "LEWISBURG",
    "dropphyst": "TN",
    "dropphyzpp": 370919998,
    "dropmaladd": "557 E COMMERCE ST",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "TN",
    "dropmalzpp": 370919998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313593232,
    "dropsitcph": 9313593232,
    "dropfax": 9312707107
  },
  {
    "dcode": "D",
    "dropkey": "PX25419",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "160 S BROAD ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 383519998,
    "dropphyadd": "160 S BROAD ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 383519998,
    "dropmaladd": "160 S BROAD ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 383519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7319682446,
    "dropsitcph": 7319682446,
    "dropfax": 7319681973
  },
  {
    "dcode": "D",
    "dropkey": "PX25420",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "230 E MAIN ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "TN",
    "dropdelzpp": 370959998,
    "dropphyadd": "230 E MAIN ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "TN",
    "dropphyzpp": 370959998,
    "dropmaladd": "230 E MAIN ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "TN",
    "dropmalzpp": 370959998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155365219,
    "dropsitcph": 6155365219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25421",
    "droptype": "D",
    "dropname": "LIMESTONE",
    "dropdeladd": "359 OPIE ARNOLD RD",
    "dropdelcty": "LIMESTONE",
    "dropdelst": "TN",
    "dropdelzpp": 376819998,
    "dropphyadd": "359 OPIE ARNOLD RD",
    "dropphycty": "LIMESTONE",
    "dropphyst": "TN",
    "dropphyzpp": 376819998,
    "dropmaladd": "359 OPIE ARNOLD RD",
    "dropmalcty": "LIMESTONE",
    "dropmalst": "TN",
    "dropmalzpp": 376819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232575600,
    "dropsitcph": 4232575600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25422",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "128 W MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "TN",
    "dropdelzpp": 370969998,
    "dropphyadd": "128 W MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "TN",
    "dropphyzpp": 370969998,
    "dropmaladd": "128 W MAIN ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "TN",
    "dropmalzpp": 370969998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315892829,
    "dropsitcph": 9315892829,
    "dropfax": 9315892112
  },
  {
    "dcode": "D",
    "dropkey": "PX25424",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "105 S COURT SQ",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "TN",
    "dropdelzpp": 385709998,
    "dropphyadd": "105 S COURT SQ",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "TN",
    "dropphyzpp": 385709998,
    "dropmaladd": "105 S COURT SQ",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "TN",
    "dropmalzpp": 385709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318237753,
    "dropsitcph": 9318232622,
    "dropfax": 9318236328
  },
  {
    "dcode": "D",
    "dropkey": "PX25425",
    "droptype": "D",
    "dropname": "LOBELVILLE",
    "dropdeladd": "22 S MAIN ST",
    "dropdelcty": "LOBELVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370979998,
    "dropphyadd": "22 S MAIN ST",
    "dropphycty": "LOBELVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370979998,
    "dropmaladd": "22 S MAIN ST",
    "dropmalcty": "LOBELVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370979998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315932575,
    "dropsitcph": 9315932575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25431",
    "droptype": "D",
    "dropname": "LOOKOUT MOUNTAIN",
    "dropdeladd": "824 SCENIC HWY",
    "dropdelcty": "LOOKOUT MOUNTAIN",
    "dropdelst": "TN",
    "dropdelzpp": 373509998,
    "dropphyadd": "824 SCENIC HWY",
    "dropphycty": "LOOKOUT MOUNTAIN",
    "dropphyst": "TN",
    "dropphyzpp": 373509998,
    "dropmaladd": "824 SCENIC HWY",
    "dropmalcty": "LOOKOUT MOUNTAIN",
    "dropmalst": "TN",
    "dropmalzpp": 373509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238227527,
    "dropsitcph": 4238227165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25436",
    "droptype": "D",
    "dropname": "LORETTO",
    "dropdeladd": "100 W COMMERCE ST",
    "dropdelcty": "LORETTO",
    "dropdelst": "TN",
    "dropdelzpp": 384699998,
    "dropphyadd": "100 W COMMERCE ST",
    "dropphycty": "LORETTO",
    "dropphyst": "TN",
    "dropphyzpp": 384699998,
    "dropmaladd": "100 W COMMERCE ST",
    "dropmalcty": "LORETTO",
    "dropmalst": "TN",
    "dropmalzpp": 384699998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318534436,
    "dropsitcph": 9318534436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25437",
    "droptype": "D",
    "dropname": "LOUDON",
    "dropdeladd": "100 GREEN ST",
    "dropdelcty": "LOUDON",
    "dropdelst": "TN",
    "dropdelzpp": 377749998,
    "dropphyadd": "100 GREEN ST",
    "dropphycty": "LOUDON",
    "dropphyst": "TN",
    "dropphyzpp": 377749998,
    "dropmaladd": "100 GREEN ST",
    "dropmalcty": "LOUDON",
    "dropmalst": "TN",
    "dropmalzpp": 377749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654584385,
    "dropsitcph": 8654587943,
    "dropfax": 8654581613
  },
  {
    "dcode": "D",
    "dropkey": "PX25438",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "2948 TOPSIDE RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 377779998,
    "dropphyadd": "2948 TOPSIDE RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 377779998,
    "dropmaladd": "2948 TOPSIDE RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 377779998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659829082,
    "dropsitcph": 8659829178,
    "dropfax": 8656811889
  },
  {
    "dcode": "D",
    "dropkey": "PX25444",
    "droptype": "D",
    "dropname": "LURAY",
    "dropdeladd": "4480 LURAY RD",
    "dropdelcty": "LURAY",
    "dropdelst": "TN",
    "dropdelzpp": 383529998,
    "dropphyadd": "4480 LURAY RD",
    "dropphycty": "LURAY",
    "dropphyst": "TN",
    "dropphyzpp": 383529998,
    "dropmaladd": "4480 LURAY RD",
    "dropmalcty": "LURAY",
    "dropmalst": "TN",
    "dropmalzpp": 383529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319688051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25445",
    "droptype": "D",
    "dropname": "LUTTRELL",
    "dropdeladd": "3333 HIGHWAY 61 E",
    "dropdelcty": "LUTTRELL",
    "dropdelst": "TN",
    "dropdelzpp": 377799998,
    "dropphyadd": "3333 HIGHWAY 61 E",
    "dropphycty": "LUTTRELL",
    "dropphyst": "TN",
    "dropphyzpp": 377799998,
    "dropmaladd": "3333 HIGHWAY 61 E",
    "dropmalcty": "LUTTRELL",
    "dropmalst": "TN",
    "dropmalzpp": 377799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659920052,
    "dropsitcph": 8659920052,
    "dropfax": 8659928545
  },
  {
    "dcode": "D",
    "dropkey": "PX25447",
    "droptype": "D",
    "dropname": "LYLES",
    "dropdeladd": "5379 HIGHWAY 100",
    "dropdelcty": "LYLES",
    "dropdelst": "TN",
    "dropdelzpp": 370989998,
    "dropphyadd": "5379 HIGHWAY 100",
    "dropphycty": "LYLES",
    "dropphyst": "TN",
    "dropphyzpp": 370989998,
    "dropmaladd": "5379 HIGHWAY 100",
    "dropmalcty": "LYLES",
    "dropmalst": "TN",
    "dropmalzpp": 370989998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316703222,
    "dropsitcph": 9316703222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25449",
    "droptype": "D",
    "dropname": "LYNCHBURG",
    "dropdeladd": "13 HILES ST",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "TN",
    "dropdelzpp": 373529998,
    "dropphyadd": "13 HILES ST",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "TN",
    "dropphyzpp": 373529998,
    "dropmaladd": "13 HILES ST",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "TN",
    "dropmalzpp": 373529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317597818,
    "dropsitcph": 9317597818,
    "dropfax": 9317597687
  },
  {
    "dcode": "D",
    "dropkey": "PX25451",
    "droptype": "D",
    "dropname": "LYNNVILLE",
    "dropdeladd": "1832 MAIN ST",
    "dropdelcty": "LYNNVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 384729998,
    "dropphyadd": "1832 MAIN ST",
    "dropphycty": "LYNNVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 384729998,
    "dropmaladd": "1832 MAIN ST",
    "dropmalcty": "LYNNVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 384729998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315273916,
    "dropsitcph": 9315273916,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25454",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "323 E OLD HICKORY BLVD",
    "dropdelcty": "MADISON",
    "dropdelst": "TN",
    "dropdelzpp": 371159998,
    "dropphyadd": "323 E OLD HICKORY BLVD",
    "dropphycty": "MADISON",
    "dropphyst": "TN",
    "dropphyzpp": 371159998,
    "dropmaladd": "323 E OLD HICKORY BLVD",
    "dropmalcty": "MADISON",
    "dropmalst": "TN",
    "dropmalzpp": 371159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158684521,
    "dropsitcph": 6158684521,
    "dropfax": 6158683253
  },
  {
    "dcode": "D",
    "dropkey": "PX25455",
    "droptype": "D",
    "dropname": "MADISONVILLE",
    "dropdeladd": "161 WARREN ST",
    "dropdelcty": "MADISONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373549998,
    "dropphyadd": "161 WARREN ST",
    "dropphycty": "MADISONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373549998,
    "dropmaladd": "161 WARREN ST",
    "dropmalcty": "MADISONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234423647,
    "dropsitcph": 4234423647,
    "dropfax": 4234421742
  },
  {
    "dcode": "D",
    "dropkey": "PX25459",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "1601 HILLSBORO BLVD",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "TN",
    "dropdelzpp": 373559998,
    "dropphyadd": "1601 HILLSBORO BLVD",
    "dropphycty": "MANCHESTER",
    "dropphyst": "TN",
    "dropphyzpp": 373559998,
    "dropmaladd": "1601 HILLSBORO BLVD",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "TN",
    "dropmalzpp": 373559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317288868,
    "dropsitcph": 9317288868,
    "dropfax": 9317230433
  },
  {
    "dcode": "D",
    "dropkey": "PX25462",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "2154 MANSFIELD RD",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 382369998,
    "dropphyadd": "2154 MANSFIELD RD",
    "dropphycty": "MANSFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 382369998,
    "dropmaladd": "2154 MANSFIELD RD",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 382369998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7316424424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25464",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "100 UNIVERSITY ST",
    "dropdelcty": "MARTIN",
    "dropdelst": "TN",
    "dropdelzpp": 382379998,
    "dropphyadd": "100 UNIVERSITY ST",
    "dropphycty": "MARTIN",
    "dropphyst": "TN",
    "dropphyzpp": 382379998,
    "dropmaladd": "100 UNIVERSITY ST",
    "dropmalcty": "MARTIN",
    "dropmalst": "TN",
    "dropmalzpp": 382379998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315870567,
    "dropfax": 7315870594
  },
  {
    "dcode": "D",
    "dropkey": "PX25465",
    "droptype": "D",
    "dropname": "MARYVILLE",
    "dropdeladd": "226 KELLER LN",
    "dropdelcty": "MARYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378019998,
    "dropphyadd": "226 KELLER LN",
    "dropphycty": "MARYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378019998,
    "dropmaladd": "226 KELLER LN",
    "dropmalcty": "MARYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659829846,
    "dropsitcph": 8655180627,
    "dropfax": 8659811061
  },
  {
    "dcode": "D",
    "dropkey": "PX25467",
    "droptype": "D",
    "dropname": "MASCOT",
    "dropdeladd": "1925 NUMBER 2 DR",
    "dropdelcty": "MASCOT",
    "dropdelst": "TN",
    "dropdelzpp": 378069998,
    "dropphyadd": "1925 NUMBER 2 DR",
    "dropphycty": "MASCOT",
    "dropphyst": "TN",
    "dropphyzpp": 378069998,
    "dropmaladd": "1925 NUMBER 2 DR",
    "dropmalcty": "MASCOT",
    "dropmalst": "TN",
    "dropmalzpp": 378069998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659336511,
    "dropsitcph": 8659336511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25468",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "361 HIGHWAY 70 W",
    "dropdelcty": "MASON",
    "dropdelst": "TN",
    "dropdelzpp": 380497858,
    "dropphyadd": "361 HIGHWAY 70 W",
    "dropphycty": "MASON",
    "dropphyst": "TN",
    "dropphyzpp": 380497858,
    "dropmaladd": "361 HIGHWAY 70 W",
    "dropmalcty": "MASON",
    "dropmalst": "TN",
    "dropmalzpp": 380497858,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9012906826,
    "dropfax": 9012906696
  },
  {
    "dcode": "D",
    "dropkey": "PX25470",
    "droptype": "D",
    "dropname": "MAURY CITY",
    "dropdeladd": "116 N BROADWAY ST",
    "dropdelcty": "MAURY CITY",
    "dropdelst": "TN",
    "dropdelzpp": 380505000,
    "dropphyadd": "116 N BROADWAY ST",
    "dropphycty": "MAURY CITY",
    "dropphyst": "TN",
    "dropphyzpp": 380505000,
    "dropmaladd": "116 N BROADWAY ST",
    "dropmalcty": "MAURY CITY",
    "dropmalst": "TN",
    "dropmalzpp": 380505000,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316562869,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25473",
    "droptype": "D",
    "dropname": "MAYNARDVILLE",
    "dropdeladd": "3009 MAYNARDVILLE HWY",
    "dropdelcty": "MAYNARDVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378079998,
    "dropphyadd": "3009 MAYNARDVILLE HWY",
    "dropphycty": "MAYNARDVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378079998,
    "dropmaladd": "3009 MAYNARDVILLE HWY",
    "dropmalcty": "MAYNARDVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378079998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659928359,
    "dropsitcph": 8659928359,
    "dropfax": 8659928359
  },
  {
    "dcode": "D",
    "dropkey": "PX25476",
    "droptype": "D",
    "dropname": "MC DONALD",
    "dropdeladd": "4980 S LEE HWY",
    "dropdelcty": "MC DONALD",
    "dropdelst": "TN",
    "dropdelzpp": 373539998,
    "dropphyadd": "4980 S LEE HWY",
    "dropphycty": "MC DONALD",
    "dropphyst": "TN",
    "dropphyzpp": 373539998,
    "dropmaladd": "4980 S LEE HWY",
    "dropmalcty": "MC DONALD",
    "dropmalst": "TN",
    "dropmalzpp": 373539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234764042,
    "dropsitcph": 4234764042,
    "dropfax": 4236148952
  },
  {
    "dcode": "D",
    "dropkey": "PX25477",
    "droptype": "D",
    "dropname": "MC EWEN",
    "dropdeladd": "32 LONG ST E",
    "dropdelcty": "MC EWEN",
    "dropdelst": "TN",
    "dropdelzpp": 371019998,
    "dropphyadd": "32 LONG ST E",
    "dropphycty": "MC EWEN",
    "dropphyst": "TN",
    "dropphyzpp": 371019998,
    "dropmaladd": "32 LONG ST E",
    "dropmalcty": "MC EWEN",
    "dropmalst": "TN",
    "dropmalzpp": 371019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315823691,
    "dropsitcph": 9315823691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25479",
    "droptype": "D",
    "dropname": "MC KENZIE",
    "dropdeladd": "15075 HIGHLAND DR",
    "dropdelcty": "MC KENZIE",
    "dropdelst": "TN",
    "dropdelzpp": 382012356,
    "dropphyadd": "15075 HIGHLAND DR",
    "dropphycty": "MC KENZIE",
    "dropphyst": "TN",
    "dropphyzpp": 382012356,
    "dropmaladd": "15075 HIGHLAND DR",
    "dropmalcty": "MC KENZIE",
    "dropmalst": "TN",
    "dropmalzpp": 382012356,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7313527977,
    "dropfax": 7313520709
  },
  {
    "dcode": "D",
    "dropkey": "PX25480",
    "droptype": "D",
    "dropname": "MC LEMORESVILLE",
    "dropdeladd": "5605 MAIN ST",
    "dropdelcty": "MC LEMORESVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 382359998,
    "dropphyadd": "5605 MAIN ST",
    "dropphycty": "MC LEMORESVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 382359998,
    "dropmaladd": "5605 MAIN ST",
    "dropmalcty": "MC LEMORESVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 382359998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319868471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25483",
    "droptype": "D",
    "dropname": "MCMINNVILLE",
    "dropdeladd": "102 E COURT SQ",
    "dropdelcty": "MCMINNVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371109998,
    "dropphyadd": "102 E COURT SQ",
    "dropphycty": "MCMINNVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371109998,
    "dropmaladd": "102 E COURT SQ",
    "dropmalcty": "MCMINNVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314732555,
    "dropsitcph": 9314732555,
    "dropfax": 9314733120
  },
  {
    "dcode": "D",
    "dropkey": "PX25491",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "318 W CHURCH AVE",
    "dropdelcty": "MEDINA",
    "dropdelst": "TN",
    "dropdelzpp": 383559998,
    "dropphyadd": "318 W CHURCH AVE",
    "dropphycty": "MEDINA",
    "dropphyst": "TN",
    "dropphyzpp": 383559998,
    "dropmaladd": "318 W CHURCH AVE",
    "dropmalcty": "MEDINA",
    "dropmalst": "TN",
    "dropmalzpp": 383559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312262711,
    "dropfax": 7317833149
  },
  {
    "dcode": "D",
    "dropkey": "PX25492",
    "droptype": "D",
    "dropname": "MEDON",
    "dropdeladd": "2056 HIGHWAY 18",
    "dropdelcty": "MEDON",
    "dropdelst": "TN",
    "dropdelzpp": 383569998,
    "dropphyadd": "2056 HIGHWAY 18",
    "dropphycty": "MEDON",
    "dropphyst": "TN",
    "dropphyzpp": 383569998,
    "dropmaladd": "2056 HIGHWAY 18",
    "dropmalcty": "MEDON",
    "dropmalst": "TN",
    "dropmalzpp": 383569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314248244,
    "dropfax": 7314222116
  },
  {
    "dcode": "D",
    "dropkey": "PX25498",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "555 S B B KING BLVD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381019998,
    "dropphyadd": "555 S B B KING BLVD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381019998,
    "dropmaladd": "555 S B B KING BLVD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015213202,
    "dropsitcph": 9015212575,
    "dropfax": 9015213214
  },
  {
    "dcode": "D",
    "dropkey": "PX25502",
    "droptype": "D",
    "dropname": "MERCER",
    "dropdeladd": "7 FRONT ST",
    "dropdelcty": "MERCER",
    "dropdelst": "TN",
    "dropdelzpp": 383929998,
    "dropphyadd": "7 FRONT ST",
    "dropphycty": "MERCER",
    "dropphyst": "TN",
    "dropphyzpp": 383929998,
    "dropmaladd": "7 FRONT ST",
    "dropmalcty": "MERCER",
    "dropmalst": "TN",
    "dropmalzpp": 383929998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7319357238,
    "dropsitcph": 7319357238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25503",
    "droptype": "D",
    "dropname": "MICHIE",
    "dropdeladd": "6032 HIGHWAY 22",
    "dropdelcty": "MICHIE",
    "dropdelst": "TN",
    "dropdelzpp": 383579998,
    "dropphyadd": "6032 HIGHWAY 22",
    "dropphycty": "MICHIE",
    "dropphyst": "TN",
    "dropphyzpp": 383579998,
    "dropmaladd": "6032 HIGHWAY 22",
    "dropmalcty": "MICHIE",
    "dropmalst": "TN",
    "dropmalzpp": 383579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312398688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25506",
    "droptype": "D",
    "dropname": "MIDDLETON",
    "dropdeladd": "296 S MAIN ST",
    "dropdelcty": "MIDDLETON",
    "dropdelst": "TN",
    "dropdelzpp": 380529998,
    "dropphyadd": "296 S MAIN ST",
    "dropphycty": "MIDDLETON",
    "dropphyst": "TN",
    "dropphyzpp": 380529998,
    "dropmaladd": "296 S MAIN ST",
    "dropmalcty": "MIDDLETON",
    "dropmalst": "TN",
    "dropmalzpp": 380529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7313760175,
    "dropsitcph": 7313760175,
    "dropfax": 7313762113
  },
  {
    "dcode": "D",
    "dropkey": "PX25509",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "1170 S MAIN ST",
    "dropdelcty": "MILAN",
    "dropdelst": "TN",
    "dropdelzpp": 383589998,
    "dropphyadd": "1170 S MAIN ST",
    "dropphycty": "MILAN",
    "dropphyst": "TN",
    "dropphyzpp": 383589998,
    "dropmaladd": "1170 S MAIN ST",
    "dropmalcty": "MILAN",
    "dropmalst": "TN",
    "dropmalzpp": 383589998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316868416,
    "dropfax": 7316869053
  },
  {
    "dcode": "D",
    "dropkey": "PX25511",
    "droptype": "D",
    "dropname": "MILLEDGEVILLE",
    "dropdeladd": "71 SALTILLO RD",
    "dropdelcty": "MILLEDGEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383599998,
    "dropphyadd": "71 SALTILLO RD",
    "dropphycty": "MILLEDGEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383599998,
    "dropmaladd": "71 SALTILLO RD",
    "dropmalcty": "MILLEDGEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316873384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25518",
    "droptype": "D",
    "dropname": "MILLIGAN",
    "dropdeladd": "101 NETH DR",
    "dropdelcty": "MILLIGAN",
    "dropdelst": "TN",
    "dropdelzpp": 376825002,
    "dropphyadd": "101 NETH DR",
    "dropphycty": "MILLIGAN",
    "dropphyst": "TN",
    "dropphyzpp": 376825002,
    "dropmaladd": "101 NETH DR",
    "dropmalcty": "MILLIGAN",
    "dropmalst": "TN",
    "dropmalzpp": 376825002,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239290837,
    "dropsitcph": 4239290837,
    "dropfax": 4239298630
  },
  {
    "dcode": "D",
    "dropkey": "PX25520",
    "droptype": "D",
    "dropname": "MILLINGTON",
    "dropdeladd": "4847 NAVY RD",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "TN",
    "dropdelzpp": 380539998,
    "dropphyadd": "4847 NAVY RD",
    "dropphycty": "MILLINGTON",
    "dropphyst": "TN",
    "dropphyzpp": 380539998,
    "dropmaladd": "4847 NAVY RD",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "TN",
    "dropmalzpp": 380539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018724591,
    "dropsitcph": 9018724591,
    "dropfax": 9018727193
  },
  {
    "dcode": "D",
    "dropkey": "PX25522",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "12017 MILTON ST",
    "dropdelcty": "MILTON",
    "dropdelst": "TN",
    "dropdelzpp": 371189998,
    "dropphyadd": "12017 MILTON ST",
    "dropphycty": "MILTON",
    "dropphyst": "TN",
    "dropphyzpp": 371189998,
    "dropmaladd": "12017 MILTON ST",
    "dropmalcty": "MILTON",
    "dropmalst": "TN",
    "dropmalzpp": 371189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152732766,
    "dropsitcph": 6152732766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25523",
    "droptype": "D",
    "dropname": "MINOR HILL",
    "dropdeladd": "12883 MINOR HILL HWY",
    "dropdelcty": "MINOR HILL",
    "dropdelst": "TN",
    "dropdelzpp": 384739998,
    "dropphyadd": "12883 MINOR HILL HWY",
    "dropphycty": "MINOR HILL",
    "dropphyst": "TN",
    "dropphyzpp": 384739998,
    "dropmaladd": "12883 MINOR HILL HWY",
    "dropmalcty": "MINOR HILL",
    "dropmalst": "TN",
    "dropmalzpp": 384739998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315653434,
    "dropsitcph": 9315653434,
    "dropfax": 9315653434
  },
  {
    "dcode": "D",
    "dropkey": "PX25528",
    "droptype": "D",
    "dropname": "MOHAWK",
    "dropdeladd": "2250 PHILLIPI RD",
    "dropdelcty": "MOHAWK",
    "dropdelst": "TN",
    "dropdelzpp": 378109998,
    "dropphyadd": "2250 PHILLIPI RD",
    "dropphycty": "MOHAWK",
    "dropphyst": "TN",
    "dropphyzpp": 378109998,
    "dropmaladd": "2250 PHILLIPI RD",
    "dropmalcty": "MOHAWK",
    "dropmalst": "TN",
    "dropmalzpp": 378109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232356498,
    "dropsitcph": 4232356498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25529",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "108 POST OFFICE LN",
    "dropdelcty": "MONROE",
    "dropdelst": "TN",
    "dropdelzpp": 385739998,
    "dropphyadd": "108 POST OFFICE LN",
    "dropphycty": "MONROE",
    "dropphyst": "TN",
    "dropphyzpp": 385739998,
    "dropmaladd": "108 POST OFFICE LN",
    "dropmalcty": "MONROE",
    "dropmalst": "TN",
    "dropmalzpp": 385739998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318234605,
    "dropsitcph": 9318234605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25530",
    "droptype": "D",
    "dropname": "MONTEAGLE",
    "dropdeladd": "320 MOFFAT ST",
    "dropdelcty": "MONTEAGLE",
    "dropdelst": "TN",
    "dropdelzpp": 373569998,
    "dropphyadd": "320 MOFFAT ST",
    "dropphycty": "MONTEAGLE",
    "dropphyst": "TN",
    "dropphyzpp": 373569998,
    "dropmaladd": "320 MOFFAT ST",
    "dropmalcty": "MONTEAGLE",
    "dropmalst": "TN",
    "dropmalzpp": 373569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319242118,
    "dropsitcph": 9319242118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25531",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "304 W COMMERCIAL AVE",
    "dropdelcty": "MONTEREY",
    "dropdelst": "TN",
    "dropdelzpp": 385749998,
    "dropphyadd": "304 W COMMERCIAL AVE",
    "dropphycty": "MONTEREY",
    "dropphyst": "TN",
    "dropphyzpp": 385749998,
    "dropmaladd": "304 W COMMERCIAL AVE",
    "dropmalcty": "MONTEREY",
    "dropmalst": "TN",
    "dropmalzpp": 385749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318393871,
    "dropsitcph": 9318392745,
    "dropfax": 9318396679
  },
  {
    "dcode": "D",
    "dropkey": "PX25532",
    "droptype": "D",
    "dropname": "MOORESBURG",
    "dropdeladd": "110 LORETTA LN",
    "dropdelcty": "MOORESBURG",
    "dropdelst": "TN",
    "dropdelzpp": 378119998,
    "dropphyadd": "110 LORETTA LN",
    "dropphycty": "MOORESBURG",
    "dropphyst": "TN",
    "dropphyzpp": 378119998,
    "dropmaladd": "110 LORETTA LN",
    "dropmalcty": "MOORESBURG",
    "dropmalst": "TN",
    "dropmalzpp": 378119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659932599,
    "dropsitcph": 8659932599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25535",
    "droptype": "D",
    "dropname": "MORRIS CHAPEL",
    "dropdeladd": "8825 COFFEE LANDING RD",
    "dropdelcty": "MORRIS CHAPEL",
    "dropdelst": "TN",
    "dropdelzpp": 383619998,
    "dropphyadd": "8825 COFFEE LANDING RD",
    "dropphycty": "MORRIS CHAPEL",
    "dropphyst": "TN",
    "dropphyzpp": 383619998,
    "dropmaladd": "8825 COFFEE LANDING RD",
    "dropmalcty": "MORRIS CHAPEL",
    "dropmalst": "TN",
    "dropmalzpp": 383619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316873183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25537",
    "droptype": "D",
    "dropname": "MORRISON",
    "dropdeladd": "140 E MAPLE ST",
    "dropdelcty": "MORRISON",
    "dropdelst": "TN",
    "dropdelzpp": 373579998,
    "dropphyadd": "140 E MAPLE ST",
    "dropphycty": "MORRISON",
    "dropphyst": "TN",
    "dropphyzpp": 373579998,
    "dropmaladd": "140 E MAPLE ST",
    "dropmalcty": "MORRISON",
    "dropmalst": "TN",
    "dropmalzpp": 373579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316352941,
    "dropsitcph": 9316352941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25538",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "803 S CUMBERLAND ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 378139998,
    "dropphyadd": "803 S CUMBERLAND ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 378139998,
    "dropmaladd": "803 S CUMBERLAND ST",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 378139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235818471,
    "dropsitcph": 4235815572,
    "dropfax": 4235874848
  },
  {
    "dcode": "D",
    "dropkey": "PX25539",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "90 4TH AVE",
    "dropdelcty": "MOSCOW",
    "dropdelst": "TN",
    "dropdelzpp": 380579998,
    "dropphyadd": "90 4TH AVE",
    "dropphycty": "MOSCOW",
    "dropphyst": "TN",
    "dropphyzpp": 380579998,
    "dropmaladd": "90 4TH AVE",
    "dropmalcty": "MOSCOW",
    "dropmalst": "TN",
    "dropmalzpp": 380579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018773433,
    "dropsitcph": 9018773433,
    "dropfax": 9018777307
  },
  {
    "dcode": "D",
    "dropkey": "PX25540",
    "droptype": "D",
    "dropname": "MOSHEIM",
    "dropdeladd": "9280 W ANDREW JOHNSON HWY",
    "dropdelcty": "MOSHEIM",
    "dropdelst": "TN",
    "dropdelzpp": 378189998,
    "dropphyadd": "9280 W ANDREW JOHNSON HWY",
    "dropphycty": "MOSHEIM",
    "dropphyst": "TN",
    "dropphyzpp": 378189998,
    "dropmaladd": "9280 W ANDREW JOHNSON HWY",
    "dropmalcty": "MOSHEIM",
    "dropmalst": "TN",
    "dropmalzpp": 378189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234227221,
    "dropsitcph": 4234227221,
    "dropfax": 4234227221
  },
  {
    "dcode": "D",
    "dropkey": "PX25541",
    "droptype": "D",
    "dropname": "MOSS",
    "dropdeladd": "7550 CLAY COUNTY HWY",
    "dropdelcty": "MOSS",
    "dropdelst": "TN",
    "dropdelzpp": 385759998,
    "dropphyadd": "7550 CLAY COUNTY HWY",
    "dropphycty": "MOSS",
    "dropphyst": "TN",
    "dropphyzpp": 385759998,
    "dropmaladd": "7550 CLAY COUNTY HWY",
    "dropmalcty": "MOSS",
    "dropmalst": "TN",
    "dropmalzpp": 385759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312583411,
    "dropsitcph": 9312583411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25543",
    "droptype": "D",
    "dropname": "MOUNT JULIET",
    "dropdeladd": "2491 N MOUNT JULIET RD",
    "dropdelcty": "MOUNT JULIET",
    "dropdelst": "TN",
    "dropdelzpp": 371229998,
    "dropphyadd": "2491 N MOUNT JULIET RD",
    "dropphycty": "MOUNT JULIET",
    "dropphyst": "TN",
    "dropphyzpp": 371229998,
    "dropmaladd": "2491 N MOUNT JULIET RD",
    "dropmalcty": "MOUNT JULIET",
    "dropmalst": "TN",
    "dropmalzpp": 371229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157733516,
    "dropsitcph": 6157733516,
    "dropfax": 6157731818
  },
  {
    "dcode": "D",
    "dropkey": "PX25544",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "TN",
    "dropdelzpp": 384749998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "TN",
    "dropphyzpp": 384749998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "TN",
    "dropmalzpp": 384749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313793285,
    "dropsitcph": 9313793285,
    "dropfax": 9313790117
  },
  {
    "dcode": "D",
    "dropkey": "PX25546",
    "droptype": "D",
    "dropname": "MOUNTAIN CITY",
    "dropdeladd": "216 COLLEGE ST",
    "dropdelcty": "MOUNTAIN CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376839998,
    "dropphyadd": "216 COLLEGE ST",
    "dropphycty": "MOUNTAIN CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376839998,
    "dropmaladd": "216 COLLEGE ST",
    "dropmalcty": "MOUNTAIN CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376839998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237276201,
    "dropsitcph": 4237276201,
    "dropfax": 4237278431
  },
  {
    "dcode": "D",
    "dropkey": "PX25547",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME",
    "dropdeladd": "53 MEMORIAL AVE",
    "dropdelcty": "MOUNTAIN HOME",
    "dropdelst": "TN",
    "dropdelzpp": 376849998,
    "dropphyadd": "53 MEMORIAL AVE",
    "dropphycty": "MOUNTAIN HOME",
    "dropphyst": "TN",
    "dropphyzpp": 376849998,
    "dropmaladd": "53 MEMORIAL AVE",
    "dropmalcty": "MOUNTAIN HOME",
    "dropmalst": "TN",
    "dropmalzpp": 376849998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239264804,
    "dropsitcph": 4239264804,
    "dropfax": 4239275853
  },
  {
    "dcode": "D",
    "dropkey": "PX25556",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "27 OLD LYNCHBURG HWY NE",
    "dropdelcty": "MULBERRY",
    "dropdelst": "TN",
    "dropdelzpp": 373599998,
    "dropphyadd": "27 OLD LYNCHBURG HWY NE",
    "dropphycty": "MULBERRY",
    "dropphyst": "TN",
    "dropphyzpp": 373599998,
    "dropmaladd": "27 OLD LYNCHBURG HWY NE",
    "dropmalcty": "MULBERRY",
    "dropmalst": "TN",
    "dropmalzpp": 373599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314335771,
    "dropsitcph": 9314335771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25557",
    "droptype": "D",
    "dropname": "MUNFORD",
    "dropdeladd": "25 BASS ST",
    "dropdelcty": "MUNFORD",
    "dropdelst": "TN",
    "dropdelzpp": 380582631,
    "dropphyadd": "25 BASS ST",
    "dropphycty": "MUNFORD",
    "dropphyst": "TN",
    "dropphyzpp": 380582631,
    "dropmaladd": "25 BASS ST",
    "dropmalcty": "MUNFORD",
    "dropmalst": "TN",
    "dropmalzpp": 380582631,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9018378744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25558",
    "droptype": "D",
    "dropname": "MURFREESBORO",
    "dropdeladd": "2255 MEMORIAL BLVD",
    "dropdelcty": "MURFREESBORO",
    "dropdelst": "TN",
    "dropdelzpp": 371299998,
    "dropphyadd": "2255 MEMORIAL BLVD",
    "dropphycty": "MURFREESBORO",
    "dropphyst": "TN",
    "dropphyzpp": 371299998,
    "dropmaladd": "2255 MEMORIAL BLVD",
    "dropmalcty": "MURFREESBORO",
    "dropmalst": "TN",
    "dropmalzpp": 371299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152174763,
    "dropsitcph": 6152174763,
    "dropfax": 6159076582
  },
  {
    "dcode": "D",
    "dropkey": "PX25566",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "901 BROADWAY",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372029998,
    "dropphyadd": "901 BROADWAY",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372029998,
    "dropmaladd": "901 BROADWAY",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372029998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158725642,
    "dropsitcph": 6158725642,
    "dropfax": 6158725765
  },
  {
    "dcode": "D",
    "dropkey": "PX25575",
    "droptype": "D",
    "dropname": "NEW JOHNSONVILLE",
    "dropdeladd": "556 BROADWAY AVE",
    "dropdelcty": "NEW JOHNSONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371349998,
    "dropphyadd": "556 BROADWAY AVE",
    "dropphycty": "NEW JOHNSONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371349998,
    "dropmaladd": "556 BROADWAY AVE",
    "dropmalcty": "NEW JOHNSONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371349998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315352490,
    "dropsitcph": 9315352490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25577",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "911 W HIGHWAY 11E",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "TN",
    "dropdelzpp": 378209998,
    "dropphyadd": "911 W HIGHWAY 11E",
    "dropphycty": "NEW MARKET",
    "dropphyst": "TN",
    "dropphyzpp": 378209998,
    "dropmaladd": "911 W HIGHWAY 11E",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "TN",
    "dropmalzpp": 378209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654710168,
    "dropsitcph": 8654710168,
    "dropfax": 8654751249
  },
  {
    "dcode": "D",
    "dropkey": "PX25582",
    "droptype": "D",
    "dropname": "NEW TAZEWELL",
    "dropdeladd": "855 MAIN ST",
    "dropdelcty": "NEW TAZEWELL",
    "dropdelst": "TN",
    "dropdelzpp": 378259998,
    "dropphyadd": "855 MAIN ST",
    "dropphycty": "NEW TAZEWELL",
    "dropphyst": "TN",
    "dropphyzpp": 378259998,
    "dropmaladd": "855 MAIN ST",
    "dropmalcty": "NEW TAZEWELL",
    "dropmalst": "TN",
    "dropmalzpp": 378259998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236260201,
    "dropsitcph": 4236260201,
    "dropfax": 4236264511
  },
  {
    "dcode": "D",
    "dropkey": "PX25583",
    "droptype": "D",
    "dropname": "NEWBERN",
    "dropdeladd": "105 BIFFLE RD",
    "dropdelcty": "NEWBERN",
    "dropdelst": "TN",
    "dropdelzpp": 380595265,
    "dropphyadd": "105 BIFFLE RD",
    "dropphycty": "NEWBERN",
    "dropphyst": "TN",
    "dropphyzpp": 380595265,
    "dropmaladd": "105 BIFFLE RD",
    "dropmalcty": "NEWBERN",
    "dropmalst": "TN",
    "dropmalzpp": 380595265,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316273803,
    "dropsitcph": 7316273803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25586",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "265 COSBY HWY",
    "dropdelcty": "NEWPORT",
    "dropdelst": "TN",
    "dropdelzpp": 378219998,
    "dropphyadd": "265 COSBY HWY",
    "dropphycty": "NEWPORT",
    "dropphyst": "TN",
    "dropphyzpp": 378219998,
    "dropmaladd": "265 COSBY HWY",
    "dropmalcty": "NEWPORT",
    "dropmalst": "TN",
    "dropmalzpp": 378219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236236137,
    "dropsitcph": 4236236136,
    "dropfax": 4236238397
  },
  {
    "dcode": "D",
    "dropkey": "PX25587",
    "droptype": "D",
    "dropname": "NIOTA",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "NIOTA",
    "dropdelst": "TN",
    "dropdelzpp": 378269998,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "NIOTA",
    "dropphyst": "TN",
    "dropphyzpp": 378269998,
    "dropmaladd": "102 E MAIN ST",
    "dropmalcty": "NIOTA",
    "dropmalst": "TN",
    "dropmalzpp": 378269998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235682590,
    "dropsitcph": 4235682590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25588",
    "droptype": "D",
    "dropname": "NOLENSVILLE",
    "dropdeladd": "923 OLDHAM DR",
    "dropdelcty": "NOLENSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371359998,
    "dropphyadd": "923 OLDHAM DR",
    "dropphycty": "NOLENSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371359998,
    "dropmaladd": "923 OLDHAM DR",
    "dropmalcty": "NOLENSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371359998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157762663,
    "dropsitcph": 6157762663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25591",
    "droptype": "D",
    "dropname": "NORENE",
    "dropdeladd": "11185 CAINSVILLE RD",
    "dropdelcty": "LEBANON",
    "dropdelst": "TN",
    "dropdelzpp": 370906710,
    "dropphyadd": "11185 CAINSVILLE RD",
    "dropphycty": "LEBANON",
    "dropphyst": "TN",
    "dropphyzpp": 370906710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORENE",
    "dropmalst": "TN",
    "dropmalzpp": 371369998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152862505,
    "dropsitcph": 6152862505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25593",
    "droptype": "D",
    "dropname": "NORMANDY",
    "dropdeladd": "1 CASCADE HOLLOW RD",
    "dropdelcty": "NORMANDY",
    "dropdelst": "TN",
    "dropdelzpp": 373609998,
    "dropphyadd": "1 CASCADE HOLLOW RD",
    "dropphycty": "NORMANDY",
    "dropphyst": "TN",
    "dropphyzpp": 373609998,
    "dropmaladd": "1 CASCADE HOLLOW RD",
    "dropmalcty": "NORMANDY",
    "dropmalst": "TN",
    "dropmalzpp": 373609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318579220,
    "dropsitcph": 9318579220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25594",
    "droptype": "D",
    "dropname": "NORRIS",
    "dropdeladd": "11 W NORRIS RD",
    "dropdelcty": "NORRIS",
    "dropdelst": "TN",
    "dropdelzpp": 378289998,
    "dropphyadd": "11 W NORRIS RD",
    "dropphycty": "NORRIS",
    "dropphyst": "TN",
    "dropphyzpp": 378289998,
    "dropmaladd": "11 W NORRIS RD",
    "dropmalcty": "NORRIS",
    "dropmalst": "TN",
    "dropmalzpp": 378289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654947777,
    "dropsitcph": 8654947777,
    "dropfax": 8654948953
  },
  {
    "dcode": "D",
    "dropkey": "PX25606",
    "droptype": "D",
    "dropname": "NUNNELLY",
    "dropdeladd": "3250 HIGHWAY 48 N",
    "dropdelcty": "NUNNELLY",
    "dropdelst": "TN",
    "dropdelzpp": 371379998,
    "dropphyadd": "3250 HIGHWAY 48 N",
    "dropphycty": "NUNNELLY",
    "dropphyst": "TN",
    "dropphyzpp": 371379998,
    "dropmaladd": "3250 HIGHWAY 48 N",
    "dropmalcty": "NUNNELLY",
    "dropmalst": "TN",
    "dropmalzpp": 371379998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317294452,
    "dropsitcph": 9317294452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25609",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "301 S TULANE AVE",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "TN",
    "dropdelzpp": 378309998,
    "dropphyadd": "301 S TULANE AVE",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "TN",
    "dropphyzpp": 378309998,
    "dropmaladd": "301 S TULANE AVE",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "TN",
    "dropmalzpp": 378309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654822750,
    "dropsitcph": 8654822750,
    "dropfax": 8654838777
  },
  {
    "dcode": "D",
    "dropkey": "PX25610",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "320 E MAIN ST",
    "dropdelcty": "OAKDALE",
    "dropdelst": "TN",
    "dropdelzpp": 378299998,
    "dropphyadd": "320 E MAIN ST",
    "dropphycty": "OAKDALE",
    "dropphyst": "TN",
    "dropphyzpp": 378299998,
    "dropmaladd": "320 E MAIN ST",
    "dropmalcty": "OAKDALE",
    "dropmalst": "TN",
    "dropmalzpp": 378299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233699311,
    "dropsitcph": 4233699311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25611",
    "droptype": "D",
    "dropname": "OAKFIELD",
    "dropdeladd": "288 OAKFIELD RD",
    "dropdelcty": "OAKFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 383629998,
    "dropphyadd": "288 OAKFIELD RD",
    "dropphycty": "OAKFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 383629998,
    "dropmaladd": "288 OAKFIELD RD",
    "dropmalcty": "OAKFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 383629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314276925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25612",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "14695 HIGHWAY 194",
    "dropdelcty": "OAKLAND",
    "dropdelst": "TN",
    "dropdelzpp": 380609998,
    "dropphyadd": "14695 HIGHWAY 194",
    "dropphycty": "OAKLAND",
    "dropphyst": "TN",
    "dropphyzpp": 380609998,
    "dropmaladd": "14695 HIGHWAY 194",
    "dropmalcty": "OAKLAND",
    "dropmalst": "TN",
    "dropmalzpp": 380609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9014652327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25613",
    "droptype": "D",
    "dropname": "OBION",
    "dropdeladd": "220 E PALESTINE AVE",
    "dropdelcty": "OBION",
    "dropdelst": "TN",
    "dropdelzpp": 382409998,
    "dropphyadd": "220 E PALESTINE AVE",
    "dropphycty": "OBION",
    "dropphyst": "TN",
    "dropphyzpp": 382409998,
    "dropmaladd": "220 E PALESTINE AVE",
    "dropmalcty": "OBION",
    "dropmalst": "TN",
    "dropmalzpp": 382409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315365531,
    "dropsitcph": 7315365531,
    "dropfax": 7315365889
  },
  {
    "dcode": "D",
    "dropkey": "PX25614",
    "droptype": "D",
    "dropname": "OCOEE",
    "dropdeladd": "3754 HIGHWAY 411",
    "dropdelcty": "OCOEE",
    "dropdelst": "TN",
    "dropdelzpp": 373619998,
    "dropphyadd": "3754 HIGHWAY 411",
    "dropphycty": "OCOEE",
    "dropphyst": "TN",
    "dropphyzpp": 373619998,
    "dropmaladd": "3754 HIGHWAY 411",
    "dropmalcty": "OCOEE",
    "dropmalst": "TN",
    "dropmalzpp": 373619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233389805,
    "dropsitcph": 4233389805,
    "dropfax": 4233384371
  },
  {
    "dcode": "D",
    "dropkey": "PX25616",
    "droptype": "D",
    "dropname": "OLD HICKORY",
    "dropdeladd": "1101 DONELSON AVE",
    "dropdelcty": "OLD HICKORY",
    "dropdelst": "TN",
    "dropdelzpp": 371389998,
    "dropphyadd": "1101 DONELSON AVE",
    "dropphycty": "OLD HICKORY",
    "dropphyst": "TN",
    "dropphyzpp": 371389998,
    "dropmaladd": "1101 DONELSON AVE",
    "dropmalcty": "OLD HICKORY",
    "dropmalst": "TN",
    "dropmalzpp": 371389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158479416,
    "dropsitcph": 6158478013,
    "dropfax": 6158473009
  },
  {
    "dcode": "D",
    "dropkey": "PX25617",
    "droptype": "D",
    "dropname": "OLD FORT",
    "dropdeladd": "2314 HIGHWAY 411",
    "dropdelcty": "OLD FORT",
    "dropdelst": "TN",
    "dropdelzpp": 373629998,
    "dropphyadd": "2314 HIGHWAY 411",
    "dropphycty": "OLD FORT",
    "dropphyst": "TN",
    "dropphyzpp": 373629998,
    "dropmaladd": "2314 HIGHWAY 411",
    "dropmalcty": "OLD FORT",
    "dropmalst": "TN",
    "dropmalzpp": 373629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233382206,
    "dropsitcph": 4233382206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25619",
    "droptype": "D",
    "dropname": "OLIVER SPRINGS",
    "dropdeladd": "200 W SPRING ST",
    "dropdelcty": "OLIVER SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 378409998,
    "dropphyadd": "200 W SPRING ST",
    "dropphycty": "OLIVER SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 378409998,
    "dropmaladd": "200 W SPRING ST",
    "dropmalcty": "OLIVER SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 378409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654357753,
    "dropsitcph": 8654357753,
    "dropfax": 8654357715
  },
  {
    "dcode": "D",
    "dropkey": "PX25620",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "103 E 2ND AVE",
    "dropdelcty": "ONEIDA",
    "dropdelst": "TN",
    "dropdelzpp": 378419998,
    "dropphyadd": "103 E 2ND AVE",
    "dropphycty": "ONEIDA",
    "dropphyst": "TN",
    "dropphyzpp": 378419998,
    "dropmaladd": "103 E 2ND AVE",
    "dropmalcty": "ONEIDA",
    "dropmalst": "TN",
    "dropmalzpp": 378419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235698353,
    "dropsitcph": 4235698353,
    "dropfax": 4235694049
  },
  {
    "dcode": "D",
    "dropkey": "PX25622",
    "droptype": "D",
    "dropname": "OOLTEWAH",
    "dropdeladd": "9301 OCOEE ST",
    "dropdelcty": "OOLTEWAH",
    "dropdelst": "TN",
    "dropdelzpp": 373639998,
    "dropphyadd": "9301 OCOEE ST",
    "dropphycty": "OOLTEWAH",
    "dropphyst": "TN",
    "dropphyzpp": 373639998,
    "dropmaladd": "9301 OCOEE ST",
    "dropmalcty": "OOLTEWAH",
    "dropmalst": "TN",
    "dropmalzpp": 373639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232387776,
    "dropsitcph": 4232387776,
    "dropfax": 4232388593
  },
  {
    "dcode": "D",
    "dropkey": "PX25623",
    "droptype": "D",
    "dropname": "ORLINDA",
    "dropdeladd": "7503 HIGHWAY 52",
    "dropdelcty": "ORLINDA",
    "dropdelst": "TN",
    "dropdelzpp": 371419998,
    "dropphyadd": "7503 HIGHWAY 52",
    "dropphycty": "ORLINDA",
    "dropphyst": "TN",
    "dropphyzpp": 371419998,
    "dropmaladd": "7503 HIGHWAY 52",
    "dropmalcty": "ORLINDA",
    "dropmalst": "TN",
    "dropmalzpp": 371419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156543967,
    "dropsitcph": 6156543967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25625",
    "droptype": "D",
    "dropname": "PALL MALL",
    "dropdeladd": "2606 N YORK HWY",
    "dropdelcty": "PALL MALL",
    "dropdelst": "TN",
    "dropdelzpp": 385779998,
    "dropphyadd": "2606 N YORK HWY",
    "dropphycty": "PALL MALL",
    "dropphyst": "TN",
    "dropphyzpp": 385779998,
    "dropmaladd": "2606 N YORK HWY",
    "dropmalcty": "PALL MALL",
    "dropmalst": "TN",
    "dropmalzpp": 385779998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318795566,
    "dropsitcph": 9318795566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25626",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "739 MAIN ST",
    "dropdelcty": "PALMER",
    "dropdelst": "TN",
    "dropdelzpp": 373659998,
    "dropphyadd": "739 MAIN ST",
    "dropphycty": "PALMER",
    "dropphyst": "TN",
    "dropphyzpp": 373659998,
    "dropmaladd": "739 MAIN ST",
    "dropmalcty": "PALMER",
    "dropmalst": "TN",
    "dropmalzpp": 373659998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317793300,
    "dropsitcph": 9317793300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25627",
    "droptype": "D",
    "dropname": "PALMERSVILLE",
    "dropdeladd": "6180 HIGHWAY 89",
    "dropdelcty": "PALMERSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 382419998,
    "dropphyadd": "6180 HIGHWAY 89",
    "dropphycty": "PALMERSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 382419998,
    "dropmaladd": "6180 HIGHWAY 89",
    "dropmalcty": "PALMERSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 382419998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7318226415,
    "dropfax": 7318226415
  },
  {
    "dcode": "D",
    "dropkey": "PX25631",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "105 W WOOD ST",
    "dropdelcty": "PARIS",
    "dropdelst": "TN",
    "dropdelzpp": 382429998,
    "dropphyadd": "105 W WOOD ST",
    "dropphycty": "PARIS",
    "dropphyst": "TN",
    "dropphyzpp": 382429998,
    "dropmaladd": "105 W WOOD ST",
    "dropmalcty": "PARIS",
    "dropmalst": "TN",
    "dropmalzpp": 382429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7316423881,
    "dropfax": 7316420706
  },
  {
    "dcode": "D",
    "dropkey": "PX25634",
    "droptype": "D",
    "dropname": "PARROTTSVILLE",
    "dropdeladd": "2053 OLD PARROTTSVILLE HWY",
    "dropdelcty": "PARROTTSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378432681,
    "dropphyadd": "2053 OLD PARROTTSVILLE HWY",
    "dropphycty": "PARROTTSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378432681,
    "dropmaladd": "2053 OLD PARROTTSVILLE HWY",
    "dropmalcty": "PARROTTSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378432681,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236235500,
    "dropsitcph": 4236235500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25635",
    "droptype": "D",
    "dropname": "PARSONS",
    "dropdeladd": "764 TENNESSEE AVE N",
    "dropdelcty": "PARSONS",
    "dropdelst": "TN",
    "dropdelzpp": 383639998,
    "dropphyadd": "764 TENNESSEE AVE N",
    "dropphycty": "PARSONS",
    "dropphyst": "TN",
    "dropphyzpp": 383639998,
    "dropmaladd": "764 TENNESSEE AVE N",
    "dropmalcty": "PARSONS",
    "dropmalst": "TN",
    "dropmalzpp": 383639998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7318472843,
    "dropsitcph": 7318472843,
    "dropfax": 7318472548
  },
  {
    "dcode": "D",
    "dropkey": "PX25636",
    "droptype": "D",
    "dropname": "PEGRAM",
    "dropdeladd": "502 HIGHWAY 70",
    "dropdelcty": "PEGRAM",
    "dropdelst": "TN",
    "dropdelzpp": 371439998,
    "dropphyadd": "502 HIGHWAY 70",
    "dropphycty": "PEGRAM",
    "dropphyst": "TN",
    "dropphyzpp": 371439998,
    "dropmaladd": "502 HIGHWAY 70",
    "dropmalcty": "PEGRAM",
    "dropmalst": "TN",
    "dropmalzpp": 371439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156466886,
    "dropsitcph": 6156466886,
    "dropfax": 6156737339
  },
  {
    "dcode": "D",
    "dropkey": "PX25637",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "1619 US 41",
    "dropdelcty": "PELHAM",
    "dropdelst": "TN",
    "dropdelzpp": 373669998,
    "dropphyadd": "1619 US 41",
    "dropphycty": "PELHAM",
    "dropphyst": "TN",
    "dropphyzpp": 373669998,
    "dropmaladd": "1619 US 41",
    "dropmalcty": "PELHAM",
    "dropmalst": "TN",
    "dropmalzpp": 373669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314673270,
    "dropsitcph": 9314673270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25639",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "100 NORTHSIDE SQ",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "TN",
    "dropdelzpp": 371449998,
    "dropphyadd": "100 NORTHSIDE SQ",
    "dropphycty": "PETERSBURG",
    "dropphyst": "TN",
    "dropphyzpp": 371449998,
    "dropmaladd": "100 NORTHSIDE SQ",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "TN",
    "dropmalzpp": 371449998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316599228,
    "dropsitcph": 9316599228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25640",
    "droptype": "D",
    "dropname": "PETROS",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "PETROS",
    "dropdelst": "TN",
    "dropdelzpp": 378459998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "PETROS",
    "dropphyst": "TN",
    "dropphyzpp": 378459998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "PETROS",
    "dropmalst": "TN",
    "dropmalzpp": 378459998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233245095,
    "dropsitcph": 4233245095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25642",
    "droptype": "D",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "22730 W LEE HWY",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "TN",
    "dropdelzpp": 378469998,
    "dropphyadd": "22730 W LEE HWY",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "TN",
    "dropphyzpp": 378469998,
    "dropmaladd": "22730 W LEE HWY",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "TN",
    "dropmalzpp": 378469998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654583306,
    "dropsitcph": 8654583306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25644",
    "droptype": "D",
    "dropname": "PICKWICK DAM",
    "dropdeladd": "40 STATE PARK LN",
    "dropdelcty": "PICKWICK DAM",
    "dropdelst": "TN",
    "dropdelzpp": 383659998,
    "dropphyadd": "40 STATE PARK LN",
    "dropphycty": "PICKWICK DAM",
    "dropphyst": "TN",
    "dropphyzpp": 383659998,
    "dropmaladd": "40 STATE PARK LN",
    "dropmalcty": "PICKWICK DAM",
    "dropmalst": "TN",
    "dropmalzpp": 383659998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312448009,
    "dropsitcph": 7312448009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25647",
    "droptype": "D",
    "dropname": "PIKEVILLE",
    "dropdeladd": "3372 MAIN ST",
    "dropdelcty": "PIKEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373679998,
    "dropphyadd": "3372 MAIN ST",
    "dropphycty": "PIKEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373679998,
    "dropmaladd": "3372 MAIN ST",
    "dropmalcty": "PIKEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373679998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234472011,
    "dropsitcph": 4234472011,
    "dropfax": 4234477187
  },
  {
    "dcode": "D",
    "dropkey": "PX25650",
    "droptype": "D",
    "dropname": "PINEY FLATS",
    "dropdeladd": "257 JONESBORO RD",
    "dropdelcty": "PINEY FLATS",
    "dropdelst": "TN",
    "dropdelzpp": 376869998,
    "dropphyadd": "257 JONESBORO RD",
    "dropphycty": "PINEY FLATS",
    "dropphyst": "TN",
    "dropphyzpp": 376869998,
    "dropmaladd": "257 JONESBORO RD",
    "dropmalcty": "PINEY FLATS",
    "dropmalst": "TN",
    "dropmalzpp": 376869998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235386672,
    "dropsitcph": 4235386672,
    "dropfax": 4235389501
  },
  {
    "dcode": "D",
    "dropkey": "PX25651",
    "droptype": "D",
    "dropname": "PINSON",
    "dropdeladd": "4099 US HIGHWAY 45 S",
    "dropdelcty": "PINSON",
    "dropdelst": "TN",
    "dropdelzpp": 383669998,
    "dropphyadd": "4099 US HIGHWAY 45 S",
    "dropphycty": "PINSON",
    "dropphyst": "TN",
    "dropphyzpp": 383669998,
    "dropmaladd": "4099 US HIGHWAY 45 S",
    "dropmalcty": "PINSON",
    "dropmalst": "TN",
    "dropmalzpp": 383669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314223331,
    "dropfax": 7314223331
  },
  {
    "dcode": "D",
    "dropkey": "PX25652",
    "droptype": "D",
    "dropname": "PIONEER",
    "dropdeladd": "2444 HOWARD BAKER HWY",
    "dropdelcty": "PIONEER",
    "dropdelst": "TN",
    "dropdelzpp": 378479998,
    "dropphyadd": "2444 HOWARD BAKER HWY",
    "dropphycty": "PIONEER",
    "dropphyst": "TN",
    "dropphyzpp": 378479998,
    "dropmaladd": "2444 HOWARD BAKER HWY",
    "dropmalcty": "PIONEER",
    "dropmalst": "TN",
    "dropmalzpp": 378479998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237846942,
    "dropsitcph": 4237846942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25656",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "626 E MAIN ST",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "TN",
    "dropdelzpp": 385789998,
    "dropphyadd": "626 E MAIN ST",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "TN",
    "dropphyzpp": 385789998,
    "dropmaladd": "626 E MAIN ST",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "TN",
    "dropmalzpp": 385789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312773773,
    "dropsitcph": 9312773773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25658",
    "droptype": "D",
    "dropname": "PLEASANT SHADE",
    "dropdeladd": "19 POST OFFICE LN",
    "dropdelcty": "PLEASANT SHADE",
    "dropdelst": "TN",
    "dropdelzpp": 371459998,
    "dropphyadd": "19 POST OFFICE LN",
    "dropphycty": "PLEASANT SHADE",
    "dropphyst": "TN",
    "dropphyzpp": 371459998,
    "dropmaladd": "19 POST OFFICE LN",
    "dropmalcty": "PLEASANT SHADE",
    "dropmalst": "TN",
    "dropmalzpp": 371459998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156776150,
    "dropsitcph": 6156776150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25659",
    "droptype": "D",
    "dropname": "PLEASANT VIEW",
    "dropdeladd": "2550 HIGHWAY 49 E",
    "dropdelcty": "PLEASANT VIEW",
    "dropdelst": "TN",
    "dropdelzpp": 371469998,
    "dropphyadd": "2550 HIGHWAY 49 E",
    "dropphycty": "PLEASANT VIEW",
    "dropphyst": "TN",
    "dropphyzpp": 371469998,
    "dropmaladd": "2550 HIGHWAY 49 E",
    "dropmalcty": "PLEASANT VIEW",
    "dropmalst": "TN",
    "dropmalzpp": 371469998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157465552,
    "dropsitcph": 6157465552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25665",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "22350 HIGHWAY 57 W",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "TN",
    "dropdelzpp": 380619998,
    "dropphyadd": "22350 HIGHWAY 57 W",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "TN",
    "dropphyzpp": 380619998,
    "dropmaladd": "22350 HIGHWAY 57 W",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "TN",
    "dropmalzpp": 380619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7313768245,
    "dropfax": 7313762162
  },
  {
    "dcode": "D",
    "dropkey": "PX25666",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "130 VILLAGE DR",
    "dropdelcty": "PORTLAND",
    "dropdelst": "TN",
    "dropdelzpp": 371489998,
    "dropphyadd": "130 VILLAGE DR",
    "dropphycty": "PORTLAND",
    "dropphyst": "TN",
    "dropphyzpp": 371489998,
    "dropmaladd": "130 VILLAGE DR",
    "dropmalcty": "PORTLAND",
    "dropmalst": "TN",
    "dropmalzpp": 371489998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153254755,
    "dropsitcph": 6153254755,
    "dropfax": 6153252786
  },
  {
    "dcode": "D",
    "dropkey": "PX25669",
    "droptype": "D",
    "dropname": "POWELL",
    "dropdeladd": "3239 SHROPSHIRE BLVD",
    "dropdelcty": "POWELL",
    "dropdelst": "TN",
    "dropdelzpp": 378494644,
    "dropphyadd": "3239 SHROPSHIRE BLVD",
    "dropphycty": "POWELL",
    "dropphyst": "TN",
    "dropphyzpp": 378494644,
    "dropmaladd": "3239 SHROPSHIRE BLVD",
    "dropmalcty": "POWELL",
    "dropmalst": "TN",
    "dropmalzpp": 378494644,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659476227,
    "dropsitcph": 8659474880,
    "dropfax": 8659475227
  },
  {
    "dcode": "D",
    "dropkey": "PX25672",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "400 MAIN ST",
    "dropdelcty": "PROSPECT",
    "dropdelst": "TN",
    "dropdelzpp": 384779998,
    "dropphyadd": "400 MAIN ST",
    "dropphycty": "PROSPECT",
    "dropphyst": "TN",
    "dropphyzpp": 384779998,
    "dropmaladd": "400 MAIN ST",
    "dropmalcty": "PROSPECT",
    "dropmalst": "TN",
    "dropmalzpp": 384779998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313630351,
    "dropsitcph": 9313630351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25674",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "111 W COLLEGE ST",
    "dropdelcty": "PULASKI",
    "dropdelst": "TN",
    "dropdelzpp": 384789998,
    "dropphyadd": "111 W COLLEGE ST",
    "dropphycty": "PULASKI",
    "dropphyst": "TN",
    "dropphyzpp": 384789998,
    "dropmaladd": "111 W COLLEGE ST",
    "dropmalcty": "PULASKI",
    "dropmalst": "TN",
    "dropmalzpp": 384789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313635546,
    "dropsitcph": 9313635546,
    "dropfax": 9314241900
  },
  {
    "dcode": "D",
    "dropkey": "PX25675",
    "droptype": "D",
    "dropname": "PURYEAR",
    "dropdeladd": "100 W FRONT ST",
    "dropdelcty": "PURYEAR",
    "dropdelst": "TN",
    "dropdelzpp": 382519998,
    "dropphyadd": "100 W FRONT ST",
    "dropphycty": "PURYEAR",
    "dropphyst": "TN",
    "dropphyzpp": 382519998,
    "dropmaladd": "100 W FRONT ST",
    "dropmalcty": "PURYEAR",
    "dropmalst": "TN",
    "dropmalzpp": 382519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7312475157,
    "dropfax": 7312475164
  },
  {
    "dcode": "D",
    "dropkey": "PX25680",
    "droptype": "D",
    "dropname": "RAMER",
    "dropdeladd": "4283 HIGHWAY 57 W",
    "dropdelcty": "RAMER",
    "dropdelst": "TN",
    "dropdelzpp": 383679998,
    "dropphyadd": "4283 HIGHWAY 57 W",
    "dropphycty": "RAMER",
    "dropphyst": "TN",
    "dropphyzpp": 383679998,
    "dropmaladd": "4283 HIGHWAY 57 W",
    "dropmalcty": "RAMER",
    "dropmalst": "TN",
    "dropmalzpp": 383679998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316459571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25683",
    "droptype": "D",
    "dropname": "READYVILLE",
    "dropdeladd": "1828 OLD WOODBURY PIKE",
    "dropdelcty": "READYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371499998,
    "dropphyadd": "1828 OLD WOODBURY PIKE",
    "dropphycty": "READYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371499998,
    "dropmaladd": "1828 OLD WOODBURY PIKE",
    "dropmalcty": "READYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371499998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155634595,
    "dropsitcph": 6155634595,
    "dropfax": 6155634595
  },
  {
    "dcode": "D",
    "dropkey": "PX25686",
    "droptype": "D",
    "dropname": "REAGAN",
    "dropdeladd": "5810 HIGHWAY 100",
    "dropdelcty": "REAGAN",
    "dropdelst": "TN",
    "dropdelzpp": 383689998,
    "dropphyadd": "5810 HIGHWAY 100",
    "dropphycty": "REAGAN",
    "dropphyst": "TN",
    "dropphyzpp": 383689998,
    "dropmaladd": "5810 HIGHWAY 100",
    "dropmalcty": "REAGAN",
    "dropmalst": "TN",
    "dropmalzpp": 383689998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315499130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25689",
    "droptype": "D",
    "dropname": "RED BOILING SPRINGS",
    "dropdeladd": "134 MARKET ST",
    "dropdelcty": "RED BOILING SPRINGS",
    "dropdelst": "TN",
    "dropdelzpp": 371509998,
    "dropphyadd": "134 MARKET ST",
    "dropphycty": "RED BOILING SPRINGS",
    "dropphyst": "TN",
    "dropphyzpp": 371509998,
    "dropmaladd": "134 MARKET ST",
    "dropmalcty": "RED BOILING SPRINGS",
    "dropmalst": "TN",
    "dropmalzpp": 371509998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156992580,
    "dropsitcph": 6156992580,
    "dropfax": 6156993032
  },
  {
    "dcode": "D",
    "dropkey": "PX25692",
    "droptype": "D",
    "dropname": "RICEVILLE",
    "dropdeladd": "3804 HIGHWAY 11 S",
    "dropdelcty": "RICEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373709998,
    "dropphyadd": "3804 HIGHWAY 11 S",
    "dropphycty": "RICEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373709998,
    "dropmaladd": "3804 HIGHWAY 11 S",
    "dropmalcty": "RICEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234622587,
    "dropsitcph": 4234622587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25695",
    "droptype": "D",
    "dropname": "RICKMAN",
    "dropdeladd": "3907 RICKMAN RD",
    "dropdelcty": "RICKMAN",
    "dropdelst": "TN",
    "dropdelzpp": 385809998,
    "dropphyadd": "3907 RICKMAN RD",
    "dropphycty": "RICKMAN",
    "dropphyst": "TN",
    "dropphyzpp": 385809998,
    "dropmaladd": "3907 RICKMAN RD",
    "dropmalcty": "RICKMAN",
    "dropmalst": "TN",
    "dropmalzpp": 385809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314982391,
    "dropsitcph": 9314982391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25696",
    "droptype": "D",
    "dropname": "RIDDLETON",
    "dropdeladd": "73 RIDDLETON CIR",
    "dropdelcty": "RIDDLETON",
    "dropdelst": "TN",
    "dropdelzpp": 371519998,
    "dropphyadd": "73 RIDDLETON CIR",
    "dropphycty": "RIDDLETON",
    "dropphyst": "TN",
    "dropphyzpp": 371519998,
    "dropmaladd": "73 RIDDLETON CIR",
    "dropmalcty": "RIDDLETON",
    "dropmalst": "TN",
    "dropmalzpp": 371519998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157350616,
    "dropsitcph": 6157350616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25698",
    "droptype": "D",
    "dropname": "RIDGELY",
    "dropdeladd": "120 LAKE ST",
    "dropdelcty": "RIDGELY",
    "dropdelst": "TN",
    "dropdelzpp": 380801352,
    "dropphyadd": "120 LAKE ST",
    "dropphycty": "RIDGELY",
    "dropphyst": "TN",
    "dropphyzpp": 380801352,
    "dropmaladd": "120 LAKE ST",
    "dropmalcty": "RIDGELY",
    "dropmalst": "TN",
    "dropmalzpp": 380801352,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314424064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25699",
    "droptype": "D",
    "dropname": "RIDGETOP",
    "dropdeladd": "1736 HIGHWAY 41 S",
    "dropdelcty": "RIDGETOP",
    "dropdelst": "TN",
    "dropdelzpp": 371529998,
    "dropphyadd": "1736 HIGHWAY 41 S",
    "dropphycty": "RIDGETOP",
    "dropphyst": "TN",
    "dropphyzpp": 371529998,
    "dropmaladd": "1736 HIGHWAY 41 S",
    "dropmalcty": "RIDGETOP",
    "dropmalst": "TN",
    "dropmalzpp": 371529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158590356,
    "dropsitcph": 6158590356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25700",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "117 E JACKSON AVE",
    "dropdelcty": "RIPLEY",
    "dropdelst": "TN",
    "dropdelzpp": 380631541,
    "dropphyadd": "117 E JACKSON AVE",
    "dropphycty": "RIPLEY",
    "dropphyst": "TN",
    "dropphyzpp": 380631541,
    "dropmaladd": "117 E JACKSON AVE",
    "dropmalcty": "RIPLEY",
    "dropmalst": "TN",
    "dropmalzpp": 380631541,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316359691,
    "dropfax": 7316359404
  },
  {
    "dcode": "D",
    "dropkey": "PX25702",
    "droptype": "D",
    "dropname": "RIVES",
    "dropdeladd": "498 S FRONT ST",
    "dropdelcty": "RIVES",
    "dropdelst": "TN",
    "dropdelzpp": 382539998,
    "dropphyadd": "498 S FRONT ST",
    "dropphycty": "RIVES",
    "dropphyst": "TN",
    "dropphyzpp": 382539998,
    "dropmaladd": "498 S FRONT ST",
    "dropmalcty": "RIVES",
    "dropmalst": "TN",
    "dropmalzpp": 382539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315365790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25703",
    "droptype": "D",
    "dropname": "ROAN MOUNTAIN",
    "dropdeladd": "8060 HIGHWAY 19 E",
    "dropdelcty": "ROAN MOUNTAIN",
    "dropdelst": "TN",
    "dropdelzpp": 376879998,
    "dropphyadd": "8060 HIGHWAY 19 E",
    "dropphycty": "ROAN MOUNTAIN",
    "dropphyst": "TN",
    "dropphyzpp": 376879998,
    "dropmaladd": "8060 HIGHWAY 19 E",
    "dropmalcty": "ROAN MOUNTAIN",
    "dropmalst": "TN",
    "dropmalzpp": 376879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237723014,
    "dropsitcph": 4237723014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25706",
    "droptype": "D",
    "dropname": "ROBBINS",
    "dropdeladd": "5900 SCOTT HWY",
    "dropdelcty": "ROBBINS",
    "dropdelst": "TN",
    "dropdelzpp": 378529998,
    "dropphyadd": "5900 SCOTT HWY",
    "dropphycty": "ROBBINS",
    "dropphyst": "TN",
    "dropphyzpp": 378529998,
    "dropmaladd": "5900 SCOTT HWY",
    "dropmalcty": "ROBBINS",
    "dropmalst": "TN",
    "dropmalzpp": 378529998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236272520,
    "dropsitcph": 4234440520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25708",
    "droptype": "D",
    "dropname": "ROCK ISLAND",
    "dropdeladd": "1190 ROCK ISLAND RD",
    "dropdelcty": "ROCK ISLAND",
    "dropdelst": "TN",
    "dropdelzpp": 385819998,
    "dropphyadd": "1190 ROCK ISLAND RD",
    "dropphycty": "ROCK ISLAND",
    "dropphyst": "TN",
    "dropphyzpp": 385819998,
    "dropmaladd": "1190 ROCK ISLAND RD",
    "dropmalcty": "ROCK ISLAND",
    "dropmalst": "TN",
    "dropmalzpp": 385819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316862523,
    "dropsitcph": 9316862523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25709",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "3902 LITTLE RIVER RD",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "TN",
    "dropdelzpp": 378539998,
    "dropphyadd": "3902 LITTLE RIVER RD",
    "dropphycty": "ROCKFORD",
    "dropphyst": "TN",
    "dropphyzpp": 378539998,
    "dropmaladd": "3902 LITTLE RIVER RD",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "TN",
    "dropmalzpp": 378539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659707617,
    "dropsitcph": 8659814597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25710",
    "droptype": "D",
    "dropname": "ROCKVALE",
    "dropdeladd": "8000 HIGHWAY 99",
    "dropdelcty": "ROCKVALE",
    "dropdelst": "TN",
    "dropdelzpp": 371539998,
    "dropphyadd": "8000 HIGHWAY 99",
    "dropphycty": "ROCKVALE",
    "dropphyst": "TN",
    "dropphyzpp": 371539998,
    "dropmaladd": "8000 HIGHWAY 99",
    "dropmalcty": "ROCKVALE",
    "dropmalst": "TN",
    "dropmalzpp": 371539998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152746205,
    "dropsitcph": 6152746205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25711",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "340 W ROCKWOOD ST",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 378549998,
    "dropphyadd": "340 W ROCKWOOD ST",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 378549998,
    "dropmaladd": "340 W ROCKWOOD ST",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 378549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8653541406,
    "dropsitcph": 8653546066,
    "dropfax": 8653543045
  },
  {
    "dcode": "D",
    "dropkey": "PX25712",
    "droptype": "D",
    "dropname": "ROGERSVILLE",
    "dropdeladd": "203 W MAIN ST",
    "dropdelcty": "ROGERSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378579998,
    "dropphyadd": "203 W MAIN ST",
    "dropphycty": "ROGERSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378579998,
    "dropmaladd": "203 W MAIN ST",
    "dropmalcty": "ROGERSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378579998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232728096,
    "dropsitcph": 4232728096,
    "dropfax": 4232728309
  },
  {
    "dcode": "D",
    "dropkey": "PX25714",
    "droptype": "D",
    "dropname": "ROSSVILLE",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "ROSSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380663882,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "ROSSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380663882,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "ROSSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380663882,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9018540996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25720",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "5645 E ANDREW JOHNSON HWY",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378609998,
    "dropphyadd": "5645 E ANDREW JOHNSON HWY",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378609998,
    "dropmaladd": "5645 E ANDREW JOHNSON HWY",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235867387,
    "dropsitcph": 4235867387,
    "dropfax": 4235818642
  },
  {
    "dcode": "D",
    "dropkey": "PX25721",
    "droptype": "D",
    "dropname": "RUTHERFORD",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "RUTHERFORD",
    "dropdelst": "TN",
    "dropdelzpp": 383699998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "RUTHERFORD",
    "dropphyst": "TN",
    "dropphyzpp": 383699998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "RUTHERFORD",
    "dropmalst": "TN",
    "dropmalzpp": 383699998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316657177,
    "dropfax": 7316657177
  },
  {
    "dcode": "D",
    "dropkey": "PX25722",
    "droptype": "D",
    "dropname": "RUTLEDGE",
    "dropdeladd": "7841 RUTLEDGE PIKE",
    "dropdelcty": "RUTLEDGE",
    "dropdelst": "TN",
    "dropdelzpp": 378619998,
    "dropphyadd": "7841 RUTLEDGE PIKE",
    "dropphycty": "RUTLEDGE",
    "dropphyst": "TN",
    "dropphyzpp": 378619998,
    "dropmaladd": "7841 RUTLEDGE PIKE",
    "dropmalcty": "RUTLEDGE",
    "dropmalst": "TN",
    "dropmalzpp": 378619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8658284600,
    "dropsitcph": 8658284600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25727",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "211 WALNUT AVE",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "TN",
    "dropdelzpp": 384819998,
    "dropphyadd": "211 WALNUT AVE",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "TN",
    "dropphyzpp": 384819998,
    "dropmaladd": "211 WALNUT AVE",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "TN",
    "dropmalzpp": 384819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318454628,
    "dropsitcph": 9318454628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25728",
    "droptype": "D",
    "dropname": "SALE CREEK",
    "dropdeladd": "15117 DAYTON PIKE",
    "dropdelcty": "SALE CREEK",
    "dropdelst": "TN",
    "dropdelzpp": 373739998,
    "dropphyadd": "15117 DAYTON PIKE",
    "dropphycty": "SALE CREEK",
    "dropphyst": "TN",
    "dropphyzpp": 373739998,
    "dropmaladd": "15117 DAYTON PIKE",
    "dropmalcty": "SALE CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 373739998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233322927,
    "dropsitcph": 4233322927,
    "dropfax": 4233326545
  },
  {
    "dcode": "D",
    "dropkey": "PX25730",
    "droptype": "D",
    "dropname": "SALTILLO",
    "dropdeladd": "47980 HIGHWAY 69",
    "dropdelcty": "SALTILLO",
    "dropdelst": "TN",
    "dropdelzpp": 383709998,
    "dropphyadd": "47980 HIGHWAY 69",
    "dropphycty": "SALTILLO",
    "dropphyst": "TN",
    "dropphyzpp": 383709998,
    "dropmaladd": "47980 HIGHWAY 69",
    "dropmalcty": "SALTILLO",
    "dropmalst": "TN",
    "dropmalzpp": 383709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316873466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25731",
    "droptype": "D",
    "dropname": "SAMBURG",
    "dropdeladd": "5466 W HIGHWAY 22 S",
    "dropdelcty": "SAMBURG",
    "dropdelst": "TN",
    "dropdelzpp": 382549998,
    "dropphyadd": "5466 W HIGHWAY 22 S",
    "dropphycty": "SAMBURG",
    "dropphyst": "TN",
    "dropphyzpp": 382549998,
    "dropmaladd": "5466 W HIGHWAY 22 S",
    "dropmalcty": "SAMBURG",
    "dropmalst": "TN",
    "dropmalzpp": 382549998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315382242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25733",
    "droptype": "D",
    "dropname": "SANTA FE",
    "dropdeladd": "2581 SANTA FE PIKE",
    "dropdelcty": "SANTA FE",
    "dropdelst": "TN",
    "dropdelzpp": 384829998,
    "dropphyadd": "2581 SANTA FE PIKE",
    "dropphycty": "SANTA FE",
    "dropphyst": "TN",
    "dropphyzpp": 384829998,
    "dropmaladd": "2581 SANTA FE PIKE",
    "dropmalcty": "SANTA FE",
    "dropmalst": "TN",
    "dropmalzpp": 384829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316822594,
    "dropsitcph": 9316822594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25734",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "2005 HINKLE RD",
    "dropdelcty": "SARDIS",
    "dropdelst": "TN",
    "dropdelzpp": 383719998,
    "dropphyadd": "2005 HINKLE RD",
    "dropphycty": "SARDIS",
    "dropphyst": "TN",
    "dropphyzpp": 383719998,
    "dropmaladd": "2005 HINKLE RD",
    "dropmalcty": "SARDIS",
    "dropmalst": "TN",
    "dropmalzpp": 383719998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7318582626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25735",
    "droptype": "D",
    "dropname": "SAULSBURY",
    "dropdeladd": "5911 HIGHWAY 57",
    "dropdelcty": "SAULSBURY",
    "dropdelst": "TN",
    "dropdelzpp": 380679998,
    "dropphyadd": "5911 HIGHWAY 57",
    "dropphycty": "SAULSBURY",
    "dropphyst": "TN",
    "dropphyzpp": 380679998,
    "dropmaladd": "5911 HIGHWAY 57",
    "dropmalcty": "SAULSBURY",
    "dropmalst": "TN",
    "dropmalzpp": 380679998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7317642585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25736",
    "droptype": "D",
    "dropname": "SAVANNAH",
    "dropdeladd": "705 WATER ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "TN",
    "dropdelzpp": 383729998,
    "dropphyadd": "705 WATER ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "TN",
    "dropphyzpp": 383729998,
    "dropmaladd": "705 WATER ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "TN",
    "dropmalzpp": 383729998,
    "dropsitphn": 7319254480,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319254480,
    "dropfax": 7319262250
  },
  {
    "dcode": "D",
    "dropkey": "PX25737",
    "droptype": "D",
    "dropname": "SCOTTS HILL",
    "dropdeladd": "685 HIGHWAY 114 S",
    "dropdelcty": "SCOTTS HILL",
    "dropdelst": "TN",
    "dropdelzpp": 383749998,
    "dropphyadd": "685 HIGHWAY 114 S",
    "dropphycty": "SCOTTS HILL",
    "dropphyst": "TN",
    "dropphyzpp": 383749998,
    "dropmaladd": "685 HIGHWAY 114 S",
    "dropmalcty": "SCOTTS HILL",
    "dropmalst": "TN",
    "dropmalzpp": 383749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7315493536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25740",
    "droptype": "D",
    "dropname": "SELMER",
    "dropdeladd": "150 HOUSTON AVE",
    "dropdelcty": "SELMER",
    "dropdelst": "TN",
    "dropdelzpp": 383759998,
    "dropphyadd": "150 HOUSTON AVE",
    "dropphycty": "SELMER",
    "dropphyst": "TN",
    "dropphyzpp": 383759998,
    "dropmaladd": "150 HOUSTON AVE",
    "dropmalcty": "SELMER",
    "dropmalst": "TN",
    "dropmalzpp": 383759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312442059,
    "dropfax": 7316455006
  },
  {
    "dcode": "D",
    "dropkey": "PX25741",
    "droptype": "D",
    "dropname": "SEQUATCHIE",
    "dropdeladd": "3670 VALLEY VIEW HWY",
    "dropdelcty": "SEQUATCHIE",
    "dropdelst": "TN",
    "dropdelzpp": 373749998,
    "dropphyadd": "3670 VALLEY VIEW HWY",
    "dropphycty": "SEQUATCHIE",
    "dropphyst": "TN",
    "dropphyzpp": 373749998,
    "dropmaladd": "3670 VALLEY VIEW HWY",
    "dropmalcty": "SEQUATCHIE",
    "dropmalst": "TN",
    "dropmalzpp": 373749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239422560,
    "dropsitcph": 4239422560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25742",
    "droptype": "D",
    "dropname": "SEVIERVILLE",
    "dropdeladd": "711 DOLLY PARTON PKWY",
    "dropdelcty": "SEVIERVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378629998,
    "dropphyadd": "711 DOLLY PARTON PKWY",
    "dropphycty": "SEVIERVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378629998,
    "dropmaladd": "711 DOLLY PARTON PKWY",
    "dropmalcty": "SEVIERVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378629998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654299818,
    "dropsitcph": 8654299818,
    "dropfax": 8654293437
  },
  {
    "dcode": "D",
    "dropkey": "PX25743",
    "droptype": "D",
    "dropname": "SEWANEE",
    "dropdeladd": "94 UNIVERSITY AVE",
    "dropdelcty": "SEWANEE",
    "dropdelst": "TN",
    "dropdelzpp": 373759998,
    "dropphyadd": "94 UNIVERSITY AVE",
    "dropphycty": "SEWANEE",
    "dropphyst": "TN",
    "dropphyzpp": 373759998,
    "dropmaladd": "94 UNIVERSITY AVE",
    "dropmalcty": "SEWANEE",
    "dropmalst": "TN",
    "dropmalzpp": 373759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315985979,
    "dropsitcph": 9315985979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25744",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "10615 CHAPMAN HWY",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "TN",
    "dropdelzpp": 378659998,
    "dropphyadd": "10615 CHAPMAN HWY",
    "dropphycty": "SEYMOUR",
    "dropphyst": "TN",
    "dropphyzpp": 378659998,
    "dropmaladd": "10615 CHAPMAN HWY",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "TN",
    "dropmalzpp": 378659998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655739761,
    "dropsitcph": 8655732530,
    "dropfax": 8655733508
  },
  {
    "dcode": "D",
    "dropkey": "PX25745",
    "droptype": "D",
    "dropname": "SHADY VALLEY",
    "dropdeladd": "136 HIGHWAY 133",
    "dropdelcty": "SHADY VALLEY",
    "dropdelst": "TN",
    "dropdelzpp": 376889998,
    "dropphyadd": "136 HIGHWAY 133",
    "dropphycty": "SHADY VALLEY",
    "dropphyst": "TN",
    "dropphyzpp": 376889998,
    "dropmaladd": "136 HIGHWAY 133",
    "dropmalcty": "SHADY VALLEY",
    "dropmalst": "TN",
    "dropmalzpp": 376889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237392173,
    "dropsitcph": 4237392173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25746",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "5321 US HIGHWAY 45",
    "dropdelcty": "SHARON",
    "dropdelst": "TN",
    "dropdelzpp": 382559998,
    "dropphyadd": "5321 US HIGHWAY 45",
    "dropphycty": "SHARON",
    "dropphyst": "TN",
    "dropphyzpp": 382559998,
    "dropmaladd": "5321 US HIGHWAY 45",
    "dropmalcty": "SHARON",
    "dropmalst": "TN",
    "dropmalzpp": 382559998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7314562651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25748",
    "droptype": "D",
    "dropname": "SHARPS CHAPEL",
    "dropdeladd": "111 DR DAVIS RD",
    "dropdelcty": "SHARPS CHAPEL",
    "dropdelst": "TN",
    "dropdelzpp": 378669998,
    "dropphyadd": "111 DR DAVIS RD",
    "dropphycty": "SHARPS CHAPEL",
    "dropphyst": "TN",
    "dropphyzpp": 378669998,
    "dropmaladd": "111 DR DAVIS RD",
    "dropmalcty": "SHARPS CHAPEL",
    "dropmalst": "TN",
    "dropmalzpp": 378669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655584567,
    "dropsitcph": 8652783333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25751",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "600 N MAIN ST",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371609998,
    "dropphyadd": "600 N MAIN ST",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371609998,
    "dropmaladd": "600 N MAIN ST",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316842812,
    "dropsitcph": 9316842812,
    "dropfax": 9316849174
  },
  {
    "dcode": "D",
    "dropkey": "PX25754",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "9769 SHERWOOD RD",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 373769998,
    "dropphyadd": "9769 SHERWOOD RD",
    "dropphycty": "SHERWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 373769998,
    "dropmaladd": "9769 SHERWOOD RD",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 373769998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315985577,
    "dropsitcph": 9315985577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25757",
    "droptype": "D",
    "dropname": "SHILOH",
    "dropdeladd": "1095 HIGHWAY 142",
    "dropdelcty": "SHILOH",
    "dropdelst": "TN",
    "dropdelzpp": 383769998,
    "dropphyadd": "1095 HIGHWAY 142",
    "dropphycty": "SHILOH",
    "dropphyst": "TN",
    "dropphyzpp": 383769998,
    "dropmaladd": "1095 HIGHWAY 142",
    "dropmalcty": "SHILOH",
    "dropmalst": "TN",
    "dropmalzpp": 383769998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316895650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25759",
    "droptype": "D",
    "dropname": "SIGNAL MOUNTAIN",
    "dropdeladd": "1155 RIDGEWAY AVE",
    "dropdelcty": "SIGNAL MOUNTAIN",
    "dropdelst": "TN",
    "dropdelzpp": 373779998,
    "dropphyadd": "1155 RIDGEWAY AVE",
    "dropphycty": "SIGNAL MOUNTAIN",
    "dropphyst": "TN",
    "dropphyzpp": 373779998,
    "dropmaladd": "1155 RIDGEWAY AVE",
    "dropmalcty": "SIGNAL MOUNTAIN",
    "dropmalst": "TN",
    "dropmalzpp": 373779998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238866443,
    "dropsitcph": 4235179328,
    "dropfax": 4238869666
  },
  {
    "dcode": "D",
    "dropkey": "PX25763",
    "droptype": "D",
    "dropname": "SILVER POINT",
    "dropdeladd": "6860 SMITHVILLE HWY",
    "dropdelcty": "SILVER POINT",
    "dropdelst": "TN",
    "dropdelzpp": 385829998,
    "dropphyadd": "6860 SMITHVILLE HWY",
    "dropphycty": "SILVER POINT",
    "dropphyst": "TN",
    "dropphyzpp": 385829998,
    "dropmaladd": "6860 SMITHVILLE HWY",
    "dropmalcty": "SILVER POINT",
    "dropmalst": "TN",
    "dropmalzpp": 385829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318584950,
    "dropsitcph": 9318584950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25765",
    "droptype": "D",
    "dropname": "SLAYDEN",
    "dropdeladd": "2830 SLAYDEN MARION RD",
    "dropdelcty": "SLAYDEN",
    "dropdelst": "TN",
    "dropdelzpp": 371659998,
    "dropphyadd": "2830 SLAYDEN MARION RD",
    "dropphycty": "SLAYDEN",
    "dropphyst": "TN",
    "dropphyzpp": 371659998,
    "dropmaladd": "2830 SLAYDEN MARION RD",
    "dropmalcty": "SLAYDEN",
    "dropmalst": "TN",
    "dropmalzpp": 371659998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157632084,
    "dropsitcph": 6157632084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25766",
    "droptype": "D",
    "dropname": "SMARTT",
    "dropdeladd": "5174 MANCHESTER HWY",
    "dropdelcty": "SMARTT",
    "dropdelst": "TN",
    "dropdelzpp": 373789998,
    "dropphyadd": "5174 MANCHESTER HWY",
    "dropphycty": "SMARTT",
    "dropphyst": "TN",
    "dropphyzpp": 373789998,
    "dropmaladd": "5174 MANCHESTER HWY",
    "dropmalcty": "SMARTT",
    "dropmalst": "TN",
    "dropmalzpp": 373789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316687174,
    "dropsitcph": 9316687174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25768",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "100 S 1ST ST STE 104",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371669998,
    "dropphyadd": "100 S 1ST ST STE 104",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371669998,
    "dropmaladd": "100 S 1ST ST STE 104",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371669998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155974781,
    "dropsitcph": 6155974781,
    "dropfax": 6155972860
  },
  {
    "dcode": "D",
    "dropkey": "PX25772",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "250 MAYFIELD DR",
    "dropdelcty": "SMYRNA",
    "dropdelst": "TN",
    "dropdelzpp": 371679998,
    "dropphyadd": "250 MAYFIELD DR",
    "dropphycty": "SMYRNA",
    "dropphyst": "TN",
    "dropphyzpp": 371679998,
    "dropmaladd": "250 MAYFIELD DR",
    "dropmalcty": "SMYRNA",
    "dropmalst": "TN",
    "dropmalzpp": 371679998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152202108,
    "dropsitcph": 6152202108,
    "dropfax": 6152230205
  },
  {
    "dcode": "D",
    "dropkey": "PX25774",
    "droptype": "D",
    "dropname": "SNEEDVILLE",
    "dropdeladd": "1314A MAIN ST",
    "dropdelcty": "SNEEDVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378699998,
    "dropphyadd": "1314A MAIN ST",
    "dropphycty": "SNEEDVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378699998,
    "dropmaladd": "1314A MAIN ST",
    "dropmalcty": "SNEEDVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378699998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237332242,
    "dropsitcph": 4237332242,
    "dropfax": 4237334202
  },
  {
    "dcode": "D",
    "dropkey": "PX25777",
    "droptype": "D",
    "dropname": "SODDY DAISY",
    "dropdeladd": "10575 DAYTON PIKE",
    "dropdelcty": "SODDY DAISY",
    "dropdelst": "TN",
    "dropdelzpp": 373799998,
    "dropphyadd": "10575 DAYTON PIKE",
    "dropphycty": "SODDY DAISY",
    "dropphyst": "TN",
    "dropphyzpp": 373799998,
    "dropmaladd": "10575 DAYTON PIKE",
    "dropmalcty": "SODDY DAISY",
    "dropmalst": "TN",
    "dropmalzpp": 373799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233328204,
    "dropsitcph": 4233327118,
    "dropfax": 4233320333
  },
  {
    "dcode": "D",
    "dropkey": "PX25779",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "116 W NORTH ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380689998,
    "dropphyadd": "116 W NORTH ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380689998,
    "dropmaladd": "116 W NORTH ST",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380689998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9014654210,
    "dropfax": 9014651296
  },
  {
    "dcode": "D",
    "dropkey": "PX25790",
    "droptype": "D",
    "dropname": "SOUTH PITTSBURG",
    "dropdeladd": "303 ELM AVE",
    "dropdelcty": "SOUTH PITTSBURG",
    "dropdelst": "TN",
    "dropdelzpp": 373809998,
    "dropphyadd": "303 ELM AVE",
    "dropphycty": "SOUTH PITTSBURG",
    "dropphyst": "TN",
    "dropphyzpp": 373809998,
    "dropmaladd": "303 ELM AVE",
    "dropmalcty": "SOUTH PITTSBURG",
    "dropmalst": "TN",
    "dropmalzpp": 373809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238376051,
    "dropsitcph": 4238376051,
    "dropfax": 4238375338
  },
  {
    "dcode": "D",
    "dropkey": "PX25793",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "309 E BOCKMAN WAY",
    "dropdelcty": "SPARTA",
    "dropdelst": "TN",
    "dropdelzpp": 385839998,
    "dropphyadd": "309 E BOCKMAN WAY",
    "dropphycty": "SPARTA",
    "dropphyst": "TN",
    "dropphyzpp": 385839998,
    "dropmaladd": "309 E BOCKMAN WAY",
    "dropmalcty": "SPARTA",
    "dropmalst": "TN",
    "dropmalzpp": 385839998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318363382,
    "dropsitcph": 9318363382,
    "dropfax": 9318362313
  },
  {
    "dcode": "D",
    "dropkey": "PX25794",
    "droptype": "D",
    "dropname": "SPEEDWELL",
    "dropdeladd": "7669 HIGHWAY 63",
    "dropdelcty": "SPEEDWELL",
    "dropdelst": "TN",
    "dropdelzpp": 378709998,
    "dropphyadd": "7669 HIGHWAY 63",
    "dropphycty": "SPEEDWELL",
    "dropphyst": "TN",
    "dropphyzpp": 378709998,
    "dropmaladd": "7669 HIGHWAY 63",
    "dropmalcty": "SPEEDWELL",
    "dropmalst": "TN",
    "dropmalzpp": 378709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235666449,
    "dropsitcph": 4235666449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25795",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "37 VETERANS SQ",
    "dropdelcty": "SPENCER",
    "dropdelst": "TN",
    "dropdelzpp": 385859998,
    "dropphyadd": "37 VETERANS SQ",
    "dropphycty": "SPENCER",
    "dropphyst": "TN",
    "dropphyzpp": 385859998,
    "dropmaladd": "37 VETERANS SQ",
    "dropmalcty": "SPENCER",
    "dropmalst": "TN",
    "dropmalzpp": 385859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319462262,
    "dropsitcph": 9319462262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25797",
    "droptype": "D",
    "dropname": "SPRING CITY",
    "dropdeladd": "265 FRONT ST",
    "dropdelcty": "SPRING CITY",
    "dropdelst": "TN",
    "dropdelzpp": 373819998,
    "dropphyadd": "265 FRONT ST",
    "dropphycty": "SPRING CITY",
    "dropphyst": "TN",
    "dropphyzpp": 373819998,
    "dropmaladd": "265 FRONT ST",
    "dropmalcty": "SPRING CITY",
    "dropmalst": "TN",
    "dropmalzpp": 373819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233656827,
    "dropsitcph": 4233656827,
    "dropfax": 4233657504
  },
  {
    "dcode": "D",
    "dropkey": "PX25798",
    "droptype": "D",
    "dropname": "SPRING CREEK",
    "dropdeladd": "3565 HIGHWAY 70 E",
    "dropdelcty": "SPRING CREEK",
    "dropdelst": "TN",
    "dropdelzpp": 383789998,
    "dropphyadd": "3565 HIGHWAY 70 E",
    "dropphycty": "SPRING CREEK",
    "dropphyst": "TN",
    "dropphyzpp": 383789998,
    "dropmaladd": "3565 HIGHWAY 70 E",
    "dropmalcty": "SPRING CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 383789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7314242313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25802",
    "droptype": "D",
    "dropname": "SPRING HILL",
    "dropdeladd": "223 TOWN CENTER PKWY",
    "dropdelcty": "SPRING HILL",
    "dropdelst": "TN",
    "dropdelzpp": 371749998,
    "dropphyadd": "223 TOWN CENTER PKWY",
    "dropphycty": "SPRING HILL",
    "dropphyst": "TN",
    "dropphyzpp": 371749998,
    "dropmaladd": "223 TOWN CENTER PKWY",
    "dropmalcty": "SPRING HILL",
    "dropmalst": "TN",
    "dropmalzpp": 371749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314862629,
    "dropsitcph": 9314862629,
    "dropfax": 9314863713
  },
  {
    "dcode": "D",
    "dropkey": "PX25804",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "800 WILLOW ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 371729998,
    "dropphyadd": "800 WILLOW ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 371729998,
    "dropmaladd": "800 WILLOW ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 371729998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153829048,
    "dropsitcph": 6153824745,
    "dropfax": 6153827706
  },
  {
    "dcode": "D",
    "dropkey": "PX25806",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "7935 HIGHWAY 69 S",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 382569998,
    "dropphyadd": "7935 HIGHWAY 69 S",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 382569998,
    "dropmaladd": "7935 HIGHWAY 69 S",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 382569998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315935127,
    "dropfax": 7315935935
  },
  {
    "dcode": "D",
    "dropkey": "PX25828",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "6 N MAIN ST",
    "dropdelcty": "STANTON",
    "dropdelst": "TN",
    "dropdelzpp": 380699998,
    "dropphyadd": "6 N MAIN ST",
    "dropphycty": "STANTON",
    "dropphyst": "TN",
    "dropphyzpp": 380699998,
    "dropmaladd": "6 N MAIN ST",
    "dropmalcty": "STANTON",
    "dropmalst": "TN",
    "dropmalzpp": 380699998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312541014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25829",
    "droptype": "D",
    "dropname": "STANTONVILLE",
    "dropdeladd": "8475 HIGHWAY 142",
    "dropdelcty": "STANTONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383799998,
    "dropphyadd": "8475 HIGHWAY 142",
    "dropphycty": "STANTONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383799998,
    "dropmaladd": "8475 HIGHWAY 142",
    "dropmalcty": "STANTONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316323378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25838",
    "droptype": "D",
    "dropname": "STEWART",
    "dropdeladd": "6100 HIGHWAY 147",
    "dropdelcty": "STEWART",
    "dropdelst": "TN",
    "dropdelzpp": 371759998,
    "dropphyadd": "6100 HIGHWAY 147",
    "dropphycty": "STEWART",
    "dropphyst": "TN",
    "dropphyzpp": 371759998,
    "dropmaladd": "6100 HIGHWAY 147",
    "dropmalcty": "STEWART",
    "dropmalst": "TN",
    "dropmalzpp": 371759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317213111,
    "dropsitcph": 9317213111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25840",
    "droptype": "D",
    "dropname": "STRAWBERRY PLAINS",
    "dropdeladd": "2704 W HIGHWAY 11E",
    "dropdelcty": "STRAWBERRY PLAINS",
    "dropdelst": "TN",
    "dropdelzpp": 378719998,
    "dropphyadd": "2704 W HIGHWAY 11E",
    "dropphycty": "STRAWBERRY PLAINS",
    "dropphyst": "TN",
    "dropphyzpp": 378719998,
    "dropmaladd": "2704 W HIGHWAY 11E",
    "dropmalcty": "STRAWBERRY PLAINS",
    "dropmalst": "TN",
    "dropmalzpp": 378719998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659333031,
    "dropsitcph": 8659333031,
    "dropfax": 8659334283
  },
  {
    "dcode": "D",
    "dropkey": "PX25841",
    "droptype": "D",
    "dropname": "SUGAR TREE",
    "dropdeladd": "6675 OLD SH 69",
    "dropdelcty": "SUGAR TREE",
    "dropdelst": "TN",
    "dropdelzpp": 383809998,
    "dropphyadd": "6675 OLD SH 69",
    "dropphycty": "SUGAR TREE",
    "dropphyst": "TN",
    "dropphyzpp": 383809998,
    "dropmaladd": "6675 OLD SH 69",
    "dropmalcty": "SUGAR TREE",
    "dropmalst": "TN",
    "dropmalzpp": 383809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7318476815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25842",
    "droptype": "D",
    "dropname": "SUMMERTOWN",
    "dropdeladd": "100 HIGHWAY 20",
    "dropdelcty": "SUMMERTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 384839998,
    "dropphyadd": "100 HIGHWAY 20",
    "dropphycty": "SUMMERTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 384839998,
    "dropmaladd": "100 HIGHWAY 20",
    "dropmalcty": "SUMMERTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 384839998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319643057,
    "dropsitcph": 9319643057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25844",
    "droptype": "D",
    "dropname": "SUMMITVILLE",
    "dropdeladd": "7881 MCMINNVILLE HWY",
    "dropdelcty": "SUMMITVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 373829998,
    "dropphyadd": "7881 MCMINNVILLE HWY",
    "dropphycty": "SUMMITVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 373829998,
    "dropmaladd": "7881 MCMINNVILLE HWY",
    "dropmalcty": "SUMMITVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 373829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317285107,
    "dropsitcph": 9317285107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25847",
    "droptype": "D",
    "dropname": "SUNBRIGHT",
    "dropdeladd": "8129 MORGAN CO HWY",
    "dropdelcty": "SUNBRIGHT",
    "dropdelst": "TN",
    "dropdelzpp": 378729998,
    "dropphyadd": "8129 MORGAN CO HWY",
    "dropphycty": "SUNBRIGHT",
    "dropphyst": "TN",
    "dropphyzpp": 378729998,
    "dropmaladd": "8129 MORGAN CO HWY",
    "dropmalcty": "SUNBRIGHT",
    "dropmalst": "TN",
    "dropmalzpp": 378729998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236282398,
    "dropsitcph": 4236282398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25848",
    "droptype": "D",
    "dropname": "SURGOINSVILLE",
    "dropdeladd": "111 BELLAMY AVE",
    "dropdelcty": "SURGOINSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 378739998,
    "dropphyadd": "111 BELLAMY AVE",
    "dropphycty": "SURGOINSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 378739998,
    "dropmaladd": "111 BELLAMY AVE",
    "dropmalcty": "SURGOINSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 378739998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233453211,
    "dropsitcph": 4233453211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25849",
    "droptype": "D",
    "dropname": "SWEETWATER",
    "dropdeladd": "701 N MAIN ST",
    "dropdelcty": "SWEETWATER",
    "dropdelst": "TN",
    "dropdelzpp": 378749998,
    "dropphyadd": "701 N MAIN ST",
    "dropphycty": "SWEETWATER",
    "dropphyst": "TN",
    "dropphyzpp": 378749998,
    "dropmaladd": "701 N MAIN ST",
    "dropmalcty": "SWEETWATER",
    "dropmalst": "TN",
    "dropmalzpp": 378749998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233377041,
    "dropsitcph": 4233377041,
    "dropfax": 4233375648
  },
  {
    "dcode": "D",
    "dropkey": "PX25850",
    "droptype": "D",
    "dropname": "TAFT",
    "dropdeladd": "1111 OLD RAILROAD BED RD",
    "dropdelcty": "TAFT",
    "dropdelst": "TN",
    "dropdelzpp": 384889998,
    "dropphyadd": "1111 OLD RAILROAD BED RD",
    "dropphycty": "TAFT",
    "dropphyst": "TN",
    "dropphyzpp": 384889998,
    "dropmaladd": "1111 OLD RAILROAD BED RD",
    "dropmalcty": "TAFT",
    "dropmalst": "TN",
    "dropmalzpp": 384889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314256431,
    "dropsitcph": 9314256431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25851",
    "droptype": "D",
    "dropname": "TALBOTT",
    "dropdeladd": "7225 W ANDREW JOHNSON HWY",
    "dropdelcty": "TALBOTT",
    "dropdelst": "TN",
    "dropdelzpp": 378779998,
    "dropphyadd": "7225 W ANDREW JOHNSON HWY",
    "dropphycty": "TALBOTT",
    "dropphyst": "TN",
    "dropphyzpp": 378779998,
    "dropmaladd": "7225 W ANDREW JOHNSON HWY",
    "dropmalcty": "TALBOTT",
    "dropmalst": "TN",
    "dropmalzpp": 378779998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235872588,
    "dropsitcph": 4235872588,
    "dropfax": 4235858430
  },
  {
    "dcode": "D",
    "dropkey": "PX25854",
    "droptype": "D",
    "dropname": "TAZEWELL",
    "dropdeladd": "1710 MAIN ST",
    "dropdelcty": "TAZEWELL",
    "dropdelst": "TN",
    "dropdelzpp": 378799998,
    "dropphyadd": "1710 MAIN ST",
    "dropphycty": "TAZEWELL",
    "dropphyst": "TN",
    "dropphyzpp": 378799998,
    "dropmaladd": "1710 MAIN ST",
    "dropmalcty": "TAZEWELL",
    "dropmalst": "TN",
    "dropmalzpp": 378799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236263219,
    "dropsitcph": 4236263219,
    "dropfax": 4236261292
  },
  {
    "dcode": "D",
    "dropkey": "PX25855",
    "droptype": "D",
    "dropname": "TELFORD",
    "dropdeladd": "1888 OLD STATE ROUTE 34",
    "dropdelcty": "TELFORD",
    "dropdelst": "TN",
    "dropdelzpp": 376909998,
    "dropphyadd": "1888 OLD STATE ROUTE 34",
    "dropphycty": "TELFORD",
    "dropphyst": "TN",
    "dropphyzpp": 376909998,
    "dropmaladd": "1888 OLD STATE ROUTE 34",
    "dropmalcty": "TELFORD",
    "dropmalst": "TN",
    "dropmalzpp": 376909998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237538461,
    "dropsitcph": 4237538461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25856",
    "droptype": "D",
    "dropname": "TELLICO PLAINS",
    "dropdeladd": "171 BANK ST",
    "dropdelcty": "TELLICO PLAINS",
    "dropdelst": "TN",
    "dropdelzpp": 373859998,
    "dropphyadd": "171 BANK ST",
    "dropphycty": "TELLICO PLAINS",
    "dropphyst": "TN",
    "dropphyzpp": 373859998,
    "dropmaladd": "171 BANK ST",
    "dropmalcty": "TELLICO PLAINS",
    "dropmalst": "TN",
    "dropmalzpp": 373859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232532218,
    "dropsitcph": 4232532218,
    "dropfax": 4232536019
  },
  {
    "dcode": "D",
    "dropkey": "PX25858",
    "droptype": "D",
    "dropname": "TEN MILE",
    "dropdeladd": "2640 STATE HIGHWAY 304",
    "dropdelcty": "TEN MILE",
    "dropdelst": "TN",
    "dropdelzpp": 378809998,
    "dropphyadd": "2640 STATE HIGHWAY 304",
    "dropphycty": "TEN MILE",
    "dropphyst": "TN",
    "dropphyzpp": 378809998,
    "dropmaladd": "2640 STATE HIGHWAY 304",
    "dropmalcty": "TEN MILE",
    "dropmalst": "TN",
    "dropmalzpp": 378809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236686070,
    "dropsitcph": 4236686070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25861",
    "droptype": "D",
    "dropname": "TENNESSEE RIDGE",
    "dropdeladd": "940 HIGHWAY 49",
    "dropdelcty": "TENNESSEE RIDGE",
    "dropdelst": "TN",
    "dropdelzpp": 371789998,
    "dropphyadd": "940 HIGHWAY 49",
    "dropphycty": "TENNESSEE RIDGE",
    "dropphyst": "TN",
    "dropphyzpp": 371789998,
    "dropmaladd": "940 HIGHWAY 49",
    "dropmalcty": "TENNESSEE RIDGE",
    "dropmalst": "TN",
    "dropmalzpp": 371789998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317214120,
    "dropsitcph": 9317214120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25866",
    "droptype": "D",
    "dropname": "THOMPSONS STATION",
    "dropdeladd": "1507 THOMPSON STATION RD W",
    "dropdelcty": "THOMPSONS STATION",
    "dropdelst": "TN",
    "dropdelzpp": 371799998,
    "dropphyadd": "1507 THOMPSON STATION RD W",
    "dropphycty": "THOMPSONS STATION",
    "dropphyst": "TN",
    "dropphyzpp": 371799998,
    "dropmaladd": "1507 THOMPSON STATION RD W",
    "dropmalcty": "THOMPSONS STATION",
    "dropmalst": "TN",
    "dropmalzpp": 371799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157943733,
    "dropsitcph": 6157943733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25867",
    "droptype": "D",
    "dropname": "THORN HILL",
    "dropdeladd": "108 OLD MOUNTAIN RD",
    "dropdelcty": "THORN HILL",
    "dropdelst": "TN",
    "dropdelzpp": 378819998,
    "dropphyadd": "108 OLD MOUNTAIN RD",
    "dropphycty": "THORN HILL",
    "dropphyst": "TN",
    "dropphyzpp": 378819998,
    "dropmaladd": "108 OLD MOUNTAIN RD",
    "dropmalcty": "THORN HILL",
    "dropmalst": "TN",
    "dropmalzpp": 378819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8657672500,
    "dropsitcph": 8657672500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25869",
    "droptype": "D",
    "dropname": "TIGRETT",
    "dropdeladd": "179 STOKES RD",
    "dropdelcty": "TIGRETT",
    "dropdelst": "TN",
    "dropdelzpp": 380709998,
    "dropphyadd": "179 STOKES RD",
    "dropphycty": "TIGRETT",
    "dropphyst": "TN",
    "dropphyzpp": 380709998,
    "dropmaladd": "179 STOKES RD",
    "dropmalcty": "TIGRETT",
    "dropmalst": "TN",
    "dropmalzpp": 380709998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316772255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25870",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "2520 TIPTON RD",
    "dropdelcty": "TIPTON",
    "dropdelst": "TN",
    "dropdelzpp": 380715000,
    "dropphyadd": "2520 TIPTON RD",
    "dropphycty": "TIPTON",
    "dropphyst": "TN",
    "dropphyzpp": 380715000,
    "dropmaladd": "2520 TIPTON RD",
    "dropmalcty": "TIPTON",
    "dropmalst": "TN",
    "dropmalzpp": 380715000,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018377989,
    "dropsitcph": 9018377989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25871",
    "droptype": "D",
    "dropname": "TIPTONVILLE",
    "dropdeladd": "404 CHURCH ST",
    "dropdelcty": "TIPTONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380799998,
    "dropphyadd": "404 CHURCH ST",
    "dropphycty": "TIPTONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380799998,
    "dropmaladd": "404 CHURCH ST",
    "dropmalcty": "TIPTONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380799998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312532043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25875",
    "droptype": "D",
    "dropname": "TOONE",
    "dropdeladd": "20 KILGORE RD",
    "dropdelcty": "TOONE",
    "dropdelst": "TN",
    "dropdelzpp": 383819998,
    "dropphyadd": "20 KILGORE RD",
    "dropphycty": "TOONE",
    "dropphyst": "TN",
    "dropphyzpp": 383819998,
    "dropmaladd": "20 KILGORE RD",
    "dropmalcty": "TOONE",
    "dropmalst": "TN",
    "dropmalzpp": 383819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316586376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25876",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "118 TOWN SQUARE DR",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "TN",
    "dropdelzpp": 378829998,
    "dropphyadd": "118 TOWN SQUARE DR",
    "dropphycty": "TOWNSEND",
    "dropphyst": "TN",
    "dropphyzpp": 378829998,
    "dropmaladd": "118 TOWN SQUARE DR",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "TN",
    "dropmalzpp": 378829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654486311,
    "dropsitcph": 8654486311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25877",
    "droptype": "D",
    "dropname": "TRACY CITY",
    "dropdeladd": "245 NATHURST ST",
    "dropdelcty": "TRACY CITY",
    "dropdelst": "TN",
    "dropdelzpp": 373879998,
    "dropphyadd": "245 NATHURST ST",
    "dropphycty": "TRACY CITY",
    "dropphyst": "TN",
    "dropphyzpp": 373879998,
    "dropmaladd": "245 NATHURST ST",
    "dropmalcty": "TRACY CITY",
    "dropmalst": "TN",
    "dropmalzpp": 373879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315926443,
    "dropsitcph": 9315926443,
    "dropfax": 9315926429
  },
  {
    "dcode": "D",
    "dropkey": "PX25880",
    "droptype": "D",
    "dropname": "TRADE",
    "dropdeladd": "164 HIGHWAY 67 N",
    "dropdelcty": "TRADE",
    "dropdelst": "TN",
    "dropdelzpp": 376919998,
    "dropphyadd": "164 HIGHWAY 67 N",
    "dropphycty": "TRADE",
    "dropphyst": "TN",
    "dropphyzpp": 376919998,
    "dropmaladd": "164 HIGHWAY 67 N",
    "dropmalcty": "TRADE",
    "dropmalst": "TN",
    "dropmalzpp": 376919998,
    "dropsitphn": 4237278211,
    "dropsitlph": 4237278211,
    "dropsitcph": 4237278211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25883",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "200 S COLLEGE ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "TN",
    "dropdelzpp": 383829998,
    "dropphyadd": "200 S COLLEGE ST",
    "dropphycty": "TRENTON",
    "dropphyst": "TN",
    "dropphyzpp": 383829998,
    "dropmaladd": "200 S COLLEGE ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "TN",
    "dropmalzpp": 383829998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7318550541,
    "dropfax": 7318552266
  },
  {
    "dcode": "D",
    "dropkey": "PX25884",
    "droptype": "D",
    "dropname": "TREZEVANT",
    "dropdeladd": "5580 BROAD ST N",
    "dropdelcty": "TREZEVANT",
    "dropdelst": "TN",
    "dropdelzpp": 382589998,
    "dropphyadd": "5580 BROAD ST N",
    "dropphycty": "TREZEVANT",
    "dropphyst": "TN",
    "dropphyzpp": 382589998,
    "dropmaladd": "5580 BROAD ST N",
    "dropmalcty": "TREZEVANT",
    "dropmalst": "TN",
    "dropmalzpp": 382589998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7316694571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25887",
    "droptype": "D",
    "dropname": "TRIMBLE",
    "dropdeladd": "70 PARKS PLZ",
    "dropdelcty": "TRIMBLE",
    "dropdelst": "TN",
    "dropdelzpp": 382599998,
    "dropphyadd": "70 PARKS PLZ",
    "dropphycty": "TRIMBLE",
    "dropphyst": "TN",
    "dropphyzpp": 382599998,
    "dropmaladd": "70 PARKS PLZ",
    "dropmalcty": "TRIMBLE",
    "dropmalst": "TN",
    "dropmalzpp": 382599998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7312973401,
    "dropsitcph": 8773641769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25889",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "214 W HARPER ST",
    "dropdelcty": "TROY",
    "dropdelst": "TN",
    "dropdelzpp": 382609998,
    "dropphyadd": "214 W HARPER ST",
    "dropphycty": "TROY",
    "dropphyst": "TN",
    "dropphyzpp": 382609998,
    "dropmaladd": "214 W HARPER ST",
    "dropmalcty": "TROY",
    "dropmalst": "TN",
    "dropmalzpp": 382609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7315364534,
    "dropfax": 7315360265
  },
  {
    "dcode": "D",
    "dropkey": "PX25890",
    "droptype": "D",
    "dropname": "TULLAHOMA",
    "dropdeladd": "200 S JACKSON ST",
    "dropdelcty": "TULLAHOMA",
    "dropdelst": "TN",
    "dropdelzpp": 373889998,
    "dropphyadd": "200 S JACKSON ST",
    "dropphycty": "TULLAHOMA",
    "dropphyst": "TN",
    "dropphyzpp": 373889998,
    "dropmaladd": "200 S JACKSON ST",
    "dropmalcty": "TULLAHOMA",
    "dropmalst": "TN",
    "dropmalzpp": 373889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314558701,
    "dropsitcph": 9314553675,
    "dropfax": 9314556380
  },
  {
    "dcode": "D",
    "dropkey": "PX25891",
    "droptype": "D",
    "dropname": "TURTLETOWN",
    "dropdeladd": "4600 HIGHWAY 68",
    "dropdelcty": "TURTLETOWN",
    "dropdelst": "TN",
    "dropdelzpp": 373919998,
    "dropphyadd": "4600 HIGHWAY 68",
    "dropphycty": "TURTLETOWN",
    "dropphyst": "TN",
    "dropphyzpp": 373919998,
    "dropmaladd": "4600 HIGHWAY 68",
    "dropmalcty": "TURTLETOWN",
    "dropmalst": "TN",
    "dropmalzpp": 373919998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234962545,
    "dropsitcph": 4234962545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25894",
    "droptype": "D",
    "dropname": "UNICOI",
    "dropdeladd": "4010 UNICOI DR",
    "dropdelcty": "UNICOI",
    "dropdelst": "TN",
    "dropdelzpp": 376929998,
    "dropphyadd": "4010 UNICOI DR",
    "dropphycty": "UNICOI",
    "dropphyst": "TN",
    "dropphyzpp": 376929998,
    "dropmaladd": "4010 UNICOI DR",
    "dropmalcty": "UNICOI",
    "dropmalst": "TN",
    "dropmalzpp": 376929998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4237434945,
    "dropsitcph": 4237434945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25895",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "114 W WASHINGTON AVE",
    "dropdelcty": "UNION CITY",
    "dropdelst": "TN",
    "dropdelzpp": 382619998,
    "dropphyadd": "114 W WASHINGTON AVE",
    "dropphycty": "UNION CITY",
    "dropphyst": "TN",
    "dropphyzpp": 382619998,
    "dropmaladd": "114 W WASHINGTON AVE",
    "dropmalcty": "UNION CITY",
    "dropmalst": "TN",
    "dropmalzpp": 382619998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7318859711,
    "dropfax": 7318856734
  },
  {
    "dcode": "D",
    "dropkey": "PX25900",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "3370 HIGHWAY 41A N",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 371809998,
    "dropphyadd": "3370 HIGHWAY 41A N",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 371809998,
    "dropmaladd": "3370 HIGHWAY 41A N",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 371809998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312945208,
    "dropsitcph": 9312945208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25914",
    "droptype": "D",
    "dropname": "VANLEER",
    "dropdeladd": "4460 HIGHWAY 49 W",
    "dropdelcty": "VANLEER",
    "dropdelst": "TN",
    "dropdelzpp": 371819998,
    "dropphyadd": "4460 HIGHWAY 49 W",
    "dropphycty": "VANLEER",
    "dropphyst": "TN",
    "dropphyzpp": 371819998,
    "dropmaladd": "4460 HIGHWAY 49 W",
    "dropmalcty": "VANLEER",
    "dropmalst": "TN",
    "dropmalzpp": 371819998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157632828,
    "dropsitcph": 6157632828,
    "dropfax": 6157632746
  },
  {
    "dcode": "D",
    "dropkey": "PX25915",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "15 LYNN ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "TN",
    "dropdelzpp": 373949998,
    "dropphyadd": "15 LYNN ST",
    "dropphycty": "VIOLA",
    "dropphyst": "TN",
    "dropphyzpp": 373949998,
    "dropmaladd": "15 LYNN ST",
    "dropmalcty": "VIOLA",
    "dropmalst": "TN",
    "dropmalzpp": 373949998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316352934,
    "dropsitcph": 9316352934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25916",
    "droptype": "D",
    "dropname": "VONORE",
    "dropdeladd": "1117 HIGHWAY 411",
    "dropdelcty": "VONORE",
    "dropdelst": "TN",
    "dropdelzpp": 378859998,
    "dropphyadd": "1117 HIGHWAY 411",
    "dropphycty": "VONORE",
    "dropphyst": "TN",
    "dropphyzpp": 378859998,
    "dropmaladd": "1117 HIGHWAY 411",
    "dropmalcty": "VONORE",
    "dropmalst": "TN",
    "dropmalzpp": 378859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238846391,
    "dropsitcph": 4238846391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25917",
    "droptype": "D",
    "dropname": "WALLAND",
    "dropdeladd": "5319 E LAMAR ALEXANDER PKWY",
    "dropdelcty": "WALLAND",
    "dropdelst": "TN",
    "dropdelzpp": 378869998,
    "dropphyadd": "5319 E LAMAR ALEXANDER PKWY",
    "dropphycty": "WALLAND",
    "dropphyst": "TN",
    "dropphyzpp": 378869998,
    "dropmaladd": "5319 E LAMAR ALEXANDER PKWY",
    "dropmalcty": "WALLAND",
    "dropmalst": "TN",
    "dropmalzpp": 378869998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659843031,
    "dropsitcph": 8659843031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25918",
    "droptype": "D",
    "dropname": "WALLING",
    "dropdeladd": "11839 MCMINNVILLE HWY",
    "dropdelcty": "WALLING",
    "dropdelst": "TN",
    "dropdelzpp": 385879998,
    "dropphyadd": "11839 MCMINNVILLE HWY",
    "dropphycty": "WALLING",
    "dropphyst": "TN",
    "dropphyzpp": 385879998,
    "dropmaladd": "11839 MCMINNVILLE HWY",
    "dropmalcty": "WALLING",
    "dropmalst": "TN",
    "dropmalzpp": 385879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316572433,
    "dropsitcph": 9316572433,
    "dropfax": 9316572439
  },
  {
    "dcode": "D",
    "dropkey": "PX25919",
    "droptype": "D",
    "dropname": "WARTBURG",
    "dropdeladd": "110 N MAIDEN ST",
    "dropdelcty": "WARTBURG",
    "dropdelst": "TN",
    "dropdelzpp": 378879998,
    "dropphyadd": "110 N MAIDEN ST",
    "dropphycty": "WARTBURG",
    "dropphyst": "TN",
    "dropphyzpp": 378879998,
    "dropmaladd": "110 N MAIDEN ST",
    "dropmalcty": "WARTBURG",
    "dropmalst": "TN",
    "dropmalzpp": 378879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4233466303,
    "dropsitcph": 4233466303,
    "dropfax": 4233462073
  },
  {
    "dcode": "D",
    "dropkey": "PX25920",
    "droptype": "D",
    "dropname": "WARTRACE",
    "dropdeladd": "506 BLACKMAN BLVD W",
    "dropdelcty": "WARTRACE",
    "dropdelst": "TN",
    "dropdelzpp": 371839998,
    "dropphyadd": "506 BLACKMAN BLVD W",
    "dropphycty": "WARTRACE",
    "dropphyst": "TN",
    "dropphyzpp": 371839998,
    "dropmaladd": "506 BLACKMAN BLVD W",
    "dropmalcty": "WARTRACE",
    "dropmalst": "TN",
    "dropmalzpp": 371839998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9313896636,
    "dropsitcph": 9313896636,
    "dropfax": 9313890002
  },
  {
    "dcode": "D",
    "dropkey": "PX25921",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "8110 HIGHWAY 131",
    "dropdelcty": "WASHBURN",
    "dropdelst": "TN",
    "dropdelzpp": 378889998,
    "dropphyadd": "8110 HIGHWAY 131",
    "dropphycty": "WASHBURN",
    "dropphyst": "TN",
    "dropphyzpp": 378889998,
    "dropmaladd": "8110 HIGHWAY 131",
    "dropmalcty": "WASHBURN",
    "dropmalst": "TN",
    "dropmalzpp": 378889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654972518,
    "dropsitcph": 8654972518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25923",
    "droptype": "D",
    "dropname": "WATAUGA",
    "dropdeladd": "105 N 2ND ST",
    "dropdelcty": "WATAUGA",
    "dropdelst": "TN",
    "dropdelzpp": 376949998,
    "dropphyadd": "105 N 2ND ST",
    "dropphycty": "WATAUGA",
    "dropphyst": "TN",
    "dropphyzpp": 376949998,
    "dropmaladd": "105 N 2ND ST",
    "dropmalcty": "WATAUGA",
    "dropmalst": "TN",
    "dropmalzpp": 376949998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4239268216,
    "dropsitcph": 4239268216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25924",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "601 E MAIN ST",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 371849998,
    "dropphyadd": "601 E MAIN ST",
    "dropphycty": "WATERTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 371849998,
    "dropmaladd": "601 E MAIN ST",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 371849998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152373044,
    "dropsitcph": 6152373044,
    "dropfax": 6152373920
  },
  {
    "dcode": "D",
    "dropkey": "PX25927",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "403 W MAIN ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "TN",
    "dropdelzpp": 371859998,
    "dropphyadd": "403 W MAIN ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "TN",
    "dropphyzpp": 371859998,
    "dropmaladd": "403 W MAIN ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "TN",
    "dropmalzpp": 371859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312962469,
    "dropsitcph": 9312962469,
    "dropfax": 9312969164
  },
  {
    "dcode": "D",
    "dropkey": "PX25928",
    "droptype": "D",
    "dropname": "WAYNESBORO",
    "dropdeladd": "422 S MAIN ST",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "TN",
    "dropdelzpp": 384859998,
    "dropphyadd": "422 S MAIN ST",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "TN",
    "dropphyzpp": 384859998,
    "dropmaladd": "422 S MAIN ST",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "TN",
    "dropmalzpp": 384859998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9317223709,
    "dropsitcph": 9317223709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25937",
    "droptype": "D",
    "dropname": "WESTMORELAND",
    "dropdeladd": "1 DEPOT ST",
    "dropdelcty": "WESTMORELAND",
    "dropdelst": "TN",
    "dropdelzpp": 371869998,
    "dropphyadd": "1 DEPOT ST",
    "dropphycty": "WESTMORELAND",
    "dropphyst": "TN",
    "dropphyzpp": 371869998,
    "dropmaladd": "1 DEPOT ST",
    "dropmalcty": "WESTMORELAND",
    "dropmalst": "TN",
    "dropmalzpp": 371869998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156442288,
    "dropsitcph": 6156442288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25940",
    "droptype": "D",
    "dropname": "WESTPOINT",
    "dropdeladd": "2023 TENNESSEE ST",
    "dropdelcty": "WESTPOINT",
    "dropdelst": "TN",
    "dropdelzpp": 384869998,
    "dropphyadd": "2023 TENNESSEE ST",
    "dropphycty": "WESTPOINT",
    "dropphyst": "TN",
    "dropphyzpp": 384869998,
    "dropmaladd": "2023 TENNESSEE ST",
    "dropmalcty": "WESTPOINT",
    "dropmalst": "TN",
    "dropmalzpp": 384869998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9318536623,
    "dropsitcph": 9318536623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25941",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "7265 WESTPORT RD",
    "dropdelcty": "WESTPORT",
    "dropdelst": "TN",
    "dropdelzpp": 383879998,
    "dropphyadd": "7265 WESTPORT RD",
    "dropphycty": "WESTPORT",
    "dropphyst": "TN",
    "dropphyzpp": 383879998,
    "dropmaladd": "7265 WESTPORT RD",
    "dropmalcty": "WESTPORT",
    "dropmalst": "TN",
    "dropmalzpp": 383879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212282,
    "dropsitcph": 7319863882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25944",
    "droptype": "D",
    "dropname": "WHITE BLUFF",
    "dropdeladd": "4401 HIGHWAY 70 E",
    "dropdelcty": "WHITE BLUFF",
    "dropdelst": "TN",
    "dropdelzpp": 371879998,
    "dropphyadd": "4401 HIGHWAY 70 E",
    "dropphycty": "WHITE BLUFF",
    "dropphyst": "TN",
    "dropphyzpp": 371879998,
    "dropmaladd": "4401 HIGHWAY 70 E",
    "dropmalcty": "WHITE BLUFF",
    "dropmalst": "TN",
    "dropmalzpp": 371879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6157973160,
    "dropsitcph": 6157973160,
    "dropfax": 6157974519
  },
  {
    "dcode": "D",
    "dropkey": "PX25945",
    "droptype": "D",
    "dropname": "WHITE HOUSE",
    "dropdeladd": "616 HIGHWAY 76",
    "dropdelcty": "WHITE HOUSE",
    "dropdelst": "TN",
    "dropdelzpp": 371889998,
    "dropphyadd": "616 HIGHWAY 76",
    "dropphycty": "WHITE HOUSE",
    "dropphyst": "TN",
    "dropphyzpp": 371889998,
    "dropmaladd": "616 HIGHWAY 76",
    "dropmalcty": "WHITE HOUSE",
    "dropmalst": "TN",
    "dropmalzpp": 371889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156722537,
    "dropsitcph": 6156722537,
    "dropfax": 6156729707
  },
  {
    "dcode": "D",
    "dropkey": "PX25946",
    "droptype": "D",
    "dropname": "WHITE PINE",
    "dropdeladd": "1559 MAIN ST",
    "dropdelcty": "WHITE PINE",
    "dropdelst": "TN",
    "dropdelzpp": 378909998,
    "dropphyadd": "1559 MAIN ST",
    "dropphycty": "WHITE PINE",
    "dropphyst": "TN",
    "dropphyzpp": 378909998,
    "dropmaladd": "1559 MAIN ST",
    "dropmalcty": "WHITE PINE",
    "dropmalst": "TN",
    "dropmalzpp": 378909998,
    "dropsitphn": 8656742403,
    "dropsitlph": 8656742403,
    "dropsitcph": 8656742403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25949",
    "droptype": "D",
    "dropname": "WHITES CREEK",
    "dropdeladd": "4402 WHITES CREEK PIKE",
    "dropdelcty": "WHITES CREEK",
    "dropdelst": "TN",
    "dropdelzpp": 371899998,
    "dropphyadd": "4402 WHITES CREEK PIKE",
    "dropphycty": "WHITES CREEK",
    "dropphyst": "TN",
    "dropphyzpp": 371899998,
    "dropmaladd": "4402 WHITES CREEK PIKE",
    "dropmalcty": "WHITES CREEK",
    "dropmalst": "TN",
    "dropmalzpp": 371899998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158763657,
    "dropsitcph": 6158763657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25951",
    "droptype": "D",
    "dropname": "WHITESBURG",
    "dropdeladd": "7800 E ANDREW JOHNSON HWY",
    "dropdelcty": "WHITESBURG",
    "dropdelst": "TN",
    "dropdelzpp": 378919998,
    "dropphyadd": "7800 E ANDREW JOHNSON HWY",
    "dropphycty": "WHITESBURG",
    "dropphyst": "TN",
    "dropphyzpp": 378919998,
    "dropmaladd": "7800 E ANDREW JOHNSON HWY",
    "dropmalcty": "WHITESBURG",
    "dropmalst": "TN",
    "dropmalzpp": 378919998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232352240,
    "dropsitcph": 4232352240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25952",
    "droptype": "D",
    "dropname": "WHITESIDE",
    "dropdeladd": "3725 HIGHWAY 134",
    "dropdelcty": "WHITESIDE",
    "dropdelst": "TN",
    "dropdelzpp": 373969998,
    "dropphyadd": "3725 HIGHWAY 134",
    "dropphycty": "WHITESIDE",
    "dropphyst": "TN",
    "dropphyzpp": 373969998,
    "dropmaladd": "3725 HIGHWAY 134",
    "dropmalcty": "WHITESIDE",
    "dropmalst": "TN",
    "dropmalzpp": 373969998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238212376,
    "dropsitcph": 4238212376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25953",
    "droptype": "D",
    "dropname": "WHITEVILLE",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "WHITEVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380759998,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "WHITEVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380759998,
    "dropmaladd": "112 W MAIN ST",
    "dropmalcty": "WHITEVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380759998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312548671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25956",
    "droptype": "D",
    "dropname": "WHITLEYVILLE",
    "dropdeladd": "3277 JENNINGS CREEK HWY",
    "dropdelcty": "WHITLEYVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 385889998,
    "dropphyadd": "3277 JENNINGS CREEK HWY",
    "dropphycty": "WHITLEYVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 385889998,
    "dropmaladd": "3277 JENNINGS CREEK HWY",
    "dropmalcty": "WHITLEYVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 385889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9312682249,
    "dropsitcph": 9312682249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25959",
    "droptype": "D",
    "dropname": "WHITWELL",
    "dropdeladd": "13190 HIGHWAY 28",
    "dropdelcty": "WHITWELL",
    "dropdelst": "TN",
    "dropdelzpp": 373979998,
    "dropphyadd": "13190 HIGHWAY 28",
    "dropphycty": "WHITWELL",
    "dropphyst": "TN",
    "dropphyzpp": 373979998,
    "dropmaladd": "13190 HIGHWAY 28",
    "dropmalcty": "WHITWELL",
    "dropmalst": "TN",
    "dropmalzpp": 373979998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236586485,
    "dropsitcph": 4236586485,
    "dropfax": 4236587556
  },
  {
    "dcode": "D",
    "dropkey": "PX25962",
    "droptype": "D",
    "dropname": "WILDER",
    "dropdeladd": "1010 VINES RIDGE RD",
    "dropdelcty": "WILDER",
    "dropdelst": "TN",
    "dropdelzpp": 385899998,
    "dropphyadd": "1010 VINES RIDGE RD",
    "dropphycty": "WILDER",
    "dropphyst": "TN",
    "dropphyzpp": 385899998,
    "dropmaladd": "1010 VINES RIDGE RD",
    "dropmalcty": "WILDER",
    "dropmalst": "TN",
    "dropmalzpp": 385899998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9314457020,
    "dropsitcph": 9314457020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25963",
    "droptype": "D",
    "dropname": "WILDERSVILLE",
    "dropdeladd": "115 WILDERSVILLE RD",
    "dropdelcty": "WILDERSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383889998,
    "dropphyadd": "115 WILDERSVILLE RD",
    "dropphycty": "WILDERSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383889998,
    "dropmaladd": "115 WILDERSVILLE RD",
    "dropmalcty": "WILDERSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383889998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319683494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25967",
    "droptype": "D",
    "dropname": "WILLIAMSPORT",
    "dropdeladd": "3568 WILLIAMSPORT PIKE",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "TN",
    "dropdelzpp": 384879998,
    "dropphyadd": "3568 WILLIAMSPORT PIKE",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "TN",
    "dropphyzpp": 384879998,
    "dropmaladd": "3568 WILLIAMSPORT PIKE",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "TN",
    "dropmalzpp": 384879998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9315832562,
    "dropsitcph": 9315832562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25970",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "200 S JEFFERSON ST RM 100",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "TN",
    "dropdelzpp": 373989998,
    "dropphyadd": "200 S JEFFERSON ST RM 100",
    "dropphycty": "WINCHESTER",
    "dropphyst": "TN",
    "dropphyzpp": 373989998,
    "dropmaladd": "200 S JEFFERSON ST RM 100",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "TN",
    "dropmalzpp": 373989998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9319689757,
    "dropsitcph": 9319689076,
    "dropfax": 9319673548
  },
  {
    "dcode": "D",
    "dropkey": "PX25972",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "24588 SCOTT HWY",
    "dropdelcty": "WINFIELD",
    "dropdelst": "TN",
    "dropdelzpp": 378929998,
    "dropphyadd": "24588 SCOTT HWY",
    "dropphycty": "WINFIELD",
    "dropphyst": "TN",
    "dropphyzpp": 378929998,
    "dropmaladd": "24588 SCOTT HWY",
    "dropmalcty": "WINFIELD",
    "dropmalst": "TN",
    "dropmalzpp": 378929998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235695785,
    "dropsitcph": 4235695785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25976",
    "droptype": "D",
    "dropname": "WOODBURY",
    "dropdeladd": "203 W HIGH ST",
    "dropdelcty": "WOODBURY",
    "dropdelst": "TN",
    "dropdelzpp": 371909998,
    "dropphyadd": "203 W HIGH ST",
    "dropphycty": "WOODBURY",
    "dropphyst": "TN",
    "dropphyzpp": 371909998,
    "dropmaladd": "203 W HIGH ST",
    "dropmalcty": "WOODBURY",
    "dropmalst": "TN",
    "dropmalzpp": 371909998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6155634511,
    "dropsitcph": 6155634511,
    "dropfax": 6155632359
  },
  {
    "dcode": "D",
    "dropkey": "PX25977",
    "droptype": "D",
    "dropname": "WOODLAND MILLS",
    "dropdeladd": "179 N THOMPSON ST",
    "dropdelcty": "WOODLAND MILLS",
    "dropdelst": "TN",
    "dropdelzpp": 382719998,
    "dropphyadd": "179 N THOMPSON ST",
    "dropphycty": "WOODLAND MILLS",
    "dropphyst": "TN",
    "dropphyzpp": 382719998,
    "dropmaladd": "179 N THOMPSON ST",
    "dropmalcty": "WOODLAND MILLS",
    "dropmalst": "TN",
    "dropmalzpp": 382719998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7315212208,
    "dropsitcph": 7318853970,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25979",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "2412 WOODLAWN RD",
    "dropdelcty": "WOODLAWN",
    "dropdelst": "TN",
    "dropdelzpp": 371919998,
    "dropphyadd": "2412 WOODLAWN RD",
    "dropphycty": "WOODLAWN",
    "dropphyst": "TN",
    "dropphyzpp": 371919998,
    "dropmaladd": "2412 WOODLAWN RD",
    "dropmalcty": "WOODLAWN",
    "dropmalst": "TN",
    "dropmalzpp": 371919998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316476452,
    "dropsitcph": 9316476452,
    "dropfax": 9316452097
  },
  {
    "dcode": "D",
    "dropkey": "PX25983",
    "droptype": "D",
    "dropname": "WYNNBURG",
    "dropdeladd": "5 1ST ST",
    "dropdelcty": "WYNNBURG",
    "dropdelst": "TN",
    "dropdelzpp": 380775000,
    "dropphyadd": "5 1ST ST",
    "dropphycty": "WYNNBURG",
    "dropphyst": "TN",
    "dropphyzpp": 380775000,
    "dropmaladd": "5 1ST ST",
    "dropmalcty": "WYNNBURG",
    "dropmalst": "TN",
    "dropmalzpp": 380775000,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7312537125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25984",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "9 NEWBERN",
    "dropdelcty": "YORKVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 383899998,
    "dropphyadd": "9 NEWBERN",
    "dropphycty": "YORKVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 383899998,
    "dropmaladd": "9 NEWBERN",
    "dropmalcty": "YORKVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 383899998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7316436145,
    "dropfax": 7316436355
  },
  {
    "dcode": "D",
    "dropkey": "PX25987",
    "droptype": "D",
    "dropname": "YUMA",
    "dropdeladd": "20 SCHOOL HOUSE RD",
    "dropdelcty": "YUMA",
    "dropdelst": "TN",
    "dropdelzpp": 383909998,
    "dropphyadd": "20 SCHOOL HOUSE RD",
    "dropphycty": "YUMA",
    "dropphyst": "TN",
    "dropphyzpp": 383909998,
    "dropmaladd": "20 SCHOOL HOUSE RD",
    "dropmalcty": "YUMA",
    "dropmalst": "TN",
    "dropmalzpp": 383909998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 7319865850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25990",
    "droptype": "D",
    "dropname": "ABINGDON",
    "dropdeladd": "300 W MAIN ST",
    "dropdelcty": "ABINGDON",
    "dropdelst": "VA",
    "dropdelzpp": 242109998,
    "dropphyadd": "300 W MAIN ST",
    "dropphycty": "ABINGDON",
    "dropphyst": "VA",
    "dropphyzpp": 242109998,
    "dropmaladd": "300 W MAIN ST",
    "dropmalcty": "ABINGDON",
    "dropmalst": "VA",
    "dropmalzpp": 242109998,
    "dropsitphn": 5409858780,
    "dropsitlph": 2766281121,
    "dropsitcph": 2766281121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25991",
    "droptype": "D",
    "dropname": "ACCOMAC",
    "dropdeladd": "23380 FRONT ST",
    "dropdelcty": "ACCOMAC",
    "dropdelst": "VA",
    "dropdelzpp": 233019998,
    "dropphyadd": "23380 FRONT ST",
    "dropphycty": "ACCOMAC",
    "dropphyst": "VA",
    "dropphyzpp": 233019998,
    "dropmaladd": "23380 FRONT ST",
    "dropmalcty": "ACCOMAC",
    "dropmalst": "VA",
    "dropmalzpp": 233019998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577874817,
    "dropsitcph": 7577874817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25992",
    "droptype": "D",
    "dropname": "ACHILLES",
    "dropdeladd": "9363 GUINEA RD",
    "dropdelcty": "ACHILLES",
    "dropdelst": "VA",
    "dropdelzpp": 230019998,
    "dropphyadd": "9363 GUINEA RD",
    "dropphycty": "ACHILLES",
    "dropphyst": "VA",
    "dropphyzpp": 230019998,
    "dropmaladd": "9363 GUINEA RD",
    "dropmalcty": "ACHILLES",
    "dropmalst": "VA",
    "dropmalzpp": 230019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046423838,
    "dropsitcph": 8046423838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX25995",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "3154 AFTON MOUNTAIN RD",
    "dropdelcty": "AFTON",
    "dropdelst": "VA",
    "dropdelzpp": 229209998,
    "dropphyadd": "3154 AFTON MOUNTAIN RD",
    "dropphycty": "AFTON",
    "dropphyst": "VA",
    "dropphyzpp": 229209998,
    "dropmaladd": "3154 AFTON MOUNTAIN RD",
    "dropmalcty": "AFTON",
    "dropmalst": "VA",
    "dropmalzpp": 229209998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5404566338,
    "dropsitcph": 5404566338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26000",
    "droptype": "D",
    "dropname": "ALBERTA",
    "dropdeladd": "642 MAIN ST",
    "dropdelcty": "ALBERTA",
    "dropdelst": "VA",
    "dropdelzpp": 238219998,
    "dropphyadd": "642 MAIN ST",
    "dropphycty": "ALBERTA",
    "dropphyst": "VA",
    "dropphyzpp": 238219998,
    "dropmaladd": "642 MAIN ST",
    "dropmalcty": "ALBERTA",
    "dropmalst": "VA",
    "dropmalzpp": 238219998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349497641,
    "dropsitcph": 4349497641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26001",
    "droptype": "D",
    "dropname": "ALDIE",
    "dropdeladd": "39344 LITTLE RIVER TPKE",
    "dropdelcty": "ALDIE",
    "dropdelst": "VA",
    "dropdelzpp": 201052000,
    "dropphyadd": "39344 LITTLE RIVER TPKE",
    "dropphycty": "ALDIE",
    "dropphyst": "VA",
    "dropphyzpp": 201052000,
    "dropmaladd": "39344 LITTLE RIVER TPKE",
    "dropmalcty": "ALDIE",
    "dropmalst": "VA",
    "dropmalzpp": 201052000,
    "dropsitphn": 7036986867,
    "dropsitlph": 7033276975,
    "dropsitcph": 7033276975,
    "dropfax": 7033273801
  },
  {
    "dcode": "D",
    "dropkey": "PX26003",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "1100 WYTHE ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223149998,
    "dropphyadd": "1100 WYTHE ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223149998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223139998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036847168,
    "dropsitcph": 7036847168,
    "dropfax": 7036830172
  },
  {
    "dcode": "D",
    "dropkey": "PX26010",
    "droptype": "D",
    "dropname": "ALTAVISTA",
    "dropdeladd": "700 BROAD ST",
    "dropdelcty": "ALTAVISTA",
    "dropdelst": "VA",
    "dropdelzpp": 245179998,
    "dropphyadd": "700 BROAD ST",
    "dropphycty": "ALTAVISTA",
    "dropphyst": "VA",
    "dropphyzpp": 245179998,
    "dropmaladd": "700 BROAD ST",
    "dropmalcty": "ALTAVISTA",
    "dropmalst": "VA",
    "dropmalzpp": 245179998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343099955,
    "dropfax": 4343691465
  },
  {
    "dcode": "D",
    "dropkey": "PX26011",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "2041 BLANE RD",
    "dropdelcty": "ALTON",
    "dropdelst": "VA",
    "dropdelzpp": 245209998,
    "dropphyadd": "2041 BLANE RD",
    "dropphycty": "ALTON",
    "dropphyst": "VA",
    "dropphyzpp": 245209998,
    "dropmaladd": "2041 BLANE RD",
    "dropmalcty": "ALTON",
    "dropmalst": "VA",
    "dropmalzpp": 245209998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347532221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26017",
    "droptype": "D",
    "dropname": "AMELIA COURT HOUSE",
    "dropdeladd": "16400 CHURCH ST",
    "dropdelcty": "AMELIA COURT HOUSE",
    "dropdelst": "VA",
    "dropdelzpp": 230029998,
    "dropphyadd": "16400 CHURCH ST",
    "dropphycty": "AMELIA COURT HOUSE",
    "dropphyst": "VA",
    "dropphyzpp": 230029998,
    "dropmaladd": "16400 CHURCH ST",
    "dropmalcty": "AMELIA COURT HOUSE",
    "dropmalst": "VA",
    "dropmalzpp": 230029998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045616092,
    "dropsitcph": 8045616092,
    "dropfax": 8045615381
  },
  {
    "dcode": "D",
    "dropkey": "PX26021",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "VA",
    "dropdelzpp": 245219998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "AMHERST",
    "dropphyst": "VA",
    "dropphyzpp": 245219998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "AMHERST",
    "dropmalst": "VA",
    "dropmalzpp": 245219998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4349460657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26022",
    "droptype": "D",
    "dropname": "AMISSVILLE",
    "dropdeladd": "768 VIEWTOWN RD",
    "dropdelcty": "AMISSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201069998,
    "dropphyadd": "768 VIEWTOWN RD",
    "dropphycty": "AMISSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201069998,
    "dropmaladd": "768 VIEWTOWN RD",
    "dropmalcty": "AMISSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201069998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409375777,
    "dropsitcph": 5409375777,
    "dropfax": 5409377375
  },
  {
    "dcode": "D",
    "dropkey": "PX26027",
    "droptype": "D",
    "dropname": "AMONATE",
    "dropdeladd": "5185 AMONATE RD",
    "dropdelcty": "AMONATE",
    "dropdelst": "VA",
    "dropdelzpp": 246019998,
    "dropphyadd": "5185 AMONATE RD",
    "dropphycty": "AMONATE",
    "dropphyst": "VA",
    "dropphyzpp": 246019998,
    "dropmaladd": "5185 AMONATE RD",
    "dropmalcty": "AMONATE",
    "dropmalst": "VA",
    "dropmalzpp": 246019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769887690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26034",
    "droptype": "D",
    "dropname": "ANNANDALE",
    "dropdeladd": "4270 JOHN MARR DR",
    "dropdelcty": "ANNANDALE",
    "dropdelst": "VA",
    "dropdelzpp": 220039998,
    "dropphyadd": "4270 JOHN MARR DR",
    "dropphycty": "ANNANDALE",
    "dropphyst": "VA",
    "dropphyzpp": 220039998,
    "dropmaladd": "4270 JOHN MARR DR",
    "dropmalcty": "ANNANDALE",
    "dropmalst": "VA",
    "dropmalzpp": 220039998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7032564990,
    "dropsitcph": 7032564990,
    "dropfax": 7032565906
  },
  {
    "dcode": "D",
    "dropkey": "PX26036",
    "droptype": "D",
    "dropname": "APPALACHIA",
    "dropdeladd": "534 W MAIN ST",
    "dropdelcty": "APPALACHIA",
    "dropdelst": "VA",
    "dropdelzpp": 242169998,
    "dropphyadd": "534 W MAIN ST",
    "dropphycty": "APPALACHIA",
    "dropphyst": "VA",
    "dropphyzpp": 242169998,
    "dropmaladd": "534 W MAIN ST",
    "dropmalcty": "APPALACHIA",
    "dropmalst": "VA",
    "dropmalzpp": 242169998,
    "dropsitphn": 5409858780,
    "dropsitlph": 2765650340,
    "dropsitcph": 2765650340,
    "dropfax": 2765650657
  },
  {
    "dcode": "D",
    "dropkey": "PX26038",
    "droptype": "D",
    "dropname": "APPOMATTOX",
    "dropdeladd": "791 COURT ST",
    "dropdelcty": "APPOMATTOX",
    "dropdelst": "VA",
    "dropdelzpp": 245229998,
    "dropphyadd": "791 COURT ST",
    "dropphycty": "APPOMATTOX",
    "dropphyst": "VA",
    "dropphyzpp": 245229998,
    "dropmaladd": "791 COURT ST",
    "dropmalcty": "APPOMATTOX",
    "dropmalst": "VA",
    "dropmalzpp": 245229998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343527026,
    "dropfax": 4343525289
  },
  {
    "dcode": "D",
    "dropkey": "PX26039",
    "droptype": "D",
    "dropname": "ARARAT",
    "dropdeladd": "5134 ARARAT HWY",
    "dropdelcty": "ARARAT",
    "dropdelst": "VA",
    "dropdelzpp": 240539998,
    "dropphyadd": "5134 ARARAT HWY",
    "dropphycty": "ARARAT",
    "dropphyst": "VA",
    "dropphyzpp": 240539998,
    "dropmaladd": "5134 ARARAT HWY",
    "dropmalcty": "ARARAT",
    "dropmalst": "VA",
    "dropmalzpp": 240539998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2762515472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26041",
    "droptype": "D",
    "dropname": "ARK",
    "dropdeladd": "9458 GEORGE WASHINGTON MEMORIAL HWY",
    "dropdelcty": "ARK",
    "dropdelst": "VA",
    "dropdelzpp": 230039998,
    "dropphyadd": "9458 GEORGE WASHINGTON MEMORIAL HWY",
    "dropphycty": "ARK",
    "dropphyst": "VA",
    "dropphyzpp": 230039998,
    "dropmaladd": "9458 GEORGE WASHINGTON MEMORIAL HWY",
    "dropmalcty": "ARK",
    "dropmalst": "VA",
    "dropmalzpp": 230039998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046935540,
    "dropsitcph": 8046935540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26044",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "3118 WASHINGTON BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222019998,
    "dropphyadd": "3118 WASHINGTON BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222019998,
    "dropmaladd": "3118 WASHINGTON BLVD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222019998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039930072,
    "dropsitcph": 7039930072,
    "dropfax": 7032489478
  },
  {
    "dcode": "D",
    "dropkey": "PX26050",
    "droptype": "D",
    "dropname": "ARRINGTON",
    "dropdeladd": "17 PHOENIX RD",
    "dropdelcty": "ARRINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 229229998,
    "dropphyadd": "17 PHOENIX RD",
    "dropphycty": "ARRINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 229229998,
    "dropmaladd": "17 PHOENIX RD",
    "dropmalcty": "ARRINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 229229998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342635382,
    "dropsitcph": 4342635382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26051",
    "droptype": "D",
    "dropname": "ARVONIA",
    "dropdeladd": "36 ARVON RD",
    "dropdelcty": "ARVONIA",
    "dropdelst": "VA",
    "dropdelzpp": 230049998,
    "dropphyadd": "36 ARVON RD",
    "dropphycty": "ARVONIA",
    "dropphyst": "VA",
    "dropphyzpp": 230049998,
    "dropmaladd": "36 ARVON RD",
    "dropmalcty": "ARVONIA",
    "dropmalst": "VA",
    "dropmalzpp": 230049998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345812121,
    "dropsitcph": 4345812121,
    "dropfax": 4345812121
  },
  {
    "dcode": "D",
    "dropkey": "PX26052",
    "droptype": "D",
    "dropname": "ASHBURN",
    "dropdeladd": "44715 PRENTICE DR",
    "dropdelcty": "DULLES",
    "dropdelst": "VA",
    "dropdelzpp": 201019996,
    "dropphyadd": "44715 PRENTICE DR",
    "dropphycty": "DULLES",
    "dropphyst": "VA",
    "dropphyzpp": 201019996,
    "dropmaladd": "44715 PRENTICE DR",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201019996,
    "dropsitphn": 7036986367,
    "dropsitlph": 7034066291,
    "dropsitcph": 7034066291,
    "dropfax": 7034066499
  },
  {
    "dcode": "D",
    "dropkey": "PX26053",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "301 ENGLAND ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "VA",
    "dropdelzpp": 230059998,
    "dropphyadd": "301 ENGLAND ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "VA",
    "dropphyzpp": 230059998,
    "dropmaladd": "301 ENGLAND ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "VA",
    "dropmalzpp": 230059998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047985390,
    "dropsitcph": 8047985390,
    "dropfax": 8047980452
  },
  {
    "dcode": "D",
    "dropkey": "PX26055",
    "droptype": "D",
    "dropname": "ASSAWOMAN",
    "dropdeladd": "11360 ATLANTIC RD",
    "dropdelcty": "ASSAWOMAN",
    "dropdelst": "VA",
    "dropdelzpp": 233029997,
    "dropphyadd": "11360 ATLANTIC RD",
    "dropphycty": "ASSAWOMAN",
    "dropphyst": "VA",
    "dropphyzpp": 233029997,
    "dropmaladd": "11360 ATLANTIC RD",
    "dropmalcty": "ASSAWOMAN",
    "dropmalst": "VA",
    "dropmalzpp": 233029997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578243411,
    "dropsitcph": 7578243411,
    "dropfax": 7578243411
  },
  {
    "dcode": "D",
    "dropkey": "PX26059",
    "droptype": "D",
    "dropname": "ATKINS",
    "dropdeladd": "5864 LEE HWY",
    "dropdelcty": "ATKINS",
    "dropdelst": "VA",
    "dropdelzpp": 243119998,
    "dropphyadd": "5864 LEE HWY",
    "dropphycty": "ATKINS",
    "dropphyst": "VA",
    "dropphyzpp": 243119998,
    "dropmaladd": "5864 LEE HWY",
    "dropmalcty": "ATKINS",
    "dropmalst": "VA",
    "dropmalzpp": 243119998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767835551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26060",
    "droptype": "D",
    "dropname": "ATLANTIC",
    "dropdeladd": "9561 ATLANTIC RD",
    "dropdelcty": "ATLANTIC",
    "dropdelst": "VA",
    "dropdelzpp": 233039998,
    "dropphyadd": "9561 ATLANTIC RD",
    "dropphycty": "ATLANTIC",
    "dropphyst": "VA",
    "dropphyzpp": 233039998,
    "dropmaladd": "9561 ATLANTIC RD",
    "dropmalcty": "ATLANTIC",
    "dropmalst": "VA",
    "dropmalzpp": 233039998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578245510,
    "dropsitcph": 7578245510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26064",
    "droptype": "D",
    "dropname": "AUGUSTA SPRINGS",
    "dropdeladd": "10 OLD WHITETAIL LN",
    "dropdelcty": "AUGUSTA SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 244119998,
    "dropphyadd": "10 OLD WHITETAIL LN",
    "dropphycty": "AUGUSTA SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 244119998,
    "dropmaladd": "10 OLD WHITETAIL LN",
    "dropmalcty": "AUGUSTA SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 244119998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409975741,
    "dropsitcph": 5409975741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26065",
    "droptype": "D",
    "dropname": "AUSTINVILLE",
    "dropdeladd": "2286 AUSTINVILLE RD",
    "dropdelcty": "AUSTINVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 243129998,
    "dropphyadd": "2286 AUSTINVILLE RD",
    "dropphycty": "AUSTINVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 243129998,
    "dropmaladd": "2286 AUSTINVILLE RD",
    "dropmalcty": "AUSTINVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 243129998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766991311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26066",
    "droptype": "D",
    "dropname": "AXTON",
    "dropdeladd": "1725 DANIEL RD",
    "dropdelcty": "AXTON",
    "dropdelst": "VA",
    "dropdelzpp": 240549998,
    "dropphyadd": "1725 DANIEL RD",
    "dropphycty": "AXTON",
    "dropphyst": "VA",
    "dropphyzpp": 240549998,
    "dropmaladd": "1725 DANIEL RD",
    "dropmalcty": "AXTON",
    "dropmalst": "VA",
    "dropmalzpp": 240549998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766502929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26067",
    "droptype": "D",
    "dropname": "AYLETT",
    "dropdeladd": "56 MILL RD",
    "dropdelcty": "AYLETT",
    "dropdelst": "VA",
    "dropdelzpp": 230099998,
    "dropphyadd": "56 MILL RD",
    "dropphycty": "AYLETT",
    "dropphyst": "VA",
    "dropphyzpp": 230099998,
    "dropmaladd": "56 MILL RD",
    "dropmalcty": "AYLETT",
    "dropmalst": "VA",
    "dropmalzpp": 230099998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047693306,
    "dropsitcph": 8047693306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26072",
    "droptype": "D",
    "dropname": "BACOVA",
    "dropdeladd": "23 POST OFFICE DR",
    "dropdelcty": "BACOVA",
    "dropdelst": "VA",
    "dropdelzpp": 244129998,
    "dropphyadd": "23 POST OFFICE DR",
    "dropphycty": "BACOVA",
    "dropphyst": "VA",
    "dropphyzpp": 244129998,
    "dropmaladd": "23 POST OFFICE DR",
    "dropmalcty": "BACOVA",
    "dropmalst": "VA",
    "dropmalzpp": 244129998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408392662,
    "dropsitcph": 5408392662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26078",
    "droptype": "D",
    "dropname": "BANDY",
    "dropdeladd": "4284 RAVENS NEST BRANCH RD",
    "dropdelcty": "BANDY",
    "dropdelst": "VA",
    "dropdelzpp": 246029998,
    "dropphyadd": "4284 RAVENS NEST BRANCH RD",
    "dropphycty": "BANDY",
    "dropphyst": "VA",
    "dropphyzpp": 246029998,
    "dropmaladd": "4284 RAVENS NEST BRANCH RD",
    "dropmalcty": "BANDY",
    "dropmalst": "VA",
    "dropmalzpp": 246029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769645101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26082",
    "droptype": "D",
    "dropname": "BARBOURSVILLE",
    "dropdeladd": "5285 BARBOURSVILLE COMM CTR DR",
    "dropdelcty": "BARBOURSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229238325,
    "dropphyadd": "5285 BARBOURSVILLE COMM CTR DR",
    "dropphycty": "BARBOURSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229238325,
    "dropmaladd": "5285 BARBOURSVILLE COMM CTR DR",
    "dropmalcty": "BARBOURSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229238325,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408323270,
    "dropsitcph": 5408323270,
    "dropfax": 5408323270
  },
  {
    "dcode": "D",
    "dropkey": "PX26085",
    "droptype": "D",
    "dropname": "BARHAMSVILLE",
    "dropdeladd": "18428 NEW KENT HWY",
    "dropdelcty": "BARHAMSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230119998,
    "dropphyadd": "18428 NEW KENT HWY",
    "dropphycty": "BARHAMSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230119998,
    "dropmaladd": "18428 NEW KENT HWY",
    "dropmalcty": "BARHAMSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230119998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7575660222,
    "dropsitcph": 7575660222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26090",
    "droptype": "D",
    "dropname": "BARREN SPRINGS",
    "dropdeladd": "1895 WYSOR HWY",
    "dropdelcty": "BARREN SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 243133643,
    "dropphyadd": "1895 WYSOR HWY",
    "dropphycty": "BARREN SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 243133643,
    "dropmaladd": "1895 WYSOR HWY",
    "dropmalcty": "BARREN SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 243133643,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767663881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26091",
    "droptype": "D",
    "dropname": "BASKERVILLE",
    "dropdeladd": "4444 BASKERVILLE RD",
    "dropdelcty": "BASKERVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239159998,
    "dropphyadd": "4444 BASKERVILLE RD",
    "dropphycty": "BASKERVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239159998,
    "dropmaladd": "4444 BASKERVILLE RD",
    "dropmalcty": "BASKERVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239159998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4344478724,
    "dropsitcph": 4344478724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26094",
    "droptype": "D",
    "dropname": "BASSETT",
    "dropdeladd": "3465 FAIRYSTONE PARK HWY",
    "dropdelcty": "BASSETT",
    "dropdelst": "VA",
    "dropdelzpp": 240559998,
    "dropphyadd": "3465 FAIRYSTONE PARK HWY",
    "dropphycty": "BASSETT",
    "dropphyst": "VA",
    "dropphyzpp": 240559998,
    "dropmaladd": "3465 FAIRYSTONE PARK HWY",
    "dropmalcty": "BASSETT",
    "dropmalst": "VA",
    "dropmalzpp": 240559998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766292113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26096",
    "droptype": "D",
    "dropname": "BASTIAN",
    "dropdeladd": "178 WALNUT DR",
    "dropdelcty": "BASTIAN",
    "dropdelst": "VA",
    "dropdelzpp": 243149998,
    "dropphyadd": "178 WALNUT DR",
    "dropphycty": "BASTIAN",
    "dropphyst": "VA",
    "dropphyzpp": 243149998,
    "dropmaladd": "178 WALNUT DR",
    "dropmalcty": "BASTIAN",
    "dropmalst": "VA",
    "dropmalzpp": 243149998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766885026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26097",
    "droptype": "D",
    "dropname": "BASYE",
    "dropdeladd": "1540 ORKNEY GRADE",
    "dropdelcty": "BASYE",
    "dropdelst": "VA",
    "dropdelzpp": 228109998,
    "dropphyadd": "1540 ORKNEY GRADE",
    "dropphycty": "BASYE",
    "dropphyst": "VA",
    "dropphyzpp": 228109998,
    "dropmaladd": "1540 ORKNEY GRADE",
    "dropmalcty": "BASYE",
    "dropmalst": "VA",
    "dropmalzpp": 228109998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408568188,
    "dropsitcph": 8778541746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26098",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "6620 PLANK RD",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229249998,
    "dropphyadd": "6620 PLANK RD",
    "dropphycty": "BATESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229249998,
    "dropmaladd": "6620 PLANK RD",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4348232300,
    "dropsitcph": 4348232300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26101",
    "droptype": "D",
    "dropname": "BATTERY PARK",
    "dropdeladd": "20512 TODD AVE",
    "dropdelcty": "BATTERY PARK",
    "dropdelst": "VA",
    "dropdelzpp": 233049998,
    "dropphyadd": "20512 TODD AVE",
    "dropphycty": "BATTERY PARK",
    "dropphyst": "VA",
    "dropphyzpp": 233049998,
    "dropmaladd": "20512 TODD AVE",
    "dropmalcty": "BATTERY PARK",
    "dropmalst": "VA",
    "dropmalzpp": 233049998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573570290,
    "dropsitcph": 7573570290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26107",
    "droptype": "D",
    "dropname": "BEALETON",
    "dropdeladd": "6189 STATION DR",
    "dropdelcty": "BEALETON",
    "dropdelst": "VA",
    "dropdelzpp": 227129998,
    "dropphyadd": "6189 STATION DR",
    "dropphycty": "BEALETON",
    "dropphyst": "VA",
    "dropphyzpp": 227129998,
    "dropmaladd": "6189 STATION DR",
    "dropmalcty": "BEALETON",
    "dropmalst": "VA",
    "dropmalzpp": 227129998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5404396483,
    "dropsitcph": 5404396483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26109",
    "droptype": "D",
    "dropname": "BEAVERDAM",
    "dropdeladd": "16176 BEAVERDAM SCHOOL RD",
    "dropdelcty": "BEAVERDAM",
    "dropdelst": "VA",
    "dropdelzpp": 230159998,
    "dropphyadd": "16176 BEAVERDAM SCHOOL RD",
    "dropphycty": "BEAVERDAM",
    "dropphyst": "VA",
    "dropphyzpp": 230159998,
    "dropmaladd": "16176 BEAVERDAM SCHOOL RD",
    "dropmalcty": "BEAVERDAM",
    "dropmalst": "VA",
    "dropmalzpp": 230159998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042584049,
    "dropsitcph": 8042584049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26111",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "500 E MAIN ST",
    "dropdelcty": "BEDFORD",
    "dropdelst": "VA",
    "dropdelzpp": 245239998,
    "dropphyadd": "500 E MAIN ST",
    "dropphycty": "BEDFORD",
    "dropphyst": "VA",
    "dropphyzpp": 245239998,
    "dropmaladd": "500 E MAIN ST",
    "dropmalcty": "BEDFORD",
    "dropmalst": "VA",
    "dropmalzpp": 245239998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405865820,
    "dropfax": 5405863794
  },
  {
    "dcode": "D",
    "dropkey": "PX26115",
    "droptype": "D",
    "dropname": "BELLE HAVEN",
    "dropdeladd": "35561 BELLE HAVEN RD",
    "dropdelcty": "BELLE HAVEN",
    "dropdelst": "VA",
    "dropdelzpp": 233069998,
    "dropphyadd": "35561 BELLE HAVEN RD",
    "dropphycty": "BELLE HAVEN",
    "dropphyst": "VA",
    "dropphyzpp": 233069998,
    "dropmaladd": "35561 BELLE HAVEN RD",
    "dropmalcty": "BELLE HAVEN",
    "dropmalst": "VA",
    "dropmalzpp": 233069998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7574426509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26120",
    "droptype": "D",
    "dropname": "BELSPRING",
    "dropdeladd": "7893 NECK CREEK RD",
    "dropdelcty": "BELSPRING",
    "dropdelst": "VA",
    "dropdelzpp": 240589998,
    "dropphyadd": "7893 NECK CREEK RD",
    "dropphycty": "BELSPRING",
    "dropphyst": "VA",
    "dropphyzpp": 240589998,
    "dropmaladd": "7893 NECK CREEK RD",
    "dropmalcty": "BELSPRING",
    "dropmalst": "VA",
    "dropmalzpp": 240589998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406396102,
    "dropfax": 5406390718
  },
  {
    "dcode": "D",
    "dropkey": "PX26121",
    "droptype": "D",
    "dropname": "BEN HUR",
    "dropdeladd": "37997 VETERANS MEMORIAL HWY",
    "dropdelcty": "BEN HUR",
    "dropdelst": "VA",
    "dropdelzpp": 242189998,
    "dropphyadd": "37997 VETERANS MEMORIAL HWY",
    "dropphycty": "BEN HUR",
    "dropphyst": "VA",
    "dropphyzpp": 242189998,
    "dropmaladd": "37997 VETERANS MEMORIAL HWY",
    "dropmalcty": "BEN HUR",
    "dropmalst": "VA",
    "dropmalzpp": 242189998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763461756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26122",
    "droptype": "D",
    "dropname": "BENA",
    "dropdeladd": "8833 GUINEA RD",
    "dropdelcty": "BENA",
    "dropdelst": "VA",
    "dropdelzpp": 230189998,
    "dropphyadd": "8833 GUINEA RD",
    "dropphycty": "BENA",
    "dropphyst": "VA",
    "dropphyzpp": 230189998,
    "dropmaladd": "8833 GUINEA RD",
    "dropmalcty": "BENA",
    "dropmalst": "VA",
    "dropmalzpp": 230189998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046426311,
    "dropsitcph": 8046426311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26124",
    "droptype": "D",
    "dropname": "BENT MOUNTAIN",
    "dropdeladd": "9961 BENT MOUNTAIN RD",
    "dropdelcty": "BENT MOUNTAIN",
    "dropdelst": "VA",
    "dropdelzpp": 240599998,
    "dropphyadd": "9961 BENT MOUNTAIN RD",
    "dropphycty": "BENT MOUNTAIN",
    "dropphyst": "VA",
    "dropphyzpp": 240599998,
    "dropmaladd": "9961 BENT MOUNTAIN RD",
    "dropmalcty": "BENT MOUNTAIN",
    "dropmalst": "VA",
    "dropmalzpp": 240599998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409294790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26126",
    "droptype": "D",
    "dropname": "BENTONVILLE",
    "dropdeladd": "2590 STONEWALL JACKSON HWY",
    "dropdelcty": "BENTONVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 226102260,
    "dropphyadd": "2590 STONEWALL JACKSON HWY",
    "dropphycty": "BENTONVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 226102260,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENTONVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 226109998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406353225,
    "dropsitcph": 5406353225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26129",
    "droptype": "D",
    "dropname": "BERGTON",
    "dropdeladd": "17175 BERGTON RD",
    "dropdelcty": "BERGTON",
    "dropdelst": "VA",
    "dropdelzpp": 228119998,
    "dropphyadd": "17175 BERGTON RD",
    "dropphycty": "BERGTON",
    "dropphyst": "VA",
    "dropphyzpp": 228119998,
    "dropmaladd": "17175 BERGTON RD",
    "dropmalcty": "BERGTON",
    "dropmalst": "VA",
    "dropmalzpp": 228119998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408523302,
    "dropsitcph": 5408523302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26131",
    "droptype": "D",
    "dropname": "BERRYVILLE",
    "dropdeladd": "27 N CHURCH ST",
    "dropdelcty": "BERRYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 226119998,
    "dropphyadd": "27 N CHURCH ST",
    "dropphycty": "BERRYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 226119998,
    "dropmaladd": "27 N CHURCH ST",
    "dropmalcty": "BERRYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 226119998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5409552667,
    "dropsitcph": 5409552667,
    "dropfax": 5409559531
  },
  {
    "dcode": "D",
    "dropkey": "PX26135",
    "droptype": "D",
    "dropname": "BIG ISLAND",
    "dropdeladd": "10830 LEE JACKSON HWY",
    "dropdelcty": "BIG ISLAND",
    "dropdelst": "VA",
    "dropdelzpp": 245269998,
    "dropphyadd": "10830 LEE JACKSON HWY",
    "dropphycty": "BIG ISLAND",
    "dropphyst": "VA",
    "dropphyzpp": 245269998,
    "dropmaladd": "10830 LEE JACKSON HWY",
    "dropmalcty": "BIG ISLAND",
    "dropmalst": "VA",
    "dropmalzpp": 245269998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342995072,
    "dropfax": 4342995072
  },
  {
    "dcode": "D",
    "dropkey": "PX26136",
    "droptype": "D",
    "dropname": "BIG ROCK",
    "dropdeladd": "32148 RIVERSIDE DR",
    "dropdelcty": "BIG ROCK",
    "dropdelst": "VA",
    "dropdelzpp": 246039998,
    "dropphyadd": "32148 RIVERSIDE DR",
    "dropphycty": "BIG ROCK",
    "dropphyst": "VA",
    "dropphyzpp": 246039998,
    "dropmaladd": "32148 RIVERSIDE DR",
    "dropmalcty": "BIG ROCK",
    "dropmalst": "VA",
    "dropmalzpp": 246039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765307660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26137",
    "droptype": "D",
    "dropname": "BIG STONE GAP",
    "dropdeladd": "322 WOOD AVE E STE 2",
    "dropdelcty": "BIG STONE GAP",
    "dropdelst": "VA",
    "dropdelzpp": 242199998,
    "dropphyadd": "322 WOOD AVE E STE 2",
    "dropphycty": "BIG STONE GAP",
    "dropphyst": "VA",
    "dropphyzpp": 242199998,
    "dropmaladd": "322 WOOD AVE E STE 2",
    "dropmalcty": "BIG STONE GAP",
    "dropmalst": "VA",
    "dropmalzpp": 242199998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2765232960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26138",
    "droptype": "D",
    "dropname": "BIRCHLEAF",
    "dropdeladd": "166 RAKES RIDGE RD",
    "dropdelcty": "BIRCHLEAF",
    "dropdelst": "VA",
    "dropdelzpp": 242209998,
    "dropphyadd": "166 RAKES RIDGE RD",
    "dropphycty": "BIRCHLEAF",
    "dropphyst": "VA",
    "dropphyzpp": 242209998,
    "dropmaladd": "166 RAKES RIDGE RD",
    "dropmalcty": "BIRCHLEAF",
    "dropmalst": "VA",
    "dropmalzpp": 242209998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768654966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26140",
    "droptype": "D",
    "dropname": "BISHOP",
    "dropdeladd": "3978 STONEY RIDGE RD",
    "dropdelcty": "BISHOP",
    "dropdelst": "VA",
    "dropdelzpp": 246049998,
    "dropphyadd": "3978 STONEY RIDGE RD",
    "dropphycty": "BISHOP",
    "dropphyst": "VA",
    "dropphyzpp": 246049998,
    "dropmaladd": "3978 STONEY RIDGE RD",
    "dropmalcty": "BISHOP",
    "dropmalst": "VA",
    "dropmalzpp": 246049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769883043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26142",
    "droptype": "D",
    "dropname": "BLACKSBURG",
    "dropdeladd": "909 UNIVERSITY CITY BLVD",
    "dropdelcty": "BLACKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 240609998,
    "dropphyadd": "909 UNIVERSITY CITY BLVD",
    "dropphycty": "BLACKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 240609998,
    "dropmaladd": "909 UNIVERSITY CITY BLVD",
    "dropmalcty": "BLACKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 240609998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405522751,
    "dropfax": 5405525219
  },
  {
    "dcode": "D",
    "dropkey": "PX26143",
    "droptype": "D",
    "dropname": "BLACKSTONE",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "BLACKSTONE",
    "dropdelst": "VA",
    "dropdelzpp": 238249998,
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "BLACKSTONE",
    "dropphyst": "VA",
    "dropphyzpp": 238249998,
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "BLACKSTONE",
    "dropmalst": "VA",
    "dropmalzpp": 238249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342924457,
    "dropsitcph": 4342924457,
    "dropfax": 4342244457
  },
  {
    "dcode": "D",
    "dropkey": "PX26144",
    "droptype": "D",
    "dropname": "BLACKWATER",
    "dropdeladd": "8989 STATE ROUTE 70 STE 101",
    "dropdelcty": "BLACKWATER",
    "dropdelst": "VA",
    "dropdelzpp": 242219998,
    "dropphyadd": "8989 STATE ROUTE 70 STE 101",
    "dropphycty": "BLACKWATER",
    "dropphyst": "VA",
    "dropphyzpp": 242219998,
    "dropmaladd": "8989 STATE ROUTE 70 STE 101",
    "dropmalcty": "BLACKWATER",
    "dropmalst": "VA",
    "dropmalzpp": 242219998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763463497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26146",
    "droptype": "D",
    "dropname": "BLAIRS",
    "dropdeladd": "5601 U S HIGHWAY 29",
    "dropdelcty": "BLAIRS",
    "dropdelst": "VA",
    "dropdelzpp": 245279998,
    "dropphyadd": "5601 U S HIGHWAY 29",
    "dropphycty": "BLAIRS",
    "dropphyst": "VA",
    "dropphyzpp": 245279998,
    "dropmaladd": "5601 U S HIGHWAY 29",
    "dropmalcty": "BLAIRS",
    "dropmalst": "VA",
    "dropmalzpp": 245279998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4348363735,
    "dropfax": 5408363735
  },
  {
    "dcode": "D",
    "dropkey": "PX26148",
    "droptype": "D",
    "dropname": "BLAND",
    "dropdeladd": "207 JACKSON ST",
    "dropdelcty": "BLAND",
    "dropdelst": "VA",
    "dropdelzpp": 243159998,
    "dropphyadd": "207 JACKSON ST",
    "dropphycty": "BLAND",
    "dropphyst": "VA",
    "dropphyzpp": 243159998,
    "dropmaladd": "207 JACKSON ST",
    "dropmalcty": "BLAND",
    "dropmalst": "VA",
    "dropmalzpp": 243159998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766883751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26150",
    "droptype": "D",
    "dropname": "BLOXOM",
    "dropdeladd": "26099 SHOREMAIN DR",
    "dropdelcty": "BLOXOM",
    "dropdelst": "VA",
    "dropdelzpp": 233089998,
    "dropphyadd": "26099 SHOREMAIN DR",
    "dropphycty": "BLOXOM",
    "dropphyst": "VA",
    "dropphyzpp": 233089998,
    "dropmaladd": "26099 SHOREMAIN DR",
    "dropmalcty": "BLOXOM",
    "dropmalst": "VA",
    "dropmalzpp": 233089998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576654130,
    "dropsitcph": 7576654130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26153",
    "droptype": "D",
    "dropname": "BLUE GRASS",
    "dropdeladd": "2741 BLUE GRASS VALLEY RD",
    "dropdelcty": "BLUE GRASS",
    "dropdelst": "VA",
    "dropdelzpp": 244139998,
    "dropphyadd": "2741 BLUE GRASS VALLEY RD",
    "dropphycty": "BLUE GRASS",
    "dropphyst": "VA",
    "dropphyzpp": 244139998,
    "dropmaladd": "2741 BLUE GRASS VALLEY RD",
    "dropmalcty": "BLUE GRASS",
    "dropmalst": "VA",
    "dropmalzpp": 244139998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5404745501,
    "dropsitcph": 5404745501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26154",
    "droptype": "D",
    "dropname": "BLUE RIDGE",
    "dropdeladd": "3521 BLUE RIDGE BLVD",
    "dropdelcty": "BLUE RIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 240649998,
    "dropphyadd": "3521 BLUE RIDGE BLVD",
    "dropphycty": "BLUE RIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 240649998,
    "dropmaladd": "3521 BLUE RIDGE BLVD",
    "dropmalcty": "BLUE RIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 240649998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409771964,
    "dropfax": 5409773641
  },
  {
    "dcode": "D",
    "dropkey": "PX26155",
    "droptype": "D",
    "dropname": "BLUEFIELD",
    "dropdeladd": "507 VIRGINIA AVE",
    "dropdelcty": "BLUEFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 246059998,
    "dropphyadd": "507 VIRGINIA AVE",
    "dropphycty": "BLUEFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 246059998,
    "dropmaladd": "507 VIRGINIA AVE",
    "dropmalcty": "BLUEFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 246059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2763261553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26156",
    "droptype": "D",
    "dropname": "BLUEMONT",
    "dropdeladd": "33775 SNICKERSVILLE TPKE",
    "dropdelcty": "BLUEMONT",
    "dropdelst": "VA",
    "dropdelzpp": 201359997,
    "dropphyadd": "33775 SNICKERSVILLE TPKE",
    "dropphycty": "BLUEMONT",
    "dropphyst": "VA",
    "dropphyzpp": 201359997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUEMONT",
    "dropmalst": "VA",
    "dropmalzpp": 201359998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5405544537,
    "dropsitcph": 5405544537,
    "dropfax": 5405548332
  },
  {
    "dcode": "D",
    "dropkey": "PX26158",
    "droptype": "D",
    "dropname": "BOISSEVAIN",
    "dropdeladd": "102 CREEKVIEW RD",
    "dropdelcty": "BOISSEVAIN",
    "dropdelst": "VA",
    "dropdelzpp": 246069998,
    "dropphyadd": "102 CREEKVIEW RD",
    "dropphycty": "BOISSEVAIN",
    "dropphyst": "VA",
    "dropphyzpp": 246069998,
    "dropmaladd": "102 CREEKVIEW RD",
    "dropmalcty": "BOISSEVAIN",
    "dropmalst": "VA",
    "dropmalzpp": 246069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769455800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26164",
    "droptype": "D",
    "dropname": "BOONES MILL",
    "dropdeladd": "60 MAIN ST",
    "dropdelcty": "BOONES MILL",
    "dropdelst": "VA",
    "dropdelzpp": 240659998,
    "dropphyadd": "60 MAIN ST",
    "dropphycty": "BOONES MILL",
    "dropphyst": "VA",
    "dropphyzpp": 240659998,
    "dropmaladd": "60 MAIN ST",
    "dropmalcty": "BOONES MILL",
    "dropmalst": "VA",
    "dropmalzpp": 240659998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403345222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26166",
    "droptype": "D",
    "dropname": "BOSTON",
    "dropdeladd": "6276 SPERRYVILLE PIKE",
    "dropdelcty": "BOSTON",
    "dropdelst": "VA",
    "dropdelzpp": 227139998,
    "dropphyadd": "6276 SPERRYVILLE PIKE",
    "dropphycty": "BOSTON",
    "dropphyst": "VA",
    "dropphyzpp": 227139998,
    "dropmaladd": "6276 SPERRYVILLE PIKE",
    "dropmalcty": "BOSTON",
    "dropmalst": "VA",
    "dropmalzpp": 227139998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5405473474,
    "dropsitcph": 5405473474,
    "dropfax": 5405472279
  },
  {
    "dcode": "D",
    "dropkey": "PX26171",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "117 MILFORD ST",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "VA",
    "dropdelzpp": 224279998,
    "dropphyadd": "117 MILFORD ST",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "VA",
    "dropphyzpp": 224279998,
    "dropmaladd": "117 MILFORD ST",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "VA",
    "dropmalzpp": 224279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046330471,
    "dropsitcph": 8046330471,
    "dropfax": 8046331491
  },
  {
    "dcode": "D",
    "dropkey": "PX26174",
    "droptype": "D",
    "dropname": "BOYCE",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "BOYCE",
    "dropdelst": "VA",
    "dropdelzpp": 226209744,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "BOYCE",
    "dropphyst": "VA",
    "dropphyzpp": 226209744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYCE",
    "dropmalst": "VA",
    "dropmalzpp": 226209998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403066321,
    "dropsitcph": 5403066321,
    "dropfax": 5408372666
  },
  {
    "dcode": "D",
    "dropkey": "PX26177",
    "droptype": "D",
    "dropname": "BOYDTON",
    "dropdeladd": "419 MADISON ST",
    "dropdelcty": "BOYDTON",
    "dropdelst": "VA",
    "dropdelzpp": 239179998,
    "dropphyadd": "419 MADISON ST",
    "dropphycty": "BOYDTON",
    "dropphyst": "VA",
    "dropphyzpp": 239179998,
    "dropmaladd": "419 MADISON ST",
    "dropmalcty": "BOYDTON",
    "dropmalst": "VA",
    "dropmalzpp": 239179998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347386477,
    "dropsitcph": 4347386477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26178",
    "droptype": "D",
    "dropname": "BOYKINS",
    "dropdeladd": "32129 N MAIN ST",
    "dropdelcty": "BOYKINS",
    "dropdelst": "VA",
    "dropdelzpp": 238279998,
    "dropphyadd": "32129 N MAIN ST",
    "dropphycty": "BOYKINS",
    "dropphyst": "VA",
    "dropphyzpp": 238279998,
    "dropmaladd": "32129 N MAIN ST",
    "dropmalcty": "BOYKINS",
    "dropmalst": "VA",
    "dropmalzpp": 238279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7576546371,
    "dropsitcph": 7576546371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26180",
    "droptype": "D",
    "dropname": "BRACEY",
    "dropdeladd": "3913 HIGHWAY NINE O THREE",
    "dropdelcty": "BRACEY",
    "dropdelst": "VA",
    "dropdelzpp": 239199998,
    "dropphyadd": "3913 HIGHWAY NINE O THREE",
    "dropphycty": "BRACEY",
    "dropphyst": "VA",
    "dropphyzpp": 239199998,
    "dropmaladd": "3913 HIGHWAY NINE O THREE",
    "dropmalcty": "BRACEY",
    "dropmalst": "VA",
    "dropmalzpp": 239199998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346362941,
    "dropsitcph": 4346362941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26181",
    "droptype": "D",
    "dropname": "BRANCHVILLE",
    "dropdeladd": "33143 WOODARD ST",
    "dropdelcty": "BRANCHVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 238289998,
    "dropphyadd": "33143 WOODARD ST",
    "dropphycty": "BRANCHVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 238289998,
    "dropmaladd": "33143 WOODARD ST",
    "dropmalcty": "BRANCHVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 238289998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046546491,
    "dropsitcph": 8046546491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26186",
    "droptype": "D",
    "dropname": "BRANDY STATION",
    "dropdeladd": "19329 BRANDY RD",
    "dropdelcty": "BRANDY STATION",
    "dropdelst": "VA",
    "dropdelzpp": 227149998,
    "dropphyadd": "19329 BRANDY RD",
    "dropphycty": "BRANDY STATION",
    "dropphyst": "VA",
    "dropphyzpp": 227149998,
    "dropmaladd": "19329 BRANDY RD",
    "dropmalcty": "BRANDY STATION",
    "dropmalst": "VA",
    "dropmalzpp": 227149998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408259322,
    "dropsitcph": 5408259322,
    "dropfax": 5408259322
  },
  {
    "dcode": "D",
    "dropkey": "PX26187",
    "droptype": "D",
    "dropname": "BREAKS",
    "dropdeladd": "579 KING SOLOMON COLLEY RD",
    "dropdelcty": "BREAKS",
    "dropdelst": "VA",
    "dropdelzpp": 246079998,
    "dropphyadd": "579 KING SOLOMON COLLEY RD",
    "dropphycty": "BREAKS",
    "dropphyst": "VA",
    "dropphyzpp": 246079998,
    "dropmaladd": "579 KING SOLOMON COLLEY RD",
    "dropmalcty": "BREAKS",
    "dropmalst": "VA",
    "dropmalzpp": 246079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765318894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26189",
    "droptype": "D",
    "dropname": "BREMO BLUFF",
    "dropdeladd": "538 BREMO RD",
    "dropdelcty": "BREMO BLUFF",
    "dropdelst": "VA",
    "dropdelzpp": 230229998,
    "dropphyadd": "538 BREMO RD",
    "dropphycty": "BREMO BLUFF",
    "dropphyst": "VA",
    "dropphyzpp": 230229998,
    "dropmaladd": "538 BREMO RD",
    "dropmalcty": "BREMO BLUFF",
    "dropmalst": "VA",
    "dropmalzpp": 230229998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4348423092,
    "dropsitcph": 4348423092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26190",
    "droptype": "D",
    "dropname": "BRIDGEWATER",
    "dropdeladd": "100 W COLLEGE ST",
    "dropdelcty": "BRIDGEWATER",
    "dropdelst": "VA",
    "dropdelzpp": 228129998,
    "dropphyadd": "100 W COLLEGE ST",
    "dropphycty": "BRIDGEWATER",
    "dropphyst": "VA",
    "dropphyzpp": 228129998,
    "dropmaladd": "100 W COLLEGE ST",
    "dropmalcty": "BRIDGEWATER",
    "dropmalst": "VA",
    "dropmalzpp": 228129998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408287114,
    "dropsitcph": 5408287114,
    "dropfax": 5408284228
  },
  {
    "dcode": "D",
    "dropkey": "PX26194",
    "droptype": "D",
    "dropname": "BRIGHTWOOD",
    "dropdeladd": "4362 N SEMINOLE TRL",
    "dropdelcty": "BRIGHTWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 227159997,
    "dropphyadd": "4362 N SEMINOLE TRL",
    "dropphycty": "BRIGHTWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 227159997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIGHTWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 227159998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5405432044,
    "dropsitcph": 5405432044,
    "dropfax": 5405432091
  },
  {
    "dcode": "D",
    "dropkey": "PX26196",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "111 6TH ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "VA",
    "dropdelzpp": 242039998,
    "dropphyadd": "111 6TH ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "VA",
    "dropphyzpp": 242039998,
    "dropmaladd": "111 6TH ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "VA",
    "dropmalzpp": 242039998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4232748010,
    "dropfax": 4234668824
  },
  {
    "dcode": "D",
    "dropkey": "PX26197",
    "droptype": "D",
    "dropname": "BRISTOW",
    "dropdeladd": "11151 VALLEY VIEW DR",
    "dropdelcty": "BRISTOW",
    "dropdelst": "VA",
    "dropdelzpp": 201369998,
    "dropphyadd": "11151 VALLEY VIEW DR",
    "dropphycty": "BRISTOW",
    "dropphyst": "VA",
    "dropphyzpp": 201369998,
    "dropmaladd": "11151 VALLEY VIEW DR",
    "dropmalcty": "BRISTOW",
    "dropmalst": "VA",
    "dropmalzpp": 201369998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7033688209,
    "dropsitcph": 7033688209,
    "dropfax": 7033683320
  },
  {
    "dcode": "D",
    "dropkey": "PX26199",
    "droptype": "D",
    "dropname": "BROAD RUN",
    "dropdeladd": "5073 JOHN MARSHALL HWY",
    "dropdelcty": "BROAD RUN",
    "dropdelst": "VA",
    "dropdelzpp": 201371716,
    "dropphyadd": "5073 JOHN MARSHALL HWY",
    "dropphycty": "BROAD RUN",
    "dropphyst": "VA",
    "dropphyzpp": 201371716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROAD RUN",
    "dropmalst": "VA",
    "dropmalzpp": 201379998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037544560,
    "dropsitcph": 7037544560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26201",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "151 N CENTRAL ST",
    "dropdelcty": "BROADWAY",
    "dropdelst": "VA",
    "dropdelzpp": 228159998,
    "dropphyadd": "151 N CENTRAL ST",
    "dropphycty": "BROADWAY",
    "dropphyst": "VA",
    "dropphyzpp": 228159998,
    "dropmaladd": "151 N CENTRAL ST",
    "dropmalcty": "BROADWAY",
    "dropmalst": "VA",
    "dropmalzpp": 228159998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409019328,
    "dropsitcph": 5409019328,
    "dropfax": 5408969441
  },
  {
    "dcode": "D",
    "dropkey": "PX26202",
    "droptype": "D",
    "dropname": "BRODNAX",
    "dropdeladd": "460 PINEY POND RD",
    "dropdelcty": "BRODNAX",
    "dropdelst": "VA",
    "dropdelzpp": 239209998,
    "dropphyadd": "460 PINEY POND RD",
    "dropphycty": "BRODNAX",
    "dropphyst": "VA",
    "dropphyzpp": 239209998,
    "dropmaladd": "460 PINEY POND RD",
    "dropmalcty": "BRODNAX",
    "dropmalst": "VA",
    "dropmalzpp": 239209998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347295225,
    "dropsitcph": 4347295225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26204",
    "droptype": "D",
    "dropname": "BROOKNEAL",
    "dropdeladd": "101 TODD ST",
    "dropdelcty": "BROOKNEAL",
    "dropdelst": "VA",
    "dropdelzpp": 245289998,
    "dropphyadd": "101 TODD ST",
    "dropphycty": "BROOKNEAL",
    "dropphyst": "VA",
    "dropphyzpp": 245289998,
    "dropmaladd": "101 TODD ST",
    "dropmalcty": "BROOKNEAL",
    "dropmalst": "VA",
    "dropmalzpp": 245289998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343762338,
    "dropfax": 4343762701
  },
  {
    "dcode": "D",
    "dropkey": "PX26207",
    "droptype": "D",
    "dropname": "BROWNSBURG",
    "dropdeladd": "2741 BROWNSBURG TPKE",
    "dropdelcty": "BROWNSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 244159800,
    "dropphyadd": "2741 BROWNSBURG TPKE",
    "dropphycty": "BROWNSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 244159800,
    "dropmaladd": "2741 BROWNSBURG TPKE",
    "dropmalcty": "BROWNSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 244159800,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403485935,
    "dropsitcph": 5403485935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26214",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "19698 MAIN ST",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "VA",
    "dropdelzpp": 240669998,
    "dropphyadd": "19698 MAIN ST",
    "dropphycty": "BUCHANAN",
    "dropphyst": "VA",
    "dropphyzpp": 240669998,
    "dropmaladd": "19698 MAIN ST",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "VA",
    "dropmalzpp": 240669998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402542178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26216",
    "droptype": "D",
    "dropname": "BUCKINGHAM",
    "dropdeladd": "4241 OAK HILL RD",
    "dropdelcty": "BUCKINGHAM",
    "dropdelst": "VA",
    "dropdelzpp": 239219998,
    "dropphyadd": "4241 OAK HILL RD",
    "dropphycty": "BUCKINGHAM",
    "dropphyst": "VA",
    "dropphyzpp": 239219998,
    "dropmaladd": "4241 OAK HILL RD",
    "dropmalcty": "BUCKINGHAM",
    "dropmalst": "VA",
    "dropmalzpp": 239219998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349694227,
    "dropsitcph": 4349694227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26218",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "2071 FOREST AVE",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "VA",
    "dropdelzpp": 244169998,
    "dropphyadd": "2071 FOREST AVE",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "VA",
    "dropphyzpp": 244169998,
    "dropmaladd": "2071 FOREST AVE",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "VA",
    "dropmalzpp": 244169998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402618959,
    "dropsitcph": 5402618959,
    "dropfax": 5402612196
  },
  {
    "dcode": "D",
    "dropkey": "PX26220",
    "droptype": "D",
    "dropname": "BUFFALO JUNCTION",
    "dropdeladd": "7199 HIGHWAY 49",
    "dropdelcty": "BUFFALO JUNCTION",
    "dropdelst": "VA",
    "dropdelzpp": 245294420,
    "dropphyadd": "7199 HIGHWAY 49",
    "dropphycty": "BUFFALO JUNCTION",
    "dropphyst": "VA",
    "dropphyzpp": 245294420,
    "dropmaladd": "7199 HIGHWAY 49",
    "dropmalcty": "BUFFALO JUNCTION",
    "dropmalst": "VA",
    "dropmalzpp": 245294420,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343742855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26222",
    "droptype": "D",
    "dropname": "BUMPASS",
    "dropdeladd": "68 FREDERICKS HALL RD",
    "dropdelcty": "BUMPASS",
    "dropdelst": "VA",
    "dropdelzpp": 230249998,
    "dropphyadd": "68 FREDERICKS HALL RD",
    "dropphycty": "BUMPASS",
    "dropphyst": "VA",
    "dropphyzpp": 230249998,
    "dropmaladd": "68 FREDERICKS HALL RD",
    "dropmalcty": "BUMPASS",
    "dropmalst": "VA",
    "dropmalzpp": 230249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408727095,
    "dropsitcph": 5408727095,
    "dropfax": 5408722453
  },
  {
    "dcode": "D",
    "dropkey": "PX26223",
    "droptype": "D",
    "dropname": "BURGESS",
    "dropdeladd": "15096 NORTHUMBERLAND HWY",
    "dropdelcty": "BURGESS",
    "dropdelst": "VA",
    "dropdelzpp": 224329998,
    "dropphyadd": "15096 NORTHUMBERLAND HWY",
    "dropphycty": "BURGESS",
    "dropphyst": "VA",
    "dropphyzpp": 224329998,
    "dropmaladd": "15096 NORTHUMBERLAND HWY",
    "dropmalcty": "BURGESS",
    "dropmalst": "VA",
    "dropmalzpp": 224329998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044533772,
    "dropsitcph": 8044533772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26226",
    "droptype": "D",
    "dropname": "BURKEVILLE",
    "dropdeladd": "204 S AGNEW ST",
    "dropdelcty": "BURKEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239229998,
    "dropphyadd": "204 S AGNEW ST",
    "dropphycty": "BURKEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239229998,
    "dropmaladd": "204 S AGNEW ST",
    "dropmalcty": "BURKEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239229998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347675233,
    "dropsitcph": 4347675233,
    "dropfax": 4347675233
  },
  {
    "dcode": "D",
    "dropkey": "PX26244",
    "droptype": "D",
    "dropname": "CALLANDS",
    "dropdeladd": "12001 CALLANDS RD",
    "dropdelcty": "CALLANDS",
    "dropdelst": "VA",
    "dropdelzpp": 245309998,
    "dropphyadd": "12001 CALLANDS RD",
    "dropphycty": "CALLANDS",
    "dropphyst": "VA",
    "dropphyzpp": 245309998,
    "dropmaladd": "12001 CALLANDS RD",
    "dropmalcty": "CALLANDS",
    "dropmalst": "VA",
    "dropmalzpp": 245309998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347244708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26245",
    "droptype": "D",
    "dropname": "CALLAO",
    "dropdeladd": "72 NORTHUMBERLAND HWY",
    "dropdelcty": "CALLAO",
    "dropdelst": "VA",
    "dropdelzpp": 224359998,
    "dropphyadd": "72 NORTHUMBERLAND HWY",
    "dropphycty": "CALLAO",
    "dropphyst": "VA",
    "dropphyzpp": 224359998,
    "dropmaladd": "72 NORTHUMBERLAND HWY",
    "dropmalcty": "CALLAO",
    "dropmalst": "VA",
    "dropmalzpp": 224359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045296811,
    "dropsitcph": 8045296811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26246",
    "droptype": "D",
    "dropname": "CALLAWAY",
    "dropdeladd": "7855 CALLAWAY RD",
    "dropdelcty": "CALLAWAY",
    "dropdelst": "VA",
    "dropdelzpp": 240679998,
    "dropphyadd": "7855 CALLAWAY RD",
    "dropphycty": "CALLAWAY",
    "dropphyst": "VA",
    "dropphyzpp": 240679998,
    "dropmaladd": "7855 CALLAWAY RD",
    "dropmalcty": "CALLAWAY",
    "dropmalst": "VA",
    "dropmalzpp": 240679998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5404839689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26247",
    "droptype": "D",
    "dropname": "CALVERTON",
    "dropdeladd": "4115 CATLETT RD",
    "dropdelcty": "CALVERTON",
    "dropdelst": "VA",
    "dropdelzpp": 201389997,
    "dropphyadd": "4115 CATLETT RD",
    "dropphycty": "CALVERTON",
    "dropphyst": "VA",
    "dropphyzpp": 201389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALVERTON",
    "dropmalst": "VA",
    "dropmalzpp": 201389998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5407884900,
    "dropsitcph": 5407884900,
    "dropfax": 5407884900
  },
  {
    "dcode": "D",
    "dropkey": "PX26253",
    "droptype": "D",
    "dropname": "CANA",
    "dropdeladd": "14207 FANCY GAP HWY",
    "dropdelcty": "CANA",
    "dropdelst": "VA",
    "dropdelzpp": 243173660,
    "dropphyadd": "14207 FANCY GAP HWY",
    "dropphycty": "CANA",
    "dropphyst": "VA",
    "dropphyzpp": 243173660,
    "dropmaladd": "14207 FANCY GAP HWY",
    "dropmalcty": "CANA",
    "dropmalst": "VA",
    "dropmalzpp": 243173660,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767554221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26254",
    "droptype": "D",
    "dropname": "CAPE CHARLES",
    "dropdeladd": "299 RANDOLPH AVE",
    "dropdelcty": "CAPE CHARLES",
    "dropdelst": "VA",
    "dropdelzpp": 233109998,
    "dropphyadd": "299 RANDOLPH AVE",
    "dropphycty": "CAPE CHARLES",
    "dropphyst": "VA",
    "dropphyzpp": 233109998,
    "dropmaladd": "299 RANDOLPH AVE",
    "dropmalcty": "CAPE CHARLES",
    "dropmalst": "VA",
    "dropmalzpp": 233109998,
    "dropsitphn": 7573314927,
    "dropsitlph": 7573314927,
    "dropsitcph": 7573314927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26258",
    "droptype": "D",
    "dropname": "CAPEVILLE",
    "dropdeladd": "4511 CAPEVILLE RD",
    "dropdelcty": "CAPEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233139998,
    "dropphyadd": "4511 CAPEVILLE RD",
    "dropphycty": "CAPEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233139998,
    "dropmaladd": "4511 CAPEVILLE RD",
    "dropmalcty": "CAPEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233139998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573312842,
    "dropsitcph": 7573312842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26263",
    "droptype": "D",
    "dropname": "CAPRON",
    "dropdeladd": "23021 MAIN ST",
    "dropdelcty": "CAPRON",
    "dropdelst": "VA",
    "dropdelzpp": 238299998,
    "dropphyadd": "23021 MAIN ST",
    "dropphycty": "CAPRON",
    "dropphyst": "VA",
    "dropphyzpp": 238299998,
    "dropmaladd": "23021 MAIN ST",
    "dropmalcty": "CAPRON",
    "dropmalst": "VA",
    "dropmalzpp": 238299998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346584101,
    "dropsitcph": 4346584101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26265",
    "droptype": "D",
    "dropname": "CARET",
    "dropdeladd": "13854 TIDEWATER TRL",
    "dropdelcty": "CARET",
    "dropdelst": "VA",
    "dropdelzpp": 224369998,
    "dropphyadd": "13854 TIDEWATER TRL",
    "dropphycty": "CARET",
    "dropphyst": "VA",
    "dropphyzpp": 224369998,
    "dropmaladd": "13854 TIDEWATER TRL",
    "dropmalcty": "CARET",
    "dropmalst": "VA",
    "dropmalzpp": 224369998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044432356,
    "dropsitcph": 8044432356,
    "dropfax": 8044432356
  },
  {
    "dcode": "D",
    "dropkey": "PX26267",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "15108 CARROLLTON BLVD",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "VA",
    "dropdelzpp": 233149998,
    "dropphyadd": "15108 CARROLLTON BLVD",
    "dropphycty": "CARROLLTON",
    "dropphyst": "VA",
    "dropphyzpp": 233149998,
    "dropmaladd": "15108 CARROLLTON BLVD",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "VA",
    "dropmalzpp": 233149998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572389124,
    "dropsitcph": 7572383158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26269",
    "droptype": "D",
    "dropname": "CARRSVILLE",
    "dropdeladd": "5354 CARRSVILLE HWY",
    "dropdelcty": "CARRSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233159998,
    "dropphyadd": "5354 CARRSVILLE HWY",
    "dropphycty": "CARRSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233159998,
    "dropmaladd": "5354 CARRSVILLE HWY",
    "dropmalcty": "CARRSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233159998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575623315,
    "dropsitcph": 7575623315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26272",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "17206 HALLIGAN PARK RD",
    "dropdelcty": "CARSON",
    "dropdelst": "VA",
    "dropdelzpp": 238309998,
    "dropphyadd": "17206 HALLIGAN PARK RD",
    "dropphycty": "CARSON",
    "dropphyst": "VA",
    "dropphyzpp": 238309998,
    "dropmaladd": "17206 HALLIGAN PARK RD",
    "dropmalcty": "CARSON",
    "dropmalst": "VA",
    "dropmalzpp": 238309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342468411,
    "dropsitcph": 4342468411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26273",
    "droptype": "D",
    "dropname": "CARTERSVILLE",
    "dropdeladd": "28 HIGH ST",
    "dropdelcty": "CARTERSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230279998,
    "dropphyadd": "28 HIGH ST",
    "dropphycty": "CARTERSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230279998,
    "dropmaladd": "28 HIGH ST",
    "dropmalcty": "CARTERSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043753419,
    "dropsitcph": 8043753419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26277",
    "droptype": "D",
    "dropname": "CASANOVA",
    "dropdeladd": "5137 WESTON RD",
    "dropdelcty": "CASANOVA",
    "dropdelst": "VA",
    "dropdelzpp": 201399997,
    "dropphyadd": "5137 WESTON RD",
    "dropphycty": "CASANOVA",
    "dropphyst": "VA",
    "dropphyzpp": 201399997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASANOVA",
    "dropmalst": "VA",
    "dropmalzpp": 201399998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5407889042,
    "dropsitcph": 5407889042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26278",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "5860 CASCADE RD",
    "dropdelcty": "CASCADE",
    "dropdelst": "VA",
    "dropdelzpp": 240699998,
    "dropphyadd": "5860 CASCADE RD",
    "dropphycty": "CASCADE",
    "dropphyst": "VA",
    "dropphyzpp": 240699998,
    "dropmaladd": "5860 CASCADE RD",
    "dropmalcty": "CASCADE",
    "dropmalst": "VA",
    "dropmalzpp": 240699998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4346853709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26281",
    "droptype": "D",
    "dropname": "CASTLEWOOD",
    "dropdeladd": "19366 US HIGHWAY 58",
    "dropdelcty": "CASTLEWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 242249998,
    "dropphyadd": "19366 US HIGHWAY 58",
    "dropphycty": "CASTLEWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 242249998,
    "dropmaladd": "19366 US HIGHWAY 58",
    "dropmalcty": "CASTLEWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 242249998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767623255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26283",
    "droptype": "D",
    "dropname": "CATAWBA",
    "dropdeladd": "4917 CATAWBA CREEK RD",
    "dropdelcty": "CATAWBA",
    "dropdelst": "VA",
    "dropdelzpp": 240709998,
    "dropphyadd": "4917 CATAWBA CREEK RD",
    "dropphycty": "CATAWBA",
    "dropphyst": "VA",
    "dropphyzpp": 240709998,
    "dropmaladd": "4917 CATAWBA CREEK RD",
    "dropmalcty": "CATAWBA",
    "dropmalst": "VA",
    "dropmalzpp": 240709998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403846011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26285",
    "droptype": "D",
    "dropname": "CATHARPIN",
    "dropdeladd": "4625 SUDLEY RD",
    "dropdelcty": "CATHARPIN",
    "dropdelst": "VA",
    "dropdelzpp": 201439998,
    "dropphyadd": "4625 SUDLEY RD",
    "dropphycty": "CATHARPIN",
    "dropphyst": "VA",
    "dropphyzpp": 201439998,
    "dropmaladd": "4625 SUDLEY RD",
    "dropmalcty": "CATHARPIN",
    "dropmalst": "VA",
    "dropmalzpp": 201439998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037548944,
    "dropsitcph": 7037548944,
    "dropfax": 7037537913
  },
  {
    "dcode": "D",
    "dropkey": "PX26286",
    "droptype": "D",
    "dropname": "CATLETT",
    "dropdeladd": "3584 CATLETT RD",
    "dropdelcty": "CATLETT",
    "dropdelst": "VA",
    "dropdelzpp": 201199997,
    "dropphyadd": "3584 CATLETT RD",
    "dropphycty": "CATLETT",
    "dropphyst": "VA",
    "dropphyzpp": 201199997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CATLETT",
    "dropmalst": "VA",
    "dropmalzpp": 201199998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5407884217,
    "dropsitcph": 5407884217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26292",
    "droptype": "D",
    "dropname": "CEDAR BLUFF",
    "dropdeladd": "1126 CEDAR VALLEY DR",
    "dropdelcty": "CEDAR BLUFF",
    "dropdelst": "VA",
    "dropdelzpp": 246099998,
    "dropphyadd": "1126 CEDAR VALLEY DR",
    "dropphycty": "CEDAR BLUFF",
    "dropphyst": "VA",
    "dropphyzpp": 246099998,
    "dropmaladd": "1126 CEDAR VALLEY DR",
    "dropmalcty": "CEDAR BLUFF",
    "dropmalst": "VA",
    "dropmalzpp": 246099998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769644216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26293",
    "droptype": "D",
    "dropname": "CENTER CROSS",
    "dropdeladd": "31837 TIDEWATER TRL",
    "dropdelcty": "CENTER CROSS",
    "dropdelst": "VA",
    "dropdelzpp": 224379998,
    "dropphyadd": "31837 TIDEWATER TRL",
    "dropphycty": "CENTER CROSS",
    "dropphyst": "VA",
    "dropphyzpp": 224379998,
    "dropmaladd": "31837 TIDEWATER TRL",
    "dropmalcty": "CENTER CROSS",
    "dropmalst": "VA",
    "dropmalzpp": 224379998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044432558,
    "dropsitcph": 8044432558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26298",
    "droptype": "D",
    "dropname": "CENTREVILLE",
    "dropdeladd": "14120A ROUTE 29",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201209998,
    "dropphyadd": "14120A ROUTE 29",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201209998,
    "dropmaladd": "14120A ROUTE 29",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201209998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038307690,
    "dropsitcph": 7038302714,
    "dropfax": 7038306919
  },
  {
    "dcode": "D",
    "dropkey": "PX26301",
    "droptype": "D",
    "dropname": "CERES",
    "dropdeladd": "5592 W BLUE GRASS TRL",
    "dropdelcty": "CERES",
    "dropdelst": "VA",
    "dropdelzpp": 243189998,
    "dropphyadd": "5592 W BLUE GRASS TRL",
    "dropphycty": "CERES",
    "dropphyst": "VA",
    "dropphyzpp": 243189998,
    "dropmaladd": "5592 W BLUE GRASS TRL",
    "dropmalcty": "CERES",
    "dropmalst": "VA",
    "dropmalzpp": 243189998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766821022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26303",
    "droptype": "D",
    "dropname": "CHAMPLAIN",
    "dropdeladd": "11246 TIDEWATER TRL",
    "dropdelcty": "CHAMPLAIN",
    "dropdelst": "VA",
    "dropdelzpp": 224389998,
    "dropphyadd": "11246 TIDEWATER TRL",
    "dropphycty": "CHAMPLAIN",
    "dropphyst": "VA",
    "dropphyzpp": 224389998,
    "dropmaladd": "11246 TIDEWATER TRL",
    "dropmalcty": "CHAMPLAIN",
    "dropmalst": "VA",
    "dropmalzpp": 224389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044431150,
    "dropsitcph": 8044431150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26306",
    "droptype": "D",
    "dropname": "CHARLES CITY",
    "dropdeladd": "10800 COURTHOUSE RD",
    "dropdelcty": "CHARLES CITY",
    "dropdelst": "VA",
    "dropdelzpp": 230309998,
    "dropphyadd": "10800 COURTHOUSE RD",
    "dropphycty": "CHARLES CITY",
    "dropphyst": "VA",
    "dropphyzpp": 230309998,
    "dropmaladd": "10800 COURTHOUSE RD",
    "dropmalcty": "CHARLES CITY",
    "dropmalst": "VA",
    "dropmalzpp": 230309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048292432,
    "dropsitcph": 8048292432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26312",
    "droptype": "D",
    "dropname": "CHARLOTTE COURT HOUSE",
    "dropdeladd": "140 DAVID BRUCE AVE",
    "dropdelcty": "CHARLOTTE COURT HOUSE",
    "dropdelst": "VA",
    "dropdelzpp": 239239998,
    "dropphyadd": "140 DAVID BRUCE AVE",
    "dropphycty": "CHARLOTTE COURT HOUSE",
    "dropphyst": "VA",
    "dropphyzpp": 239239998,
    "dropmaladd": "140 DAVID BRUCE AVE",
    "dropmalcty": "CHARLOTTE COURT HOUSE",
    "dropmalst": "VA",
    "dropmalzpp": 239239998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345425101,
    "dropsitcph": 4345425101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26314",
    "droptype": "D",
    "dropname": "CHARLOTTESVILLE",
    "dropdeladd": "1155 SEMINOLE TRL",
    "dropdelcty": "CHARLOTTESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229069998,
    "dropphyadd": "1155 SEMINOLE TRL",
    "dropphycty": "CHARLOTTESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229069998,
    "dropmaladd": "1155 SEMINOLE TRL",
    "dropmalcty": "CHARLOTTESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229069998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349787606,
    "dropsitcph": 4349787606,
    "dropfax": 8049787697
  },
  {
    "dcode": "D",
    "dropkey": "PX26318",
    "droptype": "D",
    "dropname": "CHASE CITY",
    "dropdeladd": "960 N MAIN ST",
    "dropdelcty": "CHASE CITY",
    "dropdelst": "VA",
    "dropdelzpp": 239249998,
    "dropphyadd": "960 N MAIN ST",
    "dropphycty": "CHASE CITY",
    "dropphyst": "VA",
    "dropphyzpp": 239249998,
    "dropmaladd": "960 N MAIN ST",
    "dropmalcty": "CHASE CITY",
    "dropmalst": "VA",
    "dropmalzpp": 239249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343721687,
    "dropsitcph": 4343721687,
    "dropfax": 4343720094
  },
  {
    "dcode": "D",
    "dropkey": "PX26321",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "31 S MAIN ST",
    "dropdelcty": "CHATHAM",
    "dropdelst": "VA",
    "dropdelzpp": 245319998,
    "dropphyadd": "31 S MAIN ST",
    "dropphycty": "CHATHAM",
    "dropphyst": "VA",
    "dropphyzpp": 245319998,
    "dropmaladd": "31 S MAIN ST",
    "dropmalcty": "CHATHAM",
    "dropmalst": "VA",
    "dropmalzpp": 245319998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344324321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26322",
    "droptype": "D",
    "dropname": "CHECK",
    "dropdeladd": "168 MEADOW RUN RD SE",
    "dropdelcty": "CHECK",
    "dropdelst": "VA",
    "dropdelzpp": 240729998,
    "dropphyadd": "168 MEADOW RUN RD SE",
    "dropphycty": "CHECK",
    "dropphyst": "VA",
    "dropphyzpp": 240729998,
    "dropmaladd": "168 MEADOW RUN RD SE",
    "dropmalcty": "CHECK",
    "dropmalst": "VA",
    "dropmalzpp": 240729998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406514523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26323",
    "droptype": "D",
    "dropname": "CHERITON",
    "dropdeladd": "21197 N BAYSIDE RD",
    "dropdelcty": "CHERITON",
    "dropdelst": "VA",
    "dropdelzpp": 233169998,
    "dropphyadd": "21197 N BAYSIDE RD",
    "dropphycty": "CHERITON",
    "dropphyst": "VA",
    "dropphyzpp": 233169998,
    "dropmaladd": "21197 N BAYSIDE RD",
    "dropmalcty": "CHERITON",
    "dropmalst": "VA",
    "dropmalzpp": 233169998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573311138,
    "dropsitcph": 7573311138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26324",
    "droptype": "D",
    "dropname": "CHESAPEAKE",
    "dropdeladd": "1425 BATTLEFIELD BLVD N",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233209998,
    "dropphyadd": "1425 BATTLEFIELD BLVD N",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233209998,
    "dropmaladd": "1425 BATTLEFIELD BLVD N",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233209998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574362054,
    "dropsitcph": 7574362054,
    "dropfax": 7575484654
  },
  {
    "dcode": "D",
    "dropkey": "PX26325",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "12300 ROCK HILL RD",
    "dropdelcty": "CHESTER",
    "dropdelst": "VA",
    "dropdelzpp": 238319998,
    "dropphyadd": "12300 ROCK HILL RD",
    "dropphycty": "CHESTER",
    "dropphyst": "VA",
    "dropphyzpp": 238319998,
    "dropmaladd": "12300 ROCK HILL RD",
    "dropmalcty": "CHESTER",
    "dropmalst": "VA",
    "dropmalzpp": 238319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047066734,
    "dropsitcph": 8047066734,
    "dropfax": 8047487203
  },
  {
    "dcode": "D",
    "dropkey": "PX26327",
    "droptype": "D",
    "dropname": "CHESTERFIELD",
    "dropdeladd": "10221 KRAUSE RD",
    "dropdelcty": "CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 238329998,
    "dropphyadd": "10221 KRAUSE RD",
    "dropphycty": "CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 238329998,
    "dropmaladd": "10221 KRAUSE RD",
    "dropmalcty": "CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 238329998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047069281,
    "dropsitcph": 8047069281,
    "dropfax": 8047488702
  },
  {
    "dcode": "D",
    "dropkey": "PX26329",
    "droptype": "D",
    "dropname": "CHILHOWIE",
    "dropdeladd": "195 OLD STAGE RD",
    "dropdelcty": "CHILHOWIE",
    "dropdelst": "VA",
    "dropdelzpp": 243199998,
    "dropphyadd": "195 OLD STAGE RD",
    "dropphycty": "CHILHOWIE",
    "dropphyst": "VA",
    "dropphyzpp": 243199998,
    "dropmaladd": "195 OLD STAGE RD",
    "dropmalcty": "CHILHOWIE",
    "dropmalst": "VA",
    "dropmalzpp": 243199998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766468877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26330",
    "droptype": "D",
    "dropname": "CHINCOTEAGUE ISLAND",
    "dropdeladd": "4144 MAIN ST",
    "dropdelcty": "CHINCOTEAGUE ISLAND",
    "dropdelst": "VA",
    "dropdelzpp": 233369998,
    "dropphyadd": "4144 MAIN ST",
    "dropphycty": "CHINCOTEAGUE ISLAND",
    "dropphyst": "VA",
    "dropphyzpp": 233369998,
    "dropmaladd": "4144 MAIN ST",
    "dropmalcty": "CHINCOTEAGUE ISLAND",
    "dropmalst": "VA",
    "dropmalzpp": 233369998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573362934,
    "dropsitcph": 7573362934,
    "dropfax": 7573362934
  },
  {
    "dcode": "D",
    "dropkey": "PX26335",
    "droptype": "D",
    "dropname": "CHRISTIANSBURG",
    "dropdeladd": "350 ARBOR DR",
    "dropdelcty": "CHRISTIANSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 240739998,
    "dropphyadd": "350 ARBOR DR",
    "dropphycty": "CHRISTIANSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 240739998,
    "dropmaladd": "350 ARBOR DR",
    "dropmalcty": "CHRISTIANSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 240739998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403828584,
    "dropfax": 5403826876
  },
  {
    "dcode": "D",
    "dropkey": "PX26343",
    "droptype": "D",
    "dropname": "CHURCH ROAD",
    "dropdeladd": "15300 COX RD",
    "dropdelcty": "CHURCH ROAD",
    "dropdelst": "VA",
    "dropdelzpp": 238339998,
    "dropphyadd": "15300 COX RD",
    "dropphycty": "CHURCH ROAD",
    "dropphyst": "VA",
    "dropphyzpp": 238339998,
    "dropmaladd": "15300 COX RD",
    "dropmalcty": "CHURCH ROAD",
    "dropmalst": "VA",
    "dropmalzpp": 238339998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042655637,
    "dropsitcph": 8042655637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26344",
    "droptype": "D",
    "dropname": "CHURCH VIEW",
    "dropdeladd": "51 WARES BRIDGE RD",
    "dropdelcty": "CHURCH VIEW",
    "dropdelst": "VA",
    "dropdelzpp": 230329998,
    "dropphyadd": "51 WARES BRIDGE RD",
    "dropphycty": "CHURCH VIEW",
    "dropphyst": "VA",
    "dropphyzpp": 230329998,
    "dropmaladd": "51 WARES BRIDGE RD",
    "dropmalcty": "CHURCH VIEW",
    "dropmalst": "VA",
    "dropmalzpp": 230329998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047580575,
    "dropsitcph": 8047580575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26348",
    "droptype": "D",
    "dropname": "CHURCHVILLE",
    "dropdeladd": "3696 CHURCHVILLE AVE",
    "dropdelcty": "CHURCHVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 244219998,
    "dropphyadd": "3696 CHURCHVILLE AVE",
    "dropphycty": "CHURCHVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 244219998,
    "dropmaladd": "3696 CHURCHVILLE AVE",
    "dropmalcty": "CHURCHVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 244219998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403483592,
    "dropsitcph": 5403483592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26355",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "3962 SPRING GROVE AVE",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "VA",
    "dropdelzpp": 238999998,
    "dropphyadd": "3962 SPRING GROVE AVE",
    "dropphycty": "CLAREMONT",
    "dropphyst": "VA",
    "dropphyzpp": 238999998,
    "dropmaladd": "3962 SPRING GROVE AVE",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "VA",
    "dropmalzpp": 238999998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7578668611,
    "dropsitcph": 7578668611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26356",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "104 4TH ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239279998,
    "dropphyadd": "104 4TH ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239279998,
    "dropmaladd": "104 4TH ST",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343744782,
    "dropsitcph": 4343744782,
    "dropfax": 4343744782
  },
  {
    "dcode": "D",
    "dropkey": "PX26359",
    "droptype": "D",
    "dropname": "CLAUDVILLE",
    "dropdeladd": "4551 CLAUDVILLE HWY",
    "dropdelcty": "CLAUDVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 240769998,
    "dropphyadd": "4551 CLAUDVILLE HWY",
    "dropphycty": "CLAUDVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 240769998,
    "dropmaladd": "4551 CLAUDVILLE HWY",
    "dropmalcty": "CLAUDVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 240769998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2762515822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26360",
    "droptype": "D",
    "dropname": "CLEAR BROOK",
    "dropdeladd": "1164 BRUCETOWN RD",
    "dropdelcty": "CLEAR BROOK",
    "dropdelst": "VA",
    "dropdelzpp": 226249998,
    "dropphyadd": "1164 BRUCETOWN RD",
    "dropphycty": "CLEAR BROOK",
    "dropphyst": "VA",
    "dropphyzpp": 226249998,
    "dropmaladd": "1164 BRUCETOWN RD",
    "dropmalcty": "CLEAR BROOK",
    "dropmalst": "VA",
    "dropmalzpp": 226249998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406671374,
    "dropsitcph": 5406671374,
    "dropfax": 5406784872
  },
  {
    "dcode": "D",
    "dropkey": "PX26362",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "6550 CLEVELAND RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "VA",
    "dropdelzpp": 242259998,
    "dropphyadd": "6550 CLEVELAND RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "VA",
    "dropphyzpp": 242259998,
    "dropmaladd": "6550 CLEVELAND RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "VA",
    "dropmalzpp": 242259998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768891799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26363",
    "droptype": "D",
    "dropname": "CLIFFORD",
    "dropdeladd": "120 TURKEY MOUNTAIN RD",
    "dropdelcty": "CLIFFORD",
    "dropdelst": "VA",
    "dropdelzpp": 245339998,
    "dropphyadd": "120 TURKEY MOUNTAIN RD",
    "dropphycty": "CLIFFORD",
    "dropphyst": "VA",
    "dropphyzpp": 245339998,
    "dropmaladd": "120 TURKEY MOUNTAIN RD",
    "dropmalcty": "CLIFFORD",
    "dropmalst": "VA",
    "dropmalzpp": 245339998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4349465602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26365",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "12644 CHAPEL RD",
    "dropdelcty": "CLIFTON",
    "dropdelst": "VA",
    "dropdelzpp": 201249998,
    "dropphyadd": "12644 CHAPEL RD",
    "dropphycty": "CLIFTON",
    "dropphyst": "VA",
    "dropphyzpp": 201249998,
    "dropmaladd": "12644 CHAPEL RD",
    "dropmalcty": "CLIFTON",
    "dropmalst": "VA",
    "dropmalzpp": 201249998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038157384,
    "dropsitcph": 7038157384,
    "dropfax": 7038302379
  },
  {
    "dcode": "D",
    "dropkey": "PX26366",
    "droptype": "D",
    "dropname": "CLIFTON FORGE",
    "dropdeladd": "324 COMMERCIAL AVE",
    "dropdelcty": "CLIFTON FORGE",
    "dropdelst": "VA",
    "dropdelzpp": 244229998,
    "dropphyadd": "324 COMMERCIAL AVE",
    "dropphycty": "CLIFTON FORGE",
    "dropphyst": "VA",
    "dropphyzpp": 244229998,
    "dropmaladd": "324 COMMERCIAL AVE",
    "dropmalcty": "CLIFTON FORGE",
    "dropmalst": "VA",
    "dropmalzpp": 244229998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408620980,
    "dropsitcph": 5408620980,
    "dropfax": 5408620980
  },
  {
    "dcode": "D",
    "dropkey": "PX26369",
    "droptype": "D",
    "dropname": "CLINCHCO",
    "dropdeladd": "16556 DICKENSON HWY",
    "dropdelcty": "CLINCHCO",
    "dropdelst": "VA",
    "dropdelzpp": 242269998,
    "dropphyadd": "16556 DICKENSON HWY",
    "dropphycty": "CLINCHCO",
    "dropphyst": "VA",
    "dropphyzpp": 242269998,
    "dropmaladd": "16556 DICKENSON HWY",
    "dropmalcty": "CLINCHCO",
    "dropmalst": "VA",
    "dropmalzpp": 242269998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768359315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26372",
    "droptype": "D",
    "dropname": "CLINTWOOD",
    "dropdeladd": "454 CHASE ST STE 100",
    "dropdelcty": "CLINTWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 242289998,
    "dropphyadd": "454 CHASE ST STE 100",
    "dropphycty": "CLINTWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 242289998,
    "dropmaladd": "454 CHASE ST STE 100",
    "dropmalcty": "CLINTWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 242289998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769266736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26373",
    "droptype": "D",
    "dropname": "CLOVER",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "CLOVER",
    "dropdelst": "VA",
    "dropdelzpp": 245349998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "CLOVER",
    "dropphyst": "VA",
    "dropphyzpp": 245349998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "CLOVER",
    "dropmalst": "VA",
    "dropmalzpp": 245349998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344546948,
    "dropfax": 4344546948
  },
  {
    "dcode": "D",
    "dropkey": "PX26374",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "4518 READ MOUNTAIN RD",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "VA",
    "dropdelzpp": 240779998,
    "dropphyadd": "4518 READ MOUNTAIN RD",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "VA",
    "dropphyzpp": 240779998,
    "dropmaladd": "4518 READ MOUNTAIN RD",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "VA",
    "dropmalzpp": 240779998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409922334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26376",
    "droptype": "D",
    "dropname": "CLUSTER SPRINGS",
    "dropdeladd": "6225 HUELL MATTHEWS HWY",
    "dropdelcty": "CLUSTER SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 245359998,
    "dropphyadd": "6225 HUELL MATTHEWS HWY",
    "dropphycty": "CLUSTER SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 245359998,
    "dropmaladd": "6225 HUELL MATTHEWS HWY",
    "dropmalcty": "CLUSTER SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 245359998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345728855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26379",
    "droptype": "D",
    "dropname": "COBBS CREEK",
    "dropdeladd": "2963 BUCKLEY HALL RD",
    "dropdelcty": "COBBS CREEK",
    "dropdelst": "VA",
    "dropdelzpp": 230359998,
    "dropphyadd": "2963 BUCKLEY HALL RD",
    "dropphycty": "COBBS CREEK",
    "dropphyst": "VA",
    "dropphyzpp": 230359998,
    "dropmaladd": "2963 BUCKLEY HALL RD",
    "dropmalcty": "COBBS CREEK",
    "dropmalst": "VA",
    "dropmalzpp": 230359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047253589,
    "dropsitcph": 8047253589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26382",
    "droptype": "D",
    "dropname": "COEBURN",
    "dropdeladd": "115 HIGH AVE NE",
    "dropdelcty": "COEBURN",
    "dropdelst": "VA",
    "dropdelzpp": 242309998,
    "dropphyadd": "115 HIGH AVE NE",
    "dropphycty": "COEBURN",
    "dropphyst": "VA",
    "dropphyzpp": 242309998,
    "dropmaladd": "115 HIGH AVE NE",
    "dropmalcty": "COEBURN",
    "dropmalst": "VA",
    "dropmalzpp": 242309998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763953121,
    "dropfax": 2763953121
  },
  {
    "dcode": "D",
    "dropkey": "PX26386",
    "droptype": "D",
    "dropname": "COLEMAN FALLS",
    "dropdeladd": "6285 LEE JACKSON HWY",
    "dropdelcty": "COLEMAN FALLS",
    "dropdelst": "VA",
    "dropdelzpp": 245369998,
    "dropphyadd": "6285 LEE JACKSON HWY",
    "dropphycty": "COLEMAN FALLS",
    "dropphyst": "VA",
    "dropphyzpp": 245369998,
    "dropmaladd": "6285 LEE JACKSON HWY",
    "dropmalcty": "COLEMAN FALLS",
    "dropmalst": "VA",
    "dropmalzpp": 245369998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342995379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26387",
    "droptype": "D",
    "dropname": "COLES POINT",
    "dropdeladd": "256 LONG POINT RD",
    "dropdelcty": "HAGUE",
    "dropdelst": "VA",
    "dropdelzpp": 224699996,
    "dropphyadd": "256 LONG POINT RD",
    "dropphycty": "HAGUE",
    "dropphyst": "VA",
    "dropphyzpp": 224699996,
    "dropmaladd": "256 LONG POINT RD",
    "dropmalcty": "HAGUE",
    "dropmalst": "VA",
    "dropmalzpp": 224699996,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044723214,
    "dropsitcph": 8044723214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26392",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "3365 VIRGINIA AVE",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 240789998,
    "dropphyadd": "3365 VIRGINIA AVE",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 240789998,
    "dropmaladd": "3365 VIRGINIA AVE",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 240789998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766478651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26396",
    "droptype": "D",
    "dropname": "COLONIAL BEACH",
    "dropdeladd": "1000 DWIGHT AVE",
    "dropdelcty": "COLONIAL BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 224439998,
    "dropphyadd": "1000 DWIGHT AVE",
    "dropphycty": "COLONIAL BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 224439998,
    "dropmaladd": "1000 DWIGHT AVE",
    "dropmalcty": "COLONIAL BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 224439998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042149636,
    "dropsitcph": 8042149636,
    "dropfax": 8042149636
  },
  {
    "dcode": "D",
    "dropkey": "PX26398",
    "droptype": "D",
    "dropname": "COLONIAL HEIGHTS",
    "dropdeladd": "1205 BOULEVARD",
    "dropdelcty": "COLONIAL HEIGHTS",
    "dropdelst": "VA",
    "dropdelzpp": 238349998,
    "dropphyadd": "1205 BOULEVARD",
    "dropphycty": "COLONIAL HEIGHTS",
    "dropphyst": "VA",
    "dropphyzpp": 238349998,
    "dropmaladd": "1205 BOULEVARD",
    "dropmalcty": "COLONIAL HEIGHTS",
    "dropmalst": "VA",
    "dropmalzpp": 238349998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045249237,
    "dropsitcph": 8045261166,
    "dropfax": 8045261539
  },
  {
    "dcode": "D",
    "dropkey": "PX26401",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "17 CAMERON ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "VA",
    "dropdelzpp": 230383032,
    "dropphyadd": "17 CAMERON ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "VA",
    "dropphyzpp": 230383032,
    "dropmaladd": "17 CAMERON ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "VA",
    "dropmalzpp": 230389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048423746,
    "dropsitcph": 4348423746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26407",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "10275 VILLAGE HWY",
    "dropdelcty": "CONCORD",
    "dropdelst": "VA",
    "dropdelzpp": 245389998,
    "dropphyadd": "10275 VILLAGE HWY",
    "dropphycty": "CONCORD",
    "dropphyst": "VA",
    "dropphyzpp": 245389998,
    "dropmaladd": "10275 VILLAGE HWY",
    "dropmalcty": "CONCORD",
    "dropmalst": "VA",
    "dropmalzpp": 245389998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4349933287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26410",
    "droptype": "D",
    "dropname": "COPPER HILL",
    "dropdeladd": "8480 FLOYD HWY N",
    "dropdelcty": "COPPER HILL",
    "dropdelst": "VA",
    "dropdelzpp": 240799998,
    "dropphyadd": "8480 FLOYD HWY N",
    "dropphycty": "COPPER HILL",
    "dropphyst": "VA",
    "dropphyzpp": 240799998,
    "dropmaladd": "8480 FLOYD HWY N",
    "dropmalcty": "COPPER HILL",
    "dropmalst": "VA",
    "dropmalzpp": 240799998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409294731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26411",
    "droptype": "D",
    "dropname": "CORBIN",
    "dropdeladd": "4519 FREDERICKSBURG TPKE",
    "dropdelcty": "CORBIN",
    "dropdelst": "VA",
    "dropdelzpp": 224469998,
    "dropphyadd": "4519 FREDERICKSBURG TPKE",
    "dropphycty": "CORBIN",
    "dropphyst": "VA",
    "dropphyzpp": 224469998,
    "dropmaladd": "4519 FREDERICKSBURG TPKE",
    "dropmalcty": "CORBIN",
    "dropmalst": "VA",
    "dropmalzpp": 224469998,
    "dropsitphn": 5403731513,
    "dropsitlph": 5403731513,
    "dropsitcph": 5403731513,
    "dropfax": 5403731513
  },
  {
    "dcode": "D",
    "dropkey": "PX26416",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "22183 MAIN ST",
    "dropdelcty": "COURTLAND",
    "dropdelst": "VA",
    "dropdelzpp": 238379998,
    "dropphyadd": "22183 MAIN ST",
    "dropphycty": "COURTLAND",
    "dropphyst": "VA",
    "dropphyzpp": 238379998,
    "dropmaladd": "22183 MAIN ST",
    "dropmalcty": "COURTLAND",
    "dropmalst": "VA",
    "dropmalzpp": 238379998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7576539813,
    "dropsitcph": 7576539813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26418",
    "droptype": "D",
    "dropname": "COVESVILLE",
    "dropdeladd": "5912 COVESVILLE STORE RD",
    "dropdelcty": "COVESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229319998,
    "dropphyadd": "5912 COVESVILLE STORE RD",
    "dropphycty": "COVESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229319998,
    "dropmaladd": "5912 COVESVILLE STORE RD",
    "dropmalcty": "COVESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342969055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26422",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "211 W MAIN ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 244269998,
    "dropphyadd": "211 W MAIN ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 244269998,
    "dropmaladd": "211 W MAIN ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 244269998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409622510,
    "dropsitcph": 5409622510,
    "dropfax": 5409622272
  },
  {
    "dcode": "D",
    "dropkey": "PX26424",
    "droptype": "D",
    "dropname": "CRADDOCKVILLE",
    "dropdeladd": "34032 CRADDOCKVILLE RD",
    "dropdelcty": "CRADDOCKVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233419998,
    "dropphyadd": "34032 CRADDOCKVILLE RD",
    "dropphycty": "CRADDOCKVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233419998,
    "dropmaladd": "34032 CRADDOCKVILLE RD",
    "dropmalcty": "CRADDOCKVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233419998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574424730,
    "dropsitcph": 7574424730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26428",
    "droptype": "D",
    "dropname": "CRAIGSVILLE",
    "dropdeladd": "105 W CRAIG ST",
    "dropdelcty": "CRAIGSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 244309998,
    "dropphyadd": "105 W CRAIG ST",
    "dropphycty": "CRAIGSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 244309998,
    "dropmaladd": "105 W CRAIG ST",
    "dropmalcty": "CRAIGSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 244309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409975770,
    "dropsitcph": 5409975770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26432",
    "droptype": "D",
    "dropname": "CREWE",
    "dropdeladd": "101 W TENNESSEE AVE",
    "dropdelcty": "CREWE",
    "dropdelst": "VA",
    "dropdelzpp": 239309998,
    "dropphyadd": "101 W TENNESSEE AVE",
    "dropphycty": "CREWE",
    "dropphyst": "VA",
    "dropphyzpp": 239309998,
    "dropmaladd": "101 W TENNESSEE AVE",
    "dropmalcty": "CREWE",
    "dropmalst": "VA",
    "dropmalzpp": 239309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346453627,
    "dropsitcph": 4346453627,
    "dropfax": 4346453627
  },
  {
    "dcode": "D",
    "dropkey": "PX26434",
    "droptype": "D",
    "dropname": "CRIDERS",
    "dropdeladd": "20856 CRIDERS RD",
    "dropdelcty": "CRIDERS",
    "dropdelst": "VA",
    "dropdelzpp": 228209998,
    "dropphyadd": "20856 CRIDERS RD",
    "dropphycty": "CRIDERS",
    "dropphyst": "VA",
    "dropphyzpp": 228209998,
    "dropmaladd": "20856 CRIDERS RD",
    "dropmalcty": "CRIDERS",
    "dropmalst": "VA",
    "dropmalzpp": 228209998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408523305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26436",
    "droptype": "D",
    "dropname": "CRIMORA",
    "dropdeladd": "1805 E SIDE HWY STE 101",
    "dropdelcty": "CRIMORA",
    "dropdelst": "VA",
    "dropdelzpp": 244319998,
    "dropphyadd": "1805 E SIDE HWY STE 101",
    "dropphycty": "CRIMORA",
    "dropphyst": "VA",
    "dropphyzpp": 244319998,
    "dropmaladd": "1805 E SIDE HWY STE 101",
    "dropmalcty": "CRIMORA",
    "dropmalst": "VA",
    "dropmalzpp": 244319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409464637,
    "dropsitcph": 5409464637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26440",
    "droptype": "D",
    "dropname": "CRITZ",
    "dropdeladd": "2658 ABRAM PENN HWY",
    "dropdelcty": "CRITZ",
    "dropdelst": "VA",
    "dropdelzpp": 240829998,
    "dropphyadd": "2658 ABRAM PENN HWY",
    "dropphycty": "CRITZ",
    "dropphyst": "VA",
    "dropphyzpp": 240829998,
    "dropmaladd": "2658 ABRAM PENN HWY",
    "dropmalcty": "CRITZ",
    "dropmalst": "VA",
    "dropmalzpp": 240829998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766944577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26441",
    "droptype": "D",
    "dropname": "CROCKETT",
    "dropdeladd": "1163 CROCKETT RD",
    "dropdelcty": "CROCKETT",
    "dropdelst": "VA",
    "dropdelzpp": 243239998,
    "dropphyadd": "1163 CROCKETT RD",
    "dropphycty": "CROCKETT",
    "dropphyst": "VA",
    "dropphyzpp": 243239998,
    "dropmaladd": "1163 CROCKETT RD",
    "dropmalcty": "CROCKETT",
    "dropmalst": "VA",
    "dropmalzpp": 243239998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766864511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26443",
    "droptype": "D",
    "dropname": "CROSS JUNCTION",
    "dropdeladd": "6654 N FREDERICK PIKE",
    "dropdelcty": "CROSS JUNCTION",
    "dropdelst": "VA",
    "dropdelzpp": 226252368,
    "dropphyadd": "6654 N FREDERICK PIKE",
    "dropphycty": "CROSS JUNCTION",
    "dropphyst": "VA",
    "dropphyzpp": 226252368,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS JUNCTION",
    "dropmalst": "VA",
    "dropmalzpp": 226259998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408883281,
    "dropsitcph": 5408883281,
    "dropfax": 5408889827
  },
  {
    "dcode": "D",
    "dropkey": "PX26445",
    "droptype": "D",
    "dropname": "CROZET",
    "dropdeladd": "1210 CROZET AVE",
    "dropdelcty": "CROZET",
    "dropdelst": "VA",
    "dropdelzpp": 229329998,
    "dropphyadd": "1210 CROZET AVE",
    "dropphycty": "CROZET",
    "dropphyst": "VA",
    "dropphyzpp": 229329998,
    "dropmaladd": "1210 CROZET AVE",
    "dropmalcty": "CROZET",
    "dropmalst": "VA",
    "dropmalzpp": 229329998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4348239847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26446",
    "droptype": "D",
    "dropname": "CROZIER",
    "dropdeladd": "1531 RIVER RD W",
    "dropdelcty": "CROZIER",
    "dropdelst": "VA",
    "dropdelzpp": 230399998,
    "dropphyadd": "1531 RIVER RD W",
    "dropphycty": "CROZIER",
    "dropphyst": "VA",
    "dropphyzpp": 230399998,
    "dropmaladd": "1531 RIVER RD W",
    "dropmalcty": "CROZIER",
    "dropmalst": "VA",
    "dropmalzpp": 230399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047843773,
    "dropsitcph": 8047843773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26449",
    "droptype": "D",
    "dropname": "CRYSTAL HILL",
    "dropdeladd": "6200 HOWARD P ANDERSON RD",
    "dropdelcty": "CRYSTAL HILL",
    "dropdelst": "VA",
    "dropdelzpp": 245399998,
    "dropphyadd": "6200 HOWARD P ANDERSON RD",
    "dropphycty": "CRYSTAL HILL",
    "dropphyst": "VA",
    "dropphyzpp": 245399998,
    "dropmaladd": "6200 HOWARD P ANDERSON RD",
    "dropmalcty": "CRYSTAL HILL",
    "dropmalst": "VA",
    "dropmalzpp": 245399998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344766638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26450",
    "droptype": "D",
    "dropname": "CULLEN",
    "dropdeladd": "4304 THOMAS JEFFERSON HWY",
    "dropdelcty": "CULLEN",
    "dropdelst": "VA",
    "dropdelzpp": 239349998,
    "dropphyadd": "4304 THOMAS JEFFERSON HWY",
    "dropphycty": "CULLEN",
    "dropphyst": "VA",
    "dropphyzpp": 239349998,
    "dropmaladd": "4304 THOMAS JEFFERSON HWY",
    "dropmalcty": "CULLEN",
    "dropmalst": "VA",
    "dropmalzpp": 239349998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345425226,
    "dropsitcph": 4345425226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26452",
    "droptype": "D",
    "dropname": "CULPEPER",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "CULPEPER",
    "dropdelst": "VA",
    "dropdelzpp": 227019998,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "CULPEPER",
    "dropphyst": "VA",
    "dropphyzpp": 227019998,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "CULPEPER",
    "dropmalst": "VA",
    "dropmalzpp": 227019998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408298435,
    "dropsitcph": 5408298435,
    "dropfax": 5408294052
  },
  {
    "dcode": "D",
    "dropkey": "PX26453",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "1489 ANDERSON HWY",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "VA",
    "dropdelzpp": 230409998,
    "dropphyadd": "1489 ANDERSON HWY",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "VA",
    "dropphyzpp": 230409998,
    "dropmaladd": "1489 ANDERSON HWY",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "VA",
    "dropmalzpp": 230409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044924108,
    "dropsitcph": 8044924108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26458",
    "droptype": "D",
    "dropname": "DAHLGREN",
    "dropdeladd": "17285 DAHLGREN RD",
    "dropdelcty": "DAHLGREN",
    "dropdelst": "VA",
    "dropdelzpp": 224489998,
    "dropphyadd": "17285 DAHLGREN RD",
    "dropphycty": "DAHLGREN",
    "dropphyst": "VA",
    "dropphyzpp": 224489998,
    "dropmaladd": "17285 DAHLGREN RD",
    "dropmalcty": "DAHLGREN",
    "dropmalst": "VA",
    "dropmalzpp": 224489998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5406633230,
    "dropsitcph": 5406633230,
    "dropfax": 5406633230
  },
  {
    "dcode": "D",
    "dropkey": "PX26460",
    "droptype": "D",
    "dropname": "DALEVILLE",
    "dropdeladd": "1492 ROANOKE RD",
    "dropdelcty": "DALEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 240839998,
    "dropphyadd": "1492 ROANOKE RD",
    "dropphycty": "DALEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 240839998,
    "dropmaladd": "1492 ROANOKE RD",
    "dropmalcty": "DALEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 240839998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409924422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26464",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "211 N REYNOLDS ST",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "VA",
    "dropdelzpp": 242369998,
    "dropphyadd": "211 N REYNOLDS ST",
    "dropphycty": "DAMASCUS",
    "dropphyst": "VA",
    "dropphyzpp": 242369998,
    "dropmaladd": "211 N REYNOLDS ST",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "VA",
    "dropmalzpp": 242369998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764757091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26465",
    "droptype": "D",
    "dropname": "DANTE",
    "dropdeladd": "506 BUNCHTOWN RD",
    "dropdelcty": "DANTE",
    "dropdelst": "VA",
    "dropdelzpp": 242379998,
    "dropphyadd": "506 BUNCHTOWN RD",
    "dropphycty": "DANTE",
    "dropphyst": "VA",
    "dropphyzpp": 242379998,
    "dropmaladd": "506 BUNCHTOWN RD",
    "dropmalcty": "DANTE",
    "dropmalst": "VA",
    "dropmalzpp": 242379998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764958070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26466",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "105 TEAL CT",
    "dropdelcty": "DANVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 245419998,
    "dropphyadd": "105 TEAL CT",
    "dropphycty": "DANVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 245419998,
    "dropmaladd": "105 TEAL CT",
    "dropmalcty": "DANVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 245419998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347913137,
    "dropfax": 4347913194
  },
  {
    "dcode": "D",
    "dropkey": "PX26470",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "4038 HELEN HENDERSON HWY",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "VA",
    "dropdelzpp": 242399998,
    "dropphyadd": "4038 HELEN HENDERSON HWY",
    "dropphycty": "DAVENPORT",
    "dropphyst": "VA",
    "dropphyzpp": 242399998,
    "dropmaladd": "4038 HELEN HENDERSON HWY",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "VA",
    "dropmalzpp": 242399998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768599961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26473",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "242 MAIN ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "VA",
    "dropdelzpp": 228219998,
    "dropphyadd": "242 MAIN ST",
    "dropphycty": "DAYTON",
    "dropphyst": "VA",
    "dropphyzpp": 228219998,
    "dropmaladd": "242 MAIN ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "VA",
    "dropmalzpp": 228219998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408792724,
    "dropfax": 5408792198
  },
  {
    "dcode": "D",
    "dropkey": "PX26477",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "3079 DEERFIELD VALLEY RD",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 244329998,
    "dropphyadd": "3079 DEERFIELD VALLEY RD",
    "dropphycty": "DEERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 244329998,
    "dropmaladd": "3079 DEERFIELD VALLEY RD",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 244329998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409394302,
    "dropsitcph": 5409394302,
    "dropfax": 5409394302
  },
  {
    "dcode": "D",
    "dropkey": "PX26481",
    "droptype": "D",
    "dropname": "DELAPLANE",
    "dropdeladd": "3046 DELAPLANE GRADE RD",
    "dropdelcty": "DELAPLANE",
    "dropdelst": "VA",
    "dropdelzpp": 201449998,
    "dropphyadd": "3046 DELAPLANE GRADE RD",
    "dropphycty": "DELAPLANE",
    "dropphyst": "VA",
    "dropphyzpp": 201449998,
    "dropmaladd": "3046 DELAPLANE GRADE RD",
    "dropmalcty": "DELAPLANE",
    "dropmalst": "VA",
    "dropmalzpp": 201449998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403640365,
    "dropsitcph": 5403640365,
    "dropfax": 5403641562
  },
  {
    "dcode": "D",
    "dropkey": "PX26482",
    "droptype": "D",
    "dropname": "DELTAVILLE",
    "dropdeladd": "17283 GENERAL PULLER HWY",
    "dropdelcty": "DELTAVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230432206,
    "dropphyadd": "17283 GENERAL PULLER HWY",
    "dropphycty": "DELTAVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230432206,
    "dropmaladd": "17283 GENERAL PULLER HWY",
    "dropmalcty": "DELTAVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230439998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047769750,
    "dropsitcph": 8047769750,
    "dropfax": 7767769750
  },
  {
    "dcode": "D",
    "dropkey": "PX26486",
    "droptype": "D",
    "dropname": "DENDRON",
    "dropdeladd": "2850 ROLFE HWY",
    "dropdelcty": "DENDRON",
    "dropdelst": "VA",
    "dropdelzpp": 238399998,
    "dropphyadd": "2850 ROLFE HWY",
    "dropphycty": "DENDRON",
    "dropphyst": "VA",
    "dropphyzpp": 238399998,
    "dropmaladd": "2850 ROLFE HWY",
    "dropmalcty": "DENDRON",
    "dropmalst": "VA",
    "dropmalzpp": 238399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7572672316,
    "dropsitcph": 7572672316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26489",
    "droptype": "D",
    "dropname": "DEWITT",
    "dropdeladd": "16907 BOYDTON PLANK RD",
    "dropdelcty": "DEWITT",
    "dropdelst": "VA",
    "dropdelzpp": 238409998,
    "dropphyadd": "16907 BOYDTON PLANK RD",
    "dropphycty": "DEWITT",
    "dropphyst": "VA",
    "dropphyzpp": 238409998,
    "dropmaladd": "16907 BOYDTON PLANK RD",
    "dropmalcty": "DEWITT",
    "dropmalst": "VA",
    "dropmalzpp": 238409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044693909,
    "dropsitcph": 8044693909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26493",
    "droptype": "D",
    "dropname": "DILLWYN",
    "dropdeladd": "16625 OAK ST",
    "dropdelcty": "DILLWYN",
    "dropdelst": "VA",
    "dropdelzpp": 239369998,
    "dropphyadd": "16625 OAK ST",
    "dropphycty": "DILLWYN",
    "dropphyst": "VA",
    "dropphyzpp": 239369998,
    "dropmaladd": "16625 OAK ST",
    "dropmalcty": "DILLWYN",
    "dropmalst": "VA",
    "dropmalzpp": 239369998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349838905,
    "dropsitcph": 4349838905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26494",
    "droptype": "D",
    "dropname": "DINWIDDIE",
    "dropdeladd": "14416 COURTHOUSE RD",
    "dropdelcty": "DINWIDDIE",
    "dropdelst": "VA",
    "dropdelzpp": 238419998,
    "dropphyadd": "14416 COURTHOUSE RD",
    "dropphycty": "DINWIDDIE",
    "dropphyst": "VA",
    "dropphyzpp": 238419998,
    "dropmaladd": "14416 COURTHOUSE RD",
    "dropmalcty": "DINWIDDIE",
    "dropmalst": "VA",
    "dropmalzpp": 238419998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044694617,
    "dropsitcph": 4343521082,
    "dropfax": 4343521030
  },
  {
    "dcode": "D",
    "dropkey": "PX26495",
    "droptype": "D",
    "dropname": "DISPUTANTA",
    "dropdeladd": "10001 COUNTY DR",
    "dropdelcty": "DISPUTANTA",
    "dropdelst": "VA",
    "dropdelzpp": 238429998,
    "dropphyadd": "10001 COUNTY DR",
    "dropphycty": "DISPUTANTA",
    "dropphyst": "VA",
    "dropphyzpp": 238429998,
    "dropmaladd": "10001 COUNTY DR",
    "dropmalcty": "DISPUTANTA",
    "dropmalst": "VA",
    "dropmalzpp": 238429998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049913268,
    "dropsitcph": 8049913268,
    "dropfax": 8049913268
  },
  {
    "dcode": "D",
    "dropkey": "PX26497",
    "droptype": "D",
    "dropname": "DOE HILL",
    "dropdeladd": "7583 DOE HILL RD",
    "dropdelcty": "DOE HILL",
    "dropdelst": "VA",
    "dropdelzpp": 244339998,
    "dropphyadd": "7583 DOE HILL RD",
    "dropphycty": "DOE HILL",
    "dropphyst": "VA",
    "dropphyzpp": 244339998,
    "dropmaladd": "7583 DOE HILL RD",
    "dropmalcty": "DOE HILL",
    "dropmalst": "VA",
    "dropmalzpp": 244339998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403966130,
    "dropsitcph": 5403966130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26498",
    "droptype": "D",
    "dropname": "DOGUE",
    "dropdeladd": "13218 CLEVE DR",
    "dropdelcty": "DOGUE",
    "dropdelst": "VA",
    "dropdelzpp": 224519998,
    "dropphyadd": "13218 CLEVE DR",
    "dropphycty": "DOGUE",
    "dropphyst": "VA",
    "dropphyzpp": 224519998,
    "dropmaladd": "13218 CLEVE DR",
    "dropmalcty": "DOGUE",
    "dropmalst": "VA",
    "dropmalzpp": 224519998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407750799,
    "dropsitcph": 5407750799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26499",
    "droptype": "D",
    "dropname": "DOLPHIN",
    "dropdeladd": "7593 LIBERTY RD",
    "dropdelcty": "DOLPHIN",
    "dropdelst": "VA",
    "dropdelzpp": 238439998,
    "dropphyadd": "7593 LIBERTY RD",
    "dropphycty": "DOLPHIN",
    "dropphyst": "VA",
    "dropphyzpp": 238439998,
    "dropmaladd": "7593 LIBERTY RD",
    "dropmalcty": "DOLPHIN",
    "dropmalst": "VA",
    "dropmalzpp": 238439998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4348484689,
    "dropsitcph": 4348484689,
    "dropfax": 4348484689
  },
  {
    "dcode": "D",
    "dropkey": "PX26500",
    "droptype": "D",
    "dropname": "DORAN",
    "dropdeladd": "5947 GOVERNOR G C PERRY HWY STE 1",
    "dropdelcty": "DORAN",
    "dropdelst": "VA",
    "dropdelzpp": 246129998,
    "dropphyadd": "5947 GOVERNOR G C PERRY HWY STE 1",
    "dropphycty": "DORAN",
    "dropphyst": "VA",
    "dropphyzpp": 246129998,
    "dropmaladd": "5947 GOVERNOR G C PERRY HWY STE 1",
    "dropmalcty": "DORAN",
    "dropmalst": "VA",
    "dropmalzpp": 246129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769639420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26501",
    "droptype": "D",
    "dropname": "DOSWELL",
    "dropdeladd": "16410 WASHINGTON HWY",
    "dropdelcty": "DOSWELL",
    "dropdelst": "VA",
    "dropdelzpp": 230479998,
    "dropphyadd": "16410 WASHINGTON HWY",
    "dropphycty": "DOSWELL",
    "dropphyst": "VA",
    "dropphyzpp": 230479998,
    "dropmaladd": "16410 WASHINGTON HWY",
    "dropmalcty": "DOSWELL",
    "dropmalst": "VA",
    "dropmalzpp": 230479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048763613,
    "dropsitcph": 8048763613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26508",
    "droptype": "D",
    "dropname": "DRAKES BRANCH",
    "dropdeladd": "4871 DRAKES MAIN ST",
    "dropdelcty": "DRAKES BRANCH",
    "dropdelst": "VA",
    "dropdelzpp": 239379998,
    "dropphyadd": "4871 DRAKES MAIN ST",
    "dropphycty": "DRAKES BRANCH",
    "dropphyst": "VA",
    "dropphyzpp": 239379998,
    "dropmaladd": "4871 DRAKES MAIN ST",
    "dropmalcty": "DRAKES BRANCH",
    "dropmalst": "VA",
    "dropmalzpp": 239379998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345684221,
    "dropsitcph": 4345684221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26509",
    "droptype": "D",
    "dropname": "DRAPER",
    "dropdeladd": "4390 ACADEMY ST",
    "dropdelcty": "DRAPER",
    "dropdelst": "VA",
    "dropdelzpp": 243249998,
    "dropphyadd": "4390 ACADEMY ST",
    "dropphycty": "DRAPER",
    "dropphyst": "VA",
    "dropphyzpp": 243249998,
    "dropmaladd": "4390 ACADEMY ST",
    "dropmalcty": "DRAPER",
    "dropmalst": "VA",
    "dropmalzpp": 243249998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409804580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26510",
    "droptype": "D",
    "dropname": "DREWRYVILLE",
    "dropdeladd": "22365 DREWRY RD",
    "dropdelcty": "DREWRYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 238449998,
    "dropphyadd": "22365 DREWRY RD",
    "dropphycty": "DREWRYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 238449998,
    "dropmaladd": "22365 DREWRY RD",
    "dropmalcty": "DREWRYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 238449998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346584331,
    "dropsitcph": 4346584331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26516",
    "droptype": "D",
    "dropname": "DRY FORK",
    "dropdeladd": "656 DRY FORK RD",
    "dropdelcty": "DRY FORK",
    "dropdelst": "VA",
    "dropdelzpp": 245499998,
    "dropphyadd": "656 DRY FORK RD",
    "dropphycty": "DRY FORK",
    "dropphyst": "VA",
    "dropphyzpp": 245499998,
    "dropmaladd": "656 DRY FORK RD",
    "dropmalcty": "DRY FORK",
    "dropmalst": "VA",
    "dropmalzpp": 245499998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344329130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26517",
    "droptype": "D",
    "dropname": "DRYDEN",
    "dropdeladd": "48354 VETERANS MEMORIAL HWY",
    "dropdelcty": "DRYDEN",
    "dropdelst": "VA",
    "dropdelzpp": 242439998,
    "dropphyadd": "48354 VETERANS MEMORIAL HWY",
    "dropphycty": "DRYDEN",
    "dropphyst": "VA",
    "dropphyzpp": 242439998,
    "dropmaladd": "48354 VETERANS MEMORIAL HWY",
    "dropmalcty": "DRYDEN",
    "dropmalst": "VA",
    "dropmalzpp": 242439998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2765464343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26518",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "1 TOWN CENTER DR",
    "dropdelcty": "DUBLIN",
    "dropdelst": "VA",
    "dropdelzpp": 240849998,
    "dropphyadd": "1 TOWN CENTER DR",
    "dropphycty": "DUBLIN",
    "dropphyst": "VA",
    "dropphyzpp": 240849998,
    "dropmaladd": "1 TOWN CENTER DR",
    "dropmalcty": "DUBLIN",
    "dropmalst": "VA",
    "dropmalzpp": 240849998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406745301,
    "dropfax": 5406741296
  },
  {
    "dcode": "D",
    "dropkey": "PX26519",
    "droptype": "D",
    "dropname": "DUFFIELD",
    "dropdeladd": "466 DUFF PATT HWY",
    "dropdelcty": "DUFFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 242449998,
    "dropphyadd": "466 DUFF PATT HWY",
    "dropphycty": "DUFFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 242449998,
    "dropmaladd": "466 DUFF PATT HWY",
    "dropmalcty": "DUFFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 242449998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764312697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26520",
    "droptype": "D",
    "dropname": "DUGSPUR",
    "dropdeladd": "60 DOUBLE CABIN RD",
    "dropdelcty": "DUGSPUR",
    "dropdelst": "VA",
    "dropdelzpp": 243259998,
    "dropphyadd": "60 DOUBLE CABIN RD",
    "dropphycty": "DUGSPUR",
    "dropphyst": "VA",
    "dropphyzpp": 243259998,
    "dropmaladd": "60 DOUBLE CABIN RD",
    "dropmalcty": "DUGSPUR",
    "dropmalst": "VA",
    "dropmalzpp": 243259998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767287061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26521",
    "droptype": "D",
    "dropname": "DULLES",
    "dropdeladd": "44715 PRENTICE DR",
    "dropdelcty": "DULLES",
    "dropdelst": "VA",
    "dropdelzpp": 201019998,
    "dropphyadd": "44715 PRENTICE DR",
    "dropphycty": "DULLES",
    "dropphyst": "VA",
    "dropphyzpp": 201019903,
    "dropmaladd": "44715 PRENTICE DR",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201019998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034066314,
    "dropsitcph": 7034066602,
    "dropfax": 7034066604
  },
  {
    "dcode": "D",
    "dropkey": "PX26524",
    "droptype": "D",
    "dropname": "DULLES AIR MAIL FACILITY",
    "dropdeladd": "44721 PROPELLER CT",
    "dropdelcty": "DULLES",
    "dropdelst": "VA",
    "dropdelzpp": 201029998,
    "dropphyadd": "44721 PROPELLER CT",
    "dropphycty": "DULLES",
    "dropphyst": "VA",
    "dropphyzpp": 201029998,
    "dropmaladd": "44721 PROPELLER CT",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201029998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034066427,
    "dropsitcph": 7034066427,
    "dropfax": 7036616612
  },
  {
    "dcode": "D",
    "dropkey": "PX26526",
    "droptype": "D",
    "dropname": "DUMFRIES",
    "dropdeladd": "17949 MAIN ST",
    "dropdelcty": "DUMFRIES",
    "dropdelst": "VA",
    "dropdelzpp": 220269998,
    "dropphyadd": "17949 MAIN ST",
    "dropphycty": "DUMFRIES",
    "dropphyst": "VA",
    "dropphyzpp": 220269998,
    "dropmaladd": "17949 MAIN ST",
    "dropmalcty": "DUMFRIES",
    "dropmalst": "VA",
    "dropmalzpp": 220269998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7034418304,
    "dropsitcph": 7034418304,
    "dropfax": 7032214295
  },
  {
    "dcode": "D",
    "dropkey": "PX26527",
    "droptype": "D",
    "dropname": "DUNDAS",
    "dropdeladd": "4091 DUNDAS RD",
    "dropdelcty": "DUNDAS",
    "dropdelst": "VA",
    "dropdelzpp": 239389998,
    "dropphyadd": "4091 DUNDAS RD",
    "dropphycty": "DUNDAS",
    "dropphyst": "VA",
    "dropphyzpp": 239389998,
    "dropmaladd": "4091 DUNDAS RD",
    "dropmalcty": "DUNDAS",
    "dropmalst": "VA",
    "dropmalzpp": 239389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346762445,
    "dropsitcph": 4346762445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26528",
    "droptype": "D",
    "dropname": "DUNGANNON",
    "dropdeladd": "18948 VETERANS MEMORIAL HWY STE 102",
    "dropdelcty": "DUNGANNON",
    "dropdelst": "VA",
    "dropdelzpp": 242459998,
    "dropphyadd": "18948 VETERANS MEMORIAL HWY STE 102",
    "dropphycty": "DUNGANNON",
    "dropphyst": "VA",
    "dropphyzpp": 242459998,
    "dropmaladd": "18948 VETERANS MEMORIAL HWY STE 102",
    "dropmalcty": "DUNGANNON",
    "dropmalst": "VA",
    "dropmalzpp": 242459998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764672230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26531",
    "droptype": "D",
    "dropname": "DUNNSVILLE",
    "dropdeladd": "27081 TIDEWATER TRL",
    "dropdelcty": "DUNNSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 224549998,
    "dropphyadd": "27081 TIDEWATER TRL",
    "dropphycty": "DUNNSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 224549998,
    "dropmaladd": "27081 TIDEWATER TRL",
    "dropmalcty": "DUNNSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 224549998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044435764,
    "dropsitcph": 8044435764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26534",
    "droptype": "D",
    "dropname": "DUTTON",
    "dropdeladd": "9226 DUTTON RD",
    "dropdelcty": "DUTTON",
    "dropdelst": "VA",
    "dropdelzpp": 230509998,
    "dropphyadd": "9226 DUTTON RD",
    "dropphycty": "DUTTON",
    "dropphyst": "VA",
    "dropphyzpp": 230509998,
    "dropmaladd": "9226 DUTTON RD",
    "dropmalcty": "DUTTON",
    "dropmalst": "VA",
    "dropmalzpp": 230509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046934106,
    "dropsitcph": 8046934106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26536",
    "droptype": "D",
    "dropname": "DYKE",
    "dropdeladd": "8607 DYKE RD",
    "dropdelcty": "DYKE",
    "dropdelst": "VA",
    "dropdelzpp": 229359998,
    "dropphyadd": "8607 DYKE RD",
    "dropphycty": "DYKE",
    "dropphyst": "VA",
    "dropphyzpp": 229359998,
    "dropmaladd": "8607 DYKE RD",
    "dropmalcty": "DYKE",
    "dropmalst": "VA",
    "dropmalzpp": 229359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4349853168,
    "dropfax": 4349853168
  },
  {
    "dcode": "D",
    "dropkey": "PX26540",
    "droptype": "D",
    "dropname": "EAGLE ROCK",
    "dropdeladd": "14630 CHURCH ST",
    "dropdelcty": "EAGLE ROCK",
    "dropdelst": "VA",
    "dropdelzpp": 240859998,
    "dropphyadd": "14630 CHURCH ST",
    "dropphycty": "EAGLE ROCK",
    "dropphyst": "VA",
    "dropphyzpp": 240859998,
    "dropmaladd": "14630 CHURCH ST",
    "dropmalcty": "EAGLE ROCK",
    "dropmalst": "VA",
    "dropmalzpp": 240859998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5408842400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26541",
    "droptype": "D",
    "dropname": "EARLYSVILLE",
    "dropdeladd": "675 BENT OAKS DR",
    "dropdelcty": "EARLYSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229369998,
    "dropphyadd": "675 BENT OAKS DR",
    "dropphycty": "EARLYSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229369998,
    "dropmaladd": "675 BENT OAKS DR",
    "dropmalcty": "EARLYSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229369998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342682008,
    "dropfax": 8049752197
  },
  {
    "dcode": "D",
    "dropkey": "PX26547",
    "droptype": "D",
    "dropname": "EAST STONE GAP",
    "dropdeladd": "3911 E STONE GAP RD",
    "dropdelcty": "EAST STONE GAP",
    "dropdelst": "VA",
    "dropdelzpp": 242469998,
    "dropphyadd": "3911 E STONE GAP RD",
    "dropphycty": "EAST STONE GAP",
    "dropphyst": "VA",
    "dropphyzpp": 242469998,
    "dropmaladd": "3911 E STONE GAP RD",
    "dropmalcty": "EAST STONE GAP",
    "dropmalst": "VA",
    "dropmalzpp": 242469998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2765232502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26548",
    "droptype": "D",
    "dropname": "EASTVILLE",
    "dropdeladd": "5253 WILLOW OAK RD",
    "dropdelcty": "EASTVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233479998,
    "dropphyadd": "5253 WILLOW OAK RD",
    "dropphycty": "EASTVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233479998,
    "dropmaladd": "5253 WILLOW OAK RD",
    "dropmalcty": "EASTVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233479998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7576785088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26551",
    "droptype": "D",
    "dropname": "EBONY",
    "dropdeladd": "468 ROBINSON FERRY RD",
    "dropdelcty": "EBONY",
    "dropdelst": "VA",
    "dropdelzpp": 238459998,
    "dropphyadd": "468 ROBINSON FERRY RD",
    "dropphycty": "EBONY",
    "dropphyst": "VA",
    "dropphyzpp": 238459998,
    "dropmaladd": "468 ROBINSON FERRY RD",
    "dropmalcty": "EBONY",
    "dropmalst": "VA",
    "dropmalzpp": 238459998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346362641,
    "dropsitcph": 4346362641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26552",
    "droptype": "D",
    "dropname": "EDINBURG",
    "dropdeladd": "205 N MAIN ST",
    "dropdelcty": "EDINBURG",
    "dropdelst": "VA",
    "dropdelzpp": 228249998,
    "dropphyadd": "205 N MAIN ST",
    "dropphycty": "EDINBURG",
    "dropphyst": "VA",
    "dropphyzpp": 228249998,
    "dropmaladd": "205 N MAIN ST",
    "dropmalcty": "EDINBURG",
    "dropmalst": "VA",
    "dropmalzpp": 228249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5409864377,
    "dropfax": 5402157481
  },
  {
    "dcode": "D",
    "dropkey": "PX26556",
    "droptype": "D",
    "dropname": "EGGLESTON",
    "dropdeladd": "3618 CHURCH HILL RD",
    "dropdelcty": "EGGLESTON",
    "dropdelst": "VA",
    "dropdelzpp": 240869998,
    "dropphyadd": "3618 CHURCH HILL RD",
    "dropphycty": "EGGLESTON",
    "dropphyst": "VA",
    "dropphyzpp": 240869998,
    "dropmaladd": "3618 CHURCH HILL RD",
    "dropmalcty": "EGGLESTON",
    "dropmalst": "VA",
    "dropmalzpp": 240869998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406267177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26560",
    "droptype": "D",
    "dropname": "ELK CREEK",
    "dropdeladd": "62 COMERS ROCK RD",
    "dropdelcty": "ELK CREEK",
    "dropdelst": "VA",
    "dropdelzpp": 243269998,
    "dropphyadd": "62 COMERS ROCK RD",
    "dropphycty": "ELK CREEK",
    "dropphyst": "VA",
    "dropphyzpp": 243269998,
    "dropmaladd": "62 COMERS ROCK RD",
    "dropmalcty": "ELK CREEK",
    "dropmalst": "VA",
    "dropmalzpp": 243269998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766554411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26562",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "102 W ROCKINGHAM ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "VA",
    "dropdelzpp": 228279998,
    "dropphyadd": "102 W ROCKINGHAM ST",
    "dropphycty": "ELKTON",
    "dropphyst": "VA",
    "dropphyzpp": 228279998,
    "dropmaladd": "102 W ROCKINGHAM ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "VA",
    "dropmalzpp": 228279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042987772,
    "dropsitcph": 5402987772,
    "dropfax": 5402987555
  },
  {
    "dcode": "D",
    "dropkey": "PX26563",
    "droptype": "D",
    "dropname": "ELKWOOD",
    "dropdeladd": "22098 JAMES MADISON HWY",
    "dropdelcty": "ELKWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 227181720,
    "dropphyadd": "22098 JAMES MADISON HWY",
    "dropphycty": "ELKWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 227181720,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 227189998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408251447,
    "dropsitcph": 5408251447,
    "dropfax": 5408253599
  },
  {
    "dcode": "D",
    "dropkey": "PX26564",
    "droptype": "D",
    "dropname": "ELLISTON",
    "dropdeladd": "9420 ROANOKE RD",
    "dropdelcty": "ELLISTON",
    "dropdelst": "VA",
    "dropdelzpp": 240879998,
    "dropphyadd": "9420 ROANOKE RD",
    "dropphycty": "ELLISTON",
    "dropphyst": "VA",
    "dropphyzpp": 240879998,
    "dropmaladd": "9420 ROANOKE RD",
    "dropmalcty": "ELLISTON",
    "dropmalst": "VA",
    "dropmalzpp": 240879998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402685767,
    "dropfax": 5402682186
  },
  {
    "dcode": "D",
    "dropkey": "PX26565",
    "droptype": "D",
    "dropname": "EMORY",
    "dropdeladd": "31045 OXFORD AVE",
    "dropdelcty": "EMORY",
    "dropdelst": "VA",
    "dropdelzpp": 243279998,
    "dropphyadd": "31045 OXFORD AVE",
    "dropphycty": "EMORY",
    "dropphyst": "VA",
    "dropphyzpp": 243279998,
    "dropmaladd": "31045 OXFORD AVE",
    "dropmalcty": "EMORY",
    "dropmalst": "VA",
    "dropmalzpp": 243279998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769443522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26566",
    "droptype": "D",
    "dropname": "EMPORIA",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "EMPORIA",
    "dropdelst": "VA",
    "dropdelzpp": 238479998,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "EMPORIA",
    "dropphyst": "VA",
    "dropphyzpp": 238479998,
    "dropmaladd": "109 S MAIN ST",
    "dropmalcty": "EMPORIA",
    "dropmalst": "VA",
    "dropmalzpp": 238479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346340895,
    "dropsitcph": 4346340895,
    "dropfax": 4343483469
  },
  {
    "dcode": "D",
    "dropkey": "PX26571",
    "droptype": "D",
    "dropname": "ESMONT",
    "dropdeladd": "7514 ESMONT RD",
    "dropdelcty": "ESMONT",
    "dropdelst": "VA",
    "dropdelzpp": 229379998,
    "dropphyadd": "7514 ESMONT RD",
    "dropphycty": "ESMONT",
    "dropphyst": "VA",
    "dropphyzpp": 229379998,
    "dropmaladd": "7514 ESMONT RD",
    "dropmalcty": "ESMONT",
    "dropmalst": "VA",
    "dropmalzpp": 229379998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342862715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26575",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "7077 OLD EVERGREEN RD",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "VA",
    "dropdelzpp": 239399900,
    "dropphyadd": "7077 OLD EVERGREEN RD",
    "dropphycty": "EVERGREEN",
    "dropphyst": "VA",
    "dropphyzpp": 239399900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "VA",
    "dropmalzpp": 239399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343527879,
    "dropsitcph": 4343527879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26576",
    "droptype": "D",
    "dropname": "EVINGTON",
    "dropdeladd": "11496 LEESVILLE RD",
    "dropdelcty": "EVINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 245509998,
    "dropphyadd": "11496 LEESVILLE RD",
    "dropphycty": "EVINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 245509998,
    "dropmaladd": "11496 LEESVILLE RD",
    "dropmalcty": "EVINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 245509998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4348211309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26577",
    "droptype": "D",
    "dropname": "EWING",
    "dropdeladd": "1579 DR THOMAS WALKER RD",
    "dropdelcty": "EWING",
    "dropdelst": "VA",
    "dropdelzpp": 242489998,
    "dropphyadd": "1579 DR THOMAS WALKER RD",
    "dropphycty": "EWING",
    "dropphyst": "VA",
    "dropphyzpp": 242489998,
    "dropmaladd": "1579 DR THOMAS WALKER RD",
    "dropmalcty": "EWING",
    "dropmalst": "VA",
    "dropmalzpp": 242489998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764451148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26579",
    "droptype": "D",
    "dropname": "EXMORE",
    "dropdeladd": "12144 BANK AVE",
    "dropdelcty": "EXMORE",
    "dropdelst": "VA",
    "dropdelzpp": 233509998,
    "dropphyadd": "12144 BANK AVE",
    "dropphycty": "EXMORE",
    "dropphyst": "VA",
    "dropphyzpp": 233509998,
    "dropmaladd": "12144 BANK AVE",
    "dropmalcty": "EXMORE",
    "dropmalst": "VA",
    "dropmalzpp": 233509998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574429211,
    "dropsitcph": 7574429211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26581",
    "droptype": "D",
    "dropname": "FABER",
    "dropdeladd": "68 POST OFFICE LN",
    "dropdelcty": "FABER",
    "dropdelst": "VA",
    "dropdelzpp": 229389998,
    "dropphyadd": "68 POST OFFICE LN",
    "dropphycty": "FABER",
    "dropphyst": "VA",
    "dropphyzpp": 229389998,
    "dropmaladd": "68 POST OFFICE LN",
    "dropmalcty": "FABER",
    "dropmalst": "VA",
    "dropmalzpp": 229389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342635383,
    "dropsitcph": 4342635383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26583",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "10660 PAGE AVE",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "VA",
    "dropdelzpp": 220309998,
    "dropphyadd": "10660 PAGE AVE",
    "dropphycty": "FAIRFAX",
    "dropphyst": "VA",
    "dropphyzpp": 220309998,
    "dropmaladd": "10660 PAGE AVE",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "VA",
    "dropmalzpp": 220309998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035910458,
    "dropsitcph": 7035910458,
    "dropfax": 7032738876
  },
  {
    "dcode": "D",
    "dropkey": "PX26586",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "5586 N LEE HWY",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 244359998,
    "dropphyadd": "5586 N LEE HWY",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 244359998,
    "dropmaladd": "5586 N LEE HWY",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 244359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403772616,
    "dropsitcph": 5403772616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26594",
    "droptype": "D",
    "dropname": "FALLS CHURCH",
    "dropdeladd": "800 W BROAD ST STE 100",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220409998,
    "dropphyadd": "800 W BROAD ST STE 100",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220409998,
    "dropmaladd": "800 W BROAD ST STE 100",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220409998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": 7035347818
  },
  {
    "dcode": "D",
    "dropkey": "PX26595",
    "droptype": "D",
    "dropname": "FALLS MILLS",
    "dropdeladd": "401 BRUSHFORK RD",
    "dropdelcty": "FALLS MILLS",
    "dropdelst": "VA",
    "dropdelzpp": 246139998,
    "dropphyadd": "401 BRUSHFORK RD",
    "dropphycty": "FALLS MILLS",
    "dropphyst": "VA",
    "dropphyzpp": 246139998,
    "dropmaladd": "401 BRUSHFORK RD",
    "dropmalcty": "FALLS MILLS",
    "dropmalst": "VA",
    "dropmalzpp": 246139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2763262167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26598",
    "droptype": "D",
    "dropname": "FANCY GAP",
    "dropdeladd": "7608 FANCY GAP HWY",
    "dropdelcty": "FANCY GAP",
    "dropdelst": "VA",
    "dropdelzpp": 243289998,
    "dropphyadd": "7608 FANCY GAP HWY",
    "dropphycty": "FANCY GAP",
    "dropphyst": "VA",
    "dropphyzpp": 243289998,
    "dropmaladd": "7608 FANCY GAP HWY",
    "dropmalcty": "FANCY GAP",
    "dropmalst": "VA",
    "dropmalzpp": 243289998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767287881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26600",
    "droptype": "D",
    "dropname": "FARMVILLE",
    "dropdeladd": "301 E 3RD ST",
    "dropdelcty": "FARMVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239019998,
    "dropphyadd": "301 E 3RD ST",
    "dropphycty": "FARMVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239019998,
    "dropmaladd": "301 E 3RD ST",
    "dropmalcty": "FARMVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343923354,
    "dropsitcph": 4343923354,
    "dropfax": 8043926813
  },
  {
    "dcode": "D",
    "dropkey": "PX26603",
    "droptype": "D",
    "dropname": "FARNHAM",
    "dropdeladd": "193 CEDAR GROVE RD",
    "dropdelcty": "FARNHAM",
    "dropdelst": "VA",
    "dropdelzpp": 224609998,
    "dropphyadd": "193 CEDAR GROVE RD",
    "dropphycty": "FARNHAM",
    "dropphyst": "VA",
    "dropphyzpp": 224609998,
    "dropmaladd": "193 CEDAR GROVE RD",
    "dropmalcty": "FARNHAM",
    "dropmalst": "VA",
    "dropmalzpp": 224609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043949570,
    "dropsitcph": 8043949570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26605",
    "droptype": "D",
    "dropname": "FERRUM",
    "dropdeladd": "57 FIELDCREST RD",
    "dropdelcty": "FERRUM",
    "dropdelst": "VA",
    "dropdelzpp": 240889998,
    "dropphyadd": "57 FIELDCREST RD",
    "dropphycty": "FERRUM",
    "dropphyst": "VA",
    "dropphyzpp": 240889998,
    "dropmaladd": "57 FIELDCREST RD",
    "dropmalcty": "FERRUM",
    "dropmalst": "VA",
    "dropmalzpp": 240889998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403657276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26606",
    "droptype": "D",
    "dropname": "FIELDALE",
    "dropdeladd": "20 MARSHALL WAY",
    "dropdelcty": "FIELDALE",
    "dropdelst": "VA",
    "dropdelzpp": 240899998,
    "dropphyadd": "20 MARSHALL WAY",
    "dropphycty": "FIELDALE",
    "dropphyst": "VA",
    "dropphyzpp": 240899998,
    "dropmaladd": "20 MARSHALL WAY",
    "dropmalcty": "FIELDALE",
    "dropmalst": "VA",
    "dropmalzpp": 240899998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766736638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26608",
    "droptype": "D",
    "dropname": "FINCASTLE",
    "dropdeladd": "223 S ROANOKE ST",
    "dropdelcty": "FINCASTLE",
    "dropdelst": "VA",
    "dropdelzpp": 240909998,
    "dropphyadd": "223 S ROANOKE ST",
    "dropphycty": "FINCASTLE",
    "dropphyst": "VA",
    "dropphyzpp": 240909998,
    "dropmaladd": "223 S ROANOKE ST",
    "dropmalcty": "FINCASTLE",
    "dropmalst": "VA",
    "dropmalzpp": 240909998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5404733061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26618",
    "droptype": "D",
    "dropname": "FISHERSVILLE",
    "dropdeladd": "1595 JEFFERSON HWY",
    "dropdelcty": "FISHERSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229392206,
    "dropphyadd": "1595 JEFFERSON HWY",
    "dropphycty": "FISHERSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229392206,
    "dropmaladd": "1595 JEFFERSON HWY",
    "dropmalcty": "FISHERSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5409427310,
    "dropfax": 5409496030
  },
  {
    "dcode": "D",
    "dropkey": "PX26624",
    "droptype": "D",
    "dropname": "FLINT HILL",
    "dropdeladd": "664F ZACHARY TAYLOR HWY",
    "dropdelcty": "FLINT HILL",
    "dropdelst": "VA",
    "dropdelzpp": 226279998,
    "dropphyadd": "664F ZACHARY TAYLOR HWY",
    "dropphycty": "FLINT HILL",
    "dropphyst": "VA",
    "dropphyzpp": 226279998,
    "dropmaladd": "664F ZACHARY TAYLOR HWY",
    "dropmalcty": "FLINT HILL",
    "dropmalst": "VA",
    "dropmalzpp": 226279998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5406753430,
    "dropsitcph": 5406753430,
    "dropfax": 5406753404
  },
  {
    "dcode": "D",
    "dropkey": "PX26626",
    "droptype": "D",
    "dropname": "FLOYD",
    "dropdeladd": "819 E MAIN ST",
    "dropdelcty": "FLOYD",
    "dropdelst": "VA",
    "dropdelzpp": 240919998,
    "dropphyadd": "819 E MAIN ST",
    "dropphycty": "FLOYD",
    "dropphyst": "VA",
    "dropphyzpp": 240919998,
    "dropmaladd": "819 E MAIN ST",
    "dropmalcty": "FLOYD",
    "dropmalst": "VA",
    "dropmalzpp": 240919998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407454456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26629",
    "droptype": "D",
    "dropname": "FORD",
    "dropdeladd": "9109 BALTIMORE RD",
    "dropdelcty": "FORD",
    "dropdelst": "VA",
    "dropdelzpp": 238509998,
    "dropphyadd": "9109 BALTIMORE RD",
    "dropphycty": "FORD",
    "dropphyst": "VA",
    "dropphyzpp": 238509998,
    "dropmaladd": "9109 BALTIMORE RD",
    "dropmalcty": "FORD",
    "dropmalst": "VA",
    "dropmalzpp": 238509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042655704,
    "dropsitcph": 8042655704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26630",
    "droptype": "D",
    "dropname": "FOREST",
    "dropdeladd": "14803 FOREST RD",
    "dropdelcty": "FOREST",
    "dropdelst": "VA",
    "dropdelzpp": 245519998,
    "dropphyadd": "14803 FOREST RD",
    "dropphycty": "FOREST",
    "dropphyst": "VA",
    "dropphyzpp": 245519998,
    "dropmaladd": "14803 FOREST RD",
    "dropmalcty": "FOREST",
    "dropmalst": "VA",
    "dropmalzpp": 245519998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345254235,
    "dropfax": 4345258676
  },
  {
    "dcode": "D",
    "dropkey": "PX26634",
    "droptype": "D",
    "dropname": "FORK UNION",
    "dropdeladd": "4885 JAMES MADISON HWY",
    "dropdelcty": "FORK UNION",
    "dropdelst": "VA",
    "dropdelzpp": 230559998,
    "dropphyadd": "4885 JAMES MADISON HWY",
    "dropphycty": "FORK UNION",
    "dropphyst": "VA",
    "dropphyzpp": 230559998,
    "dropmaladd": "4885 JAMES MADISON HWY",
    "dropmalcty": "FORK UNION",
    "dropmalst": "VA",
    "dropmalzpp": 230559998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048423501,
    "dropsitcph": 4348423501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26637",
    "droptype": "D",
    "dropname": "FORT BELVOIR",
    "dropdeladd": "5875 21ST ST",
    "dropdelcty": "FORT BELVOIR",
    "dropdelst": "VA",
    "dropdelzpp": 220609998,
    "dropphyadd": "5875 21ST ST",
    "dropphycty": "FORT BELVOIR",
    "dropphyst": "VA",
    "dropphyzpp": 220609998,
    "dropmaladd": "5875 21ST ST",
    "dropmalcty": "FORT BELVOIR",
    "dropmalst": "VA",
    "dropmalzpp": 220609998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037817735,
    "dropsitcph": 7037817735,
    "dropfax": 7037818435
  },
  {
    "dcode": "D",
    "dropkey": "PX26655",
    "droptype": "D",
    "dropname": "FORT VALLEY",
    "dropdeladd": "7151 FORT VALLEY RD",
    "dropdelcty": "FORT VALLEY",
    "dropdelst": "VA",
    "dropdelzpp": 226529998,
    "dropphyadd": "7151 FORT VALLEY RD",
    "dropphycty": "FORT VALLEY",
    "dropphyst": "VA",
    "dropphyzpp": 226529998,
    "dropmaladd": "7151 FORT VALLEY RD",
    "dropmalcty": "FORT VALLEY",
    "dropmalst": "VA",
    "dropmalzpp": 226529998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409336611,
    "dropsitcph": 5409336611,
    "dropfax": 5409336623
  },
  {
    "dcode": "D",
    "dropkey": "PX26656",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "15315 JOHN CLAYTON MEMORIAL HWY",
    "dropdelcty": "FOSTER",
    "dropdelst": "VA",
    "dropdelzpp": 230569998,
    "dropphyadd": "15315 JOHN CLAYTON MEMORIAL HWY",
    "dropphycty": "FOSTER",
    "dropphyst": "VA",
    "dropphyzpp": 230569998,
    "dropmaladd": "15315 JOHN CLAYTON MEMORIAL HWY",
    "dropmalcty": "FOSTER",
    "dropmalst": "VA",
    "dropmalzpp": 230569998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047257360,
    "dropsitcph": 8047257360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26659",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "519 N MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "VA",
    "dropdelzpp": 238519998,
    "dropphyadd": "519 N MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "VA",
    "dropphyzpp": 238519998,
    "dropmaladd": "519 N MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "VA",
    "dropmalzpp": 238519998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7575166647,
    "dropsitcph": 7575166647,
    "dropfax": 7575626992
  },
  {
    "dcode": "D",
    "dropkey": "PX26661",
    "droptype": "D",
    "dropname": "FRANKTOWN",
    "dropdeladd": "9135 FRANKTOWN RD",
    "dropdelcty": "FRANKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 233549998,
    "dropphyadd": "9135 FRANKTOWN RD",
    "dropphycty": "FRANKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 233549998,
    "dropmaladd": "9135 FRANKTOWN RD",
    "dropmalcty": "FRANKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 233549998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574427639,
    "dropsitcph": 7574427639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26669",
    "droptype": "D",
    "dropname": "FREDERICKSBURG",
    "dropdeladd": "600 PRINCESS ANNE ST",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 224019998,
    "dropphyadd": "600 PRINCESS ANNE ST",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 224019998,
    "dropmaladd": "600 PRINCESS ANNE ST",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 224019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403614235,
    "dropsitcph": 5403614235,
    "dropfax": 5403733422
  },
  {
    "dcode": "D",
    "dropkey": "PX26671",
    "droptype": "D",
    "dropname": "FREE UNION",
    "dropdeladd": "4270 FREE UNION RD",
    "dropdelcty": "FREE UNION",
    "dropdelst": "VA",
    "dropdelzpp": 229409998,
    "dropphyadd": "4270 FREE UNION RD",
    "dropphycty": "FREE UNION",
    "dropphyst": "VA",
    "dropphyzpp": 229409998,
    "dropmaladd": "4270 FREE UNION RD",
    "dropmalcty": "FREE UNION",
    "dropmalst": "VA",
    "dropmalzpp": 229409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4349736710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26672",
    "droptype": "D",
    "dropname": "FREEMAN",
    "dropdeladd": "18031 GOVERNOR HARRISON PKWY",
    "dropdelcty": "FREEMAN",
    "dropdelst": "VA",
    "dropdelzpp": 238569998,
    "dropphyadd": "18031 GOVERNOR HARRISON PKWY",
    "dropphycty": "FREEMAN",
    "dropphyst": "VA",
    "dropphyzpp": 238569998,
    "dropmaladd": "18031 GOVERNOR HARRISON PKWY",
    "dropmalcty": "FREEMAN",
    "dropmalst": "VA",
    "dropmalzpp": 238569998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4348482399,
    "dropsitcph": 4348482399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26676",
    "droptype": "D",
    "dropname": "FRIES",
    "dropdeladd": "491 W MAIN ST",
    "dropdelcty": "FRIES",
    "dropdelst": "VA",
    "dropdelzpp": 243309998,
    "dropphyadd": "491 W MAIN ST",
    "dropphycty": "FRIES",
    "dropphyst": "VA",
    "dropphyzpp": 243309998,
    "dropmaladd": "491 W MAIN ST",
    "dropmalcty": "FRIES",
    "dropmalst": "VA",
    "dropmalzpp": 243309998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767442511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26678",
    "droptype": "D",
    "dropname": "FRONT ROYAL",
    "dropdeladd": "120 E 3RD ST",
    "dropdelcty": "FRONT ROYAL",
    "dropdelst": "VA",
    "dropdelzpp": 226309998,
    "dropphyadd": "120 E 3RD ST",
    "dropphycty": "FRONT ROYAL",
    "dropphyst": "VA",
    "dropphyzpp": 226309998,
    "dropmaladd": "120 E 3RD ST",
    "dropmalcty": "FRONT ROYAL",
    "dropmalst": "VA",
    "dropmalzpp": 226309998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5406357983,
    "dropsitcph": 5406357983,
    "dropfax": 5406359731
  },
  {
    "dcode": "D",
    "dropkey": "PX26689",
    "droptype": "D",
    "dropname": "FULKS RUN",
    "dropdeladd": "12046 BROCKS GAP RD",
    "dropdelcty": "FULKS RUN",
    "dropdelst": "VA",
    "dropdelzpp": 228309998,
    "dropphyadd": "12046 BROCKS GAP RD",
    "dropphycty": "FULKS RUN",
    "dropphyst": "VA",
    "dropphyzpp": 228309998,
    "dropmaladd": "12046 BROCKS GAP RD",
    "dropmalcty": "FULKS RUN",
    "dropmalst": "VA",
    "dropmalzpp": 228309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408962788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26690",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "14689 LEE HWY",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201559998,
    "dropphyadd": "14689 LEE HWY",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201559998,
    "dropmaladd": "14689 LEE HWY",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201559998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037543443,
    "dropsitcph": 7037543443,
    "dropfax": 7037548378
  },
  {
    "dcode": "D",
    "dropkey": "PX26693",
    "droptype": "D",
    "dropname": "GALAX",
    "dropdeladd": "200 E GRAYSON ST",
    "dropdelcty": "GALAX",
    "dropdelst": "VA",
    "dropdelzpp": 243339998,
    "dropphyadd": "200 E GRAYSON ST",
    "dropphycty": "GALAX",
    "dropphyst": "VA",
    "dropphyzpp": 243339998,
    "dropmaladd": "200 E GRAYSON ST",
    "dropmalcty": "GALAX",
    "dropmalst": "VA",
    "dropmalzpp": 243339998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2762363891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26696",
    "droptype": "D",
    "dropname": "GARRISONVILLE",
    "dropdeladd": "524 GARRISONVILLE RD",
    "dropdelcty": "GARRISONVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 224639998,
    "dropphyadd": "524 GARRISONVILLE RD",
    "dropphycty": "GARRISONVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 224639998,
    "dropmaladd": "524 GARRISONVILLE RD",
    "dropmalcty": "GARRISONVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 224639998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5406592636,
    "dropsitcph": 5406592636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26699",
    "droptype": "D",
    "dropname": "GASBURG",
    "dropdeladd": "4205 GASBURG RD",
    "dropdelcty": "GASBURG",
    "dropdelst": "VA",
    "dropdelzpp": 238579998,
    "dropphyadd": "4205 GASBURG RD",
    "dropphycty": "GASBURG",
    "dropphyst": "VA",
    "dropphyzpp": 238579998,
    "dropmaladd": "4205 GASBURG RD",
    "dropmalcty": "GASBURG",
    "dropmalst": "VA",
    "dropmalzpp": 238579998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345772601,
    "dropsitcph": 4345772601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26700",
    "droptype": "D",
    "dropname": "GATE CITY",
    "dropdeladd": "380 JONES ST",
    "dropdelcty": "GATE CITY",
    "dropdelst": "VA",
    "dropdelzpp": 242519998,
    "dropphyadd": "380 JONES ST",
    "dropphycty": "GATE CITY",
    "dropphyst": "VA",
    "dropphyzpp": 242519998,
    "dropmaladd": "380 JONES ST",
    "dropmalcty": "GATE CITY",
    "dropmalst": "VA",
    "dropmalzpp": 242519998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763867911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26705",
    "droptype": "D",
    "dropname": "GLADE SPRING",
    "dropdeladd": "205 E GLADE ST",
    "dropdelcty": "GLADE SPRING",
    "dropdelst": "VA",
    "dropdelzpp": 243409998,
    "dropphyadd": "205 E GLADE ST",
    "dropphycty": "GLADE SPRING",
    "dropphyst": "VA",
    "dropphyzpp": 243409998,
    "dropmaladd": "205 E GLADE ST",
    "dropmalcty": "GLADE SPRING",
    "dropmalst": "VA",
    "dropmalzpp": 243409998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764295211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26706",
    "droptype": "D",
    "dropname": "GLADE HILL",
    "dropdeladd": "7300 OLD FRANKLIN TPKE",
    "dropdelcty": "GLADE HILL",
    "dropdelst": "VA",
    "dropdelzpp": 240929998,
    "dropphyadd": "7300 OLD FRANKLIN TPKE",
    "dropphycty": "GLADE HILL",
    "dropphyst": "VA",
    "dropphyzpp": 240929998,
    "dropmaladd": "7300 OLD FRANKLIN TPKE",
    "dropmalcty": "GLADE HILL",
    "dropmalst": "VA",
    "dropmalzpp": 240929998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405763521,
    "dropfax": 5405762946
  },
  {
    "dcode": "D",
    "dropkey": "PX26707",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "2418 PIEDMONT RD",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "VA",
    "dropdelzpp": 245539998,
    "dropphyadd": "2418 PIEDMONT RD",
    "dropphycty": "GLADSTONE",
    "dropphyst": "VA",
    "dropphyzpp": 245539998,
    "dropmaladd": "2418 PIEDMONT RD",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "VA",
    "dropmalzpp": 245539998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4349334433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26708",
    "droptype": "D",
    "dropname": "GLADYS",
    "dropdeladd": "62 PIGEON RUN RD",
    "dropdelcty": "GLADYS",
    "dropdelst": "VA",
    "dropdelzpp": 245549998,
    "dropphyadd": "62 PIGEON RUN RD",
    "dropphycty": "GLADYS",
    "dropphyst": "VA",
    "dropphyzpp": 245549998,
    "dropmaladd": "62 PIGEON RUN RD",
    "dropmalcty": "GLADYS",
    "dropmalst": "VA",
    "dropmalzpp": 245549998,
    "dropsitphn": 5409858780,
    "dropsitlph": 4342902111,
    "dropsitcph": 4343005444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26709",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "805 BLUE RIDGE RD",
    "dropdelcty": "GLASGOW",
    "dropdelst": "VA",
    "dropdelzpp": 245559998,
    "dropphyadd": "805 BLUE RIDGE RD",
    "dropphycty": "GLASGOW",
    "dropphyst": "VA",
    "dropphyzpp": 245559998,
    "dropmaladd": "805 BLUE RIDGE RD",
    "dropmalcty": "GLASGOW",
    "dropmalst": "VA",
    "dropmalzpp": 245559998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402582852,
    "dropfax": 5402582794
  },
  {
    "dcode": "D",
    "dropkey": "PX26711",
    "droptype": "D",
    "dropname": "GLEN ALLEN",
    "dropdeladd": "4990 SADLER PL",
    "dropdelcty": "GLEN ALLEN",
    "dropdelst": "VA",
    "dropdelzpp": 230609998,
    "dropphyadd": "4990 SADLER PL",
    "dropphycty": "GLEN ALLEN",
    "dropphyst": "VA",
    "dropphyzpp": 230609998,
    "dropmaladd": "4990 SADLER PL",
    "dropmalcty": "GLEN ALLEN",
    "dropmalst": "VA",
    "dropmalzpp": 230609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042705573,
    "dropsitcph": 8042705573,
    "dropfax": 8042700013
  },
  {
    "dcode": "D",
    "dropkey": "PX26713",
    "droptype": "D",
    "dropname": "GLEN LYN",
    "dropdeladd": "106 DAVIS AVE",
    "dropdelcty": "GLEN LYN",
    "dropdelst": "VA",
    "dropdelzpp": 240939998,
    "dropphyadd": "106 DAVIS AVE",
    "dropphycty": "GLEN LYN",
    "dropphyst": "VA",
    "dropphyzpp": 240939998,
    "dropmaladd": "106 DAVIS AVE",
    "dropmalcty": "GLEN LYN",
    "dropmalst": "VA",
    "dropmalzpp": 240939998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407263653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26714",
    "droptype": "D",
    "dropname": "GLEN WILTON",
    "dropdeladd": "20 MAIN ST",
    "dropdelcty": "GLEN WILTON",
    "dropdelst": "VA",
    "dropdelzpp": 244389800,
    "dropphyadd": "20 MAIN ST",
    "dropphycty": "GLEN WILTON",
    "dropphyst": "VA",
    "dropphyzpp": 244389800,
    "dropmaladd": "20 MAIN ST",
    "dropmalcty": "GLEN WILTON",
    "dropmalst": "VA",
    "dropmalzpp": 244389800,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408622137,
    "dropsitcph": 5408842168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26719",
    "droptype": "D",
    "dropname": "GLOUCESTER",
    "dropdeladd": "6892 MAIN ST",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "VA",
    "dropdelzpp": 230619998,
    "dropphyadd": "6892 MAIN ST",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "VA",
    "dropphyzpp": 230619998,
    "dropmaladd": "6892 MAIN ST",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "VA",
    "dropmalzpp": 230619998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046952706,
    "dropsitcph": 8046952706,
    "dropfax": 8046933556
  },
  {
    "dcode": "D",
    "dropkey": "PX26720",
    "droptype": "D",
    "dropname": "GLOUCESTER POINT",
    "dropdeladd": "1451 GEORGE WASHINGTON MEMORIAL HWY",
    "dropdelcty": "GLOUCESTER POINT",
    "dropdelst": "VA",
    "dropdelzpp": 230629998,
    "dropphyadd": "1451 GEORGE WASHINGTON MEMORIAL HWY",
    "dropphycty": "GLOUCESTER POINT",
    "dropphyst": "VA",
    "dropphyzpp": 230629998,
    "dropmaladd": "1451 GEORGE WASHINGTON MEMORIAL HWY",
    "dropmalcty": "GLOUCESTER POINT",
    "dropmalst": "VA",
    "dropmalzpp": 230629998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046424968,
    "dropsitcph": 8046424968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26725",
    "droptype": "D",
    "dropname": "GOLDVEIN",
    "dropdeladd": "14295 WARRENTON RD",
    "dropdelcty": "GOLDVEIN",
    "dropdelst": "VA",
    "dropdelzpp": 227209998,
    "dropphyadd": "14295 WARRENTON RD",
    "dropphycty": "GOLDVEIN",
    "dropphyst": "VA",
    "dropphyzpp": 227209998,
    "dropmaladd": "5338 SUMERDUCK RD",
    "dropmalcty": "SUMERDUCK",
    "dropmalst": "VA",
    "dropmalzpp": 227429997,
    "dropsitphn": 7036986867,
    "dropsitlph": 5407529720,
    "dropsitcph": 5407529720,
    "dropfax": 5407524680
  },
  {
    "dcode": "D",
    "dropkey": "PX26726",
    "droptype": "D",
    "dropname": "GOOCHLAND",
    "dropdeladd": "2972 RIVER RD W",
    "dropdelcty": "GOOCHLAND",
    "dropdelst": "VA",
    "dropdelzpp": 230639998,
    "dropphyadd": "2972 RIVER RD W",
    "dropphycty": "GOOCHLAND",
    "dropphyst": "VA",
    "dropphyzpp": 230639998,
    "dropmaladd": "2972 RIVER RD W",
    "dropmalcty": "GOOCHLAND",
    "dropmalst": "VA",
    "dropmalzpp": 230639998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045565119,
    "dropsitcph": 8045565119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26727",
    "droptype": "D",
    "dropname": "GOODE",
    "dropdeladd": "9161 FOREST RD",
    "dropdelcty": "GOODE",
    "dropdelst": "VA",
    "dropdelzpp": 245562992,
    "dropphyadd": "9161 FOREST RD",
    "dropphycty": "GOODE",
    "dropphyst": "VA",
    "dropphyzpp": 245562992,
    "dropmaladd": "9161 FOREST RD",
    "dropmalcty": "GOODE",
    "dropmalst": "VA",
    "dropmalzpp": 245562992,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405864331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26728",
    "droptype": "D",
    "dropname": "GOODVIEW",
    "dropdeladd": "7315 GOODVIEW RD",
    "dropdelcty": "GOODVIEW",
    "dropdelst": "VA",
    "dropdelzpp": 240959998,
    "dropphyadd": "7315 GOODVIEW RD",
    "dropphycty": "GOODVIEW",
    "dropphyst": "VA",
    "dropphyzpp": 240959998,
    "dropmaladd": "7315 GOODVIEW RD",
    "dropmalcty": "GOODVIEW",
    "dropmalst": "VA",
    "dropmalzpp": 240959998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5408904212,
    "dropfax": 5408906794
  },
  {
    "dcode": "D",
    "dropkey": "PX26729",
    "droptype": "D",
    "dropname": "GORDONSVILLE",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "GORDONSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229429255,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "GORDONSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229429255,
    "dropmaladd": "205 S MAIN ST",
    "dropmalcty": "GORDONSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229429255,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408325002,
    "dropfax": 5408325002
  },
  {
    "dcode": "D",
    "dropkey": "PX26732",
    "droptype": "D",
    "dropname": "GORE",
    "dropdeladd": "6819 NORTHWESTERN PIKE",
    "dropdelcty": "GORE",
    "dropdelst": "VA",
    "dropdelzpp": 226379998,
    "dropphyadd": "6819 NORTHWESTERN PIKE",
    "dropphycty": "GORE",
    "dropphyst": "VA",
    "dropphyzpp": 226379998,
    "dropmaladd": "6819 NORTHWESTERN PIKE",
    "dropmalcty": "GORE",
    "dropmalst": "VA",
    "dropmalzpp": 226379998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408583134,
    "dropsitcph": 5408583134,
    "dropfax": 5408582669
  },
  {
    "dcode": "D",
    "dropkey": "PX26733",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "9693 MAURY RIVER RD",
    "dropdelcty": "GOSHEN",
    "dropdelst": "VA",
    "dropdelzpp": 244399998,
    "dropphyadd": "9693 MAURY RIVER RD",
    "dropphycty": "GOSHEN",
    "dropphyst": "VA",
    "dropphyzpp": 244399998,
    "dropmaladd": "9693 MAURY RIVER RD",
    "dropmalcty": "GOSHEN",
    "dropmalst": "VA",
    "dropmalzpp": 244399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409975470,
    "dropsitcph": 5409975470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26744",
    "droptype": "D",
    "dropname": "GREAT FALLS",
    "dropdeladd": "10001 GEORGETOWN PIKE",
    "dropdelcty": "GREAT FALLS",
    "dropdelst": "VA",
    "dropdelzpp": 220669998,
    "dropphyadd": "10001 GEORGETOWN PIKE",
    "dropphycty": "GREAT FALLS",
    "dropphyst": "VA",
    "dropphyzpp": 220669998,
    "dropmaladd": "10001 GEORGETOWN PIKE",
    "dropmalcty": "GREAT FALLS",
    "dropmalst": "VA",
    "dropmalzpp": 220669998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037570316,
    "dropsitcph": 7037570316,
    "dropfax": 7037595928
  },
  {
    "dcode": "D",
    "dropkey": "PX26746",
    "droptype": "D",
    "dropname": "GREEN BAY",
    "dropdeladd": "8278 W PATRICK HENRY HWY",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "VA",
    "dropdelzpp": 239429998,
    "dropphyadd": "8278 W PATRICK HENRY HWY",
    "dropphycty": "GREEN BAY",
    "dropphyst": "VA",
    "dropphyzpp": 239429998,
    "dropmaladd": "8278 W PATRICK HENRY HWY",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "VA",
    "dropmalzpp": 239429998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347673348,
    "dropsitcph": 4347673348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26749",
    "droptype": "D",
    "dropname": "GREENBACKVILLE",
    "dropdeladd": "1529 STOCKTON AVE",
    "dropdelcty": "GREENBACKVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233569998,
    "dropphyadd": "1529 STOCKTON AVE",
    "dropphycty": "GREENBACKVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233569998,
    "dropmaladd": "1529 STOCKTON AVE",
    "dropmalcty": "GREENBACKVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233569998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578243564,
    "dropsitcph": 7578243564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26752",
    "droptype": "D",
    "dropname": "GREENBUSH",
    "dropdeladd": "21988 GREENBUSH RD",
    "dropdelcty": "GREENBUSH",
    "dropdelst": "VA",
    "dropdelzpp": 233579998,
    "dropphyadd": "21988 GREENBUSH RD",
    "dropphycty": "GREENBUSH",
    "dropphyst": "VA",
    "dropphyzpp": 233579998,
    "dropmaladd": "21988 GREENBUSH RD",
    "dropmalcty": "GREENBUSH",
    "dropmalst": "VA",
    "dropmalzpp": 233579998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577877145,
    "dropsitcph": 7577877145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26753",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "4171 LEE JACKSON HWY STE 101",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 244409998,
    "dropphyadd": "4171 LEE JACKSON HWY STE 101",
    "dropphycty": "GREENVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 244409998,
    "dropmaladd": "4171 LEE JACKSON HWY STE 101",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 244409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403374042,
    "dropsitcph": 5403374042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26759",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "788 GREENWOOD RD",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 229439998,
    "dropphyadd": "788 GREENWOOD RD",
    "dropphycty": "GREENWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 229439998,
    "dropmaladd": "788 GREENWOOD RD",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 229439998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5404566421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26760",
    "droptype": "D",
    "dropname": "GRETNA",
    "dropdeladd": "101 DR MARTIN LUTHER KING DR",
    "dropdelcty": "GRETNA",
    "dropdelst": "VA",
    "dropdelzpp": 245579998,
    "dropphyadd": "101 DR MARTIN LUTHER KING DR",
    "dropphycty": "GRETNA",
    "dropphyst": "VA",
    "dropphyzpp": 245579998,
    "dropmaladd": "101 DR MARTIN LUTHER KING DR",
    "dropmalcty": "GRETNA",
    "dropmalst": "VA",
    "dropmalzpp": 245579998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4346561830,
    "dropfax": 4346563574
  },
  {
    "dcode": "D",
    "dropkey": "PX26761",
    "droptype": "D",
    "dropname": "GRIMSTEAD",
    "dropdeladd": "1150 OLD FERRY RD",
    "dropdelcty": "GRIMSTEAD",
    "dropdelst": "VA",
    "dropdelzpp": 230649998,
    "dropphyadd": "1150 OLD FERRY RD",
    "dropphycty": "GRIMSTEAD",
    "dropphyst": "VA",
    "dropphyzpp": 230649998,
    "dropmaladd": "1150 OLD FERRY RD",
    "dropmalcty": "GRIMSTEAD",
    "dropmalst": "VA",
    "dropmalzpp": 230649998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047257618,
    "dropsitcph": 8047257618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26768",
    "droptype": "D",
    "dropname": "GROTTOES",
    "dropdeladd": "110 6TH ST",
    "dropdelcty": "GROTTOES",
    "dropdelst": "VA",
    "dropdelzpp": 244419998,
    "dropphyadd": "110 6TH ST",
    "dropphycty": "GROTTOES",
    "dropphyst": "VA",
    "dropphyzpp": 244419998,
    "dropmaladd": "110 6TH ST",
    "dropmalcty": "GROTTOES",
    "dropmalst": "VA",
    "dropmalzpp": 244419998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402490419,
    "dropsitcph": 5402490419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26769",
    "droptype": "D",
    "dropname": "GRUNDY",
    "dropdeladd": "123 WALNUT ST",
    "dropdelcty": "GRUNDY",
    "dropdelst": "VA",
    "dropdelzpp": 246149998,
    "dropphyadd": "123 WALNUT ST",
    "dropphycty": "GRUNDY",
    "dropphyst": "VA",
    "dropphyzpp": 246149998,
    "dropmaladd": "123 WALNUT ST",
    "dropmalcty": "GRUNDY",
    "dropmalst": "VA",
    "dropmalzpp": 246149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769352604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26773",
    "droptype": "D",
    "dropname": "GUM SPRING",
    "dropdeladd": "3250 BROAD STREET RD",
    "dropdelcty": "GUM SPRING",
    "dropdelst": "VA",
    "dropdelzpp": 230659998,
    "dropphyadd": "3250 BROAD STREET RD",
    "dropphycty": "GUM SPRING",
    "dropphyst": "VA",
    "dropphyzpp": 230659998,
    "dropmaladd": "3250 BROAD STREET RD",
    "dropmalcty": "GUM SPRING",
    "dropmalst": "VA",
    "dropmalzpp": 230659998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045564347,
    "dropsitcph": 8045564347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26775",
    "droptype": "D",
    "dropname": "GWYNN",
    "dropdeladd": "11 N BAY HAVEN RD",
    "dropdelcty": "GWYNN",
    "dropdelst": "VA",
    "dropdelzpp": 230669998,
    "dropphyadd": "11 N BAY HAVEN RD",
    "dropphycty": "GWYNN",
    "dropphyst": "VA",
    "dropphyzpp": 230669998,
    "dropmaladd": "11 N BAY HAVEN RD",
    "dropmalcty": "GWYNN",
    "dropmalst": "VA",
    "dropmalzpp": 230669998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047257770,
    "dropsitcph": 8047257770,
    "dropfax": 8047257770
  },
  {
    "dcode": "D",
    "dropkey": "PX26777",
    "droptype": "D",
    "dropname": "HADENSVILLE",
    "dropdeladd": "4650 THREE CHOPT RD",
    "dropdelcty": "HADENSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230679998,
    "dropphyadd": "4650 THREE CHOPT RD",
    "dropphycty": "HADENSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230679998,
    "dropmaladd": "4650 THREE CHOPT RD",
    "dropmalcty": "HADENSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044574338,
    "dropsitcph": 8044574338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26780",
    "droptype": "D",
    "dropname": "HAGUE",
    "dropdeladd": "8433 COPLE HWY",
    "dropdelcty": "HAGUE",
    "dropdelst": "VA",
    "dropdelzpp": 224699998,
    "dropphyadd": "8433 COPLE HWY",
    "dropphycty": "HAGUE",
    "dropphyst": "VA",
    "dropphyzpp": 224699998,
    "dropmaladd": "8433 COPLE HWY",
    "dropmalcty": "HAGUE",
    "dropmalst": "VA",
    "dropmalzpp": 224699998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044723185,
    "dropsitcph": 8044723185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26781",
    "droptype": "D",
    "dropname": "HALIFAX",
    "dropdeladd": "231 S MAIN ST",
    "dropdelcty": "HALIFAX",
    "dropdelst": "VA",
    "dropdelzpp": 245589998,
    "dropphyadd": "231 S MAIN ST",
    "dropphycty": "HALIFAX",
    "dropphyst": "VA",
    "dropphyzpp": 245589998,
    "dropmaladd": "231 S MAIN ST",
    "dropmalcty": "HALIFAX",
    "dropmalst": "VA",
    "dropmalzpp": 245589998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344764642,
    "dropfax": 4344764642
  },
  {
    "dcode": "D",
    "dropkey": "PX26782",
    "droptype": "D",
    "dropname": "HALLIEFORD",
    "dropdeladd": "1811 HALLIEFORD RD",
    "dropdelcty": "HALLIEFORD",
    "dropdelst": "VA",
    "dropdelzpp": 230689998,
    "dropphyadd": "1811 HALLIEFORD RD",
    "dropphycty": "HALLIEFORD",
    "dropphyst": "VA",
    "dropphyzpp": 230689998,
    "dropmaladd": "1811 HALLIEFORD RD",
    "dropmalcty": "HALLIEFORD",
    "dropmalst": "VA",
    "dropmalzpp": 230689998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047253187,
    "dropsitcph": 8047253187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26784",
    "droptype": "D",
    "dropname": "HALLWOOD",
    "dropdeladd": "27497 MAIN ST",
    "dropdelcty": "HALLWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 233599998,
    "dropphyadd": "27497 MAIN ST",
    "dropphycty": "HALLWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 233599998,
    "dropmaladd": "27497 MAIN ST",
    "dropmalcty": "HALLWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 233599998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7578244800,
    "dropfax": 7578244800
  },
  {
    "dcode": "D",
    "dropkey": "PX26785",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "53 W COLONIAL HWY",
    "dropdelcty": "HAMILTON",
    "dropdelst": "VA",
    "dropdelzpp": 201589998,
    "dropphyadd": "53 W COLONIAL HWY",
    "dropphycty": "HAMILTON",
    "dropphyst": "VA",
    "dropphyzpp": 201589998,
    "dropmaladd": "53 W COLONIAL HWY",
    "dropmalcty": "HAMILTON",
    "dropmalst": "VA",
    "dropmalzpp": 201589998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403382038,
    "dropsitcph": 5403382038,
    "dropfax": 5403382312
  },
  {
    "dcode": "D",
    "dropkey": "PX26787",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "809 ABERDEEN RD",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236709998,
    "dropphyadd": "809 ABERDEEN RD",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236709998,
    "dropmaladd": "809 ABERDEEN RD",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236709998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572624850,
    "dropsitcph": 7572624850,
    "dropfax": 7572624861
  },
  {
    "dcode": "D",
    "dropkey": "PX26791",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "13228 HANOVER COURTHOUSE RD",
    "dropdelcty": "HANOVER",
    "dropdelst": "VA",
    "dropdelzpp": 230699998,
    "dropphyadd": "13228 HANOVER COURTHOUSE RD",
    "dropphycty": "HANOVER",
    "dropphyst": "VA",
    "dropphyzpp": 230699998,
    "dropmaladd": "13228 HANOVER COURTHOUSE RD",
    "dropmalcty": "HANOVER",
    "dropmalst": "VA",
    "dropmalzpp": 230699998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045375385,
    "dropsitcph": 8045375385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26793",
    "droptype": "D",
    "dropname": "HARBORTON",
    "dropdeladd": "28059 DOCKVIEW ST",
    "dropdelcty": "HARBORTON",
    "dropdelst": "VA",
    "dropdelzpp": 233899997,
    "dropphyadd": "28059 DOCKVIEW ST",
    "dropphycty": "HARBORTON",
    "dropphyst": "VA",
    "dropphyzpp": 233899997,
    "dropmaladd": "28059 DOCKVIEW ST",
    "dropmalcty": "HARBORTON",
    "dropmalst": "VA",
    "dropmalzpp": 233899998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574425136,
    "dropsitcph": 7574425136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26794",
    "droptype": "D",
    "dropname": "HARDY",
    "dropdeladd": "7210 HARDY RD",
    "dropdelcty": "HARDY",
    "dropdelst": "VA",
    "dropdelzpp": 241019998,
    "dropphyadd": "7210 HARDY RD",
    "dropphycty": "HARDY",
    "dropphyst": "VA",
    "dropphyzpp": 241019998,
    "dropmaladd": "7210 HARDY RD",
    "dropmalcty": "HARDY",
    "dropmalst": "VA",
    "dropmalzpp": 241019998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5408905831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26795",
    "droptype": "D",
    "dropname": "HARDYVILLE",
    "dropdeladd": "15224 GENERAL PULLER HWY",
    "dropdelcty": "HARDYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230709998,
    "dropphyadd": "15224 GENERAL PULLER HWY",
    "dropphycty": "HARDYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230709998,
    "dropmaladd": "15224 GENERAL PULLER HWY",
    "dropmalcty": "HARDYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230709998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047766920,
    "dropsitcph": 8047766920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26801",
    "droptype": "D",
    "dropname": "HARRISONBURG",
    "dropdeladd": "3811 S MAIN ST",
    "dropdelcty": "HARRISONBURG",
    "dropdelst": "VA",
    "dropdelzpp": 228019998,
    "dropphyadd": "3811 S MAIN ST",
    "dropphycty": "HARRISONBURG",
    "dropphyst": "VA",
    "dropphyzpp": 228019998,
    "dropmaladd": "3811 S MAIN ST",
    "dropmalcty": "HARRISONBURG",
    "dropmalst": "VA",
    "dropmalzpp": 228019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5405746074,
    "dropfax": 5404332119
  },
  {
    "dcode": "D",
    "dropkey": "PX26803",
    "droptype": "D",
    "dropname": "HARTFIELD",
    "dropdeladd": "11 GRAFTON CHURCH RD",
    "dropdelcty": "HARTFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 230719998,
    "dropphyadd": "11 GRAFTON CHURCH RD",
    "dropphycty": "HARTFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 230719998,
    "dropmaladd": "11 GRAFTON CHURCH RD",
    "dropmalcty": "HARTFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 230719998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047766258,
    "dropsitcph": 8047766258,
    "dropfax": 8047760508
  },
  {
    "dcode": "D",
    "dropkey": "PX26805",
    "droptype": "D",
    "dropname": "HARTWOOD",
    "dropdeladd": "6 HARTWOOD CHURCH RD",
    "dropdelcty": "HARTWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 224719998,
    "dropphyadd": "6 HARTWOOD CHURCH RD",
    "dropphycty": "HARTWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 224719998,
    "dropmaladd": "6 HARTWOOD CHURCH RD",
    "dropmalcty": "HARTWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 224719998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407524200,
    "dropsitcph": 5407524200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26806",
    "droptype": "D",
    "dropname": "HAYES",
    "dropdeladd": "2344 GEORGE WASHINGTON MEMORIAL HWY",
    "dropdelcty": "HAYES",
    "dropdelst": "VA",
    "dropdelzpp": 230729998,
    "dropphyadd": "2344 GEORGE WASHINGTON MEMORIAL HWY",
    "dropphycty": "HAYES",
    "dropphyst": "VA",
    "dropphyzpp": 230729998,
    "dropmaladd": "2344 GEORGE WASHINGTON MEMORIAL HWY",
    "dropmalcty": "HAYES",
    "dropmalst": "VA",
    "dropmalzpp": 230729998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046422721,
    "dropsitcph": 8046422721,
    "dropfax": 8046421250
  },
  {
    "dcode": "D",
    "dropkey": "PX26810",
    "droptype": "D",
    "dropname": "HAYMARKET",
    "dropdeladd": "14658 GAP WAY",
    "dropdelcty": "HAYMARKET",
    "dropdelst": "VA",
    "dropdelzpp": 201699998,
    "dropphyadd": "14658 GAP WAY",
    "dropphycty": "HAYMARKET",
    "dropphyst": "VA",
    "dropphyzpp": 201699998,
    "dropmaladd": "14658 GAP WAY",
    "dropmalcty": "HAYMARKET",
    "dropmalst": "VA",
    "dropmalzpp": 201699998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037540937,
    "dropsitcph": 7037540937,
    "dropfax": 5712486707
  },
  {
    "dcode": "D",
    "dropkey": "PX26811",
    "droptype": "D",
    "dropname": "HAYNESVILLE",
    "dropdeladd": "11320 RICHMOND RD",
    "dropdelcty": "HAYNESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 224729998,
    "dropphyadd": "11320 RICHMOND RD",
    "dropphycty": "HAYNESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 224729998,
    "dropmaladd": "11320 RICHMOND RD",
    "dropmalcty": "HAYNESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 224729998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043334240,
    "dropsitcph": 8043334240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26814",
    "droptype": "D",
    "dropname": "HAYSI",
    "dropdeladd": "288 HAYSI MAIN ST",
    "dropdelcty": "HAYSI",
    "dropdelst": "VA",
    "dropdelzpp": 242569998,
    "dropphyadd": "288 HAYSI MAIN ST",
    "dropphycty": "HAYSI",
    "dropphyst": "VA",
    "dropphyzpp": 242569998,
    "dropmaladd": "288 HAYSI MAIN ST",
    "dropmalcty": "HAYSI",
    "dropmalst": "VA",
    "dropmalzpp": 242569998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768654698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26822",
    "droptype": "D",
    "dropname": "HEATHSVILLE",
    "dropdeladd": "27 MONUMENT PL",
    "dropdelcty": "HEATHSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 224739998,
    "dropphyadd": "27 MONUMENT PL",
    "dropphycty": "HEATHSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 224739998,
    "dropmaladd": "27 MONUMENT PL",
    "dropmalcty": "HEATHSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 224739998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045805011,
    "dropsitcph": 8045805011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26826",
    "droptype": "D",
    "dropname": "HENRY",
    "dropdeladd": "30 TOWNE CREEK RD",
    "dropdelcty": "HENRY",
    "dropdelst": "VA",
    "dropdelzpp": 241029998,
    "dropphyadd": "30 TOWNE CREEK RD",
    "dropphycty": "HENRY",
    "dropphyst": "VA",
    "dropphyzpp": 241029998,
    "dropmaladd": "30 TOWNE CREEK RD",
    "dropmalcty": "HENRY",
    "dropmalst": "VA",
    "dropmalzpp": 241029998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766298008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26828",
    "droptype": "D",
    "dropname": "HERNDON",
    "dropdeladd": "590 GROVE ST",
    "dropdelcty": "HERNDON",
    "dropdelst": "VA",
    "dropdelzpp": 201709998,
    "dropphyadd": "590 GROVE ST",
    "dropphycty": "HERNDON",
    "dropphyst": "VA",
    "dropphyzpp": 201709998,
    "dropmaladd": "590 GROVE ST",
    "dropmalcty": "HERNDON",
    "dropmalst": "VA",
    "dropmalzpp": 201709998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036899890,
    "dropsitcph": 7036899890,
    "dropfax": 7034357316
  },
  {
    "dcode": "D",
    "dropkey": "PX26843",
    "droptype": "D",
    "dropname": "HILLSVILLE",
    "dropdeladd": "404 S MAIN ST",
    "dropdelcty": "HILLSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 243439998,
    "dropphyadd": "404 S MAIN ST",
    "dropphycty": "HILLSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 243439998,
    "dropmaladd": "404 S MAIN ST",
    "dropmalcty": "HILLSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 243439998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767287041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26845",
    "droptype": "D",
    "dropname": "HILTONS",
    "dropdeladd": "90 SECOND ST",
    "dropdelcty": "HILTONS",
    "dropdelst": "VA",
    "dropdelzpp": 242589998,
    "dropphyadd": "90 SECOND ST",
    "dropphycty": "HILTONS",
    "dropphyst": "VA",
    "dropphyzpp": 242589998,
    "dropmaladd": "90 SECOND ST",
    "dropmalcty": "HILTONS",
    "dropmalst": "VA",
    "dropmalzpp": 242589998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763867221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26846",
    "droptype": "D",
    "dropname": "HINTON",
    "dropdeladd": "6121 RAWLEY PIKE",
    "dropdelcty": "HINTON",
    "dropdelst": "VA",
    "dropdelzpp": 228319998,
    "dropphyadd": "6121 RAWLEY PIKE",
    "dropphycty": "HINTON",
    "dropphyst": "VA",
    "dropphyzpp": 228319998,
    "dropmaladd": "6121 RAWLEY PIKE",
    "dropmalcty": "HINTON",
    "dropmalst": "VA",
    "dropmalzpp": 228319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408675468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26847",
    "droptype": "D",
    "dropname": "HIWASSEE",
    "dropdeladd": "2298 JULIA SIMPKINS RD",
    "dropdelcty": "HIWASSEE",
    "dropdelst": "VA",
    "dropdelzpp": 243479998,
    "dropphyadd": "2298 JULIA SIMPKINS RD",
    "dropphycty": "HIWASSEE",
    "dropphyst": "VA",
    "dropphyzpp": 243479998,
    "dropmaladd": "2298 JULIA SIMPKINS RD",
    "dropmalcty": "HIWASSEE",
    "dropmalst": "VA",
    "dropmalzpp": 243479998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409801559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26855",
    "droptype": "D",
    "dropname": "HONAKER",
    "dropdeladd": "5528 REDBUD HWY",
    "dropdelcty": "HONAKER",
    "dropdelst": "VA",
    "dropdelzpp": 242609998,
    "dropphyadd": "5528 REDBUD HWY",
    "dropphycty": "HONAKER",
    "dropphyst": "VA",
    "dropphyzpp": 242609998,
    "dropmaladd": "5528 REDBUD HWY",
    "dropmalcty": "HONAKER",
    "dropmalst": "VA",
    "dropmalzpp": 242609998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768735585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26857",
    "droptype": "D",
    "dropname": "HOOD",
    "dropdeladd": "1815 WOLFTOWN HOOD RD",
    "dropdelcty": "HOOD",
    "dropdelst": "VA",
    "dropdelzpp": 227239997,
    "dropphyadd": "1815 WOLFTOWN HOOD RD",
    "dropphycty": "HOOD",
    "dropphyst": "VA",
    "dropphyzpp": 227239997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOOD",
    "dropmalst": "VA",
    "dropmalzpp": 227239998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409487016,
    "dropsitcph": 5409487016,
    "dropfax": 5409487016
  },
  {
    "dcode": "D",
    "dropkey": "PX26858",
    "droptype": "D",
    "dropname": "HOPEWELL",
    "dropdeladd": "117 W POYTHRESS ST",
    "dropdelcty": "HOPEWELL",
    "dropdelst": "VA",
    "dropdelzpp": 238609998,
    "dropphyadd": "117 W POYTHRESS ST",
    "dropphycty": "HOPEWELL",
    "dropphyst": "VA",
    "dropphyzpp": 238609998,
    "dropmaladd": "117 W POYTHRESS ST",
    "dropmalcty": "HOPEWELL",
    "dropmalst": "VA",
    "dropmalzpp": 238609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044524350,
    "dropsitcph": 8044524350,
    "dropfax": 8044588826
  },
  {
    "dcode": "D",
    "dropkey": "PX26859",
    "droptype": "D",
    "dropname": "HORNTOWN",
    "dropdeladd": "4581 FLEMING RD",
    "dropdelcty": "HORNTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 233959998,
    "dropphyadd": "4581 FLEMING RD",
    "dropphycty": "HORNTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 233959998,
    "dropmaladd": "4581 FLEMING RD",
    "dropmalcty": "HORNTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 233959998,
    "dropsitphn": 7578245573,
    "dropsitlph": 7578245573,
    "dropsitcph": 7578245573,
    "dropfax": 7578245573
  },
  {
    "dcode": "D",
    "dropkey": "PX26860",
    "droptype": "D",
    "dropname": "HORSEPEN",
    "dropdeladd": "2354 HORSEPEN RD",
    "dropdelcty": "HORSEPEN",
    "dropdelst": "VA",
    "dropdelzpp": 246199998,
    "dropphyadd": "2354 HORSEPEN RD",
    "dropphycty": "HORSEPEN",
    "dropphyst": "VA",
    "dropphyzpp": 246199998,
    "dropmaladd": "2354 HORSEPEN RD",
    "dropmalcty": "HORSEPEN",
    "dropmalst": "VA",
    "dropmalzpp": 246199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769886367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26863",
    "droptype": "D",
    "dropname": "HOT SPRINGS",
    "dropdeladd": "2793 MAIN ST",
    "dropdelcty": "HOT SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 244452619,
    "dropphyadd": "2793 MAIN ST",
    "dropphycty": "HOT SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 244452619,
    "dropmaladd": "2793 MAIN ST",
    "dropmalcty": "HOT SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 244452619,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408392522,
    "dropsitcph": 5408392522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26867",
    "droptype": "D",
    "dropname": "HUDDLESTON",
    "dropdeladd": "1080 TOLERS FERRY RD",
    "dropdelcty": "HUDDLESTON",
    "dropdelst": "VA",
    "dropdelzpp": 241049998,
    "dropphyadd": "1080 TOLERS FERRY RD",
    "dropphycty": "HUDDLESTON",
    "dropphyst": "VA",
    "dropphyzpp": 241049998,
    "dropmaladd": "1080 TOLERS FERRY RD",
    "dropmalcty": "HUDDLESTON",
    "dropmalst": "VA",
    "dropmalzpp": 241049998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402975427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26868",
    "droptype": "D",
    "dropname": "HUDGINS",
    "dropdeladd": "8251 BUCKLEY HALL RD",
    "dropdelcty": "HUDGINS",
    "dropdelst": "VA",
    "dropdelzpp": 230769998,
    "dropphyadd": "8251 BUCKLEY HALL RD",
    "dropphycty": "HUDGINS",
    "dropphyst": "VA",
    "dropphyzpp": 230769998,
    "dropmaladd": "8251 BUCKLEY HALL RD",
    "dropmalcty": "HUDGINS",
    "dropmalst": "VA",
    "dropmalzpp": 230769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047252710,
    "dropsitcph": 8047252710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26869",
    "droptype": "D",
    "dropname": "HUME",
    "dropdeladd": "5046 LEEDS MANOR RD",
    "dropdelcty": "HUME",
    "dropdelst": "VA",
    "dropdelzpp": 226399997,
    "dropphyadd": "5046 LEEDS MANOR RD",
    "dropphycty": "HUME",
    "dropphyst": "VA",
    "dropphyzpp": 226399997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUME",
    "dropmalst": "VA",
    "dropmalzpp": 226399998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5403642600,
    "dropsitcph": 5403642600,
    "dropfax": 5403649633
  },
  {
    "dcode": "D",
    "dropkey": "PX26872",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "7505 LESTERS FORK RD",
    "dropdelcty": "HURLEY",
    "dropdelst": "VA",
    "dropdelzpp": 246209998,
    "dropphyadd": "7505 LESTERS FORK RD",
    "dropphycty": "HURLEY",
    "dropphyst": "VA",
    "dropphyzpp": 246209998,
    "dropmaladd": "7505 LESTERS FORK RD",
    "dropmalcty": "HURLEY",
    "dropmalst": "VA",
    "dropmalzpp": 246209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765668829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26873",
    "droptype": "D",
    "dropname": "HURT",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "HURT",
    "dropdelst": "VA",
    "dropdelzpp": 245639998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "HURT",
    "dropphyst": "VA",
    "dropphyzpp": 245639998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "HURT",
    "dropmalst": "VA",
    "dropmalzpp": 245639998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343244804,
    "dropfax": 4343244769
  },
  {
    "dcode": "D",
    "dropkey": "PX26874",
    "droptype": "D",
    "dropname": "HUSTLE",
    "dropdeladd": "196 HUSTLE RD",
    "dropdelcty": "HUSTLE",
    "dropdelst": "VA",
    "dropdelzpp": 224769998,
    "dropphyadd": "196 HUSTLE RD",
    "dropphycty": "HUSTLE",
    "dropphyst": "VA",
    "dropphyzpp": 224769998,
    "dropmaladd": "196 HUSTLE RD",
    "dropmalcty": "HUSTLE",
    "dropmalst": "VA",
    "dropmalzpp": 224769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044431095,
    "dropsitcph": 8044431095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26876",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "301 DAVIS ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "VA",
    "dropdelzpp": 243489998,
    "dropphyadd": "301 DAVIS ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "VA",
    "dropphyzpp": 243489998,
    "dropmaladd": "301 DAVIS ST",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "VA",
    "dropmalzpp": 243489998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767732261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26880",
    "droptype": "D",
    "dropname": "INDIAN VALLEY",
    "dropdeladd": "321 INDIAN VALLEY POST OFFICE RD NW",
    "dropdelcty": "INDIAN VALLEY",
    "dropdelst": "VA",
    "dropdelzpp": 241059998,
    "dropphyadd": "321 INDIAN VALLEY POST OFFICE RD NW",
    "dropphycty": "INDIAN VALLEY",
    "dropphyst": "VA",
    "dropphyzpp": 241059998,
    "dropmaladd": "321 INDIAN VALLEY POST OFFICE RD NW",
    "dropmalcty": "INDIAN VALLEY",
    "dropmalst": "VA",
    "dropmalzpp": 241059998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407894464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26884",
    "droptype": "D",
    "dropname": "IRON GATE",
    "dropdeladd": "511 MARKET ST",
    "dropdelcty": "IRON GATE",
    "dropdelst": "VA",
    "dropdelzpp": 244489998,
    "dropphyadd": "511 MARKET ST",
    "dropphycty": "IRON GATE",
    "dropphyst": "VA",
    "dropphyzpp": 244489998,
    "dropmaladd": "511 MARKET ST",
    "dropmalcty": "IRON GATE",
    "dropmalst": "VA",
    "dropmalzpp": 244489998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408625995,
    "dropsitcph": 5408625995,
    "dropfax": 5408625995
  },
  {
    "dcode": "D",
    "dropkey": "PX26887",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "4473 IRVINGTON RD",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 224809998,
    "dropphyadd": "4473 IRVINGTON RD",
    "dropphycty": "IRVINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 224809998,
    "dropmaladd": "4473 IRVINGTON RD",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 224809998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044385033,
    "dropsitcph": 8044385033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26888",
    "droptype": "D",
    "dropname": "ISLE OF WIGHT",
    "dropdeladd": "17161 COURTHOUSE HWY",
    "dropdelcty": "ISLE OF WIGHT",
    "dropdelst": "VA",
    "dropdelzpp": 233979998,
    "dropphyadd": "17161 COURTHOUSE HWY",
    "dropphycty": "ISLE OF WIGHT",
    "dropphyst": "VA",
    "dropphyzpp": 233979998,
    "dropmaladd": "17161 COURTHOUSE HWY",
    "dropmalcty": "ISLE OF WIGHT",
    "dropmalst": "VA",
    "dropmalzpp": 233979998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573569314,
    "dropsitcph": 7573569314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26890",
    "droptype": "D",
    "dropname": "IVOR",
    "dropdeladd": "8280 MAIN ST",
    "dropdelcty": "IVOR",
    "dropdelst": "VA",
    "dropdelzpp": 238669998,
    "dropphyadd": "8280 MAIN ST",
    "dropphycty": "IVOR",
    "dropphyst": "VA",
    "dropphyzpp": 238669998,
    "dropmaladd": "8280 MAIN ST",
    "dropmalcty": "IVOR",
    "dropmalst": "VA",
    "dropmalzpp": 238669998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7578596666,
    "dropsitcph": 7578596666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26891",
    "droptype": "D",
    "dropname": "IVY",
    "dropdeladd": "4301 IVY RD",
    "dropdelcty": "IVY",
    "dropdelst": "VA",
    "dropdelzpp": 229459997,
    "dropphyadd": "4301 IVY RD",
    "dropphycty": "IVY",
    "dropphyst": "VA",
    "dropphyzpp": 229459997,
    "dropmaladd": "4301 IVY RD",
    "dropmalcty": "IVY",
    "dropmalst": "VA",
    "dropmalzpp": 229459997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342964864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26900",
    "droptype": "D",
    "dropname": "JAMESVILLE",
    "dropdeladd": "6010 OCCOHANNOCK NECK RD",
    "dropdelcty": "JAMESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 233989998,
    "dropphyadd": "6010 OCCOHANNOCK NECK RD",
    "dropphycty": "JAMESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 233989998,
    "dropmaladd": "6010 OCCOHANNOCK NECK RD",
    "dropmalcty": "JAMESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 233989998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574423001,
    "dropsitcph": 7574423001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26903",
    "droptype": "D",
    "dropname": "JARRATT",
    "dropdeladd": "215 JARRATT AVE",
    "dropdelcty": "JARRATT",
    "dropdelst": "VA",
    "dropdelzpp": 238679998,
    "dropphyadd": "215 JARRATT AVE",
    "dropphycty": "JARRATT",
    "dropphyst": "VA",
    "dropphyzpp": 238679998,
    "dropmaladd": "215 JARRATT AVE",
    "dropmalcty": "JARRATT",
    "dropmalst": "VA",
    "dropmalzpp": 238679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345358264,
    "dropsitcph": 4345358264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26904",
    "droptype": "D",
    "dropname": "JAVA",
    "dropdeladd": "3093 JAVA RD",
    "dropdelcty": "JAVA",
    "dropdelst": "VA",
    "dropdelzpp": 245659998,
    "dropphyadd": "3093 JAVA RD",
    "dropphycty": "JAVA",
    "dropphyst": "VA",
    "dropphyzpp": 245659998,
    "dropmaladd": "3093 JAVA RD",
    "dropmalcty": "JAVA",
    "dropmalst": "VA",
    "dropmalzpp": 245659998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344320721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26907",
    "droptype": "D",
    "dropname": "JEFFERSONTON",
    "dropdeladd": "5073 JEFFERSONTON RD",
    "dropdelcty": "JEFFERSONTON",
    "dropdelst": "VA",
    "dropdelzpp": 227249998,
    "dropphyadd": "5073 JEFFERSONTON RD",
    "dropphycty": "JEFFERSONTON",
    "dropphyst": "VA",
    "dropphyzpp": 227249998,
    "dropmaladd": "5073 JEFFERSONTON RD",
    "dropmalcty": "JEFFERSONTON",
    "dropmalst": "VA",
    "dropmalzpp": 227249998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409374300,
    "dropsitcph": 5409374300,
    "dropfax": 5409376595
  },
  {
    "dcode": "D",
    "dropkey": "PX26911",
    "droptype": "D",
    "dropname": "JERSEY",
    "dropdeladd": "12079 JERSEY RD",
    "dropdelcty": "JERSEY",
    "dropdelst": "VA",
    "dropdelzpp": 224819998,
    "dropphyadd": "12079 JERSEY RD",
    "dropphycty": "JERSEY",
    "dropphyst": "VA",
    "dropphyzpp": 224819998,
    "dropmaladd": "12079 JERSEY RD",
    "dropmalcty": "JERSEY",
    "dropmalst": "VA",
    "dropmalzpp": 224819998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407754153,
    "dropsitcph": 5407754153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26912",
    "droptype": "D",
    "dropname": "JETERSVILLE",
    "dropdeladd": "21595 JETERSVILLE RD",
    "dropdelcty": "JETERSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 230839998,
    "dropphyadd": "21595 JETERSVILLE RD",
    "dropphycty": "JETERSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 230839998,
    "dropmaladd": "21595 JETERSVILLE RD",
    "dropmalcty": "JETERSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 230839998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045614000,
    "dropsitcph": 8045614000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26915",
    "droptype": "D",
    "dropname": "JEWELL RIDGE",
    "dropdeladd": "978 JEWELL MAIN RD",
    "dropdelcty": "JEWELL RIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 246229998,
    "dropphyadd": "978 JEWELL MAIN RD",
    "dropphycty": "JEWELL RIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 246229998,
    "dropmaladd": "978 JEWELL MAIN RD",
    "dropmalcty": "JEWELL RIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 246229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2768818665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26918",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "169 CHURCH ST",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 242639998,
    "dropphyadd": "169 CHURCH ST",
    "dropphycty": "JONESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 242639998,
    "dropmaladd": "169 CHURCH ST",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 242639998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763462590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26922",
    "droptype": "D",
    "dropname": "KEELING",
    "dropdeladd": "12096 OLD RICHMOND RD",
    "dropdelcty": "KEELING",
    "dropdelst": "VA",
    "dropdelzpp": 245669998,
    "dropphyadd": "12096 OLD RICHMOND RD",
    "dropphycty": "KEELING",
    "dropphyst": "VA",
    "dropphyzpp": 245669998,
    "dropmaladd": "12096 OLD RICHMOND RD",
    "dropmalcty": "KEELING",
    "dropmalst": "VA",
    "dropmalzpp": 245669998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347924850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26923",
    "droptype": "D",
    "dropname": "KEEN MOUNTAIN",
    "dropdeladd": "1063 KEEN MOUNTAIN CAMP RD",
    "dropdelcty": "KEEN MOUNTAIN",
    "dropdelst": "VA",
    "dropdelzpp": 246249998,
    "dropphyadd": "1063 KEEN MOUNTAIN CAMP RD",
    "dropphycty": "KEEN MOUNTAIN",
    "dropphyst": "VA",
    "dropphyzpp": 246249998,
    "dropmaladd": "1063 KEEN MOUNTAIN CAMP RD",
    "dropmalcty": "KEEN MOUNTAIN",
    "dropmalst": "VA",
    "dropmalzpp": 246249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2764983590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26924",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "6246 ESMONT RD",
    "dropdelcty": "KEENE",
    "dropdelst": "VA",
    "dropdelzpp": 229469998,
    "dropphyadd": "6246 ESMONT RD",
    "dropphycty": "KEENE",
    "dropphyst": "VA",
    "dropphyzpp": 229469998,
    "dropmaladd": "6246 ESMONT RD",
    "dropmalcty": "KEENE",
    "dropmalst": "VA",
    "dropmalzpp": 229469998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342863929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26927",
    "droptype": "D",
    "dropname": "KELLER",
    "dropdeladd": "18243 1ST ST",
    "dropdelcty": "KELLER",
    "dropdelst": "VA",
    "dropdelzpp": 234019998,
    "dropphyadd": "18243 1ST ST",
    "dropphycty": "KELLER",
    "dropphyst": "VA",
    "dropphyzpp": 234019998,
    "dropmaladd": "18243 1ST ST",
    "dropmalcty": "KELLER",
    "dropmalst": "VA",
    "dropmalzpp": 234019998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577874696,
    "dropsitcph": 7577874696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26929",
    "droptype": "D",
    "dropname": "KENBRIDGE",
    "dropdeladd": "118 E 5TH AVE",
    "dropdelcty": "KENBRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 239449998,
    "dropphyadd": "118 E 5TH AVE",
    "dropphycty": "KENBRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 239449998,
    "dropmaladd": "118 E 5TH AVE",
    "dropmalcty": "KENBRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 239449998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346766666,
    "dropsitcph": 4346766666,
    "dropfax": 4346766666
  },
  {
    "dcode": "D",
    "dropkey": "PX26931",
    "droptype": "D",
    "dropname": "KENTS STORE",
    "dropdeladd": "16 KENTS STORE WAY",
    "dropdelcty": "KENTS STORE",
    "dropdelst": "VA",
    "dropdelzpp": 230849998,
    "dropphyadd": "16 KENTS STORE WAY",
    "dropphycty": "KENTS STORE",
    "dropphyst": "VA",
    "dropphyzpp": 230849998,
    "dropmaladd": "16 KENTS STORE WAY",
    "dropmalcty": "KENTS STORE",
    "dropmalst": "VA",
    "dropmalzpp": 230849998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045898611,
    "dropsitcph": 4345898611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26932",
    "droptype": "D",
    "dropname": "KEOKEE",
    "dropdeladd": "119 POST OFFICE RD",
    "dropdelcty": "KEOKEE",
    "dropdelst": "VA",
    "dropdelzpp": 242659998,
    "dropphyadd": "119 POST OFFICE RD",
    "dropphycty": "KEOKEE",
    "dropphyst": "VA",
    "dropphyzpp": 242659998,
    "dropmaladd": "119 POST OFFICE RD",
    "dropmalcty": "KEOKEE",
    "dropmalst": "VA",
    "dropmalzpp": 242659998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2765651533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26934",
    "droptype": "D",
    "dropname": "KESWICK",
    "dropdeladd": "3991 LOUISA RD",
    "dropdelcty": "KESWICK",
    "dropdelst": "VA",
    "dropdelzpp": 229479998,
    "dropphyadd": "3991 LOUISA RD",
    "dropphycty": "KESWICK",
    "dropphyst": "VA",
    "dropphyzpp": 229479998,
    "dropmaladd": "3991 LOUISA RD",
    "dropmalcty": "KESWICK",
    "dropmalst": "VA",
    "dropmalzpp": 229479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342955048,
    "dropsitcph": 4342955048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26935",
    "droptype": "D",
    "dropname": "KEYSVILLE",
    "dropdeladd": "225 KING ST",
    "dropdelcty": "KEYSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 239479998,
    "dropphyadd": "225 KING ST",
    "dropphycty": "KEYSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 239479998,
    "dropmaladd": "225 KING ST",
    "dropmalcty": "KEYSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 239479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347362382,
    "dropsitcph": 4347362382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26938",
    "droptype": "D",
    "dropname": "KILMARNOCK",
    "dropdeladd": "239 N MAIN ST",
    "dropdelcty": "KILMARNOCK",
    "dropdelst": "VA",
    "dropdelzpp": 224829998,
    "dropphyadd": "239 N MAIN ST",
    "dropphycty": "KILMARNOCK",
    "dropphyst": "VA",
    "dropphyzpp": 224829998,
    "dropmaladd": "239 N MAIN ST",
    "dropmalcty": "KILMARNOCK",
    "dropmalst": "VA",
    "dropmalzpp": 224829998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044353941,
    "dropsitcph": 8044353941,
    "dropfax": 8044353941
  },
  {
    "dcode": "D",
    "dropkey": "PX26941",
    "droptype": "D",
    "dropname": "KING AND QUEEN COURT HOUSE",
    "dropdeladd": "352 ALLENS CIR",
    "dropdelcty": "KING AND QUEEN COURT HOUSE",
    "dropdelst": "VA",
    "dropdelzpp": 230859998,
    "dropphyadd": "352 ALLENS CIR",
    "dropphycty": "KING AND QUEEN COURT HOUSE",
    "dropphyst": "VA",
    "dropphyzpp": 230859998,
    "dropmaladd": "352 ALLENS CIR",
    "dropmalcty": "KING AND QUEEN COURT HOUSE",
    "dropmalst": "VA",
    "dropmalzpp": 230859998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047856253,
    "dropsitcph": 8047856253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26943",
    "droptype": "D",
    "dropname": "KING GEORGE",
    "dropdeladd": "7993 KINGS HWY",
    "dropdelcty": "KING GEORGE",
    "dropdelst": "VA",
    "dropdelzpp": 224859998,
    "dropphyadd": "7993 KINGS HWY",
    "dropphycty": "KING GEORGE",
    "dropphyst": "VA",
    "dropphyzpp": 224859998,
    "dropmaladd": "7993 KINGS HWY",
    "dropmalcty": "KING GEORGE",
    "dropmalst": "VA",
    "dropmalzpp": 224859998,
    "dropsitphn": 8047776336,
    "dropsitlph": 5407756405,
    "dropsitcph": 5407756405,
    "dropfax": 5407750864
  },
  {
    "dcode": "D",
    "dropkey": "PX26946",
    "droptype": "D",
    "dropname": "KING WILLIAM",
    "dropdeladd": "17 HORSE LANDING RD",
    "dropdelcty": "KING WILLIAM",
    "dropdelst": "VA",
    "dropdelzpp": 230869998,
    "dropphyadd": "17 HORSE LANDING RD",
    "dropphycty": "KING WILLIAM",
    "dropphyst": "VA",
    "dropphyzpp": 230869998,
    "dropmaladd": "17 HORSE LANDING RD",
    "dropmalcty": "KING WILLIAM",
    "dropmalst": "VA",
    "dropmalzpp": 230869998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047694160,
    "dropsitcph": 8047694160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26948",
    "droptype": "D",
    "dropname": "KINSALE",
    "dropdeladd": "490 KINSALE RD",
    "dropdelcty": "KINSALE",
    "dropdelst": "VA",
    "dropdelzpp": 224889998,
    "dropphyadd": "490 KINSALE RD",
    "dropphycty": "KINSALE",
    "dropphyst": "VA",
    "dropphyzpp": 224889998,
    "dropmaladd": "490 KINSALE RD",
    "dropmalcty": "KINSALE",
    "dropmalst": "VA",
    "dropmalzpp": 224889998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044722440,
    "dropsitcph": 8044722440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26953",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "50 SAINT TAMMANY RD",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "VA",
    "dropdelzpp": 239509998,
    "dropphyadd": "50 SAINT TAMMANY RD",
    "dropphycty": "LA CROSSE",
    "dropphyst": "VA",
    "dropphyzpp": 239509998,
    "dropmaladd": "50 SAINT TAMMANY RD",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "VA",
    "dropmalzpp": 239509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347577512,
    "dropsitcph": 4347577512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26955",
    "droptype": "D",
    "dropname": "LACEY SPRING",
    "dropdeladd": "8975 N VALLEY PIKE",
    "dropdelcty": "LACEY SPRING",
    "dropdelst": "VA",
    "dropdelzpp": 228339998,
    "dropphyadd": "8975 N VALLEY PIKE",
    "dropphycty": "LACEY SPRING",
    "dropphyst": "VA",
    "dropphyzpp": 228339998,
    "dropmaladd": "8975 N VALLEY PIKE",
    "dropmalcty": "LACEY SPRING",
    "dropmalst": "VA",
    "dropmalzpp": 228339998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5404344977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26956",
    "droptype": "D",
    "dropname": "LACKEY",
    "dropdeladd": "2028 OLD WILLIAMSBURG RD",
    "dropdelcty": "LACKEY",
    "dropdelst": "VA",
    "dropdelzpp": 236949800,
    "dropphyadd": "2028 OLD WILLIAMSBURG RD",
    "dropphycty": "LACKEY",
    "dropphyst": "VA",
    "dropphyzpp": 236949800,
    "dropmaladd": "2028 OLD WILLIAMSBURG RD",
    "dropmalcty": "LACKEY",
    "dropmalst": "VA",
    "dropmalzpp": 236949800,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7578871373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26958",
    "droptype": "D",
    "dropname": "LADYSMITH",
    "dropdeladd": "18014 JEFFERSON DAVIS HWY",
    "dropdelcty": "LADYSMITH",
    "dropdelst": "VA",
    "dropdelzpp": 225019998,
    "dropphyadd": "18014 JEFFERSON DAVIS HWY",
    "dropphycty": "LADYSMITH",
    "dropphyst": "VA",
    "dropphyzpp": 225019998,
    "dropmaladd": "18014 JEFFERSON DAVIS HWY",
    "dropmalcty": "LADYSMITH",
    "dropmalst": "VA",
    "dropmalzpp": 225019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044483316,
    "dropsitcph": 8044483316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26968",
    "droptype": "D",
    "dropname": "LAMBSBURG",
    "dropdeladd": "3291 LAMBSBURG RD",
    "dropdelcty": "LAMBSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 243519998,
    "dropphyadd": "3291 LAMBSBURG RD",
    "dropphycty": "LAMBSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 243519998,
    "dropmaladd": "3291 LAMBSBURG RD",
    "dropmalcty": "LAMBSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 243519998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767554131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26969",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "9054 MARY BALL RD",
    "dropdelcty": "LANCASTER",
    "dropdelst": "VA",
    "dropdelzpp": 225039998,
    "dropphyadd": "9054 MARY BALL RD",
    "dropphycty": "LANCASTER",
    "dropphyst": "VA",
    "dropphyzpp": 225039998,
    "dropmaladd": "9054 MARY BALL RD",
    "dropmalcty": "LANCASTER",
    "dropmalst": "VA",
    "dropmalzpp": 225039998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044625280,
    "dropsitcph": 8044625280,
    "dropfax": 8044625280
  },
  {
    "dcode": "D",
    "dropkey": "PX26972",
    "droptype": "D",
    "dropname": "LANEXA",
    "dropdeladd": "15545 POCAHONTAS TRL",
    "dropdelcty": "LANEXA",
    "dropdelst": "VA",
    "dropdelzpp": 230899998,
    "dropphyadd": "15545 POCAHONTAS TRL",
    "dropphycty": "LANEXA",
    "dropphyst": "VA",
    "dropphyzpp": 230899998,
    "dropmaladd": "15545 POCAHONTAS TRL",
    "dropmalcty": "LANEXA",
    "dropmalst": "VA",
    "dropmalzpp": 230899998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049662534,
    "dropsitcph": 8049660118,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26979",
    "droptype": "D",
    "dropname": "LAUREL FORK",
    "dropdeladd": "14208 DANVILLE PIKE",
    "dropdelcty": "LAUREL FORK",
    "dropdelst": "VA",
    "dropdelzpp": 243523699,
    "dropphyadd": "14208 DANVILLE PIKE",
    "dropphycty": "LAUREL FORK",
    "dropphyst": "VA",
    "dropphyzpp": 243523699,
    "dropmaladd": "14208 DANVILLE PIKE",
    "dropmalcty": "LAUREL FORK",
    "dropmalst": "VA",
    "dropmalzpp": 243523699,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763982031,
    "dropfax": 2763982031
  },
  {
    "dcode": "D",
    "dropkey": "PX26980",
    "droptype": "D",
    "dropname": "LAWRENCEVILLE",
    "dropdeladd": "409 S HICKS ST",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 238689998,
    "dropphyadd": "409 S HICKS ST",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 238689998,
    "dropmaladd": "409 S HICKS ST",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 238689998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048482956,
    "dropsitcph": 4348482956,
    "dropfax": 4348480188
  },
  {
    "dcode": "D",
    "dropkey": "PX26984",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "304 W MAIN ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "VA",
    "dropdelzpp": 242669998,
    "dropphyadd": "304 W MAIN ST",
    "dropphycty": "LEBANON",
    "dropphyst": "VA",
    "dropphyzpp": 242669998,
    "dropmaladd": "304 W MAIN ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "VA",
    "dropmalzpp": 242669998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768891451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26991",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "25 CATOCTIN CIR SE",
    "dropdelcty": "LEESBURG",
    "dropdelst": "VA",
    "dropdelzpp": 201759998,
    "dropphyadd": "25 CATOCTIN CIR SE",
    "dropphycty": "LEESBURG",
    "dropphyst": "VA",
    "dropphyzpp": 201759998,
    "dropmaladd": "25 CATOCTIN CIR SE",
    "dropmalcty": "LEESBURG",
    "dropmalst": "VA",
    "dropmalzpp": 201759998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036693755,
    "dropsitcph": 7036693755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26996",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "101 LEE AVE",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 244509998,
    "dropphyadd": "101 LEE AVE",
    "dropphycty": "LEXINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 244509998,
    "dropmaladd": "101 LEE AVE",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 244509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5404636449,
    "dropsitcph": 5404636449,
    "dropfax": 5404635111
  },
  {
    "dcode": "D",
    "dropkey": "PX26997",
    "droptype": "D",
    "dropname": "LIGHTFOOT",
    "dropdeladd": "6376 RICHMOND RD",
    "dropdelcty": "LIGHTFOOT",
    "dropdelst": "VA",
    "dropdelzpp": 230909998,
    "dropphyadd": "6376 RICHMOND RD",
    "dropphycty": "LIGHTFOOT",
    "dropphyst": "VA",
    "dropphyzpp": 230909998,
    "dropmaladd": "6376 RICHMOND RD",
    "dropmalcty": "LIGHTFOOT",
    "dropmalst": "VA",
    "dropmalzpp": 230909998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7575652103,
    "dropsitcph": 7575652103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX26998",
    "droptype": "D",
    "dropname": "LIGNUM",
    "dropdeladd": "23395 LIGNUM RD",
    "dropdelcty": "LIGNUM",
    "dropdelst": "VA",
    "dropdelzpp": 227261939,
    "dropphyadd": "23395 LIGNUM RD",
    "dropphycty": "LIGNUM",
    "dropphyst": "VA",
    "dropphyzpp": 227261939,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIGNUM",
    "dropmalst": "VA",
    "dropmalzpp": 227269998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403991815,
    "dropsitcph": 5403991815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27003",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "13474 JOHN MARSHALL HWY",
    "dropdelcty": "LINDEN",
    "dropdelst": "VA",
    "dropdelzpp": 226429998,
    "dropphyadd": "13474 JOHN MARSHALL HWY",
    "dropphycty": "LINDEN",
    "dropphyst": "VA",
    "dropphyzpp": 226429998,
    "dropmaladd": "13474 JOHN MARSHALL HWY",
    "dropmalcty": "LINDEN",
    "dropmalst": "VA",
    "dropmalzpp": 226429998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406369936,
    "dropsitcph": 5406369936,
    "dropfax": 5406362381
  },
  {
    "dcode": "D",
    "dropkey": "PX27005",
    "droptype": "D",
    "dropname": "LINVILLE",
    "dropdeladd": "3754 LINVILLE EDOM RD",
    "dropdelcty": "LINVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 228349998,
    "dropphyadd": "3754 LINVILLE EDOM RD",
    "dropphycty": "LINVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 228349998,
    "dropmaladd": "3754 LINVILLE EDOM RD",
    "dropmalcty": "LINVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 228349998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408338068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27013",
    "droptype": "D",
    "dropname": "LIVELY",
    "dropdeladd": "5316 MARY BALL RD",
    "dropdelcty": "LIVELY",
    "dropdelst": "VA",
    "dropdelzpp": 225079998,
    "dropphyadd": "5316 MARY BALL RD",
    "dropphycty": "LIVELY",
    "dropphyst": "VA",
    "dropphyzpp": 225079998,
    "dropmaladd": "5316 MARY BALL RD",
    "dropmalcty": "LIVELY",
    "dropmalst": "VA",
    "dropmalzpp": 225079998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044625411,
    "dropsitcph": 8044625411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27015",
    "droptype": "D",
    "dropname": "LOCUST DALE",
    "dropdeladd": "1296 N JAMES MADISON HWY",
    "dropdelcty": "LOCUST DALE",
    "dropdelst": "VA",
    "dropdelzpp": 229489998,
    "dropphyadd": "1296 N JAMES MADISON HWY",
    "dropphycty": "LOCUST DALE",
    "dropphyst": "VA",
    "dropphyzpp": 229489998,
    "dropmaladd": "1296 N JAMES MADISON HWY",
    "dropmalcty": "LOCUST DALE",
    "dropmalst": "VA",
    "dropmalzpp": 229489998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5406729184,
    "dropfax": 5406729184
  },
  {
    "dcode": "D",
    "dropkey": "PX27017",
    "droptype": "D",
    "dropname": "LOCUST GROVE",
    "dropdeladd": "4447 GERMANNA HWY",
    "dropdelcty": "LOCUST GROVE",
    "dropdelst": "VA",
    "dropdelzpp": 225089998,
    "dropphyadd": "4447 GERMANNA HWY",
    "dropphycty": "LOCUST GROVE",
    "dropphyst": "VA",
    "dropphyzpp": 225089998,
    "dropmaladd": "4447 GERMANNA HWY",
    "dropmalcty": "LOCUST GROVE",
    "dropmalst": "VA",
    "dropmalzpp": 225089998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409722138,
    "dropsitcph": 5409722138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27019",
    "droptype": "D",
    "dropname": "LOCUST HILL",
    "dropdeladd": "5924 GENERAL PULLER HWY",
    "dropdelcty": "LOCUST HILL",
    "dropdelst": "VA",
    "dropdelzpp": 230929998,
    "dropphyadd": "5924 GENERAL PULLER HWY",
    "dropphycty": "LOCUST HILL",
    "dropphyst": "VA",
    "dropphyzpp": 230929998,
    "dropmaladd": "5924 GENERAL PULLER HWY",
    "dropmalcty": "LOCUST HILL",
    "dropmalst": "VA",
    "dropmalzpp": 230929998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047582792,
    "dropsitcph": 8047582792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27021",
    "droptype": "D",
    "dropname": "LOCUSTVILLE",
    "dropdeladd": "28033 DRUMMONDTOWN RD",
    "dropdelcty": "LOCUSTVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 234049998,
    "dropphyadd": "28033 DRUMMONDTOWN RD",
    "dropphycty": "LOCUSTVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 234049998,
    "dropmaladd": "28033 DRUMMONDTOWN RD",
    "dropmalcty": "LOCUSTVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 234049998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577877127,
    "dropsitcph": 7577877127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27024",
    "droptype": "D",
    "dropname": "LONG ISLAND",
    "dropdeladd": "102 PEAK PL",
    "dropdelcty": "LONG ISLAND",
    "dropdelst": "VA",
    "dropdelzpp": 245699998,
    "dropphyadd": "102 PEAK PL",
    "dropphycty": "LONG ISLAND",
    "dropphyst": "VA",
    "dropphyzpp": 245699998,
    "dropmaladd": "102 PEAK PL",
    "dropmalcty": "LONG ISLAND",
    "dropmalst": "VA",
    "dropmalzpp": 245699998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342835357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27027",
    "droptype": "D",
    "dropname": "LORTON",
    "dropdeladd": "7726 GUNSTON PLZ",
    "dropdelcty": "LORTON",
    "dropdelst": "VA",
    "dropdelzpp": 220799998,
    "dropphyadd": "7726 GUNSTON PLZ",
    "dropphycty": "LORTON",
    "dropphyst": "VA",
    "dropphyzpp": 220799998,
    "dropmaladd": "7726 GUNSTON PLZ",
    "dropmalcty": "LORTON",
    "dropmalst": "VA",
    "dropmalzpp": 220799998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033394874,
    "dropsitcph": 7033396374,
    "dropfax": 7033394169
  },
  {
    "dcode": "D",
    "dropkey": "PX27029",
    "droptype": "D",
    "dropname": "LOTTSBURG",
    "dropdeladd": "2217 NORTHUMBERLAND HWY",
    "dropdelcty": "LOTTSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 225119998,
    "dropphyadd": "2217 NORTHUMBERLAND HWY",
    "dropphycty": "LOTTSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 225119998,
    "dropmaladd": "2217 NORTHUMBERLAND HWY",
    "dropmalcty": "LOTTSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 225119998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045297936,
    "dropsitcph": 8045297936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27030",
    "droptype": "D",
    "dropname": "LOUISA",
    "dropdeladd": "204 W MAIN ST",
    "dropdelcty": "LOUISA",
    "dropdelst": "VA",
    "dropdelzpp": 230939998,
    "dropphyadd": "204 W MAIN ST",
    "dropphycty": "LOUISA",
    "dropphyst": "VA",
    "dropphyzpp": 230939998,
    "dropmaladd": "204 W MAIN ST",
    "dropmalcty": "LOUISA",
    "dropmalst": "VA",
    "dropmalzpp": 230939998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049670691,
    "dropsitcph": 5409670691,
    "dropfax": 5409675908
  },
  {
    "dcode": "D",
    "dropkey": "PX27031",
    "droptype": "D",
    "dropname": "LOVETTSVILLE",
    "dropdeladd": "15 N CHURCH ST",
    "dropdelcty": "LOVETTSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201809998,
    "dropphyadd": "15 N CHURCH ST",
    "dropphycty": "LOVETTSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201809998,
    "dropmaladd": "15 N CHURCH ST",
    "dropmalcty": "LOVETTSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201809998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408223835,
    "dropsitcph": 5408223835,
    "dropfax": 5408223067
  },
  {
    "dcode": "D",
    "dropkey": "PX27034",
    "droptype": "D",
    "dropname": "LOVINGSTON",
    "dropdeladd": "131 MAIN ST",
    "dropdelcty": "LOVINGSTON",
    "dropdelst": "VA",
    "dropdelzpp": 229499998,
    "dropphyadd": "131 MAIN ST",
    "dropphycty": "LOVINGSTON",
    "dropphyst": "VA",
    "dropphyzpp": 229499998,
    "dropmaladd": "131 MAIN ST",
    "dropmalcty": "LOVINGSTON",
    "dropmalst": "VA",
    "dropmalzpp": 229499998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342635216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27035",
    "droptype": "D",
    "dropname": "LOW MOOR",
    "dropdeladd": "105 OLD CHURCH RD",
    "dropdelcty": "LOW MOOR",
    "dropdelst": "VA",
    "dropdelzpp": 244579998,
    "dropphyadd": "105 OLD CHURCH RD",
    "dropphycty": "LOW MOOR",
    "dropphyst": "VA",
    "dropphyzpp": 244579998,
    "dropmaladd": "105 OLD CHURCH RD",
    "dropmalcty": "LOW MOOR",
    "dropmalst": "VA",
    "dropmalzpp": 244579998,
    "dropsitphn": 5407756336,
    "dropsitlph": 5408627150,
    "dropsitcph": 5408627150,
    "dropfax": 6505776050
  },
  {
    "dcode": "D",
    "dropkey": "PX27040",
    "droptype": "D",
    "dropname": "LOWRY",
    "dropdeladd": "3516 LOWRY RD",
    "dropdelcty": "LOWRY",
    "dropdelst": "VA",
    "dropdelzpp": 245709998,
    "dropphyadd": "3516 LOWRY RD",
    "dropphycty": "LOWRY",
    "dropphyst": "VA",
    "dropphyzpp": 245709998,
    "dropmaladd": "3516 LOWRY RD",
    "dropmalcty": "LOWRY",
    "dropmalst": "VA",
    "dropmalzpp": 245709998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405862959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27043",
    "droptype": "D",
    "dropname": "LUNENBURG",
    "dropdeladd": "11452 COURTHOUSE RD",
    "dropdelcty": "LUNENBURG",
    "dropdelst": "VA",
    "dropdelzpp": 239529998,
    "dropphyadd": "11452 COURTHOUSE RD",
    "dropphycty": "LUNENBURG",
    "dropphyst": "VA",
    "dropphyzpp": 239529998,
    "dropmaladd": "11452 COURTHOUSE RD",
    "dropmalcty": "LUNENBURG",
    "dropmalst": "VA",
    "dropmalzpp": 239529998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346963025,
    "dropsitcph": 4346963025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27044",
    "droptype": "D",
    "dropname": "LURAY",
    "dropdeladd": "102 S BROAD ST",
    "dropdelcty": "LURAY",
    "dropdelst": "VA",
    "dropdelzpp": 228359998,
    "dropphyadd": "102 S BROAD ST",
    "dropphycty": "LURAY",
    "dropphyst": "VA",
    "dropphyzpp": 228359998,
    "dropmaladd": "102 S BROAD ST",
    "dropmalcty": "LURAY",
    "dropmalst": "VA",
    "dropmalzpp": 228359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5407432100,
    "dropfax": 5407432390
  },
  {
    "dcode": "D",
    "dropkey": "PX27045",
    "droptype": "D",
    "dropname": "LYNCH STATION",
    "dropdeladd": "969 POWELL RD",
    "dropdelcty": "LYNCH STATION",
    "dropdelst": "VA",
    "dropdelzpp": 245719998,
    "dropphyadd": "969 POWELL RD",
    "dropphycty": "LYNCH STATION",
    "dropphyst": "VA",
    "dropphyzpp": 245719998,
    "dropmaladd": "969 POWELL RD",
    "dropmalcty": "LYNCH STATION",
    "dropmalst": "VA",
    "dropmalzpp": 245719998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343696230,
    "dropfax": 4343696230
  },
  {
    "dcode": "D",
    "dropkey": "PX27047",
    "droptype": "D",
    "dropname": "LYNCHBURG",
    "dropdeladd": "3300 ODD FELLOWS RD",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245069998,
    "dropphyadd": "3300 ODD FELLOWS RD",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245069998,
    "dropmaladd": "3300 ODD FELLOWS RD",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245069998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345288910,
    "dropfax": 4345288910
  },
  {
    "dcode": "D",
    "dropkey": "PX27048",
    "droptype": "D",
    "dropname": "LYNDHURST",
    "dropdeladd": "555 MT TORREY RD",
    "dropdelcty": "LYNDHURST",
    "dropdelst": "VA",
    "dropdelzpp": 229529998,
    "dropphyadd": "555 MT TORREY RD",
    "dropphycty": "LYNDHURST",
    "dropphyst": "VA",
    "dropphyzpp": 229529998,
    "dropmaladd": "555 MT TORREY RD",
    "dropmalcty": "LYNDHURST",
    "dropmalst": "VA",
    "dropmalzpp": 229529998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5409430531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27050",
    "droptype": "D",
    "dropname": "MACHIPONGO",
    "dropdeladd": "7414 MACHIPONGO DR",
    "dropdelcty": "MACHIPONGO",
    "dropdelst": "VA",
    "dropdelzpp": 234059998,
    "dropphyadd": "7414 MACHIPONGO DR",
    "dropphycty": "MACHIPONGO",
    "dropphyst": "VA",
    "dropphyzpp": 234059998,
    "dropmaladd": "7414 MACHIPONGO DR",
    "dropmalcty": "MACHIPONGO",
    "dropmalst": "VA",
    "dropmalzpp": 234059998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576787718,
    "dropsitcph": 7576787718,
    "dropfax": 7576780053
  },
  {
    "dcode": "D",
    "dropkey": "PX27052",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "1438 N MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "VA",
    "dropdelzpp": 227279998,
    "dropphyadd": "1438 N MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "VA",
    "dropphyzpp": 227279998,
    "dropmaladd": "1438 N MAIN ST",
    "dropmalcty": "MADISON",
    "dropmalst": "VA",
    "dropmalzpp": 227279998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409485702,
    "dropsitcph": 5409485702,
    "dropfax": 5409484336
  },
  {
    "dcode": "D",
    "dropkey": "PX27054",
    "droptype": "D",
    "dropname": "MADISON HEIGHTS",
    "dropdeladd": "158 LAKEVIEW DR",
    "dropdelcty": "MADISON HEIGHTS",
    "dropdelst": "VA",
    "dropdelzpp": 245729998,
    "dropphyadd": "158 LAKEVIEW DR",
    "dropphycty": "MADISON HEIGHTS",
    "dropphyst": "VA",
    "dropphyzpp": 245729998,
    "dropmaladd": "158 LAKEVIEW DR",
    "dropmalcty": "MADISON HEIGHTS",
    "dropmalst": "VA",
    "dropmalzpp": 245729998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4348455128,
    "dropfax": 4348477803
  },
  {
    "dcode": "D",
    "dropkey": "PX27061",
    "droptype": "D",
    "dropname": "MAIDENS",
    "dropdeladd": "2746 MAIDENS LOOP STE E",
    "dropdelcty": "MAIDENS",
    "dropdelst": "VA",
    "dropdelzpp": 231029998,
    "dropphyadd": "2746 MAIDENS LOOP STE E",
    "dropphycty": "MAIDENS",
    "dropphyst": "VA",
    "dropphyzpp": 231029998,
    "dropmaladd": "2746 MAIDENS LOOP STE E",
    "dropmalcty": "MAIDENS",
    "dropmalst": "VA",
    "dropmalzpp": 231029998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045566960,
    "dropsitcph": 8045566960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27065",
    "droptype": "D",
    "dropname": "MANAKIN SABOT",
    "dropdeladd": "334 RIVER RD W",
    "dropdelcty": "MANAKIN SABOT",
    "dropdelst": "VA",
    "dropdelzpp": 231039998,
    "dropphyadd": "334 RIVER RD W",
    "dropphycty": "MANAKIN SABOT",
    "dropphyst": "VA",
    "dropphyzpp": 231039998,
    "dropmaladd": "334 RIVER RD W",
    "dropmalcty": "MANAKIN SABOT",
    "dropmalst": "VA",
    "dropmalzpp": 231039998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047844114,
    "dropsitcph": 8047844114,
    "dropfax": 8047840247
  },
  {
    "dcode": "D",
    "dropkey": "PX27067",
    "droptype": "D",
    "dropname": "MANASSAS",
    "dropdeladd": "8801 SUDLEY RD",
    "dropdelcty": "MANASSAS",
    "dropdelst": "VA",
    "dropdelzpp": 201109998,
    "dropphyadd": "8801 SUDLEY RD",
    "dropphycty": "MANASSAS",
    "dropphyst": "VA",
    "dropphyzpp": 201109998,
    "dropmaladd": "8801 SUDLEY RD",
    "dropmalcty": "MANASSAS",
    "dropmalst": "VA",
    "dropmalzpp": 201109998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033682146,
    "dropsitcph": 7033682146,
    "dropfax": 7033614708
  },
  {
    "dcode": "D",
    "dropkey": "PX27072",
    "droptype": "D",
    "dropname": "MANNBORO",
    "dropdeladd": "3800 RICHMOND RD",
    "dropdelcty": "MANNBORO",
    "dropdelst": "VA",
    "dropdelzpp": 231059998,
    "dropphyadd": "3800 RICHMOND RD",
    "dropphycty": "MANNBORO",
    "dropphyst": "VA",
    "dropphyzpp": 231059998,
    "dropmaladd": "3800 RICHMOND RD",
    "dropmalcty": "MANNBORO",
    "dropmalst": "VA",
    "dropmalzpp": 231059998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045615000,
    "dropsitcph": 8045615000,
    "dropfax": 8045615000
  },
  {
    "dcode": "D",
    "dropkey": "PX27073",
    "droptype": "D",
    "dropname": "MANQUIN",
    "dropdeladd": "2171 RICHMOND TAPPAHANNOCK HWY",
    "dropdelcty": "MANQUIN",
    "dropdelst": "VA",
    "dropdelzpp": 231069998,
    "dropphyadd": "2171 RICHMOND TAPPAHANNOCK HWY",
    "dropphycty": "MANQUIN",
    "dropphyst": "VA",
    "dropphyzpp": 231069998,
    "dropmaladd": "2171 RICHMOND TAPPAHANNOCK HWY",
    "dropmalcty": "MANQUIN",
    "dropmalst": "VA",
    "dropmalzpp": 231069998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047693238,
    "dropsitcph": 8047693238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27075",
    "droptype": "D",
    "dropname": "MAPPSVILLE",
    "dropdeladd": "14148 LANKFORD HWY",
    "dropdelcty": "MAPPSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 234079998,
    "dropphyadd": "14148 LANKFORD HWY",
    "dropphycty": "MAPPSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 234079998,
    "dropmaladd": "14148 LANKFORD HWY",
    "dropmalcty": "MAPPSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 234079998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578245588,
    "dropsitcph": 7578245588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27080",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "200 PEARL AVE",
    "dropdelcty": "MARION",
    "dropdelst": "VA",
    "dropdelzpp": 243549998,
    "dropphyadd": "200 PEARL AVE",
    "dropphycty": "MARION",
    "dropphyst": "VA",
    "dropphyzpp": 243549998,
    "dropmaladd": "200 PEARL AVE",
    "dropmalcty": "MARION",
    "dropmalst": "VA",
    "dropmalzpp": 243549998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767835051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27081",
    "droptype": "D",
    "dropname": "MARIONVILLE",
    "dropdeladd": "9095 SEASIDE RD",
    "dropdelcty": "MARIONVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 234089998,
    "dropphyadd": "9095 SEASIDE RD",
    "dropphycty": "MARIONVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 234089998,
    "dropmaladd": "9095 SEASIDE RD",
    "dropmalcty": "MARIONVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 234089998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574426843,
    "dropsitcph": 7574426843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27084",
    "droptype": "D",
    "dropname": "MARKHAM",
    "dropdeladd": "11524 OLD MARKHAM RD",
    "dropdelcty": "MARKHAM",
    "dropdelst": "VA",
    "dropdelzpp": 226439998,
    "dropphyadd": "11524 OLD MARKHAM RD",
    "dropphycty": "MARKHAM",
    "dropphyst": "VA",
    "dropphyzpp": 226439998,
    "dropmaladd": "11524 OLD MARKHAM RD",
    "dropmalcty": "MARKHAM",
    "dropmalst": "VA",
    "dropmalzpp": 226439998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403641333,
    "dropsitcph": 5403641333,
    "dropfax": 5403644035
  },
  {
    "dcode": "D",
    "dropkey": "PX27086",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "8361 W MAIN ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "VA",
    "dropdelzpp": 201159998,
    "dropphyadd": "8361 W MAIN ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "VA",
    "dropphyzpp": 201159998,
    "dropmaladd": "8361 W MAIN ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "VA",
    "dropmalzpp": 201159998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5403649491,
    "dropsitcph": 5403649491,
    "dropfax": 5403644354
  },
  {
    "dcode": "D",
    "dropkey": "PX27087",
    "droptype": "D",
    "dropname": "MARTINSVILLE",
    "dropdeladd": "1123 SPRUCE ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241129998,
    "dropphyadd": "1123 SPRUCE ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241129998,
    "dropmaladd": "1123 SPRUCE ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241129998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766382702,
    "dropfax": 2766661145
  },
  {
    "dcode": "D",
    "dropkey": "PX27095",
    "droptype": "D",
    "dropname": "MATHEWS",
    "dropdeladd": "161 MAIN ST",
    "dropdelcty": "MATHEWS",
    "dropdelst": "VA",
    "dropdelzpp": 231099998,
    "dropphyadd": "161 MAIN ST",
    "dropphycty": "MATHEWS",
    "dropphyst": "VA",
    "dropphyzpp": 231099998,
    "dropmaladd": "161 MAIN ST",
    "dropmalcty": "MATHEWS",
    "dropmalst": "VA",
    "dropmalzpp": 231099998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047252630,
    "dropsitcph": 8047252630,
    "dropfax": 8047252630
  },
  {
    "dcode": "D",
    "dropkey": "PX27097",
    "droptype": "D",
    "dropname": "MATTAPONI",
    "dropdeladd": "6877 LEWIS B PULLER MEMORIAL HWY",
    "dropdelcty": "MATTAPONI",
    "dropdelst": "VA",
    "dropdelzpp": 231109998,
    "dropphyadd": "6877 LEWIS B PULLER MEMORIAL HWY",
    "dropphycty": "MATTAPONI",
    "dropphyst": "VA",
    "dropphyzpp": 231109998,
    "dropmaladd": "6877 LEWIS B PULLER MEMORIAL HWY",
    "dropmalcty": "MATTAPONI",
    "dropmalst": "VA",
    "dropmalzpp": 231109998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047852432,
    "dropsitcph": 8047852432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27098",
    "droptype": "D",
    "dropname": "MAURERTOWN",
    "dropdeladd": "24784 OLD VALLEY PIKE",
    "dropdelcty": "MAURERTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 226442658,
    "dropphyadd": "24784 OLD VALLEY PIKE",
    "dropphycty": "MAURERTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 226442658,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAURERTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 226449998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404401003,
    "dropsitcph": 5404401003,
    "dropfax": 5404363650
  },
  {
    "dcode": "D",
    "dropkey": "PX27100",
    "droptype": "D",
    "dropname": "MAVISDALE",
    "dropdeladd": "9170 GARDEN CREEK RD",
    "dropdelcty": "MAVISDALE",
    "dropdelst": "VA",
    "dropdelzpp": 246279998,
    "dropphyadd": "9170 GARDEN CREEK RD",
    "dropphycty": "MAVISDALE",
    "dropphyst": "VA",
    "dropphyzpp": 246279998,
    "dropmaladd": "9170 GARDEN CREEK RD",
    "dropmalcty": "MAVISDALE",
    "dropmalst": "VA",
    "dropmalzpp": 246279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2764984231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27101",
    "droptype": "D",
    "dropname": "MAX MEADOWS",
    "dropdeladd": "1427 RAMSEY MOUNTAIN RD",
    "dropdelcty": "MAX MEADOWS",
    "dropdelst": "VA",
    "dropdelzpp": 243609998,
    "dropphyadd": "1427 RAMSEY MOUNTAIN RD",
    "dropphycty": "MAX MEADOWS",
    "dropphyst": "VA",
    "dropphyzpp": 243609998,
    "dropmaladd": "1427 RAMSEY MOUNTAIN RD",
    "dropmalcty": "MAX MEADOWS",
    "dropmalst": "VA",
    "dropmalzpp": 243609998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766373761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27102",
    "droptype": "D",
    "dropname": "MAXIE",
    "dropdeladd": "1793 BULL CREEK RD",
    "dropdelcty": "MAXIE",
    "dropdelst": "VA",
    "dropdelzpp": 246289998,
    "dropphyadd": "1793 BULL CREEK RD",
    "dropphycty": "MAXIE",
    "dropphyst": "VA",
    "dropphyzpp": 246289998,
    "dropmaladd": "1793 BULL CREEK RD",
    "dropmalcty": "MAXIE",
    "dropmalst": "VA",
    "dropmalzpp": 246289998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765318587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27105",
    "droptype": "D",
    "dropname": "MC COY",
    "dropdeladd": "6100 CENTENNIAL RD",
    "dropdelcty": "MC COY",
    "dropdelst": "VA",
    "dropdelzpp": 241119998,
    "dropphyadd": "6100 CENTENNIAL RD",
    "dropphycty": "MC COY",
    "dropphyst": "VA",
    "dropphyzpp": 241119998,
    "dropmaladd": "6100 CENTENNIAL RD",
    "dropmalcty": "MC COY",
    "dropmalst": "VA",
    "dropmalzpp": 241119998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407314639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27106",
    "droptype": "D",
    "dropname": "MC DOWELL",
    "dropdeladd": "8988 HIGHLAND TPKE",
    "dropdelcty": "MC DOWELL",
    "dropdelst": "VA",
    "dropdelzpp": 244589998,
    "dropphyadd": "8988 HIGHLAND TPKE",
    "dropphycty": "MC DOWELL",
    "dropphyst": "VA",
    "dropphyzpp": 244589998,
    "dropmaladd": "8988 HIGHLAND TPKE",
    "dropmalcty": "MC DOWELL",
    "dropmalst": "VA",
    "dropmalzpp": 244589998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5403963491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27107",
    "droptype": "D",
    "dropname": "MC GAHEYSVILLE",
    "dropdeladd": "419 JACOB BURNER DR",
    "dropdelcty": "MC GAHEYSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 228409998,
    "dropphyadd": "419 JACOB BURNER DR",
    "dropphycty": "MC GAHEYSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 228409998,
    "dropmaladd": "419 JACOB BURNER DR",
    "dropmalcty": "MC GAHEYSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 228409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402895088,
    "dropsitcph": 5402895088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27111",
    "droptype": "D",
    "dropname": "MC KENNEY",
    "dropdeladd": "10504 RIVES AVE",
    "dropdelcty": "MC KENNEY",
    "dropdelst": "VA",
    "dropdelzpp": 238729998,
    "dropphyadd": "10504 RIVES AVE",
    "dropphycty": "MC KENNEY",
    "dropphyst": "VA",
    "dropphyzpp": 238729998,
    "dropmaladd": "10504 RIVES AVE",
    "dropmalcty": "MC KENNEY",
    "dropmalst": "VA",
    "dropmalzpp": 238729998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 8044784223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27112",
    "droptype": "D",
    "dropname": "MC LEAN",
    "dropdeladd": "6841 ELM ST",
    "dropdelcty": "MC LEAN",
    "dropdelst": "VA",
    "dropdelzpp": 221019998,
    "dropphyadd": "6841 ELM ST",
    "dropphycty": "MC LEAN",
    "dropphyst": "VA",
    "dropphyzpp": 221019998,
    "dropmaladd": "6841 ELM ST",
    "dropmalcty": "MC LEAN",
    "dropmalst": "VA",
    "dropmalzpp": 221019998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037346241,
    "dropsitcph": 7037346241,
    "dropfax": 7037619534
  },
  {
    "dcode": "D",
    "dropkey": "PX27122",
    "droptype": "D",
    "dropname": "MEADOWS OF DAN",
    "dropdeladd": "3561 JEB STUART HWY",
    "dropdelcty": "MEADOWS OF DAN",
    "dropdelst": "VA",
    "dropdelzpp": 241209998,
    "dropphyadd": "3561 JEB STUART HWY",
    "dropphycty": "MEADOWS OF DAN",
    "dropphyst": "VA",
    "dropphyzpp": 241209998,
    "dropmaladd": "3561 JEB STUART HWY",
    "dropmalcty": "MEADOWS OF DAN",
    "dropmalst": "VA",
    "dropmalzpp": 241209998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769522124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27123",
    "droptype": "D",
    "dropname": "MEADOWVIEW",
    "dropdeladd": "29063 WALKER LN",
    "dropdelcty": "MEADOWVIEW",
    "dropdelst": "VA",
    "dropdelzpp": 243613725,
    "dropphyadd": "29063 WALKER LN",
    "dropphycty": "MEADOWVIEW",
    "dropphyst": "VA",
    "dropphyzpp": 243613725,
    "dropmaladd": "29063 WALKER LN",
    "dropmalcty": "MEADOWVIEW",
    "dropmalst": "VA",
    "dropmalzpp": 243613725,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769443081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27127",
    "droptype": "D",
    "dropname": "MECHANICSVILLE",
    "dropdeladd": "8050 MECHANICSVILLE TPKE",
    "dropdelcty": "MECHANICSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 231119998,
    "dropphyadd": "8050 MECHANICSVILLE TPKE",
    "dropphycty": "MECHANICSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 231119998,
    "dropmaladd": "8050 MECHANICSVILLE TPKE",
    "dropmalcty": "MECHANICSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 231119998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047751653,
    "dropsitcph": 8045591653,
    "dropfax": 8047463503
  },
  {
    "dcode": "D",
    "dropkey": "PX27133",
    "droptype": "D",
    "dropname": "MEHERRIN",
    "dropdeladd": "495 MOORES ORDINARY RD",
    "dropdelcty": "MEHERRIN",
    "dropdelst": "VA",
    "dropdelzpp": 239549998,
    "dropphyadd": "495 MOORES ORDINARY RD",
    "dropphycty": "MEHERRIN",
    "dropphyst": "VA",
    "dropphyzpp": 239549998,
    "dropmaladd": "495 MOORES ORDINARY RD",
    "dropmalcty": "MEHERRIN",
    "dropmalst": "VA",
    "dropmalzpp": 239549998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347368937,
    "dropsitcph": 4347368937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27134",
    "droptype": "D",
    "dropname": "MELFA",
    "dropdeladd": "19268 AIRPORT DR",
    "dropdelcty": "MELFA",
    "dropdelst": "VA",
    "dropdelzpp": 234103369,
    "dropphyadd": "19268 AIRPORT DR",
    "dropphycty": "MELFA",
    "dropphyst": "VA",
    "dropphyzpp": 234103369,
    "dropmaladd": "19268 AIRPORT DR",
    "dropmalcty": "MELFA",
    "dropmalst": "VA",
    "dropmalzpp": 234103369,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577874922,
    "dropsitcph": 7577874922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27138",
    "droptype": "D",
    "dropname": "MENDOTA",
    "dropdeladd": "2543 MENDOTA RD",
    "dropdelcty": "MENDOTA",
    "dropdelst": "VA",
    "dropdelzpp": 242709998,
    "dropphyadd": "2543 MENDOTA RD",
    "dropphycty": "MENDOTA",
    "dropphyst": "VA",
    "dropphyzpp": 242709998,
    "dropmaladd": "2543 MENDOTA RD",
    "dropmalcty": "MENDOTA",
    "dropmalst": "VA",
    "dropmalzpp": 242709998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764662877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27139",
    "droptype": "D",
    "dropname": "MEREDITHVILLE",
    "dropdeladd": "4771 BOYDTON PLANK RD",
    "dropdelcty": "MEREDITHVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 238739998,
    "dropphyadd": "4771 BOYDTON PLANK RD",
    "dropphycty": "MEREDITHVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 238739998,
    "dropmaladd": "4771 BOYDTON PLANK RD",
    "dropmalcty": "MEREDITHVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 238739998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349497405,
    "dropsitcph": 4349497405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27145",
    "droptype": "D",
    "dropname": "MERRY POINT",
    "dropdeladd": "2717 MERRY POINT RD",
    "dropdelcty": "MERRY POINT",
    "dropdelst": "VA",
    "dropdelzpp": 225139998,
    "dropphyadd": "2717 MERRY POINT RD",
    "dropphycty": "MERRY POINT",
    "dropphyst": "VA",
    "dropphyzpp": 225139998,
    "dropmaladd": "2717 MERRY POINT RD",
    "dropmalcty": "MERRY POINT",
    "dropmalst": "VA",
    "dropmalzpp": 225139998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044620096,
    "dropsitcph": 8044620096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27149",
    "droptype": "D",
    "dropname": "MIDDLEBROOK",
    "dropdeladd": "3696 MIDDLEBROOK VILLAGE RD",
    "dropdelcty": "MIDDLEBROOK",
    "dropdelst": "VA",
    "dropdelzpp": 244599998,
    "dropphyadd": "3696 MIDDLEBROOK VILLAGE RD",
    "dropphycty": "MIDDLEBROOK",
    "dropphyst": "VA",
    "dropphyzpp": 244599998,
    "dropmaladd": "3696 MIDDLEBROOK VILLAGE RD",
    "dropmalcty": "MIDDLEBROOK",
    "dropmalst": "VA",
    "dropmalzpp": 244599998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408852041,
    "dropsitcph": 5408852041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27150",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "113 W WASHINGTON ST",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "VA",
    "dropdelzpp": 201179998,
    "dropphyadd": "113 W WASHINGTON ST",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "VA",
    "dropphyzpp": 201179998,
    "dropmaladd": "113 W WASHINGTON ST",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "VA",
    "dropmalzpp": 201179998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406876598,
    "dropsitcph": 5406876598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27151",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "7922 MAIN ST",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "VA",
    "dropdelzpp": 226459998,
    "dropphyadd": "7922 MAIN ST",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "VA",
    "dropphyzpp": 226459998,
    "dropmaladd": "7922 MAIN ST",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "VA",
    "dropmalzpp": 226459998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408691627,
    "dropsitcph": 5408691627,
    "dropfax": 5408697995
  },
  {
    "dcode": "D",
    "dropkey": "PX27153",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "5473 MIDLAND RD",
    "dropdelcty": "MIDLAND",
    "dropdelst": "VA",
    "dropdelzpp": 227289998,
    "dropphyadd": "5473 MIDLAND RD",
    "dropphycty": "MIDLAND",
    "dropphyst": "VA",
    "dropphyzpp": 227289998,
    "dropmaladd": "5473 MIDLAND RD",
    "dropmalcty": "MIDLAND",
    "dropmalst": "VA",
    "dropmalzpp": 227289998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404398969,
    "dropsitcph": 5404398969,
    "dropfax": 5404398969
  },
  {
    "dcode": "D",
    "dropkey": "PX27154",
    "droptype": "D",
    "dropname": "MIDLOTHIAN",
    "dropdeladd": "1201 SYCAMORE SQUARE DR",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "VA",
    "dropdelzpp": 231139998,
    "dropphyadd": "1201 SYCAMORE SQUARE DR",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "VA",
    "dropphyzpp": 231139998,
    "dropmaladd": "1201 SYCAMORE SQUARE DR",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "VA",
    "dropmalzpp": 231139998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047941374,
    "dropsitcph": 8047941374,
    "dropfax": 8047947426
  },
  {
    "dcode": "D",
    "dropkey": "PX27159",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "15429 ANTIOCH RD",
    "dropdelcty": "MILFORD",
    "dropdelst": "VA",
    "dropdelzpp": 225149998,
    "dropphyadd": "15429 ANTIOCH RD",
    "dropphycty": "MILFORD",
    "dropphyst": "VA",
    "dropphyzpp": 225149998,
    "dropmaladd": "15429 ANTIOCH RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "VA",
    "dropmalzpp": 225149998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046337076,
    "dropsitcph": 8046337076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27162",
    "droptype": "D",
    "dropname": "MILLBORO",
    "dropdeladd": "142 MAIN ST",
    "dropdelcty": "MILLBORO",
    "dropdelst": "VA",
    "dropdelzpp": 244609998,
    "dropphyadd": "142 MAIN ST",
    "dropphycty": "MILLBORO",
    "dropphyst": "VA",
    "dropphyzpp": 244609998,
    "dropmaladd": "142 MAIN ST",
    "dropmalcty": "MILLBORO",
    "dropmalst": "VA",
    "dropmalzpp": 244609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409975373,
    "dropsitcph": 5409975373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27172",
    "droptype": "D",
    "dropname": "MILLERS TAVERN",
    "dropdeladd": "6908 RICHMOND HWY",
    "dropdelcty": "MILLERS TAVERN",
    "dropdelst": "VA",
    "dropdelzpp": 231159998,
    "dropphyadd": "6908 RICHMOND HWY",
    "dropphycty": "MILLERS TAVERN",
    "dropphyst": "VA",
    "dropphyzpp": 231159998,
    "dropmaladd": "6908 RICHMOND HWY",
    "dropmalcty": "MILLERS TAVERN",
    "dropmalst": "VA",
    "dropmalzpp": 231159998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044432438,
    "dropsitcph": 8044432438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27175",
    "droptype": "D",
    "dropname": "MILLWOOD",
    "dropdeladd": "2009 MILLWOOD RD",
    "dropdelcty": "MILLWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 226469901,
    "dropphyadd": "2009 MILLWOOD RD",
    "dropphycty": "MILLWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 226469901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 226469998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408372395,
    "dropsitcph": 5408372395,
    "dropfax": 5408372369
  },
  {
    "dcode": "D",
    "dropkey": "PX27177",
    "droptype": "D",
    "dropname": "MINERAL",
    "dropdeladd": "512 MINERAL AVE",
    "dropdelcty": "MINERAL",
    "dropdelst": "VA",
    "dropdelzpp": 231179998,
    "dropphyadd": "512 MINERAL AVE",
    "dropphycty": "MINERAL",
    "dropphyst": "VA",
    "dropphyzpp": 231179998,
    "dropmaladd": "512 MINERAL AVE",
    "dropmalcty": "MINERAL",
    "dropmalst": "VA",
    "dropmalzpp": 231179998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048944410,
    "dropsitcph": 5408944410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27179",
    "droptype": "D",
    "dropname": "MINT SPRING",
    "dropdeladd": "2069 LEE JACKSON HWY",
    "dropdelcty": "MINT SPRING",
    "dropdelst": "VA",
    "dropdelzpp": 244639900,
    "dropphyadd": "2069 LEE JACKSON HWY",
    "dropphycty": "MINT SPRING",
    "dropphyst": "VA",
    "dropphyzpp": 244639900,
    "dropmaladd": "2069 LEE JACKSON HWY",
    "dropmalcty": "MINT SPRING",
    "dropmalst": "VA",
    "dropmalzpp": 244639900,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403374043,
    "dropsitcph": 5403374043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27181",
    "droptype": "D",
    "dropname": "MITCHELLS",
    "dropdeladd": "11320 MITCHELL RD",
    "dropdelcty": "MITCHELLS",
    "dropdelst": "VA",
    "dropdelzpp": 227299997,
    "dropphyadd": "11320 MITCHELL RD",
    "dropphycty": "MITCHELLS",
    "dropphyst": "VA",
    "dropphyzpp": 227299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MITCHELLS",
    "dropmalst": "VA",
    "dropmalzpp": 227299998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408256439,
    "dropsitcph": 5408256439,
    "dropfax": 5408256439
  },
  {
    "dcode": "D",
    "dropkey": "PX27188",
    "droptype": "D",
    "dropname": "MOLLUSK",
    "dropdeladd": "7377 RIVER RD",
    "dropdelcty": "MOLLUSK",
    "dropdelst": "VA",
    "dropdelzpp": 225179998,
    "dropphyadd": "7377 RIVER RD",
    "dropphycty": "MOLLUSK",
    "dropphyst": "VA",
    "dropphyzpp": 225179998,
    "dropmaladd": "7377 RIVER RD",
    "dropmalcty": "MOLLUSK",
    "dropmalst": "VA",
    "dropmalzpp": 225179998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044625796,
    "dropsitcph": 8044625796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27189",
    "droptype": "D",
    "dropname": "MONETA",
    "dropdeladd": "14211 MONETA RD",
    "dropdelcty": "MONETA",
    "dropdelst": "VA",
    "dropdelzpp": 241219998,
    "dropphyadd": "14211 MONETA RD",
    "dropphycty": "MONETA",
    "dropphyst": "VA",
    "dropphyzpp": 241219998,
    "dropmaladd": "14211 MONETA RD",
    "dropmalcty": "MONETA",
    "dropmalst": "VA",
    "dropmalzpp": 241219998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402975311,
    "dropfax": 5402975545
  },
  {
    "dcode": "D",
    "dropkey": "PX27190",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "3378 S AMHERST HWY",
    "dropdelcty": "MONROE",
    "dropdelst": "VA",
    "dropdelzpp": 245749998,
    "dropphyadd": "3378 S AMHERST HWY",
    "dropphycty": "MONROE",
    "dropphyst": "VA",
    "dropphyzpp": 245749998,
    "dropmaladd": "3378 S AMHERST HWY",
    "dropmalcty": "MONROE",
    "dropmalst": "VA",
    "dropmalzpp": 245749998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342096570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27192",
    "droptype": "D",
    "dropname": "MONTEBELLO",
    "dropdeladd": "15048 CRABTREE FALLS HWY",
    "dropdelcty": "MONTEBELLO",
    "dropdelst": "VA",
    "dropdelzpp": 244649998,
    "dropphyadd": "15048 CRABTREE FALLS HWY",
    "dropphycty": "MONTEBELLO",
    "dropphyst": "VA",
    "dropphyzpp": 244649998,
    "dropmaladd": "15048 CRABTREE FALLS HWY",
    "dropmalcty": "MONTEBELLO",
    "dropmalst": "VA",
    "dropmalzpp": 244649998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403779218,
    "dropsitcph": 5403779218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27193",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "66 E MAIN ST",
    "dropdelcty": "MONTEREY",
    "dropdelst": "VA",
    "dropdelzpp": 244652000,
    "dropphyadd": "66 E MAIN ST",
    "dropphycty": "MONTEREY",
    "dropphyst": "VA",
    "dropphyzpp": 244652000,
    "dropmaladd": "66 E MAIN ST",
    "dropmalcty": "MONTEREY",
    "dropmalst": "VA",
    "dropmalzpp": 244652000,
    "dropsitphn": 8047756336,
    "dropsitlph": 5404682587,
    "dropsitcph": 5404682587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27199",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "17132 MOUNTAIN RD",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "VA",
    "dropdelzpp": 231929998,
    "dropphyadd": "17132 MOUNTAIN RD",
    "dropphycty": "MONTPELIER",
    "dropphyst": "VA",
    "dropphyzpp": 231929998,
    "dropmaladd": "17132 MOUNTAIN RD",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "VA",
    "dropmalzpp": 231929998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048836340,
    "dropsitcph": 8048836340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27200",
    "droptype": "D",
    "dropname": "MONTPELIER STATION",
    "dropdeladd": "11350 CONSTITUTION HWY",
    "dropdelcty": "MONTPELIER STATION",
    "dropdelst": "VA",
    "dropdelzpp": 229579998,
    "dropphyadd": "11350 CONSTITUTION HWY",
    "dropphycty": "MONTPELIER STATION",
    "dropphyst": "VA",
    "dropphyzpp": 229579998,
    "dropmaladd": "11350 CONSTITUTION HWY",
    "dropmalcty": "MONTPELIER STATION",
    "dropmalst": "VA",
    "dropmalzpp": 229579998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5406722269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27204",
    "droptype": "D",
    "dropname": "MONTROSS",
    "dropdeladd": "15917 KINGS HWY",
    "dropdelcty": "MONTROSS",
    "dropdelst": "VA",
    "dropdelzpp": 225209998,
    "dropphyadd": "15917 KINGS HWY",
    "dropphycty": "MONTROSS",
    "dropphyst": "VA",
    "dropphyzpp": 225209998,
    "dropmaladd": "15917 KINGS HWY",
    "dropmalcty": "MONTROSS",
    "dropmalst": "VA",
    "dropmalzpp": 225209998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044937351,
    "dropsitcph": 8044937351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27205",
    "droptype": "D",
    "dropname": "MONTVALE",
    "dropdeladd": "11345 W LYNCHBURG SALEM TPKE",
    "dropdelcty": "MONTVALE",
    "dropdelst": "VA",
    "dropdelzpp": 241229998,
    "dropphyadd": "11345 W LYNCHBURG SALEM TPKE",
    "dropphycty": "MONTVALE",
    "dropphyst": "VA",
    "dropphyzpp": 241229998,
    "dropmaladd": "11345 W LYNCHBURG SALEM TPKE",
    "dropmalcty": "MONTVALE",
    "dropmalst": "VA",
    "dropmalzpp": 241229998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409472311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27206",
    "droptype": "D",
    "dropname": "MOON",
    "dropdeladd": "184 HAVEN BEACH RD",
    "dropdelcty": "MOON",
    "dropdelst": "VA",
    "dropdelzpp": 231199998,
    "dropphyadd": "184 HAVEN BEACH RD",
    "dropphycty": "MOON",
    "dropphyst": "VA",
    "dropphyzpp": 231199998,
    "dropmaladd": "184 HAVEN BEACH RD",
    "dropmalcty": "MOON",
    "dropmalst": "VA",
    "dropmalzpp": 231199998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047252463,
    "dropsitcph": 8047252463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27207",
    "droptype": "D",
    "dropname": "MORATTICO",
    "dropdeladd": "6569 MORATTICO RD",
    "dropdelcty": "MORATTICO",
    "dropdelst": "VA",
    "dropdelzpp": 225239998,
    "dropphyadd": "6569 MORATTICO RD",
    "dropphycty": "MORATTICO",
    "dropphyst": "VA",
    "dropphyzpp": 225239998,
    "dropmaladd": "6569 MORATTICO RD",
    "dropmalcty": "MORATTICO",
    "dropmalst": "VA",
    "dropmalzpp": 225239998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044620175,
    "dropsitcph": 8044620175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27210",
    "droptype": "D",
    "dropname": "MOSELEY",
    "dropdeladd": "21431 HULL STREET RD",
    "dropdelcty": "MOSELEY",
    "dropdelst": "VA",
    "dropdelzpp": 231209998,
    "dropphyadd": "21431 HULL STREET RD",
    "dropphycty": "MOSELEY",
    "dropphyst": "VA",
    "dropphyzpp": 231209998,
    "dropmaladd": "21431 HULL STREET RD",
    "dropmalcty": "MOSELEY",
    "dropmalst": "VA",
    "dropmalzpp": 231209998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046395457,
    "dropsitcph": 8046395457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27211",
    "droptype": "D",
    "dropname": "MOUNT CRAWFORD",
    "dropdeladd": "411 N MAIN ST",
    "dropdelcty": "MOUNT CRAWFORD",
    "dropdelst": "VA",
    "dropdelzpp": 228419998,
    "dropphyadd": "411 N MAIN ST",
    "dropphycty": "MOUNT CRAWFORD",
    "dropphyst": "VA",
    "dropphyzpp": 228419998,
    "dropmaladd": "411 N MAIN ST",
    "dropmalcty": "MOUNT CRAWFORD",
    "dropmalst": "VA",
    "dropmalzpp": 228419998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5405744436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27212",
    "droptype": "D",
    "dropname": "MOUNT HOLLY",
    "dropdeladd": "4375 COPLE HWY",
    "dropdelcty": "MOUNT HOLLY",
    "dropdelst": "VA",
    "dropdelzpp": 225249998,
    "dropphyadd": "4375 COPLE HWY",
    "dropphycty": "MOUNT HOLLY",
    "dropphyst": "VA",
    "dropphyzpp": 225249998,
    "dropmaladd": "4375 COPLE HWY",
    "dropmalcty": "MOUNT HOLLY",
    "dropmalst": "VA",
    "dropmalzpp": 225249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044722350,
    "dropsitcph": 8044722350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27213",
    "droptype": "D",
    "dropname": "MOUNT JACKSON",
    "dropdeladd": "5240 MAIN ST",
    "dropdelcty": "MOUNT JACKSON",
    "dropdelst": "VA",
    "dropdelzpp": 228429998,
    "dropphyadd": "5240 MAIN ST",
    "dropphycty": "MOUNT JACKSON",
    "dropphyst": "VA",
    "dropphyzpp": 228429998,
    "dropmaladd": "5240 MAIN ST",
    "dropmalcty": "MOUNT JACKSON",
    "dropmalst": "VA",
    "dropmalzpp": 228429998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5404768002,
    "dropfax": 5404772962
  },
  {
    "dcode": "D",
    "dropkey": "PX27214",
    "droptype": "D",
    "dropname": "MOUNT SIDNEY",
    "dropdeladd": "2349 LEE HWY",
    "dropdelcty": "MOUNT SIDNEY",
    "dropdelst": "VA",
    "dropdelzpp": 244679998,
    "dropphyadd": "2349 LEE HWY",
    "dropphycty": "MOUNT SIDNEY",
    "dropphyst": "VA",
    "dropphyzpp": 244679998,
    "dropmaladd": "2349 LEE HWY",
    "dropmalcty": "MOUNT SIDNEY",
    "dropmalst": "VA",
    "dropmalzpp": 244679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402488564,
    "dropsitcph": 5402488564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27215",
    "droptype": "D",
    "dropname": "MOUNT SOLON",
    "dropdeladd": "885 NATURAL CHIMNEYS RD",
    "dropdelcty": "MOUNT SOLON",
    "dropdelst": "VA",
    "dropdelzpp": 228439998,
    "dropphyadd": "885 NATURAL CHIMNEYS RD",
    "dropphycty": "MOUNT SOLON",
    "dropphyst": "VA",
    "dropphyzpp": 228439998,
    "dropmaladd": "885 NATURAL CHIMNEYS RD",
    "dropmalcty": "MOUNT SOLON",
    "dropmalst": "VA",
    "dropmalzpp": 228439998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5403502122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27216",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "3500T MOUNT VERNON MEMORIAL HWY",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "VA",
    "dropdelzpp": 221219998,
    "dropphyadd": "3500T MOUNT VERNON MEMORIAL HWY",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "VA",
    "dropphyzpp": 221219998,
    "dropmaladd": "3500T MOUNT VERNON MEMORIAL HWY",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "VA",
    "dropmalzpp": 221219998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037805961,
    "dropsitcph": 7037805961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27220",
    "droptype": "D",
    "dropname": "MOUTH OF WILSON",
    "dropdeladd": "700 TROUTDALE HWY",
    "dropdelcty": "MOUTH OF WILSON",
    "dropdelst": "VA",
    "dropdelzpp": 243639998,
    "dropphyadd": "700 TROUTDALE HWY",
    "dropphycty": "MOUTH OF WILSON",
    "dropphyst": "VA",
    "dropphyzpp": 243639998,
    "dropmaladd": "700 TROUTDALE HWY",
    "dropmalcty": "MOUTH OF WILSON",
    "dropmalst": "VA",
    "dropmalzpp": 243639998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2765797482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27222",
    "droptype": "D",
    "dropname": "MERRIFIELD",
    "dropdeladd": "8409 LEE HWY",
    "dropdelcty": "MERRIFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 221169998,
    "dropphyadd": "8409 LEE HWY",
    "dropphycty": "MERRIFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 221169998,
    "dropmaladd": "8409 LEE HWY",
    "dropmalcty": "MERRIFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 221169998,
    "dropsitphn": 7036986377,
    "dropsitlph": 7036986377,
    "dropsitcph": 7036986377,
    "dropfax": 7032043040
  },
  {
    "dcode": "D",
    "dropkey": "PX27234",
    "droptype": "D",
    "dropname": "NARROWS",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "NARROWS",
    "dropdelst": "VA",
    "dropdelzpp": 241249998,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "NARROWS",
    "dropphyst": "VA",
    "dropphyzpp": 241249998,
    "dropmaladd": "305 MAIN ST",
    "dropmalcty": "NARROWS",
    "dropmalst": "VA",
    "dropmalzpp": 241249998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5403583010,
    "dropsitcph": 5403583010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27235",
    "droptype": "D",
    "dropname": "NARUNA",
    "dropdeladd": "438 WHIPPING CREEK RD",
    "dropdelcty": "NARUNA",
    "dropdelst": "VA",
    "dropdelzpp": 245769998,
    "dropphyadd": "438 WHIPPING CREEK RD",
    "dropphycty": "NARUNA",
    "dropphyst": "VA",
    "dropphyzpp": 245769998,
    "dropmaladd": "438 WHIPPING CREEK RD",
    "dropmalcty": "NARUNA",
    "dropmalst": "VA",
    "dropmalzpp": 245769998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343765355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27238",
    "droptype": "D",
    "dropname": "NASSAWADOX",
    "dropdeladd": "10238 ROGERS RD",
    "dropdelcty": "NASSAWADOX",
    "dropdelst": "VA",
    "dropdelzpp": 234139998,
    "dropphyadd": "10238 ROGERS RD",
    "dropphycty": "NASSAWADOX",
    "dropphyst": "VA",
    "dropphyzpp": 234139998,
    "dropmaladd": "10238 ROGERS RD",
    "dropmalcty": "NASSAWADOX",
    "dropmalst": "VA",
    "dropmalzpp": 234139998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574427190,
    "dropsitcph": 5404016302,
    "dropfax": 4345814552
  },
  {
    "dcode": "D",
    "dropkey": "PX27239",
    "droptype": "D",
    "dropname": "NATHALIE",
    "dropdeladd": "1031 VOLENS RD",
    "dropdelcty": "NATHALIE",
    "dropdelst": "VA",
    "dropdelzpp": 245779998,
    "dropphyadd": "1031 VOLENS RD",
    "dropphycty": "NATHALIE",
    "dropphyst": "VA",
    "dropphyzpp": 245779998,
    "dropmaladd": "1031 VOLENS RD",
    "dropmalcty": "NATHALIE",
    "dropmalst": "VA",
    "dropmalzpp": 245779998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343496274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27245",
    "droptype": "D",
    "dropname": "NATURAL BRIDGE",
    "dropdeladd": "6477 S LEE HWY",
    "dropdelcty": "NATURAL BRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 245789998,
    "dropphyadd": "6477 S LEE HWY",
    "dropphycty": "NATURAL BRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 245789998,
    "dropmaladd": "6477 S LEE HWY",
    "dropmalcty": "NATURAL BRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 245789998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402911895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27246",
    "droptype": "D",
    "dropname": "NATURAL BRIDGE STATION",
    "dropdeladd": "1482 WERT FULKNER HWY",
    "dropdelcty": "NATURAL BRIDGE STATION",
    "dropdelst": "VA",
    "dropdelzpp": 245799998,
    "dropphyadd": "1482 WERT FULKNER HWY",
    "dropphycty": "NATURAL BRIDGE STATION",
    "dropphyst": "VA",
    "dropphyzpp": 245799998,
    "dropmaladd": "1482 WERT FULKNER HWY",
    "dropmalcty": "NATURAL BRIDGE STATION",
    "dropmalst": "VA",
    "dropmalzpp": 245799998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402912105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27267",
    "droptype": "D",
    "dropname": "NELLYSFORD",
    "dropdeladd": "2663 ROCKFISH VALLEY HWY",
    "dropdelcty": "NELLYSFORD",
    "dropdelst": "VA",
    "dropdelzpp": 229589998,
    "dropphyadd": "2663 ROCKFISH VALLEY HWY",
    "dropphycty": "NELLYSFORD",
    "dropphyst": "VA",
    "dropphyzpp": 229589998,
    "dropmaladd": "2663 ROCKFISH VALLEY HWY",
    "dropmalcty": "NELLYSFORD",
    "dropmalst": "VA",
    "dropmalzpp": 229589998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4343612247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27268",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "1868 HIGHWAY 49",
    "dropdelcty": "NELSON",
    "dropdelst": "VA",
    "dropdelzpp": 245809998,
    "dropphyadd": "1868 HIGHWAY 49",
    "dropphycty": "NELSON",
    "dropphyst": "VA",
    "dropphyzpp": 245809998,
    "dropmaladd": "1868 HIGHWAY 49",
    "dropmalcty": "NELSON",
    "dropmalst": "VA",
    "dropmalzpp": 245809998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343742038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27269",
    "droptype": "D",
    "dropname": "NELSONIA",
    "dropdeladd": "16150 LANKFORD HWY",
    "dropdelcty": "NELSONIA",
    "dropdelst": "VA",
    "dropdelzpp": 234149998,
    "dropphyadd": "16150 LANKFORD HWY",
    "dropphycty": "NELSONIA",
    "dropphyst": "VA",
    "dropphyzpp": 234149998,
    "dropmaladd": "16150 LANKFORD HWY",
    "dropmalcty": "NELSONIA",
    "dropmalst": "VA",
    "dropmalzpp": 234149998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576655401,
    "dropsitcph": 7576655401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27272",
    "droptype": "D",
    "dropname": "NEW CANTON",
    "dropdeladd": "3708 C G WOODSON RD",
    "dropdelcty": "NEW CANTON",
    "dropdelst": "VA",
    "dropdelzpp": 231239998,
    "dropphyadd": "3708 C G WOODSON RD",
    "dropphycty": "NEW CANTON",
    "dropphyst": "VA",
    "dropphyzpp": 231239998,
    "dropmaladd": "3708 C G WOODSON RD",
    "dropmalcty": "NEW CANTON",
    "dropmalst": "VA",
    "dropmalzpp": 231239998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045813005,
    "dropsitcph": 4345813005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27273",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "283 MAIN ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "VA",
    "dropdelzpp": 241279998,
    "dropphyadd": "283 MAIN ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "VA",
    "dropphyzpp": 241279998,
    "dropmaladd": "283 MAIN ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "VA",
    "dropmalzpp": 241279998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5408645253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27275",
    "droptype": "D",
    "dropname": "NEW CHURCH",
    "dropdeladd": "4136 LANKFORD HWY",
    "dropdelcty": "NEW CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 234159998,
    "dropphyadd": "4136 LANKFORD HWY",
    "dropphycty": "NEW CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 234159998,
    "dropmaladd": "4136 LANKFORD HWY",
    "dropmalcty": "NEW CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 234159998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578245418,
    "dropsitcph": 7578245418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27276",
    "droptype": "D",
    "dropname": "NEW HOPE",
    "dropdeladd": "610 BATTLEFIELD RD",
    "dropdelcty": "NEW HOPE",
    "dropdelst": "VA",
    "dropdelzpp": 244699998,
    "dropphyadd": "610 BATTLEFIELD RD",
    "dropphycty": "NEW HOPE",
    "dropphyst": "VA",
    "dropphyzpp": 244699998,
    "dropmaladd": "610 BATTLEFIELD RD",
    "dropmalcty": "NEW HOPE",
    "dropmalst": "VA",
    "dropmalzpp": 244699998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403635863,
    "dropsitcph": 5403635863,
    "dropfax": 5403635863
  },
  {
    "dcode": "D",
    "dropkey": "PX27277",
    "droptype": "D",
    "dropname": "NEW KENT",
    "dropdeladd": "12109 NEW KENT HWY",
    "dropdelcty": "NEW KENT",
    "dropdelst": "VA",
    "dropdelzpp": 231249907,
    "dropphyadd": "12109 NEW KENT HWY",
    "dropphycty": "NEW KENT",
    "dropphyst": "VA",
    "dropphyzpp": 231249907,
    "dropmaladd": "12109 NEW KENT HWY",
    "dropmalcty": "NEW KENT",
    "dropmalst": "VA",
    "dropmalzpp": 231249907,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049660062,
    "dropsitcph": 8049660062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27278",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "9444 JOHN SEVIER RD",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "VA",
    "dropdelzpp": 228449998,
    "dropphyadd": "9444 JOHN SEVIER RD",
    "dropphycty": "NEW MARKET",
    "dropphyst": "VA",
    "dropphyzpp": 228449998,
    "dropmaladd": "9444 JOHN SEVIER RD",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "VA",
    "dropmalzpp": 228449998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5407402686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27279",
    "droptype": "D",
    "dropname": "NEW POINT",
    "dropdeladd": "393 SAND BANK RD",
    "dropdelcty": "NEW POINT",
    "dropdelst": "VA",
    "dropdelzpp": 231259998,
    "dropphyadd": "393 SAND BANK RD",
    "dropphycty": "NEW POINT",
    "dropphyst": "VA",
    "dropphyzpp": 231259998,
    "dropmaladd": "393 SAND BANK RD",
    "dropmalcty": "NEW POINT",
    "dropmalst": "VA",
    "dropmalzpp": 231259998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047255045,
    "dropsitcph": 8047255045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27281",
    "droptype": "D",
    "dropname": "NEW RIVER",
    "dropdeladd": "6461 NEW RIVER RD",
    "dropdelcty": "NEW RIVER",
    "dropdelst": "VA",
    "dropdelzpp": 241299998,
    "dropphyadd": "6461 NEW RIVER RD",
    "dropphycty": "NEW RIVER",
    "dropphyst": "VA",
    "dropphyzpp": 241299998,
    "dropmaladd": "6461 NEW RIVER RD",
    "dropmalcty": "NEW RIVER",
    "dropmalst": "VA",
    "dropmalzpp": 241299998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407319350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27282",
    "droptype": "D",
    "dropname": "NEWBERN",
    "dropdeladd": "5339 WILDERNESS RD",
    "dropdelcty": "NEWBERN",
    "dropdelst": "VA",
    "dropdelzpp": 241269998,
    "dropphyadd": "5339 WILDERNESS RD",
    "dropphycty": "NEWBERN",
    "dropphyst": "VA",
    "dropphyzpp": 241269998,
    "dropmaladd": "5339 WILDERNESS RD",
    "dropmalcty": "NEWBERN",
    "dropmalst": "VA",
    "dropmalzpp": 241269998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5402743006,
    "dropsitcph": 5406749506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27285",
    "droptype": "D",
    "dropname": "NEWINGTON",
    "dropdeladd": "8253A BACKLICK RD",
    "dropdelcty": "NEWINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 221229998,
    "dropphyadd": "8253A BACKLICK RD",
    "dropphycty": "NEWINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 221229998,
    "dropmaladd": "8253A BACKLICK RD",
    "dropmalcty": "NEWINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 221229998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7033394894,
    "dropsitcph": 7033394894,
    "dropfax": 7033390355
  },
  {
    "dcode": "D",
    "dropkey": "PX27286",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "119 BLUE GRASS TRL",
    "dropdelcty": "NEWPORT",
    "dropdelst": "VA",
    "dropdelzpp": 241289998,
    "dropphyadd": "119 BLUE GRASS TRL",
    "dropphycty": "NEWPORT",
    "dropphyst": "VA",
    "dropphyzpp": 241289998,
    "dropmaladd": "119 BLUE GRASS TRL",
    "dropmalcty": "NEWPORT",
    "dropmalst": "VA",
    "dropmalzpp": 241289998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405447415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27288",
    "droptype": "D",
    "dropname": "NEWPORT NEWS",
    "dropdeladd": "101 25TH ST",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236079998,
    "dropphyadd": "101 25TH ST",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236079998,
    "dropmaladd": "101 25TH ST",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236079998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572470841,
    "dropsitcph": 7572470841,
    "dropfax": 7572470231
  },
  {
    "dcode": "D",
    "dropkey": "PX27292",
    "droptype": "D",
    "dropname": "NEWSOMS",
    "dropdeladd": "29174 S MAIN ST",
    "dropdelcty": "NEWSOMS",
    "dropdelst": "VA",
    "dropdelzpp": 238749998,
    "dropphyadd": "29174 S MAIN ST",
    "dropphycty": "NEWSOMS",
    "dropphyst": "VA",
    "dropphyzpp": 238749998,
    "dropmaladd": "29174 S MAIN ST",
    "dropmalcty": "NEWSOMS",
    "dropmalst": "VA",
    "dropmalzpp": 238749998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046549642,
    "dropsitcph": 7576549642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27293",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "9933 NEWTOWN RD",
    "dropdelcty": "NEWTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 231269998,
    "dropphyadd": "9933 NEWTOWN RD",
    "dropphycty": "NEWTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 231269998,
    "dropmaladd": "9933 NEWTOWN RD",
    "dropmalcty": "NEWTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 231269998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047694730,
    "dropsitcph": 8047694730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27295",
    "droptype": "D",
    "dropname": "NICKELSVILLE",
    "dropdeladd": "158 BETHEL RD",
    "dropdelcty": "NICKELSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 242719998,
    "dropphyadd": "158 BETHEL RD",
    "dropphycty": "NICKELSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 242719998,
    "dropmaladd": "158 BETHEL RD",
    "dropmalcty": "NICKELSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 242719998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764792187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27296",
    "droptype": "D",
    "dropname": "NINDE",
    "dropdeladd": "15488 RIDGE RD",
    "dropdelcty": "NINDE",
    "dropdelst": "VA",
    "dropdelzpp": 225269998,
    "dropphyadd": "15488 RIDGE RD",
    "dropphycty": "NINDE",
    "dropphyst": "VA",
    "dropphyzpp": 225269998,
    "dropmaladd": "15488 RIDGE RD",
    "dropmalcty": "NINDE",
    "dropmalst": "VA",
    "dropmalzpp": 225269998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407750981,
    "dropsitcph": 5407750981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27298",
    "droptype": "D",
    "dropname": "NOKESVILLE",
    "dropdeladd": "12913 MARSTELLER DR",
    "dropdelcty": "NOKESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201819998,
    "dropphyadd": "12913 MARSTELLER DR",
    "dropphycty": "NOKESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201819998,
    "dropmaladd": "12913 MARSTELLER DR",
    "dropmalcty": "NOKESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201819998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035943936,
    "dropsitcph": 7035943936,
    "dropfax": 7035942660
  },
  {
    "dcode": "D",
    "dropkey": "PX27302",
    "droptype": "D",
    "dropname": "NORA",
    "dropdeladd": "5623 DANTE MOUNTAIN RD",
    "dropdelcty": "NORA",
    "dropdelst": "VA",
    "dropdelzpp": 242729998,
    "dropphyadd": "5623 DANTE MOUNTAIN RD",
    "dropphycty": "NORA",
    "dropphyst": "VA",
    "dropphyzpp": 242729998,
    "dropmaladd": "5623 DANTE MOUNTAIN RD",
    "dropmalcty": "NORA",
    "dropmalst": "VA",
    "dropmalzpp": 242729998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768359853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27304",
    "droptype": "D",
    "dropname": "NORFOLK",
    "dropdeladd": "600 CHURCH ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235019900,
    "dropphyadd": "600 CHURCH ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235019900,
    "dropmaladd": "600 CHURCH ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235019900,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576249472,
    "dropsitcph": 7576249472,
    "dropfax": 7576249472
  },
  {
    "dcode": "D",
    "dropkey": "PX27311",
    "droptype": "D",
    "dropname": "NORGE",
    "dropdeladd": "7489 RICHMOND RD",
    "dropdelcty": "NORGE",
    "dropdelst": "VA",
    "dropdelzpp": 231279998,
    "dropphyadd": "7489 RICHMOND RD",
    "dropphycty": "NORGE",
    "dropphyst": "VA",
    "dropphyzpp": 231279998,
    "dropmaladd": "7489 RICHMOND RD",
    "dropmalcty": "NORGE",
    "dropmalst": "VA",
    "dropmalzpp": 231279998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045643134,
    "dropsitcph": 7575643134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27314",
    "droptype": "D",
    "dropname": "NORTH",
    "dropdeladd": "13846 JOHN CLAYTON MEMORIAL HWY",
    "dropdelcty": "NORTH",
    "dropdelst": "VA",
    "dropdelzpp": 231289998,
    "dropphyadd": "13846 JOHN CLAYTON MEMORIAL HWY",
    "dropphycty": "NORTH",
    "dropphyst": "VA",
    "dropphyzpp": 231289998,
    "dropmaladd": "13846 JOHN CLAYTON MEMORIAL HWY",
    "dropmalcty": "NORTH",
    "dropmalst": "VA",
    "dropmalzpp": 231289998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047255299,
    "dropsitcph": 8047255299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27315",
    "droptype": "D",
    "dropname": "NORTH GARDEN",
    "dropdeladd": "4917 PLANK RD",
    "dropdelcty": "NORTH GARDEN",
    "dropdelst": "VA",
    "dropdelzpp": 229599998,
    "dropphyadd": "4917 PLANK RD",
    "dropphycty": "NORTH GARDEN",
    "dropphyst": "VA",
    "dropphyzpp": 229599998,
    "dropmaladd": "4917 PLANK RD",
    "dropmalcty": "NORTH GARDEN",
    "dropmalst": "VA",
    "dropmalzpp": 229599998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4342967443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27318",
    "droptype": "D",
    "dropname": "NORTH TAZEWELL",
    "dropdeladd": "1511 RIVERSIDE DR",
    "dropdelcty": "NORTH TAZEWELL",
    "dropdelst": "VA",
    "dropdelzpp": 246309998,
    "dropphyadd": "1511 RIVERSIDE DR",
    "dropphycty": "NORTH TAZEWELL",
    "dropphyst": "VA",
    "dropphyzpp": 246309998,
    "dropmaladd": "1511 RIVERSIDE DR",
    "dropmalcty": "NORTH TAZEWELL",
    "dropmalst": "VA",
    "dropmalzpp": 246309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769883421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27327",
    "droptype": "D",
    "dropname": "NORTON",
    "dropdeladd": "39 7TH ST NW",
    "dropdelcty": "NORTON",
    "dropdelst": "VA",
    "dropdelzpp": 242739998,
    "dropphyadd": "39 7TH ST NW",
    "dropphycty": "NORTON",
    "dropphyst": "VA",
    "dropphyzpp": 242739998,
    "dropmaladd": "39 7TH ST NW",
    "dropmalcty": "NORTON",
    "dropmalst": "VA",
    "dropmalzpp": 242739998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766792209,
    "dropfax": 2766793768
  },
  {
    "dcode": "D",
    "dropkey": "PX27331",
    "droptype": "D",
    "dropname": "NOTTOWAY",
    "dropdeladd": "329 W COURTHOUSE RD",
    "dropdelcty": "NOTTOWAY",
    "dropdelst": "VA",
    "dropdelzpp": 239553619,
    "dropphyadd": "329 W COURTHOUSE RD",
    "dropphycty": "NOTTOWAY",
    "dropphyst": "VA",
    "dropphyzpp": 239553619,
    "dropmaladd": "329 W COURTHOUSE RD",
    "dropmalcty": "NOTTOWAY",
    "dropmalst": "VA",
    "dropmalzpp": 239559998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346459440,
    "dropsitcph": 4346459440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27345",
    "droptype": "D",
    "dropname": "OAK HALL",
    "dropdeladd": "8133 LANKFORD HWY",
    "dropdelcty": "OAK HALL",
    "dropdelst": "VA",
    "dropdelzpp": 234169998,
    "dropphyadd": "8133 LANKFORD HWY",
    "dropphycty": "OAK HALL",
    "dropphyst": "VA",
    "dropphyzpp": 234169998,
    "dropmaladd": "8133 LANKFORD HWY",
    "dropmalcty": "OAK HALL",
    "dropmalst": "VA",
    "dropmalzpp": 234169998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578243568,
    "dropsitcph": 7578243568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27347",
    "droptype": "D",
    "dropname": "OAKPARK",
    "dropdeladd": "6321 OAK PARK RD",
    "dropdelcty": "OAKPARK",
    "dropdelst": "VA",
    "dropdelzpp": 227309997,
    "dropphyadd": "6321 OAK PARK RD",
    "dropphycty": "OAKPARK",
    "dropphyst": "VA",
    "dropphyzpp": 227309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKPARK",
    "dropmalst": "VA",
    "dropmalzpp": 227309998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406722523,
    "dropsitcph": 5406722523,
    "dropfax": 5406722523
  },
  {
    "dcode": "D",
    "dropkey": "PX27350",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "10735 RIVERSIDE DR",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 246319998,
    "dropphyadd": "10735 RIVERSIDE DR",
    "dropphycty": "OAKWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 246319998,
    "dropmaladd": "10735 RIVERSIDE DR",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 246319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2764983580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27351",
    "droptype": "D",
    "dropname": "OCCOQUAN",
    "dropdeladd": "202 MILL ST",
    "dropdelcty": "OCCOQUAN",
    "dropdelst": "VA",
    "dropdelzpp": 221259998,
    "dropphyadd": "202 MILL ST",
    "dropphycty": "OCCOQUAN",
    "dropphyst": "VA",
    "dropphyzpp": 221259998,
    "dropmaladd": "202 MILL ST",
    "dropmalcty": "OCCOQUAN",
    "dropmalst": "VA",
    "dropmalzpp": 221259998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034917604,
    "dropsitcph": 7034917604,
    "dropfax": 7034928075
  },
  {
    "dcode": "D",
    "dropkey": "PX27357",
    "droptype": "D",
    "dropname": "OILVILLE",
    "dropdeladd": "1411 BROAD STREET RD",
    "dropdelcty": "OILVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 231299998,
    "dropphyadd": "1411 BROAD STREET RD",
    "dropphycty": "OILVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 231299998,
    "dropmaladd": "1411 BROAD STREET RD",
    "dropmalcty": "OILVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 231299998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047843624,
    "dropsitcph": 8047843624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27362",
    "droptype": "D",
    "dropname": "OLDHAMS",
    "dropdeladd": "3498 OLDHAMS RD",
    "dropdelcty": "OLDHAMS",
    "dropdelst": "VA",
    "dropdelzpp": 225299998,
    "dropphyadd": "3498 OLDHAMS RD",
    "dropphycty": "OLDHAMS",
    "dropphyst": "VA",
    "dropphyzpp": 225299998,
    "dropmaladd": "3498 OLDHAMS RD",
    "dropmalcty": "OLDHAMS",
    "dropmalst": "VA",
    "dropmalzpp": 225299998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044722030,
    "dropsitcph": 8044722030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27364",
    "droptype": "D",
    "dropname": "ONANCOCK",
    "dropdeladd": "35 MARKET ST",
    "dropdelcty": "ONANCOCK",
    "dropdelst": "VA",
    "dropdelzpp": 234171900,
    "dropphyadd": "35 MARKET ST",
    "dropphycty": "ONANCOCK",
    "dropphyst": "VA",
    "dropphyzpp": 234171900,
    "dropmaladd": "35 MARKET ST",
    "dropmalcty": "ONANCOCK",
    "dropmalst": "VA",
    "dropmalzpp": 234171900,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577873923,
    "dropsitcph": 7577873923,
    "dropfax": 7577873923
  },
  {
    "dcode": "D",
    "dropkey": "PX27365",
    "droptype": "D",
    "dropname": "ONEMO",
    "dropdeladd": "1835 BETHEL BEACH RD",
    "dropdelcty": "ONEMO",
    "dropdelst": "VA",
    "dropdelzpp": 231309998,
    "dropphyadd": "1835 BETHEL BEACH RD",
    "dropphycty": "ONEMO",
    "dropphyst": "VA",
    "dropphyzpp": 231309998,
    "dropmaladd": "1835 BETHEL BEACH RD",
    "dropmalcty": "ONEMO",
    "dropmalst": "VA",
    "dropmalzpp": 231309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047253938,
    "dropsitcph": 8047253938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27366",
    "droptype": "D",
    "dropname": "ONLEY",
    "dropdeladd": "25468 COASTAL BLVD",
    "dropdelcty": "ONLEY",
    "dropdelst": "VA",
    "dropdelzpp": 234189998,
    "dropphyadd": "25468 COASTAL BLVD",
    "dropphycty": "ONLEY",
    "dropphyst": "VA",
    "dropphyzpp": 234189998,
    "dropmaladd": "25468 COASTAL BLVD",
    "dropmalcty": "ONLEY",
    "dropmalst": "VA",
    "dropmalzpp": 234189998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577872985,
    "dropsitcph": 7577872985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27368",
    "droptype": "D",
    "dropname": "OPHELIA",
    "dropdeladd": "22 LIGHTHOUSE VIEW DR STE B",
    "dropdelcty": "OPHELIA",
    "dropdelst": "VA",
    "dropdelzpp": 225309998,
    "dropphyadd": "22 LIGHTHOUSE VIEW DR STE B",
    "dropphycty": "OPHELIA",
    "dropphyst": "VA",
    "dropphyzpp": 225309998,
    "dropmaladd": "22 LIGHTHOUSE VIEW DR STE B",
    "dropmalcty": "OPHELIA",
    "dropmalst": "VA",
    "dropmalzpp": 225309998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044536106,
    "dropsitcph": 8044536106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27369",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "129 W MAIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "VA",
    "dropdelzpp": 229609998,
    "dropphyadd": "129 W MAIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "VA",
    "dropphyzpp": 229609998,
    "dropmaladd": "129 W MAIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "VA",
    "dropmalzpp": 229609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5406722868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27370",
    "droptype": "D",
    "dropname": "ORDINARY",
    "dropdeladd": "3992 GEORGE WASHINGTON MEMORIAL HWY",
    "dropdelcty": "ORDINARY",
    "dropdelst": "VA",
    "dropdelzpp": 231319998,
    "dropphyadd": "3992 GEORGE WASHINGTON MEMORIAL HWY",
    "dropphycty": "ORDINARY",
    "dropphyst": "VA",
    "dropphyzpp": 231319998,
    "dropmaladd": "3992 GEORGE WASHINGTON MEMORIAL HWY",
    "dropmalcty": "ORDINARY",
    "dropmalst": "VA",
    "dropmalzpp": 231319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046426211,
    "dropsitcph": 8046426211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27371",
    "droptype": "D",
    "dropname": "ORISKANY",
    "dropdeladd": "68 ORISKANY SQ",
    "dropdelcty": "ORISKANY",
    "dropdelst": "VA",
    "dropdelzpp": 241309998,
    "dropphyadd": "68 ORISKANY SQ",
    "dropphycty": "ORISKANY",
    "dropphyst": "VA",
    "dropphyzpp": 241309998,
    "dropmaladd": "68 ORISKANY SQ",
    "dropmalcty": "ORISKANY",
    "dropmalst": "VA",
    "dropmalzpp": 241309998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405672600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27373",
    "droptype": "D",
    "dropname": "ORKNEY SPRINGS",
    "dropdeladd": "4506 ORKNEY SPRINGS RD",
    "dropdelcty": "ORKNEY SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 228459998,
    "dropphyadd": "4506 ORKNEY SPRINGS RD",
    "dropphycty": "ORKNEY SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 228459998,
    "dropmaladd": "4506 ORKNEY SPRINGS RD",
    "dropmalcty": "ORKNEY SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 228459998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408562523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27375",
    "droptype": "D",
    "dropname": "ORLEAN",
    "dropdeladd": "6864 LEEDS MANOR RD",
    "dropdelcty": "ORLEAN",
    "dropdelst": "VA",
    "dropdelzpp": 201289997,
    "dropphyadd": "6864 LEEDS MANOR RD",
    "dropphycty": "ORLEAN",
    "dropphyst": "VA",
    "dropphyzpp": 201289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORLEAN",
    "dropmalst": "VA",
    "dropmalzpp": 201289998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403642657,
    "dropsitcph": 5403642657,
    "dropfax": 5403649280
  },
  {
    "dcode": "D",
    "dropkey": "PX27383",
    "droptype": "D",
    "dropname": "PAEONIAN SPRINGS",
    "dropdeladd": "16948 SIMPSON CIR",
    "dropdelcty": "PAEONIAN SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 201299997,
    "dropphyadd": "16948 SIMPSON CIR",
    "dropphycty": "PAEONIAN SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 201299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAEONIAN SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 201299998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403384422,
    "dropsitcph": 5403384422,
    "dropfax": 5403384422
  },
  {
    "dcode": "D",
    "dropkey": "PX27386",
    "droptype": "D",
    "dropname": "PAINTER",
    "dropdeladd": "33280 HICKMAN ST",
    "dropdelcty": "PAINTER",
    "dropdelst": "VA",
    "dropdelzpp": 234209998,
    "dropphyadd": "33280 HICKMAN ST",
    "dropphycty": "PAINTER",
    "dropphyst": "VA",
    "dropphyzpp": 234209998,
    "dropmaladd": "33280 HICKMAN ST",
    "dropmalcty": "PAINTER",
    "dropmalst": "VA",
    "dropmalzpp": 234209998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574429081,
    "dropsitcph": 7574429081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27387",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "13683 JAMES MADISON HWY",
    "dropdelcty": "PALMYRA",
    "dropdelst": "VA",
    "dropdelzpp": 229634300,
    "dropphyadd": "13683 JAMES MADISON HWY",
    "dropphycty": "PALMYRA",
    "dropphyst": "VA",
    "dropphyzpp": 229634300,
    "dropmaladd": "13683 JAMES MADISON HWY",
    "dropmalcty": "PALMYRA",
    "dropmalst": "VA",
    "dropmalzpp": 229634300,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4345892354,
    "dropfax": 4345892354
  },
  {
    "dcode": "D",
    "dropkey": "PX27388",
    "droptype": "D",
    "dropname": "PAMPLIN",
    "dropdeladd": "1 CHURCH ST",
    "dropdelcty": "PAMPLIN",
    "dropdelst": "VA",
    "dropdelzpp": 239589998,
    "dropphyadd": "1 CHURCH ST",
    "dropphycty": "PAMPLIN",
    "dropphyst": "VA",
    "dropphyzpp": 239589998,
    "dropmaladd": "1 CHURCH ST",
    "dropmalcty": "PAMPLIN",
    "dropmalst": "VA",
    "dropmalzpp": 239589998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342485371,
    "dropsitcph": 4342485371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27394",
    "droptype": "D",
    "dropname": "PARKSLEY",
    "dropdeladd": "24290 COOKE ST",
    "dropdelcty": "PARKSLEY",
    "dropdelst": "VA",
    "dropdelzpp": 234219998,
    "dropphyadd": "24290 COOKE ST",
    "dropphycty": "PARKSLEY",
    "dropphyst": "VA",
    "dropphyzpp": 234219998,
    "dropmaladd": "24290 COOKE ST",
    "dropmalcty": "PARKSLEY",
    "dropmalst": "VA",
    "dropmalzpp": 234219998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576654558,
    "dropsitcph": 7576654558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27396",
    "droptype": "D",
    "dropname": "PARROTT",
    "dropdeladd": "6059 PARROTT MOUNTAIN RD",
    "dropdelcty": "PARROTT",
    "dropdelst": "VA",
    "dropdelzpp": 241329998,
    "dropphyadd": "6059 PARROTT MOUNTAIN RD",
    "dropphycty": "PARROTT",
    "dropphyst": "VA",
    "dropphyzpp": 241329998,
    "dropmaladd": "6059 PARROTT MOUNTAIN RD",
    "dropmalcty": "PARROTT",
    "dropmalst": "VA",
    "dropmalzpp": 241329998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406399734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27397",
    "droptype": "D",
    "dropname": "PARTLOW",
    "dropdeladd": "2920 PARTLOW RD",
    "dropdelcty": "PARTLOW",
    "dropdelst": "VA",
    "dropdelzpp": 225349998,
    "dropphyadd": "2920 PARTLOW RD",
    "dropphycty": "PARTLOW",
    "dropphyst": "VA",
    "dropphyzpp": 225349998,
    "dropmaladd": "2920 PARTLOW RD",
    "dropmalcty": "PARTLOW",
    "dropmalst": "VA",
    "dropmalzpp": 225349998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044482289,
    "dropsitcph": 8044482289,
    "dropfax": 8044482289
  },
  {
    "dcode": "D",
    "dropkey": "PX27399",
    "droptype": "D",
    "dropname": "PATRICK SPRINGS",
    "dropdeladd": "22015 JEB STUART HWY",
    "dropdelcty": "PATRICK SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 241339998,
    "dropphyadd": "22015 JEB STUART HWY",
    "dropphycty": "PATRICK SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 241339998,
    "dropmaladd": "22015 JEB STUART HWY",
    "dropmalcty": "PATRICK SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 241339998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766946763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27401",
    "droptype": "D",
    "dropname": "PEARISBURG",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "PEARISBURG",
    "dropdelst": "VA",
    "dropdelzpp": 241349998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "PEARISBURG",
    "dropphyst": "VA",
    "dropphyzpp": 241349998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "PEARISBURG",
    "dropmalst": "VA",
    "dropmalzpp": 241349998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409211100,
    "dropsitcph": 5409211100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27403",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "102 PROGRESS ST",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "VA",
    "dropdelzpp": 241369998,
    "dropphyadd": "102 PROGRESS ST",
    "dropphycty": "PEMBROKE",
    "dropphyst": "VA",
    "dropphyzpp": 241369998,
    "dropmaladd": "102 PROGRESS ST",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "VA",
    "dropmalzpp": 241369998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406267211,
    "dropfax": 5406265615
  },
  {
    "dcode": "D",
    "dropkey": "PX27404",
    "droptype": "D",
    "dropname": "PENHOOK",
    "dropdeladd": "137 MORGANS FORK RD",
    "dropdelcty": "PENHOOK",
    "dropdelst": "VA",
    "dropdelzpp": 241379998,
    "dropphyadd": "137 MORGANS FORK RD",
    "dropphycty": "PENHOOK",
    "dropphyst": "VA",
    "dropphyzpp": 241379998,
    "dropmaladd": "137 MORGANS FORK RD",
    "dropmalcty": "PENHOOK",
    "dropmalst": "VA",
    "dropmalzpp": 241379998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402437292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27405",
    "droptype": "D",
    "dropname": "PENN LAIRD",
    "dropdeladd": "5375 SPOTSWOOD TRL",
    "dropdelcty": "PENN LAIRD",
    "dropdelst": "VA",
    "dropdelzpp": 228469998,
    "dropphyadd": "5375 SPOTSWOOD TRL",
    "dropphycty": "PENN LAIRD",
    "dropphyst": "VA",
    "dropphyzpp": 228469998,
    "dropmaladd": "5375 SPOTSWOOD TRL",
    "dropmalcty": "PENN LAIRD",
    "dropmalst": "VA",
    "dropmalzpp": 228469998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5404330069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27406",
    "droptype": "D",
    "dropname": "PENNINGTON GAP",
    "dropdeladd": "41610 W MORGAN AVE",
    "dropdelcty": "PENNINGTON GAP",
    "dropdelst": "VA",
    "dropdelzpp": 242779998,
    "dropphyadd": "41610 W MORGAN AVE",
    "dropphycty": "PENNINGTON GAP",
    "dropphyst": "VA",
    "dropphyzpp": 242779998,
    "dropmaladd": "41610 W MORGAN AVE",
    "dropmalcty": "PENNINGTON GAP",
    "dropmalst": "VA",
    "dropmalzpp": 242779998,
    "dropsitphn": 5409858780,
    "dropsitlph": 2765462623,
    "dropsitcph": 2765462623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27408",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "29 FRANKLIN ST",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 238039997,
    "dropphyadd": "29 FRANKLIN ST",
    "dropphycty": "PETERSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 238039997,
    "dropmaladd": "29 FRANKLIN ST",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 238039997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047321256,
    "dropsitcph": 8047322939,
    "dropfax": 8048615561
  },
  {
    "dcode": "D",
    "dropkey": "PX27411",
    "droptype": "D",
    "dropname": "PHENIX",
    "dropdeladd": "6836 PHENIX MAIN ST",
    "dropdelcty": "PHENIX",
    "dropdelst": "VA",
    "dropdelzpp": 239599998,
    "dropphyadd": "6836 PHENIX MAIN ST",
    "dropphycty": "PHENIX",
    "dropphyst": "VA",
    "dropphyzpp": 239599998,
    "dropmaladd": "6836 PHENIX MAIN ST",
    "dropmalcty": "PHENIX",
    "dropmalst": "VA",
    "dropmalzpp": 239599998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345425024,
    "dropsitcph": 4345425024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27412",
    "droptype": "D",
    "dropname": "PHILOMONT",
    "dropdeladd": "36550 JEB STUART RD",
    "dropdelcty": "PHILOMONT",
    "dropdelst": "VA",
    "dropdelzpp": 201319997,
    "dropphyadd": "36550 JEB STUART RD",
    "dropphycty": "PHILOMONT",
    "dropphyst": "VA",
    "dropphyzpp": 201319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHILOMONT",
    "dropmalst": "VA",
    "dropmalzpp": 201319998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403386687,
    "dropsitcph": 5403386687,
    "dropfax": 5403386687
  },
  {
    "dcode": "D",
    "dropkey": "PX27415",
    "droptype": "D",
    "dropname": "PILGRIMS KNOB",
    "dropdeladd": "14006 DISMAL RIVER RD",
    "dropdelcty": "PILGRIMS KNOB",
    "dropdelst": "VA",
    "dropdelzpp": 246349998,
    "dropphyadd": "14006 DISMAL RIVER RD",
    "dropphycty": "PILGRIMS KNOB",
    "dropphyst": "VA",
    "dropphyzpp": 246349998,
    "dropmaladd": "14006 DISMAL RIVER RD",
    "dropmalcty": "PILGRIMS KNOB",
    "dropmalst": "VA",
    "dropmalzpp": 246349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2762597774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27416",
    "droptype": "D",
    "dropname": "PILOT",
    "dropdeladd": "5044 PILOT RD",
    "dropdelcty": "PILOT",
    "dropdelst": "VA",
    "dropdelzpp": 241389998,
    "dropphyadd": "5044 PILOT RD",
    "dropphycty": "PILOT",
    "dropphyst": "VA",
    "dropphyzpp": 241389998,
    "dropmaladd": "5044 PILOT RD",
    "dropmalcty": "PILOT",
    "dropmalst": "VA",
    "dropmalzpp": 241389998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403828321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27422",
    "droptype": "D",
    "dropname": "PINEY RIVER",
    "dropdeladd": "3577 PATRICK HENRY HWY",
    "dropdelcty": "PINEY RIVER",
    "dropdelst": "VA",
    "dropdelzpp": 229649998,
    "dropphyadd": "3577 PATRICK HENRY HWY",
    "dropphycty": "PINEY RIVER",
    "dropphyst": "VA",
    "dropphyzpp": 229649998,
    "dropmaladd": "3577 PATRICK HENRY HWY",
    "dropmalcty": "PINEY RIVER",
    "dropmalst": "VA",
    "dropmalzpp": 229649998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342775951,
    "dropsitcph": 4342775951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27423",
    "droptype": "D",
    "dropname": "PITTSVILLE",
    "dropdeladd": "5424 PITTSVILLE RD",
    "dropdelcty": "PITTSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241399998,
    "dropphyadd": "5424 PITTSVILLE RD",
    "dropphycty": "PITTSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241399998,
    "dropmaladd": "5424 PITTSVILLE RD",
    "dropmalcty": "PITTSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241399998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4346561043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27430",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "300 CENTRE ST",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "VA",
    "dropdelzpp": 246355100,
    "dropphyadd": "300 CENTRE ST",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "VA",
    "dropphyzpp": 246355100,
    "dropmaladd": "300 CENTRE ST",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "VA",
    "dropmalzpp": 246355100,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769459514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27433",
    "droptype": "D",
    "dropname": "PORT HAYWOOD",
    "dropdeladd": "3781 NEW POINT COMFORT HWY",
    "dropdelcty": "PORT HAYWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 231389998,
    "dropphyadd": "3781 NEW POINT COMFORT HWY",
    "dropphycty": "PORT HAYWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 231389998,
    "dropmaladd": "3781 NEW POINT COMFORT HWY",
    "dropmalcty": "PORT HAYWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 231389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047252943,
    "dropsitcph": 8047252943,
    "dropfax": 8047252943
  },
  {
    "dcode": "D",
    "dropkey": "PX27434",
    "droptype": "D",
    "dropname": "PORT REPUBLIC",
    "dropdeladd": "8595 MAIN ST",
    "dropdelcty": "PORT REPUBLIC",
    "dropdelst": "VA",
    "dropdelzpp": 244719998,
    "dropphyadd": "8595 MAIN ST",
    "dropphycty": "PORT REPUBLIC",
    "dropphyst": "VA",
    "dropphyzpp": 244719998,
    "dropmaladd": "8595 MAIN ST",
    "dropmalcty": "PORT REPUBLIC",
    "dropmalst": "VA",
    "dropmalzpp": 244719998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402495665,
    "dropsitcph": 5402495665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27435",
    "droptype": "D",
    "dropname": "PORT ROYAL",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "PORT ROYAL",
    "dropdelst": "VA",
    "dropdelzpp": 225359998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "PORT ROYAL",
    "dropphyst": "VA",
    "dropphyzpp": 225359998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "PORT ROYAL",
    "dropmalst": "VA",
    "dropmalzpp": 225359998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047425759,
    "dropsitcph": 8047425759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27438",
    "droptype": "D",
    "dropname": "PORTSMOUTH",
    "dropdeladd": "933 BROAD ST",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "VA",
    "dropdelzpp": 237079998,
    "dropphyadd": "933 BROAD ST",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "VA",
    "dropphyzpp": 237079998,
    "dropmaladd": "933 BROAD ST",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "VA",
    "dropmalzpp": 237079998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573970841,
    "dropsitcph": 7573970841,
    "dropfax": 7573977162
  },
  {
    "dcode": "D",
    "dropkey": "PX27441",
    "droptype": "D",
    "dropname": "POUND",
    "dropdeladd": "11317 HIGHLAND AVE",
    "dropdelcty": "POUND",
    "dropdelst": "VA",
    "dropdelzpp": 242799998,
    "dropphyadd": "11317 HIGHLAND AVE",
    "dropphycty": "POUND",
    "dropphyst": "VA",
    "dropphyzpp": 242799998,
    "dropmaladd": "11317 HIGHLAND AVE",
    "dropmalcty": "POUND",
    "dropmalst": "VA",
    "dropmalzpp": 242799998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767964413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27442",
    "droptype": "D",
    "dropname": "POUNDING MILL",
    "dropdeladd": "4355 INDIAN PAINT RD",
    "dropdelcty": "POUNDING MILL",
    "dropdelst": "VA",
    "dropdelzpp": 246379998,
    "dropphyadd": "4355 INDIAN PAINT RD",
    "dropphycty": "POUNDING MILL",
    "dropphyst": "VA",
    "dropphyzpp": 246379998,
    "dropmaladd": "4355 INDIAN PAINT RD",
    "dropmalcty": "POUNDING MILL",
    "dropmalst": "VA",
    "dropmalzpp": 246379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769639259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27443",
    "droptype": "D",
    "dropname": "POWHATAN",
    "dropdeladd": "4195 ANDERSON HWY",
    "dropdelcty": "POWHATAN",
    "dropdelst": "VA",
    "dropdelzpp": 231399998,
    "dropphyadd": "4195 ANDERSON HWY",
    "dropphycty": "POWHATAN",
    "dropphyst": "VA",
    "dropphyzpp": 231399998,
    "dropmaladd": "4195 ANDERSON HWY",
    "dropmalcty": "POWHATAN",
    "dropmalst": "VA",
    "dropmalzpp": 231399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045986975,
    "dropsitcph": 8045986975,
    "dropfax": 8045984800
  },
  {
    "dcode": "D",
    "dropkey": "PX27444",
    "droptype": "D",
    "dropname": "PRATTS",
    "dropdeladd": "623 ORANGE RD",
    "dropdelcty": "PRATTS",
    "dropdelst": "VA",
    "dropdelzpp": 227319997,
    "dropphyadd": "623 ORANGE RD",
    "dropphycty": "PRATTS",
    "dropphyst": "VA",
    "dropphyzpp": 227319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRATTS",
    "dropmalst": "VA",
    "dropmalzpp": 227319998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409484060,
    "dropsitcph": 5409484060,
    "dropfax": 5409484060
  },
  {
    "dcode": "D",
    "dropkey": "PX27449",
    "droptype": "D",
    "dropname": "PRINCE GEORGE",
    "dropdeladd": "6605 COURTHOUSE RD",
    "dropdelcty": "PRINCE GEORGE",
    "dropdelst": "VA",
    "dropdelzpp": 238759998,
    "dropphyadd": "6605 COURTHOUSE RD",
    "dropphycty": "PRINCE GEORGE",
    "dropphyst": "VA",
    "dropphyzpp": 238759998,
    "dropmaladd": "6605 COURTHOUSE RD",
    "dropmalcty": "PRINCE GEORGE",
    "dropmalst": "VA",
    "dropmalzpp": 238759998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047329022,
    "dropsitcph": 8047331787,
    "dropfax": 8044512852
  },
  {
    "dcode": "D",
    "dropkey": "PX27453",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "152 PROSPECT RD",
    "dropdelcty": "PROSPECT",
    "dropdelst": "VA",
    "dropdelzpp": 239609998,
    "dropphyadd": "152 PROSPECT RD",
    "dropphycty": "PROSPECT",
    "dropphyst": "VA",
    "dropphyzpp": 239609998,
    "dropmaladd": "152 PROSPECT RD",
    "dropmalcty": "PROSPECT",
    "dropmalst": "VA",
    "dropmalzpp": 239609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4345746481,
    "dropsitcph": 4345746481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27457",
    "droptype": "D",
    "dropname": "PROVIDENCE FORGE",
    "dropdeladd": "3511 N COURTHOUSE RD",
    "dropdelcty": "PROVIDENCE FORGE",
    "dropdelst": "VA",
    "dropdelzpp": 231409998,
    "dropphyadd": "3511 N COURTHOUSE RD",
    "dropphycty": "PROVIDENCE FORGE",
    "dropphyst": "VA",
    "dropphyzpp": 231409998,
    "dropmaladd": "3511 N COURTHOUSE RD",
    "dropmalcty": "PROVIDENCE FORGE",
    "dropmalst": "VA",
    "dropmalzpp": 231409998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049662389,
    "dropsitcph": 8049662389,
    "dropfax": 8049662389
  },
  {
    "dcode": "D",
    "dropkey": "PX27464",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "109 N WASHINGTON AVE",
    "dropdelcty": "PULASKI",
    "dropdelst": "VA",
    "dropdelzpp": 243019998,
    "dropphyadd": "109 N WASHINGTON AVE",
    "dropphycty": "PULASKI",
    "dropphyst": "VA",
    "dropphyzpp": 243019998,
    "dropmaladd": "109 N WASHINGTON AVE",
    "dropmalcty": "PULASKI",
    "dropmalst": "VA",
    "dropmalzpp": 243019998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409804500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27466",
    "droptype": "D",
    "dropname": "PUNGOTEAGUE",
    "dropdeladd": "30296 BOBTOWN RD",
    "dropdelcty": "PUNGOTEAGUE",
    "dropdelst": "VA",
    "dropdelzpp": 234229998,
    "dropphyadd": "30296 BOBTOWN RD",
    "dropphycty": "PUNGOTEAGUE",
    "dropphyst": "VA",
    "dropphyzpp": 234229998,
    "dropmaladd": "30296 BOBTOWN RD",
    "dropmalcty": "PUNGOTEAGUE",
    "dropmalst": "VA",
    "dropmalzpp": 234229998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574425734,
    "dropsitcph": 7574425734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27467",
    "droptype": "D",
    "dropname": "PURCELLVILLE",
    "dropdeladd": "220 N HATCHER AVE",
    "dropdelcty": "PURCELLVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201329998,
    "dropphyadd": "220 N HATCHER AVE",
    "dropphycty": "PURCELLVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201329998,
    "dropmaladd": "220 N HATCHER AVE",
    "dropmalcty": "PURCELLVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201329998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5403384808,
    "dropsitcph": 5403384808,
    "dropfax": 5403389243
  },
  {
    "dcode": "D",
    "dropkey": "PX27471",
    "droptype": "D",
    "dropname": "QUANTICO",
    "dropdeladd": "400 5TH AVE",
    "dropdelcty": "QUANTICO",
    "dropdelst": "VA",
    "dropdelzpp": 221349998,
    "dropphyadd": "400 5TH AVE",
    "dropphycty": "QUANTICO",
    "dropphyst": "VA",
    "dropphyzpp": 221349998,
    "dropmaladd": "400 5TH AVE",
    "dropmalcty": "QUANTICO",
    "dropmalst": "VA",
    "dropmalzpp": 221349998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036407577,
    "dropsitcph": 7036407577,
    "dropfax": 7036400431
  },
  {
    "dcode": "D",
    "dropkey": "PX27473",
    "droptype": "D",
    "dropname": "QUICKSBURG",
    "dropdeladd": "4199 RIDGE RD",
    "dropdelcty": "QUICKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 228479998,
    "dropphyadd": "4199 RIDGE RD",
    "dropphycty": "QUICKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 228479998,
    "dropmaladd": "4199 RIDGE RD",
    "dropmalcty": "QUICKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 228479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046759268,
    "dropsitcph": 5407404698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27474",
    "droptype": "D",
    "dropname": "QUINBY",
    "dropdeladd": "35369 UPSHURS NECK RD",
    "dropdelcty": "QUINBY",
    "dropdelst": "VA",
    "dropdelzpp": 234239998,
    "dropphyadd": "35369 UPSHURS NECK RD",
    "dropphycty": "QUINBY",
    "dropphyst": "VA",
    "dropphyzpp": 234239998,
    "dropmaladd": "35369 UPSHURS NECK RD",
    "dropmalcty": "QUINBY",
    "dropmalst": "VA",
    "dropmalzpp": 234239998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574423197,
    "dropsitcph": 7574423197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27475",
    "droptype": "D",
    "dropname": "QUINQUE",
    "dropdeladd": "12817 SPOTSWOOD TRL",
    "dropdelcty": "QUINQUE",
    "dropdelst": "VA",
    "dropdelzpp": 229659998,
    "dropphyadd": "12817 SPOTSWOOD TRL",
    "dropphycty": "QUINQUE",
    "dropphyst": "VA",
    "dropphyzpp": 229659998,
    "dropmaladd": "12817 SPOTSWOOD TRL",
    "dropmalcty": "QUINQUE",
    "dropmalst": "VA",
    "dropmalzpp": 229659998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4349858361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27477",
    "droptype": "D",
    "dropname": "QUINTON",
    "dropdeladd": "2510 NEW KENT HWY",
    "dropdelcty": "QUINTON",
    "dropdelst": "VA",
    "dropdelzpp": 231419998,
    "dropphyadd": "2510 NEW KENT HWY",
    "dropphycty": "QUINTON",
    "dropphyst": "VA",
    "dropphyzpp": 231419998,
    "dropmaladd": "2510 NEW KENT HWY",
    "dropmalcty": "QUINTON",
    "dropmalst": "VA",
    "dropmalzpp": 231419998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8049324312,
    "dropsitcph": 8049324312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27479",
    "droptype": "D",
    "dropname": "RADFORD",
    "dropdeladd": "901 W MAIN ST",
    "dropdelcty": "RADFORD",
    "dropdelst": "VA",
    "dropdelzpp": 241419998,
    "dropphyadd": "901 W MAIN ST",
    "dropphycty": "RADFORD",
    "dropphyst": "VA",
    "dropphyzpp": 241419998,
    "dropmaladd": "901 W MAIN ST",
    "dropmalcty": "RADFORD",
    "dropmalst": "VA",
    "dropmalzpp": 241419998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5406393531,
    "dropfax": 5406399771
  },
  {
    "dcode": "D",
    "dropkey": "PX27480",
    "droptype": "D",
    "dropname": "RADIANT",
    "dropdeladd": "379 RADIANT WAY",
    "dropdelcty": "RADIANT",
    "dropdelst": "VA",
    "dropdelzpp": 227329998,
    "dropphyadd": "379 RADIANT WAY",
    "dropphycty": "RADIANT",
    "dropphyst": "VA",
    "dropphyzpp": 227329998,
    "dropmaladd": "379 RADIANT WAY",
    "dropmalcty": "RADIANT",
    "dropmalst": "VA",
    "dropmalzpp": 227329998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406725800,
    "dropsitcph": 5406725800,
    "dropfax": 5406825800
  },
  {
    "dcode": "D",
    "dropkey": "PX27482",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "6000 ROANOKE STATION RD",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "VA",
    "dropdelzpp": 239629998,
    "dropphyadd": "6000 ROANOKE STATION RD",
    "dropphycty": "RANDOLPH",
    "dropphyst": "VA",
    "dropphyzpp": 239629998,
    "dropmaladd": "6000 ROANOKE STATION RD",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "VA",
    "dropmalzpp": 239629998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4344547565,
    "dropsitcph": 4344547565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27484",
    "droptype": "D",
    "dropname": "RAPHINE",
    "dropdeladd": "2139 RAPHINE RD",
    "dropdelcty": "RAPHINE",
    "dropdelst": "VA",
    "dropdelzpp": 244729998,
    "dropphyadd": "2139 RAPHINE RD",
    "dropphycty": "RAPHINE",
    "dropphyst": "VA",
    "dropphyzpp": 244729998,
    "dropmaladd": "2139 RAPHINE RD",
    "dropmalcty": "RAPHINE",
    "dropmalst": "VA",
    "dropmalzpp": 244729998,
    "dropsitphn": 5407756336,
    "dropsitlph": 5403772854,
    "dropsitcph": 5403772854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27485",
    "droptype": "D",
    "dropname": "RAPIDAN",
    "dropdeladd": "9767 LOCUST DALE RD",
    "dropdelcty": "RAPIDAN",
    "dropdelst": "VA",
    "dropdelzpp": 227339997,
    "dropphyadd": "9767 LOCUST DALE RD",
    "dropphycty": "RAPIDAN",
    "dropphyst": "VA",
    "dropphyzpp": 227339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAPIDAN",
    "dropmalst": "VA",
    "dropmalzpp": 227339998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406721064,
    "dropsitcph": 5406721064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27486",
    "droptype": "D",
    "dropname": "RAPPAHANNOCK ACADEMY",
    "dropdeladd": "22173 TIDEWATER TRL",
    "dropdelcty": "RAPPAHANNOCK ACADEMY",
    "dropdelst": "VA",
    "dropdelzpp": 225389998,
    "dropphyadd": "22173 TIDEWATER TRL",
    "dropphycty": "RAPPAHANNOCK ACADEMY",
    "dropphyst": "VA",
    "dropphyzpp": 225389998,
    "dropmaladd": "22173 TIDEWATER TRL",
    "dropmalcty": "RAPPAHANNOCK ACADEMY",
    "dropmalst": "VA",
    "dropmalzpp": 225389998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047425604,
    "dropsitcph": 8047425604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27489",
    "droptype": "D",
    "dropname": "RAVEN",
    "dropdeladd": "561 RAVEN RD",
    "dropdelcty": "RAVEN",
    "dropdelst": "VA",
    "dropdelzpp": 246399998,
    "dropphyadd": "561 RAVEN RD",
    "dropphycty": "RAVEN",
    "dropphyst": "VA",
    "dropphyzpp": 246399998,
    "dropmaladd": "561 RAVEN RD",
    "dropmalcty": "RAVEN",
    "dropmalst": "VA",
    "dropmalzpp": 246399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769642678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27492",
    "droptype": "D",
    "dropname": "RAWLINGS",
    "dropdeladd": "4818 RAWLINGS RD",
    "dropdelcty": "RAWLINGS",
    "dropdelst": "VA",
    "dropdelzpp": 238769998,
    "dropphyadd": "4818 RAWLINGS RD",
    "dropphycty": "RAWLINGS",
    "dropphyst": "VA",
    "dropphyzpp": 238769998,
    "dropmaladd": "4818 RAWLINGS RD",
    "dropmalcty": "RAWLINGS",
    "dropmalst": "VA",
    "dropmalzpp": 238769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349497810,
    "dropsitcph": 4349497810,
    "dropfax": 4349497810
  },
  {
    "dcode": "D",
    "dropkey": "PX27493",
    "droptype": "D",
    "dropname": "RECTORTOWN",
    "dropdeladd": "2975 RECTORTOWN RD",
    "dropdelcty": "RECTORTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 201409998,
    "dropphyadd": "2975 RECTORTOWN RD",
    "dropphycty": "RECTORTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 201409998,
    "dropmaladd": "2975 RECTORTOWN RD",
    "dropmalcty": "RECTORTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 201409998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403643845,
    "dropsitcph": 5403643845,
    "dropfax": 5403641065
  },
  {
    "dcode": "D",
    "dropkey": "PX27497",
    "droptype": "D",
    "dropname": "RED HOUSE",
    "dropdeladd": "9699 RED HOUSE RD",
    "dropdelcty": "RED HOUSE",
    "dropdelst": "VA",
    "dropdelzpp": 239639998,
    "dropphyadd": "9699 RED HOUSE RD",
    "dropphycty": "RED HOUSE",
    "dropphyst": "VA",
    "dropphyzpp": 239639998,
    "dropmaladd": "9699 RED HOUSE RD",
    "dropmalcty": "RED HOUSE",
    "dropmalst": "VA",
    "dropmalzpp": 239639998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342486989,
    "dropsitcph": 4342486989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27498",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "6025 BARNESVILLE HWY",
    "dropdelcty": "RED OAK",
    "dropdelst": "VA",
    "dropdelzpp": 239649998,
    "dropphyadd": "6025 BARNESVILLE HWY",
    "dropphycty": "RED OAK",
    "dropphyst": "VA",
    "dropphyzpp": 239649998,
    "dropmaladd": "6025 BARNESVILLE HWY",
    "dropmalcty": "RED OAK",
    "dropmalst": "VA",
    "dropmalzpp": 239649998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347358591,
    "dropsitcph": 4347358591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27500",
    "droptype": "D",
    "dropname": "REDWOOD",
    "dropdeladd": "3450 OLD FRANKLIN TPKE",
    "dropdelcty": "REDWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 241469998,
    "dropphyadd": "3450 OLD FRANKLIN TPKE",
    "dropphycty": "REDWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 241469998,
    "dropmaladd": "3450 OLD FRANKLIN TPKE",
    "dropmalcty": "REDWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 241469998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5404837328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27501",
    "droptype": "D",
    "dropname": "REEDVILLE",
    "dropdeladd": "284 MORRIS AVE",
    "dropdelcty": "REEDVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 225399998,
    "dropphyadd": "284 MORRIS AVE",
    "dropphycty": "REEDVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 225399998,
    "dropmaladd": "284 MORRIS AVE",
    "dropmalcty": "REEDVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 225399998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044537503,
    "dropsitcph": 8044537503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27508",
    "droptype": "D",
    "dropname": "REMINGTON",
    "dropdeladd": "501 N JAMES MADISON ST",
    "dropdelcty": "REMINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 227349997,
    "dropphyadd": "501 N JAMES MADISON ST",
    "dropphycty": "REMINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 227349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 227349998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404393900,
    "dropsitcph": 5404393900,
    "dropfax": 5404390796
  },
  {
    "dcode": "D",
    "dropkey": "PX27511",
    "droptype": "D",
    "dropname": "RESCUE",
    "dropdeladd": "21148 RESCUE RD",
    "dropdelcty": "RESCUE",
    "dropdelst": "VA",
    "dropdelzpp": 234249998,
    "dropphyadd": "21148 RESCUE RD",
    "dropphycty": "RESCUE",
    "dropphyst": "VA",
    "dropphyzpp": 234249998,
    "dropmaladd": "21148 RESCUE RD",
    "dropmalcty": "RESCUE",
    "dropmalst": "VA",
    "dropmalzpp": 234249998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573575466,
    "dropsitcph": 7573575466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27514",
    "droptype": "D",
    "dropname": "REVA",
    "dropdeladd": "7005 JAMES MONROE HWY",
    "dropdelcty": "REVA",
    "dropdelst": "VA",
    "dropdelzpp": 227359998,
    "dropphyadd": "7005 JAMES MONROE HWY",
    "dropphycty": "REVA",
    "dropphyst": "VA",
    "dropphyzpp": 227359998,
    "dropmaladd": "7005 JAMES MONROE HWY",
    "dropmalcty": "REVA",
    "dropmalst": "VA",
    "dropmalzpp": 227359998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5405472336,
    "dropsitcph": 5405472336,
    "dropfax": 5405472336
  },
  {
    "dcode": "D",
    "dropkey": "PX27515",
    "droptype": "D",
    "dropname": "RHOADESVILLE",
    "dropdeladd": "25433 LAFAYETTE DR",
    "dropdelcty": "RHOADESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 225429998,
    "dropphyadd": "25433 LAFAYETTE DR",
    "dropphycty": "RHOADESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 225429998,
    "dropmaladd": "25433 LAFAYETTE DR",
    "dropmalcty": "RHOADESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 225429998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408544491,
    "dropsitcph": 5408544491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27518",
    "droptype": "D",
    "dropname": "RICE",
    "dropdeladd": "658 RICES DEPOT RD",
    "dropdelcty": "RICE",
    "dropdelst": "VA",
    "dropdelzpp": 239669998,
    "dropphyadd": "658 RICES DEPOT RD",
    "dropphycty": "RICE",
    "dropphyst": "VA",
    "dropphyzpp": 239669998,
    "dropmaladd": "658 RICES DEPOT RD",
    "dropmalcty": "RICE",
    "dropmalst": "VA",
    "dropmalzpp": 239669998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4343923865,
    "dropsitcph": 4343923865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27520",
    "droptype": "D",
    "dropname": "RICH CREEK",
    "dropdeladd": "299 OLD VIRGINIA AVE",
    "dropdelcty": "RICH CREEK",
    "dropdelst": "VA",
    "dropdelzpp": 241479998,
    "dropphyadd": "299 OLD VIRGINIA AVE",
    "dropphycty": "RICH CREEK",
    "dropphyst": "VA",
    "dropphyzpp": 241479998,
    "dropmaladd": "299 OLD VIRGINIA AVE",
    "dropmalcty": "RICH CREEK",
    "dropmalst": "VA",
    "dropmalzpp": 241479998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407263820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27525",
    "droptype": "D",
    "dropname": "RICHLANDS",
    "dropdeladd": "1430 FRONT ST",
    "dropdelcty": "RICHLANDS",
    "dropdelst": "VA",
    "dropdelzpp": 246419998,
    "dropphyadd": "1430 FRONT ST",
    "dropphycty": "RICHLANDS",
    "dropphyst": "VA",
    "dropphyzpp": 246419998,
    "dropmaladd": "1430 FRONT ST",
    "dropmalcty": "RICHLANDS",
    "dropmalst": "VA",
    "dropmalzpp": 246419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769649550,
    "dropfax": 2769638000
  },
  {
    "dcode": "D",
    "dropkey": "PX27528",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "1801 BROOK RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232329998,
    "dropphyadd": "1801 BROOK RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232329998,
    "dropmaladd": "1801 BROOK RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232329998,
    "dropsitphn": 8047756336,
    "dropsitlph": "",
    "dropsitcph": 8047756304,
    "dropfax": 8047756287
  },
  {
    "dcode": "D",
    "dropkey": "PX27533",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "82 MAGNOLIA ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "VA",
    "dropdelzpp": 241489998,
    "dropphyadd": "82 MAGNOLIA ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "VA",
    "dropphyzpp": 241489998,
    "dropmaladd": "82 MAGNOLIA ST",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "VA",
    "dropmalzpp": 241489998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769562354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27535",
    "droptype": "D",
    "dropname": "RILEYVILLE",
    "dropdeladd": "560 RILEYVILLE RD",
    "dropdelcty": "RILEYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 226509998,
    "dropphyadd": "560 RILEYVILLE RD",
    "dropphycty": "RILEYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 226509998,
    "dropmaladd": "560 RILEYVILLE RD",
    "dropmalcty": "RILEYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 226509998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5407433857,
    "dropsitcph": 5407433857,
    "dropfax": 5407432550
  },
  {
    "dcode": "D",
    "dropkey": "PX27538",
    "droptype": "D",
    "dropname": "RINER",
    "dropdeladd": "3955 RINER RD",
    "dropdelcty": "RINER",
    "dropdelst": "VA",
    "dropdelzpp": 241499998,
    "dropphyadd": "3955 RINER RD",
    "dropphycty": "RINER",
    "dropphyst": "VA",
    "dropphyzpp": 241499998,
    "dropmaladd": "3955 RINER RD",
    "dropmalcty": "RINER",
    "dropmalst": "VA",
    "dropmalzpp": 241499998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403827530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27539",
    "droptype": "D",
    "dropname": "RINGGOLD",
    "dropdeladd": "4745 RINGGOLD CHURCH RD",
    "dropdelcty": "RINGGOLD",
    "dropdelst": "VA",
    "dropdelzpp": 245869998,
    "dropphyadd": "4745 RINGGOLD CHURCH RD",
    "dropphycty": "RINGGOLD",
    "dropphyst": "VA",
    "dropphyzpp": 245869998,
    "dropmaladd": "4745 RINGGOLD CHURCH RD",
    "dropmalcty": "RINGGOLD",
    "dropmalst": "VA",
    "dropmalzpp": 245869998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4348226053,
    "dropfax": 4348226053
  },
  {
    "dcode": "D",
    "dropkey": "PX27540",
    "droptype": "D",
    "dropname": "RIPPLEMEAD",
    "dropdeladd": "101 GREYSTONE DR",
    "dropdelcty": "RIPPLEMEAD",
    "dropdelst": "VA",
    "dropdelzpp": 241509998,
    "dropphyadd": "101 GREYSTONE DR",
    "dropphycty": "RIPPLEMEAD",
    "dropphyst": "VA",
    "dropphyzpp": 241509998,
    "dropmaladd": "101 GREYSTONE DR",
    "dropmalcty": "RIPPLEMEAD",
    "dropmalst": "VA",
    "dropmalzpp": 241509998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409213571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27545",
    "droptype": "D",
    "dropname": "RIXEYVILLE",
    "dropdeladd": "8623 RIXEYVILLE RD",
    "dropdelcty": "RIXEYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 227379998,
    "dropphyadd": "8623 RIXEYVILLE RD",
    "dropphycty": "RIXEYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 227379998,
    "dropmaladd": "8623 RIXEYVILLE RD",
    "dropmalcty": "RIXEYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 227379998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5409374253,
    "dropsitcph": 5409374253,
    "dropfax": 5409377451
  },
  {
    "dcode": "D",
    "dropkey": "PX27549",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "419 RUTHERFORD AVE NE",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240229998,
    "dropphyadd": "419 RUTHERFORD AVE NE",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240229998,
    "dropmaladd": "419 RUTHERFORD AVE NE",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240229998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409858802,
    "dropfax": 5409858722
  },
  {
    "dcode": "D",
    "dropkey": "PX27550",
    "droptype": "D",
    "dropname": "ROCHELLE",
    "dropdeladd": "4225 JACKS SHOP RD",
    "dropdelcty": "ROCHELLE",
    "dropdelst": "VA",
    "dropdelzpp": 227389997,
    "dropphyadd": "4225 JACKS SHOP RD",
    "dropphycty": "ROCHELLE",
    "dropphyst": "VA",
    "dropphyzpp": 227389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCHELLE",
    "dropmalst": "VA",
    "dropmalzpp": 227389998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406725868,
    "dropsitcph": 5406725868,
    "dropfax": 5406725868
  },
  {
    "dcode": "D",
    "dropkey": "PX27552",
    "droptype": "D",
    "dropname": "ROCKBRIDGE BATHS",
    "dropdeladd": "4781 MAURY RIVER RD",
    "dropdelcty": "ROCKBRIDGE BATHS",
    "dropdelst": "VA",
    "dropdelzpp": 244739998,
    "dropphyadd": "4781 MAURY RIVER RD",
    "dropphycty": "ROCKBRIDGE BATHS",
    "dropphyst": "VA",
    "dropphyzpp": 244739998,
    "dropmaladd": "4781 MAURY RIVER RD",
    "dropmalcty": "ROCKBRIDGE BATHS",
    "dropmalst": "VA",
    "dropmalzpp": 244739998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403485995,
    "dropsitcph": 5403485995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27554",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "16590 POUNCEY TRACT RD",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 231469998,
    "dropphyadd": "16590 POUNCEY TRACT RD",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 231469998,
    "dropmaladd": "16590 POUNCEY TRACT RD",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 231469998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047493572,
    "dropsitcph": 8047493572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27557",
    "droptype": "D",
    "dropname": "ROCKY GAP",
    "dropdeladd": "12797 N SCENIC HWY",
    "dropdelcty": "ROCKY GAP",
    "dropdelst": "VA",
    "dropdelzpp": 243669998,
    "dropphyadd": "12797 N SCENIC HWY",
    "dropphycty": "ROCKY GAP",
    "dropphyst": "VA",
    "dropphyzpp": 243669998,
    "dropmaladd": "12797 N SCENIC HWY",
    "dropmalcty": "ROCKY GAP",
    "dropmalst": "VA",
    "dropmalzpp": 243669998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769281144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27558",
    "droptype": "D",
    "dropname": "ROCKY MOUNT",
    "dropdeladd": "20 E COLLEGE ST",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "VA",
    "dropdelzpp": 241519998,
    "dropphyadd": "20 E COLLEGE ST",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "VA",
    "dropphyzpp": 241519998,
    "dropmaladd": "20 E COLLEGE ST",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "VA",
    "dropmalzpp": 241519998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5404831530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27563",
    "droptype": "D",
    "dropname": "ROSE HILL",
    "dropdeladd": "6501 DR THOMAS WALKER RD",
    "dropdelcty": "ROSE HILL",
    "dropdelst": "VA",
    "dropdelzpp": 242819998,
    "dropphyadd": "6501 DR THOMAS WALKER RD",
    "dropphycty": "ROSE HILL",
    "dropphyst": "VA",
    "dropphyzpp": 242819998,
    "dropmaladd": "6501 DR THOMAS WALKER RD",
    "dropmalcty": "ROSE HILL",
    "dropmalst": "VA",
    "dropmalzpp": 242819998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764455291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27564",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "18542 U S HIGHWAY 19 STE C",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "VA",
    "dropdelzpp": 242809998,
    "dropphyadd": "18542 U S HIGHWAY 19 STE C",
    "dropphycty": "ROSEDALE",
    "dropphyst": "VA",
    "dropphyzpp": 242809998,
    "dropmaladd": "18542 U S HIGHWAY 19 STE C",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "VA",
    "dropmalzpp": 242809998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2768801169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27565",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "7877 PATRICK HENRY HWY",
    "dropdelcty": "ROSELAND",
    "dropdelst": "VA",
    "dropdelzpp": 229679998,
    "dropphyadd": "7877 PATRICK HENRY HWY",
    "dropphycty": "ROSELAND",
    "dropphyst": "VA",
    "dropphyzpp": 229679998,
    "dropmaladd": "7877 PATRICK HENRY HWY",
    "dropmalcty": "ROSELAND",
    "dropmalst": "VA",
    "dropmalzpp": 229679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342775919,
    "dropsitcph": 4342775919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27569",
    "droptype": "D",
    "dropname": "ROUND HILL",
    "dropdeladd": "2 MAIN ST",
    "dropdelcty": "ROUND HILL",
    "dropdelst": "VA",
    "dropdelzpp": 201419998,
    "dropphyadd": "2 MAIN ST",
    "dropphycty": "ROUND HILL",
    "dropphyst": "VA",
    "dropphyzpp": 201419998,
    "dropmaladd": "2 MAIN ST",
    "dropmalcty": "ROUND HILL",
    "dropmalst": "VA",
    "dropmalzpp": 201419998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5403381938,
    "dropsitcph": 5403381938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27571",
    "droptype": "D",
    "dropname": "ROWE",
    "dropdeladd": "2772 ROBINSON FORK RD",
    "dropdelcty": "ROWE",
    "dropdelst": "VA",
    "dropdelzpp": 246469998,
    "dropphyadd": "2772 ROBINSON FORK RD",
    "dropphycty": "ROWE",
    "dropphyst": "VA",
    "dropphyzpp": 246469998,
    "dropmaladd": "2772 ROBINSON FORK RD",
    "dropmalcty": "ROWE",
    "dropmalst": "VA",
    "dropmalzpp": 246469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2764983658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27574",
    "droptype": "D",
    "dropname": "RUBY",
    "dropdeladd": "32 ARROWHEAD DR STE 101",
    "dropdelcty": "RUBY",
    "dropdelst": "VA",
    "dropdelzpp": 225459998,
    "dropphyadd": "32 ARROWHEAD DR STE 101",
    "dropphycty": "RUBY",
    "dropphyst": "VA",
    "dropphyzpp": 225459998,
    "dropmaladd": "32 ARROWHEAD DR STE 101",
    "dropmalcty": "RUBY",
    "dropmalst": "VA",
    "dropmalzpp": 225459998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407520428,
    "dropsitcph": 5407520428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27575",
    "droptype": "D",
    "dropname": "RUCKERSVILLE",
    "dropdeladd": "8845 SEMINOLE TRL",
    "dropdelcty": "RUCKERSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229689998,
    "dropphyadd": "8845 SEMINOLE TRL",
    "dropphycty": "RUCKERSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229689998,
    "dropmaladd": "8845 SEMINOLE TRL",
    "dropmalcty": "RUCKERSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229689998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4349854842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27578",
    "droptype": "D",
    "dropname": "RURAL RETREAT",
    "dropdeladd": "405 S MAIN ST",
    "dropdelcty": "RURAL RETREAT",
    "dropdelst": "VA",
    "dropdelzpp": 243689998,
    "dropphyadd": "405 S MAIN ST",
    "dropphycty": "RURAL RETREAT",
    "dropphyst": "VA",
    "dropphyzpp": 243689998,
    "dropmaladd": "405 S MAIN ST",
    "dropmalcty": "RURAL RETREAT",
    "dropmalst": "VA",
    "dropmalzpp": 243689998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766864501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27579",
    "droptype": "D",
    "dropname": "RUSTBURG",
    "dropdeladd": "1103 VILLAGE HWY",
    "dropdelcty": "RUSTBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245889998,
    "dropphyadd": "1103 VILLAGE HWY",
    "dropphycty": "RUSTBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245889998,
    "dropmaladd": "1103 VILLAGE HWY",
    "dropmalcty": "RUSTBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245889998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343322260,
    "dropfax": 4343321257
  },
  {
    "dcode": "D",
    "dropkey": "PX27580",
    "droptype": "D",
    "dropname": "RUTHER GLEN",
    "dropdeladd": "24134 WELCOME WAY DR",
    "dropdelcty": "RUTHER GLEN",
    "dropdelst": "VA",
    "dropdelzpp": 225469998,
    "dropphyadd": "24134 WELCOME WAY DR",
    "dropphycty": "RUTHER GLEN",
    "dropphyst": "VA",
    "dropphyzpp": 225469998,
    "dropmaladd": "24134 WELCOME WAY DR",
    "dropmalcty": "RUTHER GLEN",
    "dropmalst": "VA",
    "dropmalzpp": 225469998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044488968,
    "dropsitcph": 8044488968,
    "dropfax": 8044484327
  },
  {
    "dcode": "D",
    "dropkey": "PX27583",
    "droptype": "D",
    "dropname": "RUTHVILLE",
    "dropdeladd": "13121 THE GLEBE LN",
    "dropdelcty": "RUTHVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 231479998,
    "dropphyadd": "13121 THE GLEBE LN",
    "dropphycty": "RUTHVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 231479998,
    "dropmaladd": "13121 THE GLEBE LN",
    "dropmalcty": "RUTHVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 231479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048295222,
    "dropsitcph": 8048295222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27589",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "155 MONARCH RD",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "VA",
    "dropdelzpp": 242829998,
    "dropphyadd": "155 MONARCH RD",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "VA",
    "dropphyzpp": 242829998,
    "dropmaladd": "155 MONARCH RD",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "VA",
    "dropmalzpp": 242829998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763834496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27591",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "16552 RUSSELL ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "VA",
    "dropdelzpp": 242839998,
    "dropphyadd": "16552 RUSSELL ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "VA",
    "dropphyzpp": 242839998,
    "dropmaladd": "16552 RUSSELL ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "VA",
    "dropmalzpp": 242839998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2767625871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27593",
    "droptype": "D",
    "dropname": "SAINT STEPHENS CHURCH",
    "dropdeladd": "13280 RICHMOND TAPPAHANNOCK HWY",
    "dropdelcty": "SAINT STEPHENS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 231489998,
    "dropphyadd": "13280 RICHMOND TAPPAHANNOCK HWY",
    "dropphycty": "SAINT STEPHENS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 231489998,
    "dropmaladd": "13280 RICHMOND TAPPAHANNOCK HWY",
    "dropmalcty": "SAINT STEPHENS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 231489998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047693600,
    "dropsitcph": 8047693600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27594",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "320 W MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "VA",
    "dropdelzpp": 241539998,
    "dropphyadd": "320 W MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "VA",
    "dropphyzpp": 241539998,
    "dropmaladd": "320 W MAIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "VA",
    "dropmalzpp": 241539998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403899214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27595",
    "droptype": "D",
    "dropname": "SALTVILLE",
    "dropdeladd": "146 PALMER AVE",
    "dropdelcty": "SALTVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 243709998,
    "dropphyadd": "146 PALMER AVE",
    "dropphycty": "SALTVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 243709998,
    "dropmaladd": "146 PALMER AVE",
    "dropmalcty": "SALTVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 243709998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764964662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27596",
    "droptype": "D",
    "dropname": "SALUDA",
    "dropdeladd": "880 GLOUCESTER RD",
    "dropdelcty": "SALUDA",
    "dropdelst": "VA",
    "dropdelzpp": 231492596,
    "dropphyadd": "880 GLOUCESTER RD",
    "dropphycty": "SALUDA",
    "dropphyst": "VA",
    "dropphyzpp": 231492596,
    "dropmaladd": "880 GLOUCESTER RD",
    "dropmalcty": "SALUDA",
    "dropmalst": "VA",
    "dropmalzpp": 231499998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047582861,
    "dropsitcph": 8047582861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27598",
    "droptype": "D",
    "dropname": "SANDSTON",
    "dropdeladd": "40 W WILLIAMSBURG RD",
    "dropdelcty": "SANDSTON",
    "dropdelst": "VA",
    "dropdelzpp": 231509998,
    "dropphyadd": "40 W WILLIAMSBURG RD",
    "dropphycty": "SANDSTON",
    "dropphyst": "VA",
    "dropphyzpp": 231509998,
    "dropmaladd": "40 W WILLIAMSBURG RD",
    "dropmalcty": "SANDSTON",
    "dropmalst": "VA",
    "dropmalzpp": 231509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047371382,
    "dropsitcph": 8047371382,
    "dropfax": 8047375669
  },
  {
    "dcode": "D",
    "dropkey": "PX27599",
    "droptype": "D",
    "dropname": "SANDY HOOK",
    "dropdeladd": "2883 SANDY HOOK RD",
    "dropdelcty": "SANDY HOOK",
    "dropdelst": "VA",
    "dropdelzpp": 231539998,
    "dropphyadd": "2883 SANDY HOOK RD",
    "dropphycty": "SANDY HOOK",
    "dropphyst": "VA",
    "dropphyzpp": 231539998,
    "dropmaladd": "2883 SANDY HOOK RD",
    "dropmalcty": "SANDY HOOK",
    "dropmalst": "VA",
    "dropmalzpp": 231539998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045562307,
    "dropsitcph": 8045562307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27605",
    "droptype": "D",
    "dropname": "SAXE",
    "dropdeladd": "180 HAILEY RD",
    "dropdelcty": "SAXE",
    "dropdelst": "VA",
    "dropdelzpp": 239679998,
    "dropphyadd": "180 HAILEY RD",
    "dropphycty": "SAXE",
    "dropphyst": "VA",
    "dropphyzpp": 239679998,
    "dropmaladd": "180 HAILEY RD",
    "dropmalcty": "SAXE",
    "dropmalst": "VA",
    "dropmalzpp": 239679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4344546348,
    "dropsitcph": 4344546348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27606",
    "droptype": "D",
    "dropname": "SAXIS",
    "dropdeladd": "20264 SAXIS RD",
    "dropdelcty": "SAXIS",
    "dropdelst": "VA",
    "dropdelzpp": 234279998,
    "dropphyadd": "20264 SAXIS RD",
    "dropphycty": "SAXIS",
    "dropphyst": "VA",
    "dropphyzpp": 234279998,
    "dropmaladd": "20264 SAXIS RD",
    "dropmalcty": "SAXIS",
    "dropmalst": "VA",
    "dropmalzpp": 234279998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578243673,
    "dropsitcph": 7578243673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27607",
    "droptype": "D",
    "dropname": "SCHLEY",
    "dropdeladd": "5778 WARE NECK RD",
    "dropdelcty": "SCHLEY",
    "dropdelst": "VA",
    "dropdelzpp": 231549998,
    "dropphyadd": "5778 WARE NECK RD",
    "dropphycty": "SCHLEY",
    "dropphyst": "VA",
    "dropphyzpp": 231549998,
    "dropmaladd": "5778 WARE NECK RD",
    "dropmalcty": "SCHLEY",
    "dropmalst": "VA",
    "dropmalzpp": 231549998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046934248,
    "dropsitcph": 8046934248,
    "dropfax": 8046934248
  },
  {
    "dcode": "D",
    "dropkey": "PX27610",
    "droptype": "D",
    "dropname": "SCHUYLER",
    "dropdeladd": "6648 ROCKFISH RIVER RD",
    "dropdelcty": "SCHUYLER",
    "dropdelst": "VA",
    "dropdelzpp": 229699998,
    "dropphyadd": "6648 ROCKFISH RIVER RD",
    "dropphycty": "SCHUYLER",
    "dropphyst": "VA",
    "dropphyzpp": 229699998,
    "dropmaladd": "6648 ROCKFISH RIVER RD",
    "dropmalcty": "SCHUYLER",
    "dropmalst": "VA",
    "dropmalzpp": 229699998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4348312440,
    "dropsitcph": 4348312440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27611",
    "droptype": "D",
    "dropname": "SCOTTSBURG",
    "dropdeladd": "2221 SCOTTSBURG RD",
    "dropdelcty": "SCOTTSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245899998,
    "dropphyadd": "2221 SCOTTSBURG RD",
    "dropphycty": "SCOTTSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245899998,
    "dropmaladd": "2221 SCOTTSBURG RD",
    "dropmalcty": "SCOTTSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245899998,
    "dropsitphn": 7039858780,
    "dropsitlph": 7039858779,
    "dropsitcph": 4344546382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27612",
    "droptype": "D",
    "dropname": "SCOTTSVILLE",
    "dropdeladd": "110 SCOTTSVILLE CTR",
    "dropdelcty": "SCOTTSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 245909998,
    "dropphyadd": "110 SCOTTSVILLE CTR",
    "dropphycty": "SCOTTSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 245909998,
    "dropmaladd": "110 SCOTTSVILLE CTR",
    "dropmalcty": "SCOTTSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 245909998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342862002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27614",
    "droptype": "D",
    "dropname": "SEAFORD",
    "dropdeladd": "2300 SEAFORD RD",
    "dropdelcty": "SEAFORD",
    "dropdelst": "VA",
    "dropdelzpp": 236969998,
    "dropphyadd": "2300 SEAFORD RD",
    "dropphycty": "SEAFORD",
    "dropphyst": "VA",
    "dropphyzpp": 236969998,
    "dropmaladd": "2300 SEAFORD RD",
    "dropmalcty": "SEAFORD",
    "dropmalst": "VA",
    "dropmalzpp": 236969998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7578987471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27615",
    "droptype": "D",
    "dropname": "SEALSTON",
    "dropdeladd": "1130 KINGS HWY",
    "dropdelcty": "SEALSTON",
    "dropdelst": "VA",
    "dropdelzpp": 225479998,
    "dropphyadd": "1130 KINGS HWY",
    "dropphycty": "SEALSTON",
    "dropphyst": "VA",
    "dropphyzpp": 225479998,
    "dropmaladd": "1130 KINGS HWY",
    "dropmalcty": "SEALSTON",
    "dropmalst": "VA",
    "dropmalzpp": 225479998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407753158,
    "dropsitcph": 5407753158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27618",
    "droptype": "D",
    "dropname": "SEDLEY",
    "dropdeladd": "18050 JOHNSONS MILL RD",
    "dropdelcty": "SEDLEY",
    "dropdelst": "VA",
    "dropdelzpp": 238789998,
    "dropphyadd": "18050 JOHNSONS MILL RD",
    "dropphycty": "SEDLEY",
    "dropphyst": "VA",
    "dropphyzpp": 238789998,
    "dropmaladd": "18050 JOHNSONS MILL RD",
    "dropmalcty": "SEDLEY",
    "dropmalst": "VA",
    "dropmalzpp": 238789998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7575627862,
    "dropsitcph": 7575627862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27619",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "1119 RICHMOND ST",
    "dropdelcty": "SELMA",
    "dropdelst": "VA",
    "dropdelzpp": 244749998,
    "dropphyadd": "1119 RICHMOND ST",
    "dropphycty": "SELMA",
    "dropphyst": "VA",
    "dropphyzpp": 244749998,
    "dropmaladd": "1119 RICHMOND ST",
    "dropmalcty": "SELMA",
    "dropmalst": "VA",
    "dropmalzpp": 244749998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408625093,
    "dropsitcph": 5408625093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27625",
    "droptype": "D",
    "dropname": "SHACKLEFORDS",
    "dropdeladd": "30165 THE TRL",
    "dropdelcty": "SHACKLEFORDS",
    "dropdelst": "VA",
    "dropdelzpp": 231569998,
    "dropphyadd": "30165 THE TRL",
    "dropphycty": "SHACKLEFORDS",
    "dropphyst": "VA",
    "dropphyzpp": 231569998,
    "dropmaladd": "30165 THE TRL",
    "dropmalcty": "SHACKLEFORDS",
    "dropmalst": "VA",
    "dropmalzpp": 231569998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047852440,
    "dropsitcph": 8047852440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27632",
    "droptype": "D",
    "dropname": "SHARPS",
    "dropdeladd": "5231 SHARPS RD",
    "dropdelcty": "SHARPS",
    "dropdelst": "VA",
    "dropdelzpp": 225489998,
    "dropphyadd": "5231 SHARPS RD",
    "dropphycty": "SHARPS",
    "dropphyst": "VA",
    "dropphyzpp": 225489998,
    "dropmaladd": "5231 SHARPS RD",
    "dropmalcty": "SHARPS",
    "dropmalst": "VA",
    "dropmalzpp": 225489998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043949745,
    "dropsitcph": 8043949745,
    "dropfax": 8043949745
  },
  {
    "dcode": "D",
    "dropkey": "PX27633",
    "droptype": "D",
    "dropname": "SHAWSVILLE",
    "dropdeladd": "6914 ROANOKE RD",
    "dropdelcty": "SHAWSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241629998,
    "dropphyadd": "6914 ROANOKE RD",
    "dropphycty": "SHAWSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241629998,
    "dropmaladd": "6914 ROANOKE RD",
    "dropmalcty": "SHAWSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241629998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5402682895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27635",
    "droptype": "D",
    "dropname": "SHENANDOAH",
    "dropdeladd": "206 VIRGINIA AVE",
    "dropdelcty": "SHENANDOAH",
    "dropdelst": "VA",
    "dropdelzpp": 228499998,
    "dropphyadd": "206 VIRGINIA AVE",
    "dropphycty": "SHENANDOAH",
    "dropphyst": "VA",
    "dropphyzpp": 228499998,
    "dropmaladd": "206 VIRGINIA AVE",
    "dropmalcty": "SHENANDOAH",
    "dropmalst": "VA",
    "dropmalzpp": 228499998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5406526588,
    "dropsitcph": 5406526588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27642",
    "droptype": "D",
    "dropname": "SHIPMAN",
    "dropdeladd": "10697 JAMES RIVER RD",
    "dropdelcty": "SHIPMAN",
    "dropdelst": "VA",
    "dropdelzpp": 229719998,
    "dropphyadd": "10697 JAMES RIVER RD",
    "dropphycty": "SHIPMAN",
    "dropphyst": "VA",
    "dropphyzpp": 229719998,
    "dropmaladd": "10697 JAMES RIVER RD",
    "dropmalcty": "SHIPMAN",
    "dropmalst": "VA",
    "dropmalzpp": 229719998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342635374,
    "dropsitcph": 4342635374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27650",
    "droptype": "D",
    "dropname": "SINGERS GLEN",
    "dropdeladd": "9858 SINGERS GLEN RD",
    "dropdelcty": "SINGERS GLEN",
    "dropdelst": "VA",
    "dropdelzpp": 228509998,
    "dropphyadd": "9858 SINGERS GLEN RD",
    "dropphycty": "SINGERS GLEN",
    "dropphyst": "VA",
    "dropphyzpp": 228509998,
    "dropmaladd": "9858 SINGERS GLEN RD",
    "dropmalcty": "SINGERS GLEN",
    "dropmalst": "VA",
    "dropmalzpp": 228509998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408338762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27652",
    "droptype": "D",
    "dropname": "SKIPPERS",
    "dropdeladd": "5334 SKIPPERS RD",
    "dropdelcty": "SKIPPERS",
    "dropdelst": "VA",
    "dropdelzpp": 238799998,
    "dropphyadd": "5334 SKIPPERS RD",
    "dropphycty": "SKIPPERS",
    "dropphyst": "VA",
    "dropphyzpp": 238799998,
    "dropmaladd": "5334 SKIPPERS RD",
    "dropmalcty": "SKIPPERS",
    "dropmalst": "VA",
    "dropmalzpp": 238799998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346344540,
    "dropsitcph": 4346344540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27653",
    "droptype": "D",
    "dropname": "SKIPWITH",
    "dropdeladd": "6000 SKIPWITH RD",
    "dropdelcty": "SKIPWITH",
    "dropdelst": "VA",
    "dropdelzpp": 239689998,
    "dropphyadd": "6000 SKIPWITH RD",
    "dropphycty": "SKIPWITH",
    "dropphyst": "VA",
    "dropphyzpp": 239689998,
    "dropmaladd": "6000 SKIPWITH RD",
    "dropmalcty": "SKIPWITH",
    "dropmalst": "VA",
    "dropmalzpp": 239689998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043723460,
    "dropsitcph": 4343723460,
    "dropfax": 4343723460
  },
  {
    "dcode": "D",
    "dropkey": "PX27655",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "234 MAIN ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 234309998,
    "dropphyadd": "234 MAIN ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 234309998,
    "dropmaladd": "234 MAIN ST",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 234309998,
    "dropsitphn": 7575426016,
    "dropsitlph": 7573573970,
    "dropsitcph": 7573573970,
    "dropfax": 7575426017
  },
  {
    "dcode": "D",
    "dropkey": "PX27662",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "14257 BLUE RIDGE TPKE",
    "dropdelcty": "SOMERSET",
    "dropdelst": "VA",
    "dropdelzpp": 229729998,
    "dropphyadd": "14257 BLUE RIDGE TPKE",
    "dropphycty": "SOMERSET",
    "dropphyst": "VA",
    "dropphyzpp": 229729998,
    "dropmaladd": "14257 BLUE RIDGE TPKE",
    "dropmalcty": "SOMERSET",
    "dropmalst": "VA",
    "dropmalzpp": 229729998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5406722492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27663",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "2392 MIDLAND RD",
    "dropdelcty": "MIDLAND",
    "dropdelst": "VA",
    "dropdelzpp": 227282523,
    "dropphyadd": "2392 MIDLAND RD",
    "dropphycty": "MIDLAND",
    "dropphyst": "VA",
    "dropphyzpp": 227282523,
    "dropmaladd": "2392 MIDLAND RD",
    "dropmalcty": "MIDLAND",
    "dropmalst": "VA",
    "dropmalzpp": 227282523,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037889938,
    "dropsitcph": 7037889938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27674",
    "droptype": "D",
    "dropname": "SOUTH BOSTON",
    "dropdeladd": "601 N MAIN ST",
    "dropdelcty": "SOUTH BOSTON",
    "dropdelst": "VA",
    "dropdelzpp": 245929998,
    "dropphyadd": "601 N MAIN ST",
    "dropphycty": "SOUTH BOSTON",
    "dropphyst": "VA",
    "dropphyzpp": 245929998,
    "dropmaladd": "601 N MAIN ST",
    "dropmalcty": "SOUTH BOSTON",
    "dropmalst": "VA",
    "dropmalzpp": 245929998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345757921,
    "dropfax": 4345755081
  },
  {
    "dcode": "D",
    "dropkey": "PX27677",
    "droptype": "D",
    "dropname": "SOUTH HILL",
    "dropdeladd": "216 E FERRELL ST",
    "dropdelcty": "SOUTH HILL",
    "dropdelst": "VA",
    "dropdelzpp": 239709998,
    "dropphyadd": "216 E FERRELL ST",
    "dropphycty": "SOUTH HILL",
    "dropphyst": "VA",
    "dropphyzpp": 239709998,
    "dropmaladd": "216 E FERRELL ST",
    "dropmalcty": "SOUTH HILL",
    "dropmalst": "VA",
    "dropmalzpp": 239709998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4344474664,
    "dropsitcph": 4344474664,
    "dropfax": 8044473017
  },
  {
    "dcode": "D",
    "dropkey": "PX27692",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "24100 SPARTA RD",
    "dropdelcty": "SPARTA",
    "dropdelst": "VA",
    "dropdelzpp": 225529998,
    "dropphyadd": "24100 SPARTA RD",
    "dropphycty": "SPARTA",
    "dropphyst": "VA",
    "dropphyzpp": 225529998,
    "dropmaladd": "24100 SPARTA RD",
    "dropmalcty": "SPARTA",
    "dropmalst": "VA",
    "dropmalzpp": 225529998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 8046339742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27693",
    "droptype": "D",
    "dropname": "SPEEDWELL",
    "dropdeladd": "6766 GRAYSON TPKE",
    "dropdelcty": "SPEEDWELL",
    "dropdelst": "VA",
    "dropdelzpp": 243749998,
    "dropphyadd": "6766 GRAYSON TPKE",
    "dropphycty": "SPEEDWELL",
    "dropphyst": "VA",
    "dropphyzpp": 243749998,
    "dropmaladd": "6766 GRAYSON TPKE",
    "dropmalcty": "SPEEDWELL",
    "dropmalst": "VA",
    "dropmalzpp": 243749998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766214721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27694",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "33 SPENCER PENN RD",
    "dropdelcty": "SPENCER",
    "dropdelst": "VA",
    "dropdelzpp": 241659998,
    "dropphyadd": "33 SPENCER PENN RD",
    "dropphycty": "SPENCER",
    "dropphyst": "VA",
    "dropphyzpp": 241659998,
    "dropmaladd": "33 SPENCER PENN RD",
    "dropmalcty": "SPENCER",
    "dropmalst": "VA",
    "dropmalzpp": 241659998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769572780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27695",
    "droptype": "D",
    "dropname": "SPERRYVILLE",
    "dropdeladd": "43 MAIN ST",
    "dropdelcty": "SPERRYVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 227409998,
    "dropphyadd": "43 MAIN ST",
    "dropphycty": "SPERRYVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 227409998,
    "dropmaladd": "43 MAIN ST",
    "dropmalcty": "SPERRYVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 227409998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409878388,
    "dropsitcph": 5409878388,
    "dropfax": 5409871098
  },
  {
    "dcode": "D",
    "dropkey": "PX27701",
    "droptype": "D",
    "dropname": "SPOTSYLVANIA",
    "dropdeladd": "7420 BROCK RD",
    "dropdelcty": "SPOTSYLVANIA",
    "dropdelst": "VA",
    "dropdelzpp": 225539998,
    "dropphyadd": "7420 BROCK RD",
    "dropphycty": "SPOTSYLVANIA",
    "dropphyst": "VA",
    "dropphyzpp": 225539998,
    "dropmaladd": "7420 BROCK RD",
    "dropmalcty": "SPOTSYLVANIA",
    "dropmalst": "VA",
    "dropmalzpp": 225539998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407686002,
    "dropsitcph": 5405826773,
    "dropfax": 5405826032
  },
  {
    "dcode": "D",
    "dropkey": "PX27703",
    "droptype": "D",
    "dropname": "SPOUT SPRING",
    "dropdeladd": "837 SPOUT SPRING RD",
    "dropdelcty": "SPOUT SPRING",
    "dropdelst": "VA",
    "dropdelzpp": 245939998,
    "dropphyadd": "837 SPOUT SPRING RD",
    "dropphycty": "SPOUT SPRING",
    "dropphyst": "VA",
    "dropphyzpp": 245939998,
    "dropmaladd": "837 SPOUT SPRING RD",
    "dropmalcty": "SPOUT SPRING",
    "dropmalst": "VA",
    "dropmalzpp": 245939998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4343522188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27705",
    "droptype": "D",
    "dropname": "SPRING GROVE",
    "dropdeladd": "17 SWANNS POINT RD",
    "dropdelcty": "SPRING GROVE",
    "dropdelst": "VA",
    "dropdelzpp": 238819998,
    "dropphyadd": "17 SWANNS POINT RD",
    "dropphycty": "SPRING GROVE",
    "dropphyst": "VA",
    "dropphyzpp": 238819998,
    "dropmaladd": "17 SWANNS POINT RD",
    "dropmalcty": "SPRING GROVE",
    "dropmalst": "VA",
    "dropmalzpp": 238819998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7578668420,
    "dropsitcph": 7578668420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27707",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "7051 BROOKFIELD PLZ",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 221509998,
    "dropphyadd": "7051 BROOKFIELD PLZ",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 221509998,
    "dropmaladd": "7051 BROOKFIELD PLZ",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 221509998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035698073,
    "dropsitcph": 7035698073,
    "dropfax": 7034515638
  },
  {
    "dcode": "D",
    "dropkey": "PX27736",
    "droptype": "D",
    "dropname": "STAFFORD",
    "dropdeladd": "2650 RICHMOND HWY",
    "dropdelcty": "STAFFORD",
    "dropdelst": "VA",
    "dropdelzpp": 225549998,
    "dropphyadd": "2650 RICHMOND HWY",
    "dropphycty": "STAFFORD",
    "dropphyst": "VA",
    "dropphyzpp": 225549998,
    "dropmaladd": "2650 RICHMOND HWY",
    "dropmalcty": "STAFFORD",
    "dropmalst": "VA",
    "dropmalzpp": 225549998,
    "dropsitphn": 5406597095,
    "dropsitlph": 5406597095,
    "dropsitcph": 5406597095,
    "dropfax": 5407207500
  },
  {
    "dcode": "D",
    "dropkey": "PX27737",
    "droptype": "D",
    "dropname": "STAFFORDSVILLE",
    "dropdeladd": "494 CEDAR CREST LOOP",
    "dropdelcty": "STAFFORDSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241679998,
    "dropphyadd": "494 CEDAR CREST LOOP",
    "dropphycty": "STAFFORDSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241679998,
    "dropmaladd": "494 CEDAR CREST LOOP",
    "dropmalcty": "STAFFORDSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241679998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409212600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27740",
    "droptype": "D",
    "dropname": "STANARDSVILLE",
    "dropdeladd": "47 CELT RD",
    "dropdelcty": "STANARDSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229739998,
    "dropphyadd": "47 CELT RD",
    "dropphycty": "STANARDSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229739998,
    "dropmaladd": "47 CELT RD",
    "dropmalcty": "STANARDSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229739998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4349857195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27743",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "151 E MAIN ST",
    "dropdelcty": "STANLEY",
    "dropdelst": "VA",
    "dropdelzpp": 228519998,
    "dropphyadd": "151 E MAIN ST",
    "dropphycty": "STANLEY",
    "dropphyst": "VA",
    "dropphyzpp": 228519998,
    "dropmaladd": "151 E MAIN ST",
    "dropmalcty": "STANLEY",
    "dropmalst": "VA",
    "dropmalzpp": 228519998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5407782174,
    "dropsitcph": 5407782174,
    "dropfax": 5407789244
  },
  {
    "dcode": "D",
    "dropkey": "PX27744",
    "droptype": "D",
    "dropname": "STANLEYTOWN",
    "dropdeladd": "180 FAIR OAKS DR",
    "dropdelcty": "STANLEYTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 241689998,
    "dropphyadd": "180 FAIR OAKS DR",
    "dropphycty": "STANLEYTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 241689998,
    "dropmaladd": "180 FAIR OAKS DR",
    "dropmalcty": "STANLEYTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 241689998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766297033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27746",
    "droptype": "D",
    "dropname": "STAR TANNERY",
    "dropdeladd": "2112 STAR TANNERY RD",
    "dropdelcty": "STAR TANNERY",
    "dropdelst": "VA",
    "dropdelzpp": 226542341,
    "dropphyadd": "2112 STAR TANNERY RD",
    "dropphycty": "STAR TANNERY",
    "dropphyst": "VA",
    "dropphyzpp": 226542341,
    "dropmaladd": "152 W KING ST",
    "dropmalcty": "STRASBURG",
    "dropmalst": "VA",
    "dropmalzpp": 226579998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404658083,
    "dropsitcph": 5404659102,
    "dropfax": 5406362381
  },
  {
    "dcode": "D",
    "dropkey": "PX27753",
    "droptype": "D",
    "dropname": "STAUNTON",
    "dropdeladd": "1430 N AUGUSTA ST",
    "dropdelcty": "STAUNTON",
    "dropdelst": "VA",
    "dropdelzpp": 244019998,
    "dropphyadd": "1430 N AUGUSTA ST",
    "dropphycty": "STAUNTON",
    "dropphyst": "VA",
    "dropphyzpp": 244019998,
    "dropmaladd": "1430 N AUGUSTA ST",
    "dropmalcty": "STAUNTON",
    "dropmalst": "VA",
    "dropmalzpp": 244019998,
    "dropsitphn": 5407756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408863295,
    "dropfax": 5408856397
  },
  {
    "dcode": "D",
    "dropkey": "PX27756",
    "droptype": "D",
    "dropname": "STEELES TAVERN",
    "dropdeladd": "6554 LEE JACKSON HWY",
    "dropdelcty": "STEELES TAVERN",
    "dropdelst": "VA",
    "dropdelzpp": 244769998,
    "dropphyadd": "6554 LEE JACKSON HWY",
    "dropphycty": "STEELES TAVERN",
    "dropphyst": "VA",
    "dropphyzpp": 244769998,
    "dropmaladd": "6554 LEE JACKSON HWY",
    "dropmalcty": "STEELES TAVERN",
    "dropmalst": "VA",
    "dropmalzpp": 244769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403772965,
    "dropsitcph": 5403772965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27759",
    "droptype": "D",
    "dropname": "STEPHENS CITY",
    "dropdeladd": "5071 MAIN ST",
    "dropdelcty": "STEPHENS CITY",
    "dropdelst": "VA",
    "dropdelzpp": 226559998,
    "dropphyadd": "5071 MAIN ST",
    "dropphycty": "STEPHENS CITY",
    "dropphyst": "VA",
    "dropphyzpp": 226559998,
    "dropmaladd": "5071 MAIN ST",
    "dropmalcty": "STEPHENS CITY",
    "dropmalst": "VA",
    "dropmalzpp": 226559998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5408682783,
    "dropsitcph": 5408682783,
    "dropfax": 5408693256
  },
  {
    "dcode": "D",
    "dropkey": "PX27762",
    "droptype": "D",
    "dropname": "STEPHENSON",
    "dropdeladd": "2546 MARTINSBURG PIKE STE 2",
    "dropdelcty": "STEPHENSON",
    "dropdelst": "VA",
    "dropdelzpp": 226569998,
    "dropphyadd": "2546 MARTINSBURG PIKE STE 2",
    "dropphycty": "STEPHENSON",
    "dropphyst": "VA",
    "dropphyzpp": 226569998,
    "dropmaladd": "2546 MARTINSBURG PIKE STE 2",
    "dropmalcty": "STEPHENSON",
    "dropmalst": "VA",
    "dropmalzpp": 226569998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406673696,
    "dropsitcph": 5406673696,
    "dropfax": 5406783853
  },
  {
    "dcode": "D",
    "dropkey": "PX27763",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "150 S STERLING BLVD",
    "dropdelcty": "STERLING",
    "dropdelst": "VA",
    "dropdelzpp": 201649998,
    "dropphyadd": "150 S STERLING BLVD",
    "dropphycty": "STERLING",
    "dropphyst": "VA",
    "dropphyzpp": 201649998,
    "dropmaladd": "150 S STERLING BLVD",
    "dropmalcty": "STERLING",
    "dropmalst": "VA",
    "dropmalzpp": 201649998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034443163,
    "dropsitcph": 7034443163,
    "dropfax": 7034218714
  },
  {
    "dcode": "D",
    "dropkey": "PX27766",
    "droptype": "D",
    "dropname": "STEVENSBURG",
    "dropdeladd": "19312 GERMANNA HWY",
    "dropdelcty": "STEVENSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 227411706,
    "dropphyadd": "19312 GERMANNA HWY",
    "dropphycty": "STEVENSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 227411706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEVENSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 227419998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5403991966,
    "dropsitcph": 5403991966,
    "dropfax": 5403999066
  },
  {
    "dcode": "D",
    "dropkey": "PX27776",
    "droptype": "D",
    "dropname": "STONY CREEK",
    "dropdeladd": "12445 MAIN ST",
    "dropdelcty": "STONY CREEK",
    "dropdelst": "VA",
    "dropdelzpp": 238829998,
    "dropphyadd": "12445 MAIN ST",
    "dropphycty": "STONY CREEK",
    "dropphyst": "VA",
    "dropphyzpp": 238829998,
    "dropmaladd": "12445 MAIN ST",
    "dropmalcty": "STONY CREEK",
    "dropmalst": "VA",
    "dropmalzpp": 238829998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342466671,
    "dropsitcph": 4342466671,
    "dropfax": 4342466671
  },
  {
    "dcode": "D",
    "dropkey": "PX27779",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "152 W KING ST",
    "dropdelcty": "STRASBURG",
    "dropdelst": "VA",
    "dropdelzpp": 226579998,
    "dropphyadd": "152 W KING ST",
    "dropphycty": "STRASBURG",
    "dropphyst": "VA",
    "dropphyzpp": 226579998,
    "dropmaladd": "152 W KING ST",
    "dropmalcty": "STRASBURG",
    "dropmalst": "VA",
    "dropmalzpp": 226579998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5404654586,
    "dropsitcph": 5404654586,
    "dropfax": 5404654230
  },
  {
    "dcode": "D",
    "dropkey": "PX27782",
    "droptype": "D",
    "dropname": "STUART",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "STUART",
    "dropdelst": "VA",
    "dropdelzpp": 241719998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "STUART",
    "dropphyst": "VA",
    "dropphyzpp": 241719998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "STUART",
    "dropmalst": "VA",
    "dropmalzpp": 241719998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766943332,
    "dropfax": 2766947494
  },
  {
    "dcode": "D",
    "dropkey": "PX27783",
    "droptype": "D",
    "dropname": "STUARTS DRAFT",
    "dropdeladd": "2857 STUARTS DRAFT HWY STE 133",
    "dropdelcty": "STUARTS DRAFT",
    "dropdelst": "VA",
    "dropdelzpp": 244772787,
    "dropphyadd": "2857 STUARTS DRAFT HWY STE 133",
    "dropphycty": "STUARTS DRAFT",
    "dropphyst": "VA",
    "dropphyzpp": 244772787,
    "dropmaladd": "2857 STUARTS DRAFT HWY STE 133",
    "dropmalcty": "STUARTS DRAFT",
    "dropmalst": "VA",
    "dropmalzpp": 244772787,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403372104,
    "dropsitcph": 5403372104,
    "dropfax": 6505783305
  },
  {
    "dcode": "D",
    "dropkey": "PX27784",
    "droptype": "D",
    "dropname": "STUDLEY",
    "dropdeladd": "5411 STUDLEY RD",
    "dropdelcty": "STUDLEY",
    "dropdelst": "VA",
    "dropdelzpp": 231629998,
    "dropphyadd": "5411 STUDLEY RD",
    "dropphycty": "STUDLEY",
    "dropphyst": "VA",
    "dropphyzpp": 231629997,
    "dropmaladd": "5411 STUDLEY RD",
    "dropmalcty": "STUDLEY",
    "dropmalst": "VA",
    "dropmalzpp": 231629998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047460400,
    "dropsitcph": 8047460400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27785",
    "droptype": "D",
    "dropname": "SUFFOLK",
    "dropdeladd": "445 N MAIN ST",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234349998,
    "dropphyadd": "445 N MAIN ST",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234349998,
    "dropmaladd": "445 N MAIN ST",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234349998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575398693,
    "dropsitcph": 7575398693,
    "dropfax": 7575392647
  },
  {
    "dcode": "D",
    "dropkey": "PX27786",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "5444 SUGAR GROVE HWY",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "VA",
    "dropdelzpp": 243759998,
    "dropphyadd": "5444 SUGAR GROVE HWY",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "VA",
    "dropphyzpp": 243759998,
    "dropmaladd": "5444 SUGAR GROVE HWY",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "VA",
    "dropmalzpp": 243759998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766773200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27787",
    "droptype": "D",
    "dropname": "SUMERDUCK",
    "dropdeladd": "5338 SUMERDUCK RD",
    "dropdelcty": "SUMERDUCK",
    "dropdelst": "VA",
    "dropdelzpp": 227429997,
    "dropphyadd": "5338 SUMERDUCK RD",
    "dropphycty": "SUMERDUCK",
    "dropphyst": "VA",
    "dropphyzpp": 227429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMERDUCK",
    "dropmalst": "VA",
    "dropmalzpp": 227429998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404398908,
    "dropsitcph": 5404398908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27790",
    "droptype": "D",
    "dropname": "SURRY",
    "dropdeladd": "91 COLONIAL TRL E",
    "dropdelcty": "SURRY",
    "dropdelst": "VA",
    "dropdelzpp": 238839998,
    "dropphyadd": "91 COLONIAL TRL E",
    "dropphycty": "SURRY",
    "dropphyst": "VA",
    "dropphyzpp": 238839998,
    "dropmaladd": "91 COLONIAL TRL E",
    "dropmalcty": "SURRY",
    "dropmalst": "VA",
    "dropmalzpp": 238839998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7572943993,
    "dropsitcph": 7572943993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27791",
    "droptype": "D",
    "dropname": "SUSAN",
    "dropdeladd": "5297 NEW POINT COMFORT HWY",
    "dropdelcty": "SUSAN",
    "dropdelst": "VA",
    "dropdelzpp": 231639998,
    "dropphyadd": "5297 NEW POINT COMFORT HWY",
    "dropphycty": "SUSAN",
    "dropphyst": "VA",
    "dropphyzpp": 231639998,
    "dropmaladd": "5297 NEW POINT COMFORT HWY",
    "dropmalcty": "SUSAN",
    "dropmalst": "VA",
    "dropmalzpp": 231639998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047259808,
    "dropsitcph": 8047259808,
    "dropfax": 8047259808
  },
  {
    "dcode": "D",
    "dropkey": "PX27792",
    "droptype": "D",
    "dropname": "SUSSEX",
    "dropdeladd": "15083 COURTHOUSE RD",
    "dropdelcty": "SUSSEX",
    "dropdelst": "VA",
    "dropdelzpp": 238849998,
    "dropphyadd": "15083 COURTHOUSE RD",
    "dropphycty": "SUSSEX",
    "dropphyst": "VA",
    "dropphyzpp": 238849998,
    "dropmaladd": "15083 COURTHOUSE RD",
    "dropmalcty": "SUSSEX",
    "dropmalst": "VA",
    "dropmalzpp": 238849998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342469338,
    "dropsitcph": 4342469338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27793",
    "droptype": "D",
    "dropname": "SUTHERLAND",
    "dropdeladd": "5503 HART RD",
    "dropdelcty": "SUTHERLAND",
    "dropdelst": "VA",
    "dropdelzpp": 238859998,
    "dropphyadd": "5503 HART RD",
    "dropphycty": "SUTHERLAND",
    "dropphyst": "VA",
    "dropphyzpp": 238859998,
    "dropmaladd": "5503 HART RD",
    "dropmalcty": "SUTHERLAND",
    "dropmalst": "VA",
    "dropmalzpp": 238859998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047330143,
    "dropsitcph": 8047330143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27794",
    "droptype": "D",
    "dropname": "SUTHERLIN",
    "dropdeladd": "2061 LAUREL GROVE RD",
    "dropdelcty": "SUTHERLIN",
    "dropdelst": "VA",
    "dropdelzpp": 245949998,
    "dropphyadd": "2061 LAUREL GROVE RD",
    "dropphycty": "SUTHERLIN",
    "dropphyst": "VA",
    "dropphyzpp": 245949998,
    "dropmaladd": "2061 LAUREL GROVE RD",
    "dropmalcty": "SUTHERLIN",
    "dropmalst": "VA",
    "dropmalzpp": 245949998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4348226095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27797",
    "droptype": "D",
    "dropname": "SWOOPE",
    "dropdeladd": "1351 HEWITT RD",
    "dropdelcty": "SWOOPE",
    "dropdelst": "VA",
    "dropdelzpp": 244799998,
    "dropphyadd": "1351 HEWITT RD",
    "dropphycty": "SWOOPE",
    "dropphyst": "VA",
    "dropphyzpp": 244799998,
    "dropmaladd": "1351 HEWITT RD",
    "dropmalcty": "SWOOPE",
    "dropmalst": "VA",
    "dropmalzpp": 244799998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403483587,
    "dropsitcph": 5403483587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27798",
    "droptype": "D",
    "dropname": "SWORDS CREEK",
    "dropdeladd": "4209 SWORDS CREEK RD",
    "dropdelcty": "SWORDS CREEK",
    "dropdelst": "VA",
    "dropdelzpp": 246499998,
    "dropphyadd": "4209 SWORDS CREEK RD",
    "dropphycty": "SWORDS CREEK",
    "dropphyst": "VA",
    "dropphyzpp": 246499998,
    "dropmaladd": "4209 SWORDS CREEK RD",
    "dropmalcty": "SWORDS CREEK",
    "dropmalst": "VA",
    "dropmalzpp": 246499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769910025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27801",
    "droptype": "D",
    "dropname": "SYRIA",
    "dropdeladd": "3624 OLD BLUE RIDGE TPKE",
    "dropdelcty": "SYRIA",
    "dropdelst": "VA",
    "dropdelzpp": 227439998,
    "dropphyadd": "3624 OLD BLUE RIDGE TPKE",
    "dropphycty": "SYRIA",
    "dropphyst": "VA",
    "dropphyzpp": 227439998,
    "dropmaladd": "3624 OLD BLUE RIDGE TPKE",
    "dropmalcty": "SYRIA",
    "dropmalst": "VA",
    "dropmalzpp": 227439998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5409234342,
    "dropsitcph": 5409234342,
    "dropfax": 5409234342
  },
  {
    "dcode": "D",
    "dropkey": "PX27805",
    "droptype": "D",
    "dropname": "TANGIER",
    "dropdeladd": "4432 POST OFFICE RD",
    "dropdelcty": "TANGIER",
    "dropdelst": "VA",
    "dropdelzpp": 234403301,
    "dropphyadd": "4432 POST OFFICE RD",
    "dropphycty": "TANGIER",
    "dropphyst": "VA",
    "dropphyzpp": 234403301,
    "dropmaladd": "4432 POST OFFICE RD",
    "dropmalcty": "TANGIER",
    "dropmalst": "VA",
    "dropmalzpp": 234403301,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578912292,
    "dropsitcph": 7578912292,
    "dropfax": 7578912292
  },
  {
    "dcode": "D",
    "dropkey": "PX27806",
    "droptype": "D",
    "dropname": "TANNERSVILLE",
    "dropdeladd": "1347 FREESTONE VALLEY RD",
    "dropdelcty": "TANNERSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 243775000,
    "dropphyadd": "1347 FREESTONE VALLEY RD",
    "dropphycty": "TANNERSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 243775000,
    "dropmaladd": "1347 FREESTONE VALLEY RD",
    "dropmalcty": "TANNERSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 243775000,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2764963322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27807",
    "droptype": "D",
    "dropname": "TAPPAHANNOCK",
    "dropdeladd": "400 WRIGHT ST",
    "dropdelcty": "TAPPAHANNOCK",
    "dropdelst": "VA",
    "dropdelzpp": 225609998,
    "dropphyadd": "400 WRIGHT ST",
    "dropphycty": "TAPPAHANNOCK",
    "dropphyst": "VA",
    "dropphyzpp": 225609998,
    "dropmaladd": "400 WRIGHT ST",
    "dropmalcty": "TAPPAHANNOCK",
    "dropmalst": "VA",
    "dropmalzpp": 225609998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044459178,
    "dropsitcph": 8044459178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27808",
    "droptype": "D",
    "dropname": "TASLEY",
    "dropdeladd": "24148 MERRY BRANCH RD",
    "dropdelcty": "TASLEY",
    "dropdelst": "VA",
    "dropdelzpp": 234419900,
    "dropphyadd": "24148 MERRY BRANCH RD",
    "dropphycty": "TASLEY",
    "dropphyst": "VA",
    "dropphyzpp": 234419900,
    "dropmaladd": "24148 MERRY BRANCH RD",
    "dropmalcty": "TASLEY",
    "dropmalst": "VA",
    "dropmalzpp": 234419900,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292118,
    "dropsitcph": 7577877817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27809",
    "droptype": "D",
    "dropname": "TAZEWELL",
    "dropdeladd": "276 MAIN ST",
    "dropdelcty": "TAZEWELL",
    "dropdelst": "VA",
    "dropdelzpp": 246519995,
    "dropphyadd": "276 MAIN ST",
    "dropphycty": "TAZEWELL",
    "dropphyst": "VA",
    "dropphyzpp": 246519995,
    "dropmaladd": "276 MAIN ST",
    "dropmalcty": "TAZEWELL",
    "dropmalst": "VA",
    "dropmalzpp": 246519995,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2769884880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27810",
    "droptype": "D",
    "dropname": "TEMPERANCEVILLE",
    "dropdeladd": "10469 LANKFORD HWY",
    "dropdelcty": "TEMPERANCEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 234429998,
    "dropphyadd": "10469 LANKFORD HWY",
    "dropphycty": "TEMPERANCEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 234429998,
    "dropmaladd": "10469 LANKFORD HWY",
    "dropmalcty": "TEMPERANCEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 234429998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578245423,
    "dropsitcph": 7578245423,
    "dropfax": 7578245423
  },
  {
    "dcode": "D",
    "dropkey": "PX27811",
    "droptype": "D",
    "dropname": "THAXTON",
    "dropdeladd": "1162 PENICKS MILL RD",
    "dropdelcty": "THAXTON",
    "dropdelst": "VA",
    "dropdelzpp": 241749998,
    "dropphyadd": "1162 PENICKS MILL RD",
    "dropphycty": "THAXTON",
    "dropphyst": "VA",
    "dropphyzpp": 241749998,
    "dropmaladd": "1162 PENICKS MILL RD",
    "dropmalcty": "THAXTON",
    "dropmalst": "VA",
    "dropmalzpp": 241749998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405851007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27813",
    "droptype": "D",
    "dropname": "THE PLAINS",
    "dropdeladd": "4314 FAUQUIER AVE",
    "dropdelcty": "THE PLAINS",
    "dropdelst": "VA",
    "dropdelzpp": 201989997,
    "dropphyadd": "4314 FAUQUIER AVE",
    "dropphycty": "THE PLAINS",
    "dropphyst": "VA",
    "dropphyzpp": 201989997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THE PLAINS",
    "dropmalst": "VA",
    "dropmalzpp": 201989998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5402535274,
    "dropsitcph": 5402535274,
    "dropfax": 5402537047
  },
  {
    "dcode": "D",
    "dropkey": "PX27820",
    "droptype": "D",
    "dropname": "THORNBURG",
    "dropdeladd": "5314 MUDD TAVERN RD",
    "dropdelcty": "THORNBURG",
    "dropdelst": "VA",
    "dropdelzpp": 225659998,
    "dropphyadd": "5314 MUDD TAVERN RD",
    "dropphycty": "THORNBURG",
    "dropphyst": "VA",
    "dropphyzpp": 225659998,
    "dropmaladd": "5314 MUDD TAVERN RD",
    "dropmalcty": "THORNBURG",
    "dropmalst": "VA",
    "dropmalzpp": 225659998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5405825622,
    "dropsitcph": 5405825622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27823",
    "droptype": "D",
    "dropname": "TIMBERVILLE",
    "dropdeladd": "172 S MAIN ST",
    "dropdelcty": "TIMBERVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 228539998,
    "dropphyadd": "172 S MAIN ST",
    "dropphycty": "TIMBERVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 228539998,
    "dropmaladd": "172 S MAIN ST",
    "dropmalcty": "TIMBERVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 228539998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5408965829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27828",
    "droptype": "D",
    "dropname": "TOANO",
    "dropdeladd": "7890 RICHMOND RD",
    "dropdelcty": "TOANO",
    "dropdelst": "VA",
    "dropdelzpp": 231689998,
    "dropphyadd": "7890 RICHMOND RD",
    "dropphycty": "TOANO",
    "dropphyst": "VA",
    "dropphyzpp": 231689998,
    "dropmaladd": "7890 RICHMOND RD",
    "dropmalcty": "TOANO",
    "dropmalst": "VA",
    "dropmalzpp": 231689998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045661328,
    "dropsitcph": 7575661328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27830",
    "droptype": "D",
    "dropname": "TOMS BROOK",
    "dropdeladd": "3374 S MAIN ST",
    "dropdelcty": "TOMS BROOK",
    "dropdelst": "VA",
    "dropdelzpp": 226601713,
    "dropphyadd": "3374 S MAIN ST",
    "dropphycty": "TOMS BROOK",
    "dropphyst": "VA",
    "dropphyzpp": 226601713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOMS BROOK",
    "dropmalst": "VA",
    "dropmalzpp": 226609998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5404369167,
    "dropsitcph": 5404369167,
    "dropfax": 5404363523
  },
  {
    "dcode": "D",
    "dropkey": "PX27831",
    "droptype": "D",
    "dropname": "TOPPING",
    "dropdeladd": "882 GREYS POINT RD",
    "dropdelcty": "TOPPING",
    "dropdelst": "VA",
    "dropdelzpp": 231699998,
    "dropphyadd": "882 GREYS POINT RD",
    "dropphycty": "TOPPING",
    "dropphyst": "VA",
    "dropphyzpp": 231699998,
    "dropmaladd": "882 GREYS POINT RD",
    "dropmalcty": "TOPPING",
    "dropmalst": "VA",
    "dropmalzpp": 231699998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047584100,
    "dropsitcph": 8047584100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27832",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "28463 SEASIDE RD",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "VA",
    "dropdelzpp": 234439998,
    "dropphyadd": "28463 SEASIDE RD",
    "dropphycty": "TOWNSEND",
    "dropphyst": "VA",
    "dropphyzpp": 234439998,
    "dropmaladd": "28463 SEASIDE RD",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "VA",
    "dropmalzpp": 234439998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573311061,
    "dropsitcph": 7573311061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27837",
    "droptype": "D",
    "dropname": "TRIANGLE",
    "dropdeladd": "18627 OLD TRIANGLE RD",
    "dropdelcty": "TRIANGLE",
    "dropdelst": "VA",
    "dropdelzpp": 221729998,
    "dropphyadd": "18627 OLD TRIANGLE RD",
    "dropphycty": "TRIANGLE",
    "dropphyst": "VA",
    "dropphyzpp": 221729998,
    "dropmaladd": "18627 OLD TRIANGLE RD",
    "dropmalcty": "TRIANGLE",
    "dropmalst": "VA",
    "dropmalzpp": 221729998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7032219546,
    "dropsitcph": 7032219546,
    "dropfax": 7032218286
  },
  {
    "dcode": "D",
    "dropkey": "PX27839",
    "droptype": "D",
    "dropname": "TROUTDALE",
    "dropdeladd": "93 RIPSHIN RD",
    "dropdelcty": "TROUTDALE",
    "dropdelst": "VA",
    "dropdelzpp": 243789998,
    "dropphyadd": "93 RIPSHIN RD",
    "dropphycty": "TROUTDALE",
    "dropphyst": "VA",
    "dropphyzpp": 243789998,
    "dropmaladd": "93 RIPSHIN RD",
    "dropmalcty": "TROUTDALE",
    "dropmalst": "VA",
    "dropmalzpp": 243789998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766773221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27840",
    "droptype": "D",
    "dropname": "TROUTVILLE",
    "dropdeladd": "4952 LEE HWY",
    "dropdelcty": "TROUTVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241759998,
    "dropphyadd": "4952 LEE HWY",
    "dropphycty": "TROUTVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241759998,
    "dropmaladd": "4952 LEE HWY",
    "dropmalcty": "TROUTVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241759998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409921472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27841",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "25 TROY RD",
    "dropdelcty": "TROY",
    "dropdelst": "VA",
    "dropdelzpp": 229749998,
    "dropphyadd": "25 TROY RD",
    "dropphycty": "TROY",
    "dropphyst": "VA",
    "dropphyzpp": 229749998,
    "dropmaladd": "25 TROY RD",
    "dropmalcty": "TROY",
    "dropmalst": "VA",
    "dropmalzpp": 229749998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4345898512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27853",
    "droptype": "D",
    "dropname": "UNION HALL",
    "dropdeladd": "66 BERGER LOOP",
    "dropdelcty": "UNION HALL",
    "dropdelst": "VA",
    "dropdelzpp": 241769998,
    "dropphyadd": "66 BERGER LOOP",
    "dropphycty": "UNION HALL",
    "dropphyst": "VA",
    "dropphyzpp": 241769998,
    "dropmaladd": "66 BERGER LOOP",
    "dropmalcty": "UNION HALL",
    "dropmalst": "VA",
    "dropmalzpp": 241769998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5405762012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27854",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "23209 VILLAGE RD",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 225679998,
    "dropphyadd": "23209 VILLAGE RD",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 225679998,
    "dropmaladd": "23209 VILLAGE RD",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 225679998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408544927,
    "dropsitcph": 5408544927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27865",
    "droptype": "D",
    "dropname": "UPPERVILLE",
    "dropdeladd": "9090 JOHN S MOSBY HWY",
    "dropdelcty": "UPPERVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201849998,
    "dropphyadd": "9090 JOHN S MOSBY HWY",
    "dropphycty": "UPPERVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201849998,
    "dropmaladd": "9090 JOHN S MOSBY HWY",
    "dropmalcty": "UPPERVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201849998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5405923687,
    "dropsitcph": 5405923687,
    "dropfax": 5405923687
  },
  {
    "dcode": "D",
    "dropkey": "PX27867",
    "droptype": "D",
    "dropname": "URBANNA",
    "dropdeladd": "251 VIRGINIA ST",
    "dropdelcty": "URBANNA",
    "dropdelst": "VA",
    "dropdelzpp": 231759998,
    "dropphyadd": "251 VIRGINIA ST",
    "dropphycty": "URBANNA",
    "dropphyst": "VA",
    "dropphyzpp": 231759998,
    "dropmaladd": "251 VIRGINIA ST",
    "dropmalcty": "URBANNA",
    "dropmalst": "VA",
    "dropmalzpp": 231759998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047585355,
    "dropsitcph": 8047585355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27876",
    "droptype": "D",
    "dropname": "VALENTINES",
    "dropdeladd": "23 MANNING DR",
    "dropdelcty": "VALENTINES",
    "dropdelst": "VA",
    "dropdelzpp": 238879998,
    "dropphyadd": "23 MANNING DR",
    "dropphycty": "VALENTINES",
    "dropphyst": "VA",
    "dropphyzpp": 238879998,
    "dropmaladd": "23 MANNING DR",
    "dropmalcty": "VALENTINES",
    "dropmalst": "VA",
    "dropmalzpp": 238879998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4345772456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27877",
    "droptype": "D",
    "dropname": "VANSANT",
    "dropdeladd": "1903 LOVERS GAP RD",
    "dropdelcty": "VANSANT",
    "dropdelst": "VA",
    "dropdelzpp": 246569998,
    "dropphyadd": "1903 LOVERS GAP RD",
    "dropphycty": "VANSANT",
    "dropphyst": "VA",
    "dropphyzpp": 246569998,
    "dropmaladd": "1903 LOVERS GAP RD",
    "dropmalcty": "VANSANT",
    "dropmalst": "VA",
    "dropmalzpp": 246569998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765978009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27882",
    "droptype": "D",
    "dropname": "VERNON HILL",
    "dropdeladd": "10164 MOUNTAIN RD",
    "dropdelcty": "VERNON HILL",
    "dropdelst": "VA",
    "dropdelzpp": 245979998,
    "dropphyadd": "10164 MOUNTAIN RD",
    "dropphycty": "VERNON HILL",
    "dropphyst": "VA",
    "dropphyzpp": 245979998,
    "dropmaladd": "10164 MOUNTAIN RD",
    "dropmalcty": "VERNON HILL",
    "dropmalst": "VA",
    "dropmalzpp": 245979998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4344767145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27883",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "485 LEE HWY",
    "dropdelcty": "VERONA",
    "dropdelst": "VA",
    "dropdelzpp": 244829998,
    "dropphyadd": "485 LEE HWY",
    "dropphycty": "VERONA",
    "dropphyst": "VA",
    "dropphyzpp": 244829998,
    "dropmaladd": "485 LEE HWY",
    "dropmalcty": "VERONA",
    "dropmalst": "VA",
    "dropmalzpp": 244829998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402482833,
    "dropsitcph": 5402482833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27884",
    "droptype": "D",
    "dropname": "VESTA",
    "dropdeladd": "16 COMMUNITY LN",
    "dropdelcty": "VESTA",
    "dropdelst": "VA",
    "dropdelzpp": 241779998,
    "dropphyadd": "16 COMMUNITY LN",
    "dropphycty": "VESTA",
    "dropphyst": "VA",
    "dropphyzpp": 241779998,
    "dropmaladd": "16 COMMUNITY LN",
    "dropmalcty": "VESTA",
    "dropmalst": "VA",
    "dropmalzpp": 241779998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769522195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27885",
    "droptype": "D",
    "dropname": "VESUVIUS",
    "dropdeladd": "7255 S RIVER RD",
    "dropdelcty": "VESUVIUS",
    "dropdelst": "VA",
    "dropdelzpp": 244839998,
    "dropphyadd": "7255 S RIVER RD",
    "dropphycty": "VESUVIUS",
    "dropphyst": "VA",
    "dropphyzpp": 244839998,
    "dropmaladd": "7255 S RIVER RD",
    "dropmalcty": "VESUVIUS",
    "dropmalst": "VA",
    "dropmalzpp": 244839998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403779252,
    "dropsitcph": 5403779252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27886",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "1715 MAIN ST",
    "dropdelcty": "VICTORIA",
    "dropdelst": "VA",
    "dropdelzpp": 239749998,
    "dropphyadd": "1715 MAIN ST",
    "dropphycty": "VICTORIA",
    "dropphyst": "VA",
    "dropphyzpp": 239749998,
    "dropmaladd": "1715 MAIN ST",
    "dropmalcty": "VICTORIA",
    "dropmalst": "VA",
    "dropmalzpp": 239749998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346962854,
    "dropsitcph": 4346962854,
    "dropfax": 4346962854
  },
  {
    "dcode": "D",
    "dropkey": "PX27887",
    "droptype": "D",
    "dropname": "VIENNA",
    "dropdeladd": "200 LAWYERS RD NW",
    "dropdelcty": "VIENNA",
    "dropdelst": "VA",
    "dropdelzpp": 221809998,
    "dropphyadd": "200 LAWYERS RD NW",
    "dropphycty": "VIENNA",
    "dropphyst": "VA",
    "dropphyzpp": 221809998,
    "dropmaladd": "200 LAWYERS RD NW",
    "dropmalcty": "VIENNA",
    "dropmalst": "VA",
    "dropmalzpp": 221809998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7032421393,
    "dropsitcph": 7032421393,
    "dropfax": 7039382816
  },
  {
    "dcode": "D",
    "dropkey": "PX27894",
    "droptype": "D",
    "dropname": "VINTON",
    "dropdeladd": "119 S POLLARD ST",
    "dropdelcty": "VINTON",
    "dropdelst": "VA",
    "dropdelzpp": 241799998,
    "dropphyadd": "119 S POLLARD ST",
    "dropphycty": "VINTON",
    "dropphyst": "VA",
    "dropphyzpp": 241799998,
    "dropmaladd": "119 S POLLARD ST",
    "dropmalcty": "VINTON",
    "dropmalst": "VA",
    "dropmalzpp": 241799998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403451495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27895",
    "droptype": "D",
    "dropname": "VIRGILINA",
    "dropdeladd": "1142 7TH ST",
    "dropdelcty": "VIRGILINA",
    "dropdelst": "VA",
    "dropdelzpp": 245989998,
    "dropphyadd": "1142 7TH ST",
    "dropphycty": "VIRGILINA",
    "dropphyst": "VA",
    "dropphyzpp": 245989998,
    "dropmaladd": "1142 7TH ST",
    "dropmalcty": "VIRGILINA",
    "dropmalst": "VA",
    "dropmalzpp": 245989998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345852540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27897",
    "droptype": "D",
    "dropname": "VIRGINIA BEACH",
    "dropdeladd": "501 VIKING DR",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234529998,
    "dropphyadd": "501 VIKING DR",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234529998,
    "dropmaladd": "PO BOX 2215",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234509998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574310488,
    "dropsitcph": 7573400981,
    "dropfax": 7574635925
  },
  {
    "dcode": "D",
    "dropkey": "PX27904",
    "droptype": "D",
    "dropname": "WACHAPREAGUE",
    "dropdeladd": "19 MAIN ST",
    "dropdelcty": "WACHAPREAGUE",
    "dropdelst": "VA",
    "dropdelzpp": 234809998,
    "dropphyadd": "19 MAIN ST",
    "dropphycty": "WACHAPREAGUE",
    "dropphyst": "VA",
    "dropphyzpp": 234809998,
    "dropmaladd": "19 MAIN ST",
    "dropmalcty": "WACHAPREAGUE",
    "dropmalst": "VA",
    "dropmalzpp": 234809998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577871330,
    "dropsitcph": 7577871330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27905",
    "droptype": "D",
    "dropname": "WAKE",
    "dropdeladd": "1360 WAKE RD",
    "dropdelcty": "WAKE",
    "dropdelst": "VA",
    "dropdelzpp": 231769998,
    "dropphyadd": "1360 WAKE RD",
    "dropphycty": "WAKE",
    "dropphyst": "VA",
    "dropphyzpp": 231769998,
    "dropmaladd": "1360 WAKE RD",
    "dropmalcty": "WAKE",
    "dropmalst": "VA",
    "dropmalzpp": 231769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047767221,
    "dropsitcph": 8047767221,
    "dropfax": 8047767221
  },
  {
    "dcode": "D",
    "dropkey": "PX27906",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "312 W CHURCH ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 238889998,
    "dropphyadd": "312 W CHURCH ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 238889998,
    "dropmaladd": "312 W CHURCH ST",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 238889998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7578993196,
    "dropsitcph": 7578993196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27910",
    "droptype": "D",
    "dropname": "WALKERTON",
    "dropdeladd": "2954 WALKERTON LANDING RD",
    "dropdelcty": "WALKERTON",
    "dropdelst": "VA",
    "dropdelzpp": 231779998,
    "dropphyadd": "2954 WALKERTON LANDING RD",
    "dropphycty": "WALKERTON",
    "dropphyst": "VA",
    "dropphyzpp": 231779998,
    "dropmaladd": "2954 WALKERTON LANDING RD",
    "dropmalcty": "WALKERTON",
    "dropmalst": "VA",
    "dropmalzpp": 231779998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047692635,
    "dropsitcph": 8047692635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27920",
    "droptype": "D",
    "dropname": "WARE NECK",
    "dropdeladd": "6495 WARE NECK RD",
    "dropdelcty": "WARE NECK",
    "dropdelst": "VA",
    "dropdelzpp": 231789998,
    "dropphyadd": "6495 WARE NECK RD",
    "dropphycty": "WARE NECK",
    "dropphyst": "VA",
    "dropphyzpp": 231789998,
    "dropmaladd": "6495 WARE NECK RD",
    "dropmalcty": "WARE NECK",
    "dropmalst": "VA",
    "dropmalzpp": 231789998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046933747,
    "dropsitcph": 8046933747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27921",
    "droptype": "D",
    "dropname": "WARFIELD",
    "dropdeladd": "15243 BOYDTON PLANK RD",
    "dropdelcty": "WARFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 238899998,
    "dropphyadd": "15243 BOYDTON PLANK RD",
    "dropphycty": "WARFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 238899998,
    "dropmaladd": "15243 BOYDTON PLANK RD",
    "dropmalcty": "WARFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 238899998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349497821,
    "dropsitcph": 4349497821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27924",
    "droptype": "D",
    "dropname": "WARM SPRINGS",
    "dropdeladd": "97 OLD MILL RD",
    "dropdelcty": "WARM SPRINGS",
    "dropdelst": "VA",
    "dropdelzpp": 244849998,
    "dropphyadd": "97 OLD MILL RD",
    "dropphycty": "WARM SPRINGS",
    "dropphyst": "VA",
    "dropphyzpp": 244849998,
    "dropmaladd": "97 OLD MILL RD",
    "dropmalcty": "WARM SPRINGS",
    "dropmalst": "VA",
    "dropmalzpp": 244849998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408395428,
    "dropsitcph": 5408395428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27926",
    "droptype": "D",
    "dropname": "WARRENTON",
    "dropdeladd": "53 MAIN ST",
    "dropdelcty": "WARRENTON",
    "dropdelst": "VA",
    "dropdelzpp": 201869998,
    "dropphyadd": "53 MAIN ST",
    "dropphycty": "WARRENTON",
    "dropphyst": "VA",
    "dropphyzpp": 201869998,
    "dropmaladd": "53 MAIN ST",
    "dropmalcty": "WARRENTON",
    "dropmalst": "VA",
    "dropmalzpp": 201869998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5404281861,
    "dropsitcph": 5404281861,
    "dropfax": 5403499166
  },
  {
    "dcode": "D",
    "dropkey": "PX27927",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "360 MAIN ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "VA",
    "dropdelzpp": 225729998,
    "dropphyadd": "360 MAIN ST",
    "dropphycty": "WARSAW",
    "dropphyst": "VA",
    "dropphyzpp": 225729998,
    "dropmaladd": "360 MAIN ST",
    "dropmalcty": "WARSAW",
    "dropmalst": "VA",
    "dropmalzpp": 225729998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043331868,
    "dropsitcph": 8043331868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27933",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "2 LEGGETT LN",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 227479906,
    "dropphyadd": "2 LEGGETT LN",
    "dropphycty": "WASHINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 227479906,
    "dropmaladd": "2 LEGGETT LN",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 227479906,
    "dropsitphn": 7036986867,
    "dropsitlph": 5406753881,
    "dropsitcph": 5406753881,
    "dropfax": 5406753087
  },
  {
    "dcode": "D",
    "dropkey": "PX27940",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "40175 MAIN ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "VA",
    "dropdelzpp": 201979997,
    "dropphyadd": "40175 MAIN ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "VA",
    "dropphyzpp": 201979997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERFORD",
    "dropmalst": "VA",
    "dropmalzpp": 201979998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408823545,
    "dropsitcph": 5408823545,
    "dropfax": 5408823736
  },
  {
    "dcode": "D",
    "dropkey": "PX27946",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "325 W MAIN ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "VA",
    "dropdelzpp": 238909998,
    "dropphyadd": "325 W MAIN ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "VA",
    "dropphyzpp": 238909998,
    "dropmaladd": "325 W MAIN ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "VA",
    "dropmalzpp": 238909998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8048343509,
    "dropsitcph": 8048343509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27947",
    "droptype": "D",
    "dropname": "WAYNESBORO",
    "dropdeladd": "200 S WAYNE AVE",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "VA",
    "dropdelzpp": 229809998,
    "dropphyadd": "200 S WAYNE AVE",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "VA",
    "dropphyzpp": 229809998,
    "dropmaladd": "200 S WAYNE AVE",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "VA",
    "dropmalzpp": 229809998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5409427320,
    "dropfax": 5409421675
  },
  {
    "dcode": "D",
    "dropkey": "PX27956",
    "droptype": "D",
    "dropname": "WEEMS",
    "dropdeladd": "3960 WEEMS RD",
    "dropdelcty": "WEEMS",
    "dropdelst": "VA",
    "dropdelzpp": 225769998,
    "dropphyadd": "3960 WEEMS RD",
    "dropphycty": "WEEMS",
    "dropphyst": "VA",
    "dropphyzpp": 225769998,
    "dropmaladd": "3960 WEEMS RD",
    "dropmalcty": "WEEMS",
    "dropmalst": "VA",
    "dropmalzpp": 225769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044386480,
    "dropsitcph": 8044386480,
    "dropfax": 8044386480
  },
  {
    "dcode": "D",
    "dropkey": "PX27961",
    "droptype": "D",
    "dropname": "WEST AUGUSTA",
    "dropdeladd": "209 SHENANDOAH MOUNTAIN DR",
    "dropdelcty": "WEST AUGUSTA",
    "dropdelst": "VA",
    "dropdelzpp": 244859998,
    "dropphyadd": "209 SHENANDOAH MOUNTAIN DR",
    "dropphycty": "WEST AUGUSTA",
    "dropphyst": "VA",
    "dropphyzpp": 244859998,
    "dropmaladd": "209 SHENANDOAH MOUNTAIN DR",
    "dropmalcty": "WEST AUGUSTA",
    "dropmalst": "VA",
    "dropmalzpp": 244859998,
    "dropsitphn": 8047373653,
    "dropsitlph": 5409394640,
    "dropsitcph": 5409394640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27965",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "925 MAIN ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "VA",
    "dropdelzpp": 231819998,
    "dropphyadd": "925 MAIN ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "VA",
    "dropphyzpp": 231819998,
    "dropmaladd": "925 MAIN ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "VA",
    "dropmalzpp": 231819998,
    "dropsitphn": 8047373653,
    "dropsitlph": 8048433181,
    "dropsitcph": 8048433181,
    "dropfax": 8438434528
  },
  {
    "dcode": "D",
    "dropkey": "PX27974",
    "droptype": "D",
    "dropname": "SANDY POINT",
    "dropdeladd": "951 SANDY POINT RD",
    "dropdelcty": "SANDY POINT",
    "dropdelst": "VA",
    "dropdelzpp": 225779998,
    "dropphyadd": "951 SANDY POINT RD",
    "dropphycty": "SANDY POINT",
    "dropphyst": "VA",
    "dropphyzpp": 225779998,
    "dropmaladd": "951 SANDY POINT RD",
    "dropmalcty": "SANDY POINT",
    "dropmalst": "VA",
    "dropmalzpp": 225779998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044724233,
    "dropsitcph": 8044724233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27976",
    "droptype": "D",
    "dropname": "WEYERS CAVE",
    "dropdeladd": "27 DEPOT RD",
    "dropdelcty": "WEYERS CAVE",
    "dropdelst": "VA",
    "dropdelzpp": 244869998,
    "dropphyadd": "27 DEPOT RD",
    "dropphycty": "WEYERS CAVE",
    "dropphyst": "VA",
    "dropphyzpp": 244869998,
    "dropmaladd": "27 DEPOT RD",
    "dropmalcty": "WEYERS CAVE",
    "dropmalst": "VA",
    "dropmalzpp": 244869998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5402349955,
    "dropsitcph": 5402349955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27981",
    "droptype": "D",
    "dropname": "WHITE HALL",
    "dropdeladd": "2958 BROWNS GAP TPKE",
    "dropdelcty": "WHITE HALL",
    "dropdelst": "VA",
    "dropdelzpp": 229879998,
    "dropphyadd": "2958 BROWNS GAP TPKE",
    "dropphycty": "WHITE HALL",
    "dropphyst": "VA",
    "dropphyzpp": 229879998,
    "dropmaladd": "2958 BROWNS GAP TPKE",
    "dropmalcty": "WHITE HALL",
    "dropmalst": "VA",
    "dropmalzpp": 229879998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 4348238204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27982",
    "droptype": "D",
    "dropname": "WHITE MARSH",
    "dropdeladd": "4898 GEORGE WASHINGTON MEMORIAL HWY",
    "dropdelcty": "WHITE MARSH",
    "dropdelst": "VA",
    "dropdelzpp": 231839998,
    "dropphyadd": "4898 GEORGE WASHINGTON MEMORIAL HWY",
    "dropphycty": "WHITE MARSH",
    "dropphyst": "VA",
    "dropphyzpp": 231839998,
    "dropmaladd": "4898 GEORGE WASHINGTON MEMORIAL HWY",
    "dropmalcty": "WHITE MARSH",
    "dropmalst": "VA",
    "dropmalzpp": 231839998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046932951,
    "dropsitcph": 8046932951,
    "dropfax": 8046959035
  },
  {
    "dcode": "D",
    "dropkey": "PX27983",
    "droptype": "D",
    "dropname": "WHITE PLAINS",
    "dropdeladd": "6529 ROBINSON FERRY RD",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "VA",
    "dropdelzpp": 238939998,
    "dropphyadd": "6529 ROBINSON FERRY RD",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "VA",
    "dropphyzpp": 238939998,
    "dropmaladd": "6529 ROBINSON FERRY RD",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "VA",
    "dropmalzpp": 238939998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4346365912,
    "dropsitcph": 4346365912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27985",
    "droptype": "D",
    "dropname": "WHITE POST",
    "dropdeladd": "14725 LORD FAIRFAX HWY",
    "dropdelcty": "WHITE POST",
    "dropdelst": "VA",
    "dropdelzpp": 226639998,
    "dropphyadd": "14725 LORD FAIRFAX HWY",
    "dropphycty": "WHITE POST",
    "dropphyst": "VA",
    "dropphyzpp": 226639998,
    "dropmaladd": "14725 LORD FAIRFAX HWY",
    "dropmalcty": "WHITE POST",
    "dropmalst": "VA",
    "dropmalzpp": 226639998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5408372394,
    "dropsitcph": 5408372394,
    "dropfax": 5408372243
  },
  {
    "dcode": "D",
    "dropkey": "PX27986",
    "droptype": "D",
    "dropname": "WHITE STONE",
    "dropdeladd": "564 RAPPAHANNOCK DR",
    "dropdelcty": "WHITE STONE",
    "dropdelst": "VA",
    "dropdelzpp": 225789998,
    "dropphyadd": "564 RAPPAHANNOCK DR",
    "dropphycty": "WHITE STONE",
    "dropphyst": "VA",
    "dropphyzpp": 225789998,
    "dropmaladd": "564 RAPPAHANNOCK DR",
    "dropmalcty": "WHITE STONE",
    "dropmalst": "VA",
    "dropmalzpp": 225789998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8044351879,
    "dropsitcph": 8044351879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27988",
    "droptype": "D",
    "dropname": "WHITETOP",
    "dropdeladd": "15145 HIGHLANDS PKWY",
    "dropdelcty": "WHITETOP",
    "dropdelst": "VA",
    "dropdelzpp": 242929998,
    "dropphyadd": "15145 HIGHLANDS PKWY",
    "dropphycty": "WHITETOP",
    "dropphyst": "VA",
    "dropphyzpp": 242929998,
    "dropmaladd": "15145 HIGHLANDS PKWY",
    "dropmalcty": "WHITETOP",
    "dropmalst": "VA",
    "dropmalzpp": 242929998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763883476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27989",
    "droptype": "D",
    "dropname": "WHITEWOOD",
    "dropdeladd": "1510 BROWN MOUNTAIN RD",
    "dropdelcty": "WHITEWOOD",
    "dropdelst": "VA",
    "dropdelzpp": 246579998,
    "dropphyadd": "1510 BROWN MOUNTAIN RD",
    "dropphycty": "WHITEWOOD",
    "dropphyst": "VA",
    "dropphyzpp": 246579998,
    "dropmaladd": "1510 BROWN MOUNTAIN RD",
    "dropmalcty": "WHITEWOOD",
    "dropmalst": "VA",
    "dropmalzpp": 246579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2768818151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27994",
    "droptype": "D",
    "dropname": "WICOMICO",
    "dropdeladd": "6926 POWHATAN DR",
    "dropdelcty": "WICOMICO",
    "dropdelst": "VA",
    "dropdelzpp": 231849998,
    "dropphyadd": "6926 POWHATAN DR",
    "dropphycty": "WICOMICO",
    "dropphyst": "VA",
    "dropphyzpp": 231849998,
    "dropmaladd": "6926 POWHATAN DR",
    "dropmalcty": "WICOMICO",
    "dropmalst": "VA",
    "dropmalzpp": 231849998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046424121,
    "dropsitcph": 8046424121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27996",
    "droptype": "D",
    "dropname": "WICOMICO CHURCH",
    "dropdeladd": "5148 JESSE DUPONT MEMORIAL HWY",
    "dropdelcty": "WICOMICO CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 225799998,
    "dropphyadd": "5148 JESSE DUPONT MEMORIAL HWY",
    "dropphycty": "WICOMICO CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 225799998,
    "dropmaladd": "5148 JESSE DUPONT MEMORIAL HWY",
    "dropmalcty": "WICOMICO CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 225799998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045802409,
    "dropsitcph": 8045802409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX27999",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "425 N BOUNDARY ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 231859998,
    "dropphyadd": "425 N BOUNDARY ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 231859998,
    "dropmaladd": "425 N BOUNDARY ST",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 231859998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7572290838,
    "dropsitcph": 7572290838,
    "dropfax": 7572290572
  },
  {
    "dcode": "D",
    "dropkey": "PX28001",
    "droptype": "D",
    "dropname": "WILLIAMSVILLE",
    "dropdeladd": "12258 COWPASTURE RIVER RD S",
    "dropdelcty": "WILLIAMSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 244879998,
    "dropphyadd": "12258 COWPASTURE RIVER RD S",
    "dropphycty": "WILLIAMSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 244879998,
    "dropmaladd": "12258 COWPASTURE RIVER RD S",
    "dropmalcty": "WILLIAMSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 244879998,
    "dropsitphn": 8047756336,
    "dropsitlph": 5409252358,
    "dropsitcph": 5409252358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28004",
    "droptype": "D",
    "dropname": "WILLIS",
    "dropdeladd": "5600 FLOYD HWY S",
    "dropdelcty": "WILLIS",
    "dropdelst": "VA",
    "dropdelzpp": 243809998,
    "dropphyadd": "5600 FLOYD HWY S",
    "dropphycty": "WILLIS",
    "dropphyst": "VA",
    "dropphyzpp": 243809998,
    "dropmaladd": "5600 FLOYD HWY S",
    "dropmalcty": "WILLIS",
    "dropmalst": "VA",
    "dropmalzpp": 243809998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407897940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28005",
    "droptype": "D",
    "dropname": "WILLIS WHARF",
    "dropdeladd": "4457 WILLIS WHARF RD",
    "dropdelcty": "WILLIS WHARF",
    "dropdelst": "VA",
    "dropdelzpp": 234869998,
    "dropphyadd": "4457 WILLIS WHARF RD",
    "dropphycty": "WILLIS WHARF",
    "dropphyst": "VA",
    "dropphyzpp": 234869998,
    "dropmaladd": "4457 WILLIS WHARF RD",
    "dropmalcty": "WILLIS WHARF",
    "dropmalst": "VA",
    "dropmalzpp": 234869998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574426084,
    "dropsitcph": 7574426084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28009",
    "droptype": "D",
    "dropname": "WILSONS",
    "dropdeladd": "2120 SPRINGTON RD",
    "dropdelcty": "WILSONS",
    "dropdelst": "VA",
    "dropdelzpp": 238949998,
    "dropphyadd": "2120 SPRINGTON RD",
    "dropphycty": "WILSONS",
    "dropphyst": "VA",
    "dropphyzpp": 238949998,
    "dropmaladd": "2120 SPRINGTON RD",
    "dropmalcty": "WILSONS",
    "dropmalst": "VA",
    "dropmalzpp": 238949998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042658368,
    "dropsitcph": 8042658368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28012",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "340 N PLEASANT VALLEY RD",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "VA",
    "dropdelzpp": 226019998,
    "dropphyadd": "340 N PLEASANT VALLEY RD",
    "dropphycty": "WINCHESTER",
    "dropphyst": "VA",
    "dropphyzpp": 226019998,
    "dropmaladd": "340 N PLEASANT VALLEY RD",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "VA",
    "dropmalzpp": 226019998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5405457957,
    "dropsitcph": 5405457957,
    "dropfax": 5406784899
  },
  {
    "dcode": "D",
    "dropkey": "PX28017",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "4 E WINDSOR BLVD",
    "dropdelcty": "WINDSOR",
    "dropdelst": "VA",
    "dropdelzpp": 234879998,
    "dropphyadd": "4 E WINDSOR BLVD",
    "dropphycty": "WINDSOR",
    "dropphyst": "VA",
    "dropphyzpp": 234879998,
    "dropmaladd": "4 E WINDSOR BLVD",
    "dropmalcty": "WINDSOR",
    "dropmalst": "VA",
    "dropmalzpp": 234879998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572423658,
    "dropsitcph": 7572423658,
    "dropfax": 7572429407
  },
  {
    "dcode": "D",
    "dropkey": "PX28018",
    "droptype": "D",
    "dropname": "WINGINA",
    "dropdeladd": "13711 NORWOOD RD",
    "dropdelcty": "WINGINA",
    "dropdelst": "VA",
    "dropdelzpp": 245999998,
    "dropphyadd": "13711 NORWOOD RD",
    "dropphycty": "WINGINA",
    "dropphyst": "VA",
    "dropphyzpp": 245999998,
    "dropmaladd": "13711 NORWOOD RD",
    "dropmalcty": "WINGINA",
    "dropmalst": "VA",
    "dropmalzpp": 245999998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342638346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28021",
    "droptype": "D",
    "dropname": "WIRTZ",
    "dropdeladd": "7198 BOOKER T WASHINGTON HWY",
    "dropdelcty": "WIRTZ",
    "dropdelst": "VA",
    "dropdelzpp": 241849998,
    "dropphyadd": "7198 BOOKER T WASHINGTON HWY",
    "dropphycty": "WIRTZ",
    "dropphyst": "VA",
    "dropphyzpp": 241849998,
    "dropmaladd": "7198 BOOKER T WASHINGTON HWY",
    "dropmalcty": "WIRTZ",
    "dropmalst": "VA",
    "dropmalzpp": 241849998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5407218449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28022",
    "droptype": "D",
    "dropname": "WISE",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "WISE",
    "dropdelst": "VA",
    "dropdelzpp": 242939998,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "WISE",
    "dropphyst": "VA",
    "dropphyzpp": 242939998,
    "dropmaladd": "208 MAIN ST",
    "dropmalcty": "WISE",
    "dropmalst": "VA",
    "dropmalzpp": 242939998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2763286053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28024",
    "droptype": "D",
    "dropname": "WITHAMS",
    "dropdeladd": "28309 WITHAMS RD",
    "dropdelcty": "WITHAMS",
    "dropdelst": "VA",
    "dropdelzpp": 234889998,
    "dropphyadd": "28309 WITHAMS RD",
    "dropphycty": "WITHAMS",
    "dropphyst": "VA",
    "dropphyzpp": 234889998,
    "dropmaladd": "28309 WITHAMS RD",
    "dropmalcty": "WITHAMS",
    "dropmalst": "VA",
    "dropmalzpp": 234889998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578244050,
    "dropsitcph": 7578244050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28028",
    "droptype": "D",
    "dropname": "WOLFORD",
    "dropdeladd": "5145 HURLEY RD",
    "dropdelcty": "WOLFORD",
    "dropdelst": "VA",
    "dropdelzpp": 246589998,
    "dropphyadd": "5145 HURLEY RD",
    "dropphycty": "WOLFORD",
    "dropphyst": "VA",
    "dropphyzpp": 246589998,
    "dropmaladd": "5145 HURLEY RD",
    "dropmalcty": "WOLFORD",
    "dropmalst": "VA",
    "dropmalzpp": 246589998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 2765668107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28029",
    "droptype": "D",
    "dropname": "WOLFTOWN",
    "dropdeladd": "216 RAPIDAN CHURCH LN",
    "dropdelcty": "WOLFTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 227489997,
    "dropphyadd": "216 RAPIDAN CHURCH LN",
    "dropphycty": "WOLFTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 227489997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOLFTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 227489998,
    "dropsitphn": 7036986867,
    "dropsitlph": 5409486635,
    "dropsitcph": 5409486635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28032",
    "droptype": "D",
    "dropname": "WOODBRIDGE",
    "dropdeladd": "1810 REDDY DR",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 221919998,
    "dropphyadd": "1810 REDDY DR",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 221919998,
    "dropmaladd": "1810 REDDY DR",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 221919998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7034946407,
    "dropsitcph": 7034946407,
    "dropfax": 7034906746
  },
  {
    "dcode": "D",
    "dropkey": "PX28033",
    "droptype": "D",
    "dropname": "WOODFORD",
    "dropdeladd": "11087 WOODFORD RD",
    "dropdelcty": "WOODFORD",
    "dropdelst": "VA",
    "dropdelzpp": 225809998,
    "dropphyadd": "11087 WOODFORD RD",
    "dropphycty": "WOODFORD",
    "dropphyst": "VA",
    "dropphyzpp": 225809998,
    "dropmaladd": "11087 WOODFORD RD",
    "dropmalcty": "WOODFORD",
    "dropmalst": "VA",
    "dropmalzpp": 225809998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046336923,
    "dropsitcph": 8046336923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28034",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "32 COULSON CHURCH RD",
    "dropdelcty": "WOODLAWN",
    "dropdelst": "VA",
    "dropdelzpp": 243819998,
    "dropphyadd": "32 COULSON CHURCH RD",
    "dropphycty": "WOODLAWN",
    "dropphyst": "VA",
    "dropphyzpp": 243819998,
    "dropmaladd": "32 COULSON CHURCH RD",
    "dropmalcty": "WOODLAWN",
    "dropmalst": "VA",
    "dropmalzpp": 243819998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2762368321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28040",
    "droptype": "D",
    "dropname": "WOODS CROSS ROADS",
    "dropdeladd": "9900 DAVENPORT RD",
    "dropdelcty": "WOODS CROSS ROADS",
    "dropdelst": "VA",
    "dropdelzpp": 231909998,
    "dropphyadd": "9900 DAVENPORT RD",
    "dropphycty": "WOODS CROSS ROADS",
    "dropphyst": "VA",
    "dropphyzpp": 231909998,
    "dropmaladd": "9900 DAVENPORT RD",
    "dropmalcty": "WOODS CROSS ROADS",
    "dropmalst": "VA",
    "dropmalzpp": 231909998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046932722,
    "dropsitcph": 8046932722,
    "dropfax": 8046932722
  },
  {
    "dcode": "D",
    "dropkey": "PX28045",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "120 S MUHLENBERG ST",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "VA",
    "dropdelzpp": 226649998,
    "dropphyadd": "120 S MUHLENBERG ST",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "VA",
    "dropphyzpp": 226649998,
    "dropmaladd": "120 S MUHLENBERG ST",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "VA",
    "dropmalzpp": 226649998,
    "dropsitphn": 7036986367,
    "dropsitlph": 5404591732,
    "dropsitcph": 5404591732,
    "dropfax": 5404599263
  },
  {
    "dcode": "D",
    "dropkey": "PX28050",
    "droptype": "D",
    "dropname": "WOOLWINE",
    "dropdeladd": "9724 WOOLWINE HWY",
    "dropdelcty": "WOOLWINE",
    "dropdelst": "VA",
    "dropdelzpp": 241859998,
    "dropphyadd": "9724 WOOLWINE HWY",
    "dropphycty": "WOOLWINE",
    "dropphyst": "VA",
    "dropphyzpp": 241859998,
    "dropmaladd": "9724 WOOLWINE HWY",
    "dropmalcty": "WOOLWINE",
    "dropmalst": "VA",
    "dropmalzpp": 241859998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2769302232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28054",
    "droptype": "D",
    "dropname": "WYLLIESBURG",
    "dropdeladd": "790 BARNESVILLE HWY",
    "dropdelcty": "WYLLIESBURG",
    "dropdelst": "VA",
    "dropdelzpp": 239769998,
    "dropphyadd": "790 BARNESVILLE HWY",
    "dropphycty": "WYLLIESBURG",
    "dropphyst": "VA",
    "dropphyzpp": 239769998,
    "dropmaladd": "790 BARNESVILLE HWY",
    "dropmalcty": "WYLLIESBURG",
    "dropmalst": "VA",
    "dropmalzpp": 239769998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4347358635,
    "dropsitcph": 4347358635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28056",
    "droptype": "D",
    "dropname": "WYTHEVILLE",
    "dropdeladd": "380 W MAIN ST",
    "dropdelcty": "WYTHEVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 243829998,
    "dropphyadd": "380 W MAIN ST",
    "dropphycty": "WYTHEVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 243829998,
    "dropmaladd": "380 W MAIN ST",
    "dropmalcty": "WYTHEVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 243829998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2762284011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28057",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "20123 COURTHOUSE RD STE A",
    "dropdelcty": "YALE",
    "dropdelst": "VA",
    "dropdelzpp": 238979998,
    "dropphyadd": "20123 COURTHOUSE RD STE A",
    "dropphycty": "YALE",
    "dropphyst": "VA",
    "dropphyzpp": 238979998,
    "dropmaladd": "20123 COURTHOUSE RD STE A",
    "dropmalcty": "YALE",
    "dropmalst": "VA",
    "dropmalzpp": 238979998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4342468621,
    "dropsitcph": 4342468621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28060",
    "droptype": "D",
    "dropname": "YORKTOWN",
    "dropdeladd": "126 BALLARD ST",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "VA",
    "dropdelzpp": 236909998,
    "dropphyadd": "126 BALLARD ST",
    "dropphycty": "YORKTOWN",
    "dropphyst": "VA",
    "dropphyzpp": 236909998,
    "dropmaladd": "126 BALLARD ST",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "VA",
    "dropmalzpp": 236909998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578984401,
    "dropsitcph": 7578984401,
    "dropfax": 7578985497
  },
  {
    "dcode": "D",
    "dropkey": "PX28067",
    "droptype": "D",
    "dropname": "ZUNI",
    "dropdeladd": "5375 WINDSOR BLVD",
    "dropdelcty": "ZUNI",
    "dropdelst": "VA",
    "dropdelzpp": 238989998,
    "dropphyadd": "5375 WINDSOR BLVD",
    "dropphycty": "ZUNI",
    "dropphyst": "VA",
    "dropphyzpp": 238989998,
    "dropmaladd": "5375 WINDSOR BLVD",
    "dropmalcty": "ZUNI",
    "dropmalst": "VA",
    "dropmalzpp": 238989998,
    "dropsitphn": 8047756336,
    "dropsitlph": 7572426301,
    "dropsitcph": 7572426301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28072",
    "droptype": "D",
    "dropname": "ACCOVILLE",
    "dropdeladd": "1983 BUFFALO CREEK RD",
    "dropdelcty": "ACCOVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 256069998,
    "dropphyadd": "1983 BUFFALO CREEK RD",
    "dropphycty": "ACCOVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 256069998,
    "dropmaladd": "1983 BUFFALO CREEK RD",
    "dropmalcty": "ACCOVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 256069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045832443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28076",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "6167 RT 20 SOUTH RD",
    "dropdelcty": "ADRIAN",
    "dropdelst": "WV",
    "dropdelzpp": 262109998,
    "dropphyadd": "6167 RT 20 SOUTH RD",
    "dropphycty": "ADRIAN",
    "dropphyst": "WV",
    "dropphyzpp": 262109998,
    "dropmaladd": "6167 RT 20 SOUTH RD",
    "dropmalcty": "ADRIAN",
    "dropmalst": "WV",
    "dropmalzpp": 262109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044723892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28079",
    "droptype": "D",
    "dropname": "ALDERSON",
    "dropdeladd": "111 RAILROAD AVE",
    "dropdelcty": "ALDERSON",
    "dropdelst": "WV",
    "dropdelzpp": 249109998,
    "dropphyadd": "111 RAILROAD AVE",
    "dropphycty": "ALDERSON",
    "dropphyst": "WV",
    "dropphyzpp": 249109998,
    "dropmaladd": "111 RAILROAD AVE",
    "dropmalcty": "ALDERSON",
    "dropmalst": "WV",
    "dropmalzpp": 249109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044452841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28082",
    "droptype": "D",
    "dropname": "ALKOL",
    "dropdeladd": "5 BULGER RD",
    "dropdelcty": "ALKOL",
    "dropdelst": "WV",
    "dropdelzpp": 255019998,
    "dropphyadd": "5 BULGER RD",
    "dropphycty": "ALKOL",
    "dropphyst": "WV",
    "dropphyzpp": 255019998,
    "dropmaladd": "5 BULGER RD",
    "dropmalcty": "ALKOL",
    "dropmalst": "WV",
    "dropmalzpp": 255019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045242898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28083",
    "droptype": "D",
    "dropname": "ALLEN JUNCTION",
    "dropdeladd": "3891 GULF RD",
    "dropdelcty": "ALLEN JUNCTION",
    "dropdelst": "WV",
    "dropdelzpp": 258109998,
    "dropphyadd": "3891 GULF RD",
    "dropphycty": "ALLEN JUNCTION",
    "dropphyst": "WV",
    "dropphyzpp": 258109998,
    "dropmaladd": "3891 GULF RD",
    "dropmalcty": "ALLEN JUNCTION",
    "dropmalst": "WV",
    "dropmalzpp": 258109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042948561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28084",
    "droptype": "D",
    "dropname": "ALLOY",
    "dropdeladd": "4038 MIDLAND TRL",
    "dropdelcty": "ALLOY",
    "dropdelst": "WV",
    "dropdelzpp": 250029998,
    "dropphyadd": "4038 MIDLAND TRL",
    "dropphycty": "ALLOY",
    "dropphyst": "WV",
    "dropphyzpp": 250029998,
    "dropmaladd": "4038 MIDLAND TRL",
    "dropmalcty": "ALLOY",
    "dropmalst": "WV",
    "dropmalzpp": 250029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047799107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28085",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "134 KLONDIKE RD",
    "dropdelcty": "ALMA",
    "dropdelst": "WV",
    "dropdelzpp": 263209998,
    "dropphyadd": "134 KLONDIKE RD",
    "dropphycty": "ALMA",
    "dropphyst": "WV",
    "dropphyzpp": 263209998,
    "dropmaladd": "134 KLONDIKE RD",
    "dropmalcty": "ALMA",
    "dropmalst": "WV",
    "dropmalzpp": 263209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047584210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28088",
    "droptype": "D",
    "dropname": "ALUM BRIDGE",
    "dropdeladd": "14 MOODY LN",
    "dropdelcty": "ALUM BRIDGE",
    "dropdelst": "WV",
    "dropdelzpp": 263219998,
    "dropphyadd": "14 MOODY LN",
    "dropphycty": "ALUM BRIDGE",
    "dropphyst": "WV",
    "dropphyzpp": 263219998,
    "dropmaladd": "14 MOODY LN",
    "dropmalcty": "ALUM BRIDGE",
    "dropmalst": "WV",
    "dropmalzpp": 263219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042694419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28089",
    "droptype": "D",
    "dropname": "ALUM CREEK",
    "dropdeladd": "26 LITTLE COAL RIVER RD",
    "dropdelcty": "ALUM CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 250039998,
    "dropphyadd": "26 LITTLE COAL RIVER RD",
    "dropphycty": "ALUM CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 250039998,
    "dropmaladd": "26 LITTLE COAL RIVER RD",
    "dropmalcty": "ALUM CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 250039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047569344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28095",
    "droptype": "D",
    "dropname": "AMHERSTDALE",
    "dropdeladd": "25 GARRISON DR",
    "dropdelcty": "AMHERSTDALE",
    "dropdelst": "WV",
    "dropdelzpp": 256079998,
    "dropphyadd": "25 GARRISON DR",
    "dropphycty": "AMHERSTDALE",
    "dropphyst": "WV",
    "dropphyzpp": 256079998,
    "dropmaladd": "25 GARRISON DR",
    "dropmalcty": "AMHERSTDALE",
    "dropmalst": "WV",
    "dropmalzpp": 256079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045832406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28097",
    "droptype": "D",
    "dropname": "AMMA",
    "dropdeladd": "2738 BIG SANDY RD",
    "dropdelcty": "AMMA",
    "dropdelst": "WV",
    "dropdelzpp": 250059998,
    "dropphyadd": "2738 BIG SANDY RD",
    "dropphycty": "AMMA",
    "dropphyst": "WV",
    "dropphyzpp": 250059998,
    "dropmaladd": "2738 BIG SANDY RD",
    "dropmalcty": "AMMA",
    "dropmalst": "WV",
    "dropmalzpp": 250059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045653700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28098",
    "droptype": "D",
    "dropname": "ANAWALT",
    "dropdeladd": "7 PLUM ST",
    "dropdelcty": "ANAWALT",
    "dropdelst": "WV",
    "dropdelzpp": 248089998,
    "dropphyadd": "7 PLUM ST",
    "dropphycty": "ANAWALT",
    "dropphyst": "WV",
    "dropphyzpp": 248089998,
    "dropmaladd": "7 PLUM ST",
    "dropmalcty": "ANAWALT",
    "dropmalst": "WV",
    "dropmalzpp": 248089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043832212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28099",
    "droptype": "D",
    "dropname": "ANMOORE",
    "dropdeladd": "2919 PHILIPPI PIKE",
    "dropdelcty": "ANMOORE",
    "dropdelst": "WV",
    "dropdelzpp": 263239998,
    "dropphyadd": "2919 PHILIPPI PIKE",
    "dropphycty": "ANMOORE",
    "dropphyst": "WV",
    "dropphyzpp": 263239998,
    "dropmaladd": "2919 PHILIPPI PIKE",
    "dropmalcty": "ANMOORE",
    "dropmalst": "WV",
    "dropmalzpp": 263239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046239531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28101",
    "droptype": "D",
    "dropname": "ANSTED",
    "dropdeladd": "80 JAMES RIVER AND KANAWHA TPKE E",
    "dropdelcty": "ANSTED",
    "dropdelst": "WV",
    "dropdelzpp": 258129998,
    "dropphyadd": "80 JAMES RIVER AND KANAWHA TPKE E",
    "dropphycty": "ANSTED",
    "dropphyst": "WV",
    "dropphyzpp": 258129998,
    "dropmaladd": "80 JAMES RIVER AND KANAWHA TPKE E",
    "dropmalcty": "ANSTED",
    "dropmalst": "WV",
    "dropmalzpp": 258129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046584414,
    "dropfax": 3046584414
  },
  {
    "dcode": "D",
    "dropkey": "PX28105",
    "droptype": "D",
    "dropname": "APPLE GROVE",
    "dropdeladd": "27799 HUNTINGTON RD",
    "dropdelcty": "APPLE GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 255029998,
    "dropphyadd": "27799 HUNTINGTON RD",
    "dropphycty": "APPLE GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 255029998,
    "dropmaladd": "27799 HUNTINGTON RD",
    "dropmalcty": "APPLE GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 255029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045762050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28109",
    "droptype": "D",
    "dropname": "ARNETT",
    "dropdeladd": "4461 COAL RIVER RD",
    "dropdelcty": "ARNETT",
    "dropdelst": "WV",
    "dropdelzpp": 250079998,
    "dropphyadd": "4461 COAL RIVER RD",
    "dropphycty": "ARNETT",
    "dropphyst": "WV",
    "dropphyzpp": 250079998,
    "dropmaladd": "4461 COAL RIVER RD",
    "dropmalcty": "ARNETT",
    "dropmalst": "WV",
    "dropmalzpp": 250079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049345119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28111",
    "droptype": "D",
    "dropname": "ARNOLDSBURG",
    "dropdeladd": "21 HAYS ST",
    "dropdelcty": "ARNOLDSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 252349998,
    "dropphyadd": "21 HAYS ST",
    "dropphycty": "ARNOLDSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 252349998,
    "dropmaladd": "21 HAYS ST",
    "dropmalcty": "ARNOLDSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 252349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046557290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28113",
    "droptype": "D",
    "dropname": "ARTHURDALE",
    "dropdeladd": "13258 N MOUNTAINEER HWY",
    "dropdelcty": "ARTHURDALE",
    "dropdelst": "WV",
    "dropdelzpp": 265209998,
    "dropphyadd": "13258 N MOUNTAINEER HWY",
    "dropphycty": "ARTHURDALE",
    "dropphyst": "WV",
    "dropphyzpp": 265209998,
    "dropmaladd": "13258 N MOUNTAINEER HWY",
    "dropmalcty": "ARTHURDALE",
    "dropmalst": "WV",
    "dropmalzpp": 265209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048643880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28115",
    "droptype": "D",
    "dropname": "ASBURY",
    "dropdeladd": "9712 ALTA DR",
    "dropdelcty": "ASBURY",
    "dropdelst": "WV",
    "dropdelzpp": 249169998,
    "dropphyadd": "9712 ALTA DR",
    "dropphycty": "ASBURY",
    "dropphyst": "WV",
    "dropphyzpp": 249169998,
    "dropmaladd": "9712 ALTA DR",
    "dropmalcty": "ASBURY",
    "dropmalst": "WV",
    "dropmalzpp": 249169998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046455911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28119",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "33014 HUNTINGTON RD",
    "dropdelcty": "ASHTON",
    "dropdelst": "WV",
    "dropdelzpp": 255039998,
    "dropphyadd": "33014 HUNTINGTON RD",
    "dropphycty": "ASHTON",
    "dropphyst": "WV",
    "dropphyzpp": 255039998,
    "dropmaladd": "33014 HUNTINGTON RD",
    "dropmalcty": "ASHTON",
    "dropmalst": "WV",
    "dropmalzpp": 255039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045762059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28121",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "203 VERMILLION ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "WV",
    "dropdelzpp": 247129998,
    "dropphyadd": "203 VERMILLION ST",
    "dropphycty": "ATHENS",
    "dropphyst": "WV",
    "dropphyzpp": 247129998,
    "dropmaladd": "203 VERMILLION ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "WV",
    "dropmalzpp": 247129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043847056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28123",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "12069 AUBURN RD",
    "dropdelcty": "AUBURN",
    "dropdelst": "WV",
    "dropdelzpp": 263259998,
    "dropphyadd": "12069 AUBURN RD",
    "dropphycty": "AUBURN",
    "dropphyst": "WV",
    "dropphyzpp": 263259998,
    "dropmaladd": "12069 AUBURN RD",
    "dropmalcty": "AUBURN",
    "dropmalst": "WV",
    "dropmalzpp": 263259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043492505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28124",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "16962 NORTHWESTERN PIKE",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "WV",
    "dropdelzpp": 267049998,
    "dropphyadd": "16962 NORTHWESTERN PIKE",
    "dropphycty": "AUGUSTA",
    "dropphyst": "WV",
    "dropphyzpp": 267049998,
    "dropmaladd": "16962 NORTHWESTERN PIKE",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "WV",
    "dropmalzpp": 267049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044968063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28125",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "24154 GEORGE WASHINGTON HWY",
    "dropdelcty": "AURORA",
    "dropdelst": "WV",
    "dropdelzpp": 267059998,
    "dropphyadd": "24154 GEORGE WASHINGTON HWY",
    "dropphycty": "AURORA",
    "dropphyst": "WV",
    "dropphyzpp": 267059998,
    "dropmaladd": "24154 GEORGE WASHINGTON HWY",
    "dropmalcty": "AURORA",
    "dropmalst": "WV",
    "dropmalzpp": 267059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047353181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28128",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "7060 MOUNTAINEER HWY",
    "dropdelcty": "AVONDALE",
    "dropdelst": "WV",
    "dropdelzpp": 248119998,
    "dropphyadd": "7060 MOUNTAINEER HWY",
    "dropphycty": "AVONDALE",
    "dropphyst": "WV",
    "dropphyzpp": 248119998,
    "dropmaladd": "7060 MOUNTAINEER HWY",
    "dropmalcty": "AVONDALE",
    "dropmalst": "WV",
    "dropmalzpp": 248119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049385417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28129",
    "droptype": "D",
    "dropname": "BAISDEN",
    "dropdeladd": "4082 GILBERT CREEK RD",
    "dropdelcty": "BAISDEN",
    "dropdelst": "WV",
    "dropdelzpp": 256089998,
    "dropphyadd": "4082 GILBERT CREEK RD",
    "dropphycty": "BAISDEN",
    "dropphyst": "WV",
    "dropphyzpp": 256089998,
    "dropmaladd": "4082 GILBERT CREEK RD",
    "dropmalcty": "BAISDEN",
    "dropmalst": "WV",
    "dropmalzpp": 256089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046648043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28130",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "25 STATE ROAD 259",
    "dropdelcty": "BAKER",
    "dropdelst": "WV",
    "dropdelzpp": 268017001,
    "dropphyadd": "25 STATE ROAD 259",
    "dropphycty": "BAKER",
    "dropphyst": "WV",
    "dropphyzpp": 268017001,
    "dropmaladd": "25 STATE ROAD 259",
    "dropmalcty": "BAKER",
    "dropmalst": "WV",
    "dropmalzpp": 268017001,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048976481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28134",
    "droptype": "D",
    "dropname": "BALLARD",
    "dropdeladd": "5974 BALLARD RED SULPHUR PKWY UNIT A",
    "dropdelcty": "BALLARD",
    "dropdelst": "WV",
    "dropdelzpp": 249189998,
    "dropphyadd": "5974 BALLARD RED SULPHUR PKWY UNIT A",
    "dropphycty": "BALLARD",
    "dropphyst": "WV",
    "dropphyzpp": 249189998,
    "dropmaladd": "5974 BALLARD RED SULPHUR PKWY UNIT A",
    "dropmalcty": "BALLARD",
    "dropmalst": "WV",
    "dropmalzpp": 249189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047539130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28136",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "14 MAIN ST",
    "dropdelcty": "BANCROFT",
    "dropdelst": "WV",
    "dropdelzpp": 250119998,
    "dropphyadd": "14 MAIN ST",
    "dropphycty": "BANCROFT",
    "dropphyst": "WV",
    "dropphyzpp": 250119998,
    "dropmaladd": "14 MAIN ST",
    "dropmalcty": "BANCROFT",
    "dropmalst": "WV",
    "dropmalzpp": 250119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045864484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28138",
    "droptype": "D",
    "dropname": "BARBOURSVILLE",
    "dropdeladd": "680 CENTRAL AVE",
    "dropdelcty": "BARBOURSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 255049998,
    "dropphyadd": "680 CENTRAL AVE",
    "dropphycty": "BARBOURSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 255049998,
    "dropmaladd": "680 CENTRAL AVE",
    "dropmalcty": "BARBOURSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 255049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047363675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28141",
    "droptype": "D",
    "dropname": "BARRACKVILLE",
    "dropdeladd": "209 PIKE ST",
    "dropdelcty": "BARRACKVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265599998,
    "dropphyadd": "209 PIKE ST",
    "dropphycty": "BARRACKVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265599998,
    "dropmaladd": "209 PIKE ST",
    "dropmalcty": "BARRACKVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043667738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28143",
    "droptype": "D",
    "dropname": "BARTLEY",
    "dropdeladd": "31 STORE BOTTOM RD",
    "dropdelcty": "BARTLEY",
    "dropdelst": "WV",
    "dropdelzpp": 248139998,
    "dropphyadd": "31 STORE BOTTOM RD",
    "dropphycty": "BARTLEY",
    "dropphyst": "WV",
    "dropphyzpp": 248139998,
    "dropmaladd": "31 STORE BOTTOM RD",
    "dropmalcty": "BARTLEY",
    "dropmalst": "WV",
    "dropmalzpp": 248139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049675900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28144",
    "droptype": "D",
    "dropname": "BARTOW",
    "dropdeladd": "6784 STAUNTON PARKERSBURG TPKE",
    "dropdelcty": "BARTOW",
    "dropdelst": "WV",
    "dropdelzpp": 249209998,
    "dropphyadd": "6784 STAUNTON PARKERSBURG TPKE",
    "dropphycty": "BARTOW",
    "dropphyst": "WV",
    "dropphyzpp": 249209998,
    "dropmaladd": "6784 STAUNTON PARKERSBURG TPKE",
    "dropmalcty": "BARTOW",
    "dropmalst": "WV",
    "dropmalzpp": 249209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044564384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28146",
    "droptype": "D",
    "dropname": "BAYARD",
    "dropdeladd": "2257 FRONT ST",
    "dropdelcty": "BAYARD",
    "dropdelst": "WV",
    "dropdelzpp": 267079998,
    "dropphyadd": "2257 FRONT ST",
    "dropphycty": "BAYARD",
    "dropphyst": "WV",
    "dropphyzpp": 267079998,
    "dropmaladd": "2257 FRONT ST",
    "dropmalcty": "BAYARD",
    "dropmalst": "WV",
    "dropmalzpp": 267079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046937459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28150",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "123 BEAVER PLZ",
    "dropdelcty": "BEAVER",
    "dropdelst": "WV",
    "dropdelzpp": 258139998,
    "dropphyadd": "123 BEAVER PLZ",
    "dropphycty": "BEAVER",
    "dropphyst": "WV",
    "dropphyzpp": 258139998,
    "dropmaladd": "123 BEAVER PLZ",
    "dropmalcty": "BEAVER",
    "dropmalst": "WV",
    "dropmalzpp": 258139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042551104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28152",
    "droptype": "D",
    "dropname": "BECKLEY",
    "dropdeladd": "134 INDUSTRIAL DR",
    "dropdelcty": "BECKLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258019998,
    "dropphyadd": "134 INDUSTRIAL DR",
    "dropphycty": "BECKLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258019998,
    "dropmaladd": "134 INDUSTRIAL DR",
    "dropmalcty": "BECKLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042525336,
    "dropfax": 3042529438
  },
  {
    "dcode": "D",
    "dropkey": "PX28154",
    "droptype": "D",
    "dropname": "BEECH BOTTOM",
    "dropdeladd": "15 3RD ST",
    "dropdelcty": "BEECH BOTTOM",
    "dropdelst": "WV",
    "dropdelzpp": 260301001,
    "dropphyadd": "15 3RD ST",
    "dropphycty": "BEECH BOTTOM",
    "dropphyst": "WV",
    "dropphyzpp": 260301001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEECH BOTTOM",
    "dropmalst": "WV",
    "dropmalzpp": 260309998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3043945830,
    "dropsitcph": 3043945830,
    "dropfax": 3043945830
  },
  {
    "dcode": "D",
    "dropkey": "PX28156",
    "droptype": "D",
    "dropname": "BELINGTON",
    "dropdeladd": "801 CRIM AVE",
    "dropdelcty": "BELINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 262509998,
    "dropphyadd": "801 CRIM AVE",
    "dropphycty": "BELINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 262509998,
    "dropmaladd": "801 CRIM AVE",
    "dropmalcty": "BELINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 262509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048231269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28157",
    "droptype": "D",
    "dropname": "BELLE",
    "dropdeladd": "814 E DUPONT AVE",
    "dropdelcty": "BELLE",
    "dropdelst": "WV",
    "dropdelzpp": 250159998,
    "dropphyadd": "814 E DUPONT AVE",
    "dropphycty": "BELLE",
    "dropphyst": "WV",
    "dropphyzpp": 250159998,
    "dropmaladd": "814 E DUPONT AVE",
    "dropmalcty": "BELLE",
    "dropmalst": "WV",
    "dropmalzpp": 250159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049491149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28159",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "11293 HARRIS HWY",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261339998,
    "dropphyadd": "11293 HARRIS HWY",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261339998,
    "dropmaladd": "11293 HARRIS HWY",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261339998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048639100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28161",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "310 CLARK ST",
    "dropdelcty": "BELMONT",
    "dropdelst": "WV",
    "dropdelzpp": 261349998,
    "dropphyadd": "310 CLARK ST",
    "dropphycty": "BELMONT",
    "dropphyst": "WV",
    "dropphyzpp": 261349998,
    "dropmaladd": "310 CLARK ST",
    "dropmalcty": "BELMONT",
    "dropmalst": "WV",
    "dropmalzpp": 261349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046652501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28162",
    "droptype": "D",
    "dropname": "BELVA",
    "dropdeladd": "24652 TURNPIKE RD",
    "dropdelcty": "BELVA",
    "dropdelst": "WV",
    "dropdelzpp": 266569998,
    "dropphyadd": "24652 TURNPIKE RD",
    "dropphycty": "BELVA",
    "dropphyst": "WV",
    "dropphyzpp": 266569998,
    "dropmaladd": "24652 TURNPIKE RD",
    "dropmalcty": "BELVA",
    "dropmalst": "WV",
    "dropmalzpp": 266569998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046322187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28166",
    "droptype": "D",
    "dropname": "BENWOOD",
    "dropdeladd": "401 MCMECHEN ST",
    "dropdelcty": "BENWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 260319998,
    "dropphyadd": "401 MCMECHEN ST",
    "dropphycty": "BENWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 260319998,
    "dropmaladd": "401 MCMECHEN ST",
    "dropmalcty": "BENWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 260319998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042327311,
    "dropsitcph": 3042327311,
    "dropfax": 3042331291
  },
  {
    "dcode": "D",
    "dropkey": "PX28168",
    "droptype": "D",
    "dropname": "BERGOO",
    "dropdeladd": "19 POST OFFICE LN",
    "dropdelcty": "BERGOO",
    "dropdelst": "WV",
    "dropdelzpp": 262989998,
    "dropphyadd": "19 POST OFFICE LN",
    "dropphycty": "BERGOO",
    "dropphyst": "WV",
    "dropphyzpp": 262989998,
    "dropmaladd": "19 POST OFFICE LN",
    "dropmalcty": "BERGOO",
    "dropmalst": "WV",
    "dropmalzpp": 262989998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048477374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28169",
    "droptype": "D",
    "dropname": "BERKELEY SPRINGS",
    "dropdeladd": "417 N WASHINGTON ST",
    "dropdelcty": "BERKELEY SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 254119998,
    "dropphyadd": "417 N WASHINGTON ST",
    "dropphycty": "BERKELEY SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 254119998,
    "dropmaladd": "417 N WASHINGTON ST",
    "dropmalcty": "BERKELEY SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 254119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042581424,
    "dropfax": 3042580338
  },
  {
    "dcode": "D",
    "dropkey": "PX28171",
    "droptype": "D",
    "dropname": "BERWIND",
    "dropdeladd": "2115 RIFT BERWIND RD",
    "dropdelcty": "BERWIND",
    "dropdelst": "WV",
    "dropdelzpp": 248159998,
    "dropphyadd": "2115 RIFT BERWIND RD",
    "dropphycty": "BERWIND",
    "dropphyst": "WV",
    "dropphyzpp": 248159998,
    "dropmaladd": "2115 RIFT BERWIND RD",
    "dropmalcty": "BERWIND",
    "dropmalst": "WV",
    "dropmalzpp": 248159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048753200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28172",
    "droptype": "D",
    "dropname": "BETHANY",
    "dropdeladd": "1 ROSS ST",
    "dropdelcty": "BETHANY",
    "dropdelst": "WV",
    "dropdelzpp": 260323001,
    "dropphyadd": "1 ROSS ST",
    "dropphycty": "BETHANY",
    "dropphyst": "WV",
    "dropphyzpp": 260323001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHANY",
    "dropmalst": "WV",
    "dropmalzpp": 260329998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3048294211,
    "dropsitcph": 3048294211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28173",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "290 COURT ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "WV",
    "dropdelzpp": 262539998,
    "dropphyadd": "290 COURT ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "WV",
    "dropphyzpp": 262539998,
    "dropmaladd": "290 COURT ST",
    "dropmalcty": "BEVERLY",
    "dropmalst": "WV",
    "dropmalzpp": 262539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046366580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28176",
    "droptype": "D",
    "dropname": "BICKMORE",
    "dropdeladd": "47 FOLA RD",
    "dropdelcty": "BICKMORE",
    "dropdelst": "WV",
    "dropdelzpp": 250199998,
    "dropphyadd": "47 FOLA RD",
    "dropphycty": "BICKMORE",
    "dropphyst": "WV",
    "dropphyzpp": 250199998,
    "dropmaladd": "47 FOLA RD",
    "dropmalcty": "BICKMORE",
    "dropmalst": "WV",
    "dropmalzpp": 250199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045872544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28177",
    "droptype": "D",
    "dropname": "BIG BEND",
    "dropdeladd": "6915 W LITTLE KANAWHA HWY",
    "dropdelcty": "BIG BEND",
    "dropdelst": "WV",
    "dropdelzpp": 261369998,
    "dropphyadd": "6915 W LITTLE KANAWHA HWY",
    "dropphycty": "BIG BEND",
    "dropphyst": "WV",
    "dropphyzpp": 261369998,
    "dropmaladd": "6915 W LITTLE KANAWHA HWY",
    "dropmalcty": "BIG BEND",
    "dropmalst": "WV",
    "dropmalzpp": 261369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043547606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28179",
    "droptype": "D",
    "dropname": "BIG CREEK",
    "dropdeladd": "150 BIG CREEK RD",
    "dropdelcty": "BIG CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 255059998,
    "dropphyadd": "150 BIG CREEK RD",
    "dropphycty": "BIG CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 255059998,
    "dropmaladd": "150 BIG CREEK RD",
    "dropmalcty": "BIG CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 255059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048553812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28182",
    "droptype": "D",
    "dropname": "BIG SANDY",
    "dropdeladd": "62 ORA AVE",
    "dropdelcty": "BIG SANDY",
    "dropdelst": "WV",
    "dropdelzpp": 248169998,
    "dropphyadd": "62 ORA AVE",
    "dropphycty": "BIG SANDY",
    "dropphyst": "WV",
    "dropphyzpp": 248169998,
    "dropmaladd": "62 ORA AVE",
    "dropmalcty": "BIG SANDY",
    "dropmalst": "WV",
    "dropmalzpp": 248169998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046567719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28183",
    "droptype": "D",
    "dropname": "BIG SPRINGS",
    "dropdeladd": "6657 N CALHOUN HWY",
    "dropdelcty": "BIG SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 261379998,
    "dropphyadd": "6657 N CALHOUN HWY",
    "dropphycty": "BIG SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 261379998,
    "dropmaladd": "6657 N CALHOUN HWY",
    "dropmalcty": "BIG SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 261379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043546357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28185",
    "droptype": "D",
    "dropname": "BIM",
    "dropdeladd": "31003 POND FORK RD",
    "dropdelcty": "BIM",
    "dropdelst": "WV",
    "dropdelzpp": 250219998,
    "dropphyadd": "31003 POND FORK RD",
    "dropphycty": "BIM",
    "dropphyst": "WV",
    "dropphyzpp": 250219998,
    "dropmaladd": "31003 POND FORK RD",
    "dropmalcty": "BIM",
    "dropmalst": "WV",
    "dropmalzpp": 250219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042476508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28186",
    "droptype": "D",
    "dropname": "BIRCH RIVER",
    "dropdeladd": "55 POWELLS CREEK RD",
    "dropdelcty": "BIRCH RIVER",
    "dropdelst": "WV",
    "dropdelzpp": 266109998,
    "dropphyadd": "55 POWELLS CREEK RD",
    "dropphycty": "BIRCH RIVER",
    "dropphyst": "WV",
    "dropphyzpp": 266109998,
    "dropmaladd": "55 POWELLS CREEK RD",
    "dropmalcty": "BIRCH RIVER",
    "dropmalst": "WV",
    "dropmalzpp": 266109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046492981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28188",
    "droptype": "D",
    "dropname": "BLACKSVILLE",
    "dropdeladd": "46 DAYBROOK RD",
    "dropdelcty": "BLACKSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265219998,
    "dropphyadd": "46 DAYBROOK RD",
    "dropphycty": "BLACKSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265219998,
    "dropmaladd": "46 DAYBROOK RD",
    "dropmalcty": "BLACKSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044328383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28189",
    "droptype": "D",
    "dropname": "BLAIR",
    "dropdeladd": "10516 BLAIR MOUNTAIN HWY",
    "dropdelcty": "BLAIR",
    "dropdelst": "WV",
    "dropdelzpp": 250229998,
    "dropphyadd": "10516 BLAIR MOUNTAIN HWY",
    "dropphycty": "BLAIR",
    "dropphyst": "WV",
    "dropphyzpp": 250229998,
    "dropmaladd": "10516 BLAIR MOUNTAIN HWY",
    "dropmalcty": "BLAIR",
    "dropmalst": "WV",
    "dropmalzpp": 250229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043695023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28192",
    "droptype": "D",
    "dropname": "BLOOMERY",
    "dropdeladd": "17082 BLOOMERY PIKE",
    "dropdelcty": "BLOOMERY",
    "dropdelst": "WV",
    "dropdelzpp": 268179998,
    "dropphyadd": "17082 BLOOMERY PIKE",
    "dropphycty": "BLOOMERY",
    "dropphyst": "WV",
    "dropphyzpp": 268179998,
    "dropmaladd": "17082 BLOOMERY PIKE",
    "dropmalcty": "BLOOMERY",
    "dropmalst": "WV",
    "dropmalzpp": 268179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048562713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28193",
    "droptype": "D",
    "dropname": "BLOOMINGROSE",
    "dropdeladd": "22201 COAL RIVER RD",
    "dropdelcty": "BLOOMINGROSE",
    "dropdelst": "WV",
    "dropdelzpp": 250249998,
    "dropphyadd": "22201 COAL RIVER RD",
    "dropphycty": "BLOOMINGROSE",
    "dropphyst": "WV",
    "dropphyzpp": 250249998,
    "dropmaladd": "22201 COAL RIVER RD",
    "dropmalcty": "BLOOMINGROSE",
    "dropmalst": "WV",
    "dropmalzpp": 250249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048377958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28195",
    "droptype": "D",
    "dropname": "BLUE CREEK",
    "dropdeladd": "5151 ELK RIVER RD N",
    "dropdelcty": "BLUE CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 250269998,
    "dropphyadd": "5151 ELK RIVER RD N",
    "dropphycty": "BLUE CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 250269998,
    "dropmaladd": "5151 ELK RIVER RD N",
    "dropmalcty": "BLUE CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 250269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049651986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28198",
    "droptype": "D",
    "dropname": "BLUEFIELD",
    "dropdeladd": "3010 E CUMBERLAND RD",
    "dropdelcty": "BLUEFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 247019998,
    "dropphyadd": "3010 E CUMBERLAND RD",
    "dropphycty": "BLUEFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 247019998,
    "dropmaladd": "3010 E CUMBERLAND RD",
    "dropmalcty": "BLUEFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 247019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043259196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28204",
    "droptype": "D",
    "dropname": "BOLT",
    "dropdeladd": "2214 BOLT RD",
    "dropdelcty": "BOLT",
    "dropdelst": "WV",
    "dropdelzpp": 258179998,
    "dropphyadd": "2214 BOLT RD",
    "dropphycty": "BOLT",
    "dropphyst": "WV",
    "dropphyzpp": 258179998,
    "dropmaladd": "2214 BOLT RD",
    "dropmalcty": "BOLT",
    "dropmalst": "WV",
    "dropmalzpp": 258179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049346575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28206",
    "droptype": "D",
    "dropname": "BOOMER",
    "dropdeladd": "2995 MIDLAND TRL",
    "dropdelcty": "BOOMER",
    "dropdelst": "WV",
    "dropdelzpp": 250319998,
    "dropphyadd": "2995 MIDLAND TRL",
    "dropphycty": "BOOMER",
    "dropphyst": "WV",
    "dropphyzpp": 250319998,
    "dropmaladd": "2995 MIDLAND TRL",
    "dropmalcty": "BOOMER",
    "dropmalst": "WV",
    "dropmalzpp": 250319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047792723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28211",
    "droptype": "D",
    "dropname": "BOWDEN",
    "dropdeladd": "8835 ALLEGHENY HWY",
    "dropdelcty": "BOWDEN",
    "dropdelst": "WV",
    "dropdelzpp": 262549998,
    "dropphyadd": "8835 ALLEGHENY HWY",
    "dropphycty": "BOWDEN",
    "dropphyst": "WV",
    "dropphyzpp": 262549998,
    "dropmaladd": "8835 ALLEGHENY HWY",
    "dropmalcty": "BOWDEN",
    "dropmalst": "WV",
    "dropmalzpp": 262549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046363934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28214",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "6147 ROBERT C BRYD DR",
    "dropdelcty": "BRADLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258189998,
    "dropphyadd": "6147 ROBERT C BRYD DR",
    "dropphycty": "BRADLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258189998,
    "dropmaladd": "6147 ROBERT C BRYD DR",
    "dropmalcty": "BRADLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048773447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28215",
    "droptype": "D",
    "dropname": "BRADSHAW",
    "dropdeladd": "58 MOUNTAINEER HWY",
    "dropdelcty": "BRADSHAW",
    "dropdelst": "WV",
    "dropdelzpp": 248179998,
    "dropphyadd": "58 MOUNTAINEER HWY",
    "dropphycty": "BRADSHAW",
    "dropphyst": "WV",
    "dropphyzpp": 248179998,
    "dropmaladd": "58 MOUNTAINEER HWY",
    "dropmalcty": "BRADSHAW",
    "dropmalst": "WV",
    "dropmalzpp": 248179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049677356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28216",
    "droptype": "D",
    "dropname": "BRAMWELL",
    "dropdeladd": "137 MAIN ST",
    "dropdelcty": "BRAMWELL",
    "dropdelst": "WV",
    "dropdelzpp": 247159998,
    "dropphyadd": "137 MAIN ST",
    "dropphycty": "BRAMWELL",
    "dropphyst": "WV",
    "dropphyzpp": 247159998,
    "dropmaladd": "137 MAIN ST",
    "dropmalcty": "BRAMWELL",
    "dropmalst": "WV",
    "dropmalzpp": 247159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042487000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28217",
    "droptype": "D",
    "dropname": "BRANCHLAND",
    "dropdeladd": "4934 MCCLELLAN HWY",
    "dropdelcty": "BRANCHLAND",
    "dropdelst": "WV",
    "dropdelzpp": 255069998,
    "dropphyadd": "4934 MCCLELLAN HWY",
    "dropphycty": "BRANCHLAND",
    "dropphyst": "WV",
    "dropphyzpp": 255069998,
    "dropmaladd": "4934 MCCLELLAN HWY",
    "dropmalcty": "BRANCHLAND",
    "dropmalst": "WV",
    "dropmalzpp": 255069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047787701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28219",
    "droptype": "D",
    "dropname": "BRANDYWINE",
    "dropdeladd": "11615 BLUE GRAY TRL",
    "dropdelcty": "BRANDYWINE",
    "dropdelst": "WV",
    "dropdelzpp": 268029998,
    "dropphyadd": "11615 BLUE GRAY TRL",
    "dropphycty": "BRANDYWINE",
    "dropphyst": "WV",
    "dropphyzpp": 268029998,
    "dropmaladd": "11615 BLUE GRAY TRL",
    "dropmalcty": "BRANDYWINE",
    "dropmalst": "WV",
    "dropmalzpp": 268029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042495605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28220",
    "droptype": "D",
    "dropname": "BREEDEN",
    "dropdeladd": "6386 BREEDEN CRK",
    "dropdelcty": "BREEDEN",
    "dropdelst": "WV",
    "dropdelzpp": 256669998,
    "dropphyadd": "6386 BREEDEN CRK",
    "dropphycty": "BREEDEN",
    "dropphyst": "WV",
    "dropphyzpp": 256669998,
    "dropmaladd": "6386 BREEDEN CRK",
    "dropmalcty": "BREEDEN",
    "dropmalst": "WV",
    "dropmalzpp": 256669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043933099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28221",
    "droptype": "D",
    "dropname": "BRENTON",
    "dropdeladd": "8079 R D BAILEY HWY",
    "dropdelcty": "BRENTON",
    "dropdelst": "WV",
    "dropdelzpp": 248189998,
    "dropphyadd": "8079 R D BAILEY HWY",
    "dropphycty": "BRENTON",
    "dropphyst": "WV",
    "dropphyzpp": 248189998,
    "dropmaladd": "8079 R D BAILEY HWY",
    "dropmalcty": "BRENTON",
    "dropmalst": "WV",
    "dropmalzpp": 248189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047328381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28223",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "205 S VIRGINIA AVE",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "WV",
    "dropdelzpp": 263309998,
    "dropphyadd": "205 S VIRGINIA AVE",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "WV",
    "dropphyzpp": 263309998,
    "dropmaladd": "205 S VIRGINIA AVE",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "WV",
    "dropmalzpp": 263309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048422671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28233",
    "droptype": "D",
    "dropname": "BRUCETON MILLS",
    "dropdeladd": "1 MORGANTOWN ST",
    "dropdelcty": "BRUCETON MILLS",
    "dropdelst": "WV",
    "dropdelzpp": 265259998,
    "dropphyadd": "1 MORGANTOWN ST",
    "dropphycty": "BRUCETON MILLS",
    "dropphyst": "WV",
    "dropphyzpp": 265259998,
    "dropmaladd": "1 MORGANTOWN ST",
    "dropmalcty": "BRUCETON MILLS",
    "dropmalst": "WV",
    "dropmalzpp": 265259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043792611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28234",
    "droptype": "D",
    "dropname": "BRUNO",
    "dropdeladd": "242 SANDLICK BRANCH RD",
    "dropdelcty": "BRUNO",
    "dropdelst": "WV",
    "dropdelzpp": 256119998,
    "dropphyadd": "242 SANDLICK BRANCH RD",
    "dropphycty": "BRUNO",
    "dropphyst": "WV",
    "dropphyzpp": 256119998,
    "dropmaladd": "242 SANDLICK BRANCH RD",
    "dropmalcty": "BRUNO",
    "dropmalst": "WV",
    "dropmalzpp": 256119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045836468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28237",
    "droptype": "D",
    "dropname": "BUCKEYE",
    "dropdeladd": "14333 SENECA TRL",
    "dropdelcty": "BUCKEYE",
    "dropdelst": "WV",
    "dropdelzpp": 249249998,
    "dropphyadd": "14333 SENECA TRL",
    "dropphycty": "BUCKEYE",
    "dropphyst": "WV",
    "dropphyzpp": 249249998,
    "dropmaladd": "14333 SENECA TRL",
    "dropmalcty": "BUCKEYE",
    "dropmalst": "WV",
    "dropmalzpp": 249249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047997381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28239",
    "droptype": "D",
    "dropname": "BUCKHANNON",
    "dropdeladd": "11 S SPRING ST",
    "dropdelcty": "BUCKHANNON",
    "dropdelst": "WV",
    "dropdelzpp": 262019998,
    "dropphyadd": "11 S SPRING ST",
    "dropphycty": "BUCKHANNON",
    "dropphyst": "WV",
    "dropphyzpp": 262019998,
    "dropmaladd": "11 S SPRING ST",
    "dropmalcty": "BUCKHANNON",
    "dropmalst": "WV",
    "dropmalzpp": 262019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044722020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28240",
    "droptype": "D",
    "dropname": "BUD",
    "dropdeladd": "3714 W VA RT 10 HERNDON RD",
    "dropdelcty": "BUD",
    "dropdelst": "WV",
    "dropdelzpp": 247169998,
    "dropphyadd": "3714 W VA RT 10 HERNDON RD",
    "dropphycty": "BUD",
    "dropphyst": "WV",
    "dropphyzpp": 247169998,
    "dropmaladd": "3714 W VA RT 10 HERNDON RD",
    "dropmalcty": "BUD",
    "dropmalst": "WV",
    "dropmalzpp": 247169998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042944364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28241",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "2062 BUFFALO RD",
    "dropdelcty": "BUFFALO",
    "dropdelst": "WV",
    "dropdelzpp": 250339998,
    "dropphyadd": "2062 BUFFALO RD",
    "dropphycty": "BUFFALO",
    "dropphyst": "WV",
    "dropphyzpp": 250339998,
    "dropmaladd": "2062 BUFFALO RD",
    "dropmalcty": "BUFFALO",
    "dropmalst": "WV",
    "dropmalzpp": 250339998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049373202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28242",
    "droptype": "D",
    "dropname": "BUNKER HILL",
    "dropdeladd": "9604 WINCHESTER AVE",
    "dropdelcty": "BUNKER HILL",
    "dropdelst": "WV",
    "dropdelzpp": 254139998,
    "dropphyadd": "9604 WINCHESTER AVE",
    "dropphycty": "BUNKER HILL",
    "dropphyst": "WV",
    "dropphyzpp": 254139998,
    "dropmaladd": "9604 WINCHESTER AVE",
    "dropmalcty": "BUNKER HILL",
    "dropmalst": "WV",
    "dropmalzpp": 254139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042298303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28244",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "10393 UPPER PATTERSON CREEK RD",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 267109998,
    "dropphyadd": "10393 UPPER PATTERSON CREEK RD",
    "dropphycty": "BURLINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 267109998,
    "dropmaladd": "10393 UPPER PATTERSON CREEK RD",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 267109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042893986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28246",
    "droptype": "D",
    "dropname": "BURNSVILLE",
    "dropdeladd": "126 S MAIN ST",
    "dropdelcty": "BURNSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 263359997,
    "dropphyadd": "126 S MAIN ST",
    "dropphycty": "BURNSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 263359997,
    "dropmaladd": "126 S MAIN ST",
    "dropmalcty": "BURNSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 263359997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048532631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28253",
    "droptype": "D",
    "dropname": "CABIN CREEK",
    "dropdeladd": "15043 MACCORKLE AVE",
    "dropdelcty": "CABIN CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 250359998,
    "dropphyadd": "15043 MACCORKLE AVE",
    "dropphycty": "CABIN CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 250359998,
    "dropmaladd": "15043 MACCORKLE AVE",
    "dropmalcty": "CABIN CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 250359998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045953594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28254",
    "droptype": "D",
    "dropname": "CABINS",
    "dropdeladd": "5181 N FORK HWY",
    "dropdelcty": "CABINS",
    "dropdelst": "WV",
    "dropdelzpp": 268559998,
    "dropphyadd": "5181 N FORK HWY",
    "dropphycty": "CABINS",
    "dropphyst": "WV",
    "dropphyzpp": 268559998,
    "dropmaladd": "5181 N FORK HWY",
    "dropmalcty": "CABINS",
    "dropmalst": "WV",
    "dropmalzpp": 268559998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042579455,
    "dropfax": 3042571288
  },
  {
    "dcode": "D",
    "dropkey": "PX28255",
    "droptype": "D",
    "dropname": "CAIRO",
    "dropdeladd": "150 RAILROAD ST",
    "dropdelcty": "CAIRO",
    "dropdelst": "WV",
    "dropdelzpp": 263379998,
    "dropphyadd": "150 RAILROAD ST",
    "dropphycty": "CAIRO",
    "dropphyst": "WV",
    "dropphyzpp": 263379998,
    "dropmaladd": "150 RAILROAD ST",
    "dropmalcty": "CAIRO",
    "dropmalst": "WV",
    "dropmalzpp": 263379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046283757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28256",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "35467 MIDLAND TRL E",
    "dropdelcty": "CALDWELL",
    "dropdelst": "WV",
    "dropdelzpp": 249259998,
    "dropphyadd": "35467 MIDLAND TRL E",
    "dropphycty": "CALDWELL",
    "dropphyst": "WV",
    "dropphyzpp": 249259998,
    "dropmaladd": "35467 MIDLAND TRL E",
    "dropmalcty": "CALDWELL",
    "dropmalst": "WV",
    "dropmalzpp": 249259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046456631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28257",
    "droptype": "D",
    "dropname": "CALVIN",
    "dropdeladd": "14038 WEBSTER RD",
    "dropdelcty": "CALVIN",
    "dropdelst": "WV",
    "dropdelzpp": 266609998,
    "dropphyadd": "14038 WEBSTER RD",
    "dropphycty": "CALVIN",
    "dropphyst": "WV",
    "dropphyzpp": 266609998,
    "dropmaladd": "14038 WEBSTER RD",
    "dropmalcty": "CALVIN",
    "dropmalst": "WV",
    "dropmalzpp": 266609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047423522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28258",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "4354 U S HIGHWAY 33 W",
    "dropdelcty": "CAMDEN",
    "dropdelst": "WV",
    "dropdelzpp": 263389998,
    "dropphyadd": "4354 U S HIGHWAY 33 W",
    "dropphycty": "CAMDEN",
    "dropphyst": "WV",
    "dropphyzpp": 263389998,
    "dropmaladd": "4354 U S HIGHWAY 33 W",
    "dropmalcty": "CAMDEN",
    "dropmalst": "WV",
    "dropmalzpp": 263389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042697770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28261",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "73 HIGH ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "WV",
    "dropdelzpp": 260339998,
    "dropphyadd": "73 HIGH ST",
    "dropphycty": "CAMERON",
    "dropphyst": "WV",
    "dropphyzpp": 260339998,
    "dropmaladd": "73 HIGH ST",
    "dropmalcty": "CAMERON",
    "dropmalst": "WV",
    "dropmalzpp": 260339998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3046863555,
    "dropsitcph": 3046863555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28267",
    "droptype": "D",
    "dropname": "CANNELTON",
    "dropdeladd": "216 STUMP RD",
    "dropdelcty": "CANNELTON",
    "dropdelst": "WV",
    "dropdelzpp": 250369998,
    "dropphyadd": "216 STUMP RD",
    "dropphycty": "CANNELTON",
    "dropphyst": "WV",
    "dropphyzpp": 250369998,
    "dropmaladd": "216 STUMP RD",
    "dropmalcty": "CANNELTON",
    "dropmalst": "WV",
    "dropmalzpp": 250369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28268",
    "droptype": "D",
    "dropname": "CANVAS",
    "dropdeladd": "102 OAKWOOD DR",
    "dropdelcty": "CANVAS",
    "dropdelst": "WV",
    "dropdelzpp": 266629998,
    "dropphyadd": "102 OAKWOOD DR",
    "dropphycty": "CANVAS",
    "dropphyst": "WV",
    "dropphyzpp": 266629998,
    "dropmaladd": "102 OAKWOOD DR",
    "dropmalcty": "CANVAS",
    "dropmalst": "WV",
    "dropmalzpp": 266629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048722641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28271",
    "droptype": "D",
    "dropname": "CAPON BRIDGE",
    "dropdeladd": "3164 NORTHWESTERN PIKE",
    "dropdelcty": "CAPON BRIDGE",
    "dropdelst": "WV",
    "dropdelzpp": 267119998,
    "dropphyadd": "3164 NORTHWESTERN PIKE",
    "dropphycty": "CAPON BRIDGE",
    "dropphyst": "WV",
    "dropphyzpp": 267119998,
    "dropmaladd": "3164 NORTHWESTERN PIKE",
    "dropmalcty": "CAPON BRIDGE",
    "dropmalst": "WV",
    "dropmalzpp": 267119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048563546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28272",
    "droptype": "D",
    "dropname": "CAPON SPRINGS",
    "dropdeladd": "8960 BACK CREEK RD",
    "dropdelcty": "CAPON SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 268239998,
    "dropphyadd": "8960 BACK CREEK RD",
    "dropphycty": "CAPON SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 268239998,
    "dropmaladd": "8960 BACK CREEK RD",
    "dropmalcty": "CAPON SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 268239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 6816420754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28276",
    "droptype": "D",
    "dropname": "CAROLINA",
    "dropdeladd": "33 MAIN ST",
    "dropdelcty": "CAROLINA",
    "dropdelst": "WV",
    "dropdelzpp": 265639998,
    "dropphyadd": "33 MAIN ST",
    "dropphycty": "CAROLINA",
    "dropphyst": "WV",
    "dropphyzpp": 265639998,
    "dropmaladd": "33 MAIN ST",
    "dropmalcty": "CAROLINA",
    "dropmalst": "WV",
    "dropmalzpp": 265639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042872442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28279",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "778 MASON DIXON HWY",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265279998,
    "dropphyadd": "778 MASON DIXON HWY",
    "dropphycty": "CASSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265279998,
    "dropmaladd": "576 BLUE HORIZON DR",
    "dropmalcty": "PURSGLOVE",
    "dropmalst": "WV",
    "dropmalzpp": 265469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043285511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28281",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "401 E GEORGE ST",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 250399998,
    "dropphyadd": "401 E GEORGE ST",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 250399998,
    "dropmaladd": "401 E GEORGE ST",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 250399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045952336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28287",
    "droptype": "D",
    "dropname": "CEREDO",
    "dropdeladd": "371 C ST",
    "dropdelcty": "CEREDO",
    "dropdelst": "WV",
    "dropdelzpp": 255079998,
    "dropphyadd": "371 C ST",
    "dropphycty": "CEREDO",
    "dropphyst": "WV",
    "dropphyzpp": 255079998,
    "dropmaladd": "371 C ST",
    "dropmalcty": "CEREDO",
    "dropmalst": "WV",
    "dropmalzpp": 255079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044533915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28289",
    "droptype": "D",
    "dropname": "CHAPMANVILLE",
    "dropdeladd": "93 MAIN ST",
    "dropdelcty": "CHAPMANVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 255089998,
    "dropphyadd": "93 MAIN ST",
    "dropphycty": "CHAPMANVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 255089998,
    "dropmaladd": "93 MAIN ST",
    "dropmalcty": "CHAPMANVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 255089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048553465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28290",
    "droptype": "D",
    "dropname": "CHARLES TOWN",
    "dropdeladd": "101 W WASHINGTON ST",
    "dropdelcty": "CHARLES TOWN",
    "dropdelst": "WV",
    "dropdelzpp": 254149998,
    "dropphyadd": "101 W WASHINGTON ST",
    "dropphycty": "CHARLES TOWN",
    "dropphyst": "WV",
    "dropphyzpp": 254149998,
    "dropmaladd": "101 W WASHINGTON ST",
    "dropmalcty": "CHARLES TOWN",
    "dropmalst": "WV",
    "dropmalzpp": 254149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047256726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28292",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "1002 LEE ST E",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253019998,
    "dropphyadd": "1002 LEE ST E",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253019998,
    "dropmaladd": "1002 LEE ST E",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045611000,
    "dropfax": 3045611003
  },
  {
    "dcode": "D",
    "dropkey": "PX28293",
    "droptype": "D",
    "dropname": "CHARLTON HEIGHTS",
    "dropdeladd": "6371 MIDLAND TRL",
    "dropdelcty": "CHARLTON HEIGHTS",
    "dropdelst": "WV",
    "dropdelzpp": 250409998,
    "dropphyadd": "6371 MIDLAND TRL",
    "dropphycty": "CHARLTON HEIGHTS",
    "dropphyst": "WV",
    "dropphyzpp": 250409998,
    "dropmaladd": "6371 MIDLAND TRL",
    "dropmalcty": "CHARLTON HEIGHTS",
    "dropmalst": "WV",
    "dropmalzpp": 250409998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047792998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28294",
    "droptype": "D",
    "dropname": "CHARMCO",
    "dropdeladd": "5170 MIDLAND TRL W",
    "dropdelcty": "CHARMCO",
    "dropdelst": "WV",
    "dropdelzpp": 259589998,
    "dropphyadd": "5170 MIDLAND TRL W",
    "dropphycty": "CHARMCO",
    "dropphyst": "WV",
    "dropphyzpp": 259589998,
    "dropmaladd": "5170 MIDLAND TRL W",
    "dropmalcty": "CHARMCO",
    "dropmalst": "WV",
    "dropmalzpp": 259589998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044388394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28295",
    "droptype": "D",
    "dropname": "CHATTAROY",
    "dropdeladd": "16 POST OFFICE DR",
    "dropdelcty": "CHATTAROY",
    "dropdelst": "WV",
    "dropdelzpp": 256679998,
    "dropphyadd": "16 POST OFFICE DR",
    "dropphycty": "CHATTAROY",
    "dropphyst": "WV",
    "dropphyzpp": 256679998,
    "dropmaladd": "16 POST OFFICE DR",
    "dropmalcty": "CHATTAROY",
    "dropmalst": "WV",
    "dropmalzpp": 256679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042352236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28303",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "323 CAROLINA AVE",
    "dropdelcty": "CHESTER",
    "dropdelst": "WV",
    "dropdelzpp": 260349998,
    "dropphyadd": "323 CAROLINA AVE",
    "dropphycty": "CHESTER",
    "dropphyst": "WV",
    "dropphyzpp": 260349998,
    "dropmaladd": "323 CAROLINA AVE",
    "dropmalcty": "CHESTER",
    "dropmalst": "WV",
    "dropmalzpp": 260349998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3043872560,
    "dropsitcph": 3043872560,
    "dropfax": 3043879703
  },
  {
    "dcode": "D",
    "dropkey": "PX28304",
    "droptype": "D",
    "dropname": "CHLOE",
    "dropdeladd": "22233 S CALHOUN HWY",
    "dropdelcty": "CHLOE",
    "dropdelst": "WV",
    "dropdelzpp": 252359998,
    "dropphyadd": "22233 S CALHOUN HWY",
    "dropphycty": "CHLOE",
    "dropphyst": "WV",
    "dropphyzpp": 252359998,
    "dropmaladd": "22233 S CALHOUN HWY",
    "dropmalcty": "CHLOE",
    "dropmalst": "WV",
    "dropmalzpp": 252359998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046557444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28307",
    "droptype": "D",
    "dropname": "CIRCLEVILLE",
    "dropdeladd": "2878 MOUNT FREEDOM DR",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 268049998,
    "dropphyadd": "2878 MOUNT FREEDOM DR",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 268049998,
    "dropmaladd": "2878 MOUNT FREEDOM DR",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 268049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045672532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28310",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "200 CAVA DR",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263019998,
    "dropphyadd": "200 CAVA DR",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263019998,
    "dropmaladd": "200 CAVA DR",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263019998,
    "dropsitphn": 3046237707,
    "dropsitlph": 3046237707,
    "dropsitcph": 3046237707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28311",
    "droptype": "D",
    "dropname": "CLAY",
    "dropdeladd": "54 MAIN ST",
    "dropdelcty": "CLAY",
    "dropdelst": "WV",
    "dropdelzpp": 250439998,
    "dropphyadd": "54 MAIN ST",
    "dropphycty": "CLAY",
    "dropphyst": "WV",
    "dropphyzpp": 250439998,
    "dropmaladd": "54 MAIN ST",
    "dropmalcty": "CLAY",
    "dropmalst": "WV",
    "dropmalzpp": 250439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046780025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28313",
    "droptype": "D",
    "dropname": "CLEAR CREEK",
    "dropdeladd": "119 TONEYS FORK RD",
    "dropdelcty": "CLEAR CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 250449998,
    "dropphyadd": "119 TONEYS FORK RD",
    "dropphycty": "CLEAR CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 250449998,
    "dropmaladd": "119 TONEYS FORK RD",
    "dropmalcty": "CLEAR CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 250449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048775025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28314",
    "droptype": "D",
    "dropname": "CLEAR FORK",
    "dropdeladd": "5510 CLEAR FORK VALLEY RD",
    "dropdelcty": "CLEAR FORK",
    "dropdelst": "WV",
    "dropdelzpp": 248229998,
    "dropphyadd": "5510 CLEAR FORK VALLEY RD",
    "dropphycty": "CLEAR FORK",
    "dropphyst": "WV",
    "dropphyzpp": 248229998,
    "dropmaladd": "5510 CLEAR FORK VALLEY RD",
    "dropmalcty": "CLEAR FORK",
    "dropmalst": "WV",
    "dropmalzpp": 248229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046828855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28316",
    "droptype": "D",
    "dropname": "CLENDENIN",
    "dropdeladd": "100 MAYWOOD AVE W",
    "dropdelcty": "CLENDENIN",
    "dropdelst": "WV",
    "dropdelzpp": 250459998,
    "dropphyadd": "100 MAYWOOD AVE W",
    "dropphycty": "CLENDENIN",
    "dropphyst": "WV",
    "dropphyzpp": 250459998,
    "dropmaladd": "100 MAYWOOD AVE W",
    "dropmalcty": "CLENDENIN",
    "dropmalst": "WV",
    "dropmalzpp": 250459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045486941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28323",
    "droptype": "D",
    "dropname": "CLOTHIER",
    "dropdeladd": "18841 BLAIR MOUNTAIN HWY",
    "dropdelcty": "CLOTHIER",
    "dropdelst": "WV",
    "dropdelzpp": 250479998,
    "dropphyadd": "18841 BLAIR MOUNTAIN HWY",
    "dropphycty": "CLOTHIER",
    "dropphyst": "WV",
    "dropphyzpp": 250479998,
    "dropmaladd": "18841 BLAIR MOUNTAIN HWY",
    "dropmalcty": "CLOTHIER",
    "dropmalst": "WV",
    "dropmalzpp": 250479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043695113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28325",
    "droptype": "D",
    "dropname": "COAL CITY",
    "dropdeladd": "114 TINGLER AVE",
    "dropdelcty": "COAL CITY",
    "dropdelst": "WV",
    "dropdelzpp": 258239998,
    "dropphyadd": "114 TINGLER AVE",
    "dropphycty": "COAL CITY",
    "dropphyst": "WV",
    "dropphyzpp": 258239998,
    "dropmaladd": "114 TINGLER AVE",
    "dropmalcty": "COAL CITY",
    "dropmalst": "WV",
    "dropmalzpp": 258239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046834864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28326",
    "droptype": "D",
    "dropname": "COAL MOUNTAIN",
    "dropdeladd": "8875 COAL MOUNTAIN RD",
    "dropdelcty": "COAL MOUNTAIN",
    "dropdelst": "WV",
    "dropdelzpp": 248239997,
    "dropphyadd": "8875 COAL MOUNTAIN RD",
    "dropphycty": "COAL MOUNTAIN",
    "dropphyst": "WV",
    "dropphyzpp": 248239997,
    "dropmaladd": "8875 COAL MOUNTAIN RD",
    "dropmalcty": "COAL MOUNTAIN",
    "dropmalst": "WV",
    "dropmalzpp": 248239997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045832588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28328",
    "droptype": "D",
    "dropname": "COALTON",
    "dropdeladd": "11 CHURCH ST",
    "dropdelcty": "COALTON",
    "dropdelst": "WV",
    "dropdelzpp": 262579998,
    "dropphyadd": "11 CHURCH ST",
    "dropphycty": "COALTON",
    "dropphyst": "WV",
    "dropphyzpp": 262579998,
    "dropmaladd": "11 CHURCH ST",
    "dropmalcty": "COALTON",
    "dropmalst": "WV",
    "dropmalzpp": 262579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 6814530203,
    "dropfax": 6814530206
  },
  {
    "dcode": "D",
    "dropkey": "PX28332",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "1734 COLFAX RD",
    "dropdelcty": "COLFAX",
    "dropdelst": "WV",
    "dropdelzpp": 265669998,
    "dropphyadd": "1734 COLFAX RD",
    "dropphycty": "COLFAX",
    "dropphyst": "WV",
    "dropphyzpp": 265669998,
    "dropmaladd": "1734 COLFAX RD",
    "dropmalcty": "COLFAX",
    "dropmalst": "WV",
    "dropmalzpp": 265669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043670295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28333",
    "droptype": "D",
    "dropname": "COLLIERS",
    "dropdeladd": "327 PENNSYLVANIA AVE",
    "dropdelcty": "COLLIERS",
    "dropdelst": "WV",
    "dropdelzpp": 260353001,
    "dropphyadd": "327 PENNSYLVANIA AVE",
    "dropphycty": "COLLIERS",
    "dropphyst": "WV",
    "dropphyzpp": 260353001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLIERS",
    "dropmalst": "WV",
    "dropmalzpp": 260359998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3047486602,
    "dropsitcph": 3047486602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28336",
    "droptype": "D",
    "dropname": "COMFORT",
    "dropdeladd": "7008 COAL RIVER RD",
    "dropdelcty": "COMFORT",
    "dropdelst": "WV",
    "dropdelzpp": 250499998,
    "dropphyadd": "7008 COAL RIVER RD",
    "dropphycty": "COMFORT",
    "dropphyst": "WV",
    "dropphyzpp": 250499998,
    "dropmaladd": "7008 COAL RIVER RD",
    "dropmalcty": "COMFORT",
    "dropmalst": "WV",
    "dropmalzpp": 250499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048377947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28337",
    "droptype": "D",
    "dropname": "COOL RIDGE",
    "dropdeladd": "1902 FLAT TOP RD",
    "dropdelcty": "COOL RIDGE",
    "dropdelst": "WV",
    "dropdelzpp": 258259998,
    "dropphyadd": "1902 FLAT TOP RD",
    "dropphycty": "COOL RIDGE",
    "dropphyst": "WV",
    "dropphyzpp": 258259998,
    "dropmaladd": "1902 FLAT TOP RD",
    "dropmalcty": "COOL RIDGE",
    "dropmalst": "WV",
    "dropmalzpp": 258259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047873887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28341",
    "droptype": "D",
    "dropname": "CORINNE",
    "dropdeladd": "2064 GULF RD",
    "dropdelcty": "CORINNE",
    "dropdelst": "WV",
    "dropdelzpp": 258269998,
    "dropphyadd": "2064 GULF RD",
    "dropphycty": "CORINNE",
    "dropphyst": "WV",
    "dropphyzpp": 258269998,
    "dropmaladd": "2064 GULF RD",
    "dropmalcty": "CORINNE",
    "dropmalst": "WV",
    "dropmalzpp": 258269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042948880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28346",
    "droptype": "D",
    "dropname": "COSTA",
    "dropdeladd": "122 PAULEY RD",
    "dropdelcty": "COSTA",
    "dropdelst": "WV",
    "dropdelzpp": 250519998,
    "dropphyadd": "122 PAULEY RD",
    "dropphycty": "COSTA",
    "dropphyst": "WV",
    "dropphyzpp": 250519998,
    "dropmaladd": "122 PAULEY RD",
    "dropmalcty": "COSTA",
    "dropmalst": "WV",
    "dropmalzpp": 250519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048368062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28347",
    "droptype": "D",
    "dropname": "COTTAGEVILLE",
    "dropdeladd": "53 OLE MILL RD",
    "dropdelcty": "COTTAGEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 252399998,
    "dropphyadd": "53 OLE MILL RD",
    "dropphycty": "COTTAGEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 252399998,
    "dropmaladd": "53 OLE MILL RD",
    "dropmalcty": "COTTAGEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 252399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043725846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28352",
    "droptype": "D",
    "dropname": "COVEL",
    "dropdeladd": "252 GOONEY OTTER HOLLOW RD",
    "dropdelcty": "COVEL",
    "dropdelst": "WV",
    "dropdelzpp": 247199998,
    "dropphyadd": "252 GOONEY OTTER HOLLOW RD",
    "dropphycty": "COVEL",
    "dropphyst": "WV",
    "dropphyzpp": 247199998,
    "dropmaladd": "252 GOONEY OTTER HOLLOW RD",
    "dropmalcty": "COVEL",
    "dropmalst": "WV",
    "dropmalzpp": 247199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042948484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28353",
    "droptype": "D",
    "dropname": "COWEN",
    "dropdeladd": "25 ERBACON RD",
    "dropdelcty": "COWEN",
    "dropdelst": "WV",
    "dropdelzpp": 262069998,
    "dropphyadd": "25 ERBACON RD",
    "dropphycty": "COWEN",
    "dropphyst": "WV",
    "dropphyzpp": 262069998,
    "dropmaladd": "25 ERBACON RD",
    "dropmalcty": "COWEN",
    "dropmalst": "WV",
    "dropmalzpp": 262069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042263575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28356",
    "droptype": "D",
    "dropname": "CRAB ORCHARD",
    "dropdeladd": "1325 ROBERT C BYRD DR",
    "dropdelcty": "CRAB ORCHARD",
    "dropdelst": "WV",
    "dropdelzpp": 258279998,
    "dropphyadd": "1325 ROBERT C BYRD DR",
    "dropphycty": "CRAB ORCHARD",
    "dropphyst": "WV",
    "dropphyzpp": 258279998,
    "dropmaladd": "1325 ROBERT C BYRD DR",
    "dropmalcty": "CRAB ORCHARD",
    "dropmalst": "WV",
    "dropmalzpp": 258279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042539739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28357",
    "droptype": "D",
    "dropname": "CRAIGSVILLE",
    "dropdeladd": "25 RED OAK DR",
    "dropdelcty": "CRAIGSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 262059998,
    "dropphyadd": "25 RED OAK DR",
    "dropphycty": "CRAIGSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 262059998,
    "dropmaladd": "25 RED OAK DR",
    "dropmalcty": "CRAIGSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 262059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047428817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28361",
    "droptype": "D",
    "dropname": "CRAWLEY",
    "dropdeladd": "13795 MIDLAND TRL W",
    "dropdelcty": "CRAWLEY",
    "dropdelst": "WV",
    "dropdelzpp": 249319998,
    "dropphyadd": "13795 MIDLAND TRL W",
    "dropphycty": "CRAWLEY",
    "dropphyst": "WV",
    "dropphyzpp": 249319998,
    "dropmaladd": "13795 MIDLAND TRL W",
    "dropmalcty": "CRAWLEY",
    "dropmalst": "WV",
    "dropmalzpp": 249319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043926597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28370",
    "droptype": "D",
    "dropname": "CRUM",
    "dropdeladd": "44573 ROUTE 52",
    "dropdelcty": "CRUM",
    "dropdelst": "WV",
    "dropdelzpp": 256699998,
    "dropphyadd": "44573 ROUTE 52",
    "dropphycty": "CRUM",
    "dropphyst": "WV",
    "dropphyzpp": 256699998,
    "dropmaladd": "44573 ROUTE 52",
    "dropmalcty": "CRUM",
    "dropmalst": "WV",
    "dropmalzpp": 256699998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043934160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28372",
    "droptype": "D",
    "dropname": "CUCUMBER",
    "dropdeladd": "7836 ROCKET BOYS DR",
    "dropdelcty": "CUCUMBER",
    "dropdelst": "WV",
    "dropdelzpp": 248269998,
    "dropphyadd": "7836 ROCKET BOYS DR",
    "dropphycty": "CUCUMBER",
    "dropphyst": "WV",
    "dropphyzpp": 248269998,
    "dropmaladd": "7836 ROCKET BOYS DR",
    "dropmalcty": "CUCUMBER",
    "dropmalst": "WV",
    "dropmalzpp": 248269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048753696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28373",
    "droptype": "D",
    "dropname": "CULLODEN",
    "dropdeladd": "2000 US HIGHWAY 60",
    "dropdelcty": "CULLODEN",
    "dropdelst": "WV",
    "dropdelzpp": 255109998,
    "dropphyadd": "2000 US HIGHWAY 60",
    "dropphycty": "CULLODEN",
    "dropphyst": "WV",
    "dropphyzpp": 255109998,
    "dropmaladd": "2000 US HIGHWAY 60",
    "dropmalcty": "CULLODEN",
    "dropmalst": "WV",
    "dropmalzpp": 255109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047435211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28377",
    "droptype": "D",
    "dropname": "CYCLONE",
    "dropdeladd": "5449 COUNTRY RD",
    "dropdelcty": "CYCLONE",
    "dropdelst": "WV",
    "dropdelzpp": 248279998,
    "dropphyadd": "5449 COUNTRY RD",
    "dropphycty": "CYCLONE",
    "dropphyst": "WV",
    "dropphyzpp": 248279998,
    "dropmaladd": "5449 COUNTRY RD",
    "dropmalcty": "CYCLONE",
    "dropmalst": "WV",
    "dropmalzpp": 248279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046824672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28378",
    "droptype": "D",
    "dropname": "DAILEY",
    "dropdeladd": "3391 SENECA TRL",
    "dropdelcty": "DAILEY",
    "dropdelst": "WV",
    "dropdelzpp": 262599998,
    "dropphyadd": "3391 SENECA TRL",
    "dropphycty": "DAILEY",
    "dropphyst": "WV",
    "dropphyzpp": 262599998,
    "dropmaladd": "3391 SENECA TRL",
    "dropmalcty": "DAILEY",
    "dropmalst": "WV",
    "dropmalzpp": 262599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043382126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28379",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "DALLAS",
    "dropdelst": "WV",
    "dropdelzpp": 260369998,
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "DALLAS",
    "dropphyst": "WV",
    "dropphyzpp": 260369998,
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "DALLAS",
    "dropmalst": "WV",
    "dropmalzpp": 260369998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3045475410,
    "dropsitcph": 3045475410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28380",
    "droptype": "D",
    "dropname": "DANESE",
    "dropdeladd": "17629 STANAFORD RD",
    "dropdelcty": "DANESE",
    "dropdelst": "WV",
    "dropdelzpp": 258319998,
    "dropphyadd": "17629 STANAFORD RD",
    "dropphycty": "DANESE",
    "dropphyst": "WV",
    "dropphyzpp": 258319998,
    "dropmaladd": "17629 STANAFORD RD",
    "dropmalcty": "DANESE",
    "dropmalst": "WV",
    "dropmalzpp": 258319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044385699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28381",
    "droptype": "D",
    "dropname": "DANIELS",
    "dropdeladd": "124 BURGESS DR",
    "dropdelcty": "DANIELS",
    "dropdelst": "WV",
    "dropdelzpp": 258329998,
    "dropphyadd": "124 BURGESS DR",
    "dropphycty": "DANIELS",
    "dropphyst": "WV",
    "dropphyzpp": 258329998,
    "dropmaladd": "124 BURGESS DR",
    "dropmalcty": "DANIELS",
    "dropmalst": "WV",
    "dropmalzpp": 258329998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042230001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28382",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "236 MALL RD",
    "dropdelcty": "DANVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 250539998,
    "dropphyadd": "236 MALL RD",
    "dropphycty": "DANVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 250539998,
    "dropmaladd": "236 MALL RD",
    "dropmalcty": "DANVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 250539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043691118,
    "dropfax": 3043691864
  },
  {
    "dcode": "D",
    "dropkey": "PX28383",
    "droptype": "D",
    "dropname": "DAVIN",
    "dropdeladd": "2687 HUFF CREEK HWY",
    "dropdelcty": "DAVIN",
    "dropdelst": "WV",
    "dropdelzpp": 256179998,
    "dropphyadd": "2687 HUFF CREEK HWY",
    "dropphycty": "DAVIN",
    "dropphyst": "WV",
    "dropphyzpp": 256179998,
    "dropmaladd": "2687 HUFF CREEK HWY",
    "dropmalcty": "DAVIN",
    "dropmalst": "WV",
    "dropmalzpp": 256179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045836149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28384",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "421 WILLIAM AVE",
    "dropdelcty": "DAVIS",
    "dropdelst": "WV",
    "dropdelzpp": 262609998,
    "dropphyadd": "421 WILLIAM AVE",
    "dropphycty": "DAVIS",
    "dropphyst": "WV",
    "dropphyzpp": 262609998,
    "dropmaladd": "421 WILLIAM AVE",
    "dropmalcty": "DAVIS",
    "dropmalst": "WV",
    "dropmalzpp": 262609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042595230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28385",
    "droptype": "D",
    "dropname": "DAVISVILLE",
    "dropdeladd": "6362 STAUNTON TPKE",
    "dropdelcty": "DAVISVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261429998,
    "dropphyadd": "6362 STAUNTON TPKE",
    "dropphycty": "DAVISVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261429998,
    "dropmaladd": "6362 STAUNTON TPKE",
    "dropmalcty": "DAVISVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261429998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044853431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28386",
    "droptype": "D",
    "dropname": "DAVY",
    "dropdeladd": "83 DAVY SCHOOL HOUSE RD",
    "dropdelcty": "DAVY",
    "dropdelst": "WV",
    "dropdelzpp": 248289998,
    "dropphyadd": "83 DAVY SCHOOL HOUSE RD",
    "dropphycty": "DAVY",
    "dropphyst": "WV",
    "dropphyzpp": 248289998,
    "dropmaladd": "83 DAVY SCHOOL HOUSE RD",
    "dropmalcty": "DAVY",
    "dropmalst": "WV",
    "dropmalzpp": 248289998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046567067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28387",
    "droptype": "D",
    "dropname": "DAWES",
    "dropdeladd": "5558 CABIN CREEK DR",
    "dropdelcty": "DAWES",
    "dropdelst": "WV",
    "dropdelzpp": 250549998,
    "dropphyadd": "5558 CABIN CREEK DR",
    "dropphycty": "DAWES",
    "dropphyst": "WV",
    "dropphyzpp": 250549998,
    "dropmaladd": "5558 CABIN CREEK DR",
    "dropmalcty": "DAWES",
    "dropmalst": "WV",
    "dropmalzpp": 250549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28394",
    "droptype": "D",
    "dropname": "DELBARTON",
    "dropdeladd": "128 GRACE ST",
    "dropdelcty": "DELBARTON",
    "dropdelst": "WV",
    "dropdelzpp": 256709998,
    "dropphyadd": "128 GRACE ST",
    "dropphycty": "DELBARTON",
    "dropphyst": "WV",
    "dropphyzpp": 256709998,
    "dropmaladd": "128 GRACE ST",
    "dropmalcty": "DELBARTON",
    "dropmalst": "WV",
    "dropmalzpp": 256709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044752063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28395",
    "droptype": "D",
    "dropname": "DELLSLOW",
    "dropdeladd": "1902 ELJAZID ST",
    "dropdelcty": "DELLSLOW",
    "dropdelst": "WV",
    "dropdelzpp": 265319998,
    "dropphyadd": "1902 ELJAZID ST",
    "dropphycty": "DELLSLOW",
    "dropphyst": "WV",
    "dropphyzpp": 265319998,
    "dropmaladd": "1902 ELJAZID ST",
    "dropmalcty": "DELLSLOW",
    "dropmalst": "WV",
    "dropmalzpp": 265319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042922551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28400",
    "droptype": "D",
    "dropname": "DIANA",
    "dropdeladd": "4632 DIANA DR",
    "dropdelcty": "DIANA",
    "dropdelst": "WV",
    "dropdelzpp": 262179998,
    "dropphyadd": "4632 DIANA DR",
    "dropphycty": "DIANA",
    "dropphyst": "WV",
    "dropphyzpp": 262179998,
    "dropmaladd": "4632 DIANA DR",
    "dropmalcty": "DIANA",
    "dropmalst": "WV",
    "dropmalzpp": 262179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048472247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28401",
    "droptype": "D",
    "dropname": "DILLE",
    "dropdeladd": "7078 WIDEN DILLE RD",
    "dropdelcty": "DILLE",
    "dropdelst": "WV",
    "dropdelzpp": 266179998,
    "dropphyadd": "7078 WIDEN DILLE RD",
    "dropphycty": "DILLE",
    "dropphyst": "WV",
    "dropphyzpp": 266179998,
    "dropmaladd": "7078 WIDEN DILLE RD",
    "dropmalcty": "DILLE",
    "dropmalst": "WV",
    "dropmalzpp": 266179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043325321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28402",
    "droptype": "D",
    "dropname": "DINGESS",
    "dropdeladd": "227 MOUNT HOPE DR",
    "dropdelcty": "DINGESS",
    "dropdelst": "WV",
    "dropdelzpp": 256719998,
    "dropphyadd": "227 MOUNT HOPE DR",
    "dropphycty": "DINGESS",
    "dropphyst": "WV",
    "dropphyzpp": 256719998,
    "dropmaladd": "227 MOUNT HOPE DR",
    "dropmalcty": "DINGESS",
    "dropmalst": "WV",
    "dropmalzpp": 256719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047529132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28403",
    "droptype": "D",
    "dropname": "DIXIE",
    "dropdeladd": "1792 DIXIE HWY",
    "dropdelcty": "DIXIE",
    "dropdelst": "WV",
    "dropdelzpp": 250599998,
    "dropphyadd": "1792 DIXIE HWY",
    "dropphycty": "DIXIE",
    "dropphyst": "WV",
    "dropphyzpp": 250599998,
    "dropmaladd": "1792 DIXIE HWY",
    "dropmalcty": "DIXIE",
    "dropmalst": "WV",
    "dropmalzpp": 250599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046322182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28405",
    "droptype": "D",
    "dropname": "DOROTHY",
    "dropdeladd": "8974 CLEAR FORK RD",
    "dropdelcty": "DOROTHY",
    "dropdelst": "WV",
    "dropdelzpp": 250609998,
    "dropphyadd": "8974 CLEAR FORK RD",
    "dropphycty": "DOROTHY",
    "dropphyst": "WV",
    "dropphyzpp": 250609998,
    "dropmaladd": "8974 CLEAR FORK RD",
    "dropmalcty": "DOROTHY",
    "dropmalst": "WV",
    "dropmalzpp": 250609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048542032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28410",
    "droptype": "D",
    "dropname": "DRENNEN",
    "dropdeladd": "12 MISTY RD",
    "dropdelcty": "DRENNEN",
    "dropdelst": "WV",
    "dropdelzpp": 266679998,
    "dropphyadd": "12 MISTY RD",
    "dropphycty": "DRENNEN",
    "dropphyst": "WV",
    "dropphyzpp": 266679998,
    "dropmaladd": "12 MISTY RD",
    "dropmalcty": "DRENNEN",
    "dropmalst": "WV",
    "dropmalzpp": 266679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048725830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28412",
    "droptype": "D",
    "dropname": "DRY CREEK",
    "dropdeladd": "6486 COAL RIVER RD",
    "dropdelcty": "DRY CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 250629998,
    "dropphyadd": "6486 COAL RIVER RD",
    "dropphycty": "DRY CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 250629998,
    "dropmaladd": "6486 COAL RIVER RD",
    "dropmalcty": "DRY CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 250629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048541098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28413",
    "droptype": "D",
    "dropname": "DRYBRANCH",
    "dropdeladd": "2137 CABIN CREEK RD",
    "dropdelcty": "DRYBRANCH",
    "dropdelst": "WV",
    "dropdelzpp": 250619998,
    "dropphyadd": "2137 CABIN CREEK RD",
    "dropphycty": "DRYBRANCH",
    "dropphyst": "WV",
    "dropphyzpp": 250619998,
    "dropmaladd": "2137 CABIN CREEK RD",
    "dropmalcty": "DRYBRANCH",
    "dropmalst": "WV",
    "dropmalzpp": 250619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28414",
    "droptype": "D",
    "dropname": "DRYFORK",
    "dropdeladd": "4514 APPALACHIAN HWY",
    "dropdelcty": "DRYFORK",
    "dropdelst": "WV",
    "dropdelzpp": 262639998,
    "dropphyadd": "4514 APPALACHIAN HWY",
    "dropphycty": "DRYFORK",
    "dropphyst": "WV",
    "dropphyzpp": 262639998,
    "dropmaladd": "4514 APPALACHIAN HWY",
    "dropmalcty": "DRYFORK",
    "dropmalst": "WV",
    "dropmalzpp": 262639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042274769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28415",
    "droptype": "D",
    "dropname": "DUCK",
    "dropdeladd": "390 SERVIA ELMIRA RD",
    "dropdelcty": "DUCK",
    "dropdelst": "WV",
    "dropdelzpp": 250639998,
    "dropphyadd": "390 SERVIA ELMIRA RD",
    "dropphycty": "DUCK",
    "dropphyst": "WV",
    "dropphyzpp": 250639998,
    "dropmaladd": "390 SERVIA ELMIRA RD",
    "dropmalcty": "DUCK",
    "dropmalst": "WV",
    "dropmalzpp": 250639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043645757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28417",
    "droptype": "D",
    "dropname": "DUNBAR",
    "dropdeladd": "1201 GROSSCUP AVE",
    "dropdelcty": "DUNBAR",
    "dropdelst": "WV",
    "dropdelzpp": 250649998,
    "dropphyadd": "1201 GROSSCUP AVE",
    "dropphycty": "DUNBAR",
    "dropphyst": "WV",
    "dropphyzpp": 250649998,
    "dropmaladd": "1201 GROSSCUP AVE",
    "dropmalcty": "DUNBAR",
    "dropmalst": "WV",
    "dropmalzpp": 250649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047667158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28421",
    "droptype": "D",
    "dropname": "DUNLOW",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "DUNLOW",
    "dropdelst": "WV",
    "dropdelzpp": 255119998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "DUNLOW",
    "dropphyst": "WV",
    "dropphyzpp": 255119998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "DUNLOW",
    "dropmalst": "WV",
    "dropmalzpp": 255119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043854250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28422",
    "droptype": "D",
    "dropname": "DUNMORE",
    "dropdeladd": "200 POTOMAC HIGHLANDS TRL",
    "dropdelcty": "DUNMORE",
    "dropdelst": "WV",
    "dropdelzpp": 249349998,
    "dropphyadd": "200 POTOMAC HIGHLANDS TRL",
    "dropphycty": "DUNMORE",
    "dropphyst": "WV",
    "dropphyzpp": 249349998,
    "dropmaladd": "200 POTOMAC HIGHLANDS TRL",
    "dropmalcty": "DUNMORE",
    "dropmalst": "WV",
    "dropmalzpp": 249349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044563186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28424",
    "droptype": "D",
    "dropname": "DURBIN",
    "dropdeladd": "4345 STAUNTON PARKERSBURG TPKE",
    "dropdelcty": "DURBIN",
    "dropdelst": "WV",
    "dropdelzpp": 262649998,
    "dropphyadd": "4345 STAUNTON PARKERSBURG TPKE",
    "dropphycty": "DURBIN",
    "dropphyst": "WV",
    "dropphyzpp": 262649998,
    "dropmaladd": "4345 STAUNTON PARKERSBURG TPKE",
    "dropmalcty": "DURBIN",
    "dropmalst": "WV",
    "dropmalzpp": 262649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044564861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28426",
    "droptype": "D",
    "dropname": "EAST BANK",
    "dropdeladd": "208 WILLOW ST",
    "dropdelcty": "EAST BANK",
    "dropdelst": "WV",
    "dropdelzpp": 250675000,
    "dropphyadd": "208 WILLOW ST",
    "dropphycty": "EAST BANK",
    "dropphyst": "WV",
    "dropphyzpp": 250675000,
    "dropmaladd": "208 WILLOW ST",
    "dropmalcty": "EAST BANK",
    "dropmalst": "WV",
    "dropmalzpp": 250675000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28430",
    "droptype": "D",
    "dropname": "EAST LYNN",
    "dropdeladd": "19123 E LYNN RD",
    "dropdelcty": "EAST LYNN",
    "dropdelst": "WV",
    "dropdelzpp": 255129998,
    "dropphyadd": "19123 E LYNN RD",
    "dropphycty": "EAST LYNN",
    "dropphyst": "WV",
    "dropphyzpp": 255129998,
    "dropmaladd": "19123 E LYNN RD",
    "dropmalcty": "EAST LYNN",
    "dropmalst": "WV",
    "dropmalzpp": 255129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048492366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28435",
    "droptype": "D",
    "dropname": "ECCLES",
    "dropdeladd": "108 SHAWNEE RD",
    "dropdelcty": "ECCLES",
    "dropdelst": "WV",
    "dropdelzpp": 258369998,
    "dropphyadd": "108 SHAWNEE RD",
    "dropphycty": "ECCLES",
    "dropphyst": "WV",
    "dropphyzpp": 258369998,
    "dropmaladd": "108 SHAWNEE RD",
    "dropmalcty": "ECCLES",
    "dropmalst": "WV",
    "dropmalzpp": 258369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042556975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28437",
    "droptype": "D",
    "dropname": "EDGARTON",
    "dropdeladd": "5501 RT 49",
    "dropdelcty": "EDGARTON",
    "dropdelst": "WV",
    "dropdelzpp": 256729998,
    "dropphyadd": "5501 RT 49",
    "dropphycty": "EDGARTON",
    "dropphyst": "WV",
    "dropphyzpp": 256729998,
    "dropmaladd": "5501 RT 49",
    "dropmalcty": "EDGARTON",
    "dropmalst": "WV",
    "dropmalzpp": 256729998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044266460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28439",
    "droptype": "D",
    "dropname": "EDMOND",
    "dropdeladd": "3524 LANSING EDMOND RD",
    "dropdelcty": "EDMOND",
    "dropdelst": "WV",
    "dropdelzpp": 258379998,
    "dropphyadd": "3524 LANSING EDMOND RD",
    "dropphycty": "EDMOND",
    "dropphyst": "WV",
    "dropphyzpp": 258379998,
    "dropmaladd": "3524 LANSING EDMOND RD",
    "dropmalcty": "EDMOND",
    "dropmalst": "WV",
    "dropmalzpp": 258379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045742701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28441",
    "droptype": "D",
    "dropname": "EGLON",
    "dropdeladd": "56 EGLON RD",
    "dropdelcty": "EGLON",
    "dropdelst": "WV",
    "dropdelzpp": 267169998,
    "dropphyadd": "56 EGLON RD",
    "dropphycty": "EGLON",
    "dropphyst": "WV",
    "dropphyzpp": 267169998,
    "dropmaladd": "56 EGLON RD",
    "dropmalcty": "EGLON",
    "dropmalst": "WV",
    "dropmalzpp": 267169998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047184600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28443",
    "droptype": "D",
    "dropname": "ELBERT",
    "dropdeladd": "2619 MIRACLE MOUNTAIN RD",
    "dropdelcty": "ELBERT",
    "dropdelst": "WV",
    "dropdelzpp": 248309998,
    "dropphyadd": "2619 MIRACLE MOUNTAIN RD",
    "dropphycty": "ELBERT",
    "dropphyst": "WV",
    "dropphyzpp": 248309998,
    "dropmaladd": "2619 MIRACLE MOUNTAIN RD",
    "dropmalcty": "ELBERT",
    "dropmalst": "WV",
    "dropmalzpp": 248309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044482325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28444",
    "droptype": "D",
    "dropname": "ELEANOR",
    "dropdeladd": "103 ROOSEVELT BLVD",
    "dropdelcty": "ELEANOR",
    "dropdelst": "WV",
    "dropdelzpp": 250709998,
    "dropphyadd": "103 ROOSEVELT BLVD",
    "dropphycty": "ELEANOR",
    "dropphyst": "WV",
    "dropphyzpp": 250709998,
    "dropmaladd": "103 ROOSEVELT BLVD",
    "dropmalcty": "ELEANOR",
    "dropmalst": "WV",
    "dropmalzpp": 250709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045869771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28446",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "502 E SCHOOLVIEW ST",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "WV",
    "dropdelzpp": 261439998,
    "dropphyadd": "502 E SCHOOLVIEW ST",
    "dropphycty": "ELIZABETH",
    "dropphyst": "WV",
    "dropphyzpp": 261439998,
    "dropmaladd": "502 E SCHOOLVIEW ST",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "WV",
    "dropmalzpp": 261439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042756522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28447",
    "droptype": "D",
    "dropname": "ELK GARDEN",
    "dropdeladd": "90 OAK ST",
    "dropdelcty": "ELK GARDEN",
    "dropdelst": "WV",
    "dropdelzpp": 267179998,
    "dropphyadd": "90 OAK ST",
    "dropphycty": "ELK GARDEN",
    "dropphyst": "WV",
    "dropphyzpp": 267179998,
    "dropmaladd": "90 OAK ST",
    "dropmalcty": "ELK GARDEN",
    "dropmalst": "WV",
    "dropmalzpp": 267179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044465626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28449",
    "droptype": "D",
    "dropname": "ELKINS",
    "dropdeladd": "300 3RD ST FL 1",
    "dropdelcty": "ELKINS",
    "dropdelst": "WV",
    "dropdelzpp": 262419998,
    "dropphyadd": "300 3RD ST FL 1",
    "dropphycty": "ELKINS",
    "dropphyst": "WV",
    "dropphyzpp": 262419998,
    "dropmaladd": "300 3RD ST FL 1",
    "dropmalcty": "ELKINS",
    "dropmalst": "WV",
    "dropmalzpp": 262419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046361545,
    "dropfax": 3046369667
  },
  {
    "dcode": "D",
    "dropkey": "PX28451",
    "droptype": "D",
    "dropname": "ELKVIEW",
    "dropdeladd": "5062 ELK RIVER RD S",
    "dropdelcty": "ELKVIEW",
    "dropdelst": "WV",
    "dropdelzpp": 250719998,
    "dropphyadd": "5062 ELK RIVER RD S",
    "dropphycty": "ELKVIEW",
    "dropphyst": "WV",
    "dropphyzpp": 250719998,
    "dropmaladd": "5062 ELK RIVER RD S",
    "dropmalcty": "ELKVIEW",
    "dropmalst": "WV",
    "dropmalzpp": 250719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049653221,
    "dropfax": 3049657554
  },
  {
    "dcode": "D",
    "dropkey": "PX28453",
    "droptype": "D",
    "dropname": "ELLENBORO",
    "dropdeladd": "101 E WASHINGTON AVE",
    "dropdelcty": "ELLENBORO",
    "dropdelst": "WV",
    "dropdelzpp": 263469998,
    "dropphyadd": "101 E WASHINGTON AVE",
    "dropphycty": "ELLENBORO",
    "dropphyst": "WV",
    "dropphyzpp": 263469998,
    "dropmaladd": "101 E WASHINGTON AVE",
    "dropmalcty": "ELLENBORO",
    "dropmalst": "WV",
    "dropmalzpp": 263469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048693342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28461",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "3215 HOOD AVE",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "WV",
    "dropdelzpp": 265689998,
    "dropphyadd": "3215 HOOD AVE",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "WV",
    "dropphyzpp": 265689998,
    "dropmaladd": "3215 HOOD AVE",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "WV",
    "dropmalzpp": 265689998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045923399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28462",
    "droptype": "D",
    "dropname": "ERBACON",
    "dropdeladd": "5776 ERBACON RD",
    "dropdelcty": "ERBACON",
    "dropdelst": "WV",
    "dropdelzpp": 262039998,
    "dropphyadd": "5776 ERBACON RD",
    "dropphycty": "ERBACON",
    "dropphyst": "WV",
    "dropphyzpp": 262039998,
    "dropmaladd": "5776 ERBACON RD",
    "dropmalcty": "ERBACON",
    "dropmalst": "WV",
    "dropmalzpp": 262039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042263967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28464",
    "droptype": "D",
    "dropname": "ESKDALE",
    "dropdeladd": "28 KEENEY DR",
    "dropdelcty": "ESKDALE",
    "dropdelst": "WV",
    "dropdelzpp": 250759998,
    "dropphyadd": "28 KEENEY DR",
    "dropphycty": "ESKDALE",
    "dropphyst": "WV",
    "dropphyzpp": 250759998,
    "dropmaladd": "28 KEENEY DR",
    "dropmalcty": "ESKDALE",
    "dropmalst": "WV",
    "dropmalzpp": 250759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045954601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28465",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "2978 BLAIR MOUNTAIN HWY",
    "dropdelcty": "ETHEL",
    "dropdelst": "WV",
    "dropdelzpp": 250769998,
    "dropphyadd": "2978 BLAIR MOUNTAIN HWY",
    "dropphycty": "ETHEL",
    "dropphyst": "WV",
    "dropphyzpp": 250769998,
    "dropmaladd": "2978 BLAIR MOUNTAIN HWY",
    "dropmalcty": "ETHEL",
    "dropmalst": "WV",
    "dropmalzpp": 250769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047529309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28467",
    "droptype": "D",
    "dropname": "EVANS",
    "dropdeladd": "116 EVANS RD",
    "dropdelcty": "EVANS",
    "dropdelst": "WV",
    "dropdelzpp": 252419998,
    "dropphyadd": "116 EVANS RD",
    "dropphycty": "EVANS",
    "dropphyst": "WV",
    "dropphyzpp": 252419998,
    "dropmaladd": "116 EVANS RD",
    "dropmalcty": "EVANS",
    "dropmalst": "WV",
    "dropmalzpp": 252419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043724115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28472",
    "droptype": "D",
    "dropname": "FAIRDALE",
    "dropdeladd": "698 BOLT RD",
    "dropdelcty": "FAIRDALE",
    "dropdelst": "WV",
    "dropdelzpp": 258399998,
    "dropphyadd": "698 BOLT RD",
    "dropphycty": "FAIRDALE",
    "dropphyst": "WV",
    "dropphyzpp": 258399998,
    "dropmaladd": "698 BOLT RD",
    "dropmalcty": "FAIRDALE",
    "dropmalst": "WV",
    "dropmalzpp": 258399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049346812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28474",
    "droptype": "D",
    "dropname": "FAIRMONT",
    "dropdeladd": "331 MADISON ST",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "WV",
    "dropdelzpp": 265549998,
    "dropphyadd": "331 MADISON ST",
    "dropphycty": "FAIRMONT",
    "dropphyst": "WV",
    "dropphyzpp": 265549998,
    "dropmaladd": "331 MADISON ST",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "WV",
    "dropmalzpp": 265549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043661610,
    "dropfax": 3043680316
  },
  {
    "dcode": "D",
    "dropkey": "PX28476",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "310 MAIN ST",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "WV",
    "dropdelzpp": 265709998,
    "dropphyadd": "310 MAIN ST",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "WV",
    "dropphyzpp": 265709998,
    "dropmaladd": "310 MAIN ST",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "WV",
    "dropmalzpp": 265709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044491022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28478",
    "droptype": "D",
    "dropname": "FALLING ROCK",
    "dropdeladd": "5520 ELK RIVER RD N",
    "dropdelcty": "FALLING ROCK",
    "dropdelst": "WV",
    "dropdelzpp": 250794000,
    "dropphyadd": "5520 ELK RIVER RD N",
    "dropphycty": "FALLING ROCK",
    "dropphyst": "WV",
    "dropphyzpp": 250794000,
    "dropmaladd": "5520 ELK RIVER RD N",
    "dropmalcty": "FALLING ROCK",
    "dropmalst": "WV",
    "dropmalzpp": 250794000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045484189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28479",
    "droptype": "D",
    "dropname": "FALLING WATERS",
    "dropdeladd": "9853 WILLIAMSPORT PIKE",
    "dropdelcty": "FALLING WATERS",
    "dropdelst": "WV",
    "dropdelzpp": 254199998,
    "dropphyadd": "9853 WILLIAMSPORT PIKE",
    "dropphycty": "FALLING WATERS",
    "dropphyst": "WV",
    "dropphyzpp": 254199998,
    "dropmaladd": "9853 WILLIAMSPORT PIKE",
    "dropmalcty": "FALLING WATERS",
    "dropmalst": "WV",
    "dropmalzpp": 254199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042742091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28482",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "3003 MAIN ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 265719998,
    "dropphyadd": "3003 MAIN ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 265719998,
    "dropmaladd": "3003 MAIN ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 265719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048251105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28483",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "120 W MAPLE AVE",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 258409998,
    "dropphyadd": "120 W MAPLE AVE",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 258409998,
    "dropmaladd": "120 W MAPLE AVE",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 258409998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045741050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28485",
    "droptype": "D",
    "dropname": "FENWICK",
    "dropdeladd": "2643 RICHWOOD RD",
    "dropdelcty": "FENWICK",
    "dropdelst": "WV",
    "dropdelzpp": 262029998,
    "dropphyadd": "2643 RICHWOOD RD",
    "dropphycty": "FENWICK",
    "dropphyst": "WV",
    "dropphyzpp": 262029998,
    "dropmaladd": "2643 RICHWOOD RD",
    "dropmalcty": "FENWICK",
    "dropmalst": "WV",
    "dropmalzpp": 262029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048464349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28490",
    "droptype": "D",
    "dropname": "FLAT TOP",
    "dropdeladd": "21629 BECKLEY RD",
    "dropdelcty": "FLAT TOP",
    "dropdelst": "WV",
    "dropdelzpp": 258414000,
    "dropphyadd": "21629 BECKLEY RD",
    "dropphycty": "FLAT TOP",
    "dropphyst": "WV",
    "dropphyzpp": 258414000,
    "dropmaladd": "21629 BECKLEY RD",
    "dropmalcty": "FLAT TOP",
    "dropmalst": "WV",
    "dropmalzpp": 258414000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047873887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28491",
    "droptype": "D",
    "dropname": "FLATWOODS",
    "dropdeladd": "308 FLATWOODS CORNER RD",
    "dropdelcty": "FLATWOODS",
    "dropdelst": "WV",
    "dropdelzpp": 266219998,
    "dropphyadd": "308 FLATWOODS CORNER RD",
    "dropphycty": "FLATWOODS",
    "dropphyst": "WV",
    "dropphyzpp": 266219998,
    "dropmaladd": "308 FLATWOODS CORNER RD",
    "dropmalcty": "FLATWOODS",
    "dropmalst": "WV",
    "dropmalzpp": 266219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047655480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28492",
    "droptype": "D",
    "dropname": "FLEMINGTON",
    "dropdeladd": "42 E VETERANS MEMORIAL HWY",
    "dropdelcty": "FLEMINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 263479998,
    "dropphyadd": "42 E VETERANS MEMORIAL HWY",
    "dropphycty": "FLEMINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 263479998,
    "dropmaladd": "42 E VETERANS MEMORIAL HWY",
    "dropmalcty": "FLEMINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 263479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047392440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28497",
    "droptype": "D",
    "dropname": "FOLLANSBEE",
    "dropdeladd": "1005 MAIN ST",
    "dropdelcty": "FOLLANSBEE",
    "dropdelst": "WV",
    "dropdelzpp": 260379998,
    "dropphyadd": "1005 MAIN ST",
    "dropphycty": "FOLLANSBEE",
    "dropphyst": "WV",
    "dropphyzpp": 260379998,
    "dropmaladd": "1005 MAIN ST",
    "dropmalcty": "FOLLANSBEE",
    "dropmalst": "WV",
    "dropmalzpp": 260379998,
    "dropsitphn": 4123597960,
    "dropsitlph": 3045272700,
    "dropsitcph": 3045272700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28498",
    "droptype": "D",
    "dropname": "FOLSOM",
    "dropdeladd": "28456 SHORTLINE HWY",
    "dropdelcty": "FOLSOM",
    "dropdelst": "WV",
    "dropdelzpp": 263489998,
    "dropphyadd": "28456 SHORTLINE HWY",
    "dropphycty": "FOLSOM",
    "dropphyst": "WV",
    "dropphyzpp": 263489998,
    "dropmaladd": "28456 SHORTLINE HWY",
    "dropmalcty": "FOLSOM",
    "dropmalst": "WV",
    "dropmalzpp": 263489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043342292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28499",
    "droptype": "D",
    "dropname": "FOREST HILL",
    "dropdeladd": "15830 SR 12",
    "dropdelcty": "FOREST HILL",
    "dropdelst": "WV",
    "dropdelzpp": 249359998,
    "dropphyadd": "15830 SR 12",
    "dropphycty": "FOREST HILL",
    "dropphyst": "WV",
    "dropphyzpp": 249359998,
    "dropmaladd": "15830 SR 12",
    "dropmalcty": "FOREST HILL",
    "dropmalst": "WV",
    "dropmalzpp": 249359998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044664073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28500",
    "droptype": "D",
    "dropname": "FORT ASHBY",
    "dropdeladd": "10456 FRANKFORT HWY",
    "dropdelcty": "FORT ASHBY",
    "dropdelst": "WV",
    "dropdelzpp": 267199998,
    "dropphyadd": "10456 FRANKFORT HWY",
    "dropphycty": "FORT ASHBY",
    "dropphyst": "WV",
    "dropphyzpp": 267199998,
    "dropmaladd": "10456 FRANKFORT HWY",
    "dropmalcty": "FORT ASHBY",
    "dropmalst": "WV",
    "dropmalzpp": 267199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042984749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28502",
    "droptype": "D",
    "dropname": "FORT GAY",
    "dropdeladd": "705 COURT ST",
    "dropdelcty": "FORT GAY",
    "dropdelst": "WV",
    "dropdelzpp": 255149998,
    "dropphyadd": "705 COURT ST",
    "dropphycty": "FORT GAY",
    "dropphyst": "WV",
    "dropphyzpp": 255149998,
    "dropmaladd": "705 COURT ST",
    "dropmalcty": "FORT GAY",
    "dropmalst": "WV",
    "dropmalzpp": 255149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046485346,
    "dropfax": 3046487237
  },
  {
    "dcode": "D",
    "dropkey": "PX28506",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "7976 DANIEL BOONE PKWY",
    "dropdelcty": "FOSTER",
    "dropdelst": "WV",
    "dropdelzpp": 250819998,
    "dropphyadd": "7976 DANIEL BOONE PKWY",
    "dropphycty": "FOSTER",
    "dropphyst": "WV",
    "dropphyzpp": 250819998,
    "dropmaladd": "7976 DANIEL BOONE PKWY",
    "dropmalcty": "FOSTER",
    "dropmalst": "WV",
    "dropmalzpp": 250819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043695293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28508",
    "droptype": "D",
    "dropname": "FOUR STATES",
    "dropdeladd": "84 4 STATES RD",
    "dropdelcty": "FOUR STATES",
    "dropdelst": "WV",
    "dropdelzpp": 265729998,
    "dropphyadd": "84 4 STATES RD",
    "dropphycty": "FOUR STATES",
    "dropphyst": "WV",
    "dropphyzpp": 265729998,
    "dropmaladd": "84 4 STATES RD",
    "dropmalcty": "FOUR STATES",
    "dropmalst": "WV",
    "dropmalzpp": 265729998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042872420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28510",
    "droptype": "D",
    "dropname": "FRAMETOWN",
    "dropdeladd": "7441 ELK RIVER RD",
    "dropdelcty": "FRAMETOWN",
    "dropdelst": "WV",
    "dropdelzpp": 266239998,
    "dropphyadd": "7441 ELK RIVER RD",
    "dropphycty": "FRAMETOWN",
    "dropphyst": "WV",
    "dropphyzpp": 266239998,
    "dropmaladd": "7441 ELK RIVER RD",
    "dropmalcty": "FRAMETOWN",
    "dropmalst": "WV",
    "dropmalzpp": 266239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043648389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28512",
    "droptype": "D",
    "dropname": "FRANKFORD",
    "dropdeladd": "21981 SENECA TRL N",
    "dropdelcty": "FRANKFORD",
    "dropdelst": "WV",
    "dropdelzpp": 249389998,
    "dropphyadd": "21981 SENECA TRL N",
    "dropphycty": "FRANKFORD",
    "dropphyst": "WV",
    "dropphyzpp": 249389998,
    "dropmaladd": "21981 SENECA TRL N",
    "dropmalcty": "FRANKFORD",
    "dropmalst": "WV",
    "dropmalzpp": 249389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044972440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28513",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "63 PINE ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "WV",
    "dropdelzpp": 268079998,
    "dropphyadd": "63 PINE ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "WV",
    "dropphyzpp": 268079998,
    "dropmaladd": "63 PINE ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "WV",
    "dropmalzpp": 268079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043582263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28514",
    "droptype": "D",
    "dropname": "FRAZIERS BOTTOM",
    "dropdeladd": "18350 WINFIELD RD",
    "dropdelcty": "FRAZIERS BOTTOM",
    "dropdelst": "WV",
    "dropdelzpp": 250829998,
    "dropphyadd": "18350 WINFIELD RD",
    "dropphycty": "FRAZIERS BOTTOM",
    "dropphyst": "WV",
    "dropphyzpp": 250829998,
    "dropmaladd": "18350 WINFIELD RD",
    "dropmalcty": "FRAZIERS BOTTOM",
    "dropmalst": "WV",
    "dropmalzpp": 250829998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049373292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28517",
    "droptype": "D",
    "dropname": "FRENCH CREEK",
    "dropdeladd": "7688 RT 20 SOUTH RD",
    "dropdelcty": "FRENCH CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 262189998,
    "dropphyadd": "7688 RT 20 SOUTH RD",
    "dropphycty": "FRENCH CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 262189998,
    "dropmaladd": "7688 RT 20 SOUTH RD",
    "dropmalcty": "FRENCH CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 262189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049246517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28520",
    "droptype": "D",
    "dropname": "FRIENDLY",
    "dropdeladd": "2096 FRIENDLY RD",
    "dropdelcty": "FRIENDLY",
    "dropdelst": "WV",
    "dropdelzpp": 261469998,
    "dropphyadd": "2096 FRIENDLY RD",
    "dropphycty": "FRIENDLY",
    "dropphyst": "WV",
    "dropphyzpp": 261469998,
    "dropmaladd": "2096 FRIENDLY RD",
    "dropmalcty": "FRIENDLY",
    "dropmalst": "WV",
    "dropmalzpp": 261469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046528506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28522",
    "droptype": "D",
    "dropname": "GALLAGHER",
    "dropdeladd": "2341 PAINT CREEK RD",
    "dropdelcty": "GALLAGHER",
    "dropdelst": "WV",
    "dropdelzpp": 250839998,
    "dropphyadd": "2341 PAINT CREEK RD",
    "dropphycty": "GALLAGHER",
    "dropphyst": "WV",
    "dropphyzpp": 250839998,
    "dropmaladd": "2341 PAINT CREEK RD",
    "dropmalcty": "GALLAGHER",
    "dropmalst": "WV",
    "dropmalzpp": 250839998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28523",
    "droptype": "D",
    "dropname": "GALLIPOLIS FERRY",
    "dropdeladd": "11945 HUNTINGTON RD",
    "dropdelcty": "GALLIPOLIS FERRY",
    "dropdelst": "WV",
    "dropdelzpp": 255159998,
    "dropphyadd": "11945 HUNTINGTON RD",
    "dropphycty": "GALLIPOLIS FERRY",
    "dropphyst": "WV",
    "dropphyzpp": 255159998,
    "dropmaladd": "11945 HUNTINGTON RD",
    "dropmalcty": "GALLIPOLIS FERRY",
    "dropmalst": "WV",
    "dropmalzpp": 255159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046756317,
    "dropfax": 3046756317
  },
  {
    "dcode": "D",
    "dropkey": "PX28524",
    "droptype": "D",
    "dropname": "GALLOWAY",
    "dropdeladd": "5130 GALLOWAY RD",
    "dropdelcty": "GALLOWAY",
    "dropdelst": "WV",
    "dropdelzpp": 263499998,
    "dropphyadd": "5130 GALLOWAY RD",
    "dropphycty": "GALLOWAY",
    "dropphyst": "WV",
    "dropphyzpp": 263499998,
    "dropmaladd": "5130 GALLOWAY RD",
    "dropmalcty": "GALLOWAY",
    "dropmalst": "WV",
    "dropmalzpp": 263499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047392320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28525",
    "droptype": "D",
    "dropname": "GANDEEVILLE",
    "dropdeladd": "3886 CHARLESTON RD",
    "dropdelcty": "GANDEEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 252439998,
    "dropphyadd": "3886 CHARLESTON RD",
    "dropphycty": "GANDEEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 252439998,
    "dropmaladd": "3886 CHARLESTON RD",
    "dropmalcty": "GANDEEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 252439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045776414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28526",
    "droptype": "D",
    "dropname": "GAP MILLS",
    "dropdeladd": "11331 SWEET SPRINGS VALLEY RD",
    "dropdelcty": "GAP MILLS",
    "dropdelst": "WV",
    "dropdelzpp": 249415000,
    "dropphyadd": "11331 SWEET SPRINGS VALLEY RD",
    "dropphycty": "GAP MILLS",
    "dropphyst": "WV",
    "dropphyzpp": 249415000,
    "dropmaladd": "11331 SWEET SPRINGS VALLEY RD",
    "dropmalcty": "GAP MILLS",
    "dropmalst": "WV",
    "dropmalzpp": 249415000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047723177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28530",
    "droptype": "D",
    "dropname": "GARY",
    "dropdeladd": "5798 BLACK DIAMOND HWY",
    "dropdelcty": "GARY",
    "dropdelst": "WV",
    "dropdelzpp": 248369998,
    "dropphyadd": "5798 BLACK DIAMOND HWY",
    "dropphycty": "GARY",
    "dropphyst": "WV",
    "dropphyzpp": 248369998,
    "dropmaladd": "5798 BLACK DIAMOND HWY",
    "dropmalcty": "GARY",
    "dropmalst": "WV",
    "dropmalzpp": 248369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044482739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28532",
    "droptype": "D",
    "dropname": "GASSAWAY",
    "dropdeladd": "400 ELK ST",
    "dropdelcty": "GASSAWAY",
    "dropdelst": "WV",
    "dropdelzpp": 266249998,
    "dropphyadd": "400 ELK ST",
    "dropphycty": "GASSAWAY",
    "dropphyst": "WV",
    "dropphyzpp": 266249998,
    "dropmaladd": "400 ELK ST",
    "dropmalcty": "GASSAWAY",
    "dropmalst": "WV",
    "dropmalzpp": 266249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043642291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28534",
    "droptype": "D",
    "dropname": "GAULEY BRIDGE",
    "dropdeladd": "513 GAULEY RIVER RD",
    "dropdelcty": "GAULEY BRIDGE",
    "dropdelst": "WV",
    "dropdelzpp": 250859998,
    "dropphyadd": "513 GAULEY RIVER RD",
    "dropphycty": "GAULEY BRIDGE",
    "dropphyst": "WV",
    "dropphyzpp": 250859998,
    "dropmaladd": "513 GAULEY RIVER RD",
    "dropmalcty": "GAULEY BRIDGE",
    "dropmalst": "WV",
    "dropmalzpp": 250859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046322021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28536",
    "droptype": "D",
    "dropname": "GAY",
    "dropdeladd": "7345 GAY RD",
    "dropdelcty": "GAY",
    "dropdelst": "WV",
    "dropdelzpp": 252449998,
    "dropphyadd": "7345 GAY RD",
    "dropphycty": "GAY",
    "dropphyst": "WV",
    "dropphyzpp": 252449998,
    "dropmaladd": "7345 GAY RD",
    "dropmalcty": "GAY",
    "dropmalst": "WV",
    "dropmalzpp": 252449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043721830,
    "dropfax": 3047522419
  },
  {
    "dcode": "D",
    "dropkey": "PX28538",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "21696 ROUTE 152",
    "dropdelcty": "GENOA",
    "dropdelst": "WV",
    "dropdelzpp": 255175000,
    "dropphyadd": "21696 ROUTE 152",
    "dropphycty": "GENOA",
    "dropphyst": "WV",
    "dropphyzpp": 255175000,
    "dropmaladd": "21696 ROUTE 152",
    "dropmalcty": "GENOA",
    "dropmalst": "WV",
    "dropmalzpp": 255175000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043854227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28540",
    "droptype": "D",
    "dropname": "GERRARDSTOWN",
    "dropdeladd": "1498 GERRARDSTOWN RD",
    "dropdelcty": "GERRARDSTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 254209998,
    "dropphyadd": "1498 GERRARDSTOWN RD",
    "dropphycty": "GERRARDSTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 254209998,
    "dropmaladd": "1498 GERRARDSTOWN RD",
    "dropmalcty": "GERRARDSTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 254209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042293325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28541",
    "droptype": "D",
    "dropname": "GHENT",
    "dropdeladd": "121 ODD RD",
    "dropdelcty": "GHENT",
    "dropdelst": "WV",
    "dropdelzpp": 258439998,
    "dropphyadd": "121 ODD RD",
    "dropphycty": "GHENT",
    "dropphyst": "WV",
    "dropphyzpp": 258439998,
    "dropmaladd": "121 ODD RD",
    "dropmalcty": "GHENT",
    "dropmalst": "WV",
    "dropmalzpp": 258439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047875868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28543",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "9 STAFFORD BR",
    "dropdelcty": "GILBERT",
    "dropdelst": "WV",
    "dropdelzpp": 256219998,
    "dropphyadd": "9 STAFFORD BR",
    "dropphycty": "GILBERT",
    "dropphyst": "WV",
    "dropphyzpp": 256219998,
    "dropmaladd": "9 STAFFORD BR",
    "dropmalcty": "GILBERT",
    "dropmalst": "WV",
    "dropmalzpp": 256219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046643888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28544",
    "droptype": "D",
    "dropname": "GILBOA",
    "dropdeladd": "5495 TURNPIKE RD",
    "dropdelcty": "GILBOA",
    "dropdelst": "WV",
    "dropdelzpp": 266719998,
    "dropphyadd": "5495 TURNPIKE RD",
    "dropphycty": "GILBOA",
    "dropphyst": "WV",
    "dropphyzpp": 266719998,
    "dropmaladd": "5495 TURNPIKE RD",
    "dropmalcty": "GILBOA",
    "dropmalst": "WV",
    "dropmalzpp": 266719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048726535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28553",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "406 3RD ST",
    "dropdelcty": "GLASGOW",
    "dropdelst": "WV",
    "dropdelzpp": 250869998,
    "dropphyadd": "406 3RD ST",
    "dropphycty": "GLASGOW",
    "dropphyst": "WV",
    "dropphyzpp": 250869998,
    "dropmaladd": "406 3RD ST",
    "dropmalcty": "GLASGOW",
    "dropmalst": "WV",
    "dropmalzpp": 250869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045952603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28555",
    "droptype": "D",
    "dropname": "GLEN DALE",
    "dropdeladd": "401 4TH ST",
    "dropdelcty": "GLEN DALE",
    "dropdelst": "WV",
    "dropdelzpp": 260389998,
    "dropphyadd": "401 4TH ST",
    "dropphycty": "GLEN DALE",
    "dropphyst": "WV",
    "dropphyzpp": 260389998,
    "dropmaladd": "401 4TH ST",
    "dropmalcty": "GLEN DALE",
    "dropmalst": "WV",
    "dropmalzpp": 260389998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3048452614,
    "dropsitcph": 3048452614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28556",
    "droptype": "D",
    "dropname": "GLEN DANIEL",
    "dropdeladd": "7134 HARPER RD",
    "dropdelcty": "GLEN DANIEL",
    "dropdelst": "WV",
    "dropdelzpp": 258449998,
    "dropphyadd": "7134 HARPER RD",
    "dropphycty": "GLEN DANIEL",
    "dropphyst": "WV",
    "dropphyzpp": 258449998,
    "dropmaladd": "7134 HARPER RD",
    "dropmalcty": "GLEN DANIEL",
    "dropmalst": "WV",
    "dropmalzpp": 258449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049347281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28560",
    "droptype": "D",
    "dropname": "GLEN FERRIS",
    "dropdeladd": "8999 MIDLAND TRL",
    "dropdelcty": "GLEN FERRIS",
    "dropdelst": "WV",
    "dropdelzpp": 250909998,
    "dropphyadd": "8999 MIDLAND TRL",
    "dropphycty": "GLEN FERRIS",
    "dropphyst": "WV",
    "dropphyzpp": 250909998,
    "dropmaladd": "8999 MIDLAND TRL",
    "dropmalcty": "GLEN FERRIS",
    "dropmalst": "WV",
    "dropmalzpp": 250909998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046322529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28561",
    "droptype": "D",
    "dropname": "GLEN FORK",
    "dropdeladd": "4200 POPLAR GAP RD",
    "dropdelcty": "GLEN FORK",
    "dropdelst": "WV",
    "dropdelzpp": 258459998,
    "dropphyadd": "4200 POPLAR GAP RD",
    "dropphycty": "GLEN FORK",
    "dropphyst": "WV",
    "dropphyzpp": 258459998,
    "dropmaladd": "4200 POPLAR GAP RD",
    "dropmalcty": "GLEN FORK",
    "dropmalst": "WV",
    "dropmalzpp": 258459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046825661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28562",
    "droptype": "D",
    "dropname": "GLEN JEAN",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "GLEN JEAN",
    "dropdelst": "WV",
    "dropdelzpp": 258469998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "GLEN JEAN",
    "dropphyst": "WV",
    "dropphyzpp": 258469998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "GLEN JEAN",
    "dropmalst": "WV",
    "dropmalzpp": 258469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044696989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28564",
    "droptype": "D",
    "dropname": "GLEN ROGERS",
    "dropdeladd": "2517 GLEN ROGERS RD",
    "dropdelcty": "GLEN ROGERS",
    "dropdelst": "WV",
    "dropdelzpp": 258489998,
    "dropphyadd": "2517 GLEN ROGERS RD",
    "dropphycty": "GLEN ROGERS",
    "dropphyst": "WV",
    "dropphyzpp": 258489998,
    "dropmaladd": "2517 GLEN ROGERS RD",
    "dropmalcty": "GLEN ROGERS",
    "dropmalst": "WV",
    "dropmalzpp": 258489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042944208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28569",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "201 E MAIN ST RM 100",
    "dropdelcty": "GLENVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 263519998,
    "dropphyadd": "201 E MAIN ST RM 100",
    "dropphycty": "GLENVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 263519998,
    "dropmaladd": "201 E MAIN ST RM 100",
    "dropmalcty": "GLENVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 263519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044627323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28570",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "39272 HUNTINGTON RD",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 255209998,
    "dropphyadd": "39272 HUNTINGTON RD",
    "dropphycty": "GLENWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 255209998,
    "dropmaladd": "39272 HUNTINGTON RD",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 255209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045762257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28573",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "2303 GORDON RD",
    "dropdelcty": "GORDON",
    "dropdelst": "WV",
    "dropdelzpp": 250939998,
    "dropphyadd": "2303 GORDON RD",
    "dropphycty": "GORDON",
    "dropphyst": "WV",
    "dropphyzpp": 250939998,
    "dropmaladd": "2303 GORDON RD",
    "dropmalcty": "GORDON",
    "dropmalst": "WV",
    "dropmalzpp": 250939998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042458801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28575",
    "droptype": "D",
    "dropname": "GORMANIA",
    "dropdeladd": "40 TRAIN LN",
    "dropdelcty": "GORMANIA",
    "dropdelst": "WV",
    "dropdelzpp": 267209998,
    "dropphyadd": "40 TRAIN LN",
    "dropphycty": "GORMANIA",
    "dropphyst": "WV",
    "dropphyzpp": 267209998,
    "dropmaladd": "40 TRAIN LN",
    "dropmalcty": "GORMANIA",
    "dropmalst": "WV",
    "dropmalzpp": 267209998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046937123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28577",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "260 W MAIN ST",
    "dropdelcty": "GRAFTON",
    "dropdelst": "WV",
    "dropdelzpp": 263549998,
    "dropphyadd": "260 W MAIN ST",
    "dropphycty": "GRAFTON",
    "dropphyst": "WV",
    "dropphyzpp": 263549998,
    "dropmaladd": "260 W MAIN ST",
    "dropmalcty": "GRAFTON",
    "dropmalst": "WV",
    "dropmalzpp": 263549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042651883,
    "dropfax": 3042653976
  },
  {
    "dcode": "D",
    "dropkey": "PX28579",
    "droptype": "D",
    "dropname": "GRANT TOWN",
    "dropdeladd": "107 1/2 BALLAH AVE",
    "dropdelcty": "GRANT TOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265749998,
    "dropphyadd": "107 1/2 BALLAH AVE",
    "dropphycty": "GRANT TOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265749998,
    "dropmaladd": "107 1/2 BALLAH AVE",
    "dropmalcty": "GRANT TOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265749998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042787529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28580",
    "droptype": "D",
    "dropname": "GRANTSVILLE",
    "dropdeladd": "372 MAIN ST",
    "dropdelcty": "GRANTSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261479998,
    "dropphyadd": "372 MAIN ST",
    "dropphycty": "GRANTSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261479998,
    "dropmaladd": "372 MAIN ST",
    "dropmalcty": "GRANTSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043546316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28581",
    "droptype": "D",
    "dropname": "GRANVILLE",
    "dropdeladd": "524 MAIN ST",
    "dropdelcty": "GRANVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265349998,
    "dropphyadd": "524 MAIN ST",
    "dropphycty": "GRANVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265349998,
    "dropmaladd": "524 MAIN ST",
    "dropmalcty": "GRANVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045995075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28583",
    "droptype": "D",
    "dropname": "GREAT CACAPON",
    "dropdeladd": "5010 CENTRAL AVE",
    "dropdelcty": "GREAT CACAPON",
    "dropdelst": "WV",
    "dropdelzpp": 254229998,
    "dropphyadd": "5010 CENTRAL AVE",
    "dropphycty": "GREAT CACAPON",
    "dropphyst": "WV",
    "dropphyzpp": 254229998,
    "dropmaladd": "5010 CENTRAL AVE",
    "dropmalcty": "GREAT CACAPON",
    "dropmalst": "WV",
    "dropmalzpp": 254229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042581012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28584",
    "droptype": "D",
    "dropname": "GREEN BANK",
    "dropdeladd": "5314 POTOMAC HIGHLANDS TRL",
    "dropdelcty": "GREEN BANK",
    "dropdelst": "WV",
    "dropdelzpp": 249449998,
    "dropphyadd": "5314 POTOMAC HIGHLANDS TRL",
    "dropphycty": "GREEN BANK",
    "dropphyst": "WV",
    "dropphyzpp": 249449998,
    "dropmaladd": "5314 POTOMAC HIGHLANDS TRL",
    "dropmalcty": "GREEN BANK",
    "dropmalst": "WV",
    "dropmalzpp": 249449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044564081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28586",
    "droptype": "D",
    "dropname": "GREEN SPRING",
    "dropdeladd": "167 BELL ST",
    "dropdelcty": "GREEN SPRING",
    "dropdelst": "WV",
    "dropdelzpp": 267225000,
    "dropphyadd": "167 BELL ST",
    "dropphycty": "GREEN SPRING",
    "dropphyst": "WV",
    "dropphyzpp": 267225000,
    "dropmaladd": "167 BELL ST",
    "dropmalcty": "GREEN SPRING",
    "dropmalst": "WV",
    "dropmalzpp": 267225000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044925154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28590",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "35 OLD SCHOOLHOUSE RD",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 249459998,
    "dropphyadd": "35 OLD SCHOOLHOUSE RD",
    "dropphycty": "GREENVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 249459998,
    "dropmaladd": "35 OLD SCHOOLHOUSE RD",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 249459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048326276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28592",
    "droptype": "D",
    "dropname": "GRIFFITHSVILLE",
    "dropdeladd": "5290 STRAIGHT FRK",
    "dropdelcty": "GRIFFITHSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 255219998,
    "dropphyadd": "5290 STRAIGHT FRK",
    "dropphycty": "GRIFFITHSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 255219998,
    "dropmaladd": "5290 STRAIGHT FRK",
    "dropmalcty": "GRIFFITHSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 255219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045247366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28597",
    "droptype": "D",
    "dropname": "GYPSY",
    "dropdeladd": "6426 SHINNSTON PIKE",
    "dropdelcty": "GYPSY",
    "dropdelst": "WV",
    "dropdelzpp": 263619998,
    "dropphyadd": "6426 SHINNSTON PIKE",
    "dropphycty": "GYPSY",
    "dropphyst": "WV",
    "dropphyzpp": 263619998,
    "dropmaladd": "6426 SHINNSTON PIKE",
    "dropmalcty": "GYPSY",
    "dropmalst": "WV",
    "dropmalzpp": 263619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045923612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28599",
    "droptype": "D",
    "dropname": "HALLTOWN",
    "dropdeladd": "402 SHEPHERDSTOWN PIKE",
    "dropdelcty": "HALLTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 254239998,
    "dropphyadd": "402 SHEPHERDSTOWN PIKE",
    "dropphycty": "HALLTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 254239998,
    "dropmaladd": "402 SHEPHERDSTOWN PIKE",
    "dropmalcty": "HALLTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 254239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047253367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28600",
    "droptype": "D",
    "dropname": "HAMBLETON",
    "dropdeladd": "197 CENTER ST",
    "dropdelcty": "HAMBLETON",
    "dropdelst": "WV",
    "dropdelzpp": 262699998,
    "dropphyadd": "197 CENTER ST",
    "dropphycty": "HAMBLETON",
    "dropphyst": "WV",
    "dropphyzpp": 262699998,
    "dropmaladd": "197 CENTER ST",
    "dropmalcty": "HAMBLETON",
    "dropmalst": "WV",
    "dropmalzpp": 262699998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044781156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28601",
    "droptype": "D",
    "dropname": "HAMLIN",
    "dropdeladd": "8111 COURT AVE",
    "dropdelcty": "HAMLIN",
    "dropdelst": "WV",
    "dropdelzpp": 255239998,
    "dropphyadd": "8111 COURT AVE",
    "dropphycty": "HAMLIN",
    "dropphyst": "WV",
    "dropphyzpp": 255239998,
    "dropmaladd": "8111 COURT AVE",
    "dropmalcty": "HAMLIN",
    "dropmalst": "WV",
    "dropmalzpp": 255239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048243633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28604",
    "droptype": "D",
    "dropname": "HANDLEY",
    "dropdeladd": "37 2ND AVE",
    "dropdelcty": "HANDLEY",
    "dropdelst": "WV",
    "dropdelzpp": 251029998,
    "dropphyadd": "37 2ND AVE",
    "dropphycty": "HANDLEY",
    "dropphyst": "WV",
    "dropphyzpp": 251029998,
    "dropmaladd": "37 2ND AVE",
    "dropmalcty": "HANDLEY",
    "dropmalst": "WV",
    "dropmalzpp": 251029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044424614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28605",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "5541 INTERSTATE HWY",
    "dropdelcty": "HANOVER",
    "dropdelst": "WV",
    "dropdelzpp": 248399998,
    "dropphyadd": "5541 INTERSTATE HWY",
    "dropphycty": "HANOVER",
    "dropphyst": "WV",
    "dropphyzpp": 248399998,
    "dropmaladd": "5541 INTERSTATE HWY",
    "dropmalcty": "HANOVER",
    "dropmalst": "WV",
    "dropmalzpp": 248399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046648445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28606",
    "droptype": "D",
    "dropname": "HANSFORD",
    "dropdeladd": "1210 KANAWHA ST",
    "dropdelcty": "HANSFORD",
    "dropdelst": "WV",
    "dropdelzpp": 251035001,
    "dropphyadd": "1210 KANAWHA ST",
    "dropphycty": "HANSFORD",
    "dropphyst": "WV",
    "dropphyzpp": 251035001,
    "dropmaladd": "1210 KANAWHA ST",
    "dropmalcty": "HANSFORD",
    "dropmalst": "WV",
    "dropmalzpp": 251035001,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28607",
    "droptype": "D",
    "dropname": "HARMAN",
    "dropdeladd": "62 MOTT ST",
    "dropdelcty": "HARMAN",
    "dropdelst": "WV",
    "dropdelzpp": 262709998,
    "dropphyadd": "62 MOTT ST",
    "dropphycty": "HARMAN",
    "dropphyst": "WV",
    "dropphyzpp": 262709998,
    "dropmaladd": "62 MOTT ST",
    "dropmalcty": "HARMAN",
    "dropmalst": "WV",
    "dropmalzpp": 262709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042274407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28609",
    "droptype": "D",
    "dropname": "HARPER",
    "dropdeladd": "3520 HARPER RD",
    "dropdelcty": "HARPER",
    "dropdelst": "WV",
    "dropdelzpp": 258519998,
    "dropphyadd": "3520 HARPER RD",
    "dropphycty": "HARPER",
    "dropphyst": "WV",
    "dropphyzpp": 258519998,
    "dropmaladd": "3520 HARPER RD",
    "dropmalcty": "HARPER",
    "dropmalst": "WV",
    "dropmalzpp": 258519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042555822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28610",
    "droptype": "D",
    "dropname": "HARPERS FERRY",
    "dropdeladd": "1010 WASHINGTON ST",
    "dropdelcty": "HARPERS FERRY",
    "dropdelst": "WV",
    "dropdelzpp": 254259998,
    "dropphyadd": "1010 WASHINGTON ST",
    "dropphycty": "HARPERS FERRY",
    "dropphyst": "WV",
    "dropphyzpp": 254259998,
    "dropmaladd": "1010 WASHINGTON ST",
    "dropmalcty": "HARPERS FERRY",
    "dropmalst": "WV",
    "dropmalzpp": 254259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045352479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28612",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "602 E SOUTH ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 263629998,
    "dropphyadd": "602 E SOUTH ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 263629998,
    "dropmaladd": "602 E SOUTH ST",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 263629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046432201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28613",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "209 HEALEY ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "WV",
    "dropdelzpp": 252479998,
    "dropphyadd": "209 HEALEY ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "WV",
    "dropphyzpp": 252479998,
    "dropmaladd": "209 HEALEY ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "WV",
    "dropmalzpp": 252479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048823313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28615",
    "droptype": "D",
    "dropname": "HARTS",
    "dropdeladd": "1074 MCCLELLAN HWY",
    "dropdelcty": "HARTS",
    "dropdelst": "WV",
    "dropdelzpp": 255249998,
    "dropphyadd": "1074 MCCLELLAN HWY",
    "dropphycty": "HARTS",
    "dropphyst": "WV",
    "dropphyzpp": 255249998,
    "dropmaladd": "1074 MCCLELLAN HWY",
    "dropmalcty": "HARTS",
    "dropmalst": "WV",
    "dropmalzpp": 255249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048557812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28621",
    "droptype": "D",
    "dropname": "HAYWOOD",
    "dropdeladd": "1573 HAYWOOD RD",
    "dropdelcty": "HAYWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 263669998,
    "dropphyadd": "1573 HAYWOOD RD",
    "dropphycty": "HAYWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 263669998,
    "dropmaladd": "1573 HAYWOOD RD",
    "dropmalcty": "HAYWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 263669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045844286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28624",
    "droptype": "D",
    "dropname": "HEATERS",
    "dropdeladd": "4195 GAULEY TPKE",
    "dropdelcty": "HEATERS",
    "dropdelst": "WV",
    "dropdelzpp": 266279998,
    "dropphyadd": "4195 GAULEY TPKE",
    "dropphycty": "HEATERS",
    "dropphyst": "WV",
    "dropphyzpp": 266279998,
    "dropmaladd": "4195 GAULEY TPKE",
    "dropmalcty": "HEATERS",
    "dropmalst": "WV",
    "dropmalzpp": 266279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047657743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28625",
    "droptype": "D",
    "dropname": "HEDGESVILLE",
    "dropdeladd": "5471 HEDGESVILLE RD",
    "dropdelcty": "HEDGESVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 254279998,
    "dropphyadd": "5471 HEDGESVILLE RD",
    "dropphycty": "HEDGESVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 254279998,
    "dropmaladd": "5471 HEDGESVILLE RD",
    "dropmalcty": "HEDGESVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 254279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047543013,
    "dropfax": 3047543641
  },
  {
    "dcode": "D",
    "dropkey": "PX28626",
    "droptype": "D",
    "dropname": "HELEN",
    "dropdeladd": "5011 TAMS HWY",
    "dropdelcty": "HELEN",
    "dropdelst": "WV",
    "dropdelzpp": 258539998,
    "dropphyadd": "5011 TAMS HWY",
    "dropphycty": "HELEN",
    "dropphyst": "WV",
    "dropphyzpp": 258539998,
    "dropmaladd": "5011 TAMS HWY",
    "dropmalcty": "HELEN",
    "dropmalst": "WV",
    "dropmalzpp": 258539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047740272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28627",
    "droptype": "D",
    "dropname": "HELVETIA",
    "dropdeladd": "4916 PICKENS RD",
    "dropdelcty": "HELVETIA",
    "dropdelst": "WV",
    "dropdelzpp": 262249998,
    "dropphyadd": "4916 PICKENS RD",
    "dropphycty": "HELVETIA",
    "dropphyst": "WV",
    "dropphyzpp": 262249998,
    "dropmaladd": "4916 PICKENS RD",
    "dropmalcty": "HELVETIA",
    "dropmalst": "WV",
    "dropmalzpp": 262249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049245160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28629",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "9 CHESTNUT ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "WV",
    "dropdelzpp": 251069998,
    "dropphyadd": "9 CHESTNUT ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "WV",
    "dropphyzpp": 251069998,
    "dropmaladd": "9 CHESTNUT ST",
    "dropmalcty": "HENDERSON",
    "dropmalst": "WV",
    "dropmalzpp": 251069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046753563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28630",
    "droptype": "D",
    "dropname": "HENDRICKS",
    "dropdeladd": "43 2ND ST",
    "dropdelcty": "HENDRICKS",
    "dropdelst": "WV",
    "dropdelzpp": 262719998,
    "dropphyadd": "43 2ND ST",
    "dropphycty": "HENDRICKS",
    "dropphyst": "WV",
    "dropphyzpp": 262719998,
    "dropmaladd": "43 2ND ST",
    "dropmalcty": "HENDRICKS",
    "dropmalst": "WV",
    "dropmalzpp": 262719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044783707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28631",
    "droptype": "D",
    "dropname": "HENLAWSON",
    "dropdeladd": "17 VETERANS AVE",
    "dropdelcty": "HENLAWSON",
    "dropdelst": "WV",
    "dropdelzpp": 256249998,
    "dropphyadd": "17 VETERANS AVE",
    "dropphycty": "HENLAWSON",
    "dropphyst": "WV",
    "dropphyzpp": 256249998,
    "dropmaladd": "17 VETERANS AVE",
    "dropmalcty": "HENLAWSON",
    "dropmalst": "WV",
    "dropmalzpp": 256249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047529139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28632",
    "droptype": "D",
    "dropname": "HENSLEY",
    "dropdeladd": "80 EVERGREEN DR",
    "dropdelcty": "HENSLEY",
    "dropdelst": "WV",
    "dropdelzpp": 248439998,
    "dropphyadd": "80 EVERGREEN DR",
    "dropphycty": "HENSLEY",
    "dropphyst": "WV",
    "dropphyzpp": 248439998,
    "dropmaladd": "80 EVERGREEN DR",
    "dropmalcty": "HENSLEY",
    "dropmalst": "WV",
    "dropmalzpp": 248439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046567471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28634",
    "droptype": "D",
    "dropname": "HEPZIBAH",
    "dropdeladd": "3523 SHINNSTON PIKE",
    "dropdelcty": "HEPZIBAH",
    "dropdelst": "WV",
    "dropdelzpp": 263699998,
    "dropphyadd": "3523 SHINNSTON PIKE",
    "dropphycty": "HEPZIBAH",
    "dropphyst": "WV",
    "dropphyzpp": 263699998,
    "dropmaladd": "3523 SHINNSTON PIKE",
    "dropmalcty": "HEPZIBAH",
    "dropmalst": "WV",
    "dropmalzpp": 263699998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046233536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28636",
    "droptype": "D",
    "dropname": "HERNSHAW",
    "dropdeladd": "2996 LENS CREEK RD",
    "dropdelcty": "HERNSHAW",
    "dropdelst": "WV",
    "dropdelzpp": 251079998,
    "dropphyadd": "2996 LENS CREEK RD",
    "dropphycty": "HERNSHAW",
    "dropphyst": "WV",
    "dropphyzpp": 251079998,
    "dropmaladd": "2996 LENS CREEK RD",
    "dropmalcty": "HERNSHAW",
    "dropmalst": "WV",
    "dropmalzpp": 251079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049496631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28639",
    "droptype": "D",
    "dropname": "HEWETT",
    "dropdeladd": "3864 HEWETT CREEK RD",
    "dropdelcty": "HEWETT",
    "dropdelst": "WV",
    "dropdelzpp": 251089998,
    "dropphyadd": "3864 HEWETT CREEK RD",
    "dropphycty": "HEWETT",
    "dropphyst": "WV",
    "dropphyzpp": 251089998,
    "dropmaladd": "3864 HEWETT CREEK RD",
    "dropmalcty": "HEWETT",
    "dropmalst": "WV",
    "dropmalzpp": 251089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043692520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28641",
    "droptype": "D",
    "dropname": "HICO",
    "dropdeladd": "27 WILLIAM BEAN RD",
    "dropdelcty": "HICO",
    "dropdelst": "WV",
    "dropdelzpp": 258549998,
    "dropphyadd": "27 WILLIAM BEAN RD",
    "dropphycty": "HICO",
    "dropphyst": "WV",
    "dropphyzpp": 258549998,
    "dropmaladd": "27 WILLIAM BEAN RD",
    "dropmalcty": "HICO",
    "dropmalst": "WV",
    "dropmalzpp": 258549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046584398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28642",
    "droptype": "D",
    "dropname": "HIGH VIEW",
    "dropdeladd": "2730 CARPERS PIKE",
    "dropdelcty": "HIGH VIEW",
    "dropdelst": "WV",
    "dropdelzpp": 268089998,
    "dropphyadd": "2730 CARPERS PIKE",
    "dropphycty": "HIGH VIEW",
    "dropphyst": "WV",
    "dropphyzpp": 268089998,
    "dropmaladd": "2730 CARPERS PIKE",
    "dropmalcty": "HIGH VIEW",
    "dropmalst": "WV",
    "dropmalzpp": 268089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 6816420730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28645",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "7559 SENECA TRL",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "WV",
    "dropdelzpp": 249469998,
    "dropphyadd": "7559 SENECA TRL",
    "dropphycty": "HILLSBORO",
    "dropphyst": "WV",
    "dropphyzpp": 249469998,
    "dropmaladd": "7559 SENECA TRL",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "WV",
    "dropmalzpp": 249469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046534484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28646",
    "droptype": "D",
    "dropname": "HILLTOP",
    "dropdeladd": "102 HILLTOP LOOP RD",
    "dropdelcty": "HILLTOP",
    "dropdelst": "WV",
    "dropdelzpp": 258559998,
    "dropphyadd": "102 HILLTOP LOOP RD",
    "dropphycty": "HILLTOP",
    "dropphyst": "WV",
    "dropphyzpp": 258559998,
    "dropmaladd": "102 HILLTOP LOOP RD",
    "dropmalcty": "HILLTOP",
    "dropmalst": "WV",
    "dropmalzpp": 258559998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044650212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28648",
    "droptype": "D",
    "dropname": "HINTON",
    "dropdeladd": "128 BALLENGEE ST",
    "dropdelcty": "HINTON",
    "dropdelst": "WV",
    "dropdelzpp": 259519998,
    "dropphyadd": "128 BALLENGEE ST",
    "dropphycty": "HINTON",
    "dropphyst": "WV",
    "dropphyzpp": 259519998,
    "dropmaladd": "128 BALLENGEE ST",
    "dropmalcty": "HINTON",
    "dropmalst": "WV",
    "dropmalzpp": 259519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044663741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28650",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "90 COPPERAS FORK RD",
    "dropdelcty": "HOLDEN",
    "dropdelst": "WV",
    "dropdelzpp": 256259998,
    "dropphyadd": "90 COPPERAS FORK RD",
    "dropphycty": "HOLDEN",
    "dropphyst": "WV",
    "dropphyzpp": 256259998,
    "dropmaladd": "90 COPPERAS FORK RD",
    "dropmalcty": "HOLDEN",
    "dropmalst": "WV",
    "dropmalzpp": 256259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042393212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28653",
    "droptype": "D",
    "dropname": "HOMETOWN",
    "dropdeladd": "41 5TH AVE S",
    "dropdelcty": "HOMETOWN",
    "dropdelst": "WV",
    "dropdelzpp": 251099998,
    "dropphyadd": "41 5TH AVE S",
    "dropphycty": "HOMETOWN",
    "dropphyst": "WV",
    "dropphyzpp": 251099998,
    "dropmaladd": "41 5TH AVE S",
    "dropmalcty": "HOMETOWN",
    "dropmalst": "WV",
    "dropmalzpp": 251099998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045864485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28655",
    "droptype": "D",
    "dropname": "HORNER",
    "dropdeladd": "63 GEORGETOWN RD",
    "dropdelcty": "HORNER",
    "dropdelst": "WV",
    "dropdelzpp": 263729998,
    "dropphyadd": "63 GEORGETOWN RD",
    "dropphycty": "HORNER",
    "dropphyst": "WV",
    "dropphyzpp": 263729998,
    "dropmaladd": "63 GEORGETOWN RD",
    "dropmalcty": "HORNER",
    "dropmalst": "WV",
    "dropmalzpp": 263729998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042697623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28658",
    "droptype": "D",
    "dropname": "HUGHESTON",
    "dropdeladd": "5082 HUGHES CREEK RD",
    "dropdelcty": "HUGHESTON",
    "dropdelst": "WV",
    "dropdelzpp": 251109998,
    "dropphyadd": "5082 HUGHES CREEK RD",
    "dropphycty": "HUGHESTON",
    "dropphyst": "WV",
    "dropphyzpp": 251109998,
    "dropmaladd": "5082 HUGHES CREEK RD",
    "dropmalcty": "HUGHESTON",
    "dropmalst": "WV",
    "dropmalzpp": 251109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044422817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28659",
    "droptype": "D",
    "dropname": "HUNDRED",
    "dropdeladd": "3992 HORNET HWY",
    "dropdelcty": "HUNDRED",
    "dropdelst": "WV",
    "dropdelzpp": 265759998,
    "dropphyadd": "3992 HORNET HWY",
    "dropphycty": "HUNDRED",
    "dropphyst": "WV",
    "dropphyzpp": 265759998,
    "dropmaladd": "3992 HORNET HWY",
    "dropmalcty": "HUNDRED",
    "dropmalst": "WV",
    "dropmalzpp": 265759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047755833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28663",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "1000 VIRGINIA AVE W",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257049998,
    "dropphyadd": "1000 VIRGINIA AVE W",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257049998,
    "dropmaladd": "1000 VIRGINIA AVE W",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045269600,
    "dropfax": 3045269612
  },
  {
    "dcode": "D",
    "dropkey": "PX28664",
    "droptype": "D",
    "dropname": "HURRICANE",
    "dropdeladd": "3225 TEAYS VALLEY RD",
    "dropdelcty": "HURRICANE",
    "dropdelst": "WV",
    "dropdelzpp": 255269998,
    "dropphyadd": "3225 TEAYS VALLEY RD",
    "dropphycty": "HURRICANE",
    "dropphyst": "WV",
    "dropphyzpp": 255269998,
    "dropmaladd": "3225 TEAYS VALLEY RD",
    "dropmalcty": "HURRICANE",
    "dropmalst": "WV",
    "dropmalzpp": 255269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045626811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28665",
    "droptype": "D",
    "dropname": "HUTTONSVILLE",
    "dropdeladd": "11207 SENECA TRL",
    "dropdelcty": "HUTTONSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 262739998,
    "dropphyadd": "11207 SENECA TRL",
    "dropphycty": "HUTTONSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 262739998,
    "dropmaladd": "11207 SENECA TRL",
    "dropmalcty": "HUTTONSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 262739998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043356035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28666",
    "droptype": "D",
    "dropname": "IAEGER",
    "dropdeladd": "5265 COAL HERITAGE RD",
    "dropdelcty": "IAEGER",
    "dropdelst": "WV",
    "dropdelzpp": 248449998,
    "dropphyadd": "5265 COAL HERITAGE RD",
    "dropphycty": "IAEGER",
    "dropphyst": "WV",
    "dropphyzpp": 248449998,
    "dropmaladd": "5265 COAL HERITAGE RD",
    "dropmalcty": "IAEGER",
    "dropmalst": "WV",
    "dropmalzpp": 248449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049382231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28667",
    "droptype": "D",
    "dropname": "IDAMAY",
    "dropdeladd": "1194 MAIN ST",
    "dropdelcty": "IDAMAY",
    "dropdelst": "WV",
    "dropdelzpp": 265769998,
    "dropphyadd": "1194 MAIN ST",
    "dropphycty": "IDAMAY",
    "dropphyst": "WV",
    "dropphyzpp": 265769998,
    "dropmaladd": "1194 MAIN ST",
    "dropmalcty": "IDAMAY",
    "dropmalst": "WV",
    "dropmalzpp": 265769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042872756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28668",
    "droptype": "D",
    "dropname": "IKES FORK",
    "dropdeladd": "8384 INTERSTATE HWY",
    "dropdelcty": "IKES FORK",
    "dropdelst": "WV",
    "dropdelzpp": 248459998,
    "dropphyadd": "8384 INTERSTATE HWY",
    "dropphycty": "IKES FORK",
    "dropphyst": "WV",
    "dropphyzpp": 248459998,
    "dropmaladd": "8384 INTERSTATE HWY",
    "dropmalcty": "IKES FORK",
    "dropmalst": "WV",
    "dropmalzpp": 248459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049383618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28674",
    "droptype": "D",
    "dropname": "INDORE",
    "dropdeladd": "11447 CLAY HWY",
    "dropdelcty": "INDORE",
    "dropdelst": "WV",
    "dropdelzpp": 251119998,
    "dropphyadd": "11447 CLAY HWY",
    "dropphycty": "INDORE",
    "dropphyst": "WV",
    "dropphyzpp": 251119998,
    "dropmaladd": "11447 CLAY HWY",
    "dropmalcty": "INDORE",
    "dropmalst": "WV",
    "dropmalzpp": 251119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045874795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28678",
    "droptype": "D",
    "dropname": "INSTITUTE",
    "dropdeladd": "6200 FAIRLAWN AVE",
    "dropdelcty": "INSTITUTE",
    "dropdelst": "WV",
    "dropdelzpp": 251129998,
    "dropphyadd": "6200 FAIRLAWN AVE",
    "dropphycty": "INSTITUTE",
    "dropphyst": "WV",
    "dropphyzpp": 251129998,
    "dropmaladd": "6200 FAIRLAWN AVE",
    "dropmalcty": "INSTITUTE",
    "dropmalst": "WV",
    "dropmalzpp": 251129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047688911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28679",
    "droptype": "D",
    "dropname": "INWOOD",
    "dropdeladd": "7796 WINCHESTER AVE",
    "dropdelcty": "INWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 254289998,
    "dropphyadd": "7796 WINCHESTER AVE",
    "dropphycty": "INWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 254289998,
    "dropmaladd": "7796 WINCHESTER AVE",
    "dropmalcty": "INWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 254289998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042298450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28680",
    "droptype": "D",
    "dropname": "IRELAND",
    "dropdeladd": "234 WILDCAT RD",
    "dropdelcty": "IRELAND",
    "dropdelst": "WV",
    "dropdelzpp": 263769998,
    "dropphyadd": "234 WILDCAT RD",
    "dropphycty": "IRELAND",
    "dropphyst": "WV",
    "dropphyzpp": 263769998,
    "dropmaladd": "234 WILDCAT RD",
    "dropmalcty": "IRELAND",
    "dropmalst": "WV",
    "dropmalzpp": 263769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044528893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28682",
    "droptype": "D",
    "dropname": "ITMANN",
    "dropdeladd": "11312 RIVER RD",
    "dropdelcty": "ITMANN",
    "dropdelst": "WV",
    "dropdelzpp": 248479998,
    "dropphyadd": "11312 RIVER RD",
    "dropphycty": "ITMANN",
    "dropphyst": "WV",
    "dropphyzpp": 248479998,
    "dropmaladd": "11312 RIVER RD",
    "dropmalcty": "ITMANN",
    "dropmalst": "WV",
    "dropmalzpp": 248479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042945113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28683",
    "droptype": "D",
    "dropname": "IVYDALE",
    "dropdeladd": "10514 IVYDALE RD",
    "dropdelcty": "IVYDALE",
    "dropdelst": "WV",
    "dropdelzpp": 251139998,
    "dropphyadd": "10514 IVYDALE RD",
    "dropphycty": "IVYDALE",
    "dropphyst": "WV",
    "dropphyzpp": 251139998,
    "dropmaladd": "10514 IVYDALE RD",
    "dropmalcty": "IVYDALE",
    "dropmalst": "WV",
    "dropmalzpp": 251139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042865285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28684",
    "droptype": "D",
    "dropname": "JACKSONBURG",
    "dropdeladd": "18160 SHORTLINE HWY",
    "dropdelcty": "JACKSONBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263779998,
    "dropphyadd": "18160 SHORTLINE HWY",
    "dropphycty": "JACKSONBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263779998,
    "dropmaladd": "18160 SHORTLINE HWY",
    "dropmalcty": "JACKSONBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263779998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048893292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28686",
    "droptype": "D",
    "dropname": "JANE LEW",
    "dropdeladd": "141 INDUSTRIAL PARK RD",
    "dropdelcty": "JANE LEW",
    "dropdelst": "WV",
    "dropdelzpp": 263789998,
    "dropphyadd": "141 INDUSTRIAL PARK RD",
    "dropphycty": "JANE LEW",
    "dropphyst": "WV",
    "dropphyzpp": 263789998,
    "dropmaladd": "141 INDUSTRIAL PARK RD",
    "dropmalcty": "JANE LEW",
    "dropmalst": "WV",
    "dropmalzpp": 263789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048847985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28689",
    "droptype": "D",
    "dropname": "JEFFREY",
    "dropdeladd": "162 HEWETT CREEK RD",
    "dropdelcty": "JEFFREY",
    "dropdelst": "WV",
    "dropdelzpp": 251149998,
    "dropphyadd": "162 HEWETT CREEK RD",
    "dropphycty": "JEFFREY",
    "dropphyst": "WV",
    "dropphyzpp": 251149998,
    "dropmaladd": "162 HEWETT CREEK RD",
    "dropmalcty": "JEFFREY",
    "dropmalst": "WV",
    "dropmalzpp": 251149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043693615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28690",
    "droptype": "D",
    "dropname": "JENKINJONES",
    "dropdeladd": "23 EIGHT HOLLOW RD",
    "dropdelcty": "JENKINJONES",
    "dropdelst": "WV",
    "dropdelzpp": 248489998,
    "dropphyadd": "23 EIGHT HOLLOW RD",
    "dropphycty": "JENKINJONES",
    "dropphyst": "WV",
    "dropphyzpp": 248489998,
    "dropmaladd": "23 EIGHT HOLLOW RD",
    "dropmalcty": "JENKINJONES",
    "dropmalst": "WV",
    "dropmalzpp": 248489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043832401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28691",
    "droptype": "D",
    "dropname": "JESSE",
    "dropdeladd": "71 POPLAR GAP RD",
    "dropdelcty": "JESSE",
    "dropdelst": "WV",
    "dropdelzpp": 248499998,
    "dropphyadd": "71 POPLAR GAP RD",
    "dropphycty": "JESSE",
    "dropphyst": "WV",
    "dropphyzpp": 248499998,
    "dropmaladd": "71 POPLAR GAP RD",
    "dropmalcty": "JESSE",
    "dropmalst": "WV",
    "dropmalzpp": 248499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046824729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28696",
    "droptype": "D",
    "dropname": "JOLO",
    "dropdeladd": "12499 MARSHALL HWY",
    "dropdelcty": "JOLO",
    "dropdelst": "WV",
    "dropdelzpp": 248509998,
    "dropphyadd": "12499 MARSHALL HWY",
    "dropphycty": "JOLO",
    "dropphyst": "WV",
    "dropphyzpp": 248509998,
    "dropmaladd": "12499 MARSHALL HWY",
    "dropmalcty": "JOLO",
    "dropmalst": "WV",
    "dropmalzpp": 248509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049677979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28700",
    "droptype": "D",
    "dropname": "JOSEPHINE",
    "dropdeladd": "4282 ODD RD",
    "dropdelcty": "JOSEPHINE",
    "dropdelst": "WV",
    "dropdelzpp": 258579998,
    "dropphyadd": "4282 ODD RD",
    "dropphycty": "JOSEPHINE",
    "dropphyst": "WV",
    "dropphyzpp": 258579998,
    "dropmaladd": "4282 ODD RD",
    "dropmalcty": "JOSEPHINE",
    "dropmalst": "WV",
    "dropmalzpp": 258579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046835559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28701",
    "droptype": "D",
    "dropname": "JULIAN",
    "dropdeladd": "309 HILL VALLEY DR STE A",
    "dropdelcty": "JULIAN",
    "dropdelst": "WV",
    "dropdelzpp": 255299998,
    "dropphyadd": "309 HILL VALLEY DR STE A",
    "dropphycty": "JULIAN",
    "dropphyst": "WV",
    "dropphyzpp": 255299998,
    "dropmaladd": "309 HILL VALLEY DR STE A",
    "dropmalcty": "JULIAN",
    "dropmalst": "WV",
    "dropmalzpp": 255299998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043693371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28702",
    "droptype": "D",
    "dropname": "JUMPING BRANCH",
    "dropdeladd": "5766 BEECH RUN RD",
    "dropdelcty": "JUMPING BRANCH",
    "dropdelst": "WV",
    "dropdelzpp": 259699998,
    "dropphyadd": "5766 BEECH RUN RD",
    "dropphycty": "JUMPING BRANCH",
    "dropphyst": "WV",
    "dropphyzpp": 259699998,
    "dropmaladd": "5766 BEECH RUN RD",
    "dropmalcty": "JUMPING BRANCH",
    "dropmalst": "WV",
    "dropmalzpp": 259699998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044665329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28704",
    "droptype": "D",
    "dropname": "JUNIOR",
    "dropdeladd": "1 ROW AVE N",
    "dropdelcty": "JUNIOR",
    "dropdelst": "WV",
    "dropdelzpp": 262759998,
    "dropphyadd": "1 ROW AVE N",
    "dropphycty": "JUNIOR",
    "dropphyst": "WV",
    "dropphyzpp": 262759998,
    "dropmaladd": "1 ROW AVE N",
    "dropmalcty": "JUNIOR",
    "dropmalst": "WV",
    "dropmalzpp": 262759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048231640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28705",
    "droptype": "D",
    "dropname": "JUSTICE",
    "dropdeladd": "2937 RT 52",
    "dropdelcty": "JUSTICE",
    "dropdelst": "WV",
    "dropdelzpp": 248519998,
    "dropphyadd": "2937 RT 52",
    "dropphycty": "JUSTICE",
    "dropphyst": "WV",
    "dropphyzpp": 248519998,
    "dropmaladd": "2937 RT 52",
    "dropmalcty": "JUSTICE",
    "dropmalst": "WV",
    "dropmalzpp": 248519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046648340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28712",
    "droptype": "D",
    "dropname": "KEARNEYSVILLE",
    "dropdeladd": "5512 CHARLES TOWN RD",
    "dropdelcty": "KEARNEYSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 254309998,
    "dropphyadd": "5512 CHARLES TOWN RD",
    "dropphycty": "KEARNEYSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 254309998,
    "dropmaladd": "5512 CHARLES TOWN RD",
    "dropmalcty": "KEARNEYSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 254309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048766348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28713",
    "droptype": "D",
    "dropname": "KEGLEY",
    "dropdeladd": "3376 BECKLEY RD",
    "dropdelcty": "KEGLEY",
    "dropdelst": "WV",
    "dropdelzpp": 247319998,
    "dropphyadd": "3376 BECKLEY RD",
    "dropphycty": "KEGLEY",
    "dropphyst": "WV",
    "dropphyzpp": 247319998,
    "dropmaladd": "3376 BECKLEY RD",
    "dropmalcty": "KEGLEY",
    "dropmalst": "WV",
    "dropmalzpp": 247319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044256832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28714",
    "droptype": "D",
    "dropname": "KELLYSVILLE",
    "dropdeladd": "4602 KELLYSVILLE RD",
    "dropdelcty": "KELLYSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 247329998,
    "dropphyadd": "4602 KELLYSVILLE RD",
    "dropphycty": "KELLYSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 247329998,
    "dropmaladd": "4602 KELLYSVILLE RD",
    "dropmalcty": "KELLYSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 247329998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048984202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28715",
    "droptype": "D",
    "dropname": "KENNA",
    "dropdeladd": "100 KENTUCK RD",
    "dropdelcty": "KENNA",
    "dropdelst": "WV",
    "dropdelzpp": 252489998,
    "dropphyadd": "100 KENTUCK RD",
    "dropphycty": "KENNA",
    "dropphyst": "WV",
    "dropphyzpp": 252489998,
    "dropmaladd": "100 KENTUCK RD",
    "dropmalcty": "KENNA",
    "dropmalst": "WV",
    "dropmalzpp": 252489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043728128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28716",
    "droptype": "D",
    "dropname": "KENOVA",
    "dropdeladd": "1300 CHESTNUT ST",
    "dropdelcty": "KENOVA",
    "dropdelst": "WV",
    "dropdelzpp": 255309998,
    "dropphyadd": "1300 CHESTNUT ST",
    "dropphycty": "KENOVA",
    "dropphyst": "WV",
    "dropphyzpp": 255309998,
    "dropmaladd": "1300 CHESTNUT ST",
    "dropmalcty": "KENOVA",
    "dropmalst": "WV",
    "dropmalzpp": 255309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044532751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28718",
    "droptype": "D",
    "dropname": "KERENS",
    "dropdeladd": "5173 PARSONS RD",
    "dropdelcty": "KERENS",
    "dropdelst": "WV",
    "dropdelzpp": 262769998,
    "dropphyadd": "5173 PARSONS RD",
    "dropphycty": "KERENS",
    "dropphyst": "WV",
    "dropphyzpp": 262769998,
    "dropmaladd": "5173 PARSONS RD",
    "dropmalcty": "KERENS",
    "dropmalst": "WV",
    "dropmalzpp": 262769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046367119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28719",
    "droptype": "D",
    "dropname": "KERMIT",
    "dropdeladd": "101 OHIO AVE",
    "dropdelcty": "KERMIT",
    "dropdelst": "WV",
    "dropdelzpp": 256749998,
    "dropphyadd": "101 OHIO AVE",
    "dropphycty": "KERMIT",
    "dropphyst": "WV",
    "dropphyzpp": 256749998,
    "dropmaladd": "101 OHIO AVE",
    "dropmalcty": "KERMIT",
    "dropmalst": "WV",
    "dropmalzpp": 256749998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043933659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28720",
    "droptype": "D",
    "dropname": "KESLERS CROSS LANES",
    "dropdeladd": "5596 SUMMERSVILLE LAKE RD",
    "dropdelcty": "KESLERS CROSS LANES",
    "dropdelst": "WV",
    "dropdelzpp": 266759998,
    "dropphyadd": "5596 SUMMERSVILLE LAKE RD",
    "dropphycty": "KESLERS CROSS LANES",
    "dropphyst": "WV",
    "dropphyzpp": 266759998,
    "dropmaladd": "5596 SUMMERSVILLE LAKE RD",
    "dropmalcty": "KESLERS CROSS LANES",
    "dropmalst": "WV",
    "dropmalzpp": 266759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048720183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28723",
    "droptype": "D",
    "dropname": "KEYSER",
    "dropdeladd": "2 N DAVIS ST",
    "dropdelcty": "KEYSER",
    "dropdelst": "WV",
    "dropdelzpp": 267269998,
    "dropphyadd": "2 N DAVIS ST",
    "dropphycty": "KEYSER",
    "dropphyst": "WV",
    "dropphyzpp": 267269998,
    "dropmaladd": "2 N DAVIS ST",
    "dropmalcty": "KEYSER",
    "dropmalst": "WV",
    "dropmalzpp": 267269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047881501,
    "dropfax": 3047883910
  },
  {
    "dcode": "D",
    "dropkey": "PX28728",
    "droptype": "D",
    "dropname": "KIMBALL",
    "dropdeladd": "28499 COAL HERITAGE RD",
    "dropdelcty": "KIMBALL",
    "dropdelst": "WV",
    "dropdelzpp": 248539998,
    "dropphyadd": "28499 COAL HERITAGE RD",
    "dropphycty": "KIMBALL",
    "dropphyst": "WV",
    "dropphyzpp": 248539998,
    "dropmaladd": "28499 COAL HERITAGE RD",
    "dropmalcty": "KIMBALL",
    "dropmalst": "WV",
    "dropmalzpp": 248539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045857543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28729",
    "droptype": "D",
    "dropname": "KIMBERLY",
    "dropdeladd": "15 KIMBERLY POST OFFICE RD",
    "dropdelcty": "KIMBERLY",
    "dropdelst": "WV",
    "dropdelzpp": 251189998,
    "dropphyadd": "15 KIMBERLY POST OFFICE RD",
    "dropphycty": "KIMBERLY",
    "dropphyst": "WV",
    "dropphyzpp": 251189998,
    "dropmaladd": "15 KIMBERLY POST OFFICE RD",
    "dropmalcty": "KIMBERLY",
    "dropmalst": "WV",
    "dropmalzpp": 251189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28730",
    "droptype": "D",
    "dropname": "KINCAID",
    "dropdeladd": "7598 DEEP WATER MOUNTAIN RD",
    "dropdelcty": "KINCAID",
    "dropdelst": "WV",
    "dropdelzpp": 251199998,
    "dropphyadd": "7598 DEEP WATER MOUNTAIN RD",
    "dropphycty": "KINCAID",
    "dropphyst": "WV",
    "dropphyzpp": 251199998,
    "dropmaladd": "7598 DEEP WATER MOUNTAIN RD",
    "dropmalcty": "KINCAID",
    "dropmalst": "WV",
    "dropmalzpp": 251199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044658367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28731",
    "droptype": "D",
    "dropname": "KINGMONT",
    "dropdeladd": "2379 KINGMONT RD",
    "dropdelcty": "KINGMONT",
    "dropdelst": "WV",
    "dropdelzpp": 265789998,
    "dropphyadd": "2379 KINGMONT RD",
    "dropphycty": "KINGMONT",
    "dropphyst": "WV",
    "dropphyzpp": 265789998,
    "dropmaladd": "2379 KINGMONT RD",
    "dropmalcty": "KINGMONT",
    "dropmalst": "WV",
    "dropmalzpp": 265789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043669533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28733",
    "droptype": "D",
    "dropname": "KINGWOOD",
    "dropdeladd": "225 E MAIN ST",
    "dropdelcty": "KINGWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 265379998,
    "dropphyadd": "225 E MAIN ST",
    "dropphycty": "KINGWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 265379998,
    "dropmaladd": "225 E MAIN ST",
    "dropmalcty": "KINGWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 265379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043290567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28735",
    "droptype": "D",
    "dropname": "KISTLER",
    "dropdeladd": "495 BUFFALO CREEK RD",
    "dropdelcty": "KISTLER",
    "dropdelst": "WV",
    "dropdelzpp": 256289998,
    "dropphyadd": "495 BUFFALO CREEK RD",
    "dropphycty": "KISTLER",
    "dropphyst": "WV",
    "dropphyzpp": 256289998,
    "dropmaladd": "495 BUFFALO CREEK RD",
    "dropmalcty": "KISTLER",
    "dropmalst": "WV",
    "dropmalzpp": 256289998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045837245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28741",
    "droptype": "D",
    "dropname": "LAKE",
    "dropdeladd": "2413 MAIN HEWETT CREEK RD",
    "dropdelcty": "LAKE",
    "dropdelst": "WV",
    "dropdelzpp": 251219998,
    "dropphyadd": "2413 MAIN HEWETT CREEK RD",
    "dropphycty": "LAKE",
    "dropphyst": "WV",
    "dropphyzpp": 251219998,
    "dropmaladd": "2413 MAIN HEWETT CREEK RD",
    "dropmalcty": "LAKE",
    "dropmalst": "WV",
    "dropmalzpp": 251219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047520864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28749",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "59 FAYETTE MINE RD",
    "dropdelcty": "LANSING",
    "dropdelst": "WV",
    "dropdelzpp": 258629998,
    "dropphyadd": "59 FAYETTE MINE RD",
    "dropphycty": "LANSING",
    "dropphyst": "WV",
    "dropphyzpp": 258629998,
    "dropmaladd": "59 FAYETTE MINE RD",
    "dropmalcty": "LANSING",
    "dropmalst": "WV",
    "dropmalzpp": 258629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045742730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28750",
    "droptype": "D",
    "dropname": "LASHMEET",
    "dropdeladd": "4226 MATOAKA RD",
    "dropdelcty": "LASHMEET",
    "dropdelst": "WV",
    "dropdelzpp": 247339998,
    "dropphyadd": "4226 MATOAKA RD",
    "dropphycty": "LASHMEET",
    "dropphyst": "WV",
    "dropphyzpp": 247339998,
    "dropmaladd": "4226 MATOAKA RD",
    "dropmalcty": "LASHMEET",
    "dropmalst": "WV",
    "dropmalzpp": 247339998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044677700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28752",
    "droptype": "D",
    "dropname": "LAVALETTE",
    "dropdeladd": "4642 LYNN CREEK RD",
    "dropdelcty": "LAVALETTE",
    "dropdelst": "WV",
    "dropdelzpp": 255359998,
    "dropphyadd": "4642 LYNN CREEK RD",
    "dropphycty": "LAVALETTE",
    "dropphyst": "WV",
    "dropphyzpp": 255359998,
    "dropmaladd": "4642 LYNN CREEK RD",
    "dropmalcty": "LAVALETTE",
    "dropmalst": "WV",
    "dropmalzpp": 255359998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045294223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28754",
    "droptype": "D",
    "dropname": "LAYLAND",
    "dropdeladd": "13891 STANAFORD RD",
    "dropdelcty": "LAYLAND",
    "dropdelst": "WV",
    "dropdelzpp": 258645000,
    "dropphyadd": "13891 STANAFORD RD",
    "dropphycty": "LAYLAND",
    "dropphyst": "WV",
    "dropphyzpp": 258645000,
    "dropmaladd": "13891 STANAFORD RD",
    "dropmalcty": "LAYLAND",
    "dropmalst": "WV",
    "dropmalzpp": 258645000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044387397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28755",
    "droptype": "D",
    "dropname": "LE ROY",
    "dropdeladd": "4327 LIVERPOOL RD",
    "dropdelcty": "LE ROY",
    "dropdelst": "WV",
    "dropdelzpp": 252529998,
    "dropphyadd": "4327 LIVERPOOL RD",
    "dropphycty": "LE ROY",
    "dropphyst": "WV",
    "dropphyzpp": 252529998,
    "dropmaladd": "4327 LIVERPOOL RD",
    "dropmalcty": "LE ROY",
    "dropmalst": "WV",
    "dropmalzpp": 252529998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042735461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28761",
    "droptype": "D",
    "dropname": "LEFT HAND",
    "dropdeladd": "9346 CLAY RD",
    "dropdelcty": "LEFT HAND",
    "dropdelst": "WV",
    "dropdelzpp": 252519998,
    "dropphyadd": "9346 CLAY RD",
    "dropphycty": "LEFT HAND",
    "dropphyst": "WV",
    "dropphyzpp": 252519998,
    "dropmaladd": "9346 CLAY RD",
    "dropmalcty": "LEFT HAND",
    "dropmalst": "WV",
    "dropmalzpp": 252519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045654281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28763",
    "droptype": "D",
    "dropname": "LEIVASY",
    "dropdeladd": "5325 LEIVASY RD",
    "dropdelcty": "LEIVASY",
    "dropdelst": "WV",
    "dropdelzpp": 266769998,
    "dropphyadd": "5325 LEIVASY RD",
    "dropphycty": "LEIVASY",
    "dropphyst": "WV",
    "dropphyzpp": 266769998,
    "dropmaladd": "5325 LEIVASY RD",
    "dropmalcty": "LEIVASY",
    "dropmalst": "WV",
    "dropmalzpp": 266769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048464289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28764",
    "droptype": "D",
    "dropname": "LENORE",
    "dropdeladd": "302 ROUTE 65",
    "dropdelcty": "LENORE",
    "dropdelst": "WV",
    "dropdelzpp": 256769998,
    "dropphyadd": "302 ROUTE 65",
    "dropphycty": "LENORE",
    "dropphyst": "WV",
    "dropphyzpp": 256769998,
    "dropmaladd": "302 ROUTE 65",
    "dropmalcty": "LENORE",
    "dropmalst": "WV",
    "dropmalzpp": 256769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044754530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28765",
    "droptype": "D",
    "dropname": "LEON",
    "dropdeladd": "20597 CHARLESTON RD",
    "dropdelcty": "LEON",
    "dropdelst": "WV",
    "dropdelzpp": 251239998,
    "dropphyadd": "20597 CHARLESTON RD",
    "dropphycty": "LEON",
    "dropphyst": "WV",
    "dropphyzpp": 251239998,
    "dropmaladd": "20597 CHARLESTON RD",
    "dropmalcty": "LEON",
    "dropmalst": "WV",
    "dropmalzpp": 251239998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044581081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28766",
    "droptype": "D",
    "dropname": "LERONA",
    "dropdeladd": "6832 HINTON RD",
    "dropdelcty": "LERONA",
    "dropdelst": "WV",
    "dropdelzpp": 259719998,
    "dropphyadd": "6832 HINTON RD",
    "dropphycty": "LERONA",
    "dropphyst": "WV",
    "dropphyzpp": 259719998,
    "dropmaladd": "6832 HINTON RD",
    "dropmalcty": "LERONA",
    "dropmalst": "WV",
    "dropmalzpp": 259719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043847950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28767",
    "droptype": "D",
    "dropname": "LESAGE",
    "dropdeladd": "6315 OHIO RIVER RD",
    "dropdelcty": "LESAGE",
    "dropdelst": "WV",
    "dropdelzpp": 255379998,
    "dropphyadd": "6315 OHIO RIVER RD",
    "dropphycty": "LESAGE",
    "dropphyst": "WV",
    "dropphyzpp": 255379998,
    "dropmaladd": "6315 OHIO RIVER RD",
    "dropmalcty": "LESAGE",
    "dropmalst": "WV",
    "dropmalzpp": 255379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047362546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28768",
    "droptype": "D",
    "dropname": "LESLIE",
    "dropdeladd": "3543 ORIENT HILL RD",
    "dropdelcty": "LESLIE",
    "dropdelst": "WV",
    "dropdelzpp": 259729998,
    "dropphyadd": "3543 ORIENT HILL RD",
    "dropphycty": "LESLIE",
    "dropphyst": "WV",
    "dropphyzpp": 259729998,
    "dropmaladd": "3543 ORIENT HILL RD",
    "dropmalcty": "LESLIE",
    "dropmalst": "WV",
    "dropmalzpp": 259729998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044386200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28769",
    "droptype": "D",
    "dropname": "LESTER",
    "dropdeladd": "1711 LESTER HWY",
    "dropdelcty": "LESTER",
    "dropdelst": "WV",
    "dropdelzpp": 258659998,
    "dropphyadd": "1711 LESTER HWY",
    "dropphycty": "LESTER",
    "dropphyst": "WV",
    "dropphyzpp": 258659998,
    "dropmaladd": "1711 LESTER HWY",
    "dropmalcty": "LESTER",
    "dropmalst": "WV",
    "dropmalzpp": 258659998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049346302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28770",
    "droptype": "D",
    "dropname": "LETART",
    "dropdeladd": "23758 SANDHILL RD",
    "dropdelcty": "LETART",
    "dropdelst": "WV",
    "dropdelzpp": 252539998,
    "dropphyadd": "23758 SANDHILL RD",
    "dropphycty": "LETART",
    "dropphyst": "WV",
    "dropphyzpp": 252539998,
    "dropmaladd": "23758 SANDHILL RD",
    "dropmalcty": "LETART",
    "dropmalst": "WV",
    "dropmalzpp": 252539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048953600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28775",
    "droptype": "D",
    "dropname": "LEWISBURG",
    "dropdeladd": "1129 WASHINGTON ST E",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "WV",
    "dropdelzpp": 249019998,
    "dropphyadd": "1129 WASHINGTON ST E",
    "dropphycty": "LEWISBURG",
    "dropphyst": "WV",
    "dropphyzpp": 249019998,
    "dropmaladd": "1129 WASHINGTON ST E",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "WV",
    "dropmalzpp": 249019998,
    "dropsitphn": 6813185001,
    "dropsitlph": 6813185001,
    "dropsitcph": 6813185000,
    "dropfax": 3046457782
  },
  {
    "dcode": "D",
    "dropkey": "PX28776",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "19 DERRICKS CREEK RD",
    "dropdelcty": "LIBERTY",
    "dropdelst": "WV",
    "dropdelzpp": 251249998,
    "dropphyadd": "19 DERRICKS CREEK RD",
    "dropphycty": "LIBERTY",
    "dropphyst": "WV",
    "dropphyzpp": 251249998,
    "dropmaladd": "19 DERRICKS CREEK RD",
    "dropmalcty": "LIBERTY",
    "dropmalst": "WV",
    "dropmalzpp": 251249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045864486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28781",
    "droptype": "D",
    "dropname": "LINDSIDE",
    "dropdeladd": "8529 SENECA TRL S",
    "dropdelcty": "LINDSIDE",
    "dropdelst": "WV",
    "dropdelzpp": 249519998,
    "dropphyadd": "8529 SENECA TRL S",
    "dropphycty": "LINDSIDE",
    "dropphyst": "WV",
    "dropphyzpp": 249519998,
    "dropmaladd": "8529 SENECA TRL S",
    "dropmalcty": "LINDSIDE",
    "dropmalst": "WV",
    "dropmalzpp": 249519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047534011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28783",
    "droptype": "D",
    "dropname": "LITTLE BIRCH",
    "dropdeladd": "6983 OLD TURNPIKE RD",
    "dropdelcty": "LITTLE BIRCH",
    "dropdelst": "WV",
    "dropdelzpp": 266299998,
    "dropphyadd": "6983 OLD TURNPIKE RD",
    "dropphycty": "LITTLE BIRCH",
    "dropphyst": "WV",
    "dropphyzpp": 266299998,
    "dropmaladd": "6983 OLD TURNPIKE RD",
    "dropmalcty": "LITTLE BIRCH",
    "dropmalst": "WV",
    "dropmalzpp": 266299998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047655339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28786",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "9585 HORNET HWY",
    "dropdelcty": "LITTLETON",
    "dropdelst": "WV",
    "dropdelzpp": 265819998,
    "dropphyadd": "9585 HORNET HWY",
    "dropphycty": "LITTLETON",
    "dropphyst": "WV",
    "dropphyzpp": 265819998,
    "dropmaladd": "9585 HORNET HWY",
    "dropmalcty": "LITTLETON",
    "dropmalst": "WV",
    "dropmalzpp": 265819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047752020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28788",
    "droptype": "D",
    "dropname": "LIZEMORES",
    "dropdeladd": "13938 CLAY HWY",
    "dropdelcty": "LIZEMORES",
    "dropdelst": "WV",
    "dropdelzpp": 251259998,
    "dropphyadd": "13938 CLAY HWY",
    "dropphycty": "LIZEMORES",
    "dropphyst": "WV",
    "dropphyzpp": 251259998,
    "dropmaladd": "13938 CLAY HWY",
    "dropmalcty": "LIZEMORES",
    "dropmalst": "WV",
    "dropmalzpp": 251259998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045874217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28790",
    "droptype": "D",
    "dropname": "LOCHGELLY",
    "dropdeladd": "3746 SUMMERLEE RD",
    "dropdelcty": "LOCHGELLY",
    "dropdelst": "WV",
    "dropdelzpp": 258669998,
    "dropphyadd": "3746 SUMMERLEE RD",
    "dropphycty": "LOCHGELLY",
    "dropphyst": "WV",
    "dropphyzpp": 258669998,
    "dropmaladd": "3746 SUMMERLEE RD",
    "dropmalcty": "LOCHGELLY",
    "dropmalst": "WV",
    "dropmalzpp": 258669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044696762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28794",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "400 HUDGINS ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "WV",
    "dropdelzpp": 256019998,
    "dropphyadd": "400 HUDGINS ST",
    "dropphycty": "LOGAN",
    "dropphyst": "WV",
    "dropphyzpp": 256019998,
    "dropmaladd": "400 HUDGINS ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "WV",
    "dropmalzpp": 256019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047523235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28795",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "10049 E DUPONT AVE",
    "dropdelcty": "LONDON",
    "dropdelst": "WV",
    "dropdelzpp": 251269998,
    "dropphyadd": "10049 E DUPONT AVE",
    "dropphycty": "LONDON",
    "dropphyst": "WV",
    "dropphyzpp": 251269998,
    "dropmaladd": "10049 E DUPONT AVE",
    "dropmalcty": "LONDON",
    "dropmalst": "WV",
    "dropmalzpp": 251269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28798",
    "droptype": "D",
    "dropname": "LOOKOUT",
    "dropdeladd": "31085 MIDLAND TRL",
    "dropdelcty": "LOOKOUT",
    "dropdelst": "WV",
    "dropdelzpp": 258689998,
    "dropphyadd": "31085 MIDLAND TRL",
    "dropphycty": "LOOKOUT",
    "dropphyst": "WV",
    "dropphyzpp": 258689998,
    "dropmaladd": "31085 MIDLAND TRL",
    "dropmalcty": "LOOKOUT",
    "dropmalst": "WV",
    "dropmalzpp": 258689998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045683016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28799",
    "droptype": "D",
    "dropname": "LOONEYVILLE",
    "dropdeladd": "6233 CLAY RD",
    "dropdelcty": "LOONEYVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 252599998,
    "dropphyadd": "6233 CLAY RD",
    "dropphycty": "LOONEYVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 252599998,
    "dropmaladd": "6233 CLAY RD",
    "dropmalcty": "LOONEYVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 252599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049275293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28800",
    "droptype": "D",
    "dropname": "LORADO",
    "dropdeladd": "9964 BUFFALO CREEK RD",
    "dropdelcty": "LORADO",
    "dropdelst": "WV",
    "dropdelzpp": 256309998,
    "dropphyadd": "9964 BUFFALO CREEK RD",
    "dropphycty": "LORADO",
    "dropphyst": "WV",
    "dropphyzpp": 256309998,
    "dropmaladd": "9964 BUFFALO CREEK RD",
    "dropmalcty": "LORADO",
    "dropmalst": "WV",
    "dropmalzpp": 256309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045836424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28801",
    "droptype": "D",
    "dropname": "LORENTZ",
    "dropdeladd": "3621 OLD WESTON RD",
    "dropdelcty": "LORENTZ",
    "dropdelst": "WV",
    "dropdelzpp": 262299998,
    "dropphyadd": "3621 OLD WESTON RD",
    "dropphycty": "LORENTZ",
    "dropphyst": "WV",
    "dropphyzpp": 262299998,
    "dropmaladd": "3621 OLD WESTON RD",
    "dropmalcty": "LORENTZ",
    "dropmalst": "WV",
    "dropmalzpp": 262299998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044727909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28804",
    "droptype": "D",
    "dropname": "LOST CITY",
    "dropdeladd": "9330 STATE ROAD 259",
    "dropdelcty": "LOST CITY",
    "dropdelst": "WV",
    "dropdelzpp": 268109998,
    "dropphyadd": "9330 STATE ROAD 259",
    "dropphycty": "LOST CITY",
    "dropphyst": "WV",
    "dropphyzpp": 268109998,
    "dropmaladd": "9330 STATE ROAD 259",
    "dropmalcty": "LOST CITY",
    "dropmalst": "WV",
    "dropmalzpp": 268109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048969168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28805",
    "droptype": "D",
    "dropname": "LOST CREEK",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "LOST CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 263859998,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "LOST CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 263859998,
    "dropmaladd": "107 E MAIN ST",
    "dropmalcty": "LOST CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 263859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047454136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28808",
    "droptype": "D",
    "dropname": "LUMBERPORT",
    "dropdeladd": "489 MAIN ST",
    "dropdelcty": "LUMBERPORT",
    "dropdelst": "WV",
    "dropdelzpp": 263869998,
    "dropphyadd": "489 MAIN ST",
    "dropphycty": "LUMBERPORT",
    "dropphyst": "WV",
    "dropphyzpp": 263869998,
    "dropmaladd": "489 MAIN ST",
    "dropmalcty": "LUMBERPORT",
    "dropmalst": "WV",
    "dropmalzpp": 263869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045844998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28811",
    "droptype": "D",
    "dropname": "LYNCO",
    "dropdeladd": "473 CLEAR FORK VALLEY RD",
    "dropdelcty": "LYNCO",
    "dropdelst": "WV",
    "dropdelzpp": 248579998,
    "dropphyadd": "473 CLEAR FORK VALLEY RD",
    "dropphycty": "LYNCO",
    "dropphyst": "WV",
    "dropphyzpp": 248579998,
    "dropmaladd": "473 CLEAR FORK VALLEY RD",
    "dropmalcty": "LYNCO",
    "dropmalst": "WV",
    "dropmalzpp": 248579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046825227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28813",
    "droptype": "D",
    "dropname": "MABIE",
    "dropdeladd": "1010 MABIE CASSITY RD",
    "dropdelcty": "MABIE",
    "dropdelst": "WV",
    "dropdelzpp": 262789998,
    "dropphyadd": "1010 MABIE CASSITY RD",
    "dropphycty": "MABIE",
    "dropphyst": "WV",
    "dropphyzpp": 262789998,
    "dropmaladd": "1010 MABIE CASSITY RD",
    "dropmalcty": "MABIE",
    "dropmalst": "WV",
    "dropmalzpp": 262789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046367300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28814",
    "droptype": "D",
    "dropname": "MABSCOTT",
    "dropdeladd": "113 CHESTNUT ST",
    "dropdelcty": "MABSCOTT",
    "dropdelst": "WV",
    "dropdelzpp": 258719998,
    "dropphyadd": "113 CHESTNUT ST",
    "dropphycty": "MABSCOTT",
    "dropphyst": "WV",
    "dropphyzpp": 258719998,
    "dropmaladd": "113 CHESTNUT ST",
    "dropmalcty": "MABSCOTT",
    "dropmalst": "WV",
    "dropmalzpp": 258719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042537214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28815",
    "droptype": "D",
    "dropname": "MAC ARTHUR",
    "dropdeladd": "1902 ROBERT C BYRD DR",
    "dropdelcty": "MAC ARTHUR",
    "dropdelst": "WV",
    "dropdelzpp": 258739998,
    "dropphyadd": "1902 ROBERT C BYRD DR",
    "dropphycty": "MAC ARTHUR",
    "dropphyst": "WV",
    "dropphyzpp": 258739998,
    "dropmaladd": "1902 ROBERT C BYRD DR",
    "dropmalcty": "MAC ARTHUR",
    "dropmalst": "WV",
    "dropmalzpp": 258739998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042556640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28817",
    "droptype": "D",
    "dropname": "MACFARLAN",
    "dropdeladd": "8190 STAUNTON TPKE",
    "dropdelcty": "MACFARLAN",
    "dropdelst": "WV",
    "dropdelzpp": 261489998,
    "dropphyadd": "8190 STAUNTON TPKE",
    "dropphycty": "MACFARLAN",
    "dropphyst": "WV",
    "dropphyzpp": 261489998,
    "dropmaladd": "8190 STAUNTON TPKE",
    "dropmalcty": "MACFARLAN",
    "dropmalst": "WV",
    "dropmalzpp": 261489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044773110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28819",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "650 S MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "WV",
    "dropdelzpp": 251309998,
    "dropphyadd": "650 S MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "WV",
    "dropphyzpp": 251309998,
    "dropmaladd": "650 S MAIN ST",
    "dropmalcty": "MADISON",
    "dropmalst": "WV",
    "dropmalzpp": 251309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043691251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28822",
    "droptype": "D",
    "dropname": "MAIDSVILLE",
    "dropdeladd": "933 LAZZELLE UNION RD",
    "dropdelcty": "MAIDSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265419998,
    "dropphyadd": "933 LAZZELLE UNION RD",
    "dropphycty": "MAIDSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265419998,
    "dropmaladd": "933 LAZZELLE UNION RD",
    "dropmalcty": "MAIDSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045995674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28825",
    "droptype": "D",
    "dropname": "MALLORY",
    "dropdeladd": "1453 HUFF CREEK HWY",
    "dropdelcty": "MALLORY",
    "dropdelst": "WV",
    "dropdelzpp": 256349998,
    "dropphyadd": "1453 HUFF CREEK HWY",
    "dropphycty": "MALLORY",
    "dropphyst": "WV",
    "dropphyzpp": 256349998,
    "dropmaladd": "1453 HUFF CREEK HWY",
    "dropmalcty": "MALLORY",
    "dropmalst": "WV",
    "dropmalzpp": 256349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045832468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28826",
    "droptype": "D",
    "dropname": "MAMMOTH",
    "dropdeladd": "5873 KELLEYS CREEK RD",
    "dropdelcty": "MAMMOTH",
    "dropdelst": "WV",
    "dropdelzpp": 251329998,
    "dropphyadd": "5873 KELLEYS CREEK RD",
    "dropphycty": "MAMMOTH",
    "dropphyst": "WV",
    "dropphyzpp": 251329998,
    "dropmaladd": "5873 KELLEYS CREEK RD",
    "dropmalcty": "MAMMOTH",
    "dropmalst": "WV",
    "dropmalzpp": 251329998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28827",
    "droptype": "D",
    "dropname": "MAN",
    "dropdeladd": "125 MARKET ST",
    "dropdelcty": "MAN",
    "dropdelst": "WV",
    "dropdelzpp": 256359998,
    "dropphyadd": "125 MARKET ST",
    "dropphycty": "MAN",
    "dropphyst": "WV",
    "dropphyzpp": 256359998,
    "dropmaladd": "125 MARKET ST",
    "dropmalcty": "MAN",
    "dropmalst": "WV",
    "dropmalzpp": 256359998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045839812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28829",
    "droptype": "D",
    "dropname": "MANNINGTON",
    "dropdeladd": "113 WATER ST",
    "dropdelcty": "MANNINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 265829998,
    "dropphyadd": "113 WATER ST",
    "dropphycty": "MANNINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 265829998,
    "dropmaladd": "113 WATER ST",
    "dropmalcty": "MANNINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 265829998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049861280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28834",
    "droptype": "D",
    "dropname": "MARLINTON",
    "dropdeladd": "819 4TH AVE",
    "dropdelcty": "MARLINTON",
    "dropdelst": "WV",
    "dropdelzpp": 249549998,
    "dropphyadd": "819 4TH AVE",
    "dropphycty": "MARLINTON",
    "dropphyst": "WV",
    "dropphyzpp": 249549998,
    "dropmaladd": "819 4TH AVE",
    "dropmalcty": "MARLINTON",
    "dropmalst": "WV",
    "dropmalzpp": 249549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047996108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28839",
    "droptype": "D",
    "dropname": "MARTINSBURG",
    "dropdeladd": "1355 OLD COURTHOUSE SQ",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 254049998,
    "dropphyadd": "1355 OLD COURTHOUSE SQ",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 254049998,
    "dropmaladd": "1355 OLD COURTHOUSE SQ",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 254049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042677787,
    "dropfax": 3042679360
  },
  {
    "dcode": "D",
    "dropkey": "PX28841",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "1931 2ND ST",
    "dropdelcty": "MASON",
    "dropdelst": "WV",
    "dropdelzpp": 252609998,
    "dropphyadd": "1931 2ND ST",
    "dropphycty": "MASON",
    "dropphyst": "WV",
    "dropphyzpp": 252609998,
    "dropmaladd": "1931 2ND ST",
    "dropmalcty": "MASON",
    "dropmalst": "WV",
    "dropmalzpp": 252609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047735732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28842",
    "droptype": "D",
    "dropname": "MASONTOWN",
    "dropdeladd": "20 N MAIN ST",
    "dropdelcty": "MASONTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265429998,
    "dropphyadd": "20 N MAIN ST",
    "dropphycty": "MASONTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265429998,
    "dropmaladd": "20 N MAIN ST",
    "dropmalcty": "MASONTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265429998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048645494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28843",
    "droptype": "D",
    "dropname": "MATEWAN",
    "dropdeladd": "181 MATE ST",
    "dropdelcty": "MATEWAN",
    "dropdelst": "WV",
    "dropdelzpp": 256789998,
    "dropphyadd": "181 MATE ST",
    "dropphycty": "MATEWAN",
    "dropphyst": "WV",
    "dropphyzpp": 256789998,
    "dropmaladd": "181 MATE ST",
    "dropmalcty": "MATEWAN",
    "dropmalst": "WV",
    "dropmalzpp": 256789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044268101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28845",
    "droptype": "D",
    "dropname": "MATHIAS",
    "dropdeladd": "14 MATHIAS ST",
    "dropdelcty": "MATHIAS",
    "dropdelst": "WV",
    "dropdelzpp": 268129998,
    "dropphyadd": "14 MATHIAS ST",
    "dropphycty": "MATHIAS",
    "dropphyst": "WV",
    "dropphyzpp": 268129998,
    "dropmaladd": "14 MATHIAS ST",
    "dropmalcty": "MATHIAS",
    "dropmalst": "WV",
    "dropmalzpp": 268129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048975744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28846",
    "droptype": "D",
    "dropname": "MATOAKA",
    "dropdeladd": "103 MAIN ST",
    "dropdelcty": "MATOAKA",
    "dropdelst": "WV",
    "dropdelzpp": 247369998,
    "dropphyadd": "103 MAIN ST",
    "dropphycty": "MATOAKA",
    "dropphyst": "WV",
    "dropphyzpp": 247369998,
    "dropmaladd": "103 MAIN ST",
    "dropmalcty": "MATOAKA",
    "dropmalst": "WV",
    "dropmalzpp": 247369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044677366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28848",
    "droptype": "D",
    "dropname": "MAXWELTON",
    "dropdeladd": "16387 SENECA TRL N",
    "dropdelcty": "MAXWELTON",
    "dropdelst": "WV",
    "dropdelzpp": 249579998,
    "dropphyadd": "16387 SENECA TRL N",
    "dropphycty": "MAXWELTON",
    "dropphyst": "WV",
    "dropphyzpp": 249579998,
    "dropmaladd": "16387 SENECA TRL N",
    "dropmalcty": "MAXWELTON",
    "dropmalst": "WV",
    "dropmalzpp": 249579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044973122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28849",
    "droptype": "D",
    "dropname": "MAYBEURY",
    "dropdeladd": "40128 COAL HERITAGE RD",
    "dropdelcty": "MAYBEURY",
    "dropdelst": "WV",
    "dropdelzpp": 248619998,
    "dropphyadd": "40128 COAL HERITAGE RD",
    "dropphycty": "MAYBEURY",
    "dropphyst": "WV",
    "dropphyzpp": 248619998,
    "dropmaladd": "33955 COAL HERITAGE RD",
    "dropmalcty": "NORTHFORK",
    "dropmalst": "WV",
    "dropmalzpp": 248689998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048272351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28850",
    "droptype": "D",
    "dropname": "MAYSEL",
    "dropdeladd": "1848 PROCIOUS MAYSEL RD",
    "dropdelcty": "MAYSEL",
    "dropdelst": "WV",
    "dropdelzpp": 251339998,
    "dropphyadd": "1848 PROCIOUS MAYSEL RD",
    "dropphycty": "MAYSEL",
    "dropphyst": "WV",
    "dropphyzpp": 251339998,
    "dropmaladd": "1848 PROCIOUS MAYSEL RD",
    "dropmalcty": "MAYSEL",
    "dropmalst": "WV",
    "dropmalzpp": 251339998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045874072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28851",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "8995 LUNICE CREEK HWY",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 268339998,
    "dropphyadd": "8995 LUNICE CREEK HWY",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 268339998,
    "dropmaladd": "8995 LUNICE CREEK HWY",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 268339998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 6816420627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28855",
    "droptype": "D",
    "dropname": "MC GRAWS",
    "dropdeladd": "2487 MCGRAWS RD",
    "dropdelcty": "MC GRAWS",
    "dropdelst": "WV",
    "dropdelzpp": 258759998,
    "dropphyadd": "2487 MCGRAWS RD",
    "dropphycty": "MC GRAWS",
    "dropphyst": "WV",
    "dropphyzpp": 258759998,
    "dropmaladd": "2487 MCGRAWS RD",
    "dropmalcty": "MC GRAWS",
    "dropmalst": "WV",
    "dropmalzpp": 258759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042945791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28856",
    "droptype": "D",
    "dropname": "MCMECHEN",
    "dropdeladd": "717 MARSHALL ST",
    "dropdelcty": "MCMECHEN",
    "dropdelst": "WV",
    "dropdelzpp": 260409998,
    "dropphyadd": "717 MARSHALL ST",
    "dropphycty": "MCMECHEN",
    "dropphyst": "WV",
    "dropphyzpp": 260409998,
    "dropmaladd": "717 MARSHALL ST",
    "dropmalcty": "MCMECHEN",
    "dropmalst": "WV",
    "dropmalzpp": 260409998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042324940,
    "dropsitcph": 3042324940,
    "dropfax": 3042333917
  },
  {
    "dcode": "D",
    "dropkey": "PX28862",
    "droptype": "D",
    "dropname": "MEADOW BRIDGE",
    "dropdeladd": "9245 SEWELL CREEK RD",
    "dropdelcty": "MEADOW BRIDGE",
    "dropdelst": "WV",
    "dropdelzpp": 259769998,
    "dropphyadd": "9245 SEWELL CREEK RD",
    "dropphycty": "MEADOW BRIDGE",
    "dropphyst": "WV",
    "dropphyzpp": 259769998,
    "dropmaladd": "9245 SEWELL CREEK RD",
    "dropmalcty": "MEADOW BRIDGE",
    "dropmalst": "WV",
    "dropmalzpp": 259769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044847671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28863",
    "droptype": "D",
    "dropname": "MEADOW CREEK",
    "dropdeladd": "2638 MEADOW CREEK RD",
    "dropdelcty": "MEADOW CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 259779998,
    "dropphyadd": "2638 MEADOW CREEK RD",
    "dropphycty": "MEADOW CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 259779998,
    "dropmaladd": "2638 MEADOW CREEK RD",
    "dropmalcty": "MEADOW CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 259779998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044665721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28865",
    "droptype": "D",
    "dropname": "MEADOWBROOK",
    "dropdeladd": "3754 MEADOWBROOK RD",
    "dropdelcty": "MEADOWBROOK",
    "dropdelst": "WV",
    "dropdelzpp": 264049998,
    "dropphyadd": "3754 MEADOWBROOK RD",
    "dropphycty": "MEADOWBROOK",
    "dropphyst": "WV",
    "dropphyzpp": 264049998,
    "dropmaladd": "3754 MEADOWBROOK RD",
    "dropmalcty": "MEADOWBROOK",
    "dropmalst": "WV",
    "dropmalzpp": 264049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045919352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28868",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "4933 CABIN CREEK RD",
    "dropdelcty": "MIAMI",
    "dropdelst": "WV",
    "dropdelzpp": 251349998,
    "dropphyadd": "4933 CABIN CREEK RD",
    "dropphycty": "MIAMI",
    "dropphyst": "WV",
    "dropphyzpp": 251349998,
    "dropmaladd": "4933 CABIN CREEK RD",
    "dropmalcty": "MIAMI",
    "dropmalst": "WV",
    "dropmalzpp": 251349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045956631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28869",
    "droptype": "D",
    "dropname": "MIDDLEBOURNE",
    "dropdeladd": "105 DODD ST",
    "dropdelcty": "MIDDLEBOURNE",
    "dropdelst": "WV",
    "dropdelzpp": 261499998,
    "dropphyadd": "105 DODD ST",
    "dropphycty": "MIDDLEBOURNE",
    "dropphyst": "WV",
    "dropphyzpp": 261499998,
    "dropmaladd": "105 DODD ST",
    "dropmalcty": "MIDDLEBOURNE",
    "dropmalst": "WV",
    "dropmalzpp": 261499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047583009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28870",
    "droptype": "D",
    "dropname": "MIDKIFF",
    "dropdeladd": "43 9 MILE CRK",
    "dropdelcty": "MIDKIFF",
    "dropdelst": "WV",
    "dropdelzpp": 255409998,
    "dropphyadd": "43 9 MILE CRK",
    "dropphycty": "MIDKIFF",
    "dropphyst": "WV",
    "dropphyzpp": 255409998,
    "dropmaladd": "43 9 MILE CRK",
    "dropmalcty": "MIDKIFF",
    "dropmalst": "WV",
    "dropmalzpp": 255409998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047787337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28871",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "1158 MIDWAY RD",
    "dropdelcty": "MIDWAY",
    "dropdelst": "WV",
    "dropdelzpp": 258789998,
    "dropphyadd": "1158 MIDWAY RD",
    "dropphycty": "MIDWAY",
    "dropphyst": "WV",
    "dropphyzpp": 258789998,
    "dropmaladd": "1158 MIDWAY RD",
    "dropmalcty": "MIDWAY",
    "dropmalst": "WV",
    "dropmalzpp": 258789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046839640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28874",
    "droptype": "D",
    "dropname": "MILL CREEK",
    "dropdeladd": "10054 SENECA TRL",
    "dropdelcty": "MILL CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 262809998,
    "dropphyadd": "10054 SENECA TRL",
    "dropphycty": "MILL CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 262809998,
    "dropmaladd": "10054 SENECA TRL",
    "dropmalcty": "MILL CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 262809998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043352721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28877",
    "droptype": "D",
    "dropname": "MILLSTONE",
    "dropdeladd": "11376 S CALHOUN HWY",
    "dropdelcty": "MILLSTONE",
    "dropdelst": "WV",
    "dropdelzpp": 252619998,
    "dropphyadd": "11376 S CALHOUN HWY",
    "dropphycty": "MILLSTONE",
    "dropphyst": "WV",
    "dropphyzpp": 252619998,
    "dropmaladd": "11376 S CALHOUN HWY",
    "dropmalcty": "MILLSTONE",
    "dropmalst": "WV",
    "dropmalzpp": 252619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046558862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28880",
    "droptype": "D",
    "dropname": "MILLWOOD",
    "dropdeladd": "23 DANDELION DR",
    "dropdelcty": "MILLWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 252629998,
    "dropphyadd": "23 DANDELION DR",
    "dropphycty": "MILLWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 252629998,
    "dropmaladd": "23 DANDELION DR",
    "dropmalcty": "MILLWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 252629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042735711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28882",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "1177 MAIN ST",
    "dropdelcty": "MILTON",
    "dropdelst": "WV",
    "dropdelzpp": 255419998,
    "dropphyadd": "1177 MAIN ST",
    "dropphycty": "MILTON",
    "dropphyst": "WV",
    "dropphyzpp": 255419998,
    "dropmaladd": "1177 MAIN ST",
    "dropmalcty": "MILTON",
    "dropmalst": "WV",
    "dropmalzpp": 255419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047436471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28883",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "1679 MINDEN RD",
    "dropdelcty": "MINDEN",
    "dropdelst": "WV",
    "dropdelzpp": 258799998,
    "dropphyadd": "1679 MINDEN RD",
    "dropphycty": "MINDEN",
    "dropphyst": "WV",
    "dropphyzpp": 258799998,
    "dropmaladd": "1679 MINDEN RD",
    "dropmalcty": "MINDEN",
    "dropmalst": "WV",
    "dropmalzpp": 258799998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044651879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28884",
    "droptype": "D",
    "dropname": "MINERAL WELLS",
    "dropdeladd": "1259 ELIZABETH PIKE",
    "dropdelcty": "MINERAL WELLS",
    "dropdelst": "WV",
    "dropdelzpp": 261509998,
    "dropphyadd": "1259 ELIZABETH PIKE",
    "dropphycty": "MINERAL WELLS",
    "dropphyst": "WV",
    "dropphyzpp": 261509998,
    "dropmaladd": "1259 ELIZABETH PIKE",
    "dropmalcty": "MINERAL WELLS",
    "dropmalst": "WV",
    "dropmalzpp": 261509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044892890,
    "dropfax": 3044893402
  },
  {
    "dcode": "D",
    "dropkey": "PX28889",
    "droptype": "D",
    "dropname": "MOATSVILLE",
    "dropdeladd": "13205 MORGANTOWN PIKE",
    "dropdelcty": "MOATSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 264059998,
    "dropphyadd": "13205 MORGANTOWN PIKE",
    "dropphycty": "MOATSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 264059998,
    "dropmaladd": "13205 MORGANTOWN PIKE",
    "dropmalcty": "MOATSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 264059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044571787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28894",
    "droptype": "D",
    "dropname": "MONTCALM",
    "dropdeladd": "5427 SIMMONS RIVER RD",
    "dropdelcty": "MONTCALM",
    "dropdelst": "WV",
    "dropdelzpp": 247379998,
    "dropphyadd": "5427 SIMMONS RIVER RD",
    "dropphycty": "MONTCALM",
    "dropphyst": "WV",
    "dropphyzpp": 247379998,
    "dropmaladd": "5427 SIMMONS RIVER RD",
    "dropmalcty": "MONTCALM",
    "dropmalst": "WV",
    "dropmalzpp": 247379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045896117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28897",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "315 4TH AVE",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "WV",
    "dropdelzpp": 251369998,
    "dropphyadd": "315 4TH AVE",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "WV",
    "dropphyzpp": 251369998,
    "dropmaladd": "315 4TH AVE",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "WV",
    "dropmalzpp": 251369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044422691,
    "dropfax": 3044428610
  },
  {
    "dcode": "D",
    "dropkey": "PX28899",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "9152 PARSONS RD",
    "dropdelcty": "MONTROSE",
    "dropdelst": "WV",
    "dropdelzpp": 262835000,
    "dropphyadd": "9152 PARSONS RD",
    "dropphycty": "MONTROSE",
    "dropphyst": "WV",
    "dropphyzpp": 262835000,
    "dropmaladd": "9152 PARSONS RD",
    "dropmalcty": "MONTROSE",
    "dropmalst": "WV",
    "dropmalzpp": 262835000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046362329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28900",
    "droptype": "D",
    "dropname": "MOOREFIELD",
    "dropdeladd": "410 SPRING AVE",
    "dropdelcty": "MOOREFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 268369998,
    "dropphyadd": "410 SPRING AVE",
    "dropphycty": "MOOREFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 268369998,
    "dropmaladd": "410 SPRING AVE",
    "dropmalcty": "MOOREFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 268369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045386349,
    "dropfax": 3045382554
  },
  {
    "dcode": "D",
    "dropkey": "PX28901",
    "droptype": "D",
    "dropname": "MORGANTOWN",
    "dropdeladd": "300 POSTAL PLZ",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265089998,
    "dropphyadd": "300 POSTAL PLZ",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265089998,
    "dropmaladd": "300 POSTAL PLZ",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042963011,
    "dropfax": 3042849819
  },
  {
    "dcode": "D",
    "dropkey": "PX28904",
    "droptype": "D",
    "dropname": "MOUNDSVILLE",
    "dropdeladd": "1214 3RD ST",
    "dropdelcty": "MOUNDSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 260419998,
    "dropphyadd": "1214 3RD ST",
    "dropphycty": "MOUNDSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 260419998,
    "dropmaladd": "1214 3RD ST",
    "dropmalcty": "MOUNDSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 260419998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3048450104,
    "dropsitcph": 3048450104,
    "dropfax": 3048456794
  },
  {
    "dcode": "D",
    "dropkey": "PX28908",
    "droptype": "D",
    "dropname": "MOUNT CARBON",
    "dropdeladd": "18040 DEEPWATER MOUNTAIN RD",
    "dropdelcty": "MOUNT CARBON",
    "dropdelst": "WV",
    "dropdelzpp": 251399998,
    "dropphyadd": "18040 DEEPWATER MOUNTAIN RD",
    "dropphycty": "MOUNT CARBON",
    "dropphyst": "WV",
    "dropphyzpp": 251399998,
    "dropmaladd": "18040 DEEPWATER MOUNTAIN RD",
    "dropmalcty": "MOUNT CARBON",
    "dropmalst": "WV",
    "dropmalzpp": 251399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28909",
    "droptype": "D",
    "dropname": "MOUNT CLARE",
    "dropdeladd": "3801 MOUNT CLARE RD",
    "dropdelcty": "MOUNT CLARE",
    "dropdelst": "WV",
    "dropdelzpp": 264089998,
    "dropphyadd": "3801 MOUNT CLARE RD",
    "dropphycty": "MOUNT CLARE",
    "dropphyst": "WV",
    "dropphyzpp": 264089998,
    "dropmaladd": "3801 MOUNT CLARE RD",
    "dropmalcty": "MOUNT CLARE",
    "dropmalst": "WV",
    "dropmalzpp": 264089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046224969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28910",
    "droptype": "D",
    "dropname": "MOUNT GAY",
    "dropdeladd": "352 MOUNT GAY RD",
    "dropdelcty": "MOUNT GAY",
    "dropdelst": "WV",
    "dropdelzpp": 256379998,
    "dropphyadd": "352 MOUNT GAY RD",
    "dropphycty": "MOUNT GAY",
    "dropphyst": "WV",
    "dropphyzpp": 256379998,
    "dropmaladd": "352 MOUNT GAY RD",
    "dropmalcty": "MOUNT GAY",
    "dropmalst": "WV",
    "dropmalzpp": 256379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047520216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28911",
    "droptype": "D",
    "dropname": "MOUNT HOPE",
    "dropdeladd": "415 MAIN ST",
    "dropdelcty": "MOUNT HOPE",
    "dropdelst": "WV",
    "dropdelzpp": 258809998,
    "dropphyadd": "415 MAIN ST",
    "dropphycty": "MOUNT HOPE",
    "dropphyst": "WV",
    "dropphyzpp": 258809998,
    "dropmaladd": "415 MAIN ST",
    "dropmalcty": "MOUNT HOPE",
    "dropmalst": "WV",
    "dropmalzpp": 258809998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048772171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28912",
    "droptype": "D",
    "dropname": "MOUNT LOOKOUT",
    "dropdeladd": "466 W MOUNT LOOKOUT RD",
    "dropdelcty": "MOUNT LOOKOUT",
    "dropdelst": "WV",
    "dropdelzpp": 266789998,
    "dropphyadd": "466 W MOUNT LOOKOUT RD",
    "dropphycty": "MOUNT LOOKOUT",
    "dropphyst": "WV",
    "dropphyzpp": 266789998,
    "dropmaladd": "466 W MOUNT LOOKOUT RD",
    "dropmalcty": "MOUNT LOOKOUT",
    "dropmalst": "WV",
    "dropmalzpp": 266789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048723603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28913",
    "droptype": "D",
    "dropname": "MOUNT NEBO",
    "dropdeladd": "594 RIVIERA RD",
    "dropdelcty": "MOUNT NEBO",
    "dropdelst": "WV",
    "dropdelzpp": 266799998,
    "dropphyadd": "594 RIVIERA RD",
    "dropphycty": "MOUNT NEBO",
    "dropphyst": "WV",
    "dropphyzpp": 266799998,
    "dropmaladd": "594 RIVIERA RD",
    "dropmalcty": "MOUNT NEBO",
    "dropmalst": "WV",
    "dropmalzpp": 266799998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048723295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28915",
    "droptype": "D",
    "dropname": "MOUNT STORM",
    "dropdeladd": "16615 GEORGE WASHINGTON HWY",
    "dropdelcty": "MOUNT STORM",
    "dropdelst": "WV",
    "dropdelzpp": 267399998,
    "dropphyadd": "16615 GEORGE WASHINGTON HWY",
    "dropphycty": "MOUNT STORM",
    "dropphyst": "WV",
    "dropphyzpp": 267399998,
    "dropmaladd": "16615 GEORGE WASHINGTON HWY",
    "dropmalcty": "MOUNT STORM",
    "dropmalst": "WV",
    "dropmalzpp": 267399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046892005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28922",
    "droptype": "D",
    "dropname": "MULLENS",
    "dropdeladd": "101 4TH ST",
    "dropdelcty": "MULLENS",
    "dropdelst": "WV",
    "dropdelzpp": 258829998,
    "dropphyadd": "101 4TH ST",
    "dropphycty": "MULLENS",
    "dropphyst": "WV",
    "dropphyzpp": 258829998,
    "dropmaladd": "101 4TH ST",
    "dropmalcty": "MULLENS",
    "dropmalst": "WV",
    "dropmalzpp": 258829998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042946029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28927",
    "droptype": "D",
    "dropname": "NALLEN",
    "dropdeladd": "9001 WILDERNESS HWY",
    "dropdelcty": "NALLEN",
    "dropdelst": "WV",
    "dropdelzpp": 266809998,
    "dropphyadd": "9001 WILDERNESS HWY",
    "dropphycty": "NALLEN",
    "dropphyst": "WV",
    "dropphyzpp": 266809998,
    "dropmaladd": "9001 WILDERNESS HWY",
    "dropmalcty": "NALLEN",
    "dropmalst": "WV",
    "dropmalzpp": 266809998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044387916,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28929",
    "droptype": "D",
    "dropname": "NAOMA",
    "dropdeladd": "7502 COAL RIVER RD",
    "dropdelcty": "NAOMA",
    "dropdelst": "WV",
    "dropdelzpp": 251405000,
    "dropphyadd": "7502 COAL RIVER RD",
    "dropphycty": "NAOMA",
    "dropphyst": "WV",
    "dropphyzpp": 251405000,
    "dropmaladd": "7502 COAL RIVER RD",
    "dropmalcty": "NAOMA",
    "dropmalst": "WV",
    "dropmalzpp": 251405000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048541084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28930",
    "droptype": "D",
    "dropname": "NAPIER",
    "dropdeladd": "7614 GAULEY TPKE",
    "dropdelcty": "NAPIER",
    "dropdelst": "WV",
    "dropdelzpp": 266319998,
    "dropphyadd": "7614 GAULEY TPKE",
    "dropphycty": "NAPIER",
    "dropphyst": "WV",
    "dropphyzpp": 266319998,
    "dropmaladd": "7614 GAULEY TPKE",
    "dropmalcty": "NAPIER",
    "dropmalst": "WV",
    "dropmalzpp": 266319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047655696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28931",
    "droptype": "D",
    "dropname": "NAUGATUCK",
    "dropdeladd": "3 RT 65",
    "dropdelcty": "NAUGATUCK",
    "dropdelst": "WV",
    "dropdelzpp": 256859998,
    "dropphyadd": "3 RT 65",
    "dropphycty": "NAUGATUCK",
    "dropphyst": "WV",
    "dropphyzpp": 256859998,
    "dropmaladd": "3 RT 65",
    "dropmalcty": "NAUGATUCK",
    "dropmalst": "WV",
    "dropmalzpp": 256859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042351827,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28933",
    "droptype": "D",
    "dropname": "NELLIS",
    "dropdeladd": "31 FORK CREEK RD STE A",
    "dropdelcty": "NELLIS",
    "dropdelst": "WV",
    "dropdelzpp": 251429998,
    "dropphyadd": "31 FORK CREEK RD STE A",
    "dropphycty": "NELLIS",
    "dropphyst": "WV",
    "dropphyzpp": 251429998,
    "dropmaladd": "31 FORK CREEK RD STE A",
    "dropmalcty": "NELLIS",
    "dropmalst": "WV",
    "dropmalzpp": 251429998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048368094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28934",
    "droptype": "D",
    "dropname": "NEMOURS",
    "dropdeladd": "5609 FALLS MILLS RD",
    "dropdelcty": "NEMOURS",
    "dropdelst": "WV",
    "dropdelzpp": 247389998,
    "dropphyadd": "5609 FALLS MILLS RD",
    "dropphycty": "NEMOURS",
    "dropphyst": "WV",
    "dropphyzpp": 247389998,
    "dropmaladd": "5609 FALLS MILLS RD",
    "dropmalcty": "NEMOURS",
    "dropmalst": "WV",
    "dropmalzpp": 247389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042487091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28936",
    "droptype": "D",
    "dropname": "NETTIE",
    "dropdeladd": "11427 CANVAS NETTIE RD",
    "dropdelcty": "NETTIE",
    "dropdelst": "WV",
    "dropdelzpp": 266819998,
    "dropphyadd": "11427 CANVAS NETTIE RD",
    "dropphycty": "NETTIE",
    "dropphyst": "WV",
    "dropphyzpp": 266819998,
    "dropmaladd": "11427 CANVAS NETTIE RD",
    "dropmalcty": "NETTIE",
    "dropmalst": "WV",
    "dropmalzpp": 266819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048462140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28939",
    "droptype": "D",
    "dropname": "NEW CREEK",
    "dropdeladd": "15 NEW CREEK SCHOOL RD",
    "dropdelcty": "NEW CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 267439998,
    "dropphyadd": "15 NEW CREEK SCHOOL RD",
    "dropphycty": "NEW CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 267439998,
    "dropmaladd": "15 NEW CREEK SCHOOL RD",
    "dropmalcty": "NEW CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 267439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047885254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28940",
    "droptype": "D",
    "dropname": "NEW CUMBERLAND",
    "dropdeladd": "504 RIDGE AVE",
    "dropdelcty": "NEW CUMBERLAND",
    "dropdelst": "WV",
    "dropdelzpp": 260479998,
    "dropphyadd": "504 RIDGE AVE",
    "dropphycty": "NEW CUMBERLAND",
    "dropphyst": "WV",
    "dropphyzpp": 260479998,
    "dropmaladd": "504 RIDGE AVE",
    "dropmalcty": "NEW CUMBERLAND",
    "dropmalst": "WV",
    "dropmalzpp": 260479998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3045645061,
    "dropsitcph": 3045645061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28943",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "606 5TH ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "WV",
    "dropdelzpp": 252659998,
    "dropphyadd": "606 5TH ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "WV",
    "dropphyzpp": 252659998,
    "dropmaladd": "606 5TH ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "WV",
    "dropmalzpp": 252659998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048823100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28944",
    "droptype": "D",
    "dropname": "NEW MANCHESTER",
    "dropdeladd": "290 HIGH ST",
    "dropdelcty": "NEW MANCHESTER",
    "dropdelst": "WV",
    "dropdelzpp": 260561001,
    "dropphyadd": "290 HIGH ST",
    "dropphycty": "NEW MANCHESTER",
    "dropphyst": "WV",
    "dropphyzpp": 260561001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MANCHESTER",
    "dropmalst": "WV",
    "dropmalzpp": 260569998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3045645560,
    "dropsitcph": 3045645560,
    "dropfax": 3045644281
  },
  {
    "dcode": "D",
    "dropkey": "PX28945",
    "droptype": "D",
    "dropname": "NEW MARTINSVILLE",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "NEW MARTINSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261559998,
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "NEW MARTINSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261559998,
    "dropmaladd": "230 MAIN ST",
    "dropmalcty": "NEW MARTINSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261559998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044553211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28946",
    "droptype": "D",
    "dropname": "NEW MILTON",
    "dropdeladd": "1063 MEATHOUSE FORK RD",
    "dropdelcty": "NEW MILTON",
    "dropdelst": "WV",
    "dropdelzpp": 264119998,
    "dropphyadd": "1063 MEATHOUSE FORK RD",
    "dropphycty": "NEW MILTON",
    "dropphyst": "WV",
    "dropphyzpp": 264119998,
    "dropmaladd": "1063 MEATHOUSE FORK RD",
    "dropmalcty": "NEW MILTON",
    "dropmalst": "WV",
    "dropmalzpp": 264119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048731779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28947",
    "droptype": "D",
    "dropname": "NEW RICHMOND",
    "dropdeladd": "5204 RIVER RD",
    "dropdelcty": "NEW RICHMOND",
    "dropdelst": "WV",
    "dropdelzpp": 248679998,
    "dropphyadd": "5204 RIVER RD",
    "dropphycty": "NEW RICHMOND",
    "dropphyst": "WV",
    "dropphyzpp": 248679998,
    "dropmaladd": "5204 RIVER RD",
    "dropmalcty": "NEW RICHMOND",
    "dropmalst": "WV",
    "dropmalzpp": 248679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042940369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28949",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "54 MORGANTOWN AVE",
    "dropdelcty": "NEWBURG",
    "dropdelst": "WV",
    "dropdelzpp": 264109998,
    "dropphyadd": "54 MORGANTOWN AVE",
    "dropphycty": "NEWBURG",
    "dropphyst": "WV",
    "dropphyzpp": 264109998,
    "dropmaladd": "54 MORGANTOWN AVE",
    "dropmalcty": "NEWBURG",
    "dropmalst": "WV",
    "dropmalzpp": 264109998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048924345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28950",
    "droptype": "D",
    "dropname": "NEWELL",
    "dropdeladd": "202 WASHINGTON ST",
    "dropdelcty": "NEWELL",
    "dropdelst": "WV",
    "dropdelzpp": 260509998,
    "dropphyadd": "202 WASHINGTON ST",
    "dropphycty": "NEWELL",
    "dropphyst": "WV",
    "dropphyzpp": 260509998,
    "dropmaladd": "202 WASHINGTON ST",
    "dropmalcty": "NEWELL",
    "dropmalst": "WV",
    "dropmalzpp": 260509998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3043871091,
    "dropsitcph": 3043871091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28951",
    "droptype": "D",
    "dropname": "NEWHALL",
    "dropdeladd": "19233 HIGHWAY 16 N",
    "dropdelcty": "NEWHALL",
    "dropdelst": "WV",
    "dropdelzpp": 248669998,
    "dropphyadd": "19233 HIGHWAY 16 N",
    "dropphycty": "NEWHALL",
    "dropphyst": "WV",
    "dropphyzpp": 248669998,
    "dropmaladd": "19233 HIGHWAY 16 N",
    "dropmalcty": "NEWHALL",
    "dropmalst": "WV",
    "dropmalzpp": 248669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048753157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28952",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "12426 CLAY RD",
    "dropdelcty": "NEWTON",
    "dropdelst": "WV",
    "dropdelzpp": 252669998,
    "dropphyadd": "12426 CLAY RD",
    "dropphycty": "NEWTON",
    "dropphyst": "WV",
    "dropphyzpp": 252669998,
    "dropmaladd": "12426 CLAY RD",
    "dropmalcty": "NEWTON",
    "dropmalst": "WV",
    "dropmalzpp": 252669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045657625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28957",
    "droptype": "D",
    "dropname": "NIMITZ",
    "dropdeladd": "7394 BEECH RUN RD",
    "dropdelcty": "NIMITZ",
    "dropdelst": "WV",
    "dropdelzpp": 259789998,
    "dropphyadd": "7394 BEECH RUN RD",
    "dropphycty": "NIMITZ",
    "dropphyst": "WV",
    "dropphyzpp": 259789998,
    "dropmaladd": "7394 BEECH RUN RD",
    "dropmalcty": "NIMITZ",
    "dropmalst": "WV",
    "dropmalzpp": 259789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044660091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28958",
    "droptype": "D",
    "dropname": "NITRO",
    "dropdeladd": "311 21ST ST",
    "dropdelcty": "NITRO",
    "dropdelst": "WV",
    "dropdelzpp": 251439998,
    "dropphyadd": "311 21ST ST",
    "dropphycty": "NITRO",
    "dropphyst": "WV",
    "dropphyzpp": 251439998,
    "dropmaladd": "311 21ST ST",
    "dropmalcty": "NITRO",
    "dropmalst": "WV",
    "dropmalzpp": 251439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047550731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28961",
    "droptype": "D",
    "dropname": "NORMANTOWN",
    "dropdeladd": "80 GASSAWAY RD",
    "dropdelcty": "NORMANTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 252679998,
    "dropphyadd": "80 GASSAWAY RD",
    "dropphycty": "NORMANTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 252679998,
    "dropmaladd": "80 GASSAWAY RD",
    "dropmalcty": "NORMANTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 252679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044625188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28963",
    "droptype": "D",
    "dropname": "NORTH MATEWAN",
    "dropdeladd": "567 RT 65",
    "dropdelcty": "NORTH MATEWAN",
    "dropdelst": "WV",
    "dropdelzpp": 256889998,
    "dropphyadd": "567 RT 65",
    "dropphycty": "NORTH MATEWAN",
    "dropphyst": "WV",
    "dropphyzpp": 256889998,
    "dropmaladd": "567 RT 65",
    "dropmalcty": "NORTH MATEWAN",
    "dropmalst": "WV",
    "dropmalzpp": 256889998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044264534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28967",
    "droptype": "D",
    "dropname": "NORTHFORK",
    "dropdeladd": "33955 COAL HERITAGE RD",
    "dropdelcty": "NORTHFORK",
    "dropdelst": "WV",
    "dropdelzpp": 248689998,
    "dropphyadd": "33955 COAL HERITAGE RD",
    "dropphycty": "NORTHFORK",
    "dropphyst": "WV",
    "dropphyzpp": 248689998,
    "dropmaladd": "PO BOX 1",
    "dropmalcty": "NORTHFORK",
    "dropmalst": "WV",
    "dropmalzpp": 248680001,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048623454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28971",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "208 MAIN ST E",
    "dropdelcty": "OAK HILL",
    "dropdelst": "WV",
    "dropdelzpp": 259019998,
    "dropphyadd": "208 MAIN ST E",
    "dropphycty": "OAK HILL",
    "dropphyst": "WV",
    "dropphyzpp": 259019998,
    "dropmaladd": "208 MAIN ST E",
    "dropmalcty": "OAK HILL",
    "dropmalst": "WV",
    "dropmalzpp": 259019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044693241,
    "dropfax": 3044693727
  },
  {
    "dcode": "D",
    "dropkey": "PX28973",
    "droptype": "D",
    "dropname": "OCEANA",
    "dropdeladd": "1524 COOK PKWY",
    "dropdelcty": "OCEANA",
    "dropdelst": "WV",
    "dropdelzpp": 248709998,
    "dropphyadd": "1524 COOK PKWY",
    "dropphycty": "OCEANA",
    "dropphyst": "WV",
    "dropphyzpp": 248709998,
    "dropmaladd": "1524 COOK PKWY",
    "dropmalcty": "OCEANA",
    "dropmalst": "WV",
    "dropmalzpp": 248709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046825612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28975",
    "droptype": "D",
    "dropname": "ODD",
    "dropdeladd": "2803 ODD RD",
    "dropdelcty": "ODD",
    "dropdelst": "WV",
    "dropdelzpp": 259029998,
    "dropphyadd": "2803 ODD RD",
    "dropphycty": "ODD",
    "dropphyst": "WV",
    "dropphyzpp": 259029998,
    "dropmaladd": "2803 ODD RD",
    "dropmalcty": "ODD",
    "dropmalst": "WV",
    "dropmalzpp": 259029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047873486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28977",
    "droptype": "D",
    "dropname": "OLD FIELDS",
    "dropdeladd": "165 OLD FIELDS RD",
    "dropdelcty": "OLD FIELDS",
    "dropdelst": "WV",
    "dropdelzpp": 268459998,
    "dropphyadd": "165 OLD FIELDS RD",
    "dropphycty": "OLD FIELDS",
    "dropphyst": "WV",
    "dropphyzpp": 268459998,
    "dropmaladd": "165 OLD FIELDS RD",
    "dropmalcty": "OLD FIELDS",
    "dropmalst": "WV",
    "dropmalzpp": 268459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045387260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28978",
    "droptype": "D",
    "dropname": "OMAR",
    "dropdeladd": "8296 JERRY WEST HWY",
    "dropdelcty": "OMAR",
    "dropdelst": "WV",
    "dropdelzpp": 256389998,
    "dropphyadd": "8296 JERRY WEST HWY",
    "dropphycty": "OMAR",
    "dropphyst": "WV",
    "dropphyzpp": 256389998,
    "dropmaladd": "8296 JERRY WEST HWY",
    "dropmalcty": "OMAR",
    "dropmalst": "WV",
    "dropmalzpp": 256389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049464963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28979",
    "droptype": "D",
    "dropname": "ONA",
    "dropdeladd": "2632 US ROUTE 60",
    "dropdelcty": "ONA",
    "dropdelst": "WV",
    "dropdelzpp": 255459998,
    "dropphyadd": "2632 US ROUTE 60",
    "dropphycty": "ONA",
    "dropphyst": "WV",
    "dropphyzpp": 255459998,
    "dropmaladd": "2632 US ROUTE 60",
    "dropmalcty": "ONA",
    "dropmalst": "WV",
    "dropmalzpp": 255459998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047433462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28980",
    "droptype": "D",
    "dropname": "ONEGO",
    "dropdeladd": "2942 ALLEGHENY DR",
    "dropdelcty": "ONEGO",
    "dropdelst": "WV",
    "dropdelzpp": 268869998,
    "dropphyadd": "2942 ALLEGHENY DR",
    "dropphycty": "ONEGO",
    "dropphyst": "WV",
    "dropphyzpp": 268869998,
    "dropmaladd": "2942 ALLEGHENY DR",
    "dropmalcty": "ONEGO",
    "dropmalst": "WV",
    "dropmalzpp": 268869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045673126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28981",
    "droptype": "D",
    "dropname": "ORGAS",
    "dropdeladd": "24220 COAL RIVER RD",
    "dropdelcty": "ORGAS",
    "dropdelst": "WV",
    "dropdelzpp": 251489998,
    "dropphyadd": "24220 COAL RIVER RD",
    "dropphycty": "ORGAS",
    "dropphyst": "WV",
    "dropphyzpp": 251489998,
    "dropmaladd": "24220 COAL RIVER RD",
    "dropmalcty": "ORGAS",
    "dropmalst": "WV",
    "dropmalzpp": 251489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048378484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28982",
    "droptype": "D",
    "dropname": "ORLANDO",
    "dropdeladd": "29 CEMETARY RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "WV",
    "dropdelzpp": 264129998,
    "dropphyadd": "29 CEMETARY RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "WV",
    "dropphyzpp": 264129998,
    "dropmaladd": "29 CEMETARY RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "WV",
    "dropmalzpp": 264129998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048532611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28985",
    "droptype": "D",
    "dropname": "OTTAWA",
    "dropdeladd": "22321 SPRUCE RIVER RD STE A",
    "dropdelcty": "OTTAWA",
    "dropdelst": "WV",
    "dropdelzpp": 251499998,
    "dropphyadd": "22321 SPRUCE RIVER RD STE A",
    "dropphycty": "OTTAWA",
    "dropphyst": "WV",
    "dropphyzpp": 251499998,
    "dropmaladd": "22321 SPRUCE RIVER RD STE A",
    "dropmalcty": "OTTAWA",
    "dropmalst": "WV",
    "dropmalzpp": 251499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043694915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28992",
    "droptype": "D",
    "dropname": "PADEN CITY",
    "dropdeladd": "213 W MAIN ST",
    "dropdelcty": "PADEN CITY",
    "dropdelst": "WV",
    "dropdelzpp": 261599998,
    "dropphyadd": "213 W MAIN ST",
    "dropphycty": "PADEN CITY",
    "dropphyst": "WV",
    "dropphyzpp": 261599998,
    "dropmaladd": "213 W MAIN ST",
    "dropmalcty": "PADEN CITY",
    "dropmalst": "WV",
    "dropmalzpp": 261599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043378761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28994",
    "droptype": "D",
    "dropname": "PAGETON",
    "dropdeladd": "207 MAIN ST",
    "dropdelcty": "PAGETON",
    "dropdelst": "WV",
    "dropdelzpp": 248719998,
    "dropphyadd": "207 MAIN ST",
    "dropphycty": "PAGETON",
    "dropphyst": "WV",
    "dropphyzpp": 248719998,
    "dropmaladd": "207 MAIN ST",
    "dropmalcty": "PAGETON",
    "dropmalst": "WV",
    "dropmalzpp": 248719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043834584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28996",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "2841 PALESTINE RD",
    "dropdelcty": "PALESTINE",
    "dropdelst": "WV",
    "dropdelzpp": 261609998,
    "dropphyadd": "2841 PALESTINE RD",
    "dropphycty": "PALESTINE",
    "dropphyst": "WV",
    "dropphyzpp": 261609998,
    "dropmaladd": "2841 PALESTINE RD",
    "dropmalcty": "PALESTINE",
    "dropmalst": "WV",
    "dropmalzpp": 261609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042758760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX28997",
    "droptype": "D",
    "dropname": "PANTHER",
    "dropdeladd": "534 GREENBRIER MOUNTAIN RD",
    "dropdelcty": "PANTHER",
    "dropdelst": "WV",
    "dropdelzpp": 248729998,
    "dropphyadd": "534 GREENBRIER MOUNTAIN RD",
    "dropphycty": "PANTHER",
    "dropphyst": "WV",
    "dropphyzpp": 248729998,
    "dropmaladd": "534 GREENBRIER MOUNTAIN RD",
    "dropmalcty": "PANTHER",
    "dropmalst": "WV",
    "dropmalzpp": 248729998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049382767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29001",
    "droptype": "D",
    "dropname": "PARKERSBURG",
    "dropdeladd": "401 JULIANA ST",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261017503,
    "dropphyadd": "401 JULIANA ST",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261017503,
    "dropmaladd": "401 JULIANA ST",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261017503,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044857771,
    "dropfax": 3044850724
  },
  {
    "dcode": "D",
    "dropkey": "PX29002",
    "droptype": "D",
    "dropname": "PARSONS",
    "dropdeladd": "235 WALNUT ST RM 1",
    "dropdelcty": "PARSONS",
    "dropdelst": "WV",
    "dropdelzpp": 262879998,
    "dropphyadd": "235 WALNUT ST RM 1",
    "dropphycty": "PARSONS",
    "dropphyst": "WV",
    "dropphyzpp": 262879998,
    "dropmaladd": "235 WALNUT ST RM 1",
    "dropmalcty": "PARSONS",
    "dropmalst": "WV",
    "dropmalzpp": 262879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044782882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29004",
    "droptype": "D",
    "dropname": "PAW PAW",
    "dropdeladd": "93 WINCHESTER ST",
    "dropdelcty": "PAW PAW",
    "dropdelst": "WV",
    "dropdelzpp": 254349998,
    "dropphyadd": "93 WINCHESTER ST",
    "dropphycty": "PAW PAW",
    "dropphyst": "WV",
    "dropphyzpp": 254349998,
    "dropmaladd": "93 WINCHESTER ST",
    "dropmalcty": "PAW PAW",
    "dropmalst": "WV",
    "dropmalzpp": 254349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049477671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29005",
    "droptype": "D",
    "dropname": "PAX",
    "dropdeladd": "251 MAIN ST",
    "dropdelcty": "PAX",
    "dropdelst": "WV",
    "dropdelzpp": 259049998,
    "dropphyadd": "251 MAIN ST",
    "dropphycty": "PAX",
    "dropphyst": "WV",
    "dropphyzpp": 259049998,
    "dropmaladd": "251 MAIN ST",
    "dropmalcty": "PAX",
    "dropmalst": "WV",
    "dropmalzpp": 259049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048775836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29006",
    "droptype": "D",
    "dropname": "PAYNESVILLE",
    "dropdeladd": "17117 MARSHALL HWY",
    "dropdelcty": "PAYNESVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 248739998,
    "dropphyadd": "17117 MARSHALL HWY",
    "dropphycty": "PAYNESVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 248739998,
    "dropmaladd": "17117 MARSHALL HWY",
    "dropmalcty": "PAYNESVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 248739998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049677960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29007",
    "droptype": "D",
    "dropname": "PEACH CREEK",
    "dropdeladd": "631 ALLEGHENY AVE",
    "dropdelcty": "PEACH CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 256399998,
    "dropphyadd": "631 ALLEGHENY AVE",
    "dropphycty": "PEACH CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 256399998,
    "dropmaladd": "631 ALLEGHENY AVE",
    "dropmalcty": "PEACH CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 256399998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047528376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29008",
    "droptype": "D",
    "dropname": "PECKS MILL",
    "dropdeladd": "105 THUNDER RD",
    "dropdelcty": "PECKS MILL",
    "dropdelst": "WV",
    "dropdelzpp": 255479998,
    "dropphyadd": "105 THUNDER RD",
    "dropphycty": "PECKS MILL",
    "dropphyst": "WV",
    "dropphyzpp": 255479998,
    "dropmaladd": "105 THUNDER RD",
    "dropmalcty": "PECKS MILL",
    "dropmalst": "WV",
    "dropmalzpp": 255479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047529134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29013",
    "droptype": "D",
    "dropname": "PENNSBORO",
    "dropdeladd": "202 CLAYTON ST",
    "dropdelcty": "PENNSBORO",
    "dropdelst": "WV",
    "dropdelzpp": 264159998,
    "dropphyadd": "202 CLAYTON ST",
    "dropphycty": "PENNSBORO",
    "dropphyst": "WV",
    "dropphyzpp": 264159998,
    "dropmaladd": "202 CLAYTON ST",
    "dropmalcty": "PENNSBORO",
    "dropmalst": "WV",
    "dropmalzpp": 264159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046592954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29014",
    "droptype": "D",
    "dropname": "PENTRESS",
    "dropdeladd": "55 PENTRESS RD",
    "dropdelcty": "PENTRESS",
    "dropdelst": "WV",
    "dropdelzpp": 265449998,
    "dropphyadd": "55 PENTRESS RD",
    "dropphycty": "PENTRESS",
    "dropphyst": "WV",
    "dropphyzpp": 265449998,
    "dropmaladd": "55 PENTRESS RD",
    "dropmalcty": "PENTRESS",
    "dropmalst": "WV",
    "dropmalzpp": 265449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048795597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29017",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "1 POSTAL SQ",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 268479998,
    "dropphyadd": "1 POSTAL SQ",
    "dropphycty": "PETERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 268479998,
    "dropmaladd": "1 POSTAL SQ",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 268479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042574344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29018",
    "droptype": "D",
    "dropname": "PETERSTOWN",
    "dropdeladd": "13 MARKET ST",
    "dropdelcty": "PETERSTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 249639998,
    "dropphyadd": "13 MARKET ST",
    "dropphycty": "PETERSTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 249639998,
    "dropmaladd": "13 MARKET ST",
    "dropmalcty": "PETERSTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 249639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047539732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29020",
    "droptype": "D",
    "dropname": "PEYTONA",
    "dropdeladd": "54 ROUNDBOTTOM RD STE A",
    "dropdelcty": "PEYTONA",
    "dropdelst": "WV",
    "dropdelzpp": 251549998,
    "dropphyadd": "54 ROUNDBOTTOM RD STE A",
    "dropphycty": "PEYTONA",
    "dropphyst": "WV",
    "dropphyzpp": 251549998,
    "dropmaladd": "54 ROUNDBOTTOM RD STE A",
    "dropmalcty": "PEYTONA",
    "dropmalst": "WV",
    "dropmalzpp": 251549998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048365847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29021",
    "droptype": "D",
    "dropname": "PHILIPPI",
    "dropdeladd": "105 S RAILROAD ST",
    "dropdelcty": "PHILIPPI",
    "dropdelst": "WV",
    "dropdelzpp": 264169998,
    "dropphyadd": "105 S RAILROAD ST",
    "dropphycty": "PHILIPPI",
    "dropphyst": "WV",
    "dropphyzpp": 264169998,
    "dropmaladd": "105 S RAILROAD ST",
    "dropmalcty": "PHILIPPI",
    "dropmalst": "WV",
    "dropmalzpp": 264169998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044572676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29023",
    "droptype": "D",
    "dropname": "PICKENS",
    "dropdeladd": "8 PICKENS RD",
    "dropdelcty": "PICKENS",
    "dropdelst": "WV",
    "dropdelzpp": 262309998,
    "dropphyadd": "8 PICKENS RD",
    "dropphycty": "PICKENS",
    "dropphyst": "WV",
    "dropphyzpp": 262309998,
    "dropmaladd": "8 PICKENS RD",
    "dropmalcty": "PICKENS",
    "dropmalst": "WV",
    "dropmalzpp": 262309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049245539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29024",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "25 ASHFIELD ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "WV",
    "dropdelzpp": 267509998,
    "dropphyadd": "25 ASHFIELD ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "WV",
    "dropphyzpp": 267509998,
    "dropmaladd": "25 ASHFIELD ST",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "WV",
    "dropmalzpp": 267509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043552066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29027",
    "droptype": "D",
    "dropname": "PINCH",
    "dropdeladd": "231 N PINCH RD",
    "dropdelcty": "PINCH",
    "dropdelst": "WV",
    "dropdelzpp": 251569998,
    "dropphyadd": "231 N PINCH RD",
    "dropphycty": "PINCH",
    "dropphyst": "WV",
    "dropphyzpp": 251569998,
    "dropmaladd": "231 N PINCH RD",
    "dropmalcty": "PINCH",
    "dropmalst": "WV",
    "dropmalzpp": 251569998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049651743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29028",
    "droptype": "D",
    "dropname": "PINE GROVE",
    "dropdeladd": "35 TRIPLEX ST",
    "dropdelcty": "PINE GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 264199997,
    "dropphyadd": "35 TRIPLEX ST",
    "dropphycty": "PINE GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 264199997,
    "dropmaladd": "35 TRIPLEX ST",
    "dropmalcty": "PINE GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 264199997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048893539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29030",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "145 MAIN AVE",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 248749998,
    "dropphyadd": "145 MAIN AVE",
    "dropphycty": "PINEVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 248749998,
    "dropmaladd": "145 MAIN AVE",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 248749998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047326333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29031",
    "droptype": "D",
    "dropname": "PINEY VIEW",
    "dropdeladd": "133 STONEWALL RD",
    "dropdelcty": "PINEY VIEW",
    "dropdelst": "WV",
    "dropdelzpp": 259069998,
    "dropphyadd": "133 STONEWALL RD",
    "dropphycty": "PINEY VIEW",
    "dropphyst": "WV",
    "dropphyzpp": 259069998,
    "dropmaladd": "133 STONEWALL RD",
    "dropmalcty": "PINEY VIEW",
    "dropmalst": "WV",
    "dropmalzpp": 259069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042555824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29032",
    "droptype": "D",
    "dropname": "PIPESTEM",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "PIPESTEM",
    "dropdelst": "WV",
    "dropdelzpp": 259799998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "PIPESTEM",
    "dropphyst": "WV",
    "dropphyzpp": 259799998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "PIPESTEM",
    "dropmalst": "WV",
    "dropmalzpp": 259799998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044661280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29038",
    "droptype": "D",
    "dropname": "POCA",
    "dropdeladd": "118 MAIN ST",
    "dropdelcty": "POCA",
    "dropdelst": "WV",
    "dropdelzpp": 251599998,
    "dropphyadd": "118 MAIN ST",
    "dropphycty": "POCA",
    "dropphyst": "WV",
    "dropphyzpp": 251599998,
    "dropmaladd": "118 MAIN ST",
    "dropmalcty": "POCA",
    "dropmalst": "WV",
    "dropmalzpp": 251599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047552832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29041",
    "droptype": "D",
    "dropname": "POINT PLEASANT",
    "dropdeladd": "329 MAIN ST",
    "dropdelcty": "POINT PLEASANT",
    "dropdelst": "WV",
    "dropdelzpp": 255509998,
    "dropphyadd": "329 MAIN ST",
    "dropphycty": "POINT PLEASANT",
    "dropphyst": "WV",
    "dropphyzpp": 255509998,
    "dropmaladd": "329 MAIN ST",
    "dropmalcty": "POINT PLEASANT",
    "dropmalst": "WV",
    "dropmalzpp": 255509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046753510,
    "dropfax": 3046754804
  },
  {
    "dcode": "D",
    "dropkey": "PX29042",
    "droptype": "D",
    "dropname": "POINTS",
    "dropdeladd": "10558 JERSEY MOUNTAIN RD",
    "dropdelcty": "POINTS",
    "dropdelst": "WV",
    "dropdelzpp": 254379998,
    "dropphyadd": "10558 JERSEY MOUNTAIN RD",
    "dropphycty": "POINTS",
    "dropphyst": "WV",
    "dropphyzpp": 254379998,
    "dropmaladd": "10558 JERSEY MOUNTAIN RD",
    "dropmalcty": "POINTS",
    "dropmalst": "WV",
    "dropmalzpp": 254379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044925584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29043",
    "droptype": "D",
    "dropname": "POND GAP",
    "dropdeladd": "6585 BELLE CREEK RD",
    "dropdelcty": "POND GAP",
    "dropdelst": "WV",
    "dropdelzpp": 251609998,
    "dropphyadd": "6585 BELLE CREEK RD",
    "dropphycty": "POND GAP",
    "dropphyst": "WV",
    "dropphyzpp": 251609998,
    "dropmaladd": "6585 BELLE CREEK RD",
    "dropmalcty": "POND GAP",
    "dropmalst": "WV",
    "dropmalzpp": 251609998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045954719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29047",
    "droptype": "D",
    "dropname": "POWELLTON",
    "dropdeladd": "4468 ARMSTRONG CREEK RD",
    "dropdelcty": "POWELLTON",
    "dropdelst": "WV",
    "dropdelzpp": 251619998,
    "dropphyadd": "4468 ARMSTRONG CREEK RD",
    "dropphycty": "POWELLTON",
    "dropphyst": "WV",
    "dropphyzpp": 251619998,
    "dropmaladd": "4468 ARMSTRONG CREEK RD",
    "dropmalcty": "POWELLTON",
    "dropmalst": "WV",
    "dropmalzpp": 251619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044422802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29049",
    "droptype": "D",
    "dropname": "PRATT",
    "dropdeladd": "307 CENTER ST",
    "dropdelcty": "PRATT",
    "dropdelst": "WV",
    "dropdelzpp": 251624000,
    "dropphyadd": "307 CENTER ST",
    "dropphycty": "PRATT",
    "dropphyst": "WV",
    "dropphyzpp": 251624000,
    "dropmaladd": "307 CENTER ST",
    "dropmalcty": "PRATT",
    "dropmalst": "WV",
    "dropmalzpp": 251624000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29050",
    "droptype": "D",
    "dropname": "PREMIER",
    "dropdeladd": "11 CASPIAN LN",
    "dropdelcty": "PREMIER",
    "dropdelst": "WV",
    "dropdelzpp": 248789998,
    "dropphyadd": "11 CASPIAN LN",
    "dropphycty": "PREMIER",
    "dropphyst": "WV",
    "dropphyzpp": 248789998,
    "dropmaladd": "11 CASPIAN LN",
    "dropmalcty": "PREMIER",
    "dropmalst": "WV",
    "dropmalzpp": 248789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044366353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29055",
    "droptype": "D",
    "dropname": "PRICHARD",
    "dropdeladd": "1 N ROBERTSON ST",
    "dropdelcty": "PRICHARD",
    "dropdelst": "WV",
    "dropdelzpp": 255559998,
    "dropphyadd": "1 N ROBERTSON ST",
    "dropphycty": "PRICHARD",
    "dropphyst": "WV",
    "dropphyzpp": 255559998,
    "dropmaladd": "1 N ROBERTSON ST",
    "dropmalcty": "PRICHARD",
    "dropmalst": "WV",
    "dropmalzpp": 255559998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044845772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29056",
    "droptype": "D",
    "dropname": "PRINCE",
    "dropdeladd": "4827 STANAFORD RD",
    "dropdelcty": "PRINCE",
    "dropdelst": "WV",
    "dropdelzpp": 259079998,
    "dropphyadd": "4827 STANAFORD RD",
    "dropphycty": "PRINCE",
    "dropphyst": "WV",
    "dropphyzpp": 259079998,
    "dropmaladd": "4827 STANAFORD RD",
    "dropmalcty": "PRINCE",
    "dropmalst": "WV",
    "dropmalzpp": 259079998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042554299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29057",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "1000 MERCER ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "WV",
    "dropdelzpp": 247409998,
    "dropphyadd": "1000 MERCER ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "WV",
    "dropphyzpp": 247409998,
    "dropmaladd": "1000 MERCER ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "WV",
    "dropmalzpp": 247409998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044253075,
    "dropfax": 3044873598
  },
  {
    "dcode": "D",
    "dropkey": "PX29058",
    "droptype": "D",
    "dropname": "PRINCEWICK",
    "dropdeladd": "127 EPPERLY RD",
    "dropdelcty": "PRINCEWICK",
    "dropdelst": "WV",
    "dropdelzpp": 259089998,
    "dropphyadd": "127 EPPERLY RD",
    "dropphycty": "PRINCEWICK",
    "dropphyst": "WV",
    "dropphyzpp": 259089998,
    "dropmaladd": "127 EPPERLY RD",
    "dropmalcty": "PRINCEWICK",
    "dropmalst": "WV",
    "dropmalzpp": 259089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046833313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29059",
    "droptype": "D",
    "dropname": "PROCIOUS",
    "dropdeladd": "8531 PROCIOUS MAYSEL RD",
    "dropdelcty": "PROCIOUS",
    "dropdelst": "WV",
    "dropdelzpp": 251649998,
    "dropphyadd": "8531 PROCIOUS MAYSEL RD",
    "dropphycty": "PROCIOUS",
    "dropphyst": "WV",
    "dropphyzpp": 251649998,
    "dropmaladd": "8531 PROCIOUS MAYSEL RD",
    "dropmalcty": "PROCIOUS",
    "dropmalst": "WV",
    "dropmalzpp": 251649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045484458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29060",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "1 STATE ROUTE 2",
    "dropdelcty": "PROCTOR",
    "dropdelst": "WV",
    "dropdelzpp": 260551001,
    "dropphyadd": "1 STATE ROUTE 2",
    "dropphycty": "PROCTOR",
    "dropphyst": "WV",
    "dropphyzpp": 260551001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROCTOR",
    "dropmalst": "WV",
    "dropmalzpp": 260559998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3044553862,
    "dropsitcph": 3044553862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29061",
    "droptype": "D",
    "dropname": "PROSPERITY",
    "dropdeladd": "578 PROSPERITY RD",
    "dropdelcty": "PROSPERITY",
    "dropdelst": "WV",
    "dropdelzpp": 259099998,
    "dropphyadd": "578 PROSPERITY RD",
    "dropphycty": "PROSPERITY",
    "dropphyst": "WV",
    "dropphyzpp": 259099998,
    "dropmaladd": "578 PROSPERITY RD",
    "dropmalcty": "PROSPERITY",
    "dropmalst": "WV",
    "dropmalzpp": 259099998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042555825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29063",
    "droptype": "D",
    "dropname": "PULLMAN",
    "dropdeladd": "307 MAIN ST",
    "dropdelcty": "PULLMAN",
    "dropdelst": "WV",
    "dropdelzpp": 264219998,
    "dropphyadd": "307 MAIN ST",
    "dropphycty": "PULLMAN",
    "dropphyst": "WV",
    "dropphyzpp": 264219998,
    "dropmaladd": "307 MAIN ST",
    "dropmalcty": "PULLMAN",
    "dropmalst": "WV",
    "dropmalzpp": 264219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046593141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29064",
    "droptype": "D",
    "dropname": "PURGITSVILLE",
    "dropdeladd": "6406 PURGITSVILLE PIKE",
    "dropdelcty": "PURGITSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 268529998,
    "dropphyadd": "6406 PURGITSVILLE PIKE",
    "dropphycty": "PURGITSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 268529998,
    "dropmaladd": "6406 PURGITSVILLE PIKE",
    "dropmalcty": "PURGITSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 268529998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042893942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29065",
    "droptype": "D",
    "dropname": "PURSGLOVE",
    "dropdeladd": "576 BLUE HORIZON DR",
    "dropdelcty": "PURSGLOVE",
    "dropdelst": "WV",
    "dropdelzpp": 265469998,
    "dropphyadd": "576 BLUE HORIZON DR",
    "dropphycty": "PURSGLOVE",
    "dropphyst": "WV",
    "dropphyzpp": 265469998,
    "dropmaladd": "576 BLUE HORIZON DR",
    "dropmalcty": "PURSGLOVE",
    "dropmalst": "WV",
    "dropmalzpp": 265469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045995675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29070",
    "droptype": "D",
    "dropname": "QUINWOOD",
    "dropdeladd": "115 AMICK ST W",
    "dropdelcty": "QUINWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 259819998,
    "dropphyadd": "115 AMICK ST W",
    "dropphycty": "QUINWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 259819998,
    "dropmaladd": "115 AMICK ST W",
    "dropmalcty": "QUINWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 259819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044388447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29071",
    "droptype": "D",
    "dropname": "RACHEL",
    "dropdeladd": "134 RACHEL RD",
    "dropdelcty": "RACHEL",
    "dropdelst": "WV",
    "dropdelzpp": 265879998,
    "dropphyadd": "134 RACHEL RD",
    "dropphycty": "RACHEL",
    "dropphyst": "WV",
    "dropphyzpp": 265879998,
    "dropmaladd": "134 RACHEL RD",
    "dropmalcty": "RACHEL",
    "dropmalst": "WV",
    "dropmalzpp": 265879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049862380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29072",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "3010 SHORT CREEK RD",
    "dropdelcty": "RACINE",
    "dropdelst": "WV",
    "dropdelzpp": 251659998,
    "dropphyadd": "3010 SHORT CREEK RD",
    "dropphycty": "RACINE",
    "dropphyst": "WV",
    "dropphyzpp": 251659998,
    "dropmaladd": "3010 SHORT CREEK RD",
    "dropmalcty": "RACINE",
    "dropmalst": "WV",
    "dropmalzpp": 251659998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048377949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29074",
    "droptype": "D",
    "dropname": "RAGLAND",
    "dropdeladd": "13 JACKSON ST",
    "dropdelcty": "RAGLAND",
    "dropdelst": "WV",
    "dropdelzpp": 256909998,
    "dropphyadd": "13 JACKSON ST",
    "dropphycty": "RAGLAND",
    "dropphyst": "WV",
    "dropphyzpp": 256909998,
    "dropmaladd": "13 JACKSON ST",
    "dropmalcty": "RAGLAND",
    "dropmalst": "WV",
    "dropmalzpp": 256909998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044754278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29075",
    "droptype": "D",
    "dropname": "RAINELLE",
    "dropdeladd": "397 JOHN RAINE DR",
    "dropdelcty": "RAINELLE",
    "dropdelst": "WV",
    "dropdelzpp": 259625001,
    "dropphyadd": "397 JOHN RAINE DR",
    "dropphycty": "RAINELLE",
    "dropphyst": "WV",
    "dropphyzpp": 259625001,
    "dropmaladd": "397 JOHN RAINE DR",
    "dropmalcty": "RAINELLE",
    "dropmalst": "WV",
    "dropmalzpp": 259625001,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044388851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29076",
    "droptype": "D",
    "dropname": "RALEIGH",
    "dropdeladd": "1 BURMEISTER AVE",
    "dropdelcty": "RALEIGH",
    "dropdelst": "WV",
    "dropdelzpp": 259119998,
    "dropphyadd": "1 BURMEISTER AVE",
    "dropphycty": "RALEIGH",
    "dropphyst": "WV",
    "dropphyzpp": 259119998,
    "dropmaladd": "1 BURMEISTER AVE",
    "dropmalcty": "RALEIGH",
    "dropmalst": "WV",
    "dropmalzpp": 259119998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042552421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29080",
    "droptype": "D",
    "dropname": "RANGER",
    "dropdeladd": "25 VANATTERS CRK",
    "dropdelcty": "RANGER",
    "dropdelst": "WV",
    "dropdelzpp": 255575000,
    "dropphyadd": "25 VANATTERS CRK",
    "dropphycty": "RANGER",
    "dropphyst": "WV",
    "dropphyzpp": 255575000,
    "dropmaladd": "25 VANATTERS CRK",
    "dropmalcty": "RANGER",
    "dropmalst": "WV",
    "dropmalzpp": 255575000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047787966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29081",
    "droptype": "D",
    "dropname": "RANSON",
    "dropdeladd": "205 AMBROSE DR",
    "dropdelcty": "RANSON",
    "dropdelst": "WV",
    "dropdelzpp": 254389998,
    "dropphyadd": "205 AMBROSE DR",
    "dropphycty": "RANSON",
    "dropphyst": "WV",
    "dropphyzpp": 254389998,
    "dropmaladd": "205 AMBROSE DR",
    "dropmalcty": "RANSON",
    "dropmalst": "WV",
    "dropmalzpp": 254389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047259121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29083",
    "droptype": "D",
    "dropname": "RAVENSWOOD",
    "dropdeladd": "716 WASHINGTON ST",
    "dropdelcty": "RAVENSWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 261649998,
    "dropphyadd": "716 WASHINGTON ST",
    "dropphycty": "RAVENSWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 261649998,
    "dropmaladd": "716 WASHINGTON ST",
    "dropmalcty": "RAVENSWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 261649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042734608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29084",
    "droptype": "D",
    "dropname": "RAWL",
    "dropdeladd": "19 MURPHY BR",
    "dropdelcty": "RAWL",
    "dropdelst": "WV",
    "dropdelzpp": 256919998,
    "dropphyadd": "19 MURPHY BR",
    "dropphycty": "RAWL",
    "dropphyst": "WV",
    "dropphyzpp": 256919998,
    "dropmaladd": "19 MURPHY BR",
    "dropmalcty": "RAWL",
    "dropmalst": "WV",
    "dropmalzpp": 256919998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042352528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29085",
    "droptype": "D",
    "dropname": "RAYSAL",
    "dropdeladd": "8672 MARSHALL HWY",
    "dropdelcty": "RAYSAL",
    "dropdelst": "WV",
    "dropdelzpp": 248799998,
    "dropphyadd": "8672 MARSHALL HWY",
    "dropphycty": "RAYSAL",
    "dropphyst": "WV",
    "dropphyzpp": 248799998,
    "dropmaladd": "8672 MARSHALL HWY",
    "dropmalcty": "RAYSAL",
    "dropmalst": "WV",
    "dropmalzpp": 248799998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049675800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29086",
    "droptype": "D",
    "dropname": "READER",
    "dropdeladd": "9599 SHORTLINE RD",
    "dropdelcty": "READER",
    "dropdelst": "WV",
    "dropdelzpp": 261679998,
    "dropphyadd": "9599 SHORTLINE RD",
    "dropphycty": "READER",
    "dropphyst": "WV",
    "dropphyzpp": 261679998,
    "dropmaladd": "9599 SHORTLINE RD",
    "dropmalcty": "READER",
    "dropmalst": "WV",
    "dropmalzpp": 261679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043864612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29087",
    "droptype": "D",
    "dropname": "RED CREEK",
    "dropdeladd": "94 BUTCHERS RIDGE RD",
    "dropdelcty": "RED CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 262899998,
    "dropphyadd": "94 BUTCHERS RIDGE RD",
    "dropphycty": "RED CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 262899998,
    "dropmaladd": "94 BUTCHERS RIDGE RD",
    "dropmalcty": "RED CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 262899998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048664338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29088",
    "droptype": "D",
    "dropname": "RED HOUSE",
    "dropdeladd": "11442 CHARLESTON RD",
    "dropdelcty": "RED HOUSE",
    "dropdelst": "WV",
    "dropdelzpp": 251689998,
    "dropphyadd": "11442 CHARLESTON RD",
    "dropphycty": "RED HOUSE",
    "dropphyst": "WV",
    "dropphyzpp": 251689998,
    "dropmaladd": "11442 CHARLESTON RD",
    "dropmalcty": "RED HOUSE",
    "dropmalst": "WV",
    "dropmalzpp": 251689998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045869798,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29089",
    "droptype": "D",
    "dropname": "RED JACKET",
    "dropdeladd": "1 MATE CREEK RD",
    "dropdelcty": "RED JACKET",
    "dropdelst": "WV",
    "dropdelzpp": 256929998,
    "dropphyadd": "1 MATE CREEK RD",
    "dropphycty": "RED JACKET",
    "dropphyst": "WV",
    "dropphyzpp": 256929998,
    "dropmaladd": "1 MATE CREEK RD",
    "dropmalcty": "RED JACKET",
    "dropmalst": "WV",
    "dropmalzpp": 256929998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044264661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29092",
    "droptype": "D",
    "dropname": "REEDSVILLE",
    "dropdeladd": "13275 VETERANS MEMORIAL HWY",
    "dropdelcty": "REEDSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265479998,
    "dropphyadd": "13275 VETERANS MEMORIAL HWY",
    "dropphycty": "REEDSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265479998,
    "dropmaladd": "13275 VETERANS MEMORIAL HWY",
    "dropmalcty": "REEDSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048643885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29095",
    "droptype": "D",
    "dropname": "RENICK",
    "dropdeladd": "27288 SENECA TRL N",
    "dropdelcty": "RENICK",
    "dropdelst": "WV",
    "dropdelzpp": 249669998,
    "dropphyadd": "27288 SENECA TRL N",
    "dropphycty": "RENICK",
    "dropphyst": "WV",
    "dropphyzpp": 249669998,
    "dropmaladd": "27288 SENECA TRL N",
    "dropmalcty": "RENICK",
    "dropmalst": "WV",
    "dropmalzpp": 249669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044972715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29098",
    "droptype": "D",
    "dropname": "REYNOLDSVILLE",
    "dropdeladd": "24 GLADYS HOLLOW RD",
    "dropdelcty": "REYNOLDSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 264229998,
    "dropphyadd": "24 GLADYS HOLLOW RD",
    "dropphycty": "REYNOLDSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 264229998,
    "dropmaladd": "24 GLADYS HOLLOW RD",
    "dropmalcty": "REYNOLDSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 264229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046231747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29099",
    "droptype": "D",
    "dropname": "RHODELL",
    "dropdeladd": "7230 COAL CITY RD",
    "dropdelcty": "RHODELL",
    "dropdelst": "WV",
    "dropdelzpp": 259159998,
    "dropphyadd": "7230 COAL CITY RD",
    "dropphycty": "RHODELL",
    "dropphyst": "WV",
    "dropphyzpp": 259159998,
    "dropmaladd": "7230 COAL CITY RD",
    "dropmalcty": "RHODELL",
    "dropmalst": "WV",
    "dropmalzpp": 259159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046833100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29102",
    "droptype": "D",
    "dropname": "RICHWOOD",
    "dropdeladd": "22 E MAIN ST",
    "dropdelcty": "RICHWOOD",
    "dropdelst": "WV",
    "dropdelzpp": 262619998,
    "dropphyadd": "22 E MAIN ST",
    "dropphycty": "RICHWOOD",
    "dropphyst": "WV",
    "dropphyzpp": 262619998,
    "dropmaladd": "22 E MAIN ST",
    "dropmalcty": "RICHWOOD",
    "dropmalst": "WV",
    "dropmalzpp": 262619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048466611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29103",
    "droptype": "D",
    "dropname": "RIDGELEY",
    "dropdeladd": "400 VETERANS MEMORIAL HWY",
    "dropdelcty": "RIDGELEY",
    "dropdelst": "WV",
    "dropdelzpp": 267539998,
    "dropphyadd": "400 VETERANS MEMORIAL HWY",
    "dropphycty": "RIDGELEY",
    "dropphyst": "WV",
    "dropphyzpp": 267539998,
    "dropmaladd": "400 VETERANS MEMORIAL HWY",
    "dropmalcty": "RIDGELEY",
    "dropmalst": "WV",
    "dropmalzpp": 267539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047388600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29108",
    "droptype": "D",
    "dropname": "RIO",
    "dropdeladd": "15115 FORD HILL RD",
    "dropdelcty": "RIO",
    "dropdelst": "WV",
    "dropdelzpp": 267559998,
    "dropphyadd": "15115 FORD HILL RD",
    "dropphycty": "RIO",
    "dropphyst": "WV",
    "dropphyzpp": 267559998,
    "dropmaladd": "15115 FORD HILL RD",
    "dropmalcty": "RIO",
    "dropmalst": "WV",
    "dropmalzpp": 267559998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048976094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29109",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "114 MAIN ST W",
    "dropdelcty": "RIPLEY",
    "dropdelst": "WV",
    "dropdelzpp": 252719998,
    "dropphyadd": "114 MAIN ST W",
    "dropphycty": "RIPLEY",
    "dropphyst": "WV",
    "dropphyzpp": 252719998,
    "dropmaladd": "114 MAIN ST W",
    "dropmalcty": "RIPLEY",
    "dropmalst": "WV",
    "dropmalzpp": 252719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043726271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29110",
    "droptype": "D",
    "dropname": "RIPPON",
    "dropdeladd": "2468 BERRYVILLE PIKE STE 100",
    "dropdelcty": "RIPPON",
    "dropdelst": "WV",
    "dropdelzpp": 254419998,
    "dropphyadd": "2468 BERRYVILLE PIKE STE 100",
    "dropphycty": "RIPPON",
    "dropphyst": "WV",
    "dropphyzpp": 254419998,
    "dropmaladd": "2468 BERRYVILLE PIKE STE 100",
    "dropmalcty": "RIPPON",
    "dropmalst": "WV",
    "dropmalzpp": 254419998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047253551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29114",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "61 TUSCARORA LN",
    "dropdelcty": "RIVERTON",
    "dropdelst": "WV",
    "dropdelzpp": 268149998,
    "dropphyadd": "61 TUSCARORA LN",
    "dropphycty": "RIVERTON",
    "dropphyst": "WV",
    "dropphyzpp": 268149998,
    "dropmaladd": "61 TUSCARORA LN",
    "dropmalcty": "RIVERTON",
    "dropmalst": "WV",
    "dropmalzpp": 268149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045672023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29115",
    "droptype": "D",
    "dropname": "RIVESVILLE",
    "dropdeladd": "214 MAIN ST",
    "dropdelcty": "RIVESVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 265889998,
    "dropphyadd": "214 MAIN ST",
    "dropphycty": "RIVESVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 265889998,
    "dropmaladd": "214 MAIN ST",
    "dropmalcty": "RIVESVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 265889998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042785758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29119",
    "droptype": "D",
    "dropname": "ROBSON",
    "dropdeladd": "13759 DEEPWATER MOUNTAIN RD",
    "dropdelcty": "ROBSON",
    "dropdelst": "WV",
    "dropdelzpp": 251739998,
    "dropphyadd": "13759 DEEPWATER MOUNTAIN RD",
    "dropphycty": "ROBSON",
    "dropphyst": "WV",
    "dropphyzpp": 251739998,
    "dropmaladd": "13759 DEEPWATER MOUNTAIN RD",
    "dropmalcty": "ROBSON",
    "dropmalst": "WV",
    "dropmalzpp": 251739998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047799348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29120",
    "droptype": "D",
    "dropname": "ROCK",
    "dropdeladd": "2757 ROCK RD",
    "dropdelcty": "ROCK",
    "dropdelst": "WV",
    "dropdelzpp": 247479998,
    "dropphyadd": "2757 ROCK RD",
    "dropphycty": "ROCK",
    "dropphyst": "WV",
    "dropphyzpp": 247479998,
    "dropmaladd": "2757 ROCK RD",
    "dropmalcty": "ROCK",
    "dropmalst": "WV",
    "dropmalzpp": 247479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045895745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29122",
    "droptype": "D",
    "dropname": "ROCK CAVE",
    "dropdeladd": "410 ROCK CAVE RD",
    "dropdelcty": "ROCK CAVE",
    "dropdelst": "WV",
    "dropdelzpp": 262349998,
    "dropphyadd": "410 ROCK CAVE RD",
    "dropphycty": "ROCK CAVE",
    "dropphyst": "WV",
    "dropphyzpp": 262349998,
    "dropmaladd": "410 ROCK CAVE RD",
    "dropmalcty": "ROCK CAVE",
    "dropmalst": "WV",
    "dropmalzpp": 262349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049246173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29124",
    "droptype": "D",
    "dropname": "ROCK CREEK",
    "dropdeladd": "5762 COAL RIVER RD",
    "dropdelcty": "ROCK CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 251749998,
    "dropphyadd": "5762 COAL RIVER RD",
    "dropphycty": "ROCK CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 251749998,
    "dropmaladd": "5762 COAL RIVER RD",
    "dropmalcty": "ROCK CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 251749998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048541781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29125",
    "droptype": "D",
    "dropname": "ROCK VIEW",
    "dropdeladd": "4025 APPALACHIAN HWY",
    "dropdelcty": "ROCK VIEW",
    "dropdelst": "WV",
    "dropdelzpp": 248809998,
    "dropphyadd": "4025 APPALACHIAN HWY",
    "dropphycty": "ROCK VIEW",
    "dropphyst": "WV",
    "dropphyzpp": 248809998,
    "dropmaladd": "4025 APPALACHIAN HWY",
    "dropmalcty": "ROCK VIEW",
    "dropmalst": "WV",
    "dropmalzpp": 248809998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047328212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29129",
    "droptype": "D",
    "dropname": "RODERFIELD",
    "dropdeladd": "12790 COAL HERITAGE RD",
    "dropdelcty": "RODERFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 248819998,
    "dropphyadd": "12790 COAL HERITAGE RD",
    "dropphycty": "RODERFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 248819998,
    "dropmaladd": "12790 COAL HERITAGE RD",
    "dropmalcty": "RODERFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 248819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044368133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29132",
    "droptype": "D",
    "dropname": "ROMNEY",
    "dropdeladd": "71 N MARSHAM ST",
    "dropdelcty": "ROMNEY",
    "dropdelst": "WV",
    "dropdelzpp": 267579998,
    "dropphyadd": "71 N MARSHAM ST",
    "dropphycty": "ROMNEY",
    "dropphyst": "WV",
    "dropphyzpp": 267579998,
    "dropmaladd": "71 N MARSHAM ST",
    "dropmalcty": "ROMNEY",
    "dropmalst": "WV",
    "dropmalzpp": 267579998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048225119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29133",
    "droptype": "D",
    "dropname": "RONCEVERTE",
    "dropdeladd": "314 EDGAR AVE",
    "dropdelcty": "RONCEVERTE",
    "dropdelst": "WV",
    "dropdelzpp": 249709998,
    "dropphyadd": "314 EDGAR AVE",
    "dropphycty": "RONCEVERTE",
    "dropphyst": "WV",
    "dropphyzpp": 249709998,
    "dropmaladd": "314 EDGAR AVE",
    "dropmalcty": "RONCEVERTE",
    "dropmalst": "WV",
    "dropmalzpp": 249709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046474585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29135",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "11957 ROSEDALE RD",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "WV",
    "dropdelzpp": 266369998,
    "dropphyadd": "11957 ROSEDALE RD",
    "dropphycty": "ROSEDALE",
    "dropphyst": "WV",
    "dropphyzpp": 266369998,
    "dropmaladd": "11957 ROSEDALE RD",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "WV",
    "dropmalzpp": 266369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043645903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29136",
    "droptype": "D",
    "dropname": "ROSEMONT",
    "dropdeladd": "1791 W VETERANS MEMORIAL HWY",
    "dropdelcty": "ROSEMONT",
    "dropdelst": "WV",
    "dropdelzpp": 264249998,
    "dropphyadd": "1791 W VETERANS MEMORIAL HWY",
    "dropphycty": "ROSEMONT",
    "dropphyst": "WV",
    "dropphyzpp": 264249998,
    "dropmaladd": "1791 W VETERANS MEMORIAL HWY",
    "dropmalcty": "ROSEMONT",
    "dropmalst": "WV",
    "dropmalzpp": 264249998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047394611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29138",
    "droptype": "D",
    "dropname": "ROWLESBURG",
    "dropdeladd": "67 CHESSIE LN",
    "dropdelcty": "ROWLESBURG",
    "dropdelst": "WV",
    "dropdelzpp": 264255000,
    "dropphyadd": "67 CHESSIE LN",
    "dropphycty": "ROWLESBURG",
    "dropphyst": "WV",
    "dropphyzpp": 264255000,
    "dropmaladd": "67 CHESSIE LN",
    "dropmalcty": "ROWLESBURG",
    "dropmalst": "WV",
    "dropmalzpp": 264255000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044549504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29140",
    "droptype": "D",
    "dropname": "RUPERT",
    "dropdeladd": "628 NICHOLAS ST",
    "dropdelcty": "RUPERT",
    "dropdelst": "WV",
    "dropdelzpp": 259849998,
    "dropphyadd": "628 NICHOLAS ST",
    "dropphycty": "RUPERT",
    "dropphyst": "WV",
    "dropphyzpp": 259849998,
    "dropmaladd": "628 NICHOLAS ST",
    "dropmalcty": "RUPERT",
    "dropmalst": "WV",
    "dropmalzpp": 259849998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043926325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29147",
    "droptype": "D",
    "dropname": "SAINT ALBANS",
    "dropdeladd": "431 B ST",
    "dropdelcty": "SAINT ALBANS",
    "dropdelst": "WV",
    "dropdelzpp": 251779998,
    "dropphyadd": "431 B ST",
    "dropphycty": "SAINT ALBANS",
    "dropphyst": "WV",
    "dropphyzpp": 251779998,
    "dropmaladd": "431 B ST",
    "dropmalcty": "SAINT ALBANS",
    "dropmalst": "WV",
    "dropmalzpp": 251779998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047222198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29149",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "402 2ND ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "WV",
    "dropdelzpp": 261709998,
    "dropphyadd": "402 2ND ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "WV",
    "dropphyzpp": 261709998,
    "dropmaladd": "402 2ND ST",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "WV",
    "dropmalzpp": 261709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046843041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29150",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "147 W MAIN ST",
    "dropdelcty": "SALEM",
    "dropdelst": "WV",
    "dropdelzpp": 264269998,
    "dropphyadd": "147 W MAIN ST",
    "dropphycty": "SALEM",
    "dropphyst": "WV",
    "dropphyzpp": 264269998,
    "dropmaladd": "147 W MAIN ST",
    "dropmalcty": "SALEM",
    "dropmalst": "WV",
    "dropmalzpp": 264269998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047821400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29152",
    "droptype": "D",
    "dropname": "SALT ROCK",
    "dropdeladd": "5577 MADISON CREEK RD",
    "dropdelcty": "SALT ROCK",
    "dropdelst": "WV",
    "dropdelzpp": 255599998,
    "dropphyadd": "5577 MADISON CREEK RD",
    "dropphycty": "SALT ROCK",
    "dropphyst": "WV",
    "dropphyzpp": 255599998,
    "dropmaladd": "5577 MADISON CREEK RD",
    "dropmalcty": "SALT ROCK",
    "dropmalst": "WV",
    "dropmalzpp": 255599998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047361226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29153",
    "droptype": "D",
    "dropname": "SAND FORK",
    "dropdeladd": "5383 WV HIGHWAY 5 E STE A",
    "dropdelcty": "SAND FORK",
    "dropdelst": "WV",
    "dropdelzpp": 264309998,
    "dropphyadd": "5383 WV HIGHWAY 5 E STE A",
    "dropphycty": "SAND FORK",
    "dropphyst": "WV",
    "dropphyzpp": 264309998,
    "dropmaladd": "5383 WV HIGHWAY 5 E STE A",
    "dropmalcty": "SAND FORK",
    "dropmalst": "WV",
    "dropmalzpp": 264309998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044628829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29156",
    "droptype": "D",
    "dropname": "SANDSTONE",
    "dropdeladd": "38 RIVER RD",
    "dropdelcty": "SANDSTONE",
    "dropdelst": "WV",
    "dropdelzpp": 259859998,
    "dropphyadd": "38 RIVER RD",
    "dropphycty": "SANDSTONE",
    "dropphyst": "WV",
    "dropphyzpp": 259859998,
    "dropmaladd": "38 RIVER RD",
    "dropmalcty": "SANDSTONE",
    "dropmalst": "WV",
    "dropmalzpp": 259859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044664229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29157",
    "droptype": "D",
    "dropname": "SANDYVILLE",
    "dropdeladd": "1 INDEPENDENCE RD",
    "dropdelcty": "SANDYVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 252759998,
    "dropphyadd": "1 INDEPENDENCE RD",
    "dropphycty": "SANDYVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 252759998,
    "dropmaladd": "1 INDEPENDENCE RD",
    "dropmalcty": "SANDYVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 252759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042735485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29158",
    "droptype": "D",
    "dropname": "SARAH ANN",
    "dropdeladd": "11765 JERRY WEST HWY",
    "dropdelcty": "SARAH ANN",
    "dropdelst": "WV",
    "dropdelzpp": 256449998,
    "dropphyadd": "11765 JERRY WEST HWY",
    "dropphycty": "SARAH ANN",
    "dropphyst": "WV",
    "dropphyzpp": 256449998,
    "dropmaladd": "11765 JERRY WEST HWY",
    "dropmalcty": "SARAH ANN",
    "dropmalst": "WV",
    "dropmalzpp": 256449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049462431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29164",
    "droptype": "D",
    "dropname": "SCARBRO",
    "dropdeladd": "1379 SCARBRO RD",
    "dropdelcty": "SCARBRO",
    "dropdelst": "WV",
    "dropdelzpp": 259179998,
    "dropphyadd": "1379 SCARBRO RD",
    "dropphycty": "SCARBRO",
    "dropphyst": "WV",
    "dropphyzpp": 259179998,
    "dropmaladd": "1379 SCARBRO RD",
    "dropmalcty": "SCARBRO",
    "dropmalst": "WV",
    "dropmalzpp": 259179998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044408008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29166",
    "droptype": "D",
    "dropname": "SCOTT DEPOT",
    "dropdeladd": "4909 TEAYS VALLEY RD",
    "dropdelcty": "SCOTT DEPOT",
    "dropdelst": "WV",
    "dropdelzpp": 255601200,
    "dropphyadd": "4909 TEAYS VALLEY RD",
    "dropphycty": "SCOTT DEPOT",
    "dropphyst": "WV",
    "dropphyzpp": 255601200,
    "dropmaladd": "4909 TEAYS VALLEY RD",
    "dropmalcty": "SCOTT DEPOT",
    "dropmalst": "WV",
    "dropmalzpp": 255601200,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047577274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29170",
    "droptype": "D",
    "dropname": "SENECA ROCKS",
    "dropdeladd": "648 ALLEGHENY DR",
    "dropdelcty": "SENECA ROCKS",
    "dropdelst": "WV",
    "dropdelzpp": 268849998,
    "dropphyadd": "648 ALLEGHENY DR",
    "dropphycty": "SENECA ROCKS",
    "dropphyst": "WV",
    "dropphyzpp": 268849998,
    "dropmaladd": "648 ALLEGHENY DR",
    "dropmalcty": "SENECA ROCKS",
    "dropmalst": "WV",
    "dropmalzpp": 268849998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045672902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29172",
    "droptype": "D",
    "dropname": "SETH",
    "dropdeladd": "10117 COAL RIVER RD",
    "dropdelcty": "SETH",
    "dropdelst": "WV",
    "dropdelzpp": 251819998,
    "dropphyadd": "10117 COAL RIVER RD",
    "dropphycty": "SETH",
    "dropphyst": "WV",
    "dropphyzpp": 251819998,
    "dropmaladd": "10117 COAL RIVER RD",
    "dropmalcty": "SETH",
    "dropmalst": "WV",
    "dropmalzpp": 251819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048377843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29173",
    "droptype": "D",
    "dropname": "SHADY SPRING",
    "dropdeladd": "218 HINTON RD",
    "dropdelcty": "SHADY SPRING",
    "dropdelst": "WV",
    "dropdelzpp": 259189998,
    "dropphyadd": "218 HINTON RD",
    "dropphycty": "SHADY SPRING",
    "dropphyst": "WV",
    "dropphyzpp": 259189998,
    "dropmaladd": "218 HINTON RD",
    "dropmalcty": "SHADY SPRING",
    "dropmalst": "WV",
    "dropmalzpp": 259189998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047634941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29174",
    "droptype": "D",
    "dropname": "SHANKS",
    "dropdeladd": "20661 NORTHWESTERN PIKE",
    "dropdelcty": "SHANKS",
    "dropdelst": "WV",
    "dropdelzpp": 267619998,
    "dropphyadd": "20661 NORTHWESTERN PIKE",
    "dropphycty": "SHANKS",
    "dropphyst": "WV",
    "dropphyzpp": 267619998,
    "dropmaladd": "20661 NORTHWESTERN PIKE",
    "dropmalcty": "SHANKS",
    "dropmalst": "WV",
    "dropmalzpp": 267619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044969384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29176",
    "droptype": "D",
    "dropname": "SHARPLES",
    "dropdeladd": "16547 BLAIR MOUNTAIN HWY",
    "dropdelcty": "SHARPLES",
    "dropdelst": "WV",
    "dropdelzpp": 251839998,
    "dropphyadd": "16547 BLAIR MOUNTAIN HWY",
    "dropphycty": "SHARPLES",
    "dropphyst": "WV",
    "dropphyzpp": 251839998,
    "dropmaladd": "16547 BLAIR MOUNTAIN HWY",
    "dropmalcty": "SHARPLES",
    "dropmalst": "WV",
    "dropmalzpp": 251839998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043695761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29177",
    "droptype": "D",
    "dropname": "SHENANDOAH JUNCTION",
    "dropdeladd": "360 1ST ST",
    "dropdelcty": "SHENANDOAH JUNCTION",
    "dropdelst": "WV",
    "dropdelzpp": 254429998,
    "dropphyadd": "360 1ST ST",
    "dropphycty": "SHENANDOAH JUNCTION",
    "dropphyst": "WV",
    "dropphyzpp": 254429998,
    "dropmaladd": "360 1ST ST",
    "dropmalcty": "SHENANDOAH JUNCTION",
    "dropmalst": "WV",
    "dropmalzpp": 254429998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047253907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29178",
    "droptype": "D",
    "dropname": "SHEPHERDSTOWN",
    "dropdeladd": "301 S KING ST",
    "dropdelcty": "SHEPHERDSTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 254439998,
    "dropphyadd": "301 S KING ST",
    "dropphycty": "SHEPHERDSTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 254439998,
    "dropmaladd": "301 S KING ST",
    "dropmalcty": "SHEPHERDSTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 254439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048762370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29180",
    "droptype": "D",
    "dropname": "SHINNSTON",
    "dropdeladd": "1001 HOOD AVE",
    "dropdelcty": "SHINNSTON",
    "dropdelst": "WV",
    "dropdelzpp": 264319998,
    "dropphyadd": "1001 HOOD AVE",
    "dropphycty": "SHINNSTON",
    "dropphyst": "WV",
    "dropphyzpp": 264319998,
    "dropmaladd": "1001 HOOD AVE",
    "dropmalcty": "SHINNSTON",
    "dropmalst": "WV",
    "dropmalzpp": 264319998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044138300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29181",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "3614 MCELROY CREEK RD",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "WV",
    "dropdelzpp": 264349998,
    "dropphyadd": "3614 MCELROY CREEK RD",
    "dropphycty": "SHIRLEY",
    "dropphyst": "WV",
    "dropphyzpp": 264349998,
    "dropmaladd": "3614 MCELROY CREEK RD",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "WV",
    "dropmalzpp": 264349998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047584037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29183",
    "droptype": "D",
    "dropname": "SHOALS",
    "dropdeladd": "3712 ROUTE 75",
    "dropdelcty": "SHOALS",
    "dropdelst": "WV",
    "dropdelzpp": 255629998,
    "dropphyadd": "3712 ROUTE 75",
    "dropphycty": "SHOALS",
    "dropphyst": "WV",
    "dropphyzpp": 255629998,
    "dropmaladd": "3712 ROUTE 75",
    "dropmalcty": "SHOALS",
    "dropmalst": "WV",
    "dropmalzpp": 255629998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045234054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29185",
    "droptype": "D",
    "dropname": "SHORT CREEK",
    "dropdeladd": "46 WINDY HILL RD",
    "dropdelcty": "SHORT CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 260581000,
    "dropphyadd": "46 WINDY HILL RD",
    "dropphycty": "SHORT CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 260581000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHORT CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 260589998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3043945235,
    "dropsitcph": 3043945235,
    "dropfax": 3043945202
  },
  {
    "dcode": "D",
    "dropkey": "PX29190",
    "droptype": "D",
    "dropname": "SIMON",
    "dropdeladd": "714 SIMON RD",
    "dropdelcty": "SIMON",
    "dropdelst": "WV",
    "dropdelzpp": 248829998,
    "dropphyadd": "714 SIMON RD",
    "dropphycty": "SIMON",
    "dropphyst": "WV",
    "dropphyzpp": 248829998,
    "dropmaladd": "714 SIMON RD",
    "dropmalcty": "SIMON",
    "dropmalst": "WV",
    "dropmalzpp": 248829998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046824422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29191",
    "droptype": "D",
    "dropname": "SIMPSON",
    "dropdeladd": "2230 SIMPSON RD",
    "dropdelcty": "SIMPSON",
    "dropdelst": "WV",
    "dropdelzpp": 264359997,
    "dropphyadd": "2230 SIMPSON RD",
    "dropphycty": "SIMPSON",
    "dropphyst": "WV",
    "dropphyzpp": 264359997,
    "dropmaladd": "2230 SIMPSON RD",
    "dropmalcty": "SIMPSON",
    "dropmalst": "WV",
    "dropmalzpp": 264359997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047394917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29192",
    "droptype": "D",
    "dropname": "SINKS GROVE",
    "dropdeladd": "101 FORT SPRINGS RD",
    "dropdelcty": "SINKS GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 249769998,
    "dropphyadd": "101 FORT SPRINGS RD",
    "dropphycty": "SINKS GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 249769998,
    "dropmaladd": "101 FORT SPRINGS RD",
    "dropmalcty": "SINKS GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 249769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047723148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29194",
    "droptype": "D",
    "dropname": "SISTERSVILLE",
    "dropdeladd": "521 WELLS ST",
    "dropdelcty": "SISTERSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261759998,
    "dropphyadd": "521 WELLS ST",
    "dropphycty": "SISTERSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261759998,
    "dropmaladd": "521 WELLS ST",
    "dropmalcty": "SISTERSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261759998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046525111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29196",
    "droptype": "D",
    "dropname": "SKELTON",
    "dropdeladd": "112 BECKLEY PLAZA MALL",
    "dropdelcty": "SKELTON",
    "dropdelst": "WV",
    "dropdelzpp": 259199998,
    "dropphyadd": "112 BECKLEY PLAZA MALL",
    "dropphycty": "SKELTON",
    "dropphyst": "WV",
    "dropphyzpp": 259199998,
    "dropmaladd": "112 BECKLEY PLAZA MALL",
    "dropmalcty": "SKELTON",
    "dropmalst": "WV",
    "dropmalzpp": 259199998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042522494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29200",
    "droptype": "D",
    "dropname": "SLANESVILLE",
    "dropdeladd": "41 SLANESVILLE PIKE",
    "dropdelcty": "SLANESVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 254449998,
    "dropphyadd": "41 SLANESVILLE PIKE",
    "dropphycty": "SLANESVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 254449998,
    "dropmaladd": "41 SLANESVILLE PIKE",
    "dropmalcty": "SLANESVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 254449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044967922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29201",
    "droptype": "D",
    "dropname": "SLATYFORK",
    "dropdeladd": "35161 SENECA TRL",
    "dropdelcty": "SLATYFORK",
    "dropdelst": "WV",
    "dropdelzpp": 262919998,
    "dropphyadd": "35161 SENECA TRL",
    "dropphycty": "SLATYFORK",
    "dropphyst": "WV",
    "dropphyzpp": 262919998,
    "dropmaladd": "35161 SENECA TRL",
    "dropmalcty": "SLATYFORK",
    "dropmalst": "WV",
    "dropmalzpp": 262919998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045721221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29202",
    "droptype": "D",
    "dropname": "SMITHBURG",
    "dropdeladd": "2809 SMITHTON RD",
    "dropdelcty": "SMITHBURG",
    "dropdelst": "WV",
    "dropdelzpp": 264369998,
    "dropphyadd": "2809 SMITHTON RD",
    "dropphycty": "SMITHBURG",
    "dropphyst": "WV",
    "dropphyzpp": 264369998,
    "dropmaladd": "2809 SMITHTON RD",
    "dropmalcty": "SMITHBURG",
    "dropmalst": "WV",
    "dropmalzpp": 264369998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048732026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29203",
    "droptype": "D",
    "dropname": "SMITHERS",
    "dropdeladd": "314 MICHIGAN AVE",
    "dropdelcty": "SMITHERS",
    "dropdelst": "WV",
    "dropdelzpp": 251869998,
    "dropphyadd": "314 MICHIGAN AVE",
    "dropphycty": "SMITHERS",
    "dropphyst": "WV",
    "dropphyzpp": 251869998,
    "dropmaladd": "314 MICHIGAN AVE",
    "dropmalcty": "SMITHERS",
    "dropmalst": "WV",
    "dropmalzpp": 251869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044425494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29204",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "86 MANNINGTON RD",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 264379998,
    "dropphyadd": "86 MANNINGTON RD",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 264379998,
    "dropmaladd": "86 MANNINGTON RD",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 264379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043343172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29205",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "11630 SMITHVILLE RD",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 261789998,
    "dropphyadd": "11630 SMITHVILLE RD",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 261789998,
    "dropmaladd": "11630 SMITHVILLE RD",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 261789998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044773477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29206",
    "droptype": "D",
    "dropname": "SMOOT",
    "dropdeladd": "25 GRASSY MEADOWS RD",
    "dropdelcty": "SMOOT",
    "dropdelst": "WV",
    "dropdelzpp": 249779998,
    "dropphyadd": "25 GRASSY MEADOWS RD",
    "dropphycty": "SMOOT",
    "dropphyst": "WV",
    "dropphyzpp": 249779998,
    "dropmaladd": "25 GRASSY MEADOWS RD",
    "dropmalcty": "SMOOT",
    "dropmalst": "WV",
    "dropmalzpp": 249779998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043925179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29209",
    "droptype": "D",
    "dropname": "SOD",
    "dropdeladd": "2584 GARRETTS BND",
    "dropdelcty": "SOD",
    "dropdelst": "WV",
    "dropdelzpp": 255649998,
    "dropphyadd": "2584 GARRETTS BND",
    "dropphycty": "SOD",
    "dropphyst": "WV",
    "dropphyzpp": 255649998,
    "dropmaladd": "2584 GARRETTS BND",
    "dropmalcty": "SOD",
    "dropmalst": "WV",
    "dropmalzpp": 255649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047563702,
    "dropfax": 3047562532
  },
  {
    "dcode": "D",
    "dropkey": "PX29210",
    "droptype": "D",
    "dropname": "SOPHIA",
    "dropdeladd": "221 RIFFE ST",
    "dropdelcty": "SOPHIA",
    "dropdelst": "WV",
    "dropdelzpp": 259219998,
    "dropphyadd": "221 RIFFE ST",
    "dropphycty": "SOPHIA",
    "dropphyst": "WV",
    "dropphyzpp": 259219998,
    "dropmaladd": "221 RIFFE ST",
    "dropmalcty": "SOPHIA",
    "dropmalst": "WV",
    "dropmalzpp": 259219998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046834575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29214",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "26460 KANAWHA VALLEY RD",
    "dropdelcty": "SOUTHSIDE",
    "dropdelst": "WV",
    "dropdelzpp": 251879998,
    "dropphyadd": "26460 KANAWHA VALLEY RD",
    "dropphycty": "SOUTHSIDE",
    "dropphyst": "WV",
    "dropphyzpp": 251879998,
    "dropmaladd": "26460 KANAWHA VALLEY RD",
    "dropmalcty": "SOUTHSIDE",
    "dropmalst": "WV",
    "dropmalzpp": 251879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046752136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29215",
    "droptype": "D",
    "dropname": "SPANISHBURG",
    "dropdeladd": "8781 BECKLEY RD",
    "dropdelcty": "SPANISHBURG",
    "dropdelst": "WV",
    "dropdelzpp": 259229998,
    "dropphyadd": "8781 BECKLEY RD",
    "dropphycty": "SPANISHBURG",
    "dropphyst": "WV",
    "dropphyzpp": 259229998,
    "dropmaladd": "8781 BECKLEY RD",
    "dropmalcty": "SPANISHBURG",
    "dropmalst": "WV",
    "dropmalzpp": 259229998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044251222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29217",
    "droptype": "D",
    "dropname": "SPELTER",
    "dropdeladd": "24 LEO MENENDEZ DR",
    "dropdelcty": "SPELTER",
    "dropdelst": "WV",
    "dropdelzpp": 264389998,
    "dropphyadd": "24 LEO MENENDEZ DR",
    "dropphycty": "SPELTER",
    "dropphyst": "WV",
    "dropphyzpp": 264389998,
    "dropmaladd": "24 LEO MENENDEZ DR",
    "dropmalcty": "SPELTER",
    "dropmalst": "WV",
    "dropmalzpp": 264389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046234875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29218",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "WV",
    "dropdelzpp": 252769998,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "SPENCER",
    "dropphyst": "WV",
    "dropphyzpp": 252769998,
    "dropmaladd": "110 MAIN ST",
    "dropmalcty": "SPENCER",
    "dropmalst": "WV",
    "dropmalzpp": 252769998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049271860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29221",
    "droptype": "D",
    "dropname": "SPRING DALE",
    "dropdeladd": "5130 SEWELL CREEK RD",
    "dropdelcty": "SPRING DALE",
    "dropdelst": "WV",
    "dropdelzpp": 259869998,
    "dropphyadd": "5130 SEWELL CREEK RD",
    "dropphycty": "SPRING DALE",
    "dropphyst": "WV",
    "dropphyzpp": 259869998,
    "dropmaladd": "5130 SEWELL CREEK RD",
    "dropmalcty": "SPRING DALE",
    "dropmalst": "WV",
    "dropmalzpp": 259869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044847114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29223",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "8485 CUMBERLAND RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 267639998,
    "dropphyadd": "8485 CUMBERLAND RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 267639998,
    "dropmaladd": "8485 CUMBERLAND RD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 267639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048227192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29224",
    "droptype": "D",
    "dropname": "SPURLOCKVILLE",
    "dropdeladd": "3182 BULGER RD",
    "dropdelcty": "SPURLOCKVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 255659998,
    "dropphyadd": "3182 BULGER RD",
    "dropphycty": "SPURLOCKVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 255659998,
    "dropmaladd": "3182 BULGER RD",
    "dropmalcty": "SPURLOCKVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 255659998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045247232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29225",
    "droptype": "D",
    "dropname": "SQUIRE",
    "dropdeladd": "20714 HIGHWAY 16 S",
    "dropdelcty": "SQUIRE",
    "dropdelst": "WV",
    "dropdelzpp": 248849998,
    "dropphyadd": "20714 HIGHWAY 16 S",
    "dropphycty": "SQUIRE",
    "dropphyst": "WV",
    "dropphyzpp": 248849998,
    "dropmaladd": "20714 HIGHWAY 16 S",
    "dropmalcty": "SQUIRE",
    "dropmalst": "WV",
    "dropmalzpp": 248849998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048754771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29226",
    "droptype": "D",
    "dropname": "STANAFORD",
    "dropdeladd": "909 RAGLAND RD",
    "dropdelcty": "STANAFORD",
    "dropdelst": "WV",
    "dropdelzpp": 259279998,
    "dropphyadd": "909 RAGLAND RD",
    "dropphycty": "STANAFORD",
    "dropphyst": "WV",
    "dropphyzpp": 259279998,
    "dropmaladd": "909 RAGLAND RD",
    "dropmalcty": "STANAFORD",
    "dropmalst": "WV",
    "dropmalzpp": 259279998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042555746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29233",
    "droptype": "D",
    "dropname": "STEPHENSON",
    "dropdeladd": "5869 GULF RD",
    "dropdelcty": "STEPHENSON",
    "dropdelst": "WV",
    "dropdelzpp": 259289998,
    "dropphyadd": "5869 GULF RD",
    "dropphycty": "STEPHENSON",
    "dropphyst": "WV",
    "dropphyzpp": 259289998,
    "dropmaladd": "5869 GULF RD",
    "dropmalcty": "STEPHENSON",
    "dropmalst": "WV",
    "dropmalzpp": 259289998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042944078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29236",
    "droptype": "D",
    "dropname": "STOLLINGS",
    "dropdeladd": "768 HANGING ROCK HWY",
    "dropdelcty": "STOLLINGS",
    "dropdelst": "WV",
    "dropdelzpp": 256469998,
    "dropphyadd": "768 HANGING ROCK HWY",
    "dropphycty": "STOLLINGS",
    "dropphyst": "WV",
    "dropphyzpp": 256469998,
    "dropmaladd": "768 HANGING ROCK HWY",
    "dropmalcty": "STOLLINGS",
    "dropmalst": "WV",
    "dropmalzpp": 256469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047529135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29245",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "10565 SUGAR GROVE RD",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 268159998,
    "dropphyadd": "10565 SUGAR GROVE RD",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 268159998,
    "dropmaladd": "10565 SUGAR GROVE RD",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 268159998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042495911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29247",
    "droptype": "D",
    "dropname": "SUMERCO",
    "dropdeladd": "2003 MIDWAY RD",
    "dropdelcty": "SUMERCO",
    "dropdelst": "WV",
    "dropdelzpp": 255679998,
    "dropphyadd": "2003 MIDWAY RD",
    "dropphycty": "SUMERCO",
    "dropphyst": "WV",
    "dropphyzpp": 255679998,
    "dropmaladd": "2003 MIDWAY RD",
    "dropmalcty": "SUMERCO",
    "dropmalst": "WV",
    "dropmalzpp": 255679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045249218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29249",
    "droptype": "D",
    "dropname": "SUMMERSVILLE",
    "dropdeladd": "846 BROAD ST",
    "dropdelcty": "SUMMERSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 266519998,
    "dropphyadd": "846 BROAD ST",
    "dropphycty": "SUMMERSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 266519998,
    "dropmaladd": "846 BROAD ST",
    "dropmalcty": "SUMMERSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 266519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048722381,
    "dropfax": 3048723688
  },
  {
    "dcode": "D",
    "dropkey": "PX29251",
    "droptype": "D",
    "dropname": "SUMMIT POINT",
    "dropdeladd": "117 HAWTHORNE AVE",
    "dropdelcty": "SUMMIT POINT",
    "dropdelst": "WV",
    "dropdelzpp": 254469998,
    "dropphyadd": "117 HAWTHORNE AVE",
    "dropphycty": "SUMMIT POINT",
    "dropphyst": "WV",
    "dropphyzpp": 254469998,
    "dropmaladd": "117 HAWTHORNE AVE",
    "dropmalcty": "SUMMIT POINT",
    "dropmalst": "WV",
    "dropmalzpp": 254469998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047253354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29257",
    "droptype": "D",
    "dropname": "SURVEYOR",
    "dropdeladd": "6429 HARPER RD STE F",
    "dropdelcty": "SURVEYOR",
    "dropdelst": "WV",
    "dropdelzpp": 259329998,
    "dropphyadd": "6429 HARPER RD STE F",
    "dropphycty": "SURVEYOR",
    "dropphyst": "WV",
    "dropphyzpp": 259329998,
    "dropmaladd": "6429 HARPER RD STE F",
    "dropmalcty": "SURVEYOR",
    "dropmalst": "WV",
    "dropmalzpp": 259329998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049346192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29258",
    "droptype": "D",
    "dropname": "SUTTON",
    "dropdeladd": "306 RIVERVIEW DR",
    "dropdelcty": "SUTTON",
    "dropdelst": "WV",
    "dropdelzpp": 266019998,
    "dropphyadd": "306 RIVERVIEW DR",
    "dropphycty": "SUTTON",
    "dropphyst": "WV",
    "dropphyzpp": 266019998,
    "dropmaladd": "306 RIVERVIEW DR",
    "dropmalcty": "SUTTON",
    "dropmalst": "WV",
    "dropmalzpp": 266019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047655225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29261",
    "droptype": "D",
    "dropname": "SWISS",
    "dropdeladd": "20492 TURNPIKE RD",
    "dropdelcty": "SWISS",
    "dropdelst": "WV",
    "dropdelzpp": 266909998,
    "dropphyadd": "20492 TURNPIKE RD",
    "dropphycty": "SWISS",
    "dropphyst": "WV",
    "dropphyzpp": 266909998,
    "dropmaladd": "20492 TURNPIKE RD",
    "dropmalcty": "SWISS",
    "dropmalst": "WV",
    "dropmalzpp": 266909998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046321238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29262",
    "droptype": "D",
    "dropname": "SWITCHBACK",
    "dropdeladd": "322 POWERHOUSE RD",
    "dropdelcty": "SWITCHBACK",
    "dropdelst": "WV",
    "dropdelzpp": 248879998,
    "dropphyadd": "322 POWERHOUSE RD",
    "dropphycty": "SWITCHBACK",
    "dropphyst": "WV",
    "dropphyzpp": 248879998,
    "dropmaladd": "322 POWERHOUSE RD",
    "dropmalcty": "SWITCHBACK",
    "dropmalst": "WV",
    "dropmalzpp": 248879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048272120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29263",
    "droptype": "D",
    "dropname": "SWITZER",
    "dropdeladd": "5468 JERRY WEST HWY",
    "dropdelcty": "SWITZER",
    "dropdelst": "WV",
    "dropdelzpp": 256479998,
    "dropphyadd": "5468 JERRY WEST HWY",
    "dropphycty": "SWITZER",
    "dropphyst": "WV",
    "dropphyzpp": 256479998,
    "dropmaladd": "5468 JERRY WEST HWY",
    "dropmalcty": "SWITZER",
    "dropmalst": "WV",
    "dropmalzpp": 256479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049464610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29265",
    "droptype": "D",
    "dropname": "SYLVESTER",
    "dropdeladd": "32832 COAL RIVER RD",
    "dropdelcty": "SYLVESTER",
    "dropdelst": "WV",
    "dropdelzpp": 251939998,
    "dropphyadd": "32832 COAL RIVER RD",
    "dropphycty": "SYLVESTER",
    "dropphyst": "WV",
    "dropphyzpp": 251939998,
    "dropmaladd": "32832 COAL RIVER RD",
    "dropmalcty": "SYLVESTER",
    "dropmalst": "WV",
    "dropmalzpp": 251939998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048542218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29266",
    "droptype": "D",
    "dropname": "TAD",
    "dropdeladd": "75 PATTERSON DR",
    "dropdelcty": "TAD",
    "dropdelst": "WV",
    "dropdelzpp": 252019998,
    "dropphyadd": "75 PATTERSON DR",
    "dropphycty": "TAD",
    "dropphyst": "WV",
    "dropphyzpp": 252019998,
    "dropmaladd": "75 PATTERSON DR",
    "dropmalcty": "TAD",
    "dropmalst": "WV",
    "dropmalzpp": 252019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047202220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29267",
    "droptype": "D",
    "dropname": "TALCOTT",
    "dropdeladd": "3685 SR 3 AND 12",
    "dropdelcty": "TALCOTT",
    "dropdelst": "WV",
    "dropdelzpp": 249819998,
    "dropphyadd": "3685 SR 3 AND 12",
    "dropphycty": "TALCOTT",
    "dropphyst": "WV",
    "dropphyzpp": 249819998,
    "dropmaladd": "3685 SR 3 AND 12",
    "dropmalcty": "TALCOTT",
    "dropmalst": "WV",
    "dropmalzpp": 249819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044663640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29268",
    "droptype": "D",
    "dropname": "TALLMANSVILLE",
    "dropdeladd": "6376 TALLMANSVILLE RD",
    "dropdelcty": "TALLMANSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 262379998,
    "dropphyadd": "6376 TALLMANSVILLE RD",
    "dropphycty": "TALLMANSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 262379998,
    "dropmaladd": "6376 TALLMANSVILLE RD",
    "dropmalcty": "TALLMANSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 262379998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044727462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29274",
    "droptype": "D",
    "dropname": "TEAYS",
    "dropdeladd": "31 PUTNAM VILLAGE SHOPPING CTR",
    "dropdelcty": "TEAYS",
    "dropdelst": "WV",
    "dropdelzpp": 255699998,
    "dropphyadd": "31 PUTNAM VILLAGE SHOPPING CTR",
    "dropphycty": "TEAYS",
    "dropphyst": "WV",
    "dropphyzpp": 255699998,
    "dropmaladd": "31 PUTNAM VILLAGE SHOPPING CTR",
    "dropmalcty": "TEAYS",
    "dropmalst": "WV",
    "dropmalzpp": 255699998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047576137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29276",
    "droptype": "D",
    "dropname": "TERRA ALTA",
    "dropdeladd": "103 N 4TH ST",
    "dropdelcty": "TERRA ALTA",
    "dropdelst": "WV",
    "dropdelzpp": 267649998,
    "dropphyadd": "103 N 4TH ST",
    "dropphycty": "TERRA ALTA",
    "dropphyst": "WV",
    "dropphyzpp": 267649998,
    "dropmaladd": "103 N 4TH ST",
    "dropmalcty": "TERRA ALTA",
    "dropmalst": "WV",
    "dropmalzpp": 267649998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047184700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29281",
    "droptype": "D",
    "dropname": "THOMAS",
    "dropdeladd": "51 EAST AVE",
    "dropdelcty": "THOMAS",
    "dropdelst": "WV",
    "dropdelzpp": 262929998,
    "dropphyadd": "51 EAST AVE",
    "dropphycty": "THOMAS",
    "dropphyst": "WV",
    "dropphyzpp": 262929998,
    "dropmaladd": "51 EAST AVE",
    "dropmalcty": "THOMAS",
    "dropmalst": "WV",
    "dropmalzpp": 262929998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044634163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29282",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "3990 THORTON PIKE",
    "dropdelcty": "THORNTON",
    "dropdelst": "WV",
    "dropdelzpp": 264409998,
    "dropphyadd": "3990 THORTON PIKE",
    "dropphycty": "THORNTON",
    "dropphyst": "WV",
    "dropphyzpp": 264409998,
    "dropmaladd": "3990 THORTON PIKE",
    "dropmalcty": "THORNTON",
    "dropmalst": "WV",
    "dropmalzpp": 264409998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042654591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29283",
    "droptype": "D",
    "dropname": "THORPE",
    "dropdeladd": "28 HOLIDAY BRANCH RD",
    "dropdelcty": "THORPE",
    "dropdelst": "WV",
    "dropdelzpp": 248889998,
    "dropphyadd": "28 HOLIDAY BRANCH RD",
    "dropphycty": "THORPE",
    "dropphyst": "WV",
    "dropphyzpp": 248889998,
    "dropmaladd": "28 HOLIDAY BRANCH RD",
    "dropmalcty": "THORPE",
    "dropmalst": "WV",
    "dropmalzpp": 248889998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044483456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29287",
    "droptype": "D",
    "dropname": "TIOGA",
    "dropdeladd": "108 CULLER RD",
    "dropdelcty": "TIOGA",
    "dropdelst": "WV",
    "dropdelzpp": 266919998,
    "dropphyadd": "108 CULLER RD",
    "dropphycty": "TIOGA",
    "dropphyst": "WV",
    "dropphyzpp": 266919998,
    "dropmaladd": "108 CULLER RD",
    "dropmalcty": "TIOGA",
    "dropmalst": "WV",
    "dropmalzpp": 266919998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047425223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29290",
    "droptype": "D",
    "dropname": "TORNADO",
    "dropdeladd": "7920 COAL RIVER RD",
    "dropdelcty": "TORNADO",
    "dropdelst": "WV",
    "dropdelzpp": 252029998,
    "dropphyadd": "7920 COAL RIVER RD",
    "dropphycty": "TORNADO",
    "dropphyst": "WV",
    "dropphyzpp": 252029998,
    "dropmaladd": "7920 COAL RIVER RD",
    "dropmalcty": "TORNADO",
    "dropmalst": "WV",
    "dropmalzpp": 252029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047225361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29293",
    "droptype": "D",
    "dropname": "TRIADELPHIA",
    "dropdeladd": "4317 NATIONAL RD",
    "dropdelcty": "TRIADELPHIA",
    "dropdelst": "WV",
    "dropdelzpp": 260599998,
    "dropphyadd": "4317 NATIONAL RD",
    "dropphycty": "TRIADELPHIA",
    "dropphyst": "WV",
    "dropphyzpp": 260599998,
    "dropmaladd": "4317 NATIONAL RD",
    "dropmalcty": "TRIADELPHIA",
    "dropmalst": "WV",
    "dropmalzpp": 260599998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3045475125,
    "dropsitcph": 3045475125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29295",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "3055 WV HIGHWAY 47 W",
    "dropdelcty": "TROY",
    "dropdelst": "WV",
    "dropdelzpp": 264439998,
    "dropphyadd": "3055 WV HIGHWAY 47 W",
    "dropphycty": "TROY",
    "dropphyst": "WV",
    "dropphyzpp": 264439998,
    "dropmaladd": "3055 WV HIGHWAY 47 W",
    "dropmalcty": "TROY",
    "dropmalst": "WV",
    "dropmalzpp": 264439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044627210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29297",
    "droptype": "D",
    "dropname": "TUNNELTON",
    "dropdeladd": "24 BANK ST",
    "dropdelcty": "TUNNELTON",
    "dropdelst": "WV",
    "dropdelzpp": 264449998,
    "dropphyadd": "24 BANK ST",
    "dropphycty": "TUNNELTON",
    "dropphyst": "WV",
    "dropphyzpp": 264449998,
    "dropmaladd": "24 BANK ST",
    "dropmalcty": "TUNNELTON",
    "dropmalst": "WV",
    "dropmalzpp": 264449998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045682644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29298",
    "droptype": "D",
    "dropname": "TURTLE CREEK",
    "dropdeladd": "83 OAKMONT DR",
    "dropdelcty": "TURTLE CREEK",
    "dropdelst": "WV",
    "dropdelzpp": 252039998,
    "dropphyadd": "83 OAKMONT DR",
    "dropphycty": "TURTLE CREEK",
    "dropphyst": "WV",
    "dropphyzpp": 252039998,
    "dropmaladd": "83 OAKMONT DR",
    "dropmalcty": "TURTLE CREEK",
    "dropmalst": "WV",
    "dropmalzpp": 252039998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043694718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29299",
    "droptype": "D",
    "dropname": "TWILIGHT",
    "dropdeladd": "71 POST OFFICE RD",
    "dropdelcty": "TWILIGHT",
    "dropdelst": "WV",
    "dropdelzpp": 252049998,
    "dropphyadd": "71 POST OFFICE RD",
    "dropphycty": "TWILIGHT",
    "dropphyst": "WV",
    "dropphyzpp": 252049998,
    "dropmaladd": "71 POST OFFICE RD",
    "dropmalcty": "TWILIGHT",
    "dropmalst": "WV",
    "dropmalzpp": 252049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042458348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29304",
    "droptype": "D",
    "dropname": "UNEEDA",
    "dropdeladd": "2140 POND FORK RD",
    "dropdelcty": "UNEEDA",
    "dropdelst": "WV",
    "dropdelzpp": 252059998,
    "dropphyadd": "2140 POND FORK RD",
    "dropphycty": "UNEEDA",
    "dropphyst": "WV",
    "dropphyzpp": 252059998,
    "dropmaladd": "2140 POND FORK RD",
    "dropmalcty": "UNEEDA",
    "dropmalst": "WV",
    "dropmalzpp": 252059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043695889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29306",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "1 MIDDLE ST",
    "dropdelcty": "UNION",
    "dropdelst": "WV",
    "dropdelzpp": 249839998,
    "dropphyadd": "1 MIDDLE ST",
    "dropphycty": "UNION",
    "dropphyst": "WV",
    "dropphyzpp": 249839998,
    "dropmaladd": "1 MIDDLE ST",
    "dropmalcty": "UNION",
    "dropmalst": "WV",
    "dropmalzpp": 249839998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047723028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29308",
    "droptype": "D",
    "dropname": "UPPER TRACT",
    "dropdeladd": "11477 PETERSBURG PIKE",
    "dropdelcty": "UPPER TRACT",
    "dropdelst": "WV",
    "dropdelzpp": 268669998,
    "dropphyadd": "11477 PETERSBURG PIKE",
    "dropphycty": "UPPER TRACT",
    "dropphyst": "WV",
    "dropphyzpp": 268669998,
    "dropmaladd": "11477 PETERSBURG PIKE",
    "dropmalcty": "UPPER TRACT",
    "dropmalst": "WV",
    "dropmalzpp": 268669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043587638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29309",
    "droptype": "D",
    "dropname": "UPPERGLADE",
    "dropdeladd": "85 PLEASANT RIDGE RD",
    "dropdelcty": "UPPERGLADE",
    "dropdelst": "WV",
    "dropdelzpp": 262669998,
    "dropphyadd": "85 PLEASANT RIDGE RD",
    "dropphycty": "UPPERGLADE",
    "dropphyst": "WV",
    "dropphyzpp": 262669998,
    "dropmaladd": "85 PLEASANT RIDGE RD",
    "dropmalcty": "UPPERGLADE",
    "dropmalst": "WV",
    "dropmalzpp": 262669998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042265760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29312",
    "droptype": "D",
    "dropname": "VALLEY BEND",
    "dropdeladd": "5934 SENECA TRL",
    "dropdelcty": "VALLEY BEND",
    "dropdelst": "WV",
    "dropdelzpp": 262939998,
    "dropphyadd": "5934 SENECA TRL",
    "dropphycty": "VALLEY BEND",
    "dropphyst": "WV",
    "dropphyzpp": 262939998,
    "dropmaladd": "5934 SENECA TRL",
    "dropmalcty": "VALLEY BEND",
    "dropmalst": "WV",
    "dropmalzpp": 262939998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043384783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29315",
    "droptype": "D",
    "dropname": "VALLEY GROVE",
    "dropdeladd": "8566 NATIONAL RD",
    "dropdelcty": "VALLEY GROVE",
    "dropdelst": "WV",
    "dropdelzpp": 260602901,
    "dropphyadd": "8566 NATIONAL RD",
    "dropphycty": "VALLEY GROVE",
    "dropphyst": "WV",
    "dropphyzpp": 260602901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALLEY GROVE",
    "dropmalst": "WV",
    "dropmalzpp": 260609998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3045479230,
    "dropsitcph": 3045479230,
    "dropfax": 3045479230
  },
  {
    "dcode": "D",
    "dropkey": "PX29316",
    "droptype": "D",
    "dropname": "VALLEY HEAD",
    "dropdeladd": "25232 SENECA TRL",
    "dropdelcty": "VALLEY HEAD",
    "dropdelst": "WV",
    "dropdelzpp": 262949998,
    "dropphyadd": "25232 SENECA TRL",
    "dropphycty": "VALLEY HEAD",
    "dropphyst": "WV",
    "dropphyzpp": 262949998,
    "dropmaladd": "25232 SENECA TRL",
    "dropmalcty": "VALLEY HEAD",
    "dropmalst": "WV",
    "dropmalzpp": 262949998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043394419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29318",
    "droptype": "D",
    "dropname": "VAN",
    "dropdeladd": "20042 POND FORK RD",
    "dropdelcty": "VAN",
    "dropdelst": "WV",
    "dropdelzpp": 252069998,
    "dropphyadd": "20042 POND FORK RD",
    "dropphycty": "VAN",
    "dropphyst": "WV",
    "dropphyzpp": 252069998,
    "dropmaladd": "20042 POND FORK RD",
    "dropmalcty": "VAN",
    "dropmalst": "WV",
    "dropmalzpp": 252069998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042458969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29319",
    "droptype": "D",
    "dropname": "VARNEY",
    "dropdeladd": "1135 RA WEST HWY",
    "dropdelcty": "VARNEY",
    "dropdelst": "WV",
    "dropdelzpp": 256969998,
    "dropphyadd": "1135 RA WEST HWY",
    "dropphycty": "VARNEY",
    "dropphyst": "WV",
    "dropphyzpp": 256969998,
    "dropmaladd": "1135 RA WEST HWY",
    "dropmalcty": "VARNEY",
    "dropmalst": "WV",
    "dropmalzpp": 256969998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044264212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29320",
    "droptype": "D",
    "dropname": "VERDUNVILLE",
    "dropdeladd": "2571 MUD FORK RD",
    "dropdelcty": "VERDUNVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 256499998,
    "dropphyadd": "2571 MUD FORK RD",
    "dropphycty": "VERDUNVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 256499998,
    "dropmaladd": "2571 MUD FORK RD",
    "dropmalcty": "VERDUNVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 256499998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047520217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29321",
    "droptype": "D",
    "dropname": "VERNER",
    "dropdeladd": "6151 RT 80",
    "dropdelcty": "VERNER",
    "dropdelst": "WV",
    "dropdelzpp": 256509998,
    "dropphyadd": "6151 RT 80",
    "dropphycty": "VERNER",
    "dropphyst": "WV",
    "dropphyzpp": 256509998,
    "dropmaladd": "6151 RT 80",
    "dropmalcty": "VERNER",
    "dropmalst": "WV",
    "dropmalzpp": 256509998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046643538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29322",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "21313 MIDLAND TRL",
    "dropdelcty": "VICTOR",
    "dropdelst": "WV",
    "dropdelzpp": 259389998,
    "dropphyadd": "21313 MIDLAND TRL",
    "dropphycty": "VICTOR",
    "dropphyst": "WV",
    "dropphyzpp": 259389998,
    "dropmaladd": "21313 MIDLAND TRL",
    "dropmalcty": "VICTOR",
    "dropmalst": "WV",
    "dropmalzpp": 259389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046584669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29325",
    "droptype": "D",
    "dropname": "VOLGA",
    "dropdeladd": "14271 AUDRA PARK RD",
    "dropdelcty": "VOLGA",
    "dropdelst": "WV",
    "dropdelzpp": 262389998,
    "dropphyadd": "14271 AUDRA PARK RD",
    "dropphycty": "VOLGA",
    "dropphyst": "WV",
    "dropphyzpp": 262389998,
    "dropmaladd": "14271 AUDRA PARK RD",
    "dropmalcty": "VOLGA",
    "dropmalst": "WV",
    "dropmalzpp": 262389998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044571820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29330",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "3928 WALKER RD",
    "dropdelcty": "WALKER",
    "dropdelst": "WV",
    "dropdelzpp": 261809998,
    "dropphyadd": "3928 WALKER RD",
    "dropphycty": "WALKER",
    "dropphyst": "WV",
    "dropphyzpp": 261809998,
    "dropmaladd": "3928 WALKER RD",
    "dropmalcty": "WALKER",
    "dropmalst": "WV",
    "dropmalzpp": 261809998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046793931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29331",
    "droptype": "D",
    "dropname": "WALKERSVILLE",
    "dropdeladd": "16957 US HIGHWAY 19 S",
    "dropdelcty": "WALKERSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 264479998,
    "dropphyadd": "16957 US HIGHWAY 19 S",
    "dropphycty": "WALKERSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 264479998,
    "dropmaladd": "16957 US HIGHWAY 19 S",
    "dropmalcty": "WALKERSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 264479998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044528780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29332",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "7737 WALLACE PIKE",
    "dropdelcty": "WALLACE",
    "dropdelst": "WV",
    "dropdelzpp": 264489998,
    "dropphyadd": "7737 WALLACE PIKE",
    "dropphycty": "WALLACE",
    "dropphyst": "WV",
    "dropphyzpp": 264489998,
    "dropmaladd": "7737 WALLACE PIKE",
    "dropmalcty": "WALLACE",
    "dropmalst": "WV",
    "dropmalzpp": 264489998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047964616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29333",
    "droptype": "D",
    "dropname": "WALLBACK",
    "dropdeladd": "6284 WALLBACK RD",
    "dropdelcty": "WALLBACK",
    "dropdelst": "WV",
    "dropdelzpp": 252859998,
    "dropphyadd": "6284 WALLBACK RD",
    "dropphycty": "WALLBACK",
    "dropphyst": "WV",
    "dropphyzpp": 252859998,
    "dropmaladd": "6284 WALLBACK RD",
    "dropmalcty": "WALLBACK",
    "dropmalst": "WV",
    "dropmalzpp": 252859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045872700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29334",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "30 RIVER RD",
    "dropdelcty": "WALTON",
    "dropdelst": "WV",
    "dropdelzpp": 252869998,
    "dropphyadd": "30 RIVER RD",
    "dropphycty": "WALTON",
    "dropphyst": "WV",
    "dropphyzpp": 252869998,
    "dropmaladd": "30 RIVER RD",
    "dropmalcty": "WALTON",
    "dropmalst": "WV",
    "dropmalzpp": 252869998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045776746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29335",
    "droptype": "D",
    "dropname": "WANA",
    "dropdeladd": "8468 MASON DIXON HWY",
    "dropdelcty": "WANA",
    "dropdelst": "WV",
    "dropdelzpp": 265909998,
    "dropphyadd": "8468 MASON DIXON HWY",
    "dropphycty": "WANA",
    "dropphyst": "WV",
    "dropphyzpp": 265909998,
    "dropmaladd": "8468 MASON DIXON HWY",
    "dropmalcty": "WANA",
    "dropmalst": "WV",
    "dropmalzpp": 265909998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046626377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29337",
    "droptype": "D",
    "dropname": "WAR",
    "dropdeladd": "14175 ROCKET BOYS DR",
    "dropdelcty": "WAR",
    "dropdelst": "WV",
    "dropdelzpp": 248929998,
    "dropphyadd": "14175 ROCKET BOYS DR",
    "dropphycty": "WAR",
    "dropphyst": "WV",
    "dropphyzpp": 248929998,
    "dropmaladd": "14175 ROCKET BOYS DR",
    "dropmalcty": "WAR",
    "dropmalst": "WV",
    "dropmalzpp": 248929998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044360288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29339",
    "droptype": "D",
    "dropname": "WARDENSVILLE",
    "dropdeladd": "5 W MAIN ST",
    "dropdelcty": "WARDENSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 268519998,
    "dropphyadd": "5 W MAIN ST",
    "dropphycty": "WARDENSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 268519998,
    "dropmaladd": "5 W MAIN ST",
    "dropmalcty": "WARDENSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 268519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 6816420735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29340",
    "droptype": "D",
    "dropname": "WARRIORMINE",
    "dropdeladd": "245 WAR CREEK DR",
    "dropdelcty": "WARRIORMINE",
    "dropdelst": "WV",
    "dropdelzpp": 248949998,
    "dropphyadd": "245 WAR CREEK DR",
    "dropphycty": "WARRIORMINE",
    "dropphyst": "WV",
    "dropphyzpp": 248949998,
    "dropmaladd": "245 WAR CREEK DR",
    "dropmalcty": "WARRIORMINE",
    "dropmalst": "WV",
    "dropmalzpp": 248949998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048754455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29343",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "8791 DUPONT RD",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 261819998,
    "dropphyadd": "8791 DUPONT RD",
    "dropphycty": "WASHINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 261819998,
    "dropmaladd": "8791 DUPONT RD",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 261819998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048633359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29345",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "64 WAVERLY ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "WV",
    "dropdelzpp": 261849998,
    "dropphyadd": "64 WAVERLY ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "WV",
    "dropphyzpp": 261849998,
    "dropmaladd": "64 WAVERLY ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "WV",
    "dropmalzpp": 261849998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044645131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29346",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "218 KEYSER ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "WV",
    "dropdelzpp": 255709998,
    "dropphyadd": "218 KEYSER ST",
    "dropphycty": "WAYNE",
    "dropphyst": "WV",
    "dropphyzpp": 255709998,
    "dropmaladd": "218 KEYSER ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "WV",
    "dropmalzpp": 255709998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042723383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29347",
    "droptype": "D",
    "dropname": "WAYSIDE",
    "dropdeladd": "18 WAYSIDE TALCOTT RD",
    "dropdelcty": "WAYSIDE",
    "dropdelst": "WV",
    "dropdelzpp": 249859998,
    "dropphyadd": "18 WAYSIDE TALCOTT RD",
    "dropphycty": "WAYSIDE",
    "dropphyst": "WV",
    "dropphyzpp": 249859998,
    "dropmaladd": "18 WAYSIDE TALCOTT RD",
    "dropmalcty": "WAYSIDE",
    "dropmalst": "WV",
    "dropmalzpp": 249859998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048326081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29348",
    "droptype": "D",
    "dropname": "WEBSTER SPRINGS",
    "dropdeladd": "100 BACK FORK ST",
    "dropdelcty": "WEBSTER SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 262889998,
    "dropphyadd": "100 BACK FORK ST",
    "dropphycty": "WEBSTER SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 262889998,
    "dropmaladd": "100 BACK FORK ST",
    "dropmalcty": "WEBSTER SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 262889998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048472424,
    "dropfax": 3048477158
  },
  {
    "dcode": "D",
    "dropkey": "PX29349",
    "droptype": "D",
    "dropname": "WEIRTON",
    "dropdeladd": "317 PENCO RD",
    "dropdelcty": "WEIRTON",
    "dropdelst": "WV",
    "dropdelzpp": 260629998,
    "dropphyadd": "317 PENCO RD",
    "dropphycty": "WEIRTON",
    "dropphyst": "WV",
    "dropphyzpp": 260629998,
    "dropmaladd": "317 PENCO RD",
    "dropmalcty": "WEIRTON",
    "dropmalst": "WV",
    "dropmalzpp": 260629998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3047236795,
    "dropsitcph": 3047236795,
    "dropfax": 3047235218
  },
  {
    "dcode": "D",
    "dropkey": "PX29350",
    "droptype": "D",
    "dropname": "WELCH",
    "dropdeladd": "9 MCDOWELL ST",
    "dropdelcty": "WELCH",
    "dropdelst": "WV",
    "dropdelzpp": 248019998,
    "dropphyadd": "9 MCDOWELL ST",
    "dropphycty": "WELCH",
    "dropphyst": "WV",
    "dropphyzpp": 248019998,
    "dropmaladd": "9 MCDOWELL ST",
    "dropmalcty": "WELCH",
    "dropmalst": "WV",
    "dropmalzpp": 248019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044363323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29351",
    "droptype": "D",
    "dropname": "WELLSBURG",
    "dropdeladd": "944 CHARLES ST",
    "dropdelcty": "WELLSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 260709998,
    "dropphyadd": "944 CHARLES ST",
    "dropphycty": "WELLSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 260709998,
    "dropmaladd": "944 CHARLES ST",
    "dropmalcty": "WELLSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 260709998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3047374277,
    "dropsitcph": 3047374277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29353",
    "droptype": "D",
    "dropname": "WEST COLUMBIA",
    "dropdeladd": "17404 OHIO RIVER RD",
    "dropdelcty": "WEST COLUMBIA",
    "dropdelst": "WV",
    "dropdelzpp": 252879998,
    "dropphyadd": "17404 OHIO RIVER RD",
    "dropphycty": "WEST COLUMBIA",
    "dropphyst": "WV",
    "dropphyzpp": 252879998,
    "dropmaladd": "17404 OHIO RIVER RD",
    "dropmalcty": "WEST COLUMBIA",
    "dropmalst": "WV",
    "dropmalzpp": 252879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047739150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29356",
    "droptype": "D",
    "dropname": "WEST HAMLIN",
    "dropdeladd": "6017 MCCLELLAN HWY",
    "dropdelcty": "WEST HAMLIN",
    "dropdelst": "WV",
    "dropdelzpp": 255719998,
    "dropphyadd": "6017 MCCLELLAN HWY",
    "dropphycty": "WEST HAMLIN",
    "dropphyst": "WV",
    "dropphyzpp": 255719998,
    "dropmaladd": "6017 MCCLELLAN HWY",
    "dropmalcty": "WEST HAMLIN",
    "dropmalst": "WV",
    "dropmalzpp": 255719998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048247477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29360",
    "droptype": "D",
    "dropname": "WEST MILFORD",
    "dropdeladd": "681 MAIN ST",
    "dropdelcty": "WEST MILFORD",
    "dropdelst": "WV",
    "dropdelzpp": 264519998,
    "dropphyadd": "681 MAIN ST",
    "dropphycty": "WEST MILFORD",
    "dropphyst": "WV",
    "dropphyzpp": 264519998,
    "dropmaladd": "681 MAIN ST",
    "dropmalcty": "WEST MILFORD",
    "dropmalst": "WV",
    "dropmalzpp": 264519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047455106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29361",
    "droptype": "D",
    "dropname": "WEST UNION",
    "dropdeladd": "106 COTTAGE AVE",
    "dropdelcty": "WEST UNION",
    "dropdelst": "WV",
    "dropdelzpp": 264569998,
    "dropphyadd": "106 COTTAGE AVE",
    "dropphycty": "WEST UNION",
    "dropphyst": "WV",
    "dropphyzpp": 264569998,
    "dropmaladd": "106 COTTAGE AVE",
    "dropmalcty": "WEST UNION",
    "dropmalst": "WV",
    "dropmalzpp": 264569998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048732000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29362",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "119 CENTER AVE",
    "dropdelcty": "WESTON",
    "dropdelst": "WV",
    "dropdelzpp": 264529998,
    "dropphyadd": "119 CENTER AVE",
    "dropphycty": "WESTON",
    "dropphyst": "WV",
    "dropphyzpp": 264529998,
    "dropmaladd": "119 CENTER AVE",
    "dropmalcty": "WESTON",
    "dropmalst": "WV",
    "dropmalzpp": 264529998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042691475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29364",
    "droptype": "D",
    "dropname": "WHARNCLIFFE",
    "dropdeladd": "261 LEFT FORK BEN CRK",
    "dropdelcty": "WHARNCLIFFE",
    "dropdelst": "WV",
    "dropdelzpp": 256519998,
    "dropphyadd": "261 LEFT FORK BEN CRK",
    "dropphycty": "WHARNCLIFFE",
    "dropphyst": "WV",
    "dropphyzpp": 256519998,
    "dropmaladd": "261 LEFT FORK BEN CRK",
    "dropmalcty": "WHARNCLIFFE",
    "dropmalst": "WV",
    "dropmalzpp": 256519998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046643326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29365",
    "droptype": "D",
    "dropname": "WHARTON",
    "dropdeladd": "35665 POND FORK RD",
    "dropdelcty": "WHARTON",
    "dropdelst": "WV",
    "dropdelzpp": 252089998,
    "dropphyadd": "35665 POND FORK RD",
    "dropphycty": "WHARTON",
    "dropphyst": "WV",
    "dropphyzpp": 252089998,
    "dropmaladd": "35665 POND FORK RD",
    "dropmalcty": "WHARTON",
    "dropmalst": "WV",
    "dropmalzpp": 252089998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042476694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29367",
    "droptype": "D",
    "dropname": "WHEELING",
    "dropdeladd": "2501 CHAPLINE ST",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260039998,
    "dropphyadd": "2501 CHAPLINE ST",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260039998,
    "dropmaladd": "2501 CHAPLINE ST",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260039998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042324850,
    "dropsitcph": 3042333912,
    "dropfax": 3042320084
  },
  {
    "dcode": "D",
    "dropkey": "PX29370",
    "droptype": "D",
    "dropname": "WHITE OAK",
    "dropdeladd": "809 HINTON RD",
    "dropdelcty": "WHITE OAK",
    "dropdelst": "WV",
    "dropdelzpp": 259899998,
    "dropphyadd": "809 HINTON RD",
    "dropphycty": "WHITE OAK",
    "dropphyst": "WV",
    "dropphyzpp": 259899998,
    "dropmaladd": "809 HINTON RD",
    "dropmalcty": "WHITE OAK",
    "dropmalst": "WV",
    "dropmalzpp": 259899998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047634307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29371",
    "droptype": "D",
    "dropname": "WHITE SULPHUR SPRINGS",
    "dropdeladd": "857 MAIN ST E",
    "dropdelcty": "WHITE SULPHUR SPRINGS",
    "dropdelst": "WV",
    "dropdelzpp": 249869997,
    "dropphyadd": "857 MAIN ST E",
    "dropphycty": "WHITE SULPHUR SPRINGS",
    "dropphyst": "WV",
    "dropphyzpp": 249869997,
    "dropmaladd": "857 MAIN ST E",
    "dropmalcty": "WHITE SULPHUR SPRINGS",
    "dropmalst": "WV",
    "dropmalzpp": 249869997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045362581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29372",
    "droptype": "D",
    "dropname": "WHITESVILLE",
    "dropdeladd": "157 LEWIS ST",
    "dropdelcty": "WHITESVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 252099998,
    "dropphyadd": "157 LEWIS ST",
    "dropphycty": "WHITESVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 252099998,
    "dropmaladd": "157 LEWIS ST",
    "dropmalcty": "WHITESVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 252099998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048541831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29373",
    "droptype": "D",
    "dropname": "WHITMAN",
    "dropdeladd": "1125 WHITMAN CREEK RD",
    "dropdelcty": "WHITMAN",
    "dropdelst": "WV",
    "dropdelzpp": 256529998,
    "dropphyadd": "1125 WHITMAN CREEK RD",
    "dropphycty": "WHITMAN",
    "dropphyst": "WV",
    "dropphyzpp": 256529998,
    "dropmaladd": "1125 WHITMAN CREEK RD",
    "dropmalcty": "WHITMAN",
    "dropmalst": "WV",
    "dropmalzpp": 256529998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042393215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29378",
    "droptype": "D",
    "dropname": "WIDEN",
    "dropdeladd": "522 KANAWHA ST",
    "dropdelcty": "WIDEN",
    "dropdelst": "WV",
    "dropdelzpp": 252115000,
    "dropphyadd": "522 KANAWHA ST",
    "dropphycty": "WIDEN",
    "dropphyst": "WV",
    "dropphyzpp": 252115000,
    "dropmaladd": "522 KANAWHA ST",
    "dropmalcty": "WIDEN",
    "dropmalst": "WV",
    "dropmalzpp": 252115000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043325277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29381",
    "droptype": "D",
    "dropname": "WILCOE",
    "dropdeladd": "57 POSTAL LN",
    "dropdelcty": "WILCOE",
    "dropdelst": "WV",
    "dropdelzpp": 248959998,
    "dropphyadd": "57 POSTAL LN",
    "dropphycty": "WILCOE",
    "dropphyst": "WV",
    "dropphyzpp": 248959998,
    "dropmaladd": "57 POSTAL LN",
    "dropmalcty": "WILCOE",
    "dropmalst": "WV",
    "dropmalzpp": 248959998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044483213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29383",
    "droptype": "D",
    "dropname": "WILEY FORD",
    "dropdeladd": "50 SPRINGFIELD ST",
    "dropdelcty": "WILEY FORD",
    "dropdelst": "WV",
    "dropdelzpp": 267679998,
    "dropphyadd": "50 SPRINGFIELD ST",
    "dropphycty": "WILEY FORD",
    "dropphyst": "WV",
    "dropphyzpp": 267679998,
    "dropmaladd": "50 SPRINGFIELD ST",
    "dropmalcty": "WILEY FORD",
    "dropmalst": "WV",
    "dropmalzpp": 267679998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047382100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29385",
    "droptype": "D",
    "dropname": "WILKINSON",
    "dropdeladd": "1604 JERRY WEST HWY",
    "dropdelcty": "WILKINSON",
    "dropdelst": "WV",
    "dropdelzpp": 256539998,
    "dropphyadd": "1604 JERRY WEST HWY",
    "dropphycty": "WILKINSON",
    "dropphyst": "WV",
    "dropphyzpp": 256539998,
    "dropmaladd": "1604 JERRY WEST HWY",
    "dropmalcty": "WILKINSON",
    "dropmalst": "WV",
    "dropmalzpp": 256539998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047520245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29387",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "7014 SHOESTRING TRL",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 249915001,
    "dropphyadd": "7014 SHOESTRING TRL",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 249915001,
    "dropmaladd": "7014 SHOESTRING TRL",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 249915001,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3046457695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29388",
    "droptype": "D",
    "dropname": "WILLIAMSON",
    "dropdeladd": "2 W 2ND AVE FL 1",
    "dropdelcty": "WILLIAMSON",
    "dropdelst": "WV",
    "dropdelzpp": 256619998,
    "dropphyadd": "2 W 2ND AVE FL 1",
    "dropphycty": "WILLIAMSON",
    "dropphyst": "WV",
    "dropphyzpp": 256619998,
    "dropmaladd": "2 W 2ND AVE FL 1",
    "dropmalcty": "WILLIAMSON",
    "dropmalst": "WV",
    "dropmalzpp": 256619998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042352240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29389",
    "droptype": "D",
    "dropname": "WILLIAMSTOWN",
    "dropdeladd": "420 OAKWOOD AVE",
    "dropdelcty": "WILLIAMSTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 261879998,
    "dropphyadd": "420 OAKWOOD AVE",
    "dropphycty": "WILLIAMSTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 261879998,
    "dropmaladd": "420 OAKWOOD AVE",
    "dropmalcty": "WILLIAMSTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 261879998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043756008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29395",
    "droptype": "D",
    "dropname": "WILSONDALE",
    "dropdeladd": "7478 CABWAYLINGO PARK RD",
    "dropdelcty": "WILSONDALE",
    "dropdelst": "WV",
    "dropdelzpp": 256999998,
    "dropphyadd": "7478 CABWAYLINGO PARK RD",
    "dropphycty": "WILSONDALE",
    "dropphyst": "WV",
    "dropphyzpp": 256999998,
    "dropmaladd": "7478 CABWAYLINGO PARK RD",
    "dropmalcty": "WILSONDALE",
    "dropmalst": "WV",
    "dropmalzpp": 256999998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043933040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29397",
    "droptype": "D",
    "dropname": "WINDSOR HEIGHTS",
    "dropdeladd": "290 WINDY HILL RD",
    "dropdelcty": "WINDSOR HEIGHTS",
    "dropdelst": "WV",
    "dropdelzpp": 260751000,
    "dropphyadd": "290 WINDY HILL RD",
    "dropphycty": "WINDSOR HEIGHTS",
    "dropphyst": "WV",
    "dropphyzpp": 260751000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDSOR HEIGHTS",
    "dropmalst": "WV",
    "dropmalzpp": 260759998,
    "dropsitphn": 4123597568,
    "dropsitlph": 3043941210,
    "dropsitcph": 3043941210,
    "dropfax": 3043941210
  },
  {
    "dcode": "D",
    "dropkey": "PX29400",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "3278 WINFIELD RD",
    "dropdelcty": "WINFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 252139998,
    "dropphyadd": "3278 WINFIELD RD",
    "dropphycty": "WINFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 252139998,
    "dropmaladd": "3278 WINFIELD RD",
    "dropmalcty": "WINFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 252139998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045869783,
    "dropfax": 3045862366
  },
  {
    "dcode": "D",
    "dropkey": "PX29401",
    "droptype": "D",
    "dropname": "WINIFREDE",
    "dropdeladd": "303 FIELDS CREEK RD",
    "dropdelcty": "WINIFREDE",
    "dropdelst": "WV",
    "dropdelzpp": 252149998,
    "dropphyadd": "303 FIELDS CREEK RD",
    "dropphycty": "WINIFREDE",
    "dropphyst": "WV",
    "dropphyzpp": 252149998,
    "dropmaladd": "303 FIELDS CREEK RD",
    "dropmalcty": "WINIFREDE",
    "dropmalst": "WV",
    "dropmalzpp": 252149998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049496632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29407",
    "droptype": "D",
    "dropname": "WOLFCREEK",
    "dropdeladd": "8360 WOLF CREEK RD",
    "dropdelcty": "WOLFCREEK",
    "dropdelst": "WV",
    "dropdelzpp": 249939998,
    "dropphyadd": "8360 WOLF CREEK RD",
    "dropphycty": "WOLFCREEK",
    "dropphyst": "WV",
    "dropphyzpp": 249939998,
    "dropmaladd": "8360 WOLF CREEK RD",
    "dropmalcty": "WOLFCREEK",
    "dropmalst": "WV",
    "dropmalzpp": 249939998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044452228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29411",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "287 MAIN ST",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 265919998,
    "dropphyadd": "287 MAIN ST",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 265919998,
    "dropmaladd": "287 MAIN ST",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 265919998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042872789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29413",
    "droptype": "D",
    "dropname": "WYATT",
    "dropdeladd": "151 JOETOWN RD",
    "dropdelcty": "WYATT",
    "dropdelst": "WV",
    "dropdelzpp": 264639998,
    "dropphyadd": "151 JOETOWN RD",
    "dropphycty": "WYATT",
    "dropphyst": "WV",
    "dropphyzpp": 264639998,
    "dropmaladd": "151 JOETOWN RD",
    "dropmalcty": "WYATT",
    "dropmalst": "WV",
    "dropmalzpp": 264639998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045921322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29414",
    "droptype": "D",
    "dropname": "WYCO",
    "dropdeladd": "1006 WYCO HOLLOW RD",
    "dropdelcty": "WYCO",
    "dropdelst": "WV",
    "dropdelzpp": 259439998,
    "dropphyadd": "1006 WYCO HOLLOW RD",
    "dropphycty": "WYCO",
    "dropphyst": "WV",
    "dropphyzpp": 259439998,
    "dropmaladd": "1006 WYCO HOLLOW RD",
    "dropmalcty": "WYCO",
    "dropmalst": "WV",
    "dropmalzpp": 259439998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042945814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29417",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "100 95TH ST",
    "dropdelcty": "WYOMING",
    "dropdelst": "WV",
    "dropdelzpp": 248989998,
    "dropphyadd": "100 95TH ST",
    "dropphycty": "WYOMING",
    "dropphyst": "WV",
    "dropphyzpp": 248989998,
    "dropmaladd": "100 95TH ST",
    "dropmalcty": "WYOMING",
    "dropmalst": "WV",
    "dropmalzpp": 248989998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047327119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29419",
    "droptype": "D",
    "dropname": "YELLOW SPRING",
    "dropdeladd": "7966 CARPERS PIKE",
    "dropdelcty": "YELLOW SPRING",
    "dropdelst": "WV",
    "dropdelzpp": 268659998,
    "dropphyadd": "7966 CARPERS PIKE",
    "dropphycty": "YELLOW SPRING",
    "dropphyst": "WV",
    "dropphyzpp": 268659998,
    "dropmaladd": "7966 CARPERS PIKE",
    "dropmalcty": "YELLOW SPRING",
    "dropmalst": "WV",
    "dropmalzpp": 268659998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3048563621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PX29760",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "7776 FARMINGTON BLVD",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 381382961,
    "dropphyadd": "7776 FARMINGTON BLVD",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 381382961,
    "dropmaladd": "7776 FARMINGTON BLVD",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 381382961,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017549746,
    "dropsitcph": 9017549135,
    "dropfax": 9017589031
  },
  {
    "dcode": "D",
    "dropkey": "PY10002",
    "droptype": "D",
    "dropname": "ABBEVILLE",
    "dropdeladd": "110 E WASHINGTON ST",
    "dropdelcty": "ABBEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 363102134,
    "dropphyadd": "110 E WASHINGTON ST",
    "dropphycty": "ABBEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 363102134,
    "dropmaladd": "110 E WASHINGTON ST",
    "dropmalcty": "ABBEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 363109998,
    "dropsitphn": 3345855370,
    "dropsitlph": 3345855370,
    "dropsitcph": 3345855370,
    "dropfax": 3345859534
  },
  {
    "dcode": "D",
    "dropkey": "PY10004",
    "droptype": "D",
    "dropname": "ABERNANT",
    "dropdeladd": "13525 JOHNS RD",
    "dropdelcty": "ABERNANT",
    "dropdelst": "AL",
    "dropdelzpp": 354402000,
    "dropphyadd": "13525 JOHNS RD",
    "dropphycty": "ABERNANT",
    "dropphyst": "AL",
    "dropphyzpp": 354402000,
    "dropmaladd": "13525 JOHNS RD",
    "dropmalcty": "ABERNANT",
    "dropmalst": "AL",
    "dropmalzpp": 354409998,
    "dropsitphn": 2054775059,
    "dropsitlph": 2054775059,
    "dropsitcph": 2054775059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10006",
    "droptype": "D",
    "dropname": "ADAMSVILLE",
    "dropdeladd": "3609 GRAY AVE",
    "dropdelcty": "ADAMSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350052238,
    "dropphyadd": "3609 GRAY AVE",
    "dropphycty": "ADAMSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350052238,
    "dropmaladd": "3609 GRAY AVE",
    "dropmalcty": "ADAMSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350059998,
    "dropsitphn": 2056741436,
    "dropsitlph": 2056741436,
    "dropsitcph": 2056741436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10007",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "30696 HIGHWAY 278",
    "dropdelcty": "ADDISON",
    "dropdelst": "AL",
    "dropdelzpp": 355402240,
    "dropphyadd": "30696 HIGHWAY 278",
    "dropphycty": "ADDISON",
    "dropphyst": "AL",
    "dropphyzpp": 355402240,
    "dropmaladd": "30696 HIGHWAY 278",
    "dropmalcty": "ADDISON",
    "dropmalst": "AL",
    "dropmalzpp": 355409998,
    "dropsitphn": 2056156686,
    "dropsitlph": 2056156686,
    "dropsitcph": 2566156686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10008",
    "droptype": "D",
    "dropname": "ADGER",
    "dropdeladd": "7313 JOHNS RD",
    "dropdelcty": "ADGER",
    "dropdelst": "AL",
    "dropdelzpp": 350061409,
    "dropphyadd": "7313 JOHNS RD",
    "dropphycty": "ADGER",
    "dropphyst": "AL",
    "dropphyzpp": 350061409,
    "dropmaladd": "7313 JOHNS RD",
    "dropmalcty": "ADGER",
    "dropmalst": "AL",
    "dropmalzpp": 350069998,
    "dropsitphn": 2054257490,
    "dropsitlph": 2054257490,
    "dropsitcph": 2054257490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10010",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "197 1ST AVE S",
    "dropdelcty": "AKRON",
    "dropdelst": "AL",
    "dropdelzpp": 354411935,
    "dropphyadd": "197 1ST AVE S",
    "dropphycty": "AKRON",
    "dropphyst": "AL",
    "dropphyzpp": 354411935,
    "dropmaladd": "197 1ST AVE S",
    "dropmalcty": "AKRON",
    "dropmalst": "AL",
    "dropmalzpp": 354419998,
    "dropsitphn": 2053724511,
    "dropsitlph": 2053724511,
    "dropsitcph": 2053364400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10020",
    "droptype": "D",
    "dropname": "ALABASTER",
    "dropdeladd": "50 KENT STONE WAY",
    "dropdelcty": "ALABASTER",
    "dropdelst": "AL",
    "dropdelzpp": 350075429,
    "dropphyadd": "50 KENT STONE WAY",
    "dropphycty": "ALABASTER",
    "dropphyst": "AL",
    "dropphyzpp": 350075429,
    "dropmaladd": "50 KENT STONE WAY",
    "dropmalcty": "ALABASTER",
    "dropmalst": "AL",
    "dropmalzpp": 350079998,
    "dropsitphn": 2056212628,
    "dropsitlph": 2056212628,
    "dropsitcph": 2056212628,
    "dropfax": 2056204245
  },
  {
    "dcode": "D",
    "dropkey": "PY10021",
    "droptype": "D",
    "dropname": "ALBERTA",
    "dropdeladd": "21914 HIGHWAY 5",
    "dropdelcty": "ALBERTA",
    "dropdelst": "AL",
    "dropdelzpp": 367209998,
    "dropphyadd": "21914 HIGHWAY 5",
    "dropphycty": "ALBERTA",
    "dropphyst": "AL",
    "dropphyzpp": 367209998,
    "dropmaladd": "21914 HIGHWAY 5",
    "dropmalcty": "ALBERTA",
    "dropmalst": "AL",
    "dropmalzpp": 367209998,
    "dropsitphn": 3345732235,
    "dropsitlph": 3345732235,
    "dropsitcph": 3345732235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10022",
    "droptype": "D",
    "dropname": "ALBERTVILLE",
    "dropdeladd": "210 S HAMBRICK ST",
    "dropdelcty": "ALBERTVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359501624,
    "dropphyadd": "210 S HAMBRICK ST",
    "dropphycty": "ALBERTVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359501624,
    "dropmaladd": "210 S HAMBRICK ST",
    "dropmalcty": "ALBERTVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359509998,
    "dropsitphn": 2568789461,
    "dropsitlph": 2568789461,
    "dropsitcph": 2568789461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10026",
    "droptype": "D",
    "dropname": "ALEXANDER CITY",
    "dropdeladd": "233 LEE ST",
    "dropdelcty": "ALEXANDER CITY",
    "dropdelst": "AL",
    "dropdelzpp": 350102654,
    "dropphyadd": "233 LEE ST",
    "dropphycty": "ALEXANDER CITY",
    "dropphyst": "AL",
    "dropphyzpp": 350102654,
    "dropmaladd": "233 LEE ST",
    "dropmalcty": "ALEXANDER CITY",
    "dropmalst": "AL",
    "dropmalzpp": 350109998,
    "dropsitphn": 2562343541,
    "dropsitlph": 2562343541,
    "dropsitcph": 2562343541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10027",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "6582 US HIGHWAY 431",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "AL",
    "dropdelzpp": 362505059,
    "dropphyadd": "6582 US HIGHWAY 431",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "AL",
    "dropphyzpp": 362505059,
    "dropmaladd": "6582 US HIGHWAY 431",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "AL",
    "dropmalzpp": 362509998,
    "dropsitphn": 2568200228,
    "dropsitlph": 2568200228,
    "dropsitcph": 2568200228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10029",
    "droptype": "D",
    "dropname": "ALICEVILLE",
    "dropdeladd": "119 3RD AVE NE",
    "dropdelcty": "ALICEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 354422104,
    "dropphyadd": "119 3RD AVE NE",
    "dropphycty": "ALICEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 354422104,
    "dropmaladd": "119 3RD AVE NE",
    "dropmalcty": "ALICEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 354429998,
    "dropsitphn": 2053736348,
    "dropsitlph": 2053736348,
    "dropsitcph": 2053736348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10031",
    "droptype": "D",
    "dropname": "ALLGOOD",
    "dropdeladd": "26038 HIGHWAY 75 N",
    "dropdelcty": "ALLGOOD",
    "dropdelst": "AL",
    "dropdelzpp": 350132000,
    "dropphyadd": "26038 HIGHWAY 75 N",
    "dropphycty": "ALLGOOD",
    "dropphyst": "AL",
    "dropphyzpp": 350132000,
    "dropmaladd": "26038 HIGHWAY 75 N",
    "dropmalcty": "ALLGOOD",
    "dropmalst": "AL",
    "dropmalzpp": 350139998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2052749540,
    "dropsitcph": 2052749540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10034",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "3585 GRIST MILL RD",
    "dropdelcty": "ALPINE",
    "dropdelst": "AL",
    "dropdelzpp": 350145706,
    "dropphyadd": "3585 GRIST MILL RD",
    "dropphycty": "ALPINE",
    "dropphyst": "AL",
    "dropphyzpp": 350145706,
    "dropmaladd": "3585 GRIST MILL RD",
    "dropmalcty": "ALPINE",
    "dropmalst": "AL",
    "dropmalzpp": 350149998,
    "dropsitphn": 2562689571,
    "dropsitlph": 2562689571,
    "dropsitcph": 2562689571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10035",
    "droptype": "D",
    "dropname": "ALTON",
    "dropdeladd": "5548 JOHNSON ST",
    "dropdelcty": "ALTON",
    "dropdelst": "AL",
    "dropdelzpp": 350152001,
    "dropphyadd": "5548 JOHNSON ST",
    "dropphycty": "ALTON",
    "dropphyst": "AL",
    "dropphyzpp": 350152001,
    "dropmaladd": "5548 JOHNSON ST",
    "dropmalcty": "ALTON",
    "dropmalst": "AL",
    "dropmalzpp": 350159998,
    "dropsitphn": 2058334333,
    "dropsitlph": 2058334333,
    "dropsitcph": 2058334333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10036",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "2920 COLLEGE ST",
    "dropdelcty": "ALTOONA",
    "dropdelst": "AL",
    "dropdelzpp": 359528331,
    "dropphyadd": "2920 COLLEGE ST",
    "dropphycty": "ALTOONA",
    "dropphyst": "AL",
    "dropphyzpp": 359528331,
    "dropmaladd": "2920 COLLEGE ST",
    "dropmalcty": "ALTOONA",
    "dropmalst": "AL",
    "dropmalzpp": 359529998,
    "dropsitphn": 2055896978,
    "dropsitlph": 2055896978,
    "dropsitcph": 2055896978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10038",
    "droptype": "D",
    "dropname": "ANDALUSIA",
    "dropdeladd": "520 E THREE NOTCH ST",
    "dropdelcty": "ANDALUSIA",
    "dropdelst": "AL",
    "dropdelzpp": 364203128,
    "dropphyadd": "520 E THREE NOTCH ST",
    "dropphycty": "ANDALUSIA",
    "dropphyst": "AL",
    "dropphyzpp": 364203128,
    "dropmaladd": "520 E THREE NOTCH ST",
    "dropmalcty": "ANDALUSIA",
    "dropmalst": "AL",
    "dropmalzpp": 364209998,
    "dropsitphn": 3342223521,
    "dropsitlph": 3342223521,
    "dropsitcph": 3342223521,
    "dropfax": 3344271966
  },
  {
    "dcode": "D",
    "dropkey": "PY10039",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "7312 HIGHWAY 207",
    "dropdelcty": "ANDERSON",
    "dropdelst": "AL",
    "dropdelzpp": 356104840,
    "dropphyadd": "7312 HIGHWAY 207",
    "dropphycty": "ANDERSON",
    "dropphyst": "AL",
    "dropphyzpp": 356104840,
    "dropmaladd": "7312 HIGHWAY 207",
    "dropmalcty": "ANDERSON",
    "dropmalst": "AL",
    "dropmalzpp": 356109998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2562475072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10040",
    "droptype": "D",
    "dropname": "ANNEMANIE",
    "dropdeladd": "6701 WINTON BLOUNT BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361199600,
    "dropphyadd": "6701 WINTON BLOUNT BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361199600,
    "dropmaladd": "6701 WINTON BLOUNT BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361199600,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3342447621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10042",
    "droptype": "D",
    "dropname": "ANNISTON",
    "dropdeladd": "1101 QUINTARD AVE",
    "dropdelcty": "ANNISTON",
    "dropdelst": "AL",
    "dropdelzpp": 362019998,
    "dropphyadd": "1101 QUINTARD AVE",
    "dropphycty": "ANNISTON",
    "dropphyst": "AL",
    "dropphyzpp": 362019998,
    "dropmaladd": "1101 QUINTARD AVE",
    "dropmalcty": "ANNISTON",
    "dropmalst": "AL",
    "dropmalzpp": 362019998,
    "dropsitphn": 2562359940,
    "dropsitlph": 2562359940,
    "dropsitcph": 2562359940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10045",
    "droptype": "D",
    "dropname": "ARAB",
    "dropdeladd": "819 N MAIN ST",
    "dropdelcty": "ARAB",
    "dropdelst": "AL",
    "dropdelzpp": 350161026,
    "dropphyadd": "819 N MAIN ST",
    "dropphycty": "ARAB",
    "dropphyst": "AL",
    "dropphyzpp": 350161026,
    "dropmaladd": "819 N MAIN ST",
    "dropmalcty": "ARAB",
    "dropmalst": "AL",
    "dropmalzpp": 350169998,
    "dropsitphn": 2565865690,
    "dropsitlph": 2565867166,
    "dropsitcph": 2565865690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10048",
    "droptype": "D",
    "dropname": "ARITON",
    "dropdeladd": "52 PEA RIVER RD",
    "dropdelcty": "ARITON",
    "dropdelst": "AL",
    "dropdelzpp": 363116351,
    "dropphyadd": "52 PEA RIVER RD",
    "dropphycty": "ARITON",
    "dropphyst": "AL",
    "dropphyzpp": 363116351,
    "dropmaladd": "52 PEA RIVER RD",
    "dropmalcty": "ARITON",
    "dropmalst": "AL",
    "dropmalzpp": 363119998,
    "dropsitphn": 3347622019,
    "dropsitlph": 3347622019,
    "dropsitcph": 3347622019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10050",
    "droptype": "D",
    "dropname": "ARLEY",
    "dropdeladd": "6865 COUNTY ROAD 41",
    "dropdelcty": "ARLEY",
    "dropdelst": "AL",
    "dropdelzpp": 355413356,
    "dropphyadd": "6865 COUNTY ROAD 41",
    "dropphycty": "ARLEY",
    "dropphyst": "AL",
    "dropphyzpp": 355413356,
    "dropmaladd": "6865 COUNTY ROAD 41",
    "dropmalcty": "ARLEY",
    "dropmalst": "AL",
    "dropmalzpp": 355419998,
    "dropsitphn": 2053844623,
    "dropsitlph": 2053844623,
    "dropsitcph": 2053844623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10051",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "3894 COUNTY ROAD 32",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "AL",
    "dropdelzpp": 367229998,
    "dropphyadd": "3894 COUNTY ROAD 32",
    "dropphycty": "ARLINGTON",
    "dropphyst": "AL",
    "dropphyzpp": 367229998,
    "dropmaladd": "3894 COUNTY ROAD 32",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "AL",
    "dropmalzpp": 367229998,
    "dropsitphn": 3342447624,
    "dropsitlph": 3342447515,
    "dropsitcph": 3343852525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10053",
    "droptype": "D",
    "dropname": "ASHFORD",
    "dropdeladd": "603 N BROADWAY ST",
    "dropdelcty": "ASHFORD",
    "dropdelst": "AL",
    "dropdelzpp": 363123525,
    "dropphyadd": "603 N BROADWAY ST",
    "dropphycty": "ASHFORD",
    "dropphyst": "AL",
    "dropphyzpp": 363123525,
    "dropmaladd": "603 N BROADWAY ST",
    "dropmalcty": "ASHFORD",
    "dropmalst": "AL",
    "dropmalzpp": 363129998,
    "dropsitphn": 3348993682,
    "dropsitlph": 3348993682,
    "dropsitcph": 3348993682,
    "dropfax": 3348998653
  },
  {
    "dcode": "D",
    "dropkey": "PY10054",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "83280 HIGHWAY 9",
    "dropdelcty": "ASHLAND",
    "dropdelst": "AL",
    "dropdelzpp": 362517959,
    "dropphyadd": "83280 HIGHWAY 9",
    "dropphycty": "ASHLAND",
    "dropphyst": "AL",
    "dropphyzpp": 362517959,
    "dropmaladd": "83280 HIGHWAY 9",
    "dropmalcty": "ASHLAND",
    "dropmalst": "AL",
    "dropmalzpp": 362519998,
    "dropsitphn": 2563542245,
    "dropsitlph": 2563542245,
    "dropsitcph": 2563542245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10055",
    "droptype": "D",
    "dropname": "ASHVILLE",
    "dropdeladd": "35330 US HIGHWAY 231",
    "dropdelcty": "ASHVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359533036,
    "dropphyadd": "35330 US HIGHWAY 231",
    "dropphycty": "ASHVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359533036,
    "dropmaladd": "35330 US HIGHWAY 231",
    "dropmalcty": "ASHVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359539998,
    "dropsitphn": 2055947920,
    "dropsitlph": 2055947920,
    "dropsitcph": 2055947920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10059",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "1110 W MARKET ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "AL",
    "dropdelzpp": 356112466,
    "dropphyadd": "1110 W MARKET ST",
    "dropphycty": "ATHENS",
    "dropphyst": "AL",
    "dropphyzpp": 356112466,
    "dropmaladd": "1110 W MARKET ST",
    "dropmalcty": "ATHENS",
    "dropmalst": "AL",
    "dropmalzpp": 356119998,
    "dropsitphn": 2562321100,
    "dropsitlph": 2055210367,
    "dropsitcph": 2562321100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10060",
    "droptype": "D",
    "dropname": "ATMORE",
    "dropdeladd": "114 N MAIN ST",
    "dropdelcty": "ATMORE",
    "dropdelst": "AL",
    "dropdelzpp": 365021712,
    "dropphyadd": "114 N MAIN ST",
    "dropphycty": "ATMORE",
    "dropphyst": "AL",
    "dropphyzpp": 365021712,
    "dropmaladd": "114 N MAIN ST",
    "dropmalcty": "ATMORE",
    "dropmalst": "AL",
    "dropmalzpp": 365029998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2513682871,
    "dropfax": 2513684794
  },
  {
    "dcode": "D",
    "dropkey": "PY10061",
    "droptype": "D",
    "dropname": "ATTALLA",
    "dropdeladd": "401 4TH ST NW",
    "dropdelcty": "ATTALLA",
    "dropdelst": "AL",
    "dropdelzpp": 359542204,
    "dropphyadd": "401 4TH ST NW",
    "dropphycty": "ATTALLA",
    "dropphyst": "AL",
    "dropphyzpp": 359542204,
    "dropmaladd": "401 4TH ST NW",
    "dropmalcty": "ATTALLA",
    "dropmalst": "AL",
    "dropmalzpp": 359549998,
    "dropsitphn": 2565385251,
    "dropsitlph": 2565385251,
    "dropsitcph": 2565385251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10063",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "300 OPELIKA RD",
    "dropdelcty": "AUBURN",
    "dropdelst": "AL",
    "dropdelzpp": 368309998,
    "dropphyadd": "300 OPELIKA RD",
    "dropphycty": "AUBURN",
    "dropphyst": "AL",
    "dropphyzpp": 368309998,
    "dropmaladd": "300 OPELIKA RD",
    "dropmalcty": "AUBURN",
    "dropmalst": "AL",
    "dropmalzpp": 368309998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3348213754,
    "dropsitcph": 3348213754,
    "dropfax": 3348214816
  },
  {
    "dcode": "D",
    "dropkey": "PY10064",
    "droptype": "D",
    "dropname": "AUTAUGAVILLE",
    "dropdeladd": "105 N TAYLOR ST",
    "dropdelcty": "AUTAUGAVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360039998,
    "dropphyadd": "105 N TAYLOR ST",
    "dropphycty": "AUTAUGAVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360039998,
    "dropmaladd": "105 N TAYLOR ST",
    "dropmalcty": "AUTAUGAVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360039998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3343652368,
    "dropsitcph": 3343652368,
    "dropfax": 3343658434
  },
  {
    "dcode": "D",
    "dropkey": "PY10070",
    "droptype": "D",
    "dropname": "AXIS",
    "dropdeladd": "11436 OLD HIGHWAY 43",
    "dropdelcty": "AXIS",
    "dropdelst": "AL",
    "dropdelzpp": 365054646,
    "dropphyadd": "11436 OLD HIGHWAY 43",
    "dropphycty": "AXIS",
    "dropphyst": "AL",
    "dropphyzpp": 365054646,
    "dropmaladd": "11436 OLD HIGHWAY 43",
    "dropmalcty": "AXIS",
    "dropmalst": "AL",
    "dropmalzpp": 365059998,
    "dropsitphn": 2516755905,
    "dropsitlph": 2516755905,
    "dropsitcph": 2516755905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10073",
    "droptype": "D",
    "dropname": "BAILEYTON",
    "dropdeladd": "12125 AL HIGHWAY 69 N",
    "dropdelcty": "BAILEYTON",
    "dropdelst": "AL",
    "dropdelzpp": 350199321,
    "dropphyadd": "12125 AL HIGHWAY 69 N",
    "dropphycty": "BAILEYTON",
    "dropphyst": "AL",
    "dropphyzpp": 350199321,
    "dropmaladd": "12125 AL HIGHWAY 69 N",
    "dropmalcty": "BAILEYTON",
    "dropmalst": "AL",
    "dropmalzpp": 350199998,
    "dropsitphn": 2567967240,
    "dropsitlph": 2567967240,
    "dropsitcph": 2567967240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10076",
    "droptype": "D",
    "dropname": "BANKS",
    "dropdeladd": "9378 N US HIGHWAY 29",
    "dropdelcty": "BANKS",
    "dropdelst": "AL",
    "dropdelzpp": 360053425,
    "dropphyadd": "9378 N US HIGHWAY 29",
    "dropphycty": "BANKS",
    "dropphyst": "AL",
    "dropphyzpp": 360053425,
    "dropmaladd": "9378 N US HIGHWAY 29",
    "dropmalcty": "BANKS",
    "dropmalst": "AL",
    "dropmalzpp": 360053425,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342435580,
    "dropsitcph": 3342435580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10077",
    "droptype": "D",
    "dropname": "BANKSTON",
    "dropdeladd": "10745 HIGHWAY 18 E",
    "dropdelcty": "BANKSTON",
    "dropdelst": "AL",
    "dropdelzpp": 355422738,
    "dropphyadd": "10745 HIGHWAY 18 E",
    "dropphycty": "BANKSTON",
    "dropphyst": "AL",
    "dropphyzpp": 355422738,
    "dropmaladd": "10745 HIGHWAY 18 E",
    "dropmalcty": "BANKSTON",
    "dropmalst": "AL",
    "dropmalzpp": 355429998,
    "dropsitphn": 2059325443,
    "dropsitlph": 2059325443,
    "dropsitcph": 2059325443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10084",
    "droptype": "D",
    "dropname": "BAY MINETTE",
    "dropdeladd": "601 MCMEANS AVE",
    "dropdelcty": "BAY MINETTE",
    "dropdelst": "AL",
    "dropdelzpp": 365073347,
    "dropphyadd": "601 MCMEANS AVE",
    "dropphycty": "BAY MINETTE",
    "dropphyst": "AL",
    "dropphyzpp": 365073347,
    "dropmaladd": "601 MCMEANS AVE",
    "dropmalcty": "BAY MINETTE",
    "dropmalst": "AL",
    "dropmalzpp": 365079998,
    "dropsitphn": 2519379972,
    "dropsitlph": 2519379972,
    "dropsitcph": 2519379972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10085",
    "droptype": "D",
    "dropname": "BAYOU LA BATRE",
    "dropdeladd": "8761 W RABBY ST",
    "dropdelcty": "BAYOU LA BATRE",
    "dropdelst": "AL",
    "dropdelzpp": 365092324,
    "dropphyadd": "8761 W RABBY ST",
    "dropphycty": "BAYOU LA BATRE",
    "dropphyst": "AL",
    "dropphyzpp": 365092324,
    "dropmaladd": "8761 W RABBY ST",
    "dropmalcty": "BAYOU LA BATRE",
    "dropmalst": "AL",
    "dropmalzpp": 365099998,
    "dropsitphn": 2518243317,
    "dropsitlph": 2518243317,
    "dropsitcph": 2518243317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10089",
    "droptype": "D",
    "dropname": "BEAR CREEK",
    "dropdeladd": "335 MAIN ST",
    "dropdelcty": "BEAR CREEK",
    "dropdelst": "AL",
    "dropdelzpp": 355434425,
    "dropphyadd": "335 MAIN ST",
    "dropphycty": "BEAR CREEK",
    "dropphyst": "AL",
    "dropphyzpp": 355434425,
    "dropmaladd": "335 MAIN ST",
    "dropmalcty": "BEAR CREEK",
    "dropmalst": "AL",
    "dropmalzpp": 355439998,
    "dropsitphn": 2054864647,
    "dropsitlph": 2054864647,
    "dropsitcph": 2054864647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10090",
    "droptype": "D",
    "dropname": "BEATRICE",
    "dropdeladd": "291 MOORE ST",
    "dropdelcty": "BEATRICE",
    "dropdelst": "AL",
    "dropdelzpp": 364254350,
    "dropphyadd": "291 MOORE ST",
    "dropphycty": "BEATRICE",
    "dropphyst": "AL",
    "dropphyzpp": 364254350,
    "dropmaladd": "291 MOORE ST",
    "dropmalcty": "BEATRICE",
    "dropmalst": "AL",
    "dropmalzpp": 364259998,
    "dropsitphn": 2517892364,
    "dropsitlph": 2517892364,
    "dropsitcph": 2517892364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10091",
    "droptype": "D",
    "dropname": "BEAVERTON",
    "dropdeladd": "32457 COUNTY ROAD 49",
    "dropdelcty": "BEAVERTON",
    "dropdelst": "AL",
    "dropdelzpp": 355442522,
    "dropphyadd": "32457 COUNTY ROAD 49",
    "dropphycty": "BEAVERTON",
    "dropphyst": "AL",
    "dropphyzpp": 355442522,
    "dropmaladd": "32457 COUNTY ROAD 49",
    "dropmalcty": "BEAVERTON",
    "dropmalst": "AL",
    "dropmalzpp": 355449998,
    "dropsitphn": 2056989634,
    "dropsitlph": 2056989634,
    "dropsitcph": 2056989634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10093",
    "droptype": "D",
    "dropname": "BELK",
    "dropdeladd": "7660 HIGHWAY 96",
    "dropdelcty": "BELK",
    "dropdelst": "AL",
    "dropdelzpp": 355452000,
    "dropphyadd": "7660 HIGHWAY 96",
    "dropphycty": "BELK",
    "dropphyst": "AL",
    "dropphyzpp": 355452000,
    "dropmaladd": "7660 HIGHWAY 96",
    "dropmalcty": "BELK",
    "dropmalst": "AL",
    "dropmalzpp": 355459998,
    "dropsitphn": 2059325011,
    "dropsitlph": 2059325011,
    "dropsitcph": 2059325011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10095",
    "droptype": "D",
    "dropname": "BELLAMY",
    "dropdeladd": "591 PINE ST",
    "dropdelcty": "BELLAMY",
    "dropdelst": "AL",
    "dropdelzpp": 369019998,
    "dropphyadd": "591 PINE ST",
    "dropphycty": "BELLAMY",
    "dropphyst": "AL",
    "dropphyzpp": 369019998,
    "dropmaladd": "591 PINE ST",
    "dropmalcty": "BELLAMY",
    "dropmalst": "AL",
    "dropmalzpp": 369019998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6592155152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10096",
    "droptype": "D",
    "dropname": "BELLE MINA",
    "dropdeladd": "24989 GARRETT RD",
    "dropdelcty": "BELLE MINA",
    "dropdelst": "AL",
    "dropdelzpp": 356152000,
    "dropphyadd": "24989 GARRETT RD",
    "dropphycty": "BELLE MINA",
    "dropphyst": "AL",
    "dropphyzpp": 356152000,
    "dropmaladd": "24989 GARRETT RD",
    "dropmalcty": "BELLE MINA",
    "dropmalst": "AL",
    "dropmalzpp": 356159998,
    "dropsitphn": 2563550135,
    "dropsitlph": 2563550135,
    "dropsitcph": 2563550135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10098",
    "droptype": "D",
    "dropname": "BELLWOOD",
    "dropdeladd": "4940 COUNTY ROAD 45",
    "dropdelcty": "BELLWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 363132000,
    "dropphyadd": "4940 COUNTY ROAD 45",
    "dropphycty": "BELLWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 363132000,
    "dropmaladd": "4940 COUNTY ROAD 45",
    "dropmalcty": "BELLWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 363139998,
    "dropsitphn": 3345886068,
    "dropsitlph": 3345886068,
    "dropsitcph": 3345886068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10102",
    "droptype": "D",
    "dropname": "BERRY",
    "dropdeladd": "107 FEDERAL AVE",
    "dropdelcty": "BERRY",
    "dropdelst": "AL",
    "dropdelzpp": 355462053,
    "dropphyadd": "107 FEDERAL AVE",
    "dropphycty": "BERRY",
    "dropphyst": "AL",
    "dropphyzpp": 355462053,
    "dropmaladd": "107 FEDERAL AVE",
    "dropmalcty": "BERRY",
    "dropmalst": "AL",
    "dropmalzpp": 355469998,
    "dropsitphn": 2056894249,
    "dropsitlph": 2056894249,
    "dropsitcph": 2055498216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10106",
    "droptype": "D",
    "dropname": "BESSEMER",
    "dropdeladd": "1112 4TH AVE N",
    "dropdelcty": "BESSEMER",
    "dropdelst": "AL",
    "dropdelzpp": 350205573,
    "dropphyadd": "1112 4TH AVE N",
    "dropphycty": "BESSEMER",
    "dropphyst": "AL",
    "dropphyzpp": 350205573,
    "dropmaladd": "1112 4TH AVE N",
    "dropmalcty": "BESSEMER",
    "dropmalst": "AL",
    "dropmalzpp": 350209998,
    "dropsitphn": 2054287839,
    "dropsitlph": 2054287839,
    "dropsitcph": 2054282563,
    "dropfax": 2054250288
  },
  {
    "dcode": "D",
    "dropkey": "PY10112",
    "droptype": "D",
    "dropname": "BILLINGSLEY",
    "dropdeladd": "2041 OFFICE ST",
    "dropdelcty": "BILLINGSLEY",
    "dropdelst": "AL",
    "dropdelzpp": 360069998,
    "dropphyadd": "2041 OFFICE ST",
    "dropphycty": "BILLINGSLEY",
    "dropphyst": "AL",
    "dropphyzpp": 360069998,
    "dropmaladd": "2041 OFFICE ST",
    "dropmalcty": "BILLINGSLEY",
    "dropmalst": "AL",
    "dropmalzpp": 360069998,
    "dropsitphn": 2052447515,
    "dropsitlph": 2057557966,
    "dropsitcph": 2057557966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10114",
    "droptype": "D",
    "dropname": "BIRMINGHAM",
    "dropdeladd": "351 24TH ST N",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352033875,
    "dropphyadd": "351 24TH ST N",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352033824,
    "dropmaladd": "351 24TH ST N RM 210",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352039998,
    "dropsitphn": 2055210260,
    "dropsitlph": 2055210260,
    "dropsitcph": 2055217990,
    "dropfax": 2055217918
  },
  {
    "dcode": "D",
    "dropkey": "PY10117",
    "droptype": "D",
    "dropname": "BLACK",
    "dropdeladd": "128 N MAIN ST",
    "dropdelcty": "BLACK",
    "dropdelst": "AL",
    "dropdelzpp": 363144936,
    "dropphyadd": "128 N MAIN ST",
    "dropphycty": "BLACK",
    "dropphyst": "AL",
    "dropphyzpp": 363144936,
    "dropmaladd": "128 N MAIN ST",
    "dropmalcty": "BLACK",
    "dropmalst": "AL",
    "dropmalzpp": 363144936,
    "dropsitphn": 3346849806,
    "dropsitlph": 3346849806,
    "dropsitcph": 3346849806,
    "dropfax": 3346848082
  },
  {
    "dcode": "D",
    "dropkey": "PY10122",
    "droptype": "D",
    "dropname": "BLOUNTSVILLE",
    "dropdeladd": "69210 MAIN ST",
    "dropdelcty": "BLOUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350316832,
    "dropphyadd": "69210 MAIN ST",
    "dropphycty": "BLOUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350316832,
    "dropmaladd": "69210 MAIN ST",
    "dropmalcty": "BLOUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350319998,
    "dropsitphn": 2054292403,
    "dropsitlph": 2054292403,
    "dropsitcph": 2054292403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10133",
    "droptype": "D",
    "dropname": "BOAZ",
    "dropdeladd": "109 S SNEAD ST",
    "dropdelcty": "BOAZ",
    "dropdelst": "AL",
    "dropdelzpp": 359572118,
    "dropphyadd": "109 S SNEAD ST",
    "dropphycty": "BOAZ",
    "dropphyst": "AL",
    "dropphyzpp": 359572118,
    "dropmaladd": "109 S SNEAD ST",
    "dropmalcty": "BOAZ",
    "dropmalst": "AL",
    "dropmalzpp": 359579998,
    "dropsitphn": 2055935781,
    "dropsitlph": 2055935781,
    "dropsitcph": 2565935781,
    "dropfax": 2565933476
  },
  {
    "dcode": "D",
    "dropkey": "PY10134",
    "droptype": "D",
    "dropname": "BOLIGEE",
    "dropdeladd": "157 COUNTY ROAD 81",
    "dropdelcty": "BOLIGEE",
    "dropdelst": "AL",
    "dropdelzpp": 354432005,
    "dropphyadd": "157 COUNTY ROAD 81",
    "dropphycty": "BOLIGEE",
    "dropphyst": "AL",
    "dropphyzpp": 354432005,
    "dropmaladd": "157 COUNTY ROAD 81",
    "dropmalcty": "BOLIGEE",
    "dropmalst": "AL",
    "dropmalzpp": 354439998,
    "dropsitphn": 2053368653,
    "dropsitlph": 2053368653,
    "dropsitcph": 2053368653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10137",
    "droptype": "D",
    "dropname": "BON AIR",
    "dropdeladd": "205 FRONT ST",
    "dropdelcty": "BON AIR",
    "dropdelst": "AL",
    "dropdelzpp": 350329998,
    "dropphyadd": "205 FRONT ST",
    "dropphycty": "BON AIR",
    "dropphyst": "AL",
    "dropphyzpp": 350329998,
    "dropmaladd": "205 FRONT ST",
    "dropmalcty": "BON AIR",
    "dropmalst": "AL",
    "dropmalzpp": 350329998,
    "dropsitphn": 2563780216,
    "dropsitlph": 2563780216,
    "dropsitcph": 2563780216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10138",
    "droptype": "D",
    "dropname": "BON SECOUR",
    "dropdeladd": "6419 BON SECOUR HWY",
    "dropdelcty": "BON SECOUR",
    "dropdelst": "AL",
    "dropdelzpp": 365113222,
    "dropphyadd": "6419 BON SECOUR HWY",
    "dropphycty": "BON SECOUR",
    "dropphyst": "AL",
    "dropphyzpp": 365113222,
    "dropmaladd": "6419 BON SECOUR HWY",
    "dropmalcty": "BON SECOUR",
    "dropmalst": "AL",
    "dropmalzpp": 365119998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2519496601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10140",
    "droptype": "D",
    "dropname": "BOYKIN",
    "dropdeladd": "14030 COUNTY ROAD 29",
    "dropdelcty": "BOYKIN",
    "dropdelst": "AL",
    "dropdelzpp": 367239998,
    "dropphyadd": "14030 COUNTY ROAD 29",
    "dropphycty": "BOYKIN",
    "dropphyst": "AL",
    "dropphyzpp": 367239998,
    "dropmaladd": "14030 COUNTY ROAD 29",
    "dropmalcty": "BOYKIN",
    "dropmalst": "AL",
    "dropmalzpp": 367239998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345732540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10145",
    "droptype": "D",
    "dropname": "BRANTLEY",
    "dropdeladd": "17 MONROE ST",
    "dropdelcty": "BRANTLEY",
    "dropdelst": "AL",
    "dropdelzpp": 360099998,
    "dropphyadd": "17 MONROE ST",
    "dropphycty": "BRANTLEY",
    "dropphyst": "AL",
    "dropphyzpp": 360099998,
    "dropmaladd": "17 MONROE ST",
    "dropmalcty": "BRANTLEY",
    "dropmalst": "AL",
    "dropmalzpp": 360099998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345273578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10146",
    "droptype": "D",
    "dropname": "BREMEN",
    "dropdeladd": "2313 COUNTY ROAD 54",
    "dropdelcty": "BREMEN",
    "dropdelst": "AL",
    "dropdelzpp": 350333826,
    "dropphyadd": "2313 COUNTY ROAD 54",
    "dropphycty": "BREMEN",
    "dropphyst": "AL",
    "dropphyzpp": 350333826,
    "dropmaladd": "2313 COUNTY ROAD 54",
    "dropmalcty": "BREMEN",
    "dropmalst": "AL",
    "dropmalzpp": 350339998,
    "dropsitphn": 2562871358,
    "dropsitlph": 2562871358,
    "dropsitcph": 2562871358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10147",
    "droptype": "D",
    "dropname": "BRENT",
    "dropdeladd": "2150 MAIN ST",
    "dropdelcty": "BRENT",
    "dropdelst": "AL",
    "dropdelzpp": 350343500,
    "dropphyadd": "2150 MAIN ST",
    "dropphycty": "BRENT",
    "dropphyst": "AL",
    "dropphyzpp": 350343500,
    "dropmaladd": "2150 MAIN ST",
    "dropmalcty": "BRENT",
    "dropmalst": "AL",
    "dropmalzpp": 350349998,
    "dropsitphn": 2059269091,
    "dropsitlph": 2059269091,
    "dropsitcph": 2059269091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10148",
    "droptype": "D",
    "dropname": "BREWTON",
    "dropdeladd": "323 BELLEVILLE AVE",
    "dropdelcty": "BREWTON",
    "dropdelst": "AL",
    "dropdelzpp": 364262039,
    "dropphyadd": "323 BELLEVILLE AVE",
    "dropphycty": "BREWTON",
    "dropphyst": "AL",
    "dropphyzpp": 364262039,
    "dropmaladd": "323 BELLEVILLE AVE",
    "dropmalcty": "BREWTON",
    "dropmalst": "AL",
    "dropmalzpp": 364269998,
    "dropsitphn": 2518673560,
    "dropsitlph": 2518673560,
    "dropsitcph": 2518673560,
    "dropfax": 2518672676
  },
  {
    "dcode": "D",
    "dropkey": "PY10149",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "50450 AL HIGHWAY 277",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "AL",
    "dropdelzpp": 357406517,
    "dropphyadd": "50450 AL HIGHWAY 277",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "AL",
    "dropphyzpp": 357406517,
    "dropmaladd": "50450 AL HIGHWAY 277",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "AL",
    "dropmalzpp": 357409998,
    "dropsitphn": 2564952966,
    "dropsitlph": 2564952996,
    "dropsitcph": 2564952996,
    "dropfax": 2564950082
  },
  {
    "dcode": "D",
    "dropkey": "PY10150",
    "droptype": "D",
    "dropname": "BRIERFIELD",
    "dropdeladd": "18323 HIGHWAY 139",
    "dropdelcty": "BRIERFIELD",
    "dropdelst": "AL",
    "dropdelzpp": 350353605,
    "dropphyadd": "18323 HIGHWAY 139",
    "dropphycty": "BRIERFIELD",
    "dropphyst": "AL",
    "dropphyzpp": 350353605,
    "dropmaladd": "18323 HIGHWAY 139",
    "dropmalcty": "BRIERFIELD",
    "dropmalst": "AL",
    "dropmalzpp": 350359998,
    "dropsitphn": 2056652203,
    "dropsitlph": 2056652203,
    "dropsitcph": 2056652203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10152",
    "droptype": "D",
    "dropname": "BRILLIANT",
    "dropdeladd": "1260 MAIN ST",
    "dropdelcty": "BRILLIANT",
    "dropdelst": "AL",
    "dropdelzpp": 355482000,
    "dropphyadd": "1260 MAIN ST",
    "dropphycty": "BRILLIANT",
    "dropphyst": "AL",
    "dropphyzpp": 355482000,
    "dropmaladd": "1260 MAIN ST",
    "dropmalcty": "BRILLIANT",
    "dropmalst": "AL",
    "dropmalzpp": 355489998,
    "dropsitphn": 2054659110,
    "dropsitlph": 2054659110,
    "dropsitcph": 2054659110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10156",
    "droptype": "D",
    "dropname": "BROOKSIDE",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "BROOKSIDE",
    "dropdelst": "AL",
    "dropdelzpp": 350362000,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "BROOKSIDE",
    "dropphyst": "AL",
    "dropphyzpp": 350362000,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "BROOKSIDE",
    "dropmalst": "AL",
    "dropmalzpp": 350362000,
    "dropsitphn": 2056741371,
    "dropsitlph": 2056741371,
    "dropsitcph": 2056741371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10157",
    "droptype": "D",
    "dropname": "BROOKWOOD",
    "dropdeladd": "15605 HIGHWAY 216",
    "dropdelcty": "BROOKWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 354443711,
    "dropphyadd": "15605 HIGHWAY 216",
    "dropphycty": "BROOKWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 354443711,
    "dropmaladd": "15605 HIGHWAY 216",
    "dropmalcty": "BROOKWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 354449998,
    "dropsitphn": 2055539838,
    "dropsitlph": 2055539838,
    "dropsitcph": 2055539838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10160",
    "droptype": "D",
    "dropname": "BROWNSBORO",
    "dropdeladd": "121 BROWNSBORO RD",
    "dropdelcty": "BROWNSBORO",
    "dropdelst": "AL",
    "dropdelzpp": 357419471,
    "dropphyadd": "121 BROWNSBORO RD",
    "dropphycty": "BROWNSBORO",
    "dropphyst": "AL",
    "dropphyzpp": 357419471,
    "dropmaladd": "121 BROWNSBORO RD",
    "dropmalcty": "BROWNSBORO",
    "dropmalst": "AL",
    "dropmalzpp": 357419998,
    "dropsitphn": 2567769472,
    "dropsitlph": 2567769472,
    "dropsitcph": 2567769472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10162",
    "droptype": "D",
    "dropname": "BRUNDIDGE",
    "dropdeladd": "129 N MAIN ST",
    "dropdelcty": "BRUNDIDGE",
    "dropdelst": "AL",
    "dropdelzpp": 360109998,
    "dropphyadd": "129 N MAIN ST",
    "dropphycty": "BRUNDIDGE",
    "dropphyst": "AL",
    "dropphyzpp": 360109998,
    "dropmaladd": "129 N MAIN ST",
    "dropmalcty": "BRUNDIDGE",
    "dropmalst": "AL",
    "dropmalzpp": 360109998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3347352569,
    "dropsitcph": 3347352569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10163",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "6366 AL HIGHWAY 73",
    "dropdelcty": "BRYANT",
    "dropdelst": "AL",
    "dropdelzpp": 359584239,
    "dropphyadd": "6366 AL HIGHWAY 73",
    "dropphycty": "BRYANT",
    "dropphyst": "AL",
    "dropphyzpp": 359584239,
    "dropmaladd": "6366 AL HIGHWAY 73",
    "dropmalcty": "BRYANT",
    "dropmalst": "AL",
    "dropmalzpp": 359589998,
    "dropsitphn": 2565972186,
    "dropsitlph": 2565972186,
    "dropsitcph": 2565972186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10165",
    "droptype": "D",
    "dropname": "BUCKS",
    "dropdeladd": "15260 HIGHWAY 43",
    "dropdelcty": "BUCKS",
    "dropdelst": "AL",
    "dropdelzpp": 365122000,
    "dropphyadd": "15260 HIGHWAY 43",
    "dropphycty": "BUCKS",
    "dropphyst": "AL",
    "dropphyzpp": 365122000,
    "dropmaladd": "15260 HIGHWAY 43",
    "dropmalcty": "BUCKS",
    "dropmalst": "AL",
    "dropmalzpp": 365129998,
    "dropsitphn": 2518295420,
    "dropsitlph": 2518295420,
    "dropsitcph": 2518295420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10167",
    "droptype": "D",
    "dropname": "BUHL",
    "dropdeladd": "16512 HIGHWAY 140",
    "dropdelcty": "BUHL",
    "dropdelst": "AL",
    "dropdelzpp": 354469427,
    "dropphyadd": "16512 HIGHWAY 140",
    "dropphycty": "BUHL",
    "dropphyst": "AL",
    "dropphyzpp": 354469427,
    "dropmaladd": "16512 HIGHWAY 140",
    "dropmalcty": "BUHL",
    "dropmalst": "AL",
    "dropmalzpp": 354469998,
    "dropsitphn": 2053330221,
    "dropsitlph": 2053330221,
    "dropsitcph": 2053330221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10175",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "132 RIDERWOOD DR",
    "dropdelcty": "BUTLER",
    "dropdelst": "AL",
    "dropdelzpp": 369049998,
    "dropphyadd": "132 RIDERWOOD DR",
    "dropphycty": "BUTLER",
    "dropphyst": "AL",
    "dropphyzpp": 369049998,
    "dropmaladd": "132 RIDERWOOD DR",
    "dropmalcty": "BUTLER",
    "dropmalst": "AL",
    "dropmalzpp": 369049998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2054592127,
    "dropfax": 2054593061
  },
  {
    "dcode": "D",
    "dropkey": "PY10176",
    "droptype": "D",
    "dropname": "BYNUM",
    "dropdeladd": "2045 BYNUM BLVD",
    "dropdelcty": "BYNUM",
    "dropdelst": "AL",
    "dropdelzpp": 362532001,
    "dropphyadd": "2045 BYNUM BLVD",
    "dropphycty": "BYNUM",
    "dropphyst": "AL",
    "dropphyzpp": 362532001,
    "dropmaladd": "2045 BYNUM BLVD",
    "dropmalcty": "BYNUM",
    "dropmalst": "AL",
    "dropmalzpp": 362532001,
    "dropsitphn": 2562366631,
    "dropsitlph": 2562366631,
    "dropsitcph": 2562366631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10180",
    "droptype": "D",
    "dropname": "CALERA",
    "dropdeladd": "8088 HIGHWAY 31",
    "dropdelcty": "CALERA",
    "dropdelst": "AL",
    "dropdelzpp": 350403900,
    "dropphyadd": "8088 HIGHWAY 31",
    "dropphycty": "CALERA",
    "dropphyst": "AL",
    "dropphyzpp": 350403900,
    "dropmaladd": "8088 HIGHWAY 31",
    "dropmalcty": "CALERA",
    "dropmalst": "AL",
    "dropmalzpp": 350409998,
    "dropsitphn": 2056684263,
    "dropsitlph": 2056684263,
    "dropsitcph": 2056683197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10182",
    "droptype": "D",
    "dropname": "CALVERT",
    "dropdeladd": "170 HIGHWAY 43 N",
    "dropdelcty": "CALVERT",
    "dropdelst": "AL",
    "dropdelzpp": 365132000,
    "dropphyadd": "170 HIGHWAY 43 N",
    "dropphycty": "CALVERT",
    "dropphyst": "AL",
    "dropphyzpp": 365132000,
    "dropmaladd": "170 HIGHWAY 43 N",
    "dropmalcty": "CALVERT",
    "dropmalst": "AL",
    "dropmalzpp": 365139998,
    "dropsitphn": 2518296663,
    "dropsitlph": 2518296663,
    "dropsitcph": 2518296663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10183",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "100 LEGION RD",
    "dropdelcty": "CAMDEN",
    "dropdelst": "AL",
    "dropdelzpp": 367269998,
    "dropphyadd": "100 LEGION RD",
    "dropphycty": "CAMDEN",
    "dropphyst": "AL",
    "dropphyzpp": 367269998,
    "dropmaladd": "100 LEGION RD",
    "dropmalcty": "CAMDEN",
    "dropmalst": "AL",
    "dropmalzpp": 367269998,
    "dropsitphn": 3346824723,
    "dropsitlph": 3346824723,
    "dropsitcph": 3346824723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10184",
    "droptype": "D",
    "dropname": "CAMP HILL",
    "dropdeladd": "328 S MAIN ST",
    "dropdelcty": "CAMP HILL",
    "dropdelst": "AL",
    "dropdelzpp": 368509998,
    "dropphyadd": "328 S MAIN ST",
    "dropphycty": "CAMP HILL",
    "dropphyst": "AL",
    "dropphyzpp": 368509998,
    "dropmaladd": "328 S MAIN ST",
    "dropmalcty": "CAMP HILL",
    "dropmalst": "AL",
    "dropmalzpp": 368509998,
    "dropsitphn": 2568964412,
    "dropsitlph": 2568964412,
    "dropsitcph": 2568964412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10186",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "9 CAMPBELL LN",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "AL",
    "dropdelzpp": 367279998,
    "dropphyadd": "9 CAMPBELL LN",
    "dropphycty": "CAMPBELL",
    "dropphyst": "AL",
    "dropphyzpp": 367279998,
    "dropmaladd": "9 CAMPBELL LN",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "AL",
    "dropmalzpp": 367279998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3346360743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10192",
    "droptype": "D",
    "dropname": "CAPSHAW",
    "dropdeladd": "1108 OLD RAILROAD BED RD",
    "dropdelcty": "CAPSHAW",
    "dropdelst": "AL",
    "dropdelzpp": 357422000,
    "dropphyadd": "1108 OLD RAILROAD BED RD",
    "dropphycty": "CAPSHAW",
    "dropphyst": "AL",
    "dropphyzpp": 357422000,
    "dropmaladd": "1108 OLD RAILROAD BED RD",
    "dropmalcty": "CAPSHAW",
    "dropmalst": "AL",
    "dropmalzpp": 357429998,
    "dropsitphn": 2562337947,
    "dropsitlph": 2562337947,
    "dropsitcph": 2562337947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10193",
    "droptype": "D",
    "dropname": "CARBON HILL",
    "dropdeladd": "170 3RD AVE NW",
    "dropdelcty": "CARBON HILL",
    "dropdelst": "AL",
    "dropdelzpp": 355494603,
    "dropphyadd": "170 3RD AVE NW",
    "dropphycty": "CARBON HILL",
    "dropphyst": "AL",
    "dropphyzpp": 355494603,
    "dropmaladd": "170 3RD AVE NW",
    "dropmalcty": "CARBON HILL",
    "dropmalst": "AL",
    "dropmalzpp": 355499998,
    "dropsitphn": 2059244281,
    "dropsitlph": 2059244281,
    "dropsitcph": 2059244281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10199",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "56 COURT SQ",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "AL",
    "dropdelzpp": 354472059,
    "dropphyadd": "56 COURT SQ",
    "dropphycty": "CARROLLTON",
    "dropphyst": "AL",
    "dropphyzpp": 354472059,
    "dropmaladd": "56 COURT SQ",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "AL",
    "dropmalzpp": 354479998,
    "dropsitphn": 2053678611,
    "dropsitlph": 2053678611,
    "dropsitcph": 2053678611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10202",
    "droptype": "D",
    "dropname": "CASTLEBERRY",
    "dropdeladd": "2742 S JACKSON ST",
    "dropdelcty": "CASTLEBERRY",
    "dropdelst": "AL",
    "dropdelzpp": 364323602,
    "dropphyadd": "2742 S JACKSON ST",
    "dropphycty": "CASTLEBERRY",
    "dropphyst": "AL",
    "dropphyzpp": 364323602,
    "dropmaladd": "2742 S JACKSON ST",
    "dropmalcty": "CASTLEBERRY",
    "dropmalst": "AL",
    "dropmalzpp": 364329998,
    "dropsitphn": 2519665541,
    "dropsitlph": 2519665541,
    "dropsitcph": 2519665541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10203",
    "droptype": "D",
    "dropname": "CATHERINE",
    "dropdeladd": "18001 AL HIGHWAY 5",
    "dropdelcty": "CATHERINE",
    "dropdelst": "AL",
    "dropdelzpp": 367289998,
    "dropphyadd": "18001 AL HIGHWAY 5",
    "dropphycty": "CATHERINE",
    "dropphyst": "AL",
    "dropphyzpp": 367289998,
    "dropmaladd": "18001 AL HIGHWAY 5",
    "dropmalcty": "CATHERINE",
    "dropmalst": "AL",
    "dropmalzpp": 367289998,
    "dropsitphn": 3343260005,
    "dropsitlph": 3343260005,
    "dropsitcph": 3343260005,
    "dropfax": 3343260003
  },
  {
    "dcode": "D",
    "dropkey": "PY10205",
    "droptype": "D",
    "dropname": "CEDAR BLUFF",
    "dropdeladd": "3390 GROVE ST",
    "dropdelcty": "CEDAR BLUFF",
    "dropdelst": "AL",
    "dropdelzpp": 359599998,
    "dropphyadd": "3390 GROVE ST",
    "dropphycty": "CEDAR BLUFF",
    "dropphyst": "AL",
    "dropphyzpp": 359599998,
    "dropmaladd": "3390 GROVE ST",
    "dropmalcty": "CEDAR BLUFF",
    "dropmalst": "AL",
    "dropmalzpp": 359599998,
    "dropsitphn": 2567796568,
    "dropsitlph": 2567796568,
    "dropsitcph": 2567796568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10211",
    "droptype": "D",
    "dropname": "CENTRE",
    "dropdeladd": "850 W MAIN ST",
    "dropdelcty": "CENTRE",
    "dropdelst": "AL",
    "dropdelzpp": 359601226,
    "dropphyadd": "850 W MAIN ST",
    "dropphycty": "CENTRE",
    "dropphyst": "AL",
    "dropphyzpp": 359601226,
    "dropmaladd": "850 W MAIN ST",
    "dropmalcty": "CENTRE",
    "dropmalst": "AL",
    "dropmalzpp": 359609998,
    "dropsitphn": 2569275660,
    "dropsitlph": 2569275660,
    "dropsitcph": 2569275660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10212",
    "droptype": "D",
    "dropname": "CENTREVILLE",
    "dropdeladd": "155 BIRMINGHAM RD STE 100",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350422990,
    "dropphyadd": "155 BIRMINGHAM RD STE 100",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350422990,
    "dropmaladd": "155 BIRMINGHAM RD STE 100",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350429998,
    "dropsitphn": 2059267423,
    "dropsitlph": 2059267423,
    "dropsitcph": 2059267423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10214",
    "droptype": "D",
    "dropname": "CHANCELLOR",
    "dropdeladd": "10701 N STATE HIGHWAY 27",
    "dropdelcty": "CHANCELLOR",
    "dropdelst": "AL",
    "dropdelzpp": 363165002,
    "dropphyadd": "10701 N STATE HIGHWAY 27",
    "dropphycty": "CHANCELLOR",
    "dropphyst": "AL",
    "dropphyzpp": 363165002,
    "dropmaladd": "10701 N STATE HIGHWAY 27",
    "dropmalcty": "CHANCELLOR",
    "dropmalst": "AL",
    "dropmalzpp": 363169998,
    "dropsitphn": 3346842985,
    "dropsitlph": 3346842985,
    "dropsitcph": 3346842985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10215",
    "droptype": "D",
    "dropname": "CHAPMAN",
    "dropdeladd": "12965 MOBILE RD",
    "dropdelcty": "CHAPMAN",
    "dropdelst": "AL",
    "dropdelzpp": 360152000,
    "dropphyadd": "12965 MOBILE RD",
    "dropphycty": "CHAPMAN",
    "dropphyst": "AL",
    "dropphyzpp": 360152000,
    "dropmaladd": "12965 MOBILE RD",
    "dropmalcty": "CHAPMAN",
    "dropmalst": "AL",
    "dropmalzpp": 360159998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3343769241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10217",
    "droptype": "D",
    "dropname": "CHATOM",
    "dropdeladd": "13486 SAINT STEPHENS AVE",
    "dropdelcty": "CHATOM",
    "dropdelst": "AL",
    "dropdelzpp": 365183305,
    "dropphyadd": "13486 SAINT STEPHENS AVE",
    "dropphycty": "CHATOM",
    "dropphyst": "AL",
    "dropphyzpp": 365183305,
    "dropmaladd": "13486 SAINT STEPHENS AVE",
    "dropmalcty": "CHATOM",
    "dropmalst": "AL",
    "dropmalzpp": 365189998,
    "dropsitphn": 2518472847,
    "dropsitlph": 2518472847,
    "dropsitcph": 2512741037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10218",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "16738 HIGHWAY 280",
    "dropdelcty": "CHELSEA",
    "dropdelst": "AL",
    "dropdelzpp": 350431400,
    "dropphyadd": "16738 HIGHWAY 280",
    "dropphycty": "CHELSEA",
    "dropphyst": "AL",
    "dropphyzpp": 350431400,
    "dropmaladd": "16738 HIGHWAY 280",
    "dropmalcty": "CHELSEA",
    "dropmalst": "AL",
    "dropmalzpp": 350439998,
    "dropsitphn": 2056787915,
    "dropsitlph": 2056789392,
    "dropsitcph": 2056787915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10219",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "AL",
    "dropdelzpp": 356167317,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "CHEROKEE",
    "dropphyst": "AL",
    "dropphyzpp": 356167317,
    "dropmaladd": "215 MAIN ST",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "AL",
    "dropmalzpp": 356169998,
    "dropsitphn": 2563594276,
    "dropsitlph": 2563594276,
    "dropsitcph": 2563594276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10222",
    "droptype": "D",
    "dropname": "CHILDERSBURG",
    "dropdeladd": "125 9TH AVE SW",
    "dropdelcty": "CHILDERSBURG",
    "dropdelst": "AL",
    "dropdelzpp": 350441641,
    "dropphyadd": "125 9TH AVE SW",
    "dropphycty": "CHILDERSBURG",
    "dropphyst": "AL",
    "dropphyzpp": 350441641,
    "dropmaladd": "125 9TH AVE SW",
    "dropmalcty": "CHILDERSBURG",
    "dropmalst": "AL",
    "dropmalzpp": 350449998,
    "dropsitphn": 2563787400,
    "dropsitlph": 2563787400,
    "dropsitcph": 2563787400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10224",
    "droptype": "D",
    "dropname": "CHOCCOLOCCO",
    "dropdeladd": "28 MILLIGAN ST",
    "dropdelcty": "CHOCCOLOCCO",
    "dropdelst": "AL",
    "dropdelzpp": 362542000,
    "dropphyadd": "28 MILLIGAN ST",
    "dropphycty": "CHOCCOLOCCO",
    "dropphyst": "AL",
    "dropphyzpp": 362542000,
    "dropmaladd": "28 MILLIGAN ST",
    "dropmalcty": "CHOCCOLOCCO",
    "dropmalst": "AL",
    "dropmalzpp": 362549998,
    "dropsitphn": 2562362002,
    "dropsitlph": 2562362002,
    "dropsitcph": 2562362002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10229",
    "droptype": "D",
    "dropname": "CHUNCHULA",
    "dropdeladd": "11105 ROBERTS RD",
    "dropdelcty": "CHUNCHULA",
    "dropdelst": "AL",
    "dropdelzpp": 365213431,
    "dropphyadd": "11105 ROBERTS RD",
    "dropphycty": "CHUNCHULA",
    "dropphyst": "AL",
    "dropphyzpp": 365213431,
    "dropmaladd": "11105 ROBERTS RD",
    "dropmalcty": "CHUNCHULA",
    "dropmalst": "AL",
    "dropmalzpp": 365219998,
    "dropsitphn": 2516757498,
    "dropsitlph": 2516757498,
    "dropsitcph": 2516757498,
    "dropfax": 2516757492
  },
  {
    "dcode": "D",
    "dropkey": "PY10230",
    "droptype": "D",
    "dropname": "CITRONELLE",
    "dropdeladd": "8165 FORREST ST",
    "dropdelcty": "CITRONELLE",
    "dropdelst": "AL",
    "dropdelzpp": 365223003,
    "dropphyadd": "8165 FORREST ST",
    "dropphycty": "CITRONELLE",
    "dropphyst": "AL",
    "dropphyzpp": 365223003,
    "dropmaladd": "8165 FORREST ST",
    "dropmalcty": "CITRONELLE",
    "dropmalst": "AL",
    "dropmalzpp": 365229998,
    "dropsitphn": 2518665499,
    "dropsitlph": 2518665499,
    "dropsitcph": 2518665499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10232",
    "droptype": "D",
    "dropname": "CLANTON",
    "dropdeladd": "608 6TH ST S",
    "dropdelcty": "CLANTON",
    "dropdelst": "AL",
    "dropdelzpp": 350453533,
    "dropphyadd": "608 6TH ST S",
    "dropphycty": "CLANTON",
    "dropphyst": "AL",
    "dropphyzpp": 350453533,
    "dropmaladd": "608 6TH ST S",
    "dropmalcty": "CLANTON",
    "dropmalst": "AL",
    "dropmalzpp": 350459998,
    "dropsitphn": 2057550320,
    "dropsitlph": 2057550320,
    "dropsitcph": 2057550320,
    "dropfax": 2052800035
  },
  {
    "dcode": "D",
    "dropkey": "PY10233",
    "droptype": "D",
    "dropname": "CLAY",
    "dropdeladd": "6721 OLD SPRINGVILLE RD",
    "dropdelcty": "CLAY",
    "dropdelst": "AL",
    "dropdelzpp": 350482000,
    "dropphyadd": "6721 OLD SPRINGVILLE RD",
    "dropphycty": "CLAY",
    "dropphyst": "AL",
    "dropphyzpp": 350482000,
    "dropmaladd": "6721 OLD SPRINGVILLE RD",
    "dropmalcty": "CLAY",
    "dropmalst": "AL",
    "dropmalzpp": 350489998,
    "dropsitphn": 2056813795,
    "dropsitlph": 2056813795,
    "dropsitcph": 2056813795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10235",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "15 S MIDWAY ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "AL",
    "dropdelzpp": 360169998,
    "dropphyadd": "15 S MIDWAY ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "AL",
    "dropphyzpp": 360169998,
    "dropmaladd": "15 S MIDWAY ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "AL",
    "dropmalzpp": 360169998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347759361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10236",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "18095 STATE HIGHWAY 160",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "AL",
    "dropdelzpp": 350493684,
    "dropphyadd": "18095 STATE HIGHWAY 160",
    "dropphycty": "CLEVELAND",
    "dropphyst": "AL",
    "dropphyzpp": 350493684,
    "dropmaladd": "18095 STATE HIGHWAY 160",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "AL",
    "dropmalzpp": 350499998,
    "dropsitphn": 2052747702,
    "dropsitlph": 2052747702,
    "dropsitcph": 2052747702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10237",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "12975 AL HIGHWAY 14",
    "dropdelcty": "CLINTON",
    "dropdelst": "AL",
    "dropdelzpp": 354482001,
    "dropphyadd": "12975 AL HIGHWAY 14",
    "dropphycty": "CLINTON",
    "dropphyst": "AL",
    "dropphyzpp": 354482001,
    "dropmaladd": "12975 AL HIGHWAY 14",
    "dropmalcty": "CLINTON",
    "dropmalst": "AL",
    "dropmalzpp": 354489998,
    "dropsitphn": 2053722915,
    "dropsitlph": 2053722915,
    "dropsitcph": 2053722915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10238",
    "droptype": "D",
    "dropname": "CLIO",
    "dropdeladd": "1207 BLUE SPRINGS ST",
    "dropdelcty": "CLIO",
    "dropdelst": "AL",
    "dropdelzpp": 360179998,
    "dropphyadd": "1207 BLUE SPRINGS ST",
    "dropphycty": "CLIO",
    "dropphyst": "AL",
    "dropphyzpp": 360179998,
    "dropmaladd": "1207 BLUE SPRINGS ST",
    "dropmalcty": "CLIO",
    "dropmalst": "AL",
    "dropmalzpp": 360179998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3343972314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10240",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "11440 HIGHWAY 157",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "AL",
    "dropdelzpp": 356172000,
    "dropphyadd": "11440 HIGHWAY 157",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "AL",
    "dropphyzpp": 356172000,
    "dropmaladd": "11440 HIGHWAY 157",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "AL",
    "dropmalzpp": 356179998,
    "dropsitphn": 2567662889,
    "dropsitlph": 2567662889,
    "dropsitcph": 2567662889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10245",
    "droptype": "D",
    "dropname": "COALING",
    "dropdeladd": "11153 HAGLER COALING RD",
    "dropdelcty": "COALING",
    "dropdelst": "AL",
    "dropdelzpp": 354492000,
    "dropphyadd": "11153 HAGLER COALING RD",
    "dropphycty": "COALING",
    "dropphyst": "AL",
    "dropphyzpp": 354492000,
    "dropmaladd": "11153 HAGLER COALING RD",
    "dropmalcty": "COALING",
    "dropmalst": "AL",
    "dropmalzpp": 354499998,
    "dropsitphn": 2055532606,
    "dropsitlph": 2055532606,
    "dropsitcph": 2055532606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10249",
    "droptype": "D",
    "dropname": "CODEN",
    "dropdeladd": "7970 HIGHWAY 188",
    "dropdelcty": "CODEN",
    "dropdelst": "AL",
    "dropdelzpp": 365233216,
    "dropphyadd": "7970 HIGHWAY 188",
    "dropphycty": "CODEN",
    "dropphyst": "AL",
    "dropphyzpp": 365233216,
    "dropmaladd": "7970 HIGHWAY 188",
    "dropmalcty": "CODEN",
    "dropmalst": "AL",
    "dropmalzpp": 365239998,
    "dropsitphn": 2518242031,
    "dropsitlph": 2518242031,
    "dropsitcph": 2518242031,
    "dropfax": 2518242067
  },
  {
    "dcode": "D",
    "dropkey": "PY10250",
    "droptype": "D",
    "dropname": "COFFEE SPRINGS",
    "dropdeladd": "147 N MAIN ST",
    "dropdelcty": "COFFEE SPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 363185001,
    "dropphyadd": "147 N MAIN ST",
    "dropphycty": "COFFEE SPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 363185001,
    "dropmaladd": "147 N MAIN ST",
    "dropmalcty": "COFFEE SPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 363189998,
    "dropsitphn": 3346842921,
    "dropsitlph": 3346842921,
    "dropsitcph": 3346842921,
    "dropfax": 3346840367
  },
  {
    "dcode": "D",
    "dropkey": "PY10251",
    "droptype": "D",
    "dropname": "COFFEEVILLE",
    "dropdeladd": "57 RIVER ST E",
    "dropdelcty": "COFFEEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 365245003,
    "dropphyadd": "57 RIVER ST E",
    "dropphycty": "COFFEEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 365245003,
    "dropmaladd": "57 RIVER ST E",
    "dropmalcty": "COFFEEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 365249998,
    "dropsitphn": 2512763240,
    "dropsitlph": 2512763240,
    "dropsitcph": 2512763240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10252",
    "droptype": "D",
    "dropname": "COKER",
    "dropdeladd": "14585 ROMULUS RD",
    "dropdelcty": "COKER",
    "dropdelst": "AL",
    "dropdelzpp": 354523165,
    "dropphyadd": "14585 ROMULUS RD",
    "dropphycty": "COKER",
    "dropphyst": "AL",
    "dropphyzpp": 354523165,
    "dropmaladd": "14585 ROMULUS RD",
    "dropmalcty": "COKER",
    "dropmalst": "AL",
    "dropmalzpp": 354523165,
    "dropsitphn": 2053393059,
    "dropsitlph": 2053393059,
    "dropsitcph": 2053393059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10253",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "10 POST OFFICE ST",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359613312,
    "dropphyadd": "10 POST OFFICE ST",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359613312,
    "dropmaladd": "10 POST OFFICE ST",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359619998,
    "dropsitphn": 2565242190,
    "dropsitlph": 2565242190,
    "dropsitcph": 2565242190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10257",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "AL",
    "dropdelzpp": 363193628,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "AL",
    "dropphyzpp": 363193628,
    "dropmaladd": "106 N MAIN ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "AL",
    "dropmalzpp": 363199998,
    "dropsitphn": 3346964608,
    "dropsitlph": 3346964608,
    "dropsitcph": 3346964608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10258",
    "droptype": "D",
    "dropname": "COLUMBIANA",
    "dropdeladd": "210 W COLLEGE ST",
    "dropdelcty": "COLUMBIANA",
    "dropdelst": "AL",
    "dropdelzpp": 350519734,
    "dropphyadd": "210 W COLLEGE ST",
    "dropphycty": "COLUMBIANA",
    "dropphyst": "AL",
    "dropphyzpp": 350519734,
    "dropmaladd": "210 W COLLEGE ST",
    "dropmalcty": "COLUMBIANA",
    "dropmalst": "AL",
    "dropmalzpp": 350519998,
    "dropsitphn": 2056697726,
    "dropsitlph": 2056697726,
    "dropsitcph": 2056697726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10263",
    "droptype": "D",
    "dropname": "COOSADA",
    "dropdeladd": "5798 COOSADA RD",
    "dropdelcty": "COOSADA",
    "dropdelst": "AL",
    "dropdelzpp": 360209998,
    "dropphyadd": "5798 COOSADA RD",
    "dropphycty": "COOSADA",
    "dropphyst": "AL",
    "dropphyzpp": 360209998,
    "dropmaladd": "5798 COOSADA RD",
    "dropmalcty": "COOSADA",
    "dropmalst": "AL",
    "dropmalzpp": 360209998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342853632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10265",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "10 BREWER ST",
    "dropdelcty": "CORDOVA",
    "dropdelst": "AL",
    "dropdelzpp": 355501256,
    "dropphyadd": "10 BREWER ST",
    "dropphycty": "CORDOVA",
    "dropphyst": "AL",
    "dropphyzpp": 355501256,
    "dropmaladd": "10 BREWER ST",
    "dropmalcty": "CORDOVA",
    "dropmalst": "AL",
    "dropmalzpp": 355509998,
    "dropsitphn": 2054836206,
    "dropsitlph": 2054836206,
    "dropsitcph": 2054836206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10271",
    "droptype": "D",
    "dropname": "COTTONDALE",
    "dropdeladd": "3101 BUTTERMILK RD",
    "dropdelcty": "COTTONDALE",
    "dropdelst": "AL",
    "dropdelzpp": 354530001,
    "dropphyadd": "3101 BUTTERMILK RD",
    "dropphycty": "COTTONDALE",
    "dropphyst": "AL",
    "dropphyzpp": 354530001,
    "dropmaladd": "3101 BUTTERMILK RD",
    "dropmalcty": "COTTONDALE",
    "dropmalst": "AL",
    "dropmalzpp": 354539998,
    "dropsitphn": 2055534297,
    "dropsitlph": 2055538451,
    "dropsitcph": 2055534297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10272",
    "droptype": "D",
    "dropname": "COTTONTON",
    "dropdeladd": "1 COTTONTON RD",
    "dropdelcty": "COTTONTON",
    "dropdelst": "AL",
    "dropdelzpp": 368519998,
    "dropphyadd": "1 COTTONTON RD",
    "dropphycty": "COTTONTON",
    "dropphyst": "AL",
    "dropphyzpp": 368519998,
    "dropmaladd": "1 COTTONTON RD",
    "dropmalcty": "COTTONTON",
    "dropmalst": "AL",
    "dropmalzpp": 368519998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3348552171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10273",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "53 JOE COOK ST",
    "dropdelcty": "COTTONWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 363204283,
    "dropphyadd": "53 JOE COOK ST",
    "dropphycty": "COTTONWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 363204283,
    "dropmaladd": "53 JOE COOK ST",
    "dropmalcty": "COTTONWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 363209998,
    "dropsitphn": 3346912669,
    "dropsitlph": 3346912669,
    "dropsitcph": 3346912669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10274",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "361 ALABAMA ST",
    "dropdelcty": "COURTLAND",
    "dropdelst": "AL",
    "dropdelzpp": 356183346,
    "dropphyadd": "361 ALABAMA ST",
    "dropphycty": "COURTLAND",
    "dropphyst": "AL",
    "dropphyzpp": 356183346,
    "dropmaladd": "361 ALABAMA ST",
    "dropmalcty": "COURTLAND",
    "dropmalst": "AL",
    "dropmalzpp": 356189998,
    "dropsitphn": 2566373016,
    "dropsitlph": 2566373016,
    "dropsitcph": 2566373016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10275",
    "droptype": "D",
    "dropname": "COWARTS",
    "dropdeladd": "2935 JORDON AVE",
    "dropdelcty": "COWARTS",
    "dropdelst": "AL",
    "dropdelzpp": 363214219,
    "dropphyadd": "2935 JORDON AVE",
    "dropphycty": "COWARTS",
    "dropphyst": "AL",
    "dropphyzpp": 363214219,
    "dropmaladd": "2935 JORDON AVE",
    "dropmalcty": "COWARTS",
    "dropmalst": "AL",
    "dropmalzpp": 363219998,
    "dropsitphn": 3347941153,
    "dropsitlph": 3347941153,
    "dropsitcph": 3347941153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10276",
    "droptype": "D",
    "dropname": "COY",
    "dropdeladd": "5092 J M BROOKS RD",
    "dropdelcty": "COY",
    "dropdelst": "AL",
    "dropdelzpp": 364355050,
    "dropphyadd": "5092 J M BROOKS RD",
    "dropphycty": "COY",
    "dropphyst": "AL",
    "dropphyzpp": 364355050,
    "dropmaladd": "5092 J M BROOKS RD",
    "dropmalcty": "COY",
    "dropmalst": "AL",
    "dropmalzpp": 364359998,
    "dropsitphn": 3343374557,
    "dropsitlph": 3343374557,
    "dropsitcph": 3343374557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10277",
    "droptype": "D",
    "dropname": "CRAGFORD",
    "dropdeladd": "11304 CRAGFORD RD",
    "dropdelcty": "CRAGFORD",
    "dropdelst": "AL",
    "dropdelzpp": 362556038,
    "dropphyadd": "11304 CRAGFORD RD",
    "dropphycty": "CRAGFORD",
    "dropphyst": "AL",
    "dropphyzpp": 362556038,
    "dropmaladd": "11304 CRAGFORD RD",
    "dropmalcty": "CRAGFORD",
    "dropmalst": "AL",
    "dropmalzpp": 362556038,
    "dropsitphn": 2563965778,
    "dropsitlph": 2563965778,
    "dropsitcph": 2563965778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10280",
    "droptype": "D",
    "dropname": "CRANE HILL",
    "dropdeladd": "15051 COUNTY ROAD 222",
    "dropdelcty": "CRANE HILL",
    "dropdelst": "AL",
    "dropdelzpp": 350533209,
    "dropphyadd": "15051 COUNTY ROAD 222",
    "dropphycty": "CRANE HILL",
    "dropphyst": "AL",
    "dropphyzpp": 350533209,
    "dropmaladd": "15051 COUNTY ROAD 222",
    "dropmalcty": "CRANE HILL",
    "dropmalst": "AL",
    "dropmalzpp": 350539998,
    "dropsitphn": 2567472410,
    "dropsitlph": 2567472410,
    "dropsitcph": 2567472410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10281",
    "droptype": "D",
    "dropname": "CREOLA",
    "dropdeladd": "9617 OLD HIGHWAY 43",
    "dropdelcty": "CREOLA",
    "dropdelst": "AL",
    "dropdelzpp": 365254538,
    "dropphyadd": "9617 OLD HIGHWAY 43",
    "dropphycty": "CREOLA",
    "dropphyst": "AL",
    "dropphyzpp": 365254538,
    "dropmaladd": "9617 OLD HIGHWAY 43",
    "dropmalcty": "CREOLA",
    "dropmalst": "AL",
    "dropmalzpp": 365259998,
    "dropsitphn": 2516750672,
    "dropsitlph": 2516750672,
    "dropsitcph": 2516750672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10286",
    "droptype": "D",
    "dropname": "CROPWELL",
    "dropdeladd": "2600 STEMLEY BRIDGE RD",
    "dropdelcty": "CROPWELL",
    "dropdelst": "AL",
    "dropdelzpp": 350543844,
    "dropphyadd": "2600 STEMLEY BRIDGE RD",
    "dropphycty": "CROPWELL",
    "dropphyst": "AL",
    "dropphyzpp": 350543844,
    "dropmaladd": "2600 STEMLEY BRIDGE RD",
    "dropmalcty": "CROPWELL",
    "dropmalst": "AL",
    "dropmalzpp": 350549998,
    "dropsitphn": 2058149821,
    "dropsitlph": 2058140422,
    "dropsitcph": 2058149821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10288",
    "droptype": "D",
    "dropname": "CROSSVILLE",
    "dropdeladd": "13856 AL HIGHWAY 68",
    "dropdelcty": "CROSSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359623235,
    "dropphyadd": "13856 AL HIGHWAY 68",
    "dropphycty": "CROSSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359623235,
    "dropmaladd": "13856 AL HIGHWAY 68",
    "dropmalcty": "CROSSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359629998,
    "dropsitphn": 2565287156,
    "dropsitlph": 2565287156,
    "dropsitcph": 2565287156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10291",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "404 THIRD ST",
    "dropdelcty": "CUBA",
    "dropdelst": "AL",
    "dropdelzpp": 369079998,
    "dropphyadd": "404 THIRD ST",
    "dropphycty": "CUBA",
    "dropphyst": "AL",
    "dropphyzpp": 369079998,
    "dropmaladd": "404 THIRD ST",
    "dropmalcty": "CUBA",
    "dropmalst": "AL",
    "dropmalzpp": 369079998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6592155202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10292",
    "droptype": "D",
    "dropname": "CULLMAN",
    "dropdeladd": "500 MAIN AVE SW",
    "dropdelcty": "CULLMAN",
    "dropdelst": "AL",
    "dropdelzpp": 350554736,
    "dropphyadd": "500 MAIN AVE SW",
    "dropphycty": "CULLMAN",
    "dropphyst": "AL",
    "dropphyzpp": 350554736,
    "dropmaladd": "500 MAIN AVE SW",
    "dropmalcty": "CULLMAN",
    "dropmalst": "AL",
    "dropmalzpp": 350559998,
    "dropsitphn": 2567346633,
    "dropsitlph": 2567346633,
    "dropsitcph": 2567346633,
    "dropfax": 2567342282
  },
  {
    "dcode": "D",
    "dropkey": "PY10293",
    "droptype": "D",
    "dropname": "CUSSETA",
    "dropdeladd": "3200 COUNTY ROAD 83",
    "dropdelcty": "CUSSETA",
    "dropdelst": "AL",
    "dropdelzpp": 368529998,
    "dropphyadd": "3200 COUNTY ROAD 83",
    "dropphycty": "CUSSETA",
    "dropphyst": "AL",
    "dropphyzpp": 368529998,
    "dropmaladd": "3200 COUNTY ROAD 83",
    "dropmalcty": "CUSSETA",
    "dropmalst": "AL",
    "dropmalzpp": 368529998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347453069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10296",
    "droptype": "D",
    "dropname": "DADEVILLE",
    "dropdeladd": "140 S SPRING ST",
    "dropdelcty": "DADEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 368539998,
    "dropphyadd": "140 S SPRING ST",
    "dropphycty": "DADEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 368539998,
    "dropmaladd": "140 S SPRING ST",
    "dropmalcty": "DADEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 368539998,
    "dropsitphn": 2562447515,
    "dropsitlph": 2568256011,
    "dropsitcph": 2568256011,
    "dropfax": 2568256177
  },
  {
    "dcode": "D",
    "dropkey": "PY10299",
    "droptype": "D",
    "dropname": "DALEVILLE",
    "dropdeladd": "100 VIRGINIA AVE",
    "dropdelcty": "DALEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 363222304,
    "dropphyadd": "100 VIRGINIA AVE",
    "dropphycty": "DALEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 363222304,
    "dropmaladd": "100 VIRGINIA AVE",
    "dropmalcty": "DALEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 363229998,
    "dropsitphn": 3345984995,
    "dropsitlph": 3345984995,
    "dropsitcph": 3345984995,
    "dropfax": 3345984889
  },
  {
    "dcode": "D",
    "dropkey": "PY10301",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "5652 HIGHWAY 36 W",
    "dropdelcty": "DANVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356196613,
    "dropphyadd": "5652 HIGHWAY 36 W",
    "dropphycty": "DANVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356196613,
    "dropmaladd": "5652 HIGHWAY 36 W",
    "dropmalcty": "DANVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356199998,
    "dropsitphn": 2567730037,
    "dropsitlph": 2567730037,
    "dropsitcph": 2567730037,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10304",
    "droptype": "D",
    "dropname": "DAPHNE",
    "dropdeladd": "808 DAPHNE AVE",
    "dropdelcty": "DAPHNE",
    "dropdelst": "AL",
    "dropdelzpp": 365264291,
    "dropphyadd": "808 DAPHNE AVE",
    "dropphycty": "DAPHNE",
    "dropphyst": "AL",
    "dropphyzpp": 365264291,
    "dropmaladd": "808 DAPHNE AVE",
    "dropmalcty": "DAPHNE",
    "dropmalst": "AL",
    "dropmalzpp": 365269998,
    "dropsitphn": 2516217314,
    "dropsitlph": 2516217314,
    "dropsitcph": 2516217314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10307",
    "droptype": "D",
    "dropname": "DAUPHIN ISLAND",
    "dropdeladd": "423 LA VENTE ST",
    "dropdelcty": "DAUPHIN ISLAND",
    "dropdelst": "AL",
    "dropdelzpp": 365282000,
    "dropphyadd": "423 LA VENTE ST",
    "dropphycty": "DAUPHIN ISLAND",
    "dropphyst": "AL",
    "dropphyzpp": 365282000,
    "dropmaladd": "423 LA VENTE ST",
    "dropmalcty": "DAUPHIN ISLAND",
    "dropmalst": "AL",
    "dropmalzpp": 365289998,
    "dropsitphn": 2518612702,
    "dropsitlph": 2518612702,
    "dropsitcph": 2518612702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10308",
    "droptype": "D",
    "dropname": "DAVISTON",
    "dropdeladd": "22960 HIGHWAY 22 E",
    "dropdelcty": "DAVISTON",
    "dropdelst": "AL",
    "dropdelzpp": 362566240,
    "dropphyadd": "22960 HIGHWAY 22 E",
    "dropphycty": "DAVISTON",
    "dropphyst": "AL",
    "dropphyzpp": 362566240,
    "dropmaladd": "22960 HIGHWAY 22 E",
    "dropmalcty": "DAVISTON",
    "dropmalst": "AL",
    "dropmalzpp": 362569998,
    "dropsitphn": 2563952266,
    "dropsitlph": 2563952266,
    "dropsitcph": 2563952266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10309",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "59 COUNTY ROAD 57",
    "dropdelcty": "DAWSON",
    "dropdelst": "AL",
    "dropdelzpp": 359633068,
    "dropphyadd": "59 COUNTY ROAD 57",
    "dropphycty": "DAWSON",
    "dropphyst": "AL",
    "dropphyzpp": 359633068,
    "dropmaladd": "59 COUNTY ROAD 57",
    "dropmalcty": "DAWSON",
    "dropmalst": "AL",
    "dropmalzpp": 359639998,
    "dropsitphn": 2566594727,
    "dropsitlph": 2566594727,
    "dropsitcph": 2563007336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10311",
    "droptype": "D",
    "dropname": "DE ARMANVILLE",
    "dropdeladd": "661 DE ARMANVILLE RD",
    "dropdelcty": "DE ARMANVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 362572001,
    "dropphyadd": "661 DE ARMANVILLE RD",
    "dropphycty": "DE ARMANVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 362572001,
    "dropmaladd": "661 DE ARMANVILLE RD",
    "dropmalcty": "DE ARMANVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 362579998,
    "dropsitphn": 2568310820,
    "dropsitlph": 2568310820,
    "dropsitcph": 2568310820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10315",
    "droptype": "D",
    "dropname": "DEATSVILLE",
    "dropdeladd": "7510 DEATSVILLE HWY",
    "dropdelcty": "DEATSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360229998,
    "dropphyadd": "7510 DEATSVILLE HWY",
    "dropphycty": "DEATSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360229998,
    "dropmaladd": "7510 DEATSVILLE HWY",
    "dropmalcty": "DEATSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360229998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342856800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10318",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "400 WELL ST NE",
    "dropdelcty": "DECATUR",
    "dropdelst": "AL",
    "dropdelzpp": 356011951,
    "dropphyadd": "400 WELL ST NE",
    "dropphycty": "DECATUR",
    "dropphyst": "AL",
    "dropphyzpp": 356011951,
    "dropmaladd": "400 WELL ST NE",
    "dropmalcty": "DECATUR",
    "dropmalst": "AL",
    "dropmalzpp": 356019998,
    "dropsitphn": 2563551211,
    "dropsitlph": 2563551211,
    "dropsitcph": 2563551211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10320",
    "droptype": "D",
    "dropname": "DEER PARK",
    "dropdeladd": "342 DEER PARK BURBANK RD",
    "dropdelcty": "DEER PARK",
    "dropdelst": "AL",
    "dropdelzpp": 365297000,
    "dropphyadd": "342 DEER PARK BURBANK RD",
    "dropphycty": "DEER PARK",
    "dropphyst": "AL",
    "dropphyzpp": 365297000,
    "dropmaladd": "342 DEER PARK BURBANK RD",
    "dropmalcty": "DEER PARK",
    "dropmalst": "AL",
    "dropmalzpp": 365299998,
    "dropsitphn": 2517778821,
    "dropsitlph": 2517778821,
    "dropsitcph": 2517778821,
    "dropfax": 2517778821
  },
  {
    "dcode": "D",
    "dropkey": "PY10322",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "99145 HIGHWAY 9",
    "dropdelcty": "DELTA",
    "dropdelst": "AL",
    "dropdelzpp": 362585407,
    "dropphyadd": "99145 HIGHWAY 9",
    "dropphycty": "DELTA",
    "dropphyst": "AL",
    "dropphyzpp": 362585407,
    "dropmaladd": "99145 HIGHWAY 9",
    "dropmalcty": "DELTA",
    "dropmalst": "AL",
    "dropmalzpp": 362589998,
    "dropsitphn": 2564885848,
    "dropsitlph": 2564885848,
    "dropsitcph": 2564885848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10323",
    "droptype": "D",
    "dropname": "DEMOPOLIS",
    "dropdeladd": "100 W CAPITOL ST",
    "dropdelcty": "DEMOPOLIS",
    "dropdelst": "AL",
    "dropdelzpp": 367329998,
    "dropphyadd": "100 W CAPITOL ST",
    "dropphycty": "DEMOPOLIS",
    "dropphyst": "AL",
    "dropphyzpp": 367329998,
    "dropmaladd": "100 W CAPITOL ST",
    "dropmalcty": "DEMOPOLIS",
    "dropmalst": "AL",
    "dropmalzpp": 367329998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342890450,
    "dropsitcph": 3342890450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10325",
    "droptype": "D",
    "dropname": "DETROIT",
    "dropdeladd": "65910 HIGHWAY 17",
    "dropdelcty": "DETROIT",
    "dropdelst": "AL",
    "dropdelzpp": 355522223,
    "dropphyadd": "65910 HIGHWAY 17",
    "dropphycty": "DETROIT",
    "dropphyst": "AL",
    "dropphyzpp": 355522223,
    "dropmaladd": "65910 HIGHWAY 17",
    "dropmalcty": "DETROIT",
    "dropmalst": "AL",
    "dropmalzpp": 355529998,
    "dropsitphn": 2052734227,
    "dropsitlph": 2052734227,
    "dropsitcph": 2052734227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10331",
    "droptype": "D",
    "dropname": "DIXONS MILLS",
    "dropdeladd": "5114 US HIGHWAY 43",
    "dropdelcty": "DIXONS MILLS",
    "dropdelst": "AL",
    "dropdelzpp": 367369998,
    "dropphyadd": "5114 US HIGHWAY 43",
    "dropphycty": "DIXONS MILLS",
    "dropphyst": "AL",
    "dropphyzpp": 367369998,
    "dropmaladd": "5114 US HIGHWAY 43",
    "dropmalcty": "DIXONS MILLS",
    "dropmalst": "AL",
    "dropmalzpp": 367369998,
    "dropsitphn": 3349922102,
    "dropsitlph": 3342447515,
    "dropsitcph": 3349922102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10334",
    "droptype": "D",
    "dropname": "DOCENA",
    "dropdeladd": "305 CIRCLE DR",
    "dropdelcty": "DOCENA",
    "dropdelst": "AL",
    "dropdelzpp": 350602000,
    "dropphyadd": "305 CIRCLE DR",
    "dropphycty": "DOCENA",
    "dropphyst": "AL",
    "dropphyzpp": 350602000,
    "dropmaladd": "305 CIRCLE DR",
    "dropmalcty": "DOCENA",
    "dropmalst": "AL",
    "dropmalzpp": 350609998,
    "dropsitphn": 2057988550,
    "dropsitlph": 2057988550,
    "dropsitcph": 2057988550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10335",
    "droptype": "D",
    "dropname": "DOLOMITE",
    "dropdeladd": "827 ALLISON BONNETT MEMORIAL DR",
    "dropdelcty": "DOLOMITE",
    "dropdelst": "AL",
    "dropdelzpp": 350611170,
    "dropphyadd": "827 ALLISON BONNETT MEMORIAL DR",
    "dropphycty": "DOLOMITE",
    "dropphyst": "AL",
    "dropphyzpp": 350611170,
    "dropmaladd": "827 ALLISON BONNETT MEMORIAL DR",
    "dropmalcty": "DOLOMITE",
    "dropmalst": "AL",
    "dropmalzpp": 350619998,
    "dropsitphn": 2057445761,
    "dropsitlph": 2057448159,
    "dropsitcph": 2057445761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10336",
    "droptype": "D",
    "dropname": "DORA",
    "dropdeladd": "975 SHARON BLVD",
    "dropdelcty": "DORA",
    "dropdelst": "AL",
    "dropdelzpp": 350624542,
    "dropphyadd": "975 SHARON BLVD",
    "dropphycty": "DORA",
    "dropphyst": "AL",
    "dropphyzpp": 350624542,
    "dropmaladd": "975 SHARON BLVD",
    "dropmalcty": "DORA",
    "dropmalst": "AL",
    "dropmalzpp": 350629998,
    "dropsitphn": 2056486650,
    "dropsitlph": 2056486650,
    "dropsitcph": 2056486650,
    "dropfax": 2056481700
  },
  {
    "dcode": "D",
    "dropkey": "PY10339",
    "droptype": "D",
    "dropname": "DOTHAN",
    "dropdeladd": "379 N OATES ST",
    "dropdelcty": "DOTHAN",
    "dropdelst": "AL",
    "dropdelzpp": 363024500,
    "dropphyadd": "379 N OATES ST",
    "dropphycty": "DOTHAN",
    "dropphyst": "AL",
    "dropphyzpp": 363029998,
    "dropmaladd": "379 N OATES ST",
    "dropmalcty": "DOTHAN",
    "dropmalst": "AL",
    "dropmalzpp": 363029998,
    "dropsitphn": 3347948567,
    "dropsitlph": 3347948567,
    "dropsitcph": 3347948567,
    "dropfax": 3347941032
  },
  {
    "dcode": "D",
    "dropkey": "PY10341",
    "droptype": "D",
    "dropname": "DOUBLE SPRINGS",
    "dropdeladd": "22 LYNN RD",
    "dropdelcty": "DOUBLE SPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 355532258,
    "dropphyadd": "22 LYNN RD",
    "dropphycty": "DOUBLE SPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 355532258,
    "dropmaladd": "22 LYNN RD",
    "dropmalcty": "DOUBLE SPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 355539998,
    "dropsitphn": 2054892126,
    "dropsitlph": 2054892126,
    "dropsitcph": 2054892126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10342",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "9365 AL HIGHWAY 75",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "AL",
    "dropdelzpp": 359645000,
    "dropphyadd": "9365 AL HIGHWAY 75",
    "dropphycty": "DOUGLAS",
    "dropphyst": "AL",
    "dropphyzpp": 359645000,
    "dropmaladd": "9365 AL HIGHWAY 75",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "AL",
    "dropmalzpp": 359649998,
    "dropsitphn": 2565934522,
    "dropsitlph": 2565934522,
    "dropsitcph": 2565934522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10347",
    "droptype": "D",
    "dropname": "DOZIER",
    "dropdeladd": "7787 S MAIN ST",
    "dropdelcty": "DOZIER",
    "dropdelst": "AL",
    "dropdelzpp": 360289998,
    "dropphyadd": "7787 S MAIN ST",
    "dropphycty": "DOZIER",
    "dropphyst": "AL",
    "dropphyzpp": 360289998,
    "dropmaladd": "7787 S MAIN ST",
    "dropmalcty": "DOZIER",
    "dropmalst": "AL",
    "dropmalzpp": 360289998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3344963769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10349",
    "droptype": "D",
    "dropname": "DUNCANVILLE",
    "dropdeladd": "12108 HIGHWAY 82 E",
    "dropdelcty": "DUNCANVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 354561602,
    "dropphyadd": "12108 HIGHWAY 82 E",
    "dropphycty": "DUNCANVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 354561602,
    "dropmaladd": "12108 HIGHWAY 82 E",
    "dropmalcty": "DUNCANVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 354569998,
    "dropsitphn": 2057524414,
    "dropsitlph": 2057524414,
    "dropsitcph": 2057524414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10353",
    "droptype": "D",
    "dropname": "DUTTON",
    "dropdeladd": "4496 AL HIGHWAY 71",
    "dropdelcty": "DUTTON",
    "dropdelst": "AL",
    "dropdelzpp": 357448651,
    "dropphyadd": "4496 AL HIGHWAY 71",
    "dropphycty": "DUTTON",
    "dropphyst": "AL",
    "dropphyzpp": 357448651,
    "dropmaladd": "4496 AL HIGHWAY 71",
    "dropmalcty": "DUTTON",
    "dropmalst": "AL",
    "dropmalzpp": 357449998,
    "dropsitphn": 2562283796,
    "dropsitlph": 2562283796,
    "dropsitcph": 2563887952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10362",
    "droptype": "D",
    "dropname": "EASTABOGA",
    "dropdeladd": "10329 US HIGHWAY 78 W",
    "dropdelcty": "EASTABOGA",
    "dropdelst": "AL",
    "dropdelzpp": 362605749,
    "dropphyadd": "10329 US HIGHWAY 78 W",
    "dropphycty": "EASTABOGA",
    "dropphyst": "AL",
    "dropphyzpp": 362605749,
    "dropmaladd": "10329 US HIGHWAY 78 W",
    "dropmalcty": "EASTABOGA",
    "dropmalst": "AL",
    "dropmalzpp": 362609998,
    "dropsitphn": 2568316262,
    "dropsitlph": 2568316262,
    "dropsitcph": 2568316262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10366",
    "droptype": "D",
    "dropname": "ECHOLA",
    "dropdeladd": "14930 ECHOLA RD",
    "dropdelcty": "ECHOLA",
    "dropdelst": "AL",
    "dropdelzpp": 354579998,
    "dropphyadd": "14930 ECHOLA RD",
    "dropphycty": "ECHOLA",
    "dropphyst": "AL",
    "dropphyzpp": 354579998,
    "dropmaladd": "14930 ECHOLA RD",
    "dropmalcty": "ECHOLA",
    "dropmalst": "AL",
    "dropmalzpp": 354579998,
    "dropsitphn": 2053390373,
    "dropsitlph": 2053390373,
    "dropsitcph": 2053390373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10367",
    "droptype": "D",
    "dropname": "ECLECTIC",
    "dropdeladd": "473 KOWALIGA RD",
    "dropdelcty": "ECLECTIC",
    "dropdelst": "AL",
    "dropdelzpp": 360249998,
    "dropphyadd": "473 KOWALIGA RD",
    "dropphycty": "ECLECTIC",
    "dropphyst": "AL",
    "dropphyzpp": 360249998,
    "dropmaladd": "473 KOWALIGA RD",
    "dropmalcty": "ECLECTIC",
    "dropmalst": "AL",
    "dropmalzpp": 360249998,
    "dropsitphn": 3345412386,
    "dropsitlph": 3345412386,
    "dropsitcph": 3345412386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10370",
    "droptype": "D",
    "dropname": "EDWARDSVILLE",
    "dropdeladd": "4024 TALLAPOOSA ST",
    "dropdelcty": "EDWARDSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 362612000,
    "dropphyadd": "4024 TALLAPOOSA ST",
    "dropphycty": "EDWARDSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 362612000,
    "dropmaladd": "4024 TALLAPOOSA ST",
    "dropmalcty": "EDWARDSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 362619998,
    "dropsitphn": 2564638686,
    "dropsitlph": 2564638686,
    "dropsitcph": 2564638686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10376",
    "droptype": "D",
    "dropname": "ELBA",
    "dropdeladd": "469 CLAXTON AVE N",
    "dropdelcty": "ELBA",
    "dropdelst": "AL",
    "dropdelzpp": 363231915,
    "dropphyadd": "469 CLAXTON AVE N",
    "dropphycty": "ELBA",
    "dropphyst": "AL",
    "dropphyzpp": 363231915,
    "dropmaladd": "469 CLAXTON AVE N",
    "dropmalcty": "ELBA",
    "dropmalst": "AL",
    "dropmalzpp": 363239998,
    "dropsitphn": 3348972400,
    "dropsitlph": 3348972400,
    "dropsitcph": 3348972400,
    "dropfax": 3348978523
  },
  {
    "dcode": "D",
    "dropkey": "PY10377",
    "droptype": "D",
    "dropname": "ELBERTA",
    "dropdeladd": "24750 STATE ST",
    "dropdelcty": "ELBERTA",
    "dropdelst": "AL",
    "dropdelzpp": 365302539,
    "dropphyadd": "24750 STATE ST",
    "dropphycty": "ELBERTA",
    "dropphyst": "AL",
    "dropphyzpp": 365302539,
    "dropmaladd": "24750 STATE ST",
    "dropmalcty": "ELBERTA",
    "dropmalst": "AL",
    "dropmalzpp": 365309998,
    "dropsitphn": 2519867115,
    "dropsitlph": 2519867115,
    "dropsitcph": 2519867115,
    "dropfax": 2519866236
  },
  {
    "dcode": "D",
    "dropkey": "PY10378",
    "droptype": "D",
    "dropname": "ELDRIDGE",
    "dropdeladd": "37855 HIGHWAY 78",
    "dropdelcty": "ELDRIDGE",
    "dropdelst": "AL",
    "dropdelzpp": 355543305,
    "dropphyadd": "37855 HIGHWAY 78",
    "dropphycty": "ELDRIDGE",
    "dropphyst": "AL",
    "dropphyzpp": 355543305,
    "dropmaladd": "37855 HIGHWAY 78",
    "dropmalcty": "ELDRIDGE",
    "dropmalst": "AL",
    "dropmalzpp": 355549998,
    "dropsitphn": 2059244163,
    "dropsitlph": 2059244163,
    "dropsitcph": 2059244163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10379",
    "droptype": "D",
    "dropname": "ELKMONT",
    "dropdeladd": "25540 LEVIE DAVIS DR",
    "dropdelcty": "ELKMONT",
    "dropdelst": "AL",
    "dropdelzpp": 356205646,
    "dropphyadd": "25540 LEVIE DAVIS DR",
    "dropphycty": "ELKMONT",
    "dropphyst": "AL",
    "dropphyzpp": 356205646,
    "dropmaladd": "25540 LEVIE DAVIS DR",
    "dropmalcty": "ELKMONT",
    "dropmalst": "AL",
    "dropmalzpp": 356209998,
    "dropsitphn": 2567324444,
    "dropsitlph": 2567324444,
    "dropsitcph": 2567324444,
    "dropfax": 2567323411
  },
  {
    "dcode": "D",
    "dropkey": "PY10383",
    "droptype": "D",
    "dropname": "ELMORE",
    "dropdeladd": "449 JACKSON ST",
    "dropdelcty": "ELMORE",
    "dropdelst": "AL",
    "dropdelzpp": 360259998,
    "dropphyadd": "449 JACKSON ST",
    "dropphycty": "ELMORE",
    "dropphyst": "AL",
    "dropphyzpp": 360259998,
    "dropmaladd": "449 JACKSON ST",
    "dropmalcty": "ELMORE",
    "dropmalst": "AL",
    "dropmalzpp": 360259998,
    "dropsitphn": 3345674962,
    "dropsitlph": 3345674962,
    "dropsitcph": 3345674962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10384",
    "droptype": "D",
    "dropname": "ELROD",
    "dropdeladd": "12630 ELROD RD",
    "dropdelcty": "ELROD",
    "dropdelst": "AL",
    "dropdelzpp": 354582506,
    "dropphyadd": "12630 ELROD RD",
    "dropphycty": "ELROD",
    "dropphyst": "AL",
    "dropphyzpp": 354582506,
    "dropmaladd": "12630 ELROD RD",
    "dropmalcty": "ELROD",
    "dropmalst": "AL",
    "dropmalzpp": 354589998,
    "dropsitphn": 2053330700,
    "dropsitlph": 2053330700,
    "dropsitcph": 2053330700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10387",
    "droptype": "D",
    "dropname": "EMELLE",
    "dropdeladd": "121 DAILEY AVE",
    "dropdelcty": "EMELLE",
    "dropdelst": "AL",
    "dropdelzpp": 354591900,
    "dropphyadd": "121 DAILEY AVE",
    "dropphycty": "EMELLE",
    "dropphyst": "AL",
    "dropphyzpp": 354591900,
    "dropmaladd": "121 DAILEY AVE",
    "dropmalcty": "EMELLE",
    "dropmalst": "AL",
    "dropmalzpp": 354599998,
    "dropsitphn": 2056522569,
    "dropsitlph": 2056522569,
    "dropsitcph": 2056522569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10388",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "5323 EMPIRE RD",
    "dropdelcty": "EMPIRE",
    "dropdelst": "AL",
    "dropdelzpp": 350634202,
    "dropphyadd": "5323 EMPIRE RD",
    "dropphycty": "EMPIRE",
    "dropphyst": "AL",
    "dropphyzpp": 350634202,
    "dropmaladd": "5323 EMPIRE RD",
    "dropmalcty": "EMPIRE",
    "dropmalst": "AL",
    "dropmalzpp": 350639998,
    "dropsitphn": 2056483958,
    "dropsitlph": 2056483958,
    "dropsitcph": 2056483958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10392",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "616 GLOVER AVE",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "AL",
    "dropdelzpp": 363302008,
    "dropphyadd": "616 GLOVER AVE",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "AL",
    "dropphyzpp": 363302008,
    "dropmaladd": "616 GLOVER AVE",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "AL",
    "dropmalzpp": 363309998,
    "dropsitphn": 3343478472,
    "dropsitlph": 3343478472,
    "dropsitcph": 3343478472,
    "dropfax": 3343939349
  },
  {
    "dcode": "D",
    "dropkey": "PY10394",
    "droptype": "D",
    "dropname": "EPES",
    "dropdeladd": "10230 CEDAR HILL DR",
    "dropdelcty": "EPES",
    "dropdelst": "AL",
    "dropdelzpp": 354603026,
    "dropphyadd": "10230 CEDAR HILL DR",
    "dropphycty": "EPES",
    "dropphyst": "AL",
    "dropphyzpp": 354603026,
    "dropmaladd": "10230 CEDAR HILL DR",
    "dropmalcty": "EPES",
    "dropmalst": "AL",
    "dropmalzpp": 354609998,
    "dropsitphn": 2056522482,
    "dropsitlph": 2056522482,
    "dropsitcph": 2056522482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10395",
    "droptype": "D",
    "dropname": "EQUALITY",
    "dropdeladd": "260 AL HIGHWAY 9",
    "dropdelcty": "EQUALITY",
    "dropdelst": "AL",
    "dropdelzpp": 360265455,
    "dropphyadd": "260 AL HIGHWAY 9",
    "dropphycty": "EQUALITY",
    "dropphyst": "AL",
    "dropphyzpp": 360265455,
    "dropmaladd": "260 AL HIGHWAY 9",
    "dropmalcty": "EQUALITY",
    "dropmalst": "AL",
    "dropmalzpp": 360265455,
    "dropsitphn": 3345412945,
    "dropsitlph": 3345412945,
    "dropsitcph": 3345412945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10397",
    "droptype": "D",
    "dropname": "ESTILLFORK",
    "dropdeladd": "3930 COUNTY ROAD 9",
    "dropdelcty": "ESTILLFORK",
    "dropdelst": "AL",
    "dropdelzpp": 357454529,
    "dropphyadd": "3930 COUNTY ROAD 9",
    "dropphycty": "ESTILLFORK",
    "dropphyst": "AL",
    "dropphyzpp": 357454529,
    "dropmaladd": "3930 COUNTY ROAD 9",
    "dropmalcty": "ESTILLFORK",
    "dropmalst": "AL",
    "dropmalzpp": 357459998,
    "dropsitphn": 2567763946,
    "dropsitlph": 2567763946,
    "dropsitcph": 2567763946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10398",
    "droptype": "D",
    "dropname": "ETHELSVILLE",
    "dropdeladd": "491 MAIN ST",
    "dropdelcty": "ETHELSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 354613358,
    "dropphyadd": "491 MAIN ST",
    "dropphycty": "ETHELSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 354613358,
    "dropmaladd": "491 MAIN ST",
    "dropmalcty": "ETHELSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 354619998,
    "dropsitphn": 2056582890,
    "dropsitlph": 2056582890,
    "dropsitcph": 2056582890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10401",
    "droptype": "D",
    "dropname": "EUFAULA",
    "dropdeladd": "540 E BROAD ST",
    "dropdelcty": "EUFAULA",
    "dropdelst": "AL",
    "dropdelzpp": 360279998,
    "dropphyadd": "540 E BROAD ST",
    "dropphycty": "EUFAULA",
    "dropphyst": "AL",
    "dropphyzpp": 360279998,
    "dropmaladd": "540 E BROAD ST",
    "dropmalcty": "EUFAULA",
    "dropmalst": "AL",
    "dropmalzpp": 360279998,
    "dropsitphn": 3346873550,
    "dropsitlph": 3346873550,
    "dropsitcph": 3346873550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10403",
    "droptype": "D",
    "dropname": "EUTAW",
    "dropdeladd": "227 PRAIRIE AVE",
    "dropdelcty": "EUTAW",
    "dropdelst": "AL",
    "dropdelzpp": 354625110,
    "dropphyadd": "227 PRAIRIE AVE",
    "dropphycty": "EUTAW",
    "dropphyst": "AL",
    "dropphyzpp": 354625110,
    "dropmaladd": "227 PRAIRIE AVE",
    "dropmalcty": "EUTAW",
    "dropmalst": "AL",
    "dropmalzpp": 354629998,
    "dropsitphn": 2053724304,
    "dropsitlph": 2053724304,
    "dropsitcph": 2053724304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10404",
    "droptype": "D",
    "dropname": "EVA",
    "dropdeladd": "4456 HIGHWAY 55 E",
    "dropdelcty": "EVA",
    "dropdelst": "AL",
    "dropdelzpp": 356217900,
    "dropphyadd": "4456 HIGHWAY 55 E",
    "dropphycty": "EVA",
    "dropphyst": "AL",
    "dropphyzpp": 356217900,
    "dropmaladd": "4456 HIGHWAY 55 E",
    "dropmalcty": "EVA",
    "dropmalst": "AL",
    "dropmalzpp": 356219998,
    "dropsitphn": 2567967235,
    "dropsitlph": 2567967235,
    "dropsitcph": 2567967235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10406",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "200 RURAL ST",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "AL",
    "dropdelzpp": 364012824,
    "dropphyadd": "200 RURAL ST",
    "dropphycty": "EVERGREEN",
    "dropphyst": "AL",
    "dropphyzpp": 364012824,
    "dropmaladd": "200 RURAL ST",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "AL",
    "dropmalzpp": 364012824,
    "dropsitphn": 2515782255,
    "dropsitlph": 2515782255,
    "dropsitcph": 2515782255,
    "dropfax": 2515781012
  },
  {
    "dcode": "D",
    "dropkey": "PY10408",
    "droptype": "D",
    "dropname": "EXCEL",
    "dropdeladd": "10 MAIN ST",
    "dropdelcty": "EXCEL",
    "dropdelst": "AL",
    "dropdelzpp": 364392000,
    "dropphyadd": "10 MAIN ST",
    "dropphycty": "EXCEL",
    "dropphyst": "AL",
    "dropphyzpp": 364392000,
    "dropmaladd": "10 MAIN ST",
    "dropmalcty": "EXCEL",
    "dropmalst": "AL",
    "dropmalzpp": 364399998,
    "dropsitphn": 2517652621,
    "dropsitlph": 2517652621,
    "dropsitcph": 2517652621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10414",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "420 45TH ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "AL",
    "dropdelzpp": 350649998,
    "dropphyadd": "420 45TH ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "AL",
    "dropphyzpp": 350649998,
    "dropmaladd": "420 45TH ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "AL",
    "dropmalzpp": 350649998,
    "dropsitphn": 2057804675,
    "dropsitlph": 2057804675,
    "dropsitcph": 2057804675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10418",
    "droptype": "D",
    "dropname": "FAIRHOPE",
    "dropdeladd": "509 FAIRHOPE AVE",
    "dropdelcty": "FAIRHOPE",
    "dropdelst": "AL",
    "dropdelzpp": 365322116,
    "dropphyadd": "509 FAIRHOPE AVE",
    "dropphycty": "FAIRHOPE",
    "dropphyst": "AL",
    "dropphyzpp": 365322116,
    "dropmaladd": "509 FAIRHOPE AVE",
    "dropmalcty": "FAIRHOPE",
    "dropmalst": "AL",
    "dropmalzpp": 365329998,
    "dropsitphn": 2519903623,
    "dropsitlph": 2519903623,
    "dropsitcph": 2519903623,
    "dropfax": 2519906668
  },
  {
    "dcode": "D",
    "dropkey": "PY10422",
    "droptype": "D",
    "dropname": "FALKVILLE",
    "dropdeladd": "4539 HIGHWAY 31 SW",
    "dropdelcty": "FALKVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356225045,
    "dropphyadd": "4539 HIGHWAY 31 SW",
    "dropphycty": "FALKVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356225045,
    "dropmaladd": "4539 HIGHWAY 31 SW",
    "dropmalcty": "FALKVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356229998,
    "dropsitphn": 2567845356,
    "dropsitlph": 2567845356,
    "dropsitcph": 2567845356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10427",
    "droptype": "D",
    "dropname": "FAUNSDALE",
    "dropdeladd": "35570 AL HIGHWAY 25",
    "dropdelcty": "FAUNSDALE",
    "dropdelst": "AL",
    "dropdelzpp": 367389998,
    "dropphyadd": "35570 AL HIGHWAY 25",
    "dropphycty": "FAUNSDALE",
    "dropphyst": "AL",
    "dropphyzpp": 367389998,
    "dropmaladd": "35570 AL HIGHWAY 25",
    "dropmalcty": "FAUNSDALE",
    "dropmalst": "AL",
    "dropmalzpp": 367389998,
    "dropsitphn": 3346286635,
    "dropsitlph": 3346286635,
    "dropsitcph": 3342922393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10428",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "223 TEMPLE AVE N",
    "dropdelcty": "FAYETTE",
    "dropdelst": "AL",
    "dropdelzpp": 355552306,
    "dropphyadd": "223 TEMPLE AVE N",
    "dropphycty": "FAYETTE",
    "dropphyst": "AL",
    "dropphyzpp": 355552306,
    "dropmaladd": "223 TEMPLE AVE N",
    "dropmalcty": "FAYETTE",
    "dropmalst": "AL",
    "dropmalzpp": 355559998,
    "dropsitphn": 2059325379,
    "dropsitlph": 2059325379,
    "dropsitcph": 2059325379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10437",
    "droptype": "D",
    "dropname": "FITZPATRICK",
    "dropdeladd": "9575 HIGHWAY 110",
    "dropdelcty": "FITZPATRICK",
    "dropdelst": "AL",
    "dropdelzpp": 360299998,
    "dropphyadd": "9575 HIGHWAY 110",
    "dropphycty": "FITZPATRICK",
    "dropphyst": "AL",
    "dropphyzpp": 360299998,
    "dropmaladd": "9575 HIGHWAY 110",
    "dropmalcty": "FITZPATRICK",
    "dropmalst": "AL",
    "dropmalzpp": 360299998,
    "dropsitphn": 3347385255,
    "dropsitlph": 3347385255,
    "dropsitcph": 3347385255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10438",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "27038 US HIGHWAY 431",
    "dropdelcty": "FIVE POINTS",
    "dropdelst": "AL",
    "dropdelzpp": 368559998,
    "dropphyadd": "27038 US HIGHWAY 431",
    "dropphycty": "FIVE POINTS",
    "dropphyst": "AL",
    "dropphyzpp": 368559998,
    "dropmaladd": "27038 US HIGHWAY 431",
    "dropmalcty": "FIVE POINTS",
    "dropmalst": "AL",
    "dropmalzpp": 368559998,
    "dropsitphn": 3348649433,
    "dropsitlph": 3348649433,
    "dropsitcph": 3348649433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10440",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "21447 AL HIGHWAY 71",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "AL",
    "dropdelzpp": 359665109,
    "dropphyadd": "21447 AL HIGHWAY 71",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "AL",
    "dropphyzpp": 359665109,
    "dropmaladd": "21447 AL HIGHWAY 71",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "AL",
    "dropmalzpp": 359669998,
    "dropsitphn": 2566322151,
    "dropsitlph": 2566322151,
    "dropsitcph": 2566322151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10443",
    "droptype": "D",
    "dropname": "FLOMATON",
    "dropdeladd": "417 PALAFOX ST",
    "dropdelcty": "FLOMATON",
    "dropdelst": "AL",
    "dropdelzpp": 364415461,
    "dropphyadd": "417 PALAFOX ST",
    "dropphycty": "FLOMATON",
    "dropphyst": "AL",
    "dropphyzpp": 364415461,
    "dropmaladd": "417 PALAFOX ST",
    "dropmalcty": "FLOMATON",
    "dropmalst": "AL",
    "dropmalzpp": 364419998,
    "dropsitphn": 2512962683,
    "dropsitlph": 2512962683,
    "dropsitcph": 2512962683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10444",
    "droptype": "D",
    "dropname": "FLORALA",
    "dropdeladd": "1045 5TH ST",
    "dropdelcty": "FLORALA",
    "dropdelst": "AL",
    "dropdelzpp": 364423218,
    "dropphyadd": "1045 5TH ST",
    "dropphycty": "FLORALA",
    "dropphyst": "AL",
    "dropphyzpp": 364423218,
    "dropmaladd": "1045 5TH ST",
    "dropmalcty": "FLORALA",
    "dropmalst": "AL",
    "dropmalzpp": 364429998,
    "dropsitphn": 3348586812,
    "dropsitlph": 3348586812,
    "dropsitcph": 3348586812,
    "dropfax": 3348586812
  },
  {
    "dcode": "D",
    "dropkey": "PY10445",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "210 N SEMINARY ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "AL",
    "dropdelzpp": 356304759,
    "dropphyadd": "210 N SEMINARY ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "AL",
    "dropphyzpp": 356304759,
    "dropmaladd": "210 N SEMINARY ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "AL",
    "dropmalzpp": 356309998,
    "dropsitphn": 2567406340,
    "dropsitlph": 2567406340,
    "dropsitcph": 2567406340,
    "dropfax": 2567608637
  },
  {
    "dcode": "D",
    "dropkey": "PY10446",
    "droptype": "D",
    "dropname": "FOLEY",
    "dropdeladd": "150 E LAUREL AVE",
    "dropdelcty": "FOLEY",
    "dropdelst": "AL",
    "dropdelzpp": 365352601,
    "dropphyadd": "150 E LAUREL AVE",
    "dropphycty": "FOLEY",
    "dropphyst": "AL",
    "dropphyzpp": 365352601,
    "dropmaladd": "150 E LAUREL AVE",
    "dropmalcty": "FOLEY",
    "dropmalst": "AL",
    "dropmalzpp": 365359998,
    "dropsitphn": 2519437713,
    "dropsitlph": 2519437713,
    "dropsitcph": 2519437713,
    "dropfax": 2519433593
  },
  {
    "dcode": "D",
    "dropkey": "PY10447",
    "droptype": "D",
    "dropname": "FOREST HOME",
    "dropdeladd": "7844 FOREST HOME RD",
    "dropdelcty": "FOREST HOME",
    "dropdelst": "AL",
    "dropdelzpp": 360309998,
    "dropphyadd": "7844 FOREST HOME RD",
    "dropphycty": "FOREST HOME",
    "dropphyst": "AL",
    "dropphyzpp": 360309998,
    "dropmaladd": "7844 FOREST HOME RD",
    "dropmalcty": "FOREST HOME",
    "dropmalst": "AL",
    "dropmalzpp": 360309998,
    "dropsitphn": 3343462658,
    "dropsitlph": 3343462658,
    "dropsitcph": 3343462658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10451",
    "droptype": "D",
    "dropname": "FORKLAND",
    "dropdeladd": "3663 M L KING DR",
    "dropdelcty": "FORKLAND",
    "dropdelst": "AL",
    "dropdelzpp": 367409998,
    "dropphyadd": "3663 M L KING DR",
    "dropphycty": "FORKLAND",
    "dropphyst": "AL",
    "dropphyzpp": 367409998,
    "dropmaladd": "3663 M L KING DR",
    "dropmalcty": "FORKLAND",
    "dropmalst": "AL",
    "dropmalzpp": 367409998,
    "dropsitphn": 3342890967,
    "dropsitlph": 3342890967,
    "dropsitcph": 3342890967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10453",
    "droptype": "D",
    "dropname": "FORT DAVIS",
    "dropdeladd": "14125 US HIGHWAY 29 S",
    "dropdelcty": "FORT DAVIS",
    "dropdelst": "AL",
    "dropdelzpp": 360319998,
    "dropphyadd": "14125 US HIGHWAY 29 S",
    "dropphycty": "FORT DAVIS",
    "dropphyst": "AL",
    "dropphyzpp": 360319998,
    "dropmaladd": "14125 US HIGHWAY 29 S",
    "dropmalcty": "FORT DAVIS",
    "dropmalst": "AL",
    "dropmalzpp": 360319998,
    "dropsitphn": 3344853333,
    "dropsitlph": 3344853333,
    "dropsitcph": 3344853333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10454",
    "droptype": "D",
    "dropname": "FORT DEPOSIT",
    "dropdeladd": "350 OLD FORT RD E",
    "dropdelcty": "FORT DEPOSIT",
    "dropdelst": "AL",
    "dropdelzpp": 360324031,
    "dropphyadd": "350 OLD FORT RD E",
    "dropphycty": "FORT DEPOSIT",
    "dropphyst": "AL",
    "dropphyzpp": 360324031,
    "dropmaladd": "350 OLD FORT RD E",
    "dropmalcty": "FORT DEPOSIT",
    "dropmalst": "AL",
    "dropmalzpp": 360324031,
    "dropsitphn": 3342278858,
    "dropsitlph": 3342278858,
    "dropsitcph": 3342278858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10457",
    "droptype": "D",
    "dropname": "FORT MITCHELL",
    "dropdeladd": "825 HIGHWAY 165",
    "dropdelcty": "FORT MITCHELL",
    "dropdelst": "AL",
    "dropdelzpp": 368564447,
    "dropphyadd": "825 HIGHWAY 165",
    "dropphycty": "FORT MITCHELL",
    "dropphyst": "AL",
    "dropphyzpp": 368564447,
    "dropmaladd": "825 HIGHWAY 165",
    "dropmalcty": "FORT MITCHELL",
    "dropmalst": "AL",
    "dropmalzpp": 368564447,
    "dropsitphn": 3348553187,
    "dropsitlph": 3348553187,
    "dropsitcph": 3348553187,
    "dropfax": 3348554962
  },
  {
    "dcode": "D",
    "dropkey": "PY10459",
    "droptype": "D",
    "dropname": "FORT PAYNE",
    "dropdeladd": "301 1ST ST E",
    "dropdelcty": "FORT PAYNE",
    "dropdelst": "AL",
    "dropdelzpp": 359672015,
    "dropphyadd": "301 1ST ST E",
    "dropphycty": "FORT PAYNE",
    "dropphyst": "AL",
    "dropphyzpp": 359672015,
    "dropmaladd": "301 1ST ST E",
    "dropmalcty": "FORT PAYNE",
    "dropmalst": "AL",
    "dropmalzpp": 359679998,
    "dropsitphn": 2568450434,
    "dropsitlph": 2568450434,
    "dropsitcph": 2568450434,
    "dropfax": 2569979417
  },
  {
    "dcode": "D",
    "dropkey": "PY10461",
    "droptype": "D",
    "dropname": "FOSTERS",
    "dropdeladd": "13467 HIGHWAY 11 S",
    "dropdelcty": "FOSTERS",
    "dropdelst": "AL",
    "dropdelzpp": 354639501,
    "dropphyadd": "13467 HIGHWAY 11 S",
    "dropphycty": "FOSTERS",
    "dropphyst": "AL",
    "dropphyzpp": 354639501,
    "dropmaladd": "13467 HIGHWAY 11 S",
    "dropmalcty": "FOSTERS",
    "dropmalst": "AL",
    "dropmalzpp": 354639998,
    "dropsitphn": 2057529613,
    "dropsitlph": 2057529613,
    "dropsitcph": 2057529613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10463",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "AL",
    "dropdelzpp": 364445440,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "AL",
    "dropphyzpp": 364445440,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "AL",
    "dropmalzpp": 364449998,
    "dropsitphn": 2512824490,
    "dropsitlph": 2512824490,
    "dropsitcph": 2512824490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10464",
    "droptype": "D",
    "dropname": "FRANKVILLE",
    "dropdeladd": "2323 COUNTY ROAD 31",
    "dropdelcty": "FRANKVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 365386200,
    "dropphyadd": "2323 COUNTY ROAD 31",
    "dropphycty": "FRANKVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 365386200,
    "dropmaladd": "2323 COUNTY ROAD 31",
    "dropmalcty": "FRANKVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 365389998,
    "dropsitphn": 2517549746,
    "dropsitlph": 2517549746,
    "dropsitcph": 2517549746,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10465",
    "droptype": "D",
    "dropname": "FRISCO CITY",
    "dropdeladd": "27 CHURCH ST",
    "dropdelcty": "FRISCO CITY",
    "dropdelst": "AL",
    "dropdelzpp": 364453667,
    "dropphyadd": "27 CHURCH ST",
    "dropphycty": "FRISCO CITY",
    "dropphyst": "AL",
    "dropphyzpp": 364453667,
    "dropmaladd": "27 CHURCH ST",
    "dropmalcty": "FRISCO CITY",
    "dropmalst": "AL",
    "dropmalzpp": 364459998,
    "dropsitphn": 2512673109,
    "dropsitlph": 2512673109,
    "dropsitcph": 2512673109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10466",
    "droptype": "D",
    "dropname": "FRUITDALE",
    "dropdeladd": "48 GREEN ST",
    "dropdelcty": "FRUITDALE",
    "dropdelst": "AL",
    "dropdelzpp": 365392000,
    "dropphyadd": "48 GREEN ST",
    "dropphycty": "FRUITDALE",
    "dropphyst": "AL",
    "dropphyzpp": 365392000,
    "dropmaladd": "48 GREEN ST",
    "dropmalcty": "FRUITDALE",
    "dropmalst": "AL",
    "dropmalzpp": 365399998,
    "dropsitphn": 2518276317,
    "dropsitlph": 2518276317,
    "dropsitcph": 2512358364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10467",
    "droptype": "D",
    "dropname": "FRUITHURST",
    "dropdeladd": "16205 HIGHWAY 78",
    "dropdelcty": "FRUITHURST",
    "dropdelst": "AL",
    "dropdelzpp": 362623783,
    "dropphyadd": "16205 HIGHWAY 78",
    "dropphycty": "FRUITHURST",
    "dropphyst": "AL",
    "dropphyzpp": 362623783,
    "dropmaladd": "16205 HIGHWAY 78",
    "dropmalcty": "FRUITHURST",
    "dropmalst": "AL",
    "dropmalzpp": 362629998,
    "dropsitphn": 2565792618,
    "dropsitlph": 2565792618,
    "dropsitcph": 2565792618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10474",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "152 MAIN ST",
    "dropdelcty": "FULTON",
    "dropdelst": "AL",
    "dropdelzpp": 364462000,
    "dropphyadd": "152 MAIN ST",
    "dropphycty": "FULTON",
    "dropphyst": "AL",
    "dropphyzpp": 364462000,
    "dropmaladd": "152 MAIN ST",
    "dropmalcty": "FULTON",
    "dropmalst": "AL",
    "dropmalzpp": 364469998,
    "dropsitphn": 3346365514,
    "dropsitlph": 3346365514,
    "dropsitcph": 3346365514,
    "dropfax": 3346361712
  },
  {
    "dcode": "D",
    "dropkey": "PY10476",
    "droptype": "D",
    "dropname": "FULTONDALE",
    "dropdeladd": "1515 STOUTS RD",
    "dropdelcty": "FULTONDALE",
    "dropdelst": "AL",
    "dropdelzpp": 350682028,
    "dropphyadd": "1515 STOUTS RD",
    "dropphycty": "FULTONDALE",
    "dropphyst": "AL",
    "dropphyzpp": 350682028,
    "dropmaladd": "1515 STOUTS RD",
    "dropmalcty": "FULTONDALE",
    "dropmalst": "AL",
    "dropmalzpp": 350689998,
    "dropsitphn": 2058414833,
    "dropsitlph": 2058414833,
    "dropsitcph": 2058414833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10477",
    "droptype": "D",
    "dropname": "FURMAN",
    "dropdeladd": "8545 COUNTY ROAD 59",
    "dropdelcty": "FURMAN",
    "dropdelst": "AL",
    "dropdelzpp": 367419998,
    "dropphyadd": "8545 COUNTY ROAD 59",
    "dropphycty": "FURMAN",
    "dropphyst": "AL",
    "dropphyzpp": 367419998,
    "dropmaladd": "8545 COUNTY ROAD 59",
    "dropmalcty": "FURMAN",
    "dropmalst": "AL",
    "dropmalzpp": 367419998,
    "dropsitphn": 2517462416,
    "dropsitlph": 2517462416,
    "dropsitcph": 2517462416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10478",
    "droptype": "D",
    "dropname": "FYFFE",
    "dropdeladd": "1357 MAIN ST",
    "dropdelcty": "FYFFE",
    "dropdelst": "AL",
    "dropdelzpp": 359713466,
    "dropphyadd": "1357 MAIN ST",
    "dropphycty": "FYFFE",
    "dropphyst": "AL",
    "dropphyzpp": 359713466,
    "dropmaladd": "1357 MAIN ST",
    "dropmalcty": "FYFFE",
    "dropmalst": "AL",
    "dropmalzpp": 359719998,
    "dropsitphn": 2566232604,
    "dropsitlph": 2566232604,
    "dropsitcph": 2563887951,
    "dropfax": 2563887940
  },
  {
    "dcode": "D",
    "dropkey": "PY10481",
    "droptype": "D",
    "dropname": "GAINESTOWN",
    "dropdeladd": "16430 WALKER SPRINGS RD",
    "dropdelcty": "GAINESTOWN",
    "dropdelst": "AL",
    "dropdelzpp": 365406208,
    "dropphyadd": "16430 WALKER SPRINGS RD",
    "dropphycty": "GAINESTOWN",
    "dropphyst": "AL",
    "dropphyzpp": 365406208,
    "dropmaladd": "16430 WALKER SPRINGS RD",
    "dropmalcty": "GAINESTOWN",
    "dropmalst": "AL",
    "dropmalzpp": 365409998,
    "dropsitphn": 2512469827,
    "dropsitlph": 2512469827,
    "dropsitcph": 2512469827,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10482",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "9393 STATE ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 354642143,
    "dropphyadd": "9393 STATE ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 354642143,
    "dropmaladd": "9393 STATE ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 354649998,
    "dropsitphn": 2056529470,
    "dropsitlph": 2056529470,
    "dropsitcph": 2056529470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10485",
    "droptype": "D",
    "dropname": "GALLANT",
    "dropdeladd": "9125 GALLANT RD",
    "dropdelcty": "GALLANT",
    "dropdelst": "AL",
    "dropdelzpp": 359722023,
    "dropphyadd": "9125 GALLANT RD",
    "dropphycty": "GALLANT",
    "dropphyst": "AL",
    "dropphyzpp": 359722023,
    "dropmaladd": "9125 GALLANT RD",
    "dropmalcty": "GALLANT",
    "dropmalst": "AL",
    "dropmalzpp": 359729998,
    "dropsitphn": 2565385198,
    "dropsitlph": 2565385198,
    "dropsitcph": 2565385198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10487",
    "droptype": "D",
    "dropname": "GALLION",
    "dropdeladd": "505 GALLION RD",
    "dropdelcty": "GALLION",
    "dropdelst": "AL",
    "dropdelzpp": 367429998,
    "dropphyadd": "505 GALLION RD",
    "dropphycty": "GALLION",
    "dropphyst": "AL",
    "dropphyzpp": 367429998,
    "dropmaladd": "505 GALLION RD",
    "dropmalcty": "GALLION",
    "dropmalst": "AL",
    "dropmalzpp": 367429998,
    "dropsitphn": 3342892032,
    "dropsitlph": 3342892032,
    "dropsitcph": 3342892032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10488",
    "droptype": "D",
    "dropname": "GANTT",
    "dropdeladd": "28795 COMMERCE ST",
    "dropdelcty": "GANTT",
    "dropdelst": "AL",
    "dropdelzpp": 360384400,
    "dropphyadd": "28795 COMMERCE ST",
    "dropphycty": "GANTT",
    "dropphyst": "AL",
    "dropphyzpp": 360384400,
    "dropmaladd": "28795 COMMERCE ST",
    "dropmalcty": "GANTT",
    "dropmalst": "AL",
    "dropmalzpp": 360384400,
    "dropsitphn": 3343884659,
    "dropsitlph": 3343884659,
    "dropsitcph": 3343884659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10489",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "311 1ST AVE S",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "AL",
    "dropdelzpp": 350702001,
    "dropphyadd": "311 1ST AVE S",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "AL",
    "dropphyzpp": 350702001,
    "dropmaladd": "311 1ST AVE S",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "AL",
    "dropmalzpp": 350702001,
    "dropsitphn": 2563526519,
    "dropsitlph": 2563526519,
    "dropsitcph": 2563526519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10492",
    "droptype": "D",
    "dropname": "GARDENDALE",
    "dropdeladd": "1753 DECATUR HWY",
    "dropdelcty": "GARDENDALE",
    "dropdelst": "AL",
    "dropdelzpp": 350713803,
    "dropphyadd": "1753 DECATUR HWY",
    "dropphycty": "GARDENDALE",
    "dropphyst": "AL",
    "dropphyzpp": 350713803,
    "dropmaladd": "1753 DECATUR HWY",
    "dropmalcty": "GARDENDALE",
    "dropmalst": "AL",
    "dropmalzpp": 350719998,
    "dropsitphn": 2056313410,
    "dropsitlph": 2056313410,
    "dropsitcph": 2056313410,
    "dropfax": 2056312952
  },
  {
    "dcode": "D",
    "dropkey": "PY10496",
    "droptype": "D",
    "dropname": "GAYLESVILLE",
    "dropdeladd": "4840 MAIN ST",
    "dropdelcty": "GAYLESVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359734419,
    "dropphyadd": "4840 MAIN ST",
    "dropphycty": "GAYLESVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359734419,
    "dropmaladd": "4840 MAIN ST",
    "dropmalcty": "GAYLESVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359739998,
    "dropsitphn": 2564223161,
    "dropsitlph": 2564223161,
    "dropsitcph": 2564223161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10500",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "800 E CHURCH AVE",
    "dropdelcty": "GENEVA",
    "dropdelst": "AL",
    "dropdelzpp": 363402422,
    "dropphyadd": "800 E CHURCH AVE",
    "dropphycty": "GENEVA",
    "dropphyst": "AL",
    "dropphyzpp": 363402422,
    "dropmaladd": "800 E CHURCH AVE",
    "dropmalcty": "GENEVA",
    "dropmalst": "AL",
    "dropmalzpp": 363409998,
    "dropsitphn": 3346842404,
    "dropsitlph": 3346842404,
    "dropsitcph": 3346842404,
    "dropfax": 3346840550
  },
  {
    "dcode": "D",
    "dropkey": "PY10503",
    "droptype": "D",
    "dropname": "GEORGIANA",
    "dropdeladd": "248 N MIRANDA AVE",
    "dropdelcty": "GEORGIANA",
    "dropdelst": "AL",
    "dropdelzpp": 360339998,
    "dropphyadd": "248 N MIRANDA AVE",
    "dropphycty": "GEORGIANA",
    "dropphyst": "AL",
    "dropphyzpp": 360339998,
    "dropmaladd": "248 N MIRANDA AVE",
    "dropmalcty": "GEORGIANA",
    "dropmalst": "AL",
    "dropmalzpp": 360339998,
    "dropsitphn": 3343769300,
    "dropsitlph": 3343769300,
    "dropsitcph": 3343769300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10504",
    "droptype": "D",
    "dropname": "GERALDINE",
    "dropdeladd": "41808 AL HIGHWAY 75",
    "dropdelcty": "GERALDINE",
    "dropdelst": "AL",
    "dropdelzpp": 359743416,
    "dropphyadd": "41808 AL HIGHWAY 75",
    "dropphycty": "GERALDINE",
    "dropphyst": "AL",
    "dropphyzpp": 359743416,
    "dropmaladd": "41808 AL HIGHWAY 75",
    "dropmalcty": "GERALDINE",
    "dropmalst": "AL",
    "dropmalzpp": 359749998,
    "dropsitphn": 2566592128,
    "dropsitlph": 2566592128,
    "dropsitcph": 2563007332,
    "dropfax": 2573007328
  },
  {
    "dcode": "D",
    "dropkey": "PY10506",
    "droptype": "D",
    "dropname": "GILBERTOWN",
    "dropdeladd": "100 HIGH ST",
    "dropdelcty": "GILBERTOWN",
    "dropdelst": "AL",
    "dropdelzpp": 369089998,
    "dropphyadd": "100 HIGH ST",
    "dropphycty": "GILBERTOWN",
    "dropphyst": "AL",
    "dropphyzpp": 369089998,
    "dropmaladd": "100 HIGH ST",
    "dropmalcty": "GILBERTOWN",
    "dropmalst": "AL",
    "dropmalzpp": 369089998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2518435294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10508",
    "droptype": "D",
    "dropname": "GLEN ALLEN",
    "dropdeladd": "152 HIGHWAY 129 S",
    "dropdelcty": "GLEN ALLEN",
    "dropdelst": "AL",
    "dropdelzpp": 355592000,
    "dropphyadd": "152 HIGHWAY 129 S",
    "dropphycty": "GLEN ALLEN",
    "dropphyst": "AL",
    "dropphyzpp": 355592000,
    "dropmaladd": "152 HIGHWAY 129 S",
    "dropmalcty": "GLEN ALLEN",
    "dropmalst": "AL",
    "dropmalzpp": 355599998,
    "dropsitphn": 2054874992,
    "dropsitlph": 2054874992,
    "dropsitcph": 2054874992,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10512",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "26 N KING ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 360349998,
    "dropphyadd": "26 N KING ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 360349998,
    "dropmaladd": "26 N KING ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 360349998,
    "dropsitphn": 3343353914,
    "dropsitlph": 3343353914,
    "dropsitcph": 3343353914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10517",
    "droptype": "D",
    "dropname": "GOODSPRINGS",
    "dropdeladd": "824 GOODSPRINGS RD",
    "dropdelcty": "GOODSPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 355602000,
    "dropphyadd": "824 GOODSPRINGS RD",
    "dropphycty": "GOODSPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 355602000,
    "dropmaladd": "824 GOODSPRINGS RD",
    "dropmalcty": "GOODSPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 355609998,
    "dropsitphn": 2056867158,
    "dropsitlph": 2056867158,
    "dropsitcph": 2056867158,
    "dropfax": 2056868001
  },
  {
    "dcode": "D",
    "dropkey": "PY10518",
    "droptype": "D",
    "dropname": "GOODWATER",
    "dropdeladd": "64 COOSA COUNTY ROAD 66",
    "dropdelcty": "GOODWATER",
    "dropdelst": "AL",
    "dropdelzpp": 350729998,
    "dropphyadd": "64 COOSA COUNTY ROAD 66",
    "dropphycty": "GOODWATER",
    "dropphyst": "AL",
    "dropphyzpp": 350729998,
    "dropmaladd": "64 COOSA COUNTY ROAD 66",
    "dropmalcty": "GOODWATER",
    "dropmalst": "AL",
    "dropmalzpp": 350729998,
    "dropsitphn": 2568395652,
    "dropsitlph": 2568395652,
    "dropsitcph": 2568395652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10520",
    "droptype": "D",
    "dropname": "GORDO",
    "dropdeladd": "842 INDUSTRIAL PARK BLVD",
    "dropdelcty": "GORDO",
    "dropdelst": "AL",
    "dropdelzpp": 354668000,
    "dropphyadd": "842 INDUSTRIAL PARK BLVD",
    "dropphycty": "GORDO",
    "dropphyst": "AL",
    "dropphyzpp": 354668000,
    "dropmaladd": "842 INDUSTRIAL PARK BLVD",
    "dropmalcty": "GORDO",
    "dropmalst": "AL",
    "dropmalzpp": 354669998,
    "dropsitphn": 2053647144,
    "dropsitlph": 2053647144,
    "dropsitcph": 2053647144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10521",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "1950 N COUNTY ROAD 95",
    "dropdelcty": "GORDON",
    "dropdelst": "AL",
    "dropdelzpp": 363437848,
    "dropphyadd": "1950 N COUNTY ROAD 95",
    "dropphycty": "GORDON",
    "dropphyst": "AL",
    "dropphyzpp": 363437848,
    "dropmaladd": "1950 N COUNTY ROAD 95",
    "dropmalcty": "GORDON",
    "dropmalst": "AL",
    "dropmalzpp": 363439998,
    "dropsitphn": 3345223515,
    "dropsitlph": 3345223515,
    "dropsitcph": 3345223515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10522",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "31 GREENVILLE AVE",
    "dropdelcty": "GOSHEN",
    "dropdelst": "AL",
    "dropdelzpp": 360359998,
    "dropphyadd": "31 GREENVILLE AVE",
    "dropphycty": "GOSHEN",
    "dropphyst": "AL",
    "dropphyzpp": 360359998,
    "dropmaladd": "31 GREENVILLE AVE",
    "dropmalcty": "GOSHEN",
    "dropmalst": "AL",
    "dropmalzpp": 360359998,
    "dropsitphn": 3345664520,
    "dropsitlph": 3342447515,
    "dropsitcph": 3344843402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10525",
    "droptype": "D",
    "dropname": "GRADY",
    "dropdeladd": "6208 RAMER GRADY RD",
    "dropdelcty": "GRADY",
    "dropdelst": "AL",
    "dropdelzpp": 360369998,
    "dropphyadd": "6208 RAMER GRADY RD",
    "dropphycty": "GRADY",
    "dropphyst": "AL",
    "dropphyzpp": 360369998,
    "dropmaladd": "6208 RAMER GRADY RD",
    "dropmalcty": "GRADY",
    "dropmalst": "AL",
    "dropmalzpp": 360369998,
    "dropsitphn": 3345664520,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345629152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10526",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "32877 HIGHWAY 48",
    "dropdelcty": "GRAHAM",
    "dropdelst": "AL",
    "dropdelzpp": 362634063,
    "dropphyadd": "32877 HIGHWAY 48",
    "dropphycty": "GRAHAM",
    "dropphyst": "AL",
    "dropphyzpp": 362634063,
    "dropmaladd": "32877 HIGHWAY 48",
    "dropmalcty": "GRAHAM",
    "dropmalst": "AL",
    "dropmalzpp": 362639998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2565685150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10527",
    "droptype": "D",
    "dropname": "GRAND BAY",
    "dropdeladd": "12580 US HIGHWAY 90",
    "dropdelcty": "GRAND BAY",
    "dropdelst": "AL",
    "dropdelzpp": 365412000,
    "dropphyadd": "12580 US HIGHWAY 90",
    "dropphycty": "GRAND BAY",
    "dropphyst": "AL",
    "dropphyzpp": 365412000,
    "dropmaladd": "12580 US HIGHWAY 90",
    "dropmalcty": "GRAND BAY",
    "dropmalst": "AL",
    "dropmalzpp": 365419998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2518651538,
    "dropfax": 2518652016
  },
  {
    "dcode": "D",
    "dropkey": "PY10529",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "5319 MAIN ST",
    "dropdelcty": "GRANT",
    "dropdelst": "AL",
    "dropdelzpp": 357478320,
    "dropphyadd": "5319 MAIN ST",
    "dropphycty": "GRANT",
    "dropphyst": "AL",
    "dropphyzpp": 357478320,
    "dropmaladd": "5319 MAIN ST",
    "dropmalcty": "GRANT",
    "dropmalst": "AL",
    "dropmalzpp": 357479998,
    "dropsitphn": 2567284493,
    "dropsitlph": 2567284493,
    "dropsitcph": 2567284493,
    "dropfax": 2567288493
  },
  {
    "dcode": "D",
    "dropkey": "PY10533",
    "droptype": "D",
    "dropname": "GRAYSVILLE",
    "dropdeladd": "201 2ND AVE SW",
    "dropdelcty": "GRAYSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350731143,
    "dropphyadd": "201 2ND AVE SW",
    "dropphycty": "GRAYSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350731143,
    "dropmaladd": "201 2ND AVE SW",
    "dropmalcty": "GRAYSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350739998,
    "dropsitphn": 2056740494,
    "dropsitlph": 2056740494,
    "dropsitcph": 2056740815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10535",
    "droptype": "D",
    "dropname": "GREEN POND",
    "dropdeladd": "20607 EASTERN VALLEY RD",
    "dropdelcty": "GREEN POND",
    "dropdelst": "AL",
    "dropdelzpp": 350742000,
    "dropphyadd": "20607 EASTERN VALLEY RD",
    "dropphycty": "GREEN POND",
    "dropphyst": "AL",
    "dropphyzpp": 350742000,
    "dropmaladd": "20607 EASTERN VALLEY RD",
    "dropmalcty": "GREEN POND",
    "dropmalst": "AL",
    "dropmalzpp": 350749998,
    "dropsitphn": 2059382394,
    "dropsitlph": 2059382394,
    "dropsitcph": 2059382394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10538",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "1501 MAIN ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "AL",
    "dropdelzpp": 367449998,
    "dropphyadd": "1501 MAIN ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "AL",
    "dropphyzpp": 367449998,
    "dropmaladd": "1501 MAIN ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "AL",
    "dropmalzpp": 367449998,
    "dropsitphn": 3346243943,
    "dropsitlph": 3346243943,
    "dropsitcph": 3346243943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10539",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "101 E COMMERCE ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360379998,
    "dropphyadd": "101 E COMMERCE ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360379998,
    "dropmaladd": "101 E COMMERCE ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360379998,
    "dropsitphn": 3343823721,
    "dropsitlph": 3343823721,
    "dropsitcph": 3343823721,
    "dropfax": 3343828979
  },
  {
    "dcode": "D",
    "dropkey": "PY10544",
    "droptype": "D",
    "dropname": "GROVE HILL",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "GROVE HILL",
    "dropdelst": "AL",
    "dropdelzpp": 364513144,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "GROVE HILL",
    "dropphyst": "AL",
    "dropphyzpp": 364513144,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "GROVE HILL",
    "dropmalst": "AL",
    "dropmalzpp": 364519998,
    "dropsitphn": 2512753986,
    "dropsitlph": 2512753986,
    "dropsitcph": 2512753986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10546",
    "droptype": "D",
    "dropname": "GUIN",
    "dropdeladd": "7479 US HIGHWAY 43",
    "dropdelcty": "GUIN",
    "dropdelst": "AL",
    "dropdelzpp": 355633317,
    "dropphyadd": "7479 US HIGHWAY 43",
    "dropphycty": "GUIN",
    "dropphyst": "AL",
    "dropphyzpp": 355633317,
    "dropmaladd": "7479 US HIGHWAY 43",
    "dropmalcty": "GUIN",
    "dropmalst": "AL",
    "dropmalzpp": 355639998,
    "dropsitphn": 2054683533,
    "dropsitlph": 2054683533,
    "dropsitcph": 2054683533,
    "dropfax": 2054684183
  },
  {
    "dcode": "D",
    "dropkey": "PY10548",
    "droptype": "D",
    "dropname": "GULF SHORES",
    "dropdeladd": "2149 W 1ST ST",
    "dropdelcty": "GULF SHORES",
    "dropdelst": "AL",
    "dropdelzpp": 365424435,
    "dropphyadd": "2149 W 1ST ST",
    "dropphycty": "GULF SHORES",
    "dropphyst": "AL",
    "dropphyzpp": 365424435,
    "dropmaladd": "2149 W 1ST ST",
    "dropmalcty": "GULF SHORES",
    "dropmalst": "AL",
    "dropmalzpp": 365429998,
    "dropsitphn": 2519682231,
    "dropsitlph": 2519682231,
    "dropsitcph": 2519682231,
    "dropfax": 2519686665
  },
  {
    "dcode": "D",
    "dropkey": "PY10556",
    "droptype": "D",
    "dropname": "GUNTERSVILLE",
    "dropdeladd": "1021 BLOUNT AVE",
    "dropdelcty": "GUNTERSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359761511,
    "dropphyadd": "1021 BLOUNT AVE",
    "dropphycty": "GUNTERSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359761511,
    "dropmaladd": "1021 BLOUNT AVE",
    "dropmalcty": "GUNTERSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359761511,
    "dropsitphn": 2565823862,
    "dropsitlph": 2565823862,
    "dropsitcph": 2565823862,
    "dropfax": 2565717404
  },
  {
    "dcode": "D",
    "dropkey": "PY10559",
    "droptype": "D",
    "dropname": "GURLEY",
    "dropdeladd": "6051 HIGHWAY 72 E",
    "dropdelcty": "GURLEY",
    "dropdelst": "AL",
    "dropdelzpp": 357488777,
    "dropphyadd": "6051 HIGHWAY 72 E",
    "dropphycty": "GURLEY",
    "dropphyst": "AL",
    "dropphyzpp": 357488777,
    "dropmaladd": "6051 HIGHWAY 72 E",
    "dropmalcty": "GURLEY",
    "dropmalst": "AL",
    "dropmalzpp": 357489998,
    "dropsitphn": 2567762357,
    "dropsitlph": 2567762357,
    "dropsitcph": 2567769589,
    "dropfax": 2567769589
  },
  {
    "dcode": "D",
    "dropkey": "PY10560",
    "droptype": "D",
    "dropname": "HACKLEBURG",
    "dropdeladd": "429 WALKER ST",
    "dropdelcty": "HACKLEBURG",
    "dropdelst": "AL",
    "dropdelzpp": 355644102,
    "dropphyadd": "429 WALKER ST",
    "dropphycty": "HACKLEBURG",
    "dropphyst": "AL",
    "dropphyzpp": 355644102,
    "dropmaladd": "429 WALKER ST",
    "dropmalcty": "HACKLEBURG",
    "dropmalst": "AL",
    "dropmalzpp": 355649998,
    "dropsitphn": 2059353164,
    "dropsitlph": 2059353164,
    "dropsitcph": 2053950340,
    "dropfax": 2059353542
  },
  {
    "dcode": "D",
    "dropkey": "PY10563",
    "droptype": "D",
    "dropname": "HALEYVILLE",
    "dropdeladd": "1212 21ST ST",
    "dropdelcty": "HALEYVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 355651813,
    "dropphyadd": "1212 21ST ST",
    "dropphycty": "HALEYVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 355651813,
    "dropmaladd": "1212 21ST ST",
    "dropmalcty": "HALEYVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 355659998,
    "dropsitphn": 2054862236,
    "dropsitlph": 2054862236,
    "dropsitcph": 2054862236,
    "dropfax": 2054857736
  },
  {
    "dcode": "D",
    "dropkey": "PY10564",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "315 BEXAR AVE E",
    "dropdelcty": "HAMILTON",
    "dropdelst": "AL",
    "dropdelzpp": 355704038,
    "dropphyadd": "315 BEXAR AVE E",
    "dropphycty": "HAMILTON",
    "dropphyst": "AL",
    "dropphyzpp": 355704038,
    "dropmaladd": "315 BEXAR AVE E",
    "dropmalcty": "HAMILTON",
    "dropmalst": "AL",
    "dropmalzpp": 355704038,
    "dropsitphn": 2059213895,
    "dropsitlph": 2059213895,
    "dropsitcph": 2059213895,
    "dropfax": 2059215866
  },
  {
    "dcode": "D",
    "dropkey": "PY10566",
    "droptype": "D",
    "dropname": "HANCEVILLE",
    "dropdeladd": "630 MAIN ST NE",
    "dropdelcty": "HANCEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350775457,
    "dropphyadd": "630 MAIN ST NE",
    "dropphycty": "HANCEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350775457,
    "dropmaladd": "630 MAIN ST NE",
    "dropmalcty": "HANCEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350779998,
    "dropsitphn": 2563524331,
    "dropsitlph": 2563524331,
    "dropsitcph": 2563524331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10567",
    "droptype": "D",
    "dropname": "HARDAWAY",
    "dropdeladd": "25706 COUNTY ROAD 2",
    "dropdelcty": "HARDAWAY",
    "dropdelst": "AL",
    "dropdelzpp": 360399998,
    "dropphyadd": "25706 COUNTY ROAD 2",
    "dropphycty": "HARDAWAY",
    "dropphyst": "AL",
    "dropphyzpp": 360399998,
    "dropmaladd": "25706 COUNTY ROAD 2",
    "dropmalcty": "HARDAWAY",
    "dropmalst": "AL",
    "dropmalzpp": 360399998,
    "dropsitphn": 3344853531,
    "dropsitlph": 3344853531,
    "dropsitcph": 3344853531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10569",
    "droptype": "D",
    "dropname": "HARPERSVILLE",
    "dropdeladd": "41 WHEAT ST",
    "dropdelcty": "HARPERSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 350786317,
    "dropphyadd": "41 WHEAT ST",
    "dropphycty": "HARPERSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 350786317,
    "dropmaladd": "41 WHEAT ST",
    "dropmalcty": "HARPERSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 350789998,
    "dropsitphn": 2056728456,
    "dropsitlph": 2056728456,
    "dropsitcph": 2056728209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10572",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "AL",
    "dropdelzpp": 363441600,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "AL",
    "dropphyzpp": 363441600,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "AL",
    "dropmalzpp": 363449998,
    "dropsitphn": 3345882952,
    "dropsitlph": 3345882952,
    "dropsitcph": 3345882952,
    "dropfax": 3345880722
  },
  {
    "dcode": "D",
    "dropkey": "PY10573",
    "droptype": "D",
    "dropname": "HARTSELLE",
    "dropdeladd": "201 CEDAR ST NW",
    "dropdelcty": "HARTSELLE",
    "dropdelst": "AL",
    "dropdelzpp": 356402403,
    "dropphyadd": "201 CEDAR ST NW",
    "dropphycty": "HARTSELLE",
    "dropphyst": "AL",
    "dropphyzpp": 356402403,
    "dropmaladd": "201 CEDAR ST NW",
    "dropmalcty": "HARTSELLE",
    "dropmalst": "AL",
    "dropmalzpp": 356409998,
    "dropsitphn": 2567736671,
    "dropsitlph": 2567736671,
    "dropsitcph": 2567736671,
    "dropfax": 2567733614
  },
  {
    "dcode": "D",
    "dropkey": "PY10574",
    "droptype": "D",
    "dropname": "HARVEST",
    "dropdeladd": "9157 WALL TRIANA HWY",
    "dropdelcty": "HARVEST",
    "dropdelst": "AL",
    "dropdelzpp": 357496603,
    "dropphyadd": "9157 WALL TRIANA HWY",
    "dropphycty": "HARVEST",
    "dropphyst": "AL",
    "dropphyzpp": 357496603,
    "dropmaladd": "9157 WALL TRIANA HWY",
    "dropmalcty": "HARVEST",
    "dropmalst": "AL",
    "dropmalzpp": 357499998,
    "dropsitphn": 2568370397,
    "dropsitlph": 2568370397,
    "dropsitcph": 2568370397,
    "dropfax": 2568378654
  },
  {
    "dcode": "D",
    "dropkey": "PY10575",
    "droptype": "D",
    "dropname": "HATCHECHUBBEE",
    "dropdeladd": "601 UCHEE RD",
    "dropdelcty": "HATCHECHUBBEE",
    "dropdelst": "AL",
    "dropdelzpp": 368589998,
    "dropphyadd": "601 UCHEE RD",
    "dropphycty": "HATCHECHUBBEE",
    "dropphyst": "AL",
    "dropphyzpp": 368589998,
    "dropmaladd": "601 UCHEE RD",
    "dropmalcty": "HATCHECHUBBEE",
    "dropmalst": "AL",
    "dropmalzpp": 368589998,
    "dropsitphn": 3346677324,
    "dropsitlph": 3346677324,
    "dropsitcph": 3346677324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10580",
    "droptype": "D",
    "dropname": "HAYDEN",
    "dropdeladd": "4425 STATE HIGHWAY 160",
    "dropdelcty": "HAYDEN",
    "dropdelst": "AL",
    "dropdelzpp": 350796566,
    "dropphyadd": "4425 STATE HIGHWAY 160",
    "dropphycty": "HAYDEN",
    "dropphyst": "AL",
    "dropphyzpp": 350796566,
    "dropmaladd": "4425 STATE HIGHWAY 160",
    "dropmalcty": "HAYDEN",
    "dropmalst": "AL",
    "dropmalzpp": 350799998,
    "dropsitphn": 2056473825,
    "dropsitlph": 2056473825,
    "dropsitcph": 2056473825,
    "dropfax": 2056473898
  },
  {
    "dcode": "D",
    "dropkey": "PY10581",
    "droptype": "D",
    "dropname": "HAYNEVILLE",
    "dropdeladd": "1 ACADEMY LN",
    "dropdelcty": "HAYNEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360402617,
    "dropphyadd": "1 ACADEMY LN",
    "dropphycty": "HAYNEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360402617,
    "dropmaladd": "1 ACADEMY LN",
    "dropmalcty": "HAYNEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360409998,
    "dropsitphn": 3345482146,
    "dropsitlph": 3345482146,
    "dropsitcph": 3345482146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10586",
    "droptype": "D",
    "dropname": "HAZEL GREEN",
    "dropdeladd": "14297 HIGHWAY 231 431 N",
    "dropdelcty": "HAZEL GREEN",
    "dropdelst": "AL",
    "dropdelzpp": 357508921,
    "dropphyadd": "14297 HIGHWAY 231 431 N",
    "dropphycty": "HAZEL GREEN",
    "dropphyst": "AL",
    "dropphyzpp": 357508921,
    "dropmaladd": "14297 HIGHWAY 231 431 N",
    "dropmalcty": "HAZEL GREEN",
    "dropmalst": "AL",
    "dropmalzpp": 357509998,
    "dropsitphn": 2568282658,
    "dropsitlph": 2568282658,
    "dropsitcph": 2568289772,
    "dropfax": 2568283603
  },
  {
    "dcode": "D",
    "dropkey": "PY10587",
    "droptype": "D",
    "dropname": "HEADLAND",
    "dropdeladd": "711 MITCHELL ST",
    "dropdelcty": "HEADLAND",
    "dropdelst": "AL",
    "dropdelzpp": 363452101,
    "dropphyadd": "711 MITCHELL ST",
    "dropphycty": "HEADLAND",
    "dropphyst": "AL",
    "dropphyzpp": 363452101,
    "dropmaladd": "711 MITCHELL ST",
    "dropmalcty": "HEADLAND",
    "dropmalst": "AL",
    "dropmalzpp": 363459998,
    "dropsitphn": 3346933505,
    "dropsitlph": 3346933505,
    "dropsitcph": 3346933505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10590",
    "droptype": "D",
    "dropname": "HEFLIN",
    "dropdeladd": "1519 ALMON ST",
    "dropdelcty": "HEFLIN",
    "dropdelst": "AL",
    "dropdelzpp": 362641823,
    "dropphyadd": "1519 ALMON ST",
    "dropphycty": "HEFLIN",
    "dropphyst": "AL",
    "dropphyzpp": 362641823,
    "dropmaladd": "1519 ALMON ST",
    "dropmalcty": "HEFLIN",
    "dropmalst": "AL",
    "dropmalzpp": 362649998,
    "dropsitphn": 2564632430,
    "dropsitlph": 2564632430,
    "dropsitcph": 2564632430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10591",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "800 HIGHWAY 52",
    "dropdelcty": "HELENA",
    "dropdelst": "AL",
    "dropdelzpp": 350807760,
    "dropphyadd": "800 HIGHWAY 52",
    "dropphycty": "HELENA",
    "dropphyst": "AL",
    "dropphyzpp": 350807760,
    "dropmaladd": "800 HIGHWAY 52",
    "dropmalcty": "HELENA",
    "dropmalst": "AL",
    "dropmalzpp": 350809998,
    "dropsitphn": 2056216388,
    "dropsitlph": 2056216388,
    "dropsitcph": 2056216388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10592",
    "droptype": "D",
    "dropname": "HENAGAR",
    "dropdeladd": "17136 BROAD ST",
    "dropdelcty": "HENAGAR",
    "dropdelst": "AL",
    "dropdelzpp": 359789998,
    "dropphyadd": "17136 BROAD ST",
    "dropphycty": "HENAGAR",
    "dropphyst": "AL",
    "dropphyzpp": 359789998,
    "dropmaladd": "17136 BROAD ST",
    "dropmalcty": "HENAGAR",
    "dropmalst": "AL",
    "dropmalzpp": 359789998,
    "dropsitphn": 2566573397,
    "dropsitlph": 2566573397,
    "dropsitcph": 2566573397,
    "dropfax": 2566572092
  },
  {
    "dcode": "D",
    "dropkey": "PY10595",
    "droptype": "D",
    "dropname": "HIGDON",
    "dropdeladd": "29396 AL HIGHWAY 71",
    "dropdelcty": "HIGDON",
    "dropdelst": "AL",
    "dropdelzpp": 359796200,
    "dropphyadd": "29396 AL HIGHWAY 71",
    "dropphycty": "HIGDON",
    "dropphyst": "AL",
    "dropphyzpp": 359796200,
    "dropmaladd": "29396 AL HIGHWAY 71",
    "dropmalcty": "HIGDON",
    "dropmalst": "AL",
    "dropmalzpp": 359799998,
    "dropsitphn": 2565972058,
    "dropsitlph": 2565972058,
    "dropsitcph": 2565972058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10599",
    "droptype": "D",
    "dropname": "HIGHLAND HOME",
    "dropdeladd": "17845 MONTGOMERY HWY",
    "dropdelcty": "HIGHLAND HOME",
    "dropdelst": "AL",
    "dropdelzpp": 360419998,
    "dropphyadd": "17845 MONTGOMERY HWY",
    "dropphycty": "HIGHLAND HOME",
    "dropphyst": "AL",
    "dropphyzpp": 360419998,
    "dropmaladd": "17845 MONTGOMERY HWY",
    "dropmalcty": "HIGHLAND HOME",
    "dropmalst": "AL",
    "dropmalzpp": 360419998,
    "dropsitphn": 3345374369,
    "dropsitlph": 3345374369,
    "dropsitcph": 3345374369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10602",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "564 FRONT ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "AL",
    "dropdelzpp": 356433851,
    "dropphyadd": "564 FRONT ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "AL",
    "dropphyzpp": 356433851,
    "dropmaladd": "564 FRONT ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "AL",
    "dropmalzpp": 356439998,
    "dropsitphn": 2566372405,
    "dropsitlph": 2566372405,
    "dropsitcph": 2566372405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10604",
    "droptype": "D",
    "dropname": "HODGES",
    "dropdeladd": "227 MAIN ST",
    "dropdelcty": "HODGES",
    "dropdelst": "AL",
    "dropdelzpp": 355713421,
    "dropphyadd": "227 MAIN ST",
    "dropphycty": "HODGES",
    "dropphyst": "AL",
    "dropphyzpp": 355713421,
    "dropmaladd": "227 MAIN ST",
    "dropmalcty": "HODGES",
    "dropmalst": "AL",
    "dropmalzpp": 355719998,
    "dropsitphn": 2059353510,
    "dropsitlph": 2059353510,
    "dropsitcph": 2053950340,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10609",
    "droptype": "D",
    "dropname": "HOLLY POND",
    "dropdeladd": "77 BROOKLYN RD",
    "dropdelcty": "HOLLY POND",
    "dropdelst": "AL",
    "dropdelzpp": 350836475,
    "dropphyadd": "77 BROOKLYN RD",
    "dropphycty": "HOLLY POND",
    "dropphyst": "AL",
    "dropphyzpp": 350836475,
    "dropmaladd": "77 BROOKLYN RD",
    "dropmalcty": "HOLLY POND",
    "dropmalst": "AL",
    "dropmalzpp": 350839998,
    "dropsitphn": 2567965313,
    "dropsitlph": 2567965313,
    "dropsitcph": 2567965313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10610",
    "droptype": "D",
    "dropname": "HOLLYTREE",
    "dropdeladd": "11751 AL HIGHWAY 65",
    "dropdelcty": "HOLLYTREE",
    "dropdelst": "AL",
    "dropdelzpp": 357515320,
    "dropphyadd": "11751 AL HIGHWAY 65",
    "dropphycty": "HOLLYTREE",
    "dropphyst": "AL",
    "dropphyzpp": 357515320,
    "dropmaladd": "11751 AL HIGHWAY 65",
    "dropmalcty": "HOLLYTREE",
    "dropmalst": "AL",
    "dropmalzpp": 357519998,
    "dropsitphn": 2567769055,
    "dropsitlph": 2567769055,
    "dropsitcph": 2567769055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10611",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "29206 US HIGHWAY 72",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 357526408,
    "dropphyadd": "29206 US HIGHWAY 72",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 357526408,
    "dropmaladd": "29206 US HIGHWAY 72",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 357529998,
    "dropsitphn": 2562590686,
    "dropsitlph": 2562590686,
    "dropsitcph": 2562590686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10617",
    "droptype": "D",
    "dropname": "HONORAVILLE",
    "dropdeladd": "47 POST OFFICE LOOP",
    "dropdelcty": "HONORAVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360429998,
    "dropphyadd": "47 POST OFFICE LOOP",
    "dropphycty": "HONORAVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360429998,
    "dropmaladd": "47 POST OFFICE LOOP",
    "dropmalcty": "HONORAVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360429998,
    "dropsitphn": 3343823470,
    "dropsitlph": 3343823470,
    "dropsitcph": 3343823470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10623",
    "droptype": "D",
    "dropname": "HOPE HULL",
    "dropdeladd": "275 WASDEN RD",
    "dropdelcty": "HOPE HULL",
    "dropdelst": "AL",
    "dropdelzpp": 360439998,
    "dropphyadd": "275 WASDEN RD",
    "dropphycty": "HOPE HULL",
    "dropphyst": "AL",
    "dropphyzpp": 360439998,
    "dropmaladd": "275 WASDEN RD",
    "dropmalcty": "HOPE HULL",
    "dropmalst": "AL",
    "dropmalzpp": 360439998,
    "dropsitphn": 3342816795,
    "dropsitlph": 3342816795,
    "dropsitcph": 3342816795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10625",
    "droptype": "D",
    "dropname": "HORTON",
    "dropdeladd": "6396 AL HIGHWAY 75",
    "dropdelcty": "HORTON",
    "dropdelst": "AL",
    "dropdelzpp": 359808495,
    "dropphyadd": "6396 AL HIGHWAY 75",
    "dropphycty": "HORTON",
    "dropphyst": "AL",
    "dropphyzpp": 359808495,
    "dropmaladd": "6396 AL HIGHWAY 75",
    "dropmalcty": "HORTON",
    "dropmalst": "AL",
    "dropmalzpp": 359809998,
    "dropsitphn": 2565937196,
    "dropsitlph": 2565937196,
    "dropsitcph": 2565937196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10626",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "4802 COUNTY ROAD 63",
    "dropdelcty": "HOUSTON",
    "dropdelst": "AL",
    "dropdelzpp": 355722643,
    "dropphyadd": "4802 COUNTY ROAD 63",
    "dropphycty": "HOUSTON",
    "dropphyst": "AL",
    "dropphyzpp": 355722643,
    "dropmaladd": "4802 COUNTY ROAD 63",
    "dropmalcty": "HOUSTON",
    "dropmalst": "AL",
    "dropmalzpp": 355729998,
    "dropsitphn": 2054895759,
    "dropsitlph": 2054895759,
    "dropsitcph": 2056273005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10632",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "3408 WALL TRIANA HWY",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358131000,
    "dropphyadd": "3408 WALL TRIANA HWY",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358131000,
    "dropmaladd": "3408 WALL TRIANA HWY",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358139998,
    "dropsitphn": 2564616630,
    "dropsitlph": 2564616630,
    "dropsitcph": 2564616630,
    "dropfax": 2564617885
  },
  {
    "dcode": "D",
    "dropkey": "PY10636",
    "droptype": "D",
    "dropname": "HURTSBORO",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "HURTSBORO",
    "dropdelst": "AL",
    "dropdelzpp": 368609998,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "HURTSBORO",
    "dropphyst": "AL",
    "dropphyzpp": 368609998,
    "dropmaladd": "311 MAIN ST",
    "dropmalcty": "HURTSBORO",
    "dropmalst": "AL",
    "dropmalzpp": 368609998,
    "dropsitphn": 3346677391,
    "dropsitlph": 3346677391,
    "dropsitcph": 3346677391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10644",
    "droptype": "D",
    "dropname": "IDER",
    "dropdeladd": "11134 AL HIGHWAY 75",
    "dropdelcty": "IDER",
    "dropdelst": "AL",
    "dropdelzpp": 359814714,
    "dropphyadd": "11134 AL HIGHWAY 75",
    "dropphycty": "IDER",
    "dropphyst": "AL",
    "dropphyzpp": 359814714,
    "dropmaladd": "11134 AL HIGHWAY 75",
    "dropmalcty": "IDER",
    "dropmalst": "AL",
    "dropmalzpp": 359819998,
    "dropsitphn": 2566574208,
    "dropsitlph": 2566574208,
    "dropsitcph": 2566574208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10649",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "9251 IRVINGTON BLB HWY",
    "dropdelcty": "IRVINGTON",
    "dropdelst": "AL",
    "dropdelzpp": 365442100,
    "dropphyadd": "9251 IRVINGTON BLB HWY",
    "dropphycty": "IRVINGTON",
    "dropphyst": "AL",
    "dropphyzpp": 365442100,
    "dropmaladd": "9251 IRVINGTON BLB HWY",
    "dropmalcty": "IRVINGTON",
    "dropmalst": "AL",
    "dropmalzpp": 365449998,
    "dropsitphn": 2519571643,
    "dropsitlph": 2519571643,
    "dropsitcph": 2519571643,
    "dropfax": 2519576879
  },
  {
    "dcode": "D",
    "dropkey": "PY10652",
    "droptype": "D",
    "dropname": "JACK",
    "dropdeladd": "29950 HIGHWAY 87",
    "dropdelcty": "JACK",
    "dropdelst": "AL",
    "dropdelzpp": 363465065,
    "dropphyadd": "29950 HIGHWAY 87",
    "dropphycty": "JACK",
    "dropphyst": "AL",
    "dropphyzpp": 363465065,
    "dropmaladd": "29950 HIGHWAY 87",
    "dropmalcty": "JACK",
    "dropmalst": "AL",
    "dropmalzpp": 363469998,
    "dropsitphn": 3348976738,
    "dropsitlph": 3348976738,
    "dropsitcph": 3348976738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10653",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "1829 COLLEGE AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "AL",
    "dropdelzpp": 365452429,
    "dropphyadd": "1829 COLLEGE AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "AL",
    "dropphyzpp": 365452429,
    "dropmaladd": "1829 COLLEGE AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "AL",
    "dropmalzpp": 365459998,
    "dropsitphn": 2512463626,
    "dropsitlph": 2512463626,
    "dropsitcph": 2512463626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10654",
    "droptype": "D",
    "dropname": "JACKSONS GAP",
    "dropdeladd": "1564 MAIN ST",
    "dropdelcty": "JACKSONS GAP",
    "dropdelst": "AL",
    "dropdelzpp": 368619998,
    "dropphyadd": "1564 MAIN ST",
    "dropphycty": "JACKSONS GAP",
    "dropphyst": "AL",
    "dropphyzpp": 368619998,
    "dropmaladd": "1564 MAIN ST",
    "dropmalcty": "JACKSONS GAP",
    "dropmalst": "AL",
    "dropmalzpp": 368619998,
    "dropsitphn": 2568259853,
    "dropsitlph": 2568259853,
    "dropsitcph": 2568259853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10655",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "421 PELHAM RD N",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 362652142,
    "dropphyadd": "421 PELHAM RD N",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 362652142,
    "dropmaladd": "421 PELHAM RD N",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 362659998,
    "dropsitphn": 2564359069,
    "dropsitlph": 2564359069,
    "dropsitcph": 2564359069,
    "dropfax": 2564350858
  },
  {
    "dcode": "D",
    "dropkey": "PY10658",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "2101 3RD AVE S",
    "dropdelcty": "JASPER",
    "dropdelst": "AL",
    "dropdelzpp": 355019998,
    "dropphyadd": "2101 3RD AVE S",
    "dropphycty": "JASPER",
    "dropphyst": "AL",
    "dropphyzpp": 355019998,
    "dropmaladd": "2101 3RD AVE S",
    "dropmalcty": "JASPER",
    "dropmalst": "AL",
    "dropmalzpp": 355019998,
    "dropsitphn": 2053845516,
    "dropsitlph": 2053845516,
    "dropsitcph": 2053845516,
    "dropfax": 2053841943
  },
  {
    "dcode": "D",
    "dropkey": "PY10662",
    "droptype": "D",
    "dropname": "JEMISON",
    "dropdeladd": "24760 US HIGHWAY 31",
    "dropdelcty": "JEMISON",
    "dropdelst": "AL",
    "dropdelzpp": 350854428,
    "dropphyadd": "24760 US HIGHWAY 31",
    "dropphycty": "JEMISON",
    "dropphyst": "AL",
    "dropphyzpp": 350854428,
    "dropmaladd": "24760 US HIGHWAY 31",
    "dropmalcty": "JEMISON",
    "dropmalst": "AL",
    "dropmalzpp": 350859998,
    "dropsitphn": 2056882521,
    "dropsitlph": 2056882521,
    "dropsitcph": 2056882521,
    "dropfax": 2056885772
  },
  {
    "dcode": "D",
    "dropkey": "PY10663",
    "droptype": "D",
    "dropname": "JONES",
    "dropdeladd": "891 SHORT ST",
    "dropdelcty": "JONES",
    "dropdelst": "AL",
    "dropdelzpp": 367499998,
    "dropphyadd": "891 SHORT ST",
    "dropphycty": "JONES",
    "dropphyst": "AL",
    "dropphyzpp": 367499998,
    "dropmaladd": "891 SHORT ST",
    "dropmalcty": "JONES",
    "dropmalst": "AL",
    "dropmalzpp": 367499998,
    "dropsitphn": 3348723304,
    "dropsitlph": 3348723304,
    "dropsitcph": 3348723304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10664",
    "droptype": "D",
    "dropname": "JOPPA",
    "dropdeladd": "15960 AL HIGHWAY 69 N",
    "dropdelcty": "JOPPA",
    "dropdelst": "AL",
    "dropdelzpp": 350872170,
    "dropphyadd": "15960 AL HIGHWAY 69 N",
    "dropphycty": "JOPPA",
    "dropphyst": "AL",
    "dropphyzpp": 350872170,
    "dropmaladd": "15960 AL HIGHWAY 69 N",
    "dropmalcty": "JOPPA",
    "dropmalst": "AL",
    "dropmalzpp": 350879998,
    "dropsitphn": 2565863705,
    "dropsitlph": 2565863705,
    "dropsitcph": 2565863705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10666",
    "droptype": "D",
    "dropname": "KANSAS",
    "dropdeladd": "497 OLD HIGHWAY 78",
    "dropdelcty": "KANSAS",
    "dropdelst": "AL",
    "dropdelzpp": 355732000,
    "dropphyadd": "497 OLD HIGHWAY 78",
    "dropphycty": "KANSAS",
    "dropphyst": "AL",
    "dropphyzpp": 355732000,
    "dropmaladd": "497 OLD HIGHWAY 78",
    "dropmalcty": "KANSAS",
    "dropmalst": "AL",
    "dropmalzpp": 355739998,
    "dropsitphn": 2059249621,
    "dropsitlph": 2059249621,
    "dropsitcph": 2059249621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10670",
    "droptype": "D",
    "dropname": "KELLYTON",
    "dropdeladd": "338 FIREHOUSE RD",
    "dropdelcty": "KELLYTON",
    "dropdelst": "AL",
    "dropdelzpp": 350899998,
    "dropphyadd": "338 FIREHOUSE RD",
    "dropphycty": "KELLYTON",
    "dropphyst": "AL",
    "dropphyzpp": 350899998,
    "dropmaladd": "338 FIREHOUSE RD",
    "dropmalcty": "KELLYTON",
    "dropmalst": "AL",
    "dropmalzpp": 350899998,
    "dropsitphn": 2563298968,
    "dropsitlph": 2563298968,
    "dropsitcph": 2563298968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10671",
    "droptype": "D",
    "dropname": "KENNEDY",
    "dropdeladd": "4187 COUNTY ROAD 49",
    "dropdelcty": "KENNEDY",
    "dropdelst": "AL",
    "dropdelzpp": 355742510,
    "dropphyadd": "4187 COUNTY ROAD 49",
    "dropphycty": "KENNEDY",
    "dropphyst": "AL",
    "dropphyzpp": 355742510,
    "dropmaladd": "4187 COUNTY ROAD 49",
    "dropmalcty": "KENNEDY",
    "dropmalst": "AL",
    "dropmalzpp": 355749998,
    "dropsitphn": 2055963269,
    "dropsitlph": 2055963269,
    "dropsitcph": 2055963269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10676",
    "droptype": "D",
    "dropname": "KILLEN",
    "dropdeladd": "1650 HIGHWAY 72",
    "dropdelcty": "KILLEN",
    "dropdelst": "AL",
    "dropdelzpp": 356459141,
    "dropphyadd": "1650 HIGHWAY 72",
    "dropphycty": "KILLEN",
    "dropphyst": "AL",
    "dropphyzpp": 356459141,
    "dropmaladd": "1650 HIGHWAY 72",
    "dropmalcty": "KILLEN",
    "dropmalst": "AL",
    "dropmalzpp": 356459998,
    "dropsitphn": 2567573742,
    "dropsitlph": 2567573742,
    "dropsitcph": 2567573742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10677",
    "droptype": "D",
    "dropname": "KIMBERLY",
    "dropdeladd": "9261 STOUTS RD",
    "dropdelcty": "KIMBERLY",
    "dropdelst": "AL",
    "dropdelzpp": 350912103,
    "dropphyadd": "9261 STOUTS RD",
    "dropphycty": "KIMBERLY",
    "dropphyst": "AL",
    "dropphyzpp": 350912103,
    "dropmaladd": "9261 STOUTS RD",
    "dropmalcty": "KIMBERLY",
    "dropmalst": "AL",
    "dropmalzpp": 350919998,
    "dropsitphn": 2056473151,
    "dropsitlph": 2056473151,
    "dropsitcph": 2056473151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10681",
    "droptype": "D",
    "dropname": "KINSTON",
    "dropdeladd": "216 N MAIN ST",
    "dropdelcty": "KINSTON",
    "dropdelst": "AL",
    "dropdelzpp": 364533442,
    "dropphyadd": "216 N MAIN ST",
    "dropphycty": "KINSTON",
    "dropphyst": "AL",
    "dropphyzpp": 364533442,
    "dropmaladd": "216 N MAIN ST",
    "dropmalcty": "KINSTON",
    "dropmalst": "AL",
    "dropmalzpp": 364539998,
    "dropsitphn": 3345653073,
    "dropsitlph": 3345653073,
    "dropsitcph": 3345653073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10685",
    "droptype": "D",
    "dropname": "LACEYS SPRING",
    "dropdeladd": "1795 HIGHWAY 231",
    "dropdelcty": "LACEYS SPRING",
    "dropdelst": "AL",
    "dropdelzpp": 357543448,
    "dropphyadd": "1795 HIGHWAY 231",
    "dropphycty": "LACEYS SPRING",
    "dropphyst": "AL",
    "dropphyzpp": 357543448,
    "dropmaladd": "1795 HIGHWAY 231",
    "dropmalcty": "LACEYS SPRING",
    "dropmalst": "AL",
    "dropmalzpp": 357549998,
    "dropsitphn": 2568821901,
    "dropsitlph": 2568821901,
    "dropsitcph": 2568821901,
    "dropfax": 2568827041
  },
  {
    "dcode": "D",
    "dropkey": "PY10686",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "18 ALABAMA AVE W",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "AL",
    "dropdelzpp": 368629998,
    "dropphyadd": "18 ALABAMA AVE W",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "AL",
    "dropphyzpp": 368629998,
    "dropmaladd": "18 ALABAMA AVE W",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "AL",
    "dropmalzpp": 368629998,
    "dropsitphn": 3348648388,
    "dropsitlph": 3348648388,
    "dropsitcph": 3348648388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10689",
    "droptype": "D",
    "dropname": "LAMISON",
    "dropdeladd": "6701 WINTON BLOUNT BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361199321,
    "dropphyadd": "6701 WINTON BLOUNT BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361199321,
    "dropmaladd": "6701 WINTON BLOUNT BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361199321,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3342447621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10690",
    "droptype": "D",
    "dropname": "LANETT",
    "dropdeladd": "1 1ST ST",
    "dropdelcty": "LANETT",
    "dropdelst": "AL",
    "dropdelzpp": 368639998,
    "dropphyadd": "1 1ST ST",
    "dropphycty": "LANETT",
    "dropphyst": "AL",
    "dropphyzpp": 368639998,
    "dropmaladd": "1 1ST ST",
    "dropmalcty": "LANETT",
    "dropmalst": "AL",
    "dropmalzpp": 368639998,
    "dropsitphn": 3346444606,
    "dropsitlph": 3346444606,
    "dropsitcph": 3346444606,
    "dropfax": 3346447760
  },
  {
    "dcode": "D",
    "dropkey": "PY10691",
    "droptype": "D",
    "dropname": "LANGSTON",
    "dropdeladd": "8989 COUNTY ROAD 67",
    "dropdelcty": "LANGSTON",
    "dropdelst": "AL",
    "dropdelzpp": 357558231,
    "dropphyadd": "8989 COUNTY ROAD 67",
    "dropphycty": "LANGSTON",
    "dropphyst": "AL",
    "dropphyzpp": 357558231,
    "dropmaladd": "8989 COUNTY ROAD 67",
    "dropmalcty": "LANGSTON",
    "dropmalst": "AL",
    "dropmalzpp": 357559998,
    "dropsitphn": 2562286057,
    "dropsitlph": 2562286057,
    "dropsitcph": 2562286057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10692",
    "droptype": "D",
    "dropname": "LAPINE",
    "dropdeladd": "1126 MERIWETHER TRL",
    "dropdelcty": "LAPINE",
    "dropdelst": "AL",
    "dropdelzpp": 360469998,
    "dropphyadd": "1126 MERIWETHER TRL",
    "dropphycty": "LAPINE",
    "dropphyst": "AL",
    "dropphyzpp": 360469998,
    "dropmaladd": "1126 MERIWETHER TRL",
    "dropmalcty": "LAPINE",
    "dropmalst": "AL",
    "dropmalzpp": 360469998,
    "dropsitphn": 3345374363,
    "dropsitlph": 3345374363,
    "dropsitcph": 3345374363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10694",
    "droptype": "D",
    "dropname": "LAWLEY",
    "dropdeladd": "2658 HIGHWAY 36",
    "dropdelcty": "LAWLEY",
    "dropdelst": "AL",
    "dropdelzpp": 367937187,
    "dropphyadd": "2658 HIGHWAY 36",
    "dropphycty": "LAWLEY",
    "dropphyst": "AL",
    "dropphyzpp": 367937187,
    "dropmaladd": "2658 HIGHWAY 36",
    "dropmalcty": "LAWLEY",
    "dropmalst": "AL",
    "dropmalzpp": 367937187,
    "dropsitphn": 3343662249,
    "dropsitlph": 3343662249,
    "dropsitcph": 3343662249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10696",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "1500 8TH ST",
    "dropdelcty": "LEEDS",
    "dropdelst": "AL",
    "dropdelzpp": 350944101,
    "dropphyadd": "1500 8TH ST",
    "dropphycty": "LEEDS",
    "dropphyst": "AL",
    "dropphyzpp": 350944101,
    "dropmaladd": "1500 8TH ST",
    "dropmalcty": "LEEDS",
    "dropmalst": "AL",
    "dropmalzpp": 350944101,
    "dropsitphn": 2056991077,
    "dropsitlph": 2056991077,
    "dropsitcph": 2056991077,
    "dropfax": 2056991199
  },
  {
    "dcode": "D",
    "dropkey": "PY10697",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "1045 RIVERSIDE ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "AL",
    "dropdelzpp": 359833504,
    "dropphyadd": "1045 RIVERSIDE ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "AL",
    "dropphyzpp": 359833504,
    "dropmaladd": "1045 RIVERSIDE ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "AL",
    "dropmalzpp": 359839998,
    "dropsitphn": 2055268076,
    "dropsitlph": 2055268076,
    "dropsitcph": 2566996000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10698",
    "droptype": "D",
    "dropname": "LEIGHTON",
    "dropdeladd": "8945 MAIN ST",
    "dropdelcty": "LEIGHTON",
    "dropdelst": "AL",
    "dropdelzpp": 356463825,
    "dropphyadd": "8945 MAIN ST",
    "dropphycty": "LEIGHTON",
    "dropphyst": "AL",
    "dropphyzpp": 356463825,
    "dropmaladd": "8945 MAIN ST",
    "dropmalcty": "LEIGHTON",
    "dropmalst": "AL",
    "dropmalzpp": 356469998,
    "dropsitphn": 2564465272,
    "dropsitlph": 2564465272,
    "dropsitcph": 2564461005,
    "dropfax": 2564461003
  },
  {
    "dcode": "D",
    "dropkey": "PY10701",
    "droptype": "D",
    "dropname": "LEROY",
    "dropdeladd": "19 WASHINGTON ST",
    "dropdelcty": "LEROY",
    "dropdelst": "AL",
    "dropdelzpp": 365485100,
    "dropphyadd": "19 WASHINGTON ST",
    "dropphycty": "LEROY",
    "dropphyst": "AL",
    "dropphyzpp": 365485100,
    "dropmaladd": "19 WASHINGTON ST",
    "dropmalcty": "LEROY",
    "dropmalst": "AL",
    "dropmalzpp": 365489998,
    "dropsitphn": 2512465138,
    "dropsitlph": 2512465138,
    "dropsitcph": 2512465138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10703",
    "droptype": "D",
    "dropname": "LETOHATCHEE",
    "dropdeladd": "6142 STATE HIGHWAY 97 S",
    "dropdelcty": "LETOHATCHEE",
    "dropdelst": "AL",
    "dropdelzpp": 360479998,
    "dropphyadd": "6142 STATE HIGHWAY 97 S",
    "dropphycty": "LETOHATCHEE",
    "dropphyst": "AL",
    "dropphyzpp": 360479998,
    "dropmaladd": "6142 STATE HIGHWAY 97 S",
    "dropmalcty": "LETOHATCHEE",
    "dropmalst": "AL",
    "dropmalzpp": 360479998,
    "dropsitphn": 3342279900,
    "dropsitlph": 3342279900,
    "dropsitcph": 3342279900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10707",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "101 STEVENS AVE",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "AL",
    "dropdelzpp": 356483747,
    "dropphyadd": "101 STEVENS AVE",
    "dropphycty": "LEXINGTON",
    "dropphyst": "AL",
    "dropphyzpp": 356483747,
    "dropmaladd": "101 STEVENS AVE",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "AL",
    "dropmalzpp": 356489998,
    "dropsitphn": 2562296525,
    "dropsitlph": 2562296525,
    "dropsitcph": 2562295952,
    "dropfax": 2562296525
  },
  {
    "dcode": "D",
    "dropkey": "PY10710",
    "droptype": "D",
    "dropname": "LILLIAN",
    "dropdeladd": "33985 US HIGHWAY 98",
    "dropdelcty": "LILLIAN",
    "dropdelst": "AL",
    "dropdelzpp": 365493925,
    "dropphyadd": "33985 US HIGHWAY 98",
    "dropphycty": "LILLIAN",
    "dropphyst": "AL",
    "dropphyzpp": 365493925,
    "dropmaladd": "33985 US HIGHWAY 98",
    "dropmalcty": "LILLIAN",
    "dropmalst": "AL",
    "dropmalzpp": 365499998,
    "dropsitphn": 2519623666,
    "dropsitlph": 2519623666,
    "dropsitcph": 2519623666,
    "dropfax": 2519623969
  },
  {
    "dcode": "D",
    "dropkey": "PY10712",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "47645 US HIGHWAY 78",
    "dropdelcty": "LINCOLN",
    "dropdelst": "AL",
    "dropdelzpp": 350968501,
    "dropphyadd": "47645 US HIGHWAY 78",
    "dropphycty": "LINCOLN",
    "dropphyst": "AL",
    "dropphyzpp": 350968501,
    "dropmaladd": "47645 US HIGHWAY 78",
    "dropmalcty": "LINCOLN",
    "dropmalst": "AL",
    "dropmalzpp": 350969998,
    "dropsitphn": 2057637444,
    "dropsitlph": 2057637444,
    "dropsitcph": 2057637444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10713",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "125 W 7TH AVE",
    "dropdelcty": "LINDEN",
    "dropdelst": "AL",
    "dropdelzpp": 367489998,
    "dropphyadd": "125 W 7TH AVE",
    "dropphycty": "LINDEN",
    "dropphyst": "AL",
    "dropphyzpp": 367481451,
    "dropmaladd": "125 W 7TH AVE",
    "dropmalcty": "LINDEN",
    "dropmalst": "AL",
    "dropmalzpp": 367489998,
    "dropsitphn": 3342955783,
    "dropsitlph": 3342955783,
    "dropsitcph": 3342955783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10714",
    "droptype": "D",
    "dropname": "LINEVILLE",
    "dropdeladd": "60035 HIGHWAY 49",
    "dropdelcty": "LINEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 362664736,
    "dropphyadd": "60035 HIGHWAY 49",
    "dropphycty": "LINEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 362664736,
    "dropmaladd": "60035 HIGHWAY 49",
    "dropmalcty": "LINEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 362669998,
    "dropsitphn": 2563962095,
    "dropsitlph": 2563962095,
    "dropsitcph": 2563962095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10718",
    "droptype": "D",
    "dropname": "LISMAN",
    "dropdeladd": "4845 COUNTY ROAD 9",
    "dropdelcty": "LISMAN",
    "dropdelst": "AL",
    "dropdelzpp": 369129998,
    "dropphyadd": "4845 COUNTY ROAD 9",
    "dropphycty": "LISMAN",
    "dropphyst": "AL",
    "dropphyzpp": 369129998,
    "dropmaladd": "4845 COUNTY ROAD 9",
    "dropmalcty": "LISMAN",
    "dropmalst": "AL",
    "dropmalzpp": 369129998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2053983643,
    "dropfax": 2053984043
  },
  {
    "dcode": "D",
    "dropkey": "PY10720",
    "droptype": "D",
    "dropname": "LITTLE RIVER",
    "dropdeladd": "70715 STATE HIGHWAY 59",
    "dropdelcty": "LITTLE RIVER",
    "dropdelst": "AL",
    "dropdelzpp": 365509998,
    "dropphyadd": "70715 STATE HIGHWAY 59",
    "dropphycty": "LITTLE RIVER",
    "dropphyst": "AL",
    "dropphyzpp": 365509998,
    "dropmaladd": "70715 STATE HIGHWAY 59",
    "dropmalcty": "LITTLE RIVER",
    "dropmalst": "AL",
    "dropmalzpp": 365509801,
    "dropsitphn": 2518625267,
    "dropsitlph": 2518625267,
    "dropsitcph": 2518625267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10721",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "321 WASHINGTON ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "AL",
    "dropdelzpp": 354709790,
    "dropphyadd": "321 WASHINGTON ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "AL",
    "dropphyzpp": 354709790,
    "dropmaladd": "321 WASHINGTON ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "AL",
    "dropmalzpp": 354709998,
    "dropsitphn": 2056522411,
    "dropsitlph": 2056522411,
    "dropsitcph": 2056522411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10722",
    "droptype": "D",
    "dropname": "LOACHAPOKA",
    "dropdeladd": "6091 STAGE RD",
    "dropdelcty": "LOACHAPOKA",
    "dropdelst": "AL",
    "dropdelzpp": 368659997,
    "dropphyadd": "6091 STAGE RD",
    "dropphycty": "LOACHAPOKA",
    "dropphyst": "AL",
    "dropphyzpp": 368659997,
    "dropmaladd": "6091 STAGE RD",
    "dropmalcty": "LOACHAPOKA",
    "dropmalst": "AL",
    "dropmalzpp": 368659997,
    "dropsitphn": 3348878465,
    "dropsitlph": 3348878465,
    "dropsitcph": 3348878465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10723",
    "droptype": "D",
    "dropname": "LOCKHART",
    "dropdeladd": "1550 CHIPPEWAY ST",
    "dropdelcty": "LOCKHART",
    "dropdelst": "AL",
    "dropdelzpp": 364552000,
    "dropphyadd": "1550 CHIPPEWAY ST",
    "dropphycty": "LOCKHART",
    "dropphyst": "AL",
    "dropphyzpp": 364552000,
    "dropmaladd": "1550 CHIPPEWAY ST",
    "dropmalcty": "LOCKHART",
    "dropmalst": "AL",
    "dropmalzpp": 364559998,
    "dropsitphn": 3348586244,
    "dropsitlph": 3348586244,
    "dropsitcph": 3348586244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10724",
    "droptype": "D",
    "dropname": "LOCUST FORK",
    "dropdeladd": "20 PARK RD",
    "dropdelcty": "LOCUST FORK",
    "dropdelst": "AL",
    "dropdelzpp": 350975809,
    "dropphyadd": "20 PARK RD",
    "dropphycty": "LOCUST FORK",
    "dropphyst": "AL",
    "dropphyzpp": 350975809,
    "dropmaladd": "20 PARK RD",
    "dropmalcty": "LOCUST FORK",
    "dropmalst": "AL",
    "dropmalzpp": 350979998,
    "dropsitphn": 2056812506,
    "dropsitlph": 2056812506,
    "dropsitcph": 2056812506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10725",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "4475 COUNTY ROAD 831",
    "dropdelcty": "LOGAN",
    "dropdelst": "AL",
    "dropdelzpp": 350981552,
    "dropphyadd": "4475 COUNTY ROAD 831",
    "dropphycty": "LOGAN",
    "dropphyst": "AL",
    "dropphyzpp": 350981552,
    "dropmaladd": "4475 COUNTY ROAD 831",
    "dropmalcty": "LOGAN",
    "dropmalst": "AL",
    "dropmalzpp": 350989998,
    "dropsitphn": 2057476517,
    "dropsitlph": 2057476517,
    "dropsitcph": 2567476517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10727",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "1968 MAIN ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360489998,
    "dropphyadd": "1968 MAIN ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360489998,
    "dropmaladd": "1968 MAIN ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360489998,
    "dropsitphn": 3342665943,
    "dropsitlph": 3342665943,
    "dropsitcph": 3342665943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10731",
    "droptype": "D",
    "dropname": "LOWER PEACH TREE",
    "dropdeladd": "24 COUNTY ROAD 35 E",
    "dropdelcty": "LOWER PEACH TREE",
    "dropdelst": "AL",
    "dropdelzpp": 367519998,
    "dropphyadd": "24 COUNTY ROAD 35 E",
    "dropphycty": "LOWER PEACH TREE",
    "dropphyst": "AL",
    "dropphyzpp": 367519998,
    "dropmaladd": "24 COUNTY ROAD 35 E",
    "dropmalcty": "LOWER PEACH TREE",
    "dropmalst": "AL",
    "dropmalzpp": 367519998,
    "dropsitphn": 3346365342,
    "dropsitlph": 3346365342,
    "dropsitcph": 3346365342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10732",
    "droptype": "D",
    "dropname": "LOWNDESBORO",
    "dropdeladd": "1 N BROAD ST",
    "dropdelcty": "LOWNDESBORO",
    "dropdelst": "AL",
    "dropdelzpp": 367529998,
    "dropphyadd": "1 N BROAD ST",
    "dropphycty": "LOWNDESBORO",
    "dropphyst": "AL",
    "dropphyzpp": 367529998,
    "dropmaladd": "1 N BROAD ST",
    "dropmalcty": "LOWNDESBORO",
    "dropmalst": "AL",
    "dropmalzpp": 367529998,
    "dropsitphn": 3342784445,
    "dropsitlph": 3342784445,
    "dropsitcph": 3342784445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10733",
    "droptype": "D",
    "dropname": "LOXLEY",
    "dropdeladd": "1059 S HOLLEY ST",
    "dropdelcty": "LOXLEY",
    "dropdelst": "AL",
    "dropdelzpp": 365514567,
    "dropphyadd": "1059 S HOLLEY ST",
    "dropphycty": "LOXLEY",
    "dropphyst": "AL",
    "dropphyzpp": 365514567,
    "dropmaladd": "1059 S HOLLEY ST",
    "dropmalcty": "LOXLEY",
    "dropmalst": "AL",
    "dropmalzpp": 365519998,
    "dropsitphn": 2519647887,
    "dropsitlph": 2519647887,
    "dropsitcph": 2519647866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10734",
    "droptype": "D",
    "dropname": "LUVERNE",
    "dropdeladd": "29 E 3RD ST",
    "dropdelcty": "LUVERNE",
    "dropdelst": "AL",
    "dropdelzpp": 360499998,
    "dropphyadd": "29 E 3RD ST",
    "dropphycty": "LUVERNE",
    "dropphyst": "AL",
    "dropphyzpp": 360499998,
    "dropmaladd": "29 E 3RD ST",
    "dropmalcty": "LUVERNE",
    "dropmalst": "AL",
    "dropmalzpp": 360499998,
    "dropsitphn": 3343355393,
    "dropsitlph": 3343355393,
    "dropsitcph": 3343355393,
    "dropfax": 3343354814
  },
  {
    "dcode": "D",
    "dropkey": "PY10735",
    "droptype": "D",
    "dropname": "LYNN",
    "dropdeladd": "1303 W MAIN ST",
    "dropdelcty": "LYNN",
    "dropdelst": "AL",
    "dropdelzpp": 355752156,
    "dropphyadd": "1303 W MAIN ST",
    "dropphycty": "LYNN",
    "dropphyst": "AL",
    "dropphyzpp": 355752156,
    "dropmaladd": "1303 W MAIN ST",
    "dropmalcty": "LYNN",
    "dropmalst": "AL",
    "dropmalzpp": 355759998,
    "dropsitphn": 2058935853,
    "dropsitlph": 2058935853,
    "dropsitcph": 2058935853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10737",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "56 HUGHES RD",
    "dropdelcty": "MADISON",
    "dropdelst": "AL",
    "dropdelzpp": 357589998,
    "dropphyadd": "56 HUGHES RD",
    "dropphycty": "MADISON",
    "dropphyst": "AL",
    "dropphyzpp": 357589998,
    "dropmaladd": "56 HUGHES RD",
    "dropmalcty": "MADISON",
    "dropmalst": "AL",
    "dropmalzpp": 357589998,
    "dropsitphn": 2564640728,
    "dropsitlph": 2567727413,
    "dropsitcph": 2567727413,
    "dropfax": 2567725936
  },
  {
    "dcode": "D",
    "dropkey": "PY10740",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "5716 COUNTY ROAD 30",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "AL",
    "dropdelzpp": 367549998,
    "dropphyadd": "5716 COUNTY ROAD 30",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "AL",
    "dropphyzpp": 367549998,
    "dropmaladd": "5716 COUNTY ROAD 30",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "AL",
    "dropmalzpp": 367549998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3346273914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10741",
    "droptype": "D",
    "dropname": "MAGNOLIA SPRINGS",
    "dropdeladd": "14840 US HIGHWAY 98",
    "dropdelcty": "MAGNOLIA SPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 365552000,
    "dropphyadd": "14840 US HIGHWAY 98",
    "dropphycty": "MAGNOLIA SPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 365552000,
    "dropmaladd": "14840 US HIGHWAY 98",
    "dropmalcty": "MAGNOLIA SPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 365559998,
    "dropsitphn": 2519657520,
    "dropsitlph": 2519657520,
    "dropsitcph": 2519657520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10742",
    "droptype": "D",
    "dropname": "MALCOLM",
    "dropdeladd": "100 BATES LAKE RD",
    "dropdelcty": "MALCOLM",
    "dropdelst": "AL",
    "dropdelzpp": 365562000,
    "dropphyadd": "100 BATES LAKE RD",
    "dropphycty": "MALCOLM",
    "dropphyst": "AL",
    "dropphyzpp": 365562000,
    "dropmaladd": "100 BATES LAKE RD",
    "dropmalcty": "MALCOLM",
    "dropmalst": "AL",
    "dropmalzpp": 365569998,
    "dropsitphn": 2518299735,
    "dropsitlph": 2518299735,
    "dropsitcph": 2518299735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10747",
    "droptype": "D",
    "dropname": "MAPLESVILLE",
    "dropdeladd": "9370 AL HIGHWAY 22",
    "dropdelcty": "MAPLESVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 367509998,
    "dropphyadd": "9370 AL HIGHWAY 22",
    "dropphycty": "MAPLESVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 367509998,
    "dropmaladd": "9370 AL HIGHWAY 22",
    "dropmalcty": "MAPLESVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 367509998,
    "dropsitphn": 3343662526,
    "dropsitlph": 3343662526,
    "dropsitcph": 3343662526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10750",
    "droptype": "D",
    "dropname": "MARBURY",
    "dropdeladd": "3050 AL HIGHWAY 143",
    "dropdelcty": "MARBURY",
    "dropdelst": "AL",
    "dropdelzpp": 360519998,
    "dropphyadd": "3050 AL HIGHWAY 143",
    "dropphycty": "MARBURY",
    "dropphyst": "AL",
    "dropphyzpp": 360519998,
    "dropmaladd": "3050 AL HIGHWAY 143",
    "dropmalcty": "MARBURY",
    "dropmalst": "AL",
    "dropmalzpp": 360519998,
    "dropsitphn": 2052447515,
    "dropsitlph": 2052447515,
    "dropsitcph": 3342856800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10751",
    "droptype": "D",
    "dropname": "MARGARET",
    "dropdeladd": "25 POST OFFICE DR",
    "dropdelcty": "MARGARET",
    "dropdelst": "AL",
    "dropdelzpp": 351122000,
    "dropphyadd": "25 POST OFFICE DR",
    "dropphycty": "MARGARET",
    "dropphyst": "AL",
    "dropphyzpp": 351122000,
    "dropmaladd": "25 POST OFFICE DR",
    "dropmalcty": "MARGARET",
    "dropmalst": "AL",
    "dropmalzpp": 351129998,
    "dropsitphn": 2056295295,
    "dropsitlph": 2056295295,
    "dropsitcph": 2056295295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10752",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "306 PICKENS ST",
    "dropdelcty": "MARION",
    "dropdelst": "AL",
    "dropdelzpp": 367569998,
    "dropphyadd": "306 PICKENS ST",
    "dropphycty": "MARION",
    "dropphyst": "AL",
    "dropphyzpp": 367569998,
    "dropmaladd": "306 PICKENS ST",
    "dropmalcty": "MARION",
    "dropmalst": "AL",
    "dropmalzpp": 367569998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3346836610,
    "dropsitcph": 3346836610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10754",
    "droptype": "D",
    "dropname": "MARION JUNCTION",
    "dropdeladd": "35 CHURCH ST",
    "dropdelcty": "MARION JUNCTION",
    "dropdelst": "AL",
    "dropdelzpp": 367599998,
    "dropphyadd": "35 CHURCH ST",
    "dropphycty": "MARION JUNCTION",
    "dropphyst": "AL",
    "dropphyzpp": 367599998,
    "dropmaladd": "35 CHURCH ST",
    "dropmalcty": "MARION JUNCTION",
    "dropmalst": "AL",
    "dropmalzpp": 367599998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3348729909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10764",
    "droptype": "D",
    "dropname": "MAYLENE",
    "dropdeladd": "10011 HIGHWAY 17",
    "dropdelcty": "ALABASTER",
    "dropdelst": "AL",
    "dropdelzpp": 351145900,
    "dropphyadd": "10011 HIGHWAY 17",
    "dropphycty": "ALABASTER",
    "dropphyst": "AL",
    "dropphyzpp": 351145900,
    "dropmaladd": "10011 HIGHWAY 17",
    "dropmalcty": "ALABASTER",
    "dropmalst": "AL",
    "dropmalzpp": 351149998,
    "dropsitphn": 2056202850,
    "dropsitlph": 2056202850,
    "dropsitcph": 2056202850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10766",
    "droptype": "D",
    "dropname": "MC CALLA",
    "dropdeladd": "6301 OLD TUSCALOOSA HWY",
    "dropdelcty": "MC CALLA",
    "dropdelst": "AL",
    "dropdelzpp": 351113600,
    "dropphyadd": "6301 OLD TUSCALOOSA HWY",
    "dropphycty": "MC CALLA",
    "dropphyst": "AL",
    "dropphyzpp": 351113600,
    "dropmaladd": "6301 OLD TUSCALOOSA HWY",
    "dropmalcty": "MC CALLA",
    "dropmalst": "AL",
    "dropmalzpp": 351119998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2054776435,
    "dropsitcph": 2054770719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10767",
    "droptype": "D",
    "dropname": "MC INTOSH",
    "dropdeladd": "7595 HIGHWAY 43",
    "dropdelcty": "MC INTOSH",
    "dropdelst": "AL",
    "dropdelzpp": 365536600,
    "dropphyadd": "7595 HIGHWAY 43",
    "dropphycty": "MC INTOSH",
    "dropphyst": "AL",
    "dropphyzpp": 365536600,
    "dropmaladd": "7595 HIGHWAY 43",
    "dropmalcty": "MC INTOSH",
    "dropmalst": "AL",
    "dropmalzpp": 365539998,
    "dropsitphn": 2519442667,
    "dropsitlph": 2519442667,
    "dropsitcph": 2519442667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10768",
    "droptype": "D",
    "dropname": "MC KENZIE",
    "dropdeladd": "83 N GARLAND RD",
    "dropdelcty": "MC KENZIE",
    "dropdelst": "AL",
    "dropdelzpp": 364569998,
    "dropphyadd": "83 N GARLAND RD",
    "dropphycty": "MC KENZIE",
    "dropphyst": "AL",
    "dropphyzpp": 364569998,
    "dropmaladd": "83 N GARLAND RD",
    "dropmalcty": "MC KENZIE",
    "dropmalst": "AL",
    "dropmalzpp": 364569998,
    "dropsitphn": 3343748166,
    "dropsitlph": 3343748166,
    "dropsitcph": 3343748166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10769",
    "droptype": "D",
    "dropname": "MC SHAN",
    "dropdeladd": "15 N COLUMBUS ST",
    "dropdelcty": "MC SHAN",
    "dropdelst": "AL",
    "dropdelzpp": 354712000,
    "dropphyadd": "15 N COLUMBUS ST",
    "dropphycty": "MC SHAN",
    "dropphyst": "AL",
    "dropphyzpp": 354712000,
    "dropmaladd": "15 N COLUMBUS ST",
    "dropmalcty": "MC SHAN",
    "dropmalst": "AL",
    "dropmalzpp": 354719998,
    "dropsitphn": 2053752824,
    "dropsitlph": 2053752824,
    "dropsitcph": 2053752824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10783",
    "droptype": "D",
    "dropname": "MENTONE",
    "dropdeladd": "5809 AL HIGHWAY 117",
    "dropdelcty": "MENTONE",
    "dropdelst": "AL",
    "dropdelzpp": 359843134,
    "dropphyadd": "5809 AL HIGHWAY 117",
    "dropphycty": "MENTONE",
    "dropphyst": "AL",
    "dropphyzpp": 359843134,
    "dropmaladd": "5809 AL HIGHWAY 117",
    "dropmalcty": "MENTONE",
    "dropmalst": "AL",
    "dropmalzpp": 359849998,
    "dropsitphn": 2566344588,
    "dropsitlph": 2566344588,
    "dropsitcph": 2566344588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10785",
    "droptype": "D",
    "dropname": "MERIDIANVILLE",
    "dropdeladd": "11639 HIGHWAY 231 431 N",
    "dropdelcty": "MERIDIANVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 357592119,
    "dropphyadd": "11639 HIGHWAY 231 431 N",
    "dropphycty": "MERIDIANVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 357592119,
    "dropmaladd": "11639 HIGHWAY 231 431 N",
    "dropmalcty": "MERIDIANVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 357599998,
    "dropsitphn": 2568280647,
    "dropsitlph": 2568280647,
    "dropsitcph": 2568280647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10788",
    "droptype": "D",
    "dropname": "MEXIA",
    "dropdeladd": "4891 HIGHWAY 47 S",
    "dropdelcty": "MEXIA",
    "dropdelst": "AL",
    "dropdelzpp": 364582000,
    "dropphyadd": "4891 HIGHWAY 47 S",
    "dropphycty": "MEXIA",
    "dropphyst": "AL",
    "dropphyzpp": 364582000,
    "dropmaladd": "4891 HIGHWAY 47 S",
    "dropmalcty": "MEXIA",
    "dropmalst": "AL",
    "dropmalzpp": 364589998,
    "dropsitphn": 2515752909,
    "dropsitlph": 2515752909,
    "dropsitcph": 2515752909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10790",
    "droptype": "D",
    "dropname": "MIDLAND CITY",
    "dropdeladd": "167 KELLY AVE",
    "dropdelcty": "MIDLAND CITY",
    "dropdelst": "AL",
    "dropdelzpp": 363503000,
    "dropphyadd": "167 KELLY AVE",
    "dropphycty": "MIDLAND CITY",
    "dropphyst": "AL",
    "dropphyzpp": 363503000,
    "dropmaladd": "167 KELLY AVE",
    "dropmalcty": "MIDLAND CITY",
    "dropmalst": "AL",
    "dropmalzpp": 363509998,
    "dropsitphn": 3349833698,
    "dropsitlph": 3349833698,
    "dropsitcph": 3349833698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10792",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "32848 HIGHWAY 82",
    "dropdelcty": "MIDWAY",
    "dropdelst": "AL",
    "dropdelzpp": 360535618,
    "dropphyadd": "32848 HIGHWAY 82",
    "dropphycty": "MIDWAY",
    "dropphyst": "AL",
    "dropphyzpp": 360535618,
    "dropmaladd": "32848 HIGHWAY 82",
    "dropmalcty": "MIDWAY",
    "dropmalst": "AL",
    "dropmalzpp": 360535618,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345293627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10795",
    "droptype": "D",
    "dropname": "MILLBROOK",
    "dropdeladd": "4431 MAIN ST",
    "dropdelcty": "MILLBROOK",
    "dropdelst": "AL",
    "dropdelzpp": 360549998,
    "dropphyadd": "4431 MAIN ST",
    "dropphycty": "MILLBROOK",
    "dropphyst": "AL",
    "dropphyzpp": 360542860,
    "dropmaladd": "4431 MAIN ST",
    "dropmalcty": "MILLBROOK",
    "dropmalst": "AL",
    "dropmalzpp": 360549998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342851812,
    "dropsitcph": 3342900476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10801",
    "droptype": "D",
    "dropname": "MILLPORT",
    "dropdeladd": "115 WOOD DR",
    "dropdelcty": "MILLPORT",
    "dropdelst": "AL",
    "dropdelzpp": 355762646,
    "dropphyadd": "115 WOOD DR",
    "dropphycty": "MILLPORT",
    "dropphyst": "AL",
    "dropphyzpp": 355762646,
    "dropmaladd": "115 WOOD DR",
    "dropmalcty": "MILLPORT",
    "dropmalst": "AL",
    "dropmalzpp": 355769998,
    "dropsitphn": 2056624760,
    "dropsitlph": 2056624760,
    "dropsitcph": 2056624760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10802",
    "droptype": "D",
    "dropname": "MILLRY",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "MILLRY",
    "dropdelst": "AL",
    "dropdelzpp": 365584527,
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "MILLRY",
    "dropphyst": "AL",
    "dropphyzpp": 365584527,
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "MILLRY",
    "dropmalst": "AL",
    "dropmalzpp": 365589998,
    "dropsitphn": 2518462210,
    "dropsitlph": 2518462210,
    "dropsitcph": 2512764089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10805",
    "droptype": "D",
    "dropname": "MINTER",
    "dropdeladd": "2560 COUNTY ROAD 4",
    "dropdelcty": "MINTER",
    "dropdelst": "AL",
    "dropdelzpp": 367619998,
    "dropphyadd": "2560 COUNTY ROAD 4",
    "dropphycty": "MINTER",
    "dropphyst": "AL",
    "dropphyzpp": 367619998,
    "dropmaladd": "2560 COUNTY ROAD 4",
    "dropmalcty": "MINTER",
    "dropmalst": "AL",
    "dropmalzpp": 367619998,
    "dropsitphn": 3348721155,
    "dropsitlph": 3348721155,
    "dropsitcph": 3348721155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10807",
    "droptype": "D",
    "dropname": "MOBILE",
    "dropdeladd": "250 SAINT JOSEPH ST",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366012001,
    "dropphyadd": "250 SAINT JOSEPH ST",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366012001,
    "dropmaladd": "250 SAINT JOSEPH ST",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366019998,
    "dropsitphn": 2516946106,
    "dropsitlph": 2516946106,
    "dropsitcph": 2516945969,
    "dropfax": 2516941761
  },
  {
    "dcode": "D",
    "dropkey": "PY10811",
    "droptype": "D",
    "dropname": "MONROEVILLE",
    "dropdeladd": "16 N ALABAMA AVE",
    "dropdelcty": "MONROEVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 364601819,
    "dropphyadd": "16 N ALABAMA AVE",
    "dropphycty": "MONROEVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 364601819,
    "dropmaladd": "16 N ALABAMA AVE",
    "dropmalcty": "MONROEVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 364609998,
    "dropsitphn": 2517433475,
    "dropsitlph": 2517433475,
    "dropsitcph": 2517433475,
    "dropfax": 2515754263
  },
  {
    "dcode": "D",
    "dropkey": "PY10812",
    "droptype": "D",
    "dropname": "MONTEVALLO",
    "dropdeladd": "720 VINE ST",
    "dropdelcty": "MONTEVALLO",
    "dropdelst": "AL",
    "dropdelzpp": 351153705,
    "dropphyadd": "720 VINE ST",
    "dropphycty": "MONTEVALLO",
    "dropphyst": "AL",
    "dropphyzpp": 351153705,
    "dropmaladd": "720 VINE ST",
    "dropmalcty": "MONTEVALLO",
    "dropmalst": "AL",
    "dropmalzpp": 351159998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2056651198,
    "dropsitcph": 2056654166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10815",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "6701 WINTON BLOUNT BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361192500,
    "dropphyadd": "6701 WINTON BLOUNT BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361192500,
    "dropmaladd": "6701 WINTON BLOUNT BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361192500,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342447683,
    "dropfax": 3342447600
  },
  {
    "dcode": "D",
    "dropkey": "PY10817",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "7325 SIBLEY ST",
    "dropdelcty": "MONTROSE",
    "dropdelst": "AL",
    "dropdelzpp": 365592000,
    "dropphyadd": "7325 SIBLEY ST",
    "dropphycty": "MONTROSE",
    "dropphyst": "AL",
    "dropphyzpp": 365592000,
    "dropmaladd": "7325 SIBLEY ST",
    "dropmalcty": "MONTROSE",
    "dropmalst": "AL",
    "dropmalzpp": 365599998,
    "dropsitphn": 2519285488,
    "dropsitlph": 2519285488,
    "dropsitcph": 2519285488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10818",
    "droptype": "D",
    "dropname": "MOODY",
    "dropdeladd": "2455 MOODY PKWY",
    "dropdelcty": "MOODY",
    "dropdelst": "AL",
    "dropdelzpp": 350041600,
    "dropphyadd": "2455 MOODY PKWY",
    "dropphycty": "MOODY",
    "dropphyst": "AL",
    "dropphyzpp": 350041600,
    "dropmaladd": "2455 MOODY PKWY",
    "dropmalcty": "MOODY",
    "dropmalst": "AL",
    "dropmalzpp": 350049998,
    "dropsitphn": 2056403684,
    "dropsitlph": 2056403684,
    "dropsitcph": 2056403684,
    "dropfax": 2056404999
  },
  {
    "dcode": "D",
    "dropkey": "PY10820",
    "droptype": "D",
    "dropname": "MOORESVILLE",
    "dropdeladd": "24995 LAUDERDALE ST",
    "dropdelcty": "MOORESVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356492000,
    "dropphyadd": "24995 LAUDERDALE ST",
    "dropphycty": "MOORESVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356492000,
    "dropmaladd": "24995 LAUDERDALE ST",
    "dropmalcty": "MOORESVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356499998,
    "dropsitphn": 2563081258,
    "dropsitlph": 2563081258,
    "dropsitcph": 2563081258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10824",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "8315 OLD HIGHWAY 31",
    "dropdelcty": "MORRIS",
    "dropdelst": "AL",
    "dropdelzpp": 351161230,
    "dropphyadd": "8315 OLD HIGHWAY 31",
    "dropphycty": "MORRIS",
    "dropphyst": "AL",
    "dropphyzpp": 351161230,
    "dropmaladd": "8315 OLD HIGHWAY 31",
    "dropmalcty": "MORRIS",
    "dropmalst": "AL",
    "dropmalzpp": 351169998,
    "dropsitphn": 2056476695,
    "dropsitlph": 2056476695,
    "dropsitcph": 2056476032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10828",
    "droptype": "D",
    "dropname": "MOULTON",
    "dropdeladd": "14645 COURT ST",
    "dropdelcty": "MOULTON",
    "dropdelst": "AL",
    "dropdelzpp": 356501203,
    "dropphyadd": "14645 COURT ST",
    "dropphycty": "MOULTON",
    "dropphyst": "AL",
    "dropphyzpp": 356501203,
    "dropmaladd": "14645 COURT ST",
    "dropmalcty": "MOULTON",
    "dropmalst": "AL",
    "dropmalzpp": 356509998,
    "dropsitphn": 2569746117,
    "dropsitlph": 2569746117,
    "dropsitcph": 2569746117,
    "dropfax": 2569749092
  },
  {
    "dcode": "D",
    "dropkey": "PY10829",
    "droptype": "D",
    "dropname": "MOUNDVILLE",
    "dropdeladd": "259 2ND AVE",
    "dropdelcty": "MOUNDVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 354743911,
    "dropphyadd": "259 2ND AVE",
    "dropphycty": "MOUNDVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 354743911,
    "dropmaladd": "259 2ND AVE",
    "dropmalcty": "MOUNDVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 354749998,
    "dropsitphn": 2053712288,
    "dropsitlph": 2053712288,
    "dropsitcph": 2053712288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10833",
    "droptype": "D",
    "dropname": "MOUNT HOPE",
    "dropdeladd": "7650 COUNTY ROAD 23",
    "dropdelcty": "MOUNT HOPE",
    "dropdelst": "AL",
    "dropdelzpp": 356519793,
    "dropphyadd": "7650 COUNTY ROAD 23",
    "dropphycty": "MOUNT HOPE",
    "dropphyst": "AL",
    "dropphyzpp": 356519793,
    "dropmaladd": "7650 COUNTY ROAD 23",
    "dropmalcty": "MOUNT HOPE",
    "dropmalst": "AL",
    "dropmalzpp": 356519998,
    "dropsitphn": 2569740182,
    "dropsitlph": 2569740182,
    "dropsitcph": 2569740182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10834",
    "droptype": "D",
    "dropname": "MOUNT MEIGS",
    "dropdeladd": "100 OLD PIKE RD",
    "dropdelcty": "MOUNT MEIGS",
    "dropdelst": "AL",
    "dropdelzpp": 360572500,
    "dropphyadd": "100 OLD PIKE RD",
    "dropphycty": "MOUNT MEIGS",
    "dropphyst": "AL",
    "dropphyzpp": 360572500,
    "dropmaladd": "100 OLD PIKE RD",
    "dropmalcty": "MOUNT MEIGS",
    "dropmalst": "AL",
    "dropmalzpp": 360572500,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342153619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10837",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "19175 OLD HIGHWAY 43",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "AL",
    "dropdelzpp": 365603413,
    "dropphyadd": "19175 OLD HIGHWAY 43",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "AL",
    "dropphyzpp": 365603413,
    "dropmaladd": "19175 OLD HIGHWAY 43",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "AL",
    "dropmalzpp": 365609998,
    "dropsitphn": 2518299203,
    "dropsitlph": 2518299203,
    "dropsitcph": 2518299203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10849",
    "droptype": "D",
    "dropname": "MULGA",
    "dropdeladd": "203 1ST AVE",
    "dropdelcty": "MULGA",
    "dropdelst": "AL",
    "dropdelzpp": 351189735,
    "dropphyadd": "203 1ST AVE",
    "dropphycty": "MULGA",
    "dropphyst": "AL",
    "dropphyzpp": 351189735,
    "dropmaladd": "203 1ST AVE",
    "dropmalcty": "MULGA",
    "dropmalst": "AL",
    "dropmalzpp": 351189998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2057870337,
    "dropsitcph": 2057870337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10850",
    "droptype": "D",
    "dropname": "MUNFORD",
    "dropdeladd": "33 CEDARS RD",
    "dropdelcty": "MUNFORD",
    "dropdelst": "AL",
    "dropdelzpp": 362687350,
    "dropphyadd": "33 CEDARS RD",
    "dropphycty": "MUNFORD",
    "dropphyst": "AL",
    "dropphyzpp": 362687350,
    "dropmaladd": "33 CEDARS RD",
    "dropmalcty": "MUNFORD",
    "dropmalst": "AL",
    "dropmalzpp": 362689998,
    "dropsitphn": 2563584231,
    "dropsitlph": 2563584231,
    "dropsitcph": 2563584231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10852",
    "droptype": "D",
    "dropname": "MUSCADINE",
    "dropdeladd": "37 COUNTY ROAD 267",
    "dropdelcty": "MUSCADINE",
    "dropdelst": "AL",
    "dropdelzpp": 362693446,
    "dropphyadd": "37 COUNTY ROAD 267",
    "dropphycty": "MUSCADINE",
    "dropphyst": "AL",
    "dropphyzpp": 362693446,
    "dropmaladd": "37 COUNTY ROAD 267",
    "dropmalcty": "MUSCADINE",
    "dropmalst": "AL",
    "dropmalzpp": 362699998,
    "dropsitphn": 2565792576,
    "dropsitlph": 2565792576,
    "dropsitcph": 2565792576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10855",
    "droptype": "D",
    "dropname": "MYRTLEWOOD",
    "dropdeladd": "103 E CEDAR ST",
    "dropdelcty": "MYRTLEWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 367639998,
    "dropphyadd": "103 E CEDAR ST",
    "dropphycty": "MYRTLEWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 367639998,
    "dropmaladd": "103 E CEDAR ST",
    "dropmalcty": "MYRTLEWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 367639998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342955949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10856",
    "droptype": "D",
    "dropname": "NANAFALIA",
    "dropdeladd": "39000 AL HIGHWAY 10",
    "dropdelcty": "NANAFALIA",
    "dropdelst": "AL",
    "dropdelzpp": 367649998,
    "dropphyadd": "39000 AL HIGHWAY 10",
    "dropphycty": "NANAFALIA",
    "dropphyst": "AL",
    "dropphyzpp": 367649998,
    "dropmaladd": "39000 AL HIGHWAY 10",
    "dropmalcty": "NANAFALIA",
    "dropmalst": "AL",
    "dropmalzpp": 367649998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347364473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10859",
    "droptype": "D",
    "dropname": "NATURAL BRIDGE",
    "dropdeladd": "16430 HIGHWAY 13",
    "dropdelcty": "NATURAL BRIDGE",
    "dropdelst": "AL",
    "dropdelzpp": 355779998,
    "dropphyadd": "16430 HIGHWAY 13",
    "dropphycty": "NATURAL BRIDGE",
    "dropphyst": "AL",
    "dropphyzpp": 355779998,
    "dropmaladd": "16430 HIGHWAY 13",
    "dropmalcty": "NATURAL BRIDGE",
    "dropmalst": "AL",
    "dropmalzpp": 355779998,
    "dropsitphn": 2054868101,
    "dropsitlph": 2054868101,
    "dropsitcph": 2054868101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10860",
    "droptype": "D",
    "dropname": "NAUVOO",
    "dropdeladd": "481 FOURTH ST",
    "dropdelcty": "NAUVOO",
    "dropdelst": "AL",
    "dropdelzpp": 355783630,
    "dropphyadd": "481 FOURTH ST",
    "dropphycty": "NAUVOO",
    "dropphyst": "AL",
    "dropphyzpp": 355783630,
    "dropmaladd": "481 FOURTH ST",
    "dropmalcty": "NAUVOO",
    "dropmalst": "AL",
    "dropmalzpp": 355789998,
    "dropsitphn": 2056975198,
    "dropsitlph": 2056975198,
    "dropsitcph": 2056975198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10862",
    "droptype": "D",
    "dropname": "NEEDHAM",
    "dropdeladd": "2460 NEEDHAM RD",
    "dropdelcty": "NEEDHAM",
    "dropdelst": "AL",
    "dropdelzpp": 369159998,
    "dropphyadd": "2460 NEEDHAM RD",
    "dropphycty": "NEEDHAM",
    "dropphyst": "AL",
    "dropphyzpp": 369159998,
    "dropmaladd": "2460 NEEDHAM RD",
    "dropmalcty": "NEEDHAM",
    "dropmalst": "AL",
    "dropmalzpp": 369159998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2056732369,
    "dropfax": 6013517510
  },
  {
    "dcode": "D",
    "dropkey": "PY10863",
    "droptype": "D",
    "dropname": "NEW BROCKTON",
    "dropdeladd": "311 S JOHN ST",
    "dropdelcty": "NEW BROCKTON",
    "dropdelst": "AL",
    "dropdelzpp": 363516595,
    "dropphyadd": "311 S JOHN ST",
    "dropphycty": "NEW BROCKTON",
    "dropphyst": "AL",
    "dropphyzpp": 363516595,
    "dropmaladd": "311 S JOHN ST",
    "dropmalcty": "NEW BROCKTON",
    "dropmalst": "AL",
    "dropmalzpp": 363519998,
    "dropsitphn": 3348946262,
    "dropsitlph": 3348926262,
    "dropsitcph": 3348946262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10864",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "4768 MULBERRY DR",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "AL",
    "dropdelzpp": 351192001,
    "dropphyadd": "4768 MULBERRY DR",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "AL",
    "dropphyzpp": 351192001,
    "dropmaladd": "4768 MULBERRY DR",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "AL",
    "dropmalzpp": 351199998,
    "dropsitphn": 2056319534,
    "dropsitlph": 2056319534,
    "dropsitcph": 2056319534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10866",
    "droptype": "D",
    "dropname": "NEW HOPE",
    "dropdeladd": "5464 MAIN DR",
    "dropdelcty": "NEW HOPE",
    "dropdelst": "AL",
    "dropdelzpp": 357608608,
    "dropphyadd": "5464 MAIN DR",
    "dropphycty": "NEW HOPE",
    "dropphyst": "AL",
    "dropphyzpp": 357608608,
    "dropmaladd": "5464 MAIN DR",
    "dropmalcty": "NEW HOPE",
    "dropmalst": "AL",
    "dropmalzpp": 357609998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2567233926,
    "dropsitcph": 2567233847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10867",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "5516 WINCHESTER RD",
    "dropdelcty": "NEW MARKET",
    "dropdelst": "AL",
    "dropdelzpp": 357619794,
    "dropphyadd": "5516 WINCHESTER RD",
    "dropphycty": "NEW MARKET",
    "dropphyst": "AL",
    "dropphyzpp": 357619794,
    "dropmaladd": "5516 WINCHESTER RD",
    "dropmalcty": "NEW MARKET",
    "dropmalst": "AL",
    "dropmalzpp": 357619998,
    "dropsitphn": 2563793553,
    "dropsitlph": 2563793553,
    "dropsitcph": 2563792997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10869",
    "droptype": "D",
    "dropname": "NEWBERN",
    "dropdeladd": "7790 AL HIGHWAY 61",
    "dropdelcty": "NEWBERN",
    "dropdelst": "AL",
    "dropdelzpp": 367659998,
    "dropphyadd": "7790 AL HIGHWAY 61",
    "dropphycty": "NEWBERN",
    "dropphyst": "AL",
    "dropphyzpp": 367659998,
    "dropmaladd": "7790 AL HIGHWAY 61",
    "dropmalcty": "NEWBERN",
    "dropmalst": "AL",
    "dropmalzpp": 367659998,
    "dropsitphn": 3346244147,
    "dropsitlph": 3346244147,
    "dropsitcph": 3346244147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10871",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "715 S COLLEGE ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "AL",
    "dropdelzpp": 363524094,
    "dropphyadd": "715 S COLLEGE ST",
    "dropphycty": "NEWTON",
    "dropphyst": "AL",
    "dropphyzpp": 363524094,
    "dropmaladd": "715 S COLLEGE ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "AL",
    "dropmalzpp": 363529998,
    "dropsitphn": 3342993514,
    "dropsitlph": 3342993514,
    "dropsitcph": 3342993514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10872",
    "droptype": "D",
    "dropname": "NEWVILLE",
    "dropdeladd": "182 N BROAD ST",
    "dropdelcty": "NEWVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 363534000,
    "dropphyadd": "182 N BROAD ST",
    "dropphycty": "NEWVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 363534000,
    "dropmaladd": "182 N BROAD ST",
    "dropmalcty": "NEWVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 363539998,
    "dropsitphn": 3348894211,
    "dropsitlph": 3348894211,
    "dropsitcph": 3348894211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10874",
    "droptype": "D",
    "dropname": "NORMAL",
    "dropdeladd": "100 DRAKE DR",
    "dropdelcty": "NORMAL",
    "dropdelst": "AL",
    "dropdelzpp": 357622000,
    "dropphyadd": "100 DRAKE DR",
    "dropphycty": "NORMAL",
    "dropphyst": "AL",
    "dropphyzpp": 357622000,
    "dropmaladd": "100 DRAKE DR",
    "dropmalcty": "NORMAL",
    "dropmalst": "AL",
    "dropmalzpp": 357629998,
    "dropsitphn": 2568524000,
    "dropsitlph": 2568524000,
    "dropsitcph": 2568524000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10879",
    "droptype": "D",
    "dropname": "NORTHPORT",
    "dropdeladd": "4200 MCFARLAND BLVD",
    "dropdelcty": "NORTHPORT",
    "dropdelst": "AL",
    "dropdelzpp": 354762851,
    "dropphyadd": "4200 MCFARLAND BLVD",
    "dropphycty": "NORTHPORT",
    "dropphyst": "AL",
    "dropphyzpp": 354762851,
    "dropmaladd": "4200 MCFARLAND BLVD",
    "dropmalcty": "NORTHPORT",
    "dropmalst": "AL",
    "dropmalzpp": 354769998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2053339147,
    "dropsitcph": 2053398594,
    "dropfax": 2053390293
  },
  {
    "dcode": "D",
    "dropkey": "PY10881",
    "droptype": "D",
    "dropname": "NOTASULGA",
    "dropdeladd": "241 LYON ST",
    "dropdelcty": "NOTASULGA",
    "dropdelst": "AL",
    "dropdelzpp": 368669998,
    "dropphyadd": "241 LYON ST",
    "dropphycty": "NOTASULGA",
    "dropphyst": "AL",
    "dropphyzpp": 368669998,
    "dropmaladd": "241 LYON ST",
    "dropmalcty": "NOTASULGA",
    "dropmalst": "AL",
    "dropmalzpp": 368669998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342573939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10883",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "10525 HIGHWAY 10 E",
    "dropdelcty": "OAK HILL",
    "dropdelst": "AL",
    "dropdelzpp": 367669998,
    "dropphyadd": "10525 HIGHWAY 10 E",
    "dropphycty": "OAK HILL",
    "dropphyst": "AL",
    "dropphyzpp": 367669998,
    "dropmaladd": "10525 HIGHWAY 10 E",
    "dropmalcty": "OAK HILL",
    "dropmalst": "AL",
    "dropmalzpp": 367669998,
    "dropsitphn": 2517462289,
    "dropsitlph": 2517462289,
    "dropsitcph": 2517462289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10886",
    "droptype": "D",
    "dropname": "OAKMAN",
    "dropdeladd": "8359 MARKET ST",
    "dropdelcty": "OAKMAN",
    "dropdelst": "AL",
    "dropdelzpp": 355793001,
    "dropphyadd": "8359 MARKET ST",
    "dropphycty": "OAKMAN",
    "dropphyst": "AL",
    "dropphyzpp": 355793001,
    "dropmaladd": "8359 MARKET ST",
    "dropmalcty": "OAKMAN",
    "dropmalst": "AL",
    "dropmalzpp": 355799998,
    "dropsitphn": 2056223895,
    "dropsitlph": 2056223895,
    "dropsitcph": 2056221004,
    "dropfax": 2056221002
  },
  {
    "dcode": "D",
    "dropkey": "PY10889",
    "droptype": "D",
    "dropname": "ODENVILLE",
    "dropdeladd": "17 BURGESS DR",
    "dropdelcty": "ODENVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 351204102,
    "dropphyadd": "17 BURGESS DR",
    "dropphycty": "ODENVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 351204102,
    "dropmaladd": "17 BURGESS DR",
    "dropmalcty": "ODENVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 351209998,
    "dropsitphn": 2056295333,
    "dropsitlph": 2056295333,
    "dropsitcph": 2056290261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10891",
    "droptype": "D",
    "dropname": "OHATCHEE",
    "dropdeladd": "7847 AL HIGHWAY 77",
    "dropdelcty": "OHATCHEE",
    "dropdelst": "AL",
    "dropdelzpp": 362717858,
    "dropphyadd": "7847 AL HIGHWAY 77",
    "dropphycty": "OHATCHEE",
    "dropphyst": "AL",
    "dropphyzpp": 362717858,
    "dropmaladd": "7847 AL HIGHWAY 77",
    "dropmalcty": "OHATCHEE",
    "dropmalst": "AL",
    "dropmalzpp": 362719998,
    "dropsitphn": 2568920861,
    "dropsitlph": 2568920861,
    "dropsitcph": 2568920861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10892",
    "droptype": "D",
    "dropname": "ONEONTA",
    "dropdeladd": "333 7TH ST N",
    "dropdelcty": "ONEONTA",
    "dropdelst": "AL",
    "dropdelzpp": 351211572,
    "dropphyadd": "333 7TH ST N",
    "dropphycty": "ONEONTA",
    "dropphyst": "AL",
    "dropphyzpp": 351211572,
    "dropmaladd": "333 7TH ST N",
    "dropmalcty": "ONEONTA",
    "dropmalst": "AL",
    "dropmalzpp": 351219998,
    "dropsitphn": 2052742284,
    "dropsitlph": 2052742284,
    "dropsitcph": 2052742284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10893",
    "droptype": "D",
    "dropname": "OPELIKA",
    "dropdeladd": "500 S 7TH ST",
    "dropdelcty": "OPELIKA",
    "dropdelst": "AL",
    "dropdelzpp": 368019998,
    "dropphyadd": "500 S 7TH ST",
    "dropphycty": "OPELIKA",
    "dropphyst": "AL",
    "dropphyzpp": 368019998,
    "dropmaladd": "500 S 7TH ST",
    "dropmalcty": "OPELIKA",
    "dropmalst": "AL",
    "dropmalzpp": 368019998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3347453561,
    "dropsitcph": 3347453561,
    "dropfax": 3347040244
  },
  {
    "dcode": "D",
    "dropkey": "PY10894",
    "droptype": "D",
    "dropname": "OPP",
    "dropdeladd": "710 OLD PERRY STORE RD",
    "dropdelcty": "OPP",
    "dropdelst": "AL",
    "dropdelzpp": 364672300,
    "dropphyadd": "710 OLD PERRY STORE RD",
    "dropphycty": "OPP",
    "dropphyst": "AL",
    "dropphyzpp": 364672300,
    "dropmaladd": "710 OLD PERRY STORE RD",
    "dropmalcty": "OPP",
    "dropmalst": "AL",
    "dropmalzpp": 364679998,
    "dropsitphn": 3344934028,
    "dropsitlph": 3344934028,
    "dropsitcph": 3344934028,
    "dropfax": 3344934141
  },
  {
    "dcode": "D",
    "dropkey": "PY10895",
    "droptype": "D",
    "dropname": "ORANGE BEACH",
    "dropdeladd": "25778 JOHN M SNOOK DR",
    "dropdelcty": "ORANGE BEACH",
    "dropdelst": "AL",
    "dropdelzpp": 365613457,
    "dropphyadd": "25778 JOHN M SNOOK DR",
    "dropphycty": "ORANGE BEACH",
    "dropphyst": "AL",
    "dropphyzpp": 365613457,
    "dropmaladd": "25778 JOHN M SNOOK DR",
    "dropmalcty": "ORANGE BEACH",
    "dropmalst": "AL",
    "dropmalzpp": 365619998,
    "dropsitphn": 2519815510,
    "dropsitlph": 2519815510,
    "dropsitcph": 2519815510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10896",
    "droptype": "D",
    "dropname": "ORRVILLE",
    "dropdeladd": "14664 MAIN ST",
    "dropdelcty": "ORRVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 367679998,
    "dropphyadd": "14664 MAIN ST",
    "dropphycty": "ORRVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 367679998,
    "dropmaladd": "14664 MAIN ST",
    "dropmalcty": "ORRVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 367679998,
    "dropsitphn": 3349968592,
    "dropsitlph": 3349968592,
    "dropsitcph": 3342678082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10902",
    "droptype": "D",
    "dropname": "OWENS CROSS ROADS",
    "dropdeladd": "8396 HIGHWAY 431 S",
    "dropdelcty": "OWENS CROSS ROADS",
    "dropdelst": "AL",
    "dropdelzpp": 357638911,
    "dropphyadd": "8396 HIGHWAY 431 S",
    "dropphycty": "OWENS CROSS ROADS",
    "dropphyst": "AL",
    "dropphyzpp": 357638911,
    "dropmaladd": "8396 HIGHWAY 431 S",
    "dropmalcty": "OWENS CROSS ROADS",
    "dropmalst": "AL",
    "dropmalzpp": 357639998,
    "dropsitphn": 2567257964,
    "dropsitlph": 2567257964,
    "dropsitcph": 2567257845,
    "dropfax": 2567257390
  },
  {
    "dcode": "D",
    "dropkey": "PY10910",
    "droptype": "D",
    "dropname": "OZARK",
    "dropdeladd": "537 ANDREWS AVE",
    "dropdelcty": "OZARK",
    "dropdelst": "AL",
    "dropdelzpp": 363601765,
    "dropphyadd": "537 ANDREWS AVE",
    "dropphycty": "OZARK",
    "dropphyst": "AL",
    "dropphyzpp": 363601765,
    "dropmaladd": "537 ANDREWS AVE",
    "dropmalcty": "OZARK",
    "dropmalst": "AL",
    "dropmalzpp": 363609998,
    "dropsitphn": 3347745200,
    "dropsitlph": 3347745200,
    "dropsitcph": 3347745200,
    "dropfax": 3344450316
  },
  {
    "dcode": "D",
    "dropkey": "PY10911",
    "droptype": "D",
    "dropname": "PAINT ROCK",
    "dropdeladd": "3227 US HIGHWAY 72",
    "dropdelcty": "PAINT ROCK",
    "dropdelst": "AL",
    "dropdelzpp": 357646427,
    "dropphyadd": "3227 US HIGHWAY 72",
    "dropphycty": "PAINT ROCK",
    "dropphyst": "AL",
    "dropphyzpp": 357646427,
    "dropmaladd": "3227 US HIGHWAY 72",
    "dropmalcty": "PAINT ROCK",
    "dropmalst": "AL",
    "dropmalzpp": 357649998,
    "dropsitphn": 2567763946,
    "dropsitlph": 2567763946,
    "dropsitcph": 2567763946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10912",
    "droptype": "D",
    "dropname": "PALMERDALE",
    "dropdeladd": "8079 HIGHWAY 75",
    "dropdelcty": "PALMERDALE",
    "dropdelst": "AL",
    "dropdelzpp": 351232001,
    "dropphyadd": "8079 HIGHWAY 75",
    "dropphycty": "PALMERDALE",
    "dropphyst": "AL",
    "dropphyzpp": 351232001,
    "dropmaladd": "8079 HIGHWAY 75",
    "dropmalcty": "PALMERDALE",
    "dropmalst": "AL",
    "dropmalzpp": 351239998,
    "dropsitphn": 2056817181,
    "dropsitlph": 2056817181,
    "dropsitcph": 2056817181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10913",
    "droptype": "D",
    "dropname": "PANOLA",
    "dropdeladd": "1630 PANOLA PARKWAY 34",
    "dropdelcty": "PANOLA",
    "dropdelst": "AL",
    "dropdelzpp": 354772000,
    "dropphyadd": "1630 PANOLA PARKWAY 34",
    "dropphycty": "PANOLA",
    "dropphyst": "AL",
    "dropphyzpp": 354772000,
    "dropmaladd": "1630 PANOLA PARKWAY 34",
    "dropmalcty": "PANOLA",
    "dropmalst": "AL",
    "dropmalzpp": 354779998,
    "dropsitphn": 2054552261,
    "dropsitlph": 2054552261,
    "dropsitcph": 2054552261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10914",
    "droptype": "D",
    "dropname": "PANSEY",
    "dropdeladd": "14021 E US 84",
    "dropdelcty": "PANSEY",
    "dropdelst": "AL",
    "dropdelzpp": 363704054,
    "dropphyadd": "14021 E US 84",
    "dropphycty": "PANSEY",
    "dropphyst": "AL",
    "dropphyzpp": 363704054,
    "dropmaladd": "14021 E US 84",
    "dropmalcty": "PANSEY",
    "dropmalst": "AL",
    "dropmalzpp": 363709998,
    "dropsitphn": 3348995549,
    "dropsitlph": 3348995549,
    "dropsitcph": 3348995549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10918",
    "droptype": "D",
    "dropname": "PARRISH",
    "dropdeladd": "5911 HIGHWAY 269",
    "dropdelcty": "PARRISH",
    "dropdelst": "AL",
    "dropdelzpp": 355803847,
    "dropphyadd": "5911 HIGHWAY 269",
    "dropphycty": "PARRISH",
    "dropphyst": "AL",
    "dropphyzpp": 355803847,
    "dropmaladd": "5911 HIGHWAY 269",
    "dropmalcty": "PARRISH",
    "dropmalst": "AL",
    "dropmalzpp": 355809998,
    "dropsitphn": 2056867875,
    "dropsitlph": 2056867875,
    "dropsitcph": 2056867875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10922",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "2960 PELHAM PKWY",
    "dropdelcty": "PELHAM",
    "dropdelst": "AL",
    "dropdelzpp": 351241709,
    "dropphyadd": "2960 PELHAM PKWY",
    "dropphycty": "PELHAM",
    "dropphyst": "AL",
    "dropphyzpp": 351241709,
    "dropmaladd": "2960 PELHAM PKWY",
    "dropmalcty": "PELHAM",
    "dropmalst": "AL",
    "dropmalzpp": 351249998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2056638170,
    "dropsitcph": 2056638170,
    "dropfax": 2056635853
  },
  {
    "dcode": "D",
    "dropkey": "PY10923",
    "droptype": "D",
    "dropname": "PELL CITY",
    "dropdeladd": "1400 MARTIN ST S",
    "dropdelcty": "PELL CITY",
    "dropdelst": "AL",
    "dropdelzpp": 351282314,
    "dropphyadd": "1400 MARTIN ST S",
    "dropphycty": "PELL CITY",
    "dropphyst": "AL",
    "dropphyzpp": 351282314,
    "dropmaladd": "1400 MARTIN ST S",
    "dropmalcty": "PELL CITY",
    "dropmalst": "AL",
    "dropmalzpp": 351289998,
    "dropsitphn": 2058159854,
    "dropsitlph": 2058149854,
    "dropsitcph": 2058149854,
    "dropfax": 2053380274
  },
  {
    "dcode": "D",
    "dropkey": "PY10925",
    "droptype": "D",
    "dropname": "PENNINGTON",
    "dropdeladd": "5345 MAIN ST",
    "dropdelcty": "PENNINGTON",
    "dropdelst": "AL",
    "dropdelzpp": 369169998,
    "dropphyadd": "5345 MAIN ST",
    "dropphycty": "PENNINGTON",
    "dropphyst": "AL",
    "dropphyzpp": 369169998,
    "dropmaladd": "5345 MAIN ST",
    "dropmalcty": "PENNINGTON",
    "dropmalst": "AL",
    "dropmalzpp": 369169998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6592155198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10927",
    "droptype": "D",
    "dropname": "PERDIDO",
    "dropdeladd": "23336 COUNTY ROAD 47",
    "dropdelcty": "PERDIDO",
    "dropdelst": "AL",
    "dropdelzpp": 365623069,
    "dropphyadd": "23336 COUNTY ROAD 47",
    "dropphycty": "PERDIDO",
    "dropphyst": "AL",
    "dropphyzpp": 365623069,
    "dropmaladd": "23336 COUNTY ROAD 47",
    "dropmalcty": "PERDIDO",
    "dropmalst": "AL",
    "dropmalzpp": 365629998,
    "dropsitphn": 2519375928,
    "dropsitlph": 2519375928,
    "dropsitcph": 2519375928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10929",
    "droptype": "D",
    "dropname": "PERDUE HILL",
    "dropdeladd": "10111 US HIGHWAY 84 W",
    "dropdelcty": "PERDUE HILL",
    "dropdelst": "AL",
    "dropdelzpp": 364702000,
    "dropphyadd": "10111 US HIGHWAY 84 W",
    "dropphycty": "PERDUE HILL",
    "dropphyst": "AL",
    "dropphyzpp": 364702000,
    "dropmaladd": "10111 US HIGHWAY 84 W",
    "dropmalcty": "PERDUE HILL",
    "dropmalst": "AL",
    "dropmalzpp": 364709998,
    "dropsitphn": 2515757849,
    "dropsitlph": 2515757849,
    "dropsitcph": 2515757849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10931",
    "droptype": "D",
    "dropname": "PETERMAN",
    "dropdeladd": "885 OLD PETERMAN HWY",
    "dropdelcty": "PETERMAN",
    "dropdelst": "AL",
    "dropdelzpp": 364714114,
    "dropphyadd": "885 OLD PETERMAN HWY",
    "dropphycty": "PETERMAN",
    "dropphyst": "AL",
    "dropphyzpp": 364714114,
    "dropmaladd": "885 OLD PETERMAN HWY",
    "dropmalcty": "PETERMAN",
    "dropmalst": "AL",
    "dropmalzpp": 364719998,
    "dropsitphn": 2515642536,
    "dropsitlph": 2515642536,
    "dropsitcph": 2515642536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10932",
    "droptype": "D",
    "dropname": "PETERSON",
    "dropdeladd": "8910 OLD BIRMINGHAM HWY",
    "dropdelcty": "PETERSON",
    "dropdelst": "AL",
    "dropdelzpp": 354782000,
    "dropphyadd": "8910 OLD BIRMINGHAM HWY",
    "dropphycty": "PETERSON",
    "dropphyst": "AL",
    "dropphyzpp": 354782000,
    "dropmaladd": "8910 OLD BIRMINGHAM HWY",
    "dropmalcty": "PETERSON",
    "dropmalst": "AL",
    "dropmalzpp": 354789998,
    "dropsitphn": 2055538300,
    "dropsitlph": 2055538300,
    "dropsitcph": 2055538300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10935",
    "droptype": "D",
    "dropname": "PHENIX CITY",
    "dropdeladd": "1310 9TH AVE",
    "dropdelcty": "PHENIX CITY",
    "dropdelst": "AL",
    "dropdelzpp": 368679998,
    "dropphyadd": "1310 9TH AVE",
    "dropphycty": "PHENIX CITY",
    "dropphyst": "AL",
    "dropphyzpp": 368679998,
    "dropmaladd": "1310 9TH AVE",
    "dropmalcty": "PHENIX CITY",
    "dropmalst": "AL",
    "dropmalzpp": 368679998,
    "dropsitphn": 3342987871,
    "dropsitlph": 3342987871,
    "dropsitcph": 3342987871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10939",
    "droptype": "D",
    "dropname": "PHIL CAMPBELL",
    "dropdeladd": "3025 HIGHWAY 237",
    "dropdelcty": "PHIL CAMPBELL",
    "dropdelst": "AL",
    "dropdelzpp": 355813521,
    "dropphyadd": "3025 HIGHWAY 237",
    "dropphycty": "PHIL CAMPBELL",
    "dropphyst": "AL",
    "dropphyzpp": 355813521,
    "dropmaladd": "3025 HIGHWAY 237",
    "dropmalcty": "PHIL CAMPBELL",
    "dropmalst": "AL",
    "dropmalzpp": 355819998,
    "dropsitphn": 2059935777,
    "dropsitlph": 2059935777,
    "dropsitcph": 2059935777,
    "dropfax": 2059935293
  },
  {
    "dcode": "D",
    "dropkey": "PY10942",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "111 E LADIGA ST",
    "dropdelcty": "PIEDMONT",
    "dropdelst": "AL",
    "dropdelzpp": 362721735,
    "dropphyadd": "111 E LADIGA ST",
    "dropphycty": "PIEDMONT",
    "dropphyst": "AL",
    "dropphyzpp": 362721735,
    "dropmaladd": "111 E LADIGA ST",
    "dropmalcty": "PIEDMONT",
    "dropmalst": "AL",
    "dropmalzpp": 362729998,
    "dropsitphn": 2564479061,
    "dropsitlph": 2564479061,
    "dropsitcph": 2564479061,
    "dropfax": 2564472636
  },
  {
    "dcode": "D",
    "dropkey": "PY10944",
    "droptype": "D",
    "dropname": "PIKE ROAD",
    "dropdeladd": "1320 PIKE RD",
    "dropdelcty": "PIKE ROAD",
    "dropdelst": "AL",
    "dropdelzpp": 360649998,
    "dropphyadd": "1320 PIKE RD",
    "dropphycty": "PIKE ROAD",
    "dropphyst": "AL",
    "dropphyzpp": 360649998,
    "dropmaladd": "1320 PIKE RD",
    "dropmalcty": "PIKE ROAD",
    "dropmalst": "AL",
    "dropmalzpp": 360649998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342150098,
    "dropfax": 3342158785
  },
  {
    "dcode": "D",
    "dropkey": "PY10945",
    "droptype": "D",
    "dropname": "PINCKARD",
    "dropdeladd": "1313 HIGHWAY 134",
    "dropdelcty": "PINCKARD",
    "dropdelst": "AL",
    "dropdelzpp": 363712000,
    "dropphyadd": "1313 HIGHWAY 134",
    "dropphycty": "PINCKARD",
    "dropphyst": "AL",
    "dropphyzpp": 363712000,
    "dropmaladd": "1313 HIGHWAY 134",
    "dropmalcty": "PINCKARD",
    "dropmalst": "AL",
    "dropmalzpp": 363719998,
    "dropsitphn": 3349833754,
    "dropsitlph": 3349833754,
    "dropsitcph": 3349833754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10947",
    "droptype": "D",
    "dropname": "PINE APPLE",
    "dropdeladd": "52 COUNTY ROAD 59",
    "dropdelcty": "PINE APPLE",
    "dropdelst": "AL",
    "dropdelzpp": 367689998,
    "dropphyadd": "52 COUNTY ROAD 59",
    "dropphycty": "PINE APPLE",
    "dropphyst": "AL",
    "dropphyzpp": 367689998,
    "dropmaladd": "52 COUNTY ROAD 59",
    "dropmalcty": "PINE APPLE",
    "dropmalst": "AL",
    "dropmalzpp": 367689998,
    "dropsitphn": 2517462237,
    "dropsitlph": 2517462237,
    "dropsitcph": 2517462237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10949",
    "droptype": "D",
    "dropname": "PINE HILL",
    "dropdeladd": "61 OAK GROVE ST",
    "dropdelcty": "PINE HILL",
    "dropdelst": "AL",
    "dropdelzpp": 367699998,
    "dropphyadd": "61 OAK GROVE ST",
    "dropphycty": "PINE HILL",
    "dropphyst": "AL",
    "dropphyzpp": 367699998,
    "dropmaladd": "61 OAK GROVE ST",
    "dropmalcty": "PINE HILL",
    "dropmalst": "AL",
    "dropmalzpp": 367699998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3349634880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10951",
    "droptype": "D",
    "dropname": "PINE LEVEL",
    "dropdeladd": "685 PINE LEVEL LOOP",
    "dropdelcty": "PINE LEVEL",
    "dropdelst": "AL",
    "dropdelzpp": 360659998,
    "dropphyadd": "685 PINE LEVEL LOOP",
    "dropphycty": "PINE LEVEL",
    "dropphyst": "AL",
    "dropphyzpp": 360659998,
    "dropmaladd": "685 PINE LEVEL LOOP",
    "dropmalcty": "PINE LEVEL",
    "dropmalst": "AL",
    "dropmalzpp": 360659998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345847465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10953",
    "droptype": "D",
    "dropname": "PINSON",
    "dropdeladd": "6670 HIGHWAY 75",
    "dropdelcty": "PINSON",
    "dropdelst": "AL",
    "dropdelzpp": 351263222,
    "dropphyadd": "6670 HIGHWAY 75",
    "dropphycty": "PINSON",
    "dropphyst": "AL",
    "dropphyzpp": 351263222,
    "dropmaladd": "6670 HIGHWAY 75",
    "dropmalcty": "PINSON",
    "dropmalst": "AL",
    "dropmalzpp": 351269998,
    "dropsitphn": 2056818069,
    "dropsitlph": 2056818069,
    "dropsitcph": 2056818069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10954",
    "droptype": "D",
    "dropname": "PISGAH",
    "dropdeladd": "2324 COUNTY ROAD 58",
    "dropdelcty": "PISGAH",
    "dropdelst": "AL",
    "dropdelzpp": 357658253,
    "dropphyadd": "2324 COUNTY ROAD 58",
    "dropphycty": "PISGAH",
    "dropphyst": "AL",
    "dropphyzpp": 357658253,
    "dropmaladd": "2324 COUNTY ROAD 58",
    "dropmalcty": "PISGAH",
    "dropmalst": "AL",
    "dropmalzpp": 357659998,
    "dropsitphn": 2564513263,
    "dropsitlph": 2564513263,
    "dropsitcph": 2564513263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10955",
    "droptype": "D",
    "dropname": "PITTSVIEW",
    "dropdeladd": "85 LECONTE ST",
    "dropdelcty": "PITTSVIEW",
    "dropdelst": "AL",
    "dropdelzpp": 368719998,
    "dropphyadd": "85 LECONTE ST",
    "dropphycty": "PITTSVIEW",
    "dropphyst": "AL",
    "dropphyzpp": 368719998,
    "dropmaladd": "85 LECONTE ST",
    "dropmalcty": "PITTSVIEW",
    "dropmalst": "AL",
    "dropmalzpp": 368719998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3348553421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10957",
    "droptype": "D",
    "dropname": "PLANTERSVILLE",
    "dropdeladd": "236 CHERRY ST",
    "dropdelcty": "PLANTERSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 367589998,
    "dropphyadd": "236 CHERRY ST",
    "dropphycty": "PLANTERSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 367589998,
    "dropmaladd": "236 CHERRY ST",
    "dropmalcty": "PLANTERSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 367589998,
    "dropsitphn": 3343664469,
    "dropsitlph": 3343664469,
    "dropsitcph": 3343664469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10961",
    "droptype": "D",
    "dropname": "PLEASANT GROVE",
    "dropdeladd": "832 PARK RD",
    "dropdelcty": "PLEASANT GROVE",
    "dropdelst": "AL",
    "dropdelzpp": 351271677,
    "dropphyadd": "832 PARK RD",
    "dropphycty": "PLEASANT GROVE",
    "dropphyst": "AL",
    "dropphyzpp": 351271677,
    "dropmaladd": "832 PARK RD",
    "dropmalcty": "PLEASANT GROVE",
    "dropmalst": "AL",
    "dropmalzpp": 351279998,
    "dropsitphn": 2057445791,
    "dropsitlph": 2057445791,
    "dropsitcph": 2057440724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10964",
    "droptype": "D",
    "dropname": "POINT CLEAR",
    "dropdeladd": "6581 COUNTY ROAD 32",
    "dropdelcty": "POINT CLEAR",
    "dropdelst": "AL",
    "dropdelzpp": 365642000,
    "dropphyadd": "6581 COUNTY ROAD 32",
    "dropphycty": "POINT CLEAR",
    "dropphyst": "AL",
    "dropphyzpp": 365642000,
    "dropmaladd": "6581 COUNTY ROAD 32",
    "dropmalcty": "POINT CLEAR",
    "dropmalst": "AL",
    "dropmalzpp": 365649998,
    "dropsitphn": 2519906269,
    "dropsitlph": 2519906269,
    "dropsitcph": 2519906269,
    "dropfax": 2519900890
  },
  {
    "dcode": "D",
    "dropkey": "PY10975",
    "droptype": "D",
    "dropname": "PRATTVILLE",
    "dropdeladd": "502 GREYSTONE WAY",
    "dropdelcty": "PRATTVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 360669998,
    "dropphyadd": "502 GREYSTONE WAY",
    "dropphycty": "PRATTVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 360669998,
    "dropmaladd": "502 GREYSTONE WAY",
    "dropmalcty": "PRATTVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 360669998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3343610340,
    "dropsitcph": 3343657043,
    "dropfax": 3343617992
  },
  {
    "dcode": "D",
    "dropkey": "PY10980",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "14575 AL HIGHWAY 65",
    "dropdelcty": "PRINCETON",
    "dropdelst": "AL",
    "dropdelzpp": 357666637,
    "dropphyadd": "14575 AL HIGHWAY 65",
    "dropphycty": "PRINCETON",
    "dropphyst": "AL",
    "dropphyzpp": 357666637,
    "dropmaladd": "14575 AL HIGHWAY 65",
    "dropmalcty": "PRINCETON",
    "dropmalst": "AL",
    "dropmalzpp": 357669998,
    "dropsitphn": 2567764351,
    "dropsitlph": 2567764351,
    "dropsitcph": 2567764351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10986",
    "droptype": "D",
    "dropname": "QUINTON",
    "dropdeladd": "7515 QUINTON RD",
    "dropdelcty": "QUINTON",
    "dropdelst": "AL",
    "dropdelzpp": 351304329,
    "dropphyadd": "7515 QUINTON RD",
    "dropphycty": "QUINTON",
    "dropphyst": "AL",
    "dropphyzpp": 351304329,
    "dropmaladd": "7515 QUINTON RD",
    "dropmalcty": "QUINTON",
    "dropmalst": "AL",
    "dropmalzpp": 351309998,
    "dropsitphn": 2056489227,
    "dropsitlph": 2056489227,
    "dropsitcph": 2056489227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10987",
    "droptype": "D",
    "dropname": "RAGLAND",
    "dropdeladd": "81 KATHRYN ST",
    "dropdelcty": "RAGLAND",
    "dropdelst": "AL",
    "dropdelzpp": 351313039,
    "dropphyadd": "81 KATHRYN ST",
    "dropphycty": "RAGLAND",
    "dropphyst": "AL",
    "dropphyzpp": 351313039,
    "dropmaladd": "81 KATHRYN ST",
    "dropmalcty": "RAGLAND",
    "dropmalst": "AL",
    "dropmalzpp": 351319998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2054723630,
    "dropsitcph": 2054723630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10990",
    "droptype": "D",
    "dropname": "RAINSVILLE",
    "dropdeladd": "95 SAM ELLIS DR",
    "dropdelcty": "RAINSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 359866443,
    "dropphyadd": "95 SAM ELLIS DR",
    "dropphycty": "RAINSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 359866443,
    "dropmaladd": "95 SAM ELLIS DR",
    "dropmalcty": "RAINSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 359869998,
    "dropsitphn": 2566382575,
    "dropsitlph": 2566382575,
    "dropsitcph": 2566382575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10993",
    "droptype": "D",
    "dropname": "RALPH",
    "dropdeladd": "17127 RALPH LOOP RD",
    "dropdelcty": "RALPH",
    "dropdelst": "AL",
    "dropdelzpp": 354809700,
    "dropphyadd": "17127 RALPH LOOP RD",
    "dropphycty": "RALPH",
    "dropphyst": "AL",
    "dropphyzpp": 354809700,
    "dropmaladd": "17127 RALPH LOOP RD",
    "dropmalcty": "RALPH",
    "dropmalst": "AL",
    "dropmalzpp": 354809700,
    "dropsitphn": 2057529613,
    "dropsitlph": 2057529613,
    "dropsitcph": 2057529613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10994",
    "droptype": "D",
    "dropname": "RAMER",
    "dropdeladd": "169 MAIN ST",
    "dropdelcty": "RAMER",
    "dropdelst": "AL",
    "dropdelzpp": 360699998,
    "dropphyadd": "169 MAIN ST",
    "dropphycty": "RAMER",
    "dropphyst": "AL",
    "dropphyzpp": 360699998,
    "dropmaladd": "169 MAIN ST",
    "dropmalcty": "RAMER",
    "dropmalst": "AL",
    "dropmalzpp": 360699998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345629137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10995",
    "droptype": "D",
    "dropname": "RANBURNE",
    "dropdeladd": "21371 MAIN ST",
    "dropdelcty": "RANBURNE",
    "dropdelst": "AL",
    "dropdelzpp": 362734226,
    "dropphyadd": "21371 MAIN ST",
    "dropphycty": "RANBURNE",
    "dropphyst": "AL",
    "dropphyzpp": 362734226,
    "dropmaladd": "21371 MAIN ST",
    "dropmalcty": "RANBURNE",
    "dropmalst": "AL",
    "dropmalzpp": 362739998,
    "dropsitphn": 2565682289,
    "dropsitlph": 2565682289,
    "dropsitcph": 2565682289,
    "dropfax": 2565682582
  },
  {
    "dcode": "D",
    "dropkey": "PY10996",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "8770 HIGHWAY 139",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "AL",
    "dropdelzpp": 367929998,
    "dropphyadd": "8770 HIGHWAY 139",
    "dropphycty": "RANDOLPH",
    "dropphyst": "AL",
    "dropphyzpp": 367929998,
    "dropmaladd": "8770 HIGHWAY 139",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "AL",
    "dropmalzpp": 367929998,
    "dropsitphn": 3343664215,
    "dropsitlph": 3343664215,
    "dropsitcph": 3343664215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10998",
    "droptype": "D",
    "dropname": "RED BAY",
    "dropdeladd": "300 4TH AVE SW",
    "dropdelcty": "RED BAY",
    "dropdelst": "AL",
    "dropdelzpp": 355824063,
    "dropphyadd": "300 4TH AVE SW",
    "dropphycty": "RED BAY",
    "dropphyst": "AL",
    "dropphyzpp": 355824063,
    "dropmaladd": "300 4TH AVE SW",
    "dropmalcty": "RED BAY",
    "dropmalst": "AL",
    "dropmalzpp": 355829998,
    "dropsitphn": 2563564925,
    "dropsitlph": 2563564925,
    "dropsitcph": 2563564925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY10999",
    "droptype": "D",
    "dropname": "RED LEVEL",
    "dropdeladd": "28906 SMILEY ST",
    "dropdelcty": "RED LEVEL",
    "dropdelst": "AL",
    "dropdelzpp": 364742212,
    "dropphyadd": "28906 SMILEY ST",
    "dropphycty": "RED LEVEL",
    "dropphyst": "AL",
    "dropphyzpp": 364742212,
    "dropmaladd": "28906 SMILEY ST",
    "dropmalcty": "RED LEVEL",
    "dropmalst": "AL",
    "dropmalzpp": 364749998,
    "dropsitphn": 3344695342,
    "dropsitlph": 3344695342,
    "dropsitcph": 3344695342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11005",
    "droptype": "D",
    "dropname": "REFORM",
    "dropdeladd": "406 1ST AVE E",
    "dropdelcty": "REFORM",
    "dropdelst": "AL",
    "dropdelzpp": 354819779,
    "dropphyadd": "406 1ST AVE E",
    "dropphycty": "REFORM",
    "dropphyst": "AL",
    "dropphyzpp": 354819779,
    "dropmaladd": "406 1ST AVE E",
    "dropmalcty": "REFORM",
    "dropmalst": "AL",
    "dropmalzpp": 354819998,
    "dropsitphn": 2053756388,
    "dropsitlph": 2053756388,
    "dropsitcph": 2053756388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11008",
    "droptype": "D",
    "dropname": "REMLAP",
    "dropdeladd": "17198 REMLAP DR",
    "dropdelcty": "REMLAP",
    "dropdelst": "AL",
    "dropdelzpp": 351334246,
    "dropphyadd": "17198 REMLAP DR",
    "dropphycty": "REMLAP",
    "dropphyst": "AL",
    "dropphyzpp": 351334246,
    "dropmaladd": "17198 REMLAP DR",
    "dropmalcty": "REMLAP",
    "dropmalst": "AL",
    "dropmalzpp": 351339998,
    "dropsitphn": 2056810242,
    "dropsitlph": 2056810242,
    "dropsitcph": 2056810242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11009",
    "droptype": "D",
    "dropname": "REPTON",
    "dropdeladd": "1801 CONALY ST",
    "dropdelcty": "REPTON",
    "dropdelst": "AL",
    "dropdelzpp": 364753000,
    "dropphyadd": "1801 CONALY ST",
    "dropphycty": "REPTON",
    "dropphyst": "AL",
    "dropphyzpp": 364753000,
    "dropmaladd": "1801 CONALY ST",
    "dropmalcty": "REPTON",
    "dropmalst": "AL",
    "dropmalzpp": 364759998,
    "dropsitphn": 2512610625,
    "dropsitlph": 2512610625,
    "dropsitcph": 2512610625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11014",
    "droptype": "D",
    "dropname": "RIVER FALLS",
    "dropdeladd": "24805 COVINGTON ST",
    "dropdelcty": "RIVER FALLS",
    "dropdelst": "AL",
    "dropdelzpp": 364762000,
    "dropphyadd": "24805 COVINGTON ST",
    "dropphycty": "RIVER FALLS",
    "dropphyst": "AL",
    "dropphyzpp": 364762000,
    "dropmaladd": "24805 COVINGTON ST",
    "dropmalcty": "RIVER FALLS",
    "dropmalst": "AL",
    "dropmalzpp": 364769998,
    "dropsitphn": 3342221359,
    "dropsitlph": 3342221359,
    "dropsitcph": 3342221359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11018",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "50 COLEMAN AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "AL",
    "dropdelzpp": 351351434,
    "dropphyadd": "50 COLEMAN AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "AL",
    "dropphyzpp": 351351434,
    "dropmaladd": "50 COLEMAN AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "AL",
    "dropmalzpp": 351359998,
    "dropsitphn": 2053389319,
    "dropsitlph": 2053389319,
    "dropsitcph": 2053389319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11021",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "3078 HIGHWAY 431",
    "dropdelcty": "ROANOKE",
    "dropdelst": "AL",
    "dropdelzpp": 362741737,
    "dropphyadd": "3078 HIGHWAY 431",
    "dropphycty": "ROANOKE",
    "dropphyst": "AL",
    "dropphyzpp": 362741737,
    "dropmaladd": "3078 HIGHWAY 431",
    "dropmalcty": "ROANOKE",
    "dropmalst": "AL",
    "dropmalzpp": 362749998,
    "dropsitphn": 3348632515,
    "dropsitlph": 3348632515,
    "dropsitcph": 3348632515,
    "dropfax": 3348638999
  },
  {
    "dcode": "D",
    "dropkey": "PY11023",
    "droptype": "D",
    "dropname": "ROBERTSDALE",
    "dropdeladd": "18145 US HIGHWAY 90",
    "dropdelcty": "ROBERTSDALE",
    "dropdelst": "AL",
    "dropdelzpp": 365673241,
    "dropphyadd": "18145 US HIGHWAY 90",
    "dropphycty": "ROBERTSDALE",
    "dropphyst": "AL",
    "dropphyzpp": 365673241,
    "dropmaladd": "18145 US HIGHWAY 90",
    "dropmalcty": "ROBERTSDALE",
    "dropmalst": "AL",
    "dropmalzpp": 365679998,
    "dropsitphn": 2519475574,
    "dropsitlph": 2519475574,
    "dropsitcph": 2519475574,
    "dropfax": 2519474715
  },
  {
    "dcode": "D",
    "dropkey": "PY11026",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "329 JACKSON ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "AL",
    "dropdelzpp": 351369998,
    "dropphyadd": "329 JACKSON ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "AL",
    "dropphyzpp": 351369998,
    "dropmaladd": "329 JACKSON ST",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "AL",
    "dropmalzpp": 351369998,
    "dropsitphn": 2563774698,
    "dropsitlph": 2563774698,
    "dropsitcph": 2563774698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11031",
    "droptype": "D",
    "dropname": "ROGERSVILLE",
    "dropdeladd": "15801 HIGHWAY 72",
    "dropdelcty": "ROGERSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356527923,
    "dropphyadd": "15801 HIGHWAY 72",
    "dropphycty": "ROGERSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356527923,
    "dropmaladd": "15801 HIGHWAY 72",
    "dropmalcty": "ROGERSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356529998,
    "dropsitphn": 2562475385,
    "dropsitlph": 2562475385,
    "dropsitcph": 2562475385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11041",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "301 JACKSON AVE N",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356532344,
    "dropphyadd": "301 JACKSON AVE N",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356532344,
    "dropmaladd": "301 JACKSON AVE N",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356539998,
    "dropsitphn": 2563322165,
    "dropsitlph": 2563322165,
    "dropsitcph": 2563322165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11044",
    "droptype": "D",
    "dropname": "RUTLEDGE",
    "dropdeladd": "1606 LEE ST",
    "dropdelcty": "RUTLEDGE",
    "dropdelst": "AL",
    "dropdelzpp": 360719998,
    "dropphyadd": "1606 LEE ST",
    "dropphycty": "RUTLEDGE",
    "dropphyst": "AL",
    "dropphyzpp": 360719998,
    "dropmaladd": "1606 LEE ST",
    "dropmalcty": "RUTLEDGE",
    "dropmalst": "AL",
    "dropmalzpp": 360719998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3343355633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11045",
    "droptype": "D",
    "dropname": "RYLAND",
    "dropdeladd": "370 RYLAND PIKE",
    "dropdelcty": "RYLAND",
    "dropdelst": "AL",
    "dropdelzpp": 357672000,
    "dropphyadd": "370 RYLAND PIKE",
    "dropphycty": "RYLAND",
    "dropphyst": "AL",
    "dropphyzpp": 357672000,
    "dropmaladd": "370 RYLAND PIKE",
    "dropmalcty": "RYLAND",
    "dropmalst": "AL",
    "dropmalzpp": 357679998,
    "dropsitphn": 2568523505,
    "dropsitlph": 2568523505,
    "dropsitcph": 2568523505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11048",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "858 HIGHWAY 31",
    "dropdelcty": "SAGINAW",
    "dropdelst": "AL",
    "dropdelzpp": 351372000,
    "dropphyadd": "858 HIGHWAY 31",
    "dropphycty": "SAGINAW",
    "dropphyst": "AL",
    "dropphyzpp": 351372000,
    "dropmaladd": "858 HIGHWAY 31",
    "dropmalcty": "SAGINAW",
    "dropmalst": "AL",
    "dropmalzpp": 351379998,
    "dropsitphn": 2056635754,
    "dropsitlph": 2056635754,
    "dropsitcph": 2056635754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11049",
    "droptype": "D",
    "dropname": "SAINT ELMO",
    "dropdeladd": "8900 HIGHWAY 90 W",
    "dropdelcty": "SAINT ELMO",
    "dropdelst": "AL",
    "dropdelzpp": 365682000,
    "dropphyadd": "8900 HIGHWAY 90 W",
    "dropphycty": "SAINT ELMO",
    "dropphyst": "AL",
    "dropphyzpp": 365682000,
    "dropmaladd": "8900 HIGHWAY 90 W",
    "dropmalcty": "SAINT ELMO",
    "dropmalst": "AL",
    "dropmalzpp": 365689998,
    "dropsitphn": 2059576367,
    "dropsitlph": 2059576367,
    "dropsitcph": 2519576367,
    "dropfax": 2519572957
  },
  {
    "dcode": "D",
    "dropkey": "PY11050",
    "droptype": "D",
    "dropname": "SAINT STEPHENS",
    "dropdeladd": "19250 COUNTY ROAD 34",
    "dropdelcty": "SAINT STEPHENS",
    "dropdelst": "AL",
    "dropdelzpp": 365696500,
    "dropphyadd": "19250 COUNTY ROAD 34",
    "dropphycty": "SAINT STEPHENS",
    "dropphyst": "AL",
    "dropphyzpp": 365696500,
    "dropmaladd": "19250 COUNTY ROAD 34",
    "dropmalcty": "SAINT STEPHENS",
    "dropmalst": "AL",
    "dropmalzpp": 365699998,
    "dropsitphn": 2052463075,
    "dropsitlph": 2052463075,
    "dropsitcph": 2512463075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11051",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "5153 LEE ROAD 145",
    "dropdelcty": "SALEM",
    "dropdelst": "AL",
    "dropdelzpp": 368749998,
    "dropphyadd": "5153 LEE ROAD 145",
    "dropphycty": "SALEM",
    "dropphyst": "AL",
    "dropphyzpp": 368749998,
    "dropmaladd": "5153 LEE ROAD 145",
    "dropmalcty": "SALEM",
    "dropmalst": "AL",
    "dropmalzpp": 368749998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347498252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11053",
    "droptype": "D",
    "dropname": "SAMANTHA",
    "dropdeladd": "12855 NORTHSIDE RD",
    "dropdelcty": "SAMANTHA",
    "dropdelst": "AL",
    "dropdelzpp": 354822000,
    "dropphyadd": "12855 NORTHSIDE RD",
    "dropphycty": "SAMANTHA",
    "dropphyst": "AL",
    "dropphyzpp": 354822000,
    "dropmaladd": "12855 NORTHSIDE RD",
    "dropmalcty": "SAMANTHA",
    "dropmalst": "AL",
    "dropmalzpp": 354829998,
    "dropsitphn": 2053395239,
    "dropsitlph": 2053395236,
    "dropsitcph": 2053395236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11055",
    "droptype": "D",
    "dropname": "SAMSON",
    "dropdeladd": "33 S BROAD ST",
    "dropdelcty": "SAMSON",
    "dropdelst": "AL",
    "dropdelzpp": 364771301,
    "dropphyadd": "33 S BROAD ST",
    "dropphycty": "SAMSON",
    "dropphyst": "AL",
    "dropphyzpp": 364771301,
    "dropmaladd": "33 S BROAD ST",
    "dropmalcty": "SAMSON",
    "dropmalst": "AL",
    "dropmalzpp": 364779998,
    "dropsitphn": 3348982177,
    "dropsitlph": 3348982177,
    "dropsitcph": 3348982177,
    "dropfax": 3348982757
  },
  {
    "dcode": "D",
    "dropkey": "PY11059",
    "droptype": "D",
    "dropname": "SARALAND",
    "dropdeladd": "104 NORTON AVE",
    "dropdelcty": "SARALAND",
    "dropdelst": "AL",
    "dropdelzpp": 365712422,
    "dropphyadd": "104 NORTON AVE",
    "dropphycty": "SARALAND",
    "dropphyst": "AL",
    "dropphyzpp": 365712422,
    "dropmaladd": "104 NORTON AVE",
    "dropmalcty": "SARALAND",
    "dropmalst": "AL",
    "dropmalzpp": 365719998,
    "dropsitphn": 2516790393,
    "dropsitlph": 2516790393,
    "dropsitcph": 2516790393,
    "dropfax": 2516750376
  },
  {
    "dcode": "D",
    "dropkey": "PY11060",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "5880 AL HIGHWAY 41",
    "dropdelcty": "SARDIS",
    "dropdelst": "AL",
    "dropdelzpp": 367759998,
    "dropphyadd": "5880 AL HIGHWAY 41",
    "dropphycty": "SARDIS",
    "dropphyst": "AL",
    "dropphyzpp": 367759998,
    "dropmaladd": "5880 AL HIGHWAY 41",
    "dropmalcty": "SARDIS",
    "dropmalst": "AL",
    "dropmalzpp": 367759998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3348755621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11061",
    "droptype": "D",
    "dropname": "SATSUMA",
    "dropdeladd": "50 ORANGE AVE W",
    "dropdelcty": "SATSUMA",
    "dropdelst": "AL",
    "dropdelzpp": 365722314,
    "dropphyadd": "50 ORANGE AVE W",
    "dropphycty": "SATSUMA",
    "dropphyst": "AL",
    "dropphyzpp": 365722314,
    "dropmaladd": "50 ORANGE AVE W",
    "dropmalcty": "SATSUMA",
    "dropmalst": "AL",
    "dropmalzpp": 365729998,
    "dropsitphn": 2516799251,
    "dropsitlph": 2516799251,
    "dropsitcph": 2516799251,
    "dropfax": 2516756024
  },
  {
    "dcode": "D",
    "dropkey": "PY11062",
    "droptype": "D",
    "dropname": "SAWYERVILLE",
    "dropdeladd": "16850 AL HIGHWAY 14",
    "dropdelcty": "SAWYERVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 367769998,
    "dropphyadd": "16850 AL HIGHWAY 14",
    "dropphycty": "SAWYERVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 367769998,
    "dropmaladd": "16850 AL HIGHWAY 14",
    "dropmalcty": "SAWYERVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 367769998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3346248201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11067",
    "droptype": "D",
    "dropname": "SCOTTSBORO",
    "dropdeladd": "101 S MARKET ST",
    "dropdelcty": "SCOTTSBORO",
    "dropdelst": "AL",
    "dropdelzpp": 357681804,
    "dropphyadd": "101 S MARKET ST",
    "dropphycty": "SCOTTSBORO",
    "dropphyst": "AL",
    "dropphyzpp": 357681804,
    "dropmaladd": "101 S MARKET ST",
    "dropmalcty": "SCOTTSBORO",
    "dropmalst": "AL",
    "dropmalzpp": 357689998,
    "dropsitphn": 2562595706,
    "dropsitlph": 2562595706,
    "dropsitcph": 2562595706,
    "dropfax": 2565744645
  },
  {
    "dcode": "D",
    "dropkey": "PY11070",
    "droptype": "D",
    "dropname": "SEALE",
    "dropdeladd": "21 CUTCHIN DR",
    "dropdelcty": "SEALE",
    "dropdelst": "AL",
    "dropdelzpp": 368759998,
    "dropphyadd": "21 CUTCHIN DR",
    "dropphycty": "SEALE",
    "dropphyst": "AL",
    "dropphyzpp": 368759998,
    "dropmaladd": "21 CUTCHIN DR",
    "dropmalcty": "SEALE",
    "dropmalst": "AL",
    "dropmalzpp": 368759998,
    "dropsitphn": 3348553270,
    "dropsitlph": 3348553270,
    "dropsitcph": 3348553270,
    "dropfax": 3348559138
  },
  {
    "dcode": "D",
    "dropkey": "PY11072",
    "droptype": "D",
    "dropname": "SECTION",
    "dropdeladd": "52 DUTTON RD",
    "dropdelcty": "SECTION",
    "dropdelst": "AL",
    "dropdelzpp": 357717477,
    "dropphyadd": "52 DUTTON RD",
    "dropphycty": "SECTION",
    "dropphyst": "AL",
    "dropphyzpp": 357717477,
    "dropmaladd": "52 DUTTON RD",
    "dropmalcty": "SECTION",
    "dropmalst": "AL",
    "dropmalzpp": 357719998,
    "dropsitphn": 2562284266,
    "dropsitlph": 2562284266,
    "dropsitcph": 2562284266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11073",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "1301 ALABAMA AVE",
    "dropdelcty": "SELMA",
    "dropdelst": "AL",
    "dropdelzpp": 367039998,
    "dropphyadd": "1301 ALABAMA AVE",
    "dropphycty": "SELMA",
    "dropphyst": "AL",
    "dropphyzpp": 367039998,
    "dropmaladd": "1301 ALABAMA AVE",
    "dropmalcty": "SELMA",
    "dropmalst": "AL",
    "dropmalzpp": 367039998,
    "dropsitphn": 3348744678,
    "dropsitlph": 3348744678,
    "dropsitcph": 3348744678,
    "dropfax": 3348744502
  },
  {
    "dcode": "D",
    "dropkey": "PY11077",
    "droptype": "D",
    "dropname": "SEMMES",
    "dropdeladd": "9051 MOFFETT RD",
    "dropdelcty": "SEMMES",
    "dropdelst": "AL",
    "dropdelzpp": 365753700,
    "dropphyadd": "9051 MOFFETT RD",
    "dropphycty": "SEMMES",
    "dropphyst": "AL",
    "dropphyzpp": 365753700,
    "dropmaladd": "9051 MOFFETT RD",
    "dropmalcty": "SEMMES",
    "dropmalst": "AL",
    "dropmalzpp": 365759998,
    "dropsitphn": 2516452789,
    "dropsitlph": 2516452789,
    "dropsitcph": 2516452789,
    "dropfax": 2516498951
  },
  {
    "dcode": "D",
    "dropkey": "PY11083",
    "droptype": "D",
    "dropname": "SHANNON",
    "dropdeladd": "2101 SHANNON OXMOOR RD",
    "dropdelcty": "SHANNON",
    "dropdelst": "AL",
    "dropdelzpp": 351422000,
    "dropphyadd": "2101 SHANNON OXMOOR RD",
    "dropphycty": "SHANNON",
    "dropphyst": "AL",
    "dropphyzpp": 351422000,
    "dropmaladd": "2101 SHANNON OXMOOR RD",
    "dropmalcty": "SHANNON",
    "dropmalst": "AL",
    "dropmalzpp": 351429998,
    "dropsitphn": 2059426583,
    "dropsitlph": 2059426583,
    "dropsitcph": 2059426583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11085",
    "droptype": "D",
    "dropname": "SHEFFIELD",
    "dropdeladd": "210 N COLUMBIA AVE",
    "dropdelcty": "SHEFFIELD",
    "dropdelst": "AL",
    "dropdelzpp": 356603044,
    "dropphyadd": "210 N COLUMBIA AVE",
    "dropphycty": "SHEFFIELD",
    "dropphyst": "AL",
    "dropphyzpp": 356603044,
    "dropmaladd": "210 N COLUMBIA AVE",
    "dropmalcty": "SHEFFIELD",
    "dropmalst": "AL",
    "dropmalzpp": 356609998,
    "dropsitphn": 2563830252,
    "dropsitlph": 2563830252,
    "dropsitcph": 2563830252,
    "dropfax": 2563146927
  },
  {
    "dcode": "D",
    "dropkey": "PY11086",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "3788 HIGHWAY 47",
    "dropdelcty": "SHELBY",
    "dropdelst": "AL",
    "dropdelzpp": 351437150,
    "dropphyadd": "3788 HIGHWAY 47",
    "dropphycty": "SHELBY",
    "dropphyst": "AL",
    "dropphyzpp": 351437150,
    "dropmaladd": "3788 HIGHWAY 47",
    "dropmalcty": "SHELBY",
    "dropmalst": "AL",
    "dropmalzpp": 351439998,
    "dropsitphn": 2056700335,
    "dropsitlph": 2056700335,
    "dropsitcph": 2056700327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11089",
    "droptype": "D",
    "dropname": "SHORTER",
    "dropdeladd": "2557 OLD FEDERAL RD",
    "dropdelcty": "SHORTER",
    "dropdelst": "AL",
    "dropdelzpp": 360759998,
    "dropphyadd": "2557 OLD FEDERAL RD",
    "dropphycty": "SHORTER",
    "dropphyst": "AL",
    "dropphyzpp": 360759998,
    "dropmaladd": "2557 OLD FEDERAL RD",
    "dropmalcty": "SHORTER",
    "dropmalst": "AL",
    "dropmalzpp": 360759998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347277741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11090",
    "droptype": "D",
    "dropname": "SHORTERVILLE",
    "dropdeladd": "315 COUNTY ROAD 65",
    "dropdelcty": "SHORTERVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 363736203,
    "dropphyadd": "315 COUNTY ROAD 65",
    "dropphycty": "SHORTERVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 363736203,
    "dropmaladd": "315 COUNTY ROAD 65",
    "dropmalcty": "SHORTERVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 363739998,
    "dropsitphn": 3345853770,
    "dropsitlph": 3345853770,
    "dropsitcph": 3345853770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11092",
    "droptype": "D",
    "dropname": "SILAS",
    "dropdeladd": "15 2ND AVE",
    "dropdelcty": "SILAS",
    "dropdelst": "AL",
    "dropdelzpp": 369199998,
    "dropphyadd": "15 2ND AVE",
    "dropphycty": "SILAS",
    "dropphyst": "AL",
    "dropphyzpp": 369199998,
    "dropmaladd": "15 2ND AVE",
    "dropmalcty": "SILAS",
    "dropmalst": "AL",
    "dropmalzpp": 369199998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2515429463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11095",
    "droptype": "D",
    "dropname": "SILVERHILL",
    "dropdeladd": "21731 BROAD ST",
    "dropdelcty": "SILVERHILL",
    "dropdelst": "AL",
    "dropdelzpp": 365763803,
    "dropphyadd": "21731 BROAD ST",
    "dropphycty": "SILVERHILL",
    "dropphyst": "AL",
    "dropphyzpp": 365763803,
    "dropmaladd": "21731 BROAD ST",
    "dropmalcty": "SILVERHILL",
    "dropmalst": "AL",
    "dropmalzpp": 365769998,
    "dropsitphn": 2519455186,
    "dropsitlph": 2519455186,
    "dropsitcph": 2519455186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11097",
    "droptype": "D",
    "dropname": "SIPSEY",
    "dropdeladd": "4000 SIPSEY RD",
    "dropdelcty": "SIPSEY",
    "dropdelst": "AL",
    "dropdelzpp": 355842000,
    "dropphyadd": "4000 SIPSEY RD",
    "dropphycty": "SIPSEY",
    "dropphyst": "AL",
    "dropphyzpp": 355842000,
    "dropmaladd": "4000 SIPSEY RD",
    "dropmalcty": "SIPSEY",
    "dropmalst": "AL",
    "dropmalzpp": 355849998,
    "dropsitphn": 2056482813,
    "dropsitlph": 2056482813,
    "dropsitcph": 2056482813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11098",
    "droptype": "D",
    "dropname": "SKIPPERVILLE",
    "dropdeladd": "5093 HIGHWAY 105",
    "dropdelcty": "SKIPPERVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 363747715,
    "dropphyadd": "5093 HIGHWAY 105",
    "dropphycty": "SKIPPERVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 363747715,
    "dropmaladd": "5093 HIGHWAY 105",
    "dropmalcty": "SKIPPERVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 363749998,
    "dropsitphn": 3347743393,
    "dropsitlph": 3347743393,
    "dropsitcph": 3347743393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11101",
    "droptype": "D",
    "dropname": "SLOCOMB",
    "dropdeladd": "957 W LAWRENCE HARRIS HWY",
    "dropdelcty": "SLOCOMB",
    "dropdelst": "AL",
    "dropdelzpp": 363755301,
    "dropphyadd": "957 W LAWRENCE HARRIS HWY",
    "dropphycty": "SLOCOMB",
    "dropphyst": "AL",
    "dropphyzpp": 363759998,
    "dropmaladd": "957 W LAWRENCE HARRIS HWY",
    "dropmalcty": "SLOCOMB",
    "dropmalst": "AL",
    "dropmalzpp": 363759998,
    "dropsitphn": 3348862219,
    "dropsitlph": 3348862219,
    "dropsitcph": 3348862219,
    "dropfax": 3348869780
  },
  {
    "dcode": "D",
    "dropkey": "PY11102",
    "droptype": "D",
    "dropname": "SMITHS STATION",
    "dropdeladd": "2720 PANTHER PKWY",
    "dropdelcty": "SMITHS STATION",
    "dropdelst": "AL",
    "dropdelzpp": 368779998,
    "dropphyadd": "2720 PANTHER PKWY",
    "dropphycty": "SMITHS STATION",
    "dropphyst": "AL",
    "dropphyzpp": 368779998,
    "dropmaladd": "2720 PANTHER PKWY",
    "dropmalcty": "SMITHS STATION",
    "dropmalst": "AL",
    "dropmalzpp": 368779998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342977120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11108",
    "droptype": "D",
    "dropname": "SOMERVILLE",
    "dropdeladd": "3696 HIGHWAY 67 S",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 356704736,
    "dropphyadd": "3696 HIGHWAY 67 S",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 356704736,
    "dropmaladd": "3696 HIGHWAY 67 S",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 356709998,
    "dropsitphn": 2567787309,
    "dropsitlph": 2567787309,
    "dropsitcph": 2567787309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11123",
    "droptype": "D",
    "dropname": "SPRING GARDEN",
    "dropdeladd": "1325 COUNTY ROAD 29",
    "dropdelcty": "SPRING GARDEN",
    "dropdelst": "AL",
    "dropdelzpp": 362752000,
    "dropphyadd": "1325 COUNTY ROAD 29",
    "dropphycty": "SPRING GARDEN",
    "dropphyst": "AL",
    "dropphyzpp": 362752000,
    "dropmaladd": "1325 COUNTY ROAD 29",
    "dropmalcty": "SPRING GARDEN",
    "dropmalst": "AL",
    "dropmalzpp": 362759998,
    "dropsitphn": 2564477227,
    "dropsitlph": 2564477227,
    "dropsitcph": 2564477227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11127",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "5926 US HIGHWAY 11",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 351463242,
    "dropphyadd": "5926 US HIGHWAY 11",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 351463242,
    "dropmaladd": "5926 US HIGHWAY 11",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 351469998,
    "dropsitphn": 2054676780,
    "dropsitlph": 2054676780,
    "dropsitcph": 2054676780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11129",
    "droptype": "D",
    "dropname": "SPRUCE PINE",
    "dropdeladd": "9300 HIGHWAY 22",
    "dropdelcty": "SPRUCE PINE",
    "dropdelst": "AL",
    "dropdelzpp": 355854722,
    "dropphyadd": "9300 HIGHWAY 22",
    "dropphycty": "SPRUCE PINE",
    "dropphyst": "AL",
    "dropphyzpp": 355854722,
    "dropmaladd": "9300 HIGHWAY 22",
    "dropmalcty": "SPRUCE PINE",
    "dropmalst": "AL",
    "dropmalzpp": 355859998,
    "dropsitphn": 2563325170,
    "dropsitlph": 2563325170,
    "dropsitcph": 2563325170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11140",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "2230 COUNTY ROAD 45",
    "dropdelcty": "STANTON",
    "dropdelst": "AL",
    "dropdelzpp": 367909998,
    "dropphyadd": "2230 COUNTY ROAD 45",
    "dropphycty": "STANTON",
    "dropphyst": "AL",
    "dropphyzpp": 367909998,
    "dropmaladd": "2230 COUNTY ROAD 45",
    "dropmalcty": "STANTON",
    "dropmalst": "AL",
    "dropmalzpp": 367909998,
    "dropsitphn": 3343662661,
    "dropsitlph": 3343662661,
    "dropsitcph": 3343662661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11141",
    "droptype": "D",
    "dropname": "STAPLETON",
    "dropdeladd": "35387 STATE HIGHWAY 59",
    "dropdelcty": "STAPLETON",
    "dropdelst": "AL",
    "dropdelzpp": 365783003,
    "dropphyadd": "35387 STATE HIGHWAY 59",
    "dropphycty": "STAPLETON",
    "dropphyst": "AL",
    "dropphyzpp": 365783003,
    "dropmaladd": "35387 STATE HIGHWAY 59",
    "dropmalcty": "STAPLETON",
    "dropmalst": "AL",
    "dropmalzpp": 365789998,
    "dropsitphn": 2519378633,
    "dropsitlph": 2519378633,
    "dropsitcph": 2519378633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11145",
    "droptype": "D",
    "dropname": "STEELE",
    "dropdeladd": "3934 POPE AVE",
    "dropdelcty": "STEELE",
    "dropdelst": "AL",
    "dropdelzpp": 359872902,
    "dropphyadd": "3934 POPE AVE",
    "dropphycty": "STEELE",
    "dropphyst": "AL",
    "dropphyzpp": 359872902,
    "dropmaladd": "3934 POPE AVE",
    "dropmalcty": "STEELE",
    "dropmalst": "AL",
    "dropmalzpp": 359879998,
    "dropsitphn": 2565388493,
    "dropsitlph": 2565388493,
    "dropsitcph": 2565388493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11146",
    "droptype": "D",
    "dropname": "STERRETT",
    "dropdeladd": "49930 HIGHWAY 25",
    "dropdelcty": "STERRETT",
    "dropdelst": "AL",
    "dropdelzpp": 351478515,
    "dropphyadd": "49930 HIGHWAY 25",
    "dropphycty": "STERRETT",
    "dropphyst": "AL",
    "dropphyzpp": 351478515,
    "dropmaladd": "49930 HIGHWAY 25",
    "dropmalcty": "STERRETT",
    "dropmalst": "AL",
    "dropmalzpp": 351479998,
    "dropsitphn": 2056728708,
    "dropsitlph": 2056728708,
    "dropsitcph": 2056729105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11147",
    "droptype": "D",
    "dropname": "STEVENSON",
    "dropdeladd": "101 E 2ND ST",
    "dropdelcty": "STEVENSON",
    "dropdelst": "AL",
    "dropdelzpp": 357723003,
    "dropphyadd": "101 E 2ND ST",
    "dropphycty": "STEVENSON",
    "dropphyst": "AL",
    "dropphyzpp": 357723003,
    "dropmaladd": "101 E 2ND ST",
    "dropmalcty": "STEVENSON",
    "dropmalst": "AL",
    "dropmalzpp": 357729998,
    "dropsitphn": 2564372257,
    "dropsitlph": 2564372257,
    "dropsitcph": 2564372257,
    "dropfax": 2564370603
  },
  {
    "dcode": "D",
    "dropkey": "PY11149",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "52925 HODGSON RD",
    "dropdelcty": "STOCKTON",
    "dropdelst": "AL",
    "dropdelzpp": 365794031,
    "dropphyadd": "52925 HODGSON RD",
    "dropphycty": "STOCKTON",
    "dropphyst": "AL",
    "dropphyzpp": 365794031,
    "dropmaladd": "52925 HODGSON RD",
    "dropmalcty": "STOCKTON",
    "dropmalst": "AL",
    "dropmalzpp": 365799998,
    "dropsitphn": 2519379614,
    "dropsitlph": 2519379614,
    "dropsitcph": 2519379614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11153",
    "droptype": "D",
    "dropname": "SULLIGENT",
    "dropdeladd": "55144 HIGHWAY 17",
    "dropdelcty": "SULLIGENT",
    "dropdelst": "AL",
    "dropdelzpp": 355863825,
    "dropphyadd": "55144 HIGHWAY 17",
    "dropphycty": "SULLIGENT",
    "dropphyst": "AL",
    "dropphyzpp": 355863825,
    "dropmaladd": "55144 HIGHWAY 17",
    "dropmalcty": "SULLIGENT",
    "dropmalst": "AL",
    "dropmalzpp": 355869998,
    "dropsitphn": 2056989998,
    "dropsitlph": 2056989998,
    "dropsitcph": 2056989998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11154",
    "droptype": "D",
    "dropname": "SUMITON",
    "dropdeladd": "1675 MAIN ST",
    "dropdelcty": "SUMITON",
    "dropdelst": "AL",
    "dropdelzpp": 351483821,
    "dropphyadd": "1675 MAIN ST",
    "dropphycty": "SUMITON",
    "dropphyst": "AL",
    "dropphyzpp": 351483821,
    "dropmaladd": "1675 MAIN ST",
    "dropmalcty": "SUMITON",
    "dropmalst": "AL",
    "dropmalzpp": 351489998,
    "dropsitphn": 2056486651,
    "dropsitlph": 2056486651,
    "dropsitcph": 2056486651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11155",
    "droptype": "D",
    "dropname": "SUMMERDALE",
    "dropdeladd": "112 COUNTY ROAD 32 E",
    "dropdelcty": "SUMMERDALE",
    "dropdelst": "AL",
    "dropdelzpp": 365803706,
    "dropphyadd": "112 COUNTY ROAD 32 E",
    "dropphycty": "SUMMERDALE",
    "dropphyst": "AL",
    "dropphyzpp": 365803706,
    "dropmaladd": "112 COUNTY ROAD 32 E",
    "dropmalcty": "SUMMERDALE",
    "dropmalst": "AL",
    "dropmalzpp": 365809998,
    "dropsitphn": 2519892541,
    "dropsitlph": 2519892541,
    "dropsitcph": 2519892541,
    "dropfax": 2519892554
  },
  {
    "dcode": "D",
    "dropkey": "PY11159",
    "droptype": "D",
    "dropname": "SWEET WATER",
    "dropdeladd": "31600 HIGHWAY 10 W",
    "dropdelcty": "SWEET WATER",
    "dropdelst": "AL",
    "dropdelzpp": 367829998,
    "dropphyadd": "31600 HIGHWAY 10 W",
    "dropphycty": "SWEET WATER",
    "dropphyst": "AL",
    "dropphyzpp": 367829998,
    "dropmaladd": "31600 HIGHWAY 10 W",
    "dropmalcty": "SWEET WATER",
    "dropmalst": "AL",
    "dropmalzpp": 367829998,
    "dropsitphn": 3349944624,
    "dropsitlph": 3349944624,
    "dropsitcph": 3349944624,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11160",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "479 MAIN ST",
    "dropdelcty": "SYCAMORE",
    "dropdelst": "AL",
    "dropdelzpp": 351492000,
    "dropphyadd": "479 MAIN ST",
    "dropphycty": "SYCAMORE",
    "dropphyst": "AL",
    "dropphyzpp": 351492000,
    "dropmaladd": "479 MAIN ST",
    "dropmalcty": "SYCAMORE",
    "dropmalst": "AL",
    "dropmalzpp": 351499998,
    "dropsitphn": 2562452651,
    "dropsitlph": 2562452651,
    "dropsitcph": 2562452651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11161",
    "droptype": "D",
    "dropname": "SYLACAUGA",
    "dropdeladd": "1 S BROADWAY AVE",
    "dropdelcty": "SYLACAUGA",
    "dropdelst": "AL",
    "dropdelzpp": 351503051,
    "dropphyadd": "1 S BROADWAY AVE",
    "dropphycty": "SYLACAUGA",
    "dropphyst": "AL",
    "dropphyzpp": 351503051,
    "dropmaladd": "1 S BROADWAY AVE",
    "dropmalcty": "SYLACAUGA",
    "dropmalst": "AL",
    "dropmalzpp": 351509998,
    "dropsitphn": 2562454631,
    "dropsitlph": 2562454631,
    "dropsitcph": 2562454631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11163",
    "droptype": "D",
    "dropname": "SYLVANIA",
    "dropdeladd": "9596 BLUE POND BLVD W",
    "dropdelcty": "SYLVANIA",
    "dropdelst": "AL",
    "dropdelzpp": 359882212,
    "dropphyadd": "9596 BLUE POND BLVD W",
    "dropphycty": "SYLVANIA",
    "dropphyst": "AL",
    "dropphyzpp": 359882212,
    "dropmaladd": "9596 BLUE POND BLVD W",
    "dropmalcty": "SYLVANIA",
    "dropmalst": "AL",
    "dropmalzpp": 359889998,
    "dropsitphn": 2564068061,
    "dropsitlph": 2564068061,
    "dropsitcph": 2564068061,
    "dropfax": 2564068060
  },
  {
    "dcode": "D",
    "dropkey": "PY11164",
    "droptype": "D",
    "dropname": "TALLADEGA",
    "dropdeladd": "127 EAST ST N",
    "dropdelcty": "TALLADEGA",
    "dropdelst": "AL",
    "dropdelzpp": 351602065,
    "dropphyadd": "127 EAST ST N",
    "dropphycty": "TALLADEGA",
    "dropphyst": "AL",
    "dropphyzpp": 351602065,
    "dropmaladd": "127 EAST ST N",
    "dropmalcty": "TALLADEGA",
    "dropmalst": "AL",
    "dropmalzpp": 351609998,
    "dropsitphn": 2563628731,
    "dropsitlph": 2563628731,
    "dropsitcph": 2563628731,
    "dropfax": 2563625724
  },
  {
    "dcode": "D",
    "dropkey": "PY11166",
    "droptype": "D",
    "dropname": "TALLASSEE",
    "dropdeladd": "1204 GILMER AVE",
    "dropdelcty": "TALLASSEE",
    "dropdelst": "AL",
    "dropdelzpp": 360789998,
    "dropphyadd": "1204 GILMER AVE",
    "dropphycty": "TALLASSEE",
    "dropphyst": "AL",
    "dropphyzpp": 360789998,
    "dropmaladd": "1204 GILMER AVE",
    "dropmalcty": "TALLASSEE",
    "dropmalst": "AL",
    "dropmalzpp": 360789998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342832767,
    "dropsitcph": 3342832767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11167",
    "droptype": "D",
    "dropname": "TANNER",
    "dropdeladd": "20236 HUNTSVILLE BROWNSFERRY RD",
    "dropdelcty": "TANNER",
    "dropdelst": "AL",
    "dropdelzpp": 356713646,
    "dropphyadd": "20236 HUNTSVILLE BROWNSFERRY RD",
    "dropphycty": "TANNER",
    "dropphyst": "AL",
    "dropphyzpp": 356713646,
    "dropmaladd": "20236 HUNTSVILLE BROWNSFERRY RD",
    "dropmalcty": "TANNER",
    "dropmalst": "AL",
    "dropmalzpp": 356719998,
    "dropsitphn": 2562332750,
    "dropsitlph": 2562332750,
    "dropsitcph": 2562332750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11174",
    "droptype": "D",
    "dropname": "THEODORE",
    "dropdeladd": "5631 HIGHWAY 90",
    "dropdelcty": "THEODORE",
    "dropdelst": "AL",
    "dropdelzpp": 365829998,
    "dropphyadd": "5631 HIGHWAY 90",
    "dropphycty": "THEODORE",
    "dropphyst": "AL",
    "dropphyzpp": 365829998,
    "dropmaladd": "5631 HIGHWAY 90",
    "dropmalcty": "THEODORE",
    "dropmalst": "AL",
    "dropmalzpp": 365829998,
    "dropsitphn": 2516538718,
    "dropsitlph": 2516538718,
    "dropsitcph": 2516538718,
    "dropfax": 2516531912
  },
  {
    "dcode": "D",
    "dropkey": "PY11175",
    "droptype": "D",
    "dropname": "THOMASTON",
    "dropdeladd": "127 MAIN ST",
    "dropdelcty": "THOMASTON",
    "dropdelst": "AL",
    "dropdelzpp": 367839998,
    "dropphyadd": "127 MAIN ST",
    "dropphycty": "THOMASTON",
    "dropphyst": "AL",
    "dropphyzpp": 367839998,
    "dropmaladd": "127 MAIN ST",
    "dropmalcty": "THOMASTON",
    "dropmalst": "AL",
    "dropmalzpp": 367839998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3346273555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11176",
    "droptype": "D",
    "dropname": "THOMASVILLE",
    "dropdeladd": "115 NICOL AVE W",
    "dropdelcty": "THOMASVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 367849998,
    "dropphyadd": "115 NICOL AVE W",
    "dropphycty": "THOMASVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 367849998,
    "dropmaladd": "115 NICOL AVE W",
    "dropmalcty": "THOMASVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 367849998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3346362204,
    "dropfax": 3346361364
  },
  {
    "dcode": "D",
    "dropkey": "PY11179",
    "droptype": "D",
    "dropname": "THORSBY",
    "dropdeladd": "20650 US HIGHWAY 31",
    "dropdelcty": "THORSBY",
    "dropdelst": "AL",
    "dropdelzpp": 351717760,
    "dropphyadd": "20650 US HIGHWAY 31",
    "dropphycty": "THORSBY",
    "dropphyst": "AL",
    "dropphyzpp": 351717760,
    "dropmaladd": "20650 US HIGHWAY 31",
    "dropmalcty": "THORSBY",
    "dropmalst": "AL",
    "dropmalzpp": 351719998,
    "dropsitphn": 2056462703,
    "dropsitlph": 2056462703,
    "dropsitcph": 2056462703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11181",
    "droptype": "D",
    "dropname": "TIBBIE",
    "dropdeladd": "77 HAWTHORNE RD",
    "dropdelcty": "TIBBIE",
    "dropdelst": "AL",
    "dropdelzpp": 365835209,
    "dropphyadd": "77 HAWTHORNE RD",
    "dropphycty": "TIBBIE",
    "dropphyst": "AL",
    "dropphyzpp": 365835209,
    "dropmaladd": "77 HAWTHORNE RD",
    "dropmalcty": "TIBBIE",
    "dropmalst": "AL",
    "dropmalzpp": 365839998,
    "dropsitphn": 2518473397,
    "dropsitlph": 2518473397,
    "dropsitcph": 2518473397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11183",
    "droptype": "D",
    "dropname": "TITUS",
    "dropdeladd": "5999 TITUS RD",
    "dropdelcty": "TITUS",
    "dropdelst": "AL",
    "dropdelzpp": 360809998,
    "dropphyadd": "5999 TITUS RD",
    "dropphycty": "TITUS",
    "dropphyst": "AL",
    "dropphyzpp": 360809998,
    "dropmaladd": "5999 TITUS RD",
    "dropmalcty": "TITUS",
    "dropmalst": "AL",
    "dropmalzpp": 360809998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3345676864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11184",
    "droptype": "D",
    "dropname": "TONEY",
    "dropdeladd": "136 TONEY RD",
    "dropdelcty": "TONEY",
    "dropdelst": "AL",
    "dropdelzpp": 357739329,
    "dropphyadd": "136 TONEY RD",
    "dropphycty": "TONEY",
    "dropphyst": "AL",
    "dropphyzpp": 357739329,
    "dropmaladd": "136 TONEY RD",
    "dropmalcty": "TONEY",
    "dropmalst": "AL",
    "dropmalzpp": 357739998,
    "dropsitphn": 2568598338,
    "dropsitlph": 2568598338,
    "dropsitcph": 2568598338,
    "dropfax": 2568598338
  },
  {
    "dcode": "D",
    "dropkey": "PY11185",
    "droptype": "D",
    "dropname": "TOWN CREEK",
    "dropdeladd": "2746 AL HIGHWAY 20",
    "dropdelcty": "TOWN CREEK",
    "dropdelst": "AL",
    "dropdelzpp": 356723828,
    "dropphyadd": "2746 AL HIGHWAY 20",
    "dropphycty": "TOWN CREEK",
    "dropphyst": "AL",
    "dropphyzpp": 356723828,
    "dropmaladd": "2746 AL HIGHWAY 20",
    "dropmalcty": "TOWN CREEK",
    "dropmalst": "AL",
    "dropmalzpp": 356729998,
    "dropsitphn": 2566851008,
    "dropsitlph": 2566851008,
    "dropsitcph": 2566851008,
    "dropfax": 2566851004
  },
  {
    "dcode": "D",
    "dropkey": "PY11187",
    "droptype": "D",
    "dropname": "TOWNLEY",
    "dropdeladd": "82 MAIN ST",
    "dropdelcty": "TOWNLEY",
    "dropdelst": "AL",
    "dropdelzpp": 355873705,
    "dropphyadd": "82 MAIN ST",
    "dropphycty": "TOWNLEY",
    "dropphyst": "AL",
    "dropphyzpp": 355873705,
    "dropmaladd": "82 MAIN ST",
    "dropmalcty": "TOWNLEY",
    "dropmalst": "AL",
    "dropmalzpp": 355879998,
    "dropsitphn": 2059244152,
    "dropsitlph": 2059244152,
    "dropsitcph": 2059244152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11188",
    "droptype": "D",
    "dropname": "TOXEY",
    "dropdeladd": "2616 1ST ST",
    "dropdelcty": "TOXEY",
    "dropdelst": "AL",
    "dropdelzpp": 369219998,
    "dropphyadd": "2616 1ST ST",
    "dropphycty": "TOXEY",
    "dropphyst": "AL",
    "dropphyzpp": 369219998,
    "dropmaladd": "2616 1ST ST",
    "dropmalcty": "TOXEY",
    "dropmalst": "AL",
    "dropmalzpp": 369219998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2518611797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11192",
    "droptype": "D",
    "dropname": "TRINITY",
    "dropdeladd": "1290 OLD HIGHWAY 24",
    "dropdelcty": "TRINITY",
    "dropdelst": "AL",
    "dropdelzpp": 356736013,
    "dropphyadd": "1290 OLD HIGHWAY 24",
    "dropphycty": "TRINITY",
    "dropphyst": "AL",
    "dropphyzpp": 356736013,
    "dropmaladd": "1290 OLD HIGHWAY 24",
    "dropmalcty": "TRINITY",
    "dropmalst": "AL",
    "dropmalzpp": 356739998,
    "dropsitphn": 2563531565,
    "dropsitlph": 2563531565,
    "dropsitcph": 2563531565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11193",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "1300 S BRUNDIDGE ST",
    "dropdelcty": "TROY",
    "dropdelst": "AL",
    "dropdelzpp": 360819998,
    "dropphyadd": "1300 S BRUNDIDGE ST",
    "dropphycty": "TROY",
    "dropphyst": "AL",
    "dropphyzpp": 360819998,
    "dropmaladd": "1300 S BRUNDIDGE ST",
    "dropmalcty": "TROY",
    "dropmalst": "AL",
    "dropmalzpp": 360819998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3345664520,
    "dropsitcph": 3345664520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11195",
    "droptype": "D",
    "dropname": "TRUSSVILLE",
    "dropdeladd": "810 WATTERSON CURV",
    "dropdelcty": "TRUSSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 351734800,
    "dropphyadd": "810 WATTERSON CURV",
    "dropphycty": "TRUSSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 351734800,
    "dropmaladd": "810 WATTERSON CURV",
    "dropmalcty": "TRUSSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 351739998,
    "dropsitphn": 2056552186,
    "dropsitlph": 2056553512,
    "dropsitcph": 2056610373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11201",
    "droptype": "D",
    "dropname": "TUSCALOOSA",
    "dropdeladd": "1313 22ND AVE",
    "dropdelcty": "TUSCALOOSA",
    "dropdelst": "AL",
    "dropdelzpp": 354019998,
    "dropphyadd": "1313 22ND AVE",
    "dropphycty": "TUSCALOOSA",
    "dropphyst": "AL",
    "dropphyzpp": 354019998,
    "dropmaladd": "1313 22ND AVE",
    "dropmalcty": "TUSCALOOSA",
    "dropmalst": "AL",
    "dropmalzpp": 354019998,
    "dropsitphn": 2053446080,
    "dropsitlph": 2053446080,
    "dropsitcph": 2053446080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11202",
    "droptype": "D",
    "dropname": "TUSCUMBIA",
    "dropdeladd": "599 HIGHWAY 72 W",
    "dropdelcty": "TUSCUMBIA",
    "dropdelst": "AL",
    "dropdelzpp": 356744438,
    "dropphyadd": "599 HIGHWAY 72 W",
    "dropphycty": "TUSCUMBIA",
    "dropphyst": "AL",
    "dropphyzpp": 356744438,
    "dropmaladd": "599 HIGHWAY 72 W",
    "dropmalcty": "TUSCUMBIA",
    "dropmalst": "AL",
    "dropmalzpp": 356749998,
    "dropsitphn": 2563834420,
    "dropsitlph": 2563834420,
    "dropsitcph": 2563834420,
    "dropfax": 2563140217
  },
  {
    "dcode": "D",
    "dropkey": "PY11203",
    "droptype": "D",
    "dropname": "TUSKEGEE",
    "dropdeladd": "401 N ELM ST",
    "dropdelcty": "TUSKEGEE",
    "dropdelst": "AL",
    "dropdelzpp": 360839998,
    "dropphyadd": "401 N ELM ST",
    "dropphycty": "TUSKEGEE",
    "dropphyst": "AL",
    "dropphyzpp": 360839998,
    "dropmaladd": "401 N ELM ST",
    "dropmalcty": "TUSKEGEE",
    "dropmalst": "AL",
    "dropmalzpp": 360839998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3347272880,
    "dropsitcph": 3347272880,
    "dropfax": 3347275466
  },
  {
    "dcode": "D",
    "dropkey": "PY11205",
    "droptype": "D",
    "dropname": "TUSKEGEE INSTITUTE",
    "dropdeladd": "1702 W MONTGOMERY RD",
    "dropdelcty": "TUSKEGEE INSTITUTE",
    "dropdelst": "AL",
    "dropdelzpp": 360879998,
    "dropphyadd": "1702 W MONTGOMERY RD",
    "dropphycty": "TUSKEGEE INSTITUTE",
    "dropphyst": "AL",
    "dropphyzpp": 360879998,
    "dropmaladd": "1702 W MONTGOMERY RD",
    "dropmalcty": "TUSKEGEE INSTITUTE",
    "dropmalst": "AL",
    "dropmalzpp": 360879998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3347273320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11207",
    "droptype": "D",
    "dropname": "TYLER",
    "dropdeladd": "2021 COUNTY ROAD 7",
    "dropdelcty": "TYLER",
    "dropdelst": "AL",
    "dropdelzpp": 367859998,
    "dropphyadd": "2021 COUNTY ROAD 7",
    "dropphycty": "TYLER",
    "dropphyst": "AL",
    "dropphyzpp": 367859998,
    "dropmaladd": "2021 COUNTY ROAD 7",
    "dropmalcty": "TYLER",
    "dropmalst": "AL",
    "dropmalzpp": 367859998,
    "dropsitphn": 3348743873,
    "dropsitlph": 3348743873,
    "dropsitcph": 3348743873,
    "dropfax": 3348742688
  },
  {
    "dcode": "D",
    "dropkey": "PY11211",
    "droptype": "D",
    "dropname": "UNION GROVE",
    "dropdeladd": "3935 UNION GROVE RD",
    "dropdelcty": "UNION GROVE",
    "dropdelst": "AL",
    "dropdelzpp": 351758472,
    "dropphyadd": "3935 UNION GROVE RD",
    "dropphycty": "UNION GROVE",
    "dropphyst": "AL",
    "dropphyzpp": 351758472,
    "dropmaladd": "3935 UNION GROVE RD",
    "dropmalcty": "UNION GROVE",
    "dropmalst": "AL",
    "dropmalzpp": 351759998,
    "dropsitphn": 2567536200,
    "dropsitlph": 2567536200,
    "dropsitcph": 2567536200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11214",
    "droptype": "D",
    "dropname": "UNION SPRINGS",
    "dropdeladd": "108 HARDAWAY AVE E",
    "dropdelcty": "UNION SPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 360899998,
    "dropphyadd": "108 HARDAWAY AVE E",
    "dropphycty": "UNION SPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 360899998,
    "dropmaladd": "108 HARDAWAY AVE E",
    "dropmalcty": "UNION SPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 360899998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3347382665,
    "dropsitcph": 3347382665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11215",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "100 W FRANKLIN ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "AL",
    "dropdelzpp": 367869998,
    "dropphyadd": "100 W FRANKLIN ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "AL",
    "dropphyzpp": 367869998,
    "dropmaladd": "100 W FRANKLIN ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "AL",
    "dropmalzpp": 367869998,
    "dropsitphn": 3346286241,
    "dropsitlph": 3346286241,
    "dropsitcph": 3342922170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11223",
    "droptype": "D",
    "dropname": "URIAH",
    "dropdeladd": "77 CEMETERY ST",
    "dropdelcty": "URIAH",
    "dropdelst": "AL",
    "dropdelzpp": 364805086,
    "dropphyadd": "77 CEMETERY ST",
    "dropphycty": "URIAH",
    "dropphyst": "AL",
    "dropphyzpp": 364805086,
    "dropmaladd": "77 CEMETERY ST",
    "dropmalcty": "URIAH",
    "dropmalst": "AL",
    "dropmalzpp": 364809998,
    "dropsitphn": 2518622671,
    "dropsitlph": 2518622671,
    "dropsitcph": 2518622671,
    "dropfax": 2518622467
  },
  {
    "dcode": "D",
    "dropkey": "PY11225",
    "droptype": "D",
    "dropname": "VALHERMOSO SPRINGS",
    "dropdeladd": "7071 HIGHWAY 36 E",
    "dropdelcty": "VALHERMOSO SPRINGS",
    "dropdelst": "AL",
    "dropdelzpp": 357757015,
    "dropphyadd": "7071 HIGHWAY 36 E",
    "dropphycty": "VALHERMOSO SPRINGS",
    "dropphyst": "AL",
    "dropphyzpp": 357757015,
    "dropmaladd": "7071 HIGHWAY 36 E",
    "dropmalcty": "VALHERMOSO SPRINGS",
    "dropmalst": "AL",
    "dropmalzpp": 357759998,
    "dropsitphn": 2567787318,
    "dropsitlph": 2567787318,
    "dropsitcph": 2567787318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11226",
    "droptype": "D",
    "dropname": "VALLEY",
    "dropdeladd": "30 FOB JAMES DR",
    "dropdelcty": "VALLEY",
    "dropdelst": "AL",
    "dropdelzpp": 368549998,
    "dropphyadd": "30 FOB JAMES DR",
    "dropphycty": "VALLEY",
    "dropphyst": "AL",
    "dropphyzpp": 368549998,
    "dropmaladd": "30 FOB JAMES DR",
    "dropmalcty": "VALLEY",
    "dropmalst": "AL",
    "dropmalzpp": 368549998,
    "dropsitphn": 3347563268,
    "dropsitlph": 3347563268,
    "dropsitcph": 3347563268,
    "dropfax": 3347560439
  },
  {
    "dcode": "D",
    "dropkey": "PY11227",
    "droptype": "D",
    "dropname": "VALLEY HEAD",
    "dropdeladd": "36 COMMERCE AVE",
    "dropdelcty": "VALLEY HEAD",
    "dropdelst": "AL",
    "dropdelzpp": 359894244,
    "dropphyadd": "36 COMMERCE AVE",
    "dropphycty": "VALLEY HEAD",
    "dropphyst": "AL",
    "dropphyzpp": 359894244,
    "dropmaladd": "36 COMMERCE AVE",
    "dropmalcty": "VALLEY HEAD",
    "dropmalst": "AL",
    "dropmalzpp": 359899998,
    "dropsitphn": 2566356671,
    "dropsitlph": 2566356671,
    "dropsitcph": 2566356671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11228",
    "droptype": "D",
    "dropname": "VANCE",
    "dropdeladd": "18694 HIGHWAY 11 N",
    "dropdelcty": "VANCE",
    "dropdelst": "AL",
    "dropdelzpp": 354902414,
    "dropphyadd": "18694 HIGHWAY 11 N",
    "dropphycty": "VANCE",
    "dropphyst": "AL",
    "dropphyzpp": 354902414,
    "dropmaladd": "18694 HIGHWAY 11 N",
    "dropmalcty": "VANCE",
    "dropmalst": "AL",
    "dropmalzpp": 354909998,
    "dropsitphn": 2056330915,
    "dropsitlph": 2056330915,
    "dropsitcph": 2056330915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11229",
    "droptype": "D",
    "dropname": "VANDIVER",
    "dropdeladd": "52782 HIGHWAY 25",
    "dropdelcty": "VANDIVER",
    "dropdelst": "AL",
    "dropdelzpp": 351767314,
    "dropphyadd": "52782 HIGHWAY 25",
    "dropphycty": "VANDIVER",
    "dropphyst": "AL",
    "dropphyzpp": 351767314,
    "dropmaladd": "52782 HIGHWAY 25",
    "dropmalcty": "VANDIVER",
    "dropmalst": "AL",
    "dropmalzpp": 351769998,
    "dropsitphn": 2056729302,
    "dropsitlph": 2056729302,
    "dropsitcph": 2056729302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11231",
    "droptype": "D",
    "dropname": "VERBENA",
    "dropdeladd": "3919 US HIGHWAY 31",
    "dropdelcty": "VERBENA",
    "dropdelst": "AL",
    "dropdelzpp": 360919998,
    "dropphyadd": "3919 US HIGHWAY 31",
    "dropphycty": "VERBENA",
    "dropphyst": "AL",
    "dropphyzpp": 360919998,
    "dropmaladd": "3919 US HIGHWAY 31",
    "dropmalcty": "VERBENA",
    "dropmalst": "AL",
    "dropmalzpp": 360919998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3342856800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11233",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "44924 HIGHWAY 17",
    "dropdelcty": "VERNON",
    "dropdelst": "AL",
    "dropdelzpp": 355925630,
    "dropphyadd": "44924 HIGHWAY 17",
    "dropphycty": "VERNON",
    "dropphyst": "AL",
    "dropphyzpp": 355925630,
    "dropmaladd": "44924 HIGHWAY 17",
    "dropmalcty": "VERNON",
    "dropmalst": "AL",
    "dropmalzpp": 355929998,
    "dropsitphn": 2056957013,
    "dropsitlph": 2056957013,
    "dropsitcph": 2056957013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11242",
    "droptype": "D",
    "dropname": "VINA",
    "dropdeladd": "7191 HIGHWAY 19",
    "dropdelcty": "VINA",
    "dropdelst": "AL",
    "dropdelzpp": 355935133,
    "dropphyadd": "7191 HIGHWAY 19",
    "dropphycty": "VINA",
    "dropphyst": "AL",
    "dropphyzpp": 355935133,
    "dropmaladd": "7191 HIGHWAY 19",
    "dropmalcty": "VINA",
    "dropmalst": "AL",
    "dropmalzpp": 355939998,
    "dropsitphn": 2563569410,
    "dropsitlph": 2563569410,
    "dropsitcph": 2563569410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11243",
    "droptype": "D",
    "dropname": "VINCENT",
    "dropdeladd": "42840 HIGHWAY 25",
    "dropdelcty": "VINCENT",
    "dropdelst": "AL",
    "dropdelzpp": 351786156,
    "dropphyadd": "42840 HIGHWAY 25",
    "dropphycty": "VINCENT",
    "dropphyst": "AL",
    "dropphyzpp": 351786156,
    "dropmaladd": "42840 HIGHWAY 25",
    "dropmalcty": "VINCENT",
    "dropmalst": "AL",
    "dropmalzpp": 351789998,
    "dropsitphn": 2056728751,
    "dropsitlph": 2056728751,
    "dropsitcph": 2056727942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11244",
    "droptype": "D",
    "dropname": "VINEGAR BEND",
    "dropdeladd": "21 2ND ST",
    "dropdelcty": "VINEGAR BEND",
    "dropdelst": "AL",
    "dropdelzpp": 365842000,
    "dropphyadd": "21 2ND ST",
    "dropphycty": "VINEGAR BEND",
    "dropphyst": "AL",
    "dropphyzpp": 365842000,
    "dropmaladd": "21 2ND ST",
    "dropmalcty": "VINEGAR BEND",
    "dropmalst": "AL",
    "dropmalzpp": 365849998,
    "dropsitphn": 2517778574,
    "dropsitlph": 2517778574,
    "dropsitcph": 2517778574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11245",
    "droptype": "D",
    "dropname": "VINEMONT",
    "dropdeladd": "18181 US HIGHWAY 31",
    "dropdelcty": "VINEMONT",
    "dropdelst": "AL",
    "dropdelzpp": 351797074,
    "dropphyadd": "18181 US HIGHWAY 31",
    "dropphycty": "VINEMONT",
    "dropphyst": "AL",
    "dropphyzpp": 351797074,
    "dropmaladd": "18181 US HIGHWAY 31",
    "dropmalcty": "VINEMONT",
    "dropmalst": "AL",
    "dropmalzpp": 351799998,
    "dropsitphn": 2567347028,
    "dropsitlph": 2567347028,
    "dropsitcph": 2567347028,
    "dropfax": 2567393489
  },
  {
    "dcode": "D",
    "dropkey": "PY11246",
    "droptype": "D",
    "dropname": "VREDENBURGH",
    "dropdeladd": "34 CHURCH ST",
    "dropdelcty": "VREDENBURGH",
    "dropdelst": "AL",
    "dropdelzpp": 364812000,
    "dropphyadd": "34 CHURCH ST",
    "dropphycty": "VREDENBURGH",
    "dropphyst": "AL",
    "dropphyzpp": 364812000,
    "dropmaladd": "34 CHURCH ST",
    "dropmalcty": "VREDENBURGH",
    "dropmalst": "AL",
    "dropmalzpp": 364819998,
    "dropsitphn": 3343374616,
    "dropsitlph": 3343374616,
    "dropsitcph": 3343374616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11249",
    "droptype": "D",
    "dropname": "WADLEY",
    "dropdeladd": "150 MAIN ST",
    "dropdelcty": "WADLEY",
    "dropdelst": "AL",
    "dropdelzpp": 362763000,
    "dropphyadd": "150 MAIN ST",
    "dropphycty": "WADLEY",
    "dropphyst": "AL",
    "dropphyzpp": 362763000,
    "dropmaladd": "150 MAIN ST",
    "dropmalcty": "WADLEY",
    "dropmalst": "AL",
    "dropmalzpp": 362769998,
    "dropsitphn": 2563952233,
    "dropsitlph": 2563952233,
    "dropsitcph": 2563952233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11250",
    "droptype": "D",
    "dropname": "WAGARVILLE",
    "dropdeladd": "20191 HIGHWAY 43",
    "dropdelcty": "WAGARVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 365856200,
    "dropphyadd": "20191 HIGHWAY 43",
    "dropphycty": "WAGARVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 365856200,
    "dropmaladd": "20191 HIGHWAY 43",
    "dropmalcty": "WAGARVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 365859998,
    "dropsitphn": 2512465638,
    "dropsitlph": 2512465638,
    "dropsitcph": 2512465638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11255",
    "droptype": "D",
    "dropname": "WALNUT GROVE",
    "dropdeladd": "4030 GADSDEN BLOUNTSVILLE RD",
    "dropdelcty": "WALNUT GROVE",
    "dropdelst": "AL",
    "dropdelzpp": 359902000,
    "dropphyadd": "4030 GADSDEN BLOUNTSVILLE RD",
    "dropphycty": "WALNUT GROVE",
    "dropphyst": "AL",
    "dropphyzpp": 359902000,
    "dropmaladd": "4030 GADSDEN BLOUNTSVILLE RD",
    "dropmalcty": "WALNUT GROVE",
    "dropmalst": "AL",
    "dropmalzpp": 359909998,
    "dropsitphn": 2565892244,
    "dropsitlph": 2565892244,
    "dropsitcph": 2565892244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11257",
    "droptype": "D",
    "dropname": "WARD",
    "dropdeladd": "14659 WARD 10",
    "dropdelcty": "WARD",
    "dropdelst": "AL",
    "dropdelzpp": 369229998,
    "dropphyadd": "14659 WARD 10",
    "dropphycty": "WARD",
    "dropphyst": "AL",
    "dropphyzpp": 369229998,
    "dropmaladd": "14659 WARD 10",
    "dropmalcty": "WARD",
    "dropmalst": "AL",
    "dropmalzpp": 369229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2053924206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11258",
    "droptype": "D",
    "dropname": "WARRIOR",
    "dropdeladd": "420 HIGHWAY 31 S",
    "dropdelcty": "WARRIOR",
    "dropdelst": "AL",
    "dropdelzpp": 351801401,
    "dropphyadd": "420 HIGHWAY 31 S",
    "dropphycty": "WARRIOR",
    "dropphyst": "AL",
    "dropphyzpp": 351801401,
    "dropmaladd": "420 HIGHWAY 31 S",
    "dropmalcty": "WARRIOR",
    "dropmalst": "AL",
    "dropmalzpp": 351809998,
    "dropsitphn": 2055901664,
    "dropsitlph": 2055901664,
    "dropsitcph": 2055901664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11260",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "536 MAIN ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "AL",
    "dropdelzpp": 356774405,
    "dropphyadd": "536 MAIN ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "AL",
    "dropphyzpp": 356774405,
    "dropmaladd": "536 MAIN ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "AL",
    "dropmalzpp": 356779998,
    "dropsitphn": 2567673290,
    "dropsitlph": 2567673290,
    "dropsitcph": 2567673290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11261",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "4016 POWDER MILL RD",
    "dropdelcty": "WATSON",
    "dropdelst": "AL",
    "dropdelzpp": 351812000,
    "dropphyadd": "4016 POWDER MILL RD",
    "dropphycty": "WATSON",
    "dropphyst": "AL",
    "dropphyzpp": 351812000,
    "dropmaladd": "4016 POWDER MILL RD",
    "dropmalcty": "WATSON",
    "dropmalst": "AL",
    "dropmalzpp": 351819998,
    "dropsitphn": 2056743706,
    "dropsitlph": 2056743706,
    "dropsitcph": 2056743706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11263",
    "droptype": "D",
    "dropname": "WATTSVILLE",
    "dropdeladd": "50 OAKWOOD LN",
    "dropdelcty": "WATTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 351822000,
    "dropphyadd": "50 OAKWOOD LN",
    "dropphycty": "WATTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 351822000,
    "dropmaladd": "50 OAKWOOD LN",
    "dropmalcty": "WATTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 351829998,
    "dropsitphn": 2053387022,
    "dropsitlph": 2053387022,
    "dropsitcph": 2053387022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11266",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "1478 PATRICK ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "AL",
    "dropdelzpp": 368799998,
    "dropphyadd": "1478 PATRICK ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "AL",
    "dropphyzpp": 368799998,
    "dropmaladd": "1478 PATRICK ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "AL",
    "dropmalzpp": 368799998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447515,
    "dropsitcph": 3348875775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11267",
    "droptype": "D",
    "dropname": "WEAVER",
    "dropdeladd": "300 ALEXANDRIA RD",
    "dropdelcty": "WEAVER",
    "dropdelst": "AL",
    "dropdelzpp": 362774313,
    "dropphyadd": "300 ALEXANDRIA RD",
    "dropphycty": "WEAVER",
    "dropphyst": "AL",
    "dropphyzpp": 362774313,
    "dropmaladd": "300 ALEXANDRIA RD",
    "dropmalcty": "WEAVER",
    "dropmalst": "AL",
    "dropmalzpp": 362779998,
    "dropsitphn": 2568200390,
    "dropsitlph": 2568200390,
    "dropsitcph": 2568200390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11268",
    "droptype": "D",
    "dropname": "WEBB",
    "dropdeladd": "175 KIRKLAND ST",
    "dropdelcty": "WEBB",
    "dropdelst": "AL",
    "dropdelzpp": 363765295,
    "dropphyadd": "175 KIRKLAND ST",
    "dropphycty": "WEBB",
    "dropphyst": "AL",
    "dropphyzpp": 363765295,
    "dropmaladd": "175 KIRKLAND ST",
    "dropmalcty": "WEBB",
    "dropmalst": "AL",
    "dropmalzpp": 363769998,
    "dropsitphn": 3347927462,
    "dropsitlph": 3347927462,
    "dropsitcph": 3347927462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11269",
    "droptype": "D",
    "dropname": "WEDOWEE",
    "dropdeladd": "17697 HIGHWAY 431",
    "dropdelcty": "WEDOWEE",
    "dropdelst": "AL",
    "dropdelzpp": 362784571,
    "dropphyadd": "17697 HIGHWAY 431",
    "dropphycty": "WEDOWEE",
    "dropphyst": "AL",
    "dropphyzpp": 362784571,
    "dropmaladd": "17697 HIGHWAY 431",
    "dropmalcty": "WEDOWEE",
    "dropmalst": "AL",
    "dropmalzpp": 362789998,
    "dropsitphn": 2563572812,
    "dropsitlph": 2563572812,
    "dropsitcph": 2563572812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11271",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "50 WELLINGTON DR",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "AL",
    "dropdelzpp": 362796714,
    "dropphyadd": "50 WELLINGTON DR",
    "dropphycty": "WELLINGTON",
    "dropphyst": "AL",
    "dropphyzpp": 362796714,
    "dropmaladd": "50 WELLINGTON DR",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "AL",
    "dropmalzpp": 362799998,
    "dropsitphn": 2058923716,
    "dropsitlph": 2058923716,
    "dropsitcph": 2058923716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11273",
    "droptype": "D",
    "dropname": "WEOGUFKA",
    "dropdeladd": "20312 COOSA COUNTY ROAD 29",
    "dropdelcty": "WEOGUFKA",
    "dropdelst": "AL",
    "dropdelzpp": 351832365,
    "dropphyadd": "20312 COOSA COUNTY ROAD 29",
    "dropphycty": "WEOGUFKA",
    "dropphyst": "AL",
    "dropphyzpp": 351832365,
    "dropmaladd": "20312 COOSA COUNTY ROAD 29",
    "dropmalcty": "WEOGUFKA",
    "dropmalst": "AL",
    "dropmalzpp": 351839998,
    "dropsitphn": 2562455041,
    "dropsitlph": 2562455041,
    "dropsitcph": 2562455041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11275",
    "droptype": "D",
    "dropname": "WEST BLOCTON",
    "dropdeladd": "106 FLORIDA ST",
    "dropdelcty": "WEST BLOCTON",
    "dropdelst": "AL",
    "dropdelzpp": 351842326,
    "dropphyadd": "106 FLORIDA ST",
    "dropphycty": "WEST BLOCTON",
    "dropphyst": "AL",
    "dropphyzpp": 351842326,
    "dropmaladd": "106 FLORIDA ST",
    "dropmalcty": "WEST BLOCTON",
    "dropmalst": "AL",
    "dropmalzpp": 351849998,
    "dropsitphn": 2059387662,
    "dropsitlph": 2059387662,
    "dropsitcph": 2055193011,
    "dropfax": 2055193010
  },
  {
    "dcode": "D",
    "dropkey": "PY11277",
    "droptype": "D",
    "dropname": "WEST GREENE",
    "dropdeladd": "5190 GREENE COUNTY ROAD 117",
    "dropdelcty": "WEST GREENE",
    "dropdelst": "AL",
    "dropdelzpp": 354912000,
    "dropphyadd": "5190 GREENE COUNTY ROAD 117",
    "dropphycty": "WEST GREENE",
    "dropphyst": "AL",
    "dropphyzpp": 354912000,
    "dropmaladd": "5190 GREENE COUNTY ROAD 117",
    "dropmalcty": "WEST GREENE",
    "dropmalst": "AL",
    "dropmalzpp": 354912000,
    "dropsitphn": 2053729396,
    "dropsitlph": 2053729396,
    "dropsitcph": 2053729396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11279",
    "droptype": "D",
    "dropname": "WESTOVER",
    "dropdeladd": "9779 HIGHWAY 55",
    "dropdelcty": "WESTOVER",
    "dropdelst": "AL",
    "dropdelzpp": 351852000,
    "dropphyadd": "9779 HIGHWAY 55",
    "dropphycty": "WESTOVER",
    "dropphyst": "AL",
    "dropphyzpp": 351852000,
    "dropmaladd": "9779 HIGHWAY 55",
    "dropmalcty": "WESTOVER",
    "dropmalst": "AL",
    "dropmalzpp": 351859998,
    "dropsitphn": 2056789569,
    "dropsitlph": 2056789569,
    "dropsitcph": 2056789569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11281",
    "droptype": "D",
    "dropname": "WETUMPKA",
    "dropdeladd": "216 W FORT TOULOUSE RD",
    "dropdelcty": "WETUMPKA",
    "dropdelst": "AL",
    "dropdelzpp": 360939998,
    "dropphyadd": "216 W FORT TOULOUSE RD",
    "dropphycty": "WETUMPKA",
    "dropphyst": "AL",
    "dropphyzpp": 360939998,
    "dropmaladd": "216 W FORT TOULOUSE RD",
    "dropmalcty": "WETUMPKA",
    "dropmalst": "AL",
    "dropmalzpp": 360939998,
    "dropsitphn": 3345679847,
    "dropsitlph": 3345679847,
    "dropsitcph": 3345140215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11282",
    "droptype": "D",
    "dropname": "WHATLEY",
    "dropdeladd": "1009 MAIN ST",
    "dropdelcty": "WHATLEY",
    "dropdelst": "AL",
    "dropdelzpp": 364823021,
    "dropphyadd": "1009 MAIN ST",
    "dropphycty": "WHATLEY",
    "dropphyst": "AL",
    "dropphyzpp": 364823021,
    "dropmaladd": "1009 MAIN ST",
    "dropmalcty": "WHATLEY",
    "dropmalst": "AL",
    "dropmalzpp": 364829998,
    "dropsitphn": 2512758444,
    "dropsitlph": 2512758444,
    "dropsitcph": 2512758444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11293",
    "droptype": "D",
    "dropname": "WILMER",
    "dropdeladd": "13255 MOFFETT RD",
    "dropdelcty": "WILMER",
    "dropdelst": "AL",
    "dropdelzpp": 365874419,
    "dropphyadd": "13255 MOFFETT RD",
    "dropphycty": "WILMER",
    "dropphyst": "AL",
    "dropphyzpp": 365874419,
    "dropmaladd": "13255 MOFFETT RD",
    "dropmalcty": "WILMER",
    "dropmalst": "AL",
    "dropmalzpp": 365879998,
    "dropsitphn": 2516455622,
    "dropsitlph": 2516455622,
    "dropsitcph": 2516455622,
    "dropfax": 2516498990
  },
  {
    "dcode": "D",
    "dropkey": "PY11294",
    "droptype": "D",
    "dropname": "WILSONVILLE",
    "dropdeladd": "31111 HIGHWAY 25",
    "dropdelcty": "WILSONVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 351867118,
    "dropphyadd": "31111 HIGHWAY 25",
    "dropphycty": "WILSONVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 351867118,
    "dropmaladd": "31111 HIGHWAY 25",
    "dropmalcty": "WILSONVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 351869998,
    "dropsitphn": 2056700328,
    "dropsitlph": 2056700328,
    "dropsitcph": 2056700324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11295",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "2324 HIGHWAY 25",
    "dropdelcty": "WILTON",
    "dropdelst": "AL",
    "dropdelzpp": 351872000,
    "dropphyadd": "2324 HIGHWAY 25",
    "dropphycty": "WILTON",
    "dropphyst": "AL",
    "dropphyzpp": 351872000,
    "dropmaladd": "2324 HIGHWAY 25",
    "dropmalcty": "WILTON",
    "dropmalst": "AL",
    "dropmalzpp": 351879998,
    "dropsitphn": 2056657983,
    "dropsitlph": 2056657983,
    "dropsitcph": 2056657983,
    "dropfax": 2056650233
  },
  {
    "dcode": "D",
    "dropkey": "PY11296",
    "droptype": "D",
    "dropname": "WINFIELD",
    "dropdeladd": "161 BROOK ST",
    "dropdelcty": "WINFIELD",
    "dropdelst": "AL",
    "dropdelzpp": 355945341,
    "dropphyadd": "161 BROOK ST",
    "dropphycty": "WINFIELD",
    "dropphyst": "AL",
    "dropphyzpp": 355945341,
    "dropmaladd": "161 BROOK ST",
    "dropmalcty": "WINFIELD",
    "dropmalst": "AL",
    "dropmalzpp": 355949998,
    "dropsitphn": 2054872403,
    "dropsitlph": 2054872403,
    "dropsitcph": 2054872403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11297",
    "droptype": "D",
    "dropname": "WING",
    "dropdeladd": "2989 AL HIGHWAY 137",
    "dropdelcty": "WING",
    "dropdelst": "AL",
    "dropdelzpp": 364832108,
    "dropphyadd": "2989 AL HIGHWAY 137",
    "dropphycty": "WING",
    "dropphyst": "AL",
    "dropphyzpp": 364832108,
    "dropmaladd": "2989 AL HIGHWAY 137",
    "dropmalcty": "WING",
    "dropmalst": "AL",
    "dropmalzpp": 364839998,
    "dropsitphn": 3345724124,
    "dropsitlph": 3345724124,
    "dropsitcph": 3345724124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11300",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "148 WOODLAND DR",
    "dropdelcty": "WOODLAND",
    "dropdelst": "AL",
    "dropdelzpp": 362805322,
    "dropphyadd": "148 WOODLAND DR",
    "dropphycty": "WOODLAND",
    "dropphyst": "AL",
    "dropphyzpp": 362805322,
    "dropmaladd": "148 WOODLAND DR",
    "dropmalcty": "WOODLAND",
    "dropmalst": "AL",
    "dropmalzpp": 362809998,
    "dropsitphn": 2564496162,
    "dropsitlph": 2564496162,
    "dropsitcph": 2564496162,
    "dropfax": 2564496162
  },
  {
    "dcode": "D",
    "dropkey": "PY11302",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "28770 HIGHWAY 5",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "AL",
    "dropdelzpp": 351883610,
    "dropphyadd": "28770 HIGHWAY 5",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "AL",
    "dropphyzpp": 351883610,
    "dropmaladd": "28770 HIGHWAY 5",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "AL",
    "dropmalzpp": 351889998,
    "dropsitphn": 2059387493,
    "dropsitlph": 2059387493,
    "dropsitcph": 2059387493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11303",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "30056 AL HIGHWAY 35",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 357766176,
    "dropphyadd": "30056 AL HIGHWAY 35",
    "dropphycty": "WOODVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 357766176,
    "dropmaladd": "30056 AL HIGHWAY 35",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 357769998,
    "dropsitphn": 2567763338,
    "dropsitlph": 2567763338,
    "dropsitcph": 2567763338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11310",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "207 MAIN ST",
    "dropdelcty": "YORK",
    "dropdelst": "AL",
    "dropdelzpp": 369259998,
    "dropphyadd": "207 MAIN ST",
    "dropphycty": "YORK",
    "dropphyst": "AL",
    "dropphyzpp": 369259998,
    "dropmaladd": "207 MAIN ST",
    "dropmalcty": "YORK",
    "dropmalst": "AL",
    "dropmalzpp": 369259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2053924846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11314",
    "droptype": "D",
    "dropname": "ACME",
    "dropdeladd": "3585 BUNKER HILL RD",
    "dropdelcty": "ACME",
    "dropdelst": "MI",
    "dropdelzpp": 496109800,
    "dropphyadd": "3585 BUNKER HILL RD",
    "dropphycty": "ACME",
    "dropphyst": "MI",
    "dropphyzpp": 496109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ACME",
    "dropmalst": "MI",
    "dropmalzpp": 496109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 2319381870,
    "dropfax": 2319381870
  },
  {
    "dcode": "D",
    "dropkey": "PY11315",
    "droptype": "D",
    "dropname": "ADA",
    "dropdeladd": "7125 HEADLEY ST SE",
    "dropdelcty": "ADA",
    "dropdelst": "MI",
    "dropdelzpp": 493019921,
    "dropphyadd": "7125 HEADLEY ST SE",
    "dropphycty": "ADA",
    "dropphyst": "MI",
    "dropphyzpp": 493019921,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADA",
    "dropmalst": "MI",
    "dropmalzpp": 493019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 6166761088,
    "dropfax": 6169420359
  },
  {
    "dcode": "D",
    "dropkey": "PY11316",
    "droptype": "D",
    "dropname": "ADDISON",
    "dropdeladd": "103 S TALBOT ST",
    "dropdelcty": "ADDISON",
    "dropdelst": "MI",
    "dropdelzpp": 492209998,
    "dropphyadd": "103 S TALBOT ST",
    "dropphycty": "ADDISON",
    "dropphyst": "MI",
    "dropphyzpp": 492209998,
    "dropmaladd": "103 S TALBOT ST",
    "dropmalcty": "ADDISON",
    "dropmalst": "MI",
    "dropmalzpp": 492209998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175475642,
    "dropfax": 5175476739
  },
  {
    "dcode": "D",
    "dropkey": "PY11318",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "413 E MAUMEE ST",
    "dropdelcty": "ADRIAN",
    "dropdelst": "MI",
    "dropdelzpp": 492219998,
    "dropphyadd": "413 E MAUMEE ST",
    "dropphycty": "ADRIAN",
    "dropphyst": "MI",
    "dropphyzpp": 492219998,
    "dropmaladd": "413 E MAUMEE ST",
    "dropmalcty": "ADRIAN",
    "dropmalst": "MI",
    "dropmalzpp": 492219998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172633795,
    "dropfax": 5172659725
  },
  {
    "dcode": "D",
    "dropkey": "PY11319",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "498 M 68 HWY",
    "dropdelcty": "AFTON",
    "dropdelst": "MI",
    "dropdelzpp": 497055101,
    "dropphyadd": "498 M 68 HWY",
    "dropphycty": "AFTON",
    "dropphyst": "MI",
    "dropphyzpp": 497055101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AFTON",
    "dropmalst": "MI",
    "dropmalzpp": 497059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 2312387767,
    "dropfax": 2312384952
  },
  {
    "dcode": "D",
    "dropkey": "PY11320",
    "droptype": "D",
    "dropname": "AHMEEK",
    "dropdeladd": "2 VIVIAN ST",
    "dropdelcty": "AHMEEK",
    "dropdelst": "MI",
    "dropdelzpp": 499019800,
    "dropphyadd": "2 VIVIAN ST",
    "dropphycty": "AHMEEK",
    "dropphyst": "MI",
    "dropphyzpp": 499019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AHMEEK",
    "dropmalst": "MI",
    "dropmalzpp": 499019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063373116,
    "dropsitcph": 9063373116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11322",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "4282 BEACH ST",
    "dropdelcty": "AKRON",
    "dropdelst": "MI",
    "dropdelzpp": 487019900,
    "dropphyadd": "4282 BEACH ST",
    "dropphycty": "AKRON",
    "dropphyst": "MI",
    "dropphyzpp": 487019900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKRON",
    "dropmalst": "MI",
    "dropmalzpp": 487019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 9896915281,
    "dropfax": 6169420359
  },
  {
    "dcode": "D",
    "dropkey": "PY11324",
    "droptype": "D",
    "dropname": "ALANSON",
    "dropdeladd": "6263 RIVER ST",
    "dropdelcty": "ALANSON",
    "dropdelst": "MI",
    "dropdelzpp": 497069206,
    "dropphyadd": "6263 RIVER ST",
    "dropphycty": "ALANSON",
    "dropphyst": "MI",
    "dropphyzpp": 497069206,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALANSON",
    "dropmalst": "MI",
    "dropmalzpp": 497069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 2315482380,
    "dropfax": 6169420359
  },
  {
    "dcode": "D",
    "dropkey": "PY11326",
    "droptype": "D",
    "dropname": "ALBA",
    "dropdeladd": "3995 2ND ST",
    "dropdelcty": "ALBA",
    "dropdelst": "MI",
    "dropdelzpp": 496119800,
    "dropphyadd": "3995 2ND ST",
    "dropphycty": "ALBA",
    "dropphyst": "MI",
    "dropphyzpp": 496119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBA",
    "dropmalst": "MI",
    "dropmalzpp": 496119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169426930,
    "dropsitcph": 2315842323,
    "dropfax": 6169420359
  },
  {
    "dcode": "D",
    "dropkey": "PY11327",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "307 N SUPERIOR ST",
    "dropdelcty": "ALBION",
    "dropdelst": "MI",
    "dropdelzpp": 492249998,
    "dropphyadd": "307 N SUPERIOR ST",
    "dropphycty": "ALBION",
    "dropphyst": "MI",
    "dropphyzpp": 492249998,
    "dropmaladd": "307 N SUPERIOR ST",
    "dropmalcty": "ALBION",
    "dropmalst": "MI",
    "dropmalzpp": 492249998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5176292598,
    "dropfax": 5176292427
  },
  {
    "dcode": "D",
    "dropkey": "PY11328",
    "droptype": "D",
    "dropname": "ALDEN",
    "dropdeladd": "9095 HELENA RD",
    "dropdelcty": "ALDEN",
    "dropdelst": "MI",
    "dropdelzpp": 496129800,
    "dropphyadd": "9095 HELENA RD",
    "dropphycty": "ALDEN",
    "dropphyst": "MI",
    "dropphyzpp": 496129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALDEN",
    "dropmalst": "MI",
    "dropmalzpp": 496129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313316412,
    "dropsitcph": 2313316412,
    "dropfax": 2313314189
  },
  {
    "dcode": "D",
    "dropkey": "PY11329",
    "droptype": "D",
    "dropname": "ALGER",
    "dropdeladd": "1454 JOY ST",
    "dropdelcty": "ALGER",
    "dropdelst": "MI",
    "dropdelzpp": 486102500,
    "dropphyadd": "1454 JOY ST",
    "dropphycty": "ALGER",
    "dropphyst": "MI",
    "dropphyzpp": 486102500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALGER",
    "dropmalst": "MI",
    "dropmalzpp": 486109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898362379,
    "dropsitcph": 9898362379,
    "dropfax": 9898362396
  },
  {
    "dcode": "D",
    "dropkey": "PY11330",
    "droptype": "D",
    "dropname": "ALGONAC",
    "dropdeladd": "801 SAINT CLAIR RIVER DR",
    "dropdelcty": "ALGONAC",
    "dropdelst": "MI",
    "dropdelzpp": 480019998,
    "dropphyadd": "801 SAINT CLAIR RIVER DR",
    "dropphycty": "ALGONAC",
    "dropphyst": "MI",
    "dropphyzpp": 480019998,
    "dropmaladd": "801 SAINT CLAIR RIVER DR",
    "dropmalcty": "ALGONAC",
    "dropmalst": "MI",
    "dropmalzpp": 480019998,
    "dropsitphn": 8107943821,
    "dropsitlph": 2487585622,
    "dropsitcph": 8107943821,
    "dropfax": 8107944397
  },
  {
    "dcode": "D",
    "dropkey": "PY11331",
    "droptype": "D",
    "dropname": "ALLEGAN",
    "dropdeladd": "300 TROWBRIDGE ST",
    "dropdelcty": "ALLEGAN",
    "dropdelst": "MI",
    "dropdelzpp": 490109998,
    "dropphyadd": "300 TROWBRIDGE ST",
    "dropphycty": "ALLEGAN",
    "dropphyst": "MI",
    "dropphyzpp": 490109998,
    "dropmaladd": "300 TROWBRIDGE ST",
    "dropmalcty": "ALLEGAN",
    "dropmalst": "MI",
    "dropmalzpp": 490109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696732349,
    "dropsitcph": 2696732349,
    "dropfax": 2696734819
  },
  {
    "dcode": "D",
    "dropkey": "PY11332",
    "droptype": "D",
    "dropname": "ALLEN",
    "dropdeladd": "200 E CHICAGO RD",
    "dropdelcty": "ALLEN",
    "dropdelst": "MI",
    "dropdelzpp": 492279998,
    "dropphyadd": "200 E CHICAGO RD",
    "dropphycty": "ALLEN",
    "dropphyst": "MI",
    "dropphyzpp": 492279998,
    "dropmaladd": "200 E CHICAGO RD",
    "dropmalcty": "ALLEN",
    "dropmalst": "MI",
    "dropmalzpp": 492279998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5178692389,
    "dropfax": 5178692287
  },
  {
    "dcode": "D",
    "dropkey": "PY11333",
    "droptype": "D",
    "dropname": "ALLEN PARK",
    "dropdeladd": "6800 ROOSEVELT AVE",
    "dropdelcty": "ALLEN PARK",
    "dropdelst": "MI",
    "dropdelzpp": 481019998,
    "dropphyadd": "6800 ROOSEVELT AVE",
    "dropphycty": "ALLEN PARK",
    "dropphyst": "MI",
    "dropphyzpp": 481019998,
    "dropmaladd": "6800 ROOSEVELT AVE",
    "dropmalcty": "ALLEN PARK",
    "dropmalst": "MI",
    "dropmalzpp": 481019998,
    "dropsitphn": 3133819788,
    "dropsitlph": 3132268554,
    "dropsitcph": 3133819788,
    "dropfax": 3133815414
  },
  {
    "dcode": "D",
    "dropkey": "PY11334",
    "droptype": "D",
    "dropname": "ALLENDALE",
    "dropdeladd": "6370 LAKE MICHIGAN DR STE 800",
    "dropdelcty": "ALLENDALE",
    "dropdelst": "MI",
    "dropdelzpp": 494018078,
    "dropphyadd": "6370 LAKE MICHIGAN DR STE 800",
    "dropphycty": "ALLENDALE",
    "dropphyst": "MI",
    "dropphyzpp": 494018078,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLENDALE",
    "dropmalst": "MI",
    "dropmalzpp": 494019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168951406,
    "dropsitcph": 6168951406,
    "dropfax": 6168957719
  },
  {
    "dcode": "D",
    "dropkey": "PY11336",
    "droptype": "D",
    "dropname": "ALLENTON",
    "dropdeladd": "770 CAPAC RD",
    "dropdelcty": "ALLENTON",
    "dropdelst": "MI",
    "dropdelzpp": 480029998,
    "dropphyadd": "770 CAPAC RD",
    "dropphycty": "ALLENTON",
    "dropphyst": "MI",
    "dropphyzpp": 480029998,
    "dropmaladd": "770 CAPAC RD",
    "dropmalcty": "ALLENTON",
    "dropmalst": "MI",
    "dropmalzpp": 480029998,
    "dropsitphn": 8103954957,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103954957,
    "dropfax": 8103957696
  },
  {
    "dcode": "D",
    "dropkey": "PY11339",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "233 N STATE ST",
    "dropdelcty": "ALMA",
    "dropdelst": "MI",
    "dropdelzpp": 488012276,
    "dropphyadd": "233 N STATE ST",
    "dropphycty": "ALMA",
    "dropphyst": "MI",
    "dropphyzpp": 488012276,
    "dropmaladd": "233 N STATE ST",
    "dropmalcty": "ALMA",
    "dropmalst": "MI",
    "dropmalzpp": 488012276,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894638311,
    "dropsitcph": 9894638311,
    "dropfax": 9894632847
  },
  {
    "dcode": "D",
    "dropkey": "PY11340",
    "droptype": "D",
    "dropname": "ALMONT",
    "dropdeladd": "116 N MAIN ST",
    "dropdelcty": "ALMONT",
    "dropdelst": "MI",
    "dropdelzpp": 480039998,
    "dropphyadd": "116 N MAIN ST",
    "dropphycty": "ALMONT",
    "dropphyst": "MI",
    "dropphyzpp": 480039998,
    "dropmaladd": "116 N MAIN ST",
    "dropmalcty": "ALMONT",
    "dropmalst": "MI",
    "dropmalzpp": 480039998,
    "dropsitphn": 8107988839,
    "dropsitlph": 2487585622,
    "dropsitcph": 8107988839,
    "dropfax": 8107988593
  },
  {
    "dcode": "D",
    "dropkey": "PY11343",
    "droptype": "D",
    "dropname": "ALPENA",
    "dropdeladd": "350 N 2ND AVE",
    "dropdelcty": "ALPENA",
    "dropdelst": "MI",
    "dropdelzpp": 497079998,
    "dropphyadd": "350 N 2ND AVE",
    "dropphycty": "ALPENA",
    "dropphyst": "MI",
    "dropphyzpp": 497079998,
    "dropmaladd": "350 N 2ND AVE",
    "dropmalcty": "ALPENA",
    "dropmalst": "MI",
    "dropmalzpp": 497079998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893542520,
    "dropsitcph": 9893542520,
    "dropfax": 9898846016
  },
  {
    "dcode": "D",
    "dropkey": "PY11344",
    "droptype": "D",
    "dropname": "ALPHA",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "ALPHA",
    "dropdelst": "MI",
    "dropdelzpp": 499029800,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "ALPHA",
    "dropphyst": "MI",
    "dropphyzpp": 499029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPHA",
    "dropmalst": "MI",
    "dropmalzpp": 499029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068756427,
    "dropsitcph": 9068756427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11345",
    "droptype": "D",
    "dropname": "ALTO",
    "dropdeladd": "11525 KIRBY ST SE",
    "dropdelcty": "ALTO",
    "dropdelst": "MI",
    "dropdelzpp": 493025103,
    "dropphyadd": "11525 KIRBY ST SE",
    "dropphycty": "ALTO",
    "dropphyst": "MI",
    "dropphyzpp": 493025103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTO",
    "dropmalst": "MI",
    "dropmalzpp": 493029998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168686650,
    "dropsitcph": 6168686650,
    "dropfax": 6168686327
  },
  {
    "dcode": "D",
    "dropkey": "PY11346",
    "droptype": "D",
    "dropname": "AMASA",
    "dropdeladd": "209 MAPLE AVE",
    "dropdelcty": "AMASA",
    "dropdelst": "MI",
    "dropdelzpp": 499039800,
    "dropphyadd": "209 MAPLE AVE",
    "dropphycty": "AMASA",
    "dropphyst": "MI",
    "dropphyzpp": 499039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMASA",
    "dropmalst": "MI",
    "dropmalzpp": 499039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068227771,
    "dropsitcph": 9068227771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11348",
    "droptype": "D",
    "dropname": "ANCHORVILLE",
    "dropdeladd": "9828 DIXIE HWY",
    "dropdelcty": "ANCHORVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 480049998,
    "dropphyadd": "9828 DIXIE HWY",
    "dropphycty": "ANCHORVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 480049998,
    "dropmaladd": "9828 DIXIE HWY",
    "dropmalcty": "ANCHORVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 480049998,
    "dropsitphn": 5867259332,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867259332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11351",
    "droptype": "D",
    "dropname": "ANN ARBOR",
    "dropdeladd": "2075 W STADIUM BLVD",
    "dropdelcty": "ANN ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 481039998,
    "dropphyadd": "2075 W STADIUM BLVD",
    "dropphycty": "ANN ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 481039998,
    "dropmaladd": "2075 W STADIUM BLVD",
    "dropmalcty": "ANN ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 481039998,
    "dropsitphn": 7346620223,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346620223,
    "dropfax": 7347476196
  },
  {
    "dcode": "D",
    "dropkey": "PY11354",
    "droptype": "D",
    "dropname": "APPLEGATE",
    "dropdeladd": "2469 S SHERMAN RD",
    "dropdelcty": "APPLEGATE",
    "dropdelst": "MI",
    "dropdelzpp": 484019998,
    "dropphyadd": "2469 S SHERMAN RD",
    "dropphycty": "APPLEGATE",
    "dropphyst": "MI",
    "dropphyzpp": 484019998,
    "dropmaladd": "2469 S SHERMAN RD",
    "dropmalcty": "APPLEGATE",
    "dropmalst": "MI",
    "dropmalzpp": 484019998,
    "dropsitphn": 8106339418,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106339418,
    "dropfax": 8106339194
  },
  {
    "dcode": "D",
    "dropkey": "PY11356",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "3294 LAKE ST",
    "dropdelcty": "ARCADIA",
    "dropdelst": "MI",
    "dropdelzpp": 496135121,
    "dropphyadd": "3294 LAKE ST",
    "dropphycty": "ARCADIA",
    "dropphyst": "MI",
    "dropphyzpp": 496135121,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "MI",
    "dropmalzpp": 496139998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318893111,
    "dropsitcph": 2318893111,
    "dropfax": 6168890811
  },
  {
    "dcode": "D",
    "dropkey": "PY11359",
    "droptype": "D",
    "dropname": "ARMADA",
    "dropdeladd": "74260 BURK ST",
    "dropdelcty": "ARMADA",
    "dropdelst": "MI",
    "dropdelzpp": 480059998,
    "dropphyadd": "74260 BURK ST",
    "dropphycty": "ARMADA",
    "dropphyst": "MI",
    "dropphyzpp": 480059998,
    "dropmaladd": "74260 BURK ST",
    "dropmalcty": "ARMADA",
    "dropmalst": "MI",
    "dropmalzpp": 480059998,
    "dropsitphn": 5867846045,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867846045,
    "dropfax": 5867844327
  },
  {
    "dcode": "D",
    "dropkey": "PY11365",
    "droptype": "D",
    "dropname": "ASHLEY",
    "dropdeladd": "120 S STERLING ST",
    "dropdelcty": "ASHLEY",
    "dropdelst": "MI",
    "dropdelzpp": 488065104,
    "dropphyadd": "120 S STERLING ST",
    "dropphycty": "ASHLEY",
    "dropphyst": "MI",
    "dropphyzpp": 488065104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHLEY",
    "dropmalst": "MI",
    "dropmalzpp": 488069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898474981,
    "dropsitcph": 9898474981,
    "dropfax": 9898474981
  },
  {
    "dcode": "D",
    "dropkey": "PY11367",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "115 N CAPITAL AVE",
    "dropdelcty": "ATHENS",
    "dropdelst": "MI",
    "dropdelzpp": 490119375,
    "dropphyadd": "115 N CAPITAL AVE",
    "dropphycty": "ATHENS",
    "dropphyst": "MI",
    "dropphyzpp": 490119375,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATHENS",
    "dropmalst": "MI",
    "dropmalzpp": 490119998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2697295370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11368",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "12606 STATE ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "MI",
    "dropdelzpp": 497099648,
    "dropphyadd": "12606 STATE ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "MI",
    "dropphyzpp": 497099648,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATLANTA",
    "dropmalst": "MI",
    "dropmalzpp": 497099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897854415,
    "dropsitcph": 9897854415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11369",
    "droptype": "D",
    "dropname": "ATLANTIC MINE",
    "dropdeladd": "46920 ERICKSON DR",
    "dropdelcty": "ATLANTIC MINE",
    "dropdelst": "MI",
    "dropdelzpp": 499059800,
    "dropphyadd": "46920 ERICKSON DR",
    "dropphycty": "ATLANTIC MINE",
    "dropphyst": "MI",
    "dropphyzpp": 499059800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATLANTIC MINE",
    "dropmalst": "MI",
    "dropmalzpp": 499059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064828450,
    "dropsitcph": 9064828450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11370",
    "droptype": "D",
    "dropname": "ATLAS",
    "dropdeladd": "8519 PERRY RD",
    "dropdelcty": "ATLAS",
    "dropdelst": "MI",
    "dropdelzpp": 484119998,
    "dropphyadd": "8519 PERRY RD",
    "dropphycty": "ATLAS",
    "dropphyst": "MI",
    "dropphyzpp": 484119998,
    "dropmaladd": "8519 PERRY RD",
    "dropmalcty": "ATLAS",
    "dropmalst": "MI",
    "dropmalzpp": 484119998,
    "dropsitphn": 8106362430,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106362430,
    "dropfax": 8103695004
  },
  {
    "dcode": "D",
    "dropkey": "PY11371",
    "droptype": "D",
    "dropname": "ATTICA",
    "dropdeladd": "485 N LAKE PLEASANT RD",
    "dropdelcty": "ATTICA",
    "dropdelst": "MI",
    "dropdelzpp": 484129998,
    "dropphyadd": "485 N LAKE PLEASANT RD",
    "dropphycty": "ATTICA",
    "dropphyst": "MI",
    "dropphyzpp": 484129998,
    "dropmaladd": "485 N LAKE PLEASANT RD",
    "dropmalcty": "ATTICA",
    "dropmalst": "MI",
    "dropmalzpp": 484129998,
    "dropsitphn": 8107240284,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107240284,
    "dropfax": 8107245354
  },
  {
    "dcode": "D",
    "dropkey": "PY11372",
    "droptype": "D",
    "dropname": "AU GRES",
    "dropdeladd": "109 W HURON RD",
    "dropdelcty": "AU GRES",
    "dropdelst": "MI",
    "dropdelzpp": 487039800,
    "dropphyadd": "109 W HURON RD",
    "dropphycty": "AU GRES",
    "dropphyst": "MI",
    "dropphyzpp": 487039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AU GRES",
    "dropmalst": "MI",
    "dropmalzpp": 487039998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898767710,
    "dropsitcph": 9898767710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11375",
    "droptype": "D",
    "dropname": "AU TRAIN",
    "dropdeladd": "N7589 ARBUTUS ST",
    "dropdelcty": "AU TRAIN",
    "dropdelst": "MI",
    "dropdelzpp": 498069667,
    "dropphyadd": "N7589 ARBUTUS ST",
    "dropphycty": "AU TRAIN",
    "dropphyst": "MI",
    "dropphyzpp": 498069667,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AU TRAIN",
    "dropmalst": "MI",
    "dropmalzpp": 498069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9068928335,
    "dropsitcph": 9068928335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11376",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "951 W MIDLAND RD",
    "dropdelcty": "AUBURN",
    "dropdelst": "MI",
    "dropdelzpp": 486119406,
    "dropphyadd": "951 W MIDLAND RD",
    "dropphycty": "AUBURN",
    "dropphyst": "MI",
    "dropphyzpp": 486119406,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUBURN",
    "dropmalst": "MI",
    "dropmalzpp": 486119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896622637,
    "dropsitcph": 9896622637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11380",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "112 S WEBSTER ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "MI",
    "dropdelzpp": 490129776,
    "dropphyadd": "112 S WEBSTER ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "MI",
    "dropphyzpp": 490129776,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "MI",
    "dropmalzpp": 490129998,
    "dropsitphn": 2697314947,
    "dropsitlph": 6167761473,
    "dropsitcph": 2697314947,
    "dropfax": 2697314140
  },
  {
    "dcode": "D",
    "dropkey": "PY11384",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "8810 AVOCA RD",
    "dropdelcty": "AVOCA",
    "dropdelst": "MI",
    "dropdelzpp": 480069998,
    "dropphyadd": "8810 AVOCA RD",
    "dropphycty": "AVOCA",
    "dropphyst": "MI",
    "dropphyzpp": 480069998,
    "dropmaladd": "8810 AVOCA RD",
    "dropmalcty": "AVOCA",
    "dropmalst": "MI",
    "dropmalzpp": 480069998,
    "dropsitphn": 8103242230,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103242230,
    "dropfax": 8103242008
  },
  {
    "dcode": "D",
    "dropkey": "PY11390",
    "droptype": "D",
    "dropname": "BAD AXE",
    "dropdeladd": "133 N HANSELMAN ST",
    "dropdelcty": "BAD AXE",
    "dropdelst": "MI",
    "dropdelzpp": 484139998,
    "dropphyadd": "133 N HANSELMAN ST",
    "dropphycty": "BAD AXE",
    "dropphyst": "MI",
    "dropphyzpp": 484139998,
    "dropmaladd": "133 N HANSELMAN ST",
    "dropmalcty": "BAD AXE",
    "dropmalst": "MI",
    "dropmalzpp": 484139998,
    "dropsitphn": 9892697251,
    "dropsitlph": 8102571580,
    "dropsitcph": 9892697251,
    "dropfax": 9892692511
  },
  {
    "dcode": "D",
    "dropkey": "PY11391",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "17586 BAILEY RD",
    "dropdelcty": "BAILEY",
    "dropdelst": "MI",
    "dropdelzpp": 493039772,
    "dropphyadd": "17586 BAILEY RD",
    "dropphycty": "BAILEY",
    "dropphyst": "MI",
    "dropphyzpp": 493039772,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAILEY",
    "dropmalst": "MI",
    "dropmalzpp": 493039998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318347536,
    "dropsitcph": 2318347536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11392",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "513 MICHIGAN AVE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "MI",
    "dropdelzpp": 493047992,
    "dropphyadd": "513 MICHIGAN AVE",
    "dropphycty": "BALDWIN",
    "dropphyst": "MI",
    "dropphyzpp": 493047992,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN",
    "dropmalst": "MI",
    "dropmalzpp": 493049998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317454941,
    "dropsitcph": 2317454941,
    "dropfax": 2317458008
  },
  {
    "dcode": "D",
    "dropkey": "PY11393",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "BANCROFT",
    "dropdelst": "MI",
    "dropdelzpp": 484149998,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "BANCROFT",
    "dropphyst": "MI",
    "dropphyzpp": 484149998,
    "dropmaladd": "130 N MAIN ST",
    "dropmalcty": "BANCROFT",
    "dropmalst": "MI",
    "dropmalzpp": 484149998,
    "dropsitphn": 9896349161,
    "dropsitlph": 8102571580,
    "dropsitcph": 9896349161,
    "dropfax": 9896349315
  },
  {
    "dcode": "D",
    "dropkey": "PY11395",
    "droptype": "D",
    "dropname": "BANGOR",
    "dropdeladd": "538 RAILROAD ST",
    "dropdelcty": "BANGOR",
    "dropdelst": "MI",
    "dropdelzpp": 490131465,
    "dropphyadd": "538 RAILROAD ST",
    "dropphycty": "BANGOR",
    "dropphyst": "MI",
    "dropphyzpp": 490131465,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANGOR",
    "dropmalst": "MI",
    "dropmalzpp": 490139998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694278201,
    "dropsitcph": 2694278201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11396",
    "droptype": "D",
    "dropname": "BANNISTER",
    "dropdeladd": "395 E MAIN ST",
    "dropdelcty": "BANNISTER",
    "dropdelst": "MI",
    "dropdelzpp": 488079800,
    "dropphyadd": "395 E MAIN ST",
    "dropphycty": "BANNISTER",
    "dropphyst": "MI",
    "dropphyzpp": 488079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANNISTER",
    "dropmalst": "MI",
    "dropmalzpp": 488079998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898624605,
    "dropsitcph": 9898624605,
    "dropfax": 9898624605
  },
  {
    "dcode": "D",
    "dropkey": "PY11397",
    "droptype": "D",
    "dropname": "BARAGA",
    "dropdeladd": "404 US HIGHWAY 41 N",
    "dropdelcty": "BARAGA",
    "dropdelst": "MI",
    "dropdelzpp": 499089628,
    "dropphyadd": "404 US HIGHWAY 41 N",
    "dropphycty": "BARAGA",
    "dropphyst": "MI",
    "dropphyzpp": 499089628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARAGA",
    "dropmalst": "MI",
    "dropmalzpp": 499089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063536198,
    "dropsitcph": 9063536198,
    "dropfax": 9063537504
  },
  {
    "dcode": "D",
    "dropkey": "PY11398",
    "droptype": "D",
    "dropname": "BARBEAU",
    "dropdeladd": "15005 S RIVERSIDE DR",
    "dropdelcty": "BARBEAU",
    "dropdelst": "MI",
    "dropdelzpp": 497109800,
    "dropphyadd": "15005 S RIVERSIDE DR",
    "dropphycty": "BARBEAU",
    "dropphyst": "MI",
    "dropphyzpp": 497109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARBEAU",
    "dropmalst": "MI",
    "dropmalzpp": 497109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066322954,
    "dropsitcph": 9066322954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11399",
    "droptype": "D",
    "dropname": "BARK RIVER",
    "dropdeladd": "1316 OLD HIGHWAY 2 41",
    "dropdelcty": "BARK RIVER",
    "dropdelst": "MI",
    "dropdelzpp": 498079501,
    "dropphyadd": "1316 OLD HIGHWAY 2 41",
    "dropphycty": "BARK RIVER",
    "dropphyst": "MI",
    "dropphyzpp": 498079501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARK RIVER",
    "dropmalst": "MI",
    "dropmalzpp": 498079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064669942,
    "dropsitcph": 9064669942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11400",
    "droptype": "D",
    "dropname": "BARODA",
    "dropdeladd": "1368 SOUTH ST",
    "dropdelcty": "BARODA",
    "dropdelst": "MI",
    "dropdelzpp": 491019800,
    "dropphyadd": "1368 SOUTH ST",
    "dropphycty": "BARODA",
    "dropphyst": "MI",
    "dropphyzpp": 491019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARODA",
    "dropmalst": "MI",
    "dropmalzpp": 491019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694221888,
    "dropsitcph": 2694221888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11401",
    "droptype": "D",
    "dropname": "BARRYTON",
    "dropdeladd": "151 E NORTHERN AVE",
    "dropdelcty": "BARRYTON",
    "dropdelst": "MI",
    "dropdelzpp": 493055117,
    "dropphyadd": "151 E NORTHERN AVE",
    "dropphycty": "BARRYTON",
    "dropphyst": "MI",
    "dropphyzpp": 493055117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARRYTON",
    "dropmalst": "MI",
    "dropmalzpp": 493059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893825520,
    "dropsitcph": 9893825520,
    "dropfax": 6163829035
  },
  {
    "dcode": "D",
    "dropkey": "PY11402",
    "droptype": "D",
    "dropname": "BARTON CITY",
    "dropdeladd": "1011 N MONTANA RD",
    "dropdelcty": "BARTON CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487059705,
    "dropphyadd": "1011 N MONTANA RD",
    "dropphycty": "BARTON CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487059705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARTON CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897366188,
    "dropsitcph": 9897366188,
    "dropfax": 9897366188
  },
  {
    "dcode": "D",
    "dropkey": "PY11405",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "14137 WEBSTER RD",
    "dropdelcty": "BATH",
    "dropdelst": "MI",
    "dropdelzpp": 488088745,
    "dropphyadd": "14137 WEBSTER RD",
    "dropphycty": "BATH",
    "dropphyst": "MI",
    "dropphyzpp": 488088745,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BATH",
    "dropmalst": "MI",
    "dropmalzpp": 488089998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176416365,
    "dropsitcph": 5176416365,
    "dropfax": 5176417012
  },
  {
    "dcode": "D",
    "dropkey": "PY11406",
    "droptype": "D",
    "dropname": "BATTLE CREEK",
    "dropdeladd": "90 MCCAMLY ST S",
    "dropdelcty": "BATTLE CREEK",
    "dropdelst": "MI",
    "dropdelzpp": 490169000,
    "dropphyadd": "90 MCCAMLY ST S",
    "dropphycty": "BATTLE CREEK",
    "dropphyst": "MI",
    "dropphyzpp": 490169000,
    "dropmaladd": "90 MCCAMLY ST S",
    "dropmalcty": "BATTLE CREEK",
    "dropmalst": "MI",
    "dropmalzpp": 490169000,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699653286,
    "dropsitcph": 2699653286,
    "dropfax": 2699653287
  },
  {
    "dcode": "D",
    "dropkey": "PY11408",
    "droptype": "D",
    "dropname": "BAY CITY",
    "dropdeladd": "1000 WASHINGTON AVE",
    "dropdelcty": "BAY CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487089998,
    "dropphyadd": "1000 WASHINGTON AVE",
    "dropphycty": "BAY CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487089998,
    "dropmaladd": "1000 WASHINGTON AVE",
    "dropmalcty": "BAY CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487089998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715727,
    "dropsitcph": 9898955555,
    "dropfax": 9898959612
  },
  {
    "dcode": "D",
    "dropkey": "PY11410",
    "droptype": "D",
    "dropname": "BAY PORT",
    "dropdeladd": "805 PROMENADE ST",
    "dropdelcty": "BAY PORT",
    "dropdelst": "MI",
    "dropdelzpp": 487209781,
    "dropphyadd": "805 PROMENADE ST",
    "dropphycty": "BAY PORT",
    "dropphyst": "MI",
    "dropphyzpp": 487209781,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY PORT",
    "dropmalst": "MI",
    "dropmalzpp": 487209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896563951,
    "dropsitcph": 9896563951,
    "dropfax": 9896560338
  },
  {
    "dcode": "D",
    "dropkey": "PY11413",
    "droptype": "D",
    "dropname": "BEAR LAKE",
    "dropdeladd": "7777 MAIN ST",
    "dropdelcty": "BEAR LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 496145123,
    "dropphyadd": "7777 MAIN ST",
    "dropphycty": "BEAR LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 496145123,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAR LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 496149998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318643121,
    "dropsitcph": 2318643121,
    "dropfax": 6168643121
  },
  {
    "dcode": "D",
    "dropkey": "PY11416",
    "droptype": "D",
    "dropname": "BEAVER ISLAND",
    "dropdeladd": "26135 MAIN ST",
    "dropdelcty": "BEAVER ISLAND",
    "dropdelst": "MI",
    "dropdelzpp": 497825106,
    "dropphyadd": "26135 MAIN ST",
    "dropphycty": "BEAVER ISLAND",
    "dropphyst": "MI",
    "dropphyzpp": 497825106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER ISLAND",
    "dropmalst": "MI",
    "dropmalzpp": 497829998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2314482251,
    "dropsitcph": 2314482251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11417",
    "droptype": "D",
    "dropname": "BEAVERTON",
    "dropdeladd": "362 N ROSS ST",
    "dropdelcty": "BEAVERTON",
    "dropdelst": "MI",
    "dropdelzpp": 486128165,
    "dropphyadd": "362 N ROSS ST",
    "dropphycty": "BEAVERTON",
    "dropphyst": "MI",
    "dropphyzpp": 486128165,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVERTON",
    "dropmalst": "MI",
    "dropmalzpp": 486129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894359386,
    "dropsitcph": 9894359386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11419",
    "droptype": "D",
    "dropname": "BEDFORD",
    "dropdeladd": "22115 BEDFORD RD",
    "dropdelcty": "BEDFORD",
    "dropdelst": "MI",
    "dropdelzpp": 490209800,
    "dropphyadd": "22115 BEDFORD RD",
    "dropphycty": "BEDFORD",
    "dropphyst": "MI",
    "dropphyzpp": 490209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEDFORD",
    "dropmalst": "MI",
    "dropmalzpp": 490209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699658969,
    "dropsitcph": 2699658969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11423",
    "droptype": "D",
    "dropname": "BELDING",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "BELDING",
    "dropdelst": "MI",
    "dropdelzpp": 488099998,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "BELDING",
    "dropphyst": "MI",
    "dropphyzpp": 488099998,
    "dropmaladd": "201 E MAIN ST",
    "dropmalcty": "BELDING",
    "dropmalst": "MI",
    "dropmalzpp": 488099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167940230,
    "dropsitcph": 6167940230,
    "dropfax": 6167942099
  },
  {
    "dcode": "D",
    "dropkey": "PY11424",
    "droptype": "D",
    "dropname": "BELLAIRE",
    "dropdeladd": "110 N BRIDGE ST",
    "dropdelcty": "BELLAIRE",
    "dropdelst": "MI",
    "dropdelzpp": 496155105,
    "dropphyadd": "110 N BRIDGE ST",
    "dropphycty": "BELLAIRE",
    "dropphyst": "MI",
    "dropphyzpp": 496155105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLAIRE",
    "dropmalst": "MI",
    "dropmalzpp": 496159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315338714,
    "dropsitcph": 2315338714,
    "dropfax": 2315336632
  },
  {
    "dcode": "D",
    "dropkey": "PY11425",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "45601 S INTERSTATE 94 SERVICE DR",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 481119998,
    "dropphyadd": "45601 S INTERSTATE 94 SERVICE DR",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 481119998,
    "dropmaladd": "45601 S INTERSTATE 94 SERVICE DR",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 481119998,
    "dropsitphn": 7346970047,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346970047,
    "dropfax": 7346978428
  },
  {
    "dcode": "D",
    "dropkey": "PY11426",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "MI",
    "dropdelzpp": 490219998,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "MI",
    "dropphyzpp": 490219998,
    "dropmaladd": "202 N MAIN ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "MI",
    "dropmalzpp": 490219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697639291,
    "dropsitcph": 2697639291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11428",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "6220 BELMONT AVE NE",
    "dropdelcty": "BELMONT",
    "dropdelst": "MI",
    "dropdelzpp": 493069910,
    "dropphyadd": "6220 BELMONT AVE NE",
    "dropphycty": "BELMONT",
    "dropphyst": "MI",
    "dropphyzpp": 493069910,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELMONT",
    "dropmalst": "MI",
    "dropmalzpp": 493069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163611120,
    "dropsitcph": 6163611120,
    "dropfax": 6163631976
  },
  {
    "dcode": "D",
    "dropkey": "PY11430",
    "droptype": "D",
    "dropname": "BENTON HARBOR",
    "dropdeladd": "525 RIVERVIEW DR",
    "dropdelcty": "BENTON HARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 490225073,
    "dropphyadd": "525 RIVERVIEW DR",
    "dropphycty": "BENTON HARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 490225073,
    "dropmaladd": "525 RIVERVIEW DR",
    "dropmalcty": "BENTON HARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 490225073,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699268227,
    "dropsitcph": 2699268227,
    "dropfax": 2699262471
  },
  {
    "dcode": "D",
    "dropkey": "PY11432",
    "droptype": "D",
    "dropname": "BENZONIA",
    "dropdeladd": "1035 MICHIGAN AVE",
    "dropdelcty": "BENZONIA",
    "dropdelst": "MI",
    "dropdelzpp": 496169800,
    "dropphyadd": "1035 MICHIGAN AVE",
    "dropphycty": "BENZONIA",
    "dropphyst": "MI",
    "dropphyzpp": 496169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENZONIA",
    "dropmalst": "MI",
    "dropmalzpp": 496169998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318824683,
    "dropsitcph": 2318824683,
    "dropfax": 2318827963
  },
  {
    "dcode": "D",
    "dropkey": "PY11433",
    "droptype": "D",
    "dropname": "BERGLAND",
    "dropdeladd": "107 PINE ST",
    "dropdelcty": "BERGLAND",
    "dropdelst": "MI",
    "dropdelzpp": 499109500,
    "dropphyadd": "107 PINE ST",
    "dropphycty": "BERGLAND",
    "dropphyst": "MI",
    "dropphyzpp": 499109500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERGLAND",
    "dropmalst": "MI",
    "dropmalzpp": 499109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065753516,
    "dropsitcph": 9065753516,
    "dropfax": 9065753238
  },
  {
    "dcode": "D",
    "dropkey": "PY11442",
    "droptype": "D",
    "dropname": "BERRIEN SPRINGS",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "BERRIEN SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 491039998,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "BERRIEN SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 491039998,
    "dropmaladd": "115 N MAIN ST",
    "dropmalcty": "BERRIEN SPRINGS",
    "dropmalst": "MI",
    "dropmalzpp": 491039998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694733031,
    "dropsitcph": 2694733031,
    "dropfax": 2694732325
  },
  {
    "dcode": "D",
    "dropkey": "PY11444",
    "droptype": "D",
    "dropname": "BESSEMER",
    "dropdeladd": "212 S SOPHIE ST",
    "dropdelcty": "BESSEMER",
    "dropdelst": "MI",
    "dropdelzpp": 499119998,
    "dropphyadd": "212 S SOPHIE ST",
    "dropphycty": "BESSEMER",
    "dropphyst": "MI",
    "dropphyzpp": 499119998,
    "dropmaladd": "212 S SOPHIE ST",
    "dropmalcty": "BESSEMER",
    "dropmalst": "MI",
    "dropmalzpp": 499119998,
    "dropsitphn": 4142912520,
    "dropsitlph": 9066670844,
    "dropsitcph": 9066670844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11446",
    "droptype": "D",
    "dropname": "BEULAH",
    "dropdeladd": "246 S BENZIE BLVD",
    "dropdelcty": "BEULAH",
    "dropdelst": "MI",
    "dropdelzpp": 496179412,
    "dropphyadd": "246 S BENZIE BLVD",
    "dropphycty": "BEULAH",
    "dropphyst": "MI",
    "dropphyzpp": 496179412,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEULAH",
    "dropmalst": "MI",
    "dropmalzpp": 496179998,
    "dropsitphn": 2318824683,
    "dropsitlph": 2318825588,
    "dropsitcph": 2318825588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11449",
    "droptype": "D",
    "dropname": "BIG BAY",
    "dropdeladd": "505 HOFFMAN ST",
    "dropdelcty": "BIG BAY",
    "dropdelst": "MI",
    "dropdelzpp": 498089800,
    "dropphyadd": "505 HOFFMAN ST",
    "dropphycty": "BIG BAY",
    "dropphyst": "MI",
    "dropphyzpp": 498089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG BAY",
    "dropmalst": "MI",
    "dropmalzpp": 498089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063459335,
    "dropsitcph": 9063459335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11450",
    "droptype": "D",
    "dropname": "BIG RAPIDS",
    "dropdeladd": "301 MAPLE ST",
    "dropdelcty": "BIG RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 493079998,
    "dropphyadd": "301 MAPLE ST",
    "dropphycty": "BIG RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 493079998,
    "dropmaladd": "301 MAPLE ST",
    "dropmalcty": "BIG RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 493079998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317966433,
    "dropsitcph": 2315921498,
    "dropfax": 2317960474
  },
  {
    "dcode": "D",
    "dropkey": "PY11453",
    "droptype": "D",
    "dropname": "BIRCH RUN",
    "dropdeladd": "8196 MAIN ST",
    "dropdelcty": "BIRCH RUN",
    "dropdelst": "MI",
    "dropdelzpp": 484159998,
    "dropphyadd": "8196 MAIN ST",
    "dropphycty": "BIRCH RUN",
    "dropphyst": "MI",
    "dropphyzpp": 484159998,
    "dropmaladd": "8196 MAIN ST",
    "dropmalcty": "BIRCH RUN",
    "dropmalst": "MI",
    "dropmalzpp": 484159998,
    "dropsitphn": 9896245324,
    "dropsitlph": 8102571580,
    "dropsitcph": 9896245324,
    "dropfax": 9896240118
  },
  {
    "dcode": "D",
    "dropkey": "PY11454",
    "droptype": "D",
    "dropname": "BIRMINGHAM",
    "dropdeladd": "1221 BOWERS ST",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "MI",
    "dropdelzpp": 480129998,
    "dropphyadd": "1221 BOWERS ST",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "MI",
    "dropphyzpp": 480129998,
    "dropmaladd": "1221 BOWERS ST",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "MI",
    "dropmalzpp": 480129998,
    "dropsitphn": 2486460723,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486460723,
    "dropfax": 2484338880
  },
  {
    "dcode": "D",
    "dropkey": "PY11456",
    "droptype": "D",
    "dropname": "BITELY",
    "dropdeladd": "10647 N BINGHAM AVE",
    "dropdelcty": "BITELY",
    "dropdelst": "MI",
    "dropdelzpp": 493099264,
    "dropphyadd": "10647 N BINGHAM AVE",
    "dropphycty": "BITELY",
    "dropphyst": "MI",
    "dropphyzpp": 493099264,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BITELY",
    "dropmalst": "MI",
    "dropmalzpp": 493099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317454134,
    "dropsitcph": 2317454134,
    "dropfax": 2317454134
  },
  {
    "dcode": "D",
    "dropkey": "PY11458",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "420 MAIN ST",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "MI",
    "dropdelzpp": 493109120,
    "dropphyadd": "420 MAIN ST",
    "dropphycty": "BLANCHARD",
    "dropphyst": "MI",
    "dropphyzpp": 493109120,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "MI",
    "dropmalzpp": 493109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895612380,
    "dropsitcph": 9895612380,
    "dropfax": 2695612380
  },
  {
    "dcode": "D",
    "dropkey": "PY11460",
    "droptype": "D",
    "dropname": "BLISSFIELD",
    "dropdeladd": "302 S LANE ST",
    "dropdelcty": "BLISSFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 492289998,
    "dropphyadd": "302 S LANE ST",
    "dropphycty": "BLISSFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 492289998,
    "dropmaladd": "302 S LANE ST",
    "dropmalcty": "BLISSFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 492289998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174864735,
    "dropfax": 5174863657
  },
  {
    "dcode": "D",
    "dropkey": "PY11463",
    "droptype": "D",
    "dropname": "BLOOMFIELD HILLS",
    "dropdeladd": "2050 SOUTH BLVD",
    "dropdelcty": "BLOOMFIELD HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483049998,
    "dropphyadd": "2050 SOUTH BLVD",
    "dropphycty": "BLOOMFIELD HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483049998,
    "dropmaladd": "2050 SOUTH BLVD",
    "dropmalcty": "BLOOMFIELD HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483049998,
    "dropsitphn": 2483323981,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483323981,
    "dropfax": 2486426105
  },
  {
    "dcode": "D",
    "dropkey": "PY11469",
    "droptype": "D",
    "dropname": "BLOOMINGDALE",
    "dropdeladd": "110 CHESTNUT ST",
    "dropdelcty": "BLOOMINGDALE",
    "dropdelst": "MI",
    "dropdelzpp": 490265112,
    "dropphyadd": "110 CHESTNUT ST",
    "dropphycty": "BLOOMINGDALE",
    "dropphyst": "MI",
    "dropphyzpp": 490265112,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGDALE",
    "dropmalst": "MI",
    "dropmalzpp": 490269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2695217706,
    "dropsitcph": 2695217706,
    "dropfax": 2692222090
  },
  {
    "dcode": "D",
    "dropkey": "PY11472",
    "droptype": "D",
    "dropname": "BOON",
    "dropdeladd": "209 S HASKINS RD",
    "dropdelcty": "BOON",
    "dropdelst": "MI",
    "dropdelzpp": 496189663,
    "dropphyadd": "209 S HASKINS RD",
    "dropphycty": "BOON",
    "dropphyst": "MI",
    "dropphyzpp": 496189663,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOON",
    "dropmalst": "MI",
    "dropmalzpp": 496189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317753991,
    "dropsitcph": 2317753991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11474",
    "droptype": "D",
    "dropname": "BOYNE CITY",
    "dropdeladd": "301 WATER ST",
    "dropdelcty": "BOYNE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 497129998,
    "dropphyadd": "301 WATER ST",
    "dropphycty": "BOYNE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 497129998,
    "dropmaladd": "301 WATER ST",
    "dropmalcty": "BOYNE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 497129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315829941,
    "dropsitcph": 2315829941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11475",
    "droptype": "D",
    "dropname": "BOYNE FALLS",
    "dropdeladd": "2543 CENTER ST",
    "dropdelcty": "BOYNE FALLS",
    "dropdelst": "MI",
    "dropdelzpp": 497135104,
    "dropphyadd": "2543 CENTER ST",
    "dropphycty": "BOYNE FALLS",
    "dropphyst": "MI",
    "dropphyzpp": 497135104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYNE FALLS",
    "dropmalst": "MI",
    "dropmalzpp": 497139998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315492550,
    "dropsitcph": 2315492550,
    "dropfax": 2315492550
  },
  {
    "dcode": "D",
    "dropkey": "PY11492",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "2910 10TH ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "MI",
    "dropdelzpp": 493119800,
    "dropphyadd": "2910 10TH ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "MI",
    "dropphyzpp": 493119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADLEY",
    "dropmalst": "MI",
    "dropmalzpp": 493119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697929647,
    "dropsitcph": 2697929647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11494",
    "droptype": "D",
    "dropname": "BRANCH",
    "dropdeladd": "11952 W US HIGHWAY 10",
    "dropdelcty": "BRANCH",
    "dropdelst": "MI",
    "dropdelzpp": 494025100,
    "dropphyadd": "11952 W US HIGHWAY 10",
    "dropphycty": "BRANCH",
    "dropphyst": "MI",
    "dropphyzpp": 494025100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANCH",
    "dropmalst": "MI",
    "dropmalzpp": 494029998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318982311,
    "dropsitcph": 2318982311,
    "dropfax": 2318982311
  },
  {
    "dcode": "D",
    "dropkey": "PY11498",
    "droptype": "D",
    "dropname": "BRECKENRIDGE",
    "dropdeladd": "307 E SAGINAW ST",
    "dropdelcty": "BRECKENRIDGE",
    "dropdelst": "MI",
    "dropdelzpp": 486152506,
    "dropphyadd": "307 E SAGINAW ST",
    "dropphycty": "BRECKENRIDGE",
    "dropphyst": "MI",
    "dropphyzpp": 486152506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRECKENRIDGE",
    "dropmalst": "MI",
    "dropmalzpp": 486159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898423414,
    "dropsitcph": 9898423414,
    "dropfax": 9898429097
  },
  {
    "dcode": "D",
    "dropkey": "PY11499",
    "droptype": "D",
    "dropname": "BREEDSVILLE",
    "dropdeladd": "18 E MAIN ST",
    "dropdelcty": "BREEDSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 490279800,
    "dropphyadd": "18 E MAIN ST",
    "dropphycty": "BREEDSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 490279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BREEDSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 490279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694277762,
    "dropsitcph": 2694277762,
    "dropfax": 2694279050
  },
  {
    "dcode": "D",
    "dropkey": "PY11501",
    "droptype": "D",
    "dropname": "BRETHREN",
    "dropdeladd": "14125 COATES HWY",
    "dropdelcty": "BRETHREN",
    "dropdelst": "MI",
    "dropdelzpp": 496195124,
    "dropphyadd": "14125 COATES HWY",
    "dropphycty": "BRETHREN",
    "dropphyst": "MI",
    "dropphyzpp": 496195124,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRETHREN",
    "dropmalst": "MI",
    "dropmalzpp": 496199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2314775320,
    "dropsitcph": 2314775320,
    "dropfax": 2314775320
  },
  {
    "dcode": "D",
    "dropkey": "PY11503",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "3760 STATE ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "MI",
    "dropdelzpp": 487225107,
    "dropphyadd": "3760 STATE ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "MI",
    "dropphyzpp": 487225107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "MI",
    "dropmalzpp": 487229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897775870,
    "dropsitcph": 9897775870,
    "dropfax": 9897775870
  },
  {
    "dcode": "D",
    "dropkey": "PY11507",
    "droptype": "D",
    "dropname": "BRIDGMAN",
    "dropdeladd": "9655 MAPLEWOOD AVE",
    "dropdelcty": "BRIDGMAN",
    "dropdelst": "MI",
    "dropdelzpp": 491069550,
    "dropphyadd": "9655 MAPLEWOOD AVE",
    "dropphycty": "BRIDGMAN",
    "dropphyst": "MI",
    "dropphyzpp": 491069550,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGMAN",
    "dropmalst": "MI",
    "dropmalzpp": 491069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694656116,
    "dropsitcph": 2694656116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11509",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "100 ORNDORF DR",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "MI",
    "dropdelzpp": 481169998,
    "dropphyadd": "100 ORNDORF DR",
    "dropphycty": "BRIGHTON",
    "dropphyst": "MI",
    "dropphyzpp": 481169998,
    "dropmaladd": "100 ORNDORF DR",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "MI",
    "dropmalzpp": 481169998,
    "dropsitphn": 3132268558,
    "dropsitlph": 8102291698,
    "dropsitcph": 8102291698,
    "dropfax": 8102294714
  },
  {
    "dcode": "D",
    "dropkey": "PY11511",
    "droptype": "D",
    "dropname": "BRIMLEY",
    "dropdeladd": "6981 S M 221",
    "dropdelcty": "BRIMLEY",
    "dropdelst": "MI",
    "dropdelzpp": 497158202,
    "dropphyadd": "6981 S M 221",
    "dropphycty": "BRIMLEY",
    "dropphyst": "MI",
    "dropphyzpp": 497158202,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIMLEY",
    "dropmalst": "MI",
    "dropmalzpp": 497159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9062483221,
    "dropsitcph": 9062483221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11512",
    "droptype": "D",
    "dropname": "BRITTON",
    "dropdeladd": "209 E CHICAGO BLVD",
    "dropdelcty": "BRITTON",
    "dropdelst": "MI",
    "dropdelzpp": 492299998,
    "dropphyadd": "209 E CHICAGO BLVD",
    "dropphycty": "BRITTON",
    "dropphyst": "MI",
    "dropphyzpp": 492299998,
    "dropmaladd": "209 E CHICAGO BLVD",
    "dropmalcty": "BRITTON",
    "dropmalst": "MI",
    "dropmalzpp": 492299998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174518547,
    "dropfax": 5174512029
  },
  {
    "dcode": "D",
    "dropkey": "PY11516",
    "droptype": "D",
    "dropname": "BROHMAN",
    "dropdeladd": "577 W LINCOLN ST",
    "dropdelcty": "BROHMAN",
    "dropdelst": "MI",
    "dropdelzpp": 493129800,
    "dropphyadd": "577 W LINCOLN ST",
    "dropphycty": "BROHMAN",
    "dropphyst": "MI",
    "dropphyzpp": 493129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROHMAN",
    "dropmalst": "MI",
    "dropmalzpp": 493129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316896036,
    "dropsitcph": 2316896036,
    "dropfax": 2316897466
  },
  {
    "dcode": "D",
    "dropkey": "PY11517",
    "droptype": "D",
    "dropname": "BRONSON",
    "dropdeladd": "220 E CHICAGO ST",
    "dropdelcty": "BRONSON",
    "dropdelst": "MI",
    "dropdelzpp": 490289998,
    "dropphyadd": "220 E CHICAGO ST",
    "dropphycty": "BRONSON",
    "dropphyst": "MI",
    "dropphyzpp": 490289998,
    "dropmaladd": "220 E CHICAGO ST",
    "dropmalcty": "BRONSON",
    "dropmalst": "MI",
    "dropmalzpp": 490289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173695135,
    "dropsitcph": 5173695135,
    "dropfax": 5173694832
  },
  {
    "dcode": "D",
    "dropkey": "PY11518",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "235 N MAIN ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "MI",
    "dropdelzpp": 492309998,
    "dropphyadd": "235 N MAIN ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "MI",
    "dropphyzpp": 492309998,
    "dropmaladd": "235 N MAIN ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "MI",
    "dropmalzpp": 492309998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175924209,
    "dropfax": 5175924230
  },
  {
    "dcode": "D",
    "dropkey": "PY11519",
    "droptype": "D",
    "dropname": "BROWN CITY",
    "dropdeladd": "4160 MAIN ST",
    "dropdelcty": "BROWN CITY",
    "dropdelst": "MI",
    "dropdelzpp": 484169998,
    "dropphyadd": "4160 MAIN ST",
    "dropphycty": "BROWN CITY",
    "dropphyst": "MI",
    "dropphyzpp": 484169998,
    "dropmaladd": "4160 MAIN ST",
    "dropmalcty": "BROWN CITY",
    "dropmalst": "MI",
    "dropmalzpp": 484169998,
    "dropsitphn": 8103462950,
    "dropsitlph": 8102571580,
    "dropsitcph": 8103462950,
    "dropfax": 8103462218
  },
  {
    "dcode": "D",
    "dropkey": "PY11536",
    "droptype": "D",
    "dropname": "BRUCE CROSSING",
    "dropdeladd": "13944 US HIGHWAY 45",
    "dropdelcty": "BRUCE CROSSING",
    "dropdelst": "MI",
    "dropdelzpp": 499129802,
    "dropphyadd": "13944 US HIGHWAY 45",
    "dropphycty": "BRUCE CROSSING",
    "dropphyst": "MI",
    "dropphyzpp": 499129802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUCE CROSSING",
    "dropmalst": "MI",
    "dropmalzpp": 499129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068273380,
    "dropsitcph": 9068273380,
    "dropfax": 9068273680
  },
  {
    "dcode": "D",
    "dropkey": "PY11542",
    "droptype": "D",
    "dropname": "BUCHANAN",
    "dropdeladd": "112 W FRONT ST",
    "dropdelcty": "BUCHANAN",
    "dropdelst": "MI",
    "dropdelzpp": 491079998,
    "dropphyadd": "112 W FRONT ST",
    "dropphycty": "BUCHANAN",
    "dropphyst": "MI",
    "dropphyzpp": 491079998,
    "dropmaladd": "112 W FRONT ST",
    "dropmalcty": "BUCHANAN",
    "dropmalst": "MI",
    "dropmalzpp": 491071281,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696955821,
    "dropsitcph": 2696955821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11543",
    "droptype": "D",
    "dropname": "BUCKLEY",
    "dropdeladd": "100 E WEXFORD AVE",
    "dropdelcty": "BUCKLEY",
    "dropdelst": "MI",
    "dropdelzpp": 496205107,
    "dropphyadd": "100 E WEXFORD AVE",
    "dropphycty": "BUCKLEY",
    "dropphyst": "MI",
    "dropphyzpp": 496205107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCKLEY",
    "dropmalst": "MI",
    "dropmalzpp": 496209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312693575,
    "dropsitcph": 2312693575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11546",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "119 N ELM ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 490299803,
    "dropphyadd": "119 N ELM ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 490299803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 490299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5177652927,
    "dropsitcph": 5177652927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11547",
    "droptype": "D",
    "dropname": "BURNIPS",
    "dropdeladd": "4273 30TH ST",
    "dropdelcty": "BURNIPS",
    "dropdelst": "MI",
    "dropdelzpp": 493149800,
    "dropphyadd": "4273 30TH ST",
    "dropphycty": "BURNIPS",
    "dropphyst": "MI",
    "dropphyzpp": 493149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNIPS",
    "dropmalst": "MI",
    "dropmalzpp": 493149998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168968286,
    "dropsitcph": 6168968286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11550",
    "droptype": "D",
    "dropname": "BURR OAK",
    "dropdeladd": "235 S 3RD ST",
    "dropdelcty": "BURR OAK",
    "dropdelst": "MI",
    "dropdelzpp": 490305114,
    "dropphyadd": "235 S 3RD ST",
    "dropphycty": "BURR OAK",
    "dropphyst": "MI",
    "dropphyzpp": 490305114,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURR OAK",
    "dropmalst": "MI",
    "dropmalzpp": 490309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694892896,
    "dropsitcph": 2694892896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11551",
    "droptype": "D",
    "dropname": "BURT",
    "dropdeladd": "12925 NICHOLS RD",
    "dropdelcty": "BURT",
    "dropdelst": "MI",
    "dropdelzpp": 484179998,
    "dropphyadd": "12925 NICHOLS RD",
    "dropphycty": "BURT",
    "dropphyst": "MI",
    "dropphyzpp": 484179998,
    "dropmaladd": "12925 NICHOLS RD",
    "dropmalcty": "BURT",
    "dropmalst": "MI",
    "dropmalzpp": 484179998,
    "dropsitphn": 9897704399,
    "dropsitlph": 8102571580,
    "dropsitcph": 9897704399,
    "dropfax": 9897705314
  },
  {
    "dcode": "D",
    "dropkey": "PY11552",
    "droptype": "D",
    "dropname": "BURT LAKE",
    "dropdeladd": "10501 E WEST RESORT RD",
    "dropdelcty": "BURT LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497179800,
    "dropphyadd": "10501 E WEST RESORT RD",
    "dropphycty": "BURT LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURT LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497179998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315482692,
    "dropsitcph": 2315482692,
    "dropfax": 2315483546
  },
  {
    "dcode": "D",
    "dropkey": "PY11559",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "203 S SAGINAW ST",
    "dropdelcty": "BYRON",
    "dropdelst": "MI",
    "dropdelzpp": 484189998,
    "dropphyadd": "203 S SAGINAW ST",
    "dropphycty": "BYRON",
    "dropphyst": "MI",
    "dropphyzpp": 484189998,
    "dropmaladd": "203 S SAGINAW ST",
    "dropmalcty": "BYRON",
    "dropmalst": "MI",
    "dropmalzpp": 484189998,
    "dropsitphn": 8102664562,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102664562,
    "dropfax": 8102664295
  },
  {
    "dcode": "D",
    "dropkey": "PY11560",
    "droptype": "D",
    "dropname": "BYRON CENTER",
    "dropdeladd": "8350 BYRON CENTER AVE SW",
    "dropdelcty": "BYRON CENTER",
    "dropdelst": "MI",
    "dropdelzpp": 493150167,
    "dropphyadd": "8350 BYRON CENTER AVE SW",
    "dropphycty": "BYRON CENTER",
    "dropphyst": "MI",
    "dropphyzpp": 493150167,
    "dropmaladd": "8350 BYRON CENTER AVE SW",
    "dropmalcty": "BYRON CENTER",
    "dropmalst": "MI",
    "dropmalzpp": 493150167,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168781796,
    "dropsitcph": 6168781796,
    "dropfax": 6168780710
  },
  {
    "dcode": "D",
    "dropkey": "PY11563",
    "droptype": "D",
    "dropname": "CADILLAC",
    "dropdeladd": "118 E HARRIS ST",
    "dropdelcty": "CADILLAC",
    "dropdelst": "MI",
    "dropdelzpp": 496019998,
    "dropphyadd": "118 E HARRIS ST",
    "dropphycty": "CADILLAC",
    "dropphyst": "MI",
    "dropphyzpp": 496019998,
    "dropmaladd": "118 E HARRIS ST",
    "dropmalcty": "CADILLAC",
    "dropmalst": "MI",
    "dropmalzpp": 496019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317756519,
    "dropsitcph": 2317756519,
    "dropfax": 2319427189
  },
  {
    "dcode": "D",
    "dropkey": "PY11565",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "9339 CHERRY VALLEY AVE SE",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "MI",
    "dropdelzpp": 493160090,
    "dropphyadd": "9339 CHERRY VALLEY AVE SE",
    "dropphycty": "CALEDONIA",
    "dropphyst": "MI",
    "dropphyzpp": 493160090,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "MI",
    "dropmalzpp": 493169998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168919524,
    "dropsitcph": 6168919524,
    "dropfax": 6168911401
  },
  {
    "dcode": "D",
    "dropkey": "PY11566",
    "droptype": "D",
    "dropname": "CALUMET",
    "dropdeladd": "201 6TH ST",
    "dropdelcty": "CALUMET",
    "dropdelst": "MI",
    "dropdelzpp": 499139998,
    "dropphyadd": "201 6TH ST",
    "dropphycty": "CALUMET",
    "dropphyst": "MI",
    "dropphyzpp": 499139998,
    "dropmaladd": "201 6TH ST",
    "dropmalcty": "CALUMET",
    "dropmalst": "MI",
    "dropmalzpp": 499139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063373210,
    "dropsitcph": 9063373210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11567",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "130 S MAIN ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "MI",
    "dropdelzpp": 492329998,
    "dropphyadd": "130 S MAIN ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "MI",
    "dropphyzpp": 492329998,
    "dropmaladd": "130 S MAIN ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "MI",
    "dropmalzpp": 492329998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5173685829,
    "dropfax": 5173685924
  },
  {
    "dcode": "D",
    "dropkey": "PY11573",
    "droptype": "D",
    "dropname": "CANNONSBURG",
    "dropdeladd": "7825 CANNONSBURG RD NE",
    "dropdelcty": "CANNONSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 493179800,
    "dropphyadd": "7825 CANNONSBURG RD NE",
    "dropphycty": "CANNONSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 493179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANNONSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 493179998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168748270,
    "dropsitcph": 6168748270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11576",
    "droptype": "D",
    "dropname": "CAPAC",
    "dropdeladd": "102 W MILL ST",
    "dropdelcty": "CAPAC",
    "dropdelst": "MI",
    "dropdelzpp": 480149998,
    "dropphyadd": "102 W MILL ST",
    "dropphycty": "CAPAC",
    "dropphyst": "MI",
    "dropphyzpp": 480149998,
    "dropmaladd": "102 W MILL ST",
    "dropmalcty": "CAPAC",
    "dropmalst": "MI",
    "dropmalzpp": 480149998,
    "dropsitphn": 8103957090,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103957090,
    "dropfax": 8103952371
  },
  {
    "dcode": "D",
    "dropkey": "PY11578",
    "droptype": "D",
    "dropname": "CARLETON",
    "dropdeladd": "12840 GRAFTON RD",
    "dropdelcty": "CARLETON",
    "dropdelst": "MI",
    "dropdelzpp": 481179998,
    "dropphyadd": "12840 GRAFTON RD",
    "dropphycty": "CARLETON",
    "dropphyst": "MI",
    "dropphyzpp": 481179998,
    "dropmaladd": "12840 GRAFTON RD",
    "dropmalcty": "CARLETON",
    "dropmalst": "MI",
    "dropmalzpp": 481179998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268544,
    "dropsitcph": 7346543656,
    "dropfax": 7346549280
  },
  {
    "dcode": "D",
    "dropkey": "PY11579",
    "droptype": "D",
    "dropname": "CARNEY",
    "dropdeladd": "211 N US HIGHWAY 41",
    "dropdelcty": "CARNEY",
    "dropdelst": "MI",
    "dropdelzpp": 498129756,
    "dropphyadd": "211 N US HIGHWAY 41",
    "dropphycty": "CARNEY",
    "dropphyst": "MI",
    "dropphyzpp": 498129756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARNEY",
    "dropmalst": "MI",
    "dropmalzpp": 498129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9066392127,
    "dropsitcph": 9066392127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11580",
    "droptype": "D",
    "dropname": "CARO",
    "dropdeladd": "210 W LINCOLN ST",
    "dropdelcty": "CARO",
    "dropdelst": "MI",
    "dropdelzpp": 487239998,
    "dropphyadd": "210 W LINCOLN ST",
    "dropphycty": "CARO",
    "dropphyst": "MI",
    "dropphyzpp": 487239998,
    "dropmaladd": "210 W LINCOLN ST",
    "dropmalcty": "CARO",
    "dropmalst": "MI",
    "dropmalzpp": 487239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896730066,
    "dropsitcph": 9896733104,
    "dropfax": 9896733972
  },
  {
    "dcode": "D",
    "dropkey": "PY11581",
    "droptype": "D",
    "dropname": "CARP LAKE",
    "dropdeladd": "6496 PARADISE TRL",
    "dropdelcty": "CARP LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497189400,
    "dropphyadd": "6496 PARADISE TRL",
    "dropphycty": "CARP LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497189400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARP LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315374645,
    "dropsitcph": 2315374645,
    "dropfax": 2315374958
  },
  {
    "dcode": "D",
    "dropkey": "PY11582",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "3510 N MADISON ST",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "MI",
    "dropdelzpp": 487245037,
    "dropphyadd": "3510 N MADISON ST",
    "dropphycty": "CARROLLTON",
    "dropphyst": "MI",
    "dropphyzpp": 487245037,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "MI",
    "dropmalzpp": 487249998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897556996,
    "dropsitcph": 9897556996,
    "dropfax": 9897556996
  },
  {
    "dcode": "D",
    "dropkey": "PY11583",
    "droptype": "D",
    "dropname": "CARSON CITY",
    "dropdeladd": "215 W MAIN ST",
    "dropdelcty": "CARSON CITY",
    "dropdelst": "MI",
    "dropdelzpp": 488119800,
    "dropphyadd": "215 W MAIN ST",
    "dropphycty": "CARSON CITY",
    "dropphyst": "MI",
    "dropphyzpp": 488119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARSON CITY",
    "dropmalst": "MI",
    "dropmalzpp": 488119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895843347,
    "dropsitcph": 9895843347,
    "dropfax": 9895843733
  },
  {
    "dcode": "D",
    "dropkey": "PY11584",
    "droptype": "D",
    "dropname": "CARSONVILLE",
    "dropdeladd": "77 S MAIN ST",
    "dropdelcty": "CARSONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484199998,
    "dropphyadd": "77 S MAIN ST",
    "dropphycty": "CARSONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484199998,
    "dropmaladd": "77 S MAIN ST",
    "dropmalcty": "CARSONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484199998,
    "dropsitphn": 8106579101,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106579101,
    "dropfax": 8106579273
  },
  {
    "dcode": "D",
    "dropkey": "PY11591",
    "droptype": "D",
    "dropname": "CASEVILLE",
    "dropdeladd": "7060 MAIN ST",
    "dropdelcty": "CASEVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487255112,
    "dropphyadd": "7060 MAIN ST",
    "dropphycty": "CASEVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487255112,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASEVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898562273,
    "dropsitcph": 9898562273,
    "dropfax": 9898562273
  },
  {
    "dcode": "D",
    "dropkey": "PY11592",
    "droptype": "D",
    "dropname": "CASNOVIA",
    "dropdeladd": "87 N MAIN ST",
    "dropdelcty": "CASNOVIA",
    "dropdelst": "MI",
    "dropdelzpp": 493188702,
    "dropphyadd": "87 N MAIN ST",
    "dropphycty": "CASNOVIA",
    "dropphyst": "MI",
    "dropphyzpp": 493188702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASNOVIA",
    "dropmalst": "MI",
    "dropmalzpp": 493189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166757041,
    "dropsitcph": 6166757041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11593",
    "droptype": "D",
    "dropname": "CASPIAN",
    "dropdeladd": "300 E CASPIAN AVE",
    "dropdelcty": "CASPIAN",
    "dropdelst": "MI",
    "dropdelzpp": 499159800,
    "dropphyadd": "300 E CASPIAN AVE",
    "dropphycty": "CASPIAN",
    "dropphyst": "MI",
    "dropphyzpp": 499159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASPIAN",
    "dropmalst": "MI",
    "dropmalzpp": 499159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062652683,
    "dropsitcph": 9062652683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11594",
    "droptype": "D",
    "dropname": "CASS CITY",
    "dropdeladd": "4544 SHERMAN ST",
    "dropdelcty": "CASS CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487261261,
    "dropphyadd": "4544 SHERMAN ST",
    "dropphycty": "CASS CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487261261,
    "dropmaladd": "4544 SHERMAN ST",
    "dropmalcty": "CASS CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487261261,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898722565,
    "dropsitcph": 9898722565,
    "dropfax": 9898722256
  },
  {
    "dcode": "D",
    "dropkey": "PY11595",
    "droptype": "D",
    "dropname": "CASSOPOLIS",
    "dropdeladd": "129 S ROWLAND ST",
    "dropdelcty": "CASSOPOLIS",
    "dropdelst": "MI",
    "dropdelzpp": 490319998,
    "dropphyadd": "129 S ROWLAND ST",
    "dropphycty": "CASSOPOLIS",
    "dropphyst": "MI",
    "dropphyzpp": 490319998,
    "dropmaladd": "129 S ROWLAND ST",
    "dropmalcty": "CASSOPOLIS",
    "dropmalst": "MI",
    "dropmalzpp": 490319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694458421,
    "dropsitcph": 2694458421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11598",
    "droptype": "D",
    "dropname": "CEDAR",
    "dropdeladd": "2989 E BELLINGER RD",
    "dropdelcty": "CEDAR",
    "dropdelst": "MI",
    "dropdelzpp": 496219648,
    "dropphyadd": "2989 E BELLINGER RD",
    "dropphycty": "CEDAR",
    "dropphyst": "MI",
    "dropphyzpp": 496219648,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR",
    "dropmalst": "MI",
    "dropmalzpp": 496219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312285367,
    "dropsitcph": 2312285367,
    "dropfax": 2312283467
  },
  {
    "dcode": "D",
    "dropkey": "PY11599",
    "droptype": "D",
    "dropname": "CEDAR LAKE",
    "dropdeladd": "7772 ACADEMY RD",
    "dropdelcty": "CEDAR LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 488129800,
    "dropphyadd": "7772 ACADEMY RD",
    "dropphycty": "CEDAR LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 488129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 488129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894273893,
    "dropsitcph": 9894273893,
    "dropfax": 9894273183
  },
  {
    "dcode": "D",
    "dropkey": "PY11602",
    "droptype": "D",
    "dropname": "CEDAR SPRINGS",
    "dropdeladd": "36 E CHERRY ST",
    "dropdelcty": "CEDAR SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 493195131,
    "dropphyadd": "36 E CHERRY ST",
    "dropphycty": "CEDAR SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 493195131,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR SPRINGS",
    "dropmalst": "MI",
    "dropmalzpp": 493199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166961230,
    "dropsitcph": 6166961230,
    "dropfax": 6166964140
  },
  {
    "dcode": "D",
    "dropkey": "PY11603",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "124 BEACH ST",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 497199800,
    "dropphyadd": "124 BEACH ST",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 497199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 497199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064843911,
    "dropsitcph": 9064843911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11604",
    "droptype": "D",
    "dropname": "CEMENT CITY",
    "dropdeladd": "227 MAIN ST",
    "dropdelcty": "CEMENT CITY",
    "dropdelst": "MI",
    "dropdelzpp": 492339998,
    "dropphyadd": "227 MAIN ST",
    "dropphycty": "CEMENT CITY",
    "dropphyst": "MI",
    "dropphyzpp": 492339998,
    "dropmaladd": "227 MAIN ST",
    "dropmalcty": "CEMENT CITY",
    "dropmalst": "MI",
    "dropmalzpp": 492339998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175925195,
    "dropfax": 5175924549
  },
  {
    "dcode": "D",
    "dropkey": "PY11607",
    "droptype": "D",
    "dropname": "CENTER LINE",
    "dropdeladd": "26056 VAN DYKE AVE",
    "dropdelcty": "CENTER LINE",
    "dropdelst": "MI",
    "dropdelzpp": 480159998,
    "dropphyadd": "26056 VAN DYKE AVE",
    "dropphycty": "CENTER LINE",
    "dropphyst": "MI",
    "dropphyzpp": 480159998,
    "dropmaladd": "26056 VAN DYKE AVE",
    "dropmalcty": "CENTER LINE",
    "dropmalst": "MI",
    "dropmalzpp": 480159998,
    "dropsitphn": 5865768960,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867576328,
    "dropfax": 5867572149
  },
  {
    "dcode": "D",
    "dropkey": "PY11609",
    "droptype": "D",
    "dropname": "CENTRAL LAKE",
    "dropdeladd": "7956 E STATE ST",
    "dropdelcty": "CENTRAL LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 496229803,
    "dropphyadd": "7956 E STATE ST",
    "dropphycty": "CENTRAL LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 496229803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 496229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315445100,
    "dropsitcph": 2315445100,
    "dropfax": 2315445100
  },
  {
    "dcode": "D",
    "dropkey": "PY11612",
    "droptype": "D",
    "dropname": "CENTREVILLE",
    "dropdeladd": "116 S CLARK ST",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 490329529,
    "dropphyadd": "116 S CLARK ST",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 490329529,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 490329998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694678185,
    "dropsitcph": 2694678185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11615",
    "droptype": "D",
    "dropname": "CERESCO",
    "dropdeladd": "150 MANSIE ST",
    "dropdelcty": "CERESCO",
    "dropdelst": "MI",
    "dropdelzpp": 490339793,
    "dropphyadd": "150 MANSIE ST",
    "dropphycty": "CERESCO",
    "dropphyst": "MI",
    "dropphyzpp": 490339793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CERESCO",
    "dropmalst": "MI",
    "dropmalzpp": 490339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699641956,
    "dropsitcph": 2699641956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11616",
    "droptype": "D",
    "dropname": "CHAMPION",
    "dropdeladd": "3953 US HIGHWAY 41 W",
    "dropdelcty": "CHAMPION",
    "dropdelst": "MI",
    "dropdelzpp": 498149490,
    "dropphyadd": "3953 US HIGHWAY 41 W",
    "dropphycty": "CHAMPION",
    "dropphyst": "MI",
    "dropphyzpp": 498149490,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMPION",
    "dropmalst": "MI",
    "dropmalzpp": 498149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063392190,
    "dropsitcph": 9063392190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11617",
    "droptype": "D",
    "dropname": "CHANNING",
    "dropdeladd": "601 RAILROAD AVE",
    "dropdelcty": "CHANNING",
    "dropdelst": "MI",
    "dropdelzpp": 498159755,
    "dropphyadd": "601 RAILROAD AVE",
    "dropphycty": "CHANNING",
    "dropphyst": "MI",
    "dropphyzpp": 498159755,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANNING",
    "dropmalst": "MI",
    "dropmalzpp": 498159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065423203,
    "dropsitcph": 9065423203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11618",
    "droptype": "D",
    "dropname": "CHARLEVOIX",
    "dropdeladd": "6700 M 66 N",
    "dropdelcty": "CHARLEVOIX",
    "dropdelst": "MI",
    "dropdelzpp": 497209623,
    "dropphyadd": "6700 M 66 N",
    "dropphycty": "CHARLEVOIX",
    "dropphyst": "MI",
    "dropphyzpp": 497209623,
    "dropmaladd": "6700 M 66 N",
    "dropmalcty": "CHARLEVOIX",
    "dropmalst": "MI",
    "dropmalzpp": 497209623,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315472631,
    "dropsitcph": 2315472631,
    "dropfax": 2315475566
  },
  {
    "dcode": "D",
    "dropkey": "PY11619",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "117 W LOVETT ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "MI",
    "dropdelzpp": 488139998,
    "dropphyadd": "117 W LOVETT ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "MI",
    "dropphyzpp": 488139998,
    "dropmaladd": "117 W LOVETT ST",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "MI",
    "dropmalzpp": 488139998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5175430170,
    "dropsitcph": 5175430170,
    "dropfax": 5175432141
  },
  {
    "dcode": "D",
    "dropkey": "PY11620",
    "droptype": "D",
    "dropname": "CHASE",
    "dropdeladd": "6958 S DEPOT ST",
    "dropdelcty": "CHASE",
    "dropdelst": "MI",
    "dropdelzpp": 496239800,
    "dropphyadd": "6958 S DEPOT ST",
    "dropphycty": "CHASE",
    "dropphyst": "MI",
    "dropphyzpp": 496239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHASE",
    "dropmalst": "MI",
    "dropmalzpp": 496239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318322942,
    "dropsitcph": 2318322942,
    "dropfax": 2318328912
  },
  {
    "dcode": "D",
    "dropkey": "PY11621",
    "droptype": "D",
    "dropname": "CHASSELL",
    "dropdeladd": "41951 WILSON MEMORIAL DR",
    "dropdelcty": "CHASSELL",
    "dropdelst": "MI",
    "dropdelzpp": 499169021,
    "dropphyadd": "41951 WILSON MEMORIAL DR",
    "dropphycty": "CHASSELL",
    "dropphyst": "MI",
    "dropphyzpp": 499169021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHASSELL",
    "dropmalst": "MI",
    "dropmalzpp": 499169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065234294,
    "dropsitcph": 9065234294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11622",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "E3735 MUNISING ST",
    "dropdelcty": "CHATHAM",
    "dropdelst": "MI",
    "dropdelzpp": 498169679,
    "dropphyadd": "E3735 MUNISING ST",
    "dropphycty": "CHATHAM",
    "dropphyst": "MI",
    "dropphyzpp": 498169679,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHATHAM",
    "dropmalst": "MI",
    "dropmalzpp": 498169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064395110,
    "dropsitcph": 9064395110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11623",
    "droptype": "D",
    "dropname": "CHEBOYGAN",
    "dropdeladd": "200 N MAIN ST",
    "dropdelcty": "CHEBOYGAN",
    "dropdelst": "MI",
    "dropdelzpp": 497219998,
    "dropphyadd": "200 N MAIN ST",
    "dropphycty": "CHEBOYGAN",
    "dropphyst": "MI",
    "dropphyzpp": 497219998,
    "dropmaladd": "200 N MAIN ST",
    "dropmalcty": "CHEBOYGAN",
    "dropmalst": "MI",
    "dropmalzpp": 497219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316279898,
    "dropsitcph": 2316279898,
    "dropfax": 2316271705
  },
  {
    "dcode": "D",
    "dropkey": "PY11624",
    "droptype": "D",
    "dropname": "CHELSEA",
    "dropdeladd": "1101 S MAIN ST STE 100",
    "dropdelcty": "CHELSEA",
    "dropdelst": "MI",
    "dropdelzpp": 481181642,
    "dropphyadd": "1101 S MAIN ST STE 100",
    "dropphycty": "CHELSEA",
    "dropphyst": "MI",
    "dropphyzpp": 481181642,
    "dropmaladd": "1101 S MAIN ST STE 100",
    "dropmalcty": "CHELSEA",
    "dropmalst": "MI",
    "dropmalzpp": 481181642,
    "dropsitphn": 7344758483,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344758483,
    "dropfax": 7344756314
  },
  {
    "dcode": "D",
    "dropkey": "PY11625",
    "droptype": "D",
    "dropname": "CHESANING",
    "dropdeladd": "230 E BROAD ST",
    "dropdelcty": "CHESANING",
    "dropdelst": "MI",
    "dropdelzpp": 486161559,
    "dropphyadd": "230 E BROAD ST",
    "dropphycty": "CHESANING",
    "dropphyst": "MI",
    "dropphyzpp": 486161559,
    "dropmaladd": "230 E BROAD ST",
    "dropmalcty": "CHESANING",
    "dropmalst": "MI",
    "dropmalzpp": 486161559,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898453100,
    "dropsitcph": 9898453100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11634",
    "droptype": "D",
    "dropname": "CHIPPEWA LAKE",
    "dropdeladd": "10510 DWIGHT ST",
    "dropdelcty": "CHIPPEWA LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 493209800,
    "dropphyadd": "10510 DWIGHT ST",
    "dropphycty": "CHIPPEWA LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 493209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIPPEWA LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 493209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318673323,
    "dropsitcph": 2318673323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11641",
    "droptype": "D",
    "dropname": "CLARE",
    "dropdeladd": "111 W 5TH ST",
    "dropdelcty": "CLARE",
    "dropdelst": "MI",
    "dropdelzpp": 486171497,
    "dropphyadd": "111 W 5TH ST",
    "dropphycty": "CLARE",
    "dropphyst": "MI",
    "dropphyzpp": 486171497,
    "dropmaladd": "111 W 5TH ST",
    "dropmalcty": "CLARE",
    "dropmalst": "MI",
    "dropmalzpp": 486171497,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893867682,
    "dropsitcph": 9893867682,
    "dropfax": 9893863260
  },
  {
    "dcode": "D",
    "dropkey": "PY11642",
    "droptype": "D",
    "dropname": "CLARKLAKE",
    "dropdeladd": "208 HYDE RD",
    "dropdelcty": "CLARKLAKE",
    "dropdelst": "MI",
    "dropdelzpp": 492349998,
    "dropphyadd": "208 HYDE RD",
    "dropphycty": "CLARKLAKE",
    "dropphyst": "MI",
    "dropphyzpp": 492349998,
    "dropmaladd": "208 HYDE RD",
    "dropmalcty": "CLARKLAKE",
    "dropmalst": "MI",
    "dropmalzpp": 492349998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175294752,
    "dropfax": 5175294485
  },
  {
    "dcode": "D",
    "dropkey": "PY11643",
    "droptype": "D",
    "dropname": "CLARKSTON",
    "dropdeladd": "5799 S MAIN ST",
    "dropdelcty": "CLARKSTON",
    "dropdelst": "MI",
    "dropdelzpp": 483479998,
    "dropphyadd": "5799 S MAIN ST",
    "dropphycty": "CLARKSTON",
    "dropphyst": "MI",
    "dropphyzpp": 483479998,
    "dropmaladd": "5886 S MAIN ST",
    "dropmalcty": "CLARKSTON",
    "dropmalst": "MI",
    "dropmalzpp": 483469998,
    "dropsitphn": 2486250648,
    "dropsitlph": 2487585622,
    "dropsitcph": 2489221764,
    "dropfax": 2489229087
  },
  {
    "dcode": "D",
    "dropkey": "PY11644",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488159723,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488159723,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166932261,
    "dropsitcph": 6166932261,
    "dropfax": 6166932658
  },
  {
    "dcode": "D",
    "dropkey": "PY11645",
    "droptype": "D",
    "dropname": "CLAWSON",
    "dropdeladd": "345 N MAIN ST",
    "dropdelcty": "CLAWSON",
    "dropdelst": "MI",
    "dropdelzpp": 480179998,
    "dropphyadd": "345 N MAIN ST",
    "dropphycty": "CLAWSON",
    "dropphyst": "MI",
    "dropphyzpp": 480179998,
    "dropmaladd": "345 N MAIN ST",
    "dropmalcty": "CLAWSON",
    "dropmalst": "MI",
    "dropmalzpp": 480179998,
    "dropsitphn": 2484356037,
    "dropsitlph": 2487585622,
    "dropsitcph": 2484357947,
    "dropfax": 2484354080
  },
  {
    "dcode": "D",
    "dropkey": "PY11649",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "3409 STATE ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "MI",
    "dropdelzpp": 492359998,
    "dropphyadd": "3409 STATE ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "MI",
    "dropphyzpp": 492359998,
    "dropmaladd": "3409 STATE ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "MI",
    "dropmalzpp": 492359998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174452468,
    "dropfax": 5174452798
  },
  {
    "dcode": "D",
    "dropkey": "PY11650",
    "droptype": "D",
    "dropname": "CLIFFORD",
    "dropdeladd": "9581 MAIN ST",
    "dropdelcty": "CLIFFORD",
    "dropdelst": "MI",
    "dropdelzpp": 487275124,
    "dropphyadd": "9581 MAIN ST",
    "dropphycty": "CLIFFORD",
    "dropphyst": "MI",
    "dropphyzpp": 487275124,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIFFORD",
    "dropmalst": "MI",
    "dropmalzpp": 487279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897617040,
    "dropsitcph": 9897617040,
    "dropfax": 9897610128
  },
  {
    "dcode": "D",
    "dropkey": "PY11651",
    "droptype": "D",
    "dropname": "CLIMAX",
    "dropdeladd": "116 N MAIN ST",
    "dropdelcty": "CLIMAX",
    "dropdelst": "MI",
    "dropdelzpp": 490349637,
    "dropphyadd": "116 N MAIN ST",
    "dropphycty": "CLIMAX",
    "dropphyst": "MI",
    "dropphyzpp": 490349637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIMAX",
    "dropmalst": "MI",
    "dropmalzpp": 490349998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693535053,
    "dropsitcph": 2697464500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11652",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "123 E MICHIGAN AVE",
    "dropdelcty": "CLINTON",
    "dropdelst": "MI",
    "dropdelzpp": 492369998,
    "dropphyadd": "123 E MICHIGAN AVE",
    "dropphycty": "CLINTON",
    "dropphyst": "MI",
    "dropphyzpp": 492369998,
    "dropmaladd": "123 E MICHIGAN AVE",
    "dropmalcty": "CLINTON",
    "dropmalst": "MI",
    "dropmalzpp": 492369998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174567641,
    "dropfax": 5174564682
  },
  {
    "dcode": "D",
    "dropkey": "PY11656",
    "droptype": "D",
    "dropname": "CLIO",
    "dropdeladd": "800 S MILL ST",
    "dropdelcty": "CLIO",
    "dropdelst": "MI",
    "dropdelzpp": 484209998,
    "dropphyadd": "800 S MILL ST",
    "dropphycty": "CLIO",
    "dropphyst": "MI",
    "dropphyzpp": 484209998,
    "dropmaladd": "800 S MILL ST",
    "dropmalcty": "CLIO",
    "dropmalst": "MI",
    "dropmalzpp": 484209998,
    "dropsitphn": 8106860810,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106860810,
    "dropfax": 8106860673
  },
  {
    "dcode": "D",
    "dropkey": "PY11657",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "7560 S M 43 HWY",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "MI",
    "dropdelzpp": 490359800,
    "dropphyadd": "7560 S M 43 HWY",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "MI",
    "dropphyzpp": 490359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "MI",
    "dropmalzpp": 490359998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696238915,
    "dropsitcph": 2696238915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11663",
    "droptype": "D",
    "dropname": "COHOCTAH",
    "dropdeladd": "1477 W COHOCTAH RD",
    "dropdelcty": "COHOCTAH",
    "dropdelst": "MI",
    "dropdelzpp": 488165101,
    "dropphyadd": "1477 W COHOCTAH RD",
    "dropphycty": "COHOCTAH",
    "dropphyst": "MI",
    "dropphyzpp": 488165101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COHOCTAH",
    "dropmalst": "MI",
    "dropmalzpp": 488169998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5175465998,
    "dropsitcph": 5175465998,
    "dropfax": 5175461764
  },
  {
    "dcode": "D",
    "dropkey": "PY11664",
    "droptype": "D",
    "dropname": "COLDWATER",
    "dropdeladd": "100 W PEARL ST",
    "dropdelcty": "COLDWATER",
    "dropdelst": "MI",
    "dropdelzpp": 490369998,
    "dropphyadd": "100 W PEARL ST",
    "dropphycty": "COLDWATER",
    "dropphyst": "MI",
    "dropphyzpp": 490369998,
    "dropmaladd": "100 W PEARL ST",
    "dropmalcty": "COLDWATER",
    "dropmalst": "MI",
    "dropmalzpp": 490369998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5172782632,
    "dropsitcph": 5172782632,
    "dropfax": 5172799078
  },
  {
    "dcode": "D",
    "dropkey": "PY11665",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "109 N 3RD ST",
    "dropdelcty": "COLEMAN",
    "dropdelst": "MI",
    "dropdelzpp": 486189800,
    "dropphyadd": "109 N 3RD ST",
    "dropphycty": "COLEMAN",
    "dropphyst": "MI",
    "dropphyzpp": 486189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLEMAN",
    "dropmalst": "MI",
    "dropmalzpp": 486189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894656931,
    "dropsitcph": 9894656931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11667",
    "droptype": "D",
    "dropname": "COLOMA",
    "dropdeladd": "201 N WEST ST",
    "dropdelcty": "COLOMA",
    "dropdelst": "MI",
    "dropdelzpp": 490388407,
    "dropphyadd": "201 N WEST ST",
    "dropphycty": "COLOMA",
    "dropphyst": "MI",
    "dropphyzpp": 490388407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLOMA",
    "dropmalst": "MI",
    "dropmalzpp": 490389998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694686311,
    "dropsitcph": 2694686311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11668",
    "droptype": "D",
    "dropname": "COLON",
    "dropdeladd": "123 S BLACKSTONE AVE",
    "dropdelcty": "COLON",
    "dropdelst": "MI",
    "dropdelzpp": 490409800,
    "dropphyadd": "123 S BLACKSTONE AVE",
    "dropphycty": "COLON",
    "dropphyst": "MI",
    "dropphyzpp": 490409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLON",
    "dropmalst": "MI",
    "dropmalzpp": 490409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694323775,
    "dropsitcph": 2694323775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11669",
    "droptype": "D",
    "dropname": "COLUMBIAVILLE",
    "dropdeladd": "4643 PINE ST",
    "dropdelcty": "COLUMBIAVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484219998,
    "dropphyadd": "4643 PINE ST",
    "dropphycty": "COLUMBIAVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484219998,
    "dropmaladd": "4643 PINE ST",
    "dropmalcty": "COLUMBIAVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484219998,
    "dropsitphn": 8107934000,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107934000,
    "dropfax": 8107931613
  },
  {
    "dcode": "D",
    "dropkey": "PY11675",
    "droptype": "D",
    "dropname": "COMINS",
    "dropdeladd": "4240 N ABBE RD",
    "dropdelcty": "COMINS",
    "dropdelst": "MI",
    "dropdelzpp": 486192502,
    "dropphyadd": "4240 N ABBE RD",
    "dropphycty": "COMINS",
    "dropphyst": "MI",
    "dropphyzpp": 486192502,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMINS",
    "dropmalst": "MI",
    "dropmalzpp": 486199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898485754,
    "dropsitcph": 9898485754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11679",
    "droptype": "D",
    "dropname": "COMSTOCK",
    "dropdeladd": "6095 KING HWY",
    "dropdelcty": "COMSTOCK",
    "dropdelst": "MI",
    "dropdelzpp": 490419800,
    "dropphyadd": "6095 KING HWY",
    "dropphycty": "COMSTOCK",
    "dropphyst": "MI",
    "dropphyzpp": 490419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMSTOCK",
    "dropmalst": "MI",
    "dropmalzpp": 490419998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693494444,
    "dropsitcph": 2693494444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11680",
    "droptype": "D",
    "dropname": "COMSTOCK PARK",
    "dropdeladd": "3913 LELAND AVE NW",
    "dropdelcty": "COMSTOCK PARK",
    "dropdelst": "MI",
    "dropdelzpp": 493219800,
    "dropphyadd": "3913 LELAND AVE NW",
    "dropphycty": "COMSTOCK PARK",
    "dropphyst": "MI",
    "dropphyzpp": 493219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMSTOCK PARK",
    "dropmalst": "MI",
    "dropmalzpp": 493219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167845481,
    "dropsitcph": 6167845481,
    "dropfax": 6167848124
  },
  {
    "dcode": "D",
    "dropkey": "PY11682",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "112 HOMER RD",
    "dropdelcty": "CONCORD",
    "dropdelst": "MI",
    "dropdelzpp": 492379998,
    "dropphyadd": "112 HOMER RD",
    "dropphycty": "CONCORD",
    "dropphyst": "MI",
    "dropphyzpp": 492379998,
    "dropmaladd": "112 HOMER RD",
    "dropmalcty": "CONCORD",
    "dropmalst": "MI",
    "dropmalzpp": 492379998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175246313,
    "dropfax": 5175248915
  },
  {
    "dcode": "D",
    "dropkey": "PY11684",
    "droptype": "D",
    "dropname": "CONKLIN",
    "dropdeladd": "19701 MAIN ST",
    "dropdelcty": "CONKLIN",
    "dropdelst": "MI",
    "dropdelzpp": 494039800,
    "dropphyadd": "19701 MAIN ST",
    "dropphycty": "CONKLIN",
    "dropphyst": "MI",
    "dropphyzpp": 494039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONKLIN",
    "dropmalst": "MI",
    "dropmalzpp": 494039998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168992113,
    "dropsitcph": 6168992113,
    "dropfax": 6168999809
  },
  {
    "dcode": "D",
    "dropkey": "PY11685",
    "droptype": "D",
    "dropname": "CONSTANTINE",
    "dropdeladd": "340 S WASHINGTON ST",
    "dropdelcty": "CONSTANTINE",
    "dropdelst": "MI",
    "dropdelzpp": 490429998,
    "dropphyadd": "340 S WASHINGTON ST",
    "dropphycty": "CONSTANTINE",
    "dropphyst": "MI",
    "dropphyzpp": 490429998,
    "dropmaladd": "340 S WASHINGTON ST",
    "dropmalcty": "CONSTANTINE",
    "dropmalst": "MI",
    "dropmalzpp": 490429998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694355285,
    "dropsitcph": 2694355285,
    "dropfax": 2694356206
  },
  {
    "dcode": "D",
    "dropkey": "PY11688",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "3459 N US 31",
    "dropdelcty": "CONWAY",
    "dropdelst": "MI",
    "dropdelzpp": 497229800,
    "dropphyadd": "3459 N US 31",
    "dropphycty": "CONWAY",
    "dropphyst": "MI",
    "dropphyzpp": 497229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONWAY",
    "dropmalst": "MI",
    "dropmalzpp": 497229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313477730,
    "dropsitcph": 2313477730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11689",
    "droptype": "D",
    "dropname": "COOKS",
    "dropdeladd": "1131S COUNTY ROAD 442",
    "dropdelcty": "COOKS",
    "dropdelst": "MI",
    "dropdelzpp": 498179513,
    "dropphyadd": "1131S COUNTY ROAD 442",
    "dropphycty": "COOKS",
    "dropphyst": "MI",
    "dropphyzpp": 498179513,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOKS",
    "dropmalst": "MI",
    "dropmalzpp": 498179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9066442421,
    "dropsitcph": 9066442421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11691",
    "droptype": "D",
    "dropname": "COOPERSVILLE",
    "dropdeladd": "314 CENTER ST",
    "dropdelcty": "COOPERSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494049998,
    "dropphyadd": "314 CENTER ST",
    "dropphycty": "COOPERSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494049998,
    "dropmaladd": "314 CENTER ST",
    "dropmalcty": "COOPERSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494049998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168376511,
    "dropsitcph": 6168377383,
    "dropfax": 6168379830
  },
  {
    "dcode": "D",
    "dropkey": "PY11693",
    "droptype": "D",
    "dropname": "COPEMISH",
    "dropdeladd": "18772 MAPLE ST",
    "dropdelcty": "COPEMISH",
    "dropdelst": "MI",
    "dropdelzpp": 496259530,
    "dropphyadd": "18772 MAPLE ST",
    "dropphycty": "COPEMISH",
    "dropphyst": "MI",
    "dropphyzpp": 496259530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPEMISH",
    "dropmalst": "MI",
    "dropmalzpp": 496259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313782110,
    "dropsitcph": 2313782110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11694",
    "droptype": "D",
    "dropname": "COPPER CITY",
    "dropdeladd": "212 MOHAWK ST",
    "dropdelcty": "COPPER CITY",
    "dropdelst": "MI",
    "dropdelzpp": 499179800,
    "dropphyadd": "212 MOHAWK ST",
    "dropphycty": "COPPER CITY",
    "dropphyst": "MI",
    "dropphyzpp": 499179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPPER CITY",
    "dropmalst": "MI",
    "dropmalzpp": 499179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063370918,
    "dropsitcph": 9063370918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11696",
    "droptype": "D",
    "dropname": "CORAL",
    "dropdeladd": "4726 N BAILEY RD",
    "dropdelcty": "CORAL",
    "dropdelst": "MI",
    "dropdelzpp": 493225100,
    "dropphyadd": "4726 N BAILEY RD",
    "dropphycty": "CORAL",
    "dropphyst": "MI",
    "dropphyzpp": 493225100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORAL",
    "dropmalst": "MI",
    "dropmalzpp": 493229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313546608,
    "dropsitcph": 2313546608,
    "dropfax": 6163546348
  },
  {
    "dcode": "D",
    "dropkey": "PY11697",
    "droptype": "D",
    "dropname": "CORNELL",
    "dropdeladd": "9845 BONEY FALLS H RD",
    "dropdelcty": "CORNELL",
    "dropdelst": "MI",
    "dropdelzpp": 498189528,
    "dropphyadd": "9845 BONEY FALLS H RD",
    "dropphycty": "CORNELL",
    "dropphyst": "MI",
    "dropphyzpp": 498189528,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNELL",
    "dropmalst": "MI",
    "dropmalzpp": 498189998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063846930,
    "dropsitcph": 9063846930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11698",
    "droptype": "D",
    "dropname": "CORUNNA",
    "dropdeladd": "330 N SHIAWASSEE ST",
    "dropdelcty": "CORUNNA",
    "dropdelst": "MI",
    "dropdelzpp": 488171464,
    "dropphyadd": "330 N SHIAWASSEE ST",
    "dropphycty": "CORUNNA",
    "dropphyst": "MI",
    "dropphyzpp": 488171464,
    "dropmaladd": "330 N SHIAWASSEE ST",
    "dropmalcty": "CORUNNA",
    "dropmalst": "MI",
    "dropmalzpp": 488171464,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897433400,
    "dropsitcph": 9897433400,
    "dropfax": 9897433237
  },
  {
    "dcode": "D",
    "dropkey": "PY11703",
    "droptype": "D",
    "dropname": "COVERT",
    "dropdeladd": "33845 M 140 HWY",
    "dropdelcty": "COVERT",
    "dropdelst": "MI",
    "dropdelzpp": 490439800,
    "dropphyadd": "33845 M 140 HWY",
    "dropphycty": "COVERT",
    "dropphyst": "MI",
    "dropphyzpp": 490439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COVERT",
    "dropmalst": "MI",
    "dropmalzpp": 490439998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697641518,
    "dropsitcph": 2697641518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11704",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "25387 US HIGHWAY 141",
    "dropdelcty": "COVINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 499199042,
    "dropphyadd": "25387 US HIGHWAY 141",
    "dropphycty": "COVINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 499199042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COVINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 499199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063552566,
    "dropsitcph": 9063552566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11706",
    "droptype": "D",
    "dropname": "CROSS VILLAGE",
    "dropdeladd": "6340 N LAKE SHORE DR",
    "dropdelcty": "CROSS VILLAGE",
    "dropdelst": "MI",
    "dropdelzpp": 497239800,
    "dropphyadd": "6340 N LAKE SHORE DR",
    "dropphycty": "CROSS VILLAGE",
    "dropphyst": "MI",
    "dropphyzpp": 497239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS VILLAGE",
    "dropmalst": "MI",
    "dropmalzpp": 497239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315266610,
    "dropsitcph": 2315266610,
    "dropfax": 2315262458
  },
  {
    "dcode": "D",
    "dropkey": "PY11707",
    "droptype": "D",
    "dropname": "CROSWELL",
    "dropdeladd": "104 N HOWARD AVE",
    "dropdelcty": "CROSWELL",
    "dropdelst": "MI",
    "dropdelzpp": 484229998,
    "dropphyadd": "104 N HOWARD AVE",
    "dropphycty": "CROSWELL",
    "dropphyst": "MI",
    "dropphyzpp": 484229998,
    "dropmaladd": "104 N HOWARD AVE",
    "dropmalcty": "CROSWELL",
    "dropmalst": "MI",
    "dropmalzpp": 484229998,
    "dropsitphn": 8106793226,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106793226,
    "dropfax": 8106792931
  },
  {
    "dcode": "D",
    "dropkey": "PY11709",
    "droptype": "D",
    "dropname": "CRYSTAL",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "CRYSTAL",
    "dropdelst": "MI",
    "dropdelzpp": 488189800,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "CRYSTAL",
    "dropphyst": "MI",
    "dropphyzpp": 488189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL",
    "dropmalst": "MI",
    "dropmalzpp": 488189998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892356396,
    "dropsitcph": 9892356396,
    "dropfax": 9892353619
  },
  {
    "dcode": "D",
    "dropkey": "PY11710",
    "droptype": "D",
    "dropname": "CRYSTAL FALLS",
    "dropdeladd": "501 SUPERIOR AVE",
    "dropdelcty": "CRYSTAL FALLS",
    "dropdelst": "MI",
    "dropdelzpp": 499201443,
    "dropphyadd": "501 SUPERIOR AVE",
    "dropphycty": "CRYSTAL FALLS",
    "dropphyst": "MI",
    "dropphyzpp": 499201443,
    "dropmaladd": "501 SUPERIOR AVE",
    "dropmalcty": "CRYSTAL FALLS",
    "dropmalst": "MI",
    "dropmalzpp": 499201443,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068754472,
    "dropsitcph": 9068752021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11713",
    "droptype": "D",
    "dropname": "CURRAN",
    "dropdeladd": "2071 N CURRAN RD",
    "dropdelcty": "CURRAN",
    "dropdelst": "MI",
    "dropdelzpp": 487289701,
    "dropphyadd": "2071 N CURRAN RD",
    "dropphycty": "CURRAN",
    "dropphyst": "MI",
    "dropphyzpp": 487289701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURRAN",
    "dropmalst": "MI",
    "dropmalzpp": 487289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898485051,
    "dropsitcph": 9898485051,
    "dropfax": 9898487113
  },
  {
    "dcode": "D",
    "dropkey": "PY11714",
    "droptype": "D",
    "dropname": "CURTIS",
    "dropdeladd": "W17194 MAIN ST",
    "dropdelcty": "CURTIS",
    "dropdelst": "MI",
    "dropdelzpp": 498209637,
    "dropphyadd": "W17194 MAIN ST",
    "dropphycty": "CURTIS",
    "dropphyst": "MI",
    "dropphyzpp": 498209637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURTIS",
    "dropmalst": "MI",
    "dropmalzpp": 498209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065869712,
    "dropsitcph": 9065869712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11715",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "9 S MADISON AVE",
    "dropdelcty": "CUSTER",
    "dropdelst": "MI",
    "dropdelzpp": 494059611,
    "dropphyadd": "9 S MADISON AVE",
    "dropphycty": "CUSTER",
    "dropphyst": "MI",
    "dropphyzpp": 494059611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSTER",
    "dropmalst": "MI",
    "dropmalzpp": 494059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317573852,
    "dropsitcph": 2317573852,
    "dropfax": 2317573852
  },
  {
    "dcode": "D",
    "dropkey": "PY11717",
    "droptype": "D",
    "dropname": "DAFTER",
    "dropdeladd": "3082 W 10 MILE RD",
    "dropdelcty": "DAFTER",
    "dropdelst": "MI",
    "dropdelzpp": 497249520,
    "dropphyadd": "3082 W 10 MILE RD",
    "dropphycty": "DAFTER",
    "dropphyst": "MI",
    "dropphyzpp": 497249520,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAFTER",
    "dropmalst": "MI",
    "dropmalzpp": 497249998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066326056,
    "dropsitcph": 9066326056,
    "dropfax": 9066326056
  },
  {
    "dcode": "D",
    "dropkey": "PY11718",
    "droptype": "D",
    "dropname": "DAGGETT",
    "dropdeladd": "125 W SCHOOL RD",
    "dropdelcty": "DAGGETT",
    "dropdelst": "MI",
    "dropdelzpp": 498218503,
    "dropphyadd": "125 W SCHOOL RD",
    "dropphycty": "DAGGETT",
    "dropphyst": "MI",
    "dropphyzpp": 498218503,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAGGETT",
    "dropmalst": "MI",
    "dropmalzpp": 498219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067534071,
    "dropsitcph": 9067534071,
    "dropfax": 9067534071
  },
  {
    "dcode": "D",
    "dropkey": "PY11720",
    "droptype": "D",
    "dropname": "DANSVILLE",
    "dropdeladd": "1036 S JACKSON ST",
    "dropdelcty": "DANSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488195132,
    "dropphyadd": "1036 S JACKSON ST",
    "dropphycty": "DANSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488195132,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176236491,
    "dropsitcph": 5176236491,
    "dropfax": 5176231033
  },
  {
    "dcode": "D",
    "dropkey": "PY11722",
    "droptype": "D",
    "dropname": "DAVISBURG",
    "dropdeladd": "12795 FOUNTAIN SQ",
    "dropdelcty": "DAVISBURG",
    "dropdelst": "MI",
    "dropdelzpp": 483509998,
    "dropphyadd": "12795 FOUNTAIN SQ",
    "dropphycty": "DAVISBURG",
    "dropphyst": "MI",
    "dropphyzpp": 483509998,
    "dropmaladd": "12795 FOUNTAIN SQ",
    "dropmalcty": "DAVISBURG",
    "dropmalst": "MI",
    "dropmalzpp": 483509998,
    "dropsitphn": 2486347604,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486347604,
    "dropfax": 2486348771
  },
  {
    "dcode": "D",
    "dropkey": "PY11723",
    "droptype": "D",
    "dropname": "DAVISON",
    "dropdeladd": "10290 DAVISON RD",
    "dropdelcty": "DAVISON",
    "dropdelst": "MI",
    "dropdelzpp": 484239998,
    "dropphyadd": "10290 DAVISON RD",
    "dropphycty": "DAVISON",
    "dropphyst": "MI",
    "dropphyzpp": 484239998,
    "dropmaladd": "10290 DAVISON RD",
    "dropmalcty": "DAVISON",
    "dropmalst": "MI",
    "dropmalzpp": 484239998,
    "dropsitphn": 8106532424,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106532424,
    "dropfax": 8106583525
  },
  {
    "dcode": "D",
    "dropkey": "PY11724",
    "droptype": "D",
    "dropname": "DE TOUR VILLAGE",
    "dropdeladd": "136 N ONTARIO ST",
    "dropdelcty": "DE TOUR VILLAGE",
    "dropdelst": "MI",
    "dropdelzpp": 497255010,
    "dropphyadd": "136 N ONTARIO ST",
    "dropphycty": "DE TOUR VILLAGE",
    "dropphyst": "MI",
    "dropphyzpp": 497255010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE TOUR VILLAGE",
    "dropmalst": "MI",
    "dropmalzpp": 497259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9062973411,
    "dropsitcph": 9062973411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11725",
    "droptype": "D",
    "dropname": "DEARBORN",
    "dropdeladd": "3800 GREENFIELD RD",
    "dropdelcty": "DEARBORN",
    "dropdelst": "MI",
    "dropdelzpp": 481209998,
    "dropphyadd": "3800 GREENFIELD RD",
    "dropphycty": "DEARBORN",
    "dropphyst": "MI",
    "dropphyzpp": 481209998,
    "dropmaladd": "3800 GREENFIELD RD",
    "dropmalcty": "DEARBORN",
    "dropmalst": "MI",
    "dropmalzpp": 481209998,
    "dropsitphn": 3133374700,
    "dropsitlph": 3132268554,
    "dropsitcph": 3133374700,
    "dropfax": 3133374770
  },
  {
    "dcode": "D",
    "dropkey": "PY11726",
    "droptype": "D",
    "dropname": "DEARBORN HEIGHTS",
    "dropdeladd": "26200 FORD RD",
    "dropdelcty": "DEARBORN HEIGHTS",
    "dropdelst": "MI",
    "dropdelzpp": 481279998,
    "dropphyadd": "26200 FORD RD",
    "dropphycty": "DEARBORN HEIGHTS",
    "dropphyst": "MI",
    "dropphyzpp": 481279998,
    "dropmaladd": "26200 FORD RD",
    "dropmalcty": "DEARBORN HEIGHTS",
    "dropmalst": "MI",
    "dropmalzpp": 481279998,
    "dropsitphn": 3137922518,
    "dropsitlph": 3132268554,
    "dropsitcph": 3137922518,
    "dropfax": 3132783798
  },
  {
    "dcode": "D",
    "dropkey": "PY11727",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "127 S PHELPS ST",
    "dropdelcty": "DECATUR",
    "dropdelst": "MI",
    "dropdelzpp": 490451158,
    "dropphyadd": "127 S PHELPS ST",
    "dropphycty": "DECATUR",
    "dropphyst": "MI",
    "dropphyzpp": 490451158,
    "dropmaladd": "127 S PHELPS ST",
    "dropmalcty": "DECATUR",
    "dropmalst": "MI",
    "dropmalzpp": 490451158,
    "dropsitphn": 2693535051,
    "dropsitlph": 2694233391,
    "dropsitcph": 2694233391,
    "dropfax": 2694239614
  },
  {
    "dcode": "D",
    "dropkey": "PY11728",
    "droptype": "D",
    "dropname": "DECKER",
    "dropdeladd": "1624 VAN DYKE RD",
    "dropdelcty": "DECKER",
    "dropdelst": "MI",
    "dropdelzpp": 484269998,
    "dropphyadd": "1624 VAN DYKE RD",
    "dropphycty": "DECKER",
    "dropphyst": "MI",
    "dropphyzpp": 484269998,
    "dropmaladd": "1624 VAN DYKE RD",
    "dropmalcty": "DECKER",
    "dropmalst": "MI",
    "dropmalzpp": 484269998,
    "dropsitphn": 9896357812,
    "dropsitlph": 8102571580,
    "dropsitcph": 9896357812,
    "dropfax": 9896358321
  },
  {
    "dcode": "D",
    "dropkey": "PY11729",
    "droptype": "D",
    "dropname": "DECKERVILLE",
    "dropdeladd": "2517 MAPLE ST",
    "dropdelcty": "DECKERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484279998,
    "dropphyadd": "2517 MAPLE ST",
    "dropphycty": "DECKERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484279998,
    "dropmaladd": "2517 MAPLE ST",
    "dropmalcty": "DECKERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484279998,
    "dropsitphn": 8103764360,
    "dropsitlph": 8102571580,
    "dropsitcph": 8103764360,
    "dropfax": 8103763609
  },
  {
    "dcode": "D",
    "dropkey": "PY11730",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "123 WILLIAMS ST",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 492389998,
    "dropphyadd": "123 WILLIAMS ST",
    "dropphycty": "DEERFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 492389998,
    "dropmaladd": "123 WILLIAMS ST",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 492389998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174473584,
    "dropfax": 5174474051
  },
  {
    "dcode": "D",
    "dropkey": "PY11731",
    "droptype": "D",
    "dropname": "DEERTON",
    "dropdeladd": "E1014 STATE HIGHWAY M28",
    "dropdelcty": "DEERTON",
    "dropdelst": "MI",
    "dropdelzpp": 498229744,
    "dropphyadd": "E1014 STATE HIGHWAY M28",
    "dropphycty": "DEERTON",
    "dropphyst": "MI",
    "dropphyzpp": 498229744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERTON",
    "dropmalst": "MI",
    "dropmalzpp": 498229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9063436515,
    "dropsitcph": 9063436515,
    "dropfax": 9063436501
  },
  {
    "dcode": "D",
    "dropkey": "PY11732",
    "droptype": "D",
    "dropname": "DEFORD",
    "dropdeladd": "1522 RAILROAD ST",
    "dropdelcty": "DEFORD",
    "dropdelst": "MI",
    "dropdelzpp": 487299800,
    "dropphyadd": "1522 RAILROAD ST",
    "dropphycty": "DEFORD",
    "dropphyst": "MI",
    "dropphyzpp": 487299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEFORD",
    "dropmalst": "MI",
    "dropmalzpp": 487299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898724000,
    "dropsitcph": 9898724000,
    "dropfax": 9898726625
  },
  {
    "dcode": "D",
    "dropkey": "PY11736",
    "droptype": "D",
    "dropname": "DELTON",
    "dropdeladd": "10155 S M 43 HWY",
    "dropdelcty": "DELTON",
    "dropdelst": "MI",
    "dropdelzpp": 490469602,
    "dropphyadd": "10155 S M 43 HWY",
    "dropphycty": "DELTON",
    "dropphyst": "MI",
    "dropphyzpp": 490469602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELTON",
    "dropmalst": "MI",
    "dropmalzpp": 490469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696235255,
    "dropsitcph": 2696235255,
    "dropfax": 2696232566
  },
  {
    "dcode": "D",
    "dropkey": "PY11742",
    "droptype": "D",
    "dropname": "DETROIT",
    "dropdeladd": "1401 W FORT ST RM 1006",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482339998,
    "dropphyadd": "1401 W FORT ST RM 1006",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482339998,
    "dropmaladd": "1401 W FORT ST RM 1006",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482339998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3132268075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11747",
    "droptype": "D",
    "dropname": "DEWITT",
    "dropdeladd": "901 S BRIDGE ST",
    "dropdelcty": "DEWITT",
    "dropdelst": "MI",
    "dropdelzpp": 488208820,
    "dropphyadd": "901 S BRIDGE ST",
    "dropphycty": "DEWITT",
    "dropphyst": "MI",
    "dropphyzpp": 488208820,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEWITT",
    "dropmalst": "MI",
    "dropmalzpp": 488209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176694035,
    "dropsitcph": 5176694035,
    "dropfax": 5176695401
  },
  {
    "dcode": "D",
    "dropkey": "PY11748",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "3140 BAKER RD",
    "dropdelcty": "DEXTER",
    "dropdelst": "MI",
    "dropdelzpp": 481309998,
    "dropphyadd": "3140 BAKER RD",
    "dropphycty": "DEXTER",
    "dropphyst": "MI",
    "dropphyzpp": 481309998,
    "dropmaladd": "3140 BAKER RD",
    "dropmalcty": "DEXTER",
    "dropmalst": "MI",
    "dropmalzpp": 481309998,
    "dropsitphn": 7347929007,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344262791,
    "dropfax": 7344264105
  },
  {
    "dcode": "D",
    "dropkey": "PY11750",
    "droptype": "D",
    "dropname": "DIMONDALE",
    "dropdeladd": "126 W JEFFERSON ST",
    "dropdelcty": "DIMONDALE",
    "dropdelst": "MI",
    "dropdelzpp": 488219800,
    "dropphyadd": "126 W JEFFERSON ST",
    "dropphycty": "DIMONDALE",
    "dropphyst": "MI",
    "dropphyzpp": 488219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIMONDALE",
    "dropmalst": "MI",
    "dropmalzpp": 488219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176466662,
    "dropsitcph": 5176466662,
    "dropfax": 5176469570
  },
  {
    "dcode": "D",
    "dropkey": "PY11753",
    "droptype": "D",
    "dropname": "DOLLAR BAY",
    "dropdeladd": "48694 MAIN ST",
    "dropdelcty": "DOLLAR BAY",
    "dropdelst": "MI",
    "dropdelzpp": 499229800,
    "dropphyadd": "48694 MAIN ST",
    "dropphycty": "DOLLAR BAY",
    "dropphyst": "MI",
    "dropphyzpp": 499229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOLLAR BAY",
    "dropmalst": "MI",
    "dropmalzpp": 499229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064828457,
    "dropsitcph": 9064828457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11754",
    "droptype": "D",
    "dropname": "DORR",
    "dropdeladd": "1841 142ND AVE",
    "dropdelcty": "DORR",
    "dropdelst": "MI",
    "dropdelzpp": 493235100,
    "dropphyadd": "1841 142ND AVE",
    "dropphycty": "DORR",
    "dropphyst": "MI",
    "dropphyzpp": 493235100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DORR",
    "dropmalst": "MI",
    "dropmalzpp": 493239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166812111,
    "dropsitcph": 6166812111,
    "dropfax": 6166812641
  },
  {
    "dcode": "D",
    "dropkey": "PY11755",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "70 CENTER ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "MI",
    "dropdelzpp": 494065110,
    "dropphyadd": "70 CENTER ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "MI",
    "dropphyzpp": 494065110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "MI",
    "dropmalzpp": 494069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2698574290,
    "dropsitcph": 2698574290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11760",
    "droptype": "D",
    "dropname": "DOWAGIAC",
    "dropdeladd": "202 COMMERCIAL ST",
    "dropdelcty": "DOWAGIAC",
    "dropdelst": "MI",
    "dropdelzpp": 490479998,
    "dropphyadd": "202 COMMERCIAL ST",
    "dropphycty": "DOWAGIAC",
    "dropphyst": "MI",
    "dropphyzpp": 490479998,
    "dropmaladd": "202 COMMERCIAL ST",
    "dropmalcty": "DOWAGIAC",
    "dropmalst": "MI",
    "dropmalzpp": 490479998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697826300,
    "dropsitcph": 2697826300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11761",
    "droptype": "D",
    "dropname": "DOWLING",
    "dropdeladd": "8599 S M 37 HWY",
    "dropdelcty": "DOWLING",
    "dropdelst": "MI",
    "dropdelzpp": 490509727,
    "dropphyadd": "8599 S M 37 HWY",
    "dropphycty": "DOWLING",
    "dropphyst": "MI",
    "dropphyzpp": 490509727,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOWLING",
    "dropmalst": "MI",
    "dropmalzpp": 490509998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697213440,
    "dropsitcph": 2697213440,
    "dropfax": 2697213840
  },
  {
    "dcode": "D",
    "dropkey": "PY11770",
    "droptype": "D",
    "dropname": "DRUMMOND ISLAND",
    "dropdeladd": "29726 E SOMES RD",
    "dropdelcty": "DRUMMOND ISLAND",
    "dropdelst": "MI",
    "dropdelzpp": 497269702,
    "dropphyadd": "29726 E SOMES RD",
    "dropphycty": "DRUMMOND ISLAND",
    "dropphyst": "MI",
    "dropphyzpp": 497269702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRUMMOND ISLAND",
    "dropmalst": "MI",
    "dropmalzpp": 497269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064935226,
    "dropsitcph": 9064935226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11771",
    "droptype": "D",
    "dropname": "DRYDEN",
    "dropdeladd": "5580 MAIN ST",
    "dropdelcty": "DRYDEN",
    "dropdelst": "MI",
    "dropdelzpp": 484289998,
    "dropphyadd": "5580 MAIN ST",
    "dropphycty": "DRYDEN",
    "dropphyst": "MI",
    "dropphyzpp": 484289998,
    "dropmaladd": "5580 MAIN ST",
    "dropmalcty": "DRYDEN",
    "dropmalst": "MI",
    "dropmalzpp": 484289998,
    "dropsitphn": 8107963760,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107963760,
    "dropfax": 8107964134
  },
  {
    "dcode": "D",
    "dropkey": "PY11774",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "319 W MONROE ST",
    "dropdelcty": "DUNDEE",
    "dropdelst": "MI",
    "dropdelzpp": 481319998,
    "dropphyadd": "319 W MONROE ST",
    "dropphycty": "DUNDEE",
    "dropphyst": "MI",
    "dropphyzpp": 481319998,
    "dropmaladd": "319 W MONROE ST",
    "dropmalcty": "DUNDEE",
    "dropmalst": "MI",
    "dropmalzpp": 481319998,
    "dropsitphn": 7345292757,
    "dropsitlph": 3132268544,
    "dropsitcph": 7345292757,
    "dropfax": 3135292158
  },
  {
    "dcode": "D",
    "dropkey": "PY11775",
    "droptype": "D",
    "dropname": "DURAND",
    "dropdeladd": "211 N OAK ST",
    "dropdelcty": "DURAND",
    "dropdelst": "MI",
    "dropdelzpp": 484299998,
    "dropphyadd": "211 N OAK ST",
    "dropphycty": "DURAND",
    "dropphyst": "MI",
    "dropphyzpp": 484299998,
    "dropmaladd": "211 N OAK ST",
    "dropmalcty": "DURAND",
    "dropmalst": "MI",
    "dropmalzpp": 484299998,
    "dropsitphn": 9892883876,
    "dropsitlph": 8102571580,
    "dropsitcph": 9892883876,
    "dropfax": 9892886294
  },
  {
    "dcode": "D",
    "dropkey": "PY11788",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "13479 W GRAND RIVER HWY",
    "dropdelcty": "EAGLE",
    "dropdelst": "MI",
    "dropdelzpp": 488229681,
    "dropphyadd": "13479 W GRAND RIVER HWY",
    "dropphycty": "EAGLE",
    "dropphyst": "MI",
    "dropphyzpp": 488229681,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE",
    "dropmalst": "MI",
    "dropmalzpp": 488229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176277791,
    "dropsitcph": 5176277791,
    "dropfax": 5176277791
  },
  {
    "dcode": "D",
    "dropkey": "PY11794",
    "droptype": "D",
    "dropname": "EAST DETROIT",
    "dropdeladd": "22430 GRATIOT AVE",
    "dropdelcty": "EASTPOINTE",
    "dropdelst": "MI",
    "dropdelzpp": 480219998,
    "dropphyadd": "22430 GRATIOT AVE",
    "dropphycty": "EASTPOINTE",
    "dropphyst": "MI",
    "dropphyzpp": 480219998,
    "dropmaladd": "22430 GRATIOT AVE",
    "dropmalcty": "EASTPOINTE",
    "dropmalst": "MI",
    "dropmalzpp": 480219998,
    "dropsitphn": 5867778107,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867778107,
    "dropfax": 5867753341
  },
  {
    "dcode": "D",
    "dropkey": "PY11796",
    "droptype": "D",
    "dropname": "EAST JORDAN",
    "dropdeladd": "103 2ND ST",
    "dropdelcty": "EAST JORDAN",
    "dropdelst": "MI",
    "dropdelzpp": 497275130,
    "dropphyadd": "103 2ND ST",
    "dropphycty": "EAST JORDAN",
    "dropphyst": "MI",
    "dropphyzpp": 497275130,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST JORDAN",
    "dropmalst": "MI",
    "dropmalzpp": 497279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315367311,
    "dropsitcph": 2315367311,
    "dropfax": 2315367311
  },
  {
    "dcode": "D",
    "dropkey": "PY11798",
    "droptype": "D",
    "dropname": "EAST LANSING",
    "dropdeladd": "1140 ABBOT RD",
    "dropdelcty": "EAST LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 488239998,
    "dropphyadd": "1140 ABBOT RD",
    "dropphycty": "EAST LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 488239998,
    "dropmaladd": "1140 ABBOT RD",
    "dropmalcty": "EAST LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 488239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173511024,
    "dropsitcph": 5173511024,
    "dropfax": 5173514385
  },
  {
    "dcode": "D",
    "dropkey": "PY11799",
    "droptype": "D",
    "dropname": "EAST LEROY",
    "dropdeladd": "4005 K DR S",
    "dropdelcty": "EAST LEROY",
    "dropdelst": "MI",
    "dropdelzpp": 490518501,
    "dropphyadd": "4005 K DR S",
    "dropphycty": "EAST LEROY",
    "dropphyst": "MI",
    "dropphyzpp": 490518501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST LEROY",
    "dropmalst": "MI",
    "dropmalzpp": 490519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697295102,
    "dropsitcph": 2697295102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11802",
    "droptype": "D",
    "dropname": "EAST TAWAS",
    "dropdeladd": "326 NEWMAN ST",
    "dropdelcty": "EAST TAWAS",
    "dropdelst": "MI",
    "dropdelzpp": 487301244,
    "dropphyadd": "326 NEWMAN ST",
    "dropphycty": "EAST TAWAS",
    "dropphyst": "MI",
    "dropphyzpp": 487301244,
    "dropmaladd": "326 NEWMAN ST",
    "dropmalcty": "EAST TAWAS",
    "dropmalst": "MI",
    "dropmalzpp": 487301244,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893623361,
    "dropsitcph": 9893623361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11804",
    "droptype": "D",
    "dropname": "EASTLAKE",
    "dropdeladd": "298 1ST ST",
    "dropdelcty": "EASTLAKE",
    "dropdelst": "MI",
    "dropdelzpp": 496269800,
    "dropphyadd": "298 1ST ST",
    "dropphycty": "EASTLAKE",
    "dropphyst": "MI",
    "dropphyzpp": 496269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTLAKE",
    "dropmalst": "MI",
    "dropmalzpp": 496269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317236209,
    "dropsitcph": 2317236209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11809",
    "droptype": "D",
    "dropname": "EASTPORT",
    "dropdeladd": "12037 BAKER ST",
    "dropdelcty": "EASTPORT",
    "dropdelst": "MI",
    "dropdelzpp": 496279800,
    "dropphyadd": "12037 BAKER ST",
    "dropphycty": "EASTPORT",
    "dropphyst": "MI",
    "dropphyzpp": 496279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTPORT",
    "dropmalst": "MI",
    "dropmalzpp": 496279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315992613,
    "dropsitcph": 2315992613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11811",
    "droptype": "D",
    "dropname": "EATON RAPIDS",
    "dropdeladd": "245 S MAIN ST",
    "dropdelcty": "EATON RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 488279998,
    "dropphyadd": "245 S MAIN ST",
    "dropphycty": "EATON RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 488279998,
    "dropmaladd": "245 S MAIN ST",
    "dropmalcty": "EATON RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 488279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176636611,
    "dropsitcph": 5176636611,
    "dropfax": 5176630169
  },
  {
    "dcode": "D",
    "dropkey": "PY11812",
    "droptype": "D",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "6537 E MAIN ST",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "MI",
    "dropdelzpp": 491115129,
    "dropphyadd": "6537 E MAIN ST",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "MI",
    "dropphyzpp": 491115129,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "MI",
    "dropmalzpp": 491119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694616141,
    "dropsitcph": 2694616141,
    "dropfax": 2694616141
  },
  {
    "dcode": "D",
    "dropkey": "PY11814",
    "droptype": "D",
    "dropname": "EBEN JUNCTION",
    "dropdeladd": "E2895 STATE HIGHWAY M94",
    "dropdelcty": "EBEN JUNCTION",
    "dropdelst": "MI",
    "dropdelzpp": 498259800,
    "dropphyadd": "E2895 STATE HIGHWAY M94",
    "dropphycty": "EBEN JUNCTION",
    "dropphyst": "MI",
    "dropphyzpp": 498259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EBEN JUNCTION",
    "dropmalst": "MI",
    "dropmalzpp": 498259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064395295,
    "dropsitcph": 9064395295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11815",
    "droptype": "D",
    "dropname": "ECKERMAN",
    "dropdeladd": "9925 S SHELDON RD",
    "dropdelcty": "ECKERMAN",
    "dropdelst": "MI",
    "dropdelzpp": 497285100,
    "dropphyadd": "9925 S SHELDON RD",
    "dropphycty": "ECKERMAN",
    "dropphyst": "MI",
    "dropphyzpp": 497285100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ECKERMAN",
    "dropmalst": "MI",
    "dropmalzpp": 497289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9062745539,
    "dropsitcph": 9062745539,
    "dropfax": 9062745539
  },
  {
    "dcode": "D",
    "dropkey": "PY11817",
    "droptype": "D",
    "dropname": "EDENVILLE",
    "dropdeladd": "461 CEDAR DR",
    "dropdelcty": "EDENVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 486209800,
    "dropphyadd": "461 CEDAR DR",
    "dropphycty": "EDENVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 486209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDENVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 486209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896893711,
    "dropsitcph": 9896893711,
    "dropfax": 9896895967
  },
  {
    "dcode": "D",
    "dropkey": "PY11818",
    "droptype": "D",
    "dropname": "EDMORE",
    "dropdeladd": "317 E MAIN ST",
    "dropdelcty": "EDMORE",
    "dropdelst": "MI",
    "dropdelzpp": 488299807,
    "dropphyadd": "317 E MAIN ST",
    "dropphycty": "EDMORE",
    "dropphyst": "MI",
    "dropphyzpp": 488299807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDMORE",
    "dropmalst": "MI",
    "dropmalzpp": 488299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894275293,
    "dropsitcph": 9894275293,
    "dropfax": 9894275293
  },
  {
    "dcode": "D",
    "dropkey": "PY11820",
    "droptype": "D",
    "dropname": "EDWARDSBURG",
    "dropdeladd": "68926 CASS ST",
    "dropdelcty": "EDWARDSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 491127632,
    "dropphyadd": "68926 CASS ST",
    "dropphycty": "EDWARDSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 491127632,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDWARDSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 491129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696635205,
    "dropsitcph": 2696635205,
    "dropfax": 2696632032
  },
  {
    "dcode": "D",
    "dropkey": "PY11822",
    "droptype": "D",
    "dropname": "ELBERTA",
    "dropdeladd": "655 FRANKFORT AVE",
    "dropdelcty": "ELBERTA",
    "dropdelst": "MI",
    "dropdelzpp": 496289800,
    "dropphyadd": "655 FRANKFORT AVE",
    "dropphycty": "ELBERTA",
    "dropphyst": "MI",
    "dropphyzpp": 496289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBERTA",
    "dropmalst": "MI",
    "dropmalzpp": 496289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313529261,
    "dropsitcph": 2313529261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11823",
    "droptype": "D",
    "dropname": "ELK RAPIDS",
    "dropdeladd": "105 RIVER ST",
    "dropdelcty": "ELK RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 496299604,
    "dropphyadd": "105 RIVER ST",
    "dropphycty": "ELK RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 496299604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 496299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312649909,
    "dropsitcph": 2312649909,
    "dropfax": 6162649909
  },
  {
    "dcode": "D",
    "dropkey": "PY11825",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "4958 MILL ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "MI",
    "dropdelzpp": 487315135,
    "dropphyadd": "4958 MILL ST",
    "dropphycty": "ELKTON",
    "dropphyst": "MI",
    "dropphyzpp": 487315135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKTON",
    "dropmalst": "MI",
    "dropmalzpp": 487319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893754170,
    "dropsitcph": 9893754170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11826",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "9284 MAIN ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "MI",
    "dropdelzpp": 497299800,
    "dropphyadd": "9284 MAIN ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "MI",
    "dropphyzpp": 497299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "MI",
    "dropmalzpp": 497299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315882888,
    "dropsitcph": 2315882888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11827",
    "droptype": "D",
    "dropname": "ELM HALL",
    "dropdeladd": "5025 N LUMBERJACK RD",
    "dropdelcty": "ELM HALL",
    "dropdelst": "MI",
    "dropdelzpp": 488309800,
    "dropphyadd": "5025 N LUMBERJACK RD",
    "dropphycty": "ELM HALL",
    "dropphyst": "MI",
    "dropphyzpp": 488309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELM HALL",
    "dropmalst": "MI",
    "dropmalzpp": 488309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898337387,
    "dropsitcph": 9898337387,
    "dropfax": 9898335024
  },
  {
    "dcode": "D",
    "dropkey": "PY11828",
    "droptype": "D",
    "dropname": "ELMIRA",
    "dropdeladd": "8846 UNDERWOOD AVE",
    "dropdelcty": "ELMIRA",
    "dropdelst": "MI",
    "dropdelzpp": 497309803,
    "dropphyadd": "8846 UNDERWOOD AVE",
    "dropphycty": "ELMIRA",
    "dropphyst": "MI",
    "dropphyzpp": 497309803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMIRA",
    "dropmalst": "MI",
    "dropmalzpp": 497309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315463337,
    "dropsitcph": 2315463337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11830",
    "droptype": "D",
    "dropname": "ELSIE",
    "dropdeladd": "153 E MAIN ST",
    "dropdelcty": "ELSIE",
    "dropdelst": "MI",
    "dropdelzpp": 488315113,
    "dropphyadd": "153 E MAIN ST",
    "dropphycty": "ELSIE",
    "dropphyst": "MI",
    "dropphyzpp": 488315113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELSIE",
    "dropmalst": "MI",
    "dropmalzpp": 488319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898624338,
    "dropsitcph": 9898624338,
    "dropfax": 9898625679
  },
  {
    "dcode": "D",
    "dropkey": "PY11831",
    "droptype": "D",
    "dropname": "ELWELL",
    "dropdeladd": "6477 PINGREE RD",
    "dropdelcty": "ELWELL",
    "dropdelst": "MI",
    "dropdelzpp": 488329508,
    "dropphyadd": "6477 PINGREE RD",
    "dropphycty": "ELWELL",
    "dropphyst": "MI",
    "dropphyzpp": 488329508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELWELL",
    "dropmalst": "MI",
    "dropmalzpp": 488329998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894635925,
    "dropsitcph": 9894635925,
    "dropfax": 9894635925
  },
  {
    "dcode": "D",
    "dropkey": "PY11832",
    "droptype": "D",
    "dropname": "EMMETT",
    "dropdeladd": "3120 MAIN ST",
    "dropdelcty": "EMMETT",
    "dropdelst": "MI",
    "dropdelzpp": 480229998,
    "dropphyadd": "3120 MAIN ST",
    "dropphycty": "EMMETT",
    "dropphyst": "MI",
    "dropphyzpp": 480229998,
    "dropmaladd": "3120 MAIN ST",
    "dropmalcty": "EMMETT",
    "dropmalst": "MI",
    "dropmalzpp": 480229998,
    "dropsitphn": 8103841720,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103841720,
    "dropfax": 8103841402
  },
  {
    "dcode": "D",
    "dropkey": "PY11835",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "10234 W FRONT ST",
    "dropdelcty": "EMPIRE",
    "dropdelst": "MI",
    "dropdelzpp": 496305106,
    "dropphyadd": "10234 W FRONT ST",
    "dropphycty": "EMPIRE",
    "dropphyst": "MI",
    "dropphyzpp": 496305106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMPIRE",
    "dropmalst": "MI",
    "dropmalzpp": 496309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313265201,
    "dropsitcph": 2313265201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11836",
    "droptype": "D",
    "dropname": "ENGADINE",
    "dropdeladd": "104 MELVILLE ST",
    "dropdelcty": "ENGADINE",
    "dropdelst": "MI",
    "dropdelzpp": 498279769,
    "dropphyadd": "104 MELVILLE ST",
    "dropphycty": "ENGADINE",
    "dropphyst": "MI",
    "dropphyzpp": 498279769,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENGADINE",
    "dropmalst": "MI",
    "dropmalzpp": 498279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064776231,
    "dropsitcph": 9064776231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11839",
    "droptype": "D",
    "dropname": "ESCANABA",
    "dropdeladd": "2525 1ST AVE N",
    "dropdelcty": "ESCANABA",
    "dropdelst": "MI",
    "dropdelzpp": 498299998,
    "dropphyadd": "2525 1ST AVE N",
    "dropphycty": "ESCANABA",
    "dropphyst": "MI",
    "dropphyzpp": 498299998,
    "dropmaladd": "2525 1ST AVE N",
    "dropmalcty": "ESCANABA",
    "dropmalst": "MI",
    "dropmalzpp": 498299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9067860652,
    "dropsitcph": 9067860652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11844",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "7907 N WELLING RD",
    "dropdelcty": "EUREKA",
    "dropdelst": "MI",
    "dropdelzpp": 488339800,
    "dropphyadd": "7907 N WELLING RD",
    "dropphycty": "EUREKA",
    "dropphyst": "MI",
    "dropphyzpp": 488339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EUREKA",
    "dropmalst": "MI",
    "dropmalzpp": 488339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892243111,
    "dropsitcph": 9892243111,
    "dropfax": 9892243111
  },
  {
    "dcode": "D",
    "dropkey": "PY11845",
    "droptype": "D",
    "dropname": "EVART",
    "dropdeladd": "240 N MAIN ST",
    "dropdelcty": "EVART",
    "dropdelst": "MI",
    "dropdelzpp": 496315102,
    "dropphyadd": "240 N MAIN ST",
    "dropphycty": "EVART",
    "dropphyst": "MI",
    "dropphyzpp": 496315102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVART",
    "dropmalst": "MI",
    "dropmalzpp": 496319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317342142,
    "dropsitcph": 2317342142,
    "dropfax": 2317342142
  },
  {
    "dcode": "D",
    "dropkey": "PY11846",
    "droptype": "D",
    "dropname": "EWEN",
    "dropdeladd": "106 S CEDAR ST",
    "dropdelcty": "EWEN",
    "dropdelst": "MI",
    "dropdelzpp": 499259755,
    "dropphyadd": "106 S CEDAR ST",
    "dropphycty": "EWEN",
    "dropphyst": "MI",
    "dropphyzpp": 499259755,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EWEN",
    "dropmalst": "MI",
    "dropmalzpp": 499259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9069882373,
    "dropsitcph": 9069882373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11848",
    "droptype": "D",
    "dropname": "FAIR HAVEN",
    "dropdeladd": "8680 DIXIE HWY",
    "dropdelcty": "FAIR HAVEN",
    "dropdelst": "MI",
    "dropdelzpp": 480239998,
    "dropphyadd": "8680 DIXIE HWY",
    "dropphycty": "FAIR HAVEN",
    "dropphyst": "MI",
    "dropphyzpp": 480239998,
    "dropmaladd": "8680 DIXIE HWY",
    "dropmalcty": "FAIR HAVEN",
    "dropmalst": "MI",
    "dropmalzpp": 480239998,
    "dropsitphn": 5867259674,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867259674,
    "dropfax": 5867256016
  },
  {
    "dcode": "D",
    "dropkey": "PY11849",
    "droptype": "D",
    "dropname": "FAIRGROVE",
    "dropdeladd": "2045 N MAIN ST",
    "dropdelcty": "FAIRGROVE",
    "dropdelst": "MI",
    "dropdelzpp": 487339565,
    "dropphyadd": "2045 N MAIN ST",
    "dropphycty": "FAIRGROVE",
    "dropphyst": "MI",
    "dropphyzpp": 487339565,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRGROVE",
    "dropmalst": "MI",
    "dropmalzpp": 487339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896936124,
    "dropsitcph": 9896936124,
    "dropfax": 9896936601
  },
  {
    "dcode": "D",
    "dropkey": "PY11850",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "1531 N ABBE RD",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "MI",
    "dropdelzpp": 486218719,
    "dropphyadd": "1531 N ABBE RD",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "MI",
    "dropphyzpp": 486218719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "MI",
    "dropmalzpp": 486219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898482812,
    "dropsitcph": 9898482812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11851",
    "droptype": "D",
    "dropname": "FALMOUTH",
    "dropdeladd": "6520 S MAIN ST",
    "dropdelcty": "FALMOUTH",
    "dropdelst": "MI",
    "dropdelzpp": 496329805,
    "dropphyadd": "6520 S MAIN ST",
    "dropphycty": "FALMOUTH",
    "dropphyst": "MI",
    "dropphyzpp": 496329805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALMOUTH",
    "dropmalst": "MI",
    "dropmalzpp": 496329998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318264418,
    "dropsitcph": 2318264418,
    "dropfax": 2318264418
  },
  {
    "dcode": "D",
    "dropkey": "PY11853",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "23332 FARMINGTON RD",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 483369998,
    "dropphyadd": "23332 FARMINGTON RD",
    "dropphycty": "FARMINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 483369998,
    "dropmaladd": "23332 FARMINGTON RD",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 483369998,
    "dropsitphn": 2483243485,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483243485,
    "dropfax": 2484269971
  },
  {
    "dcode": "D",
    "dropkey": "PY11858",
    "droptype": "D",
    "dropname": "FARWELL",
    "dropdeladd": "254 W MAIN ST",
    "dropdelcty": "FARWELL",
    "dropdelst": "MI",
    "dropdelzpp": 486229553,
    "dropphyadd": "254 W MAIN ST",
    "dropphycty": "FARWELL",
    "dropphyst": "MI",
    "dropphyzpp": 486229553,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARWELL",
    "dropmalst": "MI",
    "dropmalzpp": 486229998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895882889,
    "dropsitcph": 9895882889,
    "dropfax": 9895886050
  },
  {
    "dcode": "D",
    "dropkey": "PY11860",
    "droptype": "D",
    "dropname": "FELCH",
    "dropdeladd": "W4243 STATE HIGHWAY M69",
    "dropdelcty": "FELCH",
    "dropdelst": "MI",
    "dropdelzpp": 498319800,
    "dropphyadd": "W4243 STATE HIGHWAY M69",
    "dropphycty": "FELCH",
    "dropphyst": "MI",
    "dropphyzpp": 498319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FELCH",
    "dropmalst": "MI",
    "dropmalzpp": 498319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062463659,
    "dropsitcph": 9062463659,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11866",
    "droptype": "D",
    "dropname": "FENNVILLE",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "FENNVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494089218,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "FENNVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494089218,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENNVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494089998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2695616031,
    "dropsitcph": 2695616031,
    "dropfax": 2695616511
  },
  {
    "dcode": "D",
    "dropkey": "PY11868",
    "droptype": "D",
    "dropname": "FENTON",
    "dropdeladd": "210 S LEROY ST",
    "dropdelcty": "FENTON",
    "dropdelst": "MI",
    "dropdelzpp": 484309998,
    "dropphyadd": "210 S LEROY ST",
    "dropphycty": "FENTON",
    "dropphyst": "MI",
    "dropphyzpp": 484309998,
    "dropmaladd": "210 S LEROY ST",
    "dropmalcty": "FENTON",
    "dropmalst": "MI",
    "dropmalzpp": 484309998,
    "dropsitphn": 8106296813,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106296813,
    "dropfax": 8107144116
  },
  {
    "dcode": "D",
    "dropkey": "PY11869",
    "droptype": "D",
    "dropname": "FENWICK",
    "dropdeladd": "382 W FENWICK RD",
    "dropdelcty": "FENWICK",
    "dropdelst": "MI",
    "dropdelzpp": 488349561,
    "dropphyadd": "382 W FENWICK RD",
    "dropphycty": "FENWICK",
    "dropphyst": "MI",
    "dropphyzpp": 488349561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENWICK",
    "dropmalst": "MI",
    "dropmalzpp": 488349998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892483494,
    "dropsitcph": 9892483494,
    "dropfax": 9892483494
  },
  {
    "dcode": "D",
    "dropkey": "PY11871",
    "droptype": "D",
    "dropname": "FERRYSBURG",
    "dropdeladd": "110 4TH ST",
    "dropdelcty": "FERRYSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 494099800,
    "dropphyadd": "110 4TH ST",
    "dropphycty": "FERRYSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 494099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERRYSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 494099998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168429650,
    "dropsitcph": 6168442819,
    "dropfax": 6168429650
  },
  {
    "dcode": "D",
    "dropkey": "PY11873",
    "droptype": "D",
    "dropname": "FIFE LAKE",
    "dropdeladd": "113 OAK ST",
    "dropdelcty": "FIFE LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 496339800,
    "dropphyadd": "113 OAK ST",
    "dropphycty": "FIFE LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 496339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FIFE LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 496339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318793571,
    "dropsitcph": 2318793571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11874",
    "droptype": "D",
    "dropname": "FILER CITY",
    "dropdeladd": "711 MEE ST STE A",
    "dropdelcty": "FILER CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496349701,
    "dropphyadd": "711 MEE ST STE A",
    "dropphycty": "FILER CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496349701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FILER CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496349998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317232671,
    "dropsitcph": 2317232671,
    "dropfax": 2317232677
  },
  {
    "dcode": "D",
    "dropkey": "PY11885",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "26216 GIBRALTAR RD",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "MI",
    "dropdelzpp": 481349998,
    "dropphyadd": "26216 GIBRALTAR RD",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "MI",
    "dropphyzpp": 481349998,
    "dropmaladd": "26216 GIBRALTAR RD",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "MI",
    "dropmalzpp": 481349998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7347830506,
    "dropsitcph": 7347830506,
    "dropfax": 7347824109
  },
  {
    "dcode": "D",
    "dropkey": "PY11887",
    "droptype": "D",
    "dropname": "FLINT",
    "dropdeladd": "250 E BOULEVARD DR",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485029998,
    "dropphyadd": "250 E BOULEVARD DR",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485029998,
    "dropmaladd": "250 E BOULEVARD DR",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485029998,
    "dropsitphn": 8102571567,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102571506,
    "dropfax": 8102571518
  },
  {
    "dcode": "D",
    "dropkey": "PY11888",
    "droptype": "D",
    "dropname": "FLUSHING",
    "dropdeladd": "127 S CHERRY ST",
    "dropdelcty": "FLUSHING",
    "dropdelst": "MI",
    "dropdelzpp": 484339998,
    "dropphyadd": "127 S CHERRY ST",
    "dropphycty": "FLUSHING",
    "dropphyst": "MI",
    "dropphyzpp": 484339998,
    "dropmaladd": "127 S CHERRY ST",
    "dropmalcty": "FLUSHING",
    "dropmalst": "MI",
    "dropmalzpp": 484339998,
    "dropsitphn": 8106596473,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106596473,
    "dropfax": 8106597927
  },
  {
    "dcode": "D",
    "dropkey": "PY11892",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "8007 3RD ST",
    "dropdelcty": "FORESTVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484349998,
    "dropphyadd": "8007 3RD ST",
    "dropphycty": "FORESTVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484349998,
    "dropmaladd": "8007 3RD ST",
    "dropmalcty": "FORESTVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484349998,
    "dropsitphn": 9898643174,
    "dropsitlph": 8102571580,
    "dropsitcph": 9898643174,
    "dropfax": 9898643654
  },
  {
    "dcode": "D",
    "dropkey": "PY11898",
    "droptype": "D",
    "dropname": "FOSTER CITY",
    "dropdeladd": "W2492 STATE HIGHWAY M69",
    "dropdelcty": "FOSTER CITY",
    "dropdelst": "MI",
    "dropdelzpp": 498349741,
    "dropphyadd": "W2492 STATE HIGHWAY M69",
    "dropphycty": "FOSTER CITY",
    "dropphyst": "MI",
    "dropphyzpp": 498349741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOSTER CITY",
    "dropmalst": "MI",
    "dropmalzpp": 498349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062463663,
    "dropsitcph": 9062463663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11900",
    "droptype": "D",
    "dropname": "FOSTORIA",
    "dropdeladd": "9301 FOSTER ST",
    "dropdelcty": "FOSTORIA",
    "dropdelst": "MI",
    "dropdelzpp": 484359998,
    "dropphyadd": "9301 FOSTER ST",
    "dropphycty": "FOSTORIA",
    "dropphyst": "MI",
    "dropphyzpp": 484359998,
    "dropmaladd": "9301 FOSTER ST",
    "dropmalcty": "FOSTORIA",
    "dropmalst": "MI",
    "dropmalzpp": 484359998,
    "dropsitphn": 9897952124,
    "dropsitlph": 8102571580,
    "dropsitcph": 9897952124,
    "dropfax": 9897959405
  },
  {
    "dcode": "D",
    "dropkey": "PY11901",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "5016 N CLEVELAND ST",
    "dropdelcty": "FOUNTAIN",
    "dropdelst": "MI",
    "dropdelzpp": 494109800,
    "dropphyadd": "5016 N CLEVELAND ST",
    "dropphycty": "FOUNTAIN",
    "dropphyst": "MI",
    "dropphyzpp": 494109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOUNTAIN",
    "dropmalst": "MI",
    "dropmalzpp": 494109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2314623987,
    "dropsitcph": 2314623987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11903",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "135 N MAIN ST",
    "dropdelcty": "FOWLER",
    "dropdelst": "MI",
    "dropdelzpp": 488359803,
    "dropphyadd": "135 N MAIN ST",
    "dropphycty": "FOWLER",
    "dropphyst": "MI",
    "dropphyzpp": 488359803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOWLER",
    "dropmalst": "MI",
    "dropmalzpp": 488359998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895932322,
    "dropsitcph": 9895932322,
    "dropfax": 9895933851
  },
  {
    "dcode": "D",
    "dropkey": "PY11904",
    "droptype": "D",
    "dropname": "FOWLERVILLE",
    "dropdeladd": "7030 W GRAND RIVER RD",
    "dropdelcty": "FOWLERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488368635,
    "dropphyadd": "7030 W GRAND RIVER RD",
    "dropphycty": "FOWLERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488368635,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOWLERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488369998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5172238753,
    "dropsitcph": 5172233149,
    "dropfax": 5172239369
  },
  {
    "dcode": "D",
    "dropkey": "PY11907",
    "droptype": "D",
    "dropname": "FRANKENMUTH",
    "dropdeladd": "119 N MAIN ST",
    "dropdelcty": "FRANKENMUTH",
    "dropdelst": "MI",
    "dropdelzpp": 487341199,
    "dropphyadd": "119 N MAIN ST",
    "dropphycty": "FRANKENMUTH",
    "dropphyst": "MI",
    "dropphyzpp": 487341199,
    "dropmaladd": "119 N MAIN ST",
    "dropmalcty": "FRANKENMUTH",
    "dropmalst": "MI",
    "dropmalzpp": 487341199,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896526751,
    "dropsitcph": 9896526751,
    "dropfax": 9896523949
  },
  {
    "dcode": "D",
    "dropkey": "PY11909",
    "droptype": "D",
    "dropname": "FRANKFORT",
    "dropdeladd": "615 MAIN ST",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "MI",
    "dropdelzpp": 496359806,
    "dropphyadd": "615 MAIN ST",
    "dropphycty": "FRANKFORT",
    "dropphyst": "MI",
    "dropphyzpp": 496359806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "MI",
    "dropmalzpp": 496359998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313524341,
    "dropsitcph": 2313524341,
    "dropfax": 6163526581
  },
  {
    "dcode": "D",
    "dropkey": "PY11912",
    "droptype": "D",
    "dropname": "FRASER",
    "dropdeladd": "16925 MASONIC",
    "dropdelcty": "FRASER",
    "dropdelst": "MI",
    "dropdelzpp": 480269998,
    "dropphyadd": "16925 MASONIC",
    "dropphycty": "FRASER",
    "dropphyst": "MI",
    "dropphyzpp": 480269998,
    "dropmaladd": "16925 MASONIC",
    "dropmalcty": "FRASER",
    "dropmalst": "MI",
    "dropmalzpp": 480269998,
    "dropsitphn": 5862852025,
    "dropsitlph": 2487585622,
    "dropsitcph": 5862933068,
    "dropfax": 5862935164
  },
  {
    "dcode": "D",
    "dropkey": "PY11913",
    "droptype": "D",
    "dropname": "FREDERIC",
    "dropdeladd": "6450 OLD 27 N",
    "dropdelcty": "FREDERIC",
    "dropdelst": "MI",
    "dropdelzpp": 497338734,
    "dropphyadd": "6450 OLD 27 N",
    "dropphycty": "FREDERIC",
    "dropphyst": "MI",
    "dropphyzpp": 497338734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERIC",
    "dropmalst": "MI",
    "dropmalzpp": 497339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893488486,
    "dropsitcph": 9893488486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11914",
    "droptype": "D",
    "dropname": "FREE SOIL",
    "dropdeladd": "2650 E MICHIGAN ST",
    "dropdelcty": "FREE SOIL",
    "dropdelst": "MI",
    "dropdelzpp": 494119681,
    "dropphyadd": "2650 E MICHIGAN ST",
    "dropphycty": "FREE SOIL",
    "dropphyst": "MI",
    "dropphyzpp": 494119681,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREE SOIL",
    "dropmalst": "MI",
    "dropmalzpp": 494119998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6164645451,
    "dropsitcph": 2314645451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11916",
    "droptype": "D",
    "dropname": "FREELAND",
    "dropdeladd": "7736 MIDLAND RD STE 3",
    "dropdelcty": "FREELAND",
    "dropdelst": "MI",
    "dropdelzpp": 486235101,
    "dropphyadd": "7736 MIDLAND RD STE 3",
    "dropphycty": "FREELAND",
    "dropphyst": "MI",
    "dropphyzpp": 486235101,
    "dropmaladd": "7736 MIDLAND RD STE 3",
    "dropmalcty": "FREELAND",
    "dropmalst": "MI",
    "dropmalzpp": 486235101,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896958140,
    "dropsitcph": 9896958140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11917",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "162 DIVISION ST",
    "dropdelcty": "FREEPORT",
    "dropdelst": "MI",
    "dropdelzpp": 493255100,
    "dropphyadd": "162 DIVISION ST",
    "dropphycty": "FREEPORT",
    "dropphyst": "MI",
    "dropphyzpp": 493255100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEPORT",
    "dropmalst": "MI",
    "dropmalzpp": 493259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167653201,
    "dropsitcph": 6167653201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11918",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "19 S DIVISION AVE",
    "dropdelcty": "FREMONT",
    "dropdelst": "MI",
    "dropdelzpp": 494129998,
    "dropphyadd": "19 S DIVISION AVE",
    "dropphycty": "FREMONT",
    "dropphyst": "MI",
    "dropphyzpp": 494129998,
    "dropmaladd": "19 S DIVISION AVE",
    "dropmalcty": "FREMONT",
    "dropmalst": "MI",
    "dropmalzpp": 494129998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319244820,
    "dropsitcph": 2319244820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11921",
    "droptype": "D",
    "dropname": "FRONTIER",
    "dropdeladd": "2342 E MONTGOMERY RD",
    "dropdelcty": "FRONTIER",
    "dropdelst": "MI",
    "dropdelzpp": 492399998,
    "dropphyadd": "2342 E MONTGOMERY RD",
    "dropphycty": "FRONTIER",
    "dropphyst": "MI",
    "dropphyzpp": 492399998,
    "dropmaladd": "2342 E MONTGOMERY RD",
    "dropmalcty": "FRONTIER",
    "dropmalst": "MI",
    "dropmalzpp": 492399998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172544759,
    "dropfax": 5172544784
  },
  {
    "dcode": "D",
    "dropkey": "PY11922",
    "droptype": "D",
    "dropname": "FRUITPORT",
    "dropdeladd": "53 N 3RD AVE",
    "dropdelcty": "FRUITPORT",
    "dropdelst": "MI",
    "dropdelzpp": 494150259,
    "dropphyadd": "53 N 3RD AVE",
    "dropphycty": "FRUITPORT",
    "dropphyst": "MI",
    "dropphyzpp": 494150259,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRUITPORT",
    "dropmalst": "MI",
    "dropmalzpp": 494159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318653675,
    "dropsitcph": 2318653675,
    "dropfax": 2318653675
  },
  {
    "dcode": "D",
    "dropkey": "PY11923",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "13957 E W AVE",
    "dropdelcty": "FULTON",
    "dropdelst": "MI",
    "dropdelzpp": 490529789,
    "dropphyadd": "13957 E W AVE",
    "dropphycty": "FULTON",
    "dropphyst": "MI",
    "dropphyzpp": 490529789,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULTON",
    "dropmalst": "MI",
    "dropmalzpp": 490529998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697783348,
    "dropsitcph": 2697783348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11924",
    "droptype": "D",
    "dropname": "GAASTRA",
    "dropdeladd": "12 2ND ST",
    "dropdelcty": "GAASTRA",
    "dropdelst": "MI",
    "dropdelzpp": 499279700,
    "dropphyadd": "12 2ND ST",
    "dropphycty": "GAASTRA",
    "dropphyst": "MI",
    "dropphyzpp": 499279700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAASTRA",
    "dropmalst": "MI",
    "dropmalzpp": 499279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062653588,
    "dropsitcph": 9062653588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11925",
    "droptype": "D",
    "dropname": "GAGETOWN",
    "dropdeladd": "6483 LINCOLN ST",
    "dropdelcty": "GAGETOWN",
    "dropdelst": "MI",
    "dropdelzpp": 487355106,
    "dropphyadd": "6483 LINCOLN ST",
    "dropphycty": "GAGETOWN",
    "dropphyst": "MI",
    "dropphyzpp": 487355106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAGETOWN",
    "dropmalst": "MI",
    "dropmalzpp": 487359998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9896652641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11926",
    "droptype": "D",
    "dropname": "GAINES",
    "dropdeladd": "125 GENESEE ST",
    "dropdelcty": "GAINES",
    "dropdelst": "MI",
    "dropdelzpp": 484369998,
    "dropphyadd": "125 GENESEE ST",
    "dropphycty": "GAINES",
    "dropphyst": "MI",
    "dropphyzpp": 484369998,
    "dropmaladd": "125 GENESEE ST",
    "dropmalcty": "GAINES",
    "dropmalst": "MI",
    "dropmalzpp": 484369998,
    "dropsitphn": 9892719925,
    "dropsitlph": 8102571580,
    "dropsitcph": 9892719925,
    "dropfax": 9892719119
  },
  {
    "dcode": "D",
    "dropkey": "PY11927",
    "droptype": "D",
    "dropname": "GALESBURG",
    "dropdeladd": "124 E MICHIGAN AVE",
    "dropdelcty": "GALESBURG",
    "dropdelst": "MI",
    "dropdelzpp": 490539801,
    "dropphyadd": "124 E MICHIGAN AVE",
    "dropphycty": "GALESBURG",
    "dropphyst": "MI",
    "dropphyzpp": 490539801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALESBURG",
    "dropmalst": "MI",
    "dropmalzpp": 490539998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2696659551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11928",
    "droptype": "D",
    "dropname": "GALIEN",
    "dropdeladd": "114 N CLEVELAND AVE",
    "dropdelcty": "GALIEN",
    "dropdelst": "MI",
    "dropdelzpp": 491139679,
    "dropphyadd": "114 N CLEVELAND AVE",
    "dropphycty": "GALIEN",
    "dropphyst": "MI",
    "dropphyzpp": 491139679,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALIEN",
    "dropmalst": "MI",
    "dropmalzpp": 491139998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2695458875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11929",
    "droptype": "D",
    "dropname": "GARDEN",
    "dropdeladd": "6353 STATE ST",
    "dropdelcty": "GARDEN",
    "dropdelst": "MI",
    "dropdelzpp": 498359732,
    "dropphyadd": "6353 STATE ST",
    "dropphycty": "GARDEN",
    "dropphyst": "MI",
    "dropphyzpp": 498359732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN",
    "dropmalst": "MI",
    "dropmalzpp": 498359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9066442811,
    "dropsitcph": 9066442811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11930",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "140 MERRIMAN RD",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "MI",
    "dropdelzpp": 481359998,
    "dropphyadd": "140 MERRIMAN RD",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "MI",
    "dropphyzpp": 481359998,
    "dropmaladd": "140 MERRIMAN RD",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "MI",
    "dropmalzpp": 481359998,
    "dropsitphn": 7344213390,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344213390,
    "dropfax": 7344211612
  },
  {
    "dcode": "D",
    "dropkey": "PY11933",
    "droptype": "D",
    "dropname": "GAYLORD",
    "dropdeladd": "289 W COMMERCE BLVD",
    "dropdelcty": "GAYLORD",
    "dropdelst": "MI",
    "dropdelzpp": 497359998,
    "dropphyadd": "289 W COMMERCE BLVD",
    "dropphycty": "GAYLORD",
    "dropphyst": "MI",
    "dropphyzpp": 497359998,
    "dropmaladd": "289 W COMMERCE BLVD",
    "dropmalcty": "GAYLORD",
    "dropmalst": "MI",
    "dropmalzpp": 497359998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897326800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11935",
    "droptype": "D",
    "dropname": "GENESEE",
    "dropdeladd": "7198 N GENESEE RD",
    "dropdelcty": "GENESEE",
    "dropdelst": "MI",
    "dropdelzpp": 484379998,
    "dropphyadd": "7198 N GENESEE RD",
    "dropphycty": "GENESEE",
    "dropphyst": "MI",
    "dropphyzpp": 484379998,
    "dropmaladd": "7198 N GENESEE RD",
    "dropmalcty": "GENESEE",
    "dropmalst": "MI",
    "dropmalzpp": 484379998,
    "dropsitphn": 8106401760,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106401760,
    "dropfax": 8106401288
  },
  {
    "dcode": "D",
    "dropkey": "PY11938",
    "droptype": "D",
    "dropname": "GERMFASK",
    "dropdeladd": "1220 KNAGGS ST",
    "dropdelcty": "GERMFASK",
    "dropdelst": "MI",
    "dropdelzpp": 498369800,
    "dropphyadd": "1220 KNAGGS ST",
    "dropphycty": "GERMFASK",
    "dropphyst": "MI",
    "dropphyzpp": 498369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GERMFASK",
    "dropmalst": "MI",
    "dropmalzpp": 498369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065869861,
    "dropsitcph": 9065869861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11943",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "1003 DELTA AVE",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "MI",
    "dropdelzpp": 498379998,
    "dropphyadd": "1003 DELTA AVE",
    "dropphycty": "GLADSTONE",
    "dropphyst": "MI",
    "dropphyzpp": 498379998,
    "dropmaladd": "1003 DELTA AVE",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "MI",
    "dropmalzpp": 498379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064283505,
    "dropsitcph": 9064283505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11944",
    "droptype": "D",
    "dropname": "GLADWIN",
    "dropdeladd": "140 N BOWERY AVE",
    "dropdelcty": "GLADWIN",
    "dropdelst": "MI",
    "dropdelzpp": 486249998,
    "dropphyadd": "140 N BOWERY AVE",
    "dropphycty": "GLADWIN",
    "dropphyst": "MI",
    "dropphyzpp": 486249998,
    "dropmaladd": "140 N BOWERY AVE",
    "dropmalcty": "GLADWIN",
    "dropmalst": "MI",
    "dropmalzpp": 486249998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9894269343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11945",
    "droptype": "D",
    "dropname": "GLEN ARBOR",
    "dropdeladd": "6456 WESTERN AVE",
    "dropdelcty": "GLEN ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 496365101,
    "dropphyadd": "6456 WESTERN AVE",
    "dropphycty": "GLEN ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 496365101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 496369998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2313344320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11948",
    "droptype": "D",
    "dropname": "GLENNIE",
    "dropdeladd": "3160 STATE RD",
    "dropdelcty": "GLENNIE",
    "dropdelst": "MI",
    "dropdelzpp": 487379616,
    "dropphyadd": "3160 STATE RD",
    "dropphycty": "GLENNIE",
    "dropphyst": "MI",
    "dropphyzpp": 487379616,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENNIE",
    "dropmalst": "MI",
    "dropmalzpp": 487379998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897353401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11955",
    "droptype": "D",
    "dropname": "GOBLES",
    "dropdeladd": "106 E EXCHANGE ST",
    "dropdelcty": "GOBLES",
    "dropdelst": "MI",
    "dropdelzpp": 490559800,
    "dropphyadd": "106 E EXCHANGE ST",
    "dropphycty": "GOBLES",
    "dropphyst": "MI",
    "dropphyzpp": 490559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOBLES",
    "dropmalst": "MI",
    "dropmalzpp": 490559998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2696282931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11956",
    "droptype": "D",
    "dropname": "GOETZVILLE",
    "dropdeladd": "18001 E M 48",
    "dropdelcty": "GOETZVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 497368302,
    "dropphyadd": "18001 E M 48",
    "dropphycty": "GOETZVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 497368302,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOETZVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 497369998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9062978365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11962",
    "droptype": "D",
    "dropname": "GOODELLS",
    "dropdeladd": "2585 GOODELLS RD",
    "dropdelcty": "GOODELLS",
    "dropdelst": "MI",
    "dropdelzpp": 480279998,
    "dropphyadd": "2585 GOODELLS RD",
    "dropphycty": "GOODELLS",
    "dropphyst": "MI",
    "dropphyzpp": 480279998,
    "dropmaladd": "2585 GOODELLS RD",
    "dropmalcty": "GOODELLS",
    "dropmalst": "MI",
    "dropmalzpp": 480279998,
    "dropsitphn": 8103251650,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103251650,
    "dropfax": 8103251657
  },
  {
    "dcode": "D",
    "dropkey": "PY11965",
    "droptype": "D",
    "dropname": "GOODRICH",
    "dropdeladd": "8283 S STATE RD",
    "dropdelcty": "GOODRICH",
    "dropdelst": "MI",
    "dropdelzpp": 484389998,
    "dropphyadd": "8283 S STATE RD",
    "dropphycty": "GOODRICH",
    "dropphyst": "MI",
    "dropphyzpp": 484389998,
    "dropmaladd": "8283 S STATE RD",
    "dropmalcty": "GOODRICH",
    "dropmalst": "MI",
    "dropmalzpp": 484389998,
    "dropsitphn": 8106367933,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106367933,
    "dropfax": 8106366081
  },
  {
    "dcode": "D",
    "dropkey": "PY11966",
    "droptype": "D",
    "dropname": "GOULD CITY",
    "dropdeladd": "N6116 S GOULD CITY RD",
    "dropdelcty": "GOULD CITY",
    "dropdelst": "MI",
    "dropdelzpp": 498389800,
    "dropphyadd": "N6116 S GOULD CITY RD",
    "dropphycty": "GOULD CITY",
    "dropphyst": "MI",
    "dropphyzpp": 498389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOULD CITY",
    "dropmalst": "MI",
    "dropmalzpp": 498389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064776652,
    "dropsitcph": 9064776652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11967",
    "droptype": "D",
    "dropname": "GOWEN",
    "dropdeladd": "2922 OAK ST",
    "dropdelcty": "GOWEN",
    "dropdelst": "MI",
    "dropdelzpp": 493269648,
    "dropphyadd": "2922 OAK ST",
    "dropphycty": "GOWEN",
    "dropphyst": "MI",
    "dropphyzpp": 493269648,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOWEN",
    "dropmalst": "MI",
    "dropmalzpp": 493269998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6169842003,
    "dropfax": 6169842447
  },
  {
    "dcode": "D",
    "dropkey": "PY11971",
    "droptype": "D",
    "dropname": "GRAND BLANC",
    "dropdeladd": "11426 DAVIS ST",
    "dropdelcty": "GRAND BLANC",
    "dropdelst": "MI",
    "dropdelzpp": 484809998,
    "dropphyadd": "11426 DAVIS ST",
    "dropphycty": "GRAND BLANC",
    "dropphyst": "MI",
    "dropphyzpp": 484809998,
    "dropmaladd": "11426 DAVIS ST",
    "dropmalcty": "GRAND BLANC",
    "dropmalst": "MI",
    "dropmalzpp": 484809998,
    "dropsitphn": 8102571567,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106944241,
    "dropfax": 8106941643
  },
  {
    "dcode": "D",
    "dropkey": "PY11972",
    "droptype": "D",
    "dropname": "GRAND HAVEN",
    "dropdeladd": "324 WASHINGTON AVE STE 1",
    "dropdelcty": "GRAND HAVEN",
    "dropdelst": "MI",
    "dropdelzpp": 494179998,
    "dropphyadd": "324 WASHINGTON AVE STE 1",
    "dropphycty": "GRAND HAVEN",
    "dropphyst": "MI",
    "dropphyzpp": 494179998,
    "dropmaladd": "324 WASHINGTON AVE STE 1",
    "dropmalcty": "GRAND HAVEN",
    "dropmalst": "MI",
    "dropmalzpp": 494179998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6168420510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11975",
    "droptype": "D",
    "dropname": "GRAND JUNCTION",
    "dropdeladd": "54014 COUNTY ROAD 388",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "MI",
    "dropdelzpp": 490569225,
    "dropphyadd": "54014 COUNTY ROAD 388",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "MI",
    "dropphyzpp": 490569225,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "MI",
    "dropmalzpp": 490569998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2694346458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11976",
    "droptype": "D",
    "dropname": "GRAND LEDGE",
    "dropdeladd": "118 E JEFFERSON ST",
    "dropdelcty": "GRAND LEDGE",
    "dropdelst": "MI",
    "dropdelzpp": 488379998,
    "dropphyadd": "118 E JEFFERSON ST",
    "dropphycty": "GRAND LEDGE",
    "dropphyst": "MI",
    "dropphyzpp": 488379998,
    "dropmaladd": "118 E JEFFERSON ST",
    "dropmalcty": "GRAND LEDGE",
    "dropmalst": "MI",
    "dropmalzpp": 488379998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 5176272200,
    "dropfax": 5176274355
  },
  {
    "dcode": "D",
    "dropkey": "PY11977",
    "droptype": "D",
    "dropname": "GRAND MARAIS",
    "dropdeladd": "E21815 GRAND MARAIS AVE",
    "dropdelcty": "GRAND MARAIS",
    "dropdelst": "MI",
    "dropdelzpp": 498399801,
    "dropphyadd": "E21815 GRAND MARAIS AVE",
    "dropphycty": "GRAND MARAIS",
    "dropphyst": "MI",
    "dropphyzpp": 498399801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND MARAIS",
    "dropmalst": "MI",
    "dropmalzpp": 498399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064942631,
    "dropsitcph": 9064942631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11979",
    "droptype": "D",
    "dropname": "GRAND RAPIDS",
    "dropdeladd": "225 MICHIGAN ST NW",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495019901,
    "dropphyadd": "225 MICHIGAN ST NW",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495019901,
    "dropmaladd": "225 MICHIGAN ST NW",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495019901,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6167761575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11984",
    "droptype": "D",
    "dropname": "GRANDVILLE",
    "dropdeladd": "2939 WILSON AVE SW",
    "dropdelcty": "GRANDVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494189998,
    "dropphyadd": "2939 WILSON AVE SW",
    "dropphycty": "GRANDVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494189998,
    "dropmaladd": "2939 WILSON AVE SW",
    "dropmalcty": "GRANDVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494189998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6165343672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11986",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "79 W PINE ST",
    "dropdelcty": "GRANT",
    "dropdelst": "MI",
    "dropdelzpp": 493279117,
    "dropphyadd": "79 W PINE ST",
    "dropphycty": "GRANT",
    "dropphyst": "MI",
    "dropphyzpp": 493279117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANT",
    "dropmalst": "MI",
    "dropmalzpp": 493279998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2318345966,
    "dropfax": 2318345966
  },
  {
    "dcode": "D",
    "dropkey": "PY11989",
    "droptype": "D",
    "dropname": "GRASS LAKE",
    "dropdeladd": "221 E MICHIGAN AVE",
    "dropdelcty": "GRASS LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 492409998,
    "dropphyadd": "221 E MICHIGAN AVE",
    "dropphycty": "GRASS LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 492409998,
    "dropmaladd": "221 E MICHIGAN AVE",
    "dropmalcty": "GRASS LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 492409998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175225139,
    "dropfax": 5175223343
  },
  {
    "dcode": "D",
    "dropkey": "PY11993",
    "droptype": "D",
    "dropname": "GRAWN",
    "dropdeladd": "1568 STATE ST",
    "dropdelcty": "GRAWN",
    "dropdelst": "MI",
    "dropdelzpp": 496379462,
    "dropphyadd": "1568 STATE ST",
    "dropphycty": "GRAWN",
    "dropphyst": "MI",
    "dropphyzpp": 496379462,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAWN",
    "dropmalst": "MI",
    "dropmalzpp": 496379998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2312769871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11994",
    "droptype": "D",
    "dropname": "GRAYLING",
    "dropdeladd": "300 E MICHIGAN AVE",
    "dropdelcty": "GRAYLING",
    "dropdelst": "MI",
    "dropdelzpp": 497389998,
    "dropphyadd": "300 E MICHIGAN AVE",
    "dropphycty": "GRAYLING",
    "dropphyst": "MI",
    "dropphyzpp": 497389998,
    "dropmaladd": "300 E MICHIGAN AVE",
    "dropmalcty": "GRAYLING",
    "dropmalst": "MI",
    "dropmalzpp": 497389998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9893484591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY11999",
    "droptype": "D",
    "dropname": "GREENBUSH",
    "dropdeladd": "2398 S US HIGHWAY 23",
    "dropdelcty": "GREENBUSH",
    "dropdelst": "MI",
    "dropdelzpp": 487389689,
    "dropphyadd": "2398 S US HIGHWAY 23",
    "dropphycty": "GREENBUSH",
    "dropphyst": "MI",
    "dropphyzpp": 487389689,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENBUSH",
    "dropmalst": "MI",
    "dropmalzpp": 487389998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897246896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12001",
    "droptype": "D",
    "dropname": "GREENLAND",
    "dropdeladd": "311 PLANK RD",
    "dropdelcty": "GREENLAND",
    "dropdelst": "MI",
    "dropdelzpp": 499299800,
    "dropphyadd": "311 PLANK RD",
    "dropphycty": "GREENLAND",
    "dropphyst": "MI",
    "dropphyzpp": 499299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENLAND",
    "dropmalst": "MI",
    "dropmalzpp": 499299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068833530,
    "dropsitcph": 6072700801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12003",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "119 W CASS ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488389998,
    "dropphyadd": "119 W CASS ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488389998,
    "dropmaladd": "119 W CASS ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488389998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6167548732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12007",
    "droptype": "D",
    "dropname": "GREGORY",
    "dropdeladd": "114 E M 36",
    "dropdelcty": "GREGORY",
    "dropdelst": "MI",
    "dropdelzpp": 481379998,
    "dropphyadd": "114 E M 36",
    "dropphycty": "GREGORY",
    "dropphyst": "MI",
    "dropphyzpp": 481379998,
    "dropmaladd": "114 E M 36",
    "dropmalcty": "GREGORY",
    "dropmalst": "MI",
    "dropmalzpp": 481379998,
    "dropsitphn": 7344982609,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344982609,
    "dropfax": 7344983109
  },
  {
    "dcode": "D",
    "dropkey": "PY12010",
    "droptype": "D",
    "dropname": "GROSSE ILE",
    "dropdeladd": "8841 MACOMB ST",
    "dropdelcty": "GROSSE ILE",
    "dropdelst": "MI",
    "dropdelzpp": 481389998,
    "dropphyadd": "8841 MACOMB ST",
    "dropphycty": "GROSSE ILE",
    "dropphyst": "MI",
    "dropphyzpp": 481389998,
    "dropmaladd": "8841 MACOMB ST",
    "dropmalcty": "GROSSE ILE",
    "dropmalst": "MI",
    "dropmalzpp": 481389998,
    "dropsitphn": 7346760696,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346760696,
    "dropfax": 7346768432
  },
  {
    "dcode": "D",
    "dropkey": "PY12018",
    "droptype": "D",
    "dropname": "GULLIVER",
    "dropdeladd": "2926W US HIGHWAY 2",
    "dropdelcty": "GULLIVER",
    "dropdelst": "MI",
    "dropdelzpp": 498409025,
    "dropphyadd": "2926W US HIGHWAY 2",
    "dropphycty": "GULLIVER",
    "dropphyst": "MI",
    "dropphyzpp": 498409025,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GULLIVER",
    "dropmalst": "MI",
    "dropmalzpp": 498409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062833349,
    "dropsitcph": 9062833349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12019",
    "droptype": "D",
    "dropname": "GWINN",
    "dropdeladd": "95 N PINE ST",
    "dropdelcty": "GWINN",
    "dropdelst": "MI",
    "dropdelzpp": 498419998,
    "dropphyadd": "95 N PINE ST",
    "dropphycty": "GWINN",
    "dropphyst": "MI",
    "dropphyzpp": 498419998,
    "dropmaladd": "95 N PINE ST",
    "dropmalcty": "GWINN",
    "dropmalst": "MI",
    "dropmalzpp": 498419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063469322,
    "dropsitcph": 9063469322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12020",
    "droptype": "D",
    "dropname": "HADLEY",
    "dropdeladd": "3481 HADLEY RD",
    "dropdelcty": "HADLEY",
    "dropdelst": "MI",
    "dropdelzpp": 484409998,
    "dropphyadd": "3481 HADLEY RD",
    "dropphycty": "HADLEY",
    "dropphyst": "MI",
    "dropphyzpp": 484409998,
    "dropmaladd": "3481 HADLEY RD",
    "dropmalcty": "HADLEY",
    "dropmalst": "MI",
    "dropmalzpp": 484409998,
    "dropsitphn": 8107974645,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107974645,
    "dropfax": 8107975448
  },
  {
    "dcode": "D",
    "dropkey": "PY12024",
    "droptype": "D",
    "dropname": "HALE",
    "dropdeladd": "121 E MAIN ST",
    "dropdelcty": "HALE",
    "dropdelst": "MI",
    "dropdelzpp": 487398527,
    "dropphyadd": "121 E MAIN ST",
    "dropphycty": "HALE",
    "dropphyst": "MI",
    "dropphyzpp": 487398527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HALE",
    "dropmalst": "MI",
    "dropmalzpp": 487399998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897284401,
    "dropsitcph": 9897284401,
    "dropfax": 9897286614
  },
  {
    "dcode": "D",
    "dropkey": "PY12026",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "7420 E MI STATE ROAD 36",
    "dropdelcty": "HAMBURG",
    "dropdelst": "MI",
    "dropdelzpp": 481391006,
    "dropphyadd": "7420 E MI STATE ROAD 36",
    "dropphycty": "HAMBURG",
    "dropphyst": "MI",
    "dropphyzpp": 481391006,
    "dropmaladd": "7420 E MI STATE ROAD 36",
    "dropmalcty": "HAMBURG",
    "dropmalst": "MI",
    "dropmalzpp": 481391006,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 8102312701,
    "dropfax": 8102311201
  },
  {
    "dcode": "D",
    "dropkey": "PY12027",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "4668 PINE ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "MI",
    "dropdelzpp": 494199019,
    "dropphyadd": "4668 PINE ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "MI",
    "dropphyzpp": 494199019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMILTON",
    "dropmalst": "MI",
    "dropmalzpp": 494199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697515300,
    "dropsitcph": 2697515300,
    "dropfax": 2697515300
  },
  {
    "dcode": "D",
    "dropkey": "PY12030",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "221 QUINCY ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "MI",
    "dropdelzpp": 499301816,
    "dropphyadd": "221 QUINCY ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "MI",
    "dropphyzpp": 499301816,
    "dropmaladd": "221 QUINCY ST",
    "dropmalcty": "HANCOCK",
    "dropmalst": "MI",
    "dropmalzpp": 499301816,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064821721,
    "dropsitcph": 9064821721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12031",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "175 W MAIN ST",
    "dropdelcty": "HANOVER",
    "dropdelst": "MI",
    "dropdelzpp": 492419998,
    "dropphyadd": "175 W MAIN ST",
    "dropphycty": "HANOVER",
    "dropphyst": "MI",
    "dropphyzpp": 492419998,
    "dropmaladd": "175 W MAIN ST",
    "dropmalcty": "HANOVER",
    "dropmalst": "MI",
    "dropmalzpp": 492419998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175632976,
    "dropfax": 5175632796
  },
  {
    "dcode": "D",
    "dropkey": "PY12032",
    "droptype": "D",
    "dropname": "HARBERT",
    "dropdeladd": "13785 RED ARROW HWY",
    "dropdelcty": "HARBERT",
    "dropdelst": "MI",
    "dropdelzpp": 491159800,
    "dropphyadd": "13785 RED ARROW HWY",
    "dropphycty": "HARBERT",
    "dropphyst": "MI",
    "dropphyzpp": 491159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARBERT",
    "dropmalst": "MI",
    "dropmalzpp": 491159998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696126023,
    "dropsitcph": 2696126023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12033",
    "droptype": "D",
    "dropname": "HARBOR BEACH",
    "dropdeladd": "110 SCHOOL ST",
    "dropdelcty": "HARBOR BEACH",
    "dropdelst": "MI",
    "dropdelzpp": 484419998,
    "dropphyadd": "110 SCHOOL ST",
    "dropphycty": "HARBOR BEACH",
    "dropphyst": "MI",
    "dropphyzpp": 484419998,
    "dropmaladd": "110 SCHOOL ST",
    "dropmalcty": "HARBOR BEACH",
    "dropmalst": "MI",
    "dropmalzpp": 484419998,
    "dropsitphn": 9894790441,
    "dropsitlph": 8102571580,
    "dropsitcph": 9894790441,
    "dropfax": 9894793160
  },
  {
    "dcode": "D",
    "dropkey": "PY12035",
    "droptype": "D",
    "dropname": "HARBOR SPRINGS",
    "dropdeladd": "250 STATE ST",
    "dropdelcty": "HARBOR SPRINGS",
    "dropdelst": "MI",
    "dropdelzpp": 497409998,
    "dropphyadd": "250 STATE ST",
    "dropphycty": "HARBOR SPRINGS",
    "dropphyst": "MI",
    "dropphyzpp": 497409998,
    "dropmaladd": "250 STATE ST",
    "dropmalcty": "HARBOR SPRINGS",
    "dropmalst": "MI",
    "dropmalzpp": 497409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315262521,
    "dropsitcph": 2315262521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12040",
    "droptype": "D",
    "dropname": "HARRIETTA",
    "dropdeladd": "108 S DAVIS ST",
    "dropdelcty": "HARRIETTA",
    "dropdelst": "MI",
    "dropdelzpp": 496385110,
    "dropphyadd": "108 S DAVIS ST",
    "dropphycty": "HARRIETTA",
    "dropphyst": "MI",
    "dropphyzpp": 496385110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRIETTA",
    "dropmalst": "MI",
    "dropmalzpp": 496389998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313892841,
    "dropsitcph": 2313892841,
    "dropfax": 2313890114
  },
  {
    "dcode": "D",
    "dropkey": "PY12041",
    "droptype": "D",
    "dropname": "HARRIS",
    "dropdeladd": "W555 US HIGHWAY 2 41",
    "dropdelcty": "HARRIS",
    "dropdelst": "MI",
    "dropdelzpp": 498459800,
    "dropphyadd": "W555 US HIGHWAY 2 41",
    "dropphycty": "HARRIS",
    "dropphyst": "MI",
    "dropphyzpp": 498459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRIS",
    "dropmalst": "MI",
    "dropmalzpp": 498459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064662415,
    "dropsitcph": 9064662415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12042",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "191 S 1ST ST",
    "dropdelcty": "HARRISON",
    "dropdelst": "MI",
    "dropdelzpp": 486252556,
    "dropphyadd": "191 S 1ST ST",
    "dropphycty": "HARRISON",
    "dropphyst": "MI",
    "dropphyzpp": 486252556,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISON",
    "dropmalst": "MI",
    "dropmalzpp": 486259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895393100,
    "dropsitcph": 9895397433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12045",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "109 1ST ST",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487409800,
    "dropphyadd": "109 1ST ST",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897246288,
    "dropsitcph": 9897246288,
    "dropfax": 9897246288
  },
  {
    "dcode": "D",
    "dropkey": "PY12046",
    "droptype": "D",
    "dropname": "HARSENS ISLAND",
    "dropdeladd": "235 LA CROIX RD",
    "dropdelcty": "HARSENS ISLAND",
    "dropdelst": "MI",
    "dropdelzpp": 480289998,
    "dropphyadd": "235 LA CROIX RD",
    "dropphycty": "HARSENS ISLAND",
    "dropphyst": "MI",
    "dropphyzpp": 480289998,
    "dropmaladd": "235 LA CROIX RD",
    "dropmalcty": "HARSENS ISLAND",
    "dropmalst": "MI",
    "dropmalzpp": 480289998,
    "dropsitphn": 8107943821,
    "dropsitlph": 2487585622,
    "dropsitcph": 8107489979,
    "dropfax": 8107488932
  },
  {
    "dcode": "D",
    "dropkey": "PY12047",
    "droptype": "D",
    "dropname": "HART",
    "dropdeladd": "135 S STATE ST",
    "dropdelcty": "HART",
    "dropdelst": "MI",
    "dropdelzpp": 494209998,
    "dropphyadd": "135 S STATE ST",
    "dropphycty": "HART",
    "dropphyst": "MI",
    "dropphyzpp": 494209998,
    "dropmaladd": "135 S STATE ST",
    "dropmalcty": "HART",
    "dropmalst": "MI",
    "dropmalzpp": 494209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318732850,
    "dropsitcph": 2318732850,
    "dropfax": 2318730178
  },
  {
    "dcode": "D",
    "dropkey": "PY12048",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "19 N CENTER ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "MI",
    "dropdelzpp": 490579998,
    "dropphyadd": "19 N CENTER ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "MI",
    "dropphyzpp": 490579998,
    "dropmaladd": "19 N CENTER ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "MI",
    "dropmalzpp": 490579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696213701,
    "dropsitcph": 2696213701,
    "dropfax": 2696214024
  },
  {
    "dcode": "D",
    "dropkey": "PY12050",
    "droptype": "D",
    "dropname": "HARTLAND",
    "dropdeladd": "10246 CROUSE RD",
    "dropdelcty": "HARTLAND",
    "dropdelst": "MI",
    "dropdelzpp": 483539998,
    "dropphyadd": "10246 CROUSE RD",
    "dropphycty": "HARTLAND",
    "dropphyst": "MI",
    "dropphyzpp": 483539998,
    "dropmaladd": "10246 CROUSE RD",
    "dropmalcty": "HARTLAND",
    "dropmalst": "MI",
    "dropmalzpp": 483539998,
    "dropsitphn": 8106324395,
    "dropsitlph": 2487585622,
    "dropsitcph": 8106324395,
    "dropfax": 8106323071
  },
  {
    "dcode": "D",
    "dropkey": "PY12053",
    "droptype": "D",
    "dropname": "HASLETT",
    "dropdeladd": "1518 HASLETT RD",
    "dropdelcty": "HASLETT",
    "dropdelst": "MI",
    "dropdelzpp": 488408504,
    "dropphyadd": "1518 HASLETT RD",
    "dropphycty": "HASLETT",
    "dropphyst": "MI",
    "dropphyzpp": 488408504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HASLETT",
    "dropmalst": "MI",
    "dropmalzpp": 488409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173492461,
    "dropsitcph": 5173392231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12054",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "209 W MILL ST",
    "dropdelcty": "HASTINGS",
    "dropdelst": "MI",
    "dropdelzpp": 490589998,
    "dropphyadd": "209 W MILL ST",
    "dropphycty": "HASTINGS",
    "dropphyst": "MI",
    "dropphyzpp": 490589998,
    "dropmaladd": "209 W MILL ST",
    "dropmalcty": "HASTINGS",
    "dropmalst": "MI",
    "dropmalzpp": 490589998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699454273,
    "dropsitcph": 2699454273,
    "dropfax": 2699455864
  },
  {
    "dcode": "D",
    "dropkey": "PY12055",
    "droptype": "D",
    "dropname": "HAWKS",
    "dropdeladd": "8129 F-21 HWY",
    "dropdelcty": "HAWKS",
    "dropdelst": "MI",
    "dropdelzpp": 497438724,
    "dropphyadd": "8129 F-21 HWY",
    "dropphycty": "HAWKS",
    "dropphyst": "MI",
    "dropphyzpp": 497438724,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWKS",
    "dropmalst": "MI",
    "dropmalzpp": 497439998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897344366,
    "dropsitcph": 9897344366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12057",
    "droptype": "D",
    "dropname": "HAZEL PARK",
    "dropdeladd": "23200 JOHN R RD",
    "dropdelcty": "HAZEL PARK",
    "dropdelst": "MI",
    "dropdelzpp": 480309998,
    "dropphyadd": "23200 JOHN R RD",
    "dropphycty": "HAZEL PARK",
    "dropphyst": "MI",
    "dropphyzpp": 480309998,
    "dropmaladd": "23200 JOHN R RD",
    "dropmalcty": "HAZEL PARK",
    "dropmalst": "MI",
    "dropmalzpp": 480309998,
    "dropsitphn": 2485424227,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485424227,
    "dropfax": 2485424518
  },
  {
    "dcode": "D",
    "dropkey": "PY12059",
    "droptype": "D",
    "dropname": "HEMLOCK",
    "dropdeladd": "215 S HEMLOCK RD",
    "dropdelcty": "HEMLOCK",
    "dropdelst": "MI",
    "dropdelzpp": 486269800,
    "dropphyadd": "215 S HEMLOCK RD",
    "dropphycty": "HEMLOCK",
    "dropphyst": "MI",
    "dropphyzpp": 486269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEMLOCK",
    "dropmalst": "MI",
    "dropmalzpp": 486269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896428454,
    "dropsitcph": 9896428454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12060",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "121 W MAIN",
    "dropdelcty": "HENDERSON",
    "dropdelst": "MI",
    "dropdelzpp": 488418700,
    "dropphyadd": "121 W MAIN",
    "dropphycty": "HENDERSON",
    "dropphyst": "MI",
    "dropphyzpp": 488418700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENDERSON",
    "dropmalst": "MI",
    "dropmalzpp": 488419998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897235324,
    "dropsitcph": 9897235324,
    "dropfax": 9897231277
  },
  {
    "dcode": "D",
    "dropkey": "PY12062",
    "droptype": "D",
    "dropname": "HERMANSVILLE",
    "dropdeladd": "W5444 2ND ST",
    "dropdelcty": "HERMANSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 498479400,
    "dropphyadd": "W5444 2ND ST",
    "dropphycty": "HERMANSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 498479400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERMANSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 498479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064982361,
    "dropsitcph": 9064982361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12063",
    "droptype": "D",
    "dropname": "HERRON",
    "dropdeladd": "10084 M 32 W",
    "dropdelcty": "HERRON",
    "dropdelst": "MI",
    "dropdelzpp": 497449790,
    "dropphyadd": "10084 M 32 W",
    "dropphycty": "HERRON",
    "dropphyst": "MI",
    "dropphyzpp": 497449790,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERRON",
    "dropmalst": "MI",
    "dropmalzpp": 497449998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893794256,
    "dropsitcph": 9893794256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12064",
    "droptype": "D",
    "dropname": "HERSEY",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "HERSEY",
    "dropdelst": "MI",
    "dropdelzpp": 496395115,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "HERSEY",
    "dropphyst": "MI",
    "dropphyzpp": 496395115,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERSEY",
    "dropmalst": "MI",
    "dropmalzpp": 496399998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318322671,
    "dropsitcph": 2318322671,
    "dropfax": 2318322671
  },
  {
    "dcode": "D",
    "dropkey": "PY12065",
    "droptype": "D",
    "dropname": "HESPERIA",
    "dropdeladd": "100 W MICHIGAN AVE",
    "dropdelcty": "HESPERIA",
    "dropdelst": "MI",
    "dropdelzpp": 494218609,
    "dropphyadd": "100 W MICHIGAN AVE",
    "dropphycty": "HESPERIA",
    "dropphyst": "MI",
    "dropphyzpp": 494218609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HESPERIA",
    "dropmalst": "MI",
    "dropmalzpp": 494219998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318541333,
    "dropsitcph": 2318541333,
    "dropfax": 2318542800
  },
  {
    "dcode": "D",
    "dropkey": "PY12066",
    "droptype": "D",
    "dropname": "HESSEL",
    "dropdeladd": "3042 LAKE ST",
    "dropdelcty": "HESSEL",
    "dropdelst": "MI",
    "dropdelzpp": 497459801,
    "dropphyadd": "3042 LAKE ST",
    "dropphycty": "HESSEL",
    "dropphyst": "MI",
    "dropphyzpp": 497459801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HESSEL",
    "dropmalst": "MI",
    "dropmalzpp": 497459998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064843522,
    "dropsitcph": 9064843522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12068",
    "droptype": "D",
    "dropname": "HICKORY CORNERS",
    "dropdeladd": "14737 KELLOGG SCHOOL RD",
    "dropdelcty": "HICKORY CORNERS",
    "dropdelst": "MI",
    "dropdelzpp": 490609738,
    "dropphyadd": "14737 KELLOGG SCHOOL RD",
    "dropphycty": "HICKORY CORNERS",
    "dropphyst": "MI",
    "dropphyzpp": 490609738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKORY CORNERS",
    "dropmalst": "MI",
    "dropmalzpp": 490609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696715252,
    "dropsitcph": 2696715252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12071",
    "droptype": "D",
    "dropname": "HIGGINS LAKE",
    "dropdeladd": "6311 W HIGGINS LAKE DR",
    "dropdelcty": "HIGGINS LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 486279800,
    "dropphyadd": "6311 W HIGGINS LAKE DR",
    "dropphycty": "HIGGINS LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 486279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGGINS LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 486279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898219713,
    "dropsitcph": 9898219713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12072",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "376 BEACH FARM CIR",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "MI",
    "dropdelzpp": 483569998,
    "dropphyadd": "376 BEACH FARM CIR",
    "dropphycty": "HIGHLAND",
    "dropphyst": "MI",
    "dropphyzpp": 483569998,
    "dropmaladd": "376 BEACH FARM CIR",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "MI",
    "dropmalzpp": 483569998,
    "dropsitphn": 2488874722,
    "dropsitlph": 2487585622,
    "dropsitcph": 2488874722,
    "dropfax": 2488890107
  },
  {
    "dcode": "D",
    "dropkey": "PY12077",
    "droptype": "D",
    "dropname": "HILLMAN",
    "dropdeladd": "111 N STATE ST",
    "dropdelcty": "HILLMAN",
    "dropdelst": "MI",
    "dropdelzpp": 497468275,
    "dropphyadd": "111 N STATE ST",
    "dropphycty": "HILLMAN",
    "dropphyst": "MI",
    "dropphyzpp": 497468275,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLMAN",
    "dropmalst": "MI",
    "dropmalzpp": 497469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897424423,
    "dropsitcph": 9897424423,
    "dropfax": 9897423851
  },
  {
    "dcode": "D",
    "dropkey": "PY12078",
    "droptype": "D",
    "dropname": "HILLSDALE",
    "dropdeladd": "99 N BROAD ST",
    "dropdelcty": "HILLSDALE",
    "dropdelst": "MI",
    "dropdelzpp": 492429998,
    "dropphyadd": "99 N BROAD ST",
    "dropphycty": "HILLSDALE",
    "dropphyst": "MI",
    "dropphyzpp": 492429998,
    "dropmaladd": "99 N BROAD ST",
    "dropmalcty": "HILLSDALE",
    "dropmalst": "MI",
    "dropmalzpp": 492429998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174371251,
    "dropfax": 5174370537
  },
  {
    "dcode": "D",
    "dropkey": "PY12079",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "190 E 8TH ST",
    "dropdelcty": "HOLLAND",
    "dropdelst": "MI",
    "dropdelzpp": 494239998,
    "dropphyadd": "190 E 8TH ST",
    "dropphycty": "HOLLAND",
    "dropphyst": "MI",
    "dropphyzpp": 494239998,
    "dropmaladd": "190 E 8TH ST",
    "dropmalcty": "HOLLAND",
    "dropmalst": "MI",
    "dropmalzpp": 494239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163965201,
    "dropsitcph": 6163965201,
    "dropfax": 6163961194
  },
  {
    "dcode": "D",
    "dropkey": "PY12080",
    "droptype": "D",
    "dropname": "HOLLY",
    "dropdeladd": "108 W MAPLE ST",
    "dropdelcty": "HOLLY",
    "dropdelst": "MI",
    "dropdelzpp": 484429998,
    "dropphyadd": "108 W MAPLE ST",
    "dropphycty": "HOLLY",
    "dropphyst": "MI",
    "dropphyzpp": 484429998,
    "dropmaladd": "108 W MAPLE ST",
    "dropmalcty": "HOLLY",
    "dropmalst": "MI",
    "dropmalzpp": 484429998,
    "dropsitphn": 2486348362,
    "dropsitlph": 8102571580,
    "dropsitcph": 2486348362,
    "dropfax": 2486341226
  },
  {
    "dcode": "D",
    "dropkey": "PY12081",
    "droptype": "D",
    "dropname": "HOLT",
    "dropdeladd": "2190 AURELIUS RD",
    "dropdelcty": "HOLT",
    "dropdelst": "MI",
    "dropdelzpp": 488429998,
    "dropphyadd": "2190 AURELIUS RD",
    "dropphycty": "HOLT",
    "dropphyst": "MI",
    "dropphyzpp": 488429998,
    "dropmaladd": "2190 AURELIUS RD",
    "dropmalcty": "HOLT",
    "dropmalst": "MI",
    "dropmalzpp": 488429998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176992079,
    "dropsitcph": 5176992079,
    "dropfax": 5176993047
  },
  {
    "dcode": "D",
    "dropkey": "PY12082",
    "droptype": "D",
    "dropname": "HOLTON",
    "dropdeladd": "8779 HOLTON DUCK LAKE RD",
    "dropdelcty": "HOLTON",
    "dropdelst": "MI",
    "dropdelzpp": 494257540,
    "dropphyadd": "8779 HOLTON DUCK LAKE RD",
    "dropphycty": "HOLTON",
    "dropphyst": "MI",
    "dropphyzpp": 494257540,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLTON",
    "dropmalst": "MI",
    "dropmalzpp": 494259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318210129,
    "dropsitcph": 2318210129,
    "dropfax": 2318210752
  },
  {
    "dcode": "D",
    "dropkey": "PY12083",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "110 W MAIN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "MI",
    "dropdelzpp": 492451024,
    "dropphyadd": "110 W MAIN ST",
    "dropphycty": "HOMER",
    "dropphyst": "MI",
    "dropphyzpp": 492451024,
    "dropmaladd": "110 W MAIN ST",
    "dropmalcty": "HOMER",
    "dropmalst": "MI",
    "dropmalzpp": 492451024,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175684865,
    "dropfax": 5175683697
  },
  {
    "dcode": "D",
    "dropkey": "PY12084",
    "droptype": "D",
    "dropname": "HONOR",
    "dropdeladd": "10982 MAIN ST",
    "dropdelcty": "HONOR",
    "dropdelst": "MI",
    "dropdelzpp": 496409800,
    "dropphyadd": "10982 MAIN ST",
    "dropphycty": "HONOR",
    "dropphyst": "MI",
    "dropphyzpp": 496409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONOR",
    "dropmalst": "MI",
    "dropmalzpp": 496409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313252112,
    "dropsitcph": 2313252112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12086",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "5230 N HOPE RD",
    "dropdelcty": "HOPE",
    "dropdelst": "MI",
    "dropdelzpp": 486289755,
    "dropphyadd": "5230 N HOPE RD",
    "dropphycty": "HOPE",
    "dropphyst": "MI",
    "dropphyzpp": 486289755,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPE",
    "dropmalst": "MI",
    "dropmalzpp": 486289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896894431,
    "dropsitcph": 9896894431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12087",
    "droptype": "D",
    "dropname": "HOPKINS",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "HOPKINS",
    "dropdelst": "MI",
    "dropdelzpp": 493289575,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "HOPKINS",
    "dropphyst": "MI",
    "dropphyzpp": 493289575,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPKINS",
    "dropmalst": "MI",
    "dropmalzpp": 493289998,
    "dropsitphn": 2697937427,
    "dropsitlph": 2697937427,
    "dropsitcph": 2697937427,
    "dropfax": 2697937427
  },
  {
    "dcode": "D",
    "dropkey": "PY12089",
    "droptype": "D",
    "dropname": "HORTON",
    "dropdeladd": "220 MAIN ST",
    "dropdelcty": "HORTON",
    "dropdelst": "MI",
    "dropdelzpp": 492469998,
    "dropphyadd": "220 MAIN ST",
    "dropphycty": "HORTON",
    "dropphyst": "MI",
    "dropphyzpp": 492469998,
    "dropmaladd": "220 MAIN ST",
    "dropmalcty": "HORTON",
    "dropmalst": "MI",
    "dropmalzpp": 492469998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175632014,
    "dropfax": 5175638160
  },
  {
    "dcode": "D",
    "dropkey": "PY12091",
    "droptype": "D",
    "dropname": "HOUGHTON",
    "dropdeladd": "701 SHELDEN AVE",
    "dropdelcty": "HOUGHTON",
    "dropdelst": "MI",
    "dropdelzpp": 499319998,
    "dropphyadd": "701 SHELDEN AVE",
    "dropphycty": "HOUGHTON",
    "dropphyst": "MI",
    "dropphyzpp": 499319998,
    "dropmaladd": "701 SHELDEN AVE",
    "dropmalcty": "HOUGHTON",
    "dropmalst": "MI",
    "dropmalzpp": 499319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064825810,
    "dropsitcph": 9064825810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12092",
    "droptype": "D",
    "dropname": "HOUGHTON LAKE",
    "dropdeladd": "2255 TOWER HILL RD",
    "dropdelcty": "HOUGHTON LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 486299498,
    "dropphyadd": "2255 TOWER HILL RD",
    "dropphycty": "HOUGHTON LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 486299498,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUGHTON LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 486299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894224110,
    "dropsitcph": 9894224110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12094",
    "droptype": "D",
    "dropname": "HOUGHTON LAKE HEIGHTS",
    "dropdeladd": "1641 HEIGHTSVIEW DR",
    "dropdelcty": "HOUGHTON LAKE HEIGHTS",
    "dropdelst": "MI",
    "dropdelzpp": 486309800,
    "dropphyadd": "1641 HEIGHTSVIEW DR",
    "dropphycty": "HOUGHTON LAKE HEIGHTS",
    "dropphyst": "MI",
    "dropphyzpp": 486309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUGHTON LAKE HEIGHTS",
    "dropmalst": "MI",
    "dropmalzpp": 486309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894225572,
    "dropsitcph": 9894225572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12095",
    "droptype": "D",
    "dropname": "HOWARD CITY",
    "dropdeladd": "107 E EDGERTON ST",
    "dropdelcty": "HOWARD CITY",
    "dropdelst": "MI",
    "dropdelzpp": 493295114,
    "dropphyadd": "107 E EDGERTON ST",
    "dropphycty": "HOWARD CITY",
    "dropphyst": "MI",
    "dropphyzpp": 493295114,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOWARD CITY",
    "dropmalst": "MI",
    "dropmalzpp": 493299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312791096,
    "dropsitcph": 2312791096,
    "dropfax": 2319379684
  },
  {
    "dcode": "D",
    "dropkey": "PY12098",
    "droptype": "D",
    "dropname": "HOWELL",
    "dropdeladd": "325 S MICHIGAN AVE",
    "dropdelcty": "HOWELL",
    "dropdelst": "MI",
    "dropdelzpp": 488439998,
    "dropphyadd": "325 S MICHIGAN AVE",
    "dropphycty": "HOWELL",
    "dropphyst": "MI",
    "dropphyzpp": 488439998,
    "dropmaladd": "325 S MICHIGAN AVE",
    "dropmalcty": "HOWELL",
    "dropmalst": "MI",
    "dropmalzpp": 488439998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5175462582,
    "dropsitcph": 5175462582,
    "dropfax": 5175469434
  },
  {
    "dcode": "D",
    "dropkey": "PY12100",
    "droptype": "D",
    "dropname": "HUBBARD LAKE",
    "dropdeladd": "13818 HUBBARD LAKE RD",
    "dropdelcty": "HUBBARD LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497479564,
    "dropphyadd": "13818 HUBBARD LAKE RD",
    "dropphycty": "HUBBARD LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497479564,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBARD LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497479998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897272220,
    "dropsitcph": 9897272220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12101",
    "droptype": "D",
    "dropname": "HUBBARDSTON",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "HUBBARDSTON",
    "dropdelst": "MI",
    "dropdelzpp": 488455115,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "HUBBARDSTON",
    "dropphyst": "MI",
    "dropphyzpp": 488455115,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBARDSTON",
    "dropmalst": "MI",
    "dropmalzpp": 488459998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9899816850,
    "dropsitcph": 9899816850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12102",
    "droptype": "D",
    "dropname": "HUBBELL",
    "dropdeladd": "52210 DUNCAN AVE",
    "dropdelcty": "HUBBELL",
    "dropdelst": "MI",
    "dropdelzpp": 499349800,
    "dropphyadd": "52210 DUNCAN AVE",
    "dropphycty": "HUBBELL",
    "dropphyst": "MI",
    "dropphyzpp": 499349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUBBELL",
    "dropmalst": "MI",
    "dropmalzpp": 499349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062960001,
    "dropsitcph": 9062960001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12103",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "401 W MAIN ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "MI",
    "dropdelzpp": 492479998,
    "dropphyadd": "401 W MAIN ST",
    "dropphycty": "HUDSON",
    "dropphyst": "MI",
    "dropphyzpp": 492479998,
    "dropmaladd": "401 W MAIN ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "MI",
    "dropmalzpp": 492479998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174488476,
    "dropfax": 5174487721
  },
  {
    "dcode": "D",
    "dropkey": "PY12105",
    "droptype": "D",
    "dropname": "HUDSONVILLE",
    "dropdeladd": "3333 CENTRAL BLVD",
    "dropdelcty": "HUDSONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494269998,
    "dropphyadd": "3333 CENTRAL BLVD",
    "dropphycty": "HUDSONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494269998,
    "dropmaladd": "3333 CENTRAL BLVD",
    "dropmalcty": "HUDSONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166699456,
    "dropsitcph": 6166699456,
    "dropfax": 6166692162
  },
  {
    "dcode": "D",
    "dropkey": "PY12107",
    "droptype": "D",
    "dropname": "HULBERT",
    "dropdeladd": "10395 S MAPLE ST",
    "dropdelcty": "HULBERT",
    "dropdelst": "MI",
    "dropdelzpp": 497489800,
    "dropphyadd": "10395 S MAPLE ST",
    "dropphycty": "HULBERT",
    "dropphyst": "MI",
    "dropphyzpp": 497489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HULBERT",
    "dropmalst": "MI",
    "dropmalzpp": 497489998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9068762368,
    "dropsitcph": 9068762368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12114",
    "droptype": "D",
    "dropname": "IDA",
    "dropdeladd": "2888 LEWIS AVE",
    "dropdelcty": "IDA",
    "dropdelst": "MI",
    "dropdelzpp": 481409998,
    "dropphyadd": "2888 LEWIS AVE",
    "dropphycty": "IDA",
    "dropphyst": "MI",
    "dropphyzpp": 481409998,
    "dropmaladd": "2888 LEWIS AVE",
    "dropmalcty": "IDA",
    "dropmalst": "MI",
    "dropmalzpp": 481409998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7342692923,
    "dropfax": 7342692257
  },
  {
    "dcode": "D",
    "dropkey": "PY12115",
    "droptype": "D",
    "dropname": "IDLEWILD",
    "dropdeladd": "812 E ESSEX",
    "dropdelcty": "IDLEWILD",
    "dropdelst": "MI",
    "dropdelzpp": 496429770,
    "dropphyadd": "812 E ESSEX",
    "dropphycty": "IDLEWILD",
    "dropphyst": "MI",
    "dropphyzpp": 496429770,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IDLEWILD",
    "dropmalst": "MI",
    "dropmalzpp": 496429998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317457241,
    "dropsitcph": 2317457241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12117",
    "droptype": "D",
    "dropname": "IMLAY CITY",
    "dropdeladd": "310 E 3RD ST",
    "dropdelcty": "IMLAY CITY",
    "dropdelst": "MI",
    "dropdelzpp": 484449998,
    "dropphyadd": "310 E 3RD ST",
    "dropphycty": "IMLAY CITY",
    "dropphyst": "MI",
    "dropphyzpp": 484449998,
    "dropmaladd": "310 E 3RD ST",
    "dropmalcty": "IMLAY CITY",
    "dropmalst": "MI",
    "dropmalzpp": 484449998,
    "dropsitphn": 8107247545,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107247545,
    "dropfax": 8107247823
  },
  {
    "dcode": "D",
    "dropkey": "PY12121",
    "droptype": "D",
    "dropname": "INDIAN RIVER",
    "dropdeladd": "6095 LAKE ST",
    "dropdelcty": "INDIAN RIVER",
    "dropdelst": "MI",
    "dropdelzpp": 497499800,
    "dropphyadd": "6095 LAKE ST",
    "dropphycty": "INDIAN RIVER",
    "dropphyst": "MI",
    "dropphyzpp": 497499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIAN RIVER",
    "dropmalst": "MI",
    "dropmalzpp": 497499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312387242,
    "dropsitcph": 2312387242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12122",
    "droptype": "D",
    "dropname": "INGALLS",
    "dropdeladd": "N7303 US HIGHWAY 41",
    "dropdelcty": "INGALLS",
    "dropdelst": "MI",
    "dropdelzpp": 498489228,
    "dropphyadd": "N7303 US HIGHWAY 41",
    "dropphycty": "INGALLS",
    "dropphyst": "MI",
    "dropphyzpp": 498489228,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INGALLS",
    "dropmalst": "MI",
    "dropmalzpp": 498489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067532700,
    "dropsitcph": 9067534167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12123",
    "droptype": "D",
    "dropname": "INKSTER",
    "dropdeladd": "27631 MICHIGAN AVE",
    "dropdelcty": "INKSTER",
    "dropdelst": "MI",
    "dropdelzpp": 481419998,
    "dropphyadd": "27631 MICHIGAN AVE",
    "dropphycty": "INKSTER",
    "dropphyst": "MI",
    "dropphyzpp": 481419998,
    "dropmaladd": "27631 MICHIGAN AVE",
    "dropmalcty": "INKSTER",
    "dropmalst": "MI",
    "dropmalzpp": 481419998,
    "dropsitphn": 3135611564,
    "dropsitlph": 3132268554,
    "dropsitcph": 3135611564,
    "dropfax": 3135611415
  },
  {
    "dcode": "D",
    "dropkey": "PY12124",
    "droptype": "D",
    "dropname": "INTERLOCHEN",
    "dropdeladd": "9508 9TH ST",
    "dropdelcty": "INTERLOCHEN",
    "dropdelst": "MI",
    "dropdelzpp": 496439806,
    "dropphyadd": "9508 9TH ST",
    "dropphycty": "INTERLOCHEN",
    "dropphyst": "MI",
    "dropphyzpp": 496439806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INTERLOCHEN",
    "dropmalst": "MI",
    "dropmalzpp": 496439998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312769861,
    "dropsitcph": 2312769861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12125",
    "droptype": "D",
    "dropname": "IONIA",
    "dropdeladd": "117 N KIDD ST",
    "dropdelcty": "IONIA",
    "dropdelst": "MI",
    "dropdelzpp": 488469998,
    "dropphyadd": "117 N KIDD ST",
    "dropphycty": "IONIA",
    "dropphyst": "MI",
    "dropphyzpp": 488469998,
    "dropmaladd": "117 N KIDD ST",
    "dropmalcty": "IONIA",
    "dropmalst": "MI",
    "dropmalzpp": 488469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6165273370,
    "dropsitcph": 6165273370,
    "dropfax": 6165273785
  },
  {
    "dcode": "D",
    "dropkey": "PY12129",
    "droptype": "D",
    "dropname": "IRON MOUNTAIN",
    "dropdeladd": "101 W LUDINGTON ST",
    "dropdelcty": "IRON MOUNTAIN",
    "dropdelst": "MI",
    "dropdelzpp": 498019998,
    "dropphyadd": "101 W LUDINGTON ST",
    "dropphycty": "IRON MOUNTAIN",
    "dropphyst": "MI",
    "dropphyzpp": 498019998,
    "dropmaladd": "101 W LUDINGTON ST",
    "dropmalcty": "IRON MOUNTAIN",
    "dropmalst": "MI",
    "dropmalzpp": 498019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067762047,
    "dropsitcph": 9067762047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12130",
    "droptype": "D",
    "dropname": "IRON RIVER",
    "dropdeladd": "425 W GENESEE ST",
    "dropdelcty": "IRON RIVER",
    "dropdelst": "MI",
    "dropdelzpp": 499359998,
    "dropphyadd": "425 W GENESEE ST",
    "dropphycty": "IRON RIVER",
    "dropphyst": "MI",
    "dropphyzpp": 499359998,
    "dropmaladd": "425 W GENESEE ST",
    "dropmalcty": "IRON RIVER",
    "dropmalst": "MI",
    "dropmalzpp": 499359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062656441,
    "dropsitcph": 9062656441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12131",
    "droptype": "D",
    "dropname": "IRONS",
    "dropdeladd": "5574 W 10 1/2 MILE RD",
    "dropdelcty": "IRONS",
    "dropdelst": "MI",
    "dropdelzpp": 496449160,
    "dropphyadd": "5574 W 10 1/2 MILE RD",
    "dropphycty": "IRONS",
    "dropphyst": "MI",
    "dropphyzpp": 496449160,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRONS",
    "dropmalst": "MI",
    "dropmalzpp": 496449998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312665738,
    "dropsitcph": 2312665738,
    "dropfax": 2312665738
  },
  {
    "dcode": "D",
    "dropkey": "PY12132",
    "droptype": "D",
    "dropname": "IRONWOOD",
    "dropdeladd": "100 E AYER ST",
    "dropdelcty": "IRONWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 499389998,
    "dropphyadd": "100 E AYER ST",
    "dropphycty": "IRONWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 499389998,
    "dropmaladd": "100 E AYER ST",
    "dropmalcty": "IRONWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 499389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9069322421,
    "dropsitcph": 9069322421,
    "dropfax": 9069325082
  },
  {
    "dcode": "D",
    "dropkey": "PY12133",
    "droptype": "D",
    "dropname": "ISHPEMING",
    "dropdeladd": "211 N 2ND ST",
    "dropdelcty": "ISHPEMING",
    "dropdelst": "MI",
    "dropdelzpp": 498499998,
    "dropphyadd": "211 N 2ND ST",
    "dropphycty": "ISHPEMING",
    "dropphyst": "MI",
    "dropphyzpp": 498499998,
    "dropmaladd": "211 N 2ND ST",
    "dropmalcty": "ISHPEMING",
    "dropmalst": "MI",
    "dropmalzpp": 498499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064866161,
    "dropsitcph": 9064866161,
    "dropfax": 9064868569
  },
  {
    "dcode": "D",
    "dropkey": "PY12134",
    "droptype": "D",
    "dropname": "ITHACA",
    "dropdeladd": "120 N PINE RIVER ST",
    "dropdelcty": "ITHACA",
    "dropdelst": "MI",
    "dropdelzpp": 488471055,
    "dropphyadd": "120 N PINE RIVER ST",
    "dropphycty": "ITHACA",
    "dropphyst": "MI",
    "dropphyzpp": 488471055,
    "dropmaladd": "120 N PINE RIVER ST",
    "dropmalcty": "ITHACA",
    "dropmalst": "MI",
    "dropmalzpp": 488471055,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898754165,
    "dropsitcph": 9898754165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12137",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "113 W MICHIGAN AVE LBBY",
    "dropdelcty": "JACKSON",
    "dropdelst": "MI",
    "dropdelzpp": 492011386,
    "dropphyadd": "113 W MICHIGAN AVE LBBY",
    "dropphycty": "JACKSON",
    "dropphyst": "MI",
    "dropphyzpp": 492011386,
    "dropmaladd": "113 W MICHIGAN AVE LBBY",
    "dropmalcty": "JACKSON",
    "dropmalst": "MI",
    "dropmalzpp": 492011386,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5177680721,
    "dropfax": 5177680618
  },
  {
    "dcode": "D",
    "dropkey": "PY12138",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "3209 24TH AVE",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "MI",
    "dropdelzpp": 494279800,
    "dropphyadd": "3209 24TH AVE",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "MI",
    "dropphyzpp": 494279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "MI",
    "dropmalzpp": 494279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168968473,
    "dropsitcph": 6168968473,
    "dropfax": 6168968473
  },
  {
    "dcode": "D",
    "dropkey": "PY12140",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "8520 S ADRIAN HWY",
    "dropdelcty": "JASPER",
    "dropdelst": "MI",
    "dropdelzpp": 492489998,
    "dropphyadd": "8520 S ADRIAN HWY",
    "dropphycty": "JASPER",
    "dropphyst": "MI",
    "dropphyzpp": 492489998,
    "dropmaladd": "8520 S ADRIAN HWY",
    "dropmalcty": "JASPER",
    "dropmalst": "MI",
    "dropmalzpp": 492489998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174363094,
    "dropfax": 5174366474
  },
  {
    "dcode": "D",
    "dropkey": "PY12141",
    "droptype": "D",
    "dropname": "JEDDO",
    "dropdeladd": "8511 WILDCAT RD",
    "dropdelcty": "JEDDO",
    "dropdelst": "MI",
    "dropdelzpp": 480329998,
    "dropphyadd": "8511 WILDCAT RD",
    "dropphycty": "JEDDO",
    "dropphyst": "MI",
    "dropphyzpp": 480329998,
    "dropmaladd": "8511 WILDCAT RD",
    "dropmalcty": "JEDDO",
    "dropmalst": "MI",
    "dropmalzpp": 480329998,
    "dropsitphn": 8103276500,
    "dropsitlph": 8107585622,
    "dropsitcph": 8103276500,
    "dropfax": 8103270007
  },
  {
    "dcode": "D",
    "dropkey": "PY12143",
    "droptype": "D",
    "dropname": "JENISON",
    "dropdeladd": "408 CHICAGO DR",
    "dropdelcty": "JENISON",
    "dropdelst": "MI",
    "dropdelzpp": 494289243,
    "dropphyadd": "408 CHICAGO DR",
    "dropphycty": "JENISON",
    "dropphyst": "MI",
    "dropphyzpp": 494289243,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JENISON",
    "dropmalst": "MI",
    "dropmalzpp": 494289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6164572600,
    "dropsitcph": 6164572600,
    "dropfax": 6164570043
  },
  {
    "dcode": "D",
    "dropkey": "PY12144",
    "droptype": "D",
    "dropname": "JEROME",
    "dropdeladd": "8650 N JEROME RD",
    "dropdelcty": "JEROME",
    "dropdelst": "MI",
    "dropdelzpp": 492499998,
    "dropphyadd": "8650 N JEROME RD",
    "dropphycty": "JEROME",
    "dropphyst": "MI",
    "dropphyzpp": 492499998,
    "dropmaladd": "8650 N JEROME RD",
    "dropmalcty": "JEROME",
    "dropmalst": "MI",
    "dropmalzpp": 492499998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5176884471,
    "dropfax": 5176883715
  },
  {
    "dcode": "D",
    "dropkey": "PY12145",
    "droptype": "D",
    "dropname": "JOHANNESBURG",
    "dropdeladd": "10701 M 32 E",
    "dropdelcty": "JOHANNESBURG",
    "dropdelst": "MI",
    "dropdelzpp": 497519448,
    "dropphyadd": "10701 M 32 E",
    "dropphycty": "JOHANNESBURG",
    "dropphyst": "MI",
    "dropphyzpp": 497519448,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHANNESBURG",
    "dropmalst": "MI",
    "dropmalzpp": 497519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897325931,
    "dropsitcph": 9897325931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12146",
    "droptype": "D",
    "dropname": "JONES",
    "dropdeladd": "12081 M 60",
    "dropdelcty": "JONES",
    "dropdelst": "MI",
    "dropdelzpp": 490618768,
    "dropphyadd": "12081 M 60",
    "dropphycty": "JONES",
    "dropphyst": "MI",
    "dropphyzpp": 490618768,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JONES",
    "dropmalst": "MI",
    "dropmalzpp": 490619998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2692445117,
    "dropsitcph": 2692445117,
    "dropfax": 2692445117
  },
  {
    "dcode": "D",
    "dropkey": "PY12147",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "114 MAUMEE ST",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 492509998,
    "dropphyadd": "114 MAUMEE ST",
    "dropphycty": "JONESVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 492509998,
    "dropmaladd": "114 MAUMEE ST",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 492509998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5178499062,
    "dropfax": 5178492422
  },
  {
    "dcode": "D",
    "dropkey": "PY12154",
    "droptype": "D",
    "dropname": "KALAMAZOO",
    "dropdeladd": "1121 MILLER RD",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490018335,
    "dropphyadd": "1121 MILLER RD",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490018335,
    "dropmaladd": "1121 MILLER RD",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490018335,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693535053,
    "dropsitcph": 2693887200,
    "dropfax": 2693889144
  },
  {
    "dcode": "D",
    "dropkey": "PY12155",
    "droptype": "D",
    "dropname": "KALEVA",
    "dropdeladd": "14424 WUOKSI AVE",
    "dropdelcty": "KALEVA",
    "dropdelst": "MI",
    "dropdelzpp": 496455102,
    "dropphyadd": "14424 WUOKSI AVE",
    "dropphycty": "KALEVA",
    "dropphyst": "MI",
    "dropphyzpp": 496455102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALEVA",
    "dropmalst": "MI",
    "dropmalzpp": 496459998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313623753,
    "dropsitcph": 2313623753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12156",
    "droptype": "D",
    "dropname": "KALKASKA",
    "dropdeladd": "105 W 3RD ST",
    "dropdelcty": "KALKASKA",
    "dropdelst": "MI",
    "dropdelzpp": 496465107,
    "dropphyadd": "105 W 3RD ST",
    "dropphycty": "KALKASKA",
    "dropphyst": "MI",
    "dropphyzpp": 496465107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALKASKA",
    "dropmalst": "MI",
    "dropmalzpp": 496469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312589361,
    "dropsitcph": 2312589361,
    "dropfax": 2312580988
  },
  {
    "dcode": "D",
    "dropkey": "PY12158",
    "droptype": "D",
    "dropname": "KAWKAWLIN",
    "dropdeladd": "121 W GROVE ST",
    "dropdelcty": "KAWKAWLIN",
    "dropdelst": "MI",
    "dropdelzpp": 486312511,
    "dropphyadd": "121 W GROVE ST",
    "dropphycty": "KAWKAWLIN",
    "dropphyst": "MI",
    "dropphyzpp": 486312511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAWKAWLIN",
    "dropmalst": "MI",
    "dropmalzpp": 486319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896863320,
    "dropsitcph": 9896863320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12161",
    "droptype": "D",
    "dropname": "KEEGO HARBOR",
    "dropdeladd": "2851 ORCHARD LAKE RD",
    "dropdelcty": "KEEGO HARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 483209998,
    "dropphyadd": "2851 ORCHARD LAKE RD",
    "dropphycty": "KEEGO HARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 483209998,
    "dropmaladd": "2851 ORCHARD LAKE RD",
    "dropmalcty": "KEEGO HARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 483209998,
    "dropsitphn": 2484542413,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486815724,
    "dropfax": 2486816861
  },
  {
    "dcode": "D",
    "dropkey": "PY12164",
    "droptype": "D",
    "dropname": "KENDALL",
    "dropdeladd": "15925 MAIN ST",
    "dropdelcty": "KENDALL",
    "dropdelst": "MI",
    "dropdelzpp": 490629800,
    "dropphyadd": "15925 MAIN ST",
    "dropphycty": "KENDALL",
    "dropphyst": "MI",
    "dropphyzpp": 490629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENDALL",
    "dropmalst": "MI",
    "dropmalzpp": 490629998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696282336,
    "dropsitcph": 2696282336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12169",
    "droptype": "D",
    "dropname": "KENT CITY",
    "dropdeladd": "60 S MAIN ST",
    "dropdelcty": "KENT CITY",
    "dropdelst": "MI",
    "dropdelzpp": 493308969,
    "dropphyadd": "60 S MAIN ST",
    "dropphycty": "KENT CITY",
    "dropphyst": "MI",
    "dropphyzpp": 493308969,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENT CITY",
    "dropmalst": "MI",
    "dropmalzpp": 493309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166787175,
    "dropsitcph": 6166787175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12175",
    "droptype": "D",
    "dropname": "KEWADIN",
    "dropdeladd": "7292 CAIRN HWY",
    "dropdelcty": "KEWADIN",
    "dropdelst": "MI",
    "dropdelzpp": 496489782,
    "dropphyadd": "7292 CAIRN HWY",
    "dropphycty": "KEWADIN",
    "dropphyst": "MI",
    "dropphyzpp": 496489782,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEWADIN",
    "dropmalst": "MI",
    "dropmalzpp": 496489998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312645541,
    "dropsitcph": 2312645541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12181",
    "droptype": "D",
    "dropname": "KINDE",
    "dropdeladd": "220 MAIN ST",
    "dropdelcty": "KINDE",
    "dropdelst": "MI",
    "dropdelzpp": 484459998,
    "dropphyadd": "220 MAIN ST",
    "dropphycty": "KINDE",
    "dropphyst": "MI",
    "dropphyzpp": 484459998,
    "dropmaladd": "220 MAIN ST",
    "dropmalcty": "KINDE",
    "dropmalst": "MI",
    "dropmalzpp": 484459998,
    "dropsitphn": 9898744303,
    "dropsitlph": 8102571580,
    "dropsitcph": 9898744303,
    "dropfax": 9898746425
  },
  {
    "dcode": "D",
    "dropkey": "PY12183",
    "droptype": "D",
    "dropname": "KINGSLEY",
    "dropdeladd": "201 S BROWNSON AVE",
    "dropdelcty": "KINGSLEY",
    "dropdelst": "MI",
    "dropdelzpp": 496495104,
    "dropphyadd": "201 S BROWNSON AVE",
    "dropphycty": "KINGSLEY",
    "dropphyst": "MI",
    "dropphyzpp": 496495104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSLEY",
    "dropmalst": "MI",
    "dropmalzpp": 496499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312635820,
    "dropsitcph": 2312635820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12184",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "3484 RIVER ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "MI",
    "dropdelzpp": 487418738,
    "dropphyadd": "3484 RIVER ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "MI",
    "dropphyzpp": 487418738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSTON",
    "dropmalst": "MI",
    "dropmalzpp": 487419998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896832710,
    "dropsitcph": 9896832710,
    "dropfax": 9896832246
  },
  {
    "dcode": "D",
    "dropkey": "PY12185",
    "droptype": "D",
    "dropname": "KINROSS",
    "dropdeladd": "16901 S HASSETT DR",
    "dropdelcty": "KINROSS",
    "dropdelst": "MI",
    "dropdelzpp": 497529800,
    "dropphyadd": "16901 S HASSETT DR",
    "dropphycty": "KINROSS",
    "dropphyst": "MI",
    "dropphyzpp": 497529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINROSS",
    "dropmalst": "MI",
    "dropmalzpp": 497529998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064955209,
    "dropsitcph": 9064955209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12190",
    "droptype": "D",
    "dropname": "LACHINE",
    "dropdeladd": "2292 M 65 N",
    "dropdelcty": "LACHINE",
    "dropdelst": "MI",
    "dropdelzpp": 497539606,
    "dropphyadd": "2292 M 65 N",
    "dropphycty": "LACHINE",
    "dropphyst": "MI",
    "dropphyzpp": 497539606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LACHINE",
    "dropmalst": "MI",
    "dropmalzpp": 497539998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893794125,
    "dropsitcph": 9893794125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12191",
    "droptype": "D",
    "dropname": "LACOTA",
    "dropdeladd": "60062 CHURCH ST",
    "dropdelcty": "LACOTA",
    "dropdelst": "MI",
    "dropdelzpp": 490639800,
    "dropphyadd": "60062 CHURCH ST",
    "dropphycty": "LACOTA",
    "dropphyst": "MI",
    "dropphyzpp": 490639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LACOTA",
    "dropmalst": "MI",
    "dropmalzpp": 490639998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2692534423,
    "dropsitcph": 2692534423,
    "dropfax": 2692532004
  },
  {
    "dcode": "D",
    "dropkey": "PY12193",
    "droptype": "D",
    "dropname": "LAINGSBURG",
    "dropdeladd": "221 E GRAND RIVER RD",
    "dropdelcty": "LAINGSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 488488601,
    "dropphyadd": "221 E GRAND RIVER RD",
    "dropphycty": "LAINGSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 488488601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAINGSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 488489998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176515678,
    "dropsitcph": 5176515678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12194",
    "droptype": "D",
    "dropname": "LAKE",
    "dropdeladd": "8959 LAKE STATION AVE",
    "dropdelcty": "LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 486329330,
    "dropphyadd": "8959 LAKE STATION AVE",
    "dropphycty": "LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 486329330,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 486329998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895442511,
    "dropsitcph": 9895442511,
    "dropfax": 9895442511
  },
  {
    "dcode": "D",
    "dropkey": "PY12196",
    "droptype": "D",
    "dropname": "LAKE ANN",
    "dropdeladd": "19614 MAPLE ST",
    "dropdelcty": "LAKE ANN",
    "dropdelst": "MI",
    "dropdelzpp": 496509543,
    "dropphyadd": "19614 MAPLE ST",
    "dropphycty": "LAKE ANN",
    "dropphyst": "MI",
    "dropphyzpp": 496509543,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE ANN",
    "dropmalst": "MI",
    "dropmalzpp": 496509998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312757388,
    "dropsitcph": 2312757388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12197",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "121 E JOHN ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496519800,
    "dropphyadd": "121 E JOHN ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318394577,
    "dropsitcph": 2318394577,
    "dropfax": 2318398658
  },
  {
    "dcode": "D",
    "dropkey": "PY12201",
    "droptype": "D",
    "dropname": "LAKE GEORGE",
    "dropdeladd": "190 W PARK ST",
    "dropdelcty": "LAKE GEORGE",
    "dropdelst": "MI",
    "dropdelzpp": 486339800,
    "dropphyadd": "190 W PARK ST",
    "dropphycty": "LAKE GEORGE",
    "dropphyst": "MI",
    "dropphyzpp": 486339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE GEORGE",
    "dropmalst": "MI",
    "dropmalzpp": 486339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895884814,
    "dropsitcph": 9895884814,
    "dropfax": 9895884814
  },
  {
    "dcode": "D",
    "dropkey": "PY12202",
    "droptype": "D",
    "dropname": "LAKE LEELANAU",
    "dropdeladd": "115 N SAINT JOSEPH ST",
    "dropdelcty": "LAKE LEELANAU",
    "dropdelst": "MI",
    "dropdelzpp": 496538428,
    "dropphyadd": "115 N SAINT JOSEPH ST",
    "dropphycty": "LAKE LEELANAU",
    "dropphyst": "MI",
    "dropphyzpp": 496538428,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE LEELANAU",
    "dropmalst": "MI",
    "dropmalzpp": 496539998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312569702,
    "dropsitcph": 2312569702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12203",
    "droptype": "D",
    "dropname": "LAKE LINDEN",
    "dropdeladd": "600 CALUMET ST",
    "dropdelcty": "LAKE LINDEN",
    "dropdelst": "MI",
    "dropdelzpp": 499459998,
    "dropphyadd": "600 CALUMET ST",
    "dropphycty": "LAKE LINDEN",
    "dropphyst": "MI",
    "dropphyzpp": 499459998,
    "dropmaladd": "600 CALUMET ST",
    "dropmalcty": "LAKE LINDEN",
    "dropmalst": "MI",
    "dropmalzpp": 499459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062963451,
    "dropsitcph": 9062963451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12205",
    "droptype": "D",
    "dropname": "LAKE ODESSA",
    "dropdeladd": "907 4TH AVE",
    "dropdelcty": "LAKE ODESSA",
    "dropdelst": "MI",
    "dropdelzpp": 488499998,
    "dropphyadd": "907 4TH AVE",
    "dropphycty": "LAKE ODESSA",
    "dropphyst": "MI",
    "dropphyzpp": 488499998,
    "dropmaladd": "907 4TH AVE",
    "dropmalcty": "LAKE ODESSA",
    "dropmalst": "MI",
    "dropmalzpp": 488499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163748923,
    "dropsitcph": 6163748923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12206",
    "droptype": "D",
    "dropname": "LAKE ORION",
    "dropdeladd": "611 N AXFORD ST",
    "dropdelcty": "LAKE ORION",
    "dropdelst": "MI",
    "dropdelzpp": 483619998,
    "dropphyadd": "611 N AXFORD ST",
    "dropphycty": "LAKE ORION",
    "dropphyst": "MI",
    "dropphyzpp": 483619998,
    "dropmaladd": "611 N AXFORD ST",
    "dropmalcty": "LAKE ORION",
    "dropmalst": "MI",
    "dropmalzpp": 483619998,
    "dropsitphn": 2486933253,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486933253,
    "dropfax": 2486935883
  },
  {
    "dcode": "D",
    "dropkey": "PY12208",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "9680 KRESS RD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "MI",
    "dropdelzpp": 481439998,
    "dropphyadd": "9680 KRESS RD",
    "dropphycty": "LAKELAND",
    "dropphyst": "MI",
    "dropphyzpp": 481439998,
    "dropmaladd": "9680 KRESS RD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "MI",
    "dropmalzpp": 481439998,
    "dropsitphn": 8102312884,
    "dropsitlph": 3132268554,
    "dropsitcph": 8102312884,
    "dropfax": 8102312301
  },
  {
    "dcode": "D",
    "dropkey": "PY12212",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "319 WASHINGTON ST",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "MI",
    "dropdelzpp": 488509806,
    "dropphyadd": "319 WASHINGTON ST",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "MI",
    "dropphyzpp": 488509806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "MI",
    "dropmalzpp": 488509998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893526252,
    "dropsitcph": 9893526252,
    "dropfax": 9893527923
  },
  {
    "dcode": "D",
    "dropkey": "PY12213",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "1436 ROCHESTER RD",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 483669998,
    "dropphyadd": "1436 ROCHESTER RD",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 483669998,
    "dropmaladd": "1436 ROCHESTER RD",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 483669998,
    "dropsitphn": 2486283957,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486283957,
    "dropfax": 2486284617
  },
  {
    "dcode": "D",
    "dropkey": "PY12216",
    "droptype": "D",
    "dropname": "LAMBERTVILLE",
    "dropdeladd": "8213 SECOR RD",
    "dropdelcty": "LAMBERTVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 481449998,
    "dropphyadd": "8213 SECOR RD",
    "dropphycty": "LAMBERTVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 481449998,
    "dropmaladd": "8213 SECOR RD",
    "dropmalcty": "LAMBERTVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 481449998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348542392,
    "dropfax": 7348541319
  },
  {
    "dcode": "D",
    "dropkey": "PY12217",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "4521 LEONARD RD",
    "dropdelcty": "LAMONT",
    "dropdelst": "MI",
    "dropdelzpp": 494309800,
    "dropphyadd": "4521 LEONARD RD",
    "dropphycty": "LAMONT",
    "dropphyst": "MI",
    "dropphyzpp": 494309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAMONT",
    "dropmalst": "MI",
    "dropmalzpp": 494309998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166775437,
    "dropsitcph": 6166775437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12218",
    "droptype": "D",
    "dropname": "LANSE",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "LANSE",
    "dropdelst": "MI",
    "dropdelzpp": 499469998,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "LANSE",
    "dropphyst": "MI",
    "dropphyzpp": 499469998,
    "dropmaladd": "120 N MAIN ST",
    "dropmalcty": "LANSE",
    "dropmalst": "MI",
    "dropmalzpp": 499469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065247977,
    "dropsitcph": 9065247977,
    "dropfax": 9065244865
  },
  {
    "dcode": "D",
    "dropkey": "PY12220",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "4800 COLLINS RD",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489249998,
    "dropphyadd": "4800 COLLINS RD",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489249998,
    "dropmaladd": "4800 COLLINS RD",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489249998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173378775,
    "dropsitcph": 5173378715,
    "dropfax": 5173374843
  },
  {
    "dcode": "D",
    "dropkey": "PY12222",
    "droptype": "D",
    "dropname": "LAPEER",
    "dropdeladd": "567 W NEPESSING ST",
    "dropdelcty": "LAPEER",
    "dropdelst": "MI",
    "dropdelzpp": 484469998,
    "dropphyadd": "567 W NEPESSING ST",
    "dropphycty": "LAPEER",
    "dropphyst": "MI",
    "dropphyzpp": 484469998,
    "dropmaladd": "567 W NEPESSING ST",
    "dropmalcty": "LAPEER",
    "dropmalst": "MI",
    "dropmalzpp": 484469998,
    "dropsitphn": 8106647061,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106647061,
    "dropfax": 8106648550
  },
  {
    "dcode": "D",
    "dropkey": "PY12225",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "310 S PAW PAW ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "MI",
    "dropdelzpp": 490649686,
    "dropphyadd": "310 S PAW PAW ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "MI",
    "dropphyzpp": 490649686,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "MI",
    "dropmalzpp": 490649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696748222,
    "dropsitcph": 2696748222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12226",
    "droptype": "D",
    "dropname": "LAWTON",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "MI",
    "dropdelzpp": 490659816,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "LAWTON",
    "dropphyst": "MI",
    "dropphyzpp": 490659816,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWTON",
    "dropmalst": "MI",
    "dropmalzpp": 490659998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696243601,
    "dropsitcph": 2696243601,
    "dropfax": 2696241193
  },
  {
    "dcode": "D",
    "dropkey": "PY12230",
    "droptype": "D",
    "dropname": "LELAND",
    "dropdeladd": "122 N MAIN ST",
    "dropdelcty": "LELAND",
    "dropdelst": "MI",
    "dropdelzpp": 496545049,
    "dropphyadd": "122 N MAIN ST",
    "dropphycty": "LELAND",
    "dropphyst": "MI",
    "dropphyzpp": 496545049,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LELAND",
    "dropmalst": "MI",
    "dropmalzpp": 496549998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312569113,
    "dropsitcph": 2312569113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12231",
    "droptype": "D",
    "dropname": "LENNON",
    "dropdeladd": "3195 S SHERIDAN RD",
    "dropdelcty": "LENNON",
    "dropdelst": "MI",
    "dropdelzpp": 484499998,
    "dropphyadd": "3195 S SHERIDAN RD",
    "dropphycty": "LENNON",
    "dropphyst": "MI",
    "dropphyzpp": 484499998,
    "dropmaladd": "3195 S SHERIDAN RD",
    "dropmalcty": "LENNON",
    "dropmalst": "MI",
    "dropmalzpp": 484499998,
    "dropsitphn": 8106213121,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106213121,
    "dropfax": 8106213177
  },
  {
    "dcode": "D",
    "dropkey": "PY12235",
    "droptype": "D",
    "dropname": "LEONARD",
    "dropdeladd": "22 E ELMWOOD",
    "dropdelcty": "LEONARD",
    "dropdelst": "MI",
    "dropdelzpp": 483679998,
    "dropphyadd": "22 E ELMWOOD",
    "dropphycty": "LEONARD",
    "dropphyst": "MI",
    "dropphyzpp": 483679998,
    "dropmaladd": "22 E ELMWOOD",
    "dropmalcty": "LEONARD",
    "dropmalst": "MI",
    "dropmalzpp": 483679998,
    "dropsitphn": 2486285243,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486285243,
    "dropfax": 2486281758
  },
  {
    "dcode": "D",
    "dropkey": "PY12237",
    "droptype": "D",
    "dropname": "LEONIDAS",
    "dropdeladd": "30980 KING RD",
    "dropdelcty": "LEONIDAS",
    "dropdelst": "MI",
    "dropdelzpp": 490669800,
    "dropphyadd": "30980 KING RD",
    "dropphycty": "LEONIDAS",
    "dropphyst": "MI",
    "dropphyzpp": 490669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEONIDAS",
    "dropmalst": "MI",
    "dropmalzpp": 490669998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694967743,
    "dropsitcph": 2694967743,
    "dropfax": 2694965095
  },
  {
    "dcode": "D",
    "dropkey": "PY12238",
    "droptype": "D",
    "dropname": "LEROY",
    "dropdeladd": "106 W GILBERT ST",
    "dropdelcty": "LEROY",
    "dropdelst": "MI",
    "dropdelzpp": 496555123,
    "dropphyadd": "106 W GILBERT ST",
    "dropphycty": "LEROY",
    "dropphyst": "MI",
    "dropphyzpp": 496555123,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEROY",
    "dropmalst": "MI",
    "dropmalzpp": 496559998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317684943,
    "dropsitcph": 2317684943,
    "dropfax": 2317685591
  },
  {
    "dcode": "D",
    "dropkey": "PY12239",
    "droptype": "D",
    "dropname": "LESLIE",
    "dropdeladd": "170 S MAIN ST",
    "dropdelcty": "LESLIE",
    "dropdelst": "MI",
    "dropdelzpp": 492519998,
    "dropphyadd": "170 S MAIN ST",
    "dropphycty": "LESLIE",
    "dropphyst": "MI",
    "dropphyzpp": 492519998,
    "dropmaladd": "170 S MAIN ST",
    "dropmalcty": "LESLIE",
    "dropmalst": "MI",
    "dropmalzpp": 492519998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175895201,
    "dropfax": 5175898847
  },
  {
    "dcode": "D",
    "dropkey": "PY12240",
    "droptype": "D",
    "dropname": "LEVERING",
    "dropdeladd": "5912 ROBINSON ST",
    "dropdelcty": "LEVERING",
    "dropdelst": "MI",
    "dropdelzpp": 497559800,
    "dropphyadd": "5912 ROBINSON ST",
    "dropphycty": "LEVERING",
    "dropphyst": "MI",
    "dropphyzpp": 497559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEVERING",
    "dropmalst": "MI",
    "dropmalzpp": 497559998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315374713,
    "dropsitcph": 2315374713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12241",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "4165 SALLING AVE",
    "dropdelcty": "LEWISTON",
    "dropdelst": "MI",
    "dropdelzpp": 497569800,
    "dropphyadd": "4165 SALLING AVE",
    "dropphycty": "LEWISTON",
    "dropphyst": "MI",
    "dropphyzpp": 497569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISTON",
    "dropmalst": "MI",
    "dropmalzpp": 497569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897862773,
    "dropsitcph": 9897862773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12242",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "5204 MAIN ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 484509998,
    "dropphyadd": "5204 MAIN ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 484509998,
    "dropmaladd": "5204 MAIN ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 484509998,
    "dropsitphn": 8103598591,
    "dropsitlph": 8102571580,
    "dropsitcph": 8103598591,
    "dropfax": 8103597872
  },
  {
    "dcode": "D",
    "dropkey": "PY12248",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "215 S 2ND ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "MI",
    "dropdelzpp": 487429800,
    "dropphyadd": "215 S 2ND ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "MI",
    "dropphyzpp": 487429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "MI",
    "dropmalzpp": 487429998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897366111,
    "dropsitcph": 9897366111,
    "dropfax": 9897366111
  },
  {
    "dcode": "D",
    "dropkey": "PY12249",
    "droptype": "D",
    "dropname": "LINCOLN PARK",
    "dropdeladd": "1515 FORT ST",
    "dropdelcty": "LINCOLN PARK",
    "dropdelst": "MI",
    "dropdelzpp": 481469998,
    "dropphyadd": "1515 FORT ST",
    "dropphycty": "LINCOLN PARK",
    "dropphyst": "MI",
    "dropphyzpp": 481469998,
    "dropmaladd": "1515 FORT ST",
    "dropmalcty": "LINCOLN PARK",
    "dropmalst": "MI",
    "dropmalzpp": 481469998,
    "dropsitphn": 3133832084,
    "dropsitlph": 3132268554,
    "dropsitcph": 3133832084,
    "dropfax": 3133836849
  },
  {
    "dcode": "D",
    "dropkey": "PY12250",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "215 S MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "MI",
    "dropdelzpp": 484519998,
    "dropphyadd": "215 S MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "MI",
    "dropphyzpp": 484519998,
    "dropmaladd": "215 S MAIN ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "MI",
    "dropmalzpp": 484519998,
    "dropsitphn": 8107357072,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107357072,
    "dropfax": 8107351783
  },
  {
    "dcode": "D",
    "dropkey": "PY12252",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "200 W CENTER ST",
    "dropdelcty": "LINWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 486349815,
    "dropphyadd": "200 W CENTER ST",
    "dropphycty": "LINWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 486349815,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 486349998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892060047,
    "dropsitcph": 9892060047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12253",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "111 S CHICAGO ST",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 492529998,
    "dropphyadd": "111 S CHICAGO ST",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 492529998,
    "dropmaladd": "111 S CHICAGO ST",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 492529998,
    "dropsitphn": 6167761516,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175422134,
    "dropfax": 5175422130
  },
  {
    "dcode": "D",
    "dropkey": "PY12254",
    "droptype": "D",
    "dropname": "LITTLE LAKE",
    "dropdeladd": "1673 STATE HIGHWAY M35 E",
    "dropdelcty": "LITTLE LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 498339800,
    "dropphyadd": "1673 STATE HIGHWAY M35 E",
    "dropphycty": "LITTLE LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 498339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 498339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063463443,
    "dropsitcph": 9063463443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12257",
    "droptype": "D",
    "dropname": "LIVONIA",
    "dropdeladd": "11800 MERRIMAN RD",
    "dropdelcty": "LIVONIA",
    "dropdelst": "MI",
    "dropdelzpp": 481509998,
    "dropphyadd": "11800 MERRIMAN RD",
    "dropphycty": "LIVONIA",
    "dropphyst": "MI",
    "dropphyzpp": 481509998,
    "dropmaladd": "11800 MERRIMAN RD",
    "dropmalcty": "LIVONIA",
    "dropmalst": "MI",
    "dropmalzpp": 481509998,
    "dropsitphn": 7344587952,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344587952,
    "dropfax": 7344252980
  },
  {
    "dcode": "D",
    "dropkey": "PY12270",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "120 N BROADWAY ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "MI",
    "dropdelzpp": 493319998,
    "dropphyadd": "120 N BROADWAY ST",
    "dropphycty": "LOWELL",
    "dropphyst": "MI",
    "dropphyzpp": 493319998,
    "dropmaladd": "120 N BROADWAY ST",
    "dropmalcty": "LOWELL",
    "dropmalst": "MI",
    "dropmalzpp": 493319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168979949,
    "dropsitcph": 6168979949,
    "dropfax": 6168974813
  },
  {
    "dcode": "D",
    "dropkey": "PY12273",
    "droptype": "D",
    "dropname": "LUDINGTON",
    "dropdeladd": "201 E LUDINGTON AVE",
    "dropdelcty": "LUDINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 494319998,
    "dropphyadd": "201 E LUDINGTON AVE",
    "dropphycty": "LUDINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 494319998,
    "dropmaladd": "201 E LUDINGTON AVE",
    "dropmalcty": "LUDINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 494319998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318438646,
    "dropsitcph": 2318438646,
    "dropfax": 2318439860
  },
  {
    "dcode": "D",
    "dropkey": "PY12278",
    "droptype": "D",
    "dropname": "LUTHER",
    "dropdeladd": "207 STATE ST",
    "dropdelcty": "LUTHER",
    "dropdelst": "MI",
    "dropdelzpp": 496569803,
    "dropphyadd": "207 STATE ST",
    "dropphycty": "LUTHER",
    "dropphyst": "MI",
    "dropphyzpp": 496569803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUTHER",
    "dropmalst": "MI",
    "dropmalzpp": 496569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317975421,
    "dropsitcph": 2317975421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12279",
    "droptype": "D",
    "dropname": "LUZERNE",
    "dropdeladd": "2289 ROYCE AVE",
    "dropdelcty": "LUZERNE",
    "dropdelst": "MI",
    "dropdelzpp": 486369800,
    "dropphyadd": "2289 ROYCE AVE",
    "dropphycty": "LUZERNE",
    "dropphyst": "MI",
    "dropphyzpp": 486369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUZERNE",
    "dropmalst": "MI",
    "dropmalzpp": 486369998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898263378,
    "dropsitcph": 9898263378,
    "dropfax": 9898268144
  },
  {
    "dcode": "D",
    "dropkey": "PY12284",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "308 E BRIDGE ST",
    "dropdelcty": "LYONS",
    "dropdelst": "MI",
    "dropdelzpp": 488518641,
    "dropphyadd": "308 E BRIDGE ST",
    "dropphycty": "LYONS",
    "dropphyst": "MI",
    "dropphyzpp": 488518641,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYONS",
    "dropmalst": "MI",
    "dropmalzpp": 488519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898553666,
    "dropsitcph": 9898553666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12285",
    "droptype": "D",
    "dropname": "MACATAWA",
    "dropdeladd": "2150 S SHORE DR",
    "dropdelcty": "MACATAWA",
    "dropdelst": "MI",
    "dropdelzpp": 494349800,
    "dropphyadd": "2150 S SHORE DR",
    "dropphycty": "MACATAWA",
    "dropphyst": "MI",
    "dropphyzpp": 494349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACATAWA",
    "dropmalst": "MI",
    "dropmalzpp": 494349998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163352485,
    "dropsitcph": 6163352485,
    "dropfax": 6163353987
  },
  {
    "dcode": "D",
    "dropkey": "PY12288",
    "droptype": "D",
    "dropname": "MACKINAC ISLAND",
    "dropdeladd": "7316 MARKET ST",
    "dropdelcty": "MACKINAC ISLAND",
    "dropdelst": "MI",
    "dropdelzpp": 497579800,
    "dropphyadd": "7316 MARKET ST",
    "dropphycty": "MACKINAC ISLAND",
    "dropphyst": "MI",
    "dropphyzpp": 497579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACKINAC ISLAND",
    "dropmalst": "MI",
    "dropmalzpp": 497579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9068473821,
    "dropsitcph": 9068473821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12290",
    "droptype": "D",
    "dropname": "MACKINAW CITY",
    "dropdeladd": "306 E CENTRAL AVE",
    "dropdelcty": "MACKINAW CITY",
    "dropdelst": "MI",
    "dropdelzpp": 497019801,
    "dropphyadd": "306 E CENTRAL AVE",
    "dropphycty": "MACKINAW CITY",
    "dropphyst": "MI",
    "dropphyzpp": 497019801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACKINAW CITY",
    "dropmalst": "MI",
    "dropmalzpp": 497019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2314365526,
    "dropsitcph": 2314365526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12300",
    "droptype": "D",
    "dropname": "MANCELONA",
    "dropdeladd": "115 N WILLIAMS ST",
    "dropdelcty": "MANCELONA",
    "dropdelst": "MI",
    "dropdelzpp": 496597908,
    "dropphyadd": "115 N WILLIAMS ST",
    "dropphycty": "MANCELONA",
    "dropphyst": "MI",
    "dropphyzpp": 496597908,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANCELONA",
    "dropmalst": "MI",
    "dropmalzpp": 496599998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315879251,
    "dropsitcph": 2315879251,
    "dropfax": 2135879251
  },
  {
    "dcode": "D",
    "dropkey": "PY12301",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "MI",
    "dropdelzpp": 481589998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "MANCHESTER",
    "dropphyst": "MI",
    "dropphyzpp": 481589998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "MI",
    "dropmalzpp": 481589998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344287328,
    "dropfax": 7344281645
  },
  {
    "dcode": "D",
    "dropkey": "PY12302",
    "droptype": "D",
    "dropname": "MANISTEE",
    "dropdeladd": "35 FILER ST",
    "dropdelcty": "MANISTEE",
    "dropdelst": "MI",
    "dropdelzpp": 496609998,
    "dropphyadd": "35 FILER ST",
    "dropphycty": "MANISTEE",
    "dropphyst": "MI",
    "dropphyzpp": 496609998,
    "dropmaladd": "35 FILER ST",
    "dropmalcty": "MANISTEE",
    "dropmalst": "MI",
    "dropmalzpp": 496609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317232523,
    "dropsitcph": 2317232523,
    "dropfax": 2317234793
  },
  {
    "dcode": "D",
    "dropkey": "PY12303",
    "droptype": "D",
    "dropname": "MANISTIQUE",
    "dropdeladd": "301 S CEDAR ST",
    "dropdelcty": "MANISTIQUE",
    "dropdelst": "MI",
    "dropdelzpp": 498549998,
    "dropphyadd": "301 S CEDAR ST",
    "dropphycty": "MANISTIQUE",
    "dropphyst": "MI",
    "dropphyzpp": 498549998,
    "dropmaladd": "301 S CEDAR ST",
    "dropmalcty": "MANISTIQUE",
    "dropmalst": "MI",
    "dropmalzpp": 498549998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063412646,
    "dropsitcph": 9063412646,
    "dropfax": 9063413131
  },
  {
    "dcode": "D",
    "dropkey": "PY12304",
    "droptype": "D",
    "dropname": "MANITOU BEACH",
    "dropdeladd": "1235 ELM ST",
    "dropdelcty": "MANITOU BEACH",
    "dropdelst": "MI",
    "dropdelzpp": 492539998,
    "dropphyadd": "1235 ELM ST",
    "dropphycty": "MANITOU BEACH",
    "dropphyst": "MI",
    "dropphyzpp": 492539998,
    "dropmaladd": "1235 ELM ST",
    "dropmalcty": "MANITOU BEACH",
    "dropmalst": "MI",
    "dropmalzpp": 492539998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175475734,
    "dropfax": 5175475073
  },
  {
    "dcode": "D",
    "dropkey": "PY12305",
    "droptype": "D",
    "dropname": "MANTON",
    "dropdeladd": "128 W MAIN ST",
    "dropdelcty": "MANTON",
    "dropdelst": "MI",
    "dropdelzpp": 496639800,
    "dropphyadd": "128 W MAIN ST",
    "dropphycty": "MANTON",
    "dropphyst": "MI",
    "dropphyzpp": 496639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANTON",
    "dropmalst": "MI",
    "dropmalzpp": 496639998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318246461,
    "dropsitcph": 2318246461,
    "dropfax": 2318243774
  },
  {
    "dcode": "D",
    "dropkey": "PY12308",
    "droptype": "D",
    "dropname": "MAPLE CITY",
    "dropdeladd": "8621 S MAPLE CITY RD",
    "dropdelcty": "MAPLE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496648771,
    "dropphyadd": "8621 S MAPLE CITY RD",
    "dropphycty": "MAPLE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496648771,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312285369,
    "dropsitcph": 2312285369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12311",
    "droptype": "D",
    "dropname": "MAPLE RAPIDS",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "MAPLE RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 488539800,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "MAPLE RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 488539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 488539998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896824094,
    "dropsitcph": 9896824094,
    "dropfax": 9896824094
  },
  {
    "dcode": "D",
    "dropkey": "PY12312",
    "droptype": "D",
    "dropname": "MARCELLUS",
    "dropdeladd": "203 S CENTRE ST",
    "dropdelcty": "MARCELLUS",
    "dropdelst": "MI",
    "dropdelzpp": 490678758,
    "dropphyadd": "203 S CENTRE ST",
    "dropphycty": "MARCELLUS",
    "dropphyst": "MI",
    "dropphyzpp": 490678758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARCELLUS",
    "dropmalst": "MI",
    "dropmalzpp": 490679998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696463071,
    "dropsitcph": 2696463071,
    "dropfax": 2696467073
  },
  {
    "dcode": "D",
    "dropkey": "PY12313",
    "droptype": "D",
    "dropname": "MARENISCO",
    "dropdeladd": "306 HALL ST",
    "dropdelcty": "MARENISCO",
    "dropdelst": "MI",
    "dropdelzpp": 499479600,
    "dropphyadd": "306 HALL ST",
    "dropphycty": "MARENISCO",
    "dropphyst": "MI",
    "dropphyzpp": 499479600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARENISCO",
    "dropmalst": "MI",
    "dropmalzpp": 499479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067872330,
    "dropsitcph": 9067872330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12314",
    "droptype": "D",
    "dropname": "MARINE CITY",
    "dropdeladd": "460 S WATER ST",
    "dropdelcty": "MARINE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 480399998,
    "dropphyadd": "460 S WATER ST",
    "dropphycty": "MARINE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 480399998,
    "dropmaladd": "460 S WATER ST",
    "dropmalcty": "MARINE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 480399998,
    "dropsitphn": 8107659311,
    "dropsitlph": 2487585622,
    "dropsitcph": 8107659311,
    "dropfax": 8107655193
  },
  {
    "dcode": "D",
    "dropkey": "PY12315",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "216 E MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "MI",
    "dropdelzpp": 496659605,
    "dropphyadd": "216 E MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "MI",
    "dropphyzpp": 496659605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARION",
    "dropmalst": "MI",
    "dropmalzpp": 496659998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317432842,
    "dropsitcph": 2317432842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12317",
    "droptype": "D",
    "dropname": "MARLETTE",
    "dropdeladd": "2984 FENNER ST",
    "dropdelcty": "MARLETTE",
    "dropdelst": "MI",
    "dropdelzpp": 484539998,
    "dropphyadd": "2984 FENNER ST",
    "dropphycty": "MARLETTE",
    "dropphyst": "MI",
    "dropphyzpp": 484539998,
    "dropmaladd": "2984 FENNER ST",
    "dropmalcty": "MARLETTE",
    "dropmalst": "MI",
    "dropmalzpp": 484539998,
    "dropsitphn": 9896353560,
    "dropsitlph": 8102571580,
    "dropsitcph": 9896353560,
    "dropfax": 9896352434
  },
  {
    "dcode": "D",
    "dropkey": "PY12318",
    "droptype": "D",
    "dropname": "MARNE",
    "dropdeladd": "14614 STATE ST",
    "dropdelcty": "MARNE",
    "dropdelst": "MI",
    "dropdelzpp": 494355112,
    "dropphyadd": "14614 STATE ST",
    "dropphycty": "MARNE",
    "dropphyst": "MI",
    "dropphyzpp": 494355112,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARNE",
    "dropmalst": "MI",
    "dropmalzpp": 494359998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166771285,
    "dropsitcph": 6166771285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12319",
    "droptype": "D",
    "dropname": "MARQUETTE",
    "dropdeladd": "202 W WASHINGTON ST STE 1",
    "dropdelcty": "MARQUETTE",
    "dropdelst": "MI",
    "dropdelzpp": 498559998,
    "dropphyadd": "202 W WASHINGTON ST STE 1",
    "dropphycty": "MARQUETTE",
    "dropphyst": "MI",
    "dropphyzpp": 498559998,
    "dropmaladd": "202 W WASHINGTON ST STE 1",
    "dropmalcty": "MARQUETTE",
    "dropmalst": "MI",
    "dropmalzpp": 498559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062269963,
    "dropsitcph": 9062269963,
    "dropfax": 9062263776
  },
  {
    "dcode": "D",
    "dropkey": "PY12320",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "202 E MICHIGAN AVE",
    "dropdelcty": "MARSHALL",
    "dropdelst": "MI",
    "dropdelzpp": 490689998,
    "dropphyadd": "202 E MICHIGAN AVE",
    "dropphycty": "MARSHALL",
    "dropphyst": "MI",
    "dropphyzpp": 490689998,
    "dropmaladd": "202 E MICHIGAN AVE",
    "dropmalcty": "MARSHALL",
    "dropmalst": "MI",
    "dropmalzpp": 490689998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697812859,
    "dropsitcph": 2697812859,
    "dropfax": 2697810164
  },
  {
    "dcode": "D",
    "dropkey": "PY12321",
    "droptype": "D",
    "dropname": "MARTIN",
    "dropdeladd": "1588 10TH ST",
    "dropdelcty": "MARTIN",
    "dropdelst": "MI",
    "dropdelzpp": 490709728,
    "dropphyadd": "1588 10TH ST",
    "dropphycty": "MARTIN",
    "dropphyst": "MI",
    "dropphyzpp": 490709728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARTIN",
    "dropmalst": "MI",
    "dropmalzpp": 490709998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696725533,
    "dropsitcph": 2696725533,
    "dropfax": 2696729170
  },
  {
    "dcode": "D",
    "dropkey": "PY12322",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "1238 MICHIGAN AVE",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 480409998,
    "dropphyadd": "1238 MICHIGAN AVE",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 480409998,
    "dropmaladd": "1238 MICHIGAN AVE",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 480409998,
    "dropsitphn": 8109897900,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103647922,
    "dropfax": 8103648436
  },
  {
    "dcode": "D",
    "dropkey": "PY12323",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "144 W ASH ST",
    "dropdelcty": "MASON",
    "dropdelst": "MI",
    "dropdelzpp": 488549998,
    "dropphyadd": "144 W ASH ST",
    "dropphycty": "MASON",
    "dropphyst": "MI",
    "dropphyzpp": 488549998,
    "dropmaladd": "144 W ASH ST",
    "dropmalcty": "MASON",
    "dropmalst": "MI",
    "dropmalzpp": 488549998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176769400,
    "dropsitcph": 5176769400,
    "dropfax": 5176760244
  },
  {
    "dcode": "D",
    "dropkey": "PY12324",
    "droptype": "D",
    "dropname": "MASS CITY",
    "dropdeladd": "1315 ADVENTURE AVE",
    "dropdelcty": "MASS CITY",
    "dropdelst": "MI",
    "dropdelzpp": 499489611,
    "dropphyadd": "1315 ADVENTURE AVE",
    "dropphycty": "MASS CITY",
    "dropphyst": "MI",
    "dropphyzpp": 499489611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASS CITY",
    "dropmalst": "MI",
    "dropmalzpp": 499489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068833438,
    "dropsitcph": 9068833438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12325",
    "droptype": "D",
    "dropname": "MATTAWAN",
    "dropdeladd": "55680 N MAIN ST",
    "dropdelcty": "MATTAWAN",
    "dropdelst": "MI",
    "dropdelzpp": 490719800,
    "dropphyadd": "55680 N MAIN ST",
    "dropphycty": "MATTAWAN",
    "dropphyst": "MI",
    "dropphyzpp": 490719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATTAWAN",
    "dropmalst": "MI",
    "dropmalzpp": 490719998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696682217,
    "dropsitcph": 2696682217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12327",
    "droptype": "D",
    "dropname": "MAYFIELD",
    "dropdeladd": "4044 S GARFIELD RD",
    "dropdelcty": "MAYFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 496669800,
    "dropphyadd": "4044 S GARFIELD RD",
    "dropphycty": "MAYFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 496669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 496669998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312635520,
    "dropsitcph": 2312635520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12328",
    "droptype": "D",
    "dropname": "MAYVILLE",
    "dropdeladd": "6120 FULTON ST",
    "dropdelcty": "MAYVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487449127,
    "dropphyadd": "6120 FULTON ST",
    "dropphycty": "MAYVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487449127,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487449998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898435351,
    "dropsitcph": 9898435351,
    "dropfax": 9898436164
  },
  {
    "dcode": "D",
    "dropkey": "PY12329",
    "droptype": "D",
    "dropname": "MC BAIN",
    "dropdeladd": "104 N ROLAND ST",
    "dropdelcty": "MC BAIN",
    "dropdelst": "MI",
    "dropdelzpp": 496579683,
    "dropphyadd": "104 N ROLAND ST",
    "dropphycty": "MC BAIN",
    "dropphyst": "MI",
    "dropphyzpp": 496579683,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC BAIN",
    "dropmalst": "MI",
    "dropmalzpp": 496579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318252345,
    "dropsitcph": 2318252345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12330",
    "droptype": "D",
    "dropname": "MC MILLAN",
    "dropdeladd": "22579 STATE HIGHWAY M28",
    "dropdelcty": "MC MILLAN",
    "dropdelst": "MI",
    "dropdelzpp": 498539800,
    "dropphyadd": "22579 STATE HIGHWAY M28",
    "dropphycty": "MC MILLAN",
    "dropphyst": "MI",
    "dropphyzpp": 498539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC MILLAN",
    "dropmalst": "MI",
    "dropmalzpp": 498539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062938030,
    "dropsitcph": 9062938030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12332",
    "droptype": "D",
    "dropname": "MCBRIDES",
    "dropdeladd": "4321 DIVISION ST",
    "dropdelcty": "MCBRIDES",
    "dropdelst": "MI",
    "dropdelzpp": 488529800,
    "dropphyadd": "4321 DIVISION ST",
    "dropphycty": "MCBRIDES",
    "dropphyst": "MI",
    "dropphyzpp": 488529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCBRIDES",
    "dropmalst": "MI",
    "dropmalzpp": 488529998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897625085,
    "dropsitcph": 9897625085,
    "dropfax": 9897625613
  },
  {
    "dcode": "D",
    "dropkey": "PY12334",
    "droptype": "D",
    "dropname": "MEARS",
    "dropdeladd": "5666 W FOX RD",
    "dropdelcty": "MEARS",
    "dropdelst": "MI",
    "dropdelzpp": 494369565,
    "dropphyadd": "5666 W FOX RD",
    "dropphycty": "MEARS",
    "dropphyst": "MI",
    "dropphyzpp": 494369565,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEARS",
    "dropmalst": "MI",
    "dropmalzpp": 494369998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318734796,
    "dropsitcph": 2318734796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12335",
    "droptype": "D",
    "dropname": "MECOSTA",
    "dropdeladd": "250 W MAIN ST",
    "dropdelcty": "MECOSTA",
    "dropdelst": "MI",
    "dropdelzpp": 493329697,
    "dropphyadd": "250 W MAIN ST",
    "dropphycty": "MECOSTA",
    "dropphyst": "MI",
    "dropphyzpp": 493329697,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MECOSTA",
    "dropmalst": "MI",
    "dropmalzpp": 493329998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319728206,
    "dropsitcph": 2319728206,
    "dropfax": 2319724234
  },
  {
    "dcode": "D",
    "dropkey": "PY12351",
    "droptype": "D",
    "dropname": "MELVIN",
    "dropdeladd": "1296 MAIN ST",
    "dropdelcty": "MELVIN",
    "dropdelst": "MI",
    "dropdelzpp": 484549991,
    "dropphyadd": "1296 MAIN ST",
    "dropphycty": "MELVIN",
    "dropphyst": "MI",
    "dropphyzpp": 484549991,
    "dropmaladd": "1296 MAIN ST",
    "dropmalcty": "MELVIN",
    "dropmalst": "MI",
    "dropmalzpp": 484549991,
    "dropsitphn": 8103785370,
    "dropsitlph": 8102571580,
    "dropsitcph": 8103785370,
    "dropfax": 8103785408
  },
  {
    "dcode": "D",
    "dropkey": "PY12353",
    "droptype": "D",
    "dropname": "MEMPHIS",
    "dropdeladd": "34805 POTTER ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "MI",
    "dropdelzpp": 480419998,
    "dropphyadd": "34805 POTTER ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "MI",
    "dropphyzpp": 480419998,
    "dropmaladd": "34805 POTTER ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "MI",
    "dropmalzpp": 480419998,
    "dropsitphn": 8103922200,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103922200,
    "dropfax": 8103923220
  },
  {
    "dcode": "D",
    "dropkey": "PY12354",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "134 W MAIN ST",
    "dropdelcty": "MENDON",
    "dropdelst": "MI",
    "dropdelzpp": 490729800,
    "dropphyadd": "134 W MAIN ST",
    "dropphycty": "MENDON",
    "dropphyst": "MI",
    "dropphyzpp": 490729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENDON",
    "dropmalst": "MI",
    "dropmalzpp": 490729998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694965435,
    "dropsitcph": 2694965435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12355",
    "droptype": "D",
    "dropname": "MENOMINEE",
    "dropdeladd": "801 11TH ST",
    "dropdelcty": "MENOMINEE",
    "dropdelst": "MI",
    "dropdelzpp": 498589998,
    "dropphyadd": "801 11TH ST",
    "dropphycty": "MENOMINEE",
    "dropphyst": "MI",
    "dropphyzpp": 498589998,
    "dropmaladd": "801 11TH ST",
    "dropmalcty": "MENOMINEE",
    "dropmalst": "MI",
    "dropmalzpp": 498589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068632623,
    "dropsitcph": 9068632623,
    "dropfax": 9068632640
  },
  {
    "dcode": "D",
    "dropkey": "PY12356",
    "droptype": "D",
    "dropname": "MERRILL",
    "dropdeladd": "242 S MIDLAND ST",
    "dropdelcty": "MERRILL",
    "dropdelst": "MI",
    "dropdelzpp": 486372537,
    "dropphyadd": "242 S MIDLAND ST",
    "dropphycty": "MERRILL",
    "dropphyst": "MI",
    "dropphyzpp": 486372537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRILL",
    "dropmalst": "MI",
    "dropmalzpp": 486379998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896437335,
    "dropsitcph": 9896437335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12357",
    "droptype": "D",
    "dropname": "MERRITT",
    "dropdeladd": "329 S MERRITT RD",
    "dropdelcty": "MERRITT",
    "dropdelst": "MI",
    "dropdelzpp": 496679758,
    "dropphyadd": "329 S MERRITT RD",
    "dropphycty": "MERRITT",
    "dropphyst": "MI",
    "dropphyzpp": 496679758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRITT",
    "dropmalst": "MI",
    "dropmalzpp": 496679998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313284391,
    "dropsitcph": 2313284391,
    "dropfax": 2313284391
  },
  {
    "dcode": "D",
    "dropkey": "PY12358",
    "droptype": "D",
    "dropname": "MESICK",
    "dropdeladd": "340 W MESICK AVE",
    "dropdelcty": "MESICK",
    "dropdelst": "MI",
    "dropdelzpp": 496689258,
    "dropphyadd": "340 W MESICK AVE",
    "dropphycty": "MESICK",
    "dropphyst": "MI",
    "dropphyzpp": 496689258,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESICK",
    "dropmalst": "MI",
    "dropmalzpp": 496689998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318851080,
    "dropsitcph": 2318851080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12359",
    "droptype": "D",
    "dropname": "METAMORA",
    "dropdeladd": "3795 N OAK ST",
    "dropdelcty": "METAMORA",
    "dropdelst": "MI",
    "dropdelzpp": 484559998,
    "dropphyadd": "3795 N OAK ST",
    "dropphycty": "METAMORA",
    "dropphyst": "MI",
    "dropphyzpp": 484559998,
    "dropmaladd": "3795 N OAK ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "MI",
    "dropmalzpp": 484559998,
    "dropsitphn": 2486782380,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106782380,
    "dropfax": 8106783264
  },
  {
    "dcode": "D",
    "dropkey": "PY12369",
    "droptype": "D",
    "dropname": "MICHIGAMME",
    "dropdeladd": "113 W MAIN ST",
    "dropdelcty": "MICHIGAMME",
    "dropdelst": "MI",
    "dropdelzpp": 498619800,
    "dropphyadd": "113 W MAIN ST",
    "dropphycty": "MICHIGAMME",
    "dropphyst": "MI",
    "dropphyzpp": 498619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MICHIGAMME",
    "dropmalst": "MI",
    "dropmalzpp": 498619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063236210,
    "dropsitcph": 9063236210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12374",
    "droptype": "D",
    "dropname": "MICHIGAN CENTER",
    "dropdeladd": "122 BROAD ST",
    "dropdelcty": "MICHIGAN CENTER",
    "dropdelst": "MI",
    "dropdelzpp": 492549998,
    "dropphyadd": "122 BROAD ST",
    "dropphycty": "MICHIGAN CENTER",
    "dropphyst": "MI",
    "dropphyzpp": 492549998,
    "dropmaladd": "122 BROAD ST",
    "dropmalcty": "MICHIGAN CENTER",
    "dropmalst": "MI",
    "dropmalzpp": 492549998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5177643567,
    "dropfax": 5177640638
  },
  {
    "dcode": "D",
    "dropkey": "PY12377",
    "droptype": "D",
    "dropname": "MIDDLETON",
    "dropdeladd": "116 S NEWTON ST",
    "dropdelcty": "MIDDLETON",
    "dropdelst": "MI",
    "dropdelzpp": 488569788,
    "dropphyadd": "116 S NEWTON ST",
    "dropphycty": "MIDDLETON",
    "dropphyst": "MI",
    "dropphyzpp": 488569788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLETON",
    "dropmalst": "MI",
    "dropmalzpp": 488569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892367773,
    "dropsitcph": 9892367773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12378",
    "droptype": "D",
    "dropname": "MIDDLEVILLE",
    "dropdeladd": "220 S BROADWAY ST",
    "dropdelcty": "MIDDLEVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 493339145,
    "dropphyadd": "220 S BROADWAY ST",
    "dropphycty": "MIDDLEVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 493339145,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDDLEVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 493339998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697959526,
    "dropsitcph": 2697959526,
    "dropfax": 2697953113
  },
  {
    "dcode": "D",
    "dropkey": "PY12380",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "2900 RODD ST",
    "dropdelcty": "MIDLAND",
    "dropdelst": "MI",
    "dropdelzpp": 486409998,
    "dropphyadd": "2900 RODD ST",
    "dropphycty": "MIDLAND",
    "dropphyst": "MI",
    "dropphyzpp": 486409998,
    "dropmaladd": "2900 RODD ST",
    "dropmalcty": "MIDLAND",
    "dropmalst": "MI",
    "dropmalzpp": 486409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896316580,
    "dropsitcph": 9896316580,
    "dropfax": 9898986045
  },
  {
    "dcode": "D",
    "dropkey": "PY12383",
    "droptype": "D",
    "dropname": "MIKADO",
    "dropdeladd": "2256 S F 41",
    "dropdelcty": "MIKADO",
    "dropdelst": "MI",
    "dropdelzpp": 487455100,
    "dropphyadd": "2256 S F 41",
    "dropphycty": "MIKADO",
    "dropphyst": "MI",
    "dropphyzpp": 487455100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIKADO",
    "dropmalst": "MI",
    "dropmalzpp": 487459998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897368791,
    "dropsitcph": 9897368791,
    "dropfax": 9897367107
  },
  {
    "dcode": "D",
    "dropkey": "PY12384",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "123 E MAIN ST",
    "dropdelcty": "MILAN",
    "dropdelst": "MI",
    "dropdelzpp": 481609998,
    "dropphyadd": "123 E MAIN ST",
    "dropphycty": "MILAN",
    "dropphyst": "MI",
    "dropphyzpp": 481609998,
    "dropmaladd": "123 E MAIN ST",
    "dropmalcty": "MILAN",
    "dropmalst": "MI",
    "dropmalzpp": 481609998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7344390970,
    "dropsitcph": 7344390970,
    "dropfax": 7344392985
  },
  {
    "dcode": "D",
    "dropkey": "PY12386",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "1150 ATLANTIC ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "MI",
    "dropdelzpp": 483819998,
    "dropphyadd": "1150 ATLANTIC ST",
    "dropphycty": "MILFORD",
    "dropphyst": "MI",
    "dropphyzpp": 483819998,
    "dropmaladd": "1150 ATLANTIC ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "MI",
    "dropmalzpp": 483819998,
    "dropsitphn": 2486844915,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486844915,
    "dropfax": 2486845891
  },
  {
    "dcode": "D",
    "dropkey": "PY12390",
    "droptype": "D",
    "dropname": "MILLERSBURG",
    "dropdeladd": "5316 MAIN ST",
    "dropdelcty": "MILLERSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 497599435,
    "dropphyadd": "5316 MAIN ST",
    "dropphycty": "MILLERSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 497599435,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLERSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 497599998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897336650,
    "dropsitcph": 9897336650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12391",
    "droptype": "D",
    "dropname": "MILLINGTON",
    "dropdeladd": "4717 MAIN ST",
    "dropdelcty": "MILLINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 487469082,
    "dropphyadd": "4717 MAIN ST",
    "dropphycty": "MILLINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 487469082,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 487469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898713932,
    "dropsitcph": 9898713932,
    "dropfax": 9898716591
  },
  {
    "dcode": "D",
    "dropkey": "PY12394",
    "droptype": "D",
    "dropname": "MINDEN CITY",
    "dropdeladd": "1608 MAIN ST",
    "dropdelcty": "MINDEN CITY",
    "dropdelst": "MI",
    "dropdelzpp": 484569998,
    "dropphyadd": "1608 MAIN ST",
    "dropphycty": "MINDEN CITY",
    "dropphyst": "MI",
    "dropphyzpp": 484569998,
    "dropmaladd": "1608 MAIN ST",
    "dropmalcty": "MINDEN CITY",
    "dropmalst": "MI",
    "dropmalzpp": 484569998,
    "dropsitphn": 9898645580,
    "dropsitlph": 8102571580,
    "dropsitcph": 9898645580,
    "dropfax": 9898648204
  },
  {
    "dcode": "D",
    "dropkey": "PY12395",
    "droptype": "D",
    "dropname": "MIO",
    "dropdeladd": "213 S MORENCI AVE",
    "dropdelcty": "MIO",
    "dropdelst": "MI",
    "dropdelzpp": 486472509,
    "dropphyadd": "213 S MORENCI AVE",
    "dropphycty": "MIO",
    "dropphyst": "MI",
    "dropphyzpp": 486472509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIO",
    "dropmalst": "MI",
    "dropmalzpp": 486479998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898265531,
    "dropsitcph": 9898265531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12396",
    "droptype": "D",
    "dropname": "MOHAWK",
    "dropdeladd": "78 MOHAWK ST",
    "dropdelcty": "MOHAWK",
    "dropdelst": "MI",
    "dropdelzpp": 499509800,
    "dropphyadd": "78 MOHAWK ST",
    "dropphycty": "MOHAWK",
    "dropphyst": "MI",
    "dropphyzpp": 499509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOHAWK",
    "dropmalst": "MI",
    "dropmalzpp": 499509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063370824,
    "dropsitcph": 9063370824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12397",
    "droptype": "D",
    "dropname": "MOLINE",
    "dropdeladd": "1229 144TH AVE",
    "dropdelcty": "MOLINE",
    "dropdelst": "MI",
    "dropdelzpp": 493359800,
    "dropphyadd": "1229 144TH AVE",
    "dropphycty": "MOLINE",
    "dropphyst": "MI",
    "dropphyzpp": 493359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOLINE",
    "dropmalst": "MI",
    "dropmalzpp": 493359998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168774223,
    "dropsitcph": 6168774223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12398",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "210 W FRONT ST",
    "dropdelcty": "MONROE",
    "dropdelst": "MI",
    "dropdelzpp": 481619998,
    "dropphyadd": "210 W FRONT ST",
    "dropphycty": "MONROE",
    "dropphyst": "MI",
    "dropphyzpp": 481619998,
    "dropmaladd": "210 W FRONT ST",
    "dropmalcty": "MONROE",
    "dropmalst": "MI",
    "dropmalzpp": 481619998,
    "dropsitphn": 7342412689,
    "dropsitlph": 3132268554,
    "dropsitcph": 7342412689,
    "dropfax": 7342436919
  },
  {
    "dcode": "D",
    "dropkey": "PY12399",
    "droptype": "D",
    "dropname": "MONTAGUE",
    "dropdeladd": "8761 FERRY ST",
    "dropdelcty": "MONTAGUE",
    "dropdelst": "MI",
    "dropdelzpp": 494371394,
    "dropphyadd": "8761 FERRY ST",
    "dropphycty": "MONTAGUE",
    "dropphyst": "MI",
    "dropphyzpp": 494371394,
    "dropmaladd": "8761 FERRY ST",
    "dropmalcty": "MONTAGUE",
    "dropmalst": "MI",
    "dropmalzpp": 494371394,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318944851,
    "dropsitcph": 2318944851,
    "dropfax": 2318938097
  },
  {
    "dcode": "D",
    "dropkey": "PY12400",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "106 W HAKES ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "MI",
    "dropdelzpp": 492559998,
    "dropphyadd": "106 W HAKES ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "MI",
    "dropphyzpp": 492559998,
    "dropmaladd": "106 W HAKES ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "MI",
    "dropmalzpp": 492559998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172964325,
    "dropfax": 5172964396
  },
  {
    "dcode": "D",
    "dropkey": "PY12401",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "125 W MAPLE ST",
    "dropdelcty": "MONTROSE",
    "dropdelst": "MI",
    "dropdelzpp": 484579998,
    "dropphyadd": "125 W MAPLE ST",
    "dropphycty": "MONTROSE",
    "dropphyst": "MI",
    "dropphyzpp": 484579998,
    "dropmaladd": "125 W MAPLE ST",
    "dropmalcty": "MONTROSE",
    "dropmalst": "MI",
    "dropmalzpp": 484579998,
    "dropsitphn": 8106396220,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106396220,
    "dropfax": 8106394340
  },
  {
    "dcode": "D",
    "dropkey": "PY12404",
    "droptype": "D",
    "dropname": "MORAN",
    "dropdeladd": "N4050 STATE ROUTE 123",
    "dropdelcty": "MORAN",
    "dropdelst": "MI",
    "dropdelzpp": 497609803,
    "dropphyadd": "N4050 STATE ROUTE 123",
    "dropphycty": "MORAN",
    "dropphyst": "MI",
    "dropphyzpp": 497609803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORAN",
    "dropmalst": "MI",
    "dropmalzpp": 497609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066438655,
    "dropsitcph": 9066438655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12405",
    "droptype": "D",
    "dropname": "MORENCI",
    "dropdeladd": "126 W MAIN ST",
    "dropdelcty": "MORENCI",
    "dropdelst": "MI",
    "dropdelzpp": 492569998,
    "dropphyadd": "126 W MAIN ST",
    "dropphycty": "MORENCI",
    "dropphyst": "MI",
    "dropphyzpp": 492569998,
    "dropmaladd": "126 W MAIN ST",
    "dropmalcty": "MORENCI",
    "dropmalst": "MI",
    "dropmalzpp": 492569998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174586145,
    "dropfax": 5174581204
  },
  {
    "dcode": "D",
    "dropkey": "PY12406",
    "droptype": "D",
    "dropname": "MORLEY",
    "dropdeladd": "123 S CASS ST",
    "dropdelcty": "MORLEY",
    "dropdelst": "MI",
    "dropdelzpp": 493369205,
    "dropphyadd": "123 S CASS ST",
    "dropphycty": "MORLEY",
    "dropphyst": "MI",
    "dropphyzpp": 493369205,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORLEY",
    "dropmalst": "MI",
    "dropmalzpp": 493369998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318564500,
    "dropsitcph": 2318564500,
    "dropfax": 2318560113
  },
  {
    "dcode": "D",
    "dropkey": "PY12407",
    "droptype": "D",
    "dropname": "MORRICE",
    "dropdeladd": "316 MAIN ST",
    "dropdelcty": "MORRICE",
    "dropdelst": "MI",
    "dropdelzpp": 488572523,
    "dropphyadd": "316 MAIN ST",
    "dropphycty": "MORRICE",
    "dropphyst": "MI",
    "dropphyzpp": 488572523,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRICE",
    "dropmalst": "MI",
    "dropmalzpp": 488579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176254202,
    "dropsitcph": 5176254202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12409",
    "droptype": "D",
    "dropname": "MOSHERVILLE",
    "dropdeladd": "11200 WINFIELD RD",
    "dropdelcty": "MOSHERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 492589998,
    "dropphyadd": "11200 WINFIELD RD",
    "dropphycty": "MOSHERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 492589998,
    "dropmaladd": "11200 WINFIELD RD",
    "dropmalcty": "MOSHERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 492589998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175495009,
    "dropfax": 5175498433
  },
  {
    "dcode": "D",
    "dropkey": "PY12413",
    "droptype": "D",
    "dropname": "MOUNT CLEMENS",
    "dropdeladd": "155 S MAIN ST",
    "dropdelcty": "MOUNT CLEMENS",
    "dropdelst": "MI",
    "dropdelzpp": 480469998,
    "dropphyadd": "155 S MAIN ST",
    "dropphycty": "MOUNT CLEMENS",
    "dropphyst": "MI",
    "dropphyzpp": 480469998,
    "dropmaladd": "155 S MAIN ST",
    "dropmalcty": "MOUNT CLEMENS",
    "dropmalst": "MI",
    "dropmalzpp": 480469998,
    "dropsitphn": 5867832879,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867832879,
    "dropfax": 5864651471
  },
  {
    "dcode": "D",
    "dropkey": "PY12415",
    "droptype": "D",
    "dropname": "MOUNT MORRIS",
    "dropdeladd": "760 ALBERT ST",
    "dropdelcty": "MOUNT MORRIS",
    "dropdelst": "MI",
    "dropdelzpp": 484589998,
    "dropphyadd": "760 ALBERT ST",
    "dropphycty": "MOUNT MORRIS",
    "dropphyst": "MI",
    "dropphyzpp": 484589998,
    "dropmaladd": "760 ALBERT ST",
    "dropmalcty": "MOUNT MORRIS",
    "dropmalst": "MI",
    "dropmalzpp": 484589998,
    "dropsitphn": 8106868500,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106868500,
    "dropfax": 8106862158
  },
  {
    "dcode": "D",
    "dropkey": "PY12416",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "813 N MAIN ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "MI",
    "dropdelzpp": 488581506,
    "dropphyadd": "813 N MAIN ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "MI",
    "dropphyzpp": 488581506,
    "dropmaladd": "813 N MAIN ST",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "MI",
    "dropmalzpp": 488581506,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897733653,
    "dropsitcph": 9897733653,
    "dropfax": 9897734820
  },
  {
    "dcode": "D",
    "dropkey": "PY12420",
    "droptype": "D",
    "dropname": "MUIR",
    "dropdeladd": "230 SUPERIOR ST",
    "dropdelcty": "MUIR",
    "dropdelst": "MI",
    "dropdelzpp": 488609806,
    "dropphyadd": "230 SUPERIOR ST",
    "dropphycty": "MUIR",
    "dropphyst": "MI",
    "dropphyzpp": 488609806,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MUIR",
    "dropmalst": "MI",
    "dropmalzpp": 488609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898553318,
    "dropsitcph": 9898553318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12421",
    "droptype": "D",
    "dropname": "MULLETT LAKE",
    "dropdeladd": "7221 MULLETT LAKE RD",
    "dropdelcty": "MULLETT LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497619800,
    "dropphyadd": "7221 MULLETT LAKE RD",
    "dropphycty": "MULLETT LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MULLETT LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497619998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316277972,
    "dropsitcph": 2316277972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12422",
    "droptype": "D",
    "dropname": "MULLIKEN",
    "dropdeladd": "129 MAIN ST",
    "dropdelcty": "MULLIKEN",
    "dropdelst": "MI",
    "dropdelzpp": 488615102,
    "dropphyadd": "129 MAIN ST",
    "dropphycty": "MULLIKEN",
    "dropphyst": "MI",
    "dropphyzpp": 488615102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MULLIKEN",
    "dropmalst": "MI",
    "dropmalzpp": 488619998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176498356,
    "dropsitcph": 5176498356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12423",
    "droptype": "D",
    "dropname": "MUNGER",
    "dropdeladd": "11 E MUNGER RD",
    "dropdelcty": "MUNGER",
    "dropdelst": "MI",
    "dropdelzpp": 487479800,
    "dropphyadd": "11 E MUNGER RD",
    "dropphycty": "MUNGER",
    "dropphyst": "MI",
    "dropphyzpp": 487479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MUNGER",
    "dropmalst": "MI",
    "dropmalzpp": 487479998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896592255,
    "dropsitcph": 9896592255,
    "dropfax": 9896592255
  },
  {
    "dcode": "D",
    "dropkey": "PY12424",
    "droptype": "D",
    "dropname": "MUNISING",
    "dropdeladd": "220 ELM AVE",
    "dropdelcty": "MUNISING",
    "dropdelst": "MI",
    "dropdelzpp": 498629998,
    "dropphyadd": "220 ELM AVE",
    "dropphycty": "MUNISING",
    "dropphyst": "MI",
    "dropphyzpp": 498629998,
    "dropmaladd": "220 ELM AVE",
    "dropmalcty": "MUNISING",
    "dropmalst": "MI",
    "dropmalzpp": 498629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063872081,
    "dropsitcph": 9063872081,
    "dropfax": 9063874832
  },
  {
    "dcode": "D",
    "dropkey": "PY12425",
    "droptype": "D",
    "dropname": "MUNITH",
    "dropdeladd": "100 W 6TH ST",
    "dropdelcty": "MUNITH",
    "dropdelst": "MI",
    "dropdelzpp": 492599998,
    "dropphyadd": "100 W 6TH ST",
    "dropphycty": "MUNITH",
    "dropphyst": "MI",
    "dropphyzpp": 492599998,
    "dropmaladd": "100 W 6TH ST",
    "dropmalcty": "MUNITH",
    "dropmalst": "MI",
    "dropmalzpp": 492599998,
    "dropsitphn": 5175963442,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175963442,
    "dropfax": 5175963314
  },
  {
    "dcode": "D",
    "dropkey": "PY12426",
    "droptype": "D",
    "dropname": "MUSKEGON",
    "dropdeladd": "800 1ST ST",
    "dropdelcty": "MUSKEGON",
    "dropdelst": "MI",
    "dropdelzpp": 494409998,
    "dropphyadd": "800 1ST ST",
    "dropphycty": "MUSKEGON",
    "dropphyst": "MI",
    "dropphyzpp": 494409998,
    "dropmaladd": "800 1ST ST",
    "dropmalcty": "MUSKEGON",
    "dropmalst": "MI",
    "dropmalzpp": 494409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317227292,
    "dropsitcph": 2317227292,
    "dropfax": 2317220428
  },
  {
    "dcode": "D",
    "dropkey": "PY12437",
    "droptype": "D",
    "dropname": "NADEAU",
    "dropdeladd": "N13755 1ST ST",
    "dropdelcty": "NADEAU",
    "dropdelst": "MI",
    "dropdelzpp": 498639800,
    "dropphyadd": "N13755 1ST ST",
    "dropphycty": "NADEAU",
    "dropphyst": "MI",
    "dropphyzpp": 498639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NADEAU",
    "dropmalst": "MI",
    "dropmalzpp": 498639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9066392179,
    "dropsitcph": 9066392179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12439",
    "droptype": "D",
    "dropname": "NAPOLEON",
    "dropdeladd": "125 AUSTIN RD",
    "dropdelcty": "NAPOLEON",
    "dropdelst": "MI",
    "dropdelzpp": 492619998,
    "dropphyadd": "125 AUSTIN RD",
    "dropphycty": "NAPOLEON",
    "dropphyst": "MI",
    "dropphyzpp": 492619998,
    "dropmaladd": "125 AUSTIN RD",
    "dropmalcty": "NAPOLEON",
    "dropmalst": "MI",
    "dropmalzpp": 492619998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175360271,
    "dropfax": 5175360810
  },
  {
    "dcode": "D",
    "dropkey": "PY12440",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "231 N MAIN ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 490739577,
    "dropphyadd": "231 N MAIN ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 490739577,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 490739998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5178529607,
    "dropsitcph": 5178529607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12443",
    "droptype": "D",
    "dropname": "NATIONAL CITY",
    "dropdeladd": "4770 WHITTEMORE RD",
    "dropdelcty": "NATIONAL CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487489800,
    "dropphyadd": "4770 WHITTEMORE RD",
    "dropphycty": "NATIONAL CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NATIONAL CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487489998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897563911,
    "dropsitcph": 9897563911,
    "dropfax": 9897563911
  },
  {
    "dcode": "D",
    "dropkey": "PY12445",
    "droptype": "D",
    "dropname": "NAUBINWAY",
    "dropdeladd": "W11631 US HIGHWAY 2",
    "dropdelcty": "NAUBINWAY",
    "dropdelst": "MI",
    "dropdelzpp": 497625116,
    "dropphyadd": "W11631 US HIGHWAY 2",
    "dropphycty": "NAUBINWAY",
    "dropphyst": "MI",
    "dropphyzpp": 497625116,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAUBINWAY",
    "dropmalst": "MI",
    "dropmalzpp": 497629998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064776406,
    "dropsitcph": 9064776406,
    "dropfax": 9064773062
  },
  {
    "dcode": "D",
    "dropkey": "PY12446",
    "droptype": "D",
    "dropname": "NAZARETH",
    "dropdeladd": "5073 GULL RD",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490484020,
    "dropphyadd": "5073 GULL RD",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490484020,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAZARETH",
    "dropmalst": "MI",
    "dropmalzpp": 490749998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693425687,
    "dropsitcph": 2693425687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12447",
    "droptype": "D",
    "dropname": "NEGAUNEE",
    "dropdeladd": "304 W CASE ST",
    "dropdelcty": "NEGAUNEE",
    "dropdelst": "MI",
    "dropdelzpp": 498669998,
    "dropphyadd": "304 W CASE ST",
    "dropphycty": "NEGAUNEE",
    "dropphyst": "MI",
    "dropphyzpp": 498669998,
    "dropmaladd": "304 W CASE ST",
    "dropmalcty": "NEGAUNEE",
    "dropmalst": "MI",
    "dropmalzpp": 498669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064759172,
    "dropsitcph": 9064759172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12448",
    "droptype": "D",
    "dropname": "NEW BALTIMORE",
    "dropdeladd": "35339 23 MILE RD",
    "dropdelcty": "NEW BALTIMORE",
    "dropdelst": "MI",
    "dropdelzpp": 480479998,
    "dropphyadd": "35339 23 MILE RD",
    "dropphycty": "NEW BALTIMORE",
    "dropphyst": "MI",
    "dropphyzpp": 480479998,
    "dropmaladd": "35339 23 MILE RD",
    "dropmalcty": "NEW BALTIMORE",
    "dropmalst": "MI",
    "dropmalzpp": 480479998,
    "dropsitphn": 5867256575,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867256575,
    "dropfax": 5867256336
  },
  {
    "dcode": "D",
    "dropkey": "PY12449",
    "droptype": "D",
    "dropname": "NEW BOSTON",
    "dropdeladd": "18777 HURON RIVER DR",
    "dropdelcty": "NEW BOSTON",
    "dropdelst": "MI",
    "dropdelzpp": 481649998,
    "dropphyadd": "18777 HURON RIVER DR",
    "dropphycty": "NEW BOSTON",
    "dropphyst": "MI",
    "dropphyzpp": 481649998,
    "dropmaladd": "18777 HURON RIVER DR",
    "dropmalcty": "NEW BOSTON",
    "dropmalst": "MI",
    "dropmalzpp": 481649998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7347534938,
    "dropfax": 7347530831
  },
  {
    "dcode": "D",
    "dropkey": "PY12450",
    "droptype": "D",
    "dropname": "NEW BUFFALO",
    "dropdeladd": "325 W BUFFALO ST",
    "dropdelcty": "NEW BUFFALO",
    "dropdelst": "MI",
    "dropdelzpp": 491179998,
    "dropphyadd": "325 W BUFFALO ST",
    "dropphycty": "NEW BUFFALO",
    "dropphyst": "MI",
    "dropphyzpp": 491179998,
    "dropmaladd": "325 W BUFFALO ST",
    "dropmalcty": "NEW BUFFALO",
    "dropmalst": "MI",
    "dropmalzpp": 491179998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694693200,
    "dropsitcph": 2694693200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12451",
    "droptype": "D",
    "dropname": "NEW ERA",
    "dropdeladd": "4695 1ST ST",
    "dropdelcty": "NEW ERA",
    "dropdelst": "MI",
    "dropdelzpp": 494465101,
    "dropphyadd": "4695 1ST ST",
    "dropphycty": "NEW ERA",
    "dropphyst": "MI",
    "dropphyzpp": 494465101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ERA",
    "dropmalst": "MI",
    "dropmalzpp": 494469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318615249,
    "dropsitcph": 2318615249,
    "dropfax": 6168615249
  },
  {
    "dcode": "D",
    "dropkey": "PY12452",
    "droptype": "D",
    "dropname": "NEW HAVEN",
    "dropdeladd": "58480 MAIN ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "MI",
    "dropdelzpp": 480489998,
    "dropphyadd": "58480 MAIN ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "MI",
    "dropphyzpp": 480489998,
    "dropmaladd": "58480 MAIN ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "MI",
    "dropmalzpp": 480489998,
    "dropsitphn": 5867498472,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867498472,
    "dropfax": 5867493504
  },
  {
    "dcode": "D",
    "dropkey": "PY12453",
    "droptype": "D",
    "dropname": "NEW HUDSON",
    "dropdeladd": "56655 GRAND RIVER AVE",
    "dropdelcty": "NEW HUDSON",
    "dropdelst": "MI",
    "dropdelzpp": 481659998,
    "dropphyadd": "56655 GRAND RIVER AVE",
    "dropphycty": "NEW HUDSON",
    "dropphyst": "MI",
    "dropphyzpp": 481659998,
    "dropmaladd": "56655 GRAND RIVER AVE",
    "dropmalcty": "NEW HUDSON",
    "dropmalst": "MI",
    "dropmalzpp": 481659998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 2484374418,
    "dropfax": 2484376718
  },
  {
    "dcode": "D",
    "dropkey": "PY12454",
    "droptype": "D",
    "dropname": "NEW LOTHROP",
    "dropdeladd": "7505 S SAGINAW ST",
    "dropdelcty": "NEW LOTHROP",
    "dropdelst": "MI",
    "dropdelzpp": 484609998,
    "dropphyadd": "7505 S SAGINAW ST",
    "dropphycty": "NEW LOTHROP",
    "dropphyst": "MI",
    "dropphyzpp": 484609998,
    "dropmaladd": "7505 S SAGINAW ST",
    "dropmalcty": "NEW LOTHROP",
    "dropmalst": "MI",
    "dropmalzpp": 484609998,
    "dropsitphn": 8106385792,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106385792,
    "dropfax": 8106387328
  },
  {
    "dcode": "D",
    "dropkey": "PY12457",
    "droptype": "D",
    "dropname": "NEW TROY",
    "dropdeladd": "13377 CALIFORNIA RD",
    "dropdelcty": "NEW TROY",
    "dropdelst": "MI",
    "dropdelzpp": 491199802,
    "dropphyadd": "13377 CALIFORNIA RD",
    "dropphycty": "NEW TROY",
    "dropphyst": "MI",
    "dropphyzpp": 491199802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW TROY",
    "dropmalst": "MI",
    "dropmalzpp": 491199998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694263987,
    "dropsitcph": 2694263987,
    "dropfax": 2694266302
  },
  {
    "dcode": "D",
    "dropkey": "PY12458",
    "droptype": "D",
    "dropname": "NEWAYGO",
    "dropdeladd": "136 W WOOD ST",
    "dropdelcty": "NEWAYGO",
    "dropdelst": "MI",
    "dropdelzpp": 493378991,
    "dropphyadd": "136 W WOOD ST",
    "dropphycty": "NEWAYGO",
    "dropphyst": "MI",
    "dropphyzpp": 493378991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWAYGO",
    "dropmalst": "MI",
    "dropmalzpp": 493379998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316526677,
    "dropsitcph": 2316526677,
    "dropfax": 2316526055
  },
  {
    "dcode": "D",
    "dropkey": "PY12459",
    "droptype": "D",
    "dropname": "NEWBERRY",
    "dropdeladd": "216 E JOHN ST",
    "dropdelcty": "NEWBERRY",
    "dropdelst": "MI",
    "dropdelzpp": 498689998,
    "dropphyadd": "216 E JOHN ST",
    "dropphycty": "NEWBERRY",
    "dropphyst": "MI",
    "dropphyzpp": 498689998,
    "dropmaladd": "216 E JOHN ST",
    "dropmalcty": "NEWBERRY",
    "dropmalst": "MI",
    "dropmalzpp": 498689998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062938631,
    "dropsitcph": 9062938631,
    "dropfax": 9062934930
  },
  {
    "dcode": "D",
    "dropkey": "PY12461",
    "droptype": "D",
    "dropname": "NILES",
    "dropdeladd": "741 BROADWAY ST",
    "dropdelcty": "NILES",
    "dropdelst": "MI",
    "dropdelzpp": 491209998,
    "dropphyadd": "741 BROADWAY ST",
    "dropphycty": "NILES",
    "dropphyst": "MI",
    "dropphyzpp": 491209998,
    "dropmaladd": "741 BROADWAY ST",
    "dropmalcty": "NILES",
    "dropmalst": "MI",
    "dropmalzpp": 491209998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696835520,
    "dropsitcph": 2696835520,
    "dropfax": 2696832362
  },
  {
    "dcode": "D",
    "dropkey": "PY12462",
    "droptype": "D",
    "dropname": "NISULA",
    "dropdeladd": "9350 STATE HIGHWAY M38",
    "dropdelcty": "NISULA",
    "dropdelst": "MI",
    "dropdelzpp": 499529600,
    "dropphyadd": "9350 STATE HIGHWAY M38",
    "dropphycty": "NISULA",
    "dropphyst": "MI",
    "dropphyzpp": 499529600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NISULA",
    "dropmalst": "MI",
    "dropmalzpp": 499529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063382674,
    "dropsitcph": 9063382674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12465",
    "droptype": "D",
    "dropname": "NORTH ADAMS",
    "dropdeladd": "114 W MAIN ST",
    "dropdelcty": "NORTH ADAMS",
    "dropdelst": "MI",
    "dropdelzpp": 492629998,
    "dropphyadd": "114 W MAIN ST",
    "dropphycty": "NORTH ADAMS",
    "dropphyst": "MI",
    "dropphyzpp": 492629998,
    "dropmaladd": "114 W MAIN ST",
    "dropmalcty": "NORTH ADAMS",
    "dropmalst": "MI",
    "dropmalzpp": 492629998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172875098,
    "dropfax": 5172875306
  },
  {
    "dcode": "D",
    "dropkey": "PY12466",
    "droptype": "D",
    "dropname": "NORTH BRANCH",
    "dropdeladd": "6720 LINCOLN ST",
    "dropdelcty": "NORTH BRANCH",
    "dropdelst": "MI",
    "dropdelzpp": 484619998,
    "dropphyadd": "6720 LINCOLN ST",
    "dropphycty": "NORTH BRANCH",
    "dropphyst": "MI",
    "dropphyzpp": 484619998,
    "dropmaladd": "6720 LINCOLN ST",
    "dropmalcty": "NORTH BRANCH",
    "dropmalst": "MI",
    "dropmalzpp": 484619998,
    "dropsitphn": 8106883652,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106883652,
    "dropfax": 8106882944
  },
  {
    "dcode": "D",
    "dropkey": "PY12473",
    "droptype": "D",
    "dropname": "NORTH STAR",
    "dropdeladd": "107 W GRATIOT ST",
    "dropdelcty": "NORTH STAR",
    "dropdelst": "MI",
    "dropdelzpp": 488625126,
    "dropphyadd": "107 W GRATIOT ST",
    "dropphycty": "NORTH STAR",
    "dropphyst": "MI",
    "dropphyzpp": 488625126,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH STAR",
    "dropmalst": "MI",
    "dropmalzpp": 488629998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898752331,
    "dropsitcph": 9898752331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12474",
    "droptype": "D",
    "dropname": "NORTH STREET",
    "dropdeladd": "5201 NORTH RD",
    "dropdelcty": "NORTH STREET",
    "dropdelst": "MI",
    "dropdelzpp": 480499998,
    "dropphyadd": "5201 NORTH RD",
    "dropphycty": "NORTH STREET",
    "dropphyst": "MI",
    "dropphyzpp": 480499998,
    "dropmaladd": "5201 NORTH RD",
    "dropmalcty": "NORTH STREET",
    "dropmalst": "MI",
    "dropmalzpp": 480499998,
    "dropsitphn": 8109897920,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103853731,
    "dropfax": 8103851869
  },
  {
    "dcode": "D",
    "dropkey": "PY12479",
    "droptype": "D",
    "dropname": "NORTHPORT",
    "dropdeladd": "117 E NAGONABA ST",
    "dropdelcty": "NORTHPORT",
    "dropdelst": "MI",
    "dropdelzpp": 496705017,
    "dropphyadd": "117 E NAGONABA ST",
    "dropphycty": "NORTHPORT",
    "dropphyst": "MI",
    "dropphyzpp": 496705017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTHPORT",
    "dropmalst": "MI",
    "dropmalzpp": 496709998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313865852,
    "dropsitcph": 2313865852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12482",
    "droptype": "D",
    "dropname": "NORTHVILLE",
    "dropdeladd": "200 S WING ST",
    "dropdelcty": "NORTHVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 481671544,
    "dropphyadd": "200 S WING ST",
    "dropphycty": "NORTHVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 481671544,
    "dropmaladd": "200 S WING ST",
    "dropmalcty": "NORTHVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 481671544,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 2483492062,
    "dropfax": 2483498134
  },
  {
    "dcode": "D",
    "dropkey": "PY12488",
    "droptype": "D",
    "dropname": "NORVELL",
    "dropdeladd": "105 E COMMERCIAL ST",
    "dropdelcty": "NORVELL",
    "dropdelst": "MI",
    "dropdelzpp": 492639998,
    "dropphyadd": "105 E COMMERCIAL ST",
    "dropphycty": "NORVELL",
    "dropphyst": "MI",
    "dropphyzpp": 492639998,
    "dropmaladd": "105 E COMMERCIAL ST",
    "dropmalcty": "NORVELL",
    "dropmalst": "MI",
    "dropmalzpp": 492639998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175360316,
    "dropfax": 5175364592
  },
  {
    "dcode": "D",
    "dropkey": "PY12489",
    "droptype": "D",
    "dropname": "NORWAY",
    "dropdeladd": "520 MAIN ST",
    "dropdelcty": "NORWAY",
    "dropdelst": "MI",
    "dropdelzpp": 498709998,
    "dropphyadd": "520 MAIN ST",
    "dropphycty": "NORWAY",
    "dropphyst": "MI",
    "dropphyzpp": 498709998,
    "dropmaladd": "520 MAIN ST",
    "dropmalcty": "NORWAY",
    "dropmalst": "MI",
    "dropmalzpp": 498709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065638816,
    "dropsitcph": 9065638816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12490",
    "droptype": "D",
    "dropname": "NOTTAWA",
    "dropdeladd": "25987 M 86 HWY",
    "dropdelcty": "NOTTAWA",
    "dropdelst": "MI",
    "dropdelzpp": 490759800,
    "dropphyadd": "25987 M 86 HWY",
    "dropphycty": "NOTTAWA",
    "dropphyst": "MI",
    "dropphyzpp": 490759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOTTAWA",
    "dropmalst": "MI",
    "dropmalzpp": 490759998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694677066,
    "dropsitcph": 2694677066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12491",
    "droptype": "D",
    "dropname": "NOVI",
    "dropdeladd": "24875 NOVI RD",
    "dropdelcty": "NOVI",
    "dropdelst": "MI",
    "dropdelzpp": 483769998,
    "dropphyadd": "24875 NOVI RD",
    "dropphycty": "NOVI",
    "dropphyst": "MI",
    "dropphyzpp": 483769998,
    "dropmaladd": "24875 NOVI RD",
    "dropmalcty": "NOVI",
    "dropmalst": "MI",
    "dropmalzpp": 483769998,
    "dropsitphn": 2484739422,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483493152,
    "dropfax": 2484787854
  },
  {
    "dcode": "D",
    "dropkey": "PY12494",
    "droptype": "D",
    "dropname": "NUNICA",
    "dropdeladd": "16980 MAIN ST",
    "dropdelcty": "NUNICA",
    "dropdelst": "MI",
    "dropdelzpp": 494485113,
    "dropphyadd": "16980 MAIN ST",
    "dropphycty": "NUNICA",
    "dropphyst": "MI",
    "dropphyzpp": 494485113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUNICA",
    "dropmalst": "MI",
    "dropmalzpp": 494489998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168376280,
    "dropsitcph": 6168376280,
    "dropfax": 6168375084
  },
  {
    "dcode": "D",
    "dropkey": "PY12500",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "OAKLEY",
    "dropdelst": "MI",
    "dropdelzpp": 486497708,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "OAKLEY",
    "dropphyst": "MI",
    "dropphyzpp": 486497708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKLEY",
    "dropmalst": "MI",
    "dropmalzpp": 486499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898456498,
    "dropsitcph": 9892082280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12502",
    "droptype": "D",
    "dropname": "ODEN",
    "dropdeladd": "8841 MAIN ST",
    "dropdelcty": "ODEN",
    "dropdelst": "MI",
    "dropdelzpp": 497649800,
    "dropphyadd": "8841 MAIN ST",
    "dropphycty": "ODEN",
    "dropphyst": "MI",
    "dropphyzpp": 497649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODEN",
    "dropmalst": "MI",
    "dropmalzpp": 497649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313477710,
    "dropsitcph": 2313477710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12506",
    "droptype": "D",
    "dropname": "OKEMOS",
    "dropdeladd": "2025 CENTRAL PARK DR",
    "dropdelcty": "OKEMOS",
    "dropdelst": "MI",
    "dropdelzpp": 488649998,
    "dropphyadd": "2025 CENTRAL PARK DR",
    "dropphycty": "OKEMOS",
    "dropphyst": "MI",
    "dropphyzpp": 488649998,
    "dropmaladd": "2025 CENTRAL PARK DR",
    "dropmalcty": "OKEMOS",
    "dropmalst": "MI",
    "dropmalzpp": 488649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173491334,
    "dropsitcph": 5173491334,
    "dropfax": 5173492878
  },
  {
    "dcode": "D",
    "dropkey": "PY12507",
    "droptype": "D",
    "dropname": "OLD MISSION",
    "dropdeladd": "4007 SWANEY RD",
    "dropdelcty": "OLD MISSION",
    "dropdelst": "MI",
    "dropdelzpp": 496739800,
    "dropphyadd": "4007 SWANEY RD",
    "dropphycty": "OLD MISSION",
    "dropphyst": "MI",
    "dropphyzpp": 496739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD MISSION",
    "dropmalst": "MI",
    "dropmalzpp": 496739998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312234200,
    "dropsitcph": 2312234200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12511",
    "droptype": "D",
    "dropname": "OLIVET",
    "dropdeladd": "132 WASHINGTON ST",
    "dropdelcty": "OLIVET",
    "dropdelst": "MI",
    "dropdelzpp": 490768642,
    "dropphyadd": "132 WASHINGTON ST",
    "dropphycty": "OLIVET",
    "dropphyst": "MI",
    "dropphyzpp": 490768642,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLIVET",
    "dropmalst": "MI",
    "dropmalzpp": 490769998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697493691,
    "dropsitcph": 2697493691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12512",
    "droptype": "D",
    "dropname": "OMENA",
    "dropdeladd": "5059 N WEST BAYSHORE DR",
    "dropdelcty": "OMENA",
    "dropdelst": "MI",
    "dropdelzpp": 496749800,
    "dropphyadd": "5059 N WEST BAYSHORE DR",
    "dropphycty": "OMENA",
    "dropphyst": "MI",
    "dropphyzpp": 496749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMENA",
    "dropmalst": "MI",
    "dropmalzpp": 496749998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313865971,
    "dropsitcph": 2313865971,
    "dropfax": 2313865971
  },
  {
    "dcode": "D",
    "dropkey": "PY12513",
    "droptype": "D",
    "dropname": "OMER",
    "dropdeladd": "100 BRIDGE ST",
    "dropdelcty": "OMER",
    "dropdelst": "MI",
    "dropdelzpp": 487495100,
    "dropphyadd": "100 BRIDGE ST",
    "dropphycty": "OMER",
    "dropphyst": "MI",
    "dropphyzpp": 487495100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMER",
    "dropmalst": "MI",
    "dropmalzpp": 487499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896532330,
    "dropsitcph": 9896532330,
    "dropfax": 9896532330
  },
  {
    "dcode": "D",
    "dropkey": "PY12514",
    "droptype": "D",
    "dropname": "ONAWAY",
    "dropdeladd": "20675 STATE ST",
    "dropdelcty": "ONAWAY",
    "dropdelst": "MI",
    "dropdelzpp": 497655115,
    "dropphyadd": "20675 STATE ST",
    "dropphycty": "ONAWAY",
    "dropphyst": "MI",
    "dropphyzpp": 497655115,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONAWAY",
    "dropmalst": "MI",
    "dropmalzpp": 497659998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897338613,
    "dropsitcph": 9897338613,
    "dropfax": 9897337112
  },
  {
    "dcode": "D",
    "dropkey": "PY12515",
    "droptype": "D",
    "dropname": "ONEKAMA",
    "dropdeladd": "8311 MILL ST",
    "dropdelcty": "ONEKAMA",
    "dropdelst": "MI",
    "dropdelzpp": 496759800,
    "dropphyadd": "8311 MILL ST",
    "dropphycty": "ONEKAMA",
    "dropphyst": "MI",
    "dropphyzpp": 496759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONEKAMA",
    "dropmalst": "MI",
    "dropmalzpp": 496759998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318894756,
    "dropsitcph": 2318894756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12516",
    "droptype": "D",
    "dropname": "ONONDAGA",
    "dropdeladd": "5555 OAK ST",
    "dropdelcty": "ONONDAGA",
    "dropdelst": "MI",
    "dropdelzpp": 492649998,
    "dropphyadd": "5555 OAK ST",
    "dropphycty": "ONONDAGA",
    "dropphyst": "MI",
    "dropphyzpp": 492649998,
    "dropmaladd": "5555 OAK ST",
    "dropmalcty": "ONONDAGA",
    "dropmalst": "MI",
    "dropmalzpp": 492649998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5176282232,
    "dropfax": 5176282161
  },
  {
    "dcode": "D",
    "dropkey": "PY12517",
    "droptype": "D",
    "dropname": "ONSTED",
    "dropdeladd": "110 E 3RD ST",
    "dropdelcty": "ONSTED",
    "dropdelst": "MI",
    "dropdelzpp": 492659998,
    "dropphyadd": "110 E 3RD ST",
    "dropphycty": "ONSTED",
    "dropphyst": "MI",
    "dropphyzpp": 492659998,
    "dropmaladd": "110 E 3RD ST",
    "dropmalcty": "ONSTED",
    "dropmalst": "MI",
    "dropmalzpp": 492659998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174672530,
    "dropfax": 5174679088
  },
  {
    "dcode": "D",
    "dropkey": "PY12518",
    "droptype": "D",
    "dropname": "ONTONAGON",
    "dropdeladd": "207 COPPER ST",
    "dropdelcty": "ONTONAGON",
    "dropdelst": "MI",
    "dropdelzpp": 499539998,
    "dropphyadd": "207 COPPER ST",
    "dropphycty": "ONTONAGON",
    "dropphyst": "MI",
    "dropphyzpp": 499539998,
    "dropmaladd": "207 COPPER ST",
    "dropmalcty": "ONTONAGON",
    "dropmalst": "MI",
    "dropmalzpp": 499539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068842646,
    "dropsitcph": 9063657006,
    "dropfax": 9063657004
  },
  {
    "dcode": "D",
    "dropkey": "PY12524",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "3018 W PALMER RD",
    "dropdelcty": "ORLEANS",
    "dropdelst": "MI",
    "dropdelzpp": 488659804,
    "dropphyadd": "3018 W PALMER RD",
    "dropphycty": "ORLEANS",
    "dropphyst": "MI",
    "dropphyzpp": 488659804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORLEANS",
    "dropmalst": "MI",
    "dropmalzpp": 488659998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167613129,
    "dropsitcph": 6167613129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12525",
    "droptype": "D",
    "dropname": "ORTONVILLE",
    "dropdeladd": "55 POND ST",
    "dropdelcty": "ORTONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484629998,
    "dropphyadd": "55 POND ST",
    "dropphycty": "ORTONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484629998,
    "dropmaladd": "55 POND ST",
    "dropmalcty": "ORTONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484629998,
    "dropsitphn": 2486272070,
    "dropsitlph": 8102571580,
    "dropsitcph": 2486272070,
    "dropfax": 2486272186
  },
  {
    "dcode": "D",
    "dropkey": "PY12526",
    "droptype": "D",
    "dropname": "OSCODA",
    "dropdeladd": "221 N STATE ST",
    "dropdelcty": "OSCODA",
    "dropdelst": "MI",
    "dropdelzpp": 487501749,
    "dropphyadd": "221 N STATE ST",
    "dropphycty": "OSCODA",
    "dropphyst": "MI",
    "dropphyzpp": 487501749,
    "dropmaladd": "221 N STATE ST",
    "dropmalcty": "OSCODA",
    "dropmalst": "MI",
    "dropmalzpp": 487501749,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715727,
    "dropsitcph": 9897395112,
    "dropfax": 9897395949
  },
  {
    "dcode": "D",
    "dropkey": "PY12527",
    "droptype": "D",
    "dropname": "OSHTEMO",
    "dropdeladd": "3885 S 9TH ST",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490099502,
    "dropphyadd": "3885 S 9TH ST",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490099997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSHTEMO",
    "dropmalst": "MI",
    "dropmalzpp": 490779998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693535067,
    "dropsitcph": 2693535045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12528",
    "droptype": "D",
    "dropname": "OSSEO",
    "dropdeladd": "5500 BEECHER RD",
    "dropdelcty": "OSSEO",
    "dropdelst": "MI",
    "dropdelzpp": 492669998,
    "dropphyadd": "5500 BEECHER RD",
    "dropphycty": "OSSEO",
    "dropphyst": "MI",
    "dropphyzpp": 492669998,
    "dropmaladd": "5500 BEECHER RD",
    "dropmalcty": "OSSEO",
    "dropmalst": "MI",
    "dropmalzpp": 492669998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5175232556,
    "dropsitcph": 5175234166,
    "dropfax": 5175233081
  },
  {
    "dcode": "D",
    "dropkey": "PY12529",
    "droptype": "D",
    "dropname": "OSSINEKE",
    "dropdeladd": "11926 US HIGHWAY 23 S",
    "dropdelcty": "OSSINEKE",
    "dropdelst": "MI",
    "dropdelzpp": 497669588,
    "dropphyadd": "11926 US HIGHWAY 23 S",
    "dropphycty": "OSSINEKE",
    "dropphyst": "MI",
    "dropphyzpp": 497669588,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSSINEKE",
    "dropmalst": "MI",
    "dropmalzpp": 497669998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893403095,
    "dropsitcph": 9893403095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12530",
    "droptype": "D",
    "dropname": "OTISVILLE",
    "dropdeladd": "199 N STATE ST",
    "dropdelcty": "OTISVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 484639998,
    "dropphyadd": "199 N STATE ST",
    "dropphycty": "OTISVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 484639998,
    "dropmaladd": "199 N STATE ST",
    "dropmalcty": "OTISVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 484639998,
    "dropsitphn": 8106312825,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106312825,
    "dropfax": 8106313461
  },
  {
    "dcode": "D",
    "dropkey": "PY12531",
    "droptype": "D",
    "dropname": "OTSEGO",
    "dropdeladd": "118 N FAIR ST",
    "dropdelcty": "OTSEGO",
    "dropdelst": "MI",
    "dropdelzpp": 490781167,
    "dropphyadd": "118 N FAIR ST",
    "dropphycty": "OTSEGO",
    "dropphyst": "MI",
    "dropphyzpp": 490781167,
    "dropmaladd": "118 N FAIR ST",
    "dropmalcty": "OTSEGO",
    "dropmalst": "MI",
    "dropmalzpp": 490781167,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696942868,
    "dropsitcph": 2696942868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12532",
    "droptype": "D",
    "dropname": "OTTAWA LAKE",
    "dropdeladd": "8425 BROWN ST",
    "dropdelcty": "OTTAWA LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 492679998,
    "dropphyadd": "8425 BROWN ST",
    "dropphycty": "OTTAWA LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 492679998,
    "dropmaladd": "8425 BROWN ST",
    "dropmalcty": "OTTAWA LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 492679998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 7348564321,
    "dropfax": 7348567165
  },
  {
    "dcode": "D",
    "dropkey": "PY12533",
    "droptype": "D",
    "dropname": "OTTER LAKE",
    "dropdeladd": "6384 DETROIT ST",
    "dropdelcty": "OTTER LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 484649998,
    "dropphyadd": "6384 DETROIT ST",
    "dropphycty": "OTTER LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 484649998,
    "dropmaladd": "6384 DETROIT ST",
    "dropmalcty": "OTTER LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 484649998,
    "dropsitphn": 8107932615,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107932615,
    "dropfax": 8107938940
  },
  {
    "dcode": "D",
    "dropkey": "PY12536",
    "droptype": "D",
    "dropname": "OVID",
    "dropdeladd": "203 N MAIN ST",
    "dropdelcty": "OVID",
    "dropdelst": "MI",
    "dropdelzpp": 488669814,
    "dropphyadd": "203 N MAIN ST",
    "dropphycty": "OVID",
    "dropphyst": "MI",
    "dropphyzpp": 488669814,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OVID",
    "dropmalst": "MI",
    "dropmalzpp": 488669998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898345404,
    "dropsitcph": 9898345404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12538",
    "droptype": "D",
    "dropname": "OWENDALE",
    "dropdeladd": "7314 MAIN ST",
    "dropdelcty": "OWENDALE",
    "dropdelst": "MI",
    "dropdelzpp": 487545129,
    "dropphyadd": "7314 MAIN ST",
    "dropphycty": "OWENDALE",
    "dropphyst": "MI",
    "dropphyzpp": 487545129,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OWENDALE",
    "dropmalst": "MI",
    "dropmalzpp": 487549998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896784238,
    "dropsitcph": 9896784238,
    "dropfax": 9896780018
  },
  {
    "dcode": "D",
    "dropkey": "PY12539",
    "droptype": "D",
    "dropname": "OWOSSO",
    "dropdeladd": "319 N WASHINGTON ST",
    "dropdelcty": "OWOSSO",
    "dropdelst": "MI",
    "dropdelzpp": 488672800,
    "dropphyadd": "319 N WASHINGTON ST",
    "dropphycty": "OWOSSO",
    "dropphyst": "MI",
    "dropphyzpp": 488672800,
    "dropmaladd": "319 N WASHINGTON ST",
    "dropmalcty": "OWOSSO",
    "dropmalst": "MI",
    "dropmalzpp": 488672800,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897232929,
    "dropsitcph": 9897232929,
    "dropfax": 9897232383
  },
  {
    "dcode": "D",
    "dropkey": "PY12540",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "52 E BURDICK ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "MI",
    "dropdelzpp": 483719998,
    "dropphyadd": "52 E BURDICK ST",
    "dropphycty": "OXFORD",
    "dropphyst": "MI",
    "dropphyzpp": 483719998,
    "dropmaladd": "52 E BURDICK ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "MI",
    "dropmalzpp": 483719998,
    "dropsitphn": 2486283943,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486283943,
    "dropfax": 2486281926
  },
  {
    "dcode": "D",
    "dropkey": "PY12541",
    "droptype": "D",
    "dropname": "PAINESDALE",
    "dropdeladd": "43012 GOODELL AVE",
    "dropdelcty": "PAINESDALE",
    "dropdelst": "MI",
    "dropdelzpp": 499559800,
    "dropphyadd": "43012 GOODELL AVE",
    "dropphycty": "PAINESDALE",
    "dropphyst": "MI",
    "dropphyzpp": 499559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAINESDALE",
    "dropmalst": "MI",
    "dropmalzpp": 499559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064824742,
    "dropsitcph": 9064824742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12542",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "100 NICHOLAS AVE",
    "dropdelcty": "PALMER",
    "dropdelst": "MI",
    "dropdelzpp": 498719800,
    "dropphyadd": "100 NICHOLAS AVE",
    "dropphycty": "PALMER",
    "dropphyst": "MI",
    "dropphyzpp": 498719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMER",
    "dropmalst": "MI",
    "dropmalzpp": 498719998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064757386,
    "dropsitcph": 9064757386,
    "dropfax": 9064757386
  },
  {
    "dcode": "D",
    "dropkey": "PY12544",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "6380 PALMYRA RD",
    "dropdelcty": "PALMYRA",
    "dropdelst": "MI",
    "dropdelzpp": 492689998,
    "dropphyadd": "6380 PALMYRA RD",
    "dropphycty": "PALMYRA",
    "dropphyst": "MI",
    "dropphyzpp": 492689998,
    "dropmaladd": "6380 PALMYRA RD",
    "dropmalcty": "PALMYRA",
    "dropmalst": "MI",
    "dropmalzpp": 492689998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172631851,
    "dropfax": 5172661424
  },
  {
    "dcode": "D",
    "dropkey": "PY12546",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "8196 N M 123",
    "dropdelcty": "PARADISE",
    "dropdelst": "MI",
    "dropdelzpp": 497689802,
    "dropphyadd": "8196 N M 123",
    "dropphycty": "PARADISE",
    "dropphyst": "MI",
    "dropphyzpp": 497689802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARADISE",
    "dropmalst": "MI",
    "dropmalzpp": 497689998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9472081856,
    "dropsitcph": 9472081838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12548",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "21159 NORTHLAND DR",
    "dropdelcty": "PARIS",
    "dropdelst": "MI",
    "dropdelzpp": 493389475,
    "dropphyadd": "21159 NORTHLAND DR",
    "dropphycty": "PARIS",
    "dropphyst": "MI",
    "dropphyzpp": 493389475,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARIS",
    "dropmalst": "MI",
    "dropmalzpp": 493389998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317965264,
    "dropsitcph": 2317965264,
    "dropfax": 6167964908
  },
  {
    "dcode": "D",
    "dropkey": "PY12551",
    "droptype": "D",
    "dropname": "PARMA",
    "dropdeladd": "111 E MAIN ST",
    "dropdelcty": "PARMA",
    "dropdelst": "MI",
    "dropdelzpp": 492699998,
    "dropphyadd": "111 E MAIN ST",
    "dropphycty": "PARMA",
    "dropphyst": "MI",
    "dropphyzpp": 492699998,
    "dropmaladd": "111 E MAIN ST",
    "dropmalcty": "PARMA",
    "dropmalst": "MI",
    "dropmalzpp": 492699998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175314242,
    "dropfax": 5175313594
  },
  {
    "dcode": "D",
    "dropkey": "PY12554",
    "droptype": "D",
    "dropname": "PAW PAW",
    "dropdeladd": "125 N KALAMAZOO ST",
    "dropdelcty": "PAW PAW",
    "dropdelst": "MI",
    "dropdelzpp": 490799998,
    "dropphyadd": "125 N KALAMAZOO ST",
    "dropphycty": "PAW PAW",
    "dropphyst": "MI",
    "dropphyzpp": 490799998,
    "dropmaladd": "125 N KALAMAZOO ST",
    "dropmalcty": "PAW PAW",
    "dropmalst": "MI",
    "dropmalzpp": 490799998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696576668,
    "dropsitcph": 2696576668,
    "dropfax": 2696576353
  },
  {
    "dcode": "D",
    "dropkey": "PY12556",
    "droptype": "D",
    "dropname": "PECK",
    "dropdeladd": "46 E LAPEER ST",
    "dropdelcty": "PECK",
    "dropdelst": "MI",
    "dropdelzpp": 484669998,
    "dropphyadd": "46 E LAPEER ST",
    "dropphycty": "PECK",
    "dropphyst": "MI",
    "dropphyzpp": 484669998,
    "dropmaladd": "46 E LAPEER ST",
    "dropmalcty": "PECK",
    "dropmalst": "MI",
    "dropmalzpp": 484669998,
    "dropsitphn": 8103785318,
    "dropsitlph": 8102571580,
    "dropsitcph": 8103785318,
    "dropfax": 8103786038
  },
  {
    "dcode": "D",
    "dropkey": "PY12557",
    "droptype": "D",
    "dropname": "PELKIE",
    "dropdeladd": "15370 PELKIE RD",
    "dropdelcty": "PELKIE",
    "dropdelst": "MI",
    "dropdelzpp": 499589800,
    "dropphyadd": "15370 PELKIE RD",
    "dropphycty": "PELKIE",
    "dropphyst": "MI",
    "dropphyzpp": 499589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PELKIE",
    "dropmalst": "MI",
    "dropmalzpp": 499589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063537592,
    "dropsitcph": 9063537592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12558",
    "droptype": "D",
    "dropname": "PELLSTON",
    "dropdeladd": "146 STIMPSON DR",
    "dropdelcty": "PELLSTON",
    "dropdelst": "MI",
    "dropdelzpp": 497699800,
    "dropphyadd": "146 STIMPSON DR",
    "dropphycty": "PELLSTON",
    "dropphyst": "MI",
    "dropphyzpp": 497699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PELLSTON",
    "dropmalst": "MI",
    "dropmalzpp": 497699998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315398431,
    "dropsitcph": 2315398431,
    "dropfax": 2315398431
  },
  {
    "dcode": "D",
    "dropkey": "PY12560",
    "droptype": "D",
    "dropname": "PENTWATER",
    "dropdeladd": "91 S HANCOCK ST",
    "dropdelcty": "PENTWATER",
    "dropdelst": "MI",
    "dropdelzpp": 494498900,
    "dropphyadd": "91 S HANCOCK ST",
    "dropphycty": "PENTWATER",
    "dropphyst": "MI",
    "dropphyzpp": 494498900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENTWATER",
    "dropmalst": "MI",
    "dropmalzpp": 494499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318698871,
    "dropsitcph": 2318698871,
    "dropfax": 2318694649
  },
  {
    "dcode": "D",
    "dropkey": "PY12561",
    "droptype": "D",
    "dropname": "PERKINS",
    "dropdeladd": "11892 STATE HIGHWAY M35",
    "dropdelcty": "PERKINS",
    "dropdelst": "MI",
    "dropdelzpp": 498729800,
    "dropphyadd": "11892 STATE HIGHWAY M35",
    "dropphycty": "PERKINS",
    "dropphyst": "MI",
    "dropphyzpp": 498729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERKINS",
    "dropmalst": "MI",
    "dropmalzpp": 498729998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063594465,
    "dropsitcph": 9063594465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12562",
    "droptype": "D",
    "dropname": "PERRINTON",
    "dropdeladd": "128 S ROBINSON ST",
    "dropdelcty": "PERRINTON",
    "dropdelst": "MI",
    "dropdelzpp": 488719637,
    "dropphyadd": "128 S ROBINSON ST",
    "dropphycty": "PERRINTON",
    "dropphyst": "MI",
    "dropphyzpp": 488719637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERRINTON",
    "dropmalst": "MI",
    "dropmalzpp": 488719998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892367354,
    "dropsitcph": 9892367354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12563",
    "droptype": "D",
    "dropname": "PERRONVILLE",
    "dropdeladd": "W625 STATE HIGHWAY M69",
    "dropdelcty": "PERRONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 498739111,
    "dropphyadd": "W625 STATE HIGHWAY M69",
    "dropphycty": "PERRONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 498739111,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERRONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 498739998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064662795,
    "dropsitcph": 9064662795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12564",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "200 N MAIN",
    "dropdelcty": "PERRY",
    "dropdelst": "MI",
    "dropdelzpp": 488729700,
    "dropphyadd": "200 N MAIN",
    "dropphycty": "PERRY",
    "dropphyst": "MI",
    "dropphyzpp": 488729700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERRY",
    "dropmalst": "MI",
    "dropmalzpp": 488729998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176256229,
    "dropsitcph": 5176256229,
    "dropfax": 5176255350
  },
  {
    "dcode": "D",
    "dropkey": "PY12565",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "55 PAHL MALL RD",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 492709998,
    "dropphyadd": "55 PAHL MALL RD",
    "dropphycty": "PETERSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 492709998,
    "dropmaladd": "55 PAHL MALL RD",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 492709998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 7343710125,
    "dropfax": 7342795056
  },
  {
    "dcode": "D",
    "dropkey": "PY12566",
    "droptype": "D",
    "dropname": "PETOSKEY",
    "dropdeladd": "318 STATE ST",
    "dropdelcty": "PETOSKEY",
    "dropdelst": "MI",
    "dropdelzpp": 497709998,
    "dropphyadd": "318 STATE ST",
    "dropphycty": "PETOSKEY",
    "dropphyst": "MI",
    "dropphyzpp": 497709998,
    "dropmaladd": "318 STATE ST",
    "dropmalcty": "PETOSKEY",
    "dropmalst": "MI",
    "dropmalzpp": 497709998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313472671,
    "dropsitcph": 2313472671,
    "dropfax": 2313473522
  },
  {
    "dcode": "D",
    "dropkey": "PY12567",
    "droptype": "D",
    "dropname": "PEWAMO",
    "dropdeladd": "154 E MAIN ST",
    "dropdelcty": "PEWAMO",
    "dropdelst": "MI",
    "dropdelzpp": 488735102,
    "dropphyadd": "154 E MAIN ST",
    "dropphycty": "PEWAMO",
    "dropphyst": "MI",
    "dropphyzpp": 488735102,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEWAMO",
    "dropmalst": "MI",
    "dropmalzpp": 488739998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895933525,
    "dropsitcph": 9895933525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12569",
    "droptype": "D",
    "dropname": "PICKFORD",
    "dropdeladd": "160 E MAIN ST",
    "dropdelcty": "PICKFORD",
    "dropdelst": "MI",
    "dropdelzpp": 497748935,
    "dropphyadd": "160 E MAIN ST",
    "dropphycty": "PICKFORD",
    "dropphyst": "MI",
    "dropphyzpp": 497748935,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PICKFORD",
    "dropmalst": "MI",
    "dropmalzpp": 497749998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066475845,
    "dropsitcph": 9063491257,
    "dropfax": 9066478542
  },
  {
    "dcode": "D",
    "dropkey": "PY12570",
    "droptype": "D",
    "dropname": "PIERSON",
    "dropdeladd": "7 S 4TH ST",
    "dropdelcty": "PIERSON",
    "dropdelst": "MI",
    "dropdelzpp": 493399800,
    "dropphyadd": "7 S 4TH ST",
    "dropphycty": "PIERSON",
    "dropphyst": "MI",
    "dropphyzpp": 493399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERSON",
    "dropmalst": "MI",
    "dropmalzpp": 493399998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166365691,
    "dropsitcph": 6166365691,
    "dropfax": 6166365290
  },
  {
    "dcode": "D",
    "dropkey": "PY12571",
    "droptype": "D",
    "dropname": "PIGEON",
    "dropdeladd": "7181 E MICHIGAN AVE",
    "dropdelcty": "PIGEON",
    "dropdelst": "MI",
    "dropdelzpp": 487555155,
    "dropphyadd": "7181 E MICHIGAN AVE",
    "dropphycty": "PIGEON",
    "dropphyst": "MI",
    "dropphyzpp": 487555155,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIGEON",
    "dropmalst": "MI",
    "dropmalzpp": 487559998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894533392,
    "dropsitcph": 9894533392,
    "dropfax": 9894532726
  },
  {
    "dcode": "D",
    "dropkey": "PY12572",
    "droptype": "D",
    "dropname": "PINCKNEY",
    "dropdeladd": "1325 E M 36",
    "dropdelcty": "PINCKNEY",
    "dropdelst": "MI",
    "dropdelzpp": 481699998,
    "dropphyadd": "1325 E M 36",
    "dropphycty": "PINCKNEY",
    "dropphyst": "MI",
    "dropphyzpp": 481699998,
    "dropmaladd": "1325 E M 36",
    "dropmalcty": "PINCKNEY",
    "dropmalst": "MI",
    "dropmalzpp": 481699998,
    "dropsitphn": 7348783491,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348783491,
    "dropfax": 7349709024
  },
  {
    "dcode": "D",
    "dropkey": "PY12573",
    "droptype": "D",
    "dropname": "PINCONNING",
    "dropdeladd": "207 S KAISER ST",
    "dropdelcty": "PINCONNING",
    "dropdelst": "MI",
    "dropdelzpp": 486507533,
    "dropphyadd": "207 S KAISER ST",
    "dropphycty": "PINCONNING",
    "dropphyst": "MI",
    "dropphyzpp": 486507533,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINCONNING",
    "dropmalst": "MI",
    "dropmalzpp": 486509998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898794971,
    "dropsitcph": 9898794971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12577",
    "droptype": "D",
    "dropname": "PITTSFORD",
    "dropdeladd": "4448 S PITTSFORD RD",
    "dropdelcty": "PITTSFORD",
    "dropdelst": "MI",
    "dropdelzpp": 492719998,
    "dropphyadd": "4448 S PITTSFORD RD",
    "dropphycty": "PITTSFORD",
    "dropphyst": "MI",
    "dropphyzpp": 492719998,
    "dropmaladd": "4448 S PITTSFORD RD",
    "dropmalcty": "PITTSFORD",
    "dropmalst": "MI",
    "dropmalzpp": 492719998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175234142,
    "dropfax": 5175233581
  },
  {
    "dcode": "D",
    "dropkey": "PY12579",
    "droptype": "D",
    "dropname": "PLAINWELL",
    "dropdeladd": "457 E BRIDGE ST",
    "dropdelcty": "PLAINWELL",
    "dropdelst": "MI",
    "dropdelzpp": 490809998,
    "dropphyadd": "457 E BRIDGE ST",
    "dropphycty": "PLAINWELL",
    "dropphyst": "MI",
    "dropphyzpp": 490809998,
    "dropmaladd": "457 E BRIDGE ST",
    "dropmalcty": "PLAINWELL",
    "dropmalst": "MI",
    "dropmalzpp": 490809998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696858661,
    "dropsitcph": 2696858661,
    "dropfax": 2696851068
  },
  {
    "dcode": "D",
    "dropkey": "PY12582",
    "droptype": "D",
    "dropname": "PLEASANT LAKE",
    "dropdeladd": "11586 BUNKERHILL RD",
    "dropdelcty": "PLEASANT LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 492729998,
    "dropphyadd": "11586 BUNKERHILL RD",
    "dropphycty": "PLEASANT LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 492729998,
    "dropmaladd": "11586 BUNKERHILL RD",
    "dropmalcty": "PLEASANT LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 492729998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5177696198,
    "dropfax": 5177692853
  },
  {
    "dcode": "D",
    "dropkey": "PY12584",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "47526 CLIPPER ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MI",
    "dropdelzpp": 481709998,
    "dropphyadd": "47526 CLIPPER ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MI",
    "dropphyzpp": 481709998,
    "dropmaladd": "47526 CLIPPER ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MI",
    "dropmalzpp": 481709998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7344534669,
    "dropsitcph": 7344534669,
    "dropfax": 7344537807
  },
  {
    "dcode": "D",
    "dropkey": "PY12588",
    "droptype": "D",
    "dropname": "POINTE AUX PINS",
    "dropdeladd": "469 SIOUX AVE",
    "dropdelcty": "POINTE AUX PINS",
    "dropdelst": "MI",
    "dropdelzpp": 497755000,
    "dropphyadd": "469 SIOUX AVE",
    "dropphycty": "POINTE AUX PINS",
    "dropphyst": "MI",
    "dropphyzpp": 497755000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINTE AUX PINS",
    "dropmalst": "MI",
    "dropmalzpp": 497759998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316347211,
    "dropsitcph": 2316347211,
    "dropfax": 2316347039
  },
  {
    "dcode": "D",
    "dropkey": "PY12590",
    "droptype": "D",
    "dropname": "POMPEII",
    "dropdeladd": "103 E FULTON ST",
    "dropdelcty": "POMPEII",
    "dropdelst": "MI",
    "dropdelzpp": 488749800,
    "dropphyadd": "103 E FULTON ST",
    "dropphycty": "POMPEII",
    "dropphyst": "MI",
    "dropphyzpp": 488749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POMPEII",
    "dropmalst": "MI",
    "dropmalzpp": 488749998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898382226,
    "dropsitcph": 9898382226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12592",
    "droptype": "D",
    "dropname": "PONTIAC",
    "dropdeladd": "735 W HURON ST",
    "dropdelcty": "PONTIAC",
    "dropdelst": "MI",
    "dropdelzpp": 483439998,
    "dropphyadd": "735 W HURON ST",
    "dropphycty": "PONTIAC",
    "dropphyst": "MI",
    "dropphyzpp": 483439998,
    "dropmaladd": "735 W HURON ST",
    "dropmalcty": "PONTIAC",
    "dropmalst": "MI",
    "dropmalzpp": 483439998,
    "dropsitphn": 2484542413,
    "dropsitlph": 2487585622,
    "dropsitcph": 2484542413,
    "dropfax": 2483384417
  },
  {
    "dcode": "D",
    "dropkey": "PY12594",
    "droptype": "D",
    "dropname": "PORT AUSTIN",
    "dropdeladd": "8710 NORTH ST",
    "dropdelcty": "PORT AUSTIN",
    "dropdelst": "MI",
    "dropdelzpp": 484679998,
    "dropphyadd": "8710 NORTH ST",
    "dropphycty": "PORT AUSTIN",
    "dropphyst": "MI",
    "dropphyzpp": 484679998,
    "dropmaladd": "8710 NORTH ST",
    "dropmalcty": "PORT AUSTIN",
    "dropmalst": "MI",
    "dropmalzpp": 484679998,
    "dropsitphn": 9897385264,
    "dropsitlph": 8102571580,
    "dropsitcph": 9897385264,
    "dropfax": 9897388614
  },
  {
    "dcode": "D",
    "dropkey": "PY12595",
    "droptype": "D",
    "dropname": "PORT HOPE",
    "dropdeladd": "4456 MAIN ST",
    "dropdelcty": "PORT HOPE",
    "dropdelst": "MI",
    "dropdelzpp": 484689998,
    "dropphyadd": "4456 MAIN ST",
    "dropphycty": "PORT HOPE",
    "dropphyst": "MI",
    "dropphyzpp": 484689998,
    "dropmaladd": "4456 MAIN ST",
    "dropmalcty": "PORT HOPE",
    "dropmalst": "MI",
    "dropmalzpp": 484689998,
    "dropsitphn": 9894284700,
    "dropsitlph": 2487585622,
    "dropsitcph": 9894284700,
    "dropfax": 9894285022
  },
  {
    "dcode": "D",
    "dropkey": "PY12596",
    "droptype": "D",
    "dropname": "PORT HURON",
    "dropdeladd": "852 32ND ST",
    "dropdelcty": "PORT HURON",
    "dropdelst": "MI",
    "dropdelzpp": 480619998,
    "dropphyadd": "852 32ND ST",
    "dropphycty": "PORT HURON",
    "dropphyst": "MI",
    "dropphyzpp": 480619998,
    "dropmaladd": "852 32ND ST",
    "dropmalcty": "PORT HURON",
    "dropmalst": "MI",
    "dropmalzpp": 480619998,
    "dropsitphn": 8109894820,
    "dropsitlph": 2487585622,
    "dropsitcph": 8109894830,
    "dropfax": 8109894810
  },
  {
    "dcode": "D",
    "dropkey": "PY12599",
    "droptype": "D",
    "dropname": "PORT SANILAC",
    "dropdeladd": "34 N RIDGE ST",
    "dropdelcty": "PORT SANILAC",
    "dropdelst": "MI",
    "dropdelzpp": 484699998,
    "dropphyadd": "34 N RIDGE ST",
    "dropphycty": "PORT SANILAC",
    "dropphyst": "MI",
    "dropphyzpp": 484699998,
    "dropmaladd": "34 N RIDGE ST",
    "dropmalcty": "PORT SANILAC",
    "dropmalst": "MI",
    "dropmalzpp": 484699998,
    "dropsitphn": 8106228295,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106228295,
    "dropfax": 8106220171
  },
  {
    "dcode": "D",
    "dropkey": "PY12602",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "1151 W MILHAM AVE",
    "dropdelcty": "PORTAGE",
    "dropdelst": "MI",
    "dropdelzpp": 490249998,
    "dropphyadd": "1151 W MILHAM AVE",
    "dropphycty": "PORTAGE",
    "dropphyst": "MI",
    "dropphyzpp": 490249998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTAGE",
    "dropmalst": "MI",
    "dropmalzpp": 490819998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693277441,
    "dropsitcph": 2693277441,
    "dropfax": 2693230140
  },
  {
    "dcode": "D",
    "dropkey": "PY12603",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "235 N LINCOLN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "MI",
    "dropdelzpp": 488759998,
    "dropphyadd": "235 N LINCOLN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "MI",
    "dropphyzpp": 488759998,
    "dropmaladd": "235 N LINCOLN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "MI",
    "dropmalzpp": 488759998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176476456,
    "dropsitcph": 5176476456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12604",
    "droptype": "D",
    "dropname": "POSEN",
    "dropdeladd": "10993 MICHIGAN AVE",
    "dropdelcty": "POSEN",
    "dropdelst": "MI",
    "dropdelzpp": 497769800,
    "dropphyadd": "10993 MICHIGAN AVE",
    "dropphycty": "POSEN",
    "dropphyst": "MI",
    "dropphyzpp": 497769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POSEN",
    "dropmalst": "MI",
    "dropmalzpp": 497769998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897668841,
    "dropsitcph": 9897668841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12606",
    "droptype": "D",
    "dropname": "POTTERVILLE",
    "dropdeladd": "319 N DUNBAR ST",
    "dropdelcty": "POTTERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488769800,
    "dropphyadd": "319 N DUNBAR ST",
    "dropphycty": "POTTERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTTERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488769998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176452257,
    "dropsitcph": 5176452257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12607",
    "droptype": "D",
    "dropname": "POWERS",
    "dropdeladd": "W3804 US HIGHWAY 2/41",
    "dropdelcty": "POWERS",
    "dropdelst": "MI",
    "dropdelzpp": 498749793,
    "dropphyadd": "W3804 US HIGHWAY 2/41",
    "dropphycty": "POWERS",
    "dropphyst": "MI",
    "dropphyzpp": 498749793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POWERS",
    "dropmalst": "MI",
    "dropmalzpp": 498749998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064975640,
    "dropsitcph": 9064975640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12609",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "105 N WASHINGTON ST",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "MI",
    "dropdelzpp": 487565117,
    "dropphyadd": "105 N WASHINGTON ST",
    "dropphycty": "PRESCOTT",
    "dropphyst": "MI",
    "dropphyzpp": 487565117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "MI",
    "dropmalzpp": 487569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898734243,
    "dropsitcph": 9898734243,
    "dropfax": 9898734764
  },
  {
    "dcode": "D",
    "dropkey": "PY12611",
    "droptype": "D",
    "dropname": "PRESQUE ISLE",
    "dropdeladd": "8133 E GRAND LAKE RD",
    "dropdelcty": "PRESQUE ISLE",
    "dropdelst": "MI",
    "dropdelzpp": 497778630,
    "dropphyadd": "8133 E GRAND LAKE RD",
    "dropphycty": "PRESQUE ISLE",
    "dropphyst": "MI",
    "dropphyzpp": 497778630,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESQUE ISLE",
    "dropmalst": "MI",
    "dropmalzpp": 497779998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895956660,
    "dropsitcph": 9895956660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12614",
    "droptype": "D",
    "dropname": "PRUDENVILLE",
    "dropdeladd": "899 W HOUGHTON LAKE DR",
    "dropdelcty": "PRUDENVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 486518463,
    "dropphyadd": "899 W HOUGHTON LAKE DR",
    "dropphycty": "PRUDENVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 486518463,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRUDENVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 486519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893665147,
    "dropsitcph": 9893665147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12619",
    "droptype": "D",
    "dropname": "PULLMAN",
    "dropdeladd": "887 56TH ST",
    "dropdelcty": "PULLMAN",
    "dropdelst": "MI",
    "dropdelzpp": 494509739,
    "dropphyadd": "887 56TH ST",
    "dropphycty": "PULLMAN",
    "dropphyst": "MI",
    "dropphyzpp": 494509739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULLMAN",
    "dropmalst": "MI",
    "dropmalzpp": 494509998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6162365553,
    "dropsitcph": 2692365553,
    "dropfax": 2692364023
  },
  {
    "dcode": "D",
    "dropkey": "PY12621",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "7 N MAIN ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MI",
    "dropdelzpp": 490829998,
    "dropphyadd": "7 N MAIN ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MI",
    "dropphyzpp": 490829998,
    "dropmaladd": "7 N MAIN ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "MI",
    "dropmalzpp": 490829998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176394186,
    "dropsitcph": 5176394186,
    "dropfax": 5176398110
  },
  {
    "dcode": "D",
    "dropkey": "PY12622",
    "droptype": "D",
    "dropname": "QUINNESEC",
    "dropdeladd": "1214 QUINNESEC ST",
    "dropdelcty": "QUINNESEC",
    "dropdelst": "MI",
    "dropdelzpp": 498769519,
    "dropphyadd": "1214 QUINNESEC ST",
    "dropphycty": "QUINNESEC",
    "dropphyst": "MI",
    "dropphyzpp": 498769519,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUINNESEC",
    "dropmalst": "MI",
    "dropmalzpp": 498769998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067749411,
    "dropsitcph": 9067749411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12628",
    "droptype": "D",
    "dropname": "RAMSAY",
    "dropdeladd": "17 MILL ST",
    "dropdelcty": "RAMSAY",
    "dropdelst": "MI",
    "dropdelzpp": 499599800,
    "dropphyadd": "17 MILL ST",
    "dropphycty": "RAMSAY",
    "dropphyst": "MI",
    "dropphyzpp": 499599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAMSAY",
    "dropmalst": "MI",
    "dropmalzpp": 499599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9066636035,
    "dropsitcph": 9066636035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12630",
    "droptype": "D",
    "dropname": "RAPID CITY",
    "dropdeladd": "8310 RAPID CITY RD NW",
    "dropdelcty": "RAPID CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496769804,
    "dropphyadd": "8310 RAPID CITY RD NW",
    "dropphycty": "RAPID CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496769804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAPID CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496769998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313316012,
    "dropsitcph": 2313316012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12633",
    "droptype": "D",
    "dropname": "RAPID RIVER",
    "dropdeladd": "10467 S MAIN ST",
    "dropdelcty": "RAPID RIVER",
    "dropdelst": "MI",
    "dropdelzpp": 498789334,
    "dropphyadd": "10467 S MAIN ST",
    "dropphycty": "RAPID RIVER",
    "dropphyst": "MI",
    "dropphyzpp": 498789334,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAPID RIVER",
    "dropmalst": "MI",
    "dropmalzpp": 498789998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064746318,
    "dropsitcph": 9064746318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12634",
    "droptype": "D",
    "dropname": "RAVENNA",
    "dropdeladd": "12521 CROCKERY CREEK DR",
    "dropdelcty": "RAVENNA",
    "dropdelst": "MI",
    "dropdelzpp": 494515100,
    "dropphyadd": "12521 CROCKERY CREEK DR",
    "dropphycty": "RAVENNA",
    "dropphyst": "MI",
    "dropphyzpp": 494515100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAVENNA",
    "dropmalst": "MI",
    "dropmalzpp": 494519998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318532336,
    "dropsitcph": 2318532336,
    "dropfax": 2318535636
  },
  {
    "dcode": "D",
    "dropkey": "PY12640",
    "droptype": "D",
    "dropname": "READING",
    "dropdeladd": "111 MICHIGAN ST",
    "dropdelcty": "READING",
    "dropdelst": "MI",
    "dropdelzpp": 492749998,
    "dropphyadd": "111 MICHIGAN ST",
    "dropphycty": "READING",
    "dropphyst": "MI",
    "dropphyzpp": 492749998,
    "dropmaladd": "111 MICHIGAN ST",
    "dropmalcty": "READING",
    "dropmalst": "MI",
    "dropmalzpp": 492749998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172831909,
    "dropfax": 5172832214
  },
  {
    "dcode": "D",
    "dropkey": "PY12644",
    "droptype": "D",
    "dropname": "REED CITY",
    "dropdeladd": "232 W UPTON AVE",
    "dropdelcty": "REED CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496779998,
    "dropphyadd": "232 W UPTON AVE",
    "dropphycty": "REED CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496779998,
    "dropmaladd": "232 W UPTON AVE",
    "dropmalcty": "REED CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496779998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318324244,
    "dropsitcph": 2318324244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12648",
    "droptype": "D",
    "dropname": "REESE",
    "dropdeladd": "2077 GATES ST",
    "dropdelcty": "REESE",
    "dropdelst": "MI",
    "dropdelzpp": 487579580,
    "dropphyadd": "2077 GATES ST",
    "dropphycty": "REESE",
    "dropphyst": "MI",
    "dropphyzpp": 487579580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REESE",
    "dropmalst": "MI",
    "dropmalzpp": 487579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898684947,
    "dropsitcph": 9898684947,
    "dropfax": 9898683593
  },
  {
    "dcode": "D",
    "dropkey": "PY12649",
    "droptype": "D",
    "dropname": "REMUS",
    "dropdeladd": "302 W WHEATLAND AVE",
    "dropdelcty": "REMUS",
    "dropdelst": "MI",
    "dropdelzpp": 493409797,
    "dropphyadd": "302 W WHEATLAND AVE",
    "dropphycty": "REMUS",
    "dropphyst": "MI",
    "dropphyzpp": 493409797,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMUS",
    "dropmalst": "MI",
    "dropmalzpp": 493409998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9899673332,
    "dropsitcph": 9899673332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12652",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "415 2ND ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "MI",
    "dropdelzpp": 498799400,
    "dropphyadd": "415 2ND ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "MI",
    "dropphyzpp": 498799400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "MI",
    "dropmalzpp": 498799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063768267,
    "dropsitcph": 9063768267,
    "dropfax": 9063762610
  },
  {
    "dcode": "D",
    "dropkey": "PY12653",
    "droptype": "D",
    "dropname": "RHODES",
    "dropdeladd": "2832 RHODES RD",
    "dropdelcty": "RHODES",
    "dropdelst": "MI",
    "dropdelzpp": 486529740,
    "dropphyadd": "2832 RHODES RD",
    "dropphycty": "RHODES",
    "dropphyst": "MI",
    "dropphyzpp": 486529740,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RHODES",
    "dropmalst": "MI",
    "dropmalzpp": 486529998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898794446,
    "dropsitcph": 9898794446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12654",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "8480 N 32ND ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "MI",
    "dropdelzpp": 490839811,
    "dropphyadd": "8480 N 32ND ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "MI",
    "dropphyzpp": 490839811,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHLAND",
    "dropmalst": "MI",
    "dropmalzpp": 490839998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696294928,
    "dropsitcph": 2696294928,
    "dropfax": 2696293115
  },
  {
    "dcode": "D",
    "dropkey": "PY12656",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "36511 DIVISION RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "MI",
    "dropdelzpp": 480629998,
    "dropphyadd": "36511 DIVISION RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "MI",
    "dropphyzpp": 480629998,
    "dropmaladd": "36511 DIVISION RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "MI",
    "dropmalzpp": 480629998,
    "dropsitphn": 5867274435,
    "dropsitlph": 2487585622,
    "dropsitcph": 5867270697,
    "dropfax": 5867279570
  },
  {
    "dcode": "D",
    "dropkey": "PY12659",
    "droptype": "D",
    "dropname": "RICHVILLE",
    "dropdeladd": "9400 W SAGINAW RD",
    "dropdelcty": "RICHVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487589800,
    "dropphyadd": "9400 W SAGINAW RD",
    "dropphycty": "RICHVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487589998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898684954,
    "dropsitcph": 9898684954,
    "dropfax": 9898684954
  },
  {
    "dcode": "D",
    "dropkey": "PY12661",
    "droptype": "D",
    "dropname": "RIGA",
    "dropdeladd": "7512 RIGA HWY",
    "dropdelcty": "RIGA",
    "dropdelst": "MI",
    "dropdelzpp": 492769998,
    "dropphyadd": "7512 RIGA HWY",
    "dropphycty": "RIGA",
    "dropphyst": "MI",
    "dropphyzpp": 492769998,
    "dropmaladd": "7512 RIGA HWY",
    "dropmalcty": "RIGA",
    "dropmalst": "MI",
    "dropmalzpp": 492769998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174864968,
    "dropfax": 5174862695
  },
  {
    "dcode": "D",
    "dropkey": "PY12667",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "6728 N LUMBERJACK RD",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "MI",
    "dropdelzpp": 488779700,
    "dropphyadd": "6728 N LUMBERJACK RD",
    "dropphycty": "RIVERDALE",
    "dropphyst": "MI",
    "dropphyzpp": 488779700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "MI",
    "dropmalzpp": 488779998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898337988,
    "dropsitcph": 9898337988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12668",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "3889 RIVERSIDE RD",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "MI",
    "dropdelzpp": 490849800,
    "dropphyadd": "3889 RIVERSIDE RD",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "MI",
    "dropphyzpp": 490849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "MI",
    "dropmalzpp": 490849998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168491211,
    "dropsitcph": 6168491211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12670",
    "droptype": "D",
    "dropname": "RIVES JUNCTION",
    "dropdeladd": "3955 RIVES EATON RD",
    "dropdelcty": "RIVES JUNCTION",
    "dropdelst": "MI",
    "dropdelzpp": 492779998,
    "dropphyadd": "3955 RIVES EATON RD",
    "dropphycty": "RIVES JUNCTION",
    "dropphyst": "MI",
    "dropphyzpp": 492779998,
    "dropmaladd": "3955 RIVES EATON RD",
    "dropmalcty": "RIVES JUNCTION",
    "dropmalst": "MI",
    "dropmalzpp": 492779998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5175692478,
    "dropfax": 5175693776
  },
  {
    "dcode": "D",
    "dropkey": "PY12671",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "511 OLDE TOWNE RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MI",
    "dropdelzpp": 483089998,
    "dropphyadd": "511 OLDE TOWNE RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MI",
    "dropphyzpp": 483089998,
    "dropmaladd": "511 OLDE TOWNE RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MI",
    "dropmalzpp": 483089998,
    "dropsitphn": 2486011011,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486011011,
    "dropfax": 2486517420
  },
  {
    "dcode": "D",
    "dropkey": "PY12673",
    "droptype": "D",
    "dropname": "ROCK",
    "dropdeladd": "3980 W MAPLE RIDGE 37TH RD",
    "dropdelcty": "ROCK",
    "dropdelst": "MI",
    "dropdelzpp": 498809474,
    "dropphyadd": "3980 W MAPLE RIDGE 37TH RD",
    "dropphycty": "ROCK",
    "dropphyst": "MI",
    "dropphyzpp": 498809474,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK",
    "dropmalst": "MI",
    "dropmalzpp": 498809998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063566317,
    "dropsitcph": 9063566317,
    "dropfax": 9063569041
  },
  {
    "dcode": "D",
    "dropkey": "PY12674",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "57 COURTLAND ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "MI",
    "dropdelzpp": 493419998,
    "dropphyadd": "57 COURTLAND ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "MI",
    "dropphyzpp": 493419998,
    "dropmaladd": "57 COURTLAND ST",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "MI",
    "dropmalzpp": 493419998,
    "dropsitphn": 6168660789,
    "dropsitlph": 6168660789,
    "dropsitcph": 6168660789,
    "dropfax": 6168660790
  },
  {
    "dcode": "D",
    "dropkey": "PY12675",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "86 NATIONAL AVE",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "MI",
    "dropdelzpp": 499609800,
    "dropphyadd": "86 NATIONAL AVE",
    "dropphycty": "ROCKLAND",
    "dropphyst": "MI",
    "dropphyzpp": 499609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "MI",
    "dropmalzpp": 499609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068862972,
    "dropsitcph": 9068862972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12676",
    "droptype": "D",
    "dropname": "ROCKWOOD",
    "dropdeladd": "22181 HURON RIVER DR",
    "dropdelcty": "ROCKWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 481739998,
    "dropphyadd": "22181 HURON RIVER DR",
    "dropphycty": "ROCKWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 481739998,
    "dropmaladd": "22181 HURON RIVER DR",
    "dropmalcty": "ROCKWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 481739998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7343795725,
    "dropfax": 7343791301
  },
  {
    "dcode": "D",
    "dropkey": "PY12677",
    "droptype": "D",
    "dropname": "RODNEY",
    "dropdeladd": "12190 MCKINLEY RD",
    "dropdelcty": "RODNEY",
    "dropdelst": "MI",
    "dropdelzpp": 493429516,
    "dropphyadd": "12190 MCKINLEY RD",
    "dropphycty": "RODNEY",
    "dropphyst": "MI",
    "dropphyzpp": 493429516,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RODNEY",
    "dropmalst": "MI",
    "dropmalzpp": 493429998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319727708,
    "dropsitcph": 2319727708,
    "dropfax": 2319720255
  },
  {
    "dcode": "D",
    "dropkey": "PY12678",
    "droptype": "D",
    "dropname": "ROGERS CITY",
    "dropdeladd": "188 N THIRD ST",
    "dropdelcty": "ROGERS CITY",
    "dropdelst": "MI",
    "dropdelzpp": 497799998,
    "dropphyadd": "188 N THIRD ST",
    "dropphycty": "ROGERS CITY",
    "dropphyst": "MI",
    "dropphyzpp": 497799998,
    "dropmaladd": "188 N THIRD ST",
    "dropmalcty": "ROGERS CITY",
    "dropmalst": "MI",
    "dropmalzpp": 497799998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897344123,
    "dropsitcph": 9897344123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12680",
    "droptype": "D",
    "dropname": "ROMEO",
    "dropdeladd": "119 CHURCH ST",
    "dropdelcty": "ROMEO",
    "dropdelst": "MI",
    "dropdelzpp": 480659998,
    "dropphyadd": "119 CHURCH ST",
    "dropphycty": "ROMEO",
    "dropphyst": "MI",
    "dropphyzpp": 480659998,
    "dropmaladd": "119 CHURCH ST",
    "dropmalcty": "ROMEO",
    "dropmalst": "MI",
    "dropmalzpp": 480659998,
    "dropsitphn": 5863364499,
    "dropsitlph": 2487585622,
    "dropsitcph": 5863364499,
    "dropfax": 5867522226
  },
  {
    "dcode": "D",
    "dropkey": "PY12682",
    "droptype": "D",
    "dropname": "ROMULUS",
    "dropdeladd": "11000 HUNT ST",
    "dropdelcty": "ROMULUS",
    "dropdelst": "MI",
    "dropdelzpp": 481749998,
    "dropphyadd": "11000 HUNT ST",
    "dropphycty": "ROMULUS",
    "dropphyst": "MI",
    "dropphyzpp": 481749998,
    "dropmaladd": "11000 HUNT ST",
    "dropmalcty": "ROMULUS",
    "dropmalst": "MI",
    "dropmalzpp": 481749998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7349413439,
    "dropsitcph": 7349413439,
    "dropfax": 7349410760
  },
  {
    "dcode": "D",
    "dropkey": "PY12687",
    "droptype": "D",
    "dropname": "ROSCOMMON",
    "dropdeladd": "281 LAKE ST",
    "dropdelcty": "ROSCOMMON",
    "dropdelst": "MI",
    "dropdelzpp": 486539203,
    "dropphyadd": "281 LAKE ST",
    "dropphycty": "ROSCOMMON",
    "dropphyst": "MI",
    "dropphyzpp": 486539203,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSCOMMON",
    "dropmalst": "MI",
    "dropmalzpp": 486539998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892755580,
    "dropsitcph": 9892755580,
    "dropfax": 9892755319
  },
  {
    "dcode": "D",
    "dropkey": "PY12691",
    "droptype": "D",
    "dropname": "ROSE CITY",
    "dropdeladd": "130 GEORGE SMITH JR ST",
    "dropdelcty": "ROSE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 486545001,
    "dropphyadd": "130 GEORGE SMITH JR ST",
    "dropphycty": "ROSE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 486545001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 486549998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5172652126,
    "dropsitcph": 9896852126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12692",
    "droptype": "D",
    "dropname": "ROSEBUSH",
    "dropdeladd": "3905 E ROSEBUSH RD",
    "dropdelcty": "ROSEBUSH",
    "dropdelst": "MI",
    "dropdelzpp": 488789800,
    "dropphyadd": "3905 E ROSEBUSH RD",
    "dropphycty": "ROSEBUSH",
    "dropphyst": "MI",
    "dropphyzpp": 488789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSEBUSH",
    "dropmalst": "MI",
    "dropmalzpp": 488789998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5174335662,
    "dropsitcph": 5174335662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12693",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "30550 GRATIOT AVE",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 480669998,
    "dropphyadd": "30550 GRATIOT AVE",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 480669998,
    "dropmaladd": "30550 GRATIOT AVE",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 480669998,
    "dropsitphn": 5862852025,
    "dropsitlph": 8427585622,
    "dropsitcph": 5862852022,
    "dropfax": 5862946412
  },
  {
    "dcode": "D",
    "dropkey": "PY12694",
    "droptype": "D",
    "dropname": "ROTHBURY",
    "dropdeladd": "2854 W WINSTON RD",
    "dropdelcty": "ROTHBURY",
    "dropdelst": "MI",
    "dropdelzpp": 494529721,
    "dropphyadd": "2854 W WINSTON RD",
    "dropphycty": "ROTHBURY",
    "dropphyst": "MI",
    "dropphyzpp": 494529721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROTHBURY",
    "dropmalst": "MI",
    "dropmalzpp": 494529998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318945714,
    "dropsitcph": 2318945714,
    "dropfax": 2318938321
  },
  {
    "dcode": "D",
    "dropkey": "PY12697",
    "droptype": "D",
    "dropname": "ROYAL OAK",
    "dropdeladd": "200 W 2ND ST",
    "dropdelcty": "ROYAL OAK",
    "dropdelst": "MI",
    "dropdelzpp": 480689998,
    "dropphyadd": "200 W 2ND ST",
    "dropphycty": "ROYAL OAK",
    "dropphyst": "MI",
    "dropphyzpp": 480689998,
    "dropmaladd": "200 W 2ND ST",
    "dropmalcty": "ROYAL OAK",
    "dropmalst": "MI",
    "dropmalzpp": 480689998,
    "dropsitphn": 2487403324,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485467112,
    "dropfax": 2485460706
  },
  {
    "dcode": "D",
    "dropkey": "PY12701",
    "droptype": "D",
    "dropname": "RUDYARD",
    "dropdeladd": "19018 S MACKINAC TRL",
    "dropdelcty": "RUDYARD",
    "dropdelst": "MI",
    "dropdelzpp": 497809533,
    "dropphyadd": "19018 S MACKINAC TRL",
    "dropphycty": "RUDYARD",
    "dropphyst": "MI",
    "dropphyzpp": 497809533,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUDYARD",
    "dropmalst": "MI",
    "dropmalzpp": 497809998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9064784611,
    "dropsitcph": 9064784611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12704",
    "droptype": "D",
    "dropname": "RUTH",
    "dropdeladd": "7031 E ATWATER RD",
    "dropdelcty": "RUTH",
    "dropdelst": "MI",
    "dropdelzpp": 484709998,
    "dropphyadd": "7031 E ATWATER RD",
    "dropphycty": "RUTH",
    "dropphyst": "MI",
    "dropphyzpp": 484709998,
    "dropmaladd": "7031 E ATWATER RD",
    "dropmalcty": "RUTH",
    "dropmalst": "MI",
    "dropmalzpp": 484709998,
    "dropsitphn": 9898645590,
    "dropsitlph": 8102571580,
    "dropsitcph": 9898645590,
    "dropfax": 9898643262
  },
  {
    "dcode": "D",
    "dropkey": "PY12714",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "1233 S WASHINGTON AVE",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486012517,
    "dropphyadd": "1233 S WASHINGTON AVE",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486012517,
    "dropmaladd": "PO BOX 59998",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486059998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897715718,
    "dropfax": 9897715715
  },
  {
    "dcode": "D",
    "dropkey": "PY12715",
    "droptype": "D",
    "dropname": "SAGOLA",
    "dropdeladd": "302 1ST ST",
    "dropdelcty": "SAGOLA",
    "dropdelst": "MI",
    "dropdelzpp": 498819738,
    "dropphyadd": "302 1ST ST",
    "dropphycty": "SAGOLA",
    "dropphyst": "MI",
    "dropphyzpp": 498819738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAGOLA",
    "dropmalst": "MI",
    "dropmalzpp": 498819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065423846,
    "dropsitcph": 9065423846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12716",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "202 S SAGINAW ST",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "MI",
    "dropdelzpp": 486551402,
    "dropphyadd": "202 S SAGINAW ST",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "MI",
    "dropphyzpp": 486551402,
    "dropmaladd": "202 S SAGINAW ST",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "MI",
    "dropmalzpp": 486551402,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898656531,
    "dropsitcph": 9898656531,
    "dropfax": 9898657950
  },
  {
    "dcode": "D",
    "dropkey": "PY12717",
    "droptype": "D",
    "dropname": "SAINT CLAIR",
    "dropdeladd": "202 TRUMBULL ST",
    "dropdelcty": "SAINT CLAIR",
    "dropdelst": "MI",
    "dropdelzpp": 480799998,
    "dropphyadd": "202 TRUMBULL ST",
    "dropphycty": "SAINT CLAIR",
    "dropphyst": "MI",
    "dropphyzpp": 480799998,
    "dropmaladd": "202 TRUMBULL ST",
    "dropmalcty": "SAINT CLAIR",
    "dropmalst": "MI",
    "dropmalzpp": 480799998,
    "dropsitphn": 8103294555,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103294555,
    "dropfax": 8103291050
  },
  {
    "dcode": "D",
    "dropkey": "PY12718",
    "droptype": "D",
    "dropname": "SAINT CLAIR SHORES",
    "dropdeladd": "23125 GREATER MACK AVE",
    "dropdelcty": "SAINT CLAIR SHORES",
    "dropdelst": "MI",
    "dropdelzpp": 480809998,
    "dropphyadd": "23125 GREATER MACK AVE",
    "dropphycty": "SAINT CLAIR SHORES",
    "dropphyst": "MI",
    "dropphyzpp": 480809998,
    "dropmaladd": "23125 GREATER MACK AVE",
    "dropmalcty": "SAINT CLAIR SHORES",
    "dropmalst": "MI",
    "dropmalzpp": 480809998,
    "dropsitphn": 5864982874,
    "dropsitlph": 2487585622,
    "dropsitcph": 5864982874,
    "dropfax": 5867752569
  },
  {
    "dcode": "D",
    "dropkey": "PY12722",
    "droptype": "D",
    "dropname": "SAINT HELEN",
    "dropdeladd": "2332 N SAINT HELEN RD",
    "dropdelcty": "SAINT HELEN",
    "dropdelst": "MI",
    "dropdelzpp": 486569691,
    "dropphyadd": "2332 N SAINT HELEN RD",
    "dropphycty": "SAINT HELEN",
    "dropphyst": "MI",
    "dropphyzpp": 486569691,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT HELEN",
    "dropmalst": "MI",
    "dropmalzpp": 486569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893894240,
    "dropsitcph": 9893894240,
    "dropfax": 9893891230
  },
  {
    "dcode": "D",
    "dropkey": "PY12723",
    "droptype": "D",
    "dropname": "SAINT IGNACE",
    "dropdeladd": "310 S STATE ST",
    "dropdelcty": "SAINT IGNACE",
    "dropdelst": "MI",
    "dropdelzpp": 497819998,
    "dropphyadd": "310 S STATE ST",
    "dropphycty": "SAINT IGNACE",
    "dropphyst": "MI",
    "dropphyzpp": 497819998,
    "dropmaladd": "310 S STATE ST",
    "dropmalcty": "SAINT IGNACE",
    "dropmalst": "MI",
    "dropmalzpp": 497819998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066439880,
    "dropsitcph": 9066439880,
    "dropfax": 9066438490
  },
  {
    "dcode": "D",
    "dropkey": "PY12726",
    "droptype": "D",
    "dropname": "SAINT JOHNS",
    "dropdeladd": "106 W STATE ST",
    "dropdelcty": "SAINT JOHNS",
    "dropdelst": "MI",
    "dropdelzpp": 488799998,
    "dropphyadd": "106 W STATE ST",
    "dropphycty": "SAINT JOHNS",
    "dropphyst": "MI",
    "dropphyzpp": 488799998,
    "dropmaladd": "106 W STATE ST",
    "dropmalcty": "SAINT JOHNS",
    "dropmalst": "MI",
    "dropmalzpp": 488799998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892249354,
    "dropsitcph": 9892249354,
    "dropfax": 9892270086
  },
  {
    "dcode": "D",
    "dropkey": "PY12727",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MI",
    "dropdelzpp": 490859998,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MI",
    "dropphyzpp": 490859998,
    "dropmaladd": "205 MAIN ST",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MI",
    "dropmalzpp": 490859998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699831579,
    "dropsitcph": 2699831579,
    "dropfax": 2699833528
  },
  {
    "dcode": "D",
    "dropkey": "PY12728",
    "droptype": "D",
    "dropname": "SAINT LOUIS",
    "dropdeladd": "217 W CENTER ST",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MI",
    "dropdelzpp": 488809998,
    "dropphyadd": "217 W CENTER ST",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MI",
    "dropphyzpp": 488809998,
    "dropmaladd": "217 W CENTER ST",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MI",
    "dropmalzpp": 488809998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896813131,
    "dropsitcph": 9896813131,
    "dropfax": 9896812643
  },
  {
    "dcode": "D",
    "dropkey": "PY12730",
    "droptype": "D",
    "dropname": "SALINE",
    "dropdeladd": "108 N MAPLE RD",
    "dropdelcty": "SALINE",
    "dropdelst": "MI",
    "dropdelzpp": 481769998,
    "dropphyadd": "108 N MAPLE RD",
    "dropphycty": "SALINE",
    "dropphyst": "MI",
    "dropphyzpp": 481769998,
    "dropmaladd": "108 N MAPLE RD",
    "dropmalcty": "SALINE",
    "dropmalst": "MI",
    "dropmalzpp": 481769998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7349445859,
    "dropsitcph": 7349445859,
    "dropfax": 7344290888
  },
  {
    "dcode": "D",
    "dropkey": "PY12733",
    "droptype": "D",
    "dropname": "SAMARIA",
    "dropdeladd": "1344 SAMARIA RD",
    "dropdelcty": "SAMARIA",
    "dropdelst": "MI",
    "dropdelzpp": 481779998,
    "dropphyadd": "1344 SAMARIA RD",
    "dropphycty": "SAMARIA",
    "dropphyst": "MI",
    "dropphyzpp": 481779998,
    "dropmaladd": "1344 SAMARIA RD",
    "dropmalcty": "SAMARIA",
    "dropmalst": "MI",
    "dropmalzpp": 481779998,
    "dropsitphn": 7348541200,
    "dropsitlph": 3132268554,
    "dropsitcph": 7348541200,
    "dropfax": 7348567105
  },
  {
    "dcode": "D",
    "dropkey": "PY12735",
    "droptype": "D",
    "dropname": "SAND CREEK",
    "dropdeladd": "6300 SAND CREEK HWY",
    "dropdelcty": "SAND CREEK",
    "dropdelst": "MI",
    "dropdelzpp": 492799998,
    "dropphyadd": "6300 SAND CREEK HWY",
    "dropphycty": "SAND CREEK",
    "dropphyst": "MI",
    "dropphyzpp": 492799998,
    "dropmaladd": "6300 SAND CREEK HWY",
    "dropmalcty": "SAND CREEK",
    "dropmalst": "MI",
    "dropmalzpp": 492799998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174363009,
    "dropfax": 5174363538
  },
  {
    "dcode": "D",
    "dropkey": "PY12736",
    "droptype": "D",
    "dropname": "SAND LAKE",
    "dropdeladd": "20 E MAPLE ST",
    "dropdelcty": "SAND LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 493439800,
    "dropphyadd": "20 E MAPLE ST",
    "dropphycty": "SAND LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 493439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAND LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 493439998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166365111,
    "dropsitcph": 6166365111,
    "dropfax": 6166364696
  },
  {
    "dcode": "D",
    "dropkey": "PY12738",
    "droptype": "D",
    "dropname": "SANDUSKY",
    "dropdeladd": "55 S MORSE ST",
    "dropdelcty": "SANDUSKY",
    "dropdelst": "MI",
    "dropdelzpp": 484719998,
    "dropphyadd": "55 S MORSE ST",
    "dropphycty": "SANDUSKY",
    "dropphyst": "MI",
    "dropphyzpp": 484719998,
    "dropmaladd": "55 S MORSE ST",
    "dropmalcty": "SANDUSKY",
    "dropmalst": "MI",
    "dropmalzpp": 484719998,
    "dropsitphn": 8106482362,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106482362,
    "dropfax": 8106482302
  },
  {
    "dcode": "D",
    "dropkey": "PY12739",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "239 W SAGINAW RD",
    "dropdelcty": "SANFORD",
    "dropdelst": "MI",
    "dropdelzpp": 486579801,
    "dropphyadd": "239 W SAGINAW RD",
    "dropphycty": "SANFORD",
    "dropphyst": "MI",
    "dropphyzpp": 486579801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANFORD",
    "dropmalst": "MI",
    "dropmalzpp": 486579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896872311,
    "dropsitcph": 9896872311,
    "dropfax": 9896875871
  },
  {
    "dcode": "D",
    "dropkey": "PY12741",
    "droptype": "D",
    "dropname": "SARANAC",
    "dropdeladd": "29 N BRIDGE ST",
    "dropdelcty": "SARANAC",
    "dropdelst": "MI",
    "dropdelzpp": 488819815,
    "dropphyadd": "29 N BRIDGE ST",
    "dropphycty": "SARANAC",
    "dropphyst": "MI",
    "dropphyzpp": 488819815,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARANAC",
    "dropmalst": "MI",
    "dropmalzpp": 488819998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6166429461,
    "dropsitcph": 6166429461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12742",
    "droptype": "D",
    "dropname": "SAUGATUCK",
    "dropdeladd": "434 BUTLER ST",
    "dropdelcty": "SAUGATUCK",
    "dropdelst": "MI",
    "dropdelzpp": 494539498,
    "dropphyadd": "434 BUTLER ST",
    "dropphycty": "SAUGATUCK",
    "dropphyst": "MI",
    "dropphyzpp": 494539498,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAUGATUCK",
    "dropmalst": "MI",
    "dropmalzpp": 494539998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2698572708,
    "dropsitcph": 2698572708,
    "dropfax": 2698575099
  },
  {
    "dcode": "D",
    "dropkey": "PY12743",
    "droptype": "D",
    "dropname": "SAULT SAINTE MARIE",
    "dropdeladd": "161 RIDGE ST",
    "dropdelcty": "SAULT SAINTE MARIE",
    "dropdelst": "MI",
    "dropdelzpp": 497839998,
    "dropphyadd": "161 RIDGE ST",
    "dropphycty": "SAULT SAINTE MARIE",
    "dropphyst": "MI",
    "dropphyzpp": 497839998,
    "dropmaladd": "161 RIDGE ST",
    "dropmalcty": "SAULT SAINTE MARIE",
    "dropmalst": "MI",
    "dropmalzpp": 497839998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9066329951,
    "dropsitcph": 9066329951,
    "dropfax": 9066328307
  },
  {
    "dcode": "D",
    "dropkey": "PY12746",
    "droptype": "D",
    "dropname": "SAWYER",
    "dropdeladd": "5835 SAWYER RD",
    "dropdelcty": "SAWYER",
    "dropdelst": "MI",
    "dropdelzpp": 491259380,
    "dropphyadd": "5835 SAWYER RD",
    "dropphycty": "SAWYER",
    "dropphyst": "MI",
    "dropphyzpp": 491259380,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAWYER",
    "dropmalst": "MI",
    "dropmalzpp": 491259998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694264333,
    "dropsitcph": 2694264333,
    "dropfax": 2694266071
  },
  {
    "dcode": "D",
    "dropkey": "PY12748",
    "droptype": "D",
    "dropname": "SCHOOLCRAFT",
    "dropdeladd": "217 HAYWARD ST",
    "dropdelcty": "SCHOOLCRAFT",
    "dropdelst": "MI",
    "dropdelzpp": 490879800,
    "dropphyadd": "217 HAYWARD ST",
    "dropphycty": "SCHOOLCRAFT",
    "dropphyst": "MI",
    "dropphyzpp": 490879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHOOLCRAFT",
    "dropmalst": "MI",
    "dropmalzpp": 490879998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696794114,
    "dropsitcph": 2696794114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12752",
    "droptype": "D",
    "dropname": "SCOTTS",
    "dropdeladd": "11030 NORSCOTT ST",
    "dropdelcty": "SCOTTS",
    "dropdelst": "MI",
    "dropdelzpp": 490889357,
    "dropphyadd": "11030 NORSCOTT ST",
    "dropphycty": "SCOTTS",
    "dropphyst": "MI",
    "dropphyzpp": 490889357,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCOTTS",
    "dropmalst": "MI",
    "dropmalzpp": 490889998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696268876,
    "dropsitcph": 2696268876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12753",
    "droptype": "D",
    "dropname": "SCOTTVILLE",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "SCOTTVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494549998,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "SCOTTVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494549998,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "SCOTTVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494549998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317572474,
    "dropsitcph": 2317572474,
    "dropfax": 2317574619
  },
  {
    "dcode": "D",
    "dropkey": "PY12755",
    "droptype": "D",
    "dropname": "SEARS",
    "dropdeladd": "5843 50TH AVE",
    "dropdelcty": "SEARS",
    "dropdelst": "MI",
    "dropdelzpp": 496799800,
    "dropphyadd": "5843 50TH AVE",
    "dropphycty": "SEARS",
    "dropphyst": "MI",
    "dropphyzpp": 496799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEARS",
    "dropmalst": "MI",
    "dropmalzpp": 496799998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317342183,
    "dropsitcph": 2317342183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12756",
    "droptype": "D",
    "dropname": "SEBEWAING",
    "dropdeladd": "49 N CENTER ST",
    "dropdelcty": "SEBEWAING",
    "dropdelst": "MI",
    "dropdelzpp": 487591420,
    "dropphyadd": "49 N CENTER ST",
    "dropphycty": "SEBEWAING",
    "dropphyst": "MI",
    "dropphyzpp": 487591420,
    "dropmaladd": "49 N CENTER ST",
    "dropmalcty": "SEBEWAING",
    "dropmalst": "MI",
    "dropmalzpp": 487591420,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898833550,
    "dropsitcph": 9898833550,
    "dropfax": 9898832633
  },
  {
    "dcode": "D",
    "dropkey": "PY12762",
    "droptype": "D",
    "dropname": "SENEY",
    "dropdeladd": "10790N GRAND ST",
    "dropdelcty": "SENEY",
    "dropdelst": "MI",
    "dropdelzpp": 498839800,
    "dropphyadd": "10790N GRAND ST",
    "dropphycty": "SENEY",
    "dropphyst": "MI",
    "dropphyzpp": 498839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENEY",
    "dropmalst": "MI",
    "dropmalzpp": 498839998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064993377,
    "dropsitcph": 9064993377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12765",
    "droptype": "D",
    "dropname": "SHAFTSBURG",
    "dropdeladd": "7090 W BEARD RD",
    "dropdelcty": "SHAFTSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 488829800,
    "dropphyadd": "7090 W BEARD RD",
    "dropphycty": "SHAFTSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 488829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAFTSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 488829998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176755194,
    "dropsitcph": 5176755194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12768",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "210 N MICHIGAN AVE",
    "dropdelcty": "SHELBY",
    "dropdelst": "MI",
    "dropdelzpp": 494559998,
    "dropphyadd": "210 N MICHIGAN AVE",
    "dropphycty": "SHELBY",
    "dropphyst": "MI",
    "dropphyzpp": 494559998,
    "dropmaladd": "210 N MICHIGAN AVE",
    "dropmalcty": "SHELBY",
    "dropmalst": "MI",
    "dropmalzpp": 494559998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318612356,
    "dropsitcph": 2318612356,
    "dropfax": 2698618486
  },
  {
    "dcode": "D",
    "dropkey": "PY12771",
    "droptype": "D",
    "dropname": "SHELBYVILLE",
    "dropdeladd": "90 124TH AVE",
    "dropdelcty": "SHELBYVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 493449765,
    "dropphyadd": "90 124TH AVE",
    "dropphycty": "SHELBYVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 493449765,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELBYVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 493449998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696727293,
    "dropsitcph": 2696727293,
    "dropfax": 2696722340
  },
  {
    "dcode": "D",
    "dropkey": "PY12774",
    "droptype": "D",
    "dropname": "SHEPHERD",
    "dropdeladd": "101 N 2ND ST",
    "dropdelcty": "SHEPHERD",
    "dropdelst": "MI",
    "dropdelzpp": 488832509,
    "dropphyadd": "101 N 2ND ST",
    "dropphycty": "SHEPHERD",
    "dropphyst": "MI",
    "dropphyzpp": 488832509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEPHERD",
    "dropmalst": "MI",
    "dropmalzpp": 488839998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898285581,
    "dropsitcph": 9898285581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12775",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "MI",
    "dropdelzpp": 488848376,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "MI",
    "dropphyzpp": 488848376,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "MI",
    "dropmalzpp": 488849998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892913363,
    "dropsitcph": 9892913363,
    "dropfax": 9892913363
  },
  {
    "dcode": "D",
    "dropkey": "PY12776",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "133 FULTON ST",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 490899800,
    "dropphyadd": "133 FULTON ST",
    "dropphycty": "SHERWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 490899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 490899998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5177417222,
    "dropsitcph": 5177417222,
    "dropfax": 5177417222
  },
  {
    "dcode": "D",
    "dropkey": "PY12777",
    "droptype": "D",
    "dropname": "SHINGLETON",
    "dropdeladd": "E12503 STATE HIGHWAY M28",
    "dropdelcty": "SHINGLETON",
    "dropdelst": "MI",
    "dropdelzpp": 498849657,
    "dropphyadd": "E12503 STATE HIGHWAY M28",
    "dropphycty": "SHINGLETON",
    "dropphyst": "MI",
    "dropphyzpp": 498849657,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHINGLETON",
    "dropmalst": "MI",
    "dropmalzpp": 498849998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064526371,
    "dropsitcph": 9064526371,
    "dropfax": 9064526087
  },
  {
    "dcode": "D",
    "dropkey": "PY12780",
    "droptype": "D",
    "dropname": "SIDNAW",
    "dropdeladd": "13640 E STATE HIGHWAY M28",
    "dropdelcty": "SIDNAW",
    "dropdelst": "MI",
    "dropdelzpp": 499619800,
    "dropphyadd": "13640 E STATE HIGHWAY M28",
    "dropphycty": "SIDNAW",
    "dropphyst": "MI",
    "dropphyzpp": 499619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIDNAW",
    "dropmalst": "MI",
    "dropmalzpp": 499619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063552527,
    "dropsitcph": 9063552527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12781",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "2960 W SIDNEY RD",
    "dropdelcty": "SIDNEY",
    "dropdelst": "MI",
    "dropdelzpp": 488859792,
    "dropphyadd": "2960 W SIDNEY RD",
    "dropphycty": "SIDNEY",
    "dropphyst": "MI",
    "dropphyzpp": 488859792,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIDNEY",
    "dropmalst": "MI",
    "dropmalzpp": 488859998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893286451,
    "dropsitcph": 9893286451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12783",
    "droptype": "D",
    "dropname": "SILVERWOOD",
    "dropdeladd": "2760 CLIFFORD RD",
    "dropdelcty": "SILVERWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 487609782,
    "dropphyadd": "2760 CLIFFORD RD",
    "dropphycty": "SILVERWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 487609782,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVERWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 487609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897617335,
    "dropsitcph": 9897617335,
    "dropfax": 9897617310
  },
  {
    "dcode": "D",
    "dropkey": "PY12785",
    "droptype": "D",
    "dropname": "SIX LAKES",
    "dropdeladd": "126 N CLARK ST",
    "dropdelcty": "SIX LAKES",
    "dropdelst": "MI",
    "dropdelzpp": 488869802,
    "dropphyadd": "126 N CLARK ST",
    "dropphycty": "SIX LAKES",
    "dropphyst": "MI",
    "dropphyzpp": 488869802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIX LAKES",
    "dropmalst": "MI",
    "dropmalzpp": 488869998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893653518,
    "dropsitcph": 9893653518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12786",
    "droptype": "D",
    "dropname": "SKANDIA",
    "dropdeladd": "224 KREIGER DR",
    "dropdelcty": "SKANDIA",
    "dropdelst": "MI",
    "dropdelzpp": 498859456,
    "dropphyadd": "224 KREIGER DR",
    "dropphycty": "SKANDIA",
    "dropphyst": "MI",
    "dropphyzpp": 498859456,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKANDIA",
    "dropmalst": "MI",
    "dropmalzpp": 498859998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9069427773,
    "dropsitcph": 9069427773,
    "dropfax": 9069427870
  },
  {
    "dcode": "D",
    "dropkey": "PY12787",
    "droptype": "D",
    "dropname": "SKANEE",
    "dropdeladd": "13120 TOWN RD",
    "dropdelcty": "SKANEE",
    "dropdelst": "MI",
    "dropdelzpp": 499629800,
    "dropphyadd": "13120 TOWN RD",
    "dropphycty": "SKANEE",
    "dropphyst": "MI",
    "dropphyzpp": 499629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKANEE",
    "dropmalst": "MI",
    "dropmalzpp": 499629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065246883,
    "dropsitcph": 9065246883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12790",
    "droptype": "D",
    "dropname": "SMITHS CREEK",
    "dropdeladd": "425 HENRY ST",
    "dropdelcty": "SMITHS CREEK",
    "dropdelst": "MI",
    "dropdelzpp": 480749998,
    "dropphyadd": "425 HENRY ST",
    "dropphycty": "SMITHS CREEK",
    "dropphyst": "MI",
    "dropphyzpp": 480749998,
    "dropmaladd": "425 HENRY ST",
    "dropmalcty": "SMITHS CREEK",
    "dropmalst": "MI",
    "dropmalzpp": 480749998,
    "dropsitphn": 8109897920,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103673840,
    "dropfax": 8103677027
  },
  {
    "dcode": "D",
    "dropkey": "PY12792",
    "droptype": "D",
    "dropname": "SNOVER",
    "dropdeladd": "1493 MAIN ST",
    "dropdelcty": "SNOVER",
    "dropdelst": "MI",
    "dropdelzpp": 484729998,
    "dropphyadd": "1493 MAIN ST",
    "dropphycty": "SNOVER",
    "dropphyst": "MI",
    "dropphyzpp": 484729998,
    "dropmaladd": "1493 MAIN ST",
    "dropmalcty": "SNOVER",
    "dropmalst": "MI",
    "dropmalzpp": 484729998,
    "dropsitphn": 8106729794,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106729794,
    "dropfax": 8106728167
  },
  {
    "dcode": "D",
    "dropkey": "PY12796",
    "droptype": "D",
    "dropname": "SODUS",
    "dropdeladd": "3568 NAOMI RD",
    "dropdelcty": "SODUS",
    "dropdelst": "MI",
    "dropdelzpp": 491269787,
    "dropphyadd": "3568 NAOMI RD",
    "dropphycty": "SODUS",
    "dropphyst": "MI",
    "dropphyzpp": 491269787,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SODUS",
    "dropmalst": "MI",
    "dropmalzpp": 491269998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2699266252,
    "dropsitcph": 2699266252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12799",
    "droptype": "D",
    "dropname": "SOMERSET CENTER",
    "dropdeladd": "12631 E CHICAGO RD",
    "dropdelcty": "SOMERSET CENTER",
    "dropdelst": "MI",
    "dropdelzpp": 492829998,
    "dropphyadd": "12631 E CHICAGO RD",
    "dropphycty": "SOMERSET CENTER",
    "dropphyst": "MI",
    "dropphyzpp": 492829998,
    "dropmaladd": "12631 E CHICAGO RD",
    "dropmalcty": "SOMERSET CENTER",
    "dropmalst": "MI",
    "dropmalzpp": 492829998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5176883448,
    "dropfax": 5176883002
  },
  {
    "dcode": "D",
    "dropkey": "PY12803",
    "droptype": "D",
    "dropname": "SOUTH BOARDMAN",
    "dropdeladd": "5408 BOARDMAN RD SW",
    "dropdelcty": "SOUTH BOARDMAN",
    "dropdelst": "MI",
    "dropdelzpp": 496808517,
    "dropphyadd": "5408 BOARDMAN RD SW",
    "dropphycty": "SOUTH BOARDMAN",
    "dropphyst": "MI",
    "dropphyzpp": 496808517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BOARDMAN",
    "dropmalst": "MI",
    "dropmalzpp": 496809998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313692809,
    "dropsitcph": 2313692809,
    "dropfax": 2313692809
  },
  {
    "dcode": "D",
    "dropkey": "PY12804",
    "droptype": "D",
    "dropname": "SOUTH BRANCH",
    "dropdeladd": "6495 HEATH RD",
    "dropdelcty": "SOUTH BRANCH",
    "dropdelst": "MI",
    "dropdelzpp": 487619800,
    "dropphyadd": "6495 HEATH RD",
    "dropphycty": "SOUTH BRANCH",
    "dropphyst": "MI",
    "dropphyzpp": 487619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BRANCH",
    "dropmalst": "MI",
    "dropmalzpp": 487619998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892573225,
    "dropsitcph": 9892573225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12805",
    "droptype": "D",
    "dropname": "SOUTH HAVEN",
    "dropdeladd": "336 BROADWAY ST",
    "dropdelcty": "SOUTH HAVEN",
    "dropdelst": "MI",
    "dropdelzpp": 490909998,
    "dropphyadd": "336 BROADWAY ST",
    "dropphycty": "SOUTH HAVEN",
    "dropphyst": "MI",
    "dropphyzpp": 490909998,
    "dropmaladd": "336 BROADWAY ST",
    "dropmalcty": "SOUTH HAVEN",
    "dropmalst": "MI",
    "dropmalzpp": 490909998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696371283,
    "dropsitcph": 2696371283,
    "dropfax": 6166391259
  },
  {
    "dcode": "D",
    "dropkey": "PY12806",
    "droptype": "D",
    "dropname": "SOUTH LYON",
    "dropdeladd": "111 S LAFAYETTE ST",
    "dropdelcty": "SOUTH LYON",
    "dropdelst": "MI",
    "dropdelzpp": 481789998,
    "dropphyadd": "111 S LAFAYETTE ST",
    "dropphycty": "SOUTH LYON",
    "dropphyst": "MI",
    "dropphyzpp": 481789998,
    "dropmaladd": "111 S LAFAYETTE ST",
    "dropmalcty": "SOUTH LYON",
    "dropmalst": "MI",
    "dropmalzpp": 481789998,
    "dropsitphn": 3132268558,
    "dropsitlph": 2484374501,
    "dropsitcph": 2484374501,
    "dropfax": 2484377789
  },
  {
    "dcode": "D",
    "dropkey": "PY12809",
    "droptype": "D",
    "dropname": "SOUTH RANGE",
    "dropdeladd": "5 BALTIC AVE",
    "dropdelcty": "SOUTH RANGE",
    "dropdelst": "MI",
    "dropdelzpp": 499639800,
    "dropphyadd": "5 BALTIC AVE",
    "dropphycty": "SOUTH RANGE",
    "dropphyst": "MI",
    "dropphyzpp": 499639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH RANGE",
    "dropmalst": "MI",
    "dropmalzpp": 499639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064828752,
    "dropsitcph": 9064828752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12810",
    "droptype": "D",
    "dropname": "SOUTH ROCKWOOD",
    "dropdeladd": "12730 DIXIE HWY",
    "dropdelcty": "SOUTH ROCKWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 481799998,
    "dropphyadd": "12730 DIXIE HWY",
    "dropphycty": "SOUTH ROCKWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 481799998,
    "dropmaladd": "12730 DIXIE HWY",
    "dropmalcty": "SOUTH ROCKWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 481799998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7343799011,
    "dropfax": 7343790210
  },
  {
    "dcode": "D",
    "dropkey": "PY12813",
    "droptype": "D",
    "dropname": "SOUTHFIELD",
    "dropdeladd": "22200 W 11 MILE RD",
    "dropdelcty": "SOUTHFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 480379998,
    "dropphyadd": "22200 W 11 MILE RD",
    "dropphycty": "SOUTHFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 480379998,
    "dropmaladd": "22200 W 11 MILE RD",
    "dropmalcty": "SOUTHFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 480379998,
    "dropsitphn": 2483682977,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483682977,
    "dropfax": 2483682955
  },
  {
    "dcode": "D",
    "dropkey": "PY12816",
    "droptype": "D",
    "dropname": "SPALDING",
    "dropdeladd": "N16118 CEDAR ST",
    "dropdelcty": "SPALDING",
    "dropdelst": "MI",
    "dropdelzpp": 498869747,
    "dropphyadd": "N16118 CEDAR ST",
    "dropphycty": "SPALDING",
    "dropphyst": "MI",
    "dropphyzpp": 498869747,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPALDING",
    "dropmalst": "MI",
    "dropmalzpp": 498869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064975522,
    "dropsitcph": 9064975522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12817",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "34 E DIVISION ST",
    "dropdelcty": "SPARTA",
    "dropdelst": "MI",
    "dropdelzpp": 493459998,
    "dropphyadd": "34 E DIVISION ST",
    "dropphycty": "SPARTA",
    "dropphyst": "MI",
    "dropphyzpp": 493459998,
    "dropmaladd": "34 E DIVISION ST",
    "dropmalcty": "SPARTA",
    "dropmalst": "MI",
    "dropmalzpp": 493459998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168877003,
    "dropsitcph": 6168877003,
    "dropfax": 6168879180
  },
  {
    "dcode": "D",
    "dropkey": "PY12819",
    "droptype": "D",
    "dropname": "SPRING ARBOR",
    "dropdeladd": "109 TEFT RD",
    "dropdelcty": "SPRING ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 492839998,
    "dropphyadd": "109 TEFT RD",
    "dropphycty": "SPRING ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 492839998,
    "dropmaladd": "109 TEFT RD",
    "dropmalcty": "SPRING ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 492839998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5179627336,
    "dropfax": 5177502192
  },
  {
    "dcode": "D",
    "dropkey": "PY12820",
    "droptype": "D",
    "dropname": "SPRING LAKE",
    "dropdeladd": "211 W EXCHANGE ST",
    "dropdelcty": "SPRING LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 494569998,
    "dropphyadd": "211 W EXCHANGE ST",
    "dropphycty": "SPRING LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 494569998,
    "dropmaladd": "211 W EXCHANGE ST",
    "dropmalcty": "SPRING LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 494569998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168420321,
    "dropsitcph": 6168420321,
    "dropfax": 6168423661
  },
  {
    "dcode": "D",
    "dropkey": "PY12824",
    "droptype": "D",
    "dropname": "SPRINGPORT",
    "dropdeladd": "118 MECHANIC ST",
    "dropdelcty": "SPRINGPORT",
    "dropdelst": "MI",
    "dropdelzpp": 492849998,
    "dropphyadd": "118 MECHANIC ST",
    "dropphycty": "SPRINGPORT",
    "dropphyst": "MI",
    "dropphyzpp": 492849998,
    "dropmaladd": "118 MECHANIC ST",
    "dropmalcty": "SPRINGPORT",
    "dropmalst": "MI",
    "dropmalzpp": 492849998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5178572897,
    "dropfax": 5178574255
  },
  {
    "dcode": "D",
    "dropkey": "PY12826",
    "droptype": "D",
    "dropname": "SPRUCE",
    "dropdeladd": "1495 E SPRUCE RD",
    "dropdelcty": "SPRUCE",
    "dropdelst": "MI",
    "dropdelzpp": 487629542,
    "dropphyadd": "1495 E SPRUCE RD",
    "dropphycty": "SPRUCE",
    "dropphyst": "MI",
    "dropphyzpp": 487629542,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRUCE",
    "dropmalst": "MI",
    "dropmalzpp": 487629998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9894712069,
    "dropsitcph": 9894712069,
    "dropfax": 9894712089
  },
  {
    "dcode": "D",
    "dropkey": "PY12926",
    "droptype": "D",
    "dropname": "STAMBAUGH",
    "dropdeladd": "201 WASHINGTON AVE",
    "dropdelcty": "STAMBAUGH",
    "dropdelst": "MI",
    "dropdelzpp": 499649800,
    "dropphyadd": "201 WASHINGTON AVE",
    "dropphycty": "STAMBAUGH",
    "dropphyst": "MI",
    "dropphyzpp": 499649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAMBAUGH",
    "dropmalst": "MI",
    "dropmalzpp": 499649998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062655013,
    "dropsitcph": 9062655013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12928",
    "droptype": "D",
    "dropname": "STANDISH",
    "dropdeladd": "120 S GROVE ST",
    "dropdelcty": "STANDISH",
    "dropdelst": "MI",
    "dropdelzpp": 486582511,
    "dropphyadd": "120 S GROVE ST",
    "dropphycty": "STANDISH",
    "dropphyst": "MI",
    "dropphyzpp": 486582511,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANDISH",
    "dropmalst": "MI",
    "dropmalzpp": 486589998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898466408,
    "dropsitcph": 9898466408,
    "dropfax": 9898461831
  },
  {
    "dcode": "D",
    "dropkey": "PY12929",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "363 N STATE ST",
    "dropdelcty": "STANTON",
    "dropdelst": "MI",
    "dropdelzpp": 488889345,
    "dropphyadd": "363 N STATE ST",
    "dropphycty": "STANTON",
    "dropphyst": "MI",
    "dropphyzpp": 488889345,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANTON",
    "dropmalst": "MI",
    "dropmalzpp": 488889998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898315361,
    "dropsitcph": 9898315361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12930",
    "droptype": "D",
    "dropname": "STANWOOD",
    "dropdeladd": "7551 NORTHLAND DR",
    "dropdelcty": "STANWOOD",
    "dropdelst": "MI",
    "dropdelzpp": 493468926,
    "dropphyadd": "7551 NORTHLAND DR",
    "dropphycty": "STANWOOD",
    "dropphyst": "MI",
    "dropphyzpp": 493468926,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANWOOD",
    "dropmalst": "MI",
    "dropmalzpp": 493469998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318232411,
    "dropsitcph": 2318232411,
    "dropfax": 2318232411
  },
  {
    "dcode": "D",
    "dropkey": "PY12934",
    "droptype": "D",
    "dropname": "STEPHENSON",
    "dropdeladd": "W520 SAMUEL ST",
    "dropdelcty": "STEPHENSON",
    "dropdelst": "MI",
    "dropdelzpp": 498878947,
    "dropphyadd": "W520 SAMUEL ST",
    "dropphycty": "STEPHENSON",
    "dropphyst": "MI",
    "dropphyzpp": 498878947,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEPHENSON",
    "dropmalst": "MI",
    "dropmalzpp": 498879998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067536919,
    "dropsitcph": 9067536919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12935",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "420 W STATE ST",
    "dropdelcty": "STERLING",
    "dropdelst": "MI",
    "dropdelzpp": 486592501,
    "dropphyadd": "420 W STATE ST",
    "dropphycty": "STERLING",
    "dropphyst": "MI",
    "dropphyzpp": 486592501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STERLING",
    "dropmalst": "MI",
    "dropmalzpp": 486599998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896543177,
    "dropsitcph": 9896543177,
    "dropfax": 9896543400
  },
  {
    "dcode": "D",
    "dropkey": "PY12939",
    "droptype": "D",
    "dropname": "STEVENSVILLE",
    "dropdeladd": "5888 CLEVELAND AVE",
    "dropdelcty": "STEVENSVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 491279998,
    "dropphyadd": "5888 CLEVELAND AVE",
    "dropphycty": "STEVENSVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 491279998,
    "dropmaladd": "5888 CLEVELAND AVE",
    "dropmalcty": "STEVENSVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 491279998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694293452,
    "dropsitcph": 2694293452,
    "dropfax": 2694293773
  },
  {
    "dcode": "D",
    "dropkey": "PY12942",
    "droptype": "D",
    "dropname": "STOCKBRIDGE",
    "dropdeladd": "117 N CLINTON ST",
    "dropdelcty": "STOCKBRIDGE",
    "dropdelst": "MI",
    "dropdelzpp": 492859998,
    "dropphyadd": "117 N CLINTON ST",
    "dropphycty": "STOCKBRIDGE",
    "dropphyst": "MI",
    "dropphyzpp": 492859998,
    "dropmaladd": "117 N CLINTON ST",
    "dropmalcty": "STOCKBRIDGE",
    "dropmalst": "MI",
    "dropmalzpp": 492859998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5178518509,
    "dropfax": 5178514628
  },
  {
    "dcode": "D",
    "dropkey": "PY12948",
    "droptype": "D",
    "dropname": "STURGIS",
    "dropdeladd": "124 E CHICAGO RD",
    "dropdelcty": "STURGIS",
    "dropdelst": "MI",
    "dropdelzpp": 490919998,
    "dropphyadd": "124 E CHICAGO RD",
    "dropphycty": "STURGIS",
    "dropphyst": "MI",
    "dropphyzpp": 490919998,
    "dropmaladd": "124 E CHICAGO RD",
    "dropmalcty": "STURGIS",
    "dropmalst": "MI",
    "dropmalzpp": 490919998,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 2696591780,
    "dropfax": 2696512460
  },
  {
    "dcode": "D",
    "dropkey": "PY12950",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "10674 W SAINT CHARLES RD",
    "dropdelcty": "SUMNER",
    "dropdelst": "MI",
    "dropdelzpp": 488898750,
    "dropphyadd": "10674 W SAINT CHARLES RD",
    "dropphycty": "SUMNER",
    "dropphyst": "MI",
    "dropphyzpp": 488898750,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMNER",
    "dropmalst": "MI",
    "dropmalzpp": 488899998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898337409,
    "dropsitcph": 9898337409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12952",
    "droptype": "D",
    "dropname": "SUNFIELD",
    "dropdeladd": "178 MAIN ST",
    "dropdelcty": "SUNFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 488909802,
    "dropphyadd": "178 MAIN ST",
    "dropphycty": "SUNFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 488909802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 488909998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5175668745,
    "dropsitcph": 5175668745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12955",
    "droptype": "D",
    "dropname": "SUTTONS BAY",
    "dropdeladd": "106 W BROADWAY",
    "dropdelcty": "SUTTONS BAY",
    "dropdelst": "MI",
    "dropdelzpp": 496829800,
    "dropphyadd": "106 W BROADWAY",
    "dropphycty": "SUTTONS BAY",
    "dropphyst": "MI",
    "dropphyzpp": 496829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUTTONS BAY",
    "dropmalst": "MI",
    "dropmalzpp": 496829998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312713622,
    "dropsitcph": 2312713622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12956",
    "droptype": "D",
    "dropname": "SWARTZ CREEK",
    "dropdeladd": "8055 PAUL FORTINO DR",
    "dropdelcty": "SWARTZ CREEK",
    "dropdelst": "MI",
    "dropdelzpp": 484739998,
    "dropphyadd": "8055 PAUL FORTINO DR",
    "dropphycty": "SWARTZ CREEK",
    "dropphyst": "MI",
    "dropphyzpp": 484739998,
    "dropmaladd": "8055 PAUL FORTINO DR",
    "dropmalcty": "SWARTZ CREEK",
    "dropmalst": "MI",
    "dropmalzpp": 484739998,
    "dropsitphn": 8106357393,
    "dropsitlph": 8102571580,
    "dropsitcph": 8106357393,
    "dropfax": 8106359155
  },
  {
    "dcode": "D",
    "dropkey": "PY12961",
    "droptype": "D",
    "dropname": "TAWAS CITY",
    "dropdeladd": "616 W LAKE ST",
    "dropdelcty": "TAWAS CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487635107,
    "dropphyadd": "616 W LAKE ST",
    "dropphycty": "TAWAS CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487635107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAWAS CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9893622471,
    "dropsitcph": 9893622471,
    "dropfax": 9893622727
  },
  {
    "dcode": "D",
    "dropkey": "PY12962",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "24837 GODDARD RD",
    "dropdelcty": "TAYLOR",
    "dropdelst": "MI",
    "dropdelzpp": 481809998,
    "dropphyadd": "24837 GODDARD RD",
    "dropphycty": "TAYLOR",
    "dropphyst": "MI",
    "dropphyzpp": 481809998,
    "dropmaladd": "24837 GODDARD RD",
    "dropmalcty": "TAYLOR",
    "dropmalst": "MI",
    "dropmalzpp": 481809998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7349464863,
    "dropsitcph": 7349464863,
    "dropfax": 7349465524
  },
  {
    "dcode": "D",
    "dropkey": "PY12964",
    "droptype": "D",
    "dropname": "TECUMSEH",
    "dropdeladd": "320 E CHICAGO BLVD",
    "dropdelcty": "TECUMSEH",
    "dropdelst": "MI",
    "dropdelzpp": 492869998,
    "dropphyadd": "320 E CHICAGO BLVD",
    "dropphycty": "TECUMSEH",
    "dropphyst": "MI",
    "dropphyzpp": 492869998,
    "dropmaladd": "320 E CHICAGO BLVD",
    "dropmalcty": "TECUMSEH",
    "dropmalst": "MI",
    "dropmalzpp": 492869998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174231197,
    "dropfax": 5174247142
  },
  {
    "dcode": "D",
    "dropkey": "PY12965",
    "droptype": "D",
    "dropname": "TEKONSHA",
    "dropdeladd": "119 N WALNUT ST",
    "dropdelcty": "TEKONSHA",
    "dropdelst": "MI",
    "dropdelzpp": 490929800,
    "dropphyadd": "119 N WALNUT ST",
    "dropphycty": "TEKONSHA",
    "dropphyst": "MI",
    "dropphyzpp": 490929800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEKONSHA",
    "dropmalst": "MI",
    "dropmalzpp": 490929998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5177674623,
    "dropsitcph": 5177674623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12967",
    "droptype": "D",
    "dropname": "TEMPERANCE",
    "dropdeladd": "8149 LEWIS AVE",
    "dropdelcty": "TEMPERANCE",
    "dropdelst": "MI",
    "dropdelzpp": 481829998,
    "dropphyadd": "8149 LEWIS AVE",
    "dropphycty": "TEMPERANCE",
    "dropphyst": "MI",
    "dropphyzpp": 481829998,
    "dropmaladd": "8149 LEWIS AVE",
    "dropmalcty": "TEMPERANCE",
    "dropmalst": "MI",
    "dropmalzpp": 481829998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7348477994,
    "dropsitcph": 7348477994,
    "dropfax": 7348474259
  },
  {
    "dcode": "D",
    "dropkey": "PY12970",
    "droptype": "D",
    "dropname": "THOMPSONVILLE",
    "dropdeladd": "14799 THOMPSON AVE",
    "dropdelcty": "THOMPSONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 496839800,
    "dropphyadd": "14799 THOMPSON AVE",
    "dropphycty": "THOMPSONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 496839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOMPSONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 496839998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2313782411,
    "dropsitcph": 2313782411,
    "dropfax": 2313782666
  },
  {
    "dcode": "D",
    "dropkey": "PY12972",
    "droptype": "D",
    "dropname": "THREE OAKS",
    "dropdeladd": "201 N ELM ST",
    "dropdelcty": "THREE OAKS",
    "dropdelst": "MI",
    "dropdelzpp": 491289998,
    "dropphyadd": "201 N ELM ST",
    "dropphycty": "THREE OAKS",
    "dropphyst": "MI",
    "dropphyzpp": 491289998,
    "dropmaladd": "201 N ELM ST",
    "dropmalcty": "THREE OAKS",
    "dropmalst": "MI",
    "dropmalzpp": 491289998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2697563521,
    "dropsitcph": 2697563521,
    "dropfax": 2697563842
  },
  {
    "dcode": "D",
    "dropkey": "PY12973",
    "droptype": "D",
    "dropname": "THREE RIVERS",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "THREE RIVERS",
    "dropdelst": "MI",
    "dropdelzpp": 490939998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "THREE RIVERS",
    "dropphyst": "MI",
    "dropphyzpp": 490939998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "THREE RIVERS",
    "dropmalst": "MI",
    "dropmalzpp": 490939998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2692786595,
    "dropsitcph": 2692786595,
    "dropfax": 2692785600
  },
  {
    "dcode": "D",
    "dropkey": "PY12974",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "3936 W MONROE RD",
    "dropdelcty": "TIPTON",
    "dropdelst": "MI",
    "dropdelzpp": 492879998,
    "dropphyadd": "3936 W MONROE RD",
    "dropphycty": "TIPTON",
    "dropphyst": "MI",
    "dropphyzpp": 492879998,
    "dropmaladd": "3936 W MONROE RD",
    "dropmalcty": "TIPTON",
    "dropmalst": "MI",
    "dropmalzpp": 492879998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174312802,
    "dropfax": 5174314872
  },
  {
    "dcode": "D",
    "dropkey": "PY12975",
    "droptype": "D",
    "dropname": "TOIVOLA",
    "dropdeladd": "19 STATE HIGHWAY M26",
    "dropdelcty": "TOIVOLA",
    "dropdelst": "MI",
    "dropdelzpp": 499659800,
    "dropphyadd": "19 STATE HIGHWAY M26",
    "dropphycty": "TOIVOLA",
    "dropphyst": "MI",
    "dropphyzpp": 499659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOIVOLA",
    "dropmalst": "MI",
    "dropmalzpp": 499659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062883764,
    "dropsitcph": 9062883764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12976",
    "droptype": "D",
    "dropname": "TOPINABEE",
    "dropdeladd": "1593 N STRAITS HWY",
    "dropdelcty": "TOPINABEE",
    "dropdelst": "MI",
    "dropdelzpp": 497919800,
    "dropphyadd": "1593 N STRAITS HWY",
    "dropphycty": "TOPINABEE",
    "dropphyst": "MI",
    "dropphyzpp": 497919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPINABEE",
    "dropmalst": "MI",
    "dropmalzpp": 497919998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312387016,
    "dropsitcph": 2312387016,
    "dropfax": 2312383018
  },
  {
    "dcode": "D",
    "dropkey": "PY12983",
    "droptype": "D",
    "dropname": "TRAVERSE CITY",
    "dropdeladd": "202 S UNION ST",
    "dropdelcty": "TRAVERSE CITY",
    "dropdelst": "MI",
    "dropdelzpp": 496849998,
    "dropphyadd": "202 S UNION ST",
    "dropphycty": "TRAVERSE CITY",
    "dropphyst": "MI",
    "dropphyzpp": 496849998,
    "dropmaladd": "202 S UNION ST",
    "dropmalcty": "TRAVERSE CITY",
    "dropmalst": "MI",
    "dropmalzpp": 496849998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2319331040,
    "dropsitcph": 2319469616,
    "dropfax": 2319462418
  },
  {
    "dcode": "D",
    "dropkey": "PY12986",
    "droptype": "D",
    "dropname": "TRENARY",
    "dropdeladd": "E2993 STATE HIGHWAY M67",
    "dropdelcty": "TRENARY",
    "dropdelst": "MI",
    "dropdelzpp": 498919624,
    "dropphyadd": "E2993 STATE HIGHWAY M67",
    "dropphycty": "TRENARY",
    "dropphyst": "MI",
    "dropphyzpp": 498919624,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRENARY",
    "dropmalst": "MI",
    "dropmalzpp": 498919998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064463608,
    "dropsitcph": 9064463608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12987",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "2740 3RD ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "MI",
    "dropdelzpp": 481839998,
    "dropphyadd": "2740 3RD ST",
    "dropphycty": "TRENTON",
    "dropphyst": "MI",
    "dropphyzpp": 481839998,
    "dropmaladd": "2740 3RD ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "MI",
    "dropmalzpp": 481839998,
    "dropsitphn": 7346760297,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346760297,
    "dropfax": 7346762702
  },
  {
    "dcode": "D",
    "dropkey": "PY12989",
    "droptype": "D",
    "dropname": "TROUT CREEK",
    "dropdeladd": "153 DIVISION ST",
    "dropdelcty": "TROUT CREEK",
    "dropdelst": "MI",
    "dropdelzpp": 499679300,
    "dropphyadd": "153 DIVISION ST",
    "dropphycty": "TROUT CREEK",
    "dropphyst": "MI",
    "dropphyzpp": 499679300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROUT CREEK",
    "dropmalst": "MI",
    "dropmalzpp": 499679998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068523430,
    "dropsitcph": 9068523430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12990",
    "droptype": "D",
    "dropname": "TROUT LAKE",
    "dropdeladd": "100 MAPLE ST",
    "dropdelcty": "TROUT LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497939800,
    "dropphyadd": "100 MAPLE ST",
    "dropphycty": "TROUT LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROUT LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497939998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9065693213,
    "dropsitcph": 9065693213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12991",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "2844 LIVERNOIS RD",
    "dropdelcty": "TROY",
    "dropdelst": "MI",
    "dropdelzpp": 480999998,
    "dropphyadd": "2844 LIVERNOIS RD",
    "dropphycty": "TROY",
    "dropphyst": "MI",
    "dropphyzpp": 480999998,
    "dropmaladd": "2844 LIVERNOIS RD",
    "dropmalcty": "TROY",
    "dropmalst": "MI",
    "dropmalzpp": 480999998,
    "dropsitphn": 2486191576,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486191598,
    "dropfax": 2486191550
  },
  {
    "dcode": "D",
    "dropkey": "PY12992",
    "droptype": "D",
    "dropname": "TRUFANT",
    "dropdeladd": "113 W 2ND ST",
    "dropdelcty": "TRUFANT",
    "dropdelst": "MI",
    "dropdelzpp": 493479615,
    "dropphyadd": "113 W 2ND ST",
    "dropphycty": "TRUFANT",
    "dropphyst": "MI",
    "dropphyzpp": 493479615,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRUFANT",
    "dropmalst": "MI",
    "dropmalzpp": 493479998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6169842812,
    "dropsitcph": 6169842812,
    "dropfax": 6169842402
  },
  {
    "dcode": "D",
    "dropkey": "PY12995",
    "droptype": "D",
    "dropname": "TUSTIN",
    "dropdeladd": "120 E CHURCH ST",
    "dropdelcty": "TUSTIN",
    "dropdelst": "MI",
    "dropdelzpp": 496885128,
    "dropphyadd": "120 E CHURCH ST",
    "dropphycty": "TUSTIN",
    "dropphyst": "MI",
    "dropphyzpp": 496885128,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUSTIN",
    "dropmalst": "MI",
    "dropmalzpp": 496889998,
    "dropsitphn": 2312812106,
    "dropsitlph": 2312812106,
    "dropsitcph": 2312812106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY12996",
    "droptype": "D",
    "dropname": "TWIN LAKE",
    "dropdeladd": "6034 EAST ST",
    "dropdelcty": "TWIN LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 494579808,
    "dropphyadd": "6034 EAST ST",
    "dropphycty": "TWIN LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 494579808,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWIN LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 494579998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318286355,
    "dropsitcph": 2312591039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13000",
    "droptype": "D",
    "dropname": "UBLY",
    "dropdeladd": "4482 GARFIELD ST",
    "dropdelcty": "UBLY",
    "dropdelst": "MI",
    "dropdelzpp": 484759998,
    "dropphyadd": "4482 GARFIELD ST",
    "dropphycty": "UBLY",
    "dropphyst": "MI",
    "dropphyzpp": 484759998,
    "dropmaladd": "4482 GARFIELD ST",
    "dropmalcty": "UBLY",
    "dropmalst": "MI",
    "dropmalzpp": 484759998,
    "dropsitphn": 9896588092,
    "dropsitlph": 8102571580,
    "dropsitcph": 9896588092,
    "dropfax": 9896582489
  },
  {
    "dcode": "D",
    "dropkey": "PY13004",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "123 ELLEN ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "MI",
    "dropdelzpp": 490949998,
    "dropphyadd": "123 ELLEN ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "MI",
    "dropphyzpp": 490949998,
    "dropmaladd": "123 ELLEN ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "MI",
    "dropmalzpp": 490949998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5177417003,
    "dropsitcph": 5177417003,
    "dropfax": 5177417003
  },
  {
    "dcode": "D",
    "dropkey": "PY13008",
    "droptype": "D",
    "dropname": "UNION LAKE",
    "dropdeladd": "7650 COOLEY LAKE RD",
    "dropdelcty": "UNION LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 483879998,
    "dropphyadd": "7650 COOLEY LAKE RD",
    "dropphycty": "UNION LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 483879998,
    "dropmaladd": "7650 COOLEY LAKE RD",
    "dropmalcty": "UNION LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 483879998,
    "dropsitphn": 2483635202,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483635202,
    "dropfax": 2483601534
  },
  {
    "dcode": "D",
    "dropkey": "PY13012",
    "droptype": "D",
    "dropname": "UNION PIER",
    "dropdeladd": "16201 RED ARROW HWY",
    "dropdelcty": "UNION PIER",
    "dropdelst": "MI",
    "dropdelzpp": 491299479,
    "dropphyadd": "16201 RED ARROW HWY",
    "dropphycty": "UNION PIER",
    "dropphyst": "MI",
    "dropphyzpp": 491299479,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION PIER",
    "dropmalst": "MI",
    "dropmalzpp": 491299998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694691975,
    "dropsitcph": 2694691975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13013",
    "droptype": "D",
    "dropname": "UNIONVILLE",
    "dropdeladd": "6599 CENTER ST",
    "dropdelcty": "UNIONVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 487679800,
    "dropphyadd": "6599 CENTER ST",
    "dropphycty": "UNIONVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 487679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 487679998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896748745,
    "dropsitcph": 9896748745,
    "dropfax": 9896740014
  },
  {
    "dcode": "D",
    "dropkey": "PY13018",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "8785 HALL RD",
    "dropdelcty": "UTICA",
    "dropdelst": "MI",
    "dropdelzpp": 483179998,
    "dropphyadd": "8785 HALL RD",
    "dropphycty": "UTICA",
    "dropphyst": "MI",
    "dropphyzpp": 483179998,
    "dropmaladd": "8785 HALL RD",
    "dropmalcty": "UTICA",
    "dropmalst": "MI",
    "dropmalzpp": 483179998,
    "dropsitphn": 5869832359,
    "dropsitlph": 2487585622,
    "dropsitcph": 5869832359,
    "dropfax": 5867313662
  },
  {
    "dcode": "D",
    "dropkey": "PY13021",
    "droptype": "D",
    "dropname": "VANDALIA",
    "dropdeladd": "17899 MILL ST",
    "dropdelcty": "VANDALIA",
    "dropdelst": "MI",
    "dropdelzpp": 490959501,
    "dropphyadd": "17899 MILL ST",
    "dropphycty": "VANDALIA",
    "dropphyst": "MI",
    "dropphyzpp": 490959501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANDALIA",
    "dropmalst": "MI",
    "dropmalzpp": 490959998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694762654,
    "dropsitcph": 2694762654,
    "dropfax": 2694761026
  },
  {
    "dcode": "D",
    "dropkey": "PY13022",
    "droptype": "D",
    "dropname": "VANDERBILT",
    "dropdeladd": "534 E MAIN ST",
    "dropdelcty": "VANDERBILT",
    "dropdelst": "MI",
    "dropdelzpp": 497959784,
    "dropphyadd": "534 E MAIN ST",
    "dropphycty": "VANDERBILT",
    "dropphyst": "MI",
    "dropphyzpp": 497959784,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANDERBILT",
    "dropmalst": "MI",
    "dropmalzpp": 497959998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9899832221,
    "dropsitcph": 9899832221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13023",
    "droptype": "D",
    "dropname": "VASSAR",
    "dropdeladd": "203 N MAIN ST",
    "dropdelcty": "VASSAR",
    "dropdelst": "MI",
    "dropdelzpp": 487681339,
    "dropphyadd": "203 N MAIN ST",
    "dropphycty": "VASSAR",
    "dropphyst": "MI",
    "dropphyzpp": 487681339,
    "dropmaladd": "203 N MAIN ST",
    "dropmalcty": "VASSAR",
    "dropmalst": "MI",
    "dropmalzpp": 487681339,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898237851,
    "dropsitcph": 9898237851,
    "dropfax": 9898238560
  },
  {
    "dcode": "D",
    "dropkey": "PY13025",
    "droptype": "D",
    "dropname": "VERMONTVILLE",
    "dropdeladd": "139 S MAIN ST",
    "dropdelcty": "VERMONTVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 490969451,
    "dropphyadd": "139 S MAIN ST",
    "dropphycty": "VERMONTVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 490969451,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERMONTVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 490969998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5177260646,
    "dropsitcph": 5177260646,
    "dropfax": 5177261449
  },
  {
    "dcode": "D",
    "dropkey": "PY13027",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "137 E MAIN ST",
    "dropdelcty": "VERNON",
    "dropdelst": "MI",
    "dropdelzpp": 484769998,
    "dropphyadd": "137 E MAIN ST",
    "dropphycty": "VERNON",
    "dropphyst": "MI",
    "dropphyzpp": 484769998,
    "dropmaladd": "137 E MAIN ST",
    "dropmalcty": "VERNON",
    "dropmalst": "MI",
    "dropmalzpp": 484769998,
    "dropsitphn": 9892884303,
    "dropsitlph": 8102571580,
    "dropsitcph": 9892884303,
    "dropfax": 9892880155
  },
  {
    "dcode": "D",
    "dropkey": "PY13028",
    "droptype": "D",
    "dropname": "VESTABURG",
    "dropdeladd": "8845 3RD ST",
    "dropdelcty": "VESTABURG",
    "dropdelst": "MI",
    "dropdelzpp": 488915121,
    "dropphyadd": "8845 3RD ST",
    "dropphycty": "VESTABURG",
    "dropphyst": "MI",
    "dropphyzpp": 488915121,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VESTABURG",
    "dropmalst": "MI",
    "dropmalzpp": 488919998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9892685500,
    "dropsitcph": 9892685500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13034",
    "droptype": "D",
    "dropname": "VICKSBURG",
    "dropdeladd": "113 N KALAMAZOO ST",
    "dropdelcty": "VICKSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 490979998,
    "dropphyadd": "113 N KALAMAZOO ST",
    "dropphycty": "VICKSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 490979998,
    "dropmaladd": "113 N KALAMAZOO ST",
    "dropmalcty": "VICKSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 490979998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2696490148,
    "dropsitcph": 2696490148,
    "dropfax": 2696490820
  },
  {
    "dcode": "D",
    "dropkey": "PY13035",
    "droptype": "D",
    "dropname": "VULCAN",
    "dropdeladd": "W4994 CENTRAL BLVD",
    "dropdelcty": "VULCAN",
    "dropdelst": "MI",
    "dropdelzpp": 498925100,
    "dropphyadd": "W4994 CENTRAL BLVD",
    "dropphycty": "VULCAN",
    "dropphyst": "MI",
    "dropphyzpp": 498925100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VULCAN",
    "dropmalst": "MI",
    "dropmalzpp": 498929998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9065638002,
    "dropsitcph": 9065638002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13048",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "409 HANCOCK ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 499689998,
    "dropphyadd": "409 HANCOCK ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 499689998,
    "dropmaladd": "409 HANCOCK ST",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 499689998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9062295591,
    "dropsitcph": 9062295591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13049",
    "droptype": "D",
    "dropname": "WALDRON",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "WALDRON",
    "dropdelst": "MI",
    "dropdelzpp": 492889998,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "WALDRON",
    "dropphyst": "MI",
    "dropphyzpp": 492889998,
    "dropmaladd": "100 S MAIN ST",
    "dropmalcty": "WALDRON",
    "dropmalst": "MI",
    "dropmalzpp": 492889998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5172866600,
    "dropfax": 5172866240
  },
  {
    "dcode": "D",
    "dropkey": "PY13053",
    "droptype": "D",
    "dropname": "WALHALLA",
    "dropdeladd": "6635 E US HIGHWAY 10",
    "dropdelcty": "WALHALLA",
    "dropdelst": "MI",
    "dropdelzpp": 494589800,
    "dropphyadd": "6635 E US HIGHWAY 10",
    "dropphycty": "WALHALLA",
    "dropphyst": "MI",
    "dropphyzpp": 494589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALHALLA",
    "dropmalst": "MI",
    "dropmalzpp": 494589998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317573921,
    "dropsitcph": 2317573921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13056",
    "droptype": "D",
    "dropname": "WALKERVILLE",
    "dropdeladd": "132 E LAUREL ST",
    "dropdelcty": "WALKERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 494595101,
    "dropphyadd": "132 E LAUREL ST",
    "dropphycty": "WALKERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 494595101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALKERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 494599998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318734713,
    "dropsitcph": 2318734713,
    "dropfax": 2318734713
  },
  {
    "dcode": "D",
    "dropkey": "PY13058",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "N5965 US HIGHWAY 41",
    "dropdelcty": "WALLACE",
    "dropdelst": "MI",
    "dropdelzpp": 498939385,
    "dropphyadd": "N5965 US HIGHWAY 41",
    "dropphycty": "WALLACE",
    "dropphyst": "MI",
    "dropphyzpp": 498939385,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLACE",
    "dropmalst": "MI",
    "dropmalzpp": 498939998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9067884223,
    "dropsitcph": 9067884223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13059",
    "droptype": "D",
    "dropname": "WALLED LAKE",
    "dropdeladd": "995 N PONTIAC TRL",
    "dropdelcty": "WALLED LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 483909998,
    "dropphyadd": "995 N PONTIAC TRL",
    "dropphycty": "WALLED LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 483909998,
    "dropmaladd": "995 N PONTIAC TRL",
    "dropmalcty": "WALLED LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 483909998,
    "dropsitphn": 2486698089,
    "dropsitlph": 2486242869,
    "dropsitcph": 2486242869,
    "dropfax": 2486246170
  },
  {
    "dcode": "D",
    "dropkey": "PY13061",
    "droptype": "D",
    "dropname": "WALLOON LAKE",
    "dropdeladd": "4149 STATE ST",
    "dropdelcty": "WALLOON LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 497969800,
    "dropphyadd": "4149 STATE ST",
    "dropphycty": "WALLOON LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 497969800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLOON LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 497969998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315352421,
    "dropsitcph": 2315352421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13064",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "28401 MOUND RD",
    "dropdelcty": "WARREN",
    "dropdelst": "MI",
    "dropdelzpp": 480909998,
    "dropphyadd": "28401 MOUND RD",
    "dropphycty": "WARREN",
    "dropphyst": "MI",
    "dropphyzpp": 480909998,
    "dropmaladd": "28401 MOUND RD",
    "dropmalcty": "WARREN",
    "dropmalst": "MI",
    "dropmalzpp": 480909998,
    "dropsitphn": 5865768960,
    "dropsitlph": 2487585622,
    "dropsitcph": 5865768975,
    "dropfax": 5865768909
  },
  {
    "dcode": "D",
    "dropkey": "PY13065",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "58757 VAN DYKE RD",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "MI",
    "dropdelzpp": 480949998,
    "dropphyadd": "58757 VAN DYKE RD",
    "dropphycty": "WASHINGTON",
    "dropphyst": "MI",
    "dropphyzpp": 480949998,
    "dropmaladd": "58757 VAN DYKE RD",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "MI",
    "dropmalzpp": 480949998,
    "dropsitphn": 5866778603,
    "dropsitlph": 2487585622,
    "dropsitcph": 5866778603,
    "dropfax": 5867812961
  },
  {
    "dcode": "D",
    "dropkey": "PY13068",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "5036 DIXIE HWY",
    "dropdelcty": "WATERFORD",
    "dropdelst": "MI",
    "dropdelzpp": 483299998,
    "dropphyadd": "5036 DIXIE HWY",
    "dropphycty": "WATERFORD",
    "dropphyst": "MI",
    "dropphyzpp": 483299998,
    "dropmaladd": "5340 HIGHLAND RD",
    "dropmalcty": "WATERFORD",
    "dropmalst": "MI",
    "dropmalzpp": 483279998,
    "dropsitphn": 2486733343,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486733343,
    "dropfax": 2486735019
  },
  {
    "dcode": "D",
    "dropkey": "PY13072",
    "droptype": "D",
    "dropname": "WATERS",
    "dropdeladd": "10568 OTSEGOLAND RD",
    "dropdelcty": "WATERS",
    "dropdelst": "MI",
    "dropdelzpp": 497979800,
    "dropphyadd": "10568 OTSEGOLAND RD",
    "dropphycty": "WATERS",
    "dropphyst": "MI",
    "dropphyzpp": 497979800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERS",
    "dropmalst": "MI",
    "dropmalzpp": 497979998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897322031,
    "dropsitcph": 9897322031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13073",
    "droptype": "D",
    "dropname": "WATERSMEET",
    "dropdeladd": "N4708 MAIN ST",
    "dropdelcty": "WATERSMEET",
    "dropdelst": "MI",
    "dropdelzpp": 499699600,
    "dropphyadd": "N4708 MAIN ST",
    "dropphycty": "WATERSMEET",
    "dropphyst": "MI",
    "dropphyzpp": 499699600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERSMEET",
    "dropmalst": "MI",
    "dropmalzpp": 499699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063584781,
    "dropsitcph": 9063584781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13074",
    "droptype": "D",
    "dropname": "WATERVLIET",
    "dropdeladd": "342 W PLEASANT ST",
    "dropdelcty": "WATERVLIET",
    "dropdelst": "MI",
    "dropdelzpp": 490989147,
    "dropphyadd": "342 W PLEASANT ST",
    "dropphycty": "WATERVLIET",
    "dropphyst": "MI",
    "dropphyzpp": 490989147,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERVLIET",
    "dropmalst": "MI",
    "dropmalzpp": 490989998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694636142,
    "dropsitcph": 2694636142,
    "dropfax": 2694636142
  },
  {
    "dcode": "D",
    "dropkey": "PY13076",
    "droptype": "D",
    "dropname": "WATTON",
    "dropdeladd": "11729 STATE HIGHWAY M28",
    "dropdelcty": "WATTON",
    "dropdelst": "MI",
    "dropdelzpp": 499709800,
    "dropphyadd": "11729 STATE HIGHWAY M28",
    "dropphycty": "WATTON",
    "dropphyst": "MI",
    "dropphyzpp": 499709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATTON",
    "dropmalst": "MI",
    "dropmalzpp": 499709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063552308,
    "dropsitcph": 9063552308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13077",
    "droptype": "D",
    "dropname": "WAYLAND",
    "dropdeladd": "325 RENO DR",
    "dropdelcty": "WAYLAND",
    "dropdelst": "MI",
    "dropdelzpp": 493481278,
    "dropphyadd": "325 RENO DR",
    "dropphycty": "WAYLAND",
    "dropphyst": "MI",
    "dropphyzpp": 493481278,
    "dropmaladd": "325 RENO DR",
    "dropmalcty": "WAYLAND",
    "dropmalst": "MI",
    "dropmalzpp": 493481278,
    "dropsitphn": 6167761516,
    "dropsitlph": 2697922371,
    "dropsitcph": 2697922371,
    "dropfax": 2697923681
  },
  {
    "dcode": "D",
    "dropkey": "PY13078",
    "droptype": "D",
    "dropname": "WAYNE",
    "dropdeladd": "3716 NEWBERRY ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "MI",
    "dropdelzpp": 481849998,
    "dropphyadd": "3716 NEWBERRY ST",
    "dropphycty": "WAYNE",
    "dropphyst": "MI",
    "dropphyzpp": 481849998,
    "dropmaladd": "3716 NEWBERRY ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "MI",
    "dropmalzpp": 481849998,
    "dropsitphn": 7347281765,
    "dropsitlph": 3132268554,
    "dropsitcph": 7347281765,
    "dropfax": 7347280001
  },
  {
    "dcode": "D",
    "dropkey": "PY13079",
    "droptype": "D",
    "dropname": "WEBBERVILLE",
    "dropdeladd": "216 W GRAND RIVER RD",
    "dropdelcty": "WEBBERVILLE",
    "dropdelst": "MI",
    "dropdelzpp": 488925106,
    "dropphyadd": "216 W GRAND RIVER RD",
    "dropphycty": "WEBBERVILLE",
    "dropphyst": "MI",
    "dropphyzpp": 488925106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBBERVILLE",
    "dropmalst": "MI",
    "dropmalzpp": 488929998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5175213295,
    "dropsitcph": 5175213295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13081",
    "droptype": "D",
    "dropname": "WEIDMAN",
    "dropdeladd": "3366 N WOODRUFF RD",
    "dropdelcty": "WEIDMAN",
    "dropdelst": "MI",
    "dropdelzpp": 488935101,
    "dropphyadd": "3366 N WOODRUFF RD",
    "dropphycty": "WEIDMAN",
    "dropphyst": "MI",
    "dropphyzpp": 488935101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEIDMAN",
    "dropmalst": "MI",
    "dropmalzpp": 488939998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9896442345,
    "dropsitcph": 9896442345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13083",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "5659 MAIN ST",
    "dropdelcty": "WELLS",
    "dropdelst": "MI",
    "dropdelzpp": 498949754,
    "dropphyadd": "5659 MAIN ST",
    "dropphycty": "WELLS",
    "dropphyst": "MI",
    "dropphyzpp": 498949754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLS",
    "dropmalst": "MI",
    "dropmalzpp": 498949998,
    "dropsitphn": 4142912520,
    "dropsitlph": 9067868272,
    "dropsitcph": 9067868272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13084",
    "droptype": "D",
    "dropname": "WELLSTON",
    "dropdeladd": "17114 6TH ST",
    "dropdelcty": "WELLSTON",
    "dropdelst": "MI",
    "dropdelzpp": 496899802,
    "dropphyadd": "17114 6TH ST",
    "dropphycty": "WELLSTON",
    "dropphyst": "MI",
    "dropphyzpp": 496899802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLSTON",
    "dropmalst": "MI",
    "dropmalzpp": 496899998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318484424,
    "dropsitcph": 2318484424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13087",
    "droptype": "D",
    "dropname": "WEST BRANCH",
    "dropdeladd": "122 S 3RD ST",
    "dropdelcty": "WEST BRANCH",
    "dropdelst": "MI",
    "dropdelzpp": 486611328,
    "dropphyadd": "122 S 3RD ST",
    "dropphycty": "WEST BRANCH",
    "dropphyst": "MI",
    "dropphyzpp": 486611328,
    "dropmaladd": "122 S 3RD ST",
    "dropmalcty": "WEST BRANCH",
    "dropmalst": "MI",
    "dropmalzpp": 486611328,
    "dropsitphn": 6167761516,
    "dropsitlph": 9893452691,
    "dropsitcph": 9893452691,
    "dropfax": 9893454950
  },
  {
    "dcode": "D",
    "dropkey": "PY13089",
    "droptype": "D",
    "dropname": "WEST OLIVE",
    "dropdeladd": "8600 146TH AVE",
    "dropdelcty": "WEST OLIVE",
    "dropdelst": "MI",
    "dropdelzpp": 494609673,
    "dropphyadd": "8600 146TH AVE",
    "dropphycty": "WEST OLIVE",
    "dropphyst": "MI",
    "dropphyzpp": 494609673,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST OLIVE",
    "dropmalst": "MI",
    "dropmalzpp": 494609998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163991583,
    "dropsitcph": 6163991583,
    "dropfax": 6163991848
  },
  {
    "dcode": "D",
    "dropkey": "PY13092",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "4116 WESTON RD",
    "dropdelcty": "WESTON",
    "dropdelst": "MI",
    "dropdelzpp": 492899998,
    "dropphyadd": "4116 WESTON RD",
    "dropphycty": "WESTON",
    "dropphyst": "MI",
    "dropphyzpp": 492899998,
    "dropmaladd": "4116 WESTON RD",
    "dropmalcty": "WESTON",
    "dropmalst": "MI",
    "dropmalzpp": 492899998,
    "dropsitphn": 3132268554,
    "dropsitlph": 5177680726,
    "dropsitcph": 5174363283,
    "dropfax": 5174366361
  },
  {
    "dcode": "D",
    "dropkey": "PY13093",
    "droptype": "D",
    "dropname": "WESTPHALIA",
    "dropdeladd": "115 W MAIN ST",
    "dropdelcty": "WESTPHALIA",
    "dropdelst": "MI",
    "dropdelzpp": 488949838,
    "dropphyadd": "115 W MAIN ST",
    "dropphycty": "WESTPHALIA",
    "dropphyst": "MI",
    "dropphyzpp": 488949838,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTPHALIA",
    "dropmalst": "MI",
    "dropmalzpp": 488949998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9895876963,
    "dropsitcph": 9895876963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13097",
    "droptype": "D",
    "dropname": "WETMORE",
    "dropdeladd": "E9714 STATE HIGHWAY M28",
    "dropdelcty": "WETMORE",
    "dropdelst": "MI",
    "dropdelzpp": 498959088,
    "dropphyadd": "E9714 STATE HIGHWAY M28",
    "dropphycty": "WETMORE",
    "dropphyst": "MI",
    "dropphyzpp": 498959088,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WETMORE",
    "dropmalst": "MI",
    "dropmalzpp": 498959998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9063874672,
    "dropsitcph": 9063874672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13099",
    "droptype": "D",
    "dropname": "WHITE CLOUD",
    "dropdeladd": "1097 E WILCOX AVE",
    "dropdelcty": "WHITE CLOUD",
    "dropdelst": "MI",
    "dropdelzpp": 493498794,
    "dropphyadd": "1097 E WILCOX AVE",
    "dropphycty": "WHITE CLOUD",
    "dropphyst": "MI",
    "dropphyzpp": 493498794,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE CLOUD",
    "dropmalst": "MI",
    "dropmalzpp": 493499998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2316896522,
    "dropsitcph": 2316896522,
    "dropfax": 2316890290
  },
  {
    "dcode": "D",
    "dropkey": "PY13101",
    "droptype": "D",
    "dropname": "WHITE PIGEON",
    "dropdeladd": "107 N KALAMAZOO ST",
    "dropdelcty": "WHITE PIGEON",
    "dropdelst": "MI",
    "dropdelzpp": 490999726,
    "dropphyadd": "107 N KALAMAZOO ST",
    "dropphycty": "WHITE PIGEON",
    "dropphyst": "MI",
    "dropphyzpp": 490999726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE PIGEON",
    "dropmalst": "MI",
    "dropmalzpp": 490999998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2694839016,
    "dropsitcph": 2694839016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13102",
    "droptype": "D",
    "dropname": "WHITE PINE",
    "dropdeladd": "303 MINERAL RIVER PLZ",
    "dropdelcty": "WHITE PINE",
    "dropdelst": "MI",
    "dropdelzpp": 499719800,
    "dropphyadd": "303 MINERAL RIVER PLZ",
    "dropphycty": "WHITE PINE",
    "dropphyst": "MI",
    "dropphyzpp": 499719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE PINE",
    "dropmalst": "MI",
    "dropmalzpp": 499719998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9068855741,
    "dropsitcph": 9068855741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13104",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "203 S MEARS AVE",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "MI",
    "dropdelzpp": 494619998,
    "dropphyadd": "203 S MEARS AVE",
    "dropphycty": "WHITEHALL",
    "dropphyst": "MI",
    "dropphyzpp": 494619998,
    "dropmaladd": "203 S MEARS AVE",
    "dropmalcty": "WHITEHALL",
    "dropmalst": "MI",
    "dropmalzpp": 494619998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2318944553,
    "dropsitcph": 2318944553,
    "dropfax": 2318930023
  },
  {
    "dcode": "D",
    "dropkey": "PY13105",
    "droptype": "D",
    "dropname": "WHITMORE LAKE",
    "dropdeladd": "9725 MAIN ST",
    "dropdelcty": "WHITMORE LAKE",
    "dropdelst": "MI",
    "dropdelzpp": 481899998,
    "dropphyadd": "9725 MAIN ST",
    "dropphycty": "WHITMORE LAKE",
    "dropphyst": "MI",
    "dropphyzpp": 481899998,
    "dropmaladd": "9725 MAIN ST",
    "dropmalcty": "WHITMORE LAKE",
    "dropmalst": "MI",
    "dropmalzpp": 481899998,
    "dropsitphn": 7344494982,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344494982,
    "dropfax": 7344490391
  },
  {
    "dcode": "D",
    "dropkey": "PY13106",
    "droptype": "D",
    "dropname": "WHITTAKER",
    "dropdeladd": "11014 WHITTAKER RD",
    "dropdelcty": "WHITTAKER",
    "dropdelst": "MI",
    "dropdelzpp": 481909998,
    "dropphyadd": "11014 WHITTAKER RD",
    "dropphycty": "WHITTAKER",
    "dropphyst": "MI",
    "dropphyzpp": 481909998,
    "dropmaladd": "11014 WHITTAKER RD",
    "dropmalcty": "WHITTAKER",
    "dropmalst": "MI",
    "dropmalzpp": 481909998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344616875,
    "dropfax": 7344611981
  },
  {
    "dcode": "D",
    "dropkey": "PY13107",
    "droptype": "D",
    "dropname": "WHITTEMORE",
    "dropdeladd": "209 S BULLOCK ST",
    "dropdelcty": "WHITTEMORE",
    "dropdelst": "MI",
    "dropdelzpp": 487709800,
    "dropphyadd": "209 S BULLOCK ST",
    "dropphycty": "WHITTEMORE",
    "dropphyst": "MI",
    "dropphyzpp": 487709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITTEMORE",
    "dropmalst": "MI",
    "dropmalzpp": 487709998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897563641,
    "dropsitcph": 9897563641,
    "dropfax": 9897563641
  },
  {
    "dcode": "D",
    "dropkey": "PY13110",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "8344 OLD M 72",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "MI",
    "dropdelzpp": 496909701,
    "dropphyadd": "8344 OLD M 72",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "MI",
    "dropphyzpp": 496909701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "MI",
    "dropmalzpp": 496909998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2312675071,
    "dropsitcph": 2312675071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13111",
    "droptype": "D",
    "dropname": "WILLIAMSTON",
    "dropdeladd": "1295 E GRAND RIVER RD",
    "dropdelcty": "WILLIAMSTON",
    "dropdelst": "MI",
    "dropdelzpp": 488959998,
    "dropphyadd": "1295 E GRAND RIVER RD",
    "dropphycty": "WILLIAMSTON",
    "dropphyst": "MI",
    "dropphyzpp": 488959998,
    "dropmaladd": "1295 E GRAND RIVER RD",
    "dropmalcty": "WILLIAMSTON",
    "dropmalst": "MI",
    "dropmalzpp": 488959998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5176552280,
    "dropsitcph": 5176552280,
    "dropfax": 5176559074
  },
  {
    "dcode": "D",
    "dropkey": "PY13113",
    "droptype": "D",
    "dropname": "WILLIS",
    "dropdeladd": "8790 BUNTON RD",
    "dropdelcty": "WILLIS",
    "dropdelst": "MI",
    "dropdelzpp": 481919998,
    "dropphyadd": "8790 BUNTON RD",
    "dropphycty": "WILLIS",
    "dropphyst": "MI",
    "dropphyzpp": 481919998,
    "dropmaladd": "8790 BUNTON RD",
    "dropmalcty": "WILLIS",
    "dropmalst": "MI",
    "dropmalzpp": 481919998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344619700,
    "dropfax": 7344611016
  },
  {
    "dcode": "D",
    "dropkey": "PY13116",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "W2261 US HIGHWAY 2 41",
    "dropdelcty": "WILSON",
    "dropdelst": "MI",
    "dropdelzpp": 498969603,
    "dropphyadd": "W2261 US HIGHWAY 2 41",
    "dropphycty": "WILSON",
    "dropphyst": "MI",
    "dropphyzpp": 498969603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSON",
    "dropmalst": "MI",
    "dropmalzpp": 498969998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9064975959,
    "dropsitcph": 9064975959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13117",
    "droptype": "D",
    "dropname": "WINN",
    "dropdeladd": "2855 W BLANCHARD RD",
    "dropdelcty": "WINN",
    "dropdelst": "MI",
    "dropdelzpp": 488969800,
    "dropphyadd": "2855 W BLANCHARD RD",
    "dropphycty": "WINN",
    "dropphyst": "MI",
    "dropphyzpp": 488969800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINN",
    "dropmalst": "MI",
    "dropmalzpp": 488969998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9898662600,
    "dropsitcph": 9898662600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13118",
    "droptype": "D",
    "dropname": "WIXOM",
    "dropdeladd": "48660 PONTIAC TRL",
    "dropdelcty": "WIXOM",
    "dropdelst": "MI",
    "dropdelzpp": 483939998,
    "dropphyadd": "48660 PONTIAC TRL",
    "dropphycty": "WIXOM",
    "dropphyst": "MI",
    "dropphyzpp": 483939998,
    "dropmaladd": "48660 PONTIAC TRL",
    "dropmalcty": "WIXOM",
    "dropmalst": "MI",
    "dropmalzpp": 483939998,
    "dropsitphn": 2486242382,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486246248,
    "dropfax": 2486246254
  },
  {
    "dcode": "D",
    "dropkey": "PY13119",
    "droptype": "D",
    "dropname": "WOLVERINE",
    "dropdeladd": "12966 S STRAITS HWY",
    "dropdelcty": "WOLVERINE",
    "dropdelst": "MI",
    "dropdelzpp": 497999743,
    "dropphyadd": "12966 S STRAITS HWY",
    "dropphycty": "WOLVERINE",
    "dropphyst": "MI",
    "dropphyzpp": 497999743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOLVERINE",
    "dropmalst": "MI",
    "dropmalzpp": 497999998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2315258882,
    "dropsitcph": 2315258882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13123",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "134 N MAIN ST",
    "dropdelcty": "WOODLAND",
    "dropdelst": "MI",
    "dropdelzpp": 488979725,
    "dropphyadd": "134 N MAIN ST",
    "dropphycty": "WOODLAND",
    "dropphyst": "MI",
    "dropphyzpp": 488979725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODLAND",
    "dropmalst": "MI",
    "dropmalzpp": 488979998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693674444,
    "dropsitcph": 2693674444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13129",
    "droptype": "D",
    "dropname": "WYANDOTTE",
    "dropdeladd": "231 EUREKA RD",
    "dropdelcty": "WYANDOTTE",
    "dropdelst": "MI",
    "dropdelzpp": 481929998,
    "dropphyadd": "231 EUREKA RD",
    "dropphycty": "WYANDOTTE",
    "dropphyst": "MI",
    "dropphyzpp": 481929998,
    "dropmaladd": "231 EUREKA RD",
    "dropmalcty": "WYANDOTTE",
    "dropmalst": "MI",
    "dropmalzpp": 481929998,
    "dropsitphn": 7342837158,
    "dropsitlph": 3132268554,
    "dropsitcph": 7342837158,
    "dropfax": 7342845955
  },
  {
    "dcode": "D",
    "dropkey": "PY13134",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "211 JONES ST",
    "dropdelcty": "YALE",
    "dropdelst": "MI",
    "dropdelzpp": 480979998,
    "dropphyadd": "211 JONES ST",
    "dropphycty": "YALE",
    "dropphyst": "MI",
    "dropphyzpp": 480979998,
    "dropmaladd": "211 JONES ST",
    "dropmalcty": "YALE",
    "dropmalst": "MI",
    "dropmalzpp": 480979998,
    "dropsitphn": 8104629020,
    "dropsitlph": 2487585622,
    "dropsitcph": 8104629020,
    "dropfax": 8103879025
  },
  {
    "dcode": "D",
    "dropkey": "PY13138",
    "droptype": "D",
    "dropname": "YPSILANTI",
    "dropdeladd": "1606 S HURON ST",
    "dropdelcty": "YPSILANTI",
    "dropdelst": "MI",
    "dropdelzpp": 481979998,
    "dropphyadd": "1606 S HURON ST",
    "dropphycty": "YPSILANTI",
    "dropphyst": "MI",
    "dropphyzpp": 481979998,
    "dropmaladd": "1606 S HURON ST",
    "dropmalcty": "YPSILANTI",
    "dropmalst": "MI",
    "dropmalzpp": 481979998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7344823046,
    "dropsitcph": 7344823046,
    "dropfax": 7344820512
  },
  {
    "dcode": "D",
    "dropkey": "PY13140",
    "droptype": "D",
    "dropname": "ZEELAND",
    "dropdeladd": "155 E MAIN AVE",
    "dropdelcty": "ZEELAND",
    "dropdelst": "MI",
    "dropdelzpp": 494649998,
    "dropphyadd": "155 E MAIN AVE",
    "dropphycty": "ZEELAND",
    "dropphyst": "MI",
    "dropphyzpp": 494649998,
    "dropmaladd": "155 E MAIN AVE",
    "dropmalcty": "ZEELAND",
    "dropmalst": "MI",
    "dropmalzpp": 494649998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167722971,
    "dropsitcph": 6167722971,
    "dropfax": 6167725318
  },
  {
    "dcode": "D",
    "dropkey": "PY13153",
    "droptype": "D",
    "dropname": "ABBEVILLE",
    "dropdeladd": "8 E LONG ST",
    "dropdelcty": "ABBEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 386019998,
    "dropphyadd": "8 E LONG ST",
    "dropphycty": "ABBEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 386019998,
    "dropmaladd": "8 E LONG ST",
    "dropmalcty": "ABBEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 386019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622343606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13157",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "301 W COMMERCE ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "MS",
    "dropdelzpp": 397309998,
    "dropphyadd": "301 W COMMERCE ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "MS",
    "dropphyzpp": 397309998,
    "dropmaladd": "301 W COMMERCE ST",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "MS",
    "dropmalzpp": 397309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623694841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13158",
    "droptype": "D",
    "dropname": "ACKERMAN",
    "dropdeladd": "1035 W MAIN ST",
    "dropdelcty": "ACKERMAN",
    "dropdelst": "MS",
    "dropdelzpp": 397359998,
    "dropphyadd": "1035 W MAIN ST",
    "dropphycty": "ACKERMAN",
    "dropphyst": "MS",
    "dropphyzpp": 397359998,
    "dropmaladd": "1035 W MAIN ST",
    "dropmalcty": "ACKERMAN",
    "dropmalst": "MS",
    "dropmalzpp": 397359998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622856567,
    "dropfax": 6622853152
  },
  {
    "dcode": "D",
    "dropkey": "PY13166",
    "droptype": "D",
    "dropname": "ALGOMA",
    "dropdeladd": "5 MAIN AVE",
    "dropdelcty": "ALGOMA",
    "dropdelst": "MS",
    "dropdelzpp": 388209998,
    "dropphyadd": "5 MAIN AVE",
    "dropphycty": "ALGOMA",
    "dropphyst": "MS",
    "dropphyzpp": 388209998,
    "dropmaladd": "5 MAIN AVE",
    "dropmalcty": "ALGOMA",
    "dropmalst": "MS",
    "dropmalzpp": 388209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624891637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13167",
    "droptype": "D",
    "dropname": "ALLIGATOR",
    "dropdeladd": "5 MAIN ST",
    "dropdelcty": "ALLIGATOR",
    "dropdelst": "MS",
    "dropdelzpp": 387209998,
    "dropphyadd": "5 MAIN ST",
    "dropphycty": "ALLIGATOR",
    "dropphyst": "MS",
    "dropphyzpp": 387209998,
    "dropmaladd": "5 MAIN ST",
    "dropmalcty": "ALLIGATOR",
    "dropmalst": "MS",
    "dropmalzpp": 387209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626277164,
    "dropfax": 6626277164
  },
  {
    "dcode": "D",
    "dropkey": "PY13174",
    "droptype": "D",
    "dropname": "AMORY",
    "dropdeladd": "215 1ST AVE",
    "dropdelcty": "AMORY",
    "dropdelst": "MS",
    "dropdelzpp": 388219998,
    "dropphyadd": "215 1ST AVE",
    "dropphycty": "AMORY",
    "dropphyst": "MS",
    "dropphyzpp": 388219998,
    "dropmaladd": "215 1ST AVE",
    "dropmalcty": "AMORY",
    "dropmalst": "MS",
    "dropmalzpp": 388219998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622565091,
    "dropfax": 6622568324
  },
  {
    "dcode": "D",
    "dropkey": "PY13176",
    "droptype": "D",
    "dropname": "ANGUILLA",
    "dropdeladd": "119 HOLLAND ST",
    "dropdelcty": "ANGUILLA",
    "dropdelst": "MS",
    "dropdelzpp": 387219998,
    "dropphyadd": "119 HOLLAND ST",
    "dropphycty": "ANGUILLA",
    "dropphyst": "MS",
    "dropphyzpp": 387219998,
    "dropmaladd": "119 HOLLAND ST",
    "dropmalcty": "ANGUILLA",
    "dropmalst": "MS",
    "dropmalzpp": 387219998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628732607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13180",
    "droptype": "D",
    "dropname": "ARCOLA",
    "dropdeladd": "101B TOWER LN",
    "dropdelcty": "ARCOLA",
    "dropdelst": "MS",
    "dropdelzpp": 387229998,
    "dropphyadd": "101B TOWER LN",
    "dropphycty": "ARCOLA",
    "dropphyst": "MS",
    "dropphyzpp": 387229998,
    "dropmaladd": "101B TOWER LN",
    "dropmalcty": "ARCOLA",
    "dropmalst": "MS",
    "dropmalzpp": 387229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628272521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13182",
    "droptype": "D",
    "dropname": "ARKABUTLA",
    "dropdeladd": "8294 ARKABUTLA RD",
    "dropdelcty": "ARKABUTLA",
    "dropdelst": "MS",
    "dropdelzpp": 386029998,
    "dropphyadd": "8294 ARKABUTLA RD",
    "dropphycty": "ARKABUTLA",
    "dropphyst": "MS",
    "dropphyzpp": 386029998,
    "dropmaladd": "8294 ARKABUTLA RD",
    "dropmalcty": "ARKABUTLA",
    "dropmalst": "MS",
    "dropmalzpp": 386029998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625625474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13186",
    "droptype": "D",
    "dropname": "ARTESIA",
    "dropdeladd": "11 S FRONT ST",
    "dropdelcty": "ARTESIA",
    "dropdelst": "MS",
    "dropdelzpp": 397369998,
    "dropphyadd": "11 S FRONT ST",
    "dropphycty": "ARTESIA",
    "dropphyst": "MS",
    "dropphyzpp": 397369998,
    "dropmaladd": "11 S FRONT ST",
    "dropmalcty": "ARTESIA",
    "dropmalst": "MS",
    "dropmalzpp": 397369998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622725211,
    "dropfax": 6622725211
  },
  {
    "dcode": "D",
    "dropkey": "PY13187",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "16010 BOUNDARY DR",
    "dropdelcty": "ASHLAND",
    "dropdelst": "MS",
    "dropdelzpp": 386039998,
    "dropphyadd": "16010 BOUNDARY DR",
    "dropphycty": "ASHLAND",
    "dropphyst": "MS",
    "dropphyzpp": 386039998,
    "dropmaladd": "16010 BOUNDARY DR",
    "dropmalcty": "ASHLAND",
    "dropmalst": "MS",
    "dropmalzpp": 386039998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622246242,
    "dropfax": 6622246220
  },
  {
    "dcode": "D",
    "dropkey": "PY13196",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "50 AVON RD N",
    "dropdelcty": "AVON",
    "dropdelst": "MS",
    "dropdelzpp": 387239998,
    "dropphyadd": "50 AVON RD N",
    "dropphycty": "AVON",
    "dropphyst": "MS",
    "dropphyzpp": 387239998,
    "dropmaladd": "50 AVON RD N",
    "dropmalcty": "AVON",
    "dropmalst": "MS",
    "dropmalzpp": 387239998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623354064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13199",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "9032 HIGHWAY 493",
    "dropdelcty": "BAILEY",
    "dropdelst": "MS",
    "dropdelzpp": 393209998,
    "dropphyadd": "9032 HIGHWAY 493",
    "dropphycty": "BAILEY",
    "dropphyst": "MS",
    "dropphyzpp": 393209998,
    "dropmaladd": "9032 HIGHWAY 493",
    "dropmalcty": "BAILEY",
    "dropmalst": "MS",
    "dropmalzpp": 393209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017372785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13201",
    "droptype": "D",
    "dropname": "BALDWYN",
    "dropdeladd": "205 W MAIN ST",
    "dropdelcty": "BALDWYN",
    "dropdelst": "MS",
    "dropdelzpp": 388249998,
    "dropphyadd": "205 W MAIN ST",
    "dropphycty": "BALDWYN",
    "dropphyst": "MS",
    "dropphyzpp": 388249998,
    "dropmaladd": "205 W MAIN ST",
    "dropmalcty": "BALDWYN",
    "dropmalst": "MS",
    "dropmalzpp": 388249998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623652323,
    "dropfax": 6623652435
  },
  {
    "dcode": "D",
    "dropkey": "PY13214",
    "droptype": "D",
    "dropname": "BASSFIELD",
    "dropdeladd": "100 HAWKINS AVE",
    "dropdelcty": "BASSFIELD",
    "dropdelst": "MS",
    "dropdelzpp": 394219998,
    "dropphyadd": "100 HAWKINS AVE",
    "dropphycty": "BASSFIELD",
    "dropphyst": "MS",
    "dropphyzpp": 394219998,
    "dropmaladd": "100 HAWKINS AVE",
    "dropmalcty": "BASSFIELD",
    "dropmalst": "MS",
    "dropmalzpp": 394219998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019435873,
    "dropfax": 6019435655
  },
  {
    "dcode": "D",
    "dropkey": "PY13215",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "375 LAKEWOOD DR",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 386069998,
    "dropphyadd": "375 LAKEWOOD DR",
    "dropphycty": "BATESVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 386069998,
    "dropmaladd": "375 LAKEWOOD DR",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 386069998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6625634001,
    "dropsitcph": 6625634001,
    "dropfax": 6625611771
  },
  {
    "dcode": "D",
    "dropkey": "PY13221",
    "droptype": "D",
    "dropname": "BAY SAINT LOUIS",
    "dropdeladd": "1200 HIGHWAY 90",
    "dropdelcty": "BAY SAINT LOUIS",
    "dropdelst": "MS",
    "dropdelzpp": 395209998,
    "dropphyadd": "1200 HIGHWAY 90",
    "dropphycty": "BAY SAINT LOUIS",
    "dropphyst": "MS",
    "dropphyzpp": 395209998,
    "dropmaladd": "1200 HIGHWAY 90",
    "dropmalcty": "BAY SAINT LOUIS",
    "dropmalst": "MS",
    "dropmalzpp": 395209998,
    "dropsitphn": "",
    "dropsitlph": 2284669043,
    "dropsitcph": 2284677720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13223",
    "droptype": "D",
    "dropname": "BAY SPRINGS",
    "dropdeladd": "14 N THIRD ST",
    "dropdelcty": "BAY SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 394229998,
    "dropphyadd": "14 N THIRD ST",
    "dropphycty": "BAY SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 394229998,
    "dropmaladd": "14 N THIRD ST",
    "dropmalcty": "BAY SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 394229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2282205021,
    "dropsitcph": 6017642235,
    "dropfax": 6017644575
  },
  {
    "dcode": "D",
    "dropkey": "PY13230",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "825 HIGHWAY 198",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "MS",
    "dropdelzpp": 394239998,
    "dropphyadd": "825 HIGHWAY 198",
    "dropphycty": "BEAUMONT",
    "dropphyst": "MS",
    "dropphyzpp": 394239998,
    "dropmaladd": "825 HIGHWAY 198",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "MS",
    "dropmalzpp": 394239998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017846107,
    "dropfax": 6017843327
  },
  {
    "dcode": "D",
    "dropkey": "PY13231",
    "droptype": "D",
    "dropname": "BECKER",
    "dropdeladd": "52188 HIGHWAY 25 S",
    "dropdelcty": "BECKER",
    "dropdelst": "MS",
    "dropdelzpp": 388259998,
    "dropphyadd": "52188 HIGHWAY 25 S",
    "dropphycty": "BECKER",
    "dropphyst": "MS",
    "dropphyzpp": 388259998,
    "dropmaladd": "52188 HIGHWAY 25 S",
    "dropmalcty": "BECKER",
    "dropmalst": "MS",
    "dropmalzpp": 388259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622567577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13234",
    "droptype": "D",
    "dropname": "BELDEN",
    "dropdeladd": "3871 MCCULLOUGH BLVD",
    "dropdelcty": "BELDEN",
    "dropdelst": "MS",
    "dropdelzpp": 388269998,
    "dropphyadd": "3871 MCCULLOUGH BLVD",
    "dropphycty": "BELDEN",
    "dropphyst": "MS",
    "dropphyzpp": 388269998,
    "dropmaladd": "3871 MCCULLOUGH BLVD",
    "dropmalcty": "BELDEN",
    "dropmalst": "MS",
    "dropmalzpp": 388269998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628401917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13238",
    "droptype": "D",
    "dropname": "BELLEFONTAINE",
    "dropdeladd": "1 HIGHWAY 9",
    "dropdelcty": "BELLEFONTAINE",
    "dropdelst": "MS",
    "dropdelzpp": 397379998,
    "dropphyadd": "1 HIGHWAY 9",
    "dropphycty": "BELLEFONTAINE",
    "dropphyst": "MS",
    "dropphyzpp": 397379998,
    "dropmaladd": "1 HIGHWAY 9",
    "dropmalcty": "BELLEFONTAINE",
    "dropmalst": "MS",
    "dropmalzpp": 397379998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622582267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13243",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "363 2ND ST",
    "dropdelcty": "BELMONT",
    "dropdelst": "MS",
    "dropdelzpp": 388279998,
    "dropphyadd": "363 2ND ST",
    "dropphycty": "BELMONT",
    "dropphyst": "MS",
    "dropphyzpp": 388279998,
    "dropmaladd": "363 2ND ST",
    "dropmalcty": "BELMONT",
    "dropmalst": "MS",
    "dropmalzpp": 388279998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6624544104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13244",
    "droptype": "D",
    "dropname": "BELZONI",
    "dropdeladd": "102 CHURCH ST",
    "dropdelcty": "BELZONI",
    "dropdelst": "MS",
    "dropdelzpp": 390389998,
    "dropphyadd": "102 CHURCH ST",
    "dropphycty": "BELZONI",
    "dropphyst": "MS",
    "dropphyzpp": 390389998,
    "dropmaladd": "102 CHURCH ST",
    "dropmalcty": "BELZONI",
    "dropmalst": "MS",
    "dropmalzpp": 390389998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622473636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13246",
    "droptype": "D",
    "dropname": "BENOIT",
    "dropdeladd": "105 PRESTON ST",
    "dropdelcty": "BENOIT",
    "dropdelst": "MS",
    "dropdelzpp": 387259998,
    "dropphyadd": "105 PRESTON ST",
    "dropphycty": "BENOIT",
    "dropphyst": "MS",
    "dropphyzpp": 387259998,
    "dropmaladd": "105 PRESTON ST",
    "dropmalcty": "BENOIT",
    "dropmalst": "MS",
    "dropmalzpp": 387259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627423462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13248",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "1224 OLD HIGHWAY 16",
    "dropdelcty": "BENTON",
    "dropdelst": "MS",
    "dropdelzpp": 390399998,
    "dropphyadd": "1224 OLD HIGHWAY 16",
    "dropphycty": "BENTON",
    "dropphyst": "MS",
    "dropphyzpp": 390399998,
    "dropmaladd": "1224 OLD HIGHWAY 16",
    "dropmalcty": "BENTON",
    "dropmalst": "MS",
    "dropmalzpp": 390399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626739773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13249",
    "droptype": "D",
    "dropname": "BENTONIA",
    "dropdeladd": "219 W RAILROAD AVE",
    "dropdelcty": "BENTONIA",
    "dropdelst": "MS",
    "dropdelzpp": 390409998,
    "dropphyadd": "219 W RAILROAD AVE",
    "dropphycty": "BENTONIA",
    "dropphyst": "MS",
    "dropphyzpp": 390409998,
    "dropmaladd": "219 W RAILROAD AVE",
    "dropmalcty": "BENTONIA",
    "dropmalst": "MS",
    "dropmalzpp": 390409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627552212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13255",
    "droptype": "D",
    "dropname": "BEULAH",
    "dropdeladd": "220 N CLARK ST",
    "dropdelcty": "BEULAH",
    "dropdelst": "MS",
    "dropdelzpp": 387269998,
    "dropphyadd": "220 N CLARK ST",
    "dropphycty": "BEULAH",
    "dropphyst": "MS",
    "dropphyzpp": 387269998,
    "dropmaladd": "220 N CLARK ST",
    "dropmalcty": "BEULAH",
    "dropmalst": "MS",
    "dropmalzpp": 387269998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627596780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13257",
    "droptype": "D",
    "dropname": "BIG CREEK",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "BIG CREEK",
    "dropdelst": "MS",
    "dropdelzpp": 389149998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "BIG CREEK",
    "dropphyst": "MS",
    "dropphyzpp": 389149998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "BIG CREEK",
    "dropmalst": "MS",
    "dropmalzpp": 389149998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626288411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13265",
    "droptype": "D",
    "dropname": "BILOXI",
    "dropdeladd": "135 MAIN ST",
    "dropdelcty": "BILOXI",
    "dropdelst": "MS",
    "dropdelzpp": 395309998,
    "dropphyadd": "135 MAIN ST",
    "dropphycty": "BILOXI",
    "dropphyst": "MS",
    "dropphyzpp": 395309998,
    "dropmaladd": "135 MAIN ST",
    "dropmalcty": "BILOXI",
    "dropmalst": "MS",
    "dropmalzpp": 395309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2283744103,
    "dropsitcph": 2283746386,
    "dropfax": 2284352485
  },
  {
    "dcode": "D",
    "dropkey": "PY13282",
    "droptype": "D",
    "dropname": "BLUE MOUNTAIN",
    "dropdeladd": "120 N GUYTON BLVD",
    "dropdelcty": "BLUE MOUNTAIN",
    "dropdelst": "MS",
    "dropdelzpp": 386109998,
    "dropphyadd": "120 N GUYTON BLVD",
    "dropphycty": "BLUE MOUNTAIN",
    "dropphyst": "MS",
    "dropphyzpp": 386109998,
    "dropmaladd": "120 N GUYTON BLVD",
    "dropmalcty": "BLUE MOUNTAIN",
    "dropmalst": "MS",
    "dropmalzpp": 386109998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626854244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13285",
    "droptype": "D",
    "dropname": "BLUE SPRINGS",
    "dropdeladd": "1146 HIGHWAY 9 S",
    "dropdelcty": "BLUE SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 388289998,
    "dropphyadd": "1146 HIGHWAY 9 S",
    "dropphycty": "BLUE SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 388289998,
    "dropmaladd": "1146 HIGHWAY 9 S",
    "dropmalcty": "BLUE SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 388289998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625342363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13289",
    "droptype": "D",
    "dropname": "BOGUE CHITTO",
    "dropdeladd": "409 MONTICELLO ST",
    "dropdelcty": "BOGUE CHITTO",
    "dropdelst": "MS",
    "dropdelzpp": 396299998,
    "dropphyadd": "409 MONTICELLO ST",
    "dropphycty": "BOGUE CHITTO",
    "dropphyst": "MS",
    "dropphyzpp": 396299998,
    "dropmaladd": "409 MONTICELLO ST",
    "dropmalcty": "BOGUE CHITTO",
    "dropmalst": "MS",
    "dropmalzpp": 396299998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017342214,
    "dropfax": 6017346748
  },
  {
    "dcode": "D",
    "dropkey": "PY13292",
    "droptype": "D",
    "dropname": "BOLTON",
    "dropdeladd": "300 W MADISON ST",
    "dropdelcty": "BOLTON",
    "dropdelst": "MS",
    "dropdelzpp": 390419998,
    "dropphyadd": "300 W MADISON ST",
    "dropphycty": "BOLTON",
    "dropphyst": "MS",
    "dropphyzpp": 390419998,
    "dropmaladd": "300 W MADISON ST",
    "dropmalcty": "BOLTON",
    "dropmalst": "MS",
    "dropmalzpp": 390419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018662485,
    "dropsitcph": 6018667590,
    "dropfax": 6018669385
  },
  {
    "dcode": "D",
    "dropkey": "PY13294",
    "droptype": "D",
    "dropname": "BOONEVILLE",
    "dropdeladd": "515 N 2ND ST",
    "dropdelcty": "BOONEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 388299998,
    "dropphyadd": "515 N 2ND ST",
    "dropphycty": "BOONEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 388299998,
    "dropmaladd": "515 N 2ND ST",
    "dropmalcty": "BOONEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 388299998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627289267,
    "dropsitcph": 6627285470,
    "dropfax": 6627287966
  },
  {
    "dcode": "D",
    "dropkey": "PY13300",
    "droptype": "D",
    "dropname": "BOYLE",
    "dropdeladd": "123 T M JONES HWY",
    "dropdelcty": "BOYLE",
    "dropdelst": "MS",
    "dropdelzpp": 387309998,
    "dropphyadd": "123 T M JONES HWY",
    "dropphycty": "BOYLE",
    "dropphyst": "MS",
    "dropphyzpp": 387309998,
    "dropmaladd": "123 T M JONES HWY",
    "dropmalcty": "BOYLE",
    "dropmalst": "MS",
    "dropmalzpp": 387309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628433360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13303",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "1252 W GOVERNMENT ST",
    "dropdelcty": "BRANDON",
    "dropdelst": "MS",
    "dropdelzpp": 390429998,
    "dropphyadd": "1252 W GOVERNMENT ST",
    "dropphycty": "BRANDON",
    "dropphyst": "MS",
    "dropphyzpp": 390429998,
    "dropmaladd": "1252 W GOVERNMENT ST",
    "dropmalcty": "BRANDON",
    "dropmalst": "MS",
    "dropmalzpp": 390429998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018258848,
    "dropsitcph": 6018250564,
    "dropfax": 6018244248
  },
  {
    "dcode": "D",
    "dropkey": "PY13306",
    "droptype": "D",
    "dropname": "BRAXTON",
    "dropdeladd": "120 W MAIN ST",
    "dropdelcty": "BRAXTON",
    "dropdelst": "MS",
    "dropdelzpp": 390449998,
    "dropphyadd": "120 W MAIN ST",
    "dropphycty": "BRAXTON",
    "dropphyst": "MS",
    "dropphyzpp": 390449998,
    "dropmaladd": "120 W MAIN ST",
    "dropmalcty": "BRAXTON",
    "dropmalst": "MS",
    "dropmalzpp": 390449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018471126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13314",
    "droptype": "D",
    "dropname": "BROOKHAVEN",
    "dropdeladd": "201 W CHEROKEE ST",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "MS",
    "dropdelzpp": 396019998,
    "dropphyadd": "201 W CHEROKEE ST",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "MS",
    "dropphyzpp": 396019998,
    "dropmaladd": "201 W CHEROKEE ST",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "MS",
    "dropmalzpp": 396019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018336144,
    "dropsitcph": 6018333461,
    "dropfax": 6018353042
  },
  {
    "dcode": "D",
    "dropkey": "PY13316",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "132 MAIN AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "MS",
    "dropdelzpp": 394259998,
    "dropphyadd": "132 MAIN AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "MS",
    "dropphyzpp": 394259998,
    "dropmaladd": "132 MAIN AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "MS",
    "dropmalzpp": 394259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015846926,
    "dropfax": 6015846926
  },
  {
    "dcode": "D",
    "dropkey": "PY13318",
    "droptype": "D",
    "dropname": "BROOKSVILLE",
    "dropdeladd": "11 DEPOT ST",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 397395205,
    "dropphyadd": "11 DEPOT ST",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 397395205,
    "dropmaladd": "11 DEPOT ST",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 397395205,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627385890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13322",
    "droptype": "D",
    "dropname": "BRUCE",
    "dropdeladd": "309 N NEWBURGER AVE",
    "dropdelcty": "BRUCE",
    "dropdelst": "MS",
    "dropdelzpp": 389159998,
    "dropphyadd": "309 N NEWBURGER AVE",
    "dropphycty": "BRUCE",
    "dropphyst": "MS",
    "dropphyzpp": 389159998,
    "dropmaladd": "309 N NEWBURGER AVE",
    "dropmalcty": "BRUCE",
    "dropmalst": "MS",
    "dropmalzpp": 389159998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6629834060,
    "dropfax": 6629834043
  },
  {
    "dcode": "D",
    "dropkey": "PY13324",
    "droptype": "D",
    "dropname": "BUCKATUNNA",
    "dropdeladd": "2360 BUCKATUNNA CHICORA CLARA RD",
    "dropdelcty": "BUCKATUNNA",
    "dropdelst": "MS",
    "dropdelzpp": 393229998,
    "dropphyadd": "2360 BUCKATUNNA CHICORA CLARA RD",
    "dropphycty": "BUCKATUNNA",
    "dropphyst": "MS",
    "dropphyzpp": 393229998,
    "dropmaladd": "2360 BUCKATUNNA CHICORA CLARA RD",
    "dropmalcty": "BUCKATUNNA",
    "dropmalst": "MS",
    "dropmalzpp": 393229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016482231,
    "dropfax": 6016482326
  },
  {
    "dcode": "D",
    "dropkey": "PY13326",
    "droptype": "D",
    "dropname": "BUDE",
    "dropdeladd": "106 MAIN ST N",
    "dropdelcty": "BUDE",
    "dropdelst": "MS",
    "dropdelzpp": 396309998,
    "dropphyadd": "106 MAIN ST N",
    "dropphycty": "BUDE",
    "dropphyst": "MS",
    "dropphyzpp": 396309998,
    "dropmaladd": "106 MAIN ST N",
    "dropmalcty": "BUDE",
    "dropmalst": "MS",
    "dropmalzpp": 396309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013842663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13331",
    "droptype": "D",
    "dropname": "BURNSVILLE",
    "dropdeladd": "318 HIGHWAY 72",
    "dropdelcty": "BURNSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 388339998,
    "dropphyadd": "318 HIGHWAY 72",
    "dropphycty": "BURNSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 388339998,
    "dropmaladd": "318 HIGHWAY 72",
    "dropmalcty": "BURNSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 388339998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624279237,
    "dropfax": 6624279237
  },
  {
    "dcode": "D",
    "dropkey": "PY13338",
    "droptype": "D",
    "dropname": "BYHALIA",
    "dropdeladd": "8140 HIGHWAY 178",
    "dropdelcty": "BYHALIA",
    "dropdelst": "MS",
    "dropdelzpp": 386119998,
    "dropphyadd": "8140 HIGHWAY 178",
    "dropphycty": "BYHALIA",
    "dropphyst": "MS",
    "dropphyzpp": 386119998,
    "dropmaladd": "8140 HIGHWAY 178",
    "dropmalcty": "BYHALIA",
    "dropmalst": "MS",
    "dropmalzpp": 386119998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628382400,
    "dropfax": 6628388001
  },
  {
    "dcode": "D",
    "dropkey": "PY13347",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "650 MAIN ST",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "MS",
    "dropdelzpp": 397409998,
    "dropphyadd": "650 MAIN ST",
    "dropphycty": "CALEDONIA",
    "dropphyst": "MS",
    "dropphyzpp": 397409998,
    "dropmaladd": "650 MAIN ST",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "MS",
    "dropmalzpp": 397409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623566497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13349",
    "droptype": "D",
    "dropname": "CALHOUN CITY",
    "dropdeladd": "205 N MAIN ST",
    "dropdelcty": "CALHOUN CITY",
    "dropdelst": "MS",
    "dropdelzpp": 389169998,
    "dropphyadd": "205 N MAIN ST",
    "dropphycty": "CALHOUN CITY",
    "dropphyst": "MS",
    "dropphyzpp": 389169998,
    "dropmaladd": "205 N MAIN ST",
    "dropmalcty": "CALHOUN CITY",
    "dropmalst": "MS",
    "dropmalzpp": 389169998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626286372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13352",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "2124 HIGHWAY 17",
    "dropdelcty": "CAMDEN",
    "dropdelst": "MS",
    "dropdelzpp": 390459998,
    "dropphyadd": "2124 HIGHWAY 17",
    "dropphycty": "CAMDEN",
    "dropphyst": "MS",
    "dropphyzpp": 390459998,
    "dropmaladd": "2124 HIGHWAY 17",
    "dropmalcty": "CAMDEN",
    "dropmalst": "MS",
    "dropmalzpp": 390459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624682798,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13360",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "150 S UNION ST",
    "dropdelcty": "CANTON",
    "dropdelst": "MS",
    "dropdelzpp": 390469998,
    "dropphyadd": "150 S UNION ST",
    "dropphycty": "CANTON",
    "dropphyst": "MS",
    "dropphyzpp": 390469998,
    "dropmaladd": "150 S UNION ST",
    "dropmalcty": "CANTON",
    "dropmalst": "MS",
    "dropmalzpp": 390469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018594909,
    "dropsitcph": 6018557245,
    "dropfax": 6018590824
  },
  {
    "dcode": "D",
    "dropkey": "PY13367",
    "droptype": "D",
    "dropname": "CARRIERE",
    "dropdeladd": "7390 HIGHWAY 11",
    "dropdelcty": "CARRIERE",
    "dropdelst": "MS",
    "dropdelzpp": 394269998,
    "dropphyadd": "7390 HIGHWAY 11",
    "dropphycty": "CARRIERE",
    "dropphyst": "MS",
    "dropphyzpp": 394269998,
    "dropmaladd": "7390 HIGHWAY 11",
    "dropmalcty": "CARRIERE",
    "dropmalst": "MS",
    "dropmalzpp": 394269998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2272716822,
    "dropsitcph": 6017987452,
    "dropfax": 6017990269
  },
  {
    "dcode": "D",
    "dropkey": "PY13368",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "104 W JACKSON ST",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "MS",
    "dropdelzpp": 389179998,
    "dropphyadd": "104 W JACKSON ST",
    "dropphycty": "CARROLLTON",
    "dropphyst": "MS",
    "dropphyzpp": 389179998,
    "dropmaladd": "104 W JACKSON ST",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "MS",
    "dropmalzpp": 389179998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622376906,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13371",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "4963 HIGHWAY 42",
    "dropdelcty": "CARSON",
    "dropdelst": "MS",
    "dropdelzpp": 394279998,
    "dropphyadd": "4963 HIGHWAY 42",
    "dropphycty": "CARSON",
    "dropphyst": "MS",
    "dropphyzpp": 394279998,
    "dropmaladd": "4963 HIGHWAY 42",
    "dropmalcty": "CARSON",
    "dropmalst": "MS",
    "dropmalzpp": 394279998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019436271,
    "dropfax": 6019436271
  },
  {
    "dcode": "D",
    "dropkey": "PY13373",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "201 N PEARL ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "MS",
    "dropdelzpp": 390519998,
    "dropphyadd": "201 N PEARL ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "MS",
    "dropphyzpp": 390519998,
    "dropmaladd": "201 N PEARL ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "MS",
    "dropmalzpp": 390519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6012678226,
    "dropsitcph": 6012679271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13374",
    "droptype": "D",
    "dropname": "CARY",
    "dropdeladd": "95 DOGWOOD ST",
    "dropdelcty": "CARY",
    "dropdelst": "MS",
    "dropdelzpp": 390549998,
    "dropphyadd": "95 DOGWOOD ST",
    "dropphycty": "CARY",
    "dropphyst": "MS",
    "dropphyzpp": 390549998,
    "dropmaladd": "95 DOGWOOD ST",
    "dropmalcty": "CARY",
    "dropmalst": "MS",
    "dropmalzpp": 390549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628732548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13375",
    "droptype": "D",
    "dropname": "CASCILLA",
    "dropdeladd": "617 WHITTEN RD",
    "dropdelcty": "CASCILLA",
    "dropdelst": "MS",
    "dropdelzpp": 389209998,
    "dropphyadd": "617 WHITTEN RD",
    "dropphycty": "CASCILLA",
    "dropphyst": "MS",
    "dropphyzpp": 389209998,
    "dropmaladd": "617 WHITTEN RD",
    "dropmalcty": "CASCILLA",
    "dropmalst": "MS",
    "dropmalzpp": 389209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626473466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13378",
    "droptype": "D",
    "dropname": "CEDARBLUFF",
    "dropdeladd": "15363 HIGHWAY 50 W",
    "dropdelcty": "CEDARBLUFF",
    "dropdelst": "MS",
    "dropdelzpp": 397419998,
    "dropphyadd": "15363 HIGHWAY 50 W",
    "dropphycty": "CEDARBLUFF",
    "dropphyst": "MS",
    "dropphyzpp": 397419998,
    "dropmaladd": "15363 HIGHWAY 50 W",
    "dropmalcty": "CEDARBLUFF",
    "dropmalst": "MS",
    "dropmalzpp": 397419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624942458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13381",
    "droptype": "D",
    "dropname": "CENTREVILLE",
    "dropdeladd": "310 E MAIN ST",
    "dropdelcty": "CENTREVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 396319998,
    "dropphyadd": "310 E MAIN ST",
    "dropphycty": "CENTREVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 396319998,
    "dropmaladd": "310 E MAIN ST",
    "dropmalcty": "CENTREVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 396319998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016455055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13386",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "3 N SQUARE ST STE 1",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "MS",
    "dropdelzpp": 389219998,
    "dropphyadd": "3 N SQUARE ST STE 1",
    "dropphycty": "CHARLESTON",
    "dropphyst": "MS",
    "dropphyzpp": 389219998,
    "dropmaladd": "3 N SQUARE ST STE 1",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "MS",
    "dropmalzpp": 389219998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626472164,
    "dropfax": 6626473950
  },
  {
    "dcode": "D",
    "dropkey": "PY13399",
    "droptype": "D",
    "dropname": "CHUNKY",
    "dropdeladd": "23926 HIGHWAY 80",
    "dropdelcty": "CHUNKY",
    "dropdelst": "MS",
    "dropdelzpp": 393239998,
    "dropphyadd": "23926 HIGHWAY 80",
    "dropphycty": "CHUNKY",
    "dropphyst": "MS",
    "dropphyzpp": 393239998,
    "dropmaladd": "23926 HIGHWAY 80",
    "dropmalcty": "CHUNKY",
    "dropmalst": "MS",
    "dropmalzpp": 393239998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016558569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13403",
    "droptype": "D",
    "dropname": "CLARA",
    "dropdeladd": "21 CLARA SCHOOL RD",
    "dropdelcty": "CLARA",
    "dropdelst": "MS",
    "dropdelzpp": 393249998,
    "dropphyadd": "21 CLARA SCHOOL RD",
    "dropphycty": "CLARA",
    "dropphyst": "MS",
    "dropphyzpp": 393249998,
    "dropmaladd": "21 CLARA SCHOOL RD",
    "dropmalcty": "CLARA",
    "dropmalst": "MS",
    "dropmalzpp": 393249998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017352768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13404",
    "droptype": "D",
    "dropname": "CLARKSDALE",
    "dropdeladd": "236 SHARKEY AVE RM 100",
    "dropdelcty": "CLARKSDALE",
    "dropdelst": "MS",
    "dropdelzpp": 386149998,
    "dropphyadd": "236 SHARKEY AVE RM 100",
    "dropphycty": "CLARKSDALE",
    "dropphyst": "MS",
    "dropphyzpp": 386149998,
    "dropmaladd": "236 SHARKEY AVE RM 100",
    "dropmalcty": "CLARKSDALE",
    "dropmalst": "MS",
    "dropmalzpp": 386149998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6626277834,
    "dropsitcph": 6626277834,
    "dropfax": 6626211448
  },
  {
    "dcode": "D",
    "dropkey": "PY13410",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "210 S CHRISMAN AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "MS",
    "dropdelzpp": 387329998,
    "dropphyadd": "210 S CHRISMAN AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "MS",
    "dropphyzpp": 387329998,
    "dropmaladd": "210 S CHRISMAN AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "MS",
    "dropmalzpp": 387329998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628434031,
    "dropfax": 6628460498
  },
  {
    "dcode": "D",
    "dropkey": "PY13414",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "100 E LAWSON ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "MS",
    "dropdelzpp": 390569998,
    "dropphyadd": "100 E LAWSON ST",
    "dropphycty": "CLINTON",
    "dropphyst": "MS",
    "dropphyzpp": 390569998,
    "dropmaladd": "100 E LAWSON ST",
    "dropmalcty": "CLINTON",
    "dropmalst": "MS",
    "dropmalzpp": 390569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019250574,
    "dropsitcph": 6019255049,
    "dropfax": 6019259219
  },
  {
    "dcode": "D",
    "dropkey": "PY13416",
    "droptype": "D",
    "dropname": "COAHOMA",
    "dropdeladd": "100 W WALNUT ST",
    "dropdelcty": "COAHOMA",
    "dropdelst": "MS",
    "dropdelzpp": 386179998,
    "dropphyadd": "100 W WALNUT ST",
    "dropphycty": "COAHOMA",
    "dropphyst": "MS",
    "dropphyzpp": 386179998,
    "dropmaladd": "100 W WALNUT ST",
    "dropmalcty": "COAHOMA",
    "dropmalst": "MS",
    "dropmalzpp": 386179998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623372772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13418",
    "droptype": "D",
    "dropname": "COFFEEVILLE",
    "dropdeladd": "47 OAK ST",
    "dropdelcty": "COFFEEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 389229998,
    "dropphyadd": "47 OAK ST",
    "dropphycty": "COFFEEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 389229998,
    "dropmaladd": "47 OAK ST",
    "dropmalcty": "COFFEEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 389229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626752630,
    "dropfax": 6626752158
  },
  {
    "dcode": "D",
    "dropkey": "PY13421",
    "droptype": "D",
    "dropname": "COILA",
    "dropdeladd": "17731 MS HIGHWAY 17",
    "dropdelcty": "COILA",
    "dropdelst": "MS",
    "dropdelzpp": 389239998,
    "dropphyadd": "17731 MS HIGHWAY 17",
    "dropphycty": "COILA",
    "dropphyst": "MS",
    "dropphyzpp": 389239998,
    "dropmaladd": "17731 MS HIGHWAY 17",
    "dropmalcty": "COILA",
    "dropmalst": "MS",
    "dropmalzpp": 389239998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622376689,
    "dropfax": 6622376689
  },
  {
    "dcode": "D",
    "dropkey": "PY13422",
    "droptype": "D",
    "dropname": "COLDWATER",
    "dropdeladd": "686 2ND ST",
    "dropdelcty": "COLDWATER",
    "dropdelst": "MS",
    "dropdelzpp": 386189998,
    "dropphyadd": "686 2ND ST",
    "dropphycty": "COLDWATER",
    "dropphyst": "MS",
    "dropphyzpp": 386189998,
    "dropmaladd": "686 2ND ST",
    "dropmalcty": "COLDWATER",
    "dropmalst": "MS",
    "dropmalzpp": 386189998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6626227404,
    "dropsitcph": 6626227451,
    "dropfax": 6626225413
  },
  {
    "dcode": "D",
    "dropkey": "PY13425",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "304 S DOGWOOD AVE",
    "dropdelcty": "COLLINS",
    "dropdelst": "MS",
    "dropdelzpp": 394289998,
    "dropphyadd": "304 S DOGWOOD AVE",
    "dropphycty": "COLLINS",
    "dropphyst": "MS",
    "dropphyzpp": 394289998,
    "dropmaladd": "304 S DOGWOOD AVE",
    "dropmalcty": "COLLINS",
    "dropmalst": "MS",
    "dropmalzpp": 394289998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017654281,
    "dropfax": 6017654281
  },
  {
    "dcode": "D",
    "dropkey": "PY13426",
    "droptype": "D",
    "dropname": "COLLINSVILLE",
    "dropdeladd": "9061 COLLINSVILLE RD",
    "dropdelcty": "COLLINSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 393259998,
    "dropphyadd": "9061 COLLINSVILLE RD",
    "dropphycty": "COLLINSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 393259998,
    "dropmaladd": "9061 COLLINSVILLE RD",
    "dropmalcty": "COLLINSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 393259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016268190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13431",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "815 MAIN ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MS",
    "dropdelzpp": 394299998,
    "dropphyadd": "815 MAIN ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MS",
    "dropphyzpp": 394299998,
    "dropmaladd": "815 MAIN ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MS",
    "dropmalzpp": 394299998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017364653,
    "dropfax": 6017364195
  },
  {
    "dcode": "D",
    "dropkey": "PY13433",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "3202 BLUECUTT RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MS",
    "dropdelzpp": 397059998,
    "dropphyadd": "3202 BLUECUTT RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MS",
    "dropphyzpp": 397051311,
    "dropmaladd": "3202 BLUECUTT RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MS",
    "dropmalzpp": 397051311,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623282313,
    "dropsitcph": 6622450247,
    "dropfax": 6623281502
  },
  {
    "dcode": "D",
    "dropkey": "PY13439",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "209 N MAIN ST",
    "dropdelcty": "COMO",
    "dropdelst": "MS",
    "dropdelzpp": 386199998,
    "dropphyadd": "209 N MAIN ST",
    "dropphycty": "COMO",
    "dropphyst": "MS",
    "dropphyzpp": 386199998,
    "dropmaladd": "209 N MAIN ST",
    "dropmalcty": "COMO",
    "dropmalst": "MS",
    "dropmalzpp": 386199998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625265108,
    "dropfax": 6625265689
  },
  {
    "dcode": "D",
    "dropkey": "PY13440",
    "droptype": "D",
    "dropname": "CONEHATTA",
    "dropdeladd": "8396 HIGHWAY 489",
    "dropdelcty": "CONEHATTA",
    "dropdelst": "MS",
    "dropdelzpp": 390579998,
    "dropphyadd": "8396 HIGHWAY 489",
    "dropphycty": "CONEHATTA",
    "dropphyst": "MS",
    "dropphyzpp": 390579998,
    "dropmaladd": "8396 HIGHWAY 489",
    "dropmalcty": "CONEHATTA",
    "dropmalst": "MS",
    "dropmalzpp": 390579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017753649,
    "dropfax": 6017753649
  },
  {
    "dcode": "D",
    "dropkey": "PY13441",
    "droptype": "D",
    "dropname": "CORINTH",
    "dropdeladd": "500 N MADISON ST",
    "dropdelcty": "CORINTH",
    "dropdelst": "MS",
    "dropdelzpp": 388349998,
    "dropphyadd": "500 N MADISON ST",
    "dropphycty": "CORINTH",
    "dropphyst": "MS",
    "dropphyzpp": 388349998,
    "dropmaladd": "500 N MADISON ST",
    "dropmalcty": "CORINTH",
    "dropmalst": "MS",
    "dropmalzpp": 388349998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622871412,
    "dropsitcph": 6622871411,
    "dropfax": 6622878505
  },
  {
    "dcode": "D",
    "dropkey": "PY13446",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "252 OLD HIGHWAY 51",
    "dropdelcty": "COURTLAND",
    "dropdelst": "MS",
    "dropdelzpp": 386209998,
    "dropphyadd": "252 OLD HIGHWAY 51",
    "dropphycty": "COURTLAND",
    "dropphyst": "MS",
    "dropphyzpp": 386209998,
    "dropmaladd": "252 OLD HIGHWAY 51",
    "dropmalcty": "COURTLAND",
    "dropmalst": "MS",
    "dropmalzpp": 386209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625637243,
    "dropfax": 6625610280
  },
  {
    "dcode": "D",
    "dropkey": "PY13451",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "290 MAIN ST",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "MS",
    "dropdelzpp": 397439998,
    "dropphyadd": "290 MAIN ST",
    "dropphycty": "CRAWFORD",
    "dropphyst": "MS",
    "dropphyzpp": 397439998,
    "dropmaladd": "290 MAIN ST",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "MS",
    "dropmalzpp": 397439998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622725171,
    "dropfax": 6622728382
  },
  {
    "dcode": "D",
    "dropkey": "PY13452",
    "droptype": "D",
    "dropname": "CRENSHAW",
    "dropdeladd": "609 BROAD ST",
    "dropdelcty": "CRENSHAW",
    "dropdelst": "MS",
    "dropdelzpp": 386219998,
    "dropphyadd": "609 BROAD ST",
    "dropphycty": "CRENSHAW",
    "dropphyst": "MS",
    "dropphyzpp": 386219998,
    "dropmaladd": "609 BROAD ST",
    "dropmalcty": "CRENSHAW",
    "dropmalst": "MS",
    "dropmalzpp": 386219998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623825211,
    "dropfax": 6623825949
  },
  {
    "dcode": "D",
    "dropkey": "PY13454",
    "droptype": "D",
    "dropname": "CROSBY",
    "dropdeladd": "136 W PINE ST",
    "dropdelcty": "CROSBY",
    "dropdelst": "MS",
    "dropdelzpp": 396339998,
    "dropphyadd": "136 W PINE ST",
    "dropphycty": "CROSBY",
    "dropphyst": "MS",
    "dropphyzpp": 396339998,
    "dropmaladd": "136 W PINE ST",
    "dropmalcty": "CROSBY",
    "dropmalst": "MS",
    "dropmalzpp": 396339998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016394355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13459",
    "droptype": "D",
    "dropname": "CROWDER",
    "dropdeladd": "131A 3RD ST",
    "dropdelcty": "CROWDER",
    "dropdelst": "MS",
    "dropdelzpp": 386229998,
    "dropphyadd": "131A 3RD ST",
    "dropphycty": "CROWDER",
    "dropphyst": "MS",
    "dropphyzpp": 386229998,
    "dropmaladd": "131A 3RD ST",
    "dropmalcty": "CROWDER",
    "dropmalst": "MS",
    "dropmalzpp": 386229998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623264762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13460",
    "droptype": "D",
    "dropname": "CRUGER",
    "dropdeladd": "283 RAILROAD ST",
    "dropdelcty": "CRUGER",
    "dropdelst": "MS",
    "dropdelzpp": 389249998,
    "dropphyadd": "283 RAILROAD ST",
    "dropphycty": "CRUGER",
    "dropphyst": "MS",
    "dropphyzpp": 389249998,
    "dropmaladd": "283 RAILROAD ST",
    "dropmalcty": "CRUGER",
    "dropmalst": "MS",
    "dropmalzpp": 389249998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624552289,
    "dropfax": 6624556995
  },
  {
    "dcode": "D",
    "dropkey": "PY13462",
    "droptype": "D",
    "dropname": "CRYSTAL SPRINGS",
    "dropdeladd": "301 E MARION AVE",
    "dropdelcty": "CRYSTAL SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 390599998,
    "dropphyadd": "301 E MARION AVE",
    "dropphycty": "CRYSTAL SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 390599998,
    "dropmaladd": "301 E MARION AVE",
    "dropmalcty": "CRYSTAL SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 390599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018921208,
    "dropsitcph": 6018921191,
    "dropfax": 6018926016
  },
  {
    "dcode": "D",
    "dropkey": "PY13470",
    "droptype": "D",
    "dropname": "D LO",
    "dropdeladd": "2135 SIMPSON HIGHWAY 149",
    "dropdelcty": "D LO",
    "dropdelst": "MS",
    "dropdelzpp": 390629998,
    "dropphyadd": "2135 SIMPSON HIGHWAY 149",
    "dropphycty": "D LO",
    "dropphyst": "MS",
    "dropphyzpp": 390629998,
    "dropmaladd": "2135 SIMPSON HIGHWAY 149",
    "dropmalcty": "D LO",
    "dropmalst": "MS",
    "dropmalzpp": 390629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018474151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13475",
    "droptype": "D",
    "dropname": "DALEVILLE",
    "dropdeladd": "11039 HIGHWAY 39 N",
    "dropdelcty": "DALEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 393269998,
    "dropphyadd": "11039 HIGHWAY 39 N",
    "dropphycty": "DALEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 393269998,
    "dropmaladd": "11039 HIGHWAY 39 N",
    "dropmalcty": "DALEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 393269998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016818210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13480",
    "droptype": "D",
    "dropname": "DARLING",
    "dropdeladd": "580 DARLING RD",
    "dropdelcty": "DARLING",
    "dropdelst": "MS",
    "dropdelzpp": 386239998,
    "dropphyadd": "580 DARLING RD",
    "dropphycty": "DARLING",
    "dropphyst": "MS",
    "dropphyzpp": 386239998,
    "dropmaladd": "580 DARLING RD",
    "dropmalcty": "DARLING",
    "dropmalst": "MS",
    "dropmalzpp": 386239998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623268408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13485",
    "droptype": "D",
    "dropname": "DE KALB",
    "dropdeladd": "147 VETERAN ST",
    "dropdelcty": "DE KALB",
    "dropdelst": "MS",
    "dropdelzpp": 393289998,
    "dropphyadd": "147 VETERAN ST",
    "dropphycty": "DE KALB",
    "dropphyst": "MS",
    "dropphyzpp": 393289998,
    "dropmaladd": "147 VETERAN ST",
    "dropmalcty": "DE KALB",
    "dropmalst": "MS",
    "dropmalzpp": 393289998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017435101,
    "dropfax": 6017434943
  },
  {
    "dcode": "D",
    "dropkey": "PY13486",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "75 FOURTH AVE",
    "dropdelcty": "DECATUR",
    "dropdelst": "MS",
    "dropdelzpp": 393279998,
    "dropphyadd": "75 FOURTH AVE",
    "dropphycty": "DECATUR",
    "dropphyst": "MS",
    "dropphyzpp": 393279998,
    "dropmaladd": "75 FOURTH AVE",
    "dropmalcty": "DECATUR",
    "dropmalst": "MS",
    "dropmalzpp": 393279998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016352050,
    "dropfax": 6016352050
  },
  {
    "dcode": "D",
    "dropkey": "PY13490",
    "droptype": "D",
    "dropname": "DELTA CITY",
    "dropdeladd": "17 RITCHEY RD",
    "dropdelcty": "DELTA CITY",
    "dropdelst": "MS",
    "dropdelzpp": 390619998,
    "dropphyadd": "17 RITCHEY RD",
    "dropphycty": "DELTA CITY",
    "dropphyst": "MS",
    "dropphyzpp": 390619998,
    "dropmaladd": "17 RITCHEY RD",
    "dropmalcty": "DELTA CITY",
    "dropmalst": "MS",
    "dropmalzpp": 390619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018736655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13499",
    "droptype": "D",
    "dropname": "DENNIS",
    "dropdeladd": "744 HIGHWAY 4",
    "dropdelcty": "DENNIS",
    "dropdelst": "MS",
    "dropdelzpp": 388389998,
    "dropphyadd": "744 HIGHWAY 4",
    "dropphycty": "DENNIS",
    "dropphyst": "MS",
    "dropphyzpp": 388389998,
    "dropmaladd": "744 HIGHWAY 4",
    "dropmalcty": "DENNIS",
    "dropmalst": "MS",
    "dropmalzpp": 388389998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6624543559,
    "dropsitcph": 6624547209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13505",
    "droptype": "D",
    "dropname": "DERMA",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "DERMA",
    "dropdelst": "MS",
    "dropdelzpp": 388399998,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "DERMA",
    "dropphyst": "MS",
    "dropphyzpp": 388399998,
    "dropmaladd": "115 S MAIN ST",
    "dropmalcty": "DERMA",
    "dropmalst": "MS",
    "dropmalzpp": 388399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626285333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13511",
    "droptype": "D",
    "dropname": "DODDSVILLE",
    "dropdeladd": "110 5TH AVE",
    "dropdelcty": "DODDSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387369998,
    "dropphyadd": "110 5TH AVE",
    "dropphycty": "DODDSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387369998,
    "dropmaladd": "110 5TH AVE",
    "dropmalcty": "DODDSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387369998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627562673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13525",
    "droptype": "D",
    "dropname": "DREW",
    "dropdeladd": "146 W PARK AVE",
    "dropdelcty": "DREW",
    "dropdelst": "MS",
    "dropdelzpp": 387379998,
    "dropphyadd": "146 W PARK AVE",
    "dropphycty": "DREW",
    "dropphyst": "MS",
    "dropphyzpp": 387379998,
    "dropmaladd": "146 W PARK AVE",
    "dropmalcty": "DREW",
    "dropmalst": "MS",
    "dropmalzpp": 387379998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627458503,
    "dropfax": 6017458503
  },
  {
    "dcode": "D",
    "dropkey": "PY13529",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "310 SAINT PATRICK RD",
    "dropdelcty": "DUBLIN",
    "dropdelst": "MS",
    "dropdelzpp": 387399998,
    "dropphyadd": "310 SAINT PATRICK RD",
    "dropphycty": "DUBLIN",
    "dropphyst": "MS",
    "dropphyzpp": 387399998,
    "dropmaladd": "310 SAINT PATRICK RD",
    "dropmalcty": "DUBLIN",
    "dropmalst": "MS",
    "dropmalzpp": 387399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626245423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13530",
    "droptype": "D",
    "dropname": "DUCK HILL",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "DUCK HILL",
    "dropdelst": "MS",
    "dropdelzpp": 389259998,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "DUCK HILL",
    "dropphyst": "MS",
    "dropphyzpp": 389259998,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "DUCK HILL",
    "dropmalst": "MS",
    "dropmalzpp": 389259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625652480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13532",
    "droptype": "D",
    "dropname": "DUMAS",
    "dropdeladd": "3481A HIGHWAY 370",
    "dropdelcty": "DUMAS",
    "dropdelst": "MS",
    "dropdelzpp": 386259998,
    "dropphyadd": "3481A HIGHWAY 370",
    "dropphycty": "DUMAS",
    "dropphyst": "MS",
    "dropphyzpp": 386259998,
    "dropmaladd": "3481A HIGHWAY 370",
    "dropmalcty": "DUMAS",
    "dropmalst": "MS",
    "dropmalzpp": 386259998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628378595,
    "dropfax": 6628377340
  },
  {
    "dcode": "D",
    "dropkey": "PY13533",
    "droptype": "D",
    "dropname": "DUNCAN",
    "dropdeladd": "112 E MAIN ST",
    "dropdelcty": "DUNCAN",
    "dropdelst": "MS",
    "dropdelzpp": 387409998,
    "dropphyadd": "112 E MAIN ST",
    "dropphycty": "DUNCAN",
    "dropphyst": "MS",
    "dropphyzpp": 387409998,
    "dropmaladd": "112 E MAIN ST",
    "dropmalcty": "DUNCAN",
    "dropmalst": "MS",
    "dropmalzpp": 387409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623952205,
    "dropfax": 6623958314
  },
  {
    "dcode": "D",
    "dropkey": "PY13534",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "1028 RYALS RD",
    "dropdelcty": "DUNDEE",
    "dropdelst": "MS",
    "dropdelzpp": 386269998,
    "dropphyadd": "1028 RYALS RD",
    "dropphycty": "DUNDEE",
    "dropphyst": "MS",
    "dropphyzpp": 386269998,
    "dropmaladd": "1028 RYALS RD",
    "dropmalcty": "DUNDEE",
    "dropmalst": "MS",
    "dropmalzpp": 386269998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623632701,
    "dropfax": 6623632701
  },
  {
    "dcode": "D",
    "dropkey": "PY13536",
    "droptype": "D",
    "dropname": "DURANT",
    "dropdeladd": "15243 S JACKSON ST",
    "dropdelcty": "DURANT",
    "dropdelst": "MS",
    "dropdelzpp": 390639998,
    "dropphyadd": "15243 S JACKSON ST",
    "dropphycty": "DURANT",
    "dropphyst": "MS",
    "dropphyzpp": 390639998,
    "dropmaladd": "15243 S JACKSON ST",
    "dropmalcty": "DURANT",
    "dropmalst": "MS",
    "dropmalzpp": 390639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6626536344,
    "dropsitcph": 6626536341,
    "dropfax": 6626536344
  },
  {
    "dcode": "D",
    "dropkey": "PY13547",
    "droptype": "D",
    "dropname": "EASTABUCHIE",
    "dropdeladd": "423 CHURCH ST",
    "dropdelcty": "EASTABUCHIE",
    "dropdelst": "MS",
    "dropdelzpp": 394369998,
    "dropphyadd": "423 CHURCH ST",
    "dropphycty": "EASTABUCHIE",
    "dropphyst": "MS",
    "dropphyzpp": 394369998,
    "dropmaladd": "423 CHURCH ST",
    "dropmalcty": "EASTABUCHIE",
    "dropmalst": "MS",
    "dropmalzpp": 394369998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015821819,
    "dropfax": 6015821819
  },
  {
    "dcode": "D",
    "dropkey": "PY13555",
    "droptype": "D",
    "dropname": "ECRU",
    "dropdeladd": "239 MAIN ST",
    "dropdelcty": "ECRU",
    "dropdelst": "MS",
    "dropdelzpp": 388419998,
    "dropphyadd": "239 MAIN ST",
    "dropphycty": "ECRU",
    "dropphyst": "MS",
    "dropphyzpp": 388419998,
    "dropmaladd": "239 MAIN ST",
    "dropmalcty": "ECRU",
    "dropmalst": "MS",
    "dropmalzpp": 388419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624893561,
    "dropfax": 6624893561
  },
  {
    "dcode": "D",
    "dropkey": "PY13558",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "100 WITHERS ST",
    "dropdelcty": "EDWARDS",
    "dropdelst": "MS",
    "dropdelzpp": 390669998,
    "dropphyadd": "100 WITHERS ST",
    "dropphycty": "EDWARDS",
    "dropphyst": "MS",
    "dropphyzpp": 390669998,
    "dropmaladd": "100 WITHERS ST",
    "dropmalcty": "EDWARDS",
    "dropmalst": "MS",
    "dropmalzpp": 390669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018522062,
    "dropfax": 6018529405
  },
  {
    "dcode": "D",
    "dropkey": "PY13568",
    "droptype": "D",
    "dropname": "ELLISVILLE",
    "dropdeladd": "303 S COURT ST",
    "dropdelcty": "ELLISVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 394379998,
    "dropphyadd": "303 S COURT ST",
    "dropphycty": "ELLISVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 394379998,
    "dropmaladd": "303 S COURT ST",
    "dropmalcty": "ELLISVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 394379998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6014772022,
    "dropsitcph": 6014778061,
    "dropfax": 6014772280
  },
  {
    "dcode": "D",
    "dropkey": "PY13576",
    "droptype": "D",
    "dropname": "ENID",
    "dropdeladd": "79 COUNTY ROAD 206",
    "dropdelcty": "ENID",
    "dropdelst": "MS",
    "dropdelzpp": 389279998,
    "dropphyadd": "79 COUNTY ROAD 206",
    "dropphycty": "ENID",
    "dropphyst": "MS",
    "dropphyzpp": 389279998,
    "dropmaladd": "79 COUNTY ROAD 206",
    "dropmalcty": "ENID",
    "dropmalst": "MS",
    "dropmalzpp": 389279998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626238883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13579",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "77 OLD MILL CREEK RD",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "MS",
    "dropdelzpp": 393309998,
    "dropphyadd": "77 OLD MILL CREEK RD",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "MS",
    "dropphyzpp": 393309998,
    "dropmaladd": "77 OLD MILL CREEK RD",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "MS",
    "dropmalzpp": 393309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016594671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13583",
    "droptype": "D",
    "dropname": "ESCATAWPA",
    "dropdeladd": "4100 RABBY ST",
    "dropdelcty": "ESCATAWPA",
    "dropdelst": "MS",
    "dropdelzpp": 395529998,
    "dropphyadd": "4100 RABBY ST",
    "dropphycty": "ESCATAWPA",
    "dropphyst": "MS",
    "dropphyzpp": 395529998,
    "dropmaladd": "4100 RABBY ST",
    "dropmalcty": "ESCATAWPA",
    "dropmalst": "MS",
    "dropmalzpp": 395529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2284756059,
    "dropfax": 2284756067
  },
  {
    "dcode": "D",
    "dropkey": "PY13586",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "2112 MAIN ST",
    "dropdelcty": "ETHEL",
    "dropdelst": "MS",
    "dropdelzpp": 390679998,
    "dropphyadd": "2112 MAIN ST",
    "dropphycty": "ETHEL",
    "dropphyst": "MS",
    "dropphyzpp": 390679998,
    "dropmaladd": "2112 MAIN ST",
    "dropmalcty": "ETHEL",
    "dropmalst": "MS",
    "dropmalzpp": 390679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626745432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13587",
    "droptype": "D",
    "dropname": "ETTA",
    "dropdeladd": "1947 STATE ROAD 355",
    "dropdelcty": "ETTA",
    "dropdelst": "MS",
    "dropdelzpp": 386279998,
    "dropphyadd": "1947 STATE ROAD 355",
    "dropphycty": "ETTA",
    "dropphyst": "MS",
    "dropphyzpp": 386279998,
    "dropmaladd": "1947 STATE ROAD 355",
    "dropmalcty": "ETTA",
    "dropmalst": "MS",
    "dropmalzpp": 386279998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625348871,
    "dropfax": 6625348871
  },
  {
    "dcode": "D",
    "dropkey": "PY13589",
    "droptype": "D",
    "dropname": "EUPORA",
    "dropdeladd": "107 N DUNN ST",
    "dropdelcty": "EUPORA",
    "dropdelst": "MS",
    "dropdelzpp": 397449998,
    "dropphyadd": "107 N DUNN ST",
    "dropphycty": "EUPORA",
    "dropphyst": "MS",
    "dropphyzpp": 397449998,
    "dropmaladd": "107 N DUNN ST",
    "dropmalcty": "EUPORA",
    "dropmalst": "MS",
    "dropmalzpp": 397449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622587759,
    "dropfax": 6622587774
  },
  {
    "dcode": "D",
    "dropkey": "PY13603",
    "droptype": "D",
    "dropname": "FALKNER",
    "dropdeladd": "20610 HIGHWAY 15",
    "dropdelcty": "FALKNER",
    "dropdelst": "MS",
    "dropdelzpp": 386299998,
    "dropphyadd": "20610 HIGHWAY 15",
    "dropphycty": "FALKNER",
    "dropphyst": "MS",
    "dropphyzpp": 386299998,
    "dropmaladd": "20610 HIGHWAY 15",
    "dropmalcty": "FALKNER",
    "dropmalst": "MS",
    "dropmalzpp": 386299998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628378469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13609",
    "droptype": "D",
    "dropname": "FAYETTE",
    "dropdeladd": "215 E MEAD ST",
    "dropdelcty": "FAYETTE",
    "dropdelst": "MS",
    "dropdelzpp": 390699998,
    "dropphyadd": "215 E MEAD ST",
    "dropphycty": "FAYETTE",
    "dropphyst": "MS",
    "dropphyzpp": 390699998,
    "dropmaladd": "215 E MEAD ST",
    "dropmalcty": "FAYETTE",
    "dropmalst": "MS",
    "dropmalzpp": 390699998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017868261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13611",
    "droptype": "D",
    "dropname": "FERNWOOD",
    "dropdeladd": "1007 CHERRY DR",
    "dropdelcty": "FERNWOOD",
    "dropdelst": "MS",
    "dropdelzpp": 396359998,
    "dropphyadd": "1007 CHERRY DR",
    "dropphycty": "FERNWOOD",
    "dropphyst": "MS",
    "dropphyzpp": 396359998,
    "dropmaladd": "1007 CHERRY DR",
    "dropmalcty": "FERNWOOD",
    "dropmalst": "MS",
    "dropmalzpp": 396359998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016844155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13614",
    "droptype": "D",
    "dropname": "FLORA",
    "dropdeladd": "4852 MAIN ST",
    "dropdelcty": "FLORA",
    "dropdelst": "MS",
    "dropdelzpp": 390719998,
    "dropphyadd": "4852 MAIN ST",
    "dropphycty": "FLORA",
    "dropphyst": "MS",
    "dropphyzpp": 390719998,
    "dropmaladd": "4852 MAIN ST",
    "dropmalcty": "FLORA",
    "dropmalst": "MS",
    "dropmalzpp": 390719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018793101,
    "dropfax": 6018799429
  },
  {
    "dcode": "D",
    "dropkey": "PY13615",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "250 S CHURCH ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "MS",
    "dropdelzpp": 390739998,
    "dropphyadd": "250 S CHURCH ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "MS",
    "dropphyzpp": 390739998,
    "dropmaladd": "250 S CHURCH ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "MS",
    "dropmalzpp": 390739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018453919,
    "dropsitcph": 6018451885,
    "dropfax": 6018453585
  },
  {
    "dcode": "D",
    "dropkey": "PY13621",
    "droptype": "D",
    "dropname": "FOREST",
    "dropdeladd": "313 E SECOND ST",
    "dropdelcty": "FOREST",
    "dropdelst": "MS",
    "dropdelzpp": 390749998,
    "dropphyadd": "313 E SECOND ST",
    "dropphycty": "FOREST",
    "dropphyst": "MS",
    "dropphyzpp": 390749998,
    "dropmaladd": "313 E SECOND ST",
    "dropmalcty": "FOREST",
    "dropmalst": "MS",
    "dropmalzpp": 390749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014693922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13626",
    "droptype": "D",
    "dropname": "FOXWORTH",
    "dropdeladd": "72 HIGHWAY 587",
    "dropdelcty": "FOXWORTH",
    "dropdelst": "MS",
    "dropdelzpp": 394839998,
    "dropphyadd": "72 HIGHWAY 587",
    "dropphycty": "FOXWORTH",
    "dropphyst": "MS",
    "dropphyzpp": 394839998,
    "dropmaladd": "72 HIGHWAY 587",
    "dropmalcty": "FOXWORTH",
    "dropmalst": "MS",
    "dropmalzpp": 394839998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6017367411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13628",
    "droptype": "D",
    "dropname": "FRENCH CAMP",
    "dropdeladd": "6061 MS HIGHWAY 413",
    "dropdelcty": "FRENCH CAMP",
    "dropdelst": "MS",
    "dropdelzpp": 397459998,
    "dropphyadd": "6061 MS HIGHWAY 413",
    "dropphycty": "FRENCH CAMP",
    "dropphyst": "MS",
    "dropphyzpp": 397459998,
    "dropmaladd": "6061 MS HIGHWAY 413",
    "dropmalcty": "FRENCH CAMP",
    "dropmalst": "MS",
    "dropmalzpp": 397459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625476341,
    "dropfax": 6625476341
  },
  {
    "dcode": "D",
    "dropkey": "PY13631",
    "droptype": "D",
    "dropname": "FRIARS POINT",
    "dropdeladd": "774 2ND ST",
    "dropdelcty": "FRIARS POINT",
    "dropdelst": "MS",
    "dropdelzpp": 386319998,
    "dropphyadd": "774 2ND ST",
    "dropphycty": "FRIARS POINT",
    "dropphyst": "MS",
    "dropphyzpp": 386319998,
    "dropmaladd": "774 2ND ST",
    "dropmalcty": "FRIARS POINT",
    "dropmalst": "MS",
    "dropmalzpp": 386319998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623832729,
    "dropfax": 6623832729
  },
  {
    "dcode": "D",
    "dropkey": "PY13638",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "FULTON",
    "dropdelst": "MS",
    "dropdelzpp": 388439998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "FULTON",
    "dropphyst": "MS",
    "dropphyzpp": 388439998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "FULTON",
    "dropmalst": "MS",
    "dropmalzpp": 388439998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628624437,
    "dropfax": 6628622374
  },
  {
    "dcode": "D",
    "dropkey": "PY13643",
    "droptype": "D",
    "dropname": "GALLMAN",
    "dropdeladd": "20140 S HIGHWAY 51",
    "dropdelcty": "GALLMAN",
    "dropdelst": "MS",
    "dropdelzpp": 390779998,
    "dropphyadd": "20140 S HIGHWAY 51",
    "dropphycty": "GALLMAN",
    "dropphyst": "MS",
    "dropphyzpp": 390779998,
    "dropmaladd": "20140 S HIGHWAY 51",
    "dropmalcty": "GALLMAN",
    "dropmalst": "MS",
    "dropmalzpp": 390779998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018922260,
    "dropfax": 6018922260
  },
  {
    "dcode": "D",
    "dropkey": "PY13647",
    "droptype": "D",
    "dropname": "GATTMAN",
    "dropdeladd": "52492 HIGHWAY 278 E",
    "dropdelcty": "GATTMAN",
    "dropdelst": "MS",
    "dropdelzpp": 388449998,
    "dropphyadd": "52492 HIGHWAY 278 E",
    "dropphycty": "GATTMAN",
    "dropphyst": "MS",
    "dropphyzpp": 388449998,
    "dropmaladd": "52492 HIGHWAY 278 E",
    "dropmalcty": "GATTMAN",
    "dropmalst": "MS",
    "dropmalzpp": 388449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622563600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13648",
    "droptype": "D",
    "dropname": "GAUTIER",
    "dropdeladd": "1800 HIGHWAY 90",
    "dropdelcty": "GAUTIER",
    "dropdelst": "MS",
    "dropdelzpp": 395539998,
    "dropphyadd": "1800 HIGHWAY 90",
    "dropphycty": "GAUTIER",
    "dropphyst": "MS",
    "dropphyzpp": 395539998,
    "dropmaladd": "1800 HIGHWAY 90",
    "dropmalcty": "GAUTIER",
    "dropmalst": "MS",
    "dropmalzpp": 395539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2285220984,
    "dropfax": 2284973602
  },
  {
    "dcode": "D",
    "dropkey": "PY13652",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1052 BROAD ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "MS",
    "dropdelzpp": 390789998,
    "dropphyadd": "1052 BROAD ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "MS",
    "dropphyzpp": 390789998,
    "dropmaladd": "1052 BROAD ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "MS",
    "dropmalzpp": 390789998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018582265,
    "dropfax": 6018582265
  },
  {
    "dcode": "D",
    "dropkey": "PY13657",
    "droptype": "D",
    "dropname": "GLEN",
    "dropdeladd": "2430 HIGHWAY 72 E",
    "dropdelcty": "GLEN",
    "dropdelst": "MS",
    "dropdelzpp": 388469998,
    "dropphyadd": "2430 HIGHWAY 72 E",
    "dropphycty": "GLEN",
    "dropphyst": "MS",
    "dropphyzpp": 388469998,
    "dropmaladd": "2430 HIGHWAY 72 E",
    "dropmalcty": "GLEN",
    "dropmalst": "MS",
    "dropmalzpp": 388469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622872860,
    "dropfax": 6626650630
  },
  {
    "dcode": "D",
    "dropkey": "PY13658",
    "droptype": "D",
    "dropname": "GLEN ALLAN",
    "dropdeladd": "924 LAKE WASHINGTON RD E",
    "dropdelcty": "GLEN ALLAN",
    "dropdelst": "MS",
    "dropdelzpp": 387449998,
    "dropphyadd": "924 LAKE WASHINGTON RD E",
    "dropphycty": "GLEN ALLAN",
    "dropphyst": "MS",
    "dropphyzpp": 387449998,
    "dropmaladd": "924 LAKE WASHINGTON RD E",
    "dropmalcty": "GLEN ALLAN",
    "dropmalst": "MS",
    "dropmalzpp": 387449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628395051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13660",
    "droptype": "D",
    "dropname": "GLENDORA",
    "dropdeladd": "18 WESTBROOK ST",
    "dropdelcty": "GLENDORA",
    "dropdelst": "MS",
    "dropdelzpp": 389289998,
    "dropphyadd": "18 WESTBROOK ST",
    "dropphycty": "GLENDORA",
    "dropphyst": "MS",
    "dropphyzpp": 389289998,
    "dropmaladd": "18 WESTBROOK ST",
    "dropmalcty": "GLENDORA",
    "dropmalst": "MS",
    "dropmalzpp": 389289998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623759372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13661",
    "droptype": "D",
    "dropname": "GLOSTER",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "GLOSTER",
    "dropdelst": "MS",
    "dropdelzpp": 396389998,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "GLOSTER",
    "dropphyst": "MS",
    "dropphyzpp": 396389998,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "GLOSTER",
    "dropmalst": "MS",
    "dropmalzpp": 396389998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6012254392,
    "dropfax": 6012254392
  },
  {
    "dcode": "D",
    "dropkey": "PY13664",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "195 FRONT ST",
    "dropdelcty": "GOLDEN",
    "dropdelst": "MS",
    "dropdelzpp": 388479998,
    "dropphyadd": "195 FRONT ST",
    "dropphycty": "GOLDEN",
    "dropphyst": "MS",
    "dropphyzpp": 388479998,
    "dropmaladd": "195 FRONT ST",
    "dropmalcty": "GOLDEN",
    "dropmalst": "MS",
    "dropmalzpp": 388479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624547307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13669",
    "droptype": "D",
    "dropname": "GOODMAN",
    "dropdeladd": "9897 MAIN ST",
    "dropdelcty": "GOODMAN",
    "dropdelst": "MS",
    "dropdelzpp": 390799998,
    "dropphyadd": "9897 MAIN ST",
    "dropphycty": "GOODMAN",
    "dropphyst": "MS",
    "dropphyzpp": 390799998,
    "dropmaladd": "9897 MAIN ST",
    "dropmalcty": "GOODMAN",
    "dropmalst": "MS",
    "dropmalzpp": 390799998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624722716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13672",
    "droptype": "D",
    "dropname": "GORE SPRINGS",
    "dropdeladd": "32394 HIGHWAY 8 E",
    "dropdelcty": "GORE SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 389299998,
    "dropphyadd": "32394 HIGHWAY 8 E",
    "dropphycty": "GORE SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 389299998,
    "dropmaladd": "32394 HIGHWAY 8 E",
    "dropmalcty": "GORE SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 389299998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622264558,
    "dropfax": 6622264558
  },
  {
    "dcode": "D",
    "dropkey": "PY13673",
    "droptype": "D",
    "dropname": "GRACE",
    "dropdeladd": "6858 HIGHWAY 16 W",
    "dropdelcty": "GRACE",
    "dropdelst": "MS",
    "dropdelzpp": 387459998,
    "dropphyadd": "6858 HIGHWAY 16 W",
    "dropphycty": "GRACE",
    "dropphyst": "MS",
    "dropphyzpp": 387459998,
    "dropmaladd": "6858 HIGHWAY 16 W",
    "dropmalcty": "GRACE",
    "dropmalst": "MS",
    "dropmalzpp": 387459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628734102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13682",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "305 MAIN ST STE 154",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387019998,
    "dropphyadd": "305 MAIN ST STE 154",
    "dropphycty": "GREENVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387019998,
    "dropmaladd": "305 MAIN ST STE 154",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623354524,
    "dropsitcph": 6623354523,
    "dropfax": 6623328921
  },
  {
    "dcode": "D",
    "dropkey": "PY13687",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "200 E WASHINGTON ST RM 100",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "MS",
    "dropdelzpp": 389309998,
    "dropphyadd": "200 E WASHINGTON ST RM 100",
    "dropphycty": "GREENWOOD",
    "dropphyst": "MS",
    "dropphyzpp": 389309998,
    "dropmaladd": "200 E WASHINGTON ST RM 100",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "MS",
    "dropmalzpp": 389309998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6624533243,
    "dropsitcph": 6624533242,
    "dropfax": 6624555812
  },
  {
    "dcode": "D",
    "dropkey": "PY13689",
    "droptype": "D",
    "dropname": "GREENWOOD SPRINGS",
    "dropdeladd": "52066 HIGHWAY 278 E",
    "dropdelcty": "GREENWOOD SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 388489998,
    "dropphyadd": "52066 HIGHWAY 278 E",
    "dropphycty": "GREENWOOD SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 388489998,
    "dropmaladd": "52066 HIGHWAY 278 E",
    "dropmalcty": "GREENWOOD SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 388489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622563601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13692",
    "droptype": "D",
    "dropname": "GRENADA",
    "dropdeladd": "2500 GATEWAY ST",
    "dropdelcty": "GRENADA",
    "dropdelst": "MS",
    "dropdelzpp": 389019998,
    "dropphyadd": "2500 GATEWAY ST",
    "dropphycty": "GRENADA",
    "dropphyst": "MS",
    "dropphyzpp": 389019998,
    "dropmaladd": "2500 GATEWAY ST",
    "dropmalcty": "GRENADA",
    "dropmalst": "MS",
    "dropmalzpp": 389019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622265521,
    "dropsitcph": 6622265515,
    "dropfax": 6622264342
  },
  {
    "dcode": "D",
    "dropkey": "PY13700",
    "droptype": "D",
    "dropname": "GULFPORT",
    "dropdeladd": "11110 HIGHWAY 49",
    "dropdelcty": "GULFPORT",
    "dropdelst": "MS",
    "dropdelzpp": 395039998,
    "dropphyadd": "11110 HIGHWAY 49",
    "dropphycty": "GULFPORT",
    "dropphyst": "MS",
    "dropphyzpp": 395039998,
    "dropmaladd": "11110 HIGHWAY 49",
    "dropmalcty": "GULFPORT",
    "dropmalst": "MS",
    "dropmalzpp": 395039998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2288315408,
    "dropsitcph": 2288315471,
    "dropfax": 2288315410
  },
  {
    "dcode": "D",
    "dropkey": "PY13702",
    "droptype": "D",
    "dropname": "GUNNISON",
    "dropdeladd": "514 RAILROAD AVE",
    "dropdelcty": "GUNNISON",
    "dropdelst": "MS",
    "dropdelzpp": 387469998,
    "dropphyadd": "514 RAILROAD AVE",
    "dropphycty": "GUNNISON",
    "dropphyst": "MS",
    "dropphyzpp": 387469998,
    "dropmaladd": "514 RAILROAD AVE",
    "dropmalcty": "GUNNISON",
    "dropmalst": "MS",
    "dropmalzpp": 387469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627472930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13703",
    "droptype": "D",
    "dropname": "GUNTOWN",
    "dropdeladd": "1660 MAIN ST",
    "dropdelcty": "GUNTOWN",
    "dropdelst": "MS",
    "dropdelzpp": 388499998,
    "dropphyadd": "1660 MAIN ST",
    "dropphycty": "GUNTOWN",
    "dropphyst": "MS",
    "dropphyzpp": 388499998,
    "dropmaladd": "1660 MAIN ST",
    "dropmalcty": "GUNTOWN",
    "dropmalst": "MS",
    "dropmalzpp": 388499998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623485335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13705",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "40462 OLD HIGHWAY 45 S",
    "dropdelcty": "HAMILTON",
    "dropdelst": "MS",
    "dropdelzpp": 397469998,
    "dropphyadd": "40462 OLD HIGHWAY 45 S",
    "dropphycty": "HAMILTON",
    "dropphyst": "MS",
    "dropphyzpp": 397469998,
    "dropmaladd": "40462 OLD HIGHWAY 45 S",
    "dropmalcty": "HAMILTON",
    "dropmalst": "MS",
    "dropmalzpp": 397469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623435532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13710",
    "droptype": "D",
    "dropname": "HARPERVILLE",
    "dropdeladd": "9190 OLD HILLSBORO RD",
    "dropdelcty": "HARPERVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 390809998,
    "dropphyadd": "9190 OLD HILLSBORO RD",
    "dropphycty": "HARPERVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 390809998,
    "dropmaladd": "9190 OLD HILLSBORO RD",
    "dropmalcty": "HARPERVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 390809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016258892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13714",
    "droptype": "D",
    "dropname": "HARRISVILLE",
    "dropdeladd": "1569 SIMPSON HIGHWAY 469",
    "dropdelcty": "HARRISVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 390829998,
    "dropphyadd": "1569 SIMPSON HIGHWAY 469",
    "dropphycty": "HARRISVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 390829998,
    "dropmaladd": "1569 SIMPSON HIGHWAY 469",
    "dropmalcty": "HARRISVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 390829998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018474342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13721",
    "droptype": "D",
    "dropname": "HATTIESBURG",
    "dropdeladd": "220 S 40TH AVE",
    "dropdelcty": "HATTIESBURG",
    "dropdelst": "MS",
    "dropdelzpp": 394029998,
    "dropphyadd": "220 S 40TH AVE",
    "dropphycty": "HATTIESBURG",
    "dropphyst": "MS",
    "dropphyzpp": 394029998,
    "dropmaladd": "220 S 40TH AVE",
    "dropmalcty": "HATTIESBURG",
    "dropmalst": "MS",
    "dropmalzpp": 394029998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6012717080,
    "dropsitcph": 6012717000,
    "dropfax": 6012717060
  },
  {
    "dcode": "D",
    "dropkey": "PY13724",
    "droptype": "D",
    "dropname": "HAZLEHURST",
    "dropdeladd": "130 CALDWELL DR",
    "dropdelcty": "HAZLEHURST",
    "dropdelst": "MS",
    "dropdelzpp": 390839998,
    "dropphyadd": "130 CALDWELL DR",
    "dropphycty": "HAZLEHURST",
    "dropphyst": "MS",
    "dropphyzpp": 390839998,
    "dropmaladd": "130 CALDWELL DR",
    "dropmalcty": "HAZLEHURST",
    "dropmalst": "MS",
    "dropmalzpp": 390839998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018944350,
    "dropsitcph": 6018944151,
    "dropfax": 6018944883
  },
  {
    "dcode": "D",
    "dropkey": "PY13727",
    "droptype": "D",
    "dropname": "HEIDELBERG",
    "dropdeladd": "105 N OAK AVE",
    "dropdelcty": "HEIDELBERG",
    "dropdelst": "MS",
    "dropdelzpp": 394399998,
    "dropphyadd": "105 N OAK AVE",
    "dropphycty": "HEIDELBERG",
    "dropphyst": "MS",
    "dropphyzpp": 394399998,
    "dropmaladd": "105 N OAK AVE",
    "dropmalcty": "HEIDELBERG",
    "dropmalst": "MS",
    "dropmalzpp": 394399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017873921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13732",
    "droptype": "D",
    "dropname": "HERMANVILLE",
    "dropdeladd": "13071 PATTISON HERMANVILLE RD",
    "dropdelcty": "HERMANVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 390869998,
    "dropphyadd": "13071 PATTISON HERMANVILLE RD",
    "dropphycty": "HERMANVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 390869998,
    "dropmaladd": "13071 PATTISON HERMANVILLE RD",
    "dropmalcty": "HERMANVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 390869998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015352990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13733",
    "droptype": "D",
    "dropname": "HERNANDO",
    "dropdeladd": "12 W COMMERCE ST",
    "dropdelcty": "HERNANDO",
    "dropdelst": "MS",
    "dropdelzpp": 386329998,
    "dropphyadd": "12 W COMMERCE ST",
    "dropphycty": "HERNANDO",
    "dropphyst": "MS",
    "dropphyzpp": 386329998,
    "dropmaladd": "12 W COMMERCE ST",
    "dropmalcty": "HERNANDO",
    "dropmalst": "MS",
    "dropmalzpp": 386329998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6624298637,
    "dropsitcph": 6624292481,
    "dropfax": 6624298637
  },
  {
    "dcode": "D",
    "dropkey": "PY13735",
    "droptype": "D",
    "dropname": "HICKORY",
    "dropdeladd": "7464 HIGHWAY 503",
    "dropdelcty": "HICKORY",
    "dropdelst": "MS",
    "dropdelzpp": 393329998,
    "dropphyadd": "7464 HIGHWAY 503",
    "dropphycty": "HICKORY",
    "dropphyst": "MS",
    "dropphyzpp": 393329998,
    "dropmaladd": "7464 HIGHWAY 503",
    "dropmalcty": "HICKORY",
    "dropmalst": "MS",
    "dropmalzpp": 393329998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016465622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13736",
    "droptype": "D",
    "dropname": "HICKORY FLAT",
    "dropdeladd": "535 HIGHWAY 5",
    "dropdelcty": "HICKORY FLAT",
    "dropdelst": "MS",
    "dropdelzpp": 386339998,
    "dropphyadd": "535 HIGHWAY 5",
    "dropphycty": "HICKORY FLAT",
    "dropphyst": "MS",
    "dropphyzpp": 386339998,
    "dropmaladd": "535 HIGHWAY 5",
    "dropmalcty": "HICKORY FLAT",
    "dropmalst": "MS",
    "dropmalzpp": 386339998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623337687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13744",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "61 HILLSBORO LUDLOW RD",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "MS",
    "dropdelzpp": 390879998,
    "dropphyadd": "61 HILLSBORO LUDLOW RD",
    "dropphycty": "HILLSBORO",
    "dropphyst": "MS",
    "dropphyzpp": 390879998,
    "dropmaladd": "61 HILLSBORO LUDLOW RD",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "MS",
    "dropmalzpp": 390879998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016258658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13755",
    "droptype": "D",
    "dropname": "HOLCOMB",
    "dropdeladd": "8334 HIGHWAY 7 S",
    "dropdelcty": "HOLCOMB",
    "dropdelst": "MS",
    "dropdelzpp": 389409998,
    "dropphyadd": "8334 HIGHWAY 7 S",
    "dropphycty": "HOLCOMB",
    "dropphyst": "MS",
    "dropphyzpp": 389409998,
    "dropmaladd": "8334 HIGHWAY 7 S",
    "dropmalcty": "HOLCOMB",
    "dropmalst": "MS",
    "dropmalzpp": 389409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622265775,
    "dropfax": 6622271562
  },
  {
    "dcode": "D",
    "dropkey": "PY13757",
    "droptype": "D",
    "dropname": "HOLLANDALE",
    "dropdeladd": "121 EAST AVE S",
    "dropdelcty": "HOLLANDALE",
    "dropdelst": "MS",
    "dropdelzpp": 387489998,
    "dropphyadd": "121 EAST AVE S",
    "dropphycty": "HOLLANDALE",
    "dropphyst": "MS",
    "dropphyzpp": 387489998,
    "dropmaladd": "121 EAST AVE S",
    "dropmalcty": "HOLLANDALE",
    "dropmalst": "MS",
    "dropmalzpp": 387489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628272744,
    "dropfax": 6628272737
  },
  {
    "dcode": "D",
    "dropkey": "PY13761",
    "droptype": "D",
    "dropname": "HOLLY BLUFF",
    "dropdeladd": "939 HIGHWAY 16 W",
    "dropdelcty": "HOLLY BLUFF",
    "dropdelst": "MS",
    "dropdelzpp": 390889998,
    "dropphyadd": "939 HIGHWAY 16 W",
    "dropphycty": "HOLLY BLUFF",
    "dropphyst": "MS",
    "dropphyzpp": 390889998,
    "dropmaladd": "939 HIGHWAY 16 W",
    "dropmalcty": "HOLLY BLUFF",
    "dropmalst": "MS",
    "dropmalzpp": 390889998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628283240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13766",
    "droptype": "D",
    "dropname": "HOLLY SPRINGS",
    "dropdeladd": "110 N MEMPHIS ST",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 386359996,
    "dropphyadd": "110 N MEMPHIS ST",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 386359996,
    "dropmaladd": "110 N MEMPHIS ST",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 386359996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622522514,
    "dropsitcph": 6622522514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13771",
    "droptype": "D",
    "dropname": "HORN LAKE",
    "dropdeladd": "3724 GOODMAN RD W",
    "dropdelcty": "HORN LAKE",
    "dropdelst": "MS",
    "dropdelzpp": 386379998,
    "dropphyadd": "3724 GOODMAN RD W",
    "dropphycty": "HORN LAKE",
    "dropphyst": "MS",
    "dropphyzpp": 386379998,
    "dropmaladd": "3724 GOODMAN RD W",
    "dropmalcty": "HORN LAKE",
    "dropmalst": "MS",
    "dropmalzpp": 386379998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623423035,
    "dropsitcph": 6623423033,
    "dropfax": 6623423616
  },
  {
    "dcode": "D",
    "dropkey": "PY13774",
    "droptype": "D",
    "dropname": "HOULKA",
    "dropdeladd": "206 WALKER ST",
    "dropdelcty": "HOULKA",
    "dropdelst": "MS",
    "dropdelzpp": 388509998,
    "dropphyadd": "206 WALKER ST",
    "dropphycty": "HOULKA",
    "dropphyst": "MS",
    "dropphyzpp": 388509998,
    "dropmaladd": "206 WALKER ST",
    "dropmalcty": "HOULKA",
    "dropmalst": "MS",
    "dropmalzpp": 388509998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625683302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13775",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "217 N JACKSON ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "MS",
    "dropdelzpp": 388519998,
    "dropphyadd": "217 N JACKSON ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "MS",
    "dropphyzpp": 388519998,
    "dropmaladd": "217 N JACKSON ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "MS",
    "dropmalzpp": 388519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624563357,
    "dropfax": 6624564198
  },
  {
    "dcode": "D",
    "dropkey": "PY13778",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "7020 HIGHWAY 614",
    "dropdelcty": "HURLEY",
    "dropdelst": "MS",
    "dropdelzpp": 395559998,
    "dropphyadd": "7020 HIGHWAY 614",
    "dropphycty": "HURLEY",
    "dropphyst": "MS",
    "dropphyzpp": 395559998,
    "dropmaladd": "7020 HIGHWAY 614",
    "dropmalcty": "HURLEY",
    "dropmalst": "MS",
    "dropmalzpp": 395559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2285883064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13784",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "15 BILL HANCOCK RD",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "MS",
    "dropdelzpp": 386389998,
    "dropphyadd": "15 BILL HANCOCK RD",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "MS",
    "dropphyzpp": 386389998,
    "dropmaladd": "15 BILL HANCOCK RD",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "MS",
    "dropmalzpp": 386389998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622332141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13789",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "100 W PERCY ST",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "MS",
    "dropdelzpp": 387519998,
    "dropphyadd": "100 W PERCY ST",
    "dropphycty": "INDIANOLA",
    "dropphyst": "MS",
    "dropphyzpp": 387519998,
    "dropmaladd": "100 W PERCY ST",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "MS",
    "dropmalzpp": 387519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628872902,
    "dropfax": 6628876676
  },
  {
    "dcode": "D",
    "dropkey": "PY13792",
    "droptype": "D",
    "dropname": "INVERNESS",
    "dropdeladd": "900 THIRD ST",
    "dropdelcty": "INVERNESS",
    "dropdelst": "MS",
    "dropdelzpp": 387539998,
    "dropphyadd": "900 THIRD ST",
    "dropphycty": "INVERNESS",
    "dropphyst": "MS",
    "dropphyzpp": 387539998,
    "dropmaladd": "900 THIRD ST",
    "dropmalcty": "INVERNESS",
    "dropmalst": "MS",
    "dropmalzpp": 387539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622655808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13796",
    "droptype": "D",
    "dropname": "ISOLA",
    "dropdeladd": "400 JULIA ST",
    "dropdelcty": "ISOLA",
    "dropdelst": "MS",
    "dropdelzpp": 387549998,
    "dropphyadd": "400 JULIA ST",
    "dropphycty": "ISOLA",
    "dropphyst": "MS",
    "dropphyzpp": 387549998,
    "dropmaladd": "400 JULIA ST",
    "dropmalcty": "ISOLA",
    "dropmalst": "MS",
    "dropmalzpp": 387549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6629622351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13797",
    "droptype": "D",
    "dropname": "ITTA BENA",
    "dropdeladd": "100 DEWEY ST",
    "dropdelcty": "ITTA BENA",
    "dropdelst": "MS",
    "dropdelzpp": 389419998,
    "dropphyadd": "100 DEWEY ST",
    "dropphycty": "ITTA BENA",
    "dropphyst": "MS",
    "dropphyzpp": 389419998,
    "dropmaladd": "100 DEWEY ST",
    "dropmalcty": "ITTA BENA",
    "dropmalst": "MS",
    "dropmalzpp": 389419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622549112,
    "dropfax": 6622549112
  },
  {
    "dcode": "D",
    "dropkey": "PY13798",
    "droptype": "D",
    "dropname": "IUKA",
    "dropdeladd": "801 W EASTPORT ST",
    "dropdelcty": "IUKA",
    "dropdelst": "MS",
    "dropdelzpp": 388529998,
    "dropphyadd": "801 W EASTPORT ST",
    "dropphycty": "IUKA",
    "dropphyst": "MS",
    "dropphyzpp": 388529998,
    "dropmaladd": "801 W EASTPORT ST",
    "dropmalcty": "IUKA",
    "dropmalst": "MS",
    "dropmalzpp": 388529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624236434,
    "dropfax": 6624239872
  },
  {
    "dcode": "D",
    "dropkey": "PY13801",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "401 E SOUTH ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392019820,
    "dropphyadd": "401 E SOUTH ST",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392019820,
    "dropmaladd": "PO BOX 332",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392059998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517097,
    "dropsitcph": 6013517097,
    "dropfax": 6013517511
  },
  {
    "dcode": "D",
    "dropkey": "PY13807",
    "droptype": "D",
    "dropname": "JAYESS",
    "dropdeladd": "624 HIGHWAY 44",
    "dropdelcty": "JAYESS",
    "dropdelst": "MS",
    "dropdelzpp": 396419998,
    "dropphyadd": "624 HIGHWAY 44",
    "dropphycty": "JAYESS",
    "dropphyst": "MS",
    "dropphyzpp": 396419998,
    "dropmaladd": "624 HIGHWAY 44",
    "dropmalcty": "JAYESS",
    "dropmalst": "MS",
    "dropmalzpp": 396419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018338130,
    "dropfax": 6018351528
  },
  {
    "dcode": "D",
    "dropkey": "PY13815",
    "droptype": "D",
    "dropname": "JONESTOWN",
    "dropdeladd": "195 LONGINO ST",
    "dropdelcty": "JONESTOWN",
    "dropdelst": "MS",
    "dropdelzpp": 386399998,
    "dropphyadd": "195 LONGINO ST",
    "dropphycty": "JONESTOWN",
    "dropphyst": "MS",
    "dropphyzpp": 386399998,
    "dropmaladd": "195 LONGINO ST",
    "dropmalcty": "JONESTOWN",
    "dropmalst": "MS",
    "dropmalzpp": 386399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623584425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13829",
    "droptype": "D",
    "dropname": "KILMICHAEL",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "KILMICHAEL",
    "dropdelst": "MS",
    "dropdelzpp": 397479998,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "KILMICHAEL",
    "dropphyst": "MS",
    "dropphyzpp": 397479998,
    "dropmaladd": "205 E MAIN ST",
    "dropmalcty": "KILMICHAEL",
    "dropmalst": "MS",
    "dropmalzpp": 397479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622627642,
    "dropfax": 6622624960
  },
  {
    "dcode": "D",
    "dropkey": "PY13830",
    "droptype": "D",
    "dropname": "KILN",
    "dropdeladd": "16250 HIGHWAY 603",
    "dropdelcty": "KILN",
    "dropdelst": "MS",
    "dropdelzpp": 395569998,
    "dropphyadd": "16250 HIGHWAY 603",
    "dropphycty": "KILN",
    "dropphyst": "MS",
    "dropphyzpp": 395569998,
    "dropmaladd": "16250 HIGHWAY 603",
    "dropmalcty": "KILN",
    "dropmalst": "MS",
    "dropmalzpp": 395569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2285861275,
    "dropsitcph": 2285861201,
    "dropfax": 2285861275
  },
  {
    "dcode": "D",
    "dropkey": "PY13838",
    "droptype": "D",
    "dropname": "KOKOMO",
    "dropdeladd": "364 OLD HIGHWAY 24 W",
    "dropdelcty": "KOKOMO",
    "dropdelst": "MS",
    "dropdelzpp": 396439998,
    "dropphyadd": "364 OLD HIGHWAY 24 W",
    "dropphycty": "KOKOMO",
    "dropphyst": "MS",
    "dropphyzpp": 396439998,
    "dropmaladd": "364 OLD HIGHWAY 24 W",
    "dropmalcty": "KOKOMO",
    "dropmalst": "MS",
    "dropmalzpp": 396439998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017365274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13842",
    "droptype": "D",
    "dropname": "KOSCIUSKO",
    "dropdeladd": "65 VETERANS MEMORIAL DR",
    "dropdelcty": "KOSCIUSKO",
    "dropdelst": "MS",
    "dropdelzpp": 390909998,
    "dropphyadd": "65 VETERANS MEMORIAL DR",
    "dropphycty": "KOSCIUSKO",
    "dropphyst": "MS",
    "dropphyzpp": 390909998,
    "dropmaladd": "65 VETERANS MEMORIAL DR",
    "dropmalcty": "KOSCIUSKO",
    "dropmalst": "MS",
    "dropmalzpp": 390909998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622892813,
    "dropsitcph": 6622891181,
    "dropfax": 6622892813
  },
  {
    "dcode": "D",
    "dropkey": "PY13849",
    "droptype": "D",
    "dropname": "LAKE",
    "dropdeladd": "7621 STEVE LEE DR",
    "dropdelcty": "LAKE",
    "dropdelst": "MS",
    "dropdelzpp": 390929998,
    "dropphyadd": "7621 STEVE LEE DR",
    "dropphycty": "LAKE",
    "dropphyst": "MS",
    "dropphyzpp": 390929998,
    "dropmaladd": "7621 STEVE LEE DR",
    "dropmalcty": "LAKE",
    "dropmalst": "MS",
    "dropmalzpp": 390929998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017753040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13850",
    "droptype": "D",
    "dropname": "LAKE CORMORANT",
    "dropdeladd": "12744 STAR LANDING RD W",
    "dropdelcty": "LAKE CORMORANT",
    "dropdelst": "MS",
    "dropdelzpp": 386419998,
    "dropphyadd": "12744 STAR LANDING RD W",
    "dropphycty": "LAKE CORMORANT",
    "dropphyst": "MS",
    "dropphyzpp": 386419998,
    "dropmaladd": "12744 STAR LANDING RD W",
    "dropmalcty": "LAKE CORMORANT",
    "dropmalst": "MS",
    "dropmalzpp": 386419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627812470,
    "dropsitcph": 6627811628,
    "dropfax": 6627811628
  },
  {
    "dcode": "D",
    "dropkey": "PY13854",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "10464 LAMAR RD",
    "dropdelcty": "LAMAR",
    "dropdelst": "MS",
    "dropdelzpp": 386429998,
    "dropphyadd": "10464 LAMAR RD",
    "dropphycty": "LAMAR",
    "dropphyst": "MS",
    "dropphyzpp": 386429998,
    "dropmaladd": "10464 LAMAR RD",
    "dropmalcty": "LAMAR",
    "dropmalst": "MS",
    "dropmalzpp": 386429998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622524207,
    "dropfax": 6622528988
  },
  {
    "dcode": "D",
    "dropkey": "PY13856",
    "droptype": "D",
    "dropname": "LAMBERT",
    "dropdeladd": "700 COVINGTON AVE",
    "dropdelcty": "LAMBERT",
    "dropdelst": "MS",
    "dropdelzpp": 386439998,
    "dropphyadd": "700 COVINGTON AVE",
    "dropphycty": "LAMBERT",
    "dropphyst": "MS",
    "dropphyzpp": 386439998,
    "dropmaladd": "700 COVINGTON AVE",
    "dropmalcty": "LAMBERT",
    "dropmalst": "MS",
    "dropmalzpp": 386439998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623267075,
    "dropfax": 6623267075
  },
  {
    "dcode": "D",
    "dropkey": "PY13863",
    "droptype": "D",
    "dropname": "LAUDERDALE",
    "dropdeladd": "9779 OLD HIGHWAY 45 N",
    "dropdelcty": "LAUDERDALE",
    "dropdelst": "MS",
    "dropdelzpp": 393359998,
    "dropphyadd": "9779 OLD HIGHWAY 45 N",
    "dropphycty": "LAUDERDALE",
    "dropphyst": "MS",
    "dropphyzpp": 393359998,
    "dropmaladd": "9779 OLD HIGHWAY 45 N",
    "dropmalcty": "LAUDERDALE",
    "dropmalst": "MS",
    "dropmalzpp": 393359998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016798938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13864",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "315 SAWMILL RD",
    "dropdelcty": "LAUREL",
    "dropdelst": "MS",
    "dropdelzpp": 394409998,
    "dropphyadd": "315 SAWMILL RD",
    "dropphycty": "LAUREL",
    "dropphyst": "MS",
    "dropphyzpp": 394409998,
    "dropmaladd": "315 SAWMILL RD",
    "dropmalcty": "LAUREL",
    "dropmalst": "MS",
    "dropmalzpp": 394409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6014251409,
    "dropsitcph": 6014251408,
    "dropfax": 6014259563
  },
  {
    "dcode": "D",
    "dropkey": "PY13865",
    "droptype": "D",
    "dropname": "LAWRENCE",
    "dropdeladd": "5444 HIGHWAY 80",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "MS",
    "dropdelzpp": 393369998,
    "dropphyadd": "5444 HIGHWAY 80",
    "dropphycty": "LAWRENCE",
    "dropphyst": "MS",
    "dropphyzpp": 393369998,
    "dropmaladd": "5444 HIGHWAY 80",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "MS",
    "dropmalzpp": 393369998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016836331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13868",
    "droptype": "D",
    "dropname": "LEAKESVILLE",
    "dropdeladd": "621 GRAND AVE",
    "dropdelcty": "LEAKESVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 394519998,
    "dropphyadd": "621 GRAND AVE",
    "dropphycty": "LEAKESVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 394519998,
    "dropmaladd": "621 GRAND AVE",
    "dropmalcty": "LEAKESVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 394519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013942607,
    "dropfax": 6013946018
  },
  {
    "dcode": "D",
    "dropkey": "PY13877",
    "droptype": "D",
    "dropname": "LELAND",
    "dropdeladd": "204 N BROAD ST",
    "dropdelcty": "LELAND",
    "dropdelst": "MS",
    "dropdelzpp": 387569998,
    "dropphyadd": "204 N BROAD ST",
    "dropphycty": "LELAND",
    "dropphyst": "MS",
    "dropphyzpp": 387569998,
    "dropmaladd": "204 N BROAD ST",
    "dropmalcty": "LELAND",
    "dropmalst": "MS",
    "dropmalzpp": 387569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626867616,
    "dropfax": 6626862888
  },
  {
    "dcode": "D",
    "dropkey": "PY13878",
    "droptype": "D",
    "dropname": "LENA",
    "dropdeladd": "51 SUNNYSIDE DR",
    "dropdelcty": "LENA",
    "dropdelst": "MS",
    "dropdelzpp": 390949998,
    "dropphyadd": "51 SUNNYSIDE DR",
    "dropphycty": "LENA",
    "dropphyst": "MS",
    "dropphyzpp": 390949998,
    "dropmaladd": "51 SUNNYSIDE DR",
    "dropmalcty": "LENA",
    "dropmalst": "MS",
    "dropmalzpp": 390949998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016547794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13883",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "107 TCHULA ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "MS",
    "dropdelzpp": 390959998,
    "dropphyadd": "107 TCHULA ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "MS",
    "dropphyzpp": 390959998,
    "dropmaladd": "107 TCHULA ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "MS",
    "dropmalzpp": 390959998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628342385,
    "dropfax": 6628342565
  },
  {
    "dcode": "D",
    "dropkey": "PY13884",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "1010 E MAIN ST",
    "dropdelcty": "LIBERTY",
    "dropdelst": "MS",
    "dropdelzpp": 396459998,
    "dropphyadd": "1010 E MAIN ST",
    "dropphycty": "LIBERTY",
    "dropphyst": "MS",
    "dropphyzpp": 396459998,
    "dropmaladd": "1010 E MAIN ST",
    "dropmalcty": "LIBERTY",
    "dropmalst": "MS",
    "dropmalzpp": 396459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016578371,
    "dropfax": 6016578491
  },
  {
    "dcode": "D",
    "dropkey": "PY13890",
    "droptype": "D",
    "dropname": "LITTLE ROCK",
    "dropdeladd": "45 LITTLE ROCK COUNTY LINE RD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "MS",
    "dropdelzpp": 393379998,
    "dropphyadd": "45 LITTLE ROCK COUNTY LINE RD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "MS",
    "dropphyzpp": 393379998,
    "dropmaladd": "45 LITTLE ROCK COUNTY LINE RD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "MS",
    "dropmalzpp": 393379998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017748667,
    "dropfax": 6017748034
  },
  {
    "dcode": "D",
    "dropkey": "PY13902",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "200 KLONDYKE RD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "MS",
    "dropdelzpp": 395609998,
    "dropphyadd": "200 KLONDYKE RD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "MS",
    "dropphyzpp": 395609998,
    "dropmaladd": "200 KLONDYKE RD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "MS",
    "dropmalzpp": 395609998,
    "dropsitphn": 6013517144,
    "dropsitlph": "",
    "dropsitcph": 2288685419,
    "dropfax": 2288678956
  },
  {
    "dcode": "D",
    "dropkey": "PY13907",
    "droptype": "D",
    "dropname": "LORMAN",
    "dropdeladd": "18933 HIGHWAY 61",
    "dropdelcty": "LORMAN",
    "dropdelst": "MS",
    "dropdelzpp": 390969998,
    "dropphyadd": "18933 HIGHWAY 61",
    "dropphycty": "LORMAN",
    "dropphyst": "MS",
    "dropphyzpp": 390969998,
    "dropmaladd": "18933 HIGHWAY 61",
    "dropmalcty": "LORMAN",
    "dropmalst": "MS",
    "dropmalzpp": 390969998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014373662,
    "dropfax": 6014373662
  },
  {
    "dcode": "D",
    "dropkey": "PY13908",
    "droptype": "D",
    "dropname": "LOUIN",
    "dropdeladd": "4246 HIGHWAY 15",
    "dropdelcty": "LOUIN",
    "dropdelst": "MS",
    "dropdelzpp": 393389998,
    "dropphyadd": "4246 HIGHWAY 15",
    "dropphycty": "LOUIN",
    "dropphyst": "MS",
    "dropphyzpp": 393389998,
    "dropmaladd": "4246 HIGHWAY 15",
    "dropmalcty": "LOUIN",
    "dropmalst": "MS",
    "dropmalzpp": 393389998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017393677,
    "dropfax": 6017393777
  },
  {
    "dcode": "D",
    "dropkey": "PY13909",
    "droptype": "D",
    "dropname": "LOUISE",
    "dropdeladd": "1378 MAIN ST",
    "dropdelcty": "LOUISE",
    "dropdelst": "MS",
    "dropdelzpp": 390979998,
    "dropphyadd": "1378 MAIN ST",
    "dropphycty": "LOUISE",
    "dropphyst": "MS",
    "dropphyzpp": 390979998,
    "dropmaladd": "1378 MAIN ST",
    "dropmalcty": "LOUISE",
    "dropmalst": "MS",
    "dropmalzpp": 390979998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628365440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13910",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "16605 E MAIN ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 393399998,
    "dropphyadd": "16605 E MAIN ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 393399998,
    "dropmaladd": "16605 E MAIN ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 393399998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627732681,
    "dropsitcph": 6627735851,
    "dropfax": 6627739413
  },
  {
    "dcode": "D",
    "dropkey": "PY13915",
    "droptype": "D",
    "dropname": "LUCEDALE",
    "dropdeladd": "209 COX ST",
    "dropdelcty": "LUCEDALE",
    "dropdelst": "MS",
    "dropdelzpp": 394529998,
    "dropphyadd": "209 COX ST",
    "dropphycty": "LUCEDALE",
    "dropphyst": "MS",
    "dropphyzpp": 394529998,
    "dropmaladd": "209 COX ST",
    "dropmalcty": "LUCEDALE",
    "dropmalst": "MS",
    "dropmalzpp": 394529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019472719,
    "dropfax": 6019474049
  },
  {
    "dcode": "D",
    "dropkey": "PY13917",
    "droptype": "D",
    "dropname": "LUDLOW",
    "dropdeladd": "18 LEE RD",
    "dropdelcty": "LUDLOW",
    "dropdelst": "MS",
    "dropdelzpp": 390989998,
    "dropphyadd": "18 LEE RD",
    "dropphycty": "LUDLOW",
    "dropphyst": "MS",
    "dropphyzpp": 390989998,
    "dropmaladd": "18 LEE RD",
    "dropmalcty": "LUDLOW",
    "dropmalst": "MS",
    "dropmalzpp": 390989998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016543440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13920",
    "droptype": "D",
    "dropname": "LUMBERTON",
    "dropdeladd": "7877 U S HIGHWAY 11",
    "dropdelcty": "LUMBERTON",
    "dropdelst": "MS",
    "dropdelzpp": 394559998,
    "dropphyadd": "7877 U S HIGHWAY 11",
    "dropphycty": "LUMBERTON",
    "dropphyst": "MS",
    "dropphyzpp": 394559998,
    "dropmaladd": "7877 U S HIGHWAY 11",
    "dropmalcty": "LUMBERTON",
    "dropmalst": "MS",
    "dropmalzpp": 394559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2282556701,
    "dropsitcph": 2282556701,
    "dropfax": 6017964321
  },
  {
    "dcode": "D",
    "dropkey": "PY13923",
    "droptype": "D",
    "dropname": "LYON",
    "dropdeladd": "109 PARK ST",
    "dropdelcty": "LYON",
    "dropdelst": "MS",
    "dropdelzpp": 386459998,
    "dropphyadd": "109 PARK ST",
    "dropphycty": "LYON",
    "dropphyst": "MS",
    "dropphyzpp": 386459998,
    "dropmaladd": "109 PARK ST",
    "dropmalcty": "LYON",
    "dropmalst": "MS",
    "dropmalzpp": 386459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626273372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13925",
    "droptype": "D",
    "dropname": "MABEN",
    "dropdeladd": "157 WATER ST",
    "dropdelcty": "MABEN",
    "dropdelst": "MS",
    "dropdelzpp": 397509681,
    "dropphyadd": "157 WATER ST",
    "dropphycty": "MABEN",
    "dropphyst": "MS",
    "dropphyzpp": 397509681,
    "dropmaladd": "157 WATER ST",
    "dropmalcty": "MABEN",
    "dropmalst": "MS",
    "dropmalzpp": 397509681,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622638239,
    "dropfax": 6622638239
  },
  {
    "dcode": "D",
    "dropkey": "PY13928",
    "droptype": "D",
    "dropname": "MACON",
    "dropdeladd": "3022 JEFFERSON ST",
    "dropdelcty": "MACON",
    "dropdelst": "MS",
    "dropdelzpp": 393419998,
    "dropphyadd": "3022 JEFFERSON ST",
    "dropphycty": "MACON",
    "dropphyst": "MS",
    "dropphyzpp": 393419998,
    "dropmaladd": "3022 JEFFERSON ST",
    "dropmalcty": "MACON",
    "dropmalst": "MS",
    "dropmalzpp": 393419998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627265420,
    "dropfax": 6627265639
  },
  {
    "dcode": "D",
    "dropkey": "PY13929",
    "droptype": "D",
    "dropname": "MADDEN",
    "dropdeladd": "12424 HIGHWAY 488",
    "dropdelcty": "MADDEN",
    "dropdelst": "MS",
    "dropdelzpp": 391099998,
    "dropphyadd": "12424 HIGHWAY 488",
    "dropphycty": "MADDEN",
    "dropphyst": "MS",
    "dropphyzpp": 391099998,
    "dropmaladd": "12424 HIGHWAY 488",
    "dropmalcty": "MADDEN",
    "dropmalst": "MS",
    "dropmalzpp": 391099998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6012677660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13930",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "990 HIGHWAY 51",
    "dropdelcty": "MADISON",
    "dropdelst": "MS",
    "dropdelzpp": 391109998,
    "dropphyadd": "990 HIGHWAY 51",
    "dropphycty": "MADISON",
    "dropphyst": "MS",
    "dropphyzpp": 391109998,
    "dropmaladd": "990 HIGHWAY 51",
    "dropmalcty": "MADISON",
    "dropmalst": "MS",
    "dropmalzpp": 391109998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018531936,
    "dropsitcph": 6018532403,
    "dropfax": 6018984774
  },
  {
    "dcode": "D",
    "dropkey": "PY13931",
    "droptype": "D",
    "dropname": "MAGEE",
    "dropdeladd": "701 3RD ST SW",
    "dropdelcty": "MAGEE",
    "dropdelst": "MS",
    "dropdelzpp": 391119998,
    "dropphyadd": "701 3RD ST SW",
    "dropphycty": "MAGEE",
    "dropphyst": "MS",
    "dropphyzpp": 391119998,
    "dropmaladd": "701 3RD ST SW",
    "dropmalcty": "MAGEE",
    "dropmalst": "MS",
    "dropmalzpp": 391119998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018493445,
    "dropsitcph": 6018493445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13933",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "205 MAGNOLIA ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "MS",
    "dropdelzpp": 396529998,
    "dropphyadd": "205 MAGNOLIA ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "MS",
    "dropphyzpp": 396529998,
    "dropmaladd": "205 MAGNOLIA ST",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "MS",
    "dropmalzpp": 396529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017833261,
    "dropfax": 6017836823
  },
  {
    "dcode": "D",
    "dropkey": "PY13942",
    "droptype": "D",
    "dropname": "MANTACHIE",
    "dropdeladd": "3664 HIGHWAY 371 N",
    "dropdelcty": "MANTACHIE",
    "dropdelst": "MS",
    "dropdelzpp": 388559998,
    "dropphyadd": "3664 HIGHWAY 371 N",
    "dropphycty": "MANTACHIE",
    "dropphyst": "MS",
    "dropphyzpp": 388559998,
    "dropmaladd": "3664 HIGHWAY 371 N",
    "dropmalcty": "MANTACHIE",
    "dropmalst": "MS",
    "dropmalzpp": 388559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622824412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13943",
    "droptype": "D",
    "dropname": "MANTEE",
    "dropdeladd": "16 FIRST ST",
    "dropdelcty": "MANTEE",
    "dropdelst": "MS",
    "dropdelzpp": 397519998,
    "dropphyadd": "16 FIRST ST",
    "dropphycty": "MANTEE",
    "dropphyst": "MS",
    "dropphyzpp": 397519998,
    "dropmaladd": "16 FIRST ST",
    "dropmalcty": "MANTEE",
    "dropmalst": "MS",
    "dropmalzpp": 397519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624562944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13945",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "5 COUNTY ROAD 4060",
    "dropdelcty": "MARIETTA",
    "dropdelst": "MS",
    "dropdelzpp": 388569998,
    "dropphyadd": "5 COUNTY ROAD 4060",
    "dropphycty": "MARIETTA",
    "dropphyst": "MS",
    "dropphyzpp": 388569998,
    "dropmaladd": "5 COUNTY ROAD 4060",
    "dropmalcty": "MARIETTA",
    "dropmalst": "MS",
    "dropmalzpp": 388569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627289529,
    "dropfax": 6627288283
  },
  {
    "dcode": "D",
    "dropkey": "PY13946",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "5744 DALE DR",
    "dropdelcty": "MARION",
    "dropdelst": "MS",
    "dropdelzpp": 393420358,
    "dropphyadd": "5744 DALE DR",
    "dropphycty": "MARION",
    "dropphyst": "MS",
    "dropphyzpp": 393420358,
    "dropmaladd": "5744 DALE DR",
    "dropmalcty": "MARION",
    "dropmalst": "MS",
    "dropmalzpp": 393420358,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014858511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13947",
    "droptype": "D",
    "dropname": "MARKS",
    "dropdeladd": "423 POPLAR ST",
    "dropdelcty": "MARKS",
    "dropdelst": "MS",
    "dropdelzpp": 386469998,
    "dropphyadd": "423 POPLAR ST",
    "dropphycty": "MARKS",
    "dropphyst": "MS",
    "dropphyzpp": 386469998,
    "dropmaladd": "423 POPLAR ST",
    "dropmalcty": "MARKS",
    "dropmalst": "MS",
    "dropmalzpp": 386469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623265881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13951",
    "droptype": "D",
    "dropname": "MATHISTON",
    "dropdeladd": "24784 MS HIGHWAY 15",
    "dropdelcty": "MATHISTON",
    "dropdelst": "MS",
    "dropdelzpp": 397529998,
    "dropphyadd": "24784 MS HIGHWAY 15",
    "dropphycty": "MATHISTON",
    "dropphyst": "MS",
    "dropphyzpp": 397529998,
    "dropmaladd": "24784 MS HIGHWAY 15",
    "dropmalcty": "MATHISTON",
    "dropmalst": "MS",
    "dropmalzpp": 397529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622638335,
    "dropfax": 6622635190
  },
  {
    "dcode": "D",
    "dropkey": "PY13956",
    "droptype": "D",
    "dropname": "MAYERSVILLE",
    "dropdeladd": "113 COURT ST",
    "dropdelcty": "MAYERSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 391139998,
    "dropphyadd": "113 COURT ST",
    "dropphycty": "MAYERSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 391139998,
    "dropmaladd": "113 COURT ST",
    "dropmalcty": "MAYERSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 391139998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628734576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13959",
    "droptype": "D",
    "dropname": "MAYHEW",
    "dropdeladd": "438 MAYHEW RD",
    "dropdelcty": "MAYHEW",
    "dropdelst": "MS",
    "dropdelzpp": 397539998,
    "dropphyadd": "438 MAYHEW RD",
    "dropphycty": "MAYHEW",
    "dropphyst": "MS",
    "dropphyzpp": 397539998,
    "dropmaladd": "438 MAYHEW RD",
    "dropmalcty": "MAYHEW",
    "dropmalst": "MS",
    "dropmalzpp": 397539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623277019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13961",
    "droptype": "D",
    "dropname": "MC CALL CREEK",
    "dropdeladd": "10790 U S HIGHWAY 84 E",
    "dropdelcty": "MC CALL CREEK",
    "dropdelst": "MS",
    "dropdelzpp": 396479998,
    "dropphyadd": "10790 U S HIGHWAY 84 E",
    "dropphycty": "MC CALL CREEK",
    "dropphyst": "MS",
    "dropphyzpp": 396479998,
    "dropmaladd": "10790 U S HIGHWAY 84 E",
    "dropmalcty": "MC CALL CREEK",
    "dropmalst": "MS",
    "dropmalzpp": 396479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018332499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13962",
    "droptype": "D",
    "dropname": "MC CARLEY",
    "dropdeladd": "4294 COUNTY ROAD 282",
    "dropdelcty": "MC CARLEY",
    "dropdelst": "MS",
    "dropdelzpp": 389439998,
    "dropphyadd": "4294 COUNTY ROAD 282",
    "dropphycty": "MC CARLEY",
    "dropphyst": "MS",
    "dropphyzpp": 389439998,
    "dropmaladd": "4294 COUNTY ROAD 282",
    "dropmalcty": "MC CARLEY",
    "dropmalst": "MS",
    "dropmalzpp": 389439998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622831542,
    "dropfax": 6622831542
  },
  {
    "dcode": "D",
    "dropkey": "PY13964",
    "droptype": "D",
    "dropname": "MCCOMB",
    "dropdeladd": "530 DELAWARE AVE",
    "dropdelcty": "MCCOMB",
    "dropdelst": "MS",
    "dropdelzpp": 396489998,
    "dropphyadd": "530 DELAWARE AVE",
    "dropphycty": "MCCOMB",
    "dropphyst": "MS",
    "dropphyzpp": 396489998,
    "dropmaladd": "530 DELAWARE AVE",
    "dropmalcty": "MCCOMB",
    "dropmalst": "MS",
    "dropmalzpp": 396489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6016842582,
    "dropsitcph": 6016841931,
    "dropfax": 6016844526
  },
  {
    "dcode": "D",
    "dropkey": "PY13966",
    "droptype": "D",
    "dropname": "MC COOL",
    "dropdeladd": "3258 HIGHWAY 407",
    "dropdelcty": "MC COOL",
    "dropdelst": "MS",
    "dropdelzpp": 391089998,
    "dropphyadd": "3258 HIGHWAY 407",
    "dropphycty": "MC COOL",
    "dropphyst": "MS",
    "dropphyzpp": 391089998,
    "dropmaladd": "3258 HIGHWAY 407",
    "dropmalcty": "MC COOL",
    "dropmalst": "MS",
    "dropmalzpp": 391089998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625476601,
    "dropfax": 6625475359
  },
  {
    "dcode": "D",
    "dropkey": "PY13967",
    "droptype": "D",
    "dropname": "MC HENRY",
    "dropdeladd": "16 N MCHENRY AVE",
    "dropdelcty": "MC HENRY",
    "dropdelst": "MS",
    "dropdelzpp": 395619998,
    "dropphyadd": "16 N MCHENRY AVE",
    "dropphycty": "MC HENRY",
    "dropphyst": "MS",
    "dropphyzpp": 395619998,
    "dropmaladd": "16 N MCHENRY AVE",
    "dropmalcty": "MC HENRY",
    "dropmalst": "MS",
    "dropmalzpp": 395619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019283465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13968",
    "droptype": "D",
    "dropname": "MC LAIN",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "MC LAIN",
    "dropdelst": "MS",
    "dropdelzpp": 394569998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "MC LAIN",
    "dropphyst": "MS",
    "dropphyzpp": 394569998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "MC LAIN",
    "dropmalst": "MS",
    "dropmalzpp": 394569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017532793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13969",
    "droptype": "D",
    "dropname": "MC NEILL",
    "dropdeladd": "8032 HIGHWAY 11",
    "dropdelcty": "MC NEILL",
    "dropdelst": "MS",
    "dropdelzpp": 394579998,
    "dropphyadd": "8032 HIGHWAY 11",
    "dropphycty": "MC NEILL",
    "dropphyst": "MS",
    "dropphyzpp": 394579998,
    "dropmaladd": "8032 HIGHWAY 11",
    "dropmalcty": "MC NEILL",
    "dropmalst": "MS",
    "dropmalzpp": 394579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017985962,
    "dropfax": 6017985962
  },
  {
    "dcode": "D",
    "dropkey": "PY13986",
    "droptype": "D",
    "dropname": "MEADVILLE",
    "dropdeladd": "10 FIRST ST",
    "dropdelcty": "MEADVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 396539998,
    "dropphyadd": "10 FIRST ST",
    "dropphycty": "MEADVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 396539998,
    "dropmaladd": "10 FIRST ST",
    "dropmalcty": "MEADVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 396539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013845720,
    "dropfax": 6013844510
  },
  {
    "dcode": "D",
    "dropkey": "PY13991",
    "droptype": "D",
    "dropname": "MENDENHALL",
    "dropdeladd": "1658 SIMPSON HIGHWAY 149",
    "dropdelcty": "MENDENHALL",
    "dropdelst": "MS",
    "dropdelzpp": 391149998,
    "dropphyadd": "1658 SIMPSON HIGHWAY 149",
    "dropphycty": "MENDENHALL",
    "dropphyst": "MS",
    "dropphyzpp": 391149998,
    "dropmaladd": "1658 SIMPSON HIGHWAY 149",
    "dropmalcty": "MENDENHALL",
    "dropmalst": "MS",
    "dropmalzpp": 391149998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018473223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY13993",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "2100 9TH ST",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "MS",
    "dropdelzpp": 393019998,
    "dropphyadd": "2100 9TH ST",
    "dropphycty": "MERIDIAN",
    "dropphyst": "MS",
    "dropphyzpp": 393019998,
    "dropmaladd": "2100 9TH ST",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "MS",
    "dropmalzpp": 393019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015538000,
    "dropsitcph": 6016932581,
    "dropfax": 6015538024
  },
  {
    "dcode": "D",
    "dropkey": "PY13996",
    "droptype": "D",
    "dropname": "MERIGOLD",
    "dropdeladd": "106 E GOFF ST",
    "dropdelcty": "MERIGOLD",
    "dropdelst": "MS",
    "dropdelzpp": 387599998,
    "dropphyadd": "106 E GOFF ST",
    "dropphycty": "MERIGOLD",
    "dropphyst": "MS",
    "dropphyzpp": 387599998,
    "dropmaladd": "106 E GOFF ST",
    "dropmalcty": "MERIGOLD",
    "dropmalst": "MS",
    "dropmalzpp": 387599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627482369,
    "dropfax": 6627482369
  },
  {
    "dcode": "D",
    "dropkey": "PY13999",
    "droptype": "D",
    "dropname": "METCALFE",
    "dropdeladd": "401 METCALFE RD",
    "dropdelcty": "METCALFE",
    "dropdelst": "MS",
    "dropdelzpp": 387609998,
    "dropphyadd": "401 METCALFE RD",
    "dropphycty": "METCALFE",
    "dropphyst": "MS",
    "dropphyzpp": 387609998,
    "dropmaladd": "401 METCALFE RD",
    "dropmalcty": "METCALFE",
    "dropmalst": "MS",
    "dropmalzpp": 387609998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623323338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14001",
    "droptype": "D",
    "dropname": "MICHIGAN CITY",
    "dropdeladd": "73 MAIN ST",
    "dropdelcty": "MICHIGAN CITY",
    "dropdelst": "MS",
    "dropdelzpp": 386479998,
    "dropphyadd": "73 MAIN ST",
    "dropphycty": "MICHIGAN CITY",
    "dropphyst": "MS",
    "dropphyzpp": 386479998,
    "dropmaladd": "73 MAIN ST",
    "dropmalcty": "MICHIGAN CITY",
    "dropmalst": "MS",
    "dropmalzpp": 386479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627682262,
    "dropfax": 6627682262
  },
  {
    "dcode": "D",
    "dropkey": "PY14015",
    "droptype": "D",
    "dropname": "MINTER CITY",
    "dropdeladd": "28771 HIGHWAY 49",
    "dropdelcty": "MINTER CITY",
    "dropdelst": "MS",
    "dropdelzpp": 389449998,
    "dropphyadd": "28771 HIGHWAY 49",
    "dropphycty": "MINTER CITY",
    "dropphyst": "MS",
    "dropphyzpp": 389449998,
    "dropmaladd": "28771 HIGHWAY 49",
    "dropmalcty": "MINTER CITY",
    "dropmalst": "MS",
    "dropmalzpp": 389449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626584544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14024",
    "droptype": "D",
    "dropname": "MISSISSIPPI STATE",
    "dropdeladd": "414 LEE BLVD",
    "dropdelcty": "MISSISSIPPI STATE",
    "dropdelst": "MS",
    "dropdelzpp": 397629611,
    "dropphyadd": "414 LEE BLVD",
    "dropphycty": "MISSISSIPPI STATE",
    "dropphyst": "MS",
    "dropphyzpp": 397629611,
    "dropmaladd": "414 LEE BLVD",
    "dropmalcty": "MISSISSIPPI STATE",
    "dropmalst": "MS",
    "dropmalzpp": 397629611,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623237812,
    "dropsitcph": 6623235772,
    "dropfax": 6623245879
  },
  {
    "dcode": "D",
    "dropkey": "PY14028",
    "droptype": "D",
    "dropname": "MIZE",
    "dropdeladd": "107 N OAK ST",
    "dropdelcty": "MIZE",
    "dropdelst": "MS",
    "dropdelzpp": 391169998,
    "dropphyadd": "107 N OAK ST",
    "dropphycty": "MIZE",
    "dropphyst": "MS",
    "dropphyzpp": 391169998,
    "dropmaladd": "107 N OAK ST",
    "dropmalcty": "MIZE",
    "dropmalst": "MS",
    "dropmalzpp": 391169998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017332292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14034",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "1141 W BROAD ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "MS",
    "dropdelzpp": 396549998,
    "dropphyadd": "1141 W BROAD ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "MS",
    "dropphyzpp": 396549998,
    "dropmaladd": "1141 W BROAD ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "MS",
    "dropmalzpp": 396549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015874595,
    "dropsitcph": 6015874902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14038",
    "droptype": "D",
    "dropname": "MOOREVILLE",
    "dropdeladd": "110 ROAD 1427",
    "dropdelcty": "MOOREVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 388579998,
    "dropphyadd": "110 ROAD 1427",
    "dropphycty": "MOOREVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 388579998,
    "dropmaladd": "110 ROAD 1427",
    "dropmalcty": "MOOREVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 388579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628443125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14041",
    "droptype": "D",
    "dropname": "MOORHEAD",
    "dropdeladd": "900 E DELTA AVE",
    "dropdelcty": "MOORHEAD",
    "dropdelst": "MS",
    "dropdelzpp": 387619998,
    "dropphyadd": "900 E DELTA AVE",
    "dropphycty": "MOORHEAD",
    "dropphyst": "MS",
    "dropphyzpp": 387619998,
    "dropmaladd": "900 E DELTA AVE",
    "dropmalcty": "MOORHEAD",
    "dropmalst": "MS",
    "dropmalzpp": 387619998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6622453866,
    "dropfax": 6622465793
  },
  {
    "dcode": "D",
    "dropkey": "PY14042",
    "droptype": "D",
    "dropname": "MORGAN CITY",
    "dropdeladd": "208 DELTA ST",
    "dropdelcty": "MORGAN CITY",
    "dropdelst": "MS",
    "dropdelzpp": 389469998,
    "dropphyadd": "208 DELTA ST",
    "dropphycty": "MORGAN CITY",
    "dropphyst": "MS",
    "dropphyzpp": 389469998,
    "dropmaladd": "208 DELTA ST",
    "dropmalcty": "MORGAN CITY",
    "dropmalst": "MS",
    "dropmalzpp": 389469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622547253,
    "dropfax": 6622547961
  },
  {
    "dcode": "D",
    "dropkey": "PY14050",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "128 HIGHWAY 481 S",
    "dropdelcty": "MORTON",
    "dropdelst": "MS",
    "dropdelzpp": 391179998,
    "dropphyadd": "128 HIGHWAY 481 S",
    "dropphycty": "MORTON",
    "dropphyst": "MS",
    "dropphyzpp": 391179998,
    "dropmaladd": "128 HIGHWAY 481 S",
    "dropmalcty": "MORTON",
    "dropmalst": "MS",
    "dropmalzpp": 391179998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017326102,
    "dropfax": 6017322246
  },
  {
    "dcode": "D",
    "dropkey": "PY14051",
    "droptype": "D",
    "dropname": "MOSELLE",
    "dropdeladd": "1260 MOSELLE RD",
    "dropdelcty": "MOSELLE",
    "dropdelst": "MS",
    "dropdelzpp": 394599998,
    "dropphyadd": "1260 MOSELLE RD",
    "dropphycty": "MOSELLE",
    "dropphyst": "MS",
    "dropphyzpp": 394599998,
    "dropmaladd": "1260 MOSELLE RD",
    "dropmalcty": "MOSELLE",
    "dropmalst": "MS",
    "dropmalzpp": 394599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015847923,
    "dropfax": 6015823487
  },
  {
    "dcode": "D",
    "dropkey": "PY14055",
    "droptype": "D",
    "dropname": "MOUND BAYOU",
    "dropdeladd": "206 S EDWARDS AVE",
    "dropdelcty": "MOUND BAYOU",
    "dropdelst": "MS",
    "dropdelzpp": 387629998,
    "dropphyadd": "206 S EDWARDS AVE",
    "dropphycty": "MOUND BAYOU",
    "dropphyst": "MS",
    "dropphyzpp": 387629998,
    "dropmaladd": "206 S EDWARDS AVE",
    "dropmalcty": "MOUND BAYOU",
    "dropmalst": "MS",
    "dropmalzpp": 387629998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6625052045,
    "dropfax": 6625052076
  },
  {
    "dcode": "D",
    "dropkey": "PY14060",
    "droptype": "D",
    "dropname": "MOUNT OLIVE",
    "dropdeladd": "408 S MAIN ST",
    "dropdelcty": "MOUNT OLIVE",
    "dropdelst": "MS",
    "dropdelzpp": 391199998,
    "dropphyadd": "408 S MAIN ST",
    "dropphycty": "MOUNT OLIVE",
    "dropphyst": "MS",
    "dropphyzpp": 391199998,
    "dropmaladd": "408 S MAIN ST",
    "dropmalcty": "MOUNT OLIVE",
    "dropmalst": "MS",
    "dropmalzpp": 391199998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017973929,
    "dropfax": 6017974796
  },
  {
    "dcode": "D",
    "dropkey": "PY14082",
    "droptype": "D",
    "dropname": "MYRTLE",
    "dropdeladd": "1183 SPRINGDALE AVE",
    "dropdelcty": "MYRTLE",
    "dropdelst": "MS",
    "dropdelzpp": 386509998,
    "dropphyadd": "1183 SPRINGDALE AVE",
    "dropphycty": "MYRTLE",
    "dropphyst": "MS",
    "dropphyzpp": 386509998,
    "dropmaladd": "1183 SPRINGDALE AVE",
    "dropmalcty": "MYRTLE",
    "dropmalst": "MS",
    "dropmalzpp": 386509998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6629882883,
    "dropfax": 6629883510
  },
  {
    "dcode": "D",
    "dropkey": "PY14088",
    "droptype": "D",
    "dropname": "NATCHEZ",
    "dropdeladd": "214 N CANAL ST",
    "dropdelcty": "NATCHEZ",
    "dropdelst": "MS",
    "dropdelzpp": 391209998,
    "dropphyadd": "214 N CANAL ST",
    "dropphycty": "NATCHEZ",
    "dropphyst": "MS",
    "dropphyzpp": 391209998,
    "dropmaladd": "214 N CANAL ST",
    "dropmalcty": "NATCHEZ",
    "dropmalst": "MS",
    "dropmalzpp": 391209998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6014424362,
    "dropsitcph": 6014424361,
    "dropfax": 6014429959
  },
  {
    "dcode": "D",
    "dropkey": "PY14095",
    "droptype": "D",
    "dropname": "NEELY",
    "dropdeladd": "6427 OLD HIGHWAY 24",
    "dropdelcty": "NEELY",
    "dropdelst": "MS",
    "dropdelzpp": 394619998,
    "dropphyadd": "6427 OLD HIGHWAY 24",
    "dropphycty": "NEELY",
    "dropphyst": "MS",
    "dropphyzpp": 394619998,
    "dropmaladd": "6427 OLD HIGHWAY 24",
    "dropmalcty": "NEELY",
    "dropmalst": "MS",
    "dropmalzpp": 394619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015253950,
    "dropsitcph": 6015253950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14096",
    "droptype": "D",
    "dropname": "NESBIT",
    "dropdeladd": "600 OLD HIGHWAY 51 N",
    "dropdelcty": "NESBIT",
    "dropdelst": "MS",
    "dropdelzpp": 386519998,
    "dropphyadd": "600 OLD HIGHWAY 51 N",
    "dropphycty": "NESBIT",
    "dropphyst": "MS",
    "dropphyzpp": 386519998,
    "dropmaladd": "600 OLD HIGHWAY 51 N",
    "dropmalcty": "NESBIT",
    "dropmalst": "MS",
    "dropmalzpp": 386519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6624299117,
    "dropsitcph": 6624293074,
    "dropfax": 6624293074
  },
  {
    "dcode": "D",
    "dropkey": "PY14098",
    "droptype": "D",
    "dropname": "NETTLETON",
    "dropdeladd": "4540 UNION AVE",
    "dropdelcty": "NETTLETON",
    "dropdelst": "MS",
    "dropdelzpp": 388589998,
    "dropphyadd": "4540 UNION AVE",
    "dropphycty": "NETTLETON",
    "dropphyst": "MS",
    "dropphyzpp": 388589998,
    "dropmaladd": "4540 UNION AVE",
    "dropmalcty": "NETTLETON",
    "dropmalst": "MS",
    "dropmalzpp": 388589998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6629632623,
    "dropfax": 6629633058
  },
  {
    "dcode": "D",
    "dropkey": "PY14099",
    "droptype": "D",
    "dropname": "NEW ALBANY",
    "dropdeladd": "801 E BANKHEAD ST",
    "dropdelcty": "NEW ALBANY",
    "dropdelst": "MS",
    "dropdelzpp": 386529998,
    "dropphyadd": "801 E BANKHEAD ST",
    "dropphycty": "NEW ALBANY",
    "dropphyst": "MS",
    "dropphyzpp": 386529998,
    "dropmaladd": "801 E BANKHEAD ST",
    "dropmalcty": "NEW ALBANY",
    "dropmalst": "MS",
    "dropmalzpp": 386529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625345932,
    "dropfax": 6625380149
  },
  {
    "dcode": "D",
    "dropkey": "PY14100",
    "droptype": "D",
    "dropname": "NEW AUGUSTA",
    "dropdeladd": "103 FIRST ST E",
    "dropdelcty": "NEW AUGUSTA",
    "dropdelst": "MS",
    "dropdelzpp": 394629998,
    "dropphyadd": "103 FIRST ST E",
    "dropphycty": "NEW AUGUSTA",
    "dropphyst": "MS",
    "dropphyzpp": 394629998,
    "dropmaladd": "103 FIRST ST E",
    "dropmalcty": "NEW AUGUSTA",
    "dropmalst": "MS",
    "dropmalzpp": 394629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019643240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14107",
    "droptype": "D",
    "dropname": "NEWHEBRON",
    "dropdeladd": "402 MAIN AVE",
    "dropdelcty": "NEWHEBRON",
    "dropdelst": "MS",
    "dropdelzpp": 391409998,
    "dropphyadd": "402 MAIN AVE",
    "dropphycty": "NEWHEBRON",
    "dropphyst": "MS",
    "dropphyzpp": 391409998,
    "dropmaladd": "402 MAIN AVE",
    "dropmalcty": "NEWHEBRON",
    "dropmalst": "MS",
    "dropmalzpp": 391409998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016942489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14109",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "111 E CHURCH ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "MS",
    "dropdelzpp": 393459998,
    "dropphyadd": "111 E CHURCH ST",
    "dropphycty": "NEWTON",
    "dropphyst": "MS",
    "dropphyzpp": 393459998,
    "dropmaladd": "111 E CHURCH ST",
    "dropmalcty": "NEWTON",
    "dropmalst": "MS",
    "dropmalzpp": 393459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016832751,
    "dropfax": 6016837542
  },
  {
    "dcode": "D",
    "dropkey": "PY14110",
    "droptype": "D",
    "dropname": "NICHOLSON",
    "dropdeladd": "3353 JACKSON LANDING RD",
    "dropdelcty": "NICHOLSON",
    "dropdelst": "MS",
    "dropdelzpp": 394639998,
    "dropphyadd": "3353 JACKSON LANDING RD",
    "dropphycty": "NICHOLSON",
    "dropphyst": "MS",
    "dropphyzpp": 394639998,
    "dropmaladd": "3353 JACKSON LANDING RD",
    "dropmalcty": "NICHOLSON",
    "dropmalst": "MS",
    "dropmalzpp": 394639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017987788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14121",
    "droptype": "D",
    "dropname": "NORTH CARROLLTON",
    "dropdeladd": "101 MCCAIN ST",
    "dropdelcty": "NORTH CARROLLTON",
    "dropdelst": "MS",
    "dropdelzpp": 389479998,
    "dropphyadd": "101 MCCAIN ST",
    "dropphycty": "NORTH CARROLLTON",
    "dropphyst": "MS",
    "dropphyzpp": 389479998,
    "dropmaladd": "101 MCCAIN ST",
    "dropmalcty": "NORTH CARROLLTON",
    "dropmalst": "MS",
    "dropmalzpp": 389479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622376984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14128",
    "droptype": "D",
    "dropname": "NOXAPATER",
    "dropdeladd": "4991 KILPATRICK ST",
    "dropdelcty": "NOXAPATER",
    "dropdelst": "MS",
    "dropdelzpp": 393469998,
    "dropphyadd": "4991 KILPATRICK ST",
    "dropphycty": "NOXAPATER",
    "dropphyst": "MS",
    "dropphyzpp": 393469998,
    "dropmaladd": "4991 KILPATRICK ST",
    "dropmalcty": "NOXAPATER",
    "dropmalst": "MS",
    "dropmalzpp": 393469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627244255,
    "dropfax": 6627242855
  },
  {
    "dcode": "D",
    "dropkey": "PY14134",
    "droptype": "D",
    "dropname": "OAK VALE",
    "dropdeladd": "362 THIRD AVE",
    "dropdelcty": "OAK VALE",
    "dropdelst": "MS",
    "dropdelzpp": 396569998,
    "dropphyadd": "362 THIRD AVE",
    "dropphycty": "OAK VALE",
    "dropphyst": "MS",
    "dropphyzpp": 396569998,
    "dropmaladd": "362 THIRD AVE",
    "dropmalcty": "OAK VALE",
    "dropmalst": "MS",
    "dropmalzpp": 396569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017368812,
    "dropfax": 6017368812
  },
  {
    "dcode": "D",
    "dropkey": "PY14135",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "14125 HICKORY ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "MS",
    "dropdelzpp": 389489998,
    "dropphyadd": "14125 HICKORY ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "MS",
    "dropphyzpp": 389489998,
    "dropmaladd": "14125 HICKORY ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "MS",
    "dropmalzpp": 389489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626239954,
    "dropfax": 6626239954
  },
  {
    "dcode": "D",
    "dropkey": "PY14138",
    "droptype": "D",
    "dropname": "OCEAN SPRINGS",
    "dropdeladd": "1581 BIENVILLE BLVD",
    "dropdelcty": "OCEAN SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 395649998,
    "dropphyadd": "1581 BIENVILLE BLVD",
    "dropphycty": "OCEAN SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 395649998,
    "dropmaladd": "1581 BIENVILLE BLVD",
    "dropmalcty": "OCEAN SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 395649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2288726529,
    "dropsitcph": 2288185291,
    "dropfax": 2288723417
  },
  {
    "dcode": "D",
    "dropkey": "PY14139",
    "droptype": "D",
    "dropname": "OKOLONA",
    "dropdeladd": "319 W MAIN ST",
    "dropdelcty": "OKOLONA",
    "dropdelst": "MS",
    "dropdelzpp": 388609998,
    "dropphyadd": "319 W MAIN ST",
    "dropphycty": "OKOLONA",
    "dropphyst": "MS",
    "dropphyzpp": 388609998,
    "dropmaladd": "319 W MAIN ST",
    "dropmalcty": "OKOLONA",
    "dropmalst": "MS",
    "dropmalzpp": 388609998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624472338,
    "dropfax": 6624472029
  },
  {
    "dcode": "D",
    "dropkey": "PY14149",
    "droptype": "D",
    "dropname": "OLIVE BRANCH",
    "dropdeladd": "8850 MIDSOUTH DR",
    "dropdelcty": "OLIVE BRANCH",
    "dropdelst": "MS",
    "dropdelzpp": 386549998,
    "dropphyadd": "8850 MIDSOUTH DR",
    "dropphycty": "OLIVE BRANCH",
    "dropphyst": "MS",
    "dropphyzpp": 386549998,
    "dropmaladd": "8850 MIDSOUTH DR",
    "dropmalcty": "OLIVE BRANCH",
    "dropmalst": "MS",
    "dropmalzpp": 386549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6628954952,
    "dropsitcph": 6628955966,
    "dropfax": 6628937623
  },
  {
    "dcode": "D",
    "dropkey": "PY14157",
    "droptype": "D",
    "dropname": "OSYKA",
    "dropdeladd": "500 W LIBERTY ST",
    "dropdelcty": "OSYKA",
    "dropdelst": "MS",
    "dropdelzpp": 396579998,
    "dropphyadd": "500 W LIBERTY ST",
    "dropphycty": "OSYKA",
    "dropphyst": "MS",
    "dropphyzpp": 396579998,
    "dropmaladd": "500 W LIBERTY ST",
    "dropmalcty": "OSYKA",
    "dropmalst": "MS",
    "dropmalzpp": 396579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015425756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14159",
    "droptype": "D",
    "dropname": "OVETT",
    "dropdeladd": "3227 OVETT MOSELLE RD",
    "dropdelcty": "OVETT",
    "dropdelst": "MS",
    "dropdelzpp": 394649998,
    "dropphyadd": "3227 OVETT MOSELLE RD",
    "dropphycty": "OVETT",
    "dropphyst": "MS",
    "dropphyzpp": 394649998,
    "dropmaladd": "3227 OVETT MOSELLE RD",
    "dropmalcty": "OVETT",
    "dropmalst": "MS",
    "dropmalzpp": 394649998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6013452374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14162",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "401 MCELROY DR",
    "dropdelcty": "OXFORD",
    "dropdelst": "MS",
    "dropdelzpp": 386559998,
    "dropphyadd": "401 MCELROY DR",
    "dropphycty": "OXFORD",
    "dropphyst": "MS",
    "dropphyzpp": 386559998,
    "dropmaladd": "401 MCELROY DR",
    "dropmalcty": "OXFORD",
    "dropmalst": "MS",
    "dropmalzpp": 386559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622345615,
    "dropsitcph": 6622345615,
    "dropfax": 6622346184
  },
  {
    "dcode": "D",
    "dropkey": "PY14164",
    "droptype": "D",
    "dropname": "PACE",
    "dropdeladd": "329 JENNY WASHINGTON RD",
    "dropdelcty": "PACE",
    "dropdelst": "MS",
    "dropdelzpp": 387649998,
    "dropphyadd": "329 JENNY WASHINGTON RD",
    "dropphycty": "PACE",
    "dropphyst": "MS",
    "dropphyzpp": 387649998,
    "dropmaladd": "329 JENNY WASHINGTON RD",
    "dropmalcty": "PACE",
    "dropmalst": "MS",
    "dropmalzpp": 387649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627236713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14165",
    "droptype": "D",
    "dropname": "PACHUTA",
    "dropdeladd": "201 E MAIN ST",
    "dropdelcty": "PACHUTA",
    "dropdelst": "MS",
    "dropdelzpp": 393479998,
    "dropphyadd": "201 E MAIN ST",
    "dropphycty": "PACHUTA",
    "dropphyst": "MS",
    "dropphyzpp": 393479998,
    "dropmaladd": "201 E MAIN ST",
    "dropmalcty": "PACHUTA",
    "dropmalst": "MS",
    "dropmalzpp": 393479998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017763078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14174",
    "droptype": "D",
    "dropname": "PASCAGOULA",
    "dropdeladd": "911 JACKSON AVE",
    "dropdelcty": "PASCAGOULA",
    "dropdelst": "MS",
    "dropdelzpp": 395679998,
    "dropphyadd": "911 JACKSON AVE",
    "dropphycty": "PASCAGOULA",
    "dropphyst": "MS",
    "dropphyzpp": 395679998,
    "dropmaladd": "911 JACKSON AVE",
    "dropmalcty": "PASCAGOULA",
    "dropmalst": "MS",
    "dropmalzpp": 395679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2287628227,
    "dropsitcph": 2287628227,
    "dropfax": 2287626039
  },
  {
    "dcode": "D",
    "dropkey": "PY14176",
    "droptype": "D",
    "dropname": "PASS CHRISTIAN",
    "dropdeladd": "300 LADNIER ST",
    "dropdelcty": "PASS CHRISTIAN",
    "dropdelst": "MS",
    "dropdelzpp": 395719998,
    "dropphyadd": "300 LADNIER ST",
    "dropphycty": "PASS CHRISTIAN",
    "dropphyst": "MS",
    "dropphyzpp": 395719998,
    "dropmaladd": "300 LADNIER ST",
    "dropmalcty": "PASS CHRISTIAN",
    "dropmalst": "MS",
    "dropmalzpp": 395719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2284529432,
    "dropsitcph": 2284529432,
    "dropfax": 2284529514
  },
  {
    "dcode": "D",
    "dropkey": "PY14179",
    "droptype": "D",
    "dropname": "PATTISON",
    "dropdeladd": "10035 HIGHWAY 547",
    "dropdelcty": "PATTISON",
    "dropdelst": "MS",
    "dropdelzpp": 391449998,
    "dropphyadd": "10035 HIGHWAY 547",
    "dropphycty": "PATTISON",
    "dropphyst": "MS",
    "dropphyzpp": 391449998,
    "dropmaladd": "10035 HIGHWAY 547",
    "dropmalcty": "PATTISON",
    "dropmalst": "MS",
    "dropmalzpp": 391449998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014378184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14181",
    "droptype": "D",
    "dropname": "PAULDING",
    "dropdeladd": "1783 HIGHWAY 503",
    "dropdelcty": "PAULDING",
    "dropdelst": "MS",
    "dropdelzpp": 393489998,
    "dropphyadd": "1783 HIGHWAY 503",
    "dropphycty": "PAULDING",
    "dropphyst": "MS",
    "dropphyzpp": 393489998,
    "dropmaladd": "1783 HIGHWAY 503",
    "dropmalcty": "PAULDING",
    "dropmalst": "MS",
    "dropmalzpp": 393489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017279850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14189",
    "droptype": "D",
    "dropname": "PELAHATCHIE",
    "dropdeladd": "801 SECOND ST",
    "dropdelcty": "PELAHATCHIE",
    "dropdelst": "MS",
    "dropdelzpp": 391459998,
    "dropphyadd": "801 SECOND ST",
    "dropphycty": "PELAHATCHIE",
    "dropphyst": "MS",
    "dropphyzpp": 391459998,
    "dropmaladd": "801 SECOND ST",
    "dropmalcty": "PELAHATCHIE",
    "dropmalst": "MS",
    "dropmalzpp": 391459998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018548675,
    "dropsitcph": 6018547395,
    "dropfax": 6018548675
  },
  {
    "dcode": "D",
    "dropkey": "PY14196",
    "droptype": "D",
    "dropname": "PERKINSTON",
    "dropdeladd": "145 MAIN ST",
    "dropdelcty": "PERKINSTON",
    "dropdelst": "MS",
    "dropdelzpp": 395739998,
    "dropphyadd": "145 MAIN ST",
    "dropphycty": "PERKINSTON",
    "dropphyst": "MS",
    "dropphyzpp": 395739998,
    "dropmaladd": "145 MAIN ST",
    "dropmalcty": "PERKINSTON",
    "dropmalst": "MS",
    "dropmalzpp": 395739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019283962,
    "dropfax": 6015289101
  },
  {
    "dcode": "D",
    "dropkey": "PY14199",
    "droptype": "D",
    "dropname": "PETAL",
    "dropdeladd": "121 MORRIS ST",
    "dropdelcty": "PETAL",
    "dropdelst": "MS",
    "dropdelzpp": 394659998,
    "dropphyadd": "121 MORRIS ST",
    "dropphycty": "PETAL",
    "dropphyst": "MS",
    "dropphyzpp": 394659998,
    "dropmaladd": "121 MORRIS ST",
    "dropmalcty": "PETAL",
    "dropmalst": "MS",
    "dropmalzpp": 394659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015847415,
    "dropsitcph": 6015823618,
    "dropfax": 6015829691
  },
  {
    "dcode": "D",
    "dropkey": "PY14200",
    "droptype": "D",
    "dropname": "PHEBA",
    "dropdeladd": "101 N BEASLEY RD",
    "dropdelcty": "PHEBA",
    "dropdelst": "MS",
    "dropdelzpp": 397559998,
    "dropphyadd": "101 N BEASLEY RD",
    "dropphycty": "PHEBA",
    "dropphyst": "MS",
    "dropphyzpp": 397559998,
    "dropmaladd": "101 N BEASLEY RD",
    "dropmalcty": "PHEBA",
    "dropmalst": "MS",
    "dropmalzpp": 397559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624946713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14202",
    "droptype": "D",
    "dropname": "PHILADELPHIA",
    "dropdeladd": "1 GOVERNMENT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "MS",
    "dropdelzpp": 393509998,
    "dropphyadd": "1 GOVERNMENT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "MS",
    "dropphyzpp": 393509998,
    "dropmaladd": "1 GOVERNMENT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "MS",
    "dropmalzpp": 393509998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016563441,
    "dropfax": 6016563938
  },
  {
    "dcode": "D",
    "dropkey": "PY14203",
    "droptype": "D",
    "dropname": "PHILIPP",
    "dropdeladd": "1277 MS HIGHWAY 8",
    "dropdelcty": "PHILIPP",
    "dropdelst": "MS",
    "dropdelzpp": 389509998,
    "dropphyadd": "1277 MS HIGHWAY 8",
    "dropphycty": "PHILIPP",
    "dropphyst": "MS",
    "dropphyzpp": 389509998,
    "dropmaladd": "1277 MS HIGHWAY 8",
    "dropmalcty": "PHILIPP",
    "dropmalst": "MS",
    "dropmalzpp": 389509998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626583346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14206",
    "droptype": "D",
    "dropname": "PICAYUNE",
    "dropdeladd": "120 HIGHWAY 11 N",
    "dropdelcty": "PICAYUNE",
    "dropdelst": "MS",
    "dropdelzpp": 394669998,
    "dropphyadd": "120 HIGHWAY 11 N",
    "dropphycty": "PICAYUNE",
    "dropphyst": "MS",
    "dropphyzpp": 394669998,
    "dropmaladd": "120 HIGHWAY 11 N",
    "dropmalcty": "PICAYUNE",
    "dropmalst": "MS",
    "dropmalzpp": 394669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017982889,
    "dropsitcph": 6017987401,
    "dropfax": 6017989875
  },
  {
    "dcode": "D",
    "dropkey": "PY14207",
    "droptype": "D",
    "dropname": "PICKENS",
    "dropdeladd": "121 LEXINGTON ST",
    "dropdelcty": "PICKENS",
    "dropdelst": "MS",
    "dropdelzpp": 391469998,
    "dropphyadd": "121 LEXINGTON ST",
    "dropphycty": "PICKENS",
    "dropphyst": "MS",
    "dropphyzpp": 391469998,
    "dropmaladd": "121 LEXINGTON ST",
    "dropmalcty": "PICKENS",
    "dropmalst": "MS",
    "dropmalzpp": 391469998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624682523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14223",
    "droptype": "D",
    "dropname": "PINEY WOODS",
    "dropdeladd": "11 WARD LN",
    "dropdelcty": "PINEY WOODS",
    "dropdelst": "MS",
    "dropdelzpp": 391489998,
    "dropphyadd": "11 WARD LN",
    "dropphycty": "PINEY WOODS",
    "dropphyst": "MS",
    "dropphyzpp": 391489998,
    "dropmaladd": "11 WARD LN",
    "dropmalcty": "PINEY WOODS",
    "dropmalst": "MS",
    "dropmalzpp": 391489998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018452415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14224",
    "droptype": "D",
    "dropname": "PINOLA",
    "dropdeladd": "2267 SIMPSON HIGHWAY 28 W",
    "dropdelcty": "PINOLA",
    "dropdelst": "MS",
    "dropdelzpp": 391499998,
    "dropphyadd": "2267 SIMPSON HIGHWAY 28 W",
    "dropphycty": "PINOLA",
    "dropphyst": "MS",
    "dropphyzpp": 391499998,
    "dropmaladd": "2267 SIMPSON HIGHWAY 28 W",
    "dropmalcty": "PINOLA",
    "dropmalst": "MS",
    "dropmalzpp": 391499998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018474872,
    "dropfax": 6018470586
  },
  {
    "dcode": "D",
    "dropkey": "PY14228",
    "droptype": "D",
    "dropname": "PITTSBORO",
    "dropdeladd": "104 N MURPHREE ST",
    "dropdelcty": "PITTSBORO",
    "dropdelst": "MS",
    "dropdelzpp": 389519998,
    "dropphyadd": "104 N MURPHREE ST",
    "dropphycty": "PITTSBORO",
    "dropphyst": "MS",
    "dropphyzpp": 389519998,
    "dropmaladd": "104 N MURPHREE ST",
    "dropmalcty": "PITTSBORO",
    "dropmalst": "MS",
    "dropmalzpp": 389519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624122772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14231",
    "droptype": "D",
    "dropname": "PLANTERSVILLE",
    "dropdeladd": "2540 MAIN ST",
    "dropdelcty": "PLANTERSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 388629998,
    "dropphyadd": "2540 MAIN ST",
    "dropphycty": "PLANTERSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 388629998,
    "dropmaladd": "2540 MAIN ST",
    "dropmalcty": "PLANTERSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 388629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628442096,
    "dropfax": 6628427858
  },
  {
    "dcode": "D",
    "dropkey": "PY14246",
    "droptype": "D",
    "dropname": "PONTOTOC",
    "dropdeladd": "305 HIGHWAY 15 N",
    "dropdelcty": "PONTOTOC",
    "dropdelst": "MS",
    "dropdelzpp": 388639998,
    "dropphyadd": "305 HIGHWAY 15 N",
    "dropphycty": "PONTOTOC",
    "dropphyst": "MS",
    "dropphyzpp": 388639998,
    "dropmaladd": "305 HIGHWAY 15 N",
    "dropmalcty": "PONTOTOC",
    "dropmalst": "MS",
    "dropmalzpp": 388639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624894811,
    "dropfax": 6624888158
  },
  {
    "dcode": "D",
    "dropkey": "PY14247",
    "droptype": "D",
    "dropname": "POPE",
    "dropdeladd": "774 MAIN ST",
    "dropdelcty": "POPE",
    "dropdelst": "MS",
    "dropdelzpp": 386589998,
    "dropphyadd": "774 MAIN ST",
    "dropphycty": "POPE",
    "dropphyst": "MS",
    "dropphyzpp": 386589998,
    "dropmaladd": "774 MAIN ST",
    "dropmalcty": "POPE",
    "dropmalst": "MS",
    "dropmalzpp": 386589998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625634014,
    "dropfax": 6625634014
  },
  {
    "dcode": "D",
    "dropkey": "PY14253",
    "droptype": "D",
    "dropname": "POPLARVILLE",
    "dropdeladd": "301 S MAIN ST",
    "dropdelcty": "POPLARVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 394709998,
    "dropphyadd": "301 S MAIN ST",
    "dropphycty": "POPLARVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 394709998,
    "dropmaladd": "301 S MAIN ST",
    "dropmalcty": "POPLARVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 394709998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017954961,
    "dropfax": 6017956245
  },
  {
    "dcode": "D",
    "dropkey": "PY14256",
    "droptype": "D",
    "dropname": "PORT GIBSON",
    "dropdeladd": "501 MARKET ST",
    "dropdelcty": "PORT GIBSON",
    "dropdelst": "MS",
    "dropdelzpp": 391509998,
    "dropphyadd": "501 MARKET ST",
    "dropphycty": "PORT GIBSON",
    "dropphyst": "MS",
    "dropphyzpp": 391509998,
    "dropmaladd": "501 MARKET ST",
    "dropmalcty": "PORT GIBSON",
    "dropmalst": "MS",
    "dropmalzpp": 391509998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014375801,
    "dropfax": 6014378230
  },
  {
    "dcode": "D",
    "dropkey": "PY14257",
    "droptype": "D",
    "dropname": "PORTERVILLE",
    "dropdeladd": "54 PORTERVILLE RD",
    "dropdelcty": "PORTERVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 393529998,
    "dropphyadd": "54 PORTERVILLE RD",
    "dropphycty": "PORTERVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 393529998,
    "dropmaladd": "54 PORTERVILLE RD",
    "dropmalcty": "PORTERVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 393529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624765730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14262",
    "droptype": "D",
    "dropname": "POTTS CAMP",
    "dropdeladd": "24 S CENTER ST",
    "dropdelcty": "POTTS CAMP",
    "dropdelst": "MS",
    "dropdelzpp": 386599998,
    "dropphyadd": "24 S CENTER ST",
    "dropphycty": "POTTS CAMP",
    "dropphyst": "MS",
    "dropphyzpp": 386599998,
    "dropmaladd": "24 S CENTER ST",
    "dropmalcty": "POTTS CAMP",
    "dropmalst": "MS",
    "dropmalzpp": 386599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623337918,
    "dropfax": 6623336353
  },
  {
    "dcode": "D",
    "dropkey": "PY14267",
    "droptype": "D",
    "dropname": "PRAIRIE",
    "dropdeladd": "10177 HIGHWAY 382",
    "dropdelcty": "PRAIRIE",
    "dropdelst": "MS",
    "dropdelzpp": 397569998,
    "dropphyadd": "10177 HIGHWAY 382",
    "dropphycty": "PRAIRIE",
    "dropphyst": "MS",
    "dropphyzpp": 397569998,
    "dropmaladd": "10177 HIGHWAY 382",
    "dropmalcty": "PRAIRIE",
    "dropmalst": "MS",
    "dropmalzpp": 397569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623692329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14268",
    "droptype": "D",
    "dropname": "PRENTISS",
    "dropdeladd": "2112 MOUNT CARMEL AVE",
    "dropdelcty": "PRENTISS",
    "dropdelst": "MS",
    "dropdelzpp": 394749998,
    "dropphyadd": "2112 MOUNT CARMEL AVE",
    "dropphycty": "PRENTISS",
    "dropphyst": "MS",
    "dropphyzpp": 394749998,
    "dropmaladd": "2112 MOUNT CARMEL AVE",
    "dropmalcty": "PRENTISS",
    "dropmalst": "MS",
    "dropmalzpp": 394749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017925870,
    "dropfax": 6017922953
  },
  {
    "dcode": "D",
    "dropkey": "PY14269",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "10816 HIGHWAY 397",
    "dropdelcty": "PRESTON",
    "dropdelst": "MS",
    "dropdelzpp": 393549998,
    "dropphyadd": "10816 HIGHWAY 397",
    "dropphycty": "PRESTON",
    "dropphyst": "MS",
    "dropphyzpp": 393549998,
    "dropmaladd": "10816 HIGHWAY 397",
    "dropmalcty": "PRESTON",
    "dropmalst": "MS",
    "dropmalzpp": 393549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016773858,
    "dropfax": 6016773944
  },
  {
    "dcode": "D",
    "dropkey": "PY14274",
    "droptype": "D",
    "dropname": "PUCKETT",
    "dropdeladd": "1086 HIGHWAY 13 N",
    "dropdelcty": "PUCKETT",
    "dropdelst": "MS",
    "dropdelzpp": 391519998,
    "dropphyadd": "1086 HIGHWAY 13 N",
    "dropphycty": "PUCKETT",
    "dropphyst": "MS",
    "dropphyzpp": 391519998,
    "dropmaladd": "1086 HIGHWAY 13 N",
    "dropmalcty": "PUCKETT",
    "dropmalst": "MS",
    "dropmalzpp": 391519998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018257550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14275",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "7052 HIGHWAY 481 S",
    "dropdelcty": "PULASKI",
    "dropdelst": "MS",
    "dropdelzpp": 391529998,
    "dropphyadd": "7052 HIGHWAY 481 S",
    "dropphycty": "PULASKI",
    "dropphyst": "MS",
    "dropphyzpp": 391529998,
    "dropmaladd": "7052 HIGHWAY 481 S",
    "dropmalcty": "PULASKI",
    "dropmalst": "MS",
    "dropmalzpp": 391529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017322302,
    "dropsitcph": 6017328041,
    "dropfax": 6017328041
  },
  {
    "dcode": "D",
    "dropkey": "PY14278",
    "droptype": "D",
    "dropname": "PURVIS",
    "dropdeladd": "5851 US HIGHWAY 11",
    "dropdelcty": "PURVIS",
    "dropdelst": "MS",
    "dropdelzpp": 394759998,
    "dropphyadd": "5851 US HIGHWAY 11",
    "dropphycty": "PURVIS",
    "dropphyst": "MS",
    "dropphyzpp": 394759998,
    "dropmaladd": "5851 US HIGHWAY 11",
    "dropmalcty": "PURVIS",
    "dropmalst": "MS",
    "dropmalzpp": 394759998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017946411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14282",
    "droptype": "D",
    "dropname": "QUITMAN",
    "dropdeladd": "103 S ARCHUSA AVE",
    "dropdelcty": "QUITMAN",
    "dropdelst": "MS",
    "dropdelzpp": 393559998,
    "dropphyadd": "103 S ARCHUSA AVE",
    "dropphycty": "QUITMAN",
    "dropphyst": "MS",
    "dropphyzpp": 393559998,
    "dropmaladd": "103 S ARCHUSA AVE",
    "dropmalcty": "QUITMAN",
    "dropmalst": "MS",
    "dropmalzpp": 393559998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017683515,
    "dropsitcph": 6017766281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14285",
    "droptype": "D",
    "dropname": "RALEIGH",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "RALEIGH",
    "dropdelst": "MS",
    "dropdelzpp": 391539998,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "RALEIGH",
    "dropphyst": "MS",
    "dropphyzpp": 391539998,
    "dropmaladd": "111 MAIN ST",
    "dropmalcty": "RALEIGH",
    "dropmalst": "MS",
    "dropmalzpp": 391539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017824562,
    "dropfax": 6017829750
  },
  {
    "dcode": "D",
    "dropkey": "PY14286",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "213 RANDOLPH LOOP",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "MS",
    "dropdelzpp": 388649998,
    "dropphyadd": "213 RANDOLPH LOOP",
    "dropphycty": "RANDOLPH",
    "dropphyst": "MS",
    "dropphyzpp": 388649998,
    "dropmaladd": "213 RANDOLPH LOOP",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "MS",
    "dropmalzpp": 388649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624896662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14289",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "115 PORT GIBSON ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "MS",
    "dropdelzpp": 391549998,
    "dropphyadd": "115 PORT GIBSON ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "MS",
    "dropphyzpp": 391549998,
    "dropmaladd": "115 PORT GIBSON ST",
    "dropmalcty": "RAYMOND",
    "dropmalst": "MS",
    "dropmalzpp": 391549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018575602,
    "dropsitcph": 6018570124,
    "dropfax": 6018575602
  },
  {
    "dcode": "D",
    "dropkey": "PY14290",
    "droptype": "D",
    "dropname": "RED BANKS",
    "dropdeladd": "406 YARBROUGH LOOP",
    "dropdelcty": "RED BANKS",
    "dropdelst": "MS",
    "dropdelzpp": 386619998,
    "dropphyadd": "406 YARBROUGH LOOP",
    "dropphycty": "RED BANKS",
    "dropphyst": "MS",
    "dropphyzpp": 386619998,
    "dropmaladd": "406 YARBROUGH LOOP",
    "dropmalcty": "RED BANKS",
    "dropmalst": "MS",
    "dropmalzpp": 386619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622521262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14293",
    "droptype": "D",
    "dropname": "REDWOOD",
    "dropdeladd": "340 OLD HIGHWAY 3",
    "dropdelcty": "REDWOOD",
    "dropdelst": "MS",
    "dropdelzpp": 391569998,
    "dropphyadd": "340 OLD HIGHWAY 3",
    "dropphycty": "REDWOOD",
    "dropphyst": "MS",
    "dropphyzpp": 391569998,
    "dropmaladd": "340 OLD HIGHWAY 3",
    "dropmalcty": "REDWOOD",
    "dropmalst": "MS",
    "dropmalzpp": 391569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016384317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14297",
    "droptype": "D",
    "dropname": "RENA LARA",
    "dropdeladd": "3291 HIGHWAY 1",
    "dropdelcty": "RENA LARA",
    "dropdelst": "MS",
    "dropdelzpp": 387679998,
    "dropphyadd": "3291 HIGHWAY 1",
    "dropphycty": "RENA LARA",
    "dropphyst": "MS",
    "dropphyzpp": 387679998,
    "dropmaladd": "3291 HIGHWAY 1",
    "dropmalcty": "RENA LARA",
    "dropmalst": "MS",
    "dropmalzpp": 387679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626242627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14307",
    "droptype": "D",
    "dropname": "RICHTON",
    "dropdeladd": "201 FRONT ST",
    "dropdelcty": "RICHTON",
    "dropdelst": "MS",
    "dropdelzpp": 394769998,
    "dropphyadd": "201 FRONT ST",
    "dropphycty": "RICHTON",
    "dropphyst": "MS",
    "dropphyzpp": 394769998,
    "dropmaladd": "201 FRONT ST",
    "dropmalcty": "RICHTON",
    "dropmalst": "MS",
    "dropmalzpp": 394769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2283747276,
    "dropsitcph": 6017886042,
    "dropfax": 6017882825
  },
  {
    "dcode": "D",
    "dropkey": "PY14308",
    "droptype": "D",
    "dropname": "RIDGELAND",
    "dropdeladd": "611 S PEAR ORCHARD RD",
    "dropdelcty": "RIDGELAND",
    "dropdelst": "MS",
    "dropdelzpp": 391579998,
    "dropphyadd": "611 S PEAR ORCHARD RD",
    "dropphycty": "RIDGELAND",
    "dropphyst": "MS",
    "dropphyzpp": 391579998,
    "dropmaladd": "611 S PEAR ORCHARD RD",
    "dropmalcty": "RIDGELAND",
    "dropmalst": "MS",
    "dropmalzpp": 391579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019566048,
    "dropsitcph": 6019910249,
    "dropfax": 6019572986
  },
  {
    "dcode": "D",
    "dropkey": "PY14309",
    "droptype": "D",
    "dropname": "RIENZI",
    "dropdeladd": "73 S FRONT ST",
    "dropdelcty": "RIENZI",
    "dropdelst": "MS",
    "dropdelzpp": 388659998,
    "dropphyadd": "73 S FRONT ST",
    "dropphycty": "RIENZI",
    "dropphyst": "MS",
    "dropphyzpp": 388659998,
    "dropmaladd": "73 S FRONT ST",
    "dropmalcty": "RIENZI",
    "dropmalst": "MS",
    "dropmalzpp": 388659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624627452,
    "dropfax": 6624625688
  },
  {
    "dcode": "D",
    "dropkey": "PY14310",
    "droptype": "D",
    "dropname": "RIPLEY",
    "dropdeladd": "919 CITY AVE S",
    "dropdelcty": "RIPLEY",
    "dropdelst": "MS",
    "dropdelzpp": 386639998,
    "dropphyadd": "919 CITY AVE S",
    "dropphycty": "RIPLEY",
    "dropphyst": "MS",
    "dropphyzpp": 386639998,
    "dropmaladd": "919 CITY AVE S",
    "dropmalcty": "RIPLEY",
    "dropmalst": "MS",
    "dropmalzpp": 386639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628379461,
    "dropfax": 6625121957
  },
  {
    "dcode": "D",
    "dropkey": "PY14313",
    "droptype": "D",
    "dropname": "ROBINSONVILLE",
    "dropdeladd": "11457 OLD HIGHWAY 61 N",
    "dropdelcty": "ROBINSONVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 386649998,
    "dropphyadd": "11457 OLD HIGHWAY 61 N",
    "dropphycty": "ROBINSONVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 386649998,
    "dropmaladd": "11457 OLD HIGHWAY 61 N",
    "dropmalcty": "ROBINSONVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 386649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623631709,
    "dropsitcph": 6623631709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14322",
    "droptype": "D",
    "dropname": "ROLLING FORK",
    "dropdeladd": "138 WALNUT ST",
    "dropdelcty": "ROLLING FORK",
    "dropdelst": "MS",
    "dropdelzpp": 391599998,
    "dropphyadd": "138 WALNUT ST",
    "dropphycty": "ROLLING FORK",
    "dropphyst": "MS",
    "dropphyzpp": 391599998,
    "dropmaladd": "138 WALNUT ST",
    "dropmalcty": "ROLLING FORK",
    "dropmalst": "MS",
    "dropmalzpp": 391599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6628732574,
    "dropsitcph": 6628734044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14324",
    "droptype": "D",
    "dropname": "ROME",
    "dropdeladd": "800 BALTZER ROME RD",
    "dropdelcty": "ROME",
    "dropdelst": "MS",
    "dropdelzpp": 387689998,
    "dropphyadd": "800 BALTZER ROME RD",
    "dropphycty": "ROME",
    "dropphyst": "MS",
    "dropphyzpp": 387689998,
    "dropmaladd": "800 BALTZER ROME RD",
    "dropmalcty": "ROME",
    "dropmalst": "MS",
    "dropmalzpp": 387689998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623456332,
    "dropfax": 6623456332
  },
  {
    "dcode": "D",
    "dropkey": "PY14325",
    "droptype": "D",
    "dropname": "ROSE HILL",
    "dropdeladd": "4698 HIGHWAY 18",
    "dropdelcty": "ROSE HILL",
    "dropdelst": "MS",
    "dropdelzpp": 393569998,
    "dropphyadd": "4698 HIGHWAY 18",
    "dropphycty": "ROSE HILL",
    "dropphyst": "MS",
    "dropphyzpp": 393569998,
    "dropmaladd": "4698 HIGHWAY 18",
    "dropmalcty": "ROSE HILL",
    "dropmalst": "MS",
    "dropmalzpp": 393569998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017273351,
    "dropfax": 6017273351
  },
  {
    "dcode": "D",
    "dropkey": "PY14328",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "700 FRONT ST",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "MS",
    "dropdelzpp": 387699998,
    "dropphyadd": "700 FRONT ST",
    "dropphycty": "ROSEDALE",
    "dropphyst": "MS",
    "dropphyzpp": 387699998,
    "dropmaladd": "700 FRONT ST",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "MS",
    "dropmalzpp": 387699998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627593373,
    "dropfax": 6627593373
  },
  {
    "dcode": "D",
    "dropkey": "PY14334",
    "droptype": "D",
    "dropname": "ROXIE",
    "dropdeladd": "83 EAST BLVD",
    "dropdelcty": "ROXIE",
    "dropdelst": "MS",
    "dropdelzpp": 396619998,
    "dropphyadd": "83 EAST BLVD",
    "dropphycty": "ROXIE",
    "dropphyst": "MS",
    "dropphyzpp": 396619998,
    "dropmaladd": "83 EAST BLVD",
    "dropmalcty": "ROXIE",
    "dropmalst": "MS",
    "dropmalzpp": 396619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013227741,
    "dropfax": 6013227247
  },
  {
    "dcode": "D",
    "dropkey": "PY14336",
    "droptype": "D",
    "dropname": "RULEVILLE",
    "dropdeladd": "115 N CHESTER AVE",
    "dropdelcty": "RULEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387719998,
    "dropphyadd": "115 N CHESTER AVE",
    "dropphycty": "RULEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387719998,
    "dropmaladd": "115 N CHESTER AVE",
    "dropmalcty": "RULEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627562511,
    "dropfax": 6627564671
  },
  {
    "dcode": "D",
    "dropkey": "PY14340",
    "droptype": "D",
    "dropname": "RUTH",
    "dropdeladd": "3663 HIGHWAY 583 SE",
    "dropdelcty": "RUTH",
    "dropdelst": "MS",
    "dropdelzpp": 396629998,
    "dropphyadd": "3663 HIGHWAY 583 SE",
    "dropphycty": "RUTH",
    "dropphyst": "MS",
    "dropphyzpp": 396629998,
    "dropmaladd": "3663 HIGHWAY 583 SE",
    "dropmalcty": "RUTH",
    "dropmalst": "MS",
    "dropmalzpp": 396629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017346348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14348",
    "droptype": "D",
    "dropname": "SALLIS",
    "dropdeladd": "6285 FRONT ST",
    "dropdelcty": "SALLIS",
    "dropdelst": "MS",
    "dropdelzpp": 391609998,
    "dropphyadd": "6285 FRONT ST",
    "dropphycty": "SALLIS",
    "dropphyst": "MS",
    "dropphyzpp": 391609998,
    "dropmaladd": "6285 FRONT ST",
    "dropmalcty": "SALLIS",
    "dropmalst": "MS",
    "dropmalzpp": 391609998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622893523,
    "dropfax": 6622893523
  },
  {
    "dcode": "D",
    "dropkey": "PY14349",
    "droptype": "D",
    "dropname": "SALTILLO",
    "dropdeladd": "162 MOBILE ST",
    "dropdelcty": "SALTILLO",
    "dropdelst": "MS",
    "dropdelzpp": 388669998,
    "dropphyadd": "162 MOBILE ST",
    "dropphycty": "SALTILLO",
    "dropphyst": "MS",
    "dropphyzpp": 388669998,
    "dropmaladd": "162 MOBILE ST",
    "dropmalcty": "SALTILLO",
    "dropmalst": "MS",
    "dropmalzpp": 388669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628695111,
    "dropfax": 6628693743
  },
  {
    "dcode": "D",
    "dropkey": "PY14353",
    "droptype": "D",
    "dropname": "SANDERSVILLE",
    "dropdeladd": "201 N FRONT ST",
    "dropdelcty": "SANDERSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 394779998,
    "dropphyadd": "201 N FRONT ST",
    "dropphycty": "SANDERSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 394779998,
    "dropmaladd": "201 N FRONT ST",
    "dropmalcty": "SANDERSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 394779998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014266773,
    "dropfax": 6014266773
  },
  {
    "dcode": "D",
    "dropkey": "PY14356",
    "droptype": "D",
    "dropname": "SANDHILL",
    "dropdeladd": "189 CARTER STORE RD",
    "dropdelcty": "SANDHILL",
    "dropdelst": "MS",
    "dropdelzpp": 391619998,
    "dropphyadd": "189 CARTER STORE RD",
    "dropphycty": "SANDHILL",
    "dropphyst": "MS",
    "dropphyzpp": 391619998,
    "dropmaladd": "189 CARTER STORE RD",
    "dropmalcty": "SANDHILL",
    "dropmalst": "MS",
    "dropmalzpp": 391619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018291902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14357",
    "droptype": "D",
    "dropname": "SANDY HOOK",
    "dropdeladd": "480 JOHN FORD HOME RD",
    "dropdelcty": "SANDY HOOK",
    "dropdelst": "MS",
    "dropdelzpp": 394789998,
    "dropphyadd": "480 JOHN FORD HOME RD",
    "dropphycty": "SANDY HOOK",
    "dropphyst": "MS",
    "dropphyzpp": 394789998,
    "dropmaladd": "480 JOHN FORD HOME RD",
    "dropmalcty": "SANDY HOOK",
    "dropmalst": "MS",
    "dropmalzpp": 394789998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017369670,
    "dropfax": 6017369523
  },
  {
    "dcode": "D",
    "dropkey": "PY14361",
    "droptype": "D",
    "dropname": "SARAH",
    "dropdeladd": "1353 SARAH RD",
    "dropdelcty": "SARAH",
    "dropdelst": "MS",
    "dropdelzpp": 386659998,
    "dropphyadd": "1353 SARAH RD",
    "dropphycty": "SARAH",
    "dropphyst": "MS",
    "dropphyzpp": 386659998,
    "dropmaladd": "1353 SARAH RD",
    "dropmalcty": "SARAH",
    "dropmalst": "MS",
    "dropmalzpp": 386659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623825372,
    "dropfax": 6623827169
  },
  {
    "dcode": "D",
    "dropkey": "PY14362",
    "droptype": "D",
    "dropname": "SARDIS",
    "dropdeladd": "209 S MAIN ST",
    "dropdelcty": "SARDIS",
    "dropdelst": "MS",
    "dropdelzpp": 386669998,
    "dropphyadd": "209 S MAIN ST",
    "dropphycty": "SARDIS",
    "dropphyst": "MS",
    "dropphyzpp": 386669998,
    "dropmaladd": "209 S MAIN ST",
    "dropmalcty": "SARDIS",
    "dropmalst": "MS",
    "dropmalzpp": 386669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624872235,
    "dropfax": 6624872951
  },
  {
    "dcode": "D",
    "dropkey": "PY14365",
    "droptype": "D",
    "dropname": "SATARTIA",
    "dropdeladd": "9334 HIGHWAY 3",
    "dropdelcty": "SATARTIA",
    "dropdelst": "MS",
    "dropdelzpp": 391629998,
    "dropphyadd": "9334 HIGHWAY 3",
    "dropphycty": "SATARTIA",
    "dropphyst": "MS",
    "dropphyzpp": 391629998,
    "dropmaladd": "9334 HIGHWAY 3",
    "dropmalcty": "SATARTIA",
    "dropmalst": "MS",
    "dropmalzpp": 391629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627467778,
    "dropfax": 6627467778
  },
  {
    "dcode": "D",
    "dropkey": "PY14366",
    "droptype": "D",
    "dropname": "SAUCIER",
    "dropdeladd": "17690 2ND ST",
    "dropdelcty": "SAUCIER",
    "dropdelst": "MS",
    "dropdelzpp": 395749998,
    "dropphyadd": "17690 2ND ST",
    "dropphycty": "SAUCIER",
    "dropphyst": "MS",
    "dropphyzpp": 395749998,
    "dropmaladd": "17690 2ND ST",
    "dropmalcty": "SAUCIER",
    "dropmalst": "MS",
    "dropmalzpp": 395749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 2285392889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14371",
    "droptype": "D",
    "dropname": "SCHLATER",
    "dropdeladd": "101 BEATRICE ST",
    "dropdelcty": "SCHLATER",
    "dropdelst": "MS",
    "dropdelzpp": 389529998,
    "dropphyadd": "101 BEATRICE ST",
    "dropphycty": "SCHLATER",
    "dropphyst": "MS",
    "dropphyzpp": 389529998,
    "dropmaladd": "101 BEATRICE ST",
    "dropmalcty": "SCHLATER",
    "dropmalst": "MS",
    "dropmalzpp": 389529998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626582288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14372",
    "droptype": "D",
    "dropname": "SCOBEY",
    "dropdeladd": "20073 HIGHWAY 51",
    "dropdelcty": "SCOBEY",
    "dropdelst": "MS",
    "dropdelzpp": 389539998,
    "dropphyadd": "20073 HIGHWAY 51",
    "dropphycty": "SCOBEY",
    "dropphyst": "MS",
    "dropphyzpp": 389539998,
    "dropmaladd": "20073 HIGHWAY 51",
    "dropmalcty": "SCOBEY",
    "dropmalst": "MS",
    "dropmalzpp": 389539998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6622267056,
    "dropsitcph": 6622267252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14373",
    "droptype": "D",
    "dropname": "SCOOBA",
    "dropdeladd": "868 EDWARD E. NAVE DR",
    "dropdelcty": "SCOOBA",
    "dropdelst": "MS",
    "dropdelzpp": 393589998,
    "dropphyadd": "868 EDWARD E. NAVE DR",
    "dropphycty": "SCOOBA",
    "dropphyst": "MS",
    "dropphyzpp": 393589998,
    "dropmaladd": "868 EDWARD E. NAVE DR",
    "dropmalcty": "SCOOBA",
    "dropmalst": "MS",
    "dropmalzpp": 393589998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624769132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14374",
    "droptype": "D",
    "dropname": "SCOTT",
    "dropdeladd": "1 COTTON ROW",
    "dropdelcty": "SCOTT",
    "dropdelst": "MS",
    "dropdelzpp": 387729998,
    "dropphyadd": "1 COTTON ROW",
    "dropphycty": "SCOTT",
    "dropphyst": "MS",
    "dropphyzpp": 387729998,
    "dropmaladd": "1 COTTON ROW",
    "dropmalcty": "SCOTT",
    "dropmalst": "MS",
    "dropmalzpp": 387729998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627423332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14375",
    "droptype": "D",
    "dropname": "SEBASTOPOL",
    "dropdeladd": "16811 HIGHWAY 21 N",
    "dropdelcty": "SEBASTOPOL",
    "dropdelst": "MS",
    "dropdelzpp": 393599998,
    "dropphyadd": "16811 HIGHWAY 21 N",
    "dropphycty": "SEBASTOPOL",
    "dropphyst": "MS",
    "dropphyzpp": 393599998,
    "dropmaladd": "16811 HIGHWAY 21 N",
    "dropmalcty": "SEBASTOPOL",
    "dropmalst": "MS",
    "dropmalzpp": 393599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016258121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14377",
    "droptype": "D",
    "dropname": "SEMINARY",
    "dropdeladd": "205 N OAK ST",
    "dropdelcty": "SEMINARY",
    "dropdelst": "MS",
    "dropdelzpp": 394799998,
    "dropphyadd": "205 N OAK ST",
    "dropphycty": "SEMINARY",
    "dropphyst": "MS",
    "dropphyzpp": 394799998,
    "dropmaladd": "205 N OAK ST",
    "dropmalcty": "SEMINARY",
    "dropmalst": "MS",
    "dropmalzpp": 394799998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017223710,
    "dropfax": 6017223751
  },
  {
    "dcode": "D",
    "dropkey": "PY14379",
    "droptype": "D",
    "dropname": "SENATOBIA",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "SENATOBIA",
    "dropdelst": "MS",
    "dropdelzpp": 386689998,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "SENATOBIA",
    "dropphyst": "MS",
    "dropphyzpp": 386689998,
    "dropmaladd": "100 W MAIN ST",
    "dropmalcty": "SENATOBIA",
    "dropmalst": "MS",
    "dropmalzpp": 386689998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625628766,
    "dropfax": 6625600755
  },
  {
    "dcode": "D",
    "dropkey": "PY14383",
    "droptype": "D",
    "dropname": "SHANNON",
    "dropdeladd": "718 ROMIE HILL AVE",
    "dropdelcty": "SHANNON",
    "dropdelst": "MS",
    "dropdelzpp": 388689998,
    "dropphyadd": "718 ROMIE HILL AVE",
    "dropphycty": "SHANNON",
    "dropphyst": "MS",
    "dropphyzpp": 388689998,
    "dropmaladd": "718 ROMIE HILL AVE",
    "dropmalcty": "SHANNON",
    "dropmalst": "MS",
    "dropmalzpp": 388689998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627674025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14386",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "3065 HIGHWAY 43 N",
    "dropdelcty": "SHARON",
    "dropdelst": "MS",
    "dropdelzpp": 391639700,
    "dropphyadd": "3065 HIGHWAY 43 N",
    "dropphycty": "SHARON",
    "dropphyst": "MS",
    "dropphyzpp": 391639700,
    "dropmaladd": "3065 HIGHWAY 43 N",
    "dropmalcty": "SHARON",
    "dropmalst": "MS",
    "dropmalzpp": 391639700,
    "dropsitphn": 6018594881,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018599717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14387",
    "droptype": "D",
    "dropname": "SHAW",
    "dropdeladd": "100 FAISON ST",
    "dropdelcty": "SHAW",
    "dropdelst": "MS",
    "dropdelzpp": 387739998,
    "dropphyadd": "100 FAISON ST",
    "dropphycty": "SHAW",
    "dropphyst": "MS",
    "dropphyzpp": 387739998,
    "dropmaladd": "100 FAISON ST",
    "dropmalcty": "SHAW",
    "dropmalst": "MS",
    "dropmalzpp": 387739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627544231,
    "dropfax": 6627544093
  },
  {
    "dcode": "D",
    "dropkey": "PY14388",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "304 SECOND AVE",
    "dropdelcty": "SHELBY",
    "dropdelst": "MS",
    "dropdelzpp": 387749998,
    "dropphyadd": "304 SECOND AVE",
    "dropphycty": "SHELBY",
    "dropphyst": "MS",
    "dropphyzpp": 387749998,
    "dropmaladd": "304 SECOND AVE",
    "dropmalcty": "SHELBY",
    "dropmalst": "MS",
    "dropmalzpp": 387749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623987162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14392",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "65 E MAIN ST",
    "dropdelcty": "SHERMAN",
    "dropdelst": "MS",
    "dropdelzpp": 388699998,
    "dropphyadd": "65 E MAIN ST",
    "dropphycty": "SHERMAN",
    "dropphyst": "MS",
    "dropphyzpp": 388699998,
    "dropmaladd": "65 E MAIN ST",
    "dropmalcty": "SHERMAN",
    "dropmalst": "MS",
    "dropmalzpp": 388699998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628402559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14396",
    "droptype": "D",
    "dropname": "SHUBUTA",
    "dropdeladd": "160 S HIGH ST",
    "dropdelcty": "SHUBUTA",
    "dropdelst": "MS",
    "dropdelzpp": 393609998,
    "dropphyadd": "160 S HIGH ST",
    "dropphycty": "SHUBUTA",
    "dropphyst": "MS",
    "dropphyzpp": 393609998,
    "dropmaladd": "160 S HIGH ST",
    "dropmalcty": "SHUBUTA",
    "dropmalst": "MS",
    "dropmalzpp": 393609998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016871500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14397",
    "droptype": "D",
    "dropname": "SHUQUALAK",
    "dropdeladd": "135 PINE ST",
    "dropdelcty": "SHUQUALAK",
    "dropdelst": "MS",
    "dropdelzpp": 393619710,
    "dropphyadd": "135 PINE ST",
    "dropphycty": "SHUQUALAK",
    "dropphyst": "MS",
    "dropphyzpp": 393619710,
    "dropmaladd": "135 PINE ST",
    "dropmalcty": "SHUQUALAK",
    "dropmalst": "MS",
    "dropmalzpp": 393619710,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627934839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14399",
    "droptype": "D",
    "dropname": "SIBLEY",
    "dropdeladd": "1258 HIGHWAY 61 S",
    "dropdelcty": "SIBLEY",
    "dropdelst": "MS",
    "dropdelzpp": 391659998,
    "dropphyadd": "1258 HIGHWAY 61 S",
    "dropphycty": "SIBLEY",
    "dropphyst": "MS",
    "dropphyzpp": 391659998,
    "dropmaladd": "1258 HIGHWAY 61 S",
    "dropmalcty": "SIBLEY",
    "dropmalst": "MS",
    "dropmalzpp": 391659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014426006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14400",
    "droptype": "D",
    "dropname": "SIDON",
    "dropdeladd": "511 W RAILROAD AVE",
    "dropdelcty": "SIDON",
    "dropdelst": "MS",
    "dropdelzpp": 389549998,
    "dropphyadd": "511 W RAILROAD AVE",
    "dropphycty": "SIDON",
    "dropphyst": "MS",
    "dropphyzpp": 389549998,
    "dropmaladd": "511 W RAILROAD AVE",
    "dropmalcty": "SIDON",
    "dropmalst": "MS",
    "dropmalzpp": 389549998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624534358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14401",
    "droptype": "D",
    "dropname": "SILVER CITY",
    "dropdeladd": "65 WEST ST",
    "dropdelcty": "SILVER CITY",
    "dropdelst": "MS",
    "dropdelzpp": 391669998,
    "dropphyadd": "65 WEST ST",
    "dropphycty": "SILVER CITY",
    "dropphyst": "MS",
    "dropphyzpp": 391669998,
    "dropmaladd": "65 WEST ST",
    "dropmalcty": "SILVER CITY",
    "dropmalst": "MS",
    "dropmalzpp": 391669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622473644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14402",
    "droptype": "D",
    "dropname": "SILVER CREEK",
    "dropdeladd": "56 MAIN AVE",
    "dropdelcty": "SILVER CREEK",
    "dropdelst": "MS",
    "dropdelzpp": 396639998,
    "dropphyadd": "56 MAIN AVE",
    "dropphycty": "SILVER CREEK",
    "dropphyst": "MS",
    "dropphyzpp": 396639998,
    "dropmaladd": "56 MAIN AVE",
    "dropmalcty": "SILVER CREEK",
    "dropmalst": "MS",
    "dropmalzpp": 396639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018867137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14412",
    "droptype": "D",
    "dropname": "SLEDGE",
    "dropdeladd": "130 WILLIAMS AVE",
    "dropdelcty": "SLEDGE",
    "dropdelst": "MS",
    "dropdelzpp": 386709998,
    "dropphyadd": "130 WILLIAMS AVE",
    "dropphycty": "SLEDGE",
    "dropphyst": "MS",
    "dropphyzpp": 386709998,
    "dropmaladd": "130 WILLIAMS AVE",
    "dropmalcty": "SLEDGE",
    "dropmalst": "MS",
    "dropmalzpp": 386709998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623827337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14414",
    "droptype": "D",
    "dropname": "SMITHDALE",
    "dropdeladd": "6005 MS HIGHWAY 570",
    "dropdelcty": "SMITHDALE",
    "dropdelst": "MS",
    "dropdelzpp": 396649998,
    "dropphyadd": "6005 MS HIGHWAY 570",
    "dropphycty": "SMITHDALE",
    "dropphyst": "MS",
    "dropphyzpp": 396649998,
    "dropmaladd": "6005 MS HIGHWAY 570",
    "dropmalcty": "SMITHDALE",
    "dropmalst": "MS",
    "dropmalzpp": 396649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2282716031,
    "dropsitcph": 6015672621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14424",
    "droptype": "D",
    "dropname": "SONTAG",
    "dropdeladd": "903 SONTAG NOLA RD",
    "dropdelcty": "SONTAG",
    "dropdelst": "MS",
    "dropdelzpp": 396659998,
    "dropphyadd": "903 SONTAG NOLA RD",
    "dropphycty": "SONTAG",
    "dropphyst": "MS",
    "dropphyzpp": 396659998,
    "dropmaladd": "903 SONTAG NOLA RD",
    "dropmalcty": "SONTAG",
    "dropmalst": "MS",
    "dropmalzpp": 396659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6015872380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14425",
    "droptype": "D",
    "dropname": "SOSO",
    "dropdeladd": "1036 HIGHWAY 28 W",
    "dropdelcty": "SOSO",
    "dropdelst": "MS",
    "dropdelzpp": 394809998,
    "dropphyadd": "1036 HIGHWAY 28 W",
    "dropphycty": "SOSO",
    "dropphyst": "MS",
    "dropphyzpp": 394809998,
    "dropmaladd": "1036 HIGHWAY 28 W",
    "dropmalcty": "SOSO",
    "dropmalst": "MS",
    "dropmalzpp": 394809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6013942607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14428",
    "droptype": "D",
    "dropname": "SOUTHAVEN",
    "dropdeladd": "7550 AIRWAYS BLVD",
    "dropdelcty": "SOUTHAVEN",
    "dropdelst": "MS",
    "dropdelzpp": 386719998,
    "dropphyadd": "7550 AIRWAYS BLVD",
    "dropphycty": "SOUTHAVEN",
    "dropphyst": "MS",
    "dropphyzpp": 386719998,
    "dropmaladd": "7550 AIRWAYS BLVD",
    "dropmalcty": "SOUTHAVEN",
    "dropmalst": "MS",
    "dropmalzpp": 386719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623490344,
    "dropsitcph": 6623498571,
    "dropfax": 6623490899
  },
  {
    "dcode": "D",
    "dropkey": "PY14439",
    "droptype": "D",
    "dropname": "STAR",
    "dropdeladd": "339 MANGUM DR",
    "dropdelcty": "STAR",
    "dropdelst": "MS",
    "dropdelzpp": 391679998,
    "dropphyadd": "339 MANGUM DR",
    "dropphycty": "STAR",
    "dropphyst": "MS",
    "dropphyzpp": 391679998,
    "dropmaladd": "339 MANGUM DR",
    "dropmalcty": "STAR",
    "dropmalst": "MS",
    "dropmalzpp": 391679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018452333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14440",
    "droptype": "D",
    "dropname": "STARKVILLE",
    "dropdeladd": "822 TAYLOR ST",
    "dropdelcty": "STARKVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 397599998,
    "dropphyadd": "822 TAYLOR ST",
    "dropphycty": "STARKVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 397599998,
    "dropmaladd": "822 TAYLOR ST",
    "dropmalcty": "STARKVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 397599998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623234774,
    "dropsitcph": 6623234752,
    "dropfax": 6623241476
  },
  {
    "dcode": "D",
    "dropkey": "PY14444",
    "droptype": "D",
    "dropname": "STATE LINE",
    "dropdeladd": "240 MAIN ST",
    "dropdelcty": "STATE LINE",
    "dropdelst": "MS",
    "dropdelzpp": 393629998,
    "dropphyadd": "240 MAIN ST",
    "dropphycty": "STATE LINE",
    "dropphyst": "MS",
    "dropphyzpp": 393629998,
    "dropmaladd": "240 MAIN ST",
    "dropmalcty": "STATE LINE",
    "dropmalst": "MS",
    "dropmalzpp": 393629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018487894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14445",
    "droptype": "D",
    "dropname": "STEENS",
    "dropdeladd": "346 STEENS VERNON RD",
    "dropdelcty": "STEENS",
    "dropdelst": "MS",
    "dropdelzpp": 397669998,
    "dropphyadd": "346 STEENS VERNON RD",
    "dropphycty": "STEENS",
    "dropphyst": "MS",
    "dropphyzpp": 397669998,
    "dropmaladd": "346 STEENS VERNON RD",
    "dropmalcty": "STEENS",
    "dropmalst": "MS",
    "dropmalzpp": 397669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623280909,
    "dropfax": 6623280909
  },
  {
    "dcode": "D",
    "dropkey": "PY14448",
    "droptype": "D",
    "dropname": "STEWART",
    "dropdeladd": "35 CHOCTAW ST",
    "dropdelcty": "STEWART",
    "dropdelst": "MS",
    "dropdelzpp": 397679998,
    "dropphyadd": "35 CHOCTAW ST",
    "dropphycty": "STEWART",
    "dropphyst": "MS",
    "dropphyzpp": 397679998,
    "dropmaladd": "35 CHOCTAW ST",
    "dropmalcty": "STEWART",
    "dropmalst": "MS",
    "dropmalzpp": 397679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622624982,
    "dropfax": 6622624982
  },
  {
    "dcode": "D",
    "dropkey": "PY14449",
    "droptype": "D",
    "dropname": "STONEVILLE",
    "dropdeladd": "4845 OLD LELAND RD",
    "dropdelcty": "STONEVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387769998,
    "dropphyadd": "4845 OLD LELAND RD",
    "dropphycty": "STONEVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387769998,
    "dropmaladd": "4845 OLD LELAND RD",
    "dropmalcty": "STONEVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626864539,
    "dropfax": 6626864539
  },
  {
    "dcode": "D",
    "dropkey": "PY14452",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "748 ERWIN RD",
    "dropdelcty": "STONEWALL",
    "dropdelst": "MS",
    "dropdelzpp": 393639998,
    "dropphyadd": "748 ERWIN RD",
    "dropphycty": "STONEWALL",
    "dropphyst": "MS",
    "dropphyzpp": 393639998,
    "dropmaladd": "748 ERWIN RD",
    "dropmalcty": "STONEWALL",
    "dropmalst": "MS",
    "dropmalzpp": 393639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016594566,
    "dropfax": 6016599934
  },
  {
    "dcode": "D",
    "dropkey": "PY14458",
    "droptype": "D",
    "dropname": "STRINGER",
    "dropdeladd": "36 COUNTY ROAD 17",
    "dropdelcty": "STRINGER",
    "dropdelst": "MS",
    "dropdelzpp": 394819998,
    "dropphyadd": "36 COUNTY ROAD 17",
    "dropphycty": "STRINGER",
    "dropphyst": "MS",
    "dropphyzpp": 394819998,
    "dropmaladd": "36 COUNTY ROAD 17",
    "dropmalcty": "STRINGER",
    "dropmalst": "MS",
    "dropmalzpp": 394819998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014262450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14460",
    "droptype": "D",
    "dropname": "STURGIS",
    "dropdeladd": "2738 HIGHWAY 12 W",
    "dropdelcty": "STURGIS",
    "dropdelst": "MS",
    "dropdelzpp": 397699127,
    "dropphyadd": "2738 HIGHWAY 12 W",
    "dropphycty": "STURGIS",
    "dropphyst": "MS",
    "dropphyzpp": 397699127,
    "dropmaladd": "2738 HIGHWAY 12 W",
    "dropmalcty": "STURGIS",
    "dropmalst": "MS",
    "dropmalzpp": 397699127,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624657506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14462",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "501 W ROBB ST",
    "dropdelcty": "SUMMIT",
    "dropdelst": "MS",
    "dropdelzpp": 396669998,
    "dropphyadd": "501 W ROBB ST",
    "dropphycty": "SUMMIT",
    "dropphyst": "MS",
    "dropphyzpp": 396669998,
    "dropmaladd": "501 W ROBB ST",
    "dropmalcty": "SUMMIT",
    "dropmalst": "MS",
    "dropmalzpp": 396669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6012769721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14463",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "508 WAYNE ST",
    "dropdelcty": "SUMNER",
    "dropdelst": "MS",
    "dropdelzpp": 389579998,
    "dropphyadd": "508 WAYNE ST",
    "dropphycty": "SUMNER",
    "dropphyst": "MS",
    "dropphyzpp": 389579998,
    "dropmaladd": "508 WAYNE ST",
    "dropmalcty": "SUMNER",
    "dropmalst": "MS",
    "dropmalzpp": 389579998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623758735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14464",
    "droptype": "D",
    "dropname": "SUMRALL",
    "dropdeladd": "4862 HIGHWAY 589",
    "dropdelcty": "SUMRALL",
    "dropdelst": "MS",
    "dropdelzpp": 394829998,
    "dropphyadd": "4862 HIGHWAY 589",
    "dropphycty": "SUMRALL",
    "dropphyst": "MS",
    "dropphyzpp": 394829998,
    "dropmaladd": "4862 HIGHWAY 589",
    "dropmalcty": "SUMRALL",
    "dropmalst": "MS",
    "dropmalzpp": 394829998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017584722,
    "dropfax": 6017580876
  },
  {
    "dcode": "D",
    "dropkey": "PY14465",
    "droptype": "D",
    "dropname": "SUNFLOWER",
    "dropdeladd": "102 W QUIVER ST",
    "dropdelcty": "SUNFLOWER",
    "dropdelst": "MS",
    "dropdelzpp": 387789998,
    "dropphyadd": "102 W QUIVER ST",
    "dropphycty": "SUNFLOWER",
    "dropphyst": "MS",
    "dropphyzpp": 387789998,
    "dropmaladd": "102 W QUIVER ST",
    "dropmalcty": "SUNFLOWER",
    "dropmalst": "MS",
    "dropmalzpp": 387789998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6625691006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14479",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "MS",
    "dropdelzpp": 386739998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "MS",
    "dropphyzpp": 386739998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "MS",
    "dropmalzpp": 386739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622341817,
    "dropfax": 6622341817
  },
  {
    "dcode": "D",
    "dropkey": "PY14480",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "750 COMFORT ST",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 391689998,
    "dropphyadd": "750 COMFORT ST",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 391689998,
    "dropmaladd": "750 COMFORT ST",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 391689998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017856515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14483",
    "droptype": "D",
    "dropname": "TCHULA",
    "dropdeladd": "142 MERCER ST",
    "dropdelcty": "TCHULA",
    "dropdelst": "MS",
    "dropdelzpp": 391699998,
    "dropphyadd": "142 MERCER ST",
    "dropphycty": "TCHULA",
    "dropphyst": "MS",
    "dropphyzpp": 391699998,
    "dropmaladd": "142 MERCER ST",
    "dropmalcty": "TCHULA",
    "dropmalst": "MS",
    "dropmalzpp": 391699998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622355484,
    "dropfax": 6622355572
  },
  {
    "dcode": "D",
    "dropkey": "PY14487",
    "droptype": "D",
    "dropname": "TERRY",
    "dropdeladd": "404 W CUNNINGHAM AVE",
    "dropdelcty": "TERRY",
    "dropdelst": "MS",
    "dropdelzpp": 391709998,
    "dropphyadd": "404 W CUNNINGHAM AVE",
    "dropphycty": "TERRY",
    "dropphyst": "MS",
    "dropphyzpp": 391709998,
    "dropmaladd": "404 W CUNNINGHAM AVE",
    "dropmalcty": "TERRY",
    "dropmalst": "MS",
    "dropmalzpp": 391709998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018785120,
    "dropfax": 6018785699
  },
  {
    "dcode": "D",
    "dropkey": "PY14489",
    "droptype": "D",
    "dropname": "THAXTON",
    "dropdeladd": "779 THAXTON RD",
    "dropdelcty": "THAXTON",
    "dropdelst": "MS",
    "dropdelzpp": 388719998,
    "dropphyadd": "779 THAXTON RD",
    "dropphycty": "THAXTON",
    "dropphyst": "MS",
    "dropphyzpp": 388719998,
    "dropmaladd": "779 THAXTON RD",
    "dropmalcty": "THAXTON",
    "dropmalst": "MS",
    "dropmalzpp": 388719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624895581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14502",
    "droptype": "D",
    "dropname": "TILLATOBA",
    "dropdeladd": "26936 HIGHWAY 330",
    "dropdelcty": "TILLATOBA",
    "dropdelst": "MS",
    "dropdelzpp": 389619998,
    "dropphyadd": "26936 HIGHWAY 330",
    "dropphycty": "TILLATOBA",
    "dropphyst": "MS",
    "dropphyzpp": 389619998,
    "dropmaladd": "26936 HIGHWAY 330",
    "dropmalcty": "TILLATOBA",
    "dropmalst": "MS",
    "dropmalzpp": 389619998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6626230514,
    "dropsitcph": 6626238612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14504",
    "droptype": "D",
    "dropname": "TINSLEY",
    "dropdeladd": "3729 TINSLEY RD",
    "dropdelcty": "TINSLEY",
    "dropdelst": "MS",
    "dropdelzpp": 391739998,
    "dropphyadd": "3729 TINSLEY RD",
    "dropphycty": "TINSLEY",
    "dropphyst": "MS",
    "dropphyzpp": 391739998,
    "dropmaladd": "3729 TINSLEY RD",
    "dropmalcty": "TINSLEY",
    "dropmalst": "MS",
    "dropmalzpp": 391739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6627467086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14505",
    "droptype": "D",
    "dropname": "TIPLERSVILLE",
    "dropdeladd": "24440 HIGHWAY 15",
    "dropdelcty": "TIPLERSVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 386749998,
    "dropphyadd": "24440 HIGHWAY 15",
    "dropphycty": "TIPLERSVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 386749998,
    "dropmaladd": "24440 HIGHWAY 15",
    "dropmalcty": "TIPLERSVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 386749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622235240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14508",
    "droptype": "D",
    "dropname": "TIPPO",
    "dropdeladd": "2309 TIPPO MACEL RD",
    "dropdelcty": "TIPPO",
    "dropdelst": "MS",
    "dropdelzpp": 389629998,
    "dropphyadd": "2309 TIPPO MACEL RD",
    "dropphycty": "TIPPO",
    "dropphyst": "MS",
    "dropphyzpp": 389629998,
    "dropmaladd": "2309 TIPPO MACEL RD",
    "dropmalcty": "TIPPO",
    "dropmalst": "MS",
    "dropmalzpp": 389629998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626475713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14509",
    "droptype": "D",
    "dropname": "TISHOMINGO",
    "dropdeladd": "9 NATCHEZ ST",
    "dropdelcty": "TISHOMINGO",
    "dropdelst": "MS",
    "dropdelzpp": 388739998,
    "dropphyadd": "9 NATCHEZ ST",
    "dropphycty": "TISHOMINGO",
    "dropphyst": "MS",
    "dropphyzpp": 388739998,
    "dropmaladd": "9 NATCHEZ ST",
    "dropmalcty": "TISHOMINGO",
    "dropmalst": "MS",
    "dropmalzpp": 388739998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624386309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14510",
    "droptype": "D",
    "dropname": "TOCCOPOLA",
    "dropdeladd": "11 PERKINS ST",
    "dropdelcty": "TOCCOPOLA",
    "dropdelst": "MS",
    "dropdelzpp": 388749998,
    "dropphyadd": "11 PERKINS ST",
    "dropphycty": "TOCCOPOLA",
    "dropphyst": "MS",
    "dropphyzpp": 388749998,
    "dropmaladd": "11 PERKINS ST",
    "dropmalcty": "TOCCOPOLA",
    "dropmalst": "MS",
    "dropmalzpp": 388749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622366555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14512",
    "droptype": "D",
    "dropname": "TOOMSUBA",
    "dropdeladd": "3936 MELVIN SWAIN RD",
    "dropdelcty": "TOOMSUBA",
    "dropdelst": "MS",
    "dropdelzpp": 393649998,
    "dropphyadd": "3936 MELVIN SWAIN RD",
    "dropphycty": "TOOMSUBA",
    "dropphyst": "MS",
    "dropphyzpp": 393649998,
    "dropmaladd": "3936 MELVIN SWAIN RD",
    "dropmalcty": "TOOMSUBA",
    "dropmalst": "MS",
    "dropmalzpp": 393649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016324061,
    "dropfax": 6016321313
  },
  {
    "dcode": "D",
    "dropkey": "PY14516",
    "droptype": "D",
    "dropname": "TOUGALOO",
    "dropdeladd": "501 W COUNTY LINE RD",
    "dropdelcty": "TOUGALOO",
    "dropdelst": "MS",
    "dropdelzpp": 391749998,
    "dropphyadd": "501 W COUNTY LINE RD",
    "dropphycty": "TOUGALOO",
    "dropphyst": "MS",
    "dropphyzpp": 391749998,
    "dropmaladd": "501 W COUNTY LINE RD",
    "dropmalcty": "TOUGALOO",
    "dropmalst": "MS",
    "dropmalzpp": 391749998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6012065472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14518",
    "droptype": "D",
    "dropname": "TREBLOC",
    "dropdeladd": "3063 HIGHWAY 8 E",
    "dropdelcty": "TREBLOC",
    "dropdelst": "MS",
    "dropdelzpp": 388759998,
    "dropphyadd": "3063 HIGHWAY 8 E",
    "dropphycty": "TREBLOC",
    "dropphyst": "MS",
    "dropphyzpp": 388759998,
    "dropmaladd": "3063 HIGHWAY 8 E",
    "dropmalcty": "TREBLOC",
    "dropmalst": "MS",
    "dropmalzpp": 388759998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624563631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14519",
    "droptype": "D",
    "dropname": "TREMONT",
    "dropdeladd": "10019 HIGHWAY 178 E",
    "dropdelcty": "TREMONT",
    "dropdelst": "MS",
    "dropdelzpp": 388769998,
    "dropphyadd": "10019 HIGHWAY 178 E",
    "dropphycty": "TREMONT",
    "dropphyst": "MS",
    "dropphyzpp": 388769998,
    "dropmaladd": "10019 HIGHWAY 178 E",
    "dropmalcty": "TREMONT",
    "dropmalst": "MS",
    "dropmalzpp": 388769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626523622,
    "dropfax": 6626523622
  },
  {
    "dcode": "D",
    "dropkey": "PY14530",
    "droptype": "D",
    "dropname": "TUNICA",
    "dropdeladd": "912 MAGNOLIA ST",
    "dropdelcty": "TUNICA",
    "dropdelst": "MS",
    "dropdelzpp": 386769998,
    "dropphyadd": "912 MAGNOLIA ST",
    "dropphycty": "TUNICA",
    "dropphyst": "MS",
    "dropphyzpp": 386769998,
    "dropmaladd": "912 MAGNOLIA ST",
    "dropmalcty": "TUNICA",
    "dropmalst": "MS",
    "dropmalzpp": 386769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623570113,
    "dropsitcph": 6623632631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14532",
    "droptype": "D",
    "dropname": "TUPELO",
    "dropdeladd": "362 S THOMAS ST",
    "dropdelcty": "TUPELO",
    "dropdelst": "MS",
    "dropdelzpp": 388019998,
    "dropphyadd": "362 S THOMAS ST",
    "dropphycty": "TUPELO",
    "dropphyst": "MS",
    "dropphyzpp": 388019998,
    "dropmaladd": "362 S THOMAS ST",
    "dropmalcty": "TUPELO",
    "dropmalst": "MS",
    "dropmalzpp": 388019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627918430,
    "dropsitcph": 6627918401,
    "dropfax": 6628440888
  },
  {
    "dcode": "D",
    "dropkey": "PY14535",
    "droptype": "D",
    "dropname": "TUTWILER",
    "dropdeladd": "201 ALMA ST E",
    "dropdelcty": "TUTWILER",
    "dropdelst": "MS",
    "dropdelzpp": 389639998,
    "dropphyadd": "201 ALMA ST E",
    "dropphycty": "TUTWILER",
    "dropphyst": "MS",
    "dropphyzpp": 389639998,
    "dropmaladd": "201 ALMA ST E",
    "dropmalcty": "TUTWILER",
    "dropmalst": "MS",
    "dropmalzpp": 389639998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623458462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14536",
    "droptype": "D",
    "dropname": "TYLERTOWN",
    "dropdeladd": "622 BEULAH AVE",
    "dropdelcty": "TYLERTOWN",
    "dropdelst": "MS",
    "dropdelzpp": 396679998,
    "dropphyadd": "622 BEULAH AVE",
    "dropphycty": "TYLERTOWN",
    "dropphyst": "MS",
    "dropphyzpp": 396679998,
    "dropmaladd": "622 BEULAH AVE",
    "dropmalcty": "TYLERTOWN",
    "dropmalst": "MS",
    "dropmalzpp": 396679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018766122,
    "dropsitcph": 6018763755,
    "dropfax": 6018766122
  },
  {
    "dcode": "D",
    "dropkey": "PY14542",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "501 BANK ST",
    "dropdelcty": "UNION",
    "dropdelst": "MS",
    "dropdelzpp": 393659998,
    "dropphyadd": "501 BANK ST",
    "dropphycty": "UNION",
    "dropphyst": "MS",
    "dropphyzpp": 393659998,
    "dropmaladd": "501 BANK ST",
    "dropmalcty": "UNION",
    "dropmalst": "MS",
    "dropmalzpp": 393659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017748262,
    "dropsitcph": 6017748262,
    "dropfax": 6017745053
  },
  {
    "dcode": "D",
    "dropkey": "PY14543",
    "droptype": "D",
    "dropname": "UNION CHURCH",
    "dropdeladd": "65 HIGHWAY 550",
    "dropdelcty": "UNION CHURCH",
    "dropdelst": "MS",
    "dropdelzpp": 396689998,
    "dropphyadd": "65 HIGHWAY 550",
    "dropphycty": "UNION CHURCH",
    "dropphyst": "MS",
    "dropphyzpp": 396689998,
    "dropmaladd": "65 HIGHWAY 550",
    "dropmalcty": "UNION CHURCH",
    "dropmalst": "MS",
    "dropmalzpp": 396689998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017863543,
    "dropfax": 6017863543
  },
  {
    "dcode": "D",
    "dropkey": "PY14552",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "310 DEPOT ST",
    "dropdelcty": "UTICA",
    "dropdelst": "MS",
    "dropdelzpp": 391759998,
    "dropphyadd": "310 DEPOT ST",
    "dropphycty": "UTICA",
    "dropphyst": "MS",
    "dropphyzpp": 391759998,
    "dropmaladd": "310 DEPOT ST",
    "dropmalcty": "UTICA",
    "dropmalst": "MS",
    "dropmalzpp": 391759998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018856105,
    "dropfax": 6018856133
  },
  {
    "dcode": "D",
    "dropkey": "PY14555",
    "droptype": "D",
    "dropname": "VAIDEN",
    "dropdeladd": "1001 FRONT ST",
    "dropdelcty": "VAIDEN",
    "dropdelst": "MS",
    "dropdelzpp": 391769998,
    "dropphyadd": "1001 FRONT ST",
    "dropphycty": "VAIDEN",
    "dropphyst": "MS",
    "dropphyzpp": 391769998,
    "dropmaladd": "1001 FRONT ST",
    "dropmalcty": "VAIDEN",
    "dropmalst": "MS",
    "dropmalzpp": 391769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624645541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14558",
    "droptype": "D",
    "dropname": "VALLEY PARK",
    "dropdeladd": "4411 HIGHWAY 61 N",
    "dropdelcty": "VALLEY PARK",
    "dropdelst": "MS",
    "dropdelzpp": 391779998,
    "dropphyadd": "4411 HIGHWAY 61 N",
    "dropphycty": "VALLEY PARK",
    "dropphyst": "MS",
    "dropphyzpp": 391779998,
    "dropmaladd": "4411 HIGHWAY 61 N",
    "dropmalcty": "VALLEY PARK",
    "dropmalst": "MS",
    "dropmalzpp": 391779998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016380193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14562",
    "droptype": "D",
    "dropname": "VAN VLEET",
    "dropdeladd": "1640 COUNTY ROAD 164",
    "dropdelcty": "VAN VLEET",
    "dropdelst": "MS",
    "dropdelzpp": 388779998,
    "dropphyadd": "1640 COUNTY ROAD 164",
    "dropphycty": "VAN VLEET",
    "dropphyst": "MS",
    "dropphyzpp": 388779998,
    "dropmaladd": "1640 COUNTY ROAD 164",
    "dropmalcty": "VAN VLEET",
    "dropmalst": "MS",
    "dropmalzpp": 388779998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624473179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14563",
    "droptype": "D",
    "dropname": "VANCE",
    "dropdeladd": "13745 CHARLEY PRIDE HWY 3",
    "dropdelcty": "VANCE",
    "dropdelst": "MS",
    "dropdelzpp": 389649998,
    "dropphyadd": "13745 CHARLEY PRIDE HWY 3",
    "dropphycty": "VANCE",
    "dropphyst": "MS",
    "dropphyzpp": 389649998,
    "dropmaladd": "13745 CHARLEY PRIDE HWY 3",
    "dropmalcty": "VANCE",
    "dropmalst": "MS",
    "dropmalzpp": 389649998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623452259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14565",
    "droptype": "D",
    "dropname": "VARDAMAN",
    "dropdeladd": "200 BURKETT AVE",
    "dropdelcty": "VARDAMAN",
    "dropdelst": "MS",
    "dropdelzpp": 388789998,
    "dropphyadd": "200 BURKETT AVE",
    "dropphycty": "VARDAMAN",
    "dropphyst": "MS",
    "dropphyzpp": 388789998,
    "dropmaladd": "200 BURKETT AVE",
    "dropmalcty": "VARDAMAN",
    "dropmalst": "MS",
    "dropmalzpp": 388789998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6626827650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14571",
    "droptype": "D",
    "dropname": "VERONA",
    "dropdeladd": "5107 RAYMOND AVE",
    "dropdelcty": "VERONA",
    "dropdelst": "MS",
    "dropdelzpp": 388799998,
    "dropphyadd": "5107 RAYMOND AVE",
    "dropphycty": "VERONA",
    "dropphyst": "MS",
    "dropphyzpp": 388799998,
    "dropmaladd": "5107 RAYMOND AVE",
    "dropmalcty": "VERONA",
    "dropmalst": "MS",
    "dropmalzpp": 388799998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625662442,
    "dropfax": 6625664300
  },
  {
    "dcode": "D",
    "dropkey": "PY14573",
    "droptype": "D",
    "dropname": "VICKSBURG",
    "dropdeladd": "3415 PEMBERTON SQUARE BLVD",
    "dropdelcty": "VICKSBURG",
    "dropdelst": "MS",
    "dropdelzpp": 391809998,
    "dropphyadd": "3415 PEMBERTON SQUARE BLVD",
    "dropphycty": "VICKSBURG",
    "dropphyst": "MS",
    "dropphyzpp": 391809998,
    "dropmaladd": "3415 PEMBERTON SQUARE BLVD",
    "dropmalcty": "VICKSBURG",
    "dropmalst": "MS",
    "dropmalzpp": 391809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6016361071,
    "dropsitcph": 6016361022,
    "dropfax": 6016381023
  },
  {
    "dcode": "D",
    "dropkey": "PY14574",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "5764 HIGHWAY 178 W",
    "dropdelcty": "VICTORIA",
    "dropdelst": "MS",
    "dropdelzpp": 386799998,
    "dropphyadd": "5764 HIGHWAY 178 W",
    "dropphycty": "VICTORIA",
    "dropphyst": "MS",
    "dropphyzpp": 386799998,
    "dropmaladd": "5764 HIGHWAY 178 W",
    "dropmalcty": "VICTORIA",
    "dropmalst": "MS",
    "dropmalzpp": 386799998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6628382240,
    "dropfax": 6628382240
  },
  {
    "dcode": "D",
    "dropkey": "PY14577",
    "droptype": "D",
    "dropname": "VOSSBURG",
    "dropdeladd": "642 COUNTY ROAD 39",
    "dropdelcty": "VOSSBURG",
    "dropdelst": "MS",
    "dropdelzpp": 393669998,
    "dropphyadd": "642 COUNTY ROAD 39",
    "dropphycty": "VOSSBURG",
    "dropphyst": "MS",
    "dropphyzpp": 393669998,
    "dropmaladd": "642 COUNTY ROAD 39",
    "dropmalcty": "VOSSBURG",
    "dropmalst": "MS",
    "dropmalzpp": 393669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6017874332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14588",
    "droptype": "D",
    "dropname": "WALLS",
    "dropdeladd": "6380 HIGHWAY 161",
    "dropdelcty": "WALLS",
    "dropdelst": "MS",
    "dropdelzpp": 386809998,
    "dropphyadd": "6380 HIGHWAY 161",
    "dropphycty": "WALLS",
    "dropphyst": "MS",
    "dropphyzpp": 386809998,
    "dropmaladd": "6380 HIGHWAY 161",
    "dropmalcty": "WALLS",
    "dropmalst": "MS",
    "dropmalzpp": 386809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627812043,
    "dropsitcph": 6627811733,
    "dropfax": 6627812043
  },
  {
    "dcode": "D",
    "dropkey": "PY14590",
    "droptype": "D",
    "dropname": "WALNUT",
    "dropdeladd": "50 HIGHWAY 354",
    "dropdelcty": "WALNUT",
    "dropdelst": "MS",
    "dropdelzpp": 386839998,
    "dropphyadd": "50 HIGHWAY 354",
    "dropphycty": "WALNUT",
    "dropphyst": "MS",
    "dropphyzpp": 386839998,
    "dropmaladd": "50 HIGHWAY 354",
    "dropmalcty": "WALNUT",
    "dropmalst": "MS",
    "dropmalzpp": 386839998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622234453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14591",
    "droptype": "D",
    "dropname": "WALNUT GROVE",
    "dropdeladd": "143 MAIN ST",
    "dropdelcty": "WALNUT GROVE",
    "dropdelst": "MS",
    "dropdelzpp": 391899998,
    "dropphyadd": "143 MAIN ST",
    "dropphycty": "WALNUT GROVE",
    "dropphyst": "MS",
    "dropphyzpp": 391899998,
    "dropmaladd": "143 MAIN ST",
    "dropmalcty": "WALNUT GROVE",
    "dropmalst": "MS",
    "dropmalzpp": 391899998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6012532227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14594",
    "droptype": "D",
    "dropname": "WALTHALL",
    "dropdeladd": "57 HISTORICAL ST",
    "dropdelcty": "WALTHALL",
    "dropdelst": "MS",
    "dropdelzpp": 397719998,
    "dropphyadd": "57 HISTORICAL ST",
    "dropphycty": "WALTHALL",
    "dropphyst": "MS",
    "dropphyzpp": 397719998,
    "dropmaladd": "57 HISTORICAL ST",
    "dropmalcty": "WALTHALL",
    "dropmalst": "MS",
    "dropmalzpp": 397719998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622583651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14598",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "820 HIGHWAY 61 N",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "MS",
    "dropdelzpp": 391909998,
    "dropphyadd": "820 HIGHWAY 61 N",
    "dropphycty": "WASHINGTON",
    "dropphyst": "MS",
    "dropphyzpp": 391909998,
    "dropmaladd": "820 HIGHWAY 61 N",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "MS",
    "dropmalzpp": 391909998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6014454547,
    "dropsitcph": 6014425671,
    "dropfax": 6014425671
  },
  {
    "dcode": "D",
    "dropkey": "PY14602",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "9 BETHLEHEM RD",
    "dropdelcty": "WATERFORD",
    "dropdelst": "MS",
    "dropdelzpp": 386859998,
    "dropphyadd": "9 BETHLEHEM RD",
    "dropphycty": "WATERFORD",
    "dropphyst": "MS",
    "dropphyzpp": 386859998,
    "dropmaladd": "9 BETHLEHEM RD",
    "dropmalcty": "WATERFORD",
    "dropmalst": "MS",
    "dropmalzpp": 386859998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622525577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14607",
    "droptype": "D",
    "dropname": "WAYNESBORO",
    "dropdeladd": "704 AZALEA DR",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "MS",
    "dropdelzpp": 393679998,
    "dropphyadd": "704 AZALEA DR",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "MS",
    "dropphyzpp": 393679998,
    "dropmaladd": "704 AZALEA DR",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "MS",
    "dropmalzpp": 393679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017354333,
    "dropsitcph": 6017354417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14610",
    "droptype": "D",
    "dropname": "WAYSIDE",
    "dropdeladd": "3501 HIGHWAY 1 S",
    "dropdelcty": "WAYSIDE",
    "dropdelst": "MS",
    "dropdelzpp": 387809998,
    "dropphyadd": "3501 HIGHWAY 1 S",
    "dropphycty": "WAYSIDE",
    "dropphyst": "MS",
    "dropphyzpp": 387809998,
    "dropmaladd": "3501 HIGHWAY 1 S",
    "dropmalcty": "WAYSIDE",
    "dropmalst": "MS",
    "dropmalzpp": 387809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623356834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14612",
    "droptype": "D",
    "dropname": "WEBB",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "WEBB",
    "dropdelst": "MS",
    "dropdelzpp": 389669998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "WEBB",
    "dropphyst": "MS",
    "dropphyzpp": 389669998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "WEBB",
    "dropmalst": "MS",
    "dropmalzpp": 389669998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623758473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14613",
    "droptype": "D",
    "dropname": "WEIR",
    "dropdeladd": "800 MAIN ST",
    "dropdelcty": "WEIR",
    "dropdelst": "MS",
    "dropdelzpp": 397729998,
    "dropphyadd": "800 MAIN ST",
    "dropphycty": "WEIR",
    "dropphyst": "MS",
    "dropphyzpp": 397729998,
    "dropmaladd": "800 MAIN ST",
    "dropmalcty": "WEIR",
    "dropmalst": "MS",
    "dropmalzpp": 397729998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6625476969,
    "dropfax": 6625475188
  },
  {
    "dcode": "D",
    "dropkey": "PY14616",
    "droptype": "D",
    "dropname": "WESSON",
    "dropdeladd": "2072 HIGHWAY 51",
    "dropdelcty": "WESSON",
    "dropdelst": "MS",
    "dropdelzpp": 391919998,
    "dropphyadd": "2072 HIGHWAY 51",
    "dropphycty": "WESSON",
    "dropphyst": "MS",
    "dropphyzpp": 391919998,
    "dropmaladd": "2072 HIGHWAY 51",
    "dropmalcty": "WESSON",
    "dropmalst": "MS",
    "dropmalzpp": 391919998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016435231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14618",
    "droptype": "D",
    "dropname": "WEST",
    "dropdeladd": "540 CARROLLTON ST",
    "dropdelcty": "WEST",
    "dropdelst": "MS",
    "dropdelzpp": 391929998,
    "dropphyadd": "540 CARROLLTON ST",
    "dropphycty": "WEST",
    "dropphyst": "MS",
    "dropphyzpp": 391929998,
    "dropmaladd": "540 CARROLLTON ST",
    "dropmalcty": "WEST",
    "dropmalst": "MS",
    "dropmalzpp": 391929998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6629672201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14623",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "376 COMMERCE ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "MS",
    "dropdelzpp": 397732923,
    "dropphyadd": "376 COMMERCE ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "MS",
    "dropphyzpp": 397732923,
    "dropmaladd": "376 COMMERCE ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "MS",
    "dropmalzpp": 397732923,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624943303,
    "dropfax": 6624944640
  },
  {
    "dcode": "D",
    "dropkey": "PY14626",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "11 COUNTY ROAD 5110",
    "dropdelcty": "WHEELER",
    "dropdelst": "MS",
    "dropdelzpp": 388809998,
    "dropphyadd": "11 COUNTY ROAD 5110",
    "dropphycty": "WHEELER",
    "dropphyst": "MS",
    "dropphyzpp": 388809998,
    "dropmaladd": "11 COUNTY ROAD 5110",
    "dropmalcty": "WHEELER",
    "dropmalst": "MS",
    "dropmalzpp": 388809998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6623658115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14638",
    "droptype": "D",
    "dropname": "WIGGINS",
    "dropdeladd": "125 BORDER AVE W",
    "dropdelcty": "WIGGINS",
    "dropdelst": "MS",
    "dropdelzpp": 395779998,
    "dropphyadd": "125 BORDER AVE W",
    "dropphycty": "WIGGINS",
    "dropphyst": "MS",
    "dropphyzpp": 395779998,
    "dropmaladd": "125 BORDER AVE W",
    "dropmalcty": "WIGGINS",
    "dropmalst": "MS",
    "dropmalzpp": 395779998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6019283964,
    "dropfax": 6019283966
  },
  {
    "dcode": "D",
    "dropkey": "PY14645",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "310 SUMMIT ST",
    "dropdelcty": "WINONA",
    "dropdelst": "MS",
    "dropdelzpp": 389679998,
    "dropphyadd": "310 SUMMIT ST",
    "dropphycty": "WINONA",
    "dropphyst": "MS",
    "dropphyzpp": 389679998,
    "dropmaladd": "310 SUMMIT ST",
    "dropmalcty": "WINONA",
    "dropmalst": "MS",
    "dropmalzpp": 389679998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622832366,
    "dropfax": 6622833898
  },
  {
    "dcode": "D",
    "dropkey": "PY14646",
    "droptype": "D",
    "dropname": "WINSTONVILLE",
    "dropdeladd": "300 E WINSTON ST",
    "dropdelcty": "WINSTONVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387819998,
    "dropphyadd": "300 E WINSTON ST",
    "dropphycty": "WINSTONVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387819998,
    "dropmaladd": "300 E WINSTON ST",
    "dropmalcty": "WINSTONVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387819998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6627040033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14654",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "109 MARKET ST",
    "dropdelcty": "WOODLAND",
    "dropdelst": "MS",
    "dropdelzpp": 397769998,
    "dropphyadd": "109 MARKET ST",
    "dropphycty": "WOODLAND",
    "dropphyst": "MS",
    "dropphyzpp": 397769998,
    "dropmaladd": "109 MARKET ST",
    "dropmalcty": "WOODLAND",
    "dropmalst": "MS",
    "dropmalzpp": 397769998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624565587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14656",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "381 MAIN ST",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 396699998,
    "dropphyadd": "381 MAIN ST",
    "dropphycty": "WOODVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 396699998,
    "dropmaladd": "381 MAIN ST",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 396699998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6018884651,
    "dropfax": 6018889991
  },
  {
    "dcode": "D",
    "dropkey": "PY14664",
    "droptype": "D",
    "dropname": "YAZOO CITY",
    "dropdeladd": "341 N MAIN ST",
    "dropdelcty": "YAZOO CITY",
    "dropdelst": "MS",
    "dropdelzpp": 391949998,
    "dropphyadd": "341 N MAIN ST",
    "dropphycty": "YAZOO CITY",
    "dropphyst": "MS",
    "dropphyzpp": 391949998,
    "dropmaladd": "341 N MAIN ST",
    "dropmalcty": "YAZOO CITY",
    "dropmalst": "MS",
    "dropmalzpp": 391949998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6627468771,
    "dropsitcph": 6627465733,
    "dropfax": 6627160651
  },
  {
    "dcode": "D",
    "dropkey": "PY14675",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "111 S POPLAR ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "NC",
    "dropdelzpp": 283152763,
    "dropphyadd": "111 S POPLAR ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "NC",
    "dropphyzpp": 283152763,
    "dropmaladd": "PO BOX 28315",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "NC",
    "dropmalzpp": 283159998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9109441721,
    "dropsitcph": 9109441721,
    "dropfax": 9109444736
  },
  {
    "dcode": "D",
    "dropkey": "PY14681",
    "droptype": "D",
    "dropname": "ADVANCE",
    "dropdeladd": "1860 NC HIGHWAY 801 S",
    "dropdelcty": "ADVANCE",
    "dropdelst": "NC",
    "dropdelzpp": 270069998,
    "dropphyadd": "1860 NC HIGHWAY 801 S",
    "dropphycty": "ADVANCE",
    "dropphyst": "NC",
    "dropphyzpp": 270069998,
    "dropmaladd": "1860 NC HIGHWAY 801 S",
    "dropmalcty": "ADVANCE",
    "dropmalst": "NC",
    "dropmalzpp": 270069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369984423,
    "dropfax": 3369982834
  },
  {
    "dcode": "D",
    "dropkey": "PY14683",
    "droptype": "D",
    "dropname": "AHOSKIE",
    "dropdeladd": "115 CHURCH ST W",
    "dropdelcty": "AHOSKIE",
    "dropdelst": "NC",
    "dropdelzpp": 279109998,
    "dropphyadd": "115 CHURCH ST W",
    "dropphycty": "AHOSKIE",
    "dropphyst": "NC",
    "dropphyzpp": 279109998,
    "dropmaladd": "115 CHURCH ST W",
    "dropmalcty": "AHOSKIE",
    "dropmalst": "NC",
    "dropmalzpp": 279109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 2523325172,
    "dropfax": 2522090226
  },
  {
    "dcode": "D",
    "dropkey": "PY14685",
    "droptype": "D",
    "dropname": "ALAMANCE",
    "dropdeladd": "4205 S NC HIGHWAY 62",
    "dropdelcty": "ALAMANCE",
    "dropdelst": "NC",
    "dropdelzpp": 272010018,
    "dropphyadd": "4205 S NC HIGHWAY 62",
    "dropphycty": "ALAMANCE",
    "dropphyst": "NC",
    "dropphyzpp": 272010018,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALAMANCE",
    "dropmalst": "NC",
    "dropmalzpp": 272019998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362277511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14688",
    "droptype": "D",
    "dropname": "ALBEMARLE",
    "dropdeladd": "320 S 2ND ST",
    "dropdelcty": "ALBEMARLE",
    "dropdelst": "NC",
    "dropdelzpp": 280015704,
    "dropphyadd": "320 S 2ND ST",
    "dropphycty": "ALBEMARLE",
    "dropphyst": "NC",
    "dropphyzpp": 280015704,
    "dropmaladd": "320 S 2ND ST",
    "dropmalcty": "ALBEMARLE",
    "dropmalst": "NC",
    "dropmalzpp": 280015704,
    "dropsitphn": 7043934581,
    "dropsitlph": 7049824108,
    "dropsitcph": 7049824108,
    "dropfax": 7049846154
  },
  {
    "dcode": "D",
    "dropkey": "PY14689",
    "droptype": "D",
    "dropname": "ALBERTSON",
    "dropdeladd": "3714 N NC 903 HWY",
    "dropdelcty": "ALBERTSON",
    "dropdelst": "NC",
    "dropdelzpp": 285089534,
    "dropphyadd": "3714 N NC 903 HWY",
    "dropphycty": "ALBERTSON",
    "dropphyst": "NC",
    "dropphyzpp": 285089534,
    "dropmaladd": "PO BOX 28508",
    "dropmalcty": "ALBERTSON",
    "dropmalst": "NC",
    "dropmalzpp": 285089998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525683976,
    "dropsitcph": 2525683976,
    "dropfax": 2525683976
  },
  {
    "dcode": "D",
    "dropkey": "PY14690",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "2350 OLD MARSHALL HWY",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "NC",
    "dropdelzpp": 287019679,
    "dropphyadd": "2350 OLD MARSHALL HWY",
    "dropphycty": "ALEXANDER",
    "dropphyst": "NC",
    "dropphyzpp": 287019679,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "NC",
    "dropmalzpp": 287019998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286581485,
    "dropsitcph": 8286581485,
    "dropfax": 8286581485
  },
  {
    "dcode": "D",
    "dropkey": "PY14692",
    "droptype": "D",
    "dropname": "ALEXIS",
    "dropdeladd": "4226 CHARLES RAPER JONAS HWY",
    "dropdelcty": "ALEXIS",
    "dropdelst": "NC",
    "dropdelzpp": 280069766,
    "dropphyadd": "4226 CHARLES RAPER JONAS HWY",
    "dropphycty": "ALEXIS",
    "dropphyst": "NC",
    "dropphyzpp": 280069766,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXIS",
    "dropmalst": "NC",
    "dropmalzpp": 280069998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042638585,
    "dropsitcph": 7042638585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14695",
    "droptype": "D",
    "dropname": "ALLIANCE",
    "dropdeladd": "13144 NC 55 HWY",
    "dropdelcty": "ALLIANCE",
    "dropdelst": "NC",
    "dropdelzpp": 285095000,
    "dropphyadd": "13144 NC 55 HWY",
    "dropphycty": "ALLIANCE",
    "dropphyst": "NC",
    "dropphyzpp": 285095000,
    "dropmaladd": "PO BOX 28509",
    "dropmalcty": "ALLIANCE",
    "dropmalst": "NC",
    "dropmalzpp": 285099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527454524,
    "dropsitcph": 2524942686,
    "dropfax": 2524942688
  },
  {
    "dcode": "D",
    "dropkey": "PY14697",
    "droptype": "D",
    "dropname": "ALMOND",
    "dropdeladd": "1940 NC HIGHWAY 28 N",
    "dropdelcty": "ALMOND",
    "dropdelst": "NC",
    "dropdelzpp": 287029603,
    "dropphyadd": "1940 NC HIGHWAY 28 N",
    "dropphycty": "ALMOND",
    "dropphyst": "NC",
    "dropphyzpp": 287029603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMOND",
    "dropmalst": "NC",
    "dropmalzpp": 287029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284883459,
    "dropsitcph": 8284883459,
    "dropfax": 8284883459
  },
  {
    "dcode": "D",
    "dropkey": "PY14698",
    "droptype": "D",
    "dropname": "ALTAMAHAW",
    "dropdeladd": "3788 ALTAMAHAW CHURCH ST",
    "dropdelcty": "ALTAMAHAW",
    "dropdelst": "NC",
    "dropdelzpp": 272029800,
    "dropphyadd": "3788 ALTAMAHAW CHURCH ST",
    "dropphycty": "ALTAMAHAW",
    "dropphyst": "NC",
    "dropphyzpp": 272029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTAMAHAW",
    "dropmalst": "NC",
    "dropmalzpp": 272029998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365848096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14704",
    "droptype": "D",
    "dropname": "ANDREWS",
    "dropdeladd": "12 CHESTNUT ST",
    "dropdelcty": "ANDREWS",
    "dropdelst": "NC",
    "dropdelzpp": 289019748,
    "dropphyadd": "12 CHESTNUT ST",
    "dropphycty": "ANDREWS",
    "dropphyst": "NC",
    "dropphyzpp": 289019748,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANDREWS",
    "dropmalst": "NC",
    "dropmalzpp": 289019998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8283214208,
    "dropsitcph": 8283214208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14705",
    "droptype": "D",
    "dropname": "ANGIER",
    "dropdeladd": "31 W DUPREE ST",
    "dropdelcty": "ANGIER",
    "dropdelst": "NC",
    "dropdelzpp": 275019998,
    "dropphyadd": "31 W DUPREE ST",
    "dropphycty": "ANGIER",
    "dropphyst": "NC",
    "dropphyzpp": 275019998,
    "dropmaladd": "31 W DUPREE ST",
    "dropmalcty": "ANGIER",
    "dropmalst": "NC",
    "dropmalzpp": 275019998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196397129,
    "dropfax": 9196399345
  },
  {
    "dcode": "D",
    "dropkey": "PY14706",
    "droptype": "D",
    "dropname": "ANSONVILLE",
    "dropdeladd": "8795 HIGHWAY 52 N",
    "dropdelcty": "ANSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 280079798,
    "dropphyadd": "8795 HIGHWAY 52 N",
    "dropphycty": "ANSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 280079798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 280079998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048268529,
    "dropsitcph": 7048268529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14709",
    "droptype": "D",
    "dropname": "APEX",
    "dropdeladd": "501 W WILLIAMS ST",
    "dropdelcty": "APEX",
    "dropdelst": "NC",
    "dropdelzpp": 275029998,
    "dropphyadd": "501 W WILLIAMS ST",
    "dropphycty": "APEX",
    "dropphyst": "NC",
    "dropphyzpp": 275029998,
    "dropmaladd": "501 W WILLIAMS ST",
    "dropmalcty": "APEX",
    "dropmalst": "NC",
    "dropmalzpp": 275029998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9193620395,
    "dropfax": 9193037654
  },
  {
    "dcode": "D",
    "dropkey": "PY14714",
    "droptype": "D",
    "dropname": "ARAPAHOE",
    "dropdeladd": "7706 KERSHAW RD",
    "dropdelcty": "ARAPAHOE",
    "dropdelst": "NC",
    "dropdelzpp": 285109709,
    "dropphyadd": "7706 KERSHAW RD",
    "dropphycty": "ARAPAHOE",
    "dropphyst": "NC",
    "dropphyzpp": 285109709,
    "dropmaladd": "PO BOX 28510",
    "dropmalcty": "ARAPAHOE",
    "dropmalst": "NC",
    "dropmalzpp": 285109998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522491711,
    "dropsitcph": 2522491711,
    "dropfax": 2522491134
  },
  {
    "dcode": "D",
    "dropkey": "PY14715",
    "droptype": "D",
    "dropname": "ARARAT",
    "dropdeladd": "1354 ARARAT RD",
    "dropdelcty": "ARARAT",
    "dropdelst": "NC",
    "dropdelzpp": 270079998,
    "dropphyadd": "1354 ARARAT RD",
    "dropphycty": "ARARAT",
    "dropphyst": "NC",
    "dropphyzpp": 270079998,
    "dropmaladd": "1354 ARARAT RD",
    "dropmalcty": "ARARAT",
    "dropmalst": "NC",
    "dropmalzpp": 270079998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363745601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14720",
    "droptype": "D",
    "dropname": "ARDEN",
    "dropdeladd": "2385 HENDERSONVILLE RD",
    "dropdelcty": "ARDEN",
    "dropdelst": "NC",
    "dropdelzpp": 287044506,
    "dropphyadd": "2385 HENDERSONVILLE RD",
    "dropphycty": "ARDEN",
    "dropphyst": "NC",
    "dropphyzpp": 287044506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARDEN",
    "dropmalst": "NC",
    "dropmalzpp": 287049998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286846971,
    "dropsitcph": 8286846971,
    "dropfax": 8286840924
  },
  {
    "dcode": "D",
    "dropkey": "PY14726",
    "droptype": "D",
    "dropname": "ASH",
    "dropdeladd": "3882 WHITEVILLE RD NW",
    "dropdelcty": "ASH",
    "dropdelst": "NC",
    "dropdelzpp": 284203800,
    "dropphyadd": "3882 WHITEVILLE RD NW",
    "dropphycty": "ASH",
    "dropphyst": "NC",
    "dropphyzpp": 284203800,
    "dropmaladd": "PO BOX 28420",
    "dropmalcty": "ASH",
    "dropmalst": "NC",
    "dropmalzpp": 284209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102876340,
    "dropsitcph": 9102876340,
    "dropfax": 9102876340
  },
  {
    "dcode": "D",
    "dropkey": "PY14728",
    "droptype": "D",
    "dropname": "ASHEBORO",
    "dropdeladd": "1030 S CHURCH ST",
    "dropdelcty": "ASHEBORO",
    "dropdelst": "NC",
    "dropdelzpp": 272036499,
    "dropphyadd": "1030 S CHURCH ST",
    "dropphycty": "ASHEBORO",
    "dropphyst": "NC",
    "dropphyzpp": 272036499,
    "dropmaladd": "1030 S CHURCH ST",
    "dropmalcty": "ASHEBORO",
    "dropmalst": "NC",
    "dropmalzpp": 272039998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366295419,
    "dropfax": 3366297714
  },
  {
    "dcode": "D",
    "dropkey": "PY14730",
    "droptype": "D",
    "dropname": "ASHEVILLE",
    "dropdeladd": "591 BREVARD RD",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288100001,
    "dropphyadd": "591 BREVARD RD",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288100001,
    "dropmaladd": "591 BREVARD RD",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288100001,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282574194,
    "dropsitcph": 8282574194,
    "dropfax": 8282574178
  },
  {
    "dcode": "D",
    "dropkey": "PY14737",
    "droptype": "D",
    "dropname": "ATKINSON",
    "dropdeladd": "105 W CHURCH ST",
    "dropdelcty": "ATKINSON",
    "dropdelst": "NC",
    "dropdelzpp": 284219230,
    "dropphyadd": "105 W CHURCH ST",
    "dropphycty": "ATKINSON",
    "dropphyst": "NC",
    "dropphyzpp": 284219230,
    "dropmaladd": "PO BOX 28421",
    "dropmalcty": "ATKINSON",
    "dropmalst": "NC",
    "dropmalzpp": 284219998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102837483,
    "dropsitcph": 9102837483,
    "dropfax": 9102837504
  },
  {
    "dcode": "D",
    "dropkey": "PY14738",
    "droptype": "D",
    "dropname": "ATLANTIC",
    "dropdeladd": "755 SEASHORE DR",
    "dropdelcty": "ATLANTIC",
    "dropdelst": "NC",
    "dropdelzpp": 285119796,
    "dropphyadd": "755 SEASHORE DR",
    "dropphycty": "ATLANTIC",
    "dropphyst": "NC",
    "dropphyzpp": 285119796,
    "dropmaladd": "PO BOX 28511",
    "dropmalcty": "ATLANTIC",
    "dropmalst": "NC",
    "dropmalzpp": 285119998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522255081,
    "dropsitcph": 2522255081,
    "dropfax": 2522250914
  },
  {
    "dcode": "D",
    "dropkey": "PY14740",
    "droptype": "D",
    "dropname": "ATLANTIC BEACH",
    "dropdeladd": "1516 W FORT MACON RD",
    "dropdelcty": "ATLANTIC BEACH",
    "dropdelst": "NC",
    "dropdelzpp": 285125328,
    "dropphyadd": "1516 W FORT MACON RD",
    "dropphycty": "ATLANTIC BEACH",
    "dropphyst": "NC",
    "dropphyzpp": 285125328,
    "dropmaladd": "PO BOX 28512",
    "dropmalcty": "ATLANTIC BEACH",
    "dropmalst": "NC",
    "dropmalzpp": 285129998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527265630,
    "dropsitcph": 2527265630,
    "dropfax": 2522402467
  },
  {
    "dcode": "D",
    "dropkey": "PY14741",
    "droptype": "D",
    "dropname": "AULANDER",
    "dropdeladd": "107 W MAIN ST",
    "dropdelcty": "AULANDER",
    "dropdelst": "NC",
    "dropdelzpp": 278059998,
    "dropphyadd": "107 W MAIN ST",
    "dropphycty": "AULANDER",
    "dropphyst": "NC",
    "dropphyzpp": 278059998,
    "dropmaladd": "107 W MAIN ST",
    "dropmalcty": "AULANDER",
    "dropmalst": "NC",
    "dropmalzpp": 278059998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523454551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14742",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "186 N 5TH ST",
    "dropdelcty": "AURORA",
    "dropdelst": "NC",
    "dropdelzpp": 278069998,
    "dropphyadd": "186 N 5TH ST",
    "dropphycty": "AURORA",
    "dropphyst": "NC",
    "dropphyzpp": 278069998,
    "dropmaladd": "186 N 5TH ST",
    "dropmalcty": "AURORA",
    "dropmalst": "NC",
    "dropmalzpp": 278069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523224392,
    "dropfax": 2523227144
  },
  {
    "dcode": "D",
    "dropkey": "PY14744",
    "droptype": "D",
    "dropname": "AUTRYVILLE",
    "dropdeladd": "100 W WILLIAMS ST",
    "dropdelcty": "AUTRYVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283188980,
    "dropphyadd": "100 W WILLIAMS ST",
    "dropphycty": "AUTRYVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283188980,
    "dropmaladd": "PO BOX 28318",
    "dropmalcty": "AUTRYVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283189998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105255221,
    "dropsitcph": 9105255221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14750",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "41196 NC HIGHWAY 12",
    "dropdelcty": "AVON",
    "dropdelst": "NC",
    "dropdelzpp": 279159701,
    "dropphyadd": "41196 NC HIGHWAY 12",
    "dropphycty": "AVON",
    "dropphyst": "NC",
    "dropphyzpp": 279159701,
    "dropmaladd": "41196 NC HIGHWAY 12",
    "dropmalcty": "AVON",
    "dropmalst": "NC",
    "dropmalzpp": 279159701,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529955991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14751",
    "droptype": "D",
    "dropname": "AYDEN",
    "dropdeladd": "452 SECOND ST",
    "dropdelcty": "AYDEN",
    "dropdelst": "NC",
    "dropdelzpp": 285137179,
    "dropphyadd": "452 SECOND ST",
    "dropphycty": "AYDEN",
    "dropphyst": "NC",
    "dropphyzpp": 285137179,
    "dropmaladd": "PO BOX 28513",
    "dropmalcty": "AYDEN",
    "dropmalst": "NC",
    "dropmalzpp": 285139998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527466464,
    "dropsitcph": 2527466464,
    "dropfax": 2527466540
  },
  {
    "dcode": "D",
    "dropkey": "PY14752",
    "droptype": "D",
    "dropname": "AYDLETT",
    "dropdeladd": "523 AYDLETT RD",
    "dropdelcty": "AYDLETT",
    "dropdelst": "NC",
    "dropdelzpp": 279169998,
    "dropphyadd": "523 AYDLETT RD",
    "dropphycty": "AYDLETT",
    "dropphyst": "NC",
    "dropphyzpp": 279169998,
    "dropmaladd": "523 AYDLETT RD",
    "dropmalcty": "AYDLETT",
    "dropmalst": "NC",
    "dropmalzpp": 279169998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524533388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14755",
    "droptype": "D",
    "dropname": "BADIN",
    "dropdeladd": "1 BOYDEN ST",
    "dropdelcty": "BADIN",
    "dropdelst": "NC",
    "dropdelzpp": 280099798,
    "dropphyadd": "1 BOYDEN ST",
    "dropphycty": "BADIN",
    "dropphyst": "NC",
    "dropphyzpp": 280099798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BADIN",
    "dropmalst": "NC",
    "dropmalzpp": 280099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044223775,
    "dropsitcph": 7044223775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14758",
    "droptype": "D",
    "dropname": "BAHAMA",
    "dropdeladd": "1420 BAHAMA RD",
    "dropdelcty": "BAHAMA",
    "dropdelst": "NC",
    "dropdelzpp": 275039998,
    "dropphyadd": "1420 BAHAMA RD",
    "dropphycty": "BAHAMA",
    "dropphyst": "NC",
    "dropphyzpp": 275039998,
    "dropmaladd": "1420 BAHAMA RD",
    "dropmalcty": "BAHAMA",
    "dropmalst": "NC",
    "dropmalzpp": 275039998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194772449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14759",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "6171 DEANS ST",
    "dropdelcty": "BAILEY",
    "dropdelst": "NC",
    "dropdelzpp": 278079998,
    "dropphyadd": "6171 DEANS ST",
    "dropphycty": "BAILEY",
    "dropphyst": "NC",
    "dropphyzpp": 278079998,
    "dropmaladd": "6171 DEANS ST",
    "dropmalcty": "BAILEY",
    "dropmalst": "NC",
    "dropmalzpp": 278079998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522353565,
    "dropfax": 2522353565
  },
  {
    "dcode": "D",
    "dropkey": "PY14760",
    "droptype": "D",
    "dropname": "BAKERSVILLE",
    "dropdeladd": "130 HEMLOCK DR",
    "dropdelcty": "BAKERSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287057491,
    "dropphyadd": "130 HEMLOCK DR",
    "dropphycty": "BAKERSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287057491,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAKERSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287059998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286882571,
    "dropsitcph": 8286882571,
    "dropfax": 8286881971
  },
  {
    "dcode": "D",
    "dropkey": "PY14767",
    "droptype": "D",
    "dropname": "BALSAM",
    "dropdeladd": "103 CABIN FLATS RD",
    "dropdelcty": "BALSAM",
    "dropdelst": "NC",
    "dropdelzpp": 287079798,
    "dropphyadd": "103 CABIN FLATS RD",
    "dropphycty": "BALSAM",
    "dropphyst": "NC",
    "dropphyzpp": 287079798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALSAM",
    "dropmalst": "NC",
    "dropmalzpp": 287079998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284568544,
    "dropsitcph": 8284568544,
    "dropfax": 8284568544
  },
  {
    "dcode": "D",
    "dropkey": "PY14768",
    "droptype": "D",
    "dropname": "BALSAM GROVE",
    "dropdeladd": "8125 PARKWAY RD",
    "dropdelcty": "BALSAM GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 287089725,
    "dropphyadd": "8125 PARKWAY RD",
    "dropphycty": "BALSAM GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 287089725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALSAM GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 287089998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288846262,
    "dropsitcph": 8288846262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14771",
    "droptype": "D",
    "dropname": "BANNER ELK",
    "dropdeladd": "155 CENTRAL WAY SW",
    "dropdelcty": "BANNER ELK",
    "dropdelst": "NC",
    "dropdelzpp": 286049901,
    "dropphyadd": "155 CENTRAL WAY SW",
    "dropphycty": "BANNER ELK",
    "dropphyst": "NC",
    "dropphyzpp": 286049901,
    "dropmaladd": "155 CENTRAL WAY SW",
    "dropmalcty": "BANNER ELK",
    "dropmalst": "NC",
    "dropmalzpp": 286049998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8288984334,
    "dropfax": 8288983734
  },
  {
    "dcode": "D",
    "dropkey": "PY14773",
    "droptype": "D",
    "dropname": "BARCO",
    "dropdeladd": "3929 CARATOKE HWY",
    "dropdelcty": "BARCO",
    "dropdelst": "NC",
    "dropdelzpp": 279179998,
    "dropphyadd": "3929 CARATOKE HWY",
    "dropphycty": "BARCO",
    "dropphyst": "NC",
    "dropphyzpp": 279179998,
    "dropmaladd": "3929 CARATOKE HWY",
    "dropmalcty": "BARCO",
    "dropmalst": "NC",
    "dropmalzpp": 279179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524538622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14775",
    "droptype": "D",
    "dropname": "BARIUM SPRINGS",
    "dropdeladd": "2625 SHELTON AVE",
    "dropdelcty": "BARIUM SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 280109700,
    "dropphyadd": "2625 SHELTON AVE",
    "dropphycty": "BARIUM SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 280109700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARIUM SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 280109998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048727559,
    "dropsitcph": 7048727559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14776",
    "droptype": "D",
    "dropname": "BARNARDSVILLE",
    "dropdeladd": "1664 BARNARDSVILLE HWY",
    "dropdelcty": "BARNARDSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287099700,
    "dropphyadd": "1664 BARNARDSVILLE HWY",
    "dropphycty": "BARNARDSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287099700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNARDSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282203390,
    "dropsitcph": 8282203390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14785",
    "droptype": "D",
    "dropname": "BAT CAVE",
    "dropdeladd": "89 LAKE LURE HWY",
    "dropdelcty": "BAT CAVE",
    "dropdelst": "NC",
    "dropdelzpp": 287109700,
    "dropphyadd": "89 LAKE LURE HWY",
    "dropphycty": "BAT CAVE",
    "dropphyst": "NC",
    "dropphyzpp": 287109700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAT CAVE",
    "dropmalst": "NC",
    "dropmalzpp": 287109998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286254243,
    "dropsitcph": 8286254243,
    "dropfax": 8286251491
  },
  {
    "dcode": "D",
    "dropkey": "PY14786",
    "droptype": "D",
    "dropname": "BATH",
    "dropdeladd": "415 CARTERET ST",
    "dropdelcty": "BATH",
    "dropdelst": "NC",
    "dropdelzpp": 278089998,
    "dropphyadd": "415 CARTERET ST",
    "dropphycty": "BATH",
    "dropphyst": "NC",
    "dropphyzpp": 278089998,
    "dropmaladd": "415 CARTERET ST",
    "dropmalcty": "BATH",
    "dropmalst": "NC",
    "dropmalzpp": 278089998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529233201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14788",
    "droptype": "D",
    "dropname": "BATTLEBORO",
    "dropdeladd": "241 W BATTLEBORO AVE",
    "dropdelcty": "BATTLEBORO",
    "dropdelst": "NC",
    "dropdelzpp": 278099659,
    "dropphyadd": "241 W BATTLEBORO AVE",
    "dropphycty": "BATTLEBORO",
    "dropphyst": "NC",
    "dropphyzpp": 278099659,
    "dropmaladd": "241 W BATTLEBORO AVE",
    "dropmalcty": "BATTLEBORO",
    "dropmalst": "NC",
    "dropmalzpp": 278099659,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524467605,
    "dropfax": 2529722665
  },
  {
    "dcode": "D",
    "dropkey": "PY14790",
    "droptype": "D",
    "dropname": "BAYBORO",
    "dropdeladd": "107 MAIN ST",
    "dropdelcty": "BAYBORO",
    "dropdelst": "NC",
    "dropdelzpp": 285159685,
    "dropphyadd": "107 MAIN ST",
    "dropphycty": "BAYBORO",
    "dropphyst": "NC",
    "dropphyzpp": 285159685,
    "dropmaladd": "PO BOX 28515",
    "dropmalcty": "BAYBORO",
    "dropmalst": "NC",
    "dropmalzpp": 285159998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527454641,
    "dropsitcph": 2527454641,
    "dropfax": 2527454641
  },
  {
    "dcode": "D",
    "dropkey": "PY14792",
    "droptype": "D",
    "dropname": "BEAR CREEK",
    "dropdeladd": "14525 NC 902 HWY",
    "dropdelcty": "BEAR CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 272078400,
    "dropphyadd": "14525 NC 902 HWY",
    "dropphycty": "BEAR CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 272078400,
    "dropmaladd": "14525 NC 902 HWY",
    "dropmalcty": "BEAR CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 272079998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9198375962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14794",
    "droptype": "D",
    "dropname": "BEAUFORT",
    "dropdeladd": "1903 LIVE OAK ST",
    "dropdelcty": "BEAUFORT",
    "dropdelst": "NC",
    "dropdelzpp": 285167925,
    "dropphyadd": "1903 LIVE OAK ST",
    "dropphycty": "BEAUFORT",
    "dropphyst": "NC",
    "dropphyzpp": 285167925,
    "dropmaladd": "1903 LIVE OAK ST",
    "dropmalcty": "BEAUFORT",
    "dropmalst": "NC",
    "dropmalzpp": 285167925,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527281812,
    "dropsitcph": 2527281812,
    "dropfax": 2527284697
  },
  {
    "dcode": "D",
    "dropkey": "PY14802",
    "droptype": "D",
    "dropname": "BELEWS CREEK",
    "dropdeladd": "8540 BELEWS CREEK RD",
    "dropdelcty": "BELEWS CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 270099998,
    "dropphyadd": "8540 BELEWS CREEK RD",
    "dropphycty": "BELEWS CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 270099998,
    "dropmaladd": "8540 BELEWS CREEK RD",
    "dropmalcty": "BELEWS CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 270099998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365954100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14804",
    "droptype": "D",
    "dropname": "BELHAVEN",
    "dropdeladd": "614 W OLD COUNTY RD",
    "dropdelcty": "BELHAVEN",
    "dropdelst": "NC",
    "dropdelzpp": 278109998,
    "dropphyadd": "614 W OLD COUNTY RD",
    "dropphycty": "BELHAVEN",
    "dropphyst": "NC",
    "dropphyzpp": 278109998,
    "dropmaladd": "614 W OLD COUNTY RD",
    "dropmalcty": "BELHAVEN",
    "dropmalst": "NC",
    "dropmalzpp": 278109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529432364,
    "dropfax": 2529432667
  },
  {
    "dcode": "D",
    "dropkey": "PY14805",
    "droptype": "D",
    "dropname": "BELLARTHUR",
    "dropdeladd": "2643B FIREHOUSE RD",
    "dropdelcty": "BELLARTHUR",
    "dropdelst": "NC",
    "dropdelzpp": 278119998,
    "dropphyadd": "2643B FIREHOUSE RD",
    "dropphycty": "BELLARTHUR",
    "dropphyst": "NC",
    "dropphyzpp": 278119998,
    "dropmaladd": "2643B FIREHOUSE RD",
    "dropmalcty": "BELLARTHUR",
    "dropmalst": "NC",
    "dropmalzpp": 278119998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527521575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14807",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "208 GLENWAY ST",
    "dropdelcty": "BELMONT",
    "dropdelst": "NC",
    "dropdelzpp": 280123181,
    "dropphyadd": "208 GLENWAY ST",
    "dropphycty": "BELMONT",
    "dropphyst": "NC",
    "dropphyzpp": 280123181,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELMONT",
    "dropmalst": "NC",
    "dropmalzpp": 280129998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048256139,
    "dropsitcph": 7048256139,
    "dropfax": 7048259233
  },
  {
    "dcode": "D",
    "dropkey": "PY14808",
    "droptype": "D",
    "dropname": "BELVIDERE",
    "dropdeladd": "1517 BELVIDERE RD",
    "dropdelcty": "BELVIDERE",
    "dropdelst": "NC",
    "dropdelzpp": 279199804,
    "dropphyadd": "1517 BELVIDERE RD",
    "dropphycty": "BELVIDERE",
    "dropphyst": "NC",
    "dropphyzpp": 279199804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELVIDERE",
    "dropmalst": "NC",
    "dropmalzpp": 279199998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522972300,
    "dropfax": 2522972425
  },
  {
    "dcode": "D",
    "dropkey": "PY14811",
    "droptype": "D",
    "dropname": "BENNETT",
    "dropdeladd": "3859 CHATHAM ST",
    "dropdelcty": "BENNETT",
    "dropdelst": "NC",
    "dropdelzpp": 272089412,
    "dropphyadd": "3859 CHATHAM ST",
    "dropphycty": "BENNETT",
    "dropphyst": "NC",
    "dropphyzpp": 272089412,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENNETT",
    "dropmalst": "NC",
    "dropmalzpp": 272089998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365813550,
    "dropfax": 3365814046
  },
  {
    "dcode": "D",
    "dropkey": "PY14812",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "402 S MARKET ST",
    "dropdelcty": "BENSON",
    "dropdelst": "NC",
    "dropdelzpp": 275049998,
    "dropphyadd": "402 S MARKET ST",
    "dropphycty": "BENSON",
    "dropphyst": "NC",
    "dropphyzpp": 275049998,
    "dropmaladd": "402 S MARKET ST",
    "dropmalcty": "BENSON",
    "dropmalst": "NC",
    "dropmalzpp": 275049998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198946156,
    "dropfax": 9198945378
  },
  {
    "dcode": "D",
    "dropkey": "PY14817",
    "droptype": "D",
    "dropname": "BESSEMER CITY",
    "dropdeladd": "124 E ALABAMA AVE",
    "dropdelcty": "BESSEMER CITY",
    "dropdelst": "NC",
    "dropdelzpp": 280162603,
    "dropphyadd": "124 E ALABAMA AVE",
    "dropphycty": "BESSEMER CITY",
    "dropphyst": "NC",
    "dropphyzpp": 280162603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BESSEMER CITY",
    "dropmalst": "NC",
    "dropmalzpp": 280169998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046292832,
    "dropsitcph": 7046292832,
    "dropfax": 7046290747
  },
  {
    "dcode": "D",
    "dropkey": "PY14821",
    "droptype": "D",
    "dropname": "BETHANIA",
    "dropdeladd": "5670 MAIN ST",
    "dropdelcty": "BETHANIA",
    "dropdelst": "NC",
    "dropdelzpp": 270109800,
    "dropphyadd": "5670 MAIN ST",
    "dropphycty": "BETHANIA",
    "dropphyst": "NC",
    "dropphyzpp": 270109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHANIA",
    "dropmalst": "NC",
    "dropmalzpp": 270109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369244093,
    "dropfax": 3369248855
  },
  {
    "dcode": "D",
    "dropkey": "PY14822",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "3858 EAST ST",
    "dropdelcty": "BETHEL",
    "dropdelst": "NC",
    "dropdelzpp": 278129998,
    "dropphyadd": "3858 EAST ST",
    "dropphycty": "BETHEL",
    "dropphyst": "NC",
    "dropphyzpp": 278129998,
    "dropmaladd": "3858 EAST ST",
    "dropmalcty": "BETHEL",
    "dropmalst": "NC",
    "dropmalzpp": 278129998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9198313642,
    "dropsitcph": 2528254101,
    "dropfax": 2528250706
  },
  {
    "dcode": "D",
    "dropkey": "PY14826",
    "droptype": "D",
    "dropname": "BEULAVILLE",
    "dropdeladd": "807 E MAIN ST",
    "dropdelcty": "BEULAVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285188715,
    "dropphyadd": "807 E MAIN ST",
    "dropphycty": "BEULAVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285188715,
    "dropmaladd": "PO BOX 28518",
    "dropmalcty": "BEULAVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285189998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102984370,
    "dropsitcph": 9102984370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14833",
    "droptype": "D",
    "dropname": "BISCOE",
    "dropdeladd": "303 S MAIN ST",
    "dropdelcty": "BISCOE",
    "dropdelst": "NC",
    "dropdelzpp": 272098091,
    "dropphyadd": "303 S MAIN ST",
    "dropphycty": "BISCOE",
    "dropphyst": "NC",
    "dropphyzpp": 272098091,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BISCOE",
    "dropmalst": "NC",
    "dropmalzpp": 272099998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9104282511,
    "dropfax": 9104289518
  },
  {
    "dcode": "D",
    "dropkey": "PY14835",
    "droptype": "D",
    "dropname": "BLACK CREEK",
    "dropdeladd": "101 CENTRAL AVE",
    "dropdelcty": "BLACK CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 278139998,
    "dropphyadd": "101 CENTRAL AVE",
    "dropphycty": "BLACK CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 278139998,
    "dropmaladd": "101 CENTRAL AVE",
    "dropmalcty": "BLACK CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 278139998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522377540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14837",
    "droptype": "D",
    "dropname": "BLACK MOUNTAIN",
    "dropdeladd": "104 RICHARDSON BLVD",
    "dropdelcty": "BLACK MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 287113527,
    "dropphyadd": "104 RICHARDSON BLVD",
    "dropphycty": "BLACK MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 287113527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 287119998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286698381,
    "dropsitcph": 8286698381,
    "dropfax": 8286690980
  },
  {
    "dcode": "D",
    "dropkey": "PY14842",
    "droptype": "D",
    "dropname": "BLADENBORO",
    "dropdeladd": "223 MARTIN LUTHER KING JR DR",
    "dropdelcty": "BLADENBORO",
    "dropdelst": "NC",
    "dropdelzpp": 283208682,
    "dropphyadd": "223 MARTIN LUTHER KING JR DR",
    "dropphycty": "BLADENBORO",
    "dropphyst": "NC",
    "dropphyzpp": 283208682,
    "dropmaladd": "PO BOX 28320",
    "dropmalcty": "BLADENBORO",
    "dropmalst": "NC",
    "dropmalzpp": 283209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108633218,
    "dropsitcph": 9103103008,
    "dropfax": 9108634836
  },
  {
    "dcode": "D",
    "dropkey": "PY14848",
    "droptype": "D",
    "dropname": "BLOUNTS CREEK",
    "dropdeladd": "13746 NC HIGHWAY 33 E",
    "dropdelcty": "BLOUNTS CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 278149206,
    "dropphyadd": "13746 NC HIGHWAY 33 E",
    "dropphycty": "BLOUNTS CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 278149206,
    "dropmaladd": "13746 NC HIGHWAY 33 E",
    "dropmalcty": "BLOUNTS CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 278149998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523224041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14851",
    "droptype": "D",
    "dropname": "BLOWING ROCK",
    "dropdeladd": "977 MAIN ST",
    "dropdelcty": "BLOWING ROCK",
    "dropdelst": "NC",
    "dropdelzpp": 286059932,
    "dropphyadd": "977 MAIN ST",
    "dropphycty": "BLOWING ROCK",
    "dropphyst": "NC",
    "dropphyzpp": 286059932,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOWING ROCK",
    "dropmalst": "NC",
    "dropmalzpp": 286059998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282953589,
    "dropfax": 8282953479
  },
  {
    "dcode": "D",
    "dropkey": "PY14859",
    "droptype": "D",
    "dropname": "BOILING SPRINGS",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "BOILING SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 280179798,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "BOILING SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 280179798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOILING SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 280179998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044347696,
    "dropsitcph": 7044347696,
    "dropfax": 7044347959
  },
  {
    "dcode": "D",
    "dropkey": "PY14860",
    "droptype": "D",
    "dropname": "BOLIVIA",
    "dropdeladd": "3890 BUSINESS 17 E",
    "dropdelcty": "BOLIVIA",
    "dropdelst": "NC",
    "dropdelzpp": 284228665,
    "dropphyadd": "3890 BUSINESS 17 E",
    "dropphycty": "BOLIVIA",
    "dropphyst": "NC",
    "dropphyzpp": 284228665,
    "dropmaladd": "PO BOX 28422",
    "dropmalcty": "BOLIVIA",
    "dropmalst": "NC",
    "dropmalzpp": 284229998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102535757,
    "dropsitcph": 9102535757,
    "dropfax": 9102539210
  },
  {
    "dcode": "D",
    "dropkey": "PY14861",
    "droptype": "D",
    "dropname": "BOLTON",
    "dropdeladd": "15315 SAM POTTS HWY",
    "dropdelcty": "BOLTON",
    "dropdelst": "NC",
    "dropdelzpp": 284238407,
    "dropphyadd": "15315 SAM POTTS HWY",
    "dropphycty": "BOLTON",
    "dropphyst": "NC",
    "dropphyzpp": 284238407,
    "dropmaladd": "PO BOX 28423",
    "dropmalcty": "BOLTON",
    "dropmalst": "NC",
    "dropmalzpp": 284239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106558468,
    "dropsitcph": 9106558468,
    "dropfax": 9106558850
  },
  {
    "dcode": "D",
    "dropkey": "PY14862",
    "droptype": "D",
    "dropname": "BONLEE",
    "dropdeladd": "1010 ELMER MOORE RD",
    "dropdelcty": "BONLEE",
    "dropdelst": "NC",
    "dropdelzpp": 272139997,
    "dropphyadd": "1010 ELMER MOORE RD",
    "dropphycty": "BONLEE",
    "dropphyst": "NC",
    "dropphyzpp": 272139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BONLEE",
    "dropmalst": "NC",
    "dropmalzpp": 272139998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9198375471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14865",
    "droptype": "D",
    "dropname": "BOOMER",
    "dropdeladd": "2716 BOOMER RD",
    "dropdelcty": "BOOMER",
    "dropdelst": "NC",
    "dropdelzpp": 286068201,
    "dropphyadd": "2716 BOOMER RD",
    "dropphycty": "BOOMER",
    "dropphyst": "NC",
    "dropphyzpp": 286068201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOOMER",
    "dropmalst": "NC",
    "dropmalzpp": 286069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369213677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14868",
    "droptype": "D",
    "dropname": "BOONVILLE",
    "dropdeladd": "202 S CAROLINA AVE",
    "dropdelcty": "BOONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270119998,
    "dropphyadd": "202 S CAROLINA AVE",
    "dropphycty": "BOONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270119998,
    "dropmaladd": "202 S CAROLINA AVE",
    "dropmalcty": "BOONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270119998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363677850,
    "dropfax": 3363674096
  },
  {
    "dcode": "D",
    "dropkey": "PY14871",
    "droptype": "D",
    "dropname": "BOSTIC",
    "dropdeladd": "1521 BOSTIC SUNSHINE HWY",
    "dropdelcty": "BOSTIC",
    "dropdelst": "NC",
    "dropdelzpp": 280189525,
    "dropphyadd": "1521 BOSTIC SUNSHINE HWY",
    "dropphycty": "BOSTIC",
    "dropphyst": "NC",
    "dropphyzpp": 280189525,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOSTIC",
    "dropmalst": "NC",
    "dropmalzpp": 280189998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282456901,
    "dropsitcph": 8282456901,
    "dropfax": 8282457825
  },
  {
    "dcode": "D",
    "dropkey": "PY14880",
    "droptype": "D",
    "dropname": "BRASSTOWN",
    "dropdeladd": "98 SETTAWIG RD",
    "dropdelcty": "BRASSTOWN",
    "dropdelst": "NC",
    "dropdelzpp": 289029758,
    "dropphyadd": "98 SETTAWIG RD",
    "dropphycty": "BRASSTOWN",
    "dropphyst": "NC",
    "dropphyzpp": 289029758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRASSTOWN",
    "dropmalst": "NC",
    "dropmalzpp": 289029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288375046,
    "dropsitcph": 8288375046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14883",
    "droptype": "D",
    "dropname": "BREVARD",
    "dropdeladd": "159 W MAIN ST",
    "dropdelcty": "BREVARD",
    "dropdelst": "NC",
    "dropdelzpp": 287120019,
    "dropphyadd": "159 W MAIN ST",
    "dropphycty": "BREVARD",
    "dropphyst": "NC",
    "dropphyzpp": 287120019,
    "dropmaladd": "159 W MAIN ST",
    "dropmalcty": "BREVARD",
    "dropmalst": "NC",
    "dropmalzpp": 287120019,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288839380,
    "dropsitcph": 8288839380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14884",
    "droptype": "D",
    "dropname": "BRIDGETON",
    "dropdeladd": "601 N D ST",
    "dropdelcty": "BRIDGETON",
    "dropdelst": "NC",
    "dropdelzpp": 285195000,
    "dropphyadd": "601 N D ST",
    "dropphycty": "BRIDGETON",
    "dropphyst": "NC",
    "dropphyzpp": 285195000,
    "dropmaladd": "PO BOX 28519",
    "dropmalcty": "BRIDGETON",
    "dropmalst": "NC",
    "dropmalzpp": 285199998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2526386350,
    "dropsitcph": 2526386350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14888",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "BROADWAY",
    "dropdelst": "NC",
    "dropdelzpp": 275059998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "BROADWAY",
    "dropphyst": "NC",
    "dropphyzpp": 275059998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "BROADWAY",
    "dropmalst": "NC",
    "dropmalzpp": 275059998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192583934,
    "dropfax": 9192583760
  },
  {
    "dcode": "D",
    "dropkey": "PY14894",
    "droptype": "D",
    "dropname": "BROWNS SUMMIT",
    "dropdeladd": "7222 BROWNS SUMMIT RD",
    "dropdelcty": "BROWNS SUMMIT",
    "dropdelst": "NC",
    "dropdelzpp": 272149763,
    "dropphyadd": "7222 BROWNS SUMMIT RD",
    "dropphycty": "BROWNS SUMMIT",
    "dropphyst": "NC",
    "dropphyzpp": 272149763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNS SUMMIT",
    "dropmalst": "NC",
    "dropmalzpp": 272149998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366561233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14897",
    "droptype": "D",
    "dropname": "BRUNSWICK",
    "dropdeladd": "1424 VINSON BLVD",
    "dropdelcty": "BRUNSWICK",
    "dropdelst": "NC",
    "dropdelzpp": 284248900,
    "dropphyadd": "1424 VINSON BLVD",
    "dropphycty": "BRUNSWICK",
    "dropphyst": "NC",
    "dropphyzpp": 284248900,
    "dropmaladd": "PO BOX 28424",
    "dropmalcty": "BRUNSWICK",
    "dropmalst": "NC",
    "dropmalzpp": 284249998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106425791,
    "dropsitcph": 9106425791,
    "dropfax": 9106422264
  },
  {
    "dcode": "D",
    "dropkey": "PY14899",
    "droptype": "D",
    "dropname": "BRYSON CITY",
    "dropdeladd": "130 SLOPE ST",
    "dropdelcty": "BRYSON CITY",
    "dropdelst": "NC",
    "dropdelzpp": 287136835,
    "dropphyadd": "130 SLOPE ST",
    "dropphycty": "BRYSON CITY",
    "dropphyst": "NC",
    "dropphyzpp": 287136835,
    "dropmaladd": "130 SLOPE ST",
    "dropmalcty": "BRYSON CITY",
    "dropmalst": "NC",
    "dropmalzpp": 287136835,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284883481,
    "dropsitcph": 8284883481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14905",
    "droptype": "D",
    "dropname": "BUIES CREEK",
    "dropdeladd": "254 MAIN ST",
    "dropdelcty": "BUIES CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 275069998,
    "dropphyadd": "254 MAIN ST",
    "dropphycty": "BUIES CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 275069998,
    "dropmaladd": "254 MAIN ST",
    "dropmalcty": "BUIES CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 275069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9108933104,
    "dropfax": 9108935282
  },
  {
    "dcode": "D",
    "dropkey": "PY14906",
    "droptype": "D",
    "dropname": "BULLOCK",
    "dropdeladd": "8682 US HIGHWAY 15",
    "dropdelcty": "BULLOCK",
    "dropdelst": "NC",
    "dropdelzpp": 275079998,
    "dropphyadd": "8682 US HIGHWAY 15",
    "dropphycty": "BULLOCK",
    "dropphyst": "NC",
    "dropphyzpp": 275079998,
    "dropmaladd": "8682 US HIGHWAY 15",
    "dropmalcty": "BULLOCK",
    "dropmalst": "NC",
    "dropmalzpp": 275079998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196933464,
    "dropfax": 9196937478
  },
  {
    "dcode": "D",
    "dropkey": "PY14907",
    "droptype": "D",
    "dropname": "BUNN",
    "dropdeladd": "313 MAIN ST",
    "dropdelcty": "BUNN",
    "dropdelst": "NC",
    "dropdelzpp": 275089998,
    "dropphyadd": "313 MAIN ST",
    "dropphycty": "BUNN",
    "dropphyst": "NC",
    "dropphyzpp": 275089998,
    "dropmaladd": "313 MAIN ST",
    "dropmalcty": "BUNN",
    "dropmalst": "NC",
    "dropmalzpp": 275089998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194965292,
    "dropfax": 9194960199
  },
  {
    "dcode": "D",
    "dropkey": "PY14908",
    "droptype": "D",
    "dropname": "BUNNLEVEL",
    "dropdeladd": "6904 US 401 S",
    "dropdelcty": "BUNNLEVEL",
    "dropdelst": "NC",
    "dropdelzpp": 283238470,
    "dropphyadd": "6904 US 401 S",
    "dropphycty": "BUNNLEVEL",
    "dropphyst": "NC",
    "dropphyzpp": 283238470,
    "dropmaladd": "PO BOX 28323",
    "dropmalcty": "BUNNLEVEL",
    "dropmalst": "NC",
    "dropmalzpp": 283239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108936305,
    "dropsitcph": 9108936305,
    "dropfax": 9108936305
  },
  {
    "dcode": "D",
    "dropkey": "PY14910",
    "droptype": "D",
    "dropname": "BURGAW",
    "dropdeladd": "100 E SATCHWELL ST",
    "dropdelcty": "BURGAW",
    "dropdelst": "NC",
    "dropdelzpp": 284255064,
    "dropphyadd": "100 E SATCHWELL ST",
    "dropphycty": "BURGAW",
    "dropphyst": "NC",
    "dropphyzpp": 284255064,
    "dropmaladd": "PO BOX 28425",
    "dropmalcty": "BURGAW",
    "dropmalst": "NC",
    "dropmalzpp": 284259998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102594590,
    "dropsitcph": 9102594590,
    "dropfax": 9102593111
  },
  {
    "dcode": "D",
    "dropkey": "PY14914",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "405 MAPLE AVE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 272155993,
    "dropphyadd": "405 MAPLE AVE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 272155993,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 272159998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362278309,
    "dropfax": 3362262993
  },
  {
    "dcode": "D",
    "dropkey": "PY14918",
    "droptype": "D",
    "dropname": "BURNSVILLE",
    "dropdeladd": "670 W MAIN ST",
    "dropdelcty": "BURNSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287142748,
    "dropphyadd": "670 W MAIN ST",
    "dropphycty": "BURNSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287142748,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287149998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286822326,
    "dropsitcph": 8286822326,
    "dropfax": 8286824010
  },
  {
    "dcode": "D",
    "dropkey": "PY14923",
    "droptype": "D",
    "dropname": "BUTNER",
    "dropdeladd": "331 CENTRAL AVE",
    "dropdelcty": "BUTNER",
    "dropdelst": "NC",
    "dropdelzpp": 275099998,
    "dropphyadd": "331 CENTRAL AVE",
    "dropphycty": "BUTNER",
    "dropphyst": "NC",
    "dropphyzpp": 275099998,
    "dropmaladd": "331 CENTRAL AVE",
    "dropmalcty": "BUTNER",
    "dropmalst": "NC",
    "dropmalzpp": 275099998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195754415,
    "dropfax": 9195754415
  },
  {
    "dcode": "D",
    "dropkey": "PY14925",
    "droptype": "D",
    "dropname": "BUXTON",
    "dropdeladd": "48042 NC 12 HWY",
    "dropdelcty": "BUXTON",
    "dropdelst": "NC",
    "dropdelzpp": 279209700,
    "dropphyadd": "48042 NC 12 HWY",
    "dropphycty": "BUXTON",
    "dropphyst": "NC",
    "dropphyzpp": 279209700,
    "dropmaladd": "48042 NC 12 HWY",
    "dropmalcty": "BUXTON",
    "dropmalst": "NC",
    "dropmalzpp": 279209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529955755,
    "dropfax": 2529954531
  },
  {
    "dcode": "D",
    "dropkey": "PY14933",
    "droptype": "D",
    "dropname": "CALYPSO",
    "dropdeladd": "108 W TRADE ST",
    "dropdelcty": "CALYPSO",
    "dropdelst": "NC",
    "dropdelzpp": 283258900,
    "dropphyadd": "108 W TRADE ST",
    "dropphycty": "CALYPSO",
    "dropphyst": "NC",
    "dropphyzpp": 283258900,
    "dropmaladd": "PO BOX 28325",
    "dropmalcty": "CALYPSO",
    "dropmalst": "NC",
    "dropmalzpp": 283259998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9196589394,
    "dropsitcph": 9196589394,
    "dropfax": 9196589394
  },
  {
    "dcode": "D",
    "dropkey": "PY14934",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "107 US HIGHWAY 158 E",
    "dropdelcty": "CAMDEN",
    "dropdelst": "NC",
    "dropdelzpp": 279219998,
    "dropphyadd": "107 US HIGHWAY 158 E",
    "dropphycty": "CAMDEN",
    "dropphyst": "NC",
    "dropphyzpp": 279219998,
    "dropmaladd": "107 US HIGHWAY 158 E",
    "dropmalcty": "CAMDEN",
    "dropmalst": "NC",
    "dropmalzpp": 279219998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522542107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14935",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "450 CARTHAGE ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "NC",
    "dropdelzpp": 283268904,
    "dropphyadd": "450 CARTHAGE ST",
    "dropphycty": "CAMERON",
    "dropphyst": "NC",
    "dropphyzpp": 283268904,
    "dropmaladd": "PO BOX 28326",
    "dropmalcty": "CAMERON",
    "dropmalst": "NC",
    "dropmalzpp": 283269998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102454211,
    "dropsitcph": 9102454211,
    "dropfax": 9102454509
  },
  {
    "dcode": "D",
    "dropkey": "PY14942",
    "droptype": "D",
    "dropname": "CANDLER",
    "dropdeladd": "99 RUTHERFORD RD",
    "dropdelcty": "CANDLER",
    "dropdelst": "NC",
    "dropdelzpp": 287158241,
    "dropphyadd": "99 RUTHERFORD RD",
    "dropphycty": "CANDLER",
    "dropphyst": "NC",
    "dropphyzpp": 287158241,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANDLER",
    "dropmalst": "NC",
    "dropmalzpp": 287159998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8586674230,
    "dropsitcph": 8286674230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14943",
    "droptype": "D",
    "dropname": "CANDOR",
    "dropdeladd": "405 N MAIN ST",
    "dropdelcty": "CANDOR",
    "dropdelst": "NC",
    "dropdelzpp": 272299034,
    "dropphyadd": "405 N MAIN ST",
    "dropphycty": "CANDOR",
    "dropphyst": "NC",
    "dropphyzpp": 272299034,
    "dropmaladd": "405 N MAIN ST",
    "dropmalcty": "CANDOR",
    "dropmalst": "NC",
    "dropmalzpp": 272299998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9109744791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14944",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "183 PARK ST",
    "dropdelcty": "CANTON",
    "dropdelst": "NC",
    "dropdelzpp": 287164230,
    "dropphyadd": "183 PARK ST",
    "dropphycty": "CANTON",
    "dropphyst": "NC",
    "dropphyzpp": 287164230,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANTON",
    "dropmalst": "NC",
    "dropmalzpp": 287169998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286482634,
    "dropsitcph": 8286482634,
    "dropfax": 8286463824
  },
  {
    "dcode": "D",
    "dropkey": "PY14952",
    "droptype": "D",
    "dropname": "CAROLEEN",
    "dropdeladd": "2201 HIGHWAY 221A",
    "dropdelcty": "CAROLEEN",
    "dropdelst": "NC",
    "dropdelzpp": 280199798,
    "dropphyadd": "2201 HIGHWAY 221A",
    "dropphycty": "CAROLEEN",
    "dropphyst": "NC",
    "dropphyzpp": 280199798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAROLEEN",
    "dropmalst": "NC",
    "dropmalzpp": 280199998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286576413,
    "dropsitcph": 8286576413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14954",
    "droptype": "D",
    "dropname": "CAROLINA BEACH",
    "dropdeladd": "1323 BRIDGE BARRIER RD",
    "dropdelcty": "CAROLINA BEACH",
    "dropdelst": "NC",
    "dropdelzpp": 284283931,
    "dropphyadd": "1323 BRIDGE BARRIER RD",
    "dropphycty": "CAROLINA BEACH",
    "dropphyst": "NC",
    "dropphyzpp": 284283931,
    "dropmaladd": "PO BOX 28428",
    "dropmalcty": "CAROLINA BEACH",
    "dropmalst": "NC",
    "dropmalzpp": 284289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104584468,
    "dropsitcph": 9104584468,
    "dropfax": 9104587429
  },
  {
    "dcode": "D",
    "dropkey": "PY14960",
    "droptype": "D",
    "dropname": "CARRBORO",
    "dropdeladd": "1500 W MAIN ST",
    "dropdelcty": "CARRBORO",
    "dropdelst": "NC",
    "dropdelzpp": 275105514,
    "dropphyadd": "1500 W MAIN ST",
    "dropphycty": "CARRBORO",
    "dropphyst": "NC",
    "dropphyzpp": 275105514,
    "dropmaladd": "1500 W MAIN ST",
    "dropmalcty": "CARRBORO",
    "dropmalst": "NC",
    "dropmalzpp": 275109901,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199684573,
    "dropfax": 9199323567
  },
  {
    "dcode": "D",
    "dropkey": "PY14961",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "105 S RAY ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "NC",
    "dropdelzpp": 283278794,
    "dropphyadd": "105 S RAY ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "NC",
    "dropphyzpp": 283278794,
    "dropmaladd": "PO BOX 28327",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "NC",
    "dropmalzpp": 283279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9109472377,
    "dropsitcph": 9109472377,
    "dropfax": 9109473425
  },
  {
    "dcode": "D",
    "dropkey": "PY14963",
    "droptype": "D",
    "dropname": "CARY",
    "dropdeladd": "150 WRENN DR",
    "dropdelcty": "CARY",
    "dropdelst": "NC",
    "dropdelzpp": 275119998,
    "dropphyadd": "150 WRENN DR",
    "dropphycty": "CARY",
    "dropphyst": "NC",
    "dropphyzpp": 275119998,
    "dropmaladd": "150 WRENN DR",
    "dropmalcty": "CARY",
    "dropmalst": "NC",
    "dropmalzpp": 275119998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196741001,
    "dropfax": 9194673872
  },
  {
    "dcode": "D",
    "dropkey": "PY14964",
    "droptype": "D",
    "dropname": "CASAR",
    "dropdeladd": "5801 CASAR RD",
    "dropdelcty": "CASAR",
    "dropdelst": "NC",
    "dropdelzpp": 280208700,
    "dropphyadd": "5801 CASAR RD",
    "dropphycty": "CASAR",
    "dropphyst": "NC",
    "dropphyzpp": 280208700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASAR",
    "dropmalst": "NC",
    "dropmalzpp": 280209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045389471,
    "dropsitcph": 7045389471,
    "dropfax": 7045381639
  },
  {
    "dcode": "D",
    "dropkey": "PY14965",
    "droptype": "D",
    "dropname": "CASHIERS",
    "dropdeladd": "230 FRANK ALLEN RD",
    "dropdelcty": "CASHIERS",
    "dropdelst": "NC",
    "dropdelzpp": 287179561,
    "dropphyadd": "230 FRANK ALLEN RD",
    "dropphycty": "CASHIERS",
    "dropphyst": "NC",
    "dropphyzpp": 287179561,
    "dropmaladd": "230 FRANK ALLEN RD",
    "dropmalcty": "CASHIERS",
    "dropmalst": "NC",
    "dropmalzpp": 287179561,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287432565,
    "dropsitcph": 8287432565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14966",
    "droptype": "D",
    "dropname": "CASTALIA",
    "dropdeladd": "9512 MAIN ST",
    "dropdelcty": "CASTALIA",
    "dropdelst": "NC",
    "dropdelzpp": 278169560,
    "dropphyadd": "9512 MAIN ST",
    "dropphycty": "CASTALIA",
    "dropphyst": "NC",
    "dropphyzpp": 278169560,
    "dropmaladd": "9512 MAIN ST",
    "dropmalcty": "CASTALIA",
    "dropmalst": "NC",
    "dropmalzpp": 278169998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524593439,
    "dropfax": 2524593439
  },
  {
    "dcode": "D",
    "dropkey": "PY14967",
    "droptype": "D",
    "dropname": "CASTLE HAYNE",
    "dropdeladd": "4024 HOLLY SHELTER RD",
    "dropdelcty": "CASTLE HAYNE",
    "dropdelst": "NC",
    "dropdelzpp": 284295536,
    "dropphyadd": "4024 HOLLY SHELTER RD",
    "dropphycty": "CASTLE HAYNE",
    "dropphyst": "NC",
    "dropphyzpp": 284295536,
    "dropmaladd": "PO BOX 28429",
    "dropmalcty": "CASTLE HAYNE",
    "dropmalst": "NC",
    "dropmalzpp": 284299998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106752438,
    "dropsitcph": 9106752438,
    "dropfax": 9106752901
  },
  {
    "dcode": "D",
    "dropkey": "PY14970",
    "droptype": "D",
    "dropname": "CATAWBA",
    "dropdeladd": "100 E CENTRAL AVE",
    "dropdelcty": "CATAWBA",
    "dropdelst": "NC",
    "dropdelzpp": 286099518,
    "dropphyadd": "100 E CENTRAL AVE",
    "dropphycty": "CATAWBA",
    "dropphyst": "NC",
    "dropphyzpp": 286099518,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CATAWBA",
    "dropmalst": "NC",
    "dropmalzpp": 286099998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282412867,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14972",
    "droptype": "D",
    "dropname": "CEDAR FALLS",
    "dropdeladd": "370 LOFLIN POND RD",
    "dropdelcty": "CEDAR FALLS",
    "dropdelst": "NC",
    "dropdelzpp": 272309996,
    "dropphyadd": "370 LOFLIN POND RD",
    "dropphycty": "CEDAR FALLS",
    "dropphyst": "NC",
    "dropphyzpp": 272309996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR FALLS",
    "dropmalst": "NC",
    "dropmalzpp": 272309998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366295680,
    "dropfax": 3366290281
  },
  {
    "dcode": "D",
    "dropkey": "PY14974",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "5206 EFLAND CEDAR GROVE RD",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 272319400,
    "dropphyadd": "5206 EFLAND CEDAR GROVE RD",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 272319400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 272319998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9197327059,
    "dropfax": 9197327059
  },
  {
    "dcode": "D",
    "dropkey": "PY14977",
    "droptype": "D",
    "dropname": "CEDAR ISLAND",
    "dropdeladd": "3553 CEDAR ISLAND RD",
    "dropdelcty": "CEDAR ISLAND",
    "dropdelst": "NC",
    "dropdelzpp": 285209632,
    "dropphyadd": "3553 CEDAR ISLAND RD",
    "dropphycty": "CEDAR ISLAND",
    "dropphyst": "NC",
    "dropphyzpp": 285209632,
    "dropmaladd": "PO BOX 28520",
    "dropmalcty": "CEDAR ISLAND",
    "dropmalst": "NC",
    "dropmalzpp": 285209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522252131,
    "dropsitcph": 2522252131,
    "dropfax": 2522250915
  },
  {
    "dcode": "D",
    "dropkey": "PY14978",
    "droptype": "D",
    "dropname": "CEDAR MOUNTAIN",
    "dropdeladd": "9515 GREENVILLE HWY",
    "dropdelcty": "CEDAR MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 287188023,
    "dropphyadd": "9515 GREENVILLE HWY",
    "dropphycty": "CEDAR MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 287188023,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 287189998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8588852501,
    "dropsitcph": 8288852501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14987",
    "droptype": "D",
    "dropname": "CERRO GORDO",
    "dropdeladd": "76 PINE ST",
    "dropdelcty": "CERRO GORDO",
    "dropdelst": "NC",
    "dropdelzpp": 284309268,
    "dropphyadd": "76 PINE ST",
    "dropphycty": "CERRO GORDO",
    "dropphyst": "NC",
    "dropphyzpp": 284309268,
    "dropmaladd": "PO BOX 28430",
    "dropmalcty": "CERRO GORDO",
    "dropmalst": "NC",
    "dropmalzpp": 284309998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106544057,
    "dropsitcph": 9106544057,
    "dropfax": 9106544057
  },
  {
    "dcode": "D",
    "dropkey": "PY14988",
    "droptype": "D",
    "dropname": "CHADBOURN",
    "dropdeladd": "601 N BROWN ST",
    "dropdelcty": "CHADBOURN",
    "dropdelst": "NC",
    "dropdelzpp": 284311305,
    "dropphyadd": "601 N BROWN ST",
    "dropphycty": "CHADBOURN",
    "dropphyst": "NC",
    "dropphyzpp": 284311305,
    "dropmaladd": "PO BOX 28431",
    "dropmalcty": "CHADBOURN",
    "dropmalst": "NC",
    "dropmalzpp": 284319998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106544475,
    "dropsitcph": 9106544475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY14990",
    "droptype": "D",
    "dropname": "CHAPEL HILL",
    "dropdeladd": "125 S ESTES DR",
    "dropdelcty": "CHAPEL HILL",
    "dropdelst": "NC",
    "dropdelzpp": 275149998,
    "dropphyadd": "125 S ESTES DR",
    "dropphycty": "CHAPEL HILL",
    "dropphyst": "NC",
    "dropphyzpp": 275149998,
    "dropmaladd": "125 S ESTES DR",
    "dropmalcty": "CHAPEL HILL",
    "dropmalst": "NC",
    "dropmalzpp": 275149998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199299892,
    "dropfax": 9199423433
  },
  {
    "dcode": "D",
    "dropkey": "PY14993",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "201 N MCDOWELL ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282049798,
    "dropphyadd": "201 N MCDOWELL ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282049798,
    "dropmaladd": "2901 SCOTT FUTRELL DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043332542,
    "dropsitcph": 7043332542,
    "dropfax": 7043348938
  },
  {
    "dcode": "D",
    "dropkey": "PY14996",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "671 TSALI BLVD",
    "dropdelcty": "CHEROKEE",
    "dropdelst": "NC",
    "dropdelzpp": 287199213,
    "dropphyadd": "671 TSALI BLVD",
    "dropphycty": "CHEROKEE",
    "dropphyst": "NC",
    "dropphyzpp": 287199213,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHEROKEE",
    "dropmalst": "NC",
    "dropmalzpp": 287199998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284913891,
    "dropsitcph": 8284973891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15003",
    "droptype": "D",
    "dropname": "CHERRYVILLE",
    "dropdeladd": "107 N MULBERRY ST",
    "dropdelcty": "CHERRYVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 280212853,
    "dropphyadd": "107 N MULBERRY ST",
    "dropphycty": "CHERRYVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 280212853,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHERRYVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 280219998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044356648,
    "dropsitcph": 7044356648,
    "dropfax": 7044356536
  },
  {
    "dcode": "D",
    "dropkey": "PY15010",
    "droptype": "D",
    "dropname": "CHIMNEY ROCK",
    "dropdeladd": "366 MAIN ST",
    "dropdelcty": "CHIMNEY ROCK",
    "dropdelst": "NC",
    "dropdelzpp": 287209700,
    "dropphyadd": "366 MAIN ST",
    "dropphycty": "CHIMNEY ROCK",
    "dropphyst": "NC",
    "dropphyzpp": 287209700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIMNEY ROCK",
    "dropmalst": "NC",
    "dropmalzpp": 287209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286254847,
    "dropsitcph": 8286254847,
    "dropfax": 8286254847
  },
  {
    "dcode": "D",
    "dropkey": "PY15011",
    "droptype": "D",
    "dropname": "CHINA GROVE",
    "dropdeladd": "200 S BOSTIAN ST",
    "dropdelcty": "CHINA GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 280232438,
    "dropphyadd": "200 S BOSTIAN ST",
    "dropphycty": "CHINA GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 280232438,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHINA GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 280239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048575310,
    "dropsitcph": 7048575310,
    "dropfax": 7048560673
  },
  {
    "dcode": "D",
    "dropkey": "PY15013",
    "droptype": "D",
    "dropname": "CHINQUAPIN",
    "dropdeladd": "2758 S NC 41 50 HWY",
    "dropdelcty": "CHINQUAPIN",
    "dropdelst": "NC",
    "dropdelzpp": 285218502,
    "dropphyadd": "2758 S NC 41 50 HWY",
    "dropphycty": "CHINQUAPIN",
    "dropphyst": "NC",
    "dropphyzpp": 285218502,
    "dropmaladd": "PO BOX 28521",
    "dropmalcty": "CHINQUAPIN",
    "dropmalst": "NC",
    "dropmalzpp": 285219998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102852795,
    "dropsitcph": 9102852795,
    "dropfax": 9102854026
  },
  {
    "dcode": "D",
    "dropkey": "PY15014",
    "droptype": "D",
    "dropname": "CHOCOWINITY",
    "dropdeladd": "100 PATRICK LN",
    "dropdelcty": "CHOCOWINITY",
    "dropdelst": "NC",
    "dropdelzpp": 278179998,
    "dropphyadd": "100 PATRICK LN",
    "dropphycty": "CHOCOWINITY",
    "dropphyst": "NC",
    "dropphyzpp": 278179998,
    "dropmaladd": "100 PATRICK LN",
    "dropmalcty": "CHOCOWINITY",
    "dropmalst": "NC",
    "dropmalzpp": 278179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529461559,
    "dropfax": 2529461559
  },
  {
    "dcode": "D",
    "dropkey": "PY15017",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "3327 E MAIN ST",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "NC",
    "dropdelzpp": 286108699,
    "dropphyadd": "3327 E MAIN ST",
    "dropphycty": "CLAREMONT",
    "dropphyst": "NC",
    "dropphyzpp": 286108699,
    "dropmaladd": "3327 E MAIN ST",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "NC",
    "dropmalzpp": 286109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284599698,
    "dropfax": 8284590968
  },
  {
    "dcode": "D",
    "dropkey": "PY15018",
    "droptype": "D",
    "dropname": "CLARENDON",
    "dropdeladd": "6337 TEN MILE RD",
    "dropdelcty": "CLARENDON",
    "dropdelst": "NC",
    "dropdelzpp": 284326000,
    "dropphyadd": "6337 TEN MILE RD",
    "dropphycty": "CLARENDON",
    "dropphyst": "NC",
    "dropphyzpp": 284326000,
    "dropmaladd": "PO BOX 28432",
    "dropmalcty": "CLARENDON",
    "dropmalst": "NC",
    "dropmalzpp": 284329998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106533057,
    "dropsitcph": 9106533057,
    "dropfax": 9106533057
  },
  {
    "dcode": "D",
    "dropkey": "PY15019",
    "droptype": "D",
    "dropname": "CLARKTON",
    "dropdeladd": "31 E GREEN ST",
    "dropdelcty": "CLARKTON",
    "dropdelst": "NC",
    "dropdelzpp": 284332300,
    "dropphyadd": "31 E GREEN ST",
    "dropphycty": "CLARKTON",
    "dropphyst": "NC",
    "dropphyzpp": 284332300,
    "dropmaladd": "PO BOX 28433",
    "dropmalcty": "CLARKTON",
    "dropmalst": "NC",
    "dropmalzpp": 284339998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106472351,
    "dropsitcph": 9106472351,
    "dropfax": 9106472351
  },
  {
    "dcode": "D",
    "dropkey": "PY15020",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "604 E FRONT ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "NC",
    "dropdelzpp": 275209998,
    "dropphyadd": "604 E FRONT ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "NC",
    "dropphyzpp": 275209998,
    "dropmaladd": "604 E FRONT ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NC",
    "dropmalzpp": 275202058,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195531867,
    "dropfax": 9195204261
  },
  {
    "dcode": "D",
    "dropkey": "PY15021",
    "droptype": "D",
    "dropname": "CLEMMONS",
    "dropdeladd": "3630 CLEMMONS RD",
    "dropdelcty": "CLEMMONS",
    "dropdelst": "NC",
    "dropdelzpp": 270129998,
    "dropphyadd": "3630 CLEMMONS RD",
    "dropphycty": "CLEMMONS",
    "dropphyst": "NC",
    "dropphyzpp": 270129998,
    "dropmaladd": "3630 CLEMMONS RD",
    "dropmalcty": "CLEMMONS",
    "dropmalst": "NC",
    "dropmalzpp": 270129998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367666671,
    "dropfax": 3367666926
  },
  {
    "dcode": "D",
    "dropkey": "PY15022",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "NC",
    "dropdelzpp": 270139998,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "NC",
    "dropphyzpp": 270139998,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "NC",
    "dropmalzpp": 270139998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7042789192,
    "dropfax": 7042789192
  },
  {
    "dcode": "D",
    "dropkey": "PY15027",
    "droptype": "D",
    "dropname": "CLIFFSIDE",
    "dropdeladd": "244 N MAIN ST",
    "dropdelcty": "CLIFFSIDE",
    "dropdelst": "NC",
    "dropdelzpp": 280249798,
    "dropphyadd": "244 N MAIN ST",
    "dropphycty": "CLIFFSIDE",
    "dropphyst": "NC",
    "dropphyzpp": 280249798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIFFSIDE",
    "dropmalst": "NC",
    "dropmalzpp": 280249998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286575876,
    "dropsitcph": 8286575876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15029",
    "droptype": "D",
    "dropname": "CLIMAX",
    "dropdeladd": "1319 NC HIGHWAY 62 E",
    "dropdelcty": "CLIMAX",
    "dropdelst": "NC",
    "dropdelzpp": 272339153,
    "dropphyadd": "1319 NC HIGHWAY 62 E",
    "dropphycty": "CLIMAX",
    "dropphyst": "NC",
    "dropphyzpp": 272339153,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIMAX",
    "dropmalst": "NC",
    "dropmalzpp": 272339998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366747356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15032",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "1011 SUNSET AVE",
    "dropdelcty": "CLINTON",
    "dropdelst": "NC",
    "dropdelzpp": 283283817,
    "dropphyadd": "1011 SUNSET AVE",
    "dropphycty": "CLINTON",
    "dropphyst": "NC",
    "dropphyzpp": 283283817,
    "dropmaladd": "PO BOX 28328",
    "dropmalcty": "CLINTON",
    "dropmalst": "NC",
    "dropmalzpp": 283289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105922547,
    "dropsitcph": 9105922547,
    "dropfax": 9105921330
  },
  {
    "dcode": "D",
    "dropkey": "PY15033",
    "droptype": "D",
    "dropname": "CLYDE",
    "dropdeladd": "8639 CAROLINA BLVD",
    "dropdelcty": "CLYDE",
    "dropdelst": "NC",
    "dropdelzpp": 287217460,
    "dropphyadd": "8639 CAROLINA BLVD",
    "dropphycty": "CLYDE",
    "dropphyst": "NC",
    "dropphyzpp": 287217460,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLYDE",
    "dropmalst": "NC",
    "dropmalzpp": 287219998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286272831,
    "dropsitcph": 8286272831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15035",
    "droptype": "D",
    "dropname": "COATS",
    "dropdeladd": "43 W MAIN ST",
    "dropdelcty": "COATS",
    "dropdelst": "NC",
    "dropdelzpp": 275219998,
    "dropphyadd": "43 W MAIN ST",
    "dropphycty": "COATS",
    "dropphyst": "NC",
    "dropphyzpp": 275219998,
    "dropmaladd": "43 W MAIN ST",
    "dropmalcty": "COATS",
    "dropmalst": "NC",
    "dropmalzpp": 275219998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9108976497,
    "dropfax": 9108975383
  },
  {
    "dcode": "D",
    "dropkey": "PY15036",
    "droptype": "D",
    "dropname": "COFIELD",
    "dropdeladd": "1240 AHOSKIE COFIELD RD",
    "dropdelcty": "COFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 279229542,
    "dropphyadd": "1240 AHOSKIE COFIELD RD",
    "dropphycty": "COFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 279229542,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 279229998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523582336,
    "dropfax": 2523580483
  },
  {
    "dcode": "D",
    "dropkey": "PY15037",
    "droptype": "D",
    "dropname": "COINJOCK",
    "dropdeladd": "183 WORTH GUARD RD",
    "dropdelcty": "COINJOCK",
    "dropdelst": "NC",
    "dropdelzpp": 279239998,
    "dropphyadd": "183 WORTH GUARD RD",
    "dropphycty": "COINJOCK",
    "dropphyst": "NC",
    "dropphyzpp": 279239998,
    "dropmaladd": "183 WORTH GUARD RD",
    "dropmalcty": "COINJOCK",
    "dropmalst": "NC",
    "dropmalzpp": 279239998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524532055,
    "dropfax": 2524536816
  },
  {
    "dcode": "D",
    "dropkey": "PY15039",
    "droptype": "D",
    "dropname": "COLERAIN",
    "dropdeladd": "107 W RIVER ST",
    "dropdelcty": "COLERAIN",
    "dropdelst": "NC",
    "dropdelzpp": 279249006,
    "dropphyadd": "107 W RIVER ST",
    "dropphycty": "COLERAIN",
    "dropphyst": "NC",
    "dropphyzpp": 279249006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLERAIN",
    "dropmalst": "NC",
    "dropmalzpp": 279249998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523562696,
    "dropfax": 2523562696
  },
  {
    "dcode": "D",
    "dropkey": "PY15041",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "9052 W MARKET ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "NC",
    "dropdelzpp": 272359622,
    "dropphyadd": "9052 W MARKET ST",
    "dropphycty": "COLFAX",
    "dropphyst": "NC",
    "dropphyzpp": 272359622,
    "dropmaladd": "9052 W MARKET ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "NC",
    "dropmalzpp": 272359998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369937568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15044",
    "droptype": "D",
    "dropname": "COLLETTSVILLE",
    "dropdeladd": "4323 COLLETTSVILLE RD",
    "dropdelcty": "COLLETTSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286119104,
    "dropphyadd": "4323 COLLETTSVILLE RD",
    "dropphycty": "COLLETTSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286119104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLETTSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286119998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287548972,
    "dropfax": 8287541832
  },
  {
    "dcode": "D",
    "dropkey": "PY15049",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "114 S BROAD ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "NC",
    "dropdelzpp": 279259998,
    "dropphyadd": "114 S BROAD ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "NC",
    "dropphyzpp": 279259998,
    "dropmaladd": "114 S BROAD ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "NC",
    "dropmalzpp": 279259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527964081,
    "dropfax": 2527964081
  },
  {
    "dcode": "D",
    "dropkey": "PY15050",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "126 WARD ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "NC",
    "dropdelzpp": 287229401,
    "dropphyadd": "126 WARD ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "NC",
    "dropphyzpp": 287229401,
    "dropmaladd": "PO BOX 9999",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "NC",
    "dropmalzpp": 287229998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288948680,
    "dropsitcph": 8288948680,
    "dropfax": 8288948680
  },
  {
    "dcode": "D",
    "dropkey": "PY15052",
    "droptype": "D",
    "dropname": "COMFORT",
    "dropdeladd": "4262 HIGHWAY 41 W",
    "dropdelcty": "COMFORT",
    "dropdelst": "NC",
    "dropdelzpp": 285225001,
    "dropphyadd": "4262 HIGHWAY 41 W",
    "dropphycty": "COMFORT",
    "dropphyst": "NC",
    "dropphyzpp": 285225001,
    "dropmaladd": "PO BOX 28522",
    "dropmalcty": "COMFORT",
    "dropmalst": "NC",
    "dropmalzpp": 285229998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103244960,
    "dropsitcph": 9103244960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15053",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "1226 US HIGHWAY 258 N",
    "dropdelcty": "COMO",
    "dropdelst": "NC",
    "dropdelzpp": 278189998,
    "dropphyadd": "1226 US HIGHWAY 258 N",
    "dropphycty": "COMO",
    "dropphyst": "NC",
    "dropphyzpp": 278189998,
    "dropmaladd": "1226 US HIGHWAY 258 N",
    "dropmalcty": "COMO",
    "dropmalst": "NC",
    "dropmalzpp": 278189998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523983420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15054",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "66 MCCACHERN BLVD SE",
    "dropdelcty": "CONCORD",
    "dropdelst": "NC",
    "dropdelzpp": 280259998,
    "dropphyadd": "66 MCCACHERN BLVD SE",
    "dropphycty": "CONCORD",
    "dropphyst": "NC",
    "dropphyzpp": 280259998,
    "dropmaladd": "66 MCCACHERN BLVD SE",
    "dropmalcty": "CONCORD",
    "dropmalst": "NC",
    "dropmalzpp": 280259998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042623368,
    "dropsitcph": 7042623368,
    "dropfax": 7047920260
  },
  {
    "dcode": "D",
    "dropkey": "PY15055",
    "droptype": "D",
    "dropname": "CONETOE",
    "dropdeladd": "206 W CHURCH ST",
    "dropdelcty": "CONETOE",
    "dropdelst": "NC",
    "dropdelzpp": 278199700,
    "dropphyadd": "206 W CHURCH ST",
    "dropphycty": "CONETOE",
    "dropphyst": "NC",
    "dropphyzpp": 278199700,
    "dropmaladd": "206 W CHURCH ST",
    "dropmalcty": "CONETOE",
    "dropmalst": "NC",
    "dropmalzpp": 278199998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528231587,
    "dropfax": 2528231587
  },
  {
    "dcode": "D",
    "dropkey": "PY15057",
    "droptype": "D",
    "dropname": "CONNELLY SPRINGS",
    "dropdeladd": "1015 US HIGHWAY 70",
    "dropdelcty": "CONNELLY SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 286127607,
    "dropphyadd": "1015 US HIGHWAY 70",
    "dropphycty": "CONNELLY SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 286127607,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONNELLY SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 286129998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8288740784,
    "dropfax": 8288740449
  },
  {
    "dcode": "D",
    "dropkey": "PY15059",
    "droptype": "D",
    "dropname": "CONOVER",
    "dropdeladd": "201 1ST ST E",
    "dropdelcty": "CONOVER",
    "dropdelst": "NC",
    "dropdelzpp": 286132130,
    "dropphyadd": "201 1ST ST E",
    "dropphycty": "CONOVER",
    "dropphyst": "NC",
    "dropphyzpp": 286132130,
    "dropmaladd": "201 1ST ST E",
    "dropmalcty": "CONOVER",
    "dropmalst": "NC",
    "dropmalzpp": 286132130,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284642073,
    "dropfax": 8284643231
  },
  {
    "dcode": "D",
    "dropkey": "PY15060",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "205 S CHURCH ST",
    "dropdelcty": "CONWAY",
    "dropdelst": "NC",
    "dropdelzpp": 278209509,
    "dropphyadd": "205 S CHURCH ST",
    "dropphycty": "CONWAY",
    "dropphyst": "NC",
    "dropphyzpp": 278209509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONWAY",
    "dropmalst": "NC",
    "dropmalzpp": 278209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525851571,
    "dropfax": 2525850997
  },
  {
    "dcode": "D",
    "dropkey": "PY15062",
    "droptype": "D",
    "dropname": "COOLEEMEE",
    "dropdeladd": "7814 NC HWY 801 S",
    "dropdelcty": "COOLEEMEE",
    "dropdelst": "NC",
    "dropdelzpp": 270149800,
    "dropphyadd": "7814 NC HWY 801 S",
    "dropphycty": "COOLEEMEE",
    "dropphyst": "NC",
    "dropphyzpp": 270149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOLEEMEE",
    "dropmalst": "NC",
    "dropmalzpp": 270149998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366191857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15064",
    "droptype": "D",
    "dropname": "CORAPEAKE",
    "dropdeladd": "1398 NC HIGHWAY 32 N",
    "dropdelcty": "CORAPEAKE",
    "dropdelst": "NC",
    "dropdelzpp": 279269998,
    "dropphyadd": "1398 NC HIGHWAY 32 N",
    "dropphycty": "CORAPEAKE",
    "dropphyst": "NC",
    "dropphyzpp": 279269998,
    "dropmaladd": "1398 NC HIGHWAY 32 N",
    "dropmalcty": "CORAPEAKE",
    "dropmalst": "NC",
    "dropmalzpp": 279269998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524658104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15065",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "232 LEDBETTER ST",
    "dropdelcty": "CORDOVA",
    "dropdelst": "NC",
    "dropdelzpp": 283308900,
    "dropphyadd": "232 LEDBETTER ST",
    "dropphycty": "CORDOVA",
    "dropphyst": "NC",
    "dropphyzpp": 283308900,
    "dropmaladd": "PO BOX 28330",
    "dropmalcty": "CORDOVA",
    "dropmalst": "NC",
    "dropmalzpp": 283309998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108955788,
    "dropsitcph": 9108955788,
    "dropfax": 9108955788
  },
  {
    "dcode": "D",
    "dropkey": "PY15067",
    "droptype": "D",
    "dropname": "CORNELIUS",
    "dropdeladd": "20311 CHARTWELL CENTER DR",
    "dropdelcty": "CORNELIUS",
    "dropdelst": "NC",
    "dropdelzpp": 280315271,
    "dropphyadd": "20311 CHARTWELL CENTER DR",
    "dropphycty": "CORNELIUS",
    "dropphyst": "NC",
    "dropphyzpp": 280315271,
    "dropmaladd": "20311 CHARTWELL CENTER DR",
    "dropmalcty": "CORNELIUS",
    "dropmalst": "NC",
    "dropmalzpp": 280315271,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048969800,
    "dropsitcph": 7048969800,
    "dropfax": 7048928422
  },
  {
    "dcode": "D",
    "dropkey": "PY15070",
    "droptype": "D",
    "dropname": "COROLLA",
    "dropdeladd": "1150 OCEAN TRL",
    "dropdelcty": "COROLLA",
    "dropdelst": "NC",
    "dropdelzpp": 279279703,
    "dropphyadd": "1150 OCEAN TRL",
    "dropphycty": "COROLLA",
    "dropphyst": "NC",
    "dropphyzpp": 279279703,
    "dropmaladd": "1150 OCEAN TRL",
    "dropmalcty": "COROLLA",
    "dropmalst": "NC",
    "dropmalzpp": 279279998,
    "dropsitphn": 3369319444,
    "dropsitlph": 2524205175,
    "dropsitcph": 2524532552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15075",
    "droptype": "D",
    "dropname": "COUNCIL",
    "dropdeladd": "11740 NC HIGHWAY 211 E",
    "dropdelcty": "COUNCIL",
    "dropdelst": "NC",
    "dropdelzpp": 284349162,
    "dropphyadd": "11740 NC HIGHWAY 211 E",
    "dropphycty": "COUNCIL",
    "dropphyst": "NC",
    "dropphyzpp": 284349162,
    "dropmaladd": "PO BOX 28434",
    "dropmalcty": "COUNCIL",
    "dropmalst": "NC",
    "dropmalzpp": 284349998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106454683,
    "dropsitcph": 9106454683,
    "dropfax": 9106454123
  },
  {
    "dcode": "D",
    "dropkey": "PY15079",
    "droptype": "D",
    "dropname": "COVE CITY",
    "dropdeladd": "201 E SUNSET BLVD",
    "dropdelcty": "COVE CITY",
    "dropdelst": "NC",
    "dropdelzpp": 285239603,
    "dropphyadd": "201 E SUNSET BLVD",
    "dropphycty": "COVE CITY",
    "dropphyst": "NC",
    "dropphyzpp": 285239603,
    "dropmaladd": "PO BOX 28523",
    "dropmalcty": "COVE CITY",
    "dropmalst": "NC",
    "dropmalzpp": 285239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2526330783,
    "dropsitcph": 2526330783,
    "dropfax": 2526353216
  },
  {
    "dcode": "D",
    "dropkey": "PY15088",
    "droptype": "D",
    "dropname": "CRAMERTON",
    "dropdeladd": "111 CENTER ST",
    "dropdelcty": "CRAMERTON",
    "dropdelst": "NC",
    "dropdelzpp": 280321400,
    "dropphyadd": "111 CENTER ST",
    "dropphycty": "CRAMERTON",
    "dropphyst": "NC",
    "dropphyzpp": 280321400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRAMERTON",
    "dropmalst": "NC",
    "dropmalzpp": 280329998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048247411,
    "dropsitcph": 7048247411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15091",
    "droptype": "D",
    "dropname": "CREEDMOOR",
    "dropdeladd": "2157 WILTON AVE",
    "dropdelcty": "CREEDMOOR",
    "dropdelst": "NC",
    "dropdelzpp": 275229998,
    "dropphyadd": "2157 WILTON AVE",
    "dropphycty": "CREEDMOOR",
    "dropphyst": "NC",
    "dropphyzpp": 275229998,
    "dropmaladd": "2157 WILTON AVE",
    "dropmalcty": "CREEDMOOR",
    "dropmalst": "NC",
    "dropmalzpp": 275229998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195283056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15093",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "636 THREE TOP RD",
    "dropdelcty": "CRESTON",
    "dropdelst": "NC",
    "dropdelzpp": 286159997,
    "dropphyadd": "636 THREE TOP RD",
    "dropphycty": "CRESTON",
    "dropphyst": "NC",
    "dropphyzpp": 286159997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESTON",
    "dropmalst": "NC",
    "dropmalzpp": 286159998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363852481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15094",
    "droptype": "D",
    "dropname": "CRESWELL",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "CRESWELL",
    "dropdelst": "NC",
    "dropdelzpp": 279289998,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "CRESWELL",
    "dropphyst": "NC",
    "dropphyzpp": 279289998,
    "dropmaladd": "201 W MAIN ST",
    "dropmalcty": "CRESWELL",
    "dropmalst": "NC",
    "dropmalzpp": 279289998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527974610,
    "dropfax": 2527973769
  },
  {
    "dcode": "D",
    "dropkey": "PY15098",
    "droptype": "D",
    "dropname": "CROSSNORE",
    "dropdeladd": "3 FOUNTAIN CIR",
    "dropdelcty": "CROSSNORE",
    "dropdelst": "NC",
    "dropdelzpp": 286169800,
    "dropphyadd": "3 FOUNTAIN CIR",
    "dropphycty": "CROSSNORE",
    "dropphyst": "NC",
    "dropphyzpp": 286169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSSNORE",
    "dropmalst": "NC",
    "dropmalzpp": 286169998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287335702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15099",
    "droptype": "D",
    "dropname": "CROUSE",
    "dropdeladd": "2715 W OLD NC 150 HWY",
    "dropdelcty": "CROUSE",
    "dropdelst": "NC",
    "dropdelzpp": 280334506,
    "dropphyadd": "2715 W OLD NC 150 HWY",
    "dropphycty": "CROUSE",
    "dropphyst": "NC",
    "dropphyzpp": 280334506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROUSE",
    "dropmalst": "NC",
    "dropmalzpp": 280339998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047358724,
    "dropsitcph": 7047358724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15101",
    "droptype": "D",
    "dropname": "CRUMPLER",
    "dropdeladd": "9247 OLD HIGHWAY 16",
    "dropdelcty": "CRUMPLER",
    "dropdelst": "NC",
    "dropdelzpp": 286179757,
    "dropphyadd": "9247 OLD HIGHWAY 16",
    "dropphycty": "CRUMPLER",
    "dropphyst": "NC",
    "dropphyzpp": 286179757,
    "dropmaladd": "9247 OLD HIGHWAY 16",
    "dropmalcty": "CRUMPLER",
    "dropmalst": "NC",
    "dropmalzpp": 286179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369823345,
    "dropfax": 3369824785
  },
  {
    "dcode": "D",
    "dropkey": "PY15102",
    "droptype": "D",
    "dropname": "CULBERSON",
    "dropdeladd": "2400 NC HWY 60",
    "dropdelcty": "CULBERSON",
    "dropdelst": "NC",
    "dropdelzpp": 289038001,
    "dropphyadd": "2400 NC HWY 60",
    "dropphycty": "CULBERSON",
    "dropphyst": "NC",
    "dropphyzpp": 289038001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CULBERSON",
    "dropmalst": "NC",
    "dropmalzpp": 289039998,
    "dropsitphn": 8283934581,
    "dropsitlph": 8286445131,
    "dropsitcph": 8286445131,
    "dropfax": 8286445131
  },
  {
    "dcode": "D",
    "dropkey": "PY15104",
    "droptype": "D",
    "dropname": "CULLOWHEE",
    "dropdeladd": "4710 LITTLE SAVANNAH RD",
    "dropdelcty": "CULLOWHEE",
    "dropdelst": "NC",
    "dropdelzpp": 287235200,
    "dropphyadd": "4710 LITTLE SAVANNAH RD",
    "dropphycty": "CULLOWHEE",
    "dropphyst": "NC",
    "dropphyzpp": 287235200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CULLOWHEE",
    "dropmalst": "NC",
    "dropmalzpp": 287239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282939448,
    "dropsitcph": 8282939448,
    "dropfax": 8282933381
  },
  {
    "dcode": "D",
    "dropkey": "PY15105",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "2304 WINGATE RD",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "NC",
    "dropdelzpp": 283318916,
    "dropphyadd": "2304 WINGATE RD",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "NC",
    "dropphyzpp": 283318916,
    "dropmaladd": "PO BOX 28331",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "NC",
    "dropmalzpp": 283319998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104250325,
    "dropsitcph": 9104250325,
    "dropfax": 9104234865
  },
  {
    "dcode": "D",
    "dropkey": "PY15108",
    "droptype": "D",
    "dropname": "CURRIE",
    "dropdeladd": "28480 NC HWY 210",
    "dropdelcty": "CURRIE",
    "dropdelst": "NC",
    "dropdelzpp": 284359364,
    "dropphyadd": "28480 NC HWY 210",
    "dropphycty": "CURRIE",
    "dropphyst": "NC",
    "dropphyzpp": 284359364,
    "dropmaladd": "PO BOX 28435",
    "dropmalcty": "CURRIE",
    "dropmalst": "NC",
    "dropmalzpp": 284359998,
    "dropsitphn": 7043834581,
    "dropsitlph": 9102837410,
    "dropsitcph": 9102837410,
    "dropfax": 9102837410
  },
  {
    "dcode": "D",
    "dropkey": "PY15112",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "3151 DALLAS HGH SHLS HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "NC",
    "dropdelzpp": 280341307,
    "dropphyadd": "3151 DALLAS HGH SHLS HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "NC",
    "dropphyzpp": 280341307,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALLAS",
    "dropmalst": "NC",
    "dropmalzpp": 280349998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7049228438,
    "dropsitcph": 7049228438,
    "dropfax": 7049224436
  },
  {
    "dcode": "D",
    "dropkey": "PY15114",
    "droptype": "D",
    "dropname": "DANA",
    "dropdeladd": "10 RIDGE RD",
    "dropdelcty": "DANA",
    "dropdelst": "NC",
    "dropdelzpp": 287242000,
    "dropphyadd": "10 RIDGE RD",
    "dropphycty": "DANA",
    "dropphyst": "NC",
    "dropphyzpp": 287242000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANA",
    "dropmalst": "NC",
    "dropmalzpp": 287249998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286853211,
    "dropsitcph": 8286853211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15115",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "303 N MAIN ST",
    "dropdelcty": "DANBURY",
    "dropdelst": "NC",
    "dropdelzpp": 270167654,
    "dropphyadd": "303 N MAIN ST",
    "dropphycty": "DANBURY",
    "dropphyst": "NC",
    "dropphyzpp": 270167654,
    "dropmaladd": "303 N MAIN ST",
    "dropmalcty": "DANBURY",
    "dropmalst": "NC",
    "dropmalzpp": 270169998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365938623,
    "dropfax": 3365933563
  },
  {
    "dcode": "D",
    "dropkey": "PY15119",
    "droptype": "D",
    "dropname": "DAVIDSON",
    "dropdeladd": "99 JACKSON ST",
    "dropdelcty": "DAVIDSON",
    "dropdelst": "NC",
    "dropdelzpp": 280369721,
    "dropphyadd": "99 JACKSON ST",
    "dropphycty": "DAVIDSON",
    "dropphyst": "NC",
    "dropphyzpp": 280369721,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVIDSON",
    "dropmalst": "NC",
    "dropmalzpp": 280369998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048926279,
    "dropsitcph": 7048926279,
    "dropfax": 7048927444
  },
  {
    "dcode": "D",
    "dropkey": "PY15121",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "272 HORSESHOE RD",
    "dropdelcty": "DAVIS",
    "dropdelst": "NC",
    "dropdelzpp": 285245000,
    "dropphyadd": "272 HORSESHOE RD",
    "dropphycty": "DAVIS",
    "dropphyst": "NC",
    "dropphyzpp": 285245000,
    "dropmaladd": "PO BOX 28524",
    "dropmalcty": "DAVIS",
    "dropmalst": "NC",
    "dropmalzpp": 285249998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527292601,
    "dropsitcph": 2527292601,
    "dropfax": 2527292601
  },
  {
    "dcode": "D",
    "dropkey": "PY15122",
    "droptype": "D",
    "dropname": "DEEP GAP",
    "dropdeladd": "7378 OLD 421 S",
    "dropdelcty": "DEEP GAP",
    "dropdelst": "NC",
    "dropdelzpp": 286188934,
    "dropphyadd": "7378 OLD 421 S",
    "dropphycty": "DEEP GAP",
    "dropphyst": "NC",
    "dropphyzpp": 286188934,
    "dropmaladd": "7378 OLD 421 S",
    "dropmalcty": "DEEP GAP",
    "dropmalst": "NC",
    "dropmalzpp": 286189998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282660845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15124",
    "droptype": "D",
    "dropname": "DEEP RUN",
    "dropdeladd": "3466 OLD HWY 11",
    "dropdelcty": "DEEP RUN",
    "dropdelst": "NC",
    "dropdelzpp": 285259304,
    "dropphyadd": "3466 OLD HWY 11",
    "dropphycty": "DEEP RUN",
    "dropphyst": "NC",
    "dropphyzpp": 285259304,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEEP RUN",
    "dropmalst": "NC",
    "dropmalzpp": 285259998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525683228,
    "dropsitcph": 2525683228,
    "dropfax": 2525683228
  },
  {
    "dcode": "D",
    "dropkey": "PY15127",
    "droptype": "D",
    "dropname": "DELCO",
    "dropdeladd": "30 DELCO PROSPER RD",
    "dropdelcty": "DELCO",
    "dropdelst": "NC",
    "dropdelzpp": 284369804,
    "dropphyadd": "30 DELCO PROSPER RD",
    "dropphycty": "DELCO",
    "dropphyst": "NC",
    "dropphyzpp": 284369804,
    "dropmaladd": "PO BOX 28436",
    "dropmalcty": "DELCO",
    "dropmalst": "NC",
    "dropmalzpp": 284369998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106553495,
    "dropsitcph": 9106553495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15130",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "110 W SALISBURY ST",
    "dropdelcty": "DENTON",
    "dropdelst": "NC",
    "dropdelzpp": 272397295,
    "dropphyadd": "110 W SALISBURY ST",
    "dropphycty": "DENTON",
    "dropphyst": "NC",
    "dropphyzpp": 272397295,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENTON",
    "dropmalst": "NC",
    "dropmalzpp": 272399998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368594218,
    "dropfax": 3368590359
  },
  {
    "dcode": "D",
    "dropkey": "PY15131",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "3593 DENVER DR",
    "dropdelcty": "DENVER",
    "dropdelst": "NC",
    "dropdelzpp": 280377228,
    "dropphyadd": "3593 DENVER DR",
    "dropphycty": "DENVER",
    "dropphyst": "NC",
    "dropphyzpp": 280377228,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENVER",
    "dropmalst": "NC",
    "dropmalzpp": 280379998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044896590,
    "dropsitcph": 7044896590,
    "dropfax": 7044832424
  },
  {
    "dcode": "D",
    "dropkey": "PY15134",
    "droptype": "D",
    "dropname": "DILLSBORO",
    "dropdeladd": "385 HAYWOOD RD",
    "dropdelcty": "DILLSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 287258000,
    "dropphyadd": "385 HAYWOOD RD",
    "dropphycty": "DILLSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 287258000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DILLSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 287259998,
    "dropsitphn": 8283934581,
    "dropsitlph": 8285865474,
    "dropsitcph": 8285865474,
    "dropfax": 8285865474
  },
  {
    "dcode": "D",
    "dropkey": "PY15139",
    "droptype": "D",
    "dropname": "DOBSON",
    "dropdeladd": "214 W KAPP ST",
    "dropdelcty": "DOBSON",
    "dropdelst": "NC",
    "dropdelzpp": 270178826,
    "dropphyadd": "214 W KAPP ST",
    "dropphycty": "DOBSON",
    "dropphyst": "NC",
    "dropphyzpp": 270178826,
    "dropmaladd": "214 W KAPP ST",
    "dropmalcty": "DOBSON",
    "dropmalst": "NC",
    "dropmalzpp": 270179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363868281,
    "dropfax": 3363864892
  },
  {
    "dcode": "D",
    "dropkey": "PY15149",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "115 W KORNEGAY ST",
    "dropdelcty": "DOVER",
    "dropdelst": "NC",
    "dropdelzpp": 285269427,
    "dropphyadd": "115 W KORNEGAY ST",
    "dropphycty": "DOVER",
    "dropphyst": "NC",
    "dropphyzpp": 285269427,
    "dropmaladd": "PO BOX 28526",
    "dropmalcty": "DOVER",
    "dropmalst": "NC",
    "dropmalzpp": 285269998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525231440,
    "dropsitcph": 2525231440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15159",
    "droptype": "D",
    "dropname": "DREXEL",
    "dropdeladd": "200 CHURCH ST",
    "dropdelcty": "DREXEL",
    "dropdelst": "NC",
    "dropdelzpp": 286199800,
    "dropphyadd": "200 CHURCH ST",
    "dropphycty": "DREXEL",
    "dropphyst": "NC",
    "dropphyzpp": 286199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DREXEL",
    "dropmalst": "NC",
    "dropmalzpp": 286199998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284376568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15162",
    "droptype": "D",
    "dropname": "DUBLIN",
    "dropdeladd": "86 3RD ST",
    "dropdelcty": "DUBLIN",
    "dropdelst": "NC",
    "dropdelzpp": 283328903,
    "dropphyadd": "86 3RD ST",
    "dropphycty": "DUBLIN",
    "dropphyst": "NC",
    "dropphyzpp": 283328903,
    "dropmaladd": "PO BOX 28332",
    "dropmalcty": "DUBLIN",
    "dropmalst": "NC",
    "dropmalzpp": 283329998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108622986,
    "dropsitcph": 9108622986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15164",
    "droptype": "D",
    "dropname": "DUDLEY",
    "dropdeladd": "4219 US 117 ALT",
    "dropdelcty": "DUDLEY",
    "dropdelst": "NC",
    "dropdelzpp": 283337243,
    "dropphyadd": "4219 US 117 ALT",
    "dropphycty": "DUDLEY",
    "dropphyst": "NC",
    "dropphyzpp": 283337243,
    "dropmaladd": "PO BOX 28333",
    "dropmalcty": "DUDLEY",
    "dropmalst": "NC",
    "dropmalzpp": 283339998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9197362110,
    "dropsitcph": 9197362110,
    "dropfax": 9197361198
  },
  {
    "dcode": "D",
    "dropkey": "PY15174",
    "droptype": "D",
    "dropname": "DUNN",
    "dropdeladd": "1115 S CLINTON AVE",
    "dropdelcty": "DUNN",
    "dropdelst": "NC",
    "dropdelzpp": 283346314,
    "dropphyadd": "1115 S CLINTON AVE",
    "dropphycty": "DUNN",
    "dropphyst": "NC",
    "dropphyzpp": 283346314,
    "dropmaladd": "PO BOX 28334",
    "dropmalcty": "DUNN",
    "dropmalst": "NC",
    "dropmalzpp": 283349998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108923452,
    "dropsitcph": 9108923452,
    "dropfax": 9108922000
  },
  {
    "dcode": "D",
    "dropkey": "PY15179",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "323 E CHAPEL HILL ST",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277019998,
    "dropphyadd": "323 E CHAPEL HILL ST",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277019998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277029998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196279003,
    "dropfax": 9196870935
  },
  {
    "dcode": "D",
    "dropkey": "PY15196",
    "droptype": "D",
    "dropname": "EAGLE SPRINGS",
    "dropdeladd": "1984 NC HIGHWAY 211",
    "dropdelcty": "EAGLE SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 272427930,
    "dropphyadd": "1984 NC HIGHWAY 211",
    "dropphycty": "EAGLE SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 272427930,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 272429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9106737899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15197",
    "droptype": "D",
    "dropname": "EARL",
    "dropdeladd": "2719 BLACKSBURG RD",
    "dropdelcty": "EARL",
    "dropdelst": "NC",
    "dropdelzpp": 280389798,
    "dropphyadd": "2719 BLACKSBURG RD",
    "dropphycty": "EARL",
    "dropphyst": "NC",
    "dropphyzpp": 280389798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARL",
    "dropmalst": "NC",
    "dropmalzpp": 280389998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044827956,
    "dropsitcph": 7044827956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15198",
    "droptype": "D",
    "dropname": "EAST BEND",
    "dropdeladd": "448 E MAIN ST",
    "dropdelcty": "EAST BEND",
    "dropdelst": "NC",
    "dropdelzpp": 270187487,
    "dropphyadd": "448 E MAIN ST",
    "dropphycty": "EAST BEND",
    "dropphyst": "NC",
    "dropphyzpp": 270187487,
    "dropmaladd": "448 E MAIN ST",
    "dropmalcty": "EAST BEND",
    "dropmalst": "NC",
    "dropmalzpp": 270189998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364182672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15203",
    "droptype": "D",
    "dropname": "EAST FLAT ROCK",
    "dropdeladd": "125 W BLUE RIDGE RD",
    "dropdelcty": "EAST FLAT ROCK",
    "dropdelst": "NC",
    "dropdelzpp": 287260210,
    "dropphyadd": "125 W BLUE RIDGE RD",
    "dropphycty": "EAST FLAT ROCK",
    "dropphyst": "NC",
    "dropphyzpp": 287260210,
    "dropmaladd": "125 W BLUE RIDGE RD",
    "dropmalcty": "EAST FLAT ROCK",
    "dropmalst": "NC",
    "dropmalzpp": 287260210,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 8286923567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15212",
    "droptype": "D",
    "dropname": "EAST SPENCER",
    "dropdeladd": "209 S LONG ST",
    "dropdelcty": "EAST SPENCER",
    "dropdelst": "NC",
    "dropdelzpp": 280399700,
    "dropphyadd": "209 S LONG ST",
    "dropphycty": "EAST SPENCER",
    "dropphyst": "NC",
    "dropphyzpp": 280399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST SPENCER",
    "dropmalst": "NC",
    "dropmalzpp": 280399998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046338437,
    "dropsitcph": 7046338437,
    "dropfax": 7046339765
  },
  {
    "dcode": "D",
    "dropkey": "PY15220",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "332 N PIERCE ST",
    "dropdelcty": "EDEN",
    "dropdelst": "NC",
    "dropdelzpp": 272883462,
    "dropphyadd": "332 N PIERCE ST",
    "dropphycty": "EDEN",
    "dropphyst": "NC",
    "dropphyzpp": 272883462,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDEN",
    "dropmalst": "NC",
    "dropmalzpp": 272889998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366231849,
    "dropfax": 3366239375
  },
  {
    "dcode": "D",
    "dropkey": "PY15221",
    "droptype": "D",
    "dropname": "EDENTON",
    "dropdeladd": "100 N BROAD ST",
    "dropdelcty": "EDENTON",
    "dropdelst": "NC",
    "dropdelzpp": 279329998,
    "dropphyadd": "100 N BROAD ST",
    "dropphycty": "EDENTON",
    "dropphyst": "NC",
    "dropphyzpp": 279329998,
    "dropmaladd": "100 N BROAD ST",
    "dropmalcty": "EDENTON",
    "dropmalst": "NC",
    "dropmalzpp": 279329998,
    "dropsitphn": 2524822611,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524822611,
    "dropfax": 2524821919
  },
  {
    "dcode": "D",
    "dropkey": "PY15223",
    "droptype": "D",
    "dropname": "EDNEYVILLE",
    "dropdeladd": "3979 CHIMNEY ROCK RD",
    "dropdelcty": "EDNEYVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287272000,
    "dropphyadd": "3979 CHIMNEY ROCK RD",
    "dropphycty": "EDNEYVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287272000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDNEYVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286857611,
    "dropsitcph": 8286857611,
    "dropfax": 8286857611
  },
  {
    "dcode": "D",
    "dropkey": "PY15226",
    "droptype": "D",
    "dropname": "EDWARD",
    "dropdeladd": "19160 NC HIGHWAY 33 E",
    "dropdelcty": "EDWARD",
    "dropdelst": "NC",
    "dropdelzpp": 278219998,
    "dropphyadd": "19160 NC HIGHWAY 33 E",
    "dropphycty": "EDWARD",
    "dropphyst": "NC",
    "dropphyzpp": 278219998,
    "dropmaladd": "19160 NC HIGHWAY 33 E",
    "dropmalcty": "EDWARD",
    "dropmalst": "NC",
    "dropmalzpp": 278219998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523224051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15228",
    "droptype": "D",
    "dropname": "EFLAND",
    "dropdeladd": "3522 US HIGHWAY 70 W",
    "dropdelcty": "EFLAND",
    "dropdelst": "NC",
    "dropdelzpp": 272438409,
    "dropphyadd": "3522 US HIGHWAY 70 W",
    "dropphycty": "EFLAND",
    "dropphyst": "NC",
    "dropphyzpp": 272438409,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EFLAND",
    "dropmalst": "NC",
    "dropmalzpp": 272439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9197327912,
    "dropfax": 9197325987
  },
  {
    "dcode": "D",
    "dropkey": "PY15233",
    "droptype": "D",
    "dropname": "ELIZABETH CITY",
    "dropdeladd": "1001 W EHRINGHAUS ST",
    "dropdelcty": "ELIZABETH CITY",
    "dropdelst": "NC",
    "dropdelzpp": 279099998,
    "dropphyadd": "1001 W EHRINGHAUS ST",
    "dropphycty": "ELIZABETH CITY",
    "dropphyst": "NC",
    "dropphyzpp": 279099998,
    "dropmaladd": "1001 W EHRINGHAUS ST",
    "dropmalcty": "ELIZABETH CITY",
    "dropmalst": "NC",
    "dropmalzpp": 279099998,
    "dropsitphn": 3369319444,
    "dropsitlph": 2524205175,
    "dropsitcph": 2523352582,
    "dropfax": 2523385846
  },
  {
    "dcode": "D",
    "dropkey": "PY15237",
    "droptype": "D",
    "dropname": "ELIZABETHTOWN",
    "dropdeladd": "209 S POPLAR ST",
    "dropdelcty": "ELIZABETHTOWN",
    "dropdelst": "NC",
    "dropdelzpp": 283379313,
    "dropphyadd": "209 S POPLAR ST",
    "dropphycty": "ELIZABETHTOWN",
    "dropphyst": "NC",
    "dropphyzpp": 283379313,
    "dropmaladd": "PO BOX 28337",
    "dropmalcty": "ELIZABETHTOWN",
    "dropmalst": "NC",
    "dropmalzpp": 283379998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108623933,
    "dropsitcph": 9108623933,
    "dropfax": 9108626006
  },
  {
    "dcode": "D",
    "dropkey": "PY15239",
    "droptype": "D",
    "dropname": "ELK PARK",
    "dropdeladd": "153 MAIN ST",
    "dropdelcty": "ELK PARK",
    "dropdelst": "NC",
    "dropdelzpp": 286229186,
    "dropphyadd": "153 MAIN ST",
    "dropphycty": "ELK PARK",
    "dropphyst": "NC",
    "dropphyzpp": 286229186,
    "dropmaladd": "153 MAIN ST",
    "dropmalcty": "ELK PARK",
    "dropmalst": "NC",
    "dropmalzpp": 286229998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287335711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15242",
    "droptype": "D",
    "dropname": "ELKIN",
    "dropdeladd": "213 W MAIN ST",
    "dropdelcty": "ELKIN",
    "dropdelst": "NC",
    "dropdelzpp": 286213489,
    "dropphyadd": "213 W MAIN ST",
    "dropphycty": "ELKIN",
    "dropphyst": "NC",
    "dropphyzpp": 286213489,
    "dropmaladd": "213 W MAIN ST",
    "dropmalcty": "ELKIN",
    "dropmalst": "NC",
    "dropmalzpp": 286219998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368352113,
    "dropfax": 3368354553
  },
  {
    "dcode": "D",
    "dropkey": "PY15243",
    "droptype": "D",
    "dropname": "ELLENBORO",
    "dropdeladd": "131 DEPOT ST",
    "dropdelcty": "ELLENBORO",
    "dropdelst": "NC",
    "dropdelzpp": 280407784,
    "dropphyadd": "131 DEPOT ST",
    "dropphycty": "ELLENBORO",
    "dropphyst": "NC",
    "dropphyzpp": 280407784,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLENBORO",
    "dropmalst": "NC",
    "dropmalzpp": 280409998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284538584,
    "dropsitcph": 8284538584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15247",
    "droptype": "D",
    "dropname": "ELLERBE",
    "dropdeladd": "268 2ND ST",
    "dropdelcty": "ELLERBE",
    "dropdelst": "NC",
    "dropdelzpp": 283389000,
    "dropphyadd": "268 2ND ST",
    "dropphycty": "ELLERBE",
    "dropphyst": "NC",
    "dropphyzpp": 283389000,
    "dropmaladd": "PO BOX 28338",
    "dropmalcty": "ELLERBE",
    "dropmalst": "NC",
    "dropmalzpp": 283389998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106525184,
    "dropsitcph": 9106525184,
    "dropfax": 9106523463
  },
  {
    "dcode": "D",
    "dropkey": "PY15250",
    "droptype": "D",
    "dropname": "ELM CITY",
    "dropdeladd": "409 W MAIN ST",
    "dropdelcty": "ELM CITY",
    "dropdelst": "NC",
    "dropdelzpp": 278229998,
    "dropphyadd": "409 W MAIN ST",
    "dropphycty": "ELM CITY",
    "dropphyst": "NC",
    "dropphyzpp": 278229998,
    "dropmaladd": "409 W MAIN ST",
    "dropmalcty": "ELM CITY",
    "dropmalst": "NC",
    "dropmalzpp": 278229998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522364368,
    "dropfax": 2522363421
  },
  {
    "dcode": "D",
    "dropkey": "PY15255",
    "droptype": "D",
    "dropname": "ELON",
    "dropdeladd": "105 S WILLIAMSON AVE",
    "dropdelcty": "ELON",
    "dropdelst": "NC",
    "dropdelzpp": 272449204,
    "dropphyadd": "105 S WILLIAMSON AVE",
    "dropphycty": "ELON",
    "dropphyst": "NC",
    "dropphyzpp": 272449204,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELON",
    "dropmalst": "NC",
    "dropmalzpp": 272449998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365845943,
    "dropfax": 3365842082
  },
  {
    "dcode": "D",
    "dropkey": "PY15261",
    "droptype": "D",
    "dropname": "ENFIELD",
    "dropdeladd": "114 S DENNIS ST",
    "dropdelcty": "ENFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 278239998,
    "dropphyadd": "114 S DENNIS ST",
    "dropphycty": "ENFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 278239998,
    "dropmaladd": "114 S DENNIS ST",
    "dropmalcty": "ENFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 278239998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522000125,
    "dropfax": 2524452305
  },
  {
    "dcode": "D",
    "dropkey": "PY15262",
    "droptype": "D",
    "dropname": "ENGELHARD",
    "dropdeladd": "34668 US HIGHWAY 264",
    "dropdelcty": "ENGELHARD",
    "dropdelst": "NC",
    "dropdelzpp": 278249998,
    "dropphyadd": "34668 US HIGHWAY 264",
    "dropphycty": "ENGELHARD",
    "dropphyst": "NC",
    "dropphyzpp": 278249998,
    "dropmaladd": "34668 US HIGHWAY 264",
    "dropmalcty": "ENGELHARD",
    "dropmalst": "NC",
    "dropmalzpp": 278249998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529254671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15263",
    "droptype": "D",
    "dropname": "ENKA",
    "dropdeladd": "1572 SAND HILL RD",
    "dropdelcty": "ENKA",
    "dropdelst": "NC",
    "dropdelzpp": 287287500,
    "dropphyadd": "1572 SAND HILL RD",
    "dropphycty": "ENKA",
    "dropphyst": "NC",
    "dropphyzpp": 287287500,
    "dropmaladd": "1572 SAND HILL RD",
    "dropmalcty": "ENKA",
    "dropmalst": "NC",
    "dropmalzpp": 287287500,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286708829,
    "dropsitcph": 8286708829,
    "dropfax": 8286708829
  },
  {
    "dcode": "D",
    "dropkey": "PY15265",
    "droptype": "D",
    "dropname": "ENNICE",
    "dropdeladd": "2529 BARRETT RD",
    "dropdelcty": "ENNICE",
    "dropdelst": "NC",
    "dropdelzpp": 286239064,
    "dropphyadd": "2529 BARRETT RD",
    "dropphycty": "ENNICE",
    "dropphyst": "NC",
    "dropphyzpp": 286239064,
    "dropmaladd": "2529 BARRETT RD",
    "dropmalcty": "ENNICE",
    "dropmalst": "NC",
    "dropmalzpp": 286239998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366578585,
    "dropfax": 3366573817
  },
  {
    "dcode": "D",
    "dropkey": "PY15271",
    "droptype": "D",
    "dropname": "ERNUL",
    "dropdeladd": "1000 HILLS NECK RD",
    "dropdelcty": "ERNUL",
    "dropdelst": "NC",
    "dropdelzpp": 285279720,
    "dropphyadd": "1000 HILLS NECK RD",
    "dropphycty": "ERNUL",
    "dropphyst": "NC",
    "dropphyzpp": 285279720,
    "dropmaladd": "PO BOX 28527",
    "dropmalcty": "ERNUL",
    "dropmalst": "NC",
    "dropmalzpp": 285279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522440149,
    "dropsitcph": 2522440149,
    "dropfax": 2522440149
  },
  {
    "dcode": "D",
    "dropkey": "PY15272",
    "droptype": "D",
    "dropname": "ERWIN",
    "dropdeladd": "904 S 13TH ST",
    "dropdelcty": "ERWIN",
    "dropdelst": "NC",
    "dropdelzpp": 283398700,
    "dropphyadd": "904 S 13TH ST",
    "dropphycty": "ERWIN",
    "dropphyst": "NC",
    "dropphyzpp": 283398700,
    "dropmaladd": "PO BOX 28339",
    "dropmalcty": "ERWIN",
    "dropmalst": "NC",
    "dropmalzpp": 283399998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108975481,
    "dropsitcph": 9108975481,
    "dropfax": 9108978045
  },
  {
    "dcode": "D",
    "dropkey": "PY15276",
    "droptype": "D",
    "dropname": "ETHER",
    "dropdeladd": "105 HOGAN FARM RD",
    "dropdelcty": "ETHER",
    "dropdelst": "NC",
    "dropdelzpp": 272479800,
    "dropphyadd": "105 HOGAN FARM RD",
    "dropphycty": "ETHER",
    "dropphyst": "NC",
    "dropphyzpp": 272479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ETHER",
    "dropmalst": "NC",
    "dropmalzpp": 272479998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9104289494,
    "dropfax": 3369319445
  },
  {
    "dcode": "D",
    "dropkey": "PY15277",
    "droptype": "D",
    "dropname": "ETOWAH",
    "dropdeladd": "123 ETOWAH CENTER DR",
    "dropdelcty": "ETOWAH",
    "dropdelst": "NC",
    "dropdelzpp": 287298764,
    "dropphyadd": "123 ETOWAH CENTER DR",
    "dropphycty": "ETOWAH",
    "dropphyst": "NC",
    "dropphyzpp": 287298764,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ETOWAH",
    "dropmalst": "NC",
    "dropmalzpp": 287299998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288917239,
    "dropsitcph": 8288917239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15279",
    "droptype": "D",
    "dropname": "EURE",
    "dropdeladd": "1203 NC 137",
    "dropdelcty": "EURE",
    "dropdelst": "NC",
    "dropdelzpp": 279359998,
    "dropphyadd": "1203 NC 137",
    "dropphycty": "EURE",
    "dropphyst": "NC",
    "dropphyzpp": 279359998,
    "dropmaladd": "1203 NC 137",
    "dropmalcty": "EURE",
    "dropmalst": "NC",
    "dropmalzpp": 279359998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523570294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15283",
    "droptype": "D",
    "dropname": "EVERETTS",
    "dropdeladd": "106 N BROAD ST",
    "dropdelcty": "EVERETTS",
    "dropdelst": "NC",
    "dropdelzpp": 278259998,
    "dropphyadd": "106 N BROAD ST",
    "dropphycty": "EVERETTS",
    "dropphyst": "NC",
    "dropphyzpp": 278259998,
    "dropmaladd": "106 N BROAD ST",
    "dropmalcty": "EVERETTS",
    "dropmalst": "NC",
    "dropmalzpp": 278259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527927757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15284",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "7553 OLD HIGHWAY 74",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "NC",
    "dropdelzpp": 284389635,
    "dropphyadd": "7553 OLD HIGHWAY 74",
    "dropphycty": "EVERGREEN",
    "dropphyst": "NC",
    "dropphyzpp": 284389635,
    "dropmaladd": "PO BOX 28438",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "NC",
    "dropmalzpp": 284389998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106543606,
    "dropsitcph": 9106543606,
    "dropfax": 9106545892
  },
  {
    "dcode": "D",
    "dropkey": "PY15286",
    "droptype": "D",
    "dropname": "FAIR BLUFF",
    "dropdeladd": "1115 MAIN ST",
    "dropdelcty": "FAIR BLUFF",
    "dropdelst": "NC",
    "dropdelzpp": 284397000,
    "dropphyadd": "1115 MAIN ST",
    "dropphycty": "FAIR BLUFF",
    "dropphyst": "NC",
    "dropphyzpp": 284397000,
    "dropmaladd": "PO BOX 28439",
    "dropmalcty": "FAIR BLUFF",
    "dropmalst": "NC",
    "dropmalzpp": 284399998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106497888,
    "dropsitcph": 9106497888,
    "dropfax": 9106496633
  },
  {
    "dcode": "D",
    "dropkey": "PY15287",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "7089 NC HIGHWAY 94",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 278269998,
    "dropphyadd": "7089 NC HIGHWAY 94",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 278269998,
    "dropmaladd": "7089 NC HIGHWAY 94",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 278269998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529265936,
    "dropfax": 2529261991
  },
  {
    "dcode": "D",
    "dropkey": "PY15289",
    "droptype": "D",
    "dropname": "FAIRMONT",
    "dropdeladd": "100 N WALNUT ST",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "NC",
    "dropdelzpp": 283401952,
    "dropphyadd": "100 N WALNUT ST",
    "dropphycty": "FAIRMONT",
    "dropphyst": "NC",
    "dropphyzpp": 283401952,
    "dropmaladd": "PO BOX 28340",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "NC",
    "dropmalzpp": 283409998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106286778,
    "dropsitcph": 9106286778,
    "dropfax": 9106289090
  },
  {
    "dcode": "D",
    "dropkey": "PY15291",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "1352 CHARLOTTE HWY",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "NC",
    "dropdelzpp": 287308798,
    "dropphyadd": "1352 CHARLOTTE HWY",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "NC",
    "dropphyzpp": 287308798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "NC",
    "dropmalzpp": 287309998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286287838,
    "dropsitcph": 8286287838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15293",
    "droptype": "D",
    "dropname": "FAISON",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "FAISON",
    "dropdelst": "NC",
    "dropdelzpp": 283418901,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "FAISON",
    "dropphyst": "NC",
    "dropphyzpp": 283418901,
    "dropmaladd": "PO BOX 28341",
    "dropmalcty": "FAISON",
    "dropmalst": "NC",
    "dropmalzpp": 283419998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102675221,
    "dropsitcph": 9102675221,
    "dropfax": 9102675221
  },
  {
    "dcode": "D",
    "dropkey": "PY15294",
    "droptype": "D",
    "dropname": "FAITH",
    "dropdeladd": "1027 GANTT ST",
    "dropdelcty": "FAITH",
    "dropdelst": "NC",
    "dropdelzpp": 280419700,
    "dropphyadd": "1027 GANTT ST",
    "dropphycty": "FAITH",
    "dropphyst": "NC",
    "dropphyzpp": 280419700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAITH",
    "dropmalst": "NC",
    "dropmalzpp": 280419998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042793900,
    "dropsitcph": 7042793900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15295",
    "droptype": "D",
    "dropname": "FALCON",
    "dropdeladd": "7175 S WEST ST",
    "dropdelcty": "FALCON",
    "dropdelst": "NC",
    "dropdelzpp": 283428903,
    "dropphyadd": "7175 S WEST ST",
    "dropphycty": "FALCON",
    "dropphyst": "NC",
    "dropphyzpp": 283428903,
    "dropmaladd": "PO BOX 28342",
    "dropmalcty": "FALCON",
    "dropmalst": "NC",
    "dropmalzpp": 283429998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9109801058,
    "dropsitcph": 9109801058,
    "dropfax": 9109800583
  },
  {
    "dcode": "D",
    "dropkey": "PY15296",
    "droptype": "D",
    "dropname": "FALKLAND",
    "dropdeladd": "6063 NC HIGHWAY 43 N",
    "dropdelcty": "FALKLAND",
    "dropdelst": "NC",
    "dropdelzpp": 278279700,
    "dropphyadd": "6063 NC HIGHWAY 43 N",
    "dropphycty": "FALKLAND",
    "dropphyst": "NC",
    "dropphyzpp": 278279700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALKLAND",
    "dropmalst": "NC",
    "dropmalzpp": 278279998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527585084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15298",
    "droptype": "D",
    "dropname": "FALLSTON",
    "dropdeladd": "771 E STAGECOACH TRL",
    "dropdelcty": "FALLSTON",
    "dropdelst": "NC",
    "dropdelzpp": 280429700,
    "dropphyadd": "771 E STAGECOACH TRL",
    "dropphycty": "FALLSTON",
    "dropphyst": "NC",
    "dropphyzpp": 280429700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALLSTON",
    "dropmalst": "NC",
    "dropmalzpp": 280429998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045388311,
    "dropsitcph": 7045388311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15302",
    "droptype": "D",
    "dropname": "FARMVILLE",
    "dropdeladd": "3703 N MAIN ST",
    "dropdelcty": "FARMVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278289998,
    "dropphyadd": "3703 N MAIN ST",
    "dropphycty": "FARMVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278289998,
    "dropmaladd": "3703 N MAIN ST",
    "dropmalcty": "FARMVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278289998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527534580,
    "dropfax": 2527534762
  },
  {
    "dcode": "D",
    "dropkey": "PY15309",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "301 GREEN ST STE 200",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283015053,
    "dropphyadd": "301 GREEN ST STE 200",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283015053,
    "dropmaladd": "PO BOX 28302",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104862360,
    "dropsitcph": 9104862360,
    "dropfax": 9104862440
  },
  {
    "dcode": "D",
    "dropkey": "PY15317",
    "droptype": "D",
    "dropname": "FERGUSON",
    "dropdeladd": "12650 W NC HIGHWAY 268",
    "dropdelcty": "FERGUSON",
    "dropdelst": "NC",
    "dropdelzpp": 286249033,
    "dropphyadd": "12650 W NC HIGHWAY 268",
    "dropphycty": "FERGUSON",
    "dropphyst": "NC",
    "dropphyzpp": 286249033,
    "dropmaladd": "12650 W NC HIGHWAY 268",
    "dropmalcty": "FERGUSON",
    "dropmalst": "NC",
    "dropmalzpp": 286249998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369733228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15327",
    "droptype": "D",
    "dropname": "FLAT ROCK",
    "dropdeladd": "2687 GREENVILLE HWY",
    "dropdelcty": "FLAT ROCK",
    "dropdelst": "NC",
    "dropdelzpp": 287319607,
    "dropphyadd": "2687 GREENVILLE HWY",
    "dropphycty": "FLAT ROCK",
    "dropphyst": "NC",
    "dropphyzpp": 287319607,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLAT ROCK",
    "dropmalst": "NC",
    "dropmalzpp": 287319998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286928731,
    "dropsitcph": 8286928731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15331",
    "droptype": "D",
    "dropname": "FLEETWOOD",
    "dropdeladd": "910 RAILROAD GRADE RD",
    "dropdelcty": "FLEETWOOD",
    "dropdelst": "NC",
    "dropdelzpp": 286269168,
    "dropphyadd": "910 RAILROAD GRADE RD",
    "dropphycty": "FLEETWOOD",
    "dropphyst": "NC",
    "dropphyzpp": 286269168,
    "dropmaladd": "910 RAILROAD GRADE RD",
    "dropmalcty": "FLEETWOOD",
    "dropmalst": "NC",
    "dropmalzpp": 286269998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368774764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15332",
    "droptype": "D",
    "dropname": "FLETCHER",
    "dropdeladd": "3616 HENDERSONVILLE RD",
    "dropdelcty": "FLETCHER",
    "dropdelst": "NC",
    "dropdelzpp": 287324517,
    "dropphyadd": "3616 HENDERSONVILLE RD",
    "dropphycty": "FLETCHER",
    "dropphyst": "NC",
    "dropphyzpp": 287324517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLETCHER",
    "dropmalst": "NC",
    "dropmalzpp": 287329998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286846376,
    "dropsitcph": 8286846376,
    "dropfax": 8286845162
  },
  {
    "dcode": "D",
    "dropkey": "PY15335",
    "droptype": "D",
    "dropname": "FONTANA DAM",
    "dropdeladd": "50 FONTANA RD",
    "dropdelcty": "FONTANA DAM",
    "dropdelst": "NC",
    "dropdelzpp": 287336105,
    "dropphyadd": "50 FONTANA RD",
    "dropphycty": "FONTANA DAM",
    "dropphyst": "NC",
    "dropphyzpp": 287336105,
    "dropmaladd": "50 FONTANA RD",
    "dropmalcty": "FONTANA DAM",
    "dropmalst": "NC",
    "dropmalzpp": 287336105,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284982315,
    "dropsitcph": 8284982315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15338",
    "droptype": "D",
    "dropname": "FOREST CITY",
    "dropdeladd": "133 S POWELL ST",
    "dropdelcty": "FOREST CITY",
    "dropdelst": "NC",
    "dropdelzpp": 280433622,
    "dropphyadd": "133 S POWELL ST",
    "dropphycty": "FOREST CITY",
    "dropphyst": "NC",
    "dropphyzpp": 280433622,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOREST CITY",
    "dropmalst": "NC",
    "dropmalzpp": 280439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282454959,
    "dropsitcph": 8282454959,
    "dropfax": 8282450328
  },
  {
    "dcode": "D",
    "dropkey": "PY15353",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "6738 E WILSON ST",
    "dropdelcty": "FOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 278299998,
    "dropphyadd": "6738 E WILSON ST",
    "dropphycty": "FOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 278299998,
    "dropmaladd": "6738 E WILSON ST",
    "dropmalcty": "FOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 278299998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527494051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15355",
    "droptype": "D",
    "dropname": "FOUR OAKS",
    "dropdeladd": "107 N RAILROAD ST",
    "dropdelcty": "FOUR OAKS",
    "dropdelst": "NC",
    "dropdelzpp": 275249998,
    "dropphyadd": "107 N RAILROAD ST",
    "dropphycty": "FOUR OAKS",
    "dropphyst": "NC",
    "dropphyzpp": 275249998,
    "dropmaladd": "107 N RAILROAD ST",
    "dropmalcty": "FOUR OAKS",
    "dropmalst": "NC",
    "dropmalzpp": 275249998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199633257,
    "dropfax": 9199634069
  },
  {
    "dcode": "D",
    "dropkey": "PY15362",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "250 DEPOT ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NC",
    "dropdelzpp": 287343002,
    "dropphyadd": "250 DEPOT ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NC",
    "dropphyzpp": 287343002,
    "dropmaladd": "250 DEPOT ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NC",
    "dropmalzpp": 287343002,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285243219,
    "dropsitcph": 8285243219,
    "dropfax": 8283494379
  },
  {
    "dcode": "D",
    "dropkey": "PY15364",
    "droptype": "D",
    "dropname": "FRANKLINTON",
    "dropdeladd": "320 S MAIN ST",
    "dropdelcty": "FRANKLINTON",
    "dropdelst": "NC",
    "dropdelzpp": 275259998,
    "dropphyadd": "320 S MAIN ST",
    "dropphycty": "FRANKLINTON",
    "dropphyst": "NC",
    "dropphyzpp": 275259998,
    "dropmaladd": "320 S MAIN ST",
    "dropmalcty": "FRANKLINTON",
    "dropmalst": "NC",
    "dropmalzpp": 275259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194945068,
    "dropfax": 9194945090
  },
  {
    "dcode": "D",
    "dropkey": "PY15365",
    "droptype": "D",
    "dropname": "FRANKLINVILLE",
    "dropdeladd": "221 PINE ST",
    "dropdelcty": "FRANKLINVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 272489997,
    "dropphyadd": "221 PINE ST",
    "dropphycty": "FRANKLINVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 272489997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLINVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 272489998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368248459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15370",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "115 E MAIN ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "NC",
    "dropdelzpp": 278309998,
    "dropphyadd": "115 E MAIN ST",
    "dropphycty": "FREMONT",
    "dropphyst": "NC",
    "dropphyzpp": 278309998,
    "dropmaladd": "115 E MAIN ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "NC",
    "dropmalzpp": 278309998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192425817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15373",
    "droptype": "D",
    "dropname": "FRISCO",
    "dropdeladd": "53590 NC HIGHWAY 12",
    "dropdelcty": "FRISCO",
    "dropdelst": "NC",
    "dropdelzpp": 279369998,
    "dropphyadd": "53590 NC HIGHWAY 12",
    "dropphycty": "FRISCO",
    "dropphyst": "NC",
    "dropphyzpp": 279369998,
    "dropmaladd": "53590 NC HIGHWAY 12",
    "dropmalcty": "FRISCO",
    "dropmalst": "NC",
    "dropmalzpp": 279369998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529955017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15379",
    "droptype": "D",
    "dropname": "FUQUAY VARINA",
    "dropdeladd": "131 N JUDD PKWY NE",
    "dropdelcty": "FUQUAY VARINA",
    "dropdelst": "NC",
    "dropdelzpp": 275262368,
    "dropphyadd": "131 N JUDD PKWY NE",
    "dropphycty": "FUQUAY VARINA",
    "dropphyst": "NC",
    "dropphyzpp": 275262368,
    "dropmaladd": "131 N JUDD PKWY NE",
    "dropmalcty": "FUQUAY VARINA",
    "dropmalst": "NC",
    "dropmalzpp": 275269998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195521036,
    "dropfax": 9195520447
  },
  {
    "dcode": "D",
    "dropkey": "PY15386",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "107 S BLADEN AVE",
    "dropdelcty": "GARLAND",
    "dropdelst": "NC",
    "dropdelzpp": 284419716,
    "dropphyadd": "107 S BLADEN AVE",
    "dropphycty": "GARLAND",
    "dropphyst": "NC",
    "dropphyzpp": 284419716,
    "dropmaladd": "PO BOX 28441",
    "dropmalcty": "GARLAND",
    "dropmalst": "NC",
    "dropmalzpp": 284419998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105294961,
    "dropsitcph": 9105294961,
    "dropfax": 9105291740
  },
  {
    "dcode": "D",
    "dropkey": "PY15388",
    "droptype": "D",
    "dropname": "GARNER",
    "dropdeladd": "267 TIMBER DR",
    "dropdelcty": "GARNER",
    "dropdelst": "NC",
    "dropdelzpp": 275299998,
    "dropphyadd": "267 TIMBER DR",
    "dropphycty": "GARNER",
    "dropphyst": "NC",
    "dropphyzpp": 275299998,
    "dropmaladd": "267 TIMBER DR",
    "dropmalcty": "GARNER",
    "dropmalst": "NC",
    "dropmalzpp": 275299998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197725872,
    "dropfax": 9196627657
  },
  {
    "dcode": "D",
    "dropkey": "PY15389",
    "droptype": "D",
    "dropname": "GARYSBURG",
    "dropdeladd": "213 OLD HIGHWAY RD",
    "dropdelcty": "GARYSBURG",
    "dropdelst": "NC",
    "dropdelzpp": 278319998,
    "dropphyadd": "213 OLD HIGHWAY RD",
    "dropphycty": "GARYSBURG",
    "dropphyst": "NC",
    "dropphyzpp": 278319998,
    "dropmaladd": "213 OLD HIGHWAY RD",
    "dropmalcty": "GARYSBURG",
    "dropmalst": "NC",
    "dropmalzpp": 278319998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525364912,
    "dropfax": 2525364912
  },
  {
    "dcode": "D",
    "dropkey": "PY15390",
    "droptype": "D",
    "dropname": "GASTON",
    "dropdeladd": "108 ROANOKE RAPIDS RD",
    "dropdelcty": "GASTON",
    "dropdelst": "NC",
    "dropdelzpp": 278329728,
    "dropphyadd": "108 ROANOKE RAPIDS RD",
    "dropphycty": "GASTON",
    "dropphyst": "NC",
    "dropphyzpp": 278329728,
    "dropmaladd": "108 ROANOKE RAPIDS RD",
    "dropmalcty": "GASTON",
    "dropmalst": "NC",
    "dropmalzpp": 278329998,
    "dropsitphn": 3369319444,
    "dropsitlph": 2524205175,
    "dropsitcph": 2525372013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15391",
    "droptype": "D",
    "dropname": "GASTONIA",
    "dropdeladd": "301 W MAIN AVE",
    "dropdelcty": "GASTONIA",
    "dropdelst": "NC",
    "dropdelzpp": 280524185,
    "dropphyadd": "301 W MAIN AVE",
    "dropphycty": "GASTONIA",
    "dropphyst": "NC",
    "dropphyzpp": 280524185,
    "dropmaladd": "301 W MAIN AVE",
    "dropmalcty": "GASTONIA",
    "dropmalst": "NC",
    "dropmalzpp": 280524185,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048670339,
    "dropsitcph": 7048670339,
    "dropfax": 7048677056
  },
  {
    "dcode": "D",
    "dropkey": "PY15392",
    "droptype": "D",
    "dropname": "GATES",
    "dropdeladd": "958 NC HIGHWAY 37 N",
    "dropdelcty": "GATES",
    "dropdelst": "NC",
    "dropdelzpp": 279379901,
    "dropphyadd": "958 NC HIGHWAY 37 N",
    "dropphycty": "GATES",
    "dropphyst": "NC",
    "dropphyzpp": 279379901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GATES",
    "dropmalst": "NC",
    "dropmalzpp": 279379998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523571070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15393",
    "droptype": "D",
    "dropname": "GATESVILLE",
    "dropdeladd": "106 COURT ST",
    "dropdelcty": "GATESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 279389998,
    "dropphyadd": "106 COURT ST",
    "dropphycty": "GATESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 279389998,
    "dropmaladd": "106 COURT ST",
    "dropmalcty": "GATESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 279389998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523570605,
    "dropfax": 2523571153
  },
  {
    "dcode": "D",
    "dropkey": "PY15398",
    "droptype": "D",
    "dropname": "GERMANTON",
    "dropdeladd": "3188 NC 65 HWY W",
    "dropdelcty": "GERMANTON",
    "dropdelst": "NC",
    "dropdelzpp": 270198321,
    "dropphyadd": "3188 NC 65 HWY W",
    "dropphycty": "GERMANTON",
    "dropphyst": "NC",
    "dropphyzpp": 270198321,
    "dropmaladd": "3188 NC 65 HWY W",
    "dropmalcty": "GERMANTON",
    "dropmalst": "NC",
    "dropmalzpp": 270199998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365917733,
    "dropfax": 3365918284
  },
  {
    "dcode": "D",
    "dropkey": "PY15400",
    "droptype": "D",
    "dropname": "GERTON",
    "dropdeladd": "5000 GERTON HWY",
    "dropdelcty": "GERTON",
    "dropdelst": "NC",
    "dropdelzpp": 287359719,
    "dropphyadd": "5000 GERTON HWY",
    "dropphycty": "GERTON",
    "dropphyst": "NC",
    "dropphyzpp": 287359719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GERTON",
    "dropmalst": "NC",
    "dropmalzpp": 287359998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286254080,
    "dropsitcph": 8286254080,
    "dropfax": 8286254080
  },
  {
    "dcode": "D",
    "dropkey": "PY15401",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "4580 MAIN ST",
    "dropdelcty": "GIBSON",
    "dropdelst": "NC",
    "dropdelzpp": 283438853,
    "dropphyadd": "4580 MAIN ST",
    "dropphycty": "GIBSON",
    "dropphyst": "NC",
    "dropphyzpp": 283438853,
    "dropmaladd": "PO BOX 28343",
    "dropmalcty": "GIBSON",
    "dropmalst": "NC",
    "dropmalzpp": 283439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102684402,
    "dropsitcph": 9102684402,
    "dropfax": 9102684402
  },
  {
    "dcode": "D",
    "dropkey": "PY15402",
    "droptype": "D",
    "dropname": "GIBSONVILLE",
    "dropdeladd": "221 E MAIN ST",
    "dropdelcty": "GIBSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 272492418,
    "dropphyadd": "221 E MAIN ST",
    "dropphycty": "GIBSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 272492418,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIBSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 272499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364496971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15406",
    "droptype": "D",
    "dropname": "GLADE VALLEY",
    "dropdeladd": "18 GLADE VALLEY CHURCH RD",
    "dropdelcty": "GLADE VALLEY",
    "dropdelst": "NC",
    "dropdelzpp": 286279100,
    "dropphyadd": "18 GLADE VALLEY CHURCH RD",
    "dropphycty": "GLADE VALLEY",
    "dropphyst": "NC",
    "dropphyzpp": 286279100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLADE VALLEY",
    "dropmalst": "NC",
    "dropmalzpp": 286279998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363724841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15409",
    "droptype": "D",
    "dropname": "GLEN ALPINE",
    "dropdeladd": "102 CATAWBA ST",
    "dropdelcty": "GLEN ALPINE",
    "dropdelst": "NC",
    "dropdelzpp": 286289800,
    "dropphyadd": "102 CATAWBA ST",
    "dropphycty": "GLEN ALPINE",
    "dropphyst": "NC",
    "dropphyzpp": 286289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN ALPINE",
    "dropmalst": "NC",
    "dropmalzpp": 286289998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8285840628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15414",
    "droptype": "D",
    "dropname": "GLENDALE SPRINGS",
    "dropdeladd": "7471 NC HIGHWAY 16",
    "dropdelcty": "GLENDALE SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 286299800,
    "dropphyadd": "7471 NC HIGHWAY 16",
    "dropphycty": "GLENDALE SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 286299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENDALE SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 286299998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364894155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15417",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "4907 HWY 107 N",
    "dropdelcty": "GLENVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287366479,
    "dropphyadd": "4907 HWY 107 N",
    "dropphycty": "GLENVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287366479,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287369998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287432088,
    "dropsitcph": 8287432088,
    "dropfax": 8287435062
  },
  {
    "dcode": "D",
    "dropkey": "PY15424",
    "droptype": "D",
    "dropname": "GLOUCESTER",
    "dropdeladd": "310 PIGOTT RD",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "NC",
    "dropdelzpp": 285289344,
    "dropphyadd": "310 PIGOTT RD",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "NC",
    "dropphyzpp": 285289344,
    "dropmaladd": "PO BOX 28528",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "NC",
    "dropmalzpp": 285289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527291951,
    "dropsitcph": 2527291951,
    "dropfax": 2527291536
  },
  {
    "dcode": "D",
    "dropkey": "PY15425",
    "droptype": "D",
    "dropname": "GODWIN",
    "dropdeladd": "8817 MAIN ST",
    "dropdelcty": "GODWIN",
    "dropdelst": "NC",
    "dropdelzpp": 283449095,
    "dropphyadd": "8817 MAIN ST",
    "dropphycty": "GODWIN",
    "dropphyst": "NC",
    "dropphyzpp": 283449095,
    "dropmaladd": "PO BOX 28344",
    "dropmalcty": "GODWIN",
    "dropmalst": "NC",
    "dropmalzpp": 283449998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9109801362,
    "dropsitcph": 9109801362,
    "dropfax": 9109801362
  },
  {
    "dcode": "D",
    "dropkey": "PY15426",
    "droptype": "D",
    "dropname": "GOLD HILL",
    "dropdeladd": "14125 HIGHWAY 52",
    "dropdelcty": "GOLD HILL",
    "dropdelst": "NC",
    "dropdelzpp": 280718612,
    "dropphyadd": "14125 HIGHWAY 52",
    "dropphycty": "GOLD HILL",
    "dropphyst": "NC",
    "dropphyzpp": 280718612,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLD HILL",
    "dropmalst": "NC",
    "dropmalzpp": 280719998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042794090,
    "dropsitcph": 7042794090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15430",
    "droptype": "D",
    "dropname": "GOLDSBORO",
    "dropdeladd": "200 N WILLIAM ST",
    "dropdelcty": "GOLDSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 275309998,
    "dropphyadd": "200 N WILLIAM ST",
    "dropphycty": "GOLDSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 275309998,
    "dropmaladd": "200 N WILLIAM ST",
    "dropmalcty": "GOLDSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 275309997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199886037,
    "dropfax": 9197345115
  },
  {
    "dcode": "D",
    "dropkey": "PY15432",
    "droptype": "D",
    "dropname": "GOLDSTON",
    "dropdeladd": "50 E GOLDBAR AVE",
    "dropdelcty": "GOLDSTON",
    "dropdelst": "NC",
    "dropdelzpp": 272529503,
    "dropphyadd": "50 E GOLDBAR AVE",
    "dropphycty": "GOLDSTON",
    "dropphyst": "NC",
    "dropphyzpp": 272529503,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLDSTON",
    "dropmalst": "NC",
    "dropmalzpp": 272529998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9198982271,
    "dropfax": 9198982271
  },
  {
    "dcode": "D",
    "dropkey": "PY15439",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "112 S MARSHALL ST",
    "dropdelcty": "GRAHAM",
    "dropdelst": "NC",
    "dropdelzpp": 272533074,
    "dropphyadd": "112 S MARSHALL ST",
    "dropphycty": "GRAHAM",
    "dropphyst": "NC",
    "dropphyzpp": 272533074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAHAM",
    "dropmalst": "NC",
    "dropmalzpp": 272539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362262947,
    "dropfax": 3362261294
  },
  {
    "dcode": "D",
    "dropkey": "PY15442",
    "droptype": "D",
    "dropname": "GRANDY",
    "dropdeladd": "123 FORBES LOOP UNIT C",
    "dropdelcty": "GRANDY",
    "dropdelst": "NC",
    "dropdelzpp": 279399998,
    "dropphyadd": "123 FORBES LOOP UNIT C",
    "dropphycty": "GRANDY",
    "dropphyst": "NC",
    "dropphyzpp": 279399998,
    "dropmaladd": "123 FORBES LOOP UNIT C",
    "dropmalcty": "GRANDY",
    "dropmalst": "NC",
    "dropmalzpp": 279399998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524559020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15443",
    "droptype": "D",
    "dropname": "GRANITE FALLS",
    "dropdeladd": "1 LAKESIDE AVE",
    "dropdelcty": "GRANITE FALLS",
    "dropdelst": "NC",
    "dropdelzpp": 286301701,
    "dropphyadd": "1 LAKESIDE AVE",
    "dropphycty": "GRANITE FALLS",
    "dropphyst": "NC",
    "dropphyzpp": 286301701,
    "dropmaladd": "1 LAKESIDE AVE",
    "dropmalcty": "GRANITE FALLS",
    "dropmalst": "NC",
    "dropmalzpp": 286309998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283962951,
    "dropfax": 8283966982
  },
  {
    "dcode": "D",
    "dropkey": "PY15445",
    "droptype": "D",
    "dropname": "GRANITE QUARRY",
    "dropdeladd": "222 E BANK ST",
    "dropdelcty": "GRANITE QUARRY",
    "dropdelst": "NC",
    "dropdelzpp": 280729700,
    "dropphyadd": "222 E BANK ST",
    "dropphycty": "GRANITE QUARRY",
    "dropphyst": "NC",
    "dropphyzpp": 280729700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANITE QUARRY",
    "dropmalst": "NC",
    "dropmalzpp": 280729998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042794500,
    "dropsitcph": 7042794500,
    "dropfax": 7042794500
  },
  {
    "dcode": "D",
    "dropkey": "PY15447",
    "droptype": "D",
    "dropname": "GRANTSBORO",
    "dropdeladd": "10644 NC 55 HWY",
    "dropdelcty": "GRANTSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 285295000,
    "dropphyadd": "10644 NC 55 HWY",
    "dropphycty": "GRANTSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 285295000,
    "dropmaladd": "PO BOX 28529",
    "dropmalcty": "GRANTSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 285299998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527454711,
    "dropsitcph": 2527454711,
    "dropfax": 2527454159
  },
  {
    "dcode": "D",
    "dropkey": "PY15449",
    "droptype": "D",
    "dropname": "GRASSY CREEK",
    "dropdeladd": "15500 OLD NC HIGHWAY 16",
    "dropdelcty": "GRASSY CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 286319361,
    "dropphyadd": "15500 OLD NC HIGHWAY 16",
    "dropphycty": "GRASSY CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 286319361,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRASSY CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 286319998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363843696,
    "dropfax": 3363841102
  },
  {
    "dcode": "D",
    "dropkey": "PY15455",
    "droptype": "D",
    "dropname": "GREEN MOUNTAIN",
    "dropdeladd": "291 TOE RIVER RD",
    "dropdelcty": "GREEN MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 287409267,
    "dropphyadd": "291 TOE RIVER RD",
    "dropphycty": "GREEN MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 287409267,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 287409998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286826385,
    "dropsitcph": 8286826385,
    "dropfax": 8286821143
  },
  {
    "dcode": "D",
    "dropkey": "PY15458",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "201 N MURROW BLVD",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274012914,
    "dropphyadd": "201 N MURROW BLVD",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274012914,
    "dropmaladd": "PO BOX 27420",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363700227,
    "dropfax": 3363332328
  },
  {
    "dcode": "D",
    "dropkey": "PY15461",
    "droptype": "D",
    "dropname": "GREENSBORO NDC PHANTOM",
    "dropdeladd": "3701 W WENDOVER AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274950001,
    "dropphyadd": "3701 W WENDOVER AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274950001,
    "dropmaladd": "3701 W WENDOVER AVE",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274950001,
    "dropsitphn": 3368554318,
    "dropsitlph": 3368554324,
    "dropsitcph": 3368554290,
    "dropfax": 3368554323
  },
  {
    "dcode": "D",
    "dropkey": "PY15465",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "300 W 2ND ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278349998,
    "dropphyadd": "300 W 2ND ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278349998,
    "dropmaladd": "300 W 2ND ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278349998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527522153,
    "dropfax": 2527572073
  },
  {
    "dcode": "D",
    "dropkey": "PY15469",
    "droptype": "D",
    "dropname": "GRIFTON",
    "dropdeladd": "466 QUEEN ST",
    "dropdelcty": "GRIFTON",
    "dropdelst": "NC",
    "dropdelzpp": 285309731,
    "dropphyadd": "466 QUEEN ST",
    "dropphycty": "GRIFTON",
    "dropphyst": "NC",
    "dropphyzpp": 285309731,
    "dropmaladd": "PO BOX 28530",
    "dropmalcty": "GRIFTON",
    "dropmalst": "NC",
    "dropmalzpp": 285309998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525245550,
    "dropsitcph": 2522534003,
    "dropfax": 2525243948
  },
  {
    "dcode": "D",
    "dropkey": "PY15470",
    "droptype": "D",
    "dropname": "GRIMESLAND",
    "dropdeladd": "7607 PITT ST",
    "dropdelcty": "GRIMESLAND",
    "dropdelst": "NC",
    "dropdelzpp": 278379998,
    "dropphyadd": "7607 PITT ST",
    "dropphycty": "GRIMESLAND",
    "dropphyst": "NC",
    "dropphyzpp": 278379998,
    "dropmaladd": "7607 PITT ST",
    "dropmalcty": "GRIMESLAND",
    "dropmalst": "NC",
    "dropmalzpp": 278379998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527583365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15475",
    "droptype": "D",
    "dropname": "GROVER",
    "dropdeladd": "102 MULBERRY RD",
    "dropdelcty": "GROVER",
    "dropdelst": "NC",
    "dropdelzpp": 280739533,
    "dropphyadd": "102 MULBERRY RD",
    "dropphycty": "GROVER",
    "dropphyst": "NC",
    "dropphyzpp": 280739533,
    "dropmaladd": "102 MULBERRY RD",
    "dropmalcty": "GROVER",
    "dropmalst": "NC",
    "dropmalzpp": 280739533,
    "dropsitphn": 7043934581,
    "dropsitlph": 7049377176,
    "dropsitcph": 7049377176,
    "dropfax": 7049377860
  },
  {
    "dcode": "D",
    "dropkey": "PY15481",
    "droptype": "D",
    "dropname": "GULF",
    "dropdeladd": "833 THRIFT RD",
    "dropdelcty": "GULF",
    "dropdelst": "NC",
    "dropdelzpp": 272569800,
    "dropphyadd": "833 THRIFT RD",
    "dropphycty": "GULF",
    "dropphyst": "NC",
    "dropphyzpp": 272569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GULF",
    "dropmalst": "NC",
    "dropmalzpp": 272569998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9198984591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15486",
    "droptype": "D",
    "dropname": "HALIFAX",
    "dropdeladd": "28 S KING ST",
    "dropdelcty": "HALIFAX",
    "dropdelst": "NC",
    "dropdelzpp": 278399998,
    "dropphyadd": "28 S KING ST",
    "dropphycty": "HALIFAX",
    "dropphyst": "NC",
    "dropphyzpp": 278399998,
    "dropmaladd": "28 S KING ST",
    "dropmalcty": "HALIFAX",
    "dropmalst": "NC",
    "dropmalzpp": 278399998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525833621,
    "dropfax": 2525833621
  },
  {
    "dcode": "D",
    "dropkey": "PY15488",
    "droptype": "D",
    "dropname": "HALLSBORO",
    "dropdeladd": "4161 SAM POTTS HWY",
    "dropdelcty": "HALLSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 284428912,
    "dropphyadd": "4161 SAM POTTS HWY",
    "dropphycty": "HALLSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 284428912,
    "dropmaladd": "PO BOX 28442",
    "dropmalcty": "HALLSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 284429998,
    "dropsitphn": 7043834581,
    "dropsitlph": 9106463355,
    "dropsitcph": 9106463355,
    "dropfax": 9106463355
  },
  {
    "dcode": "D",
    "dropkey": "PY15490",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "NC",
    "dropdelzpp": 278409998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "NC",
    "dropphyzpp": 278409998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "NC",
    "dropmalzpp": 278409998,
    "dropsitphn": 3369319444,
    "dropsitlph": 2524205175,
    "dropsitcph": 2527982611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15491",
    "droptype": "D",
    "dropname": "HAMLET",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "HAMLET",
    "dropdelst": "NC",
    "dropdelzpp": 283453215,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "HAMLET",
    "dropphyst": "NC",
    "dropphyzpp": 283453215,
    "dropmaladd": "PO BOX 28345",
    "dropmalcty": "HAMLET",
    "dropmalst": "NC",
    "dropmalzpp": 283459998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105821070,
    "dropsitcph": 9105821070,
    "dropfax": 9105829763
  },
  {
    "dcode": "D",
    "dropkey": "PY15492",
    "droptype": "D",
    "dropname": "HAMPSTEAD",
    "dropdeladd": "121 DAN OWEN DR",
    "dropdelcty": "HAMPSTEAD",
    "dropdelst": "NC",
    "dropdelzpp": 284432174,
    "dropphyadd": "121 DAN OWEN DR",
    "dropphycty": "HAMPSTEAD",
    "dropphyst": "NC",
    "dropphyzpp": 284432174,
    "dropmaladd": "PO BOX 28443",
    "dropmalcty": "HAMPSTEAD",
    "dropmalst": "NC",
    "dropmalzpp": 284439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102704428,
    "dropsitcph": 9102704428,
    "dropfax": 9102701518
  },
  {
    "dcode": "D",
    "dropkey": "PY15493",
    "droptype": "D",
    "dropname": "HAMPTONVILLE",
    "dropdeladd": "2943 ROCKY BRANCH RD",
    "dropdelcty": "HAMPTONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270208392,
    "dropphyadd": "2943 ROCKY BRANCH RD",
    "dropphycty": "HAMPTONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270208392,
    "dropmaladd": "2943 ROCKY BRANCH RD",
    "dropmalcty": "HAMPTONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365716600,
    "dropfax": 3364688115
  },
  {
    "dcode": "D",
    "dropkey": "PY15503",
    "droptype": "D",
    "dropname": "HARBINGER",
    "dropdeladd": "8732 CARATOKE HWY",
    "dropdelcty": "HARBINGER",
    "dropdelst": "NC",
    "dropdelzpp": 279419780,
    "dropphyadd": "8732 CARATOKE HWY",
    "dropphycty": "HARBINGER",
    "dropphyst": "NC",
    "dropphyzpp": 279419780,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARBINGER",
    "dropmalst": "NC",
    "dropmalzpp": 279419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524918453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15506",
    "droptype": "D",
    "dropname": "HARKERS ISLAND",
    "dropdeladd": "823 ISLAND RD",
    "dropdelcty": "HARKERS ISLAND",
    "dropdelst": "NC",
    "dropdelzpp": 285319525,
    "dropphyadd": "823 ISLAND RD",
    "dropphycty": "HARKERS ISLAND",
    "dropphyst": "NC",
    "dropphyzpp": 285319525,
    "dropmaladd": "PO BOX 28531",
    "dropmalcty": "HARKERS ISLAND",
    "dropmalst": "NC",
    "dropmalzpp": 285319998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527282924,
    "dropsitcph": 2527282924,
    "dropfax": 2526565696
  },
  {
    "dcode": "D",
    "dropkey": "PY15507",
    "droptype": "D",
    "dropname": "HARMONY",
    "dropdeladd": "3348 HARMONY HWY",
    "dropdelcty": "HARMONY",
    "dropdelst": "NC",
    "dropdelzpp": 286349366,
    "dropphyadd": "3348 HARMONY HWY",
    "dropphycty": "HARMONY",
    "dropphyst": "NC",
    "dropphyzpp": 286349366,
    "dropmaladd": "3348 HARMONY HWY",
    "dropmalcty": "HARMONY",
    "dropmalst": "NC",
    "dropmalzpp": 286349998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7043970482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15509",
    "droptype": "D",
    "dropname": "HARRELLS",
    "dropdeladd": "218 TOMAHAWK HWY",
    "dropdelcty": "HARRELLS",
    "dropdelst": "NC",
    "dropdelzpp": 284446000,
    "dropphyadd": "218 TOMAHAWK HWY",
    "dropphycty": "HARRELLS",
    "dropphyst": "NC",
    "dropphyzpp": 284446000,
    "dropmaladd": "PO BOX 28444",
    "dropmalcty": "HARRELLS",
    "dropmalst": "NC",
    "dropmalzpp": 284449998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103123925,
    "dropsitcph": 9103123925,
    "dropfax": 9105322827
  },
  {
    "dcode": "D",
    "dropkey": "PY15510",
    "droptype": "D",
    "dropname": "HARRELLSVILLE",
    "dropdeladd": "116 E MAIN ST",
    "dropdelcty": "HARRELLSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 279429998,
    "dropphyadd": "116 E MAIN ST",
    "dropphycty": "HARRELLSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 279429998,
    "dropmaladd": "116 E MAIN ST",
    "dropmalcty": "HARRELLSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 279429998,
    "dropsitphn": 2523562869,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523562869,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15513",
    "droptype": "D",
    "dropname": "HARRIS",
    "dropdeladd": "173 HOGAN RD",
    "dropdelcty": "HARRIS",
    "dropdelst": "NC",
    "dropdelzpp": 280749700,
    "dropphyadd": "173 HOGAN RD",
    "dropphycty": "HARRIS",
    "dropphyst": "NC",
    "dropphyzpp": 280749700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRIS",
    "dropmalst": "NC",
    "dropmalzpp": 280749998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282453591,
    "dropsitcph": 8282453591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15515",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "4258 NC HIGHWAY 49 S",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "NC",
    "dropdelzpp": 280759702,
    "dropphyadd": "4258 NC HIGHWAY 49 S",
    "dropphycty": "HARRISBURG",
    "dropphyst": "NC",
    "dropphyzpp": 280759702,
    "dropmaladd": "4258 NC HIGHWAY 49 S",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "NC",
    "dropmalzpp": 280759702,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044547432,
    "dropsitcph": 7044547432,
    "dropfax": 7044559417
  },
  {
    "dcode": "D",
    "dropkey": "PY15520",
    "droptype": "D",
    "dropname": "HASSELL",
    "dropdeladd": "1524 E COMMERCE ST",
    "dropdelcty": "HASSELL",
    "dropdelst": "NC",
    "dropdelzpp": 278419700,
    "dropphyadd": "1524 E COMMERCE ST",
    "dropphycty": "HASSELL",
    "dropphyst": "NC",
    "dropphyzpp": 278419700,
    "dropmaladd": "1524 E COMMERCE ST",
    "dropmalcty": "HASSELL",
    "dropmalst": "NC",
    "dropmalzpp": 278419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527954017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15521",
    "droptype": "D",
    "dropname": "HATTERAS",
    "dropdeladd": "57689 NC HIGHWAY 12",
    "dropdelcty": "HATTERAS",
    "dropdelst": "NC",
    "dropdelzpp": 279439998,
    "dropphyadd": "57689 NC HIGHWAY 12",
    "dropphycty": "HATTERAS",
    "dropphyst": "NC",
    "dropphyzpp": 279439998,
    "dropmaladd": "57689 NC HIGHWAY 12",
    "dropmalcty": "HATTERAS",
    "dropmalst": "NC",
    "dropmalzpp": 279439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529862318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15522",
    "droptype": "D",
    "dropname": "HAVELOCK",
    "dropdeladd": "133 US HIGHWAY 70 W",
    "dropdelcty": "HAVELOCK",
    "dropdelst": "NC",
    "dropdelzpp": 285329431,
    "dropphyadd": "133 US HIGHWAY 70 W",
    "dropphycty": "HAVELOCK",
    "dropphyst": "NC",
    "dropphyzpp": 285329431,
    "dropmaladd": "PO BOX 28532",
    "dropmalcty": "HAVELOCK",
    "dropmalst": "NC",
    "dropmalzpp": 285329998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2524473819,
    "dropsitcph": 2524473819,
    "dropfax": 2524477567
  },
  {
    "dcode": "D",
    "dropkey": "PY15524",
    "droptype": "D",
    "dropname": "HAW RIVER",
    "dropdeladd": "105 ROXBORO ST",
    "dropdelcty": "HAW RIVER",
    "dropdelst": "NC",
    "dropdelzpp": 272589808,
    "dropphyadd": "105 ROXBORO ST",
    "dropphycty": "HAW RIVER",
    "dropphyst": "NC",
    "dropphyzpp": 272589808,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAW RIVER",
    "dropmalst": "NC",
    "dropmalzpp": 272589998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365780915,
    "dropfax": 3365780640
  },
  {
    "dcode": "D",
    "dropkey": "PY15526",
    "droptype": "D",
    "dropname": "HAYESVILLE",
    "dropdeladd": "136 SANDERSON ST",
    "dropdelcty": "HAYESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 289049202,
    "dropphyadd": "136 SANDERSON ST",
    "dropphycty": "HAYESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 289049202,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 289049998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8283896625,
    "dropsitcph": 8283896625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15531",
    "droptype": "D",
    "dropname": "HAYS",
    "dropdeladd": "5465 MOUNTAIN VIEW RD",
    "dropdelcty": "HAYS",
    "dropdelst": "NC",
    "dropdelzpp": 286359674,
    "dropphyadd": "5465 MOUNTAIN VIEW RD",
    "dropphycty": "HAYS",
    "dropphyst": "NC",
    "dropphyzpp": 286359674,
    "dropmaladd": "5465 MOUNTAIN VIEW RD",
    "dropmalcty": "HAYS",
    "dropmalst": "NC",
    "dropmalzpp": 286359998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366962151,
    "dropfax": 3366962608
  },
  {
    "dcode": "D",
    "dropkey": "PY15541",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "905 S GARNETT ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NC",
    "dropdelzpp": 275369998,
    "dropphyadd": "905 S GARNETT ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "NC",
    "dropphyzpp": 275369998,
    "dropmaladd": "905 S GARNETT ST",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NC",
    "dropmalzpp": 275369998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524386752,
    "dropfax": 2524928771
  },
  {
    "dcode": "D",
    "dropkey": "PY15542",
    "droptype": "D",
    "dropname": "HENDERSONVILLE",
    "dropdeladd": "1800 FOUR SEASONS BLVD STE 11",
    "dropdelcty": "HENDERSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287922894,
    "dropphyadd": "1800 FOUR SEASONS BLVD STE 11",
    "dropphycty": "HENDERSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287922894,
    "dropmaladd": "1800 FOUR SEASONS BLVD STE 11",
    "dropmalcty": "HENDERSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287922894,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286964336,
    "dropsitcph": 8286964336,
    "dropfax": 8286934210
  },
  {
    "dcode": "D",
    "dropkey": "PY15547",
    "droptype": "D",
    "dropname": "HENRICO",
    "dropdeladd": "1458 RIVER RD",
    "dropdelcty": "HENRICO",
    "dropdelst": "NC",
    "dropdelzpp": 278429998,
    "dropphyadd": "1458 RIVER RD",
    "dropphycty": "HENRICO",
    "dropphyst": "NC",
    "dropphyzpp": 278429998,
    "dropmaladd": "1458 RIVER RD",
    "dropmalcty": "HENRICO",
    "dropmalst": "NC",
    "dropmalzpp": 278429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 2525375150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15548",
    "droptype": "D",
    "dropname": "HENRIETTA",
    "dropdeladd": "2946 HARRIS HENRIETTA RD",
    "dropdelcty": "HENRIETTA",
    "dropdelst": "NC",
    "dropdelzpp": 280769700,
    "dropphyadd": "2946 HARRIS HENRIETTA RD",
    "dropphycty": "HENRIETTA",
    "dropphyst": "NC",
    "dropphyzpp": 280769700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENRIETTA",
    "dropmalst": "NC",
    "dropmalzpp": 280769998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286575996,
    "dropsitcph": 8286575996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15551",
    "droptype": "D",
    "dropname": "HERTFORD",
    "dropdeladd": "115 W GRUBB ST",
    "dropdelcty": "HERTFORD",
    "dropdelst": "NC",
    "dropdelzpp": 279449998,
    "dropphyadd": "115 W GRUBB ST",
    "dropphycty": "HERTFORD",
    "dropphyst": "NC",
    "dropphyzpp": 279449998,
    "dropmaladd": "115 W GRUBB ST",
    "dropmalcty": "HERTFORD",
    "dropmalst": "NC",
    "dropmalzpp": 279449998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524265353,
    "dropfax": 2524267927
  },
  {
    "dcode": "D",
    "dropkey": "PY15554",
    "droptype": "D",
    "dropname": "HICKORY",
    "dropdeladd": "231 GOVERNMENT AVE SW STE 99",
    "dropdelcty": "HICKORY",
    "dropdelst": "NC",
    "dropdelzpp": 286022958,
    "dropphyadd": "231 GOVERNMENT AVE SW STE 99",
    "dropphycty": "HICKORY",
    "dropphyst": "NC",
    "dropphyzpp": 286022958,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKORY",
    "dropmalst": "NC",
    "dropmalzpp": 286039998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283285503,
    "dropfax": 8283289815
  },
  {
    "dcode": "D",
    "dropkey": "PY15557",
    "droptype": "D",
    "dropname": "HIDDENITE",
    "dropdeladd": "5181 NC HIGHWAY 90 E",
    "dropdelcty": "HIDDENITE",
    "dropdelst": "NC",
    "dropdelzpp": 286369399,
    "dropphyadd": "5181 NC HIGHWAY 90 E",
    "dropphycty": "HIDDENITE",
    "dropphyst": "NC",
    "dropphyzpp": 286369399,
    "dropmaladd": "5181 NC HIGHWAY 90 E",
    "dropmalcty": "HIDDENITE",
    "dropmalst": "NC",
    "dropmalzpp": 286369998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8286322601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15560",
    "droptype": "D",
    "dropname": "HIGH POINT",
    "dropdeladd": "315 E GREEN DR",
    "dropdelcty": "HIGH POINT",
    "dropdelst": "NC",
    "dropdelzpp": 272606762,
    "dropphyadd": "315 E GREEN DR",
    "dropphycty": "HIGH POINT",
    "dropphyst": "NC",
    "dropphyzpp": 272606762,
    "dropmaladd": "PO BOX 27260",
    "dropmalcty": "HIGH POINT",
    "dropmalst": "NC",
    "dropmalzpp": 272609998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368846098,
    "dropfax": 3368845226
  },
  {
    "dcode": "D",
    "dropkey": "PY15564",
    "droptype": "D",
    "dropname": "HIGH SHOALS",
    "dropdeladd": "511 N LINCOLN ST",
    "dropdelcty": "HIGH SHOALS",
    "dropdelst": "NC",
    "dropdelzpp": 280779700,
    "dropphyadd": "511 N LINCOLN ST",
    "dropphycty": "HIGH SHOALS",
    "dropphyst": "NC",
    "dropphyzpp": 280779700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGH SHOALS",
    "dropmalst": "NC",
    "dropmalzpp": 280779998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047350721,
    "dropsitcph": 7047350721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15565",
    "droptype": "D",
    "dropname": "HIGHFALLS",
    "dropdeladd": "1368 NC HIGHWAY 22",
    "dropdelcty": "HIGHFALLS",
    "dropdelst": "NC",
    "dropdelzpp": 272599800,
    "dropphyadd": "1368 NC HIGHWAY 22",
    "dropphycty": "HIGHFALLS",
    "dropphyst": "NC",
    "dropphyzpp": 272599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGHFALLS",
    "dropmalst": "NC",
    "dropmalzpp": 272599998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9104645333,
    "dropfax": 9104646942
  },
  {
    "dcode": "D",
    "dropkey": "PY15566",
    "droptype": "D",
    "dropname": "HIGHLANDS",
    "dropdeladd": "43 DILLARD RD",
    "dropdelcty": "HIGHLANDS",
    "dropdelst": "NC",
    "dropdelzpp": 287414517,
    "dropphyadd": "43 DILLARD RD",
    "dropphycty": "HIGHLANDS",
    "dropphyst": "NC",
    "dropphyzpp": 287414517,
    "dropmaladd": "43 DILLARD RD",
    "dropmalcty": "HIGHLANDS",
    "dropmalst": "NC",
    "dropmalzpp": 287414517,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285262667,
    "dropsitcph": 8285262667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15569",
    "droptype": "D",
    "dropname": "HILDEBRAN",
    "dropdeladd": "511 US HIGHWAY 70 W STE D",
    "dropdelcty": "HILDEBRAN",
    "dropdelst": "NC",
    "dropdelzpp": 286379998,
    "dropphyadd": "511 US HIGHWAY 70 W STE D",
    "dropphycty": "HILDEBRAN",
    "dropphyst": "NC",
    "dropphyzpp": 286378398,
    "dropmaladd": "511 US HIGHWAY 70 W STE D",
    "dropmalcty": "HILDEBRAN",
    "dropmalst": "NC",
    "dropmalzpp": 286379998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283976573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15572",
    "droptype": "D",
    "dropname": "HILLSBOROUGH",
    "dropdeladd": "144 E KING ST",
    "dropdelcty": "HILLSBOROUGH",
    "dropdelst": "NC",
    "dropdelzpp": 272782686,
    "dropphyadd": "144 E KING ST",
    "dropphycty": "HILLSBOROUGH",
    "dropphyst": "NC",
    "dropphyzpp": 272782686,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSBOROUGH",
    "dropmalst": "NC",
    "dropmalzpp": 272789998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9197323986,
    "dropfax": 9197325577
  },
  {
    "dcode": "D",
    "dropkey": "PY15577",
    "droptype": "D",
    "dropname": "HOBBSVILLE",
    "dropdeladd": "385 HOBBSVILLE RD",
    "dropdelcty": "HOBBSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 279469544,
    "dropphyadd": "385 HOBBSVILLE RD",
    "dropphycty": "HOBBSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 279469544,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOBBSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 279469998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522972475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15580",
    "droptype": "D",
    "dropname": "HOBGOOD",
    "dropdeladd": "218 COMMERCE ST",
    "dropdelcty": "HOBGOOD",
    "dropdelst": "NC",
    "dropdelzpp": 278439800,
    "dropphyadd": "218 COMMERCE ST",
    "dropphycty": "HOBGOOD",
    "dropphyst": "NC",
    "dropphyzpp": 278439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOBGOOD",
    "dropmalst": "NC",
    "dropmalzpp": 278439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528264759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15581",
    "droptype": "D",
    "dropname": "HOBUCKEN",
    "dropdeladd": "51 SCHOOL HOUSE LOOP",
    "dropdelcty": "HOBUCKEN",
    "dropdelst": "NC",
    "dropdelzpp": 285375000,
    "dropphyadd": "51 SCHOOL HOUSE LOOP",
    "dropphycty": "HOBUCKEN",
    "dropphyst": "NC",
    "dropphyzpp": 285375000,
    "dropmaladd": "PO BOX 28537",
    "dropmalcty": "HOBUCKEN",
    "dropmalst": "NC",
    "dropmalzpp": 285379998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527455642,
    "dropsitcph": 2527455642,
    "dropfax": 2527454371
  },
  {
    "dcode": "D",
    "dropkey": "PY15583",
    "droptype": "D",
    "dropname": "HOFFMAN",
    "dropdeladd": "2717 N US 1 HWY",
    "dropdelcty": "MARSTON",
    "dropdelst": "NC",
    "dropdelzpp": 283638619,
    "dropphyadd": "2717 N US 1 HWY",
    "dropphycty": "MARSTON",
    "dropphyst": "NC",
    "dropphyzpp": 283638619,
    "dropmaladd": "2717 N US 1 HWY",
    "dropmalcty": "MARSTON",
    "dropmalst": "NC",
    "dropmalzpp": 283638619,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102813515,
    "dropsitcph": 9102813515,
    "dropfax": 9102813515
  },
  {
    "dcode": "D",
    "dropkey": "PY15587",
    "droptype": "D",
    "dropname": "HOLLISTER",
    "dropdeladd": "231 GIBBS AVE",
    "dropdelcty": "HOLLISTER",
    "dropdelst": "NC",
    "dropdelzpp": 278449998,
    "dropphyadd": "231 GIBBS AVE",
    "dropphycty": "HOLLISTER",
    "dropphyst": "NC",
    "dropphyzpp": 278449998,
    "dropmaladd": "231 GIBBS AVE",
    "dropmalcty": "HOLLISTER",
    "dropmalst": "NC",
    "dropmalzpp": 278449998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525863644,
    "dropfax": 2525866809
  },
  {
    "dcode": "D",
    "dropkey": "PY15590",
    "droptype": "D",
    "dropname": "HOLLY RIDGE",
    "dropdeladd": "213 HOLLY ST",
    "dropdelcty": "HOLLY RIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 284457879,
    "dropphyadd": "213 HOLLY ST",
    "dropphycty": "HOLLY RIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 284457879,
    "dropmaladd": "PO BOX 28445",
    "dropmalcty": "HOLLY RIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 284459998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103291463,
    "dropsitcph": 9103291463,
    "dropfax": 9103291925
  },
  {
    "dcode": "D",
    "dropkey": "PY15591",
    "droptype": "D",
    "dropname": "HOLLY SPRINGS",
    "dropdeladd": "112 3RD ST",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 275409998,
    "dropphyadd": "112 3RD ST",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 275409998,
    "dropmaladd": "112 3RD ST",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 275409998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 9195573508,
    "dropfax": 9195521966
  },
  {
    "dcode": "D",
    "dropkey": "PY15592",
    "droptype": "D",
    "dropname": "HOOKERTON",
    "dropdeladd": "116 S THIRD ST",
    "dropdelcty": "HOOKERTON",
    "dropdelst": "NC",
    "dropdelzpp": 285389997,
    "dropphyadd": "116 S THIRD ST",
    "dropphycty": "HOOKERTON",
    "dropphyst": "NC",
    "dropphyzpp": 285389997,
    "dropmaladd": "PO BOX 28538",
    "dropmalcty": "HOOKERTON",
    "dropmalst": "NC",
    "dropmalzpp": 285389998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527475024,
    "dropsitcph": 2527475024,
    "dropfax": 2527475024
  },
  {
    "dcode": "D",
    "dropkey": "PY15593",
    "droptype": "D",
    "dropname": "HOPE MILLS",
    "dropdeladd": "3215 N MAIN ST",
    "dropdelcty": "HOPE MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 283481830,
    "dropphyadd": "3215 N MAIN ST",
    "dropphycty": "HOPE MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 283481830,
    "dropmaladd": "PO BOX 28348",
    "dropmalcty": "HOPE MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 283489998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104255307,
    "dropsitcph": 9104255307,
    "dropfax": 9104251238
  },
  {
    "dcode": "D",
    "dropkey": "PY15596",
    "droptype": "D",
    "dropname": "HORSE SHOE",
    "dropdeladd": "3740 BREVARD RD",
    "dropdelcty": "HORSE SHOE",
    "dropdelst": "NC",
    "dropdelzpp": 287428615,
    "dropphyadd": "3740 BREVARD RD",
    "dropphycty": "HORSE SHOE",
    "dropphyst": "NC",
    "dropphyzpp": 287428615,
    "dropmaladd": "3740 BREVARD RD",
    "dropmalcty": "HORSE SHOE",
    "dropmalst": "NC",
    "dropmalzpp": 287428615,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288917761,
    "dropsitcph": 8288917761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15598",
    "droptype": "D",
    "dropname": "HOT SPRINGS",
    "dropdeladd": "111 BRIDGE ST",
    "dropdelcty": "HOT SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 287439231,
    "dropphyadd": "111 BRIDGE ST",
    "dropphycty": "HOT SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 287439231,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOT SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 287439998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286223242,
    "dropsitcph": 8286223242,
    "dropfax": 8286223592
  },
  {
    "dcode": "D",
    "dropkey": "PY15600",
    "droptype": "D",
    "dropname": "HUBERT",
    "dropdeladd": "382 HUBERT BLVD",
    "dropdelcty": "HUBERT",
    "dropdelst": "NC",
    "dropdelzpp": 285394266,
    "dropphyadd": "382 HUBERT BLVD",
    "dropphycty": "HUBERT",
    "dropphyst": "NC",
    "dropphyzpp": 285394266,
    "dropmaladd": "PO BOX 28539",
    "dropmalcty": "HUBERT",
    "dropmalst": "NC",
    "dropmalzpp": 285399998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103532766,
    "dropsitcph": 9103532766,
    "dropfax": 9103552136
  },
  {
    "dcode": "D",
    "dropkey": "PY15601",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "101 FAIRWAY AVE",
    "dropdelcty": "HUDSON",
    "dropdelst": "NC",
    "dropdelzpp": 286382490,
    "dropphyadd": "101 FAIRWAY AVE",
    "dropphycty": "HUDSON",
    "dropphyst": "NC",
    "dropphyzpp": 286382490,
    "dropmaladd": "101 FAIRWAY AVE",
    "dropmalcty": "HUDSON",
    "dropmalst": "NC",
    "dropmalzpp": 286389998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287289421,
    "dropfax": 8287268808
  },
  {
    "dcode": "D",
    "dropkey": "PY15603",
    "droptype": "D",
    "dropname": "HUNTERSVILLE",
    "dropdeladd": "400 GILEAD RD",
    "dropdelcty": "HUNTERSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 280786899,
    "dropphyadd": "400 GILEAD RD",
    "dropphycty": "HUNTERSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 280786899,
    "dropmaladd": "400 GILEAD RD",
    "dropmalcty": "HUNTERSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 280786899,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048756088,
    "dropsitcph": 7048759218,
    "dropfax": 7048750594
  },
  {
    "dcode": "D",
    "dropkey": "PY15607",
    "droptype": "D",
    "dropname": "HURDLE MILLS",
    "dropdeladd": "9581 HURDLE MILLS RD",
    "dropdelcty": "HURDLE MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 275419998,
    "dropphyadd": "9581 HURDLE MILLS RD",
    "dropphycty": "HURDLE MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 275419998,
    "dropmaladd": "9581 HURDLE MILLS RD",
    "dropmalcty": "HURDLE MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 275419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 3363642468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15611",
    "droptype": "D",
    "dropname": "ICARD",
    "dropdeladd": "3462 MILLER BRIDGE RD",
    "dropdelcty": "ICARD",
    "dropdelst": "NC",
    "dropdelzpp": 286669800,
    "dropphyadd": "3462 MILLER BRIDGE RD",
    "dropphycty": "ICARD",
    "dropphyst": "NC",
    "dropphyzpp": 286669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ICARD",
    "dropmalst": "NC",
    "dropmalzpp": 286669998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283975071,
    "dropfax": 8283972342
  },
  {
    "dcode": "D",
    "dropkey": "PY15616",
    "droptype": "D",
    "dropname": "INDIAN TRAIL",
    "dropdeladd": "210 POSTAGE WAY",
    "dropdelcty": "INDIAN TRAIL",
    "dropdelst": "NC",
    "dropdelzpp": 280799701,
    "dropphyadd": "210 POSTAGE WAY",
    "dropphycty": "INDIAN TRAIL",
    "dropphyst": "NC",
    "dropphyzpp": 280799701,
    "dropmaladd": "210 POSTAGE WAY",
    "dropmalcty": "INDIAN TRAIL",
    "dropmalst": "NC",
    "dropmalzpp": 280799701,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048214977,
    "dropsitcph": 7048214977,
    "dropfax": 7048217338
  },
  {
    "dcode": "D",
    "dropkey": "PY15623",
    "droptype": "D",
    "dropname": "IRON STATION",
    "dropdeladd": "4832 E HIGHWAY 27",
    "dropdelcty": "IRON STATION",
    "dropdelst": "NC",
    "dropdelzpp": 280809333,
    "dropphyadd": "4832 E HIGHWAY 27",
    "dropphycty": "IRON STATION",
    "dropphyst": "NC",
    "dropphyzpp": 280809333,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRON STATION",
    "dropmalst": "NC",
    "dropmalzpp": 280809998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047356144,
    "dropsitcph": 7047356144,
    "dropfax": 7047324519
  },
  {
    "dcode": "D",
    "dropkey": "PY15624",
    "droptype": "D",
    "dropname": "IVANHOE",
    "dropdeladd": "4109 IVANHOE RD",
    "dropdelcty": "IVANHOE",
    "dropdelst": "NC",
    "dropdelzpp": 284479147,
    "dropphyadd": "4109 IVANHOE RD",
    "dropphycty": "IVANHOE",
    "dropphyst": "NC",
    "dropphyzpp": 284479147,
    "dropmaladd": "PO BOX 28447",
    "dropmalcty": "IVANHOE",
    "dropmalst": "NC",
    "dropmalzpp": 284479998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105324495,
    "dropsitcph": 9105324495,
    "dropfax": 9105326032
  },
  {
    "dcode": "D",
    "dropkey": "PY15627",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "104 ATHERTON ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "NC",
    "dropdelzpp": 278459998,
    "dropphyadd": "104 ATHERTON ST",
    "dropphycty": "JACKSON",
    "dropphyst": "NC",
    "dropphyzpp": 278459998,
    "dropmaladd": "104 ATHERTON ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "NC",
    "dropmalzpp": 278459998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525343841,
    "dropfax": 2525341225
  },
  {
    "dcode": "D",
    "dropkey": "PY15631",
    "droptype": "D",
    "dropname": "JACKSON SPRINGS",
    "dropdeladd": "2411 JACKSON SPRINGS RD",
    "dropdelcty": "JACKSON SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 272818223,
    "dropphyadd": "2411 JACKSON SPRINGS RD",
    "dropphycty": "JACKSON SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 272818223,
    "dropmaladd": "2411 JACKSON SPRINGS RD",
    "dropmalcty": "JACKSON SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 272819998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9106733251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15633",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "719 NEW BRIDGE ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285405447,
    "dropphyadd": "719 NEW BRIDGE ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285405447,
    "dropmaladd": "PO BOX 28540",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285409998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103465061,
    "dropsitcph": 9103465061,
    "dropfax": 9103469112
  },
  {
    "dcode": "D",
    "dropkey": "PY15640",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "203 E MAIN ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "NC",
    "dropdelzpp": 272829828,
    "dropphyadd": "203 E MAIN ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "NC",
    "dropphyzpp": 272829828,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "NC",
    "dropmalzpp": 272829998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364542124,
    "dropfax": 3364544229
  },
  {
    "dcode": "D",
    "dropkey": "PY15642",
    "droptype": "D",
    "dropname": "JAMESVILLE",
    "dropdeladd": "1840 MAIN ST",
    "dropdelcty": "JAMESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278469998,
    "dropphyadd": "1840 MAIN ST",
    "dropphycty": "JAMESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278469998,
    "dropmaladd": "1840 MAIN ST",
    "dropmalcty": "JAMESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278469998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527927052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15645",
    "droptype": "D",
    "dropname": "JARVISBURG",
    "dropdeladd": "7066 CARATOKE HWY",
    "dropdelcty": "JARVISBURG",
    "dropdelst": "NC",
    "dropdelzpp": 279479726,
    "dropphyadd": "7066 CARATOKE HWY",
    "dropphycty": "JARVISBURG",
    "dropphyst": "NC",
    "dropphyzpp": 279479726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JARVISBURG",
    "dropmalst": "NC",
    "dropmalzpp": 279479998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524912254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15647",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "410 E MAIN ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "NC",
    "dropdelzpp": 286408985,
    "dropphyadd": "410 E MAIN ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "NC",
    "dropphyzpp": 286408985,
    "dropmaladd": "410 E MAIN ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "NC",
    "dropmalzpp": 286409998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362469632,
    "dropfax": 3362468859
  },
  {
    "dcode": "D",
    "dropkey": "PY15651",
    "droptype": "D",
    "dropname": "JONAS RIDGE",
    "dropdeladd": "9042 NC HWY 181",
    "dropdelcty": "JONAS RIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 286419801,
    "dropphyadd": "9042 NC HWY 181",
    "dropphycty": "JONAS RIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 286419801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JONAS RIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 286419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287334711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15653",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "127 N BRIDGE ST",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286422260,
    "dropphyadd": "127 N BRIDGE ST",
    "dropphycty": "JONESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286422260,
    "dropmaladd": "127 N BRIDGE ST",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366770669,
    "dropfax": 3368355187
  },
  {
    "dcode": "D",
    "dropkey": "PY15659",
    "droptype": "D",
    "dropname": "JULIAN",
    "dropdeladd": "6600 LIBERTY RD",
    "dropdelcty": "JULIAN",
    "dropdelst": "NC",
    "dropdelzpp": 272839253,
    "dropphyadd": "6600 LIBERTY RD",
    "dropphycty": "JULIAN",
    "dropphyst": "NC",
    "dropphyzpp": 272839253,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JULIAN",
    "dropmalst": "NC",
    "dropmalzpp": 272839998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366859361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15660",
    "droptype": "D",
    "dropname": "KANNAPOLIS",
    "dropdeladd": "1040 DALE EARNHARDT BLVD",
    "dropdelcty": "KANNAPOLIS",
    "dropdelst": "NC",
    "dropdelzpp": 280834476,
    "dropphyadd": "1040 DALE EARNHARDT BLVD",
    "dropphycty": "KANNAPOLIS",
    "dropphyst": "NC",
    "dropphyzpp": 280834476,
    "dropmaladd": "1040 DALE EARNHARDT BLVD",
    "dropmalcty": "KANNAPOLIS",
    "dropmalst": "NC",
    "dropmalzpp": 280834476,
    "dropsitphn": 7043934581,
    "dropsitlph": 7049381120,
    "dropsitcph": 7049381120,
    "dropfax": 7049342006
  },
  {
    "dcode": "D",
    "dropkey": "PY15663",
    "droptype": "D",
    "dropname": "KELFORD",
    "dropdeladd": "108 S MAIN ST",
    "dropdelcty": "KELFORD",
    "dropdelst": "NC",
    "dropdelzpp": 278479414,
    "dropphyadd": "108 S MAIN ST",
    "dropphycty": "KELFORD",
    "dropphyst": "NC",
    "dropphyzpp": 278479414,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELFORD",
    "dropmalst": "NC",
    "dropmalzpp": 278479998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523442161,
    "dropfax": 2523442161
  },
  {
    "dcode": "D",
    "dropkey": "PY15665",
    "droptype": "D",
    "dropname": "KELLY",
    "dropdeladd": "18529 NC HIGHWAY 53 E",
    "dropdelcty": "KELLY",
    "dropdelst": "NC",
    "dropdelzpp": 284488407,
    "dropphyadd": "18529 NC HIGHWAY 53 E",
    "dropphycty": "KELLY",
    "dropphyst": "NC",
    "dropphyzpp": 284488407,
    "dropmaladd": "PO BOX 28448",
    "dropmalcty": "KELLY",
    "dropmalst": "NC",
    "dropmalzpp": 284489998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106692893,
    "dropsitcph": 9106692893,
    "dropfax": 9106693654
  },
  {
    "dcode": "D",
    "dropkey": "PY15666",
    "droptype": "D",
    "dropname": "KENANSVILLE",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "KENANSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283498966,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "KENANSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283498966,
    "dropmaladd": "PO BOX 28349",
    "dropmalcty": "KENANSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283499998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102960888,
    "dropsitcph": 9102960888,
    "dropfax": 9102960469
  },
  {
    "dcode": "D",
    "dropkey": "PY15669",
    "droptype": "D",
    "dropname": "KENLY",
    "dropdeladd": "102 N GARDNER AVE",
    "dropdelcty": "KENLY",
    "dropdelst": "NC",
    "dropdelzpp": 275429998,
    "dropphyadd": "102 N GARDNER AVE",
    "dropphycty": "KENLY",
    "dropphyst": "NC",
    "dropphyzpp": 275429998,
    "dropmaladd": "102 N GARDNER AVE",
    "dropmalcty": "KENLY",
    "dropmalst": "NC",
    "dropmalzpp": 275429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192843810,
    "dropfax": 9192844043
  },
  {
    "dcode": "D",
    "dropkey": "PY15672",
    "droptype": "D",
    "dropname": "KERNERSVILLE",
    "dropdeladd": "325 W MOUNTAIN ST",
    "dropdelcty": "KERNERSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 272843490,
    "dropphyadd": "325 W MOUNTAIN ST",
    "dropphycty": "KERNERSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 272843490,
    "dropmaladd": "325 W MOUNTAIN ST",
    "dropmalcty": "KERNERSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 272849998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369937362,
    "dropfax": 3369965771
  },
  {
    "dcode": "D",
    "dropkey": "PY15677",
    "droptype": "D",
    "dropname": "KILL DEVIL HILLS",
    "dropdeladd": "302 S CROATAN HWY",
    "dropdelcty": "KILL DEVIL HILLS",
    "dropdelst": "NC",
    "dropdelzpp": 279489998,
    "dropphyadd": "302 S CROATAN HWY",
    "dropphycty": "KILL DEVIL HILLS",
    "dropphyst": "NC",
    "dropphyzpp": 279489998,
    "dropmaladd": "302 S CROATAN HWY",
    "dropmalcty": "KILL DEVIL HILLS",
    "dropmalst": "NC",
    "dropmalzpp": 279489998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524415666,
    "dropfax": 2524417161
  },
  {
    "dcode": "D",
    "dropkey": "PY15680",
    "droptype": "D",
    "dropname": "KING",
    "dropdeladd": "603 S MAIN ST",
    "dropdelcty": "KING",
    "dropdelst": "NC",
    "dropdelzpp": 270219998,
    "dropphyadd": "603 S MAIN ST",
    "dropphycty": "KING",
    "dropphyst": "NC",
    "dropphyzpp": 270219998,
    "dropmaladd": "603 S MAIN ST",
    "dropmalcty": "KING",
    "dropmalst": "NC",
    "dropmalzpp": 270219998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369833596,
    "dropfax": 3369839092
  },
  {
    "dcode": "D",
    "dropkey": "PY15682",
    "droptype": "D",
    "dropname": "KINGS MOUNTAIN",
    "dropdeladd": "115 E GOLD ST",
    "dropdelcty": "KINGS MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 280863431,
    "dropphyadd": "115 E GOLD ST",
    "dropphycty": "KINGS MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 280863431,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGS MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 280869998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047396138,
    "dropsitcph": 7047396138,
    "dropfax": 7047345469
  },
  {
    "dcode": "D",
    "dropkey": "PY15687",
    "droptype": "D",
    "dropname": "KINSTON",
    "dropdeladd": "208 E CASWELL ST",
    "dropdelcty": "KINSTON",
    "dropdelst": "NC",
    "dropdelzpp": 285014995,
    "dropphyadd": "208 E CASWELL ST",
    "dropphycty": "KINSTON",
    "dropphyst": "NC",
    "dropphyzpp": 285014995,
    "dropmaladd": "PO BOX 28502",
    "dropmalcty": "KINSTON",
    "dropmalst": "NC",
    "dropmalzpp": 285029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525264016,
    "dropsitcph": 2525264016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15688",
    "droptype": "D",
    "dropname": "KIPLING",
    "dropdeladd": "34 NEILL SMITH RD",
    "dropdelcty": "KIPLING",
    "dropdelst": "NC",
    "dropdelzpp": 275439998,
    "dropphyadd": "34 NEILL SMITH RD",
    "dropphycty": "KIPLING",
    "dropphyst": "NC",
    "dropphyzpp": 275439998,
    "dropmaladd": "34 NEILL SMITH RD",
    "dropmalcty": "KIPLING",
    "dropmalst": "NC",
    "dropmalzpp": 275439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195523120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15689",
    "droptype": "D",
    "dropname": "KITTRELL",
    "dropdeladd": "1400 US HIGHWAY 1 S",
    "dropdelcty": "KITTRELL",
    "dropdelst": "NC",
    "dropdelzpp": 275449998,
    "dropphyadd": "1400 US HIGHWAY 1 S",
    "dropphycty": "KITTRELL",
    "dropphyst": "NC",
    "dropphyzpp": 275449998,
    "dropmaladd": "1400 US HIGHWAY 1 S",
    "dropmalcty": "KITTRELL",
    "dropmalst": "NC",
    "dropmalzpp": 275449998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524386891,
    "dropfax": 2524381794
  },
  {
    "dcode": "D",
    "dropkey": "PY15690",
    "droptype": "D",
    "dropname": "KITTY HAWK",
    "dropdeladd": "3841 N CROATAN HWY",
    "dropdelcty": "KITTY HAWK",
    "dropdelst": "NC",
    "dropdelzpp": 279499238,
    "dropphyadd": "3841 N CROATAN HWY",
    "dropphycty": "KITTY HAWK",
    "dropphyst": "NC",
    "dropphyzpp": 279499238,
    "dropmaladd": "3841 N CROATAN HWY",
    "dropmalcty": "KITTY HAWK",
    "dropmalst": "NC",
    "dropmalzpp": 279499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 2524205175,
    "dropsitcph": 2522612211,
    "dropfax": 2522611844
  },
  {
    "dcode": "D",
    "dropkey": "PY15691",
    "droptype": "D",
    "dropname": "KNIGHTDALE",
    "dropdeladd": "1003 MULFORD CT",
    "dropdelcty": "KNIGHTDALE",
    "dropdelst": "NC",
    "dropdelzpp": 275459998,
    "dropphyadd": "1003 MULFORD CT",
    "dropphycty": "KNIGHTDALE",
    "dropphyst": "NC",
    "dropphyzpp": 275459998,
    "dropmaladd": "1003 MULFORD CT",
    "dropmalcty": "KNIGHTDALE",
    "dropmalst": "NC",
    "dropmalzpp": 275459998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192664158,
    "dropfax": 9192179137
  },
  {
    "dcode": "D",
    "dropkey": "PY15693",
    "droptype": "D",
    "dropname": "KNOTTS ISLAND",
    "dropdeladd": "407 KNOTTS ISLAND RD",
    "dropdelcty": "KNOTTS ISLAND",
    "dropdelst": "NC",
    "dropdelzpp": 279509998,
    "dropphyadd": "407 KNOTTS ISLAND RD",
    "dropphycty": "KNOTTS ISLAND",
    "dropphyst": "NC",
    "dropphyzpp": 279509998,
    "dropmaladd": "407 KNOTTS ISLAND RD",
    "dropmalcty": "KNOTTS ISLAND",
    "dropmalst": "NC",
    "dropmalzpp": 279509998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524293252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15695",
    "droptype": "D",
    "dropname": "KURE BEACH",
    "dropdeladd": "237 FORT FISHER BLVD N",
    "dropdelcty": "KURE BEACH",
    "dropdelst": "NC",
    "dropdelzpp": 284494876,
    "dropphyadd": "237 FORT FISHER BLVD N",
    "dropphycty": "KURE BEACH",
    "dropphyst": "NC",
    "dropphyzpp": 284494876,
    "dropmaladd": "PO BOX 28449",
    "dropmalcty": "KURE BEACH",
    "dropmalst": "NC",
    "dropmalzpp": 284499998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104585592,
    "dropsitcph": 9104585592,
    "dropfax": 9104585592
  },
  {
    "dcode": "D",
    "dropkey": "PY15696",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "209 S CASWELL ST",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "NC",
    "dropdelzpp": 285511709,
    "dropphyadd": "209 S CASWELL ST",
    "dropphycty": "LA GRANGE",
    "dropphyst": "NC",
    "dropphyzpp": 285511709,
    "dropmaladd": "PO BOX 28551",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "NC",
    "dropmalzpp": 285519998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525663196,
    "dropsitcph": 2525663196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15701",
    "droptype": "D",
    "dropname": "LAKE JUNALUSKA",
    "dropdeladd": "60 OLD CLYDE RD",
    "dropdelcty": "LAKE JUNALUSKA",
    "dropdelst": "NC",
    "dropdelzpp": 287458764,
    "dropphyadd": "60 OLD CLYDE RD",
    "dropphycty": "LAKE JUNALUSKA",
    "dropphyst": "NC",
    "dropphyzpp": 287458764,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE JUNALUSKA",
    "dropmalst": "NC",
    "dropmalzpp": 287459998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284524808,
    "dropsitcph": 8284524808,
    "dropfax": 8284526059
  },
  {
    "dcode": "D",
    "dropkey": "PY15702",
    "droptype": "D",
    "dropname": "LAKE LURE",
    "dropdeladd": "2432 MEMORIAL HWY",
    "dropdelcty": "LAKE LURE",
    "dropdelst": "NC",
    "dropdelzpp": 287469005,
    "dropphyadd": "2432 MEMORIAL HWY",
    "dropphycty": "LAKE LURE",
    "dropphyst": "NC",
    "dropphyzpp": 287469005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE LURE",
    "dropmalst": "NC",
    "dropmalzpp": 287469998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286254711,
    "dropsitcph": 8286254711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15703",
    "droptype": "D",
    "dropname": "LAKE TOXAWAY",
    "dropdeladd": "1320 BLUE RIDGE RD",
    "dropdelcty": "LAKE TOXAWAY",
    "dropdelst": "NC",
    "dropdelzpp": 287478732,
    "dropphyadd": "1320 BLUE RIDGE RD",
    "dropphycty": "LAKE TOXAWAY",
    "dropphyst": "NC",
    "dropphyzpp": 287478732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE TOXAWAY",
    "dropmalst": "NC",
    "dropmalzpp": 287479998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8289664281,
    "dropsitcph": 8289664281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15704",
    "droptype": "D",
    "dropname": "LAKE WACCAMAW",
    "dropdeladd": "103 CHAUNCEY TOWN RD",
    "dropdelcty": "LAKE WACCAMAW",
    "dropdelst": "NC",
    "dropdelzpp": 284502001,
    "dropphyadd": "103 CHAUNCEY TOWN RD",
    "dropphycty": "LAKE WACCAMAW",
    "dropphyst": "NC",
    "dropphyzpp": 284502001,
    "dropmaladd": "PO BOX 28450",
    "dropmalcty": "LAKE WACCAMAW",
    "dropmalst": "NC",
    "dropmalzpp": 284509998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106463501,
    "dropsitcph": 9106463501,
    "dropfax": 9106461427
  },
  {
    "dcode": "D",
    "dropkey": "PY15707",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "278 CAMP EASTER RD",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "NC",
    "dropdelzpp": 283508900,
    "dropphyadd": "278 CAMP EASTER RD",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "NC",
    "dropphyzpp": 283508900,
    "dropmaladd": "PO BOX 28350",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "NC",
    "dropmalzpp": 283509998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102454411,
    "dropsitcph": 9102454411,
    "dropfax": 9102454411
  },
  {
    "dcode": "D",
    "dropkey": "PY15708",
    "droptype": "D",
    "dropname": "LANDIS",
    "dropdeladd": "230 E RYDER AVE",
    "dropdelcty": "LANDIS",
    "dropdelst": "NC",
    "dropdelzpp": 280881440,
    "dropphyadd": "230 E RYDER AVE",
    "dropphycty": "LANDIS",
    "dropphyst": "NC",
    "dropphyzpp": 280881440,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANDIS",
    "dropmalst": "NC",
    "dropmalzpp": 280889998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048579817,
    "dropsitcph": 7048579817,
    "dropfax": 7048558355
  },
  {
    "dcode": "D",
    "dropkey": "PY15709",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "9294 NC HIGHWAY 194 N",
    "dropdelcty": "LANSING",
    "dropdelst": "NC",
    "dropdelzpp": 286439550,
    "dropphyadd": "9294 NC HIGHWAY 194 N",
    "dropphycty": "LANSING",
    "dropphyst": "NC",
    "dropphyzpp": 286439550,
    "dropmaladd": "9294 NC HIGHWAY 194 N",
    "dropmalcty": "LANSING",
    "dropmalst": "NC",
    "dropmalzpp": 286439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363843314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15712",
    "droptype": "D",
    "dropname": "LATTIMORE",
    "dropdeladd": "306 E MAIN ST",
    "dropdelcty": "LATTIMORE",
    "dropdelst": "NC",
    "dropdelzpp": 280899700,
    "dropphyadd": "306 E MAIN ST",
    "dropphycty": "LATTIMORE",
    "dropphyst": "NC",
    "dropphyzpp": 280899700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LATTIMORE",
    "dropmalst": "NC",
    "dropmalzpp": 280899998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044342901,
    "dropsitcph": 7044342901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15714",
    "droptype": "D",
    "dropname": "LAUREL HILL",
    "dropdeladd": "9140 MORGAN ST",
    "dropdelcty": "LAUREL HILL",
    "dropdelst": "NC",
    "dropdelzpp": 283519304,
    "dropphyadd": "9140 MORGAN ST",
    "dropphycty": "LAUREL HILL",
    "dropphyst": "NC",
    "dropphyzpp": 283519304,
    "dropmaladd": "PO BOX 28351",
    "dropmalcty": "LAUREL HILL",
    "dropmalst": "NC",
    "dropmalzpp": 283519998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104623342,
    "dropsitcph": 9104623342,
    "dropfax": 9104623342
  },
  {
    "dcode": "D",
    "dropkey": "PY15718",
    "droptype": "D",
    "dropname": "LAUREL SPRINGS",
    "dropdeladd": "12533 NC HIGHWAY 18 S",
    "dropdelcty": "LAUREL SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 286449276,
    "dropphyadd": "12533 NC HIGHWAY 18 S",
    "dropphycty": "LAUREL SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 286449276,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUREL SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 286449998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363592417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15719",
    "droptype": "D",
    "dropname": "LAURINBURG",
    "dropdeladd": "109 S GILL ST",
    "dropdelcty": "LAURINBURG",
    "dropdelst": "NC",
    "dropdelzpp": 283523613,
    "dropphyadd": "109 S GILL ST",
    "dropphycty": "LAURINBURG",
    "dropphyst": "NC",
    "dropphyzpp": 283523613,
    "dropmaladd": "PO BOX 28352",
    "dropmalcty": "LAURINBURG",
    "dropmalst": "NC",
    "dropmalzpp": 283529998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102763518,
    "dropsitcph": 9102763518,
    "dropfax": 9102768274
  },
  {
    "dcode": "D",
    "dropkey": "PY15720",
    "droptype": "D",
    "dropname": "LAWNDALE",
    "dropdeladd": "241 E MAIN ST",
    "dropdelcty": "LAWNDALE",
    "dropdelst": "NC",
    "dropdelzpp": 280909644,
    "dropphyadd": "241 E MAIN ST",
    "dropphycty": "LAWNDALE",
    "dropphyst": "NC",
    "dropphyzpp": 280909644,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWNDALE",
    "dropmalst": "NC",
    "dropmalzpp": 280909998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045387281,
    "dropsitcph": 7045387281,
    "dropfax": 7045385404
  },
  {
    "dcode": "D",
    "dropkey": "PY15721",
    "droptype": "D",
    "dropname": "LAWSONVILLE",
    "dropdeladd": "3471 PINEY GROVE CHURCH RD",
    "dropdelcty": "LAWSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270229998,
    "dropphyadd": "3471 PINEY GROVE CHURCH RD",
    "dropphycty": "LAWSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270229998,
    "dropmaladd": "3471 PINEY GROVE CHURCH RD",
    "dropmalcty": "LAWSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270229998,
    "dropsitphn": 3363781463,
    "dropsitlph": 3362715587,
    "dropsitcph": 3365938754,
    "dropfax": 3362715520
  },
  {
    "dcode": "D",
    "dropkey": "PY15728",
    "droptype": "D",
    "dropname": "LEASBURG",
    "dropdeladd": "7330 US HIGHWAY 158 E",
    "dropdelcty": "LEASBURG",
    "dropdelst": "NC",
    "dropdelzpp": 272919277,
    "dropphyadd": "7330 US HIGHWAY 158 E",
    "dropphycty": "LEASBURG",
    "dropphyst": "NC",
    "dropphyzpp": 272919277,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEASBURG",
    "dropmalst": "NC",
    "dropmalzpp": 272919998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365998520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15730",
    "droptype": "D",
    "dropname": "LEICESTER",
    "dropdeladd": "2520 NEW LEICESTER HWY",
    "dropdelcty": "LEICESTER",
    "dropdelst": "NC",
    "dropdelzpp": 287485179,
    "dropphyadd": "2520 NEW LEICESTER HWY",
    "dropphycty": "LEICESTER",
    "dropphyst": "NC",
    "dropphyzpp": 287485179,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEICESTER",
    "dropmalst": "NC",
    "dropmalzpp": 287489998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286833181,
    "dropsitcph": 8286833181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15732",
    "droptype": "D",
    "dropname": "LELAND",
    "dropdeladd": "1123 VILLAGE RD NE",
    "dropdelcty": "LELAND",
    "dropdelst": "NC",
    "dropdelzpp": 284518479,
    "dropphyadd": "1123 VILLAGE RD NE",
    "dropphycty": "LELAND",
    "dropphyst": "NC",
    "dropphyzpp": 284518479,
    "dropmaladd": "PO BOX 28451",
    "dropmalcty": "LELAND",
    "dropmalst": "NC",
    "dropmalzpp": 284519998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103830922,
    "dropsitcph": 9103830922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15735",
    "droptype": "D",
    "dropname": "LEMON SPRINGS",
    "dropdeladd": "7246 LEMON SPRINGS RD",
    "dropdelcty": "LEMON SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 283558902,
    "dropphyadd": "7246 LEMON SPRINGS RD",
    "dropphycty": "LEMON SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 283558902,
    "dropmaladd": "PO BOX 28355",
    "dropmalcty": "LEMON SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 283559998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9197761833,
    "dropsitcph": 9197761833,
    "dropfax": 9197761833
  },
  {
    "dcode": "D",
    "dropkey": "PY15736",
    "droptype": "D",
    "dropname": "LENOIR",
    "dropdeladd": "114 RIDGE ST NW",
    "dropdelcty": "LENOIR",
    "dropdelst": "NC",
    "dropdelzpp": 286455200,
    "dropphyadd": "114 RIDGE ST NW",
    "dropphycty": "LENOIR",
    "dropphyst": "NC",
    "dropphyzpp": 286455200,
    "dropmaladd": "114 RIDGE ST NW",
    "dropmalcty": "LENOIR",
    "dropmalst": "NC",
    "dropmalzpp": 286459998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287549053,
    "dropfax": 8287543026
  },
  {
    "dcode": "D",
    "dropkey": "PY15742",
    "droptype": "D",
    "dropname": "LEWISTON WOODVILLE",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "LEWISTON WOODVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278499588,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "LEWISTON WOODVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278499588,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISTON WOODVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523482820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15743",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "7011 GREAT WAGON RD",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270239997,
    "dropphyadd": "7011 GREAT WAGON RD",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270239997,
    "dropmaladd": "7011 GREAT WAGON RD",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270239997,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369452816,
    "dropfax": 3369456134
  },
  {
    "dcode": "D",
    "dropkey": "PY15748",
    "droptype": "D",
    "dropname": "LEXINGTON",
    "dropdeladd": "110 N STATE ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 272921000,
    "dropphyadd": "110 N STATE ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 272921000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 272929998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362494504,
    "dropfax": 3362491596
  },
  {
    "dcode": "D",
    "dropkey": "PY15750",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "416 W SWANNANOA AVE",
    "dropdelcty": "LIBERTY",
    "dropdelst": "NC",
    "dropdelzpp": 272983133,
    "dropphyadd": "416 W SWANNANOA AVE",
    "dropphycty": "LIBERTY",
    "dropphyst": "NC",
    "dropphyzpp": 272983133,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIBERTY",
    "dropmalst": "NC",
    "dropmalzpp": 272989998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366220459,
    "dropfax": 3366220089
  },
  {
    "dcode": "D",
    "dropkey": "PY15752",
    "droptype": "D",
    "dropname": "LILESVILLE",
    "dropdeladd": "103 E WALL ST",
    "dropdelcty": "LILESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 280919776,
    "dropphyadd": "103 E WALL ST",
    "dropphycty": "LILESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 280919776,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LILESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 280919998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048484708,
    "dropsitcph": 7048484708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15755",
    "droptype": "D",
    "dropname": "LILLINGTON",
    "dropdeladd": "901 S 8TH ST",
    "dropdelcty": "LILLINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 275469998,
    "dropphyadd": "901 S 8TH ST",
    "dropphycty": "LILLINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 275469998,
    "dropmaladd": "901 S 8TH ST",
    "dropmalcty": "LILLINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 275469998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9108939478,
    "dropfax": 9108143532
  },
  {
    "dcode": "D",
    "dropkey": "PY15757",
    "droptype": "D",
    "dropname": "LINCOLNTON",
    "dropdeladd": "326 E MAIN ST",
    "dropdelcty": "LINCOLNTON",
    "dropdelst": "NC",
    "dropdelzpp": 280923335,
    "dropphyadd": "326 E MAIN ST",
    "dropphycty": "LINCOLNTON",
    "dropphyst": "NC",
    "dropphyzpp": 280923335,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLNTON",
    "dropmalst": "NC",
    "dropmalzpp": 280939998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047322592,
    "dropsitcph": 7047322592,
    "dropfax": 7047357814
  },
  {
    "dcode": "D",
    "dropkey": "PY15759",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "4764 MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "NC",
    "dropdelzpp": 283569701,
    "dropphyadd": "4764 MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "NC",
    "dropphyzpp": 283569701,
    "dropmaladd": "PO BOX 28356",
    "dropmalcty": "LINDEN",
    "dropmalst": "NC",
    "dropmalzpp": 283569998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9109800127,
    "dropsitcph": 9109800127,
    "dropfax": 9109800127
  },
  {
    "dcode": "D",
    "dropkey": "PY15760",
    "droptype": "D",
    "dropname": "LINVILLE",
    "dropdeladd": "4235 MITCHELL AVE",
    "dropdelcty": "LINVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286469800,
    "dropphyadd": "4235 MITCHELL AVE",
    "dropphycty": "LINVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286469998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287335745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15761",
    "droptype": "D",
    "dropname": "LINVILLE FALLS",
    "dropdeladd": "8890 NC HIGHWAY 183",
    "dropdelcty": "LINVILLE FALLS",
    "dropdelst": "NC",
    "dropdelzpp": 286479800,
    "dropphyadd": "8890 NC HIGHWAY 183",
    "dropphycty": "LINVILLE FALLS",
    "dropphyst": "NC",
    "dropphyzpp": 286479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINVILLE FALLS",
    "dropmalst": "NC",
    "dropmalzpp": 286479998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287657788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15770",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "4276 OLD LINWOOD RD",
    "dropdelcty": "LINWOOD",
    "dropdelst": "NC",
    "dropdelzpp": 272999800,
    "dropphyadd": "4276 OLD LINWOOD RD",
    "dropphycty": "LINWOOD",
    "dropphyst": "NC",
    "dropphyzpp": 272999800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINWOOD",
    "dropmalst": "NC",
    "dropmalzpp": 272999998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369568802,
    "dropfax": 3369562884
  },
  {
    "dcode": "D",
    "dropkey": "PY15773",
    "droptype": "D",
    "dropname": "LITTLE SWITZERLAND",
    "dropdeladd": "9455 HIGHWAY 226A",
    "dropdelcty": "LITTLE SWITZERLAND",
    "dropdelst": "NC",
    "dropdelzpp": 287499100,
    "dropphyadd": "9455 HIGHWAY 226A",
    "dropphycty": "LITTLE SWITZERLAND",
    "dropphyst": "NC",
    "dropphyzpp": 287499100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE SWITZERLAND",
    "dropmalst": "NC",
    "dropmalzpp": 287499998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287652055,
    "dropsitcph": 8287652055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15775",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "109 MOSBY AVE",
    "dropdelcty": "LITTLETON",
    "dropdelst": "NC",
    "dropdelzpp": 278509998,
    "dropphyadd": "109 MOSBY AVE",
    "dropphycty": "LITTLETON",
    "dropphyst": "NC",
    "dropphyzpp": 278509998,
    "dropmaladd": "109 MOSBY AVE",
    "dropmalcty": "LITTLETON",
    "dropmalst": "NC",
    "dropmalzpp": 278509998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525864463,
    "dropfax": 2525867696
  },
  {
    "dcode": "D",
    "dropkey": "PY15780",
    "droptype": "D",
    "dropname": "LOCUST",
    "dropdeladd": "206 MAIN ST W",
    "dropdelcty": "LOCUST",
    "dropdelst": "NC",
    "dropdelzpp": 280979703,
    "dropphyadd": "206 MAIN ST W",
    "dropphycty": "LOCUST",
    "dropphyst": "NC",
    "dropphyzpp": 280979703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCUST",
    "dropmalst": "NC",
    "dropmalzpp": 280979998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048886790,
    "dropsitcph": 7048886790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15793",
    "droptype": "D",
    "dropname": "LONGWOOD",
    "dropdeladd": "2165 LONGWOOD RD NW",
    "dropdelcty": "LONGWOOD",
    "dropdelst": "NC",
    "dropdelzpp": 284529763,
    "dropphyadd": "2165 LONGWOOD RD NW",
    "dropphycty": "LONGWOOD",
    "dropphyst": "NC",
    "dropphyzpp": 284529763,
    "dropmaladd": "PO BOX 28452",
    "dropmalcty": "LONGWOOD",
    "dropmalst": "NC",
    "dropmalzpp": 284529998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102876440,
    "dropsitcph": 9102876440,
    "dropfax": 9102876047
  },
  {
    "dcode": "D",
    "dropkey": "PY15795",
    "droptype": "D",
    "dropname": "LOUISBURG",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "LOUISBURG",
    "dropdelst": "NC",
    "dropdelzpp": 275499998,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "LOUISBURG",
    "dropphyst": "NC",
    "dropphyzpp": 275499998,
    "dropmaladd": "125 N MAIN ST",
    "dropmalcty": "LOUISBURG",
    "dropmalst": "NC",
    "dropmalzpp": 275499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194961084,
    "dropfax": 9194961186
  },
  {
    "dcode": "D",
    "dropkey": "PY15798",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "206 E 1ST ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "NC",
    "dropdelzpp": 280981575,
    "dropphyadd": "206 E 1ST ST",
    "dropphycty": "LOWELL",
    "dropphyst": "NC",
    "dropphyzpp": 280981575,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWELL",
    "dropmalst": "NC",
    "dropmalzpp": 280989998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048241101,
    "dropsitcph": 7048241101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15802",
    "droptype": "D",
    "dropname": "LOWGAP",
    "dropdeladd": "8855 W PINE ST",
    "dropdelcty": "LOWGAP",
    "dropdelst": "NC",
    "dropdelzpp": 270249998,
    "dropphyadd": "8855 W PINE ST",
    "dropphycty": "LOWGAP",
    "dropphyst": "NC",
    "dropphyzpp": 270249998,
    "dropmaladd": "8855 W PINE ST",
    "dropmalcty": "LOWGAP",
    "dropmalst": "NC",
    "dropmalzpp": 270249998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363524759,
    "dropfax": 3363524759
  },
  {
    "dcode": "D",
    "dropkey": "PY15805",
    "droptype": "D",
    "dropname": "LUCAMA",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "LUCAMA",
    "dropdelst": "NC",
    "dropdelzpp": 278519998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "LUCAMA",
    "dropphyst": "NC",
    "dropphyzpp": 278519998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "LUCAMA",
    "dropmalst": "NC",
    "dropmalzpp": 278519998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522390210,
    "dropfax": 2522396518
  },
  {
    "dcode": "D",
    "dropkey": "PY15809",
    "droptype": "D",
    "dropname": "LUMBER BRIDGE",
    "dropdeladd": "104 S FAYETTEVILLE ST",
    "dropdelcty": "LUMBER BRIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 283578778,
    "dropphyadd": "104 S FAYETTEVILLE ST",
    "dropphycty": "LUMBER BRIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 283578778,
    "dropmaladd": "PO BOX 28357",
    "dropmalcty": "LUMBER BRIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 283579998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108434454,
    "dropsitcph": 9108434454,
    "dropfax": 9108434454
  },
  {
    "dcode": "D",
    "dropkey": "PY15810",
    "droptype": "D",
    "dropname": "LUMBERTON",
    "dropdeladd": "301 E 7TH ST",
    "dropdelcty": "LUMBERTON",
    "dropdelst": "NC",
    "dropdelzpp": 283584837,
    "dropphyadd": "301 E 7TH ST",
    "dropphycty": "LUMBERTON",
    "dropphyst": "NC",
    "dropphyzpp": 283584837,
    "dropmaladd": "PO BOX 28358",
    "dropmalcty": "LUMBERTON",
    "dropmalst": "NC",
    "dropmalzpp": 283589998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9107394355,
    "dropsitcph": 9107394355,
    "dropfax": 9107388858
  },
  {
    "dcode": "D",
    "dropkey": "PY15812",
    "droptype": "D",
    "dropname": "LYNN",
    "dropdeladd": "2633 LYNN RD",
    "dropdelcty": "LYNN",
    "dropdelst": "NC",
    "dropdelzpp": 287505001,
    "dropphyadd": "2633 LYNN RD",
    "dropphycty": "LYNN",
    "dropphyst": "NC",
    "dropphyzpp": 287505001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNN",
    "dropmalst": "NC",
    "dropmalzpp": 287509998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288595111,
    "dropsitcph": 8288595111,
    "dropfax": 8288595111
  },
  {
    "dcode": "D",
    "dropkey": "PY15814",
    "droptype": "D",
    "dropname": "MACCLESFIELD",
    "dropdeladd": "115 W EDGECOMBE ST",
    "dropdelcty": "MACCLESFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 278529998,
    "dropphyadd": "115 W EDGECOMBE ST",
    "dropphycty": "MACCLESFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 278529998,
    "dropmaladd": "115 W EDGECOMBE ST",
    "dropmalcty": "MACCLESFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 278529998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528275300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15816",
    "droptype": "D",
    "dropname": "MACON",
    "dropdeladd": "1608 US HIGHWAY 158 E",
    "dropdelcty": "MACON",
    "dropdelst": "NC",
    "dropdelzpp": 275519998,
    "dropphyadd": "1608 US HIGHWAY 158 E",
    "dropphycty": "MACON",
    "dropphyst": "NC",
    "dropphyzpp": 275519998,
    "dropmaladd": "1608 US HIGHWAY 158 E",
    "dropmalcty": "MACON",
    "dropmalst": "NC",
    "dropmalzpp": 275519998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522573214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15817",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "302 HIGHWAY ST STE 195",
    "dropdelcty": "MADISON",
    "dropdelst": "NC",
    "dropdelzpp": 270251673,
    "dropphyadd": "302 HIGHWAY ST STE 195",
    "dropphycty": "MADISON",
    "dropphyst": "NC",
    "dropphyzpp": 270251673,
    "dropmaladd": "302 HIGHWAY ST STE 195",
    "dropmalcty": "MADISON",
    "dropmalst": "NC",
    "dropmalzpp": 270259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365482059,
    "dropfax": 3365484874
  },
  {
    "dcode": "D",
    "dropkey": "PY15818",
    "droptype": "D",
    "dropname": "MAGGIE VALLEY",
    "dropdeladd": "4280 SOCO RD",
    "dropdelcty": "MAGGIE VALLEY",
    "dropdelst": "NC",
    "dropdelzpp": 287519599,
    "dropphyadd": "4280 SOCO RD",
    "dropphycty": "MAGGIE VALLEY",
    "dropphyst": "NC",
    "dropphyzpp": 287519599,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGGIE VALLEY",
    "dropmalst": "NC",
    "dropmalzpp": 287519998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8289260679,
    "dropsitcph": 8289260679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15820",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "215 E MAIN ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "NC",
    "dropdelzpp": 284535000,
    "dropphyadd": "215 E MAIN ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "NC",
    "dropphyzpp": 284535000,
    "dropmaladd": "PO BOX 28453",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "NC",
    "dropmalzpp": 284539998,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 9102906014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15823",
    "droptype": "D",
    "dropname": "MAIDEN",
    "dropdeladd": "512 ISLAND FORD RD",
    "dropdelcty": "MAIDEN",
    "dropdelst": "NC",
    "dropdelzpp": 286508799,
    "dropphyadd": "512 ISLAND FORD RD",
    "dropphycty": "MAIDEN",
    "dropphyst": "NC",
    "dropphyzpp": 286508799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAIDEN",
    "dropmalst": "NC",
    "dropmalzpp": 286509998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284288609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15824",
    "droptype": "D",
    "dropname": "MAMERS",
    "dropdeladd": "61 MAMERS RD",
    "dropdelcty": "MAMERS",
    "dropdelst": "NC",
    "dropdelzpp": 275529998,
    "dropphyadd": "61 MAMERS RD",
    "dropphycty": "MAMERS",
    "dropphyst": "NC",
    "dropphyzpp": 275529998,
    "dropmaladd": "61 MAMERS RD",
    "dropmalcty": "MAMERS",
    "dropmalst": "NC",
    "dropmalzpp": 275529998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9108935951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15825",
    "droptype": "D",
    "dropname": "MANNS HARBOR",
    "dropdeladd": "6941 US HIGHWAY 64",
    "dropdelcty": "MANNS HARBOR",
    "dropdelst": "NC",
    "dropdelzpp": 279539998,
    "dropphyadd": "6941 US HIGHWAY 64",
    "dropphycty": "MANNS HARBOR",
    "dropphyst": "NC",
    "dropphyzpp": 279539998,
    "dropmaladd": "6941 US HIGHWAY 64",
    "dropmalcty": "MANNS HARBOR",
    "dropmalst": "NC",
    "dropmalzpp": 279539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524733677,
    "dropfax": 2524736342
  },
  {
    "dcode": "D",
    "dropkey": "PY15828",
    "droptype": "D",
    "dropname": "MANSON",
    "dropdeladd": "1402 US HIGHWAY 1 S",
    "dropdelcty": "MANSON",
    "dropdelst": "NC",
    "dropdelzpp": 275539998,
    "dropphyadd": "1402 US HIGHWAY 1 S",
    "dropphycty": "MANSON",
    "dropphyst": "NC",
    "dropphyzpp": 275539998,
    "dropmaladd": "1402 US HIGHWAY 1 S",
    "dropmalcty": "MANSON",
    "dropmalst": "NC",
    "dropmalzpp": 275539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524562363,
    "dropfax": 2524562363
  },
  {
    "dcode": "D",
    "dropkey": "PY15829",
    "droptype": "D",
    "dropname": "MANTEO",
    "dropdeladd": "212B US HIGHWAY 64 AND 264",
    "dropdelcty": "MANTEO",
    "dropdelst": "NC",
    "dropdelzpp": 279549998,
    "dropphyadd": "212B US HIGHWAY 64 AND 264",
    "dropphycty": "MANTEO",
    "dropphyst": "NC",
    "dropphyzpp": 279549998,
    "dropmaladd": "212B US HIGHWAY 64 AND 264",
    "dropmalcty": "MANTEO",
    "dropmalst": "NC",
    "dropmalzpp": 279549998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524732534,
    "dropfax": 2524736376
  },
  {
    "dcode": "D",
    "dropkey": "PY15830",
    "droptype": "D",
    "dropname": "MAPLE",
    "dropdeladd": "3452 CARATOKE HWY",
    "dropdelcty": "MAPLE",
    "dropdelst": "NC",
    "dropdelzpp": 279569998,
    "dropphyadd": "3452 CARATOKE HWY",
    "dropphycty": "MAPLE",
    "dropphyst": "NC",
    "dropphyzpp": 279569998,
    "dropmaladd": "3452 CARATOKE HWY",
    "dropmalcty": "MAPLE",
    "dropmalst": "NC",
    "dropmalzpp": 279569998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524538147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15831",
    "droptype": "D",
    "dropname": "MAPLE HILL",
    "dropdeladd": "545 MAPLE HILL SCHOOL RD",
    "dropdelcty": "MAPLE HILL",
    "dropdelst": "NC",
    "dropdelzpp": 284547617,
    "dropphyadd": "545 MAPLE HILL SCHOOL RD",
    "dropphycty": "MAPLE HILL",
    "dropphyst": "NC",
    "dropphyzpp": 284547617,
    "dropmaladd": "545 MAPLE HILL SCHOOL RD",
    "dropmalcty": "MAPLE HILL",
    "dropmalst": "NC",
    "dropmalzpp": 284547617,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102592228,
    "dropsitcph": 9102592228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15834",
    "droptype": "D",
    "dropname": "MARBLE",
    "dropdeladd": "189 MARBLE RD",
    "dropdelcty": "MARBLE",
    "dropdelst": "NC",
    "dropdelzpp": 289058732,
    "dropphyadd": "189 MARBLE RD",
    "dropphycty": "MARBLE",
    "dropphyst": "NC",
    "dropphyzpp": 289058732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARBLE",
    "dropmalst": "NC",
    "dropmalzpp": 289059998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288375604,
    "dropsitcph": 8288375604,
    "dropfax": 8288375604
  },
  {
    "dcode": "D",
    "dropkey": "PY15837",
    "droptype": "D",
    "dropname": "MARGARETTSVILLE",
    "dropdeladd": "2717 TOWER RD",
    "dropdelcty": "MARGARETTSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278539693,
    "dropphyadd": "2717 TOWER RD",
    "dropphycty": "MARGARETTSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278539693,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARGARETTSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525892151,
    "dropfax": 2525891598
  },
  {
    "dcode": "D",
    "dropkey": "PY15840",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "2733 MARIETTA RD",
    "dropdelcty": "MARIETTA",
    "dropdelst": "NC",
    "dropdelzpp": 283628901,
    "dropphyadd": "2733 MARIETTA RD",
    "dropphycty": "MARIETTA",
    "dropphyst": "NC",
    "dropphyzpp": 283628901,
    "dropmaladd": "PO BOX 28362",
    "dropmalcty": "MARIETTA",
    "dropmalst": "NC",
    "dropmalzpp": 283629998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106289742,
    "dropsitcph": 9106289742,
    "dropfax": 9106288599
  },
  {
    "dcode": "D",
    "dropkey": "PY15841",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "215 S MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "NC",
    "dropdelzpp": 287524524,
    "dropphyadd": "215 S MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "NC",
    "dropphyzpp": 287524524,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARION",
    "dropmalst": "NC",
    "dropmalzpp": 287529998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286525838,
    "dropsitcph": 8286525838,
    "dropfax": 8286598215
  },
  {
    "dcode": "D",
    "dropkey": "PY15843",
    "droptype": "D",
    "dropname": "MARS HILL",
    "dropdeladd": "65 S MAIN ST",
    "dropdelcty": "MARS HILL",
    "dropdelst": "NC",
    "dropdelzpp": 287546608,
    "dropphyadd": "65 S MAIN ST",
    "dropphycty": "MARS HILL",
    "dropphyst": "NC",
    "dropphyzpp": 287546608,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARS HILL",
    "dropmalst": "NC",
    "dropmalzpp": 287549998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286894141,
    "dropsitcph": 8286894141,
    "dropfax": 8286899331
  },
  {
    "dcode": "D",
    "dropkey": "PY15845",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "100 S MAIN ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "NC",
    "dropdelzpp": 287537479,
    "dropphyadd": "100 S MAIN ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "NC",
    "dropphyzpp": 287537479,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHALL",
    "dropmalst": "NC",
    "dropmalzpp": 287539998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286493133,
    "dropsitcph": 8286493133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15846",
    "droptype": "D",
    "dropname": "MARSHALLBERG",
    "dropdeladd": "1160 MARSHALLBERG RD",
    "dropdelcty": "MARSHALLBERG",
    "dropdelst": "NC",
    "dropdelzpp": 285539723,
    "dropphyadd": "1160 MARSHALLBERG RD",
    "dropphycty": "MARSHALLBERG",
    "dropphyst": "NC",
    "dropphyzpp": 285539723,
    "dropmaladd": "PO BOX 28553",
    "dropmalcty": "MARSHALLBERG",
    "dropmalst": "NC",
    "dropmalzpp": 285539998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527294491,
    "dropsitcph": 2527294491,
    "dropfax": 2527291248
  },
  {
    "dcode": "D",
    "dropkey": "PY15847",
    "droptype": "D",
    "dropname": "MARSHVILLE",
    "dropdeladd": "322 E UNION ST",
    "dropdelcty": "MARSHVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281031153,
    "dropphyadd": "322 E UNION ST",
    "dropphycty": "MARSHVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281031153,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281039998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046242059,
    "dropsitcph": 7046242059,
    "dropfax": 7046243175
  },
  {
    "dcode": "D",
    "dropkey": "PY15853",
    "droptype": "D",
    "dropname": "MATTHEWS",
    "dropdeladd": "301 E JOHN ST",
    "dropdelcty": "MATTHEWS",
    "dropdelst": "NC",
    "dropdelzpp": 281054837,
    "dropphyadd": "301 E JOHN ST",
    "dropphycty": "MATTHEWS",
    "dropphyst": "NC",
    "dropphyzpp": 281054837,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATTHEWS",
    "dropmalst": "NC",
    "dropmalzpp": 281059998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048476063,
    "dropsitcph": 7048476063,
    "dropfax": 7048411956
  },
  {
    "dcode": "D",
    "dropkey": "PY15855",
    "droptype": "D",
    "dropname": "MAURY",
    "dropdeladd": "3413 HIGHWAY 903 N",
    "dropdelcty": "MAURY",
    "dropdelst": "NC",
    "dropdelzpp": 285549800,
    "dropphyadd": "3413 HIGHWAY 903 N",
    "dropphycty": "MAURY",
    "dropphyst": "NC",
    "dropphyzpp": 285549800,
    "dropmaladd": "PO BOX 28554",
    "dropmalcty": "MAURY",
    "dropmalst": "NC",
    "dropmalzpp": 285549998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527475228,
    "dropsitcph": 2527475228,
    "dropfax": 2527475228
  },
  {
    "dcode": "D",
    "dropkey": "PY15856",
    "droptype": "D",
    "dropname": "MAXTON",
    "dropdeladd": "215 MCCASKILL AVE",
    "dropdelcty": "MAXTON",
    "dropdelst": "NC",
    "dropdelzpp": 283641827,
    "dropphyadd": "215 MCCASKILL AVE",
    "dropphycty": "MAXTON",
    "dropphyst": "NC",
    "dropphyzpp": 283641827,
    "dropmaladd": "PO BOX 28364",
    "dropmalcty": "MAXTON",
    "dropmalst": "NC",
    "dropmalzpp": 283649998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108443417,
    "dropsitcph": 9108443417,
    "dropfax": 9108449142
  },
  {
    "dcode": "D",
    "dropkey": "PY15859",
    "droptype": "D",
    "dropname": "MAYODAN",
    "dropdeladd": "1000 W MAIN ST",
    "dropdelcty": "MAYODAN",
    "dropdelst": "NC",
    "dropdelzpp": 270272532,
    "dropphyadd": "1000 W MAIN ST",
    "dropphycty": "MAYODAN",
    "dropphyst": "NC",
    "dropphyzpp": 270272532,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYODAN",
    "dropmalst": "NC",
    "dropmalzpp": 270279998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365482064,
    "dropfax": 3364273666
  },
  {
    "dcode": "D",
    "dropkey": "PY15860",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "1004 MAIN ST",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285555000,
    "dropphyadd": "1004 MAIN ST",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285555000,
    "dropmaladd": "PO BOX 28555",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285559998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9107436161,
    "dropsitcph": 9107436161,
    "dropfax": 9107432673
  },
  {
    "dcode": "D",
    "dropkey": "PY15865",
    "droptype": "D",
    "dropname": "MC ADENVILLE",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "MC ADENVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281019701,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "MC ADENVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281019701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC ADENVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281019998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048240915,
    "dropsitcph": 7048240915,
    "dropfax": 7048241695
  },
  {
    "dcode": "D",
    "dropkey": "PY15871",
    "droptype": "D",
    "dropname": "MC FARLAN",
    "dropdeladd": "12005 US HIGHWAY 52 S",
    "dropdelcty": "MC FARLAN",
    "dropdelst": "NC",
    "dropdelzpp": 281029800,
    "dropphyadd": "12005 US HIGHWAY 52 S",
    "dropphycty": "MC FARLAN",
    "dropphyst": "NC",
    "dropphyzpp": 281029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC FARLAN",
    "dropmalst": "NC",
    "dropmalzpp": 281029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048513158,
    "dropsitcph": 7048513158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15872",
    "droptype": "D",
    "dropname": "MC GRADY",
    "dropdeladd": "11532 SPARTA RD",
    "dropdelcty": "MC GRADY",
    "dropdelst": "NC",
    "dropdelzpp": 286499432,
    "dropphyadd": "11532 SPARTA RD",
    "dropphycty": "MC GRADY",
    "dropphyst": "NC",
    "dropphyzpp": 286499432,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GRADY",
    "dropmalst": "NC",
    "dropmalzpp": 286499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366702382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15873",
    "droptype": "D",
    "dropname": "MC LEANSVILLE",
    "dropdeladd": "5711 MCLEANSVILLE RD",
    "dropdelcty": "MC LEANSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 273019998,
    "dropphyadd": "5711 MCLEANSVILLE RD",
    "dropphycty": "MC LEANSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 273019998,
    "dropmaladd": "5711 MCLEANSVILLE RD",
    "dropmalcty": "MC LEANSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 273019998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366978926,
    "dropfax": 3366977641
  },
  {
    "dcode": "D",
    "dropkey": "PY15889",
    "droptype": "D",
    "dropname": "MEBANE",
    "dropdeladd": "100 VILLAGE DR",
    "dropdelcty": "MEBANE",
    "dropdelst": "NC",
    "dropdelzpp": 273029760,
    "dropphyadd": "100 VILLAGE DR",
    "dropphycty": "MEBANE",
    "dropphyst": "NC",
    "dropphyzpp": 273029760,
    "dropmaladd": "100 VILLAGE DR",
    "dropmalcty": "MEBANE",
    "dropmalst": "NC",
    "dropmalzpp": 273029998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9195684201,
    "dropfax": 9193044870
  },
  {
    "dcode": "D",
    "dropkey": "PY15890",
    "droptype": "D",
    "dropname": "MERRITT",
    "dropdeladd": "19686 NC HIGHWAY 55",
    "dropdelcty": "MERRITT",
    "dropdelst": "NC",
    "dropdelzpp": 285565000,
    "dropphyadd": "19686 NC HIGHWAY 55",
    "dropphycty": "MERRITT",
    "dropphyst": "NC",
    "dropphyzpp": 285565000,
    "dropmaladd": "PO BOX 28556",
    "dropmalcty": "MERRITT",
    "dropmalst": "NC",
    "dropmalzpp": 285569998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527454409,
    "dropsitcph": 2527454409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15891",
    "droptype": "D",
    "dropname": "MERRY HILL",
    "dropdeladd": "335 OLD MERRY HILL RD",
    "dropdelcty": "MERRY HILL",
    "dropdelst": "NC",
    "dropdelzpp": 279579998,
    "dropphyadd": "335 OLD MERRY HILL RD",
    "dropphycty": "MERRY HILL",
    "dropphyst": "NC",
    "dropphyzpp": 279579998,
    "dropmaladd": "335 OLD MERRY HILL RD",
    "dropmalcty": "MERRY HILL",
    "dropmalst": "NC",
    "dropmalzpp": 279579998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524823895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15896",
    "droptype": "D",
    "dropname": "MICAVILLE",
    "dropdeladd": "551 MICAVILLE LOOP",
    "dropdelcty": "MICAVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287558000,
    "dropphyadd": "551 MICAVILLE LOOP",
    "dropphycty": "MICAVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287558000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MICAVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287559998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286754813,
    "dropsitcph": 8286754813,
    "dropfax": 8286750001
  },
  {
    "dcode": "D",
    "dropkey": "PY15899",
    "droptype": "D",
    "dropname": "MICRO",
    "dropdeladd": "101 S RAILROAD ST",
    "dropdelcty": "MICRO",
    "dropdelst": "NC",
    "dropdelzpp": 275559998,
    "dropphyadd": "101 S RAILROAD ST",
    "dropphycty": "MICRO",
    "dropphyst": "NC",
    "dropphyzpp": 275559998,
    "dropmaladd": "101 S RAILROAD ST",
    "dropmalcty": "MICRO",
    "dropmalst": "NC",
    "dropmalzpp": 275559998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 9192842004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15900",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "69 N HAWKINS AVE",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "NC",
    "dropdelzpp": 275569998,
    "dropphyadd": "69 N HAWKINS AVE",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "NC",
    "dropphyzpp": 275569998,
    "dropmaladd": "69 N HAWKINS AVE",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "NC",
    "dropmalzpp": 275569998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524923691,
    "dropfax": 2524920069
  },
  {
    "dcode": "D",
    "dropkey": "PY15901",
    "droptype": "D",
    "dropname": "MIDDLESEX",
    "dropdeladd": "10286 S NASH ST",
    "dropdelcty": "MIDDLESEX",
    "dropdelst": "NC",
    "dropdelzpp": 275579998,
    "dropphyadd": "10286 S NASH ST",
    "dropphycty": "MIDDLESEX",
    "dropphyst": "NC",
    "dropphyzpp": 275579998,
    "dropmaladd": "10286 S NASH ST",
    "dropmalcty": "MIDDLESEX",
    "dropmalst": "NC",
    "dropmalzpp": 275579998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522354081,
    "dropfax": 2522356124
  },
  {
    "dcode": "D",
    "dropkey": "PY15903",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "13379 HIGHWAY 601",
    "dropdelcty": "MIDLAND",
    "dropdelst": "NC",
    "dropdelzpp": 281079321,
    "dropphyadd": "13379 HIGHWAY 601",
    "dropphycty": "MIDLAND",
    "dropphyst": "NC",
    "dropphyzpp": 281079321,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIDLAND",
    "dropmalst": "NC",
    "dropmalzpp": 281079998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048886807,
    "dropsitcph": 7048886807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15909",
    "droptype": "D",
    "dropname": "MILL SPRING",
    "dropdeladd": "50 SCHOOL RD",
    "dropdelcty": "MILL SPRING",
    "dropdelst": "NC",
    "dropdelzpp": 287569745,
    "dropphyadd": "50 SCHOOL RD",
    "dropphycty": "MILL SPRING",
    "dropphyst": "NC",
    "dropphyzpp": 287569745,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILL SPRING",
    "dropmalst": "NC",
    "dropmalzpp": 287569998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288943199,
    "dropsitcph": 8288943199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15913",
    "droptype": "D",
    "dropname": "MILLERS CREEK",
    "dropdeladd": "148 POST OFFICE DR",
    "dropdelcty": "MILLERS CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 286519501,
    "dropphyadd": "148 POST OFFICE DR",
    "dropphycty": "MILLERS CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 286519501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLERS CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 286519998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368385653,
    "dropfax": 3368380547
  },
  {
    "dcode": "D",
    "dropkey": "PY15918",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "19 BRIDGE ST N",
    "dropdelcty": "MILTON",
    "dropdelst": "NC",
    "dropdelzpp": 273059996,
    "dropphyadd": "19 BRIDGE ST N",
    "dropphycty": "MILTON",
    "dropphyst": "NC",
    "dropphyzpp": 273059996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILTON",
    "dropmalst": "NC",
    "dropmalzpp": 273059998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362348171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15921",
    "droptype": "D",
    "dropname": "MINERAL SPRINGS",
    "dropdeladd": "5912 WAXHAW HWY",
    "dropdelcty": "MINERAL SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 281086760,
    "dropphyadd": "5912 WAXHAW HWY",
    "dropphycty": "MINERAL SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 281086760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINERAL SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 281089998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048433713,
    "dropsitcph": 7048433713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15922",
    "droptype": "D",
    "dropname": "MINNEAPOLIS",
    "dropdeladd": "2751 US HIGHWAY 19 E",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "NC",
    "dropdelzpp": 286529800,
    "dropphyadd": "2751 US HIGHWAY 19 E",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "NC",
    "dropphyzpp": 286529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "NC",
    "dropmalzpp": 286529998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287330818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15925",
    "droptype": "D",
    "dropname": "MISENHEIMER",
    "dropdeladd": "48456 US HWY 52 N",
    "dropdelcty": "MISENHEIMER",
    "dropdelst": "NC",
    "dropdelzpp": 281097965,
    "dropphyadd": "48456 US HWY 52 N",
    "dropphycty": "MISENHEIMER",
    "dropphyst": "NC",
    "dropphyzpp": 281097965,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MISENHEIMER",
    "dropmalst": "NC",
    "dropmalzpp": 281099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044637663,
    "dropsitcph": 7044637663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15926",
    "droptype": "D",
    "dropname": "MOCKSVILLE",
    "dropdeladd": "1119 YADKINVILLE RD",
    "dropdelcty": "MOCKSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270282565,
    "dropphyadd": "1119 YADKINVILLE RD",
    "dropphycty": "MOCKSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270282565,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOCKSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270289998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367512011,
    "dropfax": 3367519669
  },
  {
    "dcode": "D",
    "dropkey": "PY15929",
    "droptype": "D",
    "dropname": "MONCURE",
    "dropdeladd": "213 POST OFFICE RD",
    "dropdelcty": "MONCURE",
    "dropdelst": "NC",
    "dropdelzpp": 275599998,
    "dropphyadd": "213 POST OFFICE RD",
    "dropphycty": "MONCURE",
    "dropphyst": "NC",
    "dropphyzpp": 275599998,
    "dropmaladd": "213 POST OFFICE RD",
    "dropmalcty": "MONCURE",
    "dropmalst": "NC",
    "dropmalzpp": 275599998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195424545,
    "dropfax": 9195450586
  },
  {
    "dcode": "D",
    "dropkey": "PY15930",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "101 S CHARLOTTE AVE",
    "dropdelcty": "MONROE",
    "dropdelst": "NC",
    "dropdelzpp": 281125501,
    "dropphyadd": "101 S CHARLOTTE AVE",
    "dropphycty": "MONROE",
    "dropphyst": "NC",
    "dropphyzpp": 281125501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONROE",
    "dropmalst": "NC",
    "dropmalzpp": 281109998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042894508,
    "dropsitcph": 7042894508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15932",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "380 OLD NC HIGHWAY 181",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "NC",
    "dropdelzpp": 286539800,
    "dropphyadd": "380 OLD NC HIGHWAY 181",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "NC",
    "dropphyzpp": 286539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "NC",
    "dropmalzpp": 286539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287338191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15934",
    "droptype": "D",
    "dropname": "MONTREAT",
    "dropdeladd": "301 ASSEMBLY DR",
    "dropdelcty": "MONTREAT",
    "dropdelst": "NC",
    "dropdelzpp": 287578000,
    "dropphyadd": "301 ASSEMBLY DR",
    "dropphycty": "MONTREAT",
    "dropphyst": "NC",
    "dropphyzpp": 287578000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTREAT",
    "dropmalst": "NC",
    "dropmalzpp": 287579998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286697837,
    "dropsitcph": 8286697837,
    "dropfax": 8286697837
  },
  {
    "dcode": "D",
    "dropkey": "PY15936",
    "droptype": "D",
    "dropname": "MOORESBORO",
    "dropdeladd": "104 W CHURCH ST",
    "dropdelcty": "MOORESBORO",
    "dropdelst": "NC",
    "dropdelzpp": 281149505,
    "dropphyadd": "104 W CHURCH ST",
    "dropphycty": "MOORESBORO",
    "dropphyst": "NC",
    "dropphyzpp": 281149505,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOORESBORO",
    "dropmalst": "NC",
    "dropmalzpp": 281149998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044348986,
    "dropsitcph": 7044348986,
    "dropfax": 7044348986
  },
  {
    "dcode": "D",
    "dropkey": "PY15938",
    "droptype": "D",
    "dropname": "MOORESVILLE",
    "dropdeladd": "123 INSTITUTE ST",
    "dropdelcty": "MOORESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281154980,
    "dropphyadd": "123 INSTITUTE ST",
    "dropphycty": "MOORESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281154980,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOORESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281159998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046608823,
    "dropsitcph": 7046608823,
    "dropfax": 7046605281
  },
  {
    "dcode": "D",
    "dropkey": "PY15942",
    "droptype": "D",
    "dropname": "MORAVIAN FALLS",
    "dropdeladd": "1933 MORAVIAN FALLS RD",
    "dropdelcty": "MORAVIAN FALLS",
    "dropdelst": "NC",
    "dropdelzpp": 286549603,
    "dropphyadd": "1933 MORAVIAN FALLS RD",
    "dropphycty": "MORAVIAN FALLS",
    "dropphyst": "NC",
    "dropphyzpp": 286549603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORAVIAN FALLS",
    "dropmalst": "NC",
    "dropmalzpp": 286549998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366671711,
    "dropfax": 3366671711
  },
  {
    "dcode": "D",
    "dropkey": "PY15946",
    "droptype": "D",
    "dropname": "MOREHEAD CITY",
    "dropdeladd": "3500 BRIDGES ST",
    "dropdelcty": "MOREHEAD CITY",
    "dropdelst": "NC",
    "dropdelzpp": 285573095,
    "dropphyadd": "3500 BRIDGES ST",
    "dropphycty": "MOREHEAD CITY",
    "dropphyst": "NC",
    "dropphyzpp": 285573095,
    "dropmaladd": "PO BOX 28557",
    "dropmalcty": "MOREHEAD CITY",
    "dropmalst": "NC",
    "dropmalzpp": 285579998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527260920,
    "dropsitcph": 2527260920,
    "dropfax": 2522401351
  },
  {
    "dcode": "D",
    "dropkey": "PY15951",
    "droptype": "D",
    "dropname": "MORRISVILLE",
    "dropdeladd": "10520 CHAPEL HILL RD",
    "dropdelcty": "MORRISVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 275609998,
    "dropphyadd": "10520 CHAPEL HILL RD",
    "dropphycty": "MORRISVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 275609998,
    "dropmaladd": "10520 CHAPEL HILL RD",
    "dropmalcty": "MORRISVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 275609998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194674763,
    "dropfax": 9193196980
  },
  {
    "dcode": "D",
    "dropkey": "PY15953",
    "droptype": "D",
    "dropname": "MORVEN",
    "dropdeladd": "108 E MAIN ST",
    "dropdelcty": "MORVEN",
    "dropdelst": "NC",
    "dropdelzpp": 281199730,
    "dropphyadd": "108 E MAIN ST",
    "dropphycty": "MORVEN",
    "dropphyst": "NC",
    "dropphyzpp": 281199730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORVEN",
    "dropmalst": "NC",
    "dropmalzpp": 281199998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048519432,
    "dropsitcph": 7048519432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15954",
    "droptype": "D",
    "dropname": "MOUNT AIRY",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "MOUNT AIRY",
    "dropdelst": "NC",
    "dropdelzpp": 270303840,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "MOUNT AIRY",
    "dropphyst": "NC",
    "dropphyzpp": 270303840,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT AIRY",
    "dropmalst": "NC",
    "dropmalzpp": 270309998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367862805,
    "dropfax": 3367895623
  },
  {
    "dcode": "D",
    "dropkey": "PY15955",
    "droptype": "D",
    "dropname": "MOUNT GILEAD",
    "dropdeladd": "106 N SCHOOL ST",
    "dropdelcty": "MOUNT GILEAD",
    "dropdelst": "NC",
    "dropdelzpp": 273069270,
    "dropphyadd": "106 N SCHOOL ST",
    "dropphycty": "MOUNT GILEAD",
    "dropphyst": "NC",
    "dropphyzpp": 273069270,
    "dropmaladd": "106 N SCHOOL ST",
    "dropmalcty": "MOUNT GILEAD",
    "dropmalst": "NC",
    "dropmalzpp": 273069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9104396522,
    "dropfax": 9104399848
  },
  {
    "dcode": "D",
    "dropkey": "PY15957",
    "droptype": "D",
    "dropname": "MOUNT HOLLY",
    "dropdeladd": "806 W CENTRAL AVE",
    "dropdelcty": "MOUNT HOLLY",
    "dropdelst": "NC",
    "dropdelzpp": 281203491,
    "dropphyadd": "806 W CENTRAL AVE",
    "dropphycty": "MOUNT HOLLY",
    "dropphyst": "NC",
    "dropphyzpp": 281203491,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT HOLLY",
    "dropmalst": "NC",
    "dropmalzpp": 281209998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048276415,
    "dropsitcph": 7048276415,
    "dropfax": 7048271972
  },
  {
    "dcode": "D",
    "dropkey": "PY15958",
    "droptype": "D",
    "dropname": "MOUNT MOURNE",
    "dropdeladd": "1519 MECKLENBURG HWY",
    "dropdelcty": "MOORESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281156104,
    "dropphyadd": "1519 MECKLENBURG HWY",
    "dropphycty": "MOORESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281156104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT MOURNE",
    "dropmalst": "NC",
    "dropmalzpp": 281239998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7048928375,
    "dropfax": 7048965246
  },
  {
    "dcode": "D",
    "dropkey": "PY15959",
    "droptype": "D",
    "dropname": "MOUNT OLIVE",
    "dropdeladd": "611 N BREAZEALE AVE",
    "dropdelcty": "MOUNT OLIVE",
    "dropdelst": "NC",
    "dropdelzpp": 283651203,
    "dropphyadd": "611 N BREAZEALE AVE",
    "dropphycty": "MOUNT OLIVE",
    "dropphyst": "NC",
    "dropphyzpp": 283651203,
    "dropmaladd": "PO BOX 28365",
    "dropmalcty": "MOUNT OLIVE",
    "dropmalst": "NC",
    "dropmalzpp": 283659998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9196582474,
    "dropsitcph": 9196582474,
    "dropfax": 9106580405
  },
  {
    "dcode": "D",
    "dropkey": "PY15962",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "1498 S MAIN ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "NC",
    "dropdelzpp": 281247699,
    "dropphyadd": "1498 S MAIN ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "NC",
    "dropphyzpp": 281247699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "NC",
    "dropmalzpp": 281249998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044369707,
    "dropsitcph": 7044369707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15966",
    "droptype": "D",
    "dropname": "MOUNT ULLA",
    "dropdeladd": "775 GRAMPIAN RD",
    "dropdelcty": "MOUNT ULLA",
    "dropdelst": "NC",
    "dropdelzpp": 281259627,
    "dropphyadd": "775 GRAMPIAN RD",
    "dropphycty": "MOUNT ULLA",
    "dropphyst": "NC",
    "dropphyzpp": 281259627,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT ULLA",
    "dropmalst": "NC",
    "dropmalzpp": 281259998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042784554,
    "dropsitcph": 7042784554,
    "dropfax": 7042781873
  },
  {
    "dcode": "D",
    "dropkey": "PY15969",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME",
    "dropdeladd": "524 COURTLAND BLVD",
    "dropdelcty": "MOUNTAIN HOME",
    "dropdelst": "NC",
    "dropdelzpp": 287580658,
    "dropphyadd": "524 COURTLAND BLVD",
    "dropphycty": "MOUNTAIN HOME",
    "dropphyst": "NC",
    "dropphyzpp": 287580658,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN HOME",
    "dropmalst": "NC",
    "dropmalzpp": 287589998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286920384,
    "dropsitcph": 8286920384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY15974",
    "droptype": "D",
    "dropname": "MOYOCK",
    "dropdeladd": "574 CARATOKE HWY",
    "dropdelcty": "MOYOCK",
    "dropdelst": "NC",
    "dropdelzpp": 279589998,
    "dropphyadd": "574 CARATOKE HWY",
    "dropphycty": "MOYOCK",
    "dropphyst": "NC",
    "dropphyzpp": 279589998,
    "dropmaladd": "574 CARATOKE HWY",
    "dropmalcty": "MOYOCK",
    "dropmalst": "NC",
    "dropmalzpp": 279589998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524356231,
    "dropfax": 2524356722
  },
  {
    "dcode": "D",
    "dropkey": "PY15987",
    "droptype": "D",
    "dropname": "MURFREESBORO",
    "dropdeladd": "115 N WYNN ST",
    "dropdelcty": "MURFREESBORO",
    "dropdelst": "NC",
    "dropdelzpp": 278559998,
    "dropphyadd": "115 N WYNN ST",
    "dropphycty": "MURFREESBORO",
    "dropphyst": "NC",
    "dropphyzpp": 278559998,
    "dropmaladd": "115 N WYNN ST",
    "dropmalcty": "MURFREESBORO",
    "dropmalst": "NC",
    "dropmalzpp": 278559998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523983332,
    "dropfax": 2523984363
  },
  {
    "dcode": "D",
    "dropkey": "PY15989",
    "droptype": "D",
    "dropname": "MURPHY",
    "dropdeladd": "388 VALLEY RIVER AVE",
    "dropdelcty": "MURPHY",
    "dropdelst": "NC",
    "dropdelzpp": 289062923,
    "dropphyadd": "388 VALLEY RIVER AVE",
    "dropphycty": "MURPHY",
    "dropphyst": "NC",
    "dropphyzpp": 289062923,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURPHY",
    "dropmalst": "NC",
    "dropmalzpp": 289069998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288376214,
    "dropsitcph": 8288376214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16000",
    "droptype": "D",
    "dropname": "NAGS HEAD",
    "dropdeladd": "100 DEERING ST",
    "dropdelcty": "NAGS HEAD",
    "dropdelst": "NC",
    "dropdelzpp": 279599998,
    "dropphyadd": "100 DEERING ST",
    "dropphycty": "NAGS HEAD",
    "dropphyst": "NC",
    "dropphyzpp": 279599998,
    "dropmaladd": "100 DEERING ST",
    "dropmalcty": "NAGS HEAD",
    "dropmalst": "NC",
    "dropmalzpp": 279599998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524417387,
    "dropfax": 2524418408
  },
  {
    "dcode": "D",
    "dropkey": "PY16001",
    "droptype": "D",
    "dropname": "NAKINA",
    "dropdeladd": "7731 SEVEN CREEKS HWY",
    "dropdelcty": "NAKINA",
    "dropdelst": "NC",
    "dropdelzpp": 284558908,
    "dropphyadd": "7731 SEVEN CREEKS HWY",
    "dropphycty": "NAKINA",
    "dropphyst": "NC",
    "dropphyzpp": 284558908,
    "dropmaladd": "PO BOX 28455",
    "dropmalcty": "NAKINA",
    "dropmalst": "NC",
    "dropmalzpp": 284559998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106425303,
    "dropsitcph": 9106425303,
    "dropfax": 9106425303
  },
  {
    "dcode": "D",
    "dropkey": "PY16002",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "121 S NAPLES RD",
    "dropdelcty": "NAPLES",
    "dropdelst": "NC",
    "dropdelzpp": 287609700,
    "dropphyadd": "121 S NAPLES RD",
    "dropphycty": "NAPLES",
    "dropphyst": "NC",
    "dropphyzpp": 287609700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAPLES",
    "dropmalst": "NC",
    "dropmalzpp": 287609998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286842148,
    "dropsitcph": 8286842148,
    "dropfax": 8286842148
  },
  {
    "dcode": "D",
    "dropkey": "PY16003",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "504 S BARNES ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278569998,
    "dropphyadd": "504 S BARNES ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278569998,
    "dropmaladd": "504 S BARNES ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278569998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524593813,
    "dropfax": 2524597576
  },
  {
    "dcode": "D",
    "dropkey": "PY16017",
    "droptype": "D",
    "dropname": "NEBO",
    "dropdeladd": "229 NEBO SCHOOL RD",
    "dropdelcty": "NEBO",
    "dropdelst": "NC",
    "dropdelzpp": 287616847,
    "dropphyadd": "229 NEBO SCHOOL RD",
    "dropphycty": "NEBO",
    "dropphyst": "NC",
    "dropphyzpp": 287616847,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEBO",
    "dropmalst": "NC",
    "dropmalzpp": 287619998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286527617,
    "dropsitcph": 8286527617,
    "dropfax": 8286524272
  },
  {
    "dcode": "D",
    "dropkey": "PY16023",
    "droptype": "D",
    "dropname": "NEW BERN",
    "dropdeladd": "1851 S GLENBURNIE RD",
    "dropdelcty": "NEW BERN",
    "dropdelst": "NC",
    "dropdelzpp": 285625268,
    "dropphyadd": "1851 S GLENBURNIE RD",
    "dropphycty": "NEW BERN",
    "dropphyst": "NC",
    "dropphyzpp": 285625268,
    "dropmaladd": "PO BOX 28562",
    "dropmalcty": "NEW BERN",
    "dropmalst": "NC",
    "dropmalzpp": 285629998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2526386112,
    "dropsitcph": 2526386112,
    "dropfax": 2526332632
  },
  {
    "dcode": "D",
    "dropkey": "PY16025",
    "droptype": "D",
    "dropname": "NEW HILL",
    "dropdeladd": "3525 OLD US 1 HWY",
    "dropdelcty": "NEW HILL",
    "dropdelst": "NC",
    "dropdelzpp": 275629998,
    "dropphyadd": "3525 OLD US 1 HWY",
    "dropphycty": "NEW HILL",
    "dropphyst": "NC",
    "dropphyzpp": 275629998,
    "dropmaladd": "3525 OLD US 1 HWY",
    "dropmalcty": "NEW HILL",
    "dropmalst": "NC",
    "dropmalzpp": 275629998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9193628474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16029",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "212 S MAIN ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "NC",
    "dropdelzpp": 281279515,
    "dropphyadd": "212 S MAIN ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "NC",
    "dropphyzpp": 281279515,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "NC",
    "dropmalzpp": 281279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044635112,
    "dropsitcph": 7044635112,
    "dropfax": 7044631554
  },
  {
    "dcode": "D",
    "dropkey": "PY16034",
    "droptype": "D",
    "dropname": "NEWELL",
    "dropdeladd": "8105 OLD CONCORD RD",
    "dropdelcty": "NEWELL",
    "dropdelst": "NC",
    "dropdelzpp": 281269997,
    "dropphyadd": "8105 OLD CONCORD RD",
    "dropphycty": "NEWELL",
    "dropphyst": "NC",
    "dropphyzpp": 281269997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWELL",
    "dropmalst": "NC",
    "dropmalzpp": 281269998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045961651,
    "dropsitcph": 7045961651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16035",
    "droptype": "D",
    "dropname": "NEWLAND",
    "dropdeladd": "124 ELK ST",
    "dropdelcty": "NEWLAND",
    "dropdelst": "NC",
    "dropdelzpp": 286579311,
    "dropphyadd": "124 ELK ST",
    "dropphycty": "NEWLAND",
    "dropphyst": "NC",
    "dropphyzpp": 286579311,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWLAND",
    "dropmalst": "NC",
    "dropmalzpp": 286579998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287332500,
    "dropfax": 8287332500
  },
  {
    "dcode": "D",
    "dropkey": "PY16037",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "337 HOWARD BLVD",
    "dropdelcty": "NEWPORT",
    "dropdelst": "NC",
    "dropdelzpp": 285707929,
    "dropphyadd": "337 HOWARD BLVD",
    "dropphycty": "NEWPORT",
    "dropphyst": "NC",
    "dropphyzpp": 285707929,
    "dropmaladd": "PO BOX 28570",
    "dropmalcty": "NEWPORT",
    "dropmalst": "NC",
    "dropmalzpp": 285709998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522234638,
    "dropsitcph": 2522234638,
    "dropfax": 2522234707
  },
  {
    "dcode": "D",
    "dropkey": "PY16040",
    "droptype": "D",
    "dropname": "NEWTON GROVE",
    "dropdeladd": "208 FAYETTEVILLE ST",
    "dropdelcty": "NEWTON GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 283668992,
    "dropphyadd": "208 FAYETTEVILLE ST",
    "dropphycty": "NEWTON GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 283668992,
    "dropmaladd": "PO BOX 28366",
    "dropmalcty": "NEWTON GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 283669998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105941454,
    "dropsitcph": 9105941454,
    "dropfax": 9105940327
  },
  {
    "dcode": "D",
    "dropkey": "PY16045",
    "droptype": "D",
    "dropname": "NORLINA",
    "dropdeladd": "306 LIBERTY ST",
    "dropdelcty": "NORLINA",
    "dropdelst": "NC",
    "dropdelzpp": 275639998,
    "dropphyadd": "306 LIBERTY ST",
    "dropphycty": "NORLINA",
    "dropphyst": "NC",
    "dropphyzpp": 275639998,
    "dropmaladd": "306 LIBERTY ST",
    "dropmalcty": "NORLINA",
    "dropmalst": "NC",
    "dropmalzpp": 275639998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524562663,
    "dropfax": 2524562918
  },
  {
    "dcode": "D",
    "dropkey": "PY16046",
    "droptype": "D",
    "dropname": "NORMAN",
    "dropdeladd": "3664 NC HIGHWAY 220 N",
    "dropdelcty": "NORMAN",
    "dropdelst": "NC",
    "dropdelzpp": 283678900,
    "dropphyadd": "3664 NC HIGHWAY 220 N",
    "dropphycty": "NORMAN",
    "dropphyst": "NC",
    "dropphyzpp": 283678900,
    "dropmaladd": "PO BOX 28367",
    "dropmalcty": "NORMAN",
    "dropmalst": "NC",
    "dropmalzpp": 283679998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106526192,
    "dropsitcph": 9106526192,
    "dropfax": 9106526192
  },
  {
    "dcode": "D",
    "dropkey": "PY16072",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "243 S MAIN ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "NC",
    "dropdelzpp": 281286435,
    "dropphyadd": "243 S MAIN ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "NC",
    "dropphyzpp": 281286435,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWOOD",
    "dropmalst": "NC",
    "dropmalzpp": 281289998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044743048,
    "dropsitcph": 7044743048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16075",
    "droptype": "D",
    "dropname": "OAK CITY",
    "dropdeladd": "100 E COMMERCE ST",
    "dropdelcty": "OAK CITY",
    "dropdelst": "NC",
    "dropdelzpp": 278579684,
    "dropphyadd": "100 E COMMERCE ST",
    "dropphycty": "OAK CITY",
    "dropphyst": "NC",
    "dropphyzpp": 278579684,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAK CITY",
    "dropmalst": "NC",
    "dropmalzpp": 278579998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527982161,
    "dropfax": 2527982975
  },
  {
    "dcode": "D",
    "dropkey": "PY16085",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "8323 LINVILLE RD",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 273109405,
    "dropphyadd": "8323 LINVILLE RD",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 273109405,
    "dropmaladd": "8323 LINVILLE RD",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 273109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366447945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16086",
    "droptype": "D",
    "dropname": "OAKBORO",
    "dropdeladd": "302 N MAIN ST",
    "dropdelcty": "OAKBORO",
    "dropdelst": "NC",
    "dropdelzpp": 281299019,
    "dropphyadd": "302 N MAIN ST",
    "dropphycty": "OAKBORO",
    "dropphyst": "NC",
    "dropphyzpp": 281299019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKBORO",
    "dropmalst": "NC",
    "dropmalzpp": 281299998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044853912,
    "dropsitcph": 7044853912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16093",
    "droptype": "D",
    "dropname": "OCRACOKE",
    "dropdeladd": "1122 IRVIN GARRISH HWY",
    "dropdelcty": "OCRACOKE",
    "dropdelst": "NC",
    "dropdelzpp": 279609997,
    "dropphyadd": "1122 IRVIN GARRISH HWY",
    "dropphycty": "OCRACOKE",
    "dropphyst": "NC",
    "dropphyzpp": 279609997,
    "dropmaladd": "1122 IRVIN GARRISH HWY",
    "dropmalcty": "OCRACOKE",
    "dropmalst": "NC",
    "dropmalzpp": 279609997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529284771,
    "dropfax": 2529289905
  },
  {
    "dcode": "D",
    "dropkey": "PY16096",
    "droptype": "D",
    "dropname": "OLD FORT",
    "dropdeladd": "180 E MAIN ST",
    "dropdelcty": "OLD FORT",
    "dropdelst": "NC",
    "dropdelzpp": 287629805,
    "dropphyadd": "180 E MAIN ST",
    "dropphycty": "OLD FORT",
    "dropphyst": "NC",
    "dropphyzpp": 287629805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD FORT",
    "dropmalst": "NC",
    "dropmalzpp": 287629998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286687843,
    "dropsitcph": 8286687843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16101",
    "droptype": "D",
    "dropname": "OLIN",
    "dropdeladd": "583 OLIN LOOP",
    "dropdelcty": "OLIN",
    "dropdelst": "NC",
    "dropdelzpp": 286609516,
    "dropphyadd": "583 OLIN LOOP",
    "dropphycty": "OLIN",
    "dropphyst": "NC",
    "dropphyzpp": 286609516,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLIN",
    "dropmalst": "NC",
    "dropmalzpp": 286609998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7044988100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16105",
    "droptype": "D",
    "dropname": "OLIVIA",
    "dropdeladd": "480 SEAWELL ROSSER RD",
    "dropdelcty": "OLIVIA",
    "dropdelst": "NC",
    "dropdelzpp": 283688900,
    "dropphyadd": "480 SEAWELL ROSSER RD",
    "dropphycty": "OLIVIA",
    "dropphyst": "NC",
    "dropphyzpp": 283688900,
    "dropmaladd": "PO BOX 28368",
    "dropmalcty": "OLIVIA",
    "dropmalst": "NC",
    "dropmalzpp": 283689998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9194995411,
    "dropsitcph": 9194995411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16108",
    "droptype": "D",
    "dropname": "ORIENTAL",
    "dropdeladd": "809 BROAD ST",
    "dropdelcty": "ORIENTAL",
    "dropdelst": "NC",
    "dropdelzpp": 285719781,
    "dropphyadd": "809 BROAD ST",
    "dropphycty": "ORIENTAL",
    "dropphyst": "NC",
    "dropphyzpp": 285719781,
    "dropmaladd": "PO BOX 28571",
    "dropmalcty": "ORIENTAL",
    "dropmalst": "NC",
    "dropmalzpp": 285719998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522490454,
    "dropsitcph": 2522490454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16110",
    "droptype": "D",
    "dropname": "ORRUM",
    "dropdeladd": "1545 S CREEK RD",
    "dropdelcty": "ORRUM",
    "dropdelst": "NC",
    "dropdelzpp": 283699275,
    "dropphyadd": "1545 S CREEK RD",
    "dropphycty": "ORRUM",
    "dropphyst": "NC",
    "dropphyzpp": 283699275,
    "dropmaladd": "PO BOX 28369",
    "dropmalcty": "ORRUM",
    "dropmalst": "NC",
    "dropmalzpp": 283699998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106286226,
    "dropsitcph": 9106286226,
    "dropfax": 9106286226
  },
  {
    "dcode": "D",
    "dropkey": "PY16118",
    "droptype": "D",
    "dropname": "OTTO",
    "dropdeladd": "8491 GEORGIA RD",
    "dropdelcty": "OTTO",
    "dropdelst": "NC",
    "dropdelzpp": 287636105,
    "dropphyadd": "8491 GEORGIA RD",
    "dropphycty": "OTTO",
    "dropphyst": "NC",
    "dropphyzpp": 287636105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OTTO",
    "dropmalst": "NC",
    "dropmalzpp": 287639998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285244584,
    "dropsitcph": 8285244584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16121",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "144 MAIN ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "NC",
    "dropdelzpp": 275659998,
    "dropphyadd": "144 MAIN ST",
    "dropphycty": "OXFORD",
    "dropphyst": "NC",
    "dropphyzpp": 275659998,
    "dropmaladd": "144 MAIN ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "NC",
    "dropmalzpp": 275659998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196931591,
    "dropfax": 9196900352
  },
  {
    "dcode": "D",
    "dropkey": "PY16128",
    "droptype": "D",
    "dropname": "PANTEGO",
    "dropdeladd": "26022 US HIGHWAY 264 E",
    "dropdelcty": "PANTEGO",
    "dropdelst": "NC",
    "dropdelzpp": 278609222,
    "dropphyadd": "26022 US HIGHWAY 264 E",
    "dropphycty": "PANTEGO",
    "dropphyst": "NC",
    "dropphyzpp": 278609222,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANTEGO",
    "dropmalst": "NC",
    "dropmalzpp": 278609998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529432220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16132",
    "droptype": "D",
    "dropname": "PARKTON",
    "dropdeladd": "29 S FAYETTEVILLE ST",
    "dropdelcty": "PARKTON",
    "dropdelst": "NC",
    "dropdelzpp": 283719006,
    "dropphyadd": "29 S FAYETTEVILLE ST",
    "dropphycty": "PARKTON",
    "dropphyst": "NC",
    "dropphyzpp": 283719006,
    "dropmaladd": "PO BOX 28371",
    "dropmalcty": "PARKTON",
    "dropmalst": "NC",
    "dropmalzpp": 283719998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108583554,
    "dropsitcph": 9108583554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16139",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "2008 ROBY MARTIN RD",
    "dropdelcty": "PATTERSON",
    "dropdelst": "NC",
    "dropdelzpp": 286619800,
    "dropphyadd": "2008 ROBY MARTIN RD",
    "dropphycty": "PATTERSON",
    "dropphyst": "NC",
    "dropphyzpp": 286619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATTERSON",
    "dropmalst": "NC",
    "dropmalzpp": 286619998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287585382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16141",
    "droptype": "D",
    "dropname": "PAW CREEK",
    "dropdeladd": "7400 OLD MOUNT HOLLY RD",
    "dropdelcty": "PAW CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 281309700,
    "dropphyadd": "7400 OLD MOUNT HOLLY RD",
    "dropphycty": "PAW CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 281309700,
    "dropmaladd": "7400 OLD MOUNT HOLLY RD",
    "dropmalcty": "PAW CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 281309700,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043918265,
    "dropsitcph": 7043918265,
    "dropfax": 7043918265
  },
  {
    "dcode": "D",
    "dropkey": "PY16145",
    "droptype": "D",
    "dropname": "PEACHLAND",
    "dropdeladd": "14 W PASSAIC ST",
    "dropdelcty": "PEACHLAND",
    "dropdelst": "NC",
    "dropdelzpp": 281338739,
    "dropphyadd": "14 W PASSAIC ST",
    "dropphycty": "PEACHLAND",
    "dropphyst": "NC",
    "dropphyzpp": 281338739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEACHLAND",
    "dropmalst": "NC",
    "dropmalzpp": 281339998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042727905,
    "dropsitcph": 7042727905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16147",
    "droptype": "D",
    "dropname": "PELHAM",
    "dropdeladd": "6331 OLD US HIGHWAY 29",
    "dropdelcty": "PELHAM",
    "dropdelst": "NC",
    "dropdelzpp": 273119210,
    "dropphyadd": "6331 OLD US HIGHWAY 29",
    "dropphycty": "PELHAM",
    "dropphyst": "NC",
    "dropphyzpp": 273119210,
    "dropmaladd": "6331 OLD US HIGHWAY 29",
    "dropmalcty": "PELHAM",
    "dropmalst": "NC",
    "dropmalzpp": 273119998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363882797,
    "dropfax": 3363881402
  },
  {
    "dcode": "D",
    "dropkey": "PY16148",
    "droptype": "D",
    "dropname": "PEMBROKE",
    "dropdeladd": "404 E 3RD ST",
    "dropdelcty": "PEMBROKE",
    "dropdelst": "NC",
    "dropdelzpp": 283728801,
    "dropphyadd": "404 E 3RD ST",
    "dropphycty": "PEMBROKE",
    "dropphyst": "NC",
    "dropphyzpp": 283728801,
    "dropmaladd": "PO BOX 28372",
    "dropmalcty": "PEMBROKE",
    "dropmalst": "NC",
    "dropmalzpp": 283729998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105214792,
    "dropsitcph": 9105214792,
    "dropfax": 9105220528
  },
  {
    "dcode": "D",
    "dropkey": "PY16149",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "7488 NC HIGHWAY 35",
    "dropdelcty": "PENDLETON",
    "dropdelst": "NC",
    "dropdelzpp": 278629998,
    "dropphyadd": "7488 NC HIGHWAY 35",
    "dropphycty": "PENDLETON",
    "dropphyst": "NC",
    "dropphyzpp": 278629998,
    "dropmaladd": "7488 NC HIGHWAY 35",
    "dropmalcty": "PENDLETON",
    "dropmalst": "NC",
    "dropmalzpp": 278629998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525851513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16150",
    "droptype": "D",
    "dropname": "PENLAND",
    "dropdeladd": "1162 PENLAND RD",
    "dropdelcty": "PENLAND",
    "dropdelst": "NC",
    "dropdelzpp": 287658000,
    "dropphyadd": "1162 PENLAND RD",
    "dropphycty": "PENLAND",
    "dropphyst": "NC",
    "dropphyzpp": 287658000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENLAND",
    "dropmalst": "NC",
    "dropmalzpp": 287659998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287657397,
    "dropsitcph": 8287657397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16151",
    "droptype": "D",
    "dropname": "PENROSE",
    "dropdeladd": "5858 OLD HENDERSONVILLE HWY",
    "dropdelcty": "PENROSE",
    "dropdelst": "NC",
    "dropdelzpp": 287665000,
    "dropphyadd": "5858 OLD HENDERSONVILLE HWY",
    "dropphycty": "PENROSE",
    "dropphyst": "NC",
    "dropphyzpp": 287665000,
    "dropmaladd": "5858 OLD HENDERSONVILLE HWY",
    "dropmalcty": "PENROSE",
    "dropmalst": "NC",
    "dropmalzpp": 287665000,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288773561,
    "dropsitcph": 8288773561,
    "dropfax": 8288773561
  },
  {
    "dcode": "D",
    "dropkey": "PY16157",
    "droptype": "D",
    "dropname": "PFAFFTOWN",
    "dropdeladd": "4715 YADKINVILLE RD",
    "dropdelcty": "PFAFFTOWN",
    "dropdelst": "NC",
    "dropdelzpp": 270409901,
    "dropphyadd": "4715 YADKINVILLE RD",
    "dropphycty": "PFAFFTOWN",
    "dropphyst": "NC",
    "dropphyzpp": 270409901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PFAFFTOWN",
    "dropmalst": "NC",
    "dropmalzpp": 270409998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369244466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16160",
    "droptype": "D",
    "dropname": "PIKEVILLE",
    "dropdeladd": "214 BIG DADDYS RD",
    "dropdelcty": "PIKEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278639998,
    "dropphyadd": "214 BIG DADDYS RD",
    "dropphycty": "PIKEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278639998,
    "dropmaladd": "214 BIG DADDYS RD",
    "dropmalcty": "PIKEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278639998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192425012,
    "dropfax": 9192422348
  },
  {
    "dcode": "D",
    "dropkey": "PY16164",
    "droptype": "D",
    "dropname": "PILOT MOUNTAIN",
    "dropdeladd": "647K S KEY ST",
    "dropdelcty": "PILOT MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 270419998,
    "dropphyadd": "647K S KEY ST",
    "dropphycty": "PILOT MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 270419998,
    "dropmaladd": "647K S KEY ST",
    "dropmalcty": "PILOT MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 270419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363684659,
    "dropfax": 3363684699
  },
  {
    "dcode": "D",
    "dropkey": "PY16168",
    "droptype": "D",
    "dropname": "PINE HALL",
    "dropdeladd": "1716 PINE HALL RD",
    "dropdelcty": "PINE HALL",
    "dropdelst": "NC",
    "dropdelzpp": 270429998,
    "dropphyadd": "1716 PINE HALL RD",
    "dropphycty": "PINE HALL",
    "dropphyst": "NC",
    "dropphyzpp": 270429998,
    "dropmaladd": "1716 PINE HALL RD",
    "dropmalcty": "PINE HALL",
    "dropmalst": "NC",
    "dropmalzpp": 270429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364275606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16171",
    "droptype": "D",
    "dropname": "PINE LEVEL",
    "dropdeladd": "2180 US HIGHWAY 70A E",
    "dropdelcty": "SELMA",
    "dropdelst": "NC",
    "dropdelzpp": 275769880,
    "dropphyadd": "2180 US HIGHWAY 70A E",
    "dropphycty": "SELMA",
    "dropphyst": "NC",
    "dropphyzpp": 275769880,
    "dropmaladd": "2180 US HIGHWAY 70A E",
    "dropmalcty": "SELMA",
    "dropmalst": "NC",
    "dropmalzpp": 275769880,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199652622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16173",
    "droptype": "D",
    "dropname": "PINEBLUFF",
    "dropdeladd": "125 N WALNUT ST",
    "dropdelcty": "PINEBLUFF",
    "dropdelst": "NC",
    "dropdelzpp": 283738901,
    "dropphyadd": "125 N WALNUT ST",
    "dropphycty": "PINEBLUFF",
    "dropphyst": "NC",
    "dropphyzpp": 283738901,
    "dropmaladd": "PO BOX 28373",
    "dropmalcty": "PINEBLUFF",
    "dropmalst": "NC",
    "dropmalzpp": 283739998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102813918,
    "dropsitcph": 9102813918,
    "dropfax": 9102813918
  },
  {
    "dcode": "D",
    "dropkey": "PY16174",
    "droptype": "D",
    "dropname": "PINEHURST",
    "dropdeladd": "80 BLAKE BLVD",
    "dropdelcty": "PINEHURST",
    "dropdelst": "NC",
    "dropdelzpp": 283748449,
    "dropphyadd": "80 BLAKE BLVD",
    "dropphycty": "PINEHURST",
    "dropphyst": "NC",
    "dropphyzpp": 283748449,
    "dropmaladd": "PO BOX 28374",
    "dropmalcty": "PINEHURST",
    "dropmalst": "NC",
    "dropmalzpp": 283749998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102951231,
    "dropsitcph": 9102951231,
    "dropfax": 9102150547
  },
  {
    "dcode": "D",
    "dropkey": "PY16175",
    "droptype": "D",
    "dropname": "PINEOLA",
    "dropdeladd": "2884 LINVILLE FALLS HWY",
    "dropdelcty": "PINEOLA",
    "dropdelst": "NC",
    "dropdelzpp": 286629800,
    "dropphyadd": "2884 LINVILLE FALLS HWY",
    "dropphycty": "PINEOLA",
    "dropphyst": "NC",
    "dropphyzpp": 286629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINEOLA",
    "dropmalst": "NC",
    "dropmalzpp": 286629998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287339692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16176",
    "droptype": "D",
    "dropname": "PINETOPS",
    "dropdeladd": "108 SW 1ST ST",
    "dropdelcty": "PINETOPS",
    "dropdelst": "NC",
    "dropdelzpp": 278649998,
    "dropphyadd": "108 SW 1ST ST",
    "dropphycty": "PINETOPS",
    "dropphyst": "NC",
    "dropphyzpp": 278649998,
    "dropmaladd": "108 SW 1ST ST",
    "dropmalcty": "PINETOPS",
    "dropmalst": "NC",
    "dropmalzpp": 278649998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528274134,
    "dropfax": 2528271801
  },
  {
    "dcode": "D",
    "dropkey": "PY16177",
    "droptype": "D",
    "dropname": "PINETOWN",
    "dropdeladd": "378 MAIN ST",
    "dropdelcty": "PINETOWN",
    "dropdelst": "NC",
    "dropdelzpp": 278659998,
    "dropphyadd": "378 MAIN ST",
    "dropphycty": "PINETOWN",
    "dropphyst": "NC",
    "dropphyzpp": 278659998,
    "dropmaladd": "378 MAIN ST",
    "dropmalcty": "PINETOWN",
    "dropmalst": "NC",
    "dropmalzpp": 278659998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529273309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16178",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "9835 PINEVILLE MATTHEWS RD",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281349903,
    "dropphyadd": "9835 PINEVILLE MATTHEWS RD",
    "dropphycty": "PINEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281349903,
    "dropmaladd": "9835 PINEVILLE MATTHEWS RD",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281349903,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048892227,
    "dropsitcph": 7048892227,
    "dropfax": 7048890066
  },
  {
    "dcode": "D",
    "dropkey": "PY16181",
    "droptype": "D",
    "dropname": "PINEY CREEK",
    "dropdeladd": "4216 PINEY POST OFFICE RD",
    "dropdelcty": "PINEY CREEK",
    "dropdelst": "NC",
    "dropdelzpp": 286639112,
    "dropphyadd": "4216 PINEY POST OFFICE RD",
    "dropphycty": "PINEY CREEK",
    "dropphyst": "NC",
    "dropphyzpp": 286639112,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINEY CREEK",
    "dropmalst": "NC",
    "dropmalzpp": 286639998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363592430,
    "dropfax": 3363592602
  },
  {
    "dcode": "D",
    "dropkey": "PY16183",
    "droptype": "D",
    "dropname": "PINK HILL",
    "dropdeladd": "5951 HWY 11 S",
    "dropdelcty": "PINK HILL",
    "dropdelst": "NC",
    "dropdelzpp": 285729554,
    "dropphyadd": "5951 HWY 11 S",
    "dropphycty": "PINK HILL",
    "dropphyst": "NC",
    "dropphyzpp": 285729554,
    "dropmaladd": "PO BOX 28572",
    "dropmalcty": "PINK HILL",
    "dropmalst": "NC",
    "dropmalzpp": 285729998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525683231,
    "dropsitcph": 2525683231,
    "dropfax": 2525684561
  },
  {
    "dcode": "D",
    "dropkey": "PY16186",
    "droptype": "D",
    "dropname": "PINNACLE",
    "dropdeladd": "2870 N OLD 52 RD",
    "dropdelcty": "PINNACLE",
    "dropdelst": "NC",
    "dropdelzpp": 270439998,
    "dropphyadd": "2870 N OLD 52 RD",
    "dropphycty": "PINNACLE",
    "dropphyst": "NC",
    "dropphyzpp": 270439998,
    "dropmaladd": "2870 N OLD 52 RD",
    "dropmalcty": "PINNACLE",
    "dropmalst": "NC",
    "dropmalzpp": 270439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363682516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16187",
    "droptype": "D",
    "dropname": "PISGAH FOREST",
    "dropdeladd": "1 OLD HENDERSONVILLE HWY",
    "dropdelcty": "PISGAH FOREST",
    "dropdelst": "NC",
    "dropdelzpp": 287689703,
    "dropphyadd": "1 OLD HENDERSONVILLE HWY",
    "dropphycty": "PISGAH FOREST",
    "dropphyst": "NC",
    "dropphyzpp": 287689703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PISGAH FOREST",
    "dropmalst": "NC",
    "dropmalzpp": 287689998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288849069,
    "dropsitcph": 8288849069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16189",
    "droptype": "D",
    "dropname": "PITTSBORO",
    "dropdeladd": "916 EAST ST",
    "dropdelcty": "PITTSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 273120015,
    "dropphyadd": "916 EAST ST",
    "dropphycty": "PITTSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 273120015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PITTSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 273129998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9196420128,
    "dropfax": 9195427189
  },
  {
    "dcode": "D",
    "dropkey": "PY16194",
    "droptype": "D",
    "dropname": "PLEASANT GARDEN",
    "dropdeladd": "4621 PLEASANT GARDEN RD",
    "dropdelcty": "PLEASANT GARDEN",
    "dropdelst": "NC",
    "dropdelzpp": 273139528,
    "dropphyadd": "4621 PLEASANT GARDEN RD",
    "dropphycty": "PLEASANT GARDEN",
    "dropphyst": "NC",
    "dropphyzpp": 273139528,
    "dropmaladd": "4621 PLEASANT GARDEN RD",
    "dropmalcty": "PLEASANT GARDEN",
    "dropmalst": "NC",
    "dropmalzpp": 273139998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366747251,
    "dropfax": 3366745639
  },
  {
    "dcode": "D",
    "dropkey": "PY16200",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "4366 US HIGHWAY 301",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "NC",
    "dropdelzpp": 278669998,
    "dropphyadd": "4366 US HIGHWAY 301",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "NC",
    "dropphyzpp": 278669998,
    "dropmaladd": "4366 US HIGHWAY 301",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "NC",
    "dropmalzpp": 278669998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9198313642,
    "dropsitcph": 2525364393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16203",
    "droptype": "D",
    "dropname": "PLUMTREE",
    "dropdeladd": "4420 US HIGHWAY 19E S",
    "dropdelcty": "PLUMTREE",
    "dropdelst": "NC",
    "dropdelzpp": 286649800,
    "dropphyadd": "4420 US HIGHWAY 19E S",
    "dropphycty": "PLUMTREE",
    "dropphyst": "NC",
    "dropphyzpp": 286649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLUMTREE",
    "dropmalst": "NC",
    "dropmalzpp": 286649998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8287657398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16205",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "113 W MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "NC",
    "dropdelzpp": 279629998,
    "dropphyadd": "113 W MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "NC",
    "dropphyzpp": 279629998,
    "dropmaladd": "113 W MAIN ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "NC",
    "dropmalzpp": 279629998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527932642,
    "dropfax": 2527939781
  },
  {
    "dcode": "D",
    "dropkey": "PY16206",
    "droptype": "D",
    "dropname": "POINT HARBOR",
    "dropdeladd": "9142 CARATOKE HWY",
    "dropdelcty": "POINT HARBOR",
    "dropdelst": "NC",
    "dropdelzpp": 279649609,
    "dropphyadd": "9142 CARATOKE HWY",
    "dropphycty": "POINT HARBOR",
    "dropphyst": "NC",
    "dropphyzpp": 279649609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT HARBOR",
    "dropmalst": "NC",
    "dropmalzpp": 279649998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524918111,
    "dropfax": 2524915139
  },
  {
    "dcode": "D",
    "dropkey": "PY16208",
    "droptype": "D",
    "dropname": "POLKTON",
    "dropdeladd": "45 W POLK ST",
    "dropdelcty": "POLKTON",
    "dropdelst": "NC",
    "dropdelzpp": 281359663,
    "dropphyadd": "45 W POLK ST",
    "dropphycty": "POLKTON",
    "dropphyst": "NC",
    "dropphyzpp": 281359663,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLKTON",
    "dropmalst": "NC",
    "dropmalzpp": 281359998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042728280,
    "dropsitcph": 7042728280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16209",
    "droptype": "D",
    "dropname": "POLKVILLE",
    "dropdeladd": "4418 POLKVILLE RD",
    "dropdelcty": "SHELBY",
    "dropdelst": "NC",
    "dropdelzpp": 281504580,
    "dropphyadd": "4418 POLKVILLE RD",
    "dropphycty": "SHELBY",
    "dropphyst": "NC",
    "dropphyzpp": 281504580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLKVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281369998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045388416,
    "dropsitcph": 7045388416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16212",
    "droptype": "D",
    "dropname": "POLLOCKSVILLE",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "POLLOCKSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285735000,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "POLLOCKSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285735000,
    "dropmaladd": "PO BOX 28573",
    "dropmalcty": "POLLOCKSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285739998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522244971,
    "dropsitcph": 2522244971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16222",
    "droptype": "D",
    "dropname": "POPLAR BRANCH",
    "dropdeladd": "227 POPLAR BRANCH RD",
    "dropdelcty": "POPLAR BRANCH",
    "dropdelst": "NC",
    "dropdelzpp": 279659998,
    "dropphyadd": "227 POPLAR BRANCH RD",
    "dropphycty": "POPLAR BRANCH",
    "dropphyst": "NC",
    "dropphyzpp": 279659998,
    "dropmaladd": "227 POPLAR BRANCH RD",
    "dropmalcty": "POPLAR BRANCH",
    "dropmalst": "NC",
    "dropmalzpp": 279659998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524538195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16225",
    "droptype": "D",
    "dropname": "POTECASI",
    "dropdeladd": "3185 NC HIGHWAY 35",
    "dropdelcty": "POTECASI",
    "dropdelst": "NC",
    "dropdelzpp": 278679995,
    "dropphyadd": "3185 NC HIGHWAY 35",
    "dropphycty": "POTECASI",
    "dropphyst": "NC",
    "dropphyzpp": 278679995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTECASI",
    "dropmalst": "NC",
    "dropmalzpp": 278679998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525877121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16226",
    "droptype": "D",
    "dropname": "POWELLS POINT",
    "dropdeladd": "7664 CARATOKE HWY",
    "dropdelcty": "POWELLS POINT",
    "dropdelst": "NC",
    "dropdelzpp": 279669998,
    "dropphyadd": "7664 CARATOKE HWY",
    "dropphycty": "POWELLS POINT",
    "dropphyst": "NC",
    "dropphyzpp": 279669998,
    "dropmaladd": "7664 CARATOKE HWY",
    "dropmalcty": "POWELLS POINT",
    "dropmalst": "NC",
    "dropmalzpp": 279669998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524912483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16229",
    "droptype": "D",
    "dropname": "POWELLSVILLE",
    "dropdeladd": "103 BETHLEHEM CHURCH RD",
    "dropdelcty": "POWELLSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 279679700,
    "dropphyadd": "103 BETHLEHEM CHURCH RD",
    "dropphycty": "POWELLSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 279679700,
    "dropmaladd": "103 BETHLEHEM CHURCH RD",
    "dropmalcty": "POWELLSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 279679998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523323409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16235",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "107 W EDWARDS ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "NC",
    "dropdelzpp": 275699998,
    "dropphyadd": "107 W EDWARDS ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "NC",
    "dropphyzpp": 275699998,
    "dropmaladd": "107 W EDWARDS ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "NC",
    "dropmalzpp": 275699998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 9199360013,
    "dropfax": 9199362785
  },
  {
    "dcode": "D",
    "dropkey": "PY16237",
    "droptype": "D",
    "dropname": "PROCTORVILLE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "PROCTORVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283758901,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "PROCTORVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283758901,
    "dropmaladd": "PO BOX 28375",
    "dropmalcty": "PROCTORVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283759998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106280433,
    "dropsitcph": 9106280433,
    "dropfax": 9106281557
  },
  {
    "dcode": "D",
    "dropkey": "PY16241",
    "droptype": "D",
    "dropname": "PROSPECT HILL",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "PROSPECT HILL",
    "dropdelst": "NC",
    "dropdelzpp": 273149898,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "PROSPECT HILL",
    "dropphyst": "NC",
    "dropphyzpp": 273149898,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PROSPECT HILL",
    "dropmalst": "NC",
    "dropmalzpp": 273149998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365625440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16244",
    "droptype": "D",
    "dropname": "PROVIDENCE",
    "dropdeladd": "48 PARK SPRINGS RD",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "NC",
    "dropdelzpp": 273159581,
    "dropphyadd": "48 PARK SPRINGS RD",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "NC",
    "dropphyzpp": 273159581,
    "dropmaladd": "48 PARK SPRINGS RD",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "NC",
    "dropmalzpp": 273159998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363885211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16249",
    "droptype": "D",
    "dropname": "PURLEAR",
    "dropdeladd": "226 PURLEAR RD",
    "dropdelcty": "PURLEAR",
    "dropdelst": "NC",
    "dropdelzpp": 286659246,
    "dropphyadd": "226 PURLEAR RD",
    "dropphycty": "PURLEAR",
    "dropphyst": "NC",
    "dropphyzpp": 286659246,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PURLEAR",
    "dropmalst": "NC",
    "dropmalzpp": 286659998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368183205,
    "dropfax": 3369735523
  },
  {
    "dcode": "D",
    "dropkey": "PY16257",
    "droptype": "D",
    "dropname": "RAEFORD",
    "dropdeladd": "122 W ELWOOD AVE STE 102",
    "dropdelcty": "RAEFORD",
    "dropdelst": "NC",
    "dropdelzpp": 283762800,
    "dropphyadd": "122 W ELWOOD AVE STE 102",
    "dropphycty": "RAEFORD",
    "dropphyst": "NC",
    "dropphyzpp": 283762800,
    "dropmaladd": "PO BOX 28376",
    "dropmalcty": "RAEFORD",
    "dropmalst": "NC",
    "dropmalzpp": 283769998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108753859,
    "dropsitcph": 9108753859,
    "dropfax": 9108757548
  },
  {
    "dcode": "D",
    "dropkey": "PY16260",
    "droptype": "D",
    "dropname": "RALEIGH",
    "dropdeladd": "1 FLORETTA PL RM 88",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276769803,
    "dropphyadd": "1 FLORETTA PL RM 88",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276769803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276769998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16263",
    "droptype": "D",
    "dropname": "RAMSEUR",
    "dropdeladd": "1514 MAIN ST",
    "dropdelcty": "RAMSEUR",
    "dropdelst": "NC",
    "dropdelzpp": 273168329,
    "dropphyadd": "1514 MAIN ST",
    "dropphycty": "RAMSEUR",
    "dropphyst": "NC",
    "dropphyzpp": 273168329,
    "dropmaladd": "1514 MAIN ST",
    "dropmalcty": "RAMSEUR",
    "dropmalst": "NC",
    "dropmalzpp": 273169998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368242503,
    "dropfax": 3368241308
  },
  {
    "dcode": "D",
    "dropkey": "PY16264",
    "droptype": "D",
    "dropname": "RANDLEMAN",
    "dropdeladd": "611 W ACADEMY ST",
    "dropdelcty": "RANDLEMAN",
    "dropdelst": "NC",
    "dropdelzpp": 273179719,
    "dropphyadd": "611 W ACADEMY ST",
    "dropphycty": "RANDLEMAN",
    "dropphyst": "NC",
    "dropphyzpp": 273179719,
    "dropmaladd": "611 W ACADEMY ST",
    "dropmalcty": "RANDLEMAN",
    "dropmalst": "NC",
    "dropmalzpp": 273179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364986894,
    "dropfax": 3364985725
  },
  {
    "dcode": "D",
    "dropkey": "PY16272",
    "droptype": "D",
    "dropname": "RED OAK",
    "dropdeladd": "8382 RED OAK BLVD",
    "dropdelcty": "RED OAK",
    "dropdelst": "NC",
    "dropdelzpp": 278689800,
    "dropphyadd": "8382 RED OAK BLVD",
    "dropphycty": "RED OAK",
    "dropphyst": "NC",
    "dropphyzpp": 278689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED OAK",
    "dropmalst": "NC",
    "dropmalzpp": 278689998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524433857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16275",
    "droptype": "D",
    "dropname": "RED SPRINGS",
    "dropdeladd": "230 S MAIN ST",
    "dropdelcty": "RED SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 283771622,
    "dropphyadd": "230 S MAIN ST",
    "dropphycty": "RED SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 283771622,
    "dropmaladd": "PO BOX 28377",
    "dropmalcty": "RED SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 283779998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108432972,
    "dropsitcph": 9108432972,
    "dropfax": 9108432596
  },
  {
    "dcode": "D",
    "dropkey": "PY16281",
    "droptype": "D",
    "dropname": "REIDSVILLE",
    "dropdeladd": "201 PIEDMONT ST",
    "dropdelcty": "REIDSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 273203890,
    "dropphyadd": "201 PIEDMONT ST",
    "dropphycty": "REIDSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 273203890,
    "dropmaladd": "201 PIEDMONT ST",
    "dropmalcty": "REIDSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 273209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363427480,
    "dropfax": 3363497837
  },
  {
    "dcode": "D",
    "dropkey": "PY16291",
    "droptype": "D",
    "dropname": "REX",
    "dropdeladd": "1045 REX RD",
    "dropdelcty": "REX",
    "dropdelst": "NC",
    "dropdelzpp": 283788901,
    "dropphyadd": "1045 REX RD",
    "dropphycty": "REX",
    "dropphyst": "NC",
    "dropphyzpp": 283788901,
    "dropmaladd": "PO BOX 28378",
    "dropmalcty": "REX",
    "dropmalst": "NC",
    "dropmalzpp": 283789998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108433447,
    "dropsitcph": 9108433447,
    "dropfax": 9108431570
  },
  {
    "dcode": "D",
    "dropkey": "PY16294",
    "droptype": "D",
    "dropname": "RHODHISS",
    "dropdeladd": "206 CHURCH ST",
    "dropdelcty": "RHODHISS",
    "dropdelst": "NC",
    "dropdelzpp": 286679800,
    "dropphyadd": "206 CHURCH ST",
    "dropphycty": "RHODHISS",
    "dropphyst": "NC",
    "dropphyzpp": 286679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RHODHISS",
    "dropmalst": "NC",
    "dropmalzpp": 286679998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283963172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16297",
    "droptype": "D",
    "dropname": "RICH SQUARE",
    "dropdeladd": "113 W JACKSON ST",
    "dropdelcty": "RICH SQUARE",
    "dropdelst": "NC",
    "dropdelzpp": 278699998,
    "dropphyadd": "113 W JACKSON ST",
    "dropphycty": "RICH SQUARE",
    "dropphyst": "NC",
    "dropphyzpp": 278699998,
    "dropmaladd": "113 W JACKSON ST",
    "dropmalcty": "RICH SQUARE",
    "dropmalst": "NC",
    "dropmalzpp": 278699998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525392991,
    "dropfax": 2525392831
  },
  {
    "dcode": "D",
    "dropkey": "PY16298",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "212 NC HWY 49 N",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 281377970,
    "dropphyadd": "212 NC HWY 49 N",
    "dropphycty": "RICHFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 281377970,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 281379998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044637863,
    "dropsitcph": 7044637863,
    "dropfax": 7044631988
  },
  {
    "dcode": "D",
    "dropkey": "PY16300",
    "droptype": "D",
    "dropname": "RICHLANDS",
    "dropdeladd": "8201 RICHLANDS HWY",
    "dropdelcty": "RICHLANDS",
    "dropdelst": "NC",
    "dropdelzpp": 285747403,
    "dropphyadd": "8201 RICHLANDS HWY",
    "dropphycty": "RICHLANDS",
    "dropphyst": "NC",
    "dropphyzpp": 285747403,
    "dropmaladd": "PO BOX 28574",
    "dropmalcty": "RICHLANDS",
    "dropmalst": "NC",
    "dropmalzpp": 285749998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103244332,
    "dropsitcph": 9103244332,
    "dropfax": 9103241643
  },
  {
    "dcode": "D",
    "dropkey": "PY16303",
    "droptype": "D",
    "dropname": "RIDGECREST",
    "dropdeladd": "2 TUCKER RD",
    "dropdelcty": "RIDGECREST",
    "dropdelst": "NC",
    "dropdelzpp": 287708000,
    "dropphyadd": "2 TUCKER RD",
    "dropphycty": "RIDGECREST",
    "dropphyst": "NC",
    "dropphyzpp": 287708000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGECREST",
    "dropmalst": "NC",
    "dropmalzpp": 287709998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286692620,
    "dropsitcph": 8286692620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16305",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "686 US HIGHWAY 1 S",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "NC",
    "dropdelzpp": 275709998,
    "dropphyadd": "686 US HIGHWAY 1 S",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "NC",
    "dropphyzpp": 275709998,
    "dropmaladd": "686 US HIGHWAY 1 S",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "NC",
    "dropmalzpp": 275709998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524559017,
    "dropfax": 2524562014
  },
  {
    "dcode": "D",
    "dropkey": "PY16306",
    "droptype": "D",
    "dropname": "RIEGELWOOD",
    "dropdeladd": "208 RIEGELWOOD SHOPPING CTR",
    "dropdelcty": "RIEGELWOOD",
    "dropdelst": "NC",
    "dropdelzpp": 284568689,
    "dropphyadd": "208 RIEGELWOOD SHOPPING CTR",
    "dropphycty": "RIEGELWOOD",
    "dropphyst": "NC",
    "dropphyzpp": 284568689,
    "dropmaladd": "PO BOX 28456",
    "dropmalcty": "RIEGELWOOD",
    "dropmalst": "NC",
    "dropmalzpp": 284569998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106552564,
    "dropsitcph": 9106552564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16311",
    "droptype": "D",
    "dropname": "ROANOKE RAPIDS",
    "dropdeladd": "725 ROANOKE AVE",
    "dropdelcty": "ROANOKE RAPIDS",
    "dropdelst": "NC",
    "dropdelzpp": 278709998,
    "dropphyadd": "725 ROANOKE AVE",
    "dropphycty": "ROANOKE RAPIDS",
    "dropphyst": "NC",
    "dropphyzpp": 278709998,
    "dropmaladd": "725 ROANOKE AVE",
    "dropmalcty": "ROANOKE RAPIDS",
    "dropmalst": "NC",
    "dropmalzpp": 278709998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525376031,
    "dropfax": 2525375302
  },
  {
    "dcode": "D",
    "dropkey": "PY16315",
    "droptype": "D",
    "dropname": "ROARING GAP",
    "dropdeladd": "11370 US HIGHWAY 21 S",
    "dropdelcty": "ROARING GAP",
    "dropdelst": "NC",
    "dropdelzpp": 286689998,
    "dropphyadd": "11370 US HIGHWAY 21 S",
    "dropphycty": "ROARING GAP",
    "dropphyst": "NC",
    "dropphyzpp": 286689998,
    "dropmaladd": "11370 US HIGHWAY 21 S",
    "dropmalcty": "ROARING GAP",
    "dropmalst": "NC",
    "dropmalzpp": 286689998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363632822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16317",
    "droptype": "D",
    "dropname": "ROARING RIVER",
    "dropdeladd": "7953 ELKIN HIGHWAY 268",
    "dropdelcty": "ROARING RIVER",
    "dropdelst": "NC",
    "dropdelzpp": 286699800,
    "dropphyadd": "7953 ELKIN HIGHWAY 268",
    "dropphycty": "ROARING RIVER",
    "dropphyst": "NC",
    "dropphyzpp": 286699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROARING RIVER",
    "dropmalst": "NC",
    "dropmalzpp": 286699998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366962028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16318",
    "droptype": "D",
    "dropname": "ROBBINS",
    "dropdeladd": "181 N MIDDLETON ST",
    "dropdelcty": "ROBBINS",
    "dropdelst": "NC",
    "dropdelzpp": 273258416,
    "dropphyadd": "181 N MIDDLETON ST",
    "dropphycty": "ROBBINS",
    "dropphyst": "NC",
    "dropphyzpp": 273258416,
    "dropmaladd": "181 N MIDDLETON ST",
    "dropmalcty": "ROBBINS",
    "dropmalst": "NC",
    "dropmalzpp": 273259998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9109482230,
    "dropfax": 3369484794
  },
  {
    "dcode": "D",
    "dropkey": "PY16319",
    "droptype": "D",
    "dropname": "ROBBINSVILLE",
    "dropdeladd": "74 SWEETWATER RD",
    "dropdelcty": "ROBBINSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287719401,
    "dropphyadd": "74 SWEETWATER RD",
    "dropphycty": "ROBBINSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287719401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBBINSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287719998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284793397,
    "dropsitcph": 8284793397,
    "dropfax": 8284792597
  },
  {
    "dcode": "D",
    "dropkey": "PY16322",
    "droptype": "D",
    "dropname": "ROBERSONVILLE",
    "dropdeladd": "113 SW RAILROAD ST",
    "dropdelcty": "ROBERSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278719200,
    "dropphyadd": "113 SW RAILROAD ST",
    "dropphycty": "ROBERSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278719200,
    "dropmaladd": "113 SW RAILROAD ST",
    "dropmalcty": "ROBERSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278719998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527954838,
    "dropfax": 2527954599
  },
  {
    "dcode": "D",
    "dropkey": "PY16327",
    "droptype": "D",
    "dropname": "ROCKINGHAM",
    "dropdeladd": "119 W WASHINGTON ST",
    "dropdelcty": "ROCKINGHAM",
    "dropdelst": "NC",
    "dropdelzpp": 283793583,
    "dropphyadd": "119 W WASHINGTON ST",
    "dropphycty": "ROCKINGHAM",
    "dropphyst": "NC",
    "dropphyzpp": 283793583,
    "dropmaladd": "PO BOX 28379",
    "dropmalcty": "ROCKINGHAM",
    "dropmalst": "NC",
    "dropmalzpp": 283799998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108957016,
    "dropsitcph": 9108957016,
    "dropfax": 9109976859
  },
  {
    "dcode": "D",
    "dropkey": "PY16329",
    "droptype": "D",
    "dropname": "ROCKWELL",
    "dropdeladd": "100 BROAD ST",
    "dropdelcty": "ROCKWELL",
    "dropdelst": "NC",
    "dropdelzpp": 281388888,
    "dropphyadd": "100 BROAD ST",
    "dropphycty": "ROCKWELL",
    "dropphyst": "NC",
    "dropphyzpp": 281388888,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKWELL",
    "dropmalst": "NC",
    "dropmalzpp": 281389998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042797048,
    "dropsitcph": 7042797048,
    "dropfax": 7042792095
  },
  {
    "dcode": "D",
    "dropkey": "PY16331",
    "droptype": "D",
    "dropname": "ROCKY MOUNT",
    "dropdeladd": "327 E RALEIGH BLVD",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278019998,
    "dropphyadd": "327 E RALEIGH BLVD",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278019998,
    "dropmaladd": "327 E RALEIGH BLVD",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278019998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524071047,
    "dropfax": 2524071084
  },
  {
    "dcode": "D",
    "dropkey": "PY16333",
    "droptype": "D",
    "dropname": "ROCKY POINT",
    "dropdeladd": "7974 US HWY 117 S",
    "dropdelcty": "ROCKY POINT",
    "dropdelst": "NC",
    "dropdelzpp": 284578410,
    "dropphyadd": "7974 US HWY 117 S",
    "dropphycty": "ROCKY POINT",
    "dropphyst": "NC",
    "dropphyzpp": 284578410,
    "dropmaladd": "PO BOX 28457",
    "dropmalcty": "ROCKY POINT",
    "dropmalst": "NC",
    "dropmalzpp": 284579998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106752352,
    "dropsitcph": 9106752352,
    "dropfax": 9106753075
  },
  {
    "dcode": "D",
    "dropkey": "PY16335",
    "droptype": "D",
    "dropname": "RODANTHE",
    "dropdeladd": "25969 NC HIGHWAY 12",
    "dropdelcty": "RODANTHE",
    "dropdelst": "NC",
    "dropdelzpp": 279689998,
    "dropphyadd": "25969 NC HIGHWAY 12",
    "dropphycty": "RODANTHE",
    "dropphyst": "NC",
    "dropphyzpp": 279689998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RODANTHE",
    "dropmalst": "NC",
    "dropmalzpp": 279689902,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529872273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16336",
    "droptype": "D",
    "dropname": "RODUCO",
    "dropdeladd": "1453 US HIGHWAY 158 W",
    "dropdelcty": "RODUCO",
    "dropdelst": "NC",
    "dropdelzpp": 279699900,
    "dropphyadd": "1453 US HIGHWAY 158 W",
    "dropphycty": "RODUCO",
    "dropphyst": "NC",
    "dropphyzpp": 279699900,
    "dropmaladd": "1453 US HIGHWAY 158 W",
    "dropmalcty": "RODUCO",
    "dropmalst": "NC",
    "dropmalzpp": 279699900,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523570410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16337",
    "droptype": "D",
    "dropname": "ROLESVILLE",
    "dropdeladd": "6470 ROGERS RD",
    "dropdelcty": "ROLESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 275719998,
    "dropphyadd": "6470 ROGERS RD",
    "dropphycty": "ROLESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 275719998,
    "dropmaladd": "6470 ROGERS RD",
    "dropmalcty": "ROLESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 275719998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194536440,
    "dropfax": 9194536441
  },
  {
    "dcode": "D",
    "dropkey": "PY16339",
    "droptype": "D",
    "dropname": "RONDA",
    "dropdeladd": "383 3RD ST",
    "dropdelcty": "RONDA",
    "dropdelst": "NC",
    "dropdelzpp": 286709998,
    "dropphyadd": "383 3RD ST",
    "dropphycty": "RONDA",
    "dropphyst": "NC",
    "dropphyzpp": 286709998,
    "dropmaladd": "383 3RD ST",
    "dropmalcty": "RONDA",
    "dropmalst": "NC",
    "dropmalzpp": 286709998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368356812,
    "dropfax": 3368353850
  },
  {
    "dcode": "D",
    "dropkey": "PY16340",
    "droptype": "D",
    "dropname": "ROPER",
    "dropdeladd": "101 W HIGHWAY 64 BYP",
    "dropdelcty": "ROPER",
    "dropdelst": "NC",
    "dropdelzpp": 279709998,
    "dropphyadd": "101 W HIGHWAY 64 BYP",
    "dropphycty": "ROPER",
    "dropphyst": "NC",
    "dropphyzpp": 279709998,
    "dropmaladd": "101 W HIGHWAY 64 BYP",
    "dropmalcty": "ROPER",
    "dropmalst": "NC",
    "dropmalzpp": 279709998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527935537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16341",
    "droptype": "D",
    "dropname": "ROSE HILL",
    "dropdeladd": "128 E CHURCH ST",
    "dropdelcty": "ROSE HILL",
    "dropdelst": "NC",
    "dropdelzpp": 284587412,
    "dropphyadd": "128 E CHURCH ST",
    "dropphycty": "ROSE HILL",
    "dropphyst": "NC",
    "dropphyzpp": 284587412,
    "dropmaladd": "PO BOX 28458",
    "dropmalcty": "ROSE HILL",
    "dropmalst": "NC",
    "dropmalzpp": 284589998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102892348,
    "dropsitcph": 9102892348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16343",
    "droptype": "D",
    "dropname": "ROSEBORO",
    "dropdeladd": "201 W PLEASANT ST",
    "dropdelcty": "ROSEBORO",
    "dropdelst": "NC",
    "dropdelzpp": 283828910,
    "dropphyadd": "201 W PLEASANT ST",
    "dropphycty": "ROSEBORO",
    "dropphyst": "NC",
    "dropphyzpp": 283828910,
    "dropmaladd": "PO BOX 28382",
    "dropmalcty": "ROSEBORO",
    "dropmalst": "NC",
    "dropmalzpp": 283829998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105255418,
    "dropsitcph": 9105255418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16345",
    "droptype": "D",
    "dropname": "ROSMAN",
    "dropdeladd": "272 MAIN ST",
    "dropdelcty": "ROSMAN",
    "dropdelst": "NC",
    "dropdelzpp": 287729769,
    "dropphyadd": "272 MAIN ST",
    "dropphycty": "ROSMAN",
    "dropphyst": "NC",
    "dropphyzpp": 287729769,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSMAN",
    "dropmalst": "NC",
    "dropmalzpp": 287729998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288624745,
    "dropsitcph": 8288624745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16346",
    "droptype": "D",
    "dropname": "ROUGEMONT",
    "dropdeladd": "12311 ROXBORO RD",
    "dropdelcty": "ROUGEMONT",
    "dropdelst": "NC",
    "dropdelzpp": 275729998,
    "dropphyadd": "12311 ROXBORO RD",
    "dropphycty": "ROUGEMONT",
    "dropphyst": "NC",
    "dropphyzpp": 275729998,
    "dropmaladd": "12311 ROXBORO RD",
    "dropmalcty": "ROUGEMONT",
    "dropmalst": "NC",
    "dropmalzpp": 275729998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194777809,
    "dropfax": 9194777809
  },
  {
    "dcode": "D",
    "dropkey": "PY16348",
    "droptype": "D",
    "dropname": "ROWLAND",
    "dropdeladd": "202 N BOND ST",
    "dropdelcty": "ROWLAND",
    "dropdelst": "NC",
    "dropdelzpp": 283839770,
    "dropphyadd": "202 N BOND ST",
    "dropphycty": "ROWLAND",
    "dropphyst": "NC",
    "dropphyzpp": 283839770,
    "dropmaladd": "PO BOX 28383",
    "dropmalcty": "ROWLAND",
    "dropmalst": "NC",
    "dropmalzpp": 283839998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104223016,
    "dropsitcph": 9104223016,
    "dropfax": 9104220797
  },
  {
    "dcode": "D",
    "dropkey": "PY16349",
    "droptype": "D",
    "dropname": "ROXBORO",
    "dropdeladd": "223 S MAIN ST",
    "dropdelcty": "ROXBORO",
    "dropdelst": "NC",
    "dropdelzpp": 275739998,
    "dropphyadd": "223 S MAIN ST",
    "dropphycty": "ROXBORO",
    "dropphyst": "NC",
    "dropphyzpp": 275739998,
    "dropmaladd": "223 S MAIN ST",
    "dropmalcty": "ROXBORO",
    "dropmalst": "NC",
    "dropmalzpp": 275739998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 3363300395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16350",
    "droptype": "D",
    "dropname": "ROXOBEL",
    "dropdeladd": "106 W CHURCH ST",
    "dropdelcty": "ROXOBEL",
    "dropdelst": "NC",
    "dropdelzpp": 278729998,
    "dropphyadd": "106 W CHURCH ST",
    "dropphycty": "ROXOBEL",
    "dropphyst": "NC",
    "dropphyzpp": 278729998,
    "dropmaladd": "106 W CHURCH ST",
    "dropmalcty": "ROXOBEL",
    "dropmalst": "NC",
    "dropmalzpp": 278729998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523442301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16355",
    "droptype": "D",
    "dropname": "RUFFIN",
    "dropdeladd": "9682 US HIGHWAY 29 BUSINESS",
    "dropdelcty": "RUFFIN",
    "dropdelst": "NC",
    "dropdelzpp": 273269453,
    "dropphyadd": "9682 US HIGHWAY 29 BUSINESS",
    "dropphycty": "RUFFIN",
    "dropphyst": "NC",
    "dropphyzpp": 273269453,
    "dropmaladd": "9682 US HIGHWAY 29 BUSINESS",
    "dropmalcty": "RUFFIN",
    "dropmalst": "NC",
    "dropmalzpp": 273269998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369397969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16356",
    "droptype": "D",
    "dropname": "RURAL HALL",
    "dropdeladd": "8201 BROAD ST",
    "dropdelcty": "RURAL HALL",
    "dropdelst": "NC",
    "dropdelzpp": 270459400,
    "dropphyadd": "8201 BROAD ST",
    "dropphycty": "RURAL HALL",
    "dropphyst": "NC",
    "dropphyzpp": 270459400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RURAL HALL",
    "dropmalst": "NC",
    "dropmalzpp": 270459998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369692515,
    "dropfax": 3369694740
  },
  {
    "dcode": "D",
    "dropkey": "PY16361",
    "droptype": "D",
    "dropname": "RUTHERFORD COLLEGE",
    "dropdeladd": "721C MALCOLM BLVD",
    "dropdelcty": "RUTHERFORD COLLEGE",
    "dropdelst": "NC",
    "dropdelzpp": 286719995,
    "dropphyadd": "721C MALCOLM BLVD",
    "dropphycty": "RUTHERFORD COLLEGE",
    "dropphyst": "NC",
    "dropphyzpp": 286719995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTHERFORD COLLEGE",
    "dropmalst": "NC",
    "dropmalzpp": 286719998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8288740048,
    "dropfax": 8288740937
  },
  {
    "dcode": "D",
    "dropkey": "PY16363",
    "droptype": "D",
    "dropname": "RUTHERFORDTON",
    "dropdeladd": "130 E COURT ST",
    "dropdelcty": "RUTHERFORDTON",
    "dropdelst": "NC",
    "dropdelzpp": 281399702,
    "dropphyadd": "130 E COURT ST",
    "dropphycty": "RUTHERFORDTON",
    "dropphyst": "NC",
    "dropphyzpp": 281399702,
    "dropmaladd": "130 E COURT ST",
    "dropmalcty": "RUTHERFORDTON",
    "dropmalst": "NC",
    "dropmalzpp": 281399702,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042873750,
    "dropsitcph": 8282873750,
    "dropfax": 8282878691
  },
  {
    "dcode": "D",
    "dropkey": "PY16370",
    "droptype": "D",
    "dropname": "SAINT PAULS",
    "dropdeladd": "320 W BROAD ST",
    "dropdelcty": "SAINT PAULS",
    "dropdelst": "NC",
    "dropdelzpp": 283841536,
    "dropphyadd": "320 W BROAD ST",
    "dropphycty": "SAINT PAULS",
    "dropphyst": "NC",
    "dropphyzpp": 283841536,
    "dropmaladd": "PO BOX 28384",
    "dropmalcty": "SAINT PAULS",
    "dropmalst": "NC",
    "dropmalzpp": 283849998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108654159,
    "dropsitcph": 9108654159,
    "dropfax": 9108653125
  },
  {
    "dcode": "D",
    "dropkey": "PY16373",
    "droptype": "D",
    "dropname": "SALEMBURG",
    "dropdeladd": "108 W CLINTON ST",
    "dropdelcty": "SALEMBURG",
    "dropdelst": "NC",
    "dropdelzpp": 283858688,
    "dropphyadd": "108 W CLINTON ST",
    "dropphycty": "SALEMBURG",
    "dropphyst": "NC",
    "dropphyzpp": 283858688,
    "dropmaladd": "PO BOX 28385",
    "dropmalcty": "SALEMBURG",
    "dropmalst": "NC",
    "dropmalzpp": 283859998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105254457,
    "dropsitcph": 9105254457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16375",
    "droptype": "D",
    "dropname": "SALISBURY",
    "dropdeladd": "605 E INNES ST",
    "dropdelcty": "SALISBURY",
    "dropdelst": "NC",
    "dropdelzpp": 281445113,
    "dropphyadd": "605 E INNES ST",
    "dropphycty": "SALISBURY",
    "dropphyst": "NC",
    "dropphyzpp": 281445113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALISBURY",
    "dropmalst": "NC",
    "dropmalzpp": 281449998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046367821,
    "dropsitcph": 7046367821,
    "dropfax": 7046375616
  },
  {
    "dcode": "D",
    "dropkey": "PY16377",
    "droptype": "D",
    "dropname": "SALUDA",
    "dropdeladd": "102 E MAIN ST",
    "dropdelcty": "SALUDA",
    "dropdelst": "NC",
    "dropdelzpp": 287737812,
    "dropphyadd": "102 E MAIN ST",
    "dropphycty": "SALUDA",
    "dropphyst": "NC",
    "dropphyzpp": 287737812,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALUDA",
    "dropmalst": "NC",
    "dropmalzpp": 287739998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287495921,
    "dropsitcph": 8287495921,
    "dropfax": 8287491607
  },
  {
    "dcode": "D",
    "dropkey": "PY16383",
    "droptype": "D",
    "dropname": "SANDY RIDGE",
    "dropdeladd": "4918 NC 704 HWY E",
    "dropdelcty": "SANDY RIDGE",
    "dropdelst": "NC",
    "dropdelzpp": 270469998,
    "dropphyadd": "4918 NC 704 HWY E",
    "dropphycty": "SANDY RIDGE",
    "dropphyst": "NC",
    "dropphyzpp": 270469998,
    "dropmaladd": "4918 NC 704 HWY E",
    "dropmalcty": "SANDY RIDGE",
    "dropmalst": "NC",
    "dropmalzpp": 270469998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368712950,
    "dropfax": 3368712460
  },
  {
    "dcode": "D",
    "dropkey": "PY16384",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "1200 S HORNER BLVD",
    "dropdelcty": "SANFORD",
    "dropdelst": "NC",
    "dropdelzpp": 273309998,
    "dropphyadd": "1200 S HORNER BLVD",
    "dropphycty": "SANFORD",
    "dropphyst": "NC",
    "dropphyzpp": 273309998,
    "dropmaladd": "1200 S HORNER BLVD",
    "dropmalcty": "SANFORD",
    "dropmalst": "NC",
    "dropmalzpp": 273305626,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9197744926,
    "dropfax": 9197745909
  },
  {
    "dcode": "D",
    "dropkey": "PY16385",
    "droptype": "D",
    "dropname": "SAPPHIRE",
    "dropdeladd": "17740 ROSMAN HWY",
    "dropdelcty": "SAPPHIRE",
    "dropdelst": "NC",
    "dropdelzpp": 287747908,
    "dropphyadd": "17740 ROSMAN HWY",
    "dropphycty": "SAPPHIRE",
    "dropphyst": "NC",
    "dropphyzpp": 287747908,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAPPHIRE",
    "dropmalst": "NC",
    "dropmalzpp": 287749998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8289664787,
    "dropsitcph": 8289664787,
    "dropfax": 8289664787
  },
  {
    "dcode": "D",
    "dropkey": "PY16386",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "6744 MAIN ST",
    "dropdelcty": "SARATOGA",
    "dropdelst": "NC",
    "dropdelzpp": 278739700,
    "dropphyadd": "6744 MAIN ST",
    "dropphycty": "SARATOGA",
    "dropphyst": "NC",
    "dropphyzpp": 278739700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARATOGA",
    "dropmalst": "NC",
    "dropmalzpp": 278739998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522382136,
    "dropfax": 2522382136
  },
  {
    "dcode": "D",
    "dropkey": "PY16389",
    "droptype": "D",
    "dropname": "SAXAPAHAW",
    "dropdeladd": "1612 JORDAN DR",
    "dropdelcty": "SAXAPAHAW",
    "dropdelst": "NC",
    "dropdelzpp": 273409800,
    "dropphyadd": "1612 JORDAN DR",
    "dropphycty": "SAXAPAHAW",
    "dropphyst": "NC",
    "dropphyzpp": 273409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAXAPAHAW",
    "dropmalst": "NC",
    "dropmalzpp": 273409998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363766977,
    "dropfax": 3363763054
  },
  {
    "dcode": "D",
    "dropkey": "PY16390",
    "droptype": "D",
    "dropname": "SCALY MOUNTAIN",
    "dropdeladd": "7312 DILLARD RD",
    "dropdelcty": "SCALY MOUNTAIN",
    "dropdelst": "NC",
    "dropdelzpp": 287759612,
    "dropphyadd": "7312 DILLARD RD",
    "dropphycty": "SCALY MOUNTAIN",
    "dropphyst": "NC",
    "dropphyzpp": 287759612,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCALY MOUNTAIN",
    "dropmalst": "NC",
    "dropmalzpp": 287759998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285265611,
    "dropsitcph": 8285265611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16393",
    "droptype": "D",
    "dropname": "SCOTLAND NECK",
    "dropdeladd": "1015 MAIN ST",
    "dropdelcty": "SCOTLAND NECK",
    "dropdelst": "NC",
    "dropdelzpp": 278749998,
    "dropphyadd": "1015 MAIN ST",
    "dropphycty": "SCOTLAND NECK",
    "dropphyst": "NC",
    "dropphyzpp": 278749998,
    "dropmaladd": "1015 MAIN ST",
    "dropmalcty": "SCOTLAND NECK",
    "dropmalst": "NC",
    "dropmalzpp": 278749998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528264812,
    "dropfax": 2528263989
  },
  {
    "dcode": "D",
    "dropkey": "PY16395",
    "droptype": "D",
    "dropname": "SCOTTS",
    "dropdeladd": "4700 TAYLORSVILLE RD",
    "dropdelcty": "SCOTTS",
    "dropdelst": "NC",
    "dropdelzpp": 286999998,
    "dropphyadd": "4700 TAYLORSVILLE RD",
    "dropphycty": "SCOTTS",
    "dropphyst": "NC",
    "dropphyzpp": 286999998,
    "dropmaladd": "4700 TAYLORSVILLE RD",
    "dropmalcty": "SCOTTS",
    "dropmalst": "NC",
    "dropmalzpp": 286999998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7045852788,
    "dropfax": 7045852788
  },
  {
    "dcode": "D",
    "dropkey": "PY16399",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "500 OLD US HIGHWAY 264",
    "dropdelcty": "SCRANTON",
    "dropdelst": "NC",
    "dropdelzpp": 278759513,
    "dropphyadd": "500 OLD US HIGHWAY 264",
    "dropphycty": "SCRANTON",
    "dropphyst": "NC",
    "dropphyzpp": 278759513,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCRANTON",
    "dropmalst": "NC",
    "dropmalzpp": 278759998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529265621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16400",
    "droptype": "D",
    "dropname": "SEABOARD",
    "dropdeladd": "204 S MAIN ST",
    "dropdelcty": "SEABOARD",
    "dropdelst": "NC",
    "dropdelzpp": 278769998,
    "dropphyadd": "204 S MAIN ST",
    "dropphycty": "SEABOARD",
    "dropphyst": "NC",
    "dropphyzpp": 278769998,
    "dropmaladd": "204 S MAIN ST",
    "dropmalcty": "SEABOARD",
    "dropmalst": "NC",
    "dropmalzpp": 278769998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525895961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16401",
    "droptype": "D",
    "dropname": "SEAGROVE",
    "dropdeladd": "231 N BROAD ST",
    "dropdelcty": "SEAGROVE",
    "dropdelst": "NC",
    "dropdelzpp": 273419200,
    "dropphyadd": "231 N BROAD ST",
    "dropphycty": "SEAGROVE",
    "dropphyst": "NC",
    "dropphyzpp": 273419200,
    "dropmaladd": "231 N BROAD ST",
    "dropmalcty": "SEAGROVE",
    "dropmalst": "NC",
    "dropmalzpp": 273419998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368737351,
    "dropfax": 3368739269
  },
  {
    "dcode": "D",
    "dropkey": "PY16402",
    "droptype": "D",
    "dropname": "SEALEVEL",
    "dropdeladd": "751 HWY 70 SEA LEVEL",
    "dropdelcty": "SEALEVEL",
    "dropdelst": "NC",
    "dropdelzpp": 285779609,
    "dropphyadd": "751 HWY 70 SEA LEVEL",
    "dropphycty": "SEALEVEL",
    "dropphyst": "NC",
    "dropphyzpp": 285779609,
    "dropmaladd": "PO BOX 28577",
    "dropmalcty": "SEALEVEL",
    "dropmalst": "NC",
    "dropmalzpp": 285779998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522254791,
    "dropsitcph": 2522254791,
    "dropfax": 2522254791
  },
  {
    "dcode": "D",
    "dropkey": "PY16404",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "6147 BURLINGTON RD",
    "dropdelcty": "SEDALIA",
    "dropdelst": "NC",
    "dropdelzpp": 273429900,
    "dropphyadd": "6147 BURLINGTON RD",
    "dropphycty": "SEDALIA",
    "dropphyst": "NC",
    "dropphyzpp": 273429900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEDALIA",
    "dropmalst": "NC",
    "dropmalzpp": 273429998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364496755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16408",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "308 N RAIFORD ST",
    "dropdelcty": "SELMA",
    "dropdelst": "NC",
    "dropdelzpp": 275769998,
    "dropphyadd": "308 N RAIFORD ST",
    "dropphycty": "SELMA",
    "dropphyst": "NC",
    "dropphyzpp": 275769998,
    "dropmaladd": "308 N RAIFORD ST",
    "dropmalcty": "SELMA",
    "dropmalst": "NC",
    "dropmalzpp": 275769998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199650669,
    "dropfax": 9199652651
  },
  {
    "dcode": "D",
    "dropkey": "PY16409",
    "droptype": "D",
    "dropname": "SEMORA",
    "dropdeladd": "14757 NC HIGHWAY 119 N",
    "dropdelcty": "SEMORA",
    "dropdelst": "NC",
    "dropdelzpp": 273439515,
    "dropphyadd": "14757 NC HIGHWAY 119 N",
    "dropphycty": "SEMORA",
    "dropphyst": "NC",
    "dropphyzpp": 273439515,
    "dropmaladd": "14757 NC HIGHWAY 119 N",
    "dropmalcty": "SEMORA",
    "dropmalst": "NC",
    "dropmalzpp": 273439998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362348550,
    "dropfax": 3362348361
  },
  {
    "dcode": "D",
    "dropkey": "PY16414",
    "droptype": "D",
    "dropname": "SEVEN SPRINGS",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "SEVEN SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 285788591,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "SEVEN SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 285788591,
    "dropmaladd": "PO BOX 28578",
    "dropmalcty": "SEVEN SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 285789998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2525695511,
    "dropsitcph": 2525695511,
    "dropfax": 2525695511
  },
  {
    "dcode": "D",
    "dropkey": "PY16415",
    "droptype": "D",
    "dropname": "SEVERN",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "SEVERN",
    "dropdelst": "NC",
    "dropdelzpp": 278779900,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "SEVERN",
    "dropphyst": "NC",
    "dropphyzpp": 278779900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEVERN",
    "dropmalst": "NC",
    "dropmalzpp": 278779998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525850063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16421",
    "droptype": "D",
    "dropname": "SHALLOTTE",
    "dropdeladd": "209 SMITH AVE",
    "dropdelcty": "SHALLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 284704732,
    "dropphyadd": "209 SMITH AVE",
    "dropphycty": "SHALLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 284704732,
    "dropmaladd": "PO BOX 28459",
    "dropmalcty": "SHALLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 284599998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9107546336,
    "dropsitcph": 9107546336,
    "dropfax": 9107555006
  },
  {
    "dcode": "D",
    "dropkey": "PY16424",
    "droptype": "D",
    "dropname": "SHANNON",
    "dropdeladd": "14654 NC HIGHWAY 71 N",
    "dropdelcty": "SHANNON",
    "dropdelst": "NC",
    "dropdelzpp": 283868905,
    "dropphyadd": "14654 NC HIGHWAY 71 N",
    "dropphycty": "SHANNON",
    "dropphyst": "NC",
    "dropphyzpp": 283868905,
    "dropmaladd": "PO BOX 28386",
    "dropmalcty": "SHANNON",
    "dropmalst": "NC",
    "dropmalzpp": 283869998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108435831,
    "dropsitcph": 9108435831,
    "dropfax": 9108435831
  },
  {
    "dcode": "D",
    "dropkey": "PY16428",
    "droptype": "D",
    "dropname": "SHARPSBURG",
    "dropdeladd": "4241 S HATHAWAY BLVD",
    "dropdelcty": "SHARPSBURG",
    "dropdelst": "NC",
    "dropdelzpp": 278789998,
    "dropphyadd": "4241 S HATHAWAY BLVD",
    "dropphycty": "SHARPSBURG",
    "dropphyst": "NC",
    "dropphyzpp": 278789998,
    "dropmaladd": "4241 S HATHAWAY BLVD",
    "dropmalcty": "SHARPSBURG",
    "dropmalst": "NC",
    "dropmalzpp": 278789998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524465277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16430",
    "droptype": "D",
    "dropname": "SHAWBORO",
    "dropdeladd": "814 SHAWBORO RD",
    "dropdelcty": "SHAWBORO",
    "dropdelst": "NC",
    "dropdelzpp": 279739711,
    "dropphyadd": "814 SHAWBORO RD",
    "dropphycty": "SHAWBORO",
    "dropphyst": "NC",
    "dropphyzpp": 279739711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAWBORO",
    "dropmalst": "NC",
    "dropmalzpp": 279739998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522322782,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16431",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "405 S DEKALB ST",
    "dropdelcty": "SHELBY",
    "dropdelst": "NC",
    "dropdelzpp": 281505977,
    "dropphyadd": "405 S DEKALB ST",
    "dropphycty": "SHELBY",
    "dropphyst": "NC",
    "dropphyzpp": 281505977,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELBY",
    "dropmalst": "NC",
    "dropmalzpp": 281509998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044870156,
    "dropsitcph": 7044870156,
    "dropfax": 7044829716
  },
  {
    "dcode": "D",
    "dropkey": "PY16433",
    "droptype": "D",
    "dropname": "SHERRILLS FORD",
    "dropdeladd": "8220 SHERRILLS FORD RD",
    "dropdelcty": "SHERRILLS FORD",
    "dropdelst": "NC",
    "dropdelzpp": 286737311,
    "dropphyadd": "8220 SHERRILLS FORD RD",
    "dropphycty": "SHERRILLS FORD",
    "dropphyst": "NC",
    "dropphyzpp": 286737311,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERRILLS FORD",
    "dropmalst": "NC",
    "dropmalzpp": 286739998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284782241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16436",
    "droptype": "D",
    "dropname": "SHILOH",
    "dropdeladd": "928 NC HIGHWAY 343 S",
    "dropdelcty": "SHILOH",
    "dropdelst": "NC",
    "dropdelzpp": 279749998,
    "dropphyadd": "928 NC HIGHWAY 343 S",
    "dropphycty": "SHILOH",
    "dropphyst": "NC",
    "dropphyzpp": 279749998,
    "dropmaladd": "928 NC HIGHWAY 343 S",
    "dropmalcty": "SHILOH",
    "dropmalst": "NC",
    "dropmalzpp": 279749998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523364219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16442",
    "droptype": "D",
    "dropname": "SILER CITY",
    "dropdeladd": "116 E RALEIGH ST",
    "dropdelcty": "SILER CITY",
    "dropdelst": "NC",
    "dropdelzpp": 273449907,
    "dropphyadd": "116 E RALEIGH ST",
    "dropphycty": "SILER CITY",
    "dropphyst": "NC",
    "dropphyzpp": 273449907,
    "dropmaladd": "116 E RALEIGH ST",
    "dropmalcty": "SILER CITY",
    "dropmalst": "NC",
    "dropmalzpp": 273449998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9197425906,
    "dropfax": 9197422141
  },
  {
    "dcode": "D",
    "dropkey": "PY16445",
    "droptype": "D",
    "dropname": "SILOAM",
    "dropdeladd": "7051 SILOAM RD",
    "dropdelcty": "SILOAM",
    "dropdelst": "NC",
    "dropdelzpp": 270479275,
    "dropphyadd": "7051 SILOAM RD",
    "dropphycty": "SILOAM",
    "dropphyst": "NC",
    "dropphyzpp": 270479275,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILOAM",
    "dropmalst": "NC",
    "dropmalzpp": 270479998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366774409,
    "dropfax": 3363744332
  },
  {
    "dcode": "D",
    "dropkey": "PY16448",
    "droptype": "D",
    "dropname": "SIMPSON",
    "dropdeladd": "2806 EDWARDS DR",
    "dropdelcty": "SIMPSON",
    "dropdelst": "NC",
    "dropdelzpp": 278799998,
    "dropphyadd": "2806 EDWARDS DR",
    "dropphycty": "SIMPSON",
    "dropphyst": "NC",
    "dropphyzpp": 278799998,
    "dropmaladd": "2806 EDWARDS DR",
    "dropmalcty": "SIMPSON",
    "dropmalst": "NC",
    "dropmalzpp": 278799998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527529929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16449",
    "droptype": "D",
    "dropname": "SIMS",
    "dropdeladd": "6404 MAIN ST",
    "dropdelcty": "SIMS",
    "dropdelst": "NC",
    "dropdelzpp": 278809800,
    "dropphyadd": "6404 MAIN ST",
    "dropphycty": "SIMS",
    "dropphyst": "NC",
    "dropphyzpp": 278809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIMS",
    "dropmalst": "NC",
    "dropmalzpp": 278809998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522378704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16450",
    "droptype": "D",
    "dropname": "SKYLAND",
    "dropdeladd": "1950 HENDERSONVILLE RD",
    "dropdelcty": "SKYLAND",
    "dropdelst": "NC",
    "dropdelzpp": 287768000,
    "dropphyadd": "1950 HENDERSONVILLE RD",
    "dropphycty": "SKYLAND",
    "dropphyst": "NC",
    "dropphyzpp": 287768000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKYLAND",
    "dropmalst": "NC",
    "dropmalzpp": 287769998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286818769,
    "dropsitcph": 8286818769,
    "dropfax": 8286818769
  },
  {
    "dcode": "D",
    "dropkey": "PY16452",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "201 N 3RD ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 275779998,
    "dropphyadd": "201 N 3RD ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 275779998,
    "dropmaladd": "201 N 3RD ST",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 275779998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199349583,
    "dropfax": 9199344095
  },
  {
    "dcode": "D",
    "dropkey": "PY16455",
    "droptype": "D",
    "dropname": "SMYRNA",
    "dropdeladd": "467 HWY 70 SMYRNA",
    "dropdelcty": "SMYRNA",
    "dropdelst": "NC",
    "dropdelzpp": 285799502,
    "dropphyadd": "467 HWY 70 SMYRNA",
    "dropphycty": "SMYRNA",
    "dropphyst": "NC",
    "dropphyzpp": 285799502,
    "dropmaladd": "PO BOX 28579",
    "dropmalcty": "SMYRNA",
    "dropmalst": "NC",
    "dropmalzpp": 285799998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527294951,
    "dropsitcph": 2527294951,
    "dropfax": 2527291529
  },
  {
    "dcode": "D",
    "dropkey": "PY16456",
    "droptype": "D",
    "dropname": "SNEADS FERRY",
    "dropdeladd": "2001 NC HIGHWAY 172",
    "dropdelcty": "SNEADS FERRY",
    "dropdelst": "NC",
    "dropdelzpp": 284606624,
    "dropphyadd": "2001 NC HIGHWAY 172",
    "dropphycty": "SNEADS FERRY",
    "dropphyst": "NC",
    "dropphyzpp": 284606624,
    "dropmaladd": "PO BOX 28460",
    "dropmalcty": "SNEADS FERRY",
    "dropmalst": "NC",
    "dropmalzpp": 284609998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103275401,
    "dropsitcph": 9103275401,
    "dropfax": 9103272843
  },
  {
    "dcode": "D",
    "dropkey": "PY16458",
    "droptype": "D",
    "dropname": "SNOW CAMP",
    "dropdeladd": "130 W GREENSBORO CHAPEL HILL RD",
    "dropdelcty": "SNOW CAMP",
    "dropdelst": "NC",
    "dropdelzpp": 273499262,
    "dropphyadd": "130 W GREENSBORO CHAPEL HILL RD",
    "dropphycty": "SNOW CAMP",
    "dropphyst": "NC",
    "dropphyzpp": 273499262,
    "dropmaladd": "130 W GREENSBORO CHAPEL HILL RD",
    "dropmalcty": "SNOW CAMP",
    "dropmalst": "NC",
    "dropmalzpp": 273499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363763516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16459",
    "droptype": "D",
    "dropname": "SNOW HILL",
    "dropdeladd": "911 SE SECOND ST",
    "dropdelcty": "SNOW HILL",
    "dropdelst": "NC",
    "dropdelzpp": 285801634,
    "dropphyadd": "911 SE SECOND ST",
    "dropphycty": "SNOW HILL",
    "dropphyst": "NC",
    "dropphyzpp": 285801634,
    "dropmaladd": "PO BOX 28580",
    "dropmalcty": "SNOW HILL",
    "dropmalst": "NC",
    "dropmalzpp": 285809998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527473413,
    "dropsitcph": 2527473413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16463",
    "droptype": "D",
    "dropname": "SOPHIA",
    "dropdeladd": "5814 US HIGHWAY 311",
    "dropdelcty": "SOPHIA",
    "dropdelst": "NC",
    "dropdelzpp": 273508997,
    "dropphyadd": "5814 US HIGHWAY 311",
    "dropphycty": "SOPHIA",
    "dropphyst": "NC",
    "dropphyzpp": 273508997,
    "dropmaladd": "5814 US HIGHWAY 311",
    "dropmalcty": "SOPHIA",
    "dropmalst": "NC",
    "dropmalzpp": 273509998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364983980,
    "dropfax": 3364988111
  },
  {
    "dcode": "D",
    "dropkey": "PY16472",
    "droptype": "D",
    "dropname": "SOUTH MILLS",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "SOUTH MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 279769551,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "SOUTH MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 279769551,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 279769998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527715200,
    "dropfax": 2527715224
  },
  {
    "dcode": "D",
    "dropkey": "PY16477",
    "droptype": "D",
    "dropname": "SOUTHERN PINES",
    "dropdeladd": "190 SW BROAD ST",
    "dropdelcty": "SOUTHERN PINES",
    "dropdelst": "NC",
    "dropdelzpp": 283875452,
    "dropphyadd": "190 SW BROAD ST",
    "dropphycty": "SOUTHERN PINES",
    "dropphyst": "NC",
    "dropphyzpp": 283875452,
    "dropmaladd": "PO BOX 28387",
    "dropmalcty": "SOUTHERN PINES",
    "dropmalst": "NC",
    "dropmalzpp": 283879998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106922431,
    "dropsitcph": 9106922431,
    "dropfax": 9106927825
  },
  {
    "dcode": "D",
    "dropkey": "PY16479",
    "droptype": "D",
    "dropname": "SOUTHMONT",
    "dropdeladd": "10584 NC HIGHWAY 8 S",
    "dropdelcty": "SOUTHMONT",
    "dropdelst": "NC",
    "dropdelzpp": 273519998,
    "dropphyadd": "10584 NC HIGHWAY 8 S",
    "dropphycty": "SOUTHMONT",
    "dropphyst": "NC",
    "dropphyzpp": 273519998,
    "dropmaladd": "10584 NC HIGHWAY 8 S",
    "dropmalcty": "SOUTHMONT",
    "dropmalst": "NC",
    "dropmalzpp": 273519998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367980230,
    "dropfax": 3367983934
  },
  {
    "dcode": "D",
    "dropkey": "PY16480",
    "droptype": "D",
    "dropname": "SOUTHPORT",
    "dropdeladd": "206 E NASH ST",
    "dropdelcty": "SOUTHPORT",
    "dropdelst": "NC",
    "dropdelzpp": 284613987,
    "dropphyadd": "206 E NASH ST",
    "dropphycty": "SOUTHPORT",
    "dropphyst": "NC",
    "dropphyzpp": 284613987,
    "dropmaladd": "PO BOX 28461",
    "dropmalcty": "SOUTHPORT",
    "dropmalst": "NC",
    "dropmalzpp": 284619998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104574633,
    "dropsitcph": 9104574633,
    "dropfax": 9104574466
  },
  {
    "dcode": "D",
    "dropkey": "PY16483",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "79 S GRAYSON ST",
    "dropdelcty": "SPARTA",
    "dropdelst": "NC",
    "dropdelzpp": 286759598,
    "dropphyadd": "79 S GRAYSON ST",
    "dropphycty": "SPARTA",
    "dropphyst": "NC",
    "dropphyzpp": 286759598,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPARTA",
    "dropmalst": "NC",
    "dropmalzpp": 286759998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362651984,
    "dropfax": 3362651981
  },
  {
    "dcode": "D",
    "dropkey": "PY16485",
    "droptype": "D",
    "dropname": "SPEED",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "SPEED",
    "dropdelst": "NC",
    "dropdelzpp": 278819998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "SPEED",
    "dropphyst": "NC",
    "dropphyzpp": 278819998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "SPEED",
    "dropmalst": "NC",
    "dropmalzpp": 278819998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528237355,
    "dropfax": 2528237355
  },
  {
    "dcode": "D",
    "dropkey": "PY16487",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "110 4TH ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "NC",
    "dropdelzpp": 281592214,
    "dropphyadd": "110 4TH ST",
    "dropphycty": "SPENCER",
    "dropphyst": "NC",
    "dropphyzpp": 281592214,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPENCER",
    "dropmalst": "NC",
    "dropmalzpp": 281599998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046331394,
    "dropsitcph": 7046331394,
    "dropfax": 7046333719
  },
  {
    "dcode": "D",
    "dropkey": "PY16491",
    "droptype": "D",
    "dropname": "SPINDALE",
    "dropdeladd": "124 TANNER ST",
    "dropdelcty": "SPINDALE",
    "dropdelst": "NC",
    "dropdelzpp": 281601564,
    "dropphyadd": "124 TANNER ST",
    "dropphycty": "SPINDALE",
    "dropphyst": "NC",
    "dropphyzpp": 281601564,
    "dropmaladd": "124 TANNER ST",
    "dropmalcty": "SPINDALE",
    "dropmalst": "NC",
    "dropmalzpp": 281601564,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282863826,
    "dropsitcph": 8282863826,
    "dropfax": 8282871307
  },
  {
    "dcode": "D",
    "dropkey": "PY16495",
    "droptype": "D",
    "dropname": "SPRING HOPE",
    "dropdeladd": "107 E BRANCH ST",
    "dropdelcty": "SPRING HOPE",
    "dropdelst": "NC",
    "dropdelzpp": 278829708,
    "dropphyadd": "107 E BRANCH ST",
    "dropphycty": "SPRING HOPE",
    "dropphyst": "NC",
    "dropphyzpp": 278829708,
    "dropmaladd": "107 E BRANCH ST",
    "dropmalcty": "SPRING HOPE",
    "dropmalst": "NC",
    "dropmalzpp": 278829998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524783541,
    "dropfax": 2524783541
  },
  {
    "dcode": "D",
    "dropkey": "PY16496",
    "droptype": "D",
    "dropname": "SPRING LAKE",
    "dropdeladd": "225 N MAIN ST",
    "dropdelcty": "SPRING LAKE",
    "dropdelst": "NC",
    "dropdelzpp": 283903847,
    "dropphyadd": "225 N MAIN ST",
    "dropphycty": "SPRING LAKE",
    "dropphyst": "NC",
    "dropphyzpp": 283903847,
    "dropmaladd": "PO BOX 28390",
    "dropmalcty": "SPRING LAKE",
    "dropmalst": "NC",
    "dropmalzpp": 283909998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104970113,
    "dropsitcph": 9104970113,
    "dropfax": 9104973511
  },
  {
    "dcode": "D",
    "dropkey": "PY16503",
    "droptype": "D",
    "dropname": "SPRUCE PINE",
    "dropdeladd": "899 OAK AVE",
    "dropdelcty": "SPRUCE PINE",
    "dropdelst": "NC",
    "dropdelzpp": 287772829,
    "dropphyadd": "899 OAK AVE",
    "dropphycty": "SPRUCE PINE",
    "dropphyst": "NC",
    "dropphyzpp": 287772829,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRUCE PINE",
    "dropmalst": "NC",
    "dropmalzpp": 287779998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8287654613,
    "dropsitcph": 8287654613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16509",
    "droptype": "D",
    "dropname": "STALEY",
    "dropdeladd": "229 W FRANKLINVILLE ST",
    "dropdelcty": "STALEY",
    "dropdelst": "NC",
    "dropdelzpp": 273558348,
    "dropphyadd": "229 W FRANKLINVILLE ST",
    "dropphycty": "STALEY",
    "dropphyst": "NC",
    "dropphyzpp": 273558348,
    "dropmaladd": "229 W FRANKLINVILLE ST",
    "dropmalcty": "STALEY",
    "dropmalst": "NC",
    "dropmalzpp": 273559998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366224168,
    "dropfax": 3366227714
  },
  {
    "dcode": "D",
    "dropkey": "PY16512",
    "droptype": "D",
    "dropname": "STANFIELD",
    "dropdeladd": "213 W STANLY ST",
    "dropdelcty": "STANFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 281639701,
    "dropphyadd": "213 W STANLY ST",
    "dropphycty": "STANFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 281639701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 281639998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048886830,
    "dropsitcph": 7048886830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16513",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "301 OLD MOUNT HOLLY RD",
    "dropdelcty": "STANLEY",
    "dropdelst": "NC",
    "dropdelzpp": 281642168,
    "dropphyadd": "301 OLD MOUNT HOLLY RD",
    "dropphycty": "STANLEY",
    "dropphyst": "NC",
    "dropphyzpp": 281642168,
    "dropmaladd": "301 OLD MOUNT HOLLY RD",
    "dropmalcty": "STANLEY",
    "dropmalst": "NC",
    "dropmalzpp": 281642168,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042632058,
    "dropsitcph": 7042632058,
    "dropfax": 7042633132
  },
  {
    "dcode": "D",
    "dropkey": "PY16516",
    "droptype": "D",
    "dropname": "STANTONSBURG",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "STANTONSBURG",
    "dropdelst": "NC",
    "dropdelzpp": 278839998,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "STANTONSBURG",
    "dropphyst": "NC",
    "dropphyzpp": 278839998,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "STANTONSBURG",
    "dropmalst": "NC",
    "dropmalzpp": 278839998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522383392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16517",
    "droptype": "D",
    "dropname": "STAR",
    "dropdeladd": "202 S MAIN ST",
    "dropdelcty": "STAR",
    "dropdelst": "NC",
    "dropdelzpp": 273567720,
    "dropphyadd": "202 S MAIN ST",
    "dropphycty": "STAR",
    "dropphyst": "NC",
    "dropphyzpp": 273567720,
    "dropmaladd": "202 S MAIN ST",
    "dropmalcty": "STAR",
    "dropmalst": "NC",
    "dropmalzpp": 273569998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9104284212,
    "dropfax": 9104282746
  },
  {
    "dcode": "D",
    "dropkey": "PY16521",
    "droptype": "D",
    "dropname": "STATE ROAD",
    "dropdeladd": "950 KLONDIKE RD",
    "dropdelcty": "STATE ROAD",
    "dropdelst": "NC",
    "dropdelzpp": 286768878,
    "dropphyadd": "950 KLONDIKE RD",
    "dropphycty": "STATE ROAD",
    "dropphyst": "NC",
    "dropphyzpp": 286768878,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STATE ROAD",
    "dropmalst": "NC",
    "dropmalzpp": 286769998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368722732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16528",
    "droptype": "D",
    "dropname": "STEDMAN",
    "dropdeladd": "7519 CLINTON RD",
    "dropdelcty": "STEDMAN",
    "dropdelst": "NC",
    "dropdelzpp": 283919065,
    "dropphyadd": "7519 CLINTON RD",
    "dropphycty": "STEDMAN",
    "dropphyst": "NC",
    "dropphyzpp": 283919065,
    "dropmaladd": "PO BOX 28391",
    "dropmalcty": "STEDMAN",
    "dropmalst": "NC",
    "dropmalzpp": 283919998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104835552,
    "dropsitcph": 9104835552,
    "dropfax": 9104835552
  },
  {
    "dcode": "D",
    "dropkey": "PY16530",
    "droptype": "D",
    "dropname": "STELLA",
    "dropdeladd": "125 WETHERINGTON LANDING RD",
    "dropdelcty": "STELLA",
    "dropdelst": "NC",
    "dropdelzpp": 285825000,
    "dropphyadd": "125 WETHERINGTON LANDING RD",
    "dropphycty": "STELLA",
    "dropphyst": "NC",
    "dropphyzpp": 285825000,
    "dropmaladd": "PO BOX 28582",
    "dropmalcty": "STELLA",
    "dropmalst": "NC",
    "dropmalzpp": 285829998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2523938025,
    "dropsitcph": 2523938025,
    "dropfax": 2523938025
  },
  {
    "dcode": "D",
    "dropkey": "PY16531",
    "droptype": "D",
    "dropname": "STEM",
    "dropdeladd": "104 E TALLY HO RD",
    "dropdelcty": "STEM",
    "dropdelst": "NC",
    "dropdelzpp": 275819998,
    "dropphyadd": "104 E TALLY HO RD",
    "dropphycty": "STEM",
    "dropphyst": "NC",
    "dropphyzpp": 275819998,
    "dropmaladd": "104 E TALLY HO RD",
    "dropmalcty": "STEM",
    "dropmalst": "NC",
    "dropmalzpp": 275819998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199254474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16533",
    "droptype": "D",
    "dropname": "STOKES",
    "dropdeladd": "2817 NC HIGHWAY 903 N",
    "dropdelcty": "STOKES",
    "dropdelst": "NC",
    "dropdelzpp": 278849998,
    "dropphyadd": "2817 NC HIGHWAY 903 N",
    "dropphycty": "STOKES",
    "dropphyst": "NC",
    "dropphyzpp": 278849998,
    "dropmaladd": "2817 NC HIGHWAY 903 N",
    "dropmalcty": "STOKES",
    "dropmalst": "NC",
    "dropmalzpp": 278849998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527583757,
    "dropfax": 2527580852
  },
  {
    "dcode": "D",
    "dropkey": "PY16534",
    "droptype": "D",
    "dropname": "STOKESDALE",
    "dropdeladd": "8210 US HIGHWAY 158",
    "dropdelcty": "STOKESDALE",
    "dropdelst": "NC",
    "dropdelzpp": 273579245,
    "dropphyadd": "8210 US HIGHWAY 158",
    "dropphycty": "STOKESDALE",
    "dropphyst": "NC",
    "dropphyzpp": 273579245,
    "dropmaladd": "8210 US HIGHWAY 158",
    "dropmalcty": "STOKESDALE",
    "dropmalst": "NC",
    "dropmalzpp": 273579998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366446686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16535",
    "droptype": "D",
    "dropname": "STONEVILLE",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "STONEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270488715,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "STONEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270488715,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270489998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365739090,
    "dropfax": 3365732963
  },
  {
    "dcode": "D",
    "dropkey": "PY16538",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "16375 NC 55 HWY",
    "dropdelcty": "STONEWALL",
    "dropdelst": "NC",
    "dropdelzpp": 285835000,
    "dropphyadd": "16375 NC 55 HWY",
    "dropphycty": "STONEWALL",
    "dropphyst": "NC",
    "dropphyzpp": 285835000,
    "dropmaladd": "PO BOX 28583",
    "dropmalcty": "STONEWALL",
    "dropmalst": "NC",
    "dropmalzpp": 285839998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527453842,
    "dropsitcph": 2527453842,
    "dropfax": 2527453842
  },
  {
    "dcode": "D",
    "dropkey": "PY16543",
    "droptype": "D",
    "dropname": "STONY POINT",
    "dropdeladd": "8814 NC HWY 90 E",
    "dropdelcty": "STONY POINT",
    "dropdelst": "NC",
    "dropdelzpp": 286789301,
    "dropphyadd": "8814 NC HWY 90 E",
    "dropphycty": "STONY POINT",
    "dropphyst": "NC",
    "dropphyzpp": 286789301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONY POINT",
    "dropmalst": "NC",
    "dropmalzpp": 286789998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7045852212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16546",
    "droptype": "D",
    "dropname": "STOVALL",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "STOVALL",
    "dropdelst": "NC",
    "dropdelzpp": 275829998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "STOVALL",
    "dropphyst": "NC",
    "dropphyzpp": 275829998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "STOVALL",
    "dropmalst": "NC",
    "dropmalzpp": 275829998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196937897,
    "dropfax": 9196937897
  },
  {
    "dcode": "D",
    "dropkey": "PY16552",
    "droptype": "D",
    "dropname": "SUGAR GROVE",
    "dropdeladd": "1205 US HIGHWAY 321 N",
    "dropdelcty": "SUGAR GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 286799284,
    "dropphyadd": "1205 US HIGHWAY 321 N",
    "dropphycty": "SUGAR GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 286799284,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUGAR GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 286799998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282973361,
    "dropfax": 8282975543
  },
  {
    "dcode": "D",
    "dropkey": "PY16555",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "7412 SUMMERFIELD RD",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 273589160,
    "dropphyadd": "7412 SUMMERFIELD RD",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 273589160,
    "dropmaladd": "7412 SUMMERFIELD RD",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 273589998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366435532,
    "dropfax": 3366436087
  },
  {
    "dcode": "D",
    "dropkey": "PY16560",
    "droptype": "D",
    "dropname": "SUNBURY",
    "dropdeladd": "990 US HIGHWAY 158 E",
    "dropdelcty": "SUNBURY",
    "dropdelst": "NC",
    "dropdelzpp": 279799998,
    "dropphyadd": "990 US HIGHWAY 158 E",
    "dropphycty": "SUNBURY",
    "dropphyst": "NC",
    "dropphyzpp": 279799998,
    "dropmaladd": "990 US HIGHWAY 158 E",
    "dropmalcty": "SUNBURY",
    "dropmalst": "NC",
    "dropmalzpp": 279799998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524658222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16570",
    "droptype": "D",
    "dropname": "SUPPLY",
    "dropdeladd": "25 BLANTON RD SE",
    "dropdelcty": "SUPPLY",
    "dropdelst": "NC",
    "dropdelzpp": 284623590,
    "dropphyadd": "25 BLANTON RD SE",
    "dropphycty": "SUPPLY",
    "dropphyst": "NC",
    "dropphyzpp": 284623590,
    "dropmaladd": "PO BOX 28462",
    "dropmalcty": "SUPPLY",
    "dropmalst": "NC",
    "dropmalzpp": 284629998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9107544050,
    "dropsitcph": 9107544050,
    "dropfax": 9107555022
  },
  {
    "dcode": "D",
    "dropkey": "PY16579",
    "droptype": "D",
    "dropname": "SWANNANOA",
    "dropdeladd": "2311 US 70 HWY",
    "dropdelcty": "SWANNANOA",
    "dropdelst": "NC",
    "dropdelzpp": 287780015,
    "dropphyadd": "2311 US 70 HWY",
    "dropphycty": "SWANNANOA",
    "dropphyst": "NC",
    "dropphyzpp": 287780015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWANNANOA",
    "dropmalst": "NC",
    "dropmalzpp": 287789998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286863215,
    "dropsitcph": 8286863215,
    "dropfax": 7043934581
  },
  {
    "dcode": "D",
    "dropkey": "PY16580",
    "droptype": "D",
    "dropname": "SWANQUARTER",
    "dropdeladd": "1271 MAIN ST",
    "dropdelcty": "SWANQUARTER",
    "dropdelst": "NC",
    "dropdelzpp": 278859998,
    "dropphyadd": "1271 MAIN ST",
    "dropphycty": "SWANQUARTER",
    "dropphyst": "NC",
    "dropphyzpp": 278859998,
    "dropmaladd": "1271 MAIN ST",
    "dropmalcty": "SWANQUARTER",
    "dropmalst": "NC",
    "dropmalzpp": 278859998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529267281,
    "dropfax": 2529269200
  },
  {
    "dcode": "D",
    "dropkey": "PY16581",
    "droptype": "D",
    "dropname": "SWANSBORO",
    "dropdeladd": "664 W CORBETT AVE",
    "dropdelcty": "SWANSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 285848572,
    "dropphyadd": "664 W CORBETT AVE",
    "dropphycty": "SWANSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 285848572,
    "dropmaladd": "PO BOX 28584",
    "dropmalcty": "SWANSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 285849998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103265959,
    "dropsitcph": 9103265959,
    "dropfax": 9103262089
  },
  {
    "dcode": "D",
    "dropkey": "PY16586",
    "droptype": "D",
    "dropname": "SYLVA",
    "dropdeladd": "271 JACKSON PLZ",
    "dropdelcty": "SYLVA",
    "dropdelst": "NC",
    "dropdelzpp": 287792553,
    "dropphyadd": "271 JACKSON PLZ",
    "dropphycty": "SYLVA",
    "dropphyst": "NC",
    "dropphyzpp": 287792553,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYLVA",
    "dropmalst": "NC",
    "dropmalzpp": 287799998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285862219,
    "dropsitcph": 8285862219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16588",
    "droptype": "D",
    "dropname": "TABOR CITY",
    "dropdeladd": "200 E 5TH ST",
    "dropdelcty": "TABOR CITY",
    "dropdelst": "NC",
    "dropdelzpp": 284632102,
    "dropphyadd": "200 E 5TH ST",
    "dropphycty": "TABOR CITY",
    "dropphyst": "NC",
    "dropphyzpp": 284632102,
    "dropmaladd": "PO BOX 28463",
    "dropmalcty": "TABOR CITY",
    "dropmalst": "NC",
    "dropmalzpp": 284639998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106532658,
    "dropsitcph": 9106532658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16594",
    "droptype": "D",
    "dropname": "TAR HEEL",
    "dropdeladd": "14548 NC HIGHWAY 87 W",
    "dropdelcty": "TAR HEEL",
    "dropdelst": "NC",
    "dropdelzpp": 283928900,
    "dropphyadd": "14548 NC HIGHWAY 87 W",
    "dropphycty": "TAR HEEL",
    "dropphyst": "NC",
    "dropphyzpp": 283928900,
    "dropmaladd": "PO BOX 28392",
    "dropmalcty": "TAR HEEL",
    "dropmalst": "NC",
    "dropmalzpp": 283929998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108622472,
    "dropsitcph": 9108622472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16599",
    "droptype": "D",
    "dropname": "TARBORO",
    "dropdeladd": "525 N MAIN ST",
    "dropdelcty": "TARBORO",
    "dropdelst": "NC",
    "dropdelzpp": 278864489,
    "dropphyadd": "525 N MAIN ST",
    "dropphycty": "TARBORO",
    "dropphyst": "NC",
    "dropphyzpp": 278864489,
    "dropmaladd": "525 N MAIN ST",
    "dropmalcty": "TARBORO",
    "dropmalst": "NC",
    "dropmalzpp": 278869998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528238164,
    "dropfax": 2528231590
  },
  {
    "dcode": "D",
    "dropkey": "PY16602",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "220 1ST AVE SW",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286819998,
    "dropphyadd": "220 1ST AVE SW",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286819998,
    "dropmaladd": "220 1ST AVE SW",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286819998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8286324209,
    "dropfax": 8286350131
  },
  {
    "dcode": "D",
    "dropkey": "PY16605",
    "droptype": "D",
    "dropname": "TEACHEY",
    "dropdeladd": "103 N WEST AVE",
    "dropdelcty": "TEACHEY",
    "dropdelst": "NC",
    "dropdelzpp": 284649311,
    "dropphyadd": "103 N WEST AVE",
    "dropphycty": "TEACHEY",
    "dropphyst": "NC",
    "dropphyzpp": 284649311,
    "dropmaladd": "PO BOX 28464",
    "dropmalcty": "TEACHEY",
    "dropmalst": "NC",
    "dropmalzpp": 284649998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102854912,
    "dropsitcph": 9102854912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16607",
    "droptype": "D",
    "dropname": "TERRELL",
    "dropdeladd": "7985 NC HIGHWAY 150 E",
    "dropdelcty": "TERRELL",
    "dropdelst": "NC",
    "dropdelzpp": 286829998,
    "dropphyadd": "7985 NC HIGHWAY 150 E",
    "dropphycty": "TERRELL",
    "dropphyst": "NC",
    "dropphyzpp": 286829998,
    "dropmaladd": "7985 NC HIGHWAY 150 E",
    "dropmalcty": "TERRELL",
    "dropmalst": "NC",
    "dropmalzpp": 286829998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8284782148,
    "dropfax": 8284783046
  },
  {
    "dcode": "D",
    "dropkey": "PY16609",
    "droptype": "D",
    "dropname": "THOMASVILLE",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "THOMASVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 273603967,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "THOMASVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 273603967,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "THOMASVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 273609998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364723892,
    "dropfax": 3364727669
  },
  {
    "dcode": "D",
    "dropkey": "PY16613",
    "droptype": "D",
    "dropname": "THURMOND",
    "dropdeladd": "2301 THURMOND RD",
    "dropdelcty": "THURMOND",
    "dropdelst": "NC",
    "dropdelzpp": 286839997,
    "dropphyadd": "2301 THURMOND RD",
    "dropphycty": "THURMOND",
    "dropphyst": "NC",
    "dropphyzpp": 286839997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THURMOND",
    "dropmalst": "NC",
    "dropmalzpp": 286839998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368742479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16614",
    "droptype": "D",
    "dropname": "TILLERY",
    "dropdeladd": "45 NC HIGHWAY 481",
    "dropdelcty": "TILLERY",
    "dropdelst": "NC",
    "dropdelzpp": 278879998,
    "dropphyadd": "45 NC HIGHWAY 481",
    "dropphycty": "TILLERY",
    "dropphyst": "NC",
    "dropphyzpp": 278879998,
    "dropmaladd": "45 NC HIGHWAY 481",
    "dropmalcty": "TILLERY",
    "dropmalst": "NC",
    "dropmalzpp": 278879998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2528263449,
    "dropfax": 2528263449
  },
  {
    "dcode": "D",
    "dropkey": "PY16615",
    "droptype": "D",
    "dropname": "TIMBERLAKE",
    "dropdeladd": "545 HELENA MORIAH RD",
    "dropdelcty": "TIMBERLAKE",
    "dropdelst": "NC",
    "dropdelzpp": 275839998,
    "dropphyadd": "545 HELENA MORIAH RD",
    "dropphycty": "TIMBERLAKE",
    "dropphyst": "NC",
    "dropphyzpp": 275839998,
    "dropmaladd": "545 HELENA MORIAH RD",
    "dropmalcty": "TIMBERLAKE",
    "dropmalst": "NC",
    "dropmalzpp": 275839998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 3363648185,
    "dropfax": 3363642436
  },
  {
    "dcode": "D",
    "dropkey": "PY16617",
    "droptype": "D",
    "dropname": "TOAST",
    "dropdeladd": "1110 W PINE ST",
    "dropdelcty": "TOAST",
    "dropdelst": "NC",
    "dropdelzpp": 270499997,
    "dropphyadd": "1110 W PINE ST",
    "dropphycty": "TOAST",
    "dropphyst": "NC",
    "dropphyzpp": 270499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOAST",
    "dropmalst": "NC",
    "dropmalzpp": 270499998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367895722,
    "dropfax": 3367898043
  },
  {
    "dcode": "D",
    "dropkey": "PY16618",
    "droptype": "D",
    "dropname": "TOBACCOVILLE",
    "dropdeladd": "6900 DORAL DR",
    "dropdelcty": "TOBACCOVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270509998,
    "dropphyadd": "6900 DORAL DR",
    "dropphycty": "TOBACCOVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270509998,
    "dropmaladd": "6900 DORAL DR",
    "dropmalcty": "TOBACCOVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270509998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3369839143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16621",
    "droptype": "D",
    "dropname": "TODD",
    "dropdeladd": "4021 TODD RAILROAD GRADE RD",
    "dropdelcty": "TODD",
    "dropdelst": "NC",
    "dropdelzpp": 286849380,
    "dropphyadd": "4021 TODD RAILROAD GRADE RD",
    "dropphycty": "TODD",
    "dropphyst": "NC",
    "dropphyzpp": 286849380,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TODD",
    "dropmalst": "NC",
    "dropmalzpp": 286849998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368774444,
    "dropfax": 3368778845
  },
  {
    "dcode": "D",
    "dropkey": "PY16628",
    "droptype": "D",
    "dropname": "TOPTON",
    "dropdeladd": "23979 US HIGHWAY 19",
    "dropdelcty": "TOPTON",
    "dropdelst": "NC",
    "dropdelzpp": 287817527,
    "dropphyadd": "23979 US HIGHWAY 19",
    "dropphycty": "TOPTON",
    "dropphyst": "NC",
    "dropphyzpp": 287817527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPTON",
    "dropmalst": "NC",
    "dropmalzpp": 287819998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8283215301,
    "dropsitcph": 8283215301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16631",
    "droptype": "D",
    "dropname": "TOWNSVILLE",
    "dropdeladd": "12525 NC HIGHWAY 39 N",
    "dropdelcty": "TOWNSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 275849998,
    "dropphyadd": "12525 NC HIGHWAY 39 N",
    "dropphycty": "TOWNSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 275849998,
    "dropmaladd": "12525 NC HIGHWAY 39 N",
    "dropmalcty": "TOWNSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 275849998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524921634,
    "dropfax": 2524921634
  },
  {
    "dcode": "D",
    "dropkey": "PY16634",
    "droptype": "D",
    "dropname": "TRAPHILL",
    "dropdeladd": "9550 TRAPHILL RD",
    "dropdelcty": "TRAPHILL",
    "dropdelst": "NC",
    "dropdelzpp": 286859245,
    "dropphyadd": "9550 TRAPHILL RD",
    "dropphycty": "TRAPHILL",
    "dropphyst": "NC",
    "dropphyzpp": 286859245,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRAPHILL",
    "dropmalst": "NC",
    "dropmalzpp": 286859998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365716555,
    "dropfax": 3369574546
  },
  {
    "dcode": "D",
    "dropkey": "PY16637",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "115 S MARKET ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "NC",
    "dropdelzpp": 285855000,
    "dropphyadd": "115 S MARKET ST",
    "dropphycty": "TRENTON",
    "dropphyst": "NC",
    "dropphyzpp": 285855000,
    "dropmaladd": "PO BOX 28585",
    "dropmalcty": "TRENTON",
    "dropmalst": "NC",
    "dropmalzpp": 285859998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2524484481,
    "dropsitcph": 2524484481,
    "dropfax": 2524487821
  },
  {
    "dcode": "D",
    "dropkey": "PY16638",
    "droptype": "D",
    "dropname": "TRINITY",
    "dropdeladd": "7259 NC HIGHWAY 62",
    "dropdelcty": "TRINITY",
    "dropdelst": "NC",
    "dropdelzpp": 273708675,
    "dropphyadd": "7259 NC HIGHWAY 62",
    "dropphycty": "TRINITY",
    "dropphyst": "NC",
    "dropphyzpp": 273708675,
    "dropmaladd": "7259 NC HIGHWAY 62",
    "dropmalcty": "TRINITY",
    "dropmalst": "NC",
    "dropmalzpp": 273708675,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364319612,
    "dropfax": 3364318079
  },
  {
    "dcode": "D",
    "dropkey": "PY16640",
    "droptype": "D",
    "dropname": "TROUTMAN",
    "dropdeladd": "189 WAGNER ST",
    "dropdelcty": "TROUTMAN",
    "dropdelst": "NC",
    "dropdelzpp": 281669604,
    "dropphyadd": "189 WAGNER ST",
    "dropphycty": "TROUTMAN",
    "dropphyst": "NC",
    "dropphyzpp": 281669604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROUTMAN",
    "dropmalst": "NC",
    "dropmalzpp": 281669998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045284431,
    "dropsitcph": 7045284431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16641",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "601 N MAIN ST",
    "dropdelcty": "TROY",
    "dropdelst": "NC",
    "dropdelzpp": 273712745,
    "dropphyadd": "601 N MAIN ST",
    "dropphycty": "TROY",
    "dropphyst": "NC",
    "dropphyzpp": 273712745,
    "dropmaladd": "601 N MAIN ST",
    "dropmalcty": "TROY",
    "dropmalst": "NC",
    "dropmalzpp": 273719998,
    "dropsitphn": 3399319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9105767771,
    "dropfax": 9105760073
  },
  {
    "dcode": "D",
    "dropkey": "PY16643",
    "droptype": "D",
    "dropname": "TRYON",
    "dropdeladd": "95 PACOLET ST",
    "dropdelcty": "TRYON",
    "dropdelst": "NC",
    "dropdelzpp": 287823364,
    "dropphyadd": "95 PACOLET ST",
    "dropphycty": "TRYON",
    "dropphyst": "NC",
    "dropphyzpp": 287823364,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRYON",
    "dropmalst": "NC",
    "dropmalzpp": 287829998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8288599357,
    "dropsitcph": 8288599357,
    "dropfax": 8288596834
  },
  {
    "dcode": "D",
    "dropkey": "PY16644",
    "droptype": "D",
    "dropname": "TUCKASEGEE",
    "dropdeladd": "26 CANADA RD",
    "dropdelcty": "TUCKASEGEE",
    "dropdelst": "NC",
    "dropdelzpp": 287838865,
    "dropphyadd": "26 CANADA RD",
    "dropphycty": "TUCKASEGEE",
    "dropphyst": "NC",
    "dropphyzpp": 287838865,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUCKASEGEE",
    "dropmalst": "NC",
    "dropmalzpp": 287839998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282935074,
    "dropsitcph": 8282935074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16646",
    "droptype": "D",
    "dropname": "TURKEY",
    "dropdeladd": "54 UNION RD",
    "dropdelcty": "TURKEY",
    "dropdelst": "NC",
    "dropdelzpp": 283938467,
    "dropphyadd": "54 UNION RD",
    "dropphycty": "TURKEY",
    "dropphyst": "NC",
    "dropphyzpp": 283938467,
    "dropmaladd": "PO BOX 28393",
    "dropmalcty": "TURKEY",
    "dropmalst": "NC",
    "dropmalzpp": 283939998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105925563,
    "dropsitcph": 9105925563,
    "dropfax": 9105926582
  },
  {
    "dcode": "D",
    "dropkey": "PY16648",
    "droptype": "D",
    "dropname": "TURNERSBURG",
    "dropdeladd": "2223 TURNERSBURG HWY",
    "dropdelcty": "TURNERSBURG",
    "dropdelst": "NC",
    "dropdelzpp": 286889800,
    "dropphyadd": "2223 TURNERSBURG HWY",
    "dropphycty": "TURNERSBURG",
    "dropphyst": "NC",
    "dropphyzpp": 286889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURNERSBURG",
    "dropmalst": "NC",
    "dropmalzpp": 286889998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7047617019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16652",
    "droptype": "D",
    "dropname": "TYNER",
    "dropdeladd": "630 CENTER HILL RD",
    "dropdelcty": "TYNER",
    "dropdelst": "NC",
    "dropdelzpp": 279809998,
    "dropphyadd": "630 CENTER HILL RD",
    "dropphycty": "TYNER",
    "dropphyst": "NC",
    "dropphyzpp": 279809998,
    "dropmaladd": "630 CENTER HILL RD",
    "dropmalcty": "TYNER",
    "dropmalst": "NC",
    "dropmalzpp": 279809998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522214261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16661",
    "droptype": "D",
    "dropname": "UNION GROVE",
    "dropdeladd": "1501 UNION GROVE RD",
    "dropdelcty": "UNION GROVE",
    "dropdelst": "NC",
    "dropdelzpp": 286899800,
    "dropphyadd": "1501 UNION GROVE RD",
    "dropphycty": "UNION GROVE",
    "dropphyst": "NC",
    "dropphyzpp": 286899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION GROVE",
    "dropmalst": "NC",
    "dropmalzpp": 286899998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7045394387,
    "dropfax": 7045394527
  },
  {
    "dcode": "D",
    "dropkey": "PY16663",
    "droptype": "D",
    "dropname": "UNION MILLS",
    "dropdeladd": "3733 US 221 HWY N",
    "dropdelcty": "UNION MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 281678545,
    "dropphyadd": "3733 US 221 HWY N",
    "dropphycty": "UNION MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 281678545,
    "dropmaladd": "3733 US 221 HWY N",
    "dropmalcty": "UNION MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 281678545,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042875780,
    "dropsitcph": 8282869079,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16673",
    "droptype": "D",
    "dropname": "VALDESE",
    "dropdeladd": "300 RODORET ST S",
    "dropdelcty": "VALDESE",
    "dropdelst": "NC",
    "dropdelzpp": 286902869,
    "dropphyadd": "300 RODORET ST S",
    "dropphycty": "VALDESE",
    "dropphyst": "NC",
    "dropphyzpp": 286902869,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALDESE",
    "dropmalst": "NC",
    "dropmalzpp": 286909998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8288742812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16674",
    "droptype": "D",
    "dropname": "VALE",
    "dropdeladd": "6070 REEPSVILLE RD",
    "dropdelcty": "VALE",
    "dropdelst": "NC",
    "dropdelzpp": 281689651,
    "dropphyadd": "6070 REEPSVILLE RD",
    "dropphycty": "VALE",
    "dropphyst": "NC",
    "dropphyzpp": 281689651,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALE",
    "dropmalst": "NC",
    "dropmalzpp": 281689998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042762431,
    "dropsitcph": 7042762431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16678",
    "droptype": "D",
    "dropname": "VANCEBORO",
    "dropdeladd": "8134 MAIN ST",
    "dropdelcty": "VANCEBORO",
    "dropdelst": "NC",
    "dropdelzpp": 285869154,
    "dropphyadd": "8134 MAIN ST",
    "dropphycty": "VANCEBORO",
    "dropphyst": "NC",
    "dropphyzpp": 285869154,
    "dropmaladd": "PO BOX 28586",
    "dropmalcty": "VANCEBORO",
    "dropmalst": "NC",
    "dropmalzpp": 285869998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2522440929,
    "dropsitcph": 2522440929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16687",
    "droptype": "D",
    "dropname": "VASS",
    "dropdeladd": "120 SEABOARD ST",
    "dropdelcty": "VASS",
    "dropdelst": "NC",
    "dropdelzpp": 283948919,
    "dropphyadd": "120 SEABOARD ST",
    "dropphycty": "VASS",
    "dropphyst": "NC",
    "dropphyzpp": 283948919,
    "dropmaladd": "PO BOX 28394",
    "dropmalcty": "VASS",
    "dropmalst": "NC",
    "dropmalzpp": 283949998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102454169,
    "dropsitcph": 9102454169,
    "dropfax": 9102454169
  },
  {
    "dcode": "D",
    "dropkey": "PY16696",
    "droptype": "D",
    "dropname": "VILAS",
    "dropdeladd": "6141 US HIGHWAY 421 N",
    "dropdelcty": "VILAS",
    "dropdelst": "NC",
    "dropdelzpp": 286928463,
    "dropphyadd": "6141 US HIGHWAY 421 N",
    "dropphycty": "VILAS",
    "dropphyst": "NC",
    "dropphyzpp": 286928463,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILAS",
    "dropmalst": "NC",
    "dropmalzpp": 286929998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8283720252,
    "dropfax": 8282975532
  },
  {
    "dcode": "D",
    "dropkey": "PY16706",
    "droptype": "D",
    "dropname": "WACO",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "WACO",
    "dropdelst": "NC",
    "dropdelzpp": 281699700,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "WACO",
    "dropphyst": "NC",
    "dropphyzpp": 281699700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WACO",
    "dropmalst": "NC",
    "dropmalzpp": 281699998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7044352649,
    "dropsitcph": 7044352649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16707",
    "droptype": "D",
    "dropname": "WADE",
    "dropdeladd": "6927 WADE STEDMAN RD",
    "dropdelcty": "WADE",
    "dropdelst": "NC",
    "dropdelzpp": 283959019,
    "dropphyadd": "6927 WADE STEDMAN RD",
    "dropphycty": "WADE",
    "dropphyst": "NC",
    "dropphyzpp": 283959019,
    "dropmaladd": "PO BOX 28395",
    "dropmalcty": "WADE",
    "dropmalst": "NC",
    "dropmalzpp": 283959998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104858710,
    "dropsitcph": 9104858710,
    "dropfax": 9104858710
  },
  {
    "dcode": "D",
    "dropkey": "PY16708",
    "droptype": "D",
    "dropname": "WADESBORO",
    "dropdeladd": "105 E MARTIN ST",
    "dropdelcty": "WADESBORO",
    "dropdelst": "NC",
    "dropdelzpp": 281702216,
    "dropphyadd": "105 E MARTIN ST",
    "dropphycty": "WADESBORO",
    "dropphyst": "NC",
    "dropphyzpp": 281702216,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADESBORO",
    "dropmalst": "NC",
    "dropmalzpp": 281709998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7046943210,
    "dropsitcph": 7046943210,
    "dropfax": 7046951999
  },
  {
    "dcode": "D",
    "dropkey": "PY16712",
    "droptype": "D",
    "dropname": "WAGRAM",
    "dropdeladd": "24100 N MAIN ST",
    "dropdelcty": "WAGRAM",
    "dropdelst": "NC",
    "dropdelzpp": 283968939,
    "dropphyadd": "24100 N MAIN ST",
    "dropphycty": "WAGRAM",
    "dropphyst": "NC",
    "dropphyzpp": 283968939,
    "dropmaladd": "PO BOX 28396",
    "dropmalcty": "WAGRAM",
    "dropmalst": "NC",
    "dropmalzpp": 283969998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103692800,
    "dropsitcph": 8773642026,
    "dropfax": 9103692566
  },
  {
    "dcode": "D",
    "dropkey": "PY16714",
    "droptype": "D",
    "dropname": "WAKE FOREST",
    "dropdeladd": "224 E HOLDING AVE",
    "dropdelcty": "WAKE FOREST",
    "dropdelst": "NC",
    "dropdelzpp": 275879998,
    "dropphyadd": "224 E HOLDING AVE",
    "dropphycty": "WAKE FOREST",
    "dropphyst": "NC",
    "dropphyzpp": 275879998,
    "dropmaladd": "224 E HOLDING AVE",
    "dropmalcty": "WAKE FOREST",
    "dropmalst": "NC",
    "dropmalzpp": 275879998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195568859,
    "dropfax": 9195542863
  },
  {
    "dcode": "D",
    "dropkey": "PY16716",
    "droptype": "D",
    "dropname": "WALKERTOWN",
    "dropdeladd": "4970 US HIGHWAY 311 N",
    "dropdelcty": "WALKERTOWN",
    "dropdelst": "NC",
    "dropdelzpp": 270518700,
    "dropphyadd": "4970 US HIGHWAY 311 N",
    "dropphycty": "WALKERTOWN",
    "dropphyst": "NC",
    "dropphyzpp": 270518700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALKERTOWN",
    "dropmalst": "NC",
    "dropmalzpp": 270519998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365953026,
    "dropfax": 3365953457
  },
  {
    "dcode": "D",
    "dropkey": "PY16717",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "202 E SOUTHERLAND ST",
    "dropdelcty": "WALLACE",
    "dropdelst": "NC",
    "dropdelzpp": 284662329,
    "dropphyadd": "202 E SOUTHERLAND ST",
    "dropphycty": "WALLACE",
    "dropphyst": "NC",
    "dropphyzpp": 284662329,
    "dropmaladd": "PO BOX 28466",
    "dropmalcty": "WALLACE",
    "dropmalst": "NC",
    "dropmalzpp": 284669998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102852389,
    "dropsitcph": 9102852389,
    "dropfax": 9102854526
  },
  {
    "dcode": "D",
    "dropkey": "PY16718",
    "droptype": "D",
    "dropname": "WALLBURG",
    "dropdeladd": "8590 N NC HIGHWAY 109",
    "dropdelcty": "WALLBURG",
    "dropdelst": "NC",
    "dropdelzpp": 273739997,
    "dropphyadd": "8590 N NC HIGHWAY 109",
    "dropphycty": "WALLBURG",
    "dropphyst": "NC",
    "dropphyzpp": 273739997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLBURG",
    "dropmalst": "NC",
    "dropmalzpp": 273739998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367692561,
    "dropfax": 3367699885
  },
  {
    "dcode": "D",
    "dropkey": "PY16720",
    "droptype": "D",
    "dropname": "WALNUT COVE",
    "dropdeladd": "217 N MAIN ST",
    "dropdelcty": "WALNUT COVE",
    "dropdelst": "NC",
    "dropdelzpp": 270529998,
    "dropphyadd": "217 N MAIN ST",
    "dropphycty": "WALNUT COVE",
    "dropphyst": "NC",
    "dropphyzpp": 270529998,
    "dropmaladd": "217 N MAIN ST",
    "dropmalcty": "WALNUT COVE",
    "dropmalst": "NC",
    "dropmalzpp": 270529998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3365917380,
    "dropfax": 3365913985
  },
  {
    "dcode": "D",
    "dropkey": "PY16725",
    "droptype": "D",
    "dropname": "WALSTONBURG",
    "dropdeladd": "108 N WILSON ST",
    "dropdelcty": "WALSTONBURG",
    "dropdelst": "NC",
    "dropdelzpp": 278889998,
    "dropphyadd": "108 N WILSON ST",
    "dropphycty": "WALSTONBURG",
    "dropphyst": "NC",
    "dropphyzpp": 278889998,
    "dropmaladd": "108 N WILSON ST",
    "dropmalcty": "WALSTONBURG",
    "dropmalst": "NC",
    "dropmalzpp": 278889998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527533226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16726",
    "droptype": "D",
    "dropname": "WANCHESE",
    "dropdeladd": "3525 MILL LANDING RD",
    "dropdelcty": "WANCHESE",
    "dropdelst": "NC",
    "dropdelzpp": 279819632,
    "dropphyadd": "3525 MILL LANDING RD",
    "dropphycty": "WANCHESE",
    "dropphyst": "NC",
    "dropphyzpp": 279819632,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WANCHESE",
    "dropmalst": "NC",
    "dropmalzpp": 279819998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524733551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16727",
    "droptype": "D",
    "dropname": "WARNE",
    "dropdeladd": "4731 OLD HWY 64 W",
    "dropdelcty": "WARNE",
    "dropdelst": "NC",
    "dropdelzpp": 289097730,
    "dropphyadd": "4731 OLD HWY 64 W",
    "dropphycty": "WARNE",
    "dropphyst": "NC",
    "dropphyzpp": 289097730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARNE",
    "dropmalst": "NC",
    "dropmalzpp": 289099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8283896811,
    "dropsitcph": 8283896811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16729",
    "droptype": "D",
    "dropname": "WARRENSVILLE",
    "dropdeladd": "122 NW SCHOOL RD",
    "dropdelcty": "WARRENSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286939579,
    "dropphyadd": "122 NW SCHOOL RD",
    "dropphycty": "WARRENSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286939579,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARRENSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286939998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363842681,
    "dropfax": 3363861104
  },
  {
    "dcode": "D",
    "dropkey": "PY16732",
    "droptype": "D",
    "dropname": "WARRENTON",
    "dropdeladd": "143 N MAIN ST",
    "dropdelcty": "WARRENTON",
    "dropdelst": "NC",
    "dropdelzpp": 275899998,
    "dropphyadd": "143 N MAIN ST",
    "dropphycty": "WARRENTON",
    "dropphyst": "NC",
    "dropphyzpp": 275899998,
    "dropmaladd": "143 N MAIN ST",
    "dropmalcty": "WARRENTON",
    "dropmalst": "NC",
    "dropmalzpp": 275899998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522573683,
    "dropfax": 2522571296
  },
  {
    "dcode": "D",
    "dropkey": "PY16734",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "116 W HILL ST",
    "dropdelcty": "WARSAW",
    "dropdelst": "NC",
    "dropdelzpp": 283981816,
    "dropphyadd": "116 W HILL ST",
    "dropphycty": "WARSAW",
    "dropphyst": "NC",
    "dropphyzpp": 283981816,
    "dropmaladd": "PO BOX 28398",
    "dropmalcty": "WARSAW",
    "dropmalst": "NC",
    "dropmalzpp": 283989998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102934514,
    "dropsitcph": 9102934514,
    "dropfax": 9102933568
  },
  {
    "dcode": "D",
    "dropkey": "PY16738",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "222 W 2ND ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 278899998,
    "dropphyadd": "222 W 2ND ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 278899998,
    "dropmaladd": "222 W 2ND ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 278899998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529460128,
    "dropfax": 2529468402
  },
  {
    "dcode": "D",
    "dropkey": "PY16745",
    "droptype": "D",
    "dropname": "WAXHAW",
    "dropdeladd": "100 WAXHAW PKWY",
    "dropdelcty": "WAXHAW",
    "dropdelst": "NC",
    "dropdelzpp": 281739026,
    "dropphyadd": "100 WAXHAW PKWY",
    "dropphycty": "WAXHAW",
    "dropphyst": "NC",
    "dropphyzpp": 281739026,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAXHAW",
    "dropmalst": "NC",
    "dropmalzpp": 281739998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048433483,
    "dropsitcph": 7048433483,
    "dropfax": 7048433762
  },
  {
    "dcode": "D",
    "dropkey": "PY16746",
    "droptype": "D",
    "dropname": "WAYNESVILLE",
    "dropdeladd": "523 S HAYWOOD ST",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287863743,
    "dropphyadd": "523 S HAYWOOD ST",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287863743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287869998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284569445,
    "dropsitcph": 8284569445,
    "dropfax": 8284564872
  },
  {
    "dcode": "D",
    "dropkey": "PY16751",
    "droptype": "D",
    "dropname": "WEAVERVILLE",
    "dropdeladd": "270 N MAIN ST",
    "dropdelcty": "WEAVERVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287873000,
    "dropphyadd": "270 N MAIN ST",
    "dropphycty": "WEAVERVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287873000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEAVERVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287879998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286456110,
    "dropsitcph": 8286456110,
    "dropfax": 8286459178
  },
  {
    "dcode": "D",
    "dropkey": "PY16754",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "1345 WEBSTER RD",
    "dropdelcty": "WEBSTER",
    "dropdelst": "NC",
    "dropdelzpp": 287888000,
    "dropphyadd": "1345 WEBSTER RD",
    "dropphycty": "WEBSTER",
    "dropphyst": "NC",
    "dropphyzpp": 287888000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBSTER",
    "dropmalst": "NC",
    "dropmalzpp": 287889998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8285865926,
    "dropsitcph": 8285865926,
    "dropfax": 8285865926
  },
  {
    "dcode": "D",
    "dropkey": "PY16758",
    "droptype": "D",
    "dropname": "WELCOME",
    "dropdeladd": "6325 OLD US HIGHWAY 52",
    "dropdelcty": "WELCOME",
    "dropdelst": "NC",
    "dropdelzpp": 273749800,
    "dropphyadd": "6325 OLD US HIGHWAY 52",
    "dropphycty": "WELCOME",
    "dropphyst": "NC",
    "dropphyzpp": 273749800,
    "dropmaladd": "6325 OLD US HIGHWAY 52",
    "dropmalcty": "WELCOME",
    "dropmalst": "NC",
    "dropmalzpp": 273749998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367317141,
    "dropfax": 3367316578
  },
  {
    "dcode": "D",
    "dropkey": "PY16759",
    "droptype": "D",
    "dropname": "WELDON",
    "dropdeladd": "401 WASHINGTON AVE",
    "dropdelcty": "WELDON",
    "dropdelst": "NC",
    "dropdelzpp": 278909998,
    "dropphyadd": "401 WASHINGTON AVE",
    "dropphycty": "WELDON",
    "dropphyst": "NC",
    "dropphyzpp": 278909998,
    "dropmaladd": "401 WASHINGTON AVE",
    "dropmalcty": "WELDON",
    "dropmalst": "NC",
    "dropmalzpp": 278909998,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525364300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16761",
    "droptype": "D",
    "dropname": "WENDELL",
    "dropdeladd": "40 HANOR LN",
    "dropdelcty": "WENDELL",
    "dropdelst": "NC",
    "dropdelzpp": 275919998,
    "dropphyadd": "40 HANOR LN",
    "dropphycty": "WENDELL",
    "dropphyst": "NC",
    "dropphyzpp": 275919998,
    "dropmaladd": "40 HANOR LN",
    "dropmalcty": "WENDELL",
    "dropmalst": "NC",
    "dropmalzpp": 275919998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9193650657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16762",
    "droptype": "D",
    "dropname": "WENTWORTH",
    "dropdeladd": "200 COUNTY HOME RD",
    "dropdelcty": "WENTWORTH",
    "dropdelst": "NC",
    "dropdelzpp": 273759998,
    "dropphyadd": "200 COUNTY HOME RD",
    "dropphycty": "WENTWORTH",
    "dropphyst": "NC",
    "dropphyzpp": 273759998,
    "dropmaladd": "200 COUNTY HOME RD",
    "dropmalcty": "WENTWORTH",
    "dropmalst": "NC",
    "dropmalzpp": 273759998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363423559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16768",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "5161 NC HIGHWAY 211",
    "dropdelcty": "WEST END",
    "dropdelst": "NC",
    "dropdelzpp": 273769044,
    "dropphyadd": "5161 NC HIGHWAY 211",
    "dropphycty": "WEST END",
    "dropphyst": "NC",
    "dropphyzpp": 273769044,
    "dropmaladd": "5161 NC HIGHWAY 211",
    "dropmalcty": "WEST END",
    "dropmalst": "NC",
    "dropmalzpp": 273769998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 9106738041,
    "dropfax": 9106732219
  },
  {
    "dcode": "D",
    "dropkey": "PY16772",
    "droptype": "D",
    "dropname": "WEST JEFFERSON",
    "dropdeladd": "419 E 2ND ST",
    "dropdelcty": "WEST JEFFERSON",
    "dropdelst": "NC",
    "dropdelzpp": 286949641,
    "dropphyadd": "419 E 2ND ST",
    "dropphycty": "WEST JEFFERSON",
    "dropphyst": "NC",
    "dropphyzpp": 286949641,
    "dropmaladd": "419 E 2ND ST",
    "dropmalcty": "WEST JEFFERSON",
    "dropmalst": "NC",
    "dropmalzpp": 286949998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362462601,
    "dropfax": 3362462735
  },
  {
    "dcode": "D",
    "dropkey": "PY16781",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "6648 WESTFIELD RD",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "NC",
    "dropdelzpp": 270538169,
    "dropphyadd": "6648 WESTFIELD RD",
    "dropphycty": "WESTFIELD",
    "dropphyst": "NC",
    "dropphyzpp": 270538169,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "NC",
    "dropmalzpp": 270539998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363513161,
    "dropfax": 3363512509
  },
  {
    "dcode": "D",
    "dropkey": "PY16786",
    "droptype": "D",
    "dropname": "WHITAKERS",
    "dropdeladd": "102 NW RAILROAD ST",
    "dropdelcty": "WHITAKERS",
    "dropdelst": "NC",
    "dropdelzpp": 278919998,
    "dropphyadd": "102 NW RAILROAD ST",
    "dropphycty": "WHITAKERS",
    "dropphyst": "NC",
    "dropphyzpp": 278919998,
    "dropmaladd": "102 NW RAILROAD ST",
    "dropmalcty": "WHITAKERS",
    "dropmalst": "NC",
    "dropmalzpp": 278919998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524377851,
    "dropfax": 2524370106
  },
  {
    "dcode": "D",
    "dropkey": "PY16789",
    "droptype": "D",
    "dropname": "WHITE OAK",
    "dropdeladd": "10384 NC HIGHWAY 53 W",
    "dropdelcty": "WHITE OAK",
    "dropdelst": "NC",
    "dropdelzpp": 283999710,
    "dropphyadd": "10384 NC HIGHWAY 53 W",
    "dropphycty": "WHITE OAK",
    "dropphyst": "NC",
    "dropphyzpp": 283999710,
    "dropmaladd": "PO BOX 28399",
    "dropmalcty": "WHITE OAK",
    "dropmalst": "NC",
    "dropmalzpp": 283999998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108665333,
    "dropsitcph": 9108665333,
    "dropfax": 9108665198
  },
  {
    "dcode": "D",
    "dropkey": "PY16795",
    "droptype": "D",
    "dropname": "WHITEVILLE",
    "dropdeladd": "107 S LEE ST",
    "dropdelcty": "WHITEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 284724027,
    "dropphyadd": "107 S LEE ST",
    "dropphycty": "WHITEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 284724027,
    "dropmaladd": "PO BOX 28472",
    "dropmalcty": "WHITEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 284729998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106423336,
    "dropsitcph": 9106423336,
    "dropfax": 9106420671
  },
  {
    "dcode": "D",
    "dropkey": "PY16801",
    "droptype": "D",
    "dropname": "WHITSETT",
    "dropdeladd": "1001 NC HIGHWAY 61",
    "dropdelcty": "WHITSETT",
    "dropdelst": "NC",
    "dropdelzpp": 273779125,
    "dropphyadd": "1001 NC HIGHWAY 61",
    "dropphycty": "WHITSETT",
    "dropphyst": "NC",
    "dropphyzpp": 273779125,
    "dropmaladd": "1001 NC HIGHWAY 61",
    "dropmalcty": "WHITSETT",
    "dropmalst": "NC",
    "dropmalzpp": 273779998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3364497807,
    "dropfax": 3364490544
  },
  {
    "dcode": "D",
    "dropkey": "PY16802",
    "droptype": "D",
    "dropname": "WHITTIER",
    "dropdeladd": "22 MAIN ST",
    "dropdelcty": "WHITTIER",
    "dropdelst": "NC",
    "dropdelzpp": 287896158,
    "dropphyadd": "22 MAIN ST",
    "dropphycty": "WHITTIER",
    "dropphyst": "NC",
    "dropphyzpp": 287896158,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITTIER",
    "dropmalst": "NC",
    "dropmalzpp": 287899998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284977627,
    "dropsitcph": 8284977627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16807",
    "droptype": "D",
    "dropname": "WILKESBORO",
    "dropdeladd": "207 W MAIN ST STE 102",
    "dropdelcty": "WILKESBORO",
    "dropdelst": "NC",
    "dropdelzpp": 286972465,
    "dropphyadd": "207 W MAIN ST STE 102",
    "dropphycty": "WILKESBORO",
    "dropphyst": "NC",
    "dropphyzpp": 286972465,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILKESBORO",
    "dropmalst": "NC",
    "dropmalzpp": 286979998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366676241,
    "dropfax": 3366677220
  },
  {
    "dcode": "D",
    "dropkey": "PY16809",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "130 WILLARD RAILROAD ST",
    "dropdelcty": "WILLARD",
    "dropdelst": "NC",
    "dropdelzpp": 284787842,
    "dropphyadd": "130 WILLARD RAILROAD ST",
    "dropphycty": "WILLARD",
    "dropphyst": "NC",
    "dropphyzpp": 284787842,
    "dropmaladd": "PO BOX 28478",
    "dropmalcty": "WILLARD",
    "dropmalst": "NC",
    "dropmalzpp": 284789998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102853612,
    "dropsitcph": 9102853612,
    "dropfax": 9102853612
  },
  {
    "dcode": "D",
    "dropkey": "PY16813",
    "droptype": "D",
    "dropname": "WILLIAMSTON",
    "dropdeladd": "121 E MAIN ST",
    "dropdelcty": "WILLIAMSTON",
    "dropdelst": "NC",
    "dropdelzpp": 278929998,
    "dropphyadd": "121 E MAIN ST",
    "dropphycty": "WILLIAMSTON",
    "dropphyst": "NC",
    "dropphyzpp": 278929998,
    "dropmaladd": "121 E MAIN ST",
    "dropmalcty": "WILLIAMSTON",
    "dropmalst": "NC",
    "dropmalzpp": 278929998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527922636,
    "dropfax": 2528091242
  },
  {
    "dcode": "D",
    "dropkey": "PY16816",
    "droptype": "D",
    "dropname": "WILLOW SPRING",
    "dropdeladd": "6805 DWIGHT ROWLAND RD",
    "dropdelcty": "WILLOW SPRING",
    "dropdelst": "NC",
    "dropdelzpp": 275929998,
    "dropphyadd": "6805 DWIGHT ROWLAND RD",
    "dropphycty": "WILLOW SPRING",
    "dropphyst": "NC",
    "dropphyzpp": 275929998,
    "dropmaladd": "6805 DWIGHT ROWLAND RD",
    "dropmalcty": "WILLOW SPRING",
    "dropmalst": "NC",
    "dropmalzpp": 275929998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195776372,
    "dropfax": 9195521210
  },
  {
    "dcode": "D",
    "dropkey": "PY16820",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "152 N FRONT ST",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 284013925,
    "dropphyadd": "152 N FRONT ST",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 284013925,
    "dropmaladd": "PO BOX 28402",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 284029998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103133293,
    "dropsitcph": 9103133293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16821",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "501 MERCER ST SW",
    "dropdelcty": "WILSON",
    "dropdelst": "NC",
    "dropdelzpp": 278939998,
    "dropphyadd": "501 MERCER ST SW",
    "dropphycty": "WILSON",
    "dropphyst": "NC",
    "dropphyzpp": 278939998,
    "dropmaladd": "501 MERCER ST SW",
    "dropmalcty": "WILSON",
    "dropmalst": "NC",
    "dropmalzpp": 278939998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522374161,
    "dropfax": 2522372575
  },
  {
    "dcode": "D",
    "dropkey": "PY16823",
    "droptype": "D",
    "dropname": "WILSONS MILLS",
    "dropdeladd": "71 FIRE DEPARTMENT RD",
    "dropdelcty": "WILSONS MILLS",
    "dropdelst": "NC",
    "dropdelzpp": 275939998,
    "dropphyadd": "71 FIRE DEPARTMENT RD",
    "dropphycty": "WILSONS MILLS",
    "dropphyst": "NC",
    "dropphyzpp": 275939998,
    "dropmaladd": "71 FIRE DEPARTMENT RD",
    "dropmalcty": "WILSONS MILLS",
    "dropmalst": "NC",
    "dropmalzpp": 275939998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199348400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16826",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "130 N KING ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "NC",
    "dropdelzpp": 279839998,
    "dropphyadd": "130 N KING ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "NC",
    "dropphyzpp": 279839998,
    "dropmaladd": "130 N KING ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "NC",
    "dropmalzpp": 279839998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2527943155,
    "dropfax": 2527942541
  },
  {
    "dcode": "D",
    "dropkey": "PY16828",
    "droptype": "D",
    "dropname": "WINFALL",
    "dropdeladd": "317 MAIN ST",
    "dropdelcty": "WINFALL",
    "dropdelst": "NC",
    "dropdelzpp": 279859998,
    "dropphyadd": "317 MAIN ST",
    "dropphycty": "WINFALL",
    "dropphyst": "NC",
    "dropphyzpp": 279859998,
    "dropmaladd": "317 MAIN ST",
    "dropmalcty": "WINFALL",
    "dropmalst": "NC",
    "dropmalzpp": 279859998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524265018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16829",
    "droptype": "D",
    "dropname": "WINGATE",
    "dropdeladd": "212 N MAIN ST",
    "dropdelcty": "WINGATE",
    "dropdelst": "NC",
    "dropdelzpp": 281748289,
    "dropphyadd": "212 N MAIN ST",
    "dropphycty": "WINGATE",
    "dropphyst": "NC",
    "dropphyzpp": 281748289,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINGATE",
    "dropmalst": "NC",
    "dropmalzpp": 281749998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042330402,
    "dropsitcph": 7042330402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16830",
    "droptype": "D",
    "dropname": "WINNABOW",
    "dropdeladd": "6351 OCEAN HWY E",
    "dropdelcty": "WINNABOW",
    "dropdelst": "NC",
    "dropdelzpp": 284795770,
    "dropphyadd": "6351 OCEAN HWY E",
    "dropphycty": "WINNABOW",
    "dropphyst": "NC",
    "dropphyzpp": 284795770,
    "dropmaladd": "PO BOX 28479",
    "dropmalcty": "WINNABOW",
    "dropmalst": "NC",
    "dropmalzpp": 284799998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102535576,
    "dropsitcph": 9102943504,
    "dropfax": 9102539211
  },
  {
    "dcode": "D",
    "dropkey": "PY16832",
    "droptype": "D",
    "dropname": "WINSTON SALEM",
    "dropdeladd": "1500 N PATTERSON AVE",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271056049,
    "dropphyadd": "1500 N PATTERSON AVE",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271056049,
    "dropmaladd": "PO BOX 27102",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271029998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367216025,
    "dropfax": 3367216017
  },
  {
    "dcode": "D",
    "dropkey": "PY16836",
    "droptype": "D",
    "dropname": "WINTERVILLE",
    "dropdeladd": "467 MAIN ST",
    "dropdelcty": "WINTERVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285909748,
    "dropphyadd": "467 MAIN ST",
    "dropphycty": "WINTERVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285909748,
    "dropmaladd": "PO BOX 28590",
    "dropmalcty": "WINTERVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285909998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2527560011,
    "dropsitcph": 2527560011,
    "dropfax": 2527564724
  },
  {
    "dcode": "D",
    "dropkey": "PY16839",
    "droptype": "D",
    "dropname": "WINTON",
    "dropdeladd": "406 N MAIN ST",
    "dropdelcty": "WINTON",
    "dropdelst": "NC",
    "dropdelzpp": 279869997,
    "dropphyadd": "406 N MAIN ST",
    "dropphycty": "WINTON",
    "dropphyst": "NC",
    "dropphyzpp": 279869997,
    "dropmaladd": "406 N MAIN ST",
    "dropmalcty": "WINTON",
    "dropmalst": "NC",
    "dropmalzpp": 279869997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523582221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16840",
    "droptype": "D",
    "dropname": "WISE",
    "dropdeladd": "1728 US 1 HWY N",
    "dropdelcty": "WISE",
    "dropdelst": "NC",
    "dropdelzpp": 275949998,
    "dropphyadd": "1728 US 1 HWY N",
    "dropphycty": "WISE",
    "dropphyst": "NC",
    "dropphyzpp": 275949998,
    "dropmaladd": "1728 US 1 HWY N",
    "dropmalcty": "WISE",
    "dropmalst": "NC",
    "dropmalzpp": 275949998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2524563230,
    "dropfax": 2524563230
  },
  {
    "dcode": "D",
    "dropkey": "PY16844",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "WOODLAND",
    "dropdelst": "NC",
    "dropdelzpp": 278979782,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "WOODLAND",
    "dropphyst": "NC",
    "dropphyzpp": 278979782,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "WOODLAND",
    "dropmalst": "NC",
    "dropmalzpp": 278979998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2525875711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16846",
    "droptype": "D",
    "dropname": "WOODLEAF",
    "dropdeladd": "4220 POTNECK RD",
    "dropdelcty": "WOODLEAF",
    "dropdelst": "NC",
    "dropdelzpp": 270549998,
    "dropphyadd": "4220 POTNECK RD",
    "dropphycty": "WOODLEAF",
    "dropphyst": "NC",
    "dropphyzpp": 270549998,
    "dropmaladd": "4220 POTNECK RD",
    "dropmalcty": "WOODLEAF",
    "dropmalst": "NC",
    "dropmalzpp": 270549998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 7042784551,
    "dropfax": 7042789255
  },
  {
    "dcode": "D",
    "dropkey": "PY16852",
    "droptype": "D",
    "dropname": "WRIGHTSVILLE BEACH",
    "dropdeladd": "206 CAUSEWAY DR",
    "dropdelcty": "WRIGHTSVILLE BEACH",
    "dropdelst": "NC",
    "dropdelzpp": 284801748,
    "dropphyadd": "206 CAUSEWAY DR",
    "dropphycty": "WRIGHTSVILLE BEACH",
    "dropphyst": "NC",
    "dropphyzpp": 284801748,
    "dropmaladd": "PO BOX 28480",
    "dropmalcty": "WRIGHTSVILLE BEACH",
    "dropmalst": "NC",
    "dropmalzpp": 284809998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9102560159,
    "dropsitcph": 9102560159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16860",
    "droptype": "D",
    "dropname": "YADKINVILLE",
    "dropdeladd": "315 W MAIN ST",
    "dropdelcty": "YADKINVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 270557878,
    "dropphyadd": "315 W MAIN ST",
    "dropphycty": "YADKINVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 270557878,
    "dropmaladd": "315 W MAIN ST",
    "dropmalcty": "YADKINVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 270557878,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366798310,
    "dropfax": 3366793081
  },
  {
    "dcode": "D",
    "dropkey": "PY16863",
    "droptype": "D",
    "dropname": "YANCEYVILLE",
    "dropdeladd": "146 MAIN ST W",
    "dropdelcty": "YANCEYVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 273798780,
    "dropphyadd": "146 MAIN ST W",
    "dropphycty": "YANCEYVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 273798780,
    "dropmaladd": "146 MAIN ST W",
    "dropmalcty": "YANCEYVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 273799998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366946262,
    "dropfax": 3366946153
  },
  {
    "dcode": "D",
    "dropkey": "PY16867",
    "droptype": "D",
    "dropname": "YOUNGSVILLE",
    "dropdeladd": "112 E PERSIMMON ST",
    "dropdelcty": "YOUNGSVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 275960810,
    "dropphyadd": "112 E PERSIMMON ST",
    "dropphycty": "YOUNGSVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 275960810,
    "dropmaladd": "112 E PERSIMMON ST",
    "dropmalcty": "YOUNGSVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 275960800,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9195564831,
    "dropfax": 9195542890
  },
  {
    "dcode": "D",
    "dropkey": "PY16868",
    "droptype": "D",
    "dropname": "ZEBULON",
    "dropdeladd": "139 E VANCE ST",
    "dropdelcty": "ZEBULON",
    "dropdelst": "NC",
    "dropdelzpp": 275979998,
    "dropphyadd": "139 E VANCE ST",
    "dropphycty": "ZEBULON",
    "dropphyst": "NC",
    "dropphyzpp": 275979998,
    "dropmaladd": "139 E VANCE ST",
    "dropmalcty": "ZEBULON",
    "dropmalst": "NC",
    "dropmalzpp": 275979998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192690361,
    "dropfax": 9192696784
  },
  {
    "dcode": "D",
    "dropkey": "PY16870",
    "droptype": "D",
    "dropname": "ZIONVILLE",
    "dropdeladd": "12416 US HIGHWAY 421 N",
    "dropdelcty": "ZIONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 286989998,
    "dropphyadd": "12416 US HIGHWAY 421 N",
    "dropphycty": "ZIONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 286989998,
    "dropmaladd": "12416 US HIGHWAY 421 N",
    "dropmalcty": "ZIONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 286989998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282972444,
    "dropfax": 8282975528
  },
  {
    "dcode": "D",
    "dropkey": "PY16873",
    "droptype": "D",
    "dropname": "ZIRCONIA",
    "dropdeladd": "5576 GREENVILLE HWY",
    "dropdelcty": "ZIRCONIA",
    "dropdelst": "NC",
    "dropdelzpp": 287907879,
    "dropphyadd": "5576 GREENVILLE HWY",
    "dropphycty": "ZIRCONIA",
    "dropphyst": "NC",
    "dropphyzpp": 287907879,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZIRCONIA",
    "dropmalst": "NC",
    "dropmalzpp": 287909998,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286936783,
    "dropsitcph": 8286936783,
    "dropfax": 8286936783
  },
  {
    "dcode": "D",
    "dropkey": "PY16877",
    "droptype": "D",
    "dropname": "ABBOTSFORD",
    "dropdeladd": "113 N 2ND ST",
    "dropdelcty": "ABBOTSFORD",
    "dropdelst": "WI",
    "dropdelzpp": 544059800,
    "dropphyadd": "113 N 2ND ST",
    "dropphycty": "ABBOTSFORD",
    "dropphyst": "WI",
    "dropphyzpp": 544059800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ABBOTSFORD",
    "dropmalst": "WI",
    "dropmalzpp": 544059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152236082,
    "dropsitcph": 7152236082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16878",
    "droptype": "D",
    "dropname": "ABRAMS",
    "dropdeladd": "5886 MAIN ST",
    "dropdelcty": "ABRAMS",
    "dropdelst": "WI",
    "dropdelzpp": 541019543,
    "dropphyadd": "5886 MAIN ST",
    "dropphycty": "ABRAMS",
    "dropphyst": "WI",
    "dropphyzpp": 541019543,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ABRAMS",
    "dropmalst": "WI",
    "dropmalzpp": 541019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208265251,
    "dropsitcph": 9208265251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16879",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "151 S GRANT ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "WI",
    "dropdelzpp": 539109395,
    "dropphyadd": "151 S GRANT ST",
    "dropphycty": "ADAMS",
    "dropphyst": "WI",
    "dropphyzpp": 539109395,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMS",
    "dropmalst": "WI",
    "dropmalzpp": 539109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083397411,
    "dropsitcph": 6083397411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16880",
    "droptype": "D",
    "dropname": "ADELL",
    "dropdeladd": "611 MAINE AVE",
    "dropdelcty": "ADELL",
    "dropdelst": "WI",
    "dropdelzpp": 530019800,
    "dropphyadd": "611 MAINE AVE",
    "dropphycty": "ADELL",
    "dropphyst": "WI",
    "dropphyzpp": 530019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADELL",
    "dropmalst": "WI",
    "dropmalzpp": 530019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9209949515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16881",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "5316 S COUNTY ROAD D",
    "dropdelcty": "AFTON",
    "dropdelst": "WI",
    "dropdelzpp": 535019700,
    "dropphyadd": "5316 S COUNTY ROAD D",
    "dropphycty": "AFTON",
    "dropphyst": "WI",
    "dropphyzpp": 535019700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AFTON",
    "dropmalst": "WI",
    "dropmalzpp": 535019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087544110,
    "dropsitcph": 6087544110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16885",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "126 N WATER ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "WI",
    "dropdelzpp": 535028100,
    "dropphyadd": "126 N WATER ST",
    "dropphycty": "ALBANY",
    "dropphyst": "WI",
    "dropphyzpp": 535028100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBANY",
    "dropmalst": "WI",
    "dropmalzpp": 535029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088623232,
    "dropsitcph": 6088623232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16888",
    "droptype": "D",
    "dropname": "ALGOMA",
    "dropdeladd": "1121 FLORA AVE",
    "dropdelcty": "ALGOMA",
    "dropdelst": "WI",
    "dropdelzpp": 542019998,
    "dropphyadd": "1121 FLORA AVE",
    "dropphycty": "ALGOMA",
    "dropphyst": "WI",
    "dropphyzpp": 542019998,
    "dropmaladd": "1121 FLORA AVE",
    "dropmalcty": "ALGOMA",
    "dropmalst": "WI",
    "dropmalzpp": 542019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204872587,
    "dropsitcph": 9204872587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16889",
    "droptype": "D",
    "dropname": "ALLENTON",
    "dropdeladd": "330 1ST ST",
    "dropdelcty": "ALLENTON",
    "dropdelst": "WI",
    "dropdelzpp": 530029800,
    "dropphyadd": "330 1ST ST",
    "dropphycty": "ALLENTON",
    "dropphyst": "WI",
    "dropphyzpp": 530029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLENTON",
    "dropmalst": "WI",
    "dropmalzpp": 530029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626295212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16891",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "205 S MAIN ST",
    "dropdelcty": "ALMA",
    "dropdelst": "WI",
    "dropdelzpp": 546109703,
    "dropphyadd": "205 S MAIN ST",
    "dropphycty": "ALMA",
    "dropphyst": "WI",
    "dropphyzpp": 546109703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMA",
    "dropmalst": "WI",
    "dropmalzpp": 546109998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086853561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16892",
    "droptype": "D",
    "dropname": "ALMA CENTER",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "ALMA CENTER",
    "dropdelst": "WI",
    "dropdelzpp": 546119707,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "ALMA CENTER",
    "dropphyst": "WI",
    "dropphyzpp": 546119707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMA CENTER",
    "dropmalst": "WI",
    "dropmalzpp": 546119998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159648501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16893",
    "droptype": "D",
    "dropname": "ALMENA",
    "dropdeladd": "127 SOO AVE E",
    "dropdelcty": "ALMENA",
    "dropdelst": "WI",
    "dropdelzpp": 548057129,
    "dropphyadd": "127 SOO AVE E",
    "dropphycty": "ALMENA",
    "dropphyst": "WI",
    "dropphyzpp": 548057129,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMENA",
    "dropmalst": "WI",
    "dropmalzpp": 548059998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153573515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16894",
    "droptype": "D",
    "dropname": "ALMOND",
    "dropdeladd": "127 MAIN ST",
    "dropdelcty": "ALMOND",
    "dropdelst": "WI",
    "dropdelzpp": 549099382,
    "dropphyadd": "127 MAIN ST",
    "dropphycty": "ALMOND",
    "dropphyst": "WI",
    "dropphyzpp": 549099382,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMOND",
    "dropmalst": "WI",
    "dropmalzpp": 549099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153667141,
    "dropsitcph": 7153667141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16896",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "1328 LYNN AVE",
    "dropdelcty": "ALTOONA",
    "dropdelst": "WI",
    "dropdelzpp": 547201943,
    "dropphyadd": "1328 LYNN AVE",
    "dropphycty": "ALTOONA",
    "dropphyst": "WI",
    "dropphyzpp": 547201943,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTOONA",
    "dropmalst": "WI",
    "dropmalzpp": 547209998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158323706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16898",
    "droptype": "D",
    "dropname": "AMBERG",
    "dropdeladd": "N15075 DUTTON AVE",
    "dropdelcty": "AMBERG",
    "dropdelst": "WI",
    "dropdelzpp": 541029800,
    "dropphyadd": "N15075 DUTTON AVE",
    "dropphycty": "AMBERG",
    "dropphyst": "WI",
    "dropphyzpp": 541029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMBERG",
    "dropmalst": "WI",
    "dropmalzpp": 541029998,
    "dropsitphn": 4142912520,
    "dropsitlph": 7157595431,
    "dropsitcph": 7157595431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16900",
    "droptype": "D",
    "dropname": "AMERY",
    "dropdeladd": "1024 RIVERPLACE DR",
    "dropdelcty": "AMERY",
    "dropdelst": "WI",
    "dropdelzpp": 540015504,
    "dropphyadd": "1024 RIVERPLACE DR",
    "dropphycty": "AMERY",
    "dropphyst": "WI",
    "dropphyzpp": 540015504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMERY",
    "dropmalst": "WI",
    "dropmalzpp": 540019998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152687144,
    "dropfax": 7152687149
  },
  {
    "dcode": "D",
    "dropkey": "PY16901",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "187 N MAIN ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "WI",
    "dropdelzpp": 544069800,
    "dropphyadd": "187 N MAIN ST",
    "dropphycty": "AMHERST",
    "dropphyst": "WI",
    "dropphyzpp": 544069800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMHERST",
    "dropmalst": "WI",
    "dropmalzpp": 544069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158243423,
    "dropsitcph": 7158243423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16902",
    "droptype": "D",
    "dropname": "AMHERST JUNCTION",
    "dropdeladd": "9453 MAIN ST",
    "dropdelcty": "AMHERST JUNCTION",
    "dropdelst": "WI",
    "dropdelzpp": 544079545,
    "dropphyadd": "9453 MAIN ST",
    "dropphycty": "AMHERST JUNCTION",
    "dropphyst": "WI",
    "dropphyzpp": 544079545,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMHERST JUNCTION",
    "dropmalst": "WI",
    "dropmalzpp": 544079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158245894,
    "dropsitcph": 7158245894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16905",
    "droptype": "D",
    "dropname": "ANIWA",
    "dropdeladd": "W19057 1ST ST",
    "dropdelcty": "ANIWA",
    "dropdelst": "WI",
    "dropdelzpp": 544089800,
    "dropphyadd": "W19057 1ST ST",
    "dropphycty": "ANIWA",
    "dropphyst": "WI",
    "dropphyzpp": 544089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANIWA",
    "dropmalst": "WI",
    "dropmalzpp": 544089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154492313,
    "dropsitcph": 7154492313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16906",
    "droptype": "D",
    "dropname": "ANTIGO",
    "dropdeladd": "501 CLERMONT ST",
    "dropdelcty": "ANTIGO",
    "dropdelst": "WI",
    "dropdelzpp": 544099998,
    "dropphyadd": "501 CLERMONT ST",
    "dropphycty": "ANTIGO",
    "dropphyst": "WI",
    "dropphyzpp": 544099998,
    "dropmaladd": "501 CLERMONT ST",
    "dropmalcty": "ANTIGO",
    "dropmalst": "WI",
    "dropmalzpp": 544099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156274812,
    "dropsitcph": 7156274812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16908",
    "droptype": "D",
    "dropname": "APPLETON",
    "dropdeladd": "410 W FRANKLIN ST",
    "dropdelcty": "APPLETON",
    "dropdelst": "WI",
    "dropdelzpp": 549119998,
    "dropphyadd": "410 W FRANKLIN ST",
    "dropphycty": "APPLETON",
    "dropphyst": "WI",
    "dropphyzpp": 549119998,
    "dropmaladd": "410 W FRANKLIN ST",
    "dropmalcty": "APPLETON",
    "dropmalst": "WI",
    "dropmalzpp": 549119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209933055,
    "dropsitcph": 9209939442,
    "dropfax": 9207341506
  },
  {
    "dcode": "D",
    "dropkey": "PY16910",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "1495 E WILSON AVE",
    "dropdelcty": "ARCADIA",
    "dropdelst": "WI",
    "dropdelzpp": 546121843,
    "dropphyadd": "1495 E WILSON AVE",
    "dropphycty": "ARCADIA",
    "dropphyst": "WI",
    "dropphyzpp": 546121843,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCADIA",
    "dropmalst": "WI",
    "dropmalzpp": 546129998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083237103,
    "dropfax": 6083237192
  },
  {
    "dcode": "D",
    "dropkey": "PY16911",
    "droptype": "D",
    "dropname": "ARENA",
    "dropdeladd": "611 SOUTH ST",
    "dropdelcty": "ARENA",
    "dropdelst": "WI",
    "dropdelzpp": 535039707,
    "dropphyadd": "611 SOUTH ST",
    "dropphycty": "ARENA",
    "dropphyst": "WI",
    "dropphyzpp": 535039707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARENA",
    "dropmalst": "WI",
    "dropmalzpp": 535039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087532404,
    "dropsitcph": 6087532404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16912",
    "droptype": "D",
    "dropname": "ARGONNE",
    "dropdeladd": "7894 STATE HIGHWAY 32 55",
    "dropdelcty": "ARGONNE",
    "dropdelst": "WI",
    "dropdelzpp": 545119800,
    "dropphyadd": "7894 STATE HIGHWAY 32 55",
    "dropphycty": "ARGONNE",
    "dropphyst": "WI",
    "dropphyzpp": 545119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARGONNE",
    "dropmalst": "WI",
    "dropmalzpp": 545119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156493398,
    "dropsitcph": 7156493398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16913",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "329 E MILWAUKEE ST",
    "dropdelcty": "ARGYLE",
    "dropdelst": "WI",
    "dropdelzpp": 535049773,
    "dropphyadd": "329 E MILWAUKEE ST",
    "dropphycty": "ARGYLE",
    "dropphyst": "WI",
    "dropphyzpp": 535049773,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARGYLE",
    "dropmalst": "WI",
    "dropmalzpp": 535049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085433521,
    "dropsitcph": 6085433521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16914",
    "droptype": "D",
    "dropname": "ARKANSAW",
    "dropdeladd": "N6220 COUNTY RD N",
    "dropdelcty": "ARKANSAW",
    "dropdelst": "WI",
    "dropdelzpp": 547219486,
    "dropphyadd": "N6220 COUNTY RD N",
    "dropphycty": "ARKANSAW",
    "dropphyst": "WI",
    "dropphyzpp": 547219486,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARKANSAW",
    "dropmalst": "WI",
    "dropmalzpp": 547219998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152855893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16915",
    "droptype": "D",
    "dropname": "ARKDALE",
    "dropdeladd": "1568 STATE ROAD 21",
    "dropdelcty": "ARKDALE",
    "dropdelst": "WI",
    "dropdelzpp": 546134708,
    "dropphyadd": "1568 STATE ROAD 21",
    "dropphycty": "ARKDALE",
    "dropphyst": "WI",
    "dropphyzpp": 546134708,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARKDALE",
    "dropmalst": "WI",
    "dropmalzpp": 546139998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085647800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16917",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "205 MAIN ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "WI",
    "dropdelzpp": 539119783,
    "dropphyadd": "205 MAIN ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "WI",
    "dropphyzpp": 539119783,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "WI",
    "dropmalzpp": 539119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086352288,
    "dropsitcph": 6086352288,
    "dropfax": 6086352288
  },
  {
    "dcode": "D",
    "dropkey": "PY16918",
    "droptype": "D",
    "dropname": "ARMSTRONG CREEK",
    "dropdeladd": "7943 STATE HIGHWAY 101",
    "dropdelcty": "ARMSTRONG CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 541039800,
    "dropphyadd": "7943 STATE HIGHWAY 101",
    "dropphycty": "ARMSTRONG CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 541039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARMSTRONG CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 541039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153362430,
    "dropsitcph": 7153362430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16921",
    "droptype": "D",
    "dropname": "ARPIN",
    "dropdeladd": "8095 CHURCH RD",
    "dropdelcty": "ARPIN",
    "dropdelst": "WI",
    "dropdelzpp": 544109607,
    "dropphyadd": "8095 CHURCH RD",
    "dropphycty": "ARPIN",
    "dropphyst": "WI",
    "dropphyzpp": 544109607,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARPIN",
    "dropmalst": "WI",
    "dropmalzpp": 544109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156522800,
    "dropsitcph": 7156522800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16922",
    "droptype": "D",
    "dropname": "ASHIPPUN",
    "dropdeladd": "N546 STATE ROAD 67",
    "dropdelcty": "ASHIPPUN",
    "dropdelst": "WI",
    "dropdelzpp": 530039800,
    "dropphyadd": "N546 STATE ROAD 67",
    "dropphycty": "ASHIPPUN",
    "dropphyst": "WI",
    "dropphyzpp": 530039800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHIPPUN",
    "dropmalst": "WI",
    "dropmalzpp": 530039998,
    "dropsitphn": 9204744022,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204744022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16923",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "615 MAIN ST W",
    "dropdelcty": "ASHLAND",
    "dropdelst": "WI",
    "dropdelzpp": 548061300,
    "dropphyadd": "615 MAIN ST W",
    "dropphycty": "ASHLAND",
    "dropphyst": "WI",
    "dropphyzpp": 548061300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHLAND",
    "dropmalst": "WI",
    "dropmalzpp": 548069998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156824848,
    "dropfax": 7156825645
  },
  {
    "dcode": "D",
    "dropkey": "PY16927",
    "droptype": "D",
    "dropname": "ATHELSTANE",
    "dropdeladd": "W10056 COUNTY ROAD C",
    "dropdelcty": "ATHELSTANE",
    "dropdelst": "WI",
    "dropdelzpp": 541049766,
    "dropphyadd": "W10056 COUNTY ROAD C",
    "dropphycty": "ATHELSTANE",
    "dropphyst": "WI",
    "dropphyzpp": 541049766,
    "dropmaladd": "W10056 COUNTY ROAD C",
    "dropmalcty": "ATHELSTANE",
    "dropmalst": "WI",
    "dropmalzpp": 541049766,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158565062,
    "dropsitcph": 7158565062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16928",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "308 CAROLINE ST",
    "dropdelcty": "ATHENS",
    "dropdelst": "WI",
    "dropdelzpp": 544119498,
    "dropphyadd": "308 CAROLINE ST",
    "dropphycty": "ATHENS",
    "dropphyst": "WI",
    "dropphyzpp": 544119498,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATHENS",
    "dropmalst": "WI",
    "dropmalzpp": 544119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152577677,
    "dropsitcph": 7152577677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16930",
    "droptype": "D",
    "dropname": "AUBURNDALE",
    "dropdeladd": "10548 GEORGE AVE",
    "dropdelcty": "AUBURNDALE",
    "dropdelst": "WI",
    "dropdelzpp": 544129800,
    "dropphyadd": "10548 GEORGE AVE",
    "dropphycty": "AUBURNDALE",
    "dropphyst": "WI",
    "dropphyzpp": 544129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUBURNDALE",
    "dropmalst": "WI",
    "dropmalzpp": 544129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156522217,
    "dropsitcph": 7156522217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16931",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "130 W BROWN ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "WI",
    "dropdelzpp": 547229249,
    "dropphyadd": "130 W BROWN ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "WI",
    "dropphyzpp": 547229249,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "WI",
    "dropmalzpp": 547229998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152862954,
    "dropfax": 7152864112
  },
  {
    "dcode": "D",
    "dropkey": "PY16934",
    "droptype": "D",
    "dropname": "AVALON",
    "dropdeladd": "3109 S PLEASANT ST",
    "dropdelcty": "AVALON",
    "dropdelst": "WI",
    "dropdelzpp": 535059754,
    "dropphyadd": "3109 S PLEASANT ST",
    "dropphycty": "AVALON",
    "dropphyst": "WI",
    "dropphyzpp": 535059754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVALON",
    "dropmalst": "WI",
    "dropmalzpp": 535059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087524576,
    "dropsitcph": 6087524576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16935",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "405 FRONT ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "WI",
    "dropdelzpp": 535069668,
    "dropphyadd": "405 FRONT ST",
    "dropphycty": "AVOCA",
    "dropphyst": "WI",
    "dropphyzpp": 535069668,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVOCA",
    "dropmalst": "WI",
    "dropmalzpp": 535069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085326880,
    "dropsitcph": 6085326880,
    "dropfax": 6085326544
  },
  {
    "dcode": "D",
    "dropkey": "PY16937",
    "droptype": "D",
    "dropname": "BABCOCK",
    "dropdeladd": "1608 STATE HIGHWAY 80",
    "dropdelcty": "BABCOCK",
    "dropdelst": "WI",
    "dropdelzpp": 544139800,
    "dropphyadd": "1608 STATE HIGHWAY 80",
    "dropphycty": "BABCOCK",
    "dropphyst": "WI",
    "dropphyzpp": 544139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABCOCK",
    "dropmalst": "WI",
    "dropmalzpp": 544139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158842075,
    "dropsitcph": 7158842075,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16939",
    "droptype": "D",
    "dropname": "BAGLEY",
    "dropdeladd": "140 S BAGLEY AVE",
    "dropdelcty": "BAGLEY",
    "dropdelst": "WI",
    "dropdelzpp": 538019506,
    "dropphyadd": "140 S BAGLEY AVE",
    "dropphycty": "BAGLEY",
    "dropphyst": "WI",
    "dropphyzpp": 538019506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAGLEY",
    "dropmalst": "WI",
    "dropmalzpp": 538019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089962620,
    "dropsitcph": 6089962620,
    "dropfax": 6089962851
  },
  {
    "dcode": "D",
    "dropkey": "PY16940",
    "droptype": "D",
    "dropname": "BAILEYS HARBOR",
    "dropdeladd": "2398 BLUFF RD",
    "dropdelcty": "BAILEYS HARBOR",
    "dropdelst": "WI",
    "dropdelzpp": 542029800,
    "dropphyadd": "2398 BLUFF RD",
    "dropphycty": "BAILEYS HARBOR",
    "dropphyst": "WI",
    "dropphyzpp": 542029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAILEYS HARBOR",
    "dropmalst": "WI",
    "dropmalzpp": 542029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208390061,
    "dropsitcph": 9208390061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16943",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "1640 8TH AVE",
    "dropdelcty": "BALDWIN",
    "dropdelst": "WI",
    "dropdelzpp": 540029229,
    "dropphyadd": "1640 8TH AVE",
    "dropphycty": "BALDWIN",
    "dropphyst": "WI",
    "dropphyzpp": 540029229,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN",
    "dropmalst": "WI",
    "dropmalzpp": 540029998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156842934,
    "dropfax": 7156844685
  },
  {
    "dcode": "D",
    "dropkey": "PY16945",
    "droptype": "D",
    "dropname": "BALSAM LAKE",
    "dropdeladd": "308 PEARL ST",
    "dropdelcty": "BALSAM LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 548107254,
    "dropphyadd": "308 PEARL ST",
    "dropphycty": "BALSAM LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 548107254,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALSAM LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 548109998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154853477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16947",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "5506 COUNTY RD W",
    "dropdelcty": "BANCROFT",
    "dropdelst": "WI",
    "dropdelzpp": 549218811,
    "dropphyadd": "5506 COUNTY RD W",
    "dropphycty": "BANCROFT",
    "dropphyst": "WI",
    "dropphyzpp": 549218811,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANCROFT",
    "dropmalst": "WI",
    "dropmalzpp": 549219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153354445,
    "dropsitcph": 7153354445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16948",
    "droptype": "D",
    "dropname": "BANGOR",
    "dropdeladd": "1415 PEARL ST",
    "dropdelcty": "BANGOR",
    "dropdelst": "WI",
    "dropdelzpp": 546148858,
    "dropphyadd": "1415 PEARL ST",
    "dropphycty": "BANGOR",
    "dropphyst": "WI",
    "dropphyzpp": 546148858,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BANGOR",
    "dropmalst": "WI",
    "dropmalzpp": 546149998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084864025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16951",
    "droptype": "D",
    "dropname": "BARABOO",
    "dropdeladd": "303 BROADWAY ST",
    "dropdelcty": "BARABOO",
    "dropdelst": "WI",
    "dropdelzpp": 539139998,
    "dropphyadd": "303 BROADWAY ST",
    "dropphycty": "BARABOO",
    "dropphyst": "WI",
    "dropphyzpp": 539139998,
    "dropmaladd": "303 BROADWAY ST",
    "dropmalcty": "BARABOO",
    "dropmalst": "WI",
    "dropmalzpp": 539139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083567715,
    "dropsitcph": 6083567715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16954",
    "droptype": "D",
    "dropname": "BARNEVELD",
    "dropdeladd": "202 W MAIN ST",
    "dropdelcty": "BARNEVELD",
    "dropdelst": "WI",
    "dropdelzpp": 535079534,
    "dropphyadd": "202 W MAIN ST",
    "dropphycty": "BARNEVELD",
    "dropphyst": "WI",
    "dropphyzpp": 535079534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNEVELD",
    "dropmalst": "WI",
    "dropmalzpp": 535079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089242822,
    "dropsitcph": 6089242822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16956",
    "droptype": "D",
    "dropname": "BARRON",
    "dropdeladd": "437 E LA SALLE AVE",
    "dropdelcty": "BARRON",
    "dropdelst": "WI",
    "dropdelzpp": 548121518,
    "dropphyadd": "437 E LA SALLE AVE",
    "dropphycty": "BARRON",
    "dropphyst": "WI",
    "dropphyzpp": 548121518,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARRON",
    "dropmalst": "WI",
    "dropmalzpp": 548129998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156378203,
    "dropfax": 7155375687
  },
  {
    "dcode": "D",
    "dropkey": "PY16957",
    "droptype": "D",
    "dropname": "BARRONETT",
    "dropdeladd": "2964 US HIGHWAY 63",
    "dropdelcty": "BARRONETT",
    "dropdelst": "WI",
    "dropdelzpp": 548139464,
    "dropphyadd": "2964 US HIGHWAY 63",
    "dropphycty": "BARRONETT",
    "dropphyst": "WI",
    "dropphyzpp": 548139464,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARRONETT",
    "dropmalst": "WI",
    "dropmalzpp": 548139998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158224182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16961",
    "droptype": "D",
    "dropname": "BAY CITY",
    "dropdeladd": "W6372 MAIN ST",
    "dropdelcty": "BAY CITY",
    "dropdelst": "WI",
    "dropdelzpp": 547238324,
    "dropphyadd": "W6372 MAIN ST",
    "dropphycty": "BAY CITY",
    "dropphyst": "WI",
    "dropphyzpp": 547238324,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY CITY",
    "dropmalst": "WI",
    "dropmalzpp": 547239998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155943862,
    "dropfax": 7155943626
  },
  {
    "dcode": "D",
    "dropkey": "PY16965",
    "droptype": "D",
    "dropname": "BAYFIELD",
    "dropdeladd": "22 S BROAD ST",
    "dropdelcty": "BAYFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 548146500,
    "dropphyadd": "22 S BROAD ST",
    "dropphycty": "BAYFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 548146500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 548149998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157795636,
    "dropfax": 7157795636
  },
  {
    "dcode": "D",
    "dropkey": "PY16967",
    "droptype": "D",
    "dropname": "BEAR CREEK",
    "dropdeladd": "107 ROLLO ST",
    "dropdelcty": "BEAR CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 549229788,
    "dropphyadd": "107 ROLLO ST",
    "dropphycty": "BEAR CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 549229788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAR CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 549229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157524445,
    "dropsitcph": 7157524445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16969",
    "droptype": "D",
    "dropname": "BEAVER DAM",
    "dropdeladd": "411 N SPRING ST",
    "dropdelcty": "BEAVER DAM",
    "dropdelst": "WI",
    "dropdelzpp": 539169998,
    "dropphyadd": "411 N SPRING ST",
    "dropphycty": "BEAVER DAM",
    "dropphyst": "WI",
    "dropphyzpp": 539169998,
    "dropmaladd": "411 N SPRING ST",
    "dropmalcty": "BEAVER DAM",
    "dropmalst": "WI",
    "dropmalzpp": 539169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208853073,
    "dropsitcph": 9208853073,
    "dropfax": 9208854520
  },
  {
    "dcode": "D",
    "dropkey": "PY16971",
    "droptype": "D",
    "dropname": "BEETOWN",
    "dropdeladd": "9502 MUSCALLOUNGE RD",
    "dropdelcty": "BEETOWN",
    "dropdelst": "WI",
    "dropdelzpp": 538029701,
    "dropphyadd": "9502 MUSCALLOUNGE RD",
    "dropphycty": "BEETOWN",
    "dropphyst": "WI",
    "dropphyzpp": 538029701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEETOWN",
    "dropmalst": "WI",
    "dropmalzpp": 538029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087942134,
    "dropsitcph": 6087942134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16972",
    "droptype": "D",
    "dropname": "BELDENVILLE",
    "dropdeladd": "W7497 STATE ROAD 65",
    "dropdelcty": "BELDENVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 540034702,
    "dropphyadd": "W7497 STATE ROAD 65",
    "dropphycty": "BELDENVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 540034702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELDENVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 540039998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152734011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16975",
    "droptype": "D",
    "dropname": "BELGIUM",
    "dropdeladd": "543 MAIN ST",
    "dropdelcty": "BELGIUM",
    "dropdelst": "WI",
    "dropdelzpp": 530049998,
    "dropphyadd": "543 MAIN ST",
    "dropphycty": "BELGIUM",
    "dropphyst": "WI",
    "dropphyzpp": 530049998,
    "dropmaladd": "543 MAIN ST",
    "dropmalcty": "BELGIUM",
    "dropmalst": "WI",
    "dropmalzpp": 530049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622853791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16977",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "102 S VINE ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535089183,
    "dropphyadd": "102 S VINE ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535089183,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084241776,
    "dropsitcph": 6084246524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16979",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "112 S MOUND AVE",
    "dropdelcty": "BELMONT",
    "dropdelst": "WI",
    "dropdelzpp": 535109636,
    "dropphyadd": "112 S MOUND AVE",
    "dropphycty": "BELMONT",
    "dropphyst": "WI",
    "dropphyzpp": 535109636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELMONT",
    "dropmalst": "WI",
    "dropmalzpp": 535109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087625130,
    "dropsitcph": 6087625130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16980",
    "droptype": "D",
    "dropname": "BELOIT",
    "dropdeladd": "300 MILL ST",
    "dropdelcty": "BELOIT",
    "dropdelst": "WI",
    "dropdelzpp": 535119998,
    "dropphyadd": "300 MILL ST",
    "dropphycty": "BELOIT",
    "dropphyst": "WI",
    "dropphyzpp": 535119998,
    "dropmaladd": "300 MILL ST",
    "dropmalcty": "BELOIT",
    "dropmalst": "WI",
    "dropmalzpp": 535119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083657755,
    "dropsitcph": 6083657755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16985",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "33 BEAN ST STE 2",
    "dropdelcty": "BENTON",
    "dropdelst": "WI",
    "dropdelzpp": 538039758,
    "dropphyadd": "33 BEAN ST STE 2",
    "dropphycty": "BENTON",
    "dropphyst": "WI",
    "dropphyzpp": 538039758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENTON",
    "dropmalst": "WI",
    "dropmalzpp": 538039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087594611,
    "dropsitcph": 6087594611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16986",
    "droptype": "D",
    "dropname": "BERLIN",
    "dropdeladd": "122 S PEARL ST",
    "dropdelcty": "BERLIN",
    "dropdelst": "WI",
    "dropdelzpp": 549239998,
    "dropphyadd": "122 S PEARL ST",
    "dropphycty": "BERLIN",
    "dropphyst": "WI",
    "dropphyzpp": 549239998,
    "dropmaladd": "122 S PEARL ST",
    "dropmalcty": "BERLIN",
    "dropmalst": "WI",
    "dropmalzpp": 549239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203610360,
    "dropsitcph": 9203610360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16989",
    "droptype": "D",
    "dropname": "BIG BEND",
    "dropdeladd": "S87W22530 EDGEWOOD AVE",
    "dropdelcty": "BIG BEND",
    "dropdelst": "WI",
    "dropdelzpp": 531039998,
    "dropphyadd": "S87W22530 EDGEWOOD AVE",
    "dropphycty": "BIG BEND",
    "dropphyst": "WI",
    "dropphyzpp": 531039998,
    "dropmaladd": "S87W22530 EDGEWOOD AVE",
    "dropmalcty": "BIG BEND",
    "dropmalst": "WI",
    "dropmalzpp": 531039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626620996,
    "dropsitcph": 2626620996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16990",
    "droptype": "D",
    "dropname": "BIG FALLS",
    "dropdeladd": "216 S MAIN ST",
    "dropdelcty": "BIG FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 549269700,
    "dropphyadd": "216 S MAIN ST",
    "dropphycty": "BIG FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 549269700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 549269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157545464,
    "dropsitcph": 7157545464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16993",
    "droptype": "D",
    "dropname": "BIRCHWOOD",
    "dropdeladd": "106 S MAIN ST",
    "dropdelcty": "BIRCHWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 548178863,
    "dropphyadd": "106 S MAIN ST",
    "dropphycty": "BIRCHWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 548178863,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRCHWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 548179998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153543318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16994",
    "droptype": "D",
    "dropname": "BIRNAMWOOD",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "BIRNAMWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 544149278,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "BIRNAMWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 544149278,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRNAMWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 544149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154493133,
    "dropsitcph": 7154493133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16997",
    "droptype": "D",
    "dropname": "BLACK CREEK",
    "dropdeladd": "209 S MAIN ST",
    "dropdelcty": "BLACK CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 541069742,
    "dropphyadd": "209 S MAIN ST",
    "dropphycty": "BLACK CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 541069742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 541069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209843999,
    "dropsitcph": 9209843999,
    "dropfax": 9209843390
  },
  {
    "dcode": "D",
    "dropkey": "PY16998",
    "droptype": "D",
    "dropname": "BLACK EARTH",
    "dropdeladd": "1341 MILLS ST",
    "dropdelcty": "BLACK EARTH",
    "dropdelst": "WI",
    "dropdelzpp": 535159421,
    "dropphyadd": "1341 MILLS ST",
    "dropphycty": "BLACK EARTH",
    "dropphyst": "WI",
    "dropphyzpp": 535159421,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK EARTH",
    "dropmalst": "WI",
    "dropmalzpp": 535159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087672484,
    "dropsitcph": 6087672484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY16999",
    "droptype": "D",
    "dropname": "BLACK RIVER FALLS",
    "dropdeladd": "108 FILLMORE ST",
    "dropdelcty": "BLACK RIVER FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 546151741,
    "dropphyadd": "108 FILLMORE ST",
    "dropphycty": "BLACK RIVER FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 546151741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK RIVER FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 546159998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153331172,
    "dropfax": 7153330024
  },
  {
    "dcode": "D",
    "dropkey": "PY17001",
    "droptype": "D",
    "dropname": "BLAIR",
    "dropdeladd": "118 S URBERG AVE",
    "dropdelcty": "BLAIR",
    "dropdelst": "WI",
    "dropdelzpp": 546166200,
    "dropphyadd": "118 S URBERG AVE",
    "dropphycty": "BLAIR",
    "dropphyst": "WI",
    "dropphyzpp": 546166200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAIR",
    "dropmalst": "WI",
    "dropmalzpp": 546169998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6089892012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17002",
    "droptype": "D",
    "dropname": "BLANCHARDVILLE",
    "dropdeladd": "606 S MAIN ST",
    "dropdelcty": "BLANCHARDVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535169726,
    "dropphyadd": "606 S MAIN ST",
    "dropphycty": "BLANCHARDVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535169726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLANCHARDVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085234246,
    "dropsitcph": 6085234246,
    "dropfax": 6085234317
  },
  {
    "dcode": "D",
    "dropkey": "PY17003",
    "droptype": "D",
    "dropname": "BLENKER",
    "dropdeladd": "3888 COUNTY ROAD P",
    "dropdelcty": "BLENKER",
    "dropdelst": "WI",
    "dropdelzpp": 544159801,
    "dropphyadd": "3888 COUNTY ROAD P",
    "dropphycty": "BLENKER",
    "dropphyst": "WI",
    "dropphyzpp": 544159801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLENKER",
    "dropmalst": "WI",
    "dropmalzpp": 544159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156522996,
    "dropsitcph": 7156522996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17008",
    "droptype": "D",
    "dropname": "BLOOMER",
    "dropdeladd": "1622 MAIN ST",
    "dropdelcty": "BLOOMER",
    "dropdelst": "WI",
    "dropdelzpp": 547241647,
    "dropphyadd": "1622 MAIN ST",
    "dropphycty": "BLOOMER",
    "dropphyst": "WI",
    "dropphyzpp": 547241647,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMER",
    "dropmalst": "WI",
    "dropmalzpp": 547249998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155644038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17010",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "472 CANAL ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "WI",
    "dropdelzpp": 538049620,
    "dropphyadd": "472 CANAL ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "WI",
    "dropphyzpp": 538049620,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "WI",
    "dropmalzpp": 538049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089942343,
    "dropsitcph": 6089942343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17012",
    "droptype": "D",
    "dropname": "BLUE MOUNDS",
    "dropdeladd": "2965 JONES ST",
    "dropdelcty": "BLUE MOUNDS",
    "dropdelst": "WI",
    "dropdelzpp": 535179699,
    "dropphyadd": "2965 JONES ST",
    "dropphycty": "BLUE MOUNDS",
    "dropphyst": "WI",
    "dropphyzpp": 535179699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE MOUNDS",
    "dropmalst": "WI",
    "dropmalzpp": 535179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084375215,
    "dropsitcph": 6083008628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17013",
    "droptype": "D",
    "dropname": "BLUE RIVER",
    "dropdeladd": "105 EXCHANGE ST",
    "dropdelcty": "BLUE RIVER",
    "dropdelst": "WI",
    "dropdelzpp": 535189473,
    "dropphyadd": "105 EXCHANGE ST",
    "dropphycty": "BLUE RIVER",
    "dropphyst": "WI",
    "dropphyzpp": 535189473,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE RIVER",
    "dropmalst": "WI",
    "dropmalzpp": 535189998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085372415,
    "dropsitcph": 6085372415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17015",
    "droptype": "D",
    "dropname": "BONDUEL",
    "dropdeladd": "128 N CHURCH ST",
    "dropdelcty": "BONDUEL",
    "dropdelst": "WI",
    "dropdelzpp": 541079800,
    "dropphyadd": "128 N CHURCH ST",
    "dropphycty": "BONDUEL",
    "dropphyst": "WI",
    "dropphyzpp": 541079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BONDUEL",
    "dropmalst": "WI",
    "dropmalzpp": 541079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157582260,
    "dropsitcph": 7157582260,
    "dropfax": 7157582260
  },
  {
    "dcode": "D",
    "dropkey": "PY17016",
    "droptype": "D",
    "dropname": "BOSCOBEL",
    "dropdeladd": "105 SUPERIOR ST",
    "dropdelcty": "BOSCOBEL",
    "dropdelst": "WI",
    "dropdelzpp": 538059998,
    "dropphyadd": "105 SUPERIOR ST",
    "dropphycty": "BOSCOBEL",
    "dropphyst": "WI",
    "dropphyzpp": 538059998,
    "dropmaladd": "105 SUPERIOR ST",
    "dropmalcty": "BOSCOBEL",
    "dropmalst": "WI",
    "dropmalzpp": 538059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083755468,
    "dropsitcph": 6083755468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17017",
    "droptype": "D",
    "dropname": "BOULDER JUNCTION",
    "dropdeladd": "10328 MAIN ST",
    "dropdelcty": "BOULDER JUNCTION",
    "dropdelst": "WI",
    "dropdelzpp": 545129800,
    "dropphyadd": "10328 MAIN ST",
    "dropphycty": "BOULDER JUNCTION",
    "dropphyst": "WI",
    "dropphyzpp": 545129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOULDER JUNCTION",
    "dropmalst": "WI",
    "dropmalzpp": 545129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153852110,
    "dropsitcph": 7153852110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17018",
    "droptype": "D",
    "dropname": "BOWLER",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "BOWLER",
    "dropdelst": "WI",
    "dropdelzpp": 544169737,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "BOWLER",
    "dropphyst": "WI",
    "dropphyzpp": 544169737,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWLER",
    "dropmalst": "WI",
    "dropmalzpp": 544169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157934256,
    "dropsitcph": 7157934256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17019",
    "droptype": "D",
    "dropname": "BOYCEVILLE",
    "dropdeladd": "1246 NELSON DR",
    "dropdelcty": "BOYCEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 547254400,
    "dropphyadd": "1246 NELSON DR",
    "dropphycty": "BOYCEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 547254400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYCEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 547259998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156434351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17020",
    "droptype": "D",
    "dropname": "BOYD",
    "dropdeladd": "609 E MURRAY ST",
    "dropdelcty": "BOYD",
    "dropdelst": "WI",
    "dropdelzpp": 547269059,
    "dropphyadd": "609 E MURRAY ST",
    "dropphycty": "BOYD",
    "dropphyst": "WI",
    "dropphyzpp": 547269059,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYD",
    "dropmalst": "WI",
    "dropmalzpp": 547269998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156673392,
    "dropfax": 7156675172
  },
  {
    "dcode": "D",
    "dropkey": "PY17026",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "120 N COMMERCIAL ST",
    "dropdelcty": "BRANDON",
    "dropdelst": "WI",
    "dropdelzpp": 539199674,
    "dropphyadd": "120 N COMMERCIAL ST",
    "dropphycty": "BRANDON",
    "dropphyst": "WI",
    "dropphyzpp": 539199674,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANDON",
    "dropmalst": "WI",
    "dropmalzpp": 539199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203465314,
    "dropsitcph": 9203465314,
    "dropfax": 9203465760
  },
  {
    "dcode": "D",
    "dropkey": "PY17027",
    "droptype": "D",
    "dropname": "BRANTWOOD",
    "dropdeladd": "W1511 US HIGHWAY 8",
    "dropdelcty": "BRANTWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 545139800,
    "dropphyadd": "W1511 US HIGHWAY 8",
    "dropphycty": "BRANTWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 545139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANTWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 545139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155642244,
    "dropsitcph": 7155642244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17028",
    "droptype": "D",
    "dropname": "BRIGGSVILLE",
    "dropdeladd": "N433 COUNTY ROAD A",
    "dropdelcty": "BRIGGSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 539209701,
    "dropphyadd": "N433 COUNTY ROAD A",
    "dropphycty": "BRIGGSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 539209701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIGGSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 539209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089813008,
    "dropsitcph": 6089813009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17030",
    "droptype": "D",
    "dropname": "BRILLION",
    "dropdeladd": "210 E WATER ST",
    "dropdelcty": "BRILLION",
    "dropdelst": "WI",
    "dropdelzpp": 541109998,
    "dropphyadd": "210 E WATER ST",
    "dropphycty": "BRILLION",
    "dropphyst": "WI",
    "dropphyzpp": 541109998,
    "dropmaladd": "210 E WATER ST",
    "dropmalcty": "BRILLION",
    "dropmalst": "WI",
    "dropmalzpp": 541109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207562411,
    "dropsitcph": 9207562411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17031",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "8223 199TH AVE",
    "dropdelcty": "BRISTOL",
    "dropdelst": "WI",
    "dropdelzpp": 531049998,
    "dropphyadd": "8223 199TH AVE",
    "dropphycty": "BRISTOL",
    "dropphyst": "WI",
    "dropphyzpp": 531049998,
    "dropmaladd": "8223 199TH AVE",
    "dropmalcty": "BRISTOL",
    "dropmalst": "WI",
    "dropmalzpp": 531049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628577111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17032",
    "droptype": "D",
    "dropname": "BRODHEAD",
    "dropdeladd": "1507 1ST CENTER AVE",
    "dropdelcty": "BRODHEAD",
    "dropdelst": "WI",
    "dropdelzpp": 535209998,
    "dropphyadd": "1507 1ST CENTER AVE",
    "dropphycty": "BRODHEAD",
    "dropphyst": "WI",
    "dropphyzpp": 535209998,
    "dropmaladd": "1507 1ST CENTER AVE",
    "dropmalcty": "BRODHEAD",
    "dropmalst": "WI",
    "dropmalzpp": 535209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088974455,
    "dropsitcph": 6088974455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17033",
    "droptype": "D",
    "dropname": "BROKAW",
    "dropdeladd": "207 2ND ST",
    "dropdelcty": "BROKAW",
    "dropdelst": "WI",
    "dropdelzpp": 544179800,
    "dropphyadd": "207 2ND ST",
    "dropphycty": "BROKAW",
    "dropphyst": "WI",
    "dropphyzpp": 544179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROKAW",
    "dropmalst": "WI",
    "dropmalzpp": 544179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156753639,
    "dropsitcph": 7156753639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17034",
    "droptype": "D",
    "dropname": "BROOKFIELD",
    "dropdeladd": "17345 CIVIC DR",
    "dropdelcty": "BROOKFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 530459998,
    "dropphyadd": "17345 CIVIC DR",
    "dropphycty": "BROOKFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 530459998,
    "dropmaladd": "17345 CIVIC DR",
    "dropmalcty": "BROOKFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 530459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2627820741,
    "dropsitcph": 2627820588,
    "dropfax": 2629572749
  },
  {
    "dcode": "D",
    "dropkey": "PY17036",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "218 COMMERCIAL ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "WI",
    "dropdelzpp": 535219784,
    "dropphyadd": "218 COMMERCIAL ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "WI",
    "dropphyzpp": 535219784,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "WI",
    "dropmalzpp": 535219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084558102,
    "dropsitcph": 6084558102,
    "dropfax": 6084558101
  },
  {
    "dcode": "D",
    "dropkey": "PY17040",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "860 MAIN ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 530061439,
    "dropphyadd": "860 MAIN ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 530061439,
    "dropmaladd": "860 MAIN ST",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 530061439,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702066,
    "dropsitcph": 9205834042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17041",
    "droptype": "D",
    "dropname": "BROWNTOWN",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "BROWNTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 535229521,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "BROWNTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 535229521,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 535229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089663217,
    "dropsitcph": 6089663217,
    "dropfax": 6089663217
  },
  {
    "dcode": "D",
    "dropkey": "PY17042",
    "droptype": "D",
    "dropname": "BRUCE",
    "dropdeladd": "719 N 1ST ST",
    "dropdelcty": "BRUCE",
    "dropdelst": "WI",
    "dropdelzpp": 548199450,
    "dropphyadd": "719 N 1ST ST",
    "dropphycty": "BRUCE",
    "dropphyst": "WI",
    "dropphyzpp": 548199450,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUCE",
    "dropmalst": "WI",
    "dropmalzpp": 548199998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158684215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17043",
    "droptype": "D",
    "dropname": "BRULE",
    "dropdeladd": "13974 E US HIGHWAY 2",
    "dropdelcty": "BRULE",
    "dropdelst": "WI",
    "dropdelzpp": 548209038,
    "dropphyadd": "13974 E US HIGHWAY 2",
    "dropphycty": "BRULE",
    "dropphyst": "WI",
    "dropphyzpp": 548209038,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRULE",
    "dropmalst": "WI",
    "dropmalzpp": 548209998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153724984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17044",
    "droptype": "D",
    "dropname": "BRUSSELS",
    "dropdeladd": "1366 COUNTY ROAD DK",
    "dropdelcty": "BRUSSELS",
    "dropdelst": "WI",
    "dropdelzpp": 542049485,
    "dropphyadd": "1366 COUNTY ROAD DK",
    "dropphycty": "BRUSSELS",
    "dropphyst": "WI",
    "dropphyzpp": 542049485,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUSSELS",
    "dropmalst": "WI",
    "dropmalzpp": 542049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208251474,
    "dropsitcph": 9208251474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17049",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "100 S PINE ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "WI",
    "dropdelzpp": 531059998,
    "dropphyadd": "100 S PINE ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "WI",
    "dropphyzpp": 531059998,
    "dropmaladd": "100 S PINE ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "WI",
    "dropmalzpp": 531059998,
    "dropsitphn": 2622702120,
    "dropsitlph": 2622702120,
    "dropsitcph": 2627636300,
    "dropfax": 2627632268
  },
  {
    "dcode": "D",
    "dropkey": "PY17050",
    "droptype": "D",
    "dropname": "BURNETT",
    "dropdeladd": "N8528 2ND ST",
    "dropdelcty": "BURNETT",
    "dropdelst": "WI",
    "dropdelzpp": 539229604,
    "dropphyadd": "N8528 2ND ST",
    "dropphycty": "BURNETT",
    "dropphyst": "WI",
    "dropphyzpp": 539229604,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNETT",
    "dropmalst": "WI",
    "dropmalzpp": 539229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206892432,
    "dropsitcph": 9206892432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17051",
    "droptype": "D",
    "dropname": "BUTLER",
    "dropdeladd": "12420 W HAMPTON AVE",
    "dropdelcty": "BUTLER",
    "dropdelst": "WI",
    "dropdelzpp": 530079998,
    "dropphyadd": "12420 W HAMPTON AVE",
    "dropphycty": "BUTLER",
    "dropphyst": "WI",
    "dropphyzpp": 530079998,
    "dropmaladd": "12420 W HAMPTON AVE",
    "dropmalcty": "BUTLER",
    "dropmalst": "WI",
    "dropmalzpp": 530079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2629578951,
    "dropsitcph": 2627814064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17052",
    "droptype": "D",
    "dropname": "BUTTE DES MORTS",
    "dropdeladd": "5757 MAIN ST",
    "dropdelcty": "BUTTE DES MORTS",
    "dropdelst": "WI",
    "dropdelzpp": 549279800,
    "dropphyadd": "5757 MAIN ST",
    "dropphycty": "BUTTE DES MORTS",
    "dropphyst": "WI",
    "dropphyzpp": 549279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUTTE DES MORTS",
    "dropmalst": "WI",
    "dropmalzpp": 549279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205827567,
    "dropsitcph": 9205827567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17053",
    "droptype": "D",
    "dropname": "BUTTERNUT",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "BUTTERNUT",
    "dropdelst": "WI",
    "dropdelzpp": 545149800,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "BUTTERNUT",
    "dropphyst": "WI",
    "dropphyzpp": 545149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUTTERNUT",
    "dropmalst": "WI",
    "dropmalzpp": 545149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157693471,
    "dropsitcph": 7157693471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17055",
    "droptype": "D",
    "dropname": "CABLE",
    "dropdeladd": "43435 KAVANAUGH RD",
    "dropdelcty": "CABLE",
    "dropdelst": "WI",
    "dropdelzpp": 548214903,
    "dropphyadd": "43435 KAVANAUGH RD",
    "dropphycty": "CABLE",
    "dropphyst": "WI",
    "dropphyzpp": 548214903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CABLE",
    "dropmalst": "WI",
    "dropmalzpp": 548219998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157983719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17056",
    "droptype": "D",
    "dropname": "CADOTT",
    "dropdeladd": "321 N MAIN ST",
    "dropdelcty": "CADOTT",
    "dropdelst": "WI",
    "dropdelzpp": 547279658,
    "dropphyadd": "321 N MAIN ST",
    "dropphycty": "CADOTT",
    "dropphyst": "WI",
    "dropphyzpp": 547279658,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CADOTT",
    "dropmalst": "WI",
    "dropmalzpp": 547279998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152894227,
    "dropfax": 7152894237
  },
  {
    "dcode": "D",
    "dropkey": "PY17058",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "11510 COUNTY ROAD G",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "WI",
    "dropdelzpp": 531089998,
    "dropphyadd": "11510 COUNTY ROAD G",
    "dropphycty": "CALEDONIA",
    "dropphyst": "WI",
    "dropphyzpp": 531089998,
    "dropmaladd": "11510 COUNTY ROAD G",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "WI",
    "dropmalzpp": 531089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2628352188,
    "dropsitcph": 2628351774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17059",
    "droptype": "D",
    "dropname": "CAMBRIA",
    "dropdeladd": "102 E EDGEWATER ST",
    "dropdelcty": "CAMBRIA",
    "dropdelst": "WI",
    "dropdelzpp": 539239772,
    "dropphyadd": "102 E EDGEWATER ST",
    "dropphycty": "CAMBRIA",
    "dropphyst": "WI",
    "dropphyzpp": 539239772,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMBRIA",
    "dropmalst": "WI",
    "dropmalzpp": 539239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203485535,
    "dropsitcph": 9203485535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17060",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "107 PARK ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "WI",
    "dropdelzpp": 535239251,
    "dropphyadd": "107 PARK ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "WI",
    "dropphyzpp": 535239251,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "WI",
    "dropmalzpp": 535239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084237315,
    "dropsitcph": 6084237315,
    "dropfax": 6084233264
  },
  {
    "dcode": "D",
    "dropkey": "PY17061",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "1000 W MAIN ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "WI",
    "dropdelzpp": 548229647,
    "dropphyadd": "1000 W MAIN ST",
    "dropphycty": "CAMERON",
    "dropphyst": "WI",
    "dropphyzpp": 548229647,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMERON",
    "dropmalst": "WI",
    "dropmalzpp": 548229998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153540287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17062",
    "droptype": "D",
    "dropname": "CAMP DOUGLAS",
    "dropdeladd": "119 MAIN ST",
    "dropdelcty": "CAMP DOUGLAS",
    "dropdelst": "WI",
    "dropdelzpp": 546185005,
    "dropphyadd": "119 MAIN ST",
    "dropphycty": "CAMP DOUGLAS",
    "dropphyst": "WI",
    "dropphyzpp": 546185005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMP DOUGLAS",
    "dropmalst": "WI",
    "dropmalzpp": 546189998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084276602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17063",
    "droptype": "D",
    "dropname": "CAMP LAKE",
    "dropdeladd": "9540 CAMP LAKE RD",
    "dropdelcty": "CAMP LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 531099800,
    "dropphyadd": "9540 CAMP LAKE RD",
    "dropphycty": "CAMP LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 531099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMP LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 531099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628898191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17066",
    "droptype": "D",
    "dropname": "CAMPBELLSPORT",
    "dropdeladd": "324 N HELENA ST",
    "dropdelcty": "CAMPBELLSPORT",
    "dropdelst": "WI",
    "dropdelzpp": 530109800,
    "dropphyadd": "324 N HELENA ST",
    "dropphycty": "CAMPBELLSPORT",
    "dropphyst": "WI",
    "dropphyzpp": 530109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMPBELLSPORT",
    "dropmalst": "WI",
    "dropmalzpp": 530109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205334225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17070",
    "droptype": "D",
    "dropname": "CAROLINE",
    "dropdeladd": "W12742 COUNTY ROAD M",
    "dropdelcty": "CAROLINE",
    "dropdelst": "WI",
    "dropdelzpp": 549289724,
    "dropphyadd": "W12742 COUNTY ROAD M",
    "dropphycty": "CAROLINE",
    "dropphyst": "WI",
    "dropphyzpp": 549289724,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAROLINE",
    "dropmalst": "WI",
    "dropmalzpp": 549289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157542450,
    "dropsitcph": 7157542450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17075",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "205 LAKE ST",
    "dropdelcty": "CASCADE",
    "dropdelst": "WI",
    "dropdelzpp": 530111602,
    "dropphyadd": "205 LAKE ST",
    "dropphycty": "CASCADE",
    "dropphyst": "WI",
    "dropphyzpp": 530111602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASCADE",
    "dropmalst": "WI",
    "dropmalzpp": 530119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205288252,
    "dropfax": 9205288252
  },
  {
    "dcode": "D",
    "dropkey": "PY17076",
    "droptype": "D",
    "dropname": "CASCO",
    "dropdeladd": "307 MAIN ST",
    "dropdelcty": "CASCO",
    "dropdelst": "WI",
    "dropdelzpp": 542059484,
    "dropphyadd": "307 MAIN ST",
    "dropphycty": "CASCO",
    "dropphyst": "WI",
    "dropphyzpp": 542059484,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASCO",
    "dropmalst": "WI",
    "dropmalzpp": 542059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208377551,
    "dropsitcph": 9208377551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17077",
    "droptype": "D",
    "dropname": "CASHTON",
    "dropdeladd": "911 FRONT ST",
    "dropdelcty": "CASHTON",
    "dropdelst": "WI",
    "dropdelzpp": 546192003,
    "dropphyadd": "911 FRONT ST",
    "dropphycty": "CASHTON",
    "dropphyst": "WI",
    "dropphyzpp": 546192003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASHTON",
    "dropmalst": "WI",
    "dropmalzpp": 546199998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 6086547750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17079",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "205 E AMELIA ST",
    "dropdelcty": "CASSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 538069534,
    "dropphyadd": "205 E AMELIA ST",
    "dropphycty": "CASSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 538069534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 538069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087255136,
    "dropsitcph": 6087255136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17085",
    "droptype": "D",
    "dropname": "CAZENOVIA",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "CAZENOVIA",
    "dropdelst": "WI",
    "dropdelzpp": 539249701,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "CAZENOVIA",
    "dropphyst": "WI",
    "dropphyzpp": 539249701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAZENOVIA",
    "dropmalst": "WI",
    "dropmalzpp": 539249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089832846,
    "dropsitcph": 6089832846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17086",
    "droptype": "D",
    "dropname": "CECIL",
    "dropdeladd": "107 E FREEBORN ST",
    "dropdelcty": "CECIL",
    "dropdelst": "WI",
    "dropdelzpp": 541119800,
    "dropphyadd": "107 E FREEBORN ST",
    "dropphycty": "CECIL",
    "dropphyst": "WI",
    "dropphyzpp": 541119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CECIL",
    "dropmalst": "WI",
    "dropmalzpp": 541119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157456284,
    "dropsitcph": 7157456284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17089",
    "droptype": "D",
    "dropname": "CEDAR GROVE",
    "dropdeladd": "103 W WISCONSIN AVE",
    "dropdelcty": "CEDAR GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 530131338,
    "dropphyadd": "103 W WISCONSIN AVE",
    "dropphycty": "CEDAR GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 530131338,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 530139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206686211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17091",
    "droptype": "D",
    "dropname": "CEDARBURG",
    "dropdeladd": "W63N605 HANOVER AVE",
    "dropdelcty": "CEDARBURG",
    "dropdelst": "WI",
    "dropdelzpp": 530129998,
    "dropphyadd": "W63N605 HANOVER AVE",
    "dropphycty": "CEDARBURG",
    "dropphyst": "WI",
    "dropphyzpp": 530129998,
    "dropmaladd": "W63N605 HANOVER AVE",
    "dropmalcty": "CEDARBURG",
    "dropmalst": "WI",
    "dropmalzpp": 530129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2623770385,
    "dropsitcph": 2623770388,
    "dropfax": 4143775438
  },
  {
    "dcode": "D",
    "dropkey": "PY17096",
    "droptype": "D",
    "dropname": "CENTURIA",
    "dropdeladd": "316 4TH ST",
    "dropdelcty": "CENTURIA",
    "dropdelst": "WI",
    "dropdelzpp": 548247470,
    "dropphyadd": "316 4TH ST",
    "dropphycty": "CENTURIA",
    "dropphyst": "WI",
    "dropphyzpp": 548247470,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTURIA",
    "dropmalst": "WI",
    "dropmalzpp": 548249998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156462121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17097",
    "droptype": "D",
    "dropname": "CHASEBURG",
    "dropdeladd": "303 DEPOT ST",
    "dropdelcty": "CHASEBURG",
    "dropdelst": "WI",
    "dropdelzpp": 546219797,
    "dropphyadd": "303 DEPOT ST",
    "dropphycty": "CHASEBURG",
    "dropphyst": "WI",
    "dropphyzpp": 546219797,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHASEBURG",
    "dropmalst": "WI",
    "dropmalzpp": 546219998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084832490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17101",
    "droptype": "D",
    "dropname": "CHETEK",
    "dropdeladd": "535 1ST ST",
    "dropdelcty": "CHETEK",
    "dropdelst": "WI",
    "dropdelzpp": 547288960,
    "dropphyadd": "535 1ST ST",
    "dropphycty": "CHETEK",
    "dropphyst": "WI",
    "dropphyzpp": 547288960,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHETEK",
    "dropmalst": "WI",
    "dropmalzpp": 547289998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159243501,
    "dropfax": 7159243582
  },
  {
    "dcode": "D",
    "dropkey": "PY17102",
    "droptype": "D",
    "dropname": "CHILI",
    "dropdeladd": "W931 CHILI RD",
    "dropdelcty": "CHILI",
    "dropdelst": "WI",
    "dropdelzpp": 544209201,
    "dropphyadd": "W931 CHILI RD",
    "dropphycty": "CHILI",
    "dropphyst": "WI",
    "dropphyzpp": 544209201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHILI",
    "dropmalst": "WI",
    "dropmalzpp": 544209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156832690,
    "dropsitcph": 7156832690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17103",
    "droptype": "D",
    "dropname": "CHILTON",
    "dropdeladd": "57 E MAIN ST",
    "dropdelcty": "CHILTON",
    "dropdelst": "WI",
    "dropdelzpp": 530149998,
    "dropphyadd": "57 E MAIN ST",
    "dropphycty": "CHILTON",
    "dropphyst": "WI",
    "dropphyzpp": 530149998,
    "dropmaladd": "57 E MAIN ST",
    "dropmalcty": "CHILTON",
    "dropmalst": "WI",
    "dropmalzpp": 530149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9208492651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17104",
    "droptype": "D",
    "dropname": "CHIPPEWA FALLS",
    "dropdeladd": "315 N BRIDGE ST",
    "dropdelcty": "CHIPPEWA FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 547299925,
    "dropphyadd": "315 N BRIDGE ST",
    "dropphycty": "CHIPPEWA FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 547299925,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIPPEWA FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 547299998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157232895,
    "dropfax": 7157235805
  },
  {
    "dcode": "D",
    "dropkey": "PY17111",
    "droptype": "D",
    "dropname": "CLAM LAKE",
    "dropdeladd": "60967 STATE HIGHWAY 77",
    "dropdelcty": "CLAM LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 545179419,
    "dropphyadd": "60967 STATE HIGHWAY 77",
    "dropphycty": "CLAM LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 545179419,
    "dropmaladd": "60967 STATE HIGHWAY 77",
    "dropmalcty": "CLAM LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 545179419,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157942367,
    "dropsitcph": 7157942367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17113",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "200 PRENTICE ST N",
    "dropdelcty": "CLAYTON",
    "dropdelst": "WI",
    "dropdelzpp": 540049110,
    "dropphyadd": "200 PRENTICE ST N",
    "dropphycty": "CLAYTON",
    "dropphyst": "WI",
    "dropphyzpp": 540049110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAYTON",
    "dropmalst": "WI",
    "dropmalzpp": 540049998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159482701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17114",
    "droptype": "D",
    "dropname": "CLEAR LAKE",
    "dropdeladd": "438 3RD AVE",
    "dropdelcty": "CLEAR LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 540058907,
    "dropphyadd": "438 3RD AVE",
    "dropphycty": "CLEAR LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 540058907,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEAR LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 540059998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152653604,
    "dropfax": 7152632400
  },
  {
    "dcode": "D",
    "dropkey": "PY17121",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "1029 HEMLOCK ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "WI",
    "dropdelzpp": 530151499,
    "dropphyadd": "1029 HEMLOCK ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "WI",
    "dropphyzpp": 530151499,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "WI",
    "dropmalzpp": 530159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206938671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17123",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "243 ALLEN ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "WI",
    "dropdelzpp": 535259001,
    "dropphyadd": "243 ALLEN ST",
    "dropphycty": "CLINTON",
    "dropphyst": "WI",
    "dropphyzpp": 535259001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLINTON",
    "dropmalst": "WI",
    "dropmalzpp": 535259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086765422,
    "dropsitcph": 6086765422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17124",
    "droptype": "D",
    "dropname": "CLINTONVILLE",
    "dropdeladd": "2 N MAIN ST",
    "dropdelcty": "CLINTONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 549299998,
    "dropphyadd": "2 N MAIN ST",
    "dropphycty": "CLINTONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 549299998,
    "dropmaladd": "2 N MAIN ST",
    "dropmalcty": "CLINTONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 549299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158234217,
    "dropsitcph": 7158234217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17126",
    "droptype": "D",
    "dropname": "CLYMAN",
    "dropdeladd": "900 MAIN ST",
    "dropdelcty": "CLYMAN",
    "dropdelst": "WI",
    "dropdelzpp": 530169800,
    "dropphyadd": "900 MAIN ST",
    "dropphycty": "CLYMAN",
    "dropphyst": "WI",
    "dropphyzpp": 530169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLYMAN",
    "dropmalst": "WI",
    "dropmalzpp": 530169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206963412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17128",
    "droptype": "D",
    "dropname": "COBB",
    "dropdeladd": "106 DIVISION ST",
    "dropdelcty": "COBB",
    "dropdelst": "WI",
    "dropdelzpp": 535268501,
    "dropphyadd": "106 DIVISION ST",
    "dropphycty": "COBB",
    "dropphyst": "WI",
    "dropphyzpp": 535268501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COBB",
    "dropmalst": "WI",
    "dropmalzpp": 535269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086232008,
    "dropsitcph": 6086232008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17129",
    "droptype": "D",
    "dropname": "COCHRANE",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "COCHRANE",
    "dropdelst": "WI",
    "dropdelzpp": 546227055,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "COCHRANE",
    "dropphyst": "WI",
    "dropphyzpp": 546227055,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COCHRANE",
    "dropmalst": "WI",
    "dropmalzpp": 546229998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6082482650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17131",
    "droptype": "D",
    "dropname": "COLBY",
    "dropdeladd": "200 W SPENCE ST",
    "dropdelcty": "COLBY",
    "dropdelst": "WI",
    "dropdelzpp": 544219800,
    "dropphyadd": "200 W SPENCE ST",
    "dropphycty": "COLBY",
    "dropphyst": "WI",
    "dropphyzpp": 544219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLBY",
    "dropmalst": "WI",
    "dropmalzpp": 544219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152232626,
    "dropsitcph": 7152232626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17132",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "153 W MAIN ST",
    "dropdelcty": "COLEMAN",
    "dropdelst": "WI",
    "dropdelzpp": 541129800,
    "dropphyadd": "153 W MAIN ST",
    "dropphycty": "COLEMAN",
    "dropphyst": "WI",
    "dropphyzpp": 541129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLEMAN",
    "dropmalst": "WI",
    "dropmalzpp": 541129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208973850,
    "dropsitcph": 9208973850,
    "dropfax": 9208972326
  },
  {
    "dcode": "D",
    "dropkey": "PY17133",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "WI",
    "dropdelzpp": 547309148,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "COLFAX",
    "dropphyst": "WI",
    "dropphyzpp": 547309148,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLFAX",
    "dropmalst": "WI",
    "dropmalzpp": 547309998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159623777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17134",
    "droptype": "D",
    "dropname": "COLGATE",
    "dropdeladd": "3392 COUNTY LINE RD",
    "dropdelcty": "COLGATE",
    "dropdelst": "WI",
    "dropdelzpp": 530179998,
    "dropphyadd": "3392 COUNTY LINE RD",
    "dropphycty": "COLGATE",
    "dropphyst": "WI",
    "dropphyzpp": 530179998,
    "dropmaladd": "3392 COUNTY LINE RD",
    "dropmalcty": "COLGATE",
    "dropmalst": "WI",
    "dropmalzpp": 530179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626282393,
    "dropsitcph": 2626282393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17136",
    "droptype": "D",
    "dropname": "COLLINS",
    "dropdeladd": "20841 COUNTY ROAD JJ",
    "dropdelcty": "COLLINS",
    "dropdelst": "WI",
    "dropdelzpp": 542079800,
    "dropphyadd": "20841 COUNTY ROAD JJ",
    "dropphycty": "COLLINS",
    "dropphyst": "WI",
    "dropphyzpp": 542079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLINS",
    "dropmalst": "WI",
    "dropmalzpp": 542079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207724107,
    "dropsitcph": 9207724107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17137",
    "droptype": "D",
    "dropname": "COLOMA",
    "dropdeladd": "145 N FRONT ST",
    "dropdelcty": "COLOMA",
    "dropdelst": "WI",
    "dropdelzpp": 549309656,
    "dropphyadd": "145 N FRONT ST",
    "dropphycty": "COLOMA",
    "dropphyst": "WI",
    "dropphyzpp": 549309656,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLOMA",
    "dropmalst": "WI",
    "dropmalzpp": 549309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152283151,
    "dropsitcph": 7152283151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17138",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "211 S DICKASON BLVD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "WI",
    "dropdelzpp": 539259998,
    "dropphyadd": "211 S DICKASON BLVD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "WI",
    "dropphyzpp": 539259998,
    "dropmaladd": "211 S DICKASON BLVD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "WI",
    "dropmalzpp": 539259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206235310,
    "dropsitcph": 9206235310,
    "dropfax": 9206230283
  },
  {
    "dcode": "D",
    "dropkey": "PY17139",
    "droptype": "D",
    "dropname": "COMBINED LOCKS",
    "dropdeladd": "333 WALLACE ST",
    "dropdelcty": "COMBINED LOCKS",
    "dropdelst": "WI",
    "dropdelzpp": 541139998,
    "dropphyadd": "333 WALLACE ST",
    "dropphycty": "COMBINED LOCKS",
    "dropphyst": "WI",
    "dropphyzpp": 541139998,
    "dropmaladd": "333 WALLACE ST",
    "dropmalcty": "COMBINED LOCKS",
    "dropmalst": "WI",
    "dropmalzpp": 541139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207886849,
    "dropsitcph": 9206876925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17142",
    "droptype": "D",
    "dropname": "CONOVER",
    "dropdeladd": "4665 COUNTY ROAD K E",
    "dropdelcty": "CONOVER",
    "dropdelst": "WI",
    "dropdelzpp": 545199401,
    "dropphyadd": "4665 COUNTY ROAD K E",
    "dropphycty": "CONOVER",
    "dropphyst": "WI",
    "dropphyzpp": 545199401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONOVER",
    "dropmalst": "WI",
    "dropmalzpp": 545199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154771354,
    "dropsitcph": 7154771354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17143",
    "droptype": "D",
    "dropname": "CONRATH",
    "dropdeladd": "W7101 MAIN ST",
    "dropdelcty": "CONRATH",
    "dropdelst": "WI",
    "dropdelzpp": 547314200,
    "dropphyadd": "W7101 MAIN ST",
    "dropphycty": "CONRATH",
    "dropphyst": "WI",
    "dropphyzpp": 547314200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONRATH",
    "dropmalst": "WI",
    "dropmalzpp": 547319998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155325132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17146",
    "droptype": "D",
    "dropname": "COON VALLEY",
    "dropdeladd": "507 CENTRAL AVE",
    "dropdelcty": "COON VALLEY",
    "dropdelst": "WI",
    "dropdelzpp": 546238031,
    "dropphyadd": "507 CENTRAL AVE",
    "dropphycty": "COON VALLEY",
    "dropphyst": "WI",
    "dropphyzpp": 546238031,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COON VALLEY",
    "dropmalst": "WI",
    "dropmalzpp": 546239998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084523731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17147",
    "droptype": "D",
    "dropname": "CORNELL",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "CORNELL",
    "dropdelst": "WI",
    "dropdelzpp": 547328372,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "CORNELL",
    "dropphyst": "WI",
    "dropphyzpp": 547328372,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNELL",
    "dropmalst": "WI",
    "dropmalzpp": 547329998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152396484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17149",
    "droptype": "D",
    "dropname": "CORNUCOPIA",
    "dropdeladd": "88530 SUPERIOR AVE",
    "dropdelcty": "CORNUCOPIA",
    "dropdelst": "WI",
    "dropdelzpp": 548279601,
    "dropphyadd": "88530 SUPERIOR AVE",
    "dropphycty": "CORNUCOPIA",
    "dropphyst": "WI",
    "dropphyzpp": 548279601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNUCOPIA",
    "dropmalst": "WI",
    "dropmalzpp": 548279998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157423331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17151",
    "droptype": "D",
    "dropname": "COTTAGE GROVE",
    "dropdeladd": "451 W COTTAGE GROVE RD",
    "dropdelcty": "COTTAGE GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 535279385,
    "dropphyadd": "451 W COTTAGE GROVE RD",
    "dropphycty": "COTTAGE GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 535279385,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTAGE GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 535279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088391430,
    "dropsitcph": 6088393931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17152",
    "droptype": "D",
    "dropname": "COUDERAY",
    "dropdeladd": "4457 N HOFFER RD",
    "dropdelcty": "COUDERAY",
    "dropdelst": "WI",
    "dropdelzpp": 548287192,
    "dropphyadd": "4457 N HOFFER RD",
    "dropphycty": "COUDERAY",
    "dropphyst": "WI",
    "dropphyzpp": 548287192,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COUDERAY",
    "dropmalst": "WI",
    "dropmalzpp": 548289998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159452751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17153",
    "droptype": "D",
    "dropname": "CRANDON",
    "dropdeladd": "111 W WASHINGTON ST",
    "dropdelcty": "CRANDON",
    "dropdelst": "WI",
    "dropdelzpp": 545209998,
    "dropphyadd": "111 W WASHINGTON ST",
    "dropphycty": "CRANDON",
    "dropphyst": "WI",
    "dropphyzpp": 545209998,
    "dropmaladd": "111 W WASHINGTON ST",
    "dropmalcty": "CRANDON",
    "dropmalst": "WI",
    "dropmalzpp": 545209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154782356,
    "dropsitcph": 7154782356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17157",
    "droptype": "D",
    "dropname": "CRIVITZ",
    "dropdeladd": "1210 FJ ST",
    "dropdelcty": "CRIVITZ",
    "dropdelst": "WI",
    "dropdelzpp": 541141419,
    "dropphyadd": "1210 FJ ST",
    "dropphycty": "CRIVITZ",
    "dropphyst": "WI",
    "dropphyzpp": 541141419,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRIVITZ",
    "dropmalst": "WI",
    "dropmalzpp": 541149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158542485,
    "dropsitcph": 7158542485,
    "dropfax": 7158543688
  },
  {
    "dcode": "D",
    "dropkey": "PY17158",
    "droptype": "D",
    "dropname": "CROSS PLAINS",
    "dropdeladd": "2012 PARK ST",
    "dropdelcty": "CROSS PLAINS",
    "dropdelst": "WI",
    "dropdelzpp": 535288853,
    "dropphyadd": "2012 PARK ST",
    "dropphycty": "CROSS PLAINS",
    "dropphyst": "WI",
    "dropphyzpp": 535288853,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS PLAINS",
    "dropmalst": "WI",
    "dropmalzpp": 535289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087981462,
    "dropsitcph": 6087981462,
    "dropfax": 6087980619
  },
  {
    "dcode": "D",
    "dropkey": "PY17164",
    "droptype": "D",
    "dropname": "CUBA CITY",
    "dropdeladd": "101 S MADISON ST",
    "dropdelcty": "CUBA CITY",
    "dropdelst": "WI",
    "dropdelzpp": 538079998,
    "dropphyadd": "101 S MADISON ST",
    "dropphycty": "CUBA CITY",
    "dropphyst": "WI",
    "dropphyzpp": 538079998,
    "dropmaladd": "101 S MADISON ST",
    "dropmalcty": "CUBA CITY",
    "dropmalst": "WI",
    "dropmalzpp": 538079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087442180,
    "dropsitcph": 6087442180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17165",
    "droptype": "D",
    "dropname": "CUDAHY",
    "dropdeladd": "5656 S PACKARD AVE STE 200",
    "dropdelcty": "CUDAHY",
    "dropdelst": "WI",
    "dropdelzpp": 531102658,
    "dropphyadd": "5656 S PACKARD AVE STE 200",
    "dropphycty": "CUDAHY",
    "dropphyst": "WI",
    "dropphyzpp": 531102658,
    "dropmaladd": "5656 S PACKARD AVE STE 200",
    "dropmalcty": "CUDAHY",
    "dropmalst": "WI",
    "dropmalzpp": 531102658,
    "dropsitphn": 4142702120,
    "dropsitlph": 4147440361,
    "dropsitcph": 4147440361,
    "dropfax": 4147443217
  },
  {
    "dcode": "D",
    "dropkey": "PY17166",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "1400 3RD AVE",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "WI",
    "dropdelzpp": 548299151,
    "dropphyadd": "1400 3RD AVE",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "WI",
    "dropphyzpp": 548299151,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "WI",
    "dropmalzpp": 548299998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158222946,
    "dropfax": 7158223940
  },
  {
    "dcode": "D",
    "dropkey": "PY17167",
    "droptype": "D",
    "dropname": "CURTISS",
    "dropdeladd": "915 N MERIDIAN ST",
    "dropdelcty": "CURTISS",
    "dropdelst": "WI",
    "dropdelzpp": 544229800,
    "dropphyadd": "915 N MERIDIAN ST",
    "dropphycty": "CURTISS",
    "dropphyst": "WI",
    "dropphyzpp": 544229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURTISS",
    "dropmalst": "WI",
    "dropmalzpp": 544229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152234225,
    "dropsitcph": 7152234225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17168",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "2492 240TH ST",
    "dropdelcty": "CUSHING",
    "dropdelst": "WI",
    "dropdelzpp": 540063303,
    "dropphyadd": "2492 240TH ST",
    "dropphycty": "CUSHING",
    "dropphyst": "WI",
    "dropphyzpp": 540063303,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSHING",
    "dropmalst": "WI",
    "dropmalzpp": 540069998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156485466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17169",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "2224 CUSTER RD",
    "dropdelcty": "CUSTER",
    "dropdelst": "WI",
    "dropdelzpp": 544239800,
    "dropphyadd": "2224 CUSTER RD",
    "dropphycty": "CUSTER",
    "dropphyst": "WI",
    "dropphyzpp": 544239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSTER",
    "dropmalst": "WI",
    "dropmalzpp": 544239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155924176,
    "dropsitcph": 7155924176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17174",
    "droptype": "D",
    "dropname": "DALE",
    "dropdeladd": "W9728 STATE ROAD 96",
    "dropdelcty": "DALE",
    "dropdelst": "WI",
    "dropdelzpp": 549319700,
    "dropphyadd": "W9728 STATE ROAD 96",
    "dropphycty": "DALE",
    "dropphyst": "WI",
    "dropphyzpp": 549319700,
    "dropmaladd": "W9728 STATE ROAD 96",
    "dropmalcty": "DALE",
    "dropmalst": "WI",
    "dropmalzpp": 549319700,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207796414,
    "dropsitcph": 9207796414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17175",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "120 E DALLAS ST",
    "dropdelcty": "DALLAS",
    "dropdelst": "WI",
    "dropdelzpp": 547339702,
    "dropphyadd": "120 E DALLAS ST",
    "dropphycty": "DALLAS",
    "dropphyst": "WI",
    "dropphyzpp": 547339702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALLAS",
    "dropmalst": "WI",
    "dropmalzpp": 547339998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158371568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17176",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "N755 COUNTY ROAD FF",
    "dropdelcty": "DALTON",
    "dropdelst": "WI",
    "dropdelzpp": 539269346,
    "dropphyadd": "N755 COUNTY ROAD FF",
    "dropphycty": "DALTON",
    "dropphyst": "WI",
    "dropphyzpp": 539269346,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALTON",
    "dropmalst": "WI",
    "dropmalzpp": 539269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203943909,
    "dropsitcph": 9203943909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17177",
    "droptype": "D",
    "dropname": "DANBURY",
    "dropdeladd": "7506 MAIN ST",
    "dropdelcty": "DANBURY",
    "dropdelst": "WI",
    "dropdelzpp": 548309417,
    "dropphyadd": "7506 MAIN ST",
    "dropphycty": "DANBURY",
    "dropphyst": "WI",
    "dropphyzpp": 548309417,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANBURY",
    "dropmalst": "WI",
    "dropmalzpp": 548309998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156563527,
    "dropfax": 7156563527
  },
  {
    "dcode": "D",
    "dropkey": "PY17179",
    "droptype": "D",
    "dropname": "DANE",
    "dropdeladd": "104 DANE ST",
    "dropdelcty": "DANE",
    "dropdelst": "WI",
    "dropdelzpp": 535299615,
    "dropphyadd": "104 DANE ST",
    "dropphycty": "DANE",
    "dropphyst": "WI",
    "dropphyzpp": 535299615,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANE",
    "dropmalst": "WI",
    "dropmalzpp": 535299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088503281,
    "dropsitcph": 6088503281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17180",
    "droptype": "D",
    "dropname": "DARIEN",
    "dropdeladd": "1 E BELOIT ST",
    "dropdelcty": "DARIEN",
    "dropdelst": "WI",
    "dropdelzpp": 531141638,
    "dropphyadd": "1 E BELOIT ST",
    "dropphycty": "DARIEN",
    "dropphyst": "WI",
    "dropphyzpp": 531141638,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARIEN",
    "dropmalst": "WI",
    "dropmalzpp": 531149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2627243339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17181",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "320 WELLS ST",
    "dropdelcty": "DARLINGTON",
    "dropdelst": "WI",
    "dropdelzpp": 535309998,
    "dropphyadd": "320 WELLS ST",
    "dropphycty": "DARLINGTON",
    "dropphyst": "WI",
    "dropphyzpp": 535309998,
    "dropmaladd": "320 WELLS ST",
    "dropmalcty": "DARLINGTON",
    "dropmalst": "WI",
    "dropmalzpp": 535309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087762436,
    "dropsitcph": 6087762436,
    "dropfax": 6087763078
  },
  {
    "dcode": "D",
    "dropkey": "PY17182",
    "droptype": "D",
    "dropname": "DEFOREST",
    "dropdeladd": "619 S MAIN ST",
    "dropdelcty": "DEFOREST",
    "dropdelst": "WI",
    "dropdelzpp": 535329998,
    "dropphyadd": "619 S MAIN ST",
    "dropphycty": "DEFOREST",
    "dropphyst": "WI",
    "dropphyzpp": 535329998,
    "dropmaladd": "619 S MAIN ST",
    "dropmalcty": "DEFOREST",
    "dropmalst": "WI",
    "dropmalzpp": 535329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088465910,
    "dropsitcph": 6088465910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17183",
    "droptype": "D",
    "dropname": "DE PERE",
    "dropdeladd": "123 S 9TH ST",
    "dropdelcty": "DE PERE",
    "dropdelst": "WI",
    "dropdelzpp": 541159998,
    "dropphyadd": "123 S 9TH ST",
    "dropphycty": "DE PERE",
    "dropphyst": "WI",
    "dropphyzpp": 541159998,
    "dropmaladd": "123 S 9TH ST",
    "dropmalcty": "DE PERE",
    "dropmalst": "WI",
    "dropmalzpp": 541159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203364471,
    "dropsitcph": 9203364306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17184",
    "droptype": "D",
    "dropname": "DE SOTO",
    "dropdeladd": "207 S HOUGHTON ST",
    "dropdelcty": "DE SOTO",
    "dropdelst": "WI",
    "dropdelzpp": 546243200,
    "dropphyadd": "207 S HOUGHTON ST",
    "dropphycty": "DE SOTO",
    "dropphyst": "WI",
    "dropphyzpp": 546243200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE SOTO",
    "dropmalst": "WI",
    "dropmalzpp": 546249998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086483392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17186",
    "droptype": "D",
    "dropname": "DEER PARK",
    "dropdeladd": "100 FRONT ST W",
    "dropdelcty": "DEER PARK",
    "dropdelst": "WI",
    "dropdelzpp": 540079793,
    "dropphyadd": "100 FRONT ST W",
    "dropphycty": "DEER PARK",
    "dropphyst": "WI",
    "dropphyzpp": 540079793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER PARK",
    "dropmalst": "WI",
    "dropmalzpp": 540079998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152695212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17188",
    "droptype": "D",
    "dropname": "DEERBROOK",
    "dropdeladd": "N5290 COUNTY ROAD A",
    "dropdelcty": "DEERBROOK",
    "dropdelst": "WI",
    "dropdelzpp": 544249800,
    "dropphyadd": "N5290 COUNTY ROAD A",
    "dropphycty": "DEERBROOK",
    "dropphyst": "WI",
    "dropphyzpp": 544249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERBROOK",
    "dropmalst": "WI",
    "dropmalzpp": 544249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156277818,
    "dropsitcph": 7156277818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17189",
    "droptype": "D",
    "dropname": "DEERFIELD",
    "dropdeladd": "16 W NELSON ST",
    "dropdelcty": "DEERFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 535319669,
    "dropphyadd": "16 W NELSON ST",
    "dropphycty": "DEERFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 535319669,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 535319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087642652,
    "dropsitcph": 6087642602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17190",
    "droptype": "D",
    "dropname": "DELAFIELD",
    "dropdeladd": "925 GENESEE ST",
    "dropdelcty": "DELAFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 530189998,
    "dropphyadd": "925 GENESEE ST",
    "dropphycty": "DELAFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 530189998,
    "dropmaladd": "925 GENESEE ST",
    "dropmalcty": "DELAFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 530189998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626468423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17191",
    "droptype": "D",
    "dropname": "DELAVAN",
    "dropdeladd": "335 E WALWORTH AVE",
    "dropdelcty": "DELAVAN",
    "dropdelst": "WI",
    "dropdelzpp": 531159998,
    "dropphyadd": "335 E WALWORTH AVE",
    "dropphycty": "DELAVAN",
    "dropphyst": "WI",
    "dropphyzpp": 531159998,
    "dropmaladd": "335 E WALWORTH AVE",
    "dropmalcty": "DELAVAN",
    "dropmalst": "WI",
    "dropmalzpp": 531159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2627282100,
    "dropfax": 2627288190
  },
  {
    "dcode": "D",
    "dropkey": "PY17194",
    "droptype": "D",
    "dropname": "DENMARK",
    "dropdeladd": "135 WISCONSIN AVE",
    "dropdelcty": "DENMARK",
    "dropdelst": "WI",
    "dropdelzpp": 542088522,
    "dropphyadd": "135 WISCONSIN AVE",
    "dropphycty": "DENMARK",
    "dropphyst": "WI",
    "dropphyzpp": 542088522,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENMARK",
    "dropmalst": "WI",
    "dropmalzpp": 542089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208632612,
    "dropsitcph": 9208632612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17199",
    "droptype": "D",
    "dropname": "DICKEYVILLE",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "DICKEYVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 538089700,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "DICKEYVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 538089700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DICKEYVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 538089998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085687221,
    "dropsitcph": 6085687221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17200",
    "droptype": "D",
    "dropname": "DODGE",
    "dropdeladd": "N20224 COUNTY ROAD J",
    "dropdelcty": "DODGE",
    "dropdelst": "WI",
    "dropdelzpp": 546259737,
    "dropphyadd": "N20224 COUNTY ROAD J",
    "dropphycty": "DODGE",
    "dropphyst": "WI",
    "dropphyzpp": 546259737,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DODGE",
    "dropmalst": "WI",
    "dropmalzpp": 546259998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084303098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17201",
    "droptype": "D",
    "dropname": "DODGEVILLE",
    "dropdeladd": "1121 N JOHNS ST",
    "dropdelcty": "DODGEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535339998,
    "dropphyadd": "1121 N JOHNS ST",
    "dropphycty": "DODGEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535339998,
    "dropmaladd": "1121 N JOHNS ST",
    "dropmalcty": "DODGEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089353533,
    "dropsitcph": 6089353533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17203",
    "droptype": "D",
    "dropname": "DORCHESTER",
    "dropdeladd": "101 E BUS CNTY RD A",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "WI",
    "dropdelzpp": 544259800,
    "dropphyadd": "101 E BUS CNTY RD A",
    "dropphycty": "DORCHESTER",
    "dropphyst": "WI",
    "dropphyzpp": 544259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "WI",
    "dropmalzpp": 544259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156545181,
    "dropsitcph": 7156545181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17204",
    "droptype": "D",
    "dropname": "DOUSMAN",
    "dropdeladd": "271 N MAIN ST",
    "dropdelcty": "DOUSMAN",
    "dropdelst": "WI",
    "dropdelzpp": 531185602,
    "dropphyadd": "271 N MAIN ST",
    "dropphycty": "DOUSMAN",
    "dropphyst": "WI",
    "dropphyzpp": 531185602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOUSMAN",
    "dropmalst": "WI",
    "dropmalzpp": 531189998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2629652955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17206",
    "droptype": "D",
    "dropname": "DOWNSVILLE",
    "dropdeladd": "E4491 COUNTY ROAD C",
    "dropdelcty": "DOWNSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 547354400,
    "dropphyadd": "E4491 COUNTY ROAD C",
    "dropphycty": "DOWNSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 547354400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOWNSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 547359998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156648731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17209",
    "droptype": "D",
    "dropname": "DOYLESTOWN",
    "dropdeladd": "W2979 RAILROAD ST",
    "dropdelcty": "DOYLESTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 539289700,
    "dropphyadd": "W2979 RAILROAD ST",
    "dropphycty": "DOYLESTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 539289700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOYLESTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 539289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209923679,
    "dropsitcph": 9209923679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17211",
    "droptype": "D",
    "dropname": "DRESSER",
    "dropdeladd": "104 W MAIN ST",
    "dropdelcty": "DRESSER",
    "dropdelst": "WI",
    "dropdelzpp": 540099043,
    "dropphyadd": "104 W MAIN ST",
    "dropphycty": "DRESSER",
    "dropphyst": "WI",
    "dropphyzpp": 540099043,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRESSER",
    "dropmalst": "WI",
    "dropmalzpp": 540099998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157553511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17213",
    "droptype": "D",
    "dropname": "DRUMMOND",
    "dropdeladd": "52445 WISCONSIN AVE",
    "dropdelcty": "DRUMMOND",
    "dropdelst": "WI",
    "dropdelzpp": 548323659,
    "dropphyadd": "52445 WISCONSIN AVE",
    "dropphycty": "DRUMMOND",
    "dropphyst": "WI",
    "dropphyzpp": 548323659,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRUMMOND",
    "dropmalst": "WI",
    "dropmalzpp": 548329998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157396278,
    "dropfax": 7153740012
  },
  {
    "dcode": "D",
    "dropkey": "PY17215",
    "droptype": "D",
    "dropname": "DURAND",
    "dropdeladd": "315 4TH AVE W",
    "dropdelcty": "DURAND",
    "dropdelst": "WI",
    "dropdelzpp": 547361154,
    "dropphyadd": "315 4TH AVE W",
    "dropphycty": "DURAND",
    "dropphyst": "WI",
    "dropphyzpp": 547361154,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DURAND",
    "dropmalst": "WI",
    "dropmalzpp": 547369998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156728803,
    "dropfax": 7156728808
  },
  {
    "dcode": "D",
    "dropkey": "PY17219",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "104 MARKHAM RD",
    "dropdelcty": "EAGLE",
    "dropdelst": "WI",
    "dropdelzpp": 531199800,
    "dropphyadd": "104 MARKHAM RD",
    "dropphycty": "EAGLE",
    "dropphyst": "WI",
    "dropphyzpp": 531199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE",
    "dropmalst": "WI",
    "dropmalzpp": 531199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625942829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17221",
    "droptype": "D",
    "dropname": "EAGLE RIVER",
    "dropdeladd": "401 E WALL ST",
    "dropdelcty": "EAGLE RIVER",
    "dropdelst": "WI",
    "dropdelzpp": 545219800,
    "dropphyadd": "401 E WALL ST",
    "dropphycty": "EAGLE RIVER",
    "dropphyst": "WI",
    "dropphyzpp": 545219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE RIVER",
    "dropmalst": "WI",
    "dropmalzpp": 545219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154798981,
    "dropsitcph": 7154798981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17226",
    "droptype": "D",
    "dropname": "EAST TROY",
    "dropdeladd": "2099 MILL ST",
    "dropdelcty": "EAST TROY",
    "dropdelst": "WI",
    "dropdelzpp": 531201390,
    "dropphyadd": "2099 MILL ST",
    "dropphycty": "EAST TROY",
    "dropphyst": "WI",
    "dropphyzpp": 531201390,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST TROY",
    "dropmalst": "WI",
    "dropmalzpp": 531209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626425135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17227",
    "droptype": "D",
    "dropname": "EASTMAN",
    "dropdeladd": "106 N MAIN ST STE C",
    "dropdelcty": "EASTMAN",
    "dropdelst": "WI",
    "dropdelzpp": 546267301,
    "dropphyadd": "106 N MAIN ST STE C",
    "dropphycty": "EASTMAN",
    "dropphyst": "WI",
    "dropphyzpp": 546267301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTMAN",
    "dropmalst": "WI",
    "dropmalzpp": 546269998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6088744272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17230",
    "droptype": "D",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "225 E MADISON ST",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "WI",
    "dropdelzpp": 547033548,
    "dropphyadd": "225 E MADISON ST",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "WI",
    "dropphyzpp": 547033548,
    "dropmaladd": "225 E MADISON ST",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "WI",
    "dropmalzpp": 547033548,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 7158336785,
    "dropfax": 7158390233
  },
  {
    "dcode": "D",
    "dropkey": "PY17231",
    "droptype": "D",
    "dropname": "EAU GALLE",
    "dropdeladd": "N409 293RD ST",
    "dropdelcty": "EAU GALLE",
    "dropdelst": "WI",
    "dropdelzpp": 547379504,
    "dropphyadd": "N409 293RD ST",
    "dropphycty": "EAU GALLE",
    "dropphyst": "WI",
    "dropphyzpp": 547379504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAU GALLE",
    "dropmalst": "WI",
    "dropmalzpp": 547379998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152834253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17234",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "117 SHERIDAN ST",
    "dropdelcty": "EDEN",
    "dropdelst": "WI",
    "dropdelzpp": 530199800,
    "dropphyadd": "117 SHERIDAN ST",
    "dropphycty": "EDEN",
    "dropphyst": "WI",
    "dropphyzpp": 530199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDEN",
    "dropmalst": "WI",
    "dropmalzpp": 530199998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204775441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17235",
    "droptype": "D",
    "dropname": "EDGAR",
    "dropdeladd": "111 W BEECH ST",
    "dropdelcty": "EDGAR",
    "dropdelst": "WI",
    "dropdelzpp": 544269050,
    "dropphyadd": "111 W BEECH ST",
    "dropphycty": "EDGAR",
    "dropphyst": "WI",
    "dropphyzpp": 544269050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGAR",
    "dropmalst": "WI",
    "dropmalzpp": 544269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153522444,
    "dropsitcph": 7153522444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17236",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "104 SWIFT ST",
    "dropdelcty": "EDGERTON",
    "dropdelst": "WI",
    "dropdelzpp": 535349998,
    "dropphyadd": "104 SWIFT ST",
    "dropphycty": "EDGERTON",
    "dropphyst": "WI",
    "dropphyzpp": 535349998,
    "dropmaladd": "104 SWIFT ST",
    "dropmalcty": "EDGERTON",
    "dropmalst": "WI",
    "dropmalzpp": 535349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088846442,
    "dropsitcph": 6088846442,
    "dropfax": 6088847914
  },
  {
    "dcode": "D",
    "dropkey": "PY17240",
    "droptype": "D",
    "dropname": "EGG HARBOR",
    "dropdeladd": "7858 STATE HIGHWAY 42",
    "dropdelcty": "EGG HARBOR",
    "dropdelst": "WI",
    "dropdelzpp": 542099564,
    "dropphyadd": "7858 STATE HIGHWAY 42",
    "dropphycty": "EGG HARBOR",
    "dropphyst": "WI",
    "dropphyzpp": 542099564,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EGG HARBOR",
    "dropmalst": "WI",
    "dropmalzpp": 542099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208683902,
    "dropsitcph": 9208683902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17244",
    "droptype": "D",
    "dropname": "ELAND",
    "dropdeladd": "N7701 WHEELER AVE",
    "dropdelcty": "ELAND",
    "dropdelst": "WI",
    "dropdelzpp": 544279504,
    "dropphyadd": "N7701 WHEELER AVE",
    "dropphycty": "ELAND",
    "dropphyst": "WI",
    "dropphyzpp": 544279504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELAND",
    "dropmalst": "WI",
    "dropmalzpp": 544279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152532929,
    "dropsitcph": 7152532929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17245",
    "droptype": "D",
    "dropname": "ELCHO",
    "dropdeladd": "N11262 DORR ST",
    "dropdelcty": "ELCHO",
    "dropdelst": "WI",
    "dropdelzpp": 544289413,
    "dropphyadd": "N11262 DORR ST",
    "dropphycty": "ELCHO",
    "dropphyst": "WI",
    "dropphyzpp": 544289413,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELCHO",
    "dropmalst": "WI",
    "dropmalzpp": 544289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152753115,
    "dropsitcph": 7152753115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17247",
    "droptype": "D",
    "dropname": "ELDORADO",
    "dropdeladd": "N7666 COUNTY ROAD C",
    "dropdelcty": "ELDORADO",
    "dropdelst": "WI",
    "dropdelzpp": 549329690,
    "dropphyadd": "N7666 COUNTY ROAD C",
    "dropphycty": "ELDORADO",
    "dropphyst": "WI",
    "dropphyzpp": 549329690,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELDORADO",
    "dropmalst": "WI",
    "dropmalzpp": 549329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208722426,
    "dropsitcph": 9208722426,
    "dropfax": 9208722658
  },
  {
    "dcode": "D",
    "dropkey": "PY17249",
    "droptype": "D",
    "dropname": "ELEVA",
    "dropdeladd": "50625 N MAIN ST",
    "dropdelcty": "ELEVA",
    "dropdelst": "WI",
    "dropdelzpp": 547389336,
    "dropphyadd": "50625 N MAIN ST",
    "dropphycty": "ELEVA",
    "dropphyst": "WI",
    "dropphyzpp": 547389336,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELEVA",
    "dropmalst": "WI",
    "dropmalzpp": 547389998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152874410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17252",
    "droptype": "D",
    "dropname": "ELK MOUND",
    "dropdeladd": "E200 MENOMONIE ST",
    "dropdelcty": "ELK MOUND",
    "dropdelst": "WI",
    "dropdelzpp": 547399302,
    "dropphyadd": "E200 MENOMONIE ST",
    "dropphycty": "ELK MOUND",
    "dropphyst": "WI",
    "dropphyzpp": 547399302,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK MOUND",
    "dropmalst": "WI",
    "dropmalzpp": 547399998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158795365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17253",
    "droptype": "D",
    "dropname": "ELKHART LAKE",
    "dropdeladd": "146 E RHINE ST",
    "dropdelcty": "ELKHART LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 530202131,
    "dropphyadd": "146 E RHINE ST",
    "dropphycty": "ELKHART LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 530202131,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKHART LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 530209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9208763332,
    "dropfax": 9208762090
  },
  {
    "dcode": "D",
    "dropkey": "PY17254",
    "droptype": "D",
    "dropname": "ELKHORN",
    "dropdeladd": "102 E WALWORTH ST",
    "dropdelcty": "ELKHORN",
    "dropdelst": "WI",
    "dropdelzpp": 531219998,
    "dropphyadd": "102 E WALWORTH ST",
    "dropphycty": "ELKHORN",
    "dropphyst": "WI",
    "dropphyzpp": 531219998,
    "dropmaladd": "102 E WALWORTH ST",
    "dropmalcty": "ELKHORN",
    "dropmalst": "WI",
    "dropmalzpp": 531219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2627232679,
    "dropfax": 2627234253
  },
  {
    "dcode": "D",
    "dropkey": "PY17256",
    "droptype": "D",
    "dropname": "ELLISON BAY",
    "dropdeladd": "12055 GARRETT BAY RD",
    "dropdelcty": "ELLISON BAY",
    "dropdelst": "WI",
    "dropdelzpp": 542109742,
    "dropphyadd": "12055 GARRETT BAY RD",
    "dropphycty": "ELLISON BAY",
    "dropphyst": "WI",
    "dropphyzpp": 542109742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLISON BAY",
    "dropmalst": "WI",
    "dropmalzpp": 542109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208544463,
    "dropsitcph": 9208544463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17258",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "270 N MAPLE ST",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "WI",
    "dropdelzpp": 540119027,
    "dropphyadd": "270 N MAPLE ST",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "WI",
    "dropphyzpp": 540119027,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "WI",
    "dropmalzpp": 540119998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152734705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17259",
    "droptype": "D",
    "dropname": "ELM GROVE",
    "dropdeladd": "13425 WATERTOWN PLANK RD",
    "dropdelcty": "ELM GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 531229998,
    "dropphyadd": "13425 WATERTOWN PLANK RD",
    "dropphycty": "ELM GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 531229998,
    "dropmaladd": "13425 WATERTOWN PLANK RD",
    "dropmalcty": "ELM GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 531229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2627822396,
    "dropsitcph": 2627822370,
    "dropfax": 2627822811
  },
  {
    "dcode": "D",
    "dropkey": "PY17261",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "228 W RACE AVE",
    "dropdelcty": "ELMWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 547408742,
    "dropphyadd": "228 W RACE AVE",
    "dropphycty": "ELMWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 547408742,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 547409998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156393803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17262",
    "droptype": "D",
    "dropname": "ELROY",
    "dropdeladd": "266 MAIN ST",
    "dropdelcty": "ELROY",
    "dropdelst": "WI",
    "dropdelzpp": 539299998,
    "dropphyadd": "266 MAIN ST",
    "dropphycty": "ELROY",
    "dropphyst": "WI",
    "dropphyzpp": 539299998,
    "dropmaladd": "266 MAIN ST",
    "dropmalcty": "ELROY",
    "dropmalst": "WI",
    "dropmalzpp": 539299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084628240,
    "dropsitcph": 6084628240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17264",
    "droptype": "D",
    "dropname": "EMBARRASS",
    "dropdeladd": "115 E MAIN ST",
    "dropdelcty": "EMBARRASS",
    "dropdelst": "WI",
    "dropdelzpp": 549339700,
    "dropphyadd": "115 E MAIN ST",
    "dropphycty": "EMBARRASS",
    "dropphyst": "WI",
    "dropphyzpp": 549339700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMBARRASS",
    "dropmalst": "WI",
    "dropmalzpp": 549339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158233347,
    "dropsitcph": 7158233347,
    "dropfax": 7158233347
  },
  {
    "dcode": "D",
    "dropkey": "PY17268",
    "droptype": "D",
    "dropname": "ENDEAVOR",
    "dropdeladd": "121 PARK ST",
    "dropdelcty": "ENDEAVOR",
    "dropdelst": "WI",
    "dropdelzpp": 539309788,
    "dropphyadd": "121 PARK ST",
    "dropphycty": "ENDEAVOR",
    "dropphyst": "WI",
    "dropphyzpp": 539309788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENDEAVOR",
    "dropmalst": "WI",
    "dropmalzpp": 539309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084290085,
    "dropsitcph": 6084290089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17269",
    "droptype": "D",
    "dropname": "EPHRAIM",
    "dropdeladd": "3043 CEDAR ST",
    "dropdelcty": "EPHRAIM",
    "dropdelst": "WI",
    "dropdelzpp": 542119800,
    "dropphyadd": "3043 CEDAR ST",
    "dropphycty": "EPHRAIM",
    "dropphyst": "WI",
    "dropphyzpp": 542119800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EPHRAIM",
    "dropmalst": "WI",
    "dropmalzpp": 542119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208544426,
    "dropsitcph": 9208544426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17274",
    "droptype": "D",
    "dropname": "ETTRICK",
    "dropdeladd": "22900 N MAIN ST",
    "dropdelcty": "ETTRICK",
    "dropdelst": "WI",
    "dropdelzpp": 546279797,
    "dropphyadd": "22900 N MAIN ST",
    "dropphycty": "ETTRICK",
    "dropphyst": "WI",
    "dropphyzpp": 546279797,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ETTRICK",
    "dropmalst": "WI",
    "dropmalzpp": 546279998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085258144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17278",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "402 WATER ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535361403,
    "dropphyadd": "402 WATER ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535361403,
    "dropmaladd": "402 WATER ST",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535361403,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088825394,
    "dropsitcph": 6088825394,
    "dropfax": 6088822166
  },
  {
    "dcode": "D",
    "dropkey": "PY17280",
    "droptype": "D",
    "dropname": "EXELAND",
    "dropdeladd": "11050 W STATE ROAD 48",
    "dropdelcty": "EXELAND",
    "dropdelst": "WI",
    "dropdelzpp": 548354120,
    "dropphyadd": "11050 W STATE ROAD 48",
    "dropphycty": "EXELAND",
    "dropphyst": "WI",
    "dropphyzpp": 548354120,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXELAND",
    "dropmalst": "WI",
    "dropmalzpp": 548359998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153220004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17281",
    "droptype": "D",
    "dropname": "FAIRWATER",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "FAIRWATER",
    "dropdelst": "WI",
    "dropdelzpp": 539319700,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "FAIRWATER",
    "dropphyst": "WI",
    "dropphyzpp": 539319700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRWATER",
    "dropmalst": "WI",
    "dropmalzpp": 539319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203462284,
    "dropsitcph": 9203462284,
    "dropfax": 9203462284
  },
  {
    "dcode": "D",
    "dropkey": "PY17282",
    "droptype": "D",
    "dropname": "FAIRCHILD",
    "dropdeladd": "121 N FRONT ST",
    "dropdelcty": "FAIRCHILD",
    "dropdelst": "WI",
    "dropdelzpp": 547418260,
    "dropphyadd": "121 N FRONT ST",
    "dropphycty": "FAIRCHILD",
    "dropphyst": "WI",
    "dropphyzpp": 547418260,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRCHILD",
    "dropmalst": "WI",
    "dropmalzpp": 547419998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153344001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17284",
    "droptype": "D",
    "dropname": "FALL CREEK",
    "dropdeladd": "111 S STATE ST",
    "dropdelcty": "FALL CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 547429701,
    "dropphyadd": "111 S STATE ST",
    "dropphycty": "FALL CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 547429701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALL CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 547429998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158773339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17285",
    "droptype": "D",
    "dropname": "FALL RIVER",
    "dropdeladd": "203 STEEL RD",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "WI",
    "dropdelzpp": 539329405,
    "dropphyadd": "203 STEEL RD",
    "dropphycty": "FALL RIVER",
    "dropphyst": "WI",
    "dropphyzpp": 539329405,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "WI",
    "dropmalzpp": 539329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204843168,
    "dropsitcph": 9204843168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17287",
    "droptype": "D",
    "dropname": "FENCE",
    "dropdeladd": "603 MEMORY LN STE A",
    "dropdelcty": "FENCE",
    "dropdelst": "WI",
    "dropdelzpp": 541209800,
    "dropphyadd": "603 MEMORY LN STE A",
    "dropphycty": "FENCE",
    "dropphyst": "WI",
    "dropphyzpp": 541209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENCE",
    "dropmalst": "WI",
    "dropmalzpp": 541209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153362504,
    "dropsitcph": 7153362504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17288",
    "droptype": "D",
    "dropname": "FENNIMORE",
    "dropdeladd": "1090 12TH ST",
    "dropdelcty": "FENNIMORE",
    "dropdelst": "WI",
    "dropdelzpp": 538099998,
    "dropphyadd": "1090 12TH ST",
    "dropphycty": "FENNIMORE",
    "dropphyst": "WI",
    "dropphyzpp": 538099998,
    "dropmaladd": "1090 12TH ST",
    "dropmalcty": "FENNIMORE",
    "dropmalst": "WI",
    "dropmalzpp": 538099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088226788,
    "dropsitcph": 6088226788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17290",
    "droptype": "D",
    "dropname": "FERRYVILLE",
    "dropdeladd": "158 MAIN ST",
    "dropdelcty": "FERRYVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 546288177,
    "dropphyadd": "158 MAIN ST",
    "dropphycty": "FERRYVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 546288177,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERRYVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 546289998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6087343331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17291",
    "droptype": "D",
    "dropname": "FIFIELD",
    "dropdeladd": "N14007 FLAMBEAU AVE",
    "dropdelcty": "FIFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 545249800,
    "dropphyadd": "N14007 FLAMBEAU AVE",
    "dropphycty": "FIFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 545249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FIFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 545249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157624685,
    "dropsitcph": 7157624685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17295",
    "droptype": "D",
    "dropname": "FISH CREEK",
    "dropdeladd": "4097 MAIN ST UNIT 2",
    "dropdelcty": "FISH CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 542129347,
    "dropphyadd": "4097 MAIN ST UNIT 2",
    "dropphycty": "FISH CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 542129347,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FISH CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 542129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208683051,
    "dropsitcph": 9208683051,
    "dropfax": 9208682391
  },
  {
    "dcode": "D",
    "dropkey": "PY17302",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "540 CENTRAL AVE",
    "dropdelcty": "FLORENCE",
    "dropdelst": "WI",
    "dropdelzpp": 541219800,
    "dropphyadd": "540 CENTRAL AVE",
    "dropphycty": "FLORENCE",
    "dropphyst": "WI",
    "dropphyzpp": 541219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLORENCE",
    "dropmalst": "WI",
    "dropmalzpp": 541219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155284431,
    "dropsitcph": 7155284431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17303",
    "droptype": "D",
    "dropname": "FOND DU LAC",
    "dropdeladd": "99 W 2ND ST",
    "dropdelcty": "FOND DU LAC",
    "dropdelst": "WI",
    "dropdelzpp": 549359998,
    "dropphyadd": "99 W 2ND ST",
    "dropphycty": "FOND DU LAC",
    "dropphyst": "WI",
    "dropphyzpp": 549359998,
    "dropmaladd": "99 W 2ND ST",
    "dropmalcty": "FOND DU LAC",
    "dropmalst": "WI",
    "dropmalzpp": 549359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209212655,
    "dropsitcph": 9209212911,
    "dropfax": 9209210177
  },
  {
    "dcode": "D",
    "dropkey": "PY17304",
    "droptype": "D",
    "dropname": "FONTANA",
    "dropdeladd": "185 THIRD AVE",
    "dropdelcty": "FONTANA",
    "dropdelst": "WI",
    "dropdelzpp": 531251196,
    "dropphyadd": "185 THIRD AVE",
    "dropphycty": "FONTANA",
    "dropphyst": "WI",
    "dropphyzpp": 531251196,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FONTANA",
    "dropmalst": "WI",
    "dropmalzpp": 531259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622753325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17305",
    "droptype": "D",
    "dropname": "FOOTVILLE",
    "dropdeladd": "212 DEPOT ST",
    "dropdelcty": "FOOTVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535379700,
    "dropphyadd": "212 DEPOT ST",
    "dropphycty": "FOOTVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535379700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOOTVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088766640,
    "dropsitcph": 6088766640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17308",
    "droptype": "D",
    "dropname": "FOREST JUNCTION",
    "dropdeladd": "W2137 HIGHWAY 10",
    "dropdelcty": "FOREST JUNCTION",
    "dropdelst": "WI",
    "dropdelzpp": 541239800,
    "dropphyadd": "W2137 HIGHWAY 10",
    "dropphycty": "FOREST JUNCTION",
    "dropphyst": "WI",
    "dropphyzpp": 541239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOREST JUNCTION",
    "dropmalst": "WI",
    "dropmalzpp": 541239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209891052,
    "dropsitcph": 9209891052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17309",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "137 W MAIN ST",
    "dropdelcty": "FORESTVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 542139997,
    "dropphyadd": "137 W MAIN ST",
    "dropphycty": "FORESTVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 542139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORESTVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 542139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208566120,
    "dropsitcph": 9208566120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17310",
    "droptype": "D",
    "dropname": "FORT ATKINSON",
    "dropdeladd": "24 MILWAUKEE AVE E",
    "dropdelcty": "FORT ATKINSON",
    "dropdelst": "WI",
    "dropdelzpp": 535389998,
    "dropphyadd": "24 MILWAUKEE AVE E",
    "dropphycty": "FORT ATKINSON",
    "dropphyst": "WI",
    "dropphyzpp": 535389998,
    "dropmaladd": "24 MILWAUKEE AVE E",
    "dropmalcty": "FORT ATKINSON",
    "dropmalst": "WI",
    "dropmalzpp": 535389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205635881,
    "dropsitcph": 9205635881,
    "dropfax": 9205635987
  },
  {
    "dcode": "D",
    "dropkey": "PY17312",
    "droptype": "D",
    "dropname": "FOUNTAIN CITY",
    "dropdeladd": "1 S MAIN ST",
    "dropdelcty": "FOUNTAIN CITY",
    "dropdelst": "WI",
    "dropdelzpp": 546298266,
    "dropphyadd": "1 S MAIN ST",
    "dropphycty": "FOUNTAIN CITY",
    "dropphyst": "WI",
    "dropphyzpp": 546298266,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOUNTAIN CITY",
    "dropmalst": "WI",
    "dropmalzpp": 546299998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086876851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17313",
    "droptype": "D",
    "dropname": "FOX LAKE",
    "dropdeladd": "310 W STATE ST",
    "dropdelcty": "FOX LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 539339552,
    "dropphyadd": "310 W STATE ST",
    "dropphycty": "FOX LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 539339552,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOX LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 539339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209282215,
    "dropsitcph": 9209282215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17316",
    "droptype": "D",
    "dropname": "FRANCIS CREEK",
    "dropdeladd": "516 FOREST HOME DR",
    "dropdelcty": "FRANCIS CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 542149800,
    "dropphyadd": "516 FOREST HOME DR",
    "dropphycty": "FRANCIS CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 542149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANCIS CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 542149998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206843053,
    "dropsitcph": 9206843053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17318",
    "droptype": "D",
    "dropname": "FRANKSVILLE",
    "dropdeladd": "3319 ROBERTS ST",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "WI",
    "dropdelzpp": 531269998,
    "dropphyadd": "3319 ROBERTS ST",
    "dropphycty": "CALEDONIA",
    "dropphyst": "WI",
    "dropphyzpp": 531269998,
    "dropmaladd": "3319 ROBERTS ST",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "WI",
    "dropmalzpp": 531269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2628862825,
    "dropsitcph": 2628863664,
    "dropfax": 2628861184
  },
  {
    "dcode": "D",
    "dropkey": "PY17321",
    "droptype": "D",
    "dropname": "FREDERIC",
    "dropdeladd": "311 OAK ST W",
    "dropdelcty": "FREDERIC",
    "dropdelst": "WI",
    "dropdelzpp": 548378954,
    "dropphyadd": "311 OAK ST W",
    "dropphycty": "FREDERIC",
    "dropphyst": "WI",
    "dropphyzpp": 548378954,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERIC",
    "dropmalst": "WI",
    "dropmalzpp": 548379998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153278483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17322",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "207 REGAL DR",
    "dropdelcty": "FREDONIA",
    "dropdelst": "WI",
    "dropdelzpp": 530219998,
    "dropphyadd": "207 REGAL DR",
    "dropphycty": "FREDONIA",
    "dropphyst": "WI",
    "dropphyzpp": 530219998,
    "dropmaladd": "207 REGAL DR",
    "dropmalcty": "FREDONIA",
    "dropmalst": "WI",
    "dropmalzpp": 530219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626922341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17326",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "627 WOLF RIVER DR",
    "dropdelcty": "FREMONT",
    "dropdelst": "WI",
    "dropdelzpp": 549409029,
    "dropphyadd": "627 WOLF RIVER DR",
    "dropphycty": "FREMONT",
    "dropphyst": "WI",
    "dropphyzpp": 549409029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREMONT",
    "dropmalst": "WI",
    "dropmalzpp": 549409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204462401,
    "dropsitcph": 9204462401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17329",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "WI",
    "dropdelzpp": 539349189,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "WI",
    "dropphyzpp": 539349189,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "WI",
    "dropmalzpp": 539349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083393121,
    "dropsitcph": 6083393121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17330",
    "droptype": "D",
    "dropname": "FRIESLAND",
    "dropdeladd": "113 S MADISON ST",
    "dropdelcty": "FRIESLAND",
    "dropdelst": "WI",
    "dropdelzpp": 539359701,
    "dropphyadd": "113 S MADISON ST",
    "dropphycty": "FRIESLAND",
    "dropphyst": "WI",
    "dropphyzpp": 539359701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRIESLAND",
    "dropmalst": "WI",
    "dropmalzpp": 539359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203485880,
    "dropsitcph": 9203485880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17331",
    "droptype": "D",
    "dropname": "GALESVILLE",
    "dropdeladd": "16771 S MAIN ST",
    "dropdelcty": "GALESVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 546307187,
    "dropphyadd": "16771 S MAIN ST",
    "dropphycty": "GALESVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 546307187,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALESVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 546309998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085822068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17335",
    "droptype": "D",
    "dropname": "GAYS MILLS",
    "dropdeladd": "225 ORIN ST",
    "dropdelcty": "GAYS MILLS",
    "dropdelst": "WI",
    "dropdelzpp": 546318307,
    "dropphyadd": "225 ORIN ST",
    "dropphycty": "GAYS MILLS",
    "dropphyst": "WI",
    "dropphyzpp": 546318307,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAYS MILLS",
    "dropmalst": "WI",
    "dropmalzpp": 546319998,
    "dropsitphn": 6085496023,
    "dropsitlph": 6085496023,
    "dropsitcph": 6085496023,
    "dropfax": 6085496022
  },
  {
    "dcode": "D",
    "dropkey": "PY17338",
    "droptype": "D",
    "dropname": "GENESEE DEPOT",
    "dropdeladd": "S42W31230 STATE ROAD 83",
    "dropdelcty": "GENESEE DEPOT",
    "dropdelst": "WI",
    "dropdelzpp": 531279800,
    "dropphyadd": "S42W31230 STATE ROAD 83",
    "dropphycty": "GENESEE DEPOT",
    "dropphyst": "WI",
    "dropphyzpp": 531279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENESEE DEPOT",
    "dropmalst": "WI",
    "dropmalzpp": 531279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2629683186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17339",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "501 MAIN ST",
    "dropdelcty": "GENOA",
    "dropdelst": "WI",
    "dropdelzpp": 546328905,
    "dropphyadd": "501 MAIN ST",
    "dropphycty": "GENOA",
    "dropphyst": "WI",
    "dropphyzpp": 546328905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENOA",
    "dropmalst": "WI",
    "dropmalzpp": 546329998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086892478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17340",
    "droptype": "D",
    "dropname": "GENOA CITY",
    "dropdeladd": "742 WALWORTH ST",
    "dropdelcty": "GENOA CITY",
    "dropdelst": "WI",
    "dropdelzpp": 531289800,
    "dropphyadd": "742 WALWORTH ST",
    "dropphycty": "GENOA CITY",
    "dropphyst": "WI",
    "dropphyzpp": 531289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENOA CITY",
    "dropmalst": "WI",
    "dropmalzpp": 531289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622793669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17342",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "W156N11301 PILGRIM RD",
    "dropdelcty": "GERMANTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 530229998,
    "dropphyadd": "W156N11301 PILGRIM RD",
    "dropphycty": "GERMANTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 530229998,
    "dropmaladd": "W156N11301 PILGRIM RD",
    "dropmalcty": "GERMANTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 530229998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622516411,
    "dropfax": 2622515684
  },
  {
    "dcode": "D",
    "dropkey": "PY17345",
    "droptype": "D",
    "dropname": "GILLETT",
    "dropdeladd": "205 E MAIN ST",
    "dropdelcty": "GILLETT",
    "dropdelst": "WI",
    "dropdelzpp": 541249021,
    "dropphyadd": "205 E MAIN ST",
    "dropphycty": "GILLETT",
    "dropphyst": "WI",
    "dropphyzpp": 541249021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILLETT",
    "dropmalst": "WI",
    "dropmalzpp": 541249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208552812,
    "dropsitcph": 9208552812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17347",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "121 W MAIN ST",
    "dropdelcty": "GILMAN",
    "dropdelst": "WI",
    "dropdelzpp": 544339800,
    "dropphyadd": "121 W MAIN ST",
    "dropphycty": "GILMAN",
    "dropphyst": "WI",
    "dropphyzpp": 544339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILMAN",
    "dropmalst": "WI",
    "dropmalzpp": 544339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154478254,
    "dropsitcph": 7154478254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17348",
    "droptype": "D",
    "dropname": "GILMANTON",
    "dropdeladd": "S869A STATE HIGHWAY 88",
    "dropdelcty": "GILMANTON",
    "dropdelst": "WI",
    "dropdelzpp": 547434400,
    "dropphyadd": "S869A STATE HIGHWAY 88",
    "dropphycty": "GILMANTON",
    "dropphyst": "WI",
    "dropphyzpp": 547434400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILMANTON",
    "dropmalst": "WI",
    "dropmalzpp": 547439998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159463510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17349",
    "droptype": "D",
    "dropname": "GLEASON",
    "dropdeladd": "N5365 STATE ROAD 17",
    "dropdelcty": "GLEASON",
    "dropdelst": "WI",
    "dropdelzpp": 544359401,
    "dropphyadd": "N5365 STATE ROAD 17",
    "dropphycty": "GLEASON",
    "dropphyst": "WI",
    "dropphyzpp": 544359401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEASON",
    "dropmalst": "WI",
    "dropmalzpp": 544359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158734573,
    "dropsitcph": 7158734573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17350",
    "droptype": "D",
    "dropname": "GLEN FLORA",
    "dropdeladd": "N5796 WHITE ST",
    "dropdelcty": "GLEN FLORA",
    "dropdelst": "WI",
    "dropdelzpp": 545269605,
    "dropphyadd": "N5796 WHITE ST",
    "dropphycty": "GLEN FLORA",
    "dropphyst": "WI",
    "dropphyzpp": 545269605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN FLORA",
    "dropmalst": "WI",
    "dropmalzpp": 545269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153225252,
    "dropsitcph": 7153225252,
    "dropfax": 7153225252
  },
  {
    "dcode": "D",
    "dropkey": "PY17351",
    "droptype": "D",
    "dropname": "GLEN HAVEN",
    "dropdeladd": "13211 MAIN ST",
    "dropdelcty": "GLEN HAVEN",
    "dropdelst": "WI",
    "dropdelzpp": 538109787,
    "dropphyadd": "13211 MAIN ST",
    "dropphycty": "GLEN HAVEN",
    "dropphyst": "WI",
    "dropphyzpp": 538109787,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN HAVEN",
    "dropmalst": "WI",
    "dropmalzpp": 538109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087942385,
    "dropsitcph": 6087942385,
    "dropfax": 6087942385
  },
  {
    "dcode": "D",
    "dropkey": "PY17352",
    "droptype": "D",
    "dropname": "GLENBEULAH",
    "dropdeladd": "246 W MAIN ST",
    "dropdelcty": "GLENBEULAH",
    "dropdelst": "WI",
    "dropdelzpp": 530231153,
    "dropphyadd": "246 W MAIN ST",
    "dropphycty": "GLENBEULAH",
    "dropphyst": "WI",
    "dropphyzpp": 530231153,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENBEULAH",
    "dropmalst": "WI",
    "dropmalzpp": 530239998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205263977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17355",
    "droptype": "D",
    "dropname": "GLENWOOD CITY",
    "dropdeladd": "220 E OAK ST",
    "dropdelcty": "GLENWOOD CITY",
    "dropdelst": "WI",
    "dropdelzpp": 540138516,
    "dropphyadd": "220 E OAK ST",
    "dropphycty": "GLENWOOD CITY",
    "dropphyst": "WI",
    "dropphyzpp": 540138516,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENWOOD CITY",
    "dropmalst": "WI",
    "dropmalzpp": 540139998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152653491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17357",
    "droptype": "D",
    "dropname": "GLIDDEN",
    "dropdeladd": "41 N GRANT ST",
    "dropdelcty": "GLIDDEN",
    "dropdelst": "WI",
    "dropdelzpp": 545272272,
    "dropphyadd": "41 N GRANT ST",
    "dropphycty": "GLIDDEN",
    "dropphyst": "WI",
    "dropphyzpp": 545272272,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLIDDEN",
    "dropmalst": "WI",
    "dropmalzpp": 545279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152644301,
    "dropsitcph": 7152644301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17359",
    "droptype": "D",
    "dropname": "GOODMAN",
    "dropdeladd": "200 A ST",
    "dropdelcty": "GOODMAN",
    "dropdelst": "WI",
    "dropdelzpp": 541259800,
    "dropphyadd": "200 A ST",
    "dropphycty": "GOODMAN",
    "dropphyst": "WI",
    "dropphyzpp": 541259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODMAN",
    "dropmalst": "WI",
    "dropmalzpp": 541259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153362688,
    "dropsitcph": 7153362688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17362",
    "droptype": "D",
    "dropname": "GORDON",
    "dropdeladd": "9725 E COUNTY ROAD Y",
    "dropdelcty": "GORDON",
    "dropdelst": "WI",
    "dropdelzpp": 548389162,
    "dropphyadd": "9725 E COUNTY ROAD Y",
    "dropphycty": "GORDON",
    "dropphyst": "WI",
    "dropphyzpp": 548389162,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GORDON",
    "dropmalst": "WI",
    "dropmalzpp": 548389998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153762630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17363",
    "droptype": "D",
    "dropname": "GOTHAM",
    "dropdeladd": "32826 1ST ST",
    "dropdelcty": "GOTHAM",
    "dropdelst": "WI",
    "dropdelzpp": 535409700,
    "dropphyadd": "32826 1ST ST",
    "dropphycty": "GOTHAM",
    "dropphyst": "WI",
    "dropphyzpp": 535409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOTHAM",
    "dropmalst": "WI",
    "dropmalzpp": 535409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085832720,
    "dropsitcph": 6085832720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17364",
    "droptype": "D",
    "dropname": "GRAFTON",
    "dropdeladd": "1817 HIGHLAND DR",
    "dropdelcty": "GRAFTON",
    "dropdelst": "WI",
    "dropdelzpp": 530249998,
    "dropphyadd": "1817 HIGHLAND DR",
    "dropphycty": "GRAFTON",
    "dropphyst": "WI",
    "dropphyzpp": 530249998,
    "dropmaladd": "1817 HIGHLAND DR",
    "dropmalcty": "GRAFTON",
    "dropmalst": "WI",
    "dropmalzpp": 530249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2623774524,
    "dropsitcph": 2623774250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17366",
    "droptype": "D",
    "dropname": "GRAND MARSH",
    "dropdeladd": "644 COUNTY RD E",
    "dropdelcty": "GRAND MARSH",
    "dropdelst": "WI",
    "dropdelzpp": 539369402,
    "dropphyadd": "644 COUNTY RD E",
    "dropphycty": "GRAND MARSH",
    "dropphyst": "WI",
    "dropphyzpp": 539369402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND MARSH",
    "dropmalst": "WI",
    "dropmalzpp": 539369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083396113,
    "dropsitcph": 6083396113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17368",
    "droptype": "D",
    "dropname": "GRAND VIEW",
    "dropdeladd": "54595 CUDWORTH AVE",
    "dropdelcty": "GRAND VIEW",
    "dropdelst": "WI",
    "dropdelzpp": 548394474,
    "dropphyadd": "54595 CUDWORTH AVE",
    "dropphycty": "GRAND VIEW",
    "dropphyst": "WI",
    "dropphyzpp": 548394474,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND VIEW",
    "dropmalst": "WI",
    "dropmalzpp": 548399998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157633154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17371",
    "droptype": "D",
    "dropname": "GRANTON",
    "dropdeladd": "214 MAPLE ST",
    "dropdelcty": "GRANTON",
    "dropdelst": "WI",
    "dropdelzpp": 544369800,
    "dropphyadd": "214 MAPLE ST",
    "dropphycty": "GRANTON",
    "dropphyst": "WI",
    "dropphyzpp": 544369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANTON",
    "dropmalst": "WI",
    "dropmalzpp": 544369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152387470,
    "dropsitcph": 7152387470,
    "dropfax": 7152388017
  },
  {
    "dcode": "D",
    "dropkey": "PY17372",
    "droptype": "D",
    "dropname": "GRANTSBURG",
    "dropdeladd": "201 N PINE ST",
    "dropdelcty": "GRANTSBURG",
    "dropdelst": "WI",
    "dropdelzpp": 548407437,
    "dropphyadd": "201 N PINE ST",
    "dropphycty": "GRANTSBURG",
    "dropphyst": "WI",
    "dropphyzpp": 548407437,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANTSBURG",
    "dropmalst": "WI",
    "dropmalzpp": 548409998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154834033,
    "dropfax": 7154834032
  },
  {
    "dcode": "D",
    "dropkey": "PY17373",
    "droptype": "D",
    "dropname": "GRATIOT",
    "dropdeladd": "5801 PHILIPPS ST",
    "dropdelcty": "GRATIOT",
    "dropdelst": "WI",
    "dropdelzpp": 535419674,
    "dropphyadd": "5801 PHILIPPS ST",
    "dropphycty": "GRATIOT",
    "dropphyst": "WI",
    "dropphyzpp": 535419674,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRATIOT",
    "dropmalst": "WI",
    "dropmalzpp": 535419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089223338,
    "dropsitcph": 6089223338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17375",
    "droptype": "D",
    "dropname": "GREEN BAY",
    "dropdeladd": "300 PACKERLAND DR",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "WI",
    "dropdelzpp": 543039998,
    "dropphyadd": "300 PACKERLAND DR",
    "dropphycty": "GREEN BAY",
    "dropphyst": "WI",
    "dropphyzpp": 543039998,
    "dropmaladd": "PO BOX 7003",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "WI",
    "dropmalzpp": 543077003,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204983885,
    "dropsitcph": 9204983892,
    "dropfax": 9204983852
  },
  {
    "dcode": "D",
    "dropkey": "PY17377",
    "droptype": "D",
    "dropname": "GREEN LAKE",
    "dropdeladd": "487 HILL ST",
    "dropdelcty": "GREEN LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 549418829,
    "dropphyadd": "487 HILL ST",
    "dropphycty": "GREEN LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 549418829,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 549419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202946771,
    "dropsitcph": 9202946771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17380",
    "droptype": "D",
    "dropname": "GREENDALE",
    "dropdeladd": "5741 BROAD ST",
    "dropdelcty": "GREENDALE",
    "dropdelst": "WI",
    "dropdelzpp": 531299998,
    "dropphyadd": "5741 BROAD ST",
    "dropphycty": "GREENDALE",
    "dropphyst": "WI",
    "dropphyzpp": 531299998,
    "dropmaladd": "5741 BROAD ST",
    "dropmalcty": "GREENDALE",
    "dropmalst": "WI",
    "dropmalzpp": 531299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144217406,
    "dropsitcph": 4144217349,
    "dropfax": 4144215370
  },
  {
    "dcode": "D",
    "dropkey": "PY17384",
    "droptype": "D",
    "dropname": "GREENLEAF",
    "dropdeladd": "6814 STATE HIGHWAY 57",
    "dropdelcty": "GREENLEAF",
    "dropdelst": "WI",
    "dropdelzpp": 541269123,
    "dropphyadd": "6814 STATE HIGHWAY 57",
    "dropphycty": "GREENLEAF",
    "dropphyst": "WI",
    "dropphyzpp": 541269123,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENLEAF",
    "dropmalst": "WI",
    "dropmalzpp": 541269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208647818,
    "dropsitcph": 9208647818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17385",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "N1886 MUNICIPAL DR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 549429747,
    "dropphyadd": "N1886 MUNICIPAL DR",
    "dropphycty": "GREENVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 549429747,
    "dropmaladd": "N1886 MUNICIPAL DR",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 549429747,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207571005,
    "dropsitcph": 9207579479,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17386",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "110 E DIVISION ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 544379324,
    "dropphyadd": "110 E DIVISION ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 544379324,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 544379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152676451,
    "dropsitcph": 7152676451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17387",
    "droptype": "D",
    "dropname": "GRESHAM",
    "dropdeladd": "1201 MAIN ST",
    "dropdelcty": "GRESHAM",
    "dropdelst": "WI",
    "dropdelzpp": 541289541,
    "dropphyadd": "1201 MAIN ST",
    "dropphycty": "GRESHAM",
    "dropphyst": "WI",
    "dropphyzpp": 541289541,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRESHAM",
    "dropmalst": "WI",
    "dropmalzpp": 541289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157873293,
    "dropsitcph": 7157873293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17390",
    "droptype": "D",
    "dropname": "HAGER CITY",
    "dropdeladd": "W8123 165TH AVE",
    "dropdelcty": "HAGER CITY",
    "dropdelst": "WI",
    "dropdelzpp": 540148000,
    "dropphyadd": "W8123 165TH AVE",
    "dropphycty": "HAGER CITY",
    "dropphyst": "WI",
    "dropphyzpp": 540148000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAGER CITY",
    "dropmalst": "WI",
    "dropmalzpp": 540149998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157922919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17394",
    "droptype": "D",
    "dropname": "HALES CORNERS",
    "dropdeladd": "5444 S 108TH ST",
    "dropdelcty": "HALES CORNERS",
    "dropdelst": "WI",
    "dropdelzpp": 531309998,
    "dropphyadd": "5444 S 108TH ST",
    "dropphycty": "HALES CORNERS",
    "dropphyst": "WI",
    "dropphyzpp": 531309998,
    "dropmaladd": "5444 S 108TH ST",
    "dropmalcty": "HALES CORNERS",
    "dropmalst": "WI",
    "dropmalzpp": 531309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4145257888,
    "dropsitcph": 4145257880,
    "dropfax": 4145257882
  },
  {
    "dcode": "D",
    "dropkey": "PY17400",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "1010 DAVIS ST",
    "dropdelcty": "HAMMOND",
    "dropdelst": "WI",
    "dropdelzpp": 540159657,
    "dropphyadd": "1010 DAVIS ST",
    "dropphycty": "HAMMOND",
    "dropphyst": "WI",
    "dropphyzpp": 540159657,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMMOND",
    "dropmalst": "WI",
    "dropmalzpp": 540159998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157962248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17402",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "127 W NORTH LAKE ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "WI",
    "dropdelzpp": 549439448,
    "dropphyadd": "127 W NORTH LAKE ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "WI",
    "dropphyzpp": 549439448,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANCOCK",
    "dropmalst": "WI",
    "dropmalzpp": 549439998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152495104,
    "dropsitcph": 7152495104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17409",
    "droptype": "D",
    "dropname": "HARSHAW",
    "dropdeladd": "5289 LAKEWOOD RD",
    "dropdelcty": "HARSHAW",
    "dropdelst": "WI",
    "dropdelzpp": 545299712,
    "dropphyadd": "5289 LAKEWOOD RD",
    "dropphycty": "HARSHAW",
    "dropphyst": "WI",
    "dropphyzpp": 545299712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARSHAW",
    "dropmalst": "WI",
    "dropmalzpp": 545299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152772162,
    "dropsitcph": 7152772162,
    "dropfax": 7152772162
  },
  {
    "dcode": "D",
    "dropkey": "PY17410",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "45 E WISCONSIN ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "WI",
    "dropdelzpp": 530279998,
    "dropphyadd": "45 E WISCONSIN ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "WI",
    "dropphyzpp": 530279998,
    "dropmaladd": "45 E WISCONSIN ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "WI",
    "dropmalzpp": 530279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626706974,
    "dropfax": 2626706976
  },
  {
    "dcode": "D",
    "dropkey": "PY17411",
    "droptype": "D",
    "dropname": "HARTLAND",
    "dropdeladd": "401 E INDUSTRIAL DR",
    "dropdelcty": "HARTLAND",
    "dropdelst": "WI",
    "dropdelzpp": 530291101,
    "dropphyadd": "401 E INDUSTRIAL DR",
    "dropphycty": "HARTLAND",
    "dropphyst": "WI",
    "dropphyzpp": 530291101,
    "dropmaladd": "401 E INDUSTRIAL DR",
    "dropmalcty": "HARTLAND",
    "dropmalst": "WI",
    "dropmalzpp": 530299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2623673187,
    "dropsitcph": 2623670963,
    "dropfax": 2629123350
  },
  {
    "dcode": "D",
    "dropkey": "PY17413",
    "droptype": "D",
    "dropname": "HATLEY",
    "dropdeladd": "200 CLARK ST",
    "dropdelcty": "HATLEY",
    "dropdelst": "WI",
    "dropdelzpp": 544409800,
    "dropphyadd": "200 CLARK ST",
    "dropphycty": "HATLEY",
    "dropphyst": "WI",
    "dropphyzpp": 544409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HATLEY",
    "dropmalst": "WI",
    "dropmalzpp": 544409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154463125,
    "dropsitcph": 7154463125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17414",
    "droptype": "D",
    "dropname": "HAUGEN",
    "dropdeladd": "105 W 3RD ST",
    "dropdelcty": "HAUGEN",
    "dropdelst": "WI",
    "dropdelzpp": 548414407,
    "dropphyadd": "105 W 3RD ST",
    "dropphycty": "HAUGEN",
    "dropphyst": "WI",
    "dropphyzpp": 548414407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAUGEN",
    "dropmalst": "WI",
    "dropmalzpp": 548419998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152347831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17416",
    "droptype": "D",
    "dropname": "HAWKINS",
    "dropdeladd": "1016 MAIN ST",
    "dropdelcty": "HAWKINS",
    "dropdelst": "WI",
    "dropdelzpp": 545309578,
    "dropphyadd": "1016 MAIN ST",
    "dropphycty": "HAWKINS",
    "dropphyst": "WI",
    "dropphyzpp": 545309578,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWKINS",
    "dropmalst": "WI",
    "dropmalzpp": 545309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155856383,
    "dropsitcph": 7155856383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17417",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "7204 S WISCONSIN AVE",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "WI",
    "dropdelzpp": 548424400,
    "dropphyadd": "7204 S WISCONSIN AVE",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "WI",
    "dropphyzpp": 548424400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "WI",
    "dropmalzpp": 548429998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153742737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17418",
    "droptype": "D",
    "dropname": "HAYWARD",
    "dropdeladd": "10597 MAIN ST",
    "dropdelcty": "HAYWARD",
    "dropdelst": "WI",
    "dropdelzpp": 548436658,
    "dropphyadd": "10597 MAIN ST",
    "dropphycty": "HAYWARD",
    "dropphyst": "WI",
    "dropphyzpp": 548436658,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYWARD",
    "dropmalst": "WI",
    "dropmalzpp": 548439998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156344161,
    "dropfax": 7156347041
  },
  {
    "dcode": "D",
    "dropkey": "PY17419",
    "droptype": "D",
    "dropname": "HAZEL GREEN",
    "dropdeladd": "2130 N PERCIVAL ST",
    "dropdelcty": "HAZEL GREEN",
    "dropdelst": "WI",
    "dropdelzpp": 538119699,
    "dropphyadd": "2130 N PERCIVAL ST",
    "dropphycty": "HAZEL GREEN",
    "dropphyst": "WI",
    "dropphyzpp": 538119699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAZEL GREEN",
    "dropmalst": "WI",
    "dropmalzpp": 538119998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088542288,
    "dropsitcph": 6088542288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17420",
    "droptype": "D",
    "dropname": "HAZELHURST",
    "dropdeladd": "7057 USH 51",
    "dropdelcty": "HAZELHURST",
    "dropdelst": "WI",
    "dropdelzpp": 545319800,
    "dropphyadd": "7057 USH 51",
    "dropphycty": "HAZELHURST",
    "dropphyst": "WI",
    "dropphyzpp": 545319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAZELHURST",
    "dropmalst": "WI",
    "dropmalzpp": 545319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153566583,
    "dropsitcph": 7153566583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17422",
    "droptype": "D",
    "dropname": "HELENVILLE",
    "dropdeladd": "W3290 US HIGHWAY 18",
    "dropdelcty": "HELENVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 531379998,
    "dropphyadd": "W3290 US HIGHWAY 18",
    "dropphycty": "HELENVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 531379998,
    "dropmaladd": "W3290 US HIGHWAY 18",
    "dropmalcty": "HELENVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 531379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206759073,
    "dropfax": 9206745060
  },
  {
    "dcode": "D",
    "dropkey": "PY17424",
    "droptype": "D",
    "dropname": "HERBSTER",
    "dropdeladd": "14840 STATE HIGHWAY 13",
    "dropdelcty": "HERBSTER",
    "dropdelst": "WI",
    "dropdelzpp": 548444500,
    "dropphyadd": "14840 STATE HIGHWAY 13",
    "dropphycty": "HERBSTER",
    "dropphyst": "WI",
    "dropphyzpp": 548444500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERBSTER",
    "dropmalst": "WI",
    "dropmalzpp": 548449998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157743805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17429",
    "droptype": "D",
    "dropname": "HIGH BRIDGE",
    "dropdeladd": "39255 STATE HIGHWAY 13",
    "dropdelcty": "HIGH BRIDGE",
    "dropdelst": "WI",
    "dropdelzpp": 548464400,
    "dropphyadd": "39255 STATE HIGHWAY 13",
    "dropphycty": "HIGH BRIDGE",
    "dropphyst": "WI",
    "dropphyzpp": 548464400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGH BRIDGE",
    "dropmalst": "WI",
    "dropmalzpp": 548469998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152743209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17430",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "803 DODGEVILLE ST",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "WI",
    "dropdelzpp": 535439550,
    "dropphyadd": "803 DODGEVILLE ST",
    "dropphycty": "HIGHLAND",
    "dropphyst": "WI",
    "dropphyzpp": 535439550,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "WI",
    "dropmalzpp": 535439998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089297637,
    "dropsitcph": 6089297637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17431",
    "droptype": "D",
    "dropname": "HILBERT",
    "dropdeladd": "305 W MAIN ST",
    "dropdelcty": "HILBERT",
    "dropdelst": "WI",
    "dropdelzpp": 541299800,
    "dropphyadd": "305 W MAIN ST",
    "dropphycty": "HILBERT",
    "dropphyst": "WI",
    "dropphyzpp": 541299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILBERT",
    "dropmalst": "WI",
    "dropmalzpp": 541299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208533334,
    "dropsitcph": 9208533334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17434",
    "droptype": "D",
    "dropname": "HILLPOINT",
    "dropdeladd": "S6071 STATE ROAD 154",
    "dropdelcty": "HILLPOINT",
    "dropdelst": "WI",
    "dropdelzpp": 539379516,
    "dropphyadd": "S6071 STATE ROAD 154",
    "dropphycty": "HILLPOINT",
    "dropphyst": "WI",
    "dropphyzpp": 539379516,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLPOINT",
    "dropmalst": "WI",
    "dropmalzpp": 539379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087274181,
    "dropsitcph": 6087274181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17435",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "713 WATER AVE",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "WI",
    "dropdelzpp": 546346229,
    "dropphyadd": "713 WATER AVE",
    "dropphycty": "HILLSBORO",
    "dropphyst": "WI",
    "dropphyzpp": 546346229,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "WI",
    "dropmalzpp": 546349998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084893528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17438",
    "droptype": "D",
    "dropname": "HINGHAM",
    "dropdeladd": "N2750 MAIN ST",
    "dropdelcty": "HINGHAM",
    "dropdelst": "WI",
    "dropdelzpp": 530319800,
    "dropphyadd": "N2750 MAIN ST",
    "dropphycty": "HINGHAM",
    "dropphyst": "WI",
    "dropphyzpp": 530319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HINGHAM",
    "dropmalst": "WI",
    "dropmalzpp": 530319998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205643041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17439",
    "droptype": "D",
    "dropname": "HIXTON",
    "dropdeladd": "127 W MAIN ST",
    "dropdelcty": "HIXTON",
    "dropdelst": "WI",
    "dropdelzpp": 546359788,
    "dropphyadd": "127 W MAIN ST",
    "dropphycty": "HIXTON",
    "dropphyst": "WI",
    "dropphyzpp": 546359788,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIXTON",
    "dropmalst": "WI",
    "dropmalzpp": 546359998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159633443,
    "dropfax": 7159635503
  },
  {
    "dcode": "D",
    "dropkey": "PY17444",
    "droptype": "D",
    "dropname": "HOLCOMBE",
    "dropdeladd": "27490 263RD AVE",
    "dropdelcty": "HOLCOMBE",
    "dropdelst": "WI",
    "dropdelzpp": 547454508,
    "dropphyadd": "27490 263RD AVE",
    "dropphycty": "HOLCOMBE",
    "dropphyst": "WI",
    "dropphyzpp": 547454508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLCOMBE",
    "dropmalst": "WI",
    "dropmalzpp": 547459998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155954881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17445",
    "droptype": "D",
    "dropname": "HOLLANDALE",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "HOLLANDALE",
    "dropdelst": "WI",
    "dropdelzpp": 535449473,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "HOLLANDALE",
    "dropphyst": "WI",
    "dropphyzpp": 535449473,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLANDALE",
    "dropmalst": "WI",
    "dropmalzpp": 535449998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089672244,
    "dropsitcph": 6089672244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17447",
    "droptype": "D",
    "dropname": "HOLMEN",
    "dropdeladd": "1111 LINDEN DR",
    "dropdelcty": "HOLMEN",
    "dropdelst": "WI",
    "dropdelzpp": 546369899,
    "dropphyadd": "1111 LINDEN DR",
    "dropphycty": "HOLMEN",
    "dropphyst": "WI",
    "dropphyzpp": 546369899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLMEN",
    "dropmalst": "WI",
    "dropmalzpp": 546369998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6085266916,
    "dropsitcph": 6085264055,
    "dropfax": 6085262434
  },
  {
    "dcode": "D",
    "dropkey": "PY17448",
    "droptype": "D",
    "dropname": "HONEY CREEK",
    "dropdeladd": "N7140 HONEY CREEK RD",
    "dropdelcty": "HONEY CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 531389800,
    "dropphyadd": "N7140 HONEY CREEK RD",
    "dropphycty": "HONEY CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 531389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONEY CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 531389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625343059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17449",
    "droptype": "D",
    "dropname": "HORICON",
    "dropdeladd": "420 E LAKE ST",
    "dropdelcty": "HORICON",
    "dropdelst": "WI",
    "dropdelzpp": 530329998,
    "dropphyadd": "420 E LAKE ST",
    "dropphycty": "HORICON",
    "dropphyst": "WI",
    "dropphyzpp": 530329998,
    "dropmaladd": "420 E LAKE ST",
    "dropmalcty": "HORICON",
    "dropmalst": "WI",
    "dropmalzpp": 530329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204854429,
    "dropsitcph": 9204854429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17451",
    "droptype": "D",
    "dropname": "HORTONVILLE",
    "dropdeladd": "119 N PINE ST",
    "dropdelcty": "HORTONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 549449378,
    "dropphyadd": "119 N PINE ST",
    "dropphycty": "HORTONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 549449378,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HORTONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 549449998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207796888,
    "dropsitcph": 9207796888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17458",
    "droptype": "D",
    "dropname": "HUBERTUS",
    "dropdeladd": "3695 HUBERTUS RD",
    "dropdelcty": "HUBERTUS",
    "dropdelst": "WI",
    "dropdelzpp": 530339998,
    "dropphyadd": "3695 HUBERTUS RD",
    "dropphycty": "HUBERTUS",
    "dropphyst": "WI",
    "dropphyzpp": 530339998,
    "dropmaladd": "3695 HUBERTUS RD",
    "dropmalcty": "HUBERTUS",
    "dropmalst": "WI",
    "dropmalzpp": 530339998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626283535,
    "dropsitcph": 2626283535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17459",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "808 HEGGEN ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "WI",
    "dropdelzpp": 540165003,
    "dropphyadd": "808 HEGGEN ST",
    "dropphycty": "HUDSON",
    "dropphyst": "WI",
    "dropphyzpp": 540165003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUDSON",
    "dropmalst": "WI",
    "dropmalzpp": 540169998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153860322,
    "dropfax": 7153860398
  },
  {
    "dcode": "D",
    "dropkey": "PY17461",
    "droptype": "D",
    "dropname": "HUMBIRD",
    "dropdeladd": "N3062 KING ST",
    "dropdelcty": "HUMBIRD",
    "dropdelst": "WI",
    "dropdelzpp": 547468208,
    "dropphyadd": "N3062 KING ST",
    "dropphycty": "HUMBIRD",
    "dropphyst": "WI",
    "dropphyzpp": 547468208,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMBIRD",
    "dropmalst": "WI",
    "dropmalzpp": 547469998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159647767,
    "dropfax": 7159646005
  },
  {
    "dcode": "D",
    "dropkey": "PY17464",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "417 SILVER ST",
    "dropdelcty": "HURLEY",
    "dropdelst": "WI",
    "dropdelzpp": 545349998,
    "dropphyadd": "417 SILVER ST",
    "dropphycty": "HURLEY",
    "dropphyst": "WI",
    "dropphyzpp": 545349998,
    "dropmaladd": "417 SILVER ST",
    "dropmalcty": "HURLEY",
    "dropmalst": "WI",
    "dropmalzpp": 545349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155615770,
    "dropsitcph": 7155615770,
    "dropfax": 7155615770
  },
  {
    "dcode": "D",
    "dropkey": "PY17465",
    "droptype": "D",
    "dropname": "HUSTISFORD",
    "dropdeladd": "118 E GRIFFITH ST",
    "dropdelcty": "HUSTISFORD",
    "dropdelst": "WI",
    "dropdelzpp": 530349500,
    "dropphyadd": "118 E GRIFFITH ST",
    "dropphycty": "HUSTISFORD",
    "dropphyst": "WI",
    "dropphyzpp": 530349500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUSTISFORD",
    "dropmalst": "WI",
    "dropmalzpp": 530349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9203493646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17467",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "23569 CEDAR ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "WI",
    "dropdelzpp": 547479060,
    "dropphyadd": "23569 CEDAR ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "WI",
    "dropphyzpp": 547479060,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "WI",
    "dropmalzpp": 547479998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159852211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17470",
    "droptype": "D",
    "dropname": "IOLA",
    "dropdeladd": "190 N MAIN ST",
    "dropdelcty": "IOLA",
    "dropdelst": "WI",
    "dropdelzpp": 549459120,
    "dropphyadd": "190 N MAIN ST",
    "dropphycty": "IOLA",
    "dropphyst": "WI",
    "dropphyzpp": 549459120,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IOLA",
    "dropmalst": "WI",
    "dropmalzpp": 549459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154452417,
    "dropsitcph": 7154452417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17471",
    "droptype": "D",
    "dropname": "IRMA",
    "dropdeladd": "N6525 RAILWAY ST",
    "dropdelcty": "IRMA",
    "dropdelst": "WI",
    "dropdelzpp": 544429800,
    "dropphyadd": "N6525 RAILWAY ST",
    "dropphycty": "IRMA",
    "dropphyst": "WI",
    "dropphyzpp": 544429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRMA",
    "dropmalst": "WI",
    "dropmalzpp": 544429998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155365063,
    "dropsitcph": 7155365063,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17472",
    "droptype": "D",
    "dropname": "IRON BELT",
    "dropdeladd": "11715N MACKINNON ST",
    "dropdelcty": "IRON BELT",
    "dropdelst": "WI",
    "dropdelzpp": 545369800,
    "dropphyadd": "11715N MACKINNON ST",
    "dropphycty": "IRON BELT",
    "dropphyst": "WI",
    "dropphyzpp": 545369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRON BELT",
    "dropmalst": "WI",
    "dropmalzpp": 545369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155615160,
    "dropsitcph": 7155615160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17473",
    "droptype": "D",
    "dropname": "IRON RIDGE",
    "dropdeladd": "108 NORTH ST",
    "dropdelcty": "IRON RIDGE",
    "dropdelst": "WI",
    "dropdelzpp": 530359530,
    "dropphyadd": "108 NORTH ST",
    "dropphycty": "IRON RIDGE",
    "dropphyst": "WI",
    "dropphyzpp": 530359530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRON RIDGE",
    "dropmalst": "WI",
    "dropmalzpp": 530359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206253535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17474",
    "droptype": "D",
    "dropname": "IRON RIVER",
    "dropdeladd": "7830 W MILL ST",
    "dropdelcty": "IRON RIVER",
    "dropdelst": "WI",
    "dropdelzpp": 548474659,
    "dropphyadd": "7830 W MILL ST",
    "dropphycty": "IRON RIVER",
    "dropphyst": "WI",
    "dropphyzpp": 548474659,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRON RIVER",
    "dropmalst": "WI",
    "dropmalzpp": 548479998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153724783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17478",
    "droptype": "D",
    "dropname": "IXONIA",
    "dropdeladd": "W1235 MARIETTA AVE",
    "dropdelcty": "IXONIA",
    "dropdelst": "WI",
    "dropdelzpp": 530369998,
    "dropphyadd": "W1235 MARIETTA AVE",
    "dropphycty": "IXONIA",
    "dropphyst": "WI",
    "dropphyzpp": 530369998,
    "dropmaladd": "W1235 MARIETTA AVE",
    "dropmalcty": "IXONIA",
    "dropmalst": "WI",
    "dropmalzpp": 530369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9202613306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17481",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "W225N16702 CEDAR PARK CT",
    "dropdelcty": "JACKSON",
    "dropdelst": "WI",
    "dropdelzpp": 530379222,
    "dropphyadd": "W225N16702 CEDAR PARK CT",
    "dropphycty": "JACKSON",
    "dropphyst": "WI",
    "dropphyzpp": 530379222,
    "dropmaladd": "W225N16702 CEDAR PARK CT",
    "dropmalcty": "JACKSON",
    "dropmalst": "WI",
    "dropmalzpp": 530379222,
    "dropsitphn": 2626774078,
    "dropsitlph": 2626774350,
    "dropsitcph": 2626774078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17483",
    "droptype": "D",
    "dropname": "JANESVILLE",
    "dropdeladd": "1818 MILTON AVE STE 100",
    "dropdelcty": "JANESVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535459998,
    "dropphyadd": "1818 MILTON AVE STE 100",
    "dropphycty": "JANESVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535459998,
    "dropmaladd": "1818 MILTON AVE STE 100",
    "dropmalcty": "JANESVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087540062,
    "dropsitcph": 6087545556,
    "dropfax": 6087543401
  },
  {
    "dcode": "D",
    "dropkey": "PY17485",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "122 S CENTER AVE",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "WI",
    "dropdelzpp": 535499998,
    "dropphyadd": "122 S CENTER AVE",
    "dropphycty": "JEFFERSON",
    "dropphyst": "WI",
    "dropphyzpp": 535499998,
    "dropmaladd": "122 S CENTER AVE",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "WI",
    "dropmalzpp": 535499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206743131,
    "dropsitcph": 9206743131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17489",
    "droptype": "D",
    "dropname": "JIM FALLS",
    "dropdeladd": "14046 COUNTY HIGHWAY S S",
    "dropdelcty": "JIM FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 547481654,
    "dropphyadd": "14046 COUNTY HIGHWAY S S",
    "dropphycty": "JIM FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 547481654,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JIM FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 547489998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153824666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17492",
    "droptype": "D",
    "dropname": "JOHNSON CREEK",
    "dropdeladd": "115 DEPOT ST",
    "dropdelcty": "JOHNSON CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 530389800,
    "dropphyadd": "115 DEPOT ST",
    "dropphycty": "JOHNSON CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 530389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHNSON CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 530389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206993395,
    "dropsitcph": 9206993395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17494",
    "droptype": "D",
    "dropname": "JUDA",
    "dropdeladd": "W2899 COUNTY ROAD KS",
    "dropdelcty": "JUDA",
    "dropdelst": "WI",
    "dropdelzpp": 535509517,
    "dropphyadd": "W2899 COUNTY ROAD KS",
    "dropphycty": "JUDA",
    "dropphyst": "WI",
    "dropphyzpp": 535509517,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JUDA",
    "dropmalst": "WI",
    "dropmalzpp": 535509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089345240,
    "dropsitcph": 6089345240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17496",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "408 MAIN ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "WI",
    "dropdelzpp": 544439800,
    "dropphyadd": "408 MAIN ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "WI",
    "dropphyzpp": 544439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "WI",
    "dropmalzpp": 544439998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154572511,
    "dropsitcph": 7154572511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17497",
    "droptype": "D",
    "dropname": "JUNEAU",
    "dropdeladd": "248 E OAK ST",
    "dropdelcty": "JUNEAU",
    "dropdelst": "WI",
    "dropdelzpp": 530399998,
    "dropphyadd": "248 E OAK ST",
    "dropphycty": "JUNEAU",
    "dropphyst": "WI",
    "dropphyzpp": 530399998,
    "dropmaladd": "248 E OAK ST",
    "dropmalcty": "JUNEAU",
    "dropmalst": "WI",
    "dropmalzpp": 530399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9203865518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17500",
    "droptype": "D",
    "dropname": "KANSASVILLE",
    "dropdeladd": "3825 S BEAUMONT AVE",
    "dropdelcty": "KANSASVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 531399998,
    "dropphyadd": "3825 S BEAUMONT AVE",
    "dropphycty": "KANSASVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 531399998,
    "dropmaladd": "3825 S BEAUMONT AVE",
    "dropmalcty": "KANSASVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 531399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628781032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17501",
    "droptype": "D",
    "dropname": "KAUKAUNA",
    "dropdeladd": "120 DOTY ST",
    "dropdelcty": "KAUKAUNA",
    "dropdelst": "WI",
    "dropdelzpp": 541309998,
    "dropphyadd": "120 DOTY ST",
    "dropphycty": "KAUKAUNA",
    "dropphyst": "WI",
    "dropphyzpp": 541309998,
    "dropmaladd": "120 DOTY ST",
    "dropmalcty": "KAUKAUNA",
    "dropmalst": "WI",
    "dropmalzpp": 541309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207665750,
    "dropsitcph": 9207665848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17503",
    "droptype": "D",
    "dropname": "KELLNERSVILLE",
    "dropdeladd": "1216 MAIN ST",
    "dropdelcty": "KELLNERSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 542159800,
    "dropphyadd": "1216 MAIN ST",
    "dropphycty": "KELLNERSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 542159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLNERSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 542159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207323555,
    "dropsitcph": 9207323555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17506",
    "droptype": "D",
    "dropname": "KENDALL",
    "dropdeladd": "109 W SOUTH RAILROAD ST",
    "dropdelcty": "KENDALL",
    "dropdelst": "WI",
    "dropdelzpp": 546387085,
    "dropphyadd": "109 W SOUTH RAILROAD ST",
    "dropphycty": "KENDALL",
    "dropphyst": "WI",
    "dropphyzpp": 546387085,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENDALL",
    "dropmalst": "WI",
    "dropmalzpp": 546389998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085060004,
    "dropfax": 6085060016
  },
  {
    "dcode": "D",
    "dropkey": "PY17507",
    "droptype": "D",
    "dropname": "KENNAN",
    "dropdeladd": "W10419 MAIN ST",
    "dropdelcty": "KENNAN",
    "dropdelst": "WI",
    "dropdelzpp": 545378932,
    "dropphyadd": "W10419 MAIN ST",
    "dropphycty": "KENNAN",
    "dropphyst": "WI",
    "dropphyzpp": 545378932,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENNAN",
    "dropmalst": "WI",
    "dropmalzpp": 545379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154743393,
    "dropsitcph": 7154743393,
    "dropfax": 7154743393
  },
  {
    "dcode": "D",
    "dropkey": "PY17508",
    "droptype": "D",
    "dropname": "KENOSHA",
    "dropdeladd": "5605 SHERIDAN RD",
    "dropdelcty": "KENOSHA",
    "dropdelst": "WI",
    "dropdelzpp": 531409998,
    "dropphyadd": "5605 SHERIDAN RD",
    "dropphycty": "KENOSHA",
    "dropphyst": "WI",
    "dropphyzpp": 531409998,
    "dropmaladd": "5605 SHERIDAN RD",
    "dropmalcty": "KENOSHA",
    "dropmalst": "WI",
    "dropmalzpp": 531409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626575950,
    "dropsitcph": 2626575955,
    "dropfax": 2626570165
  },
  {
    "dcode": "D",
    "dropkey": "PY17509",
    "droptype": "D",
    "dropname": "KESHENA",
    "dropdeladd": "W3210 WOLF RIVER RD",
    "dropdelcty": "KESHENA",
    "dropdelst": "WI",
    "dropdelzpp": 541359200,
    "dropphyadd": "W3210 WOLF RIVER RD",
    "dropphycty": "KESHENA",
    "dropphyst": "WI",
    "dropphyzpp": 541359200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KESHENA",
    "dropmalst": "WI",
    "dropmalzpp": 541359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157993202,
    "dropsitcph": 7157930154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17510",
    "droptype": "D",
    "dropname": "KEWASKUM",
    "dropdeladd": "347 MAIN ST",
    "dropdelcty": "KEWASKUM",
    "dropdelst": "WI",
    "dropdelzpp": 530408932,
    "dropphyadd": "347 MAIN ST",
    "dropphycty": "KEWASKUM",
    "dropphyst": "WI",
    "dropphyzpp": 530408932,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEWASKUM",
    "dropmalst": "WI",
    "dropmalzpp": 530409998,
    "dropsitphn": 2622702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626262575,
    "dropfax": 2626264917
  },
  {
    "dcode": "D",
    "dropkey": "PY17511",
    "droptype": "D",
    "dropname": "KEWAUNEE",
    "dropdeladd": "119 ELLIS ST",
    "dropdelcty": "KEWAUNEE",
    "dropdelst": "WI",
    "dropdelzpp": 542169998,
    "dropphyadd": "119 ELLIS ST",
    "dropphycty": "KEWAUNEE",
    "dropphyst": "WI",
    "dropphyzpp": 542169998,
    "dropmaladd": "119 ELLIS ST",
    "dropmalcty": "KEWAUNEE",
    "dropmalst": "WI",
    "dropmalzpp": 542169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203883000,
    "dropsitcph": 9203883000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17512",
    "droptype": "D",
    "dropname": "KIEL",
    "dropdeladd": "220 FREMONT ST",
    "dropdelcty": "KIEL",
    "dropdelst": "WI",
    "dropdelzpp": 530429998,
    "dropphyadd": "220 FREMONT ST",
    "dropphycty": "KIEL",
    "dropphyst": "WI",
    "dropphyzpp": 530429998,
    "dropmaladd": "220 FREMONT ST",
    "dropmalcty": "KIEL",
    "dropmalst": "WI",
    "dropmalzpp": 530429998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9208942345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17513",
    "droptype": "D",
    "dropname": "KIELER",
    "dropdeladd": "3664 COUNTY ROAD HHH",
    "dropdelcty": "KIELER",
    "dropdelst": "WI",
    "dropdelzpp": 538129700,
    "dropphyadd": "3664 COUNTY ROAD HHH",
    "dropphycty": "KIELER",
    "dropphyst": "WI",
    "dropphyzpp": 538129700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIELER",
    "dropmalst": "WI",
    "dropmalzpp": 538129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085683426,
    "dropsitcph": 6085683426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17515",
    "droptype": "D",
    "dropname": "KIMBERLY",
    "dropdeladd": "415 E KIMBERLY AVE",
    "dropdelcty": "KIMBERLY",
    "dropdelst": "WI",
    "dropdelzpp": 541369998,
    "dropphyadd": "415 E KIMBERLY AVE",
    "dropphycty": "KIMBERLY",
    "dropphyst": "WI",
    "dropphyzpp": 541369998,
    "dropmaladd": "415 E KIMBERLY AVE",
    "dropmalcty": "KIMBERLY",
    "dropmalst": "WI",
    "dropmalzpp": 541369998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207887091,
    "dropsitcph": 9207886928,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17516",
    "droptype": "D",
    "dropname": "KING",
    "dropdeladd": "300 CUMBERLIDGE AVE",
    "dropdelcty": "KING",
    "dropdelst": "WI",
    "dropdelzpp": 549469701,
    "dropphyadd": "300 CUMBERLIDGE AVE",
    "dropphycty": "KING",
    "dropphyst": "WI",
    "dropphyzpp": 549469701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KING",
    "dropmalst": "WI",
    "dropmalzpp": 549469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152585441,
    "dropsitcph": 7152585441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17517",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "150 N SOUTH ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "WI",
    "dropdelzpp": 539399700,
    "dropphyadd": "150 N SOUTH ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "WI",
    "dropphyzpp": 539399700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSTON",
    "dropmalst": "WI",
    "dropmalzpp": 539399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203943663,
    "dropsitcph": 9203943663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17519",
    "droptype": "D",
    "dropname": "KNAPP",
    "dropdeladd": "315 MAIN ST",
    "dropdelcty": "KNAPP",
    "dropdelst": "WI",
    "dropdelzpp": 547499538,
    "dropphyadd": "315 MAIN ST",
    "dropphycty": "KNAPP",
    "dropphyst": "WI",
    "dropphyzpp": 547499538,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KNAPP",
    "dropmalst": "WI",
    "dropmalzpp": 547499998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156652437,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17522",
    "droptype": "D",
    "dropname": "KOHLER",
    "dropdeladd": "319 HIGHLAND DR",
    "dropdelcty": "KOHLER",
    "dropdelst": "WI",
    "dropdelzpp": 530441513,
    "dropphyadd": "319 HIGHLAND DR",
    "dropphycty": "KOHLER",
    "dropphyst": "WI",
    "dropphyzpp": 530441513,
    "dropmaladd": "319 HIGHLAND DR",
    "dropmalcty": "KOHLER",
    "dropmalst": "WI",
    "dropmalzpp": 530441513,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204528308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17524",
    "droptype": "D",
    "dropname": "KRAKOW",
    "dropdeladd": "N4805 STATE HIGHWAY 32",
    "dropdelcty": "KRAKOW",
    "dropdelst": "WI",
    "dropdelzpp": 541379800,
    "dropphyadd": "N4805 STATE HIGHWAY 32",
    "dropphycty": "KRAKOW",
    "dropphyst": "WI",
    "dropphyzpp": 541379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KRAKOW",
    "dropmalst": "WI",
    "dropmalzpp": 541379998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208993691,
    "dropsitcph": 9208993691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17529",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "425 STATE ST STE 100",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "WI",
    "dropdelzpp": 546013378,
    "dropphyadd": "425 STATE ST STE 100",
    "dropphycty": "LA CROSSE",
    "dropphyst": "WI",
    "dropphyzpp": 546013378,
    "dropmaladd": "425 STATE ST STE 100",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "WI",
    "dropmalzpp": 546019998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6087918159,
    "dropsitcph": 6087918100,
    "dropfax": 6087918126
  },
  {
    "dcode": "D",
    "dropkey": "PY17530",
    "droptype": "D",
    "dropname": "LA FARGE",
    "dropdeladd": "205 W MAIN ST",
    "dropdelcty": "LA FARGE",
    "dropdelst": "WI",
    "dropdelzpp": 546398693,
    "dropphyadd": "205 W MAIN ST",
    "dropphycty": "LA FARGE",
    "dropphyst": "WI",
    "dropphyzpp": 546398693,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA FARGE",
    "dropmalst": "WI",
    "dropmalzpp": 546399998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086252220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17531",
    "droptype": "D",
    "dropname": "LA POINTE",
    "dropdeladd": "110 COLONEL WOODS AVE",
    "dropdelcty": "LA POINTE",
    "dropdelst": "WI",
    "dropdelzpp": 548504400,
    "dropphyadd": "110 COLONEL WOODS AVE",
    "dropphycty": "LA POINTE",
    "dropphyst": "WI",
    "dropphyzpp": 548504400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA POINTE",
    "dropmalst": "WI",
    "dropmalzpp": 548509998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157473712,
    "dropfax": 7157472127
  },
  {
    "dcode": "D",
    "dropkey": "PY17532",
    "droptype": "D",
    "dropname": "LA VALLE",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "LA VALLE",
    "dropdelst": "WI",
    "dropdelzpp": 539419141,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "LA VALLE",
    "dropphyst": "WI",
    "dropphyzpp": 539419141,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA VALLE",
    "dropmalst": "WI",
    "dropmalzpp": 539419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089857895,
    "dropsitcph": 6089857895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17534",
    "droptype": "D",
    "dropname": "LAC DU FLAMBEAU",
    "dropdeladd": "614 PEACE PIPE RD",
    "dropdelcty": "LAC DU FLAMBEAU",
    "dropdelst": "WI",
    "dropdelzpp": 545389800,
    "dropphyadd": "614 PEACE PIPE RD",
    "dropphycty": "LAC DU FLAMBEAU",
    "dropphyst": "WI",
    "dropphyzpp": 545389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAC DU FLAMBEAU",
    "dropmalst": "WI",
    "dropmalzpp": 545389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155883122,
    "dropsitcph": 7155883122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17537",
    "droptype": "D",
    "dropname": "LADYSMITH",
    "dropdeladd": "212 MINER AVE W",
    "dropdelcty": "LADYSMITH",
    "dropdelst": "WI",
    "dropdelzpp": 548481744,
    "dropphyadd": "212 MINER AVE W",
    "dropphycty": "LADYSMITH",
    "dropphyst": "WI",
    "dropphyzpp": 548481744,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LADYSMITH",
    "dropmalst": "WI",
    "dropmalzpp": 548489998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155323400,
    "dropfax": 7155329383
  },
  {
    "dcode": "D",
    "dropkey": "PY17542",
    "droptype": "D",
    "dropname": "LAKE DELTON",
    "dropdeladd": "49 E ADAMS ST",
    "dropdelcty": "LAKE DELTON",
    "dropdelst": "WI",
    "dropdelzpp": 539409700,
    "dropphyadd": "49 E ADAMS ST",
    "dropphycty": "LAKE DELTON",
    "dropphyst": "WI",
    "dropphyzpp": 539409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE DELTON",
    "dropmalst": "WI",
    "dropmalzpp": 539409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082534793,
    "dropsitcph": 6082534793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17544",
    "droptype": "D",
    "dropname": "LAKE GENEVA",
    "dropdeladd": "672 W MAIN ST",
    "dropdelcty": "LAKE GENEVA",
    "dropdelst": "WI",
    "dropdelzpp": 531479998,
    "dropphyadd": "672 W MAIN ST",
    "dropphycty": "LAKE GENEVA",
    "dropphyst": "WI",
    "dropphyzpp": 531479998,
    "dropmaladd": "672 W MAIN ST",
    "dropmalcty": "LAKE GENEVA",
    "dropmalst": "WI",
    "dropmalzpp": 531479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622483545,
    "dropsitcph": 2622483545,
    "dropfax": 2622487078
  },
  {
    "dcode": "D",
    "dropkey": "PY17548",
    "droptype": "D",
    "dropname": "LAKE MILLS",
    "dropdeladd": "155 E OAK ST",
    "dropdelcty": "LAKE MILLS",
    "dropdelst": "WI",
    "dropdelzpp": 535519998,
    "dropphyadd": "155 E OAK ST",
    "dropphycty": "LAKE MILLS",
    "dropphyst": "WI",
    "dropphyzpp": 535519998,
    "dropmaladd": "155 E OAK ST",
    "dropmalcty": "LAKE MILLS",
    "dropmalst": "WI",
    "dropmalzpp": 535519998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206486706,
    "dropsitcph": 9206484707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17549",
    "droptype": "D",
    "dropname": "LAKE NEBAGAMON",
    "dropdeladd": "6870 S LAKE AVE",
    "dropdelcty": "LAKE NEBAGAMON",
    "dropdelst": "WI",
    "dropdelzpp": 548499264,
    "dropphyadd": "6870 S LAKE AVE",
    "dropphycty": "LAKE NEBAGAMON",
    "dropphyst": "WI",
    "dropphyzpp": 548499264,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE NEBAGAMON",
    "dropmalst": "WI",
    "dropmalzpp": 548499998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153743446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17550",
    "droptype": "D",
    "dropname": "LAKE TOMAHAWK",
    "dropdeladd": "7229 BRADLEY ST",
    "dropdelcty": "LAKE TOMAHAWK",
    "dropdelst": "WI",
    "dropdelzpp": 545399201,
    "dropphyadd": "7229 BRADLEY ST",
    "dropphycty": "LAKE TOMAHAWK",
    "dropphyst": "WI",
    "dropphyzpp": 545399201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE TOMAHAWK",
    "dropmalst": "WI",
    "dropmalzpp": 545399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152772693,
    "dropsitcph": 7152772693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17555",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "15283 STATE HIGHWAY 32",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 541389800,
    "dropphyadd": "15283 STATE HIGHWAY 32",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 541389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 541389998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152767667,
    "dropsitcph": 7152767667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17556",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "236 W MAPLE ST",
    "dropdelcty": "LANCASTER",
    "dropdelst": "WI",
    "dropdelzpp": 538139998,
    "dropphyadd": "236 W MAPLE ST",
    "dropphycty": "LANCASTER",
    "dropphyst": "WI",
    "dropphyzpp": 538139998,
    "dropmaladd": "236 W MAPLE ST",
    "dropmalcty": "LANCASTER",
    "dropmalst": "WI",
    "dropmalzpp": 538139998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087234923,
    "dropsitcph": 6087234923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17557",
    "droptype": "D",
    "dropname": "LAND O LAKES",
    "dropdeladd": "4272 COUNTY ROAD B",
    "dropdelcty": "LAND O LAKES",
    "dropdelst": "WI",
    "dropdelzpp": 545409800,
    "dropphyadd": "4272 COUNTY ROAD B",
    "dropphycty": "LAND O LAKES",
    "dropphyst": "WI",
    "dropphyzpp": 545409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAND O LAKES",
    "dropmalst": "WI",
    "dropmalzpp": 545409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155473640,
    "dropsitcph": 7155473640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17562",
    "droptype": "D",
    "dropname": "LANNON",
    "dropdeladd": "20414 W GOOD HOPE RD",
    "dropdelcty": "LANNON",
    "dropdelst": "WI",
    "dropdelzpp": 530469786,
    "dropphyadd": "20414 W GOOD HOPE RD",
    "dropphycty": "LANNON",
    "dropphyst": "WI",
    "dropphyzpp": 530469786,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANNON",
    "dropmalst": "WI",
    "dropmalzpp": 530469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622512067,
    "dropsitcph": 2622512067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17563",
    "droptype": "D",
    "dropname": "LAONA",
    "dropdeladd": "5324 LINDEN ST",
    "dropdelcty": "LAONA",
    "dropdelst": "WI",
    "dropdelzpp": 545419800,
    "dropphyadd": "5324 LINDEN ST",
    "dropphycty": "LAONA",
    "dropphyst": "WI",
    "dropphyzpp": 545419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAONA",
    "dropmalst": "WI",
    "dropmalzpp": 545419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152768185,
    "dropsitcph": 7152768185,
    "dropfax": 7152768185
  },
  {
    "dcode": "D",
    "dropkey": "PY17564",
    "droptype": "D",
    "dropname": "LARSEN",
    "dropdeladd": "8284 HICKORY AVE",
    "dropdelcty": "LARSEN",
    "dropdelst": "WI",
    "dropdelzpp": 549479731,
    "dropphyadd": "8284 HICKORY AVE",
    "dropphycty": "LARSEN",
    "dropphyst": "WI",
    "dropphyzpp": 549479731,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LARSEN",
    "dropmalst": "WI",
    "dropmalzpp": 549479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208362644,
    "dropsitcph": 9208362644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17567",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "N1798 COUNTY ROAD R",
    "dropdelcty": "LEBANON",
    "dropdelst": "WI",
    "dropdelzpp": 530479800,
    "dropphyadd": "N1798 COUNTY ROAD R",
    "dropphycty": "LEBANON",
    "dropphyst": "WI",
    "dropphyzpp": 530479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEBANON",
    "dropmalst": "WI",
    "dropmalzpp": 530479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9209253447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17568",
    "droptype": "D",
    "dropname": "LENA",
    "dropdeladd": "133 E RAILROAD ST",
    "dropdelcty": "LENA",
    "dropdelst": "WI",
    "dropdelzpp": 541399273,
    "dropphyadd": "133 E RAILROAD ST",
    "dropphycty": "LENA",
    "dropphyst": "WI",
    "dropphyzpp": 541399273,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LENA",
    "dropmalst": "WI",
    "dropmalzpp": 541399998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208295940,
    "dropsitcph": 9208295940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17569",
    "droptype": "D",
    "dropname": "LEOPOLIS",
    "dropdeladd": "N4952 4TH ST",
    "dropdelcty": "LEOPOLIS",
    "dropdelst": "WI",
    "dropdelzpp": 549489740,
    "dropphyadd": "N4952 4TH ST",
    "dropphycty": "LEOPOLIS",
    "dropphyst": "WI",
    "dropphyzpp": 549489740,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEOPOLIS",
    "dropmalst": "WI",
    "dropmalzpp": 549489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157874160,
    "dropsitcph": 7157874160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17572",
    "droptype": "D",
    "dropname": "LIME RIDGE",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "LIME RIDGE",
    "dropdelst": "WI",
    "dropdelzpp": 539429701,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "LIME RIDGE",
    "dropphyst": "WI",
    "dropphyzpp": 539429701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIME RIDGE",
    "dropmalst": "WI",
    "dropmalzpp": 539429998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089865481,
    "dropsitcph": 6089865481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17575",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "509 MAIN ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "WI",
    "dropdelzpp": 535539738,
    "dropphyadd": "509 MAIN ST",
    "dropphycty": "LINDEN",
    "dropphyst": "WI",
    "dropphyzpp": 535539738,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINDEN",
    "dropmalst": "WI",
    "dropmalzpp": 535539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086232775,
    "dropsitcph": 6086232775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17580",
    "droptype": "D",
    "dropname": "LITTLE CHUTE",
    "dropdeladd": "514 GRAND AVE",
    "dropdelcty": "LITTLE CHUTE",
    "dropdelst": "WI",
    "dropdelzpp": 541409998,
    "dropphyadd": "514 GRAND AVE",
    "dropphycty": "LITTLE CHUTE",
    "dropphyst": "WI",
    "dropphyzpp": 541409998,
    "dropmaladd": "514 GRAND AVE",
    "dropmalcty": "LITTLE CHUTE",
    "dropmalst": "WI",
    "dropmalzpp": 541409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207886814,
    "dropsitcph": 9206876671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17582",
    "droptype": "D",
    "dropname": "LITTLE SUAMICO",
    "dropdeladd": "1145 GROSSE RD",
    "dropdelcty": "LITTLE SUAMICO",
    "dropdelst": "WI",
    "dropdelzpp": 541418943,
    "dropphyadd": "1145 GROSSE RD",
    "dropphycty": "LITTLE SUAMICO",
    "dropphyst": "WI",
    "dropphyzpp": 541418943,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE SUAMICO",
    "dropmalst": "WI",
    "dropmalzpp": 541419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208267432,
    "dropsitcph": 9208267432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17583",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "295 N CENTER ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "WI",
    "dropdelzpp": 535549415,
    "dropphyadd": "295 N CENTER ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "WI",
    "dropphyzpp": 535549415,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "WI",
    "dropmalzpp": 535549998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089438136,
    "dropsitcph": 6089438136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17584",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "113 1ST ST",
    "dropdelcty": "LODI",
    "dropdelst": "WI",
    "dropdelzpp": 535559998,
    "dropphyadd": "113 1ST ST",
    "dropphycty": "LODI",
    "dropphyst": "WI",
    "dropphyzpp": 535559998,
    "dropmaladd": "113 1ST ST",
    "dropmalcty": "LODI",
    "dropmalst": "WI",
    "dropmalzpp": 535559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085924220,
    "dropsitcph": 6085924220,
    "dropfax": 6085925177
  },
  {
    "dcode": "D",
    "dropkey": "PY17585",
    "droptype": "D",
    "dropname": "LOGANVILLE",
    "dropdeladd": "245 WALNUT ST",
    "dropdelcty": "LOGANVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 539439696,
    "dropphyadd": "245 WALNUT ST",
    "dropphycty": "LOGANVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 539439696,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOGANVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 539439998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087273271,
    "dropsitcph": 6087273271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17588",
    "droptype": "D",
    "dropname": "LOMIRA",
    "dropdeladd": "827 RAILROAD AVE",
    "dropdelcty": "LOMIRA",
    "dropdelst": "WI",
    "dropdelzpp": 530489800,
    "dropphyadd": "827 RAILROAD AVE",
    "dropphycty": "LOMIRA",
    "dropphyst": "WI",
    "dropphyzpp": 530489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOMIRA",
    "dropmalst": "WI",
    "dropmalzpp": 530489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9202694231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17589",
    "droptype": "D",
    "dropname": "LONE ROCK",
    "dropdeladd": "103 S OAK ST",
    "dropdelcty": "LONE ROCK",
    "dropdelst": "WI",
    "dropdelzpp": 535563818,
    "dropphyadd": "103 S OAK ST",
    "dropphycty": "LONE ROCK",
    "dropphyst": "WI",
    "dropphyzpp": 535563818,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONE ROCK",
    "dropmalst": "WI",
    "dropmalzpp": 535569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085834991,
    "dropsitcph": 6085834991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17590",
    "droptype": "D",
    "dropname": "LONG LAKE",
    "dropdeladd": "3357 STATE HIGHWAY 139",
    "dropdelcty": "LONG LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 545429555,
    "dropphyadd": "3357 STATE HIGHWAY 139",
    "dropphycty": "LONG LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 545429555,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 545429998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155218004,
    "dropsitcph": 7155218004,
    "dropfax": 7155218004
  },
  {
    "dcode": "D",
    "dropkey": "PY17595",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "105 N RIVER ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "WI",
    "dropdelzpp": 535579743,
    "dropphyadd": "105 N RIVER ST",
    "dropphycty": "LOWELL",
    "dropphyst": "WI",
    "dropphyzpp": 535579743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWELL",
    "dropmalst": "WI",
    "dropmalzpp": 535579998,
    "dropsitphn": 4149273478,
    "dropsitlph": 9209273478,
    "dropsitcph": 9209273478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17596",
    "droptype": "D",
    "dropname": "LOYAL",
    "dropdeladd": "327 N MAIN ST",
    "dropdelcty": "LOYAL",
    "dropdelst": "WI",
    "dropdelzpp": 544469406,
    "dropphyadd": "327 N MAIN ST",
    "dropphycty": "LOYAL",
    "dropphyst": "WI",
    "dropphyzpp": 544469406,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOYAL",
    "dropmalst": "WI",
    "dropmalzpp": 544469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152559003,
    "dropsitcph": 7152559003,
    "dropfax": 7152559003
  },
  {
    "dcode": "D",
    "dropkey": "PY17599",
    "droptype": "D",
    "dropname": "LUBLIN",
    "dropdeladd": "W13321 SOUTH ST",
    "dropdelcty": "LUBLIN",
    "dropdelst": "WI",
    "dropdelzpp": 544479773,
    "dropphyadd": "W13321 SOUTH ST",
    "dropphycty": "LUBLIN",
    "dropphyst": "WI",
    "dropphyzpp": 544479773,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUBLIN",
    "dropmalst": "WI",
    "dropmalzpp": 544479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156693091,
    "dropsitcph": 7156693091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17600",
    "droptype": "D",
    "dropname": "LUCK",
    "dropdeladd": "128 S MAIN ST",
    "dropdelcty": "LUCK",
    "dropdelst": "WI",
    "dropdelzpp": 548534400,
    "dropphyadd": "128 S MAIN ST",
    "dropphycty": "LUCK",
    "dropphyst": "WI",
    "dropphyzpp": 548534400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCK",
    "dropmalst": "WI",
    "dropmalzpp": 548539998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154722079,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17603",
    "droptype": "D",
    "dropname": "LUXEMBURG",
    "dropdeladd": "406 MAIN ST",
    "dropdelcty": "LUXEMBURG",
    "dropdelst": "WI",
    "dropdelzpp": 542171154,
    "dropphyadd": "406 MAIN ST",
    "dropphycty": "LUXEMBURG",
    "dropphyst": "WI",
    "dropphyzpp": 542171154,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUXEMBURG",
    "dropmalst": "WI",
    "dropmalzpp": 542179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208452551,
    "dropsitcph": 9208452551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17605",
    "droptype": "D",
    "dropname": "LYNDON STATION",
    "dropdeladd": "300 E FLINT ST",
    "dropdelcty": "LYNDON STATION",
    "dropdelst": "WI",
    "dropdelzpp": 539449200,
    "dropphyadd": "300 E FLINT ST",
    "dropphycty": "LYNDON STATION",
    "dropphyst": "WI",
    "dropphyzpp": 539449200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYNDON STATION",
    "dropmalst": "WI",
    "dropmalzpp": 539449998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086663131,
    "dropsitcph": 6086663131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17608",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "1447 MILL ST",
    "dropdelcty": "LYONS",
    "dropdelst": "WI",
    "dropdelzpp": 531489800,
    "dropphyadd": "1447 MILL ST",
    "dropphycty": "LYONS",
    "dropphyst": "WI",
    "dropphyzpp": 531489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYONS",
    "dropmalst": "WI",
    "dropmalzpp": 531489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2627639319,
    "dropsitcph": 2627639319,
    "dropfax": 2627679740
  },
  {
    "dcode": "D",
    "dropkey": "PY17611",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "3902 MILWAUKEE ST",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537149998,
    "dropphyadd": "3902 MILWAUKEE ST",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537149998,
    "dropmaladd": "PO BOX 7990",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537077990,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082461284,
    "dropsitcph": 6082461228,
    "dropfax": 6082461323
  },
  {
    "dcode": "D",
    "dropkey": "PY17614",
    "droptype": "D",
    "dropname": "MAIDEN ROCK",
    "dropdeladd": "N517 COUNTY RD S",
    "dropdelcty": "MAIDEN ROCK",
    "dropdelst": "WI",
    "dropdelzpp": 547504400,
    "dropphyadd": "N517 COUNTY RD S",
    "dropphycty": "MAIDEN ROCK",
    "dropphyst": "WI",
    "dropphyzpp": 547504400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAIDEN ROCK",
    "dropmalst": "WI",
    "dropmalzpp": 547509998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154483771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17615",
    "droptype": "D",
    "dropname": "MALONE",
    "dropdeladd": "N8722 COUNTY RD W",
    "dropdelcty": "MALONE",
    "dropdelst": "WI",
    "dropdelzpp": 530499998,
    "dropphyadd": "N8722 COUNTY RD W",
    "dropphycty": "MALONE",
    "dropphyst": "WI",
    "dropphyzpp": 530499998,
    "dropmaladd": "N8722 COUNTY RD W",
    "dropmalcty": "MALONE",
    "dropmalst": "WI",
    "dropmalzpp": 530499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207954717,
    "dropsitcph": 9207954717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17616",
    "droptype": "D",
    "dropname": "MANAWA",
    "dropdeladd": "129 UNION ST",
    "dropdelcty": "MANAWA",
    "dropdelst": "WI",
    "dropdelzpp": 549499231,
    "dropphyadd": "129 UNION ST",
    "dropphycty": "MANAWA",
    "dropphyst": "WI",
    "dropphyzpp": 549499231,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANAWA",
    "dropmalst": "WI",
    "dropmalzpp": 549499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205962600,
    "dropsitcph": 9205962600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17619",
    "droptype": "D",
    "dropname": "MANITOWISH WATERS",
    "dropdeladd": "5971 COUNTY RD W",
    "dropdelcty": "MANITOWISH WATERS",
    "dropdelst": "WI",
    "dropdelzpp": 545456301,
    "dropphyadd": "5971 COUNTY RD W",
    "dropphycty": "MANITOWISH WATERS",
    "dropphyst": "WI",
    "dropphyzpp": 545456301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANITOWISH WATERS",
    "dropmalst": "WI",
    "dropmalzpp": 545459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155438322,
    "dropsitcph": 7155438322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17620",
    "droptype": "D",
    "dropname": "MANITOWOC",
    "dropdeladd": "1202 FRANKLIN ST",
    "dropdelcty": "MANITOWOC",
    "dropdelst": "WI",
    "dropdelzpp": 542209998,
    "dropphyadd": "1202 FRANKLIN ST",
    "dropphycty": "MANITOWOC",
    "dropphyst": "WI",
    "dropphyzpp": 542209998,
    "dropmaladd": "1202 FRANKLIN ST",
    "dropmalcty": "MANITOWOC",
    "dropmalst": "WI",
    "dropmalzpp": 542209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206826166,
    "dropsitcph": 9206826166,
    "dropfax": 9206826659
  },
  {
    "dcode": "D",
    "dropkey": "PY17621",
    "droptype": "D",
    "dropname": "MAPLE",
    "dropdeladd": "4774 S COUNTY ROAD F",
    "dropdelcty": "MAPLE",
    "dropdelst": "WI",
    "dropdelzpp": 548544402,
    "dropphyadd": "4774 S COUNTY ROAD F",
    "dropphycty": "MAPLE",
    "dropphyst": "WI",
    "dropphyzpp": 548544402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE",
    "dropmalst": "WI",
    "dropmalzpp": 548549998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153643019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17625",
    "droptype": "D",
    "dropname": "MAPLEWOOD",
    "dropdeladd": "1631 STATE HIGHWAY 42",
    "dropdelcty": "MAPLEWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 542269800,
    "dropphyadd": "1631 STATE HIGHWAY 42",
    "dropphycty": "MAPLEWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 542269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLEWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 542269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208566200,
    "dropsitcph": 9208566200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17626",
    "droptype": "D",
    "dropname": "MARATHON",
    "dropdeladd": "305 WALNUT ST",
    "dropdelcty": "MARATHON",
    "dropdelst": "WI",
    "dropdelzpp": 544489800,
    "dropphyadd": "305 WALNUT ST",
    "dropphycty": "MARATHON",
    "dropphyst": "WI",
    "dropphyzpp": 544489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARATHON",
    "dropmalst": "WI",
    "dropmalzpp": 544489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154432026,
    "dropsitcph": 7154432026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17629",
    "droptype": "D",
    "dropname": "MARIBEL",
    "dropdeladd": "14902 MARIBEL RD",
    "dropdelcty": "MARIBEL",
    "dropdelst": "WI",
    "dropdelzpp": 542279300,
    "dropphyadd": "14902 MARIBEL RD",
    "dropphycty": "MARIBEL",
    "dropphyst": "WI",
    "dropphyzpp": 542279300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARIBEL",
    "dropmalst": "WI",
    "dropmalzpp": 542279998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208632915,
    "dropsitcph": 9208632915,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17630",
    "droptype": "D",
    "dropname": "MARINETTE",
    "dropdeladd": "2016 MAPLE AVE",
    "dropdelcty": "MARINETTE",
    "dropdelst": "WI",
    "dropdelzpp": 541439998,
    "dropphyadd": "2016 MAPLE AVE",
    "dropphycty": "MARINETTE",
    "dropphyst": "WI",
    "dropphyzpp": 541439998,
    "dropmaladd": "2016 MAPLE AVE",
    "dropmalcty": "MARINETTE",
    "dropmalst": "WI",
    "dropmalzpp": 541439998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157357342,
    "dropsitcph": 7157357342,
    "dropfax": 7157350330
  },
  {
    "dcode": "D",
    "dropkey": "PY17631",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "238 N MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "WI",
    "dropdelzpp": 549509707,
    "dropphyadd": "238 N MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "WI",
    "dropphyzpp": 549509707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARION",
    "dropmalst": "WI",
    "dropmalzpp": 549509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157545831,
    "dropsitcph": 7157545831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17632",
    "droptype": "D",
    "dropname": "MARKESAN",
    "dropdeladd": "735 N MARGARET ST",
    "dropdelcty": "MARKESAN",
    "dropdelst": "WI",
    "dropdelzpp": 539468582,
    "dropphyadd": "735 N MARGARET ST",
    "dropphycty": "MARKESAN",
    "dropphyst": "WI",
    "dropphyzpp": 539468582,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARKESAN",
    "dropmalst": "WI",
    "dropmalzpp": 539469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203982771,
    "dropsitcph": 9203982771,
    "dropfax": 9203982771
  },
  {
    "dcode": "D",
    "dropkey": "PY17634",
    "droptype": "D",
    "dropname": "MARQUETTE",
    "dropdeladd": "126 S LYONS ST",
    "dropdelcty": "MARQUETTE",
    "dropdelst": "WI",
    "dropdelzpp": 539479700,
    "dropphyadd": "126 S LYONS ST",
    "dropphycty": "MARQUETTE",
    "dropphyst": "WI",
    "dropphyzpp": 539479700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARQUETTE",
    "dropmalst": "WI",
    "dropmalzpp": 539479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203943571,
    "dropsitcph": 9203943571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17635",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "102 S BEEBE ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "WI",
    "dropdelzpp": 535598518,
    "dropphyadd": "102 S BEEBE ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "WI",
    "dropphyzpp": 535598518,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHALL",
    "dropmalst": "WI",
    "dropmalzpp": 535599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086551822,
    "dropsitcph": 6086551822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17637",
    "droptype": "D",
    "dropname": "MARSHFIELD",
    "dropdeladd": "202 S CHESTNUT AVE",
    "dropdelcty": "MARSHFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 544499998,
    "dropphyadd": "202 S CHESTNUT AVE",
    "dropphycty": "MARSHFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 544499998,
    "dropmaladd": "202 S CHESTNUT AVE",
    "dropmalcty": "MARSHFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 544499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153892922,
    "dropsitcph": 7153892922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17639",
    "droptype": "D",
    "dropname": "MASON",
    "dropdeladd": "24675 COUNTY HWY E",
    "dropdelcty": "MASON",
    "dropdelst": "WI",
    "dropdelzpp": 548564405,
    "dropphyadd": "24675 COUNTY HWY E",
    "dropphycty": "MASON",
    "dropphyst": "WI",
    "dropphyzpp": 548564405,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASON",
    "dropmalst": "WI",
    "dropmalzpp": 548569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157654724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17641",
    "droptype": "D",
    "dropname": "MATHER",
    "dropdeladd": "W10786 MAIN ST",
    "dropdelcty": "MATHER",
    "dropdelst": "WI",
    "dropdelzpp": 546416500,
    "dropphyadd": "W10786 MAIN ST",
    "dropphycty": "MATHER",
    "dropphyst": "WI",
    "dropphyzpp": 546416500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATHER",
    "dropmalst": "WI",
    "dropmalzpp": 546419998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083784082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17642",
    "droptype": "D",
    "dropname": "MATTOON",
    "dropdeladd": "811 4TH ST",
    "dropdelcty": "MATTOON",
    "dropdelst": "WI",
    "dropdelzpp": 544509800,
    "dropphyadd": "811 4TH ST",
    "dropphycty": "MATTOON",
    "dropphyst": "WI",
    "dropphyzpp": 544509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATTOON",
    "dropmalst": "WI",
    "dropmalzpp": 544509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154893632,
    "dropsitcph": 7154893632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17643",
    "droptype": "D",
    "dropname": "MAUSTON",
    "dropdeladd": "536 LA CROSSE ST",
    "dropdelcty": "MAUSTON",
    "dropdelst": "WI",
    "dropdelzpp": 539489998,
    "dropphyadd": "536 LA CROSSE ST",
    "dropphycty": "MAUSTON",
    "dropphyst": "WI",
    "dropphyzpp": 539489998,
    "dropmaladd": "536 LA CROSSE ST",
    "dropmalcty": "MAUSTON",
    "dropmalst": "WI",
    "dropmalzpp": 539489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088475939,
    "dropsitcph": 6088475939,
    "dropfax": 6088472504
  },
  {
    "dcode": "D",
    "dropkey": "PY17644",
    "droptype": "D",
    "dropname": "MAYVILLE",
    "dropdeladd": "7 N SCHOOL ST",
    "dropdelcty": "MAYVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 530509998,
    "dropphyadd": "7 N SCHOOL ST",
    "dropphycty": "MAYVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 530509998,
    "dropmaladd": "7 N SCHOOL ST",
    "dropmalcty": "MAYVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 530509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9203875350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17645",
    "droptype": "D",
    "dropname": "MAZOMANIE",
    "dropdeladd": "37 CRESCENT ST",
    "dropdelcty": "MAZOMANIE",
    "dropdelst": "WI",
    "dropdelzpp": 535609675,
    "dropphyadd": "37 CRESCENT ST",
    "dropphycty": "MAZOMANIE",
    "dropphyst": "WI",
    "dropphyzpp": 535609675,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAZOMANIE",
    "dropmalst": "WI",
    "dropmalzpp": 535609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087954361,
    "dropsitcph": 6087954361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17646",
    "droptype": "D",
    "dropname": "MCFARLAND",
    "dropdeladd": "5315 LONG ST",
    "dropdelcty": "MCFARLAND",
    "dropdelst": "WI",
    "dropdelzpp": 535588399,
    "dropphyadd": "5315 LONG ST",
    "dropphycty": "MCFARLAND",
    "dropphyst": "WI",
    "dropphyzpp": 535588399,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCFARLAND",
    "dropmalst": "WI",
    "dropmalzpp": 535589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088389484,
    "dropsitcph": 6088386535,
    "dropfax": 6088386535
  },
  {
    "dcode": "D",
    "dropkey": "PY17650",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "120 W BROADWAY AVE",
    "dropdelcty": "MEDFORD",
    "dropdelst": "WI",
    "dropdelzpp": 544519998,
    "dropphyadd": "120 W BROADWAY AVE",
    "dropphycty": "MEDFORD",
    "dropphyst": "WI",
    "dropphyzpp": 544519998,
    "dropmaladd": "120 W BROADWAY AVE",
    "dropmalcty": "MEDFORD",
    "dropmalst": "WI",
    "dropmalzpp": 544519998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157483981,
    "dropsitcph": 7157483981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17652",
    "droptype": "D",
    "dropname": "MELLEN",
    "dropdeladd": "121 E BENNETT AVE",
    "dropdelcty": "MELLEN",
    "dropdelst": "WI",
    "dropdelzpp": 545469786,
    "dropphyadd": "121 E BENNETT AVE",
    "dropphycty": "MELLEN",
    "dropphyst": "WI",
    "dropphyzpp": 545469786,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELLEN",
    "dropmalst": "WI",
    "dropmalzpp": 545469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152742001,
    "dropsitcph": 7152742001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17653",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "407 N WASHINGTON ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "WI",
    "dropdelzpp": 546427203,
    "dropphyadd": "407 N WASHINGTON ST",
    "dropphycty": "MELROSE",
    "dropphyst": "WI",
    "dropphyzpp": 546427203,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELROSE",
    "dropmalst": "WI",
    "dropmalzpp": 546429998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084884131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17656",
    "droptype": "D",
    "dropname": "MENASHA",
    "dropdeladd": "84 RACINE ST",
    "dropdelcty": "MENASHA",
    "dropdelst": "WI",
    "dropdelzpp": 549529998,
    "dropphyadd": "84 RACINE ST",
    "dropphycty": "MENASHA",
    "dropphyst": "WI",
    "dropphyzpp": 549529998,
    "dropmaladd": "84 RACINE ST",
    "dropmalcty": "MENASHA",
    "dropmalst": "WI",
    "dropmalzpp": 549529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207220326,
    "dropsitcph": 9207220326,
    "dropfax": 9207229250
  },
  {
    "dcode": "D",
    "dropkey": "PY17658",
    "droptype": "D",
    "dropname": "MENOMONEE FALLS",
    "dropdeladd": "N85W16110 APPLETON AVE",
    "dropdelcty": "MENOMONEE FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 530513089,
    "dropphyadd": "N85W16110 APPLETON AVE",
    "dropphycty": "MENOMONEE FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 530513089,
    "dropmaladd": "N85W16110 APPLETON AVE",
    "dropmalcty": "MENOMONEE FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 530513089,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622514016,
    "dropsitcph": 2622514016,
    "dropfax": 2622518605
  },
  {
    "dcode": "D",
    "dropkey": "PY17659",
    "droptype": "D",
    "dropname": "MENOMONIE",
    "dropdeladd": "235 MAIN ST E",
    "dropdelcty": "MENOMONIE",
    "dropdelst": "WI",
    "dropdelzpp": 547512568,
    "dropphyadd": "235 MAIN ST E",
    "dropphycty": "MENOMONIE",
    "dropphyst": "WI",
    "dropphyzpp": 547512568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENOMONIE",
    "dropmalst": "WI",
    "dropmalzpp": 547519998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152352055,
    "dropfax": 7152350013
  },
  {
    "dcode": "D",
    "dropkey": "PY17661",
    "droptype": "D",
    "dropname": "MERCER",
    "dropdeladd": "5245N LAKEVIEW AVE",
    "dropdelcty": "MERCER",
    "dropdelst": "WI",
    "dropdelzpp": 545479800,
    "dropphyadd": "5245N LAKEVIEW AVE",
    "dropphycty": "MERCER",
    "dropphyst": "WI",
    "dropphyzpp": 545479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERCER",
    "dropmalst": "WI",
    "dropmalzpp": 545479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154760270,
    "dropsitcph": 7154760270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17662",
    "droptype": "D",
    "dropname": "MERRILL",
    "dropdeladd": "430 E 2ND ST",
    "dropdelcty": "MERRILL",
    "dropdelst": "WI",
    "dropdelzpp": 544529998,
    "dropphyadd": "430 E 2ND ST",
    "dropphycty": "MERRILL",
    "dropphyst": "WI",
    "dropphyzpp": 544529998,
    "dropmaladd": "430 E 2ND ST",
    "dropmalcty": "MERRILL",
    "dropmalst": "WI",
    "dropmalzpp": 544529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155393287,
    "dropsitcph": 7155393287,
    "dropfax": 7155362062
  },
  {
    "dcode": "D",
    "dropkey": "PY17663",
    "droptype": "D",
    "dropname": "MERRILLAN",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "MERRILLAN",
    "dropdelst": "WI",
    "dropdelzpp": 547544400,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "MERRILLAN",
    "dropphyst": "WI",
    "dropphyzpp": 547544400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRILLAN",
    "dropmalst": "WI",
    "dropmalzpp": 547549998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153336021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17664",
    "droptype": "D",
    "dropname": "MERRIMAC",
    "dropdeladd": "110 SCHOOL ST",
    "dropdelcty": "MERRIMAC",
    "dropdelst": "WI",
    "dropdelzpp": 535619531,
    "dropphyadd": "110 SCHOOL ST",
    "dropphycty": "MERRIMAC",
    "dropphyst": "WI",
    "dropphyzpp": 535619531,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRIMAC",
    "dropmalst": "WI",
    "dropmalzpp": 535619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084932323,
    "dropsitcph": 6084930031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17665",
    "droptype": "D",
    "dropname": "MERTON",
    "dropdeladd": "W282N7105 MAIN ST",
    "dropdelcty": "MERTON",
    "dropdelst": "WI",
    "dropdelzpp": 530564501,
    "dropphyadd": "W282N7105 MAIN ST",
    "dropphycty": "MERTON",
    "dropphyst": "WI",
    "dropphyzpp": 530564501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERTON",
    "dropmalst": "WI",
    "dropmalzpp": 530569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625381140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17675",
    "droptype": "D",
    "dropname": "MILLSTON",
    "dropdeladd": "W6593 RAILROAD ST",
    "dropdelcty": "MILLSTON",
    "dropdelst": "WI",
    "dropdelzpp": 546436500,
    "dropphyadd": "W6593 RAILROAD ST",
    "dropphycty": "MILLSTON",
    "dropphyst": "WI",
    "dropphyzpp": 546436500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLSTON",
    "dropmalst": "WI",
    "dropmalzpp": 546439998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152842326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17676",
    "droptype": "D",
    "dropname": "MILLTOWN",
    "dropdeladd": "71 MAIN ST E",
    "dropdelcty": "MILLTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 548589029,
    "dropphyadd": "71 MAIN ST E",
    "dropphycty": "MILLTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 548589029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 548589998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158252243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17677",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "150 HILLTOP DR",
    "dropdelcty": "MILTON",
    "dropdelst": "WI",
    "dropdelzpp": 535639998,
    "dropphyadd": "150 HILLTOP DR",
    "dropphycty": "MILTON",
    "dropphyst": "WI",
    "dropphyzpp": 535639998,
    "dropmaladd": "150 HILLTOP DR",
    "dropmalcty": "MILTON",
    "dropmalst": "WI",
    "dropmalzpp": 535639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088687742,
    "dropsitcph": 6088687742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17680",
    "droptype": "D",
    "dropname": "MILWAUKEE",
    "dropdeladd": "345 W SAINT PAUL AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532033099,
    "dropphyadd": "345 W SAINT PAUL AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532033099,
    "dropmaladd": "PO BOX 5066",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532015066,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702308,
    "dropsitcph": 4142702308,
    "dropfax": 4142702045
  },
  {
    "dcode": "D",
    "dropkey": "PY17682",
    "droptype": "D",
    "dropname": "MINDORO",
    "dropdeladd": "N8299 STATE ROAD 108",
    "dropdelcty": "MINDORO",
    "dropdelst": "WI",
    "dropdelzpp": 546441515,
    "dropphyadd": "N8299 STATE ROAD 108",
    "dropphycty": "MINDORO",
    "dropphyst": "WI",
    "dropphyzpp": 546441515,
    "dropmaladd": "N8299 STATE ROAD 108",
    "dropmalcty": "MINDORO",
    "dropmalst": "WI",
    "dropmalzpp": 546441515,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6088573994,
    "dropfax": 6088573779
  },
  {
    "dcode": "D",
    "dropkey": "PY17683",
    "droptype": "D",
    "dropname": "MINERAL POINT",
    "dropdeladd": "269 HIGH ST",
    "dropdelcty": "MINERAL POINT",
    "dropdelst": "WI",
    "dropdelzpp": 535659998,
    "dropphyadd": "269 HIGH ST",
    "dropphycty": "MINERAL POINT",
    "dropphyst": "WI",
    "dropphyzpp": 535659998,
    "dropmaladd": "269 HIGH ST",
    "dropmalcty": "MINERAL POINT",
    "dropmalst": "WI",
    "dropmalzpp": 535659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089872223,
    "dropsitcph": 6089872223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17684",
    "droptype": "D",
    "dropname": "MINOCQUA",
    "dropdeladd": "126 W FRONT ST",
    "dropdelcty": "MINOCQUA",
    "dropdelst": "WI",
    "dropdelzpp": 545489800,
    "dropphyadd": "126 W FRONT ST",
    "dropphycty": "MINOCQUA",
    "dropphyst": "WI",
    "dropphyzpp": 545489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINOCQUA",
    "dropmalst": "WI",
    "dropmalzpp": 545489998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153563373,
    "dropsitcph": 7153563373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17685",
    "droptype": "D",
    "dropname": "MINONG",
    "dropdeladd": "321 5TH AVE",
    "dropdelcty": "MINONG",
    "dropdelst": "WI",
    "dropdelzpp": 548599508,
    "dropphyadd": "321 5TH AVE",
    "dropphycty": "MINONG",
    "dropphyst": "WI",
    "dropphyzpp": 548599508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINONG",
    "dropmalst": "WI",
    "dropmalzpp": 548599998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154662111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17686",
    "droptype": "D",
    "dropname": "MISHICOT",
    "dropdeladd": "320 SPRUCE ST",
    "dropdelcty": "MISHICOT",
    "dropdelst": "WI",
    "dropdelzpp": 542289800,
    "dropphyadd": "320 SPRUCE ST",
    "dropphycty": "MISHICOT",
    "dropphyst": "WI",
    "dropphyzpp": 542289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MISHICOT",
    "dropmalst": "WI",
    "dropmalzpp": 542289998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207552021,
    "dropsitcph": 9207552021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17690",
    "droptype": "D",
    "dropname": "MONDOVI",
    "dropdeladd": "131 W VINE ST",
    "dropdelcty": "MONDOVI",
    "dropdelst": "WI",
    "dropdelzpp": 547551140,
    "dropphyadd": "131 W VINE ST",
    "dropphycty": "MONDOVI",
    "dropphyst": "WI",
    "dropphyzpp": 547551140,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONDOVI",
    "dropmalst": "WI",
    "dropmalzpp": 547559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159264988,
    "dropfax": 7159265374
  },
  {
    "dcode": "D",
    "dropkey": "PY17695",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "1724 11TH ST",
    "dropdelcty": "MONROE",
    "dropdelst": "WI",
    "dropdelzpp": 535669998,
    "dropphyadd": "1724 11TH ST",
    "dropphycty": "MONROE",
    "dropphyst": "WI",
    "dropphyzpp": 535669998,
    "dropmaladd": "1724 11TH ST",
    "dropmalcty": "MONROE",
    "dropmalst": "WI",
    "dropmalzpp": 535669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083253031,
    "dropsitcph": 6083253031,
    "dropfax": 6083253065
  },
  {
    "dcode": "D",
    "dropkey": "PY17697",
    "droptype": "D",
    "dropname": "MONTELLO",
    "dropdeladd": "109 E MONTELLO ST",
    "dropdelcty": "MONTELLO",
    "dropdelst": "WI",
    "dropdelzpp": 539499773,
    "dropphyadd": "109 E MONTELLO ST",
    "dropphycty": "MONTELLO",
    "dropphyst": "WI",
    "dropphyzpp": 539499773,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTELLO",
    "dropmalst": "WI",
    "dropmalzpp": 539499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082972666,
    "dropsitcph": 6082972666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17698",
    "droptype": "D",
    "dropname": "MONTFORT",
    "dropdeladd": "105 S FOUNTAIN ST",
    "dropdelcty": "MONTFORT",
    "dropdelst": "WI",
    "dropdelzpp": 535699703,
    "dropphyadd": "105 S FOUNTAIN ST",
    "dropphycty": "MONTFORT",
    "dropphyst": "WI",
    "dropphyzpp": 535699703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTFORT",
    "dropmalst": "WI",
    "dropmalzpp": 535699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089438141,
    "dropsitcph": 6089438141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17699",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "102 E NORTH AVE",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "WI",
    "dropdelzpp": 535709404,
    "dropphyadd": "102 E NORTH AVE",
    "dropphycty": "MONTICELLO",
    "dropphyst": "WI",
    "dropphyzpp": 535709404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "WI",
    "dropmalzpp": 535709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089384885,
    "dropsitcph": 6089384885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17700",
    "droptype": "D",
    "dropname": "MONTREAL",
    "dropdeladd": "138 WISCONSIN AVE",
    "dropdelcty": "MONTREAL",
    "dropdelst": "WI",
    "dropdelzpp": 545509800,
    "dropphyadd": "138 WISCONSIN AVE",
    "dropphycty": "MONTREAL",
    "dropphyst": "WI",
    "dropphyzpp": 545509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTREAL",
    "dropmalst": "WI",
    "dropmalzpp": 545509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155615680,
    "dropsitcph": 7155615680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17704",
    "droptype": "D",
    "dropname": "MORRISONVILLE",
    "dropdeladd": "4676 COUNTY ROAD DM",
    "dropdelcty": "MORRISONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535719700,
    "dropphyadd": "4676 COUNTY ROAD DM",
    "dropphycty": "MORRISONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535719700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRISONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535719998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088464994,
    "dropsitcph": 6088464994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17706",
    "droptype": "D",
    "dropname": "MOSINEE",
    "dropdeladd": "408 2ND ST",
    "dropdelcty": "MOSINEE",
    "dropdelst": "WI",
    "dropdelzpp": 544559998,
    "dropphyadd": "408 2ND ST",
    "dropphycty": "MOSINEE",
    "dropphyst": "WI",
    "dropphyzpp": 544559998,
    "dropmaladd": "408 2ND ST",
    "dropmalcty": "MOSINEE",
    "dropmalst": "WI",
    "dropmalzpp": 544559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156932315,
    "dropsitcph": 7156932315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17707",
    "droptype": "D",
    "dropname": "MOUNT CALVARY",
    "dropdeladd": "616 MOUNT CARMEL ST",
    "dropdelcty": "MOUNT CALVARY",
    "dropdelst": "WI",
    "dropdelzpp": 530579800,
    "dropphyadd": "616 MOUNT CARMEL ST",
    "dropphycty": "MOUNT CALVARY",
    "dropphyst": "WI",
    "dropphyzpp": 530579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT CALVARY",
    "dropmalst": "WI",
    "dropmalzpp": 530579998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9207533161,
    "dropfax": 9207532082
  },
  {
    "dcode": "D",
    "dropkey": "PY17708",
    "droptype": "D",
    "dropname": "MOUNT HOPE",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "MOUNT HOPE",
    "dropdelst": "WI",
    "dropdelzpp": 538169637,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "MOUNT HOPE",
    "dropphyst": "WI",
    "dropphyzpp": 538169637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT HOPE",
    "dropmalst": "WI",
    "dropmalzpp": 538169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2623931948,
    "dropsitcph": 2623931948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17709",
    "droptype": "D",
    "dropname": "MOUNT HOREB",
    "dropdeladd": "108 S 1ST ST",
    "dropdelcty": "MOUNT HOREB",
    "dropdelst": "WI",
    "dropdelzpp": 535729998,
    "dropphyadd": "108 S 1ST ST",
    "dropphycty": "MOUNT HOREB",
    "dropphyst": "WI",
    "dropphyzpp": 535729998,
    "dropmaladd": "108 S 1ST ST",
    "dropmalcty": "MOUNT HOREB",
    "dropmalst": "WI",
    "dropmalzpp": 535729998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084375133,
    "dropsitcph": 6082862504,
    "dropfax": 6084376056
  },
  {
    "dcode": "D",
    "dropkey": "PY17711",
    "droptype": "D",
    "dropname": "MOUNT STERLING",
    "dropdeladd": "305 DIAGONAL ST",
    "dropdelcty": "MOUNT STERLING",
    "dropdelst": "WI",
    "dropdelzpp": 546456500,
    "dropphyadd": "305 DIAGONAL ST",
    "dropphycty": "MOUNT STERLING",
    "dropphyst": "WI",
    "dropphyzpp": 546456500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT STERLING",
    "dropmalst": "WI",
    "dropmalzpp": 546459998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6087343011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17712",
    "droptype": "D",
    "dropname": "MOUNTAIN",
    "dropdeladd": "14092 STATE HIGHWAY 32 64",
    "dropdelcty": "MOUNTAIN",
    "dropdelst": "WI",
    "dropdelzpp": 541499664,
    "dropphyadd": "14092 STATE HIGHWAY 32 64",
    "dropphycty": "MOUNTAIN",
    "dropphyst": "WI",
    "dropphyzpp": 541499664,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN",
    "dropmalst": "WI",
    "dropmalzpp": 541499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152767301,
    "dropsitcph": 7152767301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17715",
    "droptype": "D",
    "dropname": "MUKWONAGO",
    "dropdeladd": "911 GREENRIDGE CTR",
    "dropdelcty": "MUKWONAGO",
    "dropdelst": "WI",
    "dropdelzpp": 531499998,
    "dropphyadd": "911 GREENRIDGE CTR",
    "dropphycty": "MUKWONAGO",
    "dropphyst": "WI",
    "dropphyzpp": 531499998,
    "dropmaladd": "911 GREENRIDGE CTR",
    "dropmalcty": "MUKWONAGO",
    "dropmalst": "WI",
    "dropmalzpp": 531499998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2623637741,
    "dropsitcph": 2623637741,
    "dropfax": 2623635728
  },
  {
    "dcode": "D",
    "dropkey": "PY17716",
    "droptype": "D",
    "dropname": "MUSCODA",
    "dropdeladd": "1025 N WISCONSIN AVE",
    "dropdelcty": "MUSCODA",
    "dropdelst": "WI",
    "dropdelzpp": 535739116,
    "dropphyadd": "1025 N WISCONSIN AVE",
    "dropphycty": "MUSCODA",
    "dropphyst": "WI",
    "dropphyzpp": 535739116,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MUSCODA",
    "dropmalst": "WI",
    "dropmalzpp": 535739998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087393351,
    "dropsitcph": 6087393351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17717",
    "droptype": "D",
    "dropname": "MUSKEGO",
    "dropdeladd": "S74W16860 JANESVILLE RD",
    "dropdelcty": "MUSKEGO",
    "dropdelst": "WI",
    "dropdelzpp": 531509998,
    "dropphyadd": "S74W16860 JANESVILLE RD",
    "dropphycty": "MUSKEGO",
    "dropphyst": "WI",
    "dropphyzpp": 531509998,
    "dropmaladd": "S74W16860 JANESVILLE RD",
    "dropmalcty": "MUSKEGO",
    "dropmalst": "WI",
    "dropmalzpp": 531509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144229510,
    "dropsitcph": 4144229501,
    "dropfax": 4144229092
  },
  {
    "dcode": "D",
    "dropkey": "PY17720",
    "droptype": "D",
    "dropname": "NASHOTAH",
    "dropdeladd": "W330N4361 LAKELAND DR",
    "dropdelcty": "NASHOTAH",
    "dropdelst": "WI",
    "dropdelzpp": 530589998,
    "dropphyadd": "W330N4361 LAKELAND DR",
    "dropphycty": "NASHOTAH",
    "dropphyst": "WI",
    "dropphyzpp": 530589998,
    "dropmaladd": "W330N4361 LAKELAND DR",
    "dropmalcty": "NASHOTAH",
    "dropmalst": "WI",
    "dropmalzpp": 530589998,
    "dropsitphn": 2622702120,
    "dropsitlph": 2622702120,
    "dropsitcph": 2623672813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17723",
    "droptype": "D",
    "dropname": "NECEDAH",
    "dropdeladd": "603 W 3RD ST",
    "dropdelcty": "NECEDAH",
    "dropdelst": "WI",
    "dropdelzpp": 546468105,
    "dropphyadd": "603 W 3RD ST",
    "dropphycty": "NECEDAH",
    "dropphyst": "WI",
    "dropphyzpp": 546468105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NECEDAH",
    "dropmalst": "WI",
    "dropmalzpp": 546469998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085652326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17724",
    "droptype": "D",
    "dropname": "NEENAH",
    "dropdeladd": "130 W FRANKLIN AVE",
    "dropdelcty": "NEENAH",
    "dropdelst": "WI",
    "dropdelzpp": 549569998,
    "dropphyadd": "130 W FRANKLIN AVE",
    "dropphycty": "NEENAH",
    "dropphyst": "WI",
    "dropphyzpp": 549569998,
    "dropmaladd": "130 W FRANKLIN AVE",
    "dropmalcty": "NEENAH",
    "dropmalst": "WI",
    "dropmalzpp": 549569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207250577,
    "dropsitcph": 9207250577,
    "dropfax": 9207251798
  },
  {
    "dcode": "D",
    "dropkey": "PY17725",
    "droptype": "D",
    "dropname": "NEILLSVILLE",
    "dropdeladd": "619 HEWETT ST",
    "dropdelcty": "NEILLSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 544569998,
    "dropphyadd": "619 HEWETT ST",
    "dropphycty": "NEILLSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 544569998,
    "dropmaladd": "619 HEWETT ST",
    "dropmalcty": "NEILLSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 544569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157432842,
    "dropsitcph": 7157432842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17726",
    "droptype": "D",
    "dropname": "NEKOOSA",
    "dropdeladd": "1001 MARKET ST",
    "dropdelcty": "NEKOOSA",
    "dropdelst": "WI",
    "dropdelzpp": 544579998,
    "dropphyadd": "1001 MARKET ST",
    "dropphycty": "NEKOOSA",
    "dropphyst": "WI",
    "dropphyzpp": 544579998,
    "dropmaladd": "1001 MARKET ST",
    "dropmalcty": "NEKOOSA",
    "dropmalst": "WI",
    "dropmalzpp": 544579998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158863743,
    "dropsitcph": 7158863743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17727",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "E200 CLEVELAND ST",
    "dropdelcty": "NELSON",
    "dropdelst": "WI",
    "dropdelzpp": 547568400,
    "dropphyadd": "E200 CLEVELAND ST",
    "dropphycty": "NELSON",
    "dropphyst": "WI",
    "dropphyzpp": 547568400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELSON",
    "dropmalst": "WI",
    "dropmalzpp": 547569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156734025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17728",
    "droptype": "D",
    "dropname": "NELSONVILLE",
    "dropdeladd": "3136 HIGH ST",
    "dropdelcty": "NELSONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 544589800,
    "dropphyadd": "3136 HIGH ST",
    "dropphycty": "NELSONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 544589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELSONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 544589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158242689,
    "dropsitcph": 7158242689,
    "dropfax": 7158245733
  },
  {
    "dcode": "D",
    "dropkey": "PY17729",
    "droptype": "D",
    "dropname": "NEOPIT",
    "dropdeladd": "W6786 CHURCH ST",
    "dropdelcty": "NEOPIT",
    "dropdelst": "WI",
    "dropdelzpp": 541509800,
    "dropphyadd": "W6786 CHURCH ST",
    "dropphycty": "NEOPIT",
    "dropphyst": "WI",
    "dropphyzpp": 541509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEOPIT",
    "dropmalst": "WI",
    "dropmalzpp": 541509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157562400,
    "dropsitcph": 7157562400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17730",
    "droptype": "D",
    "dropname": "NEOSHO",
    "dropdeladd": "211 RUBICON ST",
    "dropdelcty": "NEOSHO",
    "dropdelst": "WI",
    "dropdelzpp": 530599521,
    "dropphyadd": "211 RUBICON ST",
    "dropphycty": "NEOSHO",
    "dropphyst": "WI",
    "dropphyzpp": 530599521,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEOSHO",
    "dropmalst": "WI",
    "dropmalzpp": 530599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206253731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17731",
    "droptype": "D",
    "dropname": "NESHKORO",
    "dropdeladd": "316 S MAIN ST",
    "dropdelcty": "NESHKORO",
    "dropdelst": "WI",
    "dropdelzpp": 549609574,
    "dropphyadd": "316 S MAIN ST",
    "dropphycty": "NESHKORO",
    "dropphyst": "WI",
    "dropphyzpp": 549609574,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NESHKORO",
    "dropmalst": "WI",
    "dropmalzpp": 549609998,
    "dropsitphn": 9202934982,
    "dropsitlph": 9202934982,
    "dropsitcph": 9202934982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17733",
    "droptype": "D",
    "dropname": "NEW AUBURN",
    "dropdeladd": "120 E ELM ST",
    "dropdelcty": "NEW AUBURN",
    "dropdelst": "WI",
    "dropdelzpp": 547578593,
    "dropphyadd": "120 E ELM ST",
    "dropphycty": "NEW AUBURN",
    "dropphyst": "WI",
    "dropphyzpp": 547578593,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW AUBURN",
    "dropmalst": "WI",
    "dropmalzpp": 547579998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152372213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17735",
    "droptype": "D",
    "dropname": "NEW FRANKEN",
    "dropdeladd": "2406 N NEW FRANKEN RD",
    "dropdelcty": "NEW FRANKEN",
    "dropdelst": "WI",
    "dropdelzpp": 542299795,
    "dropphyadd": "2406 N NEW FRANKEN RD",
    "dropphycty": "NEW FRANKEN",
    "dropphyst": "WI",
    "dropphyzpp": 542299795,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW FRANKEN",
    "dropmalst": "WI",
    "dropmalzpp": 542299998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202003901,
    "dropsitcph": 9202003901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17736",
    "droptype": "D",
    "dropname": "NEW GLARUS",
    "dropdeladd": "10 6TH AVE",
    "dropdelcty": "NEW GLARUS",
    "dropdelst": "WI",
    "dropdelzpp": 535749549,
    "dropphyadd": "10 6TH AVE",
    "dropphycty": "NEW GLARUS",
    "dropphyst": "WI",
    "dropphyzpp": 535749549,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW GLARUS",
    "dropmalst": "WI",
    "dropmalzpp": 535749998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085272416,
    "dropsitcph": 6085272416,
    "dropfax": 6085276074
  },
  {
    "dcode": "D",
    "dropkey": "PY17738",
    "droptype": "D",
    "dropname": "NEW HOLSTEIN",
    "dropdeladd": "1816 WISCONSIN AVE",
    "dropdelcty": "NEW HOLSTEIN",
    "dropdelst": "WI",
    "dropdelzpp": 530619998,
    "dropphyadd": "1816 WISCONSIN AVE",
    "dropphycty": "NEW HOLSTEIN",
    "dropphyst": "WI",
    "dropphyzpp": 530619998,
    "dropmaladd": "1816 WISCONSIN AVE",
    "dropmalcty": "NEW HOLSTEIN",
    "dropmalst": "WI",
    "dropmalzpp": 530619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9208984414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17740",
    "droptype": "D",
    "dropname": "NEW LISBON",
    "dropdeladd": "100 N ADAMS ST",
    "dropdelcty": "NEW LISBON",
    "dropdelst": "WI",
    "dropdelzpp": 539509998,
    "dropphyadd": "100 N ADAMS ST",
    "dropphycty": "NEW LISBON",
    "dropphyst": "WI",
    "dropphyzpp": 539509998,
    "dropmaladd": "100 N ADAMS ST",
    "dropmalcty": "NEW LISBON",
    "dropmalst": "WI",
    "dropmalzpp": 539509998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085623783,
    "dropsitcph": 6085623783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17741",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "208 S PEARL ST",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "WI",
    "dropdelzpp": 549619998,
    "dropphyadd": "208 S PEARL ST",
    "dropphycty": "NEW LONDON",
    "dropphyst": "WI",
    "dropphyzpp": 549619998,
    "dropmaladd": "208 S PEARL ST",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "WI",
    "dropmalzpp": 549619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209822811,
    "dropsitcph": 9209822811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17742",
    "droptype": "D",
    "dropname": "NEW MUNSTER",
    "dropdeladd": "34315 GENEVA RD",
    "dropdelcty": "NEW MUNSTER",
    "dropdelst": "WI",
    "dropdelzpp": 531529800,
    "dropphyadd": "34315 GENEVA RD",
    "dropphycty": "NEW MUNSTER",
    "dropphyst": "WI",
    "dropphyzpp": 531529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MUNSTER",
    "dropmalst": "WI",
    "dropmalzpp": 531529998,
    "dropsitphn": 2625372776,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625372776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17744",
    "droptype": "D",
    "dropname": "NEW RICHMOND",
    "dropdeladd": "430 S KNOWLES AVE",
    "dropdelcty": "NEW RICHMOND",
    "dropdelst": "WI",
    "dropdelzpp": 540171733,
    "dropphyadd": "430 S KNOWLES AVE",
    "dropphycty": "NEW RICHMOND",
    "dropphyst": "WI",
    "dropphyzpp": 540171733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW RICHMOND",
    "dropmalst": "WI",
    "dropmalzpp": 540179998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152469666,
    "dropfax": 7152467718
  },
  {
    "dcode": "D",
    "dropkey": "PY17748",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "440 MAIN ST",
    "dropdelcty": "NEWBURG",
    "dropdelst": "WI",
    "dropdelzpp": 530609800,
    "dropphyadd": "440 MAIN ST",
    "dropphycty": "NEWBURG",
    "dropphyst": "WI",
    "dropphyzpp": 530609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWBURG",
    "dropmalst": "WI",
    "dropmalzpp": 530609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626756661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17750",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "5627 COUNTY ROAD U",
    "dropdelcty": "NEWTON",
    "dropdelst": "WI",
    "dropdelzpp": 530639601,
    "dropphyadd": "5627 COUNTY ROAD U",
    "dropphycty": "NEWTON",
    "dropphyst": "WI",
    "dropphyzpp": 530639601,
    "dropmaladd": "5627 COUNTY ROAD U",
    "dropmalcty": "NEWTON",
    "dropmalst": "WI",
    "dropmalzpp": 530639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 8779072835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17751",
    "droptype": "D",
    "dropname": "NIAGARA",
    "dropdeladd": "617 WASHINGTON AVE",
    "dropdelcty": "NIAGARA",
    "dropdelst": "WI",
    "dropdelzpp": 541519998,
    "dropphyadd": "617 WASHINGTON AVE",
    "dropphycty": "NIAGARA",
    "dropphyst": "WI",
    "dropphyzpp": 541519998,
    "dropmaladd": "617 WASHINGTON AVE",
    "dropmalcty": "NIAGARA",
    "dropmalst": "WI",
    "dropmalzpp": 541519998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152513648,
    "dropsitcph": 7152513648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17752",
    "droptype": "D",
    "dropname": "NICHOLS",
    "dropdeladd": "W5624 MAIN",
    "dropdelcty": "NICHOLS",
    "dropdelst": "WI",
    "dropdelzpp": 541529800,
    "dropphyadd": "W5624 MAIN",
    "dropphycty": "NICHOLS",
    "dropphyst": "WI",
    "dropphyzpp": 541529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NICHOLS",
    "dropmalst": "WI",
    "dropmalzpp": 541529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205251296,
    "dropsitcph": 9205251296,
    "dropfax": 9205251290
  },
  {
    "dcode": "D",
    "dropkey": "PY17755",
    "droptype": "D",
    "dropname": "NORTH FREEDOM",
    "dropdeladd": "102 E WALNUT ST",
    "dropdelcty": "NORTH FREEDOM",
    "dropdelst": "WI",
    "dropdelzpp": 539519584,
    "dropphyadd": "102 E WALNUT ST",
    "dropphycty": "NORTH FREEDOM",
    "dropphyst": "WI",
    "dropphyzpp": 539519584,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH FREEDOM",
    "dropmalst": "WI",
    "dropmalzpp": 539519998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085223622,
    "dropsitcph": 6085223622,
    "dropfax": 6085223622
  },
  {
    "dcode": "D",
    "dropkey": "PY17757",
    "droptype": "D",
    "dropname": "NORTH LAKE",
    "dropdeladd": "W315N7755 STATE ROAD 83",
    "dropdelcty": "NORTH LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 530649800,
    "dropphyadd": "W315N7755 STATE ROAD 83",
    "dropphycty": "NORTH LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 530649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 530649998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 4149667200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17759",
    "droptype": "D",
    "dropname": "NORTH PRAIRIE",
    "dropdeladd": "125 N HARRISON ST",
    "dropdelcty": "NORTH PRAIRIE",
    "dropdelst": "WI",
    "dropdelzpp": 531539791,
    "dropphyadd": "125 N HARRISON ST",
    "dropphycty": "NORTH PRAIRIE",
    "dropphyst": "WI",
    "dropphyzpp": 531539791,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH PRAIRIE",
    "dropmalst": "WI",
    "dropmalzpp": 531539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2623922800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17763",
    "droptype": "D",
    "dropname": "NORWALK",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "NORWALK",
    "dropdelst": "WI",
    "dropdelzpp": 546488091,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "NORWALK",
    "dropphyst": "WI",
    "dropphyzpp": 546488091,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWALK",
    "dropmalst": "WI",
    "dropmalzpp": 546489998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6088237927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17765",
    "droptype": "D",
    "dropname": "OAK CREEK",
    "dropdeladd": "200 E CENTENNIAL DR",
    "dropdelcty": "OAK CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 531548618,
    "dropphyadd": "200 E CENTENNIAL DR",
    "dropphycty": "OAK CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 531548618,
    "dropmaladd": "200 E CENTENNIAL DR",
    "dropmalcty": "OAK CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 531548618,
    "dropsitphn": 4142702120,
    "dropsitlph": 4147660599,
    "dropsitcph": 4147660583,
    "dropfax": 4147660599
  },
  {
    "dcode": "D",
    "dropkey": "PY17767",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "126 E BADGER DR",
    "dropdelcty": "OAKDALE",
    "dropdelst": "WI",
    "dropdelzpp": 546496500,
    "dropphyadd": "126 E BADGER DR",
    "dropphycty": "OAKDALE",
    "dropphyst": "WI",
    "dropphyzpp": 546496500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKDALE",
    "dropmalst": "WI",
    "dropmalzpp": 546499998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083723361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17768",
    "droptype": "D",
    "dropname": "OAKFIELD",
    "dropdeladd": "120 BOOTH ST",
    "dropdelcty": "OAKFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 530659998,
    "dropphyadd": "120 BOOTH ST",
    "dropphycty": "OAKFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 530659998,
    "dropmaladd": "120 BOOTH ST",
    "dropmalcty": "OAKFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 530659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205815244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17770",
    "droptype": "D",
    "dropname": "OCONOMOWOC",
    "dropdeladd": "38 S MAIN ST",
    "dropdelcty": "OCONOMOWOC",
    "dropdelst": "WI",
    "dropdelzpp": 530669998,
    "dropphyadd": "38 S MAIN ST",
    "dropphycty": "OCONOMOWOC",
    "dropphyst": "WI",
    "dropphyzpp": 530669998,
    "dropmaladd": "38 S MAIN ST",
    "dropmalcty": "OCONOMOWOC",
    "dropmalst": "WI",
    "dropmalzpp": 530669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625677241,
    "dropfax": 2625674219
  },
  {
    "dcode": "D",
    "dropkey": "PY17772",
    "droptype": "D",
    "dropname": "OCONTO",
    "dropdeladd": "141 CONGRESS ST",
    "dropdelcty": "OCONTO",
    "dropdelst": "WI",
    "dropdelzpp": 541539998,
    "dropphyadd": "141 CONGRESS ST",
    "dropphycty": "OCONTO",
    "dropphyst": "WI",
    "dropphyzpp": 541539998,
    "dropmaladd": "141 CONGRESS ST",
    "dropmalcty": "OCONTO",
    "dropmalst": "WI",
    "dropmalzpp": 541539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208343844,
    "dropsitcph": 9208343844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17773",
    "droptype": "D",
    "dropname": "OCONTO FALLS",
    "dropdeladd": "145 N FRANKLIN ST",
    "dropdelcty": "OCONTO FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 541549998,
    "dropphyadd": "145 N FRANKLIN ST",
    "dropphycty": "OCONTO FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 541549998,
    "dropmaladd": "145 N FRANKLIN ST",
    "dropmalcty": "OCONTO FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 541549998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208460439,
    "dropsitcph": 9208460439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17775",
    "droptype": "D",
    "dropname": "ODANAH",
    "dropdeladd": "73430 US HIGHWAY 2",
    "dropdelcty": "ODANAH",
    "dropdelst": "WI",
    "dropdelzpp": 548614401,
    "dropphyadd": "73430 US HIGHWAY 2",
    "dropphycty": "ODANAH",
    "dropphyst": "WI",
    "dropphyzpp": 548614401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODANAH",
    "dropmalst": "WI",
    "dropmalzpp": 548619998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156828546,
    "dropfax": 7156828546
  },
  {
    "dcode": "D",
    "dropkey": "PY17776",
    "droptype": "D",
    "dropname": "OGDENSBURG",
    "dropdeladd": "306 WASHINGTON ST",
    "dropdelcty": "OGDENSBURG",
    "dropdelst": "WI",
    "dropdelzpp": 549629319,
    "dropphyadd": "306 WASHINGTON ST",
    "dropphycty": "OGDENSBURG",
    "dropphyst": "WI",
    "dropphyzpp": 549629319,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OGDENSBURG",
    "dropmalst": "WI",
    "dropmalzpp": 549629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202447560,
    "dropsitcph": 9202447560,
    "dropfax": 9202447560
  },
  {
    "dcode": "D",
    "dropkey": "PY17777",
    "droptype": "D",
    "dropname": "OGEMA",
    "dropdeladd": "W4997 STATE HIGHWAY 86",
    "dropdelcty": "OGEMA",
    "dropdelst": "WI",
    "dropdelzpp": 544598345,
    "dropphyadd": "W4997 STATE HIGHWAY 86",
    "dropphycty": "OGEMA",
    "dropphyst": "WI",
    "dropphyzpp": 544598345,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OGEMA",
    "dropmalst": "WI",
    "dropmalzpp": 544599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157675197,
    "dropsitcph": 7157675197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17779",
    "droptype": "D",
    "dropname": "OKAUCHEE",
    "dropdeladd": "N50W35013 WISCONSIN AVE",
    "dropdelcty": "OKAUCHEE",
    "dropdelst": "WI",
    "dropdelzpp": 530699763,
    "dropphyadd": "N50W35013 WISCONSIN AVE",
    "dropphycty": "OKAUCHEE",
    "dropphyst": "WI",
    "dropphyzpp": 530699763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OKAUCHEE",
    "dropmalst": "WI",
    "dropmalzpp": 530699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625677020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17783",
    "droptype": "D",
    "dropname": "OMRO",
    "dropdeladd": "204 S WEBSTER AVE",
    "dropdelcty": "OMRO",
    "dropdelst": "WI",
    "dropdelzpp": 549639998,
    "dropphyadd": "204 S WEBSTER AVE",
    "dropphycty": "OMRO",
    "dropphyst": "WI",
    "dropphyzpp": 549639998,
    "dropmaladd": "204 S WEBSTER AVE",
    "dropmalcty": "OMRO",
    "dropmalst": "WI",
    "dropmalzpp": 549639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206855199,
    "dropsitcph": 9206855212,
    "dropfax": 9206850403
  },
  {
    "dcode": "D",
    "dropkey": "PY17784",
    "droptype": "D",
    "dropname": "ONALASKA",
    "dropdeladd": "304 11TH AVE N",
    "dropdelcty": "ONALASKA",
    "dropdelst": "WI",
    "dropdelzpp": 546502733,
    "dropphyadd": "304 11TH AVE N",
    "dropphycty": "ONALASKA",
    "dropphyst": "WI",
    "dropphyzpp": 546502733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONALASKA",
    "dropmalst": "WI",
    "dropmalzpp": 546509998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6087816553,
    "dropsitcph": 6087818777,
    "dropfax": 6087813280
  },
  {
    "dcode": "D",
    "dropkey": "PY17785",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "N7310 RED WILLOW PKWY",
    "dropdelcty": "ONEIDA",
    "dropdelst": "WI",
    "dropdelzpp": 541559692,
    "dropphyadd": "N7310 RED WILLOW PKWY",
    "dropphycty": "ONEIDA",
    "dropphyst": "WI",
    "dropphyzpp": 541559692,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONEIDA",
    "dropmalst": "WI",
    "dropmalzpp": 541559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208693710,
    "dropsitcph": 9208693710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17787",
    "droptype": "D",
    "dropname": "ONTARIO",
    "dropdeladd": "321 MAIN ST",
    "dropdelcty": "ONTARIO",
    "dropdelst": "WI",
    "dropdelzpp": 546515001,
    "dropphyadd": "321 MAIN ST",
    "dropphycty": "ONTARIO",
    "dropphyst": "WI",
    "dropphyzpp": 546515001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONTARIO",
    "dropmalst": "WI",
    "dropmalzpp": 546519998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083374722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17788",
    "droptype": "D",
    "dropname": "OOSTBURG",
    "dropdeladd": "1508 CENTER AVE",
    "dropdelcty": "OOSTBURG",
    "dropdelst": "WI",
    "dropdelzpp": 530709998,
    "dropphyadd": "1508 CENTER AVE",
    "dropphycty": "OOSTBURG",
    "dropphyst": "WI",
    "dropphyzpp": 530709998,
    "dropmaladd": "1508 CENTER AVE",
    "dropmalcty": "OOSTBURG",
    "dropmalst": "WI",
    "dropmalzpp": 530709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205642533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17789",
    "droptype": "D",
    "dropname": "OREGON",
    "dropdeladd": "102 ALPINE PKWY",
    "dropdelcty": "OREGON",
    "dropdelst": "WI",
    "dropdelzpp": 535759903,
    "dropphyadd": "102 ALPINE PKWY",
    "dropphycty": "OREGON",
    "dropphyst": "WI",
    "dropphyzpp": 535759903,
    "dropmaladd": "102 ALPINE PKWY",
    "dropmalcty": "OREGON",
    "dropmalst": "WI",
    "dropmalzpp": 535759903,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088351705,
    "dropsitcph": 6088350894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17790",
    "droptype": "D",
    "dropname": "ORFORDVILLE",
    "dropdeladd": "108 N RICHARDS ST",
    "dropdelcty": "ORFORDVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535769464,
    "dropphyadd": "108 N RICHARDS ST",
    "dropphycty": "ORFORDVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535769464,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORFORDVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535769998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088792572,
    "dropsitcph": 6088792572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17791",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "119 N CASCADE ST",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "WI",
    "dropdelzpp": 540207000,
    "dropphyadd": "119 N CASCADE ST",
    "dropphycty": "OSCEOLA",
    "dropphyst": "WI",
    "dropphyzpp": 540207000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "WI",
    "dropmalzpp": 540209998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152943613,
    "dropfax": 7152943449
  },
  {
    "dcode": "D",
    "dropkey": "PY17793",
    "droptype": "D",
    "dropname": "OSHKOSH",
    "dropdeladd": "1025 W 20TH AVE",
    "dropdelcty": "OSHKOSH",
    "dropdelst": "WI",
    "dropdelzpp": 549039998,
    "dropphyadd": "1025 W 20TH AVE",
    "dropphycty": "OSHKOSH",
    "dropphyst": "WI",
    "dropphyzpp": 549039998,
    "dropmaladd": "1025 W 20TH AVE",
    "dropmalcty": "OSHKOSH",
    "dropmalst": "WI",
    "dropmalzpp": 549039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202360249,
    "dropsitcph": 9202360627,
    "dropfax": 9202368703
  },
  {
    "dcode": "D",
    "dropkey": "PY17794",
    "droptype": "D",
    "dropname": "OSSEO",
    "dropdeladd": "50669 HARMONY ST",
    "dropdelcty": "OSSEO",
    "dropdelst": "WI",
    "dropdelzpp": 547587532,
    "dropphyadd": "50669 HARMONY ST",
    "dropphycty": "OSSEO",
    "dropphyst": "WI",
    "dropphyzpp": 547587532,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSSEO",
    "dropmalst": "WI",
    "dropmalzpp": 547589998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155972018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17795",
    "droptype": "D",
    "dropname": "OWEN",
    "dropdeladd": "320 N CENTRAL AVE",
    "dropdelcty": "OWEN",
    "dropdelst": "WI",
    "dropdelzpp": 544609732,
    "dropphyadd": "320 N CENTRAL AVE",
    "dropphycty": "OWEN",
    "dropphyst": "WI",
    "dropphyzpp": 544609732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OWEN",
    "dropmalst": "WI",
    "dropmalzpp": 544609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152292949,
    "dropsitcph": 7152292949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17796",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "119 E ORMSBY ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "WI",
    "dropdelzpp": 539529045,
    "dropphyadd": "119 E ORMSBY ST",
    "dropphycty": "OXFORD",
    "dropphyst": "WI",
    "dropphyzpp": 539529045,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OXFORD",
    "dropmalst": "WI",
    "dropmalzpp": 539529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085864357,
    "dropsitcph": 6085864357,
    "dropfax": 6085864727
  },
  {
    "dcode": "D",
    "dropkey": "PY17797",
    "droptype": "D",
    "dropname": "PACKWAUKEE",
    "dropdeladd": "W5981 MAIN ST",
    "dropdelcty": "PACKWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 539539700,
    "dropphyadd": "W5981 MAIN ST",
    "dropphycty": "PACKWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 539539700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACKWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 539539998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085895342,
    "dropsitcph": 6085895342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17799",
    "droptype": "D",
    "dropname": "PALMYRA",
    "dropdeladd": "116 N 3RD ST",
    "dropdelcty": "PALMYRA",
    "dropdelst": "WI",
    "dropdelzpp": 531569347,
    "dropphyadd": "116 N 3RD ST",
    "dropphycty": "PALMYRA",
    "dropphyst": "WI",
    "dropphyzpp": 531569347,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMYRA",
    "dropmalst": "WI",
    "dropmalzpp": 531569998,
    "dropsitphn": 4143637741,
    "dropsitlph": 4142702120,
    "dropsitcph": 2624952784,
    "dropfax": 2624952358
  },
  {
    "dcode": "D",
    "dropkey": "PY17800",
    "droptype": "D",
    "dropname": "PARDEEVILLE",
    "dropdeladd": "107 INDUSTRIAL DR",
    "dropdelcty": "PARDEEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 539548830,
    "dropphyadd": "107 INDUSTRIAL DR",
    "dropphycty": "PARDEEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 539548830,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARDEEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 539549998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084294331,
    "dropsitcph": 6084294331,
    "dropfax": 6084293480
  },
  {
    "dcode": "D",
    "dropkey": "PY17801",
    "droptype": "D",
    "dropname": "PARK FALLS",
    "dropdeladd": "109 1ST ST N",
    "dropdelcty": "PARK FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 545529998,
    "dropphyadd": "109 1ST ST N",
    "dropphycty": "PARK FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 545529998,
    "dropmaladd": "109 1ST ST N",
    "dropmalcty": "PARK FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 545529998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157624575,
    "dropsitcph": 7157624575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17805",
    "droptype": "D",
    "dropname": "PATCH GROVE",
    "dropdeladd": "306 MAIN ST",
    "dropdelcty": "PATCH GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 538179701,
    "dropphyadd": "306 MAIN ST",
    "dropphycty": "PATCH GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 538179701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATCH GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 538179998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089942582,
    "dropsitcph": 6089942582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17808",
    "droptype": "D",
    "dropname": "PELICAN LAKE",
    "dropdeladd": "737 USH 45",
    "dropdelcty": "PELICAN LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 544639997,
    "dropphyadd": "737 USH 45",
    "dropphycty": "PELICAN LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 544639997,
    "dropmaladd": "737 USH 45",
    "dropmalcty": "PELICAN LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 544639997,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154875574,
    "dropsitcph": 7154875574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17809",
    "droptype": "D",
    "dropname": "PELL LAKE",
    "dropdeladd": "N1265 PARK RD",
    "dropdelcty": "PELL LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 531579800,
    "dropphyadd": "N1265 PARK RD",
    "dropphycty": "PELL LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 531579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PELL LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 531579998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622795675,
    "dropfax": 2622793920
  },
  {
    "dcode": "D",
    "dropkey": "PY17810",
    "droptype": "D",
    "dropname": "PEMBINE",
    "dropdeladd": "N18656 US HIGHWAY 141",
    "dropdelcty": "PEMBINE",
    "dropdelst": "WI",
    "dropdelzpp": 541569800,
    "dropphyadd": "N18656 US HIGHWAY 141",
    "dropphycty": "PEMBINE",
    "dropphyst": "WI",
    "dropphyzpp": 541569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEMBINE",
    "dropmalst": "WI",
    "dropmalzpp": 541569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153245700,
    "dropsitcph": 7153245700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17813",
    "droptype": "D",
    "dropname": "PEPIN",
    "dropdeladd": "420 2ND ST",
    "dropdelcty": "PEPIN",
    "dropdelst": "WI",
    "dropdelzpp": 547599702,
    "dropphyadd": "420 2ND ST",
    "dropphycty": "PEPIN",
    "dropphyst": "WI",
    "dropphyzpp": 547599702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEPIN",
    "dropmalst": "WI",
    "dropmalzpp": 547599998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152737385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17816",
    "droptype": "D",
    "dropname": "PESHTIGO",
    "dropdeladd": "201 W FRONT ST",
    "dropdelcty": "PESHTIGO",
    "dropdelst": "WI",
    "dropdelzpp": 541579998,
    "dropphyadd": "201 W FRONT ST",
    "dropphycty": "PESHTIGO",
    "dropphyst": "WI",
    "dropphyzpp": 541579998,
    "dropmaladd": "201 W FRONT ST",
    "dropmalcty": "PESHTIGO",
    "dropmalst": "WI",
    "dropmalzpp": 541579998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155823330,
    "dropsitcph": 7155823330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17817",
    "droptype": "D",
    "dropname": "PEWAUKEE",
    "dropdeladd": "140 SIMMONS AVE",
    "dropdelcty": "PEWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 530729998,
    "dropphyadd": "140 SIMMONS AVE",
    "dropphycty": "PEWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 530729998,
    "dropmaladd": "140 SIMMONS AVE",
    "dropmalcty": "PEWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 530729998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626913289,
    "dropsitcph": 2626913253,
    "dropfax": 2626914890
  },
  {
    "dcode": "D",
    "dropkey": "PY17818",
    "droptype": "D",
    "dropname": "PHELPS",
    "dropdeladd": "4530 COUNTY RD E",
    "dropdelcty": "PHELPS",
    "dropdelst": "WI",
    "dropdelzpp": 545549800,
    "dropphyadd": "4530 COUNTY RD E",
    "dropphycty": "PHELPS",
    "dropphyst": "WI",
    "dropphyzpp": 545549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHELPS",
    "dropmalst": "WI",
    "dropmalzpp": 545549998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155452548,
    "dropsitcph": 7155452548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17819",
    "droptype": "D",
    "dropname": "PHILLIPS",
    "dropdeladd": "194 N AVON AVE",
    "dropdelcty": "PHILLIPS",
    "dropdelst": "WI",
    "dropdelzpp": 545559998,
    "dropphyadd": "194 N AVON AVE",
    "dropphycty": "PHILLIPS",
    "dropphyst": "WI",
    "dropphyzpp": 545559998,
    "dropmaladd": "194 N AVON AVE",
    "dropmalcty": "PHILLIPS",
    "dropmalst": "WI",
    "dropmalzpp": 545559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153392368,
    "dropsitcph": 7153392368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17821",
    "droptype": "D",
    "dropname": "PICKEREL",
    "dropdeladd": "N9238 STATE HIGHWAY 55",
    "dropdelcty": "PICKEREL",
    "dropdelst": "WI",
    "dropdelzpp": 544659712,
    "dropphyadd": "N9238 STATE HIGHWAY 55",
    "dropphycty": "PICKEREL",
    "dropphyst": "WI",
    "dropphyzpp": 544659712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PICKEREL",
    "dropmalst": "WI",
    "dropmalzpp": 544659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154842655,
    "dropsitcph": 7154842655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17822",
    "droptype": "D",
    "dropname": "PICKETT",
    "dropdeladd": "6642 STATE ROAD 44",
    "dropdelcty": "PICKETT",
    "dropdelst": "WI",
    "dropdelzpp": 549649570,
    "dropphyadd": "6642 STATE ROAD 44",
    "dropphycty": "PICKETT",
    "dropphyst": "WI",
    "dropphyzpp": 549649570,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PICKETT",
    "dropmalst": "WI",
    "dropmalzpp": 549649998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205892501,
    "dropsitcph": 9205892501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17823",
    "droptype": "D",
    "dropname": "PIGEON FALLS",
    "dropdeladd": "40195 WINSAND DR STE 5",
    "dropdelcty": "PIGEON FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 547604400,
    "dropphyadd": "40195 WINSAND DR STE 5",
    "dropphycty": "PIGEON FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 547604400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIGEON FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 547609998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159835520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17827",
    "droptype": "D",
    "dropname": "PINE RIVER",
    "dropdeladd": "N4712 COUNTY RD E",
    "dropdelcty": "PINE RIVER",
    "dropdelst": "WI",
    "dropdelzpp": 549659490,
    "dropphyadd": "N4712 COUNTY RD E",
    "dropphycty": "PINE RIVER",
    "dropphyst": "WI",
    "dropphyzpp": 549659490,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE RIVER",
    "dropmalst": "WI",
    "dropmalzpp": 549659998,
    "dropsitphn": 9209875403,
    "dropsitlph": 9209875403,
    "dropsitcph": 9209875403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17828",
    "droptype": "D",
    "dropname": "PITTSVILLE",
    "dropdeladd": "8250 MAIN ST",
    "dropdelcty": "PITTSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 544669800,
    "dropphyadd": "8250 MAIN ST",
    "dropphycty": "PITTSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 544669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PITTSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 544669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158842307,
    "dropsitcph": 7158842307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17829",
    "droptype": "D",
    "dropname": "PLAIN",
    "dropdeladd": "1050 MAIN ST",
    "dropdelcty": "PLAIN",
    "dropdelst": "WI",
    "dropdelzpp": 535779667,
    "dropphyadd": "1050 MAIN ST",
    "dropphycty": "PLAIN",
    "dropphyst": "WI",
    "dropphyzpp": 535779667,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAIN",
    "dropmalst": "WI",
    "dropmalzpp": 535779998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085463731,
    "dropsitcph": 6085463731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17830",
    "droptype": "D",
    "dropname": "PLAINFIELD",
    "dropdeladd": "110 W NORTH ST",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 549669739,
    "dropphyadd": "110 W NORTH ST",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 549669739,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 549669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153356741,
    "dropsitcph": 7153356741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17831",
    "droptype": "D",
    "dropname": "PLATTEVILLE",
    "dropdeladd": "85 S COURT ST",
    "dropdelcty": "PLATTEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 538189998,
    "dropphyadd": "85 S COURT ST",
    "dropphycty": "PLATTEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 538189998,
    "dropmaladd": "85 S COURT ST",
    "dropmalcty": "PLATTEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 538189998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083482181,
    "dropsitcph": 6083482181,
    "dropfax": 6083482386
  },
  {
    "dcode": "D",
    "dropkey": "PY17833",
    "droptype": "D",
    "dropname": "PLEASANT PRAIRIE",
    "dropdeladd": "4225 101ST ST",
    "dropdelcty": "PLEASANT PRAIRIE",
    "dropdelst": "WI",
    "dropdelzpp": 531589997,
    "dropphyadd": "4225 101ST ST",
    "dropphycty": "PLEASANT PRAIRIE",
    "dropphyst": "WI",
    "dropphyzpp": 531589997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT PRAIRIE",
    "dropmalst": "WI",
    "dropmalzpp": 531589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626946013,
    "dropsitcph": 2626946013,
    "dropfax": 2626974970
  },
  {
    "dcode": "D",
    "dropkey": "PY17835",
    "droptype": "D",
    "dropname": "PLOVER",
    "dropdeladd": "2601 POST RD",
    "dropdelcty": "PLOVER",
    "dropdelst": "WI",
    "dropdelzpp": 544679998,
    "dropphyadd": "2601 POST RD",
    "dropphycty": "PLOVER",
    "dropphyst": "WI",
    "dropphyzpp": 544679998,
    "dropmaladd": "2601 POST RD",
    "dropmalcty": "PLOVER",
    "dropmalst": "WI",
    "dropmalzpp": 544679998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153447342,
    "dropsitcph": 7153447342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17836",
    "droptype": "D",
    "dropname": "PLUM CITY",
    "dropdeladd": "610 1ST ST",
    "dropdelcty": "PLUM CITY",
    "dropdelst": "WI",
    "dropdelzpp": 547619003,
    "dropphyadd": "610 1ST ST",
    "dropphycty": "PLUM CITY",
    "dropphyst": "WI",
    "dropphyzpp": 547619003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLUM CITY",
    "dropmalst": "WI",
    "dropmalzpp": 547619998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156473041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17838",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "302 E MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "WI",
    "dropdelzpp": 530739998,
    "dropphyadd": "302 E MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "WI",
    "dropphyzpp": 530739998,
    "dropmaladd": "302 E MAIN ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "WI",
    "dropmalzpp": 530739998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9208928859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17843",
    "droptype": "D",
    "dropname": "POPLAR",
    "dropdeladd": "9683 E MAIN ST",
    "dropdelcty": "POPLAR",
    "dropdelst": "WI",
    "dropdelzpp": 548644404,
    "dropphyadd": "9683 E MAIN ST",
    "dropphycty": "POPLAR",
    "dropphyst": "WI",
    "dropphyzpp": 548644404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POPLAR",
    "dropmalst": "WI",
    "dropmalzpp": 548649998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153643100,
    "dropfax": 7153643047
  },
  {
    "dcode": "D",
    "dropkey": "PY17845",
    "droptype": "D",
    "dropname": "PORT EDWARDS",
    "dropdeladd": "160 MARKET AVE",
    "dropdelcty": "PORT EDWARDS",
    "dropdelst": "WI",
    "dropdelzpp": 544699998,
    "dropphyadd": "160 MARKET AVE",
    "dropphycty": "PORT EDWARDS",
    "dropphyst": "WI",
    "dropphyzpp": 544699998,
    "dropmaladd": "160 MARKET AVE",
    "dropmalcty": "PORT EDWARDS",
    "dropmalst": "WI",
    "dropmalzpp": 544699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158873611,
    "dropsitcph": 7158873611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17846",
    "droptype": "D",
    "dropname": "PORT WASHINGTON",
    "dropdeladd": "104 E MAIN ST",
    "dropdelcty": "PORT WASHINGTON",
    "dropdelst": "WI",
    "dropdelzpp": 530749998,
    "dropphyadd": "104 E MAIN ST",
    "dropphycty": "PORT WASHINGTON",
    "dropphyst": "WI",
    "dropphyzpp": 530749998,
    "dropmaladd": "104 E MAIN ST",
    "dropmalcty": "PORT WASHINGTON",
    "dropmalst": "WI",
    "dropmalzpp": 530749998,
    "dropsitphn": 2622845526,
    "dropsitlph": 2622683825,
    "dropsitcph": 2622845526,
    "dropfax": 2622842104
  },
  {
    "dcode": "D",
    "dropkey": "PY17847",
    "droptype": "D",
    "dropname": "PORT WING",
    "dropdeladd": "83320 WASHINGTON AVE",
    "dropdelcty": "PORT WING",
    "dropdelst": "WI",
    "dropdelzpp": 548654400,
    "dropphyadd": "83320 WASHINGTON AVE",
    "dropphycty": "PORT WING",
    "dropphyst": "WI",
    "dropphyzpp": 548654400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT WING",
    "dropmalst": "WI",
    "dropmalzpp": 548659998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157743615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17849",
    "droptype": "D",
    "dropname": "PORTAGE",
    "dropdeladd": "215 W CONANT ST",
    "dropdelcty": "PORTAGE",
    "dropdelst": "WI",
    "dropdelzpp": 539019998,
    "dropphyadd": "215 W CONANT ST",
    "dropphycty": "PORTAGE",
    "dropphyst": "WI",
    "dropphyzpp": 539019998,
    "dropmaladd": "215 W CONANT ST",
    "dropmalcty": "PORTAGE",
    "dropmalst": "WI",
    "dropmalzpp": 539019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087425012,
    "dropsitcph": 6087425012,
    "dropfax": 6087428669
  },
  {
    "dcode": "D",
    "dropkey": "PY17850",
    "droptype": "D",
    "dropname": "PORTERFIELD",
    "dropdeladd": "N5450 COUNTY RD E",
    "dropdelcty": "PORTERFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 541599701,
    "dropphyadd": "N5450 COUNTY RD E",
    "dropphycty": "PORTERFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 541599701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTERFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 541599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157892407,
    "dropsitcph": 7157892407,
    "dropfax": 7157892407
  },
  {
    "dcode": "D",
    "dropkey": "PY17854",
    "droptype": "D",
    "dropname": "POTOSI",
    "dropdeladd": "101 EAST ST",
    "dropdelcty": "POTOSI",
    "dropdelst": "WI",
    "dropdelzpp": 538209310,
    "dropphyadd": "101 EAST ST",
    "dropphycty": "POTOSI",
    "dropphyst": "WI",
    "dropphyzpp": 538209310,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTOSI",
    "dropmalst": "WI",
    "dropmalzpp": 538209998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087632202,
    "dropsitcph": 6087632202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17855",
    "droptype": "D",
    "dropname": "POTTER",
    "dropdeladd": "198 MAIN ST",
    "dropdelcty": "POTTER",
    "dropdelst": "WI",
    "dropdelzpp": 541609800,
    "dropphyadd": "198 MAIN ST",
    "dropphycty": "POTTER",
    "dropphyst": "WI",
    "dropphyzpp": 541609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POTTER",
    "dropmalst": "WI",
    "dropmalzpp": 541609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208533092,
    "dropsitcph": 9208533092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17856",
    "droptype": "D",
    "dropname": "POUND",
    "dropdeladd": "1018 COUNTY ROAD Q",
    "dropdelcty": "POUND",
    "dropdelst": "WI",
    "dropdelzpp": 541619736,
    "dropphyadd": "1018 COUNTY ROAD Q",
    "dropphycty": "POUND",
    "dropphyst": "WI",
    "dropphyzpp": 541619736,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POUND",
    "dropmalst": "WI",
    "dropmalzpp": 541619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208972698,
    "dropsitcph": 9208972698,
    "dropfax": 9208972698
  },
  {
    "dcode": "D",
    "dropkey": "PY17857",
    "droptype": "D",
    "dropname": "POWERS LAKE",
    "dropdeladd": "39922 BLOOMFIELD RD",
    "dropdelcty": "POWERS LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 531599800,
    "dropphyadd": "39922 BLOOMFIELD RD",
    "dropphycty": "POWERS LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 531599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POWERS LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 531599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622793433,
    "dropfax": 2622793814
  },
  {
    "dcode": "D",
    "dropkey": "PY17858",
    "droptype": "D",
    "dropname": "POY SIPPI",
    "dropdeladd": "N4396 STATE ROAD 49",
    "dropdelcty": "POY SIPPI",
    "dropdelst": "WI",
    "dropdelzpp": 549678101,
    "dropphyadd": "N4396 STATE ROAD 49",
    "dropphycty": "POY SIPPI",
    "dropphyst": "WI",
    "dropphyzpp": 549678101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POY SIPPI",
    "dropmalst": "WI",
    "dropmalzpp": 549679998,
    "dropsitphn": 9209875388,
    "dropsitlph": 9209875388,
    "dropsitcph": 9209875388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17859",
    "droptype": "D",
    "dropname": "POYNETTE",
    "dropdeladd": "128 E SEWARD ST",
    "dropdelcty": "POYNETTE",
    "dropdelst": "WI",
    "dropdelzpp": 539558980,
    "dropphyadd": "128 E SEWARD ST",
    "dropphycty": "POYNETTE",
    "dropphyst": "WI",
    "dropphyzpp": 539558980,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POYNETTE",
    "dropmalst": "WI",
    "dropmalzpp": 539559998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086352623,
    "dropsitcph": 6086352623,
    "dropfax": 6086354373
  },
  {
    "dcode": "D",
    "dropkey": "PY17860",
    "droptype": "D",
    "dropname": "PRAIRIE DU CHIEN",
    "dropdeladd": "120 S BEAUMONT RD",
    "dropdelcty": "PRAIRIE DU CHIEN",
    "dropdelst": "WI",
    "dropdelzpp": 538219998,
    "dropphyadd": "120 S BEAUMONT RD",
    "dropphycty": "PRAIRIE DU CHIEN",
    "dropphyst": "WI",
    "dropphyzpp": 538219998,
    "dropmaladd": "120 S BEAUMONT RD",
    "dropmalcty": "PRAIRIE DU CHIEN",
    "dropmalst": "WI",
    "dropmalzpp": 538219998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6083266914,
    "dropsitcph": 6083266914,
    "dropfax": 6083264998
  },
  {
    "dcode": "D",
    "dropkey": "PY17861",
    "droptype": "D",
    "dropname": "PRAIRIE DU SAC",
    "dropdeladd": "285 WASHINGTON ST",
    "dropdelcty": "PRAIRIE DU SAC",
    "dropdelst": "WI",
    "dropdelzpp": 535789998,
    "dropphyadd": "285 WASHINGTON ST",
    "dropphycty": "PRAIRIE DU SAC",
    "dropphyst": "WI",
    "dropphyzpp": 535789998,
    "dropmaladd": "285 WASHINGTON ST",
    "dropmalcty": "PRAIRIE DU SAC",
    "dropmalst": "WI",
    "dropmalzpp": 535789998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086436930,
    "dropsitcph": 6086436930,
    "dropfax": 6086430605
  },
  {
    "dcode": "D",
    "dropkey": "PY17862",
    "droptype": "D",
    "dropname": "PRAIRIE FARM",
    "dropdeladd": "125 HEPBURN ST W",
    "dropdelcty": "PRAIRIE FARM",
    "dropdelst": "WI",
    "dropdelzpp": 547624400,
    "dropphyadd": "125 HEPBURN ST W",
    "dropphycty": "PRAIRIE FARM",
    "dropphyst": "WI",
    "dropphyzpp": 547624400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRAIRIE FARM",
    "dropmalst": "WI",
    "dropmalzpp": 547629998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154551097,
    "dropfax": 7154551097
  },
  {
    "dcode": "D",
    "dropkey": "PY17865",
    "droptype": "D",
    "dropname": "PRENTICE",
    "dropdeladd": "428 CENTER ST",
    "dropdelcty": "PRENTICE",
    "dropdelst": "WI",
    "dropdelzpp": 545569997,
    "dropphyadd": "428 CENTER ST",
    "dropphycty": "PRENTICE",
    "dropphyst": "WI",
    "dropphyzpp": 545569997,
    "dropmaladd": "428 CENTER ST",
    "dropmalcty": "PRENTICE",
    "dropmalst": "WI",
    "dropmalzpp": 545569997,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154282310,
    "dropsitcph": 7154282310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17866",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "1001 CAMPBELL ST N",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "WI",
    "dropdelzpp": 540211019,
    "dropphyadd": "1001 CAMPBELL ST N",
    "dropphycty": "PRESCOTT",
    "dropphyst": "WI",
    "dropphyzpp": 540211019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "WI",
    "dropmalzpp": 540219998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152625166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17867",
    "droptype": "D",
    "dropname": "PRESQUE ISLE",
    "dropdeladd": "8302 MAIN ST",
    "dropdelcty": "PRESQUE ISLE",
    "dropdelst": "WI",
    "dropdelzpp": 545579800,
    "dropphyadd": "8302 MAIN ST",
    "dropphycty": "PRESQUE ISLE",
    "dropphyst": "WI",
    "dropphyzpp": 545579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESQUE ISLE",
    "dropmalst": "WI",
    "dropmalzpp": 545579998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156862240,
    "dropsitcph": 7156862240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17868",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "111 S PEARL ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "WI",
    "dropdelzpp": 549689155,
    "dropphyadd": "111 S PEARL ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "WI",
    "dropphyzpp": 549689155,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRINCETON",
    "dropmalst": "WI",
    "dropmalzpp": 549689998,
    "dropsitphn": 9202953609,
    "dropsitlph": 9202953609,
    "dropsitcph": 9202953609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17872",
    "droptype": "D",
    "dropname": "PULASKI",
    "dropdeladd": "306 S SAINT AUGUSTINE ST",
    "dropdelcty": "PULASKI",
    "dropdelst": "WI",
    "dropdelzpp": 541628100,
    "dropphyadd": "306 S SAINT AUGUSTINE ST",
    "dropphycty": "PULASKI",
    "dropphyst": "WI",
    "dropphyzpp": 541628100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PULASKI",
    "dropmalst": "WI",
    "dropmalzpp": 541629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208225666,
    "dropsitcph": 9208225666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17874",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "603 MAIN ST",
    "dropdelcty": "RACINE",
    "dropdelst": "WI",
    "dropdelzpp": 534039998,
    "dropphyadd": "603 MAIN ST",
    "dropphycty": "RACINE",
    "dropphyst": "WI",
    "dropphyzpp": 534039998,
    "dropmaladd": "603 MAIN ST",
    "dropmalcty": "RACINE",
    "dropmalst": "WI",
    "dropmalzpp": 534039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626326214,
    "dropsitcph": 2626326214,
    "dropfax": 2626321710
  },
  {
    "dcode": "D",
    "dropkey": "PY17875",
    "droptype": "D",
    "dropname": "RADISSON",
    "dropdeladd": "3711 N CLARK ST",
    "dropdelcty": "RADISSON",
    "dropdelst": "WI",
    "dropdelzpp": 548677013,
    "dropphyadd": "3711 N CLARK ST",
    "dropphycty": "RADISSON",
    "dropphyst": "WI",
    "dropphyzpp": 548677013,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RADISSON",
    "dropmalst": "WI",
    "dropmalzpp": 548679998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153540382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17877",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "126 W STROUD ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "WI",
    "dropdelzpp": 539569998,
    "dropphyadd": "126 W STROUD ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "WI",
    "dropphyzpp": 539569998,
    "dropmaladd": "126 W STROUD ST",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "WI",
    "dropmalzpp": 539569998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203263414,
    "dropsitcph": 9203263414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17878",
    "droptype": "D",
    "dropname": "RANDOM LAKE",
    "dropdeladd": "220 ALLEN ST",
    "dropdelcty": "RANDOM LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 530751816,
    "dropphyadd": "220 ALLEN ST",
    "dropphycty": "RANDOM LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 530751816,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOM LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 530759998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209949221,
    "dropsitcph": 9209949221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17880",
    "droptype": "D",
    "dropname": "READFIELD",
    "dropdeladd": "E9090 STATE ROAD 96",
    "dropdelcty": "READFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 549699800,
    "dropphyadd": "E9090 STATE ROAD 96",
    "dropphycty": "READFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 549699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "READFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 549699998,
    "dropsitphn": 9202702120,
    "dropsitlph": 9206674331,
    "dropsitcph": 9206674331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17881",
    "droptype": "D",
    "dropname": "READSTOWN",
    "dropdeladd": "120 N 4TH ST",
    "dropdelcty": "READSTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 546527070,
    "dropphyadd": "120 N 4TH ST",
    "dropphycty": "READSTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 546527070,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "READSTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 546529998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086295519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17884",
    "droptype": "D",
    "dropname": "REDGRANITE",
    "dropdeladd": "130 E BANNERMAN AVE",
    "dropdelcty": "REDGRANITE",
    "dropdelst": "WI",
    "dropdelzpp": 549709380,
    "dropphyadd": "130 E BANNERMAN AVE",
    "dropphycty": "REDGRANITE",
    "dropphyst": "WI",
    "dropphyzpp": 549709380,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDGRANITE",
    "dropmalst": "WI",
    "dropmalzpp": 549709998,
    "dropsitphn": 9205662870,
    "dropsitlph": 9205662870,
    "dropsitcph": 9205662870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17886",
    "droptype": "D",
    "dropname": "REEDSBURG",
    "dropdeladd": "215 N WALNUT ST",
    "dropdelcty": "REEDSBURG",
    "dropdelst": "WI",
    "dropdelzpp": 539599998,
    "dropphyadd": "215 N WALNUT ST",
    "dropphycty": "REEDSBURG",
    "dropphyst": "WI",
    "dropphyzpp": 539599998,
    "dropmaladd": "215 N WALNUT ST",
    "dropmalcty": "REEDSBURG",
    "dropmalst": "WI",
    "dropmalzpp": 539599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085242211,
    "dropsitcph": 6085242211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17887",
    "droptype": "D",
    "dropname": "REEDSVILLE",
    "dropdeladd": "104 MILL ST",
    "dropdelcty": "REEDSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 542301700,
    "dropphyadd": "104 MILL ST",
    "dropphycty": "REEDSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 542301700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REEDSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 542309998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207544228,
    "dropsitcph": 9207544228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17888",
    "droptype": "D",
    "dropname": "REESEVILLE",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "REESEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535799667,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "REESEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535799667,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REESEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209273696,
    "dropsitcph": 9209273696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17891",
    "droptype": "D",
    "dropname": "REWEY",
    "dropdeladd": "511 MAIN ST",
    "dropdelcty": "REWEY",
    "dropdelst": "WI",
    "dropdelzpp": 535809672,
    "dropphyadd": "511 MAIN ST",
    "dropphycty": "REWEY",
    "dropphyst": "WI",
    "dropphyzpp": 535809672,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REWEY",
    "dropmalst": "WI",
    "dropmalzpp": 535809998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089438188,
    "dropsitcph": 6089438188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17893",
    "droptype": "D",
    "dropname": "RHINELANDER",
    "dropdeladd": "156 S COURTNEY ST",
    "dropdelcty": "RHINELANDER",
    "dropdelst": "WI",
    "dropdelzpp": 545019998,
    "dropphyadd": "156 S COURTNEY ST",
    "dropphycty": "RHINELANDER",
    "dropphyst": "WI",
    "dropphyzpp": 545019998,
    "dropmaladd": "156 S COURTNEY ST",
    "dropmalcty": "RHINELANDER",
    "dropmalst": "WI",
    "dropmalzpp": 545019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153696813,
    "dropsitcph": 7153696813,
    "dropfax": 7153697319
  },
  {
    "dcode": "D",
    "dropkey": "PY17895",
    "droptype": "D",
    "dropname": "RIB LAKE",
    "dropdeladd": "705 MCCOMB AVE",
    "dropdelcty": "RIB LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 544709800,
    "dropphyadd": "705 MCCOMB AVE",
    "dropphycty": "RIB LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 544709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIB LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 544709998,
    "dropsitphn": 7154005291,
    "dropsitlph": 7154005291,
    "dropsitcph": 7154005291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17897",
    "droptype": "D",
    "dropname": "RICE LAKE",
    "dropdeladd": "14 E EAU CLAIRE ST",
    "dropdelcty": "RICE LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 548689942,
    "dropphyadd": "14 E EAU CLAIRE ST",
    "dropphycty": "RICE LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 548689942,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICE LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 548689998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152343553,
    "dropfax": 7152345920
  },
  {
    "dcode": "D",
    "dropkey": "PY17899",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "1925 STATE ROAD 175",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 530769998,
    "dropphyadd": "1925 STATE ROAD 175",
    "dropphycty": "RICHFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 530769998,
    "dropmaladd": "1925 STATE ROAD 175",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 530769998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626281398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17901",
    "droptype": "D",
    "dropname": "RICHLAND CENTER",
    "dropdeladd": "213 N CENTRAL AVE",
    "dropdelcty": "RICHLAND CENTER",
    "dropdelst": "WI",
    "dropdelzpp": 535819998,
    "dropphyadd": "213 N CENTRAL AVE",
    "dropphycty": "RICHLAND CENTER",
    "dropphyst": "WI",
    "dropphyzpp": 535819998,
    "dropmaladd": "213 N CENTRAL AVE",
    "dropmalcty": "RICHLAND CENTER",
    "dropmalst": "WI",
    "dropmalzpp": 535819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086472060,
    "dropsitcph": 6086472060,
    "dropfax": 6085706003
  },
  {
    "dcode": "D",
    "dropkey": "PY17903",
    "droptype": "D",
    "dropname": "RIDGELAND",
    "dropdeladd": "105 N DIAMOND ST",
    "dropdelcty": "RIDGELAND",
    "dropdelst": "WI",
    "dropdelzpp": 547634400,
    "dropphyadd": "105 N DIAMOND ST",
    "dropphycty": "RIDGELAND",
    "dropphyst": "WI",
    "dropphyzpp": 547634400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGELAND",
    "dropmalst": "WI",
    "dropmalzpp": 547639998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159491290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17904",
    "droptype": "D",
    "dropname": "RIDGEWAY",
    "dropdeladd": "613 MAIN ST",
    "dropdelcty": "RIDGEWAY",
    "dropdelst": "WI",
    "dropdelzpp": 535829711,
    "dropphyadd": "613 MAIN ST",
    "dropphycty": "RIDGEWAY",
    "dropphyst": "WI",
    "dropphyzpp": 535829711,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGEWAY",
    "dropmalst": "WI",
    "dropmalzpp": 535829998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089246040,
    "dropsitcph": 6089246040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17905",
    "droptype": "D",
    "dropname": "RINGLE",
    "dropdeladd": "169915 BRICKYARD DR",
    "dropdelcty": "RINGLE",
    "dropdelst": "WI",
    "dropdelzpp": 54471,
    "dropphyadd": "169915 BRICKYARD DR",
    "dropphycty": "RINGLE",
    "dropphyst": "WI",
    "dropphyzpp": 54471,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RINGLE",
    "dropmalst": "WI",
    "dropmalzpp": 544719998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154463766,
    "dropsitcph": 7154463766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17906",
    "droptype": "D",
    "dropname": "RIO",
    "dropdeladd": "103 LINCOLN AVE",
    "dropdelcty": "RIO",
    "dropdelst": "WI",
    "dropdelzpp": 539609365,
    "dropphyadd": "103 LINCOLN AVE",
    "dropphycty": "RIO",
    "dropphyst": "WI",
    "dropphyzpp": 539609365,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIO",
    "dropmalst": "WI",
    "dropmalzpp": 539609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209925311,
    "dropsitcph": 9209925311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17909",
    "droptype": "D",
    "dropname": "RIPON",
    "dropdeladd": "220 BLACKBURN ST",
    "dropdelcty": "RIPON",
    "dropdelst": "WI",
    "dropdelzpp": 549719998,
    "dropphyadd": "220 BLACKBURN ST",
    "dropphycty": "RIPON",
    "dropphyst": "WI",
    "dropphyzpp": 549719998,
    "dropmaladd": "220 BLACKBURN ST",
    "dropmalcty": "RIPON",
    "dropmalst": "WI",
    "dropmalzpp": 549719998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207483287,
    "dropsitcph": 9207483287,
    "dropfax": 9207483922
  },
  {
    "dcode": "D",
    "dropkey": "PY17910",
    "droptype": "D",
    "dropname": "RIVER FALLS",
    "dropdeladd": "208 N 2ND ST",
    "dropdelcty": "RIVER FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 540222321,
    "dropphyadd": "208 N 2ND ST",
    "dropphycty": "RIVER FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 540222321,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVER FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 540229998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154250390,
    "dropfax": 7154257293
  },
  {
    "dcode": "D",
    "dropkey": "PY17913",
    "droptype": "D",
    "dropname": "ROBERTS",
    "dropdeladd": "300 N PARK ST",
    "dropdelcty": "ROBERTS",
    "dropdelst": "WI",
    "dropdelzpp": 540239782,
    "dropphyadd": "300 N PARK ST",
    "dropphycty": "ROBERTS",
    "dropphyst": "WI",
    "dropphyzpp": 540239782,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROBERTS",
    "dropmalst": "WI",
    "dropmalzpp": 540239998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157493766,
    "dropfax": 7157490185
  },
  {
    "dcode": "D",
    "dropkey": "PY17914",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "208 W MAIN ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "WI",
    "dropdelzpp": 531679800,
    "dropphyadd": "208 W MAIN ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "WI",
    "dropphyzpp": 531679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "WI",
    "dropmalzpp": 531679998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702021,
    "dropsitcph": 2625346100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17917",
    "droptype": "D",
    "dropname": "ROCK SPRINGS",
    "dropdeladd": "107 W BROADWAY",
    "dropdelcty": "ROCK SPRINGS",
    "dropdelst": "WI",
    "dropdelzpp": 539618043,
    "dropphyadd": "107 W BROADWAY",
    "dropphycty": "ROCK SPRINGS",
    "dropphyst": "WI",
    "dropphyzpp": 539618043,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK SPRINGS",
    "dropmalst": "WI",
    "dropmalzpp": 539619998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085225818,
    "dropsitcph": 6085225818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17919",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "102 S COMMERCIAL ST",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "WI",
    "dropdelzpp": 546538002,
    "dropphyadd": "102 S COMMERCIAL ST",
    "dropphycty": "ROCKLAND",
    "dropphyst": "WI",
    "dropphyzpp": 546538002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "WI",
    "dropmalzpp": 546539998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084864270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17922",
    "droptype": "D",
    "dropname": "ROSENDALE",
    "dropdeladd": "181 N GRANT ST",
    "dropdelcty": "ROSENDALE",
    "dropdelst": "WI",
    "dropdelzpp": 549749771,
    "dropphyadd": "181 N GRANT ST",
    "dropphycty": "ROSENDALE",
    "dropphyst": "WI",
    "dropphyzpp": 549749771,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSENDALE",
    "dropmalst": "WI",
    "dropmalzpp": 549749998,
    "dropsitphn": 9208722456,
    "dropsitlph": 9208722456,
    "dropsitcph": 9208722456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17923",
    "droptype": "D",
    "dropname": "ROSHOLT",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "ROSHOLT",
    "dropdelst": "WI",
    "dropdelzpp": 544739800,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "ROSHOLT",
    "dropphyst": "WI",
    "dropphyzpp": 544739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSHOLT",
    "dropmalst": "WI",
    "dropmalzpp": 544739998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156773226,
    "dropsitcph": 7153268053,
    "dropfax": 7153268058
  },
  {
    "dcode": "D",
    "dropkey": "PY17924",
    "droptype": "D",
    "dropname": "ROTHSCHILD",
    "dropdeladd": "29 BROWN BLVD",
    "dropdelcty": "ROTHSCHILD",
    "dropdelst": "WI",
    "dropdelzpp": 544749998,
    "dropphyadd": "29 BROWN BLVD",
    "dropphycty": "ROTHSCHILD",
    "dropphyst": "WI",
    "dropphyzpp": 544749998,
    "dropmaladd": "29 BROWN BLVD",
    "dropmalcty": "ROTHSCHILD",
    "dropmalst": "WI",
    "dropmalzpp": 544749998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153593444,
    "dropsitcph": 7153593444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17927",
    "droptype": "D",
    "dropname": "RUBICON",
    "dropdeladd": "W1219 ROME RD",
    "dropdelcty": "RUBICON",
    "dropdelst": "WI",
    "dropdelzpp": 530789998,
    "dropphyadd": "W1219 ROME RD",
    "dropphycty": "RUBICON",
    "dropphyst": "WI",
    "dropphyzpp": 530789998,
    "dropmaladd": "W1219 ROME RD",
    "dropmalcty": "RUBICON",
    "dropmalst": "WI",
    "dropmalzpp": 530789998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626733058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17928",
    "droptype": "D",
    "dropname": "RUDOLPH",
    "dropdeladd": "1570 MAIN ST",
    "dropdelcty": "RUDOLPH",
    "dropdelst": "WI",
    "dropdelzpp": 544759728,
    "dropphyadd": "1570 MAIN ST",
    "dropphycty": "RUDOLPH",
    "dropphyst": "WI",
    "dropphyzpp": 544759728,
    "dropmaladd": "1570 MAIN ST",
    "dropmalcty": "RUDOLPH",
    "dropmalst": "WI",
    "dropmalzpp": 544759728,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154353230,
    "dropsitcph": 7154353230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17932",
    "droptype": "D",
    "dropname": "SAINT CLOUD",
    "dropdeladd": "1008 MAIN ST",
    "dropdelcty": "SAINT CLOUD",
    "dropdelst": "WI",
    "dropdelzpp": 530791479,
    "dropphyadd": "1008 MAIN ST",
    "dropphycty": "SAINT CLOUD",
    "dropphyst": "WI",
    "dropphyzpp": 530791479,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT CLOUD",
    "dropmalst": "WI",
    "dropmalzpp": 530799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207533161,
    "dropsitcph": 9207533161,
    "dropfax": 9209993841
  },
  {
    "dcode": "D",
    "dropkey": "PY17933",
    "droptype": "D",
    "dropname": "SAINT CROIX FALLS",
    "dropdeladd": "113 S WASHINGTON ST",
    "dropdelcty": "SAINT CROIX FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 540244414,
    "dropphyadd": "113 S WASHINGTON ST",
    "dropphycty": "SAINT CROIX FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 540244414,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT CROIX FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 540249998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154834022,
    "dropfax": 7154831325
  },
  {
    "dcode": "D",
    "dropkey": "PY17935",
    "droptype": "D",
    "dropname": "SAINT GERMAIN",
    "dropdeladd": "415 SUNRISE LN",
    "dropdelcty": "SAINT GERMAIN",
    "dropdelst": "WI",
    "dropdelzpp": 545589800,
    "dropphyadd": "415 SUNRISE LN",
    "dropphycty": "SAINT GERMAIN",
    "dropphyst": "WI",
    "dropphyzpp": 545589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT GERMAIN",
    "dropmalst": "WI",
    "dropmalzpp": 545589998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154794091,
    "dropsitcph": 7154794091,
    "dropfax": 7154794091
  },
  {
    "dcode": "D",
    "dropkey": "PY17937",
    "droptype": "D",
    "dropname": "SAINT NAZIANZ",
    "dropdeladd": "106 E BIRCH ST",
    "dropdelcty": "SAINT NAZIANZ",
    "dropdelst": "WI",
    "dropdelzpp": 542329800,
    "dropphyadd": "106 E BIRCH ST",
    "dropphycty": "SAINT NAZIANZ",
    "dropphyst": "WI",
    "dropphyzpp": 542329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT NAZIANZ",
    "dropmalst": "WI",
    "dropmalzpp": 542329998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207732337,
    "dropsitcph": 9202349701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17938",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "24913 83RD PL",
    "dropdelcty": "SALEM",
    "dropdelst": "WI",
    "dropdelzpp": 531689080,
    "dropphyadd": "24913 83RD PL",
    "dropphycty": "SALEM",
    "dropphyst": "WI",
    "dropphyzpp": 531689080,
    "dropmaladd": "24913 83RD PL",
    "dropmalcty": "SALEM",
    "dropmalst": "WI",
    "dropmalzpp": 531689080,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702021,
    "dropsitcph": 2628432330,
    "dropfax": 2628431623
  },
  {
    "dcode": "D",
    "dropkey": "PY17942",
    "droptype": "D",
    "dropname": "SAND CREEK",
    "dropdeladd": "E9311 COUNTY ROAD I",
    "dropdelcty": "SAND CREEK",
    "dropdelst": "WI",
    "dropdelzpp": 547654400,
    "dropphyadd": "E9311 COUNTY ROAD I",
    "dropphycty": "SAND CREEK",
    "dropphyst": "WI",
    "dropphyzpp": 547654400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAND CREEK",
    "dropmalst": "WI",
    "dropmalzpp": 547659998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156581361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17944",
    "droptype": "D",
    "dropname": "SARONA",
    "dropdeladd": "W5340 RIPLEY RD",
    "dropdelcty": "SARONA",
    "dropdelst": "WI",
    "dropdelzpp": 548709021,
    "dropphyadd": "W5340 RIPLEY RD",
    "dropphycty": "SARONA",
    "dropphyst": "WI",
    "dropphyzpp": 548709021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARONA",
    "dropmalst": "WI",
    "dropmalzpp": 548709998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154693202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17945",
    "droptype": "D",
    "dropname": "SAUK CITY",
    "dropdeladd": "739 WATER ST",
    "dropdelcty": "SAUK CITY",
    "dropdelst": "WI",
    "dropdelzpp": 535839998,
    "dropphyadd": "739 WATER ST",
    "dropphycty": "SAUK CITY",
    "dropphyst": "WI",
    "dropphyzpp": 535839998,
    "dropmaladd": "739 WATER ST",
    "dropmalcty": "SAUK CITY",
    "dropmalst": "WI",
    "dropmalzpp": 535839998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086433217,
    "dropsitcph": 6086433217,
    "dropfax": 6086433217
  },
  {
    "dcode": "D",
    "dropkey": "PY17946",
    "droptype": "D",
    "dropname": "SAUKVILLE",
    "dropdeladd": "600 W DEKORA ST",
    "dropdelcty": "SAUKVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 530801685,
    "dropphyadd": "600 W DEKORA ST",
    "dropphycty": "SAUKVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 530801685,
    "dropmaladd": "600 W DEKORA ST",
    "dropmalcty": "SAUKVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 530801685,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622845527,
    "dropsitcph": 2622845523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17947",
    "droptype": "D",
    "dropname": "SAXEVILLE",
    "dropdeladd": "W4655 PORTAGE ST",
    "dropdelcty": "SAXEVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 549769800,
    "dropphyadd": "W4655 PORTAGE ST",
    "dropphycty": "SAXEVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 549769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAXEVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 549769998,
    "dropsitphn": 9206223544,
    "dropsitlph": 9206223544,
    "dropsitcph": 9206223544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17948",
    "droptype": "D",
    "dropname": "SAXON",
    "dropdeladd": "14277N STATE HIGHWAY 122",
    "dropdelcty": "SAXON",
    "dropdelst": "WI",
    "dropdelzpp": 545599565,
    "dropphyadd": "14277N STATE HIGHWAY 122",
    "dropphycty": "SAXON",
    "dropphyst": "WI",
    "dropphyzpp": 545599565,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAXON",
    "dropmalst": "WI",
    "dropmalzpp": 545599998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158932400,
    "dropsitcph": 7158932400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17949",
    "droptype": "D",
    "dropname": "SAYNER",
    "dropdeladd": "8726 SAYNER ST",
    "dropdelcty": "SAYNER",
    "dropdelst": "WI",
    "dropdelzpp": 545609634,
    "dropphyadd": "8726 SAYNER ST",
    "dropphycty": "SAYNER",
    "dropphyst": "WI",
    "dropphyzpp": 545609634,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAYNER",
    "dropmalst": "WI",
    "dropmalzpp": 545609998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155423360,
    "dropsitcph": 7155423360,
    "dropfax": 7155423360
  },
  {
    "dcode": "D",
    "dropkey": "PY17950",
    "droptype": "D",
    "dropname": "SCANDINAVIA",
    "dropdeladd": "345 N MAIN ST",
    "dropdelcty": "SCANDINAVIA",
    "dropdelst": "WI",
    "dropdelzpp": 549779307,
    "dropphyadd": "345 N MAIN ST",
    "dropphycty": "SCANDINAVIA",
    "dropphyst": "WI",
    "dropphyzpp": 549779307,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCANDINAVIA",
    "dropmalst": "WI",
    "dropmalzpp": 549779998,
    "dropsitphn": 7154672468,
    "dropsitlph": 7154672468,
    "dropsitcph": 7154672468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17952",
    "droptype": "D",
    "dropname": "SCHOFIELD",
    "dropdeladd": "5404 NORMANDY ST",
    "dropdelcty": "SCHOFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 544769998,
    "dropphyadd": "5404 NORMANDY ST",
    "dropphycty": "SCHOFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 544769998,
    "dropmaladd": "5404 NORMANDY ST",
    "dropmalcty": "SCHOFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 544769998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153593464,
    "dropsitcph": 7153593464,
    "dropfax": 7153557102
  },
  {
    "dcode": "D",
    "dropkey": "PY17955",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "SENECA",
    "dropdelst": "WI",
    "dropdelzpp": 546546500,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "SENECA",
    "dropphyst": "WI",
    "dropphyzpp": 546546500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SENECA",
    "dropmalst": "WI",
    "dropmalzpp": 546549998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6087343555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17961",
    "droptype": "D",
    "dropname": "SEXTONVILLE",
    "dropdeladd": "28844 COUNTY HWY B",
    "dropdelcty": "SEXTONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535849700,
    "dropphyadd": "28844 COUNTY HWY B",
    "dropphycty": "SEXTONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535849700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEXTONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535849998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6086476677,
    "dropsitcph": 6086476677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17962",
    "droptype": "D",
    "dropname": "SEYMOUR",
    "dropdeladd": "607 WOODLAND PLZ",
    "dropdelcty": "SEYMOUR",
    "dropdelst": "WI",
    "dropdelzpp": 541651659,
    "dropphyadd": "607 WOODLAND PLZ",
    "dropphycty": "SEYMOUR",
    "dropphyst": "WI",
    "dropphyzpp": 541651659,
    "dropmaladd": "607 WOODLAND PLZ",
    "dropmalcty": "SEYMOUR",
    "dropmalst": "WI",
    "dropmalzpp": 541659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208336541,
    "dropsitcph": 9208336541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17964",
    "droptype": "D",
    "dropname": "SHARON",
    "dropdeladd": "199 WALWORTH ST",
    "dropdelcty": "SHARON",
    "dropdelst": "WI",
    "dropdelzpp": 535859605,
    "dropphyadd": "199 WALWORTH ST",
    "dropphycty": "SHARON",
    "dropphyst": "WI",
    "dropphyzpp": 535859605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHARON",
    "dropmalst": "WI",
    "dropmalzpp": 535859998,
    "dropsitphn": 2627364308,
    "dropsitlph": 2627364308,
    "dropsitcph": 2627364308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17965",
    "droptype": "D",
    "dropname": "SHAWANO",
    "dropdeladd": "235 S MAIN ST",
    "dropdelcty": "SHAWANO",
    "dropdelst": "WI",
    "dropdelzpp": 541669998,
    "dropphyadd": "235 S MAIN ST",
    "dropphycty": "SHAWANO",
    "dropphyst": "WI",
    "dropphyzpp": 541669998,
    "dropmaladd": "235 S MAIN ST",
    "dropmalcty": "SHAWANO",
    "dropmalst": "WI",
    "dropmalzpp": 541669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155243764,
    "dropsitcph": 7155243764,
    "dropfax": 7155265991
  },
  {
    "dcode": "D",
    "dropkey": "PY17966",
    "droptype": "D",
    "dropname": "SHEBOYGAN",
    "dropdeladd": "522 N 9TH ST",
    "dropdelcty": "SHEBOYGAN",
    "dropdelst": "WI",
    "dropdelzpp": 530819998,
    "dropphyadd": "522 N 9TH ST",
    "dropphycty": "SHEBOYGAN",
    "dropphyst": "WI",
    "dropphyzpp": 530819998,
    "dropmaladd": "522 N 9TH ST",
    "dropmalcty": "SHEBOYGAN",
    "dropmalst": "WI",
    "dropmalzpp": 530819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204582294,
    "dropfax": 9204582243
  },
  {
    "dcode": "D",
    "dropkey": "PY17968",
    "droptype": "D",
    "dropname": "SHEBOYGAN FALLS",
    "dropdeladd": "108 MAPLE ST",
    "dropdelcty": "SHEBOYGAN FALLS",
    "dropdelst": "WI",
    "dropdelzpp": 530859998,
    "dropphyadd": "108 MAPLE ST",
    "dropphycty": "SHEBOYGAN FALLS",
    "dropphyst": "WI",
    "dropphyzpp": 530859998,
    "dropmaladd": "108 MAPLE ST",
    "dropmalcty": "SHEBOYGAN FALLS",
    "dropmalst": "WI",
    "dropmalzpp": 530859998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204676510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17971",
    "droptype": "D",
    "dropname": "SHELDON",
    "dropdeladd": "W5530 MAIN ST",
    "dropdelcty": "SHELDON",
    "dropdelst": "WI",
    "dropdelzpp": 547669794,
    "dropphyadd": "W5530 MAIN ST",
    "dropphycty": "SHELDON",
    "dropphyst": "WI",
    "dropphyzpp": 547669794,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELDON",
    "dropmalst": "WI",
    "dropmalzpp": 547669998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154525160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17972",
    "droptype": "D",
    "dropname": "SHELL LAKE",
    "dropdeladd": "110 5TH AVE",
    "dropdelcty": "SHELL LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 548714404,
    "dropphyadd": "110 5TH AVE",
    "dropphycty": "SHELL LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 548714404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHELL LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 548719998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154682111,
    "dropfax": 7154682111
  },
  {
    "dcode": "D",
    "dropkey": "PY17977",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "N397 MILITARY RD",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "WI",
    "dropdelzpp": 541699661,
    "dropphyadd": "N397 MILITARY RD",
    "dropphycty": "SHERWOOD",
    "dropphyst": "WI",
    "dropphyzpp": 541699661,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "WI",
    "dropmalzpp": 541699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209891999,
    "dropsitcph": 9209891999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17978",
    "droptype": "D",
    "dropname": "SHIOCTON",
    "dropdeladd": "W7596 PARK AVE",
    "dropdelcty": "SHIOCTON",
    "dropdelst": "WI",
    "dropdelzpp": 541708534,
    "dropphyadd": "W7596 PARK AVE",
    "dropphycty": "SHIOCTON",
    "dropphyst": "WI",
    "dropphyzpp": 541708534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHIOCTON",
    "dropmalst": "WI",
    "dropmalzpp": 541709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209863221,
    "dropsitcph": 9209863221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17983",
    "droptype": "D",
    "dropname": "SHULLSBURG",
    "dropdeladd": "147 W MAIN ST",
    "dropdelcty": "SHULLSBURG",
    "dropdelst": "WI",
    "dropdelzpp": 535869323,
    "dropphyadd": "147 W MAIN ST",
    "dropphycty": "SHULLSBURG",
    "dropphyst": "WI",
    "dropphyzpp": 535869323,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHULLSBURG",
    "dropmalst": "WI",
    "dropmalzpp": 535869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089653468,
    "dropsitcph": 6089653468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17984",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "739 S COGSWELL DR",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 531701701,
    "dropphyadd": "739 S COGSWELL DR",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 531701701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 531709998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628894991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17985",
    "droptype": "D",
    "dropname": "SINSINAWA",
    "dropdeladd": "519 COUNTY ROAD Z",
    "dropdelcty": "SINSINAWA",
    "dropdelst": "WI",
    "dropdelzpp": 538249700,
    "dropphyadd": "519 COUNTY ROAD Z",
    "dropphycty": "SINSINAWA",
    "dropphyst": "WI",
    "dropphyzpp": 538249700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SINSINAWA",
    "dropmalst": "WI",
    "dropmalzpp": 538249998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6087484543,
    "dropsitcph": 6087484543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17986",
    "droptype": "D",
    "dropname": "SIREN",
    "dropdeladd": "7729 MAIN ST",
    "dropdelcty": "SIREN",
    "dropdelst": "WI",
    "dropdelzpp": 548728040,
    "dropphyadd": "7729 MAIN ST",
    "dropphycty": "SIREN",
    "dropphyst": "WI",
    "dropphyzpp": 548728040,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIREN",
    "dropmalst": "WI",
    "dropmalzpp": 548729998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153495395,
    "dropfax": 7153492516
  },
  {
    "dcode": "D",
    "dropkey": "PY17987",
    "droptype": "D",
    "dropname": "SISTER BAY",
    "dropdeladd": "10685 N BAY SHORE DR",
    "dropdelcty": "SISTER BAY",
    "dropdelst": "WI",
    "dropdelzpp": 542349595,
    "dropphyadd": "10685 N BAY SHORE DR",
    "dropphycty": "SISTER BAY",
    "dropphyst": "WI",
    "dropphyzpp": 542349595,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SISTER BAY",
    "dropmalst": "WI",
    "dropmalzpp": 542349998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208542725,
    "dropsitcph": 9208542725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17990",
    "droptype": "D",
    "dropname": "SLINGER",
    "dropdeladd": "350 E WASHINGTON ST",
    "dropdelcty": "SLINGER",
    "dropdelst": "WI",
    "dropdelzpp": 530869998,
    "dropphyadd": "350 E WASHINGTON ST",
    "dropphycty": "SLINGER",
    "dropphyst": "WI",
    "dropphyzpp": 530869998,
    "dropmaladd": "350 E WASHINGTON ST",
    "dropmalcty": "SLINGER",
    "dropmalst": "WI",
    "dropmalzpp": 530869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2626445111,
    "dropfax": 2626449947
  },
  {
    "dcode": "D",
    "dropkey": "PY17995",
    "droptype": "D",
    "dropname": "SOLDIERS GROVE",
    "dropdeladd": "101 SUNSET AVE",
    "dropdelcty": "SOLDIERS GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 546556534,
    "dropphyadd": "101 SUNSET AVE",
    "dropphycty": "SOLDIERS GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 546556534,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOLDIERS GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 546559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086245706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17997",
    "droptype": "D",
    "dropname": "SOLON SPRINGS",
    "dropdeladd": "9226 E MAIN ST",
    "dropdelcty": "SOLON SPRINGS",
    "dropdelst": "WI",
    "dropdelzpp": 548738051,
    "dropphyadd": "9226 E MAIN ST",
    "dropphycty": "SOLON SPRINGS",
    "dropphyst": "WI",
    "dropphyzpp": 548738051,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOLON SPRINGS",
    "dropmalst": "WI",
    "dropmalzpp": 548739998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153782203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17998",
    "droptype": "D",
    "dropname": "SOMERS",
    "dropdeladd": "7621 12TH ST",
    "dropdelcty": "SOMERS",
    "dropdelst": "WI",
    "dropdelzpp": 531719800,
    "dropphyadd": "7621 12TH ST",
    "dropphycty": "SOMERS",
    "dropphyst": "WI",
    "dropphyzpp": 531719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERS",
    "dropmalst": "WI",
    "dropmalzpp": 531719998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702021,
    "dropsitcph": 2628592566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY17999",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "750 RIVARD ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "WI",
    "dropdelzpp": 540251409,
    "dropphyadd": "750 RIVARD ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "WI",
    "dropphyzpp": 540251409,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERSET",
    "dropmalst": "WI",
    "dropmalzpp": 540259998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 7152473551,
    "dropfax": 7152474595
  },
  {
    "dcode": "D",
    "dropkey": "PY18006",
    "droptype": "D",
    "dropname": "SOUTH MILWAUKEE",
    "dropdeladd": "2210 10TH AVE",
    "dropdelcty": "SOUTH MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 531729998,
    "dropphyadd": "2210 10TH AVE",
    "dropphycty": "SOUTH MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 531729998,
    "dropmaladd": "2210 10TH AVE",
    "dropmalcty": "SOUTH MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 531729998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4147620674,
    "dropsitcph": 4147620601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18007",
    "droptype": "D",
    "dropname": "SOUTH RANGE",
    "dropdeladd": "6205 E WICKSTROM ST",
    "dropdelcty": "SOUTH RANGE",
    "dropdelst": "WI",
    "dropdelzpp": 548748531,
    "dropphyadd": "6205 E WICKSTROM ST",
    "dropphycty": "SOUTH RANGE",
    "dropphyst": "WI",
    "dropphyzpp": 548748531,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH RANGE",
    "dropmalst": "WI",
    "dropmalzpp": 548749998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153987107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18009",
    "droptype": "D",
    "dropname": "SOUTH WAYNE",
    "dropdeladd": "202 W CENTER ST",
    "dropdelcty": "SOUTH WAYNE",
    "dropdelst": "WI",
    "dropdelzpp": 535879509,
    "dropphyadd": "202 W CENTER ST",
    "dropphycty": "SOUTH WAYNE",
    "dropphyst": "WI",
    "dropphyzpp": 535879509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH WAYNE",
    "dropmalst": "WI",
    "dropmalzpp": 535879998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084395321,
    "dropsitcph": 6084395321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18010",
    "droptype": "D",
    "dropname": "SPARTA",
    "dropdeladd": "123 W MAIN ST",
    "dropdelcty": "SPARTA",
    "dropdelst": "WI",
    "dropdelzpp": 546561758,
    "dropphyadd": "123 W MAIN ST",
    "dropphycty": "SPARTA",
    "dropphyst": "WI",
    "dropphyzpp": 546561758,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPARTA",
    "dropmalst": "WI",
    "dropmalzpp": 546569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6084517104,
    "dropsitcph": 6084517106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18011",
    "droptype": "D",
    "dropname": "SPENCER",
    "dropdeladd": "102 W DEARBORN ST",
    "dropdelcty": "SPENCER",
    "dropdelst": "WI",
    "dropdelzpp": 544799789,
    "dropphyadd": "102 W DEARBORN ST",
    "dropphycty": "SPENCER",
    "dropphyst": "WI",
    "dropphyzpp": 544799789,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPENCER",
    "dropmalst": "WI",
    "dropmalzpp": 544799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156594062,
    "dropsitcph": 7156594062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18016",
    "droptype": "D",
    "dropname": "SPOONER",
    "dropdeladd": "704 N FRONT ST",
    "dropdelcty": "SPOONER",
    "dropdelst": "WI",
    "dropdelzpp": 548011350,
    "dropphyadd": "704 N FRONT ST",
    "dropphycty": "SPOONER",
    "dropphyst": "WI",
    "dropphyzpp": 548011350,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPOONER",
    "dropmalst": "WI",
    "dropmalzpp": 548019998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156358716,
    "dropfax": 7156357474
  },
  {
    "dcode": "D",
    "dropkey": "PY18017",
    "droptype": "D",
    "dropname": "SPRING GREEN",
    "dropdeladd": "150 S WASHINGTON ST",
    "dropdelcty": "SPRING GREEN",
    "dropdelst": "WI",
    "dropdelzpp": 535888057,
    "dropphyadd": "150 S WASHINGTON ST",
    "dropphycty": "SPRING GREEN",
    "dropphyst": "WI",
    "dropphyzpp": 535888057,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING GREEN",
    "dropmalst": "WI",
    "dropmalzpp": 535889998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6085882066,
    "dropsitcph": 6085882066,
    "dropfax": 6085882034
  },
  {
    "dcode": "D",
    "dropkey": "PY18018",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "E124 AKERS ST",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "WI",
    "dropdelzpp": 547674405,
    "dropphyadd": "E124 AKERS ST",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "WI",
    "dropphyzpp": 547674405,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "WI",
    "dropmalzpp": 547679998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157784444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18019",
    "droptype": "D",
    "dropname": "SPRINGBROOK",
    "dropdeladd": "W3060 HIGHWAY 63",
    "dropdelcty": "SPRINGBROOK",
    "dropdelst": "WI",
    "dropdelzpp": 548754400,
    "dropphyadd": "W3060 HIGHWAY 63",
    "dropphycty": "SPRINGBROOK",
    "dropphyst": "WI",
    "dropphyzpp": 548754400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGBROOK",
    "dropmalst": "WI",
    "dropmalzpp": 548759998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7157662951,
    "dropfax": 7157662951
  },
  {
    "dcode": "D",
    "dropkey": "PY18021",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "7210 SPRINGFIELD RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 531769800,
    "dropphyadd": "7210 SPRINGFIELD RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 531769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 531769998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622483088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18145",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "111 E 1ST AVE",
    "dropdelcty": "STANLEY",
    "dropdelst": "WI",
    "dropdelzpp": 547689997,
    "dropphyadd": "111 E 1ST AVE",
    "dropphycty": "STANLEY",
    "dropphyst": "WI",
    "dropphyzpp": 547689997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANLEY",
    "dropmalst": "WI",
    "dropmalzpp": 547689998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156443623,
    "dropfax": 7156440179
  },
  {
    "dcode": "D",
    "dropkey": "PY18148",
    "droptype": "D",
    "dropname": "STAR PRAIRIE",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "STAR PRAIRIE",
    "dropdelst": "WI",
    "dropdelzpp": 540269253,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "STAR PRAIRIE",
    "dropphyst": "WI",
    "dropphyzpp": 540269253,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAR PRAIRIE",
    "dropmalst": "WI",
    "dropmalzpp": 540269998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152483939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18159",
    "droptype": "D",
    "dropname": "STETSONVILLE",
    "dropdeladd": "106 S STATE HIGHWAY 13",
    "dropdelcty": "STETSONVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 544809800,
    "dropphyadd": "106 S STATE HIGHWAY 13",
    "dropphycty": "STETSONVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 544809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STETSONVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 544809998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156782685,
    "dropsitcph": 7156782685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18161",
    "droptype": "D",
    "dropname": "STEVENS POINT",
    "dropdeladd": "1320 MAIN ST",
    "dropdelcty": "STEVENS POINT",
    "dropdelst": "WI",
    "dropdelzpp": 544819998,
    "dropphyadd": "1320 MAIN ST",
    "dropphycty": "STEVENS POINT",
    "dropphyst": "WI",
    "dropphyzpp": 544819998,
    "dropmaladd": "1320 MAIN ST",
    "dropmalcty": "STEVENS POINT",
    "dropmalst": "WI",
    "dropmalzpp": 544819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153448327,
    "dropsitcph": 7153448327,
    "dropfax": 7153442530
  },
  {
    "dcode": "D",
    "dropkey": "PY18164",
    "droptype": "D",
    "dropname": "STITZER",
    "dropdeladd": "4011 COMMERCIAL ST STE 1",
    "dropdelcty": "STITZER",
    "dropdelst": "WI",
    "dropdelzpp": 538259603,
    "dropphyadd": "4011 COMMERCIAL ST STE 1",
    "dropphycty": "STITZER",
    "dropphyst": "WI",
    "dropphyzpp": 538259603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STITZER",
    "dropmalst": "WI",
    "dropmalzpp": 538259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6089438378,
    "dropsitcph": 6089438378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18165",
    "droptype": "D",
    "dropname": "STOCKBRIDGE",
    "dropdeladd": "115 S MILITARY RD",
    "dropdelcty": "STOCKBRIDGE",
    "dropdelst": "WI",
    "dropdelzpp": 530889800,
    "dropphyadd": "115 S MILITARY RD",
    "dropphycty": "STOCKBRIDGE",
    "dropphyst": "WI",
    "dropphyzpp": 530889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKBRIDGE",
    "dropmalst": "WI",
    "dropmalzpp": 530889998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204391999,
    "dropsitcph": 9204391999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18167",
    "droptype": "D",
    "dropname": "STOCKHOLM",
    "dropdeladd": "W12117 HIGHWAY 35",
    "dropdelcty": "STOCKHOLM",
    "dropdelst": "WI",
    "dropdelzpp": 547694400,
    "dropphyadd": "W12117 HIGHWAY 35",
    "dropphycty": "STOCKHOLM",
    "dropphyst": "WI",
    "dropphyzpp": 547694400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKHOLM",
    "dropmalst": "WI",
    "dropmalzpp": 547699998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7154425169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18169",
    "droptype": "D",
    "dropname": "STODDARD",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "STODDARD",
    "dropdelst": "WI",
    "dropdelzpp": 546589530,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "STODDARD",
    "dropphyst": "WI",
    "dropphyzpp": 546589530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STODDARD",
    "dropmalst": "WI",
    "dropmalzpp": 546589998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084572577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18170",
    "droptype": "D",
    "dropname": "STONE LAKE",
    "dropdeladd": "16865 W 1ST ST N",
    "dropdelcty": "STONE LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 548762203,
    "dropphyadd": "16865 W 1ST ST N",
    "dropphycty": "STONE LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 548762203,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STONE LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 548769998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158653421,
    "dropfax": 7158653421
  },
  {
    "dcode": "D",
    "dropkey": "PY18172",
    "droptype": "D",
    "dropname": "STOUGHTON",
    "dropdeladd": "246 E MAIN ST",
    "dropdelcty": "STOUGHTON",
    "dropdelst": "WI",
    "dropdelzpp": 535899998,
    "dropphyadd": "246 E MAIN ST",
    "dropphycty": "STOUGHTON",
    "dropphyst": "WI",
    "dropphyzpp": 535899998,
    "dropmaladd": "246 E MAIN ST",
    "dropmalcty": "STOUGHTON",
    "dropmalst": "WI",
    "dropmalzpp": 535899998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088731723,
    "dropsitcph": 6088779020,
    "dropfax": 6088737510
  },
  {
    "dcode": "D",
    "dropkey": "PY18173",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "213114 LEGION ST",
    "dropdelcty": "STRATFORD",
    "dropdelst": "WI",
    "dropdelzpp": 544845029,
    "dropphyadd": "213114 LEGION ST",
    "dropphycty": "STRATFORD",
    "dropphyst": "WI",
    "dropphyzpp": 544845029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATFORD",
    "dropmalst": "WI",
    "dropmalzpp": 544849998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7156874140,
    "dropsitcph": 7156874140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18174",
    "droptype": "D",
    "dropname": "STRUM",
    "dropdeladd": "116 5TH AVE N",
    "dropdelcty": "STRUM",
    "dropdelst": "WI",
    "dropdelzpp": 547709252,
    "dropphyadd": "116 5TH AVE N",
    "dropphycty": "STRUM",
    "dropphyst": "WI",
    "dropphyzpp": 547709252,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRUM",
    "dropmalst": "WI",
    "dropmalzpp": 547709998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156952636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18175",
    "droptype": "D",
    "dropname": "STURGEON BAY",
    "dropdeladd": "359 LOUISIANA ST",
    "dropdelcty": "STURGEON BAY",
    "dropdelst": "WI",
    "dropdelzpp": 542359998,
    "dropphyadd": "359 LOUISIANA ST",
    "dropphycty": "STURGEON BAY",
    "dropphyst": "WI",
    "dropphyzpp": 542359998,
    "dropmaladd": "359 LOUISIANA ST",
    "dropmalcty": "STURGEON BAY",
    "dropmalst": "WI",
    "dropmalzpp": 542359998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207433297,
    "dropsitcph": 9207433297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18176",
    "droptype": "D",
    "dropname": "STURTEVANT",
    "dropdeladd": "2849 WISCONSIN ST",
    "dropdelcty": "STURTEVANT",
    "dropdelst": "WI",
    "dropdelzpp": 531779998,
    "dropphyadd": "2849 WISCONSIN ST",
    "dropphycty": "STURTEVANT",
    "dropphyst": "WI",
    "dropphyzpp": 531779998,
    "dropmaladd": "2849 WISCONSIN ST",
    "dropmalcty": "STURTEVANT",
    "dropmalst": "WI",
    "dropmalzpp": 531779998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2628864252,
    "dropsitcph": 2628864104,
    "dropfax": 2628863948
  },
  {
    "dcode": "D",
    "dropkey": "PY18177",
    "droptype": "D",
    "dropname": "SUAMICO",
    "dropdeladd": "1815 RIVERSIDE DR",
    "dropdelcty": "SUAMICO",
    "dropdelst": "WI",
    "dropdelzpp": 541739700,
    "dropphyadd": "1815 RIVERSIDE DR",
    "dropphycty": "SUAMICO",
    "dropphyst": "WI",
    "dropphyzpp": 541739700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUAMICO",
    "dropmalst": "WI",
    "dropmalzpp": 541739998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204342183,
    "dropsitcph": 9204342183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18179",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "707 PALMYRA ST",
    "dropdelcty": "SULLIVAN",
    "dropdelst": "WI",
    "dropdelzpp": 531789998,
    "dropphyadd": "707 PALMYRA ST",
    "dropphycty": "SULLIVAN",
    "dropphyst": "WI",
    "dropphyzpp": 531789998,
    "dropmaladd": "707 PALMYRA ST",
    "dropmalcty": "SULLIVAN",
    "dropmalst": "WI",
    "dropmalzpp": 531789998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625932332,
    "dropfax": 2625938258
  },
  {
    "dcode": "D",
    "dropkey": "PY18181",
    "droptype": "D",
    "dropname": "SUMMIT LAKE",
    "dropdeladd": "N9575 COUNTY ROAD B",
    "dropdelcty": "SUMMIT LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 544859800,
    "dropphyadd": "N9575 COUNTY ROAD B",
    "dropphycty": "SUMMIT LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 544859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMIT LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 544859998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152753110,
    "dropsitcph": 7152753110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18182",
    "droptype": "D",
    "dropname": "SUN PRAIRIE",
    "dropdeladd": "1715 LINNERUD DR",
    "dropdelcty": "SUN PRAIRIE",
    "dropdelst": "WI",
    "dropdelzpp": 535909998,
    "dropphyadd": "1715 LINNERUD DR",
    "dropphycty": "SUN PRAIRIE",
    "dropphyst": "WI",
    "dropphyzpp": 535909998,
    "dropmaladd": "1715 LINNERUD DR",
    "dropmalcty": "SUN PRAIRIE",
    "dropmalst": "WI",
    "dropmalzpp": 535909998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088341662,
    "dropsitcph": 6088340952,
    "dropfax": 6088253437
  },
  {
    "dcode": "D",
    "dropkey": "PY18184",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "805 BELKNAP ST",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "WI",
    "dropdelzpp": 548802907,
    "dropphyadd": "805 BELKNAP ST",
    "dropphycty": "SUPERIOR",
    "dropphyst": "WI",
    "dropphyzpp": 548802907,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "WI",
    "dropmalzpp": 548809998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153947209,
    "dropfax": 7153946644
  },
  {
    "dcode": "D",
    "dropkey": "PY18185",
    "droptype": "D",
    "dropname": "SURING",
    "dropdeladd": "507 MAIN ST",
    "dropdelcty": "SURING",
    "dropdelst": "WI",
    "dropdelzpp": 541749570,
    "dropphyadd": "507 MAIN ST",
    "dropphycty": "SURING",
    "dropphyst": "WI",
    "dropphyzpp": 541749570,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SURING",
    "dropmalst": "WI",
    "dropmalzpp": 541749998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208422556,
    "dropsitcph": 9208422556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18186",
    "droptype": "D",
    "dropname": "SUSSEX",
    "dropdeladd": "N63W23565 SILVER SPRING DR",
    "dropdelcty": "SUSSEX",
    "dropdelst": "WI",
    "dropdelzpp": 530899998,
    "dropphyadd": "N63W23565 SILVER SPRING DR",
    "dropphycty": "SUSSEX",
    "dropphyst": "WI",
    "dropphyzpp": 530899998,
    "dropmaladd": "N63W23565 SILVER SPRING DR",
    "dropmalcty": "SUSSEX",
    "dropmalst": "WI",
    "dropmalzpp": 530899998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622468419,
    "dropsitcph": 2622468395,
    "dropfax": 6519943359
  },
  {
    "dcode": "D",
    "dropkey": "PY18191",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "110 2ND ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "WI",
    "dropdelzpp": 546596500,
    "dropphyadd": "110 2ND ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "WI",
    "dropphyzpp": 546596500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLOR",
    "dropmalst": "WI",
    "dropmalzpp": 546599998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156623001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18195",
    "droptype": "D",
    "dropname": "THERESA",
    "dropdeladd": "109 CHURCH ST",
    "dropdelcty": "THERESA",
    "dropdelst": "WI",
    "dropdelzpp": 530919800,
    "dropphyadd": "109 CHURCH ST",
    "dropphycty": "THERESA",
    "dropphyst": "WI",
    "dropphyzpp": 530919800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THERESA",
    "dropmalst": "WI",
    "dropmalzpp": 530919998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9204884121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18196",
    "droptype": "D",
    "dropname": "THIENSVILLE",
    "dropdeladd": "124 W FREISTADT RD",
    "dropdelcty": "THIENSVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 530929998,
    "dropphyadd": "124 W FREISTADT RD",
    "dropphycty": "THIENSVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 530929998,
    "dropmaladd": "124 W FREISTADT RD",
    "dropmalcty": "THIENSVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 530929998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2622420972,
    "dropsitcph": 2622420955,
    "dropfax": 4142427858
  },
  {
    "dcode": "D",
    "dropkey": "PY18198",
    "droptype": "D",
    "dropname": "THORP",
    "dropdeladd": "102 E SCHOOL ST",
    "dropdelcty": "THORP",
    "dropdelst": "WI",
    "dropdelzpp": 547719706,
    "dropphyadd": "102 E SCHOOL ST",
    "dropphycty": "THORP",
    "dropphyst": "WI",
    "dropphyzpp": 547719706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THORP",
    "dropmalst": "WI",
    "dropmalzpp": 547719998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156695766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18199",
    "droptype": "D",
    "dropname": "THREE LAKES",
    "dropdeladd": "6970 W SCHOOL ST",
    "dropdelcty": "THREE LAKES",
    "dropdelst": "WI",
    "dropdelzpp": 545629800,
    "dropphyadd": "6970 W SCHOOL ST",
    "dropphycty": "THREE LAKES",
    "dropphyst": "WI",
    "dropphyzpp": 545629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THREE LAKES",
    "dropmalst": "WI",
    "dropmalzpp": 545629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155463410,
    "dropsitcph": 7155463410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18201",
    "droptype": "D",
    "dropname": "TIGERTON",
    "dropdeladd": "232 BIRCH ST",
    "dropdelcty": "TIGERTON",
    "dropdelst": "WI",
    "dropdelzpp": 544869800,
    "dropphyadd": "232 BIRCH ST",
    "dropphycty": "TIGERTON",
    "dropphyst": "WI",
    "dropphyzpp": 544869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIGERTON",
    "dropmalst": "WI",
    "dropmalzpp": 544869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155352152,
    "dropsitcph": 7155352152,
    "dropfax": 7155352105
  },
  {
    "dcode": "D",
    "dropkey": "PY18203",
    "droptype": "D",
    "dropname": "TILLEDA",
    "dropdeladd": "N6192 COUNTY ROAD D",
    "dropdelcty": "TILLEDA",
    "dropdelst": "WI",
    "dropdelzpp": 549789700,
    "dropphyadd": "N6192 COUNTY ROAD D",
    "dropphycty": "TILLEDA",
    "dropphyst": "WI",
    "dropphyzpp": 549789700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TILLEDA",
    "dropmalst": "WI",
    "dropmalzpp": 549789998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7157874297,
    "dropsitcph": 7157874297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18205",
    "droptype": "D",
    "dropname": "TISCH MILLS",
    "dropdeladd": "E1707 COUNTY ROAD BB",
    "dropdelcty": "TISCH MILLS",
    "dropdelst": "WI",
    "dropdelzpp": 542409800,
    "dropphyadd": "E1707 COUNTY ROAD BB",
    "dropphycty": "TISCH MILLS",
    "dropphyst": "WI",
    "dropphyzpp": 542409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TISCH MILLS",
    "dropmalst": "WI",
    "dropmalzpp": 542409998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207761998,
    "dropsitcph": 9207761998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18206",
    "droptype": "D",
    "dropname": "TOMAH",
    "dropdeladd": "1000 N SUPERIOR AVE",
    "dropdelcty": "TOMAH",
    "dropdelst": "WI",
    "dropdelzpp": 546601124,
    "dropphyadd": "1000 N SUPERIOR AVE",
    "dropphycty": "TOMAH",
    "dropphyst": "WI",
    "dropphyzpp": 546601124,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOMAH",
    "dropmalst": "WI",
    "dropmalzpp": 546609998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083725611,
    "dropfax": 6083725700
  },
  {
    "dcode": "D",
    "dropkey": "PY18207",
    "droptype": "D",
    "dropname": "TOMAHAWK",
    "dropdeladd": "311 W WISCONSIN AVE",
    "dropdelcty": "TOMAHAWK",
    "dropdelst": "WI",
    "dropdelzpp": 544879998,
    "dropphyadd": "311 W WISCONSIN AVE",
    "dropphycty": "TOMAHAWK",
    "dropphyst": "WI",
    "dropphyzpp": 544879998,
    "dropmaladd": "311 W WISCONSIN AVE",
    "dropmalcty": "TOMAHAWK",
    "dropmalst": "WI",
    "dropmalzpp": 544879998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154532831,
    "dropsitcph": 7154532831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18208",
    "droptype": "D",
    "dropname": "TONY",
    "dropdeladd": "N5331 COUNTY ROAD I",
    "dropdelcty": "TONY",
    "dropdelst": "WI",
    "dropdelzpp": 545639657,
    "dropphyadd": "N5331 COUNTY ROAD I",
    "dropphycty": "TONY",
    "dropphyst": "WI",
    "dropphyzpp": 545639657,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONY",
    "dropmalst": "WI",
    "dropmalzpp": 545639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155323500,
    "dropsitcph": 7155323500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18209",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "17912 FRONT ST",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "WI",
    "dropdelzpp": 541759000,
    "dropphyadd": "17912 FRONT ST",
    "dropphycty": "TOWNSEND",
    "dropphyst": "WI",
    "dropphyzpp": 541759000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "WI",
    "dropmalzpp": 541759998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152766857,
    "dropsitcph": 7152766857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18211",
    "droptype": "D",
    "dropname": "TREGO",
    "dropdeladd": "N7288 SERVICE LOOP",
    "dropdelcty": "TREGO",
    "dropdelst": "WI",
    "dropdelzpp": 548889350,
    "dropphyadd": "N7288 SERVICE LOOP",
    "dropphycty": "TREGO",
    "dropphyst": "WI",
    "dropphyzpp": 548889350,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TREGO",
    "dropmalst": "WI",
    "dropmalzpp": 548889998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156358566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18212",
    "droptype": "D",
    "dropname": "TREMPEALEAU",
    "dropdeladd": "11421 MAIN ST",
    "dropdelcty": "TREMPEALEAU",
    "dropdelst": "WI",
    "dropdelzpp": 546616500,
    "dropphyadd": "11421 MAIN ST",
    "dropphycty": "TREMPEALEAU",
    "dropphyst": "WI",
    "dropphyzpp": 546616500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TREMPEALEAU",
    "dropmalst": "WI",
    "dropmalzpp": 546619998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6085346571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18214",
    "droptype": "D",
    "dropname": "TREVOR",
    "dropdeladd": "25930 WILMOT RD",
    "dropdelcty": "TREVOR",
    "dropdelst": "WI",
    "dropdelzpp": 531799349,
    "dropphyadd": "25930 WILMOT RD",
    "dropphycty": "TREVOR",
    "dropphyst": "WI",
    "dropphyzpp": 531799349,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TREVOR",
    "dropmalst": "WI",
    "dropmalzpp": 531799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628626877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18217",
    "droptype": "D",
    "dropname": "TRIPOLI",
    "dropdeladd": "13758 USH 8",
    "dropdelcty": "TRIPOLI",
    "dropdelst": "WI",
    "dropdelzpp": 545649416,
    "dropphyadd": "13758 USH 8",
    "dropphycty": "TRIPOLI",
    "dropphyst": "WI",
    "dropphyzpp": 545649416,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRIPOLI",
    "dropmalst": "WI",
    "dropmalzpp": 545649998,
    "dropsitphn": 4142912520,
    "dropsitlph": 7155642661,
    "dropsitcph": 7155642661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18220",
    "droptype": "D",
    "dropname": "TUNNEL CITY",
    "dropdeladd": "21447 FLAGSHIP AVE",
    "dropdelcty": "TUNNEL CITY",
    "dropdelst": "WI",
    "dropdelzpp": 546626500,
    "dropphyadd": "21447 FLAGSHIP AVE",
    "dropphycty": "TUNNEL CITY",
    "dropphyst": "WI",
    "dropphyzpp": 546626500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUNNEL CITY",
    "dropmalst": "WI",
    "dropmalzpp": 546629998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083726693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18222",
    "droptype": "D",
    "dropname": "TURTLE LAKE",
    "dropdeladd": "300 MAPLE ST S",
    "dropdelcty": "TURTLE LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 548898004,
    "dropphyadd": "300 MAPLE ST S",
    "dropphycty": "TURTLE LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 548898004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TURTLE LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 548899998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7159862222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18224",
    "droptype": "D",
    "dropname": "TWIN LAKES",
    "dropdeladd": "170 LANCE DR",
    "dropdelcty": "TWIN LAKES",
    "dropdelst": "WI",
    "dropdelzpp": 531819998,
    "dropphyadd": "170 LANCE DR",
    "dropphycty": "TWIN LAKES",
    "dropphyst": "WI",
    "dropphyzpp": 531819998,
    "dropmaladd": "170 LANCE DR",
    "dropmalcty": "TWIN LAKES",
    "dropmalst": "WI",
    "dropmalzpp": 531819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628773116,
    "dropfax": 2628773142
  },
  {
    "dcode": "D",
    "dropkey": "PY18225",
    "droptype": "D",
    "dropname": "TWO RIVERS",
    "dropdeladd": "1516 18TH ST",
    "dropdelcty": "TWO RIVERS",
    "dropdelst": "WI",
    "dropdelzpp": 542419998,
    "dropphyadd": "1516 18TH ST",
    "dropphycty": "TWO RIVERS",
    "dropphyst": "WI",
    "dropphyzpp": 542419998,
    "dropmaladd": "1516 18TH ST",
    "dropmalcty": "TWO RIVERS",
    "dropmalst": "WI",
    "dropmalzpp": 542419998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207947014,
    "dropsitcph": 9207947014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18229",
    "droptype": "D",
    "dropname": "UNION CENTER",
    "dropdeladd": "335 HIGH ST",
    "dropdelcty": "UNION CENTER",
    "dropdelst": "WI",
    "dropdelzpp": 539629700,
    "dropphyadd": "335 HIGH ST",
    "dropphycty": "UNION CENTER",
    "dropphyst": "WI",
    "dropphyzpp": 539629700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION CENTER",
    "dropmalst": "WI",
    "dropmalzpp": 539629998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084625622,
    "dropsitcph": 6084625622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18230",
    "droptype": "D",
    "dropname": "UNION GROVE",
    "dropdeladd": "830 MAIN ST",
    "dropdelcty": "UNION GROVE",
    "dropdelst": "WI",
    "dropdelzpp": 531829998,
    "dropphyadd": "830 MAIN ST",
    "dropphycty": "UNION GROVE",
    "dropphyst": "WI",
    "dropphyzpp": 531829998,
    "dropmaladd": "830 MAIN ST",
    "dropmalcty": "UNION GROVE",
    "dropmalst": "WI",
    "dropmalzpp": 531829998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628781100,
    "dropfax": 2628780201
  },
  {
    "dcode": "D",
    "dropkey": "PY18231",
    "droptype": "D",
    "dropname": "UNITY",
    "dropdeladd": "102 S FRONT ST",
    "dropdelcty": "UNITY",
    "dropdelst": "WI",
    "dropdelzpp": 544889800,
    "dropphyadd": "102 S FRONT ST",
    "dropphycty": "UNITY",
    "dropphyst": "WI",
    "dropphyzpp": 544889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNITY",
    "dropmalst": "WI",
    "dropmalzpp": 544889998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152234544,
    "dropsitcph": 7152234544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18236",
    "droptype": "D",
    "dropname": "VALDERS",
    "dropdeladd": "505 CHRISTEL DR",
    "dropdelcty": "VALDERS",
    "dropdelst": "WI",
    "dropdelzpp": 542459200,
    "dropphyadd": "505 CHRISTEL DR",
    "dropphycty": "VALDERS",
    "dropphyst": "WI",
    "dropphyzpp": 542459200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALDERS",
    "dropmalst": "WI",
    "dropmalzpp": 542459998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207754343,
    "dropsitcph": 9207754343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18238",
    "droptype": "D",
    "dropname": "VAN DYNE",
    "dropdeladd": "N9519 VAN DYNE RD",
    "dropdelcty": "VAN DYNE",
    "dropdelst": "WI",
    "dropdelzpp": 549799427,
    "dropphyadd": "N9519 VAN DYNE RD",
    "dropphycty": "VAN DYNE",
    "dropphyst": "WI",
    "dropphyzpp": 549799427,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAN DYNE",
    "dropmalst": "WI",
    "dropmalzpp": 549799998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206885566,
    "dropsitcph": 9206885566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18241",
    "droptype": "D",
    "dropname": "VESPER",
    "dropdeladd": "6565 CAMERON AVE",
    "dropdelcty": "VESPER",
    "dropdelst": "WI",
    "dropdelzpp": 544899458,
    "dropphyadd": "6565 CAMERON AVE",
    "dropphycty": "VESPER",
    "dropphyst": "WI",
    "dropphyzpp": 544899458,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VESPER",
    "dropmalst": "WI",
    "dropmalzpp": 544899998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7155694688,
    "dropsitcph": 7155694688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18244",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "117 W COMMERCIAL ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "WI",
    "dropdelzpp": 546645001,
    "dropphyadd": "117 W COMMERCIAL ST",
    "dropphycty": "VIOLA",
    "dropphyst": "WI",
    "dropphyzpp": 546645001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIOLA",
    "dropmalst": "WI",
    "dropmalzpp": 546649998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083836050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18245",
    "droptype": "D",
    "dropname": "VIROQUA",
    "dropdeladd": "119 E JEFFERSON ST",
    "dropdelcty": "VIROQUA",
    "dropdelst": "WI",
    "dropdelzpp": 546651614,
    "dropphyadd": "119 E JEFFERSON ST",
    "dropphycty": "VIROQUA",
    "dropphyst": "WI",
    "dropphyzpp": 546651614,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIROQUA",
    "dropmalst": "WI",
    "dropmalzpp": 546659998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6086373292,
    "dropfax": 6086378098
  },
  {
    "dcode": "D",
    "dropkey": "PY18251",
    "droptype": "D",
    "dropname": "WABENO",
    "dropdeladd": "4553 N BRANCH ST",
    "dropdelcty": "WABENO",
    "dropdelst": "WI",
    "dropdelzpp": 545669800,
    "dropphyadd": "4553 N BRANCH ST",
    "dropphycty": "WABENO",
    "dropphyst": "WI",
    "dropphyzpp": 545669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WABENO",
    "dropmalst": "WI",
    "dropmalzpp": 545669998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154734741,
    "dropsitcph": 7154734741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18252",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "829 2ND ST",
    "dropdelcty": "WALDO",
    "dropdelst": "WI",
    "dropdelzpp": 530939998,
    "dropphyadd": "829 2ND ST",
    "dropphycty": "WALDO",
    "dropphyst": "WI",
    "dropphyzpp": 530939998,
    "dropmaladd": "829 2ND ST",
    "dropmalcty": "WALDO",
    "dropmalst": "WI",
    "dropmalzpp": 530939998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9205288834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18253",
    "droptype": "D",
    "dropname": "WALES",
    "dropdeladd": "110 JAMES ST",
    "dropdelcty": "WALES",
    "dropdelst": "WI",
    "dropdelzpp": 531839998,
    "dropphyadd": "110 JAMES ST",
    "dropphycty": "WALES",
    "dropphyst": "WI",
    "dropphyzpp": 531839998,
    "dropmaladd": "110 JAMES ST",
    "dropmalcty": "WALES",
    "dropmalst": "WI",
    "dropmalzpp": 531839998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2629683367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18254",
    "droptype": "D",
    "dropname": "WALWORTH",
    "dropdeladd": "206 N MAIN ST",
    "dropdelcty": "WALWORTH",
    "dropdelst": "WI",
    "dropdelzpp": 531849998,
    "dropphyadd": "206 N MAIN ST",
    "dropphycty": "WALWORTH",
    "dropphyst": "WI",
    "dropphyzpp": 531849998,
    "dropmaladd": "206 N MAIN ST",
    "dropmalcty": "WALWORTH",
    "dropmalst": "WI",
    "dropmalzpp": 531849998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622753121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18257",
    "droptype": "D",
    "dropname": "WARRENS",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "WARRENS",
    "dropdelst": "WI",
    "dropdelzpp": 546669602,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "WARRENS",
    "dropphyst": "WI",
    "dropphyzpp": 546669602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARRENS",
    "dropmalst": "WI",
    "dropmalzpp": 546669998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6083784412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18259",
    "droptype": "D",
    "dropname": "WASHBURN",
    "dropdeladd": "428 W BAYFIELD ST",
    "dropdelcty": "WASHBURN",
    "dropdelst": "WI",
    "dropdelzpp": 548911148,
    "dropphyadd": "428 W BAYFIELD ST",
    "dropphycty": "WASHBURN",
    "dropphyst": "WI",
    "dropphyzpp": 548911148,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHBURN",
    "dropmalst": "WI",
    "dropmalzpp": 548919998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153732771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18262",
    "droptype": "D",
    "dropname": "WASHINGTON ISLAND",
    "dropdeladd": "1889 DETROIT HARBOR RD",
    "dropdelcty": "WASHINGTON ISLAND",
    "dropdelst": "WI",
    "dropdelzpp": 542469243,
    "dropphyadd": "1889 DETROIT HARBOR RD",
    "dropphycty": "WASHINGTON ISLAND",
    "dropphyst": "WI",
    "dropphyzpp": 542469243,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASHINGTON ISLAND",
    "dropmalst": "WI",
    "dropmalzpp": 542469998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9208472231,
    "dropsitcph": 9208472231,
    "dropfax": 9208472231
  },
  {
    "dcode": "D",
    "dropkey": "PY18264",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "218 N MILWAUKEE ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "WI",
    "dropdelzpp": 531859998,
    "dropphyadd": "218 N MILWAUKEE ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "WI",
    "dropphyzpp": 531859998,
    "dropmaladd": "218 N MILWAUKEE ST",
    "dropmalcty": "WATERFORD",
    "dropmalst": "WI",
    "dropmalzpp": 531859998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2625343255,
    "dropfax": 2625343091
  },
  {
    "dcode": "D",
    "dropkey": "PY18265",
    "droptype": "D",
    "dropname": "WATERLOO",
    "dropdeladd": "241 W MADISON ST",
    "dropdelcty": "WATERLOO",
    "dropdelst": "WI",
    "dropdelzpp": 535949998,
    "dropphyadd": "241 W MADISON ST",
    "dropphycty": "WATERLOO",
    "dropphyst": "WI",
    "dropphyzpp": 535949998,
    "dropmaladd": "241 W MADISON ST",
    "dropmalcty": "WATERLOO",
    "dropmalst": "WI",
    "dropmalzpp": 535949998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9204784904,
    "dropsitcph": 9204784335,
    "dropfax": 9204789689
  },
  {
    "dcode": "D",
    "dropkey": "PY18266",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "411 DODGE ST",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 530949998,
    "dropphyadd": "411 DODGE ST",
    "dropphycty": "WATERTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 530949998,
    "dropmaladd": "411 DODGE ST",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 530949998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9202615929,
    "dropfax": 9202613619
  },
  {
    "dcode": "D",
    "dropkey": "PY18268",
    "droptype": "D",
    "dropname": "WAUKAU",
    "dropdeladd": "2670 STATE ROAD 116",
    "dropdelcty": "WAUKAU",
    "dropdelst": "WI",
    "dropdelzpp": 549809800,
    "dropphyadd": "2670 STATE ROAD 116",
    "dropphycty": "WAUKAU",
    "dropphyst": "WI",
    "dropphyzpp": 549809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUKAU",
    "dropmalst": "WI",
    "dropmalzpp": 549809998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9206856810,
    "dropsitcph": 9206856810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18269",
    "droptype": "D",
    "dropname": "WAUKESHA",
    "dropdeladd": "300 E BROADWAY",
    "dropdelcty": "WAUKESHA",
    "dropdelst": "WI",
    "dropdelzpp": 531869998,
    "dropphyadd": "300 E BROADWAY",
    "dropphycty": "WAUKESHA",
    "dropphyst": "WI",
    "dropphyzpp": 531869998,
    "dropmaladd": "300 E BROADWAY",
    "dropmalcty": "WAUKESHA",
    "dropmalst": "WI",
    "dropmalzpp": 531869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626506357,
    "dropsitcph": 2626505388,
    "dropfax": 2626505390
  },
  {
    "dcode": "D",
    "dropkey": "PY18271",
    "droptype": "D",
    "dropname": "WAUNAKEE",
    "dropdeladd": "101 N KLEIN DR",
    "dropdelcty": "WAUNAKEE",
    "dropdelst": "WI",
    "dropdelzpp": 535979998,
    "dropphyadd": "101 N KLEIN DR",
    "dropphycty": "WAUNAKEE",
    "dropphyst": "WI",
    "dropphyzpp": 535979998,
    "dropmaladd": "101 N KLEIN DR",
    "dropmalcty": "WAUNAKEE",
    "dropmalst": "WI",
    "dropmalzpp": 535979998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088504177,
    "dropsitcph": 6088504151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18272",
    "droptype": "D",
    "dropname": "WAUPACA",
    "dropdeladd": "306 S MAIN ST",
    "dropdelcty": "WAUPACA",
    "dropdelst": "WI",
    "dropdelzpp": 549819998,
    "dropphyadd": "306 S MAIN ST",
    "dropphycty": "WAUPACA",
    "dropphyst": "WI",
    "dropphyzpp": 549819998,
    "dropmaladd": "306 S MAIN ST",
    "dropmalcty": "WAUPACA",
    "dropmalst": "WI",
    "dropmalzpp": 549819998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152582010,
    "dropsitcph": 7152582010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18273",
    "droptype": "D",
    "dropname": "WAUPUN",
    "dropdeladd": "400 E FRANKLIN ST",
    "dropdelcty": "WAUPUN",
    "dropdelst": "WI",
    "dropdelzpp": 539639998,
    "dropphyadd": "400 E FRANKLIN ST",
    "dropphycty": "WAUPUN",
    "dropphyst": "WI",
    "dropphyzpp": 539639998,
    "dropmaladd": "400 E FRANKLIN ST",
    "dropmalcty": "WAUPUN",
    "dropmalst": "WI",
    "dropmalzpp": 539639998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9203244111,
    "dropsitcph": 9203244111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18275",
    "droptype": "D",
    "dropname": "WAUSAU",
    "dropdeladd": "235 FOREST ST",
    "dropdelcty": "WAUSAU",
    "dropdelst": "WI",
    "dropdelzpp": 544039998,
    "dropphyadd": "235 FOREST ST",
    "dropphycty": "WAUSAU",
    "dropphyst": "WI",
    "dropphyzpp": 544039998,
    "dropmaladd": "235 FOREST ST",
    "dropmalcty": "WAUSAU",
    "dropmalst": "WI",
    "dropmalzpp": 544039998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152614231,
    "dropsitcph": 7152614221,
    "dropfax": 7152614261
  },
  {
    "dcode": "D",
    "dropkey": "PY18276",
    "droptype": "D",
    "dropname": "WAUSAUKEE",
    "dropdeladd": "614 MAIN ST",
    "dropdelcty": "WAUSAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 541779800,
    "dropphyadd": "614 MAIN ST",
    "dropphycty": "WAUSAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 541779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUSAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 541779998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158565311,
    "dropsitcph": 7158565311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18277",
    "droptype": "D",
    "dropname": "WAUTOMA",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "WAUTOMA",
    "dropdelst": "WI",
    "dropdelzpp": 549825409,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "WAUTOMA",
    "dropphyst": "WI",
    "dropphyzpp": 549825409,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUTOMA",
    "dropmalst": "WI",
    "dropmalzpp": 549829998,
    "dropsitphn": 9207872520,
    "dropsitlph": 9207872520,
    "dropsitcph": 9207872520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18280",
    "droptype": "D",
    "dropname": "WAUZEKA",
    "dropdeladd": "213C E FRONT ST",
    "dropdelcty": "WAUZEKA",
    "dropdelst": "WI",
    "dropdelzpp": 538269682,
    "dropphyadd": "213C E FRONT ST",
    "dropphycty": "WAUZEKA",
    "dropphyst": "WI",
    "dropphyzpp": 538269682,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUZEKA",
    "dropmalst": "WI",
    "dropmalzpp": 538269998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088756031,
    "dropsitcph": 2623930684,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18283",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "7426 MAIN ST W",
    "dropdelcty": "WEBSTER",
    "dropdelst": "WI",
    "dropdelzpp": 548938206,
    "dropphyadd": "7426 MAIN ST W",
    "dropphycty": "WEBSTER",
    "dropphyst": "WI",
    "dropphyzpp": 548938206,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBSTER",
    "dropmalst": "WI",
    "dropmalzpp": 548939998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7158664303,
    "dropfax": 7158664092
  },
  {
    "dcode": "D",
    "dropkey": "PY18288",
    "droptype": "D",
    "dropname": "WEST BEND",
    "dropdeladd": "607 ELM ST",
    "dropdelcty": "WEST BEND",
    "dropdelst": "WI",
    "dropdelzpp": 530959998,
    "dropphyadd": "607 ELM ST",
    "dropphycty": "WEST BEND",
    "dropphyst": "WI",
    "dropphyzpp": 530959998,
    "dropmaladd": "607 ELM ST",
    "dropmalcty": "WEST BEND",
    "dropmalst": "WI",
    "dropmalzpp": 530959998,
    "dropsitphn": 2622702120,
    "dropsitlph": 2623343677,
    "dropsitcph": 2623343299,
    "dropfax": 2623340818
  },
  {
    "dcode": "D",
    "dropkey": "PY18294",
    "droptype": "D",
    "dropname": "WEST SALEM",
    "dropdeladd": "111 LEONARD ST N",
    "dropdelcty": "WEST SALEM",
    "dropdelst": "WI",
    "dropdelzpp": 546691624,
    "dropphyadd": "111 LEONARD ST N",
    "dropphycty": "WEST SALEM",
    "dropphyst": "WI",
    "dropphyzpp": 546691624,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST SALEM",
    "dropmalst": "WI",
    "dropmalzpp": 546699998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084303070,
    "dropfax": 6087861497
  },
  {
    "dcode": "D",
    "dropkey": "PY18295",
    "droptype": "D",
    "dropname": "WESTBORO",
    "dropdeladd": "N8875 BUSINESS HIGHWAY 13",
    "dropdelcty": "WESTBORO",
    "dropdelst": "WI",
    "dropdelzpp": 544909498,
    "dropphyadd": "N8875 BUSINESS HIGHWAY 13",
    "dropphycty": "WESTBORO",
    "dropphyst": "WI",
    "dropphyzpp": 544909498,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTBORO",
    "dropmalst": "WI",
    "dropmalzpp": 544909998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154273307,
    "dropsitcph": 7154273307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18296",
    "droptype": "D",
    "dropname": "WESTBY",
    "dropdeladd": "102 MELBY ST",
    "dropdelcty": "WESTBY",
    "dropdelst": "WI",
    "dropdelzpp": 546671012,
    "dropphyadd": "102 MELBY ST",
    "dropphycty": "WESTBY",
    "dropphyst": "WI",
    "dropphyzpp": 546671012,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTBY",
    "dropmalst": "WI",
    "dropmalzpp": 546679998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084517103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18298",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "108 E 2ND ST",
    "dropdelcty": "WESTFIELD",
    "dropdelst": "WI",
    "dropdelzpp": 539649142,
    "dropphyadd": "108 E 2ND ST",
    "dropphycty": "WESTFIELD",
    "dropphyst": "WI",
    "dropphyzpp": 539649142,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTFIELD",
    "dropmalst": "WI",
    "dropmalzpp": 539649998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082962373,
    "dropsitcph": 6082962373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18303",
    "droptype": "D",
    "dropname": "WEYAUWEGA",
    "dropdeladd": "104 N PINE ST",
    "dropdelcty": "WEYAUWEGA",
    "dropdelst": "WI",
    "dropdelzpp": 549839800,
    "dropphyadd": "104 N PINE ST",
    "dropphycty": "WEYAUWEGA",
    "dropphyst": "WI",
    "dropphyzpp": 549839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEYAUWEGA",
    "dropmalst": "WI",
    "dropmalzpp": 549839998,
    "dropsitphn": 9208672644,
    "dropsitlph": 9208672644,
    "dropsitcph": 9208672644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18304",
    "droptype": "D",
    "dropname": "WEYERHAEUSER",
    "dropdeladd": "W14392 RAILWAY AVE",
    "dropdelcty": "WEYERHAEUSER",
    "dropdelst": "WI",
    "dropdelzpp": 548958709,
    "dropphyadd": "W14392 RAILWAY AVE",
    "dropphycty": "WEYERHAEUSER",
    "dropphyst": "WI",
    "dropphyzpp": 548958709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEYERHAEUSER",
    "dropmalst": "WI",
    "dropmalzpp": 548959998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7153532321,
    "dropfax": 7153533006
  },
  {
    "dcode": "D",
    "dropkey": "PY18305",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "404 W MAIN AVE",
    "dropdelcty": "WHEELER",
    "dropdelst": "WI",
    "dropdelzpp": 547728404,
    "dropphyadd": "404 W MAIN AVE",
    "dropphycty": "WHEELER",
    "dropphyst": "WI",
    "dropphyzpp": 547728404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEELER",
    "dropmalst": "WI",
    "dropmalzpp": 547729998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7156322022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18307",
    "droptype": "D",
    "dropname": "WHITE LAKE",
    "dropdeladd": "621 SCHOOL ST",
    "dropdelcty": "WHITE LAKE",
    "dropdelst": "WI",
    "dropdelzpp": 544919436,
    "dropphyadd": "621 SCHOOL ST",
    "dropphycty": "WHITE LAKE",
    "dropphyst": "WI",
    "dropphyzpp": 544919436,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE LAKE",
    "dropmalst": "WI",
    "dropmalzpp": 544919998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7158822926,
    "dropsitcph": 7158822926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18309",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "36451 ELLIS ST",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "WI",
    "dropdelzpp": 547735000,
    "dropphyadd": "36451 ELLIS ST",
    "dropphycty": "WHITEHALL",
    "dropphyst": "WI",
    "dropphyzpp": 547735000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITEHALL",
    "dropmalst": "WI",
    "dropmalzpp": 547739998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7155382015,
    "dropfax": 7155384599
  },
  {
    "dcode": "D",
    "dropkey": "PY18310",
    "droptype": "D",
    "dropname": "WHITELAW",
    "dropdeladd": "128 E MENASHA AVE",
    "dropdelcty": "WHITELAW",
    "dropdelst": "WI",
    "dropdelzpp": 542479556,
    "dropphyadd": "128 E MENASHA AVE",
    "dropphycty": "WHITELAW",
    "dropphyst": "WI",
    "dropphyzpp": 542479556,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITELAW",
    "dropmalst": "WI",
    "dropmalzpp": 542479998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9207323429,
    "dropsitcph": 9207323429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18311",
    "droptype": "D",
    "dropname": "WHITEWATER",
    "dropdeladd": "213 W CENTER ST",
    "dropdelcty": "WHITEWATER",
    "dropdelst": "WI",
    "dropdelzpp": 531901911,
    "dropphyadd": "213 W CENTER ST",
    "dropphycty": "WHITEWATER",
    "dropphyst": "WI",
    "dropphyzpp": 531901911,
    "dropmaladd": "213 W CENTER ST",
    "dropmalcty": "WHITEWATER",
    "dropmalst": "WI",
    "dropmalzpp": 531909998,
    "dropsitphn": 4143637741,
    "dropsitlph": 4142702120,
    "dropsitcph": 2624732103,
    "dropfax": 2624735680
  },
  {
    "dcode": "D",
    "dropkey": "PY18319",
    "droptype": "D",
    "dropname": "WILD ROSE",
    "dropdeladd": "801 MAIN ST",
    "dropdelcty": "WILD ROSE",
    "dropdelst": "WI",
    "dropdelzpp": 549846889,
    "dropphyadd": "801 MAIN ST",
    "dropphycty": "WILD ROSE",
    "dropphyst": "WI",
    "dropphyzpp": 549846889,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILD ROSE",
    "dropmalst": "WI",
    "dropmalzpp": 549849998,
    "dropsitphn": 9206223406,
    "dropsitlph": 9206223406,
    "dropsitcph": 9206223406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18321",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "W8120 MAIN ST",
    "dropdelcty": "WILLARD",
    "dropdelst": "WI",
    "dropdelzpp": 544938856,
    "dropphyadd": "W8120 MAIN ST",
    "dropphycty": "WILLARD",
    "dropphyst": "WI",
    "dropphyzpp": 544938856,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLARD",
    "dropmalst": "WI",
    "dropmalzpp": 544939998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152676448,
    "dropsitcph": 7152676448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18322",
    "droptype": "D",
    "dropname": "WILLIAMS BAY",
    "dropdeladd": "129 N WALWORTH AVE",
    "dropdelcty": "WILLIAMS BAY",
    "dropdelst": "WI",
    "dropdelzpp": 531910017,
    "dropphyadd": "129 N WALWORTH AVE",
    "dropphycty": "WILLIAMS BAY",
    "dropphyst": "WI",
    "dropphyzpp": 531910017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMS BAY",
    "dropmalst": "WI",
    "dropmalzpp": 531919998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622455183,
    "dropfax": 2622451087
  },
  {
    "dcode": "D",
    "dropkey": "PY18323",
    "droptype": "D",
    "dropname": "WILMOT",
    "dropdeladd": "30725 113TH ST",
    "dropdelcty": "WILMOT",
    "dropdelst": "WI",
    "dropdelzpp": 531929800,
    "dropphyadd": "30725 113TH ST",
    "dropphycty": "WILMOT",
    "dropphyst": "WI",
    "dropphyzpp": 531929800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILMOT",
    "dropmalst": "WI",
    "dropmalzpp": 531929998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628622728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18324",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "120 LAPOINTE RD S",
    "dropdelcty": "WILSON",
    "dropdelst": "WI",
    "dropdelzpp": 540273945,
    "dropphyadd": "120 LAPOINTE RD S",
    "dropphycty": "WILSON",
    "dropphyst": "WI",
    "dropphyzpp": 540273945,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSON",
    "dropmalst": "WI",
    "dropmalzpp": 540279998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152452849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18325",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "418 MAIN ST",
    "dropdelcty": "WILTON",
    "dropdelst": "WI",
    "dropdelzpp": 546708561,
    "dropphyadd": "418 MAIN ST",
    "dropphycty": "WILTON",
    "dropphyst": "WI",
    "dropphyzpp": 546708561,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILTON",
    "dropmalst": "WI",
    "dropmalzpp": 546709998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 6084356833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18329",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "4436 WINDSOR RD",
    "dropdelcty": "WINDSOR",
    "dropdelst": "WI",
    "dropdelzpp": 535989600,
    "dropphyadd": "4436 WINDSOR RD",
    "dropphycty": "WINDSOR",
    "dropphyst": "WI",
    "dropphyzpp": 535989600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDSOR",
    "dropmalst": "WI",
    "dropmalzpp": 535989998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6088469138,
    "dropsitcph": 6088469138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18330",
    "droptype": "D",
    "dropname": "WINNEBAGO",
    "dropdeladd": "4060 COUNTY ROAD A",
    "dropdelcty": "WINNEBAGO",
    "dropdelst": "WI",
    "dropdelzpp": 549859700,
    "dropphyadd": "4060 COUNTY ROAD A",
    "dropphycty": "WINNEBAGO",
    "dropphyst": "WI",
    "dropphyzpp": 549859700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNEBAGO",
    "dropmalst": "WI",
    "dropmalzpp": 549859998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202311782,
    "dropsitcph": 9202320179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18331",
    "droptype": "D",
    "dropname": "WINNECONNE",
    "dropdeladd": "34 S 2ND ST",
    "dropdelcty": "WINNECONNE",
    "dropdelst": "WI",
    "dropdelzpp": 549869396,
    "dropphyadd": "34 S 2ND ST",
    "dropphycty": "WINNECONNE",
    "dropphyst": "WI",
    "dropphyzpp": 549869396,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNECONNE",
    "dropmalst": "WI",
    "dropmalzpp": 549869998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205829405,
    "dropsitcph": 9205829405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18332",
    "droptype": "D",
    "dropname": "WINTER",
    "dropdeladd": "5263 N CEMETERY RD",
    "dropdelcty": "WINTER",
    "dropdelst": "WI",
    "dropdelzpp": 548966178,
    "dropphyadd": "5263 N CEMETERY RD",
    "dropphycty": "WINTER",
    "dropphyst": "WI",
    "dropphyzpp": 548966178,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINTER",
    "dropmalst": "WI",
    "dropmalzpp": 548969998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152602679,
    "dropfax": 7152666036
  },
  {
    "dcode": "D",
    "dropkey": "PY18334",
    "droptype": "D",
    "dropname": "WISCONSIN DELLS",
    "dropdeladd": "310 MINNESOTA AVE",
    "dropdelcty": "WISCONSIN DELLS",
    "dropdelst": "WI",
    "dropdelzpp": 539659998,
    "dropphyadd": "310 MINNESOTA AVE",
    "dropphycty": "WISCONSIN DELLS",
    "dropphyst": "WI",
    "dropphyzpp": 539659998,
    "dropmaladd": "310 MINNESOTA AVE",
    "dropmalcty": "WISCONSIN DELLS",
    "dropmalst": "WI",
    "dropmalzpp": 539659998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082546412,
    "dropsitcph": 6082546412,
    "dropfax": 6082533115
  },
  {
    "dcode": "D",
    "dropkey": "PY18340",
    "droptype": "D",
    "dropname": "WISCONSIN RAPIDS",
    "dropdeladd": "320 E GRAND AVE",
    "dropdelcty": "WISCONSIN RAPIDS",
    "dropdelst": "WI",
    "dropdelzpp": 544949998,
    "dropphyadd": "320 E GRAND AVE",
    "dropphycty": "WISCONSIN RAPIDS",
    "dropphyst": "WI",
    "dropphyzpp": 544949998,
    "dropmaladd": "320 E GRAND AVE",
    "dropmalcty": "WISCONSIN RAPIDS",
    "dropmalst": "WI",
    "dropmalzpp": 544949998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7154232150,
    "dropsitcph": 7154232150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18341",
    "droptype": "D",
    "dropname": "WITHEE",
    "dropdeladd": "505 DIVISION ST",
    "dropdelcty": "WITHEE",
    "dropdelst": "WI",
    "dropdelzpp": 544989800,
    "dropphyadd": "505 DIVISION ST",
    "dropphycty": "WITHEE",
    "dropphyst": "WI",
    "dropphyzpp": 544989800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WITHEE",
    "dropmalst": "WI",
    "dropmalzpp": 544989998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152292109,
    "dropsitcph": 7152292109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18342",
    "droptype": "D",
    "dropname": "WITTENBERG",
    "dropdeladd": "101 W VINAL ST",
    "dropdelcty": "WITTENBERG",
    "dropdelst": "WI",
    "dropdelzpp": 544999800,
    "dropphyadd": "101 W VINAL ST",
    "dropphycty": "WITTENBERG",
    "dropphyst": "WI",
    "dropphyzpp": 544999800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WITTENBERG",
    "dropmalst": "WI",
    "dropmalzpp": 544999998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152532639,
    "dropsitcph": 7152532639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18345",
    "droptype": "D",
    "dropname": "WONEWOC",
    "dropdeladd": "227 CENTER ST",
    "dropdelcty": "WONEWOC",
    "dropdelst": "WI",
    "dropdelzpp": 539688918,
    "dropphyadd": "227 CENTER ST",
    "dropphycty": "WONEWOC",
    "dropphyst": "WI",
    "dropphyzpp": 539688918,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WONEWOC",
    "dropmalst": "WI",
    "dropmalzpp": 539689998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084645522,
    "dropsitcph": 6084645522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18348",
    "droptype": "D",
    "dropname": "WOODFORD",
    "dropdeladd": "10700 MAIN ST",
    "dropdelcty": "WOODFORD",
    "dropdelst": "WI",
    "dropdelzpp": 535999700,
    "dropphyadd": "10700 MAIN ST",
    "dropphycty": "WOODFORD",
    "dropphyst": "WI",
    "dropphyzpp": 535999700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODFORD",
    "dropmalst": "WI",
    "dropmalzpp": 535999998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084653400,
    "dropsitcph": 6084653400,
    "dropfax": 6084653400
  },
  {
    "dcode": "D",
    "dropkey": "PY18349",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "N4997 COUNTY ROAD WS",
    "dropdelcty": "WOODLAND",
    "dropdelst": "WI",
    "dropdelzpp": 530999800,
    "dropphyadd": "N4997 COUNTY ROAD WS",
    "dropphycty": "WOODLAND",
    "dropphyst": "WI",
    "dropphyzpp": 530999800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODLAND",
    "dropmalst": "WI",
    "dropmalzpp": 530999998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 9206253309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18351",
    "droptype": "D",
    "dropname": "WOODRUFF",
    "dropdeladd": "610 VETERANS PKWY",
    "dropdelcty": "WOODRUFF",
    "dropdelst": "WI",
    "dropdelzpp": 545689483,
    "dropphyadd": "610 VETERANS PKWY",
    "dropphycty": "WOODRUFF",
    "dropphyst": "WI",
    "dropphyzpp": 545689483,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODRUFF",
    "dropmalst": "WI",
    "dropmalzpp": 545689998,
    "dropsitphn": 4142702120,
    "dropsitlph": 7153565577,
    "dropsitcph": 7153565577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18352",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 540289544,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "WOODVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 540289544,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 540289998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6122933064,
    "dropsitcph": 7152482017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18355",
    "droptype": "D",
    "dropname": "WOODWORTH",
    "dropdeladd": "8105 160TH AVE",
    "dropdelcty": "WOODWORTH",
    "dropdelst": "WI",
    "dropdelzpp": 531949800,
    "dropphyadd": "8105 160TH AVE",
    "dropphycty": "WOODWORTH",
    "dropphyst": "WI",
    "dropphyzpp": 531949800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODWORTH",
    "dropmalst": "WI",
    "dropmalzpp": 531949998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2628577300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18357",
    "droptype": "D",
    "dropname": "WRIGHTSTOWN",
    "dropdeladd": "450 HIGH ST STE 6B",
    "dropdelcty": "WRIGHTSTOWN",
    "dropdelst": "WI",
    "dropdelzpp": 541801253,
    "dropphyadd": "450 HIGH ST STE 6B",
    "dropphycty": "WRIGHTSTOWN",
    "dropphyst": "WI",
    "dropphyzpp": 541801253,
    "dropmaladd": "450 HIGH ST STE 6B",
    "dropmalcty": "WRIGHTSTOWN",
    "dropmalst": "WI",
    "dropmalzpp": 541801253,
    "dropsitphn": 4142702120,
    "dropsitlph": 9205320517,
    "dropsitcph": 9205322004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18360",
    "droptype": "D",
    "dropname": "WYOCENA",
    "dropdeladd": "230 S WASHINGTON ST",
    "dropdelcty": "WYOCENA",
    "dropdelst": "WI",
    "dropdelzpp": 539699700,
    "dropphyadd": "230 S WASHINGTON ST",
    "dropphycty": "WYOCENA",
    "dropphyst": "WI",
    "dropphyzpp": 539699700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYOCENA",
    "dropmalst": "WI",
    "dropmalzpp": 539699998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6084293641,
    "dropsitcph": 6084293641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY18365",
    "droptype": "D",
    "dropname": "ZENDA",
    "dropdeladd": "W3724 FRANKLIN WALSH ST",
    "dropdelcty": "ZENDA",
    "dropdelst": "WI",
    "dropdelzpp": 531959801,
    "dropphyadd": "W3724 FRANKLIN WALSH ST",
    "dropphycty": "ZENDA",
    "dropphyst": "WI",
    "dropphyzpp": 531959801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZENDA",
    "dropmalst": "WI",
    "dropmalzpp": 531959998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702120,
    "dropsitcph": 2622752216,
    "dropfax": 2622751001
  },
  {
    "dcode": "D",
    "dropkey": "PY18451",
    "droptype": "D",
    "dropname": "MUSCLE SHOALS",
    "dropdeladd": "2350 AVALON AVE",
    "dropdelcty": "MUSCLE SHOALS",
    "dropdelst": "AL",
    "dropdelzpp": 356613182,
    "dropphyadd": "2350 AVALON AVE",
    "dropphycty": "MUSCLE SHOALS",
    "dropphyst": "AL",
    "dropphyzpp": 356613182,
    "dropmaladd": "2350 AVALON AVE",
    "dropmalcty": "MUSCLE SHOALS",
    "dropmalst": "AL",
    "dropmalzpp": 356619998,
    "dropsitphn": 2563815908,
    "dropsitlph": 2563815908,
    "dropsitcph": 2563815908,
    "dropfax": 2563839298
  },
  {
    "dcode": "D",
    "dropkey": "PY18641",
    "droptype": "D",
    "dropname": "WATER VALLEY",
    "dropdeladd": "501 N MAIN ST",
    "dropdelcty": "WATER VALLEY",
    "dropdelst": "MS",
    "dropdelzpp": 389659998,
    "dropphyadd": "501 N MAIN ST",
    "dropphycty": "WATER VALLEY",
    "dropphyst": "MS",
    "dropphyzpp": 389659998,
    "dropmaladd": "501 N MAIN ST",
    "dropmalcty": "WATER VALLEY",
    "dropmalst": "MS",
    "dropmalzpp": 389659998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6624731721,
    "dropsitcph": 6624733004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20001",
    "droptype": "D",
    "dropname": "APO",
    "dropdeladd": "11698 NW 25TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331129997,
    "dropphyadd": "11698 NW 25TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331129997,
    "dropmaladd": "11698 NW 25TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331129997,
    "dropsitphn": 3058713327,
    "dropsitlph": "",
    "dropsitcph": 3057187501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20011",
    "droptype": "D",
    "dropname": "ADONA",
    "dropdeladd": "1892 HIGHWAY 10 W",
    "dropdelcty": "ADONA",
    "dropdelst": "AR",
    "dropdelzpp": 720019998,
    "dropphyadd": "1892 HIGHWAY 10 W",
    "dropphycty": "ADONA",
    "dropphyst": "AR",
    "dropphyzpp": 720019998,
    "dropmaladd": "1892 HIGHWAY 10 W",
    "dropmalcty": "ADONA",
    "dropmalst": "AR",
    "dropmalzpp": 720019998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016626046,
    "dropsitcph": 5016626046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20019",
    "droptype": "D",
    "dropname": "ALEXANDER",
    "dropdeladd": "15604 ALEXANDER RD",
    "dropdelcty": "ALEXANDER",
    "dropdelst": "AR",
    "dropdelzpp": 720029998,
    "dropphyadd": "15604 ALEXANDER RD",
    "dropphycty": "ALEXANDER",
    "dropphyst": "AR",
    "dropphyzpp": 720029998,
    "dropmaladd": "15604 ALEXANDER RD",
    "dropmalcty": "ALEXANDER",
    "dropmalst": "AR",
    "dropmalzpp": 720029998,
    "dropsitphn": 5014551637,
    "dropsitlph": 5014551637,
    "dropsitcph": 5014551637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20022",
    "droptype": "D",
    "dropname": "ALIX",
    "dropdeladd": "3229 HIGHWAY 186",
    "dropdelcty": "ALIX",
    "dropdelst": "AR",
    "dropdelzpp": 728209998,
    "dropphyadd": "3229 HIGHWAY 186",
    "dropphycty": "ALIX",
    "dropphyst": "AR",
    "dropphyzpp": 728209998,
    "dropmaladd": "3229 HIGHWAY 186",
    "dropmalcty": "ALIX",
    "dropmalst": "AR",
    "dropmalzpp": 728209998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794680306,
    "dropsitcph": 4794680306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20023",
    "droptype": "D",
    "dropname": "ALLEENE",
    "dropdeladd": "1845 ARKANSAS STATE HIGHWAY 234",
    "dropdelcty": "ALLEENE",
    "dropdelst": "AR",
    "dropdelzpp": 718209998,
    "dropphyadd": "1845 ARKANSAS STATE HIGHWAY 234",
    "dropphycty": "ALLEENE",
    "dropphyst": "AR",
    "dropphyzpp": 718209998,
    "dropmaladd": "1845 ARKANSAS STATE HIGHWAY 234",
    "dropmalcty": "ALLEENE",
    "dropmalst": "AR",
    "dropmalzpp": 718209998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706006301,
    "dropsitcph": 8706006301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20025",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "524 HIGHWAY 64 E",
    "dropdelcty": "ALMA",
    "dropdelst": "AR",
    "dropdelzpp": 729219998,
    "dropphyadd": "524 HIGHWAY 64 E",
    "dropphycty": "ALMA",
    "dropphyst": "AR",
    "dropphyzpp": 729219998,
    "dropmaladd": "524 HIGHWAY 64 E",
    "dropmalcty": "ALMA",
    "dropmalst": "AR",
    "dropmalzpp": 729219998,
    "dropsitphn": 4796325898,
    "dropsitlph": 4796322093,
    "dropsitcph": 4796322093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20026",
    "droptype": "D",
    "dropname": "ALMYRA",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "ALMYRA",
    "dropdelst": "AR",
    "dropdelzpp": 720039998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "ALMYRA",
    "dropphyst": "AR",
    "dropphyzpp": 720039998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "ALMYRA",
    "dropmalst": "AR",
    "dropmalzpp": 720039998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709923476,
    "dropsitcph": 8709923476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20027",
    "droptype": "D",
    "dropname": "ALPENA",
    "dropdeladd": "105 N DENTON ST",
    "dropdelcty": "ALPENA",
    "dropdelst": "AR",
    "dropdelzpp": 726119998,
    "dropphyadd": "105 N DENTON ST",
    "dropphycty": "ALPENA",
    "dropphyst": "AR",
    "dropphyzpp": 726119998,
    "dropmaladd": "105 N DENTON ST",
    "dropmalcty": "ALPENA",
    "dropmalst": "AR",
    "dropmalzpp": 726119998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704372472,
    "dropsitcph": 8704372472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20030",
    "droptype": "D",
    "dropname": "ALTHEIMER",
    "dropdeladd": "200 W FRONT ST",
    "dropdelcty": "ALTHEIMER",
    "dropdelst": "AR",
    "dropdelzpp": 720049998,
    "dropphyadd": "200 W FRONT ST",
    "dropphycty": "ALTHEIMER",
    "dropphyst": "AR",
    "dropphyzpp": 720049998,
    "dropmaladd": "200 W FRONT ST",
    "dropmalcty": "ALTHEIMER",
    "dropmalst": "AR",
    "dropmalzpp": 720049998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707668696,
    "dropsitcph": 8707668696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20031",
    "droptype": "D",
    "dropname": "ALTUS",
    "dropdeladd": "21 E MAIN ST",
    "dropdelcty": "ALTUS",
    "dropdelst": "AR",
    "dropdelzpp": 728219998,
    "dropphyadd": "21 E MAIN ST",
    "dropphycty": "ALTUS",
    "dropphyst": "AR",
    "dropphyzpp": 728219998,
    "dropmaladd": "21 E MAIN ST",
    "dropmalcty": "ALTUS",
    "dropmalst": "AR",
    "dropmalzpp": 728219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794683311,
    "dropsitcph": 4794683311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20032",
    "droptype": "D",
    "dropname": "AMAGON",
    "dropdeladd": "300 AMAGON AVE",
    "dropdelcty": "AMAGON",
    "dropdelst": "AR",
    "dropdelzpp": 720059998,
    "dropphyadd": "300 AMAGON AVE",
    "dropphycty": "AMAGON",
    "dropphyst": "AR",
    "dropphyzpp": 720059998,
    "dropmaladd": "300 AMAGON AVE",
    "dropmalcty": "AMAGON",
    "dropmalst": "AR",
    "dropmalzpp": 720059998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705235667,
    "dropsitcph": 8705235667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20034",
    "droptype": "D",
    "dropname": "AMITY",
    "dropdeladd": "136 W THOMPSON ST",
    "dropdelcty": "AMITY",
    "dropdelst": "AR",
    "dropdelzpp": 719219998,
    "dropphyadd": "136 W THOMPSON ST",
    "dropphycty": "AMITY",
    "dropphyst": "AR",
    "dropphyzpp": 719219998,
    "dropmaladd": "136 W THOMPSON ST",
    "dropmalcty": "AMITY",
    "dropmalst": "AR",
    "dropmalzpp": 719219998,
    "dropsitphn": 8703425671,
    "dropsitlph": 8703425671,
    "dropsitcph": 8703425671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20037",
    "droptype": "D",
    "dropname": "ANTOINE",
    "dropdeladd": "40 E MAIN ST",
    "dropdelcty": "ANTOINE",
    "dropdelst": "AR",
    "dropdelzpp": 719229998,
    "dropphyadd": "40 E MAIN ST",
    "dropphycty": "ANTOINE",
    "dropphyst": "AR",
    "dropphyzpp": 719229998,
    "dropmaladd": "40 E MAIN ST",
    "dropmalcty": "ANTOINE",
    "dropmalst": "AR",
    "dropmalzpp": 719229998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703792545,
    "dropsitcph": 8703792545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20041",
    "droptype": "D",
    "dropname": "ARKADELPHIA",
    "dropdeladd": "615 CRITTENDEN ST",
    "dropdelcty": "ARKADELPHIA",
    "dropdelst": "AR",
    "dropdelzpp": 719239998,
    "dropphyadd": "615 CRITTENDEN ST",
    "dropphycty": "ARKADELPHIA",
    "dropphyst": "AR",
    "dropphyzpp": 719239998,
    "dropmaladd": "615 CRITTENDEN ST",
    "dropmalcty": "ARKADELPHIA",
    "dropmalst": "AR",
    "dropmalzpp": 719239998,
    "dropsitphn": 8702466715,
    "dropsitlph": 8702466715,
    "dropsitcph": 8702466715,
    "dropfax": 8702462479
  },
  {
    "dcode": "D",
    "dropkey": "PY20042",
    "droptype": "D",
    "dropname": "ARKANSAS CITY",
    "dropdeladd": "201 SPRAGUE ST",
    "dropdelcty": "ARKANSAS CITY",
    "dropdelst": "AR",
    "dropdelzpp": 716309998,
    "dropphyadd": "201 SPRAGUE ST",
    "dropphycty": "ARKANSAS CITY",
    "dropphyst": "AR",
    "dropphyzpp": 716309998,
    "dropmaladd": "201 SPRAGUE ST",
    "dropmalcty": "ARKANSAS CITY",
    "dropmalst": "AR",
    "dropmalzpp": 716309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708772454,
    "dropsitcph": 8708772454,
    "dropfax": 8708772454
  },
  {
    "dcode": "D",
    "dropkey": "PY20046",
    "droptype": "D",
    "dropname": "ARMOREL",
    "dropdeladd": "4606 N STATE HIGHWAY 137",
    "dropdelcty": "ARMOREL",
    "dropdelst": "AR",
    "dropdelzpp": 723109998,
    "dropphyadd": "4606 N STATE HIGHWAY 137",
    "dropphycty": "ARMOREL",
    "dropphyst": "AR",
    "dropphyzpp": 723109998,
    "dropmaladd": "4606 N STATE HIGHWAY 137",
    "dropmalcty": "ARMOREL",
    "dropmalst": "AR",
    "dropmalzpp": 723109998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707621124,
    "dropsitcph": 8707621124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20049",
    "droptype": "D",
    "dropname": "ASH FLAT",
    "dropdeladd": "34 W MAIN ST",
    "dropdelcty": "ASH FLAT",
    "dropdelst": "AR",
    "dropdelzpp": 725139998,
    "dropphyadd": "34 W MAIN ST",
    "dropphycty": "ASH FLAT",
    "dropphyst": "AR",
    "dropphyzpp": 725139998,
    "dropmaladd": "34 W MAIN ST",
    "dropmalcty": "ASH FLAT",
    "dropmalst": "AR",
    "dropmalzpp": 725139998,
    "dropsitphn": 8709947308,
    "dropsitlph": 8709947308,
    "dropsitcph": 8709947308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20050",
    "droptype": "D",
    "dropname": "ASHDOWN",
    "dropdeladd": "451 E LOCKE ST",
    "dropdelcty": "ASHDOWN",
    "dropdelst": "AR",
    "dropdelzpp": 718229998,
    "dropphyadd": "451 E LOCKE ST",
    "dropphycty": "ASHDOWN",
    "dropphyst": "AR",
    "dropphyzpp": 718229998,
    "dropmaladd": "451 E LOCKE ST",
    "dropmalcty": "ASHDOWN",
    "dropmalst": "AR",
    "dropmalzpp": 718229998,
    "dropsitphn": 8708982110,
    "dropsitlph": 8708982110,
    "dropsitcph": 8708982110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20054",
    "droptype": "D",
    "dropname": "ATKINS",
    "dropdeladd": "705 N CHURCH ST",
    "dropdelcty": "ATKINS",
    "dropdelst": "AR",
    "dropdelzpp": 728239998,
    "dropphyadd": "705 N CHURCH ST",
    "dropphycty": "ATKINS",
    "dropphyst": "AR",
    "dropphyzpp": 728239998,
    "dropmaladd": "705 N CHURCH ST",
    "dropmalcty": "ATKINS",
    "dropmalst": "AR",
    "dropmalzpp": 728239998,
    "dropsitphn": 4796412067,
    "dropsitlph": 4796417210,
    "dropsitcph": 4796417210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20055",
    "droptype": "D",
    "dropname": "AUBREY",
    "dropdeladd": "3566 HIGHWAY 121 S",
    "dropdelcty": "AUBREY",
    "dropdelst": "AR",
    "dropdelzpp": 723119998,
    "dropphyadd": "3566 HIGHWAY 121 S",
    "dropphycty": "AUBREY",
    "dropphyst": "AR",
    "dropphyzpp": 723119998,
    "dropmaladd": "3566 HIGHWAY 121 S",
    "dropmalcty": "AUBREY",
    "dropmalst": "AR",
    "dropmalzpp": 723119998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702959211,
    "dropsitcph": 8702959211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20056",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "AR",
    "dropdelzpp": 720069998,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "AR",
    "dropphyzpp": 720069998,
    "dropmaladd": "120 MAIN ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "AR",
    "dropmalzpp": 720069998,
    "dropsitphn": 8703472725,
    "dropsitlph": 8703472725,
    "dropsitcph": 8703472725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20057",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "3385 HIGHWAY 367 N",
    "dropdelcty": "AUSTIN",
    "dropdelst": "AR",
    "dropdelzpp": 720079998,
    "dropphyadd": "3385 HIGHWAY 367 N",
    "dropphycty": "AUSTIN",
    "dropphyst": "AR",
    "dropphyzpp": 720079998,
    "dropmaladd": "3385 HIGHWAY 367 N",
    "dropmalcty": "AUSTIN",
    "dropmalst": "AR",
    "dropmalzpp": 720079998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018433975,
    "dropsitcph": 5018433975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20061",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "280 HIGHWAY 62 N",
    "dropdelcty": "AVOCA",
    "dropdelst": "AR",
    "dropdelzpp": 727119998,
    "dropphyadd": "280 HIGHWAY 62 N",
    "dropphycty": "AVOCA",
    "dropphyst": "AR",
    "dropphyzpp": 727119998,
    "dropmaladd": "280 HIGHWAY 62 N",
    "dropmalcty": "AVOCA",
    "dropmalst": "AR",
    "dropmalzpp": 727119998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796366053,
    "dropsitcph": 4796366053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20064",
    "droptype": "D",
    "dropname": "BALD KNOB",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "BALD KNOB",
    "dropdelst": "AR",
    "dropdelzpp": 720109998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "BALD KNOB",
    "dropphyst": "AR",
    "dropphyzpp": 720109998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "BALD KNOB",
    "dropmalst": "AR",
    "dropmalzpp": 720109998,
    "dropsitphn": 5012078105,
    "dropsitlph": 5012078105,
    "dropsitcph": 5012078105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20066",
    "droptype": "D",
    "dropname": "BANKS",
    "dropdeladd": "205 E BUCK FEVER HWY",
    "dropdelcty": "BANKS",
    "dropdelst": "AR",
    "dropdelzpp": 716319998,
    "dropphyadd": "205 E BUCK FEVER HWY",
    "dropphycty": "BANKS",
    "dropphyst": "AR",
    "dropphyzpp": 716319998,
    "dropmaladd": "205 E BUCK FEVER HWY",
    "dropmalcty": "BANKS",
    "dropmalst": "AR",
    "dropmalzpp": 716319998,
    "dropsitphn": 8704652315,
    "dropsitlph": 8704652315,
    "dropsitcph": 8704652315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20069",
    "droptype": "D",
    "dropname": "BARTON",
    "dropdeladd": "9353 HIGHWAY 85 S",
    "dropdelcty": "BARTON",
    "dropdelst": "AR",
    "dropdelzpp": 723129998,
    "dropphyadd": "9353 HIGHWAY 85 S",
    "dropphycty": "BARTON",
    "dropphyst": "AR",
    "dropphyzpp": 723129998,
    "dropmaladd": "9353 HIGHWAY 85 S",
    "dropmalcty": "BARTON",
    "dropmalst": "AR",
    "dropmalzpp": 723129998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705729533,
    "dropsitcph": 8705729533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20073",
    "droptype": "D",
    "dropname": "BASSETT",
    "dropdeladd": "414 HIGHWAY 61",
    "dropdelcty": "BASSETT",
    "dropdelst": "AR",
    "dropdelzpp": 723139998,
    "dropphyadd": "414 HIGHWAY 61",
    "dropphycty": "BASSETT",
    "dropphyst": "AR",
    "dropphyzpp": 723139998,
    "dropmaladd": "414 HIGHWAY 61",
    "dropmalcty": "BASSETT",
    "dropmalst": "AR",
    "dropmalzpp": 723139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705374611,
    "dropsitcph": 8705374611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20076",
    "droptype": "D",
    "dropname": "BATESVILLE",
    "dropdeladd": "490 E COLLEGE ST STE 139",
    "dropdelcty": "BATESVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 725019998,
    "dropphyadd": "490 E COLLEGE ST STE 139",
    "dropphycty": "BATESVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 725019998,
    "dropmaladd": "490 E COLLEGE ST STE 139",
    "dropmalcty": "BATESVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 725019998,
    "dropsitphn": 8707936829,
    "dropsitlph": 8707936828,
    "dropsitcph": 8707936828,
    "dropfax": 8706980314
  },
  {
    "dcode": "D",
    "dropkey": "PY20078",
    "droptype": "D",
    "dropname": "BAUXITE",
    "dropdeladd": "301 BAUXITE CUTOFF RD",
    "dropdelcty": "BAUXITE",
    "dropdelst": "AR",
    "dropdelzpp": 720119998,
    "dropphyadd": "301 BAUXITE CUTOFF RD",
    "dropphycty": "BAUXITE",
    "dropphyst": "AR",
    "dropphyzpp": 720119998,
    "dropmaladd": "301 BAUXITE CUTOFF RD",
    "dropmalcty": "BAUXITE",
    "dropmalst": "AR",
    "dropmalzpp": 720119998,
    "dropsitphn": 5016022944,
    "dropsitlph": 5016022944,
    "dropsitcph": 5015575531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20080",
    "droptype": "D",
    "dropname": "BAY",
    "dropdeladd": "410 N MAIN ST",
    "dropdelcty": "BAY",
    "dropdelst": "AR",
    "dropdelzpp": 724119998,
    "dropphyadd": "410 N MAIN ST",
    "dropphycty": "BAY",
    "dropphyst": "AR",
    "dropphyzpp": 724119998,
    "dropmaladd": "410 N MAIN ST",
    "dropmalcty": "BAY",
    "dropmalst": "AR",
    "dropmalzpp": 724119998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707813600,
    "dropsitcph": 8707813600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20084",
    "droptype": "D",
    "dropname": "BEARDEN",
    "dropdeladd": "160 N PLUM ST",
    "dropdelcty": "BEARDEN",
    "dropdelst": "AR",
    "dropdelzpp": 717209998,
    "dropphyadd": "160 N PLUM ST",
    "dropphycty": "BEARDEN",
    "dropphyst": "AR",
    "dropphyzpp": 717209998,
    "dropmaladd": "160 N PLUM ST",
    "dropmalcty": "BEARDEN",
    "dropmalst": "AR",
    "dropmalzpp": 717209998,
    "dropsitphn": 8704542191,
    "dropsitlph": 8704542191,
    "dropsitcph": 8704542191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20086",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "306 SQUIRE BEAVER RD",
    "dropdelcty": "BEAVER",
    "dropdelst": "AR",
    "dropdelzpp": 726138800,
    "dropphyadd": "306 SQUIRE BEAVER RD",
    "dropphycty": "BEAVER",
    "dropphyst": "AR",
    "dropphyzpp": 726138800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "AR",
    "dropmalzpp": 726139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792538817,
    "dropsitcph": 4792538817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20087",
    "droptype": "D",
    "dropname": "BEE BRANCH",
    "dropdeladd": "148 HIGHWAY 92 E",
    "dropdelcty": "BEE BRANCH",
    "dropdelst": "AR",
    "dropdelzpp": 720139998,
    "dropphyadd": "148 HIGHWAY 92 E",
    "dropphycty": "BEE BRANCH",
    "dropphyst": "AR",
    "dropphyzpp": 720139998,
    "dropmaladd": "148 HIGHWAY 92 E",
    "dropmalcty": "BEE BRANCH",
    "dropmalst": "AR",
    "dropmalzpp": 720139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016542293,
    "dropsitcph": 5016542293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20088",
    "droptype": "D",
    "dropname": "BEEBE",
    "dropdeladd": "201 E CENTER ST",
    "dropdelcty": "BEEBE",
    "dropdelst": "AR",
    "dropdelzpp": 720129998,
    "dropphyadd": "201 E CENTER ST",
    "dropphycty": "BEEBE",
    "dropphyst": "AR",
    "dropphyzpp": 720129998,
    "dropmaladd": "201 E CENTER ST",
    "dropmalcty": "BEEBE",
    "dropmalst": "AR",
    "dropmalzpp": 720129998,
    "dropsitphn": 5018823373,
    "dropsitlph": 5018823373,
    "dropsitcph": 5018823373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20090",
    "droptype": "D",
    "dropname": "BEECH GROVE",
    "dropdeladd": "9034 HIGHWAY 141 N",
    "dropdelcty": "BEECH GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 724129998,
    "dropphyadd": "9034 HIGHWAY 141 N",
    "dropphycty": "BEECH GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 724129998,
    "dropmaladd": "9034 HIGHWAY 141 N",
    "dropmalcty": "BEECH GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 724129998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705860653,
    "dropsitcph": 8705860653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20091",
    "droptype": "D",
    "dropname": "BEEDEVILLE",
    "dropdeladd": "9907 HIGHWAY 37 S",
    "dropdelcty": "BEEDEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720149998,
    "dropphyadd": "9907 HIGHWAY 37 S",
    "dropphycty": "BEEDEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720149998,
    "dropmaladd": "9907 HIGHWAY 37 S",
    "dropmalcty": "BEEDEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720149998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706972150,
    "dropsitcph": 8706972150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20092",
    "droptype": "D",
    "dropname": "BEIRNE",
    "dropdeladd": "16462 HIGHWAY 51 S",
    "dropdelcty": "BEIRNE",
    "dropdelst": "AR",
    "dropdelzpp": 717219998,
    "dropphyadd": "16462 HIGHWAY 51 S",
    "dropphycty": "BEIRNE",
    "dropphyst": "AR",
    "dropphyzpp": 717219998,
    "dropmaladd": "16462 HIGHWAY 51 S",
    "dropmalcty": "BEIRNE",
    "dropmalst": "AR",
    "dropmalzpp": 717219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703534274,
    "dropsitcph": 8703534274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20095",
    "droptype": "D",
    "dropname": "BELLEVILLE",
    "dropdeladd": "109 N MAIN ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728249998,
    "dropphyadd": "109 N MAIN ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728249998,
    "dropmaladd": "109 N MAIN ST",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794932242,
    "dropsitcph": 4794932242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20096",
    "droptype": "D",
    "dropname": "BEN LOMOND",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "BEN LOMOND",
    "dropdelst": "AR",
    "dropdelzpp": 718238800,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "BEN LOMOND",
    "dropphyst": "AR",
    "dropphyzpp": 718238800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEN LOMOND",
    "dropmalst": "AR",
    "dropmalzpp": 718239998,
    "dropsitphn": 8708982110,
    "dropsitlph": 8702874777,
    "dropsitcph": 8702874777,
    "dropfax": 8702874777
  },
  {
    "dcode": "D",
    "dropkey": "PY20098",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "1425 MILITARY RD",
    "dropdelcty": "BENTON",
    "dropdelst": "AR",
    "dropdelzpp": 720159998,
    "dropphyadd": "1425 MILITARY RD",
    "dropphycty": "BENTON",
    "dropphyst": "AR",
    "dropphyzpp": 720159998,
    "dropmaladd": "1425 MILITARY RD",
    "dropmalcty": "BENTON",
    "dropmalst": "AR",
    "dropmalzpp": 720159998,
    "dropsitphn": 5013152307,
    "dropsitlph": 5013152307,
    "dropsitcph": 5013152950,
    "dropfax": 5017787582
  },
  {
    "dcode": "D",
    "dropkey": "PY20099",
    "droptype": "D",
    "dropname": "BENTONVILLE",
    "dropdeladd": "1706 S WALTON BLVD",
    "dropdelcty": "BENTONVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727122500,
    "dropphyadd": "1706 S WALTON BLVD",
    "dropphycty": "BENTONVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727122500,
    "dropmaladd": "1706 S WALTON BLVD",
    "dropmalcty": "BENTONVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727122500,
    "dropsitphn": 4792732722,
    "dropsitlph": 4792732722,
    "dropsitcph": 4792732722,
    "dropfax": 4792731509
  },
  {
    "dcode": "D",
    "dropkey": "PY20101",
    "droptype": "D",
    "dropname": "BERGMAN",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "BERGMAN",
    "dropdelst": "AR",
    "dropdelzpp": 726159998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "BERGMAN",
    "dropphyst": "AR",
    "dropphyzpp": 726159998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "BERGMAN",
    "dropmalst": "AR",
    "dropmalzpp": 726159998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707416015,
    "dropsitcph": 8707416015,
    "dropfax": 8707416015
  },
  {
    "dcode": "D",
    "dropkey": "PY20103",
    "droptype": "D",
    "dropname": "BERRYVILLE",
    "dropdeladd": "101 E MADISON AVE STE 100",
    "dropdelcty": "BERRYVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 726169998,
    "dropphyadd": "101 E MADISON AVE STE 100",
    "dropphycty": "BERRYVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 726169998,
    "dropmaladd": "101 E MADISON AVE STE 100",
    "dropmalcty": "BERRYVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 726169998,
    "dropsitphn": 8707413473,
    "dropsitlph": 8704232044,
    "dropsitcph": 8704232044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20111",
    "droptype": "D",
    "dropname": "BIGGERS",
    "dropdeladd": "3309 BIGGERS REYNO RD",
    "dropdelcty": "BIGGERS",
    "dropdelst": "AR",
    "dropdelzpp": 724139998,
    "dropphyadd": "3309 BIGGERS REYNO RD",
    "dropphycty": "BIGGERS",
    "dropphyst": "AR",
    "dropphyzpp": 724139998,
    "dropmaladd": "3309 BIGGERS REYNO RD",
    "dropmalcty": "BIGGERS",
    "dropmalst": "AR",
    "dropmalzpp": 724139998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707692641,
    "dropsitcph": 8707692641,
    "dropfax": 8707692641
  },
  {
    "dcode": "D",
    "dropkey": "PY20115",
    "droptype": "D",
    "dropname": "BISCOE",
    "dropdeladd": "506 W SPORTSMAN DR",
    "dropdelcty": "BISCOE",
    "dropdelst": "AR",
    "dropdelzpp": 720179998,
    "dropphyadd": "506 W SPORTSMAN DR",
    "dropphycty": "BISCOE",
    "dropphyst": "AR",
    "dropphyzpp": 720179998,
    "dropmaladd": "506 W SPORTSMAN DR",
    "dropmalcty": "BISCOE",
    "dropmalst": "AR",
    "dropmalzpp": 720179998,
    "dropsitphn": 8709987182,
    "dropsitlph": 8703192345,
    "dropsitcph": 8703192345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20116",
    "droptype": "D",
    "dropname": "BISMARCK",
    "dropdeladd": "101 MILLENNIUM PARK DR",
    "dropdelcty": "BISMARCK",
    "dropdelst": "AR",
    "dropdelzpp": 719299998,
    "dropphyadd": "101 MILLENNIUM PARK DR",
    "dropphycty": "BISMARCK",
    "dropphyst": "AR",
    "dropphyzpp": 719299998,
    "dropmaladd": "101 MILLENNIUM PARK DR",
    "dropmalcty": "BISMARCK",
    "dropmalst": "AR",
    "dropmalzpp": 719299998,
    "dropsitphn": 5018653500,
    "dropsitlph": 5018653500,
    "dropsitcph": 5018653500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20118",
    "droptype": "D",
    "dropname": "BLACK OAK",
    "dropdeladd": "200 S MAIN ST",
    "dropdelcty": "BLACK OAK",
    "dropdelst": "AR",
    "dropdelzpp": 724149998,
    "dropphyadd": "200 S MAIN ST",
    "dropphycty": "BLACK OAK",
    "dropphyst": "AR",
    "dropphyzpp": 724149998,
    "dropmaladd": "200 S MAIN ST",
    "dropmalcty": "BLACK OAK",
    "dropmalst": "AR",
    "dropmalzpp": 724149998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8704862711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20121",
    "droptype": "D",
    "dropname": "BLACK ROCK",
    "dropdeladd": "1326 ELM ST",
    "dropdelcty": "BLACK ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 724159998,
    "dropphyadd": "1326 ELM ST",
    "dropphycty": "BLACK ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 724159998,
    "dropmaladd": "1326 ELM ST",
    "dropmalcty": "BLACK ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 724159998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708786769,
    "dropsitcph": 8708786769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20128",
    "droptype": "D",
    "dropname": "BLEVINS",
    "dropdeladd": "5911 HIGHWAY 29 N",
    "dropdelcty": "BLEVINS",
    "dropdelst": "AR",
    "dropdelzpp": 718259998,
    "dropphyadd": "5911 HIGHWAY 29 N",
    "dropphycty": "BLEVINS",
    "dropphyst": "AR",
    "dropphyzpp": 718259998,
    "dropmaladd": "5911 HIGHWAY 29 N",
    "dropmalcty": "BLEVINS",
    "dropmalst": "AR",
    "dropmalzpp": 718259998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708742841,
    "dropsitcph": 8708742841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20130",
    "droptype": "D",
    "dropname": "BLUE MOUNTAIN",
    "dropdeladd": "297 LOGAN ST",
    "dropdelcty": "BLUE MOUNTAIN",
    "dropdelst": "AR",
    "dropdelzpp": 728269998,
    "dropphyadd": "297 LOGAN ST",
    "dropphycty": "BLUE MOUNTAIN",
    "dropphyst": "AR",
    "dropphyzpp": 728269998,
    "dropmaladd": "297 LOGAN ST",
    "dropmalcty": "BLUE MOUNTAIN",
    "dropmalst": "AR",
    "dropmalzpp": 728269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799472288,
    "dropsitcph": 4799472288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20132",
    "droptype": "D",
    "dropname": "BLUFF CITY",
    "dropdeladd": "4979 HIGHWAY 24 W",
    "dropdelcty": "BLUFF CITY",
    "dropdelst": "AR",
    "dropdelzpp": 717229998,
    "dropphyadd": "4979 HIGHWAY 24 W",
    "dropphycty": "BLUFF CITY",
    "dropphyst": "AR",
    "dropphyzpp": 717229998,
    "dropmaladd": "4979 HIGHWAY 24 W",
    "dropmalcty": "BLUFF CITY",
    "dropmalst": "AR",
    "dropmalzpp": 717229998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706852449,
    "dropsitcph": 8706852449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20133",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "22263 W HIGHWAY 28",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "AR",
    "dropdelzpp": 728279998,
    "dropphyadd": "22263 W HIGHWAY 28",
    "dropphycty": "BLUFFTON",
    "dropphyst": "AR",
    "dropphyzpp": 728279998,
    "dropmaladd": "22263 W HIGHWAY 28",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "AR",
    "dropmalzpp": 728279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792994449,
    "dropsitcph": 4792994449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20134",
    "droptype": "D",
    "dropname": "BLYTHEVILLE",
    "dropdeladd": "600 N BROADWAY ST",
    "dropdelcty": "BLYTHEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 723159998,
    "dropphyadd": "600 N BROADWAY ST",
    "dropphycty": "BLYTHEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 723159998,
    "dropmaladd": "600 N BROADWAY ST",
    "dropmalcty": "BLYTHEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 723159998,
    "dropsitphn": 8707633692,
    "dropsitlph": 8707633690,
    "dropsitcph": 8707633690,
    "dropfax": 8707633692
  },
  {
    "dcode": "D",
    "dropkey": "PY20136",
    "droptype": "D",
    "dropname": "BOARD CAMP",
    "dropdeladd": "4199 HIGHWAY 8 E",
    "dropdelcty": "BOARD CAMP",
    "dropdelst": "AR",
    "dropdelzpp": 719328800,
    "dropphyadd": "4199 HIGHWAY 8 E",
    "dropphycty": "BOARD CAMP",
    "dropphyst": "AR",
    "dropphyzpp": 719328800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOARD CAMP",
    "dropmalst": "AR",
    "dropmalzpp": 719329998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4793940902,
    "dropsitcph": 4793940902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20137",
    "droptype": "D",
    "dropname": "BOLES",
    "dropdeladd": "11992 HIGHWAY 71 S",
    "dropdelcty": "BOLES",
    "dropdelst": "AR",
    "dropdelzpp": 729269998,
    "dropphyadd": "11992 HIGHWAY 71 S",
    "dropphycty": "BOLES",
    "dropphyst": "AR",
    "dropphyzpp": 729269998,
    "dropmaladd": "11992 HIGHWAY 71 S",
    "dropmalcty": "BOLES",
    "dropmalst": "AR",
    "dropmalzpp": 729269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4795772421,
    "dropsitcph": 4795772421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20138",
    "droptype": "D",
    "dropname": "BONNERDALE",
    "dropdeladd": "1980 HIGHWAY 70",
    "dropdelcty": "BONNERDALE",
    "dropdelst": "AR",
    "dropdelzpp": 719339998,
    "dropphyadd": "1980 HIGHWAY 70",
    "dropphycty": "BONNERDALE",
    "dropphyst": "AR",
    "dropphyzpp": 719339998,
    "dropmaladd": "1980 HIGHWAY 70",
    "dropmalcty": "BONNERDALE",
    "dropmalst": "AR",
    "dropmalzpp": 719339998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703562893,
    "dropsitcph": 8703562893,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20139",
    "droptype": "D",
    "dropname": "BONO",
    "dropdeladd": "306 HIGHWAY 63 N",
    "dropdelcty": "BONO",
    "dropdelst": "AR",
    "dropdelzpp": 724169998,
    "dropphyadd": "306 HIGHWAY 63 N",
    "dropphycty": "BONO",
    "dropphyst": "AR",
    "dropphyzpp": 724169998,
    "dropmaladd": "306 HIGHWAY 63 N",
    "dropmalcty": "BONO",
    "dropmalst": "AR",
    "dropmalzpp": 724169998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8709354973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20142",
    "droptype": "D",
    "dropname": "BOONEVILLE",
    "dropdeladd": "111 S BROADWAY AVE",
    "dropdelcty": "BOONEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 729279998,
    "dropphyadd": "111 S BROADWAY AVE",
    "dropphycty": "BOONEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 729279998,
    "dropmaladd": "111 S BROADWAY AVE",
    "dropmalcty": "BOONEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 729279998,
    "dropsitphn": 4796753217,
    "dropsitlph": 4796753217,
    "dropsitcph": 4796753217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20149",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "200 SW 3RD ST",
    "dropdelcty": "BRADFORD",
    "dropdelst": "AR",
    "dropdelzpp": 720209998,
    "dropphyadd": "200 SW 3RD ST",
    "dropphycty": "BRADFORD",
    "dropphyst": "AR",
    "dropphyzpp": 720209998,
    "dropmaladd": "200 SW 3RD ST",
    "dropmalcty": "BRADFORD",
    "dropmalst": "AR",
    "dropmalzpp": 720209998,
    "dropsitphn": 5012078042,
    "dropsitlph": 5012078042,
    "dropsitcph": 5012078042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20150",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "305 PULLMAN ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "AR",
    "dropdelzpp": 718269998,
    "dropphyadd": "305 PULLMAN ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "AR",
    "dropphyzpp": 718269998,
    "dropmaladd": "305 PULLMAN ST",
    "dropmalcty": "BRADLEY",
    "dropmalst": "AR",
    "dropmalzpp": 718269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708943433,
    "dropsitcph": 8708943433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20153",
    "droptype": "D",
    "dropname": "BRANCH",
    "dropdeladd": "510 HIGHWAY 22 W",
    "dropdelcty": "BRANCH",
    "dropdelst": "AR",
    "dropdelzpp": 729289998,
    "dropphyadd": "510 HIGHWAY 22 W",
    "dropphycty": "BRANCH",
    "dropphyst": "AR",
    "dropphyzpp": 729289998,
    "dropmaladd": "510 HIGHWAY 22 W",
    "dropmalcty": "BRANCH",
    "dropmalst": "AR",
    "dropmalzpp": 729289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799652166,
    "dropsitcph": 4799652166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20156",
    "droptype": "D",
    "dropname": "BRICKEYS",
    "dropdeladd": "12092 HIGHWAY 79 N",
    "dropdelcty": "BRICKEYS",
    "dropdelst": "AR",
    "dropdelzpp": 723209998,
    "dropphyadd": "12092 HIGHWAY 79 N",
    "dropphycty": "BRICKEYS",
    "dropphyst": "AR",
    "dropphyzpp": 723209998,
    "dropmaladd": "12092 HIGHWAY 79 N",
    "dropmalcty": "BRICKEYS",
    "dropmalst": "AR",
    "dropmalzpp": 723209998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702952616,
    "dropsitcph": 8702952616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20159",
    "droptype": "D",
    "dropname": "BRINKLEY",
    "dropdeladd": "201 N MAIN ST",
    "dropdelcty": "BRINKLEY",
    "dropdelst": "AR",
    "dropdelzpp": 720219998,
    "dropphyadd": "201 N MAIN ST",
    "dropphycty": "BRINKLEY",
    "dropphyst": "AR",
    "dropphyzpp": 720219998,
    "dropmaladd": "201 N MAIN ST",
    "dropmalcty": "BRINKLEY",
    "dropmalst": "AR",
    "dropmalzpp": 720219998,
    "dropsitphn": 8707341061,
    "dropsitlph": 8707341061,
    "dropsitcph": 8707341061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20160",
    "droptype": "D",
    "dropname": "BROCKWELL",
    "dropdeladd": "4047 N AR 9 HWY",
    "dropdelcty": "BROCKWELL",
    "dropdelst": "AR",
    "dropdelzpp": 725179998,
    "dropphyadd": "4047 N AR 9 HWY",
    "dropphycty": "BROCKWELL",
    "dropphyst": "AR",
    "dropphyzpp": 725179998,
    "dropmaladd": "4047 N AR 9 HWY",
    "dropmalcty": "BROCKWELL",
    "dropmalst": "AR",
    "dropmalzpp": 725179998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702583152,
    "dropsitcph": 8702583152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20161",
    "droptype": "D",
    "dropname": "BROOKLAND",
    "dropdeladd": "100 W HINKLEY ST",
    "dropdelcty": "BROOKLAND",
    "dropdelst": "AR",
    "dropdelzpp": 724179998,
    "dropphyadd": "100 W HINKLEY ST",
    "dropphycty": "BROOKLAND",
    "dropphyst": "AR",
    "dropphyzpp": 724179998,
    "dropmaladd": "100 W HINKLEY ST",
    "dropmalcty": "BROOKLAND",
    "dropmalst": "AR",
    "dropmalzpp": 724179998,
    "dropsitphn": 8709725137,
    "dropsitlph": 8709725137,
    "dropsitcph": 8709725137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20167",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "2103 N REYNOLDS RD",
    "dropdelcty": "BRYANT",
    "dropdelst": "AR",
    "dropdelzpp": 720899998,
    "dropphyadd": "2103 N REYNOLDS RD",
    "dropphycty": "BRYANT",
    "dropphyst": "AR",
    "dropphyzpp": 720899998,
    "dropmaladd": "2103 N REYNOLDS RD",
    "dropmalcty": "BRYANT",
    "dropmalst": "AR",
    "dropmalzpp": 720899998,
    "dropsitphn": 5018479817,
    "dropsitlph": 5018479817,
    "dropsitcph": 5018479817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20168",
    "droptype": "D",
    "dropname": "BUCKNER",
    "dropdeladd": "119 W MYRTLE ST",
    "dropdelcty": "BUCKNER",
    "dropdelst": "AR",
    "dropdelzpp": 718279998,
    "dropphyadd": "119 W MYRTLE ST",
    "dropphycty": "BUCKNER",
    "dropphyst": "AR",
    "dropphyzpp": 718279998,
    "dropmaladd": "119 W MYRTLE ST",
    "dropmalcty": "BUCKNER",
    "dropmalst": "AR",
    "dropmalzpp": 718279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705332384,
    "dropsitcph": 8705332384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20171",
    "droptype": "D",
    "dropname": "BULL SHOALS",
    "dropdeladd": "904 LAKESHORE RD",
    "dropdelcty": "BULL SHOALS",
    "dropdelst": "AR",
    "dropdelzpp": 726199998,
    "dropphyadd": "904 LAKESHORE RD",
    "dropphycty": "BULL SHOALS",
    "dropphyst": "AR",
    "dropphyzpp": 726199998,
    "dropmaladd": "904 LAKESHORE RD",
    "dropmalcty": "BULL SHOALS",
    "dropmalst": "AR",
    "dropmalzpp": 726199998,
    "dropsitphn": 8704454320,
    "dropsitlph": 8704454320,
    "dropsitcph": 8704454320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20172",
    "droptype": "D",
    "dropname": "BURDETTE",
    "dropdeladd": "157 PLANTATION DR",
    "dropdelcty": "BURDETTE",
    "dropdelst": "AR",
    "dropdelzpp": 723219998,
    "dropphyadd": "157 PLANTATION DR",
    "dropphycty": "BURDETTE",
    "dropphyst": "AR",
    "dropphyzpp": 723219998,
    "dropmaladd": "157 PLANTATION DR",
    "dropmalcty": "BURDETTE",
    "dropmalst": "AR",
    "dropmalzpp": 723219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707632032,
    "dropsitcph": 8707632032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20177",
    "droptype": "D",
    "dropname": "CABOT",
    "dropdeladd": "200 E MAIN ST",
    "dropdelcty": "CABOT",
    "dropdelst": "AR",
    "dropdelzpp": 720239998,
    "dropphyadd": "200 E MAIN ST",
    "dropphycty": "CABOT",
    "dropphyst": "AR",
    "dropphyzpp": 720239998,
    "dropmaladd": "200 E MAIN ST",
    "dropmalcty": "CABOT",
    "dropmalst": "AR",
    "dropmalzpp": 720239998,
    "dropsitphn": 5018439532,
    "dropsitlph": 5018439532,
    "dropsitcph": 5019412531,
    "dropfax": 5016051507
  },
  {
    "dcode": "D",
    "dropkey": "PY20178",
    "droptype": "D",
    "dropname": "CADDO GAP",
    "dropdeladd": "57 6TH ST",
    "dropdelcty": "CADDO GAP",
    "dropdelst": "AR",
    "dropdelzpp": 719359998,
    "dropphyadd": "57 6TH ST",
    "dropphycty": "CADDO GAP",
    "dropphyst": "AR",
    "dropphyzpp": 719359998,
    "dropmaladd": "57 6TH ST",
    "dropmalcty": "CADDO GAP",
    "dropmalst": "AR",
    "dropmalzpp": 719359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703562855,
    "dropsitcph": 8703562855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20182",
    "droptype": "D",
    "dropname": "CALE",
    "dropdeladd": "794 WESTMORELAND DR",
    "dropdelcty": "CALE",
    "dropdelst": "AR",
    "dropdelzpp": 718289998,
    "dropphyadd": "794 WESTMORELAND DR",
    "dropphycty": "CALE",
    "dropphyst": "AR",
    "dropphyzpp": 718289998,
    "dropmaladd": "794 WESTMORELAND DR",
    "dropmalcty": "CALE",
    "dropmalst": "AR",
    "dropmalzpp": 718289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708875902,
    "dropsitcph": 8708875902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20183",
    "droptype": "D",
    "dropname": "CALICO ROCK",
    "dropdeladd": "2068 AR 56 HWY",
    "dropdelcty": "CALICO ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 725199056,
    "dropphyadd": "2068 AR 56 HWY",
    "dropphycty": "CALICO ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 725199056,
    "dropmaladd": "2068 AR 56 HWY",
    "dropmalcty": "CALICO ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 725199056,
    "dropsitphn": 8702978306,
    "dropsitlph": 8702978306,
    "dropsitcph": 8702978306,
    "dropfax": 8702978883
  },
  {
    "dcode": "D",
    "dropkey": "PY20184",
    "droptype": "D",
    "dropname": "CALION",
    "dropdeladd": "324 MILL ST",
    "dropdelcty": "CALION",
    "dropdelst": "AR",
    "dropdelzpp": 717249998,
    "dropphyadd": "324 MILL ST",
    "dropphycty": "CALION",
    "dropphyst": "AR",
    "dropphyzpp": 717249998,
    "dropmaladd": "324 MILL ST",
    "dropmalcty": "CALION",
    "dropmalst": "AR",
    "dropmalzpp": 717249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707482229,
    "dropsitcph": 8707482229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20187",
    "droptype": "D",
    "dropname": "CAMDEN",
    "dropdeladd": "351 W WASHINGTON ST STE 100",
    "dropdelcty": "CAMDEN",
    "dropdelst": "AR",
    "dropdelzpp": 717019998,
    "dropphyadd": "351 W WASHINGTON ST STE 100",
    "dropphycty": "CAMDEN",
    "dropphyst": "AR",
    "dropphyzpp": 717019998,
    "dropmaladd": "351 W WASHINGTON ST STE 100",
    "dropmalcty": "CAMDEN",
    "dropmalst": "AR",
    "dropmalzpp": 717019998,
    "dropsitphn": 8708368146,
    "dropsitlph": 8708368146,
    "dropsitcph": 8708368146,
    "dropfax": 8708367549
  },
  {
    "dcode": "D",
    "dropkey": "PY20189",
    "droptype": "D",
    "dropname": "CAMP",
    "dropdeladd": "6042 HIGHWAY 9 N",
    "dropdelcty": "CAMP",
    "dropdelst": "AR",
    "dropdelzpp": 725209998,
    "dropphyadd": "6042 HIGHWAY 9 N",
    "dropphycty": "CAMP",
    "dropphyst": "AR",
    "dropphyzpp": 725209998,
    "dropmaladd": "6042 HIGHWAY 9 N",
    "dropmalcty": "CAMP",
    "dropmalst": "AR",
    "dropmalzpp": 725209998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708953857,
    "dropsitcph": 8708953857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20193",
    "droptype": "D",
    "dropname": "CANEHILL",
    "dropdeladd": "14311 HIGHWAY 45",
    "dropdelcty": "CANEHILL",
    "dropdelst": "AR",
    "dropdelzpp": 727179998,
    "dropphyadd": "14311 HIGHWAY 45",
    "dropphycty": "CANEHILL",
    "dropphyst": "AR",
    "dropphyzpp": 727179998,
    "dropmaladd": "14311 HIGHWAY 45",
    "dropmalcty": "CANEHILL",
    "dropmalst": "AR",
    "dropmalzpp": 727179998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798245938,
    "dropsitcph": 4798245938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20197",
    "droptype": "D",
    "dropname": "CARAWAY",
    "dropdeladd": "201 E KENTUCKY ST",
    "dropdelcty": "CARAWAY",
    "dropdelst": "AR",
    "dropdelzpp": 724199998,
    "dropphyadd": "201 E KENTUCKY ST",
    "dropphycty": "CARAWAY",
    "dropphyst": "AR",
    "dropphyzpp": 724199998,
    "dropmaladd": "201 E KENTUCKY ST",
    "dropmalcty": "CARAWAY",
    "dropmalst": "AR",
    "dropmalzpp": 724199998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704823718,
    "dropsitcph": 8704823718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20198",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "206 N COURT ST",
    "dropdelcty": "CARLISLE",
    "dropdelst": "AR",
    "dropdelzpp": 720249998,
    "dropphyadd": "206 N COURT ST",
    "dropphycty": "CARLISLE",
    "dropphyst": "AR",
    "dropphyzpp": 720249998,
    "dropmaladd": "206 N COURT ST",
    "dropmalcty": "CARLISLE",
    "dropmalst": "AR",
    "dropmalzpp": 720249998,
    "dropsitphn": 8707055488,
    "dropsitlph": 8707055488,
    "dropsitcph": 8707055488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20201",
    "droptype": "D",
    "dropname": "CARTHAGE",
    "dropdeladd": "112 W OAK ST",
    "dropdelcty": "CARTHAGE",
    "dropdelst": "AR",
    "dropdelzpp": 717259998,
    "dropphyadd": "112 W OAK ST",
    "dropphycty": "CARTHAGE",
    "dropphyst": "AR",
    "dropphyzpp": 717259998,
    "dropmaladd": "112 W OAK ST",
    "dropmalcty": "CARTHAGE",
    "dropmalst": "AR",
    "dropmalzpp": 717259998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702542428,
    "dropsitcph": 8702542428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20202",
    "droptype": "D",
    "dropname": "CASA",
    "dropdeladd": "3684 HIGHWAY 10 3RD ST",
    "dropdelcty": "CASA",
    "dropdelst": "AR",
    "dropdelzpp": 720258248,
    "dropphyadd": "3684 HIGHWAY 10 3RD ST",
    "dropphycty": "CASA",
    "dropphyst": "AR",
    "dropphyzpp": 720258248,
    "dropmaladd": "3684 HIGHWAY 10 3RD ST",
    "dropmalcty": "CASA",
    "dropmalst": "AR",
    "dropmalzpp": 720258248,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012336246,
    "dropsitcph": 5012336246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20203",
    "droptype": "D",
    "dropname": "CASH",
    "dropdeladd": "4598 HIGHWAY 18",
    "dropdelcty": "CASH",
    "dropdelst": "AR",
    "dropdelzpp": 724219998,
    "dropphyadd": "4598 HIGHWAY 18",
    "dropphycty": "CASH",
    "dropphyst": "AR",
    "dropphyzpp": 724219998,
    "dropmaladd": "4598 HIGHWAY 18",
    "dropmalcty": "CASH",
    "dropmalst": "AR",
    "dropmalzpp": 724219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704775650,
    "dropsitcph": 8704775650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20204",
    "droptype": "D",
    "dropname": "CASSCOE",
    "dropdeladd": "1040 HIGHWAY 33",
    "dropdelcty": "CASSCOE",
    "dropdelst": "AR",
    "dropdelzpp": 720269998,
    "dropphyadd": "1040 HIGHWAY 33",
    "dropphycty": "CASSCOE",
    "dropphyst": "AR",
    "dropphyzpp": 720269998,
    "dropmaladd": "1040 HIGHWAY 33",
    "dropmalcty": "CASSCOE",
    "dropmalst": "AR",
    "dropmalzpp": 720269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702413276,
    "dropsitcph": 8702413276,
    "dropfax": 8702411009
  },
  {
    "dcode": "D",
    "dropkey": "PY20207",
    "droptype": "D",
    "dropname": "CAVE CITY",
    "dropdeladd": "112 S MAIN ST",
    "dropdelcty": "CAVE CITY",
    "dropdelst": "AR",
    "dropdelzpp": 725219998,
    "dropphyadd": "112 S MAIN ST",
    "dropphycty": "CAVE CITY",
    "dropphyst": "AR",
    "dropphyzpp": 725219998,
    "dropmaladd": "112 S MAIN ST",
    "dropmalcty": "CAVE CITY",
    "dropmalst": "AR",
    "dropmalzpp": 725219998,
    "dropsitphn": 8702835480,
    "dropsitlph": 8702835480,
    "dropsitcph": 8702835480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20208",
    "droptype": "D",
    "dropname": "CAVE SPRINGS",
    "dropdeladd": "115 E MIDWAY AVE",
    "dropdelcty": "CAVE SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 727189998,
    "dropphyadd": "115 E MIDWAY AVE",
    "dropphycty": "CAVE SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 727189998,
    "dropmaladd": "115 E MIDWAY AVE",
    "dropmalcty": "CAVE SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 727189998,
    "dropsitphn": 4792481155,
    "dropsitlph": 4792481155,
    "dropsitcph": 4792481155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20209",
    "droptype": "D",
    "dropname": "CECIL",
    "dropdeladd": "21 W HIGHWAY 96",
    "dropdelcty": "CECIL",
    "dropdelst": "AR",
    "dropdelzpp": 729309998,
    "dropphyadd": "21 W HIGHWAY 96",
    "dropphycty": "CECIL",
    "dropphyst": "AR",
    "dropphyzpp": 729309998,
    "dropmaladd": "21 W HIGHWAY 96",
    "dropmalcty": "CECIL",
    "dropmalst": "AR",
    "dropmalzpp": 729309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796674325,
    "dropsitcph": 4796674325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20210",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "8904 N HIGHWAY 59",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 729329998,
    "dropphyadd": "8904 N HIGHWAY 59",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 729329998,
    "dropmaladd": "8904 N HIGHWAY 59",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 729329998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794743801,
    "dropsitcph": 4794743801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20217",
    "droptype": "D",
    "dropname": "CENTER RIDGE",
    "dropdeladd": "5744 HIGHWAY 9",
    "dropdelcty": "CENTER RIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 720279998,
    "dropphyadd": "5744 HIGHWAY 9",
    "dropphycty": "CENTER RIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 720279998,
    "dropmaladd": "5744 HIGHWAY 9",
    "dropmalcty": "CENTER RIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 720279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 5018932300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20218",
    "droptype": "D",
    "dropname": "CENTERTON",
    "dropdeladd": "100 MONROE ST",
    "dropdelcty": "CENTERTON",
    "dropdelst": "AR",
    "dropdelzpp": 727197000,
    "dropphyadd": "100 MONROE ST",
    "dropphycty": "CENTERTON",
    "dropphyst": "AR",
    "dropphyzpp": 727197000,
    "dropmaladd": "100 MONROE ST",
    "dropmalcty": "CENTERTON",
    "dropmalst": "AR",
    "dropmalzpp": 727197000,
    "dropsitphn": 4797952747,
    "dropsitlph": 4797952747,
    "dropsitcph": 4797952747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20219",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "16931 N STATE HIGHWAY 7",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728298800,
    "dropphyadd": "16931 N STATE HIGHWAY 7",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728298800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728299998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4795764224,
    "dropsitcph": 4795764224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20228",
    "droptype": "D",
    "dropname": "CHARLESTON",
    "dropdeladd": "215 E MAIN ST",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "AR",
    "dropdelzpp": 729339998,
    "dropphyadd": "215 E MAIN ST",
    "dropphycty": "CHARLESTON",
    "dropphyst": "AR",
    "dropphyzpp": 729339998,
    "dropmaladd": "215 E MAIN ST",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "AR",
    "dropmalzpp": 729339998,
    "dropsitphn": 4799652971,
    "dropsitlph": 4799652971,
    "dropsitcph": 4799652971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20233",
    "droptype": "D",
    "dropname": "CHERRY VALLEY",
    "dropdeladd": "3239 HIGHWAY 42",
    "dropdelcty": "CHERRY VALLEY",
    "dropdelst": "AR",
    "dropdelzpp": 723249998,
    "dropphyadd": "3239 HIGHWAY 42",
    "dropphycty": "CHERRY VALLEY",
    "dropphyst": "AR",
    "dropphyzpp": 723249998,
    "dropmaladd": "3239 HIGHWAY 42",
    "dropmalcty": "CHERRY VALLEY",
    "dropmalst": "AR",
    "dropmalzpp": 723249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705883576,
    "dropsitcph": 8705883576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20234",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "405 E FRONT AVE",
    "dropdelcty": "CHESTER",
    "dropdelst": "AR",
    "dropdelzpp": 729349998,
    "dropphyadd": "405 E FRONT AVE",
    "dropphycty": "CHESTER",
    "dropphyst": "AR",
    "dropphyzpp": 729349998,
    "dropmaladd": "405 E FRONT AVE",
    "dropmalcty": "CHESTER",
    "dropmalst": "AR",
    "dropmalzpp": 729349998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4793694203,
    "dropsitcph": 4793694203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20236",
    "droptype": "D",
    "dropname": "CHIDESTER",
    "dropdeladd": "118 HIGHWAY 57",
    "dropdelcty": "CHIDESTER",
    "dropdelst": "AR",
    "dropdelzpp": 717269998,
    "dropphyadd": "118 HIGHWAY 57",
    "dropphycty": "CHIDESTER",
    "dropphyst": "AR",
    "dropphyzpp": 717269998,
    "dropmaladd": "118 HIGHWAY 57",
    "dropmalcty": "CHIDESTER",
    "dropmalst": "AR",
    "dropmalzpp": 717269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706852369,
    "dropsitcph": 8706852369,
    "dropfax": 8706852369
  },
  {
    "dcode": "D",
    "dropkey": "PY20239",
    "droptype": "D",
    "dropname": "CHOCTAW",
    "dropdeladd": "173 HIGHWAY 330 E",
    "dropdelcty": "CHOCTAW",
    "dropdelst": "AR",
    "dropdelzpp": 720288800,
    "dropphyadd": "173 HIGHWAY 330 E",
    "dropphycty": "CHOCTAW",
    "dropphyst": "AR",
    "dropphyzpp": 720288800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHOCTAW",
    "dropmalst": "AR",
    "dropmalzpp": 720289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017458192,
    "dropsitcph": 5017458192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20240",
    "droptype": "D",
    "dropname": "CLARENDON",
    "dropdeladd": "303 MADISON ST",
    "dropdelcty": "CLARENDON",
    "dropdelst": "AR",
    "dropdelzpp": 720299998,
    "dropphyadd": "303 MADISON ST",
    "dropphycty": "CLARENDON",
    "dropphyst": "AR",
    "dropphyzpp": 720299998,
    "dropmaladd": "303 MADISON ST",
    "dropmalcty": "CLARENDON",
    "dropmalst": "AR",
    "dropmalzpp": 720299998,
    "dropsitphn": 8707473924,
    "dropsitlph": 8707473924,
    "dropsitcph": 8707473924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20241",
    "droptype": "D",
    "dropname": "CLARKEDALE",
    "dropdeladd": "10555 HIGHWAY 77",
    "dropdelcty": "CLARKEDALE",
    "dropdelst": "AR",
    "dropdelzpp": 723259998,
    "dropphyadd": "10555 HIGHWAY 77",
    "dropphycty": "CLARKEDALE",
    "dropphyst": "AR",
    "dropphyzpp": 723259998,
    "dropmaladd": "10555 HIGHWAY 77",
    "dropmalcty": "CLARKEDALE",
    "dropmalst": "AR",
    "dropmalzpp": 723259998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707391167,
    "dropsitcph": 8707391167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20242",
    "droptype": "D",
    "dropname": "CLARKRIDGE",
    "dropdeladd": "49 POSTMASTER CIR",
    "dropdelcty": "CLARKRIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 726239998,
    "dropphyadd": "49 POSTMASTER CIR",
    "dropphycty": "CLARKRIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 726239998,
    "dropmaladd": "49 POSTMASTER CIR",
    "dropmalcty": "CLARKRIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 726239998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704254120,
    "dropsitcph": 8704254120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20243",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "200 W SEVIER ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728309998,
    "dropphyadd": "200 W SEVIER ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728309998,
    "dropmaladd": "200 W SEVIER ST",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728309998,
    "dropsitphn": 4797545254,
    "dropsitlph": 4797542205,
    "dropsitcph": 4797542205,
    "dropfax": 4797542205
  },
  {
    "dcode": "D",
    "dropkey": "PY20245",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "3954 HIGHWAY 95",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "AR",
    "dropdelzpp": 720309998,
    "dropphyadd": "3954 HIGHWAY 95",
    "dropphycty": "CLEVELAND",
    "dropphyst": "AR",
    "dropphyzpp": 720309998,
    "dropmaladd": "3954 HIGHWAY 95",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "AR",
    "dropmalzpp": 720309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016692683,
    "dropsitcph": 5016692683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20246",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "145 VOLUNTEER PKWY",
    "dropdelcty": "CLINTON",
    "dropdelst": "AR",
    "dropdelzpp": 720319998,
    "dropphyadd": "145 VOLUNTEER PKWY",
    "dropphycty": "CLINTON",
    "dropphyst": "AR",
    "dropphyzpp": 720319998,
    "dropmaladd": "145 VOLUNTEER PKWY",
    "dropmalcty": "CLINTON",
    "dropmalst": "AR",
    "dropmalzpp": 720319998,
    "dropsitphn": 5017452171,
    "dropsitlph": 5017452171,
    "dropsitcph": 5017452171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20247",
    "droptype": "D",
    "dropname": "COAL HILL",
    "dropdeladd": "506 E HIGHWAY 64",
    "dropdelcty": "COAL HILL",
    "dropdelst": "AR",
    "dropdelzpp": 728329998,
    "dropphyadd": "506 E HIGHWAY 64",
    "dropphycty": "COAL HILL",
    "dropphyst": "AR",
    "dropphyzpp": 728329998,
    "dropmaladd": "506 E HIGHWAY 64",
    "dropmalcty": "COAL HILL",
    "dropmalst": "AR",
    "dropmalzpp": 728329998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794971100,
    "dropsitcph": 4794971100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20253",
    "droptype": "D",
    "dropname": "COLLEGE STATION",
    "dropdeladd": "4000 GRAY ST STE A",
    "dropdelcty": "COLLEGE STATION",
    "dropdelst": "AR",
    "dropdelzpp": 720539998,
    "dropphyadd": "4000 GRAY ST STE A",
    "dropphycty": "COLLEGE STATION",
    "dropphyst": "AR",
    "dropphyzpp": 720539998,
    "dropmaladd": "4000 GRAY ST STE A",
    "dropmalcty": "COLLEGE STATION",
    "dropmalst": "AR",
    "dropmalzpp": 720539998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5014901068,
    "dropsitcph": 5014901062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20256",
    "droptype": "D",
    "dropname": "COLT",
    "dropdeladd": "8587 HIGHWAY 1 N",
    "dropdelcty": "COLT",
    "dropdelst": "AR",
    "dropdelzpp": 723269998,
    "dropphyadd": "8587 HIGHWAY 1 N",
    "dropphycty": "COLT",
    "dropphyst": "AR",
    "dropphyzpp": 723269998,
    "dropmaladd": "8587 HIGHWAY 1 N",
    "dropmalcty": "COLT",
    "dropmalst": "AR",
    "dropmalzpp": 723269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706336348,
    "dropsitcph": 8706336348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20257",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "2803 HIGHWAY 73 W",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "AR",
    "dropdelzpp": 718319998,
    "dropphyadd": "2803 HIGHWAY 73 W",
    "dropphycty": "COLUMBUS",
    "dropphyst": "AR",
    "dropphyzpp": 718319998,
    "dropmaladd": "2803 HIGHWAY 73 W",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "AR",
    "dropmalzpp": 718319998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709832875,
    "dropsitcph": 8709832875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20258",
    "droptype": "D",
    "dropname": "COMBS",
    "dropdeladd": "10208 HIGHWAY 16",
    "dropdelcty": "COMBS",
    "dropdelst": "AR",
    "dropdelzpp": 727219998,
    "dropphyadd": "10208 HIGHWAY 16",
    "dropphycty": "COMBS",
    "dropphyst": "AR",
    "dropphyzpp": 727219998,
    "dropmaladd": "10208 HIGHWAY 16",
    "dropmalcty": "COMBS",
    "dropmalst": "AR",
    "dropmalzpp": 727219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796772355,
    "dropsitcph": 4796772355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20260",
    "droptype": "D",
    "dropname": "COMPTON",
    "dropdeladd": "1 W MAIN ST",
    "dropdelcty": "COMPTON",
    "dropdelst": "AR",
    "dropdelzpp": 726249998,
    "dropphyadd": "1 W MAIN ST",
    "dropphycty": "COMPTON",
    "dropphyst": "AR",
    "dropphyzpp": 726249998,
    "dropmaladd": "1 W MAIN ST",
    "dropmalcty": "COMPTON",
    "dropmalst": "AR",
    "dropmalzpp": 726249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794070360,
    "dropsitcph": 4794070360,
    "dropfax": 4794070360
  },
  {
    "dcode": "D",
    "dropkey": "PY20261",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "10845 HEBER SPRINGS RD N",
    "dropdelcty": "CONCORD",
    "dropdelst": "AR",
    "dropdelzpp": 725239998,
    "dropphyadd": "10845 HEBER SPRINGS RD N",
    "dropphycty": "CONCORD",
    "dropphyst": "AR",
    "dropphyzpp": 725239998,
    "dropmaladd": "10845 HEBER SPRINGS RD N",
    "dropmalcty": "CONCORD",
    "dropmalst": "AR",
    "dropmalzpp": 725239998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706683463,
    "dropsitcph": 8706683463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20262",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "1060 HOGAN LN",
    "dropdelcty": "CONWAY",
    "dropdelst": "AR",
    "dropdelzpp": 720344500,
    "dropphyadd": "1060 HOGAN LN",
    "dropphycty": "CONWAY",
    "dropphyst": "AR",
    "dropphyzpp": 720344500,
    "dropmaladd": "1060 HOGAN LN",
    "dropmalcty": "CONWAY",
    "dropmalst": "AR",
    "dropmalzpp": 720344500,
    "dropsitphn": 5017300351,
    "dropsitlph": 5017300351,
    "dropsitcph": 5017300351,
    "dropfax": 5017300655
  },
  {
    "dcode": "D",
    "dropkey": "PY20263",
    "droptype": "D",
    "dropname": "CORD",
    "dropdeladd": "8060 CORD RD",
    "dropdelcty": "CORD",
    "dropdelst": "AR",
    "dropdelzpp": 725249998,
    "dropphyadd": "8060 CORD RD",
    "dropphycty": "CORD",
    "dropphyst": "AR",
    "dropphyzpp": 725249998,
    "dropmaladd": "8060 CORD RD",
    "dropmalcty": "CORD",
    "dropmalst": "AR",
    "dropmalzpp": 725249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707993613,
    "dropsitcph": 8707993613,
    "dropfax": 8707993613
  },
  {
    "dcode": "D",
    "dropkey": "PY20266",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "700 BOBCAT LN",
    "dropdelcty": "CORNING",
    "dropdelst": "AR",
    "dropdelzpp": 724229998,
    "dropphyadd": "700 BOBCAT LN",
    "dropphycty": "CORNING",
    "dropphyst": "AR",
    "dropphyzpp": 724229998,
    "dropmaladd": "700 BOBCAT LN",
    "dropmalcty": "CORNING",
    "dropmalst": "AR",
    "dropmalzpp": 724229998,
    "dropsitphn": 8708573921,
    "dropsitlph": 8708573921,
    "dropsitcph": 8708573921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20267",
    "droptype": "D",
    "dropname": "COTTER",
    "dropdeladd": "510 SECOND ST",
    "dropdelcty": "COTTER",
    "dropdelst": "AR",
    "dropdelzpp": 726269998,
    "dropphyadd": "510 SECOND ST",
    "dropphycty": "COTTER",
    "dropphyst": "AR",
    "dropphyzpp": 726269998,
    "dropmaladd": "510 SECOND ST",
    "dropmalcty": "COTTER",
    "dropmalst": "AR",
    "dropmalzpp": 726269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704356916,
    "dropsitcph": 8704356916,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20268",
    "droptype": "D",
    "dropname": "COTTON PLANT",
    "dropdeladd": "279 W MAIN ST",
    "dropdelcty": "COTTON PLANT",
    "dropdelst": "AR",
    "dropdelzpp": 720369998,
    "dropphyadd": "279 W MAIN ST",
    "dropphycty": "COTTON PLANT",
    "dropphyst": "AR",
    "dropphyzpp": 720369998,
    "dropmaladd": "279 W MAIN ST",
    "dropmalcty": "COTTON PLANT",
    "dropmalst": "AR",
    "dropmalzpp": 720369998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704592061,
    "dropsitcph": 8704592061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20269",
    "droptype": "D",
    "dropname": "COVE",
    "dropdeladd": "120 E BARTON AVE",
    "dropdelcty": "COVE",
    "dropdelst": "AR",
    "dropdelzpp": 719379998,
    "dropphyadd": "120 E BARTON AVE",
    "dropphycty": "COVE",
    "dropphyst": "AR",
    "dropphyzpp": 719379998,
    "dropmaladd": "120 E BARTON AVE",
    "dropmalcty": "COVE",
    "dropmalst": "AR",
    "dropmalzpp": 719379998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703872430,
    "dropsitcph": 8703872430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20270",
    "droptype": "D",
    "dropname": "COY",
    "dropdeladd": "561 MAIN ST",
    "dropdelcty": "COY",
    "dropdelst": "AR",
    "dropdelzpp": 720379998,
    "dropphyadd": "561 MAIN ST",
    "dropphycty": "COY",
    "dropphyst": "AR",
    "dropphyzpp": 720379998,
    "dropmaladd": "561 MAIN ST",
    "dropmalcty": "COY",
    "dropmalst": "AR",
    "dropmalzpp": 720379998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012753665,
    "dropsitcph": 5012753665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20273",
    "droptype": "D",
    "dropname": "CRAWFORDSVILLE",
    "dropdeladd": "5482 MAIN ST",
    "dropdelcty": "CRAWFORDSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 723279998,
    "dropphyadd": "5482 MAIN ST",
    "dropphycty": "CRAWFORDSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 723279998,
    "dropmaladd": "5482 MAIN ST",
    "dropmalcty": "CRAWFORDSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 723279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708235368,
    "dropsitcph": 8708235368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20275",
    "droptype": "D",
    "dropname": "CROCKETTS BLUFF",
    "dropdeladd": "2908 HIGHWAY 153",
    "dropdelcty": "CROCKETTS BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 720389998,
    "dropphyadd": "2908 HIGHWAY 153",
    "dropphycty": "CROCKETTS BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 720389998,
    "dropmaladd": "2908 HIGHWAY 153",
    "dropmalcty": "CROCKETTS BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 720389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702823762,
    "dropsitcph": 8702823762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20279",
    "droptype": "D",
    "dropname": "CROSSETT",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "CROSSETT",
    "dropdelst": "AR",
    "dropdelzpp": 716359998,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "CROSSETT",
    "dropphyst": "AR",
    "dropphyzpp": 716359998,
    "dropmaladd": "312 MAIN ST",
    "dropmalcty": "CROSSETT",
    "dropmalst": "AR",
    "dropmalzpp": 716359998,
    "dropsitphn": 8703642938,
    "dropsitlph": 8703642938,
    "dropsitcph": 8703642938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20283",
    "droptype": "D",
    "dropname": "CRUMROD",
    "dropdeladd": "38305 HIGHWAY 44 S",
    "dropdelcty": "CRUMROD",
    "dropdelst": "AR",
    "dropdelzpp": 723289998,
    "dropphyadd": "38305 HIGHWAY 44 S",
    "dropphycty": "CRUMROD",
    "dropphyst": "AR",
    "dropphyzpp": 723289998,
    "dropmaladd": "38305 HIGHWAY 44 S",
    "dropmalcty": "CRUMROD",
    "dropmalst": "AR",
    "dropmalzpp": 723289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276680,
    "dropsitcph": 8708276680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20287",
    "droptype": "D",
    "dropname": "CURTIS",
    "dropdeladd": "14 CURTIS RD",
    "dropdelcty": "CURTIS",
    "dropdelst": "AR",
    "dropdelzpp": 717289998,
    "dropphyadd": "14 CURTIS RD",
    "dropphycty": "CURTIS",
    "dropphyst": "AR",
    "dropphyzpp": 717289998,
    "dropmaladd": "14 CURTIS RD",
    "dropmalcty": "CURTIS",
    "dropmalst": "AR",
    "dropmalzpp": 717289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702462717,
    "dropsitcph": 8702462717,
    "dropfax": 8702301531
  },
  {
    "dcode": "D",
    "dropkey": "PY20288",
    "droptype": "D",
    "dropname": "CUSHMAN",
    "dropdeladd": "100 COLLIETOWN RD",
    "dropdelcty": "CUSHMAN",
    "dropdelst": "AR",
    "dropdelzpp": 725269998,
    "dropphyadd": "100 COLLIETOWN RD",
    "dropphycty": "CUSHMAN",
    "dropphyst": "AR",
    "dropphyzpp": 725269998,
    "dropmaladd": "100 COLLIETOWN RD",
    "dropmalcty": "CUSHMAN",
    "dropmalst": "AR",
    "dropmalzpp": 725269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017933182,
    "dropsitcph": 8707933182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20294",
    "droptype": "D",
    "dropname": "DAMASCUS",
    "dropdeladd": "17465 HIGHWAY 65 S",
    "dropdelcty": "DAMASCUS",
    "dropdelst": "AR",
    "dropdelzpp": 720399998,
    "dropphyadd": "17465 HIGHWAY 65 S",
    "dropphycty": "DAMASCUS",
    "dropphyst": "AR",
    "dropphyzpp": 720399998,
    "dropmaladd": "17465 HIGHWAY 65 S",
    "dropmalcty": "DAMASCUS",
    "dropmalst": "AR",
    "dropmalzpp": 720399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013357451,
    "dropsitcph": 5013357451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20295",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "407 E 8TH ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728338821,
    "dropphyadd": "407 E 8TH ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728338821,
    "dropmaladd": "407 E 8TH ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728338821,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794952820,
    "dropsitcph": 4794952820,
    "dropfax": 4794952820
  },
  {
    "dcode": "D",
    "dropkey": "PY20296",
    "droptype": "D",
    "dropname": "DARDANELLE",
    "dropdeladd": "103 N FRONT ST",
    "dropdelcty": "DARDANELLE",
    "dropdelst": "AR",
    "dropdelzpp": 728349998,
    "dropphyadd": "103 N FRONT ST",
    "dropphycty": "DARDANELLE",
    "dropphyst": "AR",
    "dropphyzpp": 728349998,
    "dropmaladd": "103 N FRONT ST",
    "dropmalcty": "DARDANELLE",
    "dropmalst": "AR",
    "dropmalzpp": 728349998,
    "dropsitphn": 4792293929,
    "dropsitlph": 5012293929,
    "dropsitcph": 4792293929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20297",
    "droptype": "D",
    "dropname": "DATTO",
    "dropdeladd": "300 N BILL RICE ST",
    "dropdelcty": "DATTO",
    "dropdelst": "AR",
    "dropdelzpp": 724249998,
    "dropphyadd": "300 N BILL RICE ST",
    "dropphycty": "DATTO",
    "dropphyst": "AR",
    "dropphyzpp": 724249998,
    "dropmaladd": "300 N BILL RICE ST",
    "dropmalcty": "DATTO",
    "dropmalst": "AR",
    "dropmalzpp": 724249998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702765640,
    "dropsitcph": 8702765640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20300",
    "droptype": "D",
    "dropname": "DE QUEEN",
    "dropdeladd": "105 N 4TH ST",
    "dropdelcty": "DE QUEEN",
    "dropdelst": "AR",
    "dropdelzpp": 718329998,
    "dropphyadd": "105 N 4TH ST",
    "dropphycty": "DE QUEEN",
    "dropphyst": "AR",
    "dropphyzpp": 718329998,
    "dropmaladd": "105 N 4TH ST",
    "dropmalcty": "DE QUEEN",
    "dropmalst": "AR",
    "dropmalzpp": 718329998,
    "dropsitphn": 8705843234,
    "dropsitlph": 8705843234,
    "dropsitcph": 8705843234,
    "dropfax": 8706428759
  },
  {
    "dcode": "D",
    "dropkey": "PY20302",
    "droptype": "D",
    "dropname": "DE VALLS BLUFF",
    "dropdeladd": "1 NEWT PARK DR",
    "dropdelcty": "DE VALLS BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 720419998,
    "dropphyadd": "1 NEWT PARK DR",
    "dropphycty": "DE VALLS BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 720419998,
    "dropmaladd": "1 NEWT PARK DR",
    "dropmalcty": "DE VALLS BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 720419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709982665,
    "dropsitcph": 8709982665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20303",
    "droptype": "D",
    "dropname": "DE WITT",
    "dropdeladd": "221 W CROSS ST",
    "dropdelcty": "DE WITT",
    "dropdelst": "AR",
    "dropdelzpp": 720429998,
    "dropphyadd": "221 W CROSS ST",
    "dropphycty": "DE WITT",
    "dropphyst": "AR",
    "dropphyzpp": 720429998,
    "dropmaladd": "221 W CROSS ST",
    "dropmalcty": "DE WITT",
    "dropmalst": "AR",
    "dropmalzpp": 720429998,
    "dropsitphn": 8709464356,
    "dropsitlph": 8709464356,
    "dropsitcph": 8709464356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20305",
    "droptype": "D",
    "dropname": "DECATUR",
    "dropdeladd": "750 E ROLLER AVE",
    "dropdelcty": "DECATUR",
    "dropdelst": "AR",
    "dropdelzpp": 727229998,
    "dropphyadd": "750 E ROLLER AVE",
    "dropphycty": "DECATUR",
    "dropphyst": "AR",
    "dropphyzpp": 727229998,
    "dropmaladd": "750 E ROLLER AVE",
    "dropmalcty": "DECATUR",
    "dropmalst": "AR",
    "dropmalzpp": 727229998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4797523487,
    "dropsitcph": 4797523487,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20308",
    "droptype": "D",
    "dropname": "DEER",
    "dropdeladd": "312 HIGHWAY 16 W",
    "dropdelcty": "DEER",
    "dropdelst": "AR",
    "dropdelzpp": 726289998,
    "dropphyadd": "312 HIGHWAY 16 W",
    "dropphycty": "DEER",
    "dropphyst": "AR",
    "dropphyzpp": 726289998,
    "dropmaladd": "312 HIGHWAY 16 W",
    "dropmalcty": "DEER",
    "dropmalst": "AR",
    "dropmalzpp": 726289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704285952,
    "dropsitcph": 8704285952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20310",
    "droptype": "D",
    "dropname": "DELAPLAINE",
    "dropdeladd": "3523 HIGHWAY 90",
    "dropdelcty": "DELAPLAINE",
    "dropdelst": "AR",
    "dropdelzpp": 724258192,
    "dropphyadd": "3523 HIGHWAY 90",
    "dropphycty": "DELAPLAINE",
    "dropphyst": "AR",
    "dropphyzpp": 724258192,
    "dropmaladd": "3523 HIGHWAY 90",
    "dropmalcty": "DELAPLAINE",
    "dropmalst": "AR",
    "dropmalzpp": 724258192,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702493810,
    "dropsitcph": 8702493810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20311",
    "droptype": "D",
    "dropname": "DELAWARE",
    "dropdeladd": "53 E STATE HIGHWAY 393",
    "dropdelcty": "DELAWARE",
    "dropdelst": "AR",
    "dropdelzpp": 728359998,
    "dropphyadd": "53 E STATE HIGHWAY 393",
    "dropphycty": "DELAWARE",
    "dropphyst": "AR",
    "dropphyzpp": 728359998,
    "dropmaladd": "53 E STATE HIGHWAY 393",
    "dropmalcty": "DELAWARE",
    "dropmalst": "AR",
    "dropmalzpp": 728359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792292975,
    "dropsitcph": 4792292975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20312",
    "droptype": "D",
    "dropname": "DELIGHT",
    "dropdeladd": "126 E ANTIOCH ST",
    "dropdelcty": "DELIGHT",
    "dropdelst": "AR",
    "dropdelzpp": 719409998,
    "dropphyadd": "126 E ANTIOCH ST",
    "dropphycty": "DELIGHT",
    "dropphyst": "AR",
    "dropphyzpp": 719409998,
    "dropmaladd": "126 E ANTIOCH ST",
    "dropmalcty": "DELIGHT",
    "dropmalst": "AR",
    "dropmalzpp": 719409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703792766,
    "dropsitcph": 8703792766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20313",
    "droptype": "D",
    "dropname": "DELL",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "DELL",
    "dropdelst": "AR",
    "dropdelzpp": 724269998,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "DELL",
    "dropphyst": "AR",
    "dropphyzpp": 724269998,
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "DELL",
    "dropmalst": "AR",
    "dropmalzpp": 724269998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705642502,
    "dropsitcph": 8705642502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20314",
    "droptype": "D",
    "dropname": "DENNARD",
    "dropdeladd": "120 POST OFFICE RD",
    "dropdelcty": "DENNARD",
    "dropdelst": "AR",
    "dropdelzpp": 726297335,
    "dropphyadd": "120 POST OFFICE RD",
    "dropphycty": "DENNARD",
    "dropphyst": "AR",
    "dropphyzpp": 726297335,
    "dropmaladd": "120 POST OFFICE RD",
    "dropmalcty": "DENNARD",
    "dropmalst": "AR",
    "dropmalzpp": 726297335,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017452795,
    "dropsitcph": 5017452795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20315",
    "droptype": "D",
    "dropname": "DERMOTT",
    "dropdeladd": "111 S FREEMAN ST",
    "dropdelcty": "DERMOTT",
    "dropdelst": "AR",
    "dropdelzpp": 716389998,
    "dropphyadd": "111 S FREEMAN ST",
    "dropphycty": "DERMOTT",
    "dropphyst": "AR",
    "dropphyzpp": 716389998,
    "dropmaladd": "111 S FREEMAN ST",
    "dropmalcty": "DERMOTT",
    "dropmalst": "AR",
    "dropmalzpp": 716389998,
    "dropsitphn": 8705385261,
    "dropsitlph": 8705385261,
    "dropsitcph": 8705385261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20316",
    "droptype": "D",
    "dropname": "DES ARC",
    "dropdeladd": "109 S 4TH ST",
    "dropdelcty": "DES ARC",
    "dropdelst": "AR",
    "dropdelzpp": 720409998,
    "dropphyadd": "109 S 4TH ST",
    "dropphycty": "DES ARC",
    "dropphyst": "AR",
    "dropphyzpp": 720409998,
    "dropmaladd": "109 S 4TH ST",
    "dropmalcty": "DES ARC",
    "dropmalst": "AR",
    "dropmalzpp": 720409998,
    "dropsitphn": 8702564519,
    "dropsitlph": 8702564519,
    "dropsitcph": 8702564519,
    "dropfax": 5012564582
  },
  {
    "dcode": "D",
    "dropkey": "PY20317",
    "droptype": "D",
    "dropname": "DESHA",
    "dropdeladd": "20 GAINER FERRY RD",
    "dropdelcty": "DESHA",
    "dropdelst": "AR",
    "dropdelzpp": 725279998,
    "dropphyadd": "20 GAINER FERRY RD",
    "dropphycty": "DESHA",
    "dropphyst": "AR",
    "dropphyzpp": 725279998,
    "dropmaladd": "20 GAINER FERRY RD",
    "dropmalcty": "DESHA",
    "dropmalst": "AR",
    "dropmalzpp": 725279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702512250,
    "dropsitcph": 8702512250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20322",
    "droptype": "D",
    "dropname": "DIAZ",
    "dropdeladd": "3400 S MAIN ST",
    "dropdelcty": "DIAZ",
    "dropdelst": "AR",
    "dropdelzpp": 720438800,
    "dropphyadd": "3400 S MAIN ST",
    "dropphycty": "DIAZ",
    "dropphyst": "AR",
    "dropphyzpp": 720438800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIAZ",
    "dropmalst": "AR",
    "dropmalzpp": 720439998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705238679,
    "dropsitcph": 8705238679,
    "dropfax": 8705238679
  },
  {
    "dcode": "D",
    "dropkey": "PY20323",
    "droptype": "D",
    "dropname": "DIERKS",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "DIERKS",
    "dropdelst": "AR",
    "dropdelzpp": 718339998,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "DIERKS",
    "dropphyst": "AR",
    "dropphyzpp": 718339998,
    "dropmaladd": "121 MAIN ST",
    "dropmalcty": "DIERKS",
    "dropmalst": "AR",
    "dropmalzpp": 718339998,
    "dropsitphn": 8702863256,
    "dropsitlph": 8702863256,
    "dropsitcph": 8702863256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20325",
    "droptype": "D",
    "dropname": "DODDRIDGE",
    "dropdeladd": "28338 HIGHWAY 71",
    "dropdelcty": "DODDRIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 718349998,
    "dropphyadd": "28338 HIGHWAY 71",
    "dropphycty": "DODDRIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 718349998,
    "dropmaladd": "28338 HIGHWAY 71",
    "dropmalcty": "DODDRIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 718349998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706912344,
    "dropsitcph": 8706912344,
    "dropfax": 8706912344
  },
  {
    "dcode": "D",
    "dropkey": "PY20326",
    "droptype": "D",
    "dropname": "MARBLE FALLS",
    "dropdeladd": "5 DOGPATCH BLVD",
    "dropdelcty": "MARBLE FALLS",
    "dropdelst": "AR",
    "dropdelzpp": 726489998,
    "dropphyadd": "5 DOGPATCH BLVD",
    "dropphycty": "MARBLE FALLS",
    "dropphyst": "AR",
    "dropphyzpp": 726489998,
    "dropmaladd": "5 DOGPATCH BLVD",
    "dropmalcty": "MARBLE FALLS",
    "dropmalst": "AR",
    "dropmalzpp": 726489998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707431250,
    "dropsitcph": 8707431250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20329",
    "droptype": "D",
    "dropname": "DOLPH",
    "dropdeladd": "3715 DOLPH RD",
    "dropdelcty": "DOLPH",
    "dropdelst": "AR",
    "dropdelzpp": 725288848,
    "dropphyadd": "3715 DOLPH RD",
    "dropphycty": "DOLPH",
    "dropphyst": "AR",
    "dropphyzpp": 725288848,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOLPH",
    "dropmalst": "AR",
    "dropmalzpp": 725289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702973080,
    "dropsitcph": 8702973080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20331",
    "droptype": "D",
    "dropname": "DONALDSON",
    "dropdeladd": "501 BRYANT DR",
    "dropdelcty": "DONALDSON",
    "dropdelst": "AR",
    "dropdelzpp": 719419998,
    "dropphyadd": "501 BRYANT DR",
    "dropphycty": "DONALDSON",
    "dropphyst": "AR",
    "dropphyzpp": 719419998,
    "dropmaladd": "501 BRYANT DR",
    "dropmalcty": "DONALDSON",
    "dropmalst": "AR",
    "dropmalzpp": 719419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013845461,
    "dropsitcph": 5013845461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20334",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "10115 W CAMP ST",
    "dropdelcty": "DOVER",
    "dropdelst": "AR",
    "dropdelzpp": 728379198,
    "dropphyadd": "10115 W CAMP ST",
    "dropphycty": "DOVER",
    "dropphyst": "AR",
    "dropphyzpp": 728379198,
    "dropmaladd": "10115 W CAMP ST",
    "dropmalcty": "DOVER",
    "dropmalst": "AR",
    "dropmalzpp": 728379198,
    "dropsitphn": 4793312115,
    "dropsitlph": 4793312115,
    "dropsitcph": 4793312115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20337",
    "droptype": "D",
    "dropname": "DRASCO",
    "dropdeladd": "6679 HEBER SPRINGS RD N",
    "dropdelcty": "DRASCO",
    "dropdelst": "AR",
    "dropdelzpp": 725309998,
    "dropphyadd": "6679 HEBER SPRINGS RD N",
    "dropphycty": "DRASCO",
    "dropphyst": "AR",
    "dropphyzpp": 725309998,
    "dropmaladd": "6679 HEBER SPRINGS RD N",
    "dropmalcty": "DRASCO",
    "dropmalst": "AR",
    "dropmalzpp": 725309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706683985,
    "dropsitcph": 8706683985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20340",
    "droptype": "D",
    "dropname": "DUMAS",
    "dropdeladd": "320 N MAIN ST",
    "dropdelcty": "DUMAS",
    "dropdelst": "AR",
    "dropdelzpp": 716399998,
    "dropphyadd": "320 N MAIN ST",
    "dropphycty": "DUMAS",
    "dropphyst": "AR",
    "dropphyzpp": 716399998,
    "dropmaladd": "320 N MAIN ST",
    "dropmalcty": "DUMAS",
    "dropmalst": "AR",
    "dropmalzpp": 716399998,
    "dropsitphn": 8703824773,
    "dropsitlph": 8703824773,
    "dropsitcph": 8703824773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20343",
    "droptype": "D",
    "dropname": "DYER",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "DYER",
    "dropdelst": "AR",
    "dropdelzpp": 729359998,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "DYER",
    "dropphyst": "AR",
    "dropphyzpp": 729359998,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "DYER",
    "dropmalst": "AR",
    "dropmalzpp": 729359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019978834,
    "dropsitcph": 5019978834,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20344",
    "droptype": "D",
    "dropname": "DYESS",
    "dropdeladd": "105 HIGHWAY 297 N",
    "dropdelcty": "DYESS",
    "dropdelst": "AR",
    "dropdelzpp": 723309998,
    "dropphyadd": "105 HIGHWAY 297 N",
    "dropphycty": "DYESS",
    "dropphyst": "AR",
    "dropphyzpp": 723309998,
    "dropmaladd": "105 HIGHWAY 297 N",
    "dropmalcty": "DYESS",
    "dropmalst": "AR",
    "dropmalzpp": 723309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707642300,
    "dropsitcph": 8707642300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20346",
    "droptype": "D",
    "dropname": "EARLE",
    "dropdeladd": "700 EXCHANGE ST",
    "dropdelcty": "EARLE",
    "dropdelst": "AR",
    "dropdelzpp": 723319998,
    "dropphyadd": "700 EXCHANGE ST",
    "dropphycty": "EARLE",
    "dropphyst": "AR",
    "dropphyzpp": 723319998,
    "dropmaladd": "700 EXCHANGE ST",
    "dropmalcty": "EARLE",
    "dropmalst": "AR",
    "dropmalzpp": 723319998,
    "dropsitphn": 8707928108,
    "dropsitlph": 8707928108,
    "dropsitcph": 8707928108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20351",
    "droptype": "D",
    "dropname": "EDGEMONT",
    "dropdeladd": "10239 EDGEMONT RD",
    "dropdelcty": "EDGEMONT",
    "dropdelst": "AR",
    "dropdelzpp": 720449998,
    "dropphyadd": "10239 EDGEMONT RD",
    "dropphycty": "EDGEMONT",
    "dropphyst": "AR",
    "dropphyzpp": 720449998,
    "dropmaladd": "10239 EDGEMONT RD",
    "dropmalcty": "EDGEMONT",
    "dropmalst": "AR",
    "dropmalzpp": 720449998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017234396,
    "dropsitcph": 5017234396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20352",
    "droptype": "D",
    "dropname": "EDMONDSON",
    "dropdeladd": "94 WARD ST",
    "dropdelcty": "EDMONDSON",
    "dropdelst": "AR",
    "dropdelzpp": 723329998,
    "dropphyadd": "94 WARD ST",
    "dropphycty": "EDMONDSON",
    "dropphyst": "AR",
    "dropphyzpp": 723329998,
    "dropmaladd": "94 WARD ST",
    "dropmalcty": "EDMONDSON",
    "dropmalst": "AR",
    "dropmalzpp": 723329998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707325241,
    "dropsitcph": 8707325241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20355",
    "droptype": "D",
    "dropname": "EGYPT",
    "dropdeladd": "11085 KINGS HWY",
    "dropdelcty": "EGYPT",
    "dropdelst": "AR",
    "dropdelzpp": 724279998,
    "dropphyadd": "11085 KINGS HWY",
    "dropphycty": "EGYPT",
    "dropphyst": "AR",
    "dropphyzpp": 724279998,
    "dropmaladd": "11085 KINGS HWY",
    "dropmalcty": "EGYPT",
    "dropmalst": "AR",
    "dropmalzpp": 724279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704775200,
    "dropsitcph": 8704775200,
    "dropfax": 8704775200
  },
  {
    "dcode": "D",
    "dropkey": "PY20356",
    "droptype": "D",
    "dropname": "EL DORADO",
    "dropdeladd": "550 S TIMBERLANE DR",
    "dropdelcty": "EL DORADO",
    "dropdelst": "AR",
    "dropdelzpp": 717309998,
    "dropphyadd": "550 S TIMBERLANE DR",
    "dropphycty": "EL DORADO",
    "dropphyst": "AR",
    "dropphyzpp": 717309998,
    "dropmaladd": "550 S TIMBERLANE DR",
    "dropmalcty": "EL DORADO",
    "dropmalst": "AR",
    "dropmalzpp": 717309998,
    "dropsitphn": 8708637571,
    "dropsitlph": 8708637571,
    "dropsitcph": 8708637571,
    "dropfax": 8708752161
  },
  {
    "dcode": "D",
    "dropkey": "PY20357",
    "droptype": "D",
    "dropname": "EL PASO",
    "dropdeladd": "3092 HIGHWAY 5",
    "dropdelcty": "EL PASO",
    "dropdelst": "AR",
    "dropdelzpp": 720459998,
    "dropphyadd": "3092 HIGHWAY 5",
    "dropphycty": "EL PASO",
    "dropphyst": "AR",
    "dropphyzpp": 720459998,
    "dropmaladd": "3092 HIGHWAY 5",
    "dropmalcty": "EL PASO",
    "dropmalst": "AR",
    "dropmalzpp": 720459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017963379,
    "dropsitcph": 5017963379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20358",
    "droptype": "D",
    "dropname": "ELAINE",
    "dropdeladd": "217 MAIN ST",
    "dropdelcty": "ELAINE",
    "dropdelst": "AR",
    "dropdelzpp": 723339998,
    "dropphyadd": "217 MAIN ST",
    "dropphycty": "ELAINE",
    "dropphyst": "AR",
    "dropphyzpp": 723339998,
    "dropmaladd": "217 MAIN ST",
    "dropmalcty": "ELAINE",
    "dropmalst": "AR",
    "dropmalzpp": 723339998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276735,
    "dropsitcph": 8708276735,
    "dropfax": 8708276735
  },
  {
    "dcode": "D",
    "dropkey": "PY20359",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "4506 ELIZABETH RD",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "AR",
    "dropdelzpp": 725319998,
    "dropphyadd": "4506 ELIZABETH RD",
    "dropphycty": "ELIZABETH",
    "dropphyst": "AR",
    "dropphyzpp": 725319998,
    "dropmaladd": "4506 ELIZABETH RD",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "AR",
    "dropmalzpp": 725319998,
    "dropsitphn": 8708637571,
    "dropsitlph": 8709000168,
    "dropsitcph": 8709000168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20361",
    "droptype": "D",
    "dropname": "ELKINS",
    "dropdeladd": "455 N CENTER ST",
    "dropdelcty": "ELKINS",
    "dropdelst": "AR",
    "dropdelzpp": 727279998,
    "dropphyadd": "455 N CENTER ST",
    "dropphycty": "ELKINS",
    "dropphyst": "AR",
    "dropphyzpp": 727279998,
    "dropmaladd": "455 N CENTER ST",
    "dropmalcty": "ELKINS",
    "dropmalst": "AR",
    "dropmalzpp": 727279998,
    "dropsitphn": 8705779340,
    "dropsitlph": 4796432392,
    "dropsitcph": 4796432392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20364",
    "droptype": "D",
    "dropname": "ELM SPRINGS",
    "dropdeladd": "210 SCHOOL AVE",
    "dropdelcty": "ELM SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 727289998,
    "dropphyadd": "210 SCHOOL AVE",
    "dropphycty": "ELM SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 727289998,
    "dropmaladd": "210 SCHOOL AVE",
    "dropmalcty": "ELM SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 727289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792487482,
    "dropsitcph": 4792487482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20366",
    "droptype": "D",
    "dropname": "EMERSON",
    "dropdeladd": "204 N ELM ST",
    "dropdelcty": "EMERSON",
    "dropdelst": "AR",
    "dropdelzpp": 717409998,
    "dropphyadd": "204 N ELM ST",
    "dropphycty": "EMERSON",
    "dropphyst": "AR",
    "dropphyzpp": 717409998,
    "dropmaladd": "204 N ELM ST",
    "dropmalcty": "EMERSON",
    "dropmalst": "AR",
    "dropmalzpp": 717409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705472959,
    "dropsitcph": 8705472959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20367",
    "droptype": "D",
    "dropname": "EMMET",
    "dropdeladd": "101 W 1ST ST",
    "dropdelcty": "EMMET",
    "dropdelst": "AR",
    "dropdelzpp": 718359998,
    "dropphyadd": "101 W 1ST ST",
    "dropphycty": "EMMET",
    "dropphyst": "AR",
    "dropphyzpp": 718359998,
    "dropmaladd": "101 W 1ST ST",
    "dropmalcty": "EMMET",
    "dropmalst": "AR",
    "dropmalzpp": 718359998,
    "dropsitphn": 8708875856,
    "dropsitlph": 8708875856,
    "dropsitcph": 8708875856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20371",
    "droptype": "D",
    "dropname": "ENGLAND",
    "dropdeladd": "111 N MAIN ST",
    "dropdelcty": "ENGLAND",
    "dropdelst": "AR",
    "dropdelzpp": 720469998,
    "dropphyadd": "111 N MAIN ST",
    "dropphycty": "ENGLAND",
    "dropphyst": "AR",
    "dropphyzpp": 720469998,
    "dropmaladd": "111 N MAIN ST",
    "dropmalcty": "ENGLAND",
    "dropmalst": "AR",
    "dropmalzpp": 720469998,
    "dropsitphn": 5018423506,
    "dropsitlph": 5018423506,
    "dropsitcph": 5018423506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20372",
    "droptype": "D",
    "dropname": "ENOLA",
    "dropdeladd": "232C HIGHWAY 107 N",
    "dropdelcty": "ENOLA",
    "dropdelst": "AR",
    "dropdelzpp": 720479998,
    "dropphyadd": "232C HIGHWAY 107 N",
    "dropphycty": "ENOLA",
    "dropphyst": "AR",
    "dropphyzpp": 720479998,
    "dropmaladd": "232C HIGHWAY 107 N",
    "dropmalcty": "ENOLA",
    "dropmalst": "AR",
    "dropmalzpp": 720479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018496048,
    "dropsitcph": 5078496048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20378",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "2 ETHEL RD",
    "dropdelcty": "ETHEL",
    "dropdelst": "AR",
    "dropdelzpp": 720489998,
    "dropphyadd": "2 ETHEL RD",
    "dropphycty": "ETHEL",
    "dropphyst": "AR",
    "dropphyzpp": 720489998,
    "dropmaladd": "2 ETHEL RD",
    "dropmalcty": "ETHEL",
    "dropmalst": "AR",
    "dropmalzpp": 720489998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702823302,
    "dropsitcph": 8702823302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20379",
    "droptype": "D",
    "dropname": "ETOWAH",
    "dropdeladd": "924 DAVIDSON DR",
    "dropdelcty": "ETOWAH",
    "dropdelst": "AR",
    "dropdelzpp": 724289998,
    "dropphyadd": "924 DAVIDSON DR",
    "dropphycty": "ETOWAH",
    "dropphyst": "AR",
    "dropphyzpp": 724289998,
    "dropmaladd": "924 DAVIDSON DR",
    "dropmalcty": "ETOWAH",
    "dropmalst": "AR",
    "dropmalzpp": 724289998,
    "dropsitphn": 8705312350,
    "dropsitlph": 8705312350,
    "dropsitcph": 8705312350,
    "dropfax": 8705312351
  },
  {
    "dcode": "D",
    "dropkey": "PY20381",
    "droptype": "D",
    "dropname": "EUDORA",
    "dropdeladd": "112 N ARCHER ST",
    "dropdelcty": "EUDORA",
    "dropdelst": "AR",
    "dropdelzpp": 716409998,
    "dropphyadd": "112 N ARCHER ST",
    "dropphycty": "EUDORA",
    "dropphyst": "AR",
    "dropphyzpp": 716409998,
    "dropmaladd": "112 N ARCHER ST",
    "dropmalcty": "EUDORA",
    "dropmalst": "AR",
    "dropmalzpp": 716409998,
    "dropsitphn": 8703552126,
    "dropsitlph": 8703552126,
    "dropsitcph": 8703552126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20384",
    "droptype": "D",
    "dropname": "EUREKA SPRINGS",
    "dropdeladd": "101 SPRING ST",
    "dropdelcty": "EUREKA SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 726329998,
    "dropphyadd": "101 SPRING ST",
    "dropphycty": "EUREKA SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 726329998,
    "dropmaladd": "101 SPRING ST",
    "dropmalcty": "EUREKA SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 726329998,
    "dropsitphn": 4792539850,
    "dropsitlph": 4792539850,
    "dropsitcph": 4792539850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20385",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "20740 S HIGHWAY 59",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727299998,
    "dropphyadd": "20740 S HIGHWAY 59",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727299998,
    "dropmaladd": "20740 S HIGHWAY 59",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727299998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798483184,
    "dropsitcph": 4798483184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20387",
    "droptype": "D",
    "dropname": "EVENING SHADE",
    "dropdeladd": "2095 EVENING SHADE DR",
    "dropdelcty": "EVENING SHADE",
    "dropdelst": "AR",
    "dropdelzpp": 725329998,
    "dropphyadd": "2095 EVENING SHADE DR",
    "dropphycty": "EVENING SHADE",
    "dropphyst": "AR",
    "dropphyzpp": 725329998,
    "dropmaladd": "2095 EVENING SHADE DR",
    "dropmalcty": "EVENING SHADE",
    "dropmalst": "AR",
    "dropmalzpp": 725329998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702663283,
    "dropsitcph": 8702663283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20388",
    "droptype": "D",
    "dropname": "EVERTON",
    "dropdeladd": "12097 E REICH ST",
    "dropdelcty": "EVERTON",
    "dropdelst": "AR",
    "dropdelzpp": 726339998,
    "dropphyadd": "12097 E REICH ST",
    "dropphycty": "EVERTON",
    "dropphyst": "AR",
    "dropphyzpp": 726339998,
    "dropmaladd": "12097 E REICH ST",
    "dropmalcty": "EVERTON",
    "dropmalst": "AR",
    "dropmalzpp": 726339998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704296189,
    "dropsitcph": 8704296189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20399",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "190 W CIMARRON PL",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "AR",
    "dropdelzpp": 727309998,
    "dropphyadd": "190 W CIMARRON PL",
    "dropphycty": "FARMINGTON",
    "dropphyst": "AR",
    "dropphyzpp": 727309998,
    "dropmaladd": "190 W CIMARRON PL",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "AR",
    "dropmalzpp": 727309998,
    "dropsitphn": 4793009007,
    "dropsitlph": 4793009007,
    "dropsitcph": 4793009007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20403",
    "droptype": "D",
    "dropname": "FAYETTEVILLE",
    "dropdeladd": "12 W DICKSON ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727019998,
    "dropphyadd": "12 W DICKSON ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727019998,
    "dropmaladd": "12 W DICKSON ST",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727019998,
    "dropsitphn": 4794428288,
    "dropsitlph": 4794428286,
    "dropsitcph": 4794428286,
    "dropfax": 4794428880
  },
  {
    "dcode": "D",
    "dropkey": "PY20410",
    "droptype": "D",
    "dropname": "FISHER",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "FISHER",
    "dropdelst": "AR",
    "dropdelzpp": 724299998,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "FISHER",
    "dropphyst": "AR",
    "dropphyzpp": 724299998,
    "dropmaladd": "103 E MAIN ST",
    "dropmalcty": "FISHER",
    "dropmalst": "AR",
    "dropmalzpp": 724299998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703287212,
    "dropsitcph": 8703287212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20413",
    "droptype": "D",
    "dropname": "FLIPPIN",
    "dropdeladd": "210 N 8TH ST",
    "dropdelcty": "FLIPPIN",
    "dropdelst": "AR",
    "dropdelzpp": 726349998,
    "dropphyadd": "210 N 8TH ST",
    "dropphycty": "FLIPPIN",
    "dropphyst": "AR",
    "dropphyzpp": 726349998,
    "dropmaladd": "210 N 8TH ST",
    "dropmalcty": "FLIPPIN",
    "dropmalst": "AR",
    "dropmalzpp": 726349998,
    "dropsitphn": 8779078109,
    "dropsitlph": 8779078109,
    "dropsitcph": 8779078109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20414",
    "droptype": "D",
    "dropname": "FLORAL",
    "dropdeladd": "3845 FLORAL RD",
    "dropdelcty": "FLORAL",
    "dropdelst": "AR",
    "dropdelzpp": 725349998,
    "dropphyadd": "3845 FLORAL RD",
    "dropphycty": "FLORAL",
    "dropphyst": "AR",
    "dropphyzpp": 725349998,
    "dropmaladd": "3845 FLORAL RD",
    "dropmalcty": "FLORAL",
    "dropmalst": "AR",
    "dropmalzpp": 725349998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013452863,
    "dropsitcph": 5013452863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20417",
    "droptype": "D",
    "dropname": "FORDYCE",
    "dropdeladd": "801 W 4TH ST",
    "dropdelcty": "FORDYCE",
    "dropdelst": "AR",
    "dropdelzpp": 717429998,
    "dropphyadd": "801 W 4TH ST",
    "dropphycty": "FORDYCE",
    "dropphyst": "AR",
    "dropphyzpp": 717429998,
    "dropmaladd": "801 W 4TH ST",
    "dropmalcty": "FORDYCE",
    "dropmalst": "AR",
    "dropmalzpp": 717429998,
    "dropsitphn": 8703523765,
    "dropsitlph": 8703523765,
    "dropsitcph": 8703523765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20418",
    "droptype": "D",
    "dropname": "FOREMAN",
    "dropdeladd": "510 TRACY LAWRENCE AVE",
    "dropdelcty": "FOREMAN",
    "dropdelst": "AR",
    "dropdelzpp": 718369998,
    "dropphyadd": "510 TRACY LAWRENCE AVE",
    "dropphycty": "FOREMAN",
    "dropphyst": "AR",
    "dropphyzpp": 718369998,
    "dropmaladd": "510 TRACY LAWRENCE AVE",
    "dropmalcty": "FOREMAN",
    "dropmalst": "AR",
    "dropmalzpp": 718369998,
    "dropsitphn": 8705185013,
    "dropsitlph": 5705185013,
    "dropsitcph": 8705185013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20422",
    "droptype": "D",
    "dropname": "FORREST CITY",
    "dropdeladd": "621 E BROADWAY ST",
    "dropdelcty": "FORREST CITY",
    "dropdelst": "AR",
    "dropdelzpp": 723359998,
    "dropphyadd": "621 E BROADWAY ST",
    "dropphycty": "FORREST CITY",
    "dropphyst": "AR",
    "dropphyzpp": 723359998,
    "dropmaladd": "621 E BROADWAY ST",
    "dropmalcty": "FORREST CITY",
    "dropmalst": "AR",
    "dropmalzpp": 723359998,
    "dropsitphn": 8706333649,
    "dropsitlph": 8706334238,
    "dropsitcph": 8706334238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20426",
    "droptype": "D",
    "dropname": "FORT SMITH",
    "dropdeladd": "3318 S 74TH ST",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729039998,
    "dropphyadd": "3318 S 74TH ST",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729039998,
    "dropmaladd": "3318 S 74TH ST",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729039998,
    "dropsitphn": 4794846405,
    "dropsitlph": 4794846401,
    "dropsitcph": 4794846401,
    "dropfax": 4794846397
  },
  {
    "dcode": "D",
    "dropkey": "PY20428",
    "droptype": "D",
    "dropname": "FOUKE",
    "dropdeladd": "206 N MONSTER EXPY",
    "dropdelcty": "FOUKE",
    "dropdelst": "AR",
    "dropdelzpp": 718379998,
    "dropphyadd": "206 N MONSTER EXPY",
    "dropphycty": "FOUKE",
    "dropphyst": "AR",
    "dropphyzpp": 718379998,
    "dropmaladd": "206 N MONSTER EXPY",
    "dropmalcty": "FOUKE",
    "dropmalst": "AR",
    "dropmalzpp": 718379998,
    "dropsitphn": 8706534144,
    "dropsitlph": 8706534144,
    "dropsitcph": 8706534144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20429",
    "droptype": "D",
    "dropname": "FOUNTAIN HILL",
    "dropdeladd": "209 PINE ST",
    "dropdelcty": "FOUNTAIN HILL",
    "dropdelst": "AR",
    "dropdelzpp": 716429998,
    "dropphyadd": "209 PINE ST",
    "dropphycty": "FOUNTAIN HILL",
    "dropphyst": "AR",
    "dropphyzpp": 716429998,
    "dropmaladd": "209 PINE ST",
    "dropmalcty": "FOUNTAIN HILL",
    "dropmalst": "AR",
    "dropmalzpp": 716429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708535697,
    "dropsitcph": 8708535697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20434",
    "droptype": "D",
    "dropname": "FOX",
    "dropdeladd": "15949 HIGHWAY 263",
    "dropdelcty": "FOX",
    "dropdelst": "AR",
    "dropdelzpp": 720519998,
    "dropphyadd": "15949 HIGHWAY 263",
    "dropphycty": "FOX",
    "dropphyst": "AR",
    "dropphyzpp": 720519998,
    "dropmaladd": "15949 HIGHWAY 263",
    "dropmalcty": "FOX",
    "dropmalst": "AR",
    "dropmalzpp": 720519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703634598,
    "dropsitcph": 8703634598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20435",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "780 HIGHWAY 56 E",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "AR",
    "dropdelzpp": 725369998,
    "dropphyadd": "780 HIGHWAY 56 E",
    "dropphycty": "FRANKLIN",
    "dropphyst": "AR",
    "dropphyzpp": 725369998,
    "dropmaladd": "780 HIGHWAY 56 E",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "AR",
    "dropmalzpp": 725369998,
    "dropsitphn": 8703229044,
    "dropsitlph": 8703229044,
    "dropsitcph": 8703229044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20436",
    "droptype": "D",
    "dropname": "FRENCHMANS BAYOU",
    "dropdeladd": "8071 S US HIGHWAY 61",
    "dropdelcty": "FRENCHMANS BAYOU",
    "dropdelst": "AR",
    "dropdelzpp": 723389998,
    "dropphyadd": "8071 S US HIGHWAY 61",
    "dropphycty": "FRENCHMANS BAYOU",
    "dropphyst": "AR",
    "dropphyzpp": 723389998,
    "dropmaladd": "8071 S US HIGHWAY 61",
    "dropmalcty": "FRENCHMANS BAYOU",
    "dropmalst": "AR",
    "dropmalzpp": 723389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705374349,
    "dropsitcph": 8705374349,
    "dropfax": 8705374332
  },
  {
    "dcode": "D",
    "dropkey": "PY20437",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "2595 MALVERN RD",
    "dropdelcty": "FRIENDSHIP",
    "dropdelst": "AR",
    "dropdelzpp": 719428800,
    "dropphyadd": "2595 MALVERN RD",
    "dropphycty": "FRIENDSHIP",
    "dropphyst": "AR",
    "dropphyzpp": 719428800,
    "dropmaladd": "2595 MALVERN RD",
    "dropmalcty": "FRIENDSHIP",
    "dropmalst": "AR",
    "dropmalzpp": 719428800,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013842263,
    "dropsitcph": 5013842263,
    "dropfax": 5013842263
  },
  {
    "dcode": "D",
    "dropkey": "PY20438",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "303 LITTLE RIVER ST",
    "dropdelcty": "FULTON",
    "dropdelst": "AR",
    "dropdelzpp": 718389998,
    "dropphyadd": "303 LITTLE RIVER ST",
    "dropphycty": "FULTON",
    "dropphyst": "AR",
    "dropphyzpp": 718389998,
    "dropmaladd": "303 LITTLE RIVER ST",
    "dropmalcty": "FULTON",
    "dropmalst": "AR",
    "dropmalzpp": 718389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708962408,
    "dropsitcph": 8708962408,
    "dropfax": 8708962214
  },
  {
    "dcode": "D",
    "dropkey": "PY20442",
    "droptype": "D",
    "dropname": "GAMALIEL",
    "dropdeladd": "7621 HIGHWAY 101",
    "dropdelcty": "GAMALIEL",
    "dropdelst": "AR",
    "dropdelzpp": 725379998,
    "dropphyadd": "7621 HIGHWAY 101",
    "dropphycty": "GAMALIEL",
    "dropphyst": "AR",
    "dropphyzpp": 725379998,
    "dropmaladd": "7621 HIGHWAY 101",
    "dropmalcty": "GAMALIEL",
    "dropmalst": "AR",
    "dropmalzpp": 725379998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704672023,
    "dropsitcph": 8704672023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20443",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "14700 ALVIN SEAMSTER RD",
    "dropdelcty": "GARFIELD",
    "dropdelst": "AR",
    "dropdelzpp": 727329998,
    "dropphyadd": "14700 ALVIN SEAMSTER RD",
    "dropphycty": "GARFIELD",
    "dropphyst": "AR",
    "dropphyzpp": 727329998,
    "dropmaladd": "14700 ALVIN SEAMSTER RD",
    "dropmalcty": "GARFIELD",
    "dropmalst": "AR",
    "dropmalzpp": 727329998,
    "dropsitphn": 4793593344,
    "dropsitlph": 4793593344,
    "dropsitcph": 4793593344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20444",
    "droptype": "D",
    "dropname": "GARLAND CITY",
    "dropdeladd": "101 6TH ST",
    "dropdelcty": "GARLAND CITY",
    "dropdelst": "AR",
    "dropdelzpp": 718399998,
    "dropphyadd": "101 6TH ST",
    "dropphycty": "GARLAND CITY",
    "dropphyst": "AR",
    "dropphyzpp": 718399998,
    "dropmaladd": "101 6TH ST",
    "dropmalcty": "GARLAND CITY",
    "dropmalst": "AR",
    "dropmalzpp": 718399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706832355,
    "dropsitcph": 8706832355,
    "dropfax": 8706832355
  },
  {
    "dcode": "D",
    "dropkey": "PY20446",
    "droptype": "D",
    "dropname": "GARNER",
    "dropdeladd": "4392 HIGHWAY 367 S",
    "dropdelcty": "GARNER",
    "dropdelst": "AR",
    "dropdelzpp": 720529998,
    "dropphyadd": "4392 HIGHWAY 367 S",
    "dropphycty": "GARNER",
    "dropphyst": "AR",
    "dropphyzpp": 720529998,
    "dropmaladd": "4392 HIGHWAY 367 S",
    "dropmalcty": "GARNER",
    "dropmalst": "AR",
    "dropmalzpp": 720529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017263522,
    "dropsitcph": 5017263522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20448",
    "droptype": "D",
    "dropname": "GASSVILLE",
    "dropdeladd": "94 HIGHWAY 126 N",
    "dropdelcty": "GASSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 726359998,
    "dropphyadd": "94 HIGHWAY 126 N",
    "dropphycty": "GASSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 726359998,
    "dropmaladd": "94 HIGHWAY 126 N",
    "dropmalcty": "GASSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 726359998,
    "dropsitphn": 8704023056,
    "dropsitlph": 8704023056,
    "dropsitcph": 8704023056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20450",
    "droptype": "D",
    "dropname": "GATEWAY",
    "dropdeladd": "17260 HIGHWAY 37 N",
    "dropdelcty": "GATEWAY",
    "dropdelst": "AR",
    "dropdelzpp": 727339998,
    "dropphyadd": "17260 HIGHWAY 37 N",
    "dropphycty": "GATEWAY",
    "dropphyst": "AR",
    "dropphyzpp": 727339998,
    "dropmaladd": "17260 HIGHWAY 37 N",
    "dropmalcty": "GATEWAY",
    "dropmalst": "AR",
    "dropmalzpp": 727339998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796563367,
    "dropsitcph": 4796563367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20452",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "8185 STATE HIGHWAY 196",
    "dropdelcty": "GENOA",
    "dropdelst": "AR",
    "dropdelzpp": 718408800,
    "dropphyadd": "8185 STATE HIGHWAY 196",
    "dropphycty": "GENOA",
    "dropphyst": "AR",
    "dropphyzpp": 718408800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENOA",
    "dropmalst": "AR",
    "dropmalzpp": 718409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707746964,
    "dropsitcph": 8707746964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20453",
    "droptype": "D",
    "dropname": "GENTRY",
    "dropdeladd": "899 W MAIN ST",
    "dropdelcty": "GENTRY",
    "dropdelst": "AR",
    "dropdelzpp": 727349998,
    "dropphyadd": "899 W MAIN ST",
    "dropphycty": "GENTRY",
    "dropphyst": "AR",
    "dropphyzpp": 727349998,
    "dropmaladd": "899 W MAIN ST",
    "dropmalcty": "GENTRY",
    "dropmalst": "AR",
    "dropmalzpp": 727349998,
    "dropsitphn": 4797362332,
    "dropsitlph": 4797362332,
    "dropsitcph": 4797362332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20455",
    "droptype": "D",
    "dropname": "GEPP",
    "dropdeladd": "17971 HIGHWAY 62 W",
    "dropdelcty": "GEPP",
    "dropdelst": "AR",
    "dropdelzpp": 725389998,
    "dropphyadd": "17971 HIGHWAY 62 W",
    "dropphycty": "GEPP",
    "dropphyst": "AR",
    "dropphyzpp": 725389998,
    "dropmaladd": "17971 HIGHWAY 62 W",
    "dropmalcty": "GEPP",
    "dropmalst": "AR",
    "dropmalzpp": 725389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704582003,
    "dropsitcph": 8704582003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20460",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "26 N FROST ST",
    "dropdelcty": "GILBERT",
    "dropdelst": "AR",
    "dropdelzpp": 726368800,
    "dropphyadd": "26 N FROST ST",
    "dropphycty": "GILBERT",
    "dropphyst": "AR",
    "dropphyzpp": 726368800,
    "dropmaladd": "26 N FROST ST",
    "dropmalcty": "GILBERT",
    "dropmalst": "AR",
    "dropmalzpp": 726368800,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704392717,
    "dropsitcph": 8704392717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20461",
    "droptype": "D",
    "dropname": "GILLETT",
    "dropdeladd": "14 W MAIN ST",
    "dropdelcty": "GILLETT",
    "dropdelst": "AR",
    "dropdelzpp": 720559998,
    "dropphyadd": "14 W MAIN ST",
    "dropphycty": "GILLETT",
    "dropphyst": "AR",
    "dropphyzpp": 720559998,
    "dropmaladd": "14 W MAIN ST",
    "dropmalcty": "GILLETT",
    "dropmalst": "AR",
    "dropmalzpp": 720559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705482676,
    "dropsitcph": 8705482676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20462",
    "droptype": "D",
    "dropname": "GILLHAM",
    "dropdeladd": "110 N 2ND ST",
    "dropdelcty": "GILLHAM",
    "dropdelst": "AR",
    "dropdelzpp": 718419998,
    "dropphyadd": "110 N 2ND ST",
    "dropphycty": "GILLHAM",
    "dropphyst": "AR",
    "dropphyzpp": 718419998,
    "dropmaladd": "110 N 2ND ST",
    "dropmalcty": "GILLHAM",
    "dropmalst": "AR",
    "dropmalzpp": 718419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703862820,
    "dropsitcph": 8703862820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20463",
    "droptype": "D",
    "dropname": "GILMORE",
    "dropdeladd": "102 S FRONT ST",
    "dropdelcty": "GILMORE",
    "dropdelst": "AR",
    "dropdelzpp": 723399998,
    "dropphyadd": "102 S FRONT ST",
    "dropphycty": "GILMORE",
    "dropphyst": "AR",
    "dropphyzpp": 723399998,
    "dropmaladd": "102 S FRONT ST",
    "dropmalcty": "GILMORE",
    "dropmalst": "AR",
    "dropmalzpp": 723399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703432290,
    "dropsitcph": 8703432290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20466",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "32 HIGHWAY 289 S",
    "dropdelcty": "GLENCOE",
    "dropdelst": "AR",
    "dropdelzpp": 725399998,
    "dropphyadd": "32 HIGHWAY 289 S",
    "dropphycty": "GLENCOE",
    "dropphyst": "AR",
    "dropphyzpp": 725399998,
    "dropmaladd": "32 HIGHWAY 289 S",
    "dropmalcty": "GLENCOE",
    "dropmalst": "AR",
    "dropmalzpp": 725399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708952250,
    "dropsitcph": 8708952250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20468",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "916 E BROADWAY",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "AR",
    "dropdelzpp": 719439998,
    "dropphyadd": "916 E BROADWAY",
    "dropphycty": "GLENWOOD",
    "dropphyst": "AR",
    "dropphyzpp": 719439998,
    "dropmaladd": "916 E BROADWAY",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "AR",
    "dropmalzpp": 719439998,
    "dropsitphn": 8703563611,
    "dropsitlph": 8703563611,
    "dropsitcph": 8703563611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20472",
    "droptype": "D",
    "dropname": "GOODWIN",
    "dropdeladd": "75 SFC 907",
    "dropdelcty": "GOODWIN",
    "dropdelst": "AR",
    "dropdelzpp": 723409998,
    "dropphyadd": "75 SFC 907",
    "dropphycty": "GOODWIN",
    "dropphyst": "AR",
    "dropphyzpp": 723409998,
    "dropmaladd": "75 SFC 907",
    "dropmalcty": "GOODWIN",
    "dropmalst": "AR",
    "dropmalzpp": 723409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8705815084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20473",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "188 W BOWEN BLVD",
    "dropdelcty": "GOSHEN",
    "dropdelst": "AR",
    "dropdelzpp": 727359998,
    "dropphyadd": "188 W BOWEN BLVD",
    "dropphycty": "GOSHEN",
    "dropphyst": "AR",
    "dropphyzpp": 727359998,
    "dropmaladd": "188 W BOWEN BLVD",
    "dropmalcty": "GOSHEN",
    "dropmalst": "AR",
    "dropmalzpp": 727359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 4794448966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20476",
    "droptype": "D",
    "dropname": "GOULD",
    "dropdeladd": "305 W JACKSON ST",
    "dropdelcty": "GOULD",
    "dropdelst": "AR",
    "dropdelzpp": 716439998,
    "dropphyadd": "305 W JACKSON ST",
    "dropphycty": "GOULD",
    "dropphyst": "AR",
    "dropphyzpp": 716439998,
    "dropmaladd": "305 W JACKSON ST",
    "dropmalcty": "GOULD",
    "dropmalst": "AR",
    "dropmalzpp": 716439998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8702634500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20478",
    "droptype": "D",
    "dropname": "GRADY",
    "dropdeladd": "118 HIGHWAY 65 S",
    "dropdelcty": "GRADY",
    "dropdelst": "AR",
    "dropdelzpp": 716449998,
    "dropphyadd": "118 HIGHWAY 65 S",
    "dropphycty": "GRADY",
    "dropphyst": "AR",
    "dropphyzpp": 716449998,
    "dropmaladd": "118 HIGHWAY 65 S",
    "dropmalcty": "GRADY",
    "dropmalst": "AR",
    "dropmalzpp": 716449998,
    "dropsitphn": 8704793778,
    "dropsitlph": 5019456732,
    "dropsitcph": 8704793778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20481",
    "droptype": "D",
    "dropname": "GRANNIS",
    "dropdeladd": "8580 HIGHWAY 71 S",
    "dropdelcty": "GRANNIS",
    "dropdelst": "AR",
    "dropdelzpp": 719449998,
    "dropphyadd": "8580 HIGHWAY 71 S",
    "dropphycty": "GRANNIS",
    "dropphyst": "AR",
    "dropphyzpp": 719449998,
    "dropmaladd": "8580 HIGHWAY 71 S",
    "dropmalcty": "GRANNIS",
    "dropmalst": "AR",
    "dropmalzpp": 719449998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013852312,
    "dropsitcph": 8703852312,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20482",
    "droptype": "D",
    "dropname": "GRAPEVINE",
    "dropdeladd": "151 GRANT COUNTY 18",
    "dropdelcty": "GRAPEVINE",
    "dropdelst": "AR",
    "dropdelzpp": 720579998,
    "dropphyadd": "151 GRANT COUNTY 18",
    "dropphycty": "GRAPEVINE",
    "dropphyst": "AR",
    "dropphyzpp": 720579998,
    "dropmaladd": "151 GRANT COUNTY 18",
    "dropmalcty": "GRAPEVINE",
    "dropmalst": "AR",
    "dropmalzpp": 720579998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8709422611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20486",
    "droptype": "D",
    "dropname": "GRAVELLY",
    "dropdeladd": "28634 W HIGHWAY 28",
    "dropdelcty": "GRAVELLY",
    "dropdelst": "AR",
    "dropdelzpp": 728389998,
    "dropphyadd": "28634 W HIGHWAY 28",
    "dropphycty": "GRAVELLY",
    "dropphyst": "AR",
    "dropphyzpp": 728389998,
    "dropmaladd": "28634 W HIGHWAY 28",
    "dropmalcty": "GRAVELLY",
    "dropmalst": "AR",
    "dropmalzpp": 728389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 4792994032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20489",
    "droptype": "D",
    "dropname": "GRAVETTE",
    "dropdeladd": "613 MAIN ST SW",
    "dropdelcty": "GRAVETTE",
    "dropdelst": "AR",
    "dropdelzpp": 727369998,
    "dropphyadd": "613 MAIN ST SW",
    "dropphycty": "GRAVETTE",
    "dropphyst": "AR",
    "dropphyzpp": 727369998,
    "dropmaladd": "613 MAIN ST SW",
    "dropmalcty": "GRAVETTE",
    "dropmalst": "AR",
    "dropmalzpp": 727369998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 4797875441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20491",
    "droptype": "D",
    "dropname": "GREEN FOREST",
    "dropdeladd": "701 W MAIN ST",
    "dropdelcty": "GREEN FOREST",
    "dropdelst": "AR",
    "dropdelzpp": 726389998,
    "dropphyadd": "701 W MAIN ST",
    "dropphycty": "GREEN FOREST",
    "dropphyst": "AR",
    "dropphyzpp": 726389998,
    "dropmaladd": "701 W MAIN ST",
    "dropmalcty": "GREEN FOREST",
    "dropmalst": "AR",
    "dropmalzpp": 726389998,
    "dropsitphn": 8704386112,
    "dropsitlph": 5019456732,
    "dropsitcph": 8704386112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20493",
    "droptype": "D",
    "dropname": "GREENBRIER",
    "dropdeladd": "88 S BROADVIEW ST",
    "dropdelcty": "GREENBRIER",
    "dropdelst": "AR",
    "dropdelzpp": 720589998,
    "dropphyadd": "88 S BROADVIEW ST",
    "dropphycty": "GREENBRIER",
    "dropphyst": "AR",
    "dropphyzpp": 720589998,
    "dropmaladd": "88 S BROADVIEW ST",
    "dropmalcty": "GREENBRIER",
    "dropmalst": "AR",
    "dropmalzpp": 720589998,
    "dropsitphn": 5016793710,
    "dropsitlph": 5019456732,
    "dropsitcph": 5016793710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20494",
    "droptype": "D",
    "dropname": "GREENLAND",
    "dropdeladd": "4500 S SCHOOL AVE STE P",
    "dropdelcty": "GREENLAND",
    "dropdelst": "AR",
    "dropdelzpp": 727378801,
    "dropphyadd": "4500 S SCHOOL AVE STE P",
    "dropphycty": "GREENLAND",
    "dropphyst": "AR",
    "dropphyzpp": 727378801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENLAND",
    "dropmalst": "AR",
    "dropmalzpp": 727379998,
    "dropsitphn": 4793872786,
    "dropsitlph": 5019456732,
    "dropsitcph": 4794435998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20495",
    "droptype": "D",
    "dropname": "GREENWAY",
    "dropdeladd": "411 STATE ST",
    "dropdelcty": "GREENWAY",
    "dropdelst": "AR",
    "dropdelzpp": 724309998,
    "dropphyadd": "411 STATE ST",
    "dropphycty": "GREENWAY",
    "dropphyst": "AR",
    "dropphyzpp": 724309998,
    "dropmaladd": "411 STATE ST",
    "dropmalcty": "GREENWAY",
    "dropmalst": "AR",
    "dropmalzpp": 724309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8705293630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20496",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "450 E ATLANTA ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "AR",
    "dropdelzpp": 729369998,
    "dropphyadd": "450 E ATLANTA ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "AR",
    "dropphyzpp": 729369998,
    "dropmaladd": "450 E ATLANTA ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "AR",
    "dropmalzpp": 729369998,
    "dropsitphn": 4799964269,
    "dropsitlph": 5019456732,
    "dropsitcph": 4799964269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20498",
    "droptype": "D",
    "dropname": "GREGORY",
    "dropdeladd": "20087 HIGHWAY 33 S",
    "dropdelcty": "GREGORY",
    "dropdelst": "AR",
    "dropdelzpp": 720599998,
    "dropphyadd": "20087 HIGHWAY 33 S",
    "dropphycty": "GREGORY",
    "dropphyst": "AR",
    "dropphyzpp": 720599998,
    "dropmaladd": "20087 HIGHWAY 33 S",
    "dropmalcty": "GREGORY",
    "dropmalst": "AR",
    "dropmalzpp": 720599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8703475614,
    "dropfax": 8703475614
  },
  {
    "dcode": "D",
    "dropkey": "PY20501",
    "droptype": "D",
    "dropname": "GRIFFITHVILLE",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "GRIFFITHVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720609998,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "GRIFFITHVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720609998,
    "dropmaladd": "311 MAIN ST",
    "dropmalcty": "GRIFFITHVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 5013234646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20502",
    "droptype": "D",
    "dropname": "GRUBBS",
    "dropdeladd": "520 HIGHWAY 37 N",
    "dropdelcty": "GRUBBS",
    "dropdelst": "AR",
    "dropdelzpp": 724319998,
    "dropphyadd": "520 HIGHWAY 37 N",
    "dropphycty": "GRUBBS",
    "dropphyst": "AR",
    "dropphyzpp": 724319998,
    "dropmaladd": "520 HIGHWAY 37 N",
    "dropmalcty": "GRUBBS",
    "dropmalst": "AR",
    "dropmalzpp": 724319998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8702523563,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20503",
    "droptype": "D",
    "dropname": "GUION",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "GUION",
    "dropdelst": "AR",
    "dropdelzpp": 725409998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "GUION",
    "dropphyst": "AR",
    "dropphyzpp": 725409998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "GUION",
    "dropmalst": "AR",
    "dropmalzpp": 725409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8703465335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20506",
    "droptype": "D",
    "dropname": "GURDON",
    "dropdeladd": "110 E JOSLYN ST",
    "dropdelcty": "GURDON",
    "dropdelst": "AR",
    "dropdelzpp": 717439998,
    "dropphyadd": "110 E JOSLYN ST",
    "dropphycty": "GURDON",
    "dropphyst": "AR",
    "dropphyzpp": 717439998,
    "dropmaladd": "110 E JOSLYN ST",
    "dropmalcty": "GURDON",
    "dropmalst": "AR",
    "dropmalzpp": 717439998,
    "dropsitphn": 8703532420,
    "dropsitlph": 5019456732,
    "dropsitcph": 8703534561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20507",
    "droptype": "D",
    "dropname": "GUY",
    "dropdeladd": "4 SUNSET LN",
    "dropdelcty": "GUY",
    "dropdelst": "AR",
    "dropdelzpp": 720619998,
    "dropphyadd": "4 SUNSET LN",
    "dropphycty": "GUY",
    "dropphyst": "AR",
    "dropphyzpp": 720619998,
    "dropmaladd": "4 SUNSET LN",
    "dropmalcty": "GUY",
    "dropmalst": "AR",
    "dropmalzpp": 720619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 5016792401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20510",
    "droptype": "D",
    "dropname": "HACKETT",
    "dropdeladd": "402 N MAIN ST",
    "dropdelcty": "HACKETT",
    "dropdelst": "AR",
    "dropdelzpp": 729379998,
    "dropphyadd": "402 N MAIN ST",
    "dropphycty": "HACKETT",
    "dropphyst": "AR",
    "dropphyzpp": 729379998,
    "dropmaladd": "402 N MAIN ST",
    "dropmalcty": "HACKETT",
    "dropmalst": "AR",
    "dropmalzpp": 729379998,
    "dropsitphn": 4796388828,
    "dropsitlph": 4796388828,
    "dropsitcph": 4796388828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20511",
    "droptype": "D",
    "dropname": "HAGARVILLE",
    "dropdeladd": "12083 HIGHWAY 123",
    "dropdelcty": "HAGARVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728399998,
    "dropphyadd": "12083 HIGHWAY 123",
    "dropphycty": "HAGARVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728399998,
    "dropmaladd": "12083 HIGHWAY 123",
    "dropmalcty": "HAGARVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798852195,
    "dropsitcph": 4798852195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20514",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "203 E ADAMS ST",
    "dropdelcty": "HAMBURG",
    "dropdelst": "AR",
    "dropdelzpp": 716469998,
    "dropphyadd": "203 E ADAMS ST",
    "dropphycty": "HAMBURG",
    "dropphyst": "AR",
    "dropphyzpp": 716469998,
    "dropmaladd": "203 E ADAMS ST",
    "dropmalcty": "HAMBURG",
    "dropmalst": "AR",
    "dropmalzpp": 716469998,
    "dropsitphn": 8708535241,
    "dropsitlph": 8708535241,
    "dropsitcph": 8708535241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20518",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "213 W DUNN AVE",
    "dropdelcty": "HAMPTON",
    "dropdelst": "AR",
    "dropdelzpp": 717445000,
    "dropphyadd": "213 W DUNN AVE",
    "dropphycty": "HAMPTON",
    "dropphyst": "AR",
    "dropphyzpp": 717445000,
    "dropmaladd": "213 W DUNN AVE",
    "dropmalcty": "HAMPTON",
    "dropmalst": "AR",
    "dropmalzpp": 717445000,
    "dropsitphn": 8707982372,
    "dropsitlph": 8707982372,
    "dropsitcph": 8707982372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20523",
    "droptype": "D",
    "dropname": "HARDY",
    "dropdeladd": "300 HIGHWAY 63 N",
    "dropdelcty": "HARDY",
    "dropdelst": "AR",
    "dropdelzpp": 725429998,
    "dropphyadd": "300 HIGHWAY 63 N",
    "dropphycty": "HARDY",
    "dropphyst": "AR",
    "dropphyzpp": 725429998,
    "dropmaladd": "300 HIGHWAY 63 N",
    "dropmalcty": "HARDY",
    "dropmalst": "AR",
    "dropmalzpp": 725429998,
    "dropsitphn": 8708563720,
    "dropsitlph": 8708563720,
    "dropsitcph": 8708563720,
    "dropfax": 8708562560
  },
  {
    "dcode": "D",
    "dropkey": "PY20527",
    "droptype": "D",
    "dropname": "HARRELL",
    "dropdeladd": "118 E CENTRAL ST",
    "dropdelcty": "HARRELL",
    "dropdelst": "AR",
    "dropdelzpp": 717458800,
    "dropphyadd": "118 E CENTRAL ST",
    "dropphycty": "HARRELL",
    "dropphyst": "AR",
    "dropphyzpp": 717458800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRELL",
    "dropmalst": "AR",
    "dropmalzpp": 717459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707984820,
    "dropsitcph": 8707984820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20528",
    "droptype": "D",
    "dropname": "HARRIET",
    "dropdeladd": "100 E HIGHWAY 14",
    "dropdelcty": "HARRIET",
    "dropdelst": "AR",
    "dropdelzpp": 726399998,
    "dropphyadd": "100 E HIGHWAY 14",
    "dropphycty": "HARRIET",
    "dropphyst": "AR",
    "dropphyzpp": 726399998,
    "dropmaladd": "100 E HIGHWAY 14",
    "dropmalcty": "HARRIET",
    "dropmalst": "AR",
    "dropmalzpp": 726399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704483297,
    "dropsitcph": 8704483297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20530",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "705 W JACKSON ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "AR",
    "dropdelzpp": 724329998,
    "dropphyadd": "705 W JACKSON ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "AR",
    "dropphyzpp": 724329998,
    "dropmaladd": "705 W JACKSON ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "AR",
    "dropmalzpp": 724329998,
    "dropsitphn": 8705782110,
    "dropsitlph": 8705782110,
    "dropsitcph": 8705782110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20532",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "215 W INDUSTRIAL PARK RD",
    "dropdelcty": "HARRISON",
    "dropdelst": "AR",
    "dropdelzpp": 726019998,
    "dropphyadd": "215 W INDUSTRIAL PARK RD",
    "dropphycty": "HARRISON",
    "dropphyst": "AR",
    "dropphyzpp": 726019998,
    "dropmaladd": "215 W INDUSTRIAL PARK RD",
    "dropmalcty": "HARRISON",
    "dropmalst": "AR",
    "dropmalzpp": 726019998,
    "dropsitphn": 8707413473,
    "dropsitlph": 8707413473,
    "dropsitcph": 8707413473,
    "dropfax": 5017417162
  },
  {
    "dcode": "D",
    "dropkey": "PY20533",
    "droptype": "D",
    "dropname": "HARTFORD",
    "dropdeladd": "203 N BROADWAY ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "AR",
    "dropdelzpp": 729389998,
    "dropphyadd": "203 N BROADWAY ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "AR",
    "dropphyzpp": 729389998,
    "dropmaladd": "203 N BROADWAY ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "AR",
    "dropmalzpp": 729389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796392282,
    "dropsitcph": 4796392282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20534",
    "droptype": "D",
    "dropname": "HARTMAN",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "HARTMAN",
    "dropdelst": "AR",
    "dropdelzpp": 728409998,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "HARTMAN",
    "dropphyst": "AR",
    "dropphyzpp": 728409998,
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "HARTMAN",
    "dropmalst": "AR",
    "dropmalzpp": 728409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794971021,
    "dropsitcph": 4794971021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20535",
    "droptype": "D",
    "dropname": "HARVEY",
    "dropdeladd": "26396 E HIGHWAY 28",
    "dropdelcty": "HARVEY",
    "dropdelst": "AR",
    "dropdelzpp": 728419998,
    "dropphyadd": "26396 E HIGHWAY 28",
    "dropphycty": "HARVEY",
    "dropphyst": "AR",
    "dropphyzpp": 728419998,
    "dropmaladd": "26396 E HIGHWAY 28",
    "dropmalcty": "HARVEY",
    "dropmalst": "AR",
    "dropmalzpp": 728419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792994933,
    "dropsitcph": 4792994933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20537",
    "droptype": "D",
    "dropname": "HASTY",
    "dropdeladd": "100 HASTY MOUNTAIN RD",
    "dropdelcty": "HASTY",
    "dropdelst": "AR",
    "dropdelzpp": 726409998,
    "dropphyadd": "100 HASTY MOUNTAIN RD",
    "dropphycty": "HASTY",
    "dropphyst": "AR",
    "dropphyzpp": 726409998,
    "dropmaladd": "100 HASTY MOUNTAIN RD",
    "dropmalcty": "HASTY",
    "dropmalst": "AR",
    "dropmalzpp": 726409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704296291,
    "dropsitcph": 8704296291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20538",
    "droptype": "D",
    "dropname": "HATFIELD",
    "dropdeladd": "100 E HORNBECK RD",
    "dropdelcty": "HATFIELD",
    "dropdelst": "AR",
    "dropdelzpp": 719459998,
    "dropphyadd": "100 E HORNBECK RD",
    "dropphycty": "HATFIELD",
    "dropphyst": "AR",
    "dropphyzpp": 719459998,
    "dropmaladd": "100 E HORNBECK RD",
    "dropmalcty": "HATFIELD",
    "dropmalst": "AR",
    "dropmalzpp": 719459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703896151,
    "dropsitcph": 8703896151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20539",
    "droptype": "D",
    "dropname": "HATTIEVILLE",
    "dropdeladd": "670 HIGHWAY 213",
    "dropdelcty": "HATTIEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720639998,
    "dropphyadd": "670 HIGHWAY 213",
    "dropphycty": "HATTIEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720639998,
    "dropmaladd": "670 HIGHWAY 213",
    "dropmalcty": "HATTIEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720639998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013542709,
    "dropsitcph": 5013542709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20541",
    "droptype": "D",
    "dropname": "HAVANA",
    "dropdeladd": "311 W BROADWAY",
    "dropdelcty": "HAVANA",
    "dropdelst": "AR",
    "dropdelzpp": 728429998,
    "dropphyadd": "311 W BROADWAY",
    "dropphycty": "HAVANA",
    "dropphyst": "AR",
    "dropphyzpp": 728429998,
    "dropmaladd": "311 W BROADWAY",
    "dropmalcty": "HAVANA",
    "dropmalst": "AR",
    "dropmalzpp": 728429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794762245,
    "dropsitcph": 4794762245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20543",
    "droptype": "D",
    "dropname": "HAYNES",
    "dropdeladd": "8402 HIGHWAY 1 N",
    "dropdelcty": "HAYNES",
    "dropdelst": "AR",
    "dropdelzpp": 723418800,
    "dropphyadd": "8402 HIGHWAY 1 N",
    "dropphycty": "HAYNES",
    "dropphyst": "AR",
    "dropphyzpp": 723418800,
    "dropmaladd": "8402 HIGHWAY 1 N",
    "dropmalcty": "HAYNES",
    "dropmalst": "AR",
    "dropmalzpp": 723418800,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706336560,
    "dropsitcph": 8706336560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20545",
    "droptype": "D",
    "dropname": "HAZEN",
    "dropdeladd": "109 N CHESTER ST",
    "dropdelcty": "HAZEN",
    "dropdelst": "AR",
    "dropdelzpp": 720649998,
    "dropphyadd": "109 N CHESTER ST",
    "dropphycty": "HAZEN",
    "dropphyst": "AR",
    "dropphyzpp": 720649998,
    "dropmaladd": "109 N CHESTER ST",
    "dropmalcty": "HAZEN",
    "dropmalst": "AR",
    "dropmalzpp": 720649998,
    "dropsitphn": 8703193998,
    "dropsitlph": 8703193998,
    "dropsitcph": 8703193998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20548",
    "droptype": "D",
    "dropname": "HEBER SPRINGS",
    "dropdeladd": "1215 HIGHWAY 25B N",
    "dropdelcty": "HEBER SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 725439998,
    "dropphyadd": "1215 HIGHWAY 25B N",
    "dropphycty": "HEBER SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 725439998,
    "dropmaladd": "1215 HIGHWAY 25B N",
    "dropmalcty": "HEBER SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 725439998,
    "dropsitphn": 5013622493,
    "dropsitlph": 5013622493,
    "dropsitcph": 5013622493,
    "dropfax": 5013620190
  },
  {
    "dcode": "D",
    "dropkey": "PY20550",
    "droptype": "D",
    "dropname": "HECTOR",
    "dropdeladd": "59 ELM ST",
    "dropdelcty": "HECTOR",
    "dropdelst": "AR",
    "dropdelzpp": 728439998,
    "dropphyadd": "59 ELM ST",
    "dropphycty": "HECTOR",
    "dropphyst": "AR",
    "dropphyzpp": 728439998,
    "dropmaladd": "59 ELM ST",
    "dropmalcty": "HECTOR",
    "dropmalst": "AR",
    "dropmalzpp": 728439998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792844541,
    "dropsitcph": 4792844541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20551",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "617 WALNUT STE 103",
    "dropdelcty": "HELENA",
    "dropdelst": "AR",
    "dropdelzpp": 723429998,
    "dropphyadd": "617 WALNUT STE 103",
    "dropphycty": "HELENA",
    "dropphyst": "AR",
    "dropphyzpp": 723429998,
    "dropmaladd": "617 WALNUT STE 103",
    "dropmalcty": "HELENA",
    "dropmalst": "AR",
    "dropmalzpp": 723429998,
    "dropsitphn": 8703387821,
    "dropsitlph": 8703387821,
    "dropsitcph": 8703387821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20552",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "13091 HIGHWAY 62 E",
    "dropdelcty": "HENDERSON",
    "dropdelst": "AR",
    "dropdelzpp": 725449998,
    "dropphyadd": "13091 HIGHWAY 62 E",
    "dropphycty": "HENDERSON",
    "dropphyst": "AR",
    "dropphyzpp": 725449998,
    "dropmaladd": "13091 HIGHWAY 62 E",
    "dropmalcty": "HENDERSON",
    "dropmalst": "AR",
    "dropmalzpp": 725449998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704885175,
    "dropsitcph": 8704885175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20557",
    "droptype": "D",
    "dropname": "HENSLEY",
    "dropdeladd": "27001 HIGHWAY 365",
    "dropdelcty": "HENSLEY",
    "dropdelst": "AR",
    "dropdelzpp": 720659998,
    "dropphyadd": "27001 HIGHWAY 365",
    "dropphycty": "HENSLEY",
    "dropphyst": "AR",
    "dropphyzpp": 720659998,
    "dropmaladd": "27001 HIGHWAY 365",
    "dropmalcty": "HENSLEY",
    "dropmalst": "AR",
    "dropmalzpp": 720659998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013972922,
    "dropsitcph": 5013972922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20559",
    "droptype": "D",
    "dropname": "HERMITAGE",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "HERMITAGE",
    "dropdelst": "AR",
    "dropdelzpp": 716479998,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "HERMITAGE",
    "dropphyst": "AR",
    "dropphyzpp": 716479998,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "HERMITAGE",
    "dropmalst": "AR",
    "dropmalzpp": 716479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704696025,
    "dropsitcph": 8704696025,
    "dropfax": 8704696016
  },
  {
    "dcode": "D",
    "dropkey": "PY20560",
    "droptype": "D",
    "dropname": "HETH",
    "dropdeladd": "19763 HIGHWAY 70 E",
    "dropdelcty": "HETH",
    "dropdelst": "AR",
    "dropdelzpp": 723469998,
    "dropphyadd": "19763 HIGHWAY 70 E",
    "dropphycty": "HETH",
    "dropphyst": "AR",
    "dropphyzpp": 723469998,
    "dropmaladd": "19763 HIGHWAY 70 E",
    "dropmalcty": "HETH",
    "dropmalst": "AR",
    "dropmalzpp": 723469998,
    "dropsitphn": 8706353187,
    "dropsitlph": 8706572408,
    "dropsitcph": 8706572408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20563",
    "droptype": "D",
    "dropname": "HICKORY PLAINS",
    "dropdeladd": "9992 HIGHWAY 38 W",
    "dropdelcty": "HICKORY PLAINS",
    "dropdelst": "AR",
    "dropdelzpp": 720668800,
    "dropphyadd": "9992 HIGHWAY 38 W",
    "dropphycty": "HICKORY PLAINS",
    "dropphyst": "AR",
    "dropphyzpp": 720668800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKORY PLAINS",
    "dropmalst": "AR",
    "dropmalzpp": 720669998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708544565,
    "dropsitcph": 8708544565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20564",
    "droptype": "D",
    "dropname": "HICKORY RIDGE",
    "dropdeladd": "132 S FLORA ST",
    "dropdelcty": "HICKORY RIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 723479998,
    "dropphyadd": "132 S FLORA ST",
    "dropphycty": "HICKORY RIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 723479998,
    "dropmaladd": "132 S FLORA ST",
    "dropmalcty": "HICKORY RIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 723479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706972214,
    "dropsitcph": 8706972214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20566",
    "droptype": "D",
    "dropname": "HIGDEN",
    "dropdeladd": "7545 EDGEMONT RD",
    "dropdelcty": "HIGDEN",
    "dropdelst": "AR",
    "dropdelzpp": 720679998,
    "dropphyadd": "7545 EDGEMONT RD",
    "dropphycty": "HIGDEN",
    "dropphyst": "AR",
    "dropphyzpp": 720679998,
    "dropmaladd": "7545 EDGEMONT RD",
    "dropmalcty": "HIGDEN",
    "dropmalst": "AR",
    "dropmalzpp": 720679998,
    "dropsitphn": 5018256208,
    "dropsitlph": 5018256208,
    "dropsitcph": 5018256208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20567",
    "droptype": "D",
    "dropname": "HIGGINSON",
    "dropdeladd": "24 WALKER RD",
    "dropdelcty": "HIGGINSON",
    "dropdelst": "AR",
    "dropdelzpp": 720689000,
    "dropphyadd": "24 WALKER RD",
    "dropphycty": "HIGGINSON",
    "dropphyst": "AR",
    "dropphyzpp": 720689000,
    "dropmaladd": "24 WALKER RD",
    "dropmalcty": "HIGGINSON",
    "dropmalst": "AR",
    "dropmalzpp": 720689000,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017425251,
    "dropsitcph": 5017425251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20572",
    "droptype": "D",
    "dropname": "HINDSVILLE",
    "dropdeladd": "143 E VALLEY RD",
    "dropdelcty": "HINDSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727389998,
    "dropphyadd": "143 E VALLEY RD",
    "dropphycty": "HINDSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727389998,
    "dropmaladd": "143 E VALLEY RD",
    "dropmalcty": "HINDSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727389998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4797895706,
    "dropsitcph": 4797895706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20574",
    "droptype": "D",
    "dropname": "HIWASSE",
    "dropdeladd": "13902 W HIGHWAY 72",
    "dropdelcty": "HIWASSE",
    "dropdelst": "AR",
    "dropdelzpp": 727399998,
    "dropphyadd": "13902 W HIGHWAY 72",
    "dropphycty": "HIWASSE",
    "dropphyst": "AR",
    "dropphyzpp": 727399998,
    "dropmaladd": "13902 W HIGHWAY 72",
    "dropmalcty": "HIWASSE",
    "dropmalst": "AR",
    "dropmalzpp": 727399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4797876825,
    "dropsitcph": 4797876825,
    "dropfax": 4797876825
  },
  {
    "dcode": "D",
    "dropkey": "PY20577",
    "droptype": "D",
    "dropname": "HOLLY GROVE",
    "dropdeladd": "169 E RALPH ABRAMSON ST",
    "dropdelcty": "HOLLY GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 720699998,
    "dropphyadd": "169 E RALPH ABRAMSON ST",
    "dropphycty": "HOLLY GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 720699998,
    "dropmaladd": "169 E RALPH ABRAMSON ST",
    "dropmalcty": "HOLLY GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 720699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704623723,
    "dropsitcph": 8704623723,
    "dropfax": 8704623723
  },
  {
    "dcode": "D",
    "dropkey": "PY20581",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "121 S LAUREL ST",
    "dropdelcty": "HOPE",
    "dropdelst": "AR",
    "dropdelzpp": 718019998,
    "dropphyadd": "121 S LAUREL ST",
    "dropphycty": "HOPE",
    "dropphyst": "AR",
    "dropphyzpp": 718019998,
    "dropmaladd": "121 S LAUREL ST",
    "dropmalcty": "HOPE",
    "dropmalst": "AR",
    "dropmalzpp": 718019998,
    "dropsitphn": 8707773580,
    "dropsitlph": 8707773580,
    "dropsitcph": 8707773580,
    "dropfax": 5017774914
  },
  {
    "dcode": "D",
    "dropkey": "PY20584",
    "droptype": "D",
    "dropname": "HORATIO",
    "dropdeladd": "110 W MAIN ST",
    "dropdelcty": "HORATIO",
    "dropdelst": "AR",
    "dropdelzpp": 718429998,
    "dropphyadd": "110 W MAIN ST",
    "dropphycty": "HORATIO",
    "dropphyst": "AR",
    "dropphyzpp": 718429998,
    "dropmaladd": "110 W MAIN ST",
    "dropmalcty": "HORATIO",
    "dropmalst": "AR",
    "dropmalzpp": 718429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708324171,
    "dropsitcph": 8708324171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20592",
    "droptype": "D",
    "dropname": "HOT SPRINGS NATIONAL PARK",
    "dropdeladd": "335 SECTION LINE RD",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139998,
    "dropphyadd": "335 SECTION LINE RD",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139998,
    "dropmaladd": "335 SECTION LINE RD",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139998,
    "dropsitphn": 5015252473,
    "dropsitlph": 5015250558,
    "dropsitcph": 5015250558,
    "dropfax": 5015253164
  },
  {
    "dcode": "D",
    "dropkey": "PY20594",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "2087 HIGHWAY 60 E STE A",
    "dropdelcty": "HOUSTON",
    "dropdelst": "AR",
    "dropdelzpp": 720709998,
    "dropphyadd": "2087 HIGHWAY 60 E STE A",
    "dropphycty": "HOUSTON",
    "dropphyst": "AR",
    "dropphyzpp": 720709998,
    "dropmaladd": "2087 HIGHWAY 60 E STE A",
    "dropmalcty": "HOUSTON",
    "dropmalst": "AR",
    "dropmalzpp": 720709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012714026,
    "dropsitcph": 5012714026,
    "dropfax": 5012713007
  },
  {
    "dcode": "D",
    "dropkey": "PY20599",
    "droptype": "D",
    "dropname": "HUGHES",
    "dropdeladd": "201 N STONEWALL ST",
    "dropdelcty": "HUGHES",
    "dropdelst": "AR",
    "dropdelzpp": 723489998,
    "dropphyadd": "201 N STONEWALL ST",
    "dropphycty": "HUGHES",
    "dropphyst": "AR",
    "dropphyzpp": 723489998,
    "dropmaladd": "201 N STONEWALL ST",
    "dropmalcty": "HUGHES",
    "dropmalst": "AR",
    "dropmalzpp": 723489998,
    "dropsitphn": 8703392607,
    "dropsitlph": 8703392607,
    "dropsitcph": 8703392607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20600",
    "droptype": "D",
    "dropname": "HUMNOKE",
    "dropdeladd": "12221 US HIGHWAY 165 E",
    "dropdelcty": "HUMNOKE",
    "dropdelst": "AR",
    "dropdelzpp": 720729998,
    "dropphyadd": "12221 US HIGHWAY 165 E",
    "dropphycty": "HUMNOKE",
    "dropphyst": "AR",
    "dropphyzpp": 720729998,
    "dropmaladd": "12221 US HIGHWAY 165 E",
    "dropmalcty": "HUMNOKE",
    "dropmalst": "AR",
    "dropmalzpp": 720729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012753521,
    "dropsitcph": 5012753521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20601",
    "droptype": "D",
    "dropname": "HUMPHREY",
    "dropdeladd": "100 N MULBERRY ST",
    "dropdelcty": "HUMPHREY",
    "dropdelst": "AR",
    "dropdelzpp": 720739998,
    "dropphyadd": "100 N MULBERRY ST",
    "dropphycty": "HUMPHREY",
    "dropphyst": "AR",
    "dropphyzpp": 720739998,
    "dropmaladd": "100 N MULBERRY ST",
    "dropmalcty": "HUMPHREY",
    "dropmalst": "AR",
    "dropmalzpp": 720739998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708734711,
    "dropsitcph": 8708734711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20603",
    "droptype": "D",
    "dropname": "HUNTER",
    "dropdeladd": "245 SW MAIN ST",
    "dropdelcty": "HUNTER",
    "dropdelst": "AR",
    "dropdelzpp": 720749998,
    "dropphyadd": "245 SW MAIN ST",
    "dropphycty": "HUNTER",
    "dropphyst": "AR",
    "dropphyzpp": 720749998,
    "dropmaladd": "245 SW MAIN ST",
    "dropmalcty": "HUNTER",
    "dropmalst": "AR",
    "dropmalzpp": 720749998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704592298,
    "dropsitcph": 8704592298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20604",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "101 HIGHWAY 71 SW",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "AR",
    "dropdelzpp": 729409998,
    "dropphyadd": "101 HIGHWAY 71 SW",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "AR",
    "dropphyzpp": 729409998,
    "dropmaladd": "101 HIGHWAY 71 SW",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "AR",
    "dropmalzpp": 729409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799285800,
    "dropsitcph": 4799285800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20605",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "401 CHURCH AVE",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727409998,
    "dropphyadd": "401 CHURCH AVE",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727409998,
    "dropmaladd": "401 CHURCH AVE",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727409998,
    "dropsitphn": 4797386525,
    "dropsitlph": 4797386525,
    "dropsitcph": 4797386525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20607",
    "droptype": "D",
    "dropname": "HUTTIG",
    "dropdeladd": "601 OLIN AVE",
    "dropdelcty": "HUTTIG",
    "dropdelst": "AR",
    "dropdelzpp": 717479998,
    "dropphyadd": "601 OLIN AVE",
    "dropphycty": "HUTTIG",
    "dropphyst": "AR",
    "dropphyzpp": 717479998,
    "dropmaladd": "601 OLIN AVE",
    "dropmalcty": "HUTTIG",
    "dropmalst": "AR",
    "dropmalzpp": 717479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709432421,
    "dropsitcph": 8709432421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20608",
    "droptype": "D",
    "dropname": "IDA",
    "dropdeladd": "4420 HEBER SPRINGS RD N",
    "dropdelcty": "IDA",
    "dropdelst": "AR",
    "dropdelzpp": 725469998,
    "dropphyadd": "4420 HEBER SPRINGS RD N",
    "dropphycty": "IDA",
    "dropphyst": "AR",
    "dropphyzpp": 725469998,
    "dropmaladd": "4420 HEBER SPRINGS RD N",
    "dropmalcty": "IDA",
    "dropmalst": "AR",
    "dropmalzpp": 725469998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013626460,
    "dropsitcph": 5013626460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20609",
    "droptype": "D",
    "dropname": "IMBODEN",
    "dropdeladd": "105 HIGHWAY 62",
    "dropdelcty": "IMBODEN",
    "dropdelst": "AR",
    "dropdelzpp": 724349998,
    "dropphyadd": "105 HIGHWAY 62",
    "dropphycty": "IMBODEN",
    "dropphyst": "AR",
    "dropphyzpp": 724349998,
    "dropmaladd": "105 HIGHWAY 62",
    "dropmalcty": "IMBODEN",
    "dropmalst": "AR",
    "dropmalzpp": 724349998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708692239,
    "dropsitcph": 8708692239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20617",
    "droptype": "D",
    "dropname": "IVAN",
    "dropdeladd": "16 DALLAS 126",
    "dropdelcty": "IVAN",
    "dropdelst": "AR",
    "dropdelzpp": 717488800,
    "dropphyadd": "16 DALLAS 126",
    "dropphycty": "IVAN",
    "dropphyst": "AR",
    "dropphyzpp": 717488800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IVAN",
    "dropmalst": "AR",
    "dropmalzpp": 717489998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703527675,
    "dropsitcph": 8703527675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20619",
    "droptype": "D",
    "dropname": "JACKSONPORT",
    "dropdeladd": "401 REDMAN ST",
    "dropdelcty": "JACKSONPORT",
    "dropdelst": "AR",
    "dropdelzpp": 720759998,
    "dropphyadd": "401 REDMAN ST",
    "dropphycty": "JACKSONPORT",
    "dropphyst": "AR",
    "dropphyzpp": 720759998,
    "dropmaladd": "401 REDMAN ST",
    "dropmalcty": "JACKSONPORT",
    "dropmalst": "AR",
    "dropmalzpp": 720759998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705239227,
    "dropsitcph": 8705239227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20620",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "1205 W MAIN ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 720769998,
    "dropphyadd": "1205 W MAIN ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 720769998,
    "dropmaladd": "1205 W MAIN ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 720769998,
    "dropsitphn": 5018645017,
    "dropsitlph": 5019824598,
    "dropsitcph": 5019824598,
    "dropfax": 5019823477
  },
  {
    "dcode": "D",
    "dropkey": "PY20621",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "412 W COURT ST",
    "dropdelcty": "JASPER",
    "dropdelst": "AR",
    "dropdelzpp": 726419998,
    "dropphyadd": "412 W COURT ST",
    "dropphycty": "JASPER",
    "dropphyst": "AR",
    "dropphyzpp": 726419998,
    "dropmaladd": "412 W COURT ST",
    "dropmalcty": "JASPER",
    "dropmalst": "AR",
    "dropmalzpp": 726419998,
    "dropsitphn": 8704462212,
    "dropsitlph": 8704462212,
    "dropsitcph": 8704462212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20623",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "4112 S HIGHWAY 365",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "AR",
    "dropdelzpp": 720799998,
    "dropphyadd": "4112 S HIGHWAY 365",
    "dropphycty": "JEFFERSON",
    "dropphyst": "AR",
    "dropphyzpp": 720799998,
    "dropmaladd": "4112 S HIGHWAY 365",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "AR",
    "dropmalzpp": 720799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013976256,
    "dropsitcph": 5013972418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20630",
    "droptype": "D",
    "dropname": "JERSEY",
    "dropdeladd": "198 BRADLEY ROAD 1 S",
    "dropdelcty": "JERSEY",
    "dropdelst": "AR",
    "dropdelzpp": 716519998,
    "dropphyadd": "198 BRADLEY ROAD 1 S",
    "dropphycty": "JERSEY",
    "dropphyst": "AR",
    "dropphyzpp": 716519998,
    "dropmaladd": "198 BRADLEY ROAD 1 S",
    "dropmalcty": "JERSEY",
    "dropmalst": "AR",
    "dropmalzpp": 716519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704632696,
    "dropsitcph": 8704632696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20631",
    "droptype": "D",
    "dropname": "JERUSALEM",
    "dropdeladd": "421 HIGHWAY 124",
    "dropdelcty": "JERUSALEM",
    "dropdelst": "AR",
    "dropdelzpp": 720809998,
    "dropphyadd": "421 HIGHWAY 124",
    "dropphycty": "JERUSALEM",
    "dropphyst": "AR",
    "dropphyzpp": 720809998,
    "dropmaladd": "421 HIGHWAY 124",
    "dropmalcty": "JERUSALEM",
    "dropmalst": "AR",
    "dropmalzpp": 720809998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016692610,
    "dropsitcph": 5016692610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20632",
    "droptype": "D",
    "dropname": "JESSIEVILLE",
    "dropdeladd": "7919 N HIGHWAY 7",
    "dropdelcty": "JESSIEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 719499998,
    "dropphyadd": "7919 N HIGHWAY 7",
    "dropphycty": "JESSIEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 719499998,
    "dropmaladd": "7919 N HIGHWAY 7",
    "dropmalcty": "JESSIEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 719499998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019845355,
    "dropsitcph": 5019845355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20637",
    "droptype": "D",
    "dropname": "JOINER",
    "dropdeladd": "117 HIGHWAY 118 W",
    "dropdelcty": "JOINER",
    "dropdelst": "AR",
    "dropdelzpp": 723509998,
    "dropphyadd": "117 HIGHWAY 118 W",
    "dropphycty": "JOINER",
    "dropphyst": "AR",
    "dropphyzpp": 723509998,
    "dropmaladd": "117 HIGHWAY 118 W",
    "dropmalcty": "JOINER",
    "dropmalst": "AR",
    "dropmalzpp": 723509998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705374837,
    "dropsitcph": 8705374837,
    "dropfax": 8705374837
  },
  {
    "dcode": "D",
    "dropkey": "PY20641",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "2404 RACE ST",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019998,
    "dropphyadd": "2404 RACE ST",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019998,
    "dropmaladd": "2404 RACE ST",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019998,
    "dropsitphn": 8709328929,
    "dropsitlph": 8709720275,
    "dropsitcph": 8709324057,
    "dropfax": 8709316932
  },
  {
    "dcode": "D",
    "dropkey": "PY20645",
    "droptype": "D",
    "dropname": "JUDSONIA",
    "dropdeladd": "100 W WASHINGTON ST",
    "dropdelcty": "JUDSONIA",
    "dropdelst": "AR",
    "dropdelzpp": 720819998,
    "dropphyadd": "100 W WASHINGTON ST",
    "dropphycty": "JUDSONIA",
    "dropphyst": "AR",
    "dropphyzpp": 720819998,
    "dropmaladd": "100 W WASHINGTON ST",
    "dropmalcty": "JUDSONIA",
    "dropmalst": "AR",
    "dropmalzpp": 720819998,
    "dropsitphn": 5012308179,
    "dropsitlph": 5017293130,
    "dropsitcph": 5017293130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20646",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "100 E CENTER ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "AR",
    "dropdelzpp": 717499998,
    "dropphyadd": "100 E CENTER ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "AR",
    "dropphyzpp": 717499998,
    "dropmaladd": "100 E CENTER ST",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "AR",
    "dropmalzpp": 717499998,
    "dropsitphn": 8709244648,
    "dropsitlph": 8709244648,
    "dropsitcph": 8709244648,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20649",
    "droptype": "D",
    "dropname": "KEISER",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "KEISER",
    "dropdelst": "AR",
    "dropdelzpp": 723519998,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "KEISER",
    "dropphyst": "AR",
    "dropphyzpp": 723519998,
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "KEISER",
    "dropmalst": "AR",
    "dropmalzpp": 723519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705262259,
    "dropsitcph": 8705262259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20653",
    "droptype": "D",
    "dropname": "KENSETT",
    "dropdeladd": "112 E SEARCY ST",
    "dropdelcty": "KENSETT",
    "dropdelst": "AR",
    "dropdelzpp": 720829998,
    "dropphyadd": "112 E SEARCY ST",
    "dropphycty": "KENSETT",
    "dropphyst": "AR",
    "dropphyzpp": 720829998,
    "dropmaladd": "112 E SEARCY ST",
    "dropmalcty": "KENSETT",
    "dropmalst": "AR",
    "dropmalzpp": 720829998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017425441,
    "dropsitcph": 5017425441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20654",
    "droptype": "D",
    "dropname": "KEO",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "KEO",
    "dropdelst": "AR",
    "dropdelzpp": 720839998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "KEO",
    "dropphyst": "AR",
    "dropphyzpp": 720839998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "KEO",
    "dropmalst": "AR",
    "dropmalzpp": 720839998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018423871,
    "dropsitcph": 5018423871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20657",
    "droptype": "D",
    "dropname": "KINGSLAND",
    "dropdeladd": "80 FIRST ST",
    "dropdelcty": "KINGSLAND",
    "dropdelst": "AR",
    "dropdelzpp": 716529998,
    "dropphyadd": "80 FIRST ST",
    "dropphycty": "KINGSLAND",
    "dropphyst": "AR",
    "dropphyzpp": 716529998,
    "dropmaladd": "80 FIRST ST",
    "dropmalcty": "KINGSLAND",
    "dropmalst": "AR",
    "dropmalzpp": 716529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703485411,
    "dropsitcph": 8703485411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20658",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "5103 HIGHWAY 21",
    "dropdelcty": "KINGSTON",
    "dropdelst": "AR",
    "dropdelzpp": 727429998,
    "dropphyadd": "5103 HIGHWAY 21",
    "dropphycty": "KINGSTON",
    "dropphyst": "AR",
    "dropphyzpp": 727429998,
    "dropmaladd": "5103 HIGHWAY 21",
    "dropmalcty": "KINGSTON",
    "dropmalst": "AR",
    "dropmalzpp": 727429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796652260,
    "dropsitcph": 4796652260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20659",
    "droptype": "D",
    "dropname": "KIRBY",
    "dropdeladd": "2633 HIGHWAY 27 N",
    "dropdelcty": "KIRBY",
    "dropdelst": "AR",
    "dropdelzpp": 719509998,
    "dropphyadd": "2633 HIGHWAY 27 N",
    "dropphycty": "KIRBY",
    "dropphyst": "AR",
    "dropphyzpp": 719509998,
    "dropmaladd": "2633 HIGHWAY 27 N",
    "dropmalcty": "KIRBY",
    "dropmalst": "AR",
    "dropmalzpp": 719509998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703984363,
    "dropsitcph": 8703984363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20660",
    "droptype": "D",
    "dropname": "KNOBEL",
    "dropdeladd": "260 MAPLE ST",
    "dropdelcty": "KNOBEL",
    "dropdelst": "AR",
    "dropdelzpp": 724359998,
    "dropphyadd": "260 MAPLE ST",
    "dropphycty": "KNOBEL",
    "dropphyst": "AR",
    "dropphyzpp": 724359998,
    "dropmaladd": "260 MAPLE ST",
    "dropmalcty": "KNOBEL",
    "dropmalst": "AR",
    "dropmalzpp": 724359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702593241,
    "dropsitcph": 8702593241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20661",
    "droptype": "D",
    "dropname": "KNOXVILLE",
    "dropdeladd": "100 HIGHWAY 315",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728459998,
    "dropphyadd": "100 HIGHWAY 315",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728459998,
    "dropmaladd": "100 HIGHWAY 315",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798853772,
    "dropsitcph": 4798853772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20666",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "74 E CULLUM DR",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "AR",
    "dropdelzpp": 723529998,
    "dropphyadd": "74 E CULLUM DR",
    "dropphycty": "LA GRANGE",
    "dropphyst": "AR",
    "dropphyzpp": 723529998,
    "dropmaladd": "74 E CULLUM DR",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "AR",
    "dropmalzpp": 723529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702953425,
    "dropsitcph": 8702953425,
    "dropfax": 8702953425
  },
  {
    "dcode": "D",
    "dropkey": "PY20671",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "125 HICKORY RD",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "AR",
    "dropdelzpp": 724379998,
    "dropphyadd": "125 HICKORY RD",
    "dropphycty": "LAKE CITY",
    "dropphyst": "AR",
    "dropphyzpp": 724379998,
    "dropmaladd": "125 HICKORY RD",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "AR",
    "dropmalzpp": 724379998,
    "dropsitphn": 8702374541,
    "dropsitlph": 8702374541,
    "dropsitcph": 8702374541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20675",
    "droptype": "D",
    "dropname": "LAKE VILLAGE",
    "dropdeladd": "206 S COKLEY ST",
    "dropdelcty": "LAKE VILLAGE",
    "dropdelst": "AR",
    "dropdelzpp": 716539998,
    "dropphyadd": "206 S COKLEY ST",
    "dropphycty": "LAKE VILLAGE",
    "dropphyst": "AR",
    "dropphyzpp": 716539998,
    "dropmaladd": "206 S COKLEY ST",
    "dropmalcty": "LAKE VILLAGE",
    "dropmalst": "AR",
    "dropmalzpp": 716539998,
    "dropsitphn": 8702652838,
    "dropsitlph": 8702652838,
    "dropsitcph": 8702652838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20677",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "5774 HIGHWAY 178 W",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "AR",
    "dropdelzpp": 726429998,
    "dropphyadd": "5774 HIGHWAY 178 W",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "AR",
    "dropphyzpp": 726429998,
    "dropmaladd": "5774 HIGHWAY 178 W",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "AR",
    "dropmalzpp": 726429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704318243,
    "dropsitcph": 8704318243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20678",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "251 W MAIN ST",
    "dropdelcty": "LAMAR",
    "dropdelst": "AR",
    "dropdelzpp": 728469998,
    "dropphyadd": "251 W MAIN ST",
    "dropphycty": "LAMAR",
    "dropphyst": "AR",
    "dropphyzpp": 728469998,
    "dropmaladd": "251 W MAIN ST",
    "dropmalcty": "LAMAR",
    "dropmalst": "AR",
    "dropmalzpp": 728469998,
    "dropsitphn": 4793150095,
    "dropsitlph": 4793150095,
    "dropsitcph": 4793150095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20680",
    "droptype": "D",
    "dropname": "LAMBROOK",
    "dropdeladd": "31393 HIGHWAY 20",
    "dropdelcty": "LAMBROOK",
    "dropdelst": "AR",
    "dropdelzpp": 723539998,
    "dropphyadd": "31393 HIGHWAY 20",
    "dropphycty": "LAMBROOK",
    "dropphyst": "AR",
    "dropphyzpp": 723539998,
    "dropmaladd": "31393 HIGHWAY 20",
    "dropmalcty": "LAMBROOK",
    "dropmalst": "AR",
    "dropmalzpp": 723539998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276734,
    "dropsitcph": 8708276734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20684",
    "droptype": "D",
    "dropname": "LANGLEY",
    "dropdeladd": "2579 HIGHWAY 84 W",
    "dropdelcty": "LANGLEY",
    "dropdelst": "AR",
    "dropdelzpp": 719529998,
    "dropphyadd": "2579 HIGHWAY 84 W",
    "dropphycty": "LANGLEY",
    "dropphyst": "AR",
    "dropphyzpp": 719529998,
    "dropmaladd": "2579 HIGHWAY 84 W",
    "dropmalcty": "LANGLEY",
    "dropmalst": "AR",
    "dropmalzpp": 719529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703564228,
    "dropsitcph": 8703564228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20686",
    "droptype": "D",
    "dropname": "LAVACA",
    "dropdeladd": "504 W MAIN ST",
    "dropdelcty": "LAVACA",
    "dropdelst": "AR",
    "dropdelzpp": 729419998,
    "dropphyadd": "504 W MAIN ST",
    "dropphycty": "LAVACA",
    "dropphyst": "AR",
    "dropphyzpp": 729419998,
    "dropmaladd": "504 W MAIN ST",
    "dropmalcty": "LAVACA",
    "dropmalst": "AR",
    "dropmalzpp": 729419998,
    "dropsitphn": 4796742898,
    "dropsitlph": 4796742898,
    "dropsitcph": 4796742898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20688",
    "droptype": "D",
    "dropname": "LAWSON",
    "dropdeladd": "117 MOUNT ZION RD",
    "dropdelcty": "LAWSON",
    "dropdelst": "AR",
    "dropdelzpp": 717509998,
    "dropphyadd": "117 MOUNT ZION RD",
    "dropphycty": "LAWSON",
    "dropphyst": "AR",
    "dropphyzpp": 717509998,
    "dropmaladd": "117 MOUNT ZION RD",
    "dropmalcty": "LAWSON",
    "dropmalst": "AR",
    "dropmalzpp": 717509998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709623306,
    "dropsitcph": 8709623306,
    "dropfax": 8709623306
  },
  {
    "dcode": "D",
    "dropkey": "PY20689",
    "droptype": "D",
    "dropname": "LEACHVILLE",
    "dropdeladd": "300 W DOC RODMAN ST",
    "dropdelcty": "LEACHVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 724389089,
    "dropphyadd": "300 W DOC RODMAN ST",
    "dropphycty": "LEACHVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 724389089,
    "dropmaladd": "300 W DOC RODMAN ST",
    "dropmalcty": "LEACHVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 724389089,
    "dropsitphn": 8705396421,
    "dropsitlph": 8705396421,
    "dropsitcph": 8705396421,
    "dropfax": 8705392669
  },
  {
    "dcode": "D",
    "dropkey": "PY20690",
    "droptype": "D",
    "dropname": "LEAD HILL",
    "dropdeladd": "165 HIGHWAY 14",
    "dropdelcty": "LEAD HILL",
    "dropdelst": "AR",
    "dropdelzpp": 726449998,
    "dropphyadd": "165 HIGHWAY 14",
    "dropphycty": "LEAD HILL",
    "dropphyst": "AR",
    "dropphyzpp": 726449998,
    "dropmaladd": "165 HIGHWAY 14",
    "dropmalcty": "LEAD HILL",
    "dropmalst": "AR",
    "dropmalzpp": 726449998,
    "dropsitphn": 5014365219,
    "dropsitlph": 8704365219,
    "dropsitcph": 8704365219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20691",
    "droptype": "D",
    "dropname": "LEOLA",
    "dropdeladd": "609 MAIN ST",
    "dropdelcty": "LEOLA",
    "dropdelst": "AR",
    "dropdelzpp": 720849998,
    "dropphyadd": "609 MAIN ST",
    "dropphycty": "LEOLA",
    "dropphyst": "AR",
    "dropphyzpp": 720849998,
    "dropmaladd": "609 MAIN ST",
    "dropmalcty": "LEOLA",
    "dropmalst": "AR",
    "dropmalzpp": 720849998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707652670,
    "dropsitcph": 8707652670,
    "dropfax": 8707652670
  },
  {
    "dcode": "D",
    "dropkey": "PY20692",
    "droptype": "D",
    "dropname": "LEPANTO",
    "dropdeladd": "125 HOLMES ST",
    "dropdelcty": "LEPANTO",
    "dropdelst": "AR",
    "dropdelzpp": 723549998,
    "dropphyadd": "125 HOLMES ST",
    "dropphycty": "LEPANTO",
    "dropphyst": "AR",
    "dropphyzpp": 723549998,
    "dropmaladd": "125 HOLMES ST",
    "dropmalcty": "LEPANTO",
    "dropmalst": "AR",
    "dropmalzpp": 723549998,
    "dropsitphn": 8704752142,
    "dropsitlph": 8704752142,
    "dropsitcph": 8704752142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20693",
    "droptype": "D",
    "dropname": "LESLIE",
    "dropdeladd": "311 MAIN ST",
    "dropdelcty": "LESLIE",
    "dropdelst": "AR",
    "dropdelzpp": 726459998,
    "dropphyadd": "311 MAIN ST",
    "dropphycty": "LESLIE",
    "dropphyst": "AR",
    "dropphyzpp": 726459998,
    "dropmaladd": "311 MAIN ST",
    "dropmalcty": "LESLIE",
    "dropmalst": "AR",
    "dropmalzpp": 726459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704472406,
    "dropsitcph": 8704472406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20694",
    "droptype": "D",
    "dropname": "LETONA",
    "dropdeladd": "206 E MAIN ST",
    "dropdelcty": "LETONA",
    "dropdelst": "AR",
    "dropdelzpp": 720859998,
    "dropphyadd": "206 E MAIN ST",
    "dropphycty": "LETONA",
    "dropphyst": "AR",
    "dropphyzpp": 720859998,
    "dropmaladd": "206 E MAIN ST",
    "dropmalcty": "LETONA",
    "dropmalst": "AR",
    "dropmalzpp": 720859998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017283324,
    "dropsitcph": 5017283324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20696",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "310 E FIRST ST",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 718459998,
    "dropphyadd": "310 E FIRST ST",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 718459998,
    "dropmaladd": "310 E FIRST ST",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 718459998,
    "dropsitphn": 8709214320,
    "dropsitlph": 8709214320,
    "dropsitcph": 8709214320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20697",
    "droptype": "D",
    "dropname": "LEXA",
    "dropdeladd": "8984 HIGHWAY 242 W",
    "dropdelcty": "LEXA",
    "dropdelst": "AR",
    "dropdelzpp": 723559998,
    "dropphyadd": "8984 HIGHWAY 242 W",
    "dropphycty": "LEXA",
    "dropphyst": "AR",
    "dropphyzpp": 723559998,
    "dropmaladd": "8984 HIGHWAY 242 W",
    "dropmalcty": "LEXA",
    "dropmalst": "AR",
    "dropmalzpp": 723559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705722748,
    "dropsitcph": 8705722748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20703",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "304 W PRIDEMORE DR",
    "dropdelcty": "LINCOLN",
    "dropdelst": "AR",
    "dropdelzpp": 727449998,
    "dropphyadd": "304 W PRIDEMORE DR",
    "dropphycty": "LINCOLN",
    "dropphyst": "AR",
    "dropphyzpp": 727449998,
    "dropmaladd": "304 W PRIDEMORE DR",
    "dropmalcty": "LINCOLN",
    "dropmalst": "AR",
    "dropmalzpp": 727449998,
    "dropsitphn": 4798243250,
    "dropsitlph": 4798243250,
    "dropsitcph": 4798243250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20709",
    "droptype": "D",
    "dropname": "LITTLE ROCK",
    "dropdeladd": "600 E CAPITOL AVE",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722029998,
    "dropphyadd": "600 E CAPITOL AVE",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722029998,
    "dropmaladd": "600 E CAPITOL AVE",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722029998,
    "dropsitphn": 5013752644,
    "dropsitlph": 5013751414,
    "dropsitcph": 5013752644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20713",
    "droptype": "D",
    "dropname": "LOCKESBURG",
    "dropdeladd": "106 E WALNUT ST",
    "dropdelcty": "LOCKESBURG",
    "dropdelst": "AR",
    "dropdelzpp": 718469998,
    "dropphyadd": "106 E WALNUT ST",
    "dropphycty": "LOCKESBURG",
    "dropphyst": "AR",
    "dropphyzpp": 718469998,
    "dropmaladd": "106 E WALNUT ST",
    "dropmalcty": "LOCKESBURG",
    "dropmalst": "AR",
    "dropmalzpp": 718469998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702895411,
    "dropsitcph": 8702895411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20714",
    "droptype": "D",
    "dropname": "LOCUST GROVE",
    "dropdeladd": "4955 HEBER SPRINGS RD",
    "dropdelcty": "LOCUST GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 725509998,
    "dropphyadd": "4955 HEBER SPRINGS RD",
    "dropphycty": "LOCUST GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 725509998,
    "dropmaladd": "4955 HEBER SPRINGS RD",
    "dropmalcty": "LOCUST GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 725509998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702512914,
    "dropsitcph": 8702512914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20718",
    "droptype": "D",
    "dropname": "LONDON",
    "dropdeladd": "10518 US HIGHWAY 64 W",
    "dropdelcty": "LONDON",
    "dropdelst": "AR",
    "dropdelzpp": 728479998,
    "dropphyadd": "10518 US HIGHWAY 64 W",
    "dropphycty": "LONDON",
    "dropphyst": "AR",
    "dropphyzpp": 728479998,
    "dropmaladd": "10518 US HIGHWAY 64 W",
    "dropmalcty": "LONDON",
    "dropmalst": "AR",
    "dropmalzpp": 728479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792934237,
    "dropsitcph": 4792934237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20720",
    "droptype": "D",
    "dropname": "LONOKE",
    "dropdeladd": "705 E FRONT ST",
    "dropdelcty": "LONOKE",
    "dropdelst": "AR",
    "dropdelzpp": 720869998,
    "dropphyadd": "705 E FRONT ST",
    "dropphycty": "LONOKE",
    "dropphyst": "AR",
    "dropphyzpp": 720869998,
    "dropmaladd": "705 E FRONT ST",
    "dropmalcty": "LONOKE",
    "dropmalst": "AR",
    "dropmalzpp": 720869998,
    "dropsitphn": 5016765402,
    "dropsitlph": 5016765402,
    "dropsitcph": 5016765402,
    "dropfax": 5016763463
  },
  {
    "dcode": "D",
    "dropkey": "PY20721",
    "droptype": "D",
    "dropname": "LONSDALE",
    "dropdeladd": "205 PLEASANT RUN RD",
    "dropdelcty": "LONSDALE",
    "dropdelst": "AR",
    "dropdelzpp": 720879998,
    "dropphyadd": "205 PLEASANT RUN RD",
    "dropphycty": "LONSDALE",
    "dropphyst": "AR",
    "dropphyzpp": 720879998,
    "dropmaladd": "205 PLEASANT RUN RD",
    "dropmalcty": "LONSDALE",
    "dropmalst": "AR",
    "dropmalzpp": 720879998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019392249,
    "dropsitcph": 5019392249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20724",
    "droptype": "D",
    "dropname": "LOUANN",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "LOUANN",
    "dropdelst": "AR",
    "dropdelzpp": 717519998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "LOUANN",
    "dropphyst": "AR",
    "dropphyzpp": 717519998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "LOUANN",
    "dropmalst": "AR",
    "dropmalzpp": 717519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706893455,
    "dropsitcph": 8706893455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20726",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "202 S LINCOLN ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "AR",
    "dropdelzpp": 727459998,
    "dropphyadd": "202 S LINCOLN ST",
    "dropphycty": "LOWELL",
    "dropphyst": "AR",
    "dropphyzpp": 727459998,
    "dropmaladd": "202 S LINCOLN ST",
    "dropmalcty": "LOWELL",
    "dropmalst": "AR",
    "dropmalzpp": 727459998,
    "dropsitphn": 4797700099,
    "dropsitlph": 4797700099,
    "dropsitcph": 4797700099,
    "dropfax": 4797700608
  },
  {
    "dcode": "D",
    "dropkey": "PY20730",
    "droptype": "D",
    "dropname": "LUXORA",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "LUXORA",
    "dropdelst": "AR",
    "dropdelzpp": 723589998,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "LUXORA",
    "dropphyst": "AR",
    "dropphyzpp": 723589998,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "LUXORA",
    "dropmalst": "AR",
    "dropmalzpp": 723589998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706582634,
    "dropsitcph": 8706582634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20731",
    "droptype": "D",
    "dropname": "LYNN",
    "dropdeladd": "66 N HIGHWAY 25",
    "dropdelcty": "LYNN",
    "dropdelst": "AR",
    "dropdelzpp": 724409998,
    "dropphyadd": "66 N HIGHWAY 25",
    "dropphycty": "LYNN",
    "dropphyst": "AR",
    "dropphyzpp": 724409998,
    "dropmaladd": "66 N HIGHWAY 25",
    "dropmalcty": "LYNN",
    "dropmalst": "AR",
    "dropmalzpp": 724409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705283001,
    "dropsitcph": 8705283001,
    "dropfax": 8705283001
  },
  {
    "dcode": "D",
    "dropkey": "PY20732",
    "droptype": "D",
    "dropname": "MABELVALE",
    "dropdeladd": "10715 MABELVALE WEST RD",
    "dropdelcty": "MABELVALE",
    "dropdelst": "AR",
    "dropdelzpp": 721039998,
    "dropphyadd": "10715 MABELVALE WEST RD",
    "dropphycty": "MABELVALE",
    "dropphyst": "AR",
    "dropphyzpp": 721039998,
    "dropmaladd": "10715 MABELVALE WEST RD",
    "dropmalcty": "MABELVALE",
    "dropmalst": "AR",
    "dropmalzpp": 721039998,
    "dropsitphn": 5014552320,
    "dropsitlph": 5014552318,
    "dropsitcph": 5014552318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20737",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "101 S FIRST ST",
    "dropdelcty": "MADISON",
    "dropdelst": "AR",
    "dropdelzpp": 723599998,
    "dropphyadd": "101 S FIRST ST",
    "dropphycty": "MADISON",
    "dropphyst": "AR",
    "dropphyzpp": 723599998,
    "dropmaladd": "101 S FIRST ST",
    "dropmalcty": "MADISON",
    "dropmalst": "AR",
    "dropmalzpp": 723599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706335321,
    "dropsitcph": 8706335321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20738",
    "droptype": "D",
    "dropname": "MAGAZINE",
    "dropdeladd": "60 N STATE HIGHWAY 109",
    "dropdelcty": "MAGAZINE",
    "dropdelst": "AR",
    "dropdelzpp": 729439998,
    "dropphyadd": "60 N STATE HIGHWAY 109",
    "dropphycty": "MAGAZINE",
    "dropphyst": "AR",
    "dropphyzpp": 729439998,
    "dropmaladd": "60 N STATE HIGHWAY 109",
    "dropmalcty": "MAGAZINE",
    "dropmalst": "AR",
    "dropmalzpp": 729439998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799698184,
    "dropsitcph": 4799698184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20739",
    "droptype": "D",
    "dropname": "MAGNESS",
    "dropdeladd": "95 BRITTNAY ST",
    "dropdelcty": "MAGNESS",
    "dropdelst": "AR",
    "dropdelzpp": 725539998,
    "dropphyadd": "95 BRITTNAY ST",
    "dropphycty": "MAGNESS",
    "dropphyst": "AR",
    "dropphyzpp": 725539998,
    "dropmaladd": "95 BRITTNAY ST",
    "dropmalcty": "MAGNESS",
    "dropmalst": "AR",
    "dropmalzpp": 725539998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707993086,
    "dropsitcph": 8707993086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20741",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "120 N PINE",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "AR",
    "dropdelzpp": 717539998,
    "dropphyadd": "120 N PINE",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "AR",
    "dropphyzpp": 717539998,
    "dropmaladd": "120 N PINE",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "AR",
    "dropmalzpp": 717539998,
    "dropsitphn": 8702342900,
    "dropsitlph": 8702342900,
    "dropsitcph": 8702342900,
    "dropfax": 8702340546
  },
  {
    "dcode": "D",
    "dropkey": "PY20745",
    "droptype": "D",
    "dropname": "MALVERN",
    "dropdeladd": "715 MARTIN LUTHER KING BLVD OFC",
    "dropdelcty": "MALVERN",
    "dropdelst": "AR",
    "dropdelzpp": 721049998,
    "dropphyadd": "715 MARTIN LUTHER KING BLVD OFC",
    "dropphycty": "MALVERN",
    "dropphyst": "AR",
    "dropphyzpp": 721049998,
    "dropmaladd": "715 MARTIN LUTHER KING BLVD OFC",
    "dropmalcty": "MALVERN",
    "dropmalst": "AR",
    "dropmalzpp": 721049998,
    "dropsitphn": 5013777701,
    "dropsitlph": 5013377701,
    "dropsitcph": 5013377701,
    "dropfax": 5013377382
  },
  {
    "dcode": "D",
    "dropkey": "PY20746",
    "droptype": "D",
    "dropname": "MAMMOTH SPRING",
    "dropdeladd": "1075 MAIN ST",
    "dropdelcty": "MAMMOTH SPRING",
    "dropdelst": "AR",
    "dropdelzpp": 725549998,
    "dropphyadd": "1075 MAIN ST",
    "dropphycty": "MAMMOTH SPRING",
    "dropphyst": "AR",
    "dropphyzpp": 725549998,
    "dropmaladd": "1075 MAIN ST",
    "dropmalcty": "MAMMOTH SPRING",
    "dropmalst": "AR",
    "dropmalzpp": 725549998,
    "dropsitphn": 8706253522,
    "dropsitlph": 8706253522,
    "dropsitcph": 8706253522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20748",
    "droptype": "D",
    "dropname": "MANILA",
    "dropdeladd": "100 S DUNKIN ST",
    "dropdelcty": "MANILA",
    "dropdelst": "AR",
    "dropdelzpp": 724429998,
    "dropphyadd": "100 S DUNKIN ST",
    "dropphycty": "MANILA",
    "dropphyst": "AR",
    "dropphyzpp": 724429998,
    "dropmaladd": "100 S DUNKIN ST",
    "dropmalcty": "MANILA",
    "dropmalst": "AR",
    "dropmalzpp": 724429998,
    "dropsitphn": 8705613431,
    "dropsitlph": 8705613431,
    "dropsitcph": 8705613431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20750",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "310 E HOWARD ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "AR",
    "dropdelzpp": 729449998,
    "dropphyadd": "310 E HOWARD ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "AR",
    "dropphyzpp": 729449998,
    "dropmaladd": "310 E HOWARD ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "AR",
    "dropmalzpp": 729449998,
    "dropsitphn": 4799284481,
    "dropsitlph": 4799284481,
    "dropsitcph": 4799284481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20751",
    "droptype": "D",
    "dropname": "MARCELLA",
    "dropdeladd": "113 HIDDEN RD",
    "dropdelcty": "MARCELLA",
    "dropdelst": "AR",
    "dropdelzpp": 725559998,
    "dropphyadd": "113 HIDDEN RD",
    "dropphycty": "MARCELLA",
    "dropphyst": "AR",
    "dropphyzpp": 725559998,
    "dropmaladd": "113 HIDDEN RD",
    "dropmalcty": "MARCELLA",
    "dropmalst": "AR",
    "dropmalzpp": 725559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706523609,
    "dropsitcph": 8706523609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20753",
    "droptype": "D",
    "dropname": "MARIANNA",
    "dropdeladd": "1 W MISSISSIPPI ST",
    "dropdelcty": "MARIANNA",
    "dropdelst": "AR",
    "dropdelzpp": 723609998,
    "dropphyadd": "1 W MISSISSIPPI ST",
    "dropphycty": "MARIANNA",
    "dropphyst": "AR",
    "dropphyzpp": 723609998,
    "dropmaladd": "1 W MISSISSIPPI ST",
    "dropmalcty": "MARIANNA",
    "dropmalst": "AR",
    "dropmalzpp": 723609998,
    "dropsitphn": 8702955309,
    "dropsitlph": 8702955309,
    "dropsitcph": 8702955309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20754",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "140 BLOCK ST",
    "dropdelcty": "MARION",
    "dropdelst": "AR",
    "dropdelzpp": 723649998,
    "dropphyadd": "140 BLOCK ST",
    "dropphycty": "MARION",
    "dropphyst": "AR",
    "dropphyzpp": 723649998,
    "dropmaladd": "140 BLOCK ST",
    "dropmalcty": "MARION",
    "dropmalst": "AR",
    "dropmalzpp": 723649998,
    "dropsitphn": 8707395202,
    "dropsitlph": 8707395202,
    "dropsitcph": 8707392651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20755",
    "droptype": "D",
    "dropname": "MARKED TREE",
    "dropdeladd": "402 FRISCO ST",
    "dropdelcty": "MARKED TREE",
    "dropdelst": "AR",
    "dropdelzpp": 723659998,
    "dropphyadd": "402 FRISCO ST",
    "dropphycty": "MARKED TREE",
    "dropphyst": "AR",
    "dropphyzpp": 723659998,
    "dropmaladd": "402 FRISCO ST",
    "dropmalcty": "MARKED TREE",
    "dropmalst": "AR",
    "dropmalzpp": 723659998,
    "dropsitphn": 8703582226,
    "dropsitlph": 8703582226,
    "dropsitcph": 8703582226,
    "dropfax": 8703583989
  },
  {
    "dcode": "D",
    "dropkey": "PY20756",
    "droptype": "D",
    "dropname": "MARMADUKE",
    "dropdeladd": "11436 HIGHWAY 49 N",
    "dropdelcty": "MARMADUKE",
    "dropdelst": "AR",
    "dropdelzpp": 724439998,
    "dropphyadd": "11436 HIGHWAY 49 N",
    "dropphycty": "MARMADUKE",
    "dropphyst": "AR",
    "dropphyzpp": 724439998,
    "dropmaladd": "11436 HIGHWAY 49 N",
    "dropmalcty": "MARMADUKE",
    "dropmalst": "AR",
    "dropmalzpp": 724439998,
    "dropsitphn": 8705974321,
    "dropsitlph": 8705974321,
    "dropsitcph": 8705974321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20757",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "200 S GLADE ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "AR",
    "dropdelzpp": 726509998,
    "dropphyadd": "200 S GLADE ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "AR",
    "dropphyzpp": 726509998,
    "dropmaladd": "200 S GLADE ST",
    "dropmalcty": "MARSHALL",
    "dropmalst": "AR",
    "dropmalzpp": 726509998,
    "dropsitphn": 8704482396,
    "dropsitlph": 8704482396,
    "dropsitcph": 8704482396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20759",
    "droptype": "D",
    "dropname": "MARVELL",
    "dropdeladd": "403 ELM ST",
    "dropdelcty": "MARVELL",
    "dropdelst": "AR",
    "dropdelzpp": 723669998,
    "dropphyadd": "403 ELM ST",
    "dropphycty": "MARVELL",
    "dropphyst": "AR",
    "dropphyzpp": 723669998,
    "dropmaladd": "403 ELM ST",
    "dropmalcty": "MARVELL",
    "dropmalst": "AR",
    "dropmalzpp": 723669998,
    "dropsitphn": 8708292531,
    "dropsitlph": 8708292531,
    "dropsitcph": 8708292531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20764",
    "droptype": "D",
    "dropname": "MAYFLOWER",
    "dropdeladd": "8 ASHMORE DR",
    "dropdelcty": "MAYFLOWER",
    "dropdelst": "AR",
    "dropdelzpp": 721069998,
    "dropphyadd": "8 ASHMORE DR",
    "dropphycty": "MAYFLOWER",
    "dropphyst": "AR",
    "dropphyzpp": 721069998,
    "dropmaladd": "8 ASHMORE DR",
    "dropmalcty": "MAYFLOWER",
    "dropmalst": "AR",
    "dropmalzpp": 721069998,
    "dropsitphn": 5014701875,
    "dropsitlph": 5014701875,
    "dropsitcph": 5014700945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20765",
    "droptype": "D",
    "dropname": "MAYNARD",
    "dropdeladd": "132 OLD MILITARY RD",
    "dropdelcty": "MAYNARD",
    "dropdelst": "AR",
    "dropdelzpp": 724449998,
    "dropphyadd": "132 OLD MILITARY RD",
    "dropphycty": "MAYNARD",
    "dropphyst": "AR",
    "dropphyzpp": 724449998,
    "dropmaladd": "132 OLD MILITARY RD",
    "dropmalcty": "MAYNARD",
    "dropmalst": "AR",
    "dropmalzpp": 724449998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706472161,
    "dropsitcph": 8706472161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20767",
    "droptype": "D",
    "dropname": "MAYSVILLE",
    "dropdeladd": "11776 N HIGHWAY 43",
    "dropdelcty": "MAYSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727479998,
    "dropphyadd": "11776 N HIGHWAY 43",
    "dropphycty": "MAYSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727479998,
    "dropmaladd": "11776 N HIGHWAY 43",
    "dropmalcty": "MAYSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727479998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792914286,
    "dropsitcph": 4792914286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20769",
    "droptype": "D",
    "dropname": "MC CASKILL",
    "dropdeladd": "113 HEMPSTEAD 337",
    "dropdelcty": "MC CASKILL",
    "dropdelst": "AR",
    "dropdelzpp": 718479998,
    "dropphyadd": "113 HEMPSTEAD 337",
    "dropphycty": "MC CASKILL",
    "dropphyst": "AR",
    "dropphyzpp": 718479998,
    "dropmaladd": "113 HEMPSTEAD 337",
    "dropmalcty": "MC CASKILL",
    "dropmalst": "AR",
    "dropmalzpp": 718479998,
    "dropsitphn": 8708742641,
    "dropsitlph": 8708742641,
    "dropsitcph": 8708742641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20770",
    "droptype": "D",
    "dropname": "MC CRORY",
    "dropdeladd": "203 N EDMONDS AVE",
    "dropdelcty": "MC CRORY",
    "dropdelst": "AR",
    "dropdelzpp": 721019998,
    "dropphyadd": "203 N EDMONDS AVE",
    "dropphycty": "MC CRORY",
    "dropphyst": "AR",
    "dropphyzpp": 721019998,
    "dropmaladd": "203 N EDMONDS AVE",
    "dropmalcty": "MC CRORY",
    "dropmalst": "AR",
    "dropmalzpp": 721019998,
    "dropsitphn": 8707312771,
    "dropsitlph": 8707312771,
    "dropsitcph": 8707312771,
    "dropfax": 6513066463
  },
  {
    "dcode": "D",
    "dropkey": "PY20771",
    "droptype": "D",
    "dropname": "MC DOUGAL",
    "dropdeladd": "251 HIGHWAY 62",
    "dropdelcty": "MC DOUGAL",
    "dropdelst": "AR",
    "dropdelzpp": 724419998,
    "dropphyadd": "251 HIGHWAY 62",
    "dropphycty": "MC DOUGAL",
    "dropphyst": "AR",
    "dropphyzpp": 724419998,
    "dropmaladd": "251 HIGHWAY 62",
    "dropmalcty": "MC DOUGAL",
    "dropmalst": "AR",
    "dropmalzpp": 724419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702592151,
    "dropsitcph": 8702592151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20772",
    "droptype": "D",
    "dropname": "MC GEHEE",
    "dropdeladd": "104 S 1ST ST",
    "dropdelcty": "MC GEHEE",
    "dropdelst": "AR",
    "dropdelzpp": 716549998,
    "dropphyadd": "104 S 1ST ST",
    "dropphycty": "MC GEHEE",
    "dropphyst": "AR",
    "dropphyzpp": 716549998,
    "dropmaladd": "104 S 1ST ST",
    "dropmalcty": "MC GEHEE",
    "dropmalst": "AR",
    "dropmalzpp": 716549998,
    "dropsitphn": 8702224294,
    "dropsitlph": 8702224294,
    "dropsitcph": 8702224294,
    "dropfax": 8702229104
  },
  {
    "dcode": "D",
    "dropkey": "PY20773",
    "droptype": "D",
    "dropname": "MC NEIL",
    "dropdeladd": "106 OLIVE ST",
    "dropdelcty": "MC NEIL",
    "dropdelst": "AR",
    "dropdelzpp": 717529998,
    "dropphyadd": "106 OLIVE ST",
    "dropphycty": "MC NEIL",
    "dropphyst": "AR",
    "dropphyzpp": 717529998,
    "dropmaladd": "106 OLIVE ST",
    "dropmalcty": "MC NEIL",
    "dropmalst": "AR",
    "dropmalzpp": 717529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709653421,
    "dropsitcph": 8706953421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20774",
    "droptype": "D",
    "dropname": "MC RAE",
    "dropdeladd": "105 1ST ST",
    "dropdelcty": "MC RAE",
    "dropdelst": "AR",
    "dropdelzpp": 721029998,
    "dropphyadd": "105 1ST ST",
    "dropphycty": "MC RAE",
    "dropphyst": "AR",
    "dropphyzpp": 721029998,
    "dropmaladd": "105 1ST ST",
    "dropmalcty": "MC RAE",
    "dropmalst": "AR",
    "dropmalzpp": 721029998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017263580,
    "dropsitcph": 5017263580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20785",
    "droptype": "D",
    "dropname": "MELBOURNE",
    "dropdeladd": "206 LUNEN ST",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "AR",
    "dropdelzpp": 725569998,
    "dropphyadd": "206 LUNEN ST",
    "dropphycty": "MELBOURNE",
    "dropphyst": "AR",
    "dropphyzpp": 725569998,
    "dropmaladd": "206 LUNEN ST",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "AR",
    "dropmalzpp": 725569998,
    "dropsitphn": 8702662550,
    "dropsitlph": 8702662550,
    "dropsitcph": 8702662550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20786",
    "droptype": "D",
    "dropname": "MELLWOOD",
    "dropdeladd": "32403 HIGHWAY 44",
    "dropdelcty": "MELLWOOD",
    "dropdelst": "AR",
    "dropdelzpp": 723679998,
    "dropphyadd": "32403 HIGHWAY 44",
    "dropphycty": "MELLWOOD",
    "dropphyst": "AR",
    "dropphyzpp": 723679998,
    "dropmaladd": "32403 HIGHWAY 44",
    "dropmalcty": "MELLWOOD",
    "dropmalst": "AR",
    "dropmalzpp": 723679998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276642,
    "dropsitcph": 8708276642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20787",
    "droptype": "D",
    "dropname": "MENA",
    "dropdeladd": "400 MORROW ST S",
    "dropdelcty": "MENA",
    "dropdelst": "AR",
    "dropdelzpp": 719539998,
    "dropphyadd": "400 MORROW ST S",
    "dropphycty": "MENA",
    "dropphyst": "AR",
    "dropphyzpp": 719539998,
    "dropmaladd": "400 MORROW ST S",
    "dropmalcty": "MENA",
    "dropmalst": "AR",
    "dropmalzpp": 719539998,
    "dropsitphn": 4793943119,
    "dropsitlph": 4793942884,
    "dropsitcph": 4793942884,
    "dropfax": 4793947587
  },
  {
    "dcode": "D",
    "dropkey": "PY20788",
    "droptype": "D",
    "dropname": "MENIFEE",
    "dropdeladd": "3919 HIGHWAY 64",
    "dropdelcty": "MENIFEE",
    "dropdelst": "AR",
    "dropdelzpp": 721079998,
    "dropphyadd": "3919 HIGHWAY 64",
    "dropphycty": "MENIFEE",
    "dropphyst": "AR",
    "dropphyzpp": 721079998,
    "dropmaladd": "3919 HIGHWAY 64",
    "dropmalcty": "MENIFEE",
    "dropmalst": "AR",
    "dropmalzpp": 721079998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013543551,
    "dropsitcph": 5013543551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20796",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "403 N 3RD ST",
    "dropdelcty": "MIDLAND",
    "dropdelst": "AR",
    "dropdelzpp": 729459998,
    "dropphyadd": "403 N 3RD ST",
    "dropphycty": "MIDLAND",
    "dropphyst": "AR",
    "dropphyzpp": 729459998,
    "dropmaladd": "403 N 3RD ST",
    "dropmalcty": "MIDLAND",
    "dropmalst": "AR",
    "dropmalzpp": 729459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796392221,
    "dropsitcph": 4796392221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20798",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "323 HIGHWAY 178 W",
    "dropdelcty": "MIDWAY",
    "dropdelst": "AR",
    "dropdelzpp": 726519998,
    "dropphyadd": "323 HIGHWAY 178 W",
    "dropphycty": "MIDWAY",
    "dropphyst": "AR",
    "dropphyzpp": 726519998,
    "dropmaladd": "323 HIGHWAY 178 W",
    "dropmalcty": "MIDWAY",
    "dropmalst": "AR",
    "dropmalzpp": 726519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8704815350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20800",
    "droptype": "D",
    "dropname": "MINERAL SPRINGS",
    "dropdeladd": "501 E RUNNELS ST",
    "dropdelcty": "MINERAL SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 718519998,
    "dropphyadd": "501 E RUNNELS ST",
    "dropphycty": "MINERAL SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 718519998,
    "dropmaladd": "501 E RUNNELS ST",
    "dropmalcty": "MINERAL SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 718519998,
    "dropsitphn": 8702874300,
    "dropsitlph": 8702874300,
    "dropsitcph": 8702874300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20801",
    "droptype": "D",
    "dropname": "MINTURN",
    "dropdeladd": "111 W LAUREL ST",
    "dropdelcty": "MINTURN",
    "dropdelst": "AR",
    "dropdelzpp": 724459998,
    "dropphyadd": "111 W LAUREL ST",
    "dropphycty": "MINTURN",
    "dropphyst": "AR",
    "dropphyzpp": 724459998,
    "dropmaladd": "111 W LAUREL ST",
    "dropmalcty": "MINTURN",
    "dropmalst": "AR",
    "dropmalzpp": 724459998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708866925,
    "dropsitcph": 8708866925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20805",
    "droptype": "D",
    "dropname": "MONETTE",
    "dropdeladd": "105 N NANCE ST",
    "dropdelcty": "MONETTE",
    "dropdelst": "AR",
    "dropdelzpp": 724479998,
    "dropphyadd": "105 N NANCE ST",
    "dropphycty": "MONETTE",
    "dropphyst": "AR",
    "dropphyzpp": 724479998,
    "dropmaladd": "105 N NANCE ST",
    "dropmalcty": "MONETTE",
    "dropmalst": "AR",
    "dropmalzpp": 724479998,
    "dropsitphn": 8704862298,
    "dropsitlph": 8704862298,
    "dropsitcph": 8704862298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20807",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "18439 HIGHWAY 39 S",
    "dropdelcty": "MONROE",
    "dropdelst": "AR",
    "dropdelzpp": 721088800,
    "dropphyadd": "18439 HIGHWAY 39 S",
    "dropphycty": "MONROE",
    "dropphyst": "AR",
    "dropphyzpp": 721088800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONROE",
    "dropmalst": "AR",
    "dropmalzpp": 721089998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707341135,
    "dropsitcph": 8707341135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20808",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "1492 N HYATT ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "AR",
    "dropdelzpp": 716559998,
    "dropphyadd": "1492 N HYATT ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "AR",
    "dropphyzpp": 716559998,
    "dropmaladd": "1492 N HYATT ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "AR",
    "dropmalzpp": 716559998,
    "dropsitphn": 8703673122,
    "dropsitlph": 8703673122,
    "dropsitcph": 8703673122,
    "dropfax": 8703672880
  },
  {
    "dcode": "D",
    "dropkey": "PY20810",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "1400 HIGHWAY 165 N",
    "dropdelcty": "MONTROSE",
    "dropdelst": "AR",
    "dropdelzpp": 716589998,
    "dropphyadd": "1400 HIGHWAY 165 N",
    "dropphycty": "MONTROSE",
    "dropphyst": "AR",
    "dropphyzpp": 716589998,
    "dropmaladd": "1400 HIGHWAY 165 N",
    "dropmalcty": "MONTROSE",
    "dropmalst": "AR",
    "dropmalzpp": 716589998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707372623,
    "dropsitcph": 8707372623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20814",
    "droptype": "D",
    "dropname": "MORO",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "MORO",
    "dropdelst": "AR",
    "dropdelzpp": 723689998,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "MORO",
    "dropphyst": "AR",
    "dropphyzpp": 723689998,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "MORO",
    "dropmalst": "AR",
    "dropmalzpp": 723689998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707684406,
    "dropsitcph": 8707684406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20816",
    "droptype": "D",
    "dropname": "MORRILTON",
    "dropdeladd": "500 N MOOSE ST",
    "dropdelcty": "MORRILTON",
    "dropdelst": "AR",
    "dropdelzpp": 721109998,
    "dropphyadd": "500 N MOOSE ST",
    "dropphycty": "MORRILTON",
    "dropphyst": "AR",
    "dropphyzpp": 721109998,
    "dropmaladd": "500 N MOOSE ST",
    "dropmalcty": "MORRILTON",
    "dropmalst": "AR",
    "dropmalzpp": 721109998,
    "dropsitphn": 5013544133,
    "dropsitlph": 5013544133,
    "dropsitcph": 5013544133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20817",
    "droptype": "D",
    "dropname": "MORROW",
    "dropdeladd": "17149 HALE MOUNTAIN RD",
    "dropdelcty": "MORROW",
    "dropdelst": "AR",
    "dropdelzpp": 727499998,
    "dropphyadd": "17149 HALE MOUNTAIN RD",
    "dropphycty": "MORROW",
    "dropphyst": "AR",
    "dropphyzpp": 727499998,
    "dropmaladd": "17149 HALE MOUNTAIN RD",
    "dropmalcty": "MORROW",
    "dropmalst": "AR",
    "dropmalzpp": 727499998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798483111,
    "dropsitcph": 4798483111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20819",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "9201 HIGHWAY 65 S",
    "dropdelcty": "MOSCOW",
    "dropdelst": "AR",
    "dropdelzpp": 716599998,
    "dropphyadd": "9201 HIGHWAY 65 S",
    "dropphycty": "MOSCOW",
    "dropphyst": "AR",
    "dropphyzpp": 716599998,
    "dropmaladd": "9201 HIGHWAY 65 S",
    "dropmalcty": "MOSCOW",
    "dropmalst": "AR",
    "dropmalzpp": 716599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705363355,
    "dropsitcph": 8705363355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20822",
    "droptype": "D",
    "dropname": "MOUNT HOLLY",
    "dropdeladd": "151 MCCALL RD",
    "dropdelcty": "MOUNT HOLLY",
    "dropdelst": "AR",
    "dropdelzpp": 717586003,
    "dropphyadd": "151 MCCALL RD",
    "dropphycty": "MOUNT HOLLY",
    "dropphyst": "AR",
    "dropphyzpp": 717586003,
    "dropmaladd": "151 MCCALL RD",
    "dropmalcty": "MOUNT HOLLY",
    "dropmalst": "AR",
    "dropmalzpp": 717586003,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705542443,
    "dropsitcph": 8705542443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20823",
    "droptype": "D",
    "dropname": "MOUNT IDA",
    "dropdeladd": "140 HIGHWAY 270 W",
    "dropdelcty": "MOUNT IDA",
    "dropdelst": "AR",
    "dropdelzpp": 719579998,
    "dropphyadd": "140 HIGHWAY 270 W",
    "dropphycty": "MOUNT IDA",
    "dropphyst": "AR",
    "dropphyzpp": 719579998,
    "dropmaladd": "140 HIGHWAY 270 W",
    "dropmalcty": "MOUNT IDA",
    "dropmalst": "AR",
    "dropmalzpp": 719579998,
    "dropsitphn": 8708673875,
    "dropsitlph": 8708673875,
    "dropsitcph": 8708673875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20824",
    "droptype": "D",
    "dropname": "MOUNT JUDEA",
    "dropdeladd": "1 S MAIN ST",
    "dropdelcty": "MOUNT JUDEA",
    "dropdelst": "AR",
    "dropdelzpp": 726559998,
    "dropphyadd": "1 S MAIN ST",
    "dropphycty": "MOUNT JUDEA",
    "dropphyst": "AR",
    "dropphyzpp": 726559998,
    "dropmaladd": "1 S MAIN ST",
    "dropmalcty": "MOUNT JUDEA",
    "dropmalst": "AR",
    "dropmalzpp": 726559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704345322,
    "dropsitcph": 8704345322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20828",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "204 PEARL ST",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "AR",
    "dropdelzpp": 725619998,
    "dropphyadd": "204 PEARL ST",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "AR",
    "dropphyzpp": 725619998,
    "dropmaladd": "204 PEARL ST",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "AR",
    "dropmalzpp": 725619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703465330,
    "dropsitcph": 8703465330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20831",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "1375 HIGHWAY 36",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "AR",
    "dropdelzpp": 721119998,
    "dropphyadd": "1375 HIGHWAY 36",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "AR",
    "dropphyzpp": 721119998,
    "dropmaladd": "1375 HIGHWAY 36",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "AR",
    "dropmalzpp": 721119998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018496044,
    "dropsitcph": 5018496044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20833",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME",
    "dropdeladd": "975 COLEY DR",
    "dropdelcty": "MOUNTAIN HOME",
    "dropdelst": "AR",
    "dropdelzpp": 726539998,
    "dropphyadd": "975 COLEY DR",
    "dropphycty": "MOUNTAIN HOME",
    "dropphyst": "AR",
    "dropphyzpp": 726539998,
    "dropmaladd": "975 COLEY DR",
    "dropmalcty": "MOUNTAIN HOME",
    "dropmalst": "AR",
    "dropmalzpp": 726539998,
    "dropsitphn": 8704250600,
    "dropsitlph": 8704253262,
    "dropsitcph": 8704253262,
    "dropfax": 8704254422
  },
  {
    "dcode": "D",
    "dropkey": "PY20835",
    "droptype": "D",
    "dropname": "MOUNTAIN PINE",
    "dropdeladd": "240 MAIN AVE",
    "dropdelcty": "MOUNTAIN PINE",
    "dropdelst": "AR",
    "dropdelzpp": 719569998,
    "dropphyadd": "240 MAIN AVE",
    "dropphycty": "MOUNTAIN PINE",
    "dropphyst": "AR",
    "dropphyzpp": 719569998,
    "dropmaladd": "240 MAIN AVE",
    "dropmalcty": "MOUNTAIN PINE",
    "dropmalst": "AR",
    "dropmalzpp": 719569998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017676874,
    "dropsitcph": 5017676874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20837",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "802 SYLAMORE AVE",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "AR",
    "dropdelzpp": 725609998,
    "dropphyadd": "802 SYLAMORE AVE",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "AR",
    "dropphyzpp": 725609998,
    "dropmaladd": "802 SYLAMORE AVE",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "AR",
    "dropmalzpp": 725609998,
    "dropsitphn": 8702693520,
    "dropsitlph": 8702693520,
    "dropsitcph": 8702693520,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20838",
    "droptype": "D",
    "dropname": "MOUNTAINBURG",
    "dropdeladd": "6 HICKORY ST",
    "dropdelcty": "MOUNTAINBURG",
    "dropdelst": "AR",
    "dropdelzpp": 729469998,
    "dropphyadd": "6 HICKORY ST",
    "dropphycty": "MOUNTAINBURG",
    "dropphyst": "AR",
    "dropphyzpp": 729469998,
    "dropmaladd": "6 HICKORY ST",
    "dropmalcty": "MOUNTAINBURG",
    "dropmalst": "AR",
    "dropmalzpp": 729469998,
    "dropsitphn": 4793127583,
    "dropsitlph": 4793835733,
    "dropsitcph": 4793835733,
    "dropfax": 4793835724
  },
  {
    "dcode": "D",
    "dropkey": "PY20850",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "221 N MAIN ST",
    "dropdelcty": "MULBERRY",
    "dropdelst": "AR",
    "dropdelzpp": 729479998,
    "dropphyadd": "221 N MAIN ST",
    "dropphycty": "MULBERRY",
    "dropphyst": "AR",
    "dropphyzpp": 729479998,
    "dropmaladd": "221 N MAIN ST",
    "dropmalcty": "MULBERRY",
    "dropmalst": "AR",
    "dropmalzpp": 729479998,
    "dropsitphn": 4799971505,
    "dropsitlph": 4799971505,
    "dropsitcph": 4799971505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20851",
    "droptype": "D",
    "dropname": "MURFREESBORO",
    "dropdeladd": "201 E MAIN",
    "dropdelcty": "MURFREESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 719589998,
    "dropphyadd": "201 E MAIN",
    "dropphycty": "MURFREESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 719589998,
    "dropmaladd": "201 E MAIN",
    "dropmalcty": "MURFREESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 719589998,
    "dropsitphn": 8702852621,
    "dropsitlph": 8702852621,
    "dropsitcph": 8702852621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20858",
    "droptype": "D",
    "dropname": "NASHVILLE",
    "dropdeladd": "220 N MAIN ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 718529998,
    "dropphyadd": "220 N MAIN ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 718529998,
    "dropmaladd": "220 N MAIN ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 718529998,
    "dropsitphn": 8708454040,
    "dropsitlph": 8708454040,
    "dropsitcph": 8708454040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20859",
    "droptype": "D",
    "dropname": "NATURAL DAM",
    "dropdeladd": "14510 N HIGHWAY 59",
    "dropdelcty": "NATURAL DAM",
    "dropdelst": "AR",
    "dropdelzpp": 729489998,
    "dropphyadd": "14510 N HIGHWAY 59",
    "dropphycty": "NATURAL DAM",
    "dropphyst": "AR",
    "dropphyzpp": 729489998,
    "dropmaladd": "14510 N HIGHWAY 59",
    "dropmalcty": "NATURAL DAM",
    "dropmalst": "AR",
    "dropmalzpp": 729489998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799295775,
    "dropsitcph": 4799295775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20864",
    "droptype": "D",
    "dropname": "NEW BLAINE",
    "dropdeladd": "19809 E STATE HIGHWAY 22",
    "dropdelcty": "NEW BLAINE",
    "dropdelst": "AR",
    "dropdelzpp": 728519998,
    "dropphyadd": "19809 E STATE HIGHWAY 22",
    "dropphycty": "NEW BLAINE",
    "dropphyst": "AR",
    "dropphyzpp": 728519998,
    "dropmaladd": "19809 E STATE HIGHWAY 22",
    "dropmalcty": "NEW BLAINE",
    "dropmalst": "AR",
    "dropmalzpp": 728519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799387193,
    "dropsitcph": 4799387193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20865",
    "droptype": "D",
    "dropname": "NEW EDINBURG",
    "dropdeladd": "6530 HIGHWAY 8",
    "dropdelcty": "NEW EDINBURG",
    "dropdelst": "AR",
    "dropdelzpp": 716609998,
    "dropphyadd": "6530 HIGHWAY 8",
    "dropphycty": "NEW EDINBURG",
    "dropphyst": "AR",
    "dropphyzpp": 716609998,
    "dropmaladd": "6530 HIGHWAY 8",
    "dropmalcty": "NEW EDINBURG",
    "dropmalst": "AR",
    "dropmalzpp": 716609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703528291,
    "dropsitcph": 8703528291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20868",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "105 N OAK ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "AR",
    "dropdelzpp": 725629998,
    "dropphyadd": "105 N OAK ST",
    "dropphycty": "NEWARK",
    "dropphyst": "AR",
    "dropphyzpp": 725629998,
    "dropmaladd": "105 N OAK ST",
    "dropmalcty": "NEWARK",
    "dropmalst": "AR",
    "dropmalzpp": 725629998,
    "dropsitphn": 8707993021,
    "dropsitlph": 8707993021,
    "dropsitcph": 8707993021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20869",
    "droptype": "D",
    "dropname": "NEWHOPE",
    "dropdeladd": "5638 HIGHWAY 70 W",
    "dropdelcty": "NEWHOPE",
    "dropdelst": "AR",
    "dropdelzpp": 719599998,
    "dropphyadd": "5638 HIGHWAY 70 W",
    "dropphycty": "NEWHOPE",
    "dropphyst": "AR",
    "dropphyzpp": 719599998,
    "dropmaladd": "5638 HIGHWAY 70 W",
    "dropmalcty": "NEWHOPE",
    "dropmalst": "AR",
    "dropmalzpp": 719599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703985423,
    "dropsitcph": 8703985423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20872",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "110 LAUREL ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "AR",
    "dropdelzpp": 721129998,
    "dropphyadd": "110 LAUREL ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "AR",
    "dropphyzpp": 721129998,
    "dropmaladd": "110 LAUREL ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "AR",
    "dropmalzpp": 721129998,
    "dropsitphn": 8705128700,
    "dropsitlph": 8705232271,
    "dropsitcph": 8705232271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20876",
    "droptype": "D",
    "dropname": "NORFORK",
    "dropdeladd": "13862 HIGHWAY 5 S",
    "dropdelcty": "NORFORK",
    "dropdelst": "AR",
    "dropdelzpp": 726589998,
    "dropphyadd": "13862 HIGHWAY 5 S",
    "dropphycty": "NORFORK",
    "dropphyst": "AR",
    "dropphyzpp": 726589998,
    "dropmaladd": "13862 HIGHWAY 5 S",
    "dropmalcty": "NORFORK",
    "dropmalst": "AR",
    "dropmalzpp": 726589998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704995551,
    "dropsitcph": 8704995551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20877",
    "droptype": "D",
    "dropname": "NORMAN",
    "dropdeladd": "340 E MAIN ST",
    "dropdelcty": "NORMAN",
    "dropdelst": "AR",
    "dropdelzpp": 719609998,
    "dropphyadd": "340 E MAIN ST",
    "dropphycty": "NORMAN",
    "dropphyst": "AR",
    "dropphyzpp": 719609998,
    "dropmaladd": "340 E MAIN ST",
    "dropmalcty": "NORMAN",
    "dropmalst": "AR",
    "dropmalzpp": 719609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703342595,
    "dropsitcph": 8703342595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20878",
    "droptype": "D",
    "dropname": "NORPHLET",
    "dropdeladd": "101 S VINEYARD ST",
    "dropdelcty": "NORPHLET",
    "dropdelst": "AR",
    "dropdelzpp": 717599998,
    "dropphyadd": "101 S VINEYARD ST",
    "dropphycty": "NORPHLET",
    "dropphyst": "AR",
    "dropphyzpp": 717599998,
    "dropmaladd": "101 S VINEYARD ST",
    "dropmalcty": "NORPHLET",
    "dropmalst": "AR",
    "dropmalzpp": 717599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705463502,
    "dropsitcph": 8705463502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20882",
    "droptype": "D",
    "dropname": "NORTH LITTLE ROCK",
    "dropdeladd": "300 W PERSHING BLVD",
    "dropdelcty": "NORTH LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 721149998,
    "dropphyadd": "300 W PERSHING BLVD",
    "dropphycty": "NORTH LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 721149998,
    "dropmaladd": "300 W PERSHING BLVD",
    "dropmalcty": "NORTH LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 721149998,
    "dropsitphn": 5017583290,
    "dropsitlph": 5017583290,
    "dropsitcph": 5017583290,
    "dropfax": 5017589172
  },
  {
    "dcode": "D",
    "dropkey": "PY20885",
    "droptype": "D",
    "dropname": "O KEAN",
    "dropdeladd": "2233 N HIGHWAY 34",
    "dropdelcty": "O KEAN",
    "dropdelst": "AR",
    "dropdelzpp": 724499998,
    "dropphyadd": "2233 N HIGHWAY 34",
    "dropphycty": "O KEAN",
    "dropphyst": "AR",
    "dropphyzpp": 724499998,
    "dropmaladd": "2233 N HIGHWAY 34",
    "dropmalcty": "O KEAN",
    "dropmalst": "AR",
    "dropmalzpp": 724499998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708923392,
    "dropsitcph": 8708923392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20888",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "10516 HIGHWAY 21 N",
    "dropdelcty": "OAK GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 726609998,
    "dropphyadd": "10516 HIGHWAY 21 N",
    "dropphycty": "OAK GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 726609998,
    "dropmaladd": "10516 HIGHWAY 21 N",
    "dropmalcty": "OAK GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 726609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019456732,
    "dropsitcph": 8707492511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20894",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "6093 OAKLAND RD STE 1",
    "dropdelcty": "OAKLAND",
    "dropdelst": "AR",
    "dropdelzpp": 726619998,
    "dropphyadd": "6093 OAKLAND RD STE 1",
    "dropphycty": "OAKLAND",
    "dropphyst": "AR",
    "dropphyzpp": 726619998,
    "dropmaladd": "6093 OAKLAND RD STE 1",
    "dropmalcty": "OAKLAND",
    "dropmalst": "AR",
    "dropmalzpp": 726619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704318899,
    "dropsitcph": 8704318899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20896",
    "droptype": "D",
    "dropname": "OARK",
    "dropdeladd": "100 HIGHWAY 215",
    "dropdelcty": "OARK",
    "dropdelst": "AR",
    "dropdelzpp": 728529998,
    "dropphyadd": "100 HIGHWAY 215",
    "dropphycty": "OARK",
    "dropphyst": "AR",
    "dropphyzpp": 728529998,
    "dropmaladd": "100 HIGHWAY 215",
    "dropmalcty": "OARK",
    "dropmalst": "AR",
    "dropmalzpp": 728529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792923200,
    "dropsitcph": 4792923200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20897",
    "droptype": "D",
    "dropname": "ODEN",
    "dropdeladd": "1093 W HIGHWAY 88",
    "dropdelcty": "ODEN",
    "dropdelst": "AR",
    "dropdelzpp": 719619998,
    "dropphyadd": "1093 W HIGHWAY 88",
    "dropphycty": "ODEN",
    "dropphyst": "AR",
    "dropphyzpp": 719619998,
    "dropmaladd": "1093 W HIGHWAY 88",
    "dropmalcty": "ODEN",
    "dropmalst": "AR",
    "dropmalzpp": 719619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703264341,
    "dropsitcph": 8703264341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20898",
    "droptype": "D",
    "dropname": "OGDEN",
    "dropdeladd": "131 PINE ST",
    "dropdelcty": "OGDEN",
    "dropdelst": "AR",
    "dropdelzpp": 718539998,
    "dropphyadd": "131 PINE ST",
    "dropphycty": "OGDEN",
    "dropphyst": "AR",
    "dropphyzpp": 718539998,
    "dropmaladd": "131 PINE ST",
    "dropmalcty": "OGDEN",
    "dropmalst": "AR",
    "dropmalzpp": 718539998,
    "dropsitphn": 8708982110,
    "dropsitlph": 8708986144,
    "dropsitcph": 8708986144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20899",
    "droptype": "D",
    "dropname": "OIL TROUGH",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "OIL TROUGH",
    "dropdelst": "AR",
    "dropdelzpp": 725649998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "OIL TROUGH",
    "dropphyst": "AR",
    "dropphyzpp": 725649998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "OIL TROUGH",
    "dropmalst": "AR",
    "dropmalzpp": 725649998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702643241,
    "dropsitcph": 8702643241,
    "dropfax": 8702643241
  },
  {
    "dcode": "D",
    "dropkey": "PY20900",
    "droptype": "D",
    "dropname": "OKOLONA",
    "dropdeladd": "316 S MAIN ST",
    "dropdelcty": "OKOLONA",
    "dropdelst": "AR",
    "dropdelzpp": 719629998,
    "dropphyadd": "316 S MAIN ST",
    "dropphycty": "OKOLONA",
    "dropphyst": "AR",
    "dropphyzpp": 719629998,
    "dropmaladd": "316 S MAIN ST",
    "dropmalcty": "OKOLONA",
    "dropmalst": "AR",
    "dropmalzpp": 719629998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702743494,
    "dropsitcph": 8702743494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20901",
    "droptype": "D",
    "dropname": "OLA",
    "dropdeladd": "310 E PENNINGTON ST",
    "dropdelcty": "OLA",
    "dropdelst": "AR",
    "dropdelzpp": 728539998,
    "dropphyadd": "310 E PENNINGTON ST",
    "dropphycty": "OLA",
    "dropphyst": "AR",
    "dropphyzpp": 728539998,
    "dropmaladd": "310 E PENNINGTON ST",
    "dropmalcty": "OLA",
    "dropmalst": "AR",
    "dropmalzpp": 728539998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794895210,
    "dropsitcph": 4794895210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20909",
    "droptype": "D",
    "dropname": "OMAHA",
    "dropdeladd": "23620 HIGHWAY 65",
    "dropdelcty": "OMAHA",
    "dropdelst": "AR",
    "dropdelzpp": 726629998,
    "dropphyadd": "23620 HIGHWAY 65",
    "dropphycty": "OMAHA",
    "dropphyst": "AR",
    "dropphyzpp": 726629998,
    "dropmaladd": "23620 HIGHWAY 65",
    "dropmalcty": "OMAHA",
    "dropmalst": "AR",
    "dropmalzpp": 726629998,
    "dropsitphn": 8704263443,
    "dropsitlph": 8704263443,
    "dropsitcph": 8704263443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20911",
    "droptype": "D",
    "dropname": "ONEIDA",
    "dropdeladd": "374 PHILLIPS 363 RD",
    "dropdelcty": "ONEIDA",
    "dropdelst": "AR",
    "dropdelzpp": 723699998,
    "dropphyadd": "374 PHILLIPS 363 RD",
    "dropphycty": "ONEIDA",
    "dropphyst": "AR",
    "dropphyzpp": 723699998,
    "dropmaladd": "374 PHILLIPS 363 RD",
    "dropmalcty": "ONEIDA",
    "dropmalst": "AR",
    "dropmalzpp": 723699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705722249,
    "dropsitcph": 8705722249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20912",
    "droptype": "D",
    "dropname": "ONIA",
    "dropdeladd": "27284 HIGHWAY 263",
    "dropdelcty": "ONIA",
    "dropdelst": "AR",
    "dropdelzpp": 726639998,
    "dropphyadd": "27284 HIGHWAY 263",
    "dropphycty": "ONIA",
    "dropphyst": "AR",
    "dropphyzpp": 726639998,
    "dropmaladd": "27284 HIGHWAY 263",
    "dropmalcty": "ONIA",
    "dropmalst": "AR",
    "dropmalzpp": 726639998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707464618,
    "dropsitcph": 8707464618,
    "dropfax": 8707464618
  },
  {
    "dcode": "D",
    "dropkey": "PY20918",
    "droptype": "D",
    "dropname": "OSCEOLA",
    "dropdeladd": "101 E JOHNSON AVE",
    "dropdelcty": "OSCEOLA",
    "dropdelst": "AR",
    "dropdelzpp": 723709998,
    "dropphyadd": "101 E JOHNSON AVE",
    "dropphycty": "OSCEOLA",
    "dropphyst": "AR",
    "dropphyzpp": 723709998,
    "dropmaladd": "101 E JOHNSON AVE",
    "dropmalcty": "OSCEOLA",
    "dropmalst": "AR",
    "dropmalzpp": 723709998,
    "dropsitphn": 8705633763,
    "dropsitlph": 8705636272,
    "dropsitcph": 8705636272,
    "dropfax": 8705632140
  },
  {
    "dcode": "D",
    "dropkey": "PY20925",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "270 N 1ST ST",
    "dropdelcty": "OXFORD",
    "dropdelst": "AR",
    "dropdelzpp": 725659998,
    "dropphyadd": "270 N 1ST ST",
    "dropphycty": "OXFORD",
    "dropphyst": "AR",
    "dropphyzpp": 725659998,
    "dropmaladd": "270 N 1ST ST",
    "dropmalcty": "OXFORD",
    "dropmalst": "AR",
    "dropmalzpp": 725659998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702587771,
    "dropsitcph": 8702587771,
    "dropfax": 8702587771
  },
  {
    "dcode": "D",
    "dropkey": "PY20927",
    "droptype": "D",
    "dropname": "OZAN",
    "dropdeladd": "6181 HIGHWAY 278 W",
    "dropdelcty": "OZAN",
    "dropdelst": "AR",
    "dropdelzpp": 718559998,
    "dropphyadd": "6181 HIGHWAY 278 W",
    "dropphycty": "OZAN",
    "dropphyst": "AR",
    "dropphyzpp": 718559998,
    "dropmaladd": "6181 HIGHWAY 278 W",
    "dropmalcty": "OZAN",
    "dropmalst": "AR",
    "dropmalzpp": 718559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709832367,
    "dropsitcph": 8709832367,
    "dropfax": 8709832831
  },
  {
    "dcode": "D",
    "dropkey": "PY20928",
    "droptype": "D",
    "dropname": "OZARK",
    "dropdeladd": "106 E RIVER ST",
    "dropdelcty": "OZARK",
    "dropdelst": "AR",
    "dropdelzpp": 729499998,
    "dropphyadd": "106 E RIVER ST",
    "dropphycty": "OZARK",
    "dropphyst": "AR",
    "dropphyzpp": 729499998,
    "dropmaladd": "106 E RIVER ST",
    "dropmalcty": "OZARK",
    "dropmalst": "AR",
    "dropmalzpp": 729499998,
    "dropsitphn": 4796673211,
    "dropsitlph": 4796673211,
    "dropsitcph": 4796673211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20930",
    "droptype": "D",
    "dropname": "OZONE",
    "dropdeladd": "101 HIGHWAY 21 N",
    "dropdelcty": "OZONE",
    "dropdelst": "AR",
    "dropdelzpp": 728549998,
    "dropphyadd": "101 HIGHWAY 21 N",
    "dropphycty": "OZONE",
    "dropphyst": "AR",
    "dropphyzpp": 728549998,
    "dropmaladd": "101 HIGHWAY 21 N",
    "dropmalcty": "OZONE",
    "dropmalst": "AR",
    "dropmalzpp": 728549998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792923607,
    "dropsitcph": 4792923607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20931",
    "droptype": "D",
    "dropname": "PALESTINE",
    "dropdeladd": "310 W PARKER ST",
    "dropdelcty": "PALESTINE",
    "dropdelst": "AR",
    "dropdelzpp": 723729998,
    "dropphyadd": "310 W PARKER ST",
    "dropphycty": "PALESTINE",
    "dropphyst": "AR",
    "dropphyzpp": 723729998,
    "dropmaladd": "310 W PARKER ST",
    "dropmalcty": "PALESTINE",
    "dropmalst": "AR",
    "dropmalzpp": 723729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705812756,
    "dropsitcph": 8705812756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20934",
    "droptype": "D",
    "dropname": "PANGBURN",
    "dropdeladd": "608 MAIN ST",
    "dropdelcty": "PANGBURN",
    "dropdelst": "AR",
    "dropdelzpp": 721219998,
    "dropphyadd": "608 MAIN ST",
    "dropphycty": "PANGBURN",
    "dropphyst": "AR",
    "dropphyzpp": 721219998,
    "dropmaladd": "608 MAIN ST",
    "dropmalcty": "PANGBURN",
    "dropmalst": "AR",
    "dropmalzpp": 721219998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017283241,
    "dropsitcph": 5017283241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20937",
    "droptype": "D",
    "dropname": "PARAGOULD",
    "dropdeladd": "201 W COURT ST",
    "dropdelcty": "PARAGOULD",
    "dropdelst": "AR",
    "dropdelzpp": 724509998,
    "dropphyadd": "201 W COURT ST",
    "dropphycty": "PARAGOULD",
    "dropphyst": "AR",
    "dropphyzpp": 724509998,
    "dropmaladd": "201 W COURT ST",
    "dropmalcty": "PARAGOULD",
    "dropmalst": "AR",
    "dropmalzpp": 724509998,
    "dropsitphn": 8702367638,
    "dropsitlph": 8702367636,
    "dropsitcph": 8702367636,
    "dropfax": 8702390978
  },
  {
    "dcode": "D",
    "dropkey": "PY20938",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "206 N ELM ST",
    "dropdelcty": "PARIS",
    "dropdelst": "AR",
    "dropdelzpp": 728559998,
    "dropphyadd": "206 N ELM ST",
    "dropphycty": "PARIS",
    "dropphyst": "AR",
    "dropphyzpp": 728559998,
    "dropmaladd": "206 N ELM ST",
    "dropmalcty": "PARIS",
    "dropmalst": "AR",
    "dropmalzpp": 728559998,
    "dropsitphn": 4799633215,
    "dropsitlph": 4799633215,
    "dropsitcph": 4799633215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20941",
    "droptype": "D",
    "dropname": "PARKDALE",
    "dropdeladd": "208 S MAIN ST",
    "dropdelcty": "PARKDALE",
    "dropdelst": "AR",
    "dropdelzpp": 716619998,
    "dropphyadd": "208 S MAIN ST",
    "dropphycty": "PARKDALE",
    "dropphyst": "AR",
    "dropphyzpp": 716619998,
    "dropmaladd": "208 S MAIN ST",
    "dropmalcty": "PARKDALE",
    "dropmalst": "AR",
    "dropmalzpp": 716619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704735115,
    "dropsitcph": 8704735115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20942",
    "droptype": "D",
    "dropname": "PARKIN",
    "dropdeladd": "111 S FRONT ST",
    "dropdelcty": "PARKIN",
    "dropdelst": "AR",
    "dropdelzpp": 723739998,
    "dropphyadd": "111 S FRONT ST",
    "dropphycty": "PARKIN",
    "dropphyst": "AR",
    "dropphyzpp": 723739998,
    "dropmaladd": "111 S FRONT ST",
    "dropmalcty": "PARKIN",
    "dropmalst": "AR",
    "dropmalzpp": 723739998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707555627,
    "dropsitcph": 8707555627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20943",
    "droptype": "D",
    "dropname": "PARKS",
    "dropdeladd": "10009 E HIGHWAY 28",
    "dropdelcty": "PARKS",
    "dropdelst": "AR",
    "dropdelzpp": 729509998,
    "dropphyadd": "10009 E HIGHWAY 28",
    "dropphycty": "PARKS",
    "dropphyst": "AR",
    "dropphyzpp": 729509998,
    "dropmaladd": "10009 E HIGHWAY 28",
    "dropmalcty": "PARKS",
    "dropmalst": "AR",
    "dropmalzpp": 729509998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4795772271,
    "dropsitcph": 4795772271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20945",
    "droptype": "D",
    "dropname": "PARON",
    "dropdeladd": "22560 HIGHWAY 9",
    "dropdelcty": "PARON",
    "dropdelst": "AR",
    "dropdelzpp": 721229998,
    "dropphyadd": "22560 HIGHWAY 9",
    "dropphycty": "PARON",
    "dropphyst": "AR",
    "dropphyzpp": 721229998,
    "dropmaladd": "22560 HIGHWAY 9",
    "dropmalcty": "PARON",
    "dropmalst": "AR",
    "dropmalzpp": 721229998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5015945597,
    "dropsitcph": 5015945597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20946",
    "droptype": "D",
    "dropname": "PARTHENON",
    "dropdeladd": "100 HIGHWAY 327",
    "dropdelcty": "PARTHENON",
    "dropdelst": "AR",
    "dropdelzpp": 726669998,
    "dropphyadd": "100 HIGHWAY 327",
    "dropphycty": "PARTHENON",
    "dropphyst": "AR",
    "dropphyzpp": 726669998,
    "dropmaladd": "100 HIGHWAY 327",
    "dropmalcty": "PARTHENON",
    "dropmalst": "AR",
    "dropmalzpp": 726669998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704462964,
    "dropsitcph": 8704462964,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20949",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "PATTERSON",
    "dropdelst": "AR",
    "dropdelzpp": 721239998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "PATTERSON",
    "dropphyst": "AR",
    "dropphyzpp": 721239998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "PATTERSON",
    "dropmalst": "AR",
    "dropmalzpp": 721239998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707315146,
    "dropsitcph": 8707315146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20951",
    "droptype": "D",
    "dropname": "PEA RIDGE",
    "dropdeladd": "468 N CURTIS AVE",
    "dropdelcty": "PEA RIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 727519998,
    "dropphyadd": "468 N CURTIS AVE",
    "dropphycty": "PEA RIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 727519998,
    "dropmaladd": "468 N CURTIS AVE",
    "dropmalcty": "PEA RIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 727519998,
    "dropsitphn": 4794511636,
    "dropsitlph": 4794511636,
    "dropsitcph": 4794511636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20952",
    "droptype": "D",
    "dropname": "PEACH ORCHARD",
    "dropdeladd": "123 SW ELM ST",
    "dropdelcty": "PEACH ORCHARD",
    "dropdelst": "AR",
    "dropdelzpp": 724539998,
    "dropphyadd": "123 SW ELM ST",
    "dropphycty": "PEACH ORCHARD",
    "dropphyst": "AR",
    "dropphyzpp": 724539998,
    "dropmaladd": "123 SW ELM ST",
    "dropmalcty": "PEACH ORCHARD",
    "dropmalst": "AR",
    "dropmalzpp": 724539998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702493850,
    "dropsitcph": 8702493850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20953",
    "droptype": "D",
    "dropname": "PEARCY",
    "dropdeladd": "5106 AIRPORT RD",
    "dropdelcty": "PEARCY",
    "dropdelst": "AR",
    "dropdelzpp": 719649998,
    "dropphyadd": "5106 AIRPORT RD",
    "dropphycty": "PEARCY",
    "dropphyst": "AR",
    "dropphyzpp": 719649998,
    "dropmaladd": "5106 AIRPORT RD",
    "dropmalcty": "PEARCY",
    "dropmalst": "AR",
    "dropmalzpp": 719649998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017673737,
    "dropsitcph": 5017673737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20955",
    "droptype": "D",
    "dropname": "PEEL",
    "dropdeladd": "7576 HIGHWAY 125 NW",
    "dropdelcty": "PEEL",
    "dropdelst": "AR",
    "dropdelzpp": 726689998,
    "dropphyadd": "7576 HIGHWAY 125 NW",
    "dropphycty": "PEEL",
    "dropphyst": "AR",
    "dropphyzpp": 726689998,
    "dropmaladd": "7576 HIGHWAY 125 NW",
    "dropmalcty": "PEEL",
    "dropmalst": "AR",
    "dropmalzpp": 726689998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704365640,
    "dropsitcph": 8704365640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20956",
    "droptype": "D",
    "dropname": "PELSOR",
    "dropdeladd": "38501 SR 7 N",
    "dropdelcty": "PELSOR",
    "dropdelst": "AR",
    "dropdelzpp": 728569998,
    "dropphyadd": "38501 SR 7 N",
    "dropphycty": "PELSOR",
    "dropphyst": "AR",
    "dropphyzpp": 728569998,
    "dropmaladd": "38501 SR 7 N",
    "dropmalcty": "PELSOR",
    "dropmalst": "AR",
    "dropmalzpp": 728569998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702945280,
    "dropsitcph": 8702945280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20957",
    "droptype": "D",
    "dropname": "PENCIL BLUFF",
    "dropdeladd": "3672 W HIGHWAY 270",
    "dropdelcty": "PENCIL BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 719659998,
    "dropphyadd": "3672 W HIGHWAY 270",
    "dropphycty": "PENCIL BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 719659998,
    "dropmaladd": "3672 W HIGHWAY 270",
    "dropmalcty": "PENCIL BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 719659998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703264412,
    "dropsitcph": 8703264412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20960",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "3376 MAIN ST",
    "dropdelcty": "PERRY",
    "dropdelst": "AR",
    "dropdelzpp": 721259998,
    "dropphyadd": "3376 MAIN ST",
    "dropphycty": "PERRY",
    "dropphyst": "AR",
    "dropphyzpp": 721259998,
    "dropmaladd": "3376 MAIN ST",
    "dropmalcty": "PERRY",
    "dropmalst": "AR",
    "dropmalzpp": 721259998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016628076,
    "dropsitcph": 5016628076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20962",
    "droptype": "D",
    "dropname": "PERRYVILLE",
    "dropdeladd": "201 B ST",
    "dropdelcty": "PERRYVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 721269998,
    "dropphyadd": "201 B ST",
    "dropphycty": "PERRYVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 721269998,
    "dropmaladd": "201 B ST",
    "dropmalcty": "PERRYVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 721269998,
    "dropsitphn": 5018892374,
    "dropsitlph": 5018892374,
    "dropsitcph": 5018892374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20963",
    "droptype": "D",
    "dropname": "PETTIGREW",
    "dropdeladd": "23170 HIGHWAY 16",
    "dropdelcty": "PETTIGREW",
    "dropdelst": "AR",
    "dropdelzpp": 727528466,
    "dropphyadd": "23170 HIGHWAY 16",
    "dropphycty": "PETTIGREW",
    "dropphyst": "AR",
    "dropphyzpp": 727528466,
    "dropmaladd": "23170 HIGHWAY 16",
    "dropmalcty": "PETTIGREW",
    "dropmalst": "AR",
    "dropmalzpp": 727528466,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796772856,
    "dropsitcph": 4796772856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20965",
    "droptype": "D",
    "dropname": "PICKENS",
    "dropdeladd": "126 RAILROAD ST",
    "dropdelcty": "PICKENS",
    "dropdelst": "AR",
    "dropdelzpp": 716629998,
    "dropphyadd": "126 RAILROAD ST",
    "dropphycty": "PICKENS",
    "dropphyst": "AR",
    "dropphyzpp": 716629998,
    "dropmaladd": "126 RAILROAD ST",
    "dropmalcty": "PICKENS",
    "dropmalst": "AR",
    "dropmalzpp": 716629998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703824525,
    "dropsitcph": 8703824525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20968",
    "droptype": "D",
    "dropname": "PIGGOTT",
    "dropdeladd": "116 N 3RD AVE",
    "dropdelcty": "PIGGOTT",
    "dropdelst": "AR",
    "dropdelzpp": 724549998,
    "dropphyadd": "116 N 3RD AVE",
    "dropphycty": "PIGGOTT",
    "dropphyst": "AR",
    "dropphyzpp": 724549998,
    "dropmaladd": "116 N 3RD AVE",
    "dropmalcty": "PIGGOTT",
    "dropmalst": "AR",
    "dropmalzpp": 724549998,
    "dropsitphn": 8702592140,
    "dropsitlph": 8702592170,
    "dropsitcph": 8702592140,
    "dropfax": 8705983071
  },
  {
    "dcode": "D",
    "dropkey": "PY20970",
    "droptype": "D",
    "dropname": "PINDALL",
    "dropdeladd": "21838 N HIGHWAY 65",
    "dropdelcty": "PINDALL",
    "dropdelst": "AR",
    "dropdelzpp": 726698800,
    "dropphyadd": "21838 N HIGHWAY 65",
    "dropphycty": "PINDALL",
    "dropphyst": "AR",
    "dropphyzpp": 726698800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINDALL",
    "dropmalst": "AR",
    "dropmalzpp": 726699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708130539,
    "dropsitcph": 8708130539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20972",
    "droptype": "D",
    "dropname": "PINE BLUFF",
    "dropdeladd": "100 E 8TH AVE STE 105",
    "dropdelcty": "PINE BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 716019998,
    "dropphyadd": "100 E 8TH AVE STE 105",
    "dropphycty": "PINE BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 716019998,
    "dropmaladd": "100 E 8TH AVE STE 105",
    "dropmalcty": "PINE BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 716019998,
    "dropsitphn": 8705363535,
    "dropsitlph": 8705363535,
    "dropsitcph": 8705363535,
    "dropfax": 8705359512
  },
  {
    "dcode": "D",
    "dropkey": "PY20981",
    "droptype": "D",
    "dropname": "PLAINVIEW",
    "dropdeladd": "405 W MAIN ST",
    "dropdelcty": "PLAINVIEW",
    "dropdelst": "AR",
    "dropdelzpp": 728579998,
    "dropphyadd": "405 W MAIN ST",
    "dropphycty": "PLAINVIEW",
    "dropphyst": "AR",
    "dropphyzpp": 728579998,
    "dropmaladd": "405 W MAIN ST",
    "dropmalcty": "PLAINVIEW",
    "dropmalst": "AR",
    "dropmalzpp": 728579998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792724414,
    "dropsitcph": 4792724414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20984",
    "droptype": "D",
    "dropname": "PLEASANT GROVE",
    "dropdeladd": "28433 HIGHWAY 14",
    "dropdelcty": "PLEASANT GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 725679998,
    "dropphyadd": "28433 HIGHWAY 14",
    "dropphycty": "PLEASANT GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 725679998,
    "dropmaladd": "28433 HIGHWAY 14",
    "dropmalcty": "PLEASANT GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 725679998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706523526,
    "dropsitcph": 8706523526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20987",
    "droptype": "D",
    "dropname": "PLEASANT PLAINS",
    "dropdeladd": "360 MAIN ST",
    "dropdelcty": "PLEASANT PLAINS",
    "dropdelst": "AR",
    "dropdelzpp": 725689998,
    "dropphyadd": "360 MAIN ST",
    "dropphycty": "PLEASANT PLAINS",
    "dropphyst": "AR",
    "dropphyzpp": 725689998,
    "dropmaladd": "360 MAIN ST",
    "dropmalcty": "PLEASANT PLAINS",
    "dropmalst": "AR",
    "dropmalzpp": 725689998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013452637,
    "dropsitcph": 5013452637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20990",
    "droptype": "D",
    "dropname": "PLUMERVILLE",
    "dropdeladd": "300 N SPRINGFIELD ST",
    "dropdelcty": "PLUMERVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 721279998,
    "dropphyadd": "300 N SPRINGFIELD ST",
    "dropphycty": "PLUMERVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 721279998,
    "dropmaladd": "300 N SPRINGFIELD ST",
    "dropmalcty": "PLUMERVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 721279998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013543430,
    "dropsitcph": 5013543430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20991",
    "droptype": "D",
    "dropname": "POCAHONTAS",
    "dropdeladd": "501 BROADWAY ST",
    "dropdelcty": "POCAHONTAS",
    "dropdelst": "AR",
    "dropdelzpp": 724559998,
    "dropphyadd": "501 BROADWAY ST",
    "dropphycty": "POCAHONTAS",
    "dropphyst": "AR",
    "dropphyzpp": 724559998,
    "dropmaladd": "501 BROADWAY ST",
    "dropmalcty": "POCAHONTAS",
    "dropmalst": "AR",
    "dropmalzpp": 724559998,
    "dropsitphn": 8708924465,
    "dropsitlph": 8708924455,
    "dropsitcph": 8708924455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20993",
    "droptype": "D",
    "dropname": "POLLARD",
    "dropdeladd": "311 FRONT ST",
    "dropdelcty": "POLLARD",
    "dropdelst": "AR",
    "dropdelzpp": 724569998,
    "dropphyadd": "311 FRONT ST",
    "dropphycty": "POLLARD",
    "dropphyst": "AR",
    "dropphyzpp": 724569998,
    "dropmaladd": "311 FRONT ST",
    "dropmalcty": "POLLARD",
    "dropmalst": "AR",
    "dropmalzpp": 724569998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705442431,
    "dropsitcph": 8705442431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20994",
    "droptype": "D",
    "dropname": "PONCA",
    "dropdeladd": "4651 AR 43 HWY",
    "dropdelcty": "PONCA",
    "dropdelst": "AR",
    "dropdelzpp": 726709998,
    "dropphyadd": "4651 AR 43 HWY",
    "dropphycty": "PONCA",
    "dropphyst": "AR",
    "dropphyzpp": 726709998,
    "dropmaladd": "4651 AR 43 HWY",
    "dropmalcty": "PONCA",
    "dropmalst": "AR",
    "dropmalzpp": 726709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708615687,
    "dropsitcph": 8708615687,
    "dropfax": 8708615509
  },
  {
    "dcode": "D",
    "dropkey": "PY20996",
    "droptype": "D",
    "dropname": "POPLAR GROVE",
    "dropdeladd": "11200 HIGHWAY 49",
    "dropdelcty": "POPLAR GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 723749998,
    "dropphyadd": "11200 HIGHWAY 49",
    "dropphycty": "POPLAR GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 723749998,
    "dropmaladd": "11200 HIGHWAY 49",
    "dropmalcty": "POPLAR GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 723749998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708292314,
    "dropsitcph": 8708292314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20997",
    "droptype": "D",
    "dropname": "PORTIA",
    "dropdeladd": "113 W FRONT ST",
    "dropdelcty": "PORTIA",
    "dropdelst": "AR",
    "dropdelzpp": 724579998,
    "dropphyadd": "113 W FRONT ST",
    "dropphycty": "PORTIA",
    "dropphyst": "AR",
    "dropphyzpp": 724579998,
    "dropmaladd": "113 W FRONT ST",
    "dropmalcty": "PORTIA",
    "dropmalst": "AR",
    "dropmalzpp": 724579998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708863442,
    "dropsitcph": 8708863442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY20998",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "145 N MAIN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "AR",
    "dropdelzpp": 716639998,
    "dropphyadd": "145 N MAIN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "AR",
    "dropphyzpp": 716639998,
    "dropmaladd": "145 N MAIN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "AR",
    "dropmalzpp": 716639998,
    "dropsitphn": 8707372265,
    "dropsitlph": 8707372265,
    "dropsitcph": 8707372265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21002",
    "droptype": "D",
    "dropname": "POTTSVILLE",
    "dropdeladd": "5580 US HIGHWAY 64 E",
    "dropdelcty": "POTTSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728589998,
    "dropphyadd": "5580 US HIGHWAY 64 E",
    "dropphycty": "POTTSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728589998,
    "dropmaladd": "5580 US HIGHWAY 64 E",
    "dropmalcty": "POTTSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728589998,
    "dropsitphn": 4799684440,
    "dropsitlph": 4799684440,
    "dropsitcph": 4799684440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21003",
    "droptype": "D",
    "dropname": "POUGHKEEPSIE",
    "dropdeladd": "4066 ARKANSAS HIGHWAY 58",
    "dropdelcty": "POUGHKEEPSIE",
    "dropdelst": "AR",
    "dropdelzpp": 725699998,
    "dropphyadd": "4066 ARKANSAS HIGHWAY 58",
    "dropphycty": "POUGHKEEPSIE",
    "dropphyst": "AR",
    "dropphyzpp": 725699998,
    "dropmaladd": "4066 ARKANSAS HIGHWAY 58",
    "dropmalcty": "POUGHKEEPSIE",
    "dropmalst": "AR",
    "dropmalzpp": 725699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705283939,
    "dropsitcph": 8705283939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21004",
    "droptype": "D",
    "dropname": "POWHATAN",
    "dropdeladd": "4399 HIGHWAY 25",
    "dropdelcty": "POWHATAN",
    "dropdelst": "AR",
    "dropdelzpp": 724589998,
    "dropphyadd": "4399 HIGHWAY 25",
    "dropphycty": "POWHATAN",
    "dropphyst": "AR",
    "dropphyzpp": 724589998,
    "dropmaladd": "4399 HIGHWAY 25",
    "dropmalcty": "POWHATAN",
    "dropmalst": "AR",
    "dropmalzpp": 724589998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708786606,
    "dropsitcph": 8708786606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21005",
    "droptype": "D",
    "dropname": "POYEN",
    "dropdeladd": "210 E FOURTH ST",
    "dropdelcty": "POYEN",
    "dropdelst": "AR",
    "dropdelzpp": 721289998,
    "dropphyadd": "210 E FOURTH ST",
    "dropphycty": "POYEN",
    "dropphyst": "AR",
    "dropphyzpp": 721289998,
    "dropmaladd": "210 E FOURTH ST",
    "dropmalcty": "POYEN",
    "dropmalst": "AR",
    "dropmalzpp": 721289998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013370014,
    "dropsitcph": 5013370014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21007",
    "droptype": "D",
    "dropname": "PRAIRIE GROVE",
    "dropdeladd": "221 W BUCHANAN ST",
    "dropdelcty": "PRAIRIE GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 727539998,
    "dropphyadd": "221 W BUCHANAN ST",
    "dropphycty": "PRAIRIE GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 727539998,
    "dropmaladd": "221 W BUCHANAN ST",
    "dropmalcty": "PRAIRIE GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 727539998,
    "dropsitphn": 4798462260,
    "dropsitlph": 4798462260,
    "dropsitcph": 4798462260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21008",
    "droptype": "D",
    "dropname": "PRATTSVILLE",
    "dropdeladd": "9113 HIGHWAY 270 W",
    "dropdelcty": "PRATTSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 721299998,
    "dropphyadd": "9113 HIGHWAY 270 W",
    "dropphycty": "PRATTSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 721299998,
    "dropmaladd": "9113 HIGHWAY 270 W",
    "dropmalcty": "PRATTSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 721299998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706994611,
    "dropsitcph": 8706994611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21009",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "207 E ELM ST",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "AR",
    "dropdelzpp": 718579998,
    "dropphyadd": "207 E ELM ST",
    "dropphycty": "PRESCOTT",
    "dropphyst": "AR",
    "dropphyzpp": 718579998,
    "dropmaladd": "207 E ELM ST",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "AR",
    "dropmalzpp": 718579998,
    "dropsitphn": 8708875698,
    "dropsitlph": 8708873215,
    "dropsitcph": 8708873215,
    "dropfax": 8708876462
  },
  {
    "dcode": "D",
    "dropkey": "PY21013",
    "droptype": "D",
    "dropname": "PRIM",
    "dropdeladd": "4224 PRIM RD",
    "dropdelcty": "PRIM",
    "dropdelst": "AR",
    "dropdelzpp": 721309998,
    "dropphyadd": "4224 PRIM RD",
    "dropphycty": "PRIM",
    "dropphyst": "AR",
    "dropphyzpp": 721309998,
    "dropmaladd": "4224 PRIM RD",
    "dropmalcty": "PRIM",
    "dropmalst": "AR",
    "dropmalzpp": 721309998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709672004,
    "dropsitcph": 8709672004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21014",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "5650 HIGHWAY 147 S",
    "dropdelcty": "PROCTOR",
    "dropdelst": "AR",
    "dropdelzpp": 723769998,
    "dropphyadd": "5650 HIGHWAY 147 S",
    "dropphycty": "PROCTOR",
    "dropphyst": "AR",
    "dropphyzpp": 723769998,
    "dropmaladd": "5650 HIGHWAY 147 S",
    "dropmalcty": "PROCTOR",
    "dropmalst": "AR",
    "dropmalzpp": 723769998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702442034,
    "dropsitcph": 8702442034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21018",
    "droptype": "D",
    "dropname": "PYATT",
    "dropdeladd": "676 FOSTER ST",
    "dropdelcty": "PYATT",
    "dropdelst": "AR",
    "dropdelzpp": 726729998,
    "dropphyadd": "676 FOSTER ST",
    "dropphycty": "PYATT",
    "dropphyst": "AR",
    "dropphyzpp": 726729998,
    "dropmaladd": "676 FOSTER ST",
    "dropmalcty": "PYATT",
    "dropmalst": "AR",
    "dropmalzpp": 726729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704273300,
    "dropsitcph": 8704273300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21019",
    "droptype": "D",
    "dropname": "QUITMAN",
    "dropdeladd": "5770 HEBER SPRINGS RD W",
    "dropdelcty": "QUITMAN",
    "dropdelst": "AR",
    "dropdelzpp": 721319998,
    "dropphyadd": "5770 HEBER SPRINGS RD W",
    "dropphycty": "QUITMAN",
    "dropphyst": "AR",
    "dropphyzpp": 721319998,
    "dropmaladd": "5770 HEBER SPRINGS RD W",
    "dropmalcty": "QUITMAN",
    "dropmalst": "AR",
    "dropmalzpp": 721319998,
    "dropsitphn": 5012872040,
    "dropsitlph": 5012872040,
    "dropsitcph": 5012872040,
    "dropfax": 5012872040
  },
  {
    "dcode": "D",
    "dropkey": "PY21021",
    "droptype": "D",
    "dropname": "RATCLIFF",
    "dropdeladd": "9901 W STATE HIGHWAY 22",
    "dropdelcty": "RATCLIFF",
    "dropdelst": "AR",
    "dropdelzpp": 729519998,
    "dropphyadd": "9901 W STATE HIGHWAY 22",
    "dropphycty": "RATCLIFF",
    "dropphyst": "AR",
    "dropphyzpp": 729519998,
    "dropmaladd": "9901 W STATE HIGHWAY 22",
    "dropmalcty": "RATCLIFF",
    "dropmalst": "AR",
    "dropmalzpp": 729519998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796354401,
    "dropsitcph": 4796354401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21022",
    "droptype": "D",
    "dropname": "RAVENDEN",
    "dropdeladd": "471 HIGHWAY 63 W",
    "dropdelcty": "RAVENDEN",
    "dropdelst": "AR",
    "dropdelzpp": 724599998,
    "dropphyadd": "471 HIGHWAY 63 W",
    "dropphycty": "RAVENDEN",
    "dropphyst": "AR",
    "dropphyzpp": 724599998,
    "dropmaladd": "471 HIGHWAY 63 W",
    "dropmalcty": "RAVENDEN",
    "dropmalst": "AR",
    "dropmalzpp": 724599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708692946,
    "dropsitcph": 8708692946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21023",
    "droptype": "D",
    "dropname": "RAVENDEN SPRINGS",
    "dropdeladd": "19319 HIGHWAY 90 W",
    "dropdelcty": "RAVENDEN SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 724609998,
    "dropphyadd": "19319 HIGHWAY 90 W",
    "dropphycty": "RAVENDEN SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 724609998,
    "dropmaladd": "19319 HIGHWAY 90 W",
    "dropmalcty": "RAVENDEN SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 724609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708692552,
    "dropsitcph": 8708692552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21028",
    "droptype": "D",
    "dropname": "RECTOR",
    "dropdeladd": "310 S STEWART ST",
    "dropdelcty": "RECTOR",
    "dropdelst": "AR",
    "dropdelzpp": 724619998,
    "dropphyadd": "310 S STEWART ST",
    "dropphycty": "RECTOR",
    "dropphyst": "AR",
    "dropphyzpp": 724619998,
    "dropmaladd": "310 S STEWART ST",
    "dropmalcty": "RECTOR",
    "dropmalst": "AR",
    "dropmalzpp": 724619998,
    "dropsitphn": 8705952174,
    "dropsitlph": 8705952174,
    "dropsitcph": 8705952174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21032",
    "droptype": "D",
    "dropname": "REDFIELD",
    "dropdeladd": "201 NE RAILROAD ST",
    "dropdelcty": "REDFIELD",
    "dropdelst": "AR",
    "dropdelzpp": 721329998,
    "dropphyadd": "201 NE RAILROAD ST",
    "dropphycty": "REDFIELD",
    "dropphyst": "AR",
    "dropphyzpp": 721329998,
    "dropmaladd": "201 NE RAILROAD ST",
    "dropmalcty": "REDFIELD",
    "dropmalst": "AR",
    "dropmalzpp": 721329998,
    "dropsitphn": 5013972418,
    "dropsitlph": 5013972418,
    "dropsitcph": 5013972418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21040",
    "droptype": "D",
    "dropname": "REYDELL",
    "dropdeladd": "21900 S HIGHWAY 88",
    "dropdelcty": "REYDELL",
    "dropdelst": "AR",
    "dropdelzpp": 721339998,
    "dropphyadd": "21900 S HIGHWAY 88",
    "dropphycty": "REYDELL",
    "dropphyst": "AR",
    "dropphyzpp": 721339998,
    "dropmaladd": "21900 S HIGHWAY 88",
    "dropmalcty": "REYDELL",
    "dropmalst": "AR",
    "dropmalzpp": 721339998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704793055,
    "dropsitcph": 8704793055,
    "dropfax": 8704793055
  },
  {
    "dcode": "D",
    "dropkey": "PY21041",
    "droptype": "D",
    "dropname": "REYNO",
    "dropdeladd": "6720 BIGGERS REYNO RD",
    "dropdelcty": "REYNO",
    "dropdelst": "AR",
    "dropdelzpp": 724629998,
    "dropphyadd": "6720 BIGGERS REYNO RD",
    "dropphycty": "REYNO",
    "dropphyst": "AR",
    "dropphyzpp": 724629998,
    "dropmaladd": "6720 BIGGERS REYNO RD",
    "dropmalcty": "REYNO",
    "dropmalst": "AR",
    "dropmalzpp": 724629998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707692646,
    "dropsitcph": 8707692646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21043",
    "droptype": "D",
    "dropname": "RISON",
    "dropdeladd": "506 S MAIN ST",
    "dropdelcty": "RISON",
    "dropdelst": "AR",
    "dropdelzpp": 716659998,
    "dropphyadd": "506 S MAIN ST",
    "dropphycty": "RISON",
    "dropphyst": "AR",
    "dropphyzpp": 716659998,
    "dropmaladd": "506 S MAIN ST",
    "dropmalcty": "RISON",
    "dropmalst": "AR",
    "dropmalzpp": 716659998,
    "dropsitphn": 8703256845,
    "dropsitlph": 8703256845,
    "dropsitcph": 8703256845,
    "dropfax": 8703257687
  },
  {
    "dcode": "D",
    "dropkey": "PY21053",
    "droptype": "D",
    "dropname": "ROE",
    "dropdeladd": "180 MAIN ST",
    "dropdelcty": "ROE",
    "dropdelst": "AR",
    "dropdelzpp": 721349998,
    "dropphyadd": "180 MAIN ST",
    "dropphycty": "ROE",
    "dropphyst": "AR",
    "dropphyzpp": 721349998,
    "dropmaladd": "180 MAIN ST",
    "dropmalcty": "ROE",
    "dropmalst": "AR",
    "dropmalzpp": 721349998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703192515,
    "dropsitcph": 8703192515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21054",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "401 N 8TH ST",
    "dropdelcty": "ROGERS",
    "dropdelst": "AR",
    "dropdelzpp": 727569998,
    "dropphyadd": "401 N 8TH ST",
    "dropphycty": "ROGERS",
    "dropphyst": "AR",
    "dropphyzpp": 727569998,
    "dropmaladd": "401 N 8TH ST",
    "dropmalcty": "ROGERS",
    "dropmalst": "AR",
    "dropmalzpp": 727569998,
    "dropsitphn": 4796310132,
    "dropsitlph": 4796363301,
    "dropsitcph": 4796363301,
    "dropfax": 4799368378
  },
  {
    "dcode": "D",
    "dropkey": "PY21057",
    "droptype": "D",
    "dropname": "ROLAND",
    "dropdeladd": "21111 CRIBBS ST",
    "dropdelcty": "ROLAND",
    "dropdelst": "AR",
    "dropdelzpp": 721359998,
    "dropphyadd": "21111 CRIBBS ST",
    "dropphycty": "ROLAND",
    "dropphyst": "AR",
    "dropphyzpp": 721359998,
    "dropmaladd": "21111 CRIBBS ST",
    "dropmalcty": "ROLAND",
    "dropmalst": "AR",
    "dropmalzpp": 721359998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018684279,
    "dropsitcph": 5018684279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21059",
    "droptype": "D",
    "dropname": "ROMANCE",
    "dropdeladd": "292 HIGHWAY 31",
    "dropdelcty": "ROMANCE",
    "dropdelst": "AR",
    "dropdelzpp": 721369998,
    "dropphyadd": "292 HIGHWAY 31",
    "dropphycty": "ROMANCE",
    "dropphyst": "AR",
    "dropphyzpp": 721369998,
    "dropmaladd": "292 HIGHWAY 31",
    "dropmalcty": "ROMANCE",
    "dropmalst": "AR",
    "dropmalzpp": 721369998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012078016,
    "dropsitcph": 5012078016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21061",
    "droptype": "D",
    "dropname": "ROSE BUD",
    "dropdeladd": "6083 HIGHWAY 36 W",
    "dropdelcty": "ROSE BUD",
    "dropdelst": "AR",
    "dropdelzpp": 721379998,
    "dropphyadd": "6083 HIGHWAY 36 W",
    "dropphycty": "ROSE BUD",
    "dropphyst": "AR",
    "dropphyzpp": 721379998,
    "dropmaladd": "6083 HIGHWAY 36 W",
    "dropmalcty": "ROSE BUD",
    "dropmalst": "AR",
    "dropmalzpp": 721379998,
    "dropsitphn": 5015565126,
    "dropsitlph": 5015565126,
    "dropsitcph": 5015565126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21065",
    "droptype": "D",
    "dropname": "ROSIE",
    "dropdeladd": "39 CAPSHAW RD",
    "dropdelcty": "ROSIE",
    "dropdelst": "AR",
    "dropdelzpp": 725719998,
    "dropphyadd": "39 CAPSHAW RD",
    "dropphycty": "ROSIE",
    "dropphyst": "AR",
    "dropphyzpp": 725719998,
    "dropmaladd": "39 CAPSHAW RD",
    "dropmalcty": "ROSIE",
    "dropmalst": "AR",
    "dropmalzpp": 725719998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702512459,
    "dropsitcph": 8702512459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21066",
    "droptype": "D",
    "dropname": "ROSSTON",
    "dropdeladd": "4463 US HIGHWAY 371",
    "dropdelcty": "ROSSTON",
    "dropdelst": "AR",
    "dropdelzpp": 718589998,
    "dropphyadd": "4463 US HIGHWAY 371",
    "dropphycty": "ROSSTON",
    "dropphyst": "AR",
    "dropphyzpp": 718589998,
    "dropmaladd": "4463 US HIGHWAY 371",
    "dropmalcty": "ROSSTON",
    "dropmalst": "AR",
    "dropmalzpp": 718589998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708712796,
    "dropsitcph": 8708712796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21069",
    "droptype": "D",
    "dropname": "ROVER",
    "dropdeladd": "19623 S HIGHWAY 27",
    "dropdelcty": "ROVER",
    "dropdelst": "AR",
    "dropdelzpp": 728609998,
    "dropphyadd": "19623 S HIGHWAY 27",
    "dropphycty": "ROVER",
    "dropphyst": "AR",
    "dropphyzpp": 728609998,
    "dropmaladd": "19623 S HIGHWAY 27",
    "dropmalcty": "ROVER",
    "dropmalst": "AR",
    "dropmalzpp": 728609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792724618,
    "dropsitcph": 4792724618,
    "dropfax": 4792724618
  },
  {
    "dcode": "D",
    "dropkey": "PY21071",
    "droptype": "D",
    "dropname": "ROYAL",
    "dropdeladd": "6951 ALBERT PIKE RD",
    "dropdelcty": "ROYAL",
    "dropdelst": "AR",
    "dropdelzpp": 719689998,
    "dropphyadd": "6951 ALBERT PIKE RD",
    "dropphycty": "ROYAL",
    "dropphyst": "AR",
    "dropphyzpp": 719689998,
    "dropmaladd": "6951 ALBERT PIKE RD",
    "dropmalcty": "ROYAL",
    "dropmalst": "AR",
    "dropmalzpp": 719689998,
    "dropsitphn": 5017671257,
    "dropsitlph": 5017671257,
    "dropsitcph": 5017671257,
    "dropfax": 5017671257
  },
  {
    "dcode": "D",
    "dropkey": "PY21074",
    "droptype": "D",
    "dropname": "RUDY",
    "dropdeladd": "224 N RAILROAD AVE",
    "dropdelcty": "RUDY",
    "dropdelst": "AR",
    "dropdelzpp": 729529998,
    "dropphyadd": "224 N RAILROAD AVE",
    "dropphycty": "RUDY",
    "dropphyst": "AR",
    "dropphyzpp": 729529998,
    "dropmaladd": "224 N RAILROAD AVE",
    "dropmalcty": "RUDY",
    "dropmalst": "AR",
    "dropmalzpp": 729529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796322493,
    "dropsitcph": 4796322493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21079",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "4409 HIGHWAY AVE",
    "dropdelcty": "RUSSELL",
    "dropdelst": "AR",
    "dropdelzpp": 721399998,
    "dropphyadd": "4409 HIGHWAY AVE",
    "dropphycty": "RUSSELL",
    "dropphyst": "AR",
    "dropphyzpp": 721399998,
    "dropmaladd": "4409 HIGHWAY AVE",
    "dropmalcty": "RUSSELL",
    "dropmalst": "AR",
    "dropmalzpp": 721399998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5012078030,
    "dropsitcph": 5012078030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21081",
    "droptype": "D",
    "dropname": "RUSSELLVILLE",
    "dropdeladd": "203 S BOSTON AVE",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728019998,
    "dropphyadd": "203 S BOSTON AVE",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728019998,
    "dropmaladd": "203 S BOSTON AVE",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728019998,
    "dropsitphn": 4799684112,
    "dropsitlph": 4799684112,
    "dropsitcph": 4799684112,
    "dropfax": 4799683628
  },
  {
    "dcode": "D",
    "dropkey": "PY21084",
    "droptype": "D",
    "dropname": "SAFFELL",
    "dropdeladd": "363 HIGHWAY 25",
    "dropdelcty": "SAFFELL",
    "dropdelst": "AR",
    "dropdelzpp": 725729998,
    "dropphyadd": "363 HIGHWAY 25",
    "dropphycty": "SAFFELL",
    "dropphyst": "AR",
    "dropphyzpp": 725729998,
    "dropmaladd": "363 HIGHWAY 25",
    "dropmalcty": "SAFFELL",
    "dropmalst": "AR",
    "dropmalzpp": 725729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705284942,
    "dropsitcph": 8705284942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21085",
    "droptype": "D",
    "dropname": "SAGE",
    "dropdeladd": "1545 AR 69B HWY",
    "dropdelcty": "SAGE",
    "dropdelst": "AR",
    "dropdelzpp": 725739998,
    "dropphyadd": "1545 AR 69B HWY",
    "dropphycty": "SAGE",
    "dropphyst": "AR",
    "dropphyzpp": 725739998,
    "dropmaladd": "1545 AR 69B HWY",
    "dropmalcty": "SAGE",
    "dropmalst": "AR",
    "dropmalzpp": 725739998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703685017,
    "dropsitcph": 8703685017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21087",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "212 BROADWAY AVE",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "AR",
    "dropdelzpp": 721409998,
    "dropphyadd": "212 BROADWAY AVE",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "AR",
    "dropphyzpp": 721409998,
    "dropmaladd": "212 BROADWAY AVE",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "AR",
    "dropmalzpp": 721409998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702823431,
    "dropsitcph": 8702823431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21088",
    "droptype": "D",
    "dropname": "SAINT FRANCIS",
    "dropdeladd": "108 E HIGHWAY 62",
    "dropdelcty": "SAINT FRANCIS",
    "dropdelst": "AR",
    "dropdelzpp": 724649998,
    "dropphyadd": "108 E HIGHWAY 62",
    "dropphycty": "SAINT FRANCIS",
    "dropphyst": "AR",
    "dropphyzpp": 724649998,
    "dropmaladd": "108 E HIGHWAY 62",
    "dropmalcty": "SAINT FRANCIS",
    "dropmalst": "AR",
    "dropmalzpp": 724649998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705985137,
    "dropsitcph": 8705985137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21089",
    "droptype": "D",
    "dropname": "SAINT JOE",
    "dropdeladd": "1 HIGHWAY 65 S",
    "dropdelcty": "SAINT JOE",
    "dropdelst": "AR",
    "dropdelzpp": 726759998,
    "dropphyadd": "1 HIGHWAY 65 S",
    "dropphycty": "SAINT JOE",
    "dropphyst": "AR",
    "dropphyzpp": 726759998,
    "dropmaladd": "1 HIGHWAY 65 S",
    "dropmalcty": "SAINT JOE",
    "dropmalst": "AR",
    "dropmalzpp": 726759998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704392511,
    "dropsitcph": 8704392511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21090",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "190 5TH ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "AR",
    "dropdelzpp": 727609998,
    "dropphyadd": "190 5TH ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "AR",
    "dropphyzpp": 727609998,
    "dropmaladd": "190 5TH ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "AR",
    "dropmalzpp": 727609998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796772729,
    "dropsitcph": 4796772729,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21091",
    "droptype": "D",
    "dropname": "SALADO",
    "dropdeladd": "959 NEWPORT RD",
    "dropdelcty": "SALADO",
    "dropdelst": "AR",
    "dropdelzpp": 725759998,
    "dropphyadd": "959 NEWPORT RD",
    "dropphycty": "SALADO",
    "dropphyst": "AR",
    "dropphyzpp": 725759998,
    "dropmaladd": "959 NEWPORT RD",
    "dropmalcty": "SALADO",
    "dropmalst": "AR",
    "dropmalzpp": 725759998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702511095,
    "dropsitcph": 8702511095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21093",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "510 HIGHWAY 62 W",
    "dropdelcty": "SALEM",
    "dropdelst": "AR",
    "dropdelzpp": 725769998,
    "dropphyadd": "510 HIGHWAY 62 W",
    "dropphycty": "SALEM",
    "dropphyst": "AR",
    "dropphyzpp": 725769998,
    "dropmaladd": "510 HIGHWAY 62 W",
    "dropmalcty": "SALEM",
    "dropmalst": "AR",
    "dropmalzpp": 725769998,
    "dropsitphn": 8708953345,
    "dropsitlph": 8708953345,
    "dropsitcph": 8708953345,
    "dropfax": 8708953346
  },
  {
    "dcode": "D",
    "dropkey": "PY21098",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "1948 MAIN ST",
    "dropdelcty": "SARATOGA",
    "dropdelst": "AR",
    "dropdelzpp": 718599998,
    "dropphyadd": "1948 MAIN ST",
    "dropphycty": "SARATOGA",
    "dropphyst": "AR",
    "dropphyzpp": 718599998,
    "dropmaladd": "1948 MAIN ST",
    "dropmalcty": "SARATOGA",
    "dropmalst": "AR",
    "dropmalzpp": 718599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703889210,
    "dropsitcph": 8703889210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21100",
    "droptype": "D",
    "dropname": "SCOTLAND",
    "dropdeladd": "11420 HIGHWAY 95 W",
    "dropdelcty": "SCOTLAND",
    "dropdelst": "AR",
    "dropdelzpp": 721419998,
    "dropphyadd": "11420 HIGHWAY 95 W",
    "dropphycty": "SCOTLAND",
    "dropphyst": "AR",
    "dropphyzpp": 721419998,
    "dropmaladd": "11420 HIGHWAY 95 W",
    "dropmalcty": "SCOTLAND",
    "dropmalst": "AR",
    "dropmalzpp": 721419998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5015923555,
    "dropsitcph": 5015923555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21101",
    "droptype": "D",
    "dropname": "SCOTT",
    "dropdeladd": "14918 ALEXANDER RD",
    "dropdelcty": "SCOTT",
    "dropdelst": "AR",
    "dropdelzpp": 721429998,
    "dropphyadd": "14918 ALEXANDER RD",
    "dropphycty": "SCOTT",
    "dropphyst": "AR",
    "dropphyzpp": 721429998,
    "dropmaladd": "14918 ALEXANDER RD",
    "dropmalcty": "SCOTT",
    "dropmalst": "AR",
    "dropmalzpp": 721429998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5019619366,
    "dropsitcph": 5019619357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21102",
    "droptype": "D",
    "dropname": "SCRANTON",
    "dropdeladd": "508 MAGNOLIA ST",
    "dropdelcty": "SCRANTON",
    "dropdelst": "AR",
    "dropdelzpp": 728639998,
    "dropphyadd": "508 MAGNOLIA ST",
    "dropphycty": "SCRANTON",
    "dropphyst": "AR",
    "dropphyzpp": 728639998,
    "dropmaladd": "508 MAGNOLIA ST",
    "dropmalcty": "SCRANTON",
    "dropmalst": "AR",
    "dropmalzpp": 728639998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799382500,
    "dropsitcph": 4799382500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21104",
    "droptype": "D",
    "dropname": "SEARCY",
    "dropdeladd": "600 W ACADEMY AVE",
    "dropdelcty": "SEARCY",
    "dropdelst": "AR",
    "dropdelzpp": 721439998,
    "dropphyadd": "600 W ACADEMY AVE",
    "dropphycty": "SEARCY",
    "dropphyst": "AR",
    "dropphyzpp": 721439998,
    "dropmaladd": "600 W ACADEMY AVE",
    "dropmalcty": "SEARCY",
    "dropmalst": "AR",
    "dropmalzpp": 721439998,
    "dropsitphn": 5012683840,
    "dropsitlph": 5012683840,
    "dropsitcph": 5012683840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21107",
    "droptype": "D",
    "dropname": "SEDGWICK",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "SEDGWICK",
    "dropdelst": "AR",
    "dropdelzpp": 724659998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "SEDGWICK",
    "dropphyst": "AR",
    "dropphyzpp": 724659998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "SEDGWICK",
    "dropmalst": "AR",
    "dropmalzpp": 724659998,
    "dropsitphn": 8708869034,
    "dropsitlph": 8708869034,
    "dropsitcph": 8708869034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21111",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "313 S OAK ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "AR",
    "dropdelzpp": 721509998,
    "dropphyadd": "313 S OAK ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "AR",
    "dropphyzpp": 721509998,
    "dropmaladd": "313 S OAK ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "AR",
    "dropmalzpp": 721509998,
    "dropsitphn": 8709424119,
    "dropsitlph": 8709424119,
    "dropsitcph": 8709424119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21112",
    "droptype": "D",
    "dropname": "SHERRILL",
    "dropdeladd": "114 E MAIN ST",
    "dropdelcty": "SHERRILL",
    "dropdelst": "AR",
    "dropdelzpp": 721529998,
    "dropphyadd": "114 E MAIN ST",
    "dropphycty": "SHERRILL",
    "dropphyst": "AR",
    "dropphyzpp": 721529998,
    "dropmaladd": "114 E MAIN ST",
    "dropmalcty": "SHERRILL",
    "dropmalst": "AR",
    "dropmalzpp": 721529998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707664107,
    "dropsitcph": 8707664107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21116",
    "droptype": "D",
    "dropname": "SHIRLEY",
    "dropdeladd": "239 SAM ST",
    "dropdelcty": "SHIRLEY",
    "dropdelst": "AR",
    "dropdelzpp": 721539998,
    "dropphyadd": "239 SAM ST",
    "dropphycty": "SHIRLEY",
    "dropphyst": "AR",
    "dropphyzpp": 721539998,
    "dropmaladd": "239 SAM ST",
    "dropmalcty": "SHIRLEY",
    "dropmalst": "AR",
    "dropmalzpp": 721539998,
    "dropsitphn": 5017234409,
    "dropsitlph": 5017234409,
    "dropsitcph": 5017234409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21118",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "308 ARKANSAS HIGHWAY 58",
    "dropdelcty": "SIDNEY",
    "dropdelst": "AR",
    "dropdelzpp": 725779998,
    "dropphyadd": "308 ARKANSAS HIGHWAY 58",
    "dropphycty": "SIDNEY",
    "dropphyst": "AR",
    "dropphyzpp": 725779998,
    "dropmaladd": "308 ARKANSAS HIGHWAY 58",
    "dropmalcty": "SIDNEY",
    "dropmalst": "AR",
    "dropmalzpp": 725779998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702835029,
    "dropsitcph": 8702835029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21120",
    "droptype": "D",
    "dropname": "SILOAM SPRINGS",
    "dropdeladd": "828 S CARL ST",
    "dropdelcty": "SILOAM SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 727619998,
    "dropphyadd": "828 S CARL ST",
    "dropphycty": "SILOAM SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 727619998,
    "dropmaladd": "828 S CARL ST",
    "dropmalcty": "SILOAM SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 727619998,
    "dropsitphn": 4795243431,
    "dropsitlph": 4795243431,
    "dropsitcph": 4795243431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21122",
    "droptype": "D",
    "dropname": "SIMS",
    "dropdeladd": "1465 HIGHWAY 298 W",
    "dropdelcty": "SIMS",
    "dropdelst": "AR",
    "dropdelzpp": 719699998,
    "dropphyadd": "1465 HIGHWAY 298 W",
    "dropphycty": "SIMS",
    "dropphyst": "AR",
    "dropphyzpp": 719699998,
    "dropmaladd": "1465 HIGHWAY 298 W",
    "dropmalcty": "SIMS",
    "dropmalst": "AR",
    "dropmalzpp": 719699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708673224,
    "dropsitcph": 8708673224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21125",
    "droptype": "D",
    "dropname": "SMACKOVER",
    "dropdeladd": "102 W 8TH ST",
    "dropdelcty": "SMACKOVER",
    "dropdelst": "AR",
    "dropdelzpp": 717629998,
    "dropphyadd": "102 W 8TH ST",
    "dropphycty": "SMACKOVER",
    "dropphyst": "AR",
    "dropphyzpp": 717629998,
    "dropmaladd": "102 W 8TH ST",
    "dropmalcty": "SMACKOVER",
    "dropmalst": "AR",
    "dropmalzpp": 717629998,
    "dropsitphn": 8707252262,
    "dropsitlph": 8707252262,
    "dropsitcph": 8707252262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21127",
    "droptype": "D",
    "dropname": "SMITHVILLE",
    "dropdeladd": "52 BRADLEY DR",
    "dropdelcty": "SMITHVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 724668554,
    "dropphyadd": "52 BRADLEY DR",
    "dropphycty": "SMITHVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 724668554,
    "dropmaladd": "52 BRADLEY DR",
    "dropmalcty": "SMITHVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 724668554,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705283952,
    "dropsitcph": 8705283952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21128",
    "droptype": "D",
    "dropname": "SNOW LAKE",
    "dropdeladd": "1586 S HIGHWAY 85",
    "dropdelcty": "SNOW LAKE",
    "dropdelst": "AR",
    "dropdelzpp": 723798800,
    "dropphyadd": "1586 S HIGHWAY 85",
    "dropphycty": "SNOW LAKE",
    "dropphyst": "AR",
    "dropphyzpp": 723798800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNOW LAKE",
    "dropmalst": "AR",
    "dropmalzpp": 723799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276662,
    "dropsitcph": 8708276662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21132",
    "droptype": "D",
    "dropname": "SOLGOHACHIA",
    "dropdeladd": "3142 HIGHWAY 9",
    "dropdelcty": "SOLGOHACHIA",
    "dropdelst": "AR",
    "dropdelzpp": 721569998,
    "dropphyadd": "3142 HIGHWAY 9",
    "dropphycty": "SOLGOHACHIA",
    "dropphyst": "AR",
    "dropphyzpp": 721569998,
    "dropmaladd": "3142 HIGHWAY 9",
    "dropmalcty": "SOLGOHACHIA",
    "dropmalst": "AR",
    "dropmalzpp": 721569998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013545040,
    "dropsitcph": 5013545040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21138",
    "droptype": "D",
    "dropname": "SPARKMAN",
    "dropdeladd": "204 N COMMERCE AVE",
    "dropdelcty": "SPARKMAN",
    "dropdelst": "AR",
    "dropdelzpp": 717639998,
    "dropphyadd": "204 N COMMERCE AVE",
    "dropphycty": "SPARKMAN",
    "dropphyst": "AR",
    "dropphyzpp": 717639998,
    "dropmaladd": "204 N COMMERCE AVE",
    "dropmalcty": "SPARKMAN",
    "dropmalst": "AR",
    "dropmalzpp": 717639998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706782611,
    "dropsitcph": 8706782611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21139",
    "droptype": "D",
    "dropname": "SPRINGDALE",
    "dropdeladd": "2811 SPRINGDALE AVE",
    "dropdelcty": "SPRINGDALE",
    "dropdelst": "AR",
    "dropdelzpp": 727649998,
    "dropphyadd": "2811 SPRINGDALE AVE",
    "dropphycty": "SPRINGDALE",
    "dropphyst": "AR",
    "dropphyzpp": 727649998,
    "dropmaladd": "2811 SPRINGDALE AVE",
    "dropmalcty": "SPRINGDALE",
    "dropmalst": "AR",
    "dropmalzpp": 727649998,
    "dropsitphn": 4798720609,
    "dropsitlph": 4797514441,
    "dropsitcph": 4797514441,
    "dropfax": 4797503216
  },
  {
    "dcode": "D",
    "dropkey": "PY21140",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "765 STAGECOACH RD",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "AR",
    "dropdelzpp": 721579998,
    "dropphyadd": "765 STAGECOACH RD",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "AR",
    "dropphyzpp": 721579998,
    "dropmaladd": "765 STAGECOACH RD",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "AR",
    "dropmalzpp": 721579998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013545950,
    "dropsitcph": 5013545950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21148",
    "droptype": "D",
    "dropname": "STAMPS",
    "dropdeladd": "110 THOMAS ST",
    "dropdelcty": "STAMPS",
    "dropdelst": "AR",
    "dropdelzpp": 718609998,
    "dropphyadd": "110 THOMAS ST",
    "dropphycty": "STAMPS",
    "dropphyst": "AR",
    "dropphyzpp": 718609998,
    "dropmaladd": "110 THOMAS ST",
    "dropmalcty": "STAMPS",
    "dropmalst": "AR",
    "dropmalzpp": 718609998,
    "dropsitphn": 8705332283,
    "dropsitlph": 8705332283,
    "dropsitcph": 8705332283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21149",
    "droptype": "D",
    "dropname": "STAR CITY",
    "dropdeladd": "205 S JEFFERSON ST",
    "dropdelcty": "STAR CITY",
    "dropdelst": "AR",
    "dropdelzpp": 716679998,
    "dropphyadd": "205 S JEFFERSON ST",
    "dropphycty": "STAR CITY",
    "dropphyst": "AR",
    "dropphyzpp": 716679998,
    "dropmaladd": "205 S JEFFERSON ST",
    "dropmalcty": "STAR CITY",
    "dropmalst": "AR",
    "dropmalzpp": 716679998,
    "dropsitphn": 8706283534,
    "dropsitlph": 8706283534,
    "dropsitcph": 8706283534,
    "dropfax": 8706284130
  },
  {
    "dcode": "D",
    "dropkey": "PY21155",
    "droptype": "D",
    "dropname": "STEPHENS",
    "dropdeladd": "202 W RUBY ST",
    "dropdelcty": "STEPHENS",
    "dropdelst": "AR",
    "dropdelzpp": 717649998,
    "dropphyadd": "202 W RUBY ST",
    "dropphycty": "STEPHENS",
    "dropphyst": "AR",
    "dropphyzpp": 717649998,
    "dropmaladd": "202 W RUBY ST",
    "dropmalcty": "STEPHENS",
    "dropmalst": "AR",
    "dropmalzpp": 717649998,
    "dropsitphn": 8707865116,
    "dropsitlph": 8707865116,
    "dropsitcph": 8707865116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21159",
    "droptype": "D",
    "dropname": "STORY",
    "dropdeladd": "5311 HIGHWAY 27 N",
    "dropdelcty": "STORY",
    "dropdelst": "AR",
    "dropdelzpp": 719709998,
    "dropphyadd": "5311 HIGHWAY 27 N",
    "dropphycty": "STORY",
    "dropphyst": "AR",
    "dropphyzpp": 719709998,
    "dropmaladd": "5311 HIGHWAY 27 N",
    "dropmalcty": "STORY",
    "dropmalst": "AR",
    "dropmalzpp": 719709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708672634,
    "dropsitcph": 8708672634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21160",
    "droptype": "D",
    "dropname": "STRAWBERRY",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "STRAWBERRY",
    "dropdelst": "AR",
    "dropdelzpp": 724699998,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "STRAWBERRY",
    "dropphyst": "AR",
    "dropphyzpp": 724699998,
    "dropmaladd": "100 N MAIN ST",
    "dropmalcty": "STRAWBERRY",
    "dropmalst": "AR",
    "dropmalzpp": 724699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705283315,
    "dropsitcph": 8705283315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21161",
    "droptype": "D",
    "dropname": "STRONG",
    "dropdeladd": "9559 STRONG HWY",
    "dropdelcty": "STRONG",
    "dropdelst": "AR",
    "dropdelzpp": 717659998,
    "dropphyadd": "9559 STRONG HWY",
    "dropphycty": "STRONG",
    "dropphyst": "AR",
    "dropphyzpp": 717659998,
    "dropmaladd": "9559 STRONG HWY",
    "dropmalcty": "STRONG",
    "dropmalst": "AR",
    "dropmalzpp": 717659998,
    "dropsitphn": 8707977321,
    "dropsitlph": 8707977321,
    "dropsitcph": 8707977321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21162",
    "droptype": "D",
    "dropname": "STURKIE",
    "dropdeladd": "5312 STURKIE RD",
    "dropdelcty": "STURKIE",
    "dropdelst": "AR",
    "dropdelzpp": 725789998,
    "dropphyadd": "5312 STURKIE RD",
    "dropphycty": "STURKIE",
    "dropphyst": "AR",
    "dropphyzpp": 725789998,
    "dropmaladd": "5312 STURKIE RD",
    "dropmalcty": "STURKIE",
    "dropmalst": "AR",
    "dropmalzpp": 725789998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708953400,
    "dropsitcph": 8708953400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21163",
    "droptype": "D",
    "dropname": "STUTTGART",
    "dropdeladd": "304 W MICHIGAN ST",
    "dropdelcty": "STUTTGART",
    "dropdelst": "AR",
    "dropdelzpp": 721609998,
    "dropphyadd": "304 W MICHIGAN ST",
    "dropphycty": "STUTTGART",
    "dropphyst": "AR",
    "dropphyzpp": 721609998,
    "dropmaladd": "304 W MICHIGAN ST",
    "dropmalcty": "STUTTGART",
    "dropmalst": "AR",
    "dropmalzpp": 721609998,
    "dropsitphn": 8706736059,
    "dropsitlph": 8706731406,
    "dropsitcph": 8706731406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21164",
    "droptype": "D",
    "dropname": "SUBIACO",
    "dropdeladd": "283 CONRAD ST",
    "dropdelcty": "SUBIACO",
    "dropdelst": "AR",
    "dropdelzpp": 728659998,
    "dropphyadd": "283 CONRAD ST",
    "dropphycty": "SUBIACO",
    "dropphyst": "AR",
    "dropphyzpp": 728659998,
    "dropmaladd": "283 CONRAD ST",
    "dropmalcty": "SUBIACO",
    "dropmalst": "AR",
    "dropmalzpp": 728659998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4799344242,
    "dropsitcph": 4799344242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21165",
    "droptype": "D",
    "dropname": "SUCCESS",
    "dropdeladd": "511 FRONT ST",
    "dropdelcty": "SUCCESS",
    "dropdelst": "AR",
    "dropdelzpp": 724709998,
    "dropphyadd": "511 FRONT ST",
    "dropphycty": "SUCCESS",
    "dropphyst": "AR",
    "dropphyzpp": 724709998,
    "dropmaladd": "511 FRONT ST",
    "dropmalcty": "SUCCESS",
    "dropmalst": "AR",
    "dropmalzpp": 724709998,
    "dropsitphn": 8702765071,
    "dropsitlph": 8702765071,
    "dropsitcph": 8702765071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21167",
    "droptype": "D",
    "dropname": "SULPHUR ROCK",
    "dropdeladd": "210 S MAIN ST",
    "dropdelcty": "SULPHUR ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 725799998,
    "dropphyadd": "210 S MAIN ST",
    "dropphycty": "SULPHUR ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 725799998,
    "dropmaladd": "210 S MAIN ST",
    "dropmalcty": "SULPHUR ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 725799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707998395,
    "dropsitcph": 8707998395,
    "dropfax": 8707998395
  },
  {
    "dcode": "D",
    "dropkey": "PY21168",
    "droptype": "D",
    "dropname": "SULPHUR SPRINGS",
    "dropdeladd": "205 S HIBLER ST",
    "dropdelcty": "SULPHUR SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 727689998,
    "dropphyadd": "205 S HIBLER ST",
    "dropphycty": "SULPHUR SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 727689998,
    "dropmaladd": "205 S HIBLER ST",
    "dropmalcty": "SULPHUR SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 727689998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792750323,
    "dropsitcph": 4792750323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21169",
    "droptype": "D",
    "dropname": "SUMMERS",
    "dropdeladd": "10591 S HIGHWAY 59",
    "dropdelcty": "SUMMERS",
    "dropdelst": "AR",
    "dropdelzpp": 727699998,
    "dropphyadd": "10591 S HIGHWAY 59",
    "dropphycty": "SUMMERS",
    "dropphyst": "AR",
    "dropphyzpp": 727699998,
    "dropmaladd": "10591 S HIGHWAY 59",
    "dropmalcty": "SUMMERS",
    "dropmalst": "AR",
    "dropmalzpp": 727699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4798243439,
    "dropsitcph": 4798243439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21170",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "112 S MAIN ST",
    "dropdelcty": "SUMMIT",
    "dropdelst": "AR",
    "dropdelzpp": 726779998,
    "dropphyadd": "112 S MAIN ST",
    "dropphycty": "SUMMIT",
    "dropphyst": "AR",
    "dropphyzpp": 726779998,
    "dropmaladd": "112 S MAIN ST",
    "dropmalcty": "SUMMIT",
    "dropmalst": "AR",
    "dropmalzpp": 726779998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704496088,
    "dropsitcph": 8704496088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21176",
    "droptype": "D",
    "dropname": "SWEET HOME",
    "dropdeladd": "7010 HIGHWAY 365 S",
    "dropdelcty": "SWEET HOME",
    "dropdelst": "AR",
    "dropdelzpp": 721649998,
    "dropphyadd": "7010 HIGHWAY 365 S",
    "dropphycty": "SWEET HOME",
    "dropphyst": "AR",
    "dropphyzpp": 721649998,
    "dropmaladd": "7010 HIGHWAY 365 S",
    "dropmalcty": "SWEET HOME",
    "dropmalst": "AR",
    "dropmalzpp": 721649998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5014901126,
    "dropsitcph": 5014901086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21177",
    "droptype": "D",
    "dropname": "SWIFTON",
    "dropdeladd": "109 MAIN ST",
    "dropdelcty": "SWIFTON",
    "dropdelst": "AR",
    "dropdelzpp": 724719998,
    "dropphyadd": "109 MAIN ST",
    "dropphycty": "SWIFTON",
    "dropphyst": "AR",
    "dropphyzpp": 724719998,
    "dropmaladd": "109 MAIN ST",
    "dropmalcty": "SWIFTON",
    "dropmalst": "AR",
    "dropmalzpp": 724719998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704852627,
    "dropsitcph": 8704852627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21184",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "109 LONG ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "AR",
    "dropdelzpp": 718619998,
    "dropphyadd": "109 LONG ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "AR",
    "dropphyzpp": 718619998,
    "dropmaladd": "109 LONG ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "AR",
    "dropmalzpp": 718619998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706942811,
    "dropsitcph": 8706942811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21187",
    "droptype": "D",
    "dropname": "THIDA",
    "dropdeladd": "999 THIDA RD",
    "dropdelcty": "THIDA",
    "dropdelst": "AR",
    "dropdelzpp": 721659998,
    "dropphyadd": "999 THIDA RD",
    "dropphycty": "THIDA",
    "dropphyst": "AR",
    "dropphyzpp": 721659998,
    "dropmaladd": "999 THIDA RD",
    "dropmalcty": "THIDA",
    "dropmalst": "AR",
    "dropmalzpp": 721659998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702642033,
    "dropsitcph": 8702642033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21189",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "917 S 1ST ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "AR",
    "dropdelzpp": 717669998,
    "dropphyadd": "917 S 1ST ST",
    "dropphycty": "THORNTON",
    "dropphyst": "AR",
    "dropphyzpp": 717669998,
    "dropmaladd": "917 S 1ST ST",
    "dropmalcty": "THORNTON",
    "dropmalst": "AR",
    "dropmalzpp": 717669998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703523120,
    "dropsitcph": 8703523120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21190",
    "droptype": "D",
    "dropname": "TICHNOR",
    "dropdeladd": "1002 HIGHWAY 44",
    "dropdelcty": "TICHNOR",
    "dropdelst": "AR",
    "dropdelzpp": 721669998,
    "dropphyadd": "1002 HIGHWAY 44",
    "dropphycty": "TICHNOR",
    "dropphyst": "AR",
    "dropphyzpp": 721669998,
    "dropmaladd": "1002 HIGHWAY 44",
    "dropmalcty": "TICHNOR",
    "dropmalst": "AR",
    "dropmalzpp": 721669998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705482888,
    "dropsitcph": 8705482888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21191",
    "droptype": "D",
    "dropname": "TILLAR",
    "dropdeladd": "166 B ST",
    "dropdelcty": "TILLAR",
    "dropdelst": "AR",
    "dropdelzpp": 716709998,
    "dropphyadd": "166 B ST",
    "dropphycty": "TILLAR",
    "dropphyst": "AR",
    "dropphyzpp": 716709998,
    "dropmaladd": "166 B ST",
    "dropmalcty": "TILLAR",
    "dropmalst": "AR",
    "dropmalzpp": 716709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703922561,
    "dropsitcph": 8703922561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21192",
    "droptype": "D",
    "dropname": "TILLY",
    "dropdeladd": "36386 HIGHWAY 27",
    "dropdelcty": "TILLY",
    "dropdelst": "AR",
    "dropdelzpp": 726799998,
    "dropphyadd": "36386 HIGHWAY 27",
    "dropphycty": "TILLY",
    "dropphyst": "AR",
    "dropphyzpp": 726799998,
    "dropmaladd": "36386 HIGHWAY 27",
    "dropmalcty": "TILLY",
    "dropmalst": "AR",
    "dropmalzpp": 726799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704962716,
    "dropsitcph": 8704962716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21193",
    "droptype": "D",
    "dropname": "TIMBO",
    "dropdeladd": "7127 HIGHWAY 66",
    "dropdelcty": "TIMBO",
    "dropdelst": "AR",
    "dropdelzpp": 726809998,
    "dropphyadd": "7127 HIGHWAY 66",
    "dropphycty": "TIMBO",
    "dropphyst": "AR",
    "dropphyzpp": 726809998,
    "dropmaladd": "7127 HIGHWAY 66",
    "dropmalcty": "TIMBO",
    "dropmalst": "AR",
    "dropmalzpp": 726809998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707464253,
    "dropsitcph": 8707464253,
    "dropfax": 8707464253
  },
  {
    "dcode": "D",
    "dropkey": "PY21203",
    "droptype": "D",
    "dropname": "TONTITOWN",
    "dropdeladd": "246 N BARRINGTON RD",
    "dropdelcty": "TONTITOWN",
    "dropdelst": "AR",
    "dropdelzpp": 727708800,
    "dropphyadd": "246 N BARRINGTON RD",
    "dropphycty": "TONTITOWN",
    "dropphyst": "AR",
    "dropphyzpp": 727708800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONTITOWN",
    "dropmalst": "AR",
    "dropmalzpp": 727709998,
    "dropsitphn": 4793612386,
    "dropsitlph": 4793612386,
    "dropsitcph": 4793612386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21204",
    "droptype": "D",
    "dropname": "TRASKWOOD",
    "dropdeladd": "8108 HIGHWAY 229",
    "dropdelcty": "TRASKWOOD",
    "dropdelst": "AR",
    "dropdelzpp": 721679998,
    "dropphyadd": "8108 HIGHWAY 229",
    "dropphycty": "TRASKWOOD",
    "dropphyst": "AR",
    "dropphyzpp": 721679998,
    "dropmaladd": "8108 HIGHWAY 229",
    "dropmalcty": "TRASKWOOD",
    "dropmalst": "AR",
    "dropmalzpp": 721679998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017789529,
    "dropsitcph": 5017789529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21206",
    "droptype": "D",
    "dropname": "TRUMANN",
    "dropdeladd": "301 HIGHWAY 463 S",
    "dropdelcty": "TRUMANN",
    "dropdelst": "AR",
    "dropdelzpp": 724729998,
    "dropphyadd": "301 HIGHWAY 463 S",
    "dropphycty": "TRUMANN",
    "dropphyst": "AR",
    "dropphyzpp": 724729998,
    "dropmaladd": "301 HIGHWAY 463 S",
    "dropmalcty": "TRUMANN",
    "dropmalst": "AR",
    "dropmalzpp": 724729998,
    "dropsitphn": 8704835911,
    "dropsitlph": 8704835911,
    "dropsitcph": 8704835911,
    "dropfax": 8704835718
  },
  {
    "dcode": "D",
    "dropkey": "PY21207",
    "droptype": "D",
    "dropname": "TUCKER",
    "dropdeladd": "100 JOE T HENSLEE RD",
    "dropdelcty": "TUCKER",
    "dropdelst": "AR",
    "dropdelzpp": 721689998,
    "dropphyadd": "100 JOE T HENSLEE RD",
    "dropphycty": "TUCKER",
    "dropphyst": "AR",
    "dropphyzpp": 721689998,
    "dropmaladd": "100 JOE T HENSLEE RD",
    "dropmalcty": "TUCKER",
    "dropmalst": "AR",
    "dropmalzpp": 721689998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5018422806,
    "dropsitcph": 5018422806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21208",
    "droptype": "D",
    "dropname": "TUCKERMAN",
    "dropdeladd": "105 E WALNUT ST",
    "dropdelcty": "TUCKERMAN",
    "dropdelst": "AR",
    "dropdelzpp": 724739998,
    "dropphyadd": "105 E WALNUT ST",
    "dropphycty": "TUCKERMAN",
    "dropphyst": "AR",
    "dropphyzpp": 724739998,
    "dropmaladd": "105 E WALNUT ST",
    "dropmalcty": "TUCKERMAN",
    "dropmalst": "AR",
    "dropmalzpp": 724739998,
    "dropsitphn": 8703495467,
    "dropsitlph": 8703495467,
    "dropsitcph": 8703495467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21211",
    "droptype": "D",
    "dropname": "TUMBLING SHOALS",
    "dropdeladd": "2395 HEBER SPRINGS RD N",
    "dropdelcty": "TUMBLING SHOALS",
    "dropdelst": "AR",
    "dropdelzpp": 725819998,
    "dropphyadd": "2395 HEBER SPRINGS RD N",
    "dropphycty": "TUMBLING SHOALS",
    "dropphyst": "AR",
    "dropphyzpp": 725819998,
    "dropmaladd": "2395 HEBER SPRINGS RD N",
    "dropmalcty": "TUMBLING SHOALS",
    "dropmalst": "AR",
    "dropmalzpp": 725819998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013626500,
    "dropsitcph": 5013626500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21212",
    "droptype": "D",
    "dropname": "TUPELO",
    "dropdeladd": "11220 HIGHWAY 17",
    "dropdelcty": "TUPELO",
    "dropdelst": "AR",
    "dropdelzpp": 721699998,
    "dropphyadd": "11220 HIGHWAY 17",
    "dropphycty": "TUPELO",
    "dropphyst": "AR",
    "dropphyzpp": 721699998,
    "dropmaladd": "11220 HIGHWAY 17",
    "dropmalcty": "TUPELO",
    "dropmalst": "AR",
    "dropmalzpp": 721699998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707443301,
    "dropsitcph": 8707443301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21213",
    "droptype": "D",
    "dropname": "TURNER",
    "dropdeladd": "8176 HIGHWAY 39",
    "dropdelcty": "TURNER",
    "dropdelst": "AR",
    "dropdelzpp": 723839998,
    "dropphyadd": "8176 HIGHWAY 39",
    "dropphycty": "TURNER",
    "dropphyst": "AR",
    "dropphyzpp": 723839998,
    "dropmaladd": "8176 HIGHWAY 39",
    "dropmalcty": "TURNER",
    "dropmalst": "AR",
    "dropmalzpp": 723839998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708293706,
    "dropsitcph": 8708293706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21214",
    "droptype": "D",
    "dropname": "TURRELL",
    "dropdeladd": "237 BARTON ST",
    "dropdelcty": "TURRELL",
    "dropdelst": "AR",
    "dropdelzpp": 723849998,
    "dropphyadd": "237 BARTON ST",
    "dropphycty": "TURRELL",
    "dropphyst": "AR",
    "dropphyzpp": 723849998,
    "dropmaladd": "237 BARTON ST",
    "dropmalcty": "TURRELL",
    "dropmalst": "AR",
    "dropmalzpp": 723849998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703432447,
    "dropsitcph": 8703432447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21218",
    "droptype": "D",
    "dropname": "TYRONZA",
    "dropdeladd": "329 S MAIN ST",
    "dropdelcty": "TYRONZA",
    "dropdelst": "AR",
    "dropdelzpp": 723869998,
    "dropphyadd": "329 S MAIN ST",
    "dropphycty": "TYRONZA",
    "dropphyst": "AR",
    "dropphyzpp": 723869998,
    "dropmaladd": "329 S MAIN ST",
    "dropmalcty": "TYRONZA",
    "dropmalst": "AR",
    "dropmalzpp": 723869998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704872246,
    "dropsitcph": 8704872246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21221",
    "droptype": "D",
    "dropname": "ULM",
    "dropdeladd": "127 W 2ND ST",
    "dropdelcty": "ULM",
    "dropdelst": "AR",
    "dropdelzpp": 721709998,
    "dropphyadd": "127 W 2ND ST",
    "dropphycty": "ULM",
    "dropphyst": "AR",
    "dropphyzpp": 721709998,
    "dropmaladd": "127 W 2ND ST",
    "dropmalcty": "ULM",
    "dropmalst": "AR",
    "dropmalzpp": 721709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702413251,
    "dropsitcph": 8702413251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21222",
    "droptype": "D",
    "dropname": "UMPIRE",
    "dropdeladd": "142 HIGHWAY 84 E",
    "dropdelcty": "UMPIRE",
    "dropdelst": "AR",
    "dropdelzpp": 719719998,
    "dropphyadd": "142 HIGHWAY 84 E",
    "dropphycty": "UMPIRE",
    "dropphyst": "AR",
    "dropphyzpp": 719719998,
    "dropmaladd": "142 HIGHWAY 84 E",
    "dropmalcty": "UMPIRE",
    "dropmalst": "AR",
    "dropmalzpp": 719719998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705836276,
    "dropsitcph": 8705836276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21223",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "9929 UNIONTOWN HWY",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "AR",
    "dropdelzpp": 729559998,
    "dropphyadd": "9929 UNIONTOWN HWY",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "AR",
    "dropphyzpp": 729559998,
    "dropmaladd": "9929 UNIONTOWN HWY",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "AR",
    "dropmalzpp": 729559998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794745689,
    "dropsitcph": 4794745689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21235",
    "droptype": "D",
    "dropname": "VALLEY SPRINGS",
    "dropdeladd": "7729 HIGHWAY 65 S",
    "dropdelcty": "VALLEY SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 726829998,
    "dropphyadd": "7729 HIGHWAY 65 S",
    "dropphycty": "VALLEY SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 726829998,
    "dropmaladd": "7729 HIGHWAY 65 S",
    "dropmalcty": "VALLEY SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 726829998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704296379,
    "dropsitcph": 8704296379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21236",
    "droptype": "D",
    "dropname": "VAN BUREN",
    "dropdeladd": "2741 FAYETTEVILLE RD",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "AR",
    "dropdelzpp": 729569998,
    "dropphyadd": "2741 FAYETTEVILLE RD",
    "dropphycty": "VAN BUREN",
    "dropphyst": "AR",
    "dropphyzpp": 729569998,
    "dropmaladd": "2741 FAYETTEVILLE RD",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "AR",
    "dropmalzpp": 729569998,
    "dropsitphn": 4794710281,
    "dropsitlph": 4794710281,
    "dropsitcph": 4794710281,
    "dropfax": 4794717303
  },
  {
    "dcode": "D",
    "dropkey": "PY21237",
    "droptype": "D",
    "dropname": "VANDERVOORT",
    "dropdeladd": "107 N HORNBECK AVE",
    "dropdelcty": "VANDERVOORT",
    "dropdelst": "AR",
    "dropdelzpp": 719729998,
    "dropphyadd": "107 N HORNBECK AVE",
    "dropphycty": "VANDERVOORT",
    "dropphyst": "AR",
    "dropphyzpp": 719729998,
    "dropmaladd": "107 N HORNBECK AVE",
    "dropmalcty": "VANDERVOORT",
    "dropmalst": "AR",
    "dropmalzpp": 719729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703872535,
    "dropsitcph": 8703872535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21239",
    "droptype": "D",
    "dropname": "VANNDALE",
    "dropdeladd": "2905 HIGHWAY 1B",
    "dropdelcty": "VANNDALE",
    "dropdelst": "AR",
    "dropdelzpp": 723879998,
    "dropphyadd": "2905 HIGHWAY 1B",
    "dropphycty": "VANNDALE",
    "dropphyst": "AR",
    "dropphyzpp": 723879998,
    "dropmaladd": "2905 HIGHWAY 1B",
    "dropmalcty": "VANNDALE",
    "dropmalst": "AR",
    "dropmalzpp": 723879998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702388951,
    "dropsitcph": 8702388951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21240",
    "droptype": "D",
    "dropname": "VENDOR",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "VENDOR",
    "dropdelst": "AR",
    "dropdelzpp": 726839998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "VENDOR",
    "dropphyst": "AR",
    "dropphyzpp": 726839998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "VENDOR",
    "dropmalst": "AR",
    "dropmalzpp": 726839998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704345346,
    "dropsitcph": 8704345346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21248",
    "droptype": "D",
    "dropname": "VILONIA",
    "dropdeladd": "8 S CHURCH ST",
    "dropdelcty": "VILONIA",
    "dropdelst": "AR",
    "dropdelzpp": 721739998,
    "dropphyadd": "8 S CHURCH ST",
    "dropphycty": "VILONIA",
    "dropphyst": "AR",
    "dropphyzpp": 721739998,
    "dropmaladd": "8 S CHURCH ST",
    "dropmalcty": "VILONIA",
    "dropmalst": "AR",
    "dropmalzpp": 721739998,
    "dropsitphn": 5016908854,
    "dropsitlph": 5017963331,
    "dropsitcph": 5017963331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21249",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "9971 HIGHWAY 62 W",
    "dropdelcty": "VIOLA",
    "dropdelst": "AR",
    "dropdelzpp": 725839998,
    "dropphyadd": "9971 HIGHWAY 62 W",
    "dropphycty": "VIOLA",
    "dropphyst": "AR",
    "dropphyzpp": 725839998,
    "dropmaladd": "9971 HIGHWAY 62 W",
    "dropmalcty": "VIOLA",
    "dropmalst": "AR",
    "dropmalzpp": 725839998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8702918059,
    "dropsitcph": 8702918059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21250",
    "droptype": "D",
    "dropname": "VIOLET HILL",
    "dropdeladd": "100 W HIGHWAY 56",
    "dropdelcty": "VIOLET HILL",
    "dropdelst": "AR",
    "dropdelzpp": 725848800,
    "dropphyadd": "100 W HIGHWAY 56",
    "dropphycty": "VIOLET HILL",
    "dropphyst": "AR",
    "dropphyzpp": 725848800,
    "dropmaladd": "100 W HIGHWAY 56",
    "dropmalcty": "VIOLET HILL",
    "dropmalst": "AR",
    "dropmalzpp": 725848800,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703228110,
    "dropsitcph": 8703228110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21252",
    "droptype": "D",
    "dropname": "WABASH",
    "dropdeladd": "17114 HIGHWAY 44",
    "dropdelcty": "WABASH",
    "dropdelst": "AR",
    "dropdelzpp": 723899998,
    "dropphyadd": "17114 HIGHWAY 44",
    "dropphycty": "WABASH",
    "dropphyst": "AR",
    "dropphyzpp": 723899998,
    "dropmaladd": "17114 HIGHWAY 44",
    "dropmalcty": "WABASH",
    "dropmalst": "AR",
    "dropmalzpp": 723899998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708276374,
    "dropsitcph": 8708276374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21253",
    "droptype": "D",
    "dropname": "WABBASEKA",
    "dropdeladd": "210 S 1ST ST",
    "dropdelcty": "WABBASEKA",
    "dropdelst": "AR",
    "dropdelzpp": 721759998,
    "dropphyadd": "210 S 1ST ST",
    "dropphycty": "WABBASEKA",
    "dropphyst": "AR",
    "dropphyzpp": 721759998,
    "dropmaladd": "210 S 1ST ST",
    "dropmalcty": "WABBASEKA",
    "dropmalst": "AR",
    "dropmalzpp": 721759998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8707664102,
    "dropsitcph": 8707664102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21255",
    "droptype": "D",
    "dropname": "WALCOTT",
    "dropdeladd": "1951 HIGHWAY 141 S",
    "dropdelcty": "WALCOTT",
    "dropdelst": "AR",
    "dropdelzpp": 724749998,
    "dropphyadd": "1951 HIGHWAY 141 S",
    "dropphycty": "WALCOTT",
    "dropphyst": "AR",
    "dropphyzpp": 724749998,
    "dropmaladd": "1951 HIGHWAY 141 S",
    "dropmalcty": "WALCOTT",
    "dropmalst": "AR",
    "dropmalzpp": 724749998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705736936,
    "dropsitcph": 8705736936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21256",
    "droptype": "D",
    "dropname": "WALDENBURG",
    "dropdeladd": "5953 HIGHWAY 14 E",
    "dropdelcty": "WALDENBURG",
    "dropdelst": "AR",
    "dropdelzpp": 724759998,
    "dropphyadd": "5953 HIGHWAY 14 E",
    "dropphycty": "WALDENBURG",
    "dropphyst": "AR",
    "dropphyzpp": 724759998,
    "dropmaladd": "5953 HIGHWAY 14 E",
    "dropmalcty": "WALDENBURG",
    "dropmalst": "AR",
    "dropmalzpp": 724759998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705792213,
    "dropsitcph": 8705792213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21257",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "306 E MCKISSACK ST",
    "dropdelcty": "WALDO",
    "dropdelst": "AR",
    "dropdelzpp": 717709998,
    "dropphyadd": "306 E MCKISSACK ST",
    "dropphycty": "WALDO",
    "dropphyst": "AR",
    "dropphyzpp": 717709998,
    "dropmaladd": "306 E MCKISSACK ST",
    "dropmalcty": "WALDO",
    "dropmalst": "AR",
    "dropmalzpp": 717709998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706935271,
    "dropsitcph": 8706935271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21258",
    "droptype": "D",
    "dropname": "WALDRON",
    "dropdeladd": "368 WASHINGTON ST",
    "dropdelcty": "WALDRON",
    "dropdelst": "AR",
    "dropdelzpp": 729589998,
    "dropphyadd": "368 WASHINGTON ST",
    "dropphycty": "WALDRON",
    "dropphyst": "AR",
    "dropphyzpp": 729589998,
    "dropmaladd": "368 WASHINGTON ST",
    "dropmalcty": "WALDRON",
    "dropmalst": "AR",
    "dropmalzpp": 729589998,
    "dropsitphn": 4796373287,
    "dropsitlph": 4796373287,
    "dropsitcph": 4796373287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21261",
    "droptype": "D",
    "dropname": "WALNUT RIDGE",
    "dropdeladd": "210 SW 3RD ST",
    "dropdelcty": "WALNUT RIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 724769998,
    "dropphyadd": "210 SW 3RD ST",
    "dropphycty": "WALNUT RIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 724769998,
    "dropmaladd": "210 SW 3RD ST",
    "dropmalcty": "WALNUT RIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 724769998,
    "dropsitphn": 8708862581,
    "dropsitlph": 8708862581,
    "dropsitcph": 8708862581,
    "dropfax": 8708865037
  },
  {
    "dcode": "D",
    "dropkey": "PY21263",
    "droptype": "D",
    "dropname": "WARD",
    "dropdeladd": "106 BALDING RD",
    "dropdelcty": "WARD",
    "dropdelst": "AR",
    "dropdelzpp": 721769998,
    "dropphyadd": "106 BALDING RD",
    "dropphycty": "WARD",
    "dropphyst": "AR",
    "dropphyzpp": 721769998,
    "dropmaladd": "106 BALDING RD",
    "dropmalcty": "WARD",
    "dropmalst": "AR",
    "dropmalzpp": 721769998,
    "dropsitphn": 5019415287,
    "dropsitlph": 5019413946,
    "dropsitcph": 5019413946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21265",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "408 N MAIN ST",
    "dropdelcty": "WARREN",
    "dropdelst": "AR",
    "dropdelzpp": 716719998,
    "dropphyadd": "408 N MAIN ST",
    "dropphycty": "WARREN",
    "dropphyst": "AR",
    "dropphyzpp": 716719998,
    "dropmaladd": "408 N MAIN ST",
    "dropmalcty": "WARREN",
    "dropmalst": "AR",
    "dropmalzpp": 716719998,
    "dropsitphn": 8702263311,
    "dropsitlph": 8702263311,
    "dropsitcph": 8702263311,
    "dropfax": 8704666249
  },
  {
    "dcode": "D",
    "dropkey": "PY21266",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "211 FRANKLIN ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "AR",
    "dropdelzpp": 718629998,
    "dropphyadd": "211 FRANKLIN ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "AR",
    "dropphyzpp": 718629998,
    "dropmaladd": "211 FRANKLIN ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "AR",
    "dropmalzpp": 718629998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709832440,
    "dropsitcph": 8709832440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21268",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "4121 HIGHWAY 1 N",
    "dropdelcty": "WATSON",
    "dropdelst": "AR",
    "dropdelzpp": 716749998,
    "dropphyadd": "4121 HIGHWAY 1 N",
    "dropphycty": "WATSON",
    "dropphyst": "AR",
    "dropphyzpp": 716749998,
    "dropmaladd": "4121 HIGHWAY 1 N",
    "dropmalcty": "WATSON",
    "dropmalst": "AR",
    "dropmalzpp": 716749998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706443890,
    "dropsitcph": 8706443890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21275",
    "droptype": "D",
    "dropname": "WEINER",
    "dropdeladd": "117 W SECOND ST",
    "dropdelcty": "WEINER",
    "dropdelst": "AR",
    "dropdelzpp": 724799998,
    "dropphyadd": "117 W SECOND ST",
    "dropphycty": "WEINER",
    "dropphyst": "AR",
    "dropphyzpp": 724799998,
    "dropmaladd": "117 W SECOND ST",
    "dropmalcty": "WEINER",
    "dropmalst": "AR",
    "dropmalzpp": 724799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706842238,
    "dropsitcph": 8706842238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21276",
    "droptype": "D",
    "dropname": "WESLEY",
    "dropdeladd": "1611 HIGHWAY 74",
    "dropdelcty": "WESLEY",
    "dropdelst": "AR",
    "dropdelzpp": 727739998,
    "dropphyadd": "1611 HIGHWAY 74",
    "dropphycty": "WESLEY",
    "dropphyst": "AR",
    "dropphyzpp": 727739998,
    "dropmaladd": "1611 HIGHWAY 74",
    "dropmalcty": "WESLEY",
    "dropmalst": "AR",
    "dropmalzpp": 727739998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4794562686,
    "dropsitcph": 4794562686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21280",
    "droptype": "D",
    "dropname": "WEST FORK",
    "dropdeladd": "207 WEBBER ST",
    "dropdelcty": "WEST FORK",
    "dropdelst": "AR",
    "dropdelzpp": 727749998,
    "dropphyadd": "207 WEBBER ST",
    "dropphycty": "WEST FORK",
    "dropphyst": "AR",
    "dropphyzpp": 727749998,
    "dropmaladd": "207 WEBBER ST",
    "dropmalcty": "WEST FORK",
    "dropmalst": "AR",
    "dropmalzpp": 727749998,
    "dropsitphn": 4798393101,
    "dropsitlph": 4798393101,
    "dropsitcph": 4798393101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21282",
    "droptype": "D",
    "dropname": "WEST HELENA",
    "dropdeladd": "221 N SEBASTIAN",
    "dropdelcty": "WEST HELENA",
    "dropdelst": "AR",
    "dropdelzpp": 723909998,
    "dropphyadd": "221 N SEBASTIAN",
    "dropphycty": "WEST HELENA",
    "dropphyst": "AR",
    "dropphyzpp": 723909998,
    "dropmaladd": "221 N SEBASTIAN",
    "dropmalcty": "WEST HELENA",
    "dropmalst": "AR",
    "dropmalzpp": 723909998,
    "dropsitphn": 8705727711,
    "dropsitlph": 8705727711,
    "dropsitcph": 8705727711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21285",
    "droptype": "D",
    "dropname": "WEST MEMPHIS",
    "dropdeladd": "615 E COOPER AVE",
    "dropdelcty": "WEST MEMPHIS",
    "dropdelst": "AR",
    "dropdelzpp": 723019998,
    "dropphyadd": "615 E COOPER AVE",
    "dropphycty": "WEST MEMPHIS",
    "dropphyst": "AR",
    "dropphyzpp": 723019998,
    "dropmaladd": "615 E COOPER AVE",
    "dropmalcty": "WEST MEMPHIS",
    "dropmalst": "AR",
    "dropmalzpp": 723019998,
    "dropsitphn": 8707323000,
    "dropsitlph": 8707350854,
    "dropsitcph": 8707354139,
    "dropfax": 8707354000
  },
  {
    "dcode": "D",
    "dropkey": "PY21286",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "112 BROAD ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "AR",
    "dropdelzpp": 721789998,
    "dropphyadd": "112 BROAD ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "AR",
    "dropphyzpp": 721789998,
    "dropmaladd": "112 BROAD ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "AR",
    "dropmalzpp": 721789998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5017423756,
    "dropsitcph": 5017423756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21287",
    "droptype": "D",
    "dropname": "WEST RIDGE",
    "dropdeladd": "5204 W STATE HIGHWAY 140",
    "dropdelcty": "WEST RIDGE",
    "dropdelst": "AR",
    "dropdelzpp": 723919998,
    "dropphyadd": "5204 W STATE HIGHWAY 140",
    "dropphycty": "WEST RIDGE",
    "dropphyst": "AR",
    "dropphyzpp": 723919998,
    "dropmaladd": "5204 W STATE HIGHWAY 140",
    "dropmalcty": "WEST RIDGE",
    "dropmalst": "AR",
    "dropmalzpp": 723919998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8705312221,
    "dropsitcph": 8705312221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21289",
    "droptype": "D",
    "dropname": "WESTERN GROVE",
    "dropdeladd": "101 HIGHWAY 65",
    "dropdelcty": "WESTERN GROVE",
    "dropdelst": "AR",
    "dropdelzpp": 726859998,
    "dropphyadd": "101 HIGHWAY 65",
    "dropphycty": "WESTERN GROVE",
    "dropphyst": "AR",
    "dropphyzpp": 726859998,
    "dropmaladd": "101 HIGHWAY 65",
    "dropmalcty": "WESTERN GROVE",
    "dropmalst": "AR",
    "dropmalzpp": 726859998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704296198,
    "dropsitcph": 8704296198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21291",
    "droptype": "D",
    "dropname": "WHEATLEY",
    "dropdeladd": "100 LITTLE ROCK ST",
    "dropdelcty": "WHEATLEY",
    "dropdelst": "AR",
    "dropdelzpp": 723929998,
    "dropphyadd": "100 LITTLE ROCK ST",
    "dropphycty": "WHEATLEY",
    "dropphyst": "AR",
    "dropphyzpp": 723929998,
    "dropmaladd": "100 LITTLE ROCK ST",
    "dropmalcty": "WHEATLEY",
    "dropmalst": "AR",
    "dropmalzpp": 723929998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704573811,
    "dropsitcph": 8704573811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21293",
    "droptype": "D",
    "dropname": "WHELEN SPRINGS",
    "dropdeladd": "306 E MAIN ST",
    "dropdelcty": "WHELEN SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 717729998,
    "dropphyadd": "306 E MAIN ST",
    "dropphycty": "WHELEN SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 717729998,
    "dropmaladd": "306 E MAIN ST",
    "dropmalcty": "WHELEN SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 717729998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703536542,
    "dropsitcph": 8703536542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21299",
    "droptype": "D",
    "dropname": "WICKES",
    "dropdeladd": "7631 HIGHWAY 71 S",
    "dropdelcty": "WICKES",
    "dropdelst": "AR",
    "dropdelzpp": 719739998,
    "dropphyadd": "7631 HIGHWAY 71 S",
    "dropphycty": "WICKES",
    "dropphyst": "AR",
    "dropphyzpp": 719739998,
    "dropmaladd": "7631 HIGHWAY 71 S",
    "dropmalcty": "WICKES",
    "dropmalst": "AR",
    "dropmalzpp": 719739998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703852381,
    "dropsitcph": 8703852381,
    "dropfax": 8703857841
  },
  {
    "dcode": "D",
    "dropkey": "PY21301",
    "droptype": "D",
    "dropname": "WIDENER",
    "dropdeladd": "100 THIRD ST",
    "dropdelcty": "WIDENER",
    "dropdelst": "AR",
    "dropdelzpp": 723949998,
    "dropphyadd": "100 THIRD ST",
    "dropphycty": "WIDENER",
    "dropphyst": "AR",
    "dropphyzpp": 723949998,
    "dropmaladd": "100 THIRD ST",
    "dropmalcty": "WIDENER",
    "dropmalst": "AR",
    "dropmalzpp": 723949998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706335305,
    "dropsitcph": 8706335305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21303",
    "droptype": "D",
    "dropname": "WILBURN",
    "dropdeladd": "4605 WILBURN RD",
    "dropdelcty": "WILBURN",
    "dropdelst": "AR",
    "dropdelzpp": 721799998,
    "dropphyadd": "4605 WILBURN RD",
    "dropphycty": "WILBURN",
    "dropphyst": "AR",
    "dropphyzpp": 721799998,
    "dropmaladd": "4605 WILBURN RD",
    "dropmalcty": "WILBURN",
    "dropmalst": "AR",
    "dropmalzpp": 721799998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013625440,
    "dropsitcph": 5013625440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21305",
    "droptype": "D",
    "dropname": "WILLIFORD",
    "dropdeladd": "305 W MAIN ST",
    "dropdelcty": "WILLIFORD",
    "dropdelst": "AR",
    "dropdelzpp": 724829998,
    "dropphyadd": "305 W MAIN ST",
    "dropphycty": "WILLIFORD",
    "dropphyst": "AR",
    "dropphyzpp": 724829998,
    "dropmaladd": "305 W MAIN ST",
    "dropmalcty": "WILLIFORD",
    "dropmalst": "AR",
    "dropmalzpp": 724829998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709664313,
    "dropsitcph": 8709664313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21306",
    "droptype": "D",
    "dropname": "WILLISVILLE",
    "dropdeladd": "102 NEVADA 8",
    "dropdelcty": "WILLISVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 718649998,
    "dropphyadd": "102 NEVADA 8",
    "dropphycty": "WILLISVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 718649998,
    "dropmaladd": "102 NEVADA 8",
    "dropmalcty": "WILLISVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 718649998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8708712253,
    "dropsitcph": 8708712253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21308",
    "droptype": "D",
    "dropname": "WILMAR",
    "dropdeladd": "2617 HIGHWAY 278 W",
    "dropdelcty": "WILMAR",
    "dropdelst": "AR",
    "dropdelzpp": 716759998,
    "dropphyadd": "2617 HIGHWAY 278 W",
    "dropphycty": "WILMAR",
    "dropphyst": "AR",
    "dropphyzpp": 716759998,
    "dropmaladd": "2617 HIGHWAY 278 W",
    "dropmalcty": "WILMAR",
    "dropmalst": "AR",
    "dropmalzpp": 716759998,
    "dropsitphn": 8704695466,
    "dropsitlph": 8704695466,
    "dropsitcph": 8704695466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21309",
    "droptype": "D",
    "dropname": "WILMOT",
    "dropdeladd": "202 MCCOMBS ST",
    "dropdelcty": "WILMOT",
    "dropdelst": "AR",
    "dropdelzpp": 716769998,
    "dropphyadd": "202 MCCOMBS ST",
    "dropphycty": "WILMOT",
    "dropphyst": "AR",
    "dropphyzpp": 716769998,
    "dropmaladd": "202 MCCOMBS ST",
    "dropmalcty": "WILMOT",
    "dropmalst": "AR",
    "dropmalzpp": 716769998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704732878,
    "dropsitcph": 8704732878,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21310",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "3 PARK ST",
    "dropdelcty": "WILSON",
    "dropdelst": "AR",
    "dropdelzpp": 723959998,
    "dropphyadd": "3 PARK ST",
    "dropphycty": "WILSON",
    "dropphyst": "AR",
    "dropphyzpp": 723959998,
    "dropmaladd": "3 PARK ST",
    "dropmalcty": "WILSON",
    "dropmalst": "AR",
    "dropmalzpp": 723959998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706558418,
    "dropsitcph": 8706558418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21311",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "322 E DOUGLAS AVE",
    "dropdelcty": "WILTON",
    "dropdelst": "AR",
    "dropdelzpp": 718659998,
    "dropphyadd": "322 E DOUGLAS AVE",
    "dropphycty": "WILTON",
    "dropphyst": "AR",
    "dropphyzpp": 718659998,
    "dropmaladd": "322 E DOUGLAS AVE",
    "dropmalcty": "WILTON",
    "dropmalst": "AR",
    "dropmalzpp": 718659998,
    "dropsitphn": 8708982110,
    "dropsitlph": 8708982903,
    "dropsitcph": 8708982903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21312",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "5260 HIGHWAY 138",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "AR",
    "dropdelzpp": 716779998,
    "dropphyadd": "5260 HIGHWAY 138",
    "dropphycty": "WINCHESTER",
    "dropphyst": "AR",
    "dropphyzpp": 716779998,
    "dropmaladd": "5260 HIGHWAY 138",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "AR",
    "dropmalzpp": 716779998,
    "dropsitphn": 8703922255,
    "dropsitlph": 8703922255,
    "dropsitcph": 8703922255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21313",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "383 N WINSLOW BLVD",
    "dropdelcty": "WINSLOW",
    "dropdelst": "AR",
    "dropdelzpp": 729599998,
    "dropphyadd": "383 N WINSLOW BLVD",
    "dropphycty": "WINSLOW",
    "dropphyst": "AR",
    "dropphyzpp": 729599998,
    "dropmaladd": "383 N WINSLOW BLVD",
    "dropmalcty": "WINSLOW",
    "dropmalst": "AR",
    "dropmalzpp": 729599998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4796342141,
    "dropsitcph": 4796342141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21314",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "612 HIGH ST",
    "dropdelcty": "WINTHROP",
    "dropdelst": "AR",
    "dropdelzpp": 718669998,
    "dropphyadd": "612 HIGH ST",
    "dropphycty": "WINTHROP",
    "dropphyst": "AR",
    "dropphyzpp": 718669998,
    "dropmaladd": "612 HIGH ST",
    "dropmalcty": "WINTHROP",
    "dropmalst": "AR",
    "dropmalzpp": 718669998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704784035,
    "dropsitcph": 8704784035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21315",
    "droptype": "D",
    "dropname": "WISEMAN",
    "dropdeladd": "100 HIGHWAY 354 E",
    "dropdelcty": "WISEMAN",
    "dropdelst": "AR",
    "dropdelzpp": 725878800,
    "dropphyadd": "100 HIGHWAY 354 E",
    "dropphycty": "WISEMAN",
    "dropphyst": "AR",
    "dropphyzpp": 725878800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WISEMAN",
    "dropmalst": "AR",
    "dropmalzpp": 725879998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8703228496,
    "dropsitcph": 8703228496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21317",
    "droptype": "D",
    "dropname": "WITTER",
    "dropdeladd": "16734 HIGHWAY 23",
    "dropdelcty": "WITTER",
    "dropdelst": "AR",
    "dropdelzpp": 727769998,
    "dropphyadd": "16734 HIGHWAY 23",
    "dropphycty": "WITTER",
    "dropphyst": "AR",
    "dropphyzpp": 727769998,
    "dropmaladd": "16734 HIGHWAY 23",
    "dropmalcty": "WITTER",
    "dropmalst": "AR",
    "dropmalzpp": 727769998,
    "dropsitphn": 5019456732,
    "dropsitlph": 4792325757,
    "dropsitcph": 4792325757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21319",
    "droptype": "D",
    "dropname": "WITTS SPRINGS",
    "dropdeladd": "387 W HIGHWAY 16",
    "dropdelcty": "WITTS SPRINGS",
    "dropdelst": "AR",
    "dropdelzpp": 726869998,
    "dropphyadd": "387 W HIGHWAY 16",
    "dropphycty": "WITTS SPRINGS",
    "dropphyst": "AR",
    "dropphyzpp": 726869998,
    "dropmaladd": "387 W HIGHWAY 16",
    "dropmalcty": "WITTS SPRINGS",
    "dropmalst": "AR",
    "dropmalzpp": 726869998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8704962240,
    "dropsitcph": 8704962240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21323",
    "droptype": "D",
    "dropname": "WOODSON",
    "dropdeladd": "24622 HIGHWAY 365",
    "dropdelcty": "WOODSON",
    "dropdelst": "AR",
    "dropdelzpp": 721809998,
    "dropphyadd": "24622 HIGHWAY 365",
    "dropphycty": "WOODSON",
    "dropphyst": "AR",
    "dropphyzpp": 721809998,
    "dropmaladd": "24622 HIGHWAY 365",
    "dropmalcty": "WOODSON",
    "dropmalst": "AR",
    "dropmalzpp": 721809998,
    "dropsitphn": 5013972842,
    "dropsitlph": 5013972842,
    "dropsitcph": 5013972842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21324",
    "droptype": "D",
    "dropname": "WOOSTER",
    "dropdeladd": "19 PATTON RD",
    "dropdelcty": "WOOSTER",
    "dropdelst": "AR",
    "dropdelzpp": 721819998,
    "dropphyadd": "19 PATTON RD",
    "dropphycty": "WOOSTER",
    "dropphyst": "AR",
    "dropphyzpp": 721819998,
    "dropmaladd": "19 PATTON RD",
    "dropmalcty": "WOOSTER",
    "dropmalst": "AR",
    "dropmalzpp": 721819998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5016794865,
    "dropsitcph": 5016794865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21325",
    "droptype": "D",
    "dropname": "WRIGHT",
    "dropdeladd": "8305 ARKANSAS HIGHWAY 256",
    "dropdelcty": "WRIGHT",
    "dropdelst": "AR",
    "dropdelzpp": 721829998,
    "dropphyadd": "8305 ARKANSAS HIGHWAY 256",
    "dropphycty": "WRIGHT",
    "dropphyst": "AR",
    "dropphyzpp": 721829998,
    "dropmaladd": "8305 ARKANSAS HIGHWAY 256",
    "dropmalcty": "WRIGHT",
    "dropmalst": "AR",
    "dropmalzpp": 721829998,
    "dropsitphn": 5018421978,
    "dropsitlph": 5018421978,
    "dropsitcph": 5018421978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21326",
    "droptype": "D",
    "dropname": "WRIGHTSVILLE",
    "dropdeladd": "16220 HIGHWAY 365",
    "dropdelcty": "WRIGHTSVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 721839998,
    "dropphyadd": "16220 HIGHWAY 365",
    "dropphycty": "WRIGHTSVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 721839998,
    "dropmaladd": "16220 HIGHWAY 365",
    "dropmalcty": "WRIGHTSVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 721839998,
    "dropsitphn": 5018974610,
    "dropsitlph": 5018974610,
    "dropsitcph": 5018974610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21328",
    "droptype": "D",
    "dropname": "WYNNE",
    "dropdeladd": "402 MERRIMAN AVE E",
    "dropdelcty": "WYNNE",
    "dropdelst": "AR",
    "dropdelzpp": 723969998,
    "dropphyadd": "402 MERRIMAN AVE E",
    "dropphycty": "WYNNE",
    "dropphyst": "AR",
    "dropphyzpp": 723969998,
    "dropmaladd": "402 MERRIMAN AVE E",
    "dropmalcty": "WYNNE",
    "dropmalst": "AR",
    "dropmalzpp": 723969998,
    "dropsitphn": 8702382131,
    "dropsitlph": 8702382131,
    "dropsitcph": 8702382131,
    "dropfax": 8702088969
  },
  {
    "dcode": "D",
    "dropkey": "PY21332",
    "droptype": "D",
    "dropname": "YELLVILLE",
    "dropdeladd": "408 W 4TH ST",
    "dropdelcty": "YELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 726879998,
    "dropphyadd": "408 W 4TH ST",
    "dropphycty": "YELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 726879998,
    "dropmaladd": "408 W 4TH ST",
    "dropmalcty": "YELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 726879998,
    "dropsitphn": 8704496638,
    "dropsitlph": 8704496638,
    "dropsitcph": 8704496638,
    "dropfax": 8704496641
  },
  {
    "dcode": "D",
    "dropkey": "PY21334",
    "droptype": "D",
    "dropname": "YORKTOWN",
    "dropdeladd": "69 ANDERSON TRL",
    "dropdelcty": "YORKTOWN",
    "dropdelst": "AR",
    "dropdelzpp": 716788800,
    "dropphyadd": "69 ANDERSON TRL",
    "dropphycty": "YORKTOWN",
    "dropphyst": "AR",
    "dropphyzpp": 716788800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YORKTOWN",
    "dropmalst": "AR",
    "dropmalzpp": 716789998,
    "dropsitphn": 5019456732,
    "dropsitlph": 8706285446,
    "dropsitcph": 8706285446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21344",
    "droptype": "D",
    "dropname": "ALACHUA",
    "dropdeladd": "15200 NW 142ND TER",
    "dropdelcty": "ALACHUA",
    "dropdelst": "FL",
    "dropdelzpp": 326159998,
    "dropphyadd": "15200 NW 142ND TER",
    "dropphycty": "ALACHUA",
    "dropphyst": "FL",
    "dropphyzpp": 326159998,
    "dropmaladd": "15200 NW 142ND TER",
    "dropmalcty": "ALACHUA",
    "dropmalst": "FL",
    "dropmalzpp": 326159998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864621409,
    "dropsitcph": 3864621409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21347",
    "droptype": "D",
    "dropname": "ALFORD",
    "dropdeladd": "1772 GEORGIA ST",
    "dropdelcty": "ALFORD",
    "dropdelst": "FL",
    "dropdelzpp": 324209998,
    "dropphyadd": "1772 GEORGIA ST",
    "dropphycty": "ALFORD",
    "dropphyst": "FL",
    "dropphyzpp": 324209998,
    "dropmaladd": "1772 GEORGIA ST",
    "dropmalcty": "ALFORD",
    "dropmalst": "FL",
    "dropmalzpp": 324209998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505794609,
    "dropsitcph": 8505794609,
    "dropfax": 8505794609
  },
  {
    "dcode": "D",
    "dropkey": "PY21355",
    "droptype": "D",
    "dropname": "ALTAMONTE SPRINGS",
    "dropdeladd": "321 MONTGOMERY RD",
    "dropdelcty": "ALTAMONTE SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 327149998,
    "dropphyadd": "321 MONTGOMERY RD",
    "dropphycty": "ALTAMONTE SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 327149998,
    "dropmaladd": "321 MONTGOMERY RD",
    "dropmalcty": "ALTAMONTE SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 327149998,
    "dropsitphn": 4078655897,
    "dropsitlph": 4078655897,
    "dropsitcph": 4078655494,
    "dropfax": 4076823545
  },
  {
    "dcode": "D",
    "dropkey": "PY21356",
    "droptype": "D",
    "dropname": "ALTHA",
    "dropdeladd": "25934 N MAIN ST",
    "dropdelcty": "ALTHA",
    "dropdelst": "FL",
    "dropdelzpp": 324219998,
    "dropphyadd": "25934 N MAIN ST",
    "dropphycty": "ALTHA",
    "dropphyst": "FL",
    "dropphyzpp": 324219998,
    "dropmaladd": "25934 N MAIN ST",
    "dropmalcty": "ALTHA",
    "dropmalst": "FL",
    "dropmalzpp": 324219998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507628160,
    "dropsitcph": 8507628160,
    "dropfax": 8507624011
  },
  {
    "dcode": "D",
    "dropkey": "PY21357",
    "droptype": "D",
    "dropname": "ALTOONA",
    "dropdeladd": "42038 STATE ROAD 19",
    "dropdelcty": "ALTOONA",
    "dropdelst": "FL",
    "dropdelzpp": 327029998,
    "dropphyadd": "42038 STATE ROAD 19",
    "dropphycty": "ALTOONA",
    "dropphyst": "FL",
    "dropphyzpp": 327029998,
    "dropmaladd": "42038 STATE ROAD 19",
    "dropmalcty": "ALTOONA",
    "dropmalst": "FL",
    "dropmalzpp": 327029998,
    "dropsitphn": 3526694800,
    "dropsitlph": 3526694800,
    "dropsitcph": 3526694800,
    "dropfax": 3526694800
  },
  {
    "dcode": "D",
    "dropkey": "PY21358",
    "droptype": "D",
    "dropname": "ALTURAS",
    "dropdeladd": "2486 3RD ST",
    "dropdelcty": "BARTOW",
    "dropdelst": "FL",
    "dropdelzpp": 338309226,
    "dropphyadd": "2486 3RD ST",
    "dropphycty": "BARTOW",
    "dropphyst": "FL",
    "dropphyzpp": 338309226,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTURAS",
    "dropmalst": "FL",
    "dropmalzpp": 338209998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8635371302,
    "dropfax": 8635371302
  },
  {
    "dcode": "D",
    "dropkey": "PY21359",
    "droptype": "D",
    "dropname": "ALVA",
    "dropdeladd": "17301 BROADWAY ST",
    "dropdelcty": "ALVA",
    "dropdelst": "FL",
    "dropdelzpp": 339209998,
    "dropphyadd": "17301 BROADWAY ST",
    "dropphycty": "ALVA",
    "dropphyst": "FL",
    "dropphyzpp": 339209998,
    "dropmaladd": "17301 BROADWAY ST",
    "dropmalcty": "ALVA",
    "dropmalst": "FL",
    "dropmalzpp": 339209998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2397283924,
    "dropfax": 2397285026
  },
  {
    "dcode": "D",
    "dropkey": "PY21366",
    "droptype": "D",
    "dropname": "ANNA MARIA",
    "dropdeladd": "101B S BAY BLVD",
    "dropdelcty": "ANNA MARIA",
    "dropdelst": "FL",
    "dropdelzpp": 342169800,
    "dropphyadd": "101B S BAY BLVD",
    "dropphycty": "ANNA MARIA",
    "dropphyst": "FL",
    "dropphyzpp": 342169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANNA MARIA",
    "dropmalst": "FL",
    "dropmalzpp": 342169998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417786521,
    "dropfax": 9417783254
  },
  {
    "dcode": "D",
    "dropkey": "PY21367",
    "droptype": "D",
    "dropname": "ANTHONY",
    "dropdeladd": "9081 NE JACKSONVILLE RD",
    "dropdelcty": "ANTHONY",
    "dropdelst": "FL",
    "dropdelzpp": 326173519,
    "dropphyadd": "9081 NE JACKSONVILLE RD",
    "dropphycty": "ANTHONY",
    "dropphyst": "FL",
    "dropphyzpp": 326173519,
    "dropmaladd": "9081 NE JACKSONVILLE RD",
    "dropmalcty": "ANTHONY",
    "dropmalst": "FL",
    "dropmalzpp": 326179998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526296106,
    "dropsitcph": 3526296106,
    "dropfax": 3526299435
  },
  {
    "dcode": "D",
    "dropkey": "PY21368",
    "droptype": "D",
    "dropname": "APALACHICOLA",
    "dropdeladd": "20 AVENUE D STE 101",
    "dropdelcty": "APALACHICOLA",
    "dropdelst": "FL",
    "dropdelzpp": 323202700,
    "dropphyadd": "20 AVENUE D STE 101",
    "dropphycty": "APALACHICOLA",
    "dropphyst": "FL",
    "dropphyzpp": 323202700,
    "dropmaladd": "20 AVENUE D STE 101",
    "dropmalcty": "APALACHICOLA",
    "dropmalst": "FL",
    "dropmalzpp": 323202700,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506539554,
    "dropsitcph": 8506539554,
    "dropfax": 8506538540
  },
  {
    "dcode": "D",
    "dropkey": "PY21372",
    "droptype": "D",
    "dropname": "APOPKA",
    "dropdeladd": "581 N PARK AVE",
    "dropdelcty": "APOPKA",
    "dropdelst": "FL",
    "dropdelzpp": 327129998,
    "dropphyadd": "581 N PARK AVE",
    "dropphycty": "APOPKA",
    "dropphyst": "FL",
    "dropphyzpp": 327129998,
    "dropmaladd": "581 N PARK AVE",
    "dropmalcty": "APOPKA",
    "dropmalst": "FL",
    "dropmalzpp": 327129998,
    "dropsitphn": 4078861578,
    "dropsitlph": 4078861578,
    "dropsitcph": 4078865375,
    "dropfax": 4078868885
  },
  {
    "dcode": "D",
    "dropkey": "PY21373",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "109 N POLK AVE",
    "dropdelcty": "ARCADIA",
    "dropdelst": "FL",
    "dropdelzpp": 342669998,
    "dropphyadd": "109 N POLK AVE",
    "dropphycty": "ARCADIA",
    "dropphyst": "FL",
    "dropphyzpp": 342669998,
    "dropmaladd": "109 N POLK AVE",
    "dropmalcty": "ARCADIA",
    "dropmalst": "FL",
    "dropmalzpp": 342669998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 8634918372,
    "dropfax": 8634940883
  },
  {
    "dcode": "D",
    "dropkey": "PY21374",
    "droptype": "D",
    "dropname": "ARCHER",
    "dropdeladd": "13553 SW STATE ROAD 45",
    "dropdelcty": "ARCHER",
    "dropdelst": "FL",
    "dropdelzpp": 326189998,
    "dropphyadd": "13553 SW STATE ROAD 45",
    "dropphycty": "ARCHER",
    "dropphyst": "FL",
    "dropphyzpp": 326189998,
    "dropmaladd": "13553 SW STATE ROAD 45",
    "dropmalcty": "ARCHER",
    "dropmalst": "FL",
    "dropmalzpp": 326189998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524952565,
    "dropsitcph": 3524952565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21375",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "4757 U S HIGHWAY 90 E",
    "dropdelcty": "ARGYLE",
    "dropdelst": "FL",
    "dropdelzpp": 324229998,
    "dropphyadd": "4757 U S HIGHWAY 90 E",
    "dropphycty": "ARGYLE",
    "dropphyst": "FL",
    "dropphyzpp": 324229998,
    "dropmaladd": "4757 U S HIGHWAY 90 E",
    "dropmalcty": "ARGYLE",
    "dropmalst": "FL",
    "dropmalzpp": 324229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508920566,
    "dropsitcph": 8508920566,
    "dropfax": 8508920566
  },
  {
    "dcode": "D",
    "dropkey": "PY21376",
    "droptype": "D",
    "dropname": "ARIPEKA",
    "dropdeladd": "18925 ARIPEKA RD",
    "dropdelcty": "ARIPEKA",
    "dropdelst": "FL",
    "dropdelzpp": 346799801,
    "dropphyadd": "18925 ARIPEKA RD",
    "dropphycty": "ARIPEKA",
    "dropphyst": "FL",
    "dropphyzpp": 346799801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARIPEKA",
    "dropmalst": "FL",
    "dropmalzpp": 346799998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278686876,
    "dropfax": 7278686876
  },
  {
    "dcode": "D",
    "dropkey": "PY21380",
    "droptype": "D",
    "dropname": "ASTATULA",
    "dropdeladd": "25711 MONROE ST",
    "dropdelcty": "ASTATULA",
    "dropdelst": "FL",
    "dropdelzpp": 347059998,
    "dropphyadd": "25711 MONROE ST",
    "dropphycty": "ASTATULA",
    "dropphyst": "FL",
    "dropphyzpp": 347059998,
    "dropmaladd": "25711 MONROE ST",
    "dropmalcty": "ASTATULA",
    "dropmalst": "FL",
    "dropmalzpp": 347059998,
    "dropsitphn": 3527422228,
    "dropsitlph": 3527422228,
    "dropsitcph": 3526773312,
    "dropfax": 3527428150
  },
  {
    "dcode": "D",
    "dropkey": "PY21381",
    "droptype": "D",
    "dropname": "ASTOR",
    "dropdeladd": "24433 STATE ROAD 40",
    "dropdelcty": "ASTOR",
    "dropdelst": "FL",
    "dropdelzpp": 321029998,
    "dropphyadd": "24433 STATE ROAD 40",
    "dropphycty": "ASTOR",
    "dropphyst": "FL",
    "dropphyzpp": 321029998,
    "dropmaladd": "24433 STATE ROAD 40",
    "dropmalcty": "ASTOR",
    "dropmalst": "FL",
    "dropmalzpp": 321029998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527592149,
    "dropsitcph": 3527592149,
    "dropfax": 3527592149
  },
  {
    "dcode": "D",
    "dropkey": "PY21388",
    "droptype": "D",
    "dropname": "AUBURNDALE",
    "dropdeladd": "201 E LAKE AVE",
    "dropdelcty": "AUBURNDALE",
    "dropdelst": "FL",
    "dropdelzpp": 338239998,
    "dropphyadd": "201 E LAKE AVE",
    "dropphycty": "AUBURNDALE",
    "dropphyst": "FL",
    "dropphyzpp": 338239998,
    "dropmaladd": "201 E LAKE AVE",
    "dropmalcty": "AUBURNDALE",
    "dropmalst": "FL",
    "dropmalzpp": 338239998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8639650099,
    "dropfax": 8639650099
  },
  {
    "dcode": "D",
    "dropkey": "PY21393",
    "droptype": "D",
    "dropname": "AVON PARK",
    "dropdeladd": "100 S VERONA AVE",
    "dropdelcty": "AVON PARK",
    "dropdelst": "FL",
    "dropdelzpp": 338259998,
    "dropphyadd": "100 S VERONA AVE",
    "dropphycty": "AVON PARK",
    "dropphyst": "FL",
    "dropphyzpp": 338259998,
    "dropmaladd": "100 S VERONA AVE",
    "dropmalcty": "AVON PARK",
    "dropmalst": "FL",
    "dropmalzpp": 338259998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634530759,
    "dropfax": 8634538593
  },
  {
    "dcode": "D",
    "dropkey": "PY21397",
    "droptype": "D",
    "dropname": "BABSON PARK",
    "dropdeladd": "1200 N SCENIC HWY",
    "dropdelcty": "BABSON PARK",
    "dropdelst": "FL",
    "dropdelzpp": 338279998,
    "dropphyadd": "1200 N SCENIC HWY",
    "dropphycty": "BABSON PARK",
    "dropphyst": "FL",
    "dropphyzpp": 338279998,
    "dropmaladd": "1200 N SCENIC HWY",
    "dropmalcty": "BABSON PARK",
    "dropmalst": "FL",
    "dropmalzpp": 338279998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636381272,
    "dropfax": 8636387434
  },
  {
    "dcode": "D",
    "dropkey": "PY21399",
    "droptype": "D",
    "dropname": "BAGDAD",
    "dropdeladd": "4629 FORSYTH ST",
    "dropdelcty": "BAGDAD",
    "dropdelst": "FL",
    "dropdelzpp": 325309998,
    "dropphyadd": "4629 FORSYTH ST",
    "dropphycty": "BAGDAD",
    "dropphyst": "FL",
    "dropphyzpp": 325309998,
    "dropmaladd": "4629 FORSYTH ST",
    "dropmalcty": "BAGDAD",
    "dropmalst": "FL",
    "dropmalzpp": 325309998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506239520,
    "dropsitcph": 8506239520,
    "dropfax": 8509838743
  },
  {
    "dcode": "D",
    "dropkey": "PY21401",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "5690 HIGHWAY 4",
    "dropdelcty": "BAKER",
    "dropdelst": "FL",
    "dropdelzpp": 325319998,
    "dropphyadd": "5690 HIGHWAY 4",
    "dropphycty": "BAKER",
    "dropphyst": "FL",
    "dropphyzpp": 325319998,
    "dropmaladd": "5690 HIGHWAY 4",
    "dropmalcty": "BAKER",
    "dropmalst": "FL",
    "dropmalzpp": 325319998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505379211,
    "dropsitcph": 8505379211,
    "dropfax": 8505374262
  },
  {
    "dcode": "D",
    "dropkey": "PY21408",
    "droptype": "D",
    "dropname": "BALM",
    "dropdeladd": "15036 BALM RD",
    "dropdelcty": "BALM",
    "dropdelst": "FL",
    "dropdelzpp": 335039700,
    "dropphyadd": "15036 BALM RD",
    "dropphycty": "BALM",
    "dropphyst": "FL",
    "dropphyzpp": 335039700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALM",
    "dropmalst": "FL",
    "dropmalzpp": 335039998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 8132610602,
    "dropfax": 8132610678
  },
  {
    "dcode": "D",
    "dropkey": "PY21409",
    "droptype": "D",
    "dropname": "BARBERVILLE",
    "dropdeladd": "1680 RAILROAD AVE",
    "dropdelcty": "BARBERVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 321055000,
    "dropphyadd": "1680 RAILROAD AVE",
    "dropphycty": "BARBERVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 321055000,
    "dropmaladd": "1680 RAILROAD AVE",
    "dropmalcty": "BARBERVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 321059998,
    "dropsitphn": 3867492002,
    "dropsitlph": 3867492002,
    "dropsitcph": 3867492002,
    "dropfax": 3867493140
  },
  {
    "dcode": "D",
    "dropkey": "PY21414",
    "droptype": "D",
    "dropname": "BARTOW",
    "dropdeladd": "220 S CENTRAL AVE",
    "dropdelcty": "BARTOW",
    "dropdelst": "FL",
    "dropdelzpp": 338309998,
    "dropphyadd": "220 S CENTRAL AVE",
    "dropphycty": "BARTOW",
    "dropphyst": "FL",
    "dropphyzpp": 338309998,
    "dropmaladd": "220 S CENTRAL AVE",
    "dropmalcty": "BARTOW",
    "dropmalst": "FL",
    "dropmalzpp": 338309998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8635190419,
    "dropfax": 8635334160
  },
  {
    "dcode": "D",
    "dropkey": "PY21415",
    "droptype": "D",
    "dropname": "BASCOM",
    "dropdeladd": "5011 BASSWOOD RD",
    "dropdelcty": "BASCOM",
    "dropdelst": "FL",
    "dropdelzpp": 324239998,
    "dropphyadd": "5011 BASSWOOD RD",
    "dropphycty": "BASCOM",
    "dropphyst": "FL",
    "dropphyzpp": 324239998,
    "dropmaladd": "5011 BASSWOOD RD",
    "dropmalcty": "BASCOM",
    "dropmalst": "FL",
    "dropmalzpp": 324239998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505692382,
    "dropsitcph": 8505692382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21423",
    "droptype": "D",
    "dropname": "BAY PINES",
    "dropdeladd": "10000 BAY PINES BLVD BLDG 20",
    "dropdelcty": "BAY PINES",
    "dropdelst": "FL",
    "dropdelzpp": 337448298,
    "dropphyadd": "10000 BAY PINES BLVD BLDG 20",
    "dropphycty": "BAY PINES",
    "dropphyst": "FL",
    "dropphyzpp": 337448298,
    "dropmaladd": "10000 BAY PINES BLVD BLDG 20",
    "dropmalcty": "BAY PINES",
    "dropmalst": "FL",
    "dropmalzpp": 337448298,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273927171,
    "dropsitcph": 7273927171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21447",
    "droptype": "D",
    "dropname": "BELL",
    "dropdeladd": "1900 N US HIGHWAY 129",
    "dropdelcty": "BELL",
    "dropdelst": "FL",
    "dropdelzpp": 326193172,
    "dropphyadd": "1900 N US HIGHWAY 129",
    "dropphycty": "BELL",
    "dropphyst": "FL",
    "dropphyzpp": 326193172,
    "dropmaladd": "1900 N US HIGHWAY 129",
    "dropmalcty": "BELL",
    "dropmalst": "FL",
    "dropmalzpp": 326199998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524632453,
    "dropsitcph": 3524632453,
    "dropfax": 3524631275
  },
  {
    "dcode": "D",
    "dropkey": "PY21448",
    "droptype": "D",
    "dropname": "BELLE GLADE",
    "dropdeladd": "1340 NW AVENUE L",
    "dropdelcty": "BELLE GLADE",
    "dropdelst": "FL",
    "dropdelzpp": 334309998,
    "dropphyadd": "1340 NW AVENUE L",
    "dropphycty": "BELLE GLADE",
    "dropphyst": "FL",
    "dropphyzpp": 334309998,
    "dropmaladd": "1340 NW AVENUE L",
    "dropmalcty": "BELLE GLADE",
    "dropmalst": "FL",
    "dropmalzpp": 334309998,
    "dropsitphn": 5619962528,
    "dropsitlph": 5619962528,
    "dropsitcph": 5619520038,
    "dropfax": 5619961268
  },
  {
    "dcode": "D",
    "dropkey": "PY21456",
    "droptype": "D",
    "dropname": "BELLEVIEW",
    "dropdeladd": "4800 SE 110TH ST",
    "dropdelcty": "BELLEVIEW",
    "dropdelst": "FL",
    "dropdelzpp": 344209998,
    "dropphyadd": "4800 SE 110TH ST",
    "dropphycty": "BELLEVIEW",
    "dropphyst": "FL",
    "dropphyzpp": 344209998,
    "dropmaladd": "4800 SE 110TH ST",
    "dropmalcty": "BELLEVIEW",
    "dropmalst": "FL",
    "dropmalzpp": 344209998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522458777,
    "dropsitcph": 3522458777,
    "dropfax": 3522450106
  },
  {
    "dcode": "D",
    "dropkey": "PY21474",
    "droptype": "D",
    "dropname": "BLOUNTSTOWN",
    "dropdeladd": "17621 MAIN ST N",
    "dropdelcty": "BLOUNTSTOWN",
    "dropdelst": "FL",
    "dropdelzpp": 324249998,
    "dropphyadd": "17621 MAIN ST N",
    "dropphycty": "BLOUNTSTOWN",
    "dropphyst": "FL",
    "dropphyzpp": 324249998,
    "dropmaladd": "17621 MAIN ST N",
    "dropmalcty": "BLOUNTSTOWN",
    "dropmalst": "FL",
    "dropmalzpp": 324249998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506748521,
    "dropsitcph": 8506748521,
    "dropfax": 8506743478
  },
  {
    "dcode": "D",
    "dropkey": "PY21476",
    "droptype": "D",
    "dropname": "BOCA GRANDE",
    "dropdeladd": "434 4TH ST",
    "dropdelcty": "BOCA GRANDE",
    "dropdelst": "FL",
    "dropdelzpp": 339219800,
    "dropphyadd": "434 4TH ST",
    "dropphycty": "BOCA GRANDE",
    "dropphyst": "FL",
    "dropphyzpp": 339219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOCA GRANDE",
    "dropmalst": "FL",
    "dropmalzpp": 339219998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9419649067,
    "dropfax": 9419641435
  },
  {
    "dcode": "D",
    "dropkey": "PY21477",
    "droptype": "D",
    "dropname": "BOCA RATON",
    "dropdeladd": "2800 N MILITARY TRL",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334319998,
    "dropphyadd": "2800 N MILITARY TRL",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334319998,
    "dropmaladd": "2800 N MILITARY TRL",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334319998,
    "dropsitphn": 5619972559,
    "dropsitlph": 5619972559,
    "dropsitcph": 5619987781,
    "dropfax": 5619940826
  },
  {
    "dcode": "D",
    "dropkey": "PY21479",
    "droptype": "D",
    "dropname": "BOKEELIA",
    "dropdeladd": "15980 STRINGFELLOW RD",
    "dropdelcty": "BOKEELIA",
    "dropdelst": "FL",
    "dropdelzpp": 339229998,
    "dropphyadd": "15980 STRINGFELLOW RD",
    "dropphycty": "BOKEELIA",
    "dropphyst": "FL",
    "dropphyzpp": 339229998,
    "dropmaladd": "15980 STRINGFELLOW RD",
    "dropmalcty": "BOKEELIA",
    "dropmalst": "FL",
    "dropmalzpp": 339229998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392834258,
    "dropfax": 2392836025
  },
  {
    "dcode": "D",
    "dropkey": "PY21481",
    "droptype": "D",
    "dropname": "BONIFAY",
    "dropdeladd": "325 W HIGHWAY 90",
    "dropdelcty": "BONIFAY",
    "dropdelst": "FL",
    "dropdelzpp": 324259998,
    "dropphyadd": "325 W HIGHWAY 90",
    "dropphycty": "BONIFAY",
    "dropphyst": "FL",
    "dropphyzpp": 324259998,
    "dropmaladd": "325 W HIGHWAY 90",
    "dropmalcty": "BONIFAY",
    "dropmalst": "FL",
    "dropmalzpp": 324259998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505472542,
    "dropsitcph": 8505472542,
    "dropfax": 8505470990
  },
  {
    "dcode": "D",
    "dropkey": "PY21486",
    "droptype": "D",
    "dropname": "BONITA SPRINGS",
    "dropdeladd": "26150 OLD 41 RD",
    "dropdelcty": "BONITA SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 341356632,
    "dropphyadd": "26150 OLD 41 RD",
    "dropphycty": "BONITA SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 341356632,
    "dropmaladd": "26150 OLD 41 RD",
    "dropmalcty": "BONITA SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 341356632,
    "dropsitphn": 8138770788,
    "dropsitlph": 2399920442,
    "dropsitcph": 2399920442,
    "dropfax": 2399926325
  },
  {
    "dcode": "D",
    "dropkey": "PY21487",
    "droptype": "D",
    "dropname": "BOSTWICK",
    "dropdeladd": "1132 N HIGHWAY 17",
    "dropdelcty": "BOSTWICK",
    "dropdelst": "FL",
    "dropdelzpp": 320072100,
    "dropphyadd": "1132 N HIGHWAY 17",
    "dropphycty": "BOSTWICK",
    "dropphyst": "FL",
    "dropphyzpp": 320072100,
    "dropmaladd": "1132 N HIGHWAY 17",
    "dropmalcty": "BOSTWICK",
    "dropmalst": "FL",
    "dropmalzpp": 320079998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863257158,
    "dropsitcph": 3863257158,
    "dropfax": 3863258056
  },
  {
    "dcode": "D",
    "dropkey": "PY21489",
    "droptype": "D",
    "dropname": "BOWLING GREEN",
    "dropdeladd": "4702 CENTRAL AVE",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "FL",
    "dropdelzpp": 338346050,
    "dropphyadd": "4702 CENTRAL AVE",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "FL",
    "dropphyzpp": 338346050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "FL",
    "dropmalzpp": 338349998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8633753186,
    "dropfax": 8633752035
  },
  {
    "dcode": "D",
    "dropkey": "PY21491",
    "droptype": "D",
    "dropname": "BOYNTON BEACH",
    "dropdeladd": "1530 W BOYNTON BEACH BLVD",
    "dropdelcty": "BOYNTON BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334369998,
    "dropphyadd": "1530 W BOYNTON BEACH BLVD",
    "dropphycty": "BOYNTON BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334369998,
    "dropmaladd": "1530 W BOYNTON BEACH BLVD",
    "dropmalcty": "BOYNTON BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334369998,
    "dropsitphn": 5617321702,
    "dropsitlph": 5617407329,
    "dropsitcph": 5617407329,
    "dropfax": 5617378079
  },
  {
    "dcode": "D",
    "dropkey": "PY21497",
    "droptype": "D",
    "dropname": "BRADENTON",
    "dropdeladd": "824 MANATEE AVE W",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342059998,
    "dropphyadd": "824 MANATEE AVE W",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342059998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342069998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417470867,
    "dropfax": 9417486353
  },
  {
    "dcode": "D",
    "dropkey": "PY21499",
    "droptype": "D",
    "dropname": "BRADENTON BEACH",
    "dropdeladd": "116 BRIDGE ST",
    "dropdelcty": "BRADENTON BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 342172435,
    "dropphyadd": "116 BRIDGE ST",
    "dropphycty": "BRADENTON BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 342172435,
    "dropmaladd": "116 BRIDGE ST",
    "dropmalcty": "BRADENTON BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 342172435,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417790069,
    "dropfax": 9417786790
  },
  {
    "dcode": "D",
    "dropkey": "PY21501",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "6947 OLD  STATE ROAD 37",
    "dropdelcty": "BRADLEY",
    "dropdelst": "FL",
    "dropdelzpp": 338359023,
    "dropphyadd": "6947 OLD  STATE ROAD 37",
    "dropphycty": "BRADLEY",
    "dropphyst": "FL",
    "dropphyzpp": 338359023,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADLEY",
    "dropmalst": "FL",
    "dropmalzpp": 338359998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634281312,
    "dropfax": 8634281312
  },
  {
    "dcode": "D",
    "dropkey": "PY21502",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "1315 OAKFIELD DR",
    "dropdelcty": "BRANDON",
    "dropdelst": "FL",
    "dropdelzpp": 335119998,
    "dropphyadd": "1315 OAKFIELD DR",
    "dropphycty": "BRANDON",
    "dropphyst": "FL",
    "dropphyzpp": 335119998,
    "dropmaladd": "1315 OAKFIELD DR",
    "dropmalcty": "BRANDON",
    "dropmalst": "FL",
    "dropmalzpp": 335119998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136611503,
    "dropfax": 8136818777
  },
  {
    "dcode": "D",
    "dropkey": "PY21503",
    "droptype": "D",
    "dropname": "BRANFORD",
    "dropdeladd": "104 SUWANNEE AVE NW",
    "dropdelcty": "BRANFORD",
    "dropdelst": "FL",
    "dropdelzpp": 320089998,
    "dropphyadd": "104 SUWANNEE AVE NW",
    "dropphycty": "BRANFORD",
    "dropphyst": "FL",
    "dropphyzpp": 320089998,
    "dropmaladd": "104 SUWANNEE AVE NW",
    "dropmalcty": "BRANFORD",
    "dropmalst": "FL",
    "dropmalzpp": 320089998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3869351014,
    "dropsitcph": 3869351014,
    "dropfax": 3869352019
  },
  {
    "dcode": "D",
    "dropkey": "PY21507",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "12587 NW VIRGINIA G WEAVER ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "FL",
    "dropdelzpp": 323219998,
    "dropphyadd": "12587 NW VIRGINIA G WEAVER ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "FL",
    "dropphyzpp": 323219998,
    "dropmaladd": "12587 NW VIRGINIA G WEAVER ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "FL",
    "dropmalzpp": 323219998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506350087,
    "dropsitcph": 8506350087,
    "dropfax": 8506435570
  },
  {
    "dcode": "D",
    "dropkey": "PY21510",
    "droptype": "D",
    "dropname": "BRONSON",
    "dropdeladd": "747 E HATHAWAY AVE",
    "dropdelcty": "BRONSON",
    "dropdelst": "FL",
    "dropdelzpp": 326219998,
    "dropphyadd": "747 E HATHAWAY AVE",
    "dropphycty": "BRONSON",
    "dropphyst": "FL",
    "dropphyzpp": 326219998,
    "dropmaladd": "747 E HATHAWAY AVE",
    "dropmalcty": "BRONSON",
    "dropmalst": "FL",
    "dropmalzpp": 326219998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524862773,
    "dropsitcph": 3524862773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21511",
    "droptype": "D",
    "dropname": "BROOKER",
    "dropdeladd": "18796 CHARLOTTE AVE",
    "dropdelcty": "BROOKER",
    "dropdelst": "FL",
    "dropdelzpp": 326229998,
    "dropphyadd": "18796 CHARLOTTE AVE",
    "dropphycty": "BROOKER",
    "dropphyst": "FL",
    "dropphyzpp": 326229998,
    "dropmaladd": "18796 CHARLOTTE AVE",
    "dropmalcty": "BROOKER",
    "dropmalst": "FL",
    "dropmalzpp": 326229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524851711,
    "dropsitcph": 3524851711,
    "dropfax": 3524851711
  },
  {
    "dcode": "D",
    "dropkey": "PY21513",
    "droptype": "D",
    "dropname": "BROOKSVILLE",
    "dropdeladd": "19101 CORTEZ BLVD",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 346019998,
    "dropphyadd": "19101 CORTEZ BLVD",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 346019998,
    "dropmaladd": "PO BOX 10000",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 346031000,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3525444093,
    "dropfax": 3525440003
  },
  {
    "dcode": "D",
    "dropkey": "PY21519",
    "droptype": "D",
    "dropname": "BRYCEVILLE",
    "dropdeladd": "7875 US HIGHWAY 301",
    "dropdelcty": "BRYCEVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 320099998,
    "dropphyadd": "7875 US HIGHWAY 301",
    "dropphycty": "BRYCEVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 320099998,
    "dropmaladd": "7875 US HIGHWAY 301",
    "dropmalcty": "BRYCEVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 320099998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042669182,
    "dropsitcph": 9042669182,
    "dropfax": 9042663025
  },
  {
    "dcode": "D",
    "dropkey": "PY21522",
    "droptype": "D",
    "dropname": "BUNNELL",
    "dropdeladd": "704 E MOODY BLVD",
    "dropdelcty": "BUNNELL",
    "dropdelst": "FL",
    "dropdelzpp": 321105921,
    "dropphyadd": "704 E MOODY BLVD",
    "dropphycty": "BUNNELL",
    "dropphyst": "FL",
    "dropphyzpp": 321105921,
    "dropmaladd": "704 E MOODY BLVD",
    "dropmalcty": "BUNNELL",
    "dropmalst": "FL",
    "dropmalzpp": 321109998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864374874,
    "dropsitcph": 3864378453,
    "dropfax": 3864370190
  },
  {
    "dcode": "D",
    "dropkey": "PY21523",
    "droptype": "D",
    "dropname": "BUSHNELL",
    "dropdeladd": "800 N MAIN ST",
    "dropdelcty": "BUSHNELL",
    "dropdelst": "FL",
    "dropdelzpp": 335139997,
    "dropphyadd": "800 N MAIN ST",
    "dropphycty": "BUSHNELL",
    "dropphyst": "FL",
    "dropphyzpp": 335139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUSHNELL",
    "dropmalst": "FL",
    "dropmalzpp": 335139998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527931261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21527",
    "droptype": "D",
    "dropname": "CALLAHAN",
    "dropdeladd": "450054 STATE ROAD 200",
    "dropdelcty": "CALLAHAN",
    "dropdelst": "FL",
    "dropdelzpp": 320119998,
    "dropphyadd": "450054 STATE ROAD 200",
    "dropphycty": "CALLAHAN",
    "dropphyst": "FL",
    "dropphyzpp": 320119998,
    "dropmaladd": "450054 STATE ROAD 200",
    "dropmalcty": "CALLAHAN",
    "dropmalst": "FL",
    "dropmalzpp": 320119998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048792131,
    "dropsitcph": 9048792131,
    "dropfax": 9048796737
  },
  {
    "dcode": "D",
    "dropkey": "PY21530",
    "droptype": "D",
    "dropname": "CAMPBELLTON",
    "dropdeladd": "5265 HIGHWAY 231",
    "dropdelcty": "CAMPBELLTON",
    "dropdelst": "FL",
    "dropdelzpp": 324269998,
    "dropphyadd": "5265 HIGHWAY 231",
    "dropphycty": "CAMPBELLTON",
    "dropphyst": "FL",
    "dropphyzpp": 324269998,
    "dropmaladd": "5265 HIGHWAY 231",
    "dropmalcty": "CAMPBELLTON",
    "dropmalst": "FL",
    "dropmalzpp": 324269998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502634150,
    "dropsitcph": 8502634150,
    "dropfax": 8502638998
  },
  {
    "dcode": "D",
    "dropkey": "PY21531",
    "droptype": "D",
    "dropname": "CANAL POINT",
    "dropdeladd": "12570 US HIGHWAY 441",
    "dropdelcty": "CANAL POINT",
    "dropdelst": "FL",
    "dropdelzpp": 334389998,
    "dropphyadd": "12570 US HIGHWAY 441",
    "dropphycty": "CANAL POINT",
    "dropphyst": "FL",
    "dropphyzpp": 334389998,
    "dropmaladd": "12570 US HIGHWAY 441",
    "dropmalcty": "CANAL POINT",
    "dropmalst": "FL",
    "dropmalzpp": 334389998,
    "dropsitphn": 5619245428,
    "dropsitlph": 5619245428,
    "dropsitcph": 5619245636,
    "dropfax": 5619247792
  },
  {
    "dcode": "D",
    "dropkey": "PY21533",
    "droptype": "D",
    "dropname": "CANDLER",
    "dropdeladd": "10801 SE 110TH STREET RD",
    "dropdelcty": "CANDLER",
    "dropdelst": "FL",
    "dropdelzpp": 321110079,
    "dropphyadd": "10801 SE 110TH STREET RD",
    "dropphycty": "CANDLER",
    "dropphyst": "FL",
    "dropphyzpp": 321110079,
    "dropmaladd": "10801 SE 110TH STREET RD",
    "dropmalcty": "CANDLER",
    "dropmalst": "FL",
    "dropmalzpp": 321119998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526874096,
    "dropsitcph": 3526874096,
    "dropfax": 3526874096
  },
  {
    "dcode": "D",
    "dropkey": "PY21534",
    "droptype": "D",
    "dropname": "CANTONMENT",
    "dropdeladd": "1430 S HIGHWAY 29",
    "dropdelcty": "CANTONMENT",
    "dropdelst": "FL",
    "dropdelzpp": 325336407,
    "dropphyadd": "1430 S HIGHWAY 29",
    "dropphycty": "CANTONMENT",
    "dropphyst": "FL",
    "dropphyzpp": 325336407,
    "dropmaladd": "1430 S HIGHWAY 29",
    "dropmalcty": "CANTONMENT",
    "dropmalst": "FL",
    "dropmalzpp": 325336407,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509686632,
    "dropsitcph": 8509686632,
    "dropfax": 8509680096
  },
  {
    "dcode": "D",
    "dropkey": "PY21535",
    "droptype": "D",
    "dropname": "CAPE CANAVERAL",
    "dropdeladd": "8700 ASTRONAUT BLVD",
    "dropdelcty": "CAPE CANAVERAL",
    "dropdelst": "FL",
    "dropdelzpp": 329209998,
    "dropphyadd": "8700 ASTRONAUT BLVD",
    "dropphycty": "CAPE CANAVERAL",
    "dropphyst": "FL",
    "dropphyzpp": 329209998,
    "dropmaladd": "8700 ASTRONAUT BLVD",
    "dropmalcty": "CAPE CANAVERAL",
    "dropmalst": "FL",
    "dropmalzpp": 329209998,
    "dropsitphn": 3213923011,
    "dropsitlph": 3213923011,
    "dropsitcph": 3217833163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21540",
    "droptype": "D",
    "dropname": "CAPTIVA",
    "dropdeladd": "14812 CAPTIVA DR SW",
    "dropdelcty": "CAPTIVA",
    "dropdelst": "FL",
    "dropdelzpp": 339249800,
    "dropphyadd": "14812 CAPTIVA DR SW",
    "dropphycty": "CAPTIVA",
    "dropphyst": "FL",
    "dropphyzpp": 339249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAPTIVA",
    "dropmalst": "FL",
    "dropmalzpp": 339249998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2394721674,
    "dropfax": 2394729606
  },
  {
    "dcode": "D",
    "dropkey": "PY21548",
    "droptype": "D",
    "dropname": "CARRABELLE",
    "dropdeladd": "93 TALLAHASSEE ST",
    "dropdelcty": "CARRABELLE",
    "dropdelst": "FL",
    "dropdelzpp": 323229998,
    "dropphyadd": "93 TALLAHASSEE ST",
    "dropphycty": "CARRABELLE",
    "dropphyst": "FL",
    "dropphyzpp": 323229998,
    "dropmaladd": "93 TALLAHASSEE ST",
    "dropmalcty": "CARRABELLE",
    "dropmalst": "FL",
    "dropmalzpp": 323229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506973339,
    "dropsitcph": 8506973339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21552",
    "droptype": "D",
    "dropname": "CARYVILLE",
    "dropdeladd": "866 CHURCH ST",
    "dropdelcty": "CARYVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 324279998,
    "dropphyadd": "866 CHURCH ST",
    "dropphycty": "CARYVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 324279998,
    "dropmaladd": "866 CHURCH ST",
    "dropmalcty": "CARYVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 324279998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505485501,
    "dropsitcph": 8505485501,
    "dropfax": 8505470990
  },
  {
    "dcode": "D",
    "dropkey": "PY21553",
    "droptype": "D",
    "dropname": "CASSADAGA",
    "dropdeladd": "1087 STEVENS ST",
    "dropdelcty": "CASSADAGA",
    "dropdelst": "FL",
    "dropdelzpp": 327063358,
    "dropphyadd": "1087 STEVENS ST",
    "dropphycty": "CASSADAGA",
    "dropphyst": "FL",
    "dropphyzpp": 327063358,
    "dropmaladd": "1087 STEVENS ST",
    "dropmalcty": "CASSADAGA",
    "dropmalst": "FL",
    "dropmalzpp": 327069998,
    "dropsitphn": 3862284062,
    "dropsitlph": 3862284062,
    "dropsitcph": 3862284062,
    "dropfax": 3862283861
  },
  {
    "dcode": "D",
    "dropkey": "PY21554",
    "droptype": "D",
    "dropname": "CASSELBERRY",
    "dropdeladd": "109 LIVE OAKS BLVD",
    "dropdelcty": "CASSELBERRY",
    "dropdelst": "FL",
    "dropdelzpp": 327079998,
    "dropphyadd": "109 LIVE OAKS BLVD",
    "dropphycty": "CASSELBERRY",
    "dropphyst": "FL",
    "dropphyzpp": 327079998,
    "dropmaladd": "109 LIVE OAKS BLVD",
    "dropmalcty": "CASSELBERRY",
    "dropmalst": "FL",
    "dropmalzpp": 327079998,
    "dropsitphn": 4073392744,
    "dropsitlph": 4073392744,
    "dropsitcph": 4073397288,
    "dropfax": 4073399315
  },
  {
    "dcode": "D",
    "dropkey": "PY21561",
    "droptype": "D",
    "dropname": "CEDAR KEY",
    "dropdeladd": "518 2ND ST",
    "dropdelcty": "CEDAR KEY",
    "dropdelst": "FL",
    "dropdelzpp": 326259998,
    "dropphyadd": "518 2ND ST",
    "dropphycty": "CEDAR KEY",
    "dropphyst": "FL",
    "dropphyzpp": 326259998,
    "dropmaladd": "518 2ND ST",
    "dropmalcty": "CEDAR KEY",
    "dropmalst": "FL",
    "dropmalzpp": 326259998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525435477,
    "dropsitcph": 3525435477,
    "dropfax": 3525436986
  },
  {
    "dcode": "D",
    "dropkey": "PY21566",
    "droptype": "D",
    "dropname": "CENTER HILL",
    "dropdeladd": "89 E KINGS HWY",
    "dropdelcty": "CENTER HILL",
    "dropdelst": "FL",
    "dropdelzpp": 335149997,
    "dropphyadd": "89 E KINGS HWY",
    "dropphycty": "CENTER HILL",
    "dropphyst": "FL",
    "dropphyzpp": 335149997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER HILL",
    "dropmalst": "FL",
    "dropmalzpp": 335149998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527932553,
    "dropfax": 3527932553
  },
  {
    "dcode": "D",
    "dropkey": "PY21570",
    "droptype": "D",
    "dropname": "CENTURY",
    "dropdeladd": "8450 N CENTURY BLVD",
    "dropdelcty": "CENTURY",
    "dropdelst": "FL",
    "dropdelzpp": 325359998,
    "dropphyadd": "8450 N CENTURY BLVD",
    "dropphycty": "CENTURY",
    "dropphyst": "FL",
    "dropphyzpp": 325359998,
    "dropmaladd": "8450 N CENTURY BLVD",
    "dropmalcty": "CENTURY",
    "dropmalst": "FL",
    "dropmalzpp": 325359998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502562376,
    "dropsitcph": 8502562376,
    "dropfax": 8502564814
  },
  {
    "dcode": "D",
    "dropkey": "PY21574",
    "droptype": "D",
    "dropname": "CHATTAHOOCHEE",
    "dropdeladd": "116 W WASHINGTON ST",
    "dropdelcty": "CHATTAHOOCHEE",
    "dropdelst": "FL",
    "dropdelzpp": 323249998,
    "dropphyadd": "116 W WASHINGTON ST",
    "dropphycty": "CHATTAHOOCHEE",
    "dropphyst": "FL",
    "dropphyzpp": 323249998,
    "dropmaladd": "116 W WASHINGTON ST",
    "dropmalcty": "CHATTAHOOCHEE",
    "dropmalst": "FL",
    "dropmalzpp": 323249998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506634416,
    "dropsitcph": 8506634416,
    "dropfax": 8506634111
  },
  {
    "dcode": "D",
    "dropkey": "PY21575",
    "droptype": "D",
    "dropname": "CHIEFLAND",
    "dropdeladd": "222 W PARK AVE",
    "dropdelcty": "CHIEFLAND",
    "dropdelst": "FL",
    "dropdelzpp": 326269998,
    "dropphyadd": "222 W PARK AVE",
    "dropphycty": "CHIEFLAND",
    "dropphyst": "FL",
    "dropphyzpp": 326269998,
    "dropmaladd": "222 W PARK AVE",
    "dropmalcty": "CHIEFLAND",
    "dropmalst": "FL",
    "dropmalzpp": 326269998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524932912,
    "dropsitcph": 3524932912,
    "dropfax": 3524934010
  },
  {
    "dcode": "D",
    "dropkey": "PY21576",
    "droptype": "D",
    "dropname": "CHIPLEY",
    "dropdeladd": "1276 CHURCH AVE",
    "dropdelcty": "CHIPLEY",
    "dropdelst": "FL",
    "dropdelzpp": 324289998,
    "dropphyadd": "1276 CHURCH AVE",
    "dropphycty": "CHIPLEY",
    "dropphyst": "FL",
    "dropphyzpp": 324289998,
    "dropmaladd": "1276 CHURCH AVE",
    "dropmalcty": "CHIPLEY",
    "dropmalst": "FL",
    "dropmalzpp": 324289998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506380101,
    "dropsitcph": 8506380101,
    "dropfax": 8506384444
  },
  {
    "dcode": "D",
    "dropkey": "PY21577",
    "droptype": "D",
    "dropname": "CHOKOLOSKEE",
    "dropdeladd": "195 SMALLWOOD DR",
    "dropdelcty": "CHOKOLOSKEE",
    "dropdelst": "FL",
    "dropdelzpp": 341381202,
    "dropphyadd": "195 SMALLWOOD DR",
    "dropphycty": "CHOKOLOSKEE",
    "dropphyst": "FL",
    "dropphyzpp": 341381202,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHOKOLOSKEE",
    "dropmalst": "FL",
    "dropmalzpp": 341389998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396954468,
    "dropfax": 2396954468
  },
  {
    "dcode": "D",
    "dropkey": "PY21579",
    "droptype": "D",
    "dropname": "CHRISTMAS",
    "dropdeladd": "23580 E COLONIAL DR",
    "dropdelcty": "CHRISTMAS",
    "dropdelst": "FL",
    "dropdelzpp": 327099998,
    "dropphyadd": "23580 E COLONIAL DR",
    "dropphycty": "CHRISTMAS",
    "dropphyst": "FL",
    "dropphyzpp": 327099998,
    "dropmaladd": "23580 E COLONIAL DR",
    "dropmalcty": "CHRISTMAS",
    "dropmalst": "FL",
    "dropmalzpp": 327099998,
    "dropsitphn": 4075682941,
    "dropsitlph": 4075682941,
    "dropsitcph": 4075682941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21583",
    "droptype": "D",
    "dropname": "CITRA",
    "dropdeladd": "2250 E HIGHWAY 318",
    "dropdelcty": "CITRA",
    "dropdelst": "FL",
    "dropdelzpp": 321139998,
    "dropphyadd": "2250 E HIGHWAY 318",
    "dropphycty": "CITRA",
    "dropphyst": "FL",
    "dropphyzpp": 321139998,
    "dropmaladd": "2250 E HIGHWAY 318",
    "dropmalcty": "CITRA",
    "dropmalst": "FL",
    "dropmalzpp": 321139998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525953021,
    "dropsitcph": 3525953021,
    "dropfax": 3525958142
  },
  {
    "dcode": "D",
    "dropkey": "PY21590",
    "droptype": "D",
    "dropname": "CLARCONA",
    "dropdeladd": "7228 CLARCONA OCOEE RD",
    "dropdelcty": "CLARCONA",
    "dropdelst": "FL",
    "dropdelzpp": 327101209,
    "dropphyadd": "7228 CLARCONA OCOEE RD",
    "dropphycty": "CLARCONA",
    "dropphyst": "FL",
    "dropphyzpp": 327101209,
    "dropmaladd": "PO BOX 109998",
    "dropmalcty": "CLARCONA",
    "dropmalst": "FL",
    "dropmalzpp": 327109998,
    "dropsitphn": 4072992633,
    "dropsitlph": 4072992633,
    "dropsitcph": 4072992633,
    "dropfax": 4072992633
  },
  {
    "dcode": "D",
    "dropkey": "PY21591",
    "droptype": "D",
    "dropname": "CLARKSVILLE",
    "dropdeladd": "11351 STATE ROAD 20 W",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 324309998,
    "dropphyadd": "11351 STATE ROAD 20 W",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 324309998,
    "dropmaladd": "11351 STATE ROAD 20 W",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 324309998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506748783,
    "dropsitcph": 8506748783,
    "dropfax": 8506748783
  },
  {
    "dcode": "D",
    "dropkey": "PY21592",
    "droptype": "D",
    "dropname": "CLEARWATER",
    "dropdeladd": "100 S BELCHER RD",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "FL",
    "dropdelzpp": 337659998,
    "dropphyadd": "100 S BELCHER RD",
    "dropphycty": "CLEARWATER",
    "dropphyst": "FL",
    "dropphyzpp": 337659998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "FL",
    "dropmalzpp": 337589998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7274642906,
    "dropfax": 7274642951
  },
  {
    "dcode": "D",
    "dropkey": "PY21598",
    "droptype": "D",
    "dropname": "CLERMONT",
    "dropdeladd": "877 W MINNEOLA AVE",
    "dropdelcty": "CLERMONT",
    "dropdelst": "FL",
    "dropdelzpp": 347119998,
    "dropphyadd": "877 W MINNEOLA AVE",
    "dropphycty": "CLERMONT",
    "dropphyst": "FL",
    "dropphyzpp": 347119998,
    "dropmaladd": "877 W MINNEOLA AVE",
    "dropmalcty": "CLERMONT",
    "dropmalst": "FL",
    "dropmalzpp": 347119998,
    "dropsitphn": 3522417073,
    "dropsitlph": 3522417073,
    "dropsitcph": 3522417073,
    "dropfax": 3523948639
  },
  {
    "dcode": "D",
    "dropkey": "PY21602",
    "droptype": "D",
    "dropname": "CLEWISTON",
    "dropdeladd": "400 S BERNER RD",
    "dropdelcty": "CLEWISTON",
    "dropdelst": "FL",
    "dropdelzpp": 334409998,
    "dropphyadd": "400 S BERNER RD",
    "dropphycty": "CLEWISTON",
    "dropphyst": "FL",
    "dropphyzpp": 334409998,
    "dropmaladd": "400 S BERNER RD",
    "dropmalcty": "CLEWISTON",
    "dropmalst": "FL",
    "dropmalzpp": 334409998,
    "dropsitphn": 8633016005,
    "dropsitlph": 8633016005,
    "dropsitcph": 8639838570,
    "dropfax": 8639831118
  },
  {
    "dcode": "D",
    "dropkey": "PY21604",
    "droptype": "D",
    "dropname": "COCOA",
    "dropdeladd": "2000 STATE ROAD 524",
    "dropdelcty": "COCOA",
    "dropdelst": "FL",
    "dropdelzpp": 329269998,
    "dropphyadd": "2000 STATE ROAD 524",
    "dropphycty": "COCOA",
    "dropphyst": "FL",
    "dropphyzpp": 329269998,
    "dropmaladd": "2000 STATE ROAD 524",
    "dropmalcty": "COCOA",
    "dropmalst": "FL",
    "dropmalzpp": 329269998,
    "dropsitphn": 3216364015,
    "dropsitlph": 3216364015,
    "dropsitcph": 3216327190,
    "dropfax": 3216371623
  },
  {
    "dcode": "D",
    "dropkey": "PY21605",
    "droptype": "D",
    "dropname": "COCOA BEACH",
    "dropdeladd": "500 N BREVARD AVE",
    "dropdelcty": "COCOA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329319998,
    "dropphyadd": "500 N BREVARD AVE",
    "dropphycty": "COCOA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329319998,
    "dropmaladd": "500 N BREVARD AVE",
    "dropmalcty": "COCOA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329319998,
    "dropsitphn": 3217833433,
    "dropsitlph": 3217833433,
    "dropsitcph": 3217833433,
    "dropfax": 3217842189
  },
  {
    "dcode": "D",
    "dropkey": "PY21613",
    "droptype": "D",
    "dropname": "COLEMAN",
    "dropdeladd": "1109 FLORIDA AVE",
    "dropdelcty": "COLEMAN",
    "dropdelst": "FL",
    "dropdelzpp": 335219700,
    "dropphyadd": "1109 FLORIDA AVE",
    "dropphycty": "COLEMAN",
    "dropphyst": "FL",
    "dropphyzpp": 335219700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLEMAN",
    "dropmalst": "FL",
    "dropmalzpp": 335219998,
    "dropsitphn": 8138770729,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527491811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21626",
    "droptype": "D",
    "dropname": "COPELAND",
    "dropdeladd": "601 COLLIER AVE",
    "dropdelcty": "EVERGLADES CITY",
    "dropdelst": "FL",
    "dropdelzpp": 341399801,
    "dropphyadd": "601 COLLIER AVE",
    "dropphycty": "EVERGLADES CITY",
    "dropphyst": "FL",
    "dropphyzpp": 341399801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPELAND",
    "dropmalst": "FL",
    "dropmalzpp": 341379998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396952202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21639",
    "droptype": "D",
    "dropname": "CORTEZ",
    "dropdeladd": "12112 44TH AVE W",
    "dropdelcty": "CORTEZ",
    "dropdelst": "FL",
    "dropdelzpp": 342159700,
    "dropphyadd": "12112 44TH AVE W",
    "dropphycty": "CORTEZ",
    "dropphyst": "FL",
    "dropphyzpp": 342159700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORTEZ",
    "dropmalst": "FL",
    "dropmalzpp": 342159998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417941219,
    "dropfax": 9417614473
  },
  {
    "dcode": "D",
    "dropkey": "PY21641",
    "droptype": "D",
    "dropname": "COTTONDALE",
    "dropdeladd": "3155 MAIN ST",
    "dropdelcty": "COTTONDALE",
    "dropdelst": "FL",
    "dropdelzpp": 324319998,
    "dropphyadd": "3155 MAIN ST",
    "dropphycty": "COTTONDALE",
    "dropphyst": "FL",
    "dropphyzpp": 324319998,
    "dropmaladd": "3155 MAIN ST",
    "dropmalcty": "COTTONDALE",
    "dropmalst": "FL",
    "dropmalzpp": 324319998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8503591210,
    "dropsitcph": 8503591210,
    "dropfax": 6505775080
  },
  {
    "dcode": "D",
    "dropkey": "PY21647",
    "droptype": "D",
    "dropname": "CRAWFORDVILLE",
    "dropdeladd": "606 WAKULLA ARRAN RD",
    "dropdelcty": "CRAWFORDVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 323272002,
    "dropphyadd": "606 WAKULLA ARRAN RD",
    "dropphycty": "CRAWFORDVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 323272002,
    "dropmaladd": "606 WAKULLA ARRAN RD",
    "dropmalcty": "CRAWFORDVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 323272002,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509263256,
    "dropsitcph": 8509263256,
    "dropfax": 8509262153
  },
  {
    "dcode": "D",
    "dropkey": "PY21651",
    "droptype": "D",
    "dropname": "CRESCENT CITY",
    "dropdeladd": "403 N SUMMIT ST",
    "dropdelcty": "CRESCENT CITY",
    "dropdelst": "FL",
    "dropdelzpp": 321129998,
    "dropphyadd": "403 N SUMMIT ST",
    "dropphycty": "CRESCENT CITY",
    "dropphyst": "FL",
    "dropphyzpp": 321129998,
    "dropmaladd": "403 N SUMMIT ST",
    "dropmalcty": "CRESCENT CITY",
    "dropmalst": "FL",
    "dropmalzpp": 321129998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866981538,
    "dropsitcph": 3866981538,
    "dropfax": 9046981219
  },
  {
    "dcode": "D",
    "dropkey": "PY21652",
    "droptype": "D",
    "dropname": "CRESTVIEW",
    "dropdeladd": "1325 COMMERCE DR",
    "dropdelcty": "CRESTVIEW",
    "dropdelst": "FL",
    "dropdelzpp": 325399998,
    "dropphyadd": "1325 COMMERCE DR",
    "dropphycty": "CRESTVIEW",
    "dropphyst": "FL",
    "dropphyzpp": 325399998,
    "dropmaladd": "1325 COMMERCE DR",
    "dropmalcty": "CRESTVIEW",
    "dropmalst": "FL",
    "dropmalzpp": 325399998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506822634,
    "dropsitcph": 8506822634,
    "dropfax": 8506821601
  },
  {
    "dcode": "D",
    "dropkey": "PY21655",
    "droptype": "D",
    "dropname": "CROSS CITY",
    "dropdeladd": "151 SW CEDAR ST",
    "dropdelcty": "CROSS CITY",
    "dropdelst": "FL",
    "dropdelzpp": 326282105,
    "dropphyadd": "151 SW CEDAR ST",
    "dropphycty": "CROSS CITY",
    "dropphyst": "FL",
    "dropphyzpp": 326282105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSS CITY",
    "dropmalst": "FL",
    "dropmalzpp": 326289998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524985337,
    "dropsitcph": 3524985337,
    "dropfax": 3524985263
  },
  {
    "dcode": "D",
    "dropkey": "PY21663",
    "droptype": "D",
    "dropname": "CRYSTAL BEACH",
    "dropdeladd": "420 CRYSTAL BEACH AVE",
    "dropdelcty": "CRYSTAL BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 346819803,
    "dropphyadd": "420 CRYSTAL BEACH AVE",
    "dropphycty": "CRYSTAL BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 346819803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 346819998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7277845029,
    "dropfax": 7277841735
  },
  {
    "dcode": "D",
    "dropkey": "PY21665",
    "droptype": "D",
    "dropname": "CRYSTAL RIVER",
    "dropdeladd": "18 NE 4TH AVE",
    "dropdelcty": "CRYSTAL RIVER",
    "dropdelst": "FL",
    "dropdelzpp": 344299998,
    "dropphyadd": "18 NE 4TH AVE",
    "dropphycty": "CRYSTAL RIVER",
    "dropphyst": "FL",
    "dropphyzpp": 344299998,
    "dropmaladd": "18 NE 4TH AVE",
    "dropmalcty": "CRYSTAL RIVER",
    "dropmalst": "FL",
    "dropmalzpp": 344299998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527951151,
    "dropsitcph": 3527952030,
    "dropfax": 3527955903
  },
  {
    "dcode": "D",
    "dropkey": "PY21667",
    "droptype": "D",
    "dropname": "CRYSTAL SPRINGS",
    "dropdeladd": "1425 PAUL S BUCHMAN HWY",
    "dropdelcty": "CRYSTAL SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 335249700,
    "dropphyadd": "1425 PAUL S BUCHMAN HWY",
    "dropphycty": "CRYSTAL SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 335249700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 335249998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8137150955,
    "dropfax": 8137150955
  },
  {
    "dcode": "D",
    "dropkey": "PY21672",
    "droptype": "D",
    "dropname": "CYPRESS",
    "dropdeladd": "2045 MAIN ST",
    "dropdelcty": "CYPRESS",
    "dropdelst": "FL",
    "dropdelzpp": 324329998,
    "dropphyadd": "2045 MAIN ST",
    "dropphycty": "CYPRESS",
    "dropphyst": "FL",
    "dropphyzpp": 324329998,
    "dropmaladd": "2045 MAIN ST",
    "dropmalcty": "CYPRESS",
    "dropmalst": "FL",
    "dropmalzpp": 324329998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505928815,
    "dropsitcph": 8505928815,
    "dropfax": 8505928295
  },
  {
    "dcode": "D",
    "dropkey": "PY21678",
    "droptype": "D",
    "dropname": "DADE CITY",
    "dropdeladd": "37926 CHURCH AVE",
    "dropdelcty": "DADE CITY",
    "dropdelst": "FL",
    "dropdelzpp": 335259998,
    "dropphyadd": "37926 CHURCH AVE",
    "dropphycty": "DADE CITY",
    "dropphyst": "FL",
    "dropphyzpp": 335259998,
    "dropmaladd": "37926 CHURCH AVE",
    "dropmalcty": "DADE CITY",
    "dropmalst": "FL",
    "dropmalzpp": 335259998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3525679369,
    "dropfax": 3525677327
  },
  {
    "dcode": "D",
    "dropkey": "PY21680",
    "droptype": "D",
    "dropname": "DANIA",
    "dropdeladd": "21 NW 1ST AVE",
    "dropdelcty": "DANIA",
    "dropdelst": "FL",
    "dropdelzpp": 330049998,
    "dropphyadd": "21 NW 1ST AVE",
    "dropphycty": "DANIA",
    "dropphyst": "FL",
    "dropphyzpp": 330049998,
    "dropmaladd": "21 NW 1ST AVE",
    "dropmalcty": "DANIA",
    "dropmalst": "FL",
    "dropmalzpp": 330049998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549225401,
    "dropsitcph": 9549203108,
    "dropfax": 9549235147
  },
  {
    "dcode": "D",
    "dropkey": "PY21681",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "1 SOUTH BLVD E",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "FL",
    "dropdelzpp": 338379998,
    "dropphyadd": "1 SOUTH BLVD E",
    "dropphycty": "DAVENPORT",
    "dropphyst": "FL",
    "dropphyzpp": 338379998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "FL",
    "dropmalzpp": 338369998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634224451,
    "dropfax": 8634225031
  },
  {
    "dcode": "D",
    "dropkey": "PY21684",
    "droptype": "D",
    "dropname": "DAY",
    "dropdeladd": "4573 N COUNTY ROAD 53",
    "dropdelcty": "DAY",
    "dropdelst": "FL",
    "dropdelzpp": 320139998,
    "dropphyadd": "4573 N COUNTY ROAD 53",
    "dropphycty": "DAY",
    "dropphyst": "FL",
    "dropphyzpp": 320139998,
    "dropmaladd": "4573 N COUNTY ROAD 53",
    "dropmalcty": "DAY",
    "dropmalst": "FL",
    "dropmalzpp": 320139998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3862942290,
    "dropsitcph": 3862942290,
    "dropfax": 9042942290
  },
  {
    "dcode": "D",
    "dropkey": "PY21688",
    "droptype": "D",
    "dropname": "DAYTONA BEACH",
    "dropdeladd": "500 BILL FRANCE BLVD",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321149998,
    "dropphyadd": "500 BILL FRANCE BLVD",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321149998,
    "dropmaladd": "500 BILL FRANCE BLVD",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321149998,
    "dropsitphn": 3862746327,
    "dropsitlph": 3862746327,
    "dropsitcph": 3862746327,
    "dropfax": 3862743500
  },
  {
    "dcode": "D",
    "dropkey": "PY21692",
    "droptype": "D",
    "dropname": "DEFUNIAK SPRINGS",
    "dropdeladd": "100 S 18TH ST",
    "dropdelcty": "DEFUNIAK SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 324359998,
    "dropphyadd": "100 S 18TH ST",
    "dropphycty": "DEFUNIAK SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 324359998,
    "dropmaladd": "100 S 18TH ST",
    "dropmalcty": "DEFUNIAK SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 324359998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508925714,
    "dropsitcph": 8508925714,
    "dropfax": 8508924767
  },
  {
    "dcode": "D",
    "dropkey": "PY21694",
    "droptype": "D",
    "dropname": "DE LEON SPRINGS",
    "dropdeladd": "155 PONCE DELEON BLVD",
    "dropdelcty": "DE LEON SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 321303305,
    "dropphyadd": "155 PONCE DELEON BLVD",
    "dropphycty": "DE LEON SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 321303305,
    "dropmaladd": "155 PONCE DELEON BLVD",
    "dropmalcty": "DE LEON SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 321309998,
    "dropsitphn": 4073338416,
    "dropsitlph": 3869854326,
    "dropsitcph": 3869854326,
    "dropfax": 3869851904
  },
  {
    "dcode": "D",
    "dropkey": "PY21696",
    "droptype": "D",
    "dropname": "DEBARY",
    "dropdeladd": "133 S CHARLES RICHARD BEALL BLVD",
    "dropdelcty": "DEBARY",
    "dropdelst": "FL",
    "dropdelzpp": 327139998,
    "dropphyadd": "133 S CHARLES RICHARD BEALL BLVD",
    "dropphycty": "DEBARY",
    "dropphyst": "FL",
    "dropphyzpp": 327139998,
    "dropmaladd": "PO BOX 539998",
    "dropmalcty": "DEBARY",
    "dropmalst": "FL",
    "dropmalzpp": 327539998,
    "dropsitphn": 3866685468,
    "dropsitlph": 3866685468,
    "dropsitcph": 3866685468,
    "dropfax": 3866687193
  },
  {
    "dcode": "D",
    "dropkey": "PY21699",
    "droptype": "D",
    "dropname": "DEERFIELD BEACH",
    "dropdeladd": "212 E HILLSBORO BLVD",
    "dropdelcty": "DEERFIELD BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334419998,
    "dropphyadd": "212 E HILLSBORO BLVD",
    "dropphycty": "DEERFIELD BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334419998,
    "dropmaladd": "212 E HILLSBORO BLVD",
    "dropmalcty": "DEERFIELD BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334419998,
    "dropsitphn": 9544219435,
    "dropsitlph": 9544219435,
    "dropsitcph": 9544210812,
    "dropfax": 9544819725
  },
  {
    "dcode": "D",
    "dropkey": "PY21703",
    "droptype": "D",
    "dropname": "DELAND",
    "dropdeladd": "336 E NEW YORK AVE",
    "dropdelcty": "DELAND",
    "dropdelst": "FL",
    "dropdelzpp": 327249998,
    "dropphyadd": "336 E NEW YORK AVE",
    "dropphycty": "DELAND",
    "dropphyst": "FL",
    "dropphyzpp": 327249998,
    "dropmaladd": "336 E NEW YORK AVE",
    "dropmalcty": "DELAND",
    "dropmalst": "FL",
    "dropmalzpp": 327249998,
    "dropsitphn": 3869433725,
    "dropsitlph": 3869433725,
    "dropsitcph": 3869433725,
    "dropfax": 3868225575
  },
  {
    "dcode": "D",
    "dropkey": "PY21705",
    "droptype": "D",
    "dropname": "DELRAY BEACH",
    "dropdeladd": "14280 S MILITARY TRL",
    "dropdelcty": "DELRAY BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334849998,
    "dropphyadd": "14280 S MILITARY TRL",
    "dropphycty": "DELRAY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334849998,
    "dropmaladd": "PO BOX 829998",
    "dropmalcty": "DELRAY BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334829998,
    "dropsitphn": 5616377779,
    "dropsitlph": 5616377779,
    "dropsitcph": 5616389468,
    "dropfax": 5614982942
  },
  {
    "dcode": "D",
    "dropkey": "PY21708",
    "droptype": "D",
    "dropname": "DESTIN",
    "dropdeladd": "175 MAIN ST",
    "dropdelcty": "DESTIN",
    "dropdelst": "FL",
    "dropdelzpp": 325419998,
    "dropphyadd": "175 MAIN ST",
    "dropphycty": "DESTIN",
    "dropphyst": "FL",
    "dropphyzpp": 325419998,
    "dropmaladd": "175 MAIN ST",
    "dropmalcty": "DESTIN",
    "dropmalst": "FL",
    "dropmalzpp": 325419998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508376312,
    "dropsitcph": 8508376312,
    "dropfax": 8508376739
  },
  {
    "dcode": "D",
    "dropkey": "PY21718",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "14170 DR MARTIN LUTHER KING JR BLVD",
    "dropdelcty": "DOVER",
    "dropdelst": "FL",
    "dropdelzpp": 335279998,
    "dropphyadd": "14170 DR MARTIN LUTHER KING JR BLVD",
    "dropphycty": "DOVER",
    "dropphyst": "FL",
    "dropphyzpp": 335279998,
    "dropmaladd": "14170 DR MARTIN LUTHER KING JR BLVD",
    "dropmalcty": "DOVER",
    "dropmalst": "FL",
    "dropmalzpp": 335279998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8137070929,
    "dropfax": 8137071003
  },
  {
    "dcode": "D",
    "dropkey": "PY21746",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "103 ATLANTIC AVE",
    "dropdelcty": "DUNDEE",
    "dropdelst": "FL",
    "dropdelzpp": 338387000,
    "dropphyadd": "103 ATLANTIC AVE",
    "dropphycty": "DUNDEE",
    "dropphyst": "FL",
    "dropphyzpp": 338387000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNDEE",
    "dropmalst": "FL",
    "dropmalzpp": 338389998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634390617,
    "dropfax": 8634396209
  },
  {
    "dcode": "D",
    "dropkey": "PY21747",
    "droptype": "D",
    "dropname": "DUNEDIN",
    "dropdeladd": "1350 COUNTY ROAD 1",
    "dropdelcty": "DUNEDIN",
    "dropdelst": "FL",
    "dropdelzpp": 346989998,
    "dropphyadd": "1350 COUNTY ROAD 1",
    "dropphycty": "DUNEDIN",
    "dropphyst": "FL",
    "dropphyzpp": 346989998,
    "dropmaladd": "1350 COUNTY ROAD 1",
    "dropmalcty": "DUNEDIN",
    "dropmalst": "FL",
    "dropmalzpp": 346989998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7277380661,
    "dropfax": 7277345613
  },
  {
    "dcode": "D",
    "dropkey": "PY21750",
    "droptype": "D",
    "dropname": "DUNNELLON",
    "dropdeladd": "11432 N WILLIAMS ST",
    "dropdelcty": "DUNNELLON",
    "dropdelst": "FL",
    "dropdelzpp": 344329998,
    "dropphyadd": "11432 N WILLIAMS ST",
    "dropphycty": "DUNNELLON",
    "dropphyst": "FL",
    "dropphyzpp": 344329998,
    "dropmaladd": "11432 N WILLIAMS ST",
    "dropmalcty": "DUNNELLON",
    "dropmalst": "FL",
    "dropmalzpp": 344329998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524894224,
    "dropsitcph": 3524894224,
    "dropfax": 3524897489
  },
  {
    "dcode": "D",
    "dropkey": "PY21751",
    "droptype": "D",
    "dropname": "DURANT",
    "dropdeladd": "7202 TURKEY CREEK RD",
    "dropdelcty": "DURANT",
    "dropdelst": "FL",
    "dropdelzpp": 335309700,
    "dropphyadd": "7202 TURKEY CREEK RD",
    "dropphycty": "DURANT",
    "dropphyst": "FL",
    "dropphyzpp": 335309700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DURANT",
    "dropmalst": "FL",
    "dropmalzpp": 335309998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8137371900,
    "dropfax": 8137371900
  },
  {
    "dcode": "D",
    "dropkey": "PY21756",
    "droptype": "D",
    "dropname": "EAGLE LAKE",
    "dropdeladd": "665 N US HIGHWAY 17",
    "dropdelcty": "EAGLE LAKE",
    "dropdelst": "FL",
    "dropdelzpp": 338393071,
    "dropphyadd": "665 N US HIGHWAY 17",
    "dropphycty": "EAGLE LAKE",
    "dropphyst": "FL",
    "dropphyzpp": 338393071,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE LAKE",
    "dropmalst": "FL",
    "dropmalzpp": 338399998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8632955260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21758",
    "droptype": "D",
    "dropname": "EARLETON",
    "dropdeladd": "10012 NE COUNTY ROAD 1469",
    "dropdelcty": "EARLETON",
    "dropdelst": "FL",
    "dropdelzpp": 326319701,
    "dropphyadd": "10012 NE COUNTY ROAD 1469",
    "dropphycty": "EARLETON",
    "dropphyst": "FL",
    "dropphyzpp": 326319701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EARLETON",
    "dropmalst": "FL",
    "dropmalzpp": 326319998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524682566,
    "dropsitcph": 3524682566,
    "dropfax": 3524681417
  },
  {
    "dcode": "D",
    "dropkey": "PY21769",
    "droptype": "D",
    "dropname": "EAST PALATKA",
    "dropdeladd": "134 W MCCORMICK RD",
    "dropdelcty": "EAST PALATKA",
    "dropdelst": "FL",
    "dropdelzpp": 321319998,
    "dropphyadd": "134 W MCCORMICK RD",
    "dropphycty": "EAST PALATKA",
    "dropphyst": "FL",
    "dropphyzpp": 321319998,
    "dropmaladd": "134 W MCCORMICK RD",
    "dropmalcty": "EAST PALATKA",
    "dropmalst": "FL",
    "dropmalzpp": 321319998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863254071,
    "dropsitcph": 3863254071,
    "dropfax": 3863251888
  },
  {
    "dcode": "D",
    "dropkey": "PY21775",
    "droptype": "D",
    "dropname": "EASTLAKE WEIR",
    "dropdeladd": "13803 S HIGHWAY 25",
    "dropdelcty": "EASTLAKE WEIR",
    "dropdelst": "FL",
    "dropdelzpp": 321330070,
    "dropphyadd": "13803 S HIGHWAY 25",
    "dropphycty": "EASTLAKE WEIR",
    "dropphyst": "FL",
    "dropphyzpp": 321330070,
    "dropmaladd": "13803 S HIGHWAY 25",
    "dropmalcty": "EASTLAKE WEIR",
    "dropmalst": "FL",
    "dropmalzpp": 321339998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522885661,
    "dropsitcph": 3522885661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21776",
    "droptype": "D",
    "dropname": "EASTPOINT",
    "dropdeladd": "353 US HIGHWAY 98",
    "dropdelcty": "EASTPOINT",
    "dropdelst": "FL",
    "dropdelzpp": 323289998,
    "dropphyadd": "353 US HIGHWAY 98",
    "dropphycty": "EASTPOINT",
    "dropphyst": "FL",
    "dropphyzpp": 323289998,
    "dropmaladd": "353 US HIGHWAY 98",
    "dropmalcty": "EASTPOINT",
    "dropmalst": "FL",
    "dropmalzpp": 323289998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506708698,
    "dropsitcph": 8506708698,
    "dropfax": 8506704391
  },
  {
    "dcode": "D",
    "dropkey": "PY21778",
    "droptype": "D",
    "dropname": "EATON PARK",
    "dropdeladd": "2615 ELLIS AVE",
    "dropdelcty": "EATON PARK",
    "dropdelst": "FL",
    "dropdelzpp": 338409700,
    "dropphyadd": "2615 ELLIS AVE",
    "dropphycty": "EATON PARK",
    "dropphyst": "FL",
    "dropphyzpp": 338409700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EATON PARK",
    "dropmalst": "FL",
    "dropmalzpp": 338409998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636663391,
    "dropfax": 8636663391
  },
  {
    "dcode": "D",
    "dropkey": "PY21783",
    "droptype": "D",
    "dropname": "EBRO",
    "dropdeladd": "5416 OBIES ST",
    "dropdelcty": "EBRO",
    "dropdelst": "FL",
    "dropdelzpp": 324379998,
    "dropphyadd": "5416 OBIES ST",
    "dropphycty": "EBRO",
    "dropphyst": "FL",
    "dropphyzpp": 324379998,
    "dropmaladd": "5416 OBIES ST",
    "dropmalcty": "EBRO",
    "dropmalst": "FL",
    "dropmalzpp": 324379998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505354424,
    "dropsitcph": 8505354424,
    "dropfax": 8505356774
  },
  {
    "dcode": "D",
    "dropkey": "PY21785",
    "droptype": "D",
    "dropname": "EDGEWATER",
    "dropdeladd": "400 S RIDGEWOOD AVE",
    "dropdelcty": "EDGEWATER",
    "dropdelst": "FL",
    "dropdelzpp": 321329998,
    "dropphyadd": "400 S RIDGEWOOD AVE",
    "dropphycty": "EDGEWATER",
    "dropphyst": "FL",
    "dropphyzpp": 321329998,
    "dropmaladd": "400 S RIDGEWOOD AVE",
    "dropmalcty": "EDGEWATER",
    "dropmalst": "FL",
    "dropmalzpp": 321329998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864286656,
    "dropsitcph": 3864286656,
    "dropfax": 3864262204
  },
  {
    "dcode": "D",
    "dropkey": "PY21789",
    "droptype": "D",
    "dropname": "EGLIN AFB",
    "dropdeladd": "307 W VAN MATRE AVE",
    "dropdelcty": "EGLIN AFB",
    "dropdelst": "FL",
    "dropdelzpp": 325429998,
    "dropphyadd": "307 W VAN MATRE AVE",
    "dropphycty": "EGLIN AFB",
    "dropphyst": "FL",
    "dropphyzpp": 325429998,
    "dropmaladd": "307 W VAN MATRE AVE",
    "dropmalcty": "EGLIN AFB",
    "dropmalst": "FL",
    "dropmalzpp": 325429998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508823548,
    "dropsitcph": 8508823548,
    "dropfax": 8508823243
  },
  {
    "dcode": "D",
    "dropkey": "PY21794",
    "droptype": "D",
    "dropname": "ELFERS",
    "dropdeladd": "4122 MADISON ST",
    "dropdelcty": "ELFERS",
    "dropdelst": "FL",
    "dropdelzpp": 346809801,
    "dropphyadd": "4122 MADISON ST",
    "dropphycty": "ELFERS",
    "dropphyst": "FL",
    "dropphyzpp": 346809801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELFERS",
    "dropmalst": "FL",
    "dropmalzpp": 346809998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278497438,
    "dropfax": 7278497348
  },
  {
    "dcode": "D",
    "dropkey": "PY21795",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "5785 COUNTY ROAD 305",
    "dropdelcty": "ELKTON",
    "dropdelst": "FL",
    "dropdelzpp": 320339998,
    "dropphyadd": "5785 COUNTY ROAD 305",
    "dropphycty": "ELKTON",
    "dropphyst": "FL",
    "dropphyzpp": 320339998,
    "dropmaladd": "5785 COUNTY ROAD 305",
    "dropmalcty": "ELKTON",
    "dropmalst": "FL",
    "dropmalzpp": 320339998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9046922099,
    "dropsitcph": 9046922099,
    "dropfax": 9046922099
  },
  {
    "dcode": "D",
    "dropkey": "PY21796",
    "droptype": "D",
    "dropname": "ELLENTON",
    "dropdeladd": "2605 72ND AVE E",
    "dropdelcty": "ELLENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342229998,
    "dropphyadd": "2605 72ND AVE E",
    "dropphycty": "ELLENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342229998,
    "dropmaladd": "2605 72ND AVE E",
    "dropmalcty": "ELLENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342229998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417296459,
    "dropfax": 9417233521
  },
  {
    "dcode": "D",
    "dropkey": "PY21800",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "950 S RIVER RD",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 342239998,
    "dropphyadd": "950 S RIVER RD",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 342239998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 342959998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414758372,
    "dropfax": 9414730913
  },
  {
    "dcode": "D",
    "dropkey": "PY21805",
    "droptype": "D",
    "dropname": "ESTERO",
    "dropdeladd": "20791 THREE OAKS PKWY",
    "dropdelcty": "ESTERO",
    "dropdelst": "FL",
    "dropdelzpp": 339283194,
    "dropphyadd": "20791 THREE OAKS PKWY",
    "dropphycty": "ESTERO",
    "dropphyst": "FL",
    "dropphyzpp": 339283194,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESTERO",
    "dropmalst": "FL",
    "dropmalzpp": 339299998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393900823,
    "dropfax": 2399489642
  },
  {
    "dcode": "D",
    "dropkey": "PY21809",
    "droptype": "D",
    "dropname": "EUSTIS",
    "dropdeladd": "111 E CLIFFORD AVE",
    "dropdelcty": "EUSTIS",
    "dropdelst": "FL",
    "dropdelzpp": 327269998,
    "dropphyadd": "111 E CLIFFORD AVE",
    "dropphycty": "EUSTIS",
    "dropphyst": "FL",
    "dropphyzpp": 327269998,
    "dropmaladd": "111 E CLIFFORD AVE",
    "dropmalcty": "EUSTIS",
    "dropmalst": "FL",
    "dropmalzpp": 327269998,
    "dropsitphn": 3525890541,
    "dropsitlph": 3525890541,
    "dropsitcph": 3523574530,
    "dropfax": 3523574211
  },
  {
    "dcode": "D",
    "dropkey": "PY21812",
    "droptype": "D",
    "dropname": "EVERGLADES CITY",
    "dropdeladd": "601 COLLIER AVE",
    "dropdelcty": "EVERGLADES CITY",
    "dropdelst": "FL",
    "dropdelzpp": 341399800,
    "dropphyadd": "601 COLLIER AVE",
    "dropphycty": "EVERGLADES CITY",
    "dropphyst": "FL",
    "dropphyzpp": 341399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERGLADES CITY",
    "dropmalst": "FL",
    "dropmalzpp": 341399998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396952174,
    "dropfax": 2396950380
  },
  {
    "dcode": "D",
    "dropkey": "PY21814",
    "droptype": "D",
    "dropname": "EVINSTON",
    "dropdeladd": "18320 SE COUNTY ROAD 225",
    "dropdelcty": "EVINSTON",
    "dropdelst": "FL",
    "dropdelzpp": 326339998,
    "dropphyadd": "18320 SE COUNTY ROAD 225",
    "dropphycty": "EVINSTON",
    "dropphyst": "FL",
    "dropphyzpp": 326339998,
    "dropmaladd": "18320 SE COUNTY ROAD 225",
    "dropmalcty": "EVINSTON",
    "dropmalst": "FL",
    "dropmalzpp": 326339998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525914100,
    "dropsitcph": 3525914100,
    "dropfax": 3523592807
  },
  {
    "dcode": "D",
    "dropkey": "PY21817",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "14990 N HIGHWAY 225",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "FL",
    "dropdelzpp": 326349700,
    "dropphyadd": "14990 N HIGHWAY 225",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "FL",
    "dropphyzpp": 326349700,
    "dropmaladd": "14990 N HIGHWAY 225",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "FL",
    "dropmalzpp": 326349998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525912201,
    "dropsitcph": 3525912201,
    "dropfax": 3525913027
  },
  {
    "dcode": "D",
    "dropkey": "PY21822",
    "droptype": "D",
    "dropname": "FELDA",
    "dropdeladd": "14815 S STATE ROAD 29",
    "dropdelcty": "FELDA",
    "dropdelst": "FL",
    "dropdelzpp": 339309800,
    "dropphyadd": "14815 S STATE ROAD 29",
    "dropphycty": "FELDA",
    "dropphyst": "FL",
    "dropphyzpp": 339309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FELDA",
    "dropmalst": "FL",
    "dropmalzpp": 339309998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8637688083,
    "dropsitcph": 8636754783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21823",
    "droptype": "D",
    "dropname": "FELLSMERE",
    "dropdeladd": "15 N OAK ST",
    "dropdelcty": "FELLSMERE",
    "dropdelst": "FL",
    "dropdelzpp": 329489998,
    "dropphyadd": "15 N OAK ST",
    "dropphycty": "FELLSMERE",
    "dropphyst": "FL",
    "dropphyzpp": 329489998,
    "dropmaladd": "15 N OAK ST",
    "dropmalcty": "FELLSMERE",
    "dropmalst": "FL",
    "dropmalzpp": 329489998,
    "dropsitphn": 7725719791,
    "dropsitlph": 7725719791,
    "dropsitcph": 7725718315,
    "dropfax": 7725719822
  },
  {
    "dcode": "D",
    "dropkey": "PY21828",
    "droptype": "D",
    "dropname": "FERNANDINA BEACH",
    "dropdeladd": "1997 SADLER RD",
    "dropdelcty": "FERNANDINA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 320349998,
    "dropphyadd": "1997 SADLER RD",
    "dropphycty": "FERNANDINA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 320349998,
    "dropmaladd": "1997 SADLER RD",
    "dropmalcty": "FERNANDINA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 320349998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9044914680,
    "dropsitcph": 9044914680,
    "dropfax": 9042777947
  },
  {
    "dcode": "D",
    "dropkey": "PY21849",
    "droptype": "D",
    "dropname": "FLAGLER BEACH",
    "dropdeladd": "300 S DAYTONA AVE",
    "dropdelcty": "FLAGLER BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321363607,
    "dropphyadd": "300 S DAYTONA AVE",
    "dropphycty": "FLAGLER BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321363607,
    "dropmaladd": "300 S DAYTONA AVE",
    "dropmalcty": "FLAGLER BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321369998,
    "dropsitphn": 3864395944,
    "dropsitlph": 3864394826,
    "dropsitcph": 3864397347,
    "dropfax": 3864390280
  },
  {
    "dcode": "D",
    "dropkey": "PY21857",
    "droptype": "D",
    "dropname": "FLORAHOME",
    "dropdeladd": "101 N IVY AVE",
    "dropdelcty": "FLORAHOME",
    "dropdelst": "FL",
    "dropdelzpp": 321402870,
    "dropphyadd": "101 N IVY AVE",
    "dropphycty": "FLORAHOME",
    "dropphyst": "FL",
    "dropphyzpp": 321402870,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLORAHOME",
    "dropmalst": "FL",
    "dropmalzpp": 321409998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866592228,
    "dropsitcph": 3866592228,
    "dropfax": 3866591468
  },
  {
    "dcode": "D",
    "dropkey": "PY21858",
    "droptype": "D",
    "dropname": "FLORAL CITY",
    "dropdeladd": "7667 S FLORIDA AVE",
    "dropdelcty": "FLORAL CITY",
    "dropdelst": "FL",
    "dropdelzpp": 344369998,
    "dropphyadd": "7667 S FLORIDA AVE",
    "dropphycty": "FLORAL CITY",
    "dropphyst": "FL",
    "dropphyzpp": 344369998,
    "dropmaladd": "7667 S FLORIDA AVE",
    "dropmalcty": "FLORAL CITY",
    "dropmalst": "FL",
    "dropmalzpp": 344369998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527263813,
    "dropsitcph": 3527263813,
    "dropfax": 3527267626
  },
  {
    "dcode": "D",
    "dropkey": "PY21882",
    "droptype": "D",
    "dropname": "FORT LAUDERDALE",
    "dropdeladd": "1900 W OAKLAND PARK BLVD STE 100",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333109998,
    "dropphyadd": "1900 W OAKLAND PARK BLVD STE 100",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333109998,
    "dropmaladd": "1900 W OAKLAND PARK BLVD STE 100",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333109998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547655740,
    "dropsitcph": 9545273245,
    "dropfax": 9545273203
  },
  {
    "dcode": "D",
    "dropkey": "PY21883",
    "droptype": "D",
    "dropname": "FORT MC COY",
    "dropdeladd": "14945 NE HIGHWAY 315",
    "dropdelcty": "FORT MC COY",
    "dropdelst": "FL",
    "dropdelzpp": 321348199,
    "dropphyadd": "14945 NE HIGHWAY 315",
    "dropphycty": "FORT MC COY",
    "dropphyst": "FL",
    "dropphyzpp": 321348199,
    "dropmaladd": "14945 NE HIGHWAY 315",
    "dropmalcty": "FORT MC COY",
    "dropmalst": "FL",
    "dropmalzpp": 321348199,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522362090,
    "dropsitcph": 3522362090,
    "dropfax": 3522361778
  },
  {
    "dcode": "D",
    "dropkey": "PY21884",
    "droptype": "D",
    "dropname": "FORT MEADE",
    "dropdeladd": "21 N SEMINOLE AVE",
    "dropdelcty": "FORT MEADE",
    "dropdelst": "FL",
    "dropdelzpp": 338419998,
    "dropphyadd": "21 N SEMINOLE AVE",
    "dropphycty": "FORT MEADE",
    "dropphyst": "FL",
    "dropphyzpp": 338419998,
    "dropmaladd": "21 N SEMINOLE AVE",
    "dropmalcty": "FORT MEADE",
    "dropmalst": "FL",
    "dropmalzpp": 338419998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8632859640,
    "dropfax": 8632856369
  },
  {
    "dcode": "D",
    "dropkey": "PY21886",
    "droptype": "D",
    "dropname": "FORT MYERS",
    "dropdeladd": "2655 N AIRPORT RD",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339079998,
    "dropphyadd": "2655 N AIRPORT RD",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339079998,
    "dropmaladd": "2655 N AIRPORT RD",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339079998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392773336,
    "dropfax": 2392773353
  },
  {
    "dcode": "D",
    "dropkey": "PY21888",
    "droptype": "D",
    "dropname": "FORT MYERS BEACH",
    "dropdeladd": "200 CAROLINA AVE",
    "dropdelcty": "FORT MYERS BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 339319998,
    "dropphyadd": "200 CAROLINA AVE",
    "dropphycty": "FORT MYERS BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 339319998,
    "dropmaladd": "200 CAROLINA AVE",
    "dropmalcty": "FORT MYERS BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 339319998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2394637106,
    "dropfax": 2394634852
  },
  {
    "dcode": "D",
    "dropkey": "PY21889",
    "droptype": "D",
    "dropname": "FORT OGDEN",
    "dropdeladd": "9693 SW HIGHWAY 17",
    "dropdelcty": "FORT OGDEN",
    "dropdelst": "FL",
    "dropdelzpp": 342679800,
    "dropphyadd": "9693 SW HIGHWAY 17",
    "dropphycty": "FORT OGDEN",
    "dropphyst": "FL",
    "dropphyzpp": 342679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT OGDEN",
    "dropmalst": "FL",
    "dropmalzpp": 342679998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 8634944979,
    "dropfax": 8634944979
  },
  {
    "dcode": "D",
    "dropkey": "PY21890",
    "droptype": "D",
    "dropname": "FORT PIERCE",
    "dropdeladd": "5000 W MIDWAY RD",
    "dropdelcty": "FORT PIERCE",
    "dropdelst": "FL",
    "dropdelzpp": 349819998,
    "dropphyadd": "5000 W MIDWAY RD",
    "dropphycty": "FORT PIERCE",
    "dropphyst": "FL",
    "dropphyzpp": 349819998,
    "dropmaladd": "5000 W MIDWAY RD",
    "dropmalcty": "FORT PIERCE",
    "dropmalst": "FL",
    "dropmalzpp": 349819998,
    "dropsitphn": 7724600841,
    "dropsitlph": 7724600841,
    "dropsitcph": 7724600841,
    "dropfax": 7724092506
  },
  {
    "dcode": "D",
    "dropkey": "PY21891",
    "droptype": "D",
    "dropname": "FORT WALTON BEACH",
    "dropdeladd": "21 WALTER MARTIN RD NE",
    "dropdelcty": "FORT WALTON BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 325489998,
    "dropphyadd": "21 WALTER MARTIN RD NE",
    "dropphycty": "FORT WALTON BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 325489998,
    "dropmaladd": "21 WALTER MARTIN RD NE",
    "dropmalcty": "FORT WALTON BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 325489998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8503749211,
    "dropsitcph": 8502442625,
    "dropfax": 8502445286
  },
  {
    "dcode": "D",
    "dropkey": "PY21892",
    "droptype": "D",
    "dropname": "FORT WHITE",
    "dropdeladd": "318 SW HOLSTEIN AVE",
    "dropdelcty": "FORT WHITE",
    "dropdelst": "FL",
    "dropdelzpp": 320383512,
    "dropphyadd": "318 SW HOLSTEIN AVE",
    "dropphycty": "FORT WHITE",
    "dropphyst": "FL",
    "dropphyzpp": 320383512,
    "dropmaladd": "318 SW HOLSTEIN AVE",
    "dropmalcty": "FORT WHITE",
    "dropmalst": "FL",
    "dropmalzpp": 320389998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864973352,
    "dropsitcph": 3864973352,
    "dropfax": 3864971278
  },
  {
    "dcode": "D",
    "dropkey": "PY21894",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "12606 SILVER LAKE RD",
    "dropdelcty": "FOUNTAIN",
    "dropdelst": "FL",
    "dropdelzpp": 324382040,
    "dropphyadd": "12606 SILVER LAKE RD",
    "dropphycty": "FOUNTAIN",
    "dropphyst": "FL",
    "dropphyzpp": 324382040,
    "dropmaladd": "12606 SILVER LAKE RD",
    "dropmalcty": "FOUNTAIN",
    "dropmalst": "FL",
    "dropmalzpp": 324382040,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507224498,
    "dropsitcph": 8507224498,
    "dropfax": 8507224486
  },
  {
    "dcode": "D",
    "dropkey": "PY21896",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "77 BRECKYN LOOP",
    "dropdelcty": "FREEPORT",
    "dropdelst": "FL",
    "dropdelzpp": 324399998,
    "dropphyadd": "77 BRECKYN LOOP",
    "dropphycty": "FREEPORT",
    "dropphyst": "FL",
    "dropphyzpp": 324399998,
    "dropmaladd": "77 BRECKYN LOOP",
    "dropmalcty": "FREEPORT",
    "dropmalst": "FL",
    "dropmalzpp": 324399998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508805050,
    "dropsitcph": 8508352525,
    "dropfax": 8508352031
  },
  {
    "dcode": "D",
    "dropkey": "PY21897",
    "droptype": "D",
    "dropname": "FROSTPROOF",
    "dropdeladd": "1 W 1ST ST",
    "dropdelcty": "FROSTPROOF",
    "dropdelst": "FL",
    "dropdelzpp": 338439998,
    "dropphyadd": "1 W 1ST ST",
    "dropphycty": "FROSTPROOF",
    "dropphyst": "FL",
    "dropphyzpp": 338439998,
    "dropmaladd": "1 W 1ST ST",
    "dropmalcty": "FROSTPROOF",
    "dropmalst": "FL",
    "dropmalzpp": 338439998,
    "dropsitphn": 8636353746,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636357393,
    "dropfax": 8636357393
  },
  {
    "dcode": "D",
    "dropkey": "PY21898",
    "droptype": "D",
    "dropname": "FRUITLAND PARK",
    "dropdeladd": "104 W MILLER ST",
    "dropdelcty": "FRUITLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 347319998,
    "dropphyadd": "104 W MILLER ST",
    "dropphycty": "FRUITLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 347319998,
    "dropmaladd": "104 W MILLER ST",
    "dropmalcty": "FRUITLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 347319998,
    "dropsitphn": 3527875994,
    "dropsitlph": 3527875994,
    "dropsitcph": 3527874287,
    "dropfax": 3527874969
  },
  {
    "dcode": "D",
    "dropkey": "PY21915",
    "droptype": "D",
    "dropname": "GAINESVILLE",
    "dropdeladd": "4600 SW 34TH ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326089998,
    "dropphyadd": "4600 SW 34TH ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326089998,
    "dropmaladd": "4600 SW 34TH ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326089998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341870,
    "dropsitcph": 3523341902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21931",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "199 PINE ST",
    "dropdelcty": "GENEVA",
    "dropdelst": "FL",
    "dropdelzpp": 327329998,
    "dropphyadd": "199 PINE ST",
    "dropphycty": "GENEVA",
    "dropphyst": "FL",
    "dropphyzpp": 327329998,
    "dropmaladd": "199 PINE ST",
    "dropmalcty": "GENEVA",
    "dropmalst": "FL",
    "dropmalzpp": 327329998,
    "dropsitphn": 4073490557,
    "dropsitlph": 4073490557,
    "dropsitcph": 4073490557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21932",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1441 COUNTY ROAD 309",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "FL",
    "dropdelzpp": 321399998,
    "dropphyadd": "1441 COUNTY ROAD 309",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "FL",
    "dropphyzpp": 321399998,
    "dropmaladd": "1441 COUNTY ROAD 309",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "FL",
    "dropmalzpp": 321399998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864679641,
    "dropsitcph": 3864679641,
    "dropfax": 3864677215
  },
  {
    "dcode": "D",
    "dropkey": "PY21934",
    "droptype": "D",
    "dropname": "GIBSONTON",
    "dropdeladd": "11126 S US HIGHWAY 41",
    "dropdelcty": "GIBSONTON",
    "dropdelst": "FL",
    "dropdelzpp": 335349998,
    "dropphyadd": "11126 S US HIGHWAY 41",
    "dropphycty": "GIBSONTON",
    "dropphyst": "FL",
    "dropphyzpp": 335349998,
    "dropmaladd": "11126 S US HIGHWAY 41",
    "dropmalcty": "GIBSONTON",
    "dropmalst": "FL",
    "dropmalzpp": 335349998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136723621,
    "dropfax": 8136723621
  },
  {
    "dcode": "D",
    "dropkey": "PY21937",
    "droptype": "D",
    "dropname": "GLEN SAINT MARY",
    "dropdeladd": "7345 W MOUNT VERNON ST",
    "dropdelcty": "GLEN SAINT MARY",
    "dropdelst": "FL",
    "dropdelzpp": 320409998,
    "dropphyadd": "7345 W MOUNT VERNON ST",
    "dropphycty": "GLEN SAINT MARY",
    "dropphyst": "FL",
    "dropphyzpp": 320409998,
    "dropmaladd": "7345 W MOUNT VERNON ST",
    "dropmalcty": "GLEN SAINT MARY",
    "dropmalst": "FL",
    "dropmalzpp": 320409998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042596789,
    "dropsitcph": 9042596789,
    "dropfax": 9042597019
  },
  {
    "dcode": "D",
    "dropkey": "PY21952",
    "droptype": "D",
    "dropname": "GOLDENROD",
    "dropdeladd": "7501 CITRUS AVE",
    "dropdelcty": "GOLDENROD",
    "dropdelst": "FL",
    "dropdelzpp": 327339200,
    "dropphyadd": "7501 CITRUS AVE",
    "dropphycty": "GOLDENROD",
    "dropphyst": "FL",
    "dropphyzpp": 327339200,
    "dropmaladd": "PO BOX 339998",
    "dropmalcty": "GOLDENROD",
    "dropmalst": "FL",
    "dropmalzpp": 327339998,
    "dropsitphn": 4076787897,
    "dropsitlph": 4076787897,
    "dropsitcph": 4076786911,
    "dropfax": 4076787110
  },
  {
    "dcode": "D",
    "dropkey": "PY21954",
    "droptype": "D",
    "dropname": "GONZALEZ",
    "dropdeladd": "1450 OLD CHEMSTRAND RD",
    "dropdelcty": "GONZALEZ",
    "dropdelst": "FL",
    "dropdelzpp": 325609998,
    "dropphyadd": "1450 OLD CHEMSTRAND RD",
    "dropphycty": "GONZALEZ",
    "dropphyst": "FL",
    "dropphyzpp": 325609998,
    "dropmaladd": "1450 OLD CHEMSTRAND RD",
    "dropmalcty": "GONZALEZ",
    "dropmalst": "FL",
    "dropmalzpp": 325609998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509689338,
    "dropsitcph": 8509689338,
    "dropfax": 8509684825
  },
  {
    "dcode": "D",
    "dropkey": "PY21955",
    "droptype": "D",
    "dropname": "GOODLAND",
    "dropdeladd": "427 PAPAYA ST",
    "dropdelcty": "GOODLAND",
    "dropdelst": "FL",
    "dropdelzpp": 341409800,
    "dropphyadd": "427 PAPAYA ST",
    "dropphycty": "GOODLAND",
    "dropphyst": "FL",
    "dropphyzpp": 341409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODLAND",
    "dropmalst": "FL",
    "dropmalzpp": 341409998,
    "dropsitphn": 8138893938,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393947387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21957",
    "droptype": "D",
    "dropname": "GOTHA",
    "dropdeladd": "9907 8TH ST",
    "dropdelcty": "GOTHA",
    "dropdelst": "FL",
    "dropdelzpp": 347349998,
    "dropphyadd": "9907 8TH ST",
    "dropphycty": "GOTHA",
    "dropphyst": "FL",
    "dropphyzpp": 347349998,
    "dropmaladd": "9907 8TH ST",
    "dropmalcty": "GOTHA",
    "dropmalst": "FL",
    "dropmalzpp": 347349998,
    "dropsitphn": 4075789054,
    "dropsitlph": 4075789054,
    "dropsitcph": 4075229139,
    "dropfax": 4072938750
  },
  {
    "dcode": "D",
    "dropkey": "PY21960",
    "droptype": "D",
    "dropname": "GRACEVILLE",
    "dropdeladd": "5360 CLIFF ST",
    "dropdelcty": "GRACEVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 324409998,
    "dropphyadd": "5360 CLIFF ST",
    "dropphycty": "GRACEVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 324409998,
    "dropmaladd": "5360 CLIFF ST",
    "dropmalcty": "GRACEVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 324409998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502633297,
    "dropsitcph": 8502633297,
    "dropfax": 8502637937
  },
  {
    "dcode": "D",
    "dropkey": "PY21961",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "9847 SW 104TH AVE",
    "dropdelcty": "GRAHAM",
    "dropdelst": "FL",
    "dropdelzpp": 320429998,
    "dropphyadd": "9847 SW 104TH AVE",
    "dropphycty": "GRAHAM",
    "dropphyst": "FL",
    "dropphyzpp": 320429998,
    "dropmaladd": "9847 SW 104TH AVE",
    "dropmalcty": "GRAHAM",
    "dropmalst": "FL",
    "dropmalzpp": 320429998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524851000,
    "dropsitcph": 3524851000,
    "dropfax": 3524851000
  },
  {
    "dcode": "D",
    "dropkey": "PY21962",
    "droptype": "D",
    "dropname": "GRAND ISLAND",
    "dropdeladd": "36525 S FISH CAMP RD",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "FL",
    "dropdelzpp": 327359998,
    "dropphyadd": "36525 S FISH CAMP RD",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "FL",
    "dropphyzpp": 327359998,
    "dropmaladd": "36525 S FISH CAMP RD",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "FL",
    "dropmalzpp": 327359998,
    "dropsitphn": 3525892299,
    "dropsitlph": 3525892299,
    "dropsitcph": 3525892037,
    "dropfax": 3525892299
  },
  {
    "dcode": "D",
    "dropkey": "PY21963",
    "droptype": "D",
    "dropname": "GRAND RIDGE",
    "dropdeladd": "2064 PORTER AVE",
    "dropdelcty": "GRAND RIDGE",
    "dropdelst": "FL",
    "dropdelzpp": 324429998,
    "dropphyadd": "2064 PORTER AVE",
    "dropphycty": "GRAND RIDGE",
    "dropphyst": "FL",
    "dropphyzpp": 324429998,
    "dropmaladd": "2064 PORTER AVE",
    "dropmalcty": "GRAND RIDGE",
    "dropmalst": "FL",
    "dropmalzpp": 324429998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505924916,
    "dropsitcph": 8505924916,
    "dropfax": 8505922034
  },
  {
    "dcode": "D",
    "dropkey": "PY21964",
    "droptype": "D",
    "dropname": "GRANDIN",
    "dropdeladd": "938 N COUNTY ROAD 315",
    "dropdelcty": "GRANDIN",
    "dropdelst": "FL",
    "dropdelzpp": 321389900,
    "dropphyadd": "938 N COUNTY ROAD 315",
    "dropphycty": "GRANDIN",
    "dropphyst": "FL",
    "dropphyzpp": 321389900,
    "dropmaladd": "938 N COUNTY ROAD 315",
    "dropmalcty": "GRANDIN",
    "dropmalst": "FL",
    "dropmalzpp": 321389900,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866592493,
    "dropsitcph": 3866592493,
    "dropfax": 3866592872
  },
  {
    "dcode": "D",
    "dropkey": "PY21965",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "5560 OLD DIXIE HWY",
    "dropdelcty": "GRANT",
    "dropdelst": "FL",
    "dropdelzpp": 329499998,
    "dropphyadd": "5560 OLD DIXIE HWY",
    "dropphycty": "GRANT",
    "dropphyst": "FL",
    "dropphyzpp": 329499998,
    "dropmaladd": "5560 OLD DIXIE HWY",
    "dropmalcty": "GRANT",
    "dropmalst": "FL",
    "dropmalzpp": 329499998,
    "dropsitphn": 3217266815,
    "dropsitlph": 3217266815,
    "dropsitcph": 3217266815,
    "dropfax": 3219519453
  },
  {
    "dcode": "D",
    "dropkey": "PY21969",
    "droptype": "D",
    "dropname": "GREEN COVE SPRINGS",
    "dropdeladd": "500 PALMER ST",
    "dropdelcty": "GREEN COVE SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 320439998,
    "dropphyadd": "500 PALMER ST",
    "dropphycty": "GREEN COVE SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 320439998,
    "dropmaladd": "500 PALMER ST",
    "dropmalcty": "GREEN COVE SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 320439998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042849442,
    "dropsitcph": 9042849442,
    "dropfax": 9042844930
  },
  {
    "dcode": "D",
    "dropkey": "PY21973",
    "droptype": "D",
    "dropname": "GREENSBORO",
    "dropdeladd": "191 GREEN AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "FL",
    "dropdelzpp": 323301500,
    "dropphyadd": "191 GREEN AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "FL",
    "dropphyzpp": 323301500,
    "dropmaladd": "191 GREEN AVE",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "FL",
    "dropmalzpp": 323309998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504424486,
    "dropsitcph": 8504424486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21974",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "13626 W US 90",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 323314300,
    "dropphyadd": "13626 W US 90",
    "dropphycty": "GREENVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 323314300,
    "dropmaladd": "13626 W US 90",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 323314300,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509482301,
    "dropsitcph": 8509482301,
    "dropfax": 8509481821
  },
  {
    "dcode": "D",
    "dropkey": "PY21977",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "4233 BRYAN ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 324439998,
    "dropphyadd": "4233 BRYAN ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 324439998,
    "dropmaladd": "4233 BRYAN ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 324439998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505944411,
    "dropsitcph": 8505944411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY21979",
    "droptype": "D",
    "dropname": "GRETNA",
    "dropdeladd": "14678 MAIN ST",
    "dropdelcty": "GRETNA",
    "dropdelst": "FL",
    "dropdelzpp": 323329998,
    "dropphyadd": "14678 MAIN ST",
    "dropphycty": "GRETNA",
    "dropphyst": "FL",
    "dropphyzpp": 323329998,
    "dropmaladd": "14678 MAIN ST",
    "dropmalcty": "GRETNA",
    "dropmalst": "FL",
    "dropmalzpp": 323329998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508565303,
    "dropsitcph": 8508565303,
    "dropfax": 8508569046
  },
  {
    "dcode": "D",
    "dropkey": "PY21983",
    "droptype": "D",
    "dropname": "GROVELAND",
    "dropdeladd": "304 W BROAD ST",
    "dropdelcty": "GROVELAND",
    "dropdelst": "FL",
    "dropdelzpp": 347369998,
    "dropphyadd": "304 W BROAD ST",
    "dropphycty": "GROVELAND",
    "dropphyst": "FL",
    "dropphyzpp": 347369998,
    "dropmaladd": "304 W BROAD ST",
    "dropmalcty": "GROVELAND",
    "dropmalst": "FL",
    "dropmalzpp": 347369998,
    "dropsitphn": 3525573021,
    "dropsitlph": 3525573021,
    "dropsitcph": 3524292801,
    "dropfax": 3524294963
  },
  {
    "dcode": "D",
    "dropkey": "PY21984",
    "droptype": "D",
    "dropname": "GULF BREEZE",
    "dropdeladd": "100 NORTHCLIFFE DR",
    "dropdelcty": "GULF BREEZE",
    "dropdelst": "FL",
    "dropdelzpp": 325619998,
    "dropphyadd": "100 NORTHCLIFFE DR",
    "dropphycty": "GULF BREEZE",
    "dropphyst": "FL",
    "dropphyzpp": 325619998,
    "dropmaladd": "100 NORTHCLIFFE DR",
    "dropmalcty": "GULF BREEZE",
    "dropmalst": "FL",
    "dropmalzpp": 325619998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509347825,
    "dropsitcph": 8509320156,
    "dropfax": 8509340696
  },
  {
    "dcode": "D",
    "dropkey": "PY21988",
    "droptype": "D",
    "dropname": "GULF HAMMOCK",
    "dropdeladd": "5350 SE HIGHWAY 19",
    "dropdelcty": "GULF HAMMOCK",
    "dropdelst": "FL",
    "dropdelzpp": 326392100,
    "dropphyadd": "5350 SE HIGHWAY 19",
    "dropphycty": "GULF HAMMOCK",
    "dropphyst": "FL",
    "dropphyzpp": 326392100,
    "dropmaladd": "5350 SE HIGHWAY 19",
    "dropmalcty": "GULF HAMMOCK",
    "dropmalst": "FL",
    "dropmalzpp": 326399998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524862384,
    "dropsitcph": 3524862384,
    "dropfax": 3524862384
  },
  {
    "dcode": "D",
    "dropkey": "PY21999",
    "droptype": "D",
    "dropname": "HAINES CITY",
    "dropdeladd": "1051 STATE ROAD 544 E",
    "dropdelcty": "HAINES CITY",
    "dropdelst": "FL",
    "dropdelzpp": 338449998,
    "dropphyadd": "1051 STATE ROAD 544 E",
    "dropphycty": "HAINES CITY",
    "dropphyst": "FL",
    "dropphyzpp": 338449998,
    "dropmaladd": "1051 STATE ROAD 544 E",
    "dropmalcty": "HAINES CITY",
    "dropmalst": "FL",
    "dropmalzpp": 338449998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634222901,
    "dropfax": 8634225743
  },
  {
    "dcode": "D",
    "dropkey": "PY22003",
    "droptype": "D",
    "dropname": "HALLANDALE",
    "dropdeladd": "500 S FEDERAL HWY",
    "dropdelcty": "HALLANDALE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330099998,
    "dropphyadd": "500 S FEDERAL HWY",
    "dropphycty": "HALLANDALE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330099998,
    "dropmaladd": "500 S FEDERAL HWY",
    "dropmalcty": "HALLANDALE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330099998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9544559733,
    "dropsitcph": 9544550493,
    "dropfax": 9544568631
  },
  {
    "dcode": "D",
    "dropkey": "PY22007",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "5627 NAVARRE AVE",
    "dropdelcty": "HAMPTON",
    "dropdelst": "FL",
    "dropdelzpp": 320449998,
    "dropphyadd": "5627 NAVARRE AVE",
    "dropphycty": "HAMPTON",
    "dropphyst": "FL",
    "dropphyzpp": 320449998,
    "dropmaladd": "5627 NAVARRE AVE",
    "dropmalcty": "HAMPTON",
    "dropmalst": "FL",
    "dropmalzpp": 320449998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524681286,
    "dropsitcph": 3524681286,
    "dropfax": 3524681286
  },
  {
    "dcode": "D",
    "dropkey": "PY22013",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "200 E COCHRAN AVE",
    "dropdelcty": "HASTINGS",
    "dropdelst": "FL",
    "dropdelzpp": 321454228,
    "dropphyadd": "200 E COCHRAN AVE",
    "dropphycty": "HASTINGS",
    "dropphyst": "FL",
    "dropphyzpp": 321454228,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HASTINGS",
    "dropmalst": "FL",
    "dropmalzpp": 321459998,
    "dropsitphn": 9046921592,
    "dropsitlph": 9046921592,
    "dropsitcph": 9046921592,
    "dropfax": 9046922851
  },
  {
    "dcode": "D",
    "dropkey": "PY22014",
    "droptype": "D",
    "dropname": "HAVANA",
    "dropdeladd": "9080 HAVANA HWY",
    "dropdelcty": "HAVANA",
    "dropdelst": "FL",
    "dropdelzpp": 323331759,
    "dropphyadd": "9080 HAVANA HWY",
    "dropphycty": "HAVANA",
    "dropphyst": "FL",
    "dropphyzpp": 323331759,
    "dropmaladd": "9080 HAVANA HWY",
    "dropmalcty": "HAVANA",
    "dropmalst": "FL",
    "dropmalzpp": 323339998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505395005,
    "dropsitcph": 8505395005,
    "dropfax": 8505395729
  },
  {
    "dcode": "D",
    "dropkey": "PY22016",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "6300 SE 221ST ST",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "FL",
    "dropdelzpp": 326409998,
    "dropphyadd": "6300 SE 221ST ST",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "FL",
    "dropphyzpp": 326409998,
    "dropmaladd": "6300 SE 221ST ST",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "FL",
    "dropmalzpp": 326409998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524813046,
    "dropsitcph": 3524813046,
    "dropfax": 3524813003
  },
  {
    "dcode": "D",
    "dropkey": "PY22019",
    "droptype": "D",
    "dropname": "HERNANDO",
    "dropdeladd": "3795 E PARSONS POINT RD",
    "dropdelcty": "HERNANDO",
    "dropdelst": "FL",
    "dropdelzpp": 344429998,
    "dropphyadd": "3795 E PARSONS POINT RD",
    "dropphycty": "HERNANDO",
    "dropphyst": "FL",
    "dropphyzpp": 344429998,
    "dropmaladd": "3795 E PARSONS POINT RD",
    "dropmalcty": "HERNANDO",
    "dropmalst": "FL",
    "dropmalzpp": 344429998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527264345,
    "dropsitcph": 3527264345,
    "dropfax": 3527267037
  },
  {
    "dcode": "D",
    "dropkey": "PY22026",
    "droptype": "D",
    "dropname": "HIALEAH",
    "dropdeladd": "325 E 1ST AVE",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330104898,
    "dropphyadd": "325 E 1ST AVE",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330104898,
    "dropmaladd": "325 E 1ST AVE",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330104898,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058895455,
    "dropsitcph": 3058895421,
    "dropfax": 3058895495
  },
  {
    "dcode": "D",
    "dropkey": "PY22035",
    "droptype": "D",
    "dropname": "HIGH SPRINGS",
    "dropdeladd": "23687 NW 188TH AVE",
    "dropdelcty": "HIGH SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 326430341,
    "dropphyadd": "23687 NW 188TH AVE",
    "dropphycty": "HIGH SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 326430341,
    "dropmaladd": "23687 NW 188TH AVE",
    "dropmalcty": "HIGH SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 326439998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864541021,
    "dropsitcph": 3864541021,
    "dropfax": 3864541623
  },
  {
    "dcode": "D",
    "dropkey": "PY22037",
    "droptype": "D",
    "dropname": "HIGHLAND CITY",
    "dropdeladd": "4114 CLUBHOUSE RD",
    "dropdelcty": "HIGHLAND CITY",
    "dropdelst": "FL",
    "dropdelzpp": 338461755,
    "dropphyadd": "4114 CLUBHOUSE RD",
    "dropphycty": "HIGHLAND CITY",
    "dropphyst": "FL",
    "dropphyzpp": 338461755,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGHLAND CITY",
    "dropmalst": "FL",
    "dropmalzpp": 338469998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636462319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22044",
    "droptype": "D",
    "dropname": "HILLIARD",
    "dropdeladd": "551835 US HIGHWAY 1",
    "dropdelcty": "HILLIARD",
    "dropdelst": "FL",
    "dropdelzpp": 320468823,
    "dropphyadd": "551835 US HIGHWAY 1",
    "dropphycty": "HILLIARD",
    "dropphyst": "FL",
    "dropphyzpp": 320468823,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLIARD",
    "dropmalst": "FL",
    "dropmalzpp": 320469998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048452151,
    "dropsitcph": 9048452151,
    "dropfax": 9048457738
  },
  {
    "dcode": "D",
    "dropkey": "PY22050",
    "droptype": "D",
    "dropname": "HOBE SOUND",
    "dropdeladd": "9995 SE FEDERAL HWY",
    "dropdelcty": "HOBE SOUND",
    "dropdelst": "FL",
    "dropdelzpp": 334559998,
    "dropphyadd": "9995 SE FEDERAL HWY",
    "dropphycty": "HOBE SOUND",
    "dropphyst": "FL",
    "dropphyzpp": 334559998,
    "dropmaladd": "9995 SE FEDERAL HWY",
    "dropmalcty": "HOBE SOUND",
    "dropmalst": "FL",
    "dropmalzpp": 334559998,
    "dropsitphn": 7725465630,
    "dropsitlph": 7725465630,
    "dropsitcph": 7725465630,
    "dropfax": 7724029526
  },
  {
    "dcode": "D",
    "dropkey": "PY22051",
    "droptype": "D",
    "dropname": "HOLDER",
    "dropdeladd": "6906 N FLORIDA AVE",
    "dropdelcty": "HOLDER",
    "dropdelst": "FL",
    "dropdelzpp": 344450195,
    "dropphyadd": "6906 N FLORIDA AVE",
    "dropphycty": "HOLDER",
    "dropphyst": "FL",
    "dropphyzpp": 344450195,
    "dropmaladd": "6906 N FLORIDA AVE",
    "dropmalcty": "HOLDER",
    "dropmalst": "FL",
    "dropmalzpp": 344459998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524895351,
    "dropsitcph": 3524895351,
    "dropfax": 3524653181
  },
  {
    "dcode": "D",
    "dropkey": "PY22054",
    "droptype": "D",
    "dropname": "HOLLISTER",
    "dropdeladd": "650 HIGHWAY 20",
    "dropdelcty": "HOLLISTER",
    "dropdelst": "FL",
    "dropdelzpp": 321479990,
    "dropphyadd": "650 HIGHWAY 20",
    "dropphycty": "HOLLISTER",
    "dropphyst": "FL",
    "dropphyzpp": 321479990,
    "dropmaladd": "650 HIGHWAY 20",
    "dropmalcty": "HOLLISTER",
    "dropmalst": "FL",
    "dropmalzpp": 321479998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8132435960,
    "dropsitcph": 3863255527,
    "dropfax": 3863258886
  },
  {
    "dcode": "D",
    "dropkey": "PY22056",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "1801 POLK ST",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 330229998,
    "dropphyadd": "1801 POLK ST",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 330229998,
    "dropmaladd": "1801 POLK ST",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 330229998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549268669,
    "dropsitcph": 9549268669,
    "dropfax": 9549268675
  },
  {
    "dcode": "D",
    "dropkey": "PY22062",
    "droptype": "D",
    "dropname": "HOLT",
    "dropdeladd": "563 HIGHWAY 90 W",
    "dropdelcty": "HOLT",
    "dropdelst": "FL",
    "dropdelzpp": 325649998,
    "dropphyadd": "563 HIGHWAY 90 W",
    "dropphycty": "HOLT",
    "dropphyst": "FL",
    "dropphyzpp": 325649998,
    "dropmaladd": "563 HIGHWAY 90 W",
    "dropmalcty": "HOLT",
    "dropmalst": "FL",
    "dropmalzpp": 325649998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505374221,
    "dropsitcph": 8505374221,
    "dropfax": 8505377050
  },
  {
    "dcode": "D",
    "dropkey": "PY22063",
    "droptype": "D",
    "dropname": "HOMELAND",
    "dropdeladd": "339 4TH ST",
    "dropdelcty": "HOMELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338471703,
    "dropphyadd": "339 4TH ST",
    "dropphycty": "HOMELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338471703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOMELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338479998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8635338989,
    "dropfax": 8635338989
  },
  {
    "dcode": "D",
    "dropkey": "PY22064",
    "droptype": "D",
    "dropname": "HOMESTEAD",
    "dropdeladd": "739 WASHINGTON AVE",
    "dropdelcty": "HOMESTEAD",
    "dropdelst": "FL",
    "dropdelzpp": 330309998,
    "dropphyadd": "739 WASHINGTON AVE",
    "dropphycty": "HOMESTEAD",
    "dropphyst": "FL",
    "dropphyzpp": 330309998,
    "dropmaladd": "739 WASHINGTON AVE",
    "dropmalcty": "HOMESTEAD",
    "dropmalst": "FL",
    "dropmalzpp": 330309998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052471785,
    "dropsitcph": 3052471556,
    "dropfax": 3052486244
  },
  {
    "dcode": "D",
    "dropkey": "PY22068",
    "droptype": "D",
    "dropname": "HOMOSASSA",
    "dropdeladd": "10780 W YULEE DR",
    "dropdelcty": "HOMOSASSA",
    "dropdelst": "FL",
    "dropdelzpp": 344879998,
    "dropphyadd": "10780 W YULEE DR",
    "dropphycty": "HOMOSASSA",
    "dropphyst": "FL",
    "dropphyzpp": 344879998,
    "dropmaladd": "10780 W YULEE DR",
    "dropmalcty": "HOMOSASSA",
    "dropmalst": "FL",
    "dropmalzpp": 344879998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526282396,
    "dropsitcph": 3526282396,
    "dropfax": 3526282858
  },
  {
    "dcode": "D",
    "dropkey": "PY22069",
    "droptype": "D",
    "dropname": "HOMOSASSA SPRINGS",
    "dropdeladd": "4610 S SUNCOAST BLVD",
    "dropdelcty": "HOMOSASSA",
    "dropdelst": "FL",
    "dropdelzpp": 344461700,
    "dropphyadd": "4610 S SUNCOAST BLVD",
    "dropphycty": "HOMOSASSA",
    "dropphyst": "FL",
    "dropphyzpp": 344461700,
    "dropmaladd": "4610 S SUNCOAST BLVD",
    "dropmalcty": "HOMOSASSA",
    "dropmalst": "FL",
    "dropmalzpp": 344461700,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526283240,
    "dropsitcph": 3526283240,
    "dropfax": 3526280814
  },
  {
    "dcode": "D",
    "dropkey": "PY22071",
    "droptype": "D",
    "dropname": "HORSESHOE BEACH",
    "dropdeladd": "77 5TH AVE E",
    "dropdelcty": "HORSESHOE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 326482102,
    "dropphyadd": "77 5TH AVE E",
    "dropphycty": "HORSESHOE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 326482102,
    "dropmaladd": "77 5TH AVE E",
    "dropmalcty": "HORSESHOE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 326482102,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524983731,
    "dropsitcph": 3524983731,
    "dropfax": 3524980016
  },
  {
    "dcode": "D",
    "dropkey": "PY22072",
    "droptype": "D",
    "dropname": "HOSFORD",
    "dropdeladd": "16827 NE STATE ROAD 65",
    "dropdelcty": "HOSFORD",
    "dropdelst": "FL",
    "dropdelzpp": 323342403,
    "dropphyadd": "16827 NE STATE ROAD 65",
    "dropphycty": "HOSFORD",
    "dropphyst": "FL",
    "dropphyzpp": 323342403,
    "dropmaladd": "16827 NE STATE ROAD 65",
    "dropmalcty": "HOSFORD",
    "dropmalst": "FL",
    "dropmalzpp": 323349998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8778546721,
    "dropsitcph": 8778546721,
    "dropfax": 8503798011
  },
  {
    "dcode": "D",
    "dropkey": "PY22073",
    "droptype": "D",
    "dropname": "HOWEY IN THE HILLS",
    "dropdeladd": "105 S FLORIDA AVE",
    "dropdelcty": "HOWEY IN THE HILLS",
    "dropdelst": "FL",
    "dropdelzpp": 347379998,
    "dropphyadd": "105 S FLORIDA AVE",
    "dropphycty": "HOWEY IN THE HILLS",
    "dropphyst": "FL",
    "dropphyzpp": 347379998,
    "dropmaladd": "105 S FLORIDA AVE",
    "dropmalcty": "HOWEY IN THE HILLS",
    "dropmalst": "FL",
    "dropmalzpp": 347379998,
    "dropsitphn": 3523242325,
    "dropsitlph": 3523242325,
    "dropsitcph": 3523242370,
    "dropfax": 3523242370
  },
  {
    "dcode": "D",
    "dropkey": "PY22085",
    "droptype": "D",
    "dropname": "IMMOKALEE",
    "dropdeladd": "810 N 15TH ST",
    "dropdelcty": "IMMOKALEE",
    "dropdelst": "FL",
    "dropdelzpp": 341429998,
    "dropphyadd": "810 N 15TH ST",
    "dropphycty": "IMMOKALEE",
    "dropphyst": "FL",
    "dropphyzpp": 341429998,
    "dropmaladd": "810 N 15TH ST",
    "dropmalcty": "IMMOKALEE",
    "dropmalst": "FL",
    "dropmalzpp": 341429998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396579742,
    "dropfax": 2396579347
  },
  {
    "dcode": "D",
    "dropkey": "PY22096",
    "droptype": "D",
    "dropname": "INDIAN ROCKS BEACH",
    "dropdeladd": "204 4TH AVE",
    "dropdelcty": "INDIAN ROCKS BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 337859998,
    "dropphyadd": "204 4TH AVE",
    "dropphycty": "INDIAN ROCKS BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 337859998,
    "dropmaladd": "204 4TH AVE",
    "dropmalcty": "INDIAN ROCKS BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 337859998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275962894,
    "dropfax": 7275962894
  },
  {
    "dcode": "D",
    "dropkey": "PY22098",
    "droptype": "D",
    "dropname": "INDIANTOWN",
    "dropdeladd": "15300 E THELMA WATERS AVE",
    "dropdelcty": "INDIANTOWN",
    "dropdelst": "FL",
    "dropdelzpp": 349569998,
    "dropphyadd": "15300 E THELMA WATERS AVE",
    "dropphycty": "INDIANTOWN",
    "dropphyst": "FL",
    "dropphyzpp": 349569998,
    "dropmaladd": "15300 E THELMA WATERS AVE",
    "dropmalcty": "INDIANTOWN",
    "dropmalst": "FL",
    "dropmalzpp": 349569998,
    "dropsitphn": 7726191000,
    "dropsitlph": 7726191000,
    "dropsitcph": 7726191002,
    "dropfax": 7725972440
  },
  {
    "dcode": "D",
    "dropkey": "PY22100",
    "droptype": "D",
    "dropname": "INGLIS",
    "dropdeladd": "70 N INGLIS AVE",
    "dropdelcty": "INGLIS",
    "dropdelst": "FL",
    "dropdelzpp": 344499998,
    "dropphyadd": "70 N INGLIS AVE",
    "dropphycty": "INGLIS",
    "dropphyst": "FL",
    "dropphyzpp": 344499998,
    "dropmaladd": "70 N INGLIS AVE",
    "dropmalcty": "INGLIS",
    "dropmalst": "FL",
    "dropmalzpp": 344499998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524472888,
    "dropsitcph": 3524472888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22104",
    "droptype": "D",
    "dropname": "INTERCESSION CITY",
    "dropdeladd": "1538 TALLAHASSEE BLVD",
    "dropdelcty": "INTERCESSION CITY",
    "dropdelst": "FL",
    "dropdelzpp": 338489800,
    "dropphyadd": "1538 TALLAHASSEE BLVD",
    "dropphycty": "INTERCESSION CITY",
    "dropphyst": "FL",
    "dropphyzpp": 338489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INTERCESSION CITY",
    "dropmalst": "FL",
    "dropmalzpp": 338489998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 4079335912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22107",
    "droptype": "D",
    "dropname": "INTERLACHEN",
    "dropdeladd": "100 MATHE AVE",
    "dropdelcty": "INTERLACHEN",
    "dropdelst": "FL",
    "dropdelzpp": 321489998,
    "dropphyadd": "100 MATHE AVE",
    "dropphycty": "INTERLACHEN",
    "dropphyst": "FL",
    "dropphyzpp": 321489998,
    "dropmaladd": "100 MATHE AVE",
    "dropmalcty": "INTERLACHEN",
    "dropmalst": "FL",
    "dropmalzpp": 321489998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866842228,
    "dropsitcph": 3866842228,
    "dropfax": 3866849238
  },
  {
    "dcode": "D",
    "dropkey": "PY22109",
    "droptype": "D",
    "dropname": "INVERNESS",
    "dropdeladd": "1400 HIGHWAY 41 N",
    "dropdelcty": "INVERNESS",
    "dropdelst": "FL",
    "dropdelzpp": 344509998,
    "dropphyadd": "1400 HIGHWAY 41 N",
    "dropphycty": "INVERNESS",
    "dropphyst": "FL",
    "dropphyzpp": 344509998,
    "dropmaladd": "1400 HIGHWAY 41 N",
    "dropmalcty": "INVERNESS",
    "dropmalst": "FL",
    "dropmalzpp": 344509998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527262757,
    "dropsitcph": 3527262757,
    "dropfax": 3527267669
  },
  {
    "dcode": "D",
    "dropkey": "PY22115",
    "droptype": "D",
    "dropname": "ISLAMORADA",
    "dropdeladd": "82801 OVERSEAS HWY",
    "dropdelcty": "ISLAMORADA",
    "dropdelst": "FL",
    "dropdelzpp": 330369998,
    "dropphyadd": "82801 OVERSEAS HWY",
    "dropphycty": "ISLAMORADA",
    "dropphyst": "FL",
    "dropphyzpp": 330369998,
    "dropmaladd": "82801 OVERSEAS HWY",
    "dropmalcty": "ISLAMORADA",
    "dropmalst": "FL",
    "dropmalzpp": 330369998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056640649,
    "dropsitcph": 3056644738,
    "dropfax": 3056640629
  },
  {
    "dcode": "D",
    "dropkey": "PY22117",
    "droptype": "D",
    "dropname": "ISLAND GROVE",
    "dropdeladd": "21905 SE US HIGHWAY 301",
    "dropdelcty": "ISLAND GROVE",
    "dropdelst": "FL",
    "dropdelzpp": 326549998,
    "dropphyadd": "21905 SE US HIGHWAY 301",
    "dropphycty": "ISLAND GROVE",
    "dropphyst": "FL",
    "dropphyzpp": 326549998,
    "dropmaladd": "21905 SE US HIGHWAY 301",
    "dropmalcty": "ISLAND GROVE",
    "dropmalst": "FL",
    "dropmalzpp": 326549998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524819397,
    "dropsitcph": 3524819397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22118",
    "droptype": "D",
    "dropname": "ISTACHATTA",
    "dropdeladd": "28199 MAGNON DR",
    "dropdelcty": "ISTACHATTA",
    "dropdelst": "FL",
    "dropdelzpp": 346369801,
    "dropphyadd": "28199 MAGNON DR",
    "dropphycty": "ISTACHATTA",
    "dropphyst": "FL",
    "dropphyzpp": 346369801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISTACHATTA",
    "dropmalst": "FL",
    "dropmalzpp": 346369998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3527966840,
    "dropfax": 3527966840
  },
  {
    "dcode": "D",
    "dropkey": "PY22126",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "1100 KINGS RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322039998,
    "dropphyadd": "1100 KINGS RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322039998,
    "dropmaladd": "1100 KINGS RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322039998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043664892,
    "dropsitcph": 9043664892,
    "dropfax": 9043664866
  },
  {
    "dcode": "D",
    "dropkey": "PY22137",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "105 MARTIN LUTHER KING DR SE",
    "dropdelcty": "JASPER",
    "dropdelst": "FL",
    "dropdelzpp": 320526689,
    "dropphyadd": "105 MARTIN LUTHER KING DR SE",
    "dropphycty": "JASPER",
    "dropphyst": "FL",
    "dropphyzpp": 320526689,
    "dropmaladd": "105 MARTIN LUTHER KING DR SE",
    "dropmalcty": "JASPER",
    "dropmalst": "FL",
    "dropmalzpp": 320529998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3867921304,
    "dropsitcph": 3867921304,
    "dropfax": 3867921780
  },
  {
    "dcode": "D",
    "dropkey": "PY22143",
    "droptype": "D",
    "dropname": "JAY",
    "dropdeladd": "3719 HIGHWAY 4",
    "dropdelcty": "JAY",
    "dropdelst": "FL",
    "dropdelzpp": 325659998,
    "dropphyadd": "3719 HIGHWAY 4",
    "dropphycty": "JAY",
    "dropphyst": "FL",
    "dropphyzpp": 325659998,
    "dropmaladd": "3719 HIGHWAY 4",
    "dropmalcty": "JAY",
    "dropmalst": "FL",
    "dropmalzpp": 325659998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506754141,
    "dropsitcph": 8506754141,
    "dropfax": 8506754619
  },
  {
    "dcode": "D",
    "dropkey": "PY22144",
    "droptype": "D",
    "dropname": "JENNINGS",
    "dropdeladd": "1269 PLUM ST",
    "dropdelcty": "JENNINGS",
    "dropdelst": "FL",
    "dropdelzpp": 320539998,
    "dropphyadd": "1269 PLUM ST",
    "dropphycty": "JENNINGS",
    "dropphyst": "FL",
    "dropphyzpp": 320539998,
    "dropmaladd": "1269 PLUM ST",
    "dropmalcty": "JENNINGS",
    "dropmalst": "FL",
    "dropmalzpp": 320539998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3869384691,
    "dropsitcph": 3869384691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22145",
    "droptype": "D",
    "dropname": "JENSEN BEACH",
    "dropdeladd": "2301 NE SAVANNAH RD",
    "dropdelcty": "JENSEN BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 349579998,
    "dropphyadd": "2301 NE SAVANNAH RD",
    "dropphycty": "JENSEN BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 349579998,
    "dropmaladd": "2301 NE SAVANNAH RD",
    "dropmalcty": "JENSEN BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 349579998,
    "dropsitphn": 7723341592,
    "dropsitlph": 7723341592,
    "dropsitcph": 7722320869,
    "dropfax": 7723349128
  },
  {
    "dcode": "D",
    "dropkey": "PY22154",
    "droptype": "D",
    "dropname": "JUPITER",
    "dropdeladd": "1095 MILITARY TRL",
    "dropdelcty": "JUPITER",
    "dropdelst": "FL",
    "dropdelzpp": 334589998,
    "dropphyadd": "1095 MILITARY TRL",
    "dropphycty": "JUPITER",
    "dropphyst": "FL",
    "dropphyzpp": 334589998,
    "dropmaladd": "1095 MILITARY TRL",
    "dropmalcty": "JUPITER",
    "dropmalst": "FL",
    "dropmalzpp": 334589998,
    "dropsitphn": 5615756541,
    "dropsitlph": 5615756541,
    "dropsitcph": 5617442799,
    "dropfax": 5617467177
  },
  {
    "dcode": "D",
    "dropkey": "PY22156",
    "droptype": "D",
    "dropname": "KATHLEEN",
    "dropdeladd": "6136 KATHLEEN RD",
    "dropdelcty": "KATHLEEN",
    "dropdelst": "FL",
    "dropdelzpp": 338499800,
    "dropphyadd": "6136 KATHLEEN RD",
    "dropphycty": "KATHLEEN",
    "dropphyst": "FL",
    "dropphyzpp": 338499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KATHLEEN",
    "dropmalst": "FL",
    "dropmalzpp": 338499998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8638162201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22157",
    "droptype": "D",
    "dropname": "KENANSVILLE",
    "dropdeladd": "140 N KENANSVILLE RD",
    "dropdelcty": "KENANSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 347399998,
    "dropphyadd": "140 N KENANSVILLE RD",
    "dropphycty": "KENANSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 347399998,
    "dropmaladd": "140 N KENANSVILLE RD",
    "dropmalcty": "KENANSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 347399998,
    "dropsitphn": 4074361142,
    "dropsitlph": 4074361142,
    "dropsitcph": 4074361142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22166",
    "droptype": "D",
    "dropname": "KEY LARGO",
    "dropdeladd": "100100 OVERSEAS HWY",
    "dropdelcty": "KEY LARGO",
    "dropdelst": "FL",
    "dropdelzpp": 330379998,
    "dropphyadd": "100100 OVERSEAS HWY",
    "dropphycty": "KEY LARGO",
    "dropphyst": "FL",
    "dropphyzpp": 330379998,
    "dropmaladd": "100100 OVERSEAS HWY",
    "dropmalcty": "KEY LARGO",
    "dropmalst": "FL",
    "dropmalzpp": 330379998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3054510122,
    "dropsitcph": 3054513155,
    "dropfax": 3054530446
  },
  {
    "dcode": "D",
    "dropkey": "PY22167",
    "droptype": "D",
    "dropname": "KEY WEST",
    "dropdeladd": "400 WHITEHEAD ST",
    "dropdelcty": "KEY WEST",
    "dropdelst": "FL",
    "dropdelzpp": 330409998,
    "dropphyadd": "400 WHITEHEAD ST",
    "dropphycty": "KEY WEST",
    "dropphyst": "FL",
    "dropphyzpp": 330409998,
    "dropmaladd": "400 WHITEHEAD ST",
    "dropmalcty": "KEY WEST",
    "dropmalst": "FL",
    "dropmalzpp": 330409998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052943982,
    "dropsitcph": 3052949539,
    "dropfax": 3052946575
  },
  {
    "dcode": "D",
    "dropkey": "PY22169",
    "droptype": "D",
    "dropname": "KEYSTONE HEIGHTS",
    "dropdeladd": "110 NE COMMERCIAL CIR",
    "dropdelcty": "KEYSTONE HEIGHTS",
    "dropdelst": "FL",
    "dropdelzpp": 326569998,
    "dropphyadd": "110 NE COMMERCIAL CIR",
    "dropphycty": "KEYSTONE HEIGHTS",
    "dropphyst": "FL",
    "dropphyzpp": 326569998,
    "dropmaladd": "110 NE COMMERCIAL CIR",
    "dropmalcty": "KEYSTONE HEIGHTS",
    "dropmalst": "FL",
    "dropmalzpp": 326569998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524734675,
    "dropsitcph": 3524734675,
    "dropfax": 3524730035
  },
  {
    "dcode": "D",
    "dropkey": "PY22175",
    "droptype": "D",
    "dropname": "KISSIMMEE",
    "dropdeladd": "2600 MICHIGAN AVE",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347449998,
    "dropphyadd": "2600 MICHIGAN AVE",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347449998,
    "dropmaladd": "2600 MICHIGAN AVE",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347449998,
    "dropsitphn": 4078467550,
    "dropsitlph": 4079332044,
    "dropsitcph": 4078460999,
    "dropfax": 4078463022
  },
  {
    "dcode": "D",
    "dropkey": "PY22178",
    "droptype": "D",
    "dropname": "LA CROSSE",
    "dropdeladd": "20300 N STATE ROAD 121",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "FL",
    "dropdelzpp": 326582100,
    "dropphyadd": "20300 N STATE ROAD 121",
    "dropphycty": "LA CROSSE",
    "dropphyst": "FL",
    "dropphyzpp": 326582100,
    "dropmaladd": "20300 N STATE ROAD 121",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "FL",
    "dropmalzpp": 326589998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864621966,
    "dropsitcph": 3864621966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22181",
    "droptype": "D",
    "dropname": "LABELLE",
    "dropdeladd": "35 W WASHINGTON AVE",
    "dropdelcty": "LABELLE",
    "dropdelst": "FL",
    "dropdelzpp": 339359998,
    "dropphyadd": "35 W WASHINGTON AVE",
    "dropphycty": "LABELLE",
    "dropphyst": "FL",
    "dropphyzpp": 339359998,
    "dropmaladd": "35 W WASHINGTON AVE",
    "dropmalcty": "LABELLE",
    "dropmalst": "FL",
    "dropmalzpp": 339359998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 8636124854,
    "dropfax": 8636759280
  },
  {
    "dcode": "D",
    "dropkey": "PY22182",
    "droptype": "D",
    "dropname": "LACOOCHEE",
    "dropdeladd": "38915 STATE ROAD 575",
    "dropdelcty": "LACOOCHEE",
    "dropdelst": "FL",
    "dropdelzpp": 335379700,
    "dropphyadd": "38915 STATE ROAD 575",
    "dropphycty": "LACOOCHEE",
    "dropphyst": "FL",
    "dropphyzpp": 335379700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LACOOCHEE",
    "dropmalst": "FL",
    "dropmalzpp": 335379998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3525833585,
    "dropfax": 3525835148
  },
  {
    "dcode": "D",
    "dropkey": "PY22184",
    "droptype": "D",
    "dropname": "LADY LAKE",
    "dropdeladd": "850 TEAGUE TRL",
    "dropdelcty": "LADY LAKE",
    "dropdelst": "FL",
    "dropdelzpp": 321593146,
    "dropphyadd": "850 TEAGUE TRL",
    "dropphycty": "LADY LAKE",
    "dropphyst": "FL",
    "dropphyzpp": 321599998,
    "dropmaladd": "850 TEAGUE TRL",
    "dropmalcty": "LADY LAKE",
    "dropmalst": "FL",
    "dropmalzpp": 321599998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527533888,
    "dropsitcph": 3527533888,
    "dropfax": 3527538844
  },
  {
    "dcode": "D",
    "dropkey": "PY22187",
    "droptype": "D",
    "dropname": "LAKE ALFRED",
    "dropdeladd": "195 W HAINES BLVD",
    "dropdelcty": "LAKE ALFRED",
    "dropdelst": "FL",
    "dropdelzpp": 338509998,
    "dropphyadd": "195 W HAINES BLVD",
    "dropphycty": "LAKE ALFRED",
    "dropphyst": "FL",
    "dropphyzpp": 338509998,
    "dropmaladd": "195 W HAINES BLVD",
    "dropmalcty": "LAKE ALFRED",
    "dropmalst": "FL",
    "dropmalzpp": 338509998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8639564664,
    "dropfax": 8639564664
  },
  {
    "dcode": "D",
    "dropkey": "PY22189",
    "droptype": "D",
    "dropname": "LAKE BUTLER",
    "dropdeladd": "215 NW 1ST ST",
    "dropdelcty": "LAKE BUTLER",
    "dropdelst": "FL",
    "dropdelzpp": 320549998,
    "dropphyadd": "215 NW 1ST ST",
    "dropphycty": "LAKE BUTLER",
    "dropphyst": "FL",
    "dropphyzpp": 320549998,
    "dropmaladd": "215 NW 1ST ST",
    "dropmalcty": "LAKE BUTLER",
    "dropmalst": "FL",
    "dropmalzpp": 320549998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864962060,
    "dropsitcph": 3864962060,
    "dropfax": 3864964773
  },
  {
    "dcode": "D",
    "dropkey": "PY22191",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "250 NW MAIN BLVD",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "FL",
    "dropdelzpp": 320559998,
    "dropphyadd": "250 NW MAIN BLVD",
    "dropphycty": "LAKE CITY",
    "dropphyst": "FL",
    "dropphyzpp": 320559998,
    "dropmaladd": "250 NW MAIN BLVD",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "FL",
    "dropmalzpp": 320559998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3862436192,
    "dropsitcph": 3862436192,
    "dropfax": 3867525045
  },
  {
    "dcode": "D",
    "dropkey": "PY22193",
    "droptype": "D",
    "dropname": "LAKE COMO",
    "dropdeladd": "148 EUCLID AVE",
    "dropdelcty": "POMONA PARK",
    "dropdelst": "FL",
    "dropdelzpp": 321812468,
    "dropphyadd": "148 EUCLID AVE",
    "dropphycty": "POMONA PARK",
    "dropphyst": "FL",
    "dropphyzpp": 321812468,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE COMO",
    "dropmalst": "FL",
    "dropmalzpp": 321579998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866494144,
    "dropsitcph": 3866494144,
    "dropfax": 3866494144
  },
  {
    "dcode": "D",
    "dropkey": "PY22197",
    "droptype": "D",
    "dropname": "LAKE GENEVA",
    "dropdeladd": "7921 STATE ROAD 100",
    "dropdelcty": "LAKE GENEVA",
    "dropdelst": "FL",
    "dropdelzpp": 321602100,
    "dropphyadd": "7921 STATE ROAD 100",
    "dropphycty": "LAKE GENEVA",
    "dropphyst": "FL",
    "dropphyzpp": 321602100,
    "dropmaladd": "7921 STATE ROAD 100",
    "dropmalcty": "LAKE GENEVA",
    "dropmalst": "FL",
    "dropmalzpp": 321609998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524734661,
    "dropsitcph": 3524734661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22198",
    "droptype": "D",
    "dropname": "LAKE HAMILTON",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "LAKE HAMILTON",
    "dropdelst": "FL",
    "dropdelzpp": 338519058,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "LAKE HAMILTON",
    "dropphyst": "FL",
    "dropphyzpp": 338519058,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE HAMILTON",
    "dropmalst": "FL",
    "dropmalzpp": 338519998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634392211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22199",
    "droptype": "D",
    "dropname": "LAKE HARBOR",
    "dropdeladd": "15 W CORKSCREW BLVD",
    "dropdelcty": "LAKE HARBOR",
    "dropdelst": "FL",
    "dropdelzpp": 334599798,
    "dropphyadd": "15 W CORKSCREW BLVD",
    "dropphycty": "LAKE HARBOR",
    "dropphyst": "FL",
    "dropphyzpp": 334599798,
    "dropmaladd": "15 W CORKSCREW BLVD",
    "dropmalcty": "LAKE HARBOR",
    "dropmalst": "FL",
    "dropmalzpp": 334599798,
    "dropsitphn": 5619969003,
    "dropsitlph": 5619969003,
    "dropsitcph": 5619969003,
    "dropfax": 5619961207
  },
  {
    "dcode": "D",
    "dropkey": "PY22200",
    "droptype": "D",
    "dropname": "LAKE HELEN",
    "dropdeladd": "104 E MICHIGAN AVE",
    "dropdelcty": "LAKE HELEN",
    "dropdelst": "FL",
    "dropdelzpp": 327449998,
    "dropphyadd": "104 E MICHIGAN AVE",
    "dropphycty": "LAKE HELEN",
    "dropphyst": "FL",
    "dropphyzpp": 327449998,
    "dropmaladd": "104 E MICHIGAN AVE",
    "dropmalcty": "LAKE HELEN",
    "dropmalst": "FL",
    "dropmalzpp": 327449998,
    "dropsitphn": 3862282227,
    "dropsitlph": 3862282227,
    "dropsitcph": 3862282227,
    "dropfax": 3862280468
  },
  {
    "dcode": "D",
    "dropkey": "PY22207",
    "droptype": "D",
    "dropname": "LAKE MARY",
    "dropdeladd": "3415 W LAKE MARY BLVD",
    "dropdelcty": "LAKE MARY",
    "dropdelst": "FL",
    "dropdelzpp": 327469998,
    "dropphyadd": "3415 W LAKE MARY BLVD",
    "dropphycty": "LAKE MARY",
    "dropphyst": "FL",
    "dropphyzpp": 327469998,
    "dropmaladd": "3415 W LAKE MARY BLVD",
    "dropmalcty": "LAKE MARY",
    "dropmalst": "FL",
    "dropmalzpp": 327469998,
    "dropsitphn": 4073239347,
    "dropsitlph": 4073239347,
    "dropsitcph": 4073288615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22210",
    "droptype": "D",
    "dropname": "LAKE MONROE",
    "dropdeladd": "755 MONROE RD",
    "dropdelcty": "LAKE MONROE",
    "dropdelst": "FL",
    "dropdelzpp": 327478899,
    "dropphyadd": "755 MONROE RD",
    "dropphycty": "LAKE MONROE",
    "dropphyst": "FL",
    "dropphyzpp": 327478899,
    "dropmaladd": "PO BOX 479998",
    "dropmalcty": "LAKE MONROE",
    "dropmalst": "FL",
    "dropmalzpp": 327479998,
    "dropsitphn": 4073280844,
    "dropsitlph": 4073223084,
    "dropsitcph": 4073280844,
    "dropfax": 4073221447
  },
  {
    "dcode": "D",
    "dropkey": "PY22212",
    "droptype": "D",
    "dropname": "LAKE PANASOFFKEE",
    "dropdeladd": "1397 CR 437",
    "dropdelcty": "LAKE PANASOFFKEE",
    "dropdelst": "FL",
    "dropdelzpp": 335385309,
    "dropphyadd": "1397 CR 437",
    "dropphycty": "LAKE PANASOFFKEE",
    "dropphyst": "FL",
    "dropphyzpp": 335385309,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE PANASOFFKEE",
    "dropmalst": "FL",
    "dropmalzpp": 335389998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527920773,
    "dropfax": 3527935611
  },
  {
    "dcode": "D",
    "dropkey": "PY22215",
    "droptype": "D",
    "dropname": "LAKE PLACID",
    "dropdeladd": "901 HILLCREST AVE",
    "dropdelcty": "LAKE PLACID",
    "dropdelst": "FL",
    "dropdelzpp": 338529998,
    "dropphyadd": "901 HILLCREST AVE",
    "dropphycty": "LAKE PLACID",
    "dropphyst": "FL",
    "dropphyzpp": 338529998,
    "dropmaladd": "901 HILLCREST AVE",
    "dropmalcty": "LAKE PLACID",
    "dropmalst": "FL",
    "dropmalzpp": 338529998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636996776,
    "dropfax": 8634650453
  },
  {
    "dcode": "D",
    "dropkey": "PY22223",
    "droptype": "D",
    "dropname": "LAKE WALES",
    "dropdeladd": "6 W PARK AVE",
    "dropdelcty": "LAKE WALES",
    "dropdelst": "FL",
    "dropdelzpp": 338539998,
    "dropphyadd": "6 W PARK AVE",
    "dropphycty": "LAKE WALES",
    "dropphyst": "FL",
    "dropphyzpp": 338539998,
    "dropmaladd": "6 W PARK AVE",
    "dropmalcty": "LAKE WALES",
    "dropmalst": "FL",
    "dropmalzpp": 338539998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636767008,
    "dropfax": 8636781805
  },
  {
    "dcode": "D",
    "dropkey": "PY22225",
    "droptype": "D",
    "dropname": "LAKE WORTH",
    "dropdeladd": "4151 LAKE WORTH RD",
    "dropdelcty": "LAKE WORTH",
    "dropdelst": "FL",
    "dropdelzpp": 334619998,
    "dropphyadd": "4151 LAKE WORTH RD",
    "dropphycty": "LAKE WORTH",
    "dropphyst": "FL",
    "dropphyzpp": 334619998,
    "dropmaladd": "4151 LAKE WORTH RD",
    "dropmalcty": "LAKE WORTH",
    "dropmalst": "FL",
    "dropmalzpp": 334619998,
    "dropsitphn": 5619696962,
    "dropsitlph": 5619696962,
    "dropsitcph": 5613577864,
    "dropfax": 5612731044
  },
  {
    "dcode": "D",
    "dropkey": "PY22227",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "2800 LAKELAND HILLS BLVD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338059998,
    "dropphyadd": "2800 LAKELAND HILLS BLVD",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338059998,
    "dropmaladd": "2800 LAKELAND HILLS BLVD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338059998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8638022071,
    "dropfax": 8636874401
  },
  {
    "dcode": "D",
    "dropkey": "PY22230",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "6244 E CAPPS HWY",
    "dropdelcty": "LAMONT",
    "dropdelst": "FL",
    "dropdelzpp": 323369998,
    "dropphyadd": "6244 E CAPPS HWY",
    "dropphycty": "LAMONT",
    "dropphyst": "FL",
    "dropphyzpp": 323369998,
    "dropmaladd": "6244 E CAPPS HWY",
    "dropmalcty": "LAMONT",
    "dropmalst": "FL",
    "dropmalzpp": 323369998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509973070,
    "dropsitcph": 8509973070,
    "dropfax": 8509973050
  },
  {
    "dcode": "D",
    "dropkey": "PY22233",
    "droptype": "D",
    "dropname": "LAND O LAKES",
    "dropdeladd": "5230 LAND O LAKES BLVD",
    "dropdelcty": "LAND O LAKES",
    "dropdelst": "FL",
    "dropdelzpp": 346399998,
    "dropphyadd": "5230 LAND O LAKES BLVD",
    "dropphycty": "LAND O LAKES",
    "dropphyst": "FL",
    "dropphyzpp": 346399998,
    "dropmaladd": "5230 LAND O LAKES BLVD",
    "dropmalcty": "LAND O LAKES",
    "dropmalst": "FL",
    "dropmalzpp": 346399998,
    "dropsitphn": 8138770683,
    "dropsitlph": 8138770637,
    "dropsitcph": 8139961257,
    "dropfax": 8139962239
  },
  {
    "dcode": "D",
    "dropkey": "PY22237",
    "droptype": "D",
    "dropname": "LARGO",
    "dropdeladd": "50 8TH AVE SW",
    "dropdelcty": "LARGO",
    "dropdelst": "FL",
    "dropdelzpp": 337709998,
    "dropphyadd": "50 8TH AVE SW",
    "dropphycty": "LARGO",
    "dropphyst": "FL",
    "dropphyzpp": 337709998,
    "dropmaladd": "50 8TH AVE SW",
    "dropmalcty": "LARGO",
    "dropmalst": "FL",
    "dropmalzpp": 337709998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275840301,
    "dropfax": 7275817333
  },
  {
    "dcode": "D",
    "dropkey": "PY22246",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "302 LAUREL RD E",
    "dropdelcty": "LAUREL",
    "dropdelst": "FL",
    "dropdelzpp": 342729800,
    "dropphyadd": "302 LAUREL RD E",
    "dropphycty": "LAUREL",
    "dropphyst": "FL",
    "dropphyzpp": 342729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUREL",
    "dropmalst": "FL",
    "dropmalzpp": 342729998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414881954,
    "dropfax": 9414881414
  },
  {
    "dcode": "D",
    "dropkey": "PY22248",
    "droptype": "D",
    "dropname": "LAUREL HILL",
    "dropdeladd": "3957 2ND AVE",
    "dropdelcty": "LAUREL HILL",
    "dropdelst": "FL",
    "dropdelzpp": 325679998,
    "dropphyadd": "3957 2ND AVE",
    "dropphycty": "LAUREL HILL",
    "dropphyst": "FL",
    "dropphyzpp": 325679998,
    "dropmaladd": "3957 2ND AVE",
    "dropmalcty": "LAUREL HILL",
    "dropmalst": "FL",
    "dropmalzpp": 325679998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506524442,
    "dropsitcph": 8506524442,
    "dropfax": 8506522566
  },
  {
    "dcode": "D",
    "dropkey": "PY22249",
    "droptype": "D",
    "dropname": "LAWTEY",
    "dropdeladd": "22706 US HIGHWAY 301 N",
    "dropdelcty": "LAWTEY",
    "dropdelst": "FL",
    "dropdelzpp": 320589998,
    "dropphyadd": "22706 US HIGHWAY 301 N",
    "dropphycty": "LAWTEY",
    "dropphyst": "FL",
    "dropphyzpp": 320589998,
    "dropmaladd": "22706 US HIGHWAY 301 N",
    "dropmalcty": "LAWTEY",
    "dropmalst": "FL",
    "dropmalzpp": 320589998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047823600,
    "dropsitcph": 9047823600,
    "dropfax": 9047823756
  },
  {
    "dcode": "D",
    "dropkey": "PY22251",
    "droptype": "D",
    "dropname": "LECANTO",
    "dropdeladd": "320 S LECANTO HWY",
    "dropdelcty": "LECANTO",
    "dropdelst": "FL",
    "dropdelzpp": 344619998,
    "dropphyadd": "320 S LECANTO HWY",
    "dropphycty": "LECANTO",
    "dropphyst": "FL",
    "dropphyzpp": 344619998,
    "dropmaladd": "320 S LECANTO HWY",
    "dropmalcty": "LECANTO",
    "dropmalst": "FL",
    "dropmalzpp": 344619998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527462424,
    "dropsitcph": 3527462424,
    "dropfax": 3525271332
  },
  {
    "dcode": "D",
    "dropkey": "PY22252",
    "droptype": "D",
    "dropname": "LEE",
    "dropdeladd": "7760 E US HIGHWAY 90",
    "dropdelcty": "LEE",
    "dropdelst": "FL",
    "dropdelzpp": 320595762,
    "dropphyadd": "7760 E US HIGHWAY 90",
    "dropphycty": "LEE",
    "dropphyst": "FL",
    "dropphyzpp": 320595762,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEE",
    "dropmalst": "FL",
    "dropmalzpp": 320599998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507576000,
    "dropsitcph": 8507576000,
    "dropfax": 8509714139
  },
  {
    "dcode": "D",
    "dropkey": "PY22254",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "1201 S 14TH ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "FL",
    "dropdelzpp": 347489998,
    "dropphyadd": "1201 S 14TH ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "FL",
    "dropphyzpp": 347489998,
    "dropmaladd": "1201 S 14TH ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "FL",
    "dropmalzpp": 347489998,
    "dropsitphn": 3523262145,
    "dropsitlph": 3523262145,
    "dropsitcph": 3527876539,
    "dropfax": 3523268373
  },
  {
    "dcode": "D",
    "dropkey": "PY22256",
    "droptype": "D",
    "dropname": "LEHIGH ACRES",
    "dropdeladd": "1201 BUSINESS WAY",
    "dropdelcty": "LEHIGH ACRES",
    "dropdelst": "FL",
    "dropdelzpp": 339369998,
    "dropphyadd": "1201 BUSINESS WAY",
    "dropphycty": "LEHIGH ACRES",
    "dropphyst": "FL",
    "dropphyzpp": 339369998,
    "dropmaladd": "1201 BUSINESS WAY",
    "dropmalcty": "LEHIGH ACRES",
    "dropmalst": "FL",
    "dropmalzpp": 339369998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2393698911,
    "dropsitcph": 2393699154,
    "dropfax": 2393698596
  },
  {
    "dcode": "D",
    "dropkey": "PY22268",
    "droptype": "D",
    "dropname": "LITHIA",
    "dropdeladd": "7825 LITHIA PINECREST RD",
    "dropdelcty": "LITHIA",
    "dropdelst": "FL",
    "dropdelzpp": 335479998,
    "dropphyadd": "7825 LITHIA PINECREST RD",
    "dropphycty": "LITHIA",
    "dropphyst": "FL",
    "dropphyzpp": 335479998,
    "dropmaladd": "7825 LITHIA PINECREST RD",
    "dropmalcty": "LITHIA",
    "dropmalst": "FL",
    "dropmalzpp": 335479998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136614001,
    "dropfax": 6519943236
  },
  {
    "dcode": "D",
    "dropkey": "PY22271",
    "droptype": "D",
    "dropname": "LIVE OAK",
    "dropdeladd": "1415 OHIO AVE N",
    "dropdelcty": "LIVE OAK",
    "dropdelst": "FL",
    "dropdelzpp": 320649998,
    "dropphyadd": "1415 OHIO AVE N",
    "dropphycty": "LIVE OAK",
    "dropphyst": "FL",
    "dropphyzpp": 320649998,
    "dropmaladd": "1415 OHIO AVE N",
    "dropmalcty": "LIVE OAK",
    "dropmalst": "FL",
    "dropmalzpp": 320649998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863396058,
    "dropsitcph": 3863622931,
    "dropfax": 3863641412
  },
  {
    "dcode": "D",
    "dropkey": "PY22280",
    "droptype": "D",
    "dropname": "LLOYD",
    "dropdeladd": "8781 OLD LLOYD RD",
    "dropdelcty": "LLOYD",
    "dropdelst": "FL",
    "dropdelzpp": 323379900,
    "dropphyadd": "8781 OLD LLOYD RD",
    "dropphycty": "LLOYD",
    "dropphyst": "FL",
    "dropphyzpp": 323379900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LLOYD",
    "dropmalst": "FL",
    "dropmalzpp": 323379998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509973863,
    "dropsitcph": 8509973863,
    "dropfax": 8509978852
  },
  {
    "dcode": "D",
    "dropkey": "PY22283",
    "droptype": "D",
    "dropname": "LOCHLOOSA",
    "dropdeladd": "20720 SE 162ND AVE",
    "dropdelcty": "LOCHLOOSA",
    "dropdelst": "FL",
    "dropdelzpp": 326629700,
    "dropphyadd": "20720 SE 162ND AVE",
    "dropphycty": "LOCHLOOSA",
    "dropphyst": "FL",
    "dropphyzpp": 326629700,
    "dropmaladd": "20720 SE 162ND AVE",
    "dropmalcty": "LOCHLOOSA",
    "dropmalst": "FL",
    "dropmalzpp": 326629998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524819303,
    "dropsitcph": 3524819303,
    "dropfax": 3524815247
  },
  {
    "dcode": "D",
    "dropkey": "PY22287",
    "droptype": "D",
    "dropname": "LONG KEY",
    "dropdeladd": "68340 OVERSEAS HWY",
    "dropdelcty": "LONG KEY",
    "dropdelst": "FL",
    "dropdelzpp": 330019998,
    "dropphyadd": "68340 OVERSEAS HWY",
    "dropphycty": "LONG KEY",
    "dropphyst": "FL",
    "dropphyzpp": 330019998,
    "dropmaladd": "68340 OVERSEAS HWY",
    "dropmalcty": "LONG KEY",
    "dropmalst": "FL",
    "dropmalzpp": 330019998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056644112,
    "dropsitcph": 3056644112,
    "dropfax": 7869713441
  },
  {
    "dcode": "D",
    "dropkey": "PY22288",
    "droptype": "D",
    "dropname": "LONGBOAT KEY",
    "dropdeladd": "560 BAY ISLES RD",
    "dropdelcty": "LONGBOAT KEY",
    "dropdelst": "FL",
    "dropdelzpp": 342289998,
    "dropphyadd": "560 BAY ISLES RD",
    "dropphycty": "LONGBOAT KEY",
    "dropphyst": "FL",
    "dropphyzpp": 342289998,
    "dropmaladd": "560 BAY ISLES RD",
    "dropmalcty": "LONGBOAT KEY",
    "dropmalst": "FL",
    "dropmalzpp": 342289998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413834499,
    "dropfax": 9413877323
  },
  {
    "dcode": "D",
    "dropkey": "PY22289",
    "droptype": "D",
    "dropname": "LONGWOOD",
    "dropdeladd": "501 FLORIDA CENTRAL PKWY",
    "dropdelcty": "LONGWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 327509998,
    "dropphyadd": "501 FLORIDA CENTRAL PKWY",
    "dropphycty": "LONGWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 327509998,
    "dropmaladd": "501 FLORIDA CENTRAL PKWY",
    "dropmalcty": "LONGWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 327509998,
    "dropsitphn": 4073396498,
    "dropsitlph": 4073396498,
    "dropsitcph": 4073398230,
    "dropfax": 4073392329
  },
  {
    "dcode": "D",
    "dropkey": "PY22290",
    "droptype": "D",
    "dropname": "LORIDA",
    "dropdeladd": "1665 US HIGHWAY 98",
    "dropdelcty": "LORIDA",
    "dropdelst": "FL",
    "dropdelzpp": 338579800,
    "dropphyadd": "1665 US HIGHWAY 98",
    "dropphycty": "LORIDA",
    "dropphyst": "FL",
    "dropphyzpp": 338579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LORIDA",
    "dropmalst": "FL",
    "dropmalzpp": 338579998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636555265,
    "dropfax": 8636555265
  },
  {
    "dcode": "D",
    "dropkey": "PY22291",
    "droptype": "D",
    "dropname": "LOUGHMAN",
    "dropdeladd": "511 RONALD REAGAN PKWY",
    "dropdelcty": "LOUGHMAN",
    "dropdelst": "FL",
    "dropdelzpp": 338589800,
    "dropphyadd": "511 RONALD REAGAN PKWY",
    "dropphycty": "LOUGHMAN",
    "dropphyst": "FL",
    "dropphyzpp": 338589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOUGHMAN",
    "dropmalst": "FL",
    "dropmalzpp": 338589998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634242362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22292",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "12521 N GAINESVILLE RD",
    "dropdelcty": "LOWELL",
    "dropdelst": "FL",
    "dropdelzpp": 326632100,
    "dropphyadd": "12521 N GAINESVILLE RD",
    "dropphycty": "LOWELL",
    "dropphyst": "FL",
    "dropphyzpp": 326632100,
    "dropmaladd": "12521 N GAINESVILLE RD",
    "dropmalcty": "LOWELL",
    "dropmalst": "FL",
    "dropmalzpp": 326639998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526226123,
    "dropsitcph": 3526226123,
    "dropfax": 3526294952
  },
  {
    "dcode": "D",
    "dropkey": "PY22294",
    "droptype": "D",
    "dropname": "LOXAHATCHEE",
    "dropdeladd": "14611 SOUTHERN BLVD",
    "dropdelcty": "LOXAHATCHEE",
    "dropdelst": "FL",
    "dropdelzpp": 334709998,
    "dropphyadd": "14611 SOUTHERN BLVD",
    "dropphycty": "LOXAHATCHEE",
    "dropphyst": "FL",
    "dropphyzpp": 334709998,
    "dropmaladd": "14611 SOUTHERN BLVD",
    "dropmalcty": "LOXAHATCHEE",
    "dropmalst": "FL",
    "dropmalzpp": 334709998,
    "dropsitphn": 5617986958,
    "dropsitlph": 5617986958,
    "dropsitcph": 5617932086,
    "dropfax": 5617988204
  },
  {
    "dcode": "D",
    "dropkey": "PY22299",
    "droptype": "D",
    "dropname": "LUTZ",
    "dropdeladd": "18489 N US HIGHWAY 41",
    "dropdelcty": "LUTZ",
    "dropdelst": "FL",
    "dropdelzpp": 335494403,
    "dropphyadd": "18489 N US HIGHWAY 41",
    "dropphycty": "LUTZ",
    "dropphyst": "FL",
    "dropphyzpp": 335494403,
    "dropmaladd": "18489 N US HIGHWAY 41",
    "dropmalcty": "LUTZ",
    "dropmalst": "FL",
    "dropmalzpp": 335499998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139480665,
    "dropfax": 8139493903
  },
  {
    "dcode": "D",
    "dropkey": "PY22300",
    "droptype": "D",
    "dropname": "LYNN HAVEN",
    "dropdeladd": "2319 S HIGHWAY 77",
    "dropdelcty": "LYNN HAVEN",
    "dropdelst": "FL",
    "dropdelzpp": 324449998,
    "dropphyadd": "2319 S HIGHWAY 77",
    "dropphycty": "LYNN HAVEN",
    "dropphyst": "FL",
    "dropphyzpp": 324449998,
    "dropmaladd": "2319 S HIGHWAY 77",
    "dropmalcty": "LYNN HAVEN",
    "dropmalst": "FL",
    "dropmalzpp": 324449998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502655111,
    "dropsitcph": 8502655111,
    "dropfax": 8502654722
  },
  {
    "dcode": "D",
    "dropkey": "PY22305",
    "droptype": "D",
    "dropname": "MACCLENNY",
    "dropdeladd": "39 W LOWDER ST",
    "dropdelcty": "MACCLENNY",
    "dropdelst": "FL",
    "dropdelzpp": 320639998,
    "dropphyadd": "39 W LOWDER ST",
    "dropphycty": "MACCLENNY",
    "dropphyst": "FL",
    "dropphyzpp": 320639998,
    "dropmaladd": "39 W LOWDER ST",
    "dropmalcty": "MACCLENNY",
    "dropmalst": "FL",
    "dropmalzpp": 320639998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042592712,
    "dropsitcph": 9042592712,
    "dropfax": 9042593072
  },
  {
    "dcode": "D",
    "dropkey": "PY22314",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "197 SW PINCKNEY ST",
    "dropdelcty": "MADISON",
    "dropdelst": "FL",
    "dropdelzpp": 323402450,
    "dropphyadd": "197 SW PINCKNEY ST",
    "dropphycty": "MADISON",
    "dropphyst": "FL",
    "dropphyzpp": 323402450,
    "dropmaladd": "197 SW PINCKNEY ST",
    "dropmalcty": "MADISON",
    "dropmalst": "FL",
    "dropmalzpp": 323402450,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509736241,
    "dropsitcph": 8509736241,
    "dropfax": 8509738970
  },
  {
    "dcode": "D",
    "dropkey": "PY22319",
    "droptype": "D",
    "dropname": "MAITLAND",
    "dropdeladd": "151 N MAITLAND AVE",
    "dropdelcty": "MAITLAND",
    "dropdelst": "FL",
    "dropdelzpp": 327519998,
    "dropphyadd": "151 N MAITLAND AVE",
    "dropphycty": "MAITLAND",
    "dropphyst": "FL",
    "dropphyzpp": 327519998,
    "dropmaladd": "151 N MAITLAND AVE",
    "dropmalcty": "MAITLAND",
    "dropmalst": "FL",
    "dropmalzpp": 327519998,
    "dropsitphn": 4076225745,
    "dropsitlph": 4076225745,
    "dropsitcph": 4076222001,
    "dropfax": 4076472561
  },
  {
    "dcode": "D",
    "dropkey": "PY22320",
    "droptype": "D",
    "dropname": "MALABAR",
    "dropdeladd": "1720 MALABAR RD",
    "dropdelcty": "MALABAR",
    "dropdelst": "FL",
    "dropdelzpp": 329509998,
    "dropphyadd": "1720 MALABAR RD",
    "dropphycty": "MALABAR",
    "dropphyst": "FL",
    "dropphyzpp": 329509998,
    "dropmaladd": "1720 MALABAR RD",
    "dropmalcty": "MALABAR",
    "dropmalst": "FL",
    "dropmalzpp": 329509998,
    "dropsitphn": 3217277226,
    "dropsitlph": 3217277226,
    "dropsitcph": 3218371195,
    "dropfax": 3217220059
  },
  {
    "dcode": "D",
    "dropkey": "PY22322",
    "droptype": "D",
    "dropname": "MALONE",
    "dropdeladd": "5179 7TH AVE",
    "dropdelcty": "MALONE",
    "dropdelst": "FL",
    "dropdelzpp": 324453265,
    "dropphyadd": "5179 7TH AVE",
    "dropphycty": "MALONE",
    "dropphyst": "FL",
    "dropphyzpp": 324453265,
    "dropmaladd": "5179 7TH AVE",
    "dropmalcty": "MALONE",
    "dropmalst": "FL",
    "dropmalzpp": 324453265,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505692829,
    "dropsitcph": 8505692829,
    "dropfax": 8505692185
  },
  {
    "dcode": "D",
    "dropkey": "PY22329",
    "droptype": "D",
    "dropname": "MANGO",
    "dropdeladd": "11507 DR MARTIN LUTHER KING JR BLVD",
    "dropdelcty": "MANGO",
    "dropdelst": "FL",
    "dropdelzpp": 335509700,
    "dropphyadd": "11507 DR MARTIN LUTHER KING JR BLVD",
    "dropphycty": "MANGO",
    "dropphyst": "FL",
    "dropphyzpp": 335509700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANGO",
    "dropmalst": "FL",
    "dropmalzpp": 335509998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136511709,
    "dropfax": 8136622004
  },
  {
    "dcode": "D",
    "dropkey": "PY22332",
    "droptype": "D",
    "dropname": "MARATHON",
    "dropdeladd": "5171 OVERSEAS HWY",
    "dropdelcty": "MARATHON",
    "dropdelst": "FL",
    "dropdelzpp": 330509998,
    "dropphyadd": "5171 OVERSEAS HWY",
    "dropphycty": "MARATHON",
    "dropphyst": "FL",
    "dropphyzpp": 330509998,
    "dropmaladd": "5171 OVERSEAS HWY",
    "dropmalcty": "MARATHON",
    "dropmalst": "FL",
    "dropmalzpp": 330509998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3057433570,
    "dropsitcph": 3057435238,
    "dropfax": 3054339189
  },
  {
    "dcode": "D",
    "dropkey": "PY22337",
    "droptype": "D",
    "dropname": "MARCO ISLAND",
    "dropdeladd": "600 E ELKCAM CIR",
    "dropdelcty": "MARCO ISLAND",
    "dropdelst": "FL",
    "dropdelzpp": 341459998,
    "dropphyadd": "600 E ELKCAM CIR",
    "dropphycty": "MARCO ISLAND",
    "dropphyst": "FL",
    "dropphyzpp": 341459998,
    "dropmaladd": "600 E ELKCAM CIR",
    "dropmalcty": "MARCO ISLAND",
    "dropmalst": "FL",
    "dropmalzpp": 341459998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393945437,
    "dropfax": 2393945245
  },
  {
    "dcode": "D",
    "dropkey": "PY22340",
    "droptype": "D",
    "dropname": "MARIANNA",
    "dropdeladd": "4396 LAFAYETTE ST",
    "dropdelcty": "MARIANNA",
    "dropdelst": "FL",
    "dropdelzpp": 324469998,
    "dropphyadd": "4396 LAFAYETTE ST",
    "dropphycty": "MARIANNA",
    "dropphyst": "FL",
    "dropphyzpp": 324469998,
    "dropmaladd": "4396 LAFAYETTE ST",
    "dropmalcty": "MARIANNA",
    "dropmalst": "FL",
    "dropmalzpp": 324469998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504824951,
    "dropsitcph": 8504824951,
    "dropfax": 8504826362
  },
  {
    "dcode": "D",
    "dropkey": "PY22344",
    "droptype": "D",
    "dropname": "MARY ESTHER",
    "dropdeladd": "210 W HOLLYWOOD BLVD",
    "dropdelcty": "MARY ESTHER",
    "dropdelst": "FL",
    "dropdelzpp": 325691982,
    "dropphyadd": "210 W HOLLYWOOD BLVD",
    "dropphycty": "MARY ESTHER",
    "dropphyst": "FL",
    "dropphyzpp": 325691982,
    "dropmaladd": "210 W HOLLYWOOD BLVD",
    "dropmalcty": "MARY ESTHER",
    "dropmalst": "FL",
    "dropmalzpp": 325699998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502433512,
    "dropsitcph": 8502433512,
    "dropfax": 8506647519
  },
  {
    "dcode": "D",
    "dropkey": "PY22346",
    "droptype": "D",
    "dropname": "MASCOTTE",
    "dropdeladd": "411 MIDWAY AVE",
    "dropdelcty": "MASCOTTE",
    "dropdelst": "FL",
    "dropdelzpp": 347539998,
    "dropphyadd": "411 MIDWAY AVE",
    "dropphycty": "MASCOTTE",
    "dropphyst": "FL",
    "dropphyzpp": 347539998,
    "dropmaladd": "411 MIDWAY AVE",
    "dropmalcty": "MASCOTTE",
    "dropmalst": "FL",
    "dropmalzpp": 347539998,
    "dropsitphn": 3524294258,
    "dropsitlph": 3524294258,
    "dropsitcph": 3524294258,
    "dropfax": 3524298419
  },
  {
    "dcode": "D",
    "dropkey": "PY22351",
    "droptype": "D",
    "dropname": "MAYO",
    "dropdeladd": "157 E MAIN ST",
    "dropdelcty": "MAYO",
    "dropdelst": "FL",
    "dropdelzpp": 320664808,
    "dropphyadd": "157 E MAIN ST",
    "dropphycty": "MAYO",
    "dropphyst": "FL",
    "dropphyzpp": 320664808,
    "dropmaladd": "157 E MAIN ST",
    "dropmalcty": "MAYO",
    "dropmalst": "FL",
    "dropmalzpp": 320669998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3862941623,
    "dropsitcph": 3862941623,
    "dropfax": 3862942263
  },
  {
    "dcode": "D",
    "dropkey": "PY22359",
    "droptype": "D",
    "dropname": "MC ALPIN",
    "dropdeladd": "17054 US HIGHWAY 129",
    "dropdelcty": "MC ALPIN",
    "dropdelst": "FL",
    "dropdelzpp": 320629998,
    "dropphyadd": "17054 US HIGHWAY 129",
    "dropphycty": "MC ALPIN",
    "dropphyst": "FL",
    "dropphyzpp": 320629998,
    "dropmaladd": "17054 US HIGHWAY 129",
    "dropmalcty": "MC ALPIN",
    "dropmalst": "FL",
    "dropmalzpp": 320629998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863623911,
    "dropsitcph": 3863623911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22360",
    "droptype": "D",
    "dropname": "MC DAVID",
    "dropdeladd": "7 MAIN ST",
    "dropdelcty": "MC DAVID",
    "dropdelst": "FL",
    "dropdelzpp": 325689998,
    "dropphyadd": "7 MAIN ST",
    "dropphycty": "MC DAVID",
    "dropphyst": "FL",
    "dropphyzpp": 325689998,
    "dropmaladd": "7 MAIN ST",
    "dropmalcty": "MC DAVID",
    "dropmalst": "FL",
    "dropmalzpp": 325689998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502565141,
    "dropsitcph": 8502565141,
    "dropfax": 8502565168
  },
  {
    "dcode": "D",
    "dropkey": "PY22361",
    "droptype": "D",
    "dropname": "MC INTOSH",
    "dropdeladd": "5650 AVENUE G",
    "dropdelcty": "MC INTOSH",
    "dropdelst": "FL",
    "dropdelzpp": 326649998,
    "dropphyadd": "5650 AVENUE G",
    "dropphycty": "MC INTOSH",
    "dropphyst": "FL",
    "dropphyzpp": 326649998,
    "dropmaladd": "5650 AVENUE G",
    "dropmalcty": "MC INTOSH",
    "dropmalst": "FL",
    "dropmalzpp": 326649998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525912801,
    "dropsitcph": 3525912801,
    "dropfax": 3525912801
  },
  {
    "dcode": "D",
    "dropkey": "PY22370",
    "droptype": "D",
    "dropname": "MELBOURNE",
    "dropdeladd": "640 E NEW HAVEN AVE",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "FL",
    "dropdelzpp": 329019998,
    "dropphyadd": "640 E NEW HAVEN AVE",
    "dropphycty": "MELBOURNE",
    "dropphyst": "FL",
    "dropphyzpp": 329019998,
    "dropmaladd": "640 E NEW HAVEN AVE",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "FL",
    "dropmalzpp": 329019998,
    "dropsitphn": 3217241488,
    "dropsitlph": 3217241488,
    "dropsitcph": 3217236164,
    "dropfax": 3219843548
  },
  {
    "dcode": "D",
    "dropkey": "PY22375",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "859 N STATE ROAD 21",
    "dropdelcty": "MELROSE",
    "dropdelst": "FL",
    "dropdelzpp": 326669998,
    "dropphyadd": "859 N STATE ROAD 21",
    "dropphycty": "MELROSE",
    "dropphyst": "FL",
    "dropphyzpp": 326669998,
    "dropmaladd": "859 N STATE ROAD 21",
    "dropmalcty": "MELROSE",
    "dropmalst": "FL",
    "dropmalzpp": 326669998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524751701,
    "dropsitcph": 3524751701,
    "dropfax": 3524753247
  },
  {
    "dcode": "D",
    "dropkey": "PY22376",
    "droptype": "D",
    "dropname": "MERRITT ISLAND",
    "dropdeladd": "333 CROCKETT BLVD",
    "dropdelcty": "MERRITT ISLAND",
    "dropdelst": "FL",
    "dropdelzpp": 329539998,
    "dropphyadd": "333 CROCKETT BLVD",
    "dropphycty": "MERRITT ISLAND",
    "dropphyst": "FL",
    "dropphyzpp": 329539998,
    "dropmaladd": "333 CROCKETT BLVD",
    "dropmalcty": "MERRITT ISLAND",
    "dropmalst": "FL",
    "dropmalzpp": 329539998,
    "dropsitphn": 3214531367,
    "dropsitlph": 3214531367,
    "dropsitcph": 3214531366,
    "dropfax": 3214590170
  },
  {
    "dcode": "D",
    "dropkey": "PY22388",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "2200 NW 72ND AVE STE 514",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331529998,
    "dropphyadd": "2200 NW 72ND AVE STE 514",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331529998,
    "dropmaladd": "2200 NW 72ND AVE STE 514",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331529998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054700692,
    "dropsitcph": 3054700689,
    "dropfax": 3054700610
  },
  {
    "dcode": "D",
    "dropkey": "PY22400",
    "droptype": "D",
    "dropname": "MICANOPY",
    "dropdeladd": "202 NE EARLY AVE",
    "dropdelcty": "MICANOPY",
    "dropdelst": "FL",
    "dropdelzpp": 326679998,
    "dropphyadd": "202 NE EARLY AVE",
    "dropphycty": "MICANOPY",
    "dropphyst": "FL",
    "dropphyzpp": 326679998,
    "dropmaladd": "202 NE EARLY AVE",
    "dropmalcty": "MICANOPY",
    "dropmalst": "FL",
    "dropmalzpp": 326679998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524663022,
    "dropsitcph": 3524663022,
    "dropfax": 3524667017
  },
  {
    "dcode": "D",
    "dropkey": "PY22407",
    "droptype": "D",
    "dropname": "MID FLORIDA",
    "dropdeladd": "800 RINEHART RD",
    "dropdelcty": "MID FLORIDA",
    "dropdelst": "FL",
    "dropdelzpp": 327998801,
    "dropphyadd": "800 RINEHART RD",
    "dropphycty": "MID FLORIDA",
    "dropphyst": "FL",
    "dropphyzpp": 327998801,
    "dropmaladd": "PO BOX 999997",
    "dropmalcty": "MID FLORIDA",
    "dropmalst": "FL",
    "dropmalzpp": 327999997,
    "dropsitphn": 4073338496,
    "dropsitlph": 4073338496,
    "dropsitcph": 4073338400,
    "dropfax": 4073338475
  },
  {
    "dcode": "D",
    "dropkey": "PY22411",
    "droptype": "D",
    "dropname": "MIDDLEBURG",
    "dropdeladd": "2073 PALMETTO ST",
    "dropdelcty": "MIDDLEBURG",
    "dropdelst": "FL",
    "dropdelzpp": 320689998,
    "dropphyadd": "2073 PALMETTO ST",
    "dropphycty": "MIDDLEBURG",
    "dropphyst": "FL",
    "dropphyzpp": 320689998,
    "dropmaladd": "2073 PALMETTO ST",
    "dropmalcty": "MIDDLEBURG",
    "dropmalst": "FL",
    "dropmalzpp": 320689998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9044066340,
    "dropsitcph": 9042825721,
    "dropfax": 9042822095
  },
  {
    "dcode": "D",
    "dropkey": "PY22414",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "31000 BLUE STAR HWY",
    "dropdelcty": "MIDWAY",
    "dropdelst": "FL",
    "dropdelzpp": 323432416,
    "dropphyadd": "31000 BLUE STAR HWY",
    "dropphycty": "MIDWAY",
    "dropphyst": "FL",
    "dropphyzpp": 323432416,
    "dropmaladd": "31000 BLUE STAR HWY",
    "dropmalcty": "MIDWAY",
    "dropmalst": "FL",
    "dropmalzpp": 323439998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505753763,
    "dropsitcph": 8505753763,
    "dropfax": 8505750549
  },
  {
    "dcode": "D",
    "dropkey": "PY22417",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "5111 DOGWOOD DR",
    "dropdelcty": "MILTON",
    "dropdelst": "FL",
    "dropdelzpp": 325709998,
    "dropphyadd": "5111 DOGWOOD DR",
    "dropphycty": "MILTON",
    "dropphyst": "FL",
    "dropphyzpp": 325709998,
    "dropmaladd": "5111 DOGWOOD DR",
    "dropmalcty": "MILTON",
    "dropmalst": "FL",
    "dropmalzpp": 325709998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506233808,
    "dropsitcph": 8506233808,
    "dropfax": 8506269541
  },
  {
    "dcode": "D",
    "dropkey": "PY22418",
    "droptype": "D",
    "dropname": "MIMS",
    "dropdeladd": "3405 KELLY RD",
    "dropdelcty": "MIMS",
    "dropdelst": "FL",
    "dropdelzpp": 327549998,
    "dropphyadd": "3405 KELLY RD",
    "dropphycty": "MIMS",
    "dropphyst": "FL",
    "dropphyzpp": 327549998,
    "dropmaladd": "3405 KELLY RD",
    "dropmalcty": "MIMS",
    "dropmalst": "FL",
    "dropmalzpp": 327549998,
    "dropsitphn": 3212649138,
    "dropsitlph": 3212649138,
    "dropsitcph": 3212675122,
    "dropfax": 3212696155
  },
  {
    "dcode": "D",
    "dropkey": "PY22419",
    "droptype": "D",
    "dropname": "MINNEOLA",
    "dropdeladd": "131 W WASHINGTON ST",
    "dropdelcty": "MINNEOLA",
    "dropdelst": "FL",
    "dropdelzpp": 347558327,
    "dropphyadd": "131 W WASHINGTON ST",
    "dropphycty": "MINNEOLA",
    "dropphyst": "FL",
    "dropphyzpp": 347558327,
    "dropmaladd": "PO BOX 559998",
    "dropmalcty": "MINNEOLA",
    "dropmalst": "FL",
    "dropmalzpp": 347559998,
    "dropsitphn": 3522431330,
    "dropsitlph": 3522431330,
    "dropsitcph": 3526773313,
    "dropfax": 3523948675
  },
  {
    "dcode": "D",
    "dropkey": "PY22425",
    "droptype": "D",
    "dropname": "MOLINO",
    "dropdeladd": "550 MOLINO RD",
    "dropdelcty": "MOLINO",
    "dropdelst": "FL",
    "dropdelzpp": 325779998,
    "dropphyadd": "550 MOLINO RD",
    "dropphycty": "MOLINO",
    "dropphyst": "FL",
    "dropphyzpp": 325779998,
    "dropmaladd": "550 MOLINO RD",
    "dropmalcty": "MOLINO",
    "dropmalst": "FL",
    "dropmalzpp": 325779998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505875357,
    "dropsitcph": 8505875357,
    "dropfax": 8505876068
  },
  {
    "dcode": "D",
    "dropkey": "PY22426",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "275 N JEFFERSON ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "FL",
    "dropdelzpp": 323449998,
    "dropphyadd": "275 N JEFFERSON ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "FL",
    "dropphyzpp": 323449998,
    "dropmaladd": "275 N JEFFERSON ST",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "FL",
    "dropmalzpp": 323449998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509972122,
    "dropsitcph": 8509972122,
    "dropfax": 8509970550
  },
  {
    "dcode": "D",
    "dropkey": "PY22427",
    "droptype": "D",
    "dropname": "MONTVERDE",
    "dropdeladd": "17101 PORTER AVE",
    "dropdelcty": "MONTVERDE",
    "dropdelst": "FL",
    "dropdelzpp": 347569998,
    "dropphyadd": "17101 PORTER AVE",
    "dropphycty": "MONTVERDE",
    "dropphyst": "FL",
    "dropphyzpp": 347569998,
    "dropmaladd": "17101 PORTER AVE",
    "dropmalcty": "MONTVERDE",
    "dropmalst": "FL",
    "dropmalzpp": 347569998,
    "dropsitphn": 4074692113,
    "dropsitlph": 4074692113,
    "dropsitcph": 4074692855,
    "dropfax": 4074692119
  },
  {
    "dcode": "D",
    "dropkey": "PY22428",
    "droptype": "D",
    "dropname": "MOORE HAVEN",
    "dropdeladd": "250 10TH ST SW",
    "dropdelcty": "MOORE HAVEN",
    "dropdelst": "FL",
    "dropdelzpp": 334719998,
    "dropphyadd": "250 10TH ST SW",
    "dropphycty": "MOORE HAVEN",
    "dropphyst": "FL",
    "dropphyzpp": 334719998,
    "dropmaladd": "250 10TH ST SW",
    "dropmalcty": "MOORE HAVEN",
    "dropmalst": "FL",
    "dropmalzpp": 334719998,
    "dropsitphn": 8639463403,
    "dropsitlph": 8639463403,
    "dropsitcph": 8639460747,
    "dropfax": 8639460787
  },
  {
    "dcode": "D",
    "dropkey": "PY22429",
    "droptype": "D",
    "dropname": "MORRISTON",
    "dropdeladd": "3350 SE HIGHWAY 41",
    "dropdelcty": "MORRISTON",
    "dropdelst": "FL",
    "dropdelzpp": 326689998,
    "dropphyadd": "3350 SE HIGHWAY 41",
    "dropphycty": "MORRISTON",
    "dropphyst": "FL",
    "dropphyzpp": 326689998,
    "dropmaladd": "3350 SE HIGHWAY 41",
    "dropmalcty": "MORRISTON",
    "dropmalst": "FL",
    "dropmalzpp": 326689998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525286022,
    "dropsitcph": 3525286022,
    "dropfax": 3525289329
  },
  {
    "dcode": "D",
    "dropkey": "PY22431",
    "droptype": "D",
    "dropname": "MOUNT DORA",
    "dropdeladd": "2600 W OLD US HIGHWAY 441",
    "dropdelcty": "MOUNT DORA",
    "dropdelst": "FL",
    "dropdelzpp": 327573548,
    "dropphyadd": "2600 W OLD US HIGHWAY 441",
    "dropphycty": "MOUNT DORA",
    "dropphyst": "FL",
    "dropphyzpp": 327573548,
    "dropmaladd": "2600 W OLD US HIGHWAY 441",
    "dropmalcty": "MOUNT DORA",
    "dropmalst": "FL",
    "dropmalzpp": 327579998,
    "dropsitphn": 3523837792,
    "dropsitlph": 3523837792,
    "dropsitcph": 3523834066,
    "dropfax": 3523839750
  },
  {
    "dcode": "D",
    "dropkey": "PY22436",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "2000 MULFORD RD",
    "dropdelcty": "MULBERRY",
    "dropdelst": "FL",
    "dropdelzpp": 338609998,
    "dropphyadd": "2000 MULFORD RD",
    "dropphycty": "MULBERRY",
    "dropphyst": "FL",
    "dropphyzpp": 338609998,
    "dropmaladd": "2000 MULFORD RD",
    "dropmalcty": "MULBERRY",
    "dropmalst": "FL",
    "dropmalzpp": 338604600,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634256033,
    "dropfax": 8634256030
  },
  {
    "dcode": "D",
    "dropkey": "PY22443",
    "droptype": "D",
    "dropname": "MYAKKA CITY",
    "dropdeladd": "10490 CARLTON AVE",
    "dropdelcty": "MYAKKA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 342519998,
    "dropphyadd": "10490 CARLTON AVE",
    "dropphycty": "MYAKKA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 342519998,
    "dropmaladd": "10490 CARLTON AVE",
    "dropmalcty": "MYAKKA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 342519998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413221734,
    "dropfax": 9413220137
  },
  {
    "dcode": "D",
    "dropkey": "PY22467",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "1200 GOODLETTE-FRANK RD N",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341025254,
    "dropphyadd": "1200 GOODLETTE-FRANK RD N",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341025254,
    "dropmaladd": "1200 GOODLETTE-FRANK RD N",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341029998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2394352146,
    "dropfax": 2394352160
  },
  {
    "dcode": "D",
    "dropkey": "PY22487",
    "droptype": "D",
    "dropname": "NEW PORT RICHEY",
    "dropdeladd": "6550 MAIN ST",
    "dropdelcty": "NEW PORT RICHEY",
    "dropdelst": "FL",
    "dropdelzpp": 346533911,
    "dropphyadd": "6550 MAIN ST",
    "dropphycty": "NEW PORT RICHEY",
    "dropphyst": "FL",
    "dropphyzpp": 346533911,
    "dropmaladd": "6550 MAIN ST",
    "dropmalcty": "NEW PORT RICHEY",
    "dropmalst": "FL",
    "dropmalzpp": 346533911,
    "dropsitphn": 8138770729,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278471659,
    "dropfax": 7272363084
  },
  {
    "dcode": "D",
    "dropkey": "PY22492",
    "droptype": "D",
    "dropname": "NEW SMYRNA BEACH",
    "dropdeladd": "301 MISSION DR",
    "dropdelcty": "NEW SMYRNA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321689998,
    "dropphyadd": "301 MISSION DR",
    "dropphycty": "NEW SMYRNA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321689998,
    "dropmaladd": "301 MISSION DR",
    "dropmalcty": "NEW SMYRNA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321689998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864274394,
    "dropsitcph": 3864271961,
    "dropfax": 3864273511
  },
  {
    "dcode": "D",
    "dropkey": "PY22494",
    "droptype": "D",
    "dropname": "NEWBERRY",
    "dropdeladd": "252 N MAIN ST",
    "dropdelcty": "NEWBERRY",
    "dropdelst": "FL",
    "dropdelzpp": 326699998,
    "dropphyadd": "252 N MAIN ST",
    "dropphycty": "NEWBERRY",
    "dropphyst": "FL",
    "dropphyzpp": 326699998,
    "dropmaladd": "252 N MAIN ST",
    "dropmalcty": "NEWBERRY",
    "dropmalst": "FL",
    "dropmalzpp": 326699998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524722649,
    "dropsitcph": 3524722649,
    "dropfax": 3524723005
  },
  {
    "dcode": "D",
    "dropkey": "PY22496",
    "droptype": "D",
    "dropname": "NICEVILLE",
    "dropdeladd": "90 PALM BLVD N",
    "dropdelcty": "NICEVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 325781213,
    "dropphyadd": "90 PALM BLVD N",
    "dropphycty": "NICEVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 325781213,
    "dropmaladd": "90 PALM BLVD N",
    "dropmalcty": "NICEVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 325789998,
    "dropsitphn": 8506786016,
    "dropsitlph": 8506786016,
    "dropsitcph": 8506782021,
    "dropfax": 8507290232
  },
  {
    "dcode": "D",
    "dropkey": "PY22497",
    "droptype": "D",
    "dropname": "NICHOLS",
    "dropdeladd": "4805 NICHOLS RD",
    "dropdelcty": "NICHOLS",
    "dropdelst": "FL",
    "dropdelzpp": 338639800,
    "dropphyadd": "4805 NICHOLS RD",
    "dropphycty": "NICHOLS",
    "dropphyst": "FL",
    "dropphyzpp": 338639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NICHOLS",
    "dropmalst": "FL",
    "dropmalzpp": 338639998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634253328,
    "dropfax": 8634258459
  },
  {
    "dcode": "D",
    "dropkey": "PY22513",
    "droptype": "D",
    "dropname": "NOBLETON",
    "dropdeladd": "29095 FORBES ST",
    "dropdelcty": "NOBLETON",
    "dropdelst": "FL",
    "dropdelzpp": 346619801,
    "dropphyadd": "29095 FORBES ST",
    "dropphycty": "NOBLETON",
    "dropphyst": "FL",
    "dropphyzpp": 346619801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOBLETON",
    "dropmalst": "FL",
    "dropmalzpp": 346619998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 3527968846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22514",
    "droptype": "D",
    "dropname": "NOCATEE",
    "dropdeladd": "2509 SW COUNTY ROAD 760",
    "dropdelcty": "NOCATEE",
    "dropdelst": "FL",
    "dropdelzpp": 342689800,
    "dropphyadd": "2509 SW COUNTY ROAD 760",
    "dropphycty": "NOCATEE",
    "dropphyst": "FL",
    "dropphyzpp": 342689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOCATEE",
    "dropmalst": "FL",
    "dropmalzpp": 342689998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 8634945752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22515",
    "droptype": "D",
    "dropname": "NOKOMIS",
    "dropdeladd": "303 LAUREL RD W",
    "dropdelcty": "NOKOMIS",
    "dropdelst": "FL",
    "dropdelzpp": 342759998,
    "dropphyadd": "303 LAUREL RD W",
    "dropphycty": "NOKOMIS",
    "dropphyst": "FL",
    "dropphyzpp": 342759998,
    "dropmaladd": "303 LAUREL RD W",
    "dropmalcty": "NOKOMIS",
    "dropmalst": "FL",
    "dropmalzpp": 342759998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414801703,
    "dropfax": 9414844554
  },
  {
    "dcode": "D",
    "dropkey": "PY22558",
    "droptype": "D",
    "dropname": "O BRIEN",
    "dropdeladd": "22654 US HIGHWAY 129",
    "dropdelcty": "O BRIEN",
    "dropdelst": "FL",
    "dropdelzpp": 320719998,
    "dropphyadd": "22654 US HIGHWAY 129",
    "dropphycty": "O BRIEN",
    "dropphyst": "FL",
    "dropphyzpp": 320719998,
    "dropmaladd": "22654 US HIGHWAY 129",
    "dropmalcty": "O BRIEN",
    "dropmalst": "FL",
    "dropmalzpp": 320719998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3869351530,
    "dropsitcph": 3869351530,
    "dropfax": 3869351208
  },
  {
    "dcode": "D",
    "dropkey": "PY22560",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "129 E HALIFAX AVE",
    "dropdelcty": "OAK HILL",
    "dropdelst": "FL",
    "dropdelzpp": 327599998,
    "dropphyadd": "129 E HALIFAX AVE",
    "dropphycty": "OAK HILL",
    "dropphyst": "FL",
    "dropphyzpp": 327599998,
    "dropmaladd": "129 E HALIFAX AVE",
    "dropmalcty": "OAK HILL",
    "dropmalst": "FL",
    "dropmalzpp": 327599998,
    "dropsitphn": 3863453574,
    "dropsitlph": 3863453574,
    "dropsitcph": 3863453574,
    "dropfax": 3863450431
  },
  {
    "dcode": "D",
    "dropkey": "PY22565",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "210 N TUBB ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "FL",
    "dropdelzpp": 347608900,
    "dropphyadd": "210 N TUBB ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "FL",
    "dropphyzpp": 347608900,
    "dropmaladd": "PO BOX 609998",
    "dropmalcty": "OAKLAND",
    "dropmalst": "FL",
    "dropmalzpp": 347609998,
    "dropsitphn": 4076568844,
    "dropsitlph": 4076568844,
    "dropsitcph": 4076567188,
    "dropfax": 4076561443
  },
  {
    "dcode": "D",
    "dropkey": "PY22570",
    "droptype": "D",
    "dropname": "OCALA",
    "dropdeladd": "400 SW 1ST AVE",
    "dropdelcty": "OCALA",
    "dropdelst": "FL",
    "dropdelzpp": 344789998,
    "dropphyadd": "400 SW 1ST AVE",
    "dropphycty": "OCALA",
    "dropphyst": "FL",
    "dropphyzpp": 344789998,
    "dropmaladd": "400 SW 1ST AVE",
    "dropmalcty": "OCALA",
    "dropmalst": "FL",
    "dropmalzpp": 344789998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3528671728,
    "dropsitcph": 3528671603,
    "dropfax": 3526291453
  },
  {
    "dcode": "D",
    "dropkey": "PY22575",
    "droptype": "D",
    "dropname": "OCHOPEE",
    "dropdeladd": "38000 TAMIAMI TRL E",
    "dropdelcty": "OCHOPEE",
    "dropdelst": "FL",
    "dropdelzpp": 341412003,
    "dropphyadd": "38000 TAMIAMI TRL E",
    "dropphycty": "OCHOPEE",
    "dropphyst": "FL",
    "dropphyzpp": 341412003,
    "dropmaladd": "38000 TAMIAMI TRL E",
    "dropmalcty": "OCHOPEE",
    "dropmalst": "FL",
    "dropmalzpp": 341412003,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396952099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22576",
    "droptype": "D",
    "dropname": "OCKLAWAHA",
    "dropdeladd": "13470 E HIGHWAY 25",
    "dropdelcty": "OCKLAWAHA",
    "dropdelst": "FL",
    "dropdelzpp": 321795201,
    "dropphyadd": "13470 E HIGHWAY 25",
    "dropphycty": "OCKLAWAHA",
    "dropphyst": "FL",
    "dropphyzpp": 321795201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCKLAWAHA",
    "dropmalst": "FL",
    "dropmalzpp": 321839998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522883700,
    "dropsitcph": 3522883700,
    "dropfax": 3522889526
  },
  {
    "dcode": "D",
    "dropkey": "PY22577",
    "droptype": "D",
    "dropname": "OCOEE",
    "dropdeladd": "449 W SILVER STAR RD",
    "dropdelcty": "OCOEE",
    "dropdelst": "FL",
    "dropdelzpp": 347619998,
    "dropphyadd": "449 W SILVER STAR RD",
    "dropphycty": "OCOEE",
    "dropphyst": "FL",
    "dropphyzpp": 347619998,
    "dropmaladd": "449 W SILVER STAR RD",
    "dropmalcty": "OCOEE",
    "dropmalst": "FL",
    "dropmalzpp": 347619998,
    "dropsitphn": 4076569447,
    "dropsitlph": 4076569447,
    "dropsitcph": 4076549581,
    "dropfax": 4076566558
  },
  {
    "dcode": "D",
    "dropkey": "PY22578",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "13266 BYRD DR STE 100",
    "dropdelcty": "ODESSA",
    "dropdelst": "FL",
    "dropdelzpp": 335565309,
    "dropphyadd": "13266 BYRD DR STE 100",
    "dropphycty": "ODESSA",
    "dropphyst": "FL",
    "dropphyzpp": 335565309,
    "dropmaladd": "13266 BYRD DR STE 100",
    "dropmalcty": "ODESSA",
    "dropmalst": "FL",
    "dropmalzpp": 335565309,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139267013,
    "dropfax": 8139267013
  },
  {
    "dcode": "D",
    "dropkey": "PY22580",
    "droptype": "D",
    "dropname": "OKAHUMPKA",
    "dropdeladd": "3441 COUNTY ROAD 470",
    "dropdelcty": "OKAHUMPKA",
    "dropdelst": "FL",
    "dropdelzpp": 347629998,
    "dropphyadd": "3441 COUNTY ROAD 470",
    "dropphycty": "OKAHUMPKA",
    "dropphyst": "FL",
    "dropphyzpp": 347629998,
    "dropmaladd": "3441 COUNTY ROAD 470",
    "dropmalcty": "OKAHUMPKA",
    "dropmalst": "FL",
    "dropmalzpp": 347629998,
    "dropsitphn": 3527282214,
    "dropsitlph": 3527282214,
    "dropsitcph": 3527282214,
    "dropfax": 3527288357
  },
  {
    "dcode": "D",
    "dropkey": "PY22582",
    "droptype": "D",
    "dropname": "OKEECHOBEE",
    "dropdeladd": "1000 STATE ROAD 70 E",
    "dropdelcty": "OKEECHOBEE",
    "dropdelst": "FL",
    "dropdelzpp": 349729998,
    "dropphyadd": "1000 STATE ROAD 70 E",
    "dropphycty": "OKEECHOBEE",
    "dropphyst": "FL",
    "dropphyzpp": 349729998,
    "dropmaladd": "1000 STATE ROAD 70 E",
    "dropmalcty": "OKEECHOBEE",
    "dropmalst": "FL",
    "dropmalzpp": 349729998,
    "dropsitphn": 8637637639,
    "dropsitlph": 8637637639,
    "dropsitcph": 8637633616,
    "dropfax": 8638244425
  },
  {
    "dcode": "D",
    "dropkey": "PY22585",
    "droptype": "D",
    "dropname": "OLD TOWN",
    "dropdeladd": "26164 SE HIGHWAY 19",
    "dropdelcty": "OLD TOWN",
    "dropdelst": "FL",
    "dropdelzpp": 326803913,
    "dropphyadd": "26164 SE HIGHWAY 19",
    "dropphycty": "OLD TOWN",
    "dropphyst": "FL",
    "dropphyzpp": 326803913,
    "dropmaladd": "26164 SE HIGHWAY 19",
    "dropmalcty": "OLD TOWN",
    "dropmalst": "FL",
    "dropmalzpp": 326803913,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525427911,
    "dropsitcph": 3525427911,
    "dropfax": 3525429506
  },
  {
    "dcode": "D",
    "dropkey": "PY22586",
    "droptype": "D",
    "dropname": "OLDSMAR",
    "dropdeladd": "3905 TAMPA RD",
    "dropdelcty": "OLDSMAR",
    "dropdelst": "FL",
    "dropdelzpp": 346773125,
    "dropphyadd": "3905 TAMPA RD",
    "dropphycty": "OLDSMAR",
    "dropphyst": "FL",
    "dropphyzpp": 346773125,
    "dropmaladd": "3905 TAMPA RD",
    "dropmalcty": "OLDSMAR",
    "dropmalst": "FL",
    "dropmalzpp": 346773125,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 8138544660,
    "dropfax": 8132614207
  },
  {
    "dcode": "D",
    "dropkey": "PY22591",
    "droptype": "D",
    "dropname": "ONA",
    "dropdeladd": "5155 STATE ROAD 64 W",
    "dropdelcty": "ONA",
    "dropdelst": "FL",
    "dropdelzpp": 338658709,
    "dropphyadd": "5155 STATE ROAD 64 W",
    "dropphycty": "ONA",
    "dropphyst": "FL",
    "dropphyzpp": 338658709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONA",
    "dropmalst": "FL",
    "dropmalzpp": 338659998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8637350303,
    "dropfax": 8637358197
  },
  {
    "dcode": "D",
    "dropkey": "PY22593",
    "droptype": "D",
    "dropname": "ONECO",
    "dropdeladd": "2333 53RD AVE E",
    "dropdelcty": "ONECO",
    "dropdelst": "FL",
    "dropdelzpp": 342649800,
    "dropphyadd": "2333 53RD AVE E",
    "dropphycty": "ONECO",
    "dropphyst": "FL",
    "dropphyzpp": 342649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONECO",
    "dropmalst": "FL",
    "dropmalzpp": 342649998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417524019,
    "dropfax": 9417562816
  },
  {
    "dcode": "D",
    "dropkey": "PY22595",
    "droptype": "D",
    "dropname": "OPA LOCKA",
    "dropdeladd": "550 FISHERMAN ST",
    "dropdelcty": "OPA LOCKA",
    "dropdelst": "FL",
    "dropdelzpp": 330549998,
    "dropphyadd": "550 FISHERMAN ST",
    "dropphycty": "OPA LOCKA",
    "dropphyst": "FL",
    "dropphyzpp": 330549998,
    "dropmaladd": "550 FISHERMAN ST",
    "dropmalcty": "OPA LOCKA",
    "dropmalst": "FL",
    "dropmalzpp": 330549998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056814964,
    "dropsitcph": 3056818562,
    "dropfax": 3056812750
  },
  {
    "dcode": "D",
    "dropkey": "PY22601",
    "droptype": "D",
    "dropname": "ORANGE CITY",
    "dropdeladd": "260 N INDUSTRIAL DR",
    "dropdelcty": "ORANGE CITY",
    "dropdelst": "FL",
    "dropdelzpp": 327639998,
    "dropphyadd": "260 N INDUSTRIAL DR",
    "dropphycty": "ORANGE CITY",
    "dropphyst": "FL",
    "dropphyzpp": 327639998,
    "dropmaladd": "260 N INDUSTRIAL DR",
    "dropmalcty": "ORANGE CITY",
    "dropmalst": "FL",
    "dropmalzpp": 327639998,
    "dropsitphn": 3867753567,
    "dropsitlph": 3867751875,
    "dropsitcph": 3867751875,
    "dropfax": 3867751173
  },
  {
    "dcode": "D",
    "dropkey": "PY22602",
    "droptype": "D",
    "dropname": "ORANGE LAKE",
    "dropdeladd": "19250 N US HIGHWAY 441",
    "dropdelcty": "ORANGE LAKE",
    "dropdelst": "FL",
    "dropdelzpp": 326819998,
    "dropphyadd": "19250 N US HIGHWAY 441",
    "dropphycty": "ORANGE LAKE",
    "dropphyst": "FL",
    "dropphyzpp": 326819998,
    "dropmaladd": "19250 N US HIGHWAY 441",
    "dropmalcty": "ORANGE LAKE",
    "dropmalst": "FL",
    "dropmalzpp": 326819998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525912800,
    "dropsitcph": 3525912800,
    "dropfax": 3525912800
  },
  {
    "dcode": "D",
    "dropkey": "PY22603",
    "droptype": "D",
    "dropname": "ORANGE PARK",
    "dropdeladd": "1335 KINGSLEY AVE",
    "dropdelcty": "ORANGE PARK",
    "dropdelst": "FL",
    "dropdelzpp": 320739998,
    "dropphyadd": "1335 KINGSLEY AVE",
    "dropphycty": "ORANGE PARK",
    "dropphyst": "FL",
    "dropphyzpp": 320739998,
    "dropmaladd": "1335 KINGSLEY AVE",
    "dropmalcty": "ORANGE PARK",
    "dropmalst": "FL",
    "dropmalzpp": 320739998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042641388,
    "dropsitcph": 9042641388,
    "dropfax": 9042644341
  },
  {
    "dcode": "D",
    "dropkey": "PY22606",
    "droptype": "D",
    "dropname": "ORANGE SPRINGS",
    "dropdeladd": "24282 US HIGHWAY 315",
    "dropdelcty": "ORANGE SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 321829700,
    "dropphyadd": "24282 US HIGHWAY 315",
    "dropphycty": "ORANGE SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 321829700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORANGE SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 321829998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525462741,
    "dropsitcph": 3525462741,
    "dropfax": 3525464206
  },
  {
    "dcode": "D",
    "dropkey": "PY22611",
    "droptype": "D",
    "dropname": "ORLANDO",
    "dropdeladd": "10401 POST OFFICE BLVD W FL 2",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328628542,
    "dropphyadd": "10401 POST OFFICE BLVD W FL 2",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328628542,
    "dropmaladd": "PO BOX 620045",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328629998,
    "dropsitphn": 4078265608,
    "dropsitlph": 4078265608,
    "dropsitcph": 4078263419,
    "dropfax": 4078505697
  },
  {
    "dcode": "D",
    "dropkey": "PY22615",
    "droptype": "D",
    "dropname": "ORMOND BEACH",
    "dropdeladd": "260 WILLIAMSON BLVD",
    "dropdelcty": "ORMOND BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321749998,
    "dropphyadd": "260 WILLIAMSON BLVD",
    "dropphycty": "ORMOND BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321749998,
    "dropmaladd": "260 WILLIAMSON BLVD",
    "dropmalcty": "ORMOND BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321749998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866779988,
    "dropsitcph": 3866760693,
    "dropfax": 3866769208
  },
  {
    "dcode": "D",
    "dropkey": "PY22621",
    "droptype": "D",
    "dropname": "OSPREY",
    "dropdeladd": "333 S TAMIAMI TRL",
    "dropdelcty": "OSPREY",
    "dropdelst": "FL",
    "dropdelzpp": 342299213,
    "dropphyadd": "333 S TAMIAMI TRL",
    "dropphycty": "OSPREY",
    "dropphyst": "FL",
    "dropphyzpp": 342299213,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSPREY",
    "dropmalst": "FL",
    "dropmalzpp": 342299998,
    "dropsitphn": 8138770729,
    "dropsitlph": 9413595162,
    "dropsitcph": 9419665381,
    "dropfax": 9419184371
  },
  {
    "dcode": "D",
    "dropkey": "PY22622",
    "droptype": "D",
    "dropname": "OSTEEN",
    "dropdeladd": "100 DICKSON AVE",
    "dropdelcty": "OSTEEN",
    "dropdelst": "FL",
    "dropdelzpp": 327649998,
    "dropphyadd": "100 DICKSON AVE",
    "dropphycty": "OSTEEN",
    "dropphyst": "FL",
    "dropphyzpp": 327649998,
    "dropmaladd": "100 DICKSON AVE",
    "dropmalcty": "OSTEEN",
    "dropmalst": "FL",
    "dropmalzpp": 327649998,
    "dropsitphn": 4073301493,
    "dropsitlph": 4073301493,
    "dropsitcph": 4073241795,
    "dropfax": 4073301493
  },
  {
    "dcode": "D",
    "dropkey": "PY22623",
    "droptype": "D",
    "dropname": "OTTER CREEK",
    "dropdeladd": "210 SE US HIGHWAY 19",
    "dropdelcty": "OTTER CREEK",
    "dropdelst": "FL",
    "dropdelzpp": 326839700,
    "dropphyadd": "210 SE US HIGHWAY 19",
    "dropphycty": "OTTER CREEK",
    "dropphyst": "FL",
    "dropphyzpp": 326839700,
    "dropmaladd": "210 SE US HIGHWAY 19",
    "dropmalcty": "OTTER CREEK",
    "dropmalst": "FL",
    "dropmalzpp": 326839998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524864739,
    "dropsitcph": 3524864739,
    "dropfax": 3524864739
  },
  {
    "dcode": "D",
    "dropkey": "PY22625",
    "droptype": "D",
    "dropname": "OVIEDO",
    "dropdeladd": "567 E FRANKLIN ST",
    "dropdelcty": "OVIEDO",
    "dropdelst": "FL",
    "dropdelzpp": 327659997,
    "dropphyadd": "567 E FRANKLIN ST",
    "dropphycty": "OVIEDO",
    "dropphyst": "FL",
    "dropphyzpp": 327659997,
    "dropmaladd": "567 E FRANKLIN ST",
    "dropmalcty": "OVIEDO",
    "dropmalst": "FL",
    "dropmalzpp": 327659997,
    "dropsitphn": 4079716213,
    "dropsitlph": 4079716213,
    "dropsitcph": 4079716213,
    "dropfax": 4073597495
  },
  {
    "dcode": "D",
    "dropkey": "PY22626",
    "droptype": "D",
    "dropname": "OXFORD",
    "dropdeladd": "3974 COUNTY ROAD 201",
    "dropdelcty": "OXFORD",
    "dropdelst": "FL",
    "dropdelzpp": 344842801,
    "dropphyadd": "3974 COUNTY ROAD 201",
    "dropphycty": "OXFORD",
    "dropphyst": "FL",
    "dropphyzpp": 344842801,
    "dropmaladd": "3974 COUNTY ROAD 201",
    "dropmalcty": "OXFORD",
    "dropmalst": "FL",
    "dropmalzpp": 344849998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527483124,
    "dropsitcph": 3527483124,
    "dropfax": 3527483223
  },
  {
    "dcode": "D",
    "dropkey": "PY22627",
    "droptype": "D",
    "dropname": "OZONA",
    "dropdeladd": "310 ORANGE ST",
    "dropdelcty": "OZONA",
    "dropdelst": "FL",
    "dropdelzpp": 346609801,
    "dropphyadd": "310 ORANGE ST",
    "dropphycty": "OZONA",
    "dropphyst": "FL",
    "dropphyzpp": 346609801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OZONA",
    "dropmalst": "FL",
    "dropmalzpp": 346609998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7277841869,
    "dropfax": 7277841869
  },
  {
    "dcode": "D",
    "dropkey": "PY22632",
    "droptype": "D",
    "dropname": "PAHOKEE",
    "dropdeladd": "331 BACOM POINT RD",
    "dropdelcty": "PAHOKEE",
    "dropdelst": "FL",
    "dropdelzpp": 334769998,
    "dropphyadd": "331 BACOM POINT RD",
    "dropphycty": "PAHOKEE",
    "dropphyst": "FL",
    "dropphyzpp": 334769998,
    "dropmaladd": "331 BACOM POINT RD",
    "dropmalcty": "PAHOKEE",
    "dropmalst": "FL",
    "dropmalzpp": 334769998,
    "dropsitphn": 5619246298,
    "dropsitlph": 5619246298,
    "dropsitcph": 5619242321,
    "dropfax": 5619245032
  },
  {
    "dcode": "D",
    "dropkey": "PY22633",
    "droptype": "D",
    "dropname": "PAISLEY",
    "dropdeladd": "24952 COUNTY ROAD 42",
    "dropdelcty": "PAISLEY",
    "dropdelst": "FL",
    "dropdelzpp": 327679998,
    "dropphyadd": "24952 COUNTY ROAD 42",
    "dropphycty": "PAISLEY",
    "dropphyst": "FL",
    "dropphyzpp": 327679998,
    "dropmaladd": "24952 COUNTY ROAD 42",
    "dropmalcty": "PAISLEY",
    "dropmalst": "FL",
    "dropmalzpp": 327679998,
    "dropsitphn": 3527040027,
    "dropsitlph": 3527040027,
    "dropsitcph": 3527040027,
    "dropfax": 3527040047
  },
  {
    "dcode": "D",
    "dropkey": "PY22634",
    "droptype": "D",
    "dropname": "PALATKA",
    "dropdeladd": "1105 SAINT JOHNS AVE",
    "dropdelcty": "PALATKA",
    "dropdelst": "FL",
    "dropdelzpp": 321779998,
    "dropphyadd": "1105 SAINT JOHNS AVE",
    "dropphycty": "PALATKA",
    "dropphyst": "FL",
    "dropphyzpp": 321779998,
    "dropmaladd": "1105 SAINT JOHNS AVE",
    "dropmalcty": "PALATKA",
    "dropmalst": "FL",
    "dropmalzpp": 321779998,
    "dropsitphn": 3863283071,
    "dropsitlph": 3863283071,
    "dropsitcph": 3863283071,
    "dropfax": 3863286272
  },
  {
    "dcode": "D",
    "dropkey": "PY22638",
    "droptype": "D",
    "dropname": "PALM BEACH",
    "dropdeladd": "340 ROYAL POINCIANA WAY STE 328",
    "dropdelcty": "PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334809998,
    "dropphyadd": "340 ROYAL POINCIANA WAY STE 328",
    "dropphycty": "PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334809998,
    "dropmaladd": "340 ROYAL POINCIANA WAY STE 328",
    "dropmalcty": "PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334809998,
    "dropsitphn": 5618059771,
    "dropsitlph": 5618059771,
    "dropsitcph": 5618328614,
    "dropfax": 5618329063
  },
  {
    "dcode": "D",
    "dropkey": "PY22643",
    "droptype": "D",
    "dropname": "PALM CITY",
    "dropdeladd": "1257 SW MARTIN HWY",
    "dropdelcty": "PALM CITY",
    "dropdelst": "FL",
    "dropdelzpp": 349909998,
    "dropphyadd": "1257 SW MARTIN HWY",
    "dropphycty": "PALM CITY",
    "dropphyst": "FL",
    "dropphyzpp": 349909998,
    "dropmaladd": "1257 SW MARTIN HWY",
    "dropmalcty": "PALM CITY",
    "dropmalst": "FL",
    "dropmalzpp": 349909998,
    "dropsitphn": 7722834574,
    "dropsitlph": 7724036287,
    "dropsitcph": 7722831974,
    "dropfax": 7722230132
  },
  {
    "dcode": "D",
    "dropkey": "PY22645",
    "droptype": "D",
    "dropname": "PALM HARBOR",
    "dropdeladd": "495 ALT 19",
    "dropdelcty": "PALM HARBOR",
    "dropdelst": "FL",
    "dropdelzpp": 346839998,
    "dropphyadd": "495 ALT 19",
    "dropphycty": "PALM HARBOR",
    "dropphyst": "FL",
    "dropphyzpp": 346839998,
    "dropmaladd": "495 ALT 19",
    "dropmalcty": "PALM HARBOR",
    "dropmalst": "FL",
    "dropmalzpp": 346839998,
    "dropsitphn": 7277731549,
    "dropsitlph": 8138770637,
    "dropsitcph": 7277731549,
    "dropfax": 7277872307
  },
  {
    "dcode": "D",
    "dropkey": "PY22655",
    "droptype": "D",
    "dropname": "PALMDALE",
    "dropdeladd": "1134 BROADWAY ST NW",
    "dropdelcty": "PALMDALE",
    "dropdelst": "FL",
    "dropdelzpp": 339449800,
    "dropphyadd": "1134 BROADWAY ST NW",
    "dropphycty": "PALMDALE",
    "dropphyst": "FL",
    "dropphyzpp": 339449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMDALE",
    "dropmalst": "FL",
    "dropmalzpp": 339449998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 8636751334,
    "dropfax": 8636752704
  },
  {
    "dcode": "D",
    "dropkey": "PY22656",
    "droptype": "D",
    "dropname": "PALMETTO",
    "dropdeladd": "520 7TH ST W",
    "dropdelcty": "PALMETTO",
    "dropdelst": "FL",
    "dropdelzpp": 342214703,
    "dropphyadd": "520 7TH ST W",
    "dropphycty": "PALMETTO",
    "dropphyst": "FL",
    "dropphyzpp": 342214703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALMETTO",
    "dropmalst": "FL",
    "dropmalzpp": 342209998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417210306,
    "dropfax": 9417231391
  },
  {
    "dcode": "D",
    "dropkey": "PY22657",
    "droptype": "D",
    "dropname": "PANACEA",
    "dropdeladd": "1444 COASTAL HWY",
    "dropdelcty": "PANACEA",
    "dropdelst": "FL",
    "dropdelzpp": 323469998,
    "dropphyadd": "1444 COASTAL HWY",
    "dropphycty": "PANACEA",
    "dropphyst": "FL",
    "dropphyzpp": 323469998,
    "dropmaladd": "1444 COASTAL HWY",
    "dropmalcty": "PANACEA",
    "dropmalst": "FL",
    "dropmalzpp": 323469998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509845253,
    "dropsitcph": 8509845253,
    "dropfax": 8509840012
  },
  {
    "dcode": "D",
    "dropkey": "PY22659",
    "droptype": "D",
    "dropname": "PANAMA CITY",
    "dropdeladd": "1336 SHERMAN AVE",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324014465,
    "dropphyadd": "1336 SHERMAN AVE",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324014465,
    "dropmaladd": "PO BOX 35000",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324129998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507473901,
    "dropsitcph": 8507474890,
    "dropfax": 8507474814
  },
  {
    "dcode": "D",
    "dropkey": "PY22664",
    "droptype": "D",
    "dropname": "PARRISH",
    "dropdeladd": "12144 US HIGHWAY 301 N",
    "dropdelcty": "PARRISH",
    "dropdelst": "FL",
    "dropdelzpp": 342199998,
    "dropphyadd": "12144 US HIGHWAY 301 N",
    "dropphycty": "PARRISH",
    "dropphyst": "FL",
    "dropphyzpp": 342199998,
    "dropmaladd": "12144 US HIGHWAY 301 N",
    "dropmalcty": "PARRISH",
    "dropmalst": "FL",
    "dropmalzpp": 342199998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417760247,
    "dropfax": 9417762539
  },
  {
    "dcode": "D",
    "dropkey": "PY22686",
    "droptype": "D",
    "dropname": "PENNEY FARMS",
    "dropdeladd": "4380 LEWIS AVE",
    "dropdelcty": "PENNEY FARMS",
    "dropdelst": "FL",
    "dropdelzpp": 320799600,
    "dropphyadd": "4380 LEWIS AVE",
    "dropphycty": "PENNEY FARMS",
    "dropphyst": "FL",
    "dropphyzpp": 320799600,
    "dropmaladd": "4380 LEWIS AVE",
    "dropmalcty": "PENNEY FARMS",
    "dropmalst": "FL",
    "dropmalzpp": 320799998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9045299611,
    "dropsitcph": 9045299611,
    "dropfax": 9045299611
  },
  {
    "dcode": "D",
    "dropkey": "PY22688",
    "droptype": "D",
    "dropname": "PENSACOLA",
    "dropdeladd": "1400 W JORDAN ST",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325019998,
    "dropphyadd": "1400 W JORDAN ST",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325019998,
    "dropmaladd": "PO BOX 17000",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504349124,
    "dropsitcph": 8504349182,
    "dropfax": 8504388575
  },
  {
    "dcode": "D",
    "dropkey": "PY22693",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "1600 S JEFFERSON ST",
    "dropdelcty": "PERRY",
    "dropdelst": "FL",
    "dropdelzpp": 323489998,
    "dropphyadd": "1600 S JEFFERSON ST",
    "dropphycty": "PERRY",
    "dropphyst": "FL",
    "dropphyzpp": 323489998,
    "dropmaladd": "1600 S JEFFERSON ST",
    "dropmalcty": "PERRY",
    "dropmalst": "FL",
    "dropmalzpp": 323489998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505845791,
    "dropsitcph": 8505845791,
    "dropfax": 8505844211
  },
  {
    "dcode": "D",
    "dropkey": "PY22694",
    "droptype": "D",
    "dropname": "PIERSON",
    "dropdeladd": "123 N VOLUSIA AVE",
    "dropdelcty": "PIERSON",
    "dropdelst": "FL",
    "dropdelzpp": 321809998,
    "dropphyadd": "123 N VOLUSIA AVE",
    "dropphycty": "PIERSON",
    "dropphyst": "FL",
    "dropphyzpp": 321809998,
    "dropmaladd": "123 N VOLUSIA AVE",
    "dropmalcty": "PIERSON",
    "dropmalst": "FL",
    "dropmalzpp": 321809998,
    "dropsitphn": 3867492996,
    "dropsitlph": 3867492996,
    "dropsitcph": 3867492996,
    "dropfax": 3867491116
  },
  {
    "dcode": "D",
    "dropkey": "PY22702",
    "droptype": "D",
    "dropname": "PINELAND",
    "dropdeladd": "7450 PINELAND RD",
    "dropdelcty": "PINELAND",
    "dropdelst": "FL",
    "dropdelzpp": 339459800,
    "dropphyadd": "7450 PINELAND RD",
    "dropphycty": "PINELAND",
    "dropphyst": "FL",
    "dropphyzpp": 339459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINELAND",
    "dropmalst": "FL",
    "dropmalzpp": 339459998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392832420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22703",
    "droptype": "D",
    "dropname": "PINELLAS PARK",
    "dropdeladd": "5260 78TH AVE N",
    "dropdelcty": "PINELLAS PARK",
    "dropdelst": "FL",
    "dropdelzpp": 337819998,
    "dropphyadd": "5260 78TH AVE N",
    "dropphycty": "PINELLAS PARK",
    "dropphyst": "FL",
    "dropphyzpp": 337819998,
    "dropmaladd": "5260 78TH AVE N",
    "dropmalcty": "PINELLAS PARK",
    "dropmalst": "FL",
    "dropmalzpp": 337819998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275487192,
    "dropfax": 7275411576
  },
  {
    "dcode": "D",
    "dropkey": "PY22705",
    "droptype": "D",
    "dropname": "PINETTA",
    "dropdeladd": "115 NE POPLAR AVE",
    "dropdelcty": "PINETTA",
    "dropdelst": "FL",
    "dropdelzpp": 323509998,
    "dropphyadd": "115 NE POPLAR AVE",
    "dropphycty": "PINETTA",
    "dropphyst": "FL",
    "dropphyzpp": 323509998,
    "dropmaladd": "115 NE POPLAR AVE",
    "dropmalcty": "PINETTA",
    "dropmalst": "FL",
    "dropmalzpp": 323509998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509294484,
    "dropsitcph": 8509294484,
    "dropfax": 8509294820
  },
  {
    "dcode": "D",
    "dropkey": "PY22707",
    "droptype": "D",
    "dropname": "PLACIDA",
    "dropdeladd": "8601 PLACIDA RD",
    "dropdelcty": "PLACIDA",
    "dropdelst": "FL",
    "dropdelzpp": 339469998,
    "dropphyadd": "8601 PLACIDA RD",
    "dropphycty": "PLACIDA",
    "dropphyst": "FL",
    "dropphyzpp": 339469998,
    "dropmaladd": "8601 PLACIDA RD",
    "dropmalcty": "PLACIDA",
    "dropmalst": "FL",
    "dropmalzpp": 339469998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9416977614,
    "dropfax": 9416971539
  },
  {
    "dcode": "D",
    "dropkey": "PY22708",
    "droptype": "D",
    "dropname": "PLANT CITY",
    "dropdeladd": "2501 WALDEN WOODS DR",
    "dropdelcty": "PLANT CITY",
    "dropdelst": "FL",
    "dropdelzpp": 335669998,
    "dropphyadd": "2501 WALDEN WOODS DR",
    "dropphycty": "PLANT CITY",
    "dropphyst": "FL",
    "dropphyzpp": 335669998,
    "dropmaladd": "2501 WALDEN WOODS DR",
    "dropmalcty": "PLANT CITY",
    "dropmalst": "FL",
    "dropmalzpp": 335669998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8137196733,
    "dropfax": 8137191433
  },
  {
    "dcode": "D",
    "dropkey": "PY22715",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "900 PLYMOUTH SORRENTO RD",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "FL",
    "dropdelzpp": 327685815,
    "dropphyadd": "900 PLYMOUTH SORRENTO RD",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "FL",
    "dropphyzpp": 327685815,
    "dropmaladd": "PO BOX 689998",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "FL",
    "dropmalzpp": 327689998,
    "dropsitphn": 4078895598,
    "dropsitlph": 4078895598,
    "dropsitcph": 4078893610,
    "dropfax": 4078893610
  },
  {
    "dcode": "D",
    "dropkey": "PY22722",
    "droptype": "D",
    "dropname": "POLK CITY",
    "dropdeladd": "112 CARTER BLVD",
    "dropdelcty": "POLK CITY",
    "dropdelst": "FL",
    "dropdelzpp": 338689998,
    "dropphyadd": "112 CARTER BLVD",
    "dropphycty": "POLK CITY",
    "dropphyst": "FL",
    "dropphyzpp": 338689998,
    "dropmaladd": "112 CARTER BLVD",
    "dropmalcty": "POLK CITY",
    "dropmalst": "FL",
    "dropmalzpp": 338689998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8639844547,
    "dropfax": 8639844547
  },
  {
    "dcode": "D",
    "dropkey": "PY22724",
    "droptype": "D",
    "dropname": "POMONA PARK",
    "dropdeladd": "1778 S HIGHWAY 17",
    "dropdelcty": "POMONA PARK",
    "dropdelst": "FL",
    "dropdelzpp": 321819998,
    "dropphyadd": "1778 S HIGHWAY 17",
    "dropphycty": "POMONA PARK",
    "dropphyst": "FL",
    "dropphyzpp": 321819998,
    "dropmaladd": "1778 S HIGHWAY 17",
    "dropmalcty": "POMONA PARK",
    "dropmalst": "FL",
    "dropmalzpp": 321819998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866494272,
    "dropsitcph": 3866494272,
    "dropfax": 3866495193
  },
  {
    "dcode": "D",
    "dropkey": "PY22729",
    "droptype": "D",
    "dropname": "POMPANO BEACH",
    "dropdeladd": "2351 W ATLANTIC BLVD",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330699998,
    "dropphyadd": "2351 W ATLANTIC BLVD",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330699998,
    "dropmaladd": "2351 W ATLANTIC BLVD",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330699998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549355150,
    "dropsitcph": 9549355122,
    "dropfax": 9549355128
  },
  {
    "dcode": "D",
    "dropkey": "PY22731",
    "droptype": "D",
    "dropname": "PONCE DE LEON",
    "dropdeladd": "2834 N HIGHWAY 81",
    "dropdelcty": "PONCE DE LEON",
    "dropdelst": "FL",
    "dropdelzpp": 324559998,
    "dropphyadd": "2834 N HIGHWAY 81",
    "dropphycty": "PONCE DE LEON",
    "dropphyst": "FL",
    "dropphyzpp": 324559998,
    "dropmaladd": "2834 N HIGHWAY 81",
    "dropmalcty": "PONCE DE LEON",
    "dropmalst": "FL",
    "dropmalzpp": 324559998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508364311,
    "dropsitcph": 8508364311,
    "dropfax": 8508368855
  },
  {
    "dcode": "D",
    "dropkey": "PY22734",
    "droptype": "D",
    "dropname": "PONTE VEDRA BEACH",
    "dropdeladd": "130 CORRIDOR RD",
    "dropdelcty": "PONTE VEDRA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 320829998,
    "dropphyadd": "130 CORRIDOR RD",
    "dropphycty": "PONTE VEDRA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 320829998,
    "dropmaladd": "130 CORRIDOR RD",
    "dropmalcty": "PONTE VEDRA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 320829998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9046863955,
    "dropsitcph": 9045438607,
    "dropfax": 9042851128
  },
  {
    "dcode": "D",
    "dropkey": "PY22745",
    "droptype": "D",
    "dropname": "PORT RICHEY",
    "dropdeladd": "8101 WASHINGTON ST",
    "dropdelcty": "PORT RICHEY",
    "dropdelst": "FL",
    "dropdelzpp": 346689998,
    "dropphyadd": "8101 WASHINGTON ST",
    "dropphycty": "PORT RICHEY",
    "dropphyst": "FL",
    "dropphyzpp": 346689998,
    "dropmaladd": "8101 WASHINGTON ST",
    "dropmalcty": "PORT RICHEY",
    "dropmalst": "FL",
    "dropmalzpp": 346689998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7278151308,
    "dropfax": 7278483811
  },
  {
    "dcode": "D",
    "dropkey": "PY22746",
    "droptype": "D",
    "dropname": "PORT SAINT JOE",
    "dropdeladd": "502 GARRISON AVE",
    "dropdelcty": "PORT SAINT JOE",
    "dropdelst": "FL",
    "dropdelzpp": 324569998,
    "dropphyadd": "502 GARRISON AVE",
    "dropphycty": "PORT SAINT JOE",
    "dropphyst": "FL",
    "dropphyzpp": 324569998,
    "dropmaladd": "502 GARRISON AVE",
    "dropmalcty": "PORT SAINT JOE",
    "dropmalst": "FL",
    "dropmalzpp": 324569998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502298657,
    "dropsitcph": 8502298657,
    "dropfax": 8502291062
  },
  {
    "dcode": "D",
    "dropkey": "PY22749",
    "droptype": "D",
    "dropname": "PORT SALERNO",
    "dropdeladd": "4755 SE DIXIE HWY",
    "dropdelcty": "PORT SALERNO",
    "dropdelst": "FL",
    "dropdelzpp": 349926817,
    "dropphyadd": "4755 SE DIXIE HWY",
    "dropphycty": "PORT SALERNO",
    "dropphyst": "FL",
    "dropphyzpp": 349926817,
    "dropmaladd": "4755 SE DIXIE HWY",
    "dropmalcty": "PORT SALERNO",
    "dropmalst": "FL",
    "dropmalzpp": 349926817,
    "dropsitphn": 7724036016,
    "dropsitlph": 7724036015,
    "dropsitcph": 7724638307,
    "dropfax": 7722883983
  },
  {
    "dcode": "D",
    "dropkey": "PY22768",
    "droptype": "D",
    "dropname": "PUNTA GORDA",
    "dropdeladd": "130 E MARION AVE",
    "dropdelcty": "PUNTA GORDA",
    "dropdelst": "FL",
    "dropdelzpp": 339509998,
    "dropphyadd": "130 E MARION AVE",
    "dropphycty": "PUNTA GORDA",
    "dropphyst": "FL",
    "dropphyzpp": 339509998,
    "dropmaladd": "130 E MARION AVE",
    "dropmalcty": "PUNTA GORDA",
    "dropmalst": "FL",
    "dropmalzpp": 339509998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9416397016,
    "dropfax": 9416397346
  },
  {
    "dcode": "D",
    "dropkey": "PY22770",
    "droptype": "D",
    "dropname": "PUTNAM HALL",
    "dropdeladd": "971 STATE ROAD 26",
    "dropdelcty": "PUTNAM HALL",
    "dropdelst": "FL",
    "dropdelzpp": 321859900,
    "dropphyadd": "971 STATE ROAD 26",
    "dropphycty": "PUTNAM HALL",
    "dropphyst": "FL",
    "dropphyzpp": 321859900,
    "dropmaladd": "971 STATE ROAD 26",
    "dropmalcty": "PUTNAM HALL",
    "dropmalst": "FL",
    "dropmalzpp": 321859998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524734224,
    "dropsitcph": 3524734224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22773",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "772 S PAT THOMAS PKWY",
    "dropdelcty": "QUINCY",
    "dropdelst": "FL",
    "dropdelzpp": 323519998,
    "dropphyadd": "772 S PAT THOMAS PKWY",
    "dropphycty": "QUINCY",
    "dropphyst": "FL",
    "dropphyzpp": 323519998,
    "dropmaladd": "772 S PAT THOMAS PKWY",
    "dropmalcty": "QUINCY",
    "dropmalst": "FL",
    "dropmalzpp": 323519998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506278490,
    "dropsitcph": 8506278490,
    "dropfax": 8506277926
  },
  {
    "dcode": "D",
    "dropkey": "PY22775",
    "droptype": "D",
    "dropname": "RAIFORD",
    "dropdeladd": "13132 NE STATE ROAD 121",
    "dropdelcty": "RAIFORD",
    "dropdelst": "FL",
    "dropdelzpp": 320839998,
    "dropphyadd": "13132 NE STATE ROAD 121",
    "dropphycty": "RAIFORD",
    "dropphyst": "FL",
    "dropphyzpp": 320839998,
    "dropmaladd": "13132 NE STATE ROAD 121",
    "dropmalcty": "RAIFORD",
    "dropmalst": "FL",
    "dropmalzpp": 320839998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864311356,
    "dropsitcph": 3864311356,
    "dropfax": 3864311947
  },
  {
    "dcode": "D",
    "dropkey": "PY22783",
    "droptype": "D",
    "dropname": "REDDICK",
    "dropdeladd": "15373 NW GAINESVILLE RD",
    "dropdelcty": "REDDICK",
    "dropdelst": "FL",
    "dropdelzpp": 326869998,
    "dropphyadd": "15373 NW GAINESVILLE RD",
    "dropphycty": "REDDICK",
    "dropphyst": "FL",
    "dropphyzpp": 326869998,
    "dropmaladd": "15373 NW GAINESVILLE RD",
    "dropmalcty": "REDDICK",
    "dropmalst": "FL",
    "dropmalzpp": 326869998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525912832,
    "dropsitcph": 3525912832,
    "dropfax": 3525912235
  },
  {
    "dcode": "D",
    "dropkey": "PY22801",
    "droptype": "D",
    "dropname": "RIVERVIEW",
    "dropdeladd": "10810 BOYETTE RD",
    "dropdelcty": "RIVERVIEW",
    "dropdelst": "FL",
    "dropdelzpp": 335699998,
    "dropphyadd": "10810 BOYETTE RD",
    "dropphycty": "RIVERVIEW",
    "dropphyst": "FL",
    "dropphyzpp": 335699998,
    "dropmaladd": "10810 BOYETTE RD",
    "dropmalcty": "RIVERVIEW",
    "dropmalst": "FL",
    "dropmalzpp": 335699998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136724562,
    "dropfax": 8136776125
  },
  {
    "dcode": "D",
    "dropkey": "PY22804",
    "droptype": "D",
    "dropname": "ROCKLEDGE",
    "dropdeladd": "3000 MURRELL RD",
    "dropdelcty": "ROCKLEDGE",
    "dropdelst": "FL",
    "dropdelzpp": 329559998,
    "dropphyadd": "3000 MURRELL RD",
    "dropphycty": "ROCKLEDGE",
    "dropphyst": "FL",
    "dropphyzpp": 329559998,
    "dropmaladd": "3000 MURRELL RD",
    "dropmalcty": "ROCKLEDGE",
    "dropmalst": "FL",
    "dropmalzpp": 329559998,
    "dropsitphn": 3216327089,
    "dropsitlph": 3216327089,
    "dropsitcph": 3216364177,
    "dropfax": 3216319157
  },
  {
    "dcode": "D",
    "dropkey": "PY22806",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "13305 ROSELAND RD",
    "dropdelcty": "ROSELAND",
    "dropdelst": "FL",
    "dropdelzpp": 329573268,
    "dropphyadd": "13305 ROSELAND RD",
    "dropphycty": "ROSELAND",
    "dropphyst": "FL",
    "dropphyzpp": 329573268,
    "dropmaladd": "PO BOX 579998",
    "dropmalcty": "ROSELAND",
    "dropmalst": "FL",
    "dropmalzpp": 329579998,
    "dropsitphn": 7725895095,
    "dropsitlph": 7725895095,
    "dropsitcph": 7725895095,
    "dropfax": 7725892003
  },
  {
    "dcode": "D",
    "dropkey": "PY22815",
    "droptype": "D",
    "dropname": "RUSKIN",
    "dropdeladd": "455 N US HIGHWAY 41",
    "dropdelcty": "RUSKIN",
    "dropdelst": "FL",
    "dropdelzpp": 335709998,
    "dropphyadd": "455 N US HIGHWAY 41",
    "dropphycty": "RUSKIN",
    "dropphyst": "FL",
    "dropphyzpp": 335709998,
    "dropmaladd": "455 N US HIGHWAY 41",
    "dropmalcty": "RUSKIN",
    "dropmalst": "FL",
    "dropmalzpp": 335709998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136341403,
    "dropfax": 8136428081
  },
  {
    "dcode": "D",
    "dropkey": "PY22823",
    "droptype": "D",
    "dropname": "SAFETY HARBOR",
    "dropdeladd": "1703 N MCMULLEN BOOTH RD",
    "dropdelcty": "SAFETY HARBOR",
    "dropdelst": "FL",
    "dropdelzpp": 346959995,
    "dropphyadd": "1703 N MCMULLEN BOOTH RD",
    "dropphycty": "SAFETY HARBOR",
    "dropphyst": "FL",
    "dropphyzpp": 346959995,
    "dropmaladd": "1703 N MCMULLEN BOOTH RD",
    "dropmalcty": "SAFETY HARBOR",
    "dropmalst": "FL",
    "dropmalzpp": 346959995,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7276690253,
    "dropfax": 7276695728
  },
  {
    "dcode": "D",
    "dropkey": "PY22827",
    "droptype": "D",
    "dropname": "SAINT AUGUSTINE",
    "dropdeladd": "99 KING ST",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "FL",
    "dropdelzpp": 320849998,
    "dropphyadd": "99 KING ST",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "FL",
    "dropphyzpp": 320849998,
    "dropmaladd": "99 KING ST",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "FL",
    "dropmalzpp": 320849998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048254803,
    "dropsitcph": 9048250628,
    "dropfax": 9048244462
  },
  {
    "dcode": "D",
    "dropkey": "PY22831",
    "droptype": "D",
    "dropname": "SAINT CLOUD",
    "dropdeladd": "4701 OLD CANOE CREEK RD",
    "dropdelcty": "SAINT CLOUD",
    "dropdelst": "FL",
    "dropdelzpp": 347699998,
    "dropphyadd": "4701 OLD CANOE CREEK RD",
    "dropphycty": "SAINT CLOUD",
    "dropphyst": "FL",
    "dropphyzpp": 347699998,
    "dropmaladd": "4701 OLD CANOE CREEK RD",
    "dropmalcty": "SAINT CLOUD",
    "dropmalst": "FL",
    "dropmalzpp": 347699998,
    "dropsitphn": 4078923821,
    "dropsitlph": 4078923821,
    "dropsitcph": 4078926883,
    "dropfax": 4079575323
  },
  {
    "dcode": "D",
    "dropkey": "PY22833",
    "droptype": "D",
    "dropname": "SAINT JAMES CITY",
    "dropdeladd": "4480 STRINGFELLOW RD",
    "dropdelcty": "SAINT JAMES CITY",
    "dropdelst": "FL",
    "dropdelzpp": 339569998,
    "dropphyadd": "4480 STRINGFELLOW RD",
    "dropphycty": "SAINT JAMES CITY",
    "dropphyst": "FL",
    "dropphyzpp": 339569998,
    "dropmaladd": "4480 STRINGFELLOW RD",
    "dropmalcty": "SAINT JAMES CITY",
    "dropmalst": "FL",
    "dropmalzpp": 339569998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392833894,
    "dropfax": 2392839636
  },
  {
    "dcode": "D",
    "dropkey": "PY22834",
    "droptype": "D",
    "dropname": "SAINT LEO",
    "dropdeladd": "33601 STATE ROAD 52",
    "dropdelcty": "SAINT LEO",
    "dropdelst": "FL",
    "dropdelzpp": 335749700,
    "dropphyadd": "33601 STATE ROAD 52",
    "dropphycty": "SAINT LEO",
    "dropphyst": "FL",
    "dropphyzpp": 335749700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT LEO",
    "dropmalst": "FL",
    "dropmalzpp": 335749998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3525883741,
    "dropfax": 3525882954
  },
  {
    "dcode": "D",
    "dropkey": "PY22835",
    "droptype": "D",
    "dropname": "SAINT MARKS",
    "dropdeladd": "779 PORT LEON DR",
    "dropdelcty": "SAINT MARKS",
    "dropdelst": "FL",
    "dropdelzpp": 323551500,
    "dropphyadd": "779 PORT LEON DR",
    "dropphycty": "SAINT MARKS",
    "dropphyst": "FL",
    "dropphyzpp": 323551500,
    "dropmaladd": "779 PORT LEON DR",
    "dropmalcty": "SAINT MARKS",
    "dropmalst": "FL",
    "dropmalzpp": 323559998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509256178,
    "dropsitcph": 8509256178,
    "dropfax": 8509257960
  },
  {
    "dcode": "D",
    "dropkey": "PY22837",
    "droptype": "D",
    "dropname": "SAINT PETERSBURG",
    "dropdeladd": "3135 1ST AVE N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337309998,
    "dropphyadd": "3135 1ST AVE N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337309998,
    "dropmaladd": "3135 1ST AVE N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337309998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273226632,
    "dropsitcph": 7273226632,
    "dropfax": 7273286602
  },
  {
    "dcode": "D",
    "dropkey": "PY22842",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "16580 S US 19",
    "dropdelcty": "SALEM",
    "dropdelst": "FL",
    "dropdelzpp": 323562104,
    "dropphyadd": "16580 S US 19",
    "dropphycty": "SALEM",
    "dropphyst": "FL",
    "dropphyzpp": 323562104,
    "dropmaladd": "16580 S US 19",
    "dropmalcty": "SALEM",
    "dropmalst": "FL",
    "dropmalzpp": 323569998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505849224,
    "dropsitcph": 8505849256,
    "dropfax": 8505849256
  },
  {
    "dcode": "D",
    "dropkey": "PY22846",
    "droptype": "D",
    "dropname": "SAN ANTONIO",
    "dropdeladd": "12231 MAIN ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "FL",
    "dropdelzpp": 335767204,
    "dropphyadd": "12231 MAIN ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "FL",
    "dropphyzpp": 335767204,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "FL",
    "dropmalzpp": 335769998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3525882901,
    "dropfax": 3525883824
  },
  {
    "dcode": "D",
    "dropkey": "PY22847",
    "droptype": "D",
    "dropname": "SAN MATEO",
    "dropdeladd": "534 S US HIGHWAY 17",
    "dropdelcty": "SAN MATEO",
    "dropdelst": "FL",
    "dropdelzpp": 321879998,
    "dropphyadd": "534 S US HIGHWAY 17",
    "dropphycty": "SAN MATEO",
    "dropphyst": "FL",
    "dropphyzpp": 321879998,
    "dropmaladd": "534 S US HIGHWAY 17",
    "dropmalcty": "SAN MATEO",
    "dropmalst": "FL",
    "dropmalzpp": 321879998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863252303,
    "dropsitcph": 3863252303,
    "dropfax": 3863258123
  },
  {
    "dcode": "D",
    "dropkey": "PY22849",
    "droptype": "D",
    "dropname": "SANDERSON",
    "dropdeladd": "14470 US HIGHWAY 90",
    "dropdelcty": "SANDERSON",
    "dropdelst": "FL",
    "dropdelzpp": 320879998,
    "dropphyadd": "14470 US HIGHWAY 90",
    "dropphycty": "SANDERSON",
    "dropphyst": "FL",
    "dropphyzpp": 320879998,
    "dropmaladd": "14470 US HIGHWAY 90",
    "dropmalcty": "SANDERSON",
    "dropmalst": "FL",
    "dropmalzpp": 320879998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042752179,
    "dropsitcph": 9042752179,
    "dropfax": 9042752031
  },
  {
    "dcode": "D",
    "dropkey": "PY22852",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "401 E 1ST ST",
    "dropdelcty": "SANFORD",
    "dropdelst": "FL",
    "dropdelzpp": 327719998,
    "dropphyadd": "401 E 1ST ST",
    "dropphycty": "SANFORD",
    "dropphyst": "FL",
    "dropphyzpp": 327719998,
    "dropmaladd": "401 E 1ST ST",
    "dropmalcty": "SANFORD",
    "dropmalst": "FL",
    "dropmalzpp": 327719998,
    "dropsitphn": 4073249559,
    "dropsitlph": 4073249559,
    "dropsitcph": 4076889487,
    "dropfax": 4073228455
  },
  {
    "dcode": "D",
    "dropkey": "PY22853",
    "droptype": "D",
    "dropname": "SANIBEL",
    "dropdeladd": "650 TARPON BAY RD",
    "dropdelcty": "SANIBEL",
    "dropdelst": "FL",
    "dropdelzpp": 339579998,
    "dropphyadd": "650 TARPON BAY RD",
    "dropphycty": "SANIBEL",
    "dropphyst": "FL",
    "dropphyzpp": 339579998,
    "dropmaladd": "650 TARPON BAY RD",
    "dropmalcty": "SANIBEL",
    "dropmalst": "FL",
    "dropmalzpp": 339579998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2394721573,
    "dropfax": 2394726738
  },
  {
    "dcode": "D",
    "dropkey": "PY22857",
    "droptype": "D",
    "dropname": "SANTA ROSA BEACH",
    "dropdeladd": "3906 US HIGHWAY 98 W",
    "dropdelcty": "SANTA ROSA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 324599998,
    "dropphyadd": "3906 US HIGHWAY 98 W",
    "dropphycty": "SANTA ROSA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 324599998,
    "dropmaladd": "3906 US HIGHWAY 98 W",
    "dropmalcty": "SANTA ROSA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 324599998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502672280,
    "dropsitcph": 8502672280,
    "dropfax": 8502673520
  },
  {
    "dcode": "D",
    "dropkey": "PY22859",
    "droptype": "D",
    "dropname": "SARASOTA",
    "dropdeladd": "1661 RINGLING BLVD",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342309998,
    "dropphyadd": "1661 RINGLING BLVD",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342309998,
    "dropmaladd": "1661 RINGLING BLVD",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342309998,
    "dropsitphn": 8138770729,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413314221,
    "dropfax": 9413314255
  },
  {
    "dcode": "D",
    "dropkey": "PY22862",
    "droptype": "D",
    "dropname": "SATSUMA",
    "dropdeladd": "115 COUNTY ROAD 309",
    "dropdelcty": "SATSUMA",
    "dropdelst": "FL",
    "dropdelzpp": 321899998,
    "dropphyadd": "115 COUNTY ROAD 309",
    "dropphycty": "SATSUMA",
    "dropphyst": "FL",
    "dropphyzpp": 321899998,
    "dropmaladd": "115 COUNTY ROAD 309",
    "dropmalcty": "SATSUMA",
    "dropmalst": "FL",
    "dropmalzpp": 321899998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866494366,
    "dropsitcph": 3866494366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22865",
    "droptype": "D",
    "dropname": "SCOTTSMOOR",
    "dropdeladd": "3750 MAGOON AVE",
    "dropdelcty": "SCOTTSMOOR",
    "dropdelst": "FL",
    "dropdelzpp": 327756998,
    "dropphyadd": "3750 MAGOON AVE",
    "dropphycty": "SCOTTSMOOR",
    "dropphyst": "FL",
    "dropphyzpp": 327756998,
    "dropmaladd": "PO BOX 759998",
    "dropmalcty": "SCOTTSMOOR",
    "dropmalst": "FL",
    "dropmalzpp": 327759998,
    "dropsitphn": 3212678700,
    "dropsitlph": 3212678700,
    "dropsitcph": 3212678700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22870",
    "droptype": "D",
    "dropname": "SEBASTIAN",
    "dropdeladd": "1290 MAIN ST",
    "dropdelcty": "SEBASTIAN",
    "dropdelst": "FL",
    "dropdelzpp": 329589998,
    "dropphyadd": "1290 MAIN ST",
    "dropphycty": "SEBASTIAN",
    "dropphyst": "FL",
    "dropphyzpp": 329589998,
    "dropmaladd": "1290 MAIN ST",
    "dropmalcty": "SEBASTIAN",
    "dropmalst": "FL",
    "dropmalzpp": 329589998,
    "dropsitphn": 7725894407,
    "dropsitlph": 7725894407,
    "dropsitcph": 7725894397,
    "dropfax": 7725895659
  },
  {
    "dcode": "D",
    "dropkey": "PY22871",
    "droptype": "D",
    "dropname": "SEBRING",
    "dropdeladd": "518 N RIDGEWOOD DR",
    "dropdelcty": "SEBRING",
    "dropdelst": "FL",
    "dropdelzpp": 338709998,
    "dropphyadd": "518 N RIDGEWOOD DR",
    "dropphycty": "SEBRING",
    "dropphyst": "FL",
    "dropphyzpp": 338709998,
    "dropmaladd": "518 N RIDGEWOOD DR",
    "dropmalcty": "SEBRING",
    "dropmalst": "FL",
    "dropmalzpp": 338709998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8633820578,
    "dropfax": 8633821458
  },
  {
    "dcode": "D",
    "dropkey": "PY22873",
    "droptype": "D",
    "dropname": "SEFFNER",
    "dropdeladd": "1431 S KINGSWAY RD",
    "dropdelcty": "SEFFNER",
    "dropdelst": "FL",
    "dropdelzpp": 335849998,
    "dropphyadd": "1431 S KINGSWAY RD",
    "dropphycty": "SEFFNER",
    "dropphyst": "FL",
    "dropphyzpp": 335849998,
    "dropmaladd": "1431 S KINGSWAY RD",
    "dropmalcty": "SEFFNER",
    "dropmalst": "FL",
    "dropmalzpp": 335849998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136817413,
    "dropfax": 8136817413
  },
  {
    "dcode": "D",
    "dropkey": "PY22882",
    "droptype": "D",
    "dropname": "SEVILLE",
    "dropdeladd": "120 COUNTY ROAD 305",
    "dropdelcty": "SEVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 321909998,
    "dropphyadd": "120 COUNTY ROAD 305",
    "dropphycty": "SEVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 321909998,
    "dropmaladd": "120 COUNTY ROAD 305",
    "dropmalcty": "SEVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 321909998,
    "dropsitphn": 3867492884,
    "dropsitlph": 3867492884,
    "dropsitcph": 3867492884,
    "dropfax": 3863293615
  },
  {
    "dcode": "D",
    "dropkey": "PY22887",
    "droptype": "D",
    "dropname": "SHALIMAR",
    "dropdeladd": "1000 N EGLIN PKWY",
    "dropdelcty": "SHALIMAR",
    "dropdelst": "FL",
    "dropdelzpp": 325799998,
    "dropphyadd": "1000 N EGLIN PKWY",
    "dropphycty": "SHALIMAR",
    "dropphyst": "FL",
    "dropphyzpp": 325799998,
    "dropmaladd": "1000 N EGLIN PKWY",
    "dropmalcty": "SHALIMAR",
    "dropmalst": "FL",
    "dropmalzpp": 325799998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506510523,
    "dropsitcph": 8506510523,
    "dropfax": 8506515129
  },
  {
    "dcode": "D",
    "dropkey": "PY22888",
    "droptype": "D",
    "dropname": "SHARPES",
    "dropdeladd": "4425 N COCOA BLVD",
    "dropdelcty": "SHARPES",
    "dropdelst": "FL",
    "dropdelzpp": 329596025,
    "dropphyadd": "4425 N COCOA BLVD",
    "dropphycty": "SHARPES",
    "dropphyst": "FL",
    "dropphyzpp": 329596025,
    "dropmaladd": "PO BOX 599998",
    "dropmalcty": "SHARPES",
    "dropmalst": "FL",
    "dropmalzpp": 329599998,
    "dropsitphn": 3216328561,
    "dropsitlph": 3216328561,
    "dropsitcph": 3216328561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY22894",
    "droptype": "D",
    "dropname": "SILVER SPRINGS",
    "dropdeladd": "3050 NE 55TH AVE",
    "dropdelcty": "SILVER SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 344881719,
    "dropphyadd": "3050 NE 55TH AVE",
    "dropphycty": "SILVER SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 344881719,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 344899998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522362756,
    "dropsitcph": 3522362756,
    "dropfax": 3522365833
  },
  {
    "dcode": "D",
    "dropkey": "PY22899",
    "droptype": "D",
    "dropname": "SNEADS",
    "dropdeladd": "2042 GREEN AVE",
    "dropdelcty": "SNEADS",
    "dropdelst": "FL",
    "dropdelzpp": 324609998,
    "dropphyadd": "2042 GREEN AVE",
    "dropphycty": "SNEADS",
    "dropphyst": "FL",
    "dropphyzpp": 324609998,
    "dropmaladd": "2042 GREEN AVE",
    "dropmalcty": "SNEADS",
    "dropmalst": "FL",
    "dropmalzpp": 324609998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505936116,
    "dropsitcph": 8505936116,
    "dropfax": 8505930044
  },
  {
    "dcode": "D",
    "dropkey": "PY22906",
    "droptype": "D",
    "dropname": "SOPCHOPPY",
    "dropdeladd": "2284 SOPCHOPPY HWY",
    "dropdelcty": "SOPCHOPPY",
    "dropdelst": "FL",
    "dropdelzpp": 323589998,
    "dropphyadd": "2284 SOPCHOPPY HWY",
    "dropphycty": "SOPCHOPPY",
    "dropphyst": "FL",
    "dropphyzpp": 323589998,
    "dropmaladd": "2284 SOPCHOPPY HWY",
    "dropmalcty": "SOPCHOPPY",
    "dropmalst": "FL",
    "dropmalzpp": 323589998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509624741,
    "dropsitcph": 8509624741,
    "dropfax": 8509623496
  },
  {
    "dcode": "D",
    "dropkey": "PY22907",
    "droptype": "D",
    "dropname": "SORRENTO",
    "dropdeladd": "24106 STATE ROAD 46",
    "dropdelcty": "SORRENTO",
    "dropdelst": "FL",
    "dropdelzpp": 327769998,
    "dropphyadd": "24106 STATE ROAD 46",
    "dropphycty": "SORRENTO",
    "dropphyst": "FL",
    "dropphyzpp": 327769998,
    "dropmaladd": "24106 STATE ROAD 46",
    "dropmalcty": "SORRENTO",
    "dropmalst": "FL",
    "dropmalzpp": 327769998,
    "dropsitphn": 3523837113,
    "dropsitlph": 3523837113,
    "dropsitcph": 3523833388,
    "dropfax": 3523832143
  },
  {
    "dcode": "D",
    "dropkey": "PY22908",
    "droptype": "D",
    "dropname": "SOUTH BAY",
    "dropdeladd": "190 US HIGHWAY 27 S",
    "dropdelcty": "SOUTH BAY",
    "dropdelst": "FL",
    "dropdelzpp": 334939998,
    "dropphyadd": "190 US HIGHWAY 27 S",
    "dropphycty": "SOUTH BAY",
    "dropphyst": "FL",
    "dropphyzpp": 334939998,
    "dropmaladd": "190 US HIGHWAY 27 S",
    "dropmalcty": "SOUTH BAY",
    "dropmalst": "FL",
    "dropmalzpp": 334939998,
    "dropsitphn": 5619967810,
    "dropsitlph": 5619967810,
    "dropsitcph": 5619965390,
    "dropfax": 5619967810
  },
  {
    "dcode": "D",
    "dropkey": "PY22916",
    "droptype": "D",
    "dropname": "WEST PINES",
    "dropdeladd": "16000 PINES BLVD",
    "dropdelcty": "PEMBROKE PINES",
    "dropdelst": "FL",
    "dropdelzpp": 330829699,
    "dropphyadd": "16000 PINES BLVD",
    "dropphycty": "PEMBROKE PINES",
    "dropphyst": "FL",
    "dropphyzpp": 330829699,
    "dropmaladd": "16000 PINES BLVD",
    "dropmalcty": "PEMBROKE PINES",
    "dropmalst": "FL",
    "dropmalzpp": 330829699,
    "dropsitphn": 3055132368,
    "dropsitlph": 3054436527,
    "dropsitcph": 9544331644,
    "dropfax": 9544364316
  },
  {
    "dcode": "D",
    "dropkey": "PY22950",
    "droptype": "D",
    "dropname": "SPARR",
    "dropdeladd": "12855 NE JACKSONVILLE RD",
    "dropdelcty": "SPARR",
    "dropdelst": "FL",
    "dropdelzpp": 321922101,
    "dropphyadd": "12855 NE JACKSONVILLE RD",
    "dropphycty": "SPARR",
    "dropphyst": "FL",
    "dropphyzpp": 321922101,
    "dropmaladd": "12855 NE JACKSONVILLE RD",
    "dropmalcty": "SPARR",
    "dropmalst": "FL",
    "dropmalzpp": 321929998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3526295404,
    "dropsitcph": 3526295404,
    "dropfax": 3526909550
  },
  {
    "dcode": "D",
    "dropkey": "PY23016",
    "droptype": "D",
    "dropname": "STARKE",
    "dropdeladd": "122 N WALNUT ST",
    "dropdelcty": "STARKE",
    "dropdelst": "FL",
    "dropdelzpp": 320919998,
    "dropphyadd": "122 N WALNUT ST",
    "dropphycty": "STARKE",
    "dropphyst": "FL",
    "dropphyzpp": 320919998,
    "dropmaladd": "122 N WALNUT ST",
    "dropmalcty": "STARKE",
    "dropmalst": "FL",
    "dropmalzpp": 320919998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9049646457,
    "dropsitcph": 9049646457,
    "dropfax": 9049649784
  },
  {
    "dcode": "D",
    "dropkey": "PY23023",
    "droptype": "D",
    "dropname": "STEINHATCHEE",
    "dropdeladd": "104 15TH ST SE",
    "dropdelcty": "STEINHATCHEE",
    "dropdelst": "FL",
    "dropdelzpp": 323593100,
    "dropphyadd": "104 15TH ST SE",
    "dropphycty": "STEINHATCHEE",
    "dropphyst": "FL",
    "dropphyzpp": 323593100,
    "dropmaladd": "104 15TH ST SE",
    "dropmalcty": "STEINHATCHEE",
    "dropmalst": "FL",
    "dropmalzpp": 323599998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524985382,
    "dropsitcph": 3524985382,
    "dropfax": 3524985382
  },
  {
    "dcode": "D",
    "dropkey": "PY23025",
    "droptype": "D",
    "dropname": "STUART",
    "dropdeladd": "801 SE JOHNSON AVE",
    "dropdelcty": "STUART",
    "dropdelst": "FL",
    "dropdelzpp": 349949998,
    "dropphyadd": "801 SE JOHNSON AVE",
    "dropphycty": "STUART",
    "dropphyst": "FL",
    "dropphyzpp": 349949998,
    "dropmaladd": "801 SE JOHNSON AVE",
    "dropmalcty": "STUART",
    "dropmalst": "FL",
    "dropmalzpp": 349949998,
    "dropsitphn": 7722238782,
    "dropsitlph": 7722238782,
    "dropsitcph": 7722880846,
    "dropfax": 7722838056
  },
  {
    "dcode": "D",
    "dropkey": "PY23037",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "14560 S US HIGHWAY 301",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "FL",
    "dropdelzpp": 344919998,
    "dropphyadd": "14560 S US HIGHWAY 301",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "FL",
    "dropphyzpp": 344919998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "FL",
    "dropmalzpp": 344929998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522452784,
    "dropsitcph": 3522452784,
    "dropfax": 3522457440
  },
  {
    "dcode": "D",
    "dropkey": "PY23038",
    "droptype": "D",
    "dropname": "SUMMERLAND KEY",
    "dropdeladd": "24700 OVERSEAS HWY",
    "dropdelcty": "SUMMERLAND KEY",
    "dropdelst": "FL",
    "dropdelzpp": 330429998,
    "dropphyadd": "24700 OVERSEAS HWY",
    "dropphycty": "SUMMERLAND KEY",
    "dropphyst": "FL",
    "dropphyzpp": 330429998,
    "dropmaladd": "24700 OVERSEAS HWY",
    "dropmalcty": "SUMMERLAND KEY",
    "dropmalst": "FL",
    "dropmalzpp": 330429998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3057458657,
    "dropsitcph": 3057453391,
    "dropfax": 3057453105
  },
  {
    "dcode": "D",
    "dropkey": "PY23039",
    "droptype": "D",
    "dropname": "SUMTERVILLE",
    "dropdeladd": "445 S US 301",
    "dropdelcty": "SUMTERVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 335854941,
    "dropphyadd": "445 S US 301",
    "dropphycty": "SUMTERVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 335854941,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMTERVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 335859998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527934397,
    "dropfax": 3527933601
  },
  {
    "dcode": "D",
    "dropkey": "PY23040",
    "droptype": "D",
    "dropname": "SUN CITY",
    "dropdeladd": "4449 OLD HIGHWAY 41 S",
    "dropdelcty": "SUN CITY",
    "dropdelst": "FL",
    "dropdelzpp": 335869700,
    "dropphyadd": "4449 OLD HIGHWAY 41 S",
    "dropphycty": "SUN CITY",
    "dropphyst": "FL",
    "dropphyzpp": 335869700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUN CITY",
    "dropmalst": "FL",
    "dropmalzpp": 335869998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136455884,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23066",
    "droptype": "D",
    "dropname": "SUWANNEE",
    "dropdeladd": "23252 SE HIGHWAY 349",
    "dropdelcty": "SUWANNEE",
    "dropdelst": "FL",
    "dropdelzpp": 326929990,
    "dropphyadd": "23252 SE HIGHWAY 349",
    "dropphycty": "SUWANNEE",
    "dropphyst": "FL",
    "dropphyzpp": 326929990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUWANNEE",
    "dropmalst": "FL",
    "dropmalzpp": 326929998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525427111,
    "dropsitcph": 3525427111,
    "dropfax": 3525427719
  },
  {
    "dcode": "D",
    "dropkey": "PY23070",
    "droptype": "D",
    "dropname": "SYDNEY",
    "dropdeladd": "1620 SYDNEY DOVER RD",
    "dropdelcty": "SYDNEY",
    "dropdelst": "FL",
    "dropdelzpp": 335879800,
    "dropphyadd": "1620 SYDNEY DOVER RD",
    "dropphycty": "SYDNEY",
    "dropphyst": "FL",
    "dropphyzpp": 335879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SYDNEY",
    "dropmalst": "FL",
    "dropmalzpp": 335879998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136591902,
    "dropfax": 8137528844
  },
  {
    "dcode": "D",
    "dropkey": "PY23073",
    "droptype": "D",
    "dropname": "TALLAHASSEE",
    "dropdeladd": "2800 S ADAMS ST",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323019998,
    "dropphyadd": "2800 S ADAMS ST",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323019998,
    "dropmaladd": "2800 S ADAMS ST",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323019998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502164364,
    "dropsitcph": 8502164363,
    "dropfax": 8502164342
  },
  {
    "dcode": "D",
    "dropkey": "PY23074",
    "droptype": "D",
    "dropname": "TALLEVAST",
    "dropdeladd": "2205 TALLEVAST RD",
    "dropdelcty": "TALLEVAST",
    "dropdelst": "FL",
    "dropdelzpp": 342709800,
    "dropphyadd": "2205 TALLEVAST RD",
    "dropphycty": "TALLEVAST",
    "dropphyst": "FL",
    "dropphyzpp": 342709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALLEVAST",
    "dropmalst": "FL",
    "dropmalzpp": 342709998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413600431,
    "dropfax": 9413600823
  },
  {
    "dcode": "D",
    "dropkey": "PY23079",
    "droptype": "D",
    "dropname": "TAMPA",
    "dropdeladd": "3501 BESSIE COLEMAN BLVD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336305009,
    "dropphyadd": "3501 BESSIE COLEMAN BLVD FL 3",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336305010,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336309998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138770374,
    "dropfax": 8138760893
  },
  {
    "dcode": "D",
    "dropkey": "PY23082",
    "droptype": "D",
    "dropname": "TANGERINE",
    "dropdeladd": "5424 LAKE ST",
    "dropdelcty": "TANGERINE",
    "dropdelst": "FL",
    "dropdelzpp": 327777198,
    "dropphyadd": "5424 LAKE ST",
    "dropphycty": "TANGERINE",
    "dropphyst": "FL",
    "dropphyzpp": 327777198,
    "dropmaladd": "PO BOX 779998",
    "dropmalcty": "TANGERINE",
    "dropmalst": "FL",
    "dropmalzpp": 327779998,
    "dropsitphn": 3527350983,
    "dropsitlph": 3527350983,
    "dropsitcph": 3527350983,
    "dropfax": 3527350983
  },
  {
    "dcode": "D",
    "dropkey": "PY23084",
    "droptype": "D",
    "dropname": "TARPON SPRINGS",
    "dropdeladd": "850 E LIME ST",
    "dropdelcty": "TARPON SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 346899998,
    "dropphyadd": "850 E LIME ST",
    "dropphycty": "TARPON SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 346899998,
    "dropmaladd": "850 E LIME ST",
    "dropmalcty": "TARPON SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 346899998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770637,
    "dropsitcph": 7279347241,
    "dropfax": 7279377410
  },
  {
    "dcode": "D",
    "dropkey": "PY23087",
    "droptype": "D",
    "dropname": "TAVARES",
    "dropdeladd": "399 E BURLEIGH BLVD",
    "dropdelcty": "TAVARES",
    "dropdelst": "FL",
    "dropdelzpp": 327789998,
    "dropphyadd": "399 E BURLEIGH BLVD",
    "dropphycty": "TAVARES",
    "dropphyst": "FL",
    "dropphyzpp": 327789998,
    "dropmaladd": "399 E BURLEIGH BLVD",
    "dropmalcty": "TAVARES",
    "dropmalst": "FL",
    "dropmalzpp": 327789998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3523433351,
    "dropfax": 3523431192
  },
  {
    "dcode": "D",
    "dropkey": "PY23089",
    "droptype": "D",
    "dropname": "TAVERNIER",
    "dropdeladd": "91220 OVERSEAS HWY",
    "dropdelcty": "TAVERNIER",
    "dropdelst": "FL",
    "dropdelzpp": 330709998,
    "dropphyadd": "91220 OVERSEAS HWY",
    "dropphycty": "TAVERNIER",
    "dropphyst": "FL",
    "dropphyzpp": 330709998,
    "dropmaladd": "91220 OVERSEAS HWY",
    "dropmalcty": "TAVERNIER",
    "dropmalst": "FL",
    "dropmalzpp": 330709998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058537029,
    "dropsitcph": 3058531052,
    "dropfax": 3054339704
  },
  {
    "dcode": "D",
    "dropkey": "PY23090",
    "droptype": "D",
    "dropname": "TELOGIA",
    "dropdeladd": "27134 NE COUNTY ROAD 67",
    "dropdelcty": "TELOGIA",
    "dropdelst": "FL",
    "dropdelzpp": 323603098,
    "dropphyadd": "27134 NE COUNTY ROAD 67",
    "dropphycty": "TELOGIA",
    "dropphyst": "FL",
    "dropphyzpp": 323603098,
    "dropmaladd": "27134 NE COUNTY ROAD 67",
    "dropmalcty": "TELOGIA",
    "dropmalst": "FL",
    "dropmalzpp": 323603098,
    "dropsitphn": 9043592957,
    "dropsitlph": 8503798156,
    "dropsitcph": 8503798156,
    "dropfax": 8503798066
  },
  {
    "dcode": "D",
    "dropkey": "PY23096",
    "droptype": "D",
    "dropname": "TERRA CEIA",
    "dropdeladd": "1891 CENTER RD",
    "dropdelcty": "TERRA CEIA",
    "dropdelst": "FL",
    "dropdelzpp": 342509800,
    "dropphyadd": "1891 CENTER RD",
    "dropphycty": "TERRA CEIA",
    "dropphyst": "FL",
    "dropphyzpp": 342509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TERRA CEIA",
    "dropmalst": "FL",
    "dropmalzpp": 342509998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417290588,
    "dropfax": 9417298688
  },
  {
    "dcode": "D",
    "dropkey": "PY23098",
    "droptype": "D",
    "dropname": "THONOTOSASSA",
    "dropdeladd": "10806 MAIN ST",
    "dropdelcty": "THONOTOSASSA",
    "dropdelst": "FL",
    "dropdelzpp": 335929998,
    "dropphyadd": "10806 MAIN ST",
    "dropphycty": "THONOTOSASSA",
    "dropphyst": "FL",
    "dropphyzpp": 335929998,
    "dropmaladd": "10806 MAIN ST",
    "dropmalcty": "THONOTOSASSA",
    "dropmalst": "FL",
    "dropmalzpp": 335929998,
    "dropsitphn": 8137660302,
    "dropsitlph": 8137660302,
    "dropsitcph": 8139820266,
    "dropfax": 8139820266
  },
  {
    "dcode": "D",
    "dropkey": "PY23104",
    "droptype": "D",
    "dropname": "TITUSVILLE",
    "dropdeladd": "2503 S WASHINGTON AVE",
    "dropdelcty": "TITUSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 327809998,
    "dropphyadd": "2503 S WASHINGTON AVE",
    "dropphycty": "TITUSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 327809998,
    "dropmaladd": "2503 S WASHINGTON AVE",
    "dropmalcty": "TITUSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 327809998,
    "dropsitphn": 3212678144,
    "dropsitlph": 3212678144,
    "dropsitcph": 3212674826,
    "dropfax": 3212673596
  },
  {
    "dcode": "D",
    "dropkey": "PY23120",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "1831 E WADE ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "FL",
    "dropdelzpp": 326939998,
    "dropphyadd": "1831 E WADE ST",
    "dropphycty": "TRENTON",
    "dropphyst": "FL",
    "dropphyzpp": 326939998,
    "dropmaladd": "1831 E WADE ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "FL",
    "dropmalzpp": 326939998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524636129,
    "dropsitcph": 3524636129,
    "dropfax": 3524631997
  },
  {
    "dcode": "D",
    "dropkey": "PY23121",
    "droptype": "D",
    "dropname": "TRILBY",
    "dropdeladd": "37451 TRILBY RD",
    "dropdelcty": "TRILBY",
    "dropdelst": "FL",
    "dropdelzpp": 335939800,
    "dropphyadd": "37451 TRILBY RD",
    "dropphycty": "TRILBY",
    "dropphyst": "FL",
    "dropphyzpp": 335939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRILBY",
    "dropmalst": "FL",
    "dropmalzpp": 335939998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3525832282,
    "dropfax": 3525832282
  },
  {
    "dcode": "D",
    "dropkey": "PY23133",
    "droptype": "D",
    "dropname": "UMATILLA",
    "dropdeladd": "315 N CENTRAL AVE",
    "dropdelcty": "UMATILLA",
    "dropdelst": "FL",
    "dropdelzpp": 327849998,
    "dropphyadd": "315 N CENTRAL AVE",
    "dropphycty": "UMATILLA",
    "dropphyst": "FL",
    "dropphyzpp": 327849998,
    "dropmaladd": "315 N CENTRAL AVE",
    "dropmalcty": "UMATILLA",
    "dropmalst": "FL",
    "dropmalzpp": 327849998,
    "dropsitphn": 3526693289,
    "dropsitlph": 3526693289,
    "dropsitcph": 3526692611,
    "dropfax": 3526696691
  },
  {
    "dcode": "D",
    "dropkey": "PY23157",
    "droptype": "D",
    "dropname": "VALPARAISO",
    "dropdeladd": "306 EDGE AVE",
    "dropdelcty": "VALPARAISO",
    "dropdelst": "FL",
    "dropdelzpp": 325809998,
    "dropphyadd": "306 EDGE AVE",
    "dropphycty": "VALPARAISO",
    "dropphyst": "FL",
    "dropphyzpp": 325809998,
    "dropmaladd": "306 EDGE AVE",
    "dropmalcty": "VALPARAISO",
    "dropmalst": "FL",
    "dropmalzpp": 325809998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506782921,
    "dropsitcph": 8506782921,
    "dropfax": 8507293075
  },
  {
    "dcode": "D",
    "dropkey": "PY23158",
    "droptype": "D",
    "dropname": "VALRICO",
    "dropdeladd": "2406 E STATE ROAD 60",
    "dropdelcty": "VALRICO",
    "dropdelst": "FL",
    "dropdelzpp": 335949998,
    "dropphyadd": "2406 E STATE ROAD 60",
    "dropphycty": "VALRICO",
    "dropphyst": "FL",
    "dropphyzpp": 335949998,
    "dropmaladd": "2406 E STATE ROAD 60",
    "dropmalcty": "VALRICO",
    "dropmalst": "FL",
    "dropmalzpp": 335949998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136570495,
    "dropfax": 8136544974
  },
  {
    "dcode": "D",
    "dropkey": "PY23163",
    "droptype": "D",
    "dropname": "VENICE",
    "dropdeladd": "350 W VENICE AVE",
    "dropdelcty": "VENICE",
    "dropdelst": "FL",
    "dropdelzpp": 342850001,
    "dropphyadd": "350 W VENICE AVE",
    "dropphycty": "VENICE",
    "dropphyst": "FL",
    "dropphyzpp": 342850001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENICE",
    "dropmalst": "FL",
    "dropmalzpp": 342849998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414834195,
    "dropfax": 9414861238
  },
  {
    "dcode": "D",
    "dropkey": "PY23166",
    "droptype": "D",
    "dropname": "VENUS",
    "dropdeladd": "820 US HIGHWAY 27 N",
    "dropdelcty": "VENUS",
    "dropdelst": "FL",
    "dropdelzpp": 339609998,
    "dropphyadd": "820 US HIGHWAY 27 N",
    "dropphycty": "VENUS",
    "dropphyst": "FL",
    "dropphyzpp": 339609998,
    "dropmaladd": "820 US HIGHWAY 27 N",
    "dropmalcty": "VENUS",
    "dropmalst": "FL",
    "dropmalzpp": 339609998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 8634652631,
    "dropfax": 8634657431
  },
  {
    "dcode": "D",
    "dropkey": "PY23167",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "3039 MAIN ST",
    "dropdelcty": "VERNON",
    "dropdelst": "FL",
    "dropdelzpp": 324629998,
    "dropphyadd": "3039 MAIN ST",
    "dropphycty": "VERNON",
    "dropphyst": "FL",
    "dropphyzpp": 324629998,
    "dropmaladd": "3039 MAIN ST",
    "dropmalcty": "VERNON",
    "dropmalst": "FL",
    "dropmalzpp": 324629998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505352664,
    "dropsitcph": 8505352664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23168",
    "droptype": "D",
    "dropname": "VERO BEACH",
    "dropdeladd": "1551 US HIGHWAY 1",
    "dropdelcty": "VERO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329609992,
    "dropphyadd": "1551 US HIGHWAY 1",
    "dropphycty": "VERO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329609992,
    "dropmaladd": "1551 US HIGHWAY 1",
    "dropmalcty": "VERO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329609992,
    "dropsitphn": 7727783039,
    "dropsitlph": 7727783039,
    "dropsitcph": 7727783039,
    "dropfax": 7727783263
  },
  {
    "dcode": "D",
    "dropkey": "PY23189",
    "droptype": "D",
    "dropname": "WABASSO",
    "dropdeladd": "8114 US HIGHWAY 1",
    "dropdelcty": "WABASSO",
    "dropdelst": "FL",
    "dropdelzpp": 329705659,
    "dropphyadd": "8114 US HIGHWAY 1",
    "dropphycty": "WABASSO",
    "dropphyst": "FL",
    "dropphyzpp": 329705659,
    "dropmaladd": "PO BOX 709998",
    "dropmalcty": "WABASSO",
    "dropmalst": "FL",
    "dropmalzpp": 329709998,
    "dropsitphn": 7725893844,
    "dropsitlph": 7725893844,
    "dropsitcph": 7725894851,
    "dropfax": 7723881146
  },
  {
    "dcode": "D",
    "dropkey": "PY23190",
    "droptype": "D",
    "dropname": "WACISSA",
    "dropdeladd": "38 TRAM RD",
    "dropdelcty": "WACISSA",
    "dropdelst": "FL",
    "dropdelzpp": 323619900,
    "dropphyadd": "38 TRAM RD",
    "dropphycty": "WACISSA",
    "dropphyst": "FL",
    "dropphyzpp": 323619900,
    "dropmaladd": "38 TRAM RD",
    "dropmalcty": "WACISSA",
    "dropmalst": "FL",
    "dropmalzpp": 323619998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509975281,
    "dropsitcph": 8509975281,
    "dropfax": 8509978869
  },
  {
    "dcode": "D",
    "dropkey": "PY23196",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "15075 NE US HIGHWAY 301",
    "dropdelcty": "WALDO",
    "dropdelst": "FL",
    "dropdelzpp": 326944048,
    "dropphyadd": "15075 NE US HIGHWAY 301",
    "dropphycty": "WALDO",
    "dropphyst": "FL",
    "dropphyzpp": 326944048,
    "dropmaladd": "15075 NE US HIGHWAY 301",
    "dropmalcty": "WALDO",
    "dropmalst": "FL",
    "dropmalzpp": 326949998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524681970,
    "dropsitcph": 3524681970,
    "dropfax": 3524681321
  },
  {
    "dcode": "D",
    "dropkey": "PY23201",
    "droptype": "D",
    "dropname": "WAUCHULA",
    "dropdeladd": "300 E MAIN ST",
    "dropdelcty": "WAUCHULA",
    "dropdelst": "FL",
    "dropdelzpp": 338739998,
    "dropphyadd": "300 E MAIN ST",
    "dropphycty": "WAUCHULA",
    "dropphyst": "FL",
    "dropphyzpp": 338739998,
    "dropmaladd": "300 E MAIN ST",
    "dropmalcty": "WAUCHULA",
    "dropmalst": "FL",
    "dropmalzpp": 338739998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8637735811,
    "dropfax": 8637732225
  },
  {
    "dcode": "D",
    "dropkey": "PY23202",
    "droptype": "D",
    "dropname": "WAUSAU",
    "dropdeladd": "3556 WASHINGTON ST",
    "dropdelcty": "WAUSAU",
    "dropdelst": "FL",
    "dropdelzpp": 324639998,
    "dropphyadd": "3556 WASHINGTON ST",
    "dropphycty": "WAUSAU",
    "dropphyst": "FL",
    "dropphyzpp": 324639998,
    "dropmaladd": "3556 WASHINGTON ST",
    "dropmalcty": "WAUSAU",
    "dropmalst": "FL",
    "dropmalzpp": 324639998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506384158,
    "dropsitcph": 8506384158,
    "dropfax": 8504155888
  },
  {
    "dcode": "D",
    "dropkey": "PY23203",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "7301 STATE RD 540",
    "dropdelcty": "WAVERLY",
    "dropdelst": "FL",
    "dropdelzpp": 338779700,
    "dropphyadd": "7301 STATE RD 540",
    "dropphycty": "WAVERLY",
    "dropphyst": "FL",
    "dropphyzpp": 338779700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAVERLY",
    "dropmalst": "FL",
    "dropmalzpp": 338779998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8634393500,
    "dropfax": 8634398336
  },
  {
    "dcode": "D",
    "dropkey": "PY23204",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "40 SE 1ST ST",
    "dropdelcty": "WEBSTER",
    "dropdelst": "FL",
    "dropdelzpp": 335979998,
    "dropphyadd": "40 SE 1ST ST",
    "dropphycty": "WEBSTER",
    "dropphyst": "FL",
    "dropphyzpp": 335979998,
    "dropmaladd": "40 SE 1ST ST",
    "dropmalcty": "WEBSTER",
    "dropmalst": "FL",
    "dropmalzpp": 335979998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 3527939514,
    "dropfax": 3527939514
  },
  {
    "dcode": "D",
    "dropkey": "PY23206",
    "droptype": "D",
    "dropname": "WEIRSDALE",
    "dropdeladd": "13595 SE HIGHWAY 42",
    "dropdelcty": "WEIRSDALE",
    "dropdelst": "FL",
    "dropdelzpp": 321959998,
    "dropphyadd": "13595 SE HIGHWAY 42",
    "dropphycty": "WEIRSDALE",
    "dropphyst": "FL",
    "dropphyzpp": 321959998,
    "dropmaladd": "13595 SE HIGHWAY 42",
    "dropmalcty": "WEIRSDALE",
    "dropmalst": "FL",
    "dropmalzpp": 321959998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3528213172,
    "dropsitcph": 3528213172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23209",
    "droptype": "D",
    "dropname": "WELAKA",
    "dropdeladd": "664 3RD AVE",
    "dropdelcty": "WELAKA",
    "dropdelst": "FL",
    "dropdelzpp": 321939998,
    "dropphyadd": "664 3RD AVE",
    "dropphycty": "WELAKA",
    "dropphyst": "FL",
    "dropphyzpp": 321939998,
    "dropmaladd": "664 3RD AVE",
    "dropmalcty": "WELAKA",
    "dropmalst": "FL",
    "dropmalzpp": 321939998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864672116,
    "dropsitcph": 3864672116,
    "dropfax": 3864672668
  },
  {
    "dcode": "D",
    "dropkey": "PY23210",
    "droptype": "D",
    "dropname": "WELLBORN",
    "dropdeladd": "12096 COUNTY ROAD 137",
    "dropdelcty": "WELLBORN",
    "dropdelst": "FL",
    "dropdelzpp": 320949998,
    "dropphyadd": "12096 COUNTY ROAD 137",
    "dropphycty": "WELLBORN",
    "dropphyst": "FL",
    "dropphyzpp": 320949998,
    "dropmaladd": "12096 COUNTY ROAD 137",
    "dropmalcty": "WELLBORN",
    "dropmalst": "FL",
    "dropmalzpp": 320949998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3869632931,
    "dropsitcph": 3869632931,
    "dropfax": 9049632931
  },
  {
    "dcode": "D",
    "dropkey": "PY23234",
    "droptype": "D",
    "dropname": "WEST PALM BEACH",
    "dropdeladd": "3200 SUMMIT BLVD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334163599,
    "dropphyadd": "3200 SUMMIT BLVD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334163599,
    "dropmaladd": "PO BOX 169998",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334169998,
    "dropsitphn": 5616972122,
    "dropsitlph": 5616972122,
    "dropsitcph": 5616972165,
    "dropfax": 5616971970
  },
  {
    "dcode": "D",
    "dropkey": "PY23248",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "2527 N PINE ST",
    "dropdelcty": "WESTVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 324649998,
    "dropphyadd": "2527 N PINE ST",
    "dropphycty": "WESTVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 324649998,
    "dropmaladd": "2527 N PINE ST",
    "dropmalcty": "WESTVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 324649998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505209016,
    "dropsitcph": 8505209016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23249",
    "droptype": "D",
    "dropname": "WEWAHITCHKA",
    "dropdeladd": "432 HIGHWAY 22",
    "dropdelcty": "WEWAHITCHKA",
    "dropdelst": "FL",
    "dropdelzpp": 324659998,
    "dropphyadd": "432 HIGHWAY 22",
    "dropphycty": "WEWAHITCHKA",
    "dropphyst": "FL",
    "dropphyzpp": 324659998,
    "dropmaladd": "432 HIGHWAY 22",
    "dropmalcty": "WEWAHITCHKA",
    "dropmalst": "FL",
    "dropmalzpp": 324659998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506392242,
    "dropsitcph": 8506392242,
    "dropfax": 8506393273
  },
  {
    "dcode": "D",
    "dropkey": "PY23252",
    "droptype": "D",
    "dropname": "WHITE SPRINGS",
    "dropdeladd": "16555 SPRING ST",
    "dropdelcty": "WHITE SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 320969998,
    "dropphyadd": "16555 SPRING ST",
    "dropphycty": "WHITE SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 320969998,
    "dropmaladd": "16555 SPRING ST",
    "dropmalcty": "WHITE SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 320969998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3863972166,
    "dropsitcph": 3863972166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23257",
    "droptype": "D",
    "dropname": "WILDWOOD",
    "dropdeladd": "316 SHOPPING CENTER DR",
    "dropdelcty": "WILDWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 347859998,
    "dropphyadd": "316 SHOPPING CENTER DR",
    "dropphycty": "WILDWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 347859998,
    "dropmaladd": "316 SHOPPING CENTER DR",
    "dropmalcty": "WILDWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 347859998,
    "dropsitphn": 3527484175,
    "dropsitlph": 3527482550,
    "dropsitcph": 3527482550,
    "dropfax": 3527482647
  },
  {
    "dcode": "D",
    "dropkey": "PY23261",
    "droptype": "D",
    "dropname": "WILLISTON",
    "dropdeladd": "29 NW 1ST AVE",
    "dropdelcty": "WILLISTON",
    "dropdelst": "FL",
    "dropdelzpp": 326969998,
    "dropphyadd": "29 NW 1ST AVE",
    "dropphycty": "WILLISTON",
    "dropphyst": "FL",
    "dropphyzpp": 326969998,
    "dropmaladd": "29 NW 1ST AVE",
    "dropmalcty": "WILLISTON",
    "dropmalst": "FL",
    "dropmalzpp": 326969998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3525284114,
    "dropsitcph": 3525284114,
    "dropfax": 3525280420
  },
  {
    "dcode": "D",
    "dropkey": "PY23265",
    "droptype": "D",
    "dropname": "WIMAUMA",
    "dropdeladd": "5608 STATE ROAD 674",
    "dropdelcty": "WIMAUMA",
    "dropdelst": "FL",
    "dropdelzpp": 335989998,
    "dropphyadd": "5608 STATE ROAD 674",
    "dropphycty": "WIMAUMA",
    "dropphyst": "FL",
    "dropphyzpp": 335989998,
    "dropmaladd": "5608 STATE ROAD 674",
    "dropmalcty": "WIMAUMA",
    "dropmalst": "FL",
    "dropmalzpp": 335989998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136344282,
    "dropfax": 8136346766
  },
  {
    "dcode": "D",
    "dropkey": "PY23266",
    "droptype": "D",
    "dropname": "WINDERMERE",
    "dropdeladd": "9300 CONROY WINDERMERE RD",
    "dropdelcty": "WINDERMERE",
    "dropdelst": "FL",
    "dropdelzpp": 347869998,
    "dropphyadd": "9300 CONROY WINDERMERE RD",
    "dropphycty": "WINDERMERE",
    "dropphyst": "FL",
    "dropphyzpp": 347869998,
    "dropmaladd": "9300 CONROY WINDERMERE RD",
    "dropmalcty": "WINDERMERE",
    "dropmalst": "FL",
    "dropmalzpp": 347869998,
    "dropsitphn": 4078765770,
    "dropsitlph": 4078765770,
    "dropsitcph": 4078762344,
    "dropfax": 4078768721
  },
  {
    "dcode": "D",
    "dropkey": "PY23269",
    "droptype": "D",
    "dropname": "WINTER GARDEN",
    "dropdeladd": "15155 W COLONIAL DR",
    "dropdelcty": "WINTER GARDEN",
    "dropdelst": "FL",
    "dropdelzpp": 347879998,
    "dropphyadd": "15155 W COLONIAL DR",
    "dropphycty": "WINTER GARDEN",
    "dropphyst": "FL",
    "dropphyzpp": 347879998,
    "dropmaladd": "15155 W COLONIAL DR",
    "dropmalcty": "WINTER GARDEN",
    "dropmalst": "FL",
    "dropmalzpp": 347879998,
    "dropsitphn": 4076563344,
    "dropsitlph": 4076563112,
    "dropsitcph": 4076563344,
    "dropfax": 4076566443
  },
  {
    "dcode": "D",
    "dropkey": "PY23270",
    "droptype": "D",
    "dropname": "WINTER HAVEN",
    "dropdeladd": "111 W CENTRAL AVE",
    "dropdelcty": "WINTER HAVEN",
    "dropdelst": "FL",
    "dropdelzpp": 338809998,
    "dropphyadd": "111 W CENTRAL AVE",
    "dropphycty": "WINTER HAVEN",
    "dropphyst": "FL",
    "dropphyzpp": 338809998,
    "dropmaladd": "111 W CENTRAL AVE",
    "dropmalcty": "WINTER HAVEN",
    "dropmalst": "FL",
    "dropmalzpp": 338809998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8632997824,
    "dropfax": 8632948126
  },
  {
    "dcode": "D",
    "dropkey": "PY23272",
    "droptype": "D",
    "dropname": "WINTER PARK",
    "dropdeladd": "300 N NEW YORK AVE",
    "dropdelcty": "WINTER PARK",
    "dropdelst": "FL",
    "dropdelzpp": 327899998,
    "dropphyadd": "300 N NEW YORK AVE",
    "dropphycty": "WINTER PARK",
    "dropphyst": "FL",
    "dropphyzpp": 327899998,
    "dropmaladd": "300 N NEW YORK AVE",
    "dropmalcty": "WINTER PARK",
    "dropmalst": "FL",
    "dropmalzpp": 327899998,
    "dropsitphn": 4076284711,
    "dropsitlph": 4076284711,
    "dropsitcph": 4076476807,
    "dropfax": 4076451905
  },
  {
    "dcode": "D",
    "dropkey": "PY23279",
    "droptype": "D",
    "dropname": "WOODVILLE",
    "dropdeladd": "8219 WOODVILLE HWY",
    "dropdelcty": "WOODVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 323626200,
    "dropphyadd": "8219 WOODVILLE HWY",
    "dropphycty": "WOODVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 323626200,
    "dropmaladd": "8219 WOODVILLE HWY",
    "dropmalcty": "WOODVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 323629998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504215230,
    "dropsitcph": 8504215230,
    "dropfax": 8504218576
  },
  {
    "dcode": "D",
    "dropkey": "PY23281",
    "droptype": "D",
    "dropname": "WORTHINGTON SPRINGS",
    "dropdeladd": "11972 SW 37TH TRL",
    "dropdelcty": "LAKE BUTLER",
    "dropdelst": "FL",
    "dropdelzpp": 320547642,
    "dropphyadd": "11972 SW 37TH TRL",
    "dropphycty": "LAKE BUTLER",
    "dropphyst": "FL",
    "dropphyzpp": 320547642,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WORTHINGTON SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 326979998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3864963097,
    "dropsitcph": 3864963097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23285",
    "droptype": "D",
    "dropname": "YALAHA",
    "dropdeladd": "8712 COUNTY ROAD 48",
    "dropdelcty": "YALAHA",
    "dropdelst": "FL",
    "dropdelzpp": 347979998,
    "dropphyadd": "8712 COUNTY ROAD 48",
    "dropphycty": "YALAHA",
    "dropphyst": "FL",
    "dropphyzpp": 347979998,
    "dropmaladd": "8712 COUNTY ROAD 48",
    "dropmalcty": "YALAHA",
    "dropmalst": "FL",
    "dropmalzpp": 347979998,
    "dropsitphn": 3523242130,
    "dropsitlph": 3523242130,
    "dropsitcph": 3526773317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23286",
    "droptype": "D",
    "dropname": "YANKEETOWN",
    "dropdeladd": "17 56TH ST",
    "dropdelcty": "YANKEETOWN",
    "dropdelst": "FL",
    "dropdelzpp": 344989998,
    "dropphyadd": "17 56TH ST",
    "dropphycty": "YANKEETOWN",
    "dropphyst": "FL",
    "dropphyzpp": 344989998,
    "dropmaladd": "17 56TH ST",
    "dropmalcty": "YANKEETOWN",
    "dropmalst": "FL",
    "dropmalzpp": 344989998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3524472969,
    "dropsitcph": 3524472969,
    "dropfax": 3524472969
  },
  {
    "dcode": "D",
    "dropkey": "PY23290",
    "droptype": "D",
    "dropname": "YOUNGSTOWN",
    "dropdeladd": "11805 HIGHWAY 231",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "FL",
    "dropdelzpp": 324661952,
    "dropphyadd": "11805 HIGHWAY 231",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "FL",
    "dropphyzpp": 324661952,
    "dropmaladd": "11805 HIGHWAY 231",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "FL",
    "dropmalzpp": 324669998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507224552,
    "dropsitcph": 8507224552,
    "dropfax": 8507220186
  },
  {
    "dcode": "D",
    "dropkey": "PY23292",
    "droptype": "D",
    "dropname": "YULEE",
    "dropdeladd": "463063 STATE ROAD 200",
    "dropdelcty": "YULEE",
    "dropdelst": "FL",
    "dropdelzpp": 320979998,
    "dropphyadd": "463063 STATE ROAD 200",
    "dropphycty": "YULEE",
    "dropphyst": "FL",
    "dropphyzpp": 320979998,
    "dropmaladd": "463063 STATE ROAD 200",
    "dropmalcty": "YULEE",
    "dropmalst": "FL",
    "dropmalzpp": 320979998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042250936,
    "dropsitcph": 9042255331,
    "dropfax": 9042259733
  },
  {
    "dcode": "D",
    "dropkey": "PY23294",
    "droptype": "D",
    "dropname": "ZELLWOOD",
    "dropdeladd": "3125 N WASHINGTON ST",
    "dropdelcty": "ZELLWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 327989998,
    "dropphyadd": "3125 N WASHINGTON ST",
    "dropphycty": "ZELLWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 327989998,
    "dropmaladd": "3125 N WASHINGTON ST",
    "dropmalcty": "ZELLWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 327989998,
    "dropsitphn": 4078869266,
    "dropsitlph": 4078869266,
    "dropsitcph": 4078869266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23295",
    "droptype": "D",
    "dropname": "ZEPHYRHILLS",
    "dropdeladd": "38032 POSTAL DR",
    "dropdelcty": "ZEPHYRHILLS",
    "dropdelst": "FL",
    "dropdelzpp": 335429998,
    "dropphyadd": "38032 POSTAL DR",
    "dropphycty": "ZEPHYRHILLS",
    "dropphyst": "FL",
    "dropphyzpp": 335429998,
    "dropmaladd": "38032 POSTAL DR",
    "dropmalcty": "ZEPHYRHILLS",
    "dropmalst": "FL",
    "dropmalzpp": 335429998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8137150149,
    "dropfax": 8137808291
  },
  {
    "dcode": "D",
    "dropkey": "PY23297",
    "droptype": "D",
    "dropname": "ZOLFO SPRINGS",
    "dropdeladd": "3141 MAIN ST",
    "dropdelcty": "ZOLFO SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 338904762,
    "dropphyadd": "3141 MAIN ST",
    "dropphycty": "ZOLFO SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 338904762,
    "dropmaladd": "3141 MAIN ST",
    "dropmalcty": "ZOLFO SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 338909998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8637358412,
    "dropfax": 8637352030
  },
  {
    "dcode": "D",
    "dropkey": "PY23300",
    "droptype": "D",
    "dropname": "ABBEVILLE",
    "dropdeladd": "1421 VETERANS MEMORIAL DR",
    "dropdelcty": "ABBEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705103133,
    "dropphyadd": "1421 VETERANS MEMORIAL DR",
    "dropphycty": "ABBEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705103133,
    "dropmaladd": "1421 VETERANS MEMORIAL DR",
    "dropmalcty": "ABBEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705103133,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378989602,
    "dropfax": 3378933670
  },
  {
    "dcode": "D",
    "dropkey": "PY23301",
    "droptype": "D",
    "dropname": "ABITA SPRINGS",
    "dropdeladd": "22444 HIGHWAY 435",
    "dropdelcty": "ABITA SPRINGS",
    "dropdelst": "LA",
    "dropdelzpp": 704209998,
    "dropphyadd": "22444 HIGHWAY 435",
    "dropphycty": "ABITA SPRINGS",
    "dropphyst": "LA",
    "dropphyzpp": 704209998,
    "dropmaladd": "22444 HIGHWAY 435",
    "dropmalcty": "ABITA SPRINGS",
    "dropmalst": "LA",
    "dropmalzpp": 704209998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858096926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23302",
    "droptype": "D",
    "dropname": "ACME",
    "dropdeladd": "56412 HIGHWAY 129",
    "dropdelcty": "ACME",
    "dropdelst": "LA",
    "dropdelzpp": 713169998,
    "dropphyadd": "56412 HIGHWAY 129",
    "dropphycty": "ACME",
    "dropphyst": "LA",
    "dropphyzpp": 713169998,
    "dropmaladd": "56412 HIGHWAY 129",
    "dropmalcty": "ACME",
    "dropmalst": "LA",
    "dropmalzpp": 713169998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183864157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23303",
    "droptype": "D",
    "dropname": "ADDIS",
    "dropdeladd": "4260 FORET ST",
    "dropdelcty": "ADDIS",
    "dropdelst": "LA",
    "dropdelzpp": 707109998,
    "dropphyadd": "4260 FORET ST",
    "dropphycty": "ADDIS",
    "dropphyst": "LA",
    "dropphyzpp": 707109998,
    "dropmaladd": "4260 FORET ST",
    "dropmalcty": "ADDIS",
    "dropmalst": "LA",
    "dropmalzpp": 707109998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256874153,
    "dropfax": 2256874153
  },
  {
    "dcode": "D",
    "dropkey": "PY23310",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "29683 S MONTPELIER RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "LA",
    "dropdelzpp": 707119998,
    "dropphyadd": "29683 S MONTPELIER RD",
    "dropphycty": "ALBANY",
    "dropphyst": "LA",
    "dropphyzpp": 707119998,
    "dropmaladd": "29683 S MONTPELIER RD",
    "dropmalcty": "ALBANY",
    "dropmalst": "LA",
    "dropmalzpp": 707119998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2252093647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23313",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "1715 ODOM ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "LA",
    "dropdelzpp": 713019998,
    "dropphyadd": "1715 ODOM ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "LA",
    "dropphyzpp": 713019998,
    "dropmaladd": "1715 ODOM ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "LA",
    "dropmalzpp": 713019998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184844602,
    "dropfax": 3184844659
  },
  {
    "dcode": "D",
    "dropkey": "PY23320",
    "droptype": "D",
    "dropname": "AMA",
    "dropdeladd": "10833 RIVER RD",
    "dropdelcty": "AMA",
    "dropdelst": "LA",
    "dropdelzpp": 700319998,
    "dropphyadd": "10833 RIVER RD",
    "dropphycty": "AMA",
    "dropphyst": "LA",
    "dropphyzpp": 700319998,
    "dropmaladd": "10833 RIVER RD",
    "dropmalcty": "AMA",
    "dropmalst": "LA",
    "dropmalzpp": 700319998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044311193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23321",
    "droptype": "D",
    "dropname": "AMELIA",
    "dropdeladd": "119 FRANCIS ST",
    "dropdelcty": "AMELIA",
    "dropdelst": "LA",
    "dropdelzpp": 703409998,
    "dropphyadd": "119 FRANCIS ST",
    "dropphycty": "AMELIA",
    "dropphyst": "LA",
    "dropphyzpp": 703409998,
    "dropmaladd": "119 FRANCIS ST",
    "dropmalcty": "AMELIA",
    "dropmalst": "LA",
    "dropmalzpp": 703409998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856310379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23322",
    "droptype": "D",
    "dropname": "AMITE",
    "dropdeladd": "113 E MULBERRY ST",
    "dropdelcty": "AMITE",
    "dropdelst": "LA",
    "dropdelzpp": 704229998,
    "dropphyadd": "113 E MULBERRY ST",
    "dropphycty": "AMITE",
    "dropphyst": "LA",
    "dropphyzpp": 704229998,
    "dropmaladd": "113 E MULBERRY ST",
    "dropmalcty": "AMITE",
    "dropmalst": "LA",
    "dropmalzpp": 704229998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857489401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23323",
    "droptype": "D",
    "dropname": "ANACOCO",
    "dropdeladd": "4658 MAIN ST",
    "dropdelcty": "ANACOCO",
    "dropdelst": "LA",
    "dropdelzpp": 714039998,
    "dropphyadd": "4658 MAIN ST",
    "dropphycty": "ANACOCO",
    "dropphyst": "LA",
    "dropphyzpp": 714039998,
    "dropmaladd": "4658 MAIN ST",
    "dropmalcty": "ANACOCO",
    "dropmalst": "LA",
    "dropmalzpp": 714039998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3373920879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23325",
    "droptype": "D",
    "dropname": "ANGIE",
    "dropdeladd": "29891 HIGHWAY 21",
    "dropdelcty": "ANGIE",
    "dropdelst": "LA",
    "dropdelzpp": 704269998,
    "dropphyadd": "29891 HIGHWAY 21",
    "dropphycty": "ANGIE",
    "dropphyst": "LA",
    "dropphyzpp": 704269998,
    "dropmaladd": "29891 HIGHWAY 21",
    "dropmalcty": "ANGIE",
    "dropmalst": "LA",
    "dropmalzpp": 704269998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9859867486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23326",
    "droptype": "D",
    "dropname": "ANGOLA",
    "dropdeladd": "11200 MAIN ST",
    "dropdelcty": "ANGOLA",
    "dropdelst": "LA",
    "dropdelzpp": 707121200,
    "dropphyadd": "11200 MAIN ST",
    "dropphycty": "ANGOLA",
    "dropphyst": "LA",
    "dropphyzpp": 707121200,
    "dropmaladd": "PO BOX 1200",
    "dropmalcty": "ANGOLA",
    "dropmalst": "LA",
    "dropmalzpp": 707129998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256553257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23331",
    "droptype": "D",
    "dropname": "ARABI",
    "dropdeladd": "748 MEHLE ST",
    "dropdelcty": "ARABI",
    "dropdelst": "LA",
    "dropdelzpp": 700321100,
    "dropphyadd": "748 MEHLE ST",
    "dropphycty": "ARABI",
    "dropphyst": "LA",
    "dropphyzpp": 700321100,
    "dropmaladd": "748 MEHLE ST",
    "dropmalcty": "ARABI",
    "dropmalst": "LA",
    "dropmalzpp": 700321100,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046821146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23332",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "1979 N RAILROAD AVE",
    "dropdelcty": "ARCADIA",
    "dropdelst": "LA",
    "dropdelzpp": 710019998,
    "dropphyadd": "1979 N RAILROAD AVE",
    "dropphycty": "ARCADIA",
    "dropphyst": "LA",
    "dropphyzpp": 710019998,
    "dropmaladd": "1979 N RAILROAD AVE",
    "dropmalcty": "ARCADIA",
    "dropmalst": "LA",
    "dropmalzpp": 710019998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182634820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23333",
    "droptype": "D",
    "dropname": "ARCHIBALD",
    "dropdeladd": "3744 HIGHWAY 15",
    "dropdelcty": "ARCHIBALD",
    "dropdelst": "LA",
    "dropdelzpp": 712189998,
    "dropphyadd": "3744 HIGHWAY 15",
    "dropphycty": "ARCHIBALD",
    "dropphyst": "LA",
    "dropphyzpp": 712189998,
    "dropmaladd": "3744 HIGHWAY 15",
    "dropmalcty": "ARCHIBALD",
    "dropmalst": "LA",
    "dropmalzpp": 712189998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182482734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23340",
    "droptype": "D",
    "dropname": "ARNAUDVILLE",
    "dropdeladd": "259 GUIDROZ ST",
    "dropdelcty": "ARNAUDVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705126120,
    "dropphyadd": "259 GUIDROZ ST",
    "dropphycty": "ARNAUDVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705126120,
    "dropmaladd": "259 GUIDROZ ST",
    "dropmalcty": "ARNAUDVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705126120,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377549947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23341",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "521 HIGHWAY 153",
    "dropdelcty": "ASHLAND",
    "dropdelst": "LA",
    "dropdelzpp": 710029998,
    "dropphyadd": "521 HIGHWAY 153",
    "dropphycty": "ASHLAND",
    "dropphyst": "LA",
    "dropphyzpp": 710029998,
    "dropmaladd": "521 HIGHWAY 153",
    "dropmalcty": "ASHLAND",
    "dropmalst": "LA",
    "dropmalzpp": 710029998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185448031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23343",
    "droptype": "D",
    "dropname": "ATHENS",
    "dropdeladd": "258 HIGHWAY 805",
    "dropdelcty": "ATHENS",
    "dropdelst": "LA",
    "dropdelzpp": 710039998,
    "dropphyadd": "258 HIGHWAY 805",
    "dropphycty": "ATHENS",
    "dropphyst": "LA",
    "dropphyzpp": 710039998,
    "dropmaladd": "258 HIGHWAY 805",
    "dropmalcty": "ATHENS",
    "dropmalst": "LA",
    "dropmalzpp": 710039998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182585461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23345",
    "droptype": "D",
    "dropname": "ATLANTA",
    "dropdeladd": "12288 MAIN ST",
    "dropdelcty": "ATLANTA",
    "dropdelst": "LA",
    "dropdelzpp": 714049998,
    "dropphyadd": "12288 MAIN ST",
    "dropphycty": "ATLANTA",
    "dropphyst": "LA",
    "dropphyzpp": 714049998,
    "dropmaladd": "12288 MAIN ST",
    "dropmalcty": "ATLANTA",
    "dropmalst": "LA",
    "dropmalzpp": 714049998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186482543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23347",
    "droptype": "D",
    "dropname": "AVERY ISLAND",
    "dropdeladd": "100 MAIN RD",
    "dropdelcty": "AVERY ISLAND",
    "dropdelst": "LA",
    "dropdelzpp": 705139998,
    "dropphyadd": "100 MAIN RD",
    "dropphycty": "AVERY ISLAND",
    "dropphyst": "LA",
    "dropphyzpp": 705139998,
    "dropmaladd": "100 MAIN RD",
    "dropmalcty": "AVERY ISLAND",
    "dropmalst": "LA",
    "dropmalzpp": 705139998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373644485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23354",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "3009 RAY WEILAND DR",
    "dropdelcty": "BAKER",
    "dropdelst": "LA",
    "dropdelzpp": 707149998,
    "dropphyadd": "3009 RAY WEILAND DR",
    "dropphycty": "BAKER",
    "dropphyst": "LA",
    "dropphyzpp": 707149998,
    "dropmaladd": "3009 RAY WEILAND DR",
    "dropmalcty": "BAKER",
    "dropmalst": "LA",
    "dropmalzpp": 707149998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257753786,
    "dropfax": 2257744560
  },
  {
    "dcode": "D",
    "dropkey": "PY23355",
    "droptype": "D",
    "dropname": "BALDWIN",
    "dropdeladd": "604 MAIN ST",
    "dropdelcty": "BALDWIN",
    "dropdelst": "LA",
    "dropdelzpp": 705149998,
    "dropphyadd": "604 MAIN ST",
    "dropphycty": "BALDWIN",
    "dropphyst": "LA",
    "dropphyzpp": 705149998,
    "dropmaladd": "604 MAIN ST",
    "dropmalcty": "BALDWIN",
    "dropmalst": "LA",
    "dropmalzpp": 705149998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3379249150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23356",
    "droptype": "D",
    "dropname": "BALL",
    "dropdeladd": "5912 MONROE HWY",
    "dropdelcty": "BALL",
    "dropdelst": "LA",
    "dropdelzpp": 714053318,
    "dropphyadd": "5912 MONROE HWY",
    "dropphycty": "BALL",
    "dropphyst": "LA",
    "dropphyzpp": 714053318,
    "dropmaladd": "5912 MONROE HWY",
    "dropmalcty": "BALL",
    "dropmalst": "LA",
    "dropmalzpp": 714053318,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186410255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23360",
    "droptype": "D",
    "dropname": "BARATARIA",
    "dropdeladd": "4164 PRIVATEER BLVD",
    "dropdelcty": "BARATARIA",
    "dropdelst": "LA",
    "dropdelzpp": 700369998,
    "dropphyadd": "4164 PRIVATEER BLVD",
    "dropphycty": "BARATARIA",
    "dropphyst": "LA",
    "dropphyzpp": 700369998,
    "dropmaladd": "4164 PRIVATEER BLVD",
    "dropmalcty": "BARATARIA",
    "dropmalst": "LA",
    "dropmalzpp": 700369998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046890626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23365",
    "droptype": "D",
    "dropname": "BASILE",
    "dropdeladd": "1209 DIANE GAIL ST",
    "dropdelcty": "BASILE",
    "dropdelst": "LA",
    "dropdelzpp": 705155437,
    "dropphyadd": "1209 DIANE GAIL ST",
    "dropphycty": "BASILE",
    "dropphyst": "LA",
    "dropphyzpp": 705155437,
    "dropmaladd": "PO BOX 1500",
    "dropmalcty": "BASILE",
    "dropmalst": "LA",
    "dropmalzpp": 705159998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374325278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23366",
    "droptype": "D",
    "dropname": "BASKIN",
    "dropdeladd": "1179 HIGHWAY 15",
    "dropdelcty": "BASKIN",
    "dropdelst": "LA",
    "dropdelzpp": 712199998,
    "dropphyadd": "1179 HIGHWAY 15",
    "dropphycty": "BASKIN",
    "dropphyst": "LA",
    "dropphyzpp": 712199998,
    "dropmaladd": "1179 HIGHWAY 15",
    "dropmalcty": "BASKIN",
    "dropmalst": "LA",
    "dropmalzpp": 712199998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182483094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23367",
    "droptype": "D",
    "dropname": "BASTROP",
    "dropdeladd": "201 N WASHINGTON ST",
    "dropdelcty": "BASTROP",
    "dropdelst": "LA",
    "dropdelzpp": 712209998,
    "dropphyadd": "201 N WASHINGTON ST",
    "dropphycty": "BASTROP",
    "dropphyst": "LA",
    "dropphyzpp": 712209998,
    "dropmaladd": "201 N WASHINGTON ST",
    "dropmalcty": "BASTROP",
    "dropmalst": "LA",
    "dropmalzpp": 712209998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182832810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23368",
    "droptype": "D",
    "dropname": "BATCHELOR",
    "dropdeladd": "4992 LA HIGHWAY 1",
    "dropdelcty": "BATCHELOR",
    "dropdelst": "LA",
    "dropdelzpp": 707159998,
    "dropphyadd": "4992 LA HIGHWAY 1",
    "dropphycty": "BATCHELOR",
    "dropphyst": "LA",
    "dropphyzpp": 707159998,
    "dropmaladd": "4992 LA HIGHWAY 1",
    "dropmalcty": "BATCHELOR",
    "dropmalst": "LA",
    "dropmalzpp": 707159998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2254922811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23370",
    "droptype": "D",
    "dropname": "BATON ROUGE",
    "dropdeladd": "750 FLORIDA ST",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708019998,
    "dropphyadd": "750 FLORIDA ST",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708019998,
    "dropmaladd": "750 FLORIDA ST",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708019998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253391100,
    "dropfax": 2253391095
  },
  {
    "dcode": "D",
    "dropkey": "PY23385",
    "droptype": "D",
    "dropname": "BELCHER",
    "dropdeladd": "714 RAILROAD ST",
    "dropdelcty": "BELCHER",
    "dropdelst": "LA",
    "dropdelzpp": 710049998,
    "dropphyadd": "714 RAILROAD ST",
    "dropphycty": "BELCHER",
    "dropphyst": "LA",
    "dropphyzpp": 710049998,
    "dropmaladd": "714 RAILROAD ST",
    "dropmalcty": "BELCHER",
    "dropmalst": "LA",
    "dropmalzpp": 710049998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183784709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23386",
    "droptype": "D",
    "dropname": "BELL CITY",
    "dropdeladd": "7206 B ST",
    "dropdelcty": "BELL CITY",
    "dropdelst": "LA",
    "dropdelzpp": 706303904,
    "dropphyadd": "7206 B ST",
    "dropphycty": "BELL CITY",
    "dropphyst": "LA",
    "dropphyzpp": 706303904,
    "dropmaladd": "PO BOX 3000",
    "dropmalcty": "BELL CITY",
    "dropmalst": "LA",
    "dropmalzpp": 706309998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376223768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23387",
    "droptype": "D",
    "dropname": "BELLE CHASSE",
    "dropdeladd": "8710 HIGHWAY 23",
    "dropdelcty": "BELLE CHASSE",
    "dropdelst": "LA",
    "dropdelzpp": 700372228,
    "dropphyadd": "8710 HIGHWAY 23",
    "dropphycty": "BELLE CHASSE",
    "dropphyst": "LA",
    "dropphyzpp": 700372228,
    "dropmaladd": "8710 HIGHWAY 23",
    "dropmalcty": "BELLE CHASSE",
    "dropmalst": "LA",
    "dropmalzpp": 700372228,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043913130,
    "dropfax": 5044335154
  },
  {
    "dcode": "D",
    "dropkey": "PY23390",
    "droptype": "D",
    "dropname": "BELLE ROSE",
    "dropdeladd": "7101 HIGHWAY 1",
    "dropdelcty": "BELLE ROSE",
    "dropdelst": "LA",
    "dropdelzpp": 703419998,
    "dropphyadd": "7101 HIGHWAY 1",
    "dropphycty": "BELLE ROSE",
    "dropphyst": "LA",
    "dropphyzpp": 703419998,
    "dropmaladd": "7101 HIGHWAY 1",
    "dropmalcty": "BELLE ROSE",
    "dropmalst": "LA",
    "dropmalzpp": 703419998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2254731346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23394",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "9160 HIGHWAY 175",
    "dropdelcty": "BELMONT",
    "dropdelst": "LA",
    "dropdelzpp": 714069998,
    "dropphyadd": "9160 HIGHWAY 175",
    "dropphycty": "BELMONT",
    "dropphyst": "LA",
    "dropphyzpp": 714069998,
    "dropmaladd": "9160 HIGHWAY 175",
    "dropmalcty": "BELMONT",
    "dropmalst": "LA",
    "dropmalzpp": 714069998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182562912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23397",
    "droptype": "D",
    "dropname": "BENTLEY",
    "dropdeladd": "19497 HIGHWAY 167",
    "dropdelcty": "BENTLEY",
    "dropdelst": "LA",
    "dropdelzpp": 714079998,
    "dropphyadd": "19497 HIGHWAY 167",
    "dropphycty": "BENTLEY",
    "dropphyst": "LA",
    "dropphyzpp": 714079998,
    "dropmaladd": "19497 HIGHWAY 167",
    "dropmalcty": "BENTLEY",
    "dropmalst": "LA",
    "dropmalzpp": 714079998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188991536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23398",
    "droptype": "D",
    "dropname": "BENTON",
    "dropdeladd": "180 BURT BLVD",
    "dropdelcty": "BENTON",
    "dropdelst": "LA",
    "dropdelzpp": 710069998,
    "dropphyadd": "180 BURT BLVD",
    "dropphycty": "BENTON",
    "dropphyst": "LA",
    "dropphyzpp": 710069998,
    "dropmaladd": "180 BURT BLVD",
    "dropmalcty": "BENTON",
    "dropmalst": "LA",
    "dropmalzpp": 710069998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189652590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23400",
    "droptype": "D",
    "dropname": "BERNICE",
    "dropdeladd": "74 6TH ST",
    "dropdelcty": "BERNICE",
    "dropdelst": "LA",
    "dropdelzpp": 712229998,
    "dropphyadd": "74 6TH ST",
    "dropphycty": "BERNICE",
    "dropphyst": "LA",
    "dropphyzpp": 712229998,
    "dropmaladd": "74 6TH ST",
    "dropmalcty": "BERNICE",
    "dropmalst": "LA",
    "dropmalzpp": 712229998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182859744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23401",
    "droptype": "D",
    "dropname": "BERWICK",
    "dropdeladd": "101 GILMORE DR",
    "dropdelcty": "BERWICK",
    "dropdelst": "LA",
    "dropdelzpp": 703429998,
    "dropphyadd": "101 GILMORE DR",
    "dropphycty": "BERWICK",
    "dropphyst": "LA",
    "dropphyzpp": 703429998,
    "dropmaladd": "101 GILMORE DR",
    "dropmalcty": "BERWICK",
    "dropmalst": "LA",
    "dropmalzpp": 703429998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853849255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23402",
    "droptype": "D",
    "dropname": "BETHANY",
    "dropdeladd": "10085 HIGHWAY 79",
    "dropdelcty": "BETHANY",
    "dropdelst": "LA",
    "dropdelzpp": 710079998,
    "dropphyadd": "10085 HIGHWAY 79",
    "dropphycty": "BETHANY",
    "dropphyst": "LA",
    "dropphyzpp": 710079998,
    "dropmaladd": "10085 HIGHWAY 79",
    "dropmalcty": "BETHANY",
    "dropmalst": "LA",
    "dropmalzpp": 710079998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189385319,
    "dropfax": 3189385319
  },
  {
    "dcode": "D",
    "dropkey": "PY23405",
    "droptype": "D",
    "dropname": "BIENVILLE",
    "dropdeladd": "25549 HIGHWAY 9",
    "dropdelcty": "BIENVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 710089998,
    "dropphyadd": "25549 HIGHWAY 9",
    "dropphycty": "BIENVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 710089998,
    "dropmaladd": "25549 HIGHWAY 9",
    "dropmalcty": "BIENVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 710089998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183857998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23415",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "LA",
    "dropdelzpp": 710099998,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "BLANCHARD",
    "dropphyst": "LA",
    "dropphyzpp": 710099998,
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "LA",
    "dropmalzpp": 710099998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189294021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23421",
    "droptype": "D",
    "dropname": "BOGALUSA",
    "dropdeladd": "305 AVENUE B",
    "dropdelcty": "BOGALUSA",
    "dropdelst": "LA",
    "dropdelzpp": 704279998,
    "dropphyadd": "305 AVENUE B",
    "dropphycty": "BOGALUSA",
    "dropphyst": "LA",
    "dropphyzpp": 704279998,
    "dropmaladd": "305 AVENUE B",
    "dropmalcty": "BOGALUSA",
    "dropmalst": "LA",
    "dropmalzpp": 704279998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045891255,
    "dropfax": 9857320285
  },
  {
    "dcode": "D",
    "dropkey": "PY23425",
    "droptype": "D",
    "dropname": "BONITA",
    "dropdeladd": "15392 BONITA AVE",
    "dropdelcty": "BONITA",
    "dropdelst": "LA",
    "dropdelzpp": 712239998,
    "dropphyadd": "15392 BONITA AVE",
    "dropphycty": "BONITA",
    "dropphyst": "LA",
    "dropphyzpp": 712239998,
    "dropmaladd": "15392 BONITA AVE",
    "dropmalcty": "BONITA",
    "dropmalst": "LA",
    "dropmalzpp": 712239998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188234560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23428",
    "droptype": "D",
    "dropname": "BORDELONVILLE",
    "dropdeladd": "4416 HIGHWAY 451",
    "dropdelcty": "BORDELONVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713209998,
    "dropphyadd": "4416 HIGHWAY 451",
    "dropphycty": "BORDELONVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713209998,
    "dropmaladd": "4416 HIGHWAY 451",
    "dropmalcty": "BORDELONVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713209998,
    "dropsitphn": 3186672295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189972515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23432",
    "droptype": "D",
    "dropname": "BOSSIER CITY",
    "dropdeladd": "150 BENTON RD",
    "dropdelcty": "BOSSIER CITY",
    "dropdelst": "LA",
    "dropdelzpp": 711114751,
    "dropphyadd": "150 BENTON RD",
    "dropphycty": "BOSSIER CITY",
    "dropphyst": "LA",
    "dropphyzpp": 711114751,
    "dropmaladd": "150 BENTON RD",
    "dropmalcty": "BOSSIER CITY",
    "dropmalst": "LA",
    "dropmalzpp": 711114751,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187467926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23434",
    "droptype": "D",
    "dropname": "BOURG",
    "dropdeladd": "3806 COUNTRY DR",
    "dropdelcty": "BOURG",
    "dropdelst": "LA",
    "dropdelzpp": 703439998,
    "dropphyadd": "3806 COUNTRY DR",
    "dropphycty": "BOURG",
    "dropphyst": "LA",
    "dropphyzpp": 703439998,
    "dropmaladd": "3806 COUNTRY DR",
    "dropmalcty": "BOURG",
    "dropmalst": "LA",
    "dropmalzpp": 703439998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9859170496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23435",
    "droptype": "D",
    "dropname": "BOUTTE",
    "dropdeladd": "13322 HIGHWAY 90",
    "dropdelcty": "BOUTTE",
    "dropdelst": "LA",
    "dropdelzpp": 700399998,
    "dropphyadd": "13322 HIGHWAY 90",
    "dropphycty": "BOUTTE",
    "dropphyst": "LA",
    "dropphyzpp": 700399998,
    "dropmaladd": "13322 HIGHWAY 90",
    "dropmalcty": "BOUTTE",
    "dropmalst": "LA",
    "dropmalzpp": 700399998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857855296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23436",
    "droptype": "D",
    "dropname": "BOYCE",
    "dropdeladd": "95 PACIFIC AVE",
    "dropdelcty": "BOYCE",
    "dropdelst": "LA",
    "dropdelzpp": 714099998,
    "dropphyadd": "95 PACIFIC AVE",
    "dropphycty": "BOYCE",
    "dropphyst": "LA",
    "dropphyzpp": 714099998,
    "dropmaladd": "95 PACIFIC AVE",
    "dropmalcty": "BOYCE",
    "dropmalst": "LA",
    "dropmalzpp": 714099998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187934636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23437",
    "droptype": "D",
    "dropname": "BRAITHWAITE",
    "dropdeladd": "2729 ENGLISH TURN RD",
    "dropdelcty": "BRAITHWAITE",
    "dropdelst": "LA",
    "dropdelzpp": 700409998,
    "dropphyadd": "2729 ENGLISH TURN RD",
    "dropphycty": "BRAITHWAITE",
    "dropphyst": "LA",
    "dropphyzpp": 700409998,
    "dropmaladd": "2729 ENGLISH TURN RD",
    "dropmalcty": "BRAITHWAITE",
    "dropmalst": "LA",
    "dropmalzpp": 700409998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042784967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23438",
    "droptype": "D",
    "dropname": "BRANCH",
    "dropdeladd": "7031 CHURCH POINT HWY",
    "dropdelcty": "BRANCH",
    "dropdelst": "LA",
    "dropdelzpp": 705163640,
    "dropphyadd": "7031 CHURCH POINT HWY",
    "dropphycty": "BRANCH",
    "dropphyst": "LA",
    "dropphyzpp": 705163640,
    "dropmaladd": "7031 CHURCH POINT HWY",
    "dropmalcty": "BRANCH",
    "dropmalst": "LA",
    "dropmalzpp": 705163640,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373343578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23440",
    "droptype": "D",
    "dropname": "BREAUX BRIDGE",
    "dropdeladd": "700 REES ST",
    "dropdelcty": "BREAUX BRIDGE",
    "dropdelst": "LA",
    "dropdelzpp": 705174618,
    "dropphyadd": "700 REES ST",
    "dropphycty": "BREAUX BRIDGE",
    "dropphyst": "LA",
    "dropphyzpp": 705174618,
    "dropmaladd": "700 REES ST",
    "dropmalcty": "BREAUX BRIDGE",
    "dropmalst": "LA",
    "dropmalzpp": 705179998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373320961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23443",
    "droptype": "D",
    "dropname": "BRITTANY",
    "dropdeladd": "1830 E HIGHWAY 30",
    "dropdelcty": "BRITTANY",
    "dropdelst": "LA",
    "dropdelzpp": 707189998,
    "dropphyadd": "1830 E HIGHWAY 30",
    "dropphycty": "BRITTANY",
    "dropphyst": "LA",
    "dropphyzpp": 707189998,
    "dropmaladd": "1830 E HIGHWAY 30",
    "dropmalcty": "BRITTANY",
    "dropmalst": "LA",
    "dropmalzpp": 707189998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256440682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23448",
    "droptype": "D",
    "dropname": "BROUSSARD",
    "dropdeladd": "4200 HIGHWAY 90 E",
    "dropdelcty": "BROUSSARD",
    "dropdelst": "LA",
    "dropdelzpp": 705183408,
    "dropphyadd": "4200 HIGHWAY 90 E",
    "dropphycty": "BROUSSARD",
    "dropphyst": "LA",
    "dropphyzpp": 705183408,
    "dropmaladd": "4200 HIGHWAY 90 E",
    "dropmalcty": "BROUSSARD",
    "dropmalst": "LA",
    "dropmalzpp": 705183408,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378390343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23453",
    "droptype": "D",
    "dropname": "BRUSLY",
    "dropdeladd": "315 E MAIN ST",
    "dropdelcty": "BRUSLY",
    "dropdelst": "LA",
    "dropdelzpp": 707199998,
    "dropphyadd": "315 E MAIN ST",
    "dropphycty": "BRUSLY",
    "dropphyst": "LA",
    "dropphyzpp": 707199998,
    "dropmaladd": "315 E MAIN ST",
    "dropmalcty": "BRUSLY",
    "dropmalst": "LA",
    "dropmalzpp": 707199998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257497688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23458",
    "droptype": "D",
    "dropname": "BUNKIE",
    "dropdeladd": "116 W MAGNOLIA ST",
    "dropdelcty": "BUNKIE",
    "dropdelst": "LA",
    "dropdelzpp": 713229998,
    "dropphyadd": "116 W MAGNOLIA ST",
    "dropphycty": "BUNKIE",
    "dropphyst": "LA",
    "dropphyzpp": 713229998,
    "dropmaladd": "116 W MAGNOLIA ST",
    "dropmalcty": "BUNKIE",
    "dropmalst": "LA",
    "dropmalzpp": 713229998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183468133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23459",
    "droptype": "D",
    "dropname": "BURAS",
    "dropdeladd": "37823 HIGHWAY 23",
    "dropdelcty": "BURAS",
    "dropdelst": "LA",
    "dropdelzpp": 700415807,
    "dropphyadd": "37823 HIGHWAY 23",
    "dropphycty": "BURAS",
    "dropphyst": "LA",
    "dropphyzpp": 700415807,
    "dropmaladd": "37823 HIGHWAY 23",
    "dropmalcty": "BURAS",
    "dropmalst": "LA",
    "dropmalzpp": 700415807,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046576198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23464",
    "droptype": "D",
    "dropname": "BUSH",
    "dropdeladd": "81880 HIGHWAY 41",
    "dropdelcty": "BUSH",
    "dropdelst": "LA",
    "dropdelzpp": 704319998,
    "dropphyadd": "81880 HIGHWAY 41",
    "dropphycty": "BUSH",
    "dropphyst": "LA",
    "dropphyzpp": 704319998,
    "dropmaladd": "81880 HIGHWAY 41",
    "dropmalcty": "BUSH",
    "dropmalst": "LA",
    "dropmalzpp": 704319998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858863423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23472",
    "droptype": "D",
    "dropname": "CADE",
    "dropdeladd": "1597 OLD SPANISH TRL",
    "dropdelcty": "CADE",
    "dropdelst": "LA",
    "dropdelzpp": 705199998,
    "dropphyadd": "1597 OLD SPANISH TRL",
    "dropphycty": "CADE",
    "dropphyst": "LA",
    "dropphyzpp": 705199998,
    "dropmaladd": "1597 OLD SPANISH TRL",
    "dropmalcty": "CADE",
    "dropmalst": "LA",
    "dropmalzpp": 705199998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373648100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23477",
    "droptype": "D",
    "dropname": "CALHOUN",
    "dropdeladd": "3136 HIGHWAY 80 W",
    "dropdelcty": "CALHOUN",
    "dropdelst": "LA",
    "dropdelzpp": 712259998,
    "dropphyadd": "3136 HIGHWAY 80 W",
    "dropphycty": "CALHOUN",
    "dropphyst": "LA",
    "dropphyzpp": 712259998,
    "dropmaladd": "3136 HIGHWAY 80 W",
    "dropmalcty": "CALHOUN",
    "dropmalst": "LA",
    "dropmalzpp": 712259998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186441619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23480",
    "droptype": "D",
    "dropname": "CALVIN",
    "dropdeladd": "279 3RD ST",
    "dropdelcty": "CALVIN",
    "dropdelst": "LA",
    "dropdelzpp": 714109998,
    "dropphyadd": "279 3RD ST",
    "dropphycty": "CALVIN",
    "dropphyst": "LA",
    "dropphyzpp": 714109998,
    "dropmaladd": "279 3RD ST",
    "dropmalcty": "CALVIN",
    "dropmalst": "LA",
    "dropmalzpp": 714109998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187279386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23482",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "144 ADAM ROUX ST",
    "dropdelcty": "CAMERON",
    "dropdelst": "LA",
    "dropdelzpp": 706319998,
    "dropphyadd": "144 ADAM ROUX ST",
    "dropphycty": "CAMERON",
    "dropphyst": "LA",
    "dropphyzpp": 706319998,
    "dropmaladd": "144 ADAM ROUX ST",
    "dropmalcty": "CAMERON",
    "dropmalst": "LA",
    "dropmalzpp": 706319998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377753870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23487",
    "droptype": "D",
    "dropname": "CAMPTI",
    "dropdeladd": "3070 HIGHWAY 71",
    "dropdelcty": "CAMPTI",
    "dropdelst": "LA",
    "dropdelzpp": 714119998,
    "dropphyadd": "3070 HIGHWAY 71",
    "dropphycty": "CAMPTI",
    "dropphyst": "LA",
    "dropphyzpp": 714119998,
    "dropmaladd": "3070 HIGHWAY 71",
    "dropmalcty": "CAMPTI",
    "dropmalst": "LA",
    "dropmalzpp": 714119998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184763077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23492",
    "droptype": "D",
    "dropname": "CARENCRO",
    "dropdeladd": "809 VETERANS DR",
    "dropdelcty": "CARENCRO",
    "dropdelst": "LA",
    "dropdelzpp": 705209998,
    "dropphyadd": "809 VETERANS DR",
    "dropphycty": "CARENCRO",
    "dropphyst": "LA",
    "dropphyzpp": 705209998,
    "dropmaladd": "809 VETERANS DR",
    "dropmalcty": "CARENCRO",
    "dropmalst": "LA",
    "dropmalzpp": 705209998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378967898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23498",
    "droptype": "D",
    "dropname": "CARVILLE",
    "dropdeladd": "5715 HIGHWAY 75",
    "dropdelcty": "CARVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 707219998,
    "dropphyadd": "5715 HIGHWAY 75",
    "dropphycty": "CARVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 707219998,
    "dropmaladd": "5715 HIGHWAY 75",
    "dropmalcty": "CARVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 707219998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256422046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23501",
    "droptype": "D",
    "dropname": "CASTOR",
    "dropdeladd": "8992 HIGHWAY 4",
    "dropdelcty": "CASTOR",
    "dropdelst": "LA",
    "dropdelzpp": 710169998,
    "dropphyadd": "8992 HIGHWAY 4",
    "dropphycty": "CASTOR",
    "dropphyst": "LA",
    "dropphyzpp": 710169998,
    "dropmaladd": "8992 HIGHWAY 4",
    "dropmalcty": "CASTOR",
    "dropmalst": "LA",
    "dropmalzpp": 710169998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185442521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23507",
    "droptype": "D",
    "dropname": "CECILIA",
    "dropdeladd": "2224 BUSHVILLE HWY",
    "dropdelcty": "CECILIA",
    "dropdelst": "LA",
    "dropdelzpp": 705213000,
    "dropphyadd": "2224 BUSHVILLE HWY",
    "dropphycty": "CECILIA",
    "dropphyst": "LA",
    "dropphyzpp": 705213000,
    "dropmaladd": "PO BOX 2100",
    "dropmalcty": "CECILIA",
    "dropmalst": "LA",
    "dropmalzpp": 705219998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376676765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23511",
    "droptype": "D",
    "dropname": "CENTER POINT",
    "dropdeladd": "1006 HIGHWAY 107",
    "dropdelcty": "CENTER POINT",
    "dropdelst": "LA",
    "dropdelzpp": 713239998,
    "dropphyadd": "1006 HIGHWAY 107",
    "dropphycty": "CENTER POINT",
    "dropphyst": "LA",
    "dropphyzpp": 713239998,
    "dropmaladd": "1006 HIGHWAY 107",
    "dropmalcty": "CENTER POINT",
    "dropmalst": "LA",
    "dropmalzpp": 713239998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182534092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23513",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "303 SENETTE ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705229998,
    "dropphyadd": "303 SENETTE ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705229998,
    "dropmaladd": "303 SENETTE ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705229998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378369981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23517",
    "droptype": "D",
    "dropname": "CHALMETTE",
    "dropdeladd": "3340 PARIS RD",
    "dropdelcty": "CHALMETTE",
    "dropdelst": "LA",
    "dropdelzpp": 700439998,
    "dropphyadd": "3340 PARIS RD",
    "dropphycty": "CHALMETTE",
    "dropphyst": "LA",
    "dropphyzpp": 700439998,
    "dropmaladd": "3340 PARIS RD",
    "dropmalcty": "CHALMETTE",
    "dropmalst": "LA",
    "dropmalzpp": 700439998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042713140,
    "dropfax": 5042771863
  },
  {
    "dcode": "D",
    "dropkey": "PY23520",
    "droptype": "D",
    "dropname": "CHARENTON",
    "dropdeladd": "2848 CHITIMACHA TRL",
    "dropdelcty": "CHARENTON",
    "dropdelst": "LA",
    "dropdelzpp": 705233000,
    "dropphyadd": "2848 CHITIMACHA TRL",
    "dropphycty": "CHARENTON",
    "dropphyst": "LA",
    "dropphyzpp": 705233000,
    "dropmaladd": "PO BOX 2300",
    "dropmalcty": "CHARENTON",
    "dropmalst": "LA",
    "dropmalzpp": 705239998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3379236896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23522",
    "droptype": "D",
    "dropname": "CHASE",
    "dropdeladd": "120 FEED MILL RD",
    "dropdelcty": "CHASE",
    "dropdelst": "LA",
    "dropdelzpp": 713249998,
    "dropphyadd": "120 FEED MILL RD",
    "dropphycty": "CHASE",
    "dropphyst": "LA",
    "dropphyzpp": 713249998,
    "dropmaladd": "120 FEED MILL RD",
    "dropmalcty": "CHASE",
    "dropmalst": "LA",
    "dropmalzpp": 713249998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184359807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23523",
    "droptype": "D",
    "dropname": "CHATAIGNIER",
    "dropdeladd": "113 FIRST ST",
    "dropdelcty": "CHATAIGNIER",
    "dropdelst": "LA",
    "dropdelzpp": 705249998,
    "dropphyadd": "113 FIRST ST",
    "dropphycty": "CHATAIGNIER",
    "dropphyst": "LA",
    "dropphyzpp": 705249998,
    "dropmaladd": "113 FIRST ST",
    "dropmalcty": "CHATAIGNIER",
    "dropmalst": "LA",
    "dropmalzpp": 705249998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378855414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23524",
    "droptype": "D",
    "dropname": "CHATHAM",
    "dropdeladd": "6561 HIGHWAY 34",
    "dropdelcty": "CHATHAM",
    "dropdelst": "LA",
    "dropdelzpp": 712269998,
    "dropphyadd": "6561 HIGHWAY 34",
    "dropphycty": "CHATHAM",
    "dropphyst": "LA",
    "dropphyzpp": 712269998,
    "dropmaladd": "6561 HIGHWAY 34",
    "dropmalcty": "CHATHAM",
    "dropmalst": "LA",
    "dropmalzpp": 712269998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182492957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23525",
    "droptype": "D",
    "dropname": "CHAUVIN",
    "dropdeladd": "5106 HIGHWAY 56",
    "dropdelcty": "CHAUVIN",
    "dropdelst": "LA",
    "dropdelzpp": 703449998,
    "dropphyadd": "5106 HIGHWAY 56",
    "dropphycty": "CHAUVIN",
    "dropphyst": "LA",
    "dropphyzpp": 703449998,
    "dropmaladd": "5106 HIGHWAY 56",
    "dropmalcty": "CHAUVIN",
    "dropmalst": "LA",
    "dropmalzpp": 703449998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855949473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23528",
    "droptype": "D",
    "dropname": "CHENEYVILLE",
    "dropdeladd": "202 KLOCK ST",
    "dropdelcty": "CHENEYVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713259998,
    "dropphyadd": "202 KLOCK ST",
    "dropphycty": "CHENEYVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713259998,
    "dropmaladd": "202 KLOCK ST",
    "dropmalcty": "CHENEYVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713259998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182792501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23537",
    "droptype": "D",
    "dropname": "CHOUDRANT",
    "dropdeladd": "2586 HIGHWAY 80",
    "dropdelcty": "CHOUDRANT",
    "dropdelst": "LA",
    "dropdelzpp": 712279998,
    "dropphyadd": "2586 HIGHWAY 80",
    "dropphycty": "CHOUDRANT",
    "dropphyst": "LA",
    "dropphyzpp": 712279998,
    "dropmaladd": "2586 HIGHWAY 80",
    "dropmalcty": "CHOUDRANT",
    "dropmalst": "LA",
    "dropmalzpp": 712279998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187685004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23539",
    "droptype": "D",
    "dropname": "CHURCH POINT",
    "dropdeladd": "739 S MAIN ST",
    "dropdelcty": "CHURCH POINT",
    "dropdelst": "LA",
    "dropdelzpp": 705259998,
    "dropphyadd": "739 S MAIN ST",
    "dropphycty": "CHURCH POINT",
    "dropphyst": "LA",
    "dropphyzpp": 705259998,
    "dropmaladd": "739 S MAIN ST",
    "dropmalcty": "CHURCH POINT",
    "dropmalst": "LA",
    "dropmalzpp": 705259998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376840175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23544",
    "droptype": "D",
    "dropname": "CLARENCE",
    "dropdeladd": "5978 HIGHWAY 71",
    "dropdelcty": "CLARENCE",
    "dropdelst": "LA",
    "dropdelzpp": 714149998,
    "dropphyadd": "5978 HIGHWAY 71",
    "dropphycty": "CLARENCE",
    "dropphyst": "LA",
    "dropphyzpp": 714149998,
    "dropmaladd": "5978 HIGHWAY 71",
    "dropmalcty": "CLARENCE",
    "dropmalst": "LA",
    "dropmalzpp": 714149998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183578634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23545",
    "droptype": "D",
    "dropname": "CLARKS",
    "dropdeladd": "1710 HIGHWAY 845",
    "dropdelcty": "CLARKS",
    "dropdelst": "LA",
    "dropdelzpp": 714159998,
    "dropphyadd": "1710 HIGHWAY 845",
    "dropphycty": "CLARKS",
    "dropphyst": "LA",
    "dropphyzpp": 714159998,
    "dropmaladd": "1710 HIGHWAY 845",
    "dropmalcty": "CLARKS",
    "dropmalst": "LA",
    "dropmalzpp": 714159998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186496180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23546",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "31449 HIGHWAY 15",
    "dropdelcty": "CLAYTON",
    "dropdelst": "LA",
    "dropdelzpp": 713269998,
    "dropphyadd": "31449 HIGHWAY 15",
    "dropphycty": "CLAYTON",
    "dropphyst": "LA",
    "dropphyzpp": 713269998,
    "dropmaladd": "31449 HIGHWAY 15",
    "dropmalcty": "CLAYTON",
    "dropmalst": "LA",
    "dropmalzpp": 713269998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187574907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23551",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "10497 PLANK RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "LA",
    "dropdelzpp": 707229998,
    "dropphyadd": "10497 PLANK RD",
    "dropphycty": "CLINTON",
    "dropphyst": "LA",
    "dropphyzpp": 707229998,
    "dropmaladd": "10497 PLANK RD",
    "dropmalcty": "CLINTON",
    "dropmalst": "LA",
    "dropmalzpp": 707229998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256836016,
    "dropfax": 2256833217
  },
  {
    "dcode": "D",
    "dropkey": "PY23552",
    "droptype": "D",
    "dropname": "CLOUTIERVILLE",
    "dropdeladd": "14904 HIGHWAY 1",
    "dropdelcty": "CLOUTIERVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 714169998,
    "dropphyadd": "14904 HIGHWAY 1",
    "dropphycty": "CLOUTIERVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 714169998,
    "dropmaladd": "14904 HIGHWAY 1",
    "dropmalcty": "CLOUTIERVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 714169998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183798912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23556",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "707 8TH ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "LA",
    "dropdelzpp": 714179998,
    "dropphyadd": "707 8TH ST",
    "dropphycty": "COLFAX",
    "dropphyst": "LA",
    "dropphyzpp": 714179998,
    "dropmaladd": "707 8TH ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "LA",
    "dropmalzpp": 714179998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186275300,
    "dropfax": 3183101025
  },
  {
    "dcode": "D",
    "dropkey": "PY23558",
    "droptype": "D",
    "dropname": "COLLINSTON",
    "dropdeladd": "4603 MAIN ST",
    "dropdelcty": "COLLINSTON",
    "dropdelst": "LA",
    "dropdelzpp": 712299998,
    "dropphyadd": "4603 MAIN ST",
    "dropphycty": "COLLINSTON",
    "dropphyst": "LA",
    "dropphyzpp": 712299998,
    "dropmaladd": "4603 MAIN ST",
    "dropmalcty": "COLLINSTON",
    "dropmalst": "LA",
    "dropmalzpp": 712299998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188749060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23560",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "305 WALL ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "LA",
    "dropdelzpp": 714189998,
    "dropphyadd": "305 WALL ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "LA",
    "dropphyzpp": 714189998,
    "dropmaladd": "305 WALL ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "LA",
    "dropmalzpp": 714189998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186493858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23569",
    "droptype": "D",
    "dropname": "CONVENT",
    "dropdeladd": "6574 LA 44",
    "dropdelcty": "CONVENT",
    "dropdelst": "LA",
    "dropdelzpp": 707239998,
    "dropphyadd": "6574 LA 44",
    "dropphycty": "CONVENT",
    "dropphyst": "LA",
    "dropphyzpp": 707239998,
    "dropmaladd": "6574 LA 44",
    "dropmalcty": "CONVENT",
    "dropmalst": "LA",
    "dropmalzpp": 707239998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2255620875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23570",
    "droptype": "D",
    "dropname": "CONVERSE",
    "dropdeladd": "308 W PORT ARTHUR AVE",
    "dropdelcty": "CONVERSE",
    "dropdelst": "LA",
    "dropdelzpp": 714199998,
    "dropphyadd": "308 W PORT ARTHUR AVE",
    "dropphycty": "CONVERSE",
    "dropphyst": "LA",
    "dropphyzpp": 714199998,
    "dropmaladd": "308 W PORT ARTHUR AVE",
    "dropmalcty": "CONVERSE",
    "dropmalst": "LA",
    "dropmalzpp": 714199998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185673975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23578",
    "droptype": "D",
    "dropname": "COTTON VALLEY",
    "dropdeladd": "439 RESIDENT ST",
    "dropdelcty": "COTTON VALLEY",
    "dropdelst": "LA",
    "dropdelzpp": 710189998,
    "dropphyadd": "439 RESIDENT ST",
    "dropphycty": "COTTON VALLEY",
    "dropphyst": "LA",
    "dropphyzpp": 710189998,
    "dropmaladd": "439 RESIDENT ST",
    "dropmalcty": "COTTON VALLEY",
    "dropmalst": "LA",
    "dropmalzpp": 710189998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188324539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23579",
    "droptype": "D",
    "dropname": "COTTONPORT",
    "dropdeladd": "955 SYCAMORE ST",
    "dropdelcty": "COTTONPORT",
    "dropdelst": "LA",
    "dropdelzpp": 713279998,
    "dropphyadd": "955 SYCAMORE ST",
    "dropphycty": "COTTONPORT",
    "dropphyst": "LA",
    "dropphyzpp": 713279998,
    "dropmaladd": "955 SYCAMORE ST",
    "dropmalcty": "COTTONPORT",
    "dropmalst": "LA",
    "dropmalzpp": 713279998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188763160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23580",
    "droptype": "D",
    "dropname": "COUSHATTA",
    "dropdeladd": "5036 CUT OFF RD",
    "dropdelcty": "COUSHATTA",
    "dropdelst": "LA",
    "dropdelzpp": 710199998,
    "dropphyadd": "5036 CUT OFF RD",
    "dropphycty": "COUSHATTA",
    "dropphyst": "LA",
    "dropphyzpp": 710199998,
    "dropmaladd": "5036 CUT OFF RD",
    "dropmalcty": "COUSHATTA",
    "dropmalst": "LA",
    "dropmalzpp": 710199998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189329651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23581",
    "droptype": "D",
    "dropname": "COVINGTON",
    "dropdeladd": "1775 N COLUMBIA ST",
    "dropdelcty": "COVINGTON",
    "dropdelst": "LA",
    "dropdelzpp": 704339998,
    "dropphyadd": "1775 N COLUMBIA ST",
    "dropphycty": "COVINGTON",
    "dropphyst": "LA",
    "dropphyzpp": 704339998,
    "dropmaladd": "1775 N COLUMBIA ST",
    "dropmalcty": "COVINGTON",
    "dropmalst": "LA",
    "dropmalzpp": 704339998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858936896,
    "dropfax": 9858929219
  },
  {
    "dcode": "D",
    "dropkey": "PY23588",
    "droptype": "D",
    "dropname": "CROWLEY",
    "dropdeladd": "123 E 3RD ST",
    "dropdelcty": "CROWLEY",
    "dropdelst": "LA",
    "dropdelzpp": 705265135,
    "dropphyadd": "123 E 3RD ST",
    "dropphycty": "CROWLEY",
    "dropphyst": "LA",
    "dropphyzpp": 705265135,
    "dropmaladd": "123 E 3RD ST",
    "dropmalcty": "CROWLEY",
    "dropmalst": "LA",
    "dropmalzpp": 705269998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377832344,
    "dropfax": 3377838254
  },
  {
    "dcode": "D",
    "dropkey": "PY23590",
    "droptype": "D",
    "dropname": "CROWVILLE",
    "dropdeladd": "5342 HIGHWAY 17",
    "dropdelcty": "CROWVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 712309998,
    "dropphyadd": "5342 HIGHWAY 17",
    "dropphycty": "CROWVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 712309998,
    "dropmaladd": "5342 HIGHWAY 17",
    "dropmalcty": "CROWVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 712309998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187226528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23591",
    "droptype": "D",
    "dropname": "CULLEN",
    "dropdeladd": "511 COYLE AVE",
    "dropdelcty": "CULLEN",
    "dropdelst": "LA",
    "dropdelzpp": 710219998,
    "dropphyadd": "511 COYLE AVE",
    "dropphycty": "CULLEN",
    "dropphyst": "LA",
    "dropphyzpp": 710219998,
    "dropmaladd": "511 COYLE AVE",
    "dropmalcty": "CULLEN",
    "dropmalst": "LA",
    "dropmalzpp": 710219998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189942362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23594",
    "droptype": "D",
    "dropname": "CUT OFF",
    "dropdeladd": "16130 W MAIN ST",
    "dropdelcty": "CUT OFF",
    "dropdelst": "LA",
    "dropdelzpp": 703459998,
    "dropphyadd": "16130 W MAIN ST",
    "dropphycty": "CUT OFF",
    "dropphyst": "LA",
    "dropphyzpp": 703459998,
    "dropmaladd": "16130 W MAIN ST",
    "dropmalcty": "CUT OFF",
    "dropmalst": "LA",
    "dropmalzpp": 703459998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856322353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23600",
    "droptype": "D",
    "dropname": "DARROW",
    "dropdeladd": "37142 HIGHWAY 22",
    "dropdelcty": "DARROW",
    "dropdelst": "LA",
    "dropdelzpp": 707259998,
    "dropphyadd": "37142 HIGHWAY 22",
    "dropphycty": "DARROW",
    "dropphyst": "LA",
    "dropphyzpp": 707259998,
    "dropmaladd": "37142 HIGHWAY 22",
    "dropmalcty": "DARROW",
    "dropmalst": "LA",
    "dropmalzpp": 707259998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257469609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23607",
    "droptype": "D",
    "dropname": "DELCAMBRE",
    "dropdeladd": "106 W HIGHWAY 14",
    "dropdelcty": "DELCAMBRE",
    "dropdelst": "LA",
    "dropdelzpp": 705282422,
    "dropphyadd": "106 W HIGHWAY 14",
    "dropphycty": "DELCAMBRE",
    "dropphyst": "LA",
    "dropphyzpp": 705282422,
    "dropmaladd": "106 W HIGHWAY 14",
    "dropmalcty": "DELCAMBRE",
    "dropmalst": "LA",
    "dropmalzpp": 705289998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376851424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23608",
    "droptype": "D",
    "dropname": "DELHI",
    "dropdeladd": "711 BROADWAY ST",
    "dropdelcty": "DELHI",
    "dropdelst": "LA",
    "dropdelzpp": 712329998,
    "dropphyadd": "711 BROADWAY ST",
    "dropphycty": "DELHI",
    "dropphyst": "LA",
    "dropphyzpp": 712329998,
    "dropmaladd": "711 BROADWAY ST",
    "dropmalcty": "DELHI",
    "dropmalst": "LA",
    "dropmalzpp": 712329998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188780619,
    "dropfax": 3188786622
  },
  {
    "dcode": "D",
    "dropkey": "PY23609",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "200 OUACHITA AVE",
    "dropdelcty": "DELTA",
    "dropdelst": "LA",
    "dropdelzpp": 712339998,
    "dropphyadd": "200 OUACHITA AVE",
    "dropphycty": "DELTA",
    "dropphyst": "LA",
    "dropphyzpp": 712339998,
    "dropmaladd": "200 OUACHITA AVE",
    "dropmalcty": "DELTA",
    "dropmalst": "LA",
    "dropmalzpp": 712339998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186339635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23611",
    "droptype": "D",
    "dropname": "DENHAM SPRINGS",
    "dropdeladd": "140 DEL ORLEANS AVE",
    "dropdelcty": "DENHAM SPRINGS",
    "dropdelst": "LA",
    "dropdelzpp": 707269998,
    "dropphyadd": "140 DEL ORLEANS AVE",
    "dropphycty": "DENHAM SPRINGS",
    "dropphyst": "LA",
    "dropphyzpp": 707269998,
    "dropmaladd": "140 DEL ORLEANS AVE",
    "dropmalcty": "DENHAM SPRINGS",
    "dropmalst": "LA",
    "dropmalzpp": 707269998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256650528,
    "dropfax": 2256649074
  },
  {
    "dcode": "D",
    "dropkey": "PY23612",
    "droptype": "D",
    "dropname": "DEQUINCY",
    "dropdeladd": "215 COLLEGE ST",
    "dropdelcty": "DEQUINCY",
    "dropdelst": "LA",
    "dropdelzpp": 706333623,
    "dropphyadd": "215 COLLEGE ST",
    "dropphycty": "DEQUINCY",
    "dropphyst": "LA",
    "dropphyzpp": 706333623,
    "dropmaladd": "215 COLLEGE ST",
    "dropmalcty": "DEQUINCY",
    "dropmalst": "LA",
    "dropmalzpp": 706339998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377863027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23613",
    "droptype": "D",
    "dropname": "DERIDDER",
    "dropdeladd": "116 E 4TH ST",
    "dropdelcty": "DERIDDER",
    "dropdelst": "LA",
    "dropdelzpp": 706345010,
    "dropphyadd": "116 E 4TH ST",
    "dropphycty": "DERIDDER",
    "dropphyst": "LA",
    "dropphyzpp": 706345010,
    "dropmaladd": "116 E 4TH ST",
    "dropmalcty": "DERIDDER",
    "dropmalst": "LA",
    "dropmalzpp": 706345010,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374628852,
    "dropfax": 3374639665
  },
  {
    "dcode": "D",
    "dropkey": "PY23616",
    "droptype": "D",
    "dropname": "DES ALLEMANDS",
    "dropdeladd": "17242 HIGHWAY 90",
    "dropdelcty": "DES ALLEMANDS",
    "dropdelst": "LA",
    "dropdelzpp": 700309998,
    "dropphyadd": "17242 HIGHWAY 90",
    "dropphycty": "DES ALLEMANDS",
    "dropphyst": "LA",
    "dropphyzpp": 700309998,
    "dropmaladd": "17242 HIGHWAY 90",
    "dropmalcty": "DES ALLEMANDS",
    "dropmalst": "LA",
    "dropmalzpp": 700309998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857588506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23617",
    "droptype": "D",
    "dropname": "DESTREHAN",
    "dropdeladd": "13 PLANTATION RD",
    "dropdelcty": "DESTREHAN",
    "dropdelst": "LA",
    "dropdelzpp": 700479998,
    "dropphyadd": "13 PLANTATION RD",
    "dropphycty": "DESTREHAN",
    "dropphyst": "LA",
    "dropphyzpp": 700479998,
    "dropmaladd": "13 PLANTATION RD",
    "dropmalcty": "DESTREHAN",
    "dropmalst": "LA",
    "dropmalzpp": 700479998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857646985,
    "dropfax": 9857251976
  },
  {
    "dcode": "D",
    "dropkey": "PY23618",
    "droptype": "D",
    "dropname": "DEVILLE",
    "dropdeladd": "1264 HIGHWAY 115",
    "dropdelcty": "DEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713289998,
    "dropphyadd": "1264 HIGHWAY 115",
    "dropphycty": "DEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713289998,
    "dropmaladd": "1264 HIGHWAY 115",
    "dropmalcty": "DEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713289998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184663443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23622",
    "droptype": "D",
    "dropname": "DODSON",
    "dropdeladd": "104 GANSVILLE RD",
    "dropdelcty": "DODSON",
    "dropdelst": "LA",
    "dropdelzpp": 714229998,
    "dropphyadd": "104 GANSVILLE RD",
    "dropphycty": "DODSON",
    "dropphyst": "LA",
    "dropphyzpp": 714229998,
    "dropmaladd": "104 GANSVILLE RD",
    "dropmalcty": "DODSON",
    "dropmalst": "LA",
    "dropmalzpp": 714229998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186489725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23625",
    "droptype": "D",
    "dropname": "DONALDSONVILLE",
    "dropdeladd": "301 IBERVILLE ST",
    "dropdelcty": "DONALDSONVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 703469998,
    "dropphyadd": "301 IBERVILLE ST",
    "dropphycty": "DONALDSONVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 703469998,
    "dropmaladd": "301 IBERVILLE ST",
    "dropmalcty": "DONALDSONVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 703469998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2254737498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23632",
    "droptype": "D",
    "dropname": "DOWNSVILLE",
    "dropdeladd": "9507 HIGHWAY 145",
    "dropdelcty": "DOWNSVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 712349998,
    "dropphyadd": "9507 HIGHWAY 145",
    "dropphycty": "DOWNSVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 712349998,
    "dropmaladd": "9507 HIGHWAY 145",
    "dropmalcty": "DOWNSVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 712349998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189821197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23639",
    "droptype": "D",
    "dropname": "DOYLINE",
    "dropdeladd": "125 PILGRIM REST RD",
    "dropdelcty": "DOYLINE",
    "dropdelst": "LA",
    "dropdelzpp": 710239998,
    "dropphyadd": "125 PILGRIM REST RD",
    "dropphycty": "DOYLINE",
    "dropphyst": "LA",
    "dropphyzpp": 710239998,
    "dropmaladd": "125 PILGRIM REST RD",
    "dropmalcty": "DOYLINE",
    "dropmalst": "LA",
    "dropmalzpp": 710239998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187453269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23643",
    "droptype": "D",
    "dropname": "DRY CREEK",
    "dropdeladd": "8243 HIGHWAY 113",
    "dropdelcty": "DRY CREEK",
    "dropdelst": "LA",
    "dropdelzpp": 706373600,
    "dropphyadd": "8243 HIGHWAY 113",
    "dropphycty": "DRY CREEK",
    "dropphyst": "LA",
    "dropphyzpp": 706373600,
    "dropmaladd": "PO BOX 3700",
    "dropmalcty": "DRY CREEK",
    "dropmalst": "LA",
    "dropmalzpp": 706379998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373288670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23644",
    "droptype": "D",
    "dropname": "DRY PRONG",
    "dropdeladd": "605 FIRST ST",
    "dropdelcty": "DRY PRONG",
    "dropdelst": "LA",
    "dropdelzpp": 714239998,
    "dropphyadd": "605 FIRST ST",
    "dropphycty": "DRY PRONG",
    "dropphyst": "LA",
    "dropphyzpp": 714239998,
    "dropmaladd": "605 FIRST ST",
    "dropmalcty": "DRY PRONG",
    "dropmalst": "LA",
    "dropmalzpp": 714239998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188996050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23645",
    "droptype": "D",
    "dropname": "DUBACH",
    "dropdeladd": "1743 MCMULLEN ST",
    "dropdelcty": "DUBACH",
    "dropdelst": "LA",
    "dropdelzpp": 712359998,
    "dropphyadd": "1743 MCMULLEN ST",
    "dropphycty": "DUBACH",
    "dropphyst": "LA",
    "dropphyzpp": 712359998,
    "dropmaladd": "1743 MCMULLEN ST",
    "dropmalcty": "DUBACH",
    "dropmalst": "LA",
    "dropmalzpp": 712359998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187778014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23646",
    "droptype": "D",
    "dropname": "DUBBERLY",
    "dropdeladd": "3193 HIGHWAY 531",
    "dropdelcty": "DUBBERLY",
    "dropdelst": "LA",
    "dropdelzpp": 710249998,
    "dropphyadd": "3193 HIGHWAY 531",
    "dropphycty": "DUBBERLY",
    "dropphyst": "LA",
    "dropphyzpp": 710249998,
    "dropmaladd": "3193 HIGHWAY 531",
    "dropmalcty": "DUBBERLY",
    "dropmalst": "LA",
    "dropmalzpp": 710249998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183711610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23647",
    "droptype": "D",
    "dropname": "DULAC",
    "dropdeladd": "7661 GRAND CAILLOU RD",
    "dropdelcty": "DULAC",
    "dropdelst": "LA",
    "dropdelzpp": 703539998,
    "dropphyadd": "7661 GRAND CAILLOU RD",
    "dropphycty": "DULAC",
    "dropphyst": "LA",
    "dropphyzpp": 703539998,
    "dropmaladd": "7661 GRAND CAILLOU RD",
    "dropmalcty": "DULAC",
    "dropmalst": "LA",
    "dropmalzpp": 703539998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855637329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23650",
    "droptype": "D",
    "dropname": "DUPLESSIS",
    "dropdeladd": "39265 HIGHWAY 621",
    "dropdelcty": "DUPLESSIS",
    "dropdelst": "LA",
    "dropdelzpp": 707283000,
    "dropphyadd": "39265 HIGHWAY 621",
    "dropphycty": "DUPLESSIS",
    "dropphyst": "LA",
    "dropphyzpp": 707283000,
    "dropmaladd": "PO BOX 2800",
    "dropmalcty": "DUPLESSIS",
    "dropmalst": "LA",
    "dropmalzpp": 707289998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256442694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23651",
    "droptype": "D",
    "dropname": "DUPONT",
    "dropdeladd": "5735 HIGHWAY 107 S",
    "dropdelcty": "DUPONT",
    "dropdelst": "LA",
    "dropdelzpp": 713299998,
    "dropphyadd": "5735 HIGHWAY 107 S",
    "dropphycty": "DUPONT",
    "dropphyst": "LA",
    "dropphyzpp": 713299998,
    "dropmaladd": "5735 HIGHWAY 107 S",
    "dropmalcty": "DUPONT",
    "dropmalst": "LA",
    "dropmalzpp": 713299998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189223831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23652",
    "droptype": "D",
    "dropname": "DUSON",
    "dropdeladd": "501 1ST ST",
    "dropdelcty": "DUSON",
    "dropdelst": "LA",
    "dropdelzpp": 705299998,
    "dropphyadd": "501 1ST ST",
    "dropphycty": "DUSON",
    "dropphyst": "LA",
    "dropphyzpp": 705299998,
    "dropmaladd": "501 1ST ST",
    "dropmalcty": "DUSON",
    "dropmalst": "LA",
    "dropmalzpp": 705299998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378739658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23662",
    "droptype": "D",
    "dropname": "ECHO",
    "dropdeladd": "10491 HIGHWAY 1",
    "dropdelcty": "ECHO",
    "dropdelst": "LA",
    "dropdelzpp": 713309998,
    "dropphyadd": "10491 HIGHWAY 1",
    "dropphycty": "ECHO",
    "dropphyst": "LA",
    "dropphyzpp": 713309998,
    "dropmaladd": "10491 HIGHWAY 1",
    "dropmalcty": "ECHO",
    "dropmalst": "LA",
    "dropmalzpp": 713309998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185638481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23663",
    "droptype": "D",
    "dropname": "EDGARD",
    "dropdeladd": "2447 HIGHWAY 18",
    "dropdelcty": "EDGARD",
    "dropdelst": "LA",
    "dropdelzpp": 700499998,
    "dropphyadd": "2447 HIGHWAY 18",
    "dropphycty": "EDGARD",
    "dropphyst": "LA",
    "dropphyzpp": 700499998,
    "dropmaladd": "2447 HIGHWAY 18",
    "dropmalcty": "EDGARD",
    "dropmalst": "LA",
    "dropmalzpp": 700499998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9854975134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23664",
    "droptype": "D",
    "dropname": "EFFIE",
    "dropdeladd": "3277 HIGHWAY 107",
    "dropdelcty": "EFFIE",
    "dropdelst": "LA",
    "dropdelzpp": 713319998,
    "dropphyadd": "3277 HIGHWAY 107",
    "dropphycty": "EFFIE",
    "dropphyst": "LA",
    "dropphyzpp": 713319998,
    "dropmaladd": "3277 HIGHWAY 107",
    "dropmalcty": "EFFIE",
    "dropmalst": "LA",
    "dropmalzpp": 713319998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182408851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23665",
    "droptype": "D",
    "dropname": "EGAN",
    "dropdeladd": "3246 EGAN HWY",
    "dropdelcty": "EGAN",
    "dropdelst": "LA",
    "dropdelzpp": 705313414,
    "dropphyadd": "3246 EGAN HWY",
    "dropphycty": "EGAN",
    "dropphyst": "LA",
    "dropphyzpp": 705313414,
    "dropmaladd": "PO BOX 3100",
    "dropmalcty": "EGAN",
    "dropmalst": "LA",
    "dropmalzpp": 705319998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377880259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23668",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "211 E MAIN ST",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "LA",
    "dropdelzpp": 706383800,
    "dropphyadd": "211 E MAIN ST",
    "dropphycty": "ELIZABETH",
    "dropphyst": "LA",
    "dropphyzpp": 706383800,
    "dropmaladd": "PO BOX 3800",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "LA",
    "dropmalzpp": 706389998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3186347370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23669",
    "droptype": "D",
    "dropname": "ELM GROVE",
    "dropdeladd": "10718 HIGHWAY 71",
    "dropdelcty": "ELM GROVE",
    "dropdelst": "LA",
    "dropdelzpp": 710519998,
    "dropphyadd": "10718 HIGHWAY 71",
    "dropphycty": "ELM GROVE",
    "dropphyst": "LA",
    "dropphyzpp": 710519998,
    "dropmaladd": "10718 HIGHWAY 71",
    "dropmalcty": "ELM GROVE",
    "dropmalst": "LA",
    "dropmalzpp": 710519998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187423620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23670",
    "droptype": "D",
    "dropname": "ELMER",
    "dropdeladd": "6677 HIGHWAY 112",
    "dropdelcty": "ELMER",
    "dropdelst": "LA",
    "dropdelzpp": 714249998,
    "dropphyadd": "6677 HIGHWAY 112",
    "dropphycty": "ELMER",
    "dropphyst": "LA",
    "dropphyzpp": 714249998,
    "dropmaladd": "6677 HIGHWAY 112",
    "dropmalcty": "ELMER",
    "dropmalst": "LA",
    "dropmalzpp": 714249998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186594875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23672",
    "droptype": "D",
    "dropname": "ELTON",
    "dropdeladd": "2003 MAIN ST",
    "dropdelcty": "ELTON",
    "dropdelst": "LA",
    "dropdelzpp": 705323224,
    "dropphyadd": "2003 MAIN ST",
    "dropphycty": "ELTON",
    "dropphyst": "LA",
    "dropphyzpp": 705323224,
    "dropmaladd": "PO BOX 3200",
    "dropmalcty": "ELTON",
    "dropmalst": "LA",
    "dropmalzpp": 705329998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375842251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23681",
    "droptype": "D",
    "dropname": "EPPS",
    "dropdeladd": "110 HIGHWAY 17",
    "dropdelcty": "EPPS",
    "dropdelst": "LA",
    "dropdelzpp": 712379998,
    "dropphyadd": "110 HIGHWAY 17",
    "dropphycty": "EPPS",
    "dropphyst": "LA",
    "dropphyzpp": 712379998,
    "dropmaladd": "110 HIGHWAY 17",
    "dropmalcty": "EPPS",
    "dropmalst": "LA",
    "dropmalzpp": 712379998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189265705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23682",
    "droptype": "D",
    "dropname": "ERATH",
    "dropdeladd": "115 W EDWARD ST",
    "dropdelcty": "ERATH",
    "dropdelst": "LA",
    "dropdelzpp": 705339998,
    "dropphyadd": "115 W EDWARD ST",
    "dropphycty": "ERATH",
    "dropphyst": "LA",
    "dropphyzpp": 705339998,
    "dropmaladd": "115 W EDWARD ST",
    "dropmalcty": "ERATH",
    "dropmalst": "LA",
    "dropmalzpp": 705339998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3379374586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23683",
    "droptype": "D",
    "dropname": "EROS",
    "dropdeladd": "9972 HIGHWAY 34",
    "dropdelcty": "EROS",
    "dropdelst": "LA",
    "dropdelzpp": 712389998,
    "dropphyadd": "9972 HIGHWAY 34",
    "dropphycty": "EROS",
    "dropphyst": "LA",
    "dropphyzpp": 712389998,
    "dropmaladd": "9972 HIGHWAY 34",
    "dropmalcty": "EROS",
    "dropmalst": "LA",
    "dropmalzpp": 712389998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182493048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23684",
    "droptype": "D",
    "dropname": "ERWINVILLE",
    "dropdeladd": "4710 POYDRAS BAYOU DR",
    "dropdelcty": "ERWINVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 707293416,
    "dropphyadd": "4710 POYDRAS BAYOU DR",
    "dropphycty": "ERWINVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 707293416,
    "dropmaladd": "4710 POYDRAS BAYOU DR",
    "dropmalcty": "ERWINVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 707293416,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256274634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23686",
    "droptype": "D",
    "dropname": "ESTHERWOOD",
    "dropdeladd": "430 FRONT AVE",
    "dropdelcty": "ESTHERWOOD",
    "dropdelst": "LA",
    "dropdelzpp": 705349998,
    "dropphyadd": "430 FRONT AVE",
    "dropphycty": "ESTHERWOOD",
    "dropphyst": "LA",
    "dropphyzpp": 705349998,
    "dropmaladd": "430 FRONT AVE",
    "dropmalcty": "ESTHERWOOD",
    "dropmalst": "LA",
    "dropmalzpp": 705349998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377833017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23688",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "3457 HIGHWAY 19",
    "dropdelcty": "ETHEL",
    "dropdelst": "LA",
    "dropdelzpp": 707309998,
    "dropphyadd": "3457 HIGHWAY 19",
    "dropphycty": "ETHEL",
    "dropphyst": "LA",
    "dropphyzpp": 707309998,
    "dropmaladd": "3457 HIGHWAY 19",
    "dropmalcty": "ETHEL",
    "dropmalst": "LA",
    "dropmalzpp": 707309998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256340057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23689",
    "droptype": "D",
    "dropname": "EUNICE",
    "dropdeladd": "250 W LAUREL AVE",
    "dropdelcty": "EUNICE",
    "dropdelst": "LA",
    "dropdelzpp": 705353304,
    "dropphyadd": "250 W LAUREL AVE",
    "dropphycty": "EUNICE",
    "dropphyst": "LA",
    "dropphyzpp": 705353304,
    "dropmaladd": "250 W LAUREL AVE",
    "dropmalcty": "EUNICE",
    "dropmalst": "LA",
    "dropmalzpp": 705353304,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374579682,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23692",
    "droptype": "D",
    "dropname": "EVANGELINE",
    "dropdeladd": "1362 OLD EVANGELINE HWY",
    "dropdelcty": "EVANGELINE",
    "dropdelst": "LA",
    "dropdelzpp": 705373304,
    "dropphyadd": "1362 OLD EVANGELINE HWY",
    "dropphycty": "EVANGELINE",
    "dropphyst": "LA",
    "dropphyzpp": 705373304,
    "dropmaladd": "1362 OLD EVANGELINE HWY",
    "dropmalcty": "EVANGELINE",
    "dropmalst": "LA",
    "dropmalzpp": 705379998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378247923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23693",
    "droptype": "D",
    "dropname": "EVANS",
    "dropdeladd": "19158 HIGHWAY 111",
    "dropdelcty": "EVANS",
    "dropdelst": "LA",
    "dropdelzpp": 706399998,
    "dropphyadd": "19158 HIGHWAY 111",
    "dropphycty": "EVANS",
    "dropphyst": "LA",
    "dropphyzpp": 706399998,
    "dropmaladd": "19158 HIGHWAY 111",
    "dropmalcty": "EVANS",
    "dropmalst": "LA",
    "dropmalzpp": 706399998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372869031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23695",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "119 HILL ST",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "LA",
    "dropdelzpp": 713339998,
    "dropphyadd": "119 HILL ST",
    "dropphycty": "EVERGREEN",
    "dropphyst": "LA",
    "dropphyzpp": 713339998,
    "dropmaladd": "119 HILL ST",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "LA",
    "dropmalzpp": 713339998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183464422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23697",
    "droptype": "D",
    "dropname": "FAIRBANKS",
    "dropdeladd": "1003 HIGHWAY 134",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "LA",
    "dropdelzpp": 712409998,
    "dropphyadd": "1003 HIGHWAY 134",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "LA",
    "dropphyzpp": 712409998,
    "dropmaladd": "1003 HIGHWAY 134",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "LA",
    "dropmalzpp": 712409998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186650668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23701",
    "droptype": "D",
    "dropname": "FARMERVILLE",
    "dropdeladd": "202 E GREEN ST",
    "dropdelcty": "FARMERVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 712419998,
    "dropphyadd": "202 E GREEN ST",
    "dropphycty": "FARMERVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 712419998,
    "dropmaladd": "202 E GREEN ST",
    "dropmalcty": "FARMERVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 712419998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183682907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23705",
    "droptype": "D",
    "dropname": "FENTON",
    "dropdeladd": "410 PELICAN HWY",
    "dropdelcty": "FENTON",
    "dropdelst": "LA",
    "dropdelzpp": 706404000,
    "dropphyadd": "410 PELICAN HWY",
    "dropphycty": "FENTON",
    "dropphyst": "LA",
    "dropphyzpp": 706404000,
    "dropmaladd": "PO BOX 4000",
    "dropmalcty": "FENTON",
    "dropmalst": "LA",
    "dropmalzpp": 706409998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3187562637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23706",
    "droptype": "D",
    "dropname": "FERRIDAY",
    "dropdeladd": "999 1ST ST",
    "dropdelcty": "FERRIDAY",
    "dropdelst": "LA",
    "dropdelzpp": 713349998,
    "dropphyadd": "999 1ST ST",
    "dropphycty": "FERRIDAY",
    "dropphyst": "LA",
    "dropphyzpp": 713349998,
    "dropmaladd": "999 1ST ST",
    "dropmalcty": "FERRIDAY",
    "dropmalst": "LA",
    "dropmalzpp": 713349998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187576677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23711",
    "droptype": "D",
    "dropname": "FISHER",
    "dropdeladd": "737 FOUR L DR",
    "dropdelcty": "FISHER",
    "dropdelst": "LA",
    "dropdelzpp": 714269998,
    "dropphyadd": "737 FOUR L DR",
    "dropphycty": "FISHER",
    "dropphyst": "LA",
    "dropphyzpp": 714269998,
    "dropmaladd": "737 FOUR L DR",
    "dropmalcty": "FISHER",
    "dropmalst": "LA",
    "dropmalzpp": 714269998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182566752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23716",
    "droptype": "D",
    "dropname": "FLORA",
    "dropdeladd": "1689 HIGHWAY 120",
    "dropdelcty": "FLORA",
    "dropdelst": "LA",
    "dropdelzpp": 714289998,
    "dropphyadd": "1689 HIGHWAY 120",
    "dropphycty": "FLORA",
    "dropphyst": "LA",
    "dropphyzpp": 714289998,
    "dropmaladd": "1689 HIGHWAY 120",
    "dropmalcty": "FLORA",
    "dropmalst": "LA",
    "dropmalzpp": 714289998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183565502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23718",
    "droptype": "D",
    "dropname": "FLORIEN",
    "dropdeladd": "1284 N NOLAN TRCE",
    "dropdelcty": "FLORIEN",
    "dropdelst": "LA",
    "dropdelzpp": 714299998,
    "dropphyadd": "1284 N NOLAN TRCE",
    "dropphycty": "FLORIEN",
    "dropphyst": "LA",
    "dropphyzpp": 714299998,
    "dropmaladd": "1284 N NOLAN TRCE",
    "dropmalcty": "FLORIEN",
    "dropmalst": "LA",
    "dropmalzpp": 714299998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185864660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23721",
    "droptype": "D",
    "dropname": "FLUKER",
    "dropdeladd": "67013 HIGHWAY 51",
    "dropdelcty": "FLUKER",
    "dropdelst": "LA",
    "dropdelzpp": 704369998,
    "dropphyadd": "67013 HIGHWAY 51",
    "dropphycty": "FLUKER",
    "dropphyst": "LA",
    "dropphyzpp": 704369998,
    "dropmaladd": "67013 HIGHWAY 51",
    "dropmalcty": "FLUKER",
    "dropmalst": "LA",
    "dropmalzpp": 704369998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857470361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23722",
    "droptype": "D",
    "dropname": "FOLSOM",
    "dropdeladd": "82424 HIGHWAY 25",
    "dropdelcty": "FOLSOM",
    "dropdelst": "LA",
    "dropdelzpp": 704379998,
    "dropphyadd": "82424 HIGHWAY 25",
    "dropphycty": "FOLSOM",
    "dropphyst": "LA",
    "dropphyzpp": 704379998,
    "dropmaladd": "82424 HIGHWAY 25",
    "dropmalcty": "FOLSOM",
    "dropmalst": "LA",
    "dropmalzpp": 704379998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857963189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23725",
    "droptype": "D",
    "dropname": "FORDOCHE",
    "dropdeladd": "5246 FORDOCHE RD",
    "dropdelcty": "FORDOCHE",
    "dropdelst": "LA",
    "dropdelzpp": 707329998,
    "dropphyadd": "5246 FORDOCHE RD",
    "dropphycty": "FORDOCHE",
    "dropphyst": "LA",
    "dropphyzpp": 707329998,
    "dropmaladd": "5246 FORDOCHE RD",
    "dropmalcty": "FORDOCHE",
    "dropmalst": "LA",
    "dropmalzpp": 707329998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256372946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23726",
    "droptype": "D",
    "dropname": "FOREST",
    "dropdeladd": "250 CHERRY ST",
    "dropdelcty": "FOREST",
    "dropdelst": "LA",
    "dropdelzpp": 712429998,
    "dropphyadd": "250 CHERRY ST",
    "dropphycty": "FOREST",
    "dropphyst": "LA",
    "dropphyzpp": 712429998,
    "dropmaladd": "250 CHERRY ST",
    "dropmalcty": "FOREST",
    "dropmalst": "LA",
    "dropmalzpp": 712429998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184283028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23727",
    "droptype": "D",
    "dropname": "FOREST HILL",
    "dropdeladd": "11038 HIGHWAY 165 S",
    "dropdelcty": "FOREST HILL",
    "dropdelst": "LA",
    "dropdelzpp": 714309789,
    "dropphyadd": "11038 HIGHWAY 165 S",
    "dropphycty": "FOREST HILL",
    "dropphyst": "LA",
    "dropphyzpp": 714309789,
    "dropmaladd": "11038 HIGHWAY 165 S",
    "dropmalcty": "FOREST HILL",
    "dropmalst": "LA",
    "dropmalzpp": 714309789,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187484253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23735",
    "droptype": "D",
    "dropname": "FORT NECESSITY",
    "dropdeladd": "10072 HIGHWAY 562",
    "dropdelcty": "FORT NECESSITY",
    "dropdelst": "LA",
    "dropdelzpp": 712439998,
    "dropphyadd": "10072 HIGHWAY 562",
    "dropphycty": "FORT NECESSITY",
    "dropphyst": "LA",
    "dropphyzpp": 712439998,
    "dropmaladd": "10072 HIGHWAY 562",
    "dropmalcty": "FORT NECESSITY",
    "dropmalst": "LA",
    "dropmalzpp": 712439998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187234245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23741",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "420 WILLOW ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "LA",
    "dropdelzpp": 705386023,
    "dropphyadd": "420 WILLOW ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "LA",
    "dropphyzpp": 705386023,
    "dropmaladd": "420 WILLOW ST",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "LA",
    "dropmalzpp": 705386023,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378284629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23742",
    "droptype": "D",
    "dropname": "FRANKLINTON",
    "dropdeladd": "805 LEE ST",
    "dropdelcty": "FRANKLINTON",
    "dropdelst": "LA",
    "dropdelzpp": 704389998,
    "dropphyadd": "805 LEE ST",
    "dropphycty": "FRANKLINTON",
    "dropphyst": "LA",
    "dropphyzpp": 704389998,
    "dropmaladd": "805 LEE ST",
    "dropmalcty": "FRANKLINTON",
    "dropmalst": "LA",
    "dropmalzpp": 704389998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858399095,
    "dropfax": 9857959775
  },
  {
    "dcode": "D",
    "dropkey": "PY23743",
    "droptype": "D",
    "dropname": "FRENCH SETTLEMENT",
    "dropdeladd": "16169 LA HIGHWAY 16",
    "dropdelcty": "FRENCH SETTLEMENT",
    "dropdelst": "LA",
    "dropdelzpp": 707339998,
    "dropphyadd": "16169 LA HIGHWAY 16",
    "dropphycty": "FRENCH SETTLEMENT",
    "dropphyst": "LA",
    "dropphyzpp": 707339998,
    "dropmaladd": "16169 LA HIGHWAY 16",
    "dropmalcty": "FRENCH SETTLEMENT",
    "dropmalst": "LA",
    "dropmalzpp": 707339998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256989346,
    "dropfax": 2252337742
  },
  {
    "dcode": "D",
    "dropkey": "PY23747",
    "droptype": "D",
    "dropname": "FRIERSON",
    "dropdeladd": "5400 HIGHWAY 175",
    "dropdelcty": "FRIERSON",
    "dropdelst": "LA",
    "dropdelzpp": 710279998,
    "dropphyadd": "5400 HIGHWAY 175",
    "dropphycty": "FRIERSON",
    "dropphyst": "LA",
    "dropphyzpp": 710279998,
    "dropmaladd": "5400 HIGHWAY 175",
    "dropmalcty": "FRIERSON",
    "dropmalst": "LA",
    "dropmalzpp": 710279998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187979743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23760",
    "droptype": "D",
    "dropname": "GALLIANO",
    "dropdeladd": "17599 HIGHWAY 3235",
    "dropdelcty": "GALLIANO",
    "dropdelst": "LA",
    "dropdelzpp": 703549998,
    "dropphyadd": "17599 HIGHWAY 3235",
    "dropphycty": "GALLIANO",
    "dropphyst": "LA",
    "dropphyzpp": 703549998,
    "dropmaladd": "17599 HIGHWAY 3235",
    "dropmalcty": "GALLIANO",
    "dropmalst": "LA",
    "dropmalzpp": 703549998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853252652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23767",
    "droptype": "D",
    "dropname": "GARYVILLE",
    "dropdeladd": "495 HISTORIC MAIN ST",
    "dropdelcty": "GARYVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 700519998,
    "dropphyadd": "495 HISTORIC MAIN ST",
    "dropphycty": "GARYVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 700519998,
    "dropmaladd": "495 HISTORIC MAIN ST",
    "dropmalcty": "GARYVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 700519998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855351300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23773",
    "droptype": "D",
    "dropname": "GEISMAR",
    "dropdeladd": "6223 HIGHWAY 73",
    "dropdelcty": "GEISMAR",
    "dropdelst": "LA",
    "dropdelzpp": 707343333,
    "dropphyadd": "6223 HIGHWAY 73",
    "dropphycty": "GEISMAR",
    "dropphyst": "LA",
    "dropphyzpp": 707343333,
    "dropmaladd": "6223 HIGHWAY 73",
    "dropmalcty": "GEISMAR",
    "dropmalst": "LA",
    "dropmalzpp": 707343333,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256735594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23778",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "4474 HIGHWAY 500",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "LA",
    "dropdelzpp": 714329998,
    "dropphyadd": "4474 HIGHWAY 500",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "LA",
    "dropphyzpp": 714329998,
    "dropmaladd": "4474 HIGHWAY 500",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "LA",
    "dropmalzpp": 714329998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188275238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23780",
    "droptype": "D",
    "dropname": "GIBSLAND",
    "dropdeladd": "1259 S 3RD ST",
    "dropdelcty": "GIBSLAND",
    "dropdelst": "LA",
    "dropdelzpp": 710289998,
    "dropphyadd": "1259 S 3RD ST",
    "dropphycty": "GIBSLAND",
    "dropphyst": "LA",
    "dropphyzpp": 710289998,
    "dropmaladd": "1259 S 3RD ST",
    "dropmalcty": "GIBSLAND",
    "dropmalst": "LA",
    "dropmalzpp": 710289998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188436965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23781",
    "droptype": "D",
    "dropname": "GIBSON",
    "dropdeladd": "6353 S BAYOU BLACK DR",
    "dropdelcty": "GIBSON",
    "dropdelst": "LA",
    "dropdelzpp": 703563701,
    "dropphyadd": "6353 S BAYOU BLACK DR",
    "dropphycty": "GIBSON",
    "dropphyst": "LA",
    "dropphyzpp": 703569998,
    "dropmaladd": "6353 S BAYOU BLACK DR",
    "dropmalcty": "GIBSON",
    "dropmalst": "LA",
    "dropmalzpp": 703569998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855752653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23783",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "7589 GILBERT ST",
    "dropdelcty": "GILBERT",
    "dropdelst": "LA",
    "dropdelzpp": 713369998,
    "dropphyadd": "7589 GILBERT ST",
    "dropphycty": "GILBERT",
    "dropphyst": "LA",
    "dropphyzpp": 713369998,
    "dropmaladd": "7589 GILBERT ST",
    "dropmalcty": "GILBERT",
    "dropmalst": "LA",
    "dropmalzpp": 713369998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184353374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23784",
    "droptype": "D",
    "dropname": "GILLIAM",
    "dropdeladd": "5517 1ST ST",
    "dropdelcty": "GILLIAM",
    "dropdelst": "LA",
    "dropdelzpp": 710299998,
    "dropphyadd": "5517 1ST ST",
    "dropphycty": "GILLIAM",
    "dropphyst": "LA",
    "dropphyzpp": 710299998,
    "dropmaladd": "5517 1ST ST",
    "dropmalcty": "GILLIAM",
    "dropmalst": "LA",
    "dropmalzpp": 710299998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182964599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23786",
    "droptype": "D",
    "dropname": "GLENMORA",
    "dropdeladd": "1201 7TH AVE",
    "dropdelcty": "GLENMORA",
    "dropdelst": "LA",
    "dropdelzpp": 714339998,
    "dropphyadd": "1201 7TH AVE",
    "dropphycty": "GLENMORA",
    "dropphyst": "LA",
    "dropphyzpp": 714339998,
    "dropmaladd": "1201 7TH AVE",
    "dropmalcty": "GLENMORA",
    "dropmalst": "LA",
    "dropmalzpp": 714339998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187484228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23788",
    "droptype": "D",
    "dropname": "GLOSTER",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "GLOSTER",
    "dropdelst": "LA",
    "dropdelzpp": 710309998,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "GLOSTER",
    "dropphyst": "LA",
    "dropphyzpp": 710309998,
    "dropmaladd": "125 MAIN ST",
    "dropmalcty": "GLOSTER",
    "dropmalst": "LA",
    "dropmalzpp": 710309998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189338439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23789",
    "droptype": "D",
    "dropname": "GLYNN",
    "dropdeladd": "14140 LA 416",
    "dropdelcty": "GLYNN",
    "dropdelst": "LA",
    "dropdelzpp": 707363717,
    "dropphyadd": "14140 LA 416",
    "dropphycty": "GLYNN",
    "dropphyst": "LA",
    "dropphyzpp": 707363717,
    "dropmaladd": "PO BOX 3600",
    "dropmalcty": "GLYNN",
    "dropmalst": "LA",
    "dropmalzpp": 707369998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256276113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23791",
    "droptype": "D",
    "dropname": "GOLDEN MEADOW",
    "dropdeladd": "300 S ALEX PLAISANCE BLVD",
    "dropdelcty": "GOLDEN MEADOW",
    "dropdelst": "LA",
    "dropdelzpp": 703579998,
    "dropphyadd": "300 S ALEX PLAISANCE BLVD",
    "dropphycty": "GOLDEN MEADOW",
    "dropphyst": "LA",
    "dropphyzpp": 703579998,
    "dropmaladd": "300 S ALEX PLAISANCE BLVD",
    "dropmalcty": "GOLDEN MEADOW",
    "dropmalst": "LA",
    "dropmalzpp": 703579998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9854754909,
    "dropfax": 9854755066
  },
  {
    "dcode": "D",
    "dropkey": "PY23793",
    "droptype": "D",
    "dropname": "GOLDONNA",
    "dropdeladd": "3153 MAIN ST",
    "dropdelcty": "GOLDONNA",
    "dropdelst": "LA",
    "dropdelzpp": 710319998,
    "dropphyadd": "3153 MAIN ST",
    "dropphycty": "GOLDONNA",
    "dropphyst": "LA",
    "dropphyzpp": 710319998,
    "dropmaladd": "3153 MAIN ST",
    "dropmalcty": "GOLDONNA",
    "dropmalst": "LA",
    "dropmalzpp": 710319998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187274590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23794",
    "droptype": "D",
    "dropname": "GONZALES",
    "dropdeladd": "1706 S BURNSIDE AVE",
    "dropdelcty": "GONZALES",
    "dropdelst": "LA",
    "dropdelzpp": 707379998,
    "dropphyadd": "1706 S BURNSIDE AVE",
    "dropphycty": "GONZALES",
    "dropphyst": "LA",
    "dropphyzpp": 707379998,
    "dropmaladd": "1706 S BURNSIDE AVE",
    "dropmalcty": "GONZALES",
    "dropmalst": "LA",
    "dropmalzpp": 707379998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256479715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23802",
    "droptype": "D",
    "dropname": "GORUM",
    "dropdeladd": "9327 HIGHWAY 119",
    "dropdelcty": "GORUM",
    "dropdelst": "LA",
    "dropdelzpp": 714349998,
    "dropphyadd": "9327 HIGHWAY 119",
    "dropphycty": "GORUM",
    "dropphyst": "LA",
    "dropphyzpp": 714349998,
    "dropmaladd": "9327 HIGHWAY 119",
    "dropmalcty": "GORUM",
    "dropmalst": "LA",
    "dropmalzpp": 714349998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183792732,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23804",
    "droptype": "D",
    "dropname": "GRAMBLING",
    "dropdeladd": "324 MAIN ST",
    "dropdelcty": "GRAMBLING",
    "dropdelst": "LA",
    "dropdelzpp": 712459998,
    "dropphyadd": "324 MAIN ST",
    "dropphycty": "GRAMBLING",
    "dropphyst": "LA",
    "dropphyzpp": 712459998,
    "dropmaladd": "324 MAIN ST",
    "dropmalcty": "GRAMBLING",
    "dropmalst": "LA",
    "dropmalzpp": 712459998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182471036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23805",
    "droptype": "D",
    "dropname": "GRAMERCY",
    "dropdeladd": "417 E MAIN ST",
    "dropdelcty": "GRAMERCY",
    "dropdelst": "LA",
    "dropdelzpp": 700529998,
    "dropphyadd": "417 E MAIN ST",
    "dropphycty": "GRAMERCY",
    "dropphyst": "LA",
    "dropphyzpp": 700529998,
    "dropmaladd": "417 E MAIN ST",
    "dropmalcty": "GRAMERCY",
    "dropmalst": "LA",
    "dropmalzpp": 700529998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2258690741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23806",
    "droptype": "D",
    "dropname": "GRAND CANE",
    "dropdeladd": "719 MAIN ST",
    "dropdelcty": "GRAND CANE",
    "dropdelst": "LA",
    "dropdelzpp": 710329998,
    "dropphyadd": "719 MAIN ST",
    "dropphycty": "GRAND CANE",
    "dropphyst": "LA",
    "dropphyzpp": 710329998,
    "dropmaladd": "719 MAIN ST",
    "dropmalcty": "GRAND CANE",
    "dropmalst": "LA",
    "dropmalzpp": 710329998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188582600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23808",
    "droptype": "D",
    "dropname": "GRAND COTEAU",
    "dropdeladd": "214 MARTIN L KING RD",
    "dropdelcty": "GRAND COTEAU",
    "dropdelst": "LA",
    "dropdelzpp": 705419998,
    "dropphyadd": "214 MARTIN L KING RD",
    "dropphycty": "GRAND COTEAU",
    "dropphyst": "LA",
    "dropphyzpp": 705419998,
    "dropmaladd": "214 MARTIN L KING RD",
    "dropmalcty": "GRAND COTEAU",
    "dropmalst": "LA",
    "dropmalzpp": 705419998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376623465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23809",
    "droptype": "D",
    "dropname": "GRAND ISLE",
    "dropdeladd": "3393 HIGHWAY 1",
    "dropdelcty": "GRAND ISLE",
    "dropdelst": "LA",
    "dropdelzpp": 703589998,
    "dropphyadd": "3393 HIGHWAY 1",
    "dropphycty": "GRAND ISLE",
    "dropphyst": "LA",
    "dropphyzpp": 703589998,
    "dropmaladd": "3393 HIGHWAY 1",
    "dropmalcty": "GRAND ISLE",
    "dropmalst": "LA",
    "dropmalzpp": 703589998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857872317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23811",
    "droptype": "D",
    "dropname": "GRANT",
    "dropdeladd": "4177 HIGHWAY 377",
    "dropdelcty": "GRANT",
    "dropdelst": "LA",
    "dropdelzpp": 706444400,
    "dropphyadd": "4177 HIGHWAY 377",
    "dropphycty": "GRANT",
    "dropphyst": "LA",
    "dropphyzpp": 706444400,
    "dropmaladd": "PO BOX 4400",
    "dropmalcty": "GRANT",
    "dropmalst": "LA",
    "dropmalzpp": 706449998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3186345972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23812",
    "droptype": "D",
    "dropname": "GRAY",
    "dropdeladd": "4442 W MAIN ST",
    "dropdelcty": "GRAY",
    "dropdelst": "LA",
    "dropdelzpp": 703599998,
    "dropphyadd": "4442 W MAIN ST",
    "dropphycty": "GRAY",
    "dropphyst": "LA",
    "dropphyzpp": 703599998,
    "dropmaladd": "4442 W MAIN ST",
    "dropmalcty": "GRAY",
    "dropmalst": "LA",
    "dropmalzpp": 703599998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858767424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23813",
    "droptype": "D",
    "dropname": "GRAYSON",
    "dropdeladd": "954 HIGHWAY 850",
    "dropdelcty": "GRAYSON",
    "dropdelst": "LA",
    "dropdelzpp": 714359998,
    "dropphyadd": "954 HIGHWAY 850",
    "dropphycty": "GRAYSON",
    "dropphyst": "LA",
    "dropphyzpp": 714359998,
    "dropmaladd": "954 HIGHWAY 850",
    "dropmalcty": "GRAYSON",
    "dropmalst": "LA",
    "dropmalzpp": 714359998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186497120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23818",
    "droptype": "D",
    "dropname": "GREENSBURG",
    "dropdeladd": "6638 HIGHWAY 10",
    "dropdelcty": "GREENSBURG",
    "dropdelst": "LA",
    "dropdelzpp": 704419998,
    "dropphyadd": "6638 HIGHWAY 10",
    "dropphycty": "GREENSBURG",
    "dropphyst": "LA",
    "dropphyzpp": 704419998,
    "dropmaladd": "6638 HIGHWAY 10",
    "dropmalcty": "GREENSBURG",
    "dropmalst": "LA",
    "dropmalzpp": 704419998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2252223562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23819",
    "droptype": "D",
    "dropname": "GREENWELL SPRINGS",
    "dropdeladd": "22801 GREENWELL SPRINGS RD",
    "dropdelcty": "GREENWELL SPRINGS",
    "dropdelst": "LA",
    "dropdelzpp": 707399998,
    "dropphyadd": "22801 GREENWELL SPRINGS RD",
    "dropphycty": "GREENWELL SPRINGS",
    "dropphyst": "LA",
    "dropphyzpp": 707399998,
    "dropmaladd": "22801 GREENWELL SPRINGS RD",
    "dropmalcty": "GREENWELL SPRINGS",
    "dropmalst": "LA",
    "dropmalzpp": 707399998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2252614985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23821",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "7070 ADAMS LN",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "LA",
    "dropdelzpp": 710339998,
    "dropphyadd": "7070 ADAMS LN",
    "dropphycty": "GREENWOOD",
    "dropphyst": "LA",
    "dropphyzpp": 710339998,
    "dropmaladd": "7070 ADAMS LN",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "LA",
    "dropmalzpp": 710339998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189381556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23823",
    "droptype": "D",
    "dropname": "GRETNA",
    "dropdeladd": "406 GRETNA BLVD",
    "dropdelcty": "GRETNA",
    "dropdelst": "LA",
    "dropdelzpp": 700539998,
    "dropphyadd": "406 GRETNA BLVD",
    "dropphycty": "GRETNA",
    "dropphyst": "LA",
    "dropphyzpp": 700539998,
    "dropmaladd": "406 GRETNA BLVD",
    "dropmalcty": "GRETNA",
    "dropmalst": "LA",
    "dropmalzpp": 700539998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043634986,
    "dropfax": 5043672962
  },
  {
    "dcode": "D",
    "dropkey": "PY23825",
    "droptype": "D",
    "dropname": "GROSSE TETE",
    "dropdeladd": "76760 CEDAR ST",
    "dropdelcty": "GROSSE TETE",
    "dropdelst": "LA",
    "dropdelzpp": 707403317,
    "dropphyadd": "76760 CEDAR ST",
    "dropphycty": "GROSSE TETE",
    "dropphyst": "LA",
    "dropphyzpp": 707403317,
    "dropmaladd": "PO BOX 4000",
    "dropmalcty": "GROSSE TETE",
    "dropmalst": "LA",
    "dropmalzpp": 707409998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256482157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23826",
    "droptype": "D",
    "dropname": "GUEYDAN",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "GUEYDAN",
    "dropdelst": "LA",
    "dropdelzpp": 705423633,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "GUEYDAN",
    "dropphyst": "LA",
    "dropphyzpp": 705423633,
    "dropmaladd": "405 MAIN ST",
    "dropmalcty": "GUEYDAN",
    "dropmalst": "LA",
    "dropmalzpp": 705429998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375368942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23828",
    "droptype": "D",
    "dropname": "HACKBERRY",
    "dropdeladd": "904 MAIN ST",
    "dropdelcty": "HACKBERRY",
    "dropdelst": "LA",
    "dropdelzpp": 706459997,
    "dropphyadd": "904 MAIN ST",
    "dropphycty": "HACKBERRY",
    "dropphyst": "LA",
    "dropphyzpp": 706459997,
    "dropmaladd": "904 MAIN ST",
    "dropmalcty": "HACKBERRY",
    "dropmalst": "LA",
    "dropmalzpp": 706459997,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377623895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23830",
    "droptype": "D",
    "dropname": "HAHNVILLE",
    "dropdeladd": "15141 RIVER RD",
    "dropdelcty": "HAHNVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 700579998,
    "dropphyadd": "15141 RIVER RD",
    "dropphycty": "HAHNVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 700579998,
    "dropmaladd": "15141 RIVER RD",
    "dropmalcty": "HAHNVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 700579998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857832681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23833",
    "droptype": "D",
    "dropname": "HALL SUMMIT",
    "dropdeladd": "7101 CARTER AVE",
    "dropdelcty": "HALL SUMMIT",
    "dropdelst": "LA",
    "dropdelzpp": 710349998,
    "dropphyadd": "7101 CARTER AVE",
    "dropphycty": "HALL SUMMIT",
    "dropphyst": "LA",
    "dropphyzpp": 710349998,
    "dropmaladd": "7101 CARTER AVE",
    "dropmalcty": "HALL SUMMIT",
    "dropmalst": "LA",
    "dropmalzpp": 710349998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189325837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23834",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "287 OLD HIGHWAY 1",
    "dropdelcty": "HAMBURG",
    "dropdelst": "LA",
    "dropdelzpp": 713399998,
    "dropphyadd": "287 OLD HIGHWAY 1",
    "dropphycty": "HAMBURG",
    "dropphyst": "LA",
    "dropphyzpp": 713399998,
    "dropmaladd": "287 OLD HIGHWAY 1",
    "dropmalcty": "HAMBURG",
    "dropmalst": "LA",
    "dropmalzpp": 713399998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189852980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23837",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "105 NW RAILROAD AVE",
    "dropdelcty": "HAMMOND",
    "dropdelst": "LA",
    "dropdelzpp": 704019998,
    "dropphyadd": "105 NW RAILROAD AVE",
    "dropphycty": "HAMMOND",
    "dropphyst": "LA",
    "dropphyzpp": 704019998,
    "dropmaladd": "105 NW RAILROAD AVE",
    "dropmalcty": "HAMMOND",
    "dropmalst": "LA",
    "dropmalzpp": 704019998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853456019,
    "dropfax": 9855490749
  },
  {
    "dcode": "D",
    "dropkey": "PY23844",
    "droptype": "D",
    "dropname": "HARRISONBURG",
    "dropdeladd": "103 PINE ST",
    "dropdelcty": "HARRISONBURG",
    "dropdelst": "LA",
    "dropdelzpp": 713409998,
    "dropphyadd": "103 PINE ST",
    "dropphycty": "HARRISONBURG",
    "dropphyst": "LA",
    "dropphyzpp": 713409998,
    "dropmaladd": "103 PINE ST",
    "dropmalcty": "HARRISONBURG",
    "dropmalst": "LA",
    "dropmalzpp": 713409998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187441485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23846",
    "droptype": "D",
    "dropname": "HARVEY",
    "dropdeladd": "2801 MANHATTAN BLVD",
    "dropdelcty": "HARVEY",
    "dropdelst": "LA",
    "dropdelzpp": 700589998,
    "dropphyadd": "2801 MANHATTAN BLVD",
    "dropphycty": "HARVEY",
    "dropphyst": "LA",
    "dropphyzpp": 700589998,
    "dropmaladd": "2801 MANHATTAN BLVD",
    "dropmalcty": "HARVEY",
    "dropmalst": "LA",
    "dropmalzpp": 700589998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043613310,
    "dropfax": 5043666528
  },
  {
    "dcode": "D",
    "dropkey": "PY23848",
    "droptype": "D",
    "dropname": "HAUGHTON",
    "dropdeladd": "399 W MCKINLEY AVE",
    "dropdelcty": "HAUGHTON",
    "dropdelst": "LA",
    "dropdelzpp": 710379998,
    "dropphyadd": "399 W MCKINLEY AVE",
    "dropphycty": "HAUGHTON",
    "dropphyst": "LA",
    "dropphyzpp": 710379998,
    "dropmaladd": "399 W MCKINLEY AVE",
    "dropmalcty": "HAUGHTON",
    "dropmalst": "LA",
    "dropmalzpp": 710379998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189495140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23850",
    "droptype": "D",
    "dropname": "HAYES",
    "dropdeladd": "7760 E HIGHWAY 14",
    "dropdelcty": "HAYES",
    "dropdelst": "LA",
    "dropdelzpp": 706464600,
    "dropphyadd": "7760 E HIGHWAY 14",
    "dropphycty": "HAYES",
    "dropphyst": "LA",
    "dropphyzpp": 706464600,
    "dropmaladd": "PO BOX 4600",
    "dropmalcty": "HAYES",
    "dropmalst": "LA",
    "dropmalzpp": 706469998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376223449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23851",
    "droptype": "D",
    "dropname": "HAYNESVILLE",
    "dropdeladd": "10007 HIGHWAY 79",
    "dropdelcty": "HAYNESVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 710389998,
    "dropphyadd": "10007 HIGHWAY 79",
    "dropphycty": "HAYNESVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 710389998,
    "dropmaladd": "10007 HIGHWAY 79",
    "dropmalcty": "HAYNESVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 710389998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186242818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23856",
    "droptype": "D",
    "dropname": "HEFLIN",
    "dropdeladd": "106 N MAIN ST",
    "dropdelcty": "HEFLIN",
    "dropdelst": "LA",
    "dropdelzpp": 710399998,
    "dropphyadd": "106 N MAIN ST",
    "dropphycty": "HEFLIN",
    "dropphyst": "LA",
    "dropphyzpp": 710399998,
    "dropmaladd": "106 N MAIN ST",
    "dropmalcty": "HEFLIN",
    "dropmalst": "LA",
    "dropmalzpp": 710399998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183772025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23859",
    "droptype": "D",
    "dropname": "HESSMER",
    "dropdeladd": "2999 MAIN ST",
    "dropdelcty": "HESSMER",
    "dropdelst": "LA",
    "dropdelzpp": 713419998,
    "dropphyadd": "2999 MAIN ST",
    "dropphycty": "HESSMER",
    "dropphyst": "LA",
    "dropphyzpp": 713419998,
    "dropmaladd": "2999 MAIN ST",
    "dropmalcty": "HESSMER",
    "dropmalst": "LA",
    "dropmalzpp": 713419998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185978685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23860",
    "droptype": "D",
    "dropname": "HESTER",
    "dropdeladd": "4163 KAHN ST",
    "dropdelcty": "HESTER",
    "dropdelst": "LA",
    "dropdelzpp": 707439998,
    "dropphyadd": "4163 KAHN ST",
    "dropphycty": "HESTER",
    "dropphyst": "LA",
    "dropphyzpp": 707439998,
    "dropmaladd": "4163 KAHN ST",
    "dropmalcty": "HESTER",
    "dropmalst": "LA",
    "dropmalzpp": 707439998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 2258697633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23872",
    "droptype": "D",
    "dropname": "HINESTON",
    "dropdeladd": "1923 HIGHWAY 121",
    "dropdelcty": "HINESTON",
    "dropdelst": "LA",
    "dropdelzpp": 714389998,
    "dropphyadd": "1923 HIGHWAY 121",
    "dropphycty": "HINESTON",
    "dropphyst": "LA",
    "dropphyzpp": 714389998,
    "dropmaladd": "1923 HIGHWAY 121",
    "dropmalcty": "HINESTON",
    "dropmalst": "LA",
    "dropmalzpp": 714389998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187939294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23873",
    "droptype": "D",
    "dropname": "HODGE",
    "dropdeladd": "392 BANK ST",
    "dropdelcty": "HODGE",
    "dropdelst": "LA",
    "dropdelzpp": 712479998,
    "dropphyadd": "392 BANK ST",
    "dropphycty": "HODGE",
    "dropphyst": "LA",
    "dropphyzpp": 712479998,
    "dropmaladd": "392 BANK ST",
    "dropmalcty": "HODGE",
    "dropmalst": "LA",
    "dropmalzpp": 712479998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183951261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23874",
    "droptype": "D",
    "dropname": "HOLDEN",
    "dropdeladd": "30165 LA 441 HWY",
    "dropdelcty": "HOLDEN",
    "dropdelst": "LA",
    "dropdelzpp": 707449998,
    "dropphyadd": "30165 LA 441 HWY",
    "dropphycty": "HOLDEN",
    "dropphyst": "LA",
    "dropphyzpp": 707449998,
    "dropmaladd": "30165 LA 441 HWY",
    "dropmalcty": "HOLDEN",
    "dropmalst": "LA",
    "dropmalzpp": 707449998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2252099201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23883",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "612 N MAIN ST",
    "dropdelcty": "HOMER",
    "dropdelst": "LA",
    "dropdelzpp": 710409998,
    "dropphyadd": "612 N MAIN ST",
    "dropphycty": "HOMER",
    "dropphyst": "LA",
    "dropphyzpp": 710409998,
    "dropmaladd": "612 N MAIN ST",
    "dropmalcty": "HOMER",
    "dropmalst": "LA",
    "dropmalzpp": 710409998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189272428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23886",
    "droptype": "D",
    "dropname": "HORNBECK",
    "dropdeladd": "1127 HAMMOND ST",
    "dropdelcty": "HORNBECK",
    "dropdelst": "LA",
    "dropdelzpp": 714399998,
    "dropphyadd": "1127 HAMMOND ST",
    "dropphycty": "HORNBECK",
    "dropphyst": "LA",
    "dropphyzpp": 714399998,
    "dropmaladd": "1127 HAMMOND ST",
    "dropmalcty": "HORNBECK",
    "dropmalst": "LA",
    "dropmalzpp": 714399998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185653451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23887",
    "droptype": "D",
    "dropname": "HOSSTON",
    "dropdeladd": "14836 PARKWAY DR",
    "dropdelcty": "HOSSTON",
    "dropdelst": "LA",
    "dropdelzpp": 710439998,
    "dropphyadd": "14836 PARKWAY DR",
    "dropphycty": "HOSSTON",
    "dropphyst": "LA",
    "dropphyzpp": 710439998,
    "dropmaladd": "14836 PARKWAY DR",
    "dropmalcty": "HOSSTON",
    "dropmalst": "LA",
    "dropmalzpp": 710439998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182873969,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23889",
    "droptype": "D",
    "dropname": "HOUMA",
    "dropdeladd": "425 LAFAYETTE ST OFC",
    "dropdelcty": "HOUMA",
    "dropdelst": "LA",
    "dropdelzpp": 703609998,
    "dropphyadd": "425 LAFAYETTE ST OFC",
    "dropphycty": "HOUMA",
    "dropphyst": "LA",
    "dropphyzpp": 703609998,
    "dropmaladd": "425 LAFAYETTE ST OFC",
    "dropmalcty": "HOUMA",
    "dropmalst": "LA",
    "dropmalzpp": 703609998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9852231722,
    "dropfax": 9858687348
  },
  {
    "dcode": "D",
    "dropkey": "PY23894",
    "droptype": "D",
    "dropname": "HUSSER",
    "dropdeladd": "56594 HIGHWAY 445",
    "dropdelcty": "HUSSER",
    "dropdelst": "LA",
    "dropdelzpp": 704429998,
    "dropphyadd": "56594 HIGHWAY 445",
    "dropphycty": "HUSSER",
    "dropphyst": "LA",
    "dropphyzpp": 704429998,
    "dropmaladd": "56594 HIGHWAY 445",
    "dropmalcty": "HUSSER",
    "dropmalst": "LA",
    "dropmalzpp": 704429998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857489783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23899",
    "droptype": "D",
    "dropname": "IDA",
    "dropdeladd": "6994 E MAGNOLIA LN",
    "dropdelcty": "IDA",
    "dropdelst": "LA",
    "dropdelzpp": 710449998,
    "dropphyadd": "6994 E MAGNOLIA LN",
    "dropphycty": "IDA",
    "dropphyst": "LA",
    "dropphyzpp": 710449998,
    "dropmaladd": "6994 E MAGNOLIA LN",
    "dropmalcty": "IDA",
    "dropmalst": "LA",
    "dropmalzpp": 710449998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182843570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23901",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "637 3RD ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "LA",
    "dropdelzpp": 704439998,
    "dropphyadd": "637 3RD ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "LA",
    "dropphyzpp": 704439998,
    "dropmaladd": "637 3RD ST",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "LA",
    "dropmalzpp": 704439998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858783071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23906",
    "droptype": "D",
    "dropname": "INNIS",
    "dropdeladd": "6541 LA HIGHWAY 1",
    "dropdelcty": "INNIS",
    "dropdelst": "LA",
    "dropdelzpp": 707474700,
    "dropphyadd": "6541 LA HIGHWAY 1",
    "dropphycty": "INNIS",
    "dropphyst": "LA",
    "dropphyzpp": 707474700,
    "dropmaladd": "PO BOX 4700",
    "dropmalcty": "INNIS",
    "dropmalst": "LA",
    "dropmalzpp": 707479998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2254922115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23910",
    "droptype": "D",
    "dropname": "IOTA",
    "dropdeladd": "207 FREY ST",
    "dropdelcty": "IOTA",
    "dropdelst": "LA",
    "dropdelzpp": 705432000,
    "dropphyadd": "207 FREY ST",
    "dropphycty": "IOTA",
    "dropphyst": "LA",
    "dropphyzpp": 705432000,
    "dropmaladd": "PO BOX 4300",
    "dropmalcty": "IOTA",
    "dropmalst": "LA",
    "dropmalzpp": 705439998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377792083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23911",
    "droptype": "D",
    "dropname": "IOWA",
    "dropdeladd": "218 S THOMSON AVE",
    "dropdelcty": "IOWA",
    "dropdelst": "LA",
    "dropdelzpp": 706479998,
    "dropphyadd": "218 S THOMSON AVE",
    "dropphycty": "IOWA",
    "dropphyst": "LA",
    "dropphyzpp": 706479998,
    "dropmaladd": "218 S THOMSON AVE",
    "dropmalcty": "IOWA",
    "dropmalst": "LA",
    "dropmalzpp": 706479998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375827875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23917",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "3016 BANK ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "LA",
    "dropdelzpp": 707489998,
    "dropphyadd": "3016 BANK ST",
    "dropphycty": "JACKSON",
    "dropphyst": "LA",
    "dropphyzpp": 707489998,
    "dropmaladd": "3016 BANK ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "LA",
    "dropmalzpp": 707489998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256347052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23918",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "4143 E FRONT ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "LA",
    "dropdelzpp": 710459998,
    "dropphyadd": "4143 E FRONT ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "LA",
    "dropphyzpp": 710459998,
    "dropmaladd": "4143 E FRONT ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "LA",
    "dropmalzpp": 710459998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188949469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23920",
    "droptype": "D",
    "dropname": "JARREAU",
    "dropdeladd": "5341 BOULEVARD D ISLE",
    "dropdelcty": "JARREAU",
    "dropdelst": "LA",
    "dropdelzpp": 707499998,
    "dropphyadd": "5341 BOULEVARD D ISLE",
    "dropphycty": "JARREAU",
    "dropphyst": "LA",
    "dropphyzpp": 707499998,
    "dropmaladd": "5341 BOULEVARD D ISLE",
    "dropmalcty": "JARREAU",
    "dropmalst": "LA",
    "dropmalzpp": 707499998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256279981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23921",
    "droptype": "D",
    "dropname": "JEANERETTE",
    "dropdeladd": "1614 MAIN ST",
    "dropdelcty": "JEANERETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705443530,
    "dropphyadd": "1614 MAIN ST",
    "dropphycty": "JEANERETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705443530,
    "dropmaladd": "1614 MAIN ST",
    "dropmalcty": "JEANERETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705449998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372767014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23924",
    "droptype": "D",
    "dropname": "JENA",
    "dropdeladd": "3811 W OAK ST",
    "dropdelcty": "JENA",
    "dropdelst": "LA",
    "dropdelzpp": 713429998,
    "dropphyadd": "3811 W OAK ST",
    "dropphycty": "JENA",
    "dropphyst": "LA",
    "dropphyzpp": 713429998,
    "dropmaladd": "3811 W OAK ST",
    "dropmalcty": "JENA",
    "dropmalst": "LA",
    "dropmalzpp": 713429998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189920339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23925",
    "droptype": "D",
    "dropname": "JENNINGS",
    "dropdeladd": "106 S BROADWAY ST",
    "dropdelcty": "JENNINGS",
    "dropdelst": "LA",
    "dropdelzpp": 705465806,
    "dropphyadd": "106 S BROADWAY ST",
    "dropphycty": "JENNINGS",
    "dropphyst": "LA",
    "dropphyzpp": 705465806,
    "dropmaladd": "106 S BROADWAY ST",
    "dropmalcty": "JENNINGS",
    "dropmalst": "LA",
    "dropmalzpp": 705469998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378245354,
    "dropfax": 3378243331
  },
  {
    "dcode": "D",
    "dropkey": "PY23926",
    "droptype": "D",
    "dropname": "JIGGER",
    "dropdeladd": "7135 HIGHWAY 128",
    "dropdelcty": "JIGGER",
    "dropdelst": "LA",
    "dropdelzpp": 712499998,
    "dropphyadd": "7135 HIGHWAY 128",
    "dropphycty": "JIGGER",
    "dropphyst": "LA",
    "dropphyzpp": 712499998,
    "dropmaladd": "7135 HIGHWAY 128",
    "dropmalcty": "JIGGER",
    "dropmalst": "LA",
    "dropmalzpp": 712499998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187235458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23930",
    "droptype": "D",
    "dropname": "JONES",
    "dropdeladd": "17366 WILMOT HWY",
    "dropdelcty": "JONES",
    "dropdelst": "LA",
    "dropdelzpp": 712509998,
    "dropphyadd": "17366 WILMOT HWY",
    "dropphycty": "JONES",
    "dropphyst": "LA",
    "dropphyzpp": 712509998,
    "dropmaladd": "17366 WILMOT HWY",
    "dropmalcty": "JONES",
    "dropmalst": "LA",
    "dropmalzpp": 712509998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188234570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23931",
    "droptype": "D",
    "dropname": "JONESBORO",
    "dropdeladd": "610 E MAIN ST",
    "dropdelcty": "JONESBORO",
    "dropdelst": "LA",
    "dropdelzpp": 712519998,
    "dropphyadd": "610 E MAIN ST",
    "dropphycty": "JONESBORO",
    "dropphyst": "LA",
    "dropphyzpp": 712519998,
    "dropmaladd": "610 E MAIN ST",
    "dropmalcty": "JONESBORO",
    "dropmalst": "LA",
    "dropmalzpp": 712519998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182591266,
    "dropfax": 3182596232
  },
  {
    "dcode": "D",
    "dropkey": "PY23933",
    "droptype": "D",
    "dropname": "JONESVILLE",
    "dropdeladd": "902 FIRST ST",
    "dropdelcty": "JONESVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713439998,
    "dropphyadd": "902 FIRST ST",
    "dropphycty": "JONESVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713439998,
    "dropmaladd": "902 FIRST ST",
    "dropmalcty": "JONESVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713439998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183399398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23936",
    "droptype": "D",
    "dropname": "JOYCE",
    "dropdeladd": "7018 HIGHWAY 84 E",
    "dropdelcty": "JOYCE",
    "dropdelst": "LA",
    "dropdelzpp": 714409998,
    "dropphyadd": "7018 HIGHWAY 84 E",
    "dropphycty": "JOYCE",
    "dropphyst": "LA",
    "dropphyzpp": 714409998,
    "dropmaladd": "7018 HIGHWAY 84 E",
    "dropmalcty": "JOYCE",
    "dropmalst": "LA",
    "dropmalzpp": 714409998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186282494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23939",
    "droptype": "D",
    "dropname": "KAPLAN",
    "dropdeladd": "1401 W VETERANS MEML DR",
    "dropdelcty": "KAPLAN",
    "dropdelst": "LA",
    "dropdelzpp": 705484503,
    "dropphyadd": "1401 W VETERANS MEML DR",
    "dropphycty": "KAPLAN",
    "dropphyst": "LA",
    "dropphyzpp": 705484503,
    "dropmaladd": "1401 W VETERANS MEML DR",
    "dropmalcty": "KAPLAN",
    "dropmalst": "LA",
    "dropmalzpp": 705484503,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376432780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23940",
    "droptype": "D",
    "dropname": "KEATCHIE",
    "dropdeladd": "9892 HIGHWAY 5",
    "dropdelcty": "KEATCHIE",
    "dropdelst": "LA",
    "dropdelzpp": 710469998,
    "dropphyadd": "9892 HIGHWAY 5",
    "dropphycty": "KEATCHIE",
    "dropphyst": "LA",
    "dropphyzpp": 710469998,
    "dropmaladd": "9892 HIGHWAY 5",
    "dropmalcty": "KEATCHIE",
    "dropmalst": "LA",
    "dropmalzpp": 710469998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189330883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23941",
    "droptype": "D",
    "dropname": "KEITHVILLE",
    "dropdeladd": "12395 MANSFIELD RD",
    "dropdelcty": "KEITHVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 710479998,
    "dropphyadd": "12395 MANSFIELD RD",
    "dropphycty": "KEITHVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 710479998,
    "dropmaladd": "12395 MANSFIELD RD",
    "dropmalcty": "KEITHVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 710479998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189256957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23942",
    "droptype": "D",
    "dropname": "KELLY",
    "dropdeladd": "3401 HIGHWAY 506 W",
    "dropdelcty": "KELLY",
    "dropdelst": "LA",
    "dropdelzpp": 714419998,
    "dropphyadd": "3401 HIGHWAY 506 W",
    "dropphycty": "KELLY",
    "dropphyst": "LA",
    "dropphyzpp": 714419998,
    "dropmaladd": "3401 HIGHWAY 506 W",
    "dropmalcty": "KELLY",
    "dropmalst": "LA",
    "dropmalzpp": 714419998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186493184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23947",
    "droptype": "D",
    "dropname": "KENNER",
    "dropdeladd": "2300 WILLIAMS BLVD",
    "dropdelcty": "KENNER",
    "dropdelst": "LA",
    "dropdelzpp": 700629998,
    "dropphyadd": "2300 WILLIAMS BLVD",
    "dropphycty": "KENNER",
    "dropphyst": "LA",
    "dropphyzpp": 700629998,
    "dropmaladd": "2300 WILLIAMS BLVD",
    "dropmalcty": "KENNER",
    "dropmalst": "LA",
    "dropmalzpp": 700629998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044663866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23948",
    "droptype": "D",
    "dropname": "KENTWOOD",
    "dropdeladd": "601 AVENUE E",
    "dropdelcty": "KENTWOOD",
    "dropdelst": "LA",
    "dropdelzpp": 704449998,
    "dropphyadd": "601 AVENUE E",
    "dropphycty": "KENTWOOD",
    "dropphyst": "LA",
    "dropphyzpp": 704449998,
    "dropmaladd": "601 AVENUE E",
    "dropmalcty": "KENTWOOD",
    "dropmalst": "LA",
    "dropmalzpp": 704449998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9852292977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23950",
    "droptype": "D",
    "dropname": "KILBOURNE",
    "dropdeladd": "120 E MAIN ST",
    "dropdelcty": "KILBOURNE",
    "dropdelst": "LA",
    "dropdelzpp": 712539998,
    "dropphyadd": "120 E MAIN ST",
    "dropphycty": "KILBOURNE",
    "dropphyst": "LA",
    "dropphyzpp": 712539998,
    "dropmaladd": "120 E MAIN ST",
    "dropmalcty": "KILBOURNE",
    "dropmalst": "LA",
    "dropmalzpp": 712539998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184289266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23954",
    "droptype": "D",
    "dropname": "KINDER",
    "dropdeladd": "423 N 9TH ST",
    "dropdelcty": "KINDER",
    "dropdelst": "LA",
    "dropdelzpp": 706483318,
    "dropphyadd": "423 N 9TH ST",
    "dropphycty": "KINDER",
    "dropphyst": "LA",
    "dropphyzpp": 706483318,
    "dropmaladd": "423 N 9TH ST",
    "dropmalcty": "KINDER",
    "dropmalst": "LA",
    "dropmalzpp": 706489998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377382857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23964",
    "droptype": "D",
    "dropname": "KROTZ SPRINGS",
    "dropdeladd": "427 FLORIDA ST",
    "dropdelcty": "KROTZ SPRINGS",
    "dropdelst": "LA",
    "dropdelzpp": 707509998,
    "dropphyadd": "427 FLORIDA ST",
    "dropphycty": "KROTZ SPRINGS",
    "dropphyst": "LA",
    "dropphyzpp": 707509998,
    "dropmaladd": "427 FLORIDA ST",
    "dropmalcty": "KROTZ SPRINGS",
    "dropmalst": "LA",
    "dropmalzpp": 707509998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 3375662119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23973",
    "droptype": "D",
    "dropname": "LA PLACE",
    "dropdeladd": "190 BELLE TERRE BLVD",
    "dropdelcty": "LA PLACE",
    "dropdelst": "LA",
    "dropdelzpp": 700689998,
    "dropphyadd": "190 BELLE TERRE BLVD",
    "dropphycty": "LA PLACE",
    "dropphyst": "LA",
    "dropphyzpp": 700689998,
    "dropmaladd": "190 BELLE TERRE BLVD",
    "dropmalcty": "LA PLACE",
    "dropmalst": "LA",
    "dropmalzpp": 700689998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856516151,
    "dropfax": 9856523268
  },
  {
    "dcode": "D",
    "dropkey": "PY23978",
    "droptype": "D",
    "dropname": "LABADIEVILLE",
    "dropdeladd": "2643 HIGHWAY 1",
    "dropdelcty": "LABADIEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 703729998,
    "dropphyadd": "2643 HIGHWAY 1",
    "dropphycty": "LABADIEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 703729998,
    "dropmaladd": "2643 HIGHWAY 1",
    "dropmalcty": "LABADIEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 703729998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855264369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23981",
    "droptype": "D",
    "dropname": "LACASSINE",
    "dropdeladd": "18327 HIGHWAY 90",
    "dropdelcty": "LACASSINE",
    "dropdelst": "LA",
    "dropdelzpp": 706505000,
    "dropphyadd": "18327 HIGHWAY 90",
    "dropphycty": "LACASSINE",
    "dropphyst": "LA",
    "dropphyzpp": 706505000,
    "dropmaladd": "PO BOX 5000",
    "dropmalcty": "LACASSINE",
    "dropmalst": "LA",
    "dropmalzpp": 706509998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375884378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23982",
    "droptype": "D",
    "dropname": "LACOMBE",
    "dropdeladd": "27367 HIGHWAY 190",
    "dropdelcty": "LACOMBE",
    "dropdelst": "LA",
    "dropdelzpp": 704459998,
    "dropphyadd": "27367 HIGHWAY 190",
    "dropphycty": "LACOMBE",
    "dropphyst": "LA",
    "dropphyzpp": 704459998,
    "dropmaladd": "27367 HIGHWAY 190",
    "dropmalcty": "LACOMBE",
    "dropmalst": "LA",
    "dropmalzpp": 704459998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858826345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23984",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "1105 MOSS ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705019998,
    "dropphyadd": "1105 MOSS ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705019998,
    "dropmaladd": "PO BOX 90000",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705099998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372697110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23987",
    "droptype": "D",
    "dropname": "LAFITTE",
    "dropdeladd": "2630 JEAN LAFITTE BLVD",
    "dropdelcty": "LAFITTE",
    "dropdelst": "LA",
    "dropdelzpp": 700679998,
    "dropphyadd": "2630 JEAN LAFITTE BLVD",
    "dropphycty": "LAFITTE",
    "dropphyst": "LA",
    "dropphyzpp": 700679998,
    "dropmaladd": "2630 JEAN LAFITTE BLVD",
    "dropmalcty": "LAFITTE",
    "dropmalst": "LA",
    "dropmalzpp": 700679998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046893898,
    "dropfax": 5046893594
  },
  {
    "dcode": "D",
    "dropkey": "PY23989",
    "droptype": "D",
    "dropname": "LAKE ARTHUR",
    "dropdeladd": "302 KELLOGG AVE",
    "dropdelcty": "LAKE ARTHUR",
    "dropdelst": "LA",
    "dropdelzpp": 705494116,
    "dropphyadd": "302 KELLOGG AVE",
    "dropphycty": "LAKE ARTHUR",
    "dropphyst": "LA",
    "dropphyzpp": 705494116,
    "dropmaladd": "302 KELLOGG AVE",
    "dropmalcty": "LAKE ARTHUR",
    "dropmalst": "LA",
    "dropmalzpp": 705499998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377746921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23993",
    "droptype": "D",
    "dropname": "LAKE CHARLES",
    "dropdeladd": "921 MOSS ST",
    "dropdelcty": "LAKE CHARLES",
    "dropdelst": "LA",
    "dropdelzpp": 706019998,
    "dropphyadd": "921 MOSS ST",
    "dropphycty": "LAKE CHARLES",
    "dropphyst": "LA",
    "dropphyzpp": 706019998,
    "dropmaladd": "921 MOSS ST",
    "dropmalcty": "LAKE CHARLES",
    "dropmalst": "LA",
    "dropmalzpp": 706019998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374377484,
    "dropfax": 3374394385
  },
  {
    "dcode": "D",
    "dropkey": "PY23995",
    "droptype": "D",
    "dropname": "LAKE PROVIDENCE",
    "dropdeladd": "202 SPARROW ST",
    "dropdelcty": "LAKE PROVIDENCE",
    "dropdelst": "LA",
    "dropdelzpp": 712549998,
    "dropphyadd": "202 SPARROW ST",
    "dropphycty": "LAKE PROVIDENCE",
    "dropphyst": "LA",
    "dropphyzpp": 712549998,
    "dropmaladd": "202 SPARROW ST",
    "dropmalcty": "LAKE PROVIDENCE",
    "dropmalst": "LA",
    "dropmalzpp": 712549998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185590658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY23997",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "12158 LA HIGHWAY 416",
    "dropdelcty": "LAKELAND",
    "dropdelst": "LA",
    "dropdelzpp": 707523101,
    "dropphyadd": "12158 LA HIGHWAY 416",
    "dropphycty": "LAKELAND",
    "dropphyst": "LA",
    "dropphyzpp": 707523101,
    "dropmaladd": "12158 LA HIGHWAY 416",
    "dropmalcty": "LAKELAND",
    "dropmalst": "LA",
    "dropmalzpp": 707523101,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256275831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24008",
    "droptype": "D",
    "dropname": "LAROSE",
    "dropdeladd": "123 W 17TH ST",
    "dropdelcty": "LAROSE",
    "dropdelst": "LA",
    "dropdelzpp": 703739998,
    "dropphyadd": "123 W 17TH ST",
    "dropphycty": "LAROSE",
    "dropphyst": "LA",
    "dropphyzpp": 703739998,
    "dropmaladd": "123 W 17TH ST",
    "dropmalcty": "LAROSE",
    "dropmalst": "LA",
    "dropmalzpp": 703739998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9852408715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24013",
    "droptype": "D",
    "dropname": "LAWTELL",
    "dropdeladd": "10207 PREJEAN HWY",
    "dropdelcty": "LAWTELL",
    "dropdelst": "LA",
    "dropdelzpp": 705509998,
    "dropphyadd": "10207 PREJEAN HWY",
    "dropphycty": "LAWTELL",
    "dropphyst": "LA",
    "dropphyzpp": 705509998,
    "dropmaladd": "10207 PREJEAN HWY",
    "dropmalcty": "LAWTELL",
    "dropmalst": "LA",
    "dropmalzpp": 705509998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375437341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24016",
    "droptype": "D",
    "dropname": "LEBEAU",
    "dropdeladd": "8478 HIGHWAY 71",
    "dropdelcty": "LEBEAU",
    "dropdelst": "LA",
    "dropdelzpp": 713459998,
    "dropphyadd": "8478 HIGHWAY 71",
    "dropphycty": "LEBEAU",
    "dropphyst": "LA",
    "dropphyzpp": 713459998,
    "dropmaladd": "8478 HIGHWAY 71",
    "dropmalcty": "LEBEAU",
    "dropmalst": "LA",
    "dropmalzpp": 713459998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3376235530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24017",
    "droptype": "D",
    "dropname": "LEBLANC",
    "dropdeladd": "15148 HIGHWAY 190",
    "dropdelcty": "LEBLANC",
    "dropdelst": "LA",
    "dropdelzpp": 706515100,
    "dropphyadd": "15148 HIGHWAY 190",
    "dropphycty": "LEBLANC",
    "dropphyst": "LA",
    "dropphyzpp": 706515100,
    "dropmaladd": "PO BOX 5100",
    "dropmalcty": "LEBLANC",
    "dropmalst": "LA",
    "dropmalzpp": 706519998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377382446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24018",
    "droptype": "D",
    "dropname": "LECOMPTE",
    "dropdeladd": "1920 HIGHWAY 71 S",
    "dropdelcty": "LECOMPTE",
    "dropdelst": "LA",
    "dropdelzpp": 713469998,
    "dropphyadd": "1920 HIGHWAY 71 S",
    "dropphycty": "LECOMPTE",
    "dropphyst": "LA",
    "dropphyzpp": 713469998,
    "dropmaladd": "1920 HIGHWAY 71 S",
    "dropmalcty": "LECOMPTE",
    "dropmalst": "LA",
    "dropmalzpp": 713469998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187768551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24021",
    "droptype": "D",
    "dropname": "LEESVILLE",
    "dropdeladd": "303 S 3RD ST",
    "dropdelcty": "LEESVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 714469998,
    "dropphyadd": "303 S 3RD ST",
    "dropphycty": "LEESVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 714469998,
    "dropmaladd": "303 S 3RD ST",
    "dropmalcty": "LEESVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 714469998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3372392617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24028",
    "droptype": "D",
    "dropname": "LENA",
    "dropdeladd": "57 LENA FLATWOODS RD",
    "dropdelcty": "LENA",
    "dropdelst": "LA",
    "dropdelzpp": 714479998,
    "dropphyadd": "57 LENA FLATWOODS RD",
    "dropphycty": "LENA",
    "dropphyst": "LA",
    "dropphyzpp": 714479998,
    "dropmaladd": "57 LENA FLATWOODS RD",
    "dropmalcty": "LENA",
    "dropmalst": "LA",
    "dropmalzpp": 714479998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187930416,
    "dropfax": 3187934736
  },
  {
    "dcode": "D",
    "dropkey": "PY24029",
    "droptype": "D",
    "dropname": "LEONVILLE",
    "dropdeladd": "3928 HIGHWAY 31",
    "dropdelcty": "LEONVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705513000,
    "dropphyadd": "3928 HIGHWAY 31",
    "dropphycty": "LEONVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705513000,
    "dropmaladd": "PO BOX 5100",
    "dropmalcty": "LEONVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705519998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378792813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24030",
    "droptype": "D",
    "dropname": "LETTSWORTH",
    "dropdeladd": "9863 LA HIGHWAY 1",
    "dropdelcty": "LETTSWORTH",
    "dropdelst": "LA",
    "dropdelzpp": 707539998,
    "dropphyadd": "9863 LA HIGHWAY 1",
    "dropphycty": "LETTSWORTH",
    "dropphyst": "LA",
    "dropphyzpp": 707539998,
    "dropmaladd": "9863 LA HIGHWAY 1",
    "dropmalcty": "LETTSWORTH",
    "dropmalst": "LA",
    "dropmalzpp": 707539998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2254922040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24035",
    "droptype": "D",
    "dropname": "LIBUSE",
    "dropdeladd": "6400 HIGHWAY 28 E",
    "dropdelcty": "LIBUSE",
    "dropdelst": "LA",
    "dropdelzpp": 713489998,
    "dropphyadd": "6400 HIGHWAY 28 E",
    "dropphycty": "LIBUSE",
    "dropphyst": "LA",
    "dropphyzpp": 713489998,
    "dropmaladd": "6400 HIGHWAY 28 E",
    "dropmalcty": "LIBUSE",
    "dropmalst": "LA",
    "dropmalzpp": 713489998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184488364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24037",
    "droptype": "D",
    "dropname": "LILLIE",
    "dropdeladd": "113 HIGHWAY 15",
    "dropdelcty": "LILLIE",
    "dropdelst": "LA",
    "dropdelzpp": 712569998,
    "dropphyadd": "113 HIGHWAY 15",
    "dropphycty": "LILLIE",
    "dropphyst": "LA",
    "dropphyzpp": 712569998,
    "dropmaladd": "113 HIGHWAY 15",
    "dropmalcty": "LILLIE",
    "dropmalst": "LA",
    "dropmalzpp": 712569998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182857082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24040",
    "droptype": "D",
    "dropname": "LISBON",
    "dropdeladd": "20018 HIGHWAY 2",
    "dropdelcty": "LISBON",
    "dropdelst": "LA",
    "dropdelzpp": 710489998,
    "dropphyadd": "20018 HIGHWAY 2",
    "dropphycty": "LISBON",
    "dropphyst": "LA",
    "dropphyzpp": 710489998,
    "dropmaladd": "20018 HIGHWAY 2",
    "dropmalcty": "LISBON",
    "dropmalst": "LA",
    "dropmalzpp": 710489998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183531420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24046",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "29728 S FROST RD",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "LA",
    "dropdelzpp": 707549998,
    "dropphyadd": "29728 S FROST RD",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "LA",
    "dropphyzpp": 707549998,
    "dropmaladd": "29728 S FROST RD",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "LA",
    "dropmalzpp": 707549998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256863706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24047",
    "droptype": "D",
    "dropname": "LIVONIA",
    "dropdeladd": "3050 LA HIGHWAY 78",
    "dropdelcty": "LIVONIA",
    "dropdelst": "LA",
    "dropdelzpp": 707559998,
    "dropphyadd": "3050 LA HIGHWAY 78",
    "dropphycty": "LIVONIA",
    "dropphyst": "LA",
    "dropphyzpp": 707559998,
    "dropmaladd": "3050 LA HIGHWAY 78",
    "dropmalcty": "LIVONIA",
    "dropmalst": "LA",
    "dropmalzpp": 707559998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256373603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24050",
    "droptype": "D",
    "dropname": "LOCKPORT",
    "dropdeladd": "706 CRESCENT AVE",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "LA",
    "dropdelzpp": 703749998,
    "dropphyadd": "706 CRESCENT AVE",
    "dropphycty": "LOCKPORT",
    "dropphyst": "LA",
    "dropphyzpp": 703749998,
    "dropmaladd": "706 CRESCENT AVE",
    "dropmalcty": "LOCKPORT",
    "dropmalst": "LA",
    "dropmalzpp": 703749998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855328924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24053",
    "droptype": "D",
    "dropname": "LOGANSPORT",
    "dropdeladd": "108 N 4TH ST",
    "dropdelcty": "LOGANSPORT",
    "dropdelst": "LA",
    "dropdelzpp": 710499998,
    "dropphyadd": "108 N 4TH ST",
    "dropphycty": "LOGANSPORT",
    "dropphyst": "LA",
    "dropphyzpp": 710499998,
    "dropmaladd": "108 N 4TH ST",
    "dropmalcty": "LOGANSPORT",
    "dropmalst": "LA",
    "dropmalzpp": 710499998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186972388,
    "dropfax": 3186974395
  },
  {
    "dcode": "D",
    "dropkey": "PY24059",
    "droptype": "D",
    "dropname": "LONGLEAF",
    "dropdeladd": "76 LONG LEAF RD",
    "dropdelcty": "LONGLEAF",
    "dropdelst": "LA",
    "dropdelzpp": 714489998,
    "dropphyadd": "76 LONG LEAF RD",
    "dropphycty": "LONGLEAF",
    "dropphyst": "LA",
    "dropphyzpp": 714489998,
    "dropmaladd": "76 LONG LEAF RD",
    "dropmalcty": "LONGLEAF",
    "dropmalst": "LA",
    "dropmalzpp": 714489998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187484446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24061",
    "droptype": "D",
    "dropname": "LONGVILLE",
    "dropdeladd": "126 LONGVILLE RD",
    "dropdelcty": "LONGVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 706529998,
    "dropphyadd": "126 LONGVILLE RD",
    "dropphycty": "LONGVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 706529998,
    "dropmaladd": "126 LONGVILLE RD",
    "dropmalcty": "LONGVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 706529998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377259062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24062",
    "droptype": "D",
    "dropname": "LORANGER",
    "dropdeladd": "19438 HIGHWAY 40",
    "dropdelcty": "LORANGER",
    "dropdelst": "LA",
    "dropdelzpp": 704469998,
    "dropphyadd": "19438 HIGHWAY 40",
    "dropphycty": "LORANGER",
    "dropphyst": "LA",
    "dropphyzpp": 704469998,
    "dropmaladd": "19438 HIGHWAY 40",
    "dropmalcty": "LORANGER",
    "dropmalst": "LA",
    "dropmalzpp": 704469998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858780594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24063",
    "droptype": "D",
    "dropname": "LOREAUVILLE",
    "dropdeladd": "123 BOUTTE RD",
    "dropdelcty": "LOREAUVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705522037,
    "dropphyadd": "123 BOUTTE RD",
    "dropphycty": "LOREAUVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705522037,
    "dropmaladd": "123 BOUTTE RD",
    "dropmalcty": "LOREAUVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705522037,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372297825,
    "dropfax": 3372294540
  },
  {
    "dcode": "D",
    "dropkey": "PY24064",
    "droptype": "D",
    "dropname": "LOTTIE",
    "dropdeladd": "5422 LA 81 E",
    "dropdelcty": "LOTTIE",
    "dropdelst": "LA",
    "dropdelzpp": 707569998,
    "dropphyadd": "5422 LA 81 E",
    "dropphycty": "LOTTIE",
    "dropphyst": "LA",
    "dropphyzpp": 707569998,
    "dropmaladd": "5422 LA 81 E",
    "dropmalcty": "LOTTIE",
    "dropmalst": "LA",
    "dropmalzpp": 707569998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256372952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24075",
    "droptype": "D",
    "dropname": "LULING",
    "dropdeladd": "1363 PAUL MAILLARD RD",
    "dropdelcty": "LULING",
    "dropdelst": "LA",
    "dropdelzpp": 700709998,
    "dropphyadd": "1363 PAUL MAILLARD RD",
    "dropphycty": "LULING",
    "dropphyst": "LA",
    "dropphyzpp": 700709998,
    "dropmaladd": "1363 PAUL MAILLARD RD",
    "dropmalcty": "LULING",
    "dropmalst": "LA",
    "dropmalzpp": 700709998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857857184,
    "dropfax": 9857851994
  },
  {
    "dcode": "D",
    "dropkey": "PY24077",
    "droptype": "D",
    "dropname": "LUTCHER",
    "dropdeladd": "2317 TEXAS ST",
    "dropdelcty": "LUTCHER",
    "dropdelst": "LA",
    "dropdelzpp": 700719998,
    "dropphyadd": "2317 TEXAS ST",
    "dropphycty": "LUTCHER",
    "dropphyst": "LA",
    "dropphyzpp": 700719998,
    "dropmaladd": "2317 TEXAS ST",
    "dropmalcty": "LUTCHER",
    "dropmalst": "LA",
    "dropmalzpp": 700719998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2258695457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24078",
    "droptype": "D",
    "dropname": "LYDIA",
    "dropdeladd": "4013 DARNELL RD",
    "dropdelcty": "LYDIA",
    "dropdelst": "LA",
    "dropdelzpp": 705699998,
    "dropphyadd": "4013 DARNELL RD",
    "dropphycty": "LYDIA",
    "dropphyst": "LA",
    "dropphyzpp": 705699998,
    "dropmaladd": "4013 DARNELL RD",
    "dropmalcty": "LYDIA",
    "dropmalst": "LA",
    "dropmalzpp": 705699998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373655590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24082",
    "droptype": "D",
    "dropname": "MADISONVILLE",
    "dropdeladd": "100 COVINGTON ST",
    "dropdelcty": "MADISONVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 704479998,
    "dropphyadd": "100 COVINGTON ST",
    "dropphycty": "MADISONVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 704479998,
    "dropmaladd": "100 COVINGTON ST",
    "dropmalcty": "MADISONVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 704479998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858450594,
    "dropfax": 9858450594
  },
  {
    "dcode": "D",
    "dropkey": "PY24088",
    "droptype": "D",
    "dropname": "MAMOU",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "MAMOU",
    "dropdelst": "LA",
    "dropdelzpp": 705543736,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "MAMOU",
    "dropphyst": "LA",
    "dropphyzpp": 705543736,
    "dropmaladd": "500 MAIN ST",
    "dropmalcty": "MAMOU",
    "dropmalst": "LA",
    "dropmalzpp": 705549998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374682750,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24089",
    "droptype": "D",
    "dropname": "MANDEVILLE",
    "dropdeladd": "1 SAINT ANN DR",
    "dropdelcty": "MANDEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 704719998,
    "dropphyadd": "1 SAINT ANN DR",
    "dropphycty": "MANDEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 704719998,
    "dropmaladd": "1 SAINT ANN DR",
    "dropmalcty": "MANDEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 704719998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856267283,
    "dropfax": 9856264555
  },
  {
    "dcode": "D",
    "dropkey": "PY24090",
    "droptype": "D",
    "dropname": "MANGHAM",
    "dropdeladd": "102 LOUISIANA ST",
    "dropdelcty": "MANGHAM",
    "dropdelst": "LA",
    "dropdelzpp": 712599998,
    "dropphyadd": "102 LOUISIANA ST",
    "dropphycty": "MANGHAM",
    "dropphyst": "LA",
    "dropphyzpp": 712599998,
    "dropmaladd": "102 LOUISIANA ST",
    "dropmalcty": "MANGHAM",
    "dropmalst": "LA",
    "dropmalzpp": 712599998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182482417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24092",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "100 CROSBY ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "LA",
    "dropdelzpp": 710529998,
    "dropphyadd": "100 CROSBY ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "LA",
    "dropphyzpp": 710529998,
    "dropmaladd": "100 CROSBY ST",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "LA",
    "dropmalzpp": 710529998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188724819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24093",
    "droptype": "D",
    "dropname": "MANSURA",
    "dropdeladd": "2109 LEGLISE ST",
    "dropdelcty": "MANSURA",
    "dropdelst": "LA",
    "dropdelzpp": 713509998,
    "dropphyadd": "2109 LEGLISE ST",
    "dropphycty": "MANSURA",
    "dropphyst": "LA",
    "dropphyzpp": 713509998,
    "dropmaladd": "2109 LEGLISE ST",
    "dropmalcty": "MANSURA",
    "dropmalst": "LA",
    "dropmalzpp": 713509998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189645102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24095",
    "droptype": "D",
    "dropname": "MANY",
    "dropdeladd": "490 CHURCH ST",
    "dropdelcty": "MANY",
    "dropdelst": "LA",
    "dropdelzpp": 714499998,
    "dropphyadd": "490 CHURCH ST",
    "dropphycty": "MANY",
    "dropphyst": "LA",
    "dropphyzpp": 714499998,
    "dropmaladd": "490 CHURCH ST",
    "dropmalcty": "MANY",
    "dropmalst": "LA",
    "dropmalzpp": 714499998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182563022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24097",
    "droptype": "D",
    "dropname": "MARINGOUIN",
    "dropdeladd": "77330 LANDRY DR",
    "dropdelcty": "MARINGOUIN",
    "dropdelst": "LA",
    "dropdelzpp": 707579998,
    "dropphyadd": "77330 LANDRY DR",
    "dropphycty": "MARINGOUIN",
    "dropphyst": "LA",
    "dropphyzpp": 707579998,
    "dropmaladd": "77330 LANDRY DR",
    "dropmalcty": "MARINGOUIN",
    "dropmalst": "LA",
    "dropmalzpp": 707579998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256252711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24098",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "MARION",
    "dropdelst": "LA",
    "dropdelzpp": 712609998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "MARION",
    "dropphyst": "LA",
    "dropphyzpp": 712609998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "MARION",
    "dropmalst": "LA",
    "dropmalzpp": 712609998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182924149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24099",
    "droptype": "D",
    "dropname": "MARKSVILLE",
    "dropdeladd": "226 W CAPPEL ST",
    "dropdelcty": "MARKSVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713519998,
    "dropphyadd": "226 W CAPPEL ST",
    "dropphycty": "MARKSVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713519998,
    "dropmaladd": "226 W CAPPEL ST",
    "dropmalcty": "MARKSVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713519998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182535439,
    "dropfax": 3182535963
  },
  {
    "dcode": "D",
    "dropkey": "PY24100",
    "droptype": "D",
    "dropname": "MARRERO",
    "dropdeladd": "5351 LAPALCO BLVD",
    "dropdelcty": "MARRERO",
    "dropdelst": "LA",
    "dropdelzpp": 700729998,
    "dropphyadd": "5351 LAPALCO BLVD",
    "dropphycty": "MARRERO",
    "dropphyst": "LA",
    "dropphyzpp": 700729998,
    "dropmaladd": "5351 LAPALCO BLVD",
    "dropmalcty": "MARRERO",
    "dropmalst": "LA",
    "dropmalzpp": 700729998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043415786,
    "dropfax": 5043411728
  },
  {
    "dcode": "D",
    "dropkey": "PY24102",
    "droptype": "D",
    "dropname": "MARTHAVILLE",
    "dropdeladd": "10644 HIGHWAY 120",
    "dropdelcty": "MARTHAVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 714509998,
    "dropphyadd": "10644 HIGHWAY 120",
    "dropphycty": "MARTHAVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 714509998,
    "dropmaladd": "10644 HIGHWAY 120",
    "dropmalcty": "MARTHAVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 714509998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184729942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24104",
    "droptype": "D",
    "dropname": "MATHEWS",
    "dropdeladd": "4884 HIGHWAY 1 STE 4",
    "dropdelcty": "MATHEWS",
    "dropdelst": "LA",
    "dropdelzpp": 703759998,
    "dropphyadd": "4884 HIGHWAY 1 STE 4",
    "dropphycty": "MATHEWS",
    "dropphyst": "LA",
    "dropphyzpp": 703759998,
    "dropmaladd": "4884 HIGHWAY 1 STE 4",
    "dropmalcty": "MATHEWS",
    "dropmalst": "LA",
    "dropmalzpp": 703759998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855321789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24105",
    "droptype": "D",
    "dropname": "MAUREPAS",
    "dropdeladd": "23839 HIGHWAY 22",
    "dropdelcty": "MAUREPAS",
    "dropdelst": "LA",
    "dropdelzpp": 704499998,
    "dropphyadd": "23839 HIGHWAY 22",
    "dropphycty": "MAUREPAS",
    "dropphyst": "LA",
    "dropphyzpp": 704499998,
    "dropmaladd": "23839 HIGHWAY 22",
    "dropmalcty": "MAUREPAS",
    "dropmalst": "LA",
    "dropmalzpp": 704499998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2256953104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24106",
    "droptype": "D",
    "dropname": "MAURICE",
    "dropdeladd": "209 JOHN ST",
    "dropdelcty": "MAURICE",
    "dropdelst": "LA",
    "dropdelzpp": 705559998,
    "dropphyadd": "209 JOHN ST",
    "dropphycty": "MAURICE",
    "dropphyst": "LA",
    "dropphyzpp": 705559998,
    "dropmaladd": "209 JOHN ST",
    "dropmalcty": "MAURICE",
    "dropmalst": "LA",
    "dropmalzpp": 705559998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378936451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24122",
    "droptype": "D",
    "dropname": "MELVILLE",
    "dropdeladd": "522 CHURCH ST",
    "dropdelcty": "MELVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713539998,
    "dropphyadd": "522 CHURCH ST",
    "dropphycty": "MELVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713539998,
    "dropmaladd": "522 CHURCH ST",
    "dropmalcty": "MELVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713539998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3376234658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24123",
    "droptype": "D",
    "dropname": "MER ROUGE",
    "dropdeladd": "405 DAVENPORT AVE",
    "dropdelcty": "MER ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 712619998,
    "dropphyadd": "405 DAVENPORT AVE",
    "dropphycty": "MER ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 712619998,
    "dropmaladd": "405 DAVENPORT AVE",
    "dropmalcty": "MER ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 712619998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186473041,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24124",
    "droptype": "D",
    "dropname": "MERAUX",
    "dropdeladd": "4217 E JUDGE PEREZ DR STE C",
    "dropdelcty": "MERAUX",
    "dropdelst": "LA",
    "dropdelzpp": 700752645,
    "dropphyadd": "4217 E JUDGE PEREZ DR STE C",
    "dropphycty": "MERAUX",
    "dropphyst": "LA",
    "dropphyzpp": 700752645,
    "dropmaladd": "4217 E JUDGE PEREZ DR STE C",
    "dropmalcty": "MERAUX",
    "dropmalst": "LA",
    "dropmalzpp": 700752645,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046821995,
    "dropfax": 5042769620
  },
  {
    "dcode": "D",
    "dropkey": "PY24126",
    "droptype": "D",
    "dropname": "MERMENTAU",
    "dropdeladd": "101 7TH ST",
    "dropdelcty": "MERMENTAU",
    "dropdelst": "LA",
    "dropdelzpp": 705563000,
    "dropphyadd": "101 7TH ST",
    "dropphycty": "MERMENTAU",
    "dropphyst": "LA",
    "dropphyzpp": 705563000,
    "dropmaladd": "PO BOX 5600",
    "dropmalcty": "MERMENTAU",
    "dropmalst": "LA",
    "dropmalzpp": 705569998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378244752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24127",
    "droptype": "D",
    "dropname": "MERRYVILLE",
    "dropdeladd": "3035 HIGHWAY 110 W",
    "dropdelcty": "MERRYVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 706539998,
    "dropphyadd": "3035 HIGHWAY 110 W",
    "dropphycty": "MERRYVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 706539998,
    "dropmaladd": "3035 HIGHWAY 110 W",
    "dropmalcty": "MERRYVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 706539998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378257374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24128",
    "droptype": "D",
    "dropname": "METAIRIE",
    "dropdeladd": "3301 17TH ST",
    "dropdelcty": "METAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 700029998,
    "dropphyadd": "3301 17TH ST",
    "dropphycty": "METAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 700029998,
    "dropmaladd": "3301 17TH ST",
    "dropmalcty": "METAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 700029998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048286058,
    "dropfax": 5048317119
  },
  {
    "dcode": "D",
    "dropkey": "PY24141",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "109 ESPASIE ST",
    "dropdelcty": "MILTON",
    "dropdelst": "LA",
    "dropdelzpp": 705589998,
    "dropphyadd": "109 ESPASIE ST",
    "dropphycty": "MILTON",
    "dropphyst": "LA",
    "dropphyzpp": 705589998,
    "dropmaladd": "109 ESPASIE ST",
    "dropmalcty": "MILTON",
    "dropmalst": "LA",
    "dropmalzpp": 705589998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378564592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24142",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "111 S MONROE ST",
    "dropdelcty": "MINDEN",
    "dropdelst": "LA",
    "dropdelzpp": 710559998,
    "dropphyadd": "111 S MONROE ST",
    "dropphycty": "MINDEN",
    "dropphyst": "LA",
    "dropphyzpp": 710559998,
    "dropmaladd": "111 S MONROE ST",
    "dropmalcty": "MINDEN",
    "dropmalst": "LA",
    "dropmalzpp": 710559998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183778372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24149",
    "droptype": "D",
    "dropname": "MITTIE",
    "dropdeladd": "12330 HIGHWAY 26",
    "dropdelcty": "MITTIE",
    "dropdelst": "LA",
    "dropdelzpp": 706542101,
    "dropphyadd": "12330 HIGHWAY 26",
    "dropphycty": "MITTIE",
    "dropphyst": "LA",
    "dropphyzpp": 706542101,
    "dropmaladd": "PO BOX 5400",
    "dropmalcty": "MITTIE",
    "dropmalst": "LA",
    "dropmalzpp": 706549998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376393301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24156",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "501 STERLINGTON RD",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712039998,
    "dropphyadd": "501 STERLINGTON RD",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712039998,
    "dropmaladd": "501 STERLINGTON RD",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712039998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183876162,
    "dropfax": 3183241329
  },
  {
    "dcode": "D",
    "dropkey": "PY24159",
    "droptype": "D",
    "dropname": "MONTEGUT",
    "dropdeladd": "1225 HIGHWAY 55",
    "dropdelcty": "MONTEGUT",
    "dropdelst": "LA",
    "dropdelzpp": 703779998,
    "dropphyadd": "1225 HIGHWAY 55",
    "dropphycty": "MONTEGUT",
    "dropphyst": "LA",
    "dropphyzpp": 703779998,
    "dropmaladd": "1225 HIGHWAY 55",
    "dropmalcty": "MONTEGUT",
    "dropmalst": "LA",
    "dropmalzpp": 703779998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855944608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24160",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "6212 HIGHWAY 129",
    "dropdelcty": "MONTEREY",
    "dropdelst": "LA",
    "dropdelzpp": 713549998,
    "dropphyadd": "6212 HIGHWAY 129",
    "dropphycty": "MONTEREY",
    "dropphyst": "LA",
    "dropphyzpp": 713549998,
    "dropmaladd": "6212 HIGHWAY 129",
    "dropmalcty": "MONTEREY",
    "dropmalst": "LA",
    "dropmalzpp": 713549998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183864258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24161",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "509 WOODLAND ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "LA",
    "dropdelzpp": 714549998,
    "dropphyadd": "509 WOODLAND ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "LA",
    "dropphyzpp": 714549998,
    "dropmaladd": "509 WOODLAND ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "LA",
    "dropmalzpp": 714549998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186463826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24168",
    "droptype": "D",
    "dropname": "MOORINGSPORT",
    "dropdeladd": "117 CROOM ST",
    "dropdelcty": "MOORINGSPORT",
    "dropdelst": "LA",
    "dropdelzpp": 710609998,
    "dropphyadd": "117 CROOM ST",
    "dropphycty": "MOORINGSPORT",
    "dropphyst": "LA",
    "dropphyzpp": 710609998,
    "dropmaladd": "117 CROOM ST",
    "dropmalcty": "MOORINGSPORT",
    "dropmalst": "LA",
    "dropmalzpp": 710609998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189960514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24170",
    "droptype": "D",
    "dropname": "MOREAUVILLE",
    "dropdeladd": "211 MAIN ST",
    "dropdelcty": "MOREAUVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713559998,
    "dropphyadd": "211 MAIN ST",
    "dropphycty": "MOREAUVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713559998,
    "dropmaladd": "211 MAIN ST",
    "dropmalcty": "MOREAUVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713559998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189852594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24172",
    "droptype": "D",
    "dropname": "MORGAN CITY",
    "dropdeladd": "1112 BRASHEAR AVE",
    "dropdelcty": "MORGAN CITY",
    "dropdelst": "LA",
    "dropdelzpp": 703809998,
    "dropphyadd": "1112 BRASHEAR AVE",
    "dropphycty": "MORGAN CITY",
    "dropphyst": "LA",
    "dropphyzpp": 703809998,
    "dropmaladd": "1112 BRASHEAR AVE",
    "dropmalcty": "MORGAN CITY",
    "dropmalst": "LA",
    "dropmalzpp": 703809998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853840278,
    "dropfax": 9853840254
  },
  {
    "dcode": "D",
    "dropkey": "PY24175",
    "droptype": "D",
    "dropname": "MORGANZA",
    "dropdeladd": "1081 S LA 1",
    "dropdelcty": "MORGANZA",
    "dropdelst": "LA",
    "dropdelzpp": 707599998,
    "dropphyadd": "1081 S LA 1",
    "dropphycty": "MORGANZA",
    "dropphyst": "LA",
    "dropphyzpp": 707599998,
    "dropmaladd": "1081 S LA 1",
    "dropmalcty": "MORGANZA",
    "dropmalst": "LA",
    "dropmalzpp": 707599998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256943963,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24177",
    "droptype": "D",
    "dropname": "MORROW",
    "dropdeladd": "173 HIGHWAY 107",
    "dropdelcty": "MORROW",
    "dropdelst": "LA",
    "dropdelzpp": 713569998,
    "dropphyadd": "173 HIGHWAY 107",
    "dropphycty": "MORROW",
    "dropphyst": "LA",
    "dropphyzpp": 713569998,
    "dropmaladd": "173 HIGHWAY 107",
    "dropmalcty": "MORROW",
    "dropmalst": "LA",
    "dropmalzpp": 713569998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183464169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24178",
    "droptype": "D",
    "dropname": "MORSE",
    "dropdeladd": "110 E WHITNEY ST",
    "dropdelcty": "MORSE",
    "dropdelst": "LA",
    "dropdelzpp": 705599998,
    "dropphyadd": "110 E WHITNEY ST",
    "dropphycty": "MORSE",
    "dropphyst": "LA",
    "dropphyzpp": 705599998,
    "dropmaladd": "110 E WHITNEY ST",
    "dropmalcty": "MORSE",
    "dropmalst": "LA",
    "dropmalzpp": 705599998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377830368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24185",
    "droptype": "D",
    "dropname": "MOUNT HERMON",
    "dropdeladd": "36043 HIGHWAY 438",
    "dropdelcty": "MOUNT HERMON",
    "dropdelst": "LA",
    "dropdelzpp": 704509998,
    "dropphyadd": "36043 HIGHWAY 438",
    "dropphycty": "MOUNT HERMON",
    "dropphyst": "LA",
    "dropphyzpp": 704509998,
    "dropmaladd": "36043 HIGHWAY 438",
    "dropmalcty": "MOUNT HERMON",
    "dropmalst": "LA",
    "dropmalzpp": 704509998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858775772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24196",
    "droptype": "D",
    "dropname": "NAPOLEONVILLE",
    "dropdeladd": "181 HIGHWAY 401",
    "dropdelcty": "NAPOLEONVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 703902911,
    "dropphyadd": "181 HIGHWAY 401",
    "dropphycty": "NAPOLEONVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 703909998,
    "dropmaladd": "181 HIGHWAY 401",
    "dropmalcty": "NAPOLEONVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 703902911,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853699516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24198",
    "droptype": "D",
    "dropname": "NATALBANY",
    "dropdeladd": "15036 HIGHWAY 1064",
    "dropdelcty": "NATALBANY",
    "dropdelst": "LA",
    "dropdelzpp": 704519998,
    "dropphyadd": "15036 HIGHWAY 1064",
    "dropphycty": "NATALBANY",
    "dropphyst": "LA",
    "dropphyzpp": 704519998,
    "dropmaladd": "15036 HIGHWAY 1064",
    "dropmalcty": "NATALBANY",
    "dropmalst": "LA",
    "dropmalzpp": 704519998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855428629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24200",
    "droptype": "D",
    "dropname": "NATCHEZ",
    "dropdeladd": "9465 HIGHWAY 1",
    "dropdelcty": "NATCHEZ",
    "dropdelst": "LA",
    "dropdelzpp": 714569998,
    "dropphyadd": "9465 HIGHWAY 1",
    "dropphycty": "NATCHEZ",
    "dropphyst": "LA",
    "dropphyzpp": 714569998,
    "dropmaladd": "9465 HIGHWAY 1",
    "dropmalcty": "NATCHEZ",
    "dropmalst": "LA",
    "dropmalzpp": 714569998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183578409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24201",
    "droptype": "D",
    "dropname": "NATCHITOCHES",
    "dropdeladd": "240 SAINT DENIS ST",
    "dropdelcty": "NATCHITOCHES",
    "dropdelst": "LA",
    "dropdelzpp": 714579998,
    "dropphyadd": "240 SAINT DENIS ST",
    "dropphycty": "NATCHITOCHES",
    "dropphyst": "LA",
    "dropphyzpp": 714579998,
    "dropmaladd": "240 SAINT DENIS ST",
    "dropmalcty": "NATCHITOCHES",
    "dropmalst": "LA",
    "dropmalzpp": 714579998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183571669,
    "dropfax": 3183523022
  },
  {
    "dcode": "D",
    "dropkey": "PY24209",
    "droptype": "D",
    "dropname": "NEGREET",
    "dropdeladd": "4226 HIGHWAY 476",
    "dropdelcty": "NEGREET",
    "dropdelst": "LA",
    "dropdelzpp": 714609998,
    "dropphyadd": "4226 HIGHWAY 476",
    "dropphycty": "NEGREET",
    "dropphyst": "LA",
    "dropphyzpp": 714609998,
    "dropmaladd": "4226 HIGHWAY 476",
    "dropmalcty": "NEGREET",
    "dropmalst": "LA",
    "dropmalzpp": 714609998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182566870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24214",
    "droptype": "D",
    "dropname": "NEW IBERIA",
    "dropdeladd": "817 E DALE ST",
    "dropdelcty": "NEW IBERIA",
    "dropdelst": "LA",
    "dropdelzpp": 705605598,
    "dropphyadd": "817 E DALE ST",
    "dropphycty": "NEW IBERIA",
    "dropphyst": "LA",
    "dropphyzpp": 705605598,
    "dropmaladd": "817 E DALE ST",
    "dropmalcty": "NEW IBERIA",
    "dropmalst": "LA",
    "dropmalzpp": 705605598,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694849,
    "dropsitcph": 3373646972,
    "dropfax": 3373655333
  },
  {
    "dcode": "D",
    "dropkey": "PY24219",
    "droptype": "D",
    "dropname": "NEW ORLEANS",
    "dropdeladd": "701 LOYOLA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701131952,
    "dropphyadd": "701 LOYOLA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701131952,
    "dropmaladd": "701 LOYOLA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701131952,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045891714,
    "dropfax": 5045891217
  },
  {
    "dcode": "D",
    "dropkey": "PY24223",
    "droptype": "D",
    "dropname": "NEW ROADS",
    "dropdeladd": "148 NEW ROADS ST",
    "dropdelcty": "NEW ROADS",
    "dropdelst": "LA",
    "dropdelzpp": 707609998,
    "dropphyadd": "148 NEW ROADS ST",
    "dropphycty": "NEW ROADS",
    "dropphyst": "LA",
    "dropphyzpp": 707609998,
    "dropmaladd": "148 NEW ROADS ST",
    "dropmalcty": "NEW ROADS",
    "dropmalst": "LA",
    "dropmalzpp": 707609998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256388990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24226",
    "droptype": "D",
    "dropname": "NEW SARPY",
    "dropdeladd": "14394 RIVER RD",
    "dropdelcty": "NEW SARPY",
    "dropdelst": "LA",
    "dropdelzpp": 700789998,
    "dropphyadd": "14394 RIVER RD",
    "dropphycty": "NEW SARPY",
    "dropphyst": "LA",
    "dropphyzpp": 700789998,
    "dropmaladd": "14394 RIVER RD",
    "dropmalcty": "NEW SARPY",
    "dropmalst": "LA",
    "dropmalzpp": 700789998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857640918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24229",
    "droptype": "D",
    "dropname": "NEWELLTON",
    "dropdeladd": "930 VERONA ST",
    "dropdelcty": "NEWELLTON",
    "dropdelst": "LA",
    "dropdelzpp": 713579998,
    "dropphyadd": "930 VERONA ST",
    "dropphycty": "NEWELLTON",
    "dropphyst": "LA",
    "dropphyzpp": 713579998,
    "dropmaladd": "930 VERONA ST",
    "dropmalcty": "NEWELLTON",
    "dropmalst": "LA",
    "dropmalzpp": 713579998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184672362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24231",
    "droptype": "D",
    "dropname": "NEW LLANO",
    "dropdeladd": "330 VERNON ST",
    "dropdelcty": "NEW LLANO",
    "dropdelst": "LA",
    "dropdelzpp": 714619998,
    "dropphyadd": "330 VERNON ST",
    "dropphycty": "NEW LLANO",
    "dropphyst": "LA",
    "dropphyzpp": 714619998,
    "dropmaladd": "330 VERNON ST",
    "dropmalcty": "NEW LLANO",
    "dropmalst": "LA",
    "dropmalzpp": 714619998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3372385769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24235",
    "droptype": "D",
    "dropname": "NOBLE",
    "dropdeladd": "820 HIGHWAY 1218",
    "dropdelcty": "NOBLE",
    "dropdelst": "LA",
    "dropdelzpp": 714629998,
    "dropphyadd": "820 HIGHWAY 1218",
    "dropphycty": "NOBLE",
    "dropphyst": "LA",
    "dropphyzpp": 714629998,
    "dropmaladd": "820 HIGHWAY 1218",
    "dropmalcty": "NOBLE",
    "dropmalst": "LA",
    "dropmalzpp": 714629998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186459344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24237",
    "droptype": "D",
    "dropname": "NORCO",
    "dropdeladd": "558 APPLE ST",
    "dropdelcty": "NORCO",
    "dropdelst": "LA",
    "dropdelzpp": 700799998,
    "dropphyadd": "558 APPLE ST",
    "dropphycty": "NORCO",
    "dropphyst": "LA",
    "dropphyzpp": 700799998,
    "dropmaladd": "558 APPLE ST",
    "dropmalcty": "NORCO",
    "dropmalst": "LA",
    "dropmalzpp": 700799998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857646903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24247",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "3822 CAMELLIA ST",
    "dropdelcty": "NORWOOD",
    "dropdelst": "LA",
    "dropdelzpp": 707619998,
    "dropphyadd": "3822 CAMELLIA ST",
    "dropphycty": "NORWOOD",
    "dropphyst": "LA",
    "dropphyzpp": 707619998,
    "dropmaladd": "3822 CAMELLIA ST",
    "dropmalcty": "NORWOOD",
    "dropmalst": "LA",
    "dropmalzpp": 707619998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256290484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24252",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "105 S BRIGGS ST",
    "dropdelcty": "OAK GROVE",
    "dropdelst": "LA",
    "dropdelzpp": 712639998,
    "dropphyadd": "105 S BRIGGS ST",
    "dropphycty": "OAK GROVE",
    "dropphyst": "LA",
    "dropphyzpp": 712639998,
    "dropmaladd": "105 S BRIGGS ST",
    "dropmalcty": "OAK GROVE",
    "dropmalst": "LA",
    "dropmalzpp": 712639998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184285204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24254",
    "droptype": "D",
    "dropname": "OAK RIDGE",
    "dropdeladd": "100 S OAK ST",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "LA",
    "dropdelzpp": 712649998,
    "dropphyadd": "100 S OAK ST",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "LA",
    "dropphyzpp": 712649998,
    "dropmaladd": "100 S OAK ST",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "LA",
    "dropmalzpp": 712649998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182447201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24256",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "240 E 6TH AVE",
    "dropdelcty": "OAKDALE",
    "dropdelst": "LA",
    "dropdelzpp": 714639998,
    "dropphyadd": "240 E 6TH AVE",
    "dropphycty": "OAKDALE",
    "dropphyst": "LA",
    "dropphyzpp": 714639998,
    "dropmaladd": "240 E 6TH AVE",
    "dropmalcty": "OAKDALE",
    "dropmalst": "LA",
    "dropmalzpp": 714639998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183359809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24261",
    "droptype": "D",
    "dropname": "OBERLIN",
    "dropdeladd": "110 N SEVENTH ST",
    "dropdelcty": "OBERLIN",
    "dropdelst": "LA",
    "dropdelzpp": 706559998,
    "dropphyadd": "110 N SEVENTH ST",
    "dropphycty": "OBERLIN",
    "dropphyst": "LA",
    "dropphyzpp": 706559998,
    "dropmaladd": "110 N SEVENTH ST",
    "dropmalcty": "OBERLIN",
    "dropmalst": "LA",
    "dropmalzpp": 706559998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376392367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24265",
    "droptype": "D",
    "dropname": "OIL CITY",
    "dropdeladd": "200 FURMAN ST",
    "dropdelcty": "OIL CITY",
    "dropdelst": "LA",
    "dropdelzpp": 710619998,
    "dropphyadd": "200 FURMAN ST",
    "dropphycty": "OIL CITY",
    "dropphyst": "LA",
    "dropphyzpp": 710619998,
    "dropmaladd": "200 FURMAN ST",
    "dropmalcty": "OIL CITY",
    "dropmalst": "LA",
    "dropmalzpp": 710619998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189957836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24272",
    "droptype": "D",
    "dropname": "OLLA",
    "dropdeladd": "3470 MAIN STREET 165",
    "dropdelcty": "OLLA",
    "dropdelst": "LA",
    "dropdelzpp": 714659998,
    "dropphyadd": "3470 MAIN STREET 165",
    "dropphycty": "OLLA",
    "dropphyst": "LA",
    "dropphyzpp": 714659998,
    "dropmaladd": "3470 MAIN STREET 165",
    "dropmalcty": "OLLA",
    "dropmalst": "LA",
    "dropmalzpp": 714659998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184955603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24276",
    "droptype": "D",
    "dropname": "OPELOUSAS",
    "dropdeladd": "152 WALLIOR ST",
    "dropdelcty": "OPELOUSAS",
    "dropdelst": "LA",
    "dropdelzpp": 705709998,
    "dropphyadd": "152 WALLIOR ST",
    "dropphycty": "OPELOUSAS",
    "dropphyst": "LA",
    "dropphyzpp": 705709998,
    "dropmaladd": "152 WALLIOR ST",
    "dropmalcty": "OPELOUSAS",
    "dropmalst": "LA",
    "dropmalzpp": 705709998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3379487623,
    "dropfax": 3379428157
  },
  {
    "dcode": "D",
    "dropkey": "PY24278",
    "droptype": "D",
    "dropname": "OSCAR",
    "dropdeladd": "8105 FALSE RIVER RD",
    "dropdelcty": "OSCAR",
    "dropdelst": "LA",
    "dropdelzpp": 707629998,
    "dropphyadd": "8105 FALSE RIVER RD",
    "dropphycty": "OSCAR",
    "dropphyst": "LA",
    "dropphyzpp": 707629998,
    "dropmaladd": "8105 FALSE RIVER RD",
    "dropmalcty": "OSCAR",
    "dropmalst": "LA",
    "dropmalzpp": 707629998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256386524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24280",
    "droptype": "D",
    "dropname": "OTIS",
    "dropdeladd": "2951 HIGHWAY 121",
    "dropdelcty": "OTIS",
    "dropdelst": "LA",
    "dropdelzpp": 714669998,
    "dropphyadd": "2951 HIGHWAY 121",
    "dropphycty": "OTIS",
    "dropphyst": "LA",
    "dropphyzpp": 714669998,
    "dropmaladd": "2951 HIGHWAY 121",
    "dropmalcty": "OTIS",
    "dropmalst": "LA",
    "dropmalzpp": 714669998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187935671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24283",
    "droptype": "D",
    "dropname": "PAINCOURTVILLE",
    "dropdeladd": "6075 HIGHWAY 1",
    "dropdelcty": "PAINCOURTVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 703919998,
    "dropphyadd": "6075 HIGHWAY 1",
    "dropphycty": "PAINCOURTVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 703919998,
    "dropmaladd": "6075 HIGHWAY 1",
    "dropmalcty": "PAINCOURTVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 703919998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853692735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24285",
    "droptype": "D",
    "dropname": "PALMETTO",
    "dropdeladd": "214 E RAILROAD AVE STE B",
    "dropdelcty": "PALMETTO",
    "dropdelst": "LA",
    "dropdelzpp": 713589998,
    "dropphyadd": "214 E RAILROAD AVE STE B",
    "dropphycty": "PALMETTO",
    "dropphyst": "LA",
    "dropphyzpp": 713589998,
    "dropmaladd": "214 E RAILROAD AVE STE B",
    "dropmalcty": "PALMETTO",
    "dropmalst": "LA",
    "dropmalzpp": 713589998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3376234486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24287",
    "droptype": "D",
    "dropname": "PARADIS",
    "dropdeladd": "508 FONDA ST",
    "dropdelcty": "PARADIS",
    "dropdelst": "LA",
    "dropdelzpp": 700809998,
    "dropphyadd": "508 FONDA ST",
    "dropphycty": "PARADIS",
    "dropphyst": "LA",
    "dropphyzpp": 700809998,
    "dropmaladd": "508 FONDA ST",
    "dropmalcty": "PARADIS",
    "dropmalst": "LA",
    "dropmalzpp": 700809998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857582042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24294",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "600 CATHERINE ST",
    "dropdelcty": "PATTERSON",
    "dropdelst": "LA",
    "dropdelzpp": 703929998,
    "dropphyadd": "600 CATHERINE ST",
    "dropphycty": "PATTERSON",
    "dropphyst": "LA",
    "dropphyzpp": 703929998,
    "dropmaladd": "600 CATHERINE ST",
    "dropmalcty": "PATTERSON",
    "dropmalst": "LA",
    "dropmalzpp": 703929998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853953382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24295",
    "droptype": "D",
    "dropname": "PAULINA",
    "dropdeladd": "2388 LA 44",
    "dropdelcty": "PAULINA",
    "dropdelst": "LA",
    "dropdelzpp": 707639998,
    "dropphyadd": "2388 LA 44",
    "dropphycty": "PAULINA",
    "dropphyst": "LA",
    "dropphyzpp": 707639998,
    "dropmaladd": "2388 LA 44",
    "dropmalcty": "PAULINA",
    "dropmalst": "LA",
    "dropmalzpp": 707639998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2258697633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24297",
    "droptype": "D",
    "dropname": "PEARL RIVER",
    "dropdeladd": "64119 HIGHWAY 41",
    "dropdelcty": "PEARL RIVER",
    "dropdelst": "LA",
    "dropdelzpp": 704529998,
    "dropphyadd": "64119 HIGHWAY 41",
    "dropphycty": "PEARL RIVER",
    "dropphyst": "LA",
    "dropphyzpp": 704529998,
    "dropmaladd": "64119 HIGHWAY 41",
    "dropmalcty": "PEARL RIVER",
    "dropmalst": "LA",
    "dropmalzpp": 704529998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858633115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24302",
    "droptype": "D",
    "dropname": "PELICAN",
    "dropdeladd": "151 JACKSON ST",
    "dropdelcty": "PELICAN",
    "dropdelst": "LA",
    "dropdelzpp": 710639998,
    "dropphyadd": "151 JACKSON ST",
    "dropphycty": "PELICAN",
    "dropphyst": "LA",
    "dropphyzpp": 710639998,
    "dropmaladd": "151 JACKSON ST",
    "dropmalcty": "PELICAN",
    "dropmalst": "LA",
    "dropmalzpp": 710639998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187552247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24304",
    "droptype": "D",
    "dropname": "PERRY",
    "dropdeladd": "11118 HARE ST",
    "dropdelcty": "PERRY",
    "dropdelst": "LA",
    "dropdelzpp": 705759998,
    "dropphyadd": "11118 HARE ST",
    "dropphycty": "PERRY",
    "dropphyst": "LA",
    "dropphyzpp": 705759998,
    "dropmaladd": "11118 HARE ST",
    "dropmalcty": "PERRY",
    "dropmalst": "LA",
    "dropmalzpp": 705759998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378937702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24307",
    "droptype": "D",
    "dropname": "PIERRE PART",
    "dropdeladd": "3511 HIGHWAY 70 S",
    "dropdelcty": "PIERRE PART",
    "dropdelst": "LA",
    "dropdelzpp": 703399998,
    "dropphyadd": "3511 HIGHWAY 70 S",
    "dropphycty": "PIERRE PART",
    "dropphyst": "LA",
    "dropphyzpp": 703399998,
    "dropmaladd": "3511 HIGHWAY 70 S",
    "dropmalcty": "PIERRE PART",
    "dropmalst": "LA",
    "dropmalzpp": 703399998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9852528529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24312",
    "droptype": "D",
    "dropname": "PINE GROVE",
    "dropdeladd": "7185 SHILOH BAPTIST CHURCH RD",
    "dropdelcty": "PINE GROVE",
    "dropdelst": "LA",
    "dropdelzpp": 704539998,
    "dropphyadd": "7185 SHILOH BAPTIST CHURCH RD",
    "dropphycty": "PINE GROVE",
    "dropphyst": "LA",
    "dropphyzpp": 704539998,
    "dropmaladd": "7185 SHILOH BAPTIST CHURCH RD",
    "dropmalcty": "PINE GROVE",
    "dropmalst": "LA",
    "dropmalzpp": 704539998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2257774936,
    "dropfax": 5045891831
  },
  {
    "dcode": "D",
    "dropkey": "PY24315",
    "droptype": "D",
    "dropname": "PINE PRAIRIE",
    "dropdeladd": "1228 MAGNOLIA ST",
    "dropdelcty": "PINE PRAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 705769998,
    "dropphyadd": "1228 MAGNOLIA ST",
    "dropphycty": "PINE PRAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 705769998,
    "dropmaladd": "1228 MAGNOLIA ST",
    "dropmalcty": "PINE PRAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 705769998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375992115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24316",
    "droptype": "D",
    "dropname": "PINEVILLE",
    "dropdeladd": "410 PINEGROVE DR",
    "dropdelcty": "PINEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713609998,
    "dropphyadd": "410 PINEGROVE DR",
    "dropphycty": "PINEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713609998,
    "dropmaladd": "410 PINEGROVE DR",
    "dropmalcty": "PINEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713609998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3184426367,
    "dropfax": 3184843840
  },
  {
    "dcode": "D",
    "dropkey": "PY24317",
    "droptype": "D",
    "dropname": "PIONEER",
    "dropdeladd": "119 CHERRY ST",
    "dropdelcty": "PIONEER",
    "dropdelst": "LA",
    "dropdelzpp": 712669998,
    "dropphyadd": "119 CHERRY ST",
    "dropphycty": "PIONEER",
    "dropphyst": "LA",
    "dropphyzpp": 712669998,
    "dropmaladd": "119 CHERRY ST",
    "dropmalcty": "PIONEER",
    "dropmalst": "LA",
    "dropmalzpp": 712669998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184284196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24318",
    "droptype": "D",
    "dropname": "PITKIN",
    "dropdeladd": "12949 HIGHWAY 10",
    "dropdelcty": "PITKIN",
    "dropdelst": "LA",
    "dropdelzpp": 706564845,
    "dropphyadd": "12949 HIGHWAY 10",
    "dropphycty": "PITKIN",
    "dropphyst": "LA",
    "dropphyzpp": 706564845,
    "dropmaladd": "12949 HIGHWAY 10",
    "dropmalcty": "PITKIN",
    "dropmalst": "LA",
    "dropmalzpp": 706564845,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3183042011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24319",
    "droptype": "D",
    "dropname": "PLAIN DEALING",
    "dropdeladd": "301 W MARY LEE ST",
    "dropdelcty": "PLAIN DEALING",
    "dropdelst": "LA",
    "dropdelzpp": 710649998,
    "dropphyadd": "301 W MARY LEE ST",
    "dropphycty": "PLAIN DEALING",
    "dropphyst": "LA",
    "dropphyzpp": 710649998,
    "dropmaladd": "301 W MARY LEE ST",
    "dropmalcty": "PLAIN DEALING",
    "dropmalst": "LA",
    "dropmalzpp": 710649998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187102342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24322",
    "droptype": "D",
    "dropname": "PLAQUEMINE",
    "dropdeladd": "58015 CANAL ST",
    "dropdelcty": "PLAQUEMINE",
    "dropdelst": "LA",
    "dropdelzpp": 707649998,
    "dropphyadd": "58015 CANAL ST",
    "dropphycty": "PLAQUEMINE",
    "dropphyst": "LA",
    "dropphyzpp": 707649998,
    "dropmaladd": "58015 CANAL ST",
    "dropmalcty": "PLAQUEMINE",
    "dropmalst": "LA",
    "dropmalzpp": 707649998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256850858,
    "dropfax": 2256879027
  },
  {
    "dcode": "D",
    "dropkey": "PY24323",
    "droptype": "D",
    "dropname": "PLATTENVILLE",
    "dropdeladd": "220 HIGHWAY 70 SPUR",
    "dropdelcty": "PLATTENVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 703939998,
    "dropphyadd": "220 HIGHWAY 70 SPUR",
    "dropphycty": "PLATTENVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 703939998,
    "dropmaladd": "220 HIGHWAY 70 SPUR",
    "dropmalcty": "PLATTENVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 703939998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853692170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24325",
    "droptype": "D",
    "dropname": "PLAUCHEVILLE",
    "dropdeladd": "121 GIN ST",
    "dropdelcty": "PLAUCHEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 713629998,
    "dropphyadd": "121 GIN ST",
    "dropphycty": "PLAUCHEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 713629998,
    "dropmaladd": "121 GIN ST",
    "dropmalcty": "PLAUCHEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 713629998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189223482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24326",
    "droptype": "D",
    "dropname": "PLEASANT HILL",
    "dropdeladd": "2212 W MAIN ST",
    "dropdelcty": "PLEASANT HILL",
    "dropdelst": "LA",
    "dropdelzpp": 710659998,
    "dropphyadd": "2212 W MAIN ST",
    "dropphycty": "PLEASANT HILL",
    "dropphyst": "LA",
    "dropphyzpp": 710659998,
    "dropmaladd": "2212 W MAIN ST",
    "dropmalcty": "PLEASANT HILL",
    "dropmalst": "LA",
    "dropmalzpp": 710659998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187962872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24330",
    "droptype": "D",
    "dropname": "POINTE A LA HACHE",
    "dropdeladd": "18039 HIGHWAY 15",
    "dropdelcty": "POINTE A LA HACHE",
    "dropdelst": "LA",
    "dropdelzpp": 700823011,
    "dropphyadd": "18039 HIGHWAY 15",
    "dropphycty": "POINTE A LA HACHE",
    "dropphyst": "LA",
    "dropphyzpp": 700823011,
    "dropmaladd": "18039 HIGHWAY 15",
    "dropmalcty": "POINTE A LA HACHE",
    "dropmalst": "LA",
    "dropmalzpp": 700823011,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042781612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24332",
    "droptype": "D",
    "dropname": "POLLOCK",
    "dropdeladd": "7968 RIDGE ST",
    "dropdelcty": "POLLOCK",
    "dropdelst": "LA",
    "dropdelzpp": 714679998,
    "dropphyadd": "7968 RIDGE ST",
    "dropphycty": "POLLOCK",
    "dropphyst": "LA",
    "dropphyzpp": 714679998,
    "dropmaladd": "7968 RIDGE ST",
    "dropmalcty": "POLLOCK",
    "dropmalst": "LA",
    "dropmalzpp": 714679998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187650761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24333",
    "droptype": "D",
    "dropname": "PONCHATOULA",
    "dropdeladd": "275 N 5TH ST",
    "dropdelcty": "PONCHATOULA",
    "dropdelst": "LA",
    "dropdelzpp": 704549998,
    "dropphyadd": "275 N 5TH ST",
    "dropphycty": "PONCHATOULA",
    "dropphyst": "LA",
    "dropphyzpp": 704549998,
    "dropmaladd": "275 N 5TH ST",
    "dropmalcty": "PONCHATOULA",
    "dropmalst": "LA",
    "dropmalzpp": 704549998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9853864877,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24335",
    "droptype": "D",
    "dropname": "PORT ALLEN",
    "dropdeladd": "600 COURT ST",
    "dropdelcty": "PORT ALLEN",
    "dropdelst": "LA",
    "dropdelzpp": 707679998,
    "dropphyadd": "600 COURT ST",
    "dropphycty": "PORT ALLEN",
    "dropphyst": "LA",
    "dropphyzpp": 707679998,
    "dropmaladd": "600 COURT ST",
    "dropmalcty": "PORT ALLEN",
    "dropmalst": "LA",
    "dropmalzpp": 707679998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253832457,
    "dropfax": 2253361953
  },
  {
    "dcode": "D",
    "dropkey": "PY24336",
    "droptype": "D",
    "dropname": "PORT BARRE",
    "dropdeladd": "471 SAIZON ST",
    "dropdelcty": "PORT BARRE",
    "dropdelst": "LA",
    "dropdelzpp": 705775156,
    "dropphyadd": "471 SAIZON ST",
    "dropphycty": "PORT BARRE",
    "dropphyst": "LA",
    "dropphyzpp": 705775156,
    "dropmaladd": "471 SAIZON ST",
    "dropmalcty": "PORT BARRE",
    "dropmalst": "LA",
    "dropmalzpp": 705775156,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375850205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24338",
    "droptype": "D",
    "dropname": "PORT SULPHUR",
    "dropdeladd": "26852 HIGHWAY 23 STE A",
    "dropdelcty": "PORT SULPHUR",
    "dropdelst": "LA",
    "dropdelzpp": 700839998,
    "dropphyadd": "26852 HIGHWAY 23 STE A",
    "dropphycty": "PORT SULPHUR",
    "dropphyst": "LA",
    "dropphyzpp": 700839998,
    "dropmaladd": "26852 HIGHWAY 23 STE A",
    "dropmalcty": "PORT SULPHUR",
    "dropmalst": "LA",
    "dropmalzpp": 700839998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045646508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24342",
    "droptype": "D",
    "dropname": "POWHATAN",
    "dropdeladd": "1812 HIGHWAY 1 N",
    "dropdelcty": "POWHATAN",
    "dropdelst": "LA",
    "dropdelzpp": 710669998,
    "dropphyadd": "1812 HIGHWAY 1 N",
    "dropphycty": "POWHATAN",
    "dropphyst": "LA",
    "dropphyzpp": 710669998,
    "dropmaladd": "1812 HIGHWAY 1 N",
    "dropmalcty": "POWHATAN",
    "dropmalst": "LA",
    "dropmalzpp": 710669998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183570021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24344",
    "droptype": "D",
    "dropname": "PRAIRIEVILLE",
    "dropdeladd": "15655 AIRLINE HWY",
    "dropdelcty": "PRAIRIEVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 707699997,
    "dropphyadd": "15655 AIRLINE HWY",
    "dropphycty": "PRAIRIEVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 707699997,
    "dropmaladd": "15655 AIRLINE HWY",
    "dropmalcty": "PRAIRIEVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 707699997,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256738100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24346",
    "droptype": "D",
    "dropname": "PRIDE",
    "dropdeladd": "16524 PRIDE PORT HUDSON RD",
    "dropdelcty": "PRIDE",
    "dropdelst": "LA",
    "dropdelzpp": 707709203,
    "dropphyadd": "16524 PRIDE PORT HUDSON RD",
    "dropphycty": "PRIDE",
    "dropphyst": "LA",
    "dropphyzpp": 707709203,
    "dropmaladd": "PO BOX 7000",
    "dropmalcty": "PRIDE",
    "dropmalst": "LA",
    "dropmalzpp": 707709998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256581725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24347",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "5491 HIGHWAY 80",
    "dropdelcty": "PRINCETON",
    "dropdelst": "LA",
    "dropdelzpp": 710679998,
    "dropphyadd": "5491 HIGHWAY 80",
    "dropphycty": "PRINCETON",
    "dropphyst": "LA",
    "dropphyzpp": 710679998,
    "dropmaladd": "5491 HIGHWAY 80",
    "dropmalcty": "PRINCETON",
    "dropmalst": "LA",
    "dropmalzpp": 710679998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189499874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24350",
    "droptype": "D",
    "dropname": "PROVENCAL",
    "dropdeladd": "101 ROBELINE PROVENCAL RD",
    "dropdelcty": "PROVENCAL",
    "dropdelst": "LA",
    "dropdelzpp": 714689998,
    "dropphyadd": "101 ROBELINE PROVENCAL RD",
    "dropphycty": "PROVENCAL",
    "dropphyst": "LA",
    "dropphyzpp": 714689998,
    "dropmaladd": "101 ROBELINE PROVENCAL RD",
    "dropmalcty": "PROVENCAL",
    "dropmalst": "LA",
    "dropmalzpp": 714689998,
    "dropsitphn": 2186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184723619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24358",
    "droptype": "D",
    "dropname": "QUITMAN",
    "dropdeladd": "8223 QUITMAN HWY",
    "dropdelcty": "QUITMAN",
    "dropdelst": "LA",
    "dropdelzpp": 712689998,
    "dropphyadd": "8223 QUITMAN HWY",
    "dropphycty": "QUITMAN",
    "dropphyst": "LA",
    "dropphyzpp": 712689998,
    "dropmaladd": "8223 QUITMAN HWY",
    "dropmalcty": "QUITMAN",
    "dropmalst": "LA",
    "dropmalzpp": 712689998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182596638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24359",
    "droptype": "D",
    "dropname": "RACELAND",
    "dropdeladd": "109 RACELAND ST",
    "dropdelcty": "RACELAND",
    "dropdelst": "LA",
    "dropdelzpp": 703949998,
    "dropphyadd": "109 RACELAND ST",
    "dropphycty": "RACELAND",
    "dropphyst": "LA",
    "dropphyzpp": 703949998,
    "dropmaladd": "109 RACELAND ST",
    "dropmalcty": "RACELAND",
    "dropmalst": "LA",
    "dropmalzpp": 703949998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 9855378957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24360",
    "droptype": "D",
    "dropname": "RAGLEY",
    "dropdeladd": "7619 HIGHWAY 190",
    "dropdelcty": "RAGLEY",
    "dropdelst": "LA",
    "dropdelzpp": 706579998,
    "dropphyadd": "7619 HIGHWAY 190",
    "dropphycty": "RAGLEY",
    "dropphyst": "LA",
    "dropphyzpp": 706579998,
    "dropmaladd": "7619 HIGHWAY 190",
    "dropmalcty": "RAGLEY",
    "dropmalst": "LA",
    "dropmalzpp": 706579998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377253509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24365",
    "droptype": "D",
    "dropname": "RAYNE",
    "dropdeladd": "410 E TEXAS AVE",
    "dropdelcty": "RAYNE",
    "dropdelst": "LA",
    "dropdelzpp": 705786435,
    "dropphyadd": "410 E TEXAS AVE",
    "dropphycty": "RAYNE",
    "dropphyst": "LA",
    "dropphyzpp": 705786435,
    "dropmaladd": "410 E TEXAS AVE",
    "dropmalcty": "RAYNE",
    "dropmalst": "LA",
    "dropmalzpp": 705789998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373345629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24366",
    "droptype": "D",
    "dropname": "RAYVILLE",
    "dropdeladd": "103 BENEDETTE ST",
    "dropdelcty": "RAYVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 712699998,
    "dropphyadd": "103 BENEDETTE ST",
    "dropphycty": "RAYVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 712699998,
    "dropmaladd": "103 BENEDETTE ST",
    "dropmalcty": "RAYVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 712699998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186616024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24370",
    "droptype": "D",
    "dropname": "REDDELL",
    "dropdeladd": "6686 VETERANS MEMORIAL HWY",
    "dropdelcty": "REDDELL",
    "dropdelst": "LA",
    "dropdelzpp": 705809998,
    "dropphyadd": "6686 VETERANS MEMORIAL HWY",
    "dropphycty": "REDDELL",
    "dropphyst": "LA",
    "dropphyzpp": 705809998,
    "dropmaladd": "6686 VETERANS MEMORIAL HWY",
    "dropmalcty": "REDDELL",
    "dropmalst": "LA",
    "dropmalzpp": 705809998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374682424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24371",
    "droptype": "D",
    "dropname": "REEVES",
    "dropdeladd": "18320 HIGHWAY 190",
    "dropdelcty": "REEVES",
    "dropdelst": "LA",
    "dropdelzpp": 706589998,
    "dropphyadd": "18320 HIGHWAY 190",
    "dropphycty": "REEVES",
    "dropphyst": "LA",
    "dropphyzpp": 706589998,
    "dropmaladd": "18320 HIGHWAY 190",
    "dropmalcty": "REEVES",
    "dropmalst": "LA",
    "dropmalzpp": 706589998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377492993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24373",
    "droptype": "D",
    "dropname": "RESERVE",
    "dropdeladd": "129 CENTRAL AVE",
    "dropdelcty": "RESERVE",
    "dropdelst": "LA",
    "dropdelzpp": 700849998,
    "dropphyadd": "129 CENTRAL AVE",
    "dropphycty": "RESERVE",
    "dropphyst": "LA",
    "dropphyzpp": 700849998,
    "dropmaladd": "129 CENTRAL AVE",
    "dropmalcty": "RESERVE",
    "dropmalst": "LA",
    "dropmalzpp": 700849998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9854792661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24375",
    "droptype": "D",
    "dropname": "RHINEHART",
    "dropdeladd": "8769 HIGHWAY 84 E",
    "dropdelcty": "RHINEHART",
    "dropdelst": "LA",
    "dropdelzpp": 713639998,
    "dropphyadd": "8769 HIGHWAY 84 E",
    "dropphycty": "RHINEHART",
    "dropphyst": "LA",
    "dropphyzpp": 713639998,
    "dropmaladd": "8769 HIGHWAY 84 E",
    "dropmalcty": "RHINEHART",
    "dropmalst": "LA",
    "dropmalzpp": 713639998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189928956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24379",
    "droptype": "D",
    "dropname": "RINGGOLD",
    "dropdeladd": "2325 MILL ST",
    "dropdelcty": "RINGGOLD",
    "dropdelst": "LA",
    "dropdelzpp": 710689998,
    "dropphyadd": "2325 MILL ST",
    "dropphycty": "RINGGOLD",
    "dropphyst": "LA",
    "dropphyzpp": 710689998,
    "dropmaladd": "2325 MILL ST",
    "dropmalcty": "RINGGOLD",
    "dropmalst": "LA",
    "dropmalzpp": 710689998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188949258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24385",
    "droptype": "D",
    "dropname": "ROANOKE",
    "dropdeladd": "14152 HIGHWAY 395",
    "dropdelcty": "ROANOKE",
    "dropdelst": "LA",
    "dropdelzpp": 705819998,
    "dropphyadd": "14152 HIGHWAY 395",
    "dropphycty": "ROANOKE",
    "dropphyst": "LA",
    "dropphyzpp": 705819998,
    "dropmaladd": "14152 HIGHWAY 395",
    "dropmalcty": "ROANOKE",
    "dropmalst": "LA",
    "dropmalzpp": 705819998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377532699,
    "dropfax": 3377532413
  },
  {
    "dcode": "D",
    "dropkey": "PY24386",
    "droptype": "D",
    "dropname": "ROBELINE",
    "dropdeladd": "175 CHAPLIN LOOP",
    "dropdelcty": "ROBELINE",
    "dropdelst": "LA",
    "dropdelzpp": 714699998,
    "dropphyadd": "175 CHAPLIN LOOP",
    "dropphycty": "ROBELINE",
    "dropphyst": "LA",
    "dropphyzpp": 714699998,
    "dropmaladd": "175 CHAPLIN LOOP",
    "dropmalcty": "ROBELINE",
    "dropmalst": "LA",
    "dropmalzpp": 714699998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184724049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24387",
    "droptype": "D",
    "dropname": "ROBERT",
    "dropdeladd": "44225 HIGHWAY 445",
    "dropdelcty": "ROBERT",
    "dropdelst": "LA",
    "dropdelzpp": 704559998,
    "dropphyadd": "44225 HIGHWAY 445",
    "dropphycty": "ROBERT",
    "dropphyst": "LA",
    "dropphyzpp": 704559998,
    "dropmaladd": "44225 HIGHWAY 445",
    "dropmalcty": "ROBERT",
    "dropmalst": "LA",
    "dropmalzpp": 704559998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9859029288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24395",
    "droptype": "D",
    "dropname": "RODESSA",
    "dropdeladd": "20065 W FRONT ST",
    "dropdelcty": "RODESSA",
    "dropdelst": "LA",
    "dropdelzpp": 710699998,
    "dropphyadd": "20065 W FRONT ST",
    "dropphycty": "RODESSA",
    "dropphyst": "LA",
    "dropphyzpp": 710699998,
    "dropmaladd": "20065 W FRONT ST",
    "dropmalcty": "RODESSA",
    "dropmalst": "LA",
    "dropmalzpp": 710699998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182234671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24400",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "15600 HIGHWAY 77",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "LA",
    "dropdelzpp": 707729998,
    "dropphyadd": "15600 HIGHWAY 77",
    "dropphycty": "ROSEDALE",
    "dropphyst": "LA",
    "dropphyzpp": 707729998,
    "dropmaladd": "15600 HIGHWAY 77",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "LA",
    "dropmalzpp": 707729998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256482794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24402",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "62430 COMMERCIAL ST",
    "dropdelcty": "ROSELAND",
    "dropdelst": "LA",
    "dropdelzpp": 704569998,
    "dropphyadd": "62430 COMMERCIAL ST",
    "dropphycty": "ROSELAND",
    "dropphyst": "LA",
    "dropphyzpp": 704569998,
    "dropmaladd": "62430 COMMERCIAL ST",
    "dropmalcty": "ROSELAND",
    "dropmalst": "LA",
    "dropmalzpp": 704569998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9857470921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24403",
    "droptype": "D",
    "dropname": "ROSEPINE",
    "dropdeladd": "18327 JOHNNY B HALL MEMORIAL HWY",
    "dropdelcty": "ROSEPINE",
    "dropdelst": "LA",
    "dropdelzpp": 706599998,
    "dropphyadd": "18327 JOHNNY B HALL MEMORIAL HWY",
    "dropphycty": "ROSEPINE",
    "dropphyst": "LA",
    "dropphyzpp": 706599998,
    "dropmaladd": "18327 JOHNNY B HALL MEMORIAL HWY",
    "dropmalcty": "ROSEPINE",
    "dropmalst": "LA",
    "dropmalzpp": 706599998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374633462,
    "dropfax": 3374634160
  },
  {
    "dcode": "D",
    "dropkey": "PY24404",
    "droptype": "D",
    "dropname": "ROUGON",
    "dropdeladd": "13236 LA 416",
    "dropdelcty": "ROUGON",
    "dropdelst": "LA",
    "dropdelzpp": 707739998,
    "dropphyadd": "13236 LA 416",
    "dropphycty": "ROUGON",
    "dropphyst": "LA",
    "dropphyzpp": 707739998,
    "dropmaladd": "13236 LA 416",
    "dropmalcty": "ROUGON",
    "dropmalst": "LA",
    "dropmalzpp": 707739998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256274856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24410",
    "droptype": "D",
    "dropname": "RUSTON",
    "dropdeladd": "700 E GEORGIA AVE",
    "dropdelcty": "RUSTON",
    "dropdelst": "LA",
    "dropdelzpp": 712709998,
    "dropphyadd": "700 E GEORGIA AVE",
    "dropphycty": "RUSTON",
    "dropphyst": "LA",
    "dropphyzpp": 712709998,
    "dropmaladd": "700 E GEORGIA AVE",
    "dropmalcty": "RUSTON",
    "dropmalst": "LA",
    "dropmalzpp": 712709998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182323036,
    "dropfax": 3182510363
  },
  {
    "dcode": "D",
    "dropkey": "PY24413",
    "droptype": "D",
    "dropname": "SAINT AMANT",
    "dropdeladd": "44473 HIGHWAY 429",
    "dropdelcty": "SAINT AMANT",
    "dropdelst": "LA",
    "dropdelzpp": 707749998,
    "dropphyadd": "44473 HIGHWAY 429",
    "dropphycty": "SAINT AMANT",
    "dropphyst": "LA",
    "dropphyzpp": 707749998,
    "dropmaladd": "44473 HIGHWAY 429",
    "dropmalcty": "SAINT AMANT",
    "dropmalst": "LA",
    "dropmalzpp": 707749998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256443133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24414",
    "droptype": "D",
    "dropname": "SAINT BENEDICT",
    "dropdeladd": "75376 RIVER RD",
    "dropdelcty": "SAINT BENEDICT",
    "dropdelst": "LA",
    "dropdelzpp": 704579998,
    "dropphyadd": "75376 RIVER RD",
    "dropphycty": "SAINT BENEDICT",
    "dropphyst": "LA",
    "dropphyzpp": 704579998,
    "dropmaladd": "75376 RIVER RD",
    "dropmalcty": "SAINT BENEDICT",
    "dropmalst": "LA",
    "dropmalzpp": 704579998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858759157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24415",
    "droptype": "D",
    "dropname": "SAINT BERNARD",
    "dropdeladd": "1201 BAYOU RD",
    "dropdelcty": "SAINT BERNARD",
    "dropdelst": "LA",
    "dropdelzpp": 700854803,
    "dropphyadd": "1201 BAYOU RD",
    "dropphycty": "SAINT BERNARD",
    "dropphyst": "LA",
    "dropphyzpp": 700854803,
    "dropmaladd": "1201 BAYOU RD",
    "dropmalcty": "SAINT BERNARD",
    "dropmalst": "LA",
    "dropmalzpp": 700854803,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046825107,
    "dropfax": 5046827253
  },
  {
    "dcode": "D",
    "dropkey": "PY24416",
    "droptype": "D",
    "dropname": "SAINT FRANCISVILLE",
    "dropdeladd": "5613 COMMERCE ST",
    "dropdelcty": "SAINT FRANCISVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 707754413,
    "dropphyadd": "5613 COMMERCE ST",
    "dropphycty": "SAINT FRANCISVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 707754413,
    "dropmaladd": "PO BOX 7500",
    "dropmalcty": "SAINT FRANCISVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 707759998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257848945,
    "dropfax": 2256355878
  },
  {
    "dcode": "D",
    "dropkey": "PY24417",
    "droptype": "D",
    "dropname": "SAINT GABRIEL",
    "dropdeladd": "6080 HIGHWAY 74",
    "dropdelcty": "SAINT GABRIEL",
    "dropdelst": "LA",
    "dropdelzpp": 707769998,
    "dropphyadd": "6080 HIGHWAY 74",
    "dropphycty": "SAINT GABRIEL",
    "dropphyst": "LA",
    "dropphyzpp": 707769998,
    "dropmaladd": "6080 HIGHWAY 74",
    "dropmalcty": "SAINT GABRIEL",
    "dropmalst": "LA",
    "dropmalzpp": 707769998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256429382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24419",
    "droptype": "D",
    "dropname": "SAINT JAMES",
    "dropdeladd": "5525 HIGHWAY 18",
    "dropdelcty": "SAINT JAMES",
    "dropdelst": "LA",
    "dropdelzpp": 700869998,
    "dropphyadd": "5525 HIGHWAY 18",
    "dropphycty": "SAINT JAMES",
    "dropphyst": "LA",
    "dropphyzpp": 700869998,
    "dropmaladd": "5525 HIGHWAY 18",
    "dropmalcty": "SAINT JAMES",
    "dropmalst": "LA",
    "dropmalzpp": 700869998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891268,
    "dropsitcph": 2252651482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24420",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "144 PLANK RD",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "LA",
    "dropdelzpp": 713669998,
    "dropphyadd": "144 PLANK RD",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "LA",
    "dropphyzpp": 713669998,
    "dropmaladd": "144 PLANK RD",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "LA",
    "dropmalzpp": 713669998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187666166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24421",
    "droptype": "D",
    "dropname": "SAINT LANDRY",
    "dropdeladd": "1888 SAINT LANDRY HWY",
    "dropdelcty": "SAINT LANDRY",
    "dropdelst": "LA",
    "dropdelzpp": 713679998,
    "dropphyadd": "1888 SAINT LANDRY HWY",
    "dropphycty": "SAINT LANDRY",
    "dropphyst": "LA",
    "dropphyzpp": 713679998,
    "dropmaladd": "1888 SAINT LANDRY HWY",
    "dropmalcty": "SAINT LANDRY",
    "dropmalst": "LA",
    "dropmalzpp": 713679998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188382170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24422",
    "droptype": "D",
    "dropname": "SAINT MARTINVILLE",
    "dropdeladd": "224 S MAIN ST",
    "dropdelcty": "SAINT MARTINVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705824508,
    "dropphyadd": "224 S MAIN ST",
    "dropphycty": "SAINT MARTINVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705824508,
    "dropmaladd": "224 S MAIN ST",
    "dropmalcty": "SAINT MARTINVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705824508,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373948205,
    "dropfax": 3373944626
  },
  {
    "dcode": "D",
    "dropkey": "PY24424",
    "droptype": "D",
    "dropname": "SAINT ROSE",
    "dropdeladd": "11724 RIVER RD",
    "dropdelcty": "SAINT ROSE",
    "dropdelst": "LA",
    "dropdelzpp": 700879998,
    "dropphyadd": "11724 RIVER RD",
    "dropphycty": "SAINT ROSE",
    "dropphyst": "LA",
    "dropphyzpp": 700879998,
    "dropmaladd": "11724 RIVER RD",
    "dropmalcty": "SAINT ROSE",
    "dropmalst": "LA",
    "dropmalzpp": 700879998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5047126913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24426",
    "droptype": "D",
    "dropname": "SALINE",
    "dropdeladd": "1032 COOPER ST",
    "dropdelcty": "SALINE",
    "dropdelst": "LA",
    "dropdelzpp": 710709998,
    "dropphyadd": "1032 COOPER ST",
    "dropphycty": "SALINE",
    "dropphyst": "LA",
    "dropphyzpp": 710709998,
    "dropmaladd": "1032 COOPER ST",
    "dropmalcty": "SALINE",
    "dropmalst": "LA",
    "dropmalzpp": 710709998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185768714,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24432",
    "droptype": "D",
    "dropname": "SAREPTA",
    "dropdeladd": "24468 HIGHWAY 371",
    "dropdelcty": "SAREPTA",
    "dropdelst": "LA",
    "dropdelzpp": 710719998,
    "dropphyadd": "24468 HIGHWAY 371",
    "dropphycty": "SAREPTA",
    "dropphyst": "LA",
    "dropphyzpp": 710719998,
    "dropmaladd": "24468 HIGHWAY 371",
    "dropmalcty": "SAREPTA",
    "dropmalst": "LA",
    "dropmalzpp": 710719998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188474073,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24433",
    "droptype": "D",
    "dropname": "SCHRIEVER",
    "dropdeladd": "201 OLD HIGHWAY 659",
    "dropdelcty": "SCHRIEVER",
    "dropdelst": "LA",
    "dropdelzpp": 703959998,
    "dropphyadd": "201 OLD HIGHWAY 659",
    "dropphycty": "SCHRIEVER",
    "dropphyst": "LA",
    "dropphyzpp": 703959998,
    "dropmaladd": "201 OLD HIGHWAY 659",
    "dropmalcty": "SCHRIEVER",
    "dropmalst": "LA",
    "dropmalzpp": 703959998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9854466174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24436",
    "droptype": "D",
    "dropname": "SCOTT",
    "dropdeladd": "5926 CAMERON ST",
    "dropdelcty": "SCOTT",
    "dropdelst": "LA",
    "dropdelzpp": 705836000,
    "dropphyadd": "5926 CAMERON ST",
    "dropphycty": "SCOTT",
    "dropphyst": "LA",
    "dropphyzpp": 705836000,
    "dropmaladd": "5926 CAMERON ST",
    "dropmalcty": "SCOTT",
    "dropmalst": "LA",
    "dropmalzpp": 705836000,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372371589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24450",
    "droptype": "D",
    "dropname": "SHONGALOO",
    "dropdeladd": "11270 HIGHWAY 2",
    "dropdelcty": "SHONGALOO",
    "dropdelst": "LA",
    "dropdelzpp": 710729998,
    "dropphyadd": "11270 HIGHWAY 2",
    "dropphycty": "SHONGALOO",
    "dropphyst": "LA",
    "dropphyzpp": 710729998,
    "dropmaladd": "11270 HIGHWAY 2",
    "dropmalcty": "SHONGALOO",
    "dropmalst": "LA",
    "dropmalzpp": 710729998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3188462863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24454",
    "droptype": "D",
    "dropname": "SHREVEPORT",
    "dropdeladd": "2400 TEXAS AVE",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711029998,
    "dropphyadd": "2400 TEXAS AVE",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711029998,
    "dropmaladd": "2400 TEXAS AVE",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711029998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186772369,
    "dropfax": 3186772212
  },
  {
    "dcode": "D",
    "dropkey": "PY24457",
    "droptype": "D",
    "dropname": "SIBLEY",
    "dropdeladd": "219 N MAIN ST",
    "dropdelcty": "SIBLEY",
    "dropdelst": "LA",
    "dropdelzpp": 710739998,
    "dropphyadd": "219 N MAIN ST",
    "dropphycty": "SIBLEY",
    "dropphyst": "LA",
    "dropphyzpp": 710739998,
    "dropmaladd": "219 N MAIN ST",
    "dropmalcty": "SIBLEY",
    "dropmalst": "LA",
    "dropmalzpp": 710739998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183772798,
    "dropfax": 3183712628
  },
  {
    "dcode": "D",
    "dropkey": "PY24459",
    "droptype": "D",
    "dropname": "SICILY ISLAND",
    "dropdeladd": "201 PENISTON ST",
    "dropdelcty": "SICILY ISLAND",
    "dropdelst": "LA",
    "dropdelzpp": 713689998,
    "dropphyadd": "201 PENISTON ST",
    "dropphycty": "SICILY ISLAND",
    "dropphyst": "LA",
    "dropphyzpp": 713689998,
    "dropmaladd": "201 PENISTON ST",
    "dropmalcty": "SICILY ISLAND",
    "dropmalst": "LA",
    "dropmalzpp": 713689998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183894370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24462",
    "droptype": "D",
    "dropname": "SIKES",
    "dropdeladd": "4697 HIGHWAY 126",
    "dropdelcty": "SIKES",
    "dropdelst": "LA",
    "dropdelzpp": 714739998,
    "dropphyadd": "4697 HIGHWAY 126",
    "dropphycty": "SIKES",
    "dropphyst": "LA",
    "dropphyzpp": 714739998,
    "dropmaladd": "4697 HIGHWAY 126",
    "dropmalcty": "SIKES",
    "dropmalst": "LA",
    "dropmalzpp": 714739998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186481873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24463",
    "droptype": "D",
    "dropname": "SIMMESPORT",
    "dropdeladd": "360 MISSION DR",
    "dropdelcty": "SIMMESPORT",
    "dropdelst": "LA",
    "dropdelzpp": 713699998,
    "dropphyadd": "360 MISSION DR",
    "dropphycty": "SIMMESPORT",
    "dropphyst": "LA",
    "dropphyzpp": 713699998,
    "dropmaladd": "360 MISSION DR",
    "dropmalcty": "SIMMESPORT",
    "dropmalst": "LA",
    "dropmalzpp": 713699998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189415094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24465",
    "droptype": "D",
    "dropname": "SIMPSON",
    "dropdeladd": "4259 HIGHWAY 8",
    "dropdelcty": "SIMPSON",
    "dropdelst": "LA",
    "dropdelzpp": 714749998,
    "dropphyadd": "4259 HIGHWAY 8",
    "dropphycty": "SIMPSON",
    "dropphyst": "LA",
    "dropphyzpp": 714749998,
    "dropmaladd": "4259 HIGHWAY 8",
    "dropmalcty": "SIMPSON",
    "dropmalst": "LA",
    "dropmalzpp": 714749998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3373836102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24466",
    "droptype": "D",
    "dropname": "SIMSBORO",
    "dropdeladd": "2903 MARTHA ST",
    "dropdelcty": "SIMSBORO",
    "dropdelst": "LA",
    "dropdelzpp": 712759998,
    "dropphyadd": "2903 MARTHA ST",
    "dropphycty": "SIMSBORO",
    "dropphyst": "LA",
    "dropphyzpp": 712759998,
    "dropmaladd": "2903 MARTHA ST",
    "dropmalcty": "SIMSBORO",
    "dropmalst": "LA",
    "dropmalzpp": 712759998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182473397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24467",
    "droptype": "D",
    "dropname": "SINGER",
    "dropdeladd": "9068 HIGHWAY 27",
    "dropdelcty": "SINGER",
    "dropdelst": "LA",
    "dropdelzpp": 706609998,
    "dropphyadd": "9068 HIGHWAY 27",
    "dropphycty": "SINGER",
    "dropphyst": "LA",
    "dropphyzpp": 706609998,
    "dropmaladd": "9068 HIGHWAY 27",
    "dropmalcty": "SINGER",
    "dropmalst": "LA",
    "dropmalzpp": 706609998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374632796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24468",
    "droptype": "D",
    "dropname": "SLAGLE",
    "dropdeladd": "8787 HIGHWAY 8",
    "dropdelcty": "SLAGLE",
    "dropdelst": "LA",
    "dropdelzpp": 714759998,
    "dropphyadd": "8787 HIGHWAY 8",
    "dropphycty": "SLAGLE",
    "dropphyst": "LA",
    "dropphyzpp": 714759998,
    "dropmaladd": "8787 HIGHWAY 8",
    "dropmalcty": "SLAGLE",
    "dropmalst": "LA",
    "dropmalzpp": 714759998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3372381120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24469",
    "droptype": "D",
    "dropname": "SLAUGHTER",
    "dropdeladd": "3147 CHURCH ST",
    "dropdelcty": "SLAUGHTER",
    "dropdelst": "LA",
    "dropdelzpp": 707779998,
    "dropphyadd": "3147 CHURCH ST",
    "dropphycty": "SLAUGHTER",
    "dropphyst": "LA",
    "dropphyzpp": 707779998,
    "dropmaladd": "3147 CHURCH ST",
    "dropmalcty": "SLAUGHTER",
    "dropmalst": "LA",
    "dropmalzpp": 707779998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256586476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24470",
    "droptype": "D",
    "dropname": "SLIDELL",
    "dropdeladd": "1950 2ND ST",
    "dropdelcty": "SLIDELL",
    "dropdelst": "LA",
    "dropdelzpp": 704589998,
    "dropphyadd": "1950 2ND ST",
    "dropphycty": "SLIDELL",
    "dropphyst": "LA",
    "dropphyzpp": 704589998,
    "dropmaladd": "1950 2ND ST",
    "dropmalcty": "SLIDELL",
    "dropmalst": "LA",
    "dropmalzpp": 704589998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856411414,
    "dropfax": 9856432627
  },
  {
    "dcode": "D",
    "dropkey": "PY24474",
    "droptype": "D",
    "dropname": "SONDHEIMER",
    "dropdeladd": "17826 HIGHWAY 65 S",
    "dropdelcty": "SONDHEIMER",
    "dropdelst": "LA",
    "dropdelzpp": 712769998,
    "dropphyadd": "17826 HIGHWAY 65 S",
    "dropphycty": "SONDHEIMER",
    "dropphyst": "LA",
    "dropphyzpp": 712769998,
    "dropmaladd": "17826 HIGHWAY 65 S",
    "dropmalcty": "SONDHEIMER",
    "dropmalst": "LA",
    "dropmalzpp": 712769998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185526132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24475",
    "droptype": "D",
    "dropname": "SORRENTO",
    "dropdeladd": "8213 JOHN LEBLANC BLVD",
    "dropdelcty": "SORRENTO",
    "dropdelst": "LA",
    "dropdelzpp": 707789998,
    "dropphyadd": "8213 JOHN LEBLANC BLVD",
    "dropphycty": "SORRENTO",
    "dropphyst": "LA",
    "dropphyzpp": 707789998,
    "dropmaladd": "8213 JOHN LEBLANC BLVD",
    "dropmalcty": "SORRENTO",
    "dropmalst": "LA",
    "dropmalzpp": 707789998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256752722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24493",
    "droptype": "D",
    "dropname": "SPEARSVILLE",
    "dropdeladd": "1360 HIGHWAY 15",
    "dropdelcty": "SPEARSVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 712779998,
    "dropphyadd": "1360 HIGHWAY 15",
    "dropphycty": "SPEARSVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 712779998,
    "dropmaladd": "1360 HIGHWAY 15",
    "dropmalcty": "SPEARSVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 712779998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187784366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24499",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "32170 2ND ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "LA",
    "dropdelzpp": 704629998,
    "dropphyadd": "32170 2ND ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "LA",
    "dropphyzpp": 704629998,
    "dropmaladd": "32170 2ND ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "LA",
    "dropmalzpp": 704629998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2252948372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24501",
    "droptype": "D",
    "dropname": "SPRINGHILL",
    "dropdeladd": "501 N GILES ST",
    "dropdelcty": "SPRINGHILL",
    "dropdelst": "LA",
    "dropdelzpp": 710759998,
    "dropphyadd": "501 N GILES ST",
    "dropphycty": "SPRINGHILL",
    "dropphyst": "LA",
    "dropphyzpp": 710759998,
    "dropmaladd": "501 N GILES ST",
    "dropmalcty": "SPRINGHILL",
    "dropmalst": "LA",
    "dropmalzpp": 710759998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185393207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24523",
    "droptype": "D",
    "dropname": "STARKS",
    "dropdeladd": "106 BIG WOODS RD",
    "dropdelcty": "STARKS",
    "dropdelst": "LA",
    "dropdelzpp": 706619998,
    "dropphyadd": "106 BIG WOODS RD",
    "dropphycty": "STARKS",
    "dropphyst": "LA",
    "dropphyzpp": 706619998,
    "dropmaladd": "106 BIG WOODS RD",
    "dropmalcty": "STARKS",
    "dropmalst": "LA",
    "dropmalzpp": 706619998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377435247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24524",
    "droptype": "D",
    "dropname": "START",
    "dropdeladd": "34 OWL LOOP RD",
    "dropdelcty": "START",
    "dropdelst": "LA",
    "dropdelzpp": 712799998,
    "dropphyadd": "34 OWL LOOP RD",
    "dropphycty": "START",
    "dropphyst": "LA",
    "dropphyzpp": 712799998,
    "dropmaladd": "34 OWL LOOP RD",
    "dropmalcty": "START",
    "dropmalst": "LA",
    "dropmalzpp": 712799998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187285356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24526",
    "droptype": "D",
    "dropname": "STERLINGTON",
    "dropdeladd": "102 HIGH AVE",
    "dropdelcty": "STERLINGTON",
    "dropdelst": "LA",
    "dropdelzpp": 712809998,
    "dropphyadd": "102 HIGH AVE",
    "dropphycty": "STERLINGTON",
    "dropphyst": "LA",
    "dropphyzpp": 712809998,
    "dropmaladd": "102 HIGH AVE",
    "dropmalcty": "STERLINGTON",
    "dropmalst": "LA",
    "dropmalzpp": 712809998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182397232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24527",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "986 HIGHWAY 171",
    "dropdelcty": "STONEWALL",
    "dropdelst": "LA",
    "dropdelzpp": 710789998,
    "dropphyadd": "986 HIGHWAY 171",
    "dropphycty": "STONEWALL",
    "dropphyst": "LA",
    "dropphyzpp": 710789998,
    "dropmaladd": "986 HIGHWAY 171",
    "dropmalcty": "STONEWALL",
    "dropmalst": "LA",
    "dropmalzpp": 710789998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189258327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24529",
    "droptype": "D",
    "dropname": "SULPHUR",
    "dropdeladd": "800 S POST OAK RD",
    "dropdelcty": "SULPHUR",
    "dropdelst": "LA",
    "dropdelzpp": 706633664,
    "dropphyadd": "800 S POST OAK RD",
    "dropphycty": "SULPHUR",
    "dropphyst": "LA",
    "dropphyzpp": 706633664,
    "dropmaladd": "800 S POST OAK RD",
    "dropmalcty": "SULPHUR",
    "dropmalst": "LA",
    "dropmalzpp": 706639998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376252037,
    "dropfax": 3376259982
  },
  {
    "dcode": "D",
    "dropkey": "PY24531",
    "droptype": "D",
    "dropname": "SUMMERFIELD",
    "dropdeladd": "4306 HIGHWAY 9",
    "dropdelcty": "SUMMERFIELD",
    "dropdelst": "LA",
    "dropdelzpp": 710799998,
    "dropphyadd": "4306 HIGHWAY 9",
    "dropphycty": "SUMMERFIELD",
    "dropphyst": "LA",
    "dropphyzpp": 710799998,
    "dropmaladd": "4306 HIGHWAY 9",
    "dropmalcty": "SUMMERFIELD",
    "dropmalst": "LA",
    "dropmalzpp": 710799998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189271034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24533",
    "droptype": "D",
    "dropname": "SUN",
    "dropdeladd": "30034 HIGHWAY 16",
    "dropdelcty": "SUN",
    "dropdelst": "LA",
    "dropdelzpp": 704639998,
    "dropphyadd": "30034 HIGHWAY 16",
    "dropphycty": "SUN",
    "dropphyst": "LA",
    "dropphyzpp": 704639998,
    "dropmaladd": "30034 HIGHWAY 16",
    "dropmalcty": "SUN",
    "dropmalst": "LA",
    "dropmalzpp": 704639998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858863136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24535",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "924 NAPOLEON AVE",
    "dropdelcty": "SUNSET",
    "dropdelst": "LA",
    "dropdelzpp": 705849998,
    "dropphyadd": "924 NAPOLEON AVE",
    "dropphycty": "SUNSET",
    "dropphyst": "LA",
    "dropphyzpp": 705849998,
    "dropmaladd": "924 NAPOLEON AVE",
    "dropmalcty": "SUNSET",
    "dropmalst": "LA",
    "dropmalzpp": 705849998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3376623009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24537",
    "droptype": "D",
    "dropname": "SUNSHINE",
    "dropdeladd": "2135 BESSON LN",
    "dropdelcty": "SUNSHINE",
    "dropdelst": "LA",
    "dropdelzpp": 707809998,
    "dropphyadd": "2135 BESSON LN",
    "dropphycty": "SUNSHINE",
    "dropphyst": "LA",
    "dropphyzpp": 707809998,
    "dropmaladd": "2135 BESSON LN",
    "dropmalcty": "SUNSHINE",
    "dropmalst": "LA",
    "dropmalzpp": 707809998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256420717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24539",
    "droptype": "D",
    "dropname": "SWARTZ",
    "dropdeladd": "1892 HIGHWAY 139",
    "dropdelcty": "SWARTZ",
    "dropdelst": "LA",
    "dropdelzpp": 712819998,
    "dropphyadd": "1892 HIGHWAY 139",
    "dropphycty": "SWARTZ",
    "dropphyst": "LA",
    "dropphyzpp": 712819998,
    "dropmaladd": "1892 HIGHWAY 139",
    "dropmalcty": "SWARTZ",
    "dropmalst": "LA",
    "dropmalzpp": 712819998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183451809,
    "dropfax": 3183432256
  },
  {
    "dcode": "D",
    "dropkey": "PY24544",
    "droptype": "D",
    "dropname": "TALISHEEK",
    "dropdeladd": "32035 HIGHWAY 435",
    "dropdelcty": "TALISHEEK",
    "dropdelst": "LA",
    "dropdelzpp": 704649998,
    "dropphyadd": "32035 HIGHWAY 435",
    "dropphycty": "TALISHEEK",
    "dropphyst": "LA",
    "dropphyzpp": 704649998,
    "dropmaladd": "32035 HIGHWAY 435",
    "dropmalcty": "TALISHEEK",
    "dropmalst": "LA",
    "dropmalzpp": 704649998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9858862189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24546",
    "droptype": "D",
    "dropname": "TALLULAH",
    "dropdeladd": "500 N CEDAR ST",
    "dropdelcty": "TALLULAH",
    "dropdelst": "LA",
    "dropdelzpp": 712829998,
    "dropphyadd": "500 N CEDAR ST",
    "dropphycty": "TALLULAH",
    "dropphyst": "LA",
    "dropphyzpp": 712829998,
    "dropmaladd": "500 N CEDAR ST",
    "dropmalcty": "TALLULAH",
    "dropmalst": "LA",
    "dropmalzpp": 712829998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185743175,
    "dropfax": 3185744085
  },
  {
    "dcode": "D",
    "dropkey": "PY24547",
    "droptype": "D",
    "dropname": "TANGIPAHOA",
    "dropdeladd": "70136 E RAILROAD AVE",
    "dropdelcty": "TANGIPAHOA",
    "dropdelst": "LA",
    "dropdelzpp": 704659998,
    "dropphyadd": "70136 E RAILROAD AVE",
    "dropphycty": "TANGIPAHOA",
    "dropphyst": "LA",
    "dropphyzpp": 704659998,
    "dropmaladd": "70136 E RAILROAD AVE",
    "dropmalcty": "TANGIPAHOA",
    "dropmalst": "LA",
    "dropmalzpp": 704659998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9852293401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24550",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "107 SHORT ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "LA",
    "dropdelzpp": 710809998,
    "dropphyadd": "107 SHORT ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "LA",
    "dropphyzpp": 710809998,
    "dropmaladd": "107 SHORT ST",
    "dropmalcty": "TAYLOR",
    "dropmalst": "LA",
    "dropmalzpp": 710809998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3188436666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24560",
    "droptype": "D",
    "dropname": "THIBODAUX",
    "dropdeladd": "910 CANAL BLVD",
    "dropdelcty": "THIBODAUX",
    "dropdelst": "LA",
    "dropdelzpp": 703019998,
    "dropphyadd": "910 CANAL BLVD",
    "dropphycty": "THIBODAUX",
    "dropphyst": "LA",
    "dropphyzpp": 703019998,
    "dropmaladd": "910 CANAL BLVD",
    "dropmalcty": "THIBODAUX",
    "dropmalst": "LA",
    "dropmalzpp": 703019998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9854466932,
    "dropfax": 9854473739
  },
  {
    "dcode": "D",
    "dropkey": "PY24565",
    "droptype": "D",
    "dropname": "TICKFAW",
    "dropdeladd": "14494 2ND ST",
    "dropdelcty": "TICKFAW",
    "dropdelst": "LA",
    "dropdelzpp": 704669998,
    "dropphyadd": "14494 2ND ST",
    "dropphycty": "TICKFAW",
    "dropphyst": "LA",
    "dropphyzpp": 704669998,
    "dropmaladd": "14494 2ND ST",
    "dropmalcty": "TICKFAW",
    "dropmalst": "LA",
    "dropmalzpp": 704669998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9855426096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24569",
    "droptype": "D",
    "dropname": "TIOGA",
    "dropdeladd": "5019 SHREVEPORT HWY",
    "dropdelcty": "TIOGA",
    "dropdelst": "LA",
    "dropdelzpp": 714779998,
    "dropphyadd": "5019 SHREVEPORT HWY",
    "dropphycty": "TIOGA",
    "dropphyst": "LA",
    "dropphyzpp": 714779998,
    "dropmaladd": "5019 SHREVEPORT HWY",
    "dropmalcty": "TIOGA",
    "dropmalst": "LA",
    "dropmalzpp": 714779998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186409056,
    "dropfax": 3186409241
  },
  {
    "dcode": "D",
    "dropkey": "PY24578",
    "droptype": "D",
    "dropname": "TRANSYLVANIA",
    "dropdeladd": "13119 HIGHWAY 65 S",
    "dropdelcty": "TRANSYLVANIA",
    "dropdelst": "LA",
    "dropdelzpp": 712869998,
    "dropphyadd": "13119 HIGHWAY 65 S",
    "dropphycty": "TRANSYLVANIA",
    "dropphyst": "LA",
    "dropphyzpp": 712869998,
    "dropmaladd": "13119 HIGHWAY 65 S",
    "dropmalcty": "TRANSYLVANIA",
    "dropmalst": "LA",
    "dropmalzpp": 712869998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185593557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24582",
    "droptype": "D",
    "dropname": "TROUT",
    "dropdeladd": "12999 HIGHWAY 84 W",
    "dropdelcty": "TROUT",
    "dropdelst": "LA",
    "dropdelzpp": 713719998,
    "dropphyadd": "12999 HIGHWAY 84 W",
    "dropphycty": "TROUT",
    "dropphyst": "LA",
    "dropphyzpp": 713719998,
    "dropmaladd": "12999 HIGHWAY 84 W",
    "dropmalcty": "TROUT",
    "dropmalst": "LA",
    "dropmalzpp": 713719998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3189928199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24583",
    "droptype": "D",
    "dropname": "TULLOS",
    "dropdeladd": "10175 S MAIN ST",
    "dropdelcty": "TULLOS",
    "dropdelst": "LA",
    "dropdelzpp": 714799998,
    "dropphyadd": "10175 S MAIN ST",
    "dropphycty": "TULLOS",
    "dropphyst": "LA",
    "dropphyzpp": 714799998,
    "dropmaladd": "10175 S MAIN ST",
    "dropmalcty": "TULLOS",
    "dropmalst": "LA",
    "dropmalzpp": 714799998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185346572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24584",
    "droptype": "D",
    "dropname": "TUNICA",
    "dropdeladd": "16630 TUNICA TRCE",
    "dropdelcty": "TUNICA",
    "dropdelst": "LA",
    "dropdelzpp": 707828200,
    "dropphyadd": "16630 TUNICA TRCE",
    "dropphycty": "TUNICA",
    "dropphyst": "LA",
    "dropphyzpp": 707828200,
    "dropmaladd": "PO BOX 8200",
    "dropmalcty": "TUNICA",
    "dropmalst": "LA",
    "dropmalzpp": 707829998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 3376623009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24585",
    "droptype": "D",
    "dropname": "TURKEY CREEK",
    "dropdeladd": "14127 VETERANS MEMORIAL HWY",
    "dropdelcty": "TURKEY CREEK",
    "dropdelst": "LA",
    "dropdelzpp": 705853000,
    "dropphyadd": "14127 VETERANS MEMORIAL HWY",
    "dropphycty": "TURKEY CREEK",
    "dropphyst": "LA",
    "dropphyzpp": 705853000,
    "dropmaladd": "PO BOX 8500",
    "dropmalcty": "TURKEY CREEK",
    "dropmalst": "LA",
    "dropmalzpp": 705859998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374612828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24601",
    "droptype": "D",
    "dropname": "URANIA",
    "dropdeladd": "2150 E HARDTNER DR",
    "dropdelcty": "URANIA",
    "dropdelst": "LA",
    "dropdelzpp": 714809998,
    "dropphyadd": "2150 E HARDTNER DR",
    "dropphycty": "URANIA",
    "dropphyst": "LA",
    "dropphyzpp": 714809998,
    "dropmaladd": "2150 E HARDTNER DR",
    "dropmalcty": "URANIA",
    "dropmalst": "LA",
    "dropmalzpp": 714809998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184953594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24604",
    "droptype": "D",
    "dropname": "VACHERIE",
    "dropdeladd": "2747 HIGHWAY 20",
    "dropdelcty": "VACHERIE",
    "dropdelst": "LA",
    "dropdelzpp": 700909998,
    "dropphyadd": "2747 HIGHWAY 20",
    "dropphycty": "VACHERIE",
    "dropphyst": "LA",
    "dropphyzpp": 700909998,
    "dropmaladd": "2747 HIGHWAY 20",
    "dropmalcty": "VACHERIE",
    "dropmalst": "LA",
    "dropmalzpp": 700909998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 2252659138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24607",
    "droptype": "D",
    "dropname": "VENTRESS",
    "dropdeladd": "7741 LEGION RD",
    "dropdelcty": "VENTRESS",
    "dropdelst": "LA",
    "dropdelzpp": 707839998,
    "dropphyadd": "7741 LEGION RD",
    "dropphycty": "VENTRESS",
    "dropphyst": "LA",
    "dropphyzpp": 707839998,
    "dropmaladd": "7741 LEGION RD",
    "dropmalcty": "VENTRESS",
    "dropmalst": "LA",
    "dropmalzpp": 707839998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256181428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24613",
    "droptype": "D",
    "dropname": "VIDALIA",
    "dropdeladd": "1000 CARTER ST",
    "dropdelcty": "VIDALIA",
    "dropdelst": "LA",
    "dropdelzpp": 713739998,
    "dropphyadd": "1000 CARTER ST",
    "dropphycty": "VIDALIA",
    "dropphyst": "LA",
    "dropphyzpp": 713739998,
    "dropmaladd": "1000 CARTER ST",
    "dropmalcty": "VIDALIA",
    "dropmalst": "LA",
    "dropmalzpp": 713739998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183361912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24618",
    "droptype": "D",
    "dropname": "VILLE PLATTE",
    "dropdeladd": "100 W MAGNOLIA ST",
    "dropdelcty": "VILLE PLATTE",
    "dropdelst": "LA",
    "dropdelzpp": 705864554,
    "dropphyadd": "100 W MAGNOLIA ST",
    "dropphycty": "VILLE PLATTE",
    "dropphyst": "LA",
    "dropphyzpp": 705864554,
    "dropmaladd": "100 W MAGNOLIA ST",
    "dropmalcty": "VILLE PLATTE",
    "dropmalst": "LA",
    "dropmalzpp": 705864554,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3373638863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24620",
    "droptype": "D",
    "dropname": "VINTON",
    "dropdeladd": "1354 HORRIDGE ST",
    "dropdelcty": "VINTON",
    "dropdelst": "LA",
    "dropdelzpp": 706689998,
    "dropphyadd": "1354 HORRIDGE ST",
    "dropphycty": "VINTON",
    "dropphyst": "LA",
    "dropphyzpp": 706689998,
    "dropmaladd": "1354 HORRIDGE ST",
    "dropmalcty": "VINTON",
    "dropmalst": "LA",
    "dropmalzpp": 706689998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3375894163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24622",
    "droptype": "D",
    "dropname": "VIVIAN",
    "dropdeladd": "203 W LOUISIANA AVE",
    "dropdelcty": "VIVIAN",
    "dropdelst": "LA",
    "dropdelzpp": 710829998,
    "dropphyadd": "203 W LOUISIANA AVE",
    "dropphycty": "VIVIAN",
    "dropphyst": "LA",
    "dropphyzpp": 710829998,
    "dropmaladd": "203 W LOUISIANA AVE",
    "dropmalcty": "VIVIAN",
    "dropmalst": "LA",
    "dropmalzpp": 710829998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183752598,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24628",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "11206 U S HIGHWAY 61",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "LA",
    "dropdelzpp": 707848400,
    "dropphyadd": "11206 U S HIGHWAY 61",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "LA",
    "dropphyzpp": 707848400,
    "dropmaladd": "PO BOX 8400",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "LA",
    "dropmalzpp": 707849998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256353074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24629",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "10053 FLORIDA BLVD",
    "dropdelcty": "WALKER",
    "dropdelst": "LA",
    "dropdelzpp": 707859998,
    "dropphyadd": "10053 FLORIDA BLVD",
    "dropphycty": "WALKER",
    "dropphyst": "LA",
    "dropphyzpp": 707859998,
    "dropmaladd": "10053 FLORIDA BLVD",
    "dropmalcty": "WALKER",
    "dropmalst": "LA",
    "dropmalzpp": 707859998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256671589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24638",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "112 E MOUNDVILLE ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "LA",
    "dropdelzpp": 705899998,
    "dropphyadd": "112 E MOUNDVILLE ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "LA",
    "dropphyzpp": 705899998,
    "dropmaladd": "112 E MOUNDVILLE ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "LA",
    "dropmalzpp": 705899998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378264839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24641",
    "droptype": "D",
    "dropname": "WATERPROOF",
    "dropdeladd": "338 MAIN ST",
    "dropdelcty": "WATERPROOF",
    "dropdelst": "LA",
    "dropdelzpp": 713759998,
    "dropphyadd": "338 MAIN ST",
    "dropphycty": "WATERPROOF",
    "dropphyst": "LA",
    "dropphyzpp": 713759998,
    "dropmaladd": "338 MAIN ST",
    "dropmalcty": "WATERPROOF",
    "dropmalst": "LA",
    "dropmalzpp": 713759998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187499697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24642",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "8040 WATSON CIR",
    "dropdelcty": "WATSON",
    "dropdelst": "LA",
    "dropdelzpp": 707865000,
    "dropphyadd": "8040 WATSON CIR",
    "dropphycty": "WATSON",
    "dropphyst": "LA",
    "dropphyzpp": 707865000,
    "dropmaladd": "PO BOX 8600",
    "dropmalcty": "WATSON",
    "dropmalst": "LA",
    "dropmalzpp": 707869998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256658540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24647",
    "droptype": "D",
    "dropname": "WELSH",
    "dropdeladd": "202 CROWLEY ST",
    "dropdelcty": "WELSH",
    "dropdelst": "LA",
    "dropdelzpp": 705919998,
    "dropphyadd": "202 CROWLEY ST",
    "dropphycty": "WELSH",
    "dropphyst": "LA",
    "dropphyzpp": 705919998,
    "dropmaladd": "202 CROWLEY ST",
    "dropmalcty": "WELSH",
    "dropmalst": "LA",
    "dropmalzpp": 705919998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3377342241,
    "dropfax": 3377343127
  },
  {
    "dcode": "D",
    "dropkey": "PY24648",
    "droptype": "D",
    "dropname": "WEST MONROE",
    "dropdeladd": "601 WOOD ST",
    "dropdelcty": "WEST MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712919998,
    "dropphyadd": "601 WOOD ST",
    "dropphycty": "WEST MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712919998,
    "dropmaladd": "601 WOOD ST",
    "dropmalcty": "WEST MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712919998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183239847,
    "dropfax": 3183878858
  },
  {
    "dcode": "D",
    "dropkey": "PY24652",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "1504 GUILLORY ST",
    "dropdelcty": "WESTLAKE",
    "dropdelst": "LA",
    "dropdelzpp": 706699998,
    "dropphyadd": "1504 GUILLORY ST",
    "dropphycty": "WESTLAKE",
    "dropphyst": "LA",
    "dropphyzpp": 706699998,
    "dropmaladd": "1504 GUILLORY ST",
    "dropmalcty": "WESTLAKE",
    "dropmalst": "LA",
    "dropmalzpp": 706699998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374363402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24656",
    "droptype": "D",
    "dropname": "WESTWEGO",
    "dropdeladd": "1335 WESTBANK EXPY",
    "dropdelcty": "WESTWEGO",
    "dropdelst": "LA",
    "dropdelzpp": 700949998,
    "dropphyadd": "1335 WESTBANK EXPY",
    "dropphycty": "WESTWEGO",
    "dropphyst": "LA",
    "dropphyzpp": 700949998,
    "dropmaladd": "1335 WESTBANK EXPY",
    "dropmalcty": "WESTWEGO",
    "dropmalst": "LA",
    "dropmalzpp": 700949998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5046816161,
    "dropfax": 5045891831
  },
  {
    "dcode": "D",
    "dropkey": "PY24658",
    "droptype": "D",
    "dropname": "WEYANOKE",
    "dropdeladd": "6220 OUIDA IRONDALE RD",
    "dropdelcty": "WEYANOKE",
    "dropdelst": "LA",
    "dropdelzpp": 707878700,
    "dropphyadd": "6220 OUIDA IRONDALE RD",
    "dropphycty": "WEYANOKE",
    "dropphyst": "LA",
    "dropphyzpp": 707878700,
    "dropmaladd": "PO BOX 8700",
    "dropmalcty": "WEYANOKE",
    "dropmalst": "LA",
    "dropmalzpp": 707879998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256554454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24661",
    "droptype": "D",
    "dropname": "WHITE CASTLE",
    "dropdeladd": "32495 LEONA AVE",
    "dropdelcty": "WHITE CASTLE",
    "dropdelst": "LA",
    "dropdelzpp": 707889998,
    "dropphyadd": "32495 LEONA AVE",
    "dropphycty": "WHITE CASTLE",
    "dropphyst": "LA",
    "dropphyzpp": 707889998,
    "dropmaladd": "32495 LEONA AVE",
    "dropmalcty": "WHITE CASTLE",
    "dropmalst": "LA",
    "dropmalzpp": 707889998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2255454926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24674",
    "droptype": "D",
    "dropname": "WILSON",
    "dropdeladd": "10029 HIGHWAY 19",
    "dropdelcty": "WILSON",
    "dropdelst": "LA",
    "dropdelzpp": 707899998,
    "dropphyadd": "10029 HIGHWAY 19",
    "dropphycty": "WILSON",
    "dropphyst": "LA",
    "dropphyzpp": 707899998,
    "dropmaladd": "10029 HIGHWAY 19",
    "dropmalcty": "WILSON",
    "dropmalst": "LA",
    "dropmalzpp": 707899998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2256299945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24676",
    "droptype": "D",
    "dropname": "WINNFIELD",
    "dropdeladd": "201 S BEVILL ST",
    "dropdelcty": "WINNFIELD",
    "dropdelst": "LA",
    "dropdelzpp": 714839998,
    "dropphyadd": "201 S BEVILL ST",
    "dropphycty": "WINNFIELD",
    "dropphyst": "LA",
    "dropphyzpp": 714839998,
    "dropmaladd": "201 S BEVILL ST",
    "dropmalcty": "WINNFIELD",
    "dropmalst": "LA",
    "dropmalzpp": 714839998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186488164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24677",
    "droptype": "D",
    "dropname": "WINNSBORO",
    "dropdeladd": "3900 FRONT ST",
    "dropdelcty": "WINNSBORO",
    "dropdelst": "LA",
    "dropdelzpp": 712959998,
    "dropphyadd": "3900 FRONT ST",
    "dropphycty": "WINNSBORO",
    "dropphyst": "LA",
    "dropphyzpp": 712959998,
    "dropmaladd": "3900 FRONT ST",
    "dropmalcty": "WINNSBORO",
    "dropmalst": "LA",
    "dropmalzpp": 712959998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184128356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24678",
    "droptype": "D",
    "dropname": "WISNER",
    "dropdeladd": "130 FORT SCOTT ST",
    "dropdelcty": "WISNER",
    "dropdelst": "LA",
    "dropdelzpp": 713789998,
    "dropphyadd": "130 FORT SCOTT ST",
    "dropphycty": "WISNER",
    "dropphyst": "LA",
    "dropphyzpp": 713789998,
    "dropmaladd": "130 FORT SCOTT ST",
    "dropmalcty": "WISNER",
    "dropmalst": "LA",
    "dropmalzpp": 713789998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187246731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24686",
    "droptype": "D",
    "dropname": "WOODWORTH",
    "dropdeladd": "20 CASTOR PLUNGE RD",
    "dropdelcty": "WOODWORTH",
    "dropdelst": "LA",
    "dropdelzpp": 714859998,
    "dropphyadd": "20 CASTOR PLUNGE RD",
    "dropphycty": "WOODWORTH",
    "dropphyst": "LA",
    "dropphyzpp": 714859998,
    "dropmaladd": "20 CASTOR PLUNGE RD",
    "dropmalcty": "WOODWORTH",
    "dropmalst": "LA",
    "dropmalzpp": 714859998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184276982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24689",
    "droptype": "D",
    "dropname": "YOUNGSVILLE",
    "dropdeladd": "401 IBERIA ST",
    "dropdelcty": "YOUNGSVILLE",
    "dropdelst": "LA",
    "dropdelzpp": 705929998,
    "dropphyadd": "401 IBERIA ST",
    "dropphycty": "YOUNGSVILLE",
    "dropphyst": "LA",
    "dropphyzpp": 705929998,
    "dropmaladd": "401 IBERIA ST",
    "dropmalcty": "YOUNGSVILLE",
    "dropmalst": "LA",
    "dropmalzpp": 705929998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378570972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24691",
    "droptype": "D",
    "dropname": "ZACHARY",
    "dropdeladd": "6001 MAIN ST",
    "dropdelcty": "ZACHARY",
    "dropdelst": "LA",
    "dropdelzpp": 707914032,
    "dropphyadd": "6001 MAIN ST",
    "dropphycty": "ZACHARY",
    "dropphyst": "LA",
    "dropphyzpp": 707914032,
    "dropmaladd": "PO BOX 9100",
    "dropmalcty": "ZACHARY",
    "dropmalst": "LA",
    "dropmalzpp": 707919998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2255705070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24696",
    "droptype": "D",
    "dropname": "ZWOLLE",
    "dropdeladd": "1237 N MAIN ST",
    "dropdelcty": "ZWOLLE",
    "dropdelst": "LA",
    "dropdelzpp": 714869998,
    "dropphyadd": "1237 N MAIN ST",
    "dropphycty": "ZWOLLE",
    "dropphyst": "LA",
    "dropphyzpp": 714869998,
    "dropmaladd": "1237 N MAIN ST",
    "dropmalcty": "ZWOLLE",
    "dropmalst": "LA",
    "dropmalzpp": 714869998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186456512,
    "dropfax": 3186452599
  },
  {
    "dcode": "D",
    "dropkey": "PY24699",
    "droptype": "D",
    "dropname": "ADA",
    "dropdeladd": "114 4TH AVE W",
    "dropdelcty": "ADA",
    "dropdelst": "MN",
    "dropdelzpp": 565109998,
    "dropphyadd": "114 4TH AVE W",
    "dropphycty": "ADA",
    "dropphyst": "MN",
    "dropphyzpp": 565109998,
    "dropmaladd": "114 4TH AVE W",
    "dropmalcty": "ADA",
    "dropmalst": "MN",
    "dropmalzpp": 565109998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187842641,
    "dropsitcph": 2187842641,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24700",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "18 NW 4TH ST",
    "dropdelcty": "ADAMS",
    "dropdelst": "MN",
    "dropdelzpp": 559099672,
    "dropphyadd": "18 NW 4TH ST",
    "dropphycty": "ADAMS",
    "dropphyst": "MN",
    "dropphyzpp": 559099672,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADAMS",
    "dropmalst": "MN",
    "dropmalzpp": 559099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075823424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24702",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "209 MAINE AVE STE 104",
    "dropdelcty": "ADRIAN",
    "dropdelst": "MN",
    "dropdelzpp": 561101071,
    "dropphyadd": "209 MAINE AVE STE 104",
    "dropphycty": "ADRIAN",
    "dropphyst": "MN",
    "dropphyzpp": 561101071,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADRIAN",
    "dropmalst": "MN",
    "dropmalzpp": 561109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074833677,
    "dropfax": 5074833648
  },
  {
    "dcode": "D",
    "dropkey": "PY24703",
    "droptype": "D",
    "dropname": "AFTON",
    "dropdeladd": "3121 SAINT CROIX TRL S",
    "dropdelcty": "AFTON",
    "dropdelst": "MN",
    "dropdelzpp": 550019419,
    "dropphyadd": "3121 SAINT CROIX TRL S",
    "dropphycty": "AFTON",
    "dropphyst": "MN",
    "dropphyzpp": 550019419,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AFTON",
    "dropmalst": "MN",
    "dropmalzpp": 550019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514367430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24707",
    "droptype": "D",
    "dropname": "AITKIN",
    "dropdeladd": "15 MINNESOTA AVE N",
    "dropdelcty": "AITKIN",
    "dropdelst": "MN",
    "dropdelzpp": 564311407,
    "dropphyadd": "15 MINNESOTA AVE N",
    "dropphycty": "AITKIN",
    "dropphyst": "MN",
    "dropphyzpp": 564311407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AITKIN",
    "dropmalst": "MN",
    "dropmalzpp": 564319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189272518,
    "dropfax": 2189273698
  },
  {
    "dcode": "D",
    "dropkey": "PY24708",
    "droptype": "D",
    "dropname": "AKELEY",
    "dropdeladd": "10 BROADWAY ST W",
    "dropdelcty": "AKELEY",
    "dropdelst": "MN",
    "dropdelzpp": 564338415,
    "dropphyadd": "10 BROADWAY ST W",
    "dropphycty": "AKELEY",
    "dropphyst": "MN",
    "dropphyzpp": 564338415,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKELEY",
    "dropmalst": "MN",
    "dropmalzpp": 564339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186522295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24711",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "141 RAILROAD AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "MN",
    "dropdelzpp": 563079382,
    "dropphyadd": "141 RAILROAD AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "MN",
    "dropphyzpp": 563079382,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBANY",
    "dropmalst": "MN",
    "dropmalzpp": 563079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208454171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24712",
    "droptype": "D",
    "dropname": "ALBERT LEA",
    "dropdeladd": "141 S NEWTON AVE",
    "dropdelcty": "ALBERT LEA",
    "dropdelst": "MN",
    "dropdelzpp": 560072524,
    "dropphyadd": "141 S NEWTON AVE",
    "dropphycty": "ALBERT LEA",
    "dropphyst": "MN",
    "dropphyzpp": 560072524,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBERT LEA",
    "dropmalst": "MN",
    "dropmalzpp": 560079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073733167,
    "dropfax": 5073770683
  },
  {
    "dcode": "D",
    "dropkey": "PY24713",
    "droptype": "D",
    "dropname": "ALBERTA",
    "dropdeladd": "303 MAIN ST",
    "dropdelcty": "ALBERTA",
    "dropdelst": "MN",
    "dropdelzpp": 562075000,
    "dropphyadd": "303 MAIN ST",
    "dropphycty": "ALBERTA",
    "dropphyst": "MN",
    "dropphyzpp": 562075000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBERTA",
    "dropmalst": "MN",
    "dropmalzpp": 562079998,
    "dropsitphn": 6213496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203242511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24714",
    "droptype": "D",
    "dropname": "ALBERTVILLE",
    "dropdeladd": "5900 MAIN AVE NE",
    "dropdelcty": "ALBERTVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 553019775,
    "dropphyadd": "5900 MAIN AVE NE",
    "dropphycty": "ALBERTVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 553019775,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALBERTVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 553019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634977691,
    "dropfax": 7634977691
  },
  {
    "dcode": "D",
    "dropkey": "PY24716",
    "droptype": "D",
    "dropname": "ALDEN",
    "dropdeladd": "101 N BROADWAY",
    "dropdelcty": "ALDEN",
    "dropdelst": "MN",
    "dropdelzpp": 560099700,
    "dropphyadd": "101 N BROADWAY",
    "dropphycty": "ALDEN",
    "dropphyst": "MN",
    "dropphyzpp": 560099700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALDEN",
    "dropmalst": "MN",
    "dropmalzpp": 560099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078743740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24717",
    "droptype": "D",
    "dropname": "ALDRICH",
    "dropdeladd": "175 CENTRAL AVE N",
    "dropdelcty": "ALDRICH",
    "dropdelst": "MN",
    "dropdelzpp": 564342016,
    "dropphyadd": "175 CENTRAL AVE N",
    "dropphycty": "ALDRICH",
    "dropphyst": "MN",
    "dropphyzpp": 564342016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALDRICH",
    "dropmalst": "MN",
    "dropmalzpp": 564349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184455604,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24719",
    "droptype": "D",
    "dropname": "ALEXANDRIA",
    "dropdeladd": "519 ELM ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "MN",
    "dropdelzpp": 563089905,
    "dropphyadd": "519 ELM ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "MN",
    "dropphyzpp": 563089905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "MN",
    "dropmalzpp": 563089998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207633432,
    "dropfax": 3207639695
  },
  {
    "dcode": "D",
    "dropkey": "PY24724",
    "droptype": "D",
    "dropname": "ALPHA",
    "dropdeladd": "115 MAIN ST N",
    "dropdelcty": "ALPHA",
    "dropdelst": "MN",
    "dropdelzpp": 561114003,
    "dropphyadd": "115 MAIN ST N",
    "dropphycty": "ALPHA",
    "dropphyst": "MN",
    "dropphyzpp": 561114003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPHA",
    "dropmalst": "MN",
    "dropmalzpp": 561119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078472942,
    "dropfax": 5078472942
  },
  {
    "dcode": "D",
    "dropkey": "PY24725",
    "droptype": "D",
    "dropname": "ALTURA",
    "dropdeladd": "17 S MAIN ST",
    "dropdelcty": "ALTURA",
    "dropdelst": "MN",
    "dropdelzpp": 559109628,
    "dropphyadd": "17 S MAIN ST",
    "dropphycty": "ALTURA",
    "dropphyst": "MN",
    "dropphyzpp": 559109628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTURA",
    "dropmalst": "MN",
    "dropmalzpp": 559109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077966896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24726",
    "droptype": "D",
    "dropname": "ALVARADO",
    "dropdeladd": "200 MARSHALL ST",
    "dropdelcty": "ALVARADO",
    "dropdelst": "MN",
    "dropdelzpp": 567109998,
    "dropphyadd": "200 MARSHALL ST",
    "dropphycty": "ALVARADO",
    "dropphyst": "MN",
    "dropphyzpp": 567109998,
    "dropmaladd": "200 MARSHALL ST",
    "dropmalcty": "ALVARADO",
    "dropmalst": "MN",
    "dropmalzpp": 567109998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189654548,
    "dropsitcph": 2189654548,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24728",
    "droptype": "D",
    "dropname": "AMBOY",
    "dropdeladd": "208 E MAINE ST",
    "dropdelcty": "AMBOY",
    "dropdelst": "MN",
    "dropdelzpp": 560103200,
    "dropphyadd": "208 E MAINE ST",
    "dropphycty": "AMBOY",
    "dropphyst": "MN",
    "dropphyzpp": 560103200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMBOY",
    "dropmalst": "MN",
    "dropmalzpp": 560109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076743042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24733",
    "droptype": "D",
    "dropname": "ANGLE INLET",
    "dropdeladd": "9394 GOLF COURSE DR NW",
    "dropdelcty": "ANGLE INLET",
    "dropdelst": "MN",
    "dropdelzpp": 567119998,
    "dropphyadd": "9394 GOLF COURSE DR NW",
    "dropphycty": "ANGLE INLET",
    "dropphyst": "MN",
    "dropphyzpp": 567119998,
    "dropmaladd": "9394 GOLF COURSE DR NW",
    "dropmalcty": "ANGLE INLET",
    "dropmalst": "MN",
    "dropmalzpp": 567119998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182234036,
    "dropsitcph": 2182234036,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24736",
    "droptype": "D",
    "dropname": "ANNANDALE",
    "dropdeladd": "83 OAK AVE N",
    "dropdelcty": "ANNANDALE",
    "dropdelst": "MN",
    "dropdelzpp": 553021199,
    "dropphyadd": "83 OAK AVE N",
    "dropphycty": "ANNANDALE",
    "dropphyst": "MN",
    "dropphyzpp": 553021199,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANNANDALE",
    "dropmalst": "MN",
    "dropmalzpp": 553029998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202743600,
    "dropfax": 3202746327
  },
  {
    "dcode": "D",
    "dropkey": "PY24737",
    "droptype": "D",
    "dropname": "ANOKA",
    "dropdeladd": "2168 7TH AVE",
    "dropdelcty": "ANOKA",
    "dropdelst": "MN",
    "dropdelzpp": 553031713,
    "dropphyadd": "2168 7TH AVE",
    "dropphycty": "ANOKA",
    "dropphyst": "MN",
    "dropphyzpp": 553031713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANOKA",
    "dropmalst": "MN",
    "dropmalzpp": 553039998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7634221507,
    "dropsitcph": 7634221507,
    "dropfax": 6124467972
  },
  {
    "dcode": "D",
    "dropkey": "PY24742",
    "droptype": "D",
    "dropname": "APPLETON",
    "dropdeladd": "42 W SORENSON AVE",
    "dropdelcty": "APPLETON",
    "dropdelst": "MN",
    "dropdelzpp": 562081360,
    "dropphyadd": "42 W SORENSON AVE",
    "dropphycty": "APPLETON",
    "dropphyst": "MN",
    "dropphyzpp": 562081360,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "APPLETON",
    "dropmalst": "MN",
    "dropmalzpp": 562089998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202892522,
    "dropfax": 3202891068
  },
  {
    "dcode": "D",
    "dropkey": "PY24744",
    "droptype": "D",
    "dropname": "ARCO",
    "dropdeladd": "110 E LAUREL ST",
    "dropdelcty": "ARCO",
    "dropdelst": "MN",
    "dropdelzpp": 561133009,
    "dropphyadd": "110 E LAUREL ST",
    "dropphycty": "ARCO",
    "dropphyst": "MN",
    "dropphyzpp": 561133009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCO",
    "dropmalst": "MN",
    "dropmalzpp": 561139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074875515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24751",
    "droptype": "D",
    "dropname": "ARGYLE",
    "dropdeladd": "108 W 3RD ST",
    "dropdelcty": "ARGYLE",
    "dropdelst": "MN",
    "dropdelzpp": 567139998,
    "dropphyadd": "108 W 3RD ST",
    "dropphycty": "ARGYLE",
    "dropphyst": "MN",
    "dropphyzpp": 567139998,
    "dropmaladd": "108 W 3RD ST",
    "dropmalcty": "ARGYLE",
    "dropmalst": "MN",
    "dropmalzpp": 567139998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184376661,
    "dropsitcph": 2184376661,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24752",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "220 W MAIN ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "MN",
    "dropdelzpp": 553079700,
    "dropphyadd": "220 W MAIN ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "MN",
    "dropphyzpp": 553079700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "MN",
    "dropmalzpp": 553079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079645503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24757",
    "droptype": "D",
    "dropname": "ASHBY",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "ASHBY",
    "dropdelst": "MN",
    "dropdelzpp": 563094687,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "ASHBY",
    "dropphyst": "MN",
    "dropphyzpp": 563094687,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHBY",
    "dropmalst": "MN",
    "dropmalzpp": 563099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187472933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24758",
    "droptype": "D",
    "dropname": "ASKOV",
    "dropdeladd": "6370 KOBMAGERGADE",
    "dropdelcty": "ASKOV",
    "dropdelst": "MN",
    "dropdelzpp": 557044280,
    "dropphyadd": "6370 KOBMAGERGADE",
    "dropphycty": "ASKOV",
    "dropphyst": "MN",
    "dropphyzpp": 557044280,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASKOV",
    "dropmalst": "MN",
    "dropmalzpp": 557049998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208383477,
    "dropfax": 3208381631
  },
  {
    "dcode": "D",
    "dropkey": "PY24761",
    "droptype": "D",
    "dropname": "ATWATER",
    "dropdeladd": "107 3RD ST N",
    "dropdelcty": "ATWATER",
    "dropdelst": "MN",
    "dropdelzpp": 562095000,
    "dropphyadd": "107 3RD ST N",
    "dropphycty": "ATWATER",
    "dropphyst": "MN",
    "dropphyzpp": 562095000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ATWATER",
    "dropmalst": "MN",
    "dropmalzpp": 562099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3209748676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24762",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "215 4TH ST",
    "dropdelcty": "AUDUBON",
    "dropdelst": "MN",
    "dropdelzpp": 565119998,
    "dropphyadd": "215 4TH ST",
    "dropphycty": "AUDUBON",
    "dropphyst": "MN",
    "dropphyzpp": 565119998,
    "dropmaladd": "215 4TH ST",
    "dropmalcty": "AUDUBON",
    "dropmalst": "MN",
    "dropmalzpp": 565119998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184396250,
    "dropsitcph": 2184396250,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24764",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "200 MAIN ST N",
    "dropdelcty": "AURORA",
    "dropdelst": "MN",
    "dropdelzpp": 557051346,
    "dropphyadd": "200 MAIN ST N",
    "dropphycty": "AURORA",
    "dropphyst": "MN",
    "dropphyzpp": 557051346,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AURORA",
    "dropmalst": "MN",
    "dropmalzpp": 557059998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182293111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24766",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "200 1ST AVE SE",
    "dropdelcty": "AUSTIN",
    "dropdelst": "MN",
    "dropdelzpp": 559123465,
    "dropphyadd": "200 1ST AVE SE",
    "dropphycty": "AUSTIN",
    "dropphyst": "MN",
    "dropphyzpp": 559123465,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTIN",
    "dropmalst": "MN",
    "dropmalzpp": 559129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074344748,
    "dropfax": 5074371174
  },
  {
    "dcode": "D",
    "dropkey": "PY24768",
    "droptype": "D",
    "dropname": "AVOCA",
    "dropdeladd": "140 SW 2ND ST",
    "dropdelcty": "AVOCA",
    "dropdelst": "MN",
    "dropdelzpp": 561149700,
    "dropphyadd": "140 SW 2ND ST",
    "dropphycty": "AVOCA",
    "dropphyst": "MN",
    "dropphyzpp": 561149700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVOCA",
    "dropmalst": "MN",
    "dropmalzpp": 561149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073357842,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24769",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "317 BLATTNER DR",
    "dropdelcty": "AVON",
    "dropdelst": "MN",
    "dropdelzpp": 563108674,
    "dropphyadd": "317 BLATTNER DR",
    "dropphycty": "AVON",
    "dropphyst": "MN",
    "dropphyzpp": 563108674,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVON",
    "dropmalst": "MN",
    "dropmalzpp": 563109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203567676,
    "dropfax": 3203567942
  },
  {
    "dcode": "D",
    "dropkey": "PY24770",
    "droptype": "D",
    "dropname": "BABBITT",
    "dropdeladd": "33 CENTRAL BLVD STE 100",
    "dropdelcty": "BABBITT",
    "dropdelst": "MN",
    "dropdelzpp": 557061156,
    "dropphyadd": "33 CENTRAL BLVD STE 100",
    "dropphycty": "BABBITT",
    "dropphyst": "MN",
    "dropphyzpp": 557061156,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABBITT",
    "dropmalst": "MN",
    "dropmalzpp": 557069998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188273304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24771",
    "droptype": "D",
    "dropname": "BACKUS",
    "dropdeladd": "114 WASHBURN AVE E",
    "dropdelcty": "BACKUS",
    "dropdelst": "MN",
    "dropdelzpp": 564354500,
    "dropphyadd": "114 WASHBURN AVE E",
    "dropphycty": "BACKUS",
    "dropphyst": "MN",
    "dropphyzpp": 564354500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BACKUS",
    "dropmalst": "MN",
    "dropmalzpp": 564359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189474767,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24772",
    "droptype": "D",
    "dropname": "BADGER",
    "dropdeladd": "109 N MAIN ST",
    "dropdelcty": "BADGER",
    "dropdelst": "MN",
    "dropdelzpp": 567149998,
    "dropphyadd": "109 N MAIN ST",
    "dropphycty": "BADGER",
    "dropphyst": "MN",
    "dropphyzpp": 567149998,
    "dropmaladd": "109 N MAIN ST",
    "dropmalcty": "BADGER",
    "dropmalst": "MN",
    "dropmalzpp": 567149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185283500,
    "dropsitcph": 8778546660,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24773",
    "droptype": "D",
    "dropname": "BAGLEY",
    "dropdeladd": "26 GETCHELL AVE NE",
    "dropdelcty": "BAGLEY",
    "dropdelst": "MN",
    "dropdelzpp": 566218763,
    "dropphyadd": "26 GETCHELL AVE NE",
    "dropphycty": "BAGLEY",
    "dropphyst": "MN",
    "dropphyzpp": 566218763,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAGLEY",
    "dropmalst": "MN",
    "dropmalzpp": 566219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186946458,
    "dropfax": 2186943375
  },
  {
    "dcode": "D",
    "dropkey": "PY24775",
    "droptype": "D",
    "dropname": "BALATON",
    "dropdeladd": "120 3RD ST",
    "dropdelcty": "BALATON",
    "dropdelst": "MN",
    "dropdelzpp": 561159451,
    "dropphyadd": "120 3RD ST",
    "dropphycty": "BALATON",
    "dropphyst": "MN",
    "dropphyzpp": 561159451,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALATON",
    "dropmalst": "MN",
    "dropmalzpp": 561159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077343721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24781",
    "droptype": "D",
    "dropname": "BARNESVILLE",
    "dropdeladd": "212 FRONT ST S",
    "dropdelcty": "BARNESVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 565149998,
    "dropphyadd": "212 FRONT ST S",
    "dropphycty": "BARNESVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 565149998,
    "dropmaladd": "212 FRONT ST S",
    "dropmalcty": "BARNESVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 565149998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183547736,
    "dropsitcph": 2183547736,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24782",
    "droptype": "D",
    "dropname": "BARNUM",
    "dropdeladd": "3686 ALAN SYVERSON DR",
    "dropdelcty": "BARNUM",
    "dropdelst": "MN",
    "dropdelzpp": 557077004,
    "dropphyadd": "3686 ALAN SYVERSON DR",
    "dropphycty": "BARNUM",
    "dropphyst": "MN",
    "dropphyzpp": 557077004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARNUM",
    "dropmalst": "MN",
    "dropmalzpp": 557079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183896904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24783",
    "droptype": "D",
    "dropname": "BARRETT",
    "dropdeladd": "103 HAWKINS AVE",
    "dropdelcty": "BARRETT",
    "dropdelst": "MN",
    "dropdelzpp": 563114537,
    "dropphyadd": "103 HAWKINS AVE",
    "dropphycty": "BARRETT",
    "dropphyst": "MN",
    "dropphyzpp": 563114537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARRETT",
    "dropmalst": "MN",
    "dropmalzpp": 563119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205282209,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24789",
    "droptype": "D",
    "dropname": "BATTLE LAKE",
    "dropdeladd": "116 N LAKE AVE",
    "dropdelcty": "BATTLE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 565159998,
    "dropphyadd": "116 N LAKE AVE",
    "dropphycty": "BATTLE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 565159998,
    "dropmaladd": "116 N LAKE AVE",
    "dropmalcty": "BATTLE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 565159998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188648962,
    "dropsitcph": 2188648962,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24791",
    "droptype": "D",
    "dropname": "BAUDETTE",
    "dropdeladd": "119 1ST AVE NW",
    "dropdelcty": "BAUDETTE",
    "dropdelst": "MN",
    "dropdelzpp": 566232863,
    "dropphyadd": "119 1ST AVE NW",
    "dropphycty": "BAUDETTE",
    "dropphyst": "MN",
    "dropphyzpp": 566232863,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAUDETTE",
    "dropmalst": "MN",
    "dropmalzpp": 566239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183953016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24796",
    "droptype": "D",
    "dropname": "BAYPORT",
    "dropdeladd": "209 3RD ST N",
    "dropdelcty": "BAYPORT",
    "dropdelst": "MN",
    "dropdelzpp": 550031028,
    "dropphyadd": "209 3RD ST N",
    "dropphycty": "BAYPORT",
    "dropphyst": "MN",
    "dropphyzpp": 550031028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYPORT",
    "dropmalst": "MN",
    "dropmalzpp": 550039998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514395441,
    "dropfax": 6513519234
  },
  {
    "dcode": "D",
    "dropkey": "PY24801",
    "droptype": "D",
    "dropname": "BEARDSLEY",
    "dropdeladd": "116 MAIN ST N",
    "dropdelcty": "BEARDSLEY",
    "dropdelst": "MN",
    "dropdelzpp": 562119700,
    "dropphyadd": "116 MAIN ST N",
    "dropphycty": "BEARDSLEY",
    "dropphyst": "MN",
    "dropphyzpp": 562119700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEARDSLEY",
    "dropmalst": "MN",
    "dropmalzpp": 562119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202656962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24804",
    "droptype": "D",
    "dropname": "BEAVER BAY",
    "dropdeladd": "1014 MAIN ST",
    "dropdelcty": "BEAVER BAY",
    "dropdelst": "MN",
    "dropdelzpp": 556014400,
    "dropphyadd": "1014 MAIN ST",
    "dropphycty": "BEAVER BAY",
    "dropphyst": "MN",
    "dropphyzpp": 556014400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER BAY",
    "dropmalst": "MN",
    "dropmalzpp": 556019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182264129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24805",
    "droptype": "D",
    "dropname": "BEAVER CREEK",
    "dropdeladd": "313 E 1ST AVE",
    "dropdelcty": "BEAVER CREEK",
    "dropdelst": "MN",
    "dropdelzpp": 561161114,
    "dropphyadd": "313 E 1ST AVE",
    "dropphycty": "BEAVER CREEK",
    "dropphyst": "MN",
    "dropphyzpp": 561161114,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER CREEK",
    "dropmalst": "MN",
    "dropmalzpp": 561169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076732342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24808",
    "droptype": "D",
    "dropname": "BECKER",
    "dropdeladd": "13974 1ST ST",
    "dropdelcty": "BECKER",
    "dropdelst": "MN",
    "dropdelzpp": 553089349,
    "dropphyadd": "13974 1ST ST",
    "dropphycty": "BECKER",
    "dropphyst": "MN",
    "dropphyzpp": 553089349,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BECKER",
    "dropmalst": "MN",
    "dropmalzpp": 553089998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632620264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24809",
    "droptype": "D",
    "dropname": "BEJOU",
    "dropdeladd": "525 MAIN ST",
    "dropdelcty": "BEJOU",
    "dropdelst": "MN",
    "dropdelzpp": 565169998,
    "dropphyadd": "525 MAIN ST",
    "dropphycty": "BEJOU",
    "dropphyst": "MN",
    "dropphyzpp": 565169998,
    "dropmaladd": "525 MAIN ST",
    "dropmalcty": "BEJOU",
    "dropmalst": "MN",
    "dropmalzpp": 565169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189355708,
    "dropsitcph": 2189355708,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24810",
    "droptype": "D",
    "dropname": "BELGRADE",
    "dropdeladd": "421 WASHBURN AVE",
    "dropdelcty": "BELGRADE",
    "dropdelst": "MN",
    "dropdelzpp": 563124617,
    "dropphyadd": "421 WASHBURN AVE",
    "dropphycty": "BELGRADE",
    "dropphyst": "MN",
    "dropphyzpp": 563124617,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELGRADE",
    "dropmalst": "MN",
    "dropmalzpp": 563129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202543302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24811",
    "droptype": "D",
    "dropname": "BELLE PLAINE",
    "dropdeladd": "233 N MERIDIAN ST",
    "dropdelcty": "BELLE PLAINE",
    "dropdelst": "MN",
    "dropdelzpp": 560111827,
    "dropphyadd": "233 N MERIDIAN ST",
    "dropphycty": "BELLE PLAINE",
    "dropphyst": "MN",
    "dropphyzpp": 560111827,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLE PLAINE",
    "dropmalst": "MN",
    "dropmalzpp": 560119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9528735600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24812",
    "droptype": "D",
    "dropname": "BELLINGHAM",
    "dropdeladd": "305 2ND ST S",
    "dropdelcty": "BELLINGHAM",
    "dropdelst": "MN",
    "dropdelzpp": 562121000,
    "dropphyadd": "305 2ND ST S",
    "dropphycty": "BELLINGHAM",
    "dropphyst": "MN",
    "dropphyzpp": 562121000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLINGHAM",
    "dropmalst": "MN",
    "dropmalzpp": 562129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205682504,
    "dropfax": 3205682504
  },
  {
    "dcode": "D",
    "dropkey": "PY24813",
    "droptype": "D",
    "dropname": "BELTRAMI",
    "dropdeladd": "214 E 6TH ST",
    "dropdelcty": "BELTRAMI",
    "dropdelst": "MN",
    "dropdelzpp": 565179998,
    "dropphyadd": "214 E 6TH ST",
    "dropphycty": "BELTRAMI",
    "dropphyst": "MN",
    "dropphyzpp": 565179998,
    "dropmaladd": "214 E 6TH ST",
    "dropmalcty": "BELTRAMI",
    "dropmalst": "MN",
    "dropmalzpp": 565179998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189265512,
    "dropsitcph": 2189265512,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24814",
    "droptype": "D",
    "dropname": "BELVIEW",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "BELVIEW",
    "dropdelst": "MN",
    "dropdelzpp": 562145000,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "BELVIEW",
    "dropphyst": "MN",
    "dropphyzpp": 562145000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELVIEW",
    "dropmalst": "MN",
    "dropmalzpp": 562149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079384148,
    "dropfax": 5079384148
  },
  {
    "dcode": "D",
    "dropkey": "PY24816",
    "droptype": "D",
    "dropname": "BEMIDJI",
    "dropdeladd": "401 IRVINE AVE NW",
    "dropdelcty": "BEMIDJI",
    "dropdelst": "MN",
    "dropdelzpp": 566019998,
    "dropphyadd": "401 IRVINE AVE NW",
    "dropphycty": "BEMIDJI",
    "dropphyst": "MN",
    "dropphyzpp": 566019998,
    "dropmaladd": "401 IRVINE AVE NW",
    "dropmalcty": "BEMIDJI",
    "dropmalst": "MN",
    "dropmalzpp": 566019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187511059,
    "dropfax": 2187591917
  },
  {
    "dcode": "D",
    "dropkey": "PY24817",
    "droptype": "D",
    "dropname": "BENA",
    "dropdeladd": "38 COUNTY ROAD 8",
    "dropdelcty": "BENA",
    "dropdelst": "MN",
    "dropdelzpp": 566261042,
    "dropphyadd": "38 COUNTY ROAD 8",
    "dropphycty": "BENA",
    "dropphyst": "MN",
    "dropphyzpp": 566261042,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENA",
    "dropmalst": "MN",
    "dropmalzpp": 566269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186652214,
    "dropfax": 2186652214
  },
  {
    "dcode": "D",
    "dropkey": "PY24820",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "220 14TH ST N",
    "dropdelcty": "BENSON",
    "dropdelst": "MN",
    "dropdelzpp": 562151105,
    "dropphyadd": "220 14TH ST N",
    "dropphycty": "BENSON",
    "dropphyst": "MN",
    "dropphyzpp": 562151105,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENSON",
    "dropmalst": "MN",
    "dropmalzpp": 562159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208424741,
    "dropfax": 3208432072
  },
  {
    "dcode": "D",
    "dropkey": "PY24826",
    "droptype": "D",
    "dropname": "BERTHA",
    "dropdeladd": "304 MAIN ST W",
    "dropdelcty": "BERTHA",
    "dropdelst": "MN",
    "dropdelzpp": 564374500,
    "dropphyadd": "304 MAIN ST W",
    "dropphycty": "BERTHA",
    "dropphyst": "MN",
    "dropphyzpp": 564374500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BERTHA",
    "dropmalst": "MN",
    "dropmalzpp": 564379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189242130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24829",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "103 MAIN ST NW",
    "dropdelcty": "BETHEL",
    "dropdelst": "MN",
    "dropdelzpp": 550059509,
    "dropphyadd": "103 MAIN ST NW",
    "dropphycty": "BETHEL",
    "dropphyst": "MN",
    "dropphyzpp": 550059509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHEL",
    "dropmalst": "MN",
    "dropmalzpp": 550059998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7634343000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24832",
    "droptype": "D",
    "dropname": "BIG FALLS",
    "dropdeladd": "305 2ND ST NW",
    "dropdelcty": "BIG FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 566279725,
    "dropphyadd": "305 2ND ST NW",
    "dropphycty": "BIG FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 566279725,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 566279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182762301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24834",
    "droptype": "D",
    "dropname": "BIG LAKE",
    "dropdeladd": "625 ROSE DR",
    "dropdelcty": "BIG LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553099539,
    "dropphyadd": "625 ROSE DR",
    "dropphycty": "BIG LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553099539,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632632642,
    "dropfax": 7632638884
  },
  {
    "dcode": "D",
    "dropkey": "PY24835",
    "droptype": "D",
    "dropname": "BIGELOW",
    "dropdeladd": "1416 BROADWAY ST",
    "dropdelcty": "BIGELOW",
    "dropdelst": "MN",
    "dropdelzpp": 561171167,
    "dropphyadd": "1416 BROADWAY ST",
    "dropphycty": "BIGELOW",
    "dropphyst": "MN",
    "dropphyzpp": 561171167,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIGELOW",
    "dropmalst": "MN",
    "dropmalzpp": 561179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076832868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24836",
    "droptype": "D",
    "dropname": "BIGFORK",
    "dropdeladd": "305 MAIN ST",
    "dropdelcty": "BIGFORK",
    "dropdelst": "MN",
    "dropdelzpp": 566282001,
    "dropphyadd": "305 MAIN ST",
    "dropphycty": "BIGFORK",
    "dropphyst": "MN",
    "dropphyzpp": 566282001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIGFORK",
    "dropmalst": "MN",
    "dropmalzpp": 566289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187433561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24842",
    "droptype": "D",
    "dropname": "BIRCHDALE",
    "dropdeladd": "10424 HIGHWAY 11",
    "dropdelcty": "BIRCHDALE",
    "dropdelst": "MN",
    "dropdelzpp": 566292000,
    "dropphyadd": "10424 HIGHWAY 11",
    "dropphycty": "BIRCHDALE",
    "dropphyst": "MN",
    "dropphyzpp": 566292000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRCHDALE",
    "dropmalst": "MN",
    "dropmalzpp": 566299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186705240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24845",
    "droptype": "D",
    "dropname": "BIRD ISLAND",
    "dropdeladd": "240 MAIN ST",
    "dropdelcty": "BIRD ISLAND",
    "dropdelst": "MN",
    "dropdelzpp": 553101226,
    "dropphyadd": "240 MAIN ST",
    "dropphycty": "BIRD ISLAND",
    "dropphyst": "MN",
    "dropphyzpp": 553101226,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIRD ISLAND",
    "dropmalst": "MN",
    "dropmalzpp": 553109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203653800,
    "dropfax": 3203654631
  },
  {
    "dcode": "D",
    "dropkey": "PY24846",
    "droptype": "D",
    "dropname": "BIWABIK",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "BIWABIK",
    "dropdelst": "MN",
    "dropdelzpp": 557085000,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "BIWABIK",
    "dropphyst": "MN",
    "dropphyzpp": 557085000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIWABIK",
    "dropmalst": "MN",
    "dropmalzpp": 557089998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188656115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24851",
    "droptype": "D",
    "dropname": "BLACKDUCK",
    "dropdeladd": "57 1ST ST SE",
    "dropdelcty": "BLACKDUCK",
    "dropdelst": "MN",
    "dropdelzpp": 566302165,
    "dropphyadd": "57 1ST ST SE",
    "dropphycty": "BLACKDUCK",
    "dropphyst": "MN",
    "dropphyzpp": 566302165,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACKDUCK",
    "dropmalst": "MN",
    "dropmalzpp": 566309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186705500,
    "dropfax": 2184295822
  },
  {
    "dcode": "D",
    "dropkey": "PY24859",
    "droptype": "D",
    "dropname": "BLOMKEST",
    "dropdeladd": "2 NW MAIN ST",
    "dropdelcty": "BLOMKEST",
    "dropdelst": "MN",
    "dropdelzpp": 562161101,
    "dropphyadd": "2 NW MAIN ST",
    "dropphycty": "BLOMKEST",
    "dropphyst": "MN",
    "dropphyzpp": 562161101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOMKEST",
    "dropmalst": "MN",
    "dropmalzpp": 562169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3209956311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24860",
    "droptype": "D",
    "dropname": "BLOOMING PRAIRIE",
    "dropdeladd": "450 2ND ST SE",
    "dropdelcty": "BLOOMING PRAIRIE",
    "dropdelst": "MN",
    "dropdelzpp": 559171400,
    "dropphyadd": "450 2ND ST SE",
    "dropphycty": "BLOOMING PRAIRIE",
    "dropphyst": "MN",
    "dropphyzpp": 559171400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLOOMING PRAIRIE",
    "dropmalst": "MN",
    "dropmalzpp": 559179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075837527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24864",
    "droptype": "D",
    "dropname": "BLUE EARTH",
    "dropdeladd": "130 N MAIN ST",
    "dropdelcty": "BLUE EARTH",
    "dropdelst": "MN",
    "dropdelzpp": 560131937,
    "dropphyadd": "130 N MAIN ST",
    "dropphycty": "BLUE EARTH",
    "dropphyst": "MN",
    "dropphyzpp": 560131937,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE EARTH",
    "dropmalst": "MN",
    "dropmalzpp": 560139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075263813,
    "dropfax": 5075262855
  },
  {
    "dcode": "D",
    "dropkey": "PY24867",
    "droptype": "D",
    "dropname": "BLUFFTON",
    "dropdeladd": "104 2ND ST",
    "dropdelcty": "BLUFFTON",
    "dropdelst": "MN",
    "dropdelzpp": 565189998,
    "dropphyadd": "104 2ND ST",
    "dropphycty": "BLUFFTON",
    "dropphyst": "MN",
    "dropphyzpp": 565189998,
    "dropmaladd": "104 2ND ST",
    "dropmalcty": "BLUFFTON",
    "dropmalst": "MN",
    "dropmalzpp": 565189998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183853365,
    "dropsitcph": 2183853365,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24868",
    "droptype": "D",
    "dropname": "BOCK",
    "dropdeladd": "1661 WALL AVE",
    "dropdelcty": "BOCK",
    "dropdelst": "MN",
    "dropdelzpp": 563134500,
    "dropphyadd": "1661 WALL AVE",
    "dropphycty": "BOCK",
    "dropphyst": "MN",
    "dropphyzpp": 563134500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOCK",
    "dropmalst": "MN",
    "dropmalzpp": 563139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205563412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24872",
    "droptype": "D",
    "dropname": "BORUP",
    "dropdeladd": "206 MAIN AVE",
    "dropdelcty": "BORUP",
    "dropdelst": "MN",
    "dropdelzpp": 565199998,
    "dropphyadd": "206 MAIN AVE",
    "dropphycty": "BORUP",
    "dropphyst": "MN",
    "dropphyzpp": 565199998,
    "dropmaladd": "206 MAIN AVE",
    "dropmalcty": "BORUP",
    "dropmalst": "MN",
    "dropmalzpp": 565199998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185823230,
    "dropsitcph": 2185823230,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24873",
    "droptype": "D",
    "dropname": "BOVEY",
    "dropdeladd": "500 2ND ST",
    "dropdelcty": "BOVEY",
    "dropdelst": "MN",
    "dropdelzpp": 557095000,
    "dropphyadd": "500 2ND ST",
    "dropphycty": "BOVEY",
    "dropphyst": "MN",
    "dropphyzpp": 557095000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOVEY",
    "dropmalst": "MN",
    "dropmalzpp": 557099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182452133,
    "dropfax": 2182451673
  },
  {
    "dcode": "D",
    "dropkey": "PY24874",
    "droptype": "D",
    "dropname": "BOWLUS",
    "dropdeladd": "172 MAIN ST",
    "dropdelcty": "BOWLUS",
    "dropdelst": "MN",
    "dropdelzpp": 563144504,
    "dropphyadd": "172 MAIN ST",
    "dropphycty": "BOWLUS",
    "dropphyst": "MN",
    "dropphyzpp": 563144504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWLUS",
    "dropmalst": "MN",
    "dropmalzpp": 563149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205849200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24879",
    "droptype": "D",
    "dropname": "BOYD",
    "dropdeladd": "112 3RD ST",
    "dropdelcty": "BOYD",
    "dropdelst": "MN",
    "dropdelzpp": 562185000,
    "dropphyadd": "112 3RD ST",
    "dropphycty": "BOYD",
    "dropphyst": "MN",
    "dropphyzpp": 562185000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOYD",
    "dropmalst": "MN",
    "dropmalzpp": 562189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208552342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24880",
    "droptype": "D",
    "dropname": "BRAHAM",
    "dropdeladd": "120 2ND ST SW",
    "dropdelcty": "BRAHAM",
    "dropdelst": "MN",
    "dropdelzpp": 550063074,
    "dropphyadd": "120 2ND ST SW",
    "dropphycty": "BRAHAM",
    "dropphyst": "MN",
    "dropphyzpp": 550063074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRAHAM",
    "dropmalst": "MN",
    "dropmalzpp": 550069998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3203962561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24882",
    "droptype": "D",
    "dropname": "BRAINERD",
    "dropdeladd": "422 LAUREL ST",
    "dropdelcty": "BRAINERD",
    "dropdelst": "MN",
    "dropdelzpp": 564013556,
    "dropphyadd": "422 LAUREL ST",
    "dropphycty": "BRAINERD",
    "dropphyst": "MN",
    "dropphyzpp": 564013556,
    "dropmaladd": "422 LAUREL ST",
    "dropmalcty": "BRAINERD",
    "dropmalst": "MN",
    "dropmalzpp": 564013556,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188293101,
    "dropfax": 2188298690
  },
  {
    "dcode": "D",
    "dropkey": "PY24884",
    "droptype": "D",
    "dropname": "BRANDON",
    "dropdeladd": "101 FRONT ST E",
    "dropdelcty": "BRANDON",
    "dropdelst": "MN",
    "dropdelzpp": 563152029,
    "dropphyadd": "101 FRONT ST E",
    "dropphycty": "BRANDON",
    "dropphyst": "MN",
    "dropphyzpp": 563152029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANDON",
    "dropmalst": "MN",
    "dropmalzpp": 563159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208344789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24886",
    "droptype": "D",
    "dropname": "BRECKENRIDGE",
    "dropdeladd": "224 5TH ST N",
    "dropdelcty": "BRECKENRIDGE",
    "dropdelst": "MN",
    "dropdelzpp": 565209998,
    "dropphyadd": "224 5TH ST N",
    "dropphycty": "BRECKENRIDGE",
    "dropphyst": "MN",
    "dropphyzpp": 565209998,
    "dropmaladd": "224 5TH ST N",
    "dropmalcty": "BRECKENRIDGE",
    "dropmalst": "MN",
    "dropmalzpp": 565209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186436125,
    "dropsitcph": 2186436125,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24892",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "1005 2ND AVE",
    "dropdelcty": "BREWSTER",
    "dropdelst": "MN",
    "dropdelzpp": 561191004,
    "dropphyadd": "1005 2ND AVE",
    "dropphycty": "BREWSTER",
    "dropphyst": "MN",
    "dropphyzpp": 561191004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BREWSTER",
    "dropmalst": "MN",
    "dropmalzpp": 561199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078425906,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24893",
    "droptype": "D",
    "dropname": "BRICELYN",
    "dropdeladd": "215 N MAIN ST",
    "dropdelcty": "BRICELYN",
    "dropdelst": "MN",
    "dropdelzpp": 560142292,
    "dropphyadd": "215 N MAIN ST",
    "dropphycty": "BRICELYN",
    "dropphyst": "MN",
    "dropphyzpp": 560142292,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRICELYN",
    "dropmalst": "MN",
    "dropmalzpp": 560149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076534691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24894",
    "droptype": "D",
    "dropname": "BRIMSON",
    "dropdeladd": "3127 HIGHWAY 44 STE 1",
    "dropdelcty": "BRIMSON",
    "dropdelst": "MN",
    "dropdelzpp": 556021200,
    "dropphyadd": "3127 HIGHWAY 44 STE 1",
    "dropphycty": "BRIMSON",
    "dropphyst": "MN",
    "dropphyzpp": 556021200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIMSON",
    "dropmalst": "MN",
    "dropmalzpp": 556029998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188482811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24901",
    "droptype": "D",
    "dropname": "BROOK PARK",
    "dropdeladd": "509 3RD ST N",
    "dropdelcty": "BROOK PARK",
    "dropdelst": "MN",
    "dropdelzpp": 550079531,
    "dropphyadd": "509 3RD ST N",
    "dropphycty": "BROOK PARK",
    "dropphyst": "MN",
    "dropphyzpp": 550079531,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOK PARK",
    "dropmalst": "MN",
    "dropmalzpp": 550079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3206791541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24910",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "BROOKS",
    "dropdelst": "MN",
    "dropdelzpp": 567159998,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "BROOKS",
    "dropphyst": "MN",
    "dropphyzpp": 567159998,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "BROOKS",
    "dropmalst": "MN",
    "dropmalzpp": 567159998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186984287,
    "dropsitcph": 2186984287,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24912",
    "droptype": "D",
    "dropname": "BROOKSTON",
    "dropdeladd": "4869 HIGHWAY 31",
    "dropdelcty": "BROOKSTON",
    "dropdelst": "MN",
    "dropdelzpp": 557115000,
    "dropphyadd": "4869 HIGHWAY 31",
    "dropphycty": "BROOKSTON",
    "dropphyst": "MN",
    "dropphyzpp": 557115000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKSTON",
    "dropmalst": "MN",
    "dropmalzpp": 557119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184535616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24913",
    "droptype": "D",
    "dropname": "BROOTEN",
    "dropdeladd": "149 CENTRAL AVE N",
    "dropdelcty": "BROOTEN",
    "dropdelst": "MN",
    "dropdelzpp": 563164665,
    "dropphyadd": "149 CENTRAL AVE N",
    "dropphycty": "BROOTEN",
    "dropphyst": "MN",
    "dropphyzpp": 563164665,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOTEN",
    "dropmalst": "MN",
    "dropmalzpp": 563169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203462552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24914",
    "droptype": "D",
    "dropname": "BROWERVILLE",
    "dropdeladd": "517 MAIN ST S",
    "dropdelcty": "BROWERVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 564381200,
    "dropphyadd": "517 MAIN ST S",
    "dropphycty": "BROWERVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 564381200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWERVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 564389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205942260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24917",
    "droptype": "D",
    "dropname": "BROWNS VALLEY",
    "dropdeladd": "314 W BROADWAY",
    "dropdelcty": "BROWNS VALLEY",
    "dropdelst": "MN",
    "dropdelzpp": 562195000,
    "dropphyadd": "314 W BROADWAY",
    "dropphycty": "BROWNS VALLEY",
    "dropphyst": "MN",
    "dropphyzpp": 562195000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNS VALLEY",
    "dropmalst": "MN",
    "dropmalzpp": 562199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206952620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24919",
    "droptype": "D",
    "dropname": "BROWNSDALE",
    "dropdeladd": "118 MILL ST S",
    "dropdelcty": "BROWNSDALE",
    "dropdelst": "MN",
    "dropdelzpp": 559189019,
    "dropphyadd": "118 MILL ST S",
    "dropphycty": "BROWNSDALE",
    "dropphyst": "MN",
    "dropphyzpp": 559189019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNSDALE",
    "dropmalst": "MN",
    "dropmalzpp": 559189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075672580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24921",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 559198816,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 559198816,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 559199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074826652,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24924",
    "droptype": "D",
    "dropname": "BROWNTON",
    "dropdeladd": "113 4TH AVE S",
    "dropdelcty": "BROWNTON",
    "dropdelst": "MN",
    "dropdelzpp": 553126432,
    "dropphyadd": "113 4TH AVE S",
    "dropphycty": "BROWNTON",
    "dropphyst": "MN",
    "dropphyzpp": 553126432,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNTON",
    "dropmalst": "MN",
    "dropmalzpp": 553129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203284051,
    "dropfax": 3203284007
  },
  {
    "dcode": "D",
    "dropkey": "PY24925",
    "droptype": "D",
    "dropname": "BRUNO",
    "dropdeladd": "4613 E MAIN ST",
    "dropdelcty": "BRUNO",
    "dropdelst": "MN",
    "dropdelzpp": 557125050,
    "dropphyadd": "4613 E MAIN ST",
    "dropphycty": "BRUNO",
    "dropphyst": "MN",
    "dropphyzpp": 557125050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRUNO",
    "dropmalst": "MN",
    "dropmalzpp": 557129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208383201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24929",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "209 CENTRAL AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "MN",
    "dropdelzpp": 553139934,
    "dropphyadd": "209 CENTRAL AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "MN",
    "dropphyzpp": 553139934,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUFFALO",
    "dropmalst": "MN",
    "dropmalzpp": 553139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7636822500,
    "dropsitcph": 7636822500,
    "dropfax": 7636820105
  },
  {
    "dcode": "D",
    "dropkey": "PY24930",
    "droptype": "D",
    "dropname": "BUFFALO LAKE",
    "dropdeladd": "146 N MAIN ST",
    "dropdelcty": "BUFFALO LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553141090,
    "dropphyadd": "146 N MAIN ST",
    "dropphycty": "BUFFALO LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553141090,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUFFALO LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208335514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24932",
    "droptype": "D",
    "dropname": "BUHL",
    "dropdeladd": "221 STATE ST",
    "dropdelcty": "BUHL",
    "dropdelst": "MN",
    "dropdelzpp": 557135000,
    "dropphyadd": "221 STATE ST",
    "dropphycty": "BUHL",
    "dropphyst": "MN",
    "dropphyzpp": 557135000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUHL",
    "dropmalst": "MN",
    "dropmalzpp": 557139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182583402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24939",
    "droptype": "D",
    "dropname": "BURTRUM",
    "dropdeladd": "111 MAIN ST W",
    "dropdelcty": "BURTRUM",
    "dropdelst": "MN",
    "dropdelzpp": 563181074,
    "dropphyadd": "111 MAIN ST W",
    "dropphycty": "BURTRUM",
    "dropphyst": "MN",
    "dropphyzpp": 563181074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURTRUM",
    "dropmalst": "MN",
    "dropmalzpp": 563189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202857743,
    "dropfax": 3202857743
  },
  {
    "dcode": "D",
    "dropkey": "PY24943",
    "droptype": "D",
    "dropname": "BUTTERFIELD",
    "dropdeladd": "105 2ND ST N",
    "dropdelcty": "BUTTERFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 561205022,
    "dropphyadd": "105 2ND ST N",
    "dropphycty": "BUTTERFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 561205022,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUTTERFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 561209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079563751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24949",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "218 BYRON AVE N",
    "dropdelcty": "BYRON",
    "dropdelst": "MN",
    "dropdelzpp": 559201259,
    "dropphyadd": "218 BYRON AVE N",
    "dropphycty": "BYRON",
    "dropphyst": "MN",
    "dropphyzpp": 559201259,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYRON",
    "dropmalst": "MN",
    "dropmalzpp": 559209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077752450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24950",
    "droptype": "D",
    "dropname": "CALEDONIA",
    "dropdeladd": "125 E GROVE ST",
    "dropdelcty": "CALEDONIA",
    "dropdelst": "MN",
    "dropdelzpp": 559211305,
    "dropphyadd": "125 E GROVE ST",
    "dropphycty": "CALEDONIA",
    "dropphyst": "MN",
    "dropphyzpp": 559211305,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALEDONIA",
    "dropmalst": "MN",
    "dropmalzpp": 559219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077243421,
    "dropfax": 5077243470
  },
  {
    "dcode": "D",
    "dropkey": "PY24952",
    "droptype": "D",
    "dropname": "CALLAWAY",
    "dropdeladd": "312 MAIN AVE",
    "dropdelcty": "CALLAWAY",
    "dropdelst": "MN",
    "dropdelzpp": 565219998,
    "dropphyadd": "312 MAIN AVE",
    "dropphycty": "CALLAWAY",
    "dropphyst": "MN",
    "dropphyzpp": 565219998,
    "dropmaladd": "312 MAIN AVE",
    "dropmalcty": "CALLAWAY",
    "dropmalst": "MN",
    "dropmalzpp": 565219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183753271,
    "dropsitcph": 2182615031,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24953",
    "droptype": "D",
    "dropname": "CALUMET",
    "dropdeladd": "930 GARY ST",
    "dropdelcty": "CALUMET",
    "dropdelst": "MN",
    "dropdelzpp": 557165000,
    "dropphyadd": "930 GARY ST",
    "dropphycty": "CALUMET",
    "dropphyst": "MN",
    "dropphyzpp": 557165000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALUMET",
    "dropmalst": "MN",
    "dropmalzpp": 557169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182477486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24954",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "209 MAIN ST S",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MN",
    "dropdelzpp": 550081526,
    "dropphyadd": "209 MAIN ST S",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MN",
    "dropphyzpp": 550081526,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MN",
    "dropmalzpp": 550089998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7636892820,
    "dropfax": 7636894983
  },
  {
    "dcode": "D",
    "dropkey": "PY24955",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "510 5TH ST",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "MN",
    "dropdelzpp": 565229998,
    "dropphyadd": "510 5TH ST",
    "dropphycty": "CAMPBELL",
    "dropphyst": "MN",
    "dropphyzpp": 565229998,
    "dropmaladd": "510 5TH ST",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "MN",
    "dropmalzpp": 565229998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186305583,
    "dropsitcph": 2186305583,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY24956",
    "droptype": "D",
    "dropname": "CANBY",
    "dropdeladd": "220 SAINT OLAF AVE N",
    "dropdelcty": "CANBY",
    "dropdelst": "MN",
    "dropdelzpp": 562201374,
    "dropphyadd": "220 SAINT OLAF AVE N",
    "dropphycty": "CANBY",
    "dropphyst": "MN",
    "dropphyzpp": 562201374,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANBY",
    "dropmalst": "MN",
    "dropmalzpp": 562209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072237347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24958",
    "droptype": "D",
    "dropname": "CANNON FALLS",
    "dropdeladd": "419 MAIN ST W",
    "dropdelcty": "CANNON FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 550092044,
    "dropphyadd": "419 MAIN ST W",
    "dropphycty": "CANNON FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 550092044,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANNON FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 550099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072634268,
    "dropfax": 5072636914
  },
  {
    "dcode": "D",
    "dropkey": "PY24960",
    "droptype": "D",
    "dropname": "CANTON",
    "dropdeladd": "308 N MAIN ST",
    "dropdelcty": "CANTON",
    "dropdelst": "MN",
    "dropdelzpp": 559221021,
    "dropphyadd": "308 N MAIN ST",
    "dropphycty": "CANTON",
    "dropphyst": "MN",
    "dropphyzpp": 559221021,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANTON",
    "dropmalst": "MN",
    "dropmalzpp": 559229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077432256,
    "dropfax": 5077438226
  },
  {
    "dcode": "D",
    "dropkey": "PY24965",
    "droptype": "D",
    "dropname": "CARLOS",
    "dropdeladd": "104 MAIN AVE",
    "dropdelcty": "CARLOS",
    "dropdelst": "MN",
    "dropdelzpp": 563194527,
    "dropphyadd": "104 MAIN AVE",
    "dropphycty": "CARLOS",
    "dropphyst": "MN",
    "dropphyzpp": 563194527,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLOS",
    "dropmalst": "MN",
    "dropmalzpp": 563199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208527571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24967",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "313 CHESTNUT AVE",
    "dropdelcty": "CARLTON",
    "dropdelst": "MN",
    "dropdelzpp": 557185000,
    "dropphyadd": "313 CHESTNUT AVE",
    "dropphycty": "CARLTON",
    "dropphyst": "MN",
    "dropphyzpp": 557185000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLTON",
    "dropmalst": "MN",
    "dropmalzpp": 557189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183844519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24970",
    "droptype": "D",
    "dropname": "CARVER",
    "dropdeladd": "317 BROADWAY",
    "dropdelcty": "CARVER",
    "dropdelst": "MN",
    "dropdelzpp": 553152103,
    "dropphyadd": "317 BROADWAY",
    "dropphycty": "CARVER",
    "dropphyst": "MN",
    "dropphyzpp": 553152103,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARVER",
    "dropmalst": "MN",
    "dropmalzpp": 553159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524486363,
    "dropfax": 9523613172
  },
  {
    "dcode": "D",
    "dropkey": "PY24971",
    "droptype": "D",
    "dropname": "CASS LAKE",
    "dropdeladd": "322 2ND ST NW",
    "dropdelcty": "CASS LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 566333377,
    "dropphyadd": "322 2ND ST NW",
    "dropphycty": "CASS LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 566333377,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASS LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 566339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183356361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24974",
    "droptype": "D",
    "dropname": "CASTLE ROCK",
    "dropdeladd": "4379 280TH ST",
    "dropdelcty": "CASTLE ROCK",
    "dropdelst": "MN",
    "dropdelzpp": 550107000,
    "dropphyadd": "4379 280TH ST",
    "dropphycty": "CASTLE ROCK",
    "dropphyst": "MN",
    "dropphyzpp": 550107000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTLE ROCK",
    "dropmalst": "MN",
    "dropmalzpp": 550109998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7636637804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24975",
    "droptype": "D",
    "dropname": "CEDAR",
    "dropdeladd": "21427 ABERDEEN ST NE",
    "dropdelcty": "CEDAR",
    "dropdelst": "MN",
    "dropdelzpp": 550119660,
    "dropphyadd": "21427 ABERDEEN ST NE",
    "dropphycty": "CEDAR",
    "dropphyst": "MN",
    "dropphyzpp": 550119660,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR",
    "dropmalst": "MN",
    "dropmalzpp": 550119998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7634347200,
    "dropsitcph": 7634347200,
    "dropfax": 7634340164
  },
  {
    "dcode": "D",
    "dropkey": "PY24982",
    "droptype": "D",
    "dropname": "CENTER CITY",
    "dropdeladd": "280 ANDREWS AVE",
    "dropdelcty": "CENTER CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550129677,
    "dropphyadd": "280 ANDREWS AVE",
    "dropphycty": "CENTER CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550129677,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTER CITY",
    "dropmalst": "MN",
    "dropmalzpp": 550129998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6512571154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24987",
    "droptype": "D",
    "dropname": "CEYLON",
    "dropdeladd": "111 W MAIN ST",
    "dropdelcty": "CEYLON",
    "dropdelst": "MN",
    "dropdelzpp": 561215001,
    "dropphyadd": "111 W MAIN ST",
    "dropphycty": "CEYLON",
    "dropphyst": "MN",
    "dropphyzpp": 561215001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEYLON",
    "dropmalst": "MN",
    "dropmalzpp": 561219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076324573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24988",
    "droptype": "D",
    "dropname": "CHAMPLIN",
    "dropdeladd": "12299 CHAMPLIN DR",
    "dropdelcty": "CHAMPLIN",
    "dropdelst": "MN",
    "dropdelzpp": 553162093,
    "dropphyadd": "12299 CHAMPLIN DR",
    "dropphycty": "CHAMPLIN",
    "dropphyst": "MN",
    "dropphyzpp": 553162093,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMPLIN",
    "dropmalst": "MN",
    "dropmalzpp": 553169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7634272428,
    "dropsitcph": 7634272370,
    "dropfax": 6124467977
  },
  {
    "dcode": "D",
    "dropkey": "PY24989",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "211 4TH ST",
    "dropdelcty": "CHANDLER",
    "dropdelst": "MN",
    "dropdelzpp": 561221190,
    "dropphyadd": "211 4TH ST",
    "dropphycty": "CHANDLER",
    "dropphyst": "MN",
    "dropphyzpp": 561221190,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANDLER",
    "dropmalst": "MN",
    "dropmalzpp": 561229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076772530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY24990",
    "droptype": "D",
    "dropname": "CHANHASSEN",
    "dropdeladd": "7730 LAREDO DR",
    "dropdelcty": "CHANHASSEN",
    "dropdelst": "MN",
    "dropdelzpp": 553179678,
    "dropphyadd": "7730 LAREDO DR",
    "dropphycty": "CHANHASSEN",
    "dropphyst": "MN",
    "dropphyzpp": 553179678,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANHASSEN",
    "dropmalst": "MN",
    "dropmalzpp": 553179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529745297,
    "dropsitcph": 9529745297,
    "dropfax": 9529340237
  },
  {
    "dcode": "D",
    "dropkey": "PY24994",
    "droptype": "D",
    "dropname": "CHASKA",
    "dropdeladd": "300 N PINE ST",
    "dropdelcty": "CHASKA",
    "dropdelst": "MN",
    "dropdelzpp": 553181941,
    "dropphyadd": "300 N PINE ST",
    "dropphycty": "CHASKA",
    "dropphyst": "MN",
    "dropphyzpp": 553181941,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHASKA",
    "dropmalst": "MN",
    "dropmalzpp": 553189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635594392,
    "dropsitcph": 9524484632,
    "dropfax": 9524486624
  },
  {
    "dcode": "D",
    "dropkey": "PY24995",
    "droptype": "D",
    "dropname": "CHATFIELD",
    "dropdeladd": "245 MAIN ST N",
    "dropdelcty": "CHATFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 559231170,
    "dropphyadd": "245 MAIN ST N",
    "dropphycty": "CHATFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 559231170,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHATFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 559239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078673400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25001",
    "droptype": "D",
    "dropname": "CHISAGO CITY",
    "dropdeladd": "29385 OLD TOWNE RD",
    "dropdelcty": "CHISAGO CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550139407,
    "dropphyadd": "29385 OLD TOWNE RD",
    "dropphycty": "CHISAGO CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550139407,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHISAGO CITY",
    "dropmalst": "MN",
    "dropmalzpp": 550139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516812545,
    "dropsitcph": 6512572345,
    "dropfax": 6512570871
  },
  {
    "dcode": "D",
    "dropkey": "PY25005",
    "droptype": "D",
    "dropname": "CHISHOLM",
    "dropdeladd": "14 3RD AVE NW",
    "dropdelcty": "CHISHOLM",
    "dropdelst": "MN",
    "dropdelzpp": 557191639,
    "dropphyadd": "14 3RD AVE NW",
    "dropphycty": "CHISHOLM",
    "dropphyst": "MN",
    "dropphyzpp": 557191639,
    "dropmaladd": "14 3RD AVE NW",
    "dropmalcty": "CHISHOLM",
    "dropmalst": "MN",
    "dropmalzpp": 557199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182543510,
    "dropfax": 2182545607
  },
  {
    "dcode": "D",
    "dropkey": "PY25006",
    "droptype": "D",
    "dropname": "CHOKIO",
    "dropdeladd": "122 MAIN ST",
    "dropdelcty": "CHOKIO",
    "dropdelst": "MN",
    "dropdelzpp": 562215000,
    "dropphyadd": "122 MAIN ST",
    "dropphycty": "CHOKIO",
    "dropphyst": "MN",
    "dropphyzpp": 562215000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHOKIO",
    "dropmalst": "MN",
    "dropmalzpp": 562219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203247394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25007",
    "droptype": "D",
    "dropname": "CIRCLE PINES",
    "dropdeladd": "300 CIVIC HEIGHTS DR",
    "dropdelcty": "CIRCLE PINES",
    "dropdelst": "MN",
    "dropdelzpp": 550141793,
    "dropphyadd": "300 CIVIC HEIGHTS DR",
    "dropphycty": "CIRCLE PINES",
    "dropphyst": "MN",
    "dropphyzpp": 550141793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CIRCLE PINES",
    "dropmalst": "MN",
    "dropmalzpp": 550149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7637848644,
    "dropsitcph": 7637170595,
    "dropfax": 7637924639
  },
  {
    "dcode": "D",
    "dropkey": "PY25011",
    "droptype": "D",
    "dropname": "CLARA CITY",
    "dropdeladd": "218 CENTER AVE NW",
    "dropdelcty": "CLARA CITY",
    "dropdelst": "MN",
    "dropdelzpp": 562225000,
    "dropphyadd": "218 CENTER AVE NW",
    "dropphycty": "CLARA CITY",
    "dropphyst": "MN",
    "dropphyzpp": 562225000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARA CITY",
    "dropmalst": "MN",
    "dropmalzpp": 562229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208472509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25012",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "234 W FRONT ST",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "MN",
    "dropdelzpp": 559245000,
    "dropphyadd": "234 W FRONT ST",
    "dropphycty": "CLAREMONT",
    "dropphyst": "MN",
    "dropphyzpp": 559245000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "MN",
    "dropmalzpp": 559249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075282232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25013",
    "droptype": "D",
    "dropname": "CLARISSA",
    "dropdeladd": "204 MAIN ST W",
    "dropdelcty": "CLARISSA",
    "dropdelst": "MN",
    "dropdelzpp": 564404506,
    "dropphyadd": "204 MAIN ST W",
    "dropphycty": "CLARISSA",
    "dropphyst": "MN",
    "dropphyzpp": 564404506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARISSA",
    "dropmalst": "MN",
    "dropmalzpp": 564409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187563550,
    "dropfax": 2187562494
  },
  {
    "dcode": "D",
    "dropkey": "PY25015",
    "droptype": "D",
    "dropname": "CLARKFIELD",
    "dropdeladd": "1043 10TH AVE",
    "dropdelcty": "CLARKFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 562231301,
    "dropphyadd": "1043 10TH AVE",
    "dropphycty": "CLARKFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 562231301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 562239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206694807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25016",
    "droptype": "D",
    "dropname": "CLARKS GROVE",
    "dropdeladd": "104 MAIN ST W",
    "dropdelcty": "CLARKS GROVE",
    "dropdelst": "MN",
    "dropdelzpp": 560164131,
    "dropphyadd": "104 MAIN ST W",
    "dropphycty": "CLARKS GROVE",
    "dropphyst": "MN",
    "dropphyzpp": 560164131,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKS GROVE",
    "dropmalst": "MN",
    "dropmalzpp": 560169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072567223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25018",
    "droptype": "D",
    "dropname": "CLEAR LAKE",
    "dropdeladd": "8698 MAIN AVE",
    "dropdelcty": "CLEAR LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553194559,
    "dropphyadd": "8698 MAIN AVE",
    "dropphycty": "CLEAR LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553194559,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEAR LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3207432505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25020",
    "droptype": "D",
    "dropname": "CLEARBROOK",
    "dropdeladd": "117 MAIN ST S",
    "dropdelcty": "CLEARBROOK",
    "dropdelst": "MN",
    "dropdelzpp": 566342000,
    "dropphyadd": "117 MAIN ST S",
    "dropphycty": "CLEARBROOK",
    "dropphyst": "MN",
    "dropphyzpp": 566342000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARBROOK",
    "dropmalst": "MN",
    "dropmalzpp": 566349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187763700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25022",
    "droptype": "D",
    "dropname": "CLEARWATER",
    "dropdeladd": "625 SMITH ST",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "MN",
    "dropdelzpp": 553205001,
    "dropphyadd": "625 SMITH ST",
    "dropphycty": "CLEARWATER",
    "dropphyst": "MN",
    "dropphyzpp": 553205001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "MN",
    "dropmalzpp": 553209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205582405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25025",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "309 BROADWAY ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "MN",
    "dropdelzpp": 560172002,
    "dropphyadd": "309 BROADWAY ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "MN",
    "dropphyzpp": 560172002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "MN",
    "dropmalzpp": 560179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079314360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25027",
    "droptype": "D",
    "dropname": "CLIMAX",
    "dropdeladd": "202 W BROADWAY",
    "dropdelcty": "CLIMAX",
    "dropdelst": "MN",
    "dropdelzpp": 565239998,
    "dropphyadd": "202 W BROADWAY",
    "dropphycty": "CLIMAX",
    "dropphyst": "MN",
    "dropphyzpp": 565239998,
    "dropmaladd": "202 W BROADWAY",
    "dropmalcty": "CLIMAX",
    "dropmalst": "MN",
    "dropmalzpp": 565239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188573393,
    "dropsitcph": 2188573393,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25028",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "CLINTON",
    "dropdelst": "MN",
    "dropdelzpp": 562256000,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "CLINTON",
    "dropphyst": "MN",
    "dropphyzpp": 562256000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLINTON",
    "dropmalst": "MN",
    "dropmalzpp": 562259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203255266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25029",
    "droptype": "D",
    "dropname": "CLITHERALL",
    "dropdeladd": "104 S OAK ST",
    "dropdelcty": "CLITHERALL",
    "dropdelst": "MN",
    "dropdelzpp": 565249998,
    "dropphyadd": "104 S OAK ST",
    "dropphycty": "CLITHERALL",
    "dropphyst": "MN",
    "dropphyzpp": 565249998,
    "dropmaladd": "104 S OAK ST",
    "dropmalcty": "CLITHERALL",
    "dropmalst": "MN",
    "dropmalzpp": 565249998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188648720,
    "dropsitcph": 2188648720,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25030",
    "droptype": "D",
    "dropname": "CLONTARF",
    "dropdeladd": "121 GRACE AVE",
    "dropdelcty": "CLONTARF",
    "dropdelst": "MN",
    "dropdelzpp": 562265000,
    "dropphyadd": "121 GRACE AVE",
    "dropphycty": "CLONTARF",
    "dropphyst": "MN",
    "dropphyzpp": 562265000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLONTARF",
    "dropmalst": "MN",
    "dropmalzpp": 562269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208434110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25031",
    "droptype": "D",
    "dropname": "CLOQUET",
    "dropdeladd": "316 CLOQUET AVE",
    "dropdelcty": "CLOQUET",
    "dropdelst": "MN",
    "dropdelzpp": 557201743,
    "dropphyadd": "316 CLOQUET AVE",
    "dropphycty": "CLOQUET",
    "dropphyst": "MN",
    "dropphyzpp": 557201743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLOQUET",
    "dropmalst": "MN",
    "dropmalzpp": 557209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188799442,
    "dropfax": 2188794929
  },
  {
    "dcode": "D",
    "dropkey": "PY25038",
    "droptype": "D",
    "dropname": "COHASSET",
    "dropdeladd": "10 W HIGHWAY 2",
    "dropdelcty": "COHASSET",
    "dropdelst": "MN",
    "dropdelzpp": 557218614,
    "dropphyadd": "10 W HIGHWAY 2",
    "dropphycty": "COHASSET",
    "dropphyst": "MN",
    "dropphyzpp": 557218614,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COHASSET",
    "dropmalst": "MN",
    "dropmalzpp": 557219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183285109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25039",
    "droptype": "D",
    "dropname": "COKATO",
    "dropdeladd": "190 3RD ST SE",
    "dropdelcty": "COKATO",
    "dropdelst": "MN",
    "dropdelzpp": 553219650,
    "dropphyadd": "190 3RD ST SE",
    "dropphycty": "COKATO",
    "dropphyst": "MN",
    "dropphyzpp": 553219650,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COKATO",
    "dropmalst": "MN",
    "dropmalzpp": 553219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202862815,
    "dropfax": 3202865372
  },
  {
    "dcode": "D",
    "dropkey": "PY25043",
    "droptype": "D",
    "dropname": "COLD SPRING",
    "dropdeladd": "14 RED RIVER AVE N",
    "dropdelcty": "COLD SPRING",
    "dropdelst": "MN",
    "dropdelzpp": 563201621,
    "dropphyadd": "14 RED RIVER AVE N",
    "dropphycty": "COLD SPRING",
    "dropphyst": "MN",
    "dropphyzpp": 563201621,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLD SPRING",
    "dropmalst": "MN",
    "dropmalzpp": 563209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206858204,
    "dropfax": 3206854265
  },
  {
    "dcode": "D",
    "dropkey": "PY25044",
    "droptype": "D",
    "dropname": "COLERAINE",
    "dropdeladd": "208 POSTAL ST",
    "dropdelcty": "COLERAINE",
    "dropdelst": "MN",
    "dropdelzpp": 557225000,
    "dropphyadd": "208 POSTAL ST",
    "dropphycty": "COLERAINE",
    "dropphyst": "MN",
    "dropphyzpp": 557225000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLERAINE",
    "dropmalst": "MN",
    "dropmalzpp": 557229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182452226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25045",
    "droptype": "D",
    "dropname": "COLLEGEVILLE",
    "dropdeladd": "110 E POWERHOUSE RD",
    "dropdelcty": "COLLEGEVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 563214500,
    "dropphyadd": "110 E POWERHOUSE RD",
    "dropphycty": "COLLEGEVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 563214500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLEGEVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 563219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203632760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25048",
    "droptype": "D",
    "dropname": "COLOGNE",
    "dropdeladd": "509 PAUL AVE S",
    "dropdelcty": "COLOGNE",
    "dropdelst": "MN",
    "dropdelzpp": 553222600,
    "dropphyadd": "509 PAUL AVE S",
    "dropphycty": "COLOGNE",
    "dropphyst": "MN",
    "dropphyzpp": 553222600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLOGNE",
    "dropmalst": "MN",
    "dropmalzpp": 553229998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9522131489,
    "dropsitcph": 9522131489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25053",
    "droptype": "D",
    "dropname": "COMFREY",
    "dropdeladd": "100 BROWN ST E",
    "dropdelcty": "COMFREY",
    "dropdelst": "MN",
    "dropdelzpp": 560191146,
    "dropphyadd": "100 BROWN ST E",
    "dropphycty": "COMFREY",
    "dropphyst": "MN",
    "dropphyzpp": 560191146,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COMFREY",
    "dropmalst": "MN",
    "dropmalzpp": 560199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078772811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25056",
    "droptype": "D",
    "dropname": "COMSTOCK",
    "dropdeladd": "1762 160TH AVE S",
    "dropdelcty": "COMSTOCK",
    "dropdelst": "MN",
    "dropdelzpp": 565259998,
    "dropphyadd": "1762 160TH AVE S",
    "dropphycty": "COMSTOCK",
    "dropphyst": "MN",
    "dropphyzpp": 565259998,
    "dropmaladd": "1762 160TH AVE S",
    "dropmalcty": "COMSTOCK",
    "dropmalst": "MN",
    "dropmalzpp": 565259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185854577,
    "dropsitcph": 2185854577,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25059",
    "droptype": "D",
    "dropname": "CONGER",
    "dropdeladd": "94 MAPLE ST",
    "dropdelcty": "CONGER",
    "dropdelst": "MN",
    "dropdelzpp": 560204400,
    "dropphyadd": "94 MAPLE ST",
    "dropphycty": "CONGER",
    "dropphyst": "MN",
    "dropphyzpp": 560204400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONGER",
    "dropmalst": "MN",
    "dropmalzpp": 560209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072653395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25060",
    "droptype": "D",
    "dropname": "COOK",
    "dropdeladd": "126 S RIVER ST",
    "dropdelcty": "COOK",
    "dropdelst": "MN",
    "dropdelzpp": 557238133,
    "dropphyadd": "126 S RIVER ST",
    "dropphycty": "COOK",
    "dropphyst": "MN",
    "dropphyzpp": 557238133,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOK",
    "dropmalst": "MN",
    "dropmalzpp": 557239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186665370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25076",
    "droptype": "D",
    "dropname": "CORRELL",
    "dropdeladd": "110 COUNTY ROAD 25 N",
    "dropdelcty": "CORRELL",
    "dropdelst": "MN",
    "dropdelzpp": 562275000,
    "dropphyadd": "110 COUNTY ROAD 25 N",
    "dropphycty": "CORRELL",
    "dropphyst": "MN",
    "dropphyzpp": 562275000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORRELL",
    "dropmalst": "MN",
    "dropmalzpp": 562279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205962257,
    "dropfax": 3205962257
  },
  {
    "dcode": "D",
    "dropkey": "PY25077",
    "droptype": "D",
    "dropname": "COSMOS",
    "dropdeladd": "235 MILKYWAY ST S",
    "dropdelcty": "COSMOS",
    "dropdelst": "MN",
    "dropdelzpp": 562287718,
    "dropphyadd": "235 MILKYWAY ST S",
    "dropphycty": "COSMOS",
    "dropphyst": "MN",
    "dropphyzpp": 562287718,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COSMOS",
    "dropmalst": "MN",
    "dropmalzpp": 562289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208777722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25080",
    "droptype": "D",
    "dropname": "COTTON",
    "dropdeladd": "9087 HIGHWAY 53",
    "dropdelcty": "COTTON",
    "dropdelst": "MN",
    "dropdelzpp": 557248015,
    "dropphyadd": "9087 HIGHWAY 53",
    "dropphycty": "COTTON",
    "dropphyst": "MN",
    "dropphyzpp": 557248015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTON",
    "dropmalst": "MN",
    "dropmalzpp": 557249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184823212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25081",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "COTTONWOOD",
    "dropdelst": "MN",
    "dropdelzpp": 562295000,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "COTTONWOOD",
    "dropphyst": "MN",
    "dropphyzpp": 562295000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTONWOOD",
    "dropmalst": "MN",
    "dropmalzpp": 562299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074235199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25082",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "213 MAIN ST",
    "dropdelcty": "COURTLAND",
    "dropdelst": "MN",
    "dropdelzpp": 560212017,
    "dropphyadd": "213 MAIN ST",
    "dropphycty": "COURTLAND",
    "dropphyst": "MN",
    "dropphyzpp": 560212017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COURTLAND",
    "dropmalst": "MN",
    "dropmalzpp": 560219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073592541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25085",
    "droptype": "D",
    "dropname": "CRANE LAKE",
    "dropdeladd": "7511 GOLD COAST RD",
    "dropdelcty": "CRANE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 557258011,
    "dropphyadd": "7511 GOLD COAST RD",
    "dropphycty": "CRANE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 557258011,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRANE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 557259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189932277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25088",
    "droptype": "D",
    "dropname": "CROMWELL",
    "dropdeladd": "5570 HIGHWAY 210",
    "dropdelcty": "CROMWELL",
    "dropdelst": "MN",
    "dropdelzpp": 557265000,
    "dropphyadd": "5570 HIGHWAY 210",
    "dropphycty": "CROMWELL",
    "dropphyst": "MN",
    "dropphyzpp": 557265000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROMWELL",
    "dropmalst": "MN",
    "dropmalzpp": 557269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186443711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25090",
    "droptype": "D",
    "dropname": "CROOKSTON",
    "dropdeladd": "202 S BROADWAY",
    "dropdelcty": "CROOKSTON",
    "dropdelst": "MN",
    "dropdelzpp": 567169998,
    "dropphyadd": "202 S BROADWAY",
    "dropphycty": "CROOKSTON",
    "dropphyst": "MN",
    "dropphyzpp": 567169998,
    "dropmaladd": "202 S BROADWAY",
    "dropmalcty": "CROOKSTON",
    "dropmalst": "MN",
    "dropmalzpp": 567169998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182814500,
    "dropsitcph": 2182814500,
    "dropfax": 2182814354
  },
  {
    "dcode": "D",
    "dropkey": "PY25091",
    "droptype": "D",
    "dropname": "CROSBY",
    "dropdeladd": "207 W MAIN ST",
    "dropdelcty": "CROSBY",
    "dropdelst": "MN",
    "dropdelzpp": 564411324,
    "dropphyadd": "207 W MAIN ST",
    "dropphycty": "CROSBY",
    "dropphyst": "MN",
    "dropphyzpp": 564411324,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSBY",
    "dropmalst": "MN",
    "dropmalzpp": 564419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185465152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25092",
    "droptype": "D",
    "dropname": "CROSSLAKE",
    "dropdeladd": "35860 COUNTY ROAD 66",
    "dropdelcty": "CROSSLAKE",
    "dropdelst": "MN",
    "dropdelzpp": 564421200,
    "dropphyadd": "35860 COUNTY ROAD 66",
    "dropphycty": "CROSSLAKE",
    "dropphyst": "MN",
    "dropphyzpp": 564421200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROSSLAKE",
    "dropmalst": "MN",
    "dropmalzpp": 564429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186923712,
    "dropfax": 2186923718
  },
  {
    "dcode": "D",
    "dropkey": "PY25095",
    "droptype": "D",
    "dropname": "CRYSTAL BAY",
    "dropdeladd": "1355 BROWN RD S",
    "dropdelcty": "CRYSTAL BAY",
    "dropdelst": "MN",
    "dropdelzpp": 553232301,
    "dropphyadd": "1355 BROWN RD S",
    "dropphycty": "CRYSTAL BAY",
    "dropphyst": "MN",
    "dropphyzpp": 553232301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL BAY",
    "dropmalst": "MN",
    "dropmalzpp": 553239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524732352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25099",
    "droptype": "D",
    "dropname": "CURRIE",
    "dropdeladd": "121 MILL ST N",
    "dropdelcty": "CURRIE",
    "dropdelst": "MN",
    "dropdelzpp": 561231002,
    "dropphyadd": "121 MILL ST N",
    "dropphycty": "CURRIE",
    "dropphyst": "MN",
    "dropphyzpp": 561231002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURRIE",
    "dropmalst": "MN",
    "dropmalzpp": 561239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077633662,
    "dropfax": 5077633677
  },
  {
    "dcode": "D",
    "dropkey": "PY25100",
    "droptype": "D",
    "dropname": "CUSHING",
    "dropdeladd": "26113 BEAR RD",
    "dropdelcty": "CUSHING",
    "dropdelst": "MN",
    "dropdelzpp": 564432754,
    "dropphyadd": "26113 BEAR RD",
    "dropphycty": "CUSHING",
    "dropphyst": "MN",
    "dropphyzpp": 564432754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CUSHING",
    "dropmalst": "MN",
    "dropmalzpp": 564439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207492724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25102",
    "droptype": "D",
    "dropname": "CYRUS",
    "dropdeladd": "125 E MAIN ST",
    "dropdelcty": "CYRUS",
    "dropdelst": "MN",
    "dropdelzpp": 563234628,
    "dropphyadd": "125 E MAIN ST",
    "dropphycty": "CYRUS",
    "dropphyst": "MN",
    "dropphyzpp": 563234628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CYRUS",
    "dropmalst": "MN",
    "dropmalzpp": 563239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207952512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25103",
    "droptype": "D",
    "dropname": "DAKOTA",
    "dropdeladd": "745 FRONTAGE RD",
    "dropdelcty": "DAKOTA",
    "dropdelst": "MN",
    "dropdelzpp": 559257155,
    "dropphyadd": "745 FRONTAGE RD",
    "dropphycty": "DAKOTA",
    "dropphyst": "MN",
    "dropphyzpp": 559257155,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAKOTA",
    "dropmalst": "MN",
    "dropmalzpp": 559259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076436555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25104",
    "droptype": "D",
    "dropname": "DALBO",
    "dropdeladd": "5180 HIGHWAY 47 NW STE 1",
    "dropdelcty": "DALBO",
    "dropdelst": "MN",
    "dropdelzpp": 550178641,
    "dropphyadd": "5180 HIGHWAY 47 NW STE 1",
    "dropphycty": "DALBO",
    "dropphyst": "MN",
    "dropphyzpp": 550178641,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALBO",
    "dropmalst": "MN",
    "dropmalzpp": 550179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7636894499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25106",
    "droptype": "D",
    "dropname": "DALTON",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "DALTON",
    "dropdelst": "MN",
    "dropdelzpp": 563244706,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "DALTON",
    "dropphyst": "MN",
    "dropphyzpp": 563244706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DALTON",
    "dropmalst": "MN",
    "dropmalzpp": 563249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 8778549119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25109",
    "droptype": "D",
    "dropname": "DANUBE",
    "dropdeladd": "406 N MAIN ST",
    "dropdelcty": "DANUBE",
    "dropdelst": "MN",
    "dropdelzpp": 562305000,
    "dropphyadd": "406 N MAIN ST",
    "dropphycty": "DANUBE",
    "dropphyst": "MN",
    "dropphyzpp": 562305000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANUBE",
    "dropmalst": "MN",
    "dropmalzpp": 562309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208262429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25110",
    "droptype": "D",
    "dropname": "DANVERS",
    "dropdeladd": "408 MINNESOTA AVE",
    "dropdelcty": "DANVERS",
    "dropdelst": "MN",
    "dropdelzpp": 562315000,
    "dropphyadd": "408 MINNESOTA AVE",
    "dropphycty": "DANVERS",
    "dropphyst": "MN",
    "dropphyzpp": 562315000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DANVERS",
    "dropmalst": "MN",
    "dropmalzpp": 562319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205672326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25113",
    "droptype": "D",
    "dropname": "DARWIN",
    "dropdeladd": "321 N 1ST ST",
    "dropdelcty": "DARWIN",
    "dropdelst": "MN",
    "dropdelzpp": 553245243,
    "dropphyadd": "321 N 1ST ST",
    "dropphycty": "DARWIN",
    "dropphyst": "MN",
    "dropphyzpp": 553245243,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARWIN",
    "dropmalst": "MN",
    "dropmalzpp": 553249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202218057,
    "dropfax": 3202218069
  },
  {
    "dcode": "D",
    "dropkey": "PY25114",
    "droptype": "D",
    "dropname": "DASSEL",
    "dropdeladd": "501 2ND ST N",
    "dropdelcty": "DASSEL",
    "dropdelst": "MN",
    "dropdelzpp": 553251076,
    "dropphyadd": "501 2ND ST N",
    "dropphycty": "DASSEL",
    "dropphyst": "MN",
    "dropphyzpp": 553251076,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DASSEL",
    "dropmalst": "MN",
    "dropmalzpp": 553259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202752753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25115",
    "droptype": "D",
    "dropname": "DAWSON",
    "dropdeladd": "640 6TH ST",
    "dropdelcty": "DAWSON",
    "dropdelst": "MN",
    "dropdelzpp": 562325000,
    "dropphyadd": "640 6TH ST",
    "dropphycty": "DAWSON",
    "dropphyst": "MN",
    "dropphyzpp": 562325000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAWSON",
    "dropmalst": "MN",
    "dropmalzpp": 562329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3207694554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25117",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "18521 ROBINSON ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "MN",
    "dropdelzpp": 553277717,
    "dropphyadd": "18521 ROBINSON ST",
    "dropphycty": "DAYTON",
    "dropphyst": "MN",
    "dropphyzpp": 553277717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DAYTON",
    "dropmalst": "MN",
    "dropmalzpp": 553279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634282141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25125",
    "droptype": "D",
    "dropname": "DEER CREEK",
    "dropdeladd": "120 MAIN AVE E",
    "dropdelcty": "DEER CREEK",
    "dropdelst": "MN",
    "dropdelzpp": 565279998,
    "dropphyadd": "120 MAIN AVE E",
    "dropphycty": "DEER CREEK",
    "dropphyst": "MN",
    "dropphyzpp": 565279998,
    "dropmaladd": "120 MAIN AVE E",
    "dropmalcty": "DEER CREEK",
    "dropmalst": "MN",
    "dropmalzpp": 565279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184622000,
    "dropsitcph": 2184622000,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25127",
    "droptype": "D",
    "dropname": "DEER RIVER",
    "dropdeladd": "12 1ST AVE NE",
    "dropdelcty": "DEER RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 566368730,
    "dropphyadd": "12 1ST AVE NE",
    "dropphycty": "DEER RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 566368730,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 566369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182468440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25129",
    "droptype": "D",
    "dropname": "DEERWOOD",
    "dropdeladd": "23809 FOREST RD",
    "dropdelcty": "DEERWOOD",
    "dropdelst": "MN",
    "dropdelzpp": 564446100,
    "dropphyadd": "23809 FOREST RD",
    "dropphycty": "DEERWOOD",
    "dropphyst": "MN",
    "dropphyzpp": 564446100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERWOOD",
    "dropmalst": "MN",
    "dropmalzpp": 564449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 3206549744,
    "dropsitcph": 2185343144,
    "dropfax": 2185343897
  },
  {
    "dcode": "D",
    "dropkey": "PY25130",
    "droptype": "D",
    "dropname": "DELANO",
    "dropdeladd": "100 RIVER ST N",
    "dropdelcty": "DELANO",
    "dropdelst": "MN",
    "dropdelzpp": 553289311,
    "dropphyadd": "100 RIVER ST N",
    "dropphycty": "DELANO",
    "dropphyst": "MN",
    "dropphyzpp": 553289311,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELANO",
    "dropmalst": "MN",
    "dropmalzpp": 553289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7639722500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25131",
    "droptype": "D",
    "dropname": "DELAVAN",
    "dropdeladd": "100 N MAIN",
    "dropdelcty": "DELAVAN",
    "dropdelst": "MN",
    "dropdelzpp": 560234400,
    "dropphyadd": "100 N MAIN",
    "dropphycty": "DELAVAN",
    "dropphyst": "MN",
    "dropphyzpp": 560234400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELAVAN",
    "dropmalst": "MN",
    "dropmalzpp": 560239998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5078543214,
    "dropsitcph": 5078543214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25137",
    "droptype": "D",
    "dropname": "DENNISON",
    "dropdeladd": "37598 GOODHUE AVE",
    "dropdelcty": "DENNISON",
    "dropdelst": "MN",
    "dropdelzpp": 550187447,
    "dropphyadd": "37598 GOODHUE AVE",
    "dropphycty": "DENNISON",
    "dropphyst": "MN",
    "dropphyzpp": 550187447,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENNISON",
    "dropmalst": "MN",
    "dropmalzpp": 550189998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5076630417,
    "dropsitcph": 5076630417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25138",
    "droptype": "D",
    "dropname": "DENT",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "DENT",
    "dropdelst": "MN",
    "dropdelzpp": 565289998,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "DENT",
    "dropphyst": "MN",
    "dropphyzpp": 565289998,
    "dropmaladd": "108 MAIN ST",
    "dropmalcty": "DENT",
    "dropmalst": "MN",
    "dropmalzpp": 565289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187582020,
    "dropsitcph": 2187582020,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25140",
    "droptype": "D",
    "dropname": "DETROIT LAKES",
    "dropdeladd": "250 STATE ST W",
    "dropdelcty": "DETROIT LAKES",
    "dropdelst": "MN",
    "dropdelzpp": 565019998,
    "dropphyadd": "250 STATE ST W",
    "dropphycty": "DETROIT LAKES",
    "dropphyst": "MN",
    "dropphyzpp": 565019998,
    "dropmaladd": "250 STATE ST W",
    "dropmalcty": "DETROIT LAKES",
    "dropmalst": "MN",
    "dropmalzpp": 565019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188460285,
    "dropsitcph": 2188460285,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25141",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "DEXTER",
    "dropdelst": "MN",
    "dropdelzpp": 559269620,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "DEXTER",
    "dropphyst": "MN",
    "dropphyzpp": 559269620,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEXTER",
    "dropmalst": "MN",
    "dropmalzpp": 559269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075846421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25144",
    "droptype": "D",
    "dropname": "DILWORTH",
    "dropdeladd": "1 1ST AVE SE",
    "dropdelcty": "DILWORTH",
    "dropdelst": "MN",
    "dropdelzpp": 565299998,
    "dropphyadd": "1 1ST AVE SE",
    "dropphycty": "DILWORTH",
    "dropphyst": "MN",
    "dropphyzpp": 565299998,
    "dropmaladd": "1 1ST AVE SE",
    "dropmalcty": "DILWORTH",
    "dropmalst": "MN",
    "dropmalzpp": 565299998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182872195,
    "dropsitcph": 2182872195,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25147",
    "droptype": "D",
    "dropname": "DODGE CENTER",
    "dropdeladd": "37 W MAIN ST",
    "dropdelcty": "DODGE CENTER",
    "dropdelst": "MN",
    "dropdelzpp": 559272807,
    "dropphyadd": "37 W MAIN ST",
    "dropphycty": "DODGE CENTER",
    "dropphyst": "MN",
    "dropphyzpp": 559272807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DODGE CENTER",
    "dropmalst": "MN",
    "dropmalzpp": 559279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073742234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25149",
    "droptype": "D",
    "dropname": "DONALDSON",
    "dropdeladd": "110 COMMERCIAL ST STE 103",
    "dropdelcty": "DONALDSON",
    "dropdelst": "MN",
    "dropdelzpp": 567209998,
    "dropphyadd": "110 COMMERCIAL ST STE 103",
    "dropphycty": "DONALDSON",
    "dropphyst": "MN",
    "dropphyzpp": 567209998,
    "dropmaladd": "110 COMMERCIAL ST STE 103",
    "dropmalcty": "DONALDSON",
    "dropmalst": "MN",
    "dropmalzpp": 567209998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184662431,
    "dropsitcph": 2184662431,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25150",
    "droptype": "D",
    "dropname": "DONNELLY",
    "dropdeladd": "107 4TH ST",
    "dropdelcty": "DONNELLY",
    "dropdelst": "MN",
    "dropdelzpp": 562355000,
    "dropphyadd": "107 4TH ST",
    "dropphycty": "DONNELLY",
    "dropphyst": "MN",
    "dropphyzpp": 562355000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONNELLY",
    "dropmalst": "MN",
    "dropmalzpp": 562359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202463243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25156",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "212 MAIN ST N",
    "dropdelcty": "DOVER",
    "dropdelst": "MN",
    "dropdelzpp": 559291508,
    "dropphyadd": "212 MAIN ST N",
    "dropphycty": "DOVER",
    "dropphyst": "MN",
    "dropphyzpp": 559291508,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOVER",
    "dropmalst": "MN",
    "dropmalzpp": 559299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5079323377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25162",
    "droptype": "D",
    "dropname": "DULUTH",
    "dropdeladd": "2800 W MICHIGAN ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558061742,
    "dropphyadd": "2800 W MICHIGAN ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558061742,
    "dropmaladd": "2800 W MICHIGAN ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558069998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232526,
    "dropsitcph": 2187232526,
    "dropfax": 2187232557
  },
  {
    "dcode": "D",
    "dropkey": "PY25165",
    "droptype": "D",
    "dropname": "DUMONT",
    "dropdeladd": "101 MAIN ST E",
    "dropdelcty": "DUMONT",
    "dropdelst": "MN",
    "dropdelzpp": 562365050,
    "dropphyadd": "101 MAIN ST E",
    "dropphycty": "DUMONT",
    "dropphyst": "MN",
    "dropphyzpp": 562365050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUMONT",
    "dropmalst": "MN",
    "dropmalzpp": 562369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 3202080023,
    "dropsitcph": 3202080023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25166",
    "droptype": "D",
    "dropname": "DUNDAS",
    "dropdeladd": "211 COUNTY ROAD 1 E",
    "dropdelcty": "DUNDAS",
    "dropdelst": "MN",
    "dropdelzpp": 550194113,
    "dropphyadd": "211 COUNTY ROAD 1 E",
    "dropphycty": "DUNDAS",
    "dropphyst": "MN",
    "dropphyzpp": 550194113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNDAS",
    "dropmalst": "MN",
    "dropmalzpp": 550199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6122933014,
    "dropsitcph": 5076455494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25168",
    "droptype": "D",
    "dropname": "DUNNELL",
    "dropdeladd": "150 W WENBERG ST",
    "dropdelcty": "DUNNELL",
    "dropdelst": "MN",
    "dropdelzpp": 561271701,
    "dropphyadd": "150 W WENBERG ST",
    "dropphycty": "DUNNELL",
    "dropphyst": "MN",
    "dropphyzpp": 561271701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUNNELL",
    "dropmalst": "MN",
    "dropmalzpp": 561279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076952959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25173",
    "droptype": "D",
    "dropname": "EAGLE BEND",
    "dropdeladd": "103 MAIN ST W",
    "dropdelcty": "EAGLE BEND",
    "dropdelst": "MN",
    "dropdelzpp": 564461200,
    "dropphyadd": "103 MAIN ST W",
    "dropphycty": "EAGLE BEND",
    "dropphyst": "MN",
    "dropphyzpp": 564461200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE BEND",
    "dropmalst": "MN",
    "dropmalzpp": 564469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187383542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25174",
    "droptype": "D",
    "dropname": "EAGLE LAKE",
    "dropdeladd": "100 LE SUEUR AVE",
    "dropdelcty": "EAGLE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 560241200,
    "dropphyadd": "100 LE SUEUR AVE",
    "dropphycty": "EAGLE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 560241200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 560249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072573200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25179",
    "droptype": "D",
    "dropname": "EAST GRAND FORKS",
    "dropdeladd": "306 3RD ST NW",
    "dropdelcty": "EAST GRAND FORKS",
    "dropdelst": "MN",
    "dropdelzpp": 567219998,
    "dropphyadd": "306 3RD ST NW",
    "dropphycty": "EAST GRAND FORKS",
    "dropphyst": "MN",
    "dropphyzpp": 567219998,
    "dropmaladd": "306 3RD ST NW",
    "dropmalcty": "EAST GRAND FORKS",
    "dropmalst": "MN",
    "dropmalzpp": 567219998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187737643,
    "dropsitcph": 2187737643,
    "dropfax": 2187736801
  },
  {
    "dcode": "D",
    "dropkey": "PY25183",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "51 MAIN ST",
    "dropdelcty": "EASTON",
    "dropdelst": "MN",
    "dropdelzpp": 560252000,
    "dropphyadd": "51 MAIN ST",
    "dropphycty": "EASTON",
    "dropphyst": "MN",
    "dropphyzpp": 560252000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTON",
    "dropmalst": "MN",
    "dropmalzpp": 560259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077872251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25186",
    "droptype": "D",
    "dropname": "ECHO",
    "dropdeladd": "281 4TH ST",
    "dropdelcty": "ECHO",
    "dropdelst": "MN",
    "dropdelzpp": 562372501,
    "dropphyadd": "281 4TH ST",
    "dropphycty": "ECHO",
    "dropphyst": "MN",
    "dropphyzpp": 562372501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ECHO",
    "dropmalst": "MN",
    "dropmalzpp": 562379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 3202352472,
    "dropsitcph": 5074284084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25193",
    "droptype": "D",
    "dropname": "EDEN VALLEY",
    "dropdeladd": "378 CHURCH ST N",
    "dropdelcty": "EDEN VALLEY",
    "dropdelst": "MN",
    "dropdelzpp": 553291205,
    "dropphyadd": "378 CHURCH ST N",
    "dropphycty": "EDEN VALLEY",
    "dropphyst": "MN",
    "dropphyzpp": 553291205,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDEN VALLEY",
    "dropmalst": "MN",
    "dropmalzpp": 553299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3204533535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25195",
    "droptype": "D",
    "dropname": "EDGERTON",
    "dropdeladd": "741 MAIN ST",
    "dropdelcty": "EDGERTON",
    "dropdelst": "MN",
    "dropdelzpp": 561281300,
    "dropphyadd": "741 MAIN ST",
    "dropphycty": "EDGERTON",
    "dropphyst": "MN",
    "dropphyzpp": 561281300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EDGERTON",
    "dropmalst": "MN",
    "dropmalzpp": 561289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5074426441,
    "dropsitcph": 5074426441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25202",
    "droptype": "D",
    "dropname": "EITZEN",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "EITZEN",
    "dropdelst": "MN",
    "dropdelzpp": 559312900,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "EITZEN",
    "dropphyst": "MN",
    "dropphyzpp": 559312900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EITZEN",
    "dropmalst": "MN",
    "dropmalzpp": 559319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074953431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25204",
    "droptype": "D",
    "dropname": "ELBOW LAKE",
    "dropdeladd": "16 1ST AVE SE",
    "dropdelcty": "ELBOW LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 565319998,
    "dropphyadd": "16 1ST AVE SE",
    "dropphycty": "ELBOW LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 565319998,
    "dropmaladd": "16 1ST AVE SE",
    "dropmalcty": "ELBOW LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 565319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186854533,
    "dropsitcph": 2186854533,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25206",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "120 1ST AVE NE",
    "dropdelcty": "ELGIN",
    "dropdelst": "MN",
    "dropdelzpp": 559329687,
    "dropphyadd": "120 1ST AVE NE",
    "dropphycty": "ELGIN",
    "dropphyst": "MN",
    "dropphyzpp": 559329687,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELGIN",
    "dropmalst": "MN",
    "dropmalzpp": 559329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078762317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25208",
    "droptype": "D",
    "dropname": "ELK RIVER",
    "dropdeladd": "19120 FREEPORT ST NW",
    "dropdelcty": "ELK RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 553309904,
    "dropphyadd": "19120 FREEPORT ST NW",
    "dropphycty": "ELK RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 553309904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 553309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632415297,
    "dropfax": 7632419983
  },
  {
    "dcode": "D",
    "dropkey": "PY25211",
    "droptype": "D",
    "dropname": "ELLENDALE",
    "dropdeladd": "514 S 2ND ST",
    "dropdelcty": "ELLENDALE",
    "dropdelst": "MN",
    "dropdelzpp": 560264400,
    "dropphyadd": "514 S 2ND ST",
    "dropphycty": "ELLENDALE",
    "dropphyst": "MN",
    "dropphyzpp": 560264400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLENDALE",
    "dropmalst": "MN",
    "dropmalzpp": 560269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076886000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25214",
    "droptype": "D",
    "dropname": "ELLSWORTH",
    "dropdeladd": "111 E 3RD AVE",
    "dropdelcty": "ELLSWORTH",
    "dropdelst": "MN",
    "dropdelzpp": 561291060,
    "dropphyadd": "111 E 3RD AVE",
    "dropphycty": "ELLSWORTH",
    "dropphyst": "MN",
    "dropphyzpp": 561291060,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELLSWORTH",
    "dropmalst": "MN",
    "dropmalzpp": 561299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079673047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25216",
    "droptype": "D",
    "dropname": "ELMORE",
    "dropdeladd": "214 E WILLIS ST",
    "dropdelcty": "ELMORE",
    "dropdelst": "MN",
    "dropdelzpp": 560274400,
    "dropphyadd": "214 E WILLIS ST",
    "dropphycty": "ELMORE",
    "dropphyst": "MN",
    "dropphyzpp": 560274400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMORE",
    "dropmalst": "MN",
    "dropmalzpp": 560279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079433230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25218",
    "droptype": "D",
    "dropname": "ELROSA",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "ELROSA",
    "dropdelst": "MN",
    "dropdelzpp": 563254600,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "ELROSA",
    "dropphyst": "MN",
    "dropphyzpp": 563254600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELROSA",
    "dropmalst": "MN",
    "dropmalzpp": 563259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206972017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25220",
    "droptype": "D",
    "dropname": "ELY",
    "dropdeladd": "34 S 2ND AVE E",
    "dropdelcty": "ELY",
    "dropdelst": "MN",
    "dropdelzpp": 557311425,
    "dropphyadd": "34 S 2ND AVE E",
    "dropphycty": "ELY",
    "dropphyst": "MN",
    "dropphyzpp": 557311425,
    "dropmaladd": "34 S 2ND AVE E",
    "dropmalcty": "ELY",
    "dropmalst": "MN",
    "dropmalzpp": 557319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183653210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25221",
    "droptype": "D",
    "dropname": "ELYSIAN",
    "dropdeladd": "120 MAIN ST E",
    "dropdelcty": "ELYSIAN",
    "dropdelst": "MN",
    "dropdelzpp": 560281210,
    "dropphyadd": "120 MAIN ST E",
    "dropphycty": "ELYSIAN",
    "dropphyst": "MN",
    "dropphyzpp": 560281210,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELYSIAN",
    "dropmalst": "MN",
    "dropmalzpp": 560289998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072674477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25222",
    "droptype": "D",
    "dropname": "EMBARRASS",
    "dropdeladd": "4878 HIGHWAY 21",
    "dropdelcty": "EMBARRASS",
    "dropdelst": "MN",
    "dropdelzpp": 557328264,
    "dropphyadd": "4878 HIGHWAY 21",
    "dropphycty": "EMBARRASS",
    "dropphyst": "MN",
    "dropphyzpp": 557328264,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMBARRASS",
    "dropmalst": "MN",
    "dropmalzpp": 557329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189843027,
    "dropfax": 2189843027
  },
  {
    "dcode": "D",
    "dropkey": "PY25223",
    "droptype": "D",
    "dropname": "EMILY",
    "dropdeladd": "20984 COUNTY ROAD 1",
    "dropdelcty": "EMILY",
    "dropdelst": "MN",
    "dropdelzpp": 564474045,
    "dropphyadd": "20984 COUNTY ROAD 1",
    "dropphycty": "EMILY",
    "dropphyst": "MN",
    "dropphyzpp": 564474045,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMILY",
    "dropmalst": "MN",
    "dropmalzpp": 564479998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187632124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25224",
    "droptype": "D",
    "dropname": "EMMONS",
    "dropdeladd": "149 MAIN ST",
    "dropdelcty": "EMMONS",
    "dropdelst": "MN",
    "dropdelzpp": 560294400,
    "dropphyadd": "149 MAIN ST",
    "dropphycty": "EMMONS",
    "dropphyst": "MN",
    "dropphyzpp": 560294400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMMONS",
    "dropmalst": "MN",
    "dropmalzpp": 560299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5072975431,
    "dropsitcph": 5072975431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25226",
    "droptype": "D",
    "dropname": "ERHARD",
    "dropdeladd": "417 GROVE ST",
    "dropdelcty": "ERHARD",
    "dropdelst": "MN",
    "dropdelzpp": 565349998,
    "dropphyadd": "417 GROVE ST",
    "dropphycty": "ERHARD",
    "dropphyst": "MN",
    "dropphyzpp": 565349998,
    "dropmaladd": "417 GROVE ST",
    "dropmalcty": "ERHARD",
    "dropmalst": "MN",
    "dropmalzpp": 565349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188425375,
    "dropsitcph": 2188425375,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25229",
    "droptype": "D",
    "dropname": "ERSKINE",
    "dropdeladd": "123 VANCE AVE S",
    "dropdelcty": "ERSKINE",
    "dropdelst": "MN",
    "dropdelzpp": 565359998,
    "dropphyadd": "123 VANCE AVE S",
    "dropphycty": "ERSKINE",
    "dropphyst": "MN",
    "dropphyzpp": 565359998,
    "dropmaladd": "123 VANCE AVE S",
    "dropmalcty": "ERSKINE",
    "dropmalst": "MN",
    "dropmalzpp": 565359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186874545,
    "dropsitcph": 2186874545,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25230",
    "droptype": "D",
    "dropname": "ESKO",
    "dropdeladd": "10 W HIGHWAY 61",
    "dropdelcty": "ESKO",
    "dropdelst": "MN",
    "dropdelzpp": 557339701,
    "dropphyadd": "10 W HIGHWAY 61",
    "dropphycty": "ESKO",
    "dropphyst": "MN",
    "dropphyzpp": 557339701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESKO",
    "dropmalst": "MN",
    "dropmalzpp": 557339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188793242,
    "dropfax": 2188793242
  },
  {
    "dcode": "D",
    "dropkey": "PY25235",
    "droptype": "D",
    "dropname": "EVANSVILLE",
    "dropdeladd": "113 STATE ST NW",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 563264535,
    "dropphyadd": "113 STATE ST NW",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 563264535,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 563269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189482290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25238",
    "droptype": "D",
    "dropname": "EVELETH",
    "dropdeladd": "423 JONES ST",
    "dropdelcty": "EVELETH",
    "dropdelst": "MN",
    "dropdelzpp": 557341591,
    "dropphyadd": "423 JONES ST",
    "dropphycty": "EVELETH",
    "dropphyst": "MN",
    "dropphyzpp": 557341591,
    "dropmaladd": "423 JONES ST",
    "dropmalcty": "EVELETH",
    "dropmalst": "MN",
    "dropmalzpp": 557341591,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187442070,
    "dropfax": 2187442362
  },
  {
    "dcode": "D",
    "dropkey": "PY25240",
    "droptype": "D",
    "dropname": "EXCELSIOR",
    "dropdeladd": "545 2ND ST",
    "dropdelcty": "EXCELSIOR",
    "dropdelst": "MN",
    "dropdelzpp": 553311907,
    "dropphyadd": "545 2ND ST",
    "dropphycty": "EXCELSIOR",
    "dropphyst": "MN",
    "dropphyzpp": 553311907,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EXCELSIOR",
    "dropmalst": "MN",
    "dropmalzpp": 553319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9524744929,
    "dropsitcph": 9524744929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25241",
    "droptype": "D",
    "dropname": "EYOTA",
    "dropdeladd": "126 S FRONT ST SW",
    "dropdelcty": "EYOTA",
    "dropdelst": "MN",
    "dropdelzpp": 559346504,
    "dropphyadd": "126 S FRONT ST SW",
    "dropphycty": "EYOTA",
    "dropphyst": "MN",
    "dropphyzpp": 559346504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EYOTA",
    "dropmalst": "MN",
    "dropmalzpp": 559349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075452159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25244",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "137 PARK ST S",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "MN",
    "dropdelzpp": 553323180,
    "dropphyadd": "137 PARK ST S",
    "dropphycty": "FAIRFAX",
    "dropphyst": "MN",
    "dropphyzpp": 553323180,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "MN",
    "dropmalzpp": 553329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074267700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25245",
    "droptype": "D",
    "dropname": "FAIRMONT",
    "dropdeladd": "490 S STATE ST",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "MN",
    "dropdelzpp": 560314147,
    "dropphyadd": "490 S STATE ST",
    "dropphycty": "FAIRMONT",
    "dropphyst": "MN",
    "dropphyzpp": 560314147,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "MN",
    "dropmalzpp": 560319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072356368,
    "dropfax": 5072355079
  },
  {
    "dcode": "D",
    "dropkey": "PY25253",
    "droptype": "D",
    "dropname": "FARIBAULT",
    "dropdeladd": "28 3RD ST NE",
    "dropdelcty": "FARIBAULT",
    "dropdelst": "MN",
    "dropdelzpp": 550219992,
    "dropphyadd": "28 3RD ST NE",
    "dropphycty": "FARIBAULT",
    "dropphyst": "MN",
    "dropphyzpp": 550219992,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARIBAULT",
    "dropmalst": "MN",
    "dropmalzpp": 550219998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073345075,
    "dropfax": 5073347998
  },
  {
    "dcode": "D",
    "dropkey": "PY25255",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "113 ELM ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "MN",
    "dropdelzpp": 550241052,
    "dropphyadd": "113 ELM ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "MN",
    "dropphyzpp": 550241052,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "MN",
    "dropmalzpp": 550249998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514639477,
    "dropsitcph": 6514637972,
    "dropfax": 6514633805
  },
  {
    "dcode": "D",
    "dropkey": "PY25262",
    "droptype": "D",
    "dropname": "FELTON",
    "dropdeladd": "340 5TH ST",
    "dropdelcty": "FELTON",
    "dropdelst": "MN",
    "dropdelzpp": 565369998,
    "dropphyadd": "340 5TH ST",
    "dropphycty": "FELTON",
    "dropphyst": "MN",
    "dropphyzpp": 565369998,
    "dropmaladd": "340 5TH ST",
    "dropmalcty": "FELTON",
    "dropmalst": "MN",
    "dropmalzpp": 565369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184943740,
    "dropsitcph": 2184943740,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25263",
    "droptype": "D",
    "dropname": "FERGUS FALLS",
    "dropdeladd": "1011 WESTERN AVE",
    "dropdelcty": "FERGUS FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 565379998,
    "dropphyadd": "1011 WESTERN AVE",
    "dropphycty": "FERGUS FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 565379998,
    "dropmaladd": "1011 WESTERN AVE",
    "dropmalcty": "FERGUS FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 565379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187362634,
    "dropsitcph": 2187362634,
    "dropfax": 2187363621
  },
  {
    "dcode": "D",
    "dropkey": "PY25264",
    "droptype": "D",
    "dropname": "FERTILE",
    "dropdeladd": "107 WASHINGTON AVE NE",
    "dropdelcty": "FERTILE",
    "dropdelst": "MN",
    "dropdelzpp": 565409998,
    "dropphyadd": "107 WASHINGTON AVE NE",
    "dropphycty": "FERTILE",
    "dropphyst": "MN",
    "dropphyzpp": 565409998,
    "dropmaladd": "107 WASHINGTON AVE NE",
    "dropmalcty": "FERTILE",
    "dropmalst": "MN",
    "dropmalzpp": 565409998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189456906,
    "dropsitcph": 2189456906,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25274",
    "droptype": "D",
    "dropname": "FINLAND",
    "dropdeladd": "6638 HIGHWAY 1",
    "dropdelcty": "FINLAND",
    "dropdelst": "MN",
    "dropdelzpp": 556033601,
    "dropphyadd": "6638 HIGHWAY 1",
    "dropphycty": "FINLAND",
    "dropphyst": "MN",
    "dropphyzpp": 556033601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FINLAND",
    "dropmalst": "MN",
    "dropmalzpp": 556039998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183537318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25275",
    "droptype": "D",
    "dropname": "FINLAYSON",
    "dropdeladd": "2217 FINLAND AVE",
    "dropdelcty": "FINLAYSON",
    "dropdelst": "MN",
    "dropdelzpp": 557355000,
    "dropphyadd": "2217 FINLAND AVE",
    "dropphycty": "FINLAYSON",
    "dropphyst": "MN",
    "dropphyzpp": 557355000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FINLAYSON",
    "dropmalst": "MN",
    "dropmalzpp": 557359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202336581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25279",
    "droptype": "D",
    "dropname": "FISHER",
    "dropdeladd": "319 THOMPSON AVE",
    "dropdelcty": "FISHER",
    "dropdelst": "MN",
    "dropdelzpp": 567239998,
    "dropphyadd": "319 THOMPSON AVE",
    "dropphycty": "FISHER",
    "dropphyst": "MN",
    "dropphyzpp": 567239998,
    "dropmaladd": "319 THOMPSON AVE",
    "dropmalcty": "FISHER",
    "dropmalst": "MN",
    "dropmalzpp": 567239998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188914031,
    "dropsitcph": 2188914031,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25281",
    "droptype": "D",
    "dropname": "FLENSBURG",
    "dropdeladd": "28 PINE ST N",
    "dropdelcty": "FLENSBURG",
    "dropdelst": "MN",
    "dropdelzpp": 563282201,
    "dropphyadd": "28 PINE ST N",
    "dropphycty": "FLENSBURG",
    "dropphyst": "MN",
    "dropphyzpp": 563282201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLENSBURG",
    "dropmalst": "MN",
    "dropmalzpp": 563289998,
    "dropsitphn": 6123492400,
    "dropsitlph": 3206328836,
    "dropsitcph": 3206322400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25282",
    "droptype": "D",
    "dropname": "FLOM",
    "dropdeladd": "1101 COUNTY HIGHWAY 38",
    "dropdelcty": "FLOM",
    "dropdelst": "MN",
    "dropdelzpp": 565419998,
    "dropphyadd": "1101 COUNTY HIGHWAY 38",
    "dropphycty": "FLOM",
    "dropphyst": "MN",
    "dropphyzpp": 565419998,
    "dropmaladd": "1101 COUNTY HIGHWAY 38",
    "dropmalcty": "FLOM",
    "dropmalst": "MN",
    "dropmalzpp": 565419998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185678200,
    "dropsitcph": 2185678200,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25283",
    "droptype": "D",
    "dropname": "FLOODWOOD",
    "dropdeladd": "118 7TH AVE W",
    "dropdelcty": "FLOODWOOD",
    "dropdelst": "MN",
    "dropdelzpp": 557361215,
    "dropphyadd": "118 7TH AVE W",
    "dropphycty": "FLOODWOOD",
    "dropphyst": "MN",
    "dropphyzpp": 557361215,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLOODWOOD",
    "dropmalst": "MN",
    "dropmalzpp": 557369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184767121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25286",
    "droptype": "D",
    "dropname": "FOLEY",
    "dropdeladd": "450 DEWEY ST",
    "dropdelcty": "FOLEY",
    "dropdelst": "MN",
    "dropdelzpp": 563298406,
    "dropphyadd": "450 DEWEY ST",
    "dropphycty": "FOLEY",
    "dropphyst": "MN",
    "dropphyzpp": 563298406,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOLEY",
    "dropmalst": "MN",
    "dropmalzpp": 563299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3209687216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25295",
    "droptype": "D",
    "dropname": "FORBES",
    "dropdeladd": "3525 HIGHWAY 7",
    "dropdelcty": "FORBES",
    "dropdelst": "MN",
    "dropdelzpp": 557388008,
    "dropphyadd": "3525 HIGHWAY 7",
    "dropphycty": "FORBES",
    "dropphyst": "MN",
    "dropphyzpp": 557388008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORBES",
    "dropmalst": "MN",
    "dropmalzpp": 557389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187445356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25297",
    "droptype": "D",
    "dropname": "FOREST LAKE",
    "dropdeladd": "78 6TH AVE SW",
    "dropdelcty": "FOREST LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 550251574,
    "dropphyadd": "78 6TH AVE SW",
    "dropphycty": "FOREST LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 550251574,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOREST LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 550259998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514641207,
    "dropsitcph": 6514641353,
    "dropfax": 6514640070
  },
  {
    "dcode": "D",
    "dropkey": "PY25299",
    "droptype": "D",
    "dropname": "FORESTON",
    "dropdeladd": "192 WASHINGTON AVE",
    "dropdelcty": "FORESTON",
    "dropdelst": "MN",
    "dropdelzpp": 563304100,
    "dropphyadd": "192 WASHINGTON AVE",
    "dropphycty": "FORESTON",
    "dropphyst": "MN",
    "dropphyzpp": 563304100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORESTON",
    "dropmalst": "MN",
    "dropmalzpp": 563309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202945489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25300",
    "droptype": "D",
    "dropname": "FORT RIPLEY",
    "dropdeladd": "617 FRONT ST",
    "dropdelcty": "FORT RIPLEY",
    "dropdelst": "MN",
    "dropdelzpp": 564491226,
    "dropphyadd": "617 FRONT ST",
    "dropphycty": "FORT RIPLEY",
    "dropphyst": "MN",
    "dropphyzpp": 564491226,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT RIPLEY",
    "dropmalst": "MN",
    "dropmalzpp": 564499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206320462,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25303",
    "droptype": "D",
    "dropname": "FOSSTON",
    "dropdeladd": "119 2ND ST NW",
    "dropdelcty": "FOSSTON",
    "dropdelst": "MN",
    "dropdelzpp": 565429998,
    "dropphyadd": "119 2ND ST NW",
    "dropphycty": "FOSSTON",
    "dropphyst": "MN",
    "dropphyzpp": 565429998,
    "dropmaladd": "119 2ND ST NW",
    "dropmalcty": "FOSSTON",
    "dropmalst": "MN",
    "dropmalzpp": 565429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184356282,
    "dropsitcph": 2184356282,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25305",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "FOUNTAIN",
    "dropdelst": "MN",
    "dropdelzpp": 559358839,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "FOUNTAIN",
    "dropphyst": "MN",
    "dropphyzpp": 559358839,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOUNTAIN",
    "dropmalst": "MN",
    "dropmalzpp": 559359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072684941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25306",
    "droptype": "D",
    "dropname": "FOXHOME",
    "dropdeladd": "100 DENNISTON AVE",
    "dropdelcty": "FOXHOME",
    "dropdelst": "MN",
    "dropdelzpp": 565439998,
    "dropphyadd": "100 DENNISTON AVE",
    "dropphycty": "FOXHOME",
    "dropphyst": "MN",
    "dropphyzpp": 565439998,
    "dropmaladd": "100 DENNISTON AVE",
    "dropmalcty": "FOXHOME",
    "dropmalst": "MN",
    "dropmalzpp": 565439998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186433003,
    "dropsitcph": 2186433003,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25309",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "265 2ND AVE E",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "MN",
    "dropdelzpp": 553331181,
    "dropphyadd": "265 2ND AVE E",
    "dropphycty": "FRANKLIN",
    "dropphyst": "MN",
    "dropphyzpp": 553331181,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "MN",
    "dropmalzpp": 553339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075572229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25311",
    "droptype": "D",
    "dropname": "FRAZEE",
    "dropdeladd": "103 E MAIN AVE",
    "dropdelcty": "FRAZEE",
    "dropdelst": "MN",
    "dropdelzpp": 565449998,
    "dropphyadd": "103 E MAIN AVE",
    "dropphycty": "FRAZEE",
    "dropphyst": "MN",
    "dropphyzpp": 565449998,
    "dropmaladd": "103 E MAIN AVE",
    "dropmalcty": "FRAZEE",
    "dropmalst": "MN",
    "dropmalzpp": 565449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183345041,
    "dropsitcph": 2183345041,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25312",
    "droptype": "D",
    "dropname": "FREEBORN",
    "dropdeladd": "206 4TH AVE",
    "dropdelcty": "FREEBORN",
    "dropdelst": "MN",
    "dropdelzpp": 560324400,
    "dropphyadd": "206 4TH AVE",
    "dropphycty": "FREEBORN",
    "dropphyst": "MN",
    "dropphyzpp": 560324400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEBORN",
    "dropmalst": "MN",
    "dropmalzpp": 560329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078632334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25314",
    "droptype": "D",
    "dropname": "FREEPORT",
    "dropdeladd": "119 MAIN ST E",
    "dropdelcty": "FREEPORT",
    "dropdelst": "MN",
    "dropdelzpp": 563314501,
    "dropphyadd": "119 MAIN ST E",
    "dropphycty": "FREEPORT",
    "dropphyst": "MN",
    "dropphyzpp": 563314501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREEPORT",
    "dropmalst": "MN",
    "dropmalzpp": 563319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202281091,
    "dropfax": 3202281090
  },
  {
    "dcode": "D",
    "dropkey": "PY25321",
    "droptype": "D",
    "dropname": "FRONTENAC",
    "dropdeladd": "33923 HIGHWAY 61 BLVD",
    "dropdelcty": "FRONTENAC",
    "dropdelst": "MN",
    "dropdelzpp": 550267000,
    "dropphyadd": "33923 HIGHWAY 61 BLVD",
    "dropphycty": "FRONTENAC",
    "dropphyst": "MN",
    "dropphyzpp": 550267000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRONTENAC",
    "dropmalst": "MN",
    "dropmalzpp": 550269998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6513454121,
    "dropfax": 6513453127
  },
  {
    "dcode": "D",
    "dropkey": "PY25322",
    "droptype": "D",
    "dropname": "FROST",
    "dropdeladd": "155 MAIN ST",
    "dropdelcty": "FROST",
    "dropdelst": "MN",
    "dropdelzpp": 560334400,
    "dropphyadd": "155 MAIN ST",
    "dropphycty": "FROST",
    "dropphyst": "MN",
    "dropphyzpp": 560334400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FROST",
    "dropmalst": "MN",
    "dropmalzpp": 560339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078783242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25325",
    "droptype": "D",
    "dropname": "FULDA",
    "dropdeladd": "109 N BALTIMORE AVE",
    "dropdelcty": "FULDA",
    "dropdelst": "MN",
    "dropdelzpp": 561319545,
    "dropphyadd": "109 N BALTIMORE AVE",
    "dropphycty": "FULDA",
    "dropphyst": "MN",
    "dropphyzpp": 561319545,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FULDA",
    "dropmalst": "MN",
    "dropmalzpp": 561319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074252107,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25328",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "MN",
    "dropdelzpp": 560344543,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "MN",
    "dropphyzpp": 560344543,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "MN",
    "dropmalzpp": 560349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075463196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25330",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "104 STATE ST S",
    "dropdelcty": "GARFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 563324500,
    "dropphyadd": "104 STATE ST S",
    "dropphycty": "GARFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 563324500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 563329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208342276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25331",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "9424 JEFFERSON ST",
    "dropdelcty": "GARRISON",
    "dropdelst": "MN",
    "dropdelzpp": 564502023,
    "dropphyadd": "9424 JEFFERSON ST",
    "dropphycty": "GARRISON",
    "dropphyst": "MN",
    "dropphyzpp": 564502023,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARRISON",
    "dropmalst": "MN",
    "dropmalzpp": 564509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206924242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25333",
    "droptype": "D",
    "dropname": "GARY",
    "dropdeladd": "201 1ST AVE E",
    "dropdelcty": "GARY",
    "dropdelst": "MN",
    "dropdelzpp": 565459998,
    "dropphyadd": "201 1ST AVE E",
    "dropphycty": "GARY",
    "dropphyst": "MN",
    "dropphyzpp": 565459998,
    "dropmaladd": "201 1ST AVE E",
    "dropmalcty": "GARY",
    "dropmalst": "MN",
    "dropmalzpp": 565459998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183568694,
    "dropsitcph": 2183568694,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25335",
    "droptype": "D",
    "dropname": "GAYLORD",
    "dropdeladd": "311 MAIN AVE",
    "dropdelcty": "GAYLORD",
    "dropdelst": "MN",
    "dropdelzpp": 553342295,
    "dropphyadd": "311 MAIN AVE",
    "dropphycty": "GAYLORD",
    "dropphyst": "MN",
    "dropphyzpp": 553342295,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAYLORD",
    "dropmalst": "MN",
    "dropmalzpp": 553349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072372544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25339",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "201 CENTRAL AVE S",
    "dropdelcty": "GENEVA",
    "dropdelst": "MN",
    "dropdelzpp": 560354400,
    "dropphyadd": "201 CENTRAL AVE S",
    "dropphycty": "GENEVA",
    "dropphyst": "MN",
    "dropphyzpp": 560354400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENEVA",
    "dropmalst": "MN",
    "dropmalzpp": 560359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072567544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25341",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "127 MAIN ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "MN",
    "dropdelzpp": 565469998,
    "dropphyadd": "127 MAIN ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "MN",
    "dropphyzpp": 565469998,
    "dropmaladd": "127 MAIN ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "MN",
    "dropmalzpp": 565469998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182334622,
    "dropsitcph": 2182334622,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25343",
    "droptype": "D",
    "dropname": "GHENT",
    "dropdeladd": "104 W BURLINGAME ST",
    "dropdelcty": "GHENT",
    "dropdelst": "MN",
    "dropdelzpp": 562399757,
    "dropphyadd": "104 W BURLINGAME ST",
    "dropphycty": "GHENT",
    "dropphyst": "MN",
    "dropphyzpp": 562399757,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GHENT",
    "dropmalst": "MN",
    "dropmalzpp": 562399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074283405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25344",
    "droptype": "D",
    "dropname": "GIBBON",
    "dropdeladd": "1070 1ST AVE",
    "dropdelcty": "GIBBON",
    "dropdelst": "MN",
    "dropdelzpp": 553353143,
    "dropphyadd": "1070 1ST AVE",
    "dropphycty": "GIBBON",
    "dropphyst": "MN",
    "dropphyzpp": 553353143,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIBBON",
    "dropmalst": "MN",
    "dropmalzpp": 553359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078346231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25346",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "2 N BROADWAY AVE STE 1",
    "dropdelcty": "GILBERT",
    "dropdelst": "MN",
    "dropdelzpp": 557415205,
    "dropphyadd": "2 N BROADWAY AVE STE 1",
    "dropphycty": "GILBERT",
    "dropphyst": "MN",
    "dropphyzpp": 557415205,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILBERT",
    "dropmalst": "MN",
    "dropmalzpp": 557419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187416501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25347",
    "droptype": "D",
    "dropname": "GILMAN",
    "dropdeladd": "10321 115TH ST NE",
    "dropdelcty": "GILMAN",
    "dropdelst": "MN",
    "dropdelzpp": 563334500,
    "dropphyadd": "10321 115TH ST NE",
    "dropphycty": "GILMAN",
    "dropphyst": "MN",
    "dropphyzpp": 563334500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILMAN",
    "dropmalst": "MN",
    "dropmalzpp": 563339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203872804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25348",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "905 11TH ST E",
    "dropdelcty": "GLENCOE",
    "dropdelst": "MN",
    "dropdelzpp": 553362308,
    "dropphyadd": "905 11TH ST E",
    "dropphycty": "GLENCOE",
    "dropphyst": "MN",
    "dropphyzpp": 553362308,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENCOE",
    "dropmalst": "MN",
    "dropmalzpp": 553369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208644112,
    "dropfax": 3208644259
  },
  {
    "dcode": "D",
    "dropkey": "PY25350",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "220 W MAIN ST",
    "dropdelcty": "GLENVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 560369506,
    "dropphyadd": "220 W MAIN ST",
    "dropphycty": "GLENVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 560369506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 560369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074482945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25353",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "590 FRANKLIN ST N",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "MN",
    "dropdelzpp": 563341165,
    "dropphyadd": "590 FRANKLIN ST N",
    "dropphycty": "GLENWOOD",
    "dropphyst": "MN",
    "dropphyzpp": 563341165,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "MN",
    "dropmalzpp": 563349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206343156,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25354",
    "droptype": "D",
    "dropname": "GLYNDON",
    "dropdeladd": "27 STATE ST SE",
    "dropdelcty": "GLYNDON",
    "dropdelst": "MN",
    "dropdelzpp": 565479998,
    "dropphyadd": "27 STATE ST SE",
    "dropphycty": "GLYNDON",
    "dropphyst": "MN",
    "dropphyzpp": 565479998,
    "dropmaladd": "27 STATE ST SE",
    "dropmalcty": "GLYNDON",
    "dropmalst": "MN",
    "dropmalzpp": 565479998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184980201,
    "dropsitcph": 2184980201,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25359",
    "droptype": "D",
    "dropname": "GONVICK",
    "dropdeladd": "233 2ND AVE",
    "dropdelcty": "GONVICK",
    "dropdelst": "MN",
    "dropdelzpp": 566442000,
    "dropphyadd": "233 2ND AVE",
    "dropphycty": "GONVICK",
    "dropphyst": "MN",
    "dropphyzpp": 566442000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GONVICK",
    "dropmalst": "MN",
    "dropmalzpp": 566449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184875298,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25361",
    "droptype": "D",
    "dropname": "GOOD THUNDER",
    "dropdeladd": "111 S HOUK ST",
    "dropdelcty": "GOOD THUNDER",
    "dropdelst": "MN",
    "dropdelzpp": 560377506,
    "dropphyadd": "111 S HOUK ST",
    "dropphycty": "GOOD THUNDER",
    "dropphyst": "MN",
    "dropphyzpp": 560377506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOOD THUNDER",
    "dropmalst": "MN",
    "dropmalzpp": 560379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072783212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25362",
    "droptype": "D",
    "dropname": "GOODHUE",
    "dropdeladd": "205 N BROADWAY",
    "dropdelcty": "GOODHUE",
    "dropdelst": "MN",
    "dropdelzpp": 550279205,
    "dropphyadd": "205 N BROADWAY",
    "dropphycty": "GOODHUE",
    "dropphyst": "MN",
    "dropphyzpp": 550279205,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODHUE",
    "dropmalst": "MN",
    "dropmalzpp": 550279998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6519234650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25364",
    "droptype": "D",
    "dropname": "GOODRIDGE",
    "dropdeladd": "204 VAUGHN MAIN ST E",
    "dropdelcty": "GOODRIDGE",
    "dropdelst": "MN",
    "dropdelzpp": 567259998,
    "dropphyadd": "204 VAUGHN MAIN ST E",
    "dropphycty": "GOODRIDGE",
    "dropphyst": "MN",
    "dropphyzpp": 567259998,
    "dropmaladd": "204 VAUGHN MAIN ST E",
    "dropmalcty": "GOODRIDGE",
    "dropmalst": "MN",
    "dropmalzpp": 567259998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183784116,
    "dropsitcph": 2183784116,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25366",
    "droptype": "D",
    "dropname": "GRACEVILLE",
    "dropdeladd": "327 STUDDART AVE",
    "dropdelcty": "GRACEVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 562405000,
    "dropphyadd": "327 STUDDART AVE",
    "dropphycty": "GRACEVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 562405000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRACEVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 562409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3207487331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25368",
    "droptype": "D",
    "dropname": "GRANADA",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "GRANADA",
    "dropdelst": "MN",
    "dropdelzpp": 560394014,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "GRANADA",
    "dropphyst": "MN",
    "dropphyzpp": 560394014,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANADA",
    "dropmalst": "MN",
    "dropmalzpp": 560399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074472246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25371",
    "droptype": "D",
    "dropname": "GRAND MARAIS",
    "dropdeladd": "117 E HIGHWAY 61",
    "dropdelcty": "GRAND MARAIS",
    "dropdelst": "MN",
    "dropdelzpp": 556044400,
    "dropphyadd": "117 E HIGHWAY 61",
    "dropphycty": "GRAND MARAIS",
    "dropphyst": "MN",
    "dropphyzpp": 556044400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND MARAIS",
    "dropmalst": "MN",
    "dropmalzpp": 556049998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232575,
    "dropsitcph": 2183871020,
    "dropfax": 2183879173
  },
  {
    "dcode": "D",
    "dropkey": "PY25372",
    "droptype": "D",
    "dropname": "GRAND MEADOW",
    "dropdeladd": "129 MAIN ST S",
    "dropdelcty": "GRAND MEADOW",
    "dropdelst": "MN",
    "dropdelzpp": 559361109,
    "dropphyadd": "129 MAIN ST S",
    "dropphycty": "GRAND MEADOW",
    "dropphyst": "MN",
    "dropphyzpp": 559361109,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND MEADOW",
    "dropmalst": "MN",
    "dropmalzpp": 559369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077545157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25373",
    "droptype": "D",
    "dropname": "GRAND PORTAGE",
    "dropdeladd": "77 MILE CREEK RD",
    "dropdelcty": "GRAND PORTAGE",
    "dropdelst": "MN",
    "dropdelzpp": 556053028,
    "dropphyadd": "77 MILE CREEK RD",
    "dropphycty": "GRAND PORTAGE",
    "dropphyst": "MN",
    "dropphyzpp": 556053028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND PORTAGE",
    "dropmalst": "MN",
    "dropmalzpp": 556059998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184752303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25374",
    "droptype": "D",
    "dropname": "GRAND RAPIDS",
    "dropdeladd": "505 NW 1ST AVE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MN",
    "dropdelzpp": 557442667,
    "dropphyadd": "505 NW 1ST AVE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MN",
    "dropphyzpp": 557442667,
    "dropmaladd": "505 NW 1ST AVE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MN",
    "dropmalzpp": 557442667,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183263956,
    "dropfax": 2183260618
  },
  {
    "dcode": "D",
    "dropkey": "PY25376",
    "droptype": "D",
    "dropname": "GRANDY",
    "dropdeladd": "2961 369TH AVE NE",
    "dropdelcty": "GRANDY",
    "dropdelst": "MN",
    "dropdelzpp": 550297000,
    "dropphyadd": "2961 369TH AVE NE",
    "dropphycty": "GRANDY",
    "dropphyst": "MN",
    "dropphyzpp": 550297000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANDY",
    "dropmalst": "MN",
    "dropmalzpp": 550299998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7636895683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25379",
    "droptype": "D",
    "dropname": "GRANITE FALLS",
    "dropdeladd": "120 7TH AVE",
    "dropdelcty": "GRANITE FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 562411506,
    "dropphyadd": "120 7TH AVE",
    "dropphycty": "GRANITE FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 562411506,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANITE FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 562419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205643429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25384",
    "droptype": "D",
    "dropname": "GRASSTON",
    "dropdeladd": "200 PINE ST",
    "dropdelcty": "GRASSTON",
    "dropdelst": "MN",
    "dropdelzpp": 550309743,
    "dropphyadd": "200 PINE ST",
    "dropphycty": "GRASSTON",
    "dropphyst": "MN",
    "dropphyzpp": 550309743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRASSTON",
    "dropmalst": "MN",
    "dropmalzpp": 550309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3203962065,
    "dropfax": 3203962065
  },
  {
    "dcode": "D",
    "dropkey": "PY25391",
    "droptype": "D",
    "dropname": "GREEN ISLE",
    "dropdeladd": "500 MCGRANN ST",
    "dropdelcty": "GREEN ISLE",
    "dropdelst": "MN",
    "dropdelzpp": 553382201,
    "dropphyadd": "500 MCGRANN ST",
    "dropphycty": "GREEN ISLE",
    "dropphyst": "MN",
    "dropphyzpp": 553382201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN ISLE",
    "dropmalst": "MN",
    "dropmalzpp": 553389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073267021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25392",
    "droptype": "D",
    "dropname": "GREENBUSH",
    "dropdeladd": "136 4TH ST N",
    "dropdelcty": "GREENBUSH",
    "dropdelst": "MN",
    "dropdelzpp": 567269998,
    "dropphyadd": "136 4TH ST N",
    "dropphycty": "GREENBUSH",
    "dropphyst": "MN",
    "dropphyzpp": 567269998,
    "dropmaladd": "136 4TH ST N",
    "dropmalcty": "GREENBUSH",
    "dropmalst": "MN",
    "dropmalzpp": 567269998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187822468,
    "dropsitcph": 2187822468,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25396",
    "droptype": "D",
    "dropname": "GREENWALD",
    "dropdeladd": "51 N 5TH ST W",
    "dropdelcty": "GREENWALD",
    "dropdelst": "MN",
    "dropdelzpp": 563352602,
    "dropphyadd": "51 N 5TH ST W",
    "dropphycty": "GREENWALD",
    "dropphyst": "MN",
    "dropphyzpp": 563352602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENWALD",
    "dropmalst": "MN",
    "dropmalzpp": 563359998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3209873497,
    "dropfax": 3209873513
  },
  {
    "dcode": "D",
    "dropkey": "PY25401",
    "droptype": "D",
    "dropname": "GREY EAGLE",
    "dropdeladd": "210 STATE ST E",
    "dropdelcty": "GREY EAGLE",
    "dropdelst": "MN",
    "dropdelzpp": 563364400,
    "dropphyadd": "210 STATE ST E",
    "dropphycty": "GREY EAGLE",
    "dropphyst": "MN",
    "dropphyzpp": 563364400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREY EAGLE",
    "dropmalst": "MN",
    "dropmalzpp": 563369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202812062,
    "dropfax": 3202812063
  },
  {
    "dcode": "D",
    "dropkey": "PY25406",
    "droptype": "D",
    "dropname": "GROVE CITY",
    "dropdeladd": "214 ATLANTIC AVE W",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "MN",
    "dropdelzpp": 562436000,
    "dropphyadd": "214 ATLANTIC AVE W",
    "dropphycty": "GROVE CITY",
    "dropphyst": "MN",
    "dropphyzpp": 562436000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "MN",
    "dropmalzpp": 562439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208572931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25408",
    "droptype": "D",
    "dropname": "GRYGLA",
    "dropdeladd": "107 S MAIN AVE",
    "dropdelcty": "GRYGLA",
    "dropdelst": "MN",
    "dropdelzpp": 567279998,
    "dropphyadd": "107 S MAIN AVE",
    "dropphycty": "GRYGLA",
    "dropphyst": "MN",
    "dropphyzpp": 567279998,
    "dropmaladd": "107 S MAIN AVE",
    "dropmalcty": "GRYGLA",
    "dropmalst": "MN",
    "dropmalzpp": 567279998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182946141,
    "dropsitcph": 2182946141,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25409",
    "droptype": "D",
    "dropname": "GULLY",
    "dropdeladd": "301 S MAIN ST",
    "dropdelcty": "GULLY",
    "dropdelst": "MN",
    "dropdelzpp": 566465006,
    "dropphyadd": "301 S MAIN ST",
    "dropphycty": "GULLY",
    "dropphyst": "MN",
    "dropphyzpp": 566465006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GULLY",
    "dropmalst": "MN",
    "dropmalzpp": 566469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182684150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25411",
    "droptype": "D",
    "dropname": "HACKENSACK",
    "dropdeladd": "201 1ST ST S",
    "dropdelcty": "HACKENSACK",
    "dropdelst": "MN",
    "dropdelzpp": 564522595,
    "dropphyadd": "201 1ST ST S",
    "dropphycty": "HACKENSACK",
    "dropphyst": "MN",
    "dropphyzpp": 564522595,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HACKENSACK",
    "dropmalst": "MN",
    "dropmalzpp": 564529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186758004,
    "dropfax": 2186758003
  },
  {
    "dcode": "D",
    "dropkey": "PY25417",
    "droptype": "D",
    "dropname": "HALLOCK",
    "dropdeladd": "105 S BIRCH AVE",
    "dropdelcty": "HALLOCK",
    "dropdelst": "MN",
    "dropdelzpp": 567289998,
    "dropphyadd": "105 S BIRCH AVE",
    "dropphycty": "HALLOCK",
    "dropphyst": "MN",
    "dropphyzpp": 567289998,
    "dropmaladd": "105 S BIRCH AVE",
    "dropmalcty": "HALLOCK",
    "dropmalst": "MN",
    "dropmalzpp": 567289998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188432534,
    "dropsitcph": 2188432534,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25419",
    "droptype": "D",
    "dropname": "HALSTAD",
    "dropdeladd": "229 2ND AVE W",
    "dropdelcty": "HALSTAD",
    "dropdelst": "MN",
    "dropdelzpp": 565489998,
    "dropphyadd": "229 2ND AVE W",
    "dropphycty": "HALSTAD",
    "dropphyst": "MN",
    "dropphyzpp": 565489998,
    "dropmaladd": "229 2ND AVE W",
    "dropmalcty": "HALSTAD",
    "dropmalst": "MN",
    "dropmalzpp": 565489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184562616,
    "dropsitcph": 2184562616,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25421",
    "droptype": "D",
    "dropname": "HAMBURG",
    "dropdeladd": "361 HENRIETTA AVE",
    "dropdelcty": "HAMBURG",
    "dropdelst": "MN",
    "dropdelzpp": 553399469,
    "dropphyadd": "361 HENRIETTA AVE",
    "dropphycty": "HAMBURG",
    "dropphyst": "MN",
    "dropphyzpp": 553399469,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMBURG",
    "dropmalst": "MN",
    "dropmalzpp": 553399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524673185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25422",
    "droptype": "D",
    "dropname": "HAMEL",
    "dropdeladd": "105 HAMEL RD",
    "dropdelcty": "HAMEL",
    "dropdelst": "MN",
    "dropdelzpp": 553404530,
    "dropphyadd": "105 HAMEL RD",
    "dropphycty": "HAMEL",
    "dropphyst": "MN",
    "dropphyzpp": 553404530,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMEL",
    "dropmalst": "MN",
    "dropmalzpp": 553409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634786741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25424",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "23335 WATER ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "MN",
    "dropdelzpp": 550319798,
    "dropphyadd": "23335 WATER ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "MN",
    "dropphyzpp": 550319798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMPTON",
    "dropmalst": "MN",
    "dropmalzpp": 550319998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514374806,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25425",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "660 6TH ST",
    "dropdelcty": "HANCOCK",
    "dropdelst": "MN",
    "dropdelzpp": 562449422,
    "dropphyadd": "660 6TH ST",
    "dropphycty": "HANCOCK",
    "dropphyst": "MN",
    "dropphyzpp": 562449422,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANCOCK",
    "dropmalst": "MN",
    "dropmalzpp": 562449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202080035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25427",
    "droptype": "D",
    "dropname": "HANLEY FALLS",
    "dropdeladd": "123 N 3RD ST",
    "dropdelcty": "HANLEY FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 562455000,
    "dropphyadd": "123 N 3RD ST",
    "dropphycty": "HANLEY FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 562455000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANLEY FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 562459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077684047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25429",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "10961 4TH ST NE",
    "dropdelcty": "HANOVER",
    "dropdelst": "MN",
    "dropdelzpp": 553414092,
    "dropphyadd": "10961 4TH ST NE",
    "dropphycty": "HANOVER",
    "dropphyst": "MN",
    "dropphyzpp": 553414092,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANOVER",
    "dropmalst": "MN",
    "dropmalzpp": 553419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634987033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25430",
    "droptype": "D",
    "dropname": "HANSKA",
    "dropdeladd": "114 BROADWAY",
    "dropdelcty": "HANSKA",
    "dropdelst": "MN",
    "dropdelzpp": 560414400,
    "dropphyadd": "114 BROADWAY",
    "dropphycty": "HANSKA",
    "dropphyst": "MN",
    "dropphyzpp": 560414400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANSKA",
    "dropmalst": "MN",
    "dropmalzpp": 560419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074396233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25432",
    "droptype": "D",
    "dropname": "HARDWICK",
    "dropdeladd": "103 E MAIN ST",
    "dropdelcty": "HARDWICK",
    "dropdelst": "MN",
    "dropdelzpp": 561342000,
    "dropphyadd": "103 E MAIN ST",
    "dropphycty": "HARDWICK",
    "dropphyst": "MN",
    "dropphyzpp": 561342000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARDWICK",
    "dropmalst": "MN",
    "dropmalzpp": 561349998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076695062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25433",
    "droptype": "D",
    "dropname": "HARMONY",
    "dropdeladd": "50 MAIN AVE N",
    "dropdelcty": "HARMONY",
    "dropdelst": "MN",
    "dropdelzpp": 559398888,
    "dropphyadd": "50 MAIN AVE N",
    "dropphycty": "HARMONY",
    "dropphyst": "MN",
    "dropphyzpp": 559398888,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARMONY",
    "dropmalst": "MN",
    "dropmalzpp": 559399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078863772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25436",
    "droptype": "D",
    "dropname": "HARRIS",
    "dropdeladd": "43812 GINGER AVE",
    "dropdelcty": "HARRIS",
    "dropdelst": "MN",
    "dropdelzpp": 550323267,
    "dropphyadd": "43812 GINGER AVE",
    "dropphycty": "HARRIS",
    "dropphyst": "MN",
    "dropphyzpp": 550323267,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRIS",
    "dropmalst": "MN",
    "dropmalzpp": 550329998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6516748130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25438",
    "droptype": "D",
    "dropname": "HARTLAND",
    "dropdeladd": "407 BROADWAY ST",
    "dropdelcty": "HARTLAND",
    "dropdelst": "MN",
    "dropdelzpp": 560427706,
    "dropphyadd": "407 BROADWAY ST",
    "dropphycty": "HARTLAND",
    "dropphyst": "MN",
    "dropphyzpp": 560427706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTLAND",
    "dropmalst": "MN",
    "dropmalzpp": 560429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078452817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25440",
    "droptype": "D",
    "dropname": "HASTINGS",
    "dropdeladd": "300 2ND ST E",
    "dropdelcty": "HASTINGS",
    "dropdelst": "MN",
    "dropdelzpp": 550331206,
    "dropphyadd": "300 2ND ST E",
    "dropphycty": "HASTINGS",
    "dropphyst": "MN",
    "dropphyzpp": 550331206,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HASTINGS",
    "dropmalst": "MN",
    "dropmalzpp": 550339998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514371663,
    "dropfax": 6514375096
  },
  {
    "dcode": "D",
    "dropkey": "PY25445",
    "droptype": "D",
    "dropname": "HAWLEY",
    "dropdeladd": "503 FRONT ST",
    "dropdelcty": "HAWLEY",
    "dropdelst": "MN",
    "dropdelzpp": 565499998,
    "dropphyadd": "503 FRONT ST",
    "dropphycty": "HAWLEY",
    "dropphyst": "MN",
    "dropphyzpp": 565499998,
    "dropmaladd": "503 FRONT ST",
    "dropmalcty": "HAWLEY",
    "dropmalst": "MN",
    "dropmalzpp": 565499998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184833335,
    "dropsitcph": 2184833335,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25446",
    "droptype": "D",
    "dropname": "HAYFIELD",
    "dropdeladd": "11 W MAIN ST",
    "dropdelcty": "HAYFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 559408620,
    "dropphyadd": "11 W MAIN ST",
    "dropphycty": "HAYFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 559408620,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 559409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074772332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25448",
    "droptype": "D",
    "dropname": "HAYWARD",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "HAYWARD",
    "dropdelst": "MN",
    "dropdelzpp": 560434400,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "HAYWARD",
    "dropphyst": "MN",
    "dropphyzpp": 560434400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYWARD",
    "dropmalst": "MN",
    "dropmalzpp": 560439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073730961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25450",
    "droptype": "D",
    "dropname": "HECTOR",
    "dropdeladd": "237 MAIN ST S",
    "dropdelcty": "HECTOR",
    "dropdelst": "MN",
    "dropdelzpp": 553421237,
    "dropphyadd": "237 MAIN ST S",
    "dropphycty": "HECTOR",
    "dropphyst": "MN",
    "dropphyzpp": 553421237,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HECTOR",
    "dropmalst": "MN",
    "dropmalzpp": 553429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208486414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25451",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "HENDERSON",
    "dropdelst": "MN",
    "dropdelzpp": 560447709,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "HENDERSON",
    "dropphyst": "MN",
    "dropphyzpp": 560447709,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENDERSON",
    "dropmalst": "MN",
    "dropmalzpp": 560449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072483636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25452",
    "droptype": "D",
    "dropname": "HENDRICKS",
    "dropdeladd": "107 S MAIN ST",
    "dropdelcty": "HENDRICKS",
    "dropdelst": "MN",
    "dropdelzpp": 561364401,
    "dropphyadd": "107 S MAIN ST",
    "dropphycty": "HENDRICKS",
    "dropphyst": "MN",
    "dropphyzpp": 561364401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENDRICKS",
    "dropmalst": "MN",
    "dropmalzpp": 561369998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072753557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25453",
    "droptype": "D",
    "dropname": "HENDRUM",
    "dropdeladd": "307 MAIN ST E",
    "dropdelcty": "HENDRUM",
    "dropdelst": "MN",
    "dropdelzpp": 565509998,
    "dropphyadd": "307 MAIN ST E",
    "dropphycty": "HENDRUM",
    "dropphyst": "MN",
    "dropphyzpp": 565509998,
    "dropmaladd": "307 MAIN ST E",
    "dropmalcty": "HENDRUM",
    "dropmalst": "MN",
    "dropmalzpp": 565509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188616247,
    "dropsitcph": 2188616247,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25455",
    "droptype": "D",
    "dropname": "HENNING",
    "dropdeladd": "507 DOUGLAS AVE",
    "dropdelcty": "HENNING",
    "dropdelst": "MN",
    "dropdelzpp": 565519998,
    "dropphyadd": "507 DOUGLAS AVE",
    "dropphycty": "HENNING",
    "dropphyst": "MN",
    "dropphyzpp": 565519998,
    "dropmaladd": "507 DOUGLAS AVE",
    "dropmalcty": "HENNING",
    "dropmalst": "MN",
    "dropmalzpp": 565519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185832218,
    "dropsitcph": 8773641998,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "PY25457",
    "droptype": "D",
    "dropname": "HERMAN",
    "dropdeladd": "410 ATLANTIC AVE S",
    "dropdelcty": "HERMAN",
    "dropdelst": "MN",
    "dropdelzpp": 562485000,
    "dropphyadd": "410 ATLANTIC AVE S",
    "dropphycty": "HERMAN",
    "dropphyst": "MN",
    "dropphyzpp": 562485000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERMAN",
    "dropmalst": "MN",
    "dropmalzpp": 562489998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202080004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25459",
    "droptype": "D",
    "dropname": "HERON LAKE",
    "dropdeladd": "1006 3RD AVE",
    "dropdelcty": "HERON LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 561371404,
    "dropphyadd": "1006 3RD AVE",
    "dropphycty": "HERON LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 561371404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERON LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 561379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077932770,
    "dropfax": 5077932314
  },
  {
    "dcode": "D",
    "dropkey": "PY25461",
    "droptype": "D",
    "dropname": "HEWITT",
    "dropdeladd": "410 N FRONT ST",
    "dropdelcty": "HEWITT",
    "dropdelst": "MN",
    "dropdelzpp": 564538819,
    "dropphyadd": "410 N FRONT ST",
    "dropphycty": "HEWITT",
    "dropphyst": "MN",
    "dropphyzpp": 564538819,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEWITT",
    "dropmalst": "MN",
    "dropmalzpp": 564539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189242905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25462",
    "droptype": "D",
    "dropname": "HIBBING",
    "dropdeladd": "1902 3RD AVE E",
    "dropdelcty": "HIBBING",
    "dropdelst": "MN",
    "dropdelzpp": 557461649,
    "dropphyadd": "1902 3RD AVE E",
    "dropphycty": "HIBBING",
    "dropphyst": "MN",
    "dropphyzpp": 557461649,
    "dropmaladd": "1902 3RD AVE E",
    "dropmalcty": "HIBBING",
    "dropmalst": "MN",
    "dropmalzpp": 557469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182634086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25465",
    "droptype": "D",
    "dropname": "HILL CITY",
    "dropdeladd": "133 LAKE AVE",
    "dropdelcty": "HILL CITY",
    "dropdelst": "MN",
    "dropdelzpp": 557485000,
    "dropphyadd": "133 LAKE AVE",
    "dropphycty": "HILL CITY",
    "dropphyst": "MN",
    "dropphyzpp": 557485000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILL CITY",
    "dropmalst": "MN",
    "dropmalzpp": 557489998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186972651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25470",
    "droptype": "D",
    "dropname": "HILLS",
    "dropdeladd": "205 S MAIN AVE",
    "dropdelcty": "HILLS",
    "dropdelst": "MN",
    "dropdelzpp": 561381094,
    "dropphyadd": "205 S MAIN AVE",
    "dropphycty": "HILLS",
    "dropphyst": "MN",
    "dropphyzpp": 561381094,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLS",
    "dropmalst": "MN",
    "dropmalzpp": 561389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079623253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25473",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "204 MAIN ST E",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "MN",
    "dropdelzpp": 550379368,
    "dropphyadd": "204 MAIN ST E",
    "dropphycty": "HINCKLEY",
    "dropphyst": "MN",
    "dropphyzpp": 550379368,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "MN",
    "dropmalzpp": 550379998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3203846136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25474",
    "droptype": "D",
    "dropname": "HINES",
    "dropdeladd": "22061 HINES RD NE",
    "dropdelcty": "HINES",
    "dropdelst": "MN",
    "dropdelzpp": 566474821,
    "dropphyadd": "22061 HINES RD NE",
    "dropphycty": "HINES",
    "dropphyst": "MN",
    "dropphyzpp": 566474821,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HINES",
    "dropmalst": "MN",
    "dropmalzpp": 566479998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188354722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25475",
    "droptype": "D",
    "dropname": "HITTERDAL",
    "dropdeladd": "52 FRONT ST E",
    "dropdelcty": "HITTERDAL",
    "dropdelst": "MN",
    "dropdelzpp": 565529998,
    "dropphyadd": "52 FRONT ST E",
    "dropphycty": "HITTERDAL",
    "dropphyst": "MN",
    "dropphyzpp": 565529998,
    "dropmaladd": "52 FRONT ST E",
    "dropmalcty": "HITTERDAL",
    "dropmalst": "MN",
    "dropmalzpp": 565529998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189623220,
    "dropsitcph": 2189623220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25476",
    "droptype": "D",
    "dropname": "HOFFMAN",
    "dropdeladd": "128 MAIN AVE",
    "dropdelcty": "HOFFMAN",
    "dropdelst": "MN",
    "dropdelzpp": 563398139,
    "dropphyadd": "128 MAIN AVE",
    "dropphycty": "HOFFMAN",
    "dropphyst": "MN",
    "dropphyzpp": 563398139,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOFFMAN",
    "dropmalst": "MN",
    "dropmalzpp": 563399998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3209862647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25477",
    "droptype": "D",
    "dropname": "HOKAH",
    "dropdeladd": "49 MAIN ST",
    "dropdelcty": "HOKAH",
    "dropdelst": "MN",
    "dropdelzpp": 559416500,
    "dropphyadd": "49 MAIN ST",
    "dropphycty": "HOKAH",
    "dropphyst": "MN",
    "dropphyzpp": 559416500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOKAH",
    "dropmalst": "MN",
    "dropmalzpp": 559419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078944608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25478",
    "droptype": "D",
    "dropname": "HOLDINGFORD",
    "dropdeladd": "105 PLYMOUTH ST",
    "dropdelcty": "HOLDINGFORD",
    "dropdelst": "MN",
    "dropdelzpp": 563404400,
    "dropphyadd": "105 PLYMOUTH ST",
    "dropphycty": "HOLDINGFORD",
    "dropphyst": "MN",
    "dropphyzpp": 563404400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLDINGFORD",
    "dropmalst": "MN",
    "dropmalzpp": 563409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207462800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25482",
    "droptype": "D",
    "dropname": "HOLLANDALE",
    "dropdeladd": "108 PARK AVE W",
    "dropdelcty": "HOLLANDALE",
    "dropdelst": "MN",
    "dropdelzpp": 560454423,
    "dropphyadd": "108 PARK AVE W",
    "dropphycty": "HOLLANDALE",
    "dropphyst": "MN",
    "dropphyzpp": 560454423,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLANDALE",
    "dropmalst": "MN",
    "dropmalzpp": 560459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078896501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25484",
    "droptype": "D",
    "dropname": "HOLLOWAY",
    "dropdeladd": "121 RAND ST",
    "dropdelcty": "HOLLOWAY",
    "dropdelst": "MN",
    "dropdelzpp": 562491107,
    "dropphyadd": "121 RAND ST",
    "dropphycty": "HOLLOWAY",
    "dropphyst": "MN",
    "dropphyzpp": 562491107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLOWAY",
    "dropmalst": "MN",
    "dropmalzpp": 562499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203942253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25486",
    "droptype": "D",
    "dropname": "HOLMES CITY",
    "dropdeladd": "11142 COUNTY ROAD 94",
    "dropdelcty": "HOLMES CITY",
    "dropdelst": "MN",
    "dropdelzpp": 563414400,
    "dropphyadd": "11142 COUNTY ROAD 94",
    "dropphycty": "HOLMES CITY",
    "dropphyst": "MN",
    "dropphyzpp": 563414400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLMES CITY",
    "dropmalst": "MN",
    "dropmalzpp": 563419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208865260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25493",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "9064 SW 37TH AVE",
    "dropdelcty": "HOPE",
    "dropdelst": "MN",
    "dropdelzpp": 560462003,
    "dropphyadd": "9064 SW 37TH AVE",
    "dropphycty": "HOPE",
    "dropphyst": "MN",
    "dropphyzpp": 560462003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPE",
    "dropmalst": "MN",
    "dropmalzpp": 560469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074551211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25494",
    "droptype": "D",
    "dropname": "HOPKINS",
    "dropdeladd": "910 1ST ST S",
    "dropdelcty": "HOPKINS",
    "dropdelst": "MN",
    "dropdelzpp": 553437502,
    "dropphyadd": "910 1ST ST S",
    "dropphycty": "HOPKINS",
    "dropphyst": "MN",
    "dropphyzpp": 553437502,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPKINS",
    "dropmalst": "MN",
    "dropmalzpp": 553439998,
    "dropsitphn": 9522382228,
    "dropsitlph": 9522382228,
    "dropsitcph": 9529334880,
    "dropfax": 9522382257
  },
  {
    "dcode": "D",
    "dropkey": "PY25496",
    "droptype": "D",
    "dropname": "HOUSTON",
    "dropdeladd": "127 S GRANT ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "MN",
    "dropdelzpp": 559438443,
    "dropphyadd": "127 S GRANT ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "MN",
    "dropphyzpp": 559438443,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "MN",
    "dropmalzpp": 559439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078963948,
    "dropfax": 5078964172
  },
  {
    "dcode": "D",
    "dropkey": "PY25497",
    "droptype": "D",
    "dropname": "HOVLAND",
    "dropdeladd": "12 ARROWHEAD TRL",
    "dropdelcty": "HOVLAND",
    "dropdelst": "MN",
    "dropdelzpp": 556065050,
    "dropphyadd": "12 ARROWHEAD TRL",
    "dropphycty": "HOVLAND",
    "dropphyst": "MN",
    "dropphyzpp": 556065050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOVLAND",
    "dropmalst": "MN",
    "dropmalzpp": 556069998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184752286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25498",
    "droptype": "D",
    "dropname": "HOWARD LAKE",
    "dropdeladd": "609 8TH AVE",
    "dropdelcty": "HOWARD LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553495137,
    "dropphyadd": "609 8TH AVE",
    "dropphycty": "HOWARD LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553495137,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOWARD LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205432751,
    "dropfax": 3205433044
  },
  {
    "dcode": "D",
    "dropkey": "PY25501",
    "droptype": "D",
    "dropname": "HOYT LAKES",
    "dropdeladd": "281 KENNEDY MEMORIAL DR",
    "dropdelcty": "HOYT LAKES",
    "dropdelst": "MN",
    "dropdelzpp": 557501121,
    "dropphyadd": "281 KENNEDY MEMORIAL DR",
    "dropphycty": "HOYT LAKES",
    "dropphyst": "MN",
    "dropphyzpp": 557501121,
    "dropmaladd": "281 KENNEDY MEMORIAL DR",
    "dropmalcty": "HOYT LAKES",
    "dropmalst": "MN",
    "dropmalzpp": 557509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182252091,
    "dropfax": 2182252358
  },
  {
    "dcode": "D",
    "dropkey": "PY25504",
    "droptype": "D",
    "dropname": "HUGO",
    "dropdeladd": "5615 150TH ST N",
    "dropdelcty": "HUGO",
    "dropdelst": "MN",
    "dropdelzpp": 550388482,
    "dropphyadd": "5615 150TH ST N",
    "dropphycty": "HUGO",
    "dropphyst": "MN",
    "dropphyzpp": 550388482,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUGO",
    "dropmalst": "MN",
    "dropmalzpp": 550389998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514071991,
    "dropsitcph": 6514071991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25505",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "MN",
    "dropdelzpp": 567319998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "MN",
    "dropphyzpp": 567319998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "MN",
    "dropmalzpp": 567319998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183793147,
    "dropsitcph": 2183791004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25508",
    "droptype": "D",
    "dropname": "HUTCHINSON",
    "dropdeladd": "245 MAIN ST S",
    "dropdelcty": "HUTCHINSON",
    "dropdelst": "MN",
    "dropdelzpp": 553502579,
    "dropphyadd": "245 MAIN ST S",
    "dropphycty": "HUTCHINSON",
    "dropphyst": "MN",
    "dropphyzpp": 553502579,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUTCHINSON",
    "dropmalst": "MN",
    "dropmalzpp": 553509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205872497,
    "dropfax": 3205871086
  },
  {
    "dcode": "D",
    "dropkey": "PY25525",
    "droptype": "D",
    "dropname": "INTERNATIONAL FALLS",
    "dropdeladd": "400 4TH ST",
    "dropdelcty": "INTERNATIONAL FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 566499904,
    "dropphyadd": "400 4TH ST",
    "dropphycty": "INTERNATIONAL FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 566499904,
    "dropmaladd": "400 4TH ST",
    "dropmalcty": "INTERNATIONAL FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 566499904,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182833331,
    "dropfax": 2182833915
  },
  {
    "dcode": "D",
    "dropkey": "PY25532",
    "droptype": "D",
    "dropname": "IONA",
    "dropdeladd": "330 GRACE AVE",
    "dropdelcty": "IONA",
    "dropdelst": "MN",
    "dropdelzpp": 561411067,
    "dropphyadd": "330 GRACE AVE",
    "dropphycty": "IONA",
    "dropphyst": "MN",
    "dropphyzpp": 561411067,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IONA",
    "dropmalst": "MN",
    "dropmalzpp": 561419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072643793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25533",
    "droptype": "D",
    "dropname": "IRON",
    "dropdeladd": "4123 MERRITT AVE",
    "dropdelcty": "IRON",
    "dropdelst": "MN",
    "dropdelzpp": 557518255,
    "dropphyadd": "4123 MERRITT AVE",
    "dropphycty": "IRON",
    "dropphyst": "MN",
    "dropphyzpp": 557518255,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRON",
    "dropmalst": "MN",
    "dropmalzpp": 557519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187444984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25534",
    "droptype": "D",
    "dropname": "IRONTON",
    "dropdeladd": "115 4TH ST",
    "dropdelcty": "IRONTON",
    "dropdelst": "MN",
    "dropdelzpp": 564552180,
    "dropphyadd": "115 4TH ST",
    "dropphycty": "IRONTON",
    "dropphyst": "MN",
    "dropphyzpp": 564552180,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IRONTON",
    "dropmalst": "MN",
    "dropmalzpp": 564559998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185645467,
    "dropfax": 2185455467
  },
  {
    "dcode": "D",
    "dropkey": "PY25536",
    "droptype": "D",
    "dropname": "ISANTI",
    "dropdeladd": "25 W MAIN ST",
    "dropdelcty": "ISANTI",
    "dropdelst": "MN",
    "dropdelzpp": 550405001,
    "dropphyadd": "25 W MAIN ST",
    "dropphycty": "ISANTI",
    "dropphyst": "MN",
    "dropphyzpp": 550405001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISANTI",
    "dropmalst": "MN",
    "dropmalzpp": 550409998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7634445516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25537",
    "droptype": "D",
    "dropname": "ISLE",
    "dropdeladd": "250 2ND AVE S",
    "dropdelcty": "ISLE",
    "dropdelst": "MN",
    "dropdelzpp": 563424408,
    "dropphyadd": "250 2ND AVE S",
    "dropphycty": "ISLE",
    "dropphyst": "MN",
    "dropphyzpp": 563424408,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ISLE",
    "dropmalst": "MN",
    "dropmalzpp": 563429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206763207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25538",
    "droptype": "D",
    "dropname": "IVANHOE",
    "dropdeladd": "321 N SHERWOOD ST",
    "dropdelcty": "IVANHOE",
    "dropdelst": "MN",
    "dropdelzpp": 561429592,
    "dropphyadd": "321 N SHERWOOD ST",
    "dropphycty": "IVANHOE",
    "dropphyst": "MN",
    "dropphyzpp": 561429592,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IVANHOE",
    "dropmalst": "MN",
    "dropmalzpp": 561429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076941556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25541",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "211 2ND ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "MN",
    "dropdelzpp": 561431601,
    "dropphyadd": "211 2ND ST",
    "dropphycty": "JACKSON",
    "dropphyst": "MN",
    "dropphyzpp": 561431601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSON",
    "dropmalst": "MN",
    "dropmalzpp": 561439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078472810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25543",
    "droptype": "D",
    "dropname": "JANESVILLE",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "JANESVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 560489539,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "JANESVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 560489539,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JANESVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 560489998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072345381,
    "dropfax": 5072345381
  },
  {
    "dcode": "D",
    "dropkey": "PY25546",
    "droptype": "D",
    "dropname": "JASPER",
    "dropdeladd": "216 WALL ST W",
    "dropdelcty": "JASPER",
    "dropdelst": "MN",
    "dropdelzpp": 561441144,
    "dropphyadd": "216 WALL ST W",
    "dropphycty": "JASPER",
    "dropphyst": "MN",
    "dropphyzpp": 561441144,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JASPER",
    "dropmalst": "MN",
    "dropmalzpp": 561449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073487551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25547",
    "droptype": "D",
    "dropname": "JEFFERS",
    "dropdeladd": "120 E WHITED ST",
    "dropdelcty": "JEFFERS",
    "dropdelst": "MN",
    "dropdelzpp": 561454723,
    "dropphyadd": "120 E WHITED ST",
    "dropphycty": "JEFFERS",
    "dropphyst": "MN",
    "dropphyzpp": 561454723,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEFFERS",
    "dropmalst": "MN",
    "dropmalzpp": 561459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076284914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25560",
    "droptype": "D",
    "dropname": "JORDAN",
    "dropdeladd": "214 2ND ST E",
    "dropdelcty": "JORDAN",
    "dropdelst": "MN",
    "dropdelzpp": 553521402,
    "dropphyadd": "214 2ND ST E",
    "dropphycty": "JORDAN",
    "dropphyst": "MN",
    "dropphyzpp": 553521402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JORDAN",
    "dropmalst": "MN",
    "dropmalzpp": 553529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524922114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25563",
    "droptype": "D",
    "dropname": "KANDIYOHI",
    "dropdeladd": "224 ATLANTIC AVE N",
    "dropdelcty": "KANDIYOHI",
    "dropdelst": "MN",
    "dropdelzpp": 562514600,
    "dropphyadd": "224 ATLANTIC AVE N",
    "dropphycty": "KANDIYOHI",
    "dropphyst": "MN",
    "dropphyzpp": 562514600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KANDIYOHI",
    "dropmalst": "MN",
    "dropmalzpp": 562519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203828059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25564",
    "droptype": "D",
    "dropname": "KARLSTAD",
    "dropdeladd": "107 MAIN ST S",
    "dropdelcty": "KARLSTAD",
    "dropdelst": "MN",
    "dropdelzpp": 567329998,
    "dropphyadd": "107 MAIN ST S",
    "dropphycty": "KARLSTAD",
    "dropphyst": "MN",
    "dropphyzpp": 567329998,
    "dropmaladd": "107 MAIN ST S",
    "dropmalcty": "KARLSTAD",
    "dropmalst": "MN",
    "dropmalzpp": 567329998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184362176,
    "dropsitcph": 2184362176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25565",
    "droptype": "D",
    "dropname": "KASOTA",
    "dropdeladd": "140 CHERRY ST W",
    "dropdelcty": "KASOTA",
    "dropdelst": "MN",
    "dropdelzpp": 560502052,
    "dropphyadd": "140 CHERRY ST W",
    "dropphycty": "KASOTA",
    "dropphyst": "MN",
    "dropphyzpp": 560502052,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KASOTA",
    "dropmalst": "MN",
    "dropmalzpp": 560509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079315720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25566",
    "droptype": "D",
    "dropname": "KASSON",
    "dropdeladd": "14 E VETERANS MEMORIAL HWY",
    "dropdelcty": "KASSON",
    "dropdelst": "MN",
    "dropdelzpp": 559441202,
    "dropphyadd": "14 E VETERANS MEMORIAL HWY",
    "dropphycty": "KASSON",
    "dropphyst": "MN",
    "dropphyzpp": 559441202,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KASSON",
    "dropmalst": "MN",
    "dropmalzpp": 559449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076342421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25567",
    "droptype": "D",
    "dropname": "KEEWATIN",
    "dropdeladd": "123 3RD AVE",
    "dropdelcty": "KEEWATIN",
    "dropdelst": "MN",
    "dropdelzpp": 557535000,
    "dropphyadd": "123 3RD AVE",
    "dropphycty": "KEEWATIN",
    "dropphyst": "MN",
    "dropphyzpp": 557535000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEEWATIN",
    "dropmalst": "MN",
    "dropmalzpp": 557539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187786122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25569",
    "droptype": "D",
    "dropname": "KELLIHER",
    "dropdeladd": "162 E MAIN ST",
    "dropdelcty": "KELLIHER",
    "dropdelst": "MN",
    "dropdelzpp": 566502001,
    "dropphyadd": "162 E MAIN ST",
    "dropphycty": "KELLIHER",
    "dropphyst": "MN",
    "dropphyzpp": 566502001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLIHER",
    "dropmalst": "MN",
    "dropmalzpp": 566509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186478441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25570",
    "droptype": "D",
    "dropname": "KELLOGG",
    "dropdeladd": "345 E BELVIDERE AVE",
    "dropdelcty": "KELLOGG",
    "dropdelst": "MN",
    "dropdelzpp": 559459625,
    "dropphyadd": "345 E BELVIDERE AVE",
    "dropphycty": "KELLOGG",
    "dropphyst": "MN",
    "dropphyzpp": 559459625,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KELLOGG",
    "dropmalst": "MN",
    "dropmalzpp": 559459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077674993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25575",
    "droptype": "D",
    "dropname": "KENNEDY",
    "dropdeladd": "510 ATLANTIC AVE",
    "dropdelcty": "KENNEDY",
    "dropdelst": "MN",
    "dropdelzpp": 567339998,
    "dropphyadd": "510 ATLANTIC AVE",
    "dropphycty": "KENNEDY",
    "dropphyst": "MN",
    "dropphyzpp": 567339998,
    "dropmaladd": "510 ATLANTIC AVE",
    "dropmalcty": "KENNEDY",
    "dropmalst": "MN",
    "dropmalzpp": 567339998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186744149,
    "dropsitcph": 2186744149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25578",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "17 CENTRAL AVE N",
    "dropdelcty": "KENSINGTON",
    "dropdelst": "MN",
    "dropdelzpp": 563434400,
    "dropphyadd": "17 CENTRAL AVE N",
    "dropphycty": "KENSINGTON",
    "dropphyst": "MN",
    "dropphyzpp": 563434400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENSINGTON",
    "dropmalst": "MN",
    "dropmalzpp": 563439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3209652765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25579",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "216 MAIN ST",
    "dropdelcty": "KENT",
    "dropdelst": "MN",
    "dropdelzpp": 565539998,
    "dropphyadd": "216 MAIN ST",
    "dropphycty": "KENT",
    "dropphyst": "MN",
    "dropphyzpp": 565539998,
    "dropmaladd": "216 MAIN ST",
    "dropmalcty": "KENT",
    "dropmalst": "MN",
    "dropmalzpp": 565539998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185578713,
    "dropsitcph": 2182280841,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25580",
    "droptype": "D",
    "dropname": "KENYON",
    "dropdeladd": "529 2ND ST",
    "dropdelcty": "KENYON",
    "dropdelst": "MN",
    "dropdelzpp": 559461150,
    "dropphyadd": "529 2ND ST",
    "dropphycty": "KENYON",
    "dropphyst": "MN",
    "dropphyzpp": 559461150,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KENYON",
    "dropmalst": "MN",
    "dropmalzpp": 559469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077896163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25581",
    "droptype": "D",
    "dropname": "KERKHOVEN",
    "dropdeladd": "903 ATLANTIC AVE",
    "dropdelcty": "KERKHOVEN",
    "dropdelst": "MN",
    "dropdelzpp": 562525000,
    "dropphyadd": "903 ATLANTIC AVE",
    "dropphycty": "KERKHOVEN",
    "dropphyst": "MN",
    "dropphyzpp": 562525000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KERKHOVEN",
    "dropmalst": "MN",
    "dropmalzpp": 562529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202648421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25582",
    "droptype": "D",
    "dropname": "KERRICK",
    "dropdeladd": "8384 MAIN ST",
    "dropdelcty": "KERRICK",
    "dropdelst": "MN",
    "dropdelzpp": 557565050,
    "dropphyadd": "8384 MAIN ST",
    "dropphycty": "KERRICK",
    "dropphyst": "MN",
    "dropphyzpp": 557565050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KERRICK",
    "dropmalst": "MN",
    "dropmalzpp": 557569998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184965591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25584",
    "droptype": "D",
    "dropname": "KETTLE RIVER",
    "dropdeladd": "3970 MAIN ST",
    "dropdelcty": "KETTLE RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 557578647,
    "dropphyadd": "3970 MAIN ST",
    "dropphycty": "KETTLE RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 557578647,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KETTLE RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 557579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182734952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25585",
    "droptype": "D",
    "dropname": "KIESTER",
    "dropdeladd": "100 N MAIN ST",
    "dropdelcty": "KIESTER",
    "dropdelst": "MN",
    "dropdelzpp": 560514401,
    "dropphyadd": "100 N MAIN ST",
    "dropphycty": "KIESTER",
    "dropphyst": "MN",
    "dropphyzpp": 560514401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIESTER",
    "dropmalst": "MN",
    "dropmalzpp": 560519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072943707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25586",
    "droptype": "D",
    "dropname": "KILKENNY",
    "dropdeladd": "156 S LAUREL AVE",
    "dropdelcty": "KILKENNY",
    "dropdelst": "MN",
    "dropdelzpp": 560524401,
    "dropphyadd": "156 S LAUREL AVE",
    "dropphycty": "KILKENNY",
    "dropphyst": "MN",
    "dropphyzpp": 560524401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KILKENNY",
    "dropmalst": "MN",
    "dropmalzpp": 560529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075952700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25587",
    "droptype": "D",
    "dropname": "KIMBALL",
    "dropdeladd": "40 S MAIN ST",
    "dropdelcty": "KIMBALL",
    "dropdelst": "MN",
    "dropdelzpp": 553535303,
    "dropphyadd": "40 S MAIN ST",
    "dropphycty": "KIMBALL",
    "dropphyst": "MN",
    "dropphyzpp": 553535303,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIMBALL",
    "dropmalst": "MN",
    "dropmalzpp": 553539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203982375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25596",
    "droptype": "D",
    "dropname": "KNIFE RIVER",
    "dropdeladd": "200 CENTRAL AVE",
    "dropdelcty": "KNIFE RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 556094400,
    "dropphyadd": "200 CENTRAL AVE",
    "dropphycty": "KNIFE RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 556094400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KNIFE RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 556099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188343433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25599",
    "droptype": "D",
    "dropname": "LA CRESCENT",
    "dropdeladd": "230 MAIN ST",
    "dropdelcty": "LA CRESCENT",
    "dropdelst": "MN",
    "dropdelzpp": 559471181,
    "dropphyadd": "230 MAIN ST",
    "dropphycty": "LA CRESCENT",
    "dropphyst": "MN",
    "dropphyzpp": 559471181,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA CRESCENT",
    "dropmalst": "MN",
    "dropmalzpp": 559479998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078952233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25601",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "104 S BROADWAY",
    "dropdelcty": "LA SALLE",
    "dropdelst": "MN",
    "dropdelzpp": 560564400,
    "dropphyadd": "104 S BROADWAY",
    "dropphycty": "LA SALLE",
    "dropphyst": "MN",
    "dropphyzpp": 560564400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA SALLE",
    "dropmalst": "MN",
    "dropmalzpp": 560569998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073755858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25602",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "790 MAIN AVE",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "MN",
    "dropdelzpp": 560544401,
    "dropphyadd": "790 MAIN AVE",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "MN",
    "dropphyzpp": 560544401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "MN",
    "dropmalzpp": 560549998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072288252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25603",
    "droptype": "D",
    "dropname": "LAKE BENTON",
    "dropdeladd": "126 E BENTON ST",
    "dropdelcty": "LAKE BENTON",
    "dropdelst": "MN",
    "dropdelzpp": 561491309,
    "dropphyadd": "126 E BENTON ST",
    "dropphycty": "LAKE BENTON",
    "dropphyst": "MN",
    "dropphyzpp": 561491309,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE BENTON",
    "dropmalst": "MN",
    "dropmalzpp": 561499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073684229,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25604",
    "droptype": "D",
    "dropname": "LAKE BRONSON",
    "dropdeladd": "101 N 1ST AVE",
    "dropdelcty": "LAKE BRONSON",
    "dropdelst": "MN",
    "dropdelzpp": 567349998,
    "dropphyadd": "101 N 1ST AVE",
    "dropphycty": "LAKE BRONSON",
    "dropphyst": "MN",
    "dropphyzpp": 567349998,
    "dropmaladd": "101 N 1ST AVE",
    "dropmalcty": "LAKE BRONSON",
    "dropmalst": "MN",
    "dropmalzpp": 567349998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187542255,
    "dropsitcph": 2187542255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25605",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "111 S HIGH ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550411637,
    "dropphyadd": "111 S HIGH ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550411637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "MN",
    "dropmalzpp": 550419998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6513453760,
    "dropfax": 6513453760
  },
  {
    "dcode": "D",
    "dropkey": "PY25606",
    "droptype": "D",
    "dropname": "LAKE CRYSTAL",
    "dropdeladd": "201 S MAIN ST",
    "dropdelcty": "LAKE CRYSTAL",
    "dropdelst": "MN",
    "dropdelzpp": 560554593,
    "dropphyadd": "201 S MAIN ST",
    "dropphycty": "LAKE CRYSTAL",
    "dropphyst": "MN",
    "dropphyzpp": 560554593,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE CRYSTAL",
    "dropmalst": "MN",
    "dropmalzpp": 560559998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077262458,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25610",
    "droptype": "D",
    "dropname": "LAKE ELMO",
    "dropdeladd": "3469 LAKE ELMO AVE N",
    "dropdelcty": "LAKE ELMO",
    "dropdelst": "MN",
    "dropdelzpp": 550429429,
    "dropphyadd": "3469 LAKE ELMO AVE N",
    "dropphycty": "LAKE ELMO",
    "dropphyst": "MN",
    "dropphyzpp": 550429429,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE ELMO",
    "dropmalst": "MN",
    "dropmalzpp": 550429998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6517770219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25612",
    "droptype": "D",
    "dropname": "LAKE GEORGE",
    "dropdeladd": "37307 COUNTY 4",
    "dropdelcty": "LAKE GEORGE",
    "dropdelst": "MN",
    "dropdelzpp": 564584044,
    "dropphyadd": "37307 COUNTY 4",
    "dropphycty": "LAKE GEORGE",
    "dropphyst": "MN",
    "dropphyzpp": 564584044,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE GEORGE",
    "dropmalst": "MN",
    "dropmalzpp": 564589998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182663389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25615",
    "droptype": "D",
    "dropname": "LAKE LILLIAN",
    "dropdeladd": "454 LAKEVIEW ST",
    "dropdelcty": "LAKE LILLIAN",
    "dropdelst": "MN",
    "dropdelzpp": 562539525,
    "dropphyadd": "454 LAKEVIEW ST",
    "dropphycty": "LAKE LILLIAN",
    "dropphyst": "MN",
    "dropphyzpp": 562539525,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE LILLIAN",
    "dropmalst": "MN",
    "dropmalzpp": 562539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206644890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25617",
    "droptype": "D",
    "dropname": "LAKE PARK",
    "dropdeladd": "2035 2ND ST",
    "dropdelcty": "LAKE PARK",
    "dropdelst": "MN",
    "dropdelzpp": 565549998,
    "dropphyadd": "2035 2ND ST",
    "dropphycty": "LAKE PARK",
    "dropphyst": "MN",
    "dropphyzpp": 565549998,
    "dropmaladd": "2035 2ND ST",
    "dropmalcty": "LAKE PARK",
    "dropmalst": "MN",
    "dropmalzpp": 565549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182385747,
    "dropsitcph": 2182385747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25621",
    "droptype": "D",
    "dropname": "LAKE WILSON",
    "dropdeladd": "137 BROADWAY AVE",
    "dropdelcty": "LAKE WILSON",
    "dropdelst": "MN",
    "dropdelzpp": 561519615,
    "dropphyadd": "137 BROADWAY AVE",
    "dropphycty": "LAKE WILSON",
    "dropphyst": "MN",
    "dropphyzpp": 561519615,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE WILSON",
    "dropmalst": "MN",
    "dropmalzpp": 561519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078793469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25622",
    "droptype": "D",
    "dropname": "LAKEFIELD",
    "dropdeladd": "319 MAIN ST",
    "dropdelcty": "LAKEFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 561504504,
    "dropphyadd": "319 MAIN ST",
    "dropphycty": "LAKEFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 561504504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 561509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076625571,
    "dropfax": 5076626605
  },
  {
    "dcode": "D",
    "dropkey": "PY25623",
    "droptype": "D",
    "dropname": "LAKELAND",
    "dropdeladd": "396 SAINT CROIX TRL S",
    "dropdelcty": "LAKELAND",
    "dropdelst": "MN",
    "dropdelzpp": 550439729,
    "dropphyadd": "396 SAINT CROIX TRL S",
    "dropphycty": "LAKELAND",
    "dropphyst": "MN",
    "dropphyzpp": 550439729,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKELAND",
    "dropmalst": "MN",
    "dropmalzpp": 550439998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514365469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25627",
    "droptype": "D",
    "dropname": "LAKEVILLE",
    "dropdeladd": "20711 HOLT AVE",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 550449804,
    "dropphyadd": "20711 HOLT AVE",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 550449804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 550449998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6124693089,
    "dropsitcph": 9524691463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25631",
    "droptype": "D",
    "dropname": "LAMBERTON",
    "dropdeladd": "207 S MAIN ST",
    "dropdelcty": "LAMBERTON",
    "dropdelst": "MN",
    "dropdelzpp": 561521376,
    "dropphyadd": "207 S MAIN ST",
    "dropphycty": "LAMBERTON",
    "dropphyst": "MN",
    "dropphyzpp": 561521376,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAMBERTON",
    "dropmalst": "MN",
    "dropmalzpp": 561529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077527394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25634",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "113 CENTRAL AVE S",
    "dropdelcty": "LANCASTER",
    "dropdelst": "MN",
    "dropdelzpp": 567359998,
    "dropphyadd": "113 CENTRAL AVE S",
    "dropphycty": "LANCASTER",
    "dropphyst": "MN",
    "dropphyzpp": 567359998,
    "dropmaladd": "113 CENTRAL AVE S",
    "dropmalcty": "LANCASTER",
    "dropmalst": "MN",
    "dropmalzpp": 567359998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187625100,
    "dropsitcph": 2187625100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25637",
    "droptype": "D",
    "dropname": "LANESBORO",
    "dropdeladd": "114 COFFEE ST",
    "dropdelcty": "LANESBORO",
    "dropdelst": "MN",
    "dropdelzpp": 559498702,
    "dropphyadd": "114 COFFEE ST",
    "dropphycty": "LANESBORO",
    "dropphyst": "MN",
    "dropphyzpp": 559498702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANESBORO",
    "dropmalst": "MN",
    "dropmalzpp": 559499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072685226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25639",
    "droptype": "D",
    "dropname": "LANSING",
    "dropdeladd": "54016 270TH ST",
    "dropdelcty": "LANSING",
    "dropdelst": "MN",
    "dropdelzpp": 559506500,
    "dropphyadd": "54016 270TH ST",
    "dropphycty": "LANSING",
    "dropphyst": "MN",
    "dropphyzpp": 559506500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANSING",
    "dropmalst": "MN",
    "dropmalzpp": 559509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074336157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25641",
    "droptype": "D",
    "dropname": "LAPORTE",
    "dropdeladd": "80 MAIN ST E",
    "dropdelcty": "LAPORTE",
    "dropdelst": "MN",
    "dropdelzpp": 564614500,
    "dropphyadd": "80 MAIN ST E",
    "dropphycty": "LAPORTE",
    "dropphyst": "MN",
    "dropphyzpp": 564614500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAPORTE",
    "dropmalst": "MN",
    "dropmalzpp": 564619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182242462,
    "dropfax": 2182242462
  },
  {
    "dcode": "D",
    "dropkey": "PY25648",
    "droptype": "D",
    "dropname": "LE CENTER",
    "dropdeladd": "91 N PARK AVE",
    "dropdelcty": "LE CENTER",
    "dropdelst": "MN",
    "dropdelzpp": 560571510,
    "dropphyadd": "91 N PARK AVE",
    "dropphycty": "LE CENTER",
    "dropphyst": "MN",
    "dropphyzpp": 560571510,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LE CENTER",
    "dropmalst": "MN",
    "dropmalzpp": 560579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073574979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25649",
    "droptype": "D",
    "dropname": "LE ROY",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "LE ROY",
    "dropdelst": "MN",
    "dropdelzpp": 559512815,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "LE ROY",
    "dropphyst": "MN",
    "dropphyzpp": 559512815,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LE ROY",
    "dropmalst": "MN",
    "dropmalzpp": 559519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072032101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25650",
    "droptype": "D",
    "dropname": "LE SUEUR",
    "dropdeladd": "202 N MAIN ST",
    "dropdelcty": "LE SUEUR",
    "dropdelst": "MN",
    "dropdelzpp": 560581805,
    "dropphyadd": "202 N MAIN ST",
    "dropphycty": "LE SUEUR",
    "dropphyst": "MN",
    "dropphyzpp": 560581805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LE SUEUR",
    "dropmalst": "MN",
    "dropmalzpp": 560589998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076653194,
    "dropfax": 5076652162
  },
  {
    "dcode": "D",
    "dropkey": "PY25657",
    "droptype": "D",
    "dropname": "LENGBY",
    "dropdeladd": "102 MAIN AVE",
    "dropdelcty": "LENGBY",
    "dropdelst": "MN",
    "dropdelzpp": 566512009,
    "dropphyadd": "102 MAIN AVE",
    "dropphycty": "LENGBY",
    "dropphyst": "MN",
    "dropphyzpp": 566512009,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LENGBY",
    "dropmalst": "MN",
    "dropmalzpp": 566519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186682602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25662",
    "droptype": "D",
    "dropname": "LEOTA",
    "dropdeladd": "11815 110TH ST",
    "dropdelcty": "LEOTA",
    "dropdelst": "MN",
    "dropdelzpp": 561532000,
    "dropphyadd": "11815 110TH ST",
    "dropphycty": "LEOTA",
    "dropphyst": "MN",
    "dropphyzpp": 561532000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEOTA",
    "dropmalst": "MN",
    "dropmalzpp": 561539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074435060,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25664",
    "droptype": "D",
    "dropname": "LESTER PRAIRIE",
    "dropdeladd": "38 JUNIPER ST N",
    "dropdelcty": "LESTER PRAIRIE",
    "dropdelst": "MN",
    "dropdelzpp": 553541008,
    "dropphyadd": "38 JUNIPER ST N",
    "dropphycty": "LESTER PRAIRIE",
    "dropphyst": "MN",
    "dropphyzpp": 553541008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LESTER PRAIRIE",
    "dropmalst": "MN",
    "dropmalzpp": 553549998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203952311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25667",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "675 E MAIN ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "MN",
    "dropdelzpp": 559521491,
    "dropphyadd": "675 E MAIN ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "MN",
    "dropphyzpp": 559521491,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISTON",
    "dropmalst": "MN",
    "dropmalzpp": 559529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075232246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25668",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "225 LEWIS ST W",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 560604401,
    "dropphyadd": "225 LEWIS ST W",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 560604401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 560609998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074352091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25678",
    "droptype": "D",
    "dropname": "LINDSTROM",
    "dropdeladd": "12760 N 1ST AVE",
    "dropdelcty": "LINDSTROM",
    "dropdelst": "MN",
    "dropdelzpp": 550459585,
    "dropphyadd": "12760 N 1ST AVE",
    "dropphycty": "LINDSTROM",
    "dropphyst": "MN",
    "dropphyzpp": 550459585,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINDSTROM",
    "dropmalst": "MN",
    "dropmalzpp": 550459998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6512575169,
    "dropfax": 6512578262
  },
  {
    "dcode": "D",
    "dropkey": "PY25684",
    "droptype": "D",
    "dropname": "LISMORE",
    "dropdeladd": "173 S 3RD AVE",
    "dropdelcty": "LISMORE",
    "dropdelst": "MN",
    "dropdelzpp": 561551106,
    "dropphyadd": "173 S 3RD AVE",
    "dropphycty": "LISMORE",
    "dropphyst": "MN",
    "dropphyzpp": 561551106,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LISMORE",
    "dropmalst": "MN",
    "dropmalzpp": 561559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074728279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25685",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "35 E 2ND ST",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 553552101,
    "dropphyadd": "35 E 2ND ST",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 553552101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 553559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206936252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25689",
    "droptype": "D",
    "dropname": "LITTLE FALLS",
    "dropdeladd": "27 E BROADWAY",
    "dropdelcty": "LITTLE FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 563453034,
    "dropphyadd": "27 E BROADWAY",
    "dropphycty": "LITTLE FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 563453034,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 563459998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 3206328836,
    "dropfax": 3206323428
  },
  {
    "dcode": "D",
    "dropkey": "PY25694",
    "droptype": "D",
    "dropname": "LITTLEFORK",
    "dropdeladd": "716 3RD AVE",
    "dropdelcty": "LITTLEFORK",
    "dropdelst": "MN",
    "dropdelzpp": 566532001,
    "dropphyadd": "716 3RD AVE",
    "dropphycty": "LITTLEFORK",
    "dropphyst": "MN",
    "dropphyzpp": 566532001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLEFORK",
    "dropmalst": "MN",
    "dropmalzpp": 566539998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182783006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25707",
    "droptype": "D",
    "dropname": "LOMAN",
    "dropdeladd": "7678 HIGHWAY 11 S",
    "dropdelcty": "LOMAN",
    "dropdelst": "MN",
    "dropdelzpp": 566548017,
    "dropphyadd": "7678 HIGHWAY 11 S",
    "dropphycty": "LOMAN",
    "dropphyst": "MN",
    "dropphyzpp": 566548017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOMAN",
    "dropmalst": "MN",
    "dropmalzpp": 566549998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182853465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25710",
    "droptype": "D",
    "dropname": "LONG LAKE",
    "dropdeladd": "2095 DANIELS ST",
    "dropdelcty": "LONG LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553569911,
    "dropphyadd": "2095 DANIELS ST",
    "dropphycty": "LONG LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553569911,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 9524733329,
    "dropsitcph": 9524756810,
    "dropfax": 9524730193
  },
  {
    "dcode": "D",
    "dropkey": "PY25714",
    "droptype": "D",
    "dropname": "LONG PRAIRIE",
    "dropdeladd": "350 CENTRAL AVE",
    "dropdelcty": "LONG PRAIRIE",
    "dropdelst": "MN",
    "dropdelzpp": 563471304,
    "dropphyadd": "350 CENTRAL AVE",
    "dropphycty": "LONG PRAIRIE",
    "dropphyst": "MN",
    "dropphyzpp": 563471304,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONG PRAIRIE",
    "dropmalst": "MN",
    "dropmalzpp": 563479998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207323222,
    "dropfax": 3207324063
  },
  {
    "dcode": "D",
    "dropkey": "PY25715",
    "droptype": "D",
    "dropname": "LONGVILLE",
    "dropdeladd": "1462 COUNTY ROAD 5",
    "dropdelcty": "LONGVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 566553002,
    "dropphyadd": "1462 COUNTY ROAD 5",
    "dropphycty": "LONGVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 566553002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONGVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 566559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183632852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25718",
    "droptype": "D",
    "dropname": "LONSDALE",
    "dropdeladd": "108 RAILWAY ST NW",
    "dropdelcty": "LONSDALE",
    "dropdelst": "MN",
    "dropdelzpp": 550464370,
    "dropphyadd": "108 RAILWAY ST NW",
    "dropphycty": "LONSDALE",
    "dropphyst": "MN",
    "dropphyzpp": 550464370,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONSDALE",
    "dropmalst": "MN",
    "dropmalzpp": 550469998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077442825,
    "dropfax": 5077445578
  },
  {
    "dcode": "D",
    "dropkey": "PY25721",
    "droptype": "D",
    "dropname": "LORETTO",
    "dropdeladd": "99 N MEDINA ST",
    "dropdelcty": "LORETTO",
    "dropdelst": "MN",
    "dropdelzpp": 553579542,
    "dropphyadd": "99 N MEDINA ST",
    "dropphycty": "LORETTO",
    "dropphyst": "MN",
    "dropphyzpp": 553579542,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LORETTO",
    "dropmalst": "MN",
    "dropmalzpp": 553579998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634792656,
    "dropfax": 7634791986
  },
  {
    "dcode": "D",
    "dropkey": "PY25725",
    "droptype": "D",
    "dropname": "LOWRY",
    "dropdeladd": "421 FLORENCE AVE",
    "dropdelcty": "LOWRY",
    "dropdelst": "MN",
    "dropdelzpp": 563494400,
    "dropphyadd": "421 FLORENCE AVE",
    "dropphycty": "LOWRY",
    "dropphyst": "MN",
    "dropphyzpp": 563494400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWRY",
    "dropmalst": "MN",
    "dropmalzpp": 563499998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2185216729,
    "dropsitcph": 3202835275,
    "dropfax": 3202835275
  },
  {
    "dcode": "D",
    "dropkey": "PY25727",
    "droptype": "D",
    "dropname": "LUCAN",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "LUCAN",
    "dropdelst": "MN",
    "dropdelzpp": 562555000,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "LUCAN",
    "dropphyst": "MN",
    "dropphyzpp": 562555000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCAN",
    "dropmalst": "MN",
    "dropmalzpp": 562559998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077472247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25731",
    "droptype": "D",
    "dropname": "LUTSEN",
    "dropdeladd": "5321 W HIGHWAY 61",
    "dropdelcty": "LUTSEN",
    "dropdelst": "MN",
    "dropdelzpp": 556129513,
    "dropphyadd": "5321 W HIGHWAY 61",
    "dropphycty": "LUTSEN",
    "dropphyst": "MN",
    "dropphyzpp": 556129513,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUTSEN",
    "dropmalst": "MN",
    "dropmalzpp": 556129998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186637323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25732",
    "droptype": "D",
    "dropname": "LUVERNE",
    "dropdeladd": "407 E LINCOLN ST",
    "dropdelcty": "LUVERNE",
    "dropdelst": "MN",
    "dropdelzpp": 561561606,
    "dropphyadd": "407 E LINCOLN ST",
    "dropphycty": "LUVERNE",
    "dropphyst": "MN",
    "dropphyzpp": 561561606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUVERNE",
    "dropmalst": "MN",
    "dropmalzpp": 561569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072832186,
    "dropfax": 5072834952
  },
  {
    "dcode": "D",
    "dropkey": "PY25733",
    "droptype": "D",
    "dropname": "LYLE",
    "dropdeladd": "106 GROVE ST",
    "dropdelcty": "LYLE",
    "dropdelst": "MN",
    "dropdelzpp": 559539728,
    "dropphyadd": "106 GROVE ST",
    "dropphycty": "LYLE",
    "dropphyst": "MN",
    "dropphyzpp": 559539728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYLE",
    "dropmalst": "MN",
    "dropmalzpp": 559539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072031902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25734",
    "droptype": "D",
    "dropname": "LYND",
    "dropdeladd": "113 W RAILROAD ST",
    "dropdelcty": "LYND",
    "dropdelst": "MN",
    "dropdelzpp": 561579700,
    "dropphyadd": "113 W RAILROAD ST",
    "dropphycty": "LYND",
    "dropphyst": "MN",
    "dropphyzpp": 561579700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYND",
    "dropmalst": "MN",
    "dropmalzpp": 561579998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078654523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25736",
    "droptype": "D",
    "dropname": "MABEL",
    "dropdeladd": "106 MAIN ST S",
    "dropdelcty": "MABEL",
    "dropdelst": "MN",
    "dropdelzpp": 559549754,
    "dropphyadd": "106 MAIN ST S",
    "dropphycty": "MABEL",
    "dropphyst": "MN",
    "dropphyzpp": 559549754,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MABEL",
    "dropmalst": "MN",
    "dropmalzpp": 559549998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072685217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25739",
    "droptype": "D",
    "dropname": "MADELIA",
    "dropdeladd": "23 CENTER AVE N",
    "dropdelcty": "MADELIA",
    "dropdelst": "MN",
    "dropdelzpp": 560621427,
    "dropphyadd": "23 CENTER AVE N",
    "dropphycty": "MADELIA",
    "dropphyst": "MN",
    "dropphyzpp": 560621427,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADELIA",
    "dropmalst": "MN",
    "dropmalzpp": 560629998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076423325,
    "dropfax": 5076428716
  },
  {
    "dcode": "D",
    "dropkey": "PY25740",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "711 1ST ST W",
    "dropdelcty": "MADISON",
    "dropdelst": "MN",
    "dropdelzpp": 562561334,
    "dropphyadd": "711 1ST ST W",
    "dropphycty": "MADISON",
    "dropphyst": "MN",
    "dropphyzpp": 562561334,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADISON",
    "dropmalst": "MN",
    "dropmalzpp": 562569998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205987478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25742",
    "droptype": "D",
    "dropname": "MADISON LAKE",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "MADISON LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 560634501,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "MADISON LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 560634501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADISON LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 560639998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072433012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25745",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "113 W LUVERNE ST",
    "dropdelcty": "MAGNOLIA",
    "dropdelst": "MN",
    "dropdelzpp": 561582000,
    "dropphyadd": "113 W LUVERNE ST",
    "dropphycty": "MAGNOLIA",
    "dropphyst": "MN",
    "dropphyzpp": 561582000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGNOLIA",
    "dropmalst": "MN",
    "dropmalzpp": 561589998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072834881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25746",
    "droptype": "D",
    "dropname": "MAHNOMEN",
    "dropdeladd": "123 W ADAMS AVE",
    "dropdelcty": "MAHNOMEN",
    "dropdelst": "MN",
    "dropdelzpp": 565579998,
    "dropphyadd": "123 W ADAMS AVE",
    "dropphycty": "MAHNOMEN",
    "dropphyst": "MN",
    "dropphyzpp": 565579998,
    "dropmaladd": "123 W ADAMS AVE",
    "dropmalcty": "MAHNOMEN",
    "dropmalst": "MN",
    "dropmalzpp": 565579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189355591,
    "dropsitcph": 2189355591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25750",
    "droptype": "D",
    "dropname": "MAKINEN",
    "dropdeladd": "6663 WILSON RD",
    "dropdelcty": "MAKINEN",
    "dropdelst": "MN",
    "dropdelzpp": 557638136,
    "dropphyadd": "6663 WILSON RD",
    "dropphycty": "MAKINEN",
    "dropphyst": "MN",
    "dropphyzpp": 557638136,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAKINEN",
    "dropmalst": "MN",
    "dropmalzpp": 557639998,
    "dropsitphn": 6123499163,
    "dropsitlph": 2187441725,
    "dropsitcph": 2187441725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25759",
    "droptype": "D",
    "dropname": "MANKATO",
    "dropdeladd": "220 E MAIN ST STE 100",
    "dropdelcty": "MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560013515,
    "dropphyadd": "220 E MAIN ST STE 100",
    "dropphycty": "MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560013515,
    "dropmaladd": "220 E MAIN ST STE 100",
    "dropmalcty": "MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560013515,
    "dropsitphn": 6123496346,
    "dropsitlph": 5073442232,
    "dropsitcph": 5073442232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25760",
    "droptype": "D",
    "dropname": "MANTORVILLE",
    "dropdeladd": "21 5TH ST W",
    "dropdelcty": "MANTORVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 559558091,
    "dropphyadd": "21 5TH ST W",
    "dropphycty": "MANTORVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 559558091,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANTORVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 559559998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076355805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25768",
    "droptype": "D",
    "dropname": "MAPLE LAKE",
    "dropdeladd": "101 BIRCH AVE S",
    "dropdelcty": "MAPLE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553582537,
    "dropphyadd": "101 BIRCH AVE S",
    "dropphycty": "MAPLE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553582537,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553589998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 3209633914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25770",
    "droptype": "D",
    "dropname": "MAPLE PLAIN",
    "dropdeladd": "5179 MAIN ST E",
    "dropdelcty": "MAPLE PLAIN",
    "dropdelst": "MN",
    "dropdelzpp": 553599391,
    "dropphyadd": "5179 MAIN ST E",
    "dropphycty": "MAPLE PLAIN",
    "dropphyst": "MN",
    "dropphyzpp": 553599391,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE PLAIN",
    "dropmalst": "MN",
    "dropmalzpp": 553599998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634791514,
    "dropfax": 7634792844
  },
  {
    "dcode": "D",
    "dropkey": "PY25773",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "315 MAIN ST E",
    "dropdelcty": "MAPLETON",
    "dropdelst": "MN",
    "dropdelzpp": 560654402,
    "dropphyadd": "315 MAIN ST E",
    "dropphycty": "MAPLETON",
    "dropphyst": "MN",
    "dropphyzpp": 560654402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLETON",
    "dropmalst": "MN",
    "dropmalzpp": 560659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075243688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25775",
    "droptype": "D",
    "dropname": "MARBLE",
    "dropdeladd": "109 ALICE AVE",
    "dropdelcty": "MARBLE",
    "dropdelst": "MN",
    "dropdelzpp": 557645000,
    "dropphyadd": "109 ALICE AVE",
    "dropphycty": "MARBLE",
    "dropphyst": "MN",
    "dropphyzpp": 557645000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARBLE",
    "dropmalst": "MN",
    "dropmalzpp": 557649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182477986,
    "dropfax": 2182477986
  },
  {
    "dcode": "D",
    "dropkey": "PY25776",
    "droptype": "D",
    "dropname": "MARCELL",
    "dropdeladd": "39370 STATE HIGHWAY 286",
    "dropdelcty": "MARCELL",
    "dropdelst": "MN",
    "dropdelzpp": 566572253,
    "dropphyadd": "39370 STATE HIGHWAY 286",
    "dropphycty": "MARCELL",
    "dropphyst": "MN",
    "dropphyzpp": 566572253,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARCELL",
    "dropmalst": "MN",
    "dropmalzpp": 566579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188323889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25778",
    "droptype": "D",
    "dropname": "MARIETTA",
    "dropdeladd": "200 3RD AVE N",
    "dropdelcty": "MARIETTA",
    "dropdelst": "MN",
    "dropdelzpp": 562575000,
    "dropphyadd": "200 3RD AVE N",
    "dropphycty": "MARIETTA",
    "dropphyst": "MN",
    "dropphyzpp": 562575000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARIETTA",
    "dropmalst": "MN",
    "dropmalzpp": 562579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206682542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25781",
    "droptype": "D",
    "dropname": "MARINE ON SAINT CROIX",
    "dropdeladd": "11 JUDD ST",
    "dropdelcty": "MARINE ON SAINT CROIX",
    "dropdelst": "MN",
    "dropdelzpp": 550478657,
    "dropphyadd": "11 JUDD ST",
    "dropphycty": "MARINE ON SAINT CROIX",
    "dropphyst": "MN",
    "dropphyzpp": 550478657,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARINE ON SAINT CROIX",
    "dropmalst": "MN",
    "dropmalzpp": 550479998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514335190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25787",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "302 W LYON ST",
    "dropdelcty": "MARSHALL",
    "dropdelst": "MN",
    "dropdelzpp": 562581308,
    "dropphyadd": "302 W LYON ST",
    "dropphycty": "MARSHALL",
    "dropphyst": "MN",
    "dropphyzpp": 562581308,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHALL",
    "dropmalst": "MN",
    "dropmalzpp": 562589998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075324937,
    "dropfax": 5075326006
  },
  {
    "dcode": "D",
    "dropkey": "PY25793",
    "droptype": "D",
    "dropname": "MAYER",
    "dropdeladd": "117 ASH AVE N",
    "dropdelcty": "MAYER",
    "dropdelst": "MN",
    "dropdelzpp": 553609692,
    "dropphyadd": "117 ASH AVE N",
    "dropphycty": "MAYER",
    "dropphyst": "MN",
    "dropphyzpp": 553609692,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYER",
    "dropmalst": "MN",
    "dropmalzpp": 553609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9522131448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25794",
    "droptype": "D",
    "dropname": "MAYNARD",
    "dropdeladd": "350 SPICER AVE",
    "dropdelcty": "MAYNARD",
    "dropdelst": "MN",
    "dropdelzpp": 562605000,
    "dropphyadd": "350 SPICER AVE",
    "dropphycty": "MAYNARD",
    "dropphyst": "MN",
    "dropphyzpp": 562605000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYNARD",
    "dropmalst": "MN",
    "dropmalzpp": 562609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203672166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25796",
    "droptype": "D",
    "dropname": "MAZEPPA",
    "dropdeladd": "220 1ST AVE N",
    "dropdelcty": "MAZEPPA",
    "dropdelst": "MN",
    "dropdelzpp": 559563028,
    "dropphyadd": "220 1ST AVE N",
    "dropphycty": "MAZEPPA",
    "dropphyst": "MN",
    "dropphyzpp": 559563028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAZEPPA",
    "dropmalst": "MN",
    "dropmalzpp": 559569998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078433005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25797",
    "droptype": "D",
    "dropname": "MC GRATH",
    "dropdeladd": "300 MAIN ST W",
    "dropdelcty": "MC GRATH",
    "dropdelst": "MN",
    "dropdelzpp": 563504400,
    "dropphyadd": "300 MAIN ST W",
    "dropphycty": "MC GRATH",
    "dropphyst": "MN",
    "dropphyzpp": 563504400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GRATH",
    "dropmalst": "MN",
    "dropmalzpp": 563509998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205923055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25798",
    "droptype": "D",
    "dropname": "MCGREGOR",
    "dropdeladd": "26 N MADDY ST",
    "dropdelcty": "MCGREGOR",
    "dropdelst": "MN",
    "dropdelzpp": 557605007,
    "dropphyadd": "26 N MADDY ST",
    "dropphycty": "MCGREGOR",
    "dropphyst": "MN",
    "dropphyzpp": 557605007,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCGREGOR",
    "dropmalst": "MN",
    "dropmalzpp": 557609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187682991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25801",
    "droptype": "D",
    "dropname": "MCINTOSH",
    "dropdeladd": "285 CLEVELAND AVE SW",
    "dropdelcty": "MCINTOSH",
    "dropdelst": "MN",
    "dropdelzpp": 565569998,
    "dropphyadd": "285 CLEVELAND AVE SW",
    "dropphycty": "MCINTOSH",
    "dropphyst": "MN",
    "dropphyzpp": 565569998,
    "dropmaladd": "285 CLEVELAND AVE SW",
    "dropmalcty": "MCINTOSH",
    "dropmalst": "MN",
    "dropmalzpp": 565569998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185634700,
    "dropsitcph": 2185634700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25804",
    "droptype": "D",
    "dropname": "MEADOWLANDS",
    "dropdeladd": "7729 CENTRAL AVE",
    "dropdelcty": "MEADOWLANDS",
    "dropdelst": "MN",
    "dropdelzpp": 557655000,
    "dropphyadd": "7729 CENTRAL AVE",
    "dropphycty": "MEADOWLANDS",
    "dropphyst": "MN",
    "dropphyzpp": 557655000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEADOWLANDS",
    "dropmalst": "MN",
    "dropmalzpp": 557659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184272355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25806",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "221 N MAIN ST",
    "dropdelcty": "MEDFORD",
    "dropdelst": "MN",
    "dropdelzpp": 550499700,
    "dropphyadd": "221 N MAIN ST",
    "dropphycty": "MEDFORD",
    "dropphyst": "MN",
    "dropphyzpp": 550499700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEDFORD",
    "dropmalst": "MN",
    "dropmalzpp": 550499998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074510544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25813",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "304 1ST ST NE",
    "dropdelcty": "MELROSE",
    "dropdelst": "MN",
    "dropdelzpp": 563521156,
    "dropphyadd": "304 1ST ST NE",
    "dropphycty": "MELROSE",
    "dropphyst": "MN",
    "dropphyzpp": 563521156,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELROSE",
    "dropmalst": "MN",
    "dropmalzpp": 563529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202563713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25816",
    "droptype": "D",
    "dropname": "MENAHGA",
    "dropdeladd": "22 MAIN ST SE",
    "dropdelcty": "MENAHGA",
    "dropdelst": "MN",
    "dropdelzpp": 564644501,
    "dropphyadd": "22 MAIN ST SE",
    "dropphycty": "MENAHGA",
    "dropphyst": "MN",
    "dropphyzpp": 564644501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENAHGA",
    "dropmalst": "MN",
    "dropmalzpp": 564649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185644843,
    "dropfax": 2185645170
  },
  {
    "dcode": "D",
    "dropkey": "PY25820",
    "droptype": "D",
    "dropname": "MENTOR",
    "dropdeladd": "204 GARFIELD AVE N",
    "dropdelcty": "MENTOR",
    "dropdelst": "MN",
    "dropdelzpp": 567369998,
    "dropphyadd": "204 GARFIELD AVE N",
    "dropphycty": "MENTOR",
    "dropphyst": "MN",
    "dropphyzpp": 567369998,
    "dropmaladd": "204 GARFIELD AVE N",
    "dropmalcty": "MENTOR",
    "dropmalst": "MN",
    "dropmalzpp": 567369998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186373585,
    "dropsitcph": 2186373585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25822",
    "droptype": "D",
    "dropname": "MERRIFIELD",
    "dropdeladd": "11029 CRYSTAL LAKE RD",
    "dropdelcty": "MERRIFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 564654558,
    "dropphyadd": "11029 CRYSTAL LAKE RD",
    "dropphycty": "MERRIFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 564654558,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRIFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 564659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188297055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25827",
    "droptype": "D",
    "dropname": "MIDDLE RIVER",
    "dropdeladd": "208 HILL AVE S",
    "dropdelcty": "MIDDLE RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 567379998,
    "dropphyadd": "208 HILL AVE S",
    "dropphycty": "MIDDLE RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 567379998,
    "dropmaladd": "208 HILL AVE S",
    "dropmalcty": "MIDDLE RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 567379998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182223700,
    "dropsitcph": 8778541185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25832",
    "droptype": "D",
    "dropname": "MILACA",
    "dropdeladd": "230 2ND AVE SW",
    "dropdelcty": "MILACA",
    "dropdelst": "MN",
    "dropdelzpp": 563531158,
    "dropphyadd": "230 2ND AVE SW",
    "dropphycty": "MILACA",
    "dropphyst": "MN",
    "dropphyzpp": 563531158,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILACA",
    "dropmalst": "MN",
    "dropmalzpp": 563539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3209833229,
    "dropfax": 3209835699
  },
  {
    "dcode": "D",
    "dropkey": "PY25833",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "222 N 2ND ST",
    "dropdelcty": "MILAN",
    "dropdelst": "MN",
    "dropdelzpp": 562622416,
    "dropphyadd": "222 N 2ND ST",
    "dropphycty": "MILAN",
    "dropphyst": "MN",
    "dropphyzpp": 562622416,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILAN",
    "dropmalst": "MN",
    "dropmalzpp": 562629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202894171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25834",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "431 DIVISION ST",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 559578705,
    "dropphyadd": "431 DIVISION ST",
    "dropphycty": "MILLVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 559578705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 559579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077982301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25837",
    "droptype": "D",
    "dropname": "MILROY",
    "dropdeladd": "404 EUCLID AVE",
    "dropdelcty": "MILROY",
    "dropdelst": "MN",
    "dropdelzpp": 562635000,
    "dropphyadd": "404 EUCLID AVE",
    "dropphycty": "MILROY",
    "dropphyst": "MN",
    "dropphyzpp": 562635000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILROY",
    "dropmalst": "MN",
    "dropmalzpp": 562639998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073362498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25839",
    "droptype": "D",
    "dropname": "MILTONA",
    "dropdeladd": "127 MAIN ST",
    "dropdelcty": "MILTONA",
    "dropdelst": "MN",
    "dropdelzpp": 563544400,
    "dropphyadd": "127 MAIN ST",
    "dropphycty": "MILTONA",
    "dropphyst": "MN",
    "dropphyzpp": 563544400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILTONA",
    "dropmalst": "MN",
    "dropmalzpp": 563549998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185791009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25845",
    "droptype": "D",
    "dropname": "MINNEAPOLIS",
    "dropdeladd": "100 S 1ST ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554012002,
    "dropphyadd": "100 S 1ST ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554012002,
    "dropmaladd": "100 S 1ST ST RM 127",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496346,
    "dropsitcph": 6123494715,
    "dropfax": 6123494970
  },
  {
    "dcode": "D",
    "dropkey": "PY25849",
    "droptype": "D",
    "dropname": "MINNEOTA",
    "dropdeladd": "114 E 1ST ST",
    "dropdelcty": "MINNEOTA",
    "dropdelst": "MN",
    "dropdelzpp": 562649637,
    "dropphyadd": "114 E 1ST ST",
    "dropphycty": "MINNEOTA",
    "dropphyst": "MN",
    "dropphyzpp": 562649637,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNEOTA",
    "dropmalst": "MN",
    "dropmalzpp": 562649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078726382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25850",
    "droptype": "D",
    "dropname": "MINNESOTA CITY",
    "dropdeladd": "200 MILL ST",
    "dropdelcty": "MINNESOTA CITY",
    "dropdelst": "MN",
    "dropdelzpp": 559591109,
    "dropphyadd": "200 MILL ST",
    "dropphycty": "MINNESOTA CITY",
    "dropphyst": "MN",
    "dropphyzpp": 559591109,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNESOTA CITY",
    "dropmalst": "MN",
    "dropmalzpp": 559599998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076892823,
    "dropfax": 5076892888
  },
  {
    "dcode": "D",
    "dropkey": "PY25853",
    "droptype": "D",
    "dropname": "MINNESOTA LAKE",
    "dropdeladd": "115 MAIN ST N",
    "dropdelcty": "MINNESOTA LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 560684401,
    "dropphyadd": "115 MAIN ST N",
    "dropphycty": "MINNESOTA LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 560684401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINNESOTA LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 560689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074623382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25868",
    "droptype": "D",
    "dropname": "MIZPAH",
    "dropdeladd": "101 WOODLAND AVE",
    "dropdelcty": "MIZPAH",
    "dropdelst": "MN",
    "dropdelzpp": 566602001,
    "dropphyadd": "101 WOODLAND AVE",
    "dropphycty": "MIZPAH",
    "dropphyst": "MN",
    "dropphyzpp": 566602001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIZPAH",
    "dropmalst": "MN",
    "dropmalzpp": 566609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188975034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25871",
    "droptype": "D",
    "dropname": "MONTEVIDEO",
    "dropdeladd": "316 S 1ST ST",
    "dropdelcty": "MONTEVIDEO",
    "dropdelst": "MN",
    "dropdelzpp": 562651415,
    "dropphyadd": "316 S 1ST ST",
    "dropphycty": "MONTEVIDEO",
    "dropphyst": "MN",
    "dropphyzpp": 562651415,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEVIDEO",
    "dropmalst": "MN",
    "dropmalzpp": 562659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202698130,
    "dropfax": 3202698218
  },
  {
    "dcode": "D",
    "dropkey": "PY25872",
    "droptype": "D",
    "dropname": "MONTGOMERY",
    "dropdeladd": "156 ELM AVE SE",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "MN",
    "dropdelzpp": 560691629,
    "dropphyadd": "156 ELM AVE SE",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "MN",
    "dropphyzpp": 560691629,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "MN",
    "dropmalzpp": 560699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073647488,
    "dropfax": 5073645945
  },
  {
    "dcode": "D",
    "dropkey": "PY25873",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "206 E 7TH ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "MN",
    "dropdelzpp": 553629028,
    "dropphyadd": "206 E 7TH ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "MN",
    "dropphyzpp": 553629028,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "MN",
    "dropmalzpp": 553629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632952213,
    "dropfax": 7632953642
  },
  {
    "dcode": "D",
    "dropkey": "PY25874",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "360 CENTER AVE S",
    "dropdelcty": "MONTROSE",
    "dropdelst": "MN",
    "dropdelzpp": 553638612,
    "dropphyadd": "360 CENTER AVE S",
    "dropphycty": "MONTROSE",
    "dropphyst": "MN",
    "dropphyzpp": 553638612,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTROSE",
    "dropmalst": "MN",
    "dropmalzpp": 553639998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7636753237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25875",
    "droptype": "D",
    "dropname": "MOORHEAD",
    "dropdeladd": "119 5TH ST S",
    "dropdelcty": "MOORHEAD",
    "dropdelst": "MN",
    "dropdelzpp": 565609998,
    "dropphyadd": "119 5TH ST S",
    "dropphycty": "MOORHEAD",
    "dropphyst": "MN",
    "dropphyzpp": 565609998,
    "dropmaladd": "119 5TH ST S",
    "dropmalcty": "MOORHEAD",
    "dropmalst": "MN",
    "dropmalzpp": 565609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184222000,
    "dropsitcph": 2184222000,
    "dropfax": 2182369676
  },
  {
    "dcode": "D",
    "dropkey": "PY25878",
    "droptype": "D",
    "dropname": "MOOSE LAKE",
    "dropdeladd": "205 ELM AVE",
    "dropdelcty": "MOOSE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 557675000,
    "dropphyadd": "205 ELM AVE",
    "dropphycty": "MOOSE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 557675000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOOSE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 557679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184854303,
    "dropfax": 2184854626
  },
  {
    "dcode": "D",
    "dropkey": "PY25880",
    "droptype": "D",
    "dropname": "MORA",
    "dropdeladd": "810 HOWE AVE",
    "dropdelcty": "MORA",
    "dropdelst": "MN",
    "dropdelzpp": 550511633,
    "dropphyadd": "810 HOWE AVE",
    "dropphycty": "MORA",
    "dropphyst": "MN",
    "dropphyzpp": 550511633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORA",
    "dropmalst": "MN",
    "dropmalzpp": 550519998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3206793581,
    "dropfax": 3206790940
  },
  {
    "dcode": "D",
    "dropkey": "PY25883",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "207 VERNON AVE",
    "dropdelcty": "MORGAN",
    "dropdelst": "MN",
    "dropdelzpp": 562665000,
    "dropphyadd": "207 VERNON AVE",
    "dropphycty": "MORGAN",
    "dropphyst": "MN",
    "dropphyzpp": 562665000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORGAN",
    "dropmalst": "MN",
    "dropmalzpp": 562669998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074662666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25886",
    "droptype": "D",
    "dropname": "MORRIS",
    "dropdeladd": "105 E 6TH ST",
    "dropdelcty": "MORRIS",
    "dropdelst": "MN",
    "dropdelzpp": 562671210,
    "dropphyadd": "105 E 6TH ST",
    "dropphycty": "MORRIS",
    "dropphyst": "MN",
    "dropphyzpp": 562671210,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRIS",
    "dropmalst": "MN",
    "dropmalzpp": 562679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205894024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25888",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "104 DIVISION ST S",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "MN",
    "dropdelzpp": 550525189,
    "dropphyadd": "104 DIVISION ST S",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "MN",
    "dropphyzpp": 550525189,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "MN",
    "dropmalzpp": 550529998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076854545,
    "dropfax": 5076852598
  },
  {
    "dcode": "D",
    "dropkey": "PY25893",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "165 N MAIN ST",
    "dropdelcty": "MORTON",
    "dropdelst": "MN",
    "dropdelzpp": 562705000,
    "dropphyadd": "165 N MAIN ST",
    "dropphycty": "MORTON",
    "dropphyst": "MN",
    "dropphyzpp": 562705000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORTON",
    "dropmalst": "MN",
    "dropmalzpp": 562709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076976488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25894",
    "droptype": "D",
    "dropname": "MOTLEY",
    "dropdeladd": "97 BEAULIEU ST W",
    "dropdelcty": "MOTLEY",
    "dropdelst": "MN",
    "dropdelzpp": 564664571,
    "dropphyadd": "97 BEAULIEU ST W",
    "dropphycty": "MOTLEY",
    "dropphyst": "MN",
    "dropphyzpp": 564664571,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOTLEY",
    "dropmalst": "MN",
    "dropmalzpp": 564669998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183526438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25895",
    "droptype": "D",
    "dropname": "MOUND",
    "dropdeladd": "5510 SHORELINE DR",
    "dropdelcty": "MOUND",
    "dropdelst": "MN",
    "dropdelzpp": 553641633,
    "dropphyadd": "5510 SHORELINE DR",
    "dropphycty": "MOUND",
    "dropphyst": "MN",
    "dropphyzpp": 553641633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUND",
    "dropmalst": "MN",
    "dropmalzpp": 553649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524723160,
    "dropfax": 9524722004
  },
  {
    "dcode": "D",
    "dropkey": "PY25899",
    "droptype": "D",
    "dropname": "MOUNTAIN IRON",
    "dropdeladd": "5756 MOUNTAIN AVE",
    "dropdelcty": "MOUNTAIN IRON",
    "dropdelst": "MN",
    "dropdelzpp": 557689636,
    "dropphyadd": "5756 MOUNTAIN AVE",
    "dropphycty": "MOUNTAIN IRON",
    "dropphyst": "MN",
    "dropphyzpp": 557689636,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN IRON",
    "dropmalst": "MN",
    "dropmalzpp": 557689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187358900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25900",
    "droptype": "D",
    "dropname": "MOUNTAIN LAKE",
    "dropdeladd": "211 10TH ST N",
    "dropdelcty": "MOUNTAIN LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 561591659,
    "dropphyadd": "211 10TH ST N",
    "dropphycty": "MOUNTAIN LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 561591659,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 561599998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074276300,
    "dropfax": 5074272315
  },
  {
    "dcode": "D",
    "dropkey": "PY25907",
    "droptype": "D",
    "dropname": "MURDOCK",
    "dropdeladd": "412 MAIN AVE",
    "dropdelcty": "MURDOCK",
    "dropdelst": "MN",
    "dropdelzpp": 562715000,
    "dropphyadd": "412 MAIN AVE",
    "dropphycty": "MURDOCK",
    "dropphyst": "MN",
    "dropphyzpp": 562715000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MURDOCK",
    "dropmalst": "MN",
    "dropmalzpp": 562719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208752901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25919",
    "droptype": "D",
    "dropname": "NASHWAUK",
    "dropdeladd": "132 2ND ST",
    "dropdelcty": "NASHWAUK",
    "dropdelst": "MN",
    "dropdelzpp": 557691110,
    "dropphyadd": "132 2ND ST",
    "dropphycty": "NASHWAUK",
    "dropphyst": "MN",
    "dropphyzpp": 557691110,
    "dropmaladd": "132 2ND ST",
    "dropmalcty": "NASHWAUK",
    "dropmalst": "MN",
    "dropmalzpp": 557699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188851075,
    "dropfax": 2188852057
  },
  {
    "dcode": "D",
    "dropkey": "PY25922",
    "droptype": "D",
    "dropname": "NAYTAHWAUSH",
    "dropdeladd": "2531 310TH AVE",
    "dropdelcty": "NAYTAHWAUSH",
    "dropdelst": "MN",
    "dropdelzpp": 565669998,
    "dropphyadd": "2531 310TH AVE",
    "dropphycty": "NAYTAHWAUSH",
    "dropphyst": "MN",
    "dropphyzpp": 565669998,
    "dropmaladd": "2531 310TH AVE",
    "dropmalcty": "NAYTAHWAUSH",
    "dropmalst": "MN",
    "dropmalzpp": 565669998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189352430,
    "dropsitcph": 2189352430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25925",
    "droptype": "D",
    "dropname": "NELSON",
    "dropdeladd": "261 N NELSON ST",
    "dropdelcty": "NELSON",
    "dropdelst": "MN",
    "dropdelzpp": 563554400,
    "dropphyadd": "261 N NELSON ST",
    "dropphycty": "NELSON",
    "dropphyst": "MN",
    "dropphyzpp": 563554400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NELSON",
    "dropmalst": "MN",
    "dropmalzpp": 563559998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202899294,
    "dropfax": 3207620123
  },
  {
    "dcode": "D",
    "dropkey": "PY25927",
    "droptype": "D",
    "dropname": "NERSTRAND",
    "dropdeladd": "309 MAIN ST",
    "dropdelcty": "NERSTRAND",
    "dropdelst": "MN",
    "dropdelzpp": 550532848,
    "dropphyadd": "309 MAIN ST",
    "dropphycty": "NERSTRAND",
    "dropphyst": "MN",
    "dropphyzpp": 550532848,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NERSTRAND",
    "dropmalst": "MN",
    "dropmalzpp": 550539998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073347719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25933",
    "droptype": "D",
    "dropname": "NEVIS",
    "dropdeladd": "107 MAIN ST W",
    "dropdelcty": "NEVIS",
    "dropdelst": "MN",
    "dropdelzpp": 564674458,
    "dropphyadd": "107 MAIN ST W",
    "dropphycty": "NEVIS",
    "dropphyst": "MN",
    "dropphyzpp": 564674458,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEVIS",
    "dropmalst": "MN",
    "dropmalzpp": 564679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186523965,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25934",
    "droptype": "D",
    "dropname": "NEW AUBURN",
    "dropdeladd": "8301 8TH AVE",
    "dropdelcty": "NEW AUBURN",
    "dropdelst": "MN",
    "dropdelzpp": 553666600,
    "dropphyadd": "8301 8TH AVE",
    "dropphycty": "NEW AUBURN",
    "dropphyst": "MN",
    "dropphyzpp": 553666600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW AUBURN",
    "dropmalst": "MN",
    "dropmalzpp": 553669998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208644998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25938",
    "droptype": "D",
    "dropname": "NEW GERMANY",
    "dropdeladd": "240 BROADWAY ST E",
    "dropdelcty": "NEW GERMANY",
    "dropdelst": "MN",
    "dropdelzpp": 553676700,
    "dropphyadd": "240 BROADWAY ST E",
    "dropphycty": "NEW GERMANY",
    "dropphyst": "MN",
    "dropphyzpp": 553676700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW GERMANY",
    "dropmalst": "MN",
    "dropmalzpp": 553679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9523532243,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25941",
    "droptype": "D",
    "dropname": "NEW LONDON",
    "dropdeladd": "31 CENTRAL AVE E",
    "dropdelcty": "NEW LONDON",
    "dropdelst": "MN",
    "dropdelzpp": 562735000,
    "dropphyadd": "31 CENTRAL AVE E",
    "dropphycty": "NEW LONDON",
    "dropphyst": "MN",
    "dropphyzpp": 562735000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW LONDON",
    "dropmalst": "MN",
    "dropmalzpp": 562739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 3203542144,
    "dropsitcph": 3203542144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25942",
    "droptype": "D",
    "dropname": "ELKO NEW MARKET",
    "dropdeladd": "26045 MARKET PLACE BLVD",
    "dropdelcty": "ELKO NEW MARKET",
    "dropdelst": "MN",
    "dropdelzpp": 550205000,
    "dropphyadd": "26045 MARKET PLACE BLVD",
    "dropphycty": "ELKO NEW MARKET",
    "dropphyst": "MN",
    "dropphyzpp": 550205000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELKO NEW MARKET",
    "dropmalst": "MN",
    "dropmalzpp": 550209998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 9524612150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25943",
    "droptype": "D",
    "dropname": "NEW MUNICH",
    "dropdeladd": "450 MAIN ST",
    "dropdelcty": "NEW MUNICH",
    "dropdelst": "MN",
    "dropdelzpp": 563564400,
    "dropphyadd": "450 MAIN ST",
    "dropphycty": "NEW MUNICH",
    "dropphyst": "MN",
    "dropphyzpp": 563564400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW MUNICH",
    "dropmalst": "MN",
    "dropmalzpp": 563569998,
    "dropsitphn": 3208375320,
    "dropsitlph": 2187232512,
    "dropsitcph": 3208375320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25944",
    "droptype": "D",
    "dropname": "NEW PRAGUE",
    "dropdeladd": "124 MAIN ST E",
    "dropdelcty": "NEW PRAGUE",
    "dropdelst": "MN",
    "dropdelzpp": 560712440,
    "dropphyadd": "124 MAIN ST E",
    "dropphycty": "NEW PRAGUE",
    "dropphyst": "MN",
    "dropphyzpp": 560712440,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW PRAGUE",
    "dropmalst": "MN",
    "dropmalzpp": 560719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9527587678,
    "dropfax": 9527585033
  },
  {
    "dcode": "D",
    "dropkey": "PY25945",
    "droptype": "D",
    "dropname": "NEW RICHLAND",
    "dropdeladd": "141 BROADWAY AVE N",
    "dropdelcty": "NEW RICHLAND",
    "dropdelst": "MN",
    "dropdelzpp": 560722020,
    "dropphyadd": "141 BROADWAY AVE N",
    "dropphycty": "NEW RICHLAND",
    "dropphyst": "MN",
    "dropphyzpp": 560722020,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW RICHLAND",
    "dropmalst": "MN",
    "dropmalzpp": 560729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074638333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25948",
    "droptype": "D",
    "dropname": "NEW ULM",
    "dropdeladd": "27 S GERMAN ST",
    "dropdelcty": "NEW ULM",
    "dropdelst": "MN",
    "dropdelzpp": 560733015,
    "dropphyadd": "27 S GERMAN ST",
    "dropphycty": "NEW ULM",
    "dropphyst": "MN",
    "dropphyzpp": 560733015,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ULM",
    "dropmalst": "MN",
    "dropmalzpp": 560739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073542011,
    "dropfax": 5073547521
  },
  {
    "dcode": "D",
    "dropkey": "PY25949",
    "droptype": "D",
    "dropname": "NEW YORK MILLS",
    "dropdeladd": "16 WALKER AVE N",
    "dropdelcty": "NEW YORK MILLS",
    "dropdelst": "MN",
    "dropdelzpp": 565679998,
    "dropphyadd": "16 WALKER AVE N",
    "dropphycty": "NEW YORK MILLS",
    "dropphyst": "MN",
    "dropphyzpp": 565679998,
    "dropmaladd": "16 WALKER AVE N",
    "dropmalcty": "NEW YORK MILLS",
    "dropmalst": "MN",
    "dropmalzpp": 565679998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183852420,
    "dropsitcph": 2183852420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25950",
    "droptype": "D",
    "dropname": "NEWFOLDEN",
    "dropdeladd": "120 S MAIN ST",
    "dropdelcty": "NEWFOLDEN",
    "dropdelst": "MN",
    "dropdelzpp": 567389998,
    "dropphyadd": "120 S MAIN ST",
    "dropphycty": "NEWFOLDEN",
    "dropphyst": "MN",
    "dropphyzpp": 567389998,
    "dropmaladd": "120 S MAIN ST",
    "dropmalcty": "NEWFOLDEN",
    "dropmalst": "MN",
    "dropmalzpp": 567389998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188744155,
    "dropsitcph": 8773641342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25951",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "303 21ST ST STE 141",
    "dropdelcty": "NEWPORT",
    "dropdelst": "MN",
    "dropdelzpp": 550551185,
    "dropphyadd": "303 21ST ST STE 141",
    "dropphycty": "NEWPORT",
    "dropphyst": "MN",
    "dropphyzpp": 550551185,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWPORT",
    "dropmalst": "MN",
    "dropmalzpp": 550559998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514595597,
    "dropsitcph": 6517680558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25956",
    "droptype": "D",
    "dropname": "NICOLLET",
    "dropdeladd": "714 4TH ST",
    "dropdelcty": "NICOLLET",
    "dropdelst": "MN",
    "dropdelzpp": 560742016,
    "dropphyadd": "714 4TH ST",
    "dropphycty": "NICOLLET",
    "dropphyst": "MN",
    "dropphyzpp": 560742016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NICOLLET",
    "dropmalst": "MN",
    "dropmalzpp": 560749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072250698,
    "dropfax": 5072253838
  },
  {
    "dcode": "D",
    "dropkey": "PY25958",
    "droptype": "D",
    "dropname": "NIELSVILLE",
    "dropdeladd": "202 N SPOKELY AVE",
    "dropdelcty": "NIELSVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 565689998,
    "dropphyadd": "202 N SPOKELY AVE",
    "dropphycty": "NIELSVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 565689998,
    "dropmaladd": "202 N SPOKELY AVE",
    "dropmalcty": "NIELSVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 565689998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189463871,
    "dropsitcph": 2189463871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25960",
    "droptype": "D",
    "dropname": "NISSWA",
    "dropdeladd": "25551 MAIN ST",
    "dropdelcty": "NISSWA",
    "dropdelst": "MN",
    "dropdelzpp": 564685000,
    "dropphyadd": "25551 MAIN ST",
    "dropphycty": "NISSWA",
    "dropphyst": "MN",
    "dropphyzpp": 564685000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NISSWA",
    "dropmalst": "MN",
    "dropmalzpp": 564689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2189637907,
    "dropfax": 2189633809
  },
  {
    "dcode": "D",
    "dropkey": "PY25969",
    "droptype": "D",
    "dropname": "NORCROSS",
    "dropdeladd": "17557 GRISWOLD AVE",
    "dropdelcty": "NORCROSS",
    "dropdelst": "MN",
    "dropdelzpp": 562745000,
    "dropphyadd": "17557 GRISWOLD AVE",
    "dropphycty": "NORCROSS",
    "dropphyst": "MN",
    "dropphyzpp": 562745000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORCROSS",
    "dropmalst": "MN",
    "dropmalzpp": 562749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3206772422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY25973",
    "droptype": "D",
    "dropname": "NORTH BRANCH",
    "dropdeladd": "6444 ELM ST",
    "dropdelcty": "NORTH BRANCH",
    "dropdelst": "MN",
    "dropdelzpp": 550567107,
    "dropphyadd": "6444 ELM ST",
    "dropphycty": "NORTH BRANCH",
    "dropphyst": "MN",
    "dropphyzpp": 550567107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BRANCH",
    "dropmalst": "MN",
    "dropmalzpp": 550569998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6516747171,
    "dropfax": 6516747943
  },
  {
    "dcode": "D",
    "dropkey": "PY25986",
    "droptype": "D",
    "dropname": "NORTHFIELD",
    "dropdeladd": "14 BRIDGE SQ",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 550572008,
    "dropphyadd": "14 BRIDGE SQ",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 550572008,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 550579998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076457812,
    "dropfax": 5076452388
  },
  {
    "dcode": "D",
    "dropkey": "PY25988",
    "droptype": "D",
    "dropname": "NORTHOME",
    "dropdeladd": "12055 MAIN ST",
    "dropdelcty": "NORTHOME",
    "dropdelst": "MN",
    "dropdelzpp": 566618074,
    "dropphyadd": "12055 MAIN ST",
    "dropphycty": "NORTHOME",
    "dropphyst": "MN",
    "dropphyzpp": 566618074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTHOME",
    "dropmalst": "MN",
    "dropmalzpp": 566619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188975233,
    "dropfax": 2188975367
  },
  {
    "dcode": "D",
    "dropkey": "PY26008",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "106 COUNTY ROAD 28 E",
    "dropdelcty": "ODESSA",
    "dropdelst": "MN",
    "dropdelzpp": 562765000,
    "dropphyadd": "106 COUNTY ROAD 28 E",
    "dropphycty": "ODESSA",
    "dropphyst": "MN",
    "dropphyzpp": 562765000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODESSA",
    "dropmalst": "MN",
    "dropmalzpp": 562769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202732256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26009",
    "droptype": "D",
    "dropname": "ODIN",
    "dropdeladd": "105 N 1ST ST",
    "dropdelcty": "ODIN",
    "dropdelst": "MN",
    "dropdelzpp": 561603029,
    "dropphyadd": "105 N 1ST ST",
    "dropphycty": "ODIN",
    "dropphyst": "MN",
    "dropphyzpp": 561603029,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ODIN",
    "dropmalst": "MN",
    "dropmalzpp": 561609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077362701,
    "dropfax": 5077362701
  },
  {
    "dcode": "D",
    "dropkey": "PY26010",
    "droptype": "D",
    "dropname": "OGEMA",
    "dropdeladd": "412 MAIN ST E",
    "dropdelcty": "OGEMA",
    "dropdelst": "MN",
    "dropdelzpp": 565699998,
    "dropphyadd": "412 MAIN ST E",
    "dropphycty": "OGEMA",
    "dropphyst": "MN",
    "dropphyzpp": 565699998,
    "dropmaladd": "412 MAIN ST E",
    "dropmalcty": "OGEMA",
    "dropmalst": "MN",
    "dropmalzpp": 565699998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189833789,
    "dropsitcph": 2189833789,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26011",
    "droptype": "D",
    "dropname": "OGILVIE",
    "dropdeladd": "200 N HILL AVE",
    "dropdelcty": "OGILVIE",
    "dropdelst": "MN",
    "dropdelzpp": 563584501,
    "dropphyadd": "200 N HILL AVE",
    "dropphycty": "OGILVIE",
    "dropphyst": "MN",
    "dropphyzpp": 563584501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OGILVIE",
    "dropmalst": "MN",
    "dropmalzpp": 563589998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202724863,
    "dropfax": 3202724465
  },
  {
    "dcode": "D",
    "dropkey": "PY26012",
    "droptype": "D",
    "dropname": "OKABENA",
    "dropdeladd": "112 S MINNESOTA AVE",
    "dropdelcty": "OKABENA",
    "dropdelst": "MN",
    "dropdelzpp": 561614003,
    "dropphyadd": "112 S MINNESOTA AVE",
    "dropphycty": "OKABENA",
    "dropphyst": "MN",
    "dropphyzpp": 561614003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OKABENA",
    "dropmalst": "MN",
    "dropmalzpp": 561619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078531038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26015",
    "droptype": "D",
    "dropname": "OKLEE",
    "dropdeladd": "202 2ND AVE",
    "dropdelcty": "OKLEE",
    "dropdelst": "MN",
    "dropdelzpp": 567429998,
    "dropphyadd": "202 2ND AVE",
    "dropphycty": "OKLEE",
    "dropphyst": "MN",
    "dropphyzpp": 567429998,
    "dropmaladd": "202 2ND AVE",
    "dropmalcty": "OKLEE",
    "dropmalst": "MN",
    "dropmalzpp": 567429998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187965127,
    "dropsitcph": 8779072883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26017",
    "droptype": "D",
    "dropname": "OLIVIA",
    "dropdeladd": "806 E DEPUE AVE",
    "dropdelcty": "OLIVIA",
    "dropdelst": "MN",
    "dropdelzpp": 562771340,
    "dropphyadd": "806 E DEPUE AVE",
    "dropphycty": "OLIVIA",
    "dropphyst": "MN",
    "dropphyzpp": 562771340,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLIVIA",
    "dropmalst": "MN",
    "dropmalzpp": 562779998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205231112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26018",
    "droptype": "D",
    "dropname": "ONAMIA",
    "dropdeladd": "600 MAIN ST",
    "dropdelcty": "ONAMIA",
    "dropdelst": "MN",
    "dropdelzpp": 563594400,
    "dropphyadd": "600 MAIN ST",
    "dropphycty": "ONAMIA",
    "dropphyst": "MN",
    "dropphyzpp": 563594400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONAMIA",
    "dropmalst": "MN",
    "dropmalzpp": 563599998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205323146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26021",
    "droptype": "D",
    "dropname": "ORMSBY",
    "dropdeladd": "506 MAIN ST",
    "dropdelcty": "ORMSBY",
    "dropdelst": "MN",
    "dropdelzpp": 561622002,
    "dropphyadd": "506 MAIN ST",
    "dropphycty": "ORMSBY",
    "dropphyst": "MN",
    "dropphyzpp": 561622002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORMSBY",
    "dropmalst": "MN",
    "dropmalzpp": 561629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077365023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26028",
    "droptype": "D",
    "dropname": "ORONOCO",
    "dropdeladd": "10 N MINNESOTA AVE",
    "dropdelcty": "ORONOCO",
    "dropdelst": "MN",
    "dropdelzpp": 559601345,
    "dropphyadd": "10 N MINNESOTA AVE",
    "dropphycty": "ORONOCO",
    "dropphyst": "MN",
    "dropphyzpp": 559601345,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORONOCO",
    "dropmalst": "MN",
    "dropmalzpp": 559609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073674932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26029",
    "droptype": "D",
    "dropname": "ORR",
    "dropdeladd": "4523 HIGHWAY 53",
    "dropdelcty": "ORR",
    "dropdelst": "MN",
    "dropdelzpp": 557718240,
    "dropphyadd": "4523 HIGHWAY 53",
    "dropphycty": "ORR",
    "dropphyst": "MN",
    "dropphyzpp": 557718240,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORR",
    "dropmalst": "MN",
    "dropmalzpp": 557719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187572006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26030",
    "droptype": "D",
    "dropname": "ORTONVILLE",
    "dropdeladd": "104 JACKSON AVE",
    "dropdelcty": "ORTONVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 562781400,
    "dropphyadd": "104 JACKSON AVE",
    "dropphycty": "ORTONVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 562781400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORTONVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 562789998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3208392883,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26033",
    "droptype": "D",
    "dropname": "OSAGE",
    "dropdeladd": "54586 STATE HIGHWAY 34",
    "dropdelcty": "OSAGE",
    "dropdelst": "MN",
    "dropdelzpp": 565709998,
    "dropphyadd": "54586 STATE HIGHWAY 34",
    "dropphycty": "OSAGE",
    "dropphyst": "MN",
    "dropphyzpp": 565709998,
    "dropmaladd": "54586 STATE HIGHWAY 34",
    "dropmalcty": "OSAGE",
    "dropmalst": "MN",
    "dropmalzpp": 565709998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185733157,
    "dropsitcph": 2185733157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26034",
    "droptype": "D",
    "dropname": "OSAKIS",
    "dropdeladd": "60 W MAIN ST",
    "dropdelcty": "OSAKIS",
    "dropdelst": "MN",
    "dropdelzpp": 563604400,
    "dropphyadd": "60 W MAIN ST",
    "dropphycty": "OSAKIS",
    "dropphyst": "MN",
    "dropphyzpp": 563604400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSAKIS",
    "dropmalst": "MN",
    "dropmalzpp": 563609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 8779078646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26037",
    "droptype": "D",
    "dropname": "OSLO",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "OSLO",
    "dropdelst": "MN",
    "dropdelzpp": 567449998,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "OSLO",
    "dropphyst": "MN",
    "dropphyzpp": 567449998,
    "dropmaladd": "312 MAIN ST",
    "dropmalcty": "OSLO",
    "dropmalst": "MN",
    "dropmalzpp": 567449998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186953362,
    "dropsitcph": 2186953362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26039",
    "droptype": "D",
    "dropname": "OSSEO",
    "dropdeladd": "125 1ST AVE NW",
    "dropdelcty": "OSSEO",
    "dropdelst": "MN",
    "dropdelzpp": 553699906,
    "dropphyadd": "125 1ST AVE NW",
    "dropphycty": "OSSEO",
    "dropphyst": "MN",
    "dropphyzpp": 553699906,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSSEO",
    "dropmalst": "MN",
    "dropmalzpp": 553699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7634258302,
    "dropsitcph": 7634250417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26040",
    "droptype": "D",
    "dropname": "OSTRANDER",
    "dropdeladd": "303 MAIN ST",
    "dropdelcty": "OSTRANDER",
    "dropdelst": "MN",
    "dropdelzpp": 559615000,
    "dropphyadd": "303 MAIN ST",
    "dropphycty": "OSTRANDER",
    "dropphyst": "MN",
    "dropphyzpp": 559615000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OSTRANDER",
    "dropmalst": "MN",
    "dropmalzpp": 559619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076572217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26046",
    "droptype": "D",
    "dropname": "OTTERTAIL",
    "dropdeladd": "105 W MAIN ST",
    "dropdelcty": "OTTERTAIL",
    "dropdelst": "MN",
    "dropdelzpp": 565719998,
    "dropphyadd": "105 W MAIN ST",
    "dropphycty": "OTTERTAIL",
    "dropphyst": "MN",
    "dropphyzpp": 565719998,
    "dropmaladd": "105 W MAIN ST",
    "dropmalcty": "OTTERTAIL",
    "dropmalst": "MN",
    "dropmalzpp": 565719998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183672130,
    "dropsitcph": 2183672130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26047",
    "droptype": "D",
    "dropname": "OUTING",
    "dropdeladd": "420 STATE HIGHWAY 6 NE",
    "dropdelcty": "OUTING",
    "dropdelst": "MN",
    "dropdelzpp": 566626717,
    "dropphyadd": "420 STATE HIGHWAY 6 NE",
    "dropphycty": "OUTING",
    "dropphyst": "MN",
    "dropphyzpp": 566626717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OUTING",
    "dropmalst": "MN",
    "dropmalzpp": 566629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187925214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26048",
    "droptype": "D",
    "dropname": "OWATONNA",
    "dropdeladd": "209 E BROADWAY ST",
    "dropdelcty": "OWATONNA",
    "dropdelst": "MN",
    "dropdelzpp": 550602403,
    "dropphyadd": "209 E BROADWAY ST",
    "dropphycty": "OWATONNA",
    "dropphyst": "MN",
    "dropphyzpp": 550602403,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OWATONNA",
    "dropmalst": "MN",
    "dropmalzpp": 550609998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074513507,
    "dropfax": 5074512926
  },
  {
    "dcode": "D",
    "dropkey": "PY26052",
    "droptype": "D",
    "dropname": "PALISADE",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "PALISADE",
    "dropdelst": "MN",
    "dropdelzpp": 564695000,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "PALISADE",
    "dropphyst": "MN",
    "dropphyzpp": 564695000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALISADE",
    "dropmalst": "MN",
    "dropmalzpp": 564699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188452781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26055",
    "droptype": "D",
    "dropname": "PARK RAPIDS",
    "dropdeladd": "301 PARK AVE S",
    "dropdelcty": "PARK RAPIDS",
    "dropdelst": "MN",
    "dropdelzpp": 564703501,
    "dropphyadd": "301 PARK AVE S",
    "dropphycty": "PARK RAPIDS",
    "dropphyst": "MN",
    "dropphyzpp": 564703501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARK RAPIDS",
    "dropmalst": "MN",
    "dropmalzpp": 564709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187324477,
    "dropfax": 2187321505
  },
  {
    "dcode": "D",
    "dropkey": "PY26059",
    "droptype": "D",
    "dropname": "PARKERS PRAIRIE",
    "dropdeladd": "119 W SOO ST",
    "dropdelcty": "PARKERS PRAIRIE",
    "dropdelst": "MN",
    "dropdelzpp": 563614400,
    "dropphyadd": "119 W SOO ST",
    "dropphycty": "PARKERS PRAIRIE",
    "dropphyst": "MN",
    "dropphyzpp": 563614400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKERS PRAIRIE",
    "dropmalst": "MN",
    "dropmalzpp": 563619998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182718170,
    "dropfax": 2183385110
  },
  {
    "dcode": "D",
    "dropkey": "PY26068",
    "droptype": "D",
    "dropname": "PAYNESVILLE",
    "dropdeladd": "211 W JAMES ST",
    "dropdelcty": "PAYNESVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 563621218,
    "dropphyadd": "211 W JAMES ST",
    "dropphycty": "PAYNESVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 563621218,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAYNESVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 563629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202433954,
    "dropfax": 3202434939
  },
  {
    "dcode": "D",
    "dropkey": "PY26072",
    "droptype": "D",
    "dropname": "PELICAN RAPIDS",
    "dropdeladd": "25 E MILL AVE",
    "dropdelcty": "PELICAN RAPIDS",
    "dropdelst": "MN",
    "dropdelzpp": 565729998,
    "dropphyadd": "25 E MILL AVE",
    "dropphycty": "PELICAN RAPIDS",
    "dropphyst": "MN",
    "dropphyzpp": 565729998,
    "dropmaladd": "25 E MILL AVE",
    "dropmalcty": "PELICAN RAPIDS",
    "dropmalst": "MN",
    "dropmalzpp": 565729998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188635201,
    "dropsitcph": 2188635201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26073",
    "droptype": "D",
    "dropname": "PEMBERTON",
    "dropdeladd": "141 4TH ST STE 102",
    "dropdelcty": "PEMBERTON",
    "dropdelst": "MN",
    "dropdelzpp": 560782245,
    "dropphyadd": "141 4TH ST STE 102",
    "dropphycty": "PEMBERTON",
    "dropphyst": "MN",
    "dropphyzpp": 560782245,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEMBERTON",
    "dropmalst": "MN",
    "dropmalzpp": 560789998,
    "dropsitphn": 5078693261,
    "dropsitlph": 5078693261,
    "dropsitcph": 5078693261,
    "dropfax": 5078696321
  },
  {
    "dcode": "D",
    "dropkey": "PY26075",
    "droptype": "D",
    "dropname": "PENGILLY",
    "dropdeladd": "31143 STATE HIGHWAY 65",
    "dropdelcty": "PENGILLY",
    "dropdelst": "MN",
    "dropdelzpp": 557755000,
    "dropphyadd": "31143 STATE HIGHWAY 65",
    "dropphycty": "PENGILLY",
    "dropphyst": "MN",
    "dropphyzpp": 557755000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENGILLY",
    "dropmalst": "MN",
    "dropmalzpp": 557759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188852759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26077",
    "droptype": "D",
    "dropname": "PENNOCK",
    "dropdeladd": "101 ATLANTIC AVE NW",
    "dropdelcty": "PENNOCK",
    "dropdelst": "MN",
    "dropdelzpp": 562799513,
    "dropphyadd": "101 ATLANTIC AVE NW",
    "dropphycty": "PENNOCK",
    "dropphyst": "MN",
    "dropphyzpp": 562799513,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENNOCK",
    "dropmalst": "MN",
    "dropmalzpp": 562799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205994787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26078",
    "droptype": "D",
    "dropname": "PEQUOT LAKES",
    "dropdeladd": "4294 MAIN ST",
    "dropdelcty": "PEQUOT LAKES",
    "dropdelst": "MN",
    "dropdelzpp": 564724400,
    "dropphyadd": "4294 MAIN ST",
    "dropphycty": "PEQUOT LAKES",
    "dropphyst": "MN",
    "dropphyzpp": 564724400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEQUOT LAKES",
    "dropmalst": "MN",
    "dropmalzpp": 564729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185688105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26080",
    "droptype": "D",
    "dropname": "PERHAM",
    "dropdeladd": "100 3RD AVE NW",
    "dropdelcty": "PERHAM",
    "dropdelst": "MN",
    "dropdelzpp": 565739998,
    "dropphyadd": "100 3RD AVE NW",
    "dropphycty": "PERHAM",
    "dropphyst": "MN",
    "dropphyzpp": 565739998,
    "dropmaladd": "100 3RD AVE NW",
    "dropmalcty": "PERHAM",
    "dropmalst": "MN",
    "dropmalzpp": 565739998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183466185,
    "dropsitcph": 2183466185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26081",
    "droptype": "D",
    "dropname": "PERLEY",
    "dropdeladd": "214 MAIN ST",
    "dropdelcty": "PERLEY",
    "dropdelst": "MN",
    "dropdelzpp": 565749998,
    "dropphyadd": "214 MAIN ST",
    "dropphycty": "PERLEY",
    "dropphyst": "MN",
    "dropphyzpp": 565749998,
    "dropmaladd": "214 MAIN ST",
    "dropmalcty": "PERLEY",
    "dropmalst": "MN",
    "dropmalzpp": 565749998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188616565,
    "dropsitcph": 2188616565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26082",
    "droptype": "D",
    "dropname": "PETERSON",
    "dropdeladd": "328 MILL ST",
    "dropdelcty": "PETERSON",
    "dropdelst": "MN",
    "dropdelzpp": 559629774,
    "dropphyadd": "328 MILL ST",
    "dropphycty": "PETERSON",
    "dropphyst": "MN",
    "dropphyzpp": 559629774,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSON",
    "dropmalst": "MN",
    "dropmalzpp": 559629998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078752226,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26085",
    "droptype": "D",
    "dropname": "PIERZ",
    "dropdeladd": "118 MAIN ST S",
    "dropdelcty": "PIERZ",
    "dropdelst": "MN",
    "dropdelzpp": 563644400,
    "dropphyadd": "118 MAIN ST S",
    "dropphycty": "PIERZ",
    "dropphyst": "MN",
    "dropphyzpp": 563644400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERZ",
    "dropmalst": "MN",
    "dropmalzpp": 563649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3204686481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26088",
    "droptype": "D",
    "dropname": "PILLAGER",
    "dropdeladd": "123 CEDAR AVE E",
    "dropdelcty": "PILLAGER",
    "dropdelst": "MN",
    "dropdelzpp": 564734400,
    "dropphyadd": "123 CEDAR AVE E",
    "dropphycty": "PILLAGER",
    "dropphyst": "MN",
    "dropphyzpp": 564734400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PILLAGER",
    "dropmalst": "MN",
    "dropmalzpp": 564739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187463180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26090",
    "droptype": "D",
    "dropname": "PINE CITY",
    "dropdeladd": "170 EVERGREEN SQ SW",
    "dropdelcty": "PINE CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550632000,
    "dropphyadd": "170 EVERGREEN SQ SW",
    "dropphycty": "PINE CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550632000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE CITY",
    "dropmalst": "MN",
    "dropmalzpp": 550639998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3206293515,
    "dropfax": 3206294660
  },
  {
    "dcode": "D",
    "dropkey": "PY26094",
    "droptype": "D",
    "dropname": "PINE ISLAND",
    "dropdeladd": "217 S MAIN ST",
    "dropdelcty": "PINE ISLAND",
    "dropdelst": "MN",
    "dropdelzpp": 559639191,
    "dropphyadd": "217 S MAIN ST",
    "dropphycty": "PINE ISLAND",
    "dropphyst": "MN",
    "dropphyzpp": 559639191,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE ISLAND",
    "dropmalst": "MN",
    "dropmalzpp": 559639998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073568665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26099",
    "droptype": "D",
    "dropname": "PINE RIVER",
    "dropdeladd": "330 BARCLAY AVE W",
    "dropdelcty": "PINE RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 564745500,
    "dropphyadd": "330 BARCLAY AVE W",
    "dropphycty": "PINE RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 564745500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 564749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185874793,
    "dropfax": 2185874280
  },
  {
    "dcode": "D",
    "dropkey": "PY26104",
    "droptype": "D",
    "dropname": "PIPESTONE",
    "dropdeladd": "202 S HIAWATHA AVE",
    "dropdelcty": "PIPESTONE",
    "dropdelst": "MN",
    "dropdelzpp": 561641879,
    "dropphyadd": "202 S HIAWATHA AVE",
    "dropphycty": "PIPESTONE",
    "dropphyst": "MN",
    "dropphyzpp": 561641879,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIPESTONE",
    "dropmalst": "MN",
    "dropmalzpp": 561649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078252400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26107",
    "droptype": "D",
    "dropname": "PLAINVIEW",
    "dropdeladd": "334 W BROADWAY",
    "dropdelcty": "PLAINVIEW",
    "dropdelst": "MN",
    "dropdelzpp": 559641256,
    "dropphyadd": "334 W BROADWAY",
    "dropphycty": "PLAINVIEW",
    "dropphyst": "MN",
    "dropphyzpp": 559641256,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLAINVIEW",
    "dropmalst": "MN",
    "dropmalzpp": 559649998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075342504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26109",
    "droptype": "D",
    "dropname": "PLATO",
    "dropdeladd": "16 2ND AVE NE",
    "dropdelcty": "PLATO",
    "dropdelst": "MN",
    "dropdelzpp": 553705448,
    "dropphyadd": "16 2ND AVE NE",
    "dropphycty": "PLATO",
    "dropphyst": "MN",
    "dropphyzpp": 553705448,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLATO",
    "dropmalst": "MN",
    "dropmalzpp": 553709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202382223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26111",
    "droptype": "D",
    "dropname": "PLUMMER",
    "dropdeladd": "210 CENTRAL AVE E",
    "dropdelcty": "PLUMMER",
    "dropdelst": "MN",
    "dropdelzpp": 567489998,
    "dropphyadd": "210 CENTRAL AVE E",
    "dropphycty": "PLUMMER",
    "dropphyst": "MN",
    "dropphyzpp": 567489998,
    "dropmaladd": "210 CENTRAL AVE E",
    "dropmalcty": "PLUMMER",
    "dropmalst": "MN",
    "dropmalzpp": 567489998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184654240,
    "dropsitcph": 2184654240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26113",
    "droptype": "D",
    "dropname": "PONEMAH",
    "dropdeladd": "150 COUNTY ROAD 15",
    "dropdelcty": "PONEMAH",
    "dropdelst": "MN",
    "dropdelzpp": 566664400,
    "dropphyadd": "150 COUNTY ROAD 15",
    "dropphycty": "PONEMAH",
    "dropphyst": "MN",
    "dropphyzpp": 566664400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PONEMAH",
    "dropmalst": "MN",
    "dropmalzpp": 566669998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185547374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26114",
    "droptype": "D",
    "dropname": "PONSFORD",
    "dropdeladd": "48510 COUNTY HIGHWAY 26",
    "dropdelcty": "PONSFORD",
    "dropdelst": "MN",
    "dropdelzpp": 565759998,
    "dropphyadd": "48510 COUNTY HIGHWAY 26",
    "dropphycty": "PONSFORD",
    "dropphyst": "MN",
    "dropphyzpp": 565759998,
    "dropmaladd": "48510 COUNTY HIGHWAY 26",
    "dropmalcty": "PONSFORD",
    "dropmalst": "MN",
    "dropmalzpp": 565759998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185733711,
    "dropsitcph": 2185733711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26120",
    "droptype": "D",
    "dropname": "PORTER",
    "dropdeladd": "400 LONE TREE ST",
    "dropdelcty": "PORTER",
    "dropdelst": "MN",
    "dropdelzpp": 562809785,
    "dropphyadd": "400 LONE TREE ST",
    "dropphycty": "PORTER",
    "dropphyst": "MN",
    "dropphyzpp": 562809785,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORTER",
    "dropmalst": "MN",
    "dropmalzpp": 562809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072964650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26126",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "212 PLEASANT ST NE",
    "dropdelcty": "PRESTON",
    "dropdelst": "MN",
    "dropdelzpp": 559651149,
    "dropphyadd": "212 PLEASANT ST NE",
    "dropphycty": "PRESTON",
    "dropphyst": "MN",
    "dropphyzpp": 559651149,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESTON",
    "dropmalst": "MN",
    "dropmalzpp": 559659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077653334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26128",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "205 N RUM RIVER DR",
    "dropdelcty": "PRINCETON",
    "dropdelst": "MN",
    "dropdelzpp": 553711618,
    "dropphyadd": "205 N RUM RIVER DR",
    "dropphycty": "PRINCETON",
    "dropphyst": "MN",
    "dropphyzpp": 553711618,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRINCETON",
    "dropmalst": "MN",
    "dropmalzpp": 553719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7633897299,
    "dropfax": 7633893033
  },
  {
    "dcode": "D",
    "dropkey": "PY26129",
    "droptype": "D",
    "dropname": "PRINSBURG",
    "dropdeladd": "613 N 3RD ST",
    "dropdelcty": "PRINSBURG",
    "dropdelst": "MN",
    "dropdelzpp": 562815000,
    "dropphyadd": "613 N 3RD ST",
    "dropphycty": "PRINSBURG",
    "dropphyst": "MN",
    "dropphyzpp": 562815000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRINSBURG",
    "dropmalst": "MN",
    "dropmalzpp": 562819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3209784671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26130",
    "droptype": "D",
    "dropname": "PRIOR LAKE",
    "dropdeladd": "4455 VILLAGE LAKE DR SE",
    "dropdelcty": "PRIOR LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553729926,
    "dropphyadd": "4455 VILLAGE LAKE DR SE",
    "dropphycty": "PRIOR LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553729926,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRIOR LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9524471062,
    "dropsitcph": 9524471062,
    "dropfax": 9524401412
  },
  {
    "dcode": "D",
    "dropkey": "PY26134",
    "droptype": "D",
    "dropname": "PUPOSKY",
    "dropdeladd": "1139 DURAND DR NW",
    "dropdelcty": "PUPOSKY",
    "dropdelst": "MN",
    "dropdelzpp": 566676956,
    "dropphyadd": "1139 DURAND DR NW",
    "dropphycty": "PUPOSKY",
    "dropphyst": "MN",
    "dropphyzpp": 566676956,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PUPOSKY",
    "dropmalst": "MN",
    "dropmalzpp": 566679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182432513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26138",
    "droptype": "D",
    "dropname": "RACINE",
    "dropdeladd": "11 PINE AVE NE",
    "dropdelcty": "RACINE",
    "dropdelst": "MN",
    "dropdelzpp": 559678810,
    "dropphyadd": "11 PINE AVE NE",
    "dropphycty": "RACINE",
    "dropphyst": "MN",
    "dropphyzpp": 559678810,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RACINE",
    "dropmalst": "MN",
    "dropmalzpp": 559679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073785141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26141",
    "droptype": "D",
    "dropname": "RANDALL",
    "dropdeladd": "303 PACIFIC AVE",
    "dropdelcty": "RANDALL",
    "dropdelst": "MN",
    "dropdelzpp": 564754400,
    "dropphyadd": "303 PACIFIC AVE",
    "dropphycty": "RANDALL",
    "dropphyst": "MN",
    "dropphyzpp": 564754400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDALL",
    "dropmalst": "MN",
    "dropmalzpp": 564759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3207492617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26143",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "4346 292ND ST E",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "MN",
    "dropdelzpp": 550659577,
    "dropphyadd": "4346 292ND ST E",
    "dropphycty": "RANDOLPH",
    "dropphyst": "MN",
    "dropphyzpp": 550659577,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "MN",
    "dropmalzpp": 550659998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076455812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26144",
    "droptype": "D",
    "dropname": "RANIER",
    "dropdeladd": "3479 DULUTH ST",
    "dropdelcty": "RANIER",
    "dropdelst": "MN",
    "dropdelzpp": 566682000,
    "dropphyadd": "3479 DULUTH ST",
    "dropphycty": "RANIER",
    "dropphyst": "MN",
    "dropphyzpp": 566682000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANIER",
    "dropmalst": "MN",
    "dropmalzpp": 566689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182863214,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26147",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "210 SPICER AVE N",
    "dropdelcty": "RAYMOND",
    "dropdelst": "MN",
    "dropdelzpp": 562825000,
    "dropphyadd": "210 SPICER AVE N",
    "dropphycty": "RAYMOND",
    "dropphyst": "MN",
    "dropphyzpp": 562825000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAYMOND",
    "dropmalst": "MN",
    "dropmalzpp": 562829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3209674434,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26152",
    "droptype": "D",
    "dropname": "RED LAKE FALLS",
    "dropdeladd": "118 CHAMPAGNE AVE SW",
    "dropdelcty": "RED LAKE FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 567509998,
    "dropphyadd": "118 CHAMPAGNE AVE SW",
    "dropphycty": "RED LAKE FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 567509998,
    "dropmaladd": "118 CHAMPAGNE AVE SW",
    "dropmalcty": "RED LAKE FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 567509998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182532794,
    "dropsitcph": 2182532794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26154",
    "droptype": "D",
    "dropname": "RED WING",
    "dropdeladd": "222 WEST AVE",
    "dropdelcty": "RED WING",
    "dropdelst": "MN",
    "dropdelzpp": 550662251,
    "dropphyadd": "222 WEST AVE",
    "dropphycty": "RED WING",
    "dropphyst": "MN",
    "dropphyzpp": 550662251,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED WING",
    "dropmalst": "MN",
    "dropmalzpp": 550669998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6513888637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26155",
    "droptype": "D",
    "dropname": "REDBY",
    "dropdeladd": "101 3RD ST",
    "dropdelcty": "REDBY",
    "dropdelst": "MN",
    "dropdelzpp": 566702000,
    "dropphyadd": "101 3RD ST",
    "dropphycty": "REDBY",
    "dropphyst": "MN",
    "dropphyzpp": 566702000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDBY",
    "dropmalst": "MN",
    "dropmalzpp": 566709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186792124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26156",
    "droptype": "D",
    "dropname": "RED LAKE",
    "dropdeladd": "115 STATE HIGHWAY 1",
    "dropdelcty": "RED LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 566714400,
    "dropphyadd": "115 STATE HIGHWAY 1",
    "dropphycty": "RED LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 566714400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 566719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186793929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26157",
    "droptype": "D",
    "dropname": "REDWOOD FALLS",
    "dropdeladd": "204 E 4TH ST",
    "dropdelcty": "REDWOOD FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 562831616,
    "dropphyadd": "204 E 4TH ST",
    "dropphycty": "REDWOOD FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 562831616,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDWOOD FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 562839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076378415,
    "dropfax": 5076373511
  },
  {
    "dcode": "D",
    "dropkey": "PY26160",
    "droptype": "D",
    "dropname": "REMER",
    "dropdeladd": "117 MAIN ST E",
    "dropdelcty": "REMER",
    "dropdelst": "MN",
    "dropdelzpp": 566724549,
    "dropphyadd": "117 MAIN ST E",
    "dropphycty": "REMER",
    "dropphyst": "MN",
    "dropphyzpp": 566724549,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REMER",
    "dropmalst": "MN",
    "dropmalzpp": 566729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 8773540949,
    "dropfax": 2185662281
  },
  {
    "dcode": "D",
    "dropkey": "PY26162",
    "droptype": "D",
    "dropname": "RENVILLE",
    "dropdeladd": "334 MAIN ST N",
    "dropdelcty": "RENVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 562845000,
    "dropphyadd": "334 MAIN ST N",
    "dropphycty": "RENVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 562845000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RENVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 562849998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203293166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26167",
    "droptype": "D",
    "dropname": "RICE",
    "dropdeladd": "135 MAIN ST E",
    "dropdelcty": "RICE",
    "dropdelst": "MN",
    "dropdelzpp": 563674400,
    "dropphyadd": "135 MAIN ST E",
    "dropphycty": "RICE",
    "dropphyst": "MN",
    "dropphyzpp": 563674400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICE",
    "dropmalst": "MN",
    "dropmalzpp": 563679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 3206549744,
    "dropsitcph": 3203780485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26173",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "312 CENTRAL AVE S",
    "dropdelcty": "RICHMOND",
    "dropdelst": "MN",
    "dropdelzpp": 563688190,
    "dropphyadd": "312 CENTRAL AVE S",
    "dropphycty": "RICHMOND",
    "dropphyst": "MN",
    "dropphyzpp": 563688190,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHMOND",
    "dropmalst": "MN",
    "dropmalzpp": 563689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202218006,
    "dropfax": 3205973293
  },
  {
    "dcode": "D",
    "dropkey": "PY26174",
    "droptype": "D",
    "dropname": "RICHVILLE",
    "dropdeladd": "120 MAIN ST S",
    "dropdelcty": "RICHVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 565769998,
    "dropphyadd": "120 MAIN ST S",
    "dropphycty": "RICHVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 565769998,
    "dropmaladd": "120 MAIN ST S",
    "dropmalcty": "RICHVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 565769998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183467510,
    "dropsitcph": 2183467510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26186",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "1445 VALLEYHIGH DR NW",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559019998,
    "dropphyadd": "1445 VALLEYHIGH DR NW",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559019998,
    "dropmaladd": "1445 VALLEYHIGH DR NW",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5072871268,
    "dropfax": 5072926074
  },
  {
    "dcode": "D",
    "dropkey": "PY26189",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "8950 WALNUT ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "MN",
    "dropdelzpp": 553734514,
    "dropphyadd": "8950 WALNUT ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "MN",
    "dropphyzpp": 553734514,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "MN",
    "dropmalzpp": 553739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634776692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26190",
    "droptype": "D",
    "dropname": "ROCKVILLE",
    "dropdeladd": "315 BROADWAY ST W",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 563694400,
    "dropphyadd": "315 BROADWAY ST W",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 563694400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 563699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202510176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26194",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "21125 JOHN MILLESS DR",
    "dropdelcty": "ROGERS",
    "dropdelst": "MN",
    "dropdelzpp": 553749400,
    "dropphyadd": "21125 JOHN MILLESS DR",
    "dropphycty": "ROGERS",
    "dropphyst": "MN",
    "dropphyzpp": 553749400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROGERS",
    "dropmalst": "MN",
    "dropmalzpp": 553749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634284105,
    "dropfax": 7634289186
  },
  {
    "dcode": "D",
    "dropkey": "PY26196",
    "droptype": "D",
    "dropname": "ROLLINGSTONE",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "ROLLINGSTONE",
    "dropdelst": "MN",
    "dropdelzpp": 559699761,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "ROLLINGSTONE",
    "dropphyst": "MN",
    "dropphyzpp": 559699761,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROLLINGSTONE",
    "dropmalst": "MN",
    "dropmalzpp": 559699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076892846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26197",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "10 N MAIN ST",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "MN",
    "dropdelzpp": 566732001,
    "dropphyadd": "10 N MAIN ST",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "MN",
    "dropphyzpp": 566732001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "MN",
    "dropmalzpp": 566739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184427000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26200",
    "droptype": "D",
    "dropname": "ROSE CREEK",
    "dropdeladd": "101 3RD ST S",
    "dropdelcty": "ROSE CREEK",
    "dropdelst": "MN",
    "dropdelzpp": 559708839,
    "dropphyadd": "101 3RD ST S",
    "dropphycty": "ROSE CREEK",
    "dropphyst": "MN",
    "dropphyzpp": 559708839,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSE CREEK",
    "dropmalst": "MN",
    "dropmalzpp": 559709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074332042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26202",
    "droptype": "D",
    "dropname": "ROSEAU",
    "dropdeladd": "114 CENTER ST E",
    "dropdelcty": "ROSEAU",
    "dropdelst": "MN",
    "dropdelzpp": 567519998,
    "dropphyadd": "114 CENTER ST E",
    "dropphycty": "ROSEAU",
    "dropphyst": "MN",
    "dropphyzpp": 567519998,
    "dropmaladd": "114 CENTER ST E",
    "dropmalcty": "ROSEAU",
    "dropmalst": "MN",
    "dropmalzpp": 567519998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184632243,
    "dropsitcph": 2184632243,
    "dropfax": 2184631480
  },
  {
    "dcode": "D",
    "dropkey": "PY26203",
    "droptype": "D",
    "dropname": "ROSEMOUNT",
    "dropdeladd": "3050 145TH ST W",
    "dropdelcty": "ROSEMOUNT",
    "dropdelst": "MN",
    "dropdelzpp": 550689906,
    "dropphyadd": "3050 145TH ST W",
    "dropphycty": "ROSEMOUNT",
    "dropphyst": "MN",
    "dropphyzpp": 550689906,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSEMOUNT",
    "dropmalst": "MN",
    "dropmalzpp": 550689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514234807,
    "dropsitcph": 6513227704,
    "dropfax": 6514232593
  },
  {
    "dcode": "D",
    "dropkey": "PY26212",
    "droptype": "D",
    "dropname": "ROTHSAY",
    "dropdeladd": "211 1ST ST SW",
    "dropdelcty": "ROTHSAY",
    "dropdelst": "MN",
    "dropdelzpp": 565799998,
    "dropphyadd": "211 1ST ST SW",
    "dropphycty": "ROTHSAY",
    "dropphyst": "MN",
    "dropphyzpp": 565799998,
    "dropmaladd": "211 1ST ST SW",
    "dropmalcty": "ROTHSAY",
    "dropmalst": "MN",
    "dropmalzpp": 565799998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188672447,
    "dropsitcph": 2188672447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26213",
    "droptype": "D",
    "dropname": "ROUND LAKE",
    "dropdeladd": "137 MAIN ST",
    "dropdelcty": "ROUND LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 561679712,
    "dropphyadd": "137 MAIN ST",
    "dropphycty": "ROUND LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 561679712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROUND LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 561679998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079458201,
    "dropfax": 5079458201
  },
  {
    "dcode": "D",
    "dropkey": "PY26214",
    "droptype": "D",
    "dropname": "ROYALTON",
    "dropdeladd": "208 E CENTRE ST",
    "dropdelcty": "ROYALTON",
    "dropdelst": "MN",
    "dropdelzpp": 563734404,
    "dropphyadd": "208 E CENTRE ST",
    "dropphycty": "ROYALTON",
    "dropphyst": "MN",
    "dropphyzpp": 563734404,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROYALTON",
    "dropmalst": "MN",
    "dropmalzpp": 563739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205845775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26219",
    "droptype": "D",
    "dropname": "RUSH CITY",
    "dropdeladd": "265 W 5TH ST",
    "dropdelcty": "RUSH CITY",
    "dropdelst": "MN",
    "dropdelzpp": 550696500,
    "dropphyadd": "265 W 5TH ST",
    "dropphycty": "RUSH CITY",
    "dropphyst": "MN",
    "dropphyzpp": 550696500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSH CITY",
    "dropmalst": "MN",
    "dropmalzpp": 550699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3203584433,
    "dropfax": 3203580984
  },
  {
    "dcode": "D",
    "dropkey": "PY26222",
    "droptype": "D",
    "dropname": "RUSHFORD",
    "dropdeladd": "501 S MILL ST",
    "dropdelcty": "RUSHFORD",
    "dropdelst": "MN",
    "dropdelzpp": 559718841,
    "dropphyadd": "501 S MILL ST",
    "dropphycty": "RUSHFORD",
    "dropphyst": "MN",
    "dropphyzpp": 559718841,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSHFORD",
    "dropmalst": "MN",
    "dropmalzpp": 559719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 5072050022,
    "dropsitcph": 5072050022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26223",
    "droptype": "D",
    "dropname": "RUSHMORE",
    "dropdeladd": "108 N THOMPSON AVE",
    "dropdelcty": "RUSHMORE",
    "dropdelst": "MN",
    "dropdelzpp": 561689500,
    "dropphyadd": "108 N THOMPSON AVE",
    "dropphycty": "RUSHMORE",
    "dropphyst": "MN",
    "dropphyzpp": 561689500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSHMORE",
    "dropmalst": "MN",
    "dropmalzpp": 561689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074784142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26224",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "310 FRONT ST",
    "dropdelcty": "RUSSELL",
    "dropdelst": "MN",
    "dropdelzpp": 561692000,
    "dropphyadd": "310 FRONT ST",
    "dropphycty": "RUSSELL",
    "dropphyst": "MN",
    "dropphyzpp": 561692000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSELL",
    "dropmalst": "MN",
    "dropmalzpp": 561699998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078234640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26225",
    "droptype": "D",
    "dropname": "RUTHTON",
    "dropdeladd": "420 AETNA ST",
    "dropdelcty": "RUTHTON",
    "dropdelst": "MN",
    "dropdelzpp": 561702000,
    "dropphyadd": "420 AETNA ST",
    "dropphycty": "RUTHTON",
    "dropphyst": "MN",
    "dropphyzpp": 561702000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTHTON",
    "dropmalst": "MN",
    "dropmalzpp": 561709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076583374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26233",
    "droptype": "D",
    "dropname": "SABIN",
    "dropdeladd": "18 MAIN ST",
    "dropdelcty": "SABIN",
    "dropdelst": "MN",
    "dropdelzpp": 565809998,
    "dropphyadd": "18 MAIN ST",
    "dropphycty": "SABIN",
    "dropphyst": "MN",
    "dropphyzpp": 565809998,
    "dropmaladd": "18 MAIN ST",
    "dropmalcty": "SABIN",
    "dropmalst": "MN",
    "dropmalzpp": 565809998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187897211,
    "dropsitcph": 2187897211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26234",
    "droptype": "D",
    "dropname": "SACRED HEART",
    "dropdeladd": "213 2ND AVE S",
    "dropdelcty": "SACRED HEART",
    "dropdelst": "MN",
    "dropdelzpp": 562855000,
    "dropphyadd": "213 2ND AVE S",
    "dropphycty": "SACRED HEART",
    "dropphyst": "MN",
    "dropphyzpp": 562855000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SACRED HEART",
    "dropmalst": "MN",
    "dropmalzpp": 562859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3207652698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26235",
    "droptype": "D",
    "dropname": "SAGINAW",
    "dropdeladd": "7027 SAGINAW RD",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MN",
    "dropdelzpp": 557799410,
    "dropphyadd": "7027 SAGINAW RD",
    "dropphycty": "SAGINAW",
    "dropphyst": "MN",
    "dropphyzpp": 557799410,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MN",
    "dropmalzpp": 557799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187298852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26238",
    "droptype": "D",
    "dropname": "SAINT BONIFACIUS",
    "dropdeladd": "4085 TOWER ST",
    "dropdelcty": "SAINT BONIFACIUS",
    "dropdelst": "MN",
    "dropdelzpp": 553751112,
    "dropphyadd": "4085 TOWER ST",
    "dropphycty": "SAINT BONIFACIUS",
    "dropphyst": "MN",
    "dropphyzpp": 553751112,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT BONIFACIUS",
    "dropmalst": "MN",
    "dropmalzpp": 553759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524461536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26239",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "1201 WHITEWATER AVE",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "MN",
    "dropdelzpp": 559721284,
    "dropphyadd": "1201 WHITEWATER AVE",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "MN",
    "dropphyzpp": 559721284,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "MN",
    "dropmalzpp": 559729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5079324552,
    "dropfax": 5079325449
  },
  {
    "dcode": "D",
    "dropkey": "PY26240",
    "droptype": "D",
    "dropname": "SAINT CLAIR",
    "dropdeladd": "116 PARK ST N",
    "dropdelcty": "SAINT CLAIR",
    "dropdelst": "MN",
    "dropdelzpp": 560804400,
    "dropphyadd": "116 PARK ST N",
    "dropphycty": "SAINT CLAIR",
    "dropphyst": "MN",
    "dropphyzpp": 560804400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT CLAIR",
    "dropmalst": "MN",
    "dropmalzpp": 560809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072453000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26242",
    "droptype": "D",
    "dropname": "SAINT CLOUD",
    "dropdeladd": "915 2ND ST N",
    "dropdelcty": "SAINT CLOUD",
    "dropdelst": "MN",
    "dropdelzpp": 563019998,
    "dropphyadd": "915 2ND ST N",
    "dropphycty": "SAINT CLOUD",
    "dropphyst": "MN",
    "dropphyzpp": 563019998,
    "dropmaladd": "915 2ND ST N",
    "dropmalcty": "SAINT CLOUD",
    "dropmalst": "MN",
    "dropmalzpp": 563019998,
    "dropsitphn": 3202513876,
    "dropsitlph": 3202513876,
    "dropsitcph": 3202518220,
    "dropfax": 3202513984
  },
  {
    "dcode": "D",
    "dropkey": "PY26243",
    "droptype": "D",
    "dropname": "SAINT FRANCIS",
    "dropdeladd": "3726 BRIDGE ST NW",
    "dropdelcty": "SAINT FRANCIS",
    "dropdelst": "MN",
    "dropdelzpp": 550707703,
    "dropphyadd": "3726 BRIDGE ST NW",
    "dropphycty": "SAINT FRANCIS",
    "dropphyst": "MN",
    "dropphyzpp": 550707703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT FRANCIS",
    "dropmalst": "MN",
    "dropmalzpp": 550709998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 7637533435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26244",
    "droptype": "D",
    "dropname": "SAINT HILAIRE",
    "dropdeladd": "302 N BROADWAY",
    "dropdelcty": "SAINT HILAIRE",
    "dropdelst": "MN",
    "dropdelzpp": 567549998,
    "dropphyadd": "302 N BROADWAY",
    "dropphycty": "SAINT HILAIRE",
    "dropphyst": "MN",
    "dropphyzpp": 567549998,
    "dropmaladd": "302 N BROADWAY",
    "dropmalcty": "SAINT HILAIRE",
    "dropmalst": "MN",
    "dropmalzpp": 567549998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189645240,
    "dropsitcph": 2189645240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26245",
    "droptype": "D",
    "dropname": "SAINT JAMES",
    "dropdeladd": "6 ARMSTRONG BLVD S",
    "dropdelcty": "SAINT JAMES",
    "dropdelst": "MN",
    "dropdelzpp": 560811863,
    "dropphyadd": "6 ARMSTRONG BLVD S",
    "dropphycty": "SAINT JAMES",
    "dropphyst": "MN",
    "dropphyzpp": 560811863,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT JAMES",
    "dropmalst": "MN",
    "dropmalzpp": 560819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073755271,
    "dropfax": 5073751347
  },
  {
    "dcode": "D",
    "dropkey": "PY26246",
    "droptype": "D",
    "dropname": "SAINT JOSEPH",
    "dropdeladd": "117 W ASH ST",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MN",
    "dropdelzpp": 563744400,
    "dropphyadd": "117 W ASH ST",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MN",
    "dropphyzpp": 563744400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MN",
    "dropmalzpp": 563749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203638360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26250",
    "droptype": "D",
    "dropname": "SAINT MARTIN",
    "dropdeladd": "135 MAINE ST",
    "dropdelcty": "SAINT MARTIN",
    "dropdelst": "MN",
    "dropdelzpp": 563764400,
    "dropphyadd": "135 MAINE ST",
    "dropphycty": "SAINT MARTIN",
    "dropphyst": "MN",
    "dropphyzpp": 563764400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT MARTIN",
    "dropmalst": "MN",
    "dropmalzpp": 563769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202237743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26251",
    "droptype": "D",
    "dropname": "SAINT MICHAEL",
    "dropdeladd": "405 CENTRAL AVE E STE 101",
    "dropdelcty": "SAINT MICHAEL",
    "dropdelst": "MN",
    "dropdelzpp": 553769503,
    "dropphyadd": "405 CENTRAL AVE E STE 101",
    "dropphycty": "SAINT MICHAEL",
    "dropphyst": "MN",
    "dropphyzpp": 553769503,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT MICHAEL",
    "dropmalst": "MN",
    "dropmalzpp": 553769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7634972219,
    "dropfax": 7634970187
  },
  {
    "dcode": "D",
    "dropkey": "PY26254",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "101 5TH ST E STE 150",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551019909,
    "dropphyadd": "101 5TH ST E STE 150",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551019909,
    "dropmaladd": "PO BOX 645014",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551645014,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933273,
    "dropsitcph": 6512224279,
    "dropfax": 6512920493
  },
  {
    "dcode": "D",
    "dropkey": "PY26256",
    "droptype": "D",
    "dropname": "SAINT PAUL PARK",
    "dropdeladd": "619 3RD ST",
    "dropdelcty": "SAINT PAUL PARK",
    "dropdelst": "MN",
    "dropdelzpp": 550711818,
    "dropphyadd": "619 3RD ST",
    "dropphycty": "SAINT PAUL PARK",
    "dropphyst": "MN",
    "dropphyzpp": 550711818,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PAUL PARK",
    "dropmalst": "MN",
    "dropmalzpp": 550719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514590042,
    "dropsitcph": 6514590042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26257",
    "droptype": "D",
    "dropname": "SAINT PETER",
    "dropdeladd": "300 S 3RD ST",
    "dropdelcty": "SAINT PETER",
    "dropdelst": "MN",
    "dropdelzpp": 560822023,
    "dropphyadd": "300 S 3RD ST",
    "dropphycty": "SAINT PETER",
    "dropphyst": "MN",
    "dropphyzpp": 560822023,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PETER",
    "dropmalst": "MN",
    "dropmalzpp": 560829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079311950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26263",
    "droptype": "D",
    "dropname": "SANBORN",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "SANBORN",
    "dropdelst": "MN",
    "dropdelzpp": 560834401,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "SANBORN",
    "dropphyst": "MN",
    "dropphyzpp": 560834401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANBORN",
    "dropmalst": "MN",
    "dropmalzpp": 560839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076483549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26265",
    "droptype": "D",
    "dropname": "SANDSTONE",
    "dropdeladd": "514 N MAIN",
    "dropdelcty": "SANDSTONE",
    "dropdelst": "MN",
    "dropdelzpp": 550726500,
    "dropphyadd": "514 N MAIN",
    "dropphycty": "SANDSTONE",
    "dropphyst": "MN",
    "dropphyzpp": 550726500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANDSTONE",
    "dropmalst": "MN",
    "dropmalzpp": 550729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3202452412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26270",
    "droptype": "D",
    "dropname": "SARTELL",
    "dropdeladd": "113 2ND ST S",
    "dropdelcty": "SARTELL",
    "dropdelst": "MN",
    "dropdelzpp": 563771917,
    "dropphyadd": "113 2ND ST S",
    "dropphycty": "SARTELL",
    "dropphyst": "MN",
    "dropphyzpp": 563771917,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARTELL",
    "dropmalst": "MN",
    "dropmalzpp": 563779998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202525125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26272",
    "droptype": "D",
    "dropname": "SAUK CENTRE",
    "dropdeladd": "400 MAIN ST S",
    "dropdelcty": "SAUK CENTRE",
    "dropdelst": "MN",
    "dropdelzpp": 563781509,
    "dropphyadd": "400 MAIN ST S",
    "dropphycty": "SAUK CENTRE",
    "dropphyst": "MN",
    "dropphyzpp": 563781509,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAUK CENTRE",
    "dropmalst": "MN",
    "dropmalzpp": 563789998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3203523435,
    "dropfax": 3203522836
  },
  {
    "dcode": "D",
    "dropkey": "PY26278",
    "droptype": "D",
    "dropname": "SAVAGE",
    "dropdeladd": "6100 MCCOLL DR",
    "dropdelcty": "SAVAGE",
    "dropdelst": "MN",
    "dropdelzpp": 553789901,
    "dropphyadd": "6100 MCCOLL DR",
    "dropphycty": "SAVAGE",
    "dropphyst": "MN",
    "dropphyzpp": 553789901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAVAGE",
    "dropmalst": "MN",
    "dropmalzpp": 553789998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9527070857,
    "dropsitcph": 9527070857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26280",
    "droptype": "D",
    "dropname": "SAWYER",
    "dropdeladd": "3252 HIGHWAY 210",
    "dropdelcty": "SAWYER",
    "dropdelst": "MN",
    "dropdelzpp": 557805000,
    "dropphyadd": "3252 HIGHWAY 210",
    "dropphycty": "SAWYER",
    "dropphyst": "MN",
    "dropphyzpp": 557805000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAWYER",
    "dropmalst": "MN",
    "dropmalzpp": 557809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188794759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26281",
    "droptype": "D",
    "dropname": "SCANDIA",
    "dropdeladd": "21190 OZARK AVE N",
    "dropdelcty": "SCANDIA",
    "dropdelst": "MN",
    "dropdelzpp": 550739447,
    "dropphyadd": "21190 OZARK AVE N",
    "dropphycty": "SCANDIA",
    "dropphyst": "MN",
    "dropphyzpp": 550739447,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCANDIA",
    "dropmalst": "MN",
    "dropmalzpp": 550739998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514335155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26284",
    "droptype": "D",
    "dropname": "SCHROEDER",
    "dropdeladd": "7940 W HIGHWAY 61",
    "dropdelcty": "SCHROEDER",
    "dropdelst": "MN",
    "dropdelzpp": 556138717,
    "dropphyadd": "7940 W HIGHWAY 61",
    "dropphycty": "SCHROEDER",
    "dropphyst": "MN",
    "dropphyzpp": 556138717,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHROEDER",
    "dropmalst": "MN",
    "dropmalzpp": 556139998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186637568,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26287",
    "droptype": "D",
    "dropname": "SEBEKA",
    "dropdeladd": "107 MINNESOTA AVE W",
    "dropdelcty": "SEBEKA",
    "dropdelst": "MN",
    "dropdelzpp": 564776004,
    "dropphyadd": "107 MINNESOTA AVE W",
    "dropphycty": "SEBEKA",
    "dropphyst": "MN",
    "dropphyzpp": 564776004,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEBEKA",
    "dropmalst": "MN",
    "dropmalzpp": 564779998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182559895,
    "dropfax": 2182559892
  },
  {
    "dcode": "D",
    "dropkey": "PY26290",
    "droptype": "D",
    "dropname": "SHAFER",
    "dropdeladd": "30180 REDFIELD BLVD",
    "dropdelcty": "SHAFER",
    "dropdelst": "MN",
    "dropdelzpp": 550749680,
    "dropphyadd": "30180 REDFIELD BLVD",
    "dropphycty": "SHAFER",
    "dropphyst": "MN",
    "dropphyzpp": 550749680,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAFER",
    "dropmalst": "MN",
    "dropmalzpp": 550749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6512576717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26292",
    "droptype": "D",
    "dropname": "SHAKOPEE",
    "dropdeladd": "135 SOMMERVILLE ST S",
    "dropdelcty": "SHAKOPEE",
    "dropdelst": "MN",
    "dropdelzpp": 553799915,
    "dropphyadd": "135 SOMMERVILLE ST S",
    "dropphycty": "SHAKOPEE",
    "dropphyst": "MN",
    "dropphyzpp": 553799915,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAKOPEE",
    "dropmalst": "MN",
    "dropmalzpp": 553799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9524452312,
    "dropsitcph": 9524030215,
    "dropfax": 9524969722
  },
  {
    "dcode": "D",
    "dropkey": "PY26296",
    "droptype": "D",
    "dropname": "SHELLY",
    "dropdeladd": "109 W MCKINLEY AVE",
    "dropdelcty": "SHELLY",
    "dropdelst": "MN",
    "dropdelzpp": 565819998,
    "dropphyadd": "109 W MCKINLEY AVE",
    "dropphycty": "SHELLY",
    "dropphyst": "MN",
    "dropphyzpp": 565819998,
    "dropmaladd": "109 W MCKINLEY AVE",
    "dropmalcty": "SHELLY",
    "dropmalst": "MN",
    "dropmalzpp": 565819998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2182754008,
    "dropsitcph": 2182754008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26297",
    "droptype": "D",
    "dropname": "SHERBURN",
    "dropdeladd": "127 N MAIN ST",
    "dropdelcty": "SHERBURN",
    "dropdelst": "MN",
    "dropdelzpp": 561711104,
    "dropphyadd": "127 N MAIN ST",
    "dropphycty": "SHERBURN",
    "dropphyst": "MN",
    "dropphyzpp": 561711104,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERBURN",
    "dropmalst": "MN",
    "dropmalzpp": 561719998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077647341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26299",
    "droptype": "D",
    "dropname": "SHEVLIN",
    "dropdeladd": "148 BROADWAY AVE S",
    "dropdelcty": "SHEVLIN",
    "dropdelst": "MN",
    "dropdelzpp": 566762001,
    "dropphyadd": "148 BROADWAY AVE S",
    "dropphycty": "SHEVLIN",
    "dropphyst": "MN",
    "dropphyzpp": 566762001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHEVLIN",
    "dropmalst": "MN",
    "dropmalzpp": 566769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187852492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26308",
    "droptype": "D",
    "dropname": "SIDE LAKE",
    "dropdeladd": "7481 MCCARTHY BEACH RD",
    "dropdelcty": "SIDE LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 557818438,
    "dropphyadd": "7481 MCCARTHY BEACH RD",
    "dropphycty": "SIDE LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 557818438,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIDE LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 557819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182543076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26311",
    "droptype": "D",
    "dropname": "SILVER BAY",
    "dropdeladd": "13 SHOPPING CTR",
    "dropdelcty": "SILVER BAY",
    "dropdelst": "MN",
    "dropdelzpp": 556141135,
    "dropphyadd": "13 SHOPPING CTR",
    "dropphycty": "SILVER BAY",
    "dropphyst": "MN",
    "dropphyzpp": 556141135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER BAY",
    "dropmalst": "MN",
    "dropmalzpp": 556149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182263700,
    "dropfax": 2182264819
  },
  {
    "dcode": "D",
    "dropkey": "PY26315",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "113 MAIN ST W",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 553816062,
    "dropphyadd": "113 MAIN ST W",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 553816062,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 553819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203272155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26323",
    "droptype": "D",
    "dropname": "SLAYTON",
    "dropdeladd": "2541 BROADWAY AVE",
    "dropdelcty": "SLAYTON",
    "dropdelst": "MN",
    "dropdelzpp": 561721337,
    "dropphyadd": "2541 BROADWAY AVE",
    "dropphycty": "SLAYTON",
    "dropphyst": "MN",
    "dropphyzpp": 561721337,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLAYTON",
    "dropmalst": "MN",
    "dropmalzpp": 561729998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078366890,
    "dropfax": 5078366853
  },
  {
    "dcode": "D",
    "dropkey": "PY26324",
    "droptype": "D",
    "dropname": "SLEEPY EYE",
    "dropdeladd": "141 1ST AVE N",
    "dropdelcty": "SLEEPY EYE",
    "dropdelst": "MN",
    "dropdelzpp": 560851301,
    "dropphyadd": "141 1ST AVE N",
    "dropphycty": "SLEEPY EYE",
    "dropphyst": "MN",
    "dropphyzpp": 560851301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLEEPY EYE",
    "dropmalst": "MN",
    "dropmalzpp": 560859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077945081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26336",
    "droptype": "D",
    "dropname": "SOLWAY",
    "dropdeladd": "218 CENTERLINE RD N",
    "dropdelcty": "SOLWAY",
    "dropdelst": "MN",
    "dropdelzpp": 566784362,
    "dropphyadd": "218 CENTERLINE RD N",
    "dropphycty": "SOLWAY",
    "dropphyst": "MN",
    "dropphyzpp": 566784362,
    "dropmaladd": "218 CENTERLINE RD N",
    "dropmalcty": "SOLWAY",
    "dropmalst": "MN",
    "dropmalzpp": 566784362,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184673375,
    "dropfax": 2184673259
  },
  {
    "dcode": "D",
    "dropkey": "PY26337",
    "droptype": "D",
    "dropname": "SOUDAN",
    "dropdeladd": "31 1ST AVE",
    "dropdelcty": "SOUDAN",
    "dropdelst": "MN",
    "dropdelzpp": 557825000,
    "dropphyadd": "31 1ST AVE",
    "dropphycty": "SOUDAN",
    "dropphyst": "MN",
    "dropphyzpp": 557825000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUDAN",
    "dropmalst": "MN",
    "dropmalzpp": 557829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187536410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26338",
    "droptype": "D",
    "dropname": "SOUTH HAVEN",
    "dropdeladd": "524 OAK AVE N",
    "dropdelcty": "SOUTH HAVEN",
    "dropdelst": "MN",
    "dropdelzpp": 553823865,
    "dropphyadd": "524 OAK AVE N",
    "dropphycty": "SOUTH HAVEN",
    "dropphyst": "MN",
    "dropphyzpp": 553823865,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH HAVEN",
    "dropmalst": "MN",
    "dropmalzpp": 553829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202367711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26340",
    "droptype": "D",
    "dropname": "SOUTH INTERNATIONAL FALLS",
    "dropdeladd": "15 18TH ST E",
    "dropdelcty": "SOUTH INTERNATIONAL FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 566795000,
    "dropphyadd": "15 18TH ST E",
    "dropphycty": "SOUTH INTERNATIONAL FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 566795000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH INTERNATIONAL FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 566799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182838470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26342",
    "droptype": "D",
    "dropname": "SOUTH SAINT PAUL",
    "dropdeladd": "236 CONCORD EXCHANGE N",
    "dropdelcty": "SOUTH SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 550759902,
    "dropphyadd": "236 CONCORD EXCHANGE N",
    "dropphycty": "SOUTH SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 550759902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 550759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514518577,
    "dropfax": 6515521756
  },
  {
    "dcode": "D",
    "dropkey": "PY26351",
    "droptype": "D",
    "dropname": "SPICER",
    "dropdeladd": "186 PROGRESS WAY",
    "dropdelcty": "SPICER",
    "dropdelst": "MN",
    "dropdelzpp": 562885000,
    "dropphyadd": "186 PROGRESS WAY",
    "dropphycty": "SPICER",
    "dropphyst": "MN",
    "dropphyzpp": 562885000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPICER",
    "dropmalst": "MN",
    "dropmalzpp": 562889998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3207962530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26354",
    "droptype": "D",
    "dropname": "SPRING GROVE",
    "dropdeladd": "125 S DIVISION AVE",
    "dropdelcty": "SPRING GROVE",
    "dropdelst": "MN",
    "dropdelzpp": 559741118,
    "dropphyadd": "125 S DIVISION AVE",
    "dropphycty": "SPRING GROVE",
    "dropphyst": "MN",
    "dropphyzpp": 559741118,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING GROVE",
    "dropmalst": "MN",
    "dropmalzpp": 559749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074985329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26355",
    "droptype": "D",
    "dropname": "SPRING LAKE",
    "dropdeladd": "48501 COUNTY ROAD 4",
    "dropdelcty": "SPRING LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 566802000,
    "dropphyadd": "48501 COUNTY ROAD 4",
    "dropphycty": "SPRING LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 566802000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 566809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188323626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26361",
    "droptype": "D",
    "dropname": "SPRING PARK",
    "dropdeladd": "4044 SUNSET DR",
    "dropdelcty": "SPRING PARK",
    "dropdelst": "MN",
    "dropdelzpp": 553849632,
    "dropphyadd": "4044 SUNSET DR",
    "dropphycty": "SPRING PARK",
    "dropphyst": "MN",
    "dropphyzpp": 553849632,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING PARK",
    "dropmalst": "MN",
    "dropmalzpp": 553849998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524719284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26363",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "209 N BROADWAY ST",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "MN",
    "dropdelzpp": 559751225,
    "dropphyadd": "209 N BROADWAY ST",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "MN",
    "dropphyzpp": 559751225,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "MN",
    "dropmalzpp": 559759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073462114,
    "dropfax": 5073469969
  },
  {
    "dcode": "D",
    "dropkey": "PY26365",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "18 W CENTRAL ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 560871402,
    "dropphyadd": "18 W CENTRAL ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 560871402,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 560879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077235656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26368",
    "droptype": "D",
    "dropname": "SQUAW LAKE",
    "dropdeladd": "51879 STATE HIGHWAY 46",
    "dropdelcty": "SQUAW LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 566814500,
    "dropphyadd": "51879 STATE HIGHWAY 46",
    "dropphycty": "SQUAW LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 566814500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SQUAW LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 566819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183355002,
    "dropfax": 2183355003
  },
  {
    "dcode": "D",
    "dropkey": "PY26467",
    "droptype": "D",
    "dropname": "STACY",
    "dropdeladd": "31140 FOREST BLVD",
    "dropdelcty": "STACY",
    "dropdelst": "MN",
    "dropdelzpp": 550799247,
    "dropphyadd": "31140 FOREST BLVD",
    "dropphycty": "STACY",
    "dropphyst": "MN",
    "dropphyzpp": 550799247,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STACY",
    "dropmalst": "MN",
    "dropmalzpp": 550799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514624984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26468",
    "droptype": "D",
    "dropname": "STANCHFIELD",
    "dropdeladd": "38930 STANCHFIELD RD NE",
    "dropdelcty": "STANCHFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 550805049,
    "dropphyadd": "38930 STANCHFIELD RD NE",
    "dropphycty": "STANCHFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 550805049,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANCHFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 550809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 3203962400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26472",
    "droptype": "D",
    "dropname": "STAPLES",
    "dropdeladd": "229 4TH ST NE",
    "dropdelcty": "STAPLES",
    "dropdelst": "MN",
    "dropdelzpp": 564792427,
    "dropphyadd": "229 4TH ST NE",
    "dropphycty": "STAPLES",
    "dropphyst": "MN",
    "dropphyzpp": 564792427,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STAPLES",
    "dropmalst": "MN",
    "dropmalzpp": 564799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188941954,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26473",
    "droptype": "D",
    "dropname": "STARBUCK",
    "dropdeladd": "109 E 6TH ST",
    "dropdelcty": "STARBUCK",
    "dropdelst": "MN",
    "dropdelzpp": 563814400,
    "dropphyadd": "109 E 6TH ST",
    "dropphycty": "STARBUCK",
    "dropphyst": "MN",
    "dropphyzpp": 563814400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STARBUCK",
    "dropmalst": "MN",
    "dropmalzpp": 563819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3202392312,
    "dropfax": 3202392312
  },
  {
    "dcode": "D",
    "dropkey": "PY26480",
    "droptype": "D",
    "dropname": "STEPHEN",
    "dropdeladd": "422 5TH ST",
    "dropdelcty": "STEPHEN",
    "dropdelst": "MN",
    "dropdelzpp": 567579998,
    "dropphyadd": "422 5TH ST",
    "dropphycty": "STEPHEN",
    "dropphyst": "MN",
    "dropphyzpp": 567579998,
    "dropmaladd": "422 5TH ST",
    "dropmalcty": "STEPHEN",
    "dropmalst": "MN",
    "dropmalzpp": 567579998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184783513,
    "dropsitcph": 2184783513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26481",
    "droptype": "D",
    "dropname": "STEWART",
    "dropdeladd": "707 HALL ST",
    "dropdelcty": "STEWART",
    "dropdelst": "MN",
    "dropdelzpp": 553858457,
    "dropphyadd": "707 HALL ST",
    "dropphycty": "STEWART",
    "dropphyst": "MN",
    "dropphyzpp": 553858457,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEWART",
    "dropmalst": "MN",
    "dropmalzpp": 553859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205622348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26482",
    "droptype": "D",
    "dropname": "STEWARTVILLE",
    "dropdeladd": "120 2ND ST SE",
    "dropdelcty": "STEWARTVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 559761306,
    "dropphyadd": "120 2ND ST SE",
    "dropphycty": "STEWARTVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 559761306,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEWARTVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 559769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075334571,
    "dropfax": 5075338280
  },
  {
    "dcode": "D",
    "dropkey": "PY26485",
    "droptype": "D",
    "dropname": "STILLWATER",
    "dropdeladd": "216 MYRTLE ST W",
    "dropdelcty": "STILLWATER",
    "dropdelst": "MN",
    "dropdelzpp": 550824805,
    "dropphyadd": "216 MYRTLE ST W",
    "dropphycty": "STILLWATER",
    "dropphyst": "MN",
    "dropphyzpp": 550824805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STILLWATER",
    "dropmalst": "MN",
    "dropmalzpp": 550829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6513519378,
    "dropsitcph": 6514397710,
    "dropfax": 6514395882
  },
  {
    "dcode": "D",
    "dropkey": "PY26490",
    "droptype": "D",
    "dropname": "STORDEN",
    "dropdeladd": "320 AMERICA ST",
    "dropdelcty": "STORDEN",
    "dropdelst": "MN",
    "dropdelzpp": 561742074,
    "dropphyadd": "320 AMERICA ST",
    "dropphycty": "STORDEN",
    "dropphyst": "MN",
    "dropphyzpp": 561742074,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STORDEN",
    "dropmalst": "MN",
    "dropmalzpp": 561749998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074453916,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26491",
    "droptype": "D",
    "dropname": "STRANDQUIST",
    "dropdeladd": "108 MAIN ST",
    "dropdelcty": "STRANDQUIST",
    "dropdelst": "MN",
    "dropdelzpp": 567589998,
    "dropphyadd": "108 MAIN ST",
    "dropphycty": "STRANDQUIST",
    "dropphyst": "MN",
    "dropphyzpp": 567589998,
    "dropmaladd": "108 MAIN ST",
    "dropmalcty": "STRANDQUIST",
    "dropmalst": "MN",
    "dropmalzpp": 567589998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185972617,
    "dropsitcph": 2185972617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26492",
    "droptype": "D",
    "dropname": "STRATHCONA",
    "dropdeladd": "111 S 1ST ST",
    "dropdelcty": "STRATHCONA",
    "dropdelst": "MN",
    "dropdelzpp": 567599998,
    "dropphyadd": "111 S 1ST ST",
    "dropphycty": "STRATHCONA",
    "dropphyst": "MN",
    "dropphyzpp": 567599998,
    "dropmaladd": "111 S 1ST ST",
    "dropmalcty": "STRATHCONA",
    "dropmalst": "MN",
    "dropmalzpp": 567599998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187812660,
    "dropsitcph": 2187812660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26494",
    "droptype": "D",
    "dropname": "STURGEON LAKE",
    "dropdeladd": "8992 1ST AVE",
    "dropdelcty": "STURGEON LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 557838785,
    "dropphyadd": "8992 1ST AVE",
    "dropphycty": "STURGEON LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 557838785,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STURGEON LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 557839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183723116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26499",
    "droptype": "D",
    "dropname": "SUNBURG",
    "dropdeladd": "316 CENTRAL AVE",
    "dropdelcty": "SUNBURG",
    "dropdelst": "MN",
    "dropdelzpp": 562895001,
    "dropphyadd": "316 CENTRAL AVE",
    "dropphycty": "SUNBURG",
    "dropphyst": "MN",
    "dropphyzpp": 562895001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNBURG",
    "dropmalst": "MN",
    "dropmalzpp": 562899998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3203663553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26507",
    "droptype": "D",
    "dropname": "SWANVILLE",
    "dropdeladd": "310 DEGRAFF AVE",
    "dropdelcty": "SWANVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 563824400,
    "dropphyadd": "310 DEGRAFF AVE",
    "dropphycty": "SWANVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 563824400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SWANVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 563829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205472922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26515",
    "droptype": "D",
    "dropname": "TACONITE",
    "dropdeladd": "28 HAYNES ST S",
    "dropdelcty": "TACONITE",
    "dropdelst": "MN",
    "dropdelzpp": 557865000,
    "dropphyadd": "28 HAYNES ST S",
    "dropphycty": "TACONITE",
    "dropphyst": "MN",
    "dropphyzpp": 557865000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TACONITE",
    "dropmalst": "MN",
    "dropmalzpp": 557869998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2182451580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26517",
    "droptype": "D",
    "dropname": "TAMARACK",
    "dropdeladd": "275 MAIN ST N",
    "dropdelcty": "TAMARACK",
    "dropdelst": "MN",
    "dropdelzpp": 557875000,
    "dropphyadd": "275 MAIN ST N",
    "dropphycty": "TAMARACK",
    "dropphyst": "MN",
    "dropphyzpp": 557875000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAMARACK",
    "dropmalst": "MN",
    "dropmalzpp": 557879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183574008,
    "dropfax": 2183574009
  },
  {
    "dcode": "D",
    "dropkey": "PY26519",
    "droptype": "D",
    "dropname": "TAUNTON",
    "dropdeladd": "104 N MAIN ST",
    "dropdelcty": "TAUNTON",
    "dropdelst": "MN",
    "dropdelzpp": 562915000,
    "dropphyadd": "104 N MAIN ST",
    "dropphycty": "TAUNTON",
    "dropphyst": "MN",
    "dropphyzpp": 562915000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAUNTON",
    "dropmalst": "MN",
    "dropmalzpp": 562919998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078726870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26520",
    "droptype": "D",
    "dropname": "TAYLORS FALLS",
    "dropdeladd": "554 BENCH ST",
    "dropdelcty": "TAYLORS FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 550841126,
    "dropphyadd": "554 BENCH ST",
    "dropphycty": "TAYLORS FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 550841126,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLORS FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 550849998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514656424,
    "dropfax": 6514656424
  },
  {
    "dcode": "D",
    "dropkey": "PY26524",
    "droptype": "D",
    "dropname": "TENSTRIKE",
    "dropdeladd": "171 3RD AVE N",
    "dropdelcty": "TENSTRIKE",
    "dropdelst": "MN",
    "dropdelzpp": 566832225,
    "dropphyadd": "171 3RD AVE N",
    "dropphycty": "TENSTRIKE",
    "dropphyst": "MN",
    "dropphyzpp": 566832225,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TENSTRIKE",
    "dropmalst": "MN",
    "dropmalzpp": 566839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185863333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26527",
    "droptype": "D",
    "dropname": "THIEF RIVER FALLS",
    "dropdeladd": "121 LABREE AVE N",
    "dropdelcty": "THIEF RIVER FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 567019998,
    "dropphyadd": "121 LABREE AVE N",
    "dropphycty": "THIEF RIVER FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 567019998,
    "dropmaladd": "121 LABREE AVE N",
    "dropmalcty": "THIEF RIVER FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 567019998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2186813053,
    "dropsitcph": 2186813053,
    "dropfax": 2186811092
  },
  {
    "dcode": "D",
    "dropkey": "PY26534",
    "droptype": "D",
    "dropname": "TOFTE",
    "dropdeladd": "7223 TOFTE PARK RD",
    "dropdelcty": "TOFTE",
    "dropdelst": "MN",
    "dropdelzpp": 556154400,
    "dropphyadd": "7223 TOFTE PARK RD",
    "dropphycty": "TOFTE",
    "dropphyst": "MN",
    "dropphyzpp": 556154400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOFTE",
    "dropmalst": "MN",
    "dropmalzpp": 556159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186637985,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26541",
    "droptype": "D",
    "dropname": "TOWER",
    "dropdeladd": "508 MAIN ST",
    "dropdelcty": "TOWER",
    "dropdelst": "MN",
    "dropdelzpp": 557905003,
    "dropphyadd": "508 MAIN ST",
    "dropphycty": "TOWER",
    "dropphyst": "MN",
    "dropphyzpp": 557905003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOWER",
    "dropmalst": "MN",
    "dropmalzpp": 557909998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187535797,
    "dropfax": 2187535797
  },
  {
    "dcode": "D",
    "dropkey": "PY26544",
    "droptype": "D",
    "dropname": "TRACY",
    "dropdeladd": "100 3RD ST",
    "dropdelcty": "TRACY",
    "dropdelst": "MN",
    "dropdelzpp": 561751212,
    "dropphyadd": "100 3RD ST",
    "dropphycty": "TRACY",
    "dropphyst": "MN",
    "dropphyzpp": 561751212,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRACY",
    "dropmalst": "MN",
    "dropmalzpp": 561759998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076294260,
    "dropfax": 5076294260
  },
  {
    "dcode": "D",
    "dropkey": "PY26547",
    "droptype": "D",
    "dropname": "TRIMONT",
    "dropdeladd": "11 MAIN ST E",
    "dropdelcty": "TRIMONT",
    "dropdelst": "MN",
    "dropdelzpp": 561769601,
    "dropphyadd": "11 MAIN ST E",
    "dropphycty": "TRIMONT",
    "dropphyst": "MN",
    "dropphyzpp": 561769601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRIMONT",
    "dropmalst": "MN",
    "dropmalzpp": 561769998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076396111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26551",
    "droptype": "D",
    "dropname": "TRUMAN",
    "dropdeladd": "310 W CIRO ST",
    "dropdelcty": "TRUMAN",
    "dropdelst": "MN",
    "dropdelzpp": 560882182,
    "dropphyadd": "310 W CIRO ST",
    "dropphycty": "TRUMAN",
    "dropphyst": "MN",
    "dropphyzpp": 560882182,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRUMAN",
    "dropmalst": "MN",
    "dropmalzpp": 560889998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077762931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26559",
    "droptype": "D",
    "dropname": "TWIN LAKES",
    "dropdeladd": "206 MAIN ST E",
    "dropdelcty": "TWIN LAKES",
    "dropdelst": "MN",
    "dropdelzpp": 560894401,
    "dropphyadd": "206 MAIN ST E",
    "dropphycty": "TWIN LAKES",
    "dropphyst": "MN",
    "dropphyzpp": 560894401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWIN LAKES",
    "dropmalst": "MN",
    "dropmalzpp": 560899998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078522202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26561",
    "droptype": "D",
    "dropname": "TWIN VALLEY",
    "dropdeladd": "106 MAIN AVE W",
    "dropdelcty": "TWIN VALLEY",
    "dropdelst": "MN",
    "dropdelzpp": 565849998,
    "dropphyadd": "106 MAIN AVE W",
    "dropphycty": "TWIN VALLEY",
    "dropphyst": "MN",
    "dropphyzpp": 565849998,
    "dropmaladd": "106 MAIN AVE W",
    "dropmalcty": "TWIN VALLEY",
    "dropmalst": "MN",
    "dropmalzpp": 565849998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185848689,
    "dropsitcph": 2185848689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26562",
    "droptype": "D",
    "dropname": "TWO HARBORS",
    "dropdeladd": "106 WATERFRONT DR",
    "dropdelcty": "TWO HARBORS",
    "dropdelst": "MN",
    "dropdelzpp": 556167000,
    "dropphyadd": "106 WATERFRONT DR",
    "dropphycty": "TWO HARBORS",
    "dropphyst": "MN",
    "dropphyzpp": 556167000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWO HARBORS",
    "dropmalst": "MN",
    "dropmalzpp": 556169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2188343430,
    "dropfax": 2188347154
  },
  {
    "dcode": "D",
    "dropkey": "PY26563",
    "droptype": "D",
    "dropname": "TYLER",
    "dropdeladd": "263 N TYLER ST",
    "dropdelcty": "TYLER",
    "dropdelst": "MN",
    "dropdelzpp": 561781161,
    "dropphyadd": "263 N TYLER ST",
    "dropphycty": "TYLER",
    "dropphyst": "MN",
    "dropphyzpp": 561781161,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYLER",
    "dropmalst": "MN",
    "dropmalzpp": 561789998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072475484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26564",
    "droptype": "D",
    "dropname": "ULEN",
    "dropdeladd": "15 1ST ST NW",
    "dropdelcty": "ULEN",
    "dropdelst": "MN",
    "dropdelzpp": 565859998,
    "dropphyadd": "15 1ST ST NW",
    "dropphycty": "ULEN",
    "dropphyst": "MN",
    "dropphyzpp": 565859998,
    "dropmaladd": "15 1ST ST NW",
    "dropmalcty": "ULEN",
    "dropmalst": "MN",
    "dropmalzpp": 565859998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185968872,
    "dropsitcph": 2185968872,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26565",
    "droptype": "D",
    "dropname": "UNDERWOOD",
    "dropdeladd": "113 MAIN ST S",
    "dropdelcty": "UNDERWOOD",
    "dropdelst": "MN",
    "dropdelzpp": 565869998,
    "dropphyadd": "113 MAIN ST S",
    "dropphycty": "UNDERWOOD",
    "dropphyst": "MN",
    "dropphyzpp": 565869998,
    "dropmaladd": "113 MAIN ST S",
    "dropmalcty": "UNDERWOOD",
    "dropmalst": "MN",
    "dropmalzpp": 565869998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2188266646,
    "dropsitcph": 2188266646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26567",
    "droptype": "D",
    "dropname": "UPSALA",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "UPSALA",
    "dropdelst": "MN",
    "dropdelzpp": 563848412,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "UPSALA",
    "dropphyst": "MN",
    "dropphyzpp": 563848412,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UPSALA",
    "dropmalst": "MN",
    "dropmalzpp": 563849998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205732620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26570",
    "droptype": "D",
    "dropname": "UTICA",
    "dropdeladd": "112 W MAIN ST N",
    "dropdelcty": "UTICA",
    "dropdelst": "MN",
    "dropdelzpp": 559796500,
    "dropphyadd": "112 W MAIN ST N",
    "dropphycty": "UTICA",
    "dropphyst": "MN",
    "dropphyzpp": 559796500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UTICA",
    "dropmalst": "MN",
    "dropmalzpp": 559799998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5079323730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26579",
    "droptype": "D",
    "dropname": "VERGAS",
    "dropdeladd": "123 E MAIN ST",
    "dropdelcty": "VERGAS",
    "dropdelst": "MN",
    "dropdelzpp": 565879998,
    "dropphyadd": "123 E MAIN ST",
    "dropphycty": "VERGAS",
    "dropphyst": "MN",
    "dropphyzpp": 565879998,
    "dropmaladd": "123 E MAIN ST",
    "dropmalcty": "VERGAS",
    "dropmalst": "MN",
    "dropmalzpp": 565879998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183422911,
    "dropsitcph": 2183422911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26581",
    "droptype": "D",
    "dropname": "VERMILLION",
    "dropdeladd": "108 PARK AVE",
    "dropdelcty": "VERMILLION",
    "dropdelst": "MN",
    "dropdelzpp": 550856500,
    "dropphyadd": "108 PARK AVE",
    "dropphycty": "VERMILLION",
    "dropphyst": "MN",
    "dropphyzpp": 550856500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERMILLION",
    "dropmalst": "MN",
    "dropmalzpp": 550859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514377944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26582",
    "droptype": "D",
    "dropname": "VERNDALE",
    "dropdeladd": "122 S FARWELL ST",
    "dropdelcty": "VERNDALE",
    "dropdelst": "MN",
    "dropdelzpp": 564814500,
    "dropphyadd": "122 S FARWELL ST",
    "dropphycty": "VERNDALE",
    "dropphyst": "MN",
    "dropphyzpp": 564814500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERNDALE",
    "dropmalst": "MN",
    "dropmalzpp": 564819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184455850,
    "dropfax": 2184455850
  },
  {
    "dcode": "D",
    "dropkey": "PY26583",
    "droptype": "D",
    "dropname": "VERNON CENTER",
    "dropdeladd": "107 E MAIN ST",
    "dropdelcty": "VERNON CENTER",
    "dropdelst": "MN",
    "dropdelzpp": 560904401,
    "dropphyadd": "107 E MAIN ST",
    "dropphycty": "VERNON CENTER",
    "dropphyst": "MN",
    "dropphyzpp": 560904401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERNON CENTER",
    "dropmalst": "MN",
    "dropmalzpp": 560909998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075493596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26586",
    "droptype": "D",
    "dropname": "VESTA",
    "dropdeladd": "109 S FRONT ST",
    "dropdelcty": "VESTA",
    "dropdelst": "MN",
    "dropdelzpp": 562925000,
    "dropphyadd": "109 S FRONT ST",
    "dropphycty": "VESTA",
    "dropphyst": "MN",
    "dropphyzpp": 562925000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VESTA",
    "dropmalst": "MN",
    "dropmalzpp": 562929998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077623174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26587",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "7972 VICTORIA DR",
    "dropdelcty": "VICTORIA",
    "dropdelst": "MN",
    "dropdelzpp": 553867728,
    "dropphyadd": "7972 VICTORIA DR",
    "dropphycty": "VICTORIA",
    "dropphyst": "MN",
    "dropphyzpp": 553867728,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VICTORIA",
    "dropmalst": "MN",
    "dropmalzpp": 553869998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524432662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26588",
    "droptype": "D",
    "dropname": "VIKING",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "VIKING",
    "dropdelst": "MN",
    "dropdelzpp": 567609998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "VIKING",
    "dropphyst": "MN",
    "dropphyzpp": 567609998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "VIKING",
    "dropmalst": "MN",
    "dropmalzpp": 567609998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2185234355,
    "dropsitcph": 2185234355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26589",
    "droptype": "D",
    "dropname": "VILLARD",
    "dropdeladd": "602 LAKE ST",
    "dropdelcty": "VILLARD",
    "dropdelst": "MN",
    "dropdelzpp": 563854400,
    "dropphyadd": "602 LAKE ST",
    "dropphycty": "VILLARD",
    "dropphyst": "MN",
    "dropphyzpp": 563854400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILLARD",
    "dropmalst": "MN",
    "dropmalzpp": 563859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3205543444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26591",
    "droptype": "D",
    "dropname": "VINING",
    "dropdeladd": "3005 FRONT ST",
    "dropdelcty": "VINING",
    "dropdelst": "MN",
    "dropdelzpp": 565889998,
    "dropphyadd": "3005 FRONT ST",
    "dropphycty": "VINING",
    "dropphyst": "MN",
    "dropphyzpp": 565889998,
    "dropmaladd": "3005 FRONT ST",
    "dropmalcty": "VINING",
    "dropmalst": "MN",
    "dropmalzpp": 565889998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187694172,
    "dropsitcph": 2182718007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26593",
    "droptype": "D",
    "dropname": "VIRGINIA",
    "dropdeladd": "231 1ST ST S",
    "dropdelcty": "VIRGINIA",
    "dropdelst": "MN",
    "dropdelzpp": 557925050,
    "dropphyadd": "231 1ST ST S",
    "dropphycty": "VIRGINIA",
    "dropphyst": "MN",
    "dropphyzpp": 557925050,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIRGINIA",
    "dropmalst": "MN",
    "dropmalzpp": 557929998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2187414919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26602",
    "droptype": "D",
    "dropname": "WABASHA",
    "dropdeladd": "109 MAIN ST E",
    "dropdelcty": "WABASHA",
    "dropdelst": "MN",
    "dropdelzpp": 559811420,
    "dropphyadd": "109 MAIN ST E",
    "dropphycty": "WABASHA",
    "dropphyst": "MN",
    "dropphyzpp": 559811420,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WABASHA",
    "dropmalst": "MN",
    "dropmalzpp": 559819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6515653909,
    "dropfax": 6515650302
  },
  {
    "dcode": "D",
    "dropkey": "PY26603",
    "droptype": "D",
    "dropname": "WABASSO",
    "dropdeladd": "733 MAIN ST",
    "dropdelcty": "WABASSO",
    "dropdelst": "MN",
    "dropdelzpp": 562939900,
    "dropphyadd": "733 MAIN ST",
    "dropphycty": "WABASSO",
    "dropphyst": "MN",
    "dropphyzpp": 562939900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WABASSO",
    "dropmalst": "MN",
    "dropmalzpp": 562939998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073425629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26605",
    "droptype": "D",
    "dropname": "WACONIA",
    "dropdeladd": "208 S ELM ST",
    "dropdelcty": "WACONIA",
    "dropdelst": "MN",
    "dropdelzpp": 553871405,
    "dropphyadd": "208 S ELM ST",
    "dropphycty": "WACONIA",
    "dropphyst": "MN",
    "dropphyzpp": 553871405,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WACONIA",
    "dropmalst": "MN",
    "dropmalzpp": 553879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524422928,
    "dropfax": 9528521788
  },
  {
    "dcode": "D",
    "dropkey": "PY26606",
    "droptype": "D",
    "dropname": "WADENA",
    "dropdeladd": "23 BRYANT AVE SE",
    "dropdelcty": "WADENA",
    "dropdelst": "MN",
    "dropdelzpp": 564821543,
    "dropphyadd": "23 BRYANT AVE SE",
    "dropphycty": "WADENA",
    "dropphyst": "MN",
    "dropphyzpp": 564821543,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADENA",
    "dropmalst": "MN",
    "dropmalzpp": 564829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186312903,
    "dropfax": 2186313229
  },
  {
    "dcode": "D",
    "dropkey": "PY26609",
    "droptype": "D",
    "dropname": "WAHKON",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "WAHKON",
    "dropdelst": "MN",
    "dropdelzpp": 563864400,
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "WAHKON",
    "dropphyst": "MN",
    "dropphyzpp": 563864400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAHKON",
    "dropmalst": "MN",
    "dropmalzpp": 563869998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 3204952020,
    "dropfax": 3202722600
  },
  {
    "dcode": "D",
    "dropkey": "PY26614",
    "droptype": "D",
    "dropname": "WALDORF",
    "dropdeladd": "109 S MAIN ST",
    "dropdelcty": "WALDORF",
    "dropdelst": "MN",
    "dropdelzpp": 560914401,
    "dropphyadd": "109 S MAIN ST",
    "dropphycty": "WALDORF",
    "dropphyst": "MN",
    "dropphyzpp": 560914401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALDORF",
    "dropmalst": "MN",
    "dropmalzpp": 560919998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072392130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26615",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "515 MICHIGAN AVE W",
    "dropdelcty": "WALKER",
    "dropdelst": "MN",
    "dropdelzpp": 564844500,
    "dropphyadd": "515 MICHIGAN AVE W",
    "dropphycty": "WALKER",
    "dropphyst": "MN",
    "dropphyzpp": 564844500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALKER",
    "dropmalst": "MN",
    "dropmalzpp": 564849998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185471123,
    "dropfax": 2185471321
  },
  {
    "dcode": "D",
    "dropkey": "PY26617",
    "droptype": "D",
    "dropname": "WALNUT GROVE",
    "dropdeladd": "610 MAIN ST",
    "dropdelcty": "WALNUT GROVE",
    "dropdelst": "MN",
    "dropdelzpp": 561801136,
    "dropphyadd": "610 MAIN ST",
    "dropphycty": "WALNUT GROVE",
    "dropphyst": "MN",
    "dropphyzpp": 561801136,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALNUT GROVE",
    "dropmalst": "MN",
    "dropmalzpp": 561809998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078592463,
    "dropfax": 5078593032
  },
  {
    "dcode": "D",
    "dropkey": "PY26620",
    "droptype": "D",
    "dropname": "WALTHAM",
    "dropdeladd": "223 MAIN ST S",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MN",
    "dropdelzpp": 559826500,
    "dropphyadd": "223 MAIN ST S",
    "dropphycty": "WALTHAM",
    "dropphyst": "MN",
    "dropphyzpp": 559826500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MN",
    "dropmalzpp": 559829998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074772521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26621",
    "droptype": "D",
    "dropname": "WANAMINGO",
    "dropdeladd": "208 MAIN ST",
    "dropdelcty": "WANAMINGO",
    "dropdelst": "MN",
    "dropdelzpp": 559833848,
    "dropphyadd": "208 MAIN ST",
    "dropphycty": "WANAMINGO",
    "dropphyst": "MN",
    "dropphyzpp": 559833848,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WANAMINGO",
    "dropmalst": "MN",
    "dropmalzpp": 559839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5078242474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26622",
    "droptype": "D",
    "dropname": "WANDA",
    "dropdeladd": "201 W MAIN ST",
    "dropdelcty": "WANDA",
    "dropdelst": "MN",
    "dropdelzpp": 562945000,
    "dropphyadd": "201 W MAIN ST",
    "dropphycty": "WANDA",
    "dropphyst": "MN",
    "dropphyzpp": 562945000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WANDA",
    "dropmalst": "MN",
    "dropmalzpp": 562949998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072744255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26623",
    "droptype": "D",
    "dropname": "WANNASKA",
    "dropdeladd": "39985 181ST ST",
    "dropdelcty": "WANNASKA",
    "dropdelst": "MN",
    "dropdelzpp": 567619998,
    "dropphyadd": "39985 181ST ST",
    "dropphycty": "WANNASKA",
    "dropphyst": "MN",
    "dropphyzpp": 567619998,
    "dropmaladd": "39985 181ST ST",
    "dropmalcty": "WANNASKA",
    "dropmalst": "MN",
    "dropmalzpp": 567619998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184253731,
    "dropsitcph": 2184253731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26624",
    "droptype": "D",
    "dropname": "WARBA",
    "dropdeladd": "112 BRIDGE ST",
    "dropdelcty": "WARBA",
    "dropdelst": "MN",
    "dropdelzpp": 557935000,
    "dropphyadd": "112 BRIDGE ST",
    "dropphycty": "WARBA",
    "dropphyst": "MN",
    "dropphyzpp": 557935000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARBA",
    "dropmalst": "MN",
    "dropmalzpp": 557939998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2184924505,
    "dropfax": 2184924586
  },
  {
    "dcode": "D",
    "dropkey": "PY26626",
    "droptype": "D",
    "dropname": "WARREN",
    "dropdeladd": "520 N MINNESOTA ST",
    "dropdelcty": "WARREN",
    "dropdelst": "MN",
    "dropdelzpp": 567629998,
    "dropphyadd": "520 N MINNESOTA ST",
    "dropphycty": "WARREN",
    "dropphyst": "MN",
    "dropphyzpp": 567629998,
    "dropmaladd": "520 N MINNESOTA ST",
    "dropmalcty": "WARREN",
    "dropmalst": "MN",
    "dropmalzpp": 567629998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2187454581,
    "dropsitcph": 2187454581,
    "dropfax": 2187459216
  },
  {
    "dcode": "D",
    "dropkey": "PY26627",
    "droptype": "D",
    "dropname": "WARROAD",
    "dropdeladd": "204 MAIN AVE NE",
    "dropdelcty": "WARROAD",
    "dropdelst": "MN",
    "dropdelzpp": 567639998,
    "dropphyadd": "204 MAIN AVE NE",
    "dropphycty": "WARROAD",
    "dropphyst": "MN",
    "dropphyzpp": 567639998,
    "dropmaladd": "204 MAIN AVE NE",
    "dropmalcty": "WARROAD",
    "dropmalst": "MN",
    "dropmalzpp": 567639998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2183861052,
    "dropsitcph": 2183861052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26628",
    "droptype": "D",
    "dropname": "WARSAW",
    "dropdeladd": "6493 234TH ST W",
    "dropdelcty": "WARSAW",
    "dropdelst": "MN",
    "dropdelzpp": 550876500,
    "dropphyadd": "6493 234TH ST W",
    "dropphycty": "WARSAW",
    "dropphyst": "MN",
    "dropphyzpp": 550876500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARSAW",
    "dropmalst": "MN",
    "dropmalzpp": 550879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076854555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26629",
    "droptype": "D",
    "dropname": "WASECA",
    "dropdeladd": "114 2ND ST NE",
    "dropdelcty": "WASECA",
    "dropdelst": "MN",
    "dropdelzpp": 560932902,
    "dropphyadd": "114 2ND ST NE",
    "dropphycty": "WASECA",
    "dropphyst": "MN",
    "dropphyzpp": 560932902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASECA",
    "dropmalst": "MN",
    "dropmalzpp": 560939998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078354020,
    "dropfax": 5078352654
  },
  {
    "dcode": "D",
    "dropkey": "PY26631",
    "droptype": "D",
    "dropname": "WASKISH",
    "dropdeladd": "54997 HIGHWAY 72 NE",
    "dropdelcty": "WASKISH",
    "dropdelst": "MN",
    "dropdelzpp": 566854034,
    "dropphyadd": "54997 HIGHWAY 72 NE",
    "dropphycty": "WASKISH",
    "dropphyst": "MN",
    "dropphyzpp": 566854034,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WASKISH",
    "dropmalst": "MN",
    "dropmalzpp": 566859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2186478492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26634",
    "droptype": "D",
    "dropname": "WATERTOWN",
    "dropdeladd": "402 LEWIS AVE S",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "MN",
    "dropdelzpp": 553884504,
    "dropphyadd": "402 LEWIS AVE S",
    "dropphycty": "WATERTOWN",
    "dropphyst": "MN",
    "dropphyzpp": 553884504,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "MN",
    "dropmalzpp": 553889998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9529552300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26636",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "125 3RD ST N",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "MN",
    "dropdelzpp": 560961442,
    "dropphyadd": "125 3RD ST N",
    "dropphycty": "WATERVILLE",
    "dropphyst": "MN",
    "dropphyzpp": 560961442,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "MN",
    "dropmalzpp": 560969998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073624648,
    "dropfax": 5073624648
  },
  {
    "dcode": "D",
    "dropkey": "PY26637",
    "droptype": "D",
    "dropname": "WATKINS",
    "dropdeladd": "161 CEDAR AVE N",
    "dropdelcty": "WATKINS",
    "dropdelst": "MN",
    "dropdelzpp": 553891117,
    "dropphyadd": "161 CEDAR AVE N",
    "dropphycty": "WATKINS",
    "dropphyst": "MN",
    "dropphyzpp": 553891117,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATKINS",
    "dropmalst": "MN",
    "dropmalzpp": 553899998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202218003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26638",
    "droptype": "D",
    "dropname": "WATSON",
    "dropdeladd": "501 COUNTY ROAD 9",
    "dropdelcty": "WATSON",
    "dropdelst": "MN",
    "dropdelzpp": 562955000,
    "dropphyadd": "501 COUNTY ROAD 9",
    "dropphycty": "WATSON",
    "dropphyst": "MN",
    "dropphyzpp": 562955000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATSON",
    "dropmalst": "MN",
    "dropmalzpp": 562959998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 6122697623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26639",
    "droptype": "D",
    "dropname": "WAUBUN",
    "dropdeladd": "1015 1ST ST",
    "dropdelcty": "WAUBUN",
    "dropdelst": "MN",
    "dropdelzpp": 565899998,
    "dropphyadd": "1015 1ST ST",
    "dropphycty": "WAUBUN",
    "dropphyst": "MN",
    "dropphyzpp": 565899998,
    "dropmaladd": "1015 1ST ST",
    "dropmalcty": "WAUBUN",
    "dropmalst": "MN",
    "dropmalzpp": 565899998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184732183,
    "dropsitcph": 2184732183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26641",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "304 5TH ST N",
    "dropdelcty": "WAVERLY",
    "dropdelst": "MN",
    "dropdelzpp": 553905034,
    "dropphyadd": "304 5TH ST N",
    "dropphycty": "WAVERLY",
    "dropphyst": "MN",
    "dropphyzpp": 553905034,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAVERLY",
    "dropmalst": "MN",
    "dropmalzpp": 553909998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632471369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26643",
    "droptype": "D",
    "dropname": "WAYZATA",
    "dropdeladd": "229 MINNETONKA AVE S",
    "dropdelcty": "WAYZATA",
    "dropdelst": "MN",
    "dropdelzpp": 553919933,
    "dropphyadd": "229 MINNETONKA AVE S",
    "dropphycty": "WAYZATA",
    "dropphyst": "MN",
    "dropphyzpp": 553919933,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAYZATA",
    "dropmalst": "MN",
    "dropmalzpp": 553919998,
    "dropsitphn": 6123496399,
    "dropsitlph": 7637450570,
    "dropsitcph": 9524756809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26646",
    "droptype": "D",
    "dropname": "WEBSTER",
    "dropdeladd": "4472 40TH ST W",
    "dropdelcty": "WEBSTER",
    "dropdelst": "MN",
    "dropdelzpp": 550882124,
    "dropphyadd": "4472 40TH ST W",
    "dropphycty": "WEBSTER",
    "dropphyst": "MN",
    "dropphyzpp": 550882124,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEBSTER",
    "dropmalst": "MN",
    "dropmalzpp": 550889998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 9526522815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26648",
    "droptype": "D",
    "dropname": "WELCH",
    "dropdeladd": "14691 WELCH TRL",
    "dropdelcty": "WELCH",
    "dropdelst": "MN",
    "dropdelzpp": 550896500,
    "dropphyadd": "14691 WELCH TRL",
    "dropphycty": "WELCH",
    "dropphyst": "MN",
    "dropphyzpp": 550896500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELCH",
    "dropmalst": "MN",
    "dropmalzpp": 550899998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6512584225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26649",
    "droptype": "D",
    "dropname": "WELCOME",
    "dropdeladd": "113 DUGAN ST N",
    "dropdelcty": "WELCOME",
    "dropdelst": "MN",
    "dropdelzpp": 561819707,
    "dropphyadd": "113 DUGAN ST N",
    "dropphycty": "WELCOME",
    "dropphyst": "MN",
    "dropphyzpp": 561819707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELCOME",
    "dropmalst": "MN",
    "dropmalzpp": 561819998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077288661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26650",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "40 S BROADWAY",
    "dropdelcty": "WELLS",
    "dropdelst": "MN",
    "dropdelzpp": 560971633,
    "dropphyadd": "40 S BROADWAY",
    "dropphycty": "WELLS",
    "dropphyst": "MN",
    "dropphyzpp": 560971633,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLS",
    "dropmalst": "MN",
    "dropmalzpp": 560979998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5075535608,
    "dropfax": 5075535609
  },
  {
    "dcode": "D",
    "dropkey": "PY26651",
    "droptype": "D",
    "dropname": "WENDELL",
    "dropdeladd": "542 STATE HIGHWAY 55",
    "dropdelcty": "WENDELL",
    "dropdelst": "MN",
    "dropdelzpp": 565909998,
    "dropphyadd": "542 STATE HIGHWAY 55",
    "dropphycty": "WENDELL",
    "dropphyst": "MN",
    "dropphyzpp": 565909998,
    "dropmaladd": "542 STATE HIGHWAY 55",
    "dropmalcty": "WENDELL",
    "dropmalst": "MN",
    "dropmalzpp": 565909998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2184582175,
    "dropsitcph": 2184582175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26653",
    "droptype": "D",
    "dropname": "WEST CONCORD",
    "dropdeladd": "251 W MAIN ST",
    "dropdelcty": "WEST CONCORD",
    "dropdelst": "MN",
    "dropdelzpp": 559852003,
    "dropphyadd": "251 W MAIN ST",
    "dropphycty": "WEST CONCORD",
    "dropphyst": "MN",
    "dropphyzpp": 559852003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST CONCORD",
    "dropmalst": "MN",
    "dropmalzpp": 559859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5075272776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26664",
    "droptype": "D",
    "dropname": "WESTBROOK",
    "dropdeladd": "734 6TH ST",
    "dropdelcty": "WESTBROOK",
    "dropdelst": "MN",
    "dropdelzpp": 561839782,
    "dropphyadd": "734 6TH ST",
    "dropphycty": "WESTBROOK",
    "dropphyst": "MN",
    "dropphyzpp": 561839782,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTBROOK",
    "dropmalst": "MN",
    "dropmalzpp": 561839998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072746711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26666",
    "droptype": "D",
    "dropname": "WHEATON",
    "dropdeladd": "1107 BROADWAY",
    "dropdelcty": "WHEATON",
    "dropdelst": "MN",
    "dropdelzpp": 562961307,
    "dropphyadd": "1107 BROADWAY",
    "dropphycty": "WHEATON",
    "dropphyst": "MN",
    "dropphyzpp": 562961307,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHEATON",
    "dropmalst": "MN",
    "dropmalzpp": 562969998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3205634954,
    "dropfax": 3205634954
  },
  {
    "dcode": "D",
    "dropkey": "PY26675",
    "droptype": "D",
    "dropname": "WHITE EARTH",
    "dropdeladd": "26246 CRANE RD",
    "dropdelcty": "WHITE EARTH",
    "dropdelst": "MN",
    "dropdelzpp": 565919998,
    "dropphyadd": "26246 CRANE RD",
    "dropphycty": "WHITE EARTH",
    "dropphyst": "MN",
    "dropphyzpp": 565919998,
    "dropmaladd": "26246 CRANE RD",
    "dropmalcty": "WHITE EARTH",
    "dropmalst": "MN",
    "dropmalzpp": 565919998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189833661,
    "dropsitcph": 2189833661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26682",
    "droptype": "D",
    "dropname": "WILLERNIE",
    "dropdeladd": "105 WILDWOOD RD",
    "dropdelcty": "WILLERNIE",
    "dropdelst": "MN",
    "dropdelzpp": 550906500,
    "dropphyadd": "105 WILDWOOD RD",
    "dropphycty": "WILLERNIE",
    "dropphyst": "MN",
    "dropphyzpp": 550906500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLERNIE",
    "dropmalst": "MN",
    "dropmalzpp": 550909998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516531204,
    "dropsitcph": 6516531204,
    "dropfax": 6516530984
  },
  {
    "dcode": "D",
    "dropkey": "PY26683",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "24 MAIN ST",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "MN",
    "dropdelzpp": 566864601,
    "dropphyadd": "24 MAIN ST",
    "dropphycty": "WILLIAMS",
    "dropphyst": "MN",
    "dropphyzpp": 566864601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "MN",
    "dropmalzpp": 566869998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183953006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26685",
    "droptype": "D",
    "dropname": "WILLMAR",
    "dropdeladd": "401 TROTT AVE SW",
    "dropdelcty": "WILLMAR",
    "dropdelst": "MN",
    "dropdelzpp": 562013367,
    "dropphyadd": "401 TROTT AVE SW",
    "dropphycty": "WILLMAR",
    "dropphyst": "MN",
    "dropphyzpp": 562013367,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLMAR",
    "dropmalst": "MN",
    "dropmalzpp": 562019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3202352472,
    "dropfax": 3202357942
  },
  {
    "dcode": "D",
    "dropkey": "PY26687",
    "droptype": "D",
    "dropname": "WILLOW RIVER",
    "dropdeladd": "3002 MAIN ST",
    "dropdelcty": "WILLOW RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 557955000,
    "dropphyadd": "3002 MAIN ST",
    "dropphycty": "WILLOW RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 557955000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLOW RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 557959998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183723595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26689",
    "droptype": "D",
    "dropname": "WILMONT",
    "dropdeladd": "315 4TH AVE",
    "dropdelcty": "WILMONT",
    "dropdelst": "MN",
    "dropdelzpp": 561859702,
    "dropphyadd": "315 4TH AVE",
    "dropphycty": "WILMONT",
    "dropphyst": "MN",
    "dropphyzpp": 561859702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILMONT",
    "dropmalst": "MN",
    "dropmalzpp": 561859998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5079265181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26696",
    "droptype": "D",
    "dropname": "WINDOM",
    "dropdeladd": "445 9TH ST",
    "dropdelcty": "WINDOM",
    "dropdelst": "MN",
    "dropdelzpp": 561011640,
    "dropphyadd": "445 9TH ST",
    "dropphycty": "WINDOM",
    "dropphyst": "MN",
    "dropphyzpp": 561011640,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINDOM",
    "dropmalst": "MN",
    "dropmalzpp": 561019998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078312595,
    "dropfax": 5078312206
  },
  {
    "dcode": "D",
    "dropkey": "PY26698",
    "droptype": "D",
    "dropname": "WINGER",
    "dropdeladd": "14 S MAIN ST",
    "dropdelcty": "WINGER",
    "dropdelst": "MN",
    "dropdelzpp": 565929998,
    "dropphyadd": "14 S MAIN ST",
    "dropphycty": "WINGER",
    "dropphyst": "MN",
    "dropphyzpp": 565929998,
    "dropmaladd": "14 S MAIN ST",
    "dropmalcty": "WINGER",
    "dropmalst": "MN",
    "dropmalzpp": 565929998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189384455,
    "dropsitcph": 2189384455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26699",
    "droptype": "D",
    "dropname": "WINNEBAGO",
    "dropdeladd": "24 MAIN ST S",
    "dropdelcty": "WINNEBAGO",
    "dropdelst": "MN",
    "dropdelzpp": 560981010,
    "dropphyadd": "24 MAIN ST S",
    "dropphycty": "WINNEBAGO",
    "dropphyst": "MN",
    "dropphyzpp": 560981010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINNEBAGO",
    "dropmalst": "MN",
    "dropmalzpp": 560989998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5078934180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26700",
    "droptype": "D",
    "dropname": "WINONA",
    "dropdeladd": "67 W 5TH ST",
    "dropdelcty": "WINONA",
    "dropdelst": "MN",
    "dropdelzpp": 559873556,
    "dropphyadd": "67 W 5TH ST",
    "dropphycty": "WINONA",
    "dropphyst": "MN",
    "dropphyzpp": 559873556,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINONA",
    "dropmalst": "MN",
    "dropmalzpp": 559879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5074545268,
    "dropfax": 5074520108
  },
  {
    "dcode": "D",
    "dropkey": "PY26702",
    "droptype": "D",
    "dropname": "WINSTED",
    "dropdeladd": "155 MAIN AVE W",
    "dropdelcty": "WINSTED",
    "dropdelst": "MN",
    "dropdelzpp": 553957873,
    "dropphyadd": "155 MAIN AVE W",
    "dropphycty": "WINSTED",
    "dropphyst": "MN",
    "dropphyzpp": 553957873,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINSTED",
    "dropmalst": "MN",
    "dropmalzpp": 553959998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 3204852310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26703",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "215 E 2ND ST",
    "dropdelcty": "WINTHROP",
    "dropdelst": "MN",
    "dropdelzpp": 553962390,
    "dropphyadd": "215 E 2ND ST",
    "dropphycty": "WINTHROP",
    "dropphyst": "MN",
    "dropphyzpp": 553962390,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINTHROP",
    "dropmalst": "MN",
    "dropmalzpp": 553969998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076475348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26709",
    "droptype": "D",
    "dropname": "WOLVERTON",
    "dropdeladd": "333 KING OF TRAILS PKWY",
    "dropdelcty": "WOLVERTON",
    "dropdelst": "MN",
    "dropdelzpp": 565949998,
    "dropphyadd": "333 KING OF TRAILS PKWY",
    "dropphycty": "WOLVERTON",
    "dropphyst": "MN",
    "dropphyzpp": 565949998,
    "dropmaladd": "333 KING OF TRAILS PKWY",
    "dropmalcty": "WOLVERTON",
    "dropmalst": "MN",
    "dropmalzpp": 565949998,
    "dropsitphn": 6053574932,
    "dropsitlph": 2189952062,
    "dropsitcph": 2189952062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26710",
    "droptype": "D",
    "dropname": "WOOD LAKE",
    "dropdeladd": "1 2ND AVE",
    "dropdelcty": "WOOD LAKE",
    "dropdelst": "MN",
    "dropdelzpp": 562975000,
    "dropphyadd": "1 2ND AVE",
    "dropphycty": "WOOD LAKE",
    "dropphyst": "MN",
    "dropphyzpp": 562975000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOOD LAKE",
    "dropmalst": "MN",
    "dropmalzpp": 562979998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5074284065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26716",
    "droptype": "D",
    "dropname": "WOODSTOCK",
    "dropdeladd": "209 MAIN ST N",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "MN",
    "dropdelzpp": 561861101,
    "dropphyadd": "209 MAIN ST N",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "MN",
    "dropphyzpp": 561861101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "MN",
    "dropmalzpp": 561869998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5077774299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26718",
    "droptype": "D",
    "dropname": "WORTHINGTON",
    "dropdeladd": "850 10TH ST",
    "dropdelcty": "WORTHINGTON",
    "dropdelst": "MN",
    "dropdelzpp": 561872760,
    "dropphyadd": "850 10TH ST",
    "dropphycty": "WORTHINGTON",
    "dropphyst": "MN",
    "dropphyzpp": 561872760,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WORTHINGTON",
    "dropmalst": "MN",
    "dropmalzpp": 561879998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5073764870,
    "dropfax": 5073727116
  },
  {
    "dcode": "D",
    "dropkey": "PY26720",
    "droptype": "D",
    "dropname": "WRENSHALL",
    "dropdeladd": "104 BROADWAY",
    "dropdelcty": "WRENSHALL",
    "dropdelst": "MN",
    "dropdelzpp": 557975000,
    "dropphyadd": "104 BROADWAY",
    "dropphycty": "WRENSHALL",
    "dropphyst": "MN",
    "dropphyzpp": 557975000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WRENSHALL",
    "dropmalst": "MN",
    "dropmalzpp": 557979998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183844721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26721",
    "droptype": "D",
    "dropname": "WRIGHT",
    "dropdeladd": "6703 PACIFIC AVE",
    "dropdelcty": "WRIGHT",
    "dropdelst": "MN",
    "dropdelzpp": 557988273,
    "dropphyadd": "6703 PACIFIC AVE",
    "dropphycty": "WRIGHT",
    "dropphyst": "MN",
    "dropphyzpp": 557988273,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WRIGHT",
    "dropmalst": "MN",
    "dropmalzpp": 557989998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2183572936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26722",
    "droptype": "D",
    "dropname": "WYKOFF",
    "dropdeladd": "110 GOLD ST N",
    "dropdelcty": "WYKOFF",
    "dropdelst": "MN",
    "dropdelzpp": 559908734,
    "dropphyadd": "110 GOLD ST N",
    "dropphycty": "WYKOFF",
    "dropphyst": "MN",
    "dropphyzpp": 559908734,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYKOFF",
    "dropmalst": "MN",
    "dropmalzpp": 559909998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5073525131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26724",
    "droptype": "D",
    "dropname": "WYOMING",
    "dropdeladd": "26824 FELTON AVE",
    "dropdelcty": "WYOMING",
    "dropdelst": "MN",
    "dropdelzpp": 550929031,
    "dropphyadd": "26824 FELTON AVE",
    "dropphycty": "WYOMING",
    "dropphyst": "MN",
    "dropphyzpp": 550929031,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WYOMING",
    "dropmalst": "MN",
    "dropmalzpp": 550929998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 6514625252,
    "dropfax": 6514621734
  },
  {
    "dcode": "D",
    "dropkey": "PY26725",
    "droptype": "D",
    "dropname": "NORWOOD YOUNG AMERICA",
    "dropdeladd": "400 MERGER ST",
    "dropdelcty": "NORWOOD YOUNG AMERICA",
    "dropdelst": "MN",
    "dropdelzpp": 553689301,
    "dropphyadd": "400 MERGER ST",
    "dropphycty": "NORWOOD YOUNG AMERICA",
    "dropphyst": "MN",
    "dropphyzpp": 553689301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWOOD YOUNG AMERICA",
    "dropmalst": "MN",
    "dropmalzpp": 553689998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 9524672341,
    "dropfax": 9524672374
  },
  {
    "dcode": "D",
    "dropkey": "PY26729",
    "droptype": "D",
    "dropname": "ZIMMERMAN",
    "dropdeladd": "26278 2ND ST E",
    "dropdelcty": "ZIMMERMAN",
    "dropdelst": "MN",
    "dropdelzpp": 553984672,
    "dropphyadd": "26278 2ND ST E",
    "dropphycty": "ZIMMERMAN",
    "dropphyst": "MN",
    "dropphyzpp": 553984672,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZIMMERMAN",
    "dropmalst": "MN",
    "dropmalzpp": 553989998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7638569540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PY26730",
    "droptype": "D",
    "dropname": "ZUMBRO FALLS",
    "dropdeladd": "477 HIGHWAY 60",
    "dropdelcty": "ZUMBRO FALLS",
    "dropdelst": "MN",
    "dropdelzpp": 559915501,
    "dropphyadd": "477 HIGHWAY 60",
    "dropphycty": "ZUMBRO FALLS",
    "dropphyst": "MN",
    "dropphyzpp": 559915501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZUMBRO FALLS",
    "dropmalst": "MN",
    "dropmalzpp": 559919998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077533023,
    "dropfax": 5077533023
  },
  {
    "dcode": "D",
    "dropkey": "PY26732",
    "droptype": "D",
    "dropname": "ZUMBROTA",
    "dropdeladd": "138 W 5TH ST",
    "dropdelcty": "ZUMBROTA",
    "dropdelst": "MN",
    "dropdelzpp": 559921651,
    "dropphyadd": "138 W 5TH ST",
    "dropphycty": "ZUMBROTA",
    "dropphyst": "MN",
    "dropphyzpp": 559921651,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZUMBROTA",
    "dropmalst": "MN",
    "dropmalzpp": 559929998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5077325515,
    "dropfax": 5077325515
  },
  {
    "dcode": "D",
    "dropkey": "PY26929",
    "droptype": "D",
    "dropname": "TEXARKANA",
    "dropdeladd": "500 N STATE LINE AVE STE 101",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "AR",
    "dropdelzpp": 718549998,
    "dropphyadd": "500 N STATE LINE AVE STE 101",
    "dropphycty": "TEXARKANA",
    "dropphyst": "AR",
    "dropphyzpp": 718549998,
    "dropmaladd": "500 N STATE LINE AVE STE 101",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "AR",
    "dropmalzpp": 718549998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032233819,
    "dropsitcph": 9037923794,
    "dropfax": 9037928717
  },
  {
    "dcode": "D",
    "dropkey": "PY27131",
    "droptype": "D",
    "dropname": "MANASOTA",
    "dropdeladd": "850 TALLEVAST RD STE 9998",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342609852,
    "dropphyadd": "850 TALLEVAST RD STE 9998",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342609852,
    "dropmaladd": "850 TALLEVAST RD",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342605000,
    "dropsitphn": 8138893938,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413595109,
    "dropfax": 9413595177
  },
  {
    "dcode": "D",
    "dropkey": "PY28007",
    "droptype": "D",
    "dropname": "DELTONA",
    "dropdeladd": "944 DELTONA BLVD",
    "dropdelcty": "DELTONA",
    "dropdelst": "FL",
    "dropdelzpp": 327256913,
    "dropphyadd": "944 DELTONA BLVD",
    "dropphycty": "DELTONA",
    "dropphyst": "FL",
    "dropphyzpp": 327256913,
    "dropmaladd": "944 DELTONA BLVD",
    "dropmalcty": "DELTONA",
    "dropmalst": "FL",
    "dropmalzpp": 327256913,
    "dropsitphn": 3865743053,
    "dropsitlph": 3865743053,
    "dropsitcph": 3865746440,
    "dropfax": 3868602579
  },
  {
    "dcode": "D",
    "dropkey": "PZ10002",
    "droptype": "D",
    "dropname": "AKIACHAK",
    "dropdeladd": "500 PHILLIPS ST",
    "dropdelcty": "AKIACHAK",
    "dropdelst": "AK",
    "dropdelzpp": 995519800,
    "dropphyadd": "500 PHILLIPS ST",
    "dropphycty": "AKIACHAK",
    "dropphyst": "AK",
    "dropphyzpp": 995519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKIACHAK",
    "dropmalst": "AK",
    "dropmalzpp": 995519998,
    "dropsitphn": 9078254012,
    "dropsitlph": 9078254012,
    "dropsitcph": 9078254012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10003",
    "droptype": "D",
    "dropname": "AKIAK",
    "dropdeladd": "250 OFF DOOPS ST",
    "dropdelcty": "AKIAK",
    "dropdelst": "AK",
    "dropdelzpp": 995529800,
    "dropphyadd": "250 OFF DOOPS ST",
    "dropphycty": "AKIAK",
    "dropphyst": "AK",
    "dropphyzpp": 995529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995529998,
    "dropsitphn": 9077657415,
    "dropsitlph": 9077657415,
    "dropsitcph": 9077657415,
    "dropfax": 9077657418
  },
  {
    "dcode": "D",
    "dropkey": "PZ10004",
    "droptype": "D",
    "dropname": "AKUTAN",
    "dropdeladd": "101 SALMON BERRY RD",
    "dropdelcty": "AKUTAN",
    "dropdelst": "AK",
    "dropdelzpp": 995539800,
    "dropphyadd": "101 SALMON BERRY RD",
    "dropphycty": "AKUTAN",
    "dropphyst": "AK",
    "dropphyzpp": 995539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AKUTAN",
    "dropmalst": "AK",
    "dropmalzpp": 995539998,
    "dropsitphn": 9076982200,
    "dropsitlph": 9076982200,
    "dropsitcph": 9076982200,
    "dropfax": 9076982202
  },
  {
    "dcode": "D",
    "dropkey": "PZ10005",
    "droptype": "D",
    "dropname": "ALAKANUK",
    "dropdeladd": "500 ANDERSON ST",
    "dropdelcty": "ALAKANUK",
    "dropdelst": "AK",
    "dropdelzpp": 995549800,
    "dropphyadd": "500 ANDERSON ST",
    "dropphycty": "ALAKANUK",
    "dropphyst": "AK",
    "dropphyzpp": 995549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALAKANUK",
    "dropmalst": "AK",
    "dropmalzpp": 995549998,
    "dropsitphn": 9072383717,
    "dropsitlph": 9072383717,
    "dropsitcph": 9072383717,
    "dropfax": 9072383712
  },
  {
    "dcode": "D",
    "dropkey": "PZ10006",
    "droptype": "D",
    "dropname": "ALEKNAGIK",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "ALEKNAGIK",
    "dropdelst": "AK",
    "dropdelzpp": 995559800,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "ALEKNAGIK",
    "dropphyst": "AK",
    "dropphyzpp": 995559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALEKNAGIK",
    "dropmalst": "AK",
    "dropmalzpp": 995559998,
    "dropsitphn": 9078422410,
    "dropsitlph": 9078422410,
    "dropsitcph": 9078422410,
    "dropfax": 9078425732
  },
  {
    "dcode": "D",
    "dropkey": "PZ10007",
    "droptype": "D",
    "dropname": "ALLAKAKET",
    "dropdeladd": "21 ALLAKAKET RD",
    "dropdelcty": "ALLAKAKET",
    "dropdelst": "AK",
    "dropdelzpp": 997209800,
    "dropphyadd": "21 ALLAKAKET RD",
    "dropphycty": "ALLAKAKET",
    "dropphyst": "AK",
    "dropphyzpp": 997209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLAKAKET",
    "dropmalst": "AK",
    "dropmalzpp": 997209998,
    "dropsitphn": 9079682212,
    "dropsitlph": 9079682212,
    "dropsitcph": 9079682212,
    "dropfax": 9079682212
  },
  {
    "dcode": "D",
    "dropkey": "PZ10008",
    "droptype": "D",
    "dropname": "AMBLER",
    "dropdeladd": "9998 AMBLER AVE",
    "dropdelcty": "AMBLER",
    "dropdelst": "AK",
    "dropdelzpp": 997869800,
    "dropphyadd": "9998 AMBLER AVE",
    "dropphycty": "AMBLER",
    "dropphyst": "AK",
    "dropphyzpp": 997869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMBLER",
    "dropmalst": "AK",
    "dropmalzpp": 997869998,
    "dropsitphn": 9074452187,
    "dropsitlph": 9074452187,
    "dropsitcph": 9074452187,
    "dropfax": 9074452287
  },
  {
    "dcode": "D",
    "dropkey": "PZ10009",
    "droptype": "D",
    "dropname": "ANAKTUVUK PASS",
    "dropdeladd": "1104 SUMMER ST",
    "dropdelcty": "ANAKTUVUK PASS",
    "dropdelst": "AK",
    "dropdelzpp": 997219800,
    "dropphyadd": "1104 SUMMER ST",
    "dropphycty": "ANAKTUVUK PASS",
    "dropphyst": "AK",
    "dropphyzpp": 997219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANAKTUVUK PASS",
    "dropmalst": "AK",
    "dropmalzpp": 997219998,
    "dropsitphn": 9076613615,
    "dropsitlph": 9076613615,
    "dropsitcph": 9076613615,
    "dropfax": 9076613925
  },
  {
    "dcode": "D",
    "dropkey": "PZ10011",
    "droptype": "D",
    "dropname": "ANCHOR POINT",
    "dropdeladd": "33790 STERLING HWY",
    "dropdelcty": "ANCHOR POINT",
    "dropdelst": "AK",
    "dropdelzpp": 995569606,
    "dropphyadd": "33790 STERLING HWY",
    "dropphycty": "ANCHOR POINT",
    "dropphyst": "AK",
    "dropphyzpp": 995569606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANCHOR POINT",
    "dropmalst": "AK",
    "dropmalzpp": 995569998,
    "dropsitphn": 9072357666,
    "dropsitlph": 9072357666,
    "dropsitcph": 9072357666,
    "dropfax": 9072353224
  },
  {
    "dcode": "D",
    "dropkey": "PZ10014",
    "droptype": "D",
    "dropname": "ANCHORAGE",
    "dropdeladd": "1601 W NORTHERN LIGHTS BLVD",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995179998,
    "dropphyadd": "1601 W NORTHERN LIGHTS BLVD",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995179998,
    "dropmaladd": "1601 W NORTHERN LIGHTS BLVD",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995179998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072663261,
    "dropsitcph": 9072586700,
    "dropfax": 9072586720
  },
  {
    "dcode": "D",
    "dropkey": "PZ10016",
    "droptype": "D",
    "dropname": "ANGOON",
    "dropdeladd": "705 AANDEINATT ST",
    "dropdelcty": "ANGOON",
    "dropdelst": "AK",
    "dropdelzpp": 998209800,
    "dropphyadd": "705 AANDEINATT ST",
    "dropphycty": "ANGOON",
    "dropphyst": "AK",
    "dropphyzpp": 998209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANGOON",
    "dropmalst": "AK",
    "dropmalzpp": 998209998,
    "dropsitphn": 9077883442,
    "dropsitlph": 9077883442,
    "dropsitcph": 9077883442,
    "dropfax": 9707883350
  },
  {
    "dcode": "D",
    "dropkey": "PZ10017",
    "droptype": "D",
    "dropname": "ANIAK",
    "dropdeladd": "101 BOUNDARY AVE",
    "dropdelcty": "ANIAK",
    "dropdelst": "AK",
    "dropdelzpp": 995579800,
    "dropphyadd": "101 BOUNDARY AVE",
    "dropphycty": "ANIAK",
    "dropphyst": "AK",
    "dropphyzpp": 995579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995579998,
    "dropsitphn": 9076754314,
    "dropsitlph": 9076754314,
    "dropsitcph": 9076754314,
    "dropfax": 9076754516
  },
  {
    "dcode": "D",
    "dropkey": "PZ10018",
    "droptype": "D",
    "dropname": "ANVIK",
    "dropdeladd": "9998 MAIN ST",
    "dropdelcty": "ANVIK",
    "dropdelst": "AK",
    "dropdelzpp": 995589800,
    "dropphyadd": "9998 MAIN ST",
    "dropphycty": "ANVIK",
    "dropphyst": "AK",
    "dropphyzpp": 995589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANVIK",
    "dropmalst": "AK",
    "dropmalzpp": 995589998,
    "dropsitphn": 9076636325,
    "dropsitlph": 9076636325,
    "dropsitcph": 9076636325,
    "dropfax": 9076636336
  },
  {
    "dcode": "D",
    "dropkey": "PZ10019",
    "droptype": "D",
    "dropname": "ARCTIC VILLAGE",
    "dropdeladd": "9998 BRIDGE ST",
    "dropdelcty": "ARCTIC VILLAGE",
    "dropdelst": "AK",
    "dropdelzpp": 997229800,
    "dropphyadd": "9998 BRIDGE ST",
    "dropphycty": "ARCTIC VILLAGE",
    "dropphyst": "AK",
    "dropphyzpp": 997229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARCTIC VILLAGE",
    "dropmalst": "AK",
    "dropmalzpp": 997229998,
    "dropsitphn": 9075875314,
    "dropsitlph": 9075875314,
    "dropsitcph": 9075875314,
    "dropfax": 9075875395
  },
  {
    "dcode": "D",
    "dropkey": "PZ10027",
    "droptype": "D",
    "dropname": "BARROW",
    "dropdeladd": "3080 EBEN HOBSON ST",
    "dropdelcty": "BARROW",
    "dropdelst": "AK",
    "dropdelzpp": 997239800,
    "dropphyadd": "3080 EBEN HOBSON ST",
    "dropphycty": "BARROW",
    "dropphyst": "AK",
    "dropphyzpp": 997239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARROW",
    "dropmalst": "AK",
    "dropmalzpp": 997239998,
    "dropsitphn": 9078526800,
    "dropsitlph": 9078526800,
    "dropsitcph": 9078526800,
    "dropfax": 9078525075
  },
  {
    "dcode": "D",
    "dropkey": "PZ10028",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "400 C ST",
    "dropdelcty": "BEAVER",
    "dropdelst": "AK",
    "dropdelzpp": 997249800,
    "dropphyadd": "400 C ST",
    "dropphycty": "BEAVER",
    "dropphyst": "AK",
    "dropphyzpp": 997249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "AK",
    "dropmalzpp": 997249998,
    "dropsitphn": 9076286326,
    "dropsitlph": 9076286326,
    "dropsitcph": 9076286326,
    "dropfax": 9076286327
  },
  {
    "dcode": "D",
    "dropkey": "PZ10029",
    "droptype": "D",
    "dropname": "BETHEL",
    "dropdeladd": "1484 CHIEF EDDY HOFFMAN HWY",
    "dropdelcty": "BETHEL",
    "dropdelst": "AK",
    "dropdelzpp": 995599800,
    "dropphyadd": "1484 CHIEF EDDY HOFFMAN HWY",
    "dropphycty": "BETHEL",
    "dropphyst": "AK",
    "dropphyzpp": 995599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHEL",
    "dropmalst": "AK",
    "dropmalzpp": 995599998,
    "dropsitphn": 9075432525,
    "dropsitlph": 9075432525,
    "dropsitcph": 9075432525,
    "dropfax": 9075432010
  },
  {
    "dcode": "D",
    "dropkey": "PZ10031",
    "droptype": "D",
    "dropname": "BETTLES FIELD",
    "dropdeladd": "1 FRONT ST",
    "dropdelcty": "BETTLES FIELD",
    "dropdelst": "AK",
    "dropdelzpp": 997269800,
    "dropphyadd": "1 FRONT ST",
    "dropphycty": "BETTLES FIELD",
    "dropphyst": "AK",
    "dropphyzpp": 997269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETTLES FIELD",
    "dropmalst": "AK",
    "dropmalzpp": 997269998,
    "dropsitphn": 9076925236,
    "dropsitlph": 9076925236,
    "dropsitcph": 9076925236,
    "dropfax": 9076925237
  },
  {
    "dcode": "D",
    "dropkey": "PZ10037",
    "droptype": "D",
    "dropname": "BREVIG MISSION",
    "dropdeladd": "9998 KUGSHI RD",
    "dropdelcty": "BREVIG MISSION",
    "dropdelst": "AK",
    "dropdelzpp": 997859800,
    "dropphyadd": "9998 KUGSHI RD",
    "dropphycty": "BREVIG MISSION",
    "dropphyst": "AK",
    "dropphyzpp": 997859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BREVIG MISSION",
    "dropmalst": "AK",
    "dropmalzpp": 997859998,
    "dropsitphn": 9076424061,
    "dropsitlph": 9076424061,
    "dropsitcph": 9076424061,
    "dropfax": 9076426128
  },
  {
    "dcode": "D",
    "dropkey": "PZ10038",
    "droptype": "D",
    "dropname": "BUCKLAND",
    "dropdeladd": "17 BETTY AVE",
    "dropdelcty": "BUCKLAND",
    "dropdelst": "AK",
    "dropdelzpp": 997279800,
    "dropphyadd": "17 BETTY AVE",
    "dropphycty": "BUCKLAND",
    "dropphyst": "AK",
    "dropphyzpp": 997279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCKLAND",
    "dropmalst": "AK",
    "dropmalzpp": 997279998,
    "dropsitphn": 9074942151,
    "dropsitlph": 9074942151,
    "dropsitcph": 9074942151,
    "dropfax": 9074942164
  },
  {
    "dcode": "D",
    "dropkey": "PZ10040",
    "droptype": "D",
    "dropname": "CANTWELL",
    "dropdeladd": "210 GEORGE PARKS HWY",
    "dropdelcty": "CANTWELL",
    "dropdelst": "AK",
    "dropdelzpp": 997299800,
    "dropphyadd": "210 GEORGE PARKS HWY",
    "dropphycty": "CANTWELL",
    "dropphyst": "AK",
    "dropphyzpp": 997299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANTWELL",
    "dropmalst": "AK",
    "dropmalzpp": 997299998,
    "dropsitphn": 9077682292,
    "dropsitlph": 9077682292,
    "dropsitcph": 9077682292,
    "dropfax": 9077682292
  },
  {
    "dcode": "D",
    "dropkey": "PZ10041",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "128 STEESE HWY",
    "dropdelcty": "CENTRAL",
    "dropdelst": "AK",
    "dropdelzpp": 997309800,
    "dropphyadd": "128 STEESE HWY",
    "dropphycty": "CENTRAL",
    "dropphyst": "AK",
    "dropphyzpp": 997309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL",
    "dropmalst": "AK",
    "dropmalzpp": 997309998,
    "dropsitphn": 9075205959,
    "dropsitlph": 9075205959,
    "dropsitcph": 9075205959,
    "dropfax": 9075205960
  },
  {
    "dcode": "D",
    "dropkey": "PZ10043",
    "droptype": "D",
    "dropname": "CHEFORNAK",
    "dropdeladd": "500 BOARDWALK ST",
    "dropdelcty": "CHEFORNAK",
    "dropdelst": "AK",
    "dropdelzpp": 995619800,
    "dropphyadd": "500 BOARDWALK ST",
    "dropphycty": "CHEFORNAK",
    "dropphyst": "AK",
    "dropphyzpp": 995619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHEFORNAK",
    "dropmalst": "AK",
    "dropmalzpp": 995619998,
    "dropsitphn": 9078678215,
    "dropsitlph": 9078678215,
    "dropsitcph": 9078678215,
    "dropfax": 9078678216
  },
  {
    "dcode": "D",
    "dropkey": "PZ10046",
    "droptype": "D",
    "dropname": "CHEVAK",
    "dropdeladd": "9998 CHEVAK RD",
    "dropdelcty": "CHEVAK",
    "dropdelst": "AK",
    "dropdelzpp": 995639800,
    "dropphyadd": "9998 CHEVAK RD",
    "dropphycty": "CHEVAK",
    "dropphyst": "AK",
    "dropphyzpp": 995639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHEVAK",
    "dropmalst": "AK",
    "dropmalzpp": 995639998,
    "dropsitphn": 9078587213,
    "dropsitlph": 9078587213,
    "dropsitcph": 9078587213,
    "dropfax": 9078587223
  },
  {
    "dcode": "D",
    "dropkey": "PZ10048",
    "droptype": "D",
    "dropname": "CHICKEN",
    "dropdeladd": "66 TAYLOR HWY",
    "dropdelcty": "CHICKEN",
    "dropdelst": "AK",
    "dropdelzpp": 997329800,
    "dropphyadd": "66 TAYLOR HWY",
    "dropphycty": "CHICKEN",
    "dropphyst": "AK",
    "dropphyzpp": 997329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHICKEN",
    "dropmalst": "AK",
    "dropmalzpp": 997329998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9072615421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10049",
    "droptype": "D",
    "dropname": "CHIGNIK",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "CHIGNIK",
    "dropdelst": "AK",
    "dropdelzpp": 995649800,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "CHIGNIK",
    "dropphyst": "AK",
    "dropphyzpp": 995649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIGNIK",
    "dropmalst": "AK",
    "dropmalzpp": 995649998,
    "dropsitphn": 9077492220,
    "dropsitlph": 9077492220,
    "dropsitcph": 9077492220,
    "dropfax": 9077492223
  },
  {
    "dcode": "D",
    "dropkey": "PZ10050",
    "droptype": "D",
    "dropname": "CHIGNIK LAGOON",
    "dropdeladd": "100 AIRPORT DR",
    "dropdelcty": "CHIGNIK LAGOON",
    "dropdelst": "AK",
    "dropdelzpp": 995659800,
    "dropphyadd": "100 AIRPORT DR",
    "dropphycty": "CHIGNIK LAGOON",
    "dropphyst": "AK",
    "dropphyzpp": 995659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIGNIK LAGOON",
    "dropmalst": "AK",
    "dropmalzpp": 995659998,
    "dropsitphn": 9078402232,
    "dropsitlph": 9078402232,
    "dropsitcph": 9078402232,
    "dropfax": 9078402202
  },
  {
    "dcode": "D",
    "dropkey": "PZ10053",
    "droptype": "D",
    "dropname": "CHITINA",
    "dropdeladd": "400 D ST",
    "dropdelcty": "CHITINA",
    "dropdelst": "AK",
    "dropdelzpp": 995669800,
    "dropphyadd": "400 D ST",
    "dropphycty": "CHITINA",
    "dropphyst": "AK",
    "dropphyzpp": 995669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHITINA",
    "dropmalst": "AK",
    "dropmalzpp": 995669998,
    "dropsitphn": 9078232225,
    "dropsitlph": 9078232225,
    "dropsitcph": 9078232225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10055",
    "droptype": "D",
    "dropname": "CHUGIAK",
    "dropdeladd": "22255 DOGSLED CT",
    "dropdelcty": "CHUGIAK",
    "dropdelst": "AK",
    "dropdelzpp": 995679997,
    "dropphyadd": "22255 DOGSLED CT",
    "dropphycty": "CHUGIAK",
    "dropphyst": "AK",
    "dropphyzpp": 995679997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHUGIAK",
    "dropmalst": "AK",
    "dropmalzpp": 995679998,
    "dropsitphn": 9076882747,
    "dropsitlph": 9076882747,
    "dropsitcph": 9076882747,
    "dropfax": 9076881498
  },
  {
    "dcode": "D",
    "dropkey": "PZ10056",
    "droptype": "D",
    "dropname": "CIRCLE",
    "dropdeladd": "161 STEESE HWY",
    "dropdelcty": "CIRCLE",
    "dropdelst": "AK",
    "dropdelzpp": 997339800,
    "dropphyadd": "161 STEESE HWY",
    "dropphycty": "CIRCLE",
    "dropphyst": "AK",
    "dropphyzpp": 997339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CIRCLE",
    "dropmalst": "AK",
    "dropmalzpp": 997339998,
    "dropsitphn": 9077731220,
    "dropsitlph": 9077731220,
    "dropsitcph": 9077731220,
    "dropfax": 9077731218
  },
  {
    "dcode": "D",
    "dropkey": "PZ10057",
    "droptype": "D",
    "dropname": "CLAM GULCH",
    "dropdeladd": "65790 STERLING HWY",
    "dropdelcty": "CLAM GULCH",
    "dropdelst": "AK",
    "dropdelzpp": 995689753,
    "dropphyadd": "65790 STERLING HWY",
    "dropphycty": "CLAM GULCH",
    "dropphyst": "AK",
    "dropphyzpp": 995689753,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAM GULCH",
    "dropmalst": "AK",
    "dropmalzpp": 995689998,
    "dropsitphn": 9072625137,
    "dropsitlph": 9072625137,
    "dropsitcph": 9072625137,
    "dropfax": 9072627821
  },
  {
    "dcode": "D",
    "dropkey": "PZ10058",
    "droptype": "D",
    "dropname": "CLARKS POINT",
    "dropdeladd": "11 MAIN ST",
    "dropdelcty": "CLARKS POINT",
    "dropdelst": "AK",
    "dropdelzpp": 995699800,
    "dropphyadd": "11 MAIN ST",
    "dropphycty": "CLARKS POINT",
    "dropphyst": "AK",
    "dropphyzpp": 995699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKS POINT",
    "dropmalst": "AK",
    "dropmalzpp": 995699998,
    "dropsitphn": 9072361270,
    "dropsitlph": 9072361270,
    "dropsitcph": 9072361270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10062",
    "droptype": "D",
    "dropname": "COLD BAY",
    "dropdeladd": "1 LETTY AVE",
    "dropdelcty": "COLD BAY",
    "dropdelst": "AK",
    "dropdelzpp": 995719800,
    "dropphyadd": "1 LETTY AVE",
    "dropphycty": "COLD BAY",
    "dropphyst": "AK",
    "dropphyzpp": 995719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLD BAY",
    "dropmalst": "AK",
    "dropmalzpp": 995719998,
    "dropsitphn": 9075322464,
    "dropsitlph": 9075322464,
    "dropsitcph": 9075322464,
    "dropfax": 9075325138
  },
  {
    "dcode": "D",
    "dropkey": "PZ10066",
    "droptype": "D",
    "dropname": "COOPER LANDING",
    "dropdeladd": "38741 SNUG HARBOR RD",
    "dropdelcty": "COOPER LANDING",
    "dropdelst": "AK",
    "dropdelzpp": 995729798,
    "dropphyadd": "38741 SNUG HARBOR RD",
    "dropphycty": "COOPER LANDING",
    "dropphyst": "AK",
    "dropphyzpp": 995729798,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COOPER LANDING",
    "dropmalst": "AK",
    "dropmalzpp": 995729998,
    "dropsitphn": 9075951234,
    "dropsitlph": 9075951234,
    "dropsitcph": 9075951234,
    "dropfax": 9075951695
  },
  {
    "dcode": "D",
    "dropkey": "PZ10067",
    "droptype": "D",
    "dropname": "COPPER CENTER",
    "dropdeladd": "101.5 OLD RICHARDSON HWY",
    "dropdelcty": "COPPER CENTER",
    "dropdelst": "AK",
    "dropdelzpp": 995739800,
    "dropphyadd": "101.5 OLD RICHARDSON HWY",
    "dropphycty": "COPPER CENTER",
    "dropphyst": "AK",
    "dropphyzpp": 995739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPPER CENTER",
    "dropmalst": "AK",
    "dropmalzpp": 995739998,
    "dropsitphn": 9078223472,
    "dropsitlph": 9078223472,
    "dropsitcph": 9078223472,
    "dropfax": 9078225840
  },
  {
    "dcode": "D",
    "dropkey": "PZ10069",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "502 RAILROAD AVE",
    "dropdelcty": "CORDOVA",
    "dropdelst": "AK",
    "dropdelzpp": 995749800,
    "dropphyadd": "502 RAILROAD AVE",
    "dropphycty": "CORDOVA",
    "dropphyst": "AK",
    "dropphyzpp": 995749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORDOVA",
    "dropmalst": "AK",
    "dropmalzpp": 995749998,
    "dropsitphn": 9074243564,
    "dropsitlph": 9074243564,
    "dropsitcph": 9074243564,
    "dropfax": 9074245643
  },
  {
    "dcode": "D",
    "dropkey": "PZ10070",
    "droptype": "D",
    "dropname": "CRAIG",
    "dropdeladd": "303 THOMPSON RD",
    "dropdelcty": "CRAIG",
    "dropdelst": "AK",
    "dropdelzpp": 999219800,
    "dropphyadd": "303 THOMPSON RD",
    "dropphycty": "CRAIG",
    "dropphyst": "AK",
    "dropphyzpp": 999219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRAIG",
    "dropmalst": "AK",
    "dropmalzpp": 999219998,
    "dropsitphn": 9078263298,
    "dropsitlph": 9078263298,
    "dropsitcph": 9078263298,
    "dropfax": 9078262130
  },
  {
    "dcode": "D",
    "dropkey": "PZ10071",
    "droptype": "D",
    "dropname": "CROOKED CREEK",
    "dropdeladd": "500 AIRPORT RD",
    "dropdelcty": "CROOKED CREEK",
    "dropdelst": "AK",
    "dropdelzpp": 995759800,
    "dropphyadd": "500 AIRPORT RD",
    "dropphycty": "CROOKED CREEK",
    "dropphyst": "AK",
    "dropphyzpp": 995759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROOKED CREEK",
    "dropmalst": "AK",
    "dropmalzpp": 995759998,
    "dropsitphn": 9074322236,
    "dropsitlph": 9074322236,
    "dropsitcph": 9074322236,
    "dropfax": 9074322246
  },
  {
    "dcode": "D",
    "dropkey": "PZ10073",
    "droptype": "D",
    "dropname": "DEERING",
    "dropdeladd": "59B B ST",
    "dropdelcty": "DEERING",
    "dropdelst": "AK",
    "dropdelzpp": 997369800,
    "dropphyadd": "59B B ST",
    "dropphycty": "DEERING",
    "dropphyst": "AK",
    "dropphyzpp": 997369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEERING",
    "dropmalst": "AK",
    "dropmalzpp": 997369998,
    "dropsitphn": 9073632139,
    "dropsitlph": 9073632139,
    "dropsitcph": 9073632139,
    "dropfax": 9073632189
  },
  {
    "dcode": "D",
    "dropkey": "PZ10075",
    "droptype": "D",
    "dropname": "DELTA JUNCTION",
    "dropdeladd": "266 RICHARDSON HWY",
    "dropdelcty": "DELTA JUNCTION",
    "dropdelst": "AK",
    "dropdelzpp": 997379800,
    "dropphyadd": "266 RICHARDSON HWY",
    "dropphycty": "DELTA JUNCTION",
    "dropphyst": "AK",
    "dropphyzpp": 997379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELTA JUNCTION",
    "dropmalst": "AK",
    "dropmalzpp": 997379998,
    "dropsitphn": 9078954601,
    "dropsitlph": 9078954601,
    "dropsitcph": 9078954601,
    "dropfax": 9078954712
  },
  {
    "dcode": "D",
    "dropkey": "PZ10077",
    "droptype": "D",
    "dropname": "DILLINGHAM",
    "dropdeladd": "114 D ST",
    "dropdelcty": "DILLINGHAM",
    "dropdelst": "AK",
    "dropdelzpp": 995769800,
    "dropphyadd": "114 D ST",
    "dropphycty": "DILLINGHAM",
    "dropphyst": "AK",
    "dropphyzpp": 995769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DILLINGHAM",
    "dropmalst": "AK",
    "dropmalzpp": 995769998,
    "dropsitphn": 9078425633,
    "dropsitlph": 9078425633,
    "dropsitcph": 9078425633,
    "dropfax": 9078424512
  },
  {
    "dcode": "D",
    "dropkey": "PZ10088",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "200 JEFFERSON ST",
    "dropdelcty": "EAGLE",
    "dropdelst": "AK",
    "dropdelzpp": 997389800,
    "dropphyadd": "200 JEFFERSON ST",
    "dropphycty": "EAGLE",
    "dropphyst": "AK",
    "dropphyzpp": 997389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE",
    "dropmalst": "AK",
    "dropmalzpp": 997389998,
    "dropsitphn": 9075472211,
    "dropsitlph": 9075472211,
    "dropsitcph": 9075472211,
    "dropfax": 9075742262
  },
  {
    "dcode": "D",
    "dropkey": "PZ10089",
    "droptype": "D",
    "dropname": "EAGLE RIVER",
    "dropdeladd": "11471 BUSINESS BLVD",
    "dropdelcty": "EAGLE RIVER",
    "dropdelst": "AK",
    "dropdelzpp": 995779998,
    "dropphyadd": "11471 BUSINESS BLVD",
    "dropphycty": "EAGLE RIVER",
    "dropphyst": "AK",
    "dropphyzpp": 995779998,
    "dropmaladd": "11471 BUSINESS BLVD",
    "dropmalcty": "EAGLE RIVER",
    "dropmalst": "AK",
    "dropmalzpp": 995779998,
    "dropsitphn": 9076942732,
    "dropsitlph": 9076942732,
    "dropsitcph": 9076942732,
    "dropfax": 9076941723
  },
  {
    "dcode": "D",
    "dropkey": "PZ10093",
    "droptype": "D",
    "dropname": "EEK",
    "dropdeladd": "9998 1ST ST",
    "dropdelcty": "EEK",
    "dropdelst": "AK",
    "dropdelzpp": 995789800,
    "dropphyadd": "9998 1ST ST",
    "dropphycty": "EEK",
    "dropphyst": "AK",
    "dropphyzpp": 995789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EEK",
    "dropmalst": "AK",
    "dropmalzpp": 995789998,
    "dropsitphn": 9075365726,
    "dropsitlph": 9075365726,
    "dropsitcph": 9075365726,
    "dropfax": 9075365745
  },
  {
    "dcode": "D",
    "dropkey": "PZ10094",
    "droptype": "D",
    "dropname": "EGEGIK",
    "dropdeladd": "1 SCHOOL RD",
    "dropdelcty": "EGEGIK",
    "dropdelst": "AK",
    "dropdelzpp": 995799800,
    "dropphyadd": "1 SCHOOL RD",
    "dropphycty": "EGEGIK",
    "dropphyst": "AK",
    "dropphyzpp": 995799800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EGEGIK",
    "dropmalst": "AK",
    "dropmalzpp": 995799998,
    "dropsitphn": 9072332226,
    "dropsitlph": 9072332226,
    "dropsitcph": 9072332226,
    "dropfax": 9072232251
  },
  {
    "dcode": "D",
    "dropkey": "PZ10098",
    "droptype": "D",
    "dropname": "EKWOK",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "EKWOK",
    "dropdelst": "AK",
    "dropdelzpp": 995809800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "EKWOK",
    "dropphyst": "AK",
    "dropphyzpp": 995809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EKWOK",
    "dropmalst": "AK",
    "dropmalzpp": 995809998,
    "dropsitphn": 9074643316,
    "dropsitlph": 9074643316,
    "dropsitcph": 9074643316,
    "dropfax": 9074643328
  },
  {
    "dcode": "D",
    "dropkey": "PZ10099",
    "droptype": "D",
    "dropname": "ELFIN COVE",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "ELFIN COVE",
    "dropdelst": "AK",
    "dropdelzpp": 998259800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "ELFIN COVE",
    "dropphyst": "AK",
    "dropphyzpp": 998259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELFIN COVE",
    "dropmalst": "AK",
    "dropmalzpp": 998259998,
    "dropsitphn": 9072392228,
    "dropsitlph": 9072392228,
    "dropsitcph": 9072392228,
    "dropfax": 9072392228
  },
  {
    "dcode": "D",
    "dropkey": "PZ10100",
    "droptype": "D",
    "dropname": "ELIM",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "ELIM",
    "dropdelst": "AK",
    "dropdelzpp": 997399800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "ELIM",
    "dropphyst": "AK",
    "dropphyzpp": 997399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELIM",
    "dropmalst": "AK",
    "dropmalzpp": 997399998,
    "dropsitphn": 9078903431,
    "dropsitlph": 9078903431,
    "dropsitcph": 9078903431,
    "dropfax": 9078903431
  },
  {
    "dcode": "D",
    "dropkey": "PZ10103",
    "droptype": "D",
    "dropname": "EMMONAK",
    "dropdeladd": "9998 KWIGUK ST",
    "dropdelcty": "EMMONAK",
    "dropdelst": "AK",
    "dropdelzpp": 995819800,
    "dropphyadd": "9998 KWIGUK ST",
    "dropphycty": "EMMONAK",
    "dropphyst": "AK",
    "dropphyzpp": 995819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMMONAK",
    "dropmalst": "AK",
    "dropmalzpp": 995819998,
    "dropsitphn": 9079491929,
    "dropsitlph": 9079491929,
    "dropsitcph": 9079491929,
    "dropfax": 9079491949
  },
  {
    "dcode": "D",
    "dropkey": "PZ10105",
    "droptype": "D",
    "dropname": "ESTER",
    "dropdeladd": "501 VILLAGE RD",
    "dropdelcty": "ESTER",
    "dropdelst": "AK",
    "dropdelzpp": 997259800,
    "dropphyadd": "501 VILLAGE RD",
    "dropphycty": "ESTER",
    "dropphyst": "AK",
    "dropphyzpp": 997259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESTER",
    "dropmalst": "AK",
    "dropmalzpp": 997259998,
    "dropsitphn": 9074792050,
    "dropsitlph": 9074792050,
    "dropsitcph": 9074792050,
    "dropfax": 9074792674
  },
  {
    "dcode": "D",
    "dropkey": "PZ10107",
    "droptype": "D",
    "dropname": "FAIRBANKS",
    "dropdeladd": "5400 MAIL TRAIL RD",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "AK",
    "dropdelzpp": 997091001,
    "dropphyadd": "5400 MAIL TRAIL RD",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "AK",
    "dropphyzpp": 997091001,
    "dropmaladd": "5400 MAIL TRAIL RD",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "AK",
    "dropmalzpp": 997091001,
    "dropsitphn": 9074555452,
    "dropsitlph": 9074555452,
    "dropsitcph": 9074555406,
    "dropfax": 9074555480
  },
  {
    "dcode": "D",
    "dropkey": "PZ10108",
    "droptype": "D",
    "dropname": "FALSE PASS",
    "dropdeladd": "170 UMIAK DR",
    "dropdelcty": "FALSE PASS",
    "dropdelst": "AK",
    "dropdelzpp": 995839800,
    "dropphyadd": "170 UMIAK DR",
    "dropphycty": "FALSE PASS",
    "dropphyst": "AK",
    "dropphyzpp": 995839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALSE PASS",
    "dropmalst": "AK",
    "dropmalzpp": 995839998,
    "dropsitphn": 9075482243,
    "dropsitlph": 9075482243,
    "dropsitcph": 9075482243,
    "dropfax": 9075482257
  },
  {
    "dcode": "D",
    "dropkey": "PZ10115",
    "droptype": "D",
    "dropname": "FORT YUKON",
    "dropdeladd": "9998 E 3RD AVE",
    "dropdelcty": "FORT YUKON",
    "dropdelst": "AK",
    "dropdelzpp": 997409800,
    "dropphyadd": "9998 E 3RD AVE",
    "dropphycty": "FORT YUKON",
    "dropphyst": "AK",
    "dropphyzpp": 997409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT YUKON",
    "dropmalst": "AK",
    "dropmalzpp": 997409998,
    "dropsitphn": 9076622335,
    "dropsitlph": 9076622335,
    "dropsitcph": 9076622335,
    "dropfax": 9076623162
  },
  {
    "dcode": "D",
    "dropkey": "PZ10116",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "200 YUKON AVE",
    "dropdelcty": "MARSHALL",
    "dropdelst": "AK",
    "dropdelzpp": 995859800,
    "dropphyadd": "200 YUKON AVE",
    "dropphycty": "MARSHALL",
    "dropphyst": "AK",
    "dropphyzpp": 995859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARSHALL",
    "dropmalst": "AK",
    "dropmalzpp": 995859998,
    "dropsitphn": 9076796613,
    "dropsitlph": 9076796613,
    "dropsitcph": 9076796613,
    "dropfax": 9076796189
  },
  {
    "dcode": "D",
    "dropkey": "PZ10122",
    "droptype": "D",
    "dropname": "GAKONA",
    "dropdeladd": "2.5 TOK CUTOFF",
    "dropdelcty": "GAKONA",
    "dropdelst": "AK",
    "dropdelzpp": 995869800,
    "dropphyadd": "2.5 TOK CUTOFF",
    "dropphycty": "GAKONA",
    "dropphyst": "AK",
    "dropphyzpp": 995869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAKONA",
    "dropmalst": "AK",
    "dropmalzpp": 995869998,
    "dropsitphn": 9078223542,
    "dropsitlph": 9078223542,
    "dropsitcph": 9078223542,
    "dropfax": 9078225347
  },
  {
    "dcode": "D",
    "dropkey": "PZ10123",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "511 GALENA RD",
    "dropdelcty": "GALENA",
    "dropdelst": "AK",
    "dropdelzpp": 997419800,
    "dropphyadd": "511 GALENA RD",
    "dropphycty": "GALENA",
    "dropphyst": "AK",
    "dropphyzpp": 997419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALENA",
    "dropmalst": "AK",
    "dropmalzpp": 997419998,
    "dropsitphn": 9076561262,
    "dropsitlph": 9076561262,
    "dropsitcph": 9076561262,
    "dropfax": 9076561583
  },
  {
    "dcode": "D",
    "dropkey": "PZ10124",
    "droptype": "D",
    "dropname": "GAMBELL",
    "dropdeladd": "9998 SAINT LAWRENCE IS",
    "dropdelcty": "GAMBELL",
    "dropdelst": "AK",
    "dropdelzpp": 997429800,
    "dropphyadd": "9998 SAINT LAWRENCE IS",
    "dropphycty": "GAMBELL",
    "dropphyst": "AK",
    "dropphyzpp": 997429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAMBELL",
    "dropmalst": "AK",
    "dropmalzpp": 997429998,
    "dropsitphn": 9079855213,
    "dropsitlph": 9079855213,
    "dropsitcph": 9079855213,
    "dropfax": 9079855260
  },
  {
    "dcode": "D",
    "dropkey": "PZ10125",
    "droptype": "D",
    "dropname": "GIRDWOOD",
    "dropdeladd": "118 LINDBLAD AVE",
    "dropdelcty": "GIRDWOOD",
    "dropdelst": "AK",
    "dropdelzpp": 995879800,
    "dropphyadd": "118 LINDBLAD AVE",
    "dropphycty": "GIRDWOOD",
    "dropphyst": "AK",
    "dropphyzpp": 995879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GIRDWOOD",
    "dropmalst": "AK",
    "dropmalzpp": 995879998,
    "dropsitphn": 9077832922,
    "dropsitlph": 9077832922,
    "dropsitcph": 9077832922,
    "dropfax": 9077831280
  },
  {
    "dcode": "D",
    "dropkey": "PZ10126",
    "droptype": "D",
    "dropname": "GLENNALLEN",
    "dropdeladd": "9998 AURORA DR",
    "dropdelcty": "GLENNALLEN",
    "dropdelst": "AK",
    "dropdelzpp": 995889800,
    "dropphyadd": "9998 AURORA DR",
    "dropphycty": "GLENNALLEN",
    "dropphyst": "AK",
    "dropphyzpp": 995889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENNALLEN",
    "dropmalst": "AK",
    "dropmalzpp": 995889998,
    "dropsitphn": 9078223273,
    "dropsitlph": 9078223273,
    "dropsitcph": 9078223273,
    "dropfax": 9078223745
  },
  {
    "dcode": "D",
    "dropkey": "PZ10128",
    "droptype": "D",
    "dropname": "GOODNEWS BAY",
    "dropdeladd": "9998 GOODNEWS BAY ST",
    "dropdelcty": "GOODNEWS BAY",
    "dropdelst": "AK",
    "dropdelzpp": 995899800,
    "dropphyadd": "9998 GOODNEWS BAY ST",
    "dropphycty": "GOODNEWS BAY",
    "dropphyst": "AK",
    "dropphyzpp": 995899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOODNEWS BAY",
    "dropmalst": "AK",
    "dropmalzpp": 995899998,
    "dropsitphn": 9079678510,
    "dropsitlph": 9079678510,
    "dropsitcph": 9079678510,
    "dropfax": 9079678633
  },
  {
    "dcode": "D",
    "dropkey": "PZ10129",
    "droptype": "D",
    "dropname": "GRAYLING",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "GRAYLING",
    "dropdelst": "AK",
    "dropdelzpp": 995909800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "GRAYLING",
    "dropphyst": "AK",
    "dropphyzpp": 995909800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAYLING",
    "dropmalst": "AK",
    "dropmalzpp": 995909998,
    "dropsitphn": 9074535155,
    "dropsitlph": 9074535155,
    "dropsitcph": 9074535155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10131",
    "droptype": "D",
    "dropname": "GUSTAVUS",
    "dropdeladd": "123 POSTMARK DR",
    "dropdelcty": "GUSTAVUS",
    "dropdelst": "AK",
    "dropdelzpp": 998269800,
    "dropphyadd": "123 POSTMARK DR",
    "dropphycty": "GUSTAVUS",
    "dropphyst": "AK",
    "dropphyzpp": 998269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUSTAVUS",
    "dropmalst": "AK",
    "dropmalzpp": 998269998,
    "dropsitphn": 9076872202,
    "dropsitlph": 9076972202,
    "dropsitcph": 9076972202,
    "dropfax": 9076972202
  },
  {
    "dcode": "D",
    "dropkey": "PZ10132",
    "droptype": "D",
    "dropname": "HAINES",
    "dropdeladd": "55 HAINES HWY",
    "dropdelcty": "HAINES",
    "dropdelst": "AK",
    "dropdelzpp": 998279800,
    "dropphyadd": "55 HAINES HWY",
    "dropphycty": "HAINES",
    "dropphyst": "AK",
    "dropphyzpp": 998279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAINES",
    "dropmalst": "AK",
    "dropmalzpp": 998279998,
    "dropsitphn": 9077662930,
    "dropsitlph": 9077662930,
    "dropsitcph": 9077662930,
    "dropfax": 9077662932
  },
  {
    "dcode": "D",
    "dropkey": "PZ10134",
    "droptype": "D",
    "dropname": "HEALY",
    "dropdeladd": "9998 COAL ST",
    "dropdelcty": "HEALY",
    "dropdelst": "AK",
    "dropdelzpp": 997439800,
    "dropphyadd": "9998 COAL ST",
    "dropphycty": "HEALY",
    "dropphyst": "AK",
    "dropphyzpp": 997439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEALY",
    "dropmalst": "AK",
    "dropmalzpp": 997439998,
    "dropsitphn": 9076832263,
    "dropsitlph": 9076832263,
    "dropsitcph": 9076832263,
    "dropfax": 9076832367
  },
  {
    "dcode": "D",
    "dropkey": "PZ10135",
    "droptype": "D",
    "dropname": "HOLY CROSS",
    "dropdeladd": "100 4TH ST",
    "dropdelcty": "HOLY CROSS",
    "dropdelst": "AK",
    "dropdelzpp": 996029800,
    "dropphyadd": "100 4TH ST",
    "dropphycty": "HOLY CROSS",
    "dropphyst": "AK",
    "dropphyzpp": 996029800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLY CROSS",
    "dropmalst": "AK",
    "dropmalzpp": 996029998,
    "dropsitphn": 9074767133,
    "dropsitlph": 9074767133,
    "dropsitcph": 9074767133,
    "dropfax": 9074767274
  },
  {
    "dcode": "D",
    "dropkey": "PZ10136",
    "droptype": "D",
    "dropname": "HOMER",
    "dropdeladd": "3658 HEATH ST",
    "dropdelcty": "HOMER",
    "dropdelst": "AK",
    "dropdelzpp": 996039998,
    "dropphyadd": "3658 HEATH ST",
    "dropphycty": "HOMER",
    "dropphyst": "AK",
    "dropphyzpp": 996039998,
    "dropmaladd": "3658 HEATH ST",
    "dropmalcty": "HOMER",
    "dropmalst": "AK",
    "dropmalzpp": 996039998,
    "dropsitphn": 9072356120,
    "dropsitlph": 9072356120,
    "dropsitcph": 9072356120,
    "dropfax": 9072356122
  },
  {
    "dcode": "D",
    "dropkey": "PZ10137",
    "droptype": "D",
    "dropname": "HOONAH",
    "dropdeladd": "420 AIRPORT DR",
    "dropdelcty": "HOONAH",
    "dropdelst": "AK",
    "dropdelzpp": 998299800,
    "dropphyadd": "420 AIRPORT DR",
    "dropphycty": "HOONAH",
    "dropphyst": "AK",
    "dropphyzpp": 998299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOONAH",
    "dropmalst": "AK",
    "dropmalzpp": 998299998,
    "dropsitphn": 9079453260,
    "dropsitlph": 9079453260,
    "dropsitcph": 9079453260,
    "dropfax": 9079453268
  },
  {
    "dcode": "D",
    "dropkey": "PZ10138",
    "droptype": "D",
    "dropname": "HOOPER BAY",
    "dropdeladd": "1 UNIAQ AVE",
    "dropdelcty": "HOOPER BAY",
    "dropdelst": "AK",
    "dropdelzpp": 996049800,
    "dropphyadd": "1 UNIAQ AVE",
    "dropphycty": "HOOPER BAY",
    "dropphyst": "AK",
    "dropphyzpp": 996049800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOOPER BAY",
    "dropmalst": "AK",
    "dropmalzpp": 996049998,
    "dropsitphn": 9077584420,
    "dropsitlph": 9077584420,
    "dropsitcph": 9077584420,
    "dropfax": 9077584532
  },
  {
    "dcode": "D",
    "dropkey": "PZ10139",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "19059 LOGMAN LN",
    "dropdelcty": "HOPE",
    "dropdelst": "AK",
    "dropdelzpp": 996059800,
    "dropphyadd": "19059 LOGMAN LN",
    "dropphycty": "HOPE",
    "dropphyst": "AK",
    "dropphyzpp": 996059800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPE",
    "dropmalst": "AK",
    "dropmalzpp": 996059998,
    "dropsitphn": 9077823352,
    "dropsitlph": 9077823352,
    "dropsitcph": 9077823352,
    "dropfax": 9077823747
  },
  {
    "dcode": "D",
    "dropkey": "PZ10142",
    "droptype": "D",
    "dropname": "HUGHES",
    "dropdeladd": "110 FRONT ST",
    "dropdelcty": "HUGHES",
    "dropdelst": "AK",
    "dropdelzpp": 997459800,
    "dropphyadd": "110 FRONT ST",
    "dropphycty": "HUGHES",
    "dropphyst": "AK",
    "dropphyzpp": 997459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUGHES",
    "dropmalst": "AK",
    "dropmalzpp": 997459998,
    "dropsitphn": 9078892218,
    "dropsitlph": 9078892218,
    "dropsitcph": 9078892218,
    "dropfax": 9078892229
  },
  {
    "dcode": "D",
    "dropkey": "PZ10143",
    "droptype": "D",
    "dropname": "HUSLIA",
    "dropdeladd": "34 DAKLI ST",
    "dropdelcty": "HUSLIA",
    "dropdelst": "AK",
    "dropdelzpp": 997469800,
    "dropphyadd": "34 DAKLI ST",
    "dropphycty": "HUSLIA",
    "dropphyst": "AK",
    "dropphyzpp": 997469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUSLIA",
    "dropmalst": "AK",
    "dropmalzpp": 997469998,
    "dropsitphn": 9078292206,
    "dropsitlph": 9078292206,
    "dropsitcph": 9078292206,
    "dropfax": 9078292288
  },
  {
    "dcode": "D",
    "dropkey": "PZ10144",
    "droptype": "D",
    "dropname": "HYDABURG",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "HYDABURG",
    "dropdelst": "AK",
    "dropdelzpp": 999229800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "HYDABURG",
    "dropphyst": "AK",
    "dropphyzpp": 999229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYDABURG",
    "dropmalst": "AK",
    "dropmalzpp": 999229998,
    "dropsitphn": 9072853514,
    "dropsitlph": 9072853514,
    "dropsitcph": 9072853514,
    "dropfax": 9072853515
  },
  {
    "dcode": "D",
    "dropkey": "PZ10145",
    "droptype": "D",
    "dropname": "HYDER",
    "dropdeladd": "100 HYDER AVE",
    "dropdelcty": "HYDER",
    "dropdelst": "AK",
    "dropdelzpp": 999239800,
    "dropphyadd": "100 HYDER AVE",
    "dropphycty": "HYDER",
    "dropphyst": "AK",
    "dropphyzpp": 999239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYDER",
    "dropmalst": "AK",
    "dropmalzpp": 999239998,
    "dropsitphn": 2506362662,
    "dropsitlph": 2506362662,
    "dropsitcph": 2506362662,
    "dropfax": 2506362662
  },
  {
    "dcode": "D",
    "dropkey": "PZ10147",
    "droptype": "D",
    "dropname": "ILIAMNA",
    "dropdeladd": "9998 ILIAMNA AIRPORT RD",
    "dropdelcty": "ILIAMNA",
    "dropdelst": "AK",
    "dropdelzpp": 996069800,
    "dropphyadd": "9998 ILIAMNA AIRPORT RD",
    "dropphycty": "ILIAMNA",
    "dropphyst": "AK",
    "dropphyzpp": 996069800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ILIAMNA",
    "dropmalst": "AK",
    "dropmalzpp": 996069998,
    "dropsitphn": 9075711224,
    "dropsitlph": 9075711224,
    "dropsitcph": 9075711224,
    "dropfax": 9075711224
  },
  {
    "dcode": "D",
    "dropkey": "PZ10150",
    "droptype": "D",
    "dropname": "JUNEAU",
    "dropdeladd": "9491 VINTAGE BLVD",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998019997,
    "dropphyadd": "9491 VINTAGE BLVD",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998019997,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "JUNEAU",
    "dropmalst": "AK",
    "dropmalzpp": 998039998,
    "dropsitphn": 9077893295,
    "dropsitlph": 9077893295,
    "dropsitcph": 9077890934,
    "dropfax": 9077893484
  },
  {
    "dcode": "D",
    "dropkey": "PZ10151",
    "droptype": "D",
    "dropname": "KAKE",
    "dropdeladd": "272 KEKU RD",
    "dropdelcty": "KAKE",
    "dropdelst": "AK",
    "dropdelzpp": 998309800,
    "dropphyadd": "272 KEKU RD",
    "dropphycty": "KAKE",
    "dropphyst": "AK",
    "dropphyzpp": 998309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAKE",
    "dropmalst": "AK",
    "dropmalzpp": 998309998,
    "dropsitphn": 9077853123,
    "dropsitlph": 9077853123,
    "dropsitcph": 9077853123,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10152",
    "droptype": "D",
    "dropname": "KAKTOVIK",
    "dropdeladd": "2041 BARTER AVE",
    "dropdelcty": "KAKTOVIK",
    "dropdelst": "AK",
    "dropdelzpp": 997479800,
    "dropphyadd": "2041 BARTER AVE",
    "dropphycty": "KAKTOVIK",
    "dropphyst": "AK",
    "dropphyzpp": 997479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAKTOVIK",
    "dropmalst": "AK",
    "dropmalzpp": 997479998,
    "dropsitphn": 9076406420,
    "dropsitlph": 9076406420,
    "dropsitcph": 9076406420,
    "dropfax": 9076406418
  },
  {
    "dcode": "D",
    "dropkey": "PZ10153",
    "droptype": "D",
    "dropname": "KALSKAG",
    "dropdeladd": "9998 KALSKAG RD",
    "dropdelcty": "KALSKAG",
    "dropdelst": "AK",
    "dropdelzpp": 996079800,
    "dropphyadd": "9998 KALSKAG RD",
    "dropphycty": "KALSKAG",
    "dropphyst": "AK",
    "dropphyzpp": 996079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALSKAG",
    "dropmalst": "AK",
    "dropmalzpp": 996079998,
    "dropsitphn": 9074712221,
    "dropsitlph": 9074712221,
    "dropsitcph": 9074712221,
    "dropfax": 9074712520
  },
  {
    "dcode": "D",
    "dropkey": "PZ10154",
    "droptype": "D",
    "dropname": "KALTAG",
    "dropdeladd": "100 6TH AVE",
    "dropdelcty": "KALTAG",
    "dropdelst": "AK",
    "dropdelzpp": 997489800,
    "dropphyadd": "100 6TH AVE",
    "dropphycty": "KALTAG",
    "dropphyst": "AK",
    "dropphyzpp": 997489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALTAG",
    "dropmalst": "AK",
    "dropmalzpp": 997489998,
    "dropsitphn": 9075342210,
    "dropsitlph": 9075342210,
    "dropsitcph": 9075342210,
    "dropfax": 9075342210
  },
  {
    "dcode": "D",
    "dropkey": "PZ10155",
    "droptype": "D",
    "dropname": "KARLUK",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "KARLUK",
    "dropdelst": "AK",
    "dropdelzpp": 996089800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "KARLUK",
    "dropphyst": "AK",
    "dropphyzpp": 996089800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KARLUK",
    "dropmalst": "AK",
    "dropmalzpp": 996089998,
    "dropsitphn": 9072412223,
    "dropsitlph": 9072663367,
    "dropsitcph": 9072412223,
    "dropfax": 9072412227
  },
  {
    "dcode": "D",
    "dropkey": "PZ10157",
    "droptype": "D",
    "dropname": "KASIGLUK",
    "dropdeladd": "19 NAYAGAAM AND MISVIGMUIT RDS",
    "dropdelcty": "KASIGLUK",
    "dropdelst": "AK",
    "dropdelzpp": 996099800,
    "dropphyadd": "19 NAYAGAAM AND MISVIGMUIT RDS",
    "dropphycty": "KASIGLUK",
    "dropphyst": "AK",
    "dropphyzpp": 996099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KASIGLUK",
    "dropmalst": "AK",
    "dropmalzpp": 996099998,
    "dropsitphn": 9074776482,
    "dropsitlph": 9074776482,
    "dropsitcph": 9074776482,
    "dropfax": 9074776482
  },
  {
    "dcode": "D",
    "dropkey": "PZ10158",
    "droptype": "D",
    "dropname": "KASILOF",
    "dropdeladd": "23758 KALIFORNSKY BEACH RD",
    "dropdelcty": "KASILOF",
    "dropdelst": "AK",
    "dropdelzpp": 996109700,
    "dropphyadd": "23758 KALIFORNSKY BEACH RD",
    "dropphycty": "KASILOF",
    "dropphyst": "AK",
    "dropphyzpp": 996109700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KASILOF",
    "dropmalst": "AK",
    "dropmalzpp": 996109998,
    "dropsitphn": 9072627458,
    "dropsitlph": 9072627458,
    "dropsitcph": 9072627458,
    "dropfax": 9072628492
  },
  {
    "dcode": "D",
    "dropkey": "PZ10159",
    "droptype": "D",
    "dropname": "KENAI",
    "dropdeladd": "140 BIDARKA ST",
    "dropdelcty": "KENAI",
    "dropdelst": "AK",
    "dropdelzpp": 996119998,
    "dropphyadd": "140 BIDARKA ST",
    "dropphycty": "KENAI",
    "dropphyst": "AK",
    "dropphyzpp": 996119998,
    "dropmaladd": "140 BIDARKA ST",
    "dropmalcty": "KENAI",
    "dropmalst": "AK",
    "dropmalzpp": 996119998,
    "dropsitphn": 9072837771,
    "dropsitlph": 9072837771,
    "dropsitcph": 9072837771,
    "dropfax": 9072835344
  },
  {
    "dcode": "D",
    "dropkey": "PZ10161",
    "droptype": "D",
    "dropname": "KETCHIKAN",
    "dropdeladd": "3609 TONGASS AVE",
    "dropdelcty": "KETCHIKAN",
    "dropdelst": "AK",
    "dropdelzpp": 999019998,
    "dropphyadd": "3609 TONGASS AVE",
    "dropphycty": "KETCHIKAN",
    "dropphyst": "AK",
    "dropphyzpp": 999019998,
    "dropmaladd": "3609 TONGASS AVE",
    "dropmalcty": "KETCHIKAN",
    "dropmalst": "AK",
    "dropmalzpp": 999019998,
    "dropsitphn": 9072259602,
    "dropsitlph": 9072259602,
    "dropsitcph": 9072259602,
    "dropfax": 9072471272
  },
  {
    "dcode": "D",
    "dropkey": "PZ10162",
    "droptype": "D",
    "dropname": "KIANA",
    "dropdeladd": "9998 TAYLOR AND KOZAK ST",
    "dropdelcty": "KIANA",
    "dropdelst": "AK",
    "dropdelzpp": 997499800,
    "dropphyadd": "9998 TAYLOR AND KOZAK ST",
    "dropphycty": "KIANA",
    "dropphyst": "AK",
    "dropphyzpp": 997499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIANA",
    "dropmalst": "AK",
    "dropmalzpp": 997499998,
    "dropsitphn": 9074752154,
    "dropsitlph": 9074752154,
    "dropsitcph": 9074752154,
    "dropfax": 9074752271
  },
  {
    "dcode": "D",
    "dropkey": "PZ10163",
    "droptype": "D",
    "dropname": "KING COVE",
    "dropdeladd": "38 WINDY WALKWAY",
    "dropdelcty": "KING COVE",
    "dropdelst": "AK",
    "dropdelzpp": 996129800,
    "dropphyadd": "38 WINDY WALKWAY",
    "dropphycty": "KING COVE",
    "dropphyst": "AK",
    "dropphyzpp": 996129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KING COVE",
    "dropmalst": "AK",
    "dropmalzpp": 996129998,
    "dropsitphn": 9074972363,
    "dropsitlph": 9074972363,
    "dropsitcph": 9074972363,
    "dropfax": 9074973131
  },
  {
    "dcode": "D",
    "dropkey": "PZ10165",
    "droptype": "D",
    "dropname": "KING SALMON",
    "dropdeladd": "13 ALASKA HWY",
    "dropdelcty": "KING SALMON",
    "dropdelst": "AK",
    "dropdelzpp": 996139800,
    "dropphyadd": "13 ALASKA HWY",
    "dropphycty": "KING SALMON",
    "dropphyst": "AK",
    "dropphyzpp": 996139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KING SALMON",
    "dropmalst": "AK",
    "dropmalzpp": 996139998,
    "dropsitphn": 9072463396,
    "dropsitlph": 9072463396,
    "dropsitcph": 9072463396,
    "dropfax": 9072463582
  },
  {
    "dcode": "D",
    "dropkey": "PZ10166",
    "droptype": "D",
    "dropname": "KIPNUK",
    "dropdeladd": "9998 KIPNUK WAY",
    "dropdelcty": "KIPNUK",
    "dropdelst": "AK",
    "dropdelzpp": 996149800,
    "dropphyadd": "9998 KIPNUK WAY",
    "dropphycty": "KIPNUK",
    "dropphyst": "AK",
    "dropphyzpp": 996149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIPNUK",
    "dropmalst": "AK",
    "dropmalzpp": 996149998,
    "dropsitphn": 9078965115,
    "dropsitlph": 9078965115,
    "dropsitcph": 9078965115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10167",
    "droptype": "D",
    "dropname": "KIVALINA",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "KIVALINA",
    "dropdelst": "AK",
    "dropdelzpp": 997509800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "KIVALINA",
    "dropphyst": "AK",
    "dropphyzpp": 997509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIVALINA",
    "dropmalst": "AK",
    "dropmalzpp": 997509998,
    "dropsitphn": 9076452168,
    "dropsitlph": 9076452168,
    "dropsitcph": 9076452168,
    "dropfax": 9076452188
  },
  {
    "dcode": "D",
    "dropkey": "PZ10168",
    "droptype": "D",
    "dropname": "KLAWOCK",
    "dropdeladd": "6488 KLAWOCK HOLLIS HWY",
    "dropdelcty": "KLAWOCK",
    "dropdelst": "AK",
    "dropdelzpp": 999259800,
    "dropphyadd": "6488 KLAWOCK HOLLIS HWY",
    "dropphycty": "KLAWOCK",
    "dropphyst": "AK",
    "dropphyzpp": 999259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KLAWOCK",
    "dropmalst": "AK",
    "dropmalzpp": 999259998,
    "dropsitphn": 9077552977,
    "dropsitlph": 9077752977,
    "dropsitcph": 9077552977,
    "dropfax": 9077552550
  },
  {
    "dcode": "D",
    "dropkey": "PZ10170",
    "droptype": "D",
    "dropname": "KOBUK",
    "dropdeladd": "9998 AIRPORT RD",
    "dropdelcty": "KOBUK",
    "dropdelst": "AK",
    "dropdelzpp": 997519800,
    "dropphyadd": "9998 AIRPORT RD",
    "dropphycty": "KOBUK",
    "dropphyst": "AK",
    "dropphyzpp": 997519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOBUK",
    "dropmalst": "AK",
    "dropmalzpp": 997519998,
    "dropsitphn": 9079482227,
    "dropsitlph": 9072482227,
    "dropsitcph": 9079482227,
    "dropfax": 9079482227
  },
  {
    "dcode": "D",
    "dropkey": "PZ10171",
    "droptype": "D",
    "dropname": "KODIAK",
    "dropdeladd": "419 LOWER MILL BAY RD",
    "dropdelcty": "KODIAK",
    "dropdelst": "AK",
    "dropdelzpp": 996159998,
    "dropphyadd": "419 LOWER MILL BAY RD",
    "dropphycty": "KODIAK",
    "dropphyst": "AK",
    "dropphyzpp": 996159998,
    "dropmaladd": "419 LOWER MILL BAY RD",
    "dropmalcty": "KODIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996159998,
    "dropsitphn": 9074864721,
    "dropsitlph": 9074864721,
    "dropsitcph": 9074864721,
    "dropfax": 9074865213
  },
  {
    "dcode": "D",
    "dropkey": "PZ10176",
    "droptype": "D",
    "dropname": "KOTLIK",
    "dropdeladd": "500 USPS BOARDWALK",
    "dropdelcty": "KOTLIK",
    "dropdelst": "AK",
    "dropdelzpp": 996209800,
    "dropphyadd": "500 USPS BOARDWALK",
    "dropphycty": "KOTLIK",
    "dropphyst": "AK",
    "dropphyzpp": 996209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOTLIK",
    "dropmalst": "AK",
    "dropmalzpp": 996209998,
    "dropsitphn": 9078994512,
    "dropsitlph": 9078994512,
    "dropsitcph": 9078994512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10177",
    "droptype": "D",
    "dropname": "KOTZEBUE",
    "dropdeladd": "333 SHORE AVE",
    "dropdelcty": "KOTZEBUE",
    "dropdelst": "AK",
    "dropdelzpp": 997529800,
    "dropphyadd": "333 SHORE AVE",
    "dropphycty": "KOTZEBUE",
    "dropphyst": "AK",
    "dropphyzpp": 997529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOTZEBUE",
    "dropmalst": "AK",
    "dropmalzpp": 997529998,
    "dropsitphn": 9074423291,
    "dropsitlph": 9074423291,
    "dropsitcph": 9074423291,
    "dropfax": 9074422191
  },
  {
    "dcode": "D",
    "dropkey": "PZ10178",
    "droptype": "D",
    "dropname": "KOYUK",
    "dropdeladd": "200 BIRCH ST",
    "dropdelcty": "KOYUK",
    "dropdelst": "AK",
    "dropdelzpp": 997539800,
    "dropphyadd": "200 BIRCH ST",
    "dropphycty": "KOYUK",
    "dropphyst": "AK",
    "dropphyzpp": 997539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOYUK",
    "dropmalst": "AK",
    "dropmalzpp": 997539998,
    "dropsitphn": 9079632433,
    "dropsitlph": 9079632433,
    "dropsitcph": 9079632433,
    "dropfax": 9079632019
  },
  {
    "dcode": "D",
    "dropkey": "PZ10179",
    "droptype": "D",
    "dropname": "KOYUKUK",
    "dropdeladd": "149 MAIN ST",
    "dropdelcty": "KOYUKUK",
    "dropdelst": "AK",
    "dropdelzpp": 997549800,
    "dropphyadd": "149 MAIN ST",
    "dropphycty": "KOYUKUK",
    "dropphyst": "AK",
    "dropphyzpp": 997549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOYUKUK",
    "dropmalst": "AK",
    "dropmalzpp": 997549998,
    "dropsitphn": 9079272238,
    "dropsitlph": 9079272238,
    "dropsitcph": 9079272238,
    "dropfax": 9079272238
  },
  {
    "dcode": "D",
    "dropkey": "PZ10180",
    "droptype": "D",
    "dropname": "KWETHLUK",
    "dropdeladd": "500 AIRPORT RD",
    "dropdelcty": "KWETHLUK",
    "dropdelst": "AK",
    "dropdelzpp": 996219800,
    "dropphyadd": "500 AIRPORT RD",
    "dropphycty": "KWETHLUK",
    "dropphyst": "AK",
    "dropphyzpp": 996219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KWETHLUK",
    "dropmalst": "AK",
    "dropmalzpp": 996219998,
    "dropsitphn": 9077576628,
    "dropsitlph": 9077576628,
    "dropsitcph": 9077576628,
    "dropfax": 9077576630
  },
  {
    "dcode": "D",
    "dropkey": "PZ10181",
    "droptype": "D",
    "dropname": "KWIGILLINGOK",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "KWIGILLINGOK",
    "dropdelst": "AK",
    "dropdelzpp": 996229800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "KWIGILLINGOK",
    "dropphyst": "AK",
    "dropphyzpp": 996229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KWIGILLINGOK",
    "dropmalst": "AK",
    "dropmalzpp": 996229998,
    "dropsitphn": 9075888226,
    "dropsitlph": 9075888226,
    "dropsitcph": 9075888226,
    "dropfax": 9075888227
  },
  {
    "dcode": "D",
    "dropkey": "PZ10182",
    "droptype": "D",
    "dropname": "LAKE MINCHUMINA",
    "dropdeladd": "123 AIRPORT WAY",
    "dropdelcty": "LAKE MINCHUMINA",
    "dropdelst": "AK",
    "dropdelzpp": 997579800,
    "dropphyadd": "123 AIRPORT WAY",
    "dropphycty": "LAKE MINCHUMINA",
    "dropphyst": "AK",
    "dropphyzpp": 997579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE MINCHUMINA",
    "dropmalst": "AK",
    "dropmalzpp": 997579998,
    "dropsitphn": 9076743114,
    "dropsitlph": 9076743114,
    "dropsitcph": 9076743114,
    "dropfax": 9076743115
  },
  {
    "dcode": "D",
    "dropkey": "PZ10184",
    "droptype": "D",
    "dropname": "LARSEN BAY",
    "dropdeladd": "500 3RD ST",
    "dropdelcty": "LARSEN BAY",
    "dropdelst": "AK",
    "dropdelzpp": 996249800,
    "dropphyadd": "500 3RD ST",
    "dropphycty": "LARSEN BAY",
    "dropphyst": "AK",
    "dropphyzpp": 996249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LARSEN BAY",
    "dropmalst": "AK",
    "dropmalzpp": 996249998,
    "dropsitphn": 9078472232,
    "dropsitlph": 9078472232,
    "dropsitcph": 9078472232,
    "dropfax": 9078472300
  },
  {
    "dcode": "D",
    "dropkey": "PZ10185",
    "droptype": "D",
    "dropname": "LEVELOCK",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "LEVELOCK",
    "dropdelst": "AK",
    "dropdelzpp": 996259800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "LEVELOCK",
    "dropphyst": "AK",
    "dropphyzpp": 996259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEVELOCK",
    "dropmalst": "AK",
    "dropmalzpp": 996259998,
    "dropsitphn": 9074283020,
    "dropsitlph": 9072873020,
    "dropsitcph": 9072873020,
    "dropfax": 9072873014
  },
  {
    "dcode": "D",
    "dropkey": "PZ10187",
    "droptype": "D",
    "dropname": "LOWER KALSKAG",
    "dropdeladd": "100 E ST",
    "dropdelcty": "LOWER KALSKAG",
    "dropdelst": "AK",
    "dropdelzpp": 996269800,
    "dropphyadd": "100 E ST",
    "dropphycty": "LOWER KALSKAG",
    "dropphyst": "AK",
    "dropphyzpp": 996269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOWER KALSKAG",
    "dropmalst": "AK",
    "dropmalzpp": 996269998,
    "dropsitphn": 9074712260,
    "dropsitlph": 9074712260,
    "dropsitcph": 9074712260,
    "dropfax": 9074712335
  },
  {
    "dcode": "D",
    "dropkey": "PZ10190",
    "droptype": "D",
    "dropname": "MANLEY HOT SPRINGS",
    "dropdeladd": "100 LANDING RD",
    "dropdelcty": "MANLEY HOT SPRINGS",
    "dropdelst": "AK",
    "dropdelzpp": 997569800,
    "dropphyadd": "100 LANDING RD",
    "dropphycty": "MANLEY HOT SPRINGS",
    "dropphyst": "AK",
    "dropphyzpp": 997569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANLEY HOT SPRINGS",
    "dropmalst": "AK",
    "dropmalzpp": 997569998,
    "dropsitphn": 9076723577,
    "dropsitlph": 9076723577,
    "dropsitcph": 9076723577,
    "dropfax": 9076723578
  },
  {
    "dcode": "D",
    "dropkey": "PZ10191",
    "droptype": "D",
    "dropname": "MANOKOTAK",
    "dropdeladd": "300 C ST",
    "dropdelcty": "MANOKOTAK",
    "dropdelst": "AK",
    "dropdelzpp": 996289800,
    "dropphyadd": "300 C ST",
    "dropphycty": "MANOKOTAK",
    "dropphyst": "AK",
    "dropphyzpp": 996289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANOKOTAK",
    "dropmalst": "AK",
    "dropmalzpp": 996289998,
    "dropsitphn": 9072891073,
    "dropsitlph": 9072891073,
    "dropsitcph": 9072891073,
    "dropfax": 9072891070
  },
  {
    "dcode": "D",
    "dropkey": "PZ10193",
    "droptype": "D",
    "dropname": "MC GRATH",
    "dropdeladd": "123 TAKOTNA AVE",
    "dropdelcty": "MC GRATH",
    "dropdelst": "AK",
    "dropdelzpp": 996279800,
    "dropphyadd": "123 TAKOTNA AVE",
    "dropphycty": "MC GRATH",
    "dropphyst": "AK",
    "dropphyzpp": 996279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GRATH",
    "dropmalst": "AK",
    "dropmalzpp": 996279998,
    "dropsitphn": 9075243333,
    "dropsitlph": 9075243333,
    "dropsitcph": 9075243333,
    "dropfax": 9075243025
  },
  {
    "dcode": "D",
    "dropkey": "PZ10197",
    "droptype": "D",
    "dropname": "MEKORYUK",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "MEKORYUK",
    "dropdelst": "AK",
    "dropdelzpp": 996309800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "MEKORYUK",
    "dropphyst": "AK",
    "dropphyzpp": 996309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEKORYUK",
    "dropmalst": "AK",
    "dropmalzpp": 996309998,
    "dropsitphn": 9078278511,
    "dropsitlph": 9078278511,
    "dropsitcph": 9078278511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10200",
    "droptype": "D",
    "dropname": "METLAKATLA",
    "dropdeladd": "352 8TH AVE",
    "dropdelcty": "METLAKATLA",
    "dropdelst": "AK",
    "dropdelzpp": 999269800,
    "dropphyadd": "352 8TH AVE",
    "dropphycty": "METLAKATLA",
    "dropphyst": "AK",
    "dropphyzpp": 999269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "METLAKATLA",
    "dropmalst": "AK",
    "dropmalzpp": 999269998,
    "dropsitphn": 9078866712,
    "dropsitlph": 9078866712,
    "dropsitcph": 9078866712,
    "dropfax": 9078866245
  },
  {
    "dcode": "D",
    "dropkey": "PZ10203",
    "droptype": "D",
    "dropname": "MINTO",
    "dropdeladd": "100 3RD ST",
    "dropdelcty": "MINTO",
    "dropdelst": "AK",
    "dropdelzpp": 997589800,
    "dropphyadd": "100 3RD ST",
    "dropphycty": "MINTO",
    "dropphyst": "AK",
    "dropphyzpp": 997589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINTO",
    "dropmalst": "AK",
    "dropmalzpp": 997589998,
    "dropsitphn": 9077987226,
    "dropsitlph": 9077987226,
    "dropsitcph": 9077987226,
    "dropfax": 9077987105
  },
  {
    "dcode": "D",
    "dropkey": "PZ10204",
    "droptype": "D",
    "dropname": "MOOSE PASS",
    "dropdeladd": "31785 POST OFFICE DR",
    "dropdelcty": "MOOSE PASS",
    "dropdelst": "AK",
    "dropdelzpp": 996319800,
    "dropphyadd": "31785 POST OFFICE DR",
    "dropphycty": "MOOSE PASS",
    "dropphyst": "AK",
    "dropphyzpp": 996319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOOSE PASS",
    "dropmalst": "AK",
    "dropmalzpp": 996319998,
    "dropsitphn": 9072883623,
    "dropsitlph": 9072883623,
    "dropsitcph": 9072883623,
    "dropfax": 9072885623
  },
  {
    "dcode": "D",
    "dropkey": "PZ10205",
    "droptype": "D",
    "dropname": "MOUNTAIN VILLAGE",
    "dropdeladd": "9998 AIRPORT RD",
    "dropdelcty": "MOUNTAIN VILLAGE",
    "dropdelst": "AK",
    "dropdelzpp": 996329800,
    "dropphyadd": "9998 AIRPORT RD",
    "dropphycty": "MOUNTAIN VILLAGE",
    "dropphyst": "AK",
    "dropphyzpp": 996329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN VILLAGE",
    "dropmalst": "AK",
    "dropmalzpp": 996329998,
    "dropsitphn": 9075912913,
    "dropsitlph": 9075912913,
    "dropsitcph": 9075912913,
    "dropfax": 9075912813
  },
  {
    "dcode": "D",
    "dropkey": "PZ10209",
    "droptype": "D",
    "dropname": "NAKNEK",
    "dropdeladd": "1/2 SCHOOL RD",
    "dropdelcty": "NAKNEK",
    "dropdelst": "AK",
    "dropdelzpp": 996339800,
    "dropphyadd": "1/2 SCHOOL RD",
    "dropphycty": "NAKNEK",
    "dropphyst": "AK",
    "dropphyzpp": 996339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAKNEK",
    "dropmalst": "AK",
    "dropmalzpp": 996339998,
    "dropsitphn": 9072464205,
    "dropsitlph": 9072464205,
    "dropsitcph": 9072464205,
    "dropfax": 9072468407
  },
  {
    "dcode": "D",
    "dropkey": "PZ10211",
    "droptype": "D",
    "dropname": "NAPAKIAK",
    "dropdeladd": "50 MARAQ RD",
    "dropdelcty": "NAPAKIAK",
    "dropdelst": "AK",
    "dropdelzpp": 996349800,
    "dropphyadd": "50 MARAQ RD",
    "dropphycty": "NAPAKIAK",
    "dropphyst": "AK",
    "dropphyzpp": 996349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAPAKIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996349998,
    "dropsitphn": 9075892912,
    "dropsitlph": 9075892912,
    "dropsitcph": 9075892912,
    "dropfax": 9075892033
  },
  {
    "dcode": "D",
    "dropkey": "PZ10214",
    "droptype": "D",
    "dropname": "NENANA",
    "dropdeladd": "803 MARKET ST",
    "dropdelcty": "NENANA",
    "dropdelst": "AK",
    "dropdelzpp": 997609800,
    "dropphyadd": "803 MARKET ST",
    "dropphycty": "NENANA",
    "dropphyst": "AK",
    "dropphyzpp": 997609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NENANA",
    "dropmalst": "AK",
    "dropmalzpp": 997609998,
    "dropsitphn": 9078325545,
    "dropsitlph": 9078325545,
    "dropsitcph": 9078325545,
    "dropfax": 9078325405
  },
  {
    "dcode": "D",
    "dropkey": "PZ10215",
    "droptype": "D",
    "dropname": "NEW STUYAHOK",
    "dropdeladd": "100 WALLACE ST",
    "dropdelcty": "NEW STUYAHOK",
    "dropdelst": "AK",
    "dropdelzpp": 996369800,
    "dropphyadd": "100 WALLACE ST",
    "dropphycty": "NEW STUYAHOK",
    "dropphyst": "AK",
    "dropphyzpp": 996369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW STUYAHOK",
    "dropmalst": "AK",
    "dropmalzpp": 996369998,
    "dropsitphn": 9076933180,
    "dropsitlph": 9076933180,
    "dropsitcph": 9076933180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10222",
    "droptype": "D",
    "dropname": "NIKOLSKI",
    "dropdeladd": "9998 NIKOLSKI RD",
    "dropdelcty": "NIKOLSKI",
    "dropdelst": "AK",
    "dropdelzpp": 996389800,
    "dropphyadd": "9998 NIKOLSKI RD",
    "dropphycty": "NIKOLSKI",
    "dropphyst": "AK",
    "dropphyzpp": 996389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIKOLSKI",
    "dropmalst": "AK",
    "dropmalzpp": 996389998,
    "dropsitphn": 9075762223,
    "dropsitlph": 9075762223,
    "dropsitcph": 9075762223,
    "dropfax": 9075762223
  },
  {
    "dcode": "D",
    "dropkey": "PZ10223",
    "droptype": "D",
    "dropname": "NINILCHIK",
    "dropdeladd": "15700 KINGSLEY RD",
    "dropdelcty": "NINILCHIK",
    "dropdelst": "AK",
    "dropdelzpp": 996399759,
    "dropphyadd": "15700 KINGSLEY RD",
    "dropphycty": "NINILCHIK",
    "dropphyst": "AK",
    "dropphyzpp": 996399759,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NINILCHIK",
    "dropmalst": "AK",
    "dropmalzpp": 996399998,
    "dropsitphn": 9075673401,
    "dropsitlph": 9075673401,
    "dropsitcph": 9075673401,
    "dropfax": 9075671069
  },
  {
    "dcode": "D",
    "dropkey": "PZ10224",
    "droptype": "D",
    "dropname": "NOATAK",
    "dropdeladd": "9998 NOATAK RD",
    "dropdelcty": "NOATAK",
    "dropdelst": "AK",
    "dropdelzpp": 997619800,
    "dropphyadd": "9998 NOATAK RD",
    "dropphycty": "NOATAK",
    "dropphyst": "AK",
    "dropphyzpp": 997619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOATAK",
    "dropmalst": "AK",
    "dropmalzpp": 997619998,
    "dropsitphn": 9074852122,
    "dropsitlph": 9074852122,
    "dropsitcph": 9074852122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10225",
    "droptype": "D",
    "dropname": "NOME",
    "dropdeladd": "113 W FRONT ST",
    "dropdelcty": "NOME",
    "dropdelst": "AK",
    "dropdelzpp": 997629800,
    "dropphyadd": "113 W FRONT ST",
    "dropphycty": "NOME",
    "dropphyst": "AK",
    "dropphyzpp": 997629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOME",
    "dropmalst": "AK",
    "dropmalzpp": 997629998,
    "dropsitphn": 9074432129,
    "dropsitlph": 9074432401,
    "dropsitcph": 9074432401,
    "dropfax": 9074434167
  },
  {
    "dcode": "D",
    "dropkey": "PZ10226",
    "droptype": "D",
    "dropname": "NONDALTON",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "NONDALTON",
    "dropdelst": "AK",
    "dropdelzpp": 996409800,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "NONDALTON",
    "dropphyst": "AK",
    "dropphyzpp": 996409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NONDALTON",
    "dropmalst": "AK",
    "dropmalzpp": 996409998,
    "dropsitphn": 9072942246,
    "dropsitlph": 9072942246,
    "dropsitcph": 9072942246,
    "dropfax": 9072942213
  },
  {
    "dcode": "D",
    "dropkey": "PZ10227",
    "droptype": "D",
    "dropname": "NOORVIK",
    "dropdeladd": "9998 FIREWEED LN",
    "dropdelcty": "NOORVIK",
    "dropdelst": "AK",
    "dropdelzpp": 997639800,
    "dropphyadd": "9998 FIREWEED LN",
    "dropphycty": "NOORVIK",
    "dropphyst": "AK",
    "dropphyzpp": 997639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOORVIK",
    "dropmalst": "AK",
    "dropmalzpp": 997639998,
    "dropsitphn": 9076362175,
    "dropsitlph": 9076362175,
    "dropsitcph": 9076362175,
    "dropfax": 9076362143
  },
  {
    "dcode": "D",
    "dropkey": "PZ10230",
    "droptype": "D",
    "dropname": "NORTHWAY",
    "dropdeladd": "6650 NORTHWAY RD",
    "dropdelcty": "NORTHWAY",
    "dropdelst": "AK",
    "dropdelzpp": 997649800,
    "dropphyadd": "6650 NORTHWAY RD",
    "dropphycty": "NORTHWAY",
    "dropphyst": "AK",
    "dropphyzpp": 997649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTHWAY",
    "dropmalst": "AK",
    "dropmalzpp": 997649998,
    "dropsitphn": 9077782255,
    "dropsitlph": 9077782255,
    "dropsitcph": 9077782255,
    "dropfax": 9077782286
  },
  {
    "dcode": "D",
    "dropkey": "PZ10232",
    "droptype": "D",
    "dropname": "NULATO",
    "dropdeladd": "250 NIKAGHUN ST",
    "dropdelcty": "NULATO",
    "dropdelst": "AK",
    "dropdelzpp": 997659800,
    "dropphyadd": "250 NIKAGHUN ST",
    "dropphycty": "NULATO",
    "dropphyst": "AK",
    "dropphyzpp": 997659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NULATO",
    "dropmalst": "AK",
    "dropmalzpp": 997659998,
    "dropsitphn": 9078982244,
    "dropsitlph": 9078982244,
    "dropsitcph": 9078982244,
    "dropfax": 9078982371
  },
  {
    "dcode": "D",
    "dropkey": "PZ10233",
    "droptype": "D",
    "dropname": "NUNAPITCHUK",
    "dropdeladd": "9998 NUNAPITCHUK RD",
    "dropdelcty": "NUNAPITCHUK",
    "dropdelst": "AK",
    "dropdelzpp": 996419800,
    "dropphyadd": "9998 NUNAPITCHUK RD",
    "dropphycty": "NUNAPITCHUK",
    "dropphyst": "AK",
    "dropphyzpp": 996419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUNAPITCHUK",
    "dropmalst": "AK",
    "dropmalzpp": 996419998,
    "dropsitphn": 9075275702,
    "dropsitlph": 9075275702,
    "dropsitcph": 9075275702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10234",
    "droptype": "D",
    "dropname": "OLD HARBOR",
    "dropdeladd": "9998 THREE SAINTS AVE",
    "dropdelcty": "OLD HARBOR",
    "dropdelst": "AK",
    "dropdelzpp": 996439800,
    "dropphyadd": "9998 THREE SAINTS AVE",
    "dropphycty": "OLD HARBOR",
    "dropphyst": "AK",
    "dropphyzpp": 996439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLD HARBOR",
    "dropmalst": "AK",
    "dropmalzpp": 996439998,
    "dropsitphn": 9072862227,
    "dropsitlph": 9072862227,
    "dropsitcph": 9072862227,
    "dropfax": 9072862219
  },
  {
    "dcode": "D",
    "dropkey": "PZ10235",
    "droptype": "D",
    "dropname": "OUZINKIE",
    "dropdeladd": "200 2ND AND E ST",
    "dropdelcty": "OUZINKIE",
    "dropdelst": "AK",
    "dropdelzpp": 996449800,
    "dropphyadd": "200 2ND AND E ST",
    "dropphycty": "OUZINKIE",
    "dropphyst": "AK",
    "dropphyzpp": 996449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OUZINKIE",
    "dropmalst": "AK",
    "dropmalzpp": 996449998,
    "dropsitphn": 9076802252,
    "dropsitlph": 9076802252,
    "dropsitcph": 9076802252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10236",
    "droptype": "D",
    "dropname": "PALMER",
    "dropdeladd": "500 S COBB ST",
    "dropdelcty": "PALMER",
    "dropdelst": "AK",
    "dropdelzpp": 996459998,
    "dropphyadd": "500 S COBB ST",
    "dropphycty": "PALMER",
    "dropphyst": "AK",
    "dropphyzpp": 996459998,
    "dropmaladd": "500 S COBB ST",
    "dropmalcty": "PALMER",
    "dropmalst": "AK",
    "dropmalzpp": 996459998,
    "dropsitphn": 9077455051,
    "dropsitlph": 9077455051,
    "dropsitcph": 9077455051,
    "dropfax": 9077463556
  },
  {
    "dcode": "D",
    "dropkey": "PZ10239",
    "droptype": "D",
    "dropname": "PELICAN",
    "dropdeladd": "171 A SALMON WAY",
    "dropdelcty": "PELICAN",
    "dropdelst": "AK",
    "dropdelzpp": 998329800,
    "dropphyadd": "171 A SALMON WAY",
    "dropphycty": "PELICAN",
    "dropphyst": "AK",
    "dropphyzpp": 998329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PELICAN",
    "dropmalst": "AK",
    "dropmalzpp": 998329998,
    "dropsitphn": 9077352248,
    "dropsitlph": 9077352248,
    "dropsitcph": 9077352248,
    "dropfax": 9077352511
  },
  {
    "dcode": "D",
    "dropkey": "PZ10240",
    "droptype": "D",
    "dropname": "PERRYVILLE",
    "dropdeladd": "16 N BROOK ACCESS RD",
    "dropdelcty": "PERRYVILLE",
    "dropdelst": "AK",
    "dropdelzpp": 996489800,
    "dropphyadd": "16 N BROOK ACCESS RD",
    "dropphycty": "PERRYVILLE",
    "dropphyst": "AK",
    "dropphyzpp": 996489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERRYVILLE",
    "dropmalst": "AK",
    "dropmalzpp": 996489998,
    "dropsitphn": 9078532216,
    "dropsitlph": 9078532216,
    "dropsitcph": 9078532216,
    "dropfax": 9078532258
  },
  {
    "dcode": "D",
    "dropkey": "PZ10241",
    "droptype": "D",
    "dropname": "PETERSBURG",
    "dropdeladd": "1201 HAUGEN DR",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "AK",
    "dropdelzpp": 998339800,
    "dropphyadd": "1201 HAUGEN DR",
    "dropphycty": "PETERSBURG",
    "dropphyst": "AK",
    "dropphyzpp": 998339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "AK",
    "dropmalzpp": 998339998,
    "dropsitphn": 9077723121,
    "dropsitlph": 9077723121,
    "dropsitcph": 9077723121,
    "dropfax": 9077723299
  },
  {
    "dcode": "D",
    "dropkey": "PZ10242",
    "droptype": "D",
    "dropname": "PILOT POINT",
    "dropdeladd": "600 AIRPLANE LAKE RD",
    "dropdelcty": "PILOT POINT",
    "dropdelst": "AK",
    "dropdelzpp": 996499800,
    "dropphyadd": "600 AIRPLANE LAKE RD",
    "dropphycty": "PILOT POINT",
    "dropphyst": "AK",
    "dropphyzpp": 996499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PILOT POINT",
    "dropmalst": "AK",
    "dropmalzpp": 996499998,
    "dropsitphn": 9077972269,
    "dropsitlph": 9077972269,
    "dropsitcph": 9077972269,
    "dropfax": 9077972269
  },
  {
    "dcode": "D",
    "dropkey": "PZ10245",
    "droptype": "D",
    "dropname": "PILOT STATION",
    "dropdeladd": "4 BUILDING AIRPORT RD",
    "dropdelcty": "PILOT STATION",
    "dropdelst": "AK",
    "dropdelzpp": 996509800,
    "dropphyadd": "4 BUILDING AIRPORT RD",
    "dropphycty": "PILOT STATION",
    "dropphyst": "AK",
    "dropphyzpp": 996509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PILOT STATION",
    "dropmalst": "AK",
    "dropmalzpp": 996509998,
    "dropsitphn": 9075493348,
    "dropsitlph": 9075493348,
    "dropsitcph": 9075493348,
    "dropfax": 9075493684
  },
  {
    "dcode": "D",
    "dropkey": "PZ10248",
    "droptype": "D",
    "dropname": "PLATINUM",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "PLATINUM",
    "dropdelst": "AK",
    "dropdelzpp": 996519800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "PLATINUM",
    "dropphyst": "AK",
    "dropphyzpp": 996519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLATINUM",
    "dropmalst": "AK",
    "dropmalzpp": 996519998,
    "dropsitphn": 9079798312,
    "dropsitlph": 9079798312,
    "dropsitcph": 9079798312,
    "dropfax": 9079798323
  },
  {
    "dcode": "D",
    "dropkey": "PZ10249",
    "droptype": "D",
    "dropname": "POINT BAKER",
    "dropdeladd": "9998 STATE FLOAT",
    "dropdelcty": "POINT BAKER",
    "dropdelst": "AK",
    "dropdelzpp": 999279800,
    "dropphyadd": "9998 STATE FLOAT",
    "dropphycty": "POINT BAKER",
    "dropphyst": "AK",
    "dropphyzpp": 999279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT BAKER",
    "dropmalst": "AK",
    "dropmalzpp": 999279998,
    "dropsitphn": 9075592203,
    "dropsitlph": 9075592203,
    "dropsitcph": 9075592203,
    "dropfax": 9075592203
  },
  {
    "dcode": "D",
    "dropkey": "PZ10250",
    "droptype": "D",
    "dropname": "POINT HOPE",
    "dropdeladd": "655 TIKIGAQ AVE",
    "dropdelcty": "POINT HOPE",
    "dropdelst": "AK",
    "dropdelzpp": 997669800,
    "dropphyadd": "655 TIKIGAQ AVE",
    "dropphycty": "POINT HOPE",
    "dropphyst": "AK",
    "dropphyzpp": 997669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POINT HOPE",
    "dropmalst": "AK",
    "dropmalzpp": 997669998,
    "dropsitphn": 9073682133,
    "dropsitlph": 9073682133,
    "dropsitcph": 9073682133,
    "dropfax": 9073688775
  },
  {
    "dcode": "D",
    "dropkey": "PZ10253",
    "droptype": "D",
    "dropname": "PORT ALSWORTH",
    "dropdeladd": "1 FLIGHT LINE RD STE C",
    "dropdelcty": "PORT ALSWORTH",
    "dropdelst": "AK",
    "dropdelzpp": 996539801,
    "dropphyadd": "1 FLIGHT LINE RD STE C",
    "dropphycty": "PORT ALSWORTH",
    "dropphyst": "AK",
    "dropphyzpp": 996539801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT ALSWORTH",
    "dropmalst": "AK",
    "dropmalzpp": 996539998,
    "dropsitphn": 9077812289,
    "dropsitlph": 9077812289,
    "dropsitcph": 9077812289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10256",
    "droptype": "D",
    "dropname": "PORT LIONS",
    "dropdeladd": "520 MAIN ST",
    "dropdelcty": "PORT LIONS",
    "dropdelst": "AK",
    "dropdelzpp": 995509800,
    "dropphyadd": "520 MAIN ST",
    "dropphycty": "PORT LIONS",
    "dropphyst": "AK",
    "dropphyzpp": 995509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT LIONS",
    "dropmalst": "AK",
    "dropmalzpp": 995509998,
    "dropsitphn": 9074542217,
    "dropsitlph": 9074542217,
    "dropsitcph": 9074542217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10260",
    "droptype": "D",
    "dropname": "QUINHAGAK",
    "dropdeladd": "101 QANIRTUUQ RD",
    "dropdelcty": "QUINHAGAK",
    "dropdelst": "AK",
    "dropdelzpp": 996559800,
    "dropphyadd": "101 QANIRTUUQ RD",
    "dropphycty": "QUINHAGAK",
    "dropphyst": "AK",
    "dropphyzpp": 996559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUINHAGAK",
    "dropmalst": "AK",
    "dropmalzpp": 996559998,
    "dropsitphn": 9075568827,
    "dropsitlph": 9075568827,
    "dropsitcph": 9075568827,
    "dropfax": 9075568166
  },
  {
    "dcode": "D",
    "dropkey": "PZ10262",
    "droptype": "D",
    "dropname": "RED DEVIL",
    "dropdeladd": "40 RIVER RD",
    "dropdelcty": "RED DEVIL",
    "dropdelst": "AK",
    "dropdelzpp": 996569800,
    "dropphyadd": "40 RIVER RD",
    "dropphycty": "RED DEVIL",
    "dropphyst": "AK",
    "dropphyzpp": 996569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED DEVIL",
    "dropmalst": "AK",
    "dropmalzpp": 996569998,
    "dropsitphn": 9074473228,
    "dropsitlph": 9074473228,
    "dropsitcph": 9074473228,
    "dropfax": 9074473228
  },
  {
    "dcode": "D",
    "dropkey": "PZ10263",
    "droptype": "D",
    "dropname": "RUBY",
    "dropdeladd": "9998 WILDBERRY RD",
    "dropdelcty": "RUBY",
    "dropdelst": "AK",
    "dropdelzpp": 997689800,
    "dropphyadd": "9998 WILDBERRY RD",
    "dropphycty": "RUBY",
    "dropphyst": "AK",
    "dropphyzpp": 997689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUBY",
    "dropmalst": "AK",
    "dropmalzpp": 997689998,
    "dropsitphn": 9074684414,
    "dropsitlph": 9074684414,
    "dropsitcph": 9074684414,
    "dropfax": 9074684442
  },
  {
    "dcode": "D",
    "dropkey": "PZ10265",
    "droptype": "D",
    "dropname": "RUSSIAN MISSION",
    "dropdeladd": "500 AYAK LOOP",
    "dropdelcty": "RUSSIAN MISSION",
    "dropdelst": "AK",
    "dropdelzpp": 996579800,
    "dropphyadd": "500 AYAK LOOP",
    "dropphycty": "RUSSIAN MISSION",
    "dropphyst": "AK",
    "dropphyzpp": 996579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSSIAN MISSION",
    "dropmalst": "AK",
    "dropmalzpp": 996579998,
    "dropsitphn": 9075845610,
    "dropsitlph": 9075845610,
    "dropsitcph": 9075845610,
    "dropfax": 9075845736
  },
  {
    "dcode": "D",
    "dropkey": "PZ10269",
    "droptype": "D",
    "dropname": "SAINT MARYS",
    "dropdeladd": "101 ALSTROM ST",
    "dropdelcty": "SAINT MARYS",
    "dropdelst": "AK",
    "dropdelzpp": 996589800,
    "dropphyadd": "101 ALSTROM ST",
    "dropphycty": "SAINT MARYS",
    "dropphyst": "AK",
    "dropphyzpp": 996589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT MARYS",
    "dropmalst": "AK",
    "dropmalzpp": 996589998,
    "dropsitphn": 9074382314,
    "dropsitlph": 9074382314,
    "dropsitcph": 9074382314,
    "dropfax": 9074382580
  },
  {
    "dcode": "D",
    "dropkey": "PZ10270",
    "droptype": "D",
    "dropname": "SAINT MICHAEL",
    "dropdeladd": "1 POSTAL WAY",
    "dropdelcty": "SAINT MICHAEL",
    "dropdelst": "AK",
    "dropdelzpp": 996599800,
    "dropphyadd": "1 POSTAL WAY",
    "dropphycty": "SAINT MICHAEL",
    "dropphyst": "AK",
    "dropphyzpp": 996599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT MICHAEL",
    "dropmalst": "AK",
    "dropmalzpp": 996599998,
    "dropsitphn": 9079233531,
    "dropsitlph": 9079233531,
    "dropsitcph": 9079233531,
    "dropfax": 9079233010
  },
  {
    "dcode": "D",
    "dropkey": "PZ10272",
    "droptype": "D",
    "dropname": "SAINT PAUL ISLAND",
    "dropdeladd": "2000 POLOVINA TPKE",
    "dropdelcty": "SAINT PAUL ISLAND",
    "dropdelst": "AK",
    "dropdelzpp": 996609800,
    "dropphyadd": "2000 POLOVINA TPKE",
    "dropphycty": "SAINT PAUL ISLAND",
    "dropphyst": "AK",
    "dropphyzpp": 996609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PAUL ISLAND",
    "dropmalst": "AK",
    "dropmalzpp": 996609998,
    "dropsitphn": 9075462270,
    "dropsitlph": 9075462270,
    "dropsitcph": 9075462270,
    "dropfax": 6519943480
  },
  {
    "dcode": "D",
    "dropkey": "PZ10275",
    "droptype": "D",
    "dropname": "SAND POINT",
    "dropdeladd": "9998 MAIN ST",
    "dropdelcty": "SAND POINT",
    "dropdelst": "AK",
    "dropdelzpp": 996619800,
    "dropphyadd": "9998 MAIN ST",
    "dropphycty": "SAND POINT",
    "dropphyst": "AK",
    "dropphyzpp": 996619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAND POINT",
    "dropmalst": "AK",
    "dropmalzpp": 996619998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9073832955,
    "dropsitcph": 9073832955,
    "dropfax": 9073835915
  },
  {
    "dcode": "D",
    "dropkey": "PZ10277",
    "droptype": "D",
    "dropname": "SAVOONGA",
    "dropdeladd": "9769 SAVOONGA WAY",
    "dropdelcty": "SAVOONGA",
    "dropdelst": "AK",
    "dropdelzpp": 997699800,
    "dropphyadd": "9769 SAVOONGA WAY",
    "dropphycty": "SAVOONGA",
    "dropphyst": "AK",
    "dropphyzpp": 997699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAVOONGA",
    "dropmalst": "AK",
    "dropmalzpp": 997699998,
    "dropsitphn": 9079846213,
    "dropsitlph": 9079846213,
    "dropsitcph": 9079846213,
    "dropfax": 9079846821
  },
  {
    "dcode": "D",
    "dropkey": "PZ10278",
    "droptype": "D",
    "dropname": "SCAMMON BAY",
    "dropdeladd": "102 JOHNSON RD",
    "dropdelcty": "SCAMMON BAY",
    "dropdelst": "AK",
    "dropdelzpp": 996629800,
    "dropphyadd": "102 JOHNSON RD",
    "dropphycty": "SCAMMON BAY",
    "dropphyst": "AK",
    "dropphyzpp": 996629800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCAMMON BAY",
    "dropmalst": "AK",
    "dropmalzpp": 996629998,
    "dropsitphn": 9075585114,
    "dropsitlph": 9072663375,
    "dropsitcph": 9075585114,
    "dropfax": 9075585113
  },
  {
    "dcode": "D",
    "dropkey": "PZ10279",
    "droptype": "D",
    "dropname": "SELAWIK",
    "dropdeladd": "78 SELAWIK RD",
    "dropdelcty": "SELAWIK",
    "dropdelst": "AK",
    "dropdelzpp": 997709800,
    "dropphyadd": "78 SELAWIK RD",
    "dropphycty": "SELAWIK",
    "dropphyst": "AK",
    "dropphyzpp": 997709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELAWIK",
    "dropmalst": "AK",
    "dropmalzpp": 997709998,
    "dropsitphn": 9074842141,
    "dropsitlph": 9074842185,
    "dropsitcph": 9074842141,
    "dropfax": 9074842141
  },
  {
    "dcode": "D",
    "dropkey": "PZ10280",
    "droptype": "D",
    "dropname": "SELDOVIA",
    "dropdeladd": "251 MAIN ST",
    "dropdelcty": "SELDOVIA",
    "dropdelst": "AK",
    "dropdelzpp": 996639800,
    "dropphyadd": "251 MAIN ST",
    "dropphycty": "SELDOVIA",
    "dropphyst": "AK",
    "dropphyzpp": 996639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELDOVIA",
    "dropmalst": "AK",
    "dropmalzpp": 996639998,
    "dropsitphn": 9072347831,
    "dropsitlph": 9072347831,
    "dropsitcph": 9072347831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10281",
    "droptype": "D",
    "dropname": "SEWARD",
    "dropdeladd": "507 MADISON AVE",
    "dropdelcty": "SEWARD",
    "dropdelst": "AK",
    "dropdelzpp": 996649800,
    "dropphyadd": "507 MADISON AVE",
    "dropphycty": "SEWARD",
    "dropphyst": "AK",
    "dropphyzpp": 996649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEWARD",
    "dropmalst": "AK",
    "dropmalzpp": 996649998,
    "dropsitphn": 9072243001,
    "dropsitlph": 9072243001,
    "dropsitcph": 9072243001,
    "dropfax": 9072243002
  },
  {
    "dcode": "D",
    "dropkey": "PZ10282",
    "droptype": "D",
    "dropname": "SHAGELUK",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "SHAGELUK",
    "dropdelst": "AK",
    "dropdelzpp": 996659800,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "SHAGELUK",
    "dropphyst": "AK",
    "dropphyzpp": 996659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAGELUK",
    "dropmalst": "AK",
    "dropmalzpp": 996659998,
    "dropsitphn": 9074738240,
    "dropsitlph": 9074738240,
    "dropsitcph": 9074738240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10283",
    "droptype": "D",
    "dropname": "SHAKTOOLIK",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "SHAKTOOLIK",
    "dropdelst": "AK",
    "dropdelzpp": 997719800,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "SHAKTOOLIK",
    "dropphyst": "AK",
    "dropphyzpp": 997719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAKTOOLIK",
    "dropmalst": "AK",
    "dropmalzpp": 997719998,
    "dropsitphn": 9079553691,
    "dropsitlph": 9079553691,
    "dropsitcph": 9079553691,
    "dropfax": 9079552384
  },
  {
    "dcode": "D",
    "dropkey": "PZ10286",
    "droptype": "D",
    "dropname": "SHISHMAREF",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "SHISHMAREF",
    "dropdelst": "AK",
    "dropdelzpp": 997729800,
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "SHISHMAREF",
    "dropphyst": "AK",
    "dropphyzpp": 997729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHISHMAREF",
    "dropmalst": "AK",
    "dropmalzpp": 997729998,
    "dropsitphn": 9076493931,
    "dropsitlph": 9076493931,
    "dropsitcph": 9076493931,
    "dropfax": 9073493931
  },
  {
    "dcode": "D",
    "dropkey": "PZ10287",
    "droptype": "D",
    "dropname": "SHUNGNAK",
    "dropdeladd": "9998 SHUNGNAK RD",
    "dropdelcty": "SHUNGNAK",
    "dropdelst": "AK",
    "dropdelzpp": 997739800,
    "dropphyadd": "9998 SHUNGNAK RD",
    "dropphycty": "SHUNGNAK",
    "dropphyst": "AK",
    "dropphyzpp": 997739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHUNGNAK",
    "dropmalst": "AK",
    "dropmalzpp": 997739998,
    "dropsitphn": 9074372158,
    "dropsitlph": 9074372158,
    "dropsitcph": 9074372158,
    "dropfax": 9074372058
  },
  {
    "dcode": "D",
    "dropkey": "PZ10288",
    "droptype": "D",
    "dropname": "SITKA",
    "dropdeladd": "1207 SAWMILL CREEK RD",
    "dropdelcty": "SITKA",
    "dropdelst": "AK",
    "dropdelzpp": 998359998,
    "dropphyadd": "1207 SAWMILL CREEK RD",
    "dropphycty": "SITKA",
    "dropphyst": "AK",
    "dropphyzpp": 998359998,
    "dropmaladd": "1207 SAWMILL CREEK RD",
    "dropmalcty": "SITKA",
    "dropmalst": "AK",
    "dropmalzpp": 998359998,
    "dropsitphn": 9077473381,
    "dropsitlph": 9077475659,
    "dropsitcph": 9077473381,
    "dropfax": 9077475471
  },
  {
    "dcode": "D",
    "dropkey": "PZ10289",
    "droptype": "D",
    "dropname": "SKAGWAY",
    "dropdeladd": "641 BROADWAY ST",
    "dropdelcty": "SKAGWAY",
    "dropdelst": "AK",
    "dropdelzpp": 998409800,
    "dropphyadd": "641 BROADWAY ST",
    "dropphycty": "SKAGWAY",
    "dropphyst": "AK",
    "dropphyzpp": 998409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKAGWAY",
    "dropmalst": "AK",
    "dropmalzpp": 998409998,
    "dropsitphn": 9079832330,
    "dropsitlph": 9079832330,
    "dropsitcph": 9079832330,
    "dropfax": 9079833107
  },
  {
    "dcode": "D",
    "dropkey": "PZ10290",
    "droptype": "D",
    "dropname": "SKWENTNA",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "SKWENTNA",
    "dropdelst": "AK",
    "dropdelzpp": 996679800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "SKWENTNA",
    "dropphyst": "AK",
    "dropphyzpp": 996679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKWENTNA",
    "dropmalst": "AK",
    "dropmalzpp": 996679998,
    "dropsitphn": 9077332814,
    "dropsitlph": 9077332814,
    "dropsitcph": 9077332814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10292",
    "droptype": "D",
    "dropname": "SLEETMUTE",
    "dropdeladd": "100 POST OFFICE DR",
    "dropdelcty": "SLEETMUTE",
    "dropdelst": "AK",
    "dropdelzpp": 996689800,
    "dropphyadd": "100 POST OFFICE DR",
    "dropphycty": "SLEETMUTE",
    "dropphyst": "AK",
    "dropphyzpp": 996689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLEETMUTE",
    "dropmalst": "AK",
    "dropmalzpp": 996689998,
    "dropsitphn": 9074494204,
    "dropsitlph": 9074494204,
    "dropsitcph": 9074494204,
    "dropfax": 9074494204
  },
  {
    "dcode": "D",
    "dropkey": "PZ10294",
    "droptype": "D",
    "dropname": "SOLDOTNA",
    "dropdeladd": "175 N BINKLEY ST",
    "dropdelcty": "SOLDOTNA",
    "dropdelst": "AK",
    "dropdelzpp": 996699998,
    "dropphyadd": "175 N BINKLEY ST",
    "dropphycty": "SOLDOTNA",
    "dropphyst": "AK",
    "dropphyzpp": 996699998,
    "dropmaladd": "175 N BINKLEY ST",
    "dropmalcty": "SOLDOTNA",
    "dropmalst": "AK",
    "dropmalzpp": 996699998,
    "dropsitphn": 9072624760,
    "dropsitlph": 9072624760,
    "dropsitcph": 9072624760,
    "dropfax": 9072622378
  },
  {
    "dcode": "D",
    "dropkey": "PZ10295",
    "droptype": "D",
    "dropname": "SOUTH NAKNEK",
    "dropdeladd": "500 7TH ST",
    "dropdelcty": "SOUTH NAKNEK",
    "dropdelst": "AK",
    "dropdelzpp": 996709800,
    "dropphyadd": "500 7TH ST",
    "dropphycty": "SOUTH NAKNEK",
    "dropphyst": "AK",
    "dropphyzpp": 996709800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH NAKNEK",
    "dropmalst": "AK",
    "dropmalzpp": 996709998,
    "dropsitphn": 9072466531,
    "dropsitlph": 9072466531,
    "dropsitcph": 9072466531,
    "dropfax": 9072466531
  },
  {
    "dcode": "D",
    "dropkey": "PZ10309",
    "droptype": "D",
    "dropname": "STEBBINS",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "STEBBINS",
    "dropdelst": "AK",
    "dropdelzpp": 996719800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "STEBBINS",
    "dropphyst": "AK",
    "dropphyzpp": 996719800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEBBINS",
    "dropmalst": "AK",
    "dropmalzpp": 996719998,
    "dropsitphn": 9079343391,
    "dropsitlph": 9079343391,
    "dropsitcph": 9079343391,
    "dropfax": 9079343391
  },
  {
    "dcode": "D",
    "dropkey": "PZ10311",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "38161 MIDWAY DR",
    "dropdelcty": "STERLING",
    "dropdelst": "AK",
    "dropdelzpp": 996729800,
    "dropphyadd": "38161 MIDWAY DR",
    "dropphycty": "STERLING",
    "dropphyst": "AK",
    "dropphyzpp": 996729800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STERLING",
    "dropmalst": "AK",
    "dropmalzpp": 996729998,
    "dropsitphn": 9072624794,
    "dropsitlph": 9072624794,
    "dropsitcph": 9072624794,
    "dropfax": 9072622860
  },
  {
    "dcode": "D",
    "dropkey": "PZ10312",
    "droptype": "D",
    "dropname": "STEVENS VILLAGE",
    "dropdeladd": "9774 STEVENS VILLAGE RD",
    "dropdelcty": "STEVENS VILLAGE",
    "dropdelst": "AK",
    "dropdelzpp": 997749800,
    "dropphyadd": "9774 STEVENS VILLAGE RD",
    "dropphycty": "STEVENS VILLAGE",
    "dropphyst": "AK",
    "dropphyzpp": 997749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEVENS VILLAGE",
    "dropmalst": "AK",
    "dropmalzpp": 997749998,
    "dropsitphn": 9074787496,
    "dropsitlph": 9074787496,
    "dropsitcph": 9074787496,
    "dropfax": 9074787498
  },
  {
    "dcode": "D",
    "dropkey": "PZ10315",
    "droptype": "D",
    "dropname": "SUTTON",
    "dropdeladd": "11266 N CHICKALOON WAY",
    "dropdelcty": "SUTTON",
    "dropdelst": "AK",
    "dropdelzpp": 996749800,
    "dropphyadd": "11266 N CHICKALOON WAY",
    "dropphycty": "SUTTON",
    "dropphyst": "AK",
    "dropphyzpp": 996749800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUTTON",
    "dropmalst": "AK",
    "dropmalzpp": 996749998,
    "dropsitphn": 9077453433,
    "dropsitlph": 9077453433,
    "dropsitcph": 9077453433,
    "dropfax": 9077453494
  },
  {
    "dcode": "D",
    "dropkey": "PZ10317",
    "droptype": "D",
    "dropname": "TALKEETNA",
    "dropdeladd": "13707 E 1ST ST",
    "dropdelcty": "TALKEETNA",
    "dropdelst": "AK",
    "dropdelzpp": 996769800,
    "dropphyadd": "13707 E 1ST ST",
    "dropphycty": "TALKEETNA",
    "dropphyst": "AK",
    "dropphyzpp": 996769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TALKEETNA",
    "dropmalst": "AK",
    "dropmalzpp": 996769998,
    "dropsitphn": 9077332275,
    "dropsitlph": 9077332275,
    "dropsitcph": 9077332275,
    "dropfax": 9077331721
  },
  {
    "dcode": "D",
    "dropkey": "PZ10319",
    "droptype": "D",
    "dropname": "TANANA",
    "dropdeladd": "100 FRONT ST",
    "dropdelcty": "TANANA",
    "dropdelst": "AK",
    "dropdelzpp": 997779800,
    "dropphyadd": "100 FRONT ST",
    "dropphycty": "TANANA",
    "dropphyst": "AK",
    "dropphyzpp": 997779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TANANA",
    "dropmalst": "AK",
    "dropmalzpp": 997779998,
    "dropsitphn": 9073667250,
    "dropsitlph": 9073667250,
    "dropsitcph": 9073667250,
    "dropfax": 9073667250
  },
  {
    "dcode": "D",
    "dropkey": "PZ10321",
    "droptype": "D",
    "dropname": "TELLER",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "TELLER",
    "dropdelst": "AK",
    "dropdelzpp": 997789800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "TELLER",
    "dropphyst": "AK",
    "dropphyzpp": 997789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TELLER",
    "dropmalst": "AK",
    "dropmalzpp": 997789998,
    "dropsitphn": 9076424261,
    "dropsitlph": 9076424261,
    "dropsitcph": 9076424261,
    "dropfax": 9076422017
  },
  {
    "dcode": "D",
    "dropkey": "PZ10323",
    "droptype": "D",
    "dropname": "TENAKEE SPRINGS",
    "dropdeladd": "108 E TENAKEE AVE",
    "dropdelcty": "TENAKEE SPRINGS",
    "dropdelst": "AK",
    "dropdelzpp": 998419800,
    "dropphyadd": "108 E TENAKEE AVE",
    "dropphycty": "TENAKEE SPRINGS",
    "dropphyst": "AK",
    "dropphyzpp": 998419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TENAKEE SPRINGS",
    "dropmalst": "AK",
    "dropmalzpp": 998419998,
    "dropsitphn": 9077362236,
    "dropsitlph": 9077362236,
    "dropsitcph": 9077362236,
    "dropfax": 9077362241
  },
  {
    "dcode": "D",
    "dropkey": "PZ10326",
    "droptype": "D",
    "dropname": "TOGIAK",
    "dropdeladd": "9998 AIRPORT WAY",
    "dropdelcty": "TOGIAK",
    "dropdelst": "AK",
    "dropdelzpp": 996789800,
    "dropphyadd": "9998 AIRPORT WAY",
    "dropphycty": "TOGIAK",
    "dropphyst": "AK",
    "dropphyzpp": 996789800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOGIAK",
    "dropmalst": "AK",
    "dropmalzpp": 996789998,
    "dropsitphn": 9074935228,
    "dropsitlph": 9074935228,
    "dropsitcph": 9074935228,
    "dropfax": 9074935546
  },
  {
    "dcode": "D",
    "dropkey": "PZ10327",
    "droptype": "D",
    "dropname": "TOK",
    "dropdeladd": "1314.3 ALASKA HWY",
    "dropdelcty": "TOK",
    "dropdelst": "AK",
    "dropdelzpp": 997809800,
    "dropphyadd": "1314.3 ALASKA HWY",
    "dropphycty": "TOK",
    "dropphyst": "AK",
    "dropphyzpp": 997809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOK",
    "dropmalst": "AK",
    "dropmalzpp": 997809998,
    "dropsitphn": 9078835880,
    "dropsitlph": 9078835880,
    "dropsitcph": 9078835880,
    "dropfax": 9078835881
  },
  {
    "dcode": "D",
    "dropkey": "PZ10332",
    "droptype": "D",
    "dropname": "TUNUNAK",
    "dropdeladd": "100 AIRPORT WAY",
    "dropdelcty": "TUNUNAK",
    "dropdelst": "AK",
    "dropdelzpp": 996819800,
    "dropphyadd": "100 AIRPORT WAY",
    "dropphycty": "TUNUNAK",
    "dropphyst": "AK",
    "dropphyzpp": 996819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUNUNAK",
    "dropmalst": "AK",
    "dropmalzpp": 996819998,
    "dropsitphn": 9076526526,
    "dropsitlph": 9076526526,
    "dropsitcph": 9076526526,
    "dropfax": 9076526776
  },
  {
    "dcode": "D",
    "dropkey": "PZ10335",
    "droptype": "D",
    "dropname": "TYONEK",
    "dropdeladd": "16 C ST",
    "dropdelcty": "TYONEK",
    "dropdelst": "AK",
    "dropdelzpp": 996829800,
    "dropphyadd": "16 C ST",
    "dropphycty": "TYONEK",
    "dropphyst": "AK",
    "dropphyzpp": 996829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYONEK",
    "dropmalst": "AK",
    "dropmalzpp": 996829998,
    "dropsitphn": 9075832315,
    "dropsitlph": 9075832315,
    "dropsitcph": 9075832315,
    "dropfax": 9075832316
  },
  {
    "dcode": "D",
    "dropkey": "PZ10336",
    "droptype": "D",
    "dropname": "UNALAKLEET",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "UNALAKLEET",
    "dropdelst": "AK",
    "dropdelzpp": 996849800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "UNALAKLEET",
    "dropphyst": "AK",
    "dropphyzpp": 996849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNALAKLEET",
    "dropmalst": "AK",
    "dropmalzpp": 996849998,
    "dropsitphn": 9076243111,
    "dropsitlph": 9076243111,
    "dropsitcph": 9076243111,
    "dropfax": 9076243033
  },
  {
    "dcode": "D",
    "dropkey": "PZ10337",
    "droptype": "D",
    "dropname": "UNALASKA",
    "dropdeladd": "82 AIRPORT BEACH RD",
    "dropdelcty": "UNALASKA",
    "dropdelst": "AK",
    "dropdelzpp": 996859800,
    "dropphyadd": "82 AIRPORT BEACH RD",
    "dropphycty": "UNALASKA",
    "dropphyst": "AK",
    "dropphyzpp": 996859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNALASKA",
    "dropmalst": "AK",
    "dropmalzpp": 996859998,
    "dropsitphn": 9075811232,
    "dropsitlph": 9075811232,
    "dropsitcph": 9075811232,
    "dropfax": 9075814141
  },
  {
    "dcode": "D",
    "dropkey": "PZ10342",
    "droptype": "D",
    "dropname": "VALDEZ",
    "dropdeladd": "221 TATITLEK ST",
    "dropdelcty": "VALDEZ",
    "dropdelst": "AK",
    "dropdelzpp": 996869800,
    "dropphyadd": "221 TATITLEK ST",
    "dropphycty": "VALDEZ",
    "dropphyst": "AK",
    "dropphyzpp": 996869800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALDEZ",
    "dropmalst": "AK",
    "dropmalzpp": 996869998,
    "dropsitphn": 9078354449,
    "dropsitlph": 9078354449,
    "dropsitcph": 9078354449,
    "dropfax": 9078352399
  },
  {
    "dcode": "D",
    "dropkey": "PZ10343",
    "droptype": "D",
    "dropname": "VENETIE",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "VENETIE",
    "dropdelst": "AK",
    "dropdelzpp": 997819800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "VENETIE",
    "dropphyst": "AK",
    "dropphyzpp": 997819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENETIE",
    "dropmalst": "AK",
    "dropmalzpp": 997819998,
    "dropsitphn": 9078498429,
    "dropsitlph": 9078498429,
    "dropsitcph": 9078498429,
    "dropfax": 9078498429
  },
  {
    "dcode": "D",
    "dropkey": "PZ10344",
    "droptype": "D",
    "dropname": "WAINWRIGHT",
    "dropdeladd": "9998 WAINWRIGHT RD",
    "dropdelcty": "WAINWRIGHT",
    "dropdelst": "AK",
    "dropdelzpp": 997829800,
    "dropphyadd": "9998 WAINWRIGHT RD",
    "dropphycty": "WAINWRIGHT",
    "dropphyst": "AK",
    "dropphyzpp": 997829800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAINWRIGHT",
    "dropmalst": "AK",
    "dropmalzpp": 997829998,
    "dropsitphn": 9077632020,
    "dropsitlph": 9077632020,
    "dropsitcph": 9077632020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10345",
    "droptype": "D",
    "dropname": "WALES",
    "dropdeladd": "500 AIRPORT JUNCTION RD",
    "dropdelcty": "WALES",
    "dropdelst": "AK",
    "dropdelzpp": 997839800,
    "dropphyadd": "500 AIRPORT JUNCTION RD",
    "dropphycty": "WALES",
    "dropphyst": "AK",
    "dropphyzpp": 997839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALES",
    "dropmalst": "AK",
    "dropmalzpp": 997839998,
    "dropsitphn": 9076643331,
    "dropsitlph": 9076643331,
    "dropsitcph": 9076643331,
    "dropfax": 9076642141
  },
  {
    "dcode": "D",
    "dropkey": "PZ10346",
    "droptype": "D",
    "dropname": "WARD COVE",
    "dropdeladd": "7172 N TONGASS HWY",
    "dropdelcty": "WARD COVE",
    "dropdelst": "AK",
    "dropdelzpp": 999289800,
    "dropphyadd": "7172 N TONGASS HWY",
    "dropphycty": "WARD COVE",
    "dropphyst": "AK",
    "dropphyzpp": 999289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARD COVE",
    "dropmalst": "AK",
    "dropmalzpp": 999289998,
    "dropsitphn": 9072472687,
    "dropsitlph": 9072472687,
    "dropsitcph": 9072472687,
    "dropfax": 9072470776
  },
  {
    "dcode": "D",
    "dropkey": "PZ10348",
    "droptype": "D",
    "dropname": "WASILLA",
    "dropdeladd": "401 N MAIN ST",
    "dropdelcty": "WASILLA",
    "dropdelst": "AK",
    "dropdelzpp": 996549998,
    "dropphyadd": "401 N MAIN ST",
    "dropphycty": "WASILLA",
    "dropphyst": "AK",
    "dropphyzpp": 996549998,
    "dropmaladd": "PO BOX 879998",
    "dropmalcty": "WASILLA",
    "dropmalst": "AK",
    "dropmalzpp": 996879998,
    "dropsitphn": 9073764194,
    "dropsitlph": 9073765327,
    "dropsitcph": 9073765327,
    "dropfax": 9073767164
  },
  {
    "dcode": "D",
    "dropkey": "PZ10349",
    "droptype": "D",
    "dropname": "WHITE MOUNTAIN",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "WHITE MOUNTAIN",
    "dropdelst": "AK",
    "dropdelzpp": 997849800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "WHITE MOUNTAIN",
    "dropphyst": "AK",
    "dropphyzpp": 997849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE MOUNTAIN",
    "dropmalst": "AK",
    "dropmalzpp": 997849998,
    "dropsitphn": 9076383541,
    "dropsitlph": 9076383541,
    "dropsitcph": 9076383541,
    "dropfax": 9076383541
  },
  {
    "dcode": "D",
    "dropkey": "PZ10351",
    "droptype": "D",
    "dropname": "WILLOW",
    "dropdeladd": "13232 N MCKINLEY WAY",
    "dropdelcty": "WILLOW",
    "dropdelst": "AK",
    "dropdelzpp": 996889800,
    "dropphyadd": "13232 N MCKINLEY WAY",
    "dropphycty": "WILLOW",
    "dropphyst": "AK",
    "dropphyzpp": 996889800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLOW",
    "dropmalst": "AK",
    "dropmalzpp": 996889998,
    "dropsitphn": 9074956266,
    "dropsitlph": 9074956266,
    "dropsitcph": 9074956266,
    "dropfax": 9074956270
  },
  {
    "dcode": "D",
    "dropkey": "PZ10352",
    "droptype": "D",
    "dropname": "WRANGELL",
    "dropdeladd": "112 FEDERAL WAY",
    "dropdelcty": "WRANGELL",
    "dropdelst": "AK",
    "dropdelzpp": 999299800,
    "dropphyadd": "112 FEDERAL WAY",
    "dropphycty": "WRANGELL",
    "dropphyst": "AK",
    "dropphyzpp": 999299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WRANGELL",
    "dropmalst": "AK",
    "dropmalzpp": 999299998,
    "dropsitphn": 9078743714,
    "dropsitlph": 9078743714,
    "dropsitcph": 9078743714,
    "dropfax": 9078742754
  },
  {
    "dcode": "D",
    "dropkey": "PZ10353",
    "droptype": "D",
    "dropname": "YAKUTAT",
    "dropdeladd": "477 MALLOTTS AVE",
    "dropdelcty": "YAKUTAT",
    "dropdelst": "AK",
    "dropdelzpp": 996899800,
    "dropphyadd": "477 MALLOTTS AVE",
    "dropphycty": "YAKUTAT",
    "dropphyst": "AK",
    "dropphyzpp": 996899800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YAKUTAT",
    "dropmalst": "AK",
    "dropmalzpp": 996899998,
    "dropsitphn": 9077843201,
    "dropsitlph": 9077843201,
    "dropsitcph": 9077843201,
    "dropfax": 9077843558
  },
  {
    "dcode": "D",
    "dropkey": "PZ10357",
    "droptype": "D",
    "dropname": "PAGO PAGO",
    "dropdeladd": "1 LUMANAI BLDG",
    "dropdelcty": "PAGO PAGO",
    "dropdelst": "AS",
    "dropdelzpp": 967999994,
    "dropphyadd": "1 LUMANAI BLDG",
    "dropphycty": "PAGO PAGO",
    "dropphyst": "AS",
    "dropphyzpp": 967999994,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAGO PAGO",
    "dropmalst": "AS",
    "dropmalzpp": 967999998,
    "dropsitphn": 6846334051,
    "dropsitlph": 6846334051,
    "dropsitcph": 6846334051,
    "dropfax": 6846331860
  },
  {
    "dcode": "D",
    "dropkey": "PZ10361",
    "droptype": "D",
    "dropname": "AGUILA",
    "dropdeladd": "51227 HIGHWAY 60",
    "dropdelcty": "AGUILA",
    "dropdelst": "AZ",
    "dropdelzpp": 853209600,
    "dropphyadd": "51227 HIGHWAY 60",
    "dropphycty": "AGUILA",
    "dropphyst": "AZ",
    "dropphyzpp": 853209600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AGUILA",
    "dropmalst": "AZ",
    "dropmalzpp": 853209998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286853314,
    "dropsitcph": 9286853314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10365",
    "droptype": "D",
    "dropname": "AJO",
    "dropdeladd": "20 N PLAZA ST",
    "dropdelcty": "AJO",
    "dropdelst": "AZ",
    "dropdelzpp": 853219998,
    "dropphyadd": "20 N PLAZA ST",
    "dropphycty": "AJO",
    "dropphyst": "AZ",
    "dropphyzpp": 853219998,
    "dropmaladd": "20 N PLAZA ST",
    "dropmalcty": "AJO",
    "dropmalst": "AZ",
    "dropmalzpp": 853219998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5203876002,
    "dropsitcph": 5203876602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10367",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "42631 HWY 191",
    "dropdelcty": "ALPINE",
    "dropdelst": "AZ",
    "dropdelzpp": 859205300,
    "dropphyadd": "42631 HWY 191",
    "dropphycty": "ALPINE",
    "dropphyst": "AZ",
    "dropphyzpp": 859205300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPINE",
    "dropmalst": "AZ",
    "dropmalzpp": 859209998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283394697,
    "dropsitcph": 9283394697,
    "dropfax": 9283394564
  },
  {
    "dcode": "D",
    "dropkey": "PZ10369",
    "droptype": "D",
    "dropname": "APACHE JUNCTION",
    "dropdeladd": "151 W SUPERSTITION BLVD",
    "dropdelcty": "APACHE JUNCTION",
    "dropdelst": "AZ",
    "dropdelzpp": 851209998,
    "dropphyadd": "151 W SUPERSTITION BLVD",
    "dropphycty": "APACHE JUNCTION",
    "dropphyst": "AZ",
    "dropphyzpp": 851209998,
    "dropmaladd": "151 W SUPERSTITION BLVD",
    "dropmalcty": "APACHE JUNCTION",
    "dropmalst": "AZ",
    "dropmalzpp": 851209998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4802881485,
    "dropsitcph": 4809837186,
    "dropfax": 4809822571
  },
  {
    "dcode": "D",
    "dropkey": "PZ10371",
    "droptype": "D",
    "dropname": "ARIVACA",
    "dropdeladd": "17245 W 5TH ST",
    "dropdelcty": "ARIVACA",
    "dropdelst": "AZ",
    "dropdelzpp": 856019997,
    "dropphyadd": "17245 W 5TH ST",
    "dropphycty": "ARIVACA",
    "dropphyst": "AZ",
    "dropphyzpp": 856019997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARIVACA",
    "dropmalst": "AZ",
    "dropmalzpp": 856019998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203989241,
    "dropsitcph": 5203989241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10381",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "33039 W OLD US HIGHWAY 80",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "AZ",
    "dropdelzpp": 853229998,
    "dropphyadd": "33039 W OLD US HIGHWAY 80",
    "dropphycty": "ARLINGTON",
    "dropphyst": "AZ",
    "dropphyzpp": 853229998,
    "dropmaladd": "33039 W OLD US HIGHWAY 80",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "AZ",
    "dropmalzpp": 853229998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6233863679,
    "dropsitcph": 6233863679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10383",
    "droptype": "D",
    "dropname": "ASH FORK",
    "dropdeladd": "765 W OLD HIGHWAY 66",
    "dropdelcty": "ASH FORK",
    "dropdelst": "AZ",
    "dropdelzpp": 863205301,
    "dropphyadd": "765 W OLD HIGHWAY 66",
    "dropphycty": "ASH FORK",
    "dropphyst": "AZ",
    "dropphyzpp": 863205301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASH FORK",
    "dropmalst": "AZ",
    "dropmalzpp": 863209998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286372554,
    "dropsitcph": 9286372554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10385",
    "droptype": "D",
    "dropname": "AVONDALE GOODYEAR",
    "dropdeladd": "875 S ESTRELLA PKWY",
    "dropdelcty": "GOODYEAR",
    "dropdelst": "AZ",
    "dropdelzpp": 853389998,
    "dropphyadd": "875 S ESTRELLA PKWY",
    "dropphycty": "GOODYEAR",
    "dropphyst": "AZ",
    "dropphyzpp": 853389998,
    "dropmaladd": "875 S ESTRELLA PKWY",
    "dropmalcty": "GOODYEAR",
    "dropmalst": "AZ",
    "dropmalzpp": 853389998,
    "dropsitphn": 6238829146,
    "dropsitlph": 6238829143,
    "dropsitcph": 6238829148,
    "dropfax": 6238829239
  },
  {
    "dcode": "D",
    "dropkey": "PZ10389",
    "droptype": "D",
    "dropname": "BAGDAD",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "BAGDAD",
    "dropdelst": "AZ",
    "dropdelzpp": 863212100,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "BAGDAD",
    "dropphyst": "AZ",
    "dropphyzpp": 863212100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAGDAD",
    "dropmalst": "AZ",
    "dropmalzpp": 863219998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286332553,
    "dropsitcph": 9286332553,
    "dropfax": 9286335477
  },
  {
    "dcode": "D",
    "dropkey": "PZ10394",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "250 S OCOTILLO ST",
    "dropdelcty": "BENSON",
    "dropdelst": "AZ",
    "dropdelzpp": 856029998,
    "dropphyadd": "250 S OCOTILLO ST",
    "dropphycty": "BENSON",
    "dropphyst": "AZ",
    "dropphyzpp": 856029998,
    "dropmaladd": "250 S OCOTILLO ST",
    "dropmalcty": "BENSON",
    "dropmalst": "AZ",
    "dropmalzpp": 856029998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205863422,
    "dropsitcph": 5205863422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10395",
    "droptype": "D",
    "dropname": "BISBEE",
    "dropdeladd": "1248 W HIGHWAY 92",
    "dropdelcty": "BISBEE",
    "dropdelst": "AZ",
    "dropdelzpp": 856039998,
    "dropphyadd": "1248 W HIGHWAY 92",
    "dropphycty": "BISBEE",
    "dropphyst": "AZ",
    "dropphyzpp": 856039998,
    "dropmaladd": "1248 W HIGHWAY 92",
    "dropmalcty": "BISBEE",
    "dropmalst": "AZ",
    "dropmalzpp": 856039998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204322626,
    "dropsitcph": 5204322626,
    "dropfax": 5204327285
  },
  {
    "dcode": "D",
    "dropkey": "PZ10397",
    "droptype": "D",
    "dropname": "BLACK CANYON CITY",
    "dropdeladd": "19060 E K MINE RD",
    "dropdelcty": "BLACK CANYON CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 853249997,
    "dropphyadd": "19060 E K MINE RD",
    "dropphycty": "BLACK CANYON CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 853249997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK CANYON CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 853249998,
    "dropsitphn": 6022253214,
    "dropsitlph": 3253077607,
    "dropsitcph": 3253077607,
    "dropfax": 6233745871
  },
  {
    "dcode": "D",
    "dropkey": "PZ10399",
    "droptype": "D",
    "dropname": "BLUE",
    "dropdeladd": "43287 BLUE RIVER RD",
    "dropdelcty": "BLUE",
    "dropdelst": "AZ",
    "dropdelzpp": 859229900,
    "dropphyadd": "43287 BLUE RIVER RD",
    "dropphycty": "BLUE",
    "dropphyst": "AZ",
    "dropphyzpp": 859229900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE",
    "dropmalst": "AZ",
    "dropmalzpp": 859229998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283394945,
    "dropsitcph": 9283394945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10402",
    "droptype": "D",
    "dropname": "BOUSE",
    "dropdeladd": "27582 ARIZONA HWY 72",
    "dropdelcty": "BOUSE",
    "dropdelst": "AZ",
    "dropdelzpp": 853259997,
    "dropphyadd": "27582 ARIZONA HWY 72",
    "dropphycty": "BOUSE",
    "dropphyst": "AZ",
    "dropphyzpp": 853259997,
    "dropmaladd": "27582 ARIZONA HWY 72",
    "dropmalcty": "BOUSE",
    "dropmalst": "AZ",
    "dropmalzpp": 853259997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288510002,
    "dropsitcph": 9288510001,
    "dropfax": 9288510003
  },
  {
    "dcode": "D",
    "dropkey": "PZ10403",
    "droptype": "D",
    "dropname": "BOWIE",
    "dropdeladd": "118 E LOOP I 10",
    "dropdelcty": "BOWIE",
    "dropdelst": "AZ",
    "dropdelzpp": 856059900,
    "dropphyadd": "118 E LOOP I 10",
    "dropphycty": "BOWIE",
    "dropphyst": "AZ",
    "dropphyzpp": 856059900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOWIE",
    "dropmalst": "AZ",
    "dropmalzpp": 856059998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208472270,
    "dropsitcph": 5208472270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10404",
    "droptype": "D",
    "dropname": "BUCKEYE",
    "dropdeladd": "51 E MONROE AVE",
    "dropdelcty": "BUCKEYE",
    "dropdelst": "AZ",
    "dropdelzpp": 853269998,
    "dropphyadd": "51 E MONROE AVE",
    "dropphycty": "BUCKEYE",
    "dropphyst": "AZ",
    "dropphyzpp": 853269998,
    "dropmaladd": "51 E MONROE AVE",
    "dropmalcty": "BUCKEYE",
    "dropmalst": "AZ",
    "dropmalzpp": 853269998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6233862810,
    "dropsitcph": 6233863117,
    "dropfax": 6233862967
  },
  {
    "dcode": "D",
    "dropkey": "PZ10405",
    "droptype": "D",
    "dropname": "BULLHEAD CITY",
    "dropdeladd": "1882 LAKESIDE DR",
    "dropdelcty": "BULLHEAD CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 864429998,
    "dropphyadd": "1882 LAKESIDE DR",
    "dropphycty": "BULLHEAD CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 864429998,
    "dropmaladd": "1882 LAKESIDE DR",
    "dropmalcty": "BULLHEAD CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 864429998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287585730,
    "dropsitcph": 9287585711,
    "dropfax": 9287587472
  },
  {
    "dcode": "D",
    "dropkey": "PZ10410",
    "droptype": "D",
    "dropname": "BYLAS",
    "dropdeladd": "297 E US HIGHWAY 70",
    "dropdelcty": "BYLAS",
    "dropdelst": "AZ",
    "dropdelzpp": 855309900,
    "dropphyadd": "297 E US HIGHWAY 70",
    "dropphycty": "BYLAS",
    "dropphyst": "AZ",
    "dropphyzpp": 855309900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYLAS",
    "dropmalst": "AZ",
    "dropmalzpp": 855309998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284754224,
    "dropsitcph": 9284754224,
    "dropfax": 9284753917
  },
  {
    "dcode": "D",
    "dropkey": "PZ10412",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "465 HIGHWAY 89",
    "dropdelcty": "CAMERON",
    "dropdelst": "AZ",
    "dropdelzpp": 860209995,
    "dropphyadd": "465 HIGHWAY 89",
    "dropphycty": "CAMERON",
    "dropphyst": "AZ",
    "dropphyzpp": 860209995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMERON",
    "dropmalst": "AZ",
    "dropmalzpp": 860209998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286792393,
    "dropsitcph": 9286792393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10413",
    "droptype": "D",
    "dropname": "CAMP VERDE",
    "dropdeladd": "403 W FINNIE FLAT RD",
    "dropdelcty": "CAMP VERDE",
    "dropdelst": "AZ",
    "dropdelzpp": 863227279,
    "dropphyadd": "403 W FINNIE FLAT RD",
    "dropphycty": "CAMP VERDE",
    "dropphyst": "AZ",
    "dropphyzpp": 863227279,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMP VERDE",
    "dropmalst": "AZ",
    "dropmalzpp": 863229998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285673175,
    "dropsitcph": 9285673175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10423",
    "droptype": "D",
    "dropname": "CASA GRANDE",
    "dropdeladd": "1670 N PINAL AVE",
    "dropdelcty": "CASA GRANDE",
    "dropdelst": "AZ",
    "dropdelzpp": 851229998,
    "dropphyadd": "1670 N PINAL AVE",
    "dropphycty": "CASA GRANDE",
    "dropphyst": "AZ",
    "dropphyzpp": 851229998,
    "dropmaladd": "1670 N PINAL AVE",
    "dropmalcty": "CASA GRANDE",
    "dropmalst": "AZ",
    "dropmalzpp": 851229998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4804610507,
    "dropsitcph": 5208367221,
    "dropfax": 5208360970
  },
  {
    "dcode": "D",
    "dropkey": "PZ10426",
    "droptype": "D",
    "dropname": "CASHION",
    "dropdeladd": "1216 S 111TH DR",
    "dropdelcty": "CASHION",
    "dropdelst": "AZ",
    "dropdelzpp": 853299800,
    "dropphyadd": "1216 S 111TH DR",
    "dropphycty": "CASHION",
    "dropphyst": "AZ",
    "dropphyzpp": 853299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASHION",
    "dropmalst": "AZ",
    "dropmalzpp": 853299998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239361362,
    "dropsitcph": 6239361362,
    "dropfax": 6239074258
  },
  {
    "dcode": "D",
    "dropkey": "PZ10428",
    "droptype": "D",
    "dropname": "CAVE CREEK",
    "dropdeladd": "38400 N SCHOOL HOUSE RD",
    "dropdelcty": "CAVE CREEK",
    "dropdelst": "AZ",
    "dropdelzpp": 853319998,
    "dropphyadd": "38400 N SCHOOL HOUSE RD",
    "dropphycty": "CAVE CREEK",
    "dropphyst": "AZ",
    "dropphyzpp": 853319998,
    "dropmaladd": "38400 N SCHOOL HOUSE RD",
    "dropmalcty": "CAVE CREEK",
    "dropmalst": "AZ",
    "dropmalzpp": 853319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4804881218,
    "dropsitcph": 4805959598,
    "dropfax": 4804881402
  },
  {
    "dcode": "D",
    "dropkey": "PZ10431",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "5442 W COOMBS ST",
    "dropdelcty": "CENTRAL",
    "dropdelst": "AZ",
    "dropdelzpp": 855319997,
    "dropphyadd": "5442 W COOMBS ST",
    "dropphycty": "CENTRAL",
    "dropphyst": "AZ",
    "dropphyzpp": 855319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTRAL",
    "dropmalst": "AZ",
    "dropmalzpp": 855319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284286130,
    "dropsitcph": 9284286130,
    "dropfax": 9283488193
  },
  {
    "dcode": "D",
    "dropkey": "PZ10432",
    "droptype": "D",
    "dropname": "CHAMBERS",
    "dropdeladd": "800 HIGHWAY 191",
    "dropdelcty": "CHAMBERS",
    "dropdelst": "AZ",
    "dropdelzpp": 865021701,
    "dropphyadd": "800 HIGHWAY 191",
    "dropphycty": "CHAMBERS",
    "dropphyst": "AZ",
    "dropphyzpp": 865021701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMBERS",
    "dropmalst": "AZ",
    "dropmalzpp": 865029998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5205400716,
    "dropsitcph": 5205400716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10433",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "101 N COLORADO ST",
    "dropdelcty": "CHANDLER",
    "dropdelst": "AZ",
    "dropdelzpp": 852259998,
    "dropphyadd": "101 N COLORADO ST",
    "dropphycty": "CHANDLER",
    "dropphyst": "AZ",
    "dropphyzpp": 852259998,
    "dropmaladd": "101 N COLORADO ST",
    "dropmalcty": "CHANDLER",
    "dropmalst": "AZ",
    "dropmalzpp": 852259998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4808998065,
    "dropsitcph": 4809633673,
    "dropfax": 4807866558
  },
  {
    "dcode": "D",
    "dropkey": "PZ10439",
    "droptype": "D",
    "dropname": "CHINLE",
    "dropdeladd": "500 HIGHWAY 191",
    "dropdelcty": "CHINLE",
    "dropdelst": "AZ",
    "dropdelzpp": 865031799,
    "dropphyadd": "500 HIGHWAY 191",
    "dropphycty": "CHINLE",
    "dropphyst": "AZ",
    "dropphyzpp": 865031799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHINLE",
    "dropmalst": "AZ",
    "dropmalzpp": 865039998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9286745609,
    "dropsitcph": 9286745609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10440",
    "droptype": "D",
    "dropname": "CHINO VALLEY",
    "dropdeladd": "725 E ROAD 2 N",
    "dropdelcty": "CHINO VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 863239998,
    "dropphyadd": "725 E ROAD 2 N",
    "dropphycty": "CHINO VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 863239998,
    "dropmaladd": "725 E ROAD 2 N",
    "dropmalcty": "CHINO VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 863239998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286361913,
    "dropsitcph": 9286362907,
    "dropfax": 9286361966
  },
  {
    "dcode": "D",
    "dropkey": "PZ10443",
    "droptype": "D",
    "dropname": "CHLORIDE",
    "dropdeladd": "4961 W TENNESSEE AVE",
    "dropdelcty": "CHLORIDE",
    "dropdelst": "AZ",
    "dropdelzpp": 864319997,
    "dropphyadd": "4961 W TENNESSEE AVE",
    "dropphycty": "CHLORIDE",
    "dropphyst": "AZ",
    "dropphyzpp": 864319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHLORIDE",
    "dropmalst": "AZ",
    "dropmalzpp": 864319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285654890,
    "dropsitcph": 9285654890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10448",
    "droptype": "D",
    "dropname": "CLARKDALE",
    "dropdeladd": "9 S 9TH ST",
    "dropdelcty": "CLARKDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 863249998,
    "dropphyadd": "9 S 9TH ST",
    "dropphycty": "CLARKDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 863249998,
    "dropmaladd": "9 S 9TH ST",
    "dropmalcty": "CLARKDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 863249998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286348709,
    "dropsitcph": 9286345312,
    "dropfax": 9286348709
  },
  {
    "dcode": "D",
    "dropkey": "PZ10450",
    "droptype": "D",
    "dropname": "CLAY SPRINGS",
    "dropdeladd": "4995 GARDENIA",
    "dropdelcty": "CLAY SPRINGS",
    "dropdelst": "AZ",
    "dropdelzpp": 859239997,
    "dropphyadd": "4995 GARDENIA",
    "dropphycty": "CLAY SPRINGS",
    "dropphyst": "AZ",
    "dropphyzpp": 859239997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAY SPRINGS",
    "dropmalst": "AZ",
    "dropmalzpp": 859239998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287394545,
    "dropsitcph": 9287394545,
    "dropfax": 9287394243
  },
  {
    "dcode": "D",
    "dropkey": "PZ10451",
    "droptype": "D",
    "dropname": "CLAYPOOL",
    "dropdeladd": "4281 E BROADWAY",
    "dropdelcty": "CLAYPOOL",
    "dropdelst": "AZ",
    "dropdelzpp": 855329996,
    "dropphyadd": "4281 E BROADWAY",
    "dropphycty": "CLAYPOOL",
    "dropphyst": "AZ",
    "dropphyzpp": 855329996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAYPOOL",
    "dropmalst": "AZ",
    "dropmalzpp": 855329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284732131,
    "dropsitcph": 9284732131,
    "dropfax": 9284732023
  },
  {
    "dcode": "D",
    "dropkey": "PZ10453",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "494 N CORONADO BLVD",
    "dropdelcty": "CLIFTON",
    "dropdelst": "AZ",
    "dropdelzpp": 855339998,
    "dropphyadd": "494 N CORONADO BLVD",
    "dropphycty": "CLIFTON",
    "dropphyst": "AZ",
    "dropphyzpp": 855339998,
    "dropmaladd": "494 N CORONADO BLVD",
    "dropmalcty": "CLIFTON",
    "dropmalst": "AZ",
    "dropmalzpp": 855339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288653892,
    "dropsitcph": 9288653892,
    "dropfax": 9288652042
  },
  {
    "dcode": "D",
    "dropkey": "PZ10455",
    "droptype": "D",
    "dropname": "COCHISE",
    "dropdeladd": "5066 N DOS CABEZAS ST",
    "dropdelcty": "COCHISE",
    "dropdelst": "AZ",
    "dropdelzpp": 856069998,
    "dropphyadd": "5066 N DOS CABEZAS ST",
    "dropphycty": "COCHISE",
    "dropphyst": "AZ",
    "dropphyzpp": 856069998,
    "dropmaladd": "5066 N DOS CABEZAS ST",
    "dropmalcty": "COCHISE",
    "dropmalst": "AZ",
    "dropmalzpp": 856069998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203844384,
    "dropsitcph": 5203844384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10456",
    "droptype": "D",
    "dropname": "COLORADO CITY",
    "dropdeladd": "85 S CENTRAL ST",
    "dropdelcty": "COLORADO CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 860216325,
    "dropphyadd": "85 S CENTRAL ST",
    "dropphycty": "COLORADO CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 860216325,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLORADO CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 860219998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288516338,
    "dropsitcph": 9288516338,
    "dropfax": 9288516307
  },
  {
    "dcode": "D",
    "dropkey": "PZ10458",
    "droptype": "D",
    "dropname": "CONCHO",
    "dropdeladd": "37001 STATE HIGHWAY 61",
    "dropdelcty": "CONCHO",
    "dropdelst": "AZ",
    "dropdelzpp": 859249997,
    "dropphyadd": "37001 STATE HIGHWAY 61",
    "dropphycty": "CONCHO",
    "dropphyst": "AZ",
    "dropphyzpp": 859249997,
    "dropmaladd": "37001 STATE HIGHWAY 61",
    "dropmalcty": "CONCHO",
    "dropmalst": "AZ",
    "dropmalzpp": 859249997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283372957,
    "dropsitcph": 9283374494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10460",
    "droptype": "D",
    "dropname": "CONGRESS",
    "dropdeladd": "22850 W HIGHWAY 71",
    "dropdelcty": "CONGRESS",
    "dropdelst": "AZ",
    "dropdelzpp": 853325500,
    "dropphyadd": "22850 W HIGHWAY 71",
    "dropphycty": "CONGRESS",
    "dropphyst": "AZ",
    "dropphyzpp": 853325500,
    "dropmaladd": "22850 W HIGHWAY 71",
    "dropmalcty": "CONGRESS",
    "dropmalst": "AZ",
    "dropmalzpp": 853325500,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284276237,
    "dropsitcph": 9284276237,
    "dropfax": 9284270139
  },
  {
    "dcode": "D",
    "dropkey": "PZ10462",
    "droptype": "D",
    "dropname": "COOLIDGE",
    "dropdeladd": "229 W CENTRAL AVE",
    "dropdelcty": "COOLIDGE",
    "dropdelst": "AZ",
    "dropdelzpp": 851289998,
    "dropphyadd": "229 W CENTRAL AVE",
    "dropphycty": "COOLIDGE",
    "dropphyst": "AZ",
    "dropphyzpp": 851289998,
    "dropmaladd": "229 W CENTRAL AVE",
    "dropmalcty": "COOLIDGE",
    "dropmalst": "AZ",
    "dropmalzpp": 851289998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5207233011,
    "dropsitcph": 5207233011,
    "dropfax": 5207233011
  },
  {
    "dcode": "D",
    "dropkey": "PZ10468",
    "droptype": "D",
    "dropname": "CORNVILLE",
    "dropdeladd": "9400 E CORNVILLE RD",
    "dropdelcty": "CORNVILLE",
    "dropdelst": "AZ",
    "dropdelzpp": 863259997,
    "dropphyadd": "9400 E CORNVILLE RD",
    "dropphycty": "CORNVILLE",
    "dropphyst": "AZ",
    "dropphyzpp": 863259997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORNVILLE",
    "dropmalst": "AZ",
    "dropmalzpp": 863259998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286344900,
    "dropsitcph": 9286344900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10471",
    "droptype": "D",
    "dropname": "CORTARO",
    "dropdeladd": "5800 W ARIZONA PAVILIONS DR",
    "dropdelcty": "CORTARO",
    "dropdelst": "AZ",
    "dropdelzpp": 856529901,
    "dropphyadd": "5800 W ARIZONA PAVILIONS DR",
    "dropphycty": "CORTARO",
    "dropphyst": "AZ",
    "dropphyzpp": 856529901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORTARO",
    "dropmalst": "AZ",
    "dropmalzpp": 856529998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207446105,
    "dropsitcph": 5207446105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10472",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "700 E MINGUS AVE",
    "dropdelcty": "COTTONWOOD",
    "dropdelst": "AZ",
    "dropdelzpp": 863269998,
    "dropphyadd": "700 E MINGUS AVE",
    "dropphycty": "COTTONWOOD",
    "dropphyst": "AZ",
    "dropphyzpp": 863269998,
    "dropmaladd": "700 E MINGUS AVE",
    "dropmalcty": "COTTONWOOD",
    "dropmalst": "AZ",
    "dropmalzpp": 863269998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286348639,
    "dropsitcph": 9286349526,
    "dropfax": 9286343881
  },
  {
    "dcode": "D",
    "dropkey": "PZ10487",
    "droptype": "D",
    "dropname": "DEWEY",
    "dropdeladd": "12420 E KACHINA PL",
    "dropdelcty": "DEWEY",
    "dropdelst": "AZ",
    "dropdelzpp": 863279998,
    "dropphyadd": "12420 E KACHINA PL",
    "dropphycty": "DEWEY",
    "dropphyst": "AZ",
    "dropphyzpp": 863279998,
    "dropmaladd": "12420 E KACHINA PL",
    "dropmalcty": "DEWEY",
    "dropmalst": "AZ",
    "dropmalzpp": 863279998,
    "dropsitphn": 6022253491,
    "dropsitlph": 9286324287,
    "dropsitcph": 9286327291,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10496",
    "droptype": "D",
    "dropname": "DOUGLAS",
    "dropdeladd": "601 E 10TH ST",
    "dropdelcty": "DOUGLAS",
    "dropdelst": "AZ",
    "dropdelzpp": 856079998,
    "dropphyadd": "601 E 10TH ST",
    "dropphycty": "DOUGLAS",
    "dropphyst": "AZ",
    "dropphyzpp": 856079998,
    "dropmaladd": "601 E 10TH ST",
    "dropmalcty": "DOUGLAS",
    "dropmalst": "AZ",
    "dropmalzpp": 856079998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203685067,
    "dropsitcph": 5203685067,
    "dropfax": 5203647190
  },
  {
    "dcode": "D",
    "dropkey": "PZ10503",
    "droptype": "D",
    "dropname": "DRAGOON",
    "dropdeladd": "4752 DRAGOON RD",
    "dropdelcty": "DRAGOON",
    "dropdelst": "AZ",
    "dropdelzpp": 856099900,
    "dropphyadd": "4752 DRAGOON RD",
    "dropphycty": "DRAGOON",
    "dropphyst": "AZ",
    "dropphyzpp": 856099900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRAGOON",
    "dropmalst": "AZ",
    "dropmalzpp": 856099998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205867100,
    "dropsitcph": 5205867100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10504",
    "droptype": "D",
    "dropname": "DUNCAN",
    "dropdeladd": "209 MAIN ST",
    "dropdelcty": "DUNCAN",
    "dropdelst": "AZ",
    "dropdelzpp": 855349998,
    "dropphyadd": "209 MAIN ST",
    "dropphycty": "DUNCAN",
    "dropphyst": "AZ",
    "dropphyzpp": 855349998,
    "dropmaladd": "209 MAIN ST",
    "dropmalcty": "DUNCAN",
    "dropmalst": "AZ",
    "dropmalzpp": 855349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283511295,
    "dropsitcph": 9283511295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10505",
    "droptype": "D",
    "dropname": "EAGAR",
    "dropdeladd": "113 W CENTRAL AVE",
    "dropdelcty": "EAGAR",
    "dropdelst": "AZ",
    "dropdelzpp": 859259719,
    "dropphyadd": "113 W CENTRAL AVE",
    "dropphycty": "EAGAR",
    "dropphyst": "AZ",
    "dropphyzpp": 859259719,
    "dropmaladd": "113 W CENTRAL AVE",
    "dropmalcty": "EAGAR",
    "dropmalst": "AZ",
    "dropmalzpp": 859259719,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283334764,
    "dropsitcph": 9283334764,
    "dropfax": 9283335224
  },
  {
    "dcode": "D",
    "dropkey": "PZ10508",
    "droptype": "D",
    "dropname": "EHRENBERG",
    "dropdeladd": "49440 EHRENBERG RD",
    "dropdelcty": "EHRENBERG",
    "dropdelst": "AZ",
    "dropdelzpp": 853349600,
    "dropphyadd": "49440 EHRENBERG RD",
    "dropphycty": "EHRENBERG",
    "dropphyst": "AZ",
    "dropphyzpp": 853349600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EHRENBERG",
    "dropmalst": "AZ",
    "dropmalzpp": 853349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9289233151,
    "dropsitcph": 9289233151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10509",
    "droptype": "D",
    "dropname": "EL MIRAGE",
    "dropdeladd": "11925 W THUNDERBIRD RD",
    "dropdelcty": "EL MIRAGE",
    "dropdelst": "AZ",
    "dropdelzpp": 853353000,
    "dropphyadd": "11925 W THUNDERBIRD RD",
    "dropphycty": "EL MIRAGE",
    "dropphyst": "AZ",
    "dropphyzpp": 853353000,
    "dropmaladd": "11925 W THUNDERBIRD RD",
    "dropmalcty": "EL MIRAGE",
    "dropmalst": "AZ",
    "dropmalzpp": 853353000,
    "dropsitphn": 6022253214,
    "dropsitlph": 6238750682,
    "dropsitcph": 6238750670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10511",
    "droptype": "D",
    "dropname": "ELFRIDA",
    "dropdeladd": "10341 N HIGHWAY 191",
    "dropdelcty": "ELFRIDA",
    "dropdelst": "AZ",
    "dropdelzpp": 856109998,
    "dropphyadd": "10341 N HIGHWAY 191",
    "dropphycty": "ELFRIDA",
    "dropphyst": "AZ",
    "dropphyzpp": 856109998,
    "dropmaladd": "10341 N HIGHWAY 191",
    "dropmalcty": "ELFRIDA",
    "dropmalst": "AZ",
    "dropmalzpp": 856109998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206423688,
    "dropsitcph": 5206423688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10513",
    "droptype": "D",
    "dropname": "ELOY",
    "dropdeladd": "620 N MAIN ST",
    "dropdelcty": "ELOY",
    "dropdelst": "AZ",
    "dropdelzpp": 851319998,
    "dropphyadd": "620 N MAIN ST",
    "dropphycty": "ELOY",
    "dropphyst": "AZ",
    "dropphyzpp": 851319998,
    "dropmaladd": "620 N MAIN ST",
    "dropmalcty": "ELOY",
    "dropmalst": "AZ",
    "dropmalzpp": 851319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5204669417,
    "dropsitcph": 5204663451,
    "dropfax": 5204663852
  },
  {
    "dcode": "D",
    "dropkey": "PZ10520",
    "droptype": "D",
    "dropname": "FLAGSTAFF",
    "dropdeladd": "2400 N POSTAL BLVD",
    "dropdelcty": "FLAGSTAFF",
    "dropdelst": "AZ",
    "dropdelzpp": 860049998,
    "dropphyadd": "2400 N POSTAL BLVD",
    "dropphycty": "FLAGSTAFF",
    "dropphyst": "AZ",
    "dropphyzpp": 860049998,
    "dropmaladd": "2400 N POSTAL BLVD",
    "dropmalcty": "FLAGSTAFF",
    "dropmalst": "AZ",
    "dropmalzpp": 860049998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287140524,
    "dropsitcph": 9287149302,
    "dropfax": 9287149882
  },
  {
    "dcode": "D",
    "dropkey": "PZ10521",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "501 N MAIN ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "AZ",
    "dropdelzpp": 851329998,
    "dropphyadd": "501 N MAIN ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "AZ",
    "dropphyzpp": 851329998,
    "dropmaladd": "501 N MAIN ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "AZ",
    "dropmalzpp": 851329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5208683266,
    "dropsitcph": 5208685651,
    "dropfax": 5208684129
  },
  {
    "dcode": "D",
    "dropkey": "PZ10525",
    "droptype": "D",
    "dropname": "FORT APACHE",
    "dropdeladd": "105 OFFICERS ROW",
    "dropdelcty": "FORT APACHE",
    "dropdelst": "AZ",
    "dropdelzpp": 859265300,
    "dropphyadd": "105 OFFICERS ROW",
    "dropphycty": "FORT APACHE",
    "dropphyst": "AZ",
    "dropphyzpp": 859265300,
    "dropmaladd": "105 OFFICERS ROW",
    "dropmalcty": "FORT APACHE",
    "dropmalst": "AZ",
    "dropmalzpp": 859265300,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283384790,
    "dropsitcph": 9283384790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10526",
    "droptype": "D",
    "dropname": "FORT DEFIANCE",
    "dropdeladd": "400 STATE HIGHWAY 12",
    "dropdelcty": "FORT DEFIANCE",
    "dropdelst": "AZ",
    "dropdelzpp": 865041705,
    "dropphyadd": "400 STATE HIGHWAY 12",
    "dropphycty": "FORT DEFIANCE",
    "dropphyst": "AZ",
    "dropphyzpp": 865041705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT DEFIANCE",
    "dropmalst": "AZ",
    "dropmalzpp": 865049998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9287295730,
    "dropsitcph": 9287295730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10535",
    "droptype": "D",
    "dropname": "FORT THOMAS",
    "dropdeladd": "15550 W US HIGHWAY 70",
    "dropdelcty": "FORT THOMAS",
    "dropdelst": "AZ",
    "dropdelzpp": 855369996,
    "dropphyadd": "15550 W US HIGHWAY 70",
    "dropphycty": "FORT THOMAS",
    "dropphyst": "AZ",
    "dropphyzpp": 855369996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT THOMAS",
    "dropmalst": "AZ",
    "dropmalzpp": 855369998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284852011,
    "dropsitcph": 9284852011,
    "dropfax": 9284852011
  },
  {
    "dcode": "D",
    "dropkey": "PZ10538",
    "droptype": "D",
    "dropname": "FREDONIA",
    "dropdeladd": "85 N MAIN ST",
    "dropdelcty": "FREDONIA",
    "dropdelst": "AZ",
    "dropdelzpp": 860229998,
    "dropphyadd": "85 N MAIN ST",
    "dropphycty": "FREDONIA",
    "dropphyst": "AZ",
    "dropphyzpp": 860229998,
    "dropmaladd": "85 N MAIN ST",
    "dropmalcty": "FREDONIA",
    "dropmalst": "AZ",
    "dropmalzpp": 860229998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288516337,
    "dropsitcph": 9288516337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10546",
    "droptype": "D",
    "dropname": "GANADO",
    "dropdeladd": "191 STATE HIGHWAY 264",
    "dropdelcty": "GANADO",
    "dropdelst": "AZ",
    "dropdelzpp": 865059998,
    "dropphyadd": "191 STATE HIGHWAY 264",
    "dropphycty": "GANADO",
    "dropphyst": "AZ",
    "dropphyzpp": 865059998,
    "dropmaladd": "191 STATE HIGHWAY 264",
    "dropmalcty": "GANADO",
    "dropmalst": "AZ",
    "dropmalzpp": 865059998,
    "dropsitphn": 5053468261,
    "dropsitlph": 5207240256,
    "dropsitcph": 5207240256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10547",
    "droptype": "D",
    "dropname": "GILA BEND",
    "dropdeladd": "109 W PAPAGO ST",
    "dropdelcty": "GILA BEND",
    "dropdelst": "AZ",
    "dropdelzpp": 853375300,
    "dropphyadd": "109 W PAPAGO ST",
    "dropphycty": "GILA BEND",
    "dropphyst": "AZ",
    "dropphyzpp": 853375300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILA BEND",
    "dropmalst": "AZ",
    "dropmalzpp": 853379998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286831523,
    "dropsitcph": 9286831523,
    "dropfax": 9286832032
  },
  {
    "dcode": "D",
    "dropkey": "PZ10548",
    "droptype": "D",
    "dropname": "GILBERT",
    "dropdeladd": "137 E ELLIOT RD",
    "dropdelcty": "GILBERT",
    "dropdelst": "AZ",
    "dropdelzpp": 852349998,
    "dropphyadd": "137 E ELLIOT RD",
    "dropphycty": "GILBERT",
    "dropphyst": "AZ",
    "dropphyzpp": 852349998,
    "dropmaladd": "137 E ELLIOT RD",
    "dropmalcty": "GILBERT",
    "dropmalst": "AZ",
    "dropmalzpp": 852349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4806325805,
    "dropsitcph": 4805396815,
    "dropfax": 4804973590
  },
  {
    "dcode": "D",
    "dropkey": "PZ10551",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "5955 W PEORIA AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 853029998,
    "dropphyadd": "5955 W PEORIA AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 853029998,
    "dropmaladd": "5955 W PEORIA AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 853029998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6234863029,
    "dropsitcph": 6234862029,
    "dropfax": 6234865091
  },
  {
    "dcode": "D",
    "dropkey": "PZ10553",
    "droptype": "D",
    "dropname": "GLOBE",
    "dropdeladd": "101 S HILL ST",
    "dropdelcty": "GLOBE",
    "dropdelst": "AZ",
    "dropdelzpp": 855019998,
    "dropphyadd": "101 S HILL ST",
    "dropphycty": "GLOBE",
    "dropphyst": "AZ",
    "dropphyzpp": 855019998,
    "dropmaladd": "101 S HILL ST",
    "dropmalcty": "GLOBE",
    "dropmalst": "AZ",
    "dropmalzpp": 855019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284258447,
    "dropsitcph": 9284252381,
    "dropfax": 9284258438
  },
  {
    "dcode": "D",
    "dropkey": "PZ10560",
    "droptype": "D",
    "dropname": "GRAND CANYON",
    "dropdeladd": "100 MATHER BUSINESS CTR",
    "dropdelcty": "GRAND CANYON",
    "dropdelst": "AZ",
    "dropdelzpp": 860235000,
    "dropphyadd": "100 MATHER BUSINESS CTR",
    "dropphycty": "GRAND CANYON",
    "dropphyst": "AZ",
    "dropphyzpp": 860235000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND CANYON",
    "dropmalst": "AZ",
    "dropmalzpp": 860239998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286382512,
    "dropsitcph": 9286382512,
    "dropfax": 9286383160
  },
  {
    "dcode": "D",
    "dropkey": "PZ10570",
    "droptype": "D",
    "dropname": "GREEN VALLEY",
    "dropdeladd": "50 E CONTINENTAL RD",
    "dropdelcty": "GREEN VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 856149998,
    "dropphyadd": "50 E CONTINENTAL RD",
    "dropphycty": "GREEN VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 856149998,
    "dropmaladd": "50 E CONTINENTAL RD",
    "dropmalcty": "GREEN VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 856149998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206480095,
    "dropsitcph": 5206254221,
    "dropfax": 5206483978
  },
  {
    "dcode": "D",
    "dropkey": "PZ10573",
    "droptype": "D",
    "dropname": "GREER",
    "dropdeladd": "76 N MAIN ST",
    "dropdelcty": "GREER",
    "dropdelst": "AZ",
    "dropdelzpp": 859279802,
    "dropphyadd": "76 N MAIN ST",
    "dropphycty": "GREER",
    "dropphyst": "AZ",
    "dropphyzpp": 859279802,
    "dropmaladd": "76 N MAIN ST",
    "dropmalcty": "GREER",
    "dropmalst": "AZ",
    "dropmalzpp": 859279802,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287357322,
    "dropsitcph": 9287357322,
    "dropfax": 9287357763
  },
  {
    "dcode": "D",
    "dropkey": "PZ10586",
    "droptype": "D",
    "dropname": "HAYDEN",
    "dropdeladd": "154 E PARK LN",
    "dropdelcty": "HAYDEN",
    "dropdelst": "AZ",
    "dropdelzpp": 851350068,
    "dropphyadd": "154 E PARK LN",
    "dropphycty": "HAYDEN",
    "dropphyst": "AZ",
    "dropphyzpp": 851350068,
    "dropmaladd": "154 E PARK LN",
    "dropmalcty": "HAYDEN",
    "dropmalst": "AZ",
    "dropmalzpp": 851350068,
    "dropsitphn": 6022253214,
    "dropsitlph": 5203567042,
    "dropsitcph": 5203567042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10587",
    "droptype": "D",
    "dropname": "HEBER",
    "dropdeladd": "3410 BUCKSKIN CANYON RD",
    "dropdelcty": "HEBER",
    "dropdelst": "AZ",
    "dropdelzpp": 859289800,
    "dropphyadd": "3410 BUCKSKIN CANYON RD",
    "dropphycty": "HEBER",
    "dropphyst": "AZ",
    "dropphyzpp": 859289800,
    "dropmaladd": "3410 BUCKSKIN CANYON RD",
    "dropmalcty": "HEBER",
    "dropmalst": "AZ",
    "dropmalzpp": 859289800,
    "dropsitphn": 6022241041,
    "dropsitlph": 9282241058,
    "dropsitcph": 9282241058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10588",
    "droptype": "D",
    "dropname": "HEREFORD",
    "dropdeladd": "7268 S HIGHWAY 92",
    "dropdelcty": "HEREFORD",
    "dropdelst": "AZ",
    "dropdelzpp": 856159998,
    "dropphyadd": "7268 S HIGHWAY 92",
    "dropphycty": "HEREFORD",
    "dropphyst": "AZ",
    "dropphyzpp": 856159998,
    "dropmaladd": "7268 S HIGHWAY 92",
    "dropmalcty": "HEREFORD",
    "dropmalst": "AZ",
    "dropmalzpp": 856159998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203783185,
    "dropsitcph": 5203783185,
    "dropfax": 5208030194
  },
  {
    "dcode": "D",
    "dropkey": "PZ10589",
    "droptype": "D",
    "dropname": "HIGLEY",
    "dropdeladd": "3324 E RAY RD",
    "dropdelcty": "HIGLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 852364500,
    "dropphyadd": "3324 E RAY RD",
    "dropphycty": "HIGLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 852364500,
    "dropmaladd": "3324 E RAY RD",
    "dropmalcty": "HIGLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 852364500,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809889730,
    "dropsitcph": 4809889796,
    "dropfax": 4809881726
  },
  {
    "dcode": "D",
    "dropkey": "PZ10593",
    "droptype": "D",
    "dropname": "HOLBROOK",
    "dropdeladd": "100 W ERIE ST",
    "dropdelcty": "HOLBROOK",
    "dropdelst": "AZ",
    "dropdelzpp": 860259998,
    "dropphyadd": "100 W ERIE ST",
    "dropphycty": "HOLBROOK",
    "dropphyst": "AZ",
    "dropphyzpp": 860259998,
    "dropmaladd": "100 W ERIE ST",
    "dropmalcty": "HOLBROOK",
    "dropmalst": "AZ",
    "dropmalzpp": 860259998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285243311,
    "dropsitcph": 9285243311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10597",
    "droptype": "D",
    "dropname": "HOTEVILLA",
    "dropdeladd": "3 MAIN ST",
    "dropdelcty": "HOTEVILLA",
    "dropdelst": "AZ",
    "dropdelzpp": 860309997,
    "dropphyadd": "3 MAIN ST",
    "dropphycty": "HOTEVILLA",
    "dropphyst": "AZ",
    "dropphyzpp": 860309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOTEVILLA",
    "dropmalst": "AZ",
    "dropmalzpp": 860309998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287342428,
    "dropsitcph": 9287342428,
    "dropfax": 9287342458
  },
  {
    "dcode": "D",
    "dropkey": "PZ10599",
    "droptype": "D",
    "dropname": "HUACHUCA CITY",
    "dropdeladd": "690 N GONZALES BLVD",
    "dropdelcty": "HUACHUCA CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 856169998,
    "dropphyadd": "690 N GONZALES BLVD",
    "dropphycty": "HUACHUCA CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 856169998,
    "dropmaladd": "690 N GONZALES BLVD",
    "dropmalcty": "HUACHUCA CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 856169998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204569143,
    "dropsitcph": 5204569143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10603",
    "droptype": "D",
    "dropname": "HUMBOLDT",
    "dropdeladd": "12814 E MAIN ST",
    "dropdelcty": "HUMBOLDT",
    "dropdelst": "AZ",
    "dropdelzpp": 863299997,
    "dropphyadd": "12814 E MAIN ST",
    "dropphycty": "HUMBOLDT",
    "dropphyst": "AZ",
    "dropphyzpp": 863299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMBOLDT",
    "dropmalst": "AZ",
    "dropmalzpp": 863299998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286327411,
    "dropsitcph": 9286327411,
    "dropfax": 9286325231
  },
  {
    "dcode": "D",
    "dropkey": "PZ10613",
    "droptype": "D",
    "dropname": "JEROME",
    "dropdeladd": "120 MAIN ST",
    "dropdelcty": "JEROME",
    "dropdelst": "AZ",
    "dropdelzpp": 863319997,
    "dropphyadd": "120 MAIN ST",
    "dropphycty": "JEROME",
    "dropphyst": "AZ",
    "dropphyzpp": 863319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEROME",
    "dropmalst": "AZ",
    "dropmalzpp": 863319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286348241,
    "dropsitcph": 9286348241,
    "dropfax": 9286340935
  },
  {
    "dcode": "D",
    "dropkey": "PZ10615",
    "droptype": "D",
    "dropname": "JOSEPH CITY",
    "dropdeladd": "4592 W MAIN ST",
    "dropdelcty": "JOSEPH CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 860329997,
    "dropphyadd": "4592 W MAIN ST",
    "dropphycty": "JOSEPH CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 860329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOSEPH CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 860329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282883662,
    "dropsitcph": 9282883662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10622",
    "droptype": "D",
    "dropname": "KAYENTA",
    "dropdeladd": "391 HIGHWAY 163",
    "dropdelcty": "KAYENTA",
    "dropdelst": "AZ",
    "dropdelzpp": 860339997,
    "dropphyadd": "391 HIGHWAY 163",
    "dropphycty": "KAYENTA",
    "dropphyst": "AZ",
    "dropphyzpp": 860339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAYENTA",
    "dropmalst": "AZ",
    "dropmalzpp": 860339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286973922,
    "dropsitcph": 9286973922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10623",
    "droptype": "D",
    "dropname": "KEAMS CANYON",
    "dropdeladd": "403 STATE ROUTE 264",
    "dropdelcty": "KEAMS CANYON",
    "dropdelst": "AZ",
    "dropdelzpp": 860349997,
    "dropphyadd": "403 STATE ROUTE 264",
    "dropphycty": "KEAMS CANYON",
    "dropphyst": "AZ",
    "dropphyzpp": 860349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEAMS CANYON",
    "dropmalst": "AZ",
    "dropmalzpp": 860349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287382292,
    "dropsitcph": 9287382292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10624",
    "droptype": "D",
    "dropname": "KEARNY",
    "dropdeladd": "388 ALDEN RD",
    "dropdelcty": "KEARNY",
    "dropdelst": "AZ",
    "dropdelzpp": 851379998,
    "dropphyadd": "388 ALDEN RD",
    "dropphycty": "KEARNY",
    "dropphyst": "AZ",
    "dropphyzpp": 851379998,
    "dropmaladd": "388 ALDEN RD",
    "dropmalcty": "KEARNY",
    "dropmalst": "AZ",
    "dropmalzpp": 851379998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5203635621,
    "dropsitcph": 5203635621,
    "dropfax": 5203635207
  },
  {
    "dcode": "D",
    "dropkey": "PZ10627",
    "droptype": "D",
    "dropname": "KINGMAN",
    "dropdeladd": "1901 JOHNSON AVE",
    "dropdelcty": "KINGMAN",
    "dropdelst": "AZ",
    "dropdelzpp": 864019998,
    "dropphyadd": "1901 JOHNSON AVE",
    "dropphycty": "KINGMAN",
    "dropphyst": "AZ",
    "dropphyzpp": 864019998,
    "dropmaladd": "1901 JOHNSON AVE",
    "dropmalcty": "KINGMAN",
    "dropmalst": "AZ",
    "dropmalzpp": 864019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287538944,
    "dropsitcph": 9287532480,
    "dropfax": 9287533031
  },
  {
    "dcode": "D",
    "dropkey": "PZ10631",
    "droptype": "D",
    "dropname": "KIRKLAND",
    "dropdeladd": "8985 S IRON SPRINGS RD",
    "dropdelcty": "KIRKLAND",
    "dropdelst": "AZ",
    "dropdelzpp": 863325301,
    "dropphyadd": "8985 S IRON SPRINGS RD",
    "dropphycty": "KIRKLAND",
    "dropphyst": "AZ",
    "dropphyzpp": 863325301,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIRKLAND",
    "dropmalst": "AZ",
    "dropmalzpp": 863329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284423339,
    "dropsitcph": 9284423339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10636",
    "droptype": "D",
    "dropname": "KYKOTSMOVI VILLAGE",
    "dropdeladd": "113 MAIN ST",
    "dropdelcty": "KYKOTSMOVI VILLAGE",
    "dropdelst": "AZ",
    "dropdelzpp": 860399997,
    "dropphyadd": "113 MAIN ST",
    "dropphycty": "KYKOTSMOVI VILLAGE",
    "dropphyst": "AZ",
    "dropphyzpp": 860399997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KYKOTSMOVI VILLAGE",
    "dropmalst": "AZ",
    "dropmalzpp": 860399998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287342409,
    "dropsitcph": 9287342409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10637",
    "droptype": "D",
    "dropname": "LAKE HAVASU CITY",
    "dropdeladd": "1750 MCCULLOCH BLVD N",
    "dropdelcty": "LAKE HAVASU CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 864039998,
    "dropphyadd": "1750 MCCULLOCH BLVD N",
    "dropphycty": "LAKE HAVASU CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 864039998,
    "dropmaladd": "1750 MCCULLOCH BLVD N",
    "dropmalcty": "LAKE HAVASU CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 864039998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288559504,
    "dropsitcph": 9288552361,
    "dropfax": 9286806095
  },
  {
    "dcode": "D",
    "dropkey": "PZ10641",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "1815 W JACKSON LN",
    "dropdelcty": "LAKESIDE",
    "dropdelst": "AZ",
    "dropdelzpp": 859297300,
    "dropphyadd": "1815 W JACKSON LN",
    "dropphycty": "LAKESIDE",
    "dropphyst": "AZ",
    "dropphyzpp": 859297300,
    "dropmaladd": "1815 W JACKSON LN",
    "dropmalcty": "LAKESIDE",
    "dropmalst": "AZ",
    "dropmalzpp": 859297300,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283686686,
    "dropsitcph": 9283686686,
    "dropfax": 9283686318
  },
  {
    "dcode": "D",
    "dropkey": "PZ10642",
    "droptype": "D",
    "dropname": "LAVEEN",
    "dropdeladd": "9307 S 51ST AVE",
    "dropdelcty": "LAVEEN",
    "dropdelst": "AZ",
    "dropdelzpp": 853399997,
    "dropphyadd": "9307 S 51ST AVE",
    "dropphycty": "LAVEEN",
    "dropphyst": "AZ",
    "dropphyzpp": 853399997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAVEEN",
    "dropmalst": "AZ",
    "dropmalzpp": 853399998,
    "dropsitphn": 6022379051,
    "dropsitlph": 6022379168,
    "dropsitcph": 6022379051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10645",
    "droptype": "D",
    "dropname": "LITCHFIELD PARK",
    "dropdeladd": "591 E PLAZA CIR",
    "dropdelcty": "LITCHFIELD PARK",
    "dropdelst": "AZ",
    "dropdelzpp": 853409998,
    "dropphyadd": "591 E PLAZA CIR",
    "dropphycty": "LITCHFIELD PARK",
    "dropphyst": "AZ",
    "dropphyzpp": 853409998,
    "dropmaladd": "591 E PLAZA CIR",
    "dropmalcty": "LITCHFIELD PARK",
    "dropmalst": "AZ",
    "dropmalzpp": 853409998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239352685,
    "dropsitcph": 6239352089,
    "dropfax": 6235354336
  },
  {
    "dcode": "D",
    "dropkey": "PZ10647",
    "droptype": "D",
    "dropname": "LITTLEFIELD",
    "dropdeladd": "3288 E MCKNIGHT RD",
    "dropdelcty": "LITTLEFIELD",
    "dropdelst": "AZ",
    "dropdelzpp": 864329997,
    "dropphyadd": "3288 E MCKNIGHT RD",
    "dropphycty": "LITTLEFIELD",
    "dropphyst": "AZ",
    "dropphyzpp": 864329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLEFIELD",
    "dropmalst": "AZ",
    "dropmalzpp": 864329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283475201,
    "dropsitcph": 9283475201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10655",
    "droptype": "D",
    "dropname": "LUKEVILLE",
    "dropdeladd": "175 HWY 85",
    "dropdelcty": "LUKEVILLE",
    "dropdelst": "AZ",
    "dropdelzpp": 853415300,
    "dropphyadd": "175 HWY 85",
    "dropphycty": "LUKEVILLE",
    "dropphyst": "AZ",
    "dropphyzpp": 853415300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUKEVILLE",
    "dropmalst": "AZ",
    "dropmalzpp": 853419998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282245299,
    "dropsitcph": 9282245299,
    "dropfax": 5203876364
  },
  {
    "dcode": "D",
    "dropkey": "PZ10657",
    "droptype": "D",
    "dropname": "MAMMOTH",
    "dropdeladd": "230 S MAIN ST",
    "dropdelcty": "MAMMOTH",
    "dropdelst": "AZ",
    "dropdelzpp": 856189997,
    "dropphyadd": "230 S MAIN ST",
    "dropphycty": "MAMMOTH",
    "dropphyst": "AZ",
    "dropphyzpp": 856189997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAMMOTH",
    "dropmalst": "AZ",
    "dropmalzpp": 856189998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204872861,
    "dropsitcph": 5204872861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10660",
    "droptype": "D",
    "dropname": "MARANA",
    "dropdeladd": "13355 N LON ADAMS RD",
    "dropdelcty": "MARANA",
    "dropdelst": "AZ",
    "dropdelzpp": 856539998,
    "dropphyadd": "13355 N LON ADAMS RD",
    "dropphycty": "MARANA",
    "dropphyst": "AZ",
    "dropphyzpp": 856539998,
    "dropmaladd": "13355 N LON ADAMS RD",
    "dropmalcty": "MARANA",
    "dropmalst": "AZ",
    "dropmalzpp": 856539998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206822842,
    "dropsitcph": 5206823561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10662",
    "droptype": "D",
    "dropname": "MARICOPA",
    "dropdeladd": "44920 W HATHAWAY AVE",
    "dropdelcty": "MARICOPA",
    "dropdelst": "AZ",
    "dropdelzpp": 851399900,
    "dropphyadd": "44920 W HATHAWAY AVE",
    "dropphycty": "MARICOPA",
    "dropphyst": "AZ",
    "dropphyzpp": 851399900,
    "dropmaladd": "44920 W HATHAWAY AVE",
    "dropmalcty": "MARICOPA",
    "dropmalst": "AZ",
    "dropmalzpp": 851399998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5205682252,
    "dropsitcph": 5205682641,
    "dropfax": 5205682557
  },
  {
    "dcode": "D",
    "dropkey": "PZ10666",
    "droptype": "D",
    "dropname": "MAYER",
    "dropdeladd": "12795 E CENTRAL AVE",
    "dropdelcty": "MAYER",
    "dropdelst": "AZ",
    "dropdelzpp": 863339998,
    "dropphyadd": "12795 E CENTRAL AVE",
    "dropphycty": "MAYER",
    "dropphyst": "AZ",
    "dropphyzpp": 863339998,
    "dropmaladd": "12795 E CENTRAL AVE",
    "dropmalcty": "MAYER",
    "dropmalst": "AZ",
    "dropmalzpp": 863339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286327333,
    "dropsitcph": 9286327333,
    "dropfax": 9286324218
  },
  {
    "dcode": "D",
    "dropkey": "PZ10667",
    "droptype": "D",
    "dropname": "MCNARY",
    "dropdeladd": "14 CADY ST",
    "dropdelcty": "MCNARY",
    "dropdelst": "AZ",
    "dropdelzpp": 859309997,
    "dropphyadd": "14 CADY ST",
    "dropphycty": "MCNARY",
    "dropphyst": "AZ",
    "dropphyzpp": 859309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCNARY",
    "dropmalst": "AZ",
    "dropmalzpp": 859309998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283342305,
    "dropsitcph": 9283342305,
    "dropfax": 9283342305
  },
  {
    "dcode": "D",
    "dropkey": "PZ10668",
    "droptype": "D",
    "dropname": "MC NEAL",
    "dropdeladd": "9103 N HIGHWAY 191",
    "dropdelcty": "MC NEAL",
    "dropdelst": "AZ",
    "dropdelzpp": 856179713,
    "dropphyadd": "9103 N HIGHWAY 191",
    "dropphycty": "MC NEAL",
    "dropphyst": "AZ",
    "dropphyzpp": 856179713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC NEAL",
    "dropmalst": "AZ",
    "dropmalzpp": 856179998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206423595,
    "dropsitcph": 5206423595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10675",
    "droptype": "D",
    "dropname": "MESA",
    "dropdeladd": "135 N CENTER ST",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852019998,
    "dropphyadd": "135 N CENTER ST",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852019998,
    "dropmaladd": "135 N CENTER ST",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852019998,
    "dropsitphn": 4802125313,
    "dropsitlph": 4802125313,
    "dropsitcph": 4802125317,
    "dropfax": 4802125320
  },
  {
    "dcode": "D",
    "dropkey": "PZ10677",
    "droptype": "D",
    "dropname": "MIAMI",
    "dropdeladd": "161 W LIVE OAK ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "AZ",
    "dropdelzpp": 855391552,
    "dropphyadd": "161 W LIVE OAK ST",
    "dropphycty": "MIAMI",
    "dropphyst": "AZ",
    "dropphyzpp": 855391552,
    "dropmaladd": "161 W LIVE OAK ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "AZ",
    "dropmalzpp": 855391552,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284732561,
    "dropsitcph": 9284732561,
    "dropfax": 9284733297
  },
  {
    "dcode": "D",
    "dropkey": "PZ10689",
    "droptype": "D",
    "dropname": "MORENCI",
    "dropdeladd": "9 MORENCI MALL",
    "dropdelcty": "MORENCI",
    "dropdelst": "AZ",
    "dropdelzpp": 855409998,
    "dropphyadd": "9 MORENCI MALL",
    "dropphycty": "MORENCI",
    "dropphyst": "AZ",
    "dropphyzpp": 855409998,
    "dropmaladd": "9 MORENCI MALL",
    "dropmalcty": "MORENCI",
    "dropmalst": "AZ",
    "dropmalzpp": 855409998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288653312,
    "dropsitcph": 9288653312,
    "dropfax": 9288653312
  },
  {
    "dcode": "D",
    "dropkey": "PZ10691",
    "droptype": "D",
    "dropname": "MORRISTOWN",
    "dropdeladd": "41009 GRAND AVE",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "AZ",
    "dropdelzpp": 853429615,
    "dropphyadd": "41009 GRAND AVE",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "AZ",
    "dropphyzpp": 853429615,
    "dropmaladd": "41009 GRAND AVE",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "AZ",
    "dropmalzpp": 853429615,
    "dropsitphn": 6022253214,
    "dropsitlph": 3253077622,
    "dropsitcph": 3253077622,
    "dropfax": 6233882411
  },
  {
    "dcode": "D",
    "dropkey": "PZ10692",
    "droptype": "D",
    "dropname": "MOUNT LEMMON",
    "dropdeladd": "12984 N SABINO CANYON PKWY",
    "dropdelcty": "MOUNT LEMMON",
    "dropdelst": "AZ",
    "dropdelzpp": 856199997,
    "dropphyadd": "12984 N SABINO CANYON PKWY",
    "dropphycty": "MOUNT LEMMON",
    "dropphyst": "AZ",
    "dropphyzpp": 856199997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT LEMMON",
    "dropmalst": "AZ",
    "dropmalzpp": 856199998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885019,
    "dropsitcph": 5205761427,
    "dropfax": 5205761427
  },
  {
    "dcode": "D",
    "dropkey": "PZ10698",
    "droptype": "D",
    "dropname": "NACO",
    "dropdeladd": "3833 S GIESLER AVE",
    "dropdelcty": "NACO",
    "dropdelst": "AZ",
    "dropdelzpp": 856209998,
    "dropphyadd": "3833 S GIESLER AVE",
    "dropphycty": "NACO",
    "dropphyst": "AZ",
    "dropphyzpp": 856209998,
    "dropmaladd": "3833 S GIESLER AVE",
    "dropmalcty": "NACO",
    "dropmalst": "AZ",
    "dropmalzpp": 856209998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204322471,
    "dropsitcph": 5204322471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10710",
    "droptype": "D",
    "dropname": "NOGALES",
    "dropdeladd": "300 N MORLEY AVE",
    "dropdelcty": "NOGALES",
    "dropdelst": "AZ",
    "dropdelzpp": 856219998,
    "dropphyadd": "300 N MORLEY AVE",
    "dropphycty": "NOGALES",
    "dropphyst": "AZ",
    "dropphyzpp": 856219998,
    "dropmaladd": "300 N MORLEY AVE",
    "dropmalcty": "NOGALES",
    "dropmalst": "AZ",
    "dropmalzpp": 856219998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5202879246,
    "dropsitcph": 5202879247,
    "dropfax": 5202879155
  },
  {
    "dcode": "D",
    "dropkey": "PZ10714",
    "droptype": "D",
    "dropname": "NUTRIOSO",
    "dropdeladd": "1 COUNTY RD 2013",
    "dropdelcty": "NUTRIOSO",
    "dropdelst": "AZ",
    "dropdelzpp": 859329900,
    "dropphyadd": "1 COUNTY RD 2013",
    "dropphycty": "NUTRIOSO",
    "dropphyst": "AZ",
    "dropphyzpp": 859329900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUTRIOSO",
    "dropmalst": "AZ",
    "dropmalzpp": 859329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283394599,
    "dropsitcph": 9283394599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10717",
    "droptype": "D",
    "dropname": "OATMAN",
    "dropdeladd": "251 MAIN ST",
    "dropdelcty": "OATMAN",
    "dropdelst": "AZ",
    "dropdelzpp": 864339997,
    "dropphyadd": "251 MAIN ST",
    "dropphycty": "OATMAN",
    "dropphyst": "AZ",
    "dropphyzpp": 864339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OATMAN",
    "dropmalst": "AZ",
    "dropmalzpp": 864339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287683990,
    "dropsitcph": 9287683990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10720",
    "droptype": "D",
    "dropname": "ORACLE",
    "dropdeladd": "905 E AMERICAN AVE",
    "dropdelcty": "ORACLE",
    "dropdelst": "AZ",
    "dropdelzpp": 856239997,
    "dropphyadd": "905 E AMERICAN AVE",
    "dropphycty": "ORACLE",
    "dropphyst": "AZ",
    "dropphyzpp": 856239997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORACLE",
    "dropmalst": "AZ",
    "dropmalzpp": 856239998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208962641,
    "dropsitcph": 5208962641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10724",
    "droptype": "D",
    "dropname": "OVERGAARD",
    "dropdeladd": "2821 STATE HIGHWAY 260",
    "dropdelcty": "OVERGAARD",
    "dropdelst": "AZ",
    "dropdelzpp": 859339997,
    "dropphyadd": "2821 STATE HIGHWAY 260",
    "dropphycty": "OVERGAARD",
    "dropphyst": "AZ",
    "dropphyzpp": 859339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OVERGAARD",
    "dropmalst": "AZ",
    "dropmalzpp": 859339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285359341,
    "dropsitcph": 9285354765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10726",
    "droptype": "D",
    "dropname": "PAGE",
    "dropdeladd": "44 6TH AVE",
    "dropdelcty": "PAGE",
    "dropdelst": "AZ",
    "dropdelzpp": 860407500,
    "dropphyadd": "44 6TH AVE",
    "dropphycty": "PAGE",
    "dropphyst": "AZ",
    "dropphyzpp": 860407500,
    "dropmaladd": "44 6TH AVE",
    "dropmalcty": "PAGE",
    "dropmalst": "AZ",
    "dropmalzpp": 860407500,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286459190,
    "dropsitcph": 9286452571,
    "dropfax": 9286452576
  },
  {
    "dcode": "D",
    "dropkey": "PZ10734",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "1500 S CALIFORNIA AVE",
    "dropdelcty": "PARKER",
    "dropdelst": "AZ",
    "dropdelzpp": 853449998,
    "dropphyadd": "1500 S CALIFORNIA AVE",
    "dropphycty": "PARKER",
    "dropphyst": "AZ",
    "dropphyzpp": 853449998,
    "dropmaladd": "1500 S CALIFORNIA AVE",
    "dropmalcty": "PARKER",
    "dropmalst": "AZ",
    "dropmalzpp": 853449998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286695561,
    "dropsitcph": 9286698179,
    "dropfax": 9286690049
  },
  {
    "dcode": "D",
    "dropkey": "PZ10736",
    "droptype": "D",
    "dropname": "PATAGONIA",
    "dropdeladd": "100 N TAYLOR LN",
    "dropdelcty": "PATAGONIA",
    "dropdelst": "AZ",
    "dropdelzpp": 856249600,
    "dropphyadd": "100 N TAYLOR LN",
    "dropphycty": "PATAGONIA",
    "dropphyst": "AZ",
    "dropphyzpp": 856249600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATAGONIA",
    "dropmalst": "AZ",
    "dropmalzpp": 856249998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206290551,
    "dropsitcph": 5203942950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10738",
    "droptype": "D",
    "dropname": "PAULDEN",
    "dropdeladd": "23375 N STATE ROUTE 89",
    "dropdelcty": "PAULDEN",
    "dropdelst": "AZ",
    "dropdelzpp": 863349998,
    "dropphyadd": "23375 N STATE ROUTE 89",
    "dropphycty": "PAULDEN",
    "dropphyst": "AZ",
    "dropphyzpp": 863349998,
    "dropmaladd": "23375 N STATE ROUTE 89",
    "dropmalcty": "PAULDEN",
    "dropmalst": "AZ",
    "dropmalzpp": 863349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286364260,
    "dropsitcph": 9286364260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10739",
    "droptype": "D",
    "dropname": "PAYSON",
    "dropdeladd": "100 W FRONTIER ST",
    "dropdelcty": "PAYSON",
    "dropdelst": "AZ",
    "dropdelzpp": 855419998,
    "dropphyadd": "100 W FRONTIER ST",
    "dropphycty": "PAYSON",
    "dropphyst": "AZ",
    "dropphyzpp": 855419998,
    "dropmaladd": "100 W FRONTIER ST",
    "dropmalcty": "PAYSON",
    "dropmalst": "AZ",
    "dropmalzpp": 855419998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284742999,
    "dropsitcph": 9284742972,
    "dropfax": 9284743096
  },
  {
    "dcode": "D",
    "dropkey": "PZ10740",
    "droptype": "D",
    "dropname": "PEACH SPRINGS",
    "dropdeladd": "877 HIGHWAY 66",
    "dropdelcty": "PEACH SPRINGS",
    "dropdelst": "AZ",
    "dropdelzpp": 864345300,
    "dropphyadd": "877 HIGHWAY 66",
    "dropphycty": "PEACH SPRINGS",
    "dropphyst": "AZ",
    "dropphyzpp": 864345300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEACH SPRINGS",
    "dropmalst": "AZ",
    "dropmalzpp": 864349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287692300,
    "dropsitcph": 9287692300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10741",
    "droptype": "D",
    "dropname": "PEARCE",
    "dropdeladd": "107 N FRONTAGE RD",
    "dropdelcty": "PEARCE",
    "dropdelst": "AZ",
    "dropdelzpp": 856259900,
    "dropphyadd": "107 N FRONTAGE RD",
    "dropphycty": "PEARCE",
    "dropphyst": "AZ",
    "dropphyzpp": 856259900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEARCE",
    "dropmalst": "AZ",
    "dropmalzpp": 856259998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205255027,
    "dropsitcph": 5205255027,
    "dropfax": 5255252987
  },
  {
    "dcode": "D",
    "dropkey": "PZ10742",
    "droptype": "D",
    "dropname": "PEORIA",
    "dropdeladd": "8380 W EMILE ZOLA AVE",
    "dropdelcty": "PEORIA",
    "dropdelst": "AZ",
    "dropdelzpp": 853819998,
    "dropphyadd": "8380 W EMILE ZOLA AVE",
    "dropphycty": "PEORIA",
    "dropphyst": "AZ",
    "dropphyzpp": 853819998,
    "dropmaladd": "8380 W EMILE ZOLA AVE",
    "dropmalcty": "PEORIA",
    "dropmalst": "AZ",
    "dropmalzpp": 853819998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239797153,
    "dropsitcph": 6239798533,
    "dropfax": 6239794508
  },
  {
    "dcode": "D",
    "dropkey": "PZ10743",
    "droptype": "D",
    "dropname": "PERIDOT",
    "dropdeladd": "261 STATE HIGHWAY 170",
    "dropdelcty": "PERIDOT",
    "dropdelst": "AZ",
    "dropdelzpp": 855429900,
    "dropphyadd": "261 STATE HIGHWAY 170",
    "dropphycty": "PERIDOT",
    "dropphyst": "AZ",
    "dropphyzpp": 855429900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PERIDOT",
    "dropmalst": "AZ",
    "dropmalzpp": 855429998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284752674,
    "dropsitcph": 9284752674,
    "dropfax": 9284752741
  },
  {
    "dcode": "D",
    "dropkey": "PZ10747",
    "droptype": "D",
    "dropname": "PHOENIX",
    "dropdeladd": "4949 E VAN BUREN ST REAR STALL1",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850268800,
    "dropphyadd": "4949 E VAN BUREN ST RM 187",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850269998,
    "dropmaladd": "4949 E VAN BUREN ST RM 187",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850269998,
    "dropsitphn": 6022253030,
    "dropsitlph": 6022253217,
    "dropsitcph": 6022253158,
    "dropfax": 6022253000
  },
  {
    "dcode": "D",
    "dropkey": "PZ10750",
    "droptype": "D",
    "dropname": "PIMA",
    "dropdeladd": "41 E CENTER ST",
    "dropdelcty": "PIMA",
    "dropdelst": "AZ",
    "dropdelzpp": 855439998,
    "dropphyadd": "41 E CENTER ST",
    "dropphycty": "PIMA",
    "dropphyst": "AZ",
    "dropphyzpp": 855439998,
    "dropmaladd": "41 E CENTER ST",
    "dropmalcty": "PIMA",
    "dropmalst": "AZ",
    "dropmalzpp": 855439998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284852835,
    "dropsitcph": 9284852651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10752",
    "droptype": "D",
    "dropname": "PINE",
    "dropdeladd": "3847 N AZ HIGHWAY 87",
    "dropdelcty": "PINE",
    "dropdelst": "AZ",
    "dropdelzpp": 855449997,
    "dropphyadd": "3847 N AZ HIGHWAY 87",
    "dropphycty": "PINE",
    "dropphyst": "AZ",
    "dropphyzpp": 855449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINE",
    "dropmalst": "AZ",
    "dropmalzpp": 855449998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284763004,
    "dropsitcph": 9284763275,
    "dropfax": 9284763004
  },
  {
    "dcode": "D",
    "dropkey": "PZ10755",
    "droptype": "D",
    "dropname": "PINEDALE",
    "dropdeladd": "1222 PINEDALE RD",
    "dropdelcty": "PINEDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 859349997,
    "dropphyadd": "1222 PINEDALE RD",
    "dropphycty": "PINEDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 859349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINEDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 859349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287394435,
    "dropsitcph": 9287394435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10756",
    "droptype": "D",
    "dropname": "PINETOP",
    "dropdeladd": "712 E WHITE MOUNTAIN BLVD",
    "dropdelcty": "PINETOP",
    "dropdelst": "AZ",
    "dropdelzpp": 859357067,
    "dropphyadd": "712 E WHITE MOUNTAIN BLVD",
    "dropphycty": "PINETOP",
    "dropphyst": "AZ",
    "dropphyzpp": 859357067,
    "dropmaladd": "712 E WHITE MOUNTAIN BLVD",
    "dropmalcty": "PINETOP",
    "dropmalst": "AZ",
    "dropmalzpp": 859357067,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283676283,
    "dropsitcph": 9283674756,
    "dropfax": 9283676131
  },
  {
    "dcode": "D",
    "dropkey": "PZ10757",
    "droptype": "D",
    "dropname": "PINON",
    "dropdeladd": "500 STATE ROAD 4",
    "dropdelcty": "PINON",
    "dropdelst": "AZ",
    "dropdelzpp": 865101700,
    "dropphyadd": "500 STATE ROAD 4",
    "dropphycty": "PINON",
    "dropphyst": "AZ",
    "dropphyzpp": 865101700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINON",
    "dropmalst": "AZ",
    "dropmalzpp": 865109998,
    "dropsitphn": 9287253252,
    "dropsitlph": 9287253252,
    "dropsitcph": 9287253252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10760",
    "droptype": "D",
    "dropname": "PIRTLEVILLE",
    "dropdeladd": "430 W GRACE AVE",
    "dropdelcty": "PIRTLEVILLE",
    "dropdelst": "AZ",
    "dropdelzpp": 856269900,
    "dropphyadd": "430 W GRACE AVE",
    "dropphycty": "PIRTLEVILLE",
    "dropphyst": "AZ",
    "dropphyzpp": 856269900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIRTLEVILLE",
    "dropmalst": "AZ",
    "dropmalzpp": 856269998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203642912,
    "dropsitcph": 5203642912,
    "dropfax": 5203646213
  },
  {
    "dcode": "D",
    "dropkey": "PZ10762",
    "droptype": "D",
    "dropname": "POLACCA",
    "dropdeladd": "392 STATE ROUTE 264",
    "dropdelcty": "POLACCA",
    "dropdelst": "AZ",
    "dropdelzpp": 860429997,
    "dropphyadd": "392 STATE ROUTE 264",
    "dropphycty": "POLACCA",
    "dropphyst": "AZ",
    "dropphyzpp": 860429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLACCA",
    "dropmalst": "AZ",
    "dropmalzpp": 860429998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287372535,
    "dropsitcph": 9287372535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10763",
    "droptype": "D",
    "dropname": "POMERENE",
    "dropdeladd": "1408 N OLD POMERENE RD",
    "dropdelcty": "POMERENE",
    "dropdelst": "AZ",
    "dropdelzpp": 856279900,
    "dropphyadd": "1408 N OLD POMERENE RD",
    "dropphycty": "POMERENE",
    "dropphyst": "AZ",
    "dropphyzpp": 856279900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POMERENE",
    "dropmalst": "AZ",
    "dropmalzpp": 856279998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205864453,
    "dropsitcph": 5205864453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10767",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "442 MILLER VALLEY RD",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "AZ",
    "dropdelzpp": 863019998,
    "dropphyadd": "442 MILLER VALLEY RD",
    "dropphycty": "PRESCOTT",
    "dropphyst": "AZ",
    "dropphyzpp": 863019998,
    "dropmaladd": "442 MILLER VALLEY RD",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "AZ",
    "dropmalzpp": 863019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282279676,
    "dropsitcph": 9287781890,
    "dropfax": 9287781738
  },
  {
    "dcode": "D",
    "dropkey": "PZ10771",
    "droptype": "D",
    "dropname": "QUARTZSITE",
    "dropdeladd": "80 W MAIN",
    "dropdelcty": "QUARTZSITE",
    "dropdelst": "AZ",
    "dropdelzpp": 853465000,
    "dropphyadd": "80 W MAIN",
    "dropphycty": "QUARTZSITE",
    "dropphyst": "AZ",
    "dropphyzpp": 853465000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUARTZSITE",
    "dropmalst": "AZ",
    "dropmalzpp": 853469998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9289276323,
    "dropsitcph": 9289276323,
    "dropfax": 9289276024
  },
  {
    "dcode": "D",
    "dropkey": "PZ10772",
    "droptype": "D",
    "dropname": "QUEEN CREEK",
    "dropdeladd": "22424 S ELLSWORTH LOOP RD",
    "dropdelcty": "QUEEN CREEK",
    "dropdelst": "AZ",
    "dropdelzpp": 851429998,
    "dropphyadd": "22424 S ELLSWORTH LOOP RD",
    "dropphycty": "QUEEN CREEK",
    "dropphyst": "AZ",
    "dropphyzpp": 851429998,
    "dropmaladd": "22424 S ELLSWORTH LOOP RD",
    "dropmalcty": "QUEEN CREEK",
    "dropmalst": "AZ",
    "dropmalzpp": 851429998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6232406424,
    "dropsitcph": 4808882214,
    "dropfax": 4808881079
  },
  {
    "dcode": "D",
    "dropkey": "PZ10778",
    "droptype": "D",
    "dropname": "RED ROCK",
    "dropdeladd": "22187 E CAMINO CORREO",
    "dropdelcty": "RED ROCK",
    "dropdelst": "AZ",
    "dropdelzpp": 851459997,
    "dropphyadd": "22187 E CAMINO CORREO",
    "dropphycty": "RED ROCK",
    "dropphyst": "AZ",
    "dropphyzpp": 851459997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED ROCK",
    "dropmalst": "AZ",
    "dropmalzpp": 851459998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5206823486,
    "dropsitcph": 5206823486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10783",
    "droptype": "D",
    "dropname": "RILLITO",
    "dropdeladd": "11651 N CASA GRANDE HWY",
    "dropdelcty": "RILLITO",
    "dropdelst": "AZ",
    "dropdelzpp": 856549997,
    "dropphyadd": "11651 N CASA GRANDE HWY",
    "dropphycty": "RILLITO",
    "dropphyst": "AZ",
    "dropphyzpp": 856549997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RILLITO",
    "dropmalst": "AZ",
    "dropmalzpp": 856549998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206823706,
    "dropsitcph": 5206823706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10784",
    "droptype": "D",
    "dropname": "RIMROCK",
    "dropdeladd": "5235 N LOOKOUT POINT RD",
    "dropdelcty": "RIMROCK",
    "dropdelst": "AZ",
    "dropdelzpp": 863359997,
    "dropphyadd": "5235 N LOOKOUT POINT RD",
    "dropphycty": "RIMROCK",
    "dropphyst": "AZ",
    "dropphyzpp": 863359997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIMROCK",
    "dropmalst": "AZ",
    "dropmalzpp": 863359998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288516154,
    "dropsitcph": 9288516154,
    "dropfax": 9285679879
  },
  {
    "dcode": "D",
    "dropkey": "PZ10796",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "18762 N AZ HIGHWAY 188",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "AZ",
    "dropdelzpp": 855458049,
    "dropphyadd": "18762 N AZ HIGHWAY 188",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "AZ",
    "dropphyzpp": 855458049,
    "dropmaladd": "18762 N AZ HIGHWAY 188",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "AZ",
    "dropmalzpp": 855458049,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284672215,
    "dropsitcph": 9284672215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10801",
    "droptype": "D",
    "dropname": "SACATON",
    "dropdeladd": "190 W PIMA ST",
    "dropdelcty": "SACATON",
    "dropdelst": "AZ",
    "dropdelzpp": 851479997,
    "dropphyadd": "190 W PIMA ST",
    "dropphycty": "SACATON",
    "dropphyst": "AZ",
    "dropphyzpp": 851479997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SACATON",
    "dropmalst": "AZ",
    "dropmalzpp": 851479998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6025623681,
    "dropsitcph": 5205623681,
    "dropfax": 5205623681
  },
  {
    "dcode": "D",
    "dropkey": "PZ10803",
    "droptype": "D",
    "dropname": "SAFFORD",
    "dropdeladd": "504 S 5TH AVE",
    "dropdelcty": "SAFFORD",
    "dropdelst": "AZ",
    "dropdelzpp": 855469998,
    "dropphyadd": "504 S 5TH AVE",
    "dropphycty": "SAFFORD",
    "dropphyst": "AZ",
    "dropphyzpp": 855469998,
    "dropmaladd": "504 S 5TH AVE",
    "dropmalcty": "SAFFORD",
    "dropmalst": "AZ",
    "dropmalzpp": 855469998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284280220,
    "dropsitcph": 9284280220,
    "dropfax": 9283480187
  },
  {
    "dcode": "D",
    "dropkey": "PZ10804",
    "droptype": "D",
    "dropname": "SAHUARITA",
    "dropdeladd": "815 W VIA RANCHO SAHUARITA",
    "dropdelcty": "SAHUARITA",
    "dropdelst": "AZ",
    "dropdelzpp": 856299998,
    "dropphyadd": "815 W VIA RANCHO SAHUARITA",
    "dropphycty": "SAHUARITA",
    "dropphyst": "AZ",
    "dropphyzpp": 856299998,
    "dropmaladd": "815 W VIA RANCHO SAHUARITA",
    "dropmalcty": "SAHUARITA",
    "dropmalst": "AZ",
    "dropmalzpp": 856299998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206253311,
    "dropsitcph": 5206253311,
    "dropfax": 5206480848
  },
  {
    "dcode": "D",
    "dropkey": "PZ10805",
    "droptype": "D",
    "dropname": "SAINT DAVID",
    "dropdeladd": "21 S MILLER LN",
    "dropdelcty": "SAINT DAVID",
    "dropdelst": "AZ",
    "dropdelzpp": 856307204,
    "dropphyadd": "21 S MILLER LN",
    "dropphycty": "SAINT DAVID",
    "dropphyst": "AZ",
    "dropphyzpp": 856307204,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT DAVID",
    "dropmalst": "AZ",
    "dropmalzpp": 856309998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207204861,
    "dropsitcph": 5207204861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10806",
    "droptype": "D",
    "dropname": "SAINT JOHNS",
    "dropdeladd": "840 W CLEVELAND ST",
    "dropdelcty": "SAINT JOHNS",
    "dropdelst": "AZ",
    "dropdelzpp": 859369900,
    "dropphyadd": "840 W CLEVELAND ST",
    "dropphycty": "SAINT JOHNS",
    "dropphyst": "AZ",
    "dropphyzpp": 859369900,
    "dropmaladd": "840 W CLEVELAND ST",
    "dropmalcty": "SAINT JOHNS",
    "dropmalst": "AZ",
    "dropmalzpp": 859369900,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283374431,
    "dropsitcph": 9283374431,
    "dropfax": 9283372825
  },
  {
    "dcode": "D",
    "dropkey": "PZ10807",
    "droptype": "D",
    "dropname": "SAINT MICHAELS",
    "dropdeladd": "343 HIGHWAY 264",
    "dropdelcty": "SAINT MICHAELS",
    "dropdelst": "AZ",
    "dropdelzpp": 865119998,
    "dropphyadd": "343 HIGHWAY 264",
    "dropphycty": "SAINT MICHAELS",
    "dropphyst": "AZ",
    "dropphyzpp": 865119998,
    "dropmaladd": "343 HIGHWAY 264",
    "dropmalcty": "SAINT MICHAELS",
    "dropmalst": "AZ",
    "dropmalzpp": 865119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9288715207,
    "dropsitcph": 5207240489,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10810",
    "droptype": "D",
    "dropname": "SALOME",
    "dropdeladd": "66830 HIGHWAY 60",
    "dropdelcty": "SALOME",
    "dropdelst": "AZ",
    "dropdelzpp": 853489600,
    "dropphyadd": "66830 HIGHWAY 60",
    "dropphycty": "SALOME",
    "dropphyst": "AZ",
    "dropphyzpp": 853489600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALOME",
    "dropmalst": "AZ",
    "dropmalzpp": 853489998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288591005,
    "dropsitcph": 9288591005,
    "dropfax": 9288593030
  },
  {
    "dcode": "D",
    "dropkey": "PZ10811",
    "droptype": "D",
    "dropname": "SAN CARLOS",
    "dropdeladd": "9998 SAN CARLOS AVE",
    "dropdelcty": "SAN CARLOS",
    "dropdelst": "AZ",
    "dropdelzpp": 855509900,
    "dropphyadd": "9998 SAN CARLOS AVE",
    "dropphycty": "SAN CARLOS",
    "dropphyst": "AZ",
    "dropphyzpp": 855509900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN CARLOS",
    "dropmalst": "AZ",
    "dropmalzpp": 855509998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284753588,
    "dropsitcph": 9284752377,
    "dropfax": 9284753257
  },
  {
    "dcode": "D",
    "dropkey": "PZ10812",
    "droptype": "D",
    "dropname": "SAN LUIS",
    "dropdeladd": "874 S MAIN ST",
    "dropdelcty": "SAN LUIS",
    "dropdelst": "AZ",
    "dropdelzpp": 853497101,
    "dropphyadd": "874 S MAIN ST",
    "dropphycty": "SAN LUIS",
    "dropphyst": "AZ",
    "dropphyzpp": 853497101,
    "dropmaladd": "874 S MAIN ST",
    "dropmalcty": "SAN LUIS",
    "dropmalst": "AZ",
    "dropmalzpp": 853497101,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286273388,
    "dropsitcph": 9286277065,
    "dropfax": 9286273521
  },
  {
    "dcode": "D",
    "dropkey": "PZ10813",
    "droptype": "D",
    "dropname": "SAN MANUEL",
    "dropdeladd": "430 S AVENUE A",
    "dropdelcty": "SAN MANUEL",
    "dropdelst": "AZ",
    "dropdelzpp": 856319998,
    "dropphyadd": "430 S AVENUE A",
    "dropphycty": "SAN MANUEL",
    "dropphyst": "AZ",
    "dropphyzpp": 856319998,
    "dropmaladd": "430 S AVENUE A",
    "dropmalcty": "SAN MANUEL",
    "dropmalst": "AZ",
    "dropmalzpp": 856319998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203859341,
    "dropsitcph": 5203859341,
    "dropfax": 5203859308
  },
  {
    "dcode": "D",
    "dropkey": "PZ10814",
    "droptype": "D",
    "dropname": "SAN SIMON",
    "dropdeladd": "2908 N ARIZONA AVE",
    "dropdelcty": "SAN SIMON",
    "dropdelst": "AZ",
    "dropdelzpp": 856329900,
    "dropphyadd": "2908 N ARIZONA AVE",
    "dropphycty": "SAN SIMON",
    "dropphyst": "AZ",
    "dropphyzpp": 856329900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN SIMON",
    "dropmalst": "AZ",
    "dropmalzpp": 856329998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208452212,
    "dropsitcph": 5208452212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10816",
    "droptype": "D",
    "dropname": "SANDERS",
    "dropdeladd": "100 HIGHWAY 191 S",
    "dropdelcty": "SANDERS",
    "dropdelst": "AZ",
    "dropdelzpp": 865129990,
    "dropphyadd": "100 HIGHWAY 191 S",
    "dropphycty": "SANDERS",
    "dropphyst": "AZ",
    "dropphyzpp": 865129990,
    "dropmaladd": "100 HIGHWAY 191 S",
    "dropmalcty": "SANDERS",
    "dropmalst": "AZ",
    "dropmalzpp": 865129990,
    "dropsitphn": 5053468251,
    "dropsitlph": 9286831511,
    "dropsitcph": 9286831511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10818",
    "droptype": "D",
    "dropname": "SASABE",
    "dropdeladd": "41918 S SASABE HWY",
    "dropdelcty": "SASABE",
    "dropdelst": "AZ",
    "dropdelzpp": 856339901,
    "dropphyadd": "41918 S SASABE HWY",
    "dropphycty": "SASABE",
    "dropphyst": "AZ",
    "dropphyzpp": 856339901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SASABE",
    "dropmalst": "AZ",
    "dropmalzpp": 856339998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208234294,
    "dropsitcph": 5208234294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10821",
    "droptype": "D",
    "dropname": "SCOTTSDALE",
    "dropdeladd": "1776 N SCOTTSDALE RD",
    "dropdelcty": "SCOTTSDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 852572115,
    "dropphyadd": "1776 N SCOTTSDALE RD",
    "dropphycty": "SCOTTSDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 852572115,
    "dropmaladd": "1776 N SCOTTSDALE RD",
    "dropmalcty": "SCOTTSDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 852572115,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809498893,
    "dropsitcph": 4809491448,
    "dropfax": 4809477701
  },
  {
    "dcode": "D",
    "dropkey": "PZ10822",
    "droptype": "D",
    "dropname": "SECOND MESA",
    "dropdeladd": "383 HIGHWAY 264",
    "dropdelcty": "SECOND MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 860439997,
    "dropphyadd": "383 HIGHWAY 264",
    "dropphycty": "SECOND MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 860439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SECOND MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 860439998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287372560,
    "dropsitcph": 9287372560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10823",
    "droptype": "D",
    "dropname": "SEDONA",
    "dropdeladd": "190 W STATE ROUTE 89A",
    "dropdelcty": "SEDONA",
    "dropdelst": "AZ",
    "dropdelzpp": 863369998,
    "dropphyadd": "190 W STATE ROUTE 89A",
    "dropphycty": "SEDONA",
    "dropphyst": "AZ",
    "dropphyzpp": 863369998,
    "dropmaladd": "190 W STATE ROUTE 89A",
    "dropmalcty": "SEDONA",
    "dropmalst": "AZ",
    "dropmalzpp": 863369998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282393117,
    "dropsitcph": 9282823511,
    "dropfax": 9282827103
  },
  {
    "dcode": "D",
    "dropkey": "PZ10824",
    "droptype": "D",
    "dropname": "SELIGMAN",
    "dropdeladd": "22801 W OLD HIGHWAY 66",
    "dropdelcty": "SELIGMAN",
    "dropdelst": "AZ",
    "dropdelzpp": 863379996,
    "dropphyadd": "22801 W OLD HIGHWAY 66",
    "dropphycty": "SELIGMAN",
    "dropphyst": "AZ",
    "dropphyzpp": 863379996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELIGMAN",
    "dropmalst": "AZ",
    "dropmalzpp": 863379998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284220056,
    "dropsitcph": 9284220056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10825",
    "droptype": "D",
    "dropname": "SELLS",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SELLS",
    "dropdelst": "AZ",
    "dropdelzpp": 856349900,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SELLS",
    "dropphyst": "AZ",
    "dropphyzpp": 856349900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SELLS",
    "dropmalst": "AZ",
    "dropmalzpp": 856349998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203832320,
    "dropsitcph": 5203832320,
    "dropfax": 5203833402
  },
  {
    "dcode": "D",
    "dropkey": "PZ10833",
    "droptype": "D",
    "dropname": "SHOW LOW",
    "dropdeladd": "191 W DEUCE OF CLUBS",
    "dropdelcty": "SHOW LOW",
    "dropdelst": "AZ",
    "dropdelzpp": 859019998,
    "dropphyadd": "191 W DEUCE OF CLUBS",
    "dropphycty": "SHOW LOW",
    "dropphyst": "AZ",
    "dropphyzpp": 859019998,
    "dropmaladd": "191 W DEUCE OF CLUBS",
    "dropmalcty": "SHOW LOW",
    "dropmalst": "AZ",
    "dropmalzpp": 859019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285371131,
    "dropsitcph": 9285374588,
    "dropfax": 9285378458
  },
  {
    "dcode": "D",
    "dropkey": "PZ10838",
    "droptype": "D",
    "dropname": "SIERRA VISTA",
    "dropdeladd": "2300 E FRY BLVD",
    "dropdelcty": "SIERRA VISTA",
    "dropdelst": "AZ",
    "dropdelzpp": 856359998,
    "dropphyadd": "2300 E FRY BLVD",
    "dropphycty": "SIERRA VISTA",
    "dropphyst": "AZ",
    "dropphyzpp": 856359998,
    "dropmaladd": "2300 E FRY BLVD",
    "dropmalcty": "SIERRA VISTA",
    "dropmalst": "AZ",
    "dropmalzpp": 856359998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204594614,
    "dropsitcph": 5204582540,
    "dropfax": 5204598391
  },
  {
    "dcode": "D",
    "dropkey": "PZ10841",
    "droptype": "D",
    "dropname": "SKULL VALLEY",
    "dropdeladd": "3085 S IRON SPRINGS RD",
    "dropdelcty": "SKULL VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 863389900,
    "dropphyadd": "3085 S IRON SPRINGS RD",
    "dropphycty": "SKULL VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 863389900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKULL VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 863389998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284423410,
    "dropsitcph": 9284423410,
    "dropfax": 9284423309
  },
  {
    "dcode": "D",
    "dropkey": "PZ10844",
    "droptype": "D",
    "dropname": "SNOWFLAKE",
    "dropdeladd": "761 S 1ST ST W",
    "dropdelcty": "SNOWFLAKE",
    "dropdelst": "AZ",
    "dropdelzpp": 859375579,
    "dropphyadd": "761 S 1ST ST W",
    "dropphycty": "SNOWFLAKE",
    "dropphyst": "AZ",
    "dropphyzpp": 859379998,
    "dropmaladd": "761 S 1ST ST W",
    "dropmalcty": "SNOWFLAKE",
    "dropmalst": "AZ",
    "dropmalzpp": 859375579,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285363611,
    "dropsitcph": 9285363610,
    "dropfax": 9285363810
  },
  {
    "dcode": "D",
    "dropkey": "PZ10845",
    "droptype": "D",
    "dropname": "SOLOMON",
    "dropdeladd": "2106 S BOWIE AVE",
    "dropdelcty": "SOLOMON",
    "dropdelst": "AZ",
    "dropdelzpp": 855519996,
    "dropphyadd": "2106 S BOWIE AVE",
    "dropphycty": "SOLOMON",
    "dropphyst": "AZ",
    "dropphyzpp": 855519996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOLOMON",
    "dropmalst": "AZ",
    "dropmalzpp": 855519998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284284030,
    "dropsitcph": 9284284030,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10846",
    "droptype": "D",
    "dropname": "SOMERTON",
    "dropdeladd": "450 E MAIN ST",
    "dropdelcty": "SOMERTON",
    "dropdelst": "AZ",
    "dropdelzpp": 853509998,
    "dropphyadd": "450 E MAIN ST",
    "dropphycty": "SOMERTON",
    "dropphyst": "AZ",
    "dropphyzpp": 853509998,
    "dropmaladd": "450 E MAIN ST",
    "dropmalcty": "SOMERTON",
    "dropmalst": "AZ",
    "dropmalzpp": 853509998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286278181,
    "dropsitcph": 9286278181,
    "dropfax": 9286273002
  },
  {
    "dcode": "D",
    "dropkey": "PZ10847",
    "droptype": "D",
    "dropname": "SONOITA",
    "dropdeladd": "3166 HIGHWAY 83 STE 1",
    "dropdelcty": "SONOITA",
    "dropdelst": "AZ",
    "dropdelzpp": 856379998,
    "dropphyadd": "3166 HIGHWAY 83 STE 1",
    "dropphycty": "SONOITA",
    "dropphyst": "AZ",
    "dropphyzpp": 856379998,
    "dropmaladd": "3166 HIGHWAY 83 STE 1",
    "dropmalcty": "SONOITA",
    "dropmalst": "AZ",
    "dropmalzpp": 856379998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204555500,
    "dropsitcph": 5204555500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10853",
    "droptype": "D",
    "dropname": "SPRINGERVILLE",
    "dropdeladd": "5 E MAIN ST",
    "dropdelcty": "SPRINGERVILLE",
    "dropdelst": "AZ",
    "dropdelzpp": 859387200,
    "dropphyadd": "5 E MAIN ST",
    "dropphycty": "SPRINGERVILLE",
    "dropphyst": "AZ",
    "dropphyzpp": 859387200,
    "dropmaladd": "5 E MAIN ST",
    "dropmalcty": "SPRINGERVILLE",
    "dropmalst": "AZ",
    "dropmalzpp": 859387200,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283334962,
    "dropsitcph": 9283334962,
    "dropfax": 9283334972
  },
  {
    "dcode": "D",
    "dropkey": "PZ10895",
    "droptype": "D",
    "dropname": "STANFIELD",
    "dropdeladd": "36840 W HIGHWAY 84",
    "dropdelcty": "STANFIELD",
    "dropdelst": "AZ",
    "dropdelzpp": 851729998,
    "dropphyadd": "36840 W HIGHWAY 84",
    "dropphycty": "STANFIELD",
    "dropphyst": "AZ",
    "dropphyzpp": 851729998,
    "dropmaladd": "36840 W HIGHWAY 84",
    "dropmalcty": "STANFIELD",
    "dropmalst": "AZ",
    "dropmalzpp": 851729998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5204243781,
    "dropsitcph": 5204243781,
    "dropfax": 5204243267
  },
  {
    "dcode": "D",
    "dropkey": "PZ10902",
    "droptype": "D",
    "dropname": "SUN CITY",
    "dropdeladd": "9802 W BELL RD",
    "dropdelcty": "SUN CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 853519998,
    "dropphyadd": "9802 W BELL RD",
    "dropphycty": "SUN CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 853519998,
    "dropmaladd": "9802 W BELL RD",
    "dropmalcty": "SUN CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 853519998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239339887,
    "dropsitcph": 6239339887,
    "dropfax": 6239721815
  },
  {
    "dcode": "D",
    "dropkey": "PZ10912",
    "droptype": "D",
    "dropname": "SUPAI",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "SUPAI",
    "dropdelst": "AZ",
    "dropdelzpp": 864351100,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "SUPAI",
    "dropphyst": "AZ",
    "dropphyzpp": 864351100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUPAI",
    "dropmalst": "AZ",
    "dropmalzpp": 864359998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284482711,
    "dropsitcph": 9284482711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10913",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "25 N HIGH SCHOOL AVE",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "AZ",
    "dropdelzpp": 851739998,
    "dropphyadd": "25 N HIGH SCHOOL AVE",
    "dropphycty": "SUPERIOR",
    "dropphyst": "AZ",
    "dropphyzpp": 851739998,
    "dropmaladd": "25 N HIGH SCHOOL AVE",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "AZ",
    "dropmalzpp": 851739998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5206895790,
    "dropsitcph": 5206895790,
    "dropfax": 5206892161
  },
  {
    "dcode": "D",
    "dropkey": "PZ10915",
    "droptype": "D",
    "dropname": "TACNA",
    "dropdeladd": "40140 E HIGHWAY 80",
    "dropdelcty": "TACNA",
    "dropdelst": "AZ",
    "dropdelzpp": 853525300,
    "dropphyadd": "40140 E HIGHWAY 80",
    "dropphycty": "TACNA",
    "dropphyst": "AZ",
    "dropphyzpp": 853525300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TACNA",
    "dropmalst": "AZ",
    "dropmalzpp": 853529998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287859819,
    "dropsitcph": 9287854711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10917",
    "droptype": "D",
    "dropname": "TAYLOR",
    "dropdeladd": "25 S MAIN ST",
    "dropdelcty": "TAYLOR",
    "dropdelst": "AZ",
    "dropdelzpp": 859399997,
    "dropphyadd": "25 S MAIN ST",
    "dropphycty": "TAYLOR",
    "dropphyst": "AZ",
    "dropphyzpp": 859399997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAYLOR",
    "dropmalst": "AZ",
    "dropmalzpp": 859399998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9285367532,
    "dropsitcph": 9285367532,
    "dropfax": 9285363482
  },
  {
    "dcode": "D",
    "dropkey": "PZ10918",
    "droptype": "D",
    "dropname": "TEEC NOS POS",
    "dropdeladd": "100 STATE HIGHWAY 64 N",
    "dropdelcty": "TEEC NOS POS",
    "dropdelst": "AZ",
    "dropdelzpp": 865149990,
    "dropphyadd": "100 STATE HIGHWAY 64 N",
    "dropphycty": "TEEC NOS POS",
    "dropphyst": "AZ",
    "dropphyzpp": 865149990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEEC NOS POS",
    "dropmalst": "AZ",
    "dropmalzpp": 865149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056563460,
    "dropsitcph": 9286563460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10920",
    "droptype": "D",
    "dropname": "TEMPE",
    "dropdeladd": "233 E SOUTHERN AVE",
    "dropdelcty": "TEMPE",
    "dropdelst": "AZ",
    "dropdelzpp": 852829998,
    "dropphyadd": "233 E SOUTHERN AVE",
    "dropphycty": "TEMPE",
    "dropphyst": "AZ",
    "dropphyzpp": 852829998,
    "dropmaladd": "233 E SOUTHERN AVE",
    "dropmalcty": "TEMPE",
    "dropmalst": "AZ",
    "dropmalzpp": 852829998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809666981,
    "dropsitcph": 4808942128,
    "dropfax": 4808940083
  },
  {
    "dcode": "D",
    "dropkey": "PZ10922",
    "droptype": "D",
    "dropname": "THATCHER",
    "dropdeladd": "1122 N STADIUM AVE",
    "dropdelcty": "THATCHER",
    "dropdelst": "AZ",
    "dropdelzpp": 855529998,
    "dropphyadd": "1122 N STADIUM AVE",
    "dropphycty": "THATCHER",
    "dropphyst": "AZ",
    "dropphyzpp": 855529998,
    "dropmaladd": "1122 N STADIUM AVE",
    "dropmalcty": "THATCHER",
    "dropmalst": "AZ",
    "dropmalzpp": 855529998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284285583,
    "dropsitcph": 9284280613,
    "dropfax": 9284289282
  },
  {
    "dcode": "D",
    "dropkey": "PZ10928",
    "droptype": "D",
    "dropname": "TOLLESON",
    "dropdeladd": "8805 W VAN BUREN ST",
    "dropdelcty": "TOLLESON",
    "dropdelst": "AZ",
    "dropdelzpp": 853539998,
    "dropphyadd": "8805 W VAN BUREN ST",
    "dropphycty": "TOLLESON",
    "dropphyst": "AZ",
    "dropphyzpp": 853539998,
    "dropmaladd": "8805 W VAN BUREN ST",
    "dropmalcty": "TOLLESON",
    "dropmalst": "AZ",
    "dropmalzpp": 853539998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239070760,
    "dropsitcph": 6239070206,
    "dropfax": 6239072772
  },
  {
    "dcode": "D",
    "dropkey": "PZ10929",
    "droptype": "D",
    "dropname": "TOMBSTONE",
    "dropdeladd": "100 HASKELL ST",
    "dropdelcty": "TOMBSTONE",
    "dropdelst": "AZ",
    "dropdelzpp": 856389900,
    "dropphyadd": "100 HASKELL ST",
    "dropphycty": "TOMBSTONE",
    "dropphyst": "AZ",
    "dropphyzpp": 856389900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOMBSTONE",
    "dropmalst": "AZ",
    "dropmalzpp": 856389998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5204573479,
    "dropsitcph": 5204573479,
    "dropfax": 5204572385
  },
  {
    "dcode": "D",
    "dropkey": "PZ10930",
    "droptype": "D",
    "dropname": "TONALEA",
    "dropdeladd": "343 HIGHWAY 160",
    "dropdelcty": "TONALEA",
    "dropdelst": "AZ",
    "dropdelzpp": 860449997,
    "dropphyadd": "343 HIGHWAY 160",
    "dropphycty": "TONALEA",
    "dropphyst": "AZ",
    "dropphyzpp": 860449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONALEA",
    "dropmalst": "AZ",
    "dropmalzpp": 860449998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282836839,
    "dropsitcph": 9282836839,
    "dropfax": 9282836870
  },
  {
    "dcode": "D",
    "dropkey": "PZ10931",
    "droptype": "D",
    "dropname": "TONOPAH",
    "dropdeladd": "3939 N 411TH AVE",
    "dropdelcty": "TONOPAH",
    "dropdelst": "AZ",
    "dropdelzpp": 853549900,
    "dropphyadd": "3939 N 411TH AVE",
    "dropphycty": "TONOPAH",
    "dropphyst": "AZ",
    "dropphyzpp": 853549900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONOPAH",
    "dropmalst": "AZ",
    "dropmalzpp": 853549998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6023863905,
    "dropsitcph": 6233863905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10932",
    "droptype": "D",
    "dropname": "TONTO BASIN",
    "dropdeladd": "77 S OLD HIGHWAY 188",
    "dropdelcty": "TONTO BASIN",
    "dropdelst": "AZ",
    "dropdelzpp": 855539996,
    "dropphyadd": "77 S OLD HIGHWAY 188",
    "dropphycty": "TONTO BASIN",
    "dropphyst": "AZ",
    "dropphyzpp": 855539996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONTO BASIN",
    "dropmalst": "AZ",
    "dropmalzpp": 855539998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284792210,
    "dropsitcph": 9284792210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10933",
    "droptype": "D",
    "dropname": "TOPAWA",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "TOPAWA",
    "dropdelst": "AZ",
    "dropdelzpp": 856399900,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "TOPAWA",
    "dropphyst": "AZ",
    "dropphyzpp": 856399900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPAWA",
    "dropmalst": "AZ",
    "dropmalzpp": 856399998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203832558,
    "dropsitcph": 5203832558,
    "dropfax": 5209948003
  },
  {
    "dcode": "D",
    "dropkey": "PZ10934",
    "droptype": "D",
    "dropname": "TOPOCK",
    "dropdeladd": "12936 S OATMAN HWY",
    "dropdelcty": "TOPOCK",
    "dropdelst": "AZ",
    "dropdelzpp": 864369997,
    "dropphyadd": "12936 S OATMAN HWY",
    "dropphycty": "TOPOCK",
    "dropphyst": "AZ",
    "dropphyzpp": 864369997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPOCK",
    "dropmalst": "AZ",
    "dropmalzpp": 864369998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287684699,
    "dropsitcph": 9287684699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10942",
    "droptype": "D",
    "dropname": "TUBA CITY",
    "dropdeladd": "1 WARRIOR DR",
    "dropdelcty": "TUBA CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 860455000,
    "dropphyadd": "1 WARRIOR DR",
    "dropphycty": "TUBA CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 860455000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUBA CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 860459998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282836837,
    "dropsitcph": 9282836837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10945",
    "droptype": "D",
    "dropname": "TUCSON",
    "dropdeladd": "1501 S CHERRYBELL STRA RM 205",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857269998,
    "dropphyadd": "1501 S CHERRYBELL STRA RM 205",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857269998,
    "dropmaladd": "1501 S CHERRYBELL STRA RM 205",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857269998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885179,
    "dropsitcph": 5203885043,
    "dropfax": 5203885180
  },
  {
    "dcode": "D",
    "dropkey": "PZ10946",
    "droptype": "D",
    "dropname": "TUMACACORI",
    "dropdeladd": "1910 E FRONTAGE RD",
    "dropdelcty": "TUMACACORI",
    "dropdelst": "AZ",
    "dropdelzpp": 856409998,
    "dropphyadd": "1910 E FRONTAGE RD",
    "dropphycty": "TUMACACORI",
    "dropphyst": "AZ",
    "dropphyzpp": 856409998,
    "dropmaladd": "1910 E FRONTAGE RD",
    "dropmalcty": "TUMACACORI",
    "dropmalst": "AZ",
    "dropmalzpp": 856409998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203982580,
    "dropsitcph": 5203982580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10955",
    "droptype": "D",
    "dropname": "VAIL",
    "dropdeladd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropdelcty": "VAIL",
    "dropdelst": "AZ",
    "dropdelzpp": 856419803,
    "dropphyadd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropphycty": "VAIL",
    "dropphyst": "AZ",
    "dropphyzpp": 856419803,
    "dropmaladd": "13190 E COLOSSAL CAVE RD STE 100",
    "dropmalcty": "VAIL",
    "dropmalst": "AZ",
    "dropmalzpp": 856419803,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207621048,
    "dropsitcph": 5207623239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10957",
    "droptype": "D",
    "dropname": "VALLEY FARMS",
    "dropdeladd": "10995 E VAH KI INN RD",
    "dropdelcty": "VALLEY FARMS",
    "dropdelst": "AZ",
    "dropdelzpp": 851919997,
    "dropphyadd": "10995 E VAH KI INN RD",
    "dropphycty": "VALLEY FARMS",
    "dropphyst": "AZ",
    "dropphyzpp": 851919997,
    "dropmaladd": "10995 E VAH KI INN RD",
    "dropmalcty": "VALLEY FARMS",
    "dropmalst": "AZ",
    "dropmalzpp": 851919996,
    "dropsitphn": 6022253214,
    "dropsitlph": 5207237275,
    "dropsitcph": 5207237275,
    "dropfax": 5207230735
  },
  {
    "dcode": "D",
    "dropkey": "PZ10959",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "1688 APACHE COUNTY ROAD 3140",
    "dropdelcty": "VERNON",
    "dropdelst": "AZ",
    "dropdelzpp": 859409997,
    "dropphyadd": "1688 APACHE COUNTY ROAD 3140",
    "dropphycty": "VERNON",
    "dropphyst": "AZ",
    "dropphyzpp": 859409997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERNON",
    "dropmalst": "AZ",
    "dropmalzpp": 859409998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5207190745,
    "dropsitcph": 5202013646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10962",
    "droptype": "D",
    "dropname": "WADDELL",
    "dropdeladd": "7000 N COTTON LN",
    "dropdelcty": "WADDELL",
    "dropdelst": "AZ",
    "dropdelzpp": 853559998,
    "dropphyadd": "7000 N COTTON LN",
    "dropphycty": "WADDELL",
    "dropphyst": "AZ",
    "dropphyzpp": 853559998,
    "dropmaladd": "7000 N COTTON LN",
    "dropmalcty": "WADDELL",
    "dropmalst": "AZ",
    "dropmalzpp": 853559998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239355135,
    "dropsitcph": 6239355135,
    "dropfax": 6239357503
  },
  {
    "dcode": "D",
    "dropkey": "PZ10968",
    "droptype": "D",
    "dropname": "WELLTON",
    "dropdeladd": "28610 OAKLAND AVE",
    "dropdelcty": "WELLTON",
    "dropdelst": "AZ",
    "dropdelzpp": 853569901,
    "dropphyadd": "28610 OAKLAND AVE",
    "dropphycty": "WELLTON",
    "dropphyst": "AZ",
    "dropphyzpp": 853569901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLTON",
    "dropmalst": "AZ",
    "dropmalzpp": 853569998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288514520,
    "dropsitcph": 9288514520,
    "dropfax": 9287859824
  },
  {
    "dcode": "D",
    "dropkey": "PZ10969",
    "droptype": "D",
    "dropname": "WENDEN",
    "dropdeladd": "70948 US HIGHWAY 60",
    "dropdelcty": "WENDEN",
    "dropdelst": "AZ",
    "dropdelzpp": 853579600,
    "dropphyadd": "70948 US HIGHWAY 60",
    "dropphycty": "WENDEN",
    "dropphyst": "AZ",
    "dropphyzpp": 853579600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WENDEN",
    "dropmalst": "AZ",
    "dropmalzpp": 853579998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9288593414,
    "dropsitcph": 9288593414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10977",
    "droptype": "D",
    "dropname": "WHITERIVER",
    "dropdeladd": "1025 S CHIEF AVE",
    "dropdelcty": "WHITERIVER",
    "dropdelst": "AZ",
    "dropdelzpp": 859419997,
    "dropphyadd": "1025 S CHIEF AVE",
    "dropphycty": "WHITERIVER",
    "dropphyst": "AZ",
    "dropphyzpp": 859419997,
    "dropmaladd": "1025 S CHIEF AVE",
    "dropmalcty": "WHITERIVER",
    "dropmalst": "AZ",
    "dropmalzpp": 859419997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283384576,
    "dropsitcph": 9283385173,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10979",
    "droptype": "D",
    "dropname": "WICKENBURG",
    "dropdeladd": "2029 W WICKENBURG WAY",
    "dropdelcty": "WICKENBURG",
    "dropdelst": "AZ",
    "dropdelzpp": 853909998,
    "dropphyadd": "2029 W WICKENBURG WAY",
    "dropphycty": "WICKENBURG",
    "dropphyst": "AZ",
    "dropphyzpp": 853909998,
    "dropmaladd": "2029 W WICKENBURG WAY",
    "dropmalcty": "WICKENBURG",
    "dropmalst": "AZ",
    "dropmalzpp": 853909998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9286849009,
    "dropsitcph": 9286842138,
    "dropfax": 9286849067
  },
  {
    "dcode": "D",
    "dropkey": "PZ10982",
    "droptype": "D",
    "dropname": "WIKIEUP",
    "dropdeladd": "18170 S US HIGHWAY 93",
    "dropdelcty": "WIKIEUP",
    "dropdelst": "AZ",
    "dropdelzpp": 853609600,
    "dropphyadd": "18170 S US HIGHWAY 93",
    "dropphycty": "WIKIEUP",
    "dropphyst": "AZ",
    "dropphyzpp": 853609600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WIKIEUP",
    "dropmalst": "AZ",
    "dropmalzpp": 853609998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287652262,
    "dropsitcph": 9287652262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10983",
    "droptype": "D",
    "dropname": "WILLCOX",
    "dropdeladd": "200 S CURTIS AVE",
    "dropdelcty": "WILLCOX",
    "dropdelst": "AZ",
    "dropdelzpp": 856439998,
    "dropphyadd": "200 S CURTIS AVE",
    "dropphycty": "WILLCOX",
    "dropphyst": "AZ",
    "dropphyzpp": 856439998,
    "dropmaladd": "200 S CURTIS AVE",
    "dropmalcty": "WILLCOX",
    "dropmalst": "AZ",
    "dropmalzpp": 856439998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203842689,
    "dropsitcph": 5203842689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10984",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "120 S 1ST ST",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "AZ",
    "dropdelzpp": 860469998,
    "dropphyadd": "120 S 1ST ST",
    "dropphycty": "WILLIAMS",
    "dropphyst": "AZ",
    "dropphyzpp": 860469998,
    "dropmaladd": "120 S 1ST ST",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "AZ",
    "dropmalzpp": 860469998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5207240596,
    "dropsitcph": 5207240596,
    "dropfax": 5207190437
  },
  {
    "dcode": "D",
    "dropkey": "PZ10987",
    "droptype": "D",
    "dropname": "WINDOW ROCK",
    "dropdeladd": "264 WINDOW ROCK LOOP RD",
    "dropdelcty": "WINDOW ROCK",
    "dropdelst": "AZ",
    "dropdelzpp": 865159998,
    "dropphyadd": "264 WINDOW ROCK LOOP RD",
    "dropphycty": "WINDOW ROCK",
    "dropphyst": "AZ",
    "dropphyzpp": 865159998,
    "dropmaladd": "264 WINDOW ROCK LOOP RD",
    "dropmalcty": "WINDOW ROCK",
    "dropmalst": "AZ",
    "dropmalzpp": 865159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 9288714610,
    "dropsitcph": 9288714610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10988",
    "droptype": "D",
    "dropname": "WINKELMAN",
    "dropdeladd": "301 GIFFIN AVE",
    "dropdelcty": "WINKELMAN",
    "dropdelst": "AZ",
    "dropdelzpp": 851929998,
    "dropphyadd": "301 GIFFIN AVE",
    "dropphycty": "WINKELMAN",
    "dropphyst": "AZ",
    "dropphyzpp": 851929998,
    "dropmaladd": "301 GIFFIN AVE",
    "dropmalcty": "WINKELMAN",
    "dropmalst": "AZ",
    "dropmalzpp": 851929998,
    "dropsitphn": 6022253214,
    "dropsitlph": 5203567374,
    "dropsitcph": 5203567374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10990",
    "droptype": "D",
    "dropname": "WINSLOW",
    "dropdeladd": "223 N WILLIAMSON AVE",
    "dropdelcty": "WINSLOW",
    "dropdelst": "AZ",
    "dropdelzpp": 860479998,
    "dropphyadd": "223 N WILLIAMSON AVE",
    "dropphycty": "WINSLOW",
    "dropphyst": "AZ",
    "dropphyzpp": 860479998,
    "dropmaladd": "223 N WILLIAMSON AVE",
    "dropmalcty": "WINSLOW",
    "dropmalst": "AZ",
    "dropmalzpp": 860479998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282895181,
    "dropsitcph": 9282892131,
    "dropfax": 9282894561
  },
  {
    "dcode": "D",
    "dropkey": "PZ10993",
    "droptype": "D",
    "dropname": "WITTMANN",
    "dropdeladd": "32808 N CROZIER RD",
    "dropdelcty": "WITTMANN",
    "dropdelst": "AZ",
    "dropdelzpp": 853619997,
    "dropphyadd": "32808 N CROZIER RD",
    "dropphycty": "WITTMANN",
    "dropphyst": "AZ",
    "dropphyzpp": 853619997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WITTMANN",
    "dropmalst": "AZ",
    "dropmalzpp": 853619998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6233882634,
    "dropsitcph": 6233882634,
    "dropfax": 6233889481
  },
  {
    "dcode": "D",
    "dropkey": "PZ10996",
    "droptype": "D",
    "dropname": "YARNELL",
    "dropdeladd": "22610 HIGHWAY 89",
    "dropdelcty": "YARNELL",
    "dropdelst": "AZ",
    "dropdelzpp": 853629997,
    "dropphyadd": "22610 HIGHWAY 89",
    "dropphycty": "YARNELL",
    "dropphyst": "AZ",
    "dropphyzpp": 853629997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YARNELL",
    "dropmalst": "AZ",
    "dropmalzpp": 853629998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284273725,
    "dropsitcph": 9284273725,
    "dropfax": 9284273725
  },
  {
    "dcode": "D",
    "dropkey": "PZ10998",
    "droptype": "D",
    "dropname": "YOUNG",
    "dropdeladd": "48951 N ARIZONA HIGHWAY 288",
    "dropdelcty": "YOUNG",
    "dropdelst": "AZ",
    "dropdelzpp": 855549996,
    "dropphyadd": "48951 N ARIZONA HIGHWAY 288",
    "dropphycty": "YOUNG",
    "dropphyst": "AZ",
    "dropphyzpp": 855549996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YOUNG",
    "dropmalst": "AZ",
    "dropmalzpp": 855549998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284623281,
    "dropsitcph": 9284623281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ10999",
    "droptype": "D",
    "dropname": "YOUNGTOWN",
    "dropdeladd": "11129 W ARIZONA AVE",
    "dropdelcty": "YOUNGTOWN",
    "dropdelst": "AZ",
    "dropdelzpp": 853639998,
    "dropphyadd": "11129 W ARIZONA AVE",
    "dropphycty": "YOUNGTOWN",
    "dropphyst": "AZ",
    "dropphyzpp": 853639998,
    "dropmaladd": "11129 W ARIZONA AVE",
    "dropmalcty": "YOUNGTOWN",
    "dropmalst": "AZ",
    "dropmalzpp": 853639998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6239331679,
    "dropsitcph": 6239331679,
    "dropfax": 6239728113
  },
  {
    "dcode": "D",
    "dropkey": "PZ11000",
    "droptype": "D",
    "dropname": "YUCCA",
    "dropdeladd": "12241 S FRONTAGE RD",
    "dropdelcty": "YUCCA",
    "dropdelst": "AZ",
    "dropdelzpp": 864389997,
    "dropphyadd": "12241 S FRONTAGE RD",
    "dropphycty": "YUCCA",
    "dropphyst": "AZ",
    "dropphyzpp": 864389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YUCCA",
    "dropmalst": "AZ",
    "dropmalzpp": 864389998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287662306,
    "dropsitcph": 9287662306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11001",
    "droptype": "D",
    "dropname": "YUMA",
    "dropdeladd": "2222 S 4TH AVE",
    "dropdelcty": "YUMA",
    "dropdelst": "AZ",
    "dropdelzpp": 853649998,
    "dropphyadd": "2222 S 4TH AVE",
    "dropphycty": "YUMA",
    "dropphyst": "AZ",
    "dropphyzpp": 853649998,
    "dropmaladd": "2222 S 4TH AVE",
    "dropmalcty": "YUMA",
    "dropmalst": "AZ",
    "dropmalzpp": 853649998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287834394,
    "dropsitcph": 9283439416,
    "dropfax": 9287824934
  },
  {
    "dcode": "D",
    "dropkey": "PZ11008",
    "droptype": "D",
    "dropname": "AGATE",
    "dropdeladd": "40992 US HIGHWAY 40",
    "dropdelcty": "AGATE",
    "dropdelst": "CO",
    "dropdelzpp": 801019755,
    "dropphyadd": "40992 US HIGHWAY 40",
    "dropphycty": "AGATE",
    "dropphyst": "CO",
    "dropphyzpp": 801019755,
    "dropmaladd": "40992 US HIGHWAY 40",
    "dropmalcty": "AGATE",
    "dropmalst": "CO",
    "dropmalzpp": 801019755,
    "dropsitphn": 3038536511,
    "dropsitlph": 7197642421,
    "dropsitcph": 7197642421,
    "dropfax": 7197642421
  },
  {
    "dcode": "D",
    "dropkey": "PZ11009",
    "droptype": "D",
    "dropname": "AGUILAR",
    "dropdeladd": "106 E MAIN ST",
    "dropdelcty": "AGUILAR",
    "dropdelst": "CO",
    "dropdelzpp": 810209900,
    "dropphyadd": "106 E MAIN ST",
    "dropphycty": "AGUILAR",
    "dropphyst": "CO",
    "dropphyzpp": 810209900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AGUILAR",
    "dropmalst": "CO",
    "dropmalzpp": 810209998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199414010,
    "dropsitcph": 7199414010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11012",
    "droptype": "D",
    "dropname": "AKRON",
    "dropdeladd": "182 ADAMS AVE",
    "dropdelcty": "AKRON",
    "dropdelst": "CO",
    "dropdelzpp": 807209998,
    "dropphyadd": "182 ADAMS AVE",
    "dropphycty": "AKRON",
    "dropphyst": "CO",
    "dropphyzpp": 807209998,
    "dropmaladd": "182 ADAMS AVE",
    "dropmalcty": "AKRON",
    "dropmalst": "CO",
    "dropmalzpp": 807209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703456691,
    "dropsitcph": 9703456691,
    "dropfax": 9703456690
  },
  {
    "dcode": "D",
    "dropkey": "PZ11014",
    "droptype": "D",
    "dropname": "ALAMOSA",
    "dropdeladd": "505 3RD ST",
    "dropdelcty": "ALAMOSA",
    "dropdelst": "CO",
    "dropdelzpp": 811019998,
    "dropphyadd": "505 3RD ST",
    "dropphycty": "ALAMOSA",
    "dropphyst": "CO",
    "dropphyzpp": 811019998,
    "dropmaladd": "505 3RD ST",
    "dropmalcty": "ALAMOSA",
    "dropmalst": "CO",
    "dropmalzpp": 811019998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195894909,
    "dropsitcph": 7195894909,
    "dropfax": 7195894715
  },
  {
    "dcode": "D",
    "dropkey": "PZ11016",
    "droptype": "D",
    "dropname": "ALLENSPARK",
    "dropdeladd": "7 WASHINGTON ST",
    "dropdelcty": "ALLENSPARK",
    "dropdelst": "CO",
    "dropdelzpp": 805109997,
    "dropphyadd": "7 WASHINGTON ST",
    "dropphycty": "ALLENSPARK",
    "dropphyst": "CO",
    "dropphyzpp": 805109997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLENSPARK",
    "dropmalst": "CO",
    "dropmalzpp": 805109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037472559,
    "dropsitcph": 3037472559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11018",
    "droptype": "D",
    "dropname": "ALMA",
    "dropdeladd": "30 E BUCKSKIN RD",
    "dropdelcty": "ALMA",
    "dropdelst": "CO",
    "dropdelzpp": 804209900,
    "dropphyadd": "30 E BUCKSKIN RD",
    "dropphycty": "ALMA",
    "dropphyst": "CO",
    "dropphyzpp": 804209900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMA",
    "dropmalst": "CO",
    "dropmalzpp": 804209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7198362265,
    "dropsitcph": 7198362265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11019",
    "droptype": "D",
    "dropname": "ALMONT",
    "dropdeladd": "500 COUNTY ROAD 742",
    "dropdelcty": "ALMONT",
    "dropdelst": "CO",
    "dropdelzpp": 812109990,
    "dropphyadd": "500 COUNTY ROAD 742",
    "dropphycty": "ALMONT",
    "dropphyst": "CO",
    "dropphyzpp": 812109990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALMONT",
    "dropmalst": "CO",
    "dropmalzpp": 812109998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706413653,
    "dropsitcph": 9706413653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11024",
    "droptype": "D",
    "dropname": "AMHERST",
    "dropdeladd": "520 MAIN AVE",
    "dropdelcty": "AMHERST",
    "dropdelst": "CO",
    "dropdelzpp": 807219998,
    "dropphyadd": "520 MAIN AVE",
    "dropphycty": "AMHERST",
    "dropphyst": "CO",
    "dropphyzpp": 807219998,
    "dropmaladd": "520 MAIN AVE",
    "dropmalcty": "AMHERST",
    "dropmalst": "CO",
    "dropmalzpp": 807219998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708544391,
    "dropsitcph": 9708544391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11028",
    "droptype": "D",
    "dropname": "ANTON",
    "dropdeladd": "25940 US HIGHWAY 36",
    "dropdelcty": "ANTON",
    "dropdelst": "CO",
    "dropdelzpp": 808019724,
    "dropphyadd": "25940 US HIGHWAY 36",
    "dropphycty": "ANTON",
    "dropphyst": "CO",
    "dropphyzpp": 808019724,
    "dropmaladd": "25940 US HIGHWAY 36",
    "dropmalcty": "ANTON",
    "dropmalst": "CO",
    "dropmalzpp": 808019724,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703832245,
    "dropsitcph": 9703832245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11029",
    "droptype": "D",
    "dropname": "ANTONITO",
    "dropdeladd": "428 MAIN ST",
    "dropdelcty": "ANTONITO",
    "dropdelst": "CO",
    "dropdelzpp": 811209997,
    "dropphyadd": "428 MAIN ST",
    "dropphycty": "ANTONITO",
    "dropphyst": "CO",
    "dropphyzpp": 811209997,
    "dropmaladd": "428 MAIN ST",
    "dropmalcty": "ANTONITO",
    "dropmalst": "CO",
    "dropmalzpp": 811209997,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193765914,
    "dropsitcph": 7193765914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11032",
    "droptype": "D",
    "dropname": "ARAPAHOE",
    "dropdeladd": "16665 MICHIGAN AVE",
    "dropdelcty": "ARAPAHOE",
    "dropdelst": "CO",
    "dropdelzpp": 808029701,
    "dropphyadd": "16665 MICHIGAN AVE",
    "dropphycty": "ARAPAHOE",
    "dropphyst": "CO",
    "dropphyzpp": 808029701,
    "dropmaladd": "16665 MICHIGAN AVE",
    "dropmalcty": "ARAPAHOE",
    "dropmalst": "CO",
    "dropmalzpp": 808029701,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197675554,
    "dropsitcph": 7197675554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11035",
    "droptype": "D",
    "dropname": "ARBOLES",
    "dropdeladd": "86 COUNTY ROAD 982",
    "dropdelcty": "ARBOLES",
    "dropdelst": "CO",
    "dropdelzpp": 811219801,
    "dropphyadd": "86 COUNTY ROAD 982",
    "dropphycty": "ARBOLES",
    "dropphyst": "CO",
    "dropphyzpp": 811219801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARBOLES",
    "dropmalst": "CO",
    "dropmalzpp": 811219998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9708832588,
    "dropsitcph": 9708832588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11042",
    "droptype": "D",
    "dropname": "ARRIBA",
    "dropdeladd": "520 COLORADO AVE",
    "dropdelcty": "ARRIBA",
    "dropdelst": "CO",
    "dropdelzpp": 808049752,
    "dropphyadd": "520 COLORADO AVE",
    "dropphycty": "ARRIBA",
    "dropphyst": "CO",
    "dropphyzpp": 808049752,
    "dropmaladd": "520 COLORADO AVE",
    "dropmalcty": "ARRIBA",
    "dropmalst": "CO",
    "dropmalzpp": 808049752,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197683393,
    "dropsitcph": 7197683393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11044",
    "droptype": "D",
    "dropname": "ARVADA",
    "dropdeladd": "5885 ALLISON ST",
    "dropdelcty": "ARVADA",
    "dropdelst": "CO",
    "dropdelzpp": 800049998,
    "dropphyadd": "5885 ALLISON ST",
    "dropphycty": "ARVADA",
    "dropphyst": "CO",
    "dropphyzpp": 800049998,
    "dropmaladd": "5885 ALLISON ST",
    "dropmalcty": "ARVADA",
    "dropmalst": "CO",
    "dropmalzpp": 800049998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7208985346,
    "dropsitcph": 3034322092,
    "dropfax": 3034208321
  },
  {
    "dcode": "D",
    "dropkey": "PZ11046",
    "droptype": "D",
    "dropname": "ASPEN",
    "dropdeladd": "235 PUPPY SMITH ST",
    "dropdelcty": "ASPEN",
    "dropdelst": "CO",
    "dropdelzpp": 816119998,
    "dropphyadd": "235 PUPPY SMITH ST",
    "dropphycty": "ASPEN",
    "dropphyst": "CO",
    "dropphyzpp": 816119998,
    "dropmaladd": "235 PUPPY SMITH ST",
    "dropmalcty": "ASPEN",
    "dropmalst": "CO",
    "dropmalzpp": 816119998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709257523,
    "dropsitcph": 9709257523,
    "dropfax": 9709255274
  },
  {
    "dcode": "D",
    "dropkey": "PZ11051",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "16255 FRONT AVE",
    "dropdelcty": "ATWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 807229998,
    "dropphyadd": "16255 FRONT AVE",
    "dropphycty": "ATWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 807229998,
    "dropmaladd": "16255 FRONT AVE",
    "dropmalcty": "ATWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 807229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705229788,
    "dropsitcph": 9705229788,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11052",
    "droptype": "D",
    "dropname": "AULT",
    "dropdeladd": "122 1ST AVE",
    "dropdelcty": "AULT",
    "dropdelst": "CO",
    "dropdelzpp": 806109990,
    "dropphyadd": "122 1ST AVE",
    "dropphycty": "AULT",
    "dropphyst": "CO",
    "dropphyzpp": 806109990,
    "dropmaladd": "122 1ST AVE",
    "dropmalcty": "AULT",
    "dropmalst": "CO",
    "dropmalzpp": 806109990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708342840,
    "dropsitcph": 9708342840,
    "dropfax": 9708342393
  },
  {
    "dcode": "D",
    "dropkey": "PZ11053",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "16890 E ALAMEDA PKWY",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800179998,
    "dropphyadd": "16890 E ALAMEDA PKWY",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800179998,
    "dropmaladd": "16890 E ALAMEDA PKWY",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800179998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032275443,
    "dropsitcph": 3032275443,
    "dropfax": 3032275446
  },
  {
    "dcode": "D",
    "dropkey": "PZ11055",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "22009 CANAL ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "CO",
    "dropdelzpp": 814109997,
    "dropphyadd": "22009 CANAL ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "CO",
    "dropphyzpp": 814109997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTIN",
    "dropmalst": "CO",
    "dropmalzpp": 814109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708353578,
    "dropsitcph": 9708353578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11056",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "111 W BEAVER CREEK BLVD",
    "dropdelcty": "AVON",
    "dropdelst": "CO",
    "dropdelzpp": 816209998,
    "dropphyadd": "111 W BEAVER CREEK BLVD",
    "dropphycty": "AVON",
    "dropphyst": "CO",
    "dropphyzpp": 816209998,
    "dropmaladd": "111 W BEAVER CREEK BLVD",
    "dropmalcty": "AVON",
    "dropmalst": "CO",
    "dropmalzpp": 816209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709494057,
    "dropsitcph": 9709494057,
    "dropfax": 9709499357
  },
  {
    "dcode": "D",
    "dropkey": "PZ11057",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "230 AVONDALE BLVD",
    "dropdelcty": "AVONDALE",
    "dropdelst": "CO",
    "dropdelzpp": 810228700,
    "dropphyadd": "230 AVONDALE BLVD",
    "dropphycty": "AVONDALE",
    "dropphyst": "CO",
    "dropphyzpp": 810228700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVONDALE",
    "dropmalst": "CO",
    "dropmalzpp": 810229998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199473800,
    "dropsitcph": 7199473800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11059",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "24 RIVER DR",
    "dropdelcty": "BAILEY",
    "dropdelst": "CO",
    "dropdelzpp": 804212235,
    "dropphyadd": "24 RIVER DR",
    "dropphycty": "BAILEY",
    "dropphyst": "CO",
    "dropphyzpp": 804212235,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAILEY",
    "dropmalst": "CO",
    "dropmalzpp": 804219998,
    "dropsitphn": 3032976511,
    "dropsitlph": 3038382084,
    "dropsitcph": 3038382084,
    "dropfax": 3038381182
  },
  {
    "dcode": "D",
    "dropkey": "PZ11064",
    "droptype": "D",
    "dropname": "BASALT",
    "dropdeladd": "12 MIDLAND AVE",
    "dropdelcty": "BASALT",
    "dropdelst": "CO",
    "dropdelzpp": 816219996,
    "dropphyadd": "12 MIDLAND AVE",
    "dropphycty": "BASALT",
    "dropphyst": "CO",
    "dropphyzpp": 816219996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BASALT",
    "dropmalst": "CO",
    "dropmalzpp": 816219998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709273891,
    "dropsitcph": 9709273891,
    "dropfax": 9709279596
  },
  {
    "dcode": "D",
    "dropkey": "PZ11069",
    "droptype": "D",
    "dropname": "BAYFIELD",
    "dropdeladd": "145 PARK ST",
    "dropdelcty": "BAYFIELD",
    "dropdelst": "CO",
    "dropdelzpp": 811229997,
    "dropphyadd": "145 PARK ST",
    "dropphycty": "BAYFIELD",
    "dropphyst": "CO",
    "dropphyzpp": 811229997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYFIELD",
    "dropmalst": "CO",
    "dropmalzpp": 811229998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9708849618,
    "dropsitcph": 9708849618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11075",
    "droptype": "D",
    "dropname": "BEDROCK",
    "dropdeladd": "9538 HIGHWAY 90",
    "dropdelcty": "BEDROCK",
    "dropdelst": "CO",
    "dropdelzpp": 814119807,
    "dropphyadd": "9538 HIGHWAY 90",
    "dropphycty": "BEDROCK",
    "dropphyst": "CO",
    "dropphyzpp": 814119807,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEDROCK",
    "dropmalst": "CO",
    "dropmalzpp": 814119998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708597318,
    "dropsitcph": 9708597318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11077",
    "droptype": "D",
    "dropname": "BELLVUE",
    "dropdeladd": "5301 RIST CANYON RD",
    "dropdelcty": "BELLVUE",
    "dropdelst": "CO",
    "dropdelzpp": 805126036,
    "dropphyadd": "5301 RIST CANYON RD",
    "dropphycty": "BELLVUE",
    "dropphyst": "CO",
    "dropphyzpp": 805126036,
    "dropmaladd": "5301 RIST CANYON RD",
    "dropmalcty": "BELLVUE",
    "dropmalst": "CO",
    "dropmalzpp": 805126036,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704825200,
    "dropsitcph": 9704825200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11080",
    "droptype": "D",
    "dropname": "BENNETT",
    "dropdeladd": "205 S ASH ST",
    "dropdelcty": "BENNETT",
    "dropdelst": "CO",
    "dropdelzpp": 801029997,
    "dropphyadd": "205 S ASH ST",
    "dropphycty": "BENNETT",
    "dropphyst": "CO",
    "dropphyzpp": 801029997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENNETT",
    "dropmalst": "CO",
    "dropmalzpp": 801029998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036443436,
    "dropsitcph": 3036443436,
    "dropfax": 3036443136
  },
  {
    "dcode": "D",
    "dropkey": "PZ11083",
    "droptype": "D",
    "dropname": "BERTHOUD",
    "dropdeladd": "425 3RD ST",
    "dropdelcty": "BERTHOUD",
    "dropdelst": "CO",
    "dropdelzpp": 805133000,
    "dropphyadd": "425 3RD ST",
    "dropphycty": "BERTHOUD",
    "dropphyst": "CO",
    "dropphyzpp": 805133000,
    "dropmaladd": "425 3RD ST",
    "dropmalcty": "BERTHOUD",
    "dropmalst": "CO",
    "dropmalzpp": 805133000,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705320166,
    "dropsitcph": 9705325379,
    "dropfax": 9705320384
  },
  {
    "dcode": "D",
    "dropkey": "PZ11086",
    "droptype": "D",
    "dropname": "BETHUNE",
    "dropdeladd": "135 E 1ST AVE",
    "dropdelcty": "BETHUNE",
    "dropdelst": "CO",
    "dropdelzpp": 808059637,
    "dropphyadd": "135 E 1ST AVE",
    "dropphycty": "BETHUNE",
    "dropphyst": "CO",
    "dropphyzpp": 808059637,
    "dropmaladd": "135 E 1ST AVE",
    "dropmalcty": "BETHUNE",
    "dropmalst": "CO",
    "dropmalzpp": 808059637,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193465673,
    "dropsitcph": 7193465673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11087",
    "droptype": "D",
    "dropname": "BEULAH",
    "dropdeladd": "8867 GRAND AVE",
    "dropdelcty": "BEULAH",
    "dropdelst": "CO",
    "dropdelzpp": 810239741,
    "dropphyadd": "8867 GRAND AVE",
    "dropphycty": "BEULAH",
    "dropphyst": "CO",
    "dropphyzpp": 810239741,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEULAH",
    "dropmalst": "CO",
    "dropmalzpp": 810239998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194853193,
    "dropsitcph": 7194853193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11092",
    "droptype": "D",
    "dropname": "BLACK HAWK",
    "dropdeladd": "7340 BLACK HAWK BLVD",
    "dropdelcty": "BLACK HAWK",
    "dropdelst": "CO",
    "dropdelzpp": 804229997,
    "dropphyadd": "7340 BLACK HAWK BLVD",
    "dropphycty": "BLACK HAWK",
    "dropphyst": "CO",
    "dropphyzpp": 804229997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK HAWK",
    "dropmalst": "CO",
    "dropmalzpp": 804229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035825252,
    "dropsitcph": 3035825252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11094",
    "droptype": "D",
    "dropname": "BLANCA",
    "dropdeladd": "406 SMITH ST",
    "dropdelcty": "BLANCA",
    "dropdelst": "CO",
    "dropdelzpp": 811239173,
    "dropphyadd": "406 SMITH ST",
    "dropphycty": "BLANCA",
    "dropphyst": "CO",
    "dropphyzpp": 811239173,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLANCA",
    "dropmalst": "CO",
    "dropmalzpp": 811239998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193793654,
    "dropsitcph": 7193793654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11100",
    "droptype": "D",
    "dropname": "BOND",
    "dropdeladd": "16711 HIGHWAY 131",
    "dropdelcty": "MC COY",
    "dropdelst": "CO",
    "dropdelzpp": 80463,
    "dropphyadd": "16711 HIGHWAY 131",
    "dropphycty": "MC COY",
    "dropphyst": "CO",
    "dropphyzpp": 80463,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC COY",
    "dropmalst": "CO",
    "dropmalzpp": 804639998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706534308,
    "dropsitcph": 9706534308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11101",
    "droptype": "D",
    "dropname": "BOONE",
    "dropdeladd": "524 MAIN ST",
    "dropdelcty": "BOONE",
    "dropdelst": "CO",
    "dropdelzpp": 810259900,
    "dropphyadd": "524 MAIN ST",
    "dropphycty": "BOONE",
    "dropphyst": "CO",
    "dropphyzpp": 810259900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOONE",
    "dropmalst": "CO",
    "dropmalzpp": 810259998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199473864,
    "dropsitcph": 7199473864,
    "dropfax": 7199473864
  },
  {
    "dcode": "D",
    "dropkey": "PZ11102",
    "droptype": "D",
    "dropname": "BOULDER",
    "dropdeladd": "1905 15TH ST",
    "dropdelcty": "BOULDER",
    "dropdelst": "CO",
    "dropdelzpp": 803029998,
    "dropphyadd": "1905 15TH ST",
    "dropphycty": "BOULDER",
    "dropphyst": "CO",
    "dropphyzpp": 803029998,
    "dropmaladd": "1905 15TH ST",
    "dropmalcty": "BOULDER",
    "dropmalst": "CO",
    "dropmalzpp": 803029998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3039388026,
    "dropsitcph": 3039383704,
    "dropfax": 3037868756
  },
  {
    "dcode": "D",
    "dropkey": "PZ11110",
    "droptype": "D",
    "dropname": "BRANSON",
    "dropdeladd": "334 SADDLEROCK DR",
    "dropdelcty": "BRANSON",
    "dropdelst": "CO",
    "dropdelzpp": 810279901,
    "dropphyadd": "334 SADDLEROCK DR",
    "dropphycty": "BRANSON",
    "dropphyst": "CO",
    "dropphyzpp": 810279901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRANSON",
    "dropmalst": "CO",
    "dropmalzpp": 810279998,
    "dropsitphn": 7199465630,
    "dropsitlph": 7199465630,
    "dropsitcph": 7199465630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11111",
    "droptype": "D",
    "dropname": "BRECKENRIDGE",
    "dropdeladd": "305 S RIDGE ST",
    "dropdelcty": "BRECKENRIDGE",
    "dropdelst": "CO",
    "dropdelzpp": 804249998,
    "dropphyadd": "305 S RIDGE ST",
    "dropphycty": "BRECKENRIDGE",
    "dropphyst": "CO",
    "dropphyzpp": 804249998,
    "dropmaladd": "305 S RIDGE ST",
    "dropmalcty": "BRECKENRIDGE",
    "dropmalst": "CO",
    "dropmalzpp": 804249998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704535467,
    "dropsitcph": 9705470347,
    "dropfax": 9704535819
  },
  {
    "dcode": "D",
    "dropkey": "PZ11114",
    "droptype": "D",
    "dropname": "BRIGGSDALE",
    "dropdeladd": "302 MAIN ST",
    "dropdelcty": "BRIGGSDALE",
    "dropdelst": "CO",
    "dropdelzpp": 806119990,
    "dropphyadd": "302 MAIN ST",
    "dropphycty": "BRIGGSDALE",
    "dropphyst": "CO",
    "dropphyzpp": 806119990,
    "dropmaladd": "302 MAIN ST",
    "dropmalcty": "BRIGGSDALE",
    "dropmalst": "CO",
    "dropmalzpp": 806119990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706563411,
    "dropsitcph": 9706563411,
    "dropfax": 9706563411
  },
  {
    "dcode": "D",
    "dropkey": "PZ11116",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "90 N 4TH AVE",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "CO",
    "dropdelzpp": 806019998,
    "dropphyadd": "90 N 4TH AVE",
    "dropphycty": "BRIGHTON",
    "dropphyst": "CO",
    "dropphyzpp": 806019998,
    "dropmaladd": "90 N 4TH AVE",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "CO",
    "dropmalzpp": 806019998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036598258,
    "dropsitcph": 3036370826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11120",
    "droptype": "D",
    "dropname": "BROOMFIELD",
    "dropdeladd": "280 E 1ST AVE",
    "dropdelcty": "BROOMFIELD",
    "dropdelst": "CO",
    "dropdelzpp": 800209998,
    "dropphyadd": "280 E 1ST AVE",
    "dropphycty": "BROOMFIELD",
    "dropphyst": "CO",
    "dropphyzpp": 800209998,
    "dropmaladd": "280 E 1ST AVE",
    "dropmalcty": "BROOMFIELD",
    "dropmalst": "CO",
    "dropmalzpp": 800209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034389751,
    "dropsitcph": 3034380035,
    "dropfax": 3034660283
  },
  {
    "dcode": "D",
    "dropkey": "PZ11123",
    "droptype": "D",
    "dropname": "BRUSH",
    "dropdeladd": "115 CARSON ST",
    "dropdelcty": "BRUSH",
    "dropdelst": "CO",
    "dropdelzpp": 807239998,
    "dropphyadd": "115 CARSON ST",
    "dropphycty": "BRUSH",
    "dropphyst": "CO",
    "dropphyzpp": 807239998,
    "dropmaladd": "115 CARSON ST",
    "dropmalcty": "BRUSH",
    "dropmalst": "CO",
    "dropmalzpp": 807239998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708424382,
    "dropsitcph": 9708424382,
    "dropfax": 9708420373
  },
  {
    "dcode": "D",
    "dropkey": "PZ11126",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "110 BROOKDALE AVE",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "CO",
    "dropdelzpp": 812119998,
    "dropphyadd": "110 BROOKDALE AVE",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "CO",
    "dropphyzpp": 812119998,
    "dropmaladd": "110 BROOKDALE AVE",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "CO",
    "dropmalzpp": 812119998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193952446,
    "dropsitcph": 7193952446,
    "dropfax": 7193954359
  },
  {
    "dcode": "D",
    "dropkey": "PZ11129",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "259 14TH ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "CO",
    "dropdelzpp": 808071616,
    "dropphyadd": "259 14TH ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "CO",
    "dropphyzpp": 808071616,
    "dropmaladd": "259 14TH ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "CO",
    "dropmalzpp": 808071616,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193465760,
    "dropsitcph": 7193465753,
    "dropfax": 7193469543
  },
  {
    "dcode": "D",
    "dropkey": "PZ11130",
    "droptype": "D",
    "dropname": "BURNS",
    "dropdeladd": "23414 COLORADO RIVER RD",
    "dropdelcty": "BURNS",
    "dropdelst": "CO",
    "dropdelzpp": 804269990,
    "dropphyadd": "23414 COLORADO RIVER RD",
    "dropphycty": "BURNS",
    "dropphyst": "CO",
    "dropphyzpp": 804269990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURNS",
    "dropmalst": "CO",
    "dropmalzpp": 804269998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706534237,
    "dropsitcph": 9706534237,
    "dropfax": 9706534289
  },
  {
    "dcode": "D",
    "dropkey": "PZ11131",
    "droptype": "D",
    "dropname": "BYERS",
    "dropdeladd": "47 CEDAR AVE",
    "dropdelcty": "BYERS",
    "dropdelst": "CO",
    "dropdelzpp": 801039756,
    "dropphyadd": "47 CEDAR AVE",
    "dropphycty": "BYERS",
    "dropphyst": "CO",
    "dropphyzpp": 801039756,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BYERS",
    "dropmalst": "CO",
    "dropmalzpp": 801039998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038226985,
    "dropsitcph": 3038226985,
    "dropfax": 3038225312
  },
  {
    "dcode": "D",
    "dropkey": "PZ11137",
    "droptype": "D",
    "dropname": "CAHONE",
    "dropdeladd": "51796 HIGHWAY 491",
    "dropdelcty": "CAHONE",
    "dropdelst": "CO",
    "dropdelzpp": 813208500,
    "dropphyadd": "51796 HIGHWAY 491",
    "dropphycty": "CAHONE",
    "dropphyst": "CO",
    "dropphyzpp": 813208500,
    "dropmaladd": "51796 HIGHWAY 491",
    "dropmalcty": "CAHONE",
    "dropmalst": "CO",
    "dropmalzpp": 813208500,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705624223,
    "dropsitcph": 9705624223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11138",
    "droptype": "D",
    "dropname": "CALHAN",
    "dropdeladd": "655 CASCADE ST",
    "dropdelcty": "CALHAN",
    "dropdelst": "CO",
    "dropdelzpp": 808088204,
    "dropphyadd": "655 CASCADE ST",
    "dropphycty": "CALHAN",
    "dropphyst": "CO",
    "dropphyzpp": 808088204,
    "dropmaladd": "655 CASCADE ST",
    "dropmalcty": "CALHAN",
    "dropmalst": "CO",
    "dropmalzpp": 808088204,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193473254,
    "dropsitcph": 7193473269,
    "dropfax": 7193470127
  },
  {
    "dcode": "D",
    "dropkey": "PZ11139",
    "droptype": "D",
    "dropname": "CAMPO",
    "dropdeladd": "183 W 4TH ST",
    "dropdelcty": "CAMPO",
    "dropdelst": "CO",
    "dropdelzpp": 810299997,
    "dropphyadd": "183 W 4TH ST",
    "dropphycty": "CAMPO",
    "dropphyst": "CO",
    "dropphyzpp": 810299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMPO",
    "dropmalst": "CO",
    "dropmalzpp": 810299998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197872419,
    "dropsitcph": 7197872419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11140",
    "droptype": "D",
    "dropname": "CANON CITY",
    "dropdeladd": "1501 MAIN ST",
    "dropdelcty": "CANON CITY",
    "dropdelst": "CO",
    "dropdelzpp": 812122406,
    "dropphyadd": "1501 MAIN ST",
    "dropphycty": "CANON CITY",
    "dropphyst": "CO",
    "dropphyzpp": 812122406,
    "dropmaladd": "1501 MAIN ST",
    "dropmalcty": "CANON CITY",
    "dropmalst": "CO",
    "dropmalzpp": 812122406,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192756877,
    "dropsitcph": 7192756877,
    "dropfax": 7192750541
  },
  {
    "dcode": "D",
    "dropkey": "PZ11143",
    "droptype": "D",
    "dropname": "CAPULIN",
    "dropdeladd": "7999 STATE HIGHWAY 15",
    "dropdelcty": "CAPULIN",
    "dropdelst": "CO",
    "dropdelzpp": 811249990,
    "dropphyadd": "7999 STATE HIGHWAY 15",
    "dropphycty": "CAPULIN",
    "dropphyst": "CO",
    "dropphyzpp": 811249990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAPULIN",
    "dropmalst": "CO",
    "dropmalzpp": 811249998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193412653,
    "dropsitcph": 7193412653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11144",
    "droptype": "D",
    "dropname": "CARBONDALE",
    "dropdeladd": "655 MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "CO",
    "dropdelzpp": 816233600,
    "dropphyadd": "655 MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "CO",
    "dropphyzpp": 816233600,
    "dropmaladd": "655 MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "CO",
    "dropmalzpp": 816233600,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709633411,
    "dropsitcph": 9709633411,
    "dropfax": 9709639614
  },
  {
    "dcode": "D",
    "dropkey": "PZ11148",
    "droptype": "D",
    "dropname": "CARR",
    "dropdeladd": "9604 WARNER AVE",
    "dropdelcty": "CARR",
    "dropdelst": "CO",
    "dropdelzpp": 806129990,
    "dropphyadd": "9604 WARNER AVE",
    "dropphycty": "CARR",
    "dropphyst": "CO",
    "dropphyzpp": 806129990,
    "dropmaladd": "9604 WARNER AVE",
    "dropmalcty": "CARR",
    "dropmalst": "CO",
    "dropmalzpp": 806129990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708972622,
    "dropsitcph": 9708972622,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11149",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "8006 UTE PASS AVE",
    "dropdelcty": "CASCADE",
    "dropdelst": "CO",
    "dropdelzpp": 808099998,
    "dropphyadd": "8006 UTE PASS AVE",
    "dropphycty": "CASCADE",
    "dropphyst": "CO",
    "dropphyzpp": 808099998,
    "dropmaladd": "8006 UTE PASS AVE",
    "dropmalcty": "CASCADE",
    "dropmalst": "CO",
    "dropmalzpp": 808099998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196842146,
    "dropsitcph": 7196842146,
    "dropfax": 7196847742
  },
  {
    "dcode": "D",
    "dropkey": "PZ11150",
    "droptype": "D",
    "dropname": "CASTLE ROCK",
    "dropdeladd": "220 S WILCOX ST",
    "dropdelcty": "CASTLE ROCK",
    "dropdelst": "CO",
    "dropdelzpp": 801049997,
    "dropphyadd": "220 S WILCOX ST",
    "dropphycty": "CASTLE ROCK",
    "dropphyst": "CO",
    "dropphyzpp": 801049997,
    "dropmaladd": "220 S WILCOX ST",
    "dropmalcty": "CASTLE ROCK",
    "dropmalst": "CO",
    "dropmalzpp": 801049997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038146934,
    "dropsitcph": 3038146932,
    "dropfax": 3036883731
  },
  {
    "dcode": "D",
    "dropkey": "PZ11151",
    "droptype": "D",
    "dropname": "CEDAREDGE",
    "dropdeladd": "155 SW 2ND ST",
    "dropdelcty": "CEDAREDGE",
    "dropdelst": "CO",
    "dropdelzpp": 814139997,
    "dropphyadd": "155 SW 2ND ST",
    "dropphycty": "CEDAREDGE",
    "dropphyst": "CO",
    "dropphyzpp": 814139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAREDGE",
    "dropmalst": "CO",
    "dropmalzpp": 814139998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708563316,
    "dropsitcph": 9708563316,
    "dropfax": 9708567165
  },
  {
    "dcode": "D",
    "dropkey": "PZ11154",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "255 S WORTH ST",
    "dropdelcty": "CENTER",
    "dropdelst": "CO",
    "dropdelzpp": 811259990,
    "dropphyadd": "255 S WORTH ST",
    "dropphycty": "CENTER",
    "dropphyst": "CO",
    "dropphyzpp": 811259990,
    "dropmaladd": "255 S WORTH ST",
    "dropmalcty": "CENTER",
    "dropmalst": "CO",
    "dropmalzpp": 811259990,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197542215,
    "dropsitcph": 7197542215,
    "dropfax": 7197543578
  },
  {
    "dcode": "D",
    "dropkey": "PZ11156",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "149 GREGORY ST",
    "dropdelcty": "CENTRAL CITY",
    "dropdelst": "CO",
    "dropdelzpp": 804279998,
    "dropphyadd": "149 GREGORY ST",
    "dropphycty": "CENTRAL CITY",
    "dropphyst": "CO",
    "dropphyzpp": 804279998,
    "dropmaladd": "149 GREGORY ST",
    "dropmalcty": "CENTRAL CITY",
    "dropmalst": "CO",
    "dropmalzpp": 804279998,
    "dropsitphn": 7207193998,
    "dropsitlph": 7207193998,
    "dropsitcph": 7207193998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11157",
    "droptype": "D",
    "dropname": "CHAMA",
    "dropdeladd": "21844 COUNTY ROAD P.6",
    "dropdelcty": "CHAMA",
    "dropdelst": "CO",
    "dropdelzpp": 811269990,
    "dropphyadd": "21844 COUNTY ROAD P.6",
    "dropphycty": "CHAMA",
    "dropphyst": "CO",
    "dropphyzpp": 811269990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMA",
    "dropmalst": "CO",
    "dropmalzpp": 811269998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196723123,
    "dropsitcph": 7196723123,
    "dropfax": 7196723123
  },
  {
    "dcode": "D",
    "dropkey": "PZ11159",
    "droptype": "D",
    "dropname": "CHERAW",
    "dropdeladd": "207 W GRAND AVE",
    "dropdelcty": "CHERAW",
    "dropdelst": "CO",
    "dropdelzpp": 810309900,
    "dropphyadd": "207 W GRAND AVE",
    "dropphycty": "CHERAW",
    "dropphyst": "CO",
    "dropphyzpp": 810309900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHERAW",
    "dropmalst": "CO",
    "dropmalzpp": 810309998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198536279,
    "dropsitcph": 7198536279,
    "dropfax": 7198536032
  },
  {
    "dcode": "D",
    "dropkey": "PZ11165",
    "droptype": "D",
    "dropname": "CHEYENNE WELLS",
    "dropdeladd": "90 E 1ST ST",
    "dropdelcty": "CHEYENNE WELLS",
    "dropdelst": "CO",
    "dropdelzpp": 808109701,
    "dropphyadd": "90 E 1ST ST",
    "dropphycty": "CHEYENNE WELLS",
    "dropphyst": "CO",
    "dropphyzpp": 808109701,
    "dropmaladd": "90 E 1ST ST",
    "dropmalcty": "CHEYENNE WELLS",
    "dropmalst": "CO",
    "dropmalzpp": 808109701,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197675895,
    "dropsitcph": 7197675895,
    "dropfax": 7197672018
  },
  {
    "dcode": "D",
    "dropkey": "PZ11169",
    "droptype": "D",
    "dropname": "CHROMO",
    "dropdeladd": "137 COUNTY ROAD 391",
    "dropdelcty": "CHROMO",
    "dropdelst": "CO",
    "dropdelzpp": 811289902,
    "dropphyadd": "137 COUNTY ROAD 391",
    "dropphycty": "CHROMO",
    "dropphyst": "CO",
    "dropphyzpp": 811289902,
    "dropmaladd": "137 COUNTY ROAD 391",
    "dropmalcty": "CHROMO",
    "dropmalst": "CO",
    "dropmalzpp": 811289902,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702643050,
    "dropsitcph": 9702643050,
    "dropfax": 9702644619
  },
  {
    "dcode": "D",
    "dropkey": "PZ11170",
    "droptype": "D",
    "dropname": "CIMARRON",
    "dropdeladd": "82111 E US HIGHWAY 50",
    "dropdelcty": "CIMARRON",
    "dropdelst": "CO",
    "dropdelzpp": 812209990,
    "dropphyadd": "82111 E US HIGHWAY 50",
    "dropphycty": "CIMARRON",
    "dropphyst": "CO",
    "dropphyzpp": 812209990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CIMARRON",
    "dropmalst": "CO",
    "dropmalzpp": 812209998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702528366,
    "dropsitcph": 9702528366,
    "dropfax": 9702404832
  },
  {
    "dcode": "D",
    "dropkey": "PZ11172",
    "droptype": "D",
    "dropname": "CLARK",
    "dropdeladd": "54185 COUNTY ROAD 129",
    "dropdelcty": "CLARK",
    "dropdelst": "CO",
    "dropdelzpp": 804289997,
    "dropphyadd": "54185 COUNTY ROAD 129",
    "dropphycty": "CLARK",
    "dropphyst": "CO",
    "dropphyzpp": 804289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARK",
    "dropmalst": "CO",
    "dropmalzpp": 804289998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708793892,
    "dropsitcph": 9708793892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11174",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "3252 F RD",
    "dropdelcty": "CLIFTON",
    "dropdelst": "CO",
    "dropdelzpp": 815209998,
    "dropphyadd": "3252 F RD",
    "dropphycty": "CLIFTON",
    "dropphyst": "CO",
    "dropphyzpp": 815209998,
    "dropmaladd": "3252 F RD",
    "dropmalcty": "CLIFTON",
    "dropmalst": "CO",
    "dropmalzpp": 815209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704346573,
    "dropsitcph": 9704346573,
    "dropfax": 9704346258
  },
  {
    "dcode": "D",
    "dropkey": "PZ11180",
    "droptype": "D",
    "dropname": "COAL CREEK",
    "dropdeladd": "201 COAL CREEK DR",
    "dropdelcty": "COAL CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 812219997,
    "dropphyadd": "201 COAL CREEK DR",
    "dropphycty": "COAL CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 812219997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COAL CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 812219998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197844336,
    "dropsitcph": 7197844336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11182",
    "droptype": "D",
    "dropname": "COALDALE",
    "dropdeladd": "16081 US HIGHWAY 50",
    "dropdelcty": "COALDALE",
    "dropdelst": "CO",
    "dropdelzpp": 812229990,
    "dropphyadd": "16081 US HIGHWAY 50",
    "dropphycty": "COALDALE",
    "dropphyst": "CO",
    "dropphyzpp": 812229990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COALDALE",
    "dropmalst": "CO",
    "dropmalzpp": 812229998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199424275,
    "dropsitcph": 7199424275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11185",
    "droptype": "D",
    "dropname": "COLLBRAN",
    "dropdeladd": "110 MAIN ST",
    "dropdelcty": "COLLBRAN",
    "dropdelst": "CO",
    "dropdelzpp": 816249997,
    "dropphyadd": "110 MAIN ST",
    "dropphycty": "COLLBRAN",
    "dropphyst": "CO",
    "dropphyzpp": 816249997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLBRAN",
    "dropmalst": "CO",
    "dropmalzpp": 816249998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704873717,
    "dropsitcph": 9704873717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11196",
    "droptype": "D",
    "dropname": "COLORADO SPRINGS",
    "dropdeladd": "201 E PIKES PEAK AVE",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809039900,
    "dropphyadd": "201 E PIKES PEAK AVE",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809039900,
    "dropmaladd": "201 E PIKES PEAK AVE",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809039900,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705336,
    "dropsitcph": 7195705336,
    "dropfax": 7195705428
  },
  {
    "dcode": "D",
    "dropkey": "PZ11201",
    "droptype": "D",
    "dropname": "COMMERCE CITY",
    "dropdeladd": "7351 MAGNOLIA ST",
    "dropdelcty": "COMMERCE CITY",
    "dropdelst": "CO",
    "dropdelzpp": 800229998,
    "dropphyadd": "7351 MAGNOLIA ST",
    "dropphycty": "COMMERCE CITY",
    "dropphyst": "CO",
    "dropphyzpp": 800229998,
    "dropmaladd": "7351 MAGNOLIA ST",
    "dropmalcty": "COMMERCE CITY",
    "dropmalst": "CO",
    "dropmalzpp": 800229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032277383,
    "dropsitcph": 3032277381,
    "dropfax": 3032871862
  },
  {
    "dcode": "D",
    "dropkey": "PZ11204",
    "droptype": "D",
    "dropname": "CONEJOS",
    "dropdeladd": "6731 COUNTY ROAD 13",
    "dropdelcty": "CONEJOS",
    "dropdelst": "CO",
    "dropdelzpp": 811299990,
    "dropphyadd": "6731 COUNTY ROAD 13",
    "dropphycty": "CONEJOS",
    "dropphyst": "CO",
    "dropphyzpp": 811299990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONEJOS",
    "dropmalst": "CO",
    "dropmalzpp": 811299998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193765934,
    "dropsitcph": 7193765934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11205",
    "droptype": "D",
    "dropname": "CONIFER",
    "dropdeladd": "9546 S DALLMAN DR",
    "dropdelcty": "CONIFER",
    "dropdelst": "CO",
    "dropdelzpp": 804339997,
    "dropphyadd": "9546 S DALLMAN DR",
    "dropphycty": "CONIFER",
    "dropphyst": "CO",
    "dropphyzpp": 804339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONIFER",
    "dropmalst": "CO",
    "dropmalzpp": 804339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038387606,
    "dropsitcph": 3038387449,
    "dropfax": 3036701661
  },
  {
    "dcode": "D",
    "dropkey": "PZ11274",
    "droptype": "D",
    "dropname": "COPE",
    "dropdeladd": "45537 MAIN ST",
    "dropdelcty": "COPE",
    "dropdelst": "CO",
    "dropdelzpp": 808129502,
    "dropphyadd": "45537 MAIN ST",
    "dropphycty": "COPE",
    "dropphyst": "CO",
    "dropphyzpp": 808129502,
    "dropmaladd": "45537 MAIN ST",
    "dropmalcty": "COPE",
    "dropmalst": "CO",
    "dropmalzpp": 808129502,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703574227,
    "dropsitcph": 9703574227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11276",
    "droptype": "D",
    "dropname": "CORTEZ",
    "dropdeladd": "35 S BEECH ST",
    "dropdelcty": "CORTEZ",
    "dropdelst": "CO",
    "dropdelzpp": 813219998,
    "dropphyadd": "35 S BEECH ST",
    "dropphycty": "CORTEZ",
    "dropphyst": "CO",
    "dropphyzpp": 813219998,
    "dropmaladd": "35 S BEECH ST",
    "dropmalcty": "CORTEZ",
    "dropmalst": "CO",
    "dropmalzpp": 813219998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705653181,
    "dropsitcph": 9705653181,
    "dropfax": 9705656377
  },
  {
    "dcode": "D",
    "dropkey": "PZ11277",
    "droptype": "D",
    "dropname": "CORY",
    "dropdeladd": "9340 HIGHWAY 65",
    "dropdelcty": "CORY",
    "dropdelst": "CO",
    "dropdelzpp": 814149997,
    "dropphyadd": "9340 HIGHWAY 65",
    "dropphycty": "CORY",
    "dropphyst": "CO",
    "dropphyzpp": 814149997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORY",
    "dropmalst": "CO",
    "dropmalzpp": 814149998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708353521,
    "dropsitcph": 9708353521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11278",
    "droptype": "D",
    "dropname": "COTOPAXI",
    "dropdeladd": "123 COUNTY ROAD 12",
    "dropdelcty": "COTOPAXI",
    "dropdelst": "CO",
    "dropdelzpp": 812239990,
    "dropphyadd": "123 COUNTY ROAD 12",
    "dropphycty": "COTOPAXI",
    "dropphyst": "CO",
    "dropphyzpp": 812239990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTOPAXI",
    "dropmalst": "CO",
    "dropmalzpp": 812239998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199424100,
    "dropsitcph": 7199424100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11279",
    "droptype": "D",
    "dropname": "COWDREY",
    "dropdeladd": "27 COUNTY ROAD 6W",
    "dropdelcty": "COWDREY",
    "dropdelst": "CO",
    "dropdelzpp": 804349901,
    "dropphyadd": "27 COUNTY ROAD 6W",
    "dropphycty": "COWDREY",
    "dropphyst": "CO",
    "dropphyzpp": 804349901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COWDREY",
    "dropmalst": "CO",
    "dropmalzpp": 804349998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707238319,
    "dropsitcph": 9707238319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11280",
    "droptype": "D",
    "dropname": "CRAIG",
    "dropdeladd": "556 PERSHING ST",
    "dropdelcty": "CRAIG",
    "dropdelst": "CO",
    "dropdelzpp": 816259998,
    "dropphyadd": "556 PERSHING ST",
    "dropphycty": "CRAIG",
    "dropphyst": "CO",
    "dropphyzpp": 816259998,
    "dropmaladd": "556 PERSHING ST",
    "dropmalcty": "CRAIG",
    "dropmalst": "CO",
    "dropmalzpp": 816259998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708248506,
    "dropsitcph": 9708248506,
    "dropfax": 9708243887
  },
  {
    "dcode": "D",
    "dropkey": "PZ11281",
    "droptype": "D",
    "dropname": "CRAWFORD",
    "dropdeladd": "295 HIGHWAY 92",
    "dropdelcty": "CRAWFORD",
    "dropdelst": "CO",
    "dropdelzpp": 814159997,
    "dropphyadd": "295 HIGHWAY 92",
    "dropphycty": "CRAWFORD",
    "dropphyst": "CO",
    "dropphyzpp": 814159997,
    "dropmaladd": "295 HIGHWAY 92",
    "dropmalcty": "CRAWFORD",
    "dropmalst": "CO",
    "dropmalzpp": 814159997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709214425,
    "dropsitcph": 9709214425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11282",
    "droptype": "D",
    "dropname": "CREEDE",
    "dropdeladd": "10 S MAIN ST",
    "dropdelcty": "CREEDE",
    "dropdelst": "CO",
    "dropdelzpp": 811309990,
    "dropphyadd": "10 S MAIN ST",
    "dropphycty": "CREEDE",
    "dropphyst": "CO",
    "dropphyzpp": 811309990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CREEDE",
    "dropmalst": "CO",
    "dropmalzpp": 811309998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196582615,
    "dropsitcph": 7196582615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11284",
    "droptype": "D",
    "dropname": "CRESTED BUTTE",
    "dropdeladd": "217 ELK AVE",
    "dropdelcty": "CRESTED BUTTE",
    "dropdelst": "CO",
    "dropdelzpp": 812249608,
    "dropphyadd": "217 ELK AVE",
    "dropphycty": "CRESTED BUTTE",
    "dropphyst": "CO",
    "dropphyzpp": 812249608,
    "dropmaladd": "217 ELK AVE",
    "dropmalcty": "CRESTED BUTTE",
    "dropmalst": "CO",
    "dropmalzpp": 812249608,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703495568,
    "dropsitcph": 9703495568,
    "dropfax": 9703496741
  },
  {
    "dcode": "D",
    "dropkey": "PZ11286",
    "droptype": "D",
    "dropname": "CRESTONE",
    "dropdeladd": "166 S ALDER AVE",
    "dropdelcty": "CRESTONE",
    "dropdelst": "CO",
    "dropdelzpp": 811319998,
    "dropphyadd": "166 S ALDER AVE",
    "dropphycty": "CRESTONE",
    "dropphyst": "CO",
    "dropphyzpp": 811319990,
    "dropmaladd": "166 S ALDER AVE",
    "dropmalcty": "CRESTONE",
    "dropmalst": "CO",
    "dropmalzpp": 811319998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192564760,
    "dropsitcph": 7192564760,
    "dropfax": 7192564703
  },
  {
    "dcode": "D",
    "dropkey": "PZ11287",
    "droptype": "D",
    "dropname": "CRIPPLE CREEK",
    "dropdeladd": "319 W CARR ST",
    "dropdelcty": "CRIPPLE CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 808139613,
    "dropphyadd": "319 W CARR ST",
    "dropphycty": "CRIPPLE CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 808139613,
    "dropmaladd": "319 W CARR ST",
    "dropmalcty": "CRIPPLE CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 808139613,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196892423,
    "dropsitcph": 7196892423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11288",
    "droptype": "D",
    "dropname": "CROOK",
    "dropdeladd": "323 2ND AVE",
    "dropdelcty": "CROOK",
    "dropdelst": "CO",
    "dropdelzpp": 807269998,
    "dropphyadd": "323 2ND AVE",
    "dropphycty": "CROOK",
    "dropphyst": "CO",
    "dropphyzpp": 807269998,
    "dropmaladd": "323 2ND AVE",
    "dropmalcty": "CROOK",
    "dropmalst": "CO",
    "dropmalzpp": 807269998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708863111,
    "dropsitcph": 9708863111,
    "dropfax": 9708430691
  },
  {
    "dcode": "D",
    "dropkey": "PZ11289",
    "droptype": "D",
    "dropname": "CROWLEY",
    "dropdeladd": "208 BROADWAY ST",
    "dropdelcty": "CROWLEY",
    "dropdelst": "CO",
    "dropdelzpp": 810339900,
    "dropphyadd": "208 BROADWAY ST",
    "dropphycty": "CROWLEY",
    "dropphyst": "CO",
    "dropphyzpp": 810339900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWLEY",
    "dropmalst": "CO",
    "dropmalzpp": 810339998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192673431,
    "dropsitcph": 7192673431,
    "dropfax": 7192673471
  },
  {
    "dcode": "D",
    "dropkey": "PZ11297",
    "droptype": "D",
    "dropname": "DACONO",
    "dropdeladd": "650 GLEN CREIGHTON DR",
    "dropdelcty": "DACONO",
    "dropdelst": "CO",
    "dropdelzpp": 805149997,
    "dropphyadd": "650 GLEN CREIGHTON DR",
    "dropphycty": "DACONO",
    "dropphyst": "CO",
    "dropphyzpp": 805149997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DACONO",
    "dropmalst": "CO",
    "dropmalzpp": 805149998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033742188,
    "dropsitcph": 3033742188,
    "dropfax": 3033742190
  },
  {
    "dcode": "D",
    "dropkey": "PZ11298",
    "droptype": "D",
    "dropname": "DE BEQUE",
    "dropdeladd": "347 MINTER AVE",
    "dropdelcty": "DE BEQUE",
    "dropdelst": "CO",
    "dropdelzpp": 816309997,
    "dropphyadd": "347 MINTER AVE",
    "dropphycty": "DE BEQUE",
    "dropphyst": "CO",
    "dropphyzpp": 816309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DE BEQUE",
    "dropmalst": "CO",
    "dropmalzpp": 816309998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702835498,
    "dropsitcph": 9702835498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11300",
    "droptype": "D",
    "dropname": "DEER TRAIL",
    "dropdeladd": "195 DATE ST",
    "dropdelcty": "DEER TRAIL",
    "dropdelst": "CO",
    "dropdelzpp": 801059997,
    "dropphyadd": "195 DATE ST",
    "dropphycty": "DEER TRAIL",
    "dropphyst": "CO",
    "dropphyzpp": 801059997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER TRAIL",
    "dropmalst": "CO",
    "dropmalzpp": 801059998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037694661,
    "dropsitcph": 3037694661,
    "dropfax": 3037694661
  },
  {
    "dcode": "D",
    "dropkey": "PZ11301",
    "droptype": "D",
    "dropname": "DEL NORTE",
    "dropdeladd": "590 COLUMBIA AVE",
    "dropdelcty": "DEL NORTE",
    "dropdelst": "CO",
    "dropdelzpp": 811322200,
    "dropphyadd": "590 COLUMBIA AVE",
    "dropphycty": "DEL NORTE",
    "dropphyst": "CO",
    "dropphyzpp": 811322200,
    "dropmaladd": "590 COLUMBIA AVE",
    "dropmalcty": "DEL NORTE",
    "dropmalst": "CO",
    "dropmalzpp": 811322200,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196573155,
    "dropsitcph": 7196573155,
    "dropfax": 7196572944
  },
  {
    "dcode": "D",
    "dropkey": "PZ11303",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "360 MEEKER ST",
    "dropdelcty": "DELTA",
    "dropdelst": "CO",
    "dropdelzpp": 814169923,
    "dropphyadd": "360 MEEKER ST",
    "dropphycty": "DELTA",
    "dropphyst": "CO",
    "dropphyzpp": 814169923,
    "dropmaladd": "360 MEEKER ST",
    "dropmalcty": "DELTA",
    "dropmalst": "CO",
    "dropmalzpp": 814169923,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708742652,
    "dropsitcph": 9708742652,
    "dropfax": 9708747149
  },
  {
    "dcode": "D",
    "dropkey": "PZ11306",
    "droptype": "D",
    "dropname": "DENVER",
    "dropdeladd": "951 20TH ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802029998,
    "dropphyadd": "951 20TH ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802029998,
    "dropmaladd": "951 20TH ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802029998,
    "dropsitphn": 3038536547,
    "dropsitlph": 3032962071,
    "dropsitcph": 3032962071,
    "dropfax": 3032953727
  },
  {
    "dcode": "D",
    "dropkey": "PZ11313",
    "droptype": "D",
    "dropname": "DILLON",
    "dropdeladd": "500 LAKE DILLON DR",
    "dropdelcty": "DILLON",
    "dropdelst": "CO",
    "dropdelzpp": 804359998,
    "dropphyadd": "500 LAKE DILLON DR",
    "dropphycty": "DILLON",
    "dropphyst": "CO",
    "dropphyzpp": 804359998,
    "dropmaladd": "500 LAKE DILLON DR",
    "dropmalcty": "DILLON",
    "dropmalst": "CO",
    "dropmalzpp": 804359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704687767,
    "dropsitcph": 9705138282,
    "dropfax": 9702626031
  },
  {
    "dcode": "D",
    "dropkey": "PZ11314",
    "droptype": "D",
    "dropname": "DINOSAUR",
    "dropdeladd": "114 STEGOSAURUS FWY",
    "dropdelcty": "DINOSAUR",
    "dropdelst": "CO",
    "dropdelzpp": 816109997,
    "dropphyadd": "114 STEGOSAURUS FWY",
    "dropphycty": "DINOSAUR",
    "dropphyst": "CO",
    "dropphyzpp": 816109997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DINOSAUR",
    "dropmalst": "CO",
    "dropmalzpp": 816109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703742353,
    "dropsitcph": 9703742353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11315",
    "droptype": "D",
    "dropname": "DIVIDE",
    "dropdeladd": "66 HYBROOK RD S",
    "dropdelcty": "DIVIDE",
    "dropdelst": "CO",
    "dropdelzpp": 808149219,
    "dropphyadd": "66 HYBROOK RD S",
    "dropphycty": "DIVIDE",
    "dropphyst": "CO",
    "dropphyzpp": 808149219,
    "dropmaladd": "66 HYBROOK RD S",
    "dropmalcty": "DIVIDE",
    "dropmalst": "CO",
    "dropmalzpp": 808149219,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196872885,
    "dropsitcph": 7196872885,
    "dropfax": 7196872079
  },
  {
    "dcode": "D",
    "dropkey": "PZ11316",
    "droptype": "D",
    "dropname": "DOLORES",
    "dropdeladd": "1000 RAILROAD AVE N",
    "dropdelcty": "DOLORES",
    "dropdelst": "CO",
    "dropdelzpp": 813239733,
    "dropphyadd": "1000 RAILROAD AVE N",
    "dropphycty": "DOLORES",
    "dropphyst": "CO",
    "dropphyzpp": 813239733,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOLORES",
    "dropmalst": "CO",
    "dropmalzpp": 813239998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9708827796,
    "dropsitcph": 9708827796,
    "dropfax": 9708827231
  },
  {
    "dcode": "D",
    "dropkey": "PZ11318",
    "droptype": "D",
    "dropname": "DOVE CREEK",
    "dropdeladd": "110 HIGHWAY 491",
    "dropdelcty": "DOVE CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 813249901,
    "dropphyadd": "110 HIGHWAY 491",
    "dropphycty": "DOVE CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 813249901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOVE CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 813249998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706772286,
    "dropsitcph": 9706772286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11325",
    "droptype": "D",
    "dropname": "DRAKE",
    "dropdeladd": "1601 US HIGHWAY 34",
    "dropdelcty": "DRAKE",
    "dropdelst": "CO",
    "dropdelzpp": 805159702,
    "dropphyadd": "1601 US HIGHWAY 34",
    "dropphycty": "DRAKE",
    "dropphyst": "CO",
    "dropphyzpp": 805159702,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRAKE",
    "dropmalst": "CO",
    "dropmalzpp": 805159998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706671341,
    "dropsitcph": 9706671341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11326",
    "droptype": "D",
    "dropname": "DUMONT",
    "dropdeladd": "307 COUNTY ROAD 308",
    "dropdelcty": "DUMONT",
    "dropdelst": "CO",
    "dropdelzpp": 804369901,
    "dropphyadd": "307 COUNTY ROAD 308",
    "dropphycty": "DUMONT",
    "dropphyst": "CO",
    "dropphyzpp": 804369901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUMONT",
    "dropmalst": "CO",
    "dropmalzpp": 804369998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035674907,
    "dropsitcph": 3035674907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11328",
    "droptype": "D",
    "dropname": "DUPONT",
    "dropdeladd": "8096 BRIGHTON RD",
    "dropdelcty": "COMMERCE CITY",
    "dropdelst": "CO",
    "dropdelzpp": 800225315,
    "dropphyadd": "8096 BRIGHTON RD",
    "dropphycty": "COMMERCE CITY",
    "dropphyst": "CO",
    "dropphyzpp": 800225315,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUPONT",
    "dropmalst": "CO",
    "dropmalzpp": 800249998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032874296,
    "dropsitcph": 3032874296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11330",
    "droptype": "D",
    "dropname": "DURANGO",
    "dropdeladd": "222 W 8TH ST",
    "dropdelcty": "DURANGO",
    "dropdelst": "CO",
    "dropdelzpp": 813019998,
    "dropphyadd": "222 W 8TH ST",
    "dropphycty": "DURANGO",
    "dropphyst": "CO",
    "dropphyzpp": 813019998,
    "dropmaladd": "222 W 8TH ST",
    "dropmalcty": "DURANGO",
    "dropmalst": "CO",
    "dropmalzpp": 813019998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702473968,
    "dropsitcph": 9702473434,
    "dropfax": 9702473154
  },
  {
    "dcode": "D",
    "dropkey": "PZ11331",
    "droptype": "D",
    "dropname": "EADS",
    "dropdeladd": "1200 MAINE ST",
    "dropdelcty": "EADS",
    "dropdelst": "CO",
    "dropdelzpp": 810369900,
    "dropphyadd": "1200 MAINE ST",
    "dropphycty": "EADS",
    "dropphyst": "CO",
    "dropphyzpp": 810369900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EADS",
    "dropmalst": "CO",
    "dropmalzpp": 810369998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193990828,
    "dropsitcph": 7193993002,
    "dropfax": 7194385836
  },
  {
    "dcode": "D",
    "dropkey": "PZ11332",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "264 CHAMBERS AVE",
    "dropdelcty": "EAGLE",
    "dropdelst": "CO",
    "dropdelzpp": 816319997,
    "dropphyadd": "264 CHAMBERS AVE",
    "dropphycty": "EAGLE",
    "dropphyst": "CO",
    "dropphyzpp": 816319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLE",
    "dropmalst": "CO",
    "dropmalzpp": 816319998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703286828,
    "dropsitcph": 9703286828,
    "dropfax": 9703287396
  },
  {
    "dcode": "D",
    "dropkey": "PZ11337",
    "droptype": "D",
    "dropname": "EASTLAKE",
    "dropdeladd": "12470 YORK ST",
    "dropdelcty": "EASTLAKE",
    "dropdelst": "CO",
    "dropdelzpp": 806149990,
    "dropphyadd": "12470 YORK ST",
    "dropphycty": "EASTLAKE",
    "dropphyst": "CO",
    "dropphyzpp": 806149990,
    "dropmaladd": "12470 YORK ST",
    "dropmalcty": "EASTLAKE",
    "dropmalst": "CO",
    "dropmalzpp": 806149990,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032527112,
    "dropsitcph": 3032527112,
    "dropfax": 3032527320
  },
  {
    "dcode": "D",
    "dropkey": "PZ11340",
    "droptype": "D",
    "dropname": "EATON",
    "dropdeladd": "125 2ND ST",
    "dropdelcty": "EATON",
    "dropdelst": "CO",
    "dropdelzpp": 806159998,
    "dropphyadd": "125 2ND ST",
    "dropphycty": "EATON",
    "dropphyst": "CO",
    "dropphyzpp": 806159998,
    "dropmaladd": "125 2ND ST",
    "dropmalcty": "EATON",
    "dropmalst": "CO",
    "dropmalzpp": 806159998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704542286,
    "dropsitcph": 9704543238,
    "dropfax": 9704542411
  },
  {
    "dcode": "D",
    "dropkey": "PZ11341",
    "droptype": "D",
    "dropname": "ECKERT",
    "dropdeladd": "12570 HIGHWAY 65",
    "dropdelcty": "ECKERT",
    "dropdelst": "CO",
    "dropdelzpp": 814189900,
    "dropphyadd": "12570 HIGHWAY 65",
    "dropphycty": "ECKERT",
    "dropphyst": "CO",
    "dropphyzpp": 814189900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ECKERT",
    "dropmalst": "CO",
    "dropmalzpp": 814189998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708359406,
    "dropsitcph": 9708359406,
    "dropfax": 9708359409
  },
  {
    "dcode": "D",
    "dropkey": "PZ11342",
    "droptype": "D",
    "dropname": "ECKLEY",
    "dropdeladd": "115 N MAIN ST",
    "dropdelcty": "ECKLEY",
    "dropdelst": "CO",
    "dropdelzpp": 807279998,
    "dropphyadd": "115 N MAIN ST",
    "dropphycty": "ECKLEY",
    "dropphyst": "CO",
    "dropphyzpp": 807279998,
    "dropmaladd": "115 N MAIN ST",
    "dropmalcty": "ECKLEY",
    "dropmalst": "CO",
    "dropmalzpp": 807279998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703592249,
    "dropsitcph": 9703592249,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11347",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "105 EDWARDS VILLAGE BLVD UNIT A101",
    "dropdelcty": "EDWARDS",
    "dropdelst": "CO",
    "dropdelzpp": 816329998,
    "dropphyadd": "105 EDWARDS VILLAGE BLVD UNIT A101",
    "dropphycty": "EDWARDS",
    "dropphyst": "CO",
    "dropphyzpp": 816329998,
    "dropmaladd": "105 EDWARDS VILLAGE BLVD UNIT A101",
    "dropmalcty": "EDWARDS",
    "dropmalst": "CO",
    "dropmalzpp": 816329998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709263827,
    "dropsitcph": 9709263827,
    "dropfax": 9709263830
  },
  {
    "dcode": "D",
    "dropkey": "PZ11348",
    "droptype": "D",
    "dropname": "EGNAR",
    "dropdeladd": "8715 HIGHWAY 141",
    "dropdelcty": "EGNAR",
    "dropdelst": "CO",
    "dropdelzpp": 813259997,
    "dropphyadd": "8715 HIGHWAY 141",
    "dropphycty": "EGNAR",
    "dropphyst": "CO",
    "dropphyzpp": 813259997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EGNAR",
    "dropmalst": "CO",
    "dropmalzpp": 813259998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706772638,
    "dropsitcph": 9706772638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11353",
    "droptype": "D",
    "dropname": "ELBERT",
    "dropdeladd": "24150 ELBERT ST",
    "dropdelcty": "ELBERT",
    "dropdelst": "CO",
    "dropdelzpp": 801069135,
    "dropphyadd": "24150 ELBERT ST",
    "dropphycty": "ELBERT",
    "dropphyst": "CO",
    "dropphyzpp": 801069135,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBERT",
    "dropmalst": "CO",
    "dropmalzpp": 801069998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036483231,
    "dropsitcph": 3036483231,
    "dropfax": 3036489033
  },
  {
    "dcode": "D",
    "dropkey": "PZ11354",
    "droptype": "D",
    "dropname": "ELDORADO SPRINGS",
    "dropdeladd": "3330 ELDORADO SPRINGS DR",
    "dropdelcty": "ELDORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 800259900,
    "dropphyadd": "3330 ELDORADO SPRINGS DR",
    "dropphycty": "ELDORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 800259900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELDORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 800259998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034943752,
    "dropsitcph": 3034943752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11355",
    "droptype": "D",
    "dropname": "ELIZABETH",
    "dropdeladd": "795 E KIOWA AVE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "CO",
    "dropdelzpp": 801074109,
    "dropphyadd": "795 E KIOWA AVE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "CO",
    "dropphyzpp": 801074109,
    "dropmaladd": "795 E KIOWA AVE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "CO",
    "dropmalzpp": 801074109,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036463805,
    "dropsitcph": 3036463805,
    "dropfax": 3036464710
  },
  {
    "dcode": "D",
    "dropkey": "PZ11360",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "215 W PARK AVE",
    "dropdelcty": "EMPIRE",
    "dropdelst": "CO",
    "dropdelzpp": 804389997,
    "dropphyadd": "215 W PARK AVE",
    "dropphycty": "EMPIRE",
    "dropphyst": "CO",
    "dropphyzpp": 804389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMPIRE",
    "dropmalst": "CO",
    "dropmalzpp": 804389998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035692908,
    "dropsitcph": 3035692908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11361",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "915 W LEHIGH AVE",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 801109998,
    "dropphyadd": "915 W LEHIGH AVE",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 801109998,
    "dropmaladd": "915 W LEHIGH AVE",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 801109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037612689,
    "dropsitcph": 3038068863,
    "dropfax": 3037891104
  },
  {
    "dcode": "D",
    "dropkey": "PZ11363",
    "droptype": "D",
    "dropname": "ERIE",
    "dropdeladd": "150 WELLS ST",
    "dropdelcty": "ERIE",
    "dropdelst": "CO",
    "dropdelzpp": 805169997,
    "dropphyadd": "150 WELLS ST",
    "dropphycty": "ERIE",
    "dropphyst": "CO",
    "dropphyzpp": 805169997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ERIE",
    "dropmalst": "CO",
    "dropmalzpp": 805169998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038280781,
    "dropsitcph": 3038280781,
    "dropfax": 3038289003
  },
  {
    "dcode": "D",
    "dropkey": "PZ11365",
    "droptype": "D",
    "dropname": "ESTES PARK",
    "dropdeladd": "215 W RIVERSIDE DR",
    "dropdelcty": "ESTES PARK",
    "dropdelst": "CO",
    "dropdelzpp": 805179997,
    "dropphyadd": "215 W RIVERSIDE DR",
    "dropphycty": "ESTES PARK",
    "dropphyst": "CO",
    "dropphyzpp": 805179997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESTES PARK",
    "dropmalst": "CO",
    "dropmalzpp": 805179998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705860166,
    "dropsitcph": 9705860170,
    "dropfax": 9705862544
  },
  {
    "dcode": "D",
    "dropkey": "PZ11367",
    "droptype": "D",
    "dropname": "EVANS",
    "dropdeladd": "3344 11TH AVE",
    "dropdelcty": "EVANS",
    "dropdelst": "CO",
    "dropdelzpp": 806209998,
    "dropphyadd": "3344 11TH AVE",
    "dropphycty": "EVANS",
    "dropphyst": "CO",
    "dropphyzpp": 806209998,
    "dropmaladd": "3344 11TH AVE",
    "dropmalcty": "EVANS",
    "dropmalst": "CO",
    "dropmalzpp": 806209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703242087,
    "dropsitcph": 9703398293,
    "dropfax": 9703308190
  },
  {
    "dcode": "D",
    "dropkey": "PZ11368",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "3649 EVERGREEN PKWY",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "CO",
    "dropdelzpp": 804399998,
    "dropphyadd": "3649 EVERGREEN PKWY",
    "dropphycty": "EVERGREEN",
    "dropphyst": "CO",
    "dropphyzpp": 804399998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "CO",
    "dropmalzpp": 804379998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036799863,
    "dropsitcph": 3036799861,
    "dropfax": 3036747526
  },
  {
    "dcode": "D",
    "dropkey": "PZ11372",
    "droptype": "D",
    "dropname": "FAIRPLAY",
    "dropdeladd": "517 HATHAWAY ST",
    "dropdelcty": "FAIRPLAY",
    "dropdelst": "CO",
    "dropdelzpp": 804409905,
    "dropphyadd": "517 HATHAWAY ST",
    "dropphycty": "FAIRPLAY",
    "dropphyst": "CO",
    "dropphyzpp": 804409905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRPLAY",
    "dropmalst": "CO",
    "dropmalzpp": 804409998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7198362423,
    "dropsitcph": 7198362423,
    "dropfax": 7198360581
  },
  {
    "dcode": "D",
    "dropkey": "PZ11383",
    "droptype": "D",
    "dropname": "FIRESTONE",
    "dropdeladd": "478 1ST ST",
    "dropdelcty": "FIRESTONE",
    "dropdelst": "CO",
    "dropdelzpp": 805209997,
    "dropphyadd": "478 1ST ST",
    "dropphycty": "FIRESTONE",
    "dropphyst": "CO",
    "dropphyzpp": 805209997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FIRESTONE",
    "dropmalst": "CO",
    "dropmalzpp": 805209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038332412,
    "dropsitcph": 3038332412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11390",
    "droptype": "D",
    "dropname": "FLAGLER",
    "dropdeladd": "315 MAIN AVE",
    "dropdelcty": "FLAGLER",
    "dropdelst": "CO",
    "dropdelzpp": 808159237,
    "dropphyadd": "315 MAIN AVE",
    "dropphycty": "FLAGLER",
    "dropphyst": "CO",
    "dropphyzpp": 808159237,
    "dropmaladd": "315 MAIN AVE",
    "dropmalcty": "FLAGLER",
    "dropmalst": "CO",
    "dropmalzpp": 808159237,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197654815,
    "dropsitcph": 7197654815,
    "dropfax": 7197654578
  },
  {
    "dcode": "D",
    "dropkey": "PZ11391",
    "droptype": "D",
    "dropname": "FLEMING",
    "dropdeladd": "203 N LOGAN AVE",
    "dropdelcty": "FLEMING",
    "dropdelst": "CO",
    "dropdelzpp": 807289998,
    "dropphyadd": "203 N LOGAN AVE",
    "dropphycty": "FLEMING",
    "dropphyst": "CO",
    "dropphyzpp": 807289998,
    "dropmaladd": "203 N LOGAN AVE",
    "dropmalcty": "FLEMING",
    "dropmalst": "CO",
    "dropmalzpp": 807289998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702654111,
    "dropsitcph": 9702654111,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11393",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "121 N PIKES PEAK AVE",
    "dropdelcty": "FLORENCE",
    "dropdelst": "CO",
    "dropdelzpp": 812261558,
    "dropphyadd": "121 N PIKES PEAK AVE",
    "dropphycty": "FLORENCE",
    "dropphyst": "CO",
    "dropphyzpp": 812261558,
    "dropmaladd": "121 N PIKES PEAK AVE",
    "dropmalcty": "FLORENCE",
    "dropmalst": "CO",
    "dropmalzpp": 812261558,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197843818,
    "dropsitcph": 7197843818,
    "dropfax": 7197849144
  },
  {
    "dcode": "D",
    "dropkey": "PZ11395",
    "droptype": "D",
    "dropname": "FLORISSANT",
    "dropdeladd": "18101 COUNTY ROAD 1",
    "dropdelcty": "FLORISSANT",
    "dropdelst": "CO",
    "dropdelzpp": 808169604,
    "dropphyadd": "18101 COUNTY ROAD 1",
    "dropphycty": "FLORISSANT",
    "dropphyst": "CO",
    "dropphyzpp": 808169604,
    "dropmaladd": "18101 COUNTY ROAD 1",
    "dropmalcty": "FLORISSANT",
    "dropmalst": "CO",
    "dropmalzpp": 808169604,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197483891,
    "dropsitcph": 7197483891,
    "dropfax": 7197488122
  },
  {
    "dcode": "D",
    "dropkey": "PZ11402",
    "droptype": "D",
    "dropname": "FORT COLLINS",
    "dropdeladd": "301 BOARDWALK DR",
    "dropdelcty": "FORT COLLINS",
    "dropdelst": "CO",
    "dropdelzpp": 805259998,
    "dropphyadd": "301 BOARDWALK DR",
    "dropphycty": "FORT COLLINS",
    "dropphyst": "CO",
    "dropphyzpp": 805259998,
    "dropmaladd": "301 BOARDWALK DR",
    "dropmalcty": "FORT COLLINS",
    "dropmalst": "CO",
    "dropmalzpp": 805259998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702254155,
    "dropsitcph": 9702254100,
    "dropfax": 9702254139
  },
  {
    "dcode": "D",
    "dropkey": "PZ11403",
    "droptype": "D",
    "dropname": "FORT GARLAND",
    "dropdeladd": "313 HIGHWAY 159",
    "dropdelcty": "FORT GARLAND",
    "dropdelst": "CO",
    "dropdelzpp": 811339990,
    "dropphyadd": "313 HIGHWAY 159",
    "dropphycty": "FORT GARLAND",
    "dropphyst": "CO",
    "dropphyzpp": 811339990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT GARLAND",
    "dropmalst": "CO",
    "dropmalzpp": 811339998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193793481,
    "dropsitcph": 7193793481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11405",
    "droptype": "D",
    "dropname": "FORT LUPTON",
    "dropdeladd": "533 4TH ST",
    "dropdelcty": "FORT LUPTON",
    "dropdelst": "CO",
    "dropdelzpp": 806219998,
    "dropphyadd": "533 4TH ST",
    "dropphycty": "FORT LUPTON",
    "dropphyst": "CO",
    "dropphyzpp": 806219998,
    "dropmaladd": "533 4TH ST",
    "dropmalcty": "FORT LUPTON",
    "dropmalst": "CO",
    "dropmalzpp": 806219998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038574734,
    "dropsitcph": 3038572019,
    "dropfax": 3038574127
  },
  {
    "dcode": "D",
    "dropkey": "PZ11407",
    "droptype": "D",
    "dropname": "FORT MORGAN",
    "dropdeladd": "300 STATE ST",
    "dropdelcty": "FORT MORGAN",
    "dropdelst": "CO",
    "dropdelzpp": 807019998,
    "dropphyadd": "300 STATE ST",
    "dropphycty": "FORT MORGAN",
    "dropphyst": "CO",
    "dropphyzpp": 807019998,
    "dropmaladd": "300 STATE ST",
    "dropmalcty": "FORT MORGAN",
    "dropmalst": "CO",
    "dropmalzpp": 807019998,
    "dropsitphn": 9708677111,
    "dropsitlph": 9708677111,
    "dropsitcph": 9708677111,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11409",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "101 S SANTA FE AVE",
    "dropdelcty": "FOUNTAIN",
    "dropdelst": "CO",
    "dropdelzpp": 808171920,
    "dropphyadd": "101 S SANTA FE AVE",
    "dropphycty": "FOUNTAIN",
    "dropphyst": "CO",
    "dropphyzpp": 808171920,
    "dropmaladd": "101 S SANTA FE AVE",
    "dropmalcty": "FOUNTAIN",
    "dropmalst": "CO",
    "dropmalzpp": 808171920,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193824625,
    "dropsitcph": 7193824623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11410",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "34191 COUNTY ROAD 3.5 STE B",
    "dropdelcty": "FOWLER",
    "dropdelst": "CO",
    "dropdelzpp": 810399778,
    "dropphyadd": "34191 COUNTY ROAD 3.5 STE B",
    "dropphycty": "FOWLER",
    "dropphyst": "CO",
    "dropphyzpp": 810399778,
    "dropmaladd": "34191 COUNTY ROAD 3.5 STE B",
    "dropmalcty": "FOWLER",
    "dropmalst": "CO",
    "dropmalzpp": 810399778,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192635260,
    "dropsitcph": 7192635260,
    "dropfax": 7192634109
  },
  {
    "dcode": "D",
    "dropkey": "PZ11413",
    "droptype": "D",
    "dropname": "FRANKTOWN",
    "dropdeladd": "7519 E STATE HIGHWAY 86",
    "dropdelcty": "FRANKTOWN",
    "dropdelst": "CO",
    "dropdelzpp": 801168913,
    "dropphyadd": "7519 E STATE HIGHWAY 86",
    "dropphycty": "FRANKTOWN",
    "dropphyst": "CO",
    "dropphyzpp": 801168913,
    "dropmaladd": "7519 E STATE HIGHWAY 86",
    "dropmalcty": "FRANKTOWN",
    "dropmalst": "CO",
    "dropmalzpp": 801168913,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036631245,
    "dropsitcph": 3036631245,
    "dropfax": 3036885695
  },
  {
    "dcode": "D",
    "dropkey": "PZ11414",
    "droptype": "D",
    "dropname": "FRASER",
    "dropdeladd": "520 ZEREX ST",
    "dropdelcty": "FRASER",
    "dropdelst": "CO",
    "dropdelzpp": 804429997,
    "dropphyadd": "520 ZEREX ST",
    "dropphycty": "FRASER",
    "dropphyst": "CO",
    "dropphyzpp": 804429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRASER",
    "dropmalst": "CO",
    "dropmalzpp": 804429998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707265578,
    "dropsitcph": 9707265578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11415",
    "droptype": "D",
    "dropname": "FREDERICK",
    "dropdeladd": "411 OAK ST",
    "dropdelcty": "FREDERICK",
    "dropdelst": "CO",
    "dropdelzpp": 805309997,
    "dropphyadd": "411 OAK ST",
    "dropphycty": "FREDERICK",
    "dropphyst": "CO",
    "dropphyzpp": 805309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREDERICK",
    "dropmalst": "CO",
    "dropmalzpp": 805309998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038332581,
    "dropsitcph": 3038332581,
    "dropfax": 3038334138
  },
  {
    "dcode": "D",
    "dropkey": "PZ11417",
    "droptype": "D",
    "dropname": "FRISCO",
    "dropdeladd": "35 W MAIN ST",
    "dropdelcty": "FRISCO",
    "dropdelst": "CO",
    "dropdelzpp": 804439997,
    "dropphyadd": "35 W MAIN ST",
    "dropphycty": "FRISCO",
    "dropphyst": "CO",
    "dropphyzpp": 804439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRISCO",
    "dropmalst": "CO",
    "dropmalzpp": 804439998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706682089,
    "dropsitcph": 9706680610,
    "dropfax": 9706688066
  },
  {
    "dcode": "D",
    "dropkey": "PZ11418",
    "droptype": "D",
    "dropname": "FRUITA",
    "dropdeladd": "113 N PARK SQ",
    "dropdelcty": "FRUITA",
    "dropdelst": "CO",
    "dropdelzpp": 815219998,
    "dropphyadd": "113 N PARK SQ",
    "dropphycty": "FRUITA",
    "dropphyst": "CO",
    "dropphyzpp": 815212555,
    "dropmaladd": "113 N PARK SQ",
    "dropmalcty": "FRUITA",
    "dropmalst": "CO",
    "dropmalzpp": 815212555,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708587715,
    "dropsitcph": 9708587715,
    "dropfax": 9708589560
  },
  {
    "dcode": "D",
    "dropkey": "PZ11427",
    "droptype": "D",
    "dropname": "GALETON",
    "dropdeladd": "24830 1ST ST",
    "dropdelcty": "GALETON",
    "dropdelst": "CO",
    "dropdelzpp": 806229990,
    "dropphyadd": "24830 1ST ST",
    "dropphycty": "GALETON",
    "dropphyst": "CO",
    "dropphyzpp": 806229990,
    "dropmaladd": "24830 1ST ST",
    "dropmalcty": "GALETON",
    "dropmalst": "CO",
    "dropmalzpp": 806229990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704541413,
    "dropsitcph": 9704541413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11431",
    "droptype": "D",
    "dropname": "GARDNER",
    "dropdeladd": "25336 STATE HIGHWAY 69 UNIT A",
    "dropdelcty": "GARDNER",
    "dropdelst": "CO",
    "dropdelzpp": 810409792,
    "dropphyadd": "25336 STATE HIGHWAY 69 UNIT A",
    "dropphycty": "GARDNER",
    "dropphyst": "CO",
    "dropphyzpp": 810409792,
    "dropmaladd": "25336 STATE HIGHWAY 69 UNIT A",
    "dropmalcty": "GARDNER",
    "dropmalst": "CO",
    "dropmalzpp": 810409792,
    "dropsitphn": 7197385762,
    "dropsitlph": 7197462925,
    "dropsitcph": 7197462925,
    "dropfax": 7197462925
  },
  {
    "dcode": "D",
    "dropkey": "PZ11434",
    "droptype": "D",
    "dropname": "GATEWAY",
    "dropdeladd": "42700 HIGHWAY 141",
    "dropdelcty": "GATEWAY",
    "dropdelst": "CO",
    "dropdelzpp": 815229997,
    "dropphyadd": "42700 HIGHWAY 141",
    "dropphycty": "GATEWAY",
    "dropphyst": "CO",
    "dropphyzpp": 815229997,
    "dropmaladd": "42700 HIGHWAY 141",
    "dropmalcty": "GATEWAY",
    "dropmalst": "CO",
    "dropmalzpp": 815229997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709312255,
    "dropsitcph": 9709312255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11437",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "217 MAIN ST",
    "dropdelcty": "GENOA",
    "dropdelst": "CO",
    "dropdelzpp": 808189706,
    "dropphyadd": "217 MAIN ST",
    "dropphycty": "GENOA",
    "dropphyst": "CO",
    "dropphyzpp": 808189706,
    "dropmaladd": "217 MAIN ST",
    "dropmalcty": "GENOA",
    "dropmalst": "CO",
    "dropmalzpp": 808189706,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197632264,
    "dropsitcph": 7197632264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11438",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "700 6TH ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "CO",
    "dropdelzpp": 804449997,
    "dropphyadd": "700 6TH ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "CO",
    "dropphyzpp": 804449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "CO",
    "dropmalzpp": 804449998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035602771,
    "dropsitcph": 3035692771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11439",
    "droptype": "D",
    "dropname": "GILCREST",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "GILCREST",
    "dropdelst": "CO",
    "dropdelzpp": 806239990,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "GILCREST",
    "dropphyst": "CO",
    "dropphyzpp": 806239990,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "GILCREST",
    "dropmalst": "CO",
    "dropmalzpp": 806239990,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037372934,
    "dropsitcph": 9707372934,
    "dropfax": 9707372519
  },
  {
    "dcode": "D",
    "dropkey": "PZ11440",
    "droptype": "D",
    "dropname": "GILL",
    "dropdeladd": "31302 3RD ST",
    "dropdelcty": "GILL",
    "dropdelst": "CO",
    "dropdelzpp": 806249990,
    "dropphyadd": "31302 3RD ST",
    "dropphycty": "GILL",
    "dropphyst": "CO",
    "dropphyzpp": 806249990,
    "dropmaladd": "31302 3RD ST",
    "dropmalcty": "GILL",
    "dropmalst": "CO",
    "dropmalzpp": 806249990,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703524738,
    "dropsitcph": 9703524738,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11443",
    "droptype": "D",
    "dropname": "GLEN HAVEN",
    "dropdeladd": "7320 COUNTY ROAD 43",
    "dropdelcty": "GLEN HAVEN",
    "dropdelst": "CO",
    "dropdelzpp": 805329997,
    "dropphyadd": "7320 COUNTY ROAD 43",
    "dropphycty": "GLEN HAVEN",
    "dropphyst": "CO",
    "dropphyzpp": 805329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLEN HAVEN",
    "dropmalst": "CO",
    "dropmalzpp": 805329998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705862218,
    "dropsitcph": 9705862218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11447",
    "droptype": "D",
    "dropname": "GLENWOOD SPRINGS",
    "dropdeladd": "113 9TH ST",
    "dropdelcty": "GLENWOOD SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 816019998,
    "dropphyadd": "113 9TH ST",
    "dropphycty": "GLENWOOD SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 816019998,
    "dropmaladd": "113 9TH ST",
    "dropmalcty": "GLENWOOD SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 816019998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704043034,
    "dropsitcph": 9709452701,
    "dropfax": 9709280959
  },
  {
    "dcode": "D",
    "dropkey": "PZ11449",
    "droptype": "D",
    "dropname": "GOLDEN",
    "dropdeladd": "1100 JOHNSON RD",
    "dropdelcty": "GOLDEN",
    "dropdelst": "CO",
    "dropdelzpp": 804019998,
    "dropphyadd": "1100 JOHNSON RD",
    "dropphycty": "GOLDEN",
    "dropphyst": "CO",
    "dropphyzpp": 804019998,
    "dropmaladd": "1100 JOHNSON RD",
    "dropmalcty": "GOLDEN",
    "dropmalst": "CO",
    "dropmalzpp": 804019998,
    "dropsitphn": 3034458900,
    "dropsitlph": 3034458900,
    "dropsitcph": 3034458900,
    "dropfax": 3034458954
  },
  {
    "dcode": "D",
    "dropkey": "PZ11452",
    "droptype": "D",
    "dropname": "GRANADA",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "GRANADA",
    "dropdelst": "CO",
    "dropdelzpp": 810419900,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "GRANADA",
    "dropphyst": "CO",
    "dropphyzpp": 810419900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANADA",
    "dropmalst": "CO",
    "dropmalzpp": 810419998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197345358,
    "dropsitcph": 7197345358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11453",
    "droptype": "D",
    "dropname": "GRANBY",
    "dropdeladd": "54 ZERO ST",
    "dropdelcty": "GRANBY",
    "dropdelst": "CO",
    "dropdelzpp": 804469990,
    "dropphyadd": "54 ZERO ST",
    "dropphycty": "GRANBY",
    "dropphyst": "CO",
    "dropphyzpp": 804469990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANBY",
    "dropmalst": "CO",
    "dropmalzpp": 804469998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708873612,
    "dropsitcph": 9708873612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11456",
    "droptype": "D",
    "dropname": "GRAND JUNCTION",
    "dropdeladd": "241 N 4TH ST",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "CO",
    "dropdelzpp": 815019998,
    "dropphyadd": "241 N 4TH ST",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "CO",
    "dropphyzpp": 815019998,
    "dropmaladd": "241 N 4TH ST",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "CO",
    "dropmalzpp": 815019998,
    "dropsitphn": 9702443436,
    "dropsitlph": 9702443436,
    "dropsitcph": 9702443434,
    "dropfax": 9702443499
  },
  {
    "dcode": "D",
    "dropkey": "PZ11458",
    "droptype": "D",
    "dropname": "GRAND LAKE",
    "dropdeladd": "520 CENTER DR",
    "dropdelcty": "GRAND LAKE",
    "dropdelst": "CO",
    "dropdelzpp": 804479998,
    "dropphyadd": "520 CENTER DR",
    "dropphycty": "GRAND LAKE",
    "dropphyst": "CO",
    "dropphyzpp": 804479998,
    "dropmaladd": "520 CENTER DR",
    "dropmalcty": "GRAND LAKE",
    "dropmalst": "CO",
    "dropmalzpp": 804479998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706273340,
    "dropsitcph": 9706273340,
    "dropfax": 9706270544
  },
  {
    "dcode": "D",
    "dropkey": "PZ11464",
    "droptype": "D",
    "dropname": "GREELEY",
    "dropdeladd": "930 39TH AVE",
    "dropdelcty": "GREELEY",
    "dropdelst": "CO",
    "dropdelzpp": 806349998,
    "dropphyadd": "930 39TH AVE",
    "dropphycty": "GREELEY",
    "dropphyst": "CO",
    "dropphyzpp": 806349998,
    "dropmaladd": "930 39TH AVE",
    "dropmalcty": "GREELEY",
    "dropmalst": "CO",
    "dropmalzpp": 806349998,
    "dropsitphn": 9703537758,
    "dropsitlph": 9703920298,
    "dropsitcph": 9703920298,
    "dropfax": 9703920417
  },
  {
    "dcode": "D",
    "dropkey": "PZ11466",
    "droptype": "D",
    "dropname": "GREEN MOUNTAIN FALLS",
    "dropdeladd": "10560 UTE PASS AVE",
    "dropdelcty": "GREEN MOUNTAIN FALLS",
    "dropdelst": "CO",
    "dropdelzpp": 808199902,
    "dropphyadd": "10560 UTE PASS AVE",
    "dropphycty": "GREEN MOUNTAIN FALLS",
    "dropphyst": "CO",
    "dropphyzpp": 808199902,
    "dropmaladd": "10560 UTE PASS AVE",
    "dropmalcty": "GREEN MOUNTAIN FALLS",
    "dropmalst": "CO",
    "dropmalzpp": 808199902,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196849185,
    "dropsitcph": 7196849185,
    "dropfax": 7196848124
  },
  {
    "dcode": "D",
    "dropkey": "PZ11472",
    "droptype": "D",
    "dropname": "GROVER",
    "dropdeladd": "303 CHATOGA ST",
    "dropdelcty": "GROVER",
    "dropdelst": "CO",
    "dropdelzpp": 807299998,
    "dropphyadd": "303 CHATOGA ST",
    "dropphycty": "GROVER",
    "dropphyst": "CO",
    "dropphyzpp": 807299998,
    "dropmaladd": "303 CHATOGA ST",
    "dropmalcty": "GROVER",
    "dropmalst": "CO",
    "dropmalzpp": 807299998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708952219,
    "dropsitcph": 9708952219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11475",
    "droptype": "D",
    "dropname": "GUFFEY",
    "dropdeladd": "1517 CANYON ST",
    "dropdelcty": "GUFFEY",
    "dropdelst": "CO",
    "dropdelzpp": 808209506,
    "dropphyadd": "1517 CANYON ST",
    "dropphycty": "GUFFEY",
    "dropphyst": "CO",
    "dropphyzpp": 808209506,
    "dropmaladd": "1517 CANYON ST",
    "dropmalcty": "GUFFEY",
    "dropmalst": "CO",
    "dropmalzpp": 808209506,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196892062,
    "dropsitcph": 7196892062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11477",
    "droptype": "D",
    "dropname": "GUNNISON",
    "dropdeladd": "200 N WISCONSIN ST",
    "dropdelcty": "GUNNISON",
    "dropdelst": "CO",
    "dropdelzpp": 812302626,
    "dropphyadd": "200 N WISCONSIN ST",
    "dropphycty": "GUNNISON",
    "dropphyst": "CO",
    "dropphyzpp": 812302626,
    "dropmaladd": "200 N WISCONSIN ST",
    "dropmalcty": "GUNNISON",
    "dropmalst": "CO",
    "dropmalzpp": 812302626,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706411884,
    "dropsitcph": 9706411884,
    "dropfax": 9706411843
  },
  {
    "dcode": "D",
    "dropkey": "PZ11478",
    "droptype": "D",
    "dropname": "GYPSUM",
    "dropdeladd": "100 OAKRIDGE CT",
    "dropdelcty": "GYPSUM",
    "dropdelst": "CO",
    "dropdelzpp": 816379997,
    "dropphyadd": "100 OAKRIDGE CT",
    "dropphycty": "GYPSUM",
    "dropphyst": "CO",
    "dropphyzpp": 816379997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GYPSUM",
    "dropmalst": "CO",
    "dropmalzpp": 816379998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705249686,
    "dropsitcph": 9705249686,
    "dropfax": 9705247658
  },
  {
    "dcode": "D",
    "dropkey": "PZ11480",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "17436 S HIGHWAY 13",
    "dropdelcty": "HAMILTON",
    "dropdelst": "CO",
    "dropdelzpp": 816389997,
    "dropphyadd": "17436 S HIGHWAY 13",
    "dropphycty": "HAMILTON",
    "dropphyst": "CO",
    "dropphyzpp": 816389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMILTON",
    "dropmalst": "CO",
    "dropmalzpp": 816389998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708247044,
    "dropsitcph": 9708247044,
    "dropfax": 9708260224
  },
  {
    "dcode": "D",
    "dropkey": "PZ11481",
    "droptype": "D",
    "dropname": "HARTMAN",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "HARTMAN",
    "dropdelst": "CO",
    "dropdelzpp": 810439901,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "HARTMAN",
    "dropphyst": "CO",
    "dropphyzpp": 810439901,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "HARTMAN",
    "dropmalst": "CO",
    "dropmalzpp": 810439901,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197394336,
    "dropsitcph": 7197394336,
    "dropfax": 7197394336
  },
  {
    "dcode": "D",
    "dropkey": "PZ11483",
    "droptype": "D",
    "dropname": "HARTSEL",
    "dropdeladd": "88 MARIPOSA ST",
    "dropdelcty": "HARTSEL",
    "dropdelst": "CO",
    "dropdelzpp": 804499990,
    "dropphyadd": "88 MARIPOSA ST",
    "dropphycty": "HARTSEL",
    "dropphyst": "CO",
    "dropphyzpp": 804499990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARTSEL",
    "dropmalst": "CO",
    "dropmalzpp": 804499998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7193985418,
    "dropsitcph": 7193985418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11484",
    "droptype": "D",
    "dropname": "HASTY",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "HASTY",
    "dropdelst": "CO",
    "dropdelzpp": 810449900,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "HASTY",
    "dropphyst": "CO",
    "dropphyzpp": 810449900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HASTY",
    "dropmalst": "CO",
    "dropmalzpp": 810449998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198294356,
    "dropsitcph": 7198294356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11485",
    "droptype": "D",
    "dropname": "HASWELL",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "HASWELL",
    "dropdelst": "CO",
    "dropdelzpp": 810459998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "HASWELL",
    "dropphyst": "CO",
    "dropphyzpp": 810459998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "HASWELL",
    "dropmalst": "CO",
    "dropmalzpp": 810459998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193990635,
    "dropsitcph": 7193990646,
    "dropfax": 7194362331
  },
  {
    "dcode": "D",
    "dropkey": "PZ11487",
    "droptype": "D",
    "dropname": "HAXTUN",
    "dropdeladd": "225 S COLORADO AVE",
    "dropdelcty": "HAXTUN",
    "dropdelst": "CO",
    "dropdelzpp": 807319998,
    "dropphyadd": "225 S COLORADO AVE",
    "dropphycty": "HAXTUN",
    "dropphyst": "CO",
    "dropphyzpp": 807319998,
    "dropmaladd": "225 S COLORADO AVE",
    "dropmalcty": "HAXTUN",
    "dropmalst": "CO",
    "dropmalzpp": 807319998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707746436,
    "dropsitcph": 9707746436,
    "dropfax": 9707743373
  },
  {
    "dcode": "D",
    "dropkey": "PZ11488",
    "droptype": "D",
    "dropname": "HAYDEN",
    "dropdeladd": "850 W JEFFERSON AVE",
    "dropdelcty": "HAYDEN",
    "dropdelst": "CO",
    "dropdelzpp": 816399800,
    "dropphyadd": "850 W JEFFERSON AVE",
    "dropphycty": "HAYDEN",
    "dropphyst": "CO",
    "dropphyzpp": 816399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAYDEN",
    "dropmalst": "CO",
    "dropmalzpp": 816399998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702763204,
    "dropsitcph": 9702763204,
    "dropfax": 9702763347
  },
  {
    "dcode": "D",
    "dropkey": "PZ11490",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "12210 BRIGHTON RD",
    "dropdelcty": "HENDERSON",
    "dropdelst": "CO",
    "dropdelzpp": 806409998,
    "dropphyadd": "12210 BRIGHTON RD",
    "dropphycty": "HENDERSON",
    "dropphyst": "CO",
    "dropphyzpp": 806409998,
    "dropmaladd": "12210 BRIGHTON RD",
    "dropmalcty": "HENDERSON",
    "dropmalst": "CO",
    "dropmalzpp": 806409998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706591612,
    "dropsitcph": 7204397347,
    "dropfax": 3036598441
  },
  {
    "dcode": "D",
    "dropkey": "PZ11492",
    "droptype": "D",
    "dropname": "HEREFORD",
    "dropdeladd": "39590 HEREFORD ST",
    "dropdelcty": "HEREFORD",
    "dropdelst": "CO",
    "dropdelzpp": 807329997,
    "dropphyadd": "39590 HEREFORD ST",
    "dropphycty": "HEREFORD",
    "dropphyst": "CO",
    "dropphyzpp": 807329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HEREFORD",
    "dropmalst": "CO",
    "dropmalzpp": 807329998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038953355,
    "dropsitcph": 9708953355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11494",
    "droptype": "D",
    "dropname": "HESPERUS",
    "dropdeladd": "10864 HIGHWAY 160",
    "dropdelcty": "HESPERUS",
    "dropdelst": "CO",
    "dropdelzpp": 813267808,
    "dropphyadd": "10864 HIGHWAY 160",
    "dropphycty": "HESPERUS",
    "dropphyst": "CO",
    "dropphyzpp": 813267808,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HESPERUS",
    "dropmalst": "CO",
    "dropmalzpp": 813269998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703854393,
    "dropsitcph": 9703854393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11498",
    "droptype": "D",
    "dropname": "HILLROSE",
    "dropdeladd": "315 EMERSON ST",
    "dropdelcty": "HILLROSE",
    "dropdelst": "CO",
    "dropdelzpp": 807339998,
    "dropphyadd": "315 EMERSON ST",
    "dropphycty": "HILLROSE",
    "dropphyst": "CO",
    "dropphyzpp": 807339998,
    "dropmaladd": "315 EMERSON ST",
    "dropmalcty": "HILLROSE",
    "dropmalst": "CO",
    "dropmalzpp": 807339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708473394,
    "dropsitcph": 9708473394,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11500",
    "droptype": "D",
    "dropname": "HOEHNE",
    "dropdeladd": "42607 COUNTY ROAD 40.6",
    "dropdelcty": "HOEHNE",
    "dropdelst": "CO",
    "dropdelzpp": 810469990,
    "dropphyadd": "42607 COUNTY ROAD 40.6",
    "dropphycty": "HOEHNE",
    "dropphyst": "CO",
    "dropphyzpp": 810469990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOEHNE",
    "dropmalst": "CO",
    "dropmalzpp": 810469998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198464821,
    "dropsitcph": 7198464821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11504",
    "droptype": "D",
    "dropname": "HOLLY",
    "dropdeladd": "101 E SANTA FE ST",
    "dropdelcty": "HOLLY",
    "dropdelst": "CO",
    "dropdelzpp": 810479900,
    "dropphyadd": "101 E SANTA FE ST",
    "dropphycty": "HOLLY",
    "dropphyst": "CO",
    "dropphyzpp": 810479900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLLY",
    "dropmalst": "CO",
    "dropmalzpp": 810479998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195376434,
    "dropsitcph": 7195376434,
    "dropfax": 7195370253
  },
  {
    "dcode": "D",
    "dropkey": "PZ11505",
    "droptype": "D",
    "dropname": "HOLYOKE",
    "dropdeladd": "226 S INTEROCEAN AVE",
    "dropdelcty": "HOLYOKE",
    "dropdelst": "CO",
    "dropdelzpp": 807341535,
    "dropphyadd": "226 S INTEROCEAN AVE",
    "dropphycty": "HOLYOKE",
    "dropphyst": "CO",
    "dropphyzpp": 807341535,
    "dropmaladd": "226 S INTEROCEAN AVE",
    "dropmalcty": "HOLYOKE",
    "dropmalst": "CO",
    "dropmalzpp": 807341535,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708543100,
    "dropsitcph": 9708543100,
    "dropfax": 3038543251
  },
  {
    "dcode": "D",
    "dropkey": "PZ11507",
    "droptype": "D",
    "dropname": "HOOPER",
    "dropdeladd": "11701 STATE HIGHWAY 17",
    "dropdelcty": "HOOPER",
    "dropdelst": "CO",
    "dropdelzpp": 811369998,
    "dropphyadd": "11701 STATE HIGHWAY 17",
    "dropphycty": "HOOPER",
    "dropphyst": "CO",
    "dropphyzpp": 811369998,
    "dropmaladd": "11701 STATE HIGHWAY 17",
    "dropmalcty": "HOOPER",
    "dropmalst": "CO",
    "dropmalzpp": 811369998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193782111,
    "dropsitcph": 7193782111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11509",
    "droptype": "D",
    "dropname": "HOT SULPHUR SPRINGS",
    "dropdeladd": "506 GRAND AVE",
    "dropdelcty": "HOT SULPHUR SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 804519997,
    "dropphyadd": "506 GRAND AVE",
    "dropphycty": "HOT SULPHUR SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 804519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOT SULPHUR SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 804519998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707253356,
    "dropsitcph": 9707253356,
    "dropfax": 9707253963
  },
  {
    "dcode": "D",
    "dropkey": "PZ11510",
    "droptype": "D",
    "dropname": "HOTCHKISS",
    "dropdeladd": "103 E BRIDGE ST",
    "dropdelcty": "HOTCHKISS",
    "dropdelst": "CO",
    "dropdelzpp": 814199800,
    "dropphyadd": "103 E BRIDGE ST",
    "dropphycty": "HOTCHKISS",
    "dropphyst": "CO",
    "dropphyzpp": 814199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOTCHKISS",
    "dropmalst": "CO",
    "dropmalzpp": 814199998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708723135,
    "dropsitcph": 9708723135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11512",
    "droptype": "D",
    "dropname": "HOWARD",
    "dropdeladd": "9232 US HIGHWAY 50",
    "dropdelcty": "HOWARD",
    "dropdelst": "CO",
    "dropdelzpp": 812339990,
    "dropphyadd": "9232 US HIGHWAY 50",
    "dropphycty": "HOWARD",
    "dropphyst": "CO",
    "dropphyzpp": 812339990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOWARD",
    "dropmalst": "CO",
    "dropmalzpp": 812339998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199423465,
    "dropsitcph": 7199423465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11514",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "738 CEDAR ST",
    "dropdelcty": "HUDSON",
    "dropdelst": "CO",
    "dropdelzpp": 806429997,
    "dropphyadd": "738 CEDAR ST",
    "dropphycty": "HUDSON",
    "dropphyst": "CO",
    "dropphyzpp": 806429997,
    "dropmaladd": "738 CEDAR ST",
    "dropmalcty": "HUDSON",
    "dropmalst": "CO",
    "dropmalzpp": 806429997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035364775,
    "dropsitcph": 3035364775,
    "dropfax": 3035369712
  },
  {
    "dcode": "D",
    "dropkey": "PZ11515",
    "droptype": "D",
    "dropname": "HUGO",
    "dropdeladd": "422 4TH AVE",
    "dropdelcty": "HUGO",
    "dropdelst": "CO",
    "dropdelzpp": 808219012,
    "dropphyadd": "422 4TH AVE",
    "dropphycty": "HUGO",
    "dropphyst": "CO",
    "dropphyzpp": 808219012,
    "dropmaladd": "422 4TH AVE",
    "dropmalcty": "HUGO",
    "dropmalst": "CO",
    "dropmalzpp": 808219012,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197432684,
    "dropsitcph": 7197432684,
    "dropfax": 7197432138
  },
  {
    "dcode": "D",
    "dropkey": "PZ11516",
    "droptype": "D",
    "dropname": "HYGIENE",
    "dropdeladd": "11830 N 75TH ST",
    "dropdelcty": "HYGIENE",
    "dropdelst": "CO",
    "dropdelzpp": 805339997,
    "dropphyadd": "11830 N 75TH ST",
    "dropphycty": "HYGIENE",
    "dropphyst": "CO",
    "dropphyzpp": 805339997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYGIENE",
    "dropmalst": "CO",
    "dropmalzpp": 805339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037761605,
    "dropsitcph": 3037761605,
    "dropfax": 3037766306
  },
  {
    "dcode": "D",
    "dropkey": "PZ11518",
    "droptype": "D",
    "dropname": "IDAHO SPRINGS",
    "dropdeladd": "2420 COLORADO BLVD",
    "dropdelcty": "IDAHO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 804529903,
    "dropphyadd": "2420 COLORADO BLVD",
    "dropphycty": "IDAHO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 804529903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IDAHO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 804529998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035679719,
    "dropsitcph": 3035672903,
    "dropfax": 3035670346
  },
  {
    "dcode": "D",
    "dropkey": "PZ11519",
    "droptype": "D",
    "dropname": "IDALIA",
    "dropdeladd": "9030 COUNTY ROAD CC.8",
    "dropdelcty": "IDALIA",
    "dropdelst": "CO",
    "dropdelzpp": 807359998,
    "dropphyadd": "9030 COUNTY ROAD CC.8",
    "dropphycty": "IDALIA",
    "dropphyst": "CO",
    "dropphyzpp": 807359998,
    "dropmaladd": "9030 COUNTY ROAD CC.8",
    "dropmalcty": "IDALIA",
    "dropmalst": "CO",
    "dropmalzpp": 807359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703547239,
    "dropsitcph": 9705920348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11520",
    "droptype": "D",
    "dropname": "IDLEDALE",
    "dropdeladd": "21659 HIGHWAY 74",
    "dropdelcty": "IDLEDALE",
    "dropdelst": "CO",
    "dropdelzpp": 804539997,
    "dropphyadd": "21659 HIGHWAY 74",
    "dropphycty": "IDLEDALE",
    "dropphyst": "CO",
    "dropphyzpp": 804539997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IDLEDALE",
    "dropmalst": "CO",
    "dropmalzpp": 804539998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036978476,
    "dropsitcph": 3036978476,
    "dropfax": 3036978476
  },
  {
    "dcode": "D",
    "dropkey": "PZ11521",
    "droptype": "D",
    "dropname": "IGNACIO",
    "dropdeladd": "1001 WILLIAMS ST",
    "dropdelcty": "IGNACIO",
    "dropdelst": "CO",
    "dropdelzpp": 811379990,
    "dropphyadd": "1001 WILLIAMS ST",
    "dropphycty": "IGNACIO",
    "dropphyst": "CO",
    "dropphyzpp": 811379990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IGNACIO",
    "dropmalst": "CO",
    "dropmalzpp": 811379998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705634322,
    "dropsitcph": 9705634322,
    "dropfax": 9705639234
  },
  {
    "dcode": "D",
    "dropkey": "PZ11522",
    "droptype": "D",
    "dropname": "ILIFF",
    "dropdeladd": "401 W 3RD AVE",
    "dropdelcty": "ILIFF",
    "dropdelst": "CO",
    "dropdelzpp": 807369998,
    "dropphyadd": "401 W 3RD AVE",
    "dropphycty": "ILIFF",
    "dropphyst": "CO",
    "dropphyzpp": 807369998,
    "dropmaladd": "401 W 3RD AVE",
    "dropmalcty": "ILIFF",
    "dropmalst": "CO",
    "dropmalzpp": 807369998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705224153,
    "dropsitcph": 9705224153,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11526",
    "droptype": "D",
    "dropname": "INDIAN HILLS",
    "dropdeladd": "5491 S PARMALEE GULCH RD",
    "dropdelcty": "INDIAN HILLS",
    "dropdelst": "CO",
    "dropdelzpp": 804549997,
    "dropphyadd": "5491 S PARMALEE GULCH RD",
    "dropphycty": "INDIAN HILLS",
    "dropphyst": "CO",
    "dropphyzpp": 804549997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIAN HILLS",
    "dropmalst": "CO",
    "dropmalzpp": 804549998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036974465,
    "dropsitcph": 3036974465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11533",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "133 MAIN ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "CO",
    "dropdelzpp": 804559997,
    "dropphyadd": "133 MAIN ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "CO",
    "dropphyzpp": 804559997,
    "dropmaladd": "133 MAIN ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "CO",
    "dropmalzpp": 804559997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034420481,
    "dropsitcph": 3034420481,
    "dropfax": 3034490647
  },
  {
    "dcode": "D",
    "dropkey": "PZ11535",
    "droptype": "D",
    "dropname": "JAROSO",
    "dropdeladd": "111 COSTILLA RD",
    "dropdelcty": "JAROSO",
    "dropdelst": "CO",
    "dropdelzpp": 811389990,
    "dropphyadd": "111 COSTILLA RD",
    "dropphycty": "JAROSO",
    "dropphyst": "CO",
    "dropphyzpp": 811389990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAROSO",
    "dropmalst": "CO",
    "dropmalzpp": 811389998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196724269,
    "dropsitcph": 7196724269,
    "dropfax": 7196724269
  },
  {
    "dcode": "D",
    "dropkey": "PZ11538",
    "droptype": "D",
    "dropname": "JOES",
    "dropdeladd": "6461 US HIGHWAY 36",
    "dropdelcty": "JOES",
    "dropdelst": "CO",
    "dropdelzpp": 808229501,
    "dropphyadd": "6461 US HIGHWAY 36",
    "dropphycty": "JOES",
    "dropphyst": "CO",
    "dropphyzpp": 808229501,
    "dropmaladd": "6461 US HIGHWAY 36",
    "dropmalcty": "JOES",
    "dropmalst": "CO",
    "dropmalzpp": 808229501,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703584346,
    "dropsitcph": 9703584346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11541",
    "droptype": "D",
    "dropname": "JOHNSTOWN",
    "dropdeladd": "121 CASTLE PINES AVE",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "CO",
    "dropdelzpp": 805349998,
    "dropphyadd": "121 CASTLE PINES AVE",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "CO",
    "dropphyzpp": 805349998,
    "dropmaladd": "121 CASTLE PINES AVE",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "CO",
    "dropmalzpp": 805349998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705874246,
    "dropsitcph": 9705874246,
    "dropfax": 9705870140
  },
  {
    "dcode": "D",
    "dropkey": "PZ11542",
    "droptype": "D",
    "dropname": "JULESBURG",
    "dropdeladd": "319 PINE ST",
    "dropdelcty": "JULESBURG",
    "dropdelst": "CO",
    "dropdelzpp": 807379998,
    "dropphyadd": "319 PINE ST",
    "dropphycty": "JULESBURG",
    "dropphyst": "CO",
    "dropphyzpp": 807379998,
    "dropmaladd": "319 PINE ST",
    "dropmalcty": "JULESBURG",
    "dropmalst": "CO",
    "dropmalzpp": 807379998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704742640,
    "dropsitcph": 9704742640,
    "dropfax": 9704743671
  },
  {
    "dcode": "D",
    "dropkey": "PZ11543",
    "droptype": "D",
    "dropname": "KARVAL",
    "dropdeladd": "28913 COUNTY RD S",
    "dropdelcty": "KARVAL",
    "dropdelst": "CO",
    "dropdelzpp": 808239407,
    "dropphyadd": "28913 COUNTY RD S",
    "dropphycty": "KARVAL",
    "dropphyst": "CO",
    "dropphyzpp": 808239407,
    "dropmaladd": "28913 COUNTY RD S",
    "dropmalcty": "KARVAL",
    "dropmalst": "CO",
    "dropmalzpp": 808239407,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194465435,
    "dropsitcph": 7194465435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11544",
    "droptype": "D",
    "dropname": "KEENESBURG",
    "dropdeladd": "90 S MAIN ST",
    "dropdelcty": "KEENESBURG",
    "dropdelst": "CO",
    "dropdelzpp": 806439990,
    "dropphyadd": "90 S MAIN ST",
    "dropphycty": "KEENESBURG",
    "dropphyst": "CO",
    "dropphyzpp": 806439990,
    "dropmaladd": "90 S MAIN ST",
    "dropmalcty": "KEENESBURG",
    "dropmalst": "CO",
    "dropmalzpp": 806439990,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037324244,
    "dropsitcph": 3037324244,
    "dropfax": 3037324712
  },
  {
    "dcode": "D",
    "dropkey": "PZ11545",
    "droptype": "D",
    "dropname": "KERSEY",
    "dropdeladd": "331 1ST ST",
    "dropdelcty": "KERSEY",
    "dropdelst": "CO",
    "dropdelzpp": 806449997,
    "dropphyadd": "331 1ST ST",
    "dropphycty": "KERSEY",
    "dropphyst": "CO",
    "dropphyzpp": 806449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KERSEY",
    "dropmalst": "CO",
    "dropmalzpp": 806449998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703242526,
    "dropsitcph": 9703242526,
    "dropfax": 9703242528
  },
  {
    "dcode": "D",
    "dropkey": "PZ11547",
    "droptype": "D",
    "dropname": "KIM",
    "dropdeladd": "185 STATE ST",
    "dropdelcty": "KIM",
    "dropdelst": "CO",
    "dropdelzpp": 810499900,
    "dropphyadd": "185 STATE ST",
    "dropphycty": "KIM",
    "dropphyst": "CO",
    "dropphyzpp": 810499900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIM",
    "dropmalst": "CO",
    "dropmalzpp": 810499998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196420247,
    "dropsitcph": 7196420247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11548",
    "droptype": "D",
    "dropname": "KIOWA",
    "dropdeladd": "708 COMANCHE ST",
    "dropdelcty": "KIOWA",
    "dropdelst": "CO",
    "dropdelzpp": 801178608,
    "dropphyadd": "708 COMANCHE ST",
    "dropphycty": "KIOWA",
    "dropphyst": "CO",
    "dropphyzpp": 801178608,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KIOWA",
    "dropmalst": "CO",
    "dropmalzpp": 801179998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036212011,
    "dropsitcph": 3036212011,
    "dropfax": 3036218902
  },
  {
    "dcode": "D",
    "dropkey": "PZ11549",
    "droptype": "D",
    "dropname": "KIRK",
    "dropdeladd": "11028 COUNTY ROAD 3",
    "dropdelcty": "KIRK",
    "dropdelst": "CO",
    "dropdelzpp": 808249506,
    "dropphyadd": "11028 COUNTY ROAD 3",
    "dropphycty": "KIRK",
    "dropphyst": "CO",
    "dropphyzpp": 808249506,
    "dropmaladd": "11028 COUNTY ROAD 3",
    "dropmalcty": "KIRK",
    "dropmalst": "CO",
    "dropmalzpp": 808249506,
    "dropsitphn": 7195705409,
    "dropsitlph": 9703624394,
    "dropsitcph": 9703624394,
    "dropfax": 9703624394
  },
  {
    "dcode": "D",
    "dropkey": "PZ11550",
    "droptype": "D",
    "dropname": "KIT CARSON",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "KIT CARSON",
    "dropdelst": "CO",
    "dropdelzpp": 808259502,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "KIT CARSON",
    "dropphyst": "CO",
    "dropphyzpp": 808259502,
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "KIT CARSON",
    "dropmalst": "CO",
    "dropmalzpp": 808259502,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199623322,
    "dropsitcph": 7199623322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11551",
    "droptype": "D",
    "dropname": "KITTREDGE",
    "dropdeladd": "26300 HILLTOP DR",
    "dropdelcty": "KITTREDGE",
    "dropdelst": "CO",
    "dropdelzpp": 804579990,
    "dropphyadd": "26300 HILLTOP DR",
    "dropphycty": "KITTREDGE",
    "dropphyst": "CO",
    "dropphyzpp": 804579990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KITTREDGE",
    "dropmalst": "CO",
    "dropmalzpp": 804579998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036747446,
    "dropsitcph": 3036747446,
    "dropfax": 3036790875
  },
  {
    "dcode": "D",
    "dropkey": "PZ11555",
    "droptype": "D",
    "dropname": "KREMMLING",
    "dropdeladd": "701 PARK AVE",
    "dropdelcty": "KREMMLING",
    "dropdelst": "CO",
    "dropdelzpp": 804599997,
    "dropphyadd": "701 PARK AVE",
    "dropphycty": "KREMMLING",
    "dropphyst": "CO",
    "dropphyzpp": 804599997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KREMMLING",
    "dropmalst": "CO",
    "dropmalzpp": 804599998,
    "dropsitphn": 9708536511,
    "dropsitlph": 9707243771,
    "dropsitcph": 9707243771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11559",
    "droptype": "D",
    "dropname": "LA JARA",
    "dropdeladd": "525 MAIN ST",
    "dropdelcty": "LA JARA",
    "dropdelst": "CO",
    "dropdelzpp": 811409998,
    "dropphyadd": "525 MAIN ST",
    "dropphycty": "LA JARA",
    "dropphyst": "CO",
    "dropphyzpp": 811409998,
    "dropmaladd": "525 MAIN ST",
    "dropmalcty": "LA JARA",
    "dropmalst": "CO",
    "dropmalzpp": 811409998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192745331,
    "dropsitcph": 7192745331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11560",
    "droptype": "D",
    "dropname": "LA JUNTA",
    "dropdeladd": "324 COLORADO AVE STE 1",
    "dropdelcty": "LA JUNTA",
    "dropdelst": "CO",
    "dropdelzpp": 810509998,
    "dropphyadd": "324 COLORADO AVE STE 1",
    "dropphycty": "LA JUNTA",
    "dropphyst": "CO",
    "dropphyzpp": 810509998,
    "dropmaladd": "324 COLORADO AVE STE 1",
    "dropmalcty": "LA JUNTA",
    "dropmalst": "CO",
    "dropmalzpp": 810509998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193845917,
    "dropsitcph": 7193849841,
    "dropfax": 7193848525
  },
  {
    "dcode": "D",
    "dropkey": "PZ11561",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "524 N 2ND ST",
    "dropdelcty": "LA SALLE",
    "dropdelst": "CO",
    "dropdelzpp": 806453309,
    "dropphyadd": "524 N 2ND ST",
    "dropphycty": "LA SALLE",
    "dropphyst": "CO",
    "dropphyzpp": 806453309,
    "dropmaladd": "524 N 2ND ST",
    "dropmalcty": "LA SALLE",
    "dropmalst": "CO",
    "dropmalzpp": 806453309,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702846569,
    "dropsitcph": 9702846569,
    "dropfax": 9702846325
  },
  {
    "dcode": "D",
    "dropkey": "PZ11563",
    "droptype": "D",
    "dropname": "LA VETA",
    "dropdeladd": "117 E RYUS AVE",
    "dropdelcty": "LA VETA",
    "dropdelst": "CO",
    "dropdelzpp": 810558700,
    "dropphyadd": "117 E RYUS AVE",
    "dropphycty": "LA VETA",
    "dropphyst": "CO",
    "dropphyzpp": 810558700,
    "dropmaladd": "117 E RYUS AVE",
    "dropmalcty": "LA VETA",
    "dropmalst": "CO",
    "dropmalzpp": 810558700,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197423733,
    "dropsitcph": 7197423733,
    "dropfax": 7197423733
  },
  {
    "dcode": "D",
    "dropkey": "PZ11564",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "603 S PUBLIC RD",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "CO",
    "dropdelzpp": 800269998,
    "dropphyadd": "603 S PUBLIC RD",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "CO",
    "dropphyzpp": 800269998,
    "dropmaladd": "603 S PUBLIC RD",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "CO",
    "dropmalzpp": 800269998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3039261048,
    "dropsitcph": 3039261044,
    "dropfax": 3036651325
  },
  {
    "dcode": "D",
    "dropkey": "PZ11566",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "803 GUNNISON AVE",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "CO",
    "dropdelzpp": 812359707,
    "dropphyadd": "803 GUNNISON AVE",
    "dropphycty": "LAKE CITY",
    "dropphyst": "CO",
    "dropphyzpp": 812359707,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "CO",
    "dropmalzpp": 812359998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9709442560,
    "dropsitcph": 9709442560,
    "dropfax": 9709442949
  },
  {
    "dcode": "D",
    "dropkey": "PZ11567",
    "droptype": "D",
    "dropname": "LAKE GEORGE",
    "dropdeladd": "37370 US HIGHWAY 24",
    "dropdelcty": "LAKE GEORGE",
    "dropdelst": "CO",
    "dropdelzpp": 808279710,
    "dropphyadd": "37370 US HIGHWAY 24",
    "dropphycty": "LAKE GEORGE",
    "dropphyst": "CO",
    "dropphyzpp": 808279710,
    "dropmaladd": "37370 US HIGHWAY 24",
    "dropmalcty": "LAKE GEORGE",
    "dropmalst": "CO",
    "dropmalzpp": 808279710,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197483904,
    "dropsitcph": 7197483904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11573",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "300 S 5TH ST",
    "dropdelcty": "LAMAR",
    "dropdelst": "CO",
    "dropdelzpp": 810522712,
    "dropphyadd": "300 S 5TH ST",
    "dropphycty": "LAMAR",
    "dropphyst": "CO",
    "dropphyzpp": 810522712,
    "dropmaladd": "300 S 5TH ST",
    "dropmalcty": "LAMAR",
    "dropmalst": "CO",
    "dropmalzpp": 810522712,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193368720,
    "dropsitcph": 7193368756,
    "dropfax": 7193362730
  },
  {
    "dcode": "D",
    "dropkey": "PZ11574",
    "droptype": "D",
    "dropname": "LAPORTE",
    "dropdeladd": "2724 N OVERLAND TRL",
    "dropdelcty": "LAPORTE",
    "dropdelst": "CO",
    "dropdelzpp": 805359997,
    "dropphyadd": "2724 N OVERLAND TRL",
    "dropphycty": "LAPORTE",
    "dropphyst": "CO",
    "dropphyzpp": 805359997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAPORTE",
    "dropmalst": "CO",
    "dropmalzpp": 805359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704822591,
    "dropsitcph": 9704822591,
    "dropfax": 9702243347
  },
  {
    "dcode": "D",
    "dropkey": "PZ11576",
    "droptype": "D",
    "dropname": "LARKSPUR",
    "dropdeladd": "96 PERRY PARK AVE",
    "dropdelcty": "LARKSPUR",
    "dropdelst": "CO",
    "dropdelzpp": 801189998,
    "dropphyadd": "96 PERRY PARK AVE",
    "dropphycty": "LARKSPUR",
    "dropphyst": "CO",
    "dropphyzpp": 801189998,
    "dropmaladd": "96 PERRY PARK AVE",
    "dropmalcty": "LARKSPUR",
    "dropmalst": "CO",
    "dropmalzpp": 801189998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036812449,
    "dropsitcph": 3036812449,
    "dropfax": 3036812528
  },
  {
    "dcode": "D",
    "dropkey": "PZ11577",
    "droptype": "D",
    "dropname": "LAS ANIMAS",
    "dropdeladd": "513 6TH ST",
    "dropdelcty": "LAS ANIMAS",
    "dropdelst": "CO",
    "dropdelzpp": 810541716,
    "dropphyadd": "513 6TH ST",
    "dropphycty": "LAS ANIMAS",
    "dropphyst": "CO",
    "dropphyzpp": 810541716,
    "dropmaladd": "513 6TH ST",
    "dropmalcty": "LAS ANIMAS",
    "dropmalst": "CO",
    "dropmalzpp": 810541716,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194560330,
    "dropsitcph": 7194560493,
    "dropfax": 7194561930
  },
  {
    "dcode": "D",
    "dropkey": "PZ11583",
    "droptype": "D",
    "dropname": "LAZEAR",
    "dropdeladd": "8587 3100 RD",
    "dropdelcty": "LAZEAR",
    "dropdelst": "CO",
    "dropdelzpp": 814209996,
    "dropphyadd": "8587 3100 RD",
    "dropphycty": "LAZEAR",
    "dropphyst": "CO",
    "dropphyzpp": 814209996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAZEAR",
    "dropmalst": "CO",
    "dropmalzpp": 814209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708723871,
    "dropsitcph": 9708723871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11584",
    "droptype": "D",
    "dropname": "LEADVILLE",
    "dropdeladd": "130 W 5TH ST",
    "dropdelcty": "LEADVILLE",
    "dropdelst": "CO",
    "dropdelzpp": 804619998,
    "dropphyadd": "130 W 5TH ST",
    "dropphycty": "LEADVILLE",
    "dropphyst": "CO",
    "dropphyzpp": 804619998,
    "dropmaladd": "130 W 5TH ST",
    "dropmalcty": "LEADVILLE",
    "dropmalst": "CO",
    "dropmalzpp": 804619998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7194869731,
    "dropsitcph": 7194869397,
    "dropfax": 7194862477
  },
  {
    "dcode": "D",
    "dropkey": "PZ11585",
    "droptype": "D",
    "dropname": "LEWIS",
    "dropdeladd": "18794 HIGHWAY 491",
    "dropdelcty": "LEWIS",
    "dropdelst": "CO",
    "dropdelzpp": 813279997,
    "dropphyadd": "18794 HIGHWAY 491",
    "dropphycty": "LEWIS",
    "dropphyst": "CO",
    "dropphyzpp": 813279997,
    "dropmaladd": "18794 HIGHWAY 491",
    "dropmalcty": "LEWIS",
    "dropmalst": "CO",
    "dropmalzpp": 813279997,
    "dropsitphn": 7195705409,
    "dropsitlph": 9708824631,
    "dropsitcph": 9708824631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11586",
    "droptype": "D",
    "dropname": "LIMON",
    "dropdeladd": "250 F AVE",
    "dropdelcty": "LIMON",
    "dropdelst": "CO",
    "dropdelzpp": 808282218,
    "dropphyadd": "250 F AVE",
    "dropphycty": "LIMON",
    "dropphyst": "CO",
    "dropphyzpp": 808282218,
    "dropmaladd": "250 F AVE",
    "dropmalcty": "LIMON",
    "dropmalst": "CO",
    "dropmalzpp": 808282218,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197752264,
    "dropsitcph": 7197752264,
    "dropfax": 7197758789
  },
  {
    "dcode": "D",
    "dropkey": "PZ11589",
    "droptype": "D",
    "dropname": "LINDON",
    "dropdeladd": "16028 STATE HIGHWAY 36",
    "dropdelcty": "LINDON",
    "dropdelst": "CO",
    "dropdelzpp": 807409998,
    "dropphyadd": "16028 STATE HIGHWAY 36",
    "dropphycty": "LINDON",
    "dropphyst": "CO",
    "dropphyzpp": 807409998,
    "dropmaladd": "16028 STATE HIGHWAY 36",
    "dropmalcty": "LINDON",
    "dropmalst": "CO",
    "dropmalzpp": 807409998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703832294,
    "dropsitcph": 9703832294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11590",
    "droptype": "D",
    "dropname": "LITTLETON",
    "dropdeladd": "5753 S PRINCE ST",
    "dropdelcty": "LITTLETON",
    "dropdelst": "CO",
    "dropdelzpp": 801209998,
    "dropphyadd": "5753 S PRINCE ST",
    "dropphycty": "LITTLETON",
    "dropphyst": "CO",
    "dropphyzpp": 801209998,
    "dropmaladd": "5753 S PRINCE ST",
    "dropmalcty": "LITTLETON",
    "dropmalst": "CO",
    "dropmalzpp": 801209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037957479,
    "dropsitcph": 3037957346,
    "dropfax": 3037973171
  },
  {
    "dcode": "D",
    "dropkey": "PZ11592",
    "droptype": "D",
    "dropname": "LIVERMORE",
    "dropdeladd": "55 W COUNTY ROAD 74E",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "CO",
    "dropdelzpp": 805369997,
    "dropphyadd": "55 W COUNTY ROAD 74E",
    "dropphycty": "LIVERMORE",
    "dropphyst": "CO",
    "dropphyzpp": 805369997,
    "dropmaladd": "55 W COUNTY ROAD 74E",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "CO",
    "dropmalzpp": 805369997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704938660,
    "dropsitcph": 9704938660,
    "dropfax": 9702215462
  },
  {
    "dcode": "D",
    "dropkey": "PZ11597",
    "droptype": "D",
    "dropname": "LOMA",
    "dropdeladd": "1345 13 RD",
    "dropdelcty": "LOMA",
    "dropdelst": "CO",
    "dropdelzpp": 815249900,
    "dropphyadd": "1345 13 RD",
    "dropphycty": "LOMA",
    "dropphyst": "CO",
    "dropphyzpp": 815249900,
    "dropmaladd": "1345 13 RD",
    "dropmalcty": "LOMA",
    "dropmalst": "CO",
    "dropmalzpp": 815249900,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708587232,
    "dropsitcph": 9708587232,
    "dropfax": 9708588712
  },
  {
    "dcode": "D",
    "dropkey": "PZ11600",
    "droptype": "D",
    "dropname": "LONGMONT",
    "dropdeladd": "201 COFFMAN ST",
    "dropdelcty": "LONGMONT",
    "dropdelst": "CO",
    "dropdelzpp": 805019998,
    "dropphyadd": "201 COFFMAN ST",
    "dropphycty": "LONGMONT",
    "dropphyst": "CO",
    "dropphyzpp": 805019998,
    "dropmaladd": "201 COFFMAN ST",
    "dropmalcty": "LONGMONT",
    "dropmalst": "CO",
    "dropmalzpp": 805019998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034856021,
    "dropsitcph": 3037762387,
    "dropfax": 3037722839
  },
  {
    "dcode": "D",
    "dropkey": "PZ11603",
    "droptype": "D",
    "dropname": "LOUISVILLE",
    "dropdeladd": "566 S MCCASLIN BLVD",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "CO",
    "dropdelzpp": 800279998,
    "dropphyadd": "566 S MCCASLIN BLVD",
    "dropphycty": "SUPERIOR",
    "dropphyst": "CO",
    "dropphyzpp": 800279998,
    "dropmaladd": "566 S MCCASLIN BLVD",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "CO",
    "dropmalzpp": 800275200,
    "dropsitphn": 3036650030,
    "dropsitlph": 3036650030,
    "dropsitcph": 3036650030,
    "dropfax": 3036653068
  },
  {
    "dcode": "D",
    "dropkey": "PZ11604",
    "droptype": "D",
    "dropname": "LOUVIERS",
    "dropdeladd": "7895 LOUVIERS BLVD",
    "dropdelcty": "LOUVIERS",
    "dropdelst": "CO",
    "dropdelzpp": 801319997,
    "dropphyadd": "7895 LOUVIERS BLVD",
    "dropphycty": "LOUVIERS",
    "dropphyst": "CO",
    "dropphyzpp": 801319997,
    "dropmaladd": "7895 LOUVIERS BLVD",
    "dropmalcty": "LOUVIERS",
    "dropmalst": "CO",
    "dropmalzpp": 801319997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037911005,
    "dropsitcph": 3037911005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11605",
    "droptype": "D",
    "dropname": "LOVELAND",
    "dropdeladd": "446 E 29TH ST",
    "dropdelcty": "LOVELAND",
    "dropdelst": "CO",
    "dropdelzpp": 805389998,
    "dropphyadd": "446 E 29TH ST",
    "dropphycty": "LOVELAND",
    "dropphyst": "CO",
    "dropphyzpp": 805389998,
    "dropmaladd": "446 E 29TH ST",
    "dropmalcty": "LOVELAND",
    "dropmalst": "CO",
    "dropmalzpp": 805389998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706678591,
    "dropsitcph": 9706633010,
    "dropfax": 9706677920
  },
  {
    "dcode": "D",
    "dropkey": "PZ11610",
    "droptype": "D",
    "dropname": "LUCERNE",
    "dropdeladd": "32969 COUNTY ROAD 39",
    "dropdelcty": "LUCERNE",
    "dropdelst": "CO",
    "dropdelzpp": 806469997,
    "dropphyadd": "32969 COUNTY ROAD 39",
    "dropphycty": "LUCERNE",
    "dropphyst": "CO",
    "dropphyzpp": 806469997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUCERNE",
    "dropmalst": "CO",
    "dropmalzpp": 806469998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033563036,
    "dropsitcph": 9703563036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11613",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "305 RAILROAD AVE",
    "dropdelcty": "LYONS",
    "dropdelst": "CO",
    "dropdelzpp": 805409997,
    "dropphyadd": "305 RAILROAD AVE",
    "dropphycty": "LYONS",
    "dropphyst": "CO",
    "dropphyzpp": 805409997,
    "dropmaladd": "305 RAILROAD AVE",
    "dropmalcty": "LYONS",
    "dropmalst": "CO",
    "dropmalzpp": 805409997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038239803,
    "dropsitcph": 3038239803,
    "dropfax": 7203104009
  },
  {
    "dcode": "D",
    "dropkey": "PZ11614",
    "droptype": "D",
    "dropname": "MACK",
    "dropdeladd": "1021 HOTEL CIR",
    "dropdelcty": "MACK",
    "dropdelst": "CO",
    "dropdelzpp": 815259743,
    "dropphyadd": "1021 HOTEL CIR",
    "dropphycty": "MACK",
    "dropphyst": "CO",
    "dropphyzpp": 815259743,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MACK",
    "dropmalst": "CO",
    "dropmalzpp": 815259998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708587889,
    "dropsitcph": 9708587889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11618",
    "droptype": "D",
    "dropname": "MANASSA",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "MANASSA",
    "dropdelst": "CO",
    "dropdelzpp": 811419990,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "MANASSA",
    "dropphyst": "CO",
    "dropphyzpp": 811419990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANASSA",
    "dropmalst": "CO",
    "dropmalzpp": 811419998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192983885,
    "dropsitcph": 7192983803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11619",
    "droptype": "D",
    "dropname": "MANCOS",
    "dropdeladd": "291 N WALNUT ST",
    "dropdelcty": "MANCOS",
    "dropdelst": "CO",
    "dropdelzpp": 813289194,
    "dropphyadd": "291 N WALNUT ST",
    "dropphycty": "MANCOS",
    "dropphyst": "CO",
    "dropphyzpp": 813289194,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANCOS",
    "dropmalst": "CO",
    "dropmalzpp": 813289998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705337754,
    "dropsitcph": 9705337754,
    "dropfax": 9705339828
  },
  {
    "dcode": "D",
    "dropkey": "PZ11620",
    "droptype": "D",
    "dropname": "MANITOU SPRINGS",
    "dropdeladd": "307 CANON AVE",
    "dropdelcty": "MANITOU SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 808291711,
    "dropphyadd": "307 CANON AVE",
    "dropphycty": "MANITOU SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 808291711,
    "dropmaladd": "307 CANON AVE",
    "dropmalcty": "MANITOU SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 808291711,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196855915,
    "dropsitcph": 7196854407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11621",
    "droptype": "D",
    "dropname": "MANZANOLA",
    "dropdeladd": "103 S PARK ST",
    "dropdelcty": "MANZANOLA",
    "dropdelst": "CO",
    "dropdelzpp": 810589900,
    "dropphyadd": "103 S PARK ST",
    "dropphycty": "MANZANOLA",
    "dropphyst": "CO",
    "dropphyzpp": 810589900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANZANOLA",
    "dropmalst": "CO",
    "dropmalzpp": 810589998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194625247,
    "dropsitcph": 7194625247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11624",
    "droptype": "D",
    "dropname": "MARVEL",
    "dropdeladd": "10383 COUNTY ROAD 100",
    "dropdelcty": "MARVEL",
    "dropdelst": "CO",
    "dropdelzpp": 813299997,
    "dropphyadd": "10383 COUNTY ROAD 100",
    "dropphycty": "MARVEL",
    "dropphyst": "CO",
    "dropphyzpp": 813299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARVEL",
    "dropmalst": "CO",
    "dropmalzpp": 813299998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705883387,
    "dropsitcph": 9705883387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11626",
    "droptype": "D",
    "dropname": "MASONVILLE",
    "dropdeladd": "8669 N COUNTY ROAD 27",
    "dropdelcty": "MASONVILLE",
    "dropdelst": "CO",
    "dropdelzpp": 805419997,
    "dropphyadd": "8669 N COUNTY ROAD 27",
    "dropphycty": "MASONVILLE",
    "dropphyst": "CO",
    "dropphyzpp": 805419997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MASONVILLE",
    "dropmalst": "CO",
    "dropmalzpp": 805419998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706696925,
    "dropsitcph": 9706696925,
    "dropfax": 9706696925
  },
  {
    "dcode": "D",
    "dropkey": "PZ11628",
    "droptype": "D",
    "dropname": "MATHESON",
    "dropdeladd": "37021 BROADWAY AVE",
    "dropdelcty": "MATHESON",
    "dropdelst": "CO",
    "dropdelzpp": 808309710,
    "dropphyadd": "37021 BROADWAY AVE",
    "dropphycty": "MATHESON",
    "dropphyst": "CO",
    "dropphyzpp": 808309710,
    "dropmaladd": "37021 BROADWAY AVE",
    "dropmalcty": "MATHESON",
    "dropmalst": "CO",
    "dropmalzpp": 808309710,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195412761,
    "dropsitcph": 7195412761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11632",
    "droptype": "D",
    "dropname": "MAYBELL",
    "dropdeladd": "200 COLLUM ST",
    "dropdelcty": "MAYBELL",
    "dropdelst": "CO",
    "dropdelzpp": 816409997,
    "dropphyadd": "200 COLLUM ST",
    "dropphycty": "MAYBELL",
    "dropphyst": "CO",
    "dropphyzpp": 816409997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYBELL",
    "dropmalst": "CO",
    "dropmalzpp": 816409998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702729907,
    "dropsitcph": 9702729907,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11634",
    "droptype": "D",
    "dropname": "MC CLAVE",
    "dropdeladd": "111 E 1ST ST",
    "dropdelcty": "MC CLAVE",
    "dropdelst": "CO",
    "dropdelzpp": 810579900,
    "dropphyadd": "111 E 1ST ST",
    "dropphycty": "MC CLAVE",
    "dropphyst": "CO",
    "dropphyzpp": 810579900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC CLAVE",
    "dropmalst": "CO",
    "dropmalzpp": 810579998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198294680,
    "dropsitcph": 7198294680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11635",
    "droptype": "D",
    "dropname": "MC COY",
    "dropdeladd": "43 MCCOY RD",
    "dropdelcty": "MC COY",
    "dropdelst": "CO",
    "dropdelzpp": 804639991,
    "dropphyadd": "43 MCCOY RD",
    "dropphycty": "MC COY",
    "dropphyst": "CO",
    "dropphyzpp": 804639991,
    "dropmaladd": "43 MCCOY RD",
    "dropmalcty": "MC COY",
    "dropmalst": "CO",
    "dropmalzpp": 804639991,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706534308,
    "dropsitcph": 9706534308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11636",
    "droptype": "D",
    "dropname": "MEAD",
    "dropdeladd": "350 WELKER AVE",
    "dropdelcty": "MEAD",
    "dropdelst": "CO",
    "dropdelzpp": 805429606,
    "dropphyadd": "350 WELKER AVE",
    "dropphycty": "MEAD",
    "dropphyst": "CO",
    "dropphyzpp": 805429606,
    "dropmaladd": "350 WELKER AVE",
    "dropmalcty": "MEAD",
    "dropmalst": "CO",
    "dropmalzpp": 805429606,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705354612,
    "dropsitcph": 9705354612,
    "dropfax": 9705350736
  },
  {
    "dcode": "D",
    "dropkey": "PZ11637",
    "droptype": "D",
    "dropname": "MEEKER",
    "dropdeladd": "365 6TH ST",
    "dropdelcty": "MEEKER",
    "dropdelst": "CO",
    "dropdelzpp": 816419997,
    "dropphyadd": "365 6TH ST",
    "dropphycty": "MEEKER",
    "dropphyst": "CO",
    "dropphyzpp": 816419997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEEKER",
    "dropmalst": "CO",
    "dropmalzpp": 816419998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708785830,
    "dropsitcph": 9708785830,
    "dropfax": 9708784884
  },
  {
    "dcode": "D",
    "dropkey": "PZ11638",
    "droptype": "D",
    "dropname": "MEREDITH",
    "dropdeladd": "22971 FRYING PAN RD",
    "dropdelcty": "MEREDITH",
    "dropdelst": "CO",
    "dropdelzpp": 816429997,
    "dropphyadd": "22971 FRYING PAN RD",
    "dropphycty": "MEREDITH",
    "dropphyst": "CO",
    "dropphyzpp": 816429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEREDITH",
    "dropmalst": "CO",
    "dropmalzpp": 816429998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709271256,
    "dropsitcph": 9709271256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11640",
    "droptype": "D",
    "dropname": "MERINO",
    "dropdeladd": "202 COLORADO AVE",
    "dropdelcty": "MERINO",
    "dropdelst": "CO",
    "dropdelzpp": 807419998,
    "dropphyadd": "202 COLORADO AVE",
    "dropphycty": "MERINO",
    "dropphyst": "CO",
    "dropphyzpp": 807419998,
    "dropmaladd": "202 COLORADO AVE",
    "dropmalcty": "MERINO",
    "dropmalst": "CO",
    "dropmalzpp": 807419998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705225452,
    "dropsitcph": 9705225452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11641",
    "droptype": "D",
    "dropname": "MESA",
    "dropdeladd": "49012 KE RD",
    "dropdelcty": "MESA",
    "dropdelst": "CO",
    "dropdelzpp": 816439900,
    "dropphyadd": "49012 KE RD",
    "dropphycty": "MESA",
    "dropphyst": "CO",
    "dropphyzpp": 816439900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESA",
    "dropmalst": "CO",
    "dropmalzpp": 816439998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702685562,
    "dropsitcph": 9702685562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11643",
    "droptype": "D",
    "dropname": "MESA VERDE NATIONAL PARK",
    "dropdeladd": "1 MESA VERDE NATIONAL",
    "dropdelcty": "MESA VERDE NATIONAL PARK",
    "dropdelst": "CO",
    "dropdelzpp": 813309500,
    "dropphyadd": "1 MESA VERDE NATIONAL",
    "dropphycty": "MESA VERDE NATIONAL PARK",
    "dropphyst": "CO",
    "dropphyzpp": 813309500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESA VERDE NATIONAL PARK",
    "dropmalst": "CO",
    "dropmalzpp": 813309998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705294554,
    "dropsitcph": 9705294554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11646",
    "droptype": "D",
    "dropname": "MILLIKEN",
    "dropdeladd": "1009 BROAD ST",
    "dropdelcty": "MILLIKEN",
    "dropdelst": "CO",
    "dropdelzpp": 805439997,
    "dropphyadd": "1009 BROAD ST",
    "dropphycty": "MILLIKEN",
    "dropphyst": "CO",
    "dropphyzpp": 805439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLIKEN",
    "dropmalst": "CO",
    "dropmalzpp": 805439998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705873332,
    "dropsitcph": 9705873332,
    "dropfax": 9705879425
  },
  {
    "dcode": "D",
    "dropkey": "PZ11648",
    "droptype": "D",
    "dropname": "MINTURN",
    "dropdeladd": "301 BOULDER ST",
    "dropdelcty": "MINTURN",
    "dropdelst": "CO",
    "dropdelzpp": 816459997,
    "dropphyadd": "301 BOULDER ST",
    "dropphycty": "MINTURN",
    "dropphyst": "CO",
    "dropphyzpp": 816459997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINTURN",
    "dropmalst": "CO",
    "dropmalzpp": 816459998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708275266,
    "dropsitcph": 9708275266,
    "dropfax": 9708279336
  },
  {
    "dcode": "D",
    "dropkey": "PZ11651",
    "droptype": "D",
    "dropname": "MOFFAT",
    "dropdeladd": "17363 STATE HIGHWAY 17",
    "dropdelcty": "MOFFAT",
    "dropdelst": "CO",
    "dropdelzpp": 811439802,
    "dropphyadd": "17363 STATE HIGHWAY 17",
    "dropphycty": "MOFFAT",
    "dropphyst": "CO",
    "dropphyzpp": 811439802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOFFAT",
    "dropmalst": "CO",
    "dropmalzpp": 811439998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192564050,
    "dropsitcph": 7192564050,
    "dropfax": 7192564723
  },
  {
    "dcode": "D",
    "dropkey": "PZ11653",
    "droptype": "D",
    "dropname": "MOLINA",
    "dropdeladd": "53169 KE RD",
    "dropdelcty": "MOLINA",
    "dropdelst": "CO",
    "dropdelzpp": 816469997,
    "dropphyadd": "53169 KE RD",
    "dropphycty": "MOLINA",
    "dropphyst": "CO",
    "dropphyzpp": 816469997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOLINA",
    "dropmalst": "CO",
    "dropmalzpp": 816469998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702685516,
    "dropsitcph": 9702685516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11657",
    "droptype": "D",
    "dropname": "MONTE VISTA",
    "dropdeladd": "150 WASHINGTON ST",
    "dropdelcty": "MONTE VISTA",
    "dropdelst": "CO",
    "dropdelzpp": 811449998,
    "dropphyadd": "150 WASHINGTON ST",
    "dropphycty": "MONTE VISTA",
    "dropphyst": "CO",
    "dropphyzpp": 811449998,
    "dropmaladd": "150 WASHINGTON ST",
    "dropmalcty": "MONTE VISTA",
    "dropmalst": "CO",
    "dropmalzpp": 811449998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198523431,
    "dropsitcph": 7198523431,
    "dropfax": 7198525367
  },
  {
    "dcode": "D",
    "dropkey": "PZ11658",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "321 S 1ST ST",
    "dropdelcty": "MONTROSE",
    "dropdelst": "CO",
    "dropdelzpp": 814019998,
    "dropphyadd": "321 S 1ST ST",
    "dropphycty": "MONTROSE",
    "dropphyst": "CO",
    "dropphyzpp": 814019998,
    "dropmaladd": "321 S 1ST ST",
    "dropmalcty": "MONTROSE",
    "dropmalst": "CO",
    "dropmalzpp": 814019998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702496654,
    "dropsitcph": 9702496654,
    "dropfax": 9702492249
  },
  {
    "dcode": "D",
    "dropkey": "PZ11659",
    "droptype": "D",
    "dropname": "MONUMENT",
    "dropdeladd": "545 3RD ST",
    "dropdelcty": "MONUMENT",
    "dropdelst": "CO",
    "dropdelzpp": 801329998,
    "dropphyadd": "545 3RD ST",
    "dropphycty": "MONUMENT",
    "dropphyst": "CO",
    "dropphyzpp": 801329998,
    "dropmaladd": "545 3RD ST",
    "dropmalcty": "MONUMENT",
    "dropmalst": "CO",
    "dropmalzpp": 801329998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7194813124,
    "dropsitcph": 7194885878,
    "dropfax": 7194889670
  },
  {
    "dcode": "D",
    "dropkey": "PZ11664",
    "droptype": "D",
    "dropname": "MORRISON",
    "dropdeladd": "151 SUMMER ST",
    "dropdelcty": "MORRISON",
    "dropdelst": "CO",
    "dropdelzpp": 804659900,
    "dropphyadd": "151 SUMMER ST",
    "dropphycty": "MORRISON",
    "dropphyst": "CO",
    "dropphyzpp": 804659900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRISON",
    "dropmalst": "CO",
    "dropmalzpp": 804659998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037854450,
    "dropsitcph": 3036972218,
    "dropfax": 3036978854
  },
  {
    "dcode": "D",
    "dropkey": "PZ11665",
    "droptype": "D",
    "dropname": "MOSCA",
    "dropdeladd": "9260 4TH AVE",
    "dropdelcty": "MOSCA",
    "dropdelst": "CO",
    "dropdelzpp": 811469990,
    "dropphyadd": "9260 4TH AVE",
    "dropphycty": "MOSCA",
    "dropphyst": "CO",
    "dropphyzpp": 811469990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSCA",
    "dropmalst": "CO",
    "dropmalzpp": 811469998,
    "dropsitphn": 7193782401,
    "dropsitlph": 7193782401,
    "dropsitcph": 7193782401,
    "dropfax": 7193782705
  },
  {
    "dcode": "D",
    "dropkey": "PZ11674",
    "droptype": "D",
    "dropname": "NATHROP",
    "dropdeladd": "22617 US HIGHWAY 285",
    "dropdelcty": "NATHROP",
    "dropdelst": "CO",
    "dropdelzpp": 812369731,
    "dropphyadd": "22617 US HIGHWAY 285",
    "dropphycty": "NATHROP",
    "dropphyst": "CO",
    "dropphyzpp": 812369731,
    "dropmaladd": "22617 US HIGHWAY 285",
    "dropmalcty": "NATHROP",
    "dropmalst": "CO",
    "dropmalzpp": 812369731,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193952720,
    "dropsitcph": 7193952720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11676",
    "droptype": "D",
    "dropname": "NATURITA",
    "dropdeladd": "211 W MAIN ST",
    "dropdelcty": "NATURITA",
    "dropdelst": "CO",
    "dropdelzpp": 814229997,
    "dropphyadd": "211 W MAIN ST",
    "dropphycty": "NATURITA",
    "dropphyst": "CO",
    "dropphyzpp": 814229997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NATURITA",
    "dropmalst": "CO",
    "dropmalzpp": 814229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708652382,
    "dropsitcph": 9708652382,
    "dropfax": 9708652108
  },
  {
    "dcode": "D",
    "dropkey": "PZ11678",
    "droptype": "D",
    "dropname": "NEDERLAND",
    "dropdeladd": "350 EAST ST",
    "dropdelcty": "NEDERLAND",
    "dropdelst": "CO",
    "dropdelzpp": 804669908,
    "dropphyadd": "350 EAST ST",
    "dropphycty": "NEDERLAND",
    "dropphyst": "CO",
    "dropphyzpp": 804669908,
    "dropmaladd": "350 EAST ST",
    "dropmalcty": "NEDERLAND",
    "dropmalst": "CO",
    "dropmalzpp": 804669908,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032583247,
    "dropsitcph": 3032583247,
    "dropfax": 3032587608
  },
  {
    "dcode": "D",
    "dropkey": "PZ11681",
    "droptype": "D",
    "dropname": "NEW CASTLE",
    "dropdeladd": "112 W MAIN ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "CO",
    "dropdelzpp": 816479997,
    "dropphyadd": "112 W MAIN ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "CO",
    "dropphyzpp": 816479997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "CO",
    "dropmalzpp": 816479998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709842213,
    "dropsitcph": 9709842213,
    "dropfax": 9709843808
  },
  {
    "dcode": "D",
    "dropkey": "PZ11683",
    "droptype": "D",
    "dropname": "NEW RAYMER",
    "dropdeladd": "236 CENTRE AVE",
    "dropdelcty": "NEW RAYMER",
    "dropdelst": "CO",
    "dropdelzpp": 807429998,
    "dropphyadd": "236 CENTRE AVE",
    "dropphycty": "NEW RAYMER",
    "dropphyst": "CO",
    "dropphyzpp": 807429998,
    "dropmaladd": "236 CENTRE AVE",
    "dropmalcty": "NEW RAYMER",
    "dropmalst": "CO",
    "dropmalzpp": 807429998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704375317,
    "dropsitcph": 9704375317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11686",
    "droptype": "D",
    "dropname": "NIWOT",
    "dropdeladd": "150 MURRAY ST",
    "dropdelcty": "NIWOT",
    "dropdelst": "CO",
    "dropdelzpp": 805449997,
    "dropphyadd": "150 MURRAY ST",
    "dropphycty": "NIWOT",
    "dropphyst": "CO",
    "dropphyzpp": 805449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIWOT",
    "dropmalst": "CO",
    "dropmalzpp": 805449998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036522309,
    "dropsitcph": 3036522309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11697",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "1555 GRAND AVE",
    "dropdelcty": "NORWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 814239997,
    "dropphyadd": "1555 GRAND AVE",
    "dropphycty": "NORWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 814239997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 814239998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703274249,
    "dropsitcph": 9703274249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11698",
    "droptype": "D",
    "dropname": "NUCLA",
    "dropdeladd": "145 W 5TH AVE",
    "dropdelcty": "NUCLA",
    "dropdelst": "CO",
    "dropdelzpp": 814249997,
    "dropphyadd": "145 W 5TH AVE",
    "dropphycty": "NUCLA",
    "dropphyst": "CO",
    "dropphyzpp": 814249997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUCLA",
    "dropmalst": "CO",
    "dropmalzpp": 814249998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708647326,
    "dropsitcph": 9708647326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11701",
    "droptype": "D",
    "dropname": "NUNN",
    "dropdeladd": "397 LOGAN AVE",
    "dropdelcty": "NUNN",
    "dropdelst": "CO",
    "dropdelzpp": 806489997,
    "dropphyadd": "397 LOGAN AVE",
    "dropphycty": "NUNN",
    "dropphyst": "CO",
    "dropphyzpp": 806489997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NUNN",
    "dropmalst": "CO",
    "dropmalzpp": 806489998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702951347,
    "dropsitcph": 9702951347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11702",
    "droptype": "D",
    "dropname": "OAK CREEK",
    "dropdeladd": "129 W MAIN ST",
    "dropdelcty": "OAK CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 804679997,
    "dropphyadd": "129 W MAIN ST",
    "dropphycty": "OAK CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 804679997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAK CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 804679998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707362494,
    "dropsitcph": 9707362494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11706",
    "droptype": "D",
    "dropname": "OLATHE",
    "dropdeladd": "215 N US HIGHWAY 50 BUSINESS LOOP",
    "dropdelcty": "OLATHE",
    "dropdelst": "CO",
    "dropdelzpp": 814259998,
    "dropphyadd": "215 N US HIGHWAY 50 BUSINESS LOOP",
    "dropphycty": "OLATHE",
    "dropphyst": "CO",
    "dropphyzpp": 814259998,
    "dropmaladd": "215 N US HIGHWAY 50 BUSINESS LOOP",
    "dropmalcty": "OLATHE",
    "dropmalst": "CO",
    "dropmalzpp": 814259998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703235936,
    "dropsitcph": 9703235936,
    "dropfax": 9703230254
  },
  {
    "dcode": "D",
    "dropkey": "PZ11709",
    "droptype": "D",
    "dropname": "OLNEY SPRINGS",
    "dropdeladd": "601 WARNER ST",
    "dropdelcty": "OLNEY SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 810629611,
    "dropphyadd": "601 WARNER ST",
    "dropphycty": "OLNEY SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 810629611,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLNEY SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 810629998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192673376,
    "dropsitcph": 7192673376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11711",
    "droptype": "D",
    "dropname": "OPHIR",
    "dropdeladd": "431 OPHIR RD",
    "dropdelcty": "OPHIR",
    "dropdelst": "CO",
    "dropdelzpp": 814269900,
    "dropphyadd": "431 OPHIR RD",
    "dropphycty": "OPHIR",
    "dropphyst": "CO",
    "dropphyzpp": 814269900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OPHIR",
    "dropmalst": "CO",
    "dropmalzpp": 814269998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707286895,
    "dropsitcph": 9707286895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11712",
    "droptype": "D",
    "dropname": "ORCHARD",
    "dropdeladd": "22863 WASHINGTON AVE",
    "dropdelcty": "ORCHARD",
    "dropdelst": "CO",
    "dropdelzpp": 806499997,
    "dropphyadd": "22863 WASHINGTON AVE",
    "dropphycty": "ORCHARD",
    "dropphyst": "CO",
    "dropphyzpp": 806499601,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCHARD",
    "dropmalst": "CO",
    "dropmalzpp": 806499998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706452220,
    "dropsitcph": 9706452220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11716",
    "droptype": "D",
    "dropname": "ORDWAY",
    "dropdeladd": "115 SHERMAN AVE",
    "dropdelcty": "ORDWAY",
    "dropdelst": "CO",
    "dropdelzpp": 810639998,
    "dropphyadd": "115 SHERMAN AVE",
    "dropphycty": "ORDWAY",
    "dropphyst": "CO",
    "dropphyzpp": 810639998,
    "dropmaladd": "115 SHERMAN AVE",
    "dropmalcty": "ORDWAY",
    "dropmalst": "CO",
    "dropmalzpp": 810639998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192673336,
    "dropsitcph": 7192673336,
    "dropfax": 7192673073
  },
  {
    "dcode": "D",
    "dropkey": "PZ11718",
    "droptype": "D",
    "dropname": "OTIS",
    "dropdeladd": "119 N WASHINGTON ST",
    "dropdelcty": "OTIS",
    "dropdelst": "CO",
    "dropdelzpp": 807439998,
    "dropphyadd": "119 N WASHINGTON ST",
    "dropphycty": "OTIS",
    "dropphyst": "CO",
    "dropphyzpp": 807439998,
    "dropmaladd": "119 N WASHINGTON ST",
    "dropmalcty": "OTIS",
    "dropmalst": "CO",
    "dropmalzpp": 807439998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702463348,
    "dropsitcph": 9702463348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11719",
    "droptype": "D",
    "dropname": "OURAY",
    "dropdeladd": "620 MAIN ST",
    "dropdelcty": "OURAY",
    "dropdelst": "CO",
    "dropdelzpp": 814279998,
    "dropphyadd": "620 MAIN ST",
    "dropphycty": "OURAY",
    "dropphyst": "CO",
    "dropphyzpp": 814279998,
    "dropmaladd": "620 MAIN ST",
    "dropmalcty": "OURAY",
    "dropmalst": "CO",
    "dropmalzpp": 814279998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703254302,
    "dropsitcph": 9703872190,
    "dropfax": 9703259802
  },
  {
    "dcode": "D",
    "dropkey": "PZ11720",
    "droptype": "D",
    "dropname": "OVID",
    "dropdeladd": "231 MAIN ST",
    "dropdelcty": "OVID",
    "dropdelst": "CO",
    "dropdelzpp": 807449500,
    "dropphyadd": "231 MAIN ST",
    "dropphycty": "OVID",
    "dropphyst": "CO",
    "dropphyzpp": 807449500,
    "dropmaladd": "231 MAIN ST",
    "dropmalcty": "OVID",
    "dropmalst": "CO",
    "dropmalzpp": 807449500,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704635600,
    "dropsitcph": 9704635600,
    "dropfax": 9704639042
  },
  {
    "dcode": "D",
    "dropkey": "PZ11722",
    "droptype": "D",
    "dropname": "PADRONI",
    "dropdeladd": "23115 RAILROAD AVE",
    "dropdelcty": "PADRONI",
    "dropdelst": "CO",
    "dropdelzpp": 807459998,
    "dropphyadd": "23115 RAILROAD AVE",
    "dropphycty": "PADRONI",
    "dropphyst": "CO",
    "dropphyzpp": 807459998,
    "dropmaladd": "23115 RAILROAD AVE",
    "dropmalcty": "PADRONI",
    "dropmalst": "CO",
    "dropmalzpp": 807459998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705217950,
    "dropsitcph": 9705217950,
    "dropfax": 9705223406
  },
  {
    "dcode": "D",
    "dropkey": "PZ11726",
    "droptype": "D",
    "dropname": "PAGOSA SPRINGS",
    "dropdeladd": "250 HOT SPRINGS BLVD",
    "dropdelcty": "PAGOSA SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 811479821,
    "dropphyadd": "250 HOT SPRINGS BLVD",
    "dropphycty": "PAGOSA SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 811479821,
    "dropmaladd": "250 HOT SPRINGS BLVD",
    "dropmalcty": "PAGOSA SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 811479821,
    "dropsitphn": 7195705409,
    "dropsitlph": 9702645440,
    "dropsitcph": 9702645440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11728",
    "droptype": "D",
    "dropname": "PALISADE",
    "dropdeladd": "201 W THIRD ST",
    "dropdelcty": "PALISADE",
    "dropdelst": "CO",
    "dropdelzpp": 815263000,
    "dropphyadd": "201 W THIRD ST",
    "dropphycty": "PALISADE",
    "dropphyst": "CO",
    "dropphyzpp": 815263000,
    "dropmaladd": "201 W THIRD ST",
    "dropmalcty": "PALISADE",
    "dropmalst": "CO",
    "dropmalzpp": 815263000,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704647579,
    "dropsitcph": 9704647579,
    "dropfax": 9704645319
  },
  {
    "dcode": "D",
    "dropkey": "PZ11729",
    "droptype": "D",
    "dropname": "PALMER LAKE",
    "dropdeladd": "10 PRIMROSE ST",
    "dropdelcty": "PALMER LAKE",
    "dropdelst": "CO",
    "dropdelzpp": 801339998,
    "dropphyadd": "10 PRIMROSE ST",
    "dropphycty": "PALMER LAKE",
    "dropphyst": "CO",
    "dropphyzpp": 801339998,
    "dropmaladd": "10 PRIMROSE ST",
    "dropmalcty": "PALMER LAKE",
    "dropmalst": "CO",
    "dropmalzpp": 801339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 7194812146,
    "dropsitcph": 7194812146,
    "dropfax": 7194812125
  },
  {
    "dcode": "D",
    "dropkey": "PZ11732",
    "droptype": "D",
    "dropname": "PAONIA",
    "dropdeladd": "125 GRAND AVE",
    "dropdelcty": "PAONIA",
    "dropdelst": "CO",
    "dropdelzpp": 814289997,
    "dropphyadd": "125 GRAND AVE",
    "dropphycty": "PAONIA",
    "dropphyst": "CO",
    "dropphyzpp": 814289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAONIA",
    "dropmalst": "CO",
    "dropmalzpp": 814289998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705273115,
    "dropsitcph": 9705273115,
    "dropfax": 9705273140
  },
  {
    "dcode": "D",
    "dropkey": "PZ11733",
    "droptype": "D",
    "dropname": "PARACHUTE",
    "dropdeladd": "120 N RAILROAD AVE",
    "dropdelcty": "PARACHUTE",
    "dropdelst": "CO",
    "dropdelzpp": 816359997,
    "dropphyadd": "120 N RAILROAD AVE",
    "dropphycty": "PARACHUTE",
    "dropphyst": "CO",
    "dropphyzpp": 816359997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARACHUTE",
    "dropmalst": "CO",
    "dropmalzpp": 816359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702857677,
    "dropsitcph": 9702857677,
    "dropfax": 9702851476
  },
  {
    "dcode": "D",
    "dropkey": "PZ11734",
    "droptype": "D",
    "dropname": "PARADOX",
    "dropdeladd": "21395 6.0 RD",
    "dropdelcty": "PARADOX",
    "dropdelst": "CO",
    "dropdelzpp": 814299802,
    "dropphyadd": "21395 6.0 RD",
    "dropphycty": "PARADOX",
    "dropphyst": "CO",
    "dropphyzpp": 814299802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARADOX",
    "dropmalst": "CO",
    "dropmalzpp": 814299998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708597399,
    "dropsitcph": 9708597399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11737",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "18695 PONY EXPRESS DR",
    "dropdelcty": "PARKER",
    "dropdelst": "CO",
    "dropdelzpp": 801349992,
    "dropphyadd": "18695 PONY EXPRESS DR",
    "dropphycty": "PARKER",
    "dropphyst": "CO",
    "dropphyzpp": 801349992,
    "dropmaladd": "18695 PONY EXPRESS DR",
    "dropmalcty": "PARKER",
    "dropmalst": "CO",
    "dropmalzpp": 801349992,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038413072,
    "dropsitcph": 3038052109,
    "dropfax": 3038416354
  },
  {
    "dcode": "D",
    "dropkey": "PZ11738",
    "droptype": "D",
    "dropname": "PARLIN",
    "dropdeladd": "51387 US HIGHWAY 50",
    "dropdelcty": "PARLIN",
    "dropdelst": "CO",
    "dropdelzpp": 812399605,
    "dropphyadd": "51387 US HIGHWAY 50",
    "dropphycty": "PARLIN",
    "dropphyst": "CO",
    "dropphyzpp": 812399605,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARLIN",
    "dropmalst": "CO",
    "dropmalzpp": 812399998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706414676,
    "dropsitcph": 9706414676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11739",
    "droptype": "D",
    "dropname": "PARSHALL",
    "dropdeladd": "225 COUNTY ROAD 309",
    "dropdelcty": "PARSHALL",
    "dropdelst": "CO",
    "dropdelzpp": 804689997,
    "dropphyadd": "225 COUNTY ROAD 309",
    "dropphycty": "PARSHALL",
    "dropphyst": "CO",
    "dropphyzpp": 804689997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARSHALL",
    "dropmalst": "CO",
    "dropmalzpp": 804689998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707253516,
    "dropsitcph": 9707253516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11740",
    "droptype": "D",
    "dropname": "PEETZ",
    "dropdeladd": "602 MAIN ST",
    "dropdelcty": "PEETZ",
    "dropdelst": "CO",
    "dropdelzpp": 807479998,
    "dropphyadd": "602 MAIN ST",
    "dropphycty": "PEETZ",
    "dropphyst": "CO",
    "dropphyzpp": 807479998,
    "dropmaladd": "602 MAIN ST",
    "dropmalcty": "PEETZ",
    "dropmalst": "CO",
    "dropmalzpp": 807479998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703342345,
    "dropsitcph": 9703342345,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11742",
    "droptype": "D",
    "dropname": "PENROSE",
    "dropdeladd": "15 WERNER RD",
    "dropdelcty": "PENROSE",
    "dropdelst": "CO",
    "dropdelzpp": 812409227,
    "dropphyadd": "15 WERNER RD",
    "dropphycty": "PENROSE",
    "dropphyst": "CO",
    "dropphyzpp": 812409227,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PENROSE",
    "dropmalst": "CO",
    "dropmalzpp": 812409998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193726333,
    "dropsitcph": 7193726333,
    "dropfax": 7193726587
  },
  {
    "dcode": "D",
    "dropkey": "PZ11747",
    "droptype": "D",
    "dropname": "PEYTON",
    "dropdeladd": "13055 BRADSHAW RD",
    "dropdelcty": "PEYTON",
    "dropdelst": "CO",
    "dropdelzpp": 808319009,
    "dropphyadd": "13055 BRADSHAW RD",
    "dropphycty": "PEYTON",
    "dropphyst": "CO",
    "dropphyzpp": 808319009,
    "dropmaladd": "13055 BRADSHAW RD",
    "dropmalcty": "PEYTON",
    "dropmalst": "CO",
    "dropmalzpp": 808319009,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197492958,
    "dropsitcph": 7197492997,
    "dropfax": 7197490279
  },
  {
    "dcode": "D",
    "dropkey": "PZ11748",
    "droptype": "D",
    "dropname": "PHIPPSBURG",
    "dropdeladd": "21595 SECOND AVE",
    "dropdelcty": "PHIPPSBURG",
    "dropdelst": "CO",
    "dropdelzpp": 804699997,
    "dropphyadd": "21595 SECOND AVE",
    "dropphycty": "PHIPPSBURG",
    "dropphyst": "CO",
    "dropphyzpp": 804699997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PHIPPSBURG",
    "dropmalst": "CO",
    "dropmalzpp": 804699998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707362527,
    "dropsitcph": 9707362527,
    "dropfax": 9707362527
  },
  {
    "dcode": "D",
    "dropkey": "PZ11751",
    "droptype": "D",
    "dropname": "PIERCE",
    "dropdeladd": "500 2ND ST",
    "dropdelcty": "PIERCE",
    "dropdelst": "CO",
    "dropdelzpp": 806509997,
    "dropphyadd": "500 2ND ST",
    "dropphycty": "PIERCE",
    "dropphyst": "CO",
    "dropphyzpp": 806509997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIERCE",
    "dropmalst": "CO",
    "dropmalzpp": 806509998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708342116,
    "dropsitcph": 9708342116,
    "dropfax": 9708347704
  },
  {
    "dcode": "D",
    "dropkey": "PZ11752",
    "droptype": "D",
    "dropname": "PINE",
    "dropdeladd": "187 MOUNT EVANS BLVD",
    "dropdelcty": "PINE",
    "dropdelst": "CO",
    "dropdelzpp": 804709998,
    "dropphyadd": "187 MOUNT EVANS BLVD",
    "dropphycty": "PINE",
    "dropphyst": "CO",
    "dropphyzpp": 804709998,
    "dropmaladd": "187 MOUNT EVANS BLVD",
    "dropmalcty": "PINE",
    "dropmalst": "CO",
    "dropmalzpp": 804709998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038385715,
    "dropsitcph": 3038385715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11754",
    "droptype": "D",
    "dropname": "PINECLIFFE",
    "dropdeladd": "114 PINECLIFF RD",
    "dropdelcty": "PINECLIFFE",
    "dropdelst": "CO",
    "dropdelzpp": 804719997,
    "dropphyadd": "114 PINECLIFF RD",
    "dropphycty": "PINECLIFFE",
    "dropphyst": "CO",
    "dropphyzpp": 804719997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINECLIFFE",
    "dropmalst": "CO",
    "dropmalzpp": 804719998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036427358,
    "dropsitcph": 3036427358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11758",
    "droptype": "D",
    "dropname": "PITKIN",
    "dropdeladd": "419 MAIN ST",
    "dropdelcty": "PITKIN",
    "dropdelst": "CO",
    "dropdelzpp": 812419990,
    "dropphyadd": "419 MAIN ST",
    "dropphycty": "PITKIN",
    "dropphyst": "CO",
    "dropphyzpp": 812419990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PITKIN",
    "dropmalst": "CO",
    "dropmalzpp": 812419998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706419236,
    "dropsitcph": 9706419236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11759",
    "droptype": "D",
    "dropname": "PLACERVILLE",
    "dropdeladd": "300 FRONT ST",
    "dropdelcty": "PLACERVILLE",
    "dropdelst": "CO",
    "dropdelzpp": 814309997,
    "dropphyadd": "300 FRONT ST",
    "dropphycty": "PLACERVILLE",
    "dropphyst": "CO",
    "dropphyzpp": 814309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLACERVILLE",
    "dropmalst": "CO",
    "dropmalzpp": 814309998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707283493,
    "dropsitcph": 9707283493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11761",
    "droptype": "D",
    "dropname": "PLATTEVILLE",
    "dropdeladd": "400 MARION ST",
    "dropdelcty": "PLATTEVILLE",
    "dropdelst": "CO",
    "dropdelzpp": 806519998,
    "dropphyadd": "400 MARION ST",
    "dropphycty": "PLATTEVILLE",
    "dropphyst": "CO",
    "dropphyzpp": 806519998,
    "dropmaladd": "400 MARION ST",
    "dropmalcty": "PLATTEVILLE",
    "dropmalst": "CO",
    "dropmalzpp": 806519998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707852295,
    "dropsitcph": 9707852295,
    "dropfax": 9707850502
  },
  {
    "dcode": "D",
    "dropkey": "PZ11763",
    "droptype": "D",
    "dropname": "PLEASANT VIEW",
    "dropdeladd": "26070 HIGHWAY 491",
    "dropdelcty": "PLEASANT VIEW",
    "dropdelst": "CO",
    "dropdelzpp": 813319997,
    "dropphyadd": "26070 HIGHWAY 491",
    "dropphycty": "PLEASANT VIEW",
    "dropphyst": "CO",
    "dropphyzpp": 813319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLEASANT VIEW",
    "dropmalst": "CO",
    "dropmalzpp": 813319998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705624222,
    "dropsitcph": 9705624222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11765",
    "droptype": "D",
    "dropname": "PONCHA SPRINGS",
    "dropdeladd": "6500 US HIGHWAY 285",
    "dropdelcty": "PONCHA SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 812429990,
    "dropphyadd": "6500 US HIGHWAY 285",
    "dropphycty": "PONCHA SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 812429990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PONCHA SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 812429998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195392117,
    "dropsitcph": 7195392117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11767",
    "droptype": "D",
    "dropname": "POWDERHORN",
    "dropdeladd": "616 COUNTY ROAD 28",
    "dropdelcty": "POWDERHORN",
    "dropdelst": "CO",
    "dropdelzpp": 812439705,
    "dropphyadd": "616 COUNTY ROAD 28",
    "dropphycty": "POWDERHORN",
    "dropphyst": "CO",
    "dropphyzpp": 812439705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POWDERHORN",
    "dropmalst": "CO",
    "dropmalzpp": 812439998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706418737,
    "dropsitcph": 9706418737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11768",
    "droptype": "D",
    "dropname": "PRITCHETT",
    "dropdeladd": "153 RANDOLPH ST",
    "dropdelcty": "PRITCHETT",
    "dropdelst": "CO",
    "dropdelzpp": 810649900,
    "dropphyadd": "153 RANDOLPH ST",
    "dropphycty": "PRITCHETT",
    "dropphyst": "CO",
    "dropphyzpp": 810649900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRITCHETT",
    "dropmalst": "CO",
    "dropmalzpp": 810649998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195234017,
    "dropsitcph": 7195234017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11775",
    "droptype": "D",
    "dropname": "PUEBLO",
    "dropdeladd": "1022 FORTINO BLVD",
    "dropdelcty": "PUEBLO",
    "dropdelst": "CO",
    "dropdelzpp": 810082025,
    "dropphyadd": "1022 FORTINO BLVD",
    "dropphycty": "PUEBLO",
    "dropphyst": "CO",
    "dropphyzpp": 810082025,
    "dropmaladd": "1022 FORTINO BLVD",
    "dropmalcty": "PUEBLO",
    "dropmalst": "CO",
    "dropmalzpp": 810082025,
    "dropsitphn": 7195440309,
    "dropsitlph": 7195434988,
    "dropsitcph": 7195434988,
    "dropfax": 7195437678
  },
  {
    "dcode": "D",
    "dropkey": "PZ11784",
    "droptype": "D",
    "dropname": "RAMAH",
    "dropdeladd": "2 S COMMERCIAL ST",
    "dropdelcty": "RAMAH",
    "dropdelst": "CO",
    "dropdelzpp": 808329700,
    "dropphyadd": "2 S COMMERCIAL ST",
    "dropphycty": "RAMAH",
    "dropphyst": "CO",
    "dropphyzpp": 808329700,
    "dropmaladd": "2 S COMMERCIAL ST",
    "dropmalcty": "RAMAH",
    "dropmalst": "CO",
    "dropmalzpp": 808329700,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195412709,
    "dropsitcph": 7195412709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11785",
    "droptype": "D",
    "dropname": "RAND",
    "dropdeladd": "9786 HIGHWAY 125",
    "dropdelcty": "RAND",
    "dropdelst": "CO",
    "dropdelzpp": 804739997,
    "dropphyadd": "9786 HIGHWAY 125",
    "dropphycty": "RAND",
    "dropphyst": "CO",
    "dropphyzpp": 804739997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAND",
    "dropmalst": "CO",
    "dropmalzpp": 804739998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707234434,
    "dropsitcph": 9707234434,
    "dropfax": 9707234434
  },
  {
    "dcode": "D",
    "dropkey": "PZ11786",
    "droptype": "D",
    "dropname": "RANGELY",
    "dropdeladd": "104 S BIRCH AVE",
    "dropdelcty": "RANGELY",
    "dropdelst": "CO",
    "dropdelzpp": 816489910,
    "dropphyadd": "104 S BIRCH AVE",
    "dropphycty": "RANGELY",
    "dropphyst": "CO",
    "dropphyzpp": 816489910,
    "dropmaladd": "104 S BIRCH AVE",
    "dropmalcty": "RANGELY",
    "dropmalst": "CO",
    "dropmalzpp": 816489910,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706758655,
    "dropsitcph": 9706758655,
    "dropfax": 9706755453
  },
  {
    "dcode": "D",
    "dropkey": "PZ11788",
    "droptype": "D",
    "dropname": "RED CLIFF",
    "dropdeladd": "102 WATER ST",
    "dropdelcty": "RED CLIFF",
    "dropdelst": "CO",
    "dropdelzpp": 816499997,
    "dropphyadd": "102 WATER ST",
    "dropphycty": "RED CLIFF",
    "dropphyst": "CO",
    "dropphyzpp": 816499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED CLIFF",
    "dropmalst": "CO",
    "dropmalzpp": 816499998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708274219,
    "dropsitcph": 9708274219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11790",
    "droptype": "D",
    "dropname": "RED FEATHER LAKES",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "RED FEATHER LAKES",
    "dropdelst": "CO",
    "dropdelzpp": 805459997,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "RED FEATHER LAKES",
    "dropphyst": "CO",
    "dropphyzpp": 805459997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RED FEATHER LAKES",
    "dropmalst": "CO",
    "dropmalzpp": 805459998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708812976,
    "dropsitcph": 9708812976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11796",
    "droptype": "D",
    "dropname": "REDVALE",
    "dropdeladd": "35017 3575 RD",
    "dropdelcty": "REDVALE",
    "dropdelst": "CO",
    "dropdelzpp": 814319997,
    "dropphyadd": "35017 3575 RD",
    "dropphycty": "REDVALE",
    "dropphyst": "CO",
    "dropphyzpp": 814319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDVALE",
    "dropmalst": "CO",
    "dropmalzpp": 814319998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703274880,
    "dropsitcph": 9703274880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11799",
    "droptype": "D",
    "dropname": "RICO",
    "dropdeladd": "28 S GLASGOW AVE",
    "dropdelcty": "RICO",
    "dropdelst": "CO",
    "dropdelzpp": 813329901,
    "dropphyadd": "28 S GLASGOW AVE",
    "dropphycty": "RICO",
    "dropphyst": "CO",
    "dropphyzpp": 813329901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICO",
    "dropmalst": "CO",
    "dropmalzpp": 813329998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9709672563,
    "dropsitcph": 9709672563,
    "dropfax": 9709672563
  },
  {
    "dcode": "D",
    "dropkey": "PZ11800",
    "droptype": "D",
    "dropname": "RIDGWAY",
    "dropdeladd": "485 CLINTON ST",
    "dropdelcty": "RIDGWAY",
    "dropdelst": "CO",
    "dropdelzpp": 814329997,
    "dropphyadd": "485 CLINTON ST",
    "dropphycty": "RIDGWAY",
    "dropphyst": "CO",
    "dropphyzpp": 814329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIDGWAY",
    "dropmalst": "CO",
    "dropmalzpp": 814329998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706265576,
    "dropsitcph": 9706265576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11801",
    "droptype": "D",
    "dropname": "RIFLE",
    "dropdeladd": "330 RAILROAD AVE",
    "dropdelcty": "RIFLE",
    "dropdelst": "CO",
    "dropdelzpp": 816509800,
    "dropphyadd": "330 RAILROAD AVE",
    "dropphycty": "RIFLE",
    "dropphyst": "CO",
    "dropphyzpp": 816509800,
    "dropmaladd": "330 RAILROAD AVE",
    "dropmalcty": "RIFLE",
    "dropmalst": "CO",
    "dropmalzpp": 816509800,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706251070,
    "dropsitcph": 9706251070,
    "dropfax": 9706259430
  },
  {
    "dcode": "D",
    "dropkey": "PZ11807",
    "droptype": "D",
    "dropname": "ROCKVALE",
    "dropdeladd": "615 RAILROAD ST",
    "dropdelcty": "ROCKVALE",
    "dropdelst": "CO",
    "dropdelzpp": 812449990,
    "dropphyadd": "615 RAILROAD ST",
    "dropphycty": "ROCKVALE",
    "dropphyst": "CO",
    "dropphyzpp": 812449990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKVALE",
    "dropmalst": "CO",
    "dropmalzpp": 812449998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197844250,
    "dropsitcph": 7197844250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11808",
    "droptype": "D",
    "dropname": "ROCKY FORD",
    "dropdeladd": "401 N 9TH ST",
    "dropdelcty": "ROCKY FORD",
    "dropdelst": "CO",
    "dropdelzpp": 810671217,
    "dropphyadd": "401 N 9TH ST",
    "dropphycty": "ROCKY FORD",
    "dropphyst": "CO",
    "dropphyzpp": 810671217,
    "dropmaladd": "401 N 9TH ST",
    "dropmalcty": "ROCKY FORD",
    "dropmalst": "CO",
    "dropmalzpp": 810671217,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192547909,
    "dropsitcph": 7192547909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11811",
    "droptype": "D",
    "dropname": "ROGGEN",
    "dropdeladd": "413 FRONT ST",
    "dropdelcty": "ROGGEN",
    "dropdelst": "CO",
    "dropdelzpp": 806529990,
    "dropphyadd": "413 FRONT ST",
    "dropphycty": "ROGGEN",
    "dropphyst": "CO",
    "dropphyzpp": 806529990,
    "dropmaladd": "413 FRONT ST",
    "dropmalcty": "ROGGEN",
    "dropmalst": "CO",
    "dropmalzpp": 806529990,
    "dropsitphn": 3035368656,
    "dropsitlph": 3035368656,
    "dropsitcph": 9708430575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11813",
    "droptype": "D",
    "dropname": "ROLLINSVILLE",
    "dropdeladd": "143 MAIN ST",
    "dropdelcty": "ROLLINSVILLE",
    "dropdelst": "CO",
    "dropdelzpp": 804749990,
    "dropphyadd": "143 MAIN ST",
    "dropphycty": "ROLLINSVILLE",
    "dropphyst": "CO",
    "dropphyzpp": 804749990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROLLINSVILLE",
    "dropmalst": "CO",
    "dropmalzpp": 804749998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032583326,
    "dropsitcph": 3032583326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11814",
    "droptype": "D",
    "dropname": "ROMEO",
    "dropdeladd": "615 2ND AVE",
    "dropdelcty": "ROMEO",
    "dropdelst": "CO",
    "dropdelzpp": 811489100,
    "dropphyadd": "615 2ND AVE",
    "dropphycty": "ROMEO",
    "dropphyst": "CO",
    "dropphyzpp": 811489100,
    "dropmaladd": "615 2ND AVE",
    "dropmalcty": "ROMEO",
    "dropmalst": "CO",
    "dropmalzpp": 811489100,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198435808,
    "dropsitcph": 7198435808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11820",
    "droptype": "D",
    "dropname": "RUSH",
    "dropdeladd": "455 N RUSH RD",
    "dropdelcty": "RUSH",
    "dropdelst": "CO",
    "dropdelzpp": 808339706,
    "dropphyadd": "455 N RUSH RD",
    "dropphycty": "RUSH",
    "dropphyst": "CO",
    "dropphyzpp": 808339706,
    "dropmaladd": "455 N RUSH RD",
    "dropmalcty": "RUSH",
    "dropmalst": "CO",
    "dropmalzpp": 808339706,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194783855,
    "dropsitcph": 7194783855,
    "dropfax": 7194782845
  },
  {
    "dcode": "D",
    "dropkey": "PZ11821",
    "droptype": "D",
    "dropname": "RYE",
    "dropdeladd": "8084 STATE HIGHWAY 165",
    "dropdelcty": "RYE",
    "dropdelst": "CO",
    "dropdelzpp": 810698600,
    "dropphyadd": "8084 STATE HIGHWAY 165",
    "dropphycty": "RYE",
    "dropphyst": "CO",
    "dropphyzpp": 810698600,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RYE",
    "dropmalst": "CO",
    "dropmalzpp": 810699998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194893320,
    "dropsitcph": 7194893320,
    "dropfax": 7194893590
  },
  {
    "dcode": "D",
    "dropkey": "PZ11822",
    "droptype": "D",
    "dropname": "SAGUACHE",
    "dropdeladd": "350 DENVER AVE",
    "dropdelcty": "SAGUACHE",
    "dropdelst": "CO",
    "dropdelzpp": 811499990,
    "dropphyadd": "350 DENVER AVE",
    "dropphycty": "SAGUACHE",
    "dropphyst": "CO",
    "dropphyzpp": 811499990,
    "dropmaladd": "350 DENVER AVE",
    "dropmalcty": "SAGUACHE",
    "dropmalst": "CO",
    "dropmalzpp": 811499990,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196552511,
    "dropsitcph": 7196552511,
    "dropfax": 7196552013
  },
  {
    "dcode": "D",
    "dropkey": "PZ11825",
    "droptype": "D",
    "dropname": "SALIDA",
    "dropdeladd": "310 D ST",
    "dropdelcty": "SALIDA",
    "dropdelst": "CO",
    "dropdelzpp": 812012843,
    "dropphyadd": "310 D ST",
    "dropphycty": "SALIDA",
    "dropphyst": "CO",
    "dropphyzpp": 812012843,
    "dropmaladd": "310 D ST",
    "dropmalcty": "SALIDA",
    "dropmalst": "CO",
    "dropmalzpp": 812012843,
    "dropsitphn": 7195392548,
    "dropsitlph": 7195392548,
    "dropsitcph": 7195392548,
    "dropfax": 7195300763
  },
  {
    "dcode": "D",
    "dropkey": "PZ11832",
    "droptype": "D",
    "dropname": "SAN LUIS",
    "dropdeladd": "13 9TH ST",
    "dropdelcty": "SAN LUIS",
    "dropdelst": "CO",
    "dropdelzpp": 811529998,
    "dropphyadd": "13 9TH ST",
    "dropphycty": "SAN LUIS",
    "dropphyst": "CO",
    "dropphyzpp": 811529998,
    "dropmaladd": "13 9TH ST",
    "dropmalcty": "SAN LUIS",
    "dropmalst": "CO",
    "dropmalzpp": 811529998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196723968,
    "dropsitcph": 7196723968,
    "dropfax": 7196723060
  },
  {
    "dcode": "D",
    "dropkey": "PZ11837",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "810 MAIN ST",
    "dropdelcty": "SANFORD",
    "dropdelst": "CO",
    "dropdelzpp": 811512064,
    "dropphyadd": "810 MAIN ST",
    "dropphycty": "SANFORD",
    "dropphyst": "CO",
    "dropphyzpp": 811512064,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANFORD",
    "dropmalst": "CO",
    "dropmalzpp": 811519998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192745164,
    "dropsitcph": 7192745164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11841",
    "droptype": "D",
    "dropname": "SARGENTS",
    "dropdeladd": "174 MEANS AVE",
    "dropdelcty": "SARGENTS",
    "dropdelst": "CO",
    "dropdelzpp": 812489990,
    "dropphyadd": "174 MEANS AVE",
    "dropphycty": "SARGENTS",
    "dropphyst": "CO",
    "dropphyzpp": 812489990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SARGENTS",
    "dropmalst": "CO",
    "dropmalzpp": 812489998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706411418,
    "dropsitcph": 9706411418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11847",
    "droptype": "D",
    "dropname": "SEDALIA",
    "dropdeladd": "4195 DOUGLAS AVE",
    "dropdelcty": "SEDALIA",
    "dropdelst": "CO",
    "dropdelzpp": 801358001,
    "dropphyadd": "4195 DOUGLAS AVE",
    "dropphycty": "SEDALIA",
    "dropphyst": "CO",
    "dropphyzpp": 801358001,
    "dropmaladd": "4195 DOUGLAS AVE",
    "dropmalcty": "SEDALIA",
    "dropmalst": "CO",
    "dropmalzpp": 801358001,
    "dropsitphn": 3038536511,
    "dropsitlph": 7207331896,
    "dropsitcph": 7207331896,
    "dropfax": 7207331849
  },
  {
    "dcode": "D",
    "dropkey": "PZ11848",
    "droptype": "D",
    "dropname": "SEDGWICK",
    "dropdeladd": "211 MAIN AVE",
    "dropdelcty": "SEDGWICK",
    "dropdelst": "CO",
    "dropdelzpp": 807499998,
    "dropphyadd": "211 MAIN AVE",
    "dropphycty": "SEDGWICK",
    "dropphyst": "CO",
    "dropphyzpp": 807499998,
    "dropmaladd": "211 MAIN AVE",
    "dropmalcty": "SEDGWICK",
    "dropmalst": "CO",
    "dropmalzpp": 807499998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704635690,
    "dropsitcph": 9704635690,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11849",
    "droptype": "D",
    "dropname": "SEGUNDO",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "TRINIDAD",
    "dropdelst": "CO",
    "dropdelzpp": 810822712,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "TRINIDAD",
    "dropphyst": "CO",
    "dropphyzpp": 810822712,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "TRINIDAD",
    "dropmalst": "CO",
    "dropmalzpp": 810822712,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705409,
    "dropsitcph": 7198466775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11850",
    "droptype": "D",
    "dropname": "SEIBERT",
    "dropdeladd": "113 COLORADO AVE",
    "dropdelcty": "SEIBERT",
    "dropdelst": "CO",
    "dropdelzpp": 808349332,
    "dropphyadd": "113 COLORADO AVE",
    "dropphycty": "SEIBERT",
    "dropphyst": "CO",
    "dropphyzpp": 808349332,
    "dropmaladd": "113 COLORADO AVE",
    "dropmalcty": "SEIBERT",
    "dropmalst": "CO",
    "dropmalzpp": 808349332,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706642315,
    "dropsitcph": 9706642315,
    "dropfax": 9706642291
  },
  {
    "dcode": "D",
    "dropkey": "PZ11851",
    "droptype": "D",
    "dropname": "SEVERANCE",
    "dropdeladd": "320 1ST ST",
    "dropdelcty": "SEVERANCE",
    "dropdelst": "CO",
    "dropdelzpp": 805469997,
    "dropphyadd": "320 1ST ST",
    "dropphycty": "SEVERANCE",
    "dropphyst": "CO",
    "dropphyzpp": 805469997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEVERANCE",
    "dropmalst": "CO",
    "dropmalzpp": 805469998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706862697,
    "dropsitcph": 9706862697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11853",
    "droptype": "D",
    "dropname": "SHAWNEE",
    "dropdeladd": "56052 S HIGHWAY 285",
    "dropdelcty": "SHAWNEE",
    "dropdelst": "CO",
    "dropdelzpp": 804759997,
    "dropphyadd": "56052 S HIGHWAY 285",
    "dropphycty": "SHAWNEE",
    "dropphyst": "CO",
    "dropphyzpp": 804759997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAWNEE",
    "dropmalst": "CO",
    "dropmalzpp": 804759998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038389512,
    "dropsitcph": 3038389512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11856",
    "droptype": "D",
    "dropname": "SHERIDAN LAKE",
    "dropdeladd": "619 BURNETTE ST",
    "dropdelcty": "SHERIDAN LAKE",
    "dropdelst": "CO",
    "dropdelzpp": 810719628,
    "dropphyadd": "619 BURNETTE ST",
    "dropphycty": "SHERIDAN LAKE",
    "dropphyst": "CO",
    "dropphyzpp": 810719628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHERIDAN LAKE",
    "dropmalst": "CO",
    "dropmalzpp": 810719998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199413649,
    "dropsitcph": 7199413649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11857",
    "droptype": "D",
    "dropname": "SILT",
    "dropdeladd": "116 LYON BLVD",
    "dropdelcty": "SILT",
    "dropdelst": "CO",
    "dropdelzpp": 816529997,
    "dropphyadd": "116 LYON BLVD",
    "dropphycty": "SILT",
    "dropphyst": "CO",
    "dropphyzpp": 816529997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILT",
    "dropmalst": "CO",
    "dropmalzpp": 816529998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708762250,
    "dropsitcph": 9708762250,
    "dropfax": 9708765059
  },
  {
    "dcode": "D",
    "dropkey": "PZ11859",
    "droptype": "D",
    "dropname": "SILVER PLUME",
    "dropdeladd": "850 MAIN ST",
    "dropdelcty": "SILVER PLUME",
    "dropdelst": "CO",
    "dropdelzpp": 804769800,
    "dropphyadd": "850 MAIN ST",
    "dropphycty": "SILVER PLUME",
    "dropphyst": "CO",
    "dropphyzpp": 804769800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER PLUME",
    "dropmalst": "CO",
    "dropmalzpp": 804769998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035693121,
    "dropsitcph": 3035693121,
    "dropfax": 3035693121
  },
  {
    "dcode": "D",
    "dropkey": "PZ11862",
    "droptype": "D",
    "dropname": "SILVERTON",
    "dropdeladd": "138 W 12TH ST",
    "dropdelcty": "SILVERTON",
    "dropdelst": "CO",
    "dropdelzpp": 814339997,
    "dropphyadd": "138 W 12TH ST",
    "dropphycty": "SILVERTON",
    "dropphyst": "CO",
    "dropphyzpp": 814339997,
    "dropmaladd": "138 W 12TH ST",
    "dropmalcty": "SILVERTON",
    "dropmalst": "CO",
    "dropmalzpp": 814339997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703875402,
    "dropsitcph": 9703875402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11863",
    "droptype": "D",
    "dropname": "SIMLA",
    "dropdeladd": "611 CARIBOU ST",
    "dropdelcty": "SIMLA",
    "dropdelst": "CO",
    "dropdelzpp": 808359778,
    "dropphyadd": "611 CARIBOU ST",
    "dropphycty": "SIMLA",
    "dropphyst": "CO",
    "dropphyzpp": 808359778,
    "dropmaladd": "611 CARIBOU ST",
    "dropmalcty": "SIMLA",
    "dropmalst": "CO",
    "dropmalzpp": 808359778,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195412490,
    "dropsitcph": 7195412490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11865",
    "droptype": "D",
    "dropname": "SLATER",
    "dropdeladd": "681 COUNTY ROAD 129",
    "dropdelcty": "SLATER",
    "dropdelst": "CO",
    "dropdelzpp": 816539800,
    "dropphyadd": "681 COUNTY ROAD 129",
    "dropphycty": "SLATER",
    "dropphyst": "CO",
    "dropphyzpp": 816539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SLATER",
    "dropmalst": "CO",
    "dropmalzpp": 816539998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705832454,
    "dropsitcph": 9705832454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11871",
    "droptype": "D",
    "dropname": "SNOWMASS",
    "dropdeladd": "26900 HIGHWAY 82",
    "dropdelcty": "SNOWMASS",
    "dropdelst": "CO",
    "dropdelzpp": 816549997,
    "dropphyadd": "26900 HIGHWAY 82",
    "dropphycty": "SNOWMASS",
    "dropphyst": "CO",
    "dropphyzpp": 816549001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNOWMASS",
    "dropmalst": "CO",
    "dropmalzpp": 816549998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704524044,
    "dropsitcph": 9704524044,
    "dropfax": 9709271451
  },
  {
    "dcode": "D",
    "dropkey": "PZ11873",
    "droptype": "D",
    "dropname": "SNYDER",
    "dropdeladd": "22836 WINCHELL AVE",
    "dropdelcty": "SNYDER",
    "dropdelst": "CO",
    "dropdelzpp": 807509998,
    "dropphyadd": "22836 WINCHELL AVE",
    "dropphycty": "SNYDER",
    "dropphyst": "CO",
    "dropphyzpp": 807509998,
    "dropmaladd": "22836 WINCHELL AVE",
    "dropmalcty": "SNYDER",
    "dropmalst": "CO",
    "dropmalzpp": 807509998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708425823,
    "dropsitcph": 9708425823,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11875",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "3722 HIGHWAY 133",
    "dropdelcty": "SOMERSET",
    "dropdelst": "CO",
    "dropdelzpp": 814349997,
    "dropphyadd": "3722 HIGHWAY 133",
    "dropphycty": "SOMERSET",
    "dropphyst": "CO",
    "dropphyzpp": 814349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMERSET",
    "dropmalst": "CO",
    "dropmalzpp": 814349998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709295145,
    "dropsitcph": 9709295145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11879",
    "droptype": "D",
    "dropname": "SOUTH FORK",
    "dropdeladd": "130 W FRONTAGE RD",
    "dropdelcty": "SOUTH FORK",
    "dropdelst": "CO",
    "dropdelzpp": 811549990,
    "dropphyadd": "130 W FRONTAGE RD",
    "dropphycty": "SOUTH FORK",
    "dropphyst": "CO",
    "dropphyzpp": 811549990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH FORK",
    "dropmalst": "CO",
    "dropmalzpp": 811549998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198735325,
    "dropsitcph": 7198735325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11884",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "188 E 9TH AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "CO",
    "dropdelzpp": 810731602,
    "dropphyadd": "188 E 9TH AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "CO",
    "dropphyzpp": 810731602,
    "dropmaladd": "188 E 9TH AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "CO",
    "dropmalzpp": 810731602,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195236609,
    "dropsitcph": 7195236609,
    "dropfax": 7195230161
  },
  {
    "dcode": "D",
    "dropkey": "PZ11904",
    "droptype": "D",
    "dropname": "STEAMBOAT SPRINGS",
    "dropdeladd": "200 LINCOLN AVE",
    "dropdelcty": "STEAMBOAT SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 804879998,
    "dropphyadd": "200 LINCOLN AVE",
    "dropphycty": "STEAMBOAT SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 804879998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEAMBOAT SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 804779998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708798360,
    "dropsitcph": 9708798360,
    "dropfax": 9708700770
  },
  {
    "dcode": "D",
    "dropkey": "PZ11905",
    "droptype": "D",
    "dropname": "STERLING",
    "dropdeladd": "306 POPLAR ST",
    "dropdelcty": "STERLING",
    "dropdelst": "CO",
    "dropdelzpp": 807519998,
    "dropphyadd": "306 POPLAR ST",
    "dropphycty": "STERLING",
    "dropphyst": "CO",
    "dropphyzpp": 807519998,
    "dropmaladd": "306 POPLAR ST",
    "dropmalcty": "STERLING",
    "dropmalst": "CO",
    "dropmalzpp": 807519998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705224307,
    "dropsitcph": 9705224307,
    "dropfax": 9705229251
  },
  {
    "dcode": "D",
    "dropkey": "PZ11907",
    "droptype": "D",
    "dropname": "STONEHAM",
    "dropdeladd": "41621 MARBLE AVE",
    "dropdelcty": "STONEHAM",
    "dropdelst": "CO",
    "dropdelzpp": 807549998,
    "dropphyadd": "41621 MARBLE AVE",
    "dropphycty": "STONEHAM",
    "dropphyst": "CO",
    "dropphyzpp": 807549998,
    "dropmaladd": "41621 MARBLE AVE",
    "dropmalcty": "STONEHAM",
    "dropmalst": "CO",
    "dropmalzpp": 807549998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707352256,
    "dropsitcph": 9707352256,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11913",
    "droptype": "D",
    "dropname": "STRASBURG",
    "dropdeladd": "56691 E COLFAX AVE",
    "dropdelcty": "STRASBURG",
    "dropdelst": "CO",
    "dropdelzpp": 801369998,
    "dropphyadd": "56691 E COLFAX AVE",
    "dropphycty": "STRASBURG",
    "dropphyst": "CO",
    "dropphyzpp": 801369998,
    "dropmaladd": "56691 E COLFAX AVE",
    "dropmalcty": "STRASBURG",
    "dropmalst": "CO",
    "dropmalzpp": 801369998,
    "dropsitphn": 3036229866,
    "dropsitlph": 3036229866,
    "dropsitcph": 3036229866,
    "dropfax": 3036229868
  },
  {
    "dcode": "D",
    "dropkey": "PZ11914",
    "droptype": "D",
    "dropname": "STRATTON",
    "dropdeladd": "313 COLORADO AVE",
    "dropdelcty": "STRATTON",
    "dropdelst": "CO",
    "dropdelzpp": 808369998,
    "dropphyadd": "313 COLORADO AVE",
    "dropphycty": "STRATTON",
    "dropphyst": "CO",
    "dropphyzpp": 808369998,
    "dropmaladd": "313 COLORADO AVE",
    "dropmalcty": "STRATTON",
    "dropmalst": "CO",
    "dropmalzpp": 808369998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193485267,
    "dropsitcph": 7193485267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11915",
    "droptype": "D",
    "dropname": "SUGAR CITY",
    "dropdeladd": "208 COLORADO AVE",
    "dropdelcty": "SUGAR CITY",
    "dropdelst": "CO",
    "dropdelzpp": 810769700,
    "dropphyadd": "208 COLORADO AVE",
    "dropphycty": "SUGAR CITY",
    "dropphyst": "CO",
    "dropphyzpp": 810769700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUGAR CITY",
    "dropmalst": "CO",
    "dropmalzpp": 810769998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192673333,
    "dropsitcph": 7192673333,
    "dropfax": 7192673478
  },
  {
    "dcode": "D",
    "dropkey": "PZ11924",
    "droptype": "D",
    "dropname": "SWINK",
    "dropdeladd": "302 COLUMBIA AVE",
    "dropdelcty": "SWINK",
    "dropdelst": "CO",
    "dropdelzpp": 810779900,
    "dropphyadd": "302 COLUMBIA AVE",
    "dropphycty": "SWINK",
    "dropphyst": "CO",
    "dropphyzpp": 810779900,
    "dropmaladd": "302 COLUMBIA AVE",
    "dropmalcty": "SWINK",
    "dropmalst": "CO",
    "dropmalzpp": 810779900,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193847242,
    "dropsitcph": 7193847242,
    "dropfax": 7193845249
  },
  {
    "dcode": "D",
    "dropkey": "PZ11926",
    "droptype": "D",
    "dropname": "TABERNASH",
    "dropdeladd": "72147 HIGHWAY 40",
    "dropdelcty": "TABERNASH",
    "dropdelst": "CO",
    "dropdelzpp": 804789997,
    "dropphyadd": "72147 HIGHWAY 40",
    "dropphycty": "TABERNASH",
    "dropphyst": "CO",
    "dropphyzpp": 804789997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TABERNASH",
    "dropmalst": "CO",
    "dropmalzpp": 804789998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707268249,
    "dropsitcph": 9707268249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11933",
    "droptype": "D",
    "dropname": "TELLURIDE",
    "dropdeladd": "150 S WILLOW ST",
    "dropdelcty": "TELLURIDE",
    "dropdelst": "CO",
    "dropdelzpp": 814359956,
    "dropphyadd": "150 S WILLOW ST",
    "dropphycty": "TELLURIDE",
    "dropphyst": "CO",
    "dropphyzpp": 814359956,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TELLURIDE",
    "dropmalst": "CO",
    "dropmalzpp": 814359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707283900,
    "dropsitcph": 9707283900,
    "dropfax": 9707285532
  },
  {
    "dcode": "D",
    "dropkey": "PZ11945",
    "droptype": "D",
    "dropname": "TIMNATH",
    "dropdeladd": "4128 MAIN ST",
    "dropdelcty": "TIMNATH",
    "dropdelst": "CO",
    "dropdelzpp": 805479997,
    "dropphyadd": "4128 MAIN ST",
    "dropphycty": "TIMNATH",
    "dropphyst": "CO",
    "dropphyzpp": 805479997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIMNATH",
    "dropmalst": "CO",
    "dropmalzpp": 805479998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704826721,
    "dropsitcph": 9704826721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11951",
    "droptype": "D",
    "dropname": "TOPONAS",
    "dropdeladd": "33650 COUNTY ROAD 5",
    "dropdelcty": "TOPONAS",
    "dropdelst": "CO",
    "dropdelzpp": 804799997,
    "dropphyadd": "33650 COUNTY ROAD 5",
    "dropphycty": "TOPONAS",
    "dropphyst": "CO",
    "dropphyzpp": 804799997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOPONAS",
    "dropmalst": "CO",
    "dropmalzpp": 804799998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706380072,
    "dropsitcph": 9706380072,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11953",
    "droptype": "D",
    "dropname": "TOWAOC",
    "dropdeladd": "119.8 MIKE WASH RD",
    "dropdelcty": "TOWAOC",
    "dropdelst": "CO",
    "dropdelzpp": 813349801,
    "dropphyadd": "119.8 MIKE WASH RD",
    "dropphycty": "TOWAOC",
    "dropphyst": "CO",
    "dropphyzpp": 813349801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOWAOC",
    "dropmalst": "CO",
    "dropmalzpp": 813349998,
    "dropsitphn": 7195705409,
    "dropsitlph": 9705656411,
    "dropsitcph": 9705656411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11956",
    "droptype": "D",
    "dropname": "TRINCHERA",
    "dropdeladd": "60994 COUNTY ROAD 8.8",
    "dropdelcty": "TRINCHERA",
    "dropdelst": "CO",
    "dropdelzpp": 810819990,
    "dropphyadd": "60994 COUNTY ROAD 8.8",
    "dropphycty": "TRINCHERA",
    "dropphyst": "CO",
    "dropphyzpp": 810819990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRINCHERA",
    "dropmalst": "CO",
    "dropmalzpp": 810819998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199465225,
    "dropsitcph": 7199465225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11957",
    "droptype": "D",
    "dropname": "TRINIDAD",
    "dropdeladd": "301 E MAIN ST",
    "dropdelcty": "TRINIDAD",
    "dropdelst": "CO",
    "dropdelzpp": 810829998,
    "dropphyadd": "301 E MAIN ST",
    "dropphycty": "TRINIDAD",
    "dropphyst": "CO",
    "dropphyzpp": 810829998,
    "dropmaladd": "301 E MAIN ST",
    "dropmalcty": "TRINIDAD",
    "dropmalst": "CO",
    "dropmalzpp": 810829998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198450369,
    "dropsitcph": 7198451017,
    "dropfax": 7198464338
  },
  {
    "dcode": "D",
    "dropkey": "PZ11963",
    "droptype": "D",
    "dropname": "TWO BUTTES",
    "dropdeladd": "448 MAIN ST",
    "dropdelcty": "TWO BUTTES",
    "dropdelst": "CO",
    "dropdelzpp": 810849900,
    "dropphyadd": "448 MAIN ST",
    "dropphycty": "TWO BUTTES",
    "dropphyst": "CO",
    "dropphyzpp": 810849900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWO BUTTES",
    "dropmalst": "CO",
    "dropmalzpp": 810849998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193265201,
    "dropsitcph": 7193265201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11966",
    "droptype": "D",
    "dropname": "USAF ACADEMY",
    "dropdeladd": "5136 COMMUNITY CENTER DR",
    "dropdelcty": "USAF ACADEMY",
    "dropdelst": "CO",
    "dropdelzpp": 808409998,
    "dropphyadd": "5136 COMMUNITY CENTER DR",
    "dropphycty": "USAF ACADEMY",
    "dropphyst": "CO",
    "dropphyzpp": 808403099,
    "dropmaladd": "5136 COMMUNITY CENTER DR",
    "dropmalcty": "USAF ACADEMY",
    "dropmalst": "CO",
    "dropmalzpp": 808409998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194720537,
    "dropsitcph": 7194720537,
    "dropfax": 7194726549
  },
  {
    "dcode": "D",
    "dropkey": "PZ11981",
    "droptype": "D",
    "dropname": "VAIL",
    "dropdeladd": "1300 N FRONTAGE RD W",
    "dropdelcty": "VAIL",
    "dropdelst": "CO",
    "dropdelzpp": 816579998,
    "dropphyadd": "1300 N FRONTAGE RD W",
    "dropphycty": "VAIL",
    "dropphyst": "CO",
    "dropphyzpp": 816579998,
    "dropmaladd": "1300 N FRONTAGE RD W",
    "dropmalcty": "VAIL",
    "dropmalst": "CO",
    "dropmalzpp": 816579998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704761494,
    "dropsitcph": 9704761494,
    "dropfax": 9704761065
  },
  {
    "dcode": "D",
    "dropkey": "PZ11985",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "26101 WASHINGTON ST",
    "dropdelcty": "VERNON",
    "dropdelst": "CO",
    "dropdelzpp": 807559998,
    "dropphyadd": "26101 WASHINGTON ST",
    "dropphycty": "VERNON",
    "dropphyst": "CO",
    "dropphyzpp": 807559998,
    "dropmaladd": "26101 WASHINGTON ST",
    "dropmalcty": "VERNON",
    "dropmalst": "CO",
    "dropmalzpp": 807559998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703324713,
    "dropsitcph": 9703324713,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ11986",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "106 N 3RD ST",
    "dropdelcty": "VICTOR",
    "dropdelst": "CO",
    "dropdelzpp": 808609700,
    "dropphyadd": "106 N 3RD ST",
    "dropphycty": "VICTOR",
    "dropphyst": "CO",
    "dropphyzpp": 808609700,
    "dropmaladd": "106 N 3RD ST",
    "dropmalcty": "VICTOR",
    "dropmalst": "CO",
    "dropmalzpp": 808609700,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196892360,
    "dropsitcph": 7196892360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11988",
    "droptype": "D",
    "dropname": "VILAS",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "VILAS",
    "dropdelst": "CO",
    "dropdelzpp": 810879900,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "VILAS",
    "dropphyst": "CO",
    "dropphyzpp": 810879900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILAS",
    "dropmalst": "CO",
    "dropmalzpp": 810879998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195234658,
    "dropsitcph": 7195234658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11989",
    "droptype": "D",
    "dropname": "VILLA GROVE",
    "dropdeladd": "33937 US HIGHWAY 285",
    "dropdelcty": "VILLA GROVE",
    "dropdelst": "CO",
    "dropdelzpp": 811559990,
    "dropphyadd": "33937 US HIGHWAY 285",
    "dropphycty": "VILLA GROVE",
    "dropphyst": "CO",
    "dropphyzpp": 811559990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VILLA GROVE",
    "dropmalst": "CO",
    "dropmalzpp": 811559998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196552333,
    "dropsitcph": 7196552333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11994",
    "droptype": "D",
    "dropname": "VONA",
    "dropdeladd": "1263 1ST AVE",
    "dropdelcty": "VONA",
    "dropdelst": "CO",
    "dropdelzpp": 808619405,
    "dropphyadd": "1263 1ST AVE",
    "dropphycty": "VONA",
    "dropphyst": "CO",
    "dropphyzpp": 808619405,
    "dropmaladd": "1263 1ST AVE",
    "dropmalcty": "VONA",
    "dropmalst": "CO",
    "dropmalzpp": 808619405,
    "dropsitphn": 7195705409,
    "dropsitlph": 9706642230,
    "dropsitcph": 9706642230,
    "dropfax": 9706642230
  },
  {
    "dcode": "D",
    "dropkey": "PZ11998",
    "droptype": "D",
    "dropname": "WALDEN",
    "dropdeladd": "485 MAIN ST",
    "dropdelcty": "WALDEN",
    "dropdelst": "CO",
    "dropdelzpp": 804809997,
    "dropphyadd": "485 MAIN ST",
    "dropphycty": "WALDEN",
    "dropphyst": "CO",
    "dropphyzpp": 804809997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALDEN",
    "dropmalst": "CO",
    "dropmalzpp": 804809998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707234321,
    "dropsitcph": 9707234321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ11999",
    "droptype": "D",
    "dropname": "WALSENBURG",
    "dropdeladd": "204 E 6TH ST",
    "dropdelcty": "WALSENBURG",
    "dropdelst": "CO",
    "dropdelzpp": 810892022,
    "dropphyadd": "204 E 6TH ST",
    "dropphycty": "WALSENBURG",
    "dropphyst": "CO",
    "dropphyzpp": 810892022,
    "dropmaladd": "204 E 6TH ST",
    "dropmalcty": "WALSENBURG",
    "dropmalst": "CO",
    "dropmalzpp": 810892022,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197385762,
    "dropsitcph": 7197386093,
    "dropfax": 7197381132
  },
  {
    "dcode": "D",
    "dropkey": "PZ12000",
    "droptype": "D",
    "dropname": "WALSH",
    "dropdeladd": "529 COLORADO AVE",
    "dropdelcty": "WALSH",
    "dropdelst": "CO",
    "dropdelzpp": 810909900,
    "dropphyadd": "529 COLORADO AVE",
    "dropphycty": "WALSH",
    "dropphyst": "CO",
    "dropphyzpp": 810909900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALSH",
    "dropmalst": "CO",
    "dropmalzpp": 810909998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7193245700,
    "dropsitcph": 7193245700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12002",
    "droptype": "D",
    "dropname": "WARD",
    "dropdeladd": "1 COLUMBIA ST",
    "dropdelcty": "WARD",
    "dropdelst": "CO",
    "dropdelzpp": 804819900,
    "dropphyadd": "1 COLUMBIA ST",
    "dropphycty": "WARD",
    "dropphyst": "CO",
    "dropphyzpp": 804819900,
    "dropmaladd": "1 COLUMBIA ST",
    "dropmalcty": "WARD",
    "dropmalst": "CO",
    "dropmalzpp": 804819900,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034590255,
    "dropsitcph": 3034590255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12004",
    "droptype": "D",
    "dropname": "WATKINS",
    "dropdeladd": "33151 E 16TH DR",
    "dropdelcty": "WATKINS",
    "dropdelst": "CO",
    "dropdelzpp": 801376826,
    "dropphyadd": "33151 E 16TH DR",
    "dropphycty": "WATKINS",
    "dropphyst": "CO",
    "dropphyzpp": 801376826,
    "dropmaladd": "33151 E 16TH DR",
    "dropmalcty": "WATKINS",
    "dropmalst": "CO",
    "dropmalzpp": 801376826,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032619655,
    "dropsitcph": 3032619655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12008",
    "droptype": "D",
    "dropname": "WELDONA",
    "dropdeladd": "209 RAILROAD AVE",
    "dropdelcty": "WELDONA",
    "dropdelst": "CO",
    "dropdelzpp": 806539900,
    "dropphyadd": "209 RAILROAD AVE",
    "dropphycty": "WELDONA",
    "dropphyst": "CO",
    "dropphyzpp": 806539900,
    "dropmaladd": "209 RAILROAD AVE",
    "dropmalcty": "WELDONA",
    "dropmalst": "CO",
    "dropmalzpp": 806539900,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706452419,
    "dropsitcph": 9706452419,
    "dropfax": 9706459832
  },
  {
    "dcode": "D",
    "dropkey": "PZ12009",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "3829 W CLEVELAND AVE",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "CO",
    "dropdelzpp": 805499997,
    "dropphyadd": "3829 W CLEVELAND AVE",
    "dropphycty": "WELLINGTON",
    "dropphyst": "CO",
    "dropphyzpp": 805499997,
    "dropmaladd": "3829 W CLEVELAND AVE",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "CO",
    "dropmalzpp": 805499997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705683913,
    "dropsitcph": 9705683913,
    "dropfax": 9705683683
  },
  {
    "dcode": "D",
    "dropkey": "PZ12018",
    "droptype": "D",
    "dropname": "WESTCLIFFE",
    "dropdeladd": "4 BASSICK PL",
    "dropdelcty": "WESTCLIFFE",
    "dropdelst": "CO",
    "dropdelzpp": 812529990,
    "dropphyadd": "4 BASSICK PL",
    "dropphycty": "WESTCLIFFE",
    "dropphyst": "CO",
    "dropphyzpp": 812529990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTCLIFFE",
    "dropmalst": "CO",
    "dropmalzpp": 812529998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197832453,
    "dropsitcph": 7197832453,
    "dropfax": 7197833353
  },
  {
    "dcode": "D",
    "dropkey": "PZ12024",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "3051 W 105TH AVE",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CO",
    "dropdelzpp": 800319998,
    "dropphyadd": "3051 W 105TH AVE",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CO",
    "dropphyzpp": 800319998,
    "dropmaladd": "3051 W 105TH AVE",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CO",
    "dropmalzpp": 800319998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034649573,
    "dropsitcph": 3034649941,
    "dropfax": 3034640396
  },
  {
    "dcode": "D",
    "dropkey": "PZ12025",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "16900 STATE HIGHWAY 12",
    "dropdelcty": "WESTON",
    "dropdelst": "CO",
    "dropdelzpp": 810919900,
    "dropphyadd": "16900 STATE HIGHWAY 12",
    "dropphycty": "WESTON",
    "dropphyst": "CO",
    "dropphyzpp": 810919900,
    "dropmaladd": "16900 STATE HIGHWAY 12",
    "dropmalcty": "WESTON",
    "dropmalst": "CO",
    "dropmalzpp": 810919900,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198682236,
    "dropsitcph": 7198682236,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12028",
    "droptype": "D",
    "dropname": "WETMORE",
    "dropdeladd": "682 COUNTY ROAD 395",
    "dropdelcty": "WETMORE",
    "dropdelst": "CO",
    "dropdelzpp": 812539500,
    "dropphyadd": "682 COUNTY ROAD 395",
    "dropphycty": "WETMORE",
    "dropphyst": "CO",
    "dropphyzpp": 812539500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WETMORE",
    "dropmalst": "CO",
    "dropmalzpp": 812539998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7197843205,
    "dropsitcph": 7197843205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12031",
    "droptype": "D",
    "dropname": "WHEAT RIDGE",
    "dropdeladd": "4210 WADSWORTH BLVD",
    "dropdelcty": "WHEAT RIDGE",
    "dropdelst": "CO",
    "dropdelzpp": 800339998,
    "dropphyadd": "4210 WADSWORTH BLVD",
    "dropphycty": "WHEAT RIDGE",
    "dropphyst": "CO",
    "dropphyzpp": 800339998,
    "dropmaladd": "4210 WADSWORTH BLVD",
    "dropmalcty": "WHEAT RIDGE",
    "dropmalst": "CO",
    "dropmalzpp": 800339998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037854470,
    "dropsitcph": 3034254179,
    "dropfax": 3034316504
  },
  {
    "dcode": "D",
    "dropkey": "PZ12034",
    "droptype": "D",
    "dropname": "WHITEWATER",
    "dropdeladd": "109 SHORT ST",
    "dropdelcty": "WHITEWATER",
    "dropdelst": "CO",
    "dropdelzpp": 815279997,
    "dropphyadd": "109 SHORT ST",
    "dropphycty": "WHITEWATER",
    "dropphyst": "CO",
    "dropphyzpp": 815279997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITEWATER",
    "dropmalst": "CO",
    "dropmalzpp": 815279998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702413809,
    "dropsitcph": 9702413809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12036",
    "droptype": "D",
    "dropname": "WIGGINS",
    "dropdeladd": "505 CENTRAL AVE",
    "dropdelcty": "WIGGINS",
    "dropdelst": "CO",
    "dropdelzpp": 806548618,
    "dropphyadd": "505 CENTRAL AVE",
    "dropphycty": "WIGGINS",
    "dropphyst": "CO",
    "dropphyzpp": 806548618,
    "dropmaladd": "505 CENTRAL AVE",
    "dropmalcty": "WIGGINS",
    "dropmalst": "CO",
    "dropmalzpp": 806548618,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704837769,
    "dropsitcph": 9704837769,
    "dropfax": 9704837363
  },
  {
    "dcode": "D",
    "dropkey": "PZ12037",
    "droptype": "D",
    "dropname": "WILD HORSE",
    "dropdeladd": "8511 US HIGHWAY 40-287",
    "dropdelcty": "WILD HORSE",
    "dropdelst": "CO",
    "dropdelzpp": 808629998,
    "dropphyadd": "8511 US HIGHWAY 40-287",
    "dropphycty": "WILD HORSE",
    "dropphyst": "CO",
    "dropphyzpp": 808629998,
    "dropmaladd": "8511 US HIGHWAY 40-287",
    "dropmalcty": "WILD HORSE",
    "dropmalst": "CO",
    "dropmalzpp": 808629998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7199623488,
    "dropsitcph": 7199623488,
    "dropfax": 7199623488
  },
  {
    "dcode": "D",
    "dropkey": "PZ12039",
    "droptype": "D",
    "dropname": "WILEY",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "WILEY",
    "dropdelst": "CO",
    "dropdelzpp": 810929900,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "WILEY",
    "dropphyst": "CO",
    "dropphyzpp": 810929900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILEY",
    "dropmalst": "CO",
    "dropmalzpp": 810929998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7198294953,
    "dropsitcph": 7198294953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12042",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "215 6TH ST",
    "dropdelcty": "WINDSOR",
    "dropdelst": "CO",
    "dropdelzpp": 805509997,
    "dropphyadd": "215 6TH ST",
    "dropphycty": "WINDSOR",
    "dropphyst": "CO",
    "dropphyzpp": 805509997,
    "dropmaladd": "215 6TH ST",
    "dropmalcty": "WINDSOR",
    "dropmalst": "CO",
    "dropmalzpp": 805509997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708333010,
    "dropsitcph": 9708333010,
    "dropfax": 9706867525
  },
  {
    "dcode": "D",
    "dropkey": "PZ12044",
    "droptype": "D",
    "dropname": "WINTER PARK",
    "dropdeladd": "78490 US HIGHWAY 40",
    "dropdelcty": "WINTER PARK",
    "dropdelst": "CO",
    "dropdelzpp": 804829997,
    "dropphyadd": "78490 US HIGHWAY 40",
    "dropphycty": "WINTER PARK",
    "dropphyst": "CO",
    "dropphyzpp": 804829997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINTER PARK",
    "dropmalst": "CO",
    "dropmalzpp": 804829998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9707268257,
    "dropsitcph": 9707266775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12045",
    "droptype": "D",
    "dropname": "WOLCOTT",
    "dropdeladd": "28000 HIGHWAY 6",
    "dropdelcty": "WOLCOTT",
    "dropdelst": "CO",
    "dropdelzpp": 816559800,
    "dropphyadd": "28000 HIGHWAY 6",
    "dropphycty": "WOLCOTT",
    "dropphyst": "CO",
    "dropphyzpp": 816559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOLCOTT",
    "dropmalst": "CO",
    "dropmalzpp": 816559998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709265417,
    "dropsitcph": 9709265417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12046",
    "droptype": "D",
    "dropname": "WOODLAND PARK",
    "dropdeladd": "300 W SOUTH AVE",
    "dropdelcty": "WOODLAND PARK",
    "dropdelst": "CO",
    "dropdelzpp": 808632344,
    "dropphyadd": "300 W SOUTH AVE",
    "dropphycty": "WOODLAND PARK",
    "dropphyst": "CO",
    "dropphyzpp": 808632344,
    "dropmaladd": "300 W SOUTH AVE",
    "dropmalcty": "WOODLAND PARK",
    "dropmalst": "CO",
    "dropmalzpp": 808632344,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196876179,
    "dropsitcph": 7196876179,
    "dropfax": 7196873961
  },
  {
    "dcode": "D",
    "dropkey": "PZ12048",
    "droptype": "D",
    "dropname": "WOODROW",
    "dropdeladd": "28999 HIGHWAY 71",
    "dropdelcty": "WOODROW",
    "dropdelst": "CO",
    "dropdelzpp": 807579998,
    "dropphyadd": "28999 HIGHWAY 71",
    "dropphycty": "WOODROW",
    "dropphyst": "CO",
    "dropphyzpp": 807579998,
    "dropmaladd": "28999 HIGHWAY 71",
    "dropmalcty": "WOODROW",
    "dropmalst": "CO",
    "dropmalzpp": 807579998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703862275,
    "dropsitcph": 9703862275,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ12049",
    "droptype": "D",
    "dropname": "WOODY CREEK",
    "dropdeladd": "7909 UPPER RIVER RD",
    "dropdelcty": "WOODY CREEK",
    "dropdelst": "CO",
    "dropdelzpp": 816569997,
    "dropphyadd": "7909 UPPER RIVER RD",
    "dropphycty": "WOODY CREEK",
    "dropphyst": "CO",
    "dropphyzpp": 816569997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODY CREEK",
    "dropmalst": "CO",
    "dropmalzpp": 816569998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9709234266,
    "dropsitcph": 9709234266,
    "dropfax": 9709234597
  },
  {
    "dcode": "D",
    "dropkey": "PZ12051",
    "droptype": "D",
    "dropname": "WRAY",
    "dropdeladd": "407 W 7TH ST",
    "dropdelcty": "WRAY",
    "dropdelst": "CO",
    "dropdelzpp": 807581612,
    "dropphyadd": "407 W 7TH ST",
    "dropphycty": "WRAY",
    "dropphyst": "CO",
    "dropphyzpp": 807581612,
    "dropmaladd": "407 W 7TH ST",
    "dropmalcty": "WRAY",
    "dropmalst": "CO",
    "dropmalzpp": 807581612,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703325819,
    "dropsitcph": 9703325819,
    "dropfax": 9703324509
  },
  {
    "dcode": "D",
    "dropkey": "PZ12052",
    "droptype": "D",
    "dropname": "YAMPA",
    "dropdeladd": "261 MOFFAT AVE",
    "dropdelcty": "YAMPA",
    "dropdelst": "CO",
    "dropdelzpp": 804839998,
    "dropphyadd": "261 MOFFAT AVE",
    "dropphycty": "YAMPA",
    "dropphyst": "CO",
    "dropphyzpp": 804839998,
    "dropmaladd": "261 MOFFAT AVE",
    "dropmalcty": "YAMPA",
    "dropmalst": "CO",
    "dropmalzpp": 804839998,
    "dropsitphn": 3038536411,
    "dropsitlph": 9706384590,
    "dropsitcph": 9706384590,
    "dropfax": 9706384590
  },
  {
    "dcode": "D",
    "dropkey": "PZ12053",
    "droptype": "D",
    "dropname": "YELLOW JACKET",
    "dropdeladd": "22009 COUNTY ROAD 18",
    "dropdelcty": "YELLOW JACKET",
    "dropdelst": "CO",
    "dropdelzpp": 813359997,
    "dropphyadd": "22009 COUNTY ROAD 18",
    "dropphycty": "YELLOW JACKET",
    "dropphyst": "CO",
    "dropphyzpp": 813359997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YELLOW JACKET",
    "dropmalst": "CO",
    "dropmalzpp": 813359998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9705624221,
    "dropsitcph": 9705624221,
    "dropfax": 9705624221
  },
  {
    "dcode": "D",
    "dropkey": "PZ12056",
    "droptype": "D",
    "dropname": "YODER",
    "dropdeladd": "475 N YODER RD",
    "dropdelcty": "YODER",
    "dropdelst": "CO",
    "dropdelzpp": 808649998,
    "dropphyadd": "475 N YODER RD",
    "dropphycty": "YODER",
    "dropphyst": "CO",
    "dropphyzpp": 808649998,
    "dropmaladd": "475 N YODER RD",
    "dropmalcty": "YODER",
    "dropmalst": "CO",
    "dropmalzpp": 808649998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196832626,
    "dropsitcph": 7196832626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12057",
    "droptype": "D",
    "dropname": "YUMA",
    "dropdeladd": "315 S MAIN ST",
    "dropdelcty": "YUMA",
    "dropdelst": "CO",
    "dropdelzpp": 807599998,
    "dropphyadd": "315 S MAIN ST",
    "dropphycty": "YUMA",
    "dropphyst": "CO",
    "dropphyzpp": 807599998,
    "dropmaladd": "315 S MAIN ST",
    "dropmalcty": "YUMA",
    "dropmalst": "CO",
    "dropmalzpp": 807599998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708485929,
    "dropsitcph": 9708485929,
    "dropfax": 3038536458
  },
  {
    "dcode": "D",
    "dropkey": "PZ12058",
    "droptype": "D",
    "dropname": "CHUUK",
    "dropdeladd": "1 WENO",
    "dropdelcty": "CHUUK",
    "dropdelst": "FM",
    "dropdelzpp": 969429997,
    "dropphyadd": "1 WENO",
    "dropphycty": "CHUUK",
    "dropphyst": "FM",
    "dropphyzpp": 969429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHUUK",
    "dropmalst": "FM",
    "dropmalzpp": 969429998,
    "dropsitphn": 6913302737,
    "dropsitlph": 6913302737,
    "dropsitcph": 6913302737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12061",
    "droptype": "D",
    "dropname": "KOSRAE",
    "dropdeladd": "1 TOFOL",
    "dropdelcty": "KOSRAE",
    "dropdelst": "FM",
    "dropdelzpp": 969449997,
    "dropphyadd": "1 TOFOL",
    "dropphycty": "KOSRAE",
    "dropphyst": "FM",
    "dropphyzpp": 969449997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOSRAE",
    "dropmalst": "FM",
    "dropmalzpp": 969449998,
    "dropsitphn": 6913703057,
    "dropsitlph": 6913703057,
    "dropsitcph": 6913703057,
    "dropfax": 6913703517
  },
  {
    "dcode": "D",
    "dropkey": "PZ12063",
    "droptype": "D",
    "dropname": "POHNPEI",
    "dropdeladd": "1 KOLONIA TOWN",
    "dropdelcty": "POHNPEI",
    "dropdelst": "FM",
    "dropdelzpp": 969419997,
    "dropphyadd": "1 KOLONIA TOWN",
    "dropphycty": "POHNPEI",
    "dropphyst": "FM",
    "dropphyzpp": 969419997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POHNPEI",
    "dropmalst": "FM",
    "dropmalzpp": 969419998,
    "dropsitphn": 6913202313,
    "dropsitlph": 6913202313,
    "dropsitcph": 6913202313,
    "dropfax": 6913202612
  },
  {
    "dcode": "D",
    "dropkey": "PZ12067",
    "droptype": "D",
    "dropname": "YAP",
    "dropdeladd": "1 COLONIA",
    "dropdelcty": "YAP",
    "dropdelst": "FM",
    "dropdelzpp": 969439997,
    "dropphyadd": "1 COLONIA",
    "dropphycty": "YAP",
    "dropphyst": "FM",
    "dropphyzpp": 969439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YAP",
    "dropmalst": "FM",
    "dropmalzpp": 969439998,
    "dropsitphn": 6913502197,
    "dropsitlph": 6913502197,
    "dropsitcph": 6913502197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12069",
    "droptype": "D",
    "dropname": "HAGATNA",
    "dropdeladd": "223 W CHALAN SANTO PAPA",
    "dropdelcty": "HAGATNA",
    "dropdelst": "GU",
    "dropdelzpp": 969109998,
    "dropphyadd": "223 W CHALAN SANTO PAPA",
    "dropphycty": "HAGATNA",
    "dropphyst": "GU",
    "dropphyzpp": 969109998,
    "dropmaladd": "223 W CHALAN SANTO PAPA",
    "dropmalcty": "HAGATNA",
    "dropmalst": "GU",
    "dropmalzpp": 969109998,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6714726564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12107",
    "droptype": "D",
    "dropname": "AIEA",
    "dropdeladd": "99-040 KAUHALE ST",
    "dropdelcty": "AIEA",
    "dropdelst": "HI",
    "dropdelzpp": 967019998,
    "dropphyadd": "99-040 KAUHALE ST",
    "dropphycty": "AIEA",
    "dropphyst": "HI",
    "dropphyzpp": 967019998,
    "dropmaladd": "99-040 KAUHALE ST",
    "dropmalcty": "AIEA",
    "dropmalst": "HI",
    "dropmalzpp": 967019998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084830010,
    "dropsitcph": 8084830010,
    "dropfax": 8084830012
  },
  {
    "dcode": "D",
    "dropkey": "PZ12112",
    "droptype": "D",
    "dropname": "ANAHOLA",
    "dropdeladd": "4-4350 KUHIO HWY",
    "dropdelcty": "ANAHOLA",
    "dropdelst": "HI",
    "dropdelzpp": 967039997,
    "dropphyadd": "4-4350 KUHIO HWY",
    "dropphycty": "ANAHOLA",
    "dropphyst": "HI",
    "dropphyzpp": 967039997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANAHOLA",
    "dropmalst": "HI",
    "dropmalzpp": 967039998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8088224710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12124",
    "droptype": "D",
    "dropname": "CAPTAIN COOK",
    "dropdeladd": "82-6110 MAMALAHOA HWY",
    "dropdelcty": "CAPTAIN COOK",
    "dropdelst": "HI",
    "dropdelzpp": 967049998,
    "dropphyadd": "82-6110 MAMALAHOA HWY",
    "dropphycty": "CAPTAIN COOK",
    "dropphyst": "HI",
    "dropphyzpp": 967049998,
    "dropmaladd": "82-6110 MAMALAHOA HWY",
    "dropmalcty": "CAPTAIN COOK",
    "dropmalst": "HI",
    "dropmalzpp": 967049998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083239678,
    "dropsitcph": 8083239678,
    "dropfax": 8083239637
  },
  {
    "dcode": "D",
    "dropkey": "PZ12136",
    "droptype": "D",
    "dropname": "ELEELE",
    "dropdeladd": "4485 WAIALO RD",
    "dropdelcty": "ELEELE",
    "dropdelst": "HI",
    "dropdelzpp": 967059997,
    "dropphyadd": "4485 WAIALO RD",
    "dropphycty": "ELEELE",
    "dropphyst": "HI",
    "dropphyzpp": 967059997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELEELE",
    "dropmalst": "HI",
    "dropmalzpp": 967059998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083355338,
    "dropsitcph": 8083355338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12138",
    "droptype": "D",
    "dropname": "EWA BEACH",
    "dropdeladd": "91-760 PAPIPI RD",
    "dropdelcty": "EWA BEACH",
    "dropdelst": "HI",
    "dropdelzpp": 967069998,
    "dropphyadd": "91-760 PAPIPI RD",
    "dropphycty": "EWA BEACH",
    "dropphyst": "HI",
    "dropphyzpp": 967069998,
    "dropmaladd": "91-760 PAPIPI RD",
    "dropmalcty": "EWA BEACH",
    "dropmalst": "HI",
    "dropmalzpp": 967069998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086894250,
    "dropsitcph": 8086894250,
    "dropfax": 8086890605
  },
  {
    "dcode": "D",
    "dropkey": "PZ12147",
    "droptype": "D",
    "dropname": "HAIKU",
    "dropdeladd": "770 HAIKU RD",
    "dropdelcty": "HAIKU",
    "dropdelst": "HI",
    "dropdelzpp": 967089998,
    "dropphyadd": "770 HAIKU RD",
    "dropphycty": "HAIKU",
    "dropphyst": "HI",
    "dropphyzpp": 967089998,
    "dropmaladd": "770 HAIKU RD",
    "dropmalcty": "HAIKU",
    "dropmalst": "HI",
    "dropmalzpp": 967089998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085752614,
    "dropsitcph": 8085752614,
    "dropfax": 8085752068
  },
  {
    "dcode": "D",
    "dropkey": "PZ12148",
    "droptype": "D",
    "dropname": "HAKALAU",
    "dropdeladd": "29-2270 OLD MAMALAHOA HWY",
    "dropdelcty": "HAKALAU",
    "dropdelst": "HI",
    "dropdelzpp": 967109997,
    "dropphyadd": "29-2270 OLD MAMALAHOA HWY",
    "dropphycty": "HAKALAU",
    "dropphyst": "HI",
    "dropphyzpp": 967109997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAKALAU",
    "dropmalst": "HI",
    "dropmalzpp": 967109998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089636939,
    "dropsitcph": 8089636939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12150",
    "droptype": "D",
    "dropname": "HALEIWA",
    "dropdeladd": "66-437 KAMEHAMEHA HWY STE 102",
    "dropdelcty": "HALEIWA",
    "dropdelst": "HI",
    "dropdelzpp": 967129998,
    "dropphyadd": "66-437 KAMEHAMEHA HWY STE 102",
    "dropphycty": "HALEIWA",
    "dropphyst": "HI",
    "dropphyzpp": 967129998,
    "dropmaladd": "66-437 KAMEHAMEHA HWY STE 102",
    "dropmalcty": "HALEIWA",
    "dropmalst": "HI",
    "dropmalzpp": 967129998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086371711,
    "dropsitcph": 8086371711,
    "dropfax": 8086370424
  },
  {
    "dcode": "D",
    "dropkey": "PZ12152",
    "droptype": "D",
    "dropname": "HANA",
    "dropdeladd": "1 MILL ST",
    "dropdelcty": "HANA",
    "dropdelst": "HI",
    "dropdelzpp": 967139997,
    "dropphyadd": "1 MILL ST",
    "dropphycty": "HANA",
    "dropphyst": "HI",
    "dropphyzpp": 967139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANA",
    "dropmalst": "HI",
    "dropmalzpp": 967139998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082488258,
    "dropsitcph": 8082488258,
    "dropfax": 8082487307
  },
  {
    "dcode": "D",
    "dropkey": "PZ12153",
    "droptype": "D",
    "dropname": "HANALEI",
    "dropdeladd": "5-5226 KUHIO HWY",
    "dropdelcty": "HANALEI",
    "dropdelst": "HI",
    "dropdelzpp": 967149997,
    "dropphyadd": "5-5226 KUHIO HWY",
    "dropphycty": "HANALEI",
    "dropphyst": "HI",
    "dropphyzpp": 967149997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANALEI",
    "dropmalst": "HI",
    "dropmalzpp": 967149998,
    "dropsitphn": 8082120292,
    "dropsitlph": 8088261034,
    "dropsitcph": 8088261034,
    "dropfax": 8082120293
  },
  {
    "dcode": "D",
    "dropkey": "PZ12155",
    "droptype": "D",
    "dropname": "HANAPEPE",
    "dropdeladd": "3817 KONA RD",
    "dropdelcty": "HANAPEPE",
    "dropdelst": "HI",
    "dropdelzpp": 967169997,
    "dropphyadd": "3817 KONA RD",
    "dropphycty": "HANAPEPE",
    "dropphyst": "HI",
    "dropphyzpp": 967169997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANAPEPE",
    "dropmalst": "HI",
    "dropmalzpp": 967169998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8083355433,
    "dropsitcph": 8083355433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12156",
    "droptype": "D",
    "dropname": "HAUULA",
    "dropdeladd": "54-316 KAMEHAMEHA HWY",
    "dropdelcty": "HAUULA",
    "dropdelst": "HI",
    "dropdelzpp": 967179998,
    "dropphyadd": "54-316 KAMEHAMEHA HWY",
    "dropphycty": "HAUULA",
    "dropphyst": "HI",
    "dropphyzpp": 967179998,
    "dropmaladd": "54-316 KAMEHAMEHA HWY",
    "dropmalcty": "HAUULA",
    "dropmalst": "HI",
    "dropmalzpp": 967179998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082935057,
    "dropsitcph": 8082935057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12160",
    "droptype": "D",
    "dropname": "HAWAII NATIONAL PARK",
    "dropdeladd": "1 KILAUEA MILITARY CP",
    "dropdelcty": "HAWAII NATIONAL PARK",
    "dropdelst": "HI",
    "dropdelzpp": 967189997,
    "dropphyadd": "1 KILAUEA MILITARY CP",
    "dropphycty": "HAWAII NATIONAL PARK",
    "dropphyst": "HI",
    "dropphyzpp": 967189997,
    "dropmaladd": "PO BOX 189998",
    "dropmalcty": "HAWAII NATIONAL PARK",
    "dropmalst": "HI",
    "dropmalzpp": 967189998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089677471,
    "dropsitcph": 8089677471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12165",
    "droptype": "D",
    "dropname": "HAWI",
    "dropdeladd": "55-515 HAWI RD",
    "dropdelcty": "HAWI",
    "dropdelst": "HI",
    "dropdelzpp": 967199997,
    "dropphyadd": "55-515 HAWI RD",
    "dropphycty": "HAWI",
    "dropphyst": "HI",
    "dropphyzpp": 967199997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAWI",
    "dropmalst": "HI",
    "dropmalzpp": 967199998,
    "dropsitphn": 8088895088,
    "dropsitlph": 8088895088,
    "dropsitcph": 8088895088,
    "dropfax": 8082178137
  },
  {
    "dcode": "D",
    "dropkey": "PZ12171",
    "droptype": "D",
    "dropname": "HILO",
    "dropdeladd": "1299 KEKUANAOA ST",
    "dropdelcty": "HILO",
    "dropdelst": "HI",
    "dropdelzpp": 967209998,
    "dropphyadd": "1299 KEKUANAOA ST",
    "dropphycty": "HILO",
    "dropphyst": "HI",
    "dropphyzpp": 967209998,
    "dropmaladd": "1299 KEKUANAOA ST",
    "dropmalcty": "HILO",
    "dropmalst": "HI",
    "dropmalzpp": 967209998,
    "dropsitphn": 8089333019,
    "dropsitlph": 8089333019,
    "dropsitcph": 8089333019,
    "dropfax": 8089331136
  },
  {
    "dcode": "D",
    "dropkey": "PZ12177",
    "droptype": "D",
    "dropname": "HOLUALOA",
    "dropdeladd": "76-5921 MAMALAHOA HWY",
    "dropdelcty": "HOLUALOA",
    "dropdelst": "HI",
    "dropdelzpp": 967259998,
    "dropphyadd": "76-5921 MAMALAHOA HWY",
    "dropphycty": "HOLUALOA",
    "dropphyst": "HI",
    "dropphyzpp": 967259998,
    "dropmaladd": "76-5921 MAMALAHOA HWY",
    "dropmalcty": "HOLUALOA",
    "dropmalst": "HI",
    "dropmalzpp": 967259998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083225085,
    "dropsitcph": 8083225085,
    "dropfax": 8083228892
  },
  {
    "dcode": "D",
    "dropkey": "PZ12179",
    "droptype": "D",
    "dropname": "HONAUNAU",
    "dropdeladd": "84-4840 CITY OF REFUGE RD",
    "dropdelcty": "HONAUNAU",
    "dropdelst": "HI",
    "dropdelzpp": 967269997,
    "dropphyadd": "84-4840 CITY OF REFUGE RD",
    "dropphycty": "HONAUNAU",
    "dropphyst": "HI",
    "dropphyzpp": 967269997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONAUNAU",
    "dropmalst": "HI",
    "dropmalzpp": 967269998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083282500,
    "dropsitcph": 8083282500,
    "dropfax": 8083399105
  },
  {
    "dcode": "D",
    "dropkey": "PZ12182",
    "droptype": "D",
    "dropname": "HONOKAA",
    "dropdeladd": "45-490 LEHUA ST",
    "dropdelcty": "HONOKAA",
    "dropdelst": "HI",
    "dropdelzpp": 967279998,
    "dropphyadd": "45-490 LEHUA ST",
    "dropphycty": "HONOKAA",
    "dropphyst": "HI",
    "dropphyzpp": 967279998,
    "dropmaladd": "45-490 LEHUA ST",
    "dropmalcty": "HONOKAA",
    "dropmalst": "HI",
    "dropmalzpp": 967279998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8087750081,
    "dropsitcph": 8087750081,
    "dropfax": 8087758044
  },
  {
    "dcode": "D",
    "dropkey": "PZ12186",
    "droptype": "D",
    "dropname": "HONOLULU",
    "dropdeladd": "3600 AOLELE ST RM 208C",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968209998,
    "dropphyadd": "3600 AOLELE ST RM 208C",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968209998,
    "dropmaladd": "3600 AOLELE ST RM 208C",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968209998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084233909,
    "dropsitcph": 8084233917,
    "dropfax": 8084233640
  },
  {
    "dcode": "D",
    "dropkey": "PZ12189",
    "droptype": "D",
    "dropname": "HONOMU",
    "dropdeladd": "28-171 HONOMU RD",
    "dropdelcty": "HONOMU",
    "dropdelst": "HI",
    "dropdelzpp": 967289997,
    "dropphyadd": "28-171 HONOMU RD",
    "dropphycty": "HONOMU",
    "dropphyst": "HI",
    "dropphyzpp": 967289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONOMU",
    "dropmalst": "HI",
    "dropmalzpp": 967289998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089636157,
    "dropsitcph": 8089636157,
    "dropfax": 8089636740
  },
  {
    "dcode": "D",
    "dropkey": "PZ12190",
    "droptype": "D",
    "dropname": "HOOLEHUA",
    "dropdeladd": "69-2 PUUPEELUA AVE",
    "dropdelcty": "HOOLEHUA",
    "dropdelst": "HI",
    "dropdelzpp": 967299997,
    "dropphyadd": "69-2 PUUPEELUA AVE",
    "dropphycty": "HOOLEHUA",
    "dropphyst": "HI",
    "dropphyzpp": 967299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOOLEHUA",
    "dropmalst": "HI",
    "dropmalzpp": 967299998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085676144,
    "dropsitcph": 8085676144,
    "dropfax": 8082130056
  },
  {
    "dcode": "D",
    "dropkey": "PZ12195",
    "droptype": "D",
    "dropname": "KAAAWA",
    "dropdeladd": "51-480 KAMEHAMEHA HWY STE 101",
    "dropdelcty": "KAAAWA",
    "dropdelst": "HI",
    "dropdelzpp": 967309998,
    "dropphyadd": "51-480 KAMEHAMEHA HWY STE 101",
    "dropphycty": "KAAAWA",
    "dropphyst": "HI",
    "dropphyzpp": 967309998,
    "dropmaladd": "51-480 KAMEHAMEHA HWY STE 101",
    "dropmalcty": "KAAAWA",
    "dropmalst": "HI",
    "dropmalzpp": 967309998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082378372,
    "dropsitcph": 8082378372,
    "dropfax": 8082377259
  },
  {
    "dcode": "D",
    "dropkey": "PZ12197",
    "droptype": "D",
    "dropname": "KAHUKU",
    "dropdeladd": "56-565 KAMEHAMEHA HWY",
    "dropdelcty": "KAHUKU",
    "dropdelst": "HI",
    "dropdelzpp": 967319998,
    "dropphyadd": "56-565 KAMEHAMEHA HWY",
    "dropphycty": "KAHUKU",
    "dropphyst": "HI",
    "dropphyzpp": 967319998,
    "dropmaladd": "56-565 KAMEHAMEHA HWY",
    "dropmalcty": "KAHUKU",
    "dropmalst": "HI",
    "dropmalzpp": 967319998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082930485,
    "dropsitcph": 8082930485,
    "dropfax": 8084262056
  },
  {
    "dcode": "D",
    "dropkey": "PZ12198",
    "droptype": "D",
    "dropname": "KAHULUI",
    "dropdeladd": "138 S PUUNENE AVE",
    "dropdelcty": "KAHULUI",
    "dropdelst": "HI",
    "dropdelzpp": 967329998,
    "dropphyadd": "138 S PUUNENE AVE",
    "dropphycty": "KAHULUI",
    "dropphyst": "HI",
    "dropphyzpp": 967329998,
    "dropmaladd": "138 S PUUNENE AVE",
    "dropmalcty": "KAHULUI",
    "dropmalst": "HI",
    "dropmalzpp": 967329998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082141626,
    "dropsitcph": 8082141626,
    "dropfax": 8082141628
  },
  {
    "dcode": "D",
    "dropkey": "PZ12200",
    "droptype": "D",
    "dropname": "KAILUA",
    "dropdeladd": "335 HAHANI ST",
    "dropdelcty": "KAILUA",
    "dropdelst": "HI",
    "dropdelzpp": 967349998,
    "dropphyadd": "335 HAHANI ST",
    "dropphycty": "KAILUA",
    "dropphyst": "HI",
    "dropphyzpp": 967349998,
    "dropmaladd": "335 HAHANI ST",
    "dropmalcty": "KAILUA",
    "dropmalst": "HI",
    "dropmalzpp": 967349998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082663996,
    "dropsitcph": 8082663996,
    "dropfax": 8083774361
  },
  {
    "dcode": "D",
    "dropkey": "PZ12201",
    "droptype": "D",
    "dropname": "KAILUA KONA",
    "dropdeladd": "74-5577 PALANI RD",
    "dropdelcty": "KAILUA KONA",
    "dropdelst": "HI",
    "dropdelzpp": 967409998,
    "dropphyadd": "74-5577 PALANI RD",
    "dropphycty": "KAILUA KONA",
    "dropphyst": "HI",
    "dropphyzpp": 967409998,
    "dropmaladd": "74-5577 PALANI RD",
    "dropmalcty": "KAILUA KONA",
    "dropmalst": "HI",
    "dropmalzpp": 967409998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083261432,
    "dropsitcph": 8083261432,
    "dropfax": 8083298235
  },
  {
    "dcode": "D",
    "dropkey": "PZ12206",
    "droptype": "D",
    "dropname": "KALAHEO",
    "dropdeladd": "4489 PAPALINA RD",
    "dropdelcty": "KALAHEO",
    "dropdelst": "HI",
    "dropdelzpp": 967419998,
    "dropphyadd": "4489 PAPALINA RD",
    "dropphycty": "KALAHEO",
    "dropphyst": "HI",
    "dropphyzpp": 967419998,
    "dropmaladd": "4489 PAPALINA RD",
    "dropmalcty": "KALAHEO",
    "dropmalst": "HI",
    "dropmalzpp": 967419998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8083325003,
    "dropsitcph": 8083325800,
    "dropfax": 8083327465
  },
  {
    "dcode": "D",
    "dropkey": "PZ12209",
    "droptype": "D",
    "dropname": "KALAUPAPA",
    "dropdeladd": "290 BERETANIA ST",
    "dropdelcty": "KALAUPAPA",
    "dropdelst": "HI",
    "dropdelzpp": 967429997,
    "dropphyadd": "290 BERETANIA ST",
    "dropphycty": "KALAUPAPA",
    "dropphyst": "HI",
    "dropphyzpp": 967429997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALAUPAPA",
    "dropmalst": "HI",
    "dropmalzpp": 967429998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085676479,
    "dropsitcph": 8085676479,
    "dropfax": 8085679350
  },
  {
    "dcode": "D",
    "dropkey": "PZ12210",
    "droptype": "D",
    "dropname": "KAMUELA",
    "dropdeladd": "67-1197 MAMALAHOA HWY",
    "dropdelcty": "KAMUELA",
    "dropdelst": "HI",
    "dropdelzpp": 967439998,
    "dropphyadd": "67-1197 MAMALAHOA HWY",
    "dropphycty": "KAMUELA",
    "dropphyst": "HI",
    "dropphyzpp": 967439998,
    "dropmaladd": "67-1197 MAMALAHOA HWY",
    "dropmalcty": "KAMUELA",
    "dropmalst": "HI",
    "dropmalzpp": 967439998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088856239,
    "dropsitcph": 8088856239,
    "dropfax": 8088858322
  },
  {
    "dcode": "D",
    "dropkey": "PZ12211",
    "droptype": "D",
    "dropname": "KANEOHE",
    "dropdeladd": "46-036 KAMEHAMEHA HWY",
    "dropdelcty": "KANEOHE",
    "dropdelst": "HI",
    "dropdelzpp": 967449998,
    "dropphyadd": "46-036 KAMEHAMEHA HWY",
    "dropphycty": "KANEOHE",
    "dropphyst": "HI",
    "dropphyzpp": 967449998,
    "dropmaladd": "46-036 KAMEHAMEHA HWY",
    "dropmalcty": "KANEOHE",
    "dropmalst": "HI",
    "dropmalzpp": 967449998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082351055,
    "dropsitcph": 8082351055,
    "dropfax": 8082352017
  },
  {
    "dcode": "D",
    "dropkey": "PZ12215",
    "droptype": "D",
    "dropname": "KAPAA",
    "dropdeladd": "4-1101 KUHIO HWY",
    "dropdelcty": "KAPAA",
    "dropdelst": "HI",
    "dropdelzpp": 967469998,
    "dropphyadd": "4-1101 KUHIO HWY",
    "dropphycty": "KAPAA",
    "dropphyst": "HI",
    "dropphyzpp": 967469998,
    "dropmaladd": "4-1101 KUHIO HWY",
    "dropmalcty": "KAPAA",
    "dropmalst": "HI",
    "dropmalzpp": 967469998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088220268,
    "dropsitcph": 8088220093,
    "dropfax": 8088236538
  },
  {
    "dcode": "D",
    "dropkey": "PZ12217",
    "droptype": "D",
    "dropname": "KAPAAU",
    "dropdeladd": "54-396 UNION MILL RD",
    "dropdelcty": "KAPAAU",
    "dropdelst": "HI",
    "dropdelzpp": 967559997,
    "dropphyadd": "54-396 UNION MILL RD",
    "dropphycty": "KAPAAU",
    "dropphyst": "HI",
    "dropphyzpp": 967559997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAPAAU",
    "dropmalst": "HI",
    "dropmalzpp": 967559998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088896766,
    "dropsitcph": 8088896766,
    "dropfax": 8088890261
  },
  {
    "dcode": "D",
    "dropkey": "PZ12224",
    "droptype": "D",
    "dropname": "KAUMAKANI",
    "dropdeladd": "1-2600 KAUMUALII HWY",
    "dropdelcty": "KAUMAKANI",
    "dropdelst": "HI",
    "dropdelzpp": 967479997,
    "dropphyadd": "1-2600 KAUMUALII HWY",
    "dropphycty": "KAUMAKANI",
    "dropphyst": "HI",
    "dropphyzpp": 967479997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAUMAKANI",
    "dropmalst": "HI",
    "dropmalzpp": 967479998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083353641,
    "dropsitcph": 8083353641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12225",
    "droptype": "D",
    "dropname": "KAUNAKAKAI",
    "dropdeladd": "120 ALA MALAMA ST",
    "dropdelcty": "KAUNAKAKAI",
    "dropdelst": "HI",
    "dropdelzpp": 967488697,
    "dropphyadd": "120 ALA MALAMA ST",
    "dropphycty": "KAUNAKAKAI",
    "dropphyst": "HI",
    "dropphyzpp": 967488697,
    "dropmaladd": "PO BOX 489998",
    "dropmalcty": "KAUNAKAKAI",
    "dropmalst": "HI",
    "dropmalzpp": 967489998,
    "dropsitphn": 8085539042,
    "dropsitlph": 8085535845,
    "dropsitcph": 8085535845,
    "dropfax": 8085535179
  },
  {
    "dcode": "D",
    "dropkey": "PZ12227",
    "droptype": "D",
    "dropname": "KEAAU",
    "dropdeladd": "16-578 OLD VOLCANO RD",
    "dropdelcty": "KEAAU",
    "dropdelst": "HI",
    "dropdelzpp": 967499998,
    "dropphyadd": "16-578 OLD VOLCANO RD",
    "dropphycty": "KEAAU",
    "dropphyst": "HI",
    "dropphyzpp": 967499998,
    "dropmaladd": "16-578 OLD VOLCANO RD",
    "dropmalcty": "KEAAU",
    "dropmalst": "HI",
    "dropmalzpp": 967499998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089666403,
    "dropsitcph": 8089666403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12228",
    "droptype": "D",
    "dropname": "KEALAKEKUA",
    "dropdeladd": "81-990 HALEKII ST",
    "dropdelcty": "KEALAKEKUA",
    "dropdelst": "HI",
    "dropdelzpp": 967509998,
    "dropphyadd": "81-990 HALEKII ST",
    "dropphycty": "KEALAKEKUA",
    "dropphyst": "HI",
    "dropphyzpp": 967509998,
    "dropmaladd": "81-990 HALEKII ST",
    "dropmalcty": "KEALAKEKUA",
    "dropmalst": "HI",
    "dropmalzpp": 967509998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083221656,
    "dropsitcph": 8083221656,
    "dropfax": 8083246306
  },
  {
    "dcode": "D",
    "dropkey": "PZ12233",
    "droptype": "D",
    "dropname": "KEKAHA",
    "dropdeladd": "8230 KEKAHA RD",
    "dropdelcty": "KEKAHA",
    "dropdelst": "HI",
    "dropdelzpp": 967529997,
    "dropphyadd": "8230 KEKAHA RD",
    "dropphycty": "KEKAHA",
    "dropphyst": "HI",
    "dropphyzpp": 967529997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEKAHA",
    "dropmalst": "HI",
    "dropmalzpp": 967529998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083371322,
    "dropsitcph": 8083371322,
    "dropfax": 8083370409
  },
  {
    "dcode": "D",
    "dropkey": "PZ12234",
    "droptype": "D",
    "dropname": "KIHEI",
    "dropdeladd": "1254 S KIHEI RD",
    "dropdelcty": "KIHEI",
    "dropdelst": "HI",
    "dropdelzpp": 967539998,
    "dropphyadd": "1254 S KIHEI RD",
    "dropphycty": "KIHEI",
    "dropphyst": "HI",
    "dropphyzpp": 967539998,
    "dropmaladd": "1254 S KIHEI RD",
    "dropmalcty": "KIHEI",
    "dropmalst": "HI",
    "dropmalzpp": 967539998,
    "dropsitphn": 8088791987,
    "dropsitlph": 8088791987,
    "dropsitcph": 8088791987,
    "dropfax": 8088749143
  },
  {
    "dcode": "D",
    "dropkey": "PZ12236",
    "droptype": "D",
    "dropname": "KILAUEA",
    "dropdeladd": "2585 ALA NAMAHANA PKWY",
    "dropdelcty": "KILAUEA",
    "dropdelst": "HI",
    "dropdelzpp": 967545389,
    "dropphyadd": "2585 ALA NAMAHANA PKWY",
    "dropphycty": "KILAUEA",
    "dropphyst": "HI",
    "dropphyzpp": 967545389,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KILAUEA",
    "dropmalst": "HI",
    "dropmalzpp": 967549998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8088280188,
    "dropsitcph": 8088281721,
    "dropfax": 8088280217
  },
  {
    "dcode": "D",
    "dropkey": "PZ12240",
    "droptype": "D",
    "dropname": "KOLOA",
    "dropdeladd": "5485 KOLOA RD",
    "dropdelcty": "KOLOA",
    "dropdelst": "HI",
    "dropdelzpp": 967569998,
    "dropphyadd": "5485 KOLOA RD",
    "dropphycty": "KOLOA",
    "dropphyst": "HI",
    "dropphyzpp": 967569998,
    "dropmaladd": "5485 KOLOA RD",
    "dropmalcty": "KOLOA",
    "dropmalst": "HI",
    "dropmalzpp": 967569998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8087421246,
    "dropsitcph": 8087421246,
    "dropfax": 8087421697
  },
  {
    "dcode": "D",
    "dropkey": "PZ12243",
    "droptype": "D",
    "dropname": "KUALAPUU",
    "dropdeladd": "308 FARRINGTON AVE",
    "dropdelcty": "KUALAPUU",
    "dropdelst": "HI",
    "dropdelzpp": 967579997,
    "dropphyadd": "308 FARRINGTON AVE",
    "dropphycty": "KUALAPUU",
    "dropphyst": "HI",
    "dropphyzpp": 967579997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KUALAPUU",
    "dropmalst": "HI",
    "dropmalzpp": 967579998,
    "dropsitphn": 8085676638,
    "dropsitlph": 8085676638,
    "dropsitcph": 8085676638,
    "dropfax": 6514566664
  },
  {
    "dcode": "D",
    "dropkey": "PZ12247",
    "droptype": "D",
    "dropname": "KULA",
    "dropdeladd": "4450 KULA HWY",
    "dropdelcty": "KULA",
    "dropdelst": "HI",
    "dropdelzpp": 967909998,
    "dropphyadd": "4450 KULA HWY",
    "dropphycty": "KULA",
    "dropphyst": "HI",
    "dropphyzpp": 967909998,
    "dropmaladd": "4450 KULA HWY",
    "dropmalcty": "KULA",
    "dropmalst": "HI",
    "dropmalzpp": 967909998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088761056,
    "dropsitcph": 8088761056,
    "dropfax": 8088782176
  },
  {
    "dcode": "D",
    "dropkey": "PZ12249",
    "droptype": "D",
    "dropname": "KUNIA",
    "dropdeladd": "92-1770 KUNIA RD",
    "dropdelcty": "KUNIA",
    "dropdelst": "HI",
    "dropdelzpp": 967599997,
    "dropphyadd": "92-1770 KUNIA RD",
    "dropphycty": "KUNIA",
    "dropphyst": "HI",
    "dropphyzpp": 967599997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KUNIA",
    "dropmalst": "HI",
    "dropmalzpp": 967599998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086222976,
    "dropsitcph": 8086222976,
    "dropfax": 8086219409
  },
  {
    "dcode": "D",
    "dropkey": "PZ12250",
    "droptype": "D",
    "dropname": "KURTISTOWN",
    "dropdeladd": "17-345 VOLCANO RD",
    "dropdelcty": "KURTISTOWN",
    "dropdelst": "HI",
    "dropdelzpp": 967609997,
    "dropphyadd": "17-345 VOLCANO RD",
    "dropphycty": "KURTISTOWN",
    "dropphyst": "HI",
    "dropphyzpp": 967609997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KURTISTOWN",
    "dropmalst": "HI",
    "dropmalzpp": 967609998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089666228,
    "dropsitcph": 8089666228,
    "dropfax": 8089826150
  },
  {
    "dcode": "D",
    "dropkey": "PZ12251",
    "droptype": "D",
    "dropname": "LAHAINA",
    "dropdeladd": "1760 HONOAPIILANI HWY",
    "dropdelcty": "LAHAINA",
    "dropdelst": "HI",
    "dropdelzpp": 967619998,
    "dropphyadd": "1760 HONOAPIILANI HWY",
    "dropphycty": "LAHAINA",
    "dropphyst": "HI",
    "dropphyzpp": 967619998,
    "dropmaladd": "1760 HONOAPIILANI HWY",
    "dropmalcty": "LAHAINA",
    "dropmalst": "HI",
    "dropmalzpp": 967619998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086610904,
    "dropsitcph": 8086610904,
    "dropfax": 8086618227
  },
  {
    "dcode": "D",
    "dropkey": "PZ12253",
    "droptype": "D",
    "dropname": "LAIE",
    "dropdeladd": "55-510 KAMEHAMEHA HWY STE 20",
    "dropdelcty": "LAIE",
    "dropdelst": "HI",
    "dropdelzpp": 967629998,
    "dropphyadd": "55-510 KAMEHAMEHA HWY STE 20",
    "dropphycty": "LAIE",
    "dropphyst": "HI",
    "dropphyzpp": 967629998,
    "dropmaladd": "55-510 KAMEHAMEHA HWY STE 20",
    "dropmalcty": "LAIE",
    "dropmalst": "HI",
    "dropmalzpp": 967629998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082930337,
    "dropsitcph": 8082930337,
    "dropfax": 8082937165
  },
  {
    "dcode": "D",
    "dropkey": "PZ12255",
    "droptype": "D",
    "dropname": "LANAI CITY",
    "dropdeladd": "620 JACARANDA ST",
    "dropdelcty": "LANAI CITY",
    "dropdelst": "HI",
    "dropdelzpp": 967639997,
    "dropphyadd": "620 JACARANDA ST",
    "dropphycty": "LANAI CITY",
    "dropphyst": "HI",
    "dropphyzpp": 967639997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANAI CITY",
    "dropmalst": "HI",
    "dropmalzpp": 967639998,
    "dropsitphn": 8085656517,
    "dropsitlph": 8085656517,
    "dropsitcph": 8085656517,
    "dropfax": 8082150013
  },
  {
    "dcode": "D",
    "dropkey": "PZ12256",
    "droptype": "D",
    "dropname": "LAUPAHOEHOE",
    "dropdeladd": "36-2281 MAMALAHOA HWY",
    "dropdelcty": "LAUPAHOEHOE",
    "dropdelst": "HI",
    "dropdelzpp": 967649997,
    "dropphyadd": "36-2281 MAMALAHOA HWY",
    "dropphycty": "LAUPAHOEHOE",
    "dropphyst": "HI",
    "dropphyzpp": 967649997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAUPAHOEHOE",
    "dropmalst": "HI",
    "dropmalzpp": 967649998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089626238,
    "dropsitcph": 8089626238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12257",
    "droptype": "D",
    "dropname": "LAWAI",
    "dropdeladd": "2-3675 KAUMUALII HWY",
    "dropdelcty": "LAWAI",
    "dropdelst": "HI",
    "dropdelzpp": 967659997,
    "dropphyadd": "2-3675 KAUMUALII HWY",
    "dropphycty": "LAWAI",
    "dropphyst": "HI",
    "dropphyzpp": 967659997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAWAI",
    "dropmalst": "HI",
    "dropmalzpp": 967659998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083329161,
    "dropsitcph": 8083329161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12259",
    "droptype": "D",
    "dropname": "LIHUE",
    "dropdeladd": "4441 RICE ST",
    "dropdelcty": "LIHUE",
    "dropdelst": "HI",
    "dropdelzpp": 967669998,
    "dropphyadd": "4441 RICE ST",
    "dropphycty": "LIHUE",
    "dropphyst": "HI",
    "dropphyzpp": 967669998,
    "dropmaladd": "4441 RICE ST",
    "dropmalcty": "LIHUE",
    "dropmalst": "HI",
    "dropmalzpp": 967669998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8082453650,
    "dropsitcph": 8082451628,
    "dropfax": 8082460615
  },
  {
    "dcode": "D",
    "dropkey": "PZ12267",
    "droptype": "D",
    "dropname": "MAKAWAO",
    "dropdeladd": "1075 MAKAWAO AVE",
    "dropdelcty": "MAKAWAO",
    "dropdelst": "HI",
    "dropdelzpp": 967689998,
    "dropphyadd": "1075 MAKAWAO AVE",
    "dropphycty": "MAKAWAO",
    "dropphyst": "HI",
    "dropphyzpp": 967689998,
    "dropmaladd": "1075 MAKAWAO AVE",
    "dropmalcty": "MAKAWAO",
    "dropmalst": "HI",
    "dropmalzpp": 967689998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8085720019,
    "dropsitcph": 8085720019,
    "dropfax": 8085721264
  },
  {
    "dcode": "D",
    "dropkey": "PZ12269",
    "droptype": "D",
    "dropname": "MAKAWELI",
    "dropdeladd": "1-1100 KAUMUALII HWY",
    "dropdelcty": "MAKAWELI",
    "dropdelst": "HI",
    "dropdelzpp": 967699997,
    "dropphyadd": "1-1100 KAUMUALII HWY",
    "dropphycty": "MAKAWELI",
    "dropphyst": "HI",
    "dropphyzpp": 967699997,
    "dropmaladd": "PO BOX 699998",
    "dropmalcty": "MAKAWELI",
    "dropmalst": "HI",
    "dropmalzpp": 967699998,
    "dropsitphn": 8084233893,
    "dropsitlph": 8083389921,
    "dropsitcph": 8083389921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12276",
    "droptype": "D",
    "dropname": "MAUNALOA",
    "dropdeladd": "2 MAUNALOA RD BLDG 2",
    "dropdelcty": "MAUNALOA",
    "dropdelst": "HI",
    "dropdelzpp": 967709997,
    "dropphyadd": "2 MAUNALOA RD BLDG 2",
    "dropphycty": "MAUNALOA",
    "dropphyst": "HI",
    "dropphyzpp": 967709997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAUNALOA",
    "dropmalst": "HI",
    "dropmalzpp": 967709998,
    "dropsitphn": 8085522852,
    "dropsitlph": 8085522852,
    "dropsitcph": 8085522852,
    "dropfax": 6514566664
  },
  {
    "dcode": "D",
    "dropkey": "PZ12283",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "18-1350 VOLCANO RD",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "HI",
    "dropdelzpp": 967719997,
    "dropphyadd": "18-1350 VOLCANO RD",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "HI",
    "dropphyzpp": 967719997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "HI",
    "dropmalzpp": 967719998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089686461,
    "dropsitcph": 8089686461,
    "dropfax": 8089686629
  },
  {
    "dcode": "D",
    "dropkey": "PZ12285",
    "droptype": "D",
    "dropname": "NAALEHU",
    "dropdeladd": "95-5663 MAMALAHOA HWY",
    "dropdelcty": "NAALEHU",
    "dropdelst": "HI",
    "dropdelzpp": 967729997,
    "dropphyadd": "95-5663 MAMALAHOA HWY",
    "dropphycty": "NAALEHU",
    "dropphyst": "HI",
    "dropphyzpp": 967729997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAALEHU",
    "dropmalst": "HI",
    "dropmalzpp": 967729998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089297141,
    "dropsitcph": 8089297141,
    "dropfax": 8089299609
  },
  {
    "dcode": "D",
    "dropkey": "PZ12304",
    "droptype": "D",
    "dropname": "PAAUILO",
    "dropdeladd": "43-1355 MAMALAHOA HWY",
    "dropdelcty": "PAAUILO",
    "dropdelst": "HI",
    "dropdelzpp": 967769997,
    "dropphyadd": "43-1355 MAMALAHOA HWY",
    "dropphycty": "PAAUILO",
    "dropphyst": "HI",
    "dropphyzpp": 967769997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAAUILO",
    "dropmalst": "HI",
    "dropmalzpp": 967769998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8087761282,
    "dropsitcph": 8087761282,
    "dropfax": 8082178233
  },
  {
    "dcode": "D",
    "dropkey": "PZ12305",
    "droptype": "D",
    "dropname": "PAHALA",
    "dropdeladd": "96-3163 PIKAKE ST",
    "dropdelcty": "PAHALA",
    "dropdelst": "HI",
    "dropdelzpp": 967779997,
    "dropphyadd": "96-3163 PIKAKE ST",
    "dropphycty": "PAHALA",
    "dropphyst": "HI",
    "dropphyzpp": 967779997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAHALA",
    "dropmalst": "HI",
    "dropmalzpp": 967779998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089289815,
    "dropsitcph": 8089289815,
    "dropfax": 8089280804
  },
  {
    "dcode": "D",
    "dropkey": "PZ12306",
    "droptype": "D",
    "dropname": "PAHOA",
    "dropdeladd": "15-2859 PAHOA VILLAGE RD",
    "dropdelcty": "PAHOA",
    "dropdelst": "HI",
    "dropdelzpp": 967789998,
    "dropphyadd": "15-2859 PAHOA VILLAGE RD",
    "dropphycty": "PAHOA",
    "dropphyst": "HI",
    "dropphyzpp": 967789998,
    "dropmaladd": "15-2859 PAHOA VILLAGE RD",
    "dropmalcty": "PAHOA",
    "dropmalst": "HI",
    "dropmalzpp": 967789998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089651158,
    "dropsitcph": 8089651158,
    "dropfax": 8089650257
  },
  {
    "dcode": "D",
    "dropkey": "PZ12307",
    "droptype": "D",
    "dropname": "PAIA",
    "dropdeladd": "120 BALDWIN AVE",
    "dropdelcty": "PAIA",
    "dropdelst": "HI",
    "dropdelzpp": 967799998,
    "dropphyadd": "120 BALDWIN AVE",
    "dropphycty": "PAIA",
    "dropphyst": "HI",
    "dropphyzpp": 967799998,
    "dropmaladd": "120 BALDWIN AVE",
    "dropmalcty": "PAIA",
    "dropmalst": "HI",
    "dropmalzpp": 967799998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085798866,
    "dropsitcph": 8085798866,
    "dropfax": 8085799758
  },
  {
    "dcode": "D",
    "dropkey": "PZ12309",
    "droptype": "D",
    "dropname": "PAPAALOA",
    "dropdeladd": "35-2032 OLD MAMALAHOA HWY",
    "dropdelcty": "PAPAALOA",
    "dropdelst": "HI",
    "dropdelzpp": 967809997,
    "dropphyadd": "35-2032 OLD MAMALAHOA HWY",
    "dropphycty": "PAPAALOA",
    "dropphyst": "HI",
    "dropphyzpp": 967809997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAPAALOA",
    "dropmalst": "HI",
    "dropmalzpp": 967809998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089626533,
    "dropsitcph": 8089626533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12310",
    "droptype": "D",
    "dropname": "PAPAIKOU",
    "dropdeladd": "27-250 OLD MAMALAHOA HWY",
    "dropdelcty": "PAPAIKOU",
    "dropdelst": "HI",
    "dropdelzpp": 967817735,
    "dropphyadd": "27-250 OLD MAMALAHOA HWY",
    "dropphycty": "PAPAIKOU",
    "dropphyst": "HI",
    "dropphyzpp": 967817735,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAPAIKOU",
    "dropmalst": "HI",
    "dropmalzpp": 967819998,
    "dropsitphn": 8083393681,
    "dropsitlph": 8083393681,
    "dropsitcph": 8089641621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12311",
    "droptype": "D",
    "dropname": "PEARL CITY",
    "dropdeladd": "950 KAMEHAMEHA HWY",
    "dropdelcty": "PEARL CITY",
    "dropdelst": "HI",
    "dropdelzpp": 967829998,
    "dropphyadd": "950 KAMEHAMEHA HWY",
    "dropphycty": "PEARL CITY",
    "dropphyst": "HI",
    "dropphyzpp": 967829998,
    "dropmaladd": "950 KAMEHAMEHA HWY",
    "dropmalcty": "PEARL CITY",
    "dropmalst": "HI",
    "dropmalzpp": 967829998,
    "dropsitphn": 8084530111,
    "dropsitlph": 8084530111,
    "dropsitcph": 8084530111,
    "dropfax": 8086640183
  },
  {
    "dcode": "D",
    "dropkey": "PZ12320",
    "droptype": "D",
    "dropname": "PEPEEKEO",
    "dropdeladd": "28-2825 MAMALAHOA HWY",
    "dropdelcty": "PEPEEKEO",
    "dropdelst": "HI",
    "dropdelzpp": 967838497,
    "dropphyadd": "28-2825 MAMALAHOA HWY",
    "dropphycty": "PEPEEKEO",
    "dropphyst": "HI",
    "dropphyzpp": 967838497,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEPEEKEO",
    "dropmalst": "HI",
    "dropmalzpp": 967839998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089643253,
    "dropsitcph": 8089643253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12333",
    "droptype": "D",
    "dropname": "PUUNENE",
    "dropdeladd": "10 HANSEN RD",
    "dropdelcty": "PUUNENE",
    "dropdelst": "HI",
    "dropdelzpp": 967849997,
    "dropphyadd": "10 HANSEN RD",
    "dropphycty": "PUUNENE",
    "dropphyst": "HI",
    "dropphyzpp": 967849997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PUUNENE",
    "dropmalst": "HI",
    "dropmalzpp": 967849998,
    "dropsitphn": 8088711352,
    "dropsitlph": 8088711352,
    "dropsitcph": 8088711352,
    "dropfax": 8088714809
  },
  {
    "dcode": "D",
    "dropkey": "PZ12352",
    "droptype": "D",
    "dropname": "VOLCANO",
    "dropdeladd": "19-4030 OLD VOLCANO HWY",
    "dropdelcty": "VOLCANO",
    "dropdelst": "HI",
    "dropdelzpp": 967859997,
    "dropphyadd": "19-4030 OLD VOLCANO HWY",
    "dropphycty": "VOLCANO",
    "dropphyst": "HI",
    "dropphyzpp": 967859997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VOLCANO",
    "dropmalst": "HI",
    "dropmalzpp": 967859998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089677611,
    "dropsitcph": 8089677611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12353",
    "droptype": "D",
    "dropname": "WAHIAWA",
    "dropdeladd": "115 LEHUA ST",
    "dropdelcty": "WAHIAWA",
    "dropdelst": "HI",
    "dropdelzpp": 967869998,
    "dropphyadd": "115 LEHUA ST",
    "dropphycty": "WAHIAWA",
    "dropphyst": "HI",
    "dropphyzpp": 967869998,
    "dropmaladd": "115 LEHUA ST",
    "dropmalcty": "WAHIAWA",
    "dropmalst": "HI",
    "dropmalzpp": 967869998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086221182,
    "dropsitcph": 8086221182,
    "dropfax": 8086222107
  },
  {
    "dcode": "D",
    "dropkey": "PZ12356",
    "droptype": "D",
    "dropname": "WAIALUA",
    "dropdeladd": "67-079 NAUAHI ST",
    "dropdelcty": "WAIALUA",
    "dropdelst": "HI",
    "dropdelzpp": 967919998,
    "dropphyadd": "67-079 NAUAHI ST",
    "dropphycty": "WAIALUA",
    "dropphyst": "HI",
    "dropphyzpp": 967919998,
    "dropmaladd": "67-079 NAUAHI ST",
    "dropmalcty": "WAIALUA",
    "dropmalst": "HI",
    "dropmalzpp": 967919998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086372754,
    "dropsitcph": 8086372754,
    "dropfax": 8086379016
  },
  {
    "dcode": "D",
    "dropkey": "PZ12357",
    "droptype": "D",
    "dropname": "WAIANAE",
    "dropdeladd": "86-014 FARRINGTON HWY",
    "dropdelcty": "WAIANAE",
    "dropdelst": "HI",
    "dropdelzpp": 967929998,
    "dropphyadd": "86-014 FARRINGTON HWY",
    "dropphycty": "WAIANAE",
    "dropphyst": "HI",
    "dropphyzpp": 967929998,
    "dropmaladd": "86-014 FARRINGTON HWY",
    "dropmalcty": "WAIANAE",
    "dropmalst": "HI",
    "dropmalzpp": 967929998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086960161,
    "dropsitcph": 8086960161,
    "dropfax": 8086965062
  },
  {
    "dcode": "D",
    "dropkey": "PZ12363",
    "droptype": "D",
    "dropname": "WAILUKU",
    "dropdeladd": "250 IMI KALA ST",
    "dropdelcty": "WAILUKU",
    "dropdelst": "HI",
    "dropdelzpp": 967939998,
    "dropphyadd": "250 IMI KALA ST",
    "dropphycty": "WAILUKU",
    "dropphyst": "HI",
    "dropphyzpp": 967939998,
    "dropmaladd": "250 IMI KALA ST",
    "dropmalcty": "WAILUKU",
    "dropmalst": "HI",
    "dropmalzpp": 967939998,
    "dropsitphn": 8082441653,
    "dropsitlph": 8082441653,
    "dropsitcph": 8082441653,
    "dropfax": 8082428823
  },
  {
    "dcode": "D",
    "dropkey": "PZ12365",
    "droptype": "D",
    "dropname": "WAIMANALO",
    "dropdeladd": "41-859 KALANIANAOLE HWY",
    "dropdelcty": "WAIMANALO",
    "dropdelst": "HI",
    "dropdelzpp": 967959998,
    "dropphyadd": "41-859 KALANIANAOLE HWY",
    "dropphycty": "WAIMANALO",
    "dropphyst": "HI",
    "dropphyzpp": 967959998,
    "dropmaladd": "41-859 KALANIANAOLE HWY",
    "dropmalcty": "WAIMANALO",
    "dropmalst": "HI",
    "dropmalzpp": 967959998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8082590234,
    "dropsitcph": 8082590234,
    "dropfax": 8083774290
  },
  {
    "dcode": "D",
    "dropkey": "PZ12367",
    "droptype": "D",
    "dropname": "WAIMEA",
    "dropdeladd": "9911 WAIMEA RD",
    "dropdelcty": "WAIMEA",
    "dropdelst": "HI",
    "dropdelzpp": 967969997,
    "dropphyadd": "9911 WAIMEA RD",
    "dropphycty": "WAIMEA",
    "dropphyst": "HI",
    "dropphyzpp": 967969997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAIMEA",
    "dropmalst": "HI",
    "dropmalzpp": 967969998,
    "dropsitphn": 8082120271,
    "dropsitlph": 8083389973,
    "dropsitcph": 8083389973,
    "dropfax": 8083380361
  },
  {
    "dcode": "D",
    "dropkey": "PZ12368",
    "droptype": "D",
    "dropname": "WAIPAHU",
    "dropdeladd": "94-245 LEOKU ST",
    "dropdelcty": "WAIPAHU",
    "dropdelst": "HI",
    "dropdelzpp": 967979998,
    "dropphyadd": "94-245 LEOKU ST",
    "dropphycty": "WAIPAHU",
    "dropphyst": "HI",
    "dropphyzpp": 967979998,
    "dropmaladd": "94-245 LEOKU ST",
    "dropmalcty": "WAIPAHU",
    "dropmalst": "HI",
    "dropmalzpp": 967979998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086710369,
    "dropsitcph": 8086710369,
    "dropfax": 8086800077
  },
  {
    "dcode": "D",
    "dropkey": "PZ12376",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "82 W CENTRAL AVE",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "ID",
    "dropdelzpp": 832109998,
    "dropphyadd": "82 W CENTRAL AVE",
    "dropphycty": "ABERDEEN",
    "dropphyst": "ID",
    "dropphyzpp": 832109998,
    "dropmaladd": "82 W CENTRAL AVE",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "ID",
    "dropmalzpp": 832109998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083974901,
    "dropsitcph": 2083974901,
    "dropfax": 2083974901
  },
  {
    "dcode": "D",
    "dropkey": "PZ12378",
    "droptype": "D",
    "dropname": "AHSAHKA",
    "dropdeladd": "103 NORTHFORK DR",
    "dropdelcty": "AHSAHKA",
    "dropdelst": "ID",
    "dropdelzpp": 835209998,
    "dropphyadd": "103 NORTHFORK DR",
    "dropphycty": "AHSAHKA",
    "dropphyst": "ID",
    "dropphyzpp": 835209998,
    "dropmaladd": "103 NORTHFORK DR",
    "dropmalcty": "AHSAHKA",
    "dropmalst": "ID",
    "dropmalzpp": 835209998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084763432,
    "dropsitcph": 2084763432,
    "dropfax": 2084763432
  },
  {
    "dcode": "D",
    "dropkey": "PZ12383",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "150 W MARKET ST",
    "dropdelcty": "ALBION",
    "dropdelst": "ID",
    "dropdelzpp": 833119998,
    "dropphyadd": "150 W MARKET ST",
    "dropphycty": "ALBION",
    "dropphyst": "ID",
    "dropphyzpp": 833119998,
    "dropmaladd": "150 W MARKET ST",
    "dropmalcty": "ALBION",
    "dropmalst": "ID",
    "dropmalzpp": 833119998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086736680,
    "dropsitcph": 2086736680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12384",
    "droptype": "D",
    "dropname": "ALMO",
    "dropdeladd": "3001 ELBA ALMO RD",
    "dropdelcty": "ALMO",
    "dropdelst": "ID",
    "dropdelzpp": 833129998,
    "dropphyadd": "3001 ELBA ALMO RD",
    "dropphycty": "ALMO",
    "dropphyst": "ID",
    "dropphyzpp": 833129998,
    "dropmaladd": "3001 ELBA ALMO RD",
    "dropmalcty": "ALMO",
    "dropmalst": "ID",
    "dropmalzpp": 833129998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088245570,
    "dropsitcph": 2088245570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12388",
    "droptype": "D",
    "dropname": "AMERICAN FALLS",
    "dropdeladd": "136 IDAHO ST",
    "dropdelcty": "AMERICAN FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 832119998,
    "dropphyadd": "136 IDAHO ST",
    "dropphycty": "AMERICAN FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 832119998,
    "dropmaladd": "136 IDAHO ST",
    "dropmalcty": "AMERICAN FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 832119998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082265101,
    "dropsitcph": 2082265101,
    "dropfax": 2082262154
  },
  {
    "dcode": "D",
    "dropkey": "PZ12396",
    "droptype": "D",
    "dropname": "ARBON",
    "dropdeladd": "4351 ARBON VALLEY HWY",
    "dropdelcty": "ARBON",
    "dropdelst": "ID",
    "dropdelzpp": 832129998,
    "dropphyadd": "4351 ARBON VALLEY HWY",
    "dropphycty": "ARBON",
    "dropphyst": "ID",
    "dropphyzpp": 832129998,
    "dropmaladd": "4351 ARBON VALLEY HWY",
    "dropmalcty": "ARBON",
    "dropmalst": "ID",
    "dropmalzpp": 832129998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083352124,
    "dropsitcph": 2083352124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12398",
    "droptype": "D",
    "dropname": "ARCO",
    "dropdeladd": "147 LOST RIVER AVE",
    "dropdelcty": "ARCO",
    "dropdelst": "ID",
    "dropdelzpp": 832139998,
    "dropphyadd": "147 LOST RIVER AVE",
    "dropphycty": "ARCO",
    "dropphyst": "ID",
    "dropphyzpp": 832139998,
    "dropmaladd": "147 LOST RIVER AVE",
    "dropmalcty": "ARCO",
    "dropmalst": "ID",
    "dropmalzpp": 832139998,
    "dropsitphn": 2084334080,
    "dropsitlph": 9862218789,
    "dropsitcph": 9862218805,
    "dropfax": 2085273355
  },
  {
    "dcode": "D",
    "dropkey": "PZ12400",
    "droptype": "D",
    "dropname": "ARIMO",
    "dropdeladd": "25 N MEADOWVIEW ST",
    "dropdelcty": "ARIMO",
    "dropdelst": "ID",
    "dropdelzpp": 832149998,
    "dropphyadd": "25 N MEADOWVIEW ST",
    "dropphycty": "ARIMO",
    "dropphyst": "ID",
    "dropphyzpp": 832149998,
    "dropmaladd": "25 N MEADOWVIEW ST",
    "dropmalcty": "ARIMO",
    "dropmalst": "ID",
    "dropmalzpp": 832149998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082543512,
    "dropsitcph": 2082543512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12401",
    "droptype": "D",
    "dropname": "ASHTON",
    "dropdeladd": "109 S 5TH ST",
    "dropdelcty": "ASHTON",
    "dropdelst": "ID",
    "dropdelzpp": 834209998,
    "dropphyadd": "109 S 5TH ST",
    "dropphycty": "ASHTON",
    "dropphyst": "ID",
    "dropphyzpp": 834209998,
    "dropmaladd": "109 S 5TH ST",
    "dropmalcty": "ASHTON",
    "dropmalst": "ID",
    "dropmalzpp": 834209998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086523976,
    "dropsitcph": 2086523976,
    "dropfax": 2086523976
  },
  {
    "dcode": "D",
    "dropkey": "PZ12402",
    "droptype": "D",
    "dropname": "ATHOL",
    "dropdeladd": "29777 N OLD HIGHWAY 95",
    "dropdelcty": "ATHOL",
    "dropdelst": "ID",
    "dropdelzpp": 838019998,
    "dropphyadd": "29777 N OLD HIGHWAY 95",
    "dropphycty": "ATHOL",
    "dropphyst": "ID",
    "dropphyzpp": 838019998,
    "dropmaladd": "29777 N OLD HIGHWAY 95",
    "dropmalcty": "ATHOL",
    "dropmalst": "ID",
    "dropmalzpp": 838019998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086381320,
    "dropsitcph": 2086831320,
    "dropfax": 2086831321
  },
  {
    "dcode": "D",
    "dropkey": "PZ12405",
    "droptype": "D",
    "dropname": "AVERY",
    "dropdeladd": "10 DEPOT RD",
    "dropdelcty": "AVERY",
    "dropdelst": "ID",
    "dropdelzpp": 838029998,
    "dropphyadd": "10 DEPOT RD",
    "dropphycty": "AVERY",
    "dropphyst": "ID",
    "dropphyzpp": 838029998,
    "dropmaladd": "10 DEPOT RD",
    "dropmalcty": "AVERY",
    "dropmalst": "ID",
    "dropmalzpp": 838029998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082453557,
    "dropsitcph": 2082453557,
    "dropfax": 2082453557
  },
  {
    "dcode": "D",
    "dropkey": "PZ12407",
    "droptype": "D",
    "dropname": "BANCROFT",
    "dropdeladd": "11 S MAIN ST",
    "dropdelcty": "BANCROFT",
    "dropdelst": "ID",
    "dropdelzpp": 832179998,
    "dropphyadd": "11 S MAIN ST",
    "dropphycty": "BANCROFT",
    "dropphyst": "ID",
    "dropphyzpp": 832179998,
    "dropmaladd": "11 S MAIN ST",
    "dropmalcty": "BANCROFT",
    "dropmalst": "ID",
    "dropmalzpp": 832179998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086486369,
    "dropsitcph": 2086486369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12412",
    "droptype": "D",
    "dropname": "BASALT",
    "dropdeladd": "678 E 825 N",
    "dropdelcty": "BASALT",
    "dropdelst": "ID",
    "dropdelzpp": 832189998,
    "dropphyadd": "678 E 825 N",
    "dropphycty": "BASALT",
    "dropphyst": "ID",
    "dropphyzpp": 832189998,
    "dropmaladd": "678 E 825 N",
    "dropmalcty": "BASALT",
    "dropmalst": "ID",
    "dropmalzpp": 832189998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083464174,
    "dropsitcph": 2083464174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12415",
    "droptype": "D",
    "dropname": "BAYVIEW",
    "dropdeladd": "20157 E PERIMETER RD",
    "dropdelcty": "BAYVIEW",
    "dropdelst": "ID",
    "dropdelzpp": 838039998,
    "dropphyadd": "20157 E PERIMETER RD",
    "dropphycty": "BAYVIEW",
    "dropphyst": "ID",
    "dropphyzpp": 838039998,
    "dropmaladd": "20157 E PERIMETER RD",
    "dropmalcty": "BAYVIEW",
    "dropmalst": "ID",
    "dropmalzpp": 838039998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086832733,
    "dropsitcph": 2086832733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12418",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "101 E PINE ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "ID",
    "dropdelzpp": 833139998,
    "dropphyadd": "101 E PINE ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "ID",
    "dropphyzpp": 833139998,
    "dropmaladd": "101 E PINE ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "ID",
    "dropmalzpp": 833139998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087889770,
    "dropsitcph": 2087889770,
    "dropfax": 2087889770
  },
  {
    "dcode": "D",
    "dropkey": "PZ12424",
    "droptype": "D",
    "dropname": "BLACKFOOT",
    "dropdeladd": "165 W PACIFIC ST",
    "dropdelcty": "BLACKFOOT",
    "dropdelst": "ID",
    "dropdelzpp": 832219998,
    "dropphyadd": "165 W PACIFIC ST",
    "dropphycty": "BLACKFOOT",
    "dropphyst": "ID",
    "dropphyzpp": 832219998,
    "dropmaladd": "165 W PACIFIC ST",
    "dropmalcty": "BLACKFOOT",
    "dropmalst": "ID",
    "dropmalzpp": 832219998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087857648,
    "dropsitcph": 2087850333,
    "dropfax": 2087856579
  },
  {
    "dcode": "D",
    "dropkey": "PZ12425",
    "droptype": "D",
    "dropname": "BLANCHARD",
    "dropdeladd": "425 RAILROAD AVE",
    "dropdelcty": "BLANCHARD",
    "dropdelst": "ID",
    "dropdelzpp": 838049998,
    "dropphyadd": "425 RAILROAD AVE",
    "dropphycty": "BLANCHARD",
    "dropphyst": "ID",
    "dropphyzpp": 838049998,
    "dropmaladd": "425 RAILROAD AVE",
    "dropmalcty": "BLANCHARD",
    "dropmalst": "ID",
    "dropmalzpp": 838049998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084372720,
    "dropsitcph": 2084372720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12426",
    "droptype": "D",
    "dropname": "BLISS",
    "dropdeladd": "100 E HIGHWAY 30",
    "dropdelcty": "BLISS",
    "dropdelst": "ID",
    "dropdelzpp": 833149998,
    "dropphyadd": "100 E HIGHWAY 30",
    "dropphycty": "BLISS",
    "dropphyst": "ID",
    "dropphyzpp": 833149998,
    "dropmaladd": "100 E HIGHWAY 30",
    "dropmalcty": "BLISS",
    "dropmalst": "ID",
    "dropmalzpp": 833149998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083522504,
    "dropsitcph": 2083522504,
    "dropfax": 2083524293
  },
  {
    "dcode": "D",
    "dropkey": "PZ12427",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "11 N MAIN ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "ID",
    "dropdelzpp": 832239998,
    "dropphyadd": "11 N MAIN ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "ID",
    "dropphyzpp": 832239998,
    "dropmaladd": "11 N MAIN ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "ID",
    "dropmalzpp": 832239998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2089452958,
    "dropsitcph": 2089452958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12430",
    "droptype": "D",
    "dropname": "BOISE",
    "dropdeladd": "770 S 13TH ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837089998,
    "dropphyadd": "770 S 13TH ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837089998,
    "dropmaladd": "770 S 13TH ST",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837089998,
    "dropsitphn": 2084334351,
    "dropsitlph": 2084334080,
    "dropsitcph": 2084334351,
    "dropfax": 2084334400
  },
  {
    "dcode": "D",
    "dropkey": "PZ12436",
    "droptype": "D",
    "dropname": "BONNERS FERRY",
    "dropdeladd": "7167 1ST ST",
    "dropdelcty": "BONNERS FERRY",
    "dropdelst": "ID",
    "dropdelzpp": 838059998,
    "dropphyadd": "7167 1ST ST",
    "dropphycty": "BONNERS FERRY",
    "dropphyst": "ID",
    "dropphyzpp": 838059998,
    "dropmaladd": "7167 1ST ST",
    "dropmalcty": "BONNERS FERRY",
    "dropmalst": "ID",
    "dropmalzpp": 838059998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082673302,
    "dropsitcph": 2082673302,
    "dropfax": 6514566589
  },
  {
    "dcode": "D",
    "dropkey": "PZ12438",
    "droptype": "D",
    "dropname": "BOVILL",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "BOVILL",
    "dropdelst": "ID",
    "dropdelzpp": 838069998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "BOVILL",
    "dropphyst": "ID",
    "dropphyzpp": 838069998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "BOVILL",
    "dropmalst": "ID",
    "dropmalzpp": 838069998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088263415,
    "dropsitcph": 2088263415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12443",
    "droptype": "D",
    "dropname": "BRUNEAU",
    "dropdeladd": "32078 RUTH ST",
    "dropdelcty": "BRUNEAU",
    "dropdelst": "ID",
    "dropdelzpp": 836049998,
    "dropphyadd": "32078 RUTH ST",
    "dropphycty": "BRUNEAU",
    "dropphyst": "ID",
    "dropphyzpp": 836049998,
    "dropmaladd": "32078 RUTH ST",
    "dropmalcty": "BRUNEAU",
    "dropmalst": "ID",
    "dropmalzpp": 836049998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088452020,
    "dropsitcph": 2088452020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12445",
    "droptype": "D",
    "dropname": "BUHL",
    "dropdeladd": "830 MAIN ST",
    "dropdelcty": "BUHL",
    "dropdelst": "ID",
    "dropdelzpp": 833169998,
    "dropphyadd": "830 MAIN ST",
    "dropphycty": "BUHL",
    "dropphyst": "ID",
    "dropphyzpp": 833169998,
    "dropmaladd": "830 MAIN ST",
    "dropmalcty": "BUHL",
    "dropmalst": "ID",
    "dropmalzpp": 833169998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085436152,
    "dropsitcph": 2085436152,
    "dropfax": 2085432199
  },
  {
    "dcode": "D",
    "dropkey": "PZ12447",
    "droptype": "D",
    "dropname": "BURLEY",
    "dropdeladd": "1353 OVERLAND AVE",
    "dropdelcty": "BURLEY",
    "dropdelst": "ID",
    "dropdelzpp": 833181863,
    "dropphyadd": "1353 OVERLAND AVE",
    "dropphycty": "BURLEY",
    "dropphyst": "ID",
    "dropphyzpp": 833181863,
    "dropmaladd": "1353 OVERLAND AVE",
    "dropmalcty": "BURLEY",
    "dropmalst": "ID",
    "dropmalzpp": 833181863,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086782541,
    "dropsitcph": 2086782541,
    "dropfax": 2086781148
  },
  {
    "dcode": "D",
    "dropkey": "PZ12451",
    "droptype": "D",
    "dropname": "CALDER",
    "dropdeladd": "36 RAILROAD ST",
    "dropdelcty": "CALDER",
    "dropdelst": "ID",
    "dropdelzpp": 838089998,
    "dropphyadd": "36 RAILROAD ST",
    "dropphycty": "CALDER",
    "dropphyst": "ID",
    "dropphyzpp": 838089998,
    "dropmaladd": "36 RAILROAD ST",
    "dropmalcty": "CALDER",
    "dropmalst": "ID",
    "dropmalzpp": 838089998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082454483,
    "dropsitcph": 2082454483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12452",
    "droptype": "D",
    "dropname": "CALDWELL",
    "dropdeladd": "823 ARTHUR ST",
    "dropdelcty": "CALDWELL",
    "dropdelst": "ID",
    "dropdelzpp": 836059998,
    "dropphyadd": "823 ARTHUR ST",
    "dropphycty": "CALDWELL",
    "dropphyst": "ID",
    "dropphyzpp": 836059998,
    "dropmaladd": "823 ARTHUR ST",
    "dropmalcty": "CALDWELL",
    "dropmalst": "ID",
    "dropmalzpp": 836059998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084545560,
    "dropsitcph": 2084545560,
    "dropfax": 2084599304
  },
  {
    "dcode": "D",
    "dropkey": "PZ12454",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "210 N SUPERIOR ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "ID",
    "dropdelzpp": 836109998,
    "dropphyadd": "210 N SUPERIOR ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "ID",
    "dropphyzpp": 836109998,
    "dropmaladd": "210 N SUPERIOR ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "ID",
    "dropmalzpp": 836109998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082573585,
    "dropsitcph": 2082573585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12456",
    "droptype": "D",
    "dropname": "CAREY",
    "dropdeladd": "20492 N MAIN ST",
    "dropdelcty": "CAREY",
    "dropdelst": "ID",
    "dropdelzpp": 833205050,
    "dropphyadd": "20492 N MAIN ST",
    "dropphycty": "CAREY",
    "dropphyst": "ID",
    "dropphyzpp": 833205050,
    "dropmaladd": "20492 N MAIN ST",
    "dropmalcty": "CAREY",
    "dropmalst": "ID",
    "dropmalzpp": 833205050,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088234461,
    "dropsitcph": 2088234461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12458",
    "droptype": "D",
    "dropname": "CARMEN",
    "dropdeladd": "401 HIGHWAY 93 N",
    "dropdelcty": "CARMEN",
    "dropdelst": "ID",
    "dropdelzpp": 834629998,
    "dropphyadd": "401 HIGHWAY 93 N",
    "dropphycty": "CARMEN",
    "dropphyst": "ID",
    "dropphyzpp": 834629998,
    "dropmaladd": "401 HIGHWAY 93 N",
    "dropmalcty": "CARMEN",
    "dropmalst": "ID",
    "dropmalzpp": 834629998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087562557,
    "dropsitcph": 2087562557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12459",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "202 S FRONT ST",
    "dropdelcty": "CASCADE",
    "dropdelst": "ID",
    "dropdelzpp": 836115219,
    "dropphyadd": "202 S FRONT ST",
    "dropphycty": "CASCADE",
    "dropphyst": "ID",
    "dropphyzpp": 836115219,
    "dropmaladd": "202 S FRONT ST",
    "dropmalcty": "CASCADE",
    "dropmalst": "ID",
    "dropmalzpp": 836119998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083824148,
    "dropsitcph": 2083824148,
    "dropfax": 2083824991
  },
  {
    "dcode": "D",
    "dropkey": "PZ12460",
    "droptype": "D",
    "dropname": "CASTLEFORD",
    "dropdeladd": "357 MAIN ST",
    "dropdelcty": "CASTLEFORD",
    "dropdelst": "ID",
    "dropdelzpp": 833219998,
    "dropphyadd": "357 MAIN ST",
    "dropphycty": "CASTLEFORD",
    "dropphyst": "ID",
    "dropphyzpp": 833219998,
    "dropmaladd": "357 MAIN ST",
    "dropmalcty": "CASTLEFORD",
    "dropmalst": "ID",
    "dropmalzpp": 833219998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085376670,
    "dropsitcph": 2085376670,
    "dropfax": 2085379933
  },
  {
    "dcode": "D",
    "dropkey": "PZ12461",
    "droptype": "D",
    "dropname": "CATALDO",
    "dropdeladd": "36180 E CANYON RD",
    "dropdelcty": "CATALDO",
    "dropdelst": "ID",
    "dropdelzpp": 838109998,
    "dropphyadd": "36180 E CANYON RD",
    "dropphycty": "CATALDO",
    "dropphyst": "ID",
    "dropphyzpp": 838109998,
    "dropmaladd": "36180 E CANYON RD",
    "dropmalcty": "CATALDO",
    "dropmalst": "ID",
    "dropmalzpp": 838109998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086823114,
    "dropsitcph": 2086823114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12465",
    "droptype": "D",
    "dropname": "CHALLIS",
    "dropdeladd": "601 N MAIN AVE",
    "dropdelcty": "CHALLIS",
    "dropdelst": "ID",
    "dropdelzpp": 832269998,
    "dropphyadd": "601 N MAIN AVE",
    "dropphycty": "CHALLIS",
    "dropphyst": "ID",
    "dropphyzpp": 832269998,
    "dropmaladd": "601 N MAIN AVE",
    "dropmalcty": "CHALLIS",
    "dropmalst": "ID",
    "dropmalzpp": 832269998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088792705,
    "dropsitcph": 2088792705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12467",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "797 EAST ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "ID",
    "dropdelzpp": 834219998,
    "dropphyadd": "797 EAST ST",
    "dropphycty": "CHESTER",
    "dropphyst": "ID",
    "dropphyzpp": 834219998,
    "dropmaladd": "797 EAST ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "ID",
    "dropmalzpp": 834219998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086435775,
    "dropsitcph": 2086435775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12473",
    "droptype": "D",
    "dropname": "CLARK FORK",
    "dropdeladd": "230 N MAIN ST",
    "dropdelcty": "CLARK FORK",
    "dropdelst": "ID",
    "dropdelzpp": 838119998,
    "dropphyadd": "230 N MAIN ST",
    "dropphycty": "CLARK FORK",
    "dropphyst": "ID",
    "dropphyzpp": 838119998,
    "dropmaladd": "230 N MAIN ST",
    "dropmalcty": "CLARK FORK",
    "dropmalst": "ID",
    "dropmalzpp": 838119998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082661145,
    "dropsitcph": 2082661145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12476",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "ID",
    "dropdelzpp": 832279998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "ID",
    "dropphyzpp": 832279998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "ID",
    "dropmalzpp": 832279998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088382335,
    "dropsitcph": 2088382335,
    "dropfax": 2088382717
  },
  {
    "dcode": "D",
    "dropkey": "PZ12479",
    "droptype": "D",
    "dropname": "CLIFTON",
    "dropdeladd": "30 S MAIN HWY",
    "dropdelcty": "CLIFTON",
    "dropdelst": "ID",
    "dropdelzpp": 832289998,
    "dropphyadd": "30 S MAIN HWY",
    "dropphycty": "CLIFTON",
    "dropphyst": "ID",
    "dropphyzpp": 832289998,
    "dropmaladd": "30 S MAIN HWY",
    "dropmalcty": "CLIFTON",
    "dropmalst": "ID",
    "dropmalzpp": 832289998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087473200,
    "dropsitcph": 2087473200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12483",
    "droptype": "D",
    "dropname": "COCOLALLA",
    "dropdeladd": "31 COCOLALLA LOOP RD",
    "dropdelcty": "COCOLALLA",
    "dropdelst": "ID",
    "dropdelzpp": 838139998,
    "dropphyadd": "31 COCOLALLA LOOP RD",
    "dropphycty": "COCOLALLA",
    "dropphyst": "ID",
    "dropphyzpp": 838139998,
    "dropmaladd": "31 COCOLALLA LOOP RD",
    "dropmalcty": "COCOLALLA",
    "dropmalst": "ID",
    "dropmalzpp": 838139998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082631562,
    "dropsitcph": 2082631562,
    "dropfax": 6505784685
  },
  {
    "dcode": "D",
    "dropkey": "PZ12484",
    "droptype": "D",
    "dropname": "COEUR D ALENE",
    "dropdeladd": "111 N 7TH ST",
    "dropdelcty": "COEUR D ALENE",
    "dropdelst": "ID",
    "dropdelzpp": 838149998,
    "dropphyadd": "111 N 7TH ST",
    "dropphycty": "COEUR D ALENE",
    "dropphyst": "ID",
    "dropphyzpp": 838149998,
    "dropmaladd": "111 N 7TH ST",
    "dropmalcty": "COEUR D ALENE",
    "dropmalst": "ID",
    "dropmalzpp": 838149998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087651999,
    "dropsitcph": 2087653741,
    "dropfax": 6514566157
  },
  {
    "dcode": "D",
    "dropkey": "PZ12492",
    "droptype": "D",
    "dropname": "COOLIN",
    "dropdeladd": "367 BAY VIEW DR",
    "dropdelcty": "COOLIN",
    "dropdelst": "ID",
    "dropdelzpp": 838219998,
    "dropphyadd": "367 BAY VIEW DR",
    "dropphycty": "COOLIN",
    "dropphyst": "ID",
    "dropphyzpp": 838219998,
    "dropmaladd": "367 BAY VIEW DR",
    "dropmalcty": "COOLIN",
    "dropmalst": "ID",
    "dropmalzpp": 838219998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084432066,
    "dropsitcph": 2084432066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12497",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "301 BROADWAY",
    "dropdelcty": "COTTONWOOD",
    "dropdelst": "ID",
    "dropdelzpp": 835229998,
    "dropphyadd": "301 BROADWAY",
    "dropphycty": "COTTONWOOD",
    "dropphyst": "ID",
    "dropphyzpp": 835229998,
    "dropmaladd": "301 BROADWAY",
    "dropmalcty": "COTTONWOOD",
    "dropmalst": "ID",
    "dropmalzpp": 835229998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089623861,
    "dropsitcph": 2089623861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12498",
    "droptype": "D",
    "dropname": "COUNCIL",
    "dropdeladd": "101 CALIFORNIA AVE",
    "dropdelcty": "COUNCIL",
    "dropdelst": "ID",
    "dropdelzpp": 836129998,
    "dropphyadd": "101 CALIFORNIA AVE",
    "dropphycty": "COUNCIL",
    "dropphyst": "ID",
    "dropphyzpp": 836129998,
    "dropmaladd": "101 CALIFORNIA AVE",
    "dropmalcty": "COUNCIL",
    "dropmalst": "ID",
    "dropmalzpp": 836129998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082534448,
    "dropsitcph": 2082534448,
    "dropfax": 2082534448
  },
  {
    "dcode": "D",
    "dropkey": "PZ12499",
    "droptype": "D",
    "dropname": "CRAIGMONT",
    "dropdeladd": "118 W MAIN ST",
    "dropdelcty": "CRAIGMONT",
    "dropdelst": "ID",
    "dropdelzpp": 835239998,
    "dropphyadd": "118 W MAIN ST",
    "dropphycty": "CRAIGMONT",
    "dropphyst": "ID",
    "dropphyzpp": 835239998,
    "dropmaladd": "118 W MAIN ST",
    "dropmalcty": "CRAIGMONT",
    "dropmalst": "ID",
    "dropmalzpp": 835239998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089243700,
    "dropsitcph": 2089244100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12503",
    "droptype": "D",
    "dropname": "CULDESAC",
    "dropdeladd": "902 MAIN ST",
    "dropdelcty": "CULDESAC",
    "dropdelst": "ID",
    "dropdelzpp": 835249998,
    "dropphyadd": "902 MAIN ST",
    "dropphycty": "CULDESAC",
    "dropphyst": "ID",
    "dropphyzpp": 835249998,
    "dropmaladd": "902 MAIN ST",
    "dropmalcty": "CULDESAC",
    "dropmalst": "ID",
    "dropmalzpp": 835249998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088432252,
    "dropsitcph": 2088432252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12508",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "816 N WESTSIDE HWY",
    "dropdelcty": "DAYTON",
    "dropdelst": "ID",
    "dropdelzpp": 832329998,
    "dropphyadd": "816 N WESTSIDE HWY",
    "dropphycty": "DAYTON",
    "dropphyst": "ID",
    "dropphyzpp": 832329998,
    "dropmaladd": "816 N WESTSIDE HWY",
    "dropmalcty": "DAYTON",
    "dropmalst": "ID",
    "dropmalzpp": 832329998,
    "dropsitphn": 2084334080,
    "dropsitlph": 9862230182,
    "dropsitcph": 9862230182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12509",
    "droptype": "D",
    "dropname": "DEARY",
    "dropdeladd": "407 LINE ST",
    "dropdelcty": "DEARY",
    "dropdelst": "ID",
    "dropdelzpp": 838239997,
    "dropphyadd": "407 LINE ST",
    "dropphycty": "DEARY",
    "dropphyst": "ID",
    "dropphyzpp": 838239997,
    "dropmaladd": "407 LINE ST",
    "dropmalcty": "DEARY",
    "dropmalst": "ID",
    "dropmalzpp": 838239997,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088771470,
    "dropsitcph": 2088771470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12510",
    "droptype": "D",
    "dropname": "DECLO",
    "dropdeladd": "17 W MAIN ST",
    "dropdelcty": "DECLO",
    "dropdelst": "ID",
    "dropdelzpp": 833239998,
    "dropphyadd": "17 W MAIN ST",
    "dropphycty": "DECLO",
    "dropphyst": "ID",
    "dropphyzpp": 833239998,
    "dropmaladd": "17 W MAIN ST",
    "dropmalcty": "DECLO",
    "dropmalst": "ID",
    "dropmalzpp": 833239998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086542571,
    "dropsitcph": 2086542571,
    "dropfax": 2086544204
  },
  {
    "dcode": "D",
    "dropkey": "PZ12513",
    "droptype": "D",
    "dropname": "DESMET",
    "dropdeladd": "111 BYRNES AVE",
    "dropdelcty": "DESMET",
    "dropdelst": "ID",
    "dropdelzpp": 838249998,
    "dropphyadd": "111 BYRNES AVE",
    "dropphycty": "DESMET",
    "dropphyst": "ID",
    "dropphyzpp": 838249998,
    "dropmaladd": "111 BYRNES AVE",
    "dropmalcty": "DESMET",
    "dropmalst": "ID",
    "dropmalzpp": 838249998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082746461,
    "dropsitcph": 2082746461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12518",
    "droptype": "D",
    "dropname": "DONNELLY",
    "dropdeladd": "186 N MAIN ST",
    "dropdelcty": "DONNELLY",
    "dropdelst": "ID",
    "dropdelzpp": 836159998,
    "dropphyadd": "186 N MAIN ST",
    "dropphycty": "DONNELLY",
    "dropphyst": "ID",
    "dropphyzpp": 836159998,
    "dropmaladd": "186 N MAIN ST",
    "dropmalcty": "DONNELLY",
    "dropmalst": "ID",
    "dropmalzpp": 836159998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083258746,
    "dropsitcph": 2083258746,
    "dropfax": 2083258746
  },
  {
    "dcode": "D",
    "dropkey": "PZ12519",
    "droptype": "D",
    "dropname": "DOVER",
    "dropdeladd": "304 JACKSON AVE",
    "dropdelcty": "DOVER",
    "dropdelst": "ID",
    "dropdelzpp": 838259998,
    "dropphyadd": "304 JACKSON AVE",
    "dropphycty": "DOVER",
    "dropphyst": "ID",
    "dropphyzpp": 838259998,
    "dropmaladd": "304 JACKSON AVE",
    "dropmalcty": "DOVER",
    "dropmalst": "ID",
    "dropmalzpp": 838259998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082632240,
    "dropsitcph": 2082632240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12520",
    "droptype": "D",
    "dropname": "DOWNEY",
    "dropdeladd": "35 N MAIN ST",
    "dropdelcty": "DOWNEY",
    "dropdelst": "ID",
    "dropdelzpp": 832349998,
    "dropphyadd": "35 N MAIN ST",
    "dropphycty": "DOWNEY",
    "dropphyst": "ID",
    "dropphyzpp": 832349998,
    "dropmaladd": "35 N MAIN ST",
    "dropmalcty": "DOWNEY",
    "dropmalst": "ID",
    "dropmalzpp": 832349998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088975755,
    "dropsitcph": 2088975755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12521",
    "droptype": "D",
    "dropname": "DRIGGS",
    "dropdeladd": "70 S MAIN ST",
    "dropdelcty": "DRIGGS",
    "dropdelst": "ID",
    "dropdelzpp": 834229998,
    "dropphyadd": "70 S MAIN ST",
    "dropphycty": "DRIGGS",
    "dropphyst": "ID",
    "dropphyzpp": 834229998,
    "dropmaladd": "70 S MAIN ST",
    "dropmalcty": "DRIGGS",
    "dropmalst": "ID",
    "dropmalzpp": 834229998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083522337,
    "dropsitcph": 2083522337,
    "dropfax": 2083542330
  },
  {
    "dcode": "D",
    "dropkey": "PZ12523",
    "droptype": "D",
    "dropname": "DUBOIS",
    "dropdeladd": "72 W MAIN ST",
    "dropdelcty": "DUBOIS",
    "dropdelst": "ID",
    "dropdelzpp": 834239998,
    "dropphyadd": "72 W MAIN ST",
    "dropphycty": "DUBOIS",
    "dropphyst": "ID",
    "dropphyzpp": 834239998,
    "dropmaladd": "72 W MAIN ST",
    "dropmalcty": "DUBOIS",
    "dropmalst": "ID",
    "dropmalzpp": 834239998,
    "dropsitphn": 2084334080,
    "dropsitlph": 9862042026,
    "dropsitcph": 9862042026,
    "dropfax": 2083745481
  },
  {
    "dcode": "D",
    "dropkey": "PZ12524",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "141 N PALMETTO AVE",
    "dropdelcty": "EAGLE",
    "dropdelst": "ID",
    "dropdelzpp": 836169998,
    "dropphyadd": "141 N PALMETTO AVE",
    "dropphycty": "EAGLE",
    "dropphyst": "ID",
    "dropphyzpp": 836169998,
    "dropmaladd": "141 N PALMETTO AVE",
    "dropmalcty": "EAGLE",
    "dropmalst": "ID",
    "dropmalzpp": 836169998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2089397982,
    "dropsitcph": 2089397982,
    "dropfax": 2089395161
  },
  {
    "dcode": "D",
    "dropkey": "PZ12530",
    "droptype": "D",
    "dropname": "EASTPORT",
    "dropdeladd": "100 E FERRY AVE",
    "dropdelcty": "EASTPORT",
    "dropdelst": "ID",
    "dropdelzpp": 838269998,
    "dropphyadd": "100 E FERRY AVE",
    "dropphycty": "EASTPORT",
    "dropphyst": "ID",
    "dropphyzpp": 838269998,
    "dropmaladd": "100 E FERRY AVE",
    "dropmalcty": "EASTPORT",
    "dropmalst": "ID",
    "dropmalzpp": 838269998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082677390,
    "dropsitcph": 2082677390,
    "dropfax": 6505784697
  },
  {
    "dcode": "D",
    "dropkey": "PZ12532",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "220 WILSON ST E",
    "dropdelcty": "EDEN",
    "dropdelst": "ID",
    "dropdelzpp": 833259998,
    "dropphyadd": "220 WILSON ST E",
    "dropphycty": "EDEN",
    "dropphyst": "ID",
    "dropphyzpp": 833259998,
    "dropmaladd": "220 WILSON ST E",
    "dropmalcty": "EDEN",
    "dropmalst": "ID",
    "dropmalzpp": 833259998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088255089,
    "dropsitcph": 2088255089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12538",
    "droptype": "D",
    "dropname": "ELK CITY",
    "dropdeladd": "313 MAIN ST",
    "dropdelcty": "ELK CITY",
    "dropdelst": "ID",
    "dropdelzpp": 835259998,
    "dropphyadd": "313 MAIN ST",
    "dropphycty": "ELK CITY",
    "dropphyst": "ID",
    "dropphyzpp": 835259998,
    "dropmaladd": "313 MAIN ST",
    "dropmalcty": "ELK CITY",
    "dropmalst": "ID",
    "dropmalzpp": 835259998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088422278,
    "dropsitcph": 2088422278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12540",
    "droptype": "D",
    "dropname": "ELK RIVER",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "ELK RIVER",
    "dropdelst": "ID",
    "dropdelzpp": 838279998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "ELK RIVER",
    "dropphyst": "ID",
    "dropphyzpp": 838279998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "ELK RIVER",
    "dropmalst": "ID",
    "dropmalzpp": 838279998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088263495,
    "dropsitcph": 2088263495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12541",
    "droptype": "D",
    "dropname": "ELLIS",
    "dropdeladd": "26375 HIGHWAY 93",
    "dropdelcty": "ELLIS",
    "dropdelst": "ID",
    "dropdelzpp": 832358001,
    "dropphyadd": "26375 HIGHWAY 93",
    "dropphycty": "ELLIS",
    "dropphyst": "ID",
    "dropphyzpp": 832358001,
    "dropmaladd": "26375 HIGHWAY 93",
    "dropmalcty": "ELLIS",
    "dropmalst": "ID",
    "dropmalzpp": 832358001,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088764472,
    "dropsitcph": 2088764472,
    "dropfax": 2088764472
  },
  {
    "dcode": "D",
    "dropkey": "PZ12543",
    "droptype": "D",
    "dropname": "EMMETT",
    "dropdeladd": "521 E MAIN ST",
    "dropdelcty": "EMMETT",
    "dropdelst": "ID",
    "dropdelzpp": 836179998,
    "dropphyadd": "521 E MAIN ST",
    "dropphycty": "EMMETT",
    "dropphyst": "ID",
    "dropphyzpp": 836179998,
    "dropmaladd": "521 E MAIN ST",
    "dropmalcty": "EMMETT",
    "dropmalst": "ID",
    "dropmalzpp": 836179998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083652181,
    "dropsitcph": 2083652181,
    "dropfax": 2083656342
  },
  {
    "dcode": "D",
    "dropkey": "PZ12546",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "518 SOLDIER RD",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "ID",
    "dropdelzpp": 833279998,
    "dropphyadd": "518 SOLDIER RD",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "ID",
    "dropphyzpp": 833279998,
    "dropmaladd": "518 SOLDIER RD",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "ID",
    "dropmalzpp": 833279998,
    "dropsitphn": 2087641004,
    "dropsitlph": 2087641002,
    "dropsitcph": 2087641004,
    "dropfax": 2087642423
  },
  {
    "dcode": "D",
    "dropkey": "PZ12554",
    "droptype": "D",
    "dropname": "FERDINAND",
    "dropdeladd": "341 MAIN ST",
    "dropdelcty": "FERDINAND",
    "dropdelst": "ID",
    "dropdelzpp": 835269998,
    "dropphyadd": "341 MAIN ST",
    "dropphycty": "FERDINAND",
    "dropphyst": "ID",
    "dropphyzpp": 835269998,
    "dropmaladd": "341 MAIN ST",
    "dropmalcty": "FERDINAND",
    "dropmalst": "ID",
    "dropmalzpp": 835269998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089623664,
    "dropsitcph": 2089623664,
    "dropfax": 2089627378
  },
  {
    "dcode": "D",
    "dropkey": "PZ12555",
    "droptype": "D",
    "dropname": "FERNWOOD",
    "dropdeladd": "64127 HIGHWAY 3 S",
    "dropdelcty": "FERNWOOD",
    "dropdelst": "ID",
    "dropdelzpp": 838309998,
    "dropphyadd": "64127 HIGHWAY 3 S",
    "dropphycty": "FERNWOOD",
    "dropphyst": "ID",
    "dropphyzpp": 838309998,
    "dropmaladd": "64127 HIGHWAY 3 S",
    "dropmalcty": "FERNWOOD",
    "dropmalst": "ID",
    "dropmalzpp": 838309998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082453382,
    "dropsitcph": 2082453382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12556",
    "droptype": "D",
    "dropname": "FILER",
    "dropdeladd": "413 MAIN ST",
    "dropdelcty": "FILER",
    "dropdelst": "ID",
    "dropdelzpp": 833289998,
    "dropphyadd": "413 MAIN ST",
    "dropphycty": "FILER",
    "dropphyst": "ID",
    "dropphyzpp": 833289998,
    "dropmaladd": "413 MAIN ST",
    "dropmalcty": "FILER",
    "dropmalst": "ID",
    "dropmalzpp": 833289998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085955398,
    "dropsitcph": 2085955398,
    "dropfax": 2083265220
  },
  {
    "dcode": "D",
    "dropkey": "PZ12559",
    "droptype": "D",
    "dropname": "FIRTH",
    "dropdeladd": "323 N MAIN ST",
    "dropdelcty": "FIRTH",
    "dropdelst": "ID",
    "dropdelzpp": 832369998,
    "dropphyadd": "323 N MAIN ST",
    "dropphycty": "FIRTH",
    "dropphyst": "ID",
    "dropphyzpp": 832369998,
    "dropmaladd": "323 N MAIN ST",
    "dropmalcty": "FIRTH",
    "dropmalst": "ID",
    "dropmalzpp": 832369998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083466611,
    "dropsitcph": 2083466611,
    "dropfax": 2083466611
  },
  {
    "dcode": "D",
    "dropkey": "PZ12565",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "45 S 1ST E",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "ID",
    "dropdelzpp": 832379998,
    "dropphyadd": "45 S 1ST E",
    "dropphycty": "FRANKLIN",
    "dropphyst": "ID",
    "dropphyzpp": 832379998,
    "dropmaladd": "45 S 1ST E",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "ID",
    "dropmalzpp": 832379998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082546833,
    "dropsitcph": 2082546833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12566",
    "droptype": "D",
    "dropname": "FRUITLAND",
    "dropdeladd": "501 SW 3RD ST",
    "dropdelcty": "FRUITLAND",
    "dropdelst": "ID",
    "dropdelzpp": 836199998,
    "dropphyadd": "501 SW 3RD ST",
    "dropphycty": "FRUITLAND",
    "dropphyst": "ID",
    "dropphyzpp": 836199998,
    "dropmaladd": "501 SW 3RD ST",
    "dropmalcty": "FRUITLAND",
    "dropmalst": "ID",
    "dropmalzpp": 836199998,
    "dropsitphn": 2084524403,
    "dropsitlph": 2084334080,
    "dropsitcph": 2084524403,
    "dropfax": 2084526450
  },
  {
    "dcode": "D",
    "dropkey": "PZ12572",
    "droptype": "D",
    "dropname": "GARDEN VALLEY",
    "dropdeladd": "946 BANKS LOWMAN RD",
    "dropdelcty": "GARDEN VALLEY",
    "dropdelst": "ID",
    "dropdelzpp": 836229998,
    "dropphyadd": "946 BANKS LOWMAN RD",
    "dropphycty": "GARDEN VALLEY",
    "dropphyst": "ID",
    "dropphyzpp": 836229998,
    "dropmaladd": "946 BANKS LOWMAN RD",
    "dropmalcty": "GARDEN VALLEY",
    "dropmalst": "ID",
    "dropmalzpp": 836229998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085844929,
    "dropsitcph": 2085844929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12576",
    "droptype": "D",
    "dropname": "GENESEE",
    "dropdeladd": "110 W WALNUT ST",
    "dropdelcty": "GENESEE",
    "dropdelst": "ID",
    "dropdelzpp": 838329998,
    "dropphyadd": "110 W WALNUT ST",
    "dropphycty": "GENESEE",
    "dropphyst": "ID",
    "dropphyzpp": 838329998,
    "dropmaladd": "110 W WALNUT ST",
    "dropmalcty": "GENESEE",
    "dropmalst": "ID",
    "dropmalzpp": 838329998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082851315,
    "dropsitcph": 2082851315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12577",
    "droptype": "D",
    "dropname": "GENEVA",
    "dropdeladd": "40462 US HIGHWAY 89",
    "dropdelcty": "GENEVA",
    "dropdelst": "ID",
    "dropdelzpp": 832389998,
    "dropphyadd": "40462 US HIGHWAY 89",
    "dropphycty": "GENEVA",
    "dropphyst": "ID",
    "dropphyzpp": 832389998,
    "dropmaladd": "40462 US HIGHWAY 89",
    "dropmalcty": "GENEVA",
    "dropmalst": "ID",
    "dropmalzpp": 832389998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088471678,
    "dropsitcph": 2088471678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12578",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "ID",
    "dropdelzpp": 832399998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "ID",
    "dropphyzpp": 832399998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "ID",
    "dropmalzpp": 832399998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088471295,
    "dropsitcph": 2088471295,
    "dropfax": 2088471295
  },
  {
    "dcode": "D",
    "dropkey": "PZ12583",
    "droptype": "D",
    "dropname": "GLENNS FERRY",
    "dropdeladd": "22 E 2ND AVE",
    "dropdelcty": "GLENNS FERRY",
    "dropdelst": "ID",
    "dropdelzpp": 836239998,
    "dropphyadd": "22 E 2ND AVE",
    "dropphycty": "GLENNS FERRY",
    "dropphyst": "ID",
    "dropphyzpp": 836239998,
    "dropmaladd": "22 E 2ND AVE",
    "dropmalcty": "GLENNS FERRY",
    "dropmalst": "ID",
    "dropmalzpp": 836239998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083667329,
    "dropsitcph": 2083667329,
    "dropfax": 2083667329
  },
  {
    "dcode": "D",
    "dropkey": "PZ12584",
    "droptype": "D",
    "dropname": "GOODING",
    "dropdeladd": "201 3RD AVE E",
    "dropdelcty": "GOODING",
    "dropdelst": "ID",
    "dropdelzpp": 833309998,
    "dropphyadd": "201 3RD AVE E",
    "dropphycty": "GOODING",
    "dropphyst": "ID",
    "dropphyzpp": 833309998,
    "dropmaladd": "201 3RD AVE E",
    "dropmalcty": "GOODING",
    "dropmalst": "ID",
    "dropmalzpp": 833309998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085956300,
    "dropsitcph": 2085956300,
    "dropfax": 2089344822
  },
  {
    "dcode": "D",
    "dropkey": "PZ12587",
    "droptype": "D",
    "dropname": "GRACE",
    "dropdeladd": "19 N MAIN ST",
    "dropdelcty": "GRACE",
    "dropdelst": "ID",
    "dropdelzpp": 832419998,
    "dropphyadd": "19 N MAIN ST",
    "dropphycty": "GRACE",
    "dropphyst": "ID",
    "dropphyzpp": 832419998,
    "dropmaladd": "19 N MAIN ST",
    "dropmalcty": "GRACE",
    "dropmalst": "ID",
    "dropmalzpp": 832419998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084253980,
    "dropsitcph": 2084253980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12588",
    "droptype": "D",
    "dropname": "GRAND VIEW",
    "dropdeladd": "265 STATE ST",
    "dropdelcty": "GRAND VIEW",
    "dropdelst": "ID",
    "dropdelzpp": 836249998,
    "dropphyadd": "265 STATE ST",
    "dropphycty": "GRAND VIEW",
    "dropphyst": "ID",
    "dropphyzpp": 836249998,
    "dropmaladd": "265 STATE ST",
    "dropmalcty": "GRAND VIEW",
    "dropmalst": "ID",
    "dropmalzpp": 836249998,
    "dropsitphn": 2088342662,
    "dropsitlph": 2088342662,
    "dropsitcph": 2088342662,
    "dropfax": 2088342460
  },
  {
    "dcode": "D",
    "dropkey": "PZ12589",
    "droptype": "D",
    "dropname": "GRANGEVILLE",
    "dropdeladd": "300 W MAIN ST STE 100",
    "dropdelcty": "GRANGEVILLE",
    "dropdelst": "ID",
    "dropdelzpp": 835309998,
    "dropphyadd": "300 W MAIN ST STE 100",
    "dropphycty": "GRANGEVILLE",
    "dropphyst": "ID",
    "dropphyzpp": 835309998,
    "dropmaladd": "300 W MAIN ST STE 100",
    "dropmalcty": "GRANGEVILLE",
    "dropmalst": "ID",
    "dropmalzpp": 835309998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089831270,
    "dropsitcph": 2089831270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12595",
    "droptype": "D",
    "dropname": "GREENLEAF",
    "dropdeladd": "21344 MAIN ST",
    "dropdelcty": "GREENLEAF",
    "dropdelst": "ID",
    "dropdelzpp": 836269998,
    "dropphyadd": "21344 MAIN ST",
    "dropphycty": "GREENLEAF",
    "dropphyst": "ID",
    "dropphyzpp": 836269998,
    "dropmaladd": "21344 MAIN ST",
    "dropmalcty": "GREENLEAF",
    "dropmalst": "ID",
    "dropmalzpp": 836269998,
    "dropsitphn": 2084598691,
    "dropsitlph": 2083834239,
    "dropsitcph": 2084598691,
    "dropfax": 2084598691
  },
  {
    "dcode": "D",
    "dropkey": "PZ12602",
    "droptype": "D",
    "dropname": "HAGERMAN",
    "dropdeladd": "444 N STATE ST",
    "dropdelcty": "HAGERMAN",
    "dropdelst": "ID",
    "dropdelzpp": 833329998,
    "dropphyadd": "444 N STATE ST",
    "dropphycty": "HAGERMAN",
    "dropphyst": "ID",
    "dropphyzpp": 833329998,
    "dropmaladd": "444 N STATE ST",
    "dropmalcty": "HAGERMAN",
    "dropmalst": "ID",
    "dropmalzpp": 833329998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085955383,
    "dropsitcph": 2085955683,
    "dropfax": 2088374658
  },
  {
    "dcode": "D",
    "dropkey": "PZ12603",
    "droptype": "D",
    "dropname": "HAILEY",
    "dropdeladd": "820 S MAIN ST",
    "dropdelcty": "HAILEY",
    "dropdelst": "ID",
    "dropdelzpp": 833339998,
    "dropphyadd": "820 S MAIN ST",
    "dropphycty": "HAILEY",
    "dropphyst": "ID",
    "dropphyzpp": 833339998,
    "dropmaladd": "820 S MAIN ST",
    "dropmalcty": "HAILEY",
    "dropmalst": "ID",
    "dropmalzpp": 833339998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087882276,
    "dropsitcph": 2087882276,
    "dropfax": 2087882776
  },
  {
    "dcode": "D",
    "dropkey": "PZ12604",
    "droptype": "D",
    "dropname": "HAMER",
    "dropdeladd": "2449 E 2100 N",
    "dropdelcty": "HAMER",
    "dropdelst": "ID",
    "dropdelzpp": 834259998,
    "dropphyadd": "2449 E 2100 N",
    "dropphycty": "HAMER",
    "dropphyst": "ID",
    "dropphyzpp": 834259998,
    "dropmaladd": "2449 E 2100 N",
    "dropmalcty": "HAMER",
    "dropmalst": "ID",
    "dropmalzpp": 834259998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086625411,
    "dropsitcph": 2086625411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12606",
    "droptype": "D",
    "dropname": "HAMMETT",
    "dropdeladd": "9344 W KOCH CIR",
    "dropdelcty": "HAMMETT",
    "dropdelst": "ID",
    "dropdelzpp": 836279998,
    "dropphyadd": "9344 W KOCH CIR",
    "dropphycty": "HAMMETT",
    "dropphyst": "ID",
    "dropphyzpp": 836279998,
    "dropmaladd": "9344 W KOCH CIR",
    "dropmalcty": "HAMMETT",
    "dropmalst": "ID",
    "dropmalzpp": 836279998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083662919,
    "dropsitcph": 2083662919,
    "dropfax": 2083662919
  },
  {
    "dcode": "D",
    "dropkey": "PZ12607",
    "droptype": "D",
    "dropname": "HANSEN",
    "dropdeladd": "217 HIGHWAY 30",
    "dropdelcty": "HANSEN",
    "dropdelst": "ID",
    "dropdelzpp": 833349998,
    "dropphyadd": "217 HIGHWAY 30",
    "dropphycty": "HANSEN",
    "dropphyst": "ID",
    "dropphyzpp": 833349998,
    "dropmaladd": "217 HIGHWAY 30",
    "dropmalcty": "HANSEN",
    "dropmalst": "ID",
    "dropmalzpp": 833349998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084234280,
    "dropsitcph": 2084234280,
    "dropfax": 2084234280
  },
  {
    "dcode": "D",
    "dropkey": "PZ12610",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "103 S COEUR DALENE AVE",
    "dropdelcty": "HARRISON",
    "dropdelst": "ID",
    "dropdelzpp": 838339998,
    "dropphyadd": "103 S COEUR DALENE AVE",
    "dropphycty": "HARRISON",
    "dropphyst": "ID",
    "dropphyzpp": 838339998,
    "dropmaladd": "103 S COEUR DALENE AVE",
    "dropmalcty": "HARRISON",
    "dropmalst": "ID",
    "dropmalzpp": 838339998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086893413,
    "dropsitcph": 2086893413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12611",
    "droptype": "D",
    "dropname": "HARVARD",
    "dropdeladd": "4011 HIGHWAY 6",
    "dropdelcty": "HARVARD",
    "dropdelst": "ID",
    "dropdelzpp": 838349998,
    "dropphyadd": "4011 HIGHWAY 6",
    "dropphycty": "HARVARD",
    "dropphyst": "ID",
    "dropphyzpp": 838349998,
    "dropmaladd": "4011 HIGHWAY 6",
    "dropmalcty": "HARVARD",
    "dropmalst": "ID",
    "dropmalzpp": 838349998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088750265,
    "dropsitcph": 2088750265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12614",
    "droptype": "D",
    "dropname": "HAYDEN",
    "dropdeladd": "109 W HONEYSUCKLE AVE",
    "dropdelcty": "HAYDEN",
    "dropdelst": "ID",
    "dropdelzpp": 838359998,
    "dropphyadd": "109 W HONEYSUCKLE AVE",
    "dropphycty": "HAYDEN",
    "dropphyst": "ID",
    "dropphyzpp": 838359998,
    "dropmaladd": "109 W HONEYSUCKLE AVE",
    "dropmalcty": "HAYDEN",
    "dropmalst": "ID",
    "dropmalzpp": 838359998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087621038,
    "dropsitcph": 2087621038,
    "dropfax": 6514566185
  },
  {
    "dcode": "D",
    "dropkey": "PZ12616",
    "droptype": "D",
    "dropname": "HAZELTON",
    "dropdeladd": "360 MAIN ST",
    "dropdelcty": "HAZELTON",
    "dropdelst": "ID",
    "dropdelzpp": 833359998,
    "dropphyadd": "360 MAIN ST",
    "dropphycty": "HAZELTON",
    "dropphyst": "ID",
    "dropphyzpp": 833359998,
    "dropmaladd": "360 MAIN ST",
    "dropmalcty": "HAZELTON",
    "dropmalst": "ID",
    "dropmalzpp": 833359998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088295451,
    "dropsitcph": 2088295451,
    "dropfax": 2088295451
  },
  {
    "dcode": "D",
    "dropkey": "PZ12623",
    "droptype": "D",
    "dropname": "HEYBURN",
    "dropdeladd": "1030 17TH ST",
    "dropdelcty": "HEYBURN",
    "dropdelst": "ID",
    "dropdelzpp": 833369998,
    "dropphyadd": "1030 17TH ST",
    "dropphycty": "HEYBURN",
    "dropphyst": "ID",
    "dropphyzpp": 833369998,
    "dropmaladd": "1030 17TH ST",
    "dropmalcty": "HEYBURN",
    "dropmalst": "ID",
    "dropmalzpp": 833369998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086793424,
    "dropsitcph": 2086793424,
    "dropfax": 2086792915
  },
  {
    "dcode": "D",
    "dropkey": "PZ12628",
    "droptype": "D",
    "dropname": "HOMEDALE",
    "dropdeladd": "7 N MAIN ST",
    "dropdelcty": "HOMEDALE",
    "dropdelst": "ID",
    "dropdelzpp": 836289998,
    "dropphyadd": "7 N MAIN ST",
    "dropphycty": "HOMEDALE",
    "dropphyst": "ID",
    "dropphyzpp": 836289998,
    "dropmaladd": "7 N MAIN ST",
    "dropmalcty": "HOMEDALE",
    "dropmalst": "ID",
    "dropmalzpp": 836289998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083373105,
    "dropsitcph": 2083373105,
    "dropfax": 2083373105
  },
  {
    "dcode": "D",
    "dropkey": "PZ12629",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "626 WELLINGTON PL",
    "dropdelcty": "HOPE",
    "dropdelst": "ID",
    "dropdelzpp": 838369998,
    "dropphyadd": "626 WELLINGTON PL",
    "dropphycty": "HOPE",
    "dropphyst": "ID",
    "dropphyzpp": 838369998,
    "dropmaladd": "626 WELLINGTON PL",
    "dropmalcty": "HOPE",
    "dropmalst": "ID",
    "dropmalzpp": 838369998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082645223,
    "dropsitcph": 2082645223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12631",
    "droptype": "D",
    "dropname": "HORSESHOE BEND",
    "dropdeladd": "449 HIGHWAY 55",
    "dropdelcty": "HORSESHOE BEND",
    "dropdelst": "ID",
    "dropdelzpp": 836299998,
    "dropphyadd": "449 HIGHWAY 55",
    "dropphycty": "HORSESHOE BEND",
    "dropphyst": "ID",
    "dropphyzpp": 836299998,
    "dropmaladd": "449 HIGHWAY 55",
    "dropmalcty": "HORSESHOE BEND",
    "dropmalst": "ID",
    "dropmalzpp": 836299998,
    "dropsitphn": 2087932714,
    "dropsitlph": 2084334080,
    "dropsitcph": 2087932714,
    "dropfax": 2087932714
  },
  {
    "dcode": "D",
    "dropkey": "PZ12633",
    "droptype": "D",
    "dropname": "HOWE",
    "dropdeladd": "1531 HIGHWAY 33",
    "dropdelcty": "HOWE",
    "dropdelst": "ID",
    "dropdelzpp": 832449998,
    "dropphyadd": "1531 HIGHWAY 33",
    "dropphycty": "HOWE",
    "dropphyst": "ID",
    "dropphyzpp": 832449998,
    "dropmaladd": "1531 HIGHWAY 33",
    "dropmalcty": "HOWE",
    "dropmalst": "ID",
    "dropmalzpp": 832449998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087673466,
    "dropsitcph": 2087673466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12636",
    "droptype": "D",
    "dropname": "HUSTON",
    "dropdeladd": "16021 PRIDE LN",
    "dropdelcty": "HUSTON",
    "dropdelst": "ID",
    "dropdelzpp": 836309998,
    "dropphyadd": "16021 PRIDE LN",
    "dropphycty": "HUSTON",
    "dropphyst": "ID",
    "dropphyzpp": 836309998,
    "dropmaladd": "16021 PRIDE LN",
    "dropmalcty": "HUSTON",
    "dropmalst": "ID",
    "dropmalzpp": 836309998,
    "dropsitphn": 2084540982,
    "dropsitlph": 2085866200,
    "dropsitcph": 2085866300,
    "dropfax": 2084540982
  },
  {
    "dcode": "D",
    "dropkey": "PZ12639",
    "droptype": "D",
    "dropname": "IDAHO CITY",
    "dropdeladd": "3860 HIGHWAY 21",
    "dropdelcty": "IDAHO CITY",
    "dropdelst": "ID",
    "dropdelzpp": 836319998,
    "dropphyadd": "3860 HIGHWAY 21",
    "dropphycty": "IDAHO CITY",
    "dropphyst": "ID",
    "dropphyzpp": 836319998,
    "dropmaladd": "3860 HIGHWAY 21",
    "dropmalcty": "IDAHO CITY",
    "dropmalst": "ID",
    "dropmalzpp": 836319998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087814321,
    "dropsitcph": 2087814321,
    "dropfax": 2083924757
  },
  {
    "dcode": "D",
    "dropkey": "PZ12640",
    "droptype": "D",
    "dropname": "IDAHO FALLS",
    "dropdeladd": "605 4TH ST",
    "dropdelcty": "IDAHO FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 834019998,
    "dropphyadd": "605 4TH ST",
    "dropphycty": "IDAHO FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 834019998,
    "dropmaladd": "605 4TH ST",
    "dropmalcty": "IDAHO FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 834019998,
    "dropsitphn": 2084976367,
    "dropsitlph": 2084976347,
    "dropsitcph": 2085252511,
    "dropfax": 2085295853
  },
  {
    "dcode": "D",
    "dropkey": "PZ12649",
    "droptype": "D",
    "dropname": "INDIAN VALLEY",
    "dropdeladd": "2293 MUNDY GULCH RD",
    "dropdelcty": "INDIAN VALLEY",
    "dropdelst": "ID",
    "dropdelzpp": 836329998,
    "dropphyadd": "2293 MUNDY GULCH RD",
    "dropphycty": "INDIAN VALLEY",
    "dropphyst": "ID",
    "dropphyzpp": 836329998,
    "dropmaladd": "2293 MUNDY GULCH RD",
    "dropmalcty": "INDIAN VALLEY",
    "dropmalst": "ID",
    "dropmalzpp": 836329998,
    "dropsitphn": 2084334080,
    "dropsitlph": 9862140534,
    "dropsitcph": 9862140534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12650",
    "droptype": "D",
    "dropname": "INKOM",
    "dropdeladd": "210 HIGHWAY 30 E",
    "dropdelcty": "INKOM",
    "dropdelst": "ID",
    "dropdelzpp": 832459998,
    "dropphyadd": "210 HIGHWAY 30 E",
    "dropphycty": "INKOM",
    "dropphyst": "ID",
    "dropphyzpp": 832459998,
    "dropmaladd": "210 HIGHWAY 30 E",
    "dropmalcty": "INKOM",
    "dropmalst": "ID",
    "dropmalzpp": 832459998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087753587,
    "dropsitcph": 2087753587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12652",
    "droptype": "D",
    "dropname": "IONA",
    "dropdeladd": "3614 N MAIN ST",
    "dropdelcty": "IONA",
    "dropdelst": "ID",
    "dropdelzpp": 834279998,
    "dropphyadd": "3614 N MAIN ST",
    "dropphycty": "IONA",
    "dropphyst": "ID",
    "dropphyzpp": 834279998,
    "dropmaladd": "3614 N MAIN ST",
    "dropmalcty": "IONA",
    "dropmalst": "ID",
    "dropmalzpp": 834279998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085237522,
    "dropsitcph": 2085237522,
    "dropfax": 2085259313
  },
  {
    "dcode": "D",
    "dropkey": "PZ12653",
    "droptype": "D",
    "dropname": "IRWIN",
    "dropdeladd": "3373 SWAN VALLEY HWY",
    "dropdelcty": "IRWIN",
    "dropdelst": "ID",
    "dropdelzpp": 834289998,
    "dropphyadd": "3373 SWAN VALLEY HWY",
    "dropphycty": "IRWIN",
    "dropphyst": "ID",
    "dropphyzpp": 834289998,
    "dropmaladd": "3373 SWAN VALLEY HWY",
    "dropmalcty": "IRWIN",
    "dropmalst": "ID",
    "dropmalzpp": 834289998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086437420,
    "dropsitcph": 2086437420,
    "dropfax": 2084832204
  },
  {
    "dcode": "D",
    "dropkey": "PZ12654",
    "droptype": "D",
    "dropname": "ISLAND PARK",
    "dropdeladd": "3978 US HIGHWAY 20",
    "dropdelcty": "ISLAND PARK",
    "dropdelst": "ID",
    "dropdelzpp": 834299998,
    "dropphyadd": "3978 US HIGHWAY 20",
    "dropphycty": "ISLAND PARK",
    "dropphyst": "ID",
    "dropphyzpp": 834299998,
    "dropmaladd": "3978 US HIGHWAY 20",
    "dropmalcty": "ISLAND PARK",
    "dropmalst": "ID",
    "dropmalzpp": 834299998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085587476,
    "dropsitcph": 2085587476,
    "dropfax": 2085587476
  },
  {
    "dcode": "D",
    "dropkey": "PZ12657",
    "droptype": "D",
    "dropname": "JEROME",
    "dropdeladd": "154 1ST AVE E",
    "dropdelcty": "JEROME",
    "dropdelst": "ID",
    "dropdelzpp": 833389998,
    "dropphyadd": "154 1ST AVE E",
    "dropphycty": "JEROME",
    "dropphyst": "ID",
    "dropphyzpp": 833389998,
    "dropmaladd": "154 1ST AVE E",
    "dropmalcty": "JEROME",
    "dropmalst": "ID",
    "dropmalzpp": 833389998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083245381,
    "dropsitcph": 2083245381,
    "dropfax": 2083243003
  },
  {
    "dcode": "D",
    "dropkey": "PZ12659",
    "droptype": "D",
    "dropname": "JULIAETTA",
    "dropdeladd": "195 MAIN ST",
    "dropdelcty": "JULIAETTA",
    "dropdelst": "ID",
    "dropdelzpp": 835359998,
    "dropphyadd": "195 MAIN ST",
    "dropphycty": "JULIAETTA",
    "dropphyst": "ID",
    "dropphyzpp": 835359741,
    "dropmaladd": "195 MAIN ST",
    "dropmalcty": "JULIAETTA",
    "dropmalst": "ID",
    "dropmalzpp": 835359741,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082767951,
    "dropsitcph": 2082767951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12660",
    "droptype": "D",
    "dropname": "KAMIAH",
    "dropdeladd": "412 MAIN ST",
    "dropdelcty": "KAMIAH",
    "dropdelst": "ID",
    "dropdelzpp": 835369998,
    "dropphyadd": "412 MAIN ST",
    "dropphycty": "KAMIAH",
    "dropphyst": "ID",
    "dropphyzpp": 835369998,
    "dropmaladd": "412 MAIN ST",
    "dropmalcty": "KAMIAH",
    "dropmalst": "ID",
    "dropmalzpp": 835369998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089352316,
    "dropsitcph": 2089352316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12661",
    "droptype": "D",
    "dropname": "KELLOGG",
    "dropdeladd": "302 S DIVISION ST",
    "dropdelcty": "KELLOGG",
    "dropdelst": "ID",
    "dropdelzpp": 838379998,
    "dropphyadd": "302 S DIVISION ST",
    "dropphycty": "KELLOGG",
    "dropphyst": "ID",
    "dropphyzpp": 838379998,
    "dropmaladd": "302 S DIVISION ST",
    "dropmalcty": "KELLOGG",
    "dropmalst": "ID",
    "dropmalzpp": 838379998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087869161,
    "dropsitcph": 2087869161,
    "dropfax": 2087836171
  },
  {
    "dcode": "D",
    "dropkey": "PZ12662",
    "droptype": "D",
    "dropname": "KENDRICK",
    "dropdeladd": "703 E MAIN ST",
    "dropdelcty": "KENDRICK",
    "dropdelst": "ID",
    "dropdelzpp": 835379998,
    "dropphyadd": "703 E MAIN ST",
    "dropphycty": "KENDRICK",
    "dropphyst": "ID",
    "dropphyzpp": 835379998,
    "dropmaladd": "703 E MAIN ST",
    "dropmalcty": "KENDRICK",
    "dropmalst": "ID",
    "dropmalzpp": 835379998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082894071,
    "dropsitcph": 2082894071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12663",
    "droptype": "D",
    "dropname": "KETCHUM",
    "dropdeladd": "151 4TH ST W",
    "dropdelcty": "KETCHUM",
    "dropdelst": "ID",
    "dropdelzpp": 833409400,
    "dropphyadd": "151 4TH ST W",
    "dropphycty": "KETCHUM",
    "dropphyst": "ID",
    "dropphyzpp": 833409400,
    "dropmaladd": "151 4TH ST W",
    "dropmalcty": "KETCHUM",
    "dropmalst": "ID",
    "dropmalzpp": 833409400,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087265161,
    "dropsitcph": 2087265161,
    "dropfax": 2087262317
  },
  {
    "dcode": "D",
    "dropkey": "PZ12667",
    "droptype": "D",
    "dropname": "KIMBERLY",
    "dropdeladd": "225 MAIN ST N",
    "dropdelcty": "KIMBERLY",
    "dropdelst": "ID",
    "dropdelzpp": 833419998,
    "dropphyadd": "225 MAIN ST N",
    "dropphycty": "KIMBERLY",
    "dropphyst": "ID",
    "dropphyzpp": 833419998,
    "dropmaladd": "225 MAIN ST N",
    "dropmalcty": "KIMBERLY",
    "dropmalst": "ID",
    "dropmalzpp": 833419998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084234050,
    "dropsitcph": 2084234050,
    "dropfax": 2084234158
  },
  {
    "dcode": "D",
    "dropkey": "PZ12669",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "43051 SILVER VALLEY RD",
    "dropdelcty": "KINGSTON",
    "dropdelst": "ID",
    "dropdelzpp": 838399998,
    "dropphyadd": "43051 SILVER VALLEY RD",
    "dropphycty": "KINGSTON",
    "dropphyst": "ID",
    "dropphyzpp": 838399998,
    "dropmaladd": "43051 SILVER VALLEY RD",
    "dropmalcty": "KINGSTON",
    "dropmalst": "ID",
    "dropmalzpp": 838399998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086823580,
    "dropsitcph": 2086823580,
    "dropfax": 2086823580
  },
  {
    "dcode": "D",
    "dropkey": "PZ12671",
    "droptype": "D",
    "dropname": "KOOSKIA",
    "dropdeladd": "104 S MAIN ST",
    "dropdelcty": "KOOSKIA",
    "dropdelst": "ID",
    "dropdelzpp": 835399998,
    "dropphyadd": "104 S MAIN ST",
    "dropphycty": "KOOSKIA",
    "dropphyst": "ID",
    "dropphyzpp": 835399998,
    "dropmaladd": "104 S MAIN ST",
    "dropmalcty": "KOOSKIA",
    "dropmalst": "ID",
    "dropmalzpp": 835399998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082138608,
    "dropsitcph": 2082138608,
    "dropfax": 2082138606
  },
  {
    "dcode": "D",
    "dropkey": "PZ12673",
    "droptype": "D",
    "dropname": "KUNA",
    "dropdeladd": "693 E WYTHE CREEK CT",
    "dropdelcty": "KUNA",
    "dropdelst": "ID",
    "dropdelzpp": 836349998,
    "dropphyadd": "693 E WYTHE CREEK CT",
    "dropphycty": "KUNA",
    "dropphyst": "ID",
    "dropphyzpp": 836349998,
    "dropmaladd": "693 E WYTHE CREEK CT",
    "dropmalcty": "KUNA",
    "dropmalst": "ID",
    "dropmalzpp": 836349998,
    "dropsitphn": 2089229888,
    "dropsitlph": 2089229888,
    "dropsitcph": 2089229888,
    "dropfax": 2089224530
  },
  {
    "dcode": "D",
    "dropkey": "PZ12675",
    "droptype": "D",
    "dropname": "LACLEDE",
    "dropdeladd": "163 RILEY CREEK PARK RD",
    "dropdelcty": "LACLEDE",
    "dropdelst": "ID",
    "dropdelzpp": 838419998,
    "dropphyadd": "163 RILEY CREEK PARK RD",
    "dropphycty": "LACLEDE",
    "dropphyst": "ID",
    "dropphyzpp": 838419998,
    "dropmaladd": "163 RILEY CREEK PARK RD",
    "dropmalcty": "LACLEDE",
    "dropmalst": "ID",
    "dropmalzpp": 838419998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082637138,
    "dropsitcph": 2082637138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12680",
    "droptype": "D",
    "dropname": "LAPWAI",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "LAPWAI",
    "dropdelst": "ID",
    "dropdelzpp": 835409998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "LAPWAI",
    "dropphyst": "ID",
    "dropphyzpp": 835409998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "LAPWAI",
    "dropmalst": "ID",
    "dropmalzpp": 835409998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088432522,
    "dropsitcph": 2088432522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12683",
    "droptype": "D",
    "dropname": "LAVA HOT SPRINGS",
    "dropdeladd": "15 S CENTER ST",
    "dropdelcty": "LAVA HOT SPRINGS",
    "dropdelst": "ID",
    "dropdelzpp": 832469998,
    "dropphyadd": "15 S CENTER ST",
    "dropphycty": "LAVA HOT SPRINGS",
    "dropphyst": "ID",
    "dropphyzpp": 832469998,
    "dropmaladd": "15 S CENTER ST",
    "dropmalcty": "LAVA HOT SPRINGS",
    "dropmalst": "ID",
    "dropmalzpp": 832469998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087761422,
    "dropsitcph": 2087761422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12684",
    "droptype": "D",
    "dropname": "LEADORE",
    "dropdeladd": "115 S RAILROAD ST",
    "dropdelcty": "LEADORE",
    "dropdelst": "ID",
    "dropdelzpp": 834649998,
    "dropphyadd": "115 S RAILROAD ST",
    "dropphycty": "LEADORE",
    "dropphyst": "ID",
    "dropphyzpp": 834649998,
    "dropmaladd": "115 S RAILROAD ST",
    "dropmalcty": "LEADORE",
    "dropmalst": "ID",
    "dropmalzpp": 834649998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087682202,
    "dropsitcph": 2087682202,
    "dropfax": 2087689039
  },
  {
    "dcode": "D",
    "dropkey": "PZ12685",
    "droptype": "D",
    "dropname": "LEMHI",
    "dropdeladd": "3000 LEMHI RD",
    "dropdelcty": "LEMHI",
    "dropdelst": "ID",
    "dropdelzpp": 834659998,
    "dropphyadd": "3000 LEMHI RD",
    "dropphycty": "LEMHI",
    "dropphyst": "ID",
    "dropphyzpp": 834659998,
    "dropmaladd": "3000 LEMHI RD",
    "dropmalcty": "LEMHI",
    "dropmalst": "ID",
    "dropmalzpp": 834659998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087682680,
    "dropsitcph": 2087682680,
    "dropfax": 2087682680
  },
  {
    "dcode": "D",
    "dropkey": "PZ12686",
    "droptype": "D",
    "dropname": "LENORE",
    "dropdeladd": "19770 LENORE GRADE",
    "dropdelcty": "LENORE",
    "dropdelst": "ID",
    "dropdelzpp": 835419998,
    "dropphyadd": "19770 LENORE GRADE",
    "dropphycty": "LENORE",
    "dropphyst": "ID",
    "dropphyzpp": 835419998,
    "dropmaladd": "19770 LENORE GRADE",
    "dropmalcty": "LENORE",
    "dropmalst": "ID",
    "dropmalzpp": 835419998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088365720,
    "dropsitcph": 2088365720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12690",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "1613 IDAHO ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "ID",
    "dropdelzpp": 835019998,
    "dropphyadd": "1613 IDAHO ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "ID",
    "dropphyzpp": 835019998,
    "dropmaladd": "1613 IDAHO ST",
    "dropmalcty": "LEWISTON",
    "dropmalst": "ID",
    "dropmalzpp": 835019998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087433476,
    "dropsitcph": 2087984929,
    "dropfax": 6514566199
  },
  {
    "dcode": "D",
    "dropkey": "PZ12691",
    "droptype": "D",
    "dropname": "LEWISVILLE",
    "dropdeladd": "3444 E 480 N",
    "dropdelcty": "LEWISVILLE",
    "dropdelst": "ID",
    "dropdelzpp": 834319998,
    "dropphyadd": "3444 E 480 N",
    "dropphycty": "LEWISVILLE",
    "dropphyst": "ID",
    "dropphyzpp": 834319998,
    "dropmaladd": "3444 E 480 N",
    "dropmalcty": "LEWISVILLE",
    "dropmalst": "ID",
    "dropmalzpp": 834319998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087544571,
    "dropsitcph": 2087544571,
    "dropfax": 2087544571
  },
  {
    "dcode": "D",
    "dropkey": "PZ12703",
    "droptype": "D",
    "dropname": "LUCILE",
    "dropdeladd": "106 COW CREEK RD",
    "dropdelcty": "LUCILE",
    "dropdelst": "ID",
    "dropdelzpp": 835429998,
    "dropphyadd": "106 COW CREEK RD",
    "dropphycty": "LUCILE",
    "dropphyst": "ID",
    "dropphyzpp": 835429998,
    "dropmaladd": "106 COW CREEK RD",
    "dropmalcty": "LUCILE",
    "dropmalst": "ID",
    "dropmalzpp": 835429998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086281022,
    "dropsitcph": 2086281022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12707",
    "droptype": "D",
    "dropname": "MACKAY",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "MACKAY",
    "dropdelst": "ID",
    "dropdelzpp": 832519998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "MACKAY",
    "dropphyst": "ID",
    "dropphyzpp": 832519998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "MACKAY",
    "dropmalst": "ID",
    "dropmalzpp": 832519998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085882679,
    "dropsitcph": 2085882679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12713",
    "droptype": "D",
    "dropname": "MALAD CITY",
    "dropdeladd": "68 W 100 N",
    "dropdelcty": "MALAD CITY",
    "dropdelst": "ID",
    "dropdelzpp": 832529998,
    "dropphyadd": "68 W 100 N",
    "dropphycty": "MALAD CITY",
    "dropphyst": "ID",
    "dropphyzpp": 832529998,
    "dropmaladd": "68 W 100 N",
    "dropmalcty": "MALAD CITY",
    "dropmalst": "ID",
    "dropmalzpp": 832529998,
    "dropsitphn": 2087153967,
    "dropsitlph": 2087153967,
    "dropsitcph": 2087153967,
    "dropfax": 2087153967
  },
  {
    "dcode": "D",
    "dropkey": "PZ12715",
    "droptype": "D",
    "dropname": "MALTA",
    "dropdeladd": "15 S MAIN ST",
    "dropdelcty": "MALTA",
    "dropdelst": "ID",
    "dropdelzpp": 833429998,
    "dropphyadd": "15 S MAIN ST",
    "dropphycty": "MALTA",
    "dropphyst": "ID",
    "dropphyzpp": 833429998,
    "dropmaladd": "15 S MAIN ST",
    "dropmalcty": "MALTA",
    "dropmalst": "ID",
    "dropmalzpp": 833429998,
    "dropsitphn": 2084334080,
    "dropsitlph": 9866420414,
    "dropsitcph": 9866420414,
    "dropfax": 2086452522
  },
  {
    "dcode": "D",
    "dropkey": "PZ12718",
    "droptype": "D",
    "dropname": "MARSING",
    "dropdeladd": "210 W MAIN ST",
    "dropdelcty": "MARSING",
    "dropdelst": "ID",
    "dropdelzpp": 836399998,
    "dropphyadd": "210 W MAIN ST",
    "dropphycty": "MARSING",
    "dropphyst": "ID",
    "dropphyzpp": 836399998,
    "dropmaladd": "210 W MAIN ST",
    "dropmalcty": "MARSING",
    "dropmalst": "ID",
    "dropmalzpp": 836399998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088965054,
    "dropsitcph": 2088965054,
    "dropfax": 2088965054
  },
  {
    "dcode": "D",
    "dropkey": "PZ12722",
    "droptype": "D",
    "dropname": "MCCALL",
    "dropdeladd": "495 DEINHARD LN",
    "dropdelcty": "MCCALL",
    "dropdelst": "ID",
    "dropdelzpp": 836389998,
    "dropphyadd": "495 DEINHARD LN",
    "dropphycty": "MCCALL",
    "dropphyst": "ID",
    "dropphyzpp": 836389998,
    "dropmaladd": "495 DEINHARD LN",
    "dropmalcty": "MCCALL",
    "dropmalst": "ID",
    "dropmalzpp": 836389998,
    "dropsitphn": 2086343164,
    "dropsitlph": 2084334080,
    "dropsitcph": 2086343164,
    "dropfax": 2086343276
  },
  {
    "dcode": "D",
    "dropkey": "PZ12723",
    "droptype": "D",
    "dropname": "MCCAMMON",
    "dropdeladd": "809 CENTER ST",
    "dropdelcty": "MCCAMMON",
    "dropdelst": "ID",
    "dropdelzpp": 832509998,
    "dropphyadd": "809 CENTER ST",
    "dropphycty": "MCCAMMON",
    "dropphyst": "ID",
    "dropphyzpp": 832509998,
    "dropmaladd": "809 CENTER ST",
    "dropmalcty": "MCCAMMON",
    "dropmalst": "ID",
    "dropmalzpp": 832509998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082543944,
    "dropsitcph": 2082543944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12728",
    "droptype": "D",
    "dropname": "MELBA",
    "dropdeladd": "314 CARRIE REX AVE",
    "dropdelcty": "MELBA",
    "dropdelst": "ID",
    "dropdelzpp": 836419998,
    "dropphyadd": "314 CARRIE REX AVE",
    "dropphycty": "MELBA",
    "dropphyst": "ID",
    "dropphyzpp": 836419998,
    "dropmaladd": "314 CARRIE REX AVE",
    "dropmalcty": "MELBA",
    "dropmalst": "ID",
    "dropmalzpp": 836419998,
    "dropsitphn": 2084952847,
    "dropsitlph": 2084954766,
    "dropsitcph": 2084955678,
    "dropfax": 2084952853
  },
  {
    "dcode": "D",
    "dropkey": "PZ12730",
    "droptype": "D",
    "dropname": "MENAN",
    "dropdeladd": "3509 E MENAN LORENZO HWY",
    "dropdelcty": "MENAN",
    "dropdelst": "ID",
    "dropdelzpp": 834349998,
    "dropphyadd": "3509 E MENAN LORENZO HWY",
    "dropphycty": "MENAN",
    "dropphyst": "ID",
    "dropphyzpp": 834349998,
    "dropmaladd": "3509 E MENAN LORENZO HWY",
    "dropmalcty": "MENAN",
    "dropmalst": "ID",
    "dropmalzpp": 834349998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087540422,
    "dropsitcph": 2087540422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12731",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "1200 N MAIN ST",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "ID",
    "dropdelzpp": 836429998,
    "dropphyadd": "1200 N MAIN ST",
    "dropphycty": "MERIDIAN",
    "dropphyst": "ID",
    "dropphyzpp": 836429998,
    "dropmaladd": "1200 N MAIN ST",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "ID",
    "dropmalzpp": 836429998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2088871620,
    "dropsitcph": 2088871620,
    "dropfax": 2088879592
  },
  {
    "dcode": "D",
    "dropkey": "PZ12733",
    "droptype": "D",
    "dropname": "MIDDLETON",
    "dropdeladd": "10 S HAWTHORNE AVE",
    "dropdelcty": "MIDDLETON",
    "dropdelst": "ID",
    "dropdelzpp": 836449998,
    "dropphyadd": "10 S HAWTHORNE AVE",
    "dropphycty": "MIDDLETON",
    "dropphyst": "ID",
    "dropphyzpp": 836449998,
    "dropmaladd": "10 S HAWTHORNE AVE",
    "dropmalcty": "MIDDLETON",
    "dropmalst": "ID",
    "dropmalzpp": 836449998,
    "dropsitphn": 2085852219,
    "dropsitlph": 2084334080,
    "dropsitcph": 2085852219,
    "dropfax": 2085852219
  },
  {
    "dcode": "D",
    "dropkey": "PZ12734",
    "droptype": "D",
    "dropname": "MIDVALE",
    "dropdeladd": "85 E BRIDGE ST",
    "dropdelcty": "MIDVALE",
    "dropdelst": "ID",
    "dropdelzpp": 836452067,
    "dropphyadd": "85 E BRIDGE ST",
    "dropphycty": "MIDVALE",
    "dropphyst": "ID",
    "dropphyzpp": 836452067,
    "dropmaladd": "85 E BRIDGE ST",
    "dropmalcty": "MIDVALE",
    "dropmalst": "ID",
    "dropmalzpp": 836452067,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083552240,
    "dropsitcph": 2083552240,
    "dropfax": 2083552240
  },
  {
    "dcode": "D",
    "dropkey": "PZ12737",
    "droptype": "D",
    "dropname": "MONTEVIEW",
    "dropdeladd": "2381 N 800 E",
    "dropdelcty": "MONTEVIEW",
    "dropdelst": "ID",
    "dropdelzpp": 834359998,
    "dropphyadd": "2381 N 800 E",
    "dropphycty": "MONTEVIEW",
    "dropphyst": "ID",
    "dropphyzpp": 834359998,
    "dropmaladd": "2381 N 800 E",
    "dropmalcty": "MONTEVIEW",
    "dropmalst": "ID",
    "dropmalzpp": 834359998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2086572286,
    "dropsitcph": 2086572286,
    "dropfax": 2086572286
  },
  {
    "dcode": "D",
    "dropkey": "PZ12739",
    "droptype": "D",
    "dropname": "MONTPELIER",
    "dropdeladd": "804 GRANT ST",
    "dropdelcty": "MONTPELIER",
    "dropdelst": "ID",
    "dropdelzpp": 832549998,
    "dropphyadd": "804 GRANT ST",
    "dropphycty": "MONTPELIER",
    "dropphyst": "ID",
    "dropphyzpp": 832549998,
    "dropmaladd": "804 GRANT ST",
    "dropmalcty": "MONTPELIER",
    "dropmalst": "ID",
    "dropmalzpp": 832549998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088471894,
    "dropsitcph": 2088471894,
    "dropfax": 2088471894
  },
  {
    "dcode": "D",
    "dropkey": "PZ12740",
    "droptype": "D",
    "dropname": "MOORE",
    "dropdeladd": "3252 W 3160 N",
    "dropdelcty": "MOORE",
    "dropdelst": "ID",
    "dropdelzpp": 832559998,
    "dropphyadd": "3252 W 3160 N",
    "dropphycty": "MOORE",
    "dropphyst": "ID",
    "dropphyzpp": 832559998,
    "dropmaladd": "3252 W 3160 N",
    "dropmalcty": "MOORE",
    "dropmalst": "ID",
    "dropmalzpp": 832559998,
    "dropsitphn": 2083834239,
    "dropsitlph": 9862218766,
    "dropsitcph": 9862230179,
    "dropfax": 2085544211
  },
  {
    "dcode": "D",
    "dropkey": "PZ12742",
    "droptype": "D",
    "dropname": "MORELAND",
    "dropdeladd": "180 N 740 W",
    "dropdelcty": "MORELAND",
    "dropdelst": "ID",
    "dropdelzpp": 832569998,
    "dropphyadd": "180 N 740 W",
    "dropphycty": "MORELAND",
    "dropphyst": "ID",
    "dropphyzpp": 832569998,
    "dropmaladd": "180 N 740 W",
    "dropmalcty": "MORELAND",
    "dropmalst": "ID",
    "dropmalzpp": 832569998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2086844538,
    "dropsitcph": 2086844538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12746",
    "droptype": "D",
    "dropname": "MOSCOW",
    "dropdeladd": "220 E 5TH ST LBBY",
    "dropdelcty": "MOSCOW",
    "dropdelst": "ID",
    "dropdelzpp": 838439998,
    "dropphyadd": "220 E 5TH ST LBBY",
    "dropphycty": "MOSCOW",
    "dropphyst": "ID",
    "dropphyzpp": 838439998,
    "dropmaladd": "220 E 5TH ST LBBY",
    "dropmalcty": "MOSCOW",
    "dropmalst": "ID",
    "dropmalzpp": 838439998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088824900,
    "dropsitcph": 2088838464,
    "dropfax": 2088839751
  },
  {
    "dcode": "D",
    "dropkey": "PZ12748",
    "droptype": "D",
    "dropname": "MOUNTAIN HOME",
    "dropdeladd": "350 N 3RD E",
    "dropdelcty": "MOUNTAIN HOME",
    "dropdelst": "ID",
    "dropdelzpp": 836479998,
    "dropphyadd": "350 N 3RD E",
    "dropphycty": "MOUNTAIN HOME",
    "dropphyst": "ID",
    "dropphyzpp": 836479998,
    "dropmaladd": "350 N 3RD E",
    "dropmalcty": "MOUNTAIN HOME",
    "dropmalst": "ID",
    "dropmalzpp": 836479998,
    "dropsitphn": 2085871413,
    "dropsitlph": 2085871413,
    "dropsitcph": 2085871413,
    "dropfax": 2085879013
  },
  {
    "dcode": "D",
    "dropkey": "PZ12753",
    "droptype": "D",
    "dropname": "MOYIE SPRINGS",
    "dropdeladd": "3197 ROOSEVELT RD",
    "dropdelcty": "MOYIE SPRINGS",
    "dropdelst": "ID",
    "dropdelzpp": 838459998,
    "dropphyadd": "3197 ROOSEVELT RD",
    "dropphycty": "MOYIE SPRINGS",
    "dropphyst": "ID",
    "dropphyzpp": 838459998,
    "dropmaladd": "3197 ROOSEVELT RD",
    "dropmalcty": "MOYIE SPRINGS",
    "dropmalst": "ID",
    "dropmalzpp": 838459998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082677411,
    "dropsitcph": 2082677411,
    "dropfax": 6503576558
  },
  {
    "dcode": "D",
    "dropkey": "PZ12760",
    "droptype": "D",
    "dropname": "MULLAN",
    "dropdeladd": "237 EARLE AVE",
    "dropdelcty": "MULLAN",
    "dropdelst": "ID",
    "dropdelzpp": 838469998,
    "dropphyadd": "237 EARLE AVE",
    "dropphycty": "MULLAN",
    "dropphyst": "ID",
    "dropphyzpp": 838469998,
    "dropmaladd": "237 EARLE AVE",
    "dropmalcty": "MULLAN",
    "dropmalst": "ID",
    "dropmalzpp": 838469998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087441315,
    "dropsitcph": 2087441315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12761",
    "droptype": "D",
    "dropname": "MURPHY",
    "dropdeladd": "17026 HAILEY ST",
    "dropdelcty": "MURPHY",
    "dropdelst": "ID",
    "dropdelzpp": 836509998,
    "dropphyadd": "17026 HAILEY ST",
    "dropphycty": "MURPHY",
    "dropphyst": "ID",
    "dropphyzpp": 836509998,
    "dropmaladd": "17026 HAILEY ST",
    "dropmalcty": "MURPHY",
    "dropmalst": "ID",
    "dropmalzpp": 836509998,
    "dropsitphn": 2084952535,
    "dropsitlph": 2089454206,
    "dropsitcph": 2084952535,
    "dropfax": 2084952976
  },
  {
    "dcode": "D",
    "dropkey": "PZ12763",
    "droptype": "D",
    "dropname": "MURTAUGH",
    "dropdeladd": "244 1ST ST S",
    "dropdelcty": "MURTAUGH",
    "dropdelst": "ID",
    "dropdelzpp": 833449998,
    "dropphyadd": "244 1ST ST S",
    "dropphycty": "MURTAUGH",
    "dropphyst": "ID",
    "dropphyzpp": 833449998,
    "dropmaladd": "244 1ST ST S",
    "dropmalcty": "MURTAUGH",
    "dropmalst": "ID",
    "dropmalzpp": 833449998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2084325509,
    "dropsitcph": 2084325509,
    "dropfax": 2084326042
  },
  {
    "dcode": "D",
    "dropkey": "PZ12765",
    "droptype": "D",
    "dropname": "NAMPA",
    "dropdeladd": "123 11TH AVE S",
    "dropdelcty": "NAMPA",
    "dropdelst": "ID",
    "dropdelzpp": 836519998,
    "dropphyadd": "123 11TH AVE S",
    "dropphycty": "NAMPA",
    "dropphyst": "ID",
    "dropphyzpp": 836519998,
    "dropmaladd": "123 11TH AVE S",
    "dropmalcty": "NAMPA",
    "dropmalst": "ID",
    "dropmalzpp": 836519998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084668939,
    "dropsitcph": 2084610379,
    "dropfax": 2084632849
  },
  {
    "dcode": "D",
    "dropkey": "PZ12766",
    "droptype": "D",
    "dropname": "NAPLES",
    "dropdeladd": "517 DEEP CREEK LOOP",
    "dropdelcty": "NAPLES",
    "dropdelst": "ID",
    "dropdelzpp": 838479998,
    "dropphyadd": "517 DEEP CREEK LOOP",
    "dropphycty": "NAPLES",
    "dropphyst": "ID",
    "dropphyzpp": 838479998,
    "dropmaladd": "517 DEEP CREEK LOOP",
    "dropmalcty": "NAPLES",
    "dropmalst": "ID",
    "dropmalzpp": 838479998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082677313,
    "dropsitcph": 2082677313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12769",
    "droptype": "D",
    "dropname": "NEW MEADOWS",
    "dropdeladd": "221 VIRGINIA ST",
    "dropdelcty": "NEW MEADOWS",
    "dropdelst": "ID",
    "dropdelzpp": 836549998,
    "dropphyadd": "221 VIRGINIA ST",
    "dropphycty": "NEW MEADOWS",
    "dropphyst": "ID",
    "dropphyzpp": 836549998,
    "dropmaladd": "221 VIRGINIA ST",
    "dropmalcty": "NEW MEADOWS",
    "dropmalst": "ID",
    "dropmalzpp": 836549998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083472134,
    "dropsitcph": 2083472134,
    "dropfax": 2083472134
  },
  {
    "dcode": "D",
    "dropkey": "PZ12770",
    "droptype": "D",
    "dropname": "NEW PLYMOUTH",
    "dropdeladd": "325 N PLYMOUTH AVE",
    "dropdelcty": "NEW PLYMOUTH",
    "dropdelst": "ID",
    "dropdelzpp": 836559998,
    "dropphyadd": "325 N PLYMOUTH AVE",
    "dropphycty": "NEW PLYMOUTH",
    "dropphyst": "ID",
    "dropphyzpp": 836559998,
    "dropmaladd": "325 N PLYMOUTH AVE",
    "dropmalcty": "NEW PLYMOUTH",
    "dropmalst": "ID",
    "dropmalzpp": 836559998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082785868,
    "dropsitcph": 2082785868,
    "dropfax": 2082785868
  },
  {
    "dcode": "D",
    "dropkey": "PZ12772",
    "droptype": "D",
    "dropname": "NEWDALE",
    "dropdeladd": "385 CITY ST",
    "dropdelcty": "NEWDALE",
    "dropdelst": "ID",
    "dropdelzpp": 834369998,
    "dropphyadd": "385 CITY ST",
    "dropphycty": "NEWDALE",
    "dropphyst": "ID",
    "dropphyzpp": 834369998,
    "dropmaladd": "385 CITY ST",
    "dropmalcty": "NEWDALE",
    "dropmalst": "ID",
    "dropmalzpp": 834369998,
    "dropsitphn": 2084584911,
    "dropsitlph": 2086432308,
    "dropsitcph": 2086432308,
    "dropfax": 2086432252
  },
  {
    "dcode": "D",
    "dropkey": "PZ12774",
    "droptype": "D",
    "dropname": "NEZPERCE",
    "dropdeladd": "310 OAK ST",
    "dropdelcty": "NEZPERCE",
    "dropdelst": "ID",
    "dropdelzpp": 835439998,
    "dropphyadd": "310 OAK ST",
    "dropphycty": "NEZPERCE",
    "dropphyst": "ID",
    "dropphyzpp": 835439998,
    "dropmaladd": "310 OAK ST",
    "dropmalcty": "NEZPERCE",
    "dropmalst": "ID",
    "dropmalzpp": 835439998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089375046,
    "dropsitcph": 2089375046,
    "dropfax": 2089372029
  },
  {
    "dcode": "D",
    "dropkey": "PZ12776",
    "droptype": "D",
    "dropname": "NORDMAN",
    "dropdeladd": "36442 HIGHWAY 57",
    "dropdelcty": "NORDMAN",
    "dropdelst": "ID",
    "dropdelzpp": 838489998,
    "dropphyadd": "36442 HIGHWAY 57",
    "dropphycty": "NORDMAN",
    "dropphyst": "ID",
    "dropphyzpp": 838489998,
    "dropmaladd": "36442 HIGHWAY 57",
    "dropmalcty": "NORDMAN",
    "dropmalst": "ID",
    "dropmalzpp": 838489998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084432093,
    "dropsitcph": 2084432093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12777",
    "droptype": "D",
    "dropname": "NORTH FORK",
    "dropdeladd": "2048 HIGHWAY 93 N",
    "dropdelcty": "NORTH FORK",
    "dropdelst": "ID",
    "dropdelzpp": 834669998,
    "dropphyadd": "2048 HIGHWAY 93 N",
    "dropphycty": "NORTH FORK",
    "dropphyst": "ID",
    "dropphyzpp": 834669998,
    "dropmaladd": "2048 HIGHWAY 93 N",
    "dropmalcty": "NORTH FORK",
    "dropmalst": "ID",
    "dropmalzpp": 834669998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088652556,
    "dropsitcph": 2088652556,
    "dropfax": 2088652556
  },
  {
    "dcode": "D",
    "dropkey": "PZ12781",
    "droptype": "D",
    "dropname": "NOTUS",
    "dropdeladd": "385 FARGO AVE",
    "dropdelcty": "NOTUS",
    "dropdelst": "ID",
    "dropdelzpp": 836569998,
    "dropphyadd": "385 FARGO AVE",
    "dropphycty": "NOTUS",
    "dropphyst": "ID",
    "dropphyzpp": 836569998,
    "dropmaladd": "385 FARGO AVE",
    "dropmalcty": "NOTUS",
    "dropmalst": "ID",
    "dropmalzpp": 836569998,
    "dropsitphn": 2084592817,
    "dropsitlph": 2084334080,
    "dropsitcph": 2084592817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12783",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "OAKLEY",
    "dropdelst": "ID",
    "dropdelzpp": 833469998,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "OAKLEY",
    "dropphyst": "ID",
    "dropphyzpp": 833469998,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "OAKLEY",
    "dropmalst": "ID",
    "dropmalzpp": 833469998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088623852,
    "dropsitcph": 2088623852,
    "dropfax": 2088623852
  },
  {
    "dcode": "D",
    "dropkey": "PZ12785",
    "droptype": "D",
    "dropname": "OLA",
    "dropdeladd": "11000 OLA SCHOOL RD",
    "dropdelcty": "OLA",
    "dropdelst": "ID",
    "dropdelzpp": 836579998,
    "dropphyadd": "11000 OLA SCHOOL RD",
    "dropphycty": "OLA",
    "dropphyst": "ID",
    "dropphyzpp": 836579998,
    "dropmaladd": "11000 OLA SCHOOL RD",
    "dropmalcty": "OLA",
    "dropmalst": "ID",
    "dropmalzpp": 836579998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085849301,
    "dropsitcph": 2085849301,
    "dropfax": 2085849301
  },
  {
    "dcode": "D",
    "dropkey": "PZ12789",
    "droptype": "D",
    "dropname": "OROFINO",
    "dropdeladd": "320 MICHIGAN AVE",
    "dropdelcty": "OROFINO",
    "dropdelst": "ID",
    "dropdelzpp": 835449998,
    "dropphyadd": "320 MICHIGAN AVE",
    "dropphycty": "OROFINO",
    "dropphyst": "ID",
    "dropphyzpp": 835449998,
    "dropmaladd": "320 MICHIGAN AVE",
    "dropmalcty": "OROFINO",
    "dropmalst": "ID",
    "dropmalzpp": 835449998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084765115,
    "dropsitcph": 2084765115,
    "dropfax": 6505772543
  },
  {
    "dcode": "D",
    "dropkey": "PZ12790",
    "droptype": "D",
    "dropname": "OSBURN",
    "dropdeladd": "107 N 4TH ST",
    "dropdelcty": "OSBURN",
    "dropdelst": "ID",
    "dropdelzpp": 838499998,
    "dropphyadd": "107 N 4TH ST",
    "dropphycty": "OSBURN",
    "dropphyst": "ID",
    "dropphyzpp": 838499998,
    "dropmaladd": "107 N 4TH ST",
    "dropmalcty": "OSBURN",
    "dropmalst": "ID",
    "dropmalzpp": 838499998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087538951,
    "dropsitcph": 2087538951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12796",
    "droptype": "D",
    "dropname": "PARIS",
    "dropdeladd": "70 N MAIN ST",
    "dropdelcty": "PARIS",
    "dropdelst": "ID",
    "dropdelzpp": 832619998,
    "dropphyadd": "70 N MAIN ST",
    "dropphycty": "PARIS",
    "dropphyst": "ID",
    "dropphyzpp": 832619998,
    "dropmaladd": "70 N MAIN ST",
    "dropmalcty": "PARIS",
    "dropmalst": "ID",
    "dropmalzpp": 832619998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2089452768,
    "dropsitcph": 2089452768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12797",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "31 N CENTER",
    "dropdelcty": "PARKER",
    "dropdelst": "ID",
    "dropdelzpp": 834389998,
    "dropphyadd": "31 N CENTER",
    "dropphycty": "PARKER",
    "dropphyst": "ID",
    "dropphyzpp": 834389998,
    "dropmaladd": "31 N CENTER",
    "dropmalcty": "PARKER",
    "dropmalst": "ID",
    "dropmalzpp": 834389998,
    "dropsitphn": 2083834239,
    "dropsitlph": 9862042216,
    "dropsitcph": 9862042216,
    "dropfax": 2086247346
  },
  {
    "dcode": "D",
    "dropkey": "PZ12798",
    "droptype": "D",
    "dropname": "PARMA",
    "dropdeladd": "207 N 3RD ST",
    "dropdelcty": "PARMA",
    "dropdelst": "ID",
    "dropdelzpp": 836609998,
    "dropphyadd": "207 N 3RD ST",
    "dropphycty": "PARMA",
    "dropphyst": "ID",
    "dropphyzpp": 836609998,
    "dropmaladd": "207 N 3RD ST",
    "dropmalcty": "PARMA",
    "dropmalst": "ID",
    "dropmalzpp": 836609998,
    "dropsitphn": 2087225164,
    "dropsitlph": 2084334080,
    "dropsitcph": 2087225164,
    "dropfax": 2087225164
  },
  {
    "dcode": "D",
    "dropkey": "PZ12800",
    "droptype": "D",
    "dropname": "PAUL",
    "dropdeladd": "110 E IDAHO ST",
    "dropdelcty": "PAUL",
    "dropdelst": "ID",
    "dropdelzpp": 833479998,
    "dropphyadd": "110 E IDAHO ST",
    "dropphycty": "PAUL",
    "dropphyst": "ID",
    "dropphyzpp": 833479998,
    "dropmaladd": "110 E IDAHO ST",
    "dropmalcty": "PAUL",
    "dropmalst": "ID",
    "dropmalzpp": 833479998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084382222,
    "dropsitcph": 2084382222,
    "dropfax": 2084382222
  },
  {
    "dcode": "D",
    "dropkey": "PZ12801",
    "droptype": "D",
    "dropname": "PAYETTE",
    "dropdeladd": "915 CENTER AVE",
    "dropdelcty": "PAYETTE",
    "dropdelst": "ID",
    "dropdelzpp": 836619998,
    "dropphyadd": "915 CENTER AVE",
    "dropphycty": "PAYETTE",
    "dropphyst": "ID",
    "dropphyzpp": 836619998,
    "dropmaladd": "915 CENTER AVE",
    "dropmalcty": "PAYETTE",
    "dropmalst": "ID",
    "dropmalzpp": 836619998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086423211,
    "dropsitcph": 2086423211,
    "dropfax": 2086423211
  },
  {
    "dcode": "D",
    "dropkey": "PZ12804",
    "droptype": "D",
    "dropname": "PECK",
    "dropdeladd": "102 N MAIN ST",
    "dropdelcty": "PECK",
    "dropdelst": "ID",
    "dropdelzpp": 835459998,
    "dropphyadd": "102 N MAIN ST",
    "dropphycty": "PECK",
    "dropphyst": "ID",
    "dropphyzpp": 835459998,
    "dropmaladd": "102 N MAIN ST",
    "dropmalcty": "PECK",
    "dropmalst": "ID",
    "dropmalzpp": 835459998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084867051,
    "dropsitcph": 2084867051,
    "dropfax": 6505783271
  },
  {
    "dcode": "D",
    "dropkey": "PZ12808",
    "droptype": "D",
    "dropname": "PIERCE",
    "dropdeladd": "111 S MAIN ST",
    "dropdelcty": "PIERCE",
    "dropdelst": "ID",
    "dropdelzpp": 835469998,
    "dropphyadd": "111 S MAIN ST",
    "dropphycty": "PIERCE",
    "dropphyst": "ID",
    "dropphyzpp": 835469998,
    "dropmaladd": "111 S MAIN ST",
    "dropmalcty": "PIERCE",
    "dropmalst": "ID",
    "dropmalzpp": 835469998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084642113,
    "dropsitcph": 2084642113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12811",
    "droptype": "D",
    "dropname": "PINEHURST",
    "dropdeladd": "9 MAIN ST",
    "dropdelcty": "PINEHURST",
    "dropdelst": "ID",
    "dropdelzpp": 838509998,
    "dropphyadd": "9 MAIN ST",
    "dropphycty": "PINEHURST",
    "dropphyst": "ID",
    "dropphyzpp": 838509998,
    "dropmaladd": "9 MAIN ST",
    "dropmalcty": "PINEHURST",
    "dropmalst": "ID",
    "dropmalzpp": 838509998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086822514,
    "dropsitcph": 2086822514,
    "dropfax": 6505774869
  },
  {
    "dcode": "D",
    "dropkey": "PZ12812",
    "droptype": "D",
    "dropname": "PINGREE",
    "dropdeladd": "1507 W HIGHWAY 39",
    "dropdelcty": "PINGREE",
    "dropdelst": "ID",
    "dropdelzpp": 832629998,
    "dropphyadd": "1507 W HIGHWAY 39",
    "dropphycty": "PINGREE",
    "dropphyst": "ID",
    "dropphyzpp": 832629998,
    "dropmaladd": "1507 W HIGHWAY 39",
    "dropmalcty": "PINGREE",
    "dropmalst": "ID",
    "dropmalzpp": 832629998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082346418,
    "dropsitcph": 2086843140,
    "dropfax": 2086843140
  },
  {
    "dcode": "D",
    "dropkey": "PZ12817",
    "droptype": "D",
    "dropname": "PLUMMER",
    "dropdeladd": "235 10TH ST",
    "dropdelcty": "PLUMMER",
    "dropdelst": "ID",
    "dropdelzpp": 838519998,
    "dropphyadd": "235 10TH ST",
    "dropphycty": "PLUMMER",
    "dropphyst": "ID",
    "dropphyzpp": 838519998,
    "dropmaladd": "235 10TH ST",
    "dropmalcty": "PLUMMER",
    "dropmalst": "ID",
    "dropmalzpp": 838519998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086861748,
    "dropsitcph": 2086861748,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12819",
    "droptype": "D",
    "dropname": "POCATELLO",
    "dropdeladd": "730 E CLARK ST",
    "dropdelcty": "POCATELLO",
    "dropdelst": "ID",
    "dropdelzpp": 832019998,
    "dropphyadd": "730 E CLARK ST",
    "dropphycty": "POCATELLO",
    "dropphyst": "ID",
    "dropphyzpp": 832019998,
    "dropmaladd": "730 E CLARK ST",
    "dropmalcty": "POCATELLO",
    "dropmalst": "ID",
    "dropmalzpp": 832019998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082355517,
    "dropsitcph": 2082352190,
    "dropfax": 2082352186
  },
  {
    "dcode": "D",
    "dropkey": "PZ12820",
    "droptype": "D",
    "dropname": "POLLOCK",
    "dropdeladd": "169 OLD POLLOCK RD",
    "dropdelcty": "POLLOCK",
    "dropdelst": "ID",
    "dropdelzpp": 835479998,
    "dropphyadd": "169 OLD POLLOCK RD",
    "dropphycty": "POLLOCK",
    "dropphyst": "ID",
    "dropphyzpp": 835479998,
    "dropmaladd": "169 OLD POLLOCK RD",
    "dropmalcty": "POLLOCK",
    "dropmalst": "ID",
    "dropmalzpp": 835479998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086283521,
    "dropsitcph": 2086283521,
    "dropfax": 2086282309
  },
  {
    "dcode": "D",
    "dropkey": "PZ12821",
    "droptype": "D",
    "dropname": "PONDERAY",
    "dropdeladd": "296 4TH ST",
    "dropdelcty": "PONDERAY",
    "dropdelst": "ID",
    "dropdelzpp": 838529998,
    "dropphyadd": "296 4TH ST",
    "dropphycty": "PONDERAY",
    "dropphyst": "ID",
    "dropphyzpp": 838529998,
    "dropmaladd": "296 4TH ST",
    "dropmalcty": "PONDERAY",
    "dropmalst": "ID",
    "dropmalzpp": 838529998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082639803,
    "dropsitcph": 2082639803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12823",
    "droptype": "D",
    "dropname": "PORTHILL",
    "dropdeladd": "3329 PORTHILL LOOP RD",
    "dropdelcty": "PORTHILL",
    "dropdelst": "ID",
    "dropdelzpp": 838539998,
    "dropphyadd": "3329 PORTHILL LOOP RD",
    "dropphycty": "PORTHILL",
    "dropphyst": "ID",
    "dropphyzpp": 838539998,
    "dropmaladd": "3329 PORTHILL LOOP RD",
    "dropmalcty": "PORTHILL",
    "dropmalst": "ID",
    "dropmalzpp": 838539998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2082672687,
    "dropsitcph": 2082672687,
    "dropfax": 2082672687
  },
  {
    "dcode": "D",
    "dropkey": "PZ12824",
    "droptype": "D",
    "dropname": "POST FALLS",
    "dropdeladd": "405 N GREENSFERRY RD",
    "dropdelcty": "POST FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 838549998,
    "dropphyadd": "405 N GREENSFERRY RD",
    "dropphycty": "POST FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 838549998,
    "dropmaladd": "405 N GREENSFERRY RD",
    "dropmalcty": "POST FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 838549998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2087736443,
    "dropsitcph": 2087774073,
    "dropfax": 6514566237
  },
  {
    "dcode": "D",
    "dropkey": "PZ12825",
    "droptype": "D",
    "dropname": "POTLATCH",
    "dropdeladd": "535 PINE ST",
    "dropdelcty": "POTLATCH",
    "dropdelst": "ID",
    "dropdelzpp": 838559998,
    "dropphyadd": "535 PINE ST",
    "dropphycty": "POTLATCH",
    "dropphyst": "ID",
    "dropphyzpp": 838559998,
    "dropmaladd": "535 PINE ST",
    "dropmalcty": "POTLATCH",
    "dropmalst": "ID",
    "dropmalzpp": 838559998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2088750828,
    "dropsitcph": 2088750828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12827",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "55 E ONEIDA ST",
    "dropdelcty": "PRESTON",
    "dropdelst": "ID",
    "dropdelzpp": 832639998,
    "dropphyadd": "55 E ONEIDA ST",
    "dropphycty": "PRESTON",
    "dropphyst": "ID",
    "dropphyzpp": 832639998,
    "dropmaladd": "55 E ONEIDA ST",
    "dropmalcty": "PRESTON",
    "dropmalst": "ID",
    "dropmalzpp": 832639998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088520263,
    "dropsitcph": 2088520263,
    "dropfax": 2088521214
  },
  {
    "dcode": "D",
    "dropkey": "PZ12829",
    "droptype": "D",
    "dropname": "PRIEST RIVER",
    "dropdeladd": "43 TREAT ST",
    "dropdelcty": "PRIEST RIVER",
    "dropdelst": "ID",
    "dropdelzpp": 838569998,
    "dropphyadd": "43 TREAT ST",
    "dropphycty": "PRIEST RIVER",
    "dropphyst": "ID",
    "dropphyzpp": 838569998,
    "dropmaladd": "43 TREAT ST",
    "dropmalcty": "PRIEST RIVER",
    "dropmalst": "ID",
    "dropmalzpp": 838569998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2084481513,
    "dropsitcph": 2084481513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12830",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "3469 HIGHWAY 6",
    "dropdelcty": "PRINCETON",
    "dropdelst": "ID",
    "dropdelzpp": 838579998,
    "dropphyadd": "3469 HIGHWAY 6",
    "dropphycty": "PRINCETON",
    "dropphyst": "ID",
    "dropphyzpp": 838579998,
    "dropmaladd": "3469 HIGHWAY 6",
    "dropmalcty": "PRINCETON",
    "dropmalst": "ID",
    "dropmalzpp": 838579998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2088750552,
    "dropsitcph": 2088750552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12832",
    "droptype": "D",
    "dropname": "RATHDRUM",
    "dropdeladd": "13867 W HIGHWAY 53",
    "dropdelcty": "RATHDRUM",
    "dropdelst": "ID",
    "dropdelzpp": 838589998,
    "dropphyadd": "13867 W HIGHWAY 53",
    "dropphycty": "RATHDRUM",
    "dropphyst": "ID",
    "dropphyzpp": 838589998,
    "dropmaladd": "13867 W HIGHWAY 53",
    "dropmalcty": "RATHDRUM",
    "dropmalst": "ID",
    "dropmalzpp": 838589998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2086871281,
    "dropsitcph": 2086873415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12837",
    "droptype": "D",
    "dropname": "REXBURG",
    "dropdeladd": "140 S CENTER ST",
    "dropdelcty": "REXBURG",
    "dropdelst": "ID",
    "dropdelzpp": 834409998,
    "dropphyadd": "140 S CENTER ST",
    "dropphycty": "REXBURG",
    "dropphyst": "ID",
    "dropphyzpp": 834409998,
    "dropmaladd": "140 S CENTER ST",
    "dropmalcty": "REXBURG",
    "dropmalst": "ID",
    "dropmalzpp": 834409998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083565031,
    "dropsitcph": 2083565031,
    "dropfax": 2083591575
  },
  {
    "dcode": "D",
    "dropkey": "PZ12840",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "180 N MAIN ST",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "ID",
    "dropdelzpp": 833499998,
    "dropphyadd": "180 N MAIN ST",
    "dropphycty": "RICHFIELD",
    "dropphyst": "ID",
    "dropphyzpp": 833499998,
    "dropmaladd": "180 N MAIN ST",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "ID",
    "dropmalzpp": 833499998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2084873488,
    "dropsitcph": 2084873488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12843",
    "droptype": "D",
    "dropname": "RIGBY",
    "dropdeladd": "165 S STATE ST",
    "dropdelcty": "RIGBY",
    "dropdelst": "ID",
    "dropdelzpp": 834425312,
    "dropphyadd": "165 S STATE ST",
    "dropphycty": "RIGBY",
    "dropphyst": "ID",
    "dropphyzpp": 834425312,
    "dropmaladd": "165 S STATE ST",
    "dropmalcty": "RIGBY",
    "dropmalst": "ID",
    "dropmalzpp": 834425312,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087456792,
    "dropsitcph": 2087456792,
    "dropfax": 2087457749
  },
  {
    "dcode": "D",
    "dropkey": "PZ12844",
    "droptype": "D",
    "dropname": "RIGGINS",
    "dropdeladd": "400 S MAIN ST",
    "dropdelcty": "RIGGINS",
    "dropdelst": "ID",
    "dropdelzpp": 835499998,
    "dropphyadd": "400 S MAIN ST",
    "dropphycty": "RIGGINS",
    "dropphyst": "ID",
    "dropphyzpp": 835499998,
    "dropmaladd": "400 S MAIN ST",
    "dropmalcty": "RIGGINS",
    "dropmalst": "ID",
    "dropmalzpp": 835499998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2086281019,
    "dropsitcph": 2086281019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12845",
    "droptype": "D",
    "dropname": "RIRIE",
    "dropdeladd": "120 W RIRIE HWY",
    "dropdelcty": "RIRIE",
    "dropdelst": "ID",
    "dropdelzpp": 834439998,
    "dropphyadd": "120 W RIRIE HWY",
    "dropphycty": "RIRIE",
    "dropphyst": "ID",
    "dropphyzpp": 834439998,
    "dropmaladd": "120 W RIRIE HWY",
    "dropmalcty": "RIRIE",
    "dropmalst": "ID",
    "dropmalzpp": 834439998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2085387818,
    "dropsitcph": 2085387818,
    "dropfax": 2085385236
  },
  {
    "dcode": "D",
    "dropkey": "PZ12848",
    "droptype": "D",
    "dropname": "ROBERTS",
    "dropdeladd": "2876 E 650 N",
    "dropdelcty": "ROBERTS",
    "dropdelst": "ID",
    "dropdelzpp": 834449998,
    "dropphyadd": "2876 E 650 N",
    "dropphycty": "ROBERTS",
    "dropphyst": "ID",
    "dropphyzpp": 834449998,
    "dropmaladd": "2876 E 650 N",
    "dropmalcty": "ROBERTS",
    "dropmalst": "ID",
    "dropmalzpp": 834449998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082283521,
    "dropsitcph": 2082283521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12852",
    "droptype": "D",
    "dropname": "ROCKLAND",
    "dropdeladd": "155 S MAIN ST",
    "dropdelcty": "ROCKLAND",
    "dropdelst": "ID",
    "dropdelzpp": 832719998,
    "dropphyadd": "155 S MAIN ST",
    "dropphycty": "ROCKLAND",
    "dropphyst": "ID",
    "dropphyzpp": 832719998,
    "dropmaladd": "155 S MAIN ST",
    "dropmalcty": "ROCKLAND",
    "dropmalst": "ID",
    "dropmalzpp": 832719998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2085482646,
    "dropsitcph": 2085482646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12861",
    "droptype": "D",
    "dropname": "RUPERT",
    "dropdeladd": "724 F ST",
    "dropdelcty": "RUPERT",
    "dropdelst": "ID",
    "dropdelzpp": 833509998,
    "dropphyadd": "724 F ST",
    "dropphycty": "RUPERT",
    "dropphyst": "ID",
    "dropphyzpp": 833509998,
    "dropmaladd": "724 F ST",
    "dropmalcty": "RUPERT",
    "dropmalst": "ID",
    "dropmalzpp": 833509998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2084363446,
    "dropsitcph": 2084363446,
    "dropfax": 2084364439
  },
  {
    "dcode": "D",
    "dropkey": "PZ12862",
    "droptype": "D",
    "dropname": "SAGLE",
    "dropdeladd": "468665 HIGHWAY 95",
    "dropdelcty": "SAGLE",
    "dropdelst": "ID",
    "dropdelzpp": 838609998,
    "dropphyadd": "468665 HIGHWAY 95",
    "dropphycty": "SAGLE",
    "dropphyst": "ID",
    "dropphyzpp": 838609998,
    "dropmaladd": "468665 HIGHWAY 95",
    "dropmalcty": "SAGLE",
    "dropmalst": "ID",
    "dropmalzpp": 838609998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082650876,
    "dropsitcph": 2082632338,
    "dropfax": 6514566252
  },
  {
    "dcode": "D",
    "dropkey": "PZ12863",
    "droptype": "D",
    "dropname": "SAINT ANTHONY",
    "dropdeladd": "50 W 1ST N",
    "dropdelcty": "SAINT ANTHONY",
    "dropdelst": "ID",
    "dropdelzpp": 834459998,
    "dropphyadd": "50 W 1ST N",
    "dropphycty": "SAINT ANTHONY",
    "dropphyst": "ID",
    "dropphyzpp": 834459998,
    "dropmaladd": "50 W 1ST N",
    "dropmalcty": "SAINT ANTHONY",
    "dropmalst": "ID",
    "dropmalzpp": 834459998,
    "dropsitphn": 9862042195,
    "dropsitlph": 9862042195,
    "dropsitcph": 9862042195,
    "dropfax": 9862042195
  },
  {
    "dcode": "D",
    "dropkey": "PZ12864",
    "droptype": "D",
    "dropname": "SAINT CHARLES",
    "dropdeladd": "195 N MAIN ST",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "ID",
    "dropdelzpp": 832729998,
    "dropphyadd": "195 N MAIN ST",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "ID",
    "dropphyzpp": 832729998,
    "dropmaladd": "195 N MAIN ST",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "ID",
    "dropmalzpp": 832729998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2089452328,
    "dropsitcph": 2089452328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12866",
    "droptype": "D",
    "dropname": "SAINT MARIES",
    "dropdeladd": "222 S 7TH ST STE 2",
    "dropdelcty": "SAINT MARIES",
    "dropdelst": "ID",
    "dropdelzpp": 838619998,
    "dropphyadd": "222 S 7TH ST STE 2",
    "dropphycty": "SAINT MARIES",
    "dropphyst": "ID",
    "dropphyzpp": 838619998,
    "dropmaladd": "222 S 7TH ST STE 2",
    "dropmalcty": "SAINT MARIES",
    "dropmalst": "ID",
    "dropmalzpp": 838619998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2082452031,
    "dropsitcph": 2082452031,
    "dropfax": 6514566253
  },
  {
    "dcode": "D",
    "dropkey": "PZ12867",
    "droptype": "D",
    "dropname": "SALMON",
    "dropdeladd": "600 SHOUP ST",
    "dropdelcty": "SALMON",
    "dropdelst": "ID",
    "dropdelzpp": 834679998,
    "dropphyadd": "600 SHOUP ST",
    "dropphycty": "SALMON",
    "dropphyst": "ID",
    "dropphyzpp": 834679998,
    "dropmaladd": "600 SHOUP ST",
    "dropmalcty": "SALMON",
    "dropmalst": "ID",
    "dropmalzpp": 834679998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087562410,
    "dropsitcph": 2087562410,
    "dropfax": 2087562419
  },
  {
    "dcode": "D",
    "dropkey": "PZ12871",
    "droptype": "D",
    "dropname": "SANDPOINT",
    "dropdeladd": "204 N 4TH AVE",
    "dropdelcty": "SANDPOINT",
    "dropdelst": "ID",
    "dropdelzpp": 838649998,
    "dropphyadd": "204 N 4TH AVE",
    "dropphycty": "SANDPOINT",
    "dropphyst": "ID",
    "dropphyzpp": 838649998,
    "dropmaladd": "204 N 4TH AVE",
    "dropmalcty": "SANDPOINT",
    "dropmalst": "ID",
    "dropmalzpp": 838649998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2082632716,
    "dropsitcph": 2082632716,
    "dropfax": 6514566567
  },
  {
    "dcode": "D",
    "dropkey": "PZ12872",
    "droptype": "D",
    "dropname": "SANTA",
    "dropdeladd": "68244 HIGHWAY 3 S",
    "dropdelcty": "SANTA",
    "dropdelst": "ID",
    "dropdelzpp": 838669900,
    "dropphyadd": "68244 HIGHWAY 3 S",
    "dropphycty": "SANTA",
    "dropphyst": "ID",
    "dropphyzpp": 838669900,
    "dropmaladd": "68244 HIGHWAY 3 S",
    "dropmalcty": "SANTA",
    "dropmalst": "ID",
    "dropmalzpp": 838669900,
    "dropsitphn": 5094590201,
    "dropsitlph": 2082453685,
    "dropsitcph": 2082453685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12874",
    "droptype": "D",
    "dropname": "SHELLEY",
    "dropdeladd": "244 W PINE ST",
    "dropdelcty": "SHELLEY",
    "dropdelst": "ID",
    "dropdelzpp": 832749998,
    "dropphyadd": "244 W PINE ST",
    "dropphycty": "SHELLEY",
    "dropphyst": "ID",
    "dropphyzpp": 832749998,
    "dropmaladd": "244 W PINE ST",
    "dropmalcty": "SHELLEY",
    "dropmalst": "ID",
    "dropmalzpp": 832749998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086438044,
    "dropsitcph": 2086438044,
    "dropfax": 2083577980
  },
  {
    "dcode": "D",
    "dropkey": "PZ12876",
    "droptype": "D",
    "dropname": "SHOSHONE",
    "dropdeladd": "211 W A ST",
    "dropdelcty": "SHOSHONE",
    "dropdelst": "ID",
    "dropdelzpp": 833529998,
    "dropphyadd": "211 W A ST",
    "dropphycty": "SHOSHONE",
    "dropphyst": "ID",
    "dropphyzpp": 833529998,
    "dropmaladd": "211 W A ST",
    "dropmalcty": "SHOSHONE",
    "dropmalst": "ID",
    "dropmalzpp": 833529998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2083295576,
    "dropsitcph": 2083296549,
    "dropfax": 2088862062
  },
  {
    "dcode": "D",
    "dropkey": "PZ12880",
    "droptype": "D",
    "dropname": "SILVERTON",
    "dropdeladd": "102 W YELLOWSTONE AVE",
    "dropdelcty": "SILVERTON",
    "dropdelst": "ID",
    "dropdelzpp": 838679998,
    "dropphyadd": "102 W YELLOWSTONE AVE",
    "dropphycty": "SILVERTON",
    "dropphyst": "ID",
    "dropphyzpp": 838679998,
    "dropmaladd": "102 W YELLOWSTONE AVE",
    "dropmalcty": "SILVERTON",
    "dropmalst": "ID",
    "dropmalzpp": 838679998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2087523881,
    "dropsitcph": 2087523881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12884",
    "droptype": "D",
    "dropname": "SMELTERVILLE",
    "dropdeladd": "223 MAIN ST",
    "dropdelcty": "SMELTERVILLE",
    "dropdelst": "ID",
    "dropdelzpp": 838689998,
    "dropphyadd": "223 MAIN ST",
    "dropphycty": "SMELTERVILLE",
    "dropphyst": "ID",
    "dropphyzpp": 838689998,
    "dropmaladd": "223 MAIN ST",
    "dropmalcty": "SMELTERVILLE",
    "dropmalst": "ID",
    "dropmalzpp": 838689998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2087847711,
    "dropsitcph": 2087847711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12886",
    "droptype": "D",
    "dropname": "SODA SPRINGS",
    "dropdeladd": "220 S MAIN ST",
    "dropdelcty": "SODA SPRINGS",
    "dropdelst": "ID",
    "dropdelzpp": 832769998,
    "dropphyadd": "220 S MAIN ST",
    "dropphycty": "SODA SPRINGS",
    "dropphyst": "ID",
    "dropphyzpp": 832769998,
    "dropmaladd": "220 S MAIN ST",
    "dropmalcty": "SODA SPRINGS",
    "dropmalst": "ID",
    "dropmalzpp": 832769998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2085473794,
    "dropsitcph": 2085473794,
    "dropfax": 2085474517
  },
  {
    "dcode": "D",
    "dropkey": "PZ12892",
    "droptype": "D",
    "dropname": "SPIRIT LAKE",
    "dropdeladd": "6087 W MAINE ST",
    "dropdelcty": "SPIRIT LAKE",
    "dropdelst": "ID",
    "dropdelzpp": 838699998,
    "dropphyadd": "6087 W MAINE ST",
    "dropphycty": "SPIRIT LAKE",
    "dropphyst": "ID",
    "dropphyzpp": 838699998,
    "dropmaladd": "6087 W MAINE ST",
    "dropmalcty": "SPIRIT LAKE",
    "dropmalst": "ID",
    "dropmalzpp": 838699998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2086234121,
    "dropsitcph": 2086234121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12906",
    "droptype": "D",
    "dropname": "STANLEY",
    "dropdeladd": "640 ACE OF DIAMONDS BLVD",
    "dropdelcty": "STANLEY",
    "dropdelst": "ID",
    "dropdelzpp": 832789998,
    "dropphyadd": "640 ACE OF DIAMONDS BLVD",
    "dropphycty": "STANLEY",
    "dropphyst": "ID",
    "dropphyzpp": 832789998,
    "dropmaladd": "640 ACE OF DIAMONDS BLVD",
    "dropmalcty": "STANLEY",
    "dropmalst": "ID",
    "dropmalzpp": 832789998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087742230,
    "dropsitcph": 2087742230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12907",
    "droptype": "D",
    "dropname": "STAR",
    "dropdeladd": "10780 W STATE ST",
    "dropdelcty": "STAR",
    "dropdelst": "ID",
    "dropdelzpp": 836695591,
    "dropphyadd": "10780 W STATE ST",
    "dropphycty": "STAR",
    "dropphyst": "ID",
    "dropphyzpp": 836695591,
    "dropmaladd": "10780 W STATE ST",
    "dropmalcty": "STAR",
    "dropmalst": "ID",
    "dropmalzpp": 836695591,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082867304,
    "dropsitcph": 2082867304,
    "dropfax": 2082867304
  },
  {
    "dcode": "D",
    "dropkey": "PZ12913",
    "droptype": "D",
    "dropname": "STITES",
    "dropdeladd": "212 MAIN ST",
    "dropdelcty": "STITES",
    "dropdelst": "ID",
    "dropdelzpp": 835529998,
    "dropphyadd": "212 MAIN ST",
    "dropphycty": "STITES",
    "dropphyst": "ID",
    "dropphyzpp": 835529998,
    "dropmaladd": "212 MAIN ST",
    "dropmalcty": "STITES",
    "dropmalst": "ID",
    "dropmalzpp": 835529998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089261015,
    "dropsitcph": 2089261015,
    "dropfax": 2089261009
  },
  {
    "dcode": "D",
    "dropkey": "PZ12917",
    "droptype": "D",
    "dropname": "SUGAR CITY",
    "dropdeladd": "33 E CENTER ST",
    "dropdelcty": "SUGAR CITY",
    "dropdelst": "ID",
    "dropdelzpp": 834489998,
    "dropphyadd": "33 E CENTER ST",
    "dropphycty": "SUGAR CITY",
    "dropphyst": "ID",
    "dropphyzpp": 834489998,
    "dropmaladd": "33 E CENTER ST",
    "dropmalcty": "SUGAR CITY",
    "dropmalst": "ID",
    "dropmalzpp": 834489998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083523065,
    "dropsitcph": 2083523065,
    "dropfax": 2087403019
  },
  {
    "dcode": "D",
    "dropkey": "PZ12919",
    "droptype": "D",
    "dropname": "SUN VALLEY",
    "dropdeladd": "100 SUN VALLEY RD",
    "dropdelcty": "SUN VALLEY",
    "dropdelst": "ID",
    "dropdelzpp": 833539998,
    "dropphyadd": "100 SUN VALLEY RD",
    "dropphycty": "SUN VALLEY",
    "dropphyst": "ID",
    "dropphyzpp": 833539998,
    "dropmaladd": "100 SUN VALLEY RD",
    "dropmalcty": "SUN VALLEY",
    "dropmalst": "ID",
    "dropmalzpp": 833539998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2086225265,
    "dropsitcph": 2086225265,
    "dropfax": 2086223840
  },
  {
    "dcode": "D",
    "dropkey": "PZ12923",
    "droptype": "D",
    "dropname": "SWAN VALLEY",
    "dropdeladd": "3004 SWAN VALLEY HWY",
    "dropdelcty": "SWAN VALLEY",
    "dropdelst": "ID",
    "dropdelzpp": 834499998,
    "dropphyadd": "3004 SWAN VALLEY HWY",
    "dropphycty": "SWAN VALLEY",
    "dropphyst": "ID",
    "dropphyzpp": 834499998,
    "dropmaladd": "3004 SWAN VALLEY HWY",
    "dropmalcty": "SWAN VALLEY",
    "dropmalst": "ID",
    "dropmalzpp": 834499998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087872232,
    "dropsitcph": 2084832402,
    "dropfax": 2087872232
  },
  {
    "dcode": "D",
    "dropkey": "PZ12924",
    "droptype": "D",
    "dropname": "SWAN LAKE",
    "dropdeladd": "31117 S HIGHWAY 91",
    "dropdelcty": "SWAN LAKE",
    "dropdelst": "ID",
    "dropdelzpp": 832819800,
    "dropphyadd": "31117 S HIGHWAY 91",
    "dropphycty": "SWAN LAKE",
    "dropphyst": "ID",
    "dropphyzpp": 832819800,
    "dropmaladd": "31117 S HIGHWAY 91",
    "dropmalcty": "SWAN LAKE",
    "dropmalst": "ID",
    "dropmalzpp": 832819800,
    "dropsitphn": 2083834239,
    "dropsitlph": 2088975561,
    "dropsitcph": 2088975561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12931",
    "droptype": "D",
    "dropname": "TENDOY",
    "dropdeladd": "1944 HIGHWAY 28",
    "dropdelcty": "TENDOY",
    "dropdelst": "ID",
    "dropdelzpp": 834689998,
    "dropphyadd": "1944 HIGHWAY 28",
    "dropphycty": "TENDOY",
    "dropphyst": "ID",
    "dropphyzpp": 834689998,
    "dropmaladd": "1944 HIGHWAY 28",
    "dropmalcty": "TENDOY",
    "dropmalst": "ID",
    "dropmalzpp": 834689998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087563290,
    "dropsitcph": 2087563290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12932",
    "droptype": "D",
    "dropname": "TENSED",
    "dropdeladd": "208 3RD ST",
    "dropdelcty": "TENSED",
    "dropdelst": "ID",
    "dropdelzpp": 838709998,
    "dropphyadd": "208 3RD ST",
    "dropphycty": "TENSED",
    "dropphyst": "ID",
    "dropphyzpp": 838709998,
    "dropmaladd": "208 3RD ST",
    "dropmalcty": "TENSED",
    "dropmalst": "ID",
    "dropmalzpp": 838709998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2082745551,
    "dropsitcph": 2082745551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12933",
    "droptype": "D",
    "dropname": "TERRETON",
    "dropdeladd": "1290 E 1500 N",
    "dropdelcty": "TERRETON",
    "dropdelst": "ID",
    "dropdelzpp": 834509998,
    "dropphyadd": "1290 E 1500 N",
    "dropphycty": "TERRETON",
    "dropphyst": "ID",
    "dropphyzpp": 834509998,
    "dropmaladd": "1290 E 1500 N",
    "dropmalcty": "TERRETON",
    "dropmalst": "ID",
    "dropmalzpp": 834509998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2086634627,
    "dropsitcph": 2086634627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12934",
    "droptype": "D",
    "dropname": "TETON",
    "dropdeladd": "8 E MAIN ST",
    "dropdelcty": "TETON",
    "dropdelst": "ID",
    "dropdelzpp": 834519998,
    "dropphyadd": "8 E MAIN ST",
    "dropphycty": "TETON",
    "dropphyst": "ID",
    "dropphyzpp": 834519998,
    "dropmaladd": "8 E MAIN ST",
    "dropmalcty": "TETON",
    "dropmalst": "ID",
    "dropmalzpp": 834519998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2087452015,
    "dropsitcph": 2087452015,
    "dropfax": 2087452014
  },
  {
    "dcode": "D",
    "dropkey": "PZ12935",
    "droptype": "D",
    "dropname": "TETONIA",
    "dropdeladd": "6229 S MAIN ST",
    "dropdelcty": "TETONIA",
    "dropdelst": "ID",
    "dropdelzpp": 834529998,
    "dropphyadd": "6229 S MAIN ST",
    "dropphycty": "TETONIA",
    "dropphyst": "ID",
    "dropphyzpp": 834529998,
    "dropmaladd": "6229 S MAIN ST",
    "dropmalcty": "TETONIA",
    "dropmalst": "ID",
    "dropmalzpp": 834529998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2082740774,
    "dropsitcph": 2082740774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12945",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "605 S MAIN ST",
    "dropdelcty": "TROY",
    "dropdelst": "ID",
    "dropdelzpp": 838719998,
    "dropphyadd": "605 S MAIN ST",
    "dropphycty": "TROY",
    "dropphyst": "ID",
    "dropphyzpp": 838719998,
    "dropmaladd": "605 S MAIN ST",
    "dropmalcty": "TROY",
    "dropmalst": "ID",
    "dropmalzpp": 838719998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2088359100,
    "dropsitcph": 2088359222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12949",
    "droptype": "D",
    "dropname": "TWIN FALLS",
    "dropdeladd": "253 2ND AVE W",
    "dropdelcty": "TWIN FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 833019998,
    "dropphyadd": "253 2ND AVE W",
    "dropphycty": "TWIN FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 833019998,
    "dropmaladd": "253 2ND AVE W",
    "dropmalcty": "TWIN FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 833019998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087330702,
    "dropsitcph": 2085367067,
    "dropfax": 2087325671
  },
  {
    "dcode": "D",
    "dropkey": "PZ12953",
    "droptype": "D",
    "dropname": "UCON",
    "dropdeladd": "10990 N YELLOWSTONE HWY",
    "dropdelcty": "UCON",
    "dropdelst": "ID",
    "dropdelzpp": 834549998,
    "dropphyadd": "10990 N YELLOWSTONE HWY",
    "dropphycty": "UCON",
    "dropphyst": "ID",
    "dropphyzpp": 834549998,
    "dropmaladd": "10990 N YELLOWSTONE HWY",
    "dropmalcty": "UCON",
    "dropmalst": "ID",
    "dropmalzpp": 834549998,
    "dropsitphn": 2085240203,
    "dropsitlph": 2085240203,
    "dropsitcph": 2085240203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12960",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "92 S MAIN ST",
    "dropdelcty": "VICTOR",
    "dropdelst": "ID",
    "dropdelzpp": 834559998,
    "dropphyadd": "92 S MAIN ST",
    "dropphycty": "VICTOR",
    "dropphyst": "ID",
    "dropphyzpp": 834559998,
    "dropmaladd": "92 S MAIN ST",
    "dropmalcty": "VICTOR",
    "dropmalst": "ID",
    "dropmalzpp": 834559998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2082740771,
    "dropsitcph": 2082740771,
    "dropfax": 2082740761
  },
  {
    "dcode": "D",
    "dropkey": "PZ12962",
    "droptype": "D",
    "dropname": "VIOLA",
    "dropdeladd": "1300 MAIN ST",
    "dropdelcty": "VIOLA",
    "dropdelst": "ID",
    "dropdelzpp": 838729723,
    "dropphyadd": "1300 MAIN ST",
    "dropphycty": "VIOLA",
    "dropphyst": "ID",
    "dropphyzpp": 838729723,
    "dropmaladd": "1300 MAIN ST",
    "dropmalcty": "VIOLA",
    "dropmalst": "ID",
    "dropmalzpp": 838729723,
    "dropsitphn": 5094590201,
    "dropsitlph": 2088824552,
    "dropsitcph": 2088824552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12964",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "403 CEDAR ST",
    "dropdelcty": "WALLACE",
    "dropdelst": "ID",
    "dropdelzpp": 838739998,
    "dropphyadd": "403 CEDAR ST",
    "dropphycty": "WALLACE",
    "dropphyst": "ID",
    "dropphyzpp": 838739998,
    "dropmaladd": "403 CEDAR ST",
    "dropmalcty": "WALLACE",
    "dropmalst": "ID",
    "dropmalzpp": 838739998,
    "dropsitphn": 5094590201,
    "dropsitlph": 2087533435,
    "dropsitcph": 2087533435,
    "dropfax": 2085566271
  },
  {
    "dcode": "D",
    "dropkey": "PZ12972",
    "droptype": "D",
    "dropname": "WEIPPE",
    "dropdeladd": "207 N MAIN ST",
    "dropdelcty": "WEIPPE",
    "dropdelst": "ID",
    "dropdelzpp": 835539998,
    "dropphyadd": "207 N MAIN ST",
    "dropphycty": "WEIPPE",
    "dropphyst": "ID",
    "dropphyzpp": 835539998,
    "dropmaladd": "207 N MAIN ST",
    "dropmalcty": "WEIPPE",
    "dropmalst": "ID",
    "dropmalzpp": 835539998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2084354361,
    "dropsitcph": 2084354361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12973",
    "droptype": "D",
    "dropname": "WEISER",
    "dropdeladd": "106 W MAIN ST",
    "dropdelcty": "WEISER",
    "dropdelst": "ID",
    "dropdelzpp": 836729998,
    "dropphyadd": "106 W MAIN ST",
    "dropphycty": "WEISER",
    "dropphyst": "ID",
    "dropphyzpp": 836729998,
    "dropmaladd": "106 W MAIN ST",
    "dropmalcty": "WEISER",
    "dropmalst": "ID",
    "dropmalzpp": 836729998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085490114,
    "dropsitcph": 2085490114,
    "dropfax": 2085490114
  },
  {
    "dcode": "D",
    "dropkey": "PZ12975",
    "droptype": "D",
    "dropname": "WENDELL",
    "dropdeladd": "32 N SHOSHONE ST",
    "dropdelcty": "WENDELL",
    "dropdelst": "ID",
    "dropdelzpp": 833559998,
    "dropphyadd": "32 N SHOSHONE ST",
    "dropphycty": "WENDELL",
    "dropphyst": "ID",
    "dropphyzpp": 833559998,
    "dropmaladd": "32 N SHOSHONE ST",
    "dropmalcty": "WENDELL",
    "dropmalst": "ID",
    "dropmalzpp": 833559998,
    "dropsitphn": 2083834239,
    "dropsitlph": 2085956333,
    "dropsitcph": 2085956333,
    "dropfax": 2085362171
  },
  {
    "dcode": "D",
    "dropkey": "PZ12978",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "77 W DEPOT ST",
    "dropdelcty": "WESTON",
    "dropdelst": "ID",
    "dropdelzpp": 832869998,
    "dropphyadd": "77 W DEPOT ST",
    "dropphycty": "WESTON",
    "dropphyst": "ID",
    "dropphyzpp": 832869998,
    "dropmaladd": "77 W DEPOT ST",
    "dropmalcty": "WESTON",
    "dropmalst": "ID",
    "dropmalzpp": 832869998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087473739,
    "dropsitcph": 2087473739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12980",
    "droptype": "D",
    "dropname": "WHITE BIRD",
    "dropdeladd": "255 RIVER ST",
    "dropdelcty": "WHITE BIRD",
    "dropdelst": "ID",
    "dropdelzpp": 835549998,
    "dropphyadd": "255 RIVER ST",
    "dropphycty": "WHITE BIRD",
    "dropphyst": "ID",
    "dropphyzpp": 835549998,
    "dropmaladd": "255 RIVER ST",
    "dropmalcty": "WHITE BIRD",
    "dropmalst": "ID",
    "dropmalzpp": 835549998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088392660,
    "dropsitcph": 2088392660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12983",
    "droptype": "D",
    "dropname": "WILDER",
    "dropdeladd": "109 5TH ST STE B",
    "dropdelcty": "WILDER",
    "dropdelst": "ID",
    "dropdelzpp": 836766018,
    "dropphyadd": "109 5TH ST STE B",
    "dropphycty": "WILDER",
    "dropphyst": "ID",
    "dropphyzpp": 836766018,
    "dropmaladd": "109 5TH ST STE B",
    "dropmalcty": "WILDER",
    "dropmalst": "ID",
    "dropmalzpp": 836766018,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084826525,
    "dropsitcph": 2084826525,
    "dropfax": 2084826525
  },
  {
    "dcode": "D",
    "dropkey": "PZ12985",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "318 NEZPERCE AVE",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "ID",
    "dropdelzpp": 835559998,
    "dropphyadd": "318 NEZPERCE AVE",
    "dropphycty": "WINCHESTER",
    "dropphyst": "ID",
    "dropphyzpp": 835559998,
    "dropmaladd": "318 NEZPERCE AVE",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "ID",
    "dropmalzpp": 835559998,
    "dropsitphn": 5093636210,
    "dropsitlph": 2089243600,
    "dropsitcph": 2089243600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12988",
    "droptype": "D",
    "dropname": "WORLEY",
    "dropdeladd": "29801 S 3RD ST",
    "dropdelcty": "WORLEY",
    "dropdelst": "ID",
    "dropdelzpp": 838767625,
    "dropphyadd": "29801 S 3RD ST",
    "dropphycty": "WORLEY",
    "dropphyst": "ID",
    "dropphyzpp": 838767625,
    "dropmaladd": "29801 S 3RD ST",
    "dropmalcty": "WORLEY",
    "dropmalst": "ID",
    "dropmalzpp": 838767625,
    "dropsitphn": 5094590201,
    "dropsitlph": 2086861452,
    "dropsitcph": 2086861452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12989",
    "droptype": "D",
    "dropname": "YELLOW PINE",
    "dropdeladd": "390 STIBNITE RD",
    "dropdelcty": "YELLOW PINE",
    "dropdelst": "ID",
    "dropdelzpp": 836779998,
    "dropphyadd": "390 STIBNITE RD",
    "dropphycty": "YELLOW PINE",
    "dropphyst": "ID",
    "dropphyzpp": 836779998,
    "dropmaladd": "390 STIBNITE RD",
    "dropmalcty": "YELLOW PINE",
    "dropmalst": "ID",
    "dropmalzpp": 836779998,
    "dropsitphn": 2086333677,
    "dropsitlph": 2084334080,
    "dropsitcph": 2086333677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12992",
    "droptype": "D",
    "dropname": "EBEYE",
    "dropdeladd": "1 EBEYE TOWN",
    "dropdelcty": "EBEYE",
    "dropdelst": "MH",
    "dropdelzpp": 969709997,
    "dropphyadd": "1 EBEYE TOWN",
    "dropphycty": "EBEYE",
    "dropphyst": "MH",
    "dropphyzpp": 969709997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EBEYE",
    "dropmalst": "MH",
    "dropmalzpp": 969709998,
    "dropsitphn": 6923293035,
    "dropsitlph": 6923293035,
    "dropsitcph": 6923293035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12994",
    "droptype": "D",
    "dropname": "MAJURO",
    "dropdeladd": "1 ULIGA TOWN",
    "dropdelcty": "MAJURO",
    "dropdelst": "MH",
    "dropdelzpp": 969609997,
    "dropphyadd": "1 ULIGA TOWN",
    "dropphycty": "MAJURO",
    "dropphyst": "MH",
    "dropphyzpp": 969609997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAJURO",
    "dropmalst": "MH",
    "dropmalzpp": 969609998,
    "dropsitphn": 6926253221,
    "dropsitlph": 6926253221,
    "dropsitcph": 6926253221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ12997",
    "droptype": "D",
    "dropname": "ROTA",
    "dropdeladd": "1 SONG SONG VLG",
    "dropdelcty": "ROTA",
    "dropdelst": "MP",
    "dropdelzpp": 969519997,
    "dropphyadd": "1 SONG SONG VLG",
    "dropphycty": "ROTA",
    "dropphyst": "MP",
    "dropphyzpp": 969519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROTA",
    "dropmalst": "MP",
    "dropmalzpp": 969519998,
    "dropsitphn": 8084233841,
    "dropsitlph": 6705329401,
    "dropsitcph": 6705329401,
    "dropfax": 6705323160
  },
  {
    "dcode": "D",
    "dropkey": "PZ12999",
    "droptype": "D",
    "dropname": "SAIPAN",
    "dropdeladd": "1 CHALAN KANOA VLG",
    "dropdelcty": "SAIPAN",
    "dropdelst": "MP",
    "dropdelzpp": 969509996,
    "dropphyadd": "1 CHALAN KANOA VLG",
    "dropphycty": "SAIPAN",
    "dropphyst": "MP",
    "dropphyzpp": 969509996,
    "dropmaladd": "PO BOX 509998",
    "dropmalcty": "SAIPAN",
    "dropmalst": "MP",
    "dropmalzpp": 969509998,
    "dropsitphn": 8084233841,
    "dropsitlph": 6702346270,
    "dropsitcph": 6702346270,
    "dropfax": 6702351039
  },
  {
    "dcode": "D",
    "dropkey": "PZ13006",
    "droptype": "D",
    "dropname": "ABSAROKEE",
    "dropdeladd": "25 N MONTANA AVE",
    "dropdelcty": "ABSAROKEE",
    "dropdelst": "MT",
    "dropdelzpp": 590019998,
    "dropphyadd": "25 N MONTANA AVE",
    "dropphycty": "ABSAROKEE",
    "dropphyst": "MT",
    "dropphyzpp": 590019998,
    "dropmaladd": "25 N MONTANA AVE",
    "dropmalcty": "ABSAROKEE",
    "dropmalst": "MT",
    "dropmalzpp": 590019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067033015,
    "dropsitcph": 4067033015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13009",
    "droptype": "D",
    "dropname": "ALBERTON",
    "dropdeladd": "153 RAILROAD AVE",
    "dropdelcty": "ALBERTON",
    "dropdelst": "MT",
    "dropdelzpp": 598209998,
    "dropphyadd": "153 RAILROAD AVE",
    "dropphycty": "ALBERTON",
    "dropphyst": "MT",
    "dropphyzpp": 598209998,
    "dropmaladd": "153 RAILROAD AVE",
    "dropmalcty": "ALBERTON",
    "dropmalst": "MT",
    "dropmalzpp": 598209998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067224911,
    "dropsitcph": 4067224911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13010",
    "droptype": "D",
    "dropname": "ALDER",
    "dropdeladd": "2325 MT HIGHWAY 287",
    "dropdelcty": "ALDER",
    "dropdelst": "MT",
    "dropdelzpp": 597109998,
    "dropphyadd": "2325 MT HIGHWAY 287",
    "dropphycty": "ALDER",
    "dropphyst": "MT",
    "dropphyzpp": 597109998,
    "dropmaladd": "2325 MT HIGHWAY 287",
    "dropmalcty": "ALDER",
    "dropmalst": "MT",
    "dropmalzpp": 597109998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068425331,
    "dropsitcph": 4068425331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13012",
    "droptype": "D",
    "dropname": "ALZADA",
    "dropdeladd": "13700 HIGHWAY 212",
    "dropdelcty": "ALZADA",
    "dropdelst": "MT",
    "dropdelzpp": 593119998,
    "dropphyadd": "13700 HIGHWAY 212",
    "dropphycty": "ALZADA",
    "dropphyst": "MT",
    "dropphyzpp": 593119998,
    "dropmaladd": "13700 HIGHWAY 212",
    "dropmalcty": "ALZADA",
    "dropmalst": "MT",
    "dropmalzpp": 593119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068284578,
    "dropsitcph": 4068284578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13014",
    "droptype": "D",
    "dropname": "ANACONDA",
    "dropdeladd": "218 MAIN ST",
    "dropdelcty": "ANACONDA",
    "dropdelst": "MT",
    "dropdelzpp": 597119998,
    "dropphyadd": "218 MAIN ST",
    "dropphycty": "ANACONDA",
    "dropphyst": "MT",
    "dropphyzpp": 597119998,
    "dropmaladd": "218 MAIN ST",
    "dropmalcty": "ANACONDA",
    "dropmalst": "MT",
    "dropmalzpp": 597119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065632241,
    "dropsitcph": 4065632241,
    "dropfax": 4065636840
  },
  {
    "dcode": "D",
    "dropkey": "PZ13015",
    "droptype": "D",
    "dropname": "ANGELA",
    "dropdeladd": "1 ANGELA RD S",
    "dropdelcty": "ANGELA",
    "dropdelst": "MT",
    "dropdelzpp": 593129998,
    "dropphyadd": "1 ANGELA RD S",
    "dropphycty": "ANGELA",
    "dropphyst": "MT",
    "dropphyzpp": 593129998,
    "dropmaladd": "1 ANGELA RD S",
    "dropmalcty": "ANGELA",
    "dropmalst": "MT",
    "dropmalzpp": 593129998,
    "dropsitphn": 4068132206,
    "dropsitlph": 4068132206,
    "dropsitcph": 4068132208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13016",
    "droptype": "D",
    "dropname": "ANTELOPE",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "ANTELOPE",
    "dropdelst": "MT",
    "dropdelzpp": 592119998,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "ANTELOPE",
    "dropphyst": "MT",
    "dropphyzpp": 592119998,
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "ANTELOPE",
    "dropmalst": "MT",
    "dropmalzpp": 592119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062865256,
    "dropsitcph": 4062865256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13018",
    "droptype": "D",
    "dropname": "ARLEE",
    "dropdeladd": "92441 US HIGHWAY 93",
    "dropdelcty": "ARLEE",
    "dropdelst": "MT",
    "dropdelzpp": 598219998,
    "dropphyadd": "92441 US HIGHWAY 93",
    "dropphycty": "ARLEE",
    "dropphyst": "MT",
    "dropphyzpp": 598219998,
    "dropmaladd": "92441 US HIGHWAY 93",
    "dropmalcty": "ARLEE",
    "dropmalst": "MT",
    "dropmalzpp": 598219998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067263262,
    "dropsitcph": 4067263262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13020",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "304 MAIN ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "MT",
    "dropdelzpp": 590039998,
    "dropphyadd": "304 MAIN ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "MT",
    "dropphyzpp": 590039998,
    "dropmaladd": "304 MAIN ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "MT",
    "dropmalzpp": 590039998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067842599,
    "dropsitcph": 4067842599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13021",
    "droptype": "D",
    "dropname": "AUGUSTA",
    "dropdeladd": "102 WALRATH ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "MT",
    "dropdelzpp": 594109998,
    "dropphyadd": "102 WALRATH ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "MT",
    "dropphyzpp": 594109998,
    "dropmaladd": "102 WALRATH ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "MT",
    "dropmalzpp": 594109998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068131768,
    "dropsitcph": 4068131768,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13022",
    "droptype": "D",
    "dropname": "AVON",
    "dropdeladd": "102 OLD AVON RD",
    "dropdelcty": "AVON",
    "dropdelst": "MT",
    "dropdelzpp": 597139998,
    "dropphyadd": "102 OLD AVON RD",
    "dropphycty": "AVON",
    "dropphyst": "MT",
    "dropphyzpp": 597139998,
    "dropmaladd": "102 OLD AVON RD",
    "dropmalcty": "AVON",
    "dropmalst": "MT",
    "dropmalzpp": 597139998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064926700,
    "dropsitcph": 4064926700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13023",
    "droptype": "D",
    "dropname": "BABB",
    "dropdeladd": "4016 US HIGHWAY 89",
    "dropdelcty": "BABB",
    "dropdelst": "MT",
    "dropdelzpp": 594119998,
    "dropphyadd": "4016 US HIGHWAY 89",
    "dropphycty": "BABB",
    "dropphyst": "MT",
    "dropphyzpp": 594119998,
    "dropmaladd": "4016 US HIGHWAY 89",
    "dropmalcty": "BABB",
    "dropmalst": "MT",
    "dropmalzpp": 594119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067329261,
    "dropsitcph": 4067329261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13024",
    "droptype": "D",
    "dropname": "BAINVILLE",
    "dropdeladd": "306 CLINTON AVE",
    "dropdelcty": "BAINVILLE",
    "dropdelst": "MT",
    "dropdelzpp": 592129998,
    "dropphyadd": "306 CLINTON AVE",
    "dropphycty": "BAINVILLE",
    "dropphyst": "MT",
    "dropphyzpp": 592129998,
    "dropmaladd": "306 CLINTON AVE",
    "dropmalcty": "BAINVILLE",
    "dropmalst": "MT",
    "dropmalzpp": 592129998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067421021,
    "dropsitcph": 4067421021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13025",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "130 S 1ST ST W",
    "dropdelcty": "BAKER",
    "dropdelst": "MT",
    "dropdelzpp": 593139998,
    "dropphyadd": "130 S 1ST ST W",
    "dropphycty": "BAKER",
    "dropphyst": "MT",
    "dropphyzpp": 593139998,
    "dropmaladd": "130 S 1ST ST W",
    "dropmalcty": "BAKER",
    "dropmalst": "MT",
    "dropmalzpp": 593139998,
    "dropsitphn": 4066575713,
    "dropsitlph": 8778548444,
    "dropsitcph": 8778548444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13026",
    "droptype": "D",
    "dropname": "BALLANTINE",
    "dropdeladd": "1605 ASH ST",
    "dropdelcty": "BALLANTINE",
    "dropdelst": "MT",
    "dropdelzpp": 590069998,
    "dropphyadd": "1605 ASH ST",
    "dropphycty": "BALLANTINE",
    "dropphyst": "MT",
    "dropphyzpp": 590069998,
    "dropmaladd": "1605 ASH ST",
    "dropmalcty": "BALLANTINE",
    "dropmalst": "MT",
    "dropmalzpp": 590069998,
    "dropsitphn": 4064122200,
    "dropsitlph": 4064122200,
    "dropsitcph": 4064122200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13027",
    "droptype": "D",
    "dropname": "BASIN",
    "dropdeladd": "100 BASIN ST",
    "dropdelcty": "BASIN",
    "dropdelst": "MT",
    "dropdelzpp": 596319998,
    "dropphyadd": "100 BASIN ST",
    "dropphycty": "BASIN",
    "dropphyst": "MT",
    "dropphyzpp": 596319998,
    "dropmaladd": "100 BASIN ST",
    "dropmalcty": "BASIN",
    "dropmalst": "MT",
    "dropmalzpp": 596319998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062254333,
    "dropsitcph": 4062254333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13028",
    "droptype": "D",
    "dropname": "BEARCREEK",
    "dropdeladd": "139 MAIN ST",
    "dropdelcty": "BEARCREEK",
    "dropdelst": "MT",
    "dropdelzpp": 590079998,
    "dropphyadd": "139 MAIN ST",
    "dropphycty": "BEARCREEK",
    "dropphyst": "MT",
    "dropphyzpp": 590079998,
    "dropmaladd": "139 MAIN ST",
    "dropmalcty": "BEARCREEK",
    "dropmalst": "MT",
    "dropmalzpp": 590079998,
    "dropsitphn": 4064463516,
    "dropsitlph": 4064463516,
    "dropsitcph": 4064463516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13030",
    "droptype": "D",
    "dropname": "BELFRY",
    "dropdeladd": "115 VAILL AVE",
    "dropdelcty": "BELFRY",
    "dropdelst": "MT",
    "dropdelzpp": 590089998,
    "dropphyadd": "115 VAILL AVE",
    "dropphycty": "BELFRY",
    "dropphyst": "MT",
    "dropphyzpp": 590089998,
    "dropmaladd": "115 VAILL AVE",
    "dropmalcty": "BELFRY",
    "dropmalst": "MT",
    "dropmalzpp": 590089998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066643305,
    "dropsitcph": 4066643305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13031",
    "droptype": "D",
    "dropname": "BELGRADE",
    "dropdeladd": "96 N WEAVER ST",
    "dropdelcty": "BELGRADE",
    "dropdelst": "MT",
    "dropdelzpp": 597149998,
    "dropphyadd": "96 N WEAVER ST",
    "dropphycty": "BELGRADE",
    "dropphyst": "MT",
    "dropphyzpp": 597149998,
    "dropmaladd": "96 N WEAVER ST",
    "dropmalcty": "BELGRADE",
    "dropmalst": "MT",
    "dropmalzpp": 597149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063884490,
    "dropsitcph": 4063884490,
    "dropfax": 4063882698
  },
  {
    "dcode": "D",
    "dropkey": "PZ13034",
    "droptype": "D",
    "dropname": "BELT",
    "dropdeladd": "314 BRIDGE ST",
    "dropdelcty": "BELT",
    "dropdelst": "MT",
    "dropdelzpp": 594129998,
    "dropphyadd": "314 BRIDGE ST",
    "dropphycty": "BELT",
    "dropphyst": "MT",
    "dropphyzpp": 594129998,
    "dropmaladd": "314 BRIDGE ST",
    "dropmalcty": "BELT",
    "dropmalst": "MT",
    "dropmalzpp": 594129998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064016696,
    "dropsitcph": 4064016696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13037",
    "droptype": "D",
    "dropname": "BIDDLE",
    "dropdeladd": "218 S STATE HIGHWAY 59",
    "dropdelcty": "BIDDLE",
    "dropdelst": "MT",
    "dropdelzpp": 593149998,
    "dropphyadd": "218 S STATE HIGHWAY 59",
    "dropphycty": "BIDDLE",
    "dropphyst": "MT",
    "dropphyzpp": 593149998,
    "dropmaladd": "218 S STATE HIGHWAY 59",
    "dropmalcty": "BIDDLE",
    "dropmalst": "MT",
    "dropmalzpp": 593149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064275400,
    "dropsitcph": 4064275400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13038",
    "droptype": "D",
    "dropname": "BIG ARM",
    "dropdeladd": "28541 5TH ST",
    "dropdelcty": "BIG ARM",
    "dropdelst": "MT",
    "dropdelzpp": 599109998,
    "dropphyadd": "28541 5TH ST",
    "dropphycty": "BIG ARM",
    "dropphyst": "MT",
    "dropphyzpp": 599109998,
    "dropmaladd": "28541 5TH ST",
    "dropmalcty": "BIG ARM",
    "dropmalst": "MT",
    "dropmalzpp": 599109998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068495409,
    "dropsitcph": 4068495409,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13039",
    "droptype": "D",
    "dropname": "BIG SANDY",
    "dropdeladd": "103 JOHANNES AVE",
    "dropdelcty": "BIG SANDY",
    "dropdelst": "MT",
    "dropdelzpp": 595209998,
    "dropphyadd": "103 JOHANNES AVE",
    "dropphycty": "BIG SANDY",
    "dropphyst": "MT",
    "dropphyzpp": 595209998,
    "dropmaladd": "103 JOHANNES AVE",
    "dropmalcty": "BIG SANDY",
    "dropmalst": "MT",
    "dropmalzpp": 595209998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063782296,
    "dropsitcph": 4063782296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13041",
    "droptype": "D",
    "dropname": "BIG TIMBER",
    "dropdeladd": "415 WALNUT ST",
    "dropdelcty": "BIG TIMBER",
    "dropdelst": "MT",
    "dropdelzpp": 590119998,
    "dropphyadd": "415 WALNUT ST",
    "dropphycty": "BIG TIMBER",
    "dropphyst": "MT",
    "dropphyzpp": 590119998,
    "dropmaladd": "415 WALNUT ST",
    "dropmalcty": "BIG TIMBER",
    "dropmalst": "MT",
    "dropmalzpp": 590119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069325484,
    "dropsitcph": 4069325484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13042",
    "droptype": "D",
    "dropname": "BIGFORK",
    "dropdeladd": "265 HOLT DR",
    "dropdelcty": "BIGFORK",
    "dropdelst": "MT",
    "dropdelzpp": 599119998,
    "dropphyadd": "265 HOLT DR",
    "dropphycty": "BIGFORK",
    "dropphyst": "MT",
    "dropphyzpp": 599119998,
    "dropmaladd": "265 HOLT DR",
    "dropmalcty": "BIGFORK",
    "dropmalst": "MT",
    "dropmalzpp": 599119998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068374479,
    "dropsitcph": 4068374479,
    "dropfax": 4068374406
  },
  {
    "dcode": "D",
    "dropkey": "PZ13043",
    "droptype": "D",
    "dropname": "BIGHORN",
    "dropdeladd": "138 BIGHORN RD",
    "dropdelcty": "BIGHORN",
    "dropdelst": "MT",
    "dropdelzpp": 590109998,
    "dropphyadd": "138 BIGHORN RD",
    "dropphycty": "BIGHORN",
    "dropphyst": "MT",
    "dropphyzpp": 590109998,
    "dropmaladd": "138 BIGHORN RD",
    "dropmalcty": "BIGHORN",
    "dropmalst": "MT",
    "dropmalzpp": 590109998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066235760,
    "dropsitcph": 4066235760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13046",
    "droptype": "D",
    "dropname": "BILLINGS",
    "dropdeladd": "841 S 26TH ST",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591019600,
    "dropphyadd": "841 S 26TH ST",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591019600,
    "dropmaladd": "841 S 26TH ST",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591019600,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062556455,
    "dropsitcph": 4062556455,
    "dropfax": 4062556436
  },
  {
    "dcode": "D",
    "dropkey": "PZ13048",
    "droptype": "D",
    "dropname": "BIRNEY",
    "dropdeladd": "302 COMMERCIAL ST",
    "dropdelcty": "BIRNEY",
    "dropdelst": "MT",
    "dropdelzpp": 590129998,
    "dropphyadd": "302 COMMERCIAL ST",
    "dropphycty": "BIRNEY",
    "dropphyst": "MT",
    "dropphyzpp": 590129998,
    "dropmaladd": "302 COMMERCIAL ST",
    "dropmalcty": "BIRNEY",
    "dropmalst": "MT",
    "dropmalzpp": 590129998,
    "dropsitphn": 4069846200,
    "dropsitlph": 4068132386,
    "dropsitcph": 4068132386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13051",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "2 RD 532",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "MT",
    "dropdelzpp": 593159998,
    "dropphyadd": "2 RD 532",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "MT",
    "dropphyzpp": 593159998,
    "dropmaladd": "2 RD 532",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "MT",
    "dropmalzpp": 593159998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065837537,
    "dropsitcph": 4065837537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13053",
    "droptype": "D",
    "dropname": "BONNER",
    "dropdeladd": "9389 MT HIGHWAY 200 E",
    "dropdelcty": "BONNER",
    "dropdelst": "MT",
    "dropdelzpp": 598239998,
    "dropphyadd": "9389 MT HIGHWAY 200 E",
    "dropphycty": "BONNER",
    "dropphyst": "MT",
    "dropphyzpp": 598239998,
    "dropmaladd": "9389 MT HIGHWAY 200 E",
    "dropmalcty": "BONNER",
    "dropmalst": "MT",
    "dropmalzpp": 598239998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062586591,
    "dropsitcph": 4062586591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13054",
    "droptype": "D",
    "dropname": "BOULDER",
    "dropdeladd": "126 S MAIN ST",
    "dropdelcty": "BOULDER",
    "dropdelst": "MT",
    "dropdelzpp": 596329998,
    "dropphyadd": "126 S MAIN ST",
    "dropphycty": "BOULDER",
    "dropphyst": "MT",
    "dropphyzpp": 596329998,
    "dropmaladd": "126 S MAIN ST",
    "dropmalcty": "BOULDER",
    "dropmalst": "MT",
    "dropmalzpp": 596329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062253395,
    "dropsitcph": 4062253395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13055",
    "droptype": "D",
    "dropname": "BOX ELDER",
    "dropdeladd": "40 1ST AVE SW",
    "dropdelcty": "BOX ELDER",
    "dropdelst": "MT",
    "dropdelzpp": 595219998,
    "dropphyadd": "40 1ST AVE SW",
    "dropphycty": "BOX ELDER",
    "dropphyst": "MT",
    "dropphyzpp": 595219998,
    "dropmaladd": "40 1ST AVE SW",
    "dropmalcty": "BOX ELDER",
    "dropmalst": "MT",
    "dropmalzpp": 595219998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063523195,
    "dropsitcph": 4063523195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13057",
    "droptype": "D",
    "dropname": "BOYES",
    "dropdeladd": "10203 HIGHWAY 212",
    "dropdelcty": "BOYES",
    "dropdelst": "MT",
    "dropdelzpp": 593169998,
    "dropphyadd": "10203 HIGHWAY 212",
    "dropphycty": "BOYES",
    "dropphyst": "MT",
    "dropphyzpp": 593169998,
    "dropmaladd": "10203 HIGHWAY 212",
    "dropmalcty": "BOYES",
    "dropmalst": "MT",
    "dropmalzpp": 593169998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064275333,
    "dropsitcph": 4064275333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13058",
    "droptype": "D",
    "dropname": "BOZEMAN",
    "dropdeladd": "2201 BAXTER LN",
    "dropdelcty": "BOZEMAN",
    "dropdelst": "MT",
    "dropdelzpp": 597189998,
    "dropphyadd": "2201 BAXTER LN",
    "dropphycty": "BOZEMAN",
    "dropphyst": "MT",
    "dropphyzpp": 597189998,
    "dropmaladd": "2201 BAXTER LN",
    "dropmalcty": "BOZEMAN",
    "dropmalst": "MT",
    "dropmalzpp": 597189998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065861508,
    "dropsitcph": 4065861508,
    "dropfax": 4065871103
  },
  {
    "dcode": "D",
    "dropkey": "PZ13059",
    "droptype": "D",
    "dropname": "BRADY",
    "dropdeladd": "107 CENTRAL AVE E LOWR",
    "dropdelcty": "BRADY",
    "dropdelst": "MT",
    "dropdelzpp": 594169998,
    "dropphyadd": "107 CENTRAL AVE E LOWR",
    "dropphycty": "BRADY",
    "dropphyst": "MT",
    "dropphyzpp": 594169998,
    "dropmaladd": "107 CENTRAL AVE E LOWR",
    "dropmalcty": "BRADY",
    "dropmalst": "MT",
    "dropmalzpp": 594169998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067532218,
    "dropsitcph": 4067532218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13061",
    "droptype": "D",
    "dropname": "BRIDGER",
    "dropdeladd": "113 N MAIN ST",
    "dropdelcty": "BRIDGER",
    "dropdelst": "MT",
    "dropdelzpp": 590149998,
    "dropphyadd": "113 N MAIN ST",
    "dropphycty": "BRIDGER",
    "dropphyst": "MT",
    "dropphyzpp": 590149998,
    "dropmaladd": "113 N MAIN ST",
    "dropmalcty": "BRIDGER",
    "dropmalst": "MT",
    "dropmalzpp": 590149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066623585,
    "dropsitcph": 4066623585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13062",
    "droptype": "D",
    "dropname": "BROADUS",
    "dropdeladd": "202 N LINCOLN AVE",
    "dropdelcty": "BROADUS",
    "dropdelst": "MT",
    "dropdelzpp": 593179998,
    "dropphyadd": "202 N LINCOLN AVE",
    "dropphycty": "BROADUS",
    "dropphyst": "MT",
    "dropphyzpp": 593179998,
    "dropmaladd": "202 N LINCOLN AVE",
    "dropmalcty": "BROADUS",
    "dropmalst": "MT",
    "dropmalzpp": 593179998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064362491,
    "dropsitcph": 4064362491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13063",
    "droptype": "D",
    "dropname": "BROADVIEW",
    "dropdeladd": "16713 IOWA AVE",
    "dropdelcty": "BROADVIEW",
    "dropdelst": "MT",
    "dropdelzpp": 590159998,
    "dropphyadd": "16713 IOWA AVE",
    "dropphycty": "BROADVIEW",
    "dropphyst": "MT",
    "dropphyzpp": 590159998,
    "dropmaladd": "16713 IOWA AVE",
    "dropmalcty": "BROADVIEW",
    "dropmalst": "MT",
    "dropmalzpp": 590159998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066672279,
    "dropsitcph": 4066672279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13064",
    "droptype": "D",
    "dropname": "BROCKTON",
    "dropdeladd": "701 B ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MT",
    "dropdelzpp": 592139998,
    "dropphyadd": "701 B ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "MT",
    "dropphyzpp": 592139998,
    "dropmaladd": "701 B ST",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MT",
    "dropmalzpp": 592139998,
    "dropsitphn": 4066575713,
    "dropsitlph": 6267705736,
    "dropsitcph": 6267705736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13065",
    "droptype": "D",
    "dropname": "BROCKWAY",
    "dropdeladd": "306 2ND AVE",
    "dropdelcty": "BROCKWAY",
    "dropdelst": "MT",
    "dropdelzpp": 592149998,
    "dropphyadd": "306 2ND AVE",
    "dropphycty": "BROCKWAY",
    "dropphyst": "MT",
    "dropphyzpp": 592149998,
    "dropmaladd": "306 2ND AVE",
    "dropmalcty": "BROCKWAY",
    "dropmalst": "MT",
    "dropmalzpp": 592149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064853550,
    "dropsitcph": 4064853550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13066",
    "droptype": "D",
    "dropname": "BROWNING",
    "dropdeladd": "316 N PIEGAN ST",
    "dropdelcty": "BROWNING",
    "dropdelst": "MT",
    "dropdelzpp": 594179998,
    "dropphyadd": "316 N PIEGAN ST",
    "dropphycty": "BROWNING",
    "dropphyst": "MT",
    "dropphyzpp": 594179998,
    "dropmaladd": "316 N PIEGAN ST",
    "dropmalcty": "BROWNING",
    "dropmalst": "MT",
    "dropmalzpp": 594179998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063385377,
    "dropsitcph": 4063385377,
    "dropfax": 4063385399
  },
  {
    "dcode": "D",
    "dropkey": "PZ13067",
    "droptype": "D",
    "dropname": "BRUSETT",
    "dropdeladd": "2198 BRUSETT RD",
    "dropdelcty": "BRUSETT",
    "dropdelst": "MT",
    "dropdelzpp": 593189998,
    "dropphyadd": "2198 BRUSETT RD",
    "dropphycty": "BRUSETT",
    "dropphyst": "MT",
    "dropphyzpp": 593189998,
    "dropmaladd": "2198 BRUSETT RD",
    "dropmalcty": "BRUSETT",
    "dropmalst": "MT",
    "dropmalzpp": 593189998,
    "dropsitphn": 4065576244,
    "dropsitlph": 4065576244,
    "dropsitcph": 4065576244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13068",
    "droptype": "D",
    "dropname": "BUFFALO",
    "dropdeladd": "102 2ND ST N",
    "dropdelcty": "BUFFALO",
    "dropdelst": "MT",
    "dropdelzpp": 594189998,
    "dropphyadd": "102 2ND ST N",
    "dropphycty": "BUFFALO",
    "dropphyst": "MT",
    "dropphyzpp": 594189998,
    "dropmaladd": "102 2ND ST N",
    "dropmalcty": "BUFFALO",
    "dropmalst": "MT",
    "dropmalzpp": 594189998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063742368,
    "dropsitcph": 4063742368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13069",
    "droptype": "D",
    "dropname": "BUSBY",
    "dropdeladd": "301 US HIGHWAY 212 E",
    "dropdelcty": "BUSBY",
    "dropdelst": "MT",
    "dropdelzpp": 590169998,
    "dropphyadd": "301 US HIGHWAY 212 E",
    "dropphycty": "BUSBY",
    "dropphyst": "MT",
    "dropphyzpp": 590169998,
    "dropmaladd": "301 US HIGHWAY 212 E",
    "dropmalcty": "BUSBY",
    "dropmalst": "MT",
    "dropmalzpp": 590169998,
    "dropsitphn": 4065923543,
    "dropsitlph": 4068130109,
    "dropsitcph": 4068130109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13071",
    "droptype": "D",
    "dropname": "BUTTE",
    "dropdeladd": "701 DEWEY BLVD",
    "dropdelcty": "BUTTE",
    "dropdelst": "MT",
    "dropdelzpp": 597019998,
    "dropphyadd": "701 DEWEY BLVD",
    "dropphycty": "BUTTE",
    "dropphyst": "MT",
    "dropphyzpp": 597019998,
    "dropmaladd": "701 DEWEY BLVD",
    "dropmalcty": "BUTTE",
    "dropmalst": "MT",
    "dropmalzpp": 597019998,
    "dropsitphn": 4064942107,
    "dropsitlph": 4064942107,
    "dropsitcph": 4064942107,
    "dropfax": 4064942718
  },
  {
    "dcode": "D",
    "dropkey": "PZ13072",
    "droptype": "D",
    "dropname": "BYNUM",
    "dropdeladd": "5520 HIGHWAY 89 N",
    "dropdelcty": "BYNUM",
    "dropdelst": "MT",
    "dropdelzpp": 594199998,
    "dropphyadd": "5520 HIGHWAY 89 N",
    "dropphycty": "BYNUM",
    "dropphyst": "MT",
    "dropphyzpp": 594199998,
    "dropmaladd": "5520 HIGHWAY 89 N",
    "dropmalcty": "BYNUM",
    "dropmalst": "MT",
    "dropmalzpp": 594199998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064967295,
    "dropsitcph": 4064967295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13073",
    "droptype": "D",
    "dropname": "CAMERON",
    "dropdeladd": "3787 US HIGHWAY 287 N",
    "dropdelcty": "CAMERON",
    "dropdelst": "MT",
    "dropdelzpp": 597209998,
    "dropphyadd": "3787 US HIGHWAY 287 N",
    "dropphycty": "CAMERON",
    "dropphyst": "MT",
    "dropphyzpp": 597209998,
    "dropmaladd": "3787 US HIGHWAY 287 N",
    "dropmalcty": "CAMERON",
    "dropmalst": "MT",
    "dropmalzpp": 597209998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066827605,
    "dropsitcph": 4066827605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13076",
    "droptype": "D",
    "dropname": "CARDWELL",
    "dropdeladd": "58 MT HIGHWAY 359",
    "dropdelcty": "CARDWELL",
    "dropdelst": "MT",
    "dropdelzpp": 597219998,
    "dropphyadd": "58 MT HIGHWAY 359",
    "dropphycty": "CARDWELL",
    "dropphyst": "MT",
    "dropphyzpp": 597219998,
    "dropmaladd": "58 MT HIGHWAY 359",
    "dropmalcty": "CARDWELL",
    "dropmalst": "MT",
    "dropmalzpp": 597219998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062873377,
    "dropsitcph": 4062873377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13078",
    "droptype": "D",
    "dropname": "CARTER",
    "dropdeladd": "180 2ND ST W",
    "dropdelcty": "CARTER",
    "dropdelst": "MT",
    "dropdelzpp": 594209998,
    "dropphyadd": "180 2ND ST W",
    "dropphycty": "CARTER",
    "dropphyst": "MT",
    "dropphyzpp": 594209998,
    "dropmaladd": "180 2ND ST W",
    "dropmalcty": "CARTER",
    "dropmalst": "MT",
    "dropmalzpp": 594209998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067345357,
    "dropsitcph": 4067345357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13079",
    "droptype": "D",
    "dropname": "CASCADE",
    "dropdeladd": "105 3RD AVE S",
    "dropdelcty": "CASCADE",
    "dropdelst": "MT",
    "dropdelzpp": 594219998,
    "dropphyadd": "105 3RD AVE S",
    "dropphycty": "CASCADE",
    "dropphyst": "MT",
    "dropphyzpp": 594219998,
    "dropmaladd": "105 3RD AVE S",
    "dropmalcty": "CASCADE",
    "dropmalst": "MT",
    "dropmalzpp": 594219998,
    "dropsitphn": 4064682823,
    "dropsitlph": 4064682823,
    "dropsitcph": 4064682823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13083",
    "droptype": "D",
    "dropname": "CHARLO",
    "dropdeladd": "56677 MT HIGHWAY 212",
    "dropdelcty": "CHARLO",
    "dropdelst": "MT",
    "dropdelzpp": 598249998,
    "dropphyadd": "56677 MT HIGHWAY 212",
    "dropphycty": "CHARLO",
    "dropphyst": "MT",
    "dropphyzpp": 598249998,
    "dropmaladd": "56677 MT HIGHWAY 212",
    "dropmalcty": "CHARLO",
    "dropmalst": "MT",
    "dropmalzpp": 598249998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065711049,
    "dropsitcph": 4065711049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13084",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "25 MAIN ST",
    "dropdelcty": "CHESTER",
    "dropdelst": "MT",
    "dropdelzpp": 595229998,
    "dropphyadd": "25 MAIN ST",
    "dropphycty": "CHESTER",
    "dropphyst": "MT",
    "dropphyzpp": 595229998,
    "dropmaladd": "25 MAIN ST",
    "dropmalcty": "CHESTER",
    "dropmalst": "MT",
    "dropmalzpp": 595229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067595514,
    "dropsitcph": 4067595514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13085",
    "droptype": "D",
    "dropname": "CHINOOK",
    "dropdeladd": "113 3RD ST W",
    "dropdelcty": "CHINOOK",
    "dropdelst": "MT",
    "dropdelzpp": 595239998,
    "dropphyadd": "113 3RD ST W",
    "dropphycty": "CHINOOK",
    "dropphyst": "MT",
    "dropphyzpp": 595239998,
    "dropmaladd": "113 3RD ST W",
    "dropmalcty": "CHINOOK",
    "dropmalst": "MT",
    "dropmalzpp": 595239998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064009300,
    "dropsitcph": 8778541395,
    "dropfax": 4063573189
  },
  {
    "dcode": "D",
    "dropkey": "PZ13086",
    "droptype": "D",
    "dropname": "CHOTEAU",
    "dropdeladd": "103 1ST ST NW",
    "dropdelcty": "CHOTEAU",
    "dropdelst": "MT",
    "dropdelzpp": 594229998,
    "dropphyadd": "103 1ST ST NW",
    "dropphycty": "CHOTEAU",
    "dropphyst": "MT",
    "dropphyzpp": 594229998,
    "dropmaladd": "103 1ST ST NW",
    "dropmalcty": "CHOTEAU",
    "dropmalst": "MT",
    "dropmalzpp": 594229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064662362,
    "dropsitcph": 4064662362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13087",
    "droptype": "D",
    "dropname": "CIRCLE",
    "dropdeladd": "301 8TH ST",
    "dropdelcty": "CIRCLE",
    "dropdelst": "MT",
    "dropdelzpp": 592159998,
    "dropphyadd": "301 8TH ST",
    "dropphycty": "CIRCLE",
    "dropphyst": "MT",
    "dropphyzpp": 592159998,
    "dropmaladd": "301 8TH ST",
    "dropmalcty": "CIRCLE",
    "dropmalst": "MT",
    "dropmalzpp": 592159998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064853626,
    "dropsitcph": 4064853626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13090",
    "droptype": "D",
    "dropname": "CLANCY",
    "dropdeladd": "2 N MAIN ST",
    "dropdelcty": "CLANCY",
    "dropdelst": "MT",
    "dropdelzpp": 596349998,
    "dropphyadd": "2 N MAIN ST",
    "dropphycty": "CLANCY",
    "dropphyst": "MT",
    "dropphyzpp": 596349998,
    "dropmaladd": "2 N MAIN ST",
    "dropmalcty": "CLANCY",
    "dropmalst": "MT",
    "dropmalzpp": 596349998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069335655,
    "dropsitcph": 4069335655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13091",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "20455 E MULLAN RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "MT",
    "dropdelzpp": 598259998,
    "dropphyadd": "20455 E MULLAN RD",
    "dropphycty": "CLINTON",
    "dropphyst": "MT",
    "dropphyzpp": 598259998,
    "dropmaladd": "20455 E MULLAN RD",
    "dropmalcty": "CLINTON",
    "dropmalst": "MT",
    "dropmalzpp": 598259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068254848,
    "dropsitcph": 4068254848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13092",
    "droptype": "D",
    "dropname": "CLYDE PARK",
    "dropdeladd": "103 1ST AVE N",
    "dropdelcty": "CLYDE PARK",
    "dropdelst": "MT",
    "dropdelzpp": 590189998,
    "dropphyadd": "103 1ST AVE N",
    "dropphycty": "CLYDE PARK",
    "dropphyst": "MT",
    "dropphyzpp": 590189998,
    "dropmaladd": "103 1ST AVE N",
    "dropmalcty": "CLYDE PARK",
    "dropmalst": "MT",
    "dropmalzpp": 590189998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066864940,
    "dropsitcph": 4066864940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13093",
    "droptype": "D",
    "dropname": "COFFEE CREEK",
    "dropdeladd": "115 MAIN ST",
    "dropdelcty": "COFFEE CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 594249998,
    "dropphyadd": "115 MAIN ST",
    "dropphycty": "COFFEE CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 594249998,
    "dropmaladd": "115 MAIN ST",
    "dropmalcty": "COFFEE CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 594249998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065672467,
    "dropsitcph": 4065672467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13094",
    "droptype": "D",
    "dropname": "COHAGEN",
    "dropdeladd": "5928 HIGHWAY 59 N STE 1",
    "dropdelcty": "COHAGEN",
    "dropdelst": "MT",
    "dropdelzpp": 593229998,
    "dropphyadd": "5928 HIGHWAY 59 N STE 1",
    "dropphycty": "COHAGEN",
    "dropphyst": "MT",
    "dropphyzpp": 593229998,
    "dropmaladd": "5928 HIGHWAY 59 N STE 1",
    "dropmalcty": "COHAGEN",
    "dropmalst": "MT",
    "dropmalzpp": 593229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132213,
    "dropsitcph": 6268420190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13095",
    "droptype": "D",
    "dropname": "COLSTRIP",
    "dropdeladd": "6 LOCUST ST",
    "dropdelcty": "COLSTRIP",
    "dropdelst": "MT",
    "dropdelzpp": 593239998,
    "dropphyadd": "6 LOCUST ST",
    "dropphycty": "COLSTRIP",
    "dropphyst": "MT",
    "dropphyzpp": 593239998,
    "dropmaladd": "6 LOCUST ST",
    "dropmalcty": "COLSTRIP",
    "dropmalst": "MT",
    "dropmalzpp": 593239998,
    "dropsitphn": 4067480003,
    "dropsitlph": 4067480001,
    "dropsitcph": 4067480003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13096",
    "droptype": "D",
    "dropname": "COLUMBIA FALLS",
    "dropdeladd": "65 1ST ST E",
    "dropdelcty": "COLUMBIA FALLS",
    "dropdelst": "MT",
    "dropdelzpp": 599129998,
    "dropphyadd": "65 1ST ST E",
    "dropphycty": "COLUMBIA FALLS",
    "dropphyst": "MT",
    "dropphyzpp": 599129998,
    "dropmaladd": "65 1ST ST E",
    "dropmalcty": "COLUMBIA FALLS",
    "dropmalst": "MT",
    "dropmalzpp": 599129998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068927621,
    "dropsitcph": 4068927621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13097",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "139 N PRATTEN ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MT",
    "dropdelzpp": 590199998,
    "dropphyadd": "139 N PRATTEN ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MT",
    "dropphyzpp": 590199998,
    "dropmaladd": "139 N PRATTEN ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MT",
    "dropmalzpp": 590199998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063229987,
    "dropsitcph": 4063229987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13099",
    "droptype": "D",
    "dropname": "CONDON",
    "dropdeladd": "7245 MT HIGHWAY 83",
    "dropdelcty": "CONDON",
    "dropdelst": "MT",
    "dropdelzpp": 598269998,
    "dropphyadd": "7245 MT HIGHWAY 83",
    "dropphycty": "CONDON",
    "dropphyst": "MT",
    "dropphyzpp": 598269998,
    "dropmaladd": "7245 MT HIGHWAY 83",
    "dropmalcty": "CONDON",
    "dropmalst": "MT",
    "dropmalzpp": 598269998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067542500,
    "dropsitcph": 4067542500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13100",
    "droptype": "D",
    "dropname": "CONNER",
    "dropdeladd": "157 CONNER CUTOFF RD",
    "dropdelcty": "CONNER",
    "dropdelst": "MT",
    "dropdelzpp": 598279998,
    "dropphyadd": "157 CONNER CUTOFF RD",
    "dropphycty": "CONNER",
    "dropphyst": "MT",
    "dropphyzpp": 598279998,
    "dropmaladd": "157 CONNER CUTOFF RD",
    "dropmalcty": "CONNER",
    "dropmalst": "MT",
    "dropmalzpp": 598279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068214776,
    "dropsitcph": 4068214776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13101",
    "droptype": "D",
    "dropname": "CONRAD",
    "dropdeladd": "14 5TH AVE SE",
    "dropdelcty": "CONRAD",
    "dropdelst": "MT",
    "dropdelzpp": 594259998,
    "dropphyadd": "14 5TH AVE SE",
    "dropphycty": "CONRAD",
    "dropphyst": "MT",
    "dropphyzpp": 594259998,
    "dropmaladd": "14 5TH AVE SE",
    "dropmalcty": "CONRAD",
    "dropmalst": "MT",
    "dropmalzpp": 594259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064348035,
    "dropsitcph": 4064348035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13102",
    "droptype": "D",
    "dropname": "COOKE CITY",
    "dropdeladd": "208 MAIN ST E",
    "dropdelcty": "COOKE CITY",
    "dropdelst": "MT",
    "dropdelzpp": 590209998,
    "dropphyadd": "208 MAIN ST E",
    "dropphycty": "COOKE CITY",
    "dropphyst": "MT",
    "dropphyzpp": 590209998,
    "dropmaladd": "208 MAIN ST E",
    "dropmalcty": "COOKE CITY",
    "dropmalst": "MT",
    "dropmalzpp": 590209998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068382210,
    "dropsitcph": 4068382210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13104",
    "droptype": "D",
    "dropname": "CORVALLIS",
    "dropdeladd": "1021 MAIN ST",
    "dropdelcty": "CORVALLIS",
    "dropdelst": "MT",
    "dropdelzpp": 598289998,
    "dropphyadd": "1021 MAIN ST",
    "dropphycty": "CORVALLIS",
    "dropphyst": "MT",
    "dropphyzpp": 598289998,
    "dropmaladd": "1021 MAIN ST",
    "dropmalcty": "CORVALLIS",
    "dropmalst": "MT",
    "dropmalzpp": 598289998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069613821,
    "dropsitcph": 4069613821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13107",
    "droptype": "D",
    "dropname": "CRANE",
    "dropdeladd": "117 GARFIELD AVE",
    "dropdelcty": "CRANE",
    "dropdelst": "MT",
    "dropdelzpp": 592179998,
    "dropphyadd": "117 GARFIELD AVE",
    "dropphycty": "CRANE",
    "dropphyst": "MT",
    "dropphyzpp": 592179998,
    "dropmaladd": "117 GARFIELD AVE",
    "dropmalcty": "CRANE",
    "dropmalst": "MT",
    "dropmalzpp": 592179998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064821881,
    "dropsitcph": 4064821881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13109",
    "droptype": "D",
    "dropname": "CROW AGENCY",
    "dropdeladd": "7001 E MAKAWASHA AVE",
    "dropdelcty": "CROW AGENCY",
    "dropdelst": "MT",
    "dropdelzpp": 590229998,
    "dropphyadd": "7001 E MAKAWASHA AVE",
    "dropphycty": "CROW AGENCY",
    "dropphyst": "MT",
    "dropphyzpp": 590229998,
    "dropmaladd": "7001 E MAKAWASHA AVE",
    "dropmalcty": "CROW AGENCY",
    "dropmalst": "MT",
    "dropmalzpp": 590229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066382934,
    "dropsitcph": 4066382934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13110",
    "droptype": "D",
    "dropname": "CULBERTSON",
    "dropdeladd": "21 3RD ST E",
    "dropdelcty": "CULBERTSON",
    "dropdelst": "MT",
    "dropdelzpp": 592189998,
    "dropphyadd": "21 3RD ST E",
    "dropphycty": "CULBERTSON",
    "dropphyst": "MT",
    "dropphyzpp": 592189998,
    "dropmaladd": "21 3RD ST E",
    "dropmalcty": "CULBERTSON",
    "dropmalst": "MT",
    "dropmalzpp": 592189998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132135,
    "dropsitcph": 4068132135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13112",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "413 2ND AVE",
    "dropdelcty": "CUSTER",
    "dropdelst": "MT",
    "dropdelzpp": 590249998,
    "dropphyadd": "413 2ND AVE",
    "dropphycty": "CUSTER",
    "dropphyst": "MT",
    "dropphyzpp": 590249998,
    "dropmaladd": "413 2ND AVE",
    "dropmalcty": "CUSTER",
    "dropmalst": "MT",
    "dropmalzpp": 590249998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194059,
    "dropsitcph": 4069194059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13113",
    "droptype": "D",
    "dropname": "CUT BANK",
    "dropdeladd": "37 S CENTRAL AVE",
    "dropdelcty": "CUT BANK",
    "dropdelst": "MT",
    "dropdelzpp": 594279998,
    "dropphyadd": "37 S CENTRAL AVE",
    "dropphycty": "CUT BANK",
    "dropphyst": "MT",
    "dropphyzpp": 594279998,
    "dropmaladd": "37 S CENTRAL AVE",
    "dropmalcty": "CUT BANK",
    "dropmalst": "MT",
    "dropmalzpp": 594279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068734521,
    "dropsitcph": 4068734521,
    "dropfax": 4068734069
  },
  {
    "dcode": "D",
    "dropkey": "PZ13114",
    "droptype": "D",
    "dropname": "DAGMAR",
    "dropdeladd": "205 W CENTRAL AVE",
    "dropdelcty": "DAGMAR",
    "dropdelst": "MT",
    "dropdelzpp": 592199998,
    "dropphyadd": "205 W CENTRAL AVE",
    "dropphycty": "DAGMAR",
    "dropphyst": "MT",
    "dropphyzpp": 592199998,
    "dropmaladd": "205 W CENTRAL AVE",
    "dropmalcty": "DAGMAR",
    "dropmalst": "MT",
    "dropmalzpp": 592199998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132140,
    "dropsitcph": 4068132140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13115",
    "droptype": "D",
    "dropname": "DARBY",
    "dropdeladd": "407 N MAIN ST",
    "dropdelcty": "DARBY",
    "dropdelst": "MT",
    "dropdelzpp": 598299998,
    "dropphyadd": "407 N MAIN ST",
    "dropphycty": "DARBY",
    "dropphyst": "MT",
    "dropphyzpp": 598299998,
    "dropmaladd": "407 N MAIN ST",
    "dropmalcty": "DARBY",
    "dropmalst": "MT",
    "dropmalzpp": 598299998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068213441,
    "dropsitcph": 4068213441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13116",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "43789 LAKE MARY RONAN RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "MT",
    "dropdelzpp": 599149998,
    "dropphyadd": "43789 LAKE MARY RONAN RD",
    "dropphycty": "DAYTON",
    "dropphyst": "MT",
    "dropphyzpp": 599149998,
    "dropmaladd": "43789 LAKE MARY RONAN RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "MT",
    "dropmalzpp": 599149998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068492019,
    "dropsitcph": 4068492019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13118",
    "droptype": "D",
    "dropname": "DECKER",
    "dropdeladd": "1 HIGHWAY 314",
    "dropdelcty": "DECKER",
    "dropdelst": "MT",
    "dropdelzpp": 590259998,
    "dropphyadd": "1 HIGHWAY 314",
    "dropphycty": "DECKER",
    "dropphyst": "MT",
    "dropphyzpp": 590259998,
    "dropmaladd": "1 HIGHWAY 314",
    "dropmalcty": "DECKER",
    "dropmalst": "MT",
    "dropmalzpp": 590259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067572484,
    "dropsitcph": 4067572484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13119",
    "droptype": "D",
    "dropname": "DEER LODGE",
    "dropdeladd": "510 MAIN ST",
    "dropdelcty": "DEER LODGE",
    "dropdelst": "MT",
    "dropdelzpp": 597229998,
    "dropphyadd": "510 MAIN ST",
    "dropphycty": "DEER LODGE",
    "dropphyst": "MT",
    "dropphyzpp": 597229998,
    "dropmaladd": "510 MAIN ST",
    "dropmalcty": "DEER LODGE",
    "dropmalst": "MT",
    "dropmalzpp": 597229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068461882,
    "dropsitcph": 4068461882,
    "dropfax": 4068461499
  },
  {
    "dcode": "D",
    "dropkey": "PZ13123",
    "droptype": "D",
    "dropname": "DENTON",
    "dropdeladd": "422 BROADWAY AVE",
    "dropdelcty": "DENTON",
    "dropdelst": "MT",
    "dropdelzpp": 594309998,
    "dropphyadd": "422 BROADWAY AVE",
    "dropphycty": "DENTON",
    "dropphyst": "MT",
    "dropphyzpp": 594309998,
    "dropmaladd": "422 BROADWAY AVE",
    "dropmalcty": "DENTON",
    "dropmalst": "MT",
    "dropmalzpp": 594309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065672575,
    "dropsitcph": 4065672575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13124",
    "droptype": "D",
    "dropname": "DILLON",
    "dropdeladd": "117 S IDAHO ST",
    "dropdelcty": "DILLON",
    "dropdelst": "MT",
    "dropdelzpp": 597259998,
    "dropphyadd": "117 S IDAHO ST",
    "dropphycty": "DILLON",
    "dropphyst": "MT",
    "dropphyzpp": 597259998,
    "dropmaladd": "117 S IDAHO ST",
    "dropmalcty": "DILLON",
    "dropmalst": "MT",
    "dropmalzpp": 597259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066832841,
    "dropsitcph": 4066832841,
    "dropfax": 4066836719
  },
  {
    "dcode": "D",
    "dropkey": "PZ13125",
    "droptype": "D",
    "dropname": "DIVIDE",
    "dropdeladd": "43 N RIVER RD",
    "dropdelcty": "DIVIDE",
    "dropdelst": "MT",
    "dropdelzpp": 597279998,
    "dropphyadd": "43 N RIVER RD",
    "dropphycty": "DIVIDE",
    "dropphyst": "MT",
    "dropphyzpp": 597279998,
    "dropmaladd": "43 N RIVER RD",
    "dropmalcty": "DIVIDE",
    "dropmalst": "MT",
    "dropmalzpp": 597279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062673386,
    "dropsitcph": 4062673386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13126",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "203 A ST",
    "dropdelcty": "DIXON",
    "dropdelst": "MT",
    "dropdelzpp": 598319998,
    "dropphyadd": "203 A ST",
    "dropphycty": "DIXON",
    "dropphyst": "MT",
    "dropphyzpp": 598319998,
    "dropmaladd": "203 A ST",
    "dropmalcty": "DIXON",
    "dropmalst": "MT",
    "dropmalzpp": 598319998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062463225,
    "dropsitcph": 4062463225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13127",
    "droptype": "D",
    "dropname": "DODSON",
    "dropdeladd": "300 BARRETT AVE",
    "dropdelcty": "DODSON",
    "dropdelst": "MT",
    "dropdelzpp": 595249998,
    "dropphyadd": "300 BARRETT AVE",
    "dropphycty": "DODSON",
    "dropphyst": "MT",
    "dropphyzpp": 595249998,
    "dropmaladd": "300 BARRETT AVE",
    "dropmalcty": "DODSON",
    "dropmalst": "MT",
    "dropmalzpp": 595249998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066466018,
    "dropsitcph": 4066462018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13129",
    "droptype": "D",
    "dropname": "DRUMMOND",
    "dropdeladd": "60 E BROAD ST",
    "dropdelcty": "DRUMMOND",
    "dropdelst": "MT",
    "dropdelzpp": 598329998,
    "dropphyadd": "60 E BROAD ST",
    "dropphycty": "DRUMMOND",
    "dropphyst": "MT",
    "dropphyzpp": 598329998,
    "dropmaladd": "60 E BROAD ST",
    "dropmalcty": "DRUMMOND",
    "dropmalst": "MT",
    "dropmalzpp": 598329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068131033,
    "dropsitcph": 4068131033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13130",
    "droptype": "D",
    "dropname": "DUPUYER",
    "dropdeladd": "110 MONTANA ST",
    "dropdelcty": "DUPUYER",
    "dropdelst": "MT",
    "dropdelzpp": 594329998,
    "dropphyadd": "110 MONTANA ST",
    "dropphycty": "DUPUYER",
    "dropphyst": "MT",
    "dropphyzpp": 594329998,
    "dropmaladd": "110 MONTANA ST",
    "dropmalcty": "DUPUYER",
    "dropmalst": "MT",
    "dropmalzpp": 594329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064723289,
    "dropsitcph": 4064723289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13131",
    "droptype": "D",
    "dropname": "DUTTON",
    "dropdeladd": "77 SW 1ST ST",
    "dropdelcty": "DUTTON",
    "dropdelst": "MT",
    "dropdelzpp": 594339998,
    "dropphyadd": "77 SW 1ST ST",
    "dropphycty": "DUTTON",
    "dropphyst": "MT",
    "dropphyzpp": 594339998,
    "dropmaladd": "77 SW 1ST ST",
    "dropmalcty": "DUTTON",
    "dropmalst": "MT",
    "dropmalzpp": 594339998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064761015,
    "dropsitcph": 4064761015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13133",
    "droptype": "D",
    "dropname": "EAST GLACIER PARK",
    "dropdeladd": "15 BLACKFOOT AVE",
    "dropdelcty": "EAST GLACIER PARK",
    "dropdelst": "MT",
    "dropdelzpp": 594349998,
    "dropphyadd": "15 BLACKFOOT AVE",
    "dropphycty": "EAST GLACIER PARK",
    "dropphyst": "MT",
    "dropphyzpp": 594349998,
    "dropmaladd": "15 BLACKFOOT AVE",
    "dropmalcty": "EAST GLACIER PARK",
    "dropmalst": "MT",
    "dropmalzpp": 594349998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062265534,
    "dropsitcph": 4062265534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13134",
    "droptype": "D",
    "dropname": "EAST HELENA",
    "dropdeladd": "607 E PORTER ST",
    "dropdelcty": "EAST HELENA",
    "dropdelst": "MT",
    "dropdelzpp": 596359998,
    "dropphyadd": "607 E PORTER ST",
    "dropphycty": "EAST HELENA",
    "dropphyst": "MT",
    "dropphyzpp": 596359998,
    "dropmaladd": "607 E PORTER ST",
    "dropmalcty": "EAST HELENA",
    "dropmalst": "MT",
    "dropmalzpp": 596359998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062275325,
    "dropsitcph": 4062275325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13136",
    "droptype": "D",
    "dropname": "EDGAR",
    "dropdeladd": "201 ELWELL ST",
    "dropdelcty": "EDGAR",
    "dropdelst": "MT",
    "dropdelzpp": 590269998,
    "dropphyadd": "201 ELWELL ST",
    "dropphycty": "EDGAR",
    "dropphyst": "MT",
    "dropphyzpp": 590269998,
    "dropmaladd": "201 ELWELL ST",
    "dropmalcty": "EDGAR",
    "dropmalst": "MT",
    "dropmalzpp": 590269998,
    "dropsitphn": 4069623341,
    "dropsitlph": 4069623341,
    "dropsitcph": 4069623341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13137",
    "droptype": "D",
    "dropname": "EKALAKA",
    "dropdeladd": "116 CHURCH AVE",
    "dropdelcty": "EKALAKA",
    "dropdelst": "MT",
    "dropdelzpp": 593249998,
    "dropphyadd": "116 CHURCH AVE",
    "dropphycty": "EKALAKA",
    "dropphyst": "MT",
    "dropphyzpp": 593249998,
    "dropmaladd": "116 CHURCH AVE",
    "dropmalcty": "EKALAKA",
    "dropmalst": "MT",
    "dropmalzpp": 593249998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067756474,
    "dropsitcph": 4067756474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13138",
    "droptype": "D",
    "dropname": "ELLISTON",
    "dropdeladd": "101 W FRONT ST",
    "dropdelcty": "ELLISTON",
    "dropdelst": "MT",
    "dropdelzpp": 597289998,
    "dropphyadd": "101 W FRONT ST",
    "dropphycty": "ELLISTON",
    "dropphyst": "MT",
    "dropphyzpp": 597289998,
    "dropmaladd": "101 W FRONT ST",
    "dropmalcty": "ELLISTON",
    "dropmalst": "MT",
    "dropmalzpp": 597289998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064926644,
    "dropsitcph": 4064926644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13139",
    "droptype": "D",
    "dropname": "ELMO",
    "dropdeladd": "26288 MISSOULA AVE",
    "dropdelcty": "ELMO",
    "dropdelst": "MT",
    "dropdelzpp": 599159998,
    "dropphyadd": "26288 MISSOULA AVE",
    "dropphycty": "ELMO",
    "dropphyst": "MT",
    "dropphyzpp": 599159998,
    "dropmaladd": "26288 MISSOULA AVE",
    "dropmalcty": "ELMO",
    "dropmalst": "MT",
    "dropmalzpp": 599159998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068492014,
    "dropsitcph": 4068492014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13140",
    "droptype": "D",
    "dropname": "EMIGRANT",
    "dropdeladd": "305 STORY RD",
    "dropdelcty": "EMIGRANT",
    "dropdelst": "MT",
    "dropdelzpp": 590279998,
    "dropphyadd": "305 STORY RD",
    "dropphycty": "EMIGRANT",
    "dropphyst": "MT",
    "dropphyzpp": 590279998,
    "dropmaladd": "305 STORY RD",
    "dropmalcty": "EMIGRANT",
    "dropmalst": "MT",
    "dropmalzpp": 590279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063334333,
    "dropsitcph": 4063336067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13142",
    "droptype": "D",
    "dropname": "ENNIS",
    "dropdeladd": "81 MT HIGHWAY 287",
    "dropdelcty": "ENNIS",
    "dropdelst": "MT",
    "dropdelzpp": 597299998,
    "dropphyadd": "81 MT HIGHWAY 287",
    "dropphycty": "ENNIS",
    "dropphyst": "MT",
    "dropphyzpp": 597299998,
    "dropmaladd": "81 MT HIGHWAY 287",
    "dropmalcty": "ENNIS",
    "dropmalst": "MT",
    "dropmalzpp": 597299998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066824286,
    "dropsitcph": 4066824286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13144",
    "droptype": "D",
    "dropname": "ETHRIDGE",
    "dropdeladd": "26667 US HIGHWAY 2",
    "dropdelcty": "ETHRIDGE",
    "dropdelst": "MT",
    "dropdelzpp": 594359998,
    "dropphyadd": "26667 US HIGHWAY 2",
    "dropphycty": "ETHRIDGE",
    "dropphyst": "MT",
    "dropphyzpp": 594359998,
    "dropmaladd": "26667 US HIGHWAY 2",
    "dropmalcty": "ETHRIDGE",
    "dropmalst": "MT",
    "dropmalzpp": 594359998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063392141,
    "dropsitcph": 4063392141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13145",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "113 14TH ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "MT",
    "dropdelzpp": 599179998,
    "dropphyadd": "113 14TH ST",
    "dropphycty": "EUREKA",
    "dropphyst": "MT",
    "dropphyzpp": 599179998,
    "dropmaladd": "113 14TH ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "MT",
    "dropmalzpp": 599179998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062972132,
    "dropsitcph": 4062972132,
    "dropfax": 4062975280
  },
  {
    "dcode": "D",
    "dropkey": "PZ13149",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "409 1ST AVE S",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "MT",
    "dropdelzpp": 594369998,
    "dropphyadd": "409 1ST AVE S",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "MT",
    "dropphyzpp": 594369998,
    "dropmaladd": "409 1ST AVE S",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "MT",
    "dropmalzpp": 594369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064761012,
    "dropsitcph": 4064761012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13151",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "515 S ELLERY AVE",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "MT",
    "dropdelzpp": 592219998,
    "dropphyadd": "515 S ELLERY AVE",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "MT",
    "dropphyzpp": 592219998,
    "dropmaladd": "515 S ELLERY AVE",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "MT",
    "dropmalzpp": 592219998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067425653,
    "dropsitcph": 4067425653,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13152",
    "droptype": "D",
    "dropname": "FALLON",
    "dropdeladd": "500 N RAILWAY AVE",
    "dropdelcty": "FALLON",
    "dropdelst": "MT",
    "dropdelzpp": 593269998,
    "dropphyadd": "500 N RAILWAY AVE",
    "dropphycty": "FALLON",
    "dropphyst": "MT",
    "dropphyzpp": 593269998,
    "dropmaladd": "500 N RAILWAY AVE",
    "dropmalcty": "FALLON",
    "dropmalst": "MT",
    "dropmalzpp": 593269998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066353012,
    "dropsitcph": 4066353012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13159",
    "droptype": "D",
    "dropname": "FISHTAIL",
    "dropdeladd": "200 W MAIN ST",
    "dropdelcty": "FISHTAIL",
    "dropdelst": "MT",
    "dropdelzpp": 590289998,
    "dropphyadd": "200 W MAIN ST",
    "dropphycty": "FISHTAIL",
    "dropphyst": "MT",
    "dropphyzpp": 590289998,
    "dropmaladd": "200 W MAIN ST",
    "dropmalcty": "FISHTAIL",
    "dropmalst": "MT",
    "dropmalzpp": 590289998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063284252,
    "dropsitcph": 4063284252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13160",
    "droptype": "D",
    "dropname": "FLAXVILLE",
    "dropdeladd": "101 MAIN ST",
    "dropdelcty": "FLAXVILLE",
    "dropdelst": "MT",
    "dropdelzpp": 592229998,
    "dropphyadd": "101 MAIN ST",
    "dropphycty": "FLAXVILLE",
    "dropphyst": "MT",
    "dropphyzpp": 592229998,
    "dropmaladd": "101 MAIN ST",
    "dropmalcty": "FLAXVILLE",
    "dropmalst": "MT",
    "dropmalzpp": 592229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069195850,
    "dropsitcph": 4069195850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13161",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "268 HOLLOWAY LN",
    "dropdelcty": "FLORENCE",
    "dropdelst": "MT",
    "dropdelzpp": 598339998,
    "dropphyadd": "268 HOLLOWAY LN",
    "dropphycty": "FLORENCE",
    "dropphyst": "MT",
    "dropphyzpp": 598339998,
    "dropmaladd": "268 HOLLOWAY LN",
    "dropmalcty": "FLORENCE",
    "dropmalst": "MT",
    "dropmalzpp": 598339998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062732731,
    "dropsitcph": 4062732731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13164",
    "droptype": "D",
    "dropname": "FORSYTH",
    "dropdeladd": "216 N 10TH AVE",
    "dropdelcty": "FORSYTH",
    "dropdelst": "MT",
    "dropdelzpp": 593279998,
    "dropphyadd": "216 N 10TH AVE",
    "dropphycty": "FORSYTH",
    "dropphyst": "MT",
    "dropphyzpp": 593279998,
    "dropmaladd": "216 N 10TH AVE",
    "dropmalcty": "FORSYTH",
    "dropmalst": "MT",
    "dropmalzpp": 593279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063567761,
    "dropsitcph": 4063567761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13165",
    "droptype": "D",
    "dropname": "FORT BENTON",
    "dropdeladd": "818 16TH ST",
    "dropdelcty": "FORT BENTON",
    "dropdelst": "MT",
    "dropdelzpp": 594429998,
    "dropphyadd": "818 16TH ST",
    "dropphycty": "FORT BENTON",
    "dropphyst": "MT",
    "dropphyzpp": 594429998,
    "dropmaladd": "818 16TH ST",
    "dropmalcty": "FORT BENTON",
    "dropmalst": "MT",
    "dropmalzpp": 594429998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066223613,
    "dropsitcph": 4066223613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13166",
    "droptype": "D",
    "dropname": "FORT HARRISON",
    "dropdeladd": "3687 VETERANS DR STE 145",
    "dropdelcty": "FORT HARRISON",
    "dropdelst": "MT",
    "dropdelzpp": 596369998,
    "dropphyadd": "3687 VETERANS DR STE 145",
    "dropphycty": "FORT HARRISON",
    "dropphyst": "MT",
    "dropphyzpp": 596369998,
    "dropmaladd": "3687 VETERANS DR STE 145",
    "dropmalcty": "FORT HARRISON",
    "dropmalst": "MT",
    "dropmalzpp": 596369998,
    "dropsitphn": 4064492856,
    "dropsitlph": 4064492856,
    "dropsitcph": 4064492856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13167",
    "droptype": "D",
    "dropname": "FORT PECK",
    "dropdeladd": "101 MISSOURI AVE",
    "dropdelcty": "FORT PECK",
    "dropdelst": "MT",
    "dropdelzpp": 592239998,
    "dropphyadd": "101 MISSOURI AVE",
    "dropphycty": "FORT PECK",
    "dropphyst": "MT",
    "dropphyzpp": 592239998,
    "dropmaladd": "101 MISSOURI AVE",
    "dropmalcty": "FORT PECK",
    "dropmalst": "MT",
    "dropmalzpp": 592239998,
    "dropsitphn": 4068006689,
    "dropsitlph": 4068006693,
    "dropsitcph": 4068006693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13168",
    "droptype": "D",
    "dropname": "FORT SHAW",
    "dropdeladd": "13356 MT HIGHWAY 200",
    "dropdelcty": "FORT SHAW",
    "dropdelst": "MT",
    "dropdelzpp": 594439998,
    "dropphyadd": "13356 MT HIGHWAY 200",
    "dropphycty": "FORT SHAW",
    "dropphyst": "MT",
    "dropphyzpp": 594439998,
    "dropmaladd": "13356 MT HIGHWAY 200",
    "dropmalcty": "FORT SHAW",
    "dropmalst": "MT",
    "dropmalzpp": 594439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062645496,
    "dropsitcph": 4062645496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13170",
    "droptype": "D",
    "dropname": "FORTINE",
    "dropdeladd": "170 MEADOW CREEK RD",
    "dropdelcty": "FORTINE",
    "dropdelst": "MT",
    "dropdelzpp": 599189998,
    "dropphyadd": "170 MEADOW CREEK RD",
    "dropphycty": "FORTINE",
    "dropphyst": "MT",
    "dropphyzpp": 599189998,
    "dropmaladd": "170 MEADOW CREEK RD",
    "dropmalcty": "FORTINE",
    "dropmalst": "MT",
    "dropmalzpp": 599189998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068824550,
    "dropsitcph": 4068824550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13173",
    "droptype": "D",
    "dropname": "FRAZER",
    "dropdeladd": "432 5TH ST",
    "dropdelcty": "FRAZER",
    "dropdelst": "MT",
    "dropdelzpp": 592259998,
    "dropphyadd": "432 5TH ST",
    "dropphycty": "FRAZER",
    "dropphyst": "MT",
    "dropphyzpp": 592259998,
    "dropmaladd": "432 5TH ST",
    "dropmalcty": "FRAZER",
    "dropmalst": "MT",
    "dropmalzpp": 592259998,
    "dropsitphn": 4066952299,
    "dropsitlph": 4069243261,
    "dropsitcph": 4069243261,
    "dropfax": 4066952299
  },
  {
    "dcode": "D",
    "dropkey": "PZ13174",
    "droptype": "D",
    "dropname": "FRENCHTOWN",
    "dropdeladd": "16600 BECKWITH ST",
    "dropdelcty": "FRENCHTOWN",
    "dropdelst": "MT",
    "dropdelzpp": 598349998,
    "dropphyadd": "16600 BECKWITH ST",
    "dropphycty": "FRENCHTOWN",
    "dropphyst": "MT",
    "dropphyzpp": 598349998,
    "dropmaladd": "16600 BECKWITH ST",
    "dropmalcty": "FRENCHTOWN",
    "dropmalst": "MT",
    "dropmalzpp": 598349998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066267089,
    "dropsitcph": 4066267089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13175",
    "droptype": "D",
    "dropname": "FROID",
    "dropdeladd": "111 2ND AVE S",
    "dropdelcty": "FROID",
    "dropdelst": "MT",
    "dropdelzpp": 592269998,
    "dropphyadd": "111 2ND AVE S",
    "dropphycty": "FROID",
    "dropphyst": "MT",
    "dropphyzpp": 592269998,
    "dropmaladd": "111 2ND AVE S",
    "dropmalcty": "FROID",
    "dropmalst": "MT",
    "dropmalzpp": 592269998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067662331,
    "dropsitcph": 4067662331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13176",
    "droptype": "D",
    "dropname": "FROMBERG",
    "dropdeladd": "123 W RIVER ST",
    "dropdelcty": "FROMBERG",
    "dropdelst": "MT",
    "dropdelzpp": 590299998,
    "dropphyadd": "123 W RIVER ST",
    "dropphycty": "FROMBERG",
    "dropphyst": "MT",
    "dropphyzpp": 590299998,
    "dropmaladd": "123 W RIVER ST",
    "dropmalcty": "FROMBERG",
    "dropmalst": "MT",
    "dropmalzpp": 590299998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066681027,
    "dropsitcph": 4066681027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13177",
    "droptype": "D",
    "dropname": "GALATA",
    "dropdeladd": "73 GALATA RD",
    "dropdelcty": "GALATA",
    "dropdelst": "MT",
    "dropdelzpp": 594449998,
    "dropphyadd": "73 GALATA RD",
    "dropphycty": "GALATA",
    "dropphyst": "MT",
    "dropphyzpp": 594449998,
    "dropmaladd": "73 GALATA RD",
    "dropmalcty": "GALATA",
    "dropmalst": "MT",
    "dropmalzpp": 594449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064322460,
    "dropsitcph": 4064322460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13179",
    "droptype": "D",
    "dropname": "GALLATIN GATEWAY",
    "dropdeladd": "4 RABEL LN",
    "dropdelcty": "GALLATIN GATEWAY",
    "dropdelst": "MT",
    "dropdelzpp": 597309998,
    "dropphyadd": "4 RABEL LN",
    "dropphycty": "GALLATIN GATEWAY",
    "dropphyst": "MT",
    "dropphyzpp": 597309998,
    "dropmaladd": "4 RABEL LN",
    "dropmalcty": "GALLATIN GATEWAY",
    "dropmalst": "MT",
    "dropmalzpp": 597309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067634260,
    "dropsitcph": 4067634260,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13180",
    "droptype": "D",
    "dropname": "GARDINER",
    "dropdeladd": "707 SCOTT ST W",
    "dropdelcty": "GARDINER",
    "dropdelst": "MT",
    "dropdelzpp": 590309998,
    "dropphyadd": "707 SCOTT ST W",
    "dropphycty": "GARDINER",
    "dropphyst": "MT",
    "dropphyzpp": 590309998,
    "dropmaladd": "707 SCOTT ST W",
    "dropmalcty": "GARDINER",
    "dropmalst": "MT",
    "dropmalzpp": 590309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068487579,
    "dropsitcph": 4068487579,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13183",
    "droptype": "D",
    "dropname": "GARRYOWEN",
    "dropdeladd": "4185 GARRYOWEN RD",
    "dropdelcty": "GARRYOWEN",
    "dropdelst": "MT",
    "dropdelzpp": 590319998,
    "dropphyadd": "4185 GARRYOWEN RD",
    "dropphycty": "GARRYOWEN",
    "dropphyst": "MT",
    "dropphyzpp": 590319998,
    "dropmaladd": "4185 GARRYOWEN RD",
    "dropmalcty": "GARRYOWEN",
    "dropmalst": "MT",
    "dropmalzpp": 590319998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066384401,
    "dropsitcph": 4066384401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13185",
    "droptype": "D",
    "dropname": "GERALDINE",
    "dropdeladd": "159 BROADWAY AVE W",
    "dropdelcty": "GERALDINE",
    "dropdelst": "MT",
    "dropdelzpp": 594469998,
    "dropphyadd": "159 BROADWAY AVE W",
    "dropphycty": "GERALDINE",
    "dropphyst": "MT",
    "dropphyzpp": 594469998,
    "dropmaladd": "159 BROADWAY AVE W",
    "dropmalcty": "GERALDINE",
    "dropmalst": "MT",
    "dropmalzpp": 594469998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067374472,
    "dropsitcph": 4067374472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13186",
    "droptype": "D",
    "dropname": "GEYSER",
    "dropdeladd": "110 E HILL AVE",
    "dropdelcty": "GEYSER",
    "dropdelst": "MT",
    "dropdelzpp": 594479998,
    "dropphyadd": "110 E HILL AVE",
    "dropphycty": "GEYSER",
    "dropphyst": "MT",
    "dropphyzpp": 594479998,
    "dropmaladd": "110 E HILL AVE",
    "dropmalcty": "GEYSER",
    "dropmalst": "MT",
    "dropmalzpp": 594479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067354382,
    "dropsitcph": 4067354382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13187",
    "droptype": "D",
    "dropname": "GILDFORD",
    "dropdeladd": "525 1ST AVE",
    "dropdelcty": "GILDFORD",
    "dropdelst": "MT",
    "dropdelzpp": 595259998,
    "dropphyadd": "525 1ST AVE",
    "dropphycty": "GILDFORD",
    "dropphyst": "MT",
    "dropphyzpp": 595259998,
    "dropmaladd": "525 1ST AVE",
    "dropmalcty": "GILDFORD",
    "dropmalst": "MT",
    "dropmalzpp": 595259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068086029,
    "dropsitcph": 4068086029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13188",
    "droptype": "D",
    "dropname": "GLASGOW",
    "dropdeladd": "605 2ND AVE S STE 102",
    "dropdelcty": "GLASGOW",
    "dropdelst": "MT",
    "dropdelzpp": 592309998,
    "dropphyadd": "605 2ND AVE S STE 102",
    "dropphycty": "GLASGOW",
    "dropphyst": "MT",
    "dropphyzpp": 592309998,
    "dropmaladd": "605 2ND AVE S STE 102",
    "dropmalcty": "GLASGOW",
    "dropmalst": "MT",
    "dropmalzpp": 592309998,
    "dropsitphn": 4062284342,
    "dropsitlph": 4063455690,
    "dropsitcph": 4063455690,
    "dropfax": 4063454692
  },
  {
    "dcode": "D",
    "dropkey": "PZ13190",
    "droptype": "D",
    "dropname": "GLENDIVE",
    "dropdeladd": "221 N KENDRICK AVE",
    "dropdelcty": "GLENDIVE",
    "dropdelst": "MT",
    "dropdelzpp": 593309998,
    "dropphyadd": "221 N KENDRICK AVE",
    "dropphycty": "GLENDIVE",
    "dropphyst": "MT",
    "dropphyzpp": 593309998,
    "dropmaladd": "221 N KENDRICK AVE",
    "dropmalcty": "GLENDIVE",
    "dropmalst": "MT",
    "dropmalzpp": 593309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063653373,
    "dropsitcph": 4063653373,
    "dropfax": 4063656344
  },
  {
    "dcode": "D",
    "dropkey": "PZ13196",
    "droptype": "D",
    "dropname": "GRASS RANGE",
    "dropdeladd": "614 MAIN ST",
    "dropdelcty": "GRASS RANGE",
    "dropdelst": "MT",
    "dropdelzpp": 590329998,
    "dropphyadd": "614 MAIN ST",
    "dropphycty": "GRASS RANGE",
    "dropphyst": "MT",
    "dropphyzpp": 590329998,
    "dropmaladd": "614 MAIN ST",
    "dropmalcty": "GRASS RANGE",
    "dropmalst": "MT",
    "dropmalzpp": 590329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068130308,
    "dropsitcph": 4068130308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13198",
    "droptype": "D",
    "dropname": "GREAT FALLS",
    "dropdeladd": "215 1ST AVE N",
    "dropdelcty": "GREAT FALLS",
    "dropdelst": "MT",
    "dropdelzpp": 594019998,
    "dropphyadd": "215 1ST AVE N",
    "dropphycty": "GREAT FALLS",
    "dropphyst": "MT",
    "dropphyzpp": 594019998,
    "dropmaladd": "215 1ST AVE N",
    "dropmalcty": "GREAT FALLS",
    "dropmalst": "MT",
    "dropmalzpp": 594019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067712163,
    "dropsitcph": 4067712163,
    "dropfax": 4067912570
  },
  {
    "dcode": "D",
    "dropkey": "PZ13200",
    "droptype": "D",
    "dropname": "GREYCLIFF",
    "dropdeladd": "217 A ST",
    "dropdelcty": "GREYCLIFF",
    "dropdelst": "MT",
    "dropdelzpp": 590339998,
    "dropphyadd": "217 A ST",
    "dropphycty": "GREYCLIFF",
    "dropphyst": "MT",
    "dropphyzpp": 590339998,
    "dropmaladd": "217 A ST",
    "dropmalcty": "GREYCLIFF",
    "dropmalst": "MT",
    "dropmalzpp": 590339998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069326645,
    "dropsitcph": 4069326645,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13201",
    "droptype": "D",
    "dropname": "HALL",
    "dropdeladd": "101 E MAIN ST",
    "dropdelcty": "HALL",
    "dropdelst": "MT",
    "dropdelzpp": 598379998,
    "dropphyadd": "101 E MAIN ST",
    "dropphycty": "HALL",
    "dropphyst": "MT",
    "dropphyzpp": 598379998,
    "dropmaladd": "101 E MAIN ST",
    "dropmalcty": "HALL",
    "dropmalst": "MT",
    "dropmalzpp": 598379998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062883334,
    "dropsitcph": 4062883334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13202",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "150 N 4TH ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "MT",
    "dropdelzpp": 598409998,
    "dropphyadd": "150 N 4TH ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "MT",
    "dropphyzpp": 598409998,
    "dropmaladd": "150 N 4TH ST",
    "dropmalcty": "HAMILTON",
    "dropmalst": "MT",
    "dropmalzpp": 598409998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063631445,
    "dropsitcph": 4063631445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13203",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "HAMMOND",
    "dropdelst": "MT",
    "dropdelzpp": 593329998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "HAMMOND",
    "dropphyst": "MT",
    "dropphyzpp": 593329998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "HAMMOND",
    "dropmalst": "MT",
    "dropmalzpp": 593329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064275390,
    "dropsitcph": 4064275390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13204",
    "droptype": "D",
    "dropname": "HARDIN",
    "dropdeladd": "502 N CHEYENNE AVE",
    "dropdelcty": "HARDIN",
    "dropdelst": "MT",
    "dropdelzpp": 590349998,
    "dropphyadd": "502 N CHEYENNE AVE",
    "dropphycty": "HARDIN",
    "dropphyst": "MT",
    "dropphyzpp": 590349998,
    "dropmaladd": "502 N CHEYENNE AVE",
    "dropmalcty": "HARDIN",
    "dropmalst": "MT",
    "dropmalzpp": 590349998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066235100,
    "dropsitcph": 4066235193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13205",
    "droptype": "D",
    "dropname": "HARLEM",
    "dropdeladd": "216 2ND ST SW",
    "dropdelcty": "HARLEM",
    "dropdelst": "MT",
    "dropdelzpp": 595269998,
    "dropphyadd": "216 2ND ST SW",
    "dropphycty": "HARLEM",
    "dropphyst": "MT",
    "dropphyzpp": 595269998,
    "dropmaladd": "216 2ND ST SW",
    "dropmalcty": "HARLEM",
    "dropmalst": "MT",
    "dropmalzpp": 595269998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063532593,
    "dropsitcph": 4063532593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13206",
    "droptype": "D",
    "dropname": "HARLOWTON",
    "dropdeladd": "12 1ST ST SE",
    "dropdelcty": "HARLOWTON",
    "dropdelst": "MT",
    "dropdelzpp": 590369998,
    "dropphyadd": "12 1ST ST SE",
    "dropphycty": "HARLOWTON",
    "dropphyst": "MT",
    "dropphyzpp": 590369998,
    "dropmaladd": "12 1ST ST SE",
    "dropmalcty": "HARLOWTON",
    "dropmalst": "MT",
    "dropmalzpp": 590369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066325822,
    "dropsitcph": 4066325822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13207",
    "droptype": "D",
    "dropname": "HARRISON",
    "dropdeladd": "7552 US HIGHWAY 287 N",
    "dropdelcty": "HARRISON",
    "dropdelst": "MT",
    "dropdelzpp": 597359998,
    "dropphyadd": "7552 US HIGHWAY 287 N",
    "dropphycty": "HARRISON",
    "dropphyst": "MT",
    "dropphyzpp": 597359998,
    "dropmaladd": "7552 US HIGHWAY 287 N",
    "dropmalcty": "HARRISON",
    "dropmalst": "MT",
    "dropmalzpp": 597359998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066853436,
    "dropsitcph": 4066853436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13211",
    "droptype": "D",
    "dropname": "HAVRE",
    "dropdeladd": "115 3RD ST",
    "dropdelcty": "HAVRE",
    "dropdelst": "MT",
    "dropdelzpp": 595019998,
    "dropphyadd": "115 3RD ST",
    "dropphycty": "HAVRE",
    "dropphyst": "MT",
    "dropphyzpp": 595019998,
    "dropmaladd": "115 3RD ST",
    "dropmalcty": "HAVRE",
    "dropmalst": "MT",
    "dropmalzpp": 595019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062655581,
    "dropsitcph": 4062655581,
    "dropfax": 4062656886
  },
  {
    "dcode": "D",
    "dropkey": "PZ13212",
    "droptype": "D",
    "dropname": "HAYS",
    "dropdeladd": "260 STEVENS ST",
    "dropdelcty": "HAYS",
    "dropdelst": "MT",
    "dropdelzpp": 595279998,
    "dropphyadd": "260 STEVENS ST",
    "dropphycty": "HAYS",
    "dropphyst": "MT",
    "dropphyzpp": 595279998,
    "dropmaladd": "260 STEVENS ST",
    "dropmalcty": "HAYS",
    "dropmalst": "MT",
    "dropmalzpp": 595279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006751,
    "dropsitcph": 4068006751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13213",
    "droptype": "D",
    "dropname": "HEART BUTTE",
    "dropdeladd": "22 WHITETAIL CREEK RD",
    "dropdelcty": "HEART BUTTE",
    "dropdelst": "MT",
    "dropdelzpp": 594489998,
    "dropphyadd": "22 WHITETAIL CREEK RD",
    "dropphycty": "HEART BUTTE",
    "dropphyst": "MT",
    "dropphyzpp": 594489998,
    "dropmaladd": "22 WHITETAIL CREEK RD",
    "dropmalcty": "HEART BUTTE",
    "dropmalst": "MT",
    "dropmalzpp": 594489998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063382399,
    "dropsitcph": 4063382399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13216",
    "droptype": "D",
    "dropname": "HELENA",
    "dropdeladd": "2300 N HARRIS ST",
    "dropdelcty": "HELENA",
    "dropdelst": "MT",
    "dropdelzpp": 596019998,
    "dropphyadd": "2300 N HARRIS ST",
    "dropphycty": "HELENA",
    "dropphyst": "MT",
    "dropphyzpp": 596019998,
    "dropmaladd": "2300 N HARRIS ST",
    "dropmalcty": "HELENA",
    "dropmalst": "MT",
    "dropmalzpp": 596019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064433304,
    "dropsitcph": 4064433304,
    "dropfax": 4064427946
  },
  {
    "dcode": "D",
    "dropkey": "PZ13218",
    "droptype": "D",
    "dropname": "HELMVILLE",
    "dropdeladd": "508 S MAIN ST STE 2",
    "dropdelcty": "HELMVILLE",
    "dropdelst": "MT",
    "dropdelzpp": 598439998,
    "dropphyadd": "508 S MAIN ST STE 2",
    "dropphycty": "HELMVILLE",
    "dropphyst": "MT",
    "dropphyzpp": 598439998,
    "dropmaladd": "508 S MAIN ST STE 2",
    "dropmalcty": "HELMVILLE",
    "dropmalst": "MT",
    "dropmalzpp": 598439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067935537,
    "dropsitcph": 4067935537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13219",
    "droptype": "D",
    "dropname": "HERON",
    "dropdeladd": "128 RAILROAD AVE",
    "dropdelcty": "HERON",
    "dropdelst": "MT",
    "dropdelzpp": 598449998,
    "dropphyadd": "128 RAILROAD AVE",
    "dropphycty": "HERON",
    "dropphyst": "MT",
    "dropphyzpp": 598449998,
    "dropmaladd": "128 RAILROAD AVE",
    "dropmalcty": "HERON",
    "dropmalst": "MT",
    "dropmalzpp": 598449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068475505,
    "dropsitcph": 4068475505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13222",
    "droptype": "D",
    "dropname": "HIGHWOOD",
    "dropdeladd": "164 BROADWAY AVE W",
    "dropdelcty": "HIGHWOOD",
    "dropdelst": "MT",
    "dropdelzpp": 594509998,
    "dropphyadd": "164 BROADWAY AVE W",
    "dropphycty": "HIGHWOOD",
    "dropphyst": "MT",
    "dropphyzpp": 594509998,
    "dropmaladd": "164 BROADWAY AVE W",
    "dropmalcty": "HIGHWOOD",
    "dropmalst": "MT",
    "dropmalzpp": 594509998,
    "dropsitphn": 4067335131,
    "dropsitlph": 4067335131,
    "dropsitcph": 4067335131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13223",
    "droptype": "D",
    "dropname": "HILGER",
    "dropdeladd": "39 SWOPE ST",
    "dropdelcty": "HILGER",
    "dropdelst": "MT",
    "dropdelzpp": 594519998,
    "dropphyadd": "39 SWOPE ST",
    "dropphycty": "HILGER",
    "dropphyst": "MT",
    "dropphyzpp": 594519998,
    "dropmaladd": "39 SWOPE ST",
    "dropmalcty": "HILGER",
    "dropmalst": "MT",
    "dropmalzpp": 594519998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065389355,
    "dropsitcph": 4065389355,
    "dropfax": 4065307772
  },
  {
    "dcode": "D",
    "dropkey": "PZ13224",
    "droptype": "D",
    "dropname": "HINGHAM",
    "dropdeladd": "508 2ND ST",
    "dropdelcty": "HINGHAM",
    "dropdelst": "MT",
    "dropdelzpp": 595289998,
    "dropphyadd": "508 2ND ST",
    "dropphycty": "HINGHAM",
    "dropphyst": "MT",
    "dropphyzpp": 595289998,
    "dropmaladd": "508 2ND ST",
    "dropmalcty": "HINGHAM",
    "dropmalst": "MT",
    "dropmalzpp": 595289998,
    "dropsitphn": 4063973183,
    "dropsitlph": 4068132344,
    "dropsitcph": 4068132344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13225",
    "droptype": "D",
    "dropname": "HINSDALE",
    "dropdeladd": "217 MONTANA ST",
    "dropdelcty": "HINSDALE",
    "dropdelst": "MT",
    "dropdelzpp": 592419998,
    "dropphyadd": "217 MONTANA ST",
    "dropphycty": "HINSDALE",
    "dropphyst": "MT",
    "dropphyzpp": 592419998,
    "dropmaladd": "217 MONTANA ST",
    "dropmalcty": "HINSDALE",
    "dropmalst": "MT",
    "dropmalzpp": 592419998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006696,
    "dropsitcph": 4068006696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13226",
    "droptype": "D",
    "dropname": "HOBSON",
    "dropdeladd": "109 CENTRAL AVE",
    "dropdelcty": "HOBSON",
    "dropdelst": "MT",
    "dropdelzpp": 594529998,
    "dropphyadd": "109 CENTRAL AVE",
    "dropphycty": "HOBSON",
    "dropphyst": "MT",
    "dropphyzpp": 594529998,
    "dropmaladd": "109 CENTRAL AVE",
    "dropmalcty": "HOBSON",
    "dropmalst": "MT",
    "dropmalzpp": 594529998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068130844,
    "dropsitcph": 8779072522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13227",
    "droptype": "D",
    "dropname": "HOGELAND",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "HOGELAND",
    "dropdelst": "MT",
    "dropdelzpp": 595299998,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "HOGELAND",
    "dropphyst": "MT",
    "dropphyzpp": 595299998,
    "dropmaladd": "125 MAIN ST",
    "dropmalcty": "HOGELAND",
    "dropmalst": "MT",
    "dropmalzpp": 595299998,
    "dropsitphn": 4063792244,
    "dropsitlph": 4068130792,
    "dropsitcph": 4068130792,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13229",
    "droptype": "D",
    "dropname": "HOT SPRINGS",
    "dropdeladd": "111 SPRING ST",
    "dropdelcty": "HOT SPRINGS",
    "dropdelst": "MT",
    "dropdelzpp": 598459998,
    "dropphyadd": "111 SPRING ST",
    "dropphycty": "HOT SPRINGS",
    "dropphyst": "MT",
    "dropphyzpp": 598459998,
    "dropmaladd": "111 SPRING ST",
    "dropmalcty": "HOT SPRINGS",
    "dropmalst": "MT",
    "dropmalzpp": 598459998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065711047,
    "dropsitcph": 4065711047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13231",
    "droptype": "D",
    "dropname": "HUNTLEY",
    "dropdeladd": "155 NORTHERN AVE",
    "dropdelcty": "HUNTLEY",
    "dropdelst": "MT",
    "dropdelzpp": 590379998,
    "dropphyadd": "155 NORTHERN AVE",
    "dropphycty": "HUNTLEY",
    "dropphyst": "MT",
    "dropphyzpp": 590379998,
    "dropmaladd": "155 NORTHERN AVE",
    "dropmalcty": "HUNTLEY",
    "dropmalst": "MT",
    "dropmalzpp": 590379998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063188700,
    "dropsitcph": 4063188700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13233",
    "droptype": "D",
    "dropname": "HYSHAM",
    "dropdeladd": "118 SPURLING ST",
    "dropdelcty": "HYSHAM",
    "dropdelst": "MT",
    "dropdelzpp": 590389998,
    "dropphyadd": "118 SPURLING ST",
    "dropphycty": "HYSHAM",
    "dropphyst": "MT",
    "dropphyzpp": 590389998,
    "dropmaladd": "118 SPURLING ST",
    "dropmalcty": "HYSHAM",
    "dropmalst": "MT",
    "dropmalzpp": 590389998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068131017,
    "dropsitcph": 4068131017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13234",
    "droptype": "D",
    "dropname": "INGOMAR",
    "dropdeladd": "403 1ST AVE",
    "dropdelcty": "INGOMAR",
    "dropdelst": "MT",
    "dropdelzpp": 590399000,
    "dropphyadd": "403 1ST AVE",
    "dropphycty": "INGOMAR",
    "dropphyst": "MT",
    "dropphyzpp": 590399000,
    "dropmaladd": "403 1ST AVE",
    "dropmalcty": "INGOMAR",
    "dropmalst": "MT",
    "dropmalzpp": 590399000,
    "dropsitphn": 4068130205,
    "dropsitlph": 4068130206,
    "dropsitcph": 4068130206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13235",
    "droptype": "D",
    "dropname": "INVERNESS",
    "dropdeladd": "130 MAIN ST",
    "dropdelcty": "INVERNESS",
    "dropdelst": "MT",
    "dropdelzpp": 595309998,
    "dropphyadd": "130 MAIN ST",
    "dropphycty": "INVERNESS",
    "dropphyst": "MT",
    "dropphyzpp": 595309998,
    "dropmaladd": "130 MAIN ST",
    "dropmalcty": "INVERNESS",
    "dropmalst": "MT",
    "dropmalzpp": 595309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062923891,
    "dropsitcph": 4062923891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13236",
    "droptype": "D",
    "dropname": "ISMAY",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "ISMAY",
    "dropdelst": "MT",
    "dropdelzpp": 593369998,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "ISMAY",
    "dropphyst": "MT",
    "dropphyzpp": 593369998,
    "dropmaladd": "409 MAIN ST",
    "dropmalcty": "ISMAY",
    "dropmalst": "MT",
    "dropmalzpp": 593369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067725718,
    "dropsitcph": 4067725718,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13237",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "1 JARDINE AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "MT",
    "dropdelzpp": 597369998,
    "dropphyadd": "1 JARDINE AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "MT",
    "dropphyzpp": 597369998,
    "dropmaladd": "1 JARDINE AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "MT",
    "dropmalzpp": 597369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069243197,
    "dropsitcph": 4069243197,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13239",
    "droptype": "D",
    "dropname": "JEFFERSON CITY",
    "dropdeladd": "1 N MAIN ST",
    "dropdelcty": "JEFFERSON CITY",
    "dropdelst": "MT",
    "dropdelzpp": 596389998,
    "dropphyadd": "1 N MAIN ST",
    "dropphycty": "JEFFERSON CITY",
    "dropphyst": "MT",
    "dropphyzpp": 596389998,
    "dropmaladd": "1 N MAIN ST",
    "dropmalcty": "JEFFERSON CITY",
    "dropmalst": "MT",
    "dropmalzpp": 596389998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069338551,
    "dropsitcph": 4069338551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13240",
    "droptype": "D",
    "dropname": "JOLIET",
    "dropdeladd": "120 E FRONT AVE",
    "dropdelcty": "JOLIET",
    "dropdelst": "MT",
    "dropdelzpp": 590419998,
    "dropphyadd": "120 E FRONT AVE",
    "dropphycty": "JOLIET",
    "dropphyst": "MT",
    "dropphyzpp": 590419998,
    "dropmaladd": "120 E FRONT AVE",
    "dropmalcty": "JOLIET",
    "dropmalst": "MT",
    "dropmalzpp": 590419998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069625028,
    "dropsitcph": 4069625028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13241",
    "droptype": "D",
    "dropname": "JOPLIN",
    "dropdeladd": "23 2ND ST",
    "dropdelcty": "JOPLIN",
    "dropdelst": "MT",
    "dropdelzpp": 595319998,
    "dropphyadd": "23 2ND ST",
    "dropphycty": "JOPLIN",
    "dropphyst": "MT",
    "dropphyzpp": 595319998,
    "dropmaladd": "23 2ND ST",
    "dropmalcty": "JOPLIN",
    "dropmalst": "MT",
    "dropmalzpp": 595319998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062923888,
    "dropsitcph": 4062923888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13242",
    "droptype": "D",
    "dropname": "JORDAN",
    "dropdeladd": "547 MAIN ST",
    "dropdelcty": "JORDAN",
    "dropdelst": "MT",
    "dropdelzpp": 593379998,
    "dropphyadd": "547 MAIN ST",
    "dropphycty": "JORDAN",
    "dropphyst": "MT",
    "dropphyzpp": 593379998,
    "dropmaladd": "547 MAIN ST",
    "dropmalcty": "JORDAN",
    "dropmalst": "MT",
    "dropmalzpp": 593379998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132203,
    "dropsitcph": 4068132204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13243",
    "droptype": "D",
    "dropname": "JUDITH GAP",
    "dropdeladd": "115 6TH AVE N",
    "dropdelcty": "JUDITH GAP",
    "dropdelst": "MT",
    "dropdelzpp": 594539998,
    "dropphyadd": "115 6TH AVE N",
    "dropphycty": "JUDITH GAP",
    "dropphyst": "MT",
    "dropphyzpp": 594539998,
    "dropmaladd": "115 6TH AVE N",
    "dropmalcty": "JUDITH GAP",
    "dropmalst": "MT",
    "dropmalzpp": 594539998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064732256,
    "dropsitcph": 4064732256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13246",
    "droptype": "D",
    "dropname": "KALISPELL",
    "dropdeladd": "350 N MERIDIAN RD",
    "dropdelcty": "KALISPELL",
    "dropdelst": "MT",
    "dropdelzpp": 599019998,
    "dropphyadd": "350 N MERIDIAN RD",
    "dropphycty": "KALISPELL",
    "dropphyst": "MT",
    "dropphyzpp": 599019998,
    "dropmaladd": "350 N MERIDIAN RD",
    "dropmalcty": "KALISPELL",
    "dropmalst": "MT",
    "dropmalzpp": 599019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067556450,
    "dropsitcph": 4067556450,
    "dropfax": 4067560045
  },
  {
    "dcode": "D",
    "dropkey": "PZ13247",
    "droptype": "D",
    "dropname": "KEVIN",
    "dropdeladd": "11 FRONT ST",
    "dropdelcty": "KEVIN",
    "dropdelst": "MT",
    "dropdelzpp": 594549998,
    "dropphyadd": "11 FRONT ST",
    "dropphycty": "KEVIN",
    "dropphyst": "MT",
    "dropphyzpp": 594549998,
    "dropmaladd": "11 FRONT ST",
    "dropmalcty": "KEVIN",
    "dropmalst": "MT",
    "dropmalzpp": 594549998,
    "dropsitphn": 4063375971,
    "dropsitlph": 4063373971,
    "dropsitcph": 4063373971,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13248",
    "droptype": "D",
    "dropname": "KILA",
    "dropdeladd": "345 KILA RD",
    "dropdelcty": "KILA",
    "dropdelst": "MT",
    "dropdelzpp": 599209998,
    "dropphyadd": "345 KILA RD",
    "dropphycty": "KILA",
    "dropphyst": "MT",
    "dropphyzpp": 599209998,
    "dropmaladd": "345 KILA RD",
    "dropmalcty": "KILA",
    "dropmalst": "MT",
    "dropmalzpp": 599209998,
    "dropsitphn": 4062572470,
    "dropsitlph": 4062572470,
    "dropsitcph": 4062572470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13249",
    "droptype": "D",
    "dropname": "KINSEY",
    "dropdeladd": "39 MASTIN RD",
    "dropdelcty": "KINSEY",
    "dropdelst": "MT",
    "dropdelzpp": 593389997,
    "dropphyadd": "39 MASTIN RD",
    "dropphycty": "KINSEY",
    "dropphyst": "MT",
    "dropphyzpp": 593389997,
    "dropmaladd": "39 MASTIN RD",
    "dropmalcty": "KINSEY",
    "dropmalst": "MT",
    "dropmalzpp": 593389997,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062320031,
    "dropsitcph": 4062328875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13252",
    "droptype": "D",
    "dropname": "KREMLIN",
    "dropdeladd": "210 CENTRAL AVE",
    "dropdelcty": "KREMLIN",
    "dropdelst": "MT",
    "dropdelzpp": 595329998,
    "dropphyadd": "210 CENTRAL AVE",
    "dropphycty": "KREMLIN",
    "dropphyst": "MT",
    "dropphyzpp": 595329998,
    "dropmaladd": "210 CENTRAL AVE",
    "dropmalcty": "KREMLIN",
    "dropmalst": "MT",
    "dropmalzpp": 595329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068086029,
    "dropsitcph": 4068086029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13254",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "7196 US HIGHWAY 93",
    "dropdelcty": "LAKESIDE",
    "dropdelst": "MT",
    "dropdelzpp": 599229998,
    "dropphyadd": "7196 US HIGHWAY 93",
    "dropphycty": "LAKESIDE",
    "dropphyst": "MT",
    "dropphyzpp": 599229998,
    "dropmaladd": "7196 US HIGHWAY 93",
    "dropmalcty": "LAKESIDE",
    "dropmalst": "MT",
    "dropmalzpp": 599229998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068443224,
    "dropsitcph": 4068443224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13255",
    "droptype": "D",
    "dropname": "LAMBERT",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "LAMBERT",
    "dropdelst": "MT",
    "dropdelzpp": 592439998,
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "LAMBERT",
    "dropphyst": "MT",
    "dropphyzpp": 592439998,
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "LAMBERT",
    "dropmalst": "MT",
    "dropmalzpp": 592439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066305032,
    "dropsitcph": 4066305032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13256",
    "droptype": "D",
    "dropname": "LAME DEER",
    "dropdeladd": "346 LAME DEER RD",
    "dropdelcty": "LAME DEER",
    "dropdelst": "MT",
    "dropdelzpp": 590439998,
    "dropphyadd": "346 LAME DEER RD",
    "dropphycty": "LAME DEER",
    "dropphyst": "MT",
    "dropphyzpp": 590439998,
    "dropmaladd": "346 LAME DEER RD",
    "dropmalcty": "LAME DEER",
    "dropmalst": "MT",
    "dropmalzpp": 590439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064776707,
    "dropsitcph": 4064776707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13257",
    "droptype": "D",
    "dropname": "LARSLAN",
    "dropdeladd": "101 SCHOOL RD",
    "dropdelcty": "LARSLAN",
    "dropdelst": "MT",
    "dropdelzpp": 592449998,
    "dropphyadd": "101 SCHOOL RD",
    "dropphycty": "LARSLAN",
    "dropphyst": "MT",
    "dropphyzpp": 592449998,
    "dropmaladd": "101 SCHOOL RD",
    "dropmalcty": "LARSLAN",
    "dropmalst": "MT",
    "dropmalzpp": 592449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067253303,
    "dropsitcph": 4067253303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13259",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "614 1ST AVE",
    "dropdelcty": "LAUREL",
    "dropdelst": "MT",
    "dropdelzpp": 590449998,
    "dropphyadd": "614 1ST AVE",
    "dropphycty": "LAUREL",
    "dropphyst": "MT",
    "dropphyzpp": 590449998,
    "dropmaladd": "614 1ST AVE",
    "dropmalcty": "LAUREL",
    "dropmalst": "MT",
    "dropmalzpp": 590449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066286818,
    "dropsitcph": 4066286818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13260",
    "droptype": "D",
    "dropname": "LAVINA",
    "dropdeladd": "2 MAIN ST",
    "dropdelcty": "LAVINA",
    "dropdelst": "MT",
    "dropdelzpp": 590469998,
    "dropphyadd": "2 MAIN ST",
    "dropphycty": "LAVINA",
    "dropphyst": "MT",
    "dropphyzpp": 590469998,
    "dropmaladd": "2 MAIN ST",
    "dropmalcty": "LAVINA",
    "dropmalst": "MT",
    "dropmalzpp": 590469998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066362061,
    "dropsitcph": 4066362061,
    "dropfax": 4066362087
  },
  {
    "dcode": "D",
    "dropkey": "PZ13263",
    "droptype": "D",
    "dropname": "LEWISTOWN",
    "dropdeladd": "204 3RD AVE N",
    "dropdelcty": "LEWISTOWN",
    "dropdelst": "MT",
    "dropdelzpp": 594579998,
    "dropphyadd": "204 3RD AVE N",
    "dropphycty": "LEWISTOWN",
    "dropphyst": "MT",
    "dropphyzpp": 594579998,
    "dropmaladd": "204 3RD AVE N",
    "dropmalcty": "LEWISTOWN",
    "dropmalst": "MT",
    "dropmalzpp": 594579998,
    "dropsitphn": 4069686012,
    "dropsitlph": 4069686012,
    "dropsitcph": 4069686012,
    "dropfax": 4065386461
  },
  {
    "dcode": "D",
    "dropkey": "PZ13264",
    "droptype": "D",
    "dropname": "LIBBY",
    "dropdeladd": "518 MAIN AVE",
    "dropdelcty": "LIBBY",
    "dropdelst": "MT",
    "dropdelzpp": 599239998,
    "dropphyadd": "518 MAIN AVE",
    "dropphycty": "LIBBY",
    "dropphyst": "MT",
    "dropphyzpp": 599239998,
    "dropmaladd": "518 MAIN AVE",
    "dropmalcty": "LIBBY",
    "dropmalst": "MT",
    "dropmalzpp": 599239998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062934184,
    "dropsitcph": 4062934184,
    "dropfax": 4062935673
  },
  {
    "dcode": "D",
    "dropkey": "PZ13265",
    "droptype": "D",
    "dropname": "LIMA",
    "dropdeladd": "700 PEAT ST",
    "dropdelcty": "LIMA",
    "dropdelst": "MT",
    "dropdelzpp": 597399998,
    "dropphyadd": "700 PEAT ST",
    "dropphycty": "LIMA",
    "dropphyst": "MT",
    "dropphyzpp": 597399998,
    "dropmaladd": "700 PEAT ST",
    "dropmalcty": "LIMA",
    "dropmalst": "MT",
    "dropmalzpp": 597399998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062763515,
    "dropsitcph": 4062763515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13266",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "237 MAIN ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "MT",
    "dropdelzpp": 596399998,
    "dropphyadd": "237 MAIN ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "MT",
    "dropphyzpp": 596399998,
    "dropmaladd": "237 MAIN ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "MT",
    "dropmalzpp": 596399998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063624523,
    "dropsitcph": 4063624523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13267",
    "droptype": "D",
    "dropname": "LINDSAY",
    "dropdeladd": "2117 FAS 470",
    "dropdelcty": "LINDSAY",
    "dropdelst": "MT",
    "dropdelzpp": 593399998,
    "dropphyadd": "2117 FAS 470",
    "dropphycty": "LINDSAY",
    "dropphyst": "MT",
    "dropphyzpp": 593399998,
    "dropmaladd": "2117 FAS 470",
    "dropmalcty": "LINDSAY",
    "dropmalst": "MT",
    "dropmalzpp": 593399998,
    "dropsitphn": 4065847402,
    "dropsitlph": 4065847402,
    "dropsitcph": 4065847402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13268",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "105 N 2ND ST FL 1",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "MT",
    "dropdelzpp": 590479998,
    "dropphyadd": "105 N 2ND ST FL 1",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "MT",
    "dropphyzpp": 590479998,
    "dropmaladd": "105 N 2ND ST FL 1",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "MT",
    "dropmalzpp": 590479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062220912,
    "dropsitcph": 4062220912,
    "dropfax": 4062224633
  },
  {
    "dcode": "D",
    "dropkey": "PZ13271",
    "droptype": "D",
    "dropname": "LODGE GRASS",
    "dropdeladd": "14 S MAIN ST",
    "dropdelcty": "LODGE GRASS",
    "dropdelst": "MT",
    "dropdelzpp": 590509998,
    "dropphyadd": "14 S MAIN ST",
    "dropphycty": "LODGE GRASS",
    "dropphyst": "MT",
    "dropphyzpp": 590509998,
    "dropmaladd": "14 S MAIN ST",
    "dropmalcty": "LODGE GRASS",
    "dropmalst": "MT",
    "dropmalzpp": 590509998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066023978,
    "dropsitcph": 4066023978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13272",
    "droptype": "D",
    "dropname": "LOLO",
    "dropdeladd": "11815 LEWIS CLARK DR",
    "dropdelcty": "LOLO",
    "dropdelst": "MT",
    "dropdelzpp": 598479998,
    "dropphyadd": "11815 LEWIS CLARK DR",
    "dropphycty": "LOLO",
    "dropphyst": "MT",
    "dropphyzpp": 598479998,
    "dropmaladd": "11815 LEWIS CLARK DR",
    "dropmalcty": "LOLO",
    "dropmalst": "MT",
    "dropmalzpp": 598479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062732251,
    "dropsitcph": 4064192644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13273",
    "droptype": "D",
    "dropname": "LOMA",
    "dropdeladd": "111 2ND AVE",
    "dropdelcty": "LOMA",
    "dropdelst": "MT",
    "dropdelzpp": 594609998,
    "dropphyadd": "111 2ND AVE",
    "dropphycty": "LOMA",
    "dropphyst": "MT",
    "dropphyzpp": 594609998,
    "dropmaladd": "111 2ND AVE",
    "dropmalcty": "LOMA",
    "dropmalst": "MT",
    "dropmalzpp": 594609998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067394222,
    "dropsitcph": 4067394222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13275",
    "droptype": "D",
    "dropname": "LORING",
    "dropdeladd": "93 MAIN ST",
    "dropdelcty": "LORING",
    "dropdelst": "MT",
    "dropdelzpp": 595379998,
    "dropphyadd": "93 MAIN ST",
    "dropphycty": "LORING",
    "dropphyst": "MT",
    "dropphyzpp": 595379998,
    "dropmaladd": "93 MAIN ST",
    "dropmalcty": "LORING",
    "dropmalst": "MT",
    "dropmalzpp": 595379998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006755,
    "dropsitcph": 4068006755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13281",
    "droptype": "D",
    "dropname": "MALTA",
    "dropdeladd": "207 S 1ST AVE E",
    "dropdelcty": "MALTA",
    "dropdelst": "MT",
    "dropdelzpp": 595389998,
    "dropphyadd": "207 S 1ST AVE E",
    "dropphycty": "MALTA",
    "dropphyst": "MT",
    "dropphyzpp": 595389998,
    "dropmaladd": "207 S 1ST AVE E",
    "dropmalcty": "MALTA",
    "dropmalst": "MT",
    "dropmalzpp": 595389998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006557,
    "dropsitcph": 4068006557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13282",
    "droptype": "D",
    "dropname": "MANHATTAN",
    "dropdeladd": "201 E RAILROAD AVE N",
    "dropdelcty": "MANHATTAN",
    "dropdelst": "MT",
    "dropdelzpp": 597419998,
    "dropphyadd": "201 E RAILROAD AVE N",
    "dropphycty": "MANHATTAN",
    "dropphyst": "MT",
    "dropphyzpp": 597419998,
    "dropmaladd": "201 E RAILROAD AVE N",
    "dropmalcty": "MANHATTAN",
    "dropmalst": "MT",
    "dropmalzpp": 597419998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062846585,
    "dropsitcph": 4062846585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13283",
    "droptype": "D",
    "dropname": "MARION",
    "dropdeladd": "365 PLEASANT VALLEY RD",
    "dropdelcty": "MARION",
    "dropdelst": "MT",
    "dropdelzpp": 599259998,
    "dropphyadd": "365 PLEASANT VALLEY RD",
    "dropphycty": "MARION",
    "dropphyst": "MT",
    "dropphyzpp": 599259998,
    "dropmaladd": "365 PLEASANT VALLEY RD",
    "dropmalcty": "MARION",
    "dropmalst": "MT",
    "dropmalzpp": 599259998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068542282,
    "dropsitcph": 4068542282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13285",
    "droptype": "D",
    "dropname": "MARTINSDALE",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "MARTINSDALE",
    "dropdelst": "MT",
    "dropdelzpp": 590539998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "MARTINSDALE",
    "dropphyst": "MT",
    "dropphyzpp": 590539998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "MARTINSDALE",
    "dropmalst": "MT",
    "dropmalzpp": 590539998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065723633,
    "dropsitcph": 4065723633,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13287",
    "droptype": "D",
    "dropname": "MC ALLISTER",
    "dropdeladd": "5557 US HIGHWAY 287",
    "dropdelcty": "MC ALLISTER",
    "dropdelst": "MT",
    "dropdelzpp": 597409998,
    "dropphyadd": "5557 US HIGHWAY 287",
    "dropphycty": "MC ALLISTER",
    "dropphyst": "MT",
    "dropphyzpp": 597409998,
    "dropmaladd": "5557 US HIGHWAY 287",
    "dropmalcty": "MC ALLISTER",
    "dropmalst": "MT",
    "dropmalzpp": 597409998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066824503,
    "dropsitcph": 4066824503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13289",
    "droptype": "D",
    "dropname": "MC LEOD",
    "dropdeladd": "18 MCLEOD MAIN ST",
    "dropdelcty": "MC LEOD",
    "dropdelst": "MT",
    "dropdelzpp": 590529998,
    "dropphyadd": "18 MCLEOD MAIN ST",
    "dropphycty": "MC LEOD",
    "dropphyst": "MT",
    "dropphyzpp": 590529998,
    "dropmaladd": "18 MCLEOD MAIN ST",
    "dropmalcty": "MC LEOD",
    "dropmalst": "MT",
    "dropmalzpp": 590529998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069324096,
    "dropsitcph": 4069324096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13293",
    "droptype": "D",
    "dropname": "MEDICINE LAKE",
    "dropdeladd": "107 2ND AVE N",
    "dropdelcty": "MEDICINE LAKE",
    "dropdelst": "MT",
    "dropdelzpp": 592479998,
    "dropphyadd": "107 2ND AVE N",
    "dropphycty": "MEDICINE LAKE",
    "dropphyst": "MT",
    "dropphyzpp": 592479998,
    "dropmaladd": "107 2ND AVE N",
    "dropmalcty": "MEDICINE LAKE",
    "dropmalst": "MT",
    "dropmalzpp": 592479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067892491,
    "dropsitcph": 4067892491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13294",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "228 MAIN ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "MT",
    "dropdelzpp": 597439998,
    "dropphyadd": "228 MAIN ST",
    "dropphycty": "MELROSE",
    "dropphyst": "MT",
    "dropphyzpp": 597439998,
    "dropmaladd": "228 MAIN ST",
    "dropmalcty": "MELROSE",
    "dropmalst": "MT",
    "dropmalzpp": 597439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068352851,
    "dropsitcph": 4068352851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13295",
    "droptype": "D",
    "dropname": "MELSTONE",
    "dropdeladd": "310 1ST ST W",
    "dropdelcty": "MELSTONE",
    "dropdelst": "MT",
    "dropdelzpp": 590549998,
    "dropphyadd": "310 1ST ST W",
    "dropphycty": "MELSTONE",
    "dropphyst": "MT",
    "dropphyzpp": 590549998,
    "dropmaladd": "310 1ST ST W",
    "dropmalcty": "MELSTONE",
    "dropmalst": "MT",
    "dropmalzpp": 590549998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063582381,
    "dropsitcph": 4063582381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13296",
    "droptype": "D",
    "dropname": "MELVILLE",
    "dropdeladd": "7 JABS RD",
    "dropdelcty": "MELVILLE",
    "dropdelst": "MT",
    "dropdelzpp": 590559998,
    "dropphyadd": "7 JABS RD",
    "dropphycty": "MELVILLE",
    "dropphyst": "MT",
    "dropphyzpp": 590559998,
    "dropmaladd": "7 JABS RD",
    "dropmalcty": "MELVILLE",
    "dropmalst": "MT",
    "dropmalzpp": 590559998,
    "dropsitphn": 4065374505,
    "dropsitlph": 4065374422,
    "dropsitcph": 4065374422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13299",
    "droptype": "D",
    "dropname": "MILES CITY",
    "dropdeladd": "106 N 7TH ST",
    "dropdelcty": "MILES CITY",
    "dropdelst": "MT",
    "dropdelzpp": 593019998,
    "dropphyadd": "106 N 7TH ST",
    "dropphycty": "MILES CITY",
    "dropphyst": "MT",
    "dropphyzpp": 593019998,
    "dropmaladd": "106 N 7TH ST",
    "dropmalcty": "MILES CITY",
    "dropmalst": "MT",
    "dropmalzpp": 593019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062322586,
    "dropsitcph": 4062322586,
    "dropfax": 4062321429
  },
  {
    "dcode": "D",
    "dropkey": "PZ13301",
    "droptype": "D",
    "dropname": "MILLTOWN",
    "dropdeladd": "7298 MT HIGHWAY 200 E",
    "dropdelcty": "MILLTOWN",
    "dropdelst": "MT",
    "dropdelzpp": 598519998,
    "dropphyadd": "7298 MT HIGHWAY 200 E",
    "dropphycty": "MILLTOWN",
    "dropphyst": "MT",
    "dropphyzpp": 598519998,
    "dropmaladd": "7298 MT HIGHWAY 200 E",
    "dropmalcty": "MILLTOWN",
    "dropmalst": "MT",
    "dropmalzpp": 598519998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065081005,
    "dropsitcph": 4065081005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13304",
    "droptype": "D",
    "dropname": "MISSOULA",
    "dropdeladd": "1100 W KENT AVE",
    "dropdelcty": "MISSOULA",
    "dropdelst": "MT",
    "dropdelzpp": 598019998,
    "dropphyadd": "1100 W KENT AVE",
    "dropphycty": "MISSOULA",
    "dropphyst": "MT",
    "dropphyzpp": 598019998,
    "dropmaladd": "1100 W KENT AVE",
    "dropmalcty": "MISSOULA",
    "dropmalst": "MT",
    "dropmalzpp": 598019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063292233,
    "dropsitcph": 4063292233,
    "dropfax": 4063292280
  },
  {
    "dcode": "D",
    "dropkey": "PZ13305",
    "droptype": "D",
    "dropname": "MOCCASIN",
    "dropdeladd": "202 1ST AVE W",
    "dropdelcty": "MOCCASIN",
    "dropdelst": "MT",
    "dropdelzpp": 594629998,
    "dropphyadd": "202 1ST AVE W",
    "dropphycty": "MOCCASIN",
    "dropphyst": "MT",
    "dropphyzpp": 594629998,
    "dropmaladd": "202 1ST AVE W",
    "dropmalcty": "MOCCASIN",
    "dropmalst": "MT",
    "dropmalzpp": 594629998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067076012,
    "dropsitcph": 4067076012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13307",
    "droptype": "D",
    "dropname": "MOLT",
    "dropdeladd": "118 WOLFSKILL AVE",
    "dropdelcty": "MOLT",
    "dropdelst": "MT",
    "dropdelzpp": 590579998,
    "dropphyadd": "118 WOLFSKILL AVE",
    "dropphycty": "MOLT",
    "dropphyst": "MT",
    "dropphyzpp": 590579998,
    "dropmaladd": "118 WOLFSKILL AVE",
    "dropmalcty": "MOLT",
    "dropmalst": "MT",
    "dropmalzpp": 590579998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066693296,
    "dropsitcph": 4066693296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13308",
    "droptype": "D",
    "dropname": "MONARCH",
    "dropdeladd": "15 MISSOULA AVE",
    "dropdelcty": "MONARCH",
    "dropdelst": "MT",
    "dropdelzpp": 594639998,
    "dropphyadd": "15 MISSOULA AVE",
    "dropphycty": "MONARCH",
    "dropphyst": "MT",
    "dropphyzpp": 594639998,
    "dropmaladd": "15 MISSOULA AVE",
    "dropmalcty": "MONARCH",
    "dropmalst": "MT",
    "dropmalzpp": 594639998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132346,
    "dropsitcph": 4068132346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13312",
    "droptype": "D",
    "dropname": "MOORE",
    "dropdeladd": "201 FERGUS AVE",
    "dropdelcty": "MOORE",
    "dropdelst": "MT",
    "dropdelzpp": 594649998,
    "dropphyadd": "201 FERGUS AVE",
    "dropphycty": "MOORE",
    "dropphyst": "MT",
    "dropphyzpp": 594649998,
    "dropmaladd": "201 FERGUS AVE",
    "dropmalcty": "MOORE",
    "dropmalst": "MT",
    "dropmalzpp": 594649998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063742532,
    "dropsitcph": 4063742532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13315",
    "droptype": "D",
    "dropname": "MUSSELSHELL",
    "dropdeladd": "17 S MUSSELSHELL RD",
    "dropdelcty": "MUSSELSHELL",
    "dropdelst": "MT",
    "dropdelzpp": 590599998,
    "dropphyadd": "17 S MUSSELSHELL RD",
    "dropphycty": "MUSSELSHELL",
    "dropphyst": "MT",
    "dropphyzpp": 590599998,
    "dropmaladd": "17 S MUSSELSHELL RD",
    "dropmalcty": "MUSSELSHELL",
    "dropmalst": "MT",
    "dropmalzpp": 590599998,
    "dropsitphn": 4066575713,
    "dropsitlph": 8778541927,
    "dropsitcph": 8778547927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13317",
    "droptype": "D",
    "dropname": "NASHUA",
    "dropdeladd": "1005 FRONT ST",
    "dropdelcty": "NASHUA",
    "dropdelst": "MT",
    "dropdelzpp": 592489998,
    "dropphyadd": "1005 FRONT ST",
    "dropphycty": "NASHUA",
    "dropphyst": "MT",
    "dropphyzpp": 592489998,
    "dropmaladd": "1005 FRONT ST",
    "dropmalcty": "NASHUA",
    "dropmalst": "MT",
    "dropmalzpp": 592489998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006585,
    "dropsitcph": 4068006585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13318",
    "droptype": "D",
    "dropname": "NEIHART",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "NEIHART",
    "dropdelst": "MT",
    "dropdelzpp": 594659998,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "NEIHART",
    "dropphyst": "MT",
    "dropphyzpp": 594659998,
    "dropmaladd": "108 N MAIN ST",
    "dropmalcty": "NEIHART",
    "dropmalst": "MT",
    "dropmalzpp": 594659998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062365309,
    "dropsitcph": 4062365309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13320",
    "droptype": "D",
    "dropname": "NORRIS",
    "dropdeladd": "6536 US HIGHWAY 287",
    "dropdelcty": "NORRIS",
    "dropdelst": "MT",
    "dropdelzpp": 597459998,
    "dropphyadd": "6536 US HIGHWAY 287",
    "dropphycty": "NORRIS",
    "dropphyst": "MT",
    "dropphyzpp": 597459998,
    "dropmaladd": "6536 US HIGHWAY 287",
    "dropmalcty": "NORRIS",
    "dropmalst": "MT",
    "dropmalzpp": 597459998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066853210,
    "dropsitcph": 4066853210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13321",
    "droptype": "D",
    "dropname": "NOXON",
    "dropdeladd": "110 EVANS ST",
    "dropdelcty": "NOXON",
    "dropdelst": "MT",
    "dropdelzpp": 598539998,
    "dropphyadd": "110 EVANS ST",
    "dropphycty": "NOXON",
    "dropphyst": "MT",
    "dropphyzpp": 598539998,
    "dropmaladd": "110 EVANS ST",
    "dropmalcty": "NOXON",
    "dropmalst": "MT",
    "dropmalzpp": 598539998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068472412,
    "dropsitcph": 4068472412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13325",
    "droptype": "D",
    "dropname": "OLNEY",
    "dropdeladd": "1 OLNEY LOOP RD",
    "dropdelcty": "OLNEY",
    "dropdelst": "MT",
    "dropdelzpp": 599279998,
    "dropphyadd": "1 OLNEY LOOP RD",
    "dropphycty": "OLNEY",
    "dropphyst": "MT",
    "dropphyzpp": 599279998,
    "dropmaladd": "1 OLNEY LOOP RD",
    "dropmalcty": "OLNEY",
    "dropmalst": "MT",
    "dropmalzpp": 599279998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068812565,
    "dropsitcph": 4068812565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13326",
    "droptype": "D",
    "dropname": "OPHEIM",
    "dropdeladd": "102 MAIN ST N",
    "dropdelcty": "OPHEIM",
    "dropdelst": "MT",
    "dropdelzpp": 592509998,
    "dropphyadd": "102 MAIN ST N",
    "dropphycty": "OPHEIM",
    "dropphyst": "MT",
    "dropphyzpp": 592509998,
    "dropmaladd": "102 MAIN ST N",
    "dropmalcty": "OPHEIM",
    "dropmalst": "MT",
    "dropmalzpp": 592509998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067623219,
    "dropsitcph": 4067623219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13328",
    "droptype": "D",
    "dropname": "OTTER",
    "dropdeladd": "268 OTTER CREEK RD",
    "dropdelcty": "OTTER",
    "dropdelst": "MT",
    "dropdelzpp": 590629998,
    "dropphyadd": "268 OTTER CREEK RD",
    "dropphycty": "OTTER",
    "dropphyst": "MT",
    "dropphyzpp": 590629998,
    "dropmaladd": "268 OTTER CREEK RD",
    "dropmalcty": "OTTER",
    "dropmalst": "MT",
    "dropmalzpp": 590629998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067842510,
    "dropsitcph": 4067842510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13329",
    "droptype": "D",
    "dropname": "OUTLOOK",
    "dropdeladd": "202 MAIN ST",
    "dropdelcty": "OUTLOOK",
    "dropdelst": "MT",
    "dropdelzpp": 592529998,
    "dropphyadd": "202 MAIN ST",
    "dropphycty": "OUTLOOK",
    "dropphyst": "MT",
    "dropphyzpp": 592529998,
    "dropmaladd": "202 MAIN ST",
    "dropmalcty": "OUTLOOK",
    "dropmalst": "MT",
    "dropmalzpp": 592529998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068131096,
    "dropsitcph": 4068131096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13330",
    "droptype": "D",
    "dropname": "OVANDO",
    "dropdeladd": "312 MAIN ST",
    "dropdelcty": "OVANDO",
    "dropdelst": "MT",
    "dropdelzpp": 598549998,
    "dropphyadd": "312 MAIN ST",
    "dropphycty": "OVANDO",
    "dropphyst": "MT",
    "dropphyzpp": 598549998,
    "dropmaladd": "312 MAIN ST",
    "dropmalcty": "OVANDO",
    "dropmalst": "MT",
    "dropmalzpp": 598549998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194657,
    "dropsitcph": 4069194657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13331",
    "droptype": "D",
    "dropname": "PABLO",
    "dropdeladd": "42025 OLD US HIGHWAY 93",
    "dropdelcty": "PABLO",
    "dropdelst": "MT",
    "dropdelzpp": 598559998,
    "dropphyadd": "42025 OLD US HIGHWAY 93",
    "dropphycty": "PABLO",
    "dropphyst": "MT",
    "dropphyzpp": 598559998,
    "dropmaladd": "42025 OLD US HIGHWAY 93",
    "dropmalcty": "PABLO",
    "dropmalst": "MT",
    "dropmalzpp": 598559998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066752324,
    "dropsitcph": 4066752324,
    "dropfax": 4066572388
  },
  {
    "dcode": "D",
    "dropkey": "PZ13332",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "5 MCLAUGHLIN CREEK RD",
    "dropdelcty": "PARADISE",
    "dropdelst": "MT",
    "dropdelzpp": 598569998,
    "dropphyadd": "5 MCLAUGHLIN CREEK RD",
    "dropphycty": "PARADISE",
    "dropphyst": "MT",
    "dropphyzpp": 598569998,
    "dropmaladd": "5 MCLAUGHLIN CREEK RD",
    "dropmalcty": "PARADISE",
    "dropmalst": "MT",
    "dropmalzpp": 598569998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068268225,
    "dropsitcph": 4068268225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13333",
    "droptype": "D",
    "dropname": "PARK CITY",
    "dropdeladd": "6 1ST AVE SW",
    "dropdelcty": "PARK CITY",
    "dropdelst": "MT",
    "dropdelzpp": 590639998,
    "dropphyadd": "6 1ST AVE SW",
    "dropphycty": "PARK CITY",
    "dropphyst": "MT",
    "dropphyzpp": 590639998,
    "dropmaladd": "6 1ST AVE SW",
    "dropmalcty": "PARK CITY",
    "dropmalst": "MT",
    "dropmalzpp": 590639998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066624017,
    "dropsitcph": 4066624017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13334",
    "droptype": "D",
    "dropname": "PEERLESS",
    "dropdeladd": "106 RAILROAD AVE E",
    "dropdelcty": "PEERLESS",
    "dropdelst": "MT",
    "dropdelzpp": 592539998,
    "dropphyadd": "106 RAILROAD AVE E",
    "dropphycty": "PEERLESS",
    "dropphyst": "MT",
    "dropphyzpp": 592539998,
    "dropmaladd": "106 RAILROAD AVE E",
    "dropmalcty": "PEERLESS",
    "dropmalst": "MT",
    "dropmalzpp": 592539998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132814,
    "dropsitcph": 4068132814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13335",
    "droptype": "D",
    "dropname": "PENDROY",
    "dropdeladd": "121 MAIN ST",
    "dropdelcty": "PENDROY",
    "dropdelst": "MT",
    "dropdelzpp": 594679998,
    "dropphyadd": "121 MAIN ST",
    "dropphycty": "PENDROY",
    "dropphyst": "MT",
    "dropphyzpp": 594679998,
    "dropmaladd": "121 MAIN ST",
    "dropmalcty": "PENDROY",
    "dropmalst": "MT",
    "dropmalzpp": 594679998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064692246,
    "dropsitcph": 4064692246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13336",
    "droptype": "D",
    "dropname": "PHILIPSBURG",
    "dropdeladd": "234 E BROADWAY ST",
    "dropdelcty": "PHILIPSBURG",
    "dropdelst": "MT",
    "dropdelzpp": 598589998,
    "dropphyadd": "234 E BROADWAY ST",
    "dropphycty": "PHILIPSBURG",
    "dropphyst": "MT",
    "dropphyzpp": 598589998,
    "dropmaladd": "234 E BROADWAY ST",
    "dropmalcty": "PHILIPSBURG",
    "dropmalst": "MT",
    "dropmalzpp": 598589998,
    "dropsitphn": 4065520144,
    "dropsitlph": 4065521200,
    "dropsitcph": 4065521200,
    "dropfax": 8884732963
  },
  {
    "dcode": "D",
    "dropkey": "PZ13339",
    "droptype": "D",
    "dropname": "PLAINS",
    "dropdeladd": "310 W MEANY ST",
    "dropdelcty": "PLAINS",
    "dropdelst": "MT",
    "dropdelzpp": 598599998,
    "dropphyadd": "310 W MEANY ST",
    "dropphycty": "PLAINS",
    "dropphyst": "MT",
    "dropphyzpp": 598599998,
    "dropmaladd": "310 W MEANY ST",
    "dropmalcty": "PLAINS",
    "dropmalst": "MT",
    "dropmalzpp": 598599998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068263541,
    "dropsitcph": 4068263541,
    "dropfax": 4068264300
  },
  {
    "dcode": "D",
    "dropkey": "PZ13340",
    "droptype": "D",
    "dropname": "PLENTYWOOD",
    "dropdeladd": "302 N MAIN ST",
    "dropdelcty": "PLENTYWOOD",
    "dropdelst": "MT",
    "dropdelzpp": 592549998,
    "dropphyadd": "302 N MAIN ST",
    "dropphycty": "PLENTYWOOD",
    "dropphyst": "MT",
    "dropphyzpp": 592549998,
    "dropmaladd": "302 N MAIN ST",
    "dropmalcty": "PLENTYWOOD",
    "dropmalst": "MT",
    "dropmalzpp": 592549998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067651710,
    "dropsitcph": 4067651710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13341",
    "droptype": "D",
    "dropname": "PLEVNA",
    "dropdeladd": "125 N MAIN ST",
    "dropdelcty": "PLEVNA",
    "dropdelst": "MT",
    "dropdelzpp": 593449998,
    "dropphyadd": "125 N MAIN ST",
    "dropphycty": "PLEVNA",
    "dropphyst": "MT",
    "dropphyzpp": 593449998,
    "dropmaladd": "125 N MAIN ST",
    "dropmalcty": "PLEVNA",
    "dropmalst": "MT",
    "dropmalzpp": 593449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067725531,
    "dropsitcph": 4067725531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13344",
    "droptype": "D",
    "dropname": "POLSON",
    "dropdeladd": "105 4TH AVE E",
    "dropdelcty": "POLSON",
    "dropdelst": "MT",
    "dropdelzpp": 598609998,
    "dropphyadd": "105 4TH AVE E",
    "dropphycty": "POLSON",
    "dropphyst": "MT",
    "dropphyzpp": 598609998,
    "dropmaladd": "105 4TH AVE E",
    "dropmalcty": "POLSON",
    "dropmalst": "MT",
    "dropmalzpp": 598609998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068832088,
    "dropsitcph": 4068832088,
    "dropfax": 4068831047
  },
  {
    "dcode": "D",
    "dropkey": "PZ13345",
    "droptype": "D",
    "dropname": "POMPEYS PILLAR",
    "dropdeladd": "3519 2ND ST S",
    "dropdelcty": "POMPEYS PILLAR",
    "dropdelst": "MT",
    "dropdelzpp": 590649998,
    "dropphyadd": "3519 2ND ST S",
    "dropphycty": "POMPEYS PILLAR",
    "dropphyst": "MT",
    "dropphyzpp": 590649998,
    "dropmaladd": "3519 2ND ST S",
    "dropmalcty": "POMPEYS PILLAR",
    "dropmalst": "MT",
    "dropmalzpp": 590649998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068752145,
    "dropsitcph": 4068752145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13346",
    "droptype": "D",
    "dropname": "PONY",
    "dropdeladd": "3 REEL ST",
    "dropdelcty": "PONY",
    "dropdelst": "MT",
    "dropdelzpp": 597479998,
    "dropphyadd": "3 REEL ST",
    "dropphycty": "PONY",
    "dropphyst": "MT",
    "dropphyzpp": 597479998,
    "dropmaladd": "3 REEL ST",
    "dropmalcty": "PONY",
    "dropmalst": "MT",
    "dropmalzpp": 597479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066853503,
    "dropsitcph": 4066853503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13347",
    "droptype": "D",
    "dropname": "POPLAR",
    "dropdeladd": "105 E ST W",
    "dropdelcty": "POPLAR",
    "dropdelst": "MT",
    "dropdelzpp": 592559998,
    "dropphyadd": "105 E ST W",
    "dropphycty": "POPLAR",
    "dropphyst": "MT",
    "dropphyzpp": 592559998,
    "dropmaladd": "105 E ST W",
    "dropmalcty": "POPLAR",
    "dropmalst": "MT",
    "dropmalzpp": 592559998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067683398,
    "dropsitcph": 4067683398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13350",
    "droptype": "D",
    "dropname": "POWER",
    "dropdeladd": "406 CENTRAL AVE",
    "dropdelcty": "POWER",
    "dropdelst": "MT",
    "dropdelzpp": 594689998,
    "dropphyadd": "406 CENTRAL AVE",
    "dropphycty": "POWER",
    "dropphyst": "MT",
    "dropphyzpp": 594689998,
    "dropmaladd": "406 CENTRAL AVE",
    "dropmalcty": "POWER",
    "dropmalst": "MT",
    "dropmalzpp": 594689998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064632296,
    "dropsitcph": 4064632296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13351",
    "droptype": "D",
    "dropname": "PRAY",
    "dropdeladd": "8 PRAY RD",
    "dropdelcty": "PRAY",
    "dropdelst": "MT",
    "dropdelzpp": 590659998,
    "dropphyadd": "8 PRAY RD",
    "dropphycty": "PRAY",
    "dropphyst": "MT",
    "dropphyzpp": 590659998,
    "dropmaladd": "8 PRAY RD",
    "dropmalcty": "PRAY",
    "dropmalst": "MT",
    "dropmalzpp": 590659998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063334267,
    "dropsitcph": 4063334267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13353",
    "droptype": "D",
    "dropname": "PRYOR",
    "dropdeladd": "130 MAKPUA AVE",
    "dropdelcty": "PRYOR",
    "dropdelst": "MT",
    "dropdelzpp": 590669998,
    "dropphyadd": "130 MAKPUA AVE",
    "dropphycty": "PRYOR",
    "dropphyst": "MT",
    "dropphyzpp": 590669998,
    "dropmaladd": "130 MAKPUA AVE",
    "dropmalcty": "PRYOR",
    "dropmalst": "MT",
    "dropmalzpp": 590669998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062593387,
    "dropsitcph": 4062593387,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13355",
    "droptype": "D",
    "dropname": "RAMSAY",
    "dropdeladd": "1 BEULAH ST",
    "dropdelcty": "RAMSAY",
    "dropdelst": "MT",
    "dropdelzpp": 597489998,
    "dropphyadd": "1 BEULAH ST",
    "dropphycty": "RAMSAY",
    "dropphyst": "MT",
    "dropphyzpp": 597489998,
    "dropmaladd": "1 BEULAH ST",
    "dropmalcty": "RAMSAY",
    "dropmalst": "MT",
    "dropmalzpp": 597489998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067821895,
    "dropsitcph": 4067821895,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13356",
    "droptype": "D",
    "dropname": "RAPELJE",
    "dropdeladd": "219 4TH ST",
    "dropdelcty": "RAPELJE",
    "dropdelst": "MT",
    "dropdelzpp": 590679998,
    "dropphyadd": "219 4TH ST",
    "dropphycty": "RAPELJE",
    "dropphyst": "MT",
    "dropphyzpp": 590679998,
    "dropmaladd": "219 4TH ST",
    "dropmalcty": "RAPELJE",
    "dropmalst": "MT",
    "dropmalzpp": 590679998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066632238,
    "dropsitcph": 4066632238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13358",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "310 RAYMOND RD",
    "dropdelcty": "RAYMOND",
    "dropdelst": "MT",
    "dropdelzpp": 592569998,
    "dropphyadd": "310 RAYMOND RD",
    "dropphycty": "RAYMOND",
    "dropphyst": "MT",
    "dropphyzpp": 592569998,
    "dropmaladd": "310 RAYMOND RD",
    "dropmalcty": "RAYMOND",
    "dropmalst": "MT",
    "dropmalzpp": 592569998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069195881,
    "dropsitcph": 4069195881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13359",
    "droptype": "D",
    "dropname": "RAYNESFORD",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "RAYNESFORD",
    "dropdelst": "MT",
    "dropdelzpp": 594699998,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "RAYNESFORD",
    "dropphyst": "MT",
    "dropphyzpp": 594699998,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "RAYNESFORD",
    "dropmalst": "MT",
    "dropmalzpp": 594699998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067384394,
    "dropsitcph": 4067384394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13360",
    "droptype": "D",
    "dropname": "RED LODGE",
    "dropdeladd": "119 S HAUSER AVE",
    "dropdelcty": "RED LODGE",
    "dropdelst": "MT",
    "dropdelzpp": 590689998,
    "dropphyadd": "119 S HAUSER AVE",
    "dropphycty": "RED LODGE",
    "dropphyst": "MT",
    "dropphyzpp": 590689998,
    "dropmaladd": "119 S HAUSER AVE",
    "dropmalcty": "RED LODGE",
    "dropmalst": "MT",
    "dropmalzpp": 590689998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064462629,
    "dropsitcph": 4064462629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13362",
    "droptype": "D",
    "dropname": "REED POINT",
    "dropdeladd": "3 DIVISION ST",
    "dropdelcty": "REED POINT",
    "dropdelst": "MT",
    "dropdelzpp": 590699998,
    "dropphyadd": "3 DIVISION ST",
    "dropphycty": "REED POINT",
    "dropphyst": "MT",
    "dropphyzpp": 590699998,
    "dropmaladd": "3 DIVISION ST",
    "dropmalcty": "REED POINT",
    "dropmalst": "MT",
    "dropmalzpp": 590699998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067033097,
    "dropsitcph": 4067033097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13363",
    "droptype": "D",
    "dropname": "RESERVE",
    "dropdeladd": "400 E CENTRAL AVE",
    "dropdelcty": "RESERVE",
    "dropdelst": "MT",
    "dropdelzpp": 592589998,
    "dropphyadd": "400 E CENTRAL AVE",
    "dropphycty": "RESERVE",
    "dropphyst": "MT",
    "dropphyzpp": 592589998,
    "dropmaladd": "400 E CENTRAL AVE",
    "dropmalcty": "RESERVE",
    "dropmalst": "MT",
    "dropmalzpp": 592589998,
    "dropsitphn": 4069243226,
    "dropsitlph": 4069243231,
    "dropsitcph": 4069243231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13364",
    "droptype": "D",
    "dropname": "REXFORD",
    "dropdeladd": "202 GATEWAY ST",
    "dropdelcty": "REXFORD",
    "dropdelst": "MT",
    "dropdelzpp": 599309998,
    "dropphyadd": "202 GATEWAY ST",
    "dropphycty": "REXFORD",
    "dropphyst": "MT",
    "dropphyzpp": 599309998,
    "dropmaladd": "202 GATEWAY ST",
    "dropmalcty": "REXFORD",
    "dropmalst": "MT",
    "dropmalzpp": 599309998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062972106,
    "dropsitcph": 4062972106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13365",
    "droptype": "D",
    "dropname": "RICHEY",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "RICHEY",
    "dropdelst": "MT",
    "dropdelzpp": 592599998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "RICHEY",
    "dropphyst": "MT",
    "dropphyzpp": 592599998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "RICHEY",
    "dropmalst": "MT",
    "dropmalzpp": 592599998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067735580,
    "dropsitcph": 4067735580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13366",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "74 MAIN ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "MT",
    "dropdelzpp": 592609998,
    "dropphyadd": "74 MAIN ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "MT",
    "dropphyzpp": 592609998,
    "dropmaladd": "74 MAIN ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "MT",
    "dropmalzpp": 592609998,
    "dropsitphn": 4067243382,
    "dropsitlph": 4067243382,
    "dropsitcph": 4067243382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13367",
    "droptype": "D",
    "dropname": "RINGLING",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "RINGLING",
    "dropdelst": "MT",
    "dropdelzpp": 596429998,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "RINGLING",
    "dropphyst": "MT",
    "dropphyzpp": 596429998,
    "dropmaladd": "100 MAIN ST",
    "dropmalcty": "RINGLING",
    "dropmalst": "MT",
    "dropmalzpp": 596429998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065305250,
    "dropsitcph": 4065305250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13369",
    "droptype": "D",
    "dropname": "ROBERTS",
    "dropdeladd": "1 N 1ST ST",
    "dropdelcty": "ROBERTS",
    "dropdelst": "MT",
    "dropdelzpp": 590709998,
    "dropphyadd": "1 N 1ST ST",
    "dropphycty": "ROBERTS",
    "dropphyst": "MT",
    "dropphyzpp": 590709998,
    "dropmaladd": "1 N 1ST ST",
    "dropmalcty": "ROBERTS",
    "dropmalst": "MT",
    "dropmalzpp": 590709998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064452309,
    "dropsitcph": 4064452309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13374",
    "droptype": "D",
    "dropname": "RONAN",
    "dropdeladd": "222 ADAMS ST SW",
    "dropdelcty": "RONAN",
    "dropdelst": "MT",
    "dropdelzpp": 598649998,
    "dropphyadd": "222 ADAMS ST SW",
    "dropphycty": "RONAN",
    "dropphyst": "MT",
    "dropphyzpp": 598649998,
    "dropmaladd": "222 ADAMS ST SW",
    "dropmalcty": "RONAN",
    "dropmalst": "MT",
    "dropmalzpp": 598649998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066768271,
    "dropsitcph": 4066768271,
    "dropfax": 4066768298
  },
  {
    "dcode": "D",
    "dropkey": "PZ13375",
    "droptype": "D",
    "dropname": "ROSCOE",
    "dropdeladd": "111 MAIN ST",
    "dropdelcty": "ROSCOE",
    "dropdelst": "MT",
    "dropdelzpp": 590719998,
    "dropphyadd": "111 MAIN ST",
    "dropphycty": "ROSCOE",
    "dropphyst": "MT",
    "dropphyzpp": 590719998,
    "dropmaladd": "111 MAIN ST",
    "dropmalcty": "ROSCOE",
    "dropmalst": "MT",
    "dropmalzpp": 590719998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063286860,
    "dropsitcph": 4063286860,
    "dropfax": 4063286860
  },
  {
    "dcode": "D",
    "dropkey": "PZ13376",
    "droptype": "D",
    "dropname": "ROSEBUD",
    "dropdeladd": "125 MAIN ST",
    "dropdelcty": "ROSEBUD",
    "dropdelst": "MT",
    "dropdelzpp": 593479998,
    "dropphyadd": "125 MAIN ST",
    "dropphycty": "ROSEBUD",
    "dropphyst": "MT",
    "dropphyzpp": 593479998,
    "dropmaladd": "125 MAIN ST",
    "dropmalcty": "ROSEBUD",
    "dropmalst": "MT",
    "dropmalzpp": 593479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068512150,
    "dropsitcph": 4063336067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13377",
    "droptype": "D",
    "dropname": "ROUNDUP",
    "dropdeladd": "908 MAIN ST",
    "dropdelcty": "ROUNDUP",
    "dropdelst": "MT",
    "dropdelzpp": 590729998,
    "dropphyadd": "908 MAIN ST",
    "dropphycty": "ROUNDUP",
    "dropphyst": "MT",
    "dropphyzpp": 590729998,
    "dropmaladd": "908 MAIN ST",
    "dropmalcty": "ROUNDUP",
    "dropmalst": "MT",
    "dropmalzpp": 590729998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063231803,
    "dropsitcph": 4063231803,
    "dropfax": 4063233024
  },
  {
    "dcode": "D",
    "dropkey": "PZ13378",
    "droptype": "D",
    "dropname": "ROY",
    "dropdeladd": "228 MAIN ST",
    "dropdelcty": "ROY",
    "dropdelst": "MT",
    "dropdelzpp": 594719998,
    "dropphyadd": "228 MAIN ST",
    "dropphycty": "ROY",
    "dropphyst": "MT",
    "dropphyzpp": 594719998,
    "dropmaladd": "228 MAIN ST",
    "dropmalcty": "ROY",
    "dropmalst": "MT",
    "dropmalzpp": 594719998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068130956,
    "dropsitcph": 4068130956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13379",
    "droptype": "D",
    "dropname": "RUDYARD",
    "dropdeladd": "15 MAIN ST N",
    "dropdelcty": "RUDYARD",
    "dropdelst": "MT",
    "dropdelzpp": 595409998,
    "dropphyadd": "15 MAIN ST N",
    "dropphycty": "RUDYARD",
    "dropphyst": "MT",
    "dropphyzpp": 595409998,
    "dropmaladd": "15 MAIN ST N",
    "dropmalcty": "RUDYARD",
    "dropmalst": "MT",
    "dropmalzpp": 595409998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132448,
    "dropsitcph": 4068132448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13380",
    "droptype": "D",
    "dropname": "RYEGATE",
    "dropdeladd": "114 1ST ST N",
    "dropdelcty": "RYEGATE",
    "dropdelst": "MT",
    "dropdelzpp": 590749998,
    "dropphyadd": "114 1ST ST N",
    "dropphycty": "RYEGATE",
    "dropphyst": "MT",
    "dropphyzpp": 590749998,
    "dropmaladd": "114 1ST ST N",
    "dropmalcty": "RYEGATE",
    "dropmalst": "MT",
    "dropmalzpp": 590749998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065682362,
    "dropsitcph": 4065682362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13381",
    "droptype": "D",
    "dropname": "SACO",
    "dropdeladd": "98 HIGHWAY 243",
    "dropdelcty": "SACO",
    "dropdelst": "MT",
    "dropdelzpp": 592619998,
    "dropphyadd": "98 HIGHWAY 243",
    "dropphycty": "SACO",
    "dropphyst": "MT",
    "dropphyzpp": 592619998,
    "dropmaladd": "98 HIGHWAY 243",
    "dropmalcty": "SACO",
    "dropmalst": "MT",
    "dropmalzpp": 592619998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006702,
    "dropsitcph": 4068006702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13382",
    "droptype": "D",
    "dropname": "SAINT IGNATIUS",
    "dropdeladd": "120 1ST AVE",
    "dropdelcty": "SAINT IGNATIUS",
    "dropdelst": "MT",
    "dropdelzpp": 598659998,
    "dropphyadd": "120 1ST AVE",
    "dropphycty": "SAINT IGNATIUS",
    "dropphyst": "MT",
    "dropphyzpp": 598659998,
    "dropmaladd": "120 1ST AVE",
    "dropmalcty": "SAINT IGNATIUS",
    "dropmalst": "MT",
    "dropmalzpp": 598659998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067454438,
    "dropsitcph": 4067454438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13386",
    "droptype": "D",
    "dropname": "SAINT REGIS",
    "dropdeladd": "330 MT HIGHWAY 135",
    "dropdelcty": "SAINT REGIS",
    "dropdelst": "MT",
    "dropdelzpp": 598669767,
    "dropphyadd": "330 MT HIGHWAY 135",
    "dropphycty": "SAINT REGIS",
    "dropphyst": "MT",
    "dropphyzpp": 598669767,
    "dropmaladd": "330 MT HIGHWAY 135",
    "dropmalcty": "SAINT REGIS",
    "dropmalst": "MT",
    "dropmalzpp": 598669767,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194064,
    "dropsitcph": 4069194064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13387",
    "droptype": "D",
    "dropname": "SAINT XAVIER",
    "dropdeladd": "108 FORT SMITH AVE",
    "dropdelcty": "SAINT XAVIER",
    "dropdelst": "MT",
    "dropdelzpp": 590759998,
    "dropphyadd": "108 FORT SMITH AVE",
    "dropphycty": "SAINT XAVIER",
    "dropphyst": "MT",
    "dropphyzpp": 590759998,
    "dropmaladd": "108 FORT SMITH AVE",
    "dropmalcty": "SAINT XAVIER",
    "dropmalst": "MT",
    "dropmalzpp": 590759998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006692,
    "dropsitcph": 4068006692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13389",
    "droptype": "D",
    "dropname": "SAND COULEE",
    "dropdeladd": "538 E HUNTER RD",
    "dropdelcty": "SAND COULEE",
    "dropdelst": "MT",
    "dropdelzpp": 594729998,
    "dropphyadd": "538 E HUNTER RD",
    "dropphycty": "SAND COULEE",
    "dropphyst": "MT",
    "dropphyzpp": 594729998,
    "dropmaladd": "538 E HUNTER RD",
    "dropmalcty": "SAND COULEE",
    "dropmalst": "MT",
    "dropmalzpp": 594729998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067365656,
    "dropsitcph": 4067365656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13390",
    "droptype": "D",
    "dropname": "SAND SPRINGS",
    "dropdeladd": "3198 HIGHWAY 200 W",
    "dropdelcty": "SAND SPRINGS",
    "dropdelst": "MT",
    "dropdelzpp": 590779998,
    "dropphyadd": "3198 HIGHWAY 200 W",
    "dropphycty": "SAND SPRINGS",
    "dropphyst": "MT",
    "dropphyzpp": 590779998,
    "dropmaladd": "3198 HIGHWAY 200 W",
    "dropmalcty": "SAND SPRINGS",
    "dropmalst": "MT",
    "dropmalzpp": 590779998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132225,
    "dropsitcph": 4066982225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13393",
    "droptype": "D",
    "dropname": "SAVAGE",
    "dropdeladd": "264 MAIN ST",
    "dropdelcty": "SAVAGE",
    "dropdelst": "MT",
    "dropdelzpp": 592629998,
    "dropphyadd": "264 MAIN ST",
    "dropphycty": "SAVAGE",
    "dropphyst": "MT",
    "dropphyzpp": 592629998,
    "dropmaladd": "264 MAIN ST",
    "dropmalcty": "SAVAGE",
    "dropmalst": "MT",
    "dropmalzpp": 592629998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067762313,
    "dropsitcph": 4067762313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13394",
    "droptype": "D",
    "dropname": "SCOBEY",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "SCOBEY",
    "dropdelst": "MT",
    "dropdelzpp": 592639998,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "SCOBEY",
    "dropphyst": "MT",
    "dropphyzpp": 592639998,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "SCOBEY",
    "dropmalst": "MT",
    "dropmalzpp": 592639998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064872230,
    "dropsitcph": 4064872230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13395",
    "droptype": "D",
    "dropname": "SEELEY LAKE",
    "dropdeladd": "3172 MT HIGHWAY 83 N",
    "dropdelcty": "SEELEY LAKE",
    "dropdelst": "MT",
    "dropdelzpp": 598689998,
    "dropphyadd": "3172 MT HIGHWAY 83 N",
    "dropphycty": "SEELEY LAKE",
    "dropphyst": "MT",
    "dropphyzpp": 598689998,
    "dropmaladd": "3172 MT HIGHWAY 83 N",
    "dropmalcty": "SEELEY LAKE",
    "dropmalst": "MT",
    "dropmalzpp": 598689998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066772474,
    "dropsitcph": 4066861081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13396",
    "droptype": "D",
    "dropname": "SHAWMUT",
    "dropdeladd": "4 W FIRST AVE",
    "dropdelcty": "SHAWMUT",
    "dropdelst": "MT",
    "dropdelzpp": 590789998,
    "dropphyadd": "4 W FIRST AVE",
    "dropphycty": "SHAWMUT",
    "dropphyst": "MT",
    "dropphyzpp": 590789998,
    "dropmaladd": "4 W FIRST AVE",
    "dropmalcty": "SHAWMUT",
    "dropmalst": "MT",
    "dropmalzpp": 590789998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066324507,
    "dropsitcph": 4066324507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13397",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "145 1ST AVE SE",
    "dropdelcty": "SHELBY",
    "dropdelst": "MT",
    "dropdelzpp": 594749998,
    "dropphyadd": "145 1ST AVE SE",
    "dropphycty": "SHELBY",
    "dropphyst": "MT",
    "dropphyzpp": 594749998,
    "dropmaladd": "145 1ST AVE SE",
    "dropmalcty": "SHELBY",
    "dropmalst": "MT",
    "dropmalzpp": 594749998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064342621,
    "dropsitcph": 4064342621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13398",
    "droptype": "D",
    "dropname": "SHEPHERD",
    "dropdeladd": "5450 CAREY AVE",
    "dropdelcty": "SHEPHERD",
    "dropdelst": "MT",
    "dropdelzpp": 590799998,
    "dropphyadd": "5450 CAREY AVE",
    "dropphycty": "SHEPHERD",
    "dropphyst": "MT",
    "dropphyzpp": 590799998,
    "dropmaladd": "5450 CAREY AVE",
    "dropmalcty": "SHEPHERD",
    "dropmalst": "MT",
    "dropmalzpp": 590799998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063845400,
    "dropsitcph": 4063735355,
    "dropfax": 4063736774
  },
  {
    "dcode": "D",
    "dropkey": "PZ13399",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "208 S MAIN ST",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "MT",
    "dropdelzpp": 597499998,
    "dropphyadd": "208 S MAIN ST",
    "dropphycty": "SHERIDAN",
    "dropphyst": "MT",
    "dropphyzpp": 597499998,
    "dropmaladd": "208 S MAIN ST",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "MT",
    "dropmalzpp": 597499998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194639,
    "dropsitcph": 4069194639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13401",
    "droptype": "D",
    "dropname": "SIDNEY",
    "dropdeladd": "101 W HOLLY ST",
    "dropdelcty": "SIDNEY",
    "dropdelst": "MT",
    "dropdelzpp": 592709998,
    "dropphyadd": "101 W HOLLY ST",
    "dropphycty": "SIDNEY",
    "dropphyst": "MT",
    "dropphyzpp": 592709998,
    "dropmaladd": "101 W HOLLY ST",
    "dropmalcty": "SIDNEY",
    "dropmalst": "MT",
    "dropmalzpp": 592709998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064822107,
    "dropsitcph": 4064822107,
    "dropfax": 4064821759
  },
  {
    "dcode": "D",
    "dropkey": "PZ13406",
    "droptype": "D",
    "dropname": "SIMMS",
    "dropdeladd": "310 N MAIN ST",
    "dropdelcty": "SIMMS",
    "dropdelst": "MT",
    "dropdelzpp": 594779998,
    "dropphyadd": "310 N MAIN ST",
    "dropphycty": "SIMMS",
    "dropphyst": "MT",
    "dropphyzpp": 594779998,
    "dropmaladd": "310 N MAIN ST",
    "dropmalcty": "SIMMS",
    "dropmalst": "MT",
    "dropmalzpp": 594779998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062645128,
    "dropsitcph": 4062645128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13407",
    "droptype": "D",
    "dropname": "SOMERS",
    "dropdeladd": "150 SOMERS RD",
    "dropdelcty": "SOMERS",
    "dropdelst": "MT",
    "dropdelzpp": 599329998,
    "dropphyadd": "150 SOMERS RD",
    "dropphycty": "SOMERS",
    "dropphyst": "MT",
    "dropphyzpp": 599329998,
    "dropmaladd": "150 SOMERS RD",
    "dropmalcty": "SOMERS",
    "dropmalst": "MT",
    "dropmalzpp": 599329998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068573330,
    "dropsitcph": 4068573330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13412",
    "droptype": "D",
    "dropname": "STANFORD",
    "dropdeladd": "80 CENTRAL AVE",
    "dropdelcty": "STANFORD",
    "dropdelst": "MT",
    "dropdelzpp": 594799998,
    "dropphyadd": "80 CENTRAL AVE",
    "dropphycty": "STANFORD",
    "dropphyst": "MT",
    "dropphyzpp": 594799998,
    "dropmaladd": "80 CENTRAL AVE",
    "dropmalcty": "STANFORD",
    "dropmalst": "MT",
    "dropmalzpp": 594799998,
    "dropsitphn": 4066575713,
    "dropsitlph": 8773641401,
    "dropsitcph": 8773641401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13415",
    "droptype": "D",
    "dropname": "STEVENSVILLE",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "STEVENSVILLE",
    "dropdelst": "MT",
    "dropdelzpp": 598709998,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "STEVENSVILLE",
    "dropphyst": "MT",
    "dropphyzpp": 598709998,
    "dropmaladd": "701 MAIN ST",
    "dropmalcty": "STEVENSVILLE",
    "dropmalst": "MT",
    "dropmalzpp": 598709998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067775812,
    "dropsitcph": 4067775812,
    "dropfax": 4067771061
  },
  {
    "dcode": "D",
    "dropkey": "PZ13416",
    "droptype": "D",
    "dropname": "STOCKETT",
    "dropdeladd": "15 COTTONWOOD AVE",
    "dropdelcty": "STOCKETT",
    "dropdelst": "MT",
    "dropdelzpp": 594809998,
    "dropphyadd": "15 COTTONWOOD AVE",
    "dropphycty": "STOCKETT",
    "dropphyst": "MT",
    "dropphyzpp": 594809998,
    "dropmaladd": "15 COTTONWOOD AVE",
    "dropmalcty": "STOCKETT",
    "dropmalst": "MT",
    "dropmalzpp": 594809998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067365636,
    "dropsitcph": 4067365636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13418",
    "droptype": "D",
    "dropname": "STRYKER",
    "dropdeladd": "120 SUNDAY CREEK RD",
    "dropdelcty": "STRYKER",
    "dropdelst": "MT",
    "dropdelzpp": 599339998,
    "dropphyadd": "120 SUNDAY CREEK RD",
    "dropphycty": "STRYKER",
    "dropphyst": "MT",
    "dropphyzpp": 599339998,
    "dropmaladd": "120 SUNDAY CREEK RD",
    "dropmalcty": "STRYKER",
    "dropmalst": "MT",
    "dropmalzpp": 599339998,
    "dropsitphn": 4068824723,
    "dropsitlph": 4068824723,
    "dropsitcph": 4068824723,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13419",
    "droptype": "D",
    "dropname": "SULA",
    "dropdeladd": "502 E FORK RD",
    "dropdelcty": "SULA",
    "dropdelst": "MT",
    "dropdelzpp": 598719998,
    "dropphyadd": "502 E FORK RD",
    "dropphycty": "SULA",
    "dropphyst": "MT",
    "dropphyzpp": 598719998,
    "dropmaladd": "502 E FORK RD",
    "dropmalcty": "SULA",
    "dropmalst": "MT",
    "dropmalzpp": 598719998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068213852,
    "dropsitcph": 4068213852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13420",
    "droptype": "D",
    "dropname": "SUMATRA",
    "dropdeladd": "2960 SUMATRA HYSHAM RD",
    "dropdelcty": "SUMATRA",
    "dropdelst": "MT",
    "dropdelzpp": 590839998,
    "dropphyadd": "2960 SUMATRA HYSHAM RD",
    "dropphycty": "SUMATRA",
    "dropphyst": "MT",
    "dropphyzpp": 590839998,
    "dropmaladd": "2960 SUMATRA HYSHAM RD",
    "dropmalcty": "SUMATRA",
    "dropmalst": "MT",
    "dropmalzpp": 590839998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063582475,
    "dropsitcph": 4063582475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13422",
    "droptype": "D",
    "dropname": "SUN RIVER",
    "dropdeladd": "220 W CARROLL ST",
    "dropdelcty": "SUN RIVER",
    "dropdelst": "MT",
    "dropdelzpp": 594839998,
    "dropphyadd": "220 W CARROLL ST",
    "dropphycty": "SUN RIVER",
    "dropphyst": "MT",
    "dropphyzpp": 594839998,
    "dropmaladd": "220 W CARROLL ST",
    "dropmalcty": "SUN RIVER",
    "dropmalst": "MT",
    "dropmalzpp": 594839998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064016650,
    "dropsitcph": 4064016650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13423",
    "droptype": "D",
    "dropname": "SUNBURST",
    "dropdeladd": "28 1ST ST N",
    "dropdelcty": "SUNBURST",
    "dropdelst": "MT",
    "dropdelzpp": 594829998,
    "dropphyadd": "28 1ST ST N",
    "dropphycty": "SUNBURST",
    "dropphyst": "MT",
    "dropphyzpp": 594829998,
    "dropmaladd": "28 1ST ST N",
    "dropmalcty": "SUNBURST",
    "dropmalst": "MT",
    "dropmalzpp": 594829998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069377475,
    "dropsitcph": 4069377475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13424",
    "droptype": "D",
    "dropname": "SUPERIOR",
    "dropdeladd": "104 3RD AVE E",
    "dropdelcty": "SUPERIOR",
    "dropdelst": "MT",
    "dropdelzpp": 598729998,
    "dropphyadd": "104 3RD AVE E",
    "dropphycty": "SUPERIOR",
    "dropphyst": "MT",
    "dropphyzpp": 598729998,
    "dropmaladd": "104 3RD AVE E",
    "dropmalcty": "SUPERIOR",
    "dropmalst": "MT",
    "dropmalzpp": 598729998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068224231,
    "dropsitcph": 4068224231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13426",
    "droptype": "D",
    "dropname": "SWEET GRASS",
    "dropdeladd": "334 CHURCH ST",
    "dropdelcty": "SWEET GRASS",
    "dropdelst": "MT",
    "dropdelzpp": 594849998,
    "dropphyadd": "334 CHURCH ST",
    "dropphycty": "SWEET GRASS",
    "dropphyst": "MT",
    "dropphyzpp": 594849998,
    "dropmaladd": "334 CHURCH ST",
    "dropmalcty": "SWEET GRASS",
    "dropmalst": "MT",
    "dropmalzpp": 594849998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069195243,
    "dropsitcph": 4069195243,
    "dropfax": 4063352791
  },
  {
    "dcode": "D",
    "dropkey": "PZ13429",
    "droptype": "D",
    "dropname": "TERRY",
    "dropdeladd": "303 LOGAN AVE",
    "dropdelcty": "TERRY",
    "dropdelst": "MT",
    "dropdelzpp": 593499998,
    "dropphyadd": "303 LOGAN AVE",
    "dropphycty": "TERRY",
    "dropphyst": "MT",
    "dropphyzpp": 593499998,
    "dropmaladd": "303 LOGAN AVE",
    "dropmalcty": "TERRY",
    "dropmalst": "MT",
    "dropmalzpp": 593499998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066355345,
    "dropsitcph": 4066355345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13430",
    "droptype": "D",
    "dropname": "THOMPSON FALLS",
    "dropdeladd": "1611 MAIN ST",
    "dropdelcty": "THOMPSON FALLS",
    "dropdelst": "MT",
    "dropdelzpp": 598739998,
    "dropphyadd": "1611 MAIN ST",
    "dropphycty": "THOMPSON FALLS",
    "dropphyst": "MT",
    "dropphyzpp": 598739998,
    "dropmaladd": "1611 MAIN ST",
    "dropmalcty": "THOMPSON FALLS",
    "dropmalst": "MT",
    "dropmalzpp": 598739998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068273977,
    "dropsitcph": 4069194017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13431",
    "droptype": "D",
    "dropname": "THREE FORKS",
    "dropdeladd": "9 E FRONT ST",
    "dropdelcty": "THREE FORKS",
    "dropdelst": "MT",
    "dropdelzpp": 597529998,
    "dropphyadd": "9 E FRONT ST",
    "dropphycty": "THREE FORKS",
    "dropphyst": "MT",
    "dropphyzpp": 597529998,
    "dropmaladd": "9 E FRONT ST",
    "dropmalcty": "THREE FORKS",
    "dropmalst": "MT",
    "dropmalzpp": 597529998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062853421,
    "dropsitcph": 4062853421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13432",
    "droptype": "D",
    "dropname": "TOSTON",
    "dropdeladd": "511 MISSOURI ST",
    "dropdelcty": "TOSTON",
    "dropdelst": "MT",
    "dropdelzpp": 596439998,
    "dropphyadd": "511 MISSOURI ST",
    "dropphycty": "TOSTON",
    "dropphyst": "MT",
    "dropphyzpp": 596439998,
    "dropmaladd": "511 MISSOURI ST",
    "dropmalcty": "TOSTON",
    "dropmalst": "MT",
    "dropmalzpp": 596439998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062665772,
    "dropsitcph": 4062665772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13433",
    "droptype": "D",
    "dropname": "TOWNSEND",
    "dropdeladd": "501 S FRONT ST",
    "dropdelcty": "TOWNSEND",
    "dropdelst": "MT",
    "dropdelzpp": 596449998,
    "dropphyadd": "501 S FRONT ST",
    "dropphycty": "TOWNSEND",
    "dropphyst": "MT",
    "dropphyzpp": 596449998,
    "dropmaladd": "501 S FRONT ST",
    "dropmalcty": "TOWNSEND",
    "dropmalst": "MT",
    "dropmalzpp": 596449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062663400,
    "dropsitcph": 4062663400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13434",
    "droptype": "D",
    "dropname": "TREGO",
    "dropdeladd": "252 FORTINE CREEK RD",
    "dropdelcty": "TREGO",
    "dropdelst": "MT",
    "dropdelzpp": 599349998,
    "dropphyadd": "252 FORTINE CREEK RD",
    "dropphycty": "TREGO",
    "dropphyst": "MT",
    "dropphyzpp": 599349998,
    "dropmaladd": "252 FORTINE CREEK RD",
    "dropmalcty": "TREGO",
    "dropmalst": "MT",
    "dropmalzpp": 599349998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068824651,
    "dropsitcph": 4068824651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13436",
    "droptype": "D",
    "dropname": "TROUT CREEK",
    "dropdeladd": "2971 MT HIGHWAY 200",
    "dropdelcty": "TROUT CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 598749998,
    "dropphyadd": "2971 MT HIGHWAY 200",
    "dropphycty": "TROUT CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 598749998,
    "dropmaladd": "2971 MT HIGHWAY 200",
    "dropmalcty": "TROUT CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 598749998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194128,
    "dropsitcph": 4069194128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13437",
    "droptype": "D",
    "dropname": "TROY",
    "dropdeladd": "123 E KOOTENAI AVE",
    "dropdelcty": "TROY",
    "dropdelst": "MT",
    "dropdelzpp": 599359998,
    "dropphyadd": "123 E KOOTENAI AVE",
    "dropphycty": "TROY",
    "dropphyst": "MT",
    "dropphyzpp": 599359998,
    "dropmaladd": "123 E KOOTENAI AVE",
    "dropmalcty": "TROY",
    "dropmalst": "MT",
    "dropmalzpp": 599359998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062954021,
    "dropsitcph": 4062954021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13439",
    "droptype": "D",
    "dropname": "TURNER",
    "dropdeladd": "102 MAIN ST",
    "dropdelcty": "TURNER",
    "dropdelst": "MT",
    "dropdelzpp": 595429998,
    "dropphyadd": "102 MAIN ST",
    "dropphycty": "TURNER",
    "dropphyst": "MT",
    "dropphyzpp": 595429998,
    "dropmaladd": "102 MAIN ST",
    "dropmalcty": "TURNER",
    "dropmalst": "MT",
    "dropmalzpp": 595429998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006760,
    "dropsitcph": 4068006760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13440",
    "droptype": "D",
    "dropname": "TWIN BRIDGES",
    "dropdeladd": "101 S MAIN ST",
    "dropdelcty": "TWIN BRIDGES",
    "dropdelst": "MT",
    "dropdelzpp": 597549998,
    "dropphyadd": "101 S MAIN ST",
    "dropphycty": "TWIN BRIDGES",
    "dropphyst": "MT",
    "dropphyzpp": 597549998,
    "dropmaladd": "101 S MAIN ST",
    "dropmalcty": "TWIN BRIDGES",
    "dropmalst": "MT",
    "dropmalzpp": 597549998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066845486,
    "dropsitcph": 4066845486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13441",
    "droptype": "D",
    "dropname": "TWO DOT",
    "dropdeladd": "68 TWO DOT HWY",
    "dropdelcty": "TWO DOT",
    "dropdelst": "MT",
    "dropdelzpp": 590859998,
    "dropphyadd": "68 TWO DOT HWY",
    "dropphycty": "TWO DOT",
    "dropphyst": "MT",
    "dropphyzpp": 590859998,
    "dropmaladd": "68 TWO DOT HWY",
    "dropmalcty": "TWO DOT",
    "dropmalst": "MT",
    "dropmalzpp": 590859998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066324410,
    "dropsitcph": 4066324410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13442",
    "droptype": "D",
    "dropname": "ULM",
    "dropdeladd": "6 MILLEGAN RD",
    "dropdelcty": "ULM",
    "dropdelst": "MT",
    "dropdelzpp": 594859998,
    "dropphyadd": "6 MILLEGAN RD",
    "dropphycty": "ULM",
    "dropphyst": "MT",
    "dropphyzpp": 594859998,
    "dropmaladd": "6 MILLEGAN RD",
    "dropmalcty": "ULM",
    "dropmalst": "MT",
    "dropmalzpp": 594859998,
    "dropsitphn": 4068663580,
    "dropsitlph": 4064016695,
    "dropsitcph": 4064016695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13445",
    "droptype": "D",
    "dropname": "VALIER",
    "dropdeladd": "515 MONTANA",
    "dropdelcty": "VALIER",
    "dropdelst": "MT",
    "dropdelzpp": 594869998,
    "dropphyadd": "515 MONTANA",
    "dropphycty": "VALIER",
    "dropphyst": "MT",
    "dropphyzpp": 594869998,
    "dropmaladd": "515 MONTANA",
    "dropmalcty": "VALIER",
    "dropmalst": "MT",
    "dropmalzpp": 594869998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062793313,
    "dropsitcph": 4062793313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13447",
    "droptype": "D",
    "dropname": "VAUGHN",
    "dropdeladd": "380 POST AVE",
    "dropdelcty": "VAUGHN",
    "dropdelst": "MT",
    "dropdelzpp": 594879998,
    "dropphyadd": "380 POST AVE",
    "dropphycty": "VAUGHN",
    "dropphyst": "MT",
    "dropphyzpp": 594879998,
    "dropmaladd": "380 POST AVE",
    "dropmalcty": "VAUGHN",
    "dropmalst": "MT",
    "dropmalzpp": 594879998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069652612,
    "dropsitcph": 4069652612,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13448",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "VICTOR",
    "dropdelst": "MT",
    "dropdelzpp": 598759998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "VICTOR",
    "dropphyst": "MT",
    "dropphyzpp": 598759998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "VICTOR",
    "dropmalst": "MT",
    "dropmalzpp": 598759998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066423361,
    "dropsitcph": 4066423361,
    "dropfax": 4066423153
  },
  {
    "dcode": "D",
    "dropkey": "PZ13449",
    "droptype": "D",
    "dropname": "VIDA",
    "dropdeladd": "2991 MT HIGHWAY 13",
    "dropdelcty": "VIDA",
    "dropdelst": "MT",
    "dropdelzpp": 592749998,
    "dropphyadd": "2991 MT HIGHWAY 13",
    "dropphycty": "VIDA",
    "dropphyst": "MT",
    "dropphyzpp": 592749998,
    "dropmaladd": "2991 MT HIGHWAY 13",
    "dropmalcty": "VIDA",
    "dropmalst": "MT",
    "dropmalzpp": 592749998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069194284,
    "dropsitcph": 4069194284,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13450",
    "droptype": "D",
    "dropname": "VIRGINIA CITY",
    "dropdeladd": "209 W WALLACE",
    "dropdelcty": "VIRGINIA CITY",
    "dropdelst": "MT",
    "dropdelzpp": 597559998,
    "dropphyadd": "209 W WALLACE",
    "dropphycty": "VIRGINIA CITY",
    "dropphyst": "MT",
    "dropphyzpp": 597559998,
    "dropmaladd": "209 W WALLACE",
    "dropmalcty": "VIRGINIA CITY",
    "dropmalst": "MT",
    "dropmalzpp": 597559998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068435339,
    "dropsitcph": 4068435339,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13451",
    "droptype": "D",
    "dropname": "VOLBORG",
    "dropdeladd": "2708 HIGHWAY 59",
    "dropdelcty": "VOLBORG",
    "dropdelst": "MT",
    "dropdelzpp": 593519998,
    "dropphyadd": "2708 HIGHWAY 59",
    "dropphycty": "VOLBORG",
    "dropphyst": "MT",
    "dropphyzpp": 593519998,
    "dropmaladd": "2708 HIGHWAY 59",
    "dropmalcty": "VOLBORG",
    "dropmalst": "MT",
    "dropmalzpp": 593519998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064215300,
    "dropsitcph": 4064215300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13455",
    "droptype": "D",
    "dropname": "WARM SPRINGS",
    "dropdeladd": "22 GARNET WAY",
    "dropdelcty": "WARM SPRINGS",
    "dropdelst": "MT",
    "dropdelzpp": 597569998,
    "dropphyadd": "22 GARNET WAY",
    "dropphycty": "WARM SPRINGS",
    "dropphyst": "MT",
    "dropphyzpp": 597569998,
    "dropmaladd": "22 GARNET WAY",
    "dropmalcty": "WARM SPRINGS",
    "dropmalst": "MT",
    "dropmalzpp": 597569998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066932369,
    "dropsitcph": 4066932369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13459",
    "droptype": "D",
    "dropname": "WEST GLACIER",
    "dropdeladd": "110 GOING TO THE SUN RD",
    "dropdelcty": "WEST GLACIER",
    "dropdelst": "MT",
    "dropdelzpp": 599369998,
    "dropphyadd": "110 GOING TO THE SUN RD",
    "dropphycty": "WEST GLACIER",
    "dropphyst": "MT",
    "dropphyzpp": 599369998,
    "dropmaladd": "110 GOING TO THE SUN RD",
    "dropmalcty": "WEST GLACIER",
    "dropmalst": "MT",
    "dropmalzpp": 599369998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066121004,
    "dropsitcph": 4066121004,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13460",
    "droptype": "D",
    "dropname": "WEST YELLOWSTONE",
    "dropdeladd": "209 GRIZZLY AVE",
    "dropdelcty": "WEST YELLOWSTONE",
    "dropdelst": "MT",
    "dropdelzpp": 597589998,
    "dropphyadd": "209 GRIZZLY AVE",
    "dropphycty": "WEST YELLOWSTONE",
    "dropphyst": "MT",
    "dropphyzpp": 597589998,
    "dropmaladd": "209 GRIZZLY AVE",
    "dropmalcty": "WEST YELLOWSTONE",
    "dropmalst": "MT",
    "dropmalzpp": 597589998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066467704,
    "dropsitcph": 4066467704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13461",
    "droptype": "D",
    "dropname": "WESTBY",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "WESTBY",
    "dropdelst": "MT",
    "dropdelzpp": 592759998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "WESTBY",
    "dropphyst": "MT",
    "dropphyzpp": 592759998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "WESTBY",
    "dropmalst": "MT",
    "dropmalzpp": 592759998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068130787,
    "dropsitcph": 4068130787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13462",
    "droptype": "D",
    "dropname": "WHITE SULPHUR SPRINGS",
    "dropdeladd": "103 W MAIN ST",
    "dropdelcty": "WHITE SULPHUR SPRINGS",
    "dropdelst": "MT",
    "dropdelzpp": 596459998,
    "dropphyadd": "103 W MAIN ST",
    "dropphycty": "WHITE SULPHUR SPRINGS",
    "dropphyst": "MT",
    "dropphyzpp": 596459998,
    "dropmaladd": "103 W MAIN ST",
    "dropmalcty": "WHITE SULPHUR SPRINGS",
    "dropmalst": "MT",
    "dropmalzpp": 596459998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065473360,
    "dropsitcph": 4065305250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13463",
    "droptype": "D",
    "dropname": "WHITEFISH",
    "dropdeladd": "424 BAKER AVE",
    "dropdelcty": "WHITEFISH",
    "dropdelst": "MT",
    "dropdelzpp": 599379998,
    "dropphyadd": "424 BAKER AVE",
    "dropphycty": "WHITEFISH",
    "dropphyst": "MT",
    "dropphyzpp": 599379998,
    "dropmaladd": "424 BAKER AVE",
    "dropmalcty": "WHITEFISH",
    "dropmalst": "MT",
    "dropmalzpp": 599379998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068622151,
    "dropsitcph": 4068622151,
    "dropfax": 4068627385
  },
  {
    "dcode": "D",
    "dropkey": "PZ13464",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "15 N MAIN ST",
    "dropdelcty": "WHITEHALL",
    "dropdelst": "MT",
    "dropdelzpp": 597599998,
    "dropphyadd": "15 N MAIN ST",
    "dropphycty": "WHITEHALL",
    "dropphyst": "MT",
    "dropphyzpp": 597599998,
    "dropmaladd": "15 N MAIN ST",
    "dropmalcty": "WHITEHALL",
    "dropmalst": "MT",
    "dropmalzpp": 597599998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062873822,
    "dropsitcph": 4062873822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13465",
    "droptype": "D",
    "dropname": "WHITETAIL",
    "dropdeladd": "106 MAIN ST",
    "dropdelcty": "WHITETAIL",
    "dropdelst": "MT",
    "dropdelzpp": 592769998,
    "dropphyadd": "106 MAIN ST",
    "dropphycty": "WHITETAIL",
    "dropphyst": "MT",
    "dropphyzpp": 592769998,
    "dropmaladd": "106 MAIN ST",
    "dropmalcty": "WHITETAIL",
    "dropmalst": "MT",
    "dropmalzpp": 592769998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068132034,
    "dropsitcph": 8773646506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13466",
    "droptype": "D",
    "dropname": "WHITEWATER",
    "dropdeladd": "66 1ST AVE E",
    "dropdelcty": "WHITEWATER",
    "dropdelst": "MT",
    "dropdelzpp": 595449998,
    "dropphyadd": "66 1ST AVE E",
    "dropphycty": "WHITEWATER",
    "dropphyst": "MT",
    "dropphyzpp": 595449998,
    "dropmaladd": "66 1ST AVE E",
    "dropmalcty": "WHITEWATER",
    "dropmalst": "MT",
    "dropmalzpp": 595449998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006756,
    "dropsitcph": 4068006756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13467",
    "droptype": "D",
    "dropname": "WHITLASH",
    "dropdeladd": "645 WHITLASH RD",
    "dropdelcty": "WHITLASH",
    "dropdelst": "MT",
    "dropdelzpp": 595459998,
    "dropphyadd": "645 WHITLASH RD",
    "dropphycty": "WHITLASH",
    "dropphyst": "MT",
    "dropphyzpp": 595459998,
    "dropmaladd": "645 WHITLASH RD",
    "dropmalcty": "WHITLASH",
    "dropmalst": "MT",
    "dropmalzpp": 595459998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064325200,
    "dropsitcph": 4064325200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13468",
    "droptype": "D",
    "dropname": "WIBAUX",
    "dropdeladd": "211 WIBAUX ST S",
    "dropdelcty": "WIBAUX",
    "dropdelst": "MT",
    "dropdelzpp": 593539998,
    "dropphyadd": "211 WIBAUX ST S",
    "dropphycty": "WIBAUX",
    "dropphyst": "MT",
    "dropphyzpp": 593539998,
    "dropmaladd": "211 WIBAUX ST S",
    "dropmalcty": "WIBAUX",
    "dropmalst": "MT",
    "dropmalzpp": 593539998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067962536,
    "dropsitcph": 4067962536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13470",
    "droptype": "D",
    "dropname": "WILLOW CREEK",
    "dropdeladd": "14 MAIN ST",
    "dropdelcty": "WILLOW CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 597609998,
    "dropphyadd": "14 MAIN ST",
    "dropphycty": "WILLOW CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 597609998,
    "dropmaladd": "14 MAIN ST",
    "dropmalcty": "WILLOW CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 597609998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062856727,
    "dropsitcph": 4062856727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13471",
    "droptype": "D",
    "dropname": "WILSALL",
    "dropdeladd": "310 ELLIOT ST N",
    "dropdelcty": "WILSALL",
    "dropdelst": "MT",
    "dropdelzpp": 590869998,
    "dropphyadd": "310 ELLIOT ST N",
    "dropphycty": "WILSALL",
    "dropphyst": "MT",
    "dropphyzpp": 590869998,
    "dropmaladd": "310 ELLIOT ST N",
    "dropmalcty": "WILSALL",
    "dropmalst": "MT",
    "dropmalzpp": 590869998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065783267,
    "dropsitcph": 4065783267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13473",
    "droptype": "D",
    "dropname": "WINIFRED",
    "dropdeladd": "210 MAIN ST",
    "dropdelcty": "WINIFRED",
    "dropdelst": "MT",
    "dropdelzpp": 594899998,
    "dropphyadd": "210 MAIN ST",
    "dropphycty": "WINIFRED",
    "dropphyst": "MT",
    "dropphyzpp": 594899998,
    "dropmaladd": "210 MAIN ST",
    "dropmalcty": "WINIFRED",
    "dropmalst": "MT",
    "dropmalzpp": 594899998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064625370,
    "dropsitcph": 4064625370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13474",
    "droptype": "D",
    "dropname": "WINNETT",
    "dropdeladd": "5 W MAIN ST",
    "dropdelcty": "WINNETT",
    "dropdelst": "MT",
    "dropdelzpp": 590879998,
    "dropphyadd": "5 W MAIN ST",
    "dropphycty": "WINNETT",
    "dropphyst": "MT",
    "dropphyzpp": 590879998,
    "dropmaladd": "5 W MAIN ST",
    "dropmalcty": "WINNETT",
    "dropmalst": "MT",
    "dropmalzpp": 590879998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064295111,
    "dropsitcph": 8779076162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13476",
    "droptype": "D",
    "dropname": "WISDOM",
    "dropdeladd": "200 MAIN ST",
    "dropdelcty": "WISDOM",
    "dropdelst": "MT",
    "dropdelzpp": 597619998,
    "dropphyadd": "200 MAIN ST",
    "dropphycty": "WISDOM",
    "dropphyst": "MT",
    "dropphyzpp": 597619998,
    "dropmaladd": "200 MAIN ST",
    "dropmalcty": "WISDOM",
    "dropmalst": "MT",
    "dropmalzpp": 597619998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066893224,
    "dropsitcph": 4066893224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13477",
    "droptype": "D",
    "dropname": "WISE RIVER",
    "dropdeladd": "65209 MT HIGHWAY 43",
    "dropdelcty": "WISE RIVER",
    "dropdelst": "MT",
    "dropdelzpp": 597629998,
    "dropphyadd": "65209 MT HIGHWAY 43",
    "dropphycty": "WISE RIVER",
    "dropphyst": "MT",
    "dropphyzpp": 597629998,
    "dropmaladd": "65209 MT HIGHWAY 43",
    "dropmalcty": "WISE RIVER",
    "dropmalst": "MT",
    "dropmalzpp": 597629998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068323280,
    "dropsitcph": 4068323280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13478",
    "droptype": "D",
    "dropname": "WOLF CREEK",
    "dropdeladd": "250 MAIN ST",
    "dropdelcty": "WOLF CREEK",
    "dropdelst": "MT",
    "dropdelzpp": 596489998,
    "dropphyadd": "250 MAIN ST",
    "dropphycty": "WOLF CREEK",
    "dropphyst": "MT",
    "dropphyzpp": 596489998,
    "dropmaladd": "250 MAIN ST",
    "dropmalcty": "WOLF CREEK",
    "dropmalst": "MT",
    "dropmalzpp": 596489998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062354220,
    "dropsitcph": 4062354220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13480",
    "droptype": "D",
    "dropname": "WOLF POINT",
    "dropdeladd": "131 FRONT ST",
    "dropdelcty": "WOLF POINT",
    "dropdelst": "MT",
    "dropdelzpp": 592019998,
    "dropphyadd": "131 FRONT ST",
    "dropphycty": "WOLF POINT",
    "dropphyst": "MT",
    "dropphyzpp": 592019998,
    "dropmaladd": "131 FRONT ST",
    "dropmalcty": "WOLF POINT",
    "dropmalst": "MT",
    "dropmalzpp": 592019998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066532802,
    "dropsitcph": 4066532802,
    "dropfax": 4066533650
  },
  {
    "dcode": "D",
    "dropkey": "PZ13481",
    "droptype": "D",
    "dropname": "WORDEN",
    "dropdeladd": "2427 MAIN ST",
    "dropdelcty": "WORDEN",
    "dropdelst": "MT",
    "dropdelzpp": 590889998,
    "dropphyadd": "2427 MAIN ST",
    "dropphycty": "WORDEN",
    "dropphyst": "MT",
    "dropphyzpp": 590889998,
    "dropmaladd": "2427 MAIN ST",
    "dropmalcty": "WORDEN",
    "dropmalst": "MT",
    "dropmalzpp": 590889998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4069673589,
    "dropsitcph": 4069673589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13482",
    "droptype": "D",
    "dropname": "WYOLA",
    "dropdeladd": "15 S MONDELL AVE",
    "dropdelcty": "WYOLA",
    "dropdelst": "MT",
    "dropdelzpp": 590899998,
    "dropphyadd": "15 S MONDELL AVE",
    "dropphycty": "WYOLA",
    "dropphyst": "MT",
    "dropphyzpp": 590899998,
    "dropmaladd": "15 S MONDELL AVE",
    "dropmalcty": "WYOLA",
    "dropmalst": "MT",
    "dropmalzpp": 590899998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063432131,
    "dropsitcph": 4063432131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13485",
    "droptype": "D",
    "dropname": "ZORTMAN",
    "dropdeladd": "157 WHITCOMB ST",
    "dropdelcty": "ZORTMAN",
    "dropdelst": "MT",
    "dropdelzpp": 595469998,
    "dropphyadd": "157 WHITCOMB ST",
    "dropphycty": "ZORTMAN",
    "dropphyst": "MT",
    "dropphyzpp": 595469998,
    "dropmaladd": "157 WHITCOMB ST",
    "dropmalcty": "ZORTMAN",
    "dropmalst": "MT",
    "dropmalzpp": 595469998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4068006752,
    "dropsitcph": 4068006752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13486",
    "droptype": "D",
    "dropname": "ZURICH",
    "dropdeladd": "150 1ST AVE",
    "dropdelcty": "ZURICH",
    "dropdelst": "MT",
    "dropdelzpp": 595479998,
    "dropphyadd": "150 1ST AVE",
    "dropphycty": "ZURICH",
    "dropphyst": "MT",
    "dropphyzpp": 595479998,
    "dropmaladd": "150 1ST AVE",
    "dropmalcty": "ZURICH",
    "dropmalst": "MT",
    "dropmalzpp": 595479998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4063574242,
    "dropsitcph": 4069195376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13489",
    "droptype": "D",
    "dropname": "ABIQUIU",
    "dropdeladd": "4 COUNTY ROAD 187",
    "dropdelcty": "ABIQUIU",
    "dropdelst": "NM",
    "dropdelzpp": 875109998,
    "dropphyadd": "4 COUNTY ROAD 187",
    "dropphycty": "ABIQUIU",
    "dropphyst": "NM",
    "dropphyzpp": 875109998,
    "dropmaladd": "4 COUNTY ROAD 187",
    "dropmalcty": "ABIQUIU",
    "dropmalst": "NM",
    "dropmalzpp": 875109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056854460,
    "dropsitcph": 5056854460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13500",
    "droptype": "D",
    "dropname": "ALAMOGORDO",
    "dropdeladd": "930 12TH ST",
    "dropdelcty": "ALAMOGORDO",
    "dropdelst": "NM",
    "dropdelzpp": 883109998,
    "dropphyadd": "930 12TH ST",
    "dropphycty": "ALAMOGORDO",
    "dropphyst": "NM",
    "dropphyzpp": 883109998,
    "dropmaladd": "930 12TH ST",
    "dropmalcty": "ALAMOGORDO",
    "dropmalst": "NM",
    "dropmalzpp": 883109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754379390,
    "dropsitcph": 5754379390,
    "dropfax": 5754374713
  },
  {
    "dcode": "D",
    "dropkey": "PZ13505",
    "droptype": "D",
    "dropname": "ALBUQUERQUE",
    "dropdeladd": "1135 BROADWAY BLVD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871010001,
    "dropphyadd": "1135 BROADWAY BLVD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871010001,
    "dropmaladd": "1135 BROADWAY BLVD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871010001,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468053,
    "dropsitcph": 5053468052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13506",
    "droptype": "D",
    "dropname": "ALCALDE",
    "dropdeladd": "1 COUNTY ROAD 37",
    "dropdelcty": "ALCALDE",
    "dropdelst": "NM",
    "dropdelzpp": 875119998,
    "dropphyadd": "1 COUNTY ROAD 37",
    "dropphycty": "ALCALDE",
    "dropphyst": "NM",
    "dropphyzpp": 875119998,
    "dropmaladd": "1 COUNTY ROAD 37",
    "dropmalcty": "ALCALDE",
    "dropmalst": "NM",
    "dropmalzpp": 875119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058524382,
    "dropsitcph": 5058524382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13510",
    "droptype": "D",
    "dropname": "ALTO",
    "dropdeladd": "100 SUN VALLEY RD",
    "dropdelcty": "ALTO",
    "dropdelst": "NM",
    "dropdelzpp": 883129800,
    "dropphyadd": "100 SUN VALLEY RD",
    "dropphycty": "ALTO",
    "dropphyst": "NM",
    "dropphyzpp": 883129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALTO",
    "dropmalst": "NM",
    "dropmalzpp": 883129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753364341,
    "dropsitcph": 5753364341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13512",
    "droptype": "D",
    "dropname": "AMALIA",
    "dropdeladd": "650 STATE HIGHWAY 196",
    "dropdelcty": "AMALIA",
    "dropdelst": "NM",
    "dropdelzpp": 875129998,
    "dropphyadd": "650 STATE HIGHWAY 196",
    "dropphycty": "AMALIA",
    "dropphyst": "NM",
    "dropphyzpp": 875129998,
    "dropmaladd": "650 STATE HIGHWAY 196",
    "dropmalcty": "AMALIA",
    "dropmalst": "NM",
    "dropmalzpp": 875129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755862112,
    "dropsitcph": 5755862112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13514",
    "droptype": "D",
    "dropname": "AMISTAD",
    "dropdeladd": "21 AMISTAD RD",
    "dropdelcty": "AMISTAD",
    "dropdelst": "NM",
    "dropdelzpp": 884109998,
    "dropphyadd": "21 AMISTAD RD",
    "dropphycty": "AMISTAD",
    "dropphyst": "NM",
    "dropphyzpp": 884109998,
    "dropmaladd": "21 AMISTAD RD",
    "dropmalcty": "AMISTAD",
    "dropmalst": "NM",
    "dropmalzpp": 884109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756290228,
    "dropsitcph": 5756290228,
    "dropfax": 5756290016
  },
  {
    "dcode": "D",
    "dropkey": "PZ13519",
    "droptype": "D",
    "dropname": "ANIMAS",
    "dropdeladd": "2415 STATE HIGHWAY 338",
    "dropdelcty": "ANIMAS",
    "dropdelst": "NM",
    "dropdelzpp": 880209800,
    "dropphyadd": "2415 STATE HIGHWAY 338",
    "dropphycty": "ANIMAS",
    "dropphyst": "NM",
    "dropphyzpp": 880209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANIMAS",
    "dropmalst": "NM",
    "dropmalzpp": 880209998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755482240,
    "dropsitcph": 5755482240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13520",
    "droptype": "D",
    "dropname": "ANTHONY",
    "dropdeladd": "1190 ANTHONY DR",
    "dropdelcty": "ANTHONY",
    "dropdelst": "NM",
    "dropdelzpp": 880219800,
    "dropphyadd": "1190 ANTHONY DR",
    "dropphycty": "ANTHONY",
    "dropphyst": "NM",
    "dropphyzpp": 880219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANTHONY",
    "dropmalst": "NM",
    "dropmalzpp": 880219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758825259,
    "dropsitcph": 5758825259,
    "dropfax": 5758822962
  },
  {
    "dcode": "D",
    "dropkey": "PZ13521",
    "droptype": "D",
    "dropname": "ANTON CHICO",
    "dropdeladd": "1067 STATE HIGHWAY 386",
    "dropdelcty": "ANTON CHICO",
    "dropdelst": "NM",
    "dropdelzpp": 877119998,
    "dropphyadd": "1067 STATE HIGHWAY 386",
    "dropphycty": "ANTON CHICO",
    "dropphyst": "NM",
    "dropphyzpp": 877119998,
    "dropmaladd": "1067 STATE HIGHWAY 386",
    "dropmalcty": "ANTON CHICO",
    "dropmalst": "NM",
    "dropmalzpp": 877119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754463795,
    "dropsitcph": 5754463795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13528",
    "droptype": "D",
    "dropname": "ARREY",
    "dropdeladd": "13717 HIGHWAY 187",
    "dropdelcty": "ARREY",
    "dropdelst": "NM",
    "dropdelzpp": 879309800,
    "dropphyadd": "13717 HIGHWAY 187",
    "dropphycty": "ARREY",
    "dropphyst": "NM",
    "dropphyzpp": 879309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARREY",
    "dropmalst": "NM",
    "dropmalzpp": 879309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752676227,
    "dropsitcph": 5752676227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13529",
    "droptype": "D",
    "dropname": "ARROYO HONDO",
    "dropdeladd": "12 OLD STATE ROAD 3",
    "dropdelcty": "ARROYO HONDO",
    "dropdelst": "NM",
    "dropdelzpp": 875139998,
    "dropphyadd": "12 OLD STATE ROAD 3",
    "dropphycty": "ARROYO HONDO",
    "dropphyst": "NM",
    "dropphyzpp": 875139998,
    "dropmaladd": "12 OLD STATE ROAD 3",
    "dropmalcty": "ARROYO HONDO",
    "dropmalst": "NM",
    "dropmalzpp": 875139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757413203,
    "dropsitcph": 5757413203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13530",
    "droptype": "D",
    "dropname": "ARROYO SECO",
    "dropdeladd": "505 STATE HIGHWAY 150",
    "dropdelcty": "ARROYO SECO",
    "dropdelst": "NM",
    "dropdelzpp": 875149998,
    "dropphyadd": "505 STATE HIGHWAY 150",
    "dropphycty": "ARROYO SECO",
    "dropphyst": "NM",
    "dropphyzpp": 875149998,
    "dropmaladd": "505 STATE HIGHWAY 150",
    "dropmalcty": "ARROYO SECO",
    "dropmalst": "NM",
    "dropmalzpp": 875149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757761936,
    "dropsitcph": 5757761936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13531",
    "droptype": "D",
    "dropname": "ARTESIA",
    "dropdeladd": "201 N 4TH ST",
    "dropdelcty": "ARTESIA",
    "dropdelst": "NM",
    "dropdelzpp": 882109998,
    "dropphyadd": "201 N 4TH ST",
    "dropphycty": "ARTESIA",
    "dropphyst": "NM",
    "dropphyzpp": 882109998,
    "dropmaladd": "201 N 4TH ST",
    "dropmalcty": "ARTESIA",
    "dropmalst": "NM",
    "dropmalzpp": 882109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757464412,
    "dropsitcph": 5757464412,
    "dropfax": 5757469751
  },
  {
    "dcode": "D",
    "dropkey": "PZ13536",
    "droptype": "D",
    "dropname": "AZTEC",
    "dropdeladd": "601 S RIO GRANDE AVE",
    "dropdelcty": "AZTEC",
    "dropdelst": "NM",
    "dropdelzpp": 874109998,
    "dropphyadd": "601 S RIO GRANDE AVE",
    "dropphycty": "AZTEC",
    "dropphyst": "NM",
    "dropphyzpp": 874109998,
    "dropmaladd": "601 S RIO GRANDE AVE",
    "dropmalcty": "AZTEC",
    "dropmalst": "NM",
    "dropmalzpp": 874109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053346181,
    "dropsitcph": 5053346181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13540",
    "droptype": "D",
    "dropname": "BAYARD",
    "dropdeladd": "810 CENTRAL AVE",
    "dropdelcty": "BAYARD",
    "dropdelst": "NM",
    "dropdelzpp": 880239800,
    "dropphyadd": "810 CENTRAL AVE",
    "dropphycty": "BAYARD",
    "dropphyst": "NM",
    "dropphyzpp": 880239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAYARD",
    "dropmalst": "NM",
    "dropmalzpp": 880239998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755375168,
    "dropsitcph": 5755375168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13541",
    "droptype": "D",
    "dropname": "BELEN",
    "dropdeladd": "400 N MAIN ST",
    "dropdelcty": "BELEN",
    "dropdelst": "NM",
    "dropdelzpp": 870029998,
    "dropphyadd": "400 N MAIN ST",
    "dropphycty": "BELEN",
    "dropphyst": "NM",
    "dropphyzpp": 870029998,
    "dropmaladd": "400 N MAIN ST",
    "dropmalcty": "BELEN",
    "dropmalst": "NM",
    "dropmalzpp": 870029998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058648571,
    "dropsitcph": 5058648571,
    "dropfax": 5058649576
  },
  {
    "dcode": "D",
    "dropkey": "PZ13545",
    "droptype": "D",
    "dropname": "BENT",
    "dropdeladd": "21 BENT RD",
    "dropdelcty": "BENT",
    "dropdelst": "NM",
    "dropdelzpp": 883149800,
    "dropphyadd": "21 BENT RD",
    "dropphycty": "BENT",
    "dropphyst": "NM",
    "dropphyzpp": 883149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BENT",
    "dropmalst": "NM",
    "dropmalzpp": 883149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756719147,
    "dropsitcph": 5756719147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13548",
    "droptype": "D",
    "dropname": "BERNALILLO",
    "dropdeladd": "145 CALLE DEL PRESIDENTE",
    "dropdelcty": "BERNALILLO",
    "dropdelst": "NM",
    "dropdelzpp": 870049998,
    "dropphyadd": "145 CALLE DEL PRESIDENTE",
    "dropphycty": "BERNALILLO",
    "dropphyst": "NM",
    "dropphyzpp": 870049998,
    "dropmaladd": "145 CALLE DEL PRESIDENTE",
    "dropmalcty": "BERNALILLO",
    "dropmalst": "NM",
    "dropmalzpp": 870049998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057718822,
    "dropsitcph": 5057718822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13555",
    "droptype": "D",
    "dropname": "BLANCO",
    "dropdeladd": "7367 US 64",
    "dropdelcty": "BLANCO",
    "dropdelst": "NM",
    "dropdelzpp": 874129998,
    "dropphyadd": "7367 US 64",
    "dropphycty": "BLANCO",
    "dropphyst": "NM",
    "dropphyzpp": 874129998,
    "dropmaladd": "7367 US 64",
    "dropmalcty": "BLANCO",
    "dropmalst": "NM",
    "dropmalzpp": 874129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056328481,
    "dropsitcph": 5056328481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13556",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "1108 W BROADWAY AVE",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NM",
    "dropdelzpp": 874139998,
    "dropphyadd": "1108 W BROADWAY AVE",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NM",
    "dropphyzpp": 874139998,
    "dropmaladd": "1108 W BROADWAY AVE",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NM",
    "dropmalzpp": 874139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056323050,
    "dropsitcph": 5056323050,
    "dropfax": 5056320213
  },
  {
    "dcode": "D",
    "dropkey": "PZ13557",
    "droptype": "D",
    "dropname": "BLUEWATER",
    "dropdeladd": "75 MAIN ST",
    "dropdelcty": "BLUEWATER",
    "dropdelst": "NM",
    "dropdelzpp": 870059998,
    "dropphyadd": "75 MAIN ST",
    "dropphycty": "BLUEWATER",
    "dropphyst": "NM",
    "dropphyzpp": 870059998,
    "dropmaladd": "75 MAIN ST",
    "dropmalcty": "BLUEWATER",
    "dropmalst": "NM",
    "dropmalzpp": 870059998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058764957,
    "dropsitcph": 5058764957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13559",
    "droptype": "D",
    "dropname": "BOSQUE",
    "dropdeladd": "1002 S HIGHWAY 116",
    "dropdelcty": "BOSQUE",
    "dropdelst": "NM",
    "dropdelzpp": 870069998,
    "dropphyadd": "1002 S HIGHWAY 116",
    "dropphycty": "BOSQUE",
    "dropphyst": "NM",
    "dropphyzpp": 870069998,
    "dropmaladd": "1002 S HIGHWAY 116",
    "dropmalcty": "BOSQUE",
    "dropmalst": "NM",
    "dropmalzpp": 870069998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058642366,
    "dropsitcph": 5058642366,
    "dropfax": 5058610915
  },
  {
    "dcode": "D",
    "dropkey": "PZ13567",
    "droptype": "D",
    "dropname": "BUCKHORN",
    "dropdeladd": "7658 HIGHWAY 180 W",
    "dropdelcty": "BUCKHORN",
    "dropdelst": "NM",
    "dropdelzpp": 880259800,
    "dropphyadd": "7658 HIGHWAY 180 W",
    "dropphycty": "BUCKHORN",
    "dropphyst": "NM",
    "dropphyzpp": 880259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCKHORN",
    "dropmalst": "NM",
    "dropmalzpp": 880259998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755354171,
    "dropsitcph": 5755354171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13569",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "2191 STATE HIGHWAY 518",
    "dropdelcty": "BUENA VISTA",
    "dropdelst": "NM",
    "dropdelzpp": 877129998,
    "dropphyadd": "2191 STATE HIGHWAY 518",
    "dropphycty": "BUENA VISTA",
    "dropphyst": "NM",
    "dropphyzpp": 877129998,
    "dropmaladd": "2191 STATE HIGHWAY 518",
    "dropmalcty": "BUENA VISTA",
    "dropmalst": "NM",
    "dropmalzpp": 877129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752142577,
    "dropsitcph": 5752142577,
    "dropfax": 5753879048
  },
  {
    "dcode": "D",
    "dropkey": "PZ13572",
    "droptype": "D",
    "dropname": "CABALLO",
    "dropdeladd": "14730 HIGHWAY 187",
    "dropdelcty": "CABALLO",
    "dropdelst": "NM",
    "dropdelzpp": 879319800,
    "dropphyadd": "14730 HIGHWAY 187",
    "dropphycty": "CABALLO",
    "dropphyst": "NM",
    "dropphyzpp": 879319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CABALLO",
    "dropmalst": "NM",
    "dropmalzpp": 879319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757439703,
    "dropsitcph": 5757439703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13577",
    "droptype": "D",
    "dropname": "CANJILON",
    "dropdeladd": "385 STATE ROAD 115",
    "dropdelcty": "CANJILON",
    "dropdelst": "NM",
    "dropdelzpp": 875159998,
    "dropphyadd": "385 STATE ROAD 115",
    "dropphycty": "CANJILON",
    "dropphyst": "NM",
    "dropphyzpp": 875159998,
    "dropmaladd": "385 STATE ROAD 115",
    "dropmalcty": "CANJILON",
    "dropmalst": "NM",
    "dropmalzpp": 875159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752560103,
    "dropsitcph": 5752560103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13586",
    "droptype": "D",
    "dropname": "CAPITAN",
    "dropdeladd": "226 E SMOKEY BEAR BLVD",
    "dropdelcty": "CAPITAN",
    "dropdelst": "NM",
    "dropdelzpp": 883169800,
    "dropphyadd": "226 E SMOKEY BEAR BLVD",
    "dropphycty": "CAPITAN",
    "dropphyst": "NM",
    "dropphyzpp": 883169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAPITAN",
    "dropmalst": "NM",
    "dropmalzpp": 883169998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756863097,
    "dropsitcph": 5756863097,
    "dropfax": 5756863095
  },
  {
    "dcode": "D",
    "dropkey": "PZ13590",
    "droptype": "D",
    "dropname": "CARLSBAD",
    "dropdeladd": "204 W SHAW ST",
    "dropdelcty": "CARLSBAD",
    "dropdelst": "NM",
    "dropdelzpp": 882206290,
    "dropphyadd": "204 W SHAW ST",
    "dropphycty": "CARLSBAD",
    "dropphyst": "NM",
    "dropphyzpp": 882206290,
    "dropmaladd": "204 W SHAW ST",
    "dropmalcty": "CARLSBAD",
    "dropmalst": "NM",
    "dropmalzpp": 882206290,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758875757,
    "dropsitcph": 5758855717,
    "dropfax": 5758873253
  },
  {
    "dcode": "D",
    "dropkey": "PZ13593",
    "droptype": "D",
    "dropname": "CARRIZOZO",
    "dropdeladd": "509 12TH ST",
    "dropdelcty": "CARRIZOZO",
    "dropdelst": "NM",
    "dropdelzpp": 883019800,
    "dropphyadd": "509 12TH ST",
    "dropphycty": "CARRIZOZO",
    "dropphyst": "NM",
    "dropphyzpp": 883019800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARRIZOZO",
    "dropmalst": "NM",
    "dropmalzpp": 883019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756482271,
    "dropsitcph": 5756482271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13594",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "508 STATE HIGHWAY 567",
    "dropdelcty": "CARSON",
    "dropdelst": "NM",
    "dropdelzpp": 875179998,
    "dropphyadd": "508 STATE HIGHWAY 567",
    "dropphycty": "CARSON",
    "dropphyst": "NM",
    "dropphyzpp": 875179998,
    "dropmaladd": "508 STATE HIGHWAY 567",
    "dropmalcty": "CARSON",
    "dropmalst": "NM",
    "dropmalzpp": 875179998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757513473,
    "dropsitcph": 5757513473,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13595",
    "droptype": "D",
    "dropname": "CASA BLANCA",
    "dropdeladd": "182 CASA BLANCA RD",
    "dropdelcty": "CASA BLANCA",
    "dropdelst": "NM",
    "dropdelzpp": 870071000,
    "dropphyadd": "182 CASA BLANCA RD",
    "dropphycty": "CASA BLANCA",
    "dropphyst": "NM",
    "dropphyzpp": 870071000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASA BLANCA",
    "dropmalst": "NM",
    "dropmalzpp": 870079998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055520408,
    "dropsitcph": 5055520408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13596",
    "droptype": "D",
    "dropname": "CAUSEY",
    "dropdeladd": "122 CAUSEY MAIN ST",
    "dropdelcty": "CAUSEY",
    "dropdelst": "NM",
    "dropdelzpp": 881139800,
    "dropphyadd": "122 CAUSEY MAIN ST",
    "dropphycty": "CAUSEY",
    "dropphyst": "NM",
    "dropphyzpp": 881139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAUSEY",
    "dropmalst": "NM",
    "dropmalzpp": 881139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752734264,
    "dropsitcph": 5752734264,
    "dropfax": 5752734264
  },
  {
    "dcode": "D",
    "dropkey": "PZ13597",
    "droptype": "D",
    "dropname": "CEBOLLA",
    "dropdeladd": "5A COUNTY ROAD 310",
    "dropdelcty": "CEBOLLA",
    "dropdelst": "NM",
    "dropdelzpp": 875189998,
    "dropphyadd": "5A COUNTY ROAD 310",
    "dropphycty": "CEBOLLA",
    "dropphyst": "NM",
    "dropphyzpp": 875189998,
    "dropmaladd": "5A COUNTY ROAD 310",
    "dropmalcty": "CEBOLLA",
    "dropmalst": "NM",
    "dropmalzpp": 875189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756842482,
    "dropsitcph": 5756842482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13598",
    "droptype": "D",
    "dropname": "CEDAR CREST",
    "dropdeladd": "12218 N HIGHWAY 14",
    "dropdelcty": "CEDAR CREST",
    "dropdelst": "NM",
    "dropdelzpp": 870089998,
    "dropphyadd": "12218 N HIGHWAY 14",
    "dropphycty": "CEDAR CREST",
    "dropphyst": "NM",
    "dropphyzpp": 870089998,
    "dropmaladd": "12218 N HIGHWAY 14",
    "dropmalcty": "CEDAR CREST",
    "dropmalst": "NM",
    "dropmalzpp": 870089998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054373596,
    "dropsitcph": 5054373596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13601",
    "droptype": "D",
    "dropname": "SANTA CLARA",
    "dropdeladd": "514 FORT BAYARD ST",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "NM",
    "dropdelzpp": 880269800,
    "dropphyadd": "514 FORT BAYARD ST",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "NM",
    "dropphyzpp": 880269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "NM",
    "dropmalzpp": 880269998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755373888,
    "dropsitcph": 5755373888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13602",
    "droptype": "D",
    "dropname": "CERRILLOS",
    "dropdeladd": "8A MAIN ST",
    "dropdelcty": "CERRILLOS",
    "dropdelst": "NM",
    "dropdelzpp": 870109998,
    "dropphyadd": "8A MAIN ST",
    "dropphycty": "CERRILLOS",
    "dropphyst": "NM",
    "dropphyzpp": 870109998,
    "dropmaladd": "8A MAIN ST",
    "dropmalcty": "CERRILLOS",
    "dropmalst": "NM",
    "dropmalzpp": 870109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054746813,
    "dropsitcph": 5054746813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13604",
    "droptype": "D",
    "dropname": "CERRO",
    "dropdeladd": "122 HIGHWAY 378",
    "dropdelcty": "CERRO",
    "dropdelst": "NM",
    "dropdelzpp": 875199998,
    "dropphyadd": "122 HIGHWAY 378",
    "dropphycty": "CERRO",
    "dropphyst": "NM",
    "dropphyzpp": 875199998,
    "dropmaladd": "122 HIGHWAY 378",
    "dropmalcty": "CERRO",
    "dropmalst": "NM",
    "dropmalzpp": 875199998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755860441,
    "dropsitcph": 5755860441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13606",
    "droptype": "D",
    "dropname": "CHACON",
    "dropdeladd": "26 STATE HIGHWAY 121",
    "dropdelcty": "CHACON",
    "dropdelst": "NM",
    "dropdelzpp": 877131000,
    "dropphyadd": "26 STATE HIGHWAY 121",
    "dropphycty": "CHACON",
    "dropphyst": "NM",
    "dropphyzpp": 877131000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHACON",
    "dropmalst": "NM",
    "dropmalzpp": 877139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752405008,
    "dropsitcph": 5752405008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13607",
    "droptype": "D",
    "dropname": "CHAMA",
    "dropdeladd": "199 5TH ST W",
    "dropdelcty": "CHAMA",
    "dropdelst": "NM",
    "dropdelzpp": 875209998,
    "dropphyadd": "199 5TH ST W",
    "dropphycty": "CHAMA",
    "dropphyst": "NM",
    "dropphyzpp": 875209998,
    "dropmaladd": "199 5TH ST W",
    "dropmalcty": "CHAMA",
    "dropmalst": "NM",
    "dropmalzpp": 875209998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757562240,
    "dropsitcph": 5757562240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13608",
    "droptype": "D",
    "dropname": "CHAMBERINO",
    "dropdeladd": "9620 STATE HIGHWAY 28 S",
    "dropdelcty": "CHAMBERINO",
    "dropdelst": "NM",
    "dropdelzpp": 880279800,
    "dropphyadd": "9620 STATE HIGHWAY 28 S",
    "dropphycty": "CHAMBERINO",
    "dropphyst": "NM",
    "dropphyzpp": 880279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHAMBERINO",
    "dropmalst": "NM",
    "dropmalzpp": 880279998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758822296,
    "dropsitcph": 5758822296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13609",
    "droptype": "D",
    "dropname": "CHAMISAL",
    "dropdeladd": "2756 STATE ROAD 76",
    "dropdelcty": "CHAMISAL",
    "dropdelst": "NM",
    "dropdelzpp": 875219998,
    "dropphyadd": "2756 STATE ROAD 76",
    "dropphycty": "CHAMISAL",
    "dropphyst": "NM",
    "dropphyzpp": 875219998,
    "dropmaladd": "2756 STATE ROAD 76",
    "dropmalcty": "CHAMISAL",
    "dropmalst": "NM",
    "dropmalzpp": 875219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755872246,
    "dropsitcph": 5755872246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13615",
    "droptype": "D",
    "dropname": "CHIMAYO",
    "dropdeladd": "724 STATE HIGHWAY 76",
    "dropdelcty": "CHIMAYO",
    "dropdelst": "NM",
    "dropdelzpp": 875229998,
    "dropphyadd": "724 STATE HIGHWAY 76",
    "dropphycty": "CHIMAYO",
    "dropphyst": "NM",
    "dropphyzpp": 875229998,
    "dropmaladd": "724 STATE HIGHWAY 76",
    "dropmalcty": "CHIMAYO",
    "dropmalst": "NM",
    "dropmalzpp": 875229998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053514524,
    "dropsitcph": 5053514524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13618",
    "droptype": "D",
    "dropname": "CHURCH ROCK",
    "dropdeladd": "825 OUTLAW RD",
    "dropdelcty": "CHURCH ROCK",
    "dropdelst": "NM",
    "dropdelzpp": 873119701,
    "dropphyadd": "825 OUTLAW RD",
    "dropphycty": "CHURCH ROCK",
    "dropphyst": "NM",
    "dropphyzpp": 873119701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHURCH ROCK",
    "dropmalst": "NM",
    "dropmalzpp": 873119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059056337,
    "dropsitcph": 5059056337,
    "dropfax": 5059058039
  },
  {
    "dcode": "D",
    "dropkey": "PZ13619",
    "droptype": "D",
    "dropname": "CIMARRON",
    "dropdeladd": "210 E 9TH ST",
    "dropdelcty": "CIMARRON",
    "dropdelst": "NM",
    "dropdelzpp": 877149998,
    "dropphyadd": "210 E 9TH ST",
    "dropphycty": "CIMARRON",
    "dropphyst": "NM",
    "dropphyzpp": 877149998,
    "dropmaladd": "210 E 9TH ST",
    "dropmalcty": "CIMARRON",
    "dropmalst": "NM",
    "dropmalzpp": 877149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753762548,
    "dropsitcph": 5753762548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13621",
    "droptype": "D",
    "dropname": "CLAUNCH",
    "dropdeladd": "1468 S HIGHWAY 55",
    "dropdelcty": "CLAUNCH",
    "dropdelst": "NM",
    "dropdelzpp": 870119998,
    "dropphyadd": "1468 S HIGHWAY 55",
    "dropphycty": "CLAUNCH",
    "dropphyst": "NM",
    "dropphyzpp": 870119998,
    "dropmaladd": "1468 S HIGHWAY 55",
    "dropmalcty": "CLAUNCH",
    "dropmalst": "NM",
    "dropmalzpp": 870119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754153173,
    "dropsitcph": 5754153173,
    "dropfax": 5758491179
  },
  {
    "dcode": "D",
    "dropkey": "PZ13622",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "1 WALNUT ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "NM",
    "dropdelzpp": 884159998,
    "dropphyadd": "1 WALNUT ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "NM",
    "dropphyzpp": 884159998,
    "dropmaladd": "1 WALNUT ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "NM",
    "dropmalzpp": 884159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753765090,
    "dropsitcph": 5753765090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13623",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "3177 STATE HIGHWAY 518",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "NM",
    "dropdelzpp": 877151001,
    "dropphyadd": "3177 STATE HIGHWAY 518",
    "dropphycty": "CLEVELAND",
    "dropphyst": "NM",
    "dropphyzpp": 877151001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "NM",
    "dropmalzpp": 877159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755877028,
    "dropsitcph": 5755877028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13626",
    "droptype": "D",
    "dropname": "CLIFF",
    "dropdeladd": "8427 FRONTAGE RD",
    "dropdelcty": "CLIFF",
    "dropdelst": "NM",
    "dropdelzpp": 880289800,
    "dropphyadd": "8427 FRONTAGE RD",
    "dropphycty": "CLIFF",
    "dropphyst": "NM",
    "dropphyzpp": 880289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIFF",
    "dropmalst": "NM",
    "dropmalzpp": 880289998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755352951,
    "dropsitcph": 5755352951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13628",
    "droptype": "D",
    "dropname": "CLOUDCROFT",
    "dropdeladd": "20 CURLEW PL",
    "dropdelcty": "CLOUDCROFT",
    "dropdelst": "NM",
    "dropdelzpp": 883179800,
    "dropphyadd": "20 CURLEW PL",
    "dropphycty": "CLOUDCROFT",
    "dropphyst": "NM",
    "dropphyzpp": 883179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLOUDCROFT",
    "dropmalst": "NM",
    "dropmalzpp": 883179998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756822431,
    "dropsitcph": 5756822431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13631",
    "droptype": "D",
    "dropname": "CLOVIS",
    "dropdeladd": "417 GIDDING ST STE 100",
    "dropdelcty": "CLOVIS",
    "dropdelst": "NM",
    "dropdelzpp": 881019998,
    "dropphyadd": "417 GIDDING ST STE 100",
    "dropphycty": "CLOVIS",
    "dropphyst": "NM",
    "dropphyzpp": 881019998,
    "dropmaladd": "417 GIDDING ST STE 100",
    "dropmalcty": "CLOVIS",
    "dropmalst": "NM",
    "dropmalzpp": 881019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757635556,
    "dropsitcph": 5757635556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13636",
    "droptype": "D",
    "dropname": "COLUMBUS",
    "dropdeladd": "40 E BROADWAY AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "NM",
    "dropdelzpp": 880299100,
    "dropphyadd": "40 E BROADWAY AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "NM",
    "dropphyzpp": 880299100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "NM",
    "dropmalzpp": 880299998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755312680,
    "dropsitcph": 5755312680,
    "dropfax": 5755312816
  },
  {
    "dcode": "D",
    "dropkey": "PZ13638",
    "droptype": "D",
    "dropname": "CONTINENTAL DIVIDE",
    "dropdeladd": "40 WRANGLER RD",
    "dropdelcty": "CONTINENTAL DIVIDE",
    "dropdelst": "NM",
    "dropdelzpp": 873129998,
    "dropphyadd": "40 WRANGLER RD",
    "dropphycty": "CONTINENTAL DIVIDE",
    "dropphyst": "NM",
    "dropphyzpp": 873129998,
    "dropmaladd": "40 WRANGLER RD",
    "dropmalcty": "CONTINENTAL DIVIDE",
    "dropmalst": "NM",
    "dropmalzpp": 873129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058627454,
    "dropsitcph": 5058627454,
    "dropfax": 5058627652
  },
  {
    "dcode": "D",
    "dropkey": "PZ13642",
    "droptype": "D",
    "dropname": "CORDOVA",
    "dropdeladd": "74 COUNTY ROAD 80",
    "dropdelcty": "CORDOVA",
    "dropdelst": "NM",
    "dropdelzpp": 875239998,
    "dropphyadd": "74 COUNTY ROAD 80",
    "dropphycty": "CORDOVA",
    "dropphyst": "NM",
    "dropphyzpp": 875239998,
    "dropmaladd": "74 COUNTY ROAD 80",
    "dropmalcty": "CORDOVA",
    "dropmalst": "NM",
    "dropmalzpp": 875239998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053514611,
    "dropsitcph": 5053514611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13643",
    "droptype": "D",
    "dropname": "CORONA",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "CORONA",
    "dropdelst": "NM",
    "dropdelzpp": 883189802,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "CORONA",
    "dropphyst": "NM",
    "dropphyzpp": 883189802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORONA",
    "dropmalst": "NM",
    "dropmalzpp": 883189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756182212,
    "dropsitcph": 5756182212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13645",
    "droptype": "D",
    "dropname": "CORRALES",
    "dropdeladd": "4101 CORRALES RD",
    "dropdelcty": "CORRALES",
    "dropdelst": "NM",
    "dropdelzpp": 870489998,
    "dropphyadd": "4101 CORRALES RD",
    "dropphycty": "CORRALES",
    "dropphyst": "NM",
    "dropphyzpp": 870489998,
    "dropmaladd": "4101 CORRALES RD",
    "dropmalcty": "CORRALES",
    "dropmalst": "NM",
    "dropmalzpp": 870489998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058909400,
    "dropsitcph": 5058906222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13649",
    "droptype": "D",
    "dropname": "COSTILLA",
    "dropdeladd": "6 GARCIA RD",
    "dropdelcty": "COSTILLA",
    "dropdelst": "NM",
    "dropdelzpp": 875249998,
    "dropphyadd": "6 GARCIA RD",
    "dropphycty": "COSTILLA",
    "dropphyst": "NM",
    "dropphyzpp": 875249998,
    "dropmaladd": "6 GARCIA RD",
    "dropmalcty": "COSTILLA",
    "dropmalst": "NM",
    "dropmalzpp": 875249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755860353,
    "dropsitcph": 5755860353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13653",
    "droptype": "D",
    "dropname": "COYOTE",
    "dropdeladd": "3390 STATE HIGHWAY 96",
    "dropdelcty": "COYOTE",
    "dropdelst": "NM",
    "dropdelzpp": 870129998,
    "dropphyadd": "3390 STATE HIGHWAY 96",
    "dropphycty": "COYOTE",
    "dropphyst": "NM",
    "dropphyzpp": 870129998,
    "dropmaladd": "3390 STATE HIGHWAY 96",
    "dropmalcty": "COYOTE",
    "dropmalst": "NM",
    "dropmalzpp": 870129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752500285,
    "dropsitcph": 5752500285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13655",
    "droptype": "D",
    "dropname": "CROWNPOINT",
    "dropdeladd": "1 MAIN RD",
    "dropdelcty": "CROWNPOINT",
    "dropdelst": "NM",
    "dropdelzpp": 873139901,
    "dropphyadd": "1 MAIN RD",
    "dropphycty": "CROWNPOINT",
    "dropphyst": "NM",
    "dropphyzpp": 873139901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CROWNPOINT",
    "dropmalst": "NM",
    "dropmalzpp": 873139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752142683,
    "dropsitcph": 5752142683,
    "dropfax": 5754463447
  },
  {
    "dcode": "D",
    "dropkey": "PZ13658",
    "droptype": "D",
    "dropname": "CUBA",
    "dropdeladd": "6358 MAIN ST",
    "dropdelcty": "CUBA",
    "dropdelst": "NM",
    "dropdelzpp": 870139998,
    "dropphyadd": "6358 MAIN ST",
    "dropphycty": "CUBA",
    "dropphyst": "NM",
    "dropphyzpp": 870139998,
    "dropmaladd": "6358 MAIN ST",
    "dropmalcty": "CUBA",
    "dropmalst": "NM",
    "dropmalzpp": 870139998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752893426,
    "dropsitcph": 5752893426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13659",
    "droptype": "D",
    "dropname": "CUBERO",
    "dropdeladd": "6 CAMINO REAL RD",
    "dropdelcty": "CUBERO",
    "dropdelst": "NM",
    "dropdelzpp": 870149998,
    "dropphyadd": "6 CAMINO REAL RD",
    "dropphycty": "CUBERO",
    "dropphyst": "NM",
    "dropphyzpp": 870149998,
    "dropmaladd": "6 CAMINO REAL RD",
    "dropmalcty": "CUBERO",
    "dropmalst": "NM",
    "dropmalzpp": 870149998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055526811,
    "dropsitcph": 5055526811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13666",
    "droptype": "D",
    "dropname": "DATIL",
    "dropdeladd": "101 W HIGHWAY 60",
    "dropdelcty": "DATIL",
    "dropdelst": "NM",
    "dropdelzpp": 878219998,
    "dropphyadd": "101 W HIGHWAY 60",
    "dropphycty": "DATIL",
    "dropphyst": "NM",
    "dropphyzpp": 878219998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DATIL",
    "dropmalst": "NM",
    "dropmalzpp": 878219997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053021608,
    "dropsitcph": 5053021608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13668",
    "droptype": "D",
    "dropname": "DEMING",
    "dropdeladd": "201 W SPRUCE ST",
    "dropdelcty": "DEMING",
    "dropdelst": "NM",
    "dropdelzpp": 880309998,
    "dropphyadd": "201 W SPRUCE ST",
    "dropphycty": "DEMING",
    "dropphyst": "NM",
    "dropphyzpp": 880309998,
    "dropmaladd": "201 W SPRUCE ST",
    "dropmalcty": "DEMING",
    "dropmalst": "NM",
    "dropmalzpp": 880309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755469461,
    "dropsitcph": 5755469461,
    "dropfax": 5755442721
  },
  {
    "dcode": "D",
    "dropkey": "PZ13670",
    "droptype": "D",
    "dropname": "DERRY",
    "dropdeladd": "13125 HIGHWAY 187",
    "dropdelcty": "DERRY",
    "dropdelst": "NM",
    "dropdelzpp": 879339800,
    "dropphyadd": "13125 HIGHWAY 187",
    "dropphycty": "DERRY",
    "dropphyst": "NM",
    "dropphyzpp": 879339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DERRY",
    "dropmalst": "NM",
    "dropmalzpp": 879339998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752671317,
    "dropsitcph": 5752671317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13671",
    "droptype": "D",
    "dropname": "DES MOINES",
    "dropdeladd": "720 BROADWAY AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "NM",
    "dropdelzpp": 884189998,
    "dropphyadd": "720 BROADWAY AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "NM",
    "dropphyzpp": 884189998,
    "dropmaladd": "720 BROADWAY AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "NM",
    "dropmalzpp": 884189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752782561,
    "dropsitcph": 5752782561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13672",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "302 S LINCOLN AVE",
    "dropdelcty": "DEXTER",
    "dropdelst": "NM",
    "dropdelzpp": 882309800,
    "dropphyadd": "302 S LINCOLN AVE",
    "dropphycty": "DEXTER",
    "dropphyst": "NM",
    "dropphyzpp": 882309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEXTER",
    "dropmalst": "NM",
    "dropmalzpp": 882309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752317372,
    "dropsitcph": 5752317372,
    "dropfax": 5757345850
  },
  {
    "dcode": "D",
    "dropkey": "PZ13674",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "221 STATE ROAD 75",
    "dropdelcty": "DIXON",
    "dropdelst": "NM",
    "dropdelzpp": 875279998,
    "dropphyadd": "221 STATE ROAD 75",
    "dropphycty": "DIXON",
    "dropphyst": "NM",
    "dropphyzpp": 875279998,
    "dropmaladd": "221 STATE ROAD 75",
    "dropmalcty": "DIXON",
    "dropmalst": "NM",
    "dropmalzpp": 875279998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055794272,
    "dropsitcph": 5055794272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13676",
    "droptype": "D",
    "dropname": "DONA ANA",
    "dropdeladd": "5480 LEDESMA",
    "dropdelcty": "DONA ANA",
    "dropdelst": "NM",
    "dropdelzpp": 880329800,
    "dropphyadd": "5480 LEDESMA",
    "dropphycty": "DONA ANA",
    "dropphyst": "NM",
    "dropphyzpp": 880329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DONA ANA",
    "dropmalst": "NM",
    "dropmalzpp": 880329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752883339,
    "dropsitcph": 5752883336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13677",
    "droptype": "D",
    "dropname": "DORA",
    "dropdeladd": "130 DORA MAIN ST",
    "dropdelcty": "DORA",
    "dropdelst": "NM",
    "dropdelzpp": 881159800,
    "dropphyadd": "130 DORA MAIN ST",
    "dropphycty": "DORA",
    "dropphyst": "NM",
    "dropphyzpp": 881159800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DORA",
    "dropmalst": "NM",
    "dropmalzpp": 881159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754772301,
    "dropsitcph": 5754772301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13679",
    "droptype": "D",
    "dropname": "DULCE",
    "dropdeladd": "10 FOOTHILL ST",
    "dropdelcty": "DULCE",
    "dropdelst": "NM",
    "dropdelzpp": 875289998,
    "dropphyadd": "10 FOOTHILL ST",
    "dropphycty": "DULCE",
    "dropphyst": "NM",
    "dropphyzpp": 875289998,
    "dropmaladd": "10 FOOTHILL ST",
    "dropmalcty": "DULCE",
    "dropmalst": "NM",
    "dropmalzpp": 875289998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757593497,
    "dropsitcph": 5757593497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13683",
    "droptype": "D",
    "dropname": "EAGLE NEST",
    "dropdeladd": "152 W THERMA DR",
    "dropdelcty": "EAGLE NEST",
    "dropdelst": "NM",
    "dropdelzpp": 877189998,
    "dropphyadd": "152 W THERMA DR",
    "dropphycty": "EAGLE NEST",
    "dropphyst": "NM",
    "dropphyzpp": 877189998,
    "dropmaladd": "152 W THERMA DR",
    "dropmalcty": "EAGLE NEST",
    "dropmalst": "NM",
    "dropmalzpp": 877189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753772212,
    "dropsitcph": 5753772212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13686",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "13 PLAZA LOOP",
    "dropdelcty": "EDGEWOOD",
    "dropdelst": "NM",
    "dropdelzpp": 870159998,
    "dropphyadd": "13 PLAZA LOOP",
    "dropphycty": "EDGEWOOD",
    "dropphyst": "NM",
    "dropphyzpp": 870159998,
    "dropmaladd": "13 PLAZA LOOP",
    "dropmalcty": "EDGEWOOD",
    "dropmalst": "NM",
    "dropmalzpp": 870159998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052813535,
    "dropsitcph": 5052813535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13697",
    "droptype": "D",
    "dropname": "EL PRADO",
    "dropdeladd": "1518 PASEO DEL PUEBLO NORTE",
    "dropdelcty": "EL PRADO",
    "dropdelst": "NM",
    "dropdelzpp": 875299998,
    "dropphyadd": "1518 PASEO DEL PUEBLO NORTE",
    "dropphycty": "EL PRADO",
    "dropphyst": "NM",
    "dropphyzpp": 875299998,
    "dropmaladd": "1518 PASEO DEL PUEBLO NORTE",
    "dropmalcty": "EL PRADO",
    "dropmalst": "NM",
    "dropmalzpp": 875299998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757584810,
    "dropsitcph": 5757584810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13702",
    "droptype": "D",
    "dropname": "EL RITO",
    "dropdeladd": "1134 STATE ROAD 554",
    "dropdelcty": "EL RITO",
    "dropdelst": "NM",
    "dropdelzpp": 875309998,
    "dropphyadd": "1134 STATE ROAD 554",
    "dropphycty": "EL RITO",
    "dropphyst": "NM",
    "dropphyzpp": 875309998,
    "dropmaladd": "1134 STATE ROAD 554",
    "dropmalcty": "EL RITO",
    "dropmalst": "NM",
    "dropmalzpp": 875309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755702006,
    "dropsitcph": 5755702006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13706",
    "droptype": "D",
    "dropname": "ELEPHANT BUTTE",
    "dropdeladd": "109 ODESSA ST",
    "dropdelcty": "ELEPHANT BUTTE",
    "dropdelst": "NM",
    "dropdelzpp": 879359800,
    "dropphyadd": "109 ODESSA ST",
    "dropphycty": "ELEPHANT BUTTE",
    "dropphyst": "NM",
    "dropphyzpp": 879359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELEPHANT BUTTE",
    "dropmalst": "NM",
    "dropmalzpp": 879359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752976003,
    "dropsitcph": 5757445257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13707",
    "droptype": "D",
    "dropname": "ELIDA",
    "dropdeladd": "101 N CENTER ST",
    "dropdelcty": "ELIDA",
    "dropdelst": "NM",
    "dropdelzpp": 881169800,
    "dropphyadd": "101 N CENTER ST",
    "dropphycty": "ELIDA",
    "dropphyst": "NM",
    "dropphyzpp": 881169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELIDA",
    "dropmalst": "NM",
    "dropmalzpp": 881169998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752746483,
    "dropsitcph": 5752746483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13711",
    "droptype": "D",
    "dropname": "ENCINO",
    "dropdeladd": "122 US HIGHWAY 285",
    "dropdelcty": "ENCINO",
    "dropdelst": "NM",
    "dropdelzpp": 883219800,
    "dropphyadd": "122 US HIGHWAY 285",
    "dropphycty": "ENCINO",
    "dropphyst": "NM",
    "dropphyzpp": 883219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENCINO",
    "dropmalst": "NM",
    "dropmalzpp": 883219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754463921,
    "dropsitcph": 5754463921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13715",
    "droptype": "D",
    "dropname": "ESPANOLA",
    "dropdeladd": "1010 INDUSTRIAL PARK RD",
    "dropdelcty": "ESPANOLA",
    "dropdelst": "NM",
    "dropdelzpp": 875329998,
    "dropphyadd": "1010 INDUSTRIAL PARK RD",
    "dropphycty": "ESPANOLA",
    "dropphyst": "NM",
    "dropphyzpp": 875329998,
    "dropmaladd": "1010 INDUSTRIAL PARK RD",
    "dropmalcty": "ESPANOLA",
    "dropmalst": "NM",
    "dropmalzpp": 875329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057533335,
    "dropsitcph": 5057533335,
    "dropfax": 5057533440
  },
  {
    "dcode": "D",
    "dropkey": "PZ13717",
    "droptype": "D",
    "dropname": "ESTANCIA",
    "dropdeladd": "413 E HIGHLAND AVE",
    "dropdelcty": "ESTANCIA",
    "dropdelst": "NM",
    "dropdelzpp": 870169998,
    "dropphyadd": "413 E HIGHLAND AVE",
    "dropphycty": "ESTANCIA",
    "dropphyst": "NM",
    "dropphyzpp": 870169998,
    "dropmaladd": "413 E HIGHLAND AVE",
    "dropmalcty": "ESTANCIA",
    "dropmalst": "NM",
    "dropmalzpp": 870169998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053842721,
    "dropsitcph": 5053842721,
    "dropfax": 5053844168
  },
  {
    "dcode": "D",
    "dropkey": "PZ13718",
    "droptype": "D",
    "dropname": "EUNICE",
    "dropdeladd": "1201 AVENUE K",
    "dropdelcty": "EUNICE",
    "dropdelst": "NM",
    "dropdelzpp": 882313562,
    "dropphyadd": "1201 AVENUE K",
    "dropphycty": "EUNICE",
    "dropphyst": "NM",
    "dropphyzpp": 882313562,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EUNICE",
    "dropmalst": "NM",
    "dropmalzpp": 882319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753948122,
    "dropsitcph": 5753948122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13719",
    "droptype": "D",
    "dropname": "FAIRACRES",
    "dropdeladd": "3800 W PICACHO AVE",
    "dropdelcty": "FAIRACRES",
    "dropdelst": "NM",
    "dropdelzpp": 880339800,
    "dropphyadd": "3800 W PICACHO AVE",
    "dropphycty": "FAIRACRES",
    "dropphyst": "NM",
    "dropphyzpp": 880339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRACRES",
    "dropmalst": "NM",
    "dropmalzpp": 880339998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752228483,
    "dropsitcph": 5752228483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13724",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "2301 E 20TH ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "NM",
    "dropdelzpp": 874019998,
    "dropphyadd": "2301 E 20TH ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "NM",
    "dropphyzpp": 874019998,
    "dropmaladd": "2301 E 20TH ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "NM",
    "dropmalzpp": 874019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053243055,
    "dropsitcph": 5053243055,
    "dropfax": 5053241143
  },
  {
    "dcode": "D",
    "dropkey": "PZ13726",
    "droptype": "D",
    "dropname": "FAYWOOD",
    "dropdeladd": "1123 HIGHWAY 61",
    "dropdelcty": "FAYWOOD",
    "dropdelst": "NM",
    "dropdelzpp": 880349800,
    "dropphyadd": "1123 HIGHWAY 61",
    "dropphycty": "FAYWOOD",
    "dropphyst": "NM",
    "dropphyzpp": 880349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAYWOOD",
    "dropmalst": "NM",
    "dropmalzpp": 880349998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755362880,
    "dropsitcph": 5755362880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13727",
    "droptype": "D",
    "dropname": "FENCE LAKE",
    "dropdeladd": "2119 STATE HWY 36",
    "dropdelcty": "FENCE LAKE",
    "dropdelst": "NM",
    "dropdelzpp": 873159998,
    "dropphyadd": "2119 STATE HWY 36",
    "dropphycty": "FENCE LAKE",
    "dropphyst": "NM",
    "dropphyzpp": 873159998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FENCE LAKE",
    "dropmalst": "NM",
    "dropmalzpp": 873159997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057882234,
    "dropsitcph": 5057882234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13732",
    "droptype": "D",
    "dropname": "FLORA VISTA",
    "dropdeladd": "810 NM 516",
    "dropdelcty": "FLORA VISTA",
    "dropdelst": "NM",
    "dropdelzpp": 874159701,
    "dropphyadd": "810 NM 516",
    "dropphycty": "FLORA VISTA",
    "dropphyst": "NM",
    "dropphyzpp": 874159701,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLORA VISTA",
    "dropmalst": "NM",
    "dropmalzpp": 874159997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053343606,
    "dropsitcph": 5053343606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13734",
    "droptype": "D",
    "dropname": "FLOYD",
    "dropdeladd": "1561 NEW MEXICO 267",
    "dropdelcty": "FLOYD",
    "dropdelst": "NM",
    "dropdelzpp": 881189800,
    "dropphyadd": "1561 NEW MEXICO 267",
    "dropphycty": "FLOYD",
    "dropphyst": "NM",
    "dropphyzpp": 881189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLOYD",
    "dropmalst": "NM",
    "dropmalzpp": 881189998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754782283,
    "dropsitcph": 5754782283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13737",
    "droptype": "D",
    "dropname": "FOLSOM",
    "dropdeladd": "53 GRAND AVE",
    "dropdelcty": "FOLSOM",
    "dropdelst": "NM",
    "dropdelzpp": 884199998,
    "dropphyadd": "53 GRAND AVE",
    "dropphycty": "FOLSOM",
    "dropphyst": "NM",
    "dropphyzpp": 884199998,
    "dropmaladd": "53 GRAND AVE",
    "dropmalcty": "FOLSOM",
    "dropmalst": "NM",
    "dropmalzpp": 884199998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752782150,
    "dropsitcph": 5752782150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13739",
    "droptype": "D",
    "dropname": "FORT STANTON",
    "dropdeladd": "100 BLACK JACK PERSHING RD",
    "dropdelcty": "FORT STANTON",
    "dropdelst": "NM",
    "dropdelzpp": 883239800,
    "dropphyadd": "100 BLACK JACK PERSHING RD",
    "dropphycty": "FORT STANTON",
    "dropphyst": "NM",
    "dropphyzpp": 883239800,
    "dropmaladd": "100 BLACK JACK PERSHING RD",
    "dropmalcty": "FORT STANTON",
    "dropmalst": "NM",
    "dropmalzpp": 883239800,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753542577,
    "dropsitcph": 5753542577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13740",
    "droptype": "D",
    "dropname": "FORT SUMNER",
    "dropdeladd": "688 N 5TH ST",
    "dropdelcty": "FORT SUMNER",
    "dropdelst": "NM",
    "dropdelzpp": 881199803,
    "dropphyadd": "688 N 5TH ST",
    "dropphycty": "FORT SUMNER",
    "dropphyst": "NM",
    "dropphyzpp": 881199803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT SUMNER",
    "dropmalst": "NM",
    "dropmalzpp": 881199998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756182192,
    "dropsitcph": 5756182192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13741",
    "droptype": "D",
    "dropname": "FORT WINGATE",
    "dropdeladd": "286B STATE HIGHWAY 400",
    "dropdelcty": "FORT WINGATE",
    "dropdelst": "NM",
    "dropdelzpp": 873169998,
    "dropphyadd": "286B STATE HIGHWAY 400",
    "dropphycty": "FORT WINGATE",
    "dropphyst": "NM",
    "dropphyzpp": 873169998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT WINGATE",
    "dropmalst": "NM",
    "dropmalzpp": 873169997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054885565,
    "dropsitcph": 5054885565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13744",
    "droptype": "D",
    "dropname": "FRUITLAND",
    "dropdeladd": "97 ROAD 6675",
    "dropdelcty": "FRUITLAND",
    "dropdelst": "NM",
    "dropdelzpp": 874169998,
    "dropphyadd": "97 ROAD 6675",
    "dropphycty": "FRUITLAND",
    "dropphyst": "NM",
    "dropphyzpp": 874169998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRUITLAND",
    "dropmalst": "NM",
    "dropmalzpp": 874169997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055984120,
    "dropsitcph": 5055984120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13752",
    "droptype": "D",
    "dropname": "GALLINA",
    "dropdeladd": "1970 STATE HIGHWAY 96",
    "dropdelcty": "GALLINA",
    "dropdelst": "NM",
    "dropdelzpp": 870179998,
    "dropphyadd": "1970 STATE HIGHWAY 96",
    "dropphycty": "GALLINA",
    "dropphyst": "NM",
    "dropphyzpp": 870179998,
    "dropmaladd": "1970 STATE HIGHWAY 96",
    "dropmalcty": "GALLINA",
    "dropmalst": "NM",
    "dropmalzpp": 870179998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756385616,
    "dropsitcph": 5756385616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13755",
    "droptype": "D",
    "dropname": "GALLUP",
    "dropdeladd": "500 S SECOND ST",
    "dropdelcty": "GALLUP",
    "dropdelst": "NM",
    "dropdelzpp": 873019998,
    "dropphyadd": "500 S SECOND ST",
    "dropphycty": "GALLUP",
    "dropphyst": "NM",
    "dropphyzpp": 873019998,
    "dropmaladd": "500 S SECOND ST",
    "dropmalcty": "GALLUP",
    "dropmalst": "NM",
    "dropmalzpp": 873019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057225265,
    "dropsitcph": 5057225265,
    "dropfax": 5058639635
  },
  {
    "dcode": "D",
    "dropkey": "PZ13758",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "8960 HIGHWAY 187",
    "dropdelcty": "GARFIELD",
    "dropdelst": "NM",
    "dropdelzpp": 879369800,
    "dropphyadd": "8960 HIGHWAY 187",
    "dropphycty": "GARFIELD",
    "dropphyst": "NM",
    "dropphyzpp": 879369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARFIELD",
    "dropmalst": "NM",
    "dropmalzpp": 879369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752674923,
    "dropsitcph": 5752674923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13759",
    "droptype": "D",
    "dropname": "GARITA",
    "dropdeladd": "5120 NM HIGHWAY 104",
    "dropdelcty": "GARITA",
    "dropdelst": "NM",
    "dropdelzpp": 884219998,
    "dropphyadd": "5120 NM HIGHWAY 104",
    "dropphycty": "GARITA",
    "dropphyst": "NM",
    "dropphyzpp": 884219998,
    "dropmaladd": "5120 NM HIGHWAY 104",
    "dropmalcty": "GARITA",
    "dropmalst": "NM",
    "dropmalzpp": 884219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756415239,
    "dropsitcph": 5756415239,
    "dropfax": 5756415239
  },
  {
    "dcode": "D",
    "dropkey": "PZ13762",
    "droptype": "D",
    "dropname": "GILA",
    "dropdeladd": "407 STATE HIGHWAY 211",
    "dropdelcty": "GILA",
    "dropdelst": "NM",
    "dropdelzpp": 880389800,
    "dropphyadd": "407 STATE HIGHWAY 211",
    "dropphycty": "GILA",
    "dropphyst": "NM",
    "dropphyzpp": 880389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GILA",
    "dropmalst": "NM",
    "dropmalzpp": 880389998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755352363,
    "dropsitcph": 5755352363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13765",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "27489 US HIGHWAY 70",
    "dropdelcty": "GLENCOE",
    "dropdelst": "NM",
    "dropdelzpp": 883249800,
    "dropphyadd": "27489 US HIGHWAY 70",
    "dropphycty": "GLENCOE",
    "dropphyst": "NM",
    "dropphyzpp": 883249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENCOE",
    "dropmalst": "NM",
    "dropmalzpp": 883249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756534314,
    "dropsitcph": 5756534314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13767",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "5111 HIGHWAY 180",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "NM",
    "dropdelzpp": 880399800,
    "dropphyadd": "5111 HIGHWAY 180",
    "dropphycty": "GLENWOOD",
    "dropphyst": "NM",
    "dropphyzpp": 880399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "NM",
    "dropmalzpp": 880399998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755392131,
    "dropsitcph": 5755392131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13768",
    "droptype": "D",
    "dropname": "GLORIETA",
    "dropdeladd": "16 CALLE LOMITA",
    "dropdelcty": "GLORIETA",
    "dropdelst": "NM",
    "dropdelzpp": 875359998,
    "dropphyadd": "16 CALLE LOMITA",
    "dropphycty": "GLORIETA",
    "dropphyst": "NM",
    "dropphyzpp": 875359998,
    "dropmaladd": "16 CALLE LOMITA",
    "dropmalcty": "GLORIETA",
    "dropmalst": "NM",
    "dropmalzpp": 875359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756182117,
    "dropsitcph": 5756182117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13775",
    "droptype": "D",
    "dropname": "GRADY",
    "dropdeladd": "406 W MAIN ST",
    "dropdelcty": "GRADY",
    "dropdelst": "NM",
    "dropdelzpp": 881209800,
    "dropphyadd": "406 W MAIN ST",
    "dropphycty": "GRADY",
    "dropphyst": "NM",
    "dropphyzpp": 881209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRADY",
    "dropmalst": "NM",
    "dropmalzpp": 881209998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754463688,
    "dropsitcph": 5754463688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13776",
    "droptype": "D",
    "dropname": "GRANTS",
    "dropdeladd": "816 W SANTA FE AVE",
    "dropdelcty": "GRANTS",
    "dropdelst": "NM",
    "dropdelzpp": 870207000,
    "dropphyadd": "816 W SANTA FE AVE",
    "dropphycty": "GRANTS",
    "dropphyst": "NM",
    "dropphyzpp": 870207000,
    "dropmaladd": "816 W SANTA FE AVE",
    "dropmalcty": "GRANTS",
    "dropmalst": "NM",
    "dropmalzpp": 870207000,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052873143,
    "dropsitcph": 5052873143,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13778",
    "droptype": "D",
    "dropname": "GRENVILLE",
    "dropdeladd": "16 5TH AVE",
    "dropdelcty": "GRENVILLE",
    "dropdelst": "NM",
    "dropdelzpp": 884249998,
    "dropphyadd": "16 5TH AVE",
    "dropphycty": "GRENVILLE",
    "dropphyst": "NM",
    "dropphyzpp": 884249998,
    "dropmaladd": "16 5TH AVE",
    "dropmalcty": "GRENVILLE",
    "dropmalst": "NM",
    "dropmalzpp": 884249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752142978,
    "dropsitcph": 5752142978,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13782",
    "droptype": "D",
    "dropname": "GUADALUPITA",
    "dropdeladd": "1447 STATE HIGHWAY 434",
    "dropdelcty": "GUADALUPITA",
    "dropdelst": "NM",
    "dropdelzpp": 877229998,
    "dropphyadd": "1447 STATE HIGHWAY 434",
    "dropphycty": "GUADALUPITA",
    "dropphyst": "NM",
    "dropphyzpp": 877229998,
    "dropmaladd": "1447 STATE HIGHWAY 434",
    "dropmalcty": "GUADALUPITA",
    "dropmalst": "NM",
    "dropmalzpp": 877229998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753876079,
    "dropsitcph": 5753876079,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13785",
    "droptype": "D",
    "dropname": "HACHITA",
    "dropdeladd": "26 B ST",
    "dropdelcty": "HACHITA",
    "dropdelst": "NM",
    "dropdelzpp": 880409800,
    "dropphyadd": "26 B ST",
    "dropphycty": "HACHITA",
    "dropphyst": "NM",
    "dropphyzpp": 880409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HACHITA",
    "dropmalst": "NM",
    "dropmalzpp": 880409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832026,
    "dropsitcph": 5054832026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13786",
    "droptype": "D",
    "dropname": "HAGERMAN",
    "dropdeladd": "108 E ARGYLE ST",
    "dropdelcty": "HAGERMAN",
    "dropdelst": "NM",
    "dropdelzpp": 882329800,
    "dropphyadd": "108 E ARGYLE ST",
    "dropphycty": "HAGERMAN",
    "dropphyst": "NM",
    "dropphyzpp": 882329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAGERMAN",
    "dropmalst": "NM",
    "dropmalzpp": 882329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757523730,
    "dropsitcph": 5757523730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13787",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "70 FIERRO RD",
    "dropdelcty": "HANOVER",
    "dropdelst": "NM",
    "dropdelzpp": 880419800,
    "dropphyadd": "70 FIERRO RD",
    "dropphycty": "HANOVER",
    "dropphyst": "NM",
    "dropphyzpp": 880419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANOVER",
    "dropmalst": "NM",
    "dropmalzpp": 880419998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755375696,
    "dropsitcph": 5755375696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13789",
    "droptype": "D",
    "dropname": "HATCH",
    "dropdeladd": "107 E DAVIS ST",
    "dropdelcty": "HATCH",
    "dropdelst": "NM",
    "dropdelzpp": 879379800,
    "dropphyadd": "107 E DAVIS ST",
    "dropphycty": "HATCH",
    "dropphyst": "NM",
    "dropphyzpp": 879379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HATCH",
    "dropmalst": "NM",
    "dropmalzpp": 879379998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752674811,
    "dropsitcph": 5752674811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13795",
    "droptype": "D",
    "dropname": "HIGH ROLLS MOUNTAIN PARK",
    "dropdeladd": "4 CHERRY BLOSSOM",
    "dropdelcty": "HIGH ROLLS MOUNTAIN PARK",
    "dropdelst": "NM",
    "dropdelzpp": 883259800,
    "dropphyadd": "4 CHERRY BLOSSOM",
    "dropphycty": "HIGH ROLLS MOUNTAIN PARK",
    "dropphyst": "NM",
    "dropphyzpp": 883259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HIGH ROLLS MOUNTAIN PARK",
    "dropmalst": "NM",
    "dropmalzpp": 883259998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756822974,
    "dropsitcph": 5756822974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13798",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "NM",
    "dropdelzpp": 880429800,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "NM",
    "dropphyzpp": 880429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "NM",
    "dropmalzpp": 880429998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758955315,
    "dropsitcph": 5758955315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13799",
    "droptype": "D",
    "dropname": "HOBBS",
    "dropdeladd": "2200 N ALTO DR",
    "dropdelcty": "HOBBS",
    "dropdelst": "NM",
    "dropdelzpp": 882409998,
    "dropphyadd": "2200 N ALTO DR",
    "dropphycty": "HOBBS",
    "dropphyst": "NM",
    "dropphyzpp": 882409998,
    "dropmaladd": "2200 N ALTO DR",
    "dropmalcty": "HOBBS",
    "dropmalst": "NM",
    "dropmalzpp": 882409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753932912,
    "dropsitcph": 5753932912,
    "dropfax": 5753973759
  },
  {
    "dcode": "D",
    "dropkey": "PZ13801",
    "droptype": "D",
    "dropname": "HOLLOMAN AIR FORCE BASE",
    "dropdeladd": "721 NEW MEXICO AVE",
    "dropdelcty": "HOLLOMAN AIR FORCE BASE",
    "dropdelst": "NM",
    "dropdelzpp": 883309998,
    "dropphyadd": "721 NEW MEXICO AVE",
    "dropphycty": "HOLLOMAN AIR FORCE BASE",
    "dropphyst": "NM",
    "dropphyzpp": 883309998,
    "dropmaladd": "721 NEW MEXICO AVE",
    "dropmalcty": "HOLLOMAN AIR FORCE BASE",
    "dropmalst": "NM",
    "dropmalzpp": 883309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755723192,
    "dropsitcph": 5755723192,
    "dropfax": 5754796279
  },
  {
    "dcode": "D",
    "dropkey": "PZ13804",
    "droptype": "D",
    "dropname": "HOLMAN",
    "dropdeladd": "3543 STATE HIGHWAY 518",
    "dropdelcty": "HOLMAN",
    "dropdelst": "NM",
    "dropdelzpp": 877231001,
    "dropphyadd": "3543 STATE HIGHWAY 518",
    "dropphycty": "HOLMAN",
    "dropphyst": "NM",
    "dropphyzpp": 877231001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOLMAN",
    "dropmalst": "NM",
    "dropmalzpp": 877239998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753872028,
    "dropsitcph": 5753872028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13805",
    "droptype": "D",
    "dropname": "HONDO",
    "dropdeladd": "28633 US HIGHWAY 70",
    "dropdelcty": "HONDO",
    "dropdelst": "NM",
    "dropdelzpp": 883369800,
    "dropphyadd": "28633 US HIGHWAY 70",
    "dropphycty": "HONDO",
    "dropphyst": "NM",
    "dropphyzpp": 883369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONDO",
    "dropmalst": "NM",
    "dropmalzpp": 883369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756534306,
    "dropsitcph": 5756534306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13806",
    "droptype": "D",
    "dropname": "HOPE",
    "dropdeladd": "810 MAIN ST",
    "dropdelcty": "HOPE",
    "dropdelst": "NM",
    "dropdelzpp": 882509800,
    "dropphyadd": "810 MAIN ST",
    "dropphycty": "HOPE",
    "dropphyst": "NM",
    "dropphyzpp": 882509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOPE",
    "dropmalst": "NM",
    "dropmalzpp": 882509998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754843503,
    "dropsitcph": 5754843503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13808",
    "droptype": "D",
    "dropname": "HOUSE",
    "dropdeladd": "105 N APPLE ST",
    "dropdelcty": "HOUSE",
    "dropdelst": "NM",
    "dropdelzpp": 881219800,
    "dropphyadd": "105 N APPLE ST",
    "dropphycty": "HOUSE",
    "dropphyst": "NM",
    "dropphyzpp": 881219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOUSE",
    "dropmalst": "NM",
    "dropmalzpp": 881219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752860104,
    "dropsitcph": 5752860104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13809",
    "droptype": "D",
    "dropname": "HURLEY",
    "dropdeladd": "16 CORTEZ AVE",
    "dropdelcty": "HURLEY",
    "dropdelst": "NM",
    "dropdelzpp": 880439800,
    "dropphyadd": "16 CORTEZ AVE",
    "dropphycty": "HURLEY",
    "dropphyst": "NM",
    "dropphyzpp": 880439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HURLEY",
    "dropmalst": "NM",
    "dropmalzpp": 880439998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755372146,
    "dropsitcph": 5755372146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13812",
    "droptype": "D",
    "dropname": "ISLETA",
    "dropdeladd": "119 TRIBAL ROAD 40",
    "dropdelcty": "ISLETA",
    "dropdelst": "NM",
    "dropdelzpp": 870229998,
    "dropphyadd": "119 TRIBAL ROAD 40",
    "dropphycty": "ISLETA",
    "dropphyst": "NM",
    "dropphyzpp": 870229998,
    "dropmaladd": "119 TRIBAL ROAD 40",
    "dropmalcty": "ISLETA",
    "dropmalst": "NM",
    "dropmalzpp": 870229998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058693907,
    "dropsitcph": 5058693907,
    "dropfax": 5058692445
  },
  {
    "dcode": "D",
    "dropkey": "PZ13815",
    "droptype": "D",
    "dropname": "JAL",
    "dropdeladd": "111 S 4TH ST",
    "dropdelcty": "JAL",
    "dropdelst": "NM",
    "dropdelzpp": 882529800,
    "dropphyadd": "111 S 4TH ST",
    "dropphycty": "JAL",
    "dropphyst": "NM",
    "dropphyzpp": 882529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JAL",
    "dropmalst": "NM",
    "dropmalzpp": 882529998,
    "dropsitphn": 5753953222,
    "dropsitlph": 5753953222,
    "dropsitcph": 5753953222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13817",
    "droptype": "D",
    "dropname": "JARALES",
    "dropdeladd": "483 HIGHWAY 109",
    "dropdelcty": "JARALES",
    "dropdelst": "NM",
    "dropdelzpp": 870239998,
    "dropphyadd": "483 HIGHWAY 109",
    "dropphycty": "JARALES",
    "dropphyst": "NM",
    "dropphyzpp": 870239998,
    "dropmaladd": "483 HIGHWAY 109",
    "dropmalcty": "JARALES",
    "dropmalst": "NM",
    "dropmalzpp": 870239998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058648525,
    "dropsitcph": 5058648525,
    "dropfax": 5058648525
  },
  {
    "dcode": "D",
    "dropkey": "PZ13818",
    "droptype": "D",
    "dropname": "JEMEZ PUEBLO",
    "dropdeladd": "4965 HIGHWAY 4",
    "dropdelcty": "JEMEZ PUEBLO",
    "dropdelst": "NM",
    "dropdelzpp": 870249998,
    "dropphyadd": "4965 HIGHWAY 4",
    "dropphycty": "JEMEZ PUEBLO",
    "dropphyst": "NM",
    "dropphyzpp": 870249998,
    "dropmaladd": "4965 HIGHWAY 4",
    "dropmalcty": "JEMEZ PUEBLO",
    "dropmalst": "NM",
    "dropmalzpp": 870249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752540115,
    "dropsitcph": 5752540115,
    "dropfax": 5752540103
  },
  {
    "dcode": "D",
    "dropkey": "PZ13819",
    "droptype": "D",
    "dropname": "JEMEZ SPRINGS",
    "dropdeladd": "16957 HIGHWAY 4",
    "dropdelcty": "JEMEZ SPRINGS",
    "dropdelst": "NM",
    "dropdelzpp": 870259998,
    "dropphyadd": "16957 HIGHWAY 4",
    "dropphycty": "JEMEZ SPRINGS",
    "dropphyst": "NM",
    "dropphyzpp": 870259998,
    "dropmaladd": "16957 HIGHWAY 4",
    "dropmalcty": "JEMEZ SPRINGS",
    "dropmalst": "NM",
    "dropmalzpp": 870259998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752540086,
    "dropsitcph": 5752540086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13824",
    "droptype": "D",
    "dropname": "KIRTLAND",
    "dropdeladd": "4211 US 64",
    "dropdelcty": "KIRTLAND",
    "dropdelst": "NM",
    "dropdelzpp": 874179998,
    "dropphyadd": "4211 US 64",
    "dropphycty": "KIRTLAND",
    "dropphyst": "NM",
    "dropphyzpp": 874179998,
    "dropmaladd": "4211 US 64",
    "dropmalcty": "KIRTLAND",
    "dropmalst": "NM",
    "dropmalzpp": 874179998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054394093,
    "dropsitcph": 5054394093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13834",
    "droptype": "D",
    "dropname": "LA JARA",
    "dropdeladd": "167 STATE HIGHWAY 96",
    "dropdelcty": "LA JARA",
    "dropdelst": "NM",
    "dropdelzpp": 870279998,
    "dropphyadd": "167 STATE HIGHWAY 96",
    "dropphycty": "LA JARA",
    "dropphyst": "NM",
    "dropphyzpp": 870279998,
    "dropmaladd": "167 STATE HIGHWAY 96",
    "dropmalcty": "LA JARA",
    "dropmalst": "NM",
    "dropmalzpp": 870279998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752893668,
    "dropsitcph": 5752893668,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13838",
    "droptype": "D",
    "dropname": "LA LUZ",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "LA LUZ",
    "dropdelst": "NM",
    "dropdelzpp": 883379800,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "LA LUZ",
    "dropphyst": "NM",
    "dropphyzpp": 883379800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA LUZ",
    "dropmalst": "NM",
    "dropmalzpp": 883379998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754341078,
    "dropsitcph": 5754341078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13839",
    "droptype": "D",
    "dropname": "LA MADERA",
    "dropdeladd": "4 STATE ROAD 519",
    "dropdelcty": "LA MADERA",
    "dropdelst": "NM",
    "dropdelzpp": 875399998,
    "dropphyadd": "4 STATE ROAD 519",
    "dropphycty": "LA MADERA",
    "dropphyst": "NM",
    "dropphyzpp": 875399998,
    "dropmaladd": "4 STATE ROAD 519",
    "dropmalcty": "LA MADERA",
    "dropmalst": "NM",
    "dropmalzpp": 875399998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055832223,
    "dropsitcph": 5055832223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13840",
    "droptype": "D",
    "dropname": "LA MESA",
    "dropdeladd": "16140 S HIGHWAY 28",
    "dropdelcty": "LA MESA",
    "dropdelst": "NM",
    "dropdelzpp": 880449802,
    "dropphyadd": "16140 S HIGHWAY 28",
    "dropphycty": "LA MESA",
    "dropphyst": "NM",
    "dropphyzpp": 880449802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA MESA",
    "dropmalst": "NM",
    "dropmalzpp": 880449998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752333531,
    "dropsitcph": 5752333531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13842",
    "droptype": "D",
    "dropname": "LA PLATA",
    "dropdeladd": "1239 NM 170",
    "dropdelcty": "LA PLATA",
    "dropdelst": "NM",
    "dropdelzpp": 874189998,
    "dropphyadd": "1239 NM 170",
    "dropphycty": "LA PLATA",
    "dropphyst": "NM",
    "dropphyzpp": 874189998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA PLATA",
    "dropmalst": "NM",
    "dropmalzpp": 874189997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053255775,
    "dropsitcph": 5053255775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13847",
    "droptype": "D",
    "dropname": "LAGUNA",
    "dropdeladd": "6 RIO SAN JOSE RD",
    "dropdelcty": "LAGUNA",
    "dropdelst": "NM",
    "dropdelzpp": 870269998,
    "dropphyadd": "6 RIO SAN JOSE RD",
    "dropphycty": "LAGUNA",
    "dropphyst": "NM",
    "dropphyzpp": 870269998,
    "dropmaladd": "6 RIO SAN JOSE RD",
    "dropmalcty": "LAGUNA",
    "dropmalst": "NM",
    "dropmalzpp": 870269998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055526105,
    "dropsitcph": 5055526105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13849",
    "droptype": "D",
    "dropname": "LA JOYA",
    "dropdeladd": "8 HIGHWAY 304",
    "dropdelcty": "LA JOYA",
    "dropdelst": "NM",
    "dropdelzpp": 870289998,
    "dropphyadd": "8 HIGHWAY 304",
    "dropphycty": "LA JOYA",
    "dropphyst": "NM",
    "dropphyzpp": 870289998,
    "dropmaladd": "8 HIGHWAY 304",
    "dropmalcty": "LA JOYA",
    "dropmalst": "NM",
    "dropmalzpp": 870289998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058615708,
    "dropsitcph": 5058615708,
    "dropfax": 5058615709
  },
  {
    "dcode": "D",
    "dropkey": "PZ13850",
    "droptype": "D",
    "dropname": "LAKE ARTHUR",
    "dropdeladd": "506 N NEVADA RD",
    "dropdelcty": "LAKE ARTHUR",
    "dropdelst": "NM",
    "dropdelzpp": 882539800,
    "dropphyadd": "506 N NEVADA RD",
    "dropphycty": "LAKE ARTHUR",
    "dropphyst": "NM",
    "dropphyzpp": 882539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE ARTHUR",
    "dropmalst": "NM",
    "dropmalzpp": 882539998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753652069,
    "dropsitcph": 5753652069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13852",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "194 LAKEWOOD RD",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "NM",
    "dropdelzpp": 882549800,
    "dropphyadd": "194 LAKEWOOD RD",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "NM",
    "dropphyzpp": 882549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "NM",
    "dropmalzpp": 882549998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754572535,
    "dropsitcph": 5754572535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13856",
    "droptype": "D",
    "dropname": "LAS CRUCES",
    "dropdeladd": "201 E LAS CRUCES AVE",
    "dropdelcty": "LAS CRUCES",
    "dropdelst": "NM",
    "dropdelzpp": 880019998,
    "dropphyadd": "201 E LAS CRUCES AVE",
    "dropphycty": "LAS CRUCES",
    "dropphyst": "NM",
    "dropphyzpp": 880019998,
    "dropmaladd": "201 E LAS CRUCES AVE",
    "dropmalcty": "LAS CRUCES",
    "dropmalst": "NM",
    "dropmalzpp": 880019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755242903,
    "dropsitcph": 5755242903,
    "dropfax": 5755252411
  },
  {
    "dcode": "D",
    "dropkey": "PZ13862",
    "droptype": "D",
    "dropname": "LAS VEGAS",
    "dropdeladd": "1001 DOUGLAS AVE",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NM",
    "dropdelzpp": 877019998,
    "dropphyadd": "1001 DOUGLAS AVE",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NM",
    "dropphyzpp": 877019998,
    "dropmaladd": "1001 DOUGLAS AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NM",
    "dropmalzpp": 877019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054259387,
    "dropsitcph": 5054259387,
    "dropfax": 5054254124
  },
  {
    "dcode": "D",
    "dropkey": "PZ13864",
    "droptype": "D",
    "dropname": "LEMITAR",
    "dropdeladd": "5 CHAMBON RD",
    "dropdelcty": "LEMITAR",
    "dropdelst": "NM",
    "dropdelzpp": 878239998,
    "dropphyadd": "5 CHAMBON RD",
    "dropphycty": "LEMITAR",
    "dropphyst": "NM",
    "dropphyzpp": 878239998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEMITAR",
    "dropmalst": "NM",
    "dropmalzpp": 878239997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758380973,
    "dropsitcph": 5758380973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13867",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "859 CALLE LA PLACITA",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NM",
    "dropdelzpp": 883389800,
    "dropphyadd": "859 CALLE LA PLACITA",
    "dropphycty": "LINCOLN",
    "dropphyst": "NM",
    "dropphyzpp": 883389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NM",
    "dropmalzpp": 883389998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756534680,
    "dropsitcph": 5756534680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13869",
    "droptype": "D",
    "dropname": "LINDRITH",
    "dropdeladd": "1094 STATE HIGHWAY 595",
    "dropdelcty": "LINDRITH",
    "dropdelst": "NM",
    "dropdelzpp": 870299998,
    "dropphyadd": "1094 STATE HIGHWAY 595",
    "dropphycty": "LINDRITH",
    "dropphyst": "NM",
    "dropphyzpp": 870299998,
    "dropmaladd": "1094 STATE HIGHWAY 595",
    "dropmalcty": "LINDRITH",
    "dropmalst": "NM",
    "dropmalzpp": 870299998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757746516,
    "dropsitcph": 5757746516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13877",
    "droptype": "D",
    "dropname": "LOCO HILLS",
    "dropdeladd": "3 GOAT ROPER RD",
    "dropdelcty": "LOCO HILLS",
    "dropdelst": "NM",
    "dropdelzpp": 882559800,
    "dropphyadd": "3 GOAT ROPER RD",
    "dropphycty": "LOCO HILLS",
    "dropphyst": "NM",
    "dropphyzpp": 882559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCO HILLS",
    "dropmalst": "NM",
    "dropmalzpp": 882559998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756773295,
    "dropsitcph": 5756773295,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13878",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "1003 MARTINEZ ST",
    "dropdelcty": "LOGAN",
    "dropdelst": "NM",
    "dropdelzpp": 884269998,
    "dropphyadd": "1003 MARTINEZ ST",
    "dropphycty": "LOGAN",
    "dropphyst": "NM",
    "dropphyzpp": 884269998,
    "dropmaladd": "1003 MARTINEZ ST",
    "dropmalcty": "LOGAN",
    "dropmalst": "NM",
    "dropmalzpp": 884269998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754894016,
    "dropsitcph": 5754894016,
    "dropfax": 5754894015
  },
  {
    "dcode": "D",
    "dropkey": "PZ13879",
    "droptype": "D",
    "dropname": "LORDSBURG",
    "dropdeladd": "401 SHAKESPEARE ST",
    "dropdelcty": "LORDSBURG",
    "dropdelst": "NM",
    "dropdelzpp": 880459998,
    "dropphyadd": "401 SHAKESPEARE ST",
    "dropphycty": "LORDSBURG",
    "dropphyst": "NM",
    "dropphyzpp": 880459998,
    "dropmaladd": "401 SHAKESPEARE ST",
    "dropmalcty": "LORDSBURG",
    "dropmalst": "NM",
    "dropmalzpp": 880459998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832087,
    "dropsitcph": 5054832087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13880",
    "droptype": "D",
    "dropname": "LOS ALAMOS",
    "dropdeladd": "199 CENTRAL PARK SQ",
    "dropdelcty": "LOS ALAMOS",
    "dropdelst": "NM",
    "dropdelzpp": 875444037,
    "dropphyadd": "199 CENTRAL PARK SQ",
    "dropphycty": "LOS ALAMOS",
    "dropphyst": "NM",
    "dropphyzpp": 875444037,
    "dropmaladd": "199 CENTRAL PARK SQ",
    "dropmalcty": "LOS ALAMOS",
    "dropmalst": "NM",
    "dropmalzpp": 875444037,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056622153,
    "dropsitcph": 5056622153,
    "dropfax": 5056625329
  },
  {
    "dcode": "D",
    "dropkey": "PZ13883",
    "droptype": "D",
    "dropname": "LOS LUNAS",
    "dropdeladd": "100 CARSON DR SE",
    "dropdelcty": "LOS LUNAS",
    "dropdelst": "NM",
    "dropdelzpp": 870319998,
    "dropphyadd": "100 CARSON DR SE",
    "dropphycty": "LOS LUNAS",
    "dropphyst": "NM",
    "dropphyzpp": 870319998,
    "dropmaladd": "100 CARSON DR SE",
    "dropmalcty": "LOS LUNAS",
    "dropmalst": "NM",
    "dropmalzpp": 870319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058657887,
    "dropsitcph": 5058657887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13884",
    "droptype": "D",
    "dropname": "LOS OJOS",
    "dropdeladd": "95 STATE ROAD 514",
    "dropdelcty": "LOS OJOS",
    "dropdelst": "NM",
    "dropdelzpp": 875519997,
    "dropphyadd": "95 STATE ROAD 514",
    "dropphycty": "LOS OJOS",
    "dropphyst": "NM",
    "dropphyzpp": 875519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOS OJOS",
    "dropmalst": "NM",
    "dropmalzpp": 875519998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752095254,
    "dropsitcph": 5752095254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13890",
    "droptype": "D",
    "dropname": "LOVING",
    "dropdeladd": "402 W BEECH ST",
    "dropdelcty": "LOVING",
    "dropdelst": "NM",
    "dropdelzpp": 882569800,
    "dropphyadd": "402 W BEECH ST",
    "dropphycty": "LOVING",
    "dropphyst": "NM",
    "dropphyzpp": 882569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOVING",
    "dropmalst": "NM",
    "dropmalzpp": 882569998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754141098,
    "dropsitcph": 5754141098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13891",
    "droptype": "D",
    "dropname": "LOVINGTON",
    "dropdeladd": "203 E AVENUE D",
    "dropdelcty": "LOVINGTON",
    "dropdelst": "NM",
    "dropdelzpp": 882609998,
    "dropphyadd": "203 E AVENUE D",
    "dropphycty": "LOVINGTON",
    "dropphyst": "NM",
    "dropphyzpp": 882609998,
    "dropmaladd": "203 E AVENUE D",
    "dropmalcty": "LOVINGTON",
    "dropmalst": "NM",
    "dropmalzpp": 882609998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753962300,
    "dropsitcph": 5753962300,
    "dropfax": 5753962859
  },
  {
    "dcode": "D",
    "dropkey": "PZ13900",
    "droptype": "D",
    "dropname": "LUNA",
    "dropdeladd": "747 US HIGHWAY 180",
    "dropdelcty": "LUNA",
    "dropdelst": "NM",
    "dropdelzpp": 878249998,
    "dropphyadd": "747 US HIGHWAY 180",
    "dropphycty": "LUNA",
    "dropphyst": "NM",
    "dropphyzpp": 878249998,
    "dropmaladd": "747 US HIGHWAY 180",
    "dropmalcty": "LUNA",
    "dropmalst": "NM",
    "dropmalzpp": 878249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755472044,
    "dropsitcph": 5755472044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13903",
    "droptype": "D",
    "dropname": "MAGDALENA",
    "dropdeladd": "100 E 1ST ST",
    "dropdelcty": "MAGDALENA",
    "dropdelst": "NM",
    "dropdelzpp": 878259998,
    "dropphyadd": "100 E 1ST ST",
    "dropphycty": "MAGDALENA",
    "dropphyst": "NM",
    "dropphyzpp": 878259998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAGDALENA",
    "dropmalst": "NM",
    "dropmalzpp": 878259997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832018,
    "dropsitcph": 5054832018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13904",
    "droptype": "D",
    "dropname": "MALAGA",
    "dropdeladd": "1623 PECOS HWY",
    "dropdelcty": "MALAGA",
    "dropdelst": "NM",
    "dropdelzpp": 882639800,
    "dropphyadd": "1623 PECOS HWY",
    "dropphycty": "MALAGA",
    "dropphyst": "NM",
    "dropphyzpp": 882639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALAGA",
    "dropmalst": "NM",
    "dropmalzpp": 882639998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752371710,
    "dropsitcph": 5752371710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13905",
    "droptype": "D",
    "dropname": "MALJAMAR",
    "dropdeladd": "11060 HIGHWAY 82",
    "dropdelcty": "MALJAMAR",
    "dropdelst": "NM",
    "dropdelzpp": 882649801,
    "dropphyadd": "11060 HIGHWAY 82",
    "dropphycty": "MALJAMAR",
    "dropphyst": "NM",
    "dropphyzpp": 882649801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALJAMAR",
    "dropmalst": "NM",
    "dropmalzpp": 882649998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756763411,
    "dropsitcph": 5756763411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13909",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "300 MAXWELL AVE",
    "dropdelcty": "MAXWELL",
    "dropdelst": "NM",
    "dropdelzpp": 877289998,
    "dropphyadd": "300 MAXWELL AVE",
    "dropphycty": "MAXWELL",
    "dropphyst": "NM",
    "dropphyzpp": 877289998,
    "dropmaladd": "300 MAXWELL AVE",
    "dropmalcty": "MAXWELL",
    "dropmalst": "NM",
    "dropmalzpp": 877289998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753752611,
    "dropsitcph": 5753752611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13910",
    "droptype": "D",
    "dropname": "MAYHILL",
    "dropdeladd": "3495 US HIGHWAY 82",
    "dropdelcty": "MAYHILL",
    "dropdelst": "NM",
    "dropdelzpp": 883399800,
    "dropphyadd": "3495 US HIGHWAY 82",
    "dropphycty": "MAYHILL",
    "dropphyst": "NM",
    "dropphyzpp": 883399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYHILL",
    "dropmalst": "NM",
    "dropmalzpp": 883399998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756873638,
    "dropsitcph": 5756873638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13911",
    "droptype": "D",
    "dropname": "MCALISTER",
    "dropdeladd": "3209 STATE HIGHWAY 252",
    "dropdelcty": "MCALISTER",
    "dropdelst": "NM",
    "dropdelzpp": 884279998,
    "dropphyadd": "3209 STATE HIGHWAY 252",
    "dropphycty": "MCALISTER",
    "dropphyst": "NM",
    "dropphyzpp": 884279998,
    "dropmaladd": "3209 STATE HIGHWAY 252",
    "dropmalcty": "MCALISTER",
    "dropmalst": "NM",
    "dropmalzpp": 884279998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756186693,
    "dropsitcph": 5756186693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13913",
    "droptype": "D",
    "dropname": "MCINTOSH",
    "dropdeladd": "1820 HIGHWAY 41",
    "dropdelcty": "MCINTOSH",
    "dropdelst": "NM",
    "dropdelzpp": 870329998,
    "dropphyadd": "1820 HIGHWAY 41",
    "dropphycty": "MCINTOSH",
    "dropphyst": "NM",
    "dropphyzpp": 870329998,
    "dropmaladd": "1820 HIGHWAY 41",
    "dropmalcty": "MCINTOSH",
    "dropmalst": "NM",
    "dropmalzpp": 870329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756182327,
    "dropsitcph": 5756182327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13919",
    "droptype": "D",
    "dropname": "MEDANALES",
    "dropdeladd": "180 COUNTY ROAD 142",
    "dropdelcty": "MEDANALES",
    "dropdelst": "NM",
    "dropdelzpp": 875489998,
    "dropphyadd": "180 COUNTY ROAD 142",
    "dropphycty": "MEDANALES",
    "dropphyst": "NM",
    "dropphyzpp": 875489998,
    "dropmaladd": "180 COUNTY ROAD 142",
    "dropmalcty": "MEDANALES",
    "dropmalst": "NM",
    "dropmalzpp": 875489998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056854099,
    "dropsitcph": 5056854099,
    "dropfax": 5056854099
  },
  {
    "dcode": "D",
    "dropkey": "PZ13921",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "501 N 5TH ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "NM",
    "dropdelzpp": 881249800,
    "dropphyadd": "501 N 5TH ST",
    "dropphycty": "MELROSE",
    "dropphyst": "NM",
    "dropphyzpp": 881249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MELROSE",
    "dropmalst": "NM",
    "dropmalzpp": 881249998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753298018,
    "dropsitcph": 5753298018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13924",
    "droptype": "D",
    "dropname": "MESCALERO",
    "dropdeladd": "124 CHIRICAHUA PLZ",
    "dropdelcty": "MESCALERO",
    "dropdelst": "NM",
    "dropdelzpp": 883409801,
    "dropphyadd": "124 CHIRICAHUA PLZ",
    "dropphycty": "MESCALERO",
    "dropphyst": "NM",
    "dropphyzpp": 883409801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESCALERO",
    "dropmalst": "NM",
    "dropmalzpp": 883409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752281238,
    "dropsitcph": 5752281238,
    "dropfax": 5752281174
  },
  {
    "dcode": "D",
    "dropkey": "PZ13926",
    "droptype": "D",
    "dropname": "MESILLA",
    "dropdeladd": "2253 CALLE DE PARIAN",
    "dropdelcty": "MESILLA",
    "dropdelst": "NM",
    "dropdelzpp": 880469800,
    "dropphyadd": "2253 CALLE DE PARIAN",
    "dropphycty": "MESILLA",
    "dropphyst": "NM",
    "dropphyzpp": 880469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESILLA",
    "dropmalst": "NM",
    "dropmalzpp": 880469998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755241531,
    "dropsitcph": 5755241531,
    "dropfax": 5756472953
  },
  {
    "dcode": "D",
    "dropkey": "PZ13927",
    "droptype": "D",
    "dropname": "MESILLA PARK",
    "dropdeladd": "310 E UNION AVE",
    "dropdelcty": "MESILLA PARK",
    "dropdelst": "NM",
    "dropdelzpp": 880479800,
    "dropphyadd": "310 E UNION AVE",
    "dropphycty": "MESILLA PARK",
    "dropphyst": "NM",
    "dropphyzpp": 880479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESILLA PARK",
    "dropmalst": "NM",
    "dropmalzpp": 880479998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755237088,
    "dropsitcph": 5755237088,
    "dropfax": 5755251835
  },
  {
    "dcode": "D",
    "dropkey": "PZ13929",
    "droptype": "D",
    "dropname": "MESQUITE",
    "dropdeladd": "395 HIGHWAY 228",
    "dropdelcty": "MESQUITE",
    "dropdelst": "NM",
    "dropdelzpp": 880489800,
    "dropphyadd": "395 HIGHWAY 228",
    "dropphycty": "MESQUITE",
    "dropphyst": "NM",
    "dropphyzpp": 880489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MESQUITE",
    "dropmalst": "NM",
    "dropmalzpp": 880489998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752333501,
    "dropsitcph": 5752333501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13935",
    "droptype": "D",
    "dropname": "MILLS",
    "dropdeladd": "100 WILSON AVE",
    "dropdelcty": "MILLS",
    "dropdelst": "NM",
    "dropdelzpp": 877309998,
    "dropphyadd": "100 WILSON AVE",
    "dropphycty": "MILLS",
    "dropphyst": "NM",
    "dropphyzpp": 877309998,
    "dropmaladd": "100 WILSON AVE",
    "dropmalcty": "MILLS",
    "dropmalst": "NM",
    "dropmalzpp": 877309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754852620,
    "dropsitcph": 5754852620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13937",
    "droptype": "D",
    "dropname": "MIMBRES",
    "dropdeladd": "3084 HIGHWAY 35 N",
    "dropdelcty": "MIMBRES",
    "dropdelst": "NM",
    "dropdelzpp": 880499800,
    "dropphyadd": "3084 HIGHWAY 35 N",
    "dropphycty": "MIMBRES",
    "dropphyst": "NM",
    "dropphyzpp": 880499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MIMBRES",
    "dropmalst": "NM",
    "dropmalzpp": 880499998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755369810,
    "dropsitcph": 5755369810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13940",
    "droptype": "D",
    "dropname": "MONTEZUMA",
    "dropdeladd": "4 CAMPUS DR",
    "dropdelcty": "MONTEZUMA",
    "dropdelst": "NM",
    "dropdelzpp": 877311000,
    "dropphyadd": "4 CAMPUS DR",
    "dropphycty": "MONTEZUMA",
    "dropphyst": "NM",
    "dropphyzpp": 877311000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEZUMA",
    "dropmalst": "NM",
    "dropmalzpp": 877319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054258608,
    "dropsitcph": 5054258608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13941",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "355 CALLE DEL NORTE RD",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "NM",
    "dropdelzpp": 879399800,
    "dropphyadd": "355 CALLE DEL NORTE RD",
    "dropphycty": "MONTICELLO",
    "dropphyst": "NM",
    "dropphyzpp": 879399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "NM",
    "dropmalzpp": 879399998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757430076,
    "dropsitcph": 5757430076,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13942",
    "droptype": "D",
    "dropname": "MONUMENT",
    "dropdeladd": "9921 W NM HIGHWAY 322",
    "dropdelcty": "MONUMENT",
    "dropdelst": "NM",
    "dropdelzpp": 882659800,
    "dropphyadd": "9921 W NM HIGHWAY 322",
    "dropphycty": "MONUMENT",
    "dropphyst": "NM",
    "dropphyzpp": 882659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONUMENT",
    "dropmalst": "NM",
    "dropmalzpp": 882659998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753935015,
    "dropsitcph": 5753935015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13943",
    "droptype": "D",
    "dropname": "MORA",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "MORA",
    "dropdelst": "NM",
    "dropdelzpp": 877321000,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "MORA",
    "dropphyst": "NM",
    "dropphyzpp": 877321000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORA",
    "dropmalst": "NM",
    "dropmalzpp": 877329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753872245,
    "dropsitcph": 5753872245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13944",
    "droptype": "D",
    "dropname": "MORIARTY",
    "dropdeladd": "514 ROUTE 66",
    "dropdelcty": "MORIARTY",
    "dropdelst": "NM",
    "dropdelzpp": 870359998,
    "dropphyadd": "514 ROUTE 66",
    "dropphycty": "MORIARTY",
    "dropphyst": "NM",
    "dropphyzpp": 870359998,
    "dropmaladd": "514 ROUTE 66",
    "dropmalcty": "MORIARTY",
    "dropmalst": "NM",
    "dropmalzpp": 870359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058324914,
    "dropsitcph": 5058324914,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13946",
    "droptype": "D",
    "dropname": "MOSQUERO",
    "dropdeladd": "34 MAIN ST",
    "dropdelcty": "MOSQUERO",
    "dropdelst": "NM",
    "dropdelzpp": 877331000,
    "dropphyadd": "34 MAIN ST",
    "dropphycty": "MOSQUERO",
    "dropphyst": "NM",
    "dropphyzpp": 877331000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSQUERO",
    "dropmalst": "NM",
    "dropmalzpp": 877339998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752864996,
    "dropsitcph": 5752864996,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13949",
    "droptype": "D",
    "dropname": "MOUNTAINAIR",
    "dropdeladd": "221 BROADWAY W",
    "dropdelcty": "MOUNTAINAIR",
    "dropdelst": "NM",
    "dropdelzpp": 870369998,
    "dropphyadd": "221 BROADWAY W",
    "dropphycty": "MOUNTAINAIR",
    "dropphyst": "NM",
    "dropphyzpp": 870369998,
    "dropmaladd": "221 BROADWAY W",
    "dropmalcty": "MOUNTAINAIR",
    "dropmalst": "NM",
    "dropmalzpp": 870369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058472206,
    "dropsitcph": 5058472206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13951",
    "droptype": "D",
    "dropname": "MULE CREEK",
    "dropdeladd": "5 BRUSHY MOUNTAIN RD",
    "dropdelcty": "MULE CREEK",
    "dropdelst": "NM",
    "dropdelzpp": 880519800,
    "dropphyadd": "5 BRUSHY MOUNTAIN RD",
    "dropphycty": "MULE CREEK",
    "dropphyst": "NM",
    "dropphyzpp": 880519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MULE CREEK",
    "dropmalst": "NM",
    "dropmalzpp": 880519998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755354266,
    "dropsitcph": 5755354266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13952",
    "droptype": "D",
    "dropname": "NAGEEZI",
    "dropdeladd": "11577 US HIGHWAY 550",
    "dropdelcty": "NAGEEZI",
    "dropdelst": "NM",
    "dropdelzpp": 870379998,
    "dropphyadd": "11577 US HIGHWAY 550",
    "dropphycty": "NAGEEZI",
    "dropphyst": "NM",
    "dropphyzpp": 870379998,
    "dropmaladd": "11577 US HIGHWAY 550",
    "dropmalcty": "NAGEEZI",
    "dropmalst": "NM",
    "dropmalzpp": 870379998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055607107,
    "dropsitcph": 5055607106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13954",
    "droptype": "D",
    "dropname": "NARA VISA",
    "dropdeladd": "460 BELL ST",
    "dropdelcty": "NARA VISA",
    "dropdelst": "NM",
    "dropdelzpp": 884309998,
    "dropphyadd": "460 BELL ST",
    "dropphycty": "NARA VISA",
    "dropphyst": "NM",
    "dropphyzpp": 884309998,
    "dropmaladd": "460 BELL ST",
    "dropmalcty": "NARA VISA",
    "dropmalst": "NM",
    "dropmalzpp": 884309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756332958,
    "dropsitcph": 5756332958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13957",
    "droptype": "D",
    "dropname": "NAVAJO DAM",
    "dropdeladd": "1787 HIGHWAY 173",
    "dropdelcty": "NAVAJO DAM",
    "dropdelst": "NM",
    "dropdelzpp": 874199997,
    "dropphyadd": "1787 HIGHWAY 173",
    "dropphycty": "NAVAJO DAM",
    "dropphyst": "NM",
    "dropphyzpp": 874199997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAVAJO DAM",
    "dropmalst": "NM",
    "dropmalzpp": 874199998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056320722,
    "dropsitcph": 5056320722,
    "dropfax": 5056327586
  },
  {
    "dcode": "D",
    "dropkey": "PZ13959",
    "droptype": "D",
    "dropname": "NEW LAGUNA",
    "dropdeladd": "22 STATE ROAD 124",
    "dropdelcty": "NEW LAGUNA",
    "dropdelst": "NM",
    "dropdelzpp": 870381000,
    "dropphyadd": "22 STATE ROAD 124",
    "dropphycty": "NEW LAGUNA",
    "dropphyst": "NM",
    "dropphyzpp": 870381000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW LAGUNA",
    "dropmalst": "NM",
    "dropmalzpp": 870389998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055529290,
    "dropsitcph": 5055529290,
    "dropfax": 5055520267
  },
  {
    "dcode": "D",
    "dropkey": "PZ13964",
    "droptype": "D",
    "dropname": "NEWKIRK",
    "dropdeladd": "1006 EMERALD RD",
    "dropdelcty": "NEWKIRK",
    "dropdelst": "NM",
    "dropdelzpp": 884319998,
    "dropphyadd": "1006 EMERALD RD",
    "dropphycty": "NEWKIRK",
    "dropphyst": "NM",
    "dropphyzpp": 884319998,
    "dropmaladd": "1006 EMERALD RD",
    "dropmalcty": "NEWKIRK",
    "dropmalst": "NM",
    "dropmalzpp": 884319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758682374,
    "dropsitcph": 5758682374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13965",
    "droptype": "D",
    "dropname": "NOGAL",
    "dropdeladd": "1108 STATE HIGHWAY 37",
    "dropdelcty": "NOGAL",
    "dropdelst": "NM",
    "dropdelzpp": 883419800,
    "dropphyadd": "1108 STATE HIGHWAY 37",
    "dropphycty": "NOGAL",
    "dropphyst": "NM",
    "dropphyzpp": 883419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NOGAL",
    "dropmalst": "NM",
    "dropmalzpp": 883419998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753542548,
    "dropsitcph": 5753542548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13972",
    "droptype": "D",
    "dropname": "OCATE",
    "dropdeladd": "1730 STATE HIGHWAY 120",
    "dropdelcty": "OCATE",
    "dropdelst": "NM",
    "dropdelzpp": 877341001,
    "dropphyadd": "1730 STATE HIGHWAY 120",
    "dropphycty": "OCATE",
    "dropphyst": "NM",
    "dropphyzpp": 877341001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCATE",
    "dropmalst": "NM",
    "dropmalzpp": 877349998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754154345,
    "dropsitcph": 5754154345,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13977",
    "droptype": "D",
    "dropname": "OJO CALIENTE",
    "dropdeladd": "35286 US HIGHWAY 285",
    "dropdelcty": "OJO CALIENTE",
    "dropdelst": "NM",
    "dropdelzpp": 875499998,
    "dropphyadd": "35286 US HIGHWAY 285",
    "dropphycty": "OJO CALIENTE",
    "dropphyst": "NM",
    "dropphyzpp": 875499998,
    "dropmaladd": "35286 US HIGHWAY 285",
    "dropmalcty": "OJO CALIENTE",
    "dropmalst": "NM",
    "dropmalzpp": 875499998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055331217,
    "dropsitcph": 5055331217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13985",
    "droptype": "D",
    "dropname": "ORGAN",
    "dropdeladd": "15770 PADRE LA RUE ST",
    "dropdelcty": "ORGAN",
    "dropdelst": "NM",
    "dropdelzpp": 880529800,
    "dropphyadd": "15770 PADRE LA RUE ST",
    "dropphycty": "ORGAN",
    "dropphyst": "NM",
    "dropphyzpp": 880529800,
    "dropmaladd": "15770 PADRE LA RUE ST",
    "dropmalcty": "ORGAN",
    "dropmalst": "NM",
    "dropmalzpp": 880529800,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753825949,
    "dropsitcph": 5753825949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13986",
    "droptype": "D",
    "dropname": "OROGRANDE",
    "dropdeladd": "1271 MAIN ST",
    "dropdelcty": "OROGRANDE",
    "dropdelst": "NM",
    "dropdelzpp": 883429800,
    "dropphyadd": "1271 MAIN ST",
    "dropphycty": "OROGRANDE",
    "dropphyst": "NM",
    "dropphyzpp": 883429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OROGRANDE",
    "dropmalst": "NM",
    "dropmalzpp": 883429998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754344777,
    "dropsitcph": 5754344777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13987",
    "droptype": "D",
    "dropname": "PAGUATE",
    "dropdeladd": "31 POSTAL RD",
    "dropdelcty": "PAGUATE",
    "dropdelst": "NM",
    "dropdelzpp": 870409998,
    "dropphyadd": "31 POSTAL RD",
    "dropphycty": "PAGUATE",
    "dropphyst": "NM",
    "dropphyzpp": 870409998,
    "dropmaladd": "31 POSTAL RD",
    "dropmalcty": "PAGUATE",
    "dropmalst": "NM",
    "dropmalzpp": 870409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055526900,
    "dropsitcph": 5055526900,
    "dropfax": 5055526900
  },
  {
    "dcode": "D",
    "dropkey": "PZ13993",
    "droptype": "D",
    "dropname": "PECOS",
    "dropdeladd": "63 S MAIN ST",
    "dropdelcty": "PECOS",
    "dropdelst": "NM",
    "dropdelzpp": 875529998,
    "dropphyadd": "63 S MAIN ST",
    "dropphycty": "PECOS",
    "dropphyst": "NM",
    "dropphyzpp": 875529998,
    "dropmaladd": "63 S MAIN ST",
    "dropmalcty": "PECOS",
    "dropmalst": "NM",
    "dropmalzpp": 875529998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057576200,
    "dropsitcph": 5057576200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13995",
    "droptype": "D",
    "dropname": "PENA BLANCA",
    "dropdeladd": "823 STATE ROAD 22",
    "dropdelcty": "PENA BLANCA",
    "dropdelst": "NM",
    "dropdelzpp": 870419998,
    "dropphyadd": "823 STATE ROAD 22",
    "dropphycty": "PENA BLANCA",
    "dropphyst": "NM",
    "dropphyzpp": 870419998,
    "dropmaladd": "823 STATE ROAD 22",
    "dropmalcty": "PENA BLANCA",
    "dropmalst": "NM",
    "dropmalzpp": 870419998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054652315,
    "dropsitcph": 5054652315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13996",
    "droptype": "D",
    "dropname": "PENASCO",
    "dropdeladd": "14196 STATE ROAD 75",
    "dropdelcty": "PENASCO",
    "dropdelst": "NM",
    "dropdelzpp": 875539998,
    "dropphyadd": "14196 STATE ROAD 75",
    "dropphycty": "PENASCO",
    "dropphyst": "NM",
    "dropphyzpp": 875539998,
    "dropmaladd": "14196 STATE ROAD 75",
    "dropmalcty": "PENASCO",
    "dropmalst": "NM",
    "dropmalzpp": 875539998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755872371,
    "dropsitcph": 5755872371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13998",
    "droptype": "D",
    "dropname": "PEP",
    "dropdeladd": "5950 NM HIGHWAY 206",
    "dropdelcty": "PEP",
    "dropdelst": "NM",
    "dropdelzpp": 881269716,
    "dropphyadd": "5950 NM HIGHWAY 206",
    "dropphycty": "PEP",
    "dropphyst": "NM",
    "dropphyzpp": 881269716,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEP",
    "dropmalst": "NM",
    "dropmalzpp": 881269998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754772476,
    "dropsitcph": 5754772476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ13999",
    "droptype": "D",
    "dropname": "PERALTA",
    "dropdeladd": "2470 BOSQUE FARMS BLVD",
    "dropdelcty": "PERALTA",
    "dropdelst": "NM",
    "dropdelzpp": 870429998,
    "dropphyadd": "2470 BOSQUE FARMS BLVD",
    "dropphycty": "PERALTA",
    "dropphyst": "NM",
    "dropphyzpp": 870429998,
    "dropmaladd": "2470 BOSQUE FARMS BLVD",
    "dropmalcty": "PERALTA",
    "dropmalst": "NM",
    "dropmalzpp": 870429998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058599180,
    "dropsitcph": 5058699180,
    "dropfax": 5053463406
  },
  {
    "dcode": "D",
    "dropkey": "PZ14004",
    "droptype": "D",
    "dropname": "PICACHO",
    "dropdeladd": "29340 US HIGHWAY 70",
    "dropdelcty": "PICACHO",
    "dropdelst": "NM",
    "dropdelzpp": 883439800,
    "dropphyadd": "29340 US HIGHWAY 70",
    "dropphycty": "PICACHO",
    "dropphyst": "NM",
    "dropphyzpp": 883439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PICACHO",
    "dropmalst": "NM",
    "dropmalzpp": 883439998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752142641,
    "dropsitcph": 5752142641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14006",
    "droptype": "D",
    "dropname": "PIE TOWN",
    "dropdeladd": "33 APRICOT AVE",
    "dropdelcty": "PIE TOWN",
    "dropdelst": "NM",
    "dropdelzpp": 878275000,
    "dropphyadd": "33 APRICOT AVE",
    "dropphycty": "PIE TOWN",
    "dropphyst": "NM",
    "dropphyzpp": 878275000,
    "dropmaladd": "33 APRICOT AVE",
    "dropmalcty": "PIE TOWN",
    "dropmalst": "NM",
    "dropmalzpp": 878275000,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832031,
    "dropsitcph": 5054832031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14013",
    "droptype": "D",
    "dropname": "PINON",
    "dropdeladd": "2332 HIGHWAY 24",
    "dropdelcty": "PINON",
    "dropdelst": "NM",
    "dropdelzpp": 883449800,
    "dropphyadd": "2332 HIGHWAY 24",
    "dropphycty": "PINON",
    "dropphyst": "NM",
    "dropphyzpp": 883449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PINON",
    "dropmalst": "NM",
    "dropmalzpp": 883449998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756873495,
    "dropsitcph": 5756873495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14020",
    "droptype": "D",
    "dropname": "PLACITAS",
    "dropdeladd": "652 STATE HIGHWAY 165",
    "dropdelcty": "PLACITAS",
    "dropdelst": "NM",
    "dropdelzpp": 870439998,
    "dropphyadd": "652 STATE HIGHWAY 165",
    "dropphycty": "PLACITAS",
    "dropphyst": "NM",
    "dropphyzpp": 870439998,
    "dropmaladd": "652 STATE HIGHWAY 165",
    "dropmalcty": "PLACITAS",
    "dropmalst": "NM",
    "dropmalzpp": 870439998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058673460,
    "dropsitcph": 5058673460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14026",
    "droptype": "D",
    "dropname": "POLVADERA",
    "dropdeladd": "15 CORREO ST",
    "dropdelcty": "POLVADERA",
    "dropdelst": "NM",
    "dropdelzpp": 878289998,
    "dropphyadd": "15 CORREO ST",
    "dropphycty": "POLVADERA",
    "dropphyst": "NM",
    "dropphyzpp": 878289998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POLVADERA",
    "dropmalst": "NM",
    "dropmalzpp": 878289997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758359707,
    "dropsitcph": 5758359707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14028",
    "droptype": "D",
    "dropname": "PORTALES",
    "dropdeladd": "116 W 1ST ST",
    "dropdelcty": "PORTALES",
    "dropdelst": "NM",
    "dropdelzpp": 881309998,
    "dropphyadd": "116 W 1ST ST",
    "dropphycty": "PORTALES",
    "dropphyst": "NM",
    "dropphyzpp": 881309998,
    "dropmaladd": "116 W 1ST ST",
    "dropmalcty": "PORTALES",
    "dropmalst": "NM",
    "dropmalzpp": 881309998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753564781,
    "dropsitcph": 5753564781,
    "dropfax": 5753562644
  },
  {
    "dcode": "D",
    "dropkey": "PZ14030",
    "droptype": "D",
    "dropname": "PREWITT",
    "dropdeladd": "1692 STATE HIGHWAY 122",
    "dropdelcty": "PREWITT",
    "dropdelst": "NM",
    "dropdelzpp": 870459998,
    "dropphyadd": "1692 STATE HIGHWAY 122",
    "dropphycty": "PREWITT",
    "dropphyst": "NM",
    "dropphyzpp": 870459998,
    "dropmaladd": "1692 STATE HIGHWAY 122",
    "dropmalcty": "PREWITT",
    "dropmalst": "NM",
    "dropmalzpp": 870459998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058762570,
    "dropsitcph": 5058762570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14040",
    "droptype": "D",
    "dropname": "QUEMADO",
    "dropdeladd": "3476 W HIGHWAY 60",
    "dropdelcty": "QUEMADO",
    "dropdelst": "NM",
    "dropdelzpp": 878299998,
    "dropphyadd": "3476 W HIGHWAY 60",
    "dropphycty": "QUEMADO",
    "dropphyst": "NM",
    "dropphyzpp": 878299998,
    "dropmaladd": "3476 W HIGHWAY 60",
    "dropmalcty": "QUEMADO",
    "dropmalst": "NM",
    "dropmalzpp": 878299998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832051,
    "dropsitcph": 5054832051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14042",
    "droptype": "D",
    "dropname": "QUESTA",
    "dropdeladd": "43 HIGHWAY 38",
    "dropdelcty": "QUESTA",
    "dropdelst": "NM",
    "dropdelzpp": 875569998,
    "dropphyadd": "43 HIGHWAY 38",
    "dropphycty": "QUESTA",
    "dropphyst": "NM",
    "dropphyzpp": 875569998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUESTA",
    "dropmalst": "NM",
    "dropmalzpp": 875569997,
    "dropsitphn": 5755860691,
    "dropsitlph": 5755861594,
    "dropsitcph": 5755861594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14045",
    "droptype": "D",
    "dropname": "RADIUM SPRINGS",
    "dropdeladd": "1145 FORT SELDEN RD",
    "dropdelcty": "RADIUM SPRINGS",
    "dropdelst": "NM",
    "dropdelzpp": 880549800,
    "dropphyadd": "1145 FORT SELDEN RD",
    "dropphycty": "RADIUM SPRINGS",
    "dropphyst": "NM",
    "dropphyzpp": 880549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RADIUM SPRINGS",
    "dropmalst": "NM",
    "dropmalzpp": 880549998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755244378,
    "dropsitcph": 5755244378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14046",
    "droptype": "D",
    "dropname": "RAINSVILLE",
    "dropdeladd": "42 COUNTY ROAD A029",
    "dropdelcty": "RAINSVILLE",
    "dropdelst": "NM",
    "dropdelzpp": 877369997,
    "dropphyadd": "42 COUNTY ROAD A029",
    "dropphycty": "RAINSVILLE",
    "dropphyst": "NM",
    "dropphyzpp": 877369997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAINSVILLE",
    "dropmalst": "NM",
    "dropmalzpp": 877369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754894561,
    "dropsitcph": 5754894561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14049",
    "droptype": "D",
    "dropname": "RAMAH",
    "dropdeladd": "3347 BOND ST",
    "dropdelcty": "RAMAH",
    "dropdelst": "NM",
    "dropdelzpp": 873219998,
    "dropphyadd": "3347 BOND ST",
    "dropphycty": "RAMAH",
    "dropphyst": "NM",
    "dropphyzpp": 873219998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAMAH",
    "dropmalst": "NM",
    "dropmalzpp": 873219997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055910021,
    "dropsitcph": 5055910021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14059",
    "droptype": "D",
    "dropname": "RANCHOS DE TAOS",
    "dropdeladd": "4 SAN FRANCISCO ST",
    "dropdelcty": "RANCHOS DE TAOS",
    "dropdelst": "NM",
    "dropdelzpp": 875579998,
    "dropphyadd": "4 SAN FRANCISCO ST",
    "dropphycty": "RANCHOS DE TAOS",
    "dropphyst": "NM",
    "dropphyzpp": 875579998,
    "dropmaladd": "4 SAN FRANCISCO ST",
    "dropmalcty": "RANCHOS DE TAOS",
    "dropmalst": "NM",
    "dropmalzpp": 875579998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757583944,
    "dropsitcph": 5757583944,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14061",
    "droptype": "D",
    "dropname": "RATON",
    "dropdeladd": "245 PARK AVE",
    "dropdelcty": "RATON",
    "dropdelst": "NM",
    "dropdelzpp": 877409998,
    "dropphyadd": "245 PARK AVE",
    "dropphycty": "RATON",
    "dropphyst": "NM",
    "dropphyzpp": 877409998,
    "dropmaladd": "245 PARK AVE",
    "dropmalcty": "RATON",
    "dropmalst": "NM",
    "dropmalzpp": 877409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754452681,
    "dropsitcph": 5754452681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14064",
    "droptype": "D",
    "dropname": "RED RIVER",
    "dropdeladd": "120 W MAIN ST",
    "dropdelcty": "RED RIVER",
    "dropdelst": "NM",
    "dropdelzpp": 875589998,
    "dropphyadd": "120 W MAIN ST",
    "dropphycty": "RED RIVER",
    "dropphyst": "NM",
    "dropphyzpp": 875589998,
    "dropmaladd": "120 W MAIN ST",
    "dropmalcty": "RED RIVER",
    "dropmalst": "NM",
    "dropmalzpp": 875589998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757542555,
    "dropsitcph": 5757542555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14067",
    "droptype": "D",
    "dropname": "REHOBOTH",
    "dropdeladd": "21 REHOBOTH DR",
    "dropdelcty": "REHOBOTH",
    "dropdelst": "NM",
    "dropdelzpp": 873229998,
    "dropphyadd": "21 REHOBOTH DR",
    "dropphycty": "REHOBOTH",
    "dropphyst": "NM",
    "dropphyzpp": 873229998,
    "dropmaladd": "21 REHOBOTH DR",
    "dropmalcty": "REHOBOTH",
    "dropmalst": "NM",
    "dropmalzpp": 873229998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058633140,
    "dropsitcph": 5058633140,
    "dropfax": 5058639038
  },
  {
    "dcode": "D",
    "dropkey": "PZ14069",
    "droptype": "D",
    "dropname": "RESERVE",
    "dropdeladd": "10 BALKE ST",
    "dropdelcty": "RESERVE",
    "dropdelst": "NM",
    "dropdelzpp": 878309997,
    "dropphyadd": "10 BALKE ST",
    "dropphycty": "RESERVE",
    "dropphyst": "NM",
    "dropphyzpp": 878309997,
    "dropmaladd": "10 BALKE ST",
    "dropmalcty": "RESERVE",
    "dropmalst": "NM",
    "dropmalzpp": 878309997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832057,
    "dropsitcph": 5054832057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14070",
    "droptype": "D",
    "dropname": "RIBERA",
    "dropdeladd": "169 STATE HIGHWAY 3",
    "dropdelcty": "RIBERA",
    "dropdelst": "NM",
    "dropdelzpp": 875609998,
    "dropphyadd": "169 STATE HIGHWAY 3",
    "dropphycty": "RIBERA",
    "dropphyst": "NM",
    "dropphyzpp": 875609998,
    "dropmaladd": "169 STATE HIGHWAY 3",
    "dropmalcty": "RIBERA",
    "dropmalst": "NM",
    "dropmalzpp": 875609998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754212627,
    "dropsitcph": 5754212627,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14071",
    "droptype": "D",
    "dropname": "RINCON",
    "dropdeladd": "2203 RINCON RD",
    "dropdelcty": "RINCON",
    "dropdelst": "NM",
    "dropdelzpp": 879409800,
    "dropphyadd": "2203 RINCON RD",
    "dropphycty": "RINCON",
    "dropphyst": "NM",
    "dropphyzpp": 879409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RINCON",
    "dropmalst": "NM",
    "dropmalzpp": 879409998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752675542,
    "dropsitcph": 5752675542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14081",
    "droptype": "D",
    "dropname": "ROCIADA",
    "dropdeladd": "302 NEW MEXICO HIGHWAY 105",
    "dropdelcty": "ROCIADA",
    "dropdelst": "NM",
    "dropdelzpp": 877421000,
    "dropphyadd": "302 NEW MEXICO HIGHWAY 105",
    "dropphycty": "ROCIADA",
    "dropphyst": "NM",
    "dropphyzpp": 877421000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCIADA",
    "dropmalst": "NM",
    "dropmalzpp": 877429998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054548596,
    "dropsitcph": 5054548596,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14084",
    "droptype": "D",
    "dropname": "RODEO",
    "dropdeladd": "16 CUSTIE AVE",
    "dropdelcty": "RODEO",
    "dropdelst": "NM",
    "dropdelzpp": 880569800,
    "dropphyadd": "16 CUSTIE AVE",
    "dropphycty": "RODEO",
    "dropphyst": "NM",
    "dropphyzpp": 880569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RODEO",
    "dropmalst": "NM",
    "dropmalzpp": 880569998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054832032,
    "dropsitcph": 5054832032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14086",
    "droptype": "D",
    "dropname": "ROGERS",
    "dropdeladd": "597 NM HIGHWAY 235",
    "dropdelcty": "ROGERS",
    "dropdelst": "NM",
    "dropdelzpp": 881329800,
    "dropphyadd": "597 NM HIGHWAY 235",
    "dropphycty": "ROGERS",
    "dropphyst": "NM",
    "dropphyzpp": 881329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROGERS",
    "dropmalst": "NM",
    "dropmalzpp": 881329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754772272,
    "dropsitcph": 5754772272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14090",
    "droptype": "D",
    "dropname": "ROSWELL",
    "dropdeladd": "415 N PENNSYLVANIA AVE",
    "dropdelcty": "ROSWELL",
    "dropdelst": "NM",
    "dropdelzpp": 882019998,
    "dropphyadd": "415 N PENNSYLVANIA AVE",
    "dropphycty": "ROSWELL",
    "dropphyst": "NM",
    "dropphyzpp": 882019998,
    "dropmaladd": "415 N PENNSYLVANIA AVE",
    "dropmalcty": "ROSWELL",
    "dropmalst": "NM",
    "dropmalzpp": 882019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756239868,
    "dropsitcph": 5756239868,
    "dropfax": 5756222807
  },
  {
    "dcode": "D",
    "dropkey": "PZ14092",
    "droptype": "D",
    "dropname": "ROWE",
    "dropdeladd": "3198 FRONTAGE RD",
    "dropdelcty": "ROWE",
    "dropdelst": "NM",
    "dropdelzpp": 875629998,
    "dropphyadd": "3198 FRONTAGE RD",
    "dropphycty": "ROWE",
    "dropphyst": "NM",
    "dropphyzpp": 875629998,
    "dropmaladd": "3198 FRONTAGE RD",
    "dropmalcty": "ROWE",
    "dropmalst": "NM",
    "dropmalzpp": 875629998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057573094,
    "dropsitcph": 5057573094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14093",
    "droptype": "D",
    "dropname": "ROY",
    "dropdeladd": "350 RICHELIEU ST",
    "dropdelcty": "ROY",
    "dropdelst": "NM",
    "dropdelzpp": 877439997,
    "dropphyadd": "350 RICHELIEU ST",
    "dropphycty": "ROY",
    "dropphyst": "NM",
    "dropphyzpp": 877439997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROY",
    "dropmalst": "NM",
    "dropmalzpp": 877439998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052260539,
    "dropsitcph": 5052260539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14094",
    "droptype": "D",
    "dropname": "RUIDOSO",
    "dropdeladd": "1090 MECHEM DR",
    "dropdelcty": "RUIDOSO",
    "dropdelst": "NM",
    "dropdelzpp": 883459998,
    "dropphyadd": "1090 MECHEM DR",
    "dropphycty": "RUIDOSO",
    "dropphyst": "NM",
    "dropphyzpp": 883459998,
    "dropmaladd": "1090 MECHEM DR",
    "dropmalcty": "RUIDOSO",
    "dropmalst": "NM",
    "dropmalzpp": 883459998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752581882,
    "dropsitcph": 5752581882,
    "dropfax": 5752583683
  },
  {
    "dcode": "D",
    "dropkey": "PZ14095",
    "droptype": "D",
    "dropname": "RUIDOSO DOWNS",
    "dropdeladd": "26336 US HIGHWAY 70",
    "dropdelcty": "RUIDOSO DOWNS",
    "dropdelst": "NM",
    "dropdelzpp": 883469153,
    "dropphyadd": "26336 US HIGHWAY 70",
    "dropphycty": "RUIDOSO DOWNS",
    "dropphyst": "NM",
    "dropphyzpp": 883469153,
    "dropmaladd": "26336 US HIGHWAY 70",
    "dropmalcty": "RUIDOSO DOWNS",
    "dropmalst": "NM",
    "dropmalzpp": 883469153,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753784595,
    "dropsitcph": 5753784595,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14099",
    "droptype": "D",
    "dropname": "SACRAMENTO",
    "dropdeladd": "16 ASSEMBLY RD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "NM",
    "dropdelzpp": 883479800,
    "dropphyadd": "16 ASSEMBLY RD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "NM",
    "dropphyzpp": 883479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "NM",
    "dropmalzpp": 883479998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756872220,
    "dropsitcph": 5756872220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14101",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "4550 HIGHWAY 187 N",
    "dropdelcty": "SALEM",
    "dropdelst": "NM",
    "dropdelzpp": 879419800,
    "dropphyadd": "4550 HIGHWAY 187 N",
    "dropphycty": "SALEM",
    "dropphyst": "NM",
    "dropphyzpp": 879419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALEM",
    "dropmalst": "NM",
    "dropmalzpp": 879419998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752674301,
    "dropsitcph": 5752674301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14102",
    "droptype": "D",
    "dropname": "SAN ACACIA",
    "dropdeladd": "161 MACEDONIO RD",
    "dropdelcty": "SAN ACACIA",
    "dropdelst": "NM",
    "dropdelzpp": 878319998,
    "dropphyadd": "161 MACEDONIO RD",
    "dropphycty": "SAN ACACIA",
    "dropphyst": "NM",
    "dropphyzpp": 878319998,
    "dropmaladd": "161 MACEDONIO RD",
    "dropmalcty": "SAN ACACIA",
    "dropmalst": "NM",
    "dropmalzpp": 878319998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758351766,
    "dropsitcph": 5758351766,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14103",
    "droptype": "D",
    "dropname": "SAN ANTONIO",
    "dropdeladd": "65A HIGHWAY 380",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "NM",
    "dropdelzpp": 878329997,
    "dropphyadd": "65A HIGHWAY 380",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "NM",
    "dropphyzpp": 878329997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "NM",
    "dropmalzpp": 878329998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758351664,
    "dropsitcph": 5758351664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14105",
    "droptype": "D",
    "dropname": "SAN CRISTOBAL",
    "dropdeladd": "38 CAMINO DEL MEDIO",
    "dropdelcty": "SAN CRISTOBAL",
    "dropdelst": "NM",
    "dropdelzpp": 875649998,
    "dropphyadd": "38 CAMINO DEL MEDIO",
    "dropphycty": "SAN CRISTOBAL",
    "dropphyst": "NM",
    "dropphyzpp": 875649998,
    "dropmaladd": "38 CAMINO DEL MEDIO",
    "dropmalcty": "SAN CRISTOBAL",
    "dropmalst": "NM",
    "dropmalzpp": 875649998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755865148,
    "dropsitcph": 5755865148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14107",
    "droptype": "D",
    "dropname": "SAN FIDEL",
    "dropdeladd": "1094 STATE HIGHWAY 124",
    "dropdelcty": "SAN FIDEL",
    "dropdelst": "NM",
    "dropdelzpp": 870491003,
    "dropphyadd": "1094 STATE HIGHWAY 124",
    "dropphycty": "SAN FIDEL",
    "dropphyst": "NM",
    "dropphyzpp": 870491003,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN FIDEL",
    "dropmalst": "NM",
    "dropmalzpp": 870499998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055529311,
    "dropsitcph": 5055529311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14111",
    "droptype": "D",
    "dropname": "SAN JON",
    "dropdeladd": "402 ROUTE 66",
    "dropdelcty": "SAN JON",
    "dropdelst": "NM",
    "dropdelzpp": 884349998,
    "dropphyadd": "402 ROUTE 66",
    "dropphycty": "SAN JON",
    "dropphyst": "NM",
    "dropphyzpp": 884349998,
    "dropmaladd": "402 ROUTE 66",
    "dropmalcty": "SAN JON",
    "dropmalst": "NM",
    "dropmalzpp": 884349998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755783817,
    "dropsitcph": 5755783817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14113",
    "droptype": "D",
    "dropname": "SAN JOSE",
    "dropdeladd": "16 CAMINO DE LOS PEIRDAS",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "NM",
    "dropdelzpp": 875659998,
    "dropphyadd": "16 CAMINO DE LOS PEIRDAS",
    "dropphycty": "SAN JOSE",
    "dropphyst": "NM",
    "dropphyzpp": 875659998,
    "dropmaladd": "16 CAMINO DE LOS PEIRDAS",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "NM",
    "dropmalzpp": 875659998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752861179,
    "dropsitcph": 5752861179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14115",
    "droptype": "D",
    "dropname": "OHKAY OWINGEH",
    "dropdeladd": "331 MAIN ST",
    "dropdelcty": "OHKAY OWINGEH",
    "dropdelst": "NM",
    "dropdelzpp": 875669998,
    "dropphyadd": "331 MAIN ST",
    "dropphycty": "OHKAY OWINGEH",
    "dropphyst": "NM",
    "dropphyzpp": 875669998,
    "dropmaladd": "331 MAIN ST",
    "dropmalcty": "OHKAY OWINGEH",
    "dropmalst": "NM",
    "dropmalzpp": 875669998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057472404,
    "dropsitcph": 5057472404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14119",
    "droptype": "D",
    "dropname": "SAN MIGUEL",
    "dropdeladd": "19003 STATE HIGHWAY 28",
    "dropdelcty": "SAN MIGUEL",
    "dropdelst": "NM",
    "dropdelzpp": 880589800,
    "dropphyadd": "19003 STATE HIGHWAY 28",
    "dropphycty": "SAN MIGUEL",
    "dropphyst": "NM",
    "dropphyzpp": 880589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN MIGUEL",
    "dropmalst": "NM",
    "dropmalzpp": 880589998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752332141,
    "dropsitcph": 5752332141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14120",
    "droptype": "D",
    "dropname": "SAN PATRICIO",
    "dropdeladd": "28100 PETER HURD LOOP",
    "dropdelcty": "SAN PATRICIO",
    "dropdelst": "NM",
    "dropdelzpp": 883489800,
    "dropphyadd": "28100 PETER HURD LOOP",
    "dropphycty": "SAN PATRICIO",
    "dropphyst": "NM",
    "dropphyzpp": 883489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN PATRICIO",
    "dropmalst": "NM",
    "dropmalzpp": 883489998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752281152,
    "dropsitcph": 5752281152,
    "dropfax": 5752281151
  },
  {
    "dcode": "D",
    "dropkey": "PZ14122",
    "droptype": "D",
    "dropname": "SAN RAFAEL",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "SAN RAFAEL",
    "dropdelst": "NM",
    "dropdelzpp": 870519998,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "SAN RAFAEL",
    "dropphyst": "NM",
    "dropphyzpp": 870519998,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "SAN RAFAEL",
    "dropmalst": "NM",
    "dropmalzpp": 870519998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052874221,
    "dropsitcph": 5052874221,
    "dropfax": 5052875549
  },
  {
    "dcode": "D",
    "dropkey": "PZ14123",
    "droptype": "D",
    "dropname": "SAN YSIDRO",
    "dropdeladd": "90 BOBBY GARCIA LN",
    "dropdelcty": "SAN YSIDRO",
    "dropdelst": "NM",
    "dropdelzpp": 870539998,
    "dropphyadd": "90 BOBBY GARCIA LN",
    "dropphycty": "SAN YSIDRO",
    "dropphyst": "NM",
    "dropphyzpp": 870539998,
    "dropmaladd": "90 BOBBY GARCIA LN",
    "dropmalcty": "SAN YSIDRO",
    "dropmalst": "NM",
    "dropmalzpp": 870539998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758347099,
    "dropsitcph": 5758347099,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14126",
    "droptype": "D",
    "dropname": "SANDIA PARK",
    "dropdeladd": "16 FROST RD",
    "dropdelcty": "SANDIA PARK",
    "dropdelst": "NM",
    "dropdelzpp": 870479998,
    "dropphyadd": "16 FROST RD",
    "dropphycty": "SANDIA PARK",
    "dropphyst": "NM",
    "dropphyzpp": 870479998,
    "dropmaladd": "16 FROST RD",
    "dropmalcty": "SANDIA PARK",
    "dropmalst": "NM",
    "dropmalzpp": 870479998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054375715,
    "dropsitcph": 5054375715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14132",
    "droptype": "D",
    "dropname": "SANTA CRUZ",
    "dropdeladd": "1701 NM 76",
    "dropdelcty": "SANTA CRUZ",
    "dropdelst": "NM",
    "dropdelzpp": 875679998,
    "dropphyadd": "1701 NM 76",
    "dropphycty": "SANTA CRUZ",
    "dropphyst": "NM",
    "dropphyzpp": 875679998,
    "dropmaladd": "1701 NM 76",
    "dropmalcty": "SANTA CRUZ",
    "dropmalst": "NM",
    "dropmalzpp": 875679998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057537643,
    "dropsitcph": 5057537643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14134",
    "droptype": "D",
    "dropname": "SANTA FE",
    "dropdeladd": "120 S FEDERAL PL STE 101",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875019902,
    "dropphyadd": "120 S FEDERAL PL STE 101",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875019902,
    "dropmaladd": "120 S FEDERAL PL STE 101",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875019902,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059882239,
    "dropsitcph": 5059882239,
    "dropfax": 5059886363
  },
  {
    "dcode": "D",
    "dropkey": "PZ14135",
    "droptype": "D",
    "dropname": "SANTA ROSA",
    "dropdeladd": "120 S 5TH ST",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "NM",
    "dropdelzpp": 884359998,
    "dropphyadd": "120 S 5TH ST",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "NM",
    "dropphyzpp": 884359998,
    "dropmaladd": "120 S 5TH ST",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "NM",
    "dropmalzpp": 884359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754723743,
    "dropsitcph": 5754723743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14137",
    "droptype": "D",
    "dropname": "SANTO DOMINGO PUEBLO",
    "dropdeladd": "175 TANO ST",
    "dropdelcty": "SANTO DOMINGO PUEBLO",
    "dropdelst": "NM",
    "dropdelzpp": 870529998,
    "dropphyadd": "175 TANO ST",
    "dropphycty": "SANTO DOMINGO PUEBLO",
    "dropphyst": "NM",
    "dropphyzpp": 870529998,
    "dropmaladd": "175 TANO ST",
    "dropmalcty": "SANTO DOMINGO PUEBLO",
    "dropmalst": "NM",
    "dropmalzpp": 870529998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054652786,
    "dropsitcph": 5054652786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14143",
    "droptype": "D",
    "dropname": "SEDAN",
    "dropdeladd": "508 CALLIS RD",
    "dropdelcty": "SEDAN",
    "dropdelst": "NM",
    "dropdelzpp": 884369998,
    "dropphyadd": "508 CALLIS RD",
    "dropphycty": "SEDAN",
    "dropphyst": "NM",
    "dropphyzpp": 884369998,
    "dropmaladd": "508 CALLIS RD",
    "dropmalcty": "SEDAN",
    "dropmalst": "NM",
    "dropmalzpp": 884369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753749082,
    "dropsitcph": 5753749082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14149",
    "droptype": "D",
    "dropname": "SERAFINA",
    "dropdeladd": "294 COUNTY ROAD B26A",
    "dropdelcty": "SERAFINA",
    "dropdelst": "NM",
    "dropdelzpp": 875699998,
    "dropphyadd": "294 COUNTY ROAD B26A",
    "dropphycty": "SERAFINA",
    "dropphyst": "NM",
    "dropphyzpp": 875699998,
    "dropmaladd": "294 COUNTY ROAD B26A",
    "dropmalcty": "SERAFINA",
    "dropmalst": "NM",
    "dropmalzpp": 875699998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754213780,
    "dropsitcph": 5754213780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14157",
    "droptype": "D",
    "dropname": "SHIPROCK",
    "dropdeladd": "91 HIGHWAY 491 S",
    "dropdelcty": "SHIPROCK",
    "dropdelst": "NM",
    "dropdelzpp": 874209998,
    "dropphyadd": "91 HIGHWAY 491 S",
    "dropphycty": "SHIPROCK",
    "dropphyst": "NM",
    "dropphyzpp": 874209998,
    "dropmaladd": "91 HIGHWAY 491 S",
    "dropmalcty": "SHIPROCK",
    "dropmalst": "NM",
    "dropmalzpp": 874209998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053684497,
    "dropsitcph": 5053684497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14161",
    "droptype": "D",
    "dropname": "SILVER CITY",
    "dropdeladd": "500 N HUDSON ST",
    "dropdelcty": "SILVER CITY",
    "dropdelst": "NM",
    "dropdelzpp": 880619998,
    "dropphyadd": "500 N HUDSON ST",
    "dropphycty": "SILVER CITY",
    "dropphyst": "NM",
    "dropphyzpp": 880619998,
    "dropmaladd": "500 N HUDSON ST",
    "dropmalcty": "SILVER CITY",
    "dropmalst": "NM",
    "dropmalzpp": 880619998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755382831,
    "dropsitcph": 5755382831,
    "dropfax": 5753881852
  },
  {
    "dcode": "D",
    "dropkey": "PZ14172",
    "droptype": "D",
    "dropname": "SOCORRO",
    "dropdeladd": "124 PLAZA ST",
    "dropdelcty": "SOCORRO",
    "dropdelst": "NM",
    "dropdelzpp": 878019998,
    "dropphyadd": "124 PLAZA ST",
    "dropphycty": "SOCORRO",
    "dropphyst": "NM",
    "dropphyzpp": 878019998,
    "dropmaladd": "124 PLAZA ST",
    "dropmalcty": "SOCORRO",
    "dropmalst": "NM",
    "dropmalzpp": 878019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758350542,
    "dropsitcph": 5758350542,
    "dropfax": 5758358921
  },
  {
    "dcode": "D",
    "dropkey": "PZ14175",
    "droptype": "D",
    "dropname": "SOLANO",
    "dropdeladd": "2979 NM HIGHWAY 39",
    "dropdelcty": "SOLANO",
    "dropdelst": "NM",
    "dropdelzpp": 877469998,
    "dropphyadd": "2979 NM HIGHWAY 39",
    "dropphycty": "SOLANO",
    "dropphyst": "NM",
    "dropphyzpp": 877469998,
    "dropmaladd": "2979 NM HIGHWAY 39",
    "dropmalcty": "SOLANO",
    "dropmalst": "NM",
    "dropmalzpp": 877469998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756732430,
    "dropsitcph": 5756732430,
    "dropfax": 5756732430
  },
  {
    "dcode": "D",
    "dropkey": "PZ14179",
    "droptype": "D",
    "dropname": "SPRINGER",
    "dropdeladd": "610 5TH ST",
    "dropdelcty": "SPRINGER",
    "dropdelst": "NM",
    "dropdelzpp": 877479998,
    "dropphyadd": "610 5TH ST",
    "dropphycty": "SPRINGER",
    "dropphyst": "NM",
    "dropphyzpp": 877479998,
    "dropmaladd": "610 5TH ST",
    "dropmalcty": "SPRINGER",
    "dropmalst": "NM",
    "dropmalzpp": 877479998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754835050,
    "dropsitcph": 5754835050,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14204",
    "droptype": "D",
    "dropname": "SUNLAND PARK",
    "dropdeladd": "3500 MCNUTT RD",
    "dropdelcty": "SUNLAND PARK",
    "dropdelst": "NM",
    "dropdelzpp": 880639800,
    "dropphyadd": "3500 MCNUTT RD",
    "dropphycty": "SUNLAND PARK",
    "dropphyst": "NM",
    "dropphyzpp": 880639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNLAND PARK",
    "dropmalst": "NM",
    "dropmalzpp": 880639998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755897548,
    "dropsitcph": 5755897548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14206",
    "droptype": "D",
    "dropname": "SUNSPOT",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SUNSPOT",
    "dropdelst": "NM",
    "dropdelzpp": 883499800,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SUNSPOT",
    "dropphyst": "NM",
    "dropphyzpp": 883499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNSPOT",
    "dropmalst": "NM",
    "dropmalzpp": 883499998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754342399,
    "dropsitcph": 5754342399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14208",
    "droptype": "D",
    "dropname": "TAIBAN",
    "dropdeladd": "32610 US HIGHWAY 60",
    "dropdelcty": "TAIBAN",
    "dropdelst": "NM",
    "dropdelzpp": 881349800,
    "dropphyadd": "32610 US HIGHWAY 60",
    "dropphycty": "TAIBAN",
    "dropphyst": "NM",
    "dropphyzpp": 881349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAIBAN",
    "dropmalst": "NM",
    "dropmalzpp": 881349998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053170617,
    "dropsitcph": 5053170617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14211",
    "droptype": "D",
    "dropname": "TAOS",
    "dropdeladd": "318 PASEO DEL PUEBLO NORTE",
    "dropdelcty": "TAOS",
    "dropdelst": "NM",
    "dropdelzpp": 875719998,
    "dropphyadd": "318 PASEO DEL PUEBLO NORTE",
    "dropphycty": "TAOS",
    "dropphyst": "NM",
    "dropphyzpp": 875719998,
    "dropmaladd": "318 PASEO DEL PUEBLO NORTE",
    "dropmalcty": "TAOS",
    "dropmalst": "NM",
    "dropmalzpp": 875719998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757582081,
    "dropsitcph": 5757582081,
    "dropfax": 5757587429
  },
  {
    "dcode": "D",
    "dropkey": "PZ14214",
    "droptype": "D",
    "dropname": "TATUM",
    "dropdeladd": "114 S AVENUE A",
    "dropdelcty": "TATUM",
    "dropdelst": "NM",
    "dropdelzpp": 882679802,
    "dropphyadd": "114 S AVENUE A",
    "dropphycty": "TATUM",
    "dropphyst": "NM",
    "dropphyzpp": 882679802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TATUM",
    "dropmalst": "NM",
    "dropmalzpp": 882679998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753331028,
    "dropsitcph": 5753331028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14216",
    "droptype": "D",
    "dropname": "TESUQUE",
    "dropdeladd": "174 TESUQUE VILLAGE RD",
    "dropdelcty": "TESUQUE",
    "dropdelst": "NM",
    "dropdelzpp": 875749998,
    "dropphyadd": "174 TESUQUE VILLAGE RD",
    "dropphycty": "TESUQUE",
    "dropphyst": "NM",
    "dropphyzpp": 875749998,
    "dropmaladd": "174 TESUQUE VILLAGE RD",
    "dropmalcty": "TESUQUE",
    "dropmalst": "NM",
    "dropmalzpp": 875749998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059928561,
    "dropsitcph": 5059928651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14218",
    "droptype": "D",
    "dropname": "TEXICO",
    "dropdeladd": "212 N STATE ST",
    "dropdelcty": "TEXICO",
    "dropdelst": "NM",
    "dropdelzpp": 881359800,
    "dropphyadd": "212 N STATE ST",
    "dropphycty": "TEXICO",
    "dropphyst": "NM",
    "dropphyzpp": 881359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEXICO",
    "dropmalst": "NM",
    "dropmalzpp": 881359998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752187116,
    "dropsitcph": 5752187116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14220",
    "droptype": "D",
    "dropname": "THOREAU",
    "dropdeladd": "3 PREWITT ST",
    "dropdelcty": "THOREAU",
    "dropdelst": "NM",
    "dropdelzpp": 873239998,
    "dropphyadd": "3 PREWITT ST",
    "dropphycty": "THOREAU",
    "dropphyst": "NM",
    "dropphyzpp": 873239998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THOREAU",
    "dropmalst": "NM",
    "dropmalzpp": 873239997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058627946,
    "dropsitcph": 5058627946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14222",
    "droptype": "D",
    "dropname": "TIERRA AMARILLA",
    "dropdeladd": "17306 STATE HIGHWAY 84/64",
    "dropdelcty": "TIERRA AMARILLA",
    "dropdelst": "NM",
    "dropdelzpp": 875759998,
    "dropphyadd": "17306 STATE HIGHWAY 84/64",
    "dropphycty": "TIERRA AMARILLA",
    "dropphyst": "NM",
    "dropphyzpp": 875759998,
    "dropmaladd": "17306 STATE HIGHWAY 84/64",
    "dropmalcty": "TIERRA AMARILLA",
    "dropmalst": "NM",
    "dropmalzpp": 875759998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755887219,
    "dropsitcph": 5755887219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14223",
    "droptype": "D",
    "dropname": "TIJERAS",
    "dropdeladd": "499 NM 333",
    "dropdelcty": "TIJERAS",
    "dropdelst": "NM",
    "dropdelzpp": 870599998,
    "dropphyadd": "499 NM 333",
    "dropphycty": "TIJERAS",
    "dropphyst": "NM",
    "dropphyzpp": 870599998,
    "dropmaladd": "499 NM 333",
    "dropmalcty": "TIJERAS",
    "dropmalst": "NM",
    "dropmalzpp": 870599998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052815656,
    "dropsitcph": 5052815656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14226",
    "droptype": "D",
    "dropname": "TINNIE",
    "dropdeladd": "28801 US HIGHWAY 70",
    "dropdelcty": "TINNIE",
    "dropdelst": "NM",
    "dropdelzpp": 883519800,
    "dropphyadd": "28801 US HIGHWAY 70",
    "dropphycty": "TINNIE",
    "dropphyst": "NM",
    "dropphyzpp": 883519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TINNIE",
    "dropmalst": "NM",
    "dropmalzpp": 883519998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756534343,
    "dropsitcph": 5756534343,
    "dropfax": 5752143620
  },
  {
    "dcode": "D",
    "dropkey": "PZ14229",
    "droptype": "D",
    "dropname": "TOHATCHI",
    "dropdeladd": "1 TOHATCHI DR",
    "dropdelcty": "TOHATCHI",
    "dropdelst": "NM",
    "dropdelzpp": 873259998,
    "dropphyadd": "1 TOHATCHI DR",
    "dropphycty": "TOHATCHI",
    "dropphyst": "NM",
    "dropphyzpp": 873259998,
    "dropmaladd": "1 TOHATCHI DR",
    "dropmalcty": "TOHATCHI",
    "dropmalst": "NM",
    "dropmalzpp": 873259998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057332276,
    "dropsitcph": 5057332276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14232",
    "droptype": "D",
    "dropname": "TOME",
    "dropdeladd": "2971 STATE HIGHWAY 47",
    "dropdelcty": "TOME",
    "dropdelst": "NM",
    "dropdelzpp": 870609998,
    "dropphyadd": "2971 STATE HIGHWAY 47",
    "dropphycty": "TOME",
    "dropphyst": "NM",
    "dropphyzpp": 870609998,
    "dropmaladd": "2971 STATE HIGHWAY 47",
    "dropmalcty": "TOME",
    "dropmalst": "NM",
    "dropmalzpp": 870609998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058656166,
    "dropsitcph": 5058656166,
    "dropfax": 5058664567
  },
  {
    "dcode": "D",
    "dropkey": "PZ14234",
    "droptype": "D",
    "dropname": "TORREON",
    "dropdeladd": "8563 HIGHWAY 55",
    "dropdelcty": "TORREON",
    "dropdelst": "NM",
    "dropdelzpp": 870619998,
    "dropphyadd": "8563 HIGHWAY 55",
    "dropphycty": "TORREON",
    "dropphyst": "NM",
    "dropphyzpp": 870619998,
    "dropmaladd": "8563 HIGHWAY 55",
    "dropmalcty": "TORREON",
    "dropmalst": "NM",
    "dropmalzpp": 870619998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053843122,
    "dropsitcph": 5053843122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14238",
    "droptype": "D",
    "dropname": "TREMENTINA",
    "dropdeladd": "26 POST OFFICE LN",
    "dropdelcty": "TREMENTINA",
    "dropdelst": "NM",
    "dropdelzpp": 884399998,
    "dropphyadd": "26 POST OFFICE LN",
    "dropphycty": "TREMENTINA",
    "dropphyst": "NM",
    "dropphyzpp": 884399998,
    "dropmaladd": "26 POST OFFICE LN",
    "dropmalcty": "TREMENTINA",
    "dropmalst": "NM",
    "dropmalzpp": 884399998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756415281,
    "dropsitcph": 5756415281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14239",
    "droptype": "D",
    "dropname": "TRES PIEDRAS",
    "dropdeladd": "38440 HIGHWAY 285",
    "dropdelcty": "TRES PIEDRAS",
    "dropdelst": "NM",
    "dropdelzpp": 875779998,
    "dropphyadd": "38440 HIGHWAY 285",
    "dropphycty": "TRES PIEDRAS",
    "dropphyst": "NM",
    "dropphyzpp": 875779998,
    "dropmaladd": "38440 HIGHWAY 285",
    "dropmalcty": "TRES PIEDRAS",
    "dropmalst": "NM",
    "dropmalzpp": 875779998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757510981,
    "dropsitcph": 5757510981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14245",
    "droptype": "D",
    "dropname": "TRUTH OR CONSEQUENCES",
    "dropdeladd": "1507 N DATE ST",
    "dropdelcty": "TRUTH OR CONSEQUENCES",
    "dropdelst": "NM",
    "dropdelzpp": 879019998,
    "dropphyadd": "1507 N DATE ST",
    "dropphycty": "TRUTH OR CONSEQUENCES",
    "dropphyst": "NM",
    "dropphyzpp": 879019998,
    "dropmaladd": "1507 N DATE ST",
    "dropmalcty": "TRUTH OR CONSEQUENCES",
    "dropmalst": "NM",
    "dropmalzpp": 879019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758943137,
    "dropsitcph": 5758943137,
    "dropfax": 5758949402
  },
  {
    "dcode": "D",
    "dropkey": "PZ14247",
    "droptype": "D",
    "dropname": "TUCUMCARI",
    "dropdeladd": "220 S 1ST ST",
    "dropdelcty": "TUCUMCARI",
    "dropdelst": "NM",
    "dropdelzpp": 884019998,
    "dropphyadd": "220 S 1ST ST",
    "dropphycty": "TUCUMCARI",
    "dropphyst": "NM",
    "dropphyzpp": 884019998,
    "dropmaladd": "220 S 1ST ST",
    "dropmalcty": "TUCUMCARI",
    "dropmalst": "NM",
    "dropmalzpp": 884019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754610370,
    "dropsitcph": 5754610370,
    "dropfax": 5754613942
  },
  {
    "dcode": "D",
    "dropkey": "PZ14248",
    "droptype": "D",
    "dropname": "TULAROSA",
    "dropdeladd": "360 CENTRAL AVE",
    "dropdelcty": "TULAROSA",
    "dropdelst": "NM",
    "dropdelzpp": 883529998,
    "dropphyadd": "360 CENTRAL AVE",
    "dropphycty": "TULAROSA",
    "dropphyst": "NM",
    "dropphyzpp": 883529998,
    "dropmaladd": "360 CENTRAL AVE",
    "dropmalcty": "TULAROSA",
    "dropmalst": "NM",
    "dropmalzpp": 883529998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755854431,
    "dropsitcph": 5755854431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14252",
    "droptype": "D",
    "dropname": "TYRONE",
    "dropdeladd": "210 TURQUOISE ST",
    "dropdelcty": "TYRONE",
    "dropdelst": "NM",
    "dropdelzpp": 880659800,
    "dropphyadd": "210 TURQUOISE ST",
    "dropphycty": "TYRONE",
    "dropphyst": "NM",
    "dropphyzpp": 880659800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TYRONE",
    "dropmalst": "NM",
    "dropmalzpp": 880659998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755382523,
    "dropsitcph": 5755382523,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14263",
    "droptype": "D",
    "dropname": "UTE PARK",
    "dropdeladd": "9 HUMMINGBIRD LN",
    "dropdelcty": "UTE PARK",
    "dropdelst": "NM",
    "dropdelzpp": 877499998,
    "dropphyadd": "9 HUMMINGBIRD LN",
    "dropphycty": "UTE PARK",
    "dropphyst": "NM",
    "dropphyzpp": 877499998,
    "dropmaladd": "9 HUMMINGBIRD LN",
    "dropmalcty": "UTE PARK",
    "dropmalst": "NM",
    "dropmalzpp": 877499998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753762396,
    "dropsitcph": 5753762396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14265",
    "droptype": "D",
    "dropname": "VADITO",
    "dropdeladd": "1709 STATE HIGHWAY 75",
    "dropdelcty": "VADITO",
    "dropdelst": "NM",
    "dropdelzpp": 875799998,
    "dropphyadd": "1709 STATE HIGHWAY 75",
    "dropphycty": "VADITO",
    "dropphyst": "NM",
    "dropphyzpp": 875799998,
    "dropmaladd": "1709 STATE HIGHWAY 75",
    "dropmalcty": "VADITO",
    "dropmalst": "NM",
    "dropmalzpp": 875799998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755870422,
    "dropsitcph": 5755870422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14269",
    "droptype": "D",
    "dropname": "VALLECITOS",
    "dropdeladd": "1484 STATE ROAD 111",
    "dropdelcty": "VALLECITOS",
    "dropdelst": "NM",
    "dropdelzpp": 875819998,
    "dropphyadd": "1484 STATE ROAD 111",
    "dropphycty": "VALLECITOS",
    "dropphyst": "NM",
    "dropphyzpp": 875819998,
    "dropmaladd": "1484 STATE ROAD 111",
    "dropmalcty": "VALLECITOS",
    "dropmalst": "NM",
    "dropmalzpp": 875819998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755824296,
    "dropsitcph": 5755824296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14273",
    "droptype": "D",
    "dropname": "VAUGHN",
    "dropdeladd": "800 W 8TH ST",
    "dropdelcty": "VAUGHN",
    "dropdelst": "NM",
    "dropdelzpp": 883539800,
    "dropphyadd": "800 W 8TH ST",
    "dropphycty": "VAUGHN",
    "dropphyst": "NM",
    "dropphyzpp": 883539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAUGHN",
    "dropmalst": "NM",
    "dropmalzpp": 883539998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755842640,
    "dropsitcph": 5755842640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14274",
    "droptype": "D",
    "dropname": "VEGUITA",
    "dropdeladd": "1351 HIGHWAY 304",
    "dropdelcty": "VEGUITA",
    "dropdelst": "NM",
    "dropdelzpp": 870629998,
    "dropphyadd": "1351 HIGHWAY 304",
    "dropphycty": "VEGUITA",
    "dropphyst": "NM",
    "dropphyzpp": 870629998,
    "dropmaladd": "1351 HIGHWAY 304",
    "dropmalcty": "VEGUITA",
    "dropmalst": "NM",
    "dropmalzpp": 870629998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754894166,
    "dropsitcph": 5754894166,
    "dropfax": 5058641162
  },
  {
    "dcode": "D",
    "dropkey": "PZ14275",
    "droptype": "D",
    "dropname": "VELARDE",
    "dropdeladd": "1446 US ROUTE 68",
    "dropdelcty": "VELARDE",
    "dropdelst": "NM",
    "dropdelzpp": 875829998,
    "dropphyadd": "1446 US ROUTE 68",
    "dropphycty": "VELARDE",
    "dropphyst": "NM",
    "dropphyzpp": 875829998,
    "dropmaladd": "1446 US ROUTE 68",
    "dropmalcty": "VELARDE",
    "dropmalst": "NM",
    "dropmalzpp": 875829998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058524581,
    "dropsitcph": 5058524581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14277",
    "droptype": "D",
    "dropname": "VILLANUEVA",
    "dropdeladd": "1221 NM HIGHWAY 3",
    "dropdelcty": "VILLANUEVA",
    "dropdelst": "NM",
    "dropdelzpp": 875839998,
    "dropphyadd": "1221 NM HIGHWAY 3",
    "dropphycty": "VILLANUEVA",
    "dropphyst": "NM",
    "dropphyzpp": 875839998,
    "dropmaladd": "1221 NM HIGHWAY 3",
    "dropmalcty": "VILLANUEVA",
    "dropmalst": "NM",
    "dropmalzpp": 875839998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5754212395,
    "dropsitcph": 5754212395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14279",
    "droptype": "D",
    "dropname": "WAGON MOUND",
    "dropdeladd": "504 RAILROAD AVE",
    "dropdelcty": "WAGON MOUND",
    "dropdelst": "NM",
    "dropdelzpp": 877529998,
    "dropphyadd": "504 RAILROAD AVE",
    "dropphycty": "WAGON MOUND",
    "dropphyst": "NM",
    "dropphyzpp": 877529998,
    "dropmaladd": "504 RAILROAD AVE",
    "dropmalcty": "WAGON MOUND",
    "dropmalst": "NM",
    "dropmalzpp": 877529998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756662245,
    "dropsitcph": 5756662245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14281",
    "droptype": "D",
    "dropname": "WATERFLOW",
    "dropdeladd": "3428 US 64",
    "dropdelcty": "WATERFLOW",
    "dropdelst": "NM",
    "dropdelzpp": 874219997,
    "dropphyadd": "3428 US 64",
    "dropphycty": "WATERFLOW",
    "dropphyst": "NM",
    "dropphyzpp": 874219997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERFLOW",
    "dropmalst": "NM",
    "dropmalzpp": 874219998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5055986338,
    "dropsitcph": 5055986338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14282",
    "droptype": "D",
    "dropname": "WATROUS",
    "dropdeladd": "233 BRIDGE ST",
    "dropdelcty": "WATROUS",
    "dropdelst": "NM",
    "dropdelzpp": 877531001,
    "dropphyadd": "233 BRIDGE ST",
    "dropphycty": "WATROUS",
    "dropphyst": "NM",
    "dropphyzpp": 877531001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATROUS",
    "dropmalst": "NM",
    "dropmalzpp": 877539998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054252785,
    "dropsitcph": 5054252785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14283",
    "droptype": "D",
    "dropname": "WEED",
    "dropdeladd": "21 WEED RD",
    "dropdelcty": "WEED",
    "dropdelst": "NM",
    "dropdelzpp": 883549800,
    "dropphyadd": "21 WEED RD",
    "dropphycty": "WEED",
    "dropphyst": "NM",
    "dropphyzpp": 883549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEED",
    "dropmalst": "NM",
    "dropmalzpp": 883549998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756872348,
    "dropsitcph": 5756872348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14292",
    "droptype": "D",
    "dropname": "WHITES CITY",
    "dropdeladd": "23 CARLSBAD CAVERNS HWY",
    "dropdelcty": "WHITES CITY",
    "dropdelst": "NM",
    "dropdelzpp": 882689800,
    "dropphyadd": "23 CARLSBAD CAVERNS HWY",
    "dropphycty": "WHITES CITY",
    "dropphyst": "NM",
    "dropphyzpp": 882689800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITES CITY",
    "dropmalst": "NM",
    "dropmalzpp": 882689998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757852220,
    "dropsitcph": 5757852220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14296",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "105 CENTRAL ST",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "NM",
    "dropdelzpp": 879429800,
    "dropphyadd": "105 CENTRAL ST",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "NM",
    "dropphyzpp": 879429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "NM",
    "dropmalzpp": 879429998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758946265,
    "dropsitcph": 5758946265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14297",
    "droptype": "D",
    "dropname": "WINSTON",
    "dropdeladd": "451 GRAFTON RD",
    "dropdelcty": "WINSTON",
    "dropdelst": "NM",
    "dropdelzpp": 879439803,
    "dropphyadd": "451 GRAFTON RD",
    "dropphycty": "WINSTON",
    "dropphyst": "NM",
    "dropphyzpp": 879439803,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINSTON",
    "dropmalst": "NM",
    "dropmalzpp": 879439998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757430157,
    "dropsitcph": 5757430157,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14300",
    "droptype": "D",
    "dropname": "YESO",
    "dropdeladd": "13520 US 60",
    "dropdelcty": "YESO",
    "dropdelst": "NM",
    "dropdelzpp": 881369800,
    "dropphyadd": "13520 US 60",
    "dropphycty": "YESO",
    "dropphyst": "NM",
    "dropphyzpp": 881369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YESO",
    "dropmalst": "NM",
    "dropmalzpp": 881369998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052892618,
    "dropsitcph": 5052892618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14301",
    "droptype": "D",
    "dropname": "YOUNGSVILLE",
    "dropdeladd": "3774 STATE HIGHWAY 96",
    "dropdelcty": "YOUNGSVILLE",
    "dropdelst": "NM",
    "dropdelzpp": 870649998,
    "dropphyadd": "3774 STATE HIGHWAY 96",
    "dropphycty": "YOUNGSVILLE",
    "dropphyst": "NM",
    "dropphyzpp": 870649998,
    "dropmaladd": "3774 STATE HIGHWAY 96",
    "dropmalcty": "YOUNGSVILLE",
    "dropmalst": "NM",
    "dropmalzpp": 870649998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756389141,
    "dropsitcph": 5756389141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14303",
    "droptype": "D",
    "dropname": "ZUNI",
    "dropdeladd": "1207 HIGHWAY 53",
    "dropdelcty": "ZUNI",
    "dropdelst": "NM",
    "dropdelzpp": 873279998,
    "dropphyadd": "1207 HIGHWAY 53",
    "dropphycty": "ZUNI",
    "dropphyst": "NM",
    "dropphyzpp": 873279998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZUNI",
    "dropmalst": "NM",
    "dropmalzpp": 873279997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057824525,
    "dropsitcph": 5057824525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14306",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "40 N PURPLE SAGE AVE",
    "dropdelcty": "ALAMO",
    "dropdelst": "NV",
    "dropdelzpp": 890019801,
    "dropphyadd": "40 N PURPLE SAGE AVE",
    "dropphycty": "ALAMO",
    "dropphyst": "NV",
    "dropphyzpp": 890019801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALAMO",
    "dropmalst": "NV",
    "dropmalzpp": 890019998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757253506,
    "dropsitcph": 7757253506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14307",
    "droptype": "D",
    "dropname": "AMARGOSA VALLEY",
    "dropdeladd": "3830 E SAGE ST",
    "dropdelcty": "AMARGOSA VALLEY",
    "dropdelst": "NV",
    "dropdelzpp": 890200482,
    "dropphyadd": "3830 E SAGE ST",
    "dropphycty": "AMARGOSA VALLEY",
    "dropphyst": "NV",
    "dropphyzpp": 890200482,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMARGOSA VALLEY",
    "dropmalst": "NV",
    "dropmalzpp": 890209998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7753725379,
    "dropsitcph": 7753725379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14314",
    "droptype": "D",
    "dropname": "AUSTIN",
    "dropdeladd": "166 MAIN ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "NV",
    "dropdelzpp": 893109995,
    "dropphyadd": "166 MAIN ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "NV",
    "dropphyzpp": 893109995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTIN",
    "dropmalst": "NV",
    "dropmalzpp": 893109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7759642685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14316",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "101 CARSON ST",
    "dropdelcty": "BAKER",
    "dropdelst": "NV",
    "dropdelzpp": 893119995,
    "dropphyadd": "101 CARSON ST",
    "dropphycty": "BAKER",
    "dropphyst": "NV",
    "dropphyzpp": 893119995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAKER",
    "dropmalst": "NV",
    "dropmalzpp": 893119998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752347231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14320",
    "droptype": "D",
    "dropname": "BATTLE MOUNTAIN",
    "dropdeladd": "810 SUNSET DR",
    "dropdelcty": "BATTLE MOUNTAIN",
    "dropdelst": "NV",
    "dropdelzpp": 898202617,
    "dropphyadd": "810 SUNSET DR",
    "dropphycty": "BATTLE MOUNTAIN",
    "dropphyst": "NV",
    "dropphyzpp": 898202617,
    "dropmaladd": "810 SUNSET DR",
    "dropmalcty": "BATTLE MOUNTAIN",
    "dropmalst": "NV",
    "dropmalzpp": 898209998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7756352705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14321",
    "droptype": "D",
    "dropname": "BEATTY",
    "dropdeladd": "600 E HWY 95 N",
    "dropdelcty": "BEATTY",
    "dropdelst": "NV",
    "dropdelzpp": 890030107,
    "dropphyadd": "600 E HWY 95 N",
    "dropphycty": "BEATTY",
    "dropphyst": "NV",
    "dropphyzpp": 890030107,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEATTY",
    "dropmalst": "NV",
    "dropmalzpp": 890039998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755532343,
    "dropsitcph": 7755532343,
    "dropfax": 7755532495
  },
  {
    "dcode": "D",
    "dropkey": "PZ14324",
    "droptype": "D",
    "dropname": "BLUE DIAMOND",
    "dropdeladd": "2 DIAMOND ST",
    "dropdelcty": "BLUE DIAMOND",
    "dropdelst": "NV",
    "dropdelzpp": 890049800,
    "dropphyadd": "2 DIAMOND ST",
    "dropphycty": "BLUE DIAMOND",
    "dropphyst": "NV",
    "dropphyzpp": 890049800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE DIAMOND",
    "dropmalst": "NV",
    "dropmalzpp": 890049998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028752676,
    "dropsitcph": 7028752676,
    "dropfax": 7028752676
  },
  {
    "dcode": "D",
    "dropkey": "PZ14329",
    "droptype": "D",
    "dropname": "BOULDER CITY",
    "dropdeladd": "1101 COLORADO ST",
    "dropdelcty": "BOULDER CITY",
    "dropdelst": "NV",
    "dropdelzpp": 890059998,
    "dropphyadd": "1101 COLORADO ST",
    "dropphycty": "BOULDER CITY",
    "dropphyst": "NV",
    "dropphyzpp": 890059998,
    "dropmaladd": "1101 COLORADO ST",
    "dropmalcty": "BOULDER CITY",
    "dropmalst": "NV",
    "dropmalzpp": 890059998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022931219,
    "dropsitcph": 7022932740,
    "dropfax": 7022933419
  },
  {
    "dcode": "D",
    "dropkey": "PZ14331",
    "droptype": "D",
    "dropname": "BUNKERVILLE",
    "dropdeladd": "170 MAIN ST",
    "dropdelcty": "BUNKERVILLE",
    "dropdelst": "NV",
    "dropdelzpp": 890079900,
    "dropphyadd": "170 MAIN ST",
    "dropphycty": "BUNKERVILLE",
    "dropphyst": "NV",
    "dropphyzpp": 890079900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUNKERVILLE",
    "dropmalst": "NV",
    "dropmalzpp": 890079998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023465527,
    "dropsitcph": 7023465527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14336",
    "droptype": "D",
    "dropname": "CALIENTE",
    "dropdeladd": "700 FRONT ST",
    "dropdelcty": "CALIENTE",
    "dropdelst": "NV",
    "dropdelzpp": 890080100,
    "dropphyadd": "700 FRONT ST",
    "dropphycty": "CALIENTE",
    "dropphyst": "NV",
    "dropphyzpp": 890080100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALIENTE",
    "dropmalst": "NV",
    "dropmalzpp": 890089998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757263198,
    "dropsitcph": 7754419383,
    "dropfax": 7757263571
  },
  {
    "dcode": "D",
    "dropkey": "PZ14339",
    "droptype": "D",
    "dropname": "CARLIN",
    "dropdeladd": "1106 CHESTNUT ST",
    "dropdelcty": "CARLIN",
    "dropdelst": "NV",
    "dropdelzpp": 898229995,
    "dropphyadd": "1106 CHESTNUT ST",
    "dropphycty": "CARLIN",
    "dropphyst": "NV",
    "dropphyzpp": 898229995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLIN",
    "dropmalst": "NV",
    "dropmalzpp": 898229998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757546221,
    "dropfax": 7757542510
  },
  {
    "dcode": "D",
    "dropkey": "PZ14342",
    "droptype": "D",
    "dropname": "CARSON CITY",
    "dropdeladd": "1111 S ROOP ST",
    "dropdelcty": "CARSON CITY",
    "dropdelst": "NV",
    "dropdelzpp": 897019998,
    "dropphyadd": "1111 S ROOP ST",
    "dropphycty": "CARSON CITY",
    "dropphyst": "NV",
    "dropphyzpp": 897019998,
    "dropmaladd": "1111 S ROOP ST",
    "dropmalcty": "CARSON CITY",
    "dropmalst": "NV",
    "dropmalzpp": 897019998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758842327,
    "dropsitcph": 7758842300,
    "dropfax": 7758842471
  },
  {
    "dcode": "D",
    "dropkey": "PZ14373",
    "droptype": "D",
    "dropname": "CRYSTAL BAY",
    "dropdeladd": "26 STATE ROUTE 28",
    "dropdelcty": "CRYSTAL BAY",
    "dropdelst": "NV",
    "dropdelzpp": 894029801,
    "dropphyadd": "26 STATE ROUTE 28",
    "dropphycty": "CRYSTAL BAY",
    "dropphyst": "NV",
    "dropphyzpp": 894029801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRYSTAL BAY",
    "dropmalst": "NV",
    "dropmalzpp": 894029998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758319017,
    "dropsitcph": 7758319017,
    "dropfax": 7758318079
  },
  {
    "dcode": "D",
    "dropkey": "PZ14376",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "50 FOURTH AVE",
    "dropdelcty": "DAYTON",
    "dropdelst": "NV",
    "dropdelzpp": 894039998,
    "dropphyadd": "50 FOURTH AVE",
    "dropphycty": "DAYTON",
    "dropphyst": "NV",
    "dropphyzpp": 894039998,
    "dropmaladd": "50 FOURTH AVE",
    "dropmalcty": "DAYTON",
    "dropmalst": "NV",
    "dropmalzpp": 894039998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7752467689,
    "dropsitcph": 7752467689,
    "dropfax": 7752413067
  },
  {
    "dcode": "D",
    "dropkey": "PZ14377",
    "droptype": "D",
    "dropname": "DEETH",
    "dropdeladd": "100 MAIN ST",
    "dropdelcty": "DEETH",
    "dropdelst": "NV",
    "dropdelzpp": 898239800,
    "dropphyadd": "100 MAIN ST",
    "dropphycty": "DEETH",
    "dropphyst": "NV",
    "dropphyzpp": 898239800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEETH",
    "dropmalst": "NV",
    "dropmalzpp": 898239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7754550961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14378",
    "droptype": "D",
    "dropname": "DENIO",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "DENIO",
    "dropdelst": "NV",
    "dropdelzpp": 894049995,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "DENIO",
    "dropphyst": "NV",
    "dropphyzpp": 894049995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DENIO",
    "dropmalst": "NV",
    "dropmalzpp": 894049998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7759410240,
    "dropsitcph": 7759410240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14389",
    "droptype": "D",
    "dropname": "DYER",
    "dropdeladd": "1 VALLEY CENTER RD",
    "dropdelcty": "DYER",
    "dropdelst": "NV",
    "dropdelzpp": 890109997,
    "dropphyadd": "1 VALLEY CENTER RD",
    "dropphycty": "DYER",
    "dropphyst": "NV",
    "dropphyzpp": 890109997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DYER",
    "dropmalst": "NV",
    "dropmalzpp": 890109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755723333,
    "dropsitcph": 7755723333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14401",
    "droptype": "D",
    "dropname": "ELKO",
    "dropdeladd": "275 3RD ST",
    "dropdelcty": "ELKO",
    "dropdelst": "NV",
    "dropdelzpp": 898013618,
    "dropphyadd": "275 3RD ST",
    "dropphycty": "ELKO",
    "dropphyst": "NV",
    "dropphyzpp": 898013618,
    "dropmaladd": "275 3RD ST",
    "dropmalcty": "ELKO",
    "dropmalst": "NV",
    "dropmalzpp": 898019998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757387309,
    "dropsitcph": 7757779803,
    "dropfax": 7757385980
  },
  {
    "dcode": "D",
    "dropkey": "PZ14404",
    "droptype": "D",
    "dropname": "ELY",
    "dropdeladd": "2600 BRISTLECONE AVE",
    "dropdelcty": "ELY",
    "dropdelst": "NV",
    "dropdelzpp": 893013140,
    "dropphyadd": "2600 BRISTLECONE AVE",
    "dropphycty": "ELY",
    "dropphyst": "NV",
    "dropphyzpp": 893013140,
    "dropmaladd": "2600 BRISTLECONE AVE",
    "dropmalcty": "ELY",
    "dropmalst": "NV",
    "dropmalzpp": 893019998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752899276,
    "dropfax": 7022892614
  },
  {
    "dcode": "D",
    "dropkey": "PZ14407",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "51 S MAIN ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "NV",
    "dropdelzpp": 893169995,
    "dropphyadd": "51 S MAIN ST",
    "dropphycty": "EUREKA",
    "dropphyst": "NV",
    "dropphyzpp": 893169995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EUREKA",
    "dropmalst": "NV",
    "dropmalzpp": 893169998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752375257,
    "dropfax": 7752375257
  },
  {
    "dcode": "D",
    "dropkey": "PZ14408",
    "droptype": "D",
    "dropname": "FALLON",
    "dropdeladd": "120 N MAINE ST",
    "dropdelcty": "FALLON",
    "dropdelst": "NV",
    "dropdelzpp": 894062930,
    "dropphyadd": "120 N MAINE ST",
    "dropphycty": "FALLON",
    "dropphyst": "NV",
    "dropphyzpp": 894062930,
    "dropmaladd": "120 N MAINE ST",
    "dropmalcty": "FALLON",
    "dropmalst": "NV",
    "dropmalzpp": 894069998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754282906,
    "dropsitcph": 7754282906,
    "dropfax": 7754282848
  },
  {
    "dcode": "D",
    "dropkey": "PZ14413",
    "droptype": "D",
    "dropname": "FERNLEY",
    "dropdeladd": "315 E MAIN ST",
    "dropdelcty": "FERNLEY",
    "dropdelst": "NV",
    "dropdelzpp": 894087747,
    "dropphyadd": "315 E MAIN ST",
    "dropphycty": "FERNLEY",
    "dropphyst": "NV",
    "dropphyzpp": 894087747,
    "dropmaladd": "315 E MAIN ST",
    "dropmalcty": "FERNLEY",
    "dropmalst": "NV",
    "dropmalzpp": 894087747,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755752214,
    "dropsitcph": 7755756962,
    "dropfax": 7755753200
  },
  {
    "dcode": "D",
    "dropkey": "PZ14416",
    "droptype": "D",
    "dropname": "GABBS",
    "dropdeladd": "101 4TH ST",
    "dropdelcty": "GABBS",
    "dropdelst": "NV",
    "dropdelzpp": 894099800,
    "dropphyadd": "101 4TH ST",
    "dropphycty": "GABBS",
    "dropphyst": "NV",
    "dropphyzpp": 894099800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GABBS",
    "dropmalst": "NV",
    "dropmalzpp": 894099998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7752852663,
    "dropsitcph": 7752852663,
    "dropfax": 7752850046
  },
  {
    "dcode": "D",
    "dropkey": "PZ14419",
    "droptype": "D",
    "dropname": "GARDNERVILLE",
    "dropdeladd": "1267 US HIGHWAY 395 N STE L",
    "dropdelcty": "GARDNERVILLE",
    "dropdelst": "NV",
    "dropdelzpp": 894108300,
    "dropphyadd": "1267 US HIGHWAY 395 N STE L",
    "dropphycty": "GARDNERVILLE",
    "dropphyst": "NV",
    "dropphyzpp": 894108300,
    "dropmaladd": "1267 US HIGHWAY 395 N STE L",
    "dropmalcty": "GARDNERVILLE",
    "dropmalst": "NV",
    "dropmalzpp": 894109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757823085,
    "dropsitcph": 7757824139,
    "dropfax": 7757830074
  },
  {
    "dcode": "D",
    "dropkey": "PZ14423",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "2244 FOOTHILL RD",
    "dropdelcty": "GENOA",
    "dropdelst": "NV",
    "dropdelzpp": 894119998,
    "dropphyadd": "2244 FOOTHILL RD",
    "dropphycty": "GENOA",
    "dropphyst": "NV",
    "dropphyzpp": 894119998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GENOA",
    "dropmalst": "NV",
    "dropmalzpp": 894119997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757820552,
    "dropsitcph": 7757820552,
    "dropfax": 7757825682
  },
  {
    "dcode": "D",
    "dropkey": "PZ14424",
    "droptype": "D",
    "dropname": "GERLACH",
    "dropdeladd": "345 E SUNSET BLVD",
    "dropdelcty": "GERLACH",
    "dropdelst": "NV",
    "dropdelzpp": 894129800,
    "dropphyadd": "345 E SUNSET BLVD",
    "dropphycty": "GERLACH",
    "dropphyst": "NV",
    "dropphyzpp": 894129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GERLACH",
    "dropmalst": "NV",
    "dropmalzpp": 894129998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755572333,
    "dropsitcph": 7755572333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14425",
    "droptype": "D",
    "dropname": "GLENBROOK",
    "dropdeladd": "1785 US HIGHWAY 50",
    "dropdelcty": "GLENBROOK",
    "dropdelst": "NV",
    "dropdelzpp": 894139995,
    "dropphyadd": "1785 US HIGHWAY 50",
    "dropphycty": "GLENBROOK",
    "dropphyst": "NV",
    "dropphyzpp": 894139995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENBROOK",
    "dropmalst": "NV",
    "dropmalzpp": 894139998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757495260,
    "dropsitcph": 7757495260,
    "dropfax": 7757495260
  },
  {
    "dcode": "D",
    "dropkey": "PZ14426",
    "droptype": "D",
    "dropname": "GOLCONDA",
    "dropdeladd": "295 OLD HIGHWAY 40 E",
    "dropdelcty": "GOLCONDA",
    "dropdelst": "NV",
    "dropdelzpp": 894149800,
    "dropphyadd": "295 OLD HIGHWAY 40 E",
    "dropphycty": "GOLCONDA",
    "dropphyst": "NV",
    "dropphyzpp": 894149800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLCONDA",
    "dropmalst": "NV",
    "dropmalzpp": 894149998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7756232449,
    "dropsitcph": 7756232449,
    "dropfax": 7756236710
  },
  {
    "dcode": "D",
    "dropkey": "PZ14430",
    "droptype": "D",
    "dropname": "GOLDFIELD",
    "dropdeladd": "400 S 4TH ST",
    "dropdelcty": "GOLDFIELD",
    "dropdelst": "NV",
    "dropdelzpp": 890139997,
    "dropphyadd": "400 S 4TH ST",
    "dropphycty": "GOLDFIELD",
    "dropphyst": "NV",
    "dropphyzpp": 890139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLDFIELD",
    "dropmalst": "NV",
    "dropmalzpp": 890139998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754856374,
    "dropsitcph": 7754856374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14438",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "701 6TH ST",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "NV",
    "dropdelzpp": 894159995,
    "dropphyadd": "701 6TH ST",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "NV",
    "dropphyzpp": 894159995,
    "dropmaladd": "701 6TH ST",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "NV",
    "dropmalzpp": 894159998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619453,
    "dropsitcph": 7759452850,
    "dropfax": 7759458524
  },
  {
    "dcode": "D",
    "dropkey": "PZ14441",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "404 S BOULDER HWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890159998,
    "dropphyadd": "404 S BOULDER HWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890159998,
    "dropmaladd": "404 S BOULDER HWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890159998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7025587486,
    "dropsitcph": 7025587486,
    "dropfax": 7025658908
  },
  {
    "dcode": "D",
    "dropkey": "PZ14449",
    "droptype": "D",
    "dropname": "IMLAY",
    "dropdeladd": "410 MAIN ST",
    "dropdelcty": "IMLAY",
    "dropdelst": "NV",
    "dropdelzpp": 894189995,
    "dropphyadd": "410 MAIN ST",
    "dropphycty": "IMLAY",
    "dropphyst": "NV",
    "dropphyzpp": 894189995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IMLAY",
    "dropmalst": "NV",
    "dropmalzpp": 894189998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755387383,
    "dropsitcph": 7755387383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14451",
    "droptype": "D",
    "dropname": "INDIAN SPRINGS",
    "dropdeladd": "185 N HWY 95",
    "dropdelcty": "INDIAN SPRINGS",
    "dropdelst": "NV",
    "dropdelzpp": 890180139,
    "dropphyadd": "185 N HWY 95",
    "dropphycty": "INDIAN SPRINGS",
    "dropphyst": "NV",
    "dropphyzpp": 890180139,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIAN SPRINGS",
    "dropmalst": "NV",
    "dropmalzpp": 890189998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028793289,
    "dropsitcph": 7028793289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14456",
    "droptype": "D",
    "dropname": "JACKPOT",
    "dropdeladd": "1925 GURLEY DR",
    "dropdelcty": "JACKPOT",
    "dropdelst": "NV",
    "dropdelzpp": 898259995,
    "dropphyadd": "1925 GURLEY DR",
    "dropphycty": "JACKPOT",
    "dropphyst": "NV",
    "dropphyzpp": 898259995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKPOT",
    "dropmalst": "NV",
    "dropmalzpp": 898259998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757552252,
    "dropfax": 7757552685
  },
  {
    "dcode": "D",
    "dropkey": "PZ14460",
    "droptype": "D",
    "dropname": "JEAN",
    "dropdeladd": "18500 LAS VEGAS BLVD S",
    "dropdelcty": "JEAN",
    "dropdelst": "NV",
    "dropdelzpp": 890199995,
    "dropphyadd": "18500 LAS VEGAS BLVD S",
    "dropphycty": "JEAN",
    "dropphyst": "NV",
    "dropphyzpp": 890199995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JEAN",
    "dropmalst": "NV",
    "dropmalzpp": 890199998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028741327,
    "dropsitcph": 7028741327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14477",
    "droptype": "D",
    "dropname": "LAS VEGAS",
    "dropdeladd": "1001 E SUNSET RD RM 1030",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891999998,
    "dropphyadd": "1001 E SUNSET RD RM 1030",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891999998,
    "dropmaladd": "1001 E SUNSET RD RM 1030",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891999998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619230,
    "dropsitcph": 7023619230,
    "dropfax": 7023619349
  },
  {
    "dcode": "D",
    "dropkey": "PZ14480",
    "droptype": "D",
    "dropname": "LAUGHLIN",
    "dropdeladd": "2850 S NEEDLES HWY",
    "dropdelcty": "LAUGHLIN",
    "dropdelst": "NV",
    "dropdelzpp": 890299998,
    "dropphyadd": "2850 S NEEDLES HWY",
    "dropphycty": "LAUGHLIN",
    "dropphyst": "NV",
    "dropphyzpp": 890299998,
    "dropmaladd": "2850 S NEEDLES HWY",
    "dropmalcty": "LAUGHLIN",
    "dropmalst": "NV",
    "dropmalzpp": 890299998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022986161,
    "dropsitcph": 7022986161,
    "dropfax": 7022983019
  },
  {
    "dcode": "D",
    "dropkey": "PZ14488",
    "droptype": "D",
    "dropname": "LOGANDALE",
    "dropdeladd": "3145 N MOAPA VALLEY BLVD",
    "dropdelcty": "LOGANDALE",
    "dropdelst": "NV",
    "dropdelzpp": 890219995,
    "dropphyadd": "3145 N MOAPA VALLEY BLVD",
    "dropphycty": "LOGANDALE",
    "dropphyst": "NV",
    "dropphyzpp": 890219995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOGANDALE",
    "dropmalst": "NV",
    "dropmalzpp": 890219998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619229,
    "dropsitcph": 7023983405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14489",
    "droptype": "D",
    "dropname": "LOVELOCK",
    "dropdeladd": "390 MAIN ST",
    "dropdelcty": "LOVELOCK",
    "dropdelst": "NV",
    "dropdelzpp": 894199995,
    "dropphyadd": "390 MAIN ST",
    "dropphycty": "LOVELOCK",
    "dropphyst": "NV",
    "dropphyzpp": 894199995,
    "dropmaladd": "390 MAIN ST",
    "dropmalcty": "LOVELOCK",
    "dropmalst": "NV",
    "dropmalzpp": 894199998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7752737862,
    "dropsitcph": 7752737862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14491",
    "droptype": "D",
    "dropname": "LUND",
    "dropdeladd": "50 S MAIN ST",
    "dropdelcty": "LUND",
    "dropdelst": "NV",
    "dropdelzpp": 893179800,
    "dropphyadd": "50 S MAIN ST",
    "dropphycty": "LUND",
    "dropphyst": "NV",
    "dropphyzpp": 893179800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUND",
    "dropmalst": "NV",
    "dropmalzpp": 893179998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752385215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14492",
    "droptype": "D",
    "dropname": "LUNING",
    "dropdeladd": "202 PLYMIRE ST",
    "dropdelcty": "LUNING",
    "dropdelst": "NV",
    "dropdelzpp": 894209700,
    "dropphyadd": "202 PLYMIRE ST",
    "dropphycty": "LUNING",
    "dropphyst": "NV",
    "dropphyzpp": 894209700,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LUNING",
    "dropmalst": "NV",
    "dropmalzpp": 894209998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755732539,
    "dropsitcph": 7755732539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14495",
    "droptype": "D",
    "dropname": "MANHATTAN",
    "dropdeladd": "17 MAIN ST",
    "dropdelcty": "MANHATTAN",
    "dropdelst": "NV",
    "dropdelzpp": 890229995,
    "dropphyadd": "17 MAIN ST",
    "dropphycty": "MANHATTAN",
    "dropphyst": "NV",
    "dropphyzpp": 890229995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANHATTAN",
    "dropmalst": "NV",
    "dropmalzpp": 890229998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754872315,
    "dropsitcph": 7754872315,
    "dropfax": 7754872373
  },
  {
    "dcode": "D",
    "dropkey": "PZ14498",
    "droptype": "D",
    "dropname": "MC DERMITT",
    "dropdeladd": "5 US HIGHWAY 95 S",
    "dropdelcty": "MC DERMITT",
    "dropdelst": "NV",
    "dropdelzpp": 894219800,
    "dropphyadd": "5 US HIGHWAY 95 S",
    "dropphycty": "MC DERMITT",
    "dropphyst": "NV",
    "dropphyzpp": 894219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC DERMITT",
    "dropmalst": "NV",
    "dropmalzpp": 894219998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7755374797,
    "dropfax": 7755374797
  },
  {
    "dcode": "D",
    "dropkey": "PZ14499",
    "droptype": "D",
    "dropname": "MC GILL",
    "dropdeladd": "2 4TH ST",
    "dropdelcty": "MC GILL",
    "dropdelst": "NV",
    "dropdelzpp": 893189800,
    "dropphyadd": "2 4TH ST",
    "dropphycty": "MC GILL",
    "dropphyst": "NV",
    "dropphyzpp": 893189800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MC GILL",
    "dropmalst": "NV",
    "dropmalzpp": 893189998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752357593,
    "dropfax": 7752357427
  },
  {
    "dcode": "D",
    "dropkey": "PZ14502",
    "droptype": "D",
    "dropname": "MERCURY",
    "dropdeladd": "525 BUSTER ST",
    "dropdelcty": "MERCURY",
    "dropdelst": "NV",
    "dropdelzpp": 890239997,
    "dropphyadd": "525 BUSTER ST",
    "dropphycty": "MERCURY",
    "dropphyst": "NV",
    "dropphyzpp": 890239997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERCURY",
    "dropmalst": "NV",
    "dropmalzpp": 890239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022956939,
    "dropsitcph": 7022956939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14503",
    "droptype": "D",
    "dropname": "MESQUITE",
    "dropdeladd": "510 W MESQUITE BLVD",
    "dropdelcty": "MESQUITE",
    "dropdelst": "NV",
    "dropdelzpp": 890279995,
    "dropphyadd": "510 W MESQUITE BLVD",
    "dropphycty": "MESQUITE",
    "dropphyst": "NV",
    "dropphyzpp": 890279995,
    "dropmaladd": "510 W MESQUITE BLVD",
    "dropmalcty": "MESQUITE",
    "dropmalst": "NV",
    "dropmalzpp": 890279995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023465274,
    "dropsitcph": 7023468149,
    "dropfax": 7023468618
  },
  {
    "dcode": "D",
    "dropkey": "PZ14508",
    "droptype": "D",
    "dropname": "MINA",
    "dropdeladd": "215 8TH ST",
    "dropdelcty": "MINA",
    "dropdelst": "NV",
    "dropdelzpp": 894229800,
    "dropphyadd": "215 8TH ST",
    "dropphycty": "MINA",
    "dropphyst": "NV",
    "dropphyzpp": 894229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINA",
    "dropmalst": "NV",
    "dropmalzpp": 894229998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755732245,
    "dropsitcph": 7755732245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14509",
    "droptype": "D",
    "dropname": "MINDEN",
    "dropdeladd": "1640 US HIGHWAY 395 N",
    "dropdelcty": "MINDEN",
    "dropdelst": "NV",
    "dropdelzpp": 894234307,
    "dropphyadd": "1640 US HIGHWAY 395 N",
    "dropphycty": "MINDEN",
    "dropphyst": "NV",
    "dropphyzpp": 894234307,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINDEN",
    "dropmalst": "NV",
    "dropmalzpp": 894239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757822877,
    "dropsitcph": 7757822944,
    "dropfax": 7757822868
  },
  {
    "dcode": "D",
    "dropkey": "PZ14510",
    "droptype": "D",
    "dropname": "MOAPA",
    "dropdeladd": "1800 E STATE HIGHWAY 168",
    "dropdelcty": "MOAPA",
    "dropdelst": "NV",
    "dropdelzpp": 890259002,
    "dropphyadd": "1800 E STATE HIGHWAY 168",
    "dropphycty": "MOAPA",
    "dropphyst": "NV",
    "dropphyzpp": 890259002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOAPA",
    "dropmalst": "NV",
    "dropmalzpp": 890259998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028642273,
    "dropsitcph": 7028642273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14512",
    "droptype": "D",
    "dropname": "MONTELLO",
    "dropdeladd": "143 FRONT ST",
    "dropdelcty": "MONTELLO",
    "dropdelst": "NV",
    "dropdelzpp": 898309800,
    "dropphyadd": "143 FRONT ST",
    "dropphycty": "MONTELLO",
    "dropphyst": "NV",
    "dropphyzpp": 898309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTELLO",
    "dropmalst": "NV",
    "dropmalzpp": 898309998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757762529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14514",
    "droptype": "D",
    "dropname": "MOUNTAIN CITY",
    "dropdeladd": "519 DAVIDSON ST",
    "dropdelcty": "MOUNTAIN CITY",
    "dropdelst": "NV",
    "dropdelzpp": 898319995,
    "dropphyadd": "519 DAVIDSON ST",
    "dropphycty": "MOUNTAIN CITY",
    "dropphyst": "NV",
    "dropphyzpp": 898319995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN CITY",
    "dropmalst": "NV",
    "dropmalzpp": 898319998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757636663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14531",
    "droptype": "D",
    "dropname": "NIXON",
    "dropdeladd": "199 STATE ROUTE 447",
    "dropdelcty": "NIXON",
    "dropdelst": "NV",
    "dropdelzpp": 894249800,
    "dropphyadd": "199 STATE ROUTE 447",
    "dropphycty": "NIXON",
    "dropphyst": "NV",
    "dropphyzpp": 894249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NIXON",
    "dropmalst": "NV",
    "dropmalzpp": 894249998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755741033,
    "dropsitcph": 7755741033,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14533",
    "droptype": "D",
    "dropname": "NORTH LAS VEGAS",
    "dropdeladd": "1414 E LAKE MEAD BLVD",
    "dropdelcty": "NORTH LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 890309998,
    "dropphyadd": "1414 E LAKE MEAD BLVD",
    "dropphycty": "NORTH LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 890309998,
    "dropmaladd": "1414 E LAKE MEAD BLVD",
    "dropmalcty": "NORTH LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 890309998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7026491871,
    "dropsitcph": 7026491871,
    "dropfax": 7026335087
  },
  {
    "dcode": "D",
    "dropkey": "PZ14538",
    "droptype": "D",
    "dropname": "OROVADA",
    "dropdeladd": "0 US HIGHWAY 95 RD",
    "dropdelcty": "OROVADA",
    "dropdelst": "NV",
    "dropdelzpp": 894259995,
    "dropphyadd": "0 US HIGHWAY 95 RD",
    "dropphycty": "OROVADA",
    "dropphyst": "NV",
    "dropphyzpp": 894259995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OROVADA",
    "dropmalst": "NV",
    "dropmalzpp": 894259998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7752723228,
    "dropsitcph": 7752642300,
    "dropfax": 7752723228
  },
  {
    "dcode": "D",
    "dropkey": "PZ14539",
    "droptype": "D",
    "dropname": "OVERTON",
    "dropdeladd": "275 MOAPA VALLEY BLVD",
    "dropdelcty": "OVERTON",
    "dropdelst": "NV",
    "dropdelzpp": 890409000,
    "dropphyadd": "275 MOAPA VALLEY BLVD",
    "dropphycty": "OVERTON",
    "dropphyst": "NV",
    "dropphyzpp": 890409000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OVERTON",
    "dropmalst": "NV",
    "dropmalzpp": 890409998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023972140,
    "dropsitcph": 7023972140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14541",
    "droptype": "D",
    "dropname": "OWYHEE",
    "dropdeladd": "23830 NV STATE HWY 225",
    "dropdelcty": "OWYHEE",
    "dropdelst": "NV",
    "dropdelzpp": 898329800,
    "dropphyadd": "23830 NV STATE HWY 225",
    "dropphycty": "OWYHEE",
    "dropphyst": "NV",
    "dropphyzpp": 898329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OWYHEE",
    "dropmalst": "NV",
    "dropmalzpp": 898329998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757573736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14542",
    "droptype": "D",
    "dropname": "PAHRUMP",
    "dropdeladd": "2300 POSTAL DR",
    "dropdelcty": "PAHRUMP",
    "dropdelst": "NV",
    "dropdelzpp": 890489998,
    "dropphyadd": "2300 POSTAL DR",
    "dropphycty": "PAHRUMP",
    "dropphyst": "NV",
    "dropphyzpp": 890489998,
    "dropmaladd": "2300 POSTAL DR",
    "dropmalcty": "PAHRUMP",
    "dropmalst": "NV",
    "dropmalzpp": 890489998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757277055,
    "dropsitcph": 7757277055,
    "dropfax": 7757278062
  },
  {
    "dcode": "D",
    "dropkey": "PZ14544",
    "droptype": "D",
    "dropname": "PANACA",
    "dropdeladd": "350 MAIN ST",
    "dropdelcty": "PANACA",
    "dropdelst": "NV",
    "dropdelzpp": 890429800,
    "dropphyadd": "350 MAIN ST",
    "dropphycty": "PANACA",
    "dropphyst": "NV",
    "dropphyzpp": 890429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANACA",
    "dropmalst": "NV",
    "dropmalzpp": 890429998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757284512,
    "dropsitcph": 7757284512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14549",
    "droptype": "D",
    "dropname": "PARADISE VALLEY",
    "dropdeladd": "130 S MAIN ST",
    "dropdelcty": "PARADISE VALLEY",
    "dropdelst": "NV",
    "dropdelzpp": 894269800,
    "dropphyadd": "130 S MAIN ST",
    "dropphycty": "PARADISE VALLEY",
    "dropphyst": "NV",
    "dropphyzpp": 894269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARADISE VALLEY",
    "dropmalst": "NV",
    "dropmalzpp": 894269998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7755783310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14556",
    "droptype": "D",
    "dropname": "PIOCHE",
    "dropdeladd": "432 MAIN ST",
    "dropdelcty": "PIOCHE",
    "dropdelst": "NV",
    "dropdelzpp": 890432568,
    "dropphyadd": "432 MAIN ST",
    "dropphycty": "PIOCHE",
    "dropphyst": "NV",
    "dropphyzpp": 890432568,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIOCHE",
    "dropmalst": "NV",
    "dropmalzpp": 890439998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7759810573,
    "dropsitcph": 7759810573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14578",
    "droptype": "D",
    "dropname": "RENO",
    "dropdeladd": "2000 VASSAR ST",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895109991,
    "dropphyadd": "2000 VASSAR ST",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895109998,
    "dropmaladd": "2000 VASSAR ST",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880729,
    "dropsitcph": 7757880729,
    "dropfax": 7757880692
  },
  {
    "dcode": "D",
    "dropkey": "PZ14585",
    "droptype": "D",
    "dropname": "ROUND MOUNTAIN",
    "dropdeladd": "83 HADLEY LN",
    "dropdelcty": "ROUND MOUNTAIN",
    "dropdelst": "NV",
    "dropdelzpp": 890459995,
    "dropphyadd": "83 HADLEY LN",
    "dropphycty": "ROUND MOUNTAIN",
    "dropphyst": "NV",
    "dropphyzpp": 890459995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROUND MOUNTAIN",
    "dropmalst": "NV",
    "dropmalzpp": 890459998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7753772237,
    "dropsitcph": 7753772237,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14588",
    "droptype": "D",
    "dropname": "RUTH",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "RUTH",
    "dropdelst": "NV",
    "dropdelzpp": 893199800,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "RUTH",
    "dropphyst": "NV",
    "dropphyzpp": 893199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTH",
    "dropmalst": "NV",
    "dropmalzpp": 893199998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7752893533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14595",
    "droptype": "D",
    "dropname": "SCHURZ",
    "dropdeladd": "4000A US HIGHWAY 95 N",
    "dropdelcty": "SCHURZ",
    "dropdelst": "NV",
    "dropdelzpp": 894279800,
    "dropphyadd": "4000A US HIGHWAY 95 N",
    "dropphycty": "SCHURZ",
    "dropphyst": "NV",
    "dropphyzpp": 894279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SCHURZ",
    "dropmalst": "NV",
    "dropmalzpp": 894279998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7757732359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14596",
    "droptype": "D",
    "dropname": "SEARCHLIGHT",
    "dropdeladd": "437 S MAIN ST",
    "dropdelcty": "SEARCHLIGHT",
    "dropdelst": "NV",
    "dropdelzpp": 890469800,
    "dropphyadd": "437 S MAIN ST",
    "dropphycty": "SEARCHLIGHT",
    "dropphyst": "NV",
    "dropphyzpp": 890469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEARCHLIGHT",
    "dropmalst": "NV",
    "dropmalzpp": 890469998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022971219,
    "dropsitcph": 7022971219,
    "dropfax": 7022971219
  },
  {
    "dcode": "D",
    "dropkey": "PZ14604",
    "droptype": "D",
    "dropname": "SILVER CITY",
    "dropdeladd": "270 MAIN ST",
    "dropdelcty": "SILVER CITY",
    "dropdelst": "NV",
    "dropdelzpp": 894289800,
    "dropphyadd": "270 MAIN ST",
    "dropphycty": "SILVER CITY",
    "dropphyst": "NV",
    "dropphyzpp": 894289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER CITY",
    "dropmalst": "NV",
    "dropmalzpp": 894289998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880653,
    "dropsitcph": 7758470200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14606",
    "droptype": "D",
    "dropname": "SILVER SPRINGS",
    "dropdeladd": "1250 DONNER TRL",
    "dropdelcty": "SILVER SPRINGS",
    "dropdelst": "NV",
    "dropdelzpp": 894299997,
    "dropphyadd": "1250 DONNER TRL",
    "dropphycty": "SILVER SPRINGS",
    "dropphyst": "NV",
    "dropphyzpp": 894299997,
    "dropmaladd": "1250 DONNER TRL",
    "dropmalcty": "SILVER SPRINGS",
    "dropmalst": "NV",
    "dropmalzpp": 894299997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755773409,
    "dropsitcph": 7755770703,
    "dropfax": 7755770623
  },
  {
    "dcode": "D",
    "dropkey": "PZ14607",
    "droptype": "D",
    "dropname": "SILVERPEAK",
    "dropdeladd": "350 MAIN ST",
    "dropdelcty": "SILVERPEAK",
    "dropdelst": "NV",
    "dropdelzpp": 890479995,
    "dropphyadd": "350 MAIN ST",
    "dropphycty": "SILVERPEAK",
    "dropphyst": "NV",
    "dropphyzpp": 890479995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVERPEAK",
    "dropmalst": "NV",
    "dropmalzpp": 890479998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7759372366,
    "dropsitcph": 7759372366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14611",
    "droptype": "D",
    "dropname": "SMITH",
    "dropdeladd": "2306 STATE ROUTE 208",
    "dropdelcty": "SMITH",
    "dropdelst": "NV",
    "dropdelzpp": 894309995,
    "dropphyadd": "2306 STATE ROUTE 208",
    "dropphycty": "SMITH",
    "dropphyst": "NV",
    "dropphyzpp": 894309995,
    "dropmaladd": "2306 STATE ROUTE 208",
    "dropmalcty": "SMITH",
    "dropmalst": "NV",
    "dropmalzpp": 894309995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880653,
    "dropsitcph": 7754652301,
    "dropfax": 7754652085
  },
  {
    "dcode": "D",
    "dropkey": "PZ14616",
    "droptype": "D",
    "dropname": "SPARKS",
    "dropdeladd": "750 4TH ST",
    "dropdelcty": "SPARKS",
    "dropdelst": "NV",
    "dropdelzpp": 894317419,
    "dropphyadd": "750 4TH ST",
    "dropphycty": "SPARKS",
    "dropphyst": "NV",
    "dropphyzpp": 894317419,
    "dropmaladd": "750 4TH ST",
    "dropmalcty": "SPARKS",
    "dropmalst": "NV",
    "dropmalzpp": 894319998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7753591163,
    "dropsitcph": 7753591043,
    "dropfax": 7753599312
  },
  {
    "dcode": "D",
    "dropkey": "PZ14658",
    "droptype": "D",
    "dropname": "TONOPAH",
    "dropdeladd": "201 ERIE MAIN",
    "dropdelcty": "TONOPAH",
    "dropdelst": "NV",
    "dropdelzpp": 890499800,
    "dropphyadd": "201 ERIE MAIN",
    "dropphycty": "TONOPAH",
    "dropphyst": "NV",
    "dropphyzpp": 890499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONOPAH",
    "dropmalst": "NV",
    "dropmalzpp": 890499998,
    "dropsitphn": 7754823359,
    "dropsitlph": 7754823359,
    "dropsitcph": 7754823359,
    "dropfax": 7754826172
  },
  {
    "dcode": "D",
    "dropkey": "PZ14668",
    "droptype": "D",
    "dropname": "TUSCARORA",
    "dropdeladd": "55 WEED ST",
    "dropdelcty": "TUSCARORA",
    "dropdelst": "NV",
    "dropdelzpp": 898349995,
    "dropphyadd": "55 WEED ST",
    "dropphycty": "TUSCARORA",
    "dropphyst": "NV",
    "dropphyzpp": 898349995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUSCARORA",
    "dropmalst": "NV",
    "dropmalzpp": 898349998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757566597,
    "dropfax": 7757566597
  },
  {
    "dcode": "D",
    "dropkey": "PZ14677",
    "droptype": "D",
    "dropname": "VALMY",
    "dropdeladd": "1 I 80 W EXIT 216",
    "dropdelcty": "VALMY",
    "dropdelst": "NV",
    "dropdelzpp": 894389800,
    "dropphyadd": "1 I 80 W EXIT 216",
    "dropphycty": "VALMY",
    "dropphyst": "NV",
    "dropphyzpp": 894389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VALMY",
    "dropmalst": "NV",
    "dropmalzpp": 894389998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7756355077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14678",
    "droptype": "D",
    "dropname": "VERDI",
    "dropdeladd": "1675 HIGHWAY 40 W",
    "dropdelcty": "VERDI",
    "dropdelst": "NV",
    "dropdelzpp": 894399998,
    "dropphyadd": "1675 HIGHWAY 40 W",
    "dropphycty": "VERDI",
    "dropphyst": "NV",
    "dropphyzpp": 894399998,
    "dropmaladd": "1675 HIGHWAY 40 W",
    "dropmalcty": "VERDI",
    "dropmalst": "NV",
    "dropmalzpp": 894399998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7753451012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14679",
    "droptype": "D",
    "dropname": "VIRGINIA CITY",
    "dropdeladd": "132 S C ST",
    "dropdelcty": "VIRGINIA CITY",
    "dropdelst": "NV",
    "dropdelzpp": 894409800,
    "dropphyadd": "132 S C ST",
    "dropphycty": "VIRGINIA CITY",
    "dropphyst": "NV",
    "dropphyzpp": 894409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VIRGINIA CITY",
    "dropmalst": "NV",
    "dropmalzpp": 894409998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7758470515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14683",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "150 US HIGHWAY 40",
    "dropdelcty": "WADSWORTH",
    "dropdelst": "NV",
    "dropdelzpp": 894429800,
    "dropphyadd": "150 US HIGHWAY 40",
    "dropphycty": "WADSWORTH",
    "dropphyst": "NV",
    "dropphyzpp": 894429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WADSWORTH",
    "dropmalst": "NV",
    "dropmalzpp": 894429998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7755754667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14692",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "2818 STATE ROUTE 208",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "NV",
    "dropdelzpp": 894449995,
    "dropphyadd": "2818 STATE ROUTE 208",
    "dropphycty": "WELLINGTON",
    "dropphyst": "NV",
    "dropphyzpp": 894449995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "NV",
    "dropmalzpp": 894449998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7754652250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14693",
    "droptype": "D",
    "dropname": "WELLS",
    "dropdeladd": "201 CASTLE ST",
    "dropdelcty": "WELLS",
    "dropdelst": "NV",
    "dropdelzpp": 898359995,
    "dropphyadd": "201 CASTLE ST",
    "dropphycty": "WELLS",
    "dropphyst": "NV",
    "dropphyzpp": 898359995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WELLS",
    "dropmalst": "NV",
    "dropmalzpp": 898359998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7757523234,
    "dropfax": 7757523364
  },
  {
    "dcode": "D",
    "dropkey": "PZ14694",
    "droptype": "D",
    "dropname": "WEST WENDOVER",
    "dropdeladd": "810 ALPINE ST",
    "dropdelcty": "WEST WENDOVER",
    "dropdelst": "NV",
    "dropdelzpp": 898839800,
    "dropphyadd": "810 ALPINE ST",
    "dropphycty": "WEST WENDOVER",
    "dropphyst": "NV",
    "dropphyzpp": 898839800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST WENDOVER",
    "dropmalst": "NV",
    "dropmalzpp": 898839998,
    "dropsitphn": 7023619453,
    "dropsitlph": 8019742558,
    "dropsitcph": 7756642929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14700",
    "droptype": "D",
    "dropname": "WINNEMUCCA",
    "dropdeladd": "850 HANSON ST",
    "dropdelcty": "WINNEMUCCA",
    "dropdelst": "NV",
    "dropdelzpp": 894453676,
    "dropphyadd": "850 HANSON ST",
    "dropphycty": "WINNEMUCCA",
    "dropphyst": "NV",
    "dropphyzpp": 894453676,
    "dropmaladd": "850 HANSON ST",
    "dropmalcty": "WINNEMUCCA",
    "dropmalst": "NV",
    "dropmalzpp": 894459998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 7756232456,
    "dropfax": 7756230233
  },
  {
    "dcode": "D",
    "dropkey": "PZ14703",
    "droptype": "D",
    "dropname": "YERINGTON",
    "dropdeladd": "26 N MAIN ST",
    "dropdelcty": "YERINGTON",
    "dropdelst": "NV",
    "dropdelzpp": 894472278,
    "dropphyadd": "26 N MAIN ST",
    "dropphycty": "YERINGTON",
    "dropphyst": "NV",
    "dropphyzpp": 894472278,
    "dropmaladd": "26 N MAIN ST",
    "dropmalcty": "YERINGTON",
    "dropmalst": "NV",
    "dropmalzpp": 894479998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754639687,
    "dropsitcph": 7754639087,
    "dropfax": 7754632257
  },
  {
    "dcode": "D",
    "dropkey": "PZ14704",
    "droptype": "D",
    "dropname": "ZEPHYR COVE",
    "dropdeladd": "212 ELKS POINT RD",
    "dropdelcty": "ZEPHYR COVE",
    "dropdelst": "NV",
    "dropdelzpp": 894489800,
    "dropphyadd": "212 ELKS POINT RD",
    "dropphycty": "ZEPHYR COVE",
    "dropphyst": "NV",
    "dropphyzpp": 894489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZEPHYR COVE",
    "dropmalst": "NV",
    "dropmalzpp": 894489998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7755885419,
    "dropsitcph": 7755885419,
    "dropfax": 7755886042
  },
  {
    "dcode": "D",
    "dropkey": "PZ14710",
    "droptype": "D",
    "dropname": "ADAMS",
    "dropdeladd": "230 OLD HIGHWAY 11",
    "dropdelcty": "ADAMS",
    "dropdelst": "OR",
    "dropdelzpp": 978105000,
    "dropphyadd": "230 OLD HIGHWAY 11",
    "dropphycty": "ADAMS",
    "dropphyst": "OR",
    "dropphyzpp": 978105000,
    "dropmaladd": "230 OLD HIGHWAY 11",
    "dropmalcty": "ADAMS",
    "dropmalst": "OR",
    "dropmalzpp": 978109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415662689,
    "dropsitcph": 5415662689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14711",
    "droptype": "D",
    "dropname": "ADEL",
    "dropdeladd": "1 HIGHWAY 140 E",
    "dropdelcty": "ADEL",
    "dropdelst": "OR",
    "dropdelzpp": 976209700,
    "dropphyadd": "1 HIGHWAY 140 E",
    "dropphycty": "ADEL",
    "dropphyst": "OR",
    "dropphyzpp": 976209700,
    "dropmaladd": "1 HIGHWAY 140 E",
    "dropmalcty": "ADEL",
    "dropmalst": "OR",
    "dropmalzpp": 976209700,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414071124,
    "dropsitcph": 5414071124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14712",
    "droptype": "D",
    "dropname": "ADRIAN",
    "dropdeladd": "105 OREGON ST",
    "dropdelcty": "ADRIAN",
    "dropdelst": "OR",
    "dropdelzpp": 979015099,
    "dropphyadd": "105 OREGON ST",
    "dropphycty": "ADRIAN",
    "dropphyst": "OR",
    "dropphyzpp": 979015099,
    "dropmaladd": "105 OREGON ST",
    "dropmalcty": "ADRIAN",
    "dropmalst": "OR",
    "dropmalzpp": 979019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413723959,
    "dropsitcph": 5413723959,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14714",
    "droptype": "D",
    "dropname": "AGNESS",
    "dropdeladd": "3996 COUGAR LN",
    "dropdelcty": "AGNESS",
    "dropdelst": "OR",
    "dropdelzpp": 974069707,
    "dropphyadd": "3996 COUGAR LN",
    "dropphycty": "AGNESS",
    "dropphyst": "OR",
    "dropphyzpp": 974069707,
    "dropmaladd": "3996 COUGAR LN",
    "dropmalcty": "AGNESS",
    "dropmalst": "OR",
    "dropmalzpp": 974069998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412478505,
    "dropsitcph": 5412478505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14717",
    "droptype": "D",
    "dropname": "ALBANY",
    "dropdeladd": "525 2ND AVE SW",
    "dropdelcty": "ALBANY",
    "dropdelst": "OR",
    "dropdelzpp": 973212238,
    "dropphyadd": "525 2ND AVE SW",
    "dropphycty": "ALBANY",
    "dropphyst": "OR",
    "dropphyzpp": 973212238,
    "dropmaladd": "525 2ND AVE SW",
    "dropmalcty": "ALBANY",
    "dropmalst": "OR",
    "dropmalzpp": 973219998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419268829,
    "dropsitcph": 5419249691,
    "dropfax": 5419283915
  },
  {
    "dcode": "D",
    "dropkey": "PZ14720",
    "droptype": "D",
    "dropname": "ALLEGANY",
    "dropdeladd": "10361 HIGHWAY 241",
    "dropdelcty": "ALLEGANY",
    "dropdelst": "OR",
    "dropdelzpp": 974079700,
    "dropphyadd": "10361 HIGHWAY 241",
    "dropphycty": "ALLEGANY",
    "dropphyst": "OR",
    "dropphyzpp": 974079700,
    "dropmaladd": "10361 HIGHWAY 241",
    "dropmalcty": "ALLEGANY",
    "dropmalst": "OR",
    "dropmalzpp": 974079998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412692039,
    "dropsitcph": 5412692039,
    "dropfax": 5412692039
  },
  {
    "dcode": "D",
    "dropkey": "PZ14724",
    "droptype": "D",
    "dropname": "ALSEA",
    "dropdeladd": "140 E MAIN ST",
    "dropdelcty": "ALSEA",
    "dropdelst": "OR",
    "dropdelzpp": 973249407,
    "dropphyadd": "140 E MAIN ST",
    "dropphycty": "ALSEA",
    "dropphyst": "OR",
    "dropphyzpp": 973249407,
    "dropmaladd": "140 E MAIN ST",
    "dropmalcty": "ALSEA",
    "dropmalst": "OR",
    "dropmalzpp": 973249998,
    "dropsitphn": 5412942242,
    "dropsitlph": 5034875981,
    "dropsitcph": 5414875981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14726",
    "droptype": "D",
    "dropname": "ALVADORE",
    "dropdeladd": "90828 RAILROAD ST",
    "dropdelcty": "ALVADORE",
    "dropdelst": "OR",
    "dropdelzpp": 974099700,
    "dropphyadd": "90828 RAILROAD ST",
    "dropphycty": "ALVADORE",
    "dropphyst": "OR",
    "dropphyzpp": 974099700,
    "dropmaladd": "90828 RAILROAD ST",
    "dropmalcty": "ALVADORE",
    "dropmalst": "OR",
    "dropmalzpp": 974099998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416880936,
    "dropsitcph": 5416880936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14728",
    "droptype": "D",
    "dropname": "AMITY",
    "dropdeladd": "105 WOODSON ST",
    "dropdelcty": "AMITY",
    "dropdelst": "OR",
    "dropdelzpp": 971012820,
    "dropphyadd": "105 WOODSON ST",
    "dropphycty": "AMITY",
    "dropphyst": "OR",
    "dropphyzpp": 971012820,
    "dropmaladd": "105 WOODSON ST",
    "dropmalcty": "AMITY",
    "dropmalst": "OR",
    "dropmalzpp": 971019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 9712673326,
    "dropsitcph": 5038356029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14730",
    "droptype": "D",
    "dropname": "ANTELOPE",
    "dropdeladd": "45404 MAIN ST",
    "dropdelcty": "ANTELOPE",
    "dropdelst": "OR",
    "dropdelzpp": 970017001,
    "dropphyadd": "45404 MAIN ST",
    "dropphycty": "ANTELOPE",
    "dropphyst": "OR",
    "dropphyzpp": 970017001,
    "dropmaladd": "45404 MAIN ST",
    "dropmalcty": "ANTELOPE",
    "dropmalst": "OR",
    "dropmalzpp": 970019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416512064,
    "dropsitcph": 5416512064,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14735",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "300 ARLINGTON MALL",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "OR",
    "dropdelzpp": 978125000,
    "dropphyadd": "300 ARLINGTON MALL",
    "dropphycty": "ARLINGTON",
    "dropphyst": "OR",
    "dropphyzpp": 978125000,
    "dropmaladd": "300 ARLINGTON MALL",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "OR",
    "dropmalzpp": 978125000,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414542651,
    "dropsitcph": 5414542651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14736",
    "droptype": "D",
    "dropname": "AROCK",
    "dropdeladd": "3070 OREGON AVE",
    "dropdelcty": "AROCK",
    "dropdelst": "OR",
    "dropdelzpp": 979025000,
    "dropphyadd": "3070 OREGON AVE",
    "dropphycty": "AROCK",
    "dropphyst": "OR",
    "dropphyzpp": 979025000,
    "dropmaladd": "3070 OREGON AVE",
    "dropmalcty": "AROCK",
    "dropmalst": "OR",
    "dropmalzpp": 979029998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415862941,
    "dropsitcph": 5415862941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14737",
    "droptype": "D",
    "dropname": "ASHLAND",
    "dropdeladd": "120 N 1ST ST",
    "dropdelcty": "ASHLAND",
    "dropdelst": "OR",
    "dropdelzpp": 975201900,
    "dropphyadd": "120 N 1ST ST",
    "dropphycty": "ASHLAND",
    "dropphyst": "OR",
    "dropphyzpp": 975201900,
    "dropmaladd": "120 N 1ST ST",
    "dropmalcty": "ASHLAND",
    "dropmalst": "OR",
    "dropmalzpp": 975209998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414823998,
    "dropsitcph": 5415521622,
    "dropfax": 5414885549
  },
  {
    "dcode": "D",
    "dropkey": "PZ14740",
    "droptype": "D",
    "dropname": "ASTORIA",
    "dropdeladd": "750 COMMERCIAL ST",
    "dropdelcty": "ASTORIA",
    "dropdelst": "OR",
    "dropdelzpp": 971034543,
    "dropphyadd": "750 COMMERCIAL ST",
    "dropphycty": "ASTORIA",
    "dropphyst": "OR",
    "dropphyzpp": 971034543,
    "dropmaladd": "750 COMMERCIAL ST STE 104",
    "dropmalcty": "ASTORIA",
    "dropmalst": "OR",
    "dropmalzpp": 971039998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033380319,
    "dropsitcph": 5033380316,
    "dropfax": 5033386404
  },
  {
    "dcode": "D",
    "dropkey": "PZ14741",
    "droptype": "D",
    "dropname": "ATHENA",
    "dropdeladd": "345 E MAIN ST",
    "dropdelcty": "ATHENA",
    "dropdelst": "OR",
    "dropdelzpp": 978136074,
    "dropphyadd": "345 E MAIN ST",
    "dropphycty": "ATHENA",
    "dropphyst": "OR",
    "dropphyzpp": 978136074,
    "dropmaladd": "345 E MAIN ST",
    "dropmalcty": "ATHENA",
    "dropmalst": "OR",
    "dropmalzpp": 978139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415662261,
    "dropsitcph": 5415662261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14742",
    "droptype": "D",
    "dropname": "AUMSVILLE",
    "dropdeladd": "320 MAIN ST",
    "dropdelcty": "AUMSVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 973259809,
    "dropphyadd": "320 MAIN ST",
    "dropphycty": "AUMSVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 973259809,
    "dropmaladd": "320 MAIN ST",
    "dropmalcty": "AUMSVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 973259998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037491133,
    "dropsitcph": 5037499172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14743",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "14682 OTTAWAY RD NE",
    "dropdelcty": "AURORA",
    "dropdelst": "OR",
    "dropdelzpp": 970027002,
    "dropphyadd": "14682 OTTAWAY RD NE",
    "dropphycty": "AURORA",
    "dropphyst": "OR",
    "dropphyzpp": 970027002,
    "dropmaladd": "14682 OTTAWAY RD NE",
    "dropmalcty": "AURORA",
    "dropmalst": "OR",
    "dropmalzpp": 970029998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036781778,
    "dropsitcph": 5036786395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14744",
    "droptype": "D",
    "dropname": "AZALEA",
    "dropdeladd": "490 AZALEA GLEN RD",
    "dropdelcty": "AZALEA",
    "dropdelst": "OR",
    "dropdelzpp": 974109736,
    "dropphyadd": "490 AZALEA GLEN RD",
    "dropphycty": "AZALEA",
    "dropphyst": "OR",
    "dropphyzpp": 974109736,
    "dropmaladd": "490 AZALEA GLEN RD",
    "dropmalcty": "AZALEA",
    "dropmalst": "OR",
    "dropmalzpp": 974109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418371183,
    "dropsitcph": 5418371183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14746",
    "droptype": "D",
    "dropname": "BAKER CITY",
    "dropdeladd": "1550 DEWEY AVE",
    "dropdelcty": "BAKER CITY",
    "dropdelst": "OR",
    "dropdelzpp": 978143840,
    "dropphyadd": "1550 DEWEY AVE",
    "dropphycty": "BAKER CITY",
    "dropphyst": "OR",
    "dropphyzpp": 978143840,
    "dropmaladd": "1550 DEWEY AVE",
    "dropmalcty": "BAKER CITY",
    "dropmalst": "OR",
    "dropmalzpp": 978149998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415238593,
    "dropsitcph": 5415238593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14749",
    "droptype": "D",
    "dropname": "BANDON",
    "dropdeladd": "105 12TH ST SE",
    "dropdelcty": "BANDON",
    "dropdelst": "OR",
    "dropdelzpp": 974119062,
    "dropphyadd": "105 12TH ST SE",
    "dropphycty": "BANDON",
    "dropphyst": "OR",
    "dropphyzpp": 974119062,
    "dropmaladd": "105 12TH ST SE",
    "dropmalcty": "BANDON",
    "dropmalst": "OR",
    "dropmalzpp": 974119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413472495,
    "dropsitcph": 5413471160,
    "dropfax": 5413479257
  },
  {
    "dcode": "D",
    "dropkey": "PZ14750",
    "droptype": "D",
    "dropname": "BANKS",
    "dropdeladd": "42355 NW OAK WAY",
    "dropdelcty": "BANKS",
    "dropdelst": "OR",
    "dropdelzpp": 971066021,
    "dropphyadd": "42355 NW OAK WAY",
    "dropphycty": "BANKS",
    "dropphyst": "OR",
    "dropphyzpp": 971066021,
    "dropmaladd": "42355 NW OAK WAY",
    "dropmalcty": "BANKS",
    "dropmalst": "OR",
    "dropmalzpp": 971069998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033246391,
    "dropsitcph": 5033248029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14756",
    "droptype": "D",
    "dropname": "BEATTY",
    "dropdeladd": "24199 GODOWA SPRINGS RD",
    "dropdelcty": "BEATTY",
    "dropdelst": "OR",
    "dropdelzpp": 976219707,
    "dropphyadd": "24199 GODOWA SPRINGS RD",
    "dropphycty": "BEATTY",
    "dropphyst": "OR",
    "dropphyzpp": 976219707,
    "dropmaladd": "24199 GODOWA SPRINGS RD",
    "dropmalcty": "BEATTY",
    "dropmalst": "OR",
    "dropmalzpp": 976219998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415332292,
    "dropsitcph": 5415332292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14759",
    "droptype": "D",
    "dropname": "BEAVERCREEK",
    "dropdeladd": "16101 S LELAND RD",
    "dropdelcty": "BEAVERCREEK",
    "dropdelst": "OR",
    "dropdelzpp": 970047004,
    "dropphyadd": "16101 S LELAND RD",
    "dropphycty": "BEAVERCREEK",
    "dropphyst": "OR",
    "dropphyzpp": 970047004,
    "dropmaladd": "16101 S LELAND RD",
    "dropmalcty": "BEAVERCREEK",
    "dropmalst": "OR",
    "dropmalzpp": 970047004,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036328267,
    "dropsitcph": 5036323357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14760",
    "droptype": "D",
    "dropname": "BEAVERTON",
    "dropdeladd": "4550 SW BETTS AVE",
    "dropdelcty": "BEAVERTON",
    "dropdelst": "OR",
    "dropdelzpp": 970052869,
    "dropphyadd": "4550 SW BETTS AVE",
    "dropphycty": "BEAVERTON",
    "dropphyst": "OR",
    "dropphyzpp": 970052869,
    "dropmaladd": "4550 SW BETTS AVE",
    "dropmalcty": "BEAVERTON",
    "dropmalst": "OR",
    "dropmalzpp": 970059998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036463198,
    "dropsitcph": 5036435263,
    "dropfax": 5036439729
  },
  {
    "dcode": "D",
    "dropkey": "PZ14765",
    "droptype": "D",
    "dropname": "BEND",
    "dropdeladd": "2300 NE 4TH ST",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977013615,
    "dropphyadd": "2300 NE 4TH ST",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977013615,
    "dropmaladd": "2300 NE 4TH ST",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413882427,
    "dropsitcph": 5413185068,
    "dropfax": 5413178612
  },
  {
    "dcode": "D",
    "dropkey": "PZ14777",
    "droptype": "D",
    "dropname": "BLODGETT",
    "dropdeladd": "21412 HIGHWAY 20",
    "dropdelcty": "BLODGETT",
    "dropdelst": "OR",
    "dropdelzpp": 973269604,
    "dropphyadd": "21412 HIGHWAY 20",
    "dropphycty": "BLODGETT",
    "dropphyst": "OR",
    "dropphyzpp": 973269604,
    "dropmaladd": "21412 HIGHWAY 20",
    "dropmalcty": "BLODGETT",
    "dropmalst": "OR",
    "dropmalzpp": 973269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414535771,
    "dropsitcph": 5414535771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14779",
    "droptype": "D",
    "dropname": "BLUE RIVER",
    "dropdeladd": "91160 MCCAULEY ST",
    "dropdelcty": "BLUE RIVER",
    "dropdelst": "OR",
    "dropdelzpp": 974139737,
    "dropphyadd": "91160 MCCAULEY ST",
    "dropphycty": "BLUE RIVER",
    "dropphyst": "OR",
    "dropphyzpp": 974139737,
    "dropmaladd": "91160 MCCAULEY ST",
    "dropmalcty": "BLUE RIVER",
    "dropmalst": "OR",
    "dropmalzpp": 974139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418223305,
    "dropsitcph": 5418223305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14780",
    "droptype": "D",
    "dropname": "BLY",
    "dropdeladd": "61133 HWY 140 E",
    "dropdelcty": "BLY",
    "dropdelst": "OR",
    "dropdelzpp": 976229700,
    "dropphyadd": "61133 HWY 140 E",
    "dropphycty": "BLY",
    "dropphyst": "OR",
    "dropphyzpp": 976229700,
    "dropmaladd": "61133 HWY 140 E",
    "dropmalcty": "BLY",
    "dropmalst": "OR",
    "dropmalzpp": 976229998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413532521,
    "dropsitcph": 5413532521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14781",
    "droptype": "D",
    "dropname": "BOARDMAN",
    "dropdeladd": "200 NW 1ST ST",
    "dropdelcty": "BOARDMAN",
    "dropdelst": "OR",
    "dropdelzpp": 978189724,
    "dropphyadd": "200 NW 1ST ST",
    "dropphycty": "BOARDMAN",
    "dropphyst": "OR",
    "dropphyzpp": 978189724,
    "dropmaladd": "200 NW 1ST ST",
    "dropmalcty": "BOARDMAN",
    "dropmalst": "OR",
    "dropmalzpp": 978189998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414814925,
    "dropsitcph": 5414814925,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14782",
    "droptype": "D",
    "dropname": "BONANZA",
    "dropdeladd": "2899 MARKET ST",
    "dropdelcty": "BONANZA",
    "dropdelst": "OR",
    "dropdelzpp": 976237725,
    "dropphyadd": "2899 MARKET ST",
    "dropphycty": "BONANZA",
    "dropphyst": "OR",
    "dropphyzpp": 976237725,
    "dropmaladd": "2899 MARKET ST",
    "dropmalcty": "BONANZA",
    "dropmalst": "OR",
    "dropmalzpp": 976239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415456342,
    "dropsitcph": 5412389467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14785",
    "droptype": "D",
    "dropname": "BORING",
    "dropdeladd": "28515 SE HIGHWAY 212",
    "dropdelcty": "BORING",
    "dropdelst": "OR",
    "dropdelzpp": 970099009,
    "dropphyadd": "28515 SE HIGHWAY 212",
    "dropphycty": "BORING",
    "dropphyst": "OR",
    "dropphyzpp": 970099009,
    "dropmaladd": "28515 SE HIGHWAY 212",
    "dropmalcty": "BORING",
    "dropmalst": "OR",
    "dropmalzpp": 970099998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033287440,
    "dropsitcph": 5036630289,
    "dropfax": 5036635322
  },
  {
    "dcode": "D",
    "dropkey": "PZ14789",
    "droptype": "D",
    "dropname": "BRIDAL VEIL",
    "dropdeladd": "47100 W MILL RD",
    "dropdelcty": "BRIDAL VEIL",
    "dropdelst": "OR",
    "dropdelzpp": 970107010,
    "dropphyadd": "47100 W MILL RD",
    "dropphycty": "BRIDAL VEIL",
    "dropphyst": "OR",
    "dropphyzpp": 970107010,
    "dropmaladd": "47100 W MILL RD",
    "dropmalcty": "BRIDAL VEIL",
    "dropmalst": "OR",
    "dropmalzpp": 970109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036952380,
    "dropsitcph": 5036952380,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14793",
    "droptype": "D",
    "dropname": "BRIGHTWOOD",
    "dropdeladd": "20275 E AMBROSE ST",
    "dropdelcty": "BRIGHTWOOD",
    "dropdelst": "OR",
    "dropdelzpp": 970117011,
    "dropphyadd": "20275 E AMBROSE ST",
    "dropphycty": "BRIGHTWOOD",
    "dropphyst": "OR",
    "dropphyzpp": 970117011,
    "dropmaladd": "20275 E AMBROSE ST",
    "dropmalcty": "BRIGHTWOOD",
    "dropmalst": "OR",
    "dropmalzpp": 970119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036224284,
    "dropsitcph": 5036224277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14794",
    "droptype": "D",
    "dropname": "BROADBENT",
    "dropdeladd": "51008 DEMENT CREEK RD",
    "dropdelcty": "BROADBENT",
    "dropdelst": "OR",
    "dropdelzpp": 974149714,
    "dropphyadd": "51008 DEMENT CREEK RD",
    "dropphycty": "BROADBENT",
    "dropphyst": "OR",
    "dropphyzpp": 974149714,
    "dropmaladd": "51008 DEMENT CREEK RD",
    "dropmalcty": "BROADBENT",
    "dropmalst": "OR",
    "dropmalzpp": 974149714,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415722995,
    "dropsitcph": 5415722995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14797",
    "droptype": "D",
    "dropname": "BROOKINGS",
    "dropdeladd": "711 SPRUCE ST",
    "dropdelcty": "BROOKINGS",
    "dropdelst": "OR",
    "dropdelzpp": 974157900,
    "dropphyadd": "711 SPRUCE ST",
    "dropphycty": "BROOKINGS",
    "dropphyst": "OR",
    "dropphyzpp": 974157900,
    "dropmaladd": "711 SPRUCE ST",
    "dropmalcty": "BROOKINGS",
    "dropmalst": "OR",
    "dropmalzpp": 974159998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414120591,
    "dropsitcph": 5414127048,
    "dropfax": 5414120822
  },
  {
    "dcode": "D",
    "dropkey": "PZ14800",
    "droptype": "D",
    "dropname": "BROTHERS",
    "dropdeladd": "34100 E HIGHWAY 20",
    "dropdelcty": "BROTHERS",
    "dropdelst": "OR",
    "dropdelzpp": 977129701,
    "dropphyadd": "34100 E HIGHWAY 20",
    "dropphycty": "BROTHERS",
    "dropphyst": "OR",
    "dropphyzpp": 977129701,
    "dropmaladd": "34100 E HIGHWAY 20",
    "dropmalcty": "BROTHERS",
    "dropmalst": "OR",
    "dropmalzpp": 977129998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415762795,
    "dropsitcph": 5415762795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14802",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "430 N MAIN ST",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 973272147,
    "dropphyadd": "430 N MAIN ST",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 973272147,
    "dropmaladd": "430 N MAIN ST",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 973279998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414663524,
    "dropsitcph": 5414665937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14808",
    "droptype": "D",
    "dropname": "BURNS",
    "dropdeladd": "100 S BROADWAY AVE",
    "dropdelcty": "BURNS",
    "dropdelst": "OR",
    "dropdelzpp": 977202203,
    "dropphyadd": "100 S BROADWAY AVE",
    "dropphycty": "BURNS",
    "dropphyst": "OR",
    "dropphyzpp": 977202203,
    "dropmaladd": "100 S BROADWAY AVE",
    "dropmalcty": "BURNS",
    "dropmalst": "OR",
    "dropmalzpp": 977209998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415734228,
    "dropsitcph": 5415731720,
    "dropfax": 6513066545
  },
  {
    "dcode": "D",
    "dropkey": "PZ14812",
    "droptype": "D",
    "dropname": "BUTTE FALLS",
    "dropdeladd": "355 BROAD ST",
    "dropdelcty": "BUTTE FALLS",
    "dropdelst": "OR",
    "dropdelzpp": 975229707,
    "dropphyadd": "355 BROAD ST",
    "dropphycty": "BUTTE FALLS",
    "dropphyst": "OR",
    "dropphyzpp": 975229707,
    "dropmaladd": "355 BROAD ST",
    "dropmalcty": "BUTTE FALLS",
    "dropmalst": "OR",
    "dropmalzpp": 975229998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418653372,
    "dropsitcph": 5418653372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14820",
    "droptype": "D",
    "dropname": "CAMP SHERMAN",
    "dropdeladd": "25453 SW FOREST SERVICE RD",
    "dropdelcty": "CAMP SHERMAN",
    "dropdelst": "OR",
    "dropdelzpp": 977309702,
    "dropphyadd": "25453 SW FOREST SERVICE RD",
    "dropphycty": "CAMP SHERMAN",
    "dropphyst": "OR",
    "dropphyzpp": 977309702,
    "dropmaladd": "25453 SW FOREST SERVICE RD",
    "dropmalcty": "CAMP SHERMAN",
    "dropmalst": "OR",
    "dropmalzpp": 977309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415956868,
    "dropsitcph": 5415956868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14823",
    "droptype": "D",
    "dropname": "CANBY",
    "dropdeladd": "615 NW 2ND AVE",
    "dropdelcty": "CANBY",
    "dropdelst": "OR",
    "dropdelzpp": 970133434,
    "dropphyadd": "615 NW 2ND AVE",
    "dropphycty": "CANBY",
    "dropphyst": "OR",
    "dropphyzpp": 970133434,
    "dropmaladd": "615 NW 2ND AVE",
    "dropmalcty": "CANBY",
    "dropmalst": "OR",
    "dropmalzpp": 970139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032667720,
    "dropsitcph": 5032663353,
    "dropfax": 5032663453
  },
  {
    "dcode": "D",
    "dropkey": "PZ14824",
    "droptype": "D",
    "dropname": "CANNON BEACH",
    "dropdeladd": "163 N HEMLOCK",
    "dropdelcty": "CANNON BEACH",
    "dropdelst": "OR",
    "dropdelzpp": 971109800,
    "dropphyadd": "163 N HEMLOCK",
    "dropphycty": "CANNON BEACH",
    "dropphyst": "OR",
    "dropphyzpp": 971109800,
    "dropmaladd": "163 N HEMLOCK",
    "dropmalcty": "CANNON BEACH",
    "dropmalst": "OR",
    "dropmalzpp": 971109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5034362822,
    "dropsitcph": 5034362822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14825",
    "droptype": "D",
    "dropname": "CANYON CITY",
    "dropdeladd": "101 S CLARK ST",
    "dropdelcty": "CANYON CITY",
    "dropdelst": "OR",
    "dropdelzpp": 978206188,
    "dropphyadd": "101 S CLARK ST",
    "dropphycty": "CANYON CITY",
    "dropphyst": "OR",
    "dropphyzpp": 978206188,
    "dropmaladd": "101 S CLARK ST",
    "dropmalcty": "CANYON CITY",
    "dropmalst": "OR",
    "dropmalzpp": 978206188,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415751306,
    "dropsitcph": 5415751306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14826",
    "droptype": "D",
    "dropname": "CANYONVILLE",
    "dropdeladd": "131 SE 2ND ST",
    "dropdelcty": "CANYONVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 974179703,
    "dropphyadd": "131 SE 2ND ST",
    "dropphycty": "CANYONVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 974179703,
    "dropmaladd": "131 SE 2ND ST",
    "dropmalcty": "CANYONVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 974179998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418394832,
    "dropsitcph": 5418394832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14830",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "438 W MAIN ST",
    "dropdelcty": "CARLTON",
    "dropdelst": "OR",
    "dropdelzpp": 971119104,
    "dropphyadd": "438 W MAIN ST",
    "dropphycty": "CARLTON",
    "dropphyst": "OR",
    "dropphyzpp": 971119104,
    "dropmaladd": "438 W MAIN ST",
    "dropmalcty": "CARLTON",
    "dropmalst": "OR",
    "dropmalzpp": 971119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038526289,
    "dropsitcph": 5038526874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14834",
    "droptype": "D",
    "dropname": "CASCADE LOCKS",
    "dropdeladd": "461 NW WANAPA ST",
    "dropdelcty": "CASCADE LOCKS",
    "dropdelst": "OR",
    "dropdelzpp": 970147014,
    "dropphyadd": "461 NW WANAPA ST",
    "dropphycty": "CASCADE LOCKS",
    "dropphyst": "OR",
    "dropphyzpp": 970147014,
    "dropmaladd": "461 NW WANAPA ST",
    "dropmalcty": "CASCADE LOCKS",
    "dropmalst": "OR",
    "dropmalzpp": 970147014,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413748923,
    "dropsitcph": 5413745026,
    "dropfax": 5413748134
  },
  {
    "dcode": "D",
    "dropkey": "PZ14839",
    "droptype": "D",
    "dropname": "CAVE JUNCTION",
    "dropdeladd": "102 S HUSSEY AVE",
    "dropdelcty": "CAVE JUNCTION",
    "dropdelst": "OR",
    "dropdelzpp": 975239372,
    "dropphyadd": "102 S HUSSEY AVE",
    "dropphycty": "CAVE JUNCTION",
    "dropphyst": "OR",
    "dropphyzpp": 975239372,
    "dropmaladd": "102 S HUSSEY AVE",
    "dropmalcty": "CAVE JUNCTION",
    "dropmalst": "OR",
    "dropmalzpp": 975239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415923709,
    "dropsitcph": 5415923709,
    "dropfax": 5415926726
  },
  {
    "dcode": "D",
    "dropkey": "PZ14855",
    "droptype": "D",
    "dropname": "CHEMULT",
    "dropdeladd": "125 G C PALMER ST",
    "dropdelcty": "CHEMULT",
    "dropdelst": "OR",
    "dropdelzpp": 977319733,
    "dropphyadd": "125 G C PALMER ST",
    "dropphycty": "CHEMULT",
    "dropphyst": "OR",
    "dropphyzpp": 977319733,
    "dropmaladd": "125 G C PALMER ST",
    "dropmalcty": "CHEMULT",
    "dropmalst": "OR",
    "dropmalzpp": 977319733,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413654411,
    "dropsitcph": 5413654411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14856",
    "droptype": "D",
    "dropname": "CHESHIRE",
    "dropdeladd": "27071 HIGHWAY 36",
    "dropdelcty": "CHESHIRE",
    "dropdelst": "OR",
    "dropdelzpp": 974199752,
    "dropphyadd": "27071 HIGHWAY 36",
    "dropphycty": "CHESHIRE",
    "dropphyst": "OR",
    "dropphyzpp": 974199752,
    "dropmaladd": "27071 HIGHWAY 36",
    "dropmalcty": "CHESHIRE",
    "dropmalst": "OR",
    "dropmalzpp": 974199998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419988381,
    "dropsitcph": 5419988381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14857",
    "droptype": "D",
    "dropname": "CHILOQUIN",
    "dropdeladd": "228 S 1ST AVE",
    "dropdelcty": "CHILOQUIN",
    "dropdelst": "OR",
    "dropdelzpp": 976249720,
    "dropphyadd": "228 S 1ST AVE",
    "dropphycty": "CHILOQUIN",
    "dropphyst": "OR",
    "dropphyzpp": 976249720,
    "dropmaladd": "228 S 1ST AVE",
    "dropmalcty": "CHILOQUIN",
    "dropmalst": "OR",
    "dropmalzpp": 976249998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417832745,
    "dropsitcph": 5417832745,
    "dropfax": 5417833625
  },
  {
    "dcode": "D",
    "dropkey": "PZ14861",
    "droptype": "D",
    "dropname": "CLACKAMAS",
    "dropdeladd": "9009 SE ADAMS ST",
    "dropdelcty": "CLACKAMAS",
    "dropdelst": "OR",
    "dropdelzpp": 970159594,
    "dropphyadd": "9009 SE ADAMS ST",
    "dropphycty": "CLACKAMAS",
    "dropphyst": "OR",
    "dropphyzpp": 970159594,
    "dropmaladd": "9009 SE ADAMS ST",
    "dropmalcty": "CLACKAMAS",
    "dropmalst": "OR",
    "dropmalzpp": 970159998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036559685,
    "dropsitcph": 5036579358,
    "dropfax": 5035570197
  },
  {
    "dcode": "D",
    "dropkey": "PZ14864",
    "droptype": "D",
    "dropname": "CLATSKANIE",
    "dropdeladd": "90 SW BELAIR DR",
    "dropdelcty": "CLATSKANIE",
    "dropdelst": "OR",
    "dropdelzpp": 970169800,
    "dropphyadd": "90 SW BELAIR DR",
    "dropphycty": "CLATSKANIE",
    "dropphyst": "OR",
    "dropphyzpp": 970169800,
    "dropmaladd": "90 SW BELAIR DR",
    "dropmalcty": "CLATSKANIE",
    "dropmalst": "OR",
    "dropmalzpp": 970169998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037282797,
    "dropsitcph": 5037284797,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14867",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "34480 HIGHWAY 101 S",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "OR",
    "dropdelzpp": 971129555,
    "dropphyadd": "34480 HIGHWAY 101 S",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "OR",
    "dropphyzpp": 971129555,
    "dropmaladd": "34480 HIGHWAY 101 S",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "OR",
    "dropmalzpp": 971129998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033923393,
    "dropsitcph": 5033923393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14872",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "20980 S HIGHWAY 211",
    "dropdelcty": "COLTON",
    "dropdelst": "OR",
    "dropdelzpp": 970177017,
    "dropphyadd": "20980 S HIGHWAY 211",
    "dropphycty": "COLTON",
    "dropphyst": "OR",
    "dropphyzpp": 970177017,
    "dropmaladd": "20980 S HIGHWAY 211",
    "dropmalcty": "COLTON",
    "dropmalst": "OR",
    "dropmalzpp": 970179998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038246222,
    "dropsitcph": 5038246222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14873",
    "droptype": "D",
    "dropname": "COLUMBIA CITY",
    "dropdeladd": "1905 2ND ST",
    "dropdelcty": "COLUMBIA CITY",
    "dropdelst": "OR",
    "dropdelzpp": 970189600,
    "dropphyadd": "1905 2ND ST",
    "dropphycty": "COLUMBIA CITY",
    "dropphyst": "OR",
    "dropphyzpp": 970189600,
    "dropmaladd": "1905 2ND ST",
    "dropmalcty": "COLUMBIA CITY",
    "dropmalst": "OR",
    "dropmalzpp": 970189998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033970089,
    "dropsitcph": 5033970089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14874",
    "droptype": "D",
    "dropname": "CONDON",
    "dropdeladd": "330 S MAIN ST",
    "dropdelcty": "CONDON",
    "dropdelst": "OR",
    "dropdelzpp": 978235000,
    "dropphyadd": "330 S MAIN ST",
    "dropphycty": "CONDON",
    "dropphyst": "OR",
    "dropphyzpp": 978235000,
    "dropmaladd": "330 S MAIN ST",
    "dropmalcty": "CONDON",
    "dropmalst": "OR",
    "dropmalzpp": 978239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413843833,
    "dropsitcph": 5413843833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14875",
    "droptype": "D",
    "dropname": "COOS BAY",
    "dropdeladd": "470 GOLDEN AVE",
    "dropdelcty": "COOS BAY",
    "dropdelst": "OR",
    "dropdelzpp": 974201573,
    "dropphyadd": "470 GOLDEN AVE",
    "dropphycty": "COOS BAY",
    "dropphyst": "OR",
    "dropphyzpp": 974201573,
    "dropmaladd": "470 GOLDEN AVE",
    "dropmalcty": "COOS BAY",
    "dropmalst": "OR",
    "dropmalzpp": 974201573,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412675122,
    "dropsitcph": 5412670379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14878",
    "droptype": "D",
    "dropname": "COQUILLE",
    "dropdeladd": "75 N BIRCH ST",
    "dropdelcty": "COQUILLE",
    "dropdelst": "OR",
    "dropdelzpp": 974231287,
    "dropphyadd": "75 N BIRCH ST",
    "dropphycty": "COQUILLE",
    "dropphyst": "OR",
    "dropphyzpp": 974231287,
    "dropmaladd": "75 N BIRCH ST",
    "dropmalcty": "COQUILLE",
    "dropmalst": "OR",
    "dropmalzpp": 974239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413964281,
    "dropsitcph": 5413963549,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14879",
    "droptype": "D",
    "dropname": "CORBETT",
    "dropdeladd": "36046 E HISTORIC COLUMBIA RIVER HWY",
    "dropdelcty": "CORBETT",
    "dropdelst": "OR",
    "dropdelzpp": 970197019,
    "dropphyadd": "36046 E HISTORIC COLUMBIA RIVER HWY",
    "dropphycty": "CORBETT",
    "dropphyst": "OR",
    "dropphyzpp": 970197019,
    "dropmaladd": "36046 E HISTORIC COLUMBIA RIVER HWY",
    "dropmalcty": "CORBETT",
    "dropmalst": "OR",
    "dropmalzpp": 970199998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036952510,
    "dropsitcph": 5036952510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14880",
    "droptype": "D",
    "dropname": "CORNELIUS",
    "dropdeladd": "1639 BASELINE ST",
    "dropdelcty": "CORNELIUS",
    "dropdelst": "OR",
    "dropdelzpp": 971138813,
    "dropphyadd": "1639 BASELINE ST",
    "dropphycty": "CORNELIUS",
    "dropphyst": "OR",
    "dropphyzpp": 971138813,
    "dropmaladd": "1639 BASELINE ST",
    "dropmalcty": "CORNELIUS",
    "dropmalst": "OR",
    "dropmalzpp": 971139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033577738,
    "dropsitcph": 5039929003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14882",
    "droptype": "D",
    "dropname": "CORVALLIS",
    "dropdeladd": "311 SW 2ND ST",
    "dropdelcty": "CORVALLIS",
    "dropdelst": "OR",
    "dropdelzpp": 973334631,
    "dropphyadd": "311 SW 2ND ST",
    "dropphycty": "CORVALLIS",
    "dropphyst": "OR",
    "dropphyzpp": 973334631,
    "dropmaladd": "311 SW 2ND ST",
    "dropmalcty": "CORVALLIS",
    "dropmalst": "OR",
    "dropmalzpp": 973339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417583046,
    "dropsitcph": 5417524358,
    "dropfax": 5417528207
  },
  {
    "dcode": "D",
    "dropkey": "PZ14883",
    "droptype": "D",
    "dropname": "COTTAGE GROVE",
    "dropdeladd": "115 N 14TH ST",
    "dropdelcty": "COTTAGE GROVE",
    "dropdelst": "OR",
    "dropdelzpp": 974242210,
    "dropphyadd": "115 N 14TH ST",
    "dropphycty": "COTTAGE GROVE",
    "dropphyst": "OR",
    "dropphyzpp": 974242210,
    "dropmaladd": "115 N 14TH ST",
    "dropmalcty": "COTTAGE GROVE",
    "dropmalst": "OR",
    "dropmalzpp": 974242210,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419426969,
    "dropsitcph": 5419422232,
    "dropfax": 5419425566
  },
  {
    "dcode": "D",
    "dropkey": "PZ14886",
    "droptype": "D",
    "dropname": "COVE",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "COVE",
    "dropdelst": "OR",
    "dropdelzpp": 978248429,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "COVE",
    "dropphyst": "OR",
    "dropphyzpp": 978248429,
    "dropmaladd": "601 MAIN ST",
    "dropmalcty": "COVE",
    "dropmalst": "OR",
    "dropmalzpp": 978249998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415684533,
    "dropsitcph": 5415684533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14887",
    "droptype": "D",
    "dropname": "CRABTREE",
    "dropdeladd": "37640 CRABTREE DR",
    "dropdelcty": "CRABTREE",
    "dropdelst": "OR",
    "dropdelzpp": 973351111,
    "dropphyadd": "37640 CRABTREE DR",
    "dropphycty": "CRABTREE",
    "dropphyst": "OR",
    "dropphyzpp": 973351111,
    "dropmaladd": "37640 CRABTREE DR",
    "dropmalcty": "CRABTREE",
    "dropmalst": "OR",
    "dropmalzpp": 973359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 9714335104,
    "dropsitcph": 9714335104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14888",
    "droptype": "D",
    "dropname": "CRANE",
    "dropdeladd": "43140 FOURTH ST",
    "dropdelcty": "CRANE",
    "dropdelst": "OR",
    "dropdelzpp": 977329802,
    "dropphyadd": "43140 FOURTH ST",
    "dropphycty": "CRANE",
    "dropphyst": "OR",
    "dropphyzpp": 977329802,
    "dropmaladd": "43140 FOURTH ST",
    "dropmalcty": "CRANE",
    "dropmalst": "OR",
    "dropmalzpp": 977329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414932003,
    "dropsitcph": 5414932003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14892",
    "droptype": "D",
    "dropname": "CRAWFORDSVILLE",
    "dropdeladd": "26064 1ST ST",
    "dropdelcty": "CRAWFORDSVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 973369700,
    "dropphyadd": "26064 1ST ST",
    "dropphycty": "CRAWFORDSVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 973369700,
    "dropmaladd": "26064 1ST ST",
    "dropmalcty": "CRAWFORDSVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 973369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413676713,
    "dropsitcph": 5413676713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14893",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "136728 MAIN ST",
    "dropdelcty": "CRESCENT",
    "dropdelst": "OR",
    "dropdelzpp": 977339702,
    "dropphyadd": "136728 MAIN ST",
    "dropphycty": "CRESCENT",
    "dropphyst": "OR",
    "dropphyzpp": 977339702,
    "dropmaladd": "136728 MAIN ST",
    "dropmalcty": "CRESCENT",
    "dropmalst": "OR",
    "dropmalzpp": 977339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414332238,
    "dropsitcph": 5414332238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14898",
    "droptype": "D",
    "dropname": "CRESWELL",
    "dropdeladd": "150 N MILL ST",
    "dropdelcty": "CRESWELL",
    "dropdelst": "OR",
    "dropdelzpp": 974269774,
    "dropphyadd": "150 N MILL ST",
    "dropphycty": "CRESWELL",
    "dropphyst": "OR",
    "dropphyzpp": 974269774,
    "dropmaladd": "150 N MILL ST",
    "dropmalcty": "CRESWELL",
    "dropmalst": "OR",
    "dropmalzpp": 974269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418954557,
    "dropsitcph": 5418953764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14907",
    "droptype": "D",
    "dropname": "CULVER",
    "dropdeladd": "200 W C ST",
    "dropdelcty": "CULVER",
    "dropdelst": "OR",
    "dropdelzpp": 977349753,
    "dropphyadd": "200 W C ST",
    "dropphycty": "CULVER",
    "dropphyst": "OR",
    "dropphyzpp": 977349753,
    "dropmaladd": "200 W C ST",
    "dropmalcty": "CULVER",
    "dropmalst": "OR",
    "dropmalzpp": 977349998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415460005,
    "dropsitcph": 5415460005,
    "dropfax": 5415463538
  },
  {
    "dcode": "D",
    "dropkey": "PZ14913",
    "droptype": "D",
    "dropname": "DALLAS",
    "dropdeladd": "768 SW CHURCH ST",
    "dropdelcty": "DALLAS",
    "dropdelst": "OR",
    "dropdelzpp": 973383102,
    "dropphyadd": "768 SW CHURCH ST",
    "dropphycty": "DALLAS",
    "dropphyst": "OR",
    "dropphyzpp": 973383102,
    "dropmaladd": "768 SW CHURCH ST",
    "dropmalcty": "DALLAS",
    "dropmalst": "OR",
    "dropmalzpp": 973389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036233835,
    "dropsitcph": 5038310050,
    "dropfax": 5036239059
  },
  {
    "dcode": "D",
    "dropkey": "PZ14918",
    "droptype": "D",
    "dropname": "DAYS CREEK",
    "dropdeladd": "11286 TILLER TRAIL HWY",
    "dropdelcty": "DAYS CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 974299756,
    "dropphyadd": "11286 TILLER TRAIL HWY",
    "dropphycty": "DAYS CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 974299756,
    "dropmaladd": "11286 TILLER TRAIL HWY",
    "dropmalcty": "DAYS CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 974299998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418253465,
    "dropsitcph": 5418253465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14920",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "530 FERRY ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OR",
    "dropdelzpp": 971149800,
    "dropphyadd": "530 FERRY ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OR",
    "dropphyzpp": 971149800,
    "dropmaladd": "530 FERRY ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OR",
    "dropmalzpp": 971149998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038643172,
    "dropsitcph": 5038649010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14921",
    "droptype": "D",
    "dropname": "DAYVILLE",
    "dropdeladd": "145 E FRANKLIN AVE",
    "dropdelcty": "DAYVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 978255000,
    "dropphyadd": "145 E FRANKLIN AVE",
    "dropphycty": "DAYVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 978255000,
    "dropmaladd": "145 E FRANKLIN AVE",
    "dropmalcty": "DAYVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 978259998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419872762,
    "dropsitcph": 5419872762,
    "dropfax": 5419872762
  },
  {
    "dcode": "D",
    "dropkey": "PZ14923",
    "droptype": "D",
    "dropname": "DEADWOOD",
    "dropdeladd": "14701 HIGHWAY 36",
    "dropdelcty": "DEADWOOD",
    "dropdelst": "OR",
    "dropdelzpp": 974309719,
    "dropphyadd": "14701 HIGHWAY 36",
    "dropphycty": "DEADWOOD",
    "dropphyst": "OR",
    "dropphyzpp": 974309719,
    "dropmaladd": "14701 HIGHWAY 36",
    "dropmalcty": "DEADWOOD",
    "dropmalst": "OR",
    "dropmalzpp": 974309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419645311,
    "dropsitcph": 5419645311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14929",
    "droptype": "D",
    "dropname": "DEPOE BAY",
    "dropdeladd": "486 N HIGHWAY 101",
    "dropdelcty": "DEPOE BAY",
    "dropdelst": "OR",
    "dropdelzpp": 973419801,
    "dropphyadd": "486 N HIGHWAY 101",
    "dropphycty": "DEPOE BAY",
    "dropphyst": "OR",
    "dropphyzpp": 973419801,
    "dropmaladd": "486 N HIGHWAY 101",
    "dropmalcty": "DEPOE BAY",
    "dropmalst": "OR",
    "dropmalzpp": 973419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417652480,
    "dropsitcph": 5417652480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14933",
    "droptype": "D",
    "dropname": "DETROIT",
    "dropdeladd": "170 DETROIT AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "OR",
    "dropdelzpp": 973429700,
    "dropphyadd": "170 DETROIT AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "OR",
    "dropphyzpp": 973429700,
    "dropmaladd": "170 DETROIT AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "OR",
    "dropmalzpp": 973429998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038543689,
    "dropsitcph": 5038543689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14936",
    "droptype": "D",
    "dropname": "DEXTER",
    "dropdeladd": "38880 DEXTER RD",
    "dropdelcty": "DEXTER",
    "dropdelst": "OR",
    "dropdelzpp": 974319775,
    "dropphyadd": "38880 DEXTER RD",
    "dropphycty": "DEXTER",
    "dropphyst": "OR",
    "dropphyzpp": 974319775,
    "dropmaladd": "38880 DEXTER RD",
    "dropmalcty": "DEXTER",
    "dropmalst": "OR",
    "dropmalzpp": 974319998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419373112,
    "dropsitcph": 5419373112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14940",
    "droptype": "D",
    "dropname": "DILLARD",
    "dropdeladd": "9455 OLD HWY 99 S",
    "dropdelcty": "DILLARD",
    "dropdelst": "OR",
    "dropdelzpp": 974329700,
    "dropphyadd": "9455 OLD HWY 99 S",
    "dropphycty": "DILLARD",
    "dropphyst": "OR",
    "dropphyzpp": 974329700,
    "dropmaladd": "9455 OLD HWY 99 S",
    "dropmalcty": "DILLARD",
    "dropmalst": "OR",
    "dropmalzpp": 974329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416795802,
    "dropsitcph": 5416795802,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14944",
    "droptype": "D",
    "dropname": "DONALD",
    "dropdeladd": "10751 MAIN ST NE",
    "dropdelcty": "DONALD",
    "dropdelst": "OR",
    "dropdelzpp": 970207020,
    "dropphyadd": "10751 MAIN ST NE",
    "dropphycty": "DONALD",
    "dropphyst": "OR",
    "dropphyzpp": 970207020,
    "dropmaladd": "10751 MAIN ST NE",
    "dropmalcty": "DONALD",
    "dropmalst": "OR",
    "dropmalzpp": 970207020,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036785594,
    "dropsitcph": 5036785594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14946",
    "droptype": "D",
    "dropname": "DORENA",
    "dropdeladd": "75694 WICKS RD",
    "dropdelcty": "DORENA",
    "dropdelst": "OR",
    "dropdelzpp": 974349712,
    "dropphyadd": "75694 WICKS RD",
    "dropphycty": "DORENA",
    "dropphyst": "OR",
    "dropphyzpp": 974349712,
    "dropmaladd": "75694 WICKS RD",
    "dropmalcty": "DORENA",
    "dropmalst": "OR",
    "dropmalzpp": 974349998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419461616,
    "dropsitcph": 5419461616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14950",
    "droptype": "D",
    "dropname": "DRAIN",
    "dropdeladd": "228 W C AVE",
    "dropdelcty": "DRAIN",
    "dropdelst": "OR",
    "dropdelzpp": 974359706,
    "dropphyadd": "228 W C AVE",
    "dropphycty": "DRAIN",
    "dropphyst": "OR",
    "dropphyzpp": 974359706,
    "dropmaladd": "228 W C AVE",
    "dropmalcty": "DRAIN",
    "dropmalst": "OR",
    "dropmalzpp": 974359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418367200,
    "dropsitcph": 5418367200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14952",
    "droptype": "D",
    "dropname": "DREWSEY",
    "dropdeladd": "78912 DREWSEY RD",
    "dropdelcty": "DREWSEY",
    "dropdelst": "OR",
    "dropdelzpp": 979045001,
    "dropphyadd": "78912 DREWSEY RD",
    "dropphycty": "DREWSEY",
    "dropphyst": "OR",
    "dropphyzpp": 979045001,
    "dropmaladd": "78912 DREWSEY RD",
    "dropmalcty": "DREWSEY",
    "dropmalst": "OR",
    "dropmalzpp": 979049998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414932625,
    "dropsitcph": 5414932625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14953",
    "droptype": "D",
    "dropname": "DUFUR",
    "dropdeladd": "96 N MAIN ST",
    "dropdelcty": "DUFUR",
    "dropdelst": "OR",
    "dropdelzpp": 970217021,
    "dropphyadd": "96 N MAIN ST",
    "dropphycty": "DUFUR",
    "dropphyst": "OR",
    "dropphyzpp": 970217021,
    "dropmaladd": "96 N MAIN ST",
    "dropmalcty": "DUFUR",
    "dropmalst": "OR",
    "dropmalzpp": 970219998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413943065,
    "dropsitcph": 5413943065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14954",
    "droptype": "D",
    "dropname": "DUNDEE",
    "dropdeladd": "279 SW 5TH ST",
    "dropdelcty": "DUNDEE",
    "dropdelst": "OR",
    "dropdelzpp": 971159605,
    "dropphyadd": "279 SW 5TH ST",
    "dropphycty": "DUNDEE",
    "dropphyst": "OR",
    "dropphyzpp": 971159605,
    "dropmaladd": "279 SW 5TH ST",
    "dropmalcty": "DUNDEE",
    "dropmalst": "OR",
    "dropmalzpp": 971159998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035540016,
    "dropsitcph": 5035388250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14957",
    "droptype": "D",
    "dropname": "DURKEE",
    "dropdeladd": "28677 OLD HWY 30",
    "dropdelcty": "DURKEE",
    "dropdelst": "OR",
    "dropdelzpp": 979055000,
    "dropphyadd": "28677 OLD HWY 30",
    "dropphycty": "DURKEE",
    "dropphyst": "OR",
    "dropphyzpp": 979055000,
    "dropmaladd": "28677 OLD HWY 30",
    "dropmalcty": "DURKEE",
    "dropmalst": "OR",
    "dropmalzpp": 979059998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418772224,
    "dropsitcph": 5418772224,
    "dropfax": 5038772441
  },
  {
    "dcode": "D",
    "dropkey": "PZ14958",
    "droptype": "D",
    "dropname": "EAGLE CREEK",
    "dropdeladd": "24200 SE EAGLE CREEK RD",
    "dropdelcty": "EAGLE CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 970227022,
    "dropphyadd": "24200 SE EAGLE CREEK RD",
    "dropphycty": "EAGLE CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 970227022,
    "dropmaladd": "24200 SE EAGLE CREEK RD",
    "dropmalcty": "EAGLE CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 970229998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036376548,
    "dropsitcph": 5036376532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14961",
    "droptype": "D",
    "dropname": "EAGLE POINT",
    "dropdeladd": "236 LOTO ST",
    "dropdelcty": "EAGLE POINT",
    "dropdelst": "OR",
    "dropdelzpp": 975249793,
    "dropphyadd": "236 LOTO ST",
    "dropphycty": "EAGLE POINT",
    "dropphyst": "OR",
    "dropphyzpp": 975249793,
    "dropmaladd": "236 LOTO ST",
    "dropmalcty": "EAGLE POINT",
    "dropmalst": "OR",
    "dropmalzpp": 975249998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418261732,
    "dropsitcph": 5418261692,
    "dropfax": 5418300364
  },
  {
    "dcode": "D",
    "dropkey": "PZ14968",
    "droptype": "D",
    "dropname": "ECHO",
    "dropdeladd": "130 W MAIN ST",
    "dropdelcty": "ECHO",
    "dropdelst": "OR",
    "dropdelzpp": 978269656,
    "dropphyadd": "130 W MAIN ST",
    "dropphycty": "ECHO",
    "dropphyst": "OR",
    "dropphyzpp": 978269656,
    "dropmaladd": "130 W MAIN ST",
    "dropmalcty": "ECHO",
    "dropmalst": "OR",
    "dropmalzpp": 978269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413768351,
    "dropsitcph": 5413768351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14969",
    "droptype": "D",
    "dropname": "EDDYVILLE",
    "dropdeladd": "6769 CRYSTAL CREEK LOOP",
    "dropdelcty": "EDDYVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 973439792,
    "dropphyadd": "6769 CRYSTAL CREEK LOOP",
    "dropphycty": "EDDYVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 973439792,
    "dropmaladd": "6769 CRYSTAL CREEK LOOP",
    "dropmalcty": "EDDYVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 973439998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418754881,
    "dropsitcph": 5418754881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14972",
    "droptype": "D",
    "dropname": "ELGIN",
    "dropdeladd": "887 DIVISION ST",
    "dropdelcty": "ELGIN",
    "dropdelst": "OR",
    "dropdelzpp": 978275000,
    "dropphyadd": "887 DIVISION ST",
    "dropphycty": "ELGIN",
    "dropphyst": "OR",
    "dropphyzpp": 978275000,
    "dropmaladd": "887 DIVISION ST",
    "dropmalcty": "ELGIN",
    "dropmalst": "OR",
    "dropmalzpp": 978279998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415340019,
    "dropsitcph": 5415340019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14974",
    "droptype": "D",
    "dropname": "ELKTON",
    "dropdeladd": "275 B ST",
    "dropdelcty": "ELKTON",
    "dropdelst": "OR",
    "dropdelzpp": 974369600,
    "dropphyadd": "275 B ST",
    "dropphycty": "ELKTON",
    "dropphyst": "OR",
    "dropphyzpp": 974369600,
    "dropmaladd": "275 B ST",
    "dropmalcty": "ELKTON",
    "dropmalst": "OR",
    "dropmalzpp": 974369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415842646,
    "dropsitcph": 5415842646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14976",
    "droptype": "D",
    "dropname": "ELMIRA",
    "dropdeladd": "88769 TERRITORIAL HWY",
    "dropdelcty": "ELMIRA",
    "dropdelst": "OR",
    "dropdelzpp": 974379759,
    "dropphyadd": "88769 TERRITORIAL HWY",
    "dropphycty": "ELMIRA",
    "dropphyst": "OR",
    "dropphyzpp": 974379759,
    "dropmaladd": "88769 TERRITORIAL HWY",
    "dropmalcty": "ELMIRA",
    "dropmalst": "OR",
    "dropmalzpp": 974379998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419351966,
    "dropsitcph": 5419351966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14981",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "201 W NORTH ST",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "OR",
    "dropdelzpp": 978281038,
    "dropphyadd": "201 W NORTH ST",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "OR",
    "dropphyzpp": 978281038,
    "dropmaladd": "201 W NORTH ST",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "OR",
    "dropmalzpp": 978289998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414266089,
    "dropsitcph": 5414265980,
    "dropfax": 5414263875
  },
  {
    "dcode": "D",
    "dropkey": "PZ14983",
    "droptype": "D",
    "dropname": "ESTACADA",
    "dropdeladd": "205 SW 2ND AVE",
    "dropdelcty": "ESTACADA",
    "dropdelst": "OR",
    "dropdelzpp": 970237023,
    "dropphyadd": "205 SW 2ND AVE",
    "dropphycty": "ESTACADA",
    "dropphyst": "OR",
    "dropphyzpp": 970237023,
    "dropmaladd": "205 SW 2ND AVE",
    "dropmalcty": "ESTACADA",
    "dropmalst": "OR",
    "dropmalzpp": 970239998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036306818,
    "dropsitcph": 5036304874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ14986",
    "droptype": "D",
    "dropname": "EUGENE",
    "dropdeladd": "520 WILLAMETTE ST",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974012627,
    "dropphyadd": "520 WILLAMETTE ST",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974012627,
    "dropmaladd": "520 WILLAMETTE ST",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413639,
    "dropsitcph": 5413413601,
    "dropfax": 5413413663
  },
  {
    "dcode": "D",
    "dropkey": "PZ14989",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "1700 NE MARKET DR",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "OR",
    "dropdelzpp": 970247024,
    "dropphyadd": "1700 NE MARKET DR",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "OR",
    "dropphyzpp": 970247024,
    "dropmaladd": "1700 NE MARKET DR",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "OR",
    "dropmalzpp": 970249998,
    "dropsitphn": 5036652663,
    "dropsitlph": 5036187531,
    "dropsitcph": 5036693010,
    "dropfax": 5034922211
  },
  {
    "dcode": "D",
    "dropkey": "PZ14992",
    "droptype": "D",
    "dropname": "FALLS CITY",
    "dropdeladd": "123 PARRY ST",
    "dropdelcty": "FALLS CITY",
    "dropdelst": "OR",
    "dropdelzpp": 973449801,
    "dropphyadd": "123 PARRY ST",
    "dropphycty": "FALLS CITY",
    "dropphyst": "OR",
    "dropphyzpp": 973449801,
    "dropmaladd": "123 PARRY ST",
    "dropmalcty": "FALLS CITY",
    "dropmalst": "OR",
    "dropmalzpp": 973449998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037873648,
    "dropsitcph": 5037873648,
    "dropfax": 5037872923
  },
  {
    "dcode": "D",
    "dropkey": "PZ15005",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "770 MAPLE ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "OR",
    "dropdelzpp": 974399491,
    "dropphyadd": "770 MAPLE ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "OR",
    "dropphyzpp": 974399491,
    "dropmaladd": "770 MAPLE ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "OR",
    "dropmalzpp": 974399998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419979406,
    "dropsitcph": 5419979406,
    "dropfax": 5419978017
  },
  {
    "dcode": "D",
    "dropkey": "PZ15006",
    "droptype": "D",
    "dropname": "FOREST GROVE",
    "dropdeladd": "2214 PACIFIC AVE",
    "dropdelcty": "FOREST GROVE",
    "dropdelst": "OR",
    "dropdelzpp": 971162448,
    "dropphyadd": "2214 PACIFIC AVE",
    "dropphycty": "FOREST GROVE",
    "dropphyst": "OR",
    "dropphyzpp": 971162448,
    "dropmaladd": "2214 PACIFIC AVE",
    "dropmalcty": "FOREST GROVE",
    "dropmalst": "OR",
    "dropmalzpp": 971169998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033578214,
    "dropsitcph": 5033577247,
    "dropfax": 5033599138
  },
  {
    "dcode": "D",
    "dropkey": "PZ15008",
    "droptype": "D",
    "dropname": "FORT KLAMATH",
    "dropdeladd": "52649 HIGHWAY 62",
    "dropdelcty": "FORT KLAMATH",
    "dropdelst": "OR",
    "dropdelzpp": 976269700,
    "dropphyadd": "52649 HIGHWAY 62",
    "dropphycty": "FORT KLAMATH",
    "dropphyst": "OR",
    "dropphyzpp": 976269700,
    "dropmaladd": "52649 HIGHWAY 62",
    "dropmalcty": "FORT KLAMATH",
    "dropmalst": "OR",
    "dropmalzpp": 976269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413812241,
    "dropsitcph": 5413812241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15009",
    "droptype": "D",
    "dropname": "FORT ROCK",
    "dropdeladd": "61698 ANTELOPE VISTA DR",
    "dropdelcty": "FORT ROCK",
    "dropdelst": "OR",
    "dropdelzpp": 977359798,
    "dropphyadd": "61698 ANTELOPE VISTA DR",
    "dropphycty": "FORT ROCK",
    "dropphyst": "OR",
    "dropphyzpp": 977359798,
    "dropmaladd": "61698 ANTELOPE VISTA DR",
    "dropmalcty": "FORT ROCK",
    "dropmalst": "OR",
    "dropmalzpp": 977359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415762112,
    "dropsitcph": 5415762112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15012",
    "droptype": "D",
    "dropname": "FOSSIL",
    "dropdeladd": "606 MAIN ST",
    "dropdelcty": "FOSSIL",
    "dropdelst": "OR",
    "dropdelzpp": 978305000,
    "dropphyadd": "606 MAIN ST",
    "dropphycty": "FOSSIL",
    "dropphyst": "OR",
    "dropphyzpp": 978305000,
    "dropmaladd": "606 MAIN ST",
    "dropmalcty": "FOSSIL",
    "dropmalst": "OR",
    "dropmalzpp": 978309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417632460,
    "dropsitcph": 5417632460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15013",
    "droptype": "D",
    "dropname": "FOSTER",
    "dropdeladd": "5300 POPLAR ST",
    "dropdelcty": "FOSTER",
    "dropdelst": "OR",
    "dropdelzpp": 973459740,
    "dropphyadd": "5300 POPLAR ST",
    "dropphycty": "FOSTER",
    "dropphyst": "OR",
    "dropphyzpp": 973459740,
    "dropmaladd": "5300 POPLAR ST",
    "dropmalcty": "FOSTER",
    "dropmalst": "OR",
    "dropmalzpp": 973459998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413676388,
    "dropsitcph": 5413676388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15027",
    "droptype": "D",
    "dropname": "GARDINER",
    "dropdeladd": "77251 HIGHWAY 101",
    "dropdelcty": "GARDINER",
    "dropdelst": "OR",
    "dropdelzpp": 974419706,
    "dropphyadd": "77251 HIGHWAY 101",
    "dropphycty": "GARDINER",
    "dropphyst": "OR",
    "dropphyzpp": 974419706,
    "dropmaladd": "77251 HIGHWAY 101",
    "dropmalcty": "GARDINER",
    "dropmalst": "OR",
    "dropmalzpp": 974419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412712313,
    "dropsitcph": 5412712313,
    "dropfax": 5412712313
  },
  {
    "dcode": "D",
    "dropkey": "PZ15028",
    "droptype": "D",
    "dropname": "GARIBALDI",
    "dropdeladd": "511 ACACIA ST",
    "dropdelcty": "GARIBALDI",
    "dropdelst": "OR",
    "dropdelzpp": 971189100,
    "dropphyadd": "511 ACACIA ST",
    "dropphycty": "GARIBALDI",
    "dropphyst": "OR",
    "dropphyzpp": 971189100,
    "dropmaladd": "511 ACACIA ST",
    "dropmalcty": "GARIBALDI",
    "dropmalst": "OR",
    "dropmalzpp": 971189998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033223675,
    "dropsitcph": 5033223675,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15029",
    "droptype": "D",
    "dropname": "GASTON",
    "dropdeladd": "29895 NW OLSON RD",
    "dropdelcty": "GASTON",
    "dropdelst": "OR",
    "dropdelzpp": 971198225,
    "dropphyadd": "29895 NW OLSON RD",
    "dropphycty": "GASTON",
    "dropphyst": "OR",
    "dropphyzpp": 971198225,
    "dropmaladd": "29895 NW OLSON RD",
    "dropmalcty": "GASTON",
    "dropmalst": "OR",
    "dropmalzpp": 971199998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5039857171,
    "dropsitcph": 5039850186,
    "dropfax": 5039850225
  },
  {
    "dcode": "D",
    "dropkey": "PZ15035",
    "droptype": "D",
    "dropname": "GERVAIS",
    "dropdeladd": "380 DOUGLAS AVE",
    "dropdelcty": "GERVAIS",
    "dropdelst": "OR",
    "dropdelzpp": 970267026,
    "dropphyadd": "380 DOUGLAS AVE",
    "dropphycty": "GERVAIS",
    "dropphyst": "OR",
    "dropphyzpp": 970267026,
    "dropmaladd": "380 DOUGLAS AVE",
    "dropmalcty": "GERVAIS",
    "dropmalst": "OR",
    "dropmalzpp": 970269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037923867,
    "dropsitcph": 5037923868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15036",
    "droptype": "D",
    "dropname": "GILCHRIST",
    "dropdeladd": "138309 HIGHWAY 97 N",
    "dropdelcty": "GILCHRIST",
    "dropdelst": "OR",
    "dropdelzpp": 977379757,
    "dropphyadd": "138309 HIGHWAY 97 N",
    "dropphycty": "GILCHRIST",
    "dropphyst": "OR",
    "dropphyzpp": 977379757,
    "dropmaladd": "138309 HIGHWAY 97 N",
    "dropmalcty": "GILCHRIST",
    "dropmalst": "OR",
    "dropmalzpp": 977379757,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414339360,
    "dropsitcph": 5414339360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15038",
    "droptype": "D",
    "dropname": "GLADSTONE",
    "dropdeladd": "605 PORTLAND AVE",
    "dropdelcty": "GLADSTONE",
    "dropdelst": "OR",
    "dropdelzpp": 970272700,
    "dropphyadd": "605 PORTLAND AVE",
    "dropphycty": "GLADSTONE",
    "dropphyst": "OR",
    "dropphyzpp": 970272700,
    "dropmaladd": "605 PORTLAND AVE",
    "dropmalcty": "GLADSTONE",
    "dropmalst": "OR",
    "dropmalzpp": 970279998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035573547,
    "dropsitcph": 5035573599,
    "dropfax": 5035578342
  },
  {
    "dcode": "D",
    "dropkey": "PZ15042",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "358 PACIFIC AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "OR",
    "dropdelzpp": 974429744,
    "dropphyadd": "358 PACIFIC AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "OR",
    "dropphyzpp": 974429744,
    "dropmaladd": "358 PACIFIC AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "OR",
    "dropmalzpp": 974429998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418322206,
    "dropsitcph": 5418322945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15048",
    "droptype": "D",
    "dropname": "GLIDE",
    "dropdeladd": "19443 N UMPQUA HWY",
    "dropdelcty": "GLIDE",
    "dropdelst": "OR",
    "dropdelzpp": 974439738,
    "dropphyadd": "19443 N UMPQUA HWY",
    "dropphycty": "GLIDE",
    "dropphyst": "OR",
    "dropphyzpp": 974439738,
    "dropmaladd": "19443 N UMPQUA HWY",
    "dropmalcty": "GLIDE",
    "dropmalst": "OR",
    "dropmalzpp": 974439998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412290096,
    "dropsitcph": 5412290096,
    "dropfax": "0000000000"
  },
  {
    "dcode": "D",
    "dropkey": "PZ15051",
    "droptype": "D",
    "dropname": "GOLD BEACH",
    "dropdeladd": "29917 HARBOR WAY",
    "dropdelcty": "GOLD BEACH",
    "dropdelst": "OR",
    "dropdelzpp": 974449700,
    "dropphyadd": "29917 HARBOR WAY",
    "dropphycty": "GOLD BEACH",
    "dropphyst": "OR",
    "dropphyzpp": 974449700,
    "dropmaladd": "29917 HARBOR WAY",
    "dropmalcty": "GOLD BEACH",
    "dropmalst": "OR",
    "dropmalzpp": 974449700,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412478142,
    "dropsitcph": 5412478142,
    "dropfax": 5412476131
  },
  {
    "dcode": "D",
    "dropkey": "PZ15052",
    "droptype": "D",
    "dropname": "GOLD HILL",
    "dropdeladd": "375 2ND AVE",
    "dropdelcty": "GOLD HILL",
    "dropdelst": "OR",
    "dropdelzpp": 975259585,
    "dropphyadd": "375 2ND AVE",
    "dropphycty": "GOLD HILL",
    "dropphyst": "OR",
    "dropphyzpp": 975259585,
    "dropmaladd": "375 2ND AVE",
    "dropmalcty": "GOLD HILL",
    "dropmalst": "OR",
    "dropmalzpp": 975259998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418558906,
    "dropsitcph": 5418558904,
    "dropfax": 5418559629
  },
  {
    "dcode": "D",
    "dropkey": "PZ15055",
    "droptype": "D",
    "dropname": "GOVERNMENT CAMP",
    "dropdeladd": "88331 E GOVERNMENT CAMP LOOP",
    "dropdelcty": "GOVERNMENT CAMP",
    "dropdelst": "OR",
    "dropdelzpp": 970287028,
    "dropphyadd": "88331 E GOVERNMENT CAMP LOOP",
    "dropphycty": "GOVERNMENT CAMP",
    "dropphyst": "OR",
    "dropphyzpp": 970287028,
    "dropmaladd": "88331 E GOVERNMENT CAMP LOOP",
    "dropmalcty": "GOVERNMENT CAMP",
    "dropmalst": "OR",
    "dropmalzpp": 970289998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032723238,
    "dropsitcph": 5032723238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15057",
    "droptype": "D",
    "dropname": "GRAND RONDE",
    "dropdeladd": "8650 GRAND RONDE RD",
    "dropdelcty": "GRAND RONDE",
    "dropdelst": "OR",
    "dropdelzpp": 973479720,
    "dropphyadd": "8650 GRAND RONDE RD",
    "dropphycty": "GRAND RONDE",
    "dropphyst": "OR",
    "dropphyzpp": 973479720,
    "dropmaladd": "8650 GRAND RONDE RD",
    "dropmalcty": "GRAND RONDE",
    "dropmalst": "OR",
    "dropmalzpp": 973479998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038795222,
    "dropsitcph": 5038795222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15059",
    "droptype": "D",
    "dropname": "GRANTS PASS",
    "dropdeladd": "132 NW 6TH ST",
    "dropdelcty": "GRANTS PASS",
    "dropdelst": "OR",
    "dropdelzpp": 975262003,
    "dropphyadd": "132 NW 6TH ST",
    "dropphycty": "GRANTS PASS",
    "dropphyst": "OR",
    "dropphyzpp": 975262003,
    "dropmaladd": "132 NW 6TH ST",
    "dropmalcty": "GRANTS PASS",
    "dropmalst": "OR",
    "dropmalzpp": 975269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414712163,
    "dropsitcph": 5414712163,
    "dropfax": 5414713446
  },
  {
    "dcode": "D",
    "dropkey": "PZ15061",
    "droptype": "D",
    "dropname": "GRASS VALLEY",
    "dropdeladd": "114 N MILL ST",
    "dropdelcty": "GRASS VALLEY",
    "dropdelst": "OR",
    "dropdelzpp": 970297029,
    "dropphyadd": "114 N MILL ST",
    "dropphycty": "GRASS VALLEY",
    "dropphyst": "OR",
    "dropphyzpp": 970297029,
    "dropmaladd": "114 N MILL ST",
    "dropmalcty": "GRASS VALLEY",
    "dropmalst": "OR",
    "dropmalzpp": 970299998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413943048,
    "dropsitcph": 5413943048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15071",
    "droptype": "D",
    "dropname": "GRESHAM",
    "dropdeladd": "103 W POWELL BLVD",
    "dropdelcty": "GRESHAM",
    "dropdelst": "OR",
    "dropdelzpp": 970303000,
    "dropphyadd": "103 W POWELL BLVD",
    "dropphycty": "GRESHAM",
    "dropphyst": "OR",
    "dropphyzpp": 970303000,
    "dropmaladd": "103 W POWELL BLVD",
    "dropmalcty": "GRESHAM",
    "dropmalst": "OR",
    "dropmalzpp": 970309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036653115,
    "dropsitcph": 5036652663,
    "dropfax": 5036696516
  },
  {
    "dcode": "D",
    "dropkey": "PZ15074",
    "droptype": "D",
    "dropname": "HAINES",
    "dropdeladd": "918 FRONT ST",
    "dropdelcty": "HAINES",
    "dropdelst": "OR",
    "dropdelzpp": 978335000,
    "dropphyadd": "918 FRONT ST",
    "dropphycty": "HAINES",
    "dropphyst": "OR",
    "dropphyzpp": 978335000,
    "dropmaladd": "918 FRONT ST",
    "dropmalcty": "HAINES",
    "dropmalst": "OR",
    "dropmalzpp": 978339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418563585,
    "dropsitcph": 5418563585,
    "dropfax": 5418563848
  },
  {
    "dcode": "D",
    "dropkey": "PZ15075",
    "droptype": "D",
    "dropname": "HALFWAY",
    "dropdeladd": "107 S MAIN ST",
    "dropdelcty": "HALFWAY",
    "dropdelst": "OR",
    "dropdelzpp": 978345000,
    "dropphyadd": "107 S MAIN ST",
    "dropphycty": "HALFWAY",
    "dropphyst": "OR",
    "dropphyzpp": 978345000,
    "dropmaladd": "107 S MAIN ST",
    "dropmalcty": "HALFWAY",
    "dropmalst": "OR",
    "dropmalzpp": 978349998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417424381,
    "dropsitcph": 5417424381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15077",
    "droptype": "D",
    "dropname": "HALSEY",
    "dropdeladd": "124 NW 2ND ST",
    "dropdelcty": "HALSEY",
    "dropdelst": "OR",
    "dropdelzpp": 973489671,
    "dropphyadd": "124 NW 2ND ST",
    "dropphycty": "HALSEY",
    "dropphyst": "OR",
    "dropphyzpp": 973489671,
    "dropmaladd": "124 NW 2ND ST",
    "dropmalcty": "HALSEY",
    "dropmalst": "OR",
    "dropmalzpp": 973489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412092745,
    "dropsitcph": 5412092745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15078",
    "droptype": "D",
    "dropname": "HAMMOND",
    "dropdeladd": "906 PACIFIC DR",
    "dropdelcty": "HAMMOND",
    "dropdelst": "OR",
    "dropdelzpp": 971219200,
    "dropphyadd": "906 PACIFIC DR",
    "dropphycty": "HAMMOND",
    "dropphyst": "OR",
    "dropphyzpp": 971219200,
    "dropmaladd": "906 PACIFIC DR",
    "dropmalcty": "HAMMOND",
    "dropmalst": "OR",
    "dropmalzpp": 971219998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038612671,
    "dropsitcph": 5038612671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15083",
    "droptype": "D",
    "dropname": "HARPER",
    "dropdeladd": "2965 A ST",
    "dropdelcty": "HARPER",
    "dropdelst": "OR",
    "dropdelzpp": 979064000,
    "dropphyadd": "2965 A ST",
    "dropphycty": "HARPER",
    "dropphyst": "OR",
    "dropphyzpp": 979064000,
    "dropmaladd": "2965 A ST",
    "dropmalcty": "HARPER",
    "dropmalst": "OR",
    "dropmalzpp": 979069998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412239990,
    "dropsitcph": 5412239990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15086",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "204 SMITH ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "OR",
    "dropdelzpp": 974469800,
    "dropphyadd": "204 SMITH ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "OR",
    "dropphyzpp": 974469800,
    "dropmaladd": "204 SMITH ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "OR",
    "dropmalzpp": 974469998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419951006,
    "dropsitcph": 5419951003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15090",
    "droptype": "D",
    "dropname": "HEBO",
    "dropdeladd": "31155 HIGHWAY 101 S",
    "dropdelcty": "HEBO",
    "dropdelst": "OR",
    "dropdelzpp": 971229723,
    "dropphyadd": "31155 HIGHWAY 101 S",
    "dropphycty": "HEBO",
    "dropphyst": "OR",
    "dropphyzpp": 971229723,
    "dropmaladd": "31155 HIGHWAY 101 S",
    "dropmalcty": "HEBO",
    "dropmalst": "OR",
    "dropmalzpp": 971229998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033923137,
    "dropsitcph": 5033923137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15093",
    "droptype": "D",
    "dropname": "HELIX",
    "dropdeladd": "209 CONCORD ST",
    "dropdelcty": "HELIX",
    "dropdelst": "OR",
    "dropdelzpp": 978355000,
    "dropphyadd": "209 CONCORD ST",
    "dropphycty": "HELIX",
    "dropphyst": "OR",
    "dropphyzpp": 978355000,
    "dropmaladd": "209 CONCORD ST",
    "dropmalcty": "HELIX",
    "dropmalst": "OR",
    "dropmalzpp": 978359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414572583,
    "dropsitcph": 5414572583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15097",
    "droptype": "D",
    "dropname": "HEPPNER",
    "dropdeladd": "167 N MAIN ST",
    "dropdelcty": "HEPPNER",
    "dropdelst": "OR",
    "dropdelzpp": 978365001,
    "dropphyadd": "167 N MAIN ST",
    "dropphycty": "HEPPNER",
    "dropphyst": "OR",
    "dropphyzpp": 978365001,
    "dropmaladd": "167 N MAIN ST",
    "dropmalcty": "HEPPNER",
    "dropmalst": "OR",
    "dropmalzpp": 978369998,
    "dropsitphn": 5416769630,
    "dropsitlph": 5416769274,
    "dropsitcph": 5416769630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15099",
    "droptype": "D",
    "dropname": "HERMISTON",
    "dropdeladd": "375 W ORCHARD AVE",
    "dropdelcty": "HERMISTON",
    "dropdelst": "OR",
    "dropdelzpp": 978381757,
    "dropphyadd": "375 W ORCHARD AVE",
    "dropphycty": "HERMISTON",
    "dropphyst": "OR",
    "dropphyzpp": 978381757,
    "dropmaladd": "375 W ORCHARD AVE",
    "dropmalcty": "HERMISTON",
    "dropmalst": "OR",
    "dropmalzpp": 978389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415678039,
    "dropsitcph": 5415647921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15101",
    "droptype": "D",
    "dropname": "HILLSBORO",
    "dropdeladd": "125 S 1ST AVE",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "OR",
    "dropdelzpp": 971233954,
    "dropphyadd": "125 S 1ST AVE",
    "dropphycty": "HILLSBORO",
    "dropphyst": "OR",
    "dropphyzpp": 971233954,
    "dropmaladd": "1330 SW WALNUT ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "OR",
    "dropmalzpp": 971239994,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036152824,
    "dropsitcph": 5036152825,
    "dropfax": 5036150806
  },
  {
    "dcode": "D",
    "dropkey": "PZ15102",
    "droptype": "D",
    "dropname": "HINES",
    "dropdeladd": "128 SW CIRCLE DR",
    "dropdelcty": "HINES",
    "dropdelst": "OR",
    "dropdelzpp": 977389700,
    "dropphyadd": "128 SW CIRCLE DR",
    "dropphycty": "HINES",
    "dropphyst": "OR",
    "dropphyzpp": 977389700,
    "dropmaladd": "128 SW CIRCLE DR",
    "dropmalcty": "HINES",
    "dropmalst": "OR",
    "dropmalzpp": 977389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415732444,
    "dropsitcph": 5415732444,
    "dropfax": 5415732444
  },
  {
    "dcode": "D",
    "dropkey": "PZ15106",
    "droptype": "D",
    "dropname": "HOOD RIVER",
    "dropdeladd": "408 CASCADE AVE",
    "dropdelcty": "HOOD RIVER",
    "dropdelst": "OR",
    "dropdelzpp": 970317031,
    "dropphyadd": "408 CASCADE AVE",
    "dropphycty": "HOOD RIVER",
    "dropphyst": "OR",
    "dropphyzpp": 970317031,
    "dropmaladd": "408 CASCADE AVE",
    "dropmalcty": "HOOD RIVER",
    "dropmalst": "OR",
    "dropmalzpp": 970317031,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413869416,
    "dropsitcph": 5413861584,
    "dropfax": 5033869418
  },
  {
    "dcode": "D",
    "dropkey": "PZ15111",
    "droptype": "D",
    "dropname": "HUBBARD",
    "dropdeladd": "3016 G ST",
    "dropdelcty": "HUBBARD",
    "dropdelst": "OR",
    "dropdelzpp": 970327032,
    "dropphyadd": "3016 G ST",
    "dropphycty": "HUBBARD",
    "dropphyst": "OR",
    "dropphyzpp": 970327032,
    "dropmaladd": "3016 G ST",
    "dropmalcty": "HUBBARD",
    "dropmalst": "OR",
    "dropmalzpp": 970329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5039822976,
    "dropsitcph": 5039822968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15114",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "10 E WASHINGTON ST",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "OR",
    "dropdelzpp": 979074000,
    "dropphyadd": "10 E WASHINGTON ST",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "OR",
    "dropphyzpp": 979074000,
    "dropmaladd": "10 E WASHINGTON ST",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "OR",
    "dropmalzpp": 979079998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418692256,
    "dropsitcph": 5418692256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15115",
    "droptype": "D",
    "dropname": "IDANHA",
    "dropdeladd": "103 HIGHWAY 22",
    "dropdelcty": "IDANHA",
    "dropdelst": "OR",
    "dropdelzpp": 973509700,
    "dropphyadd": "103 HIGHWAY 22",
    "dropphycty": "IDANHA",
    "dropphyst": "OR",
    "dropphyzpp": 973509700,
    "dropmaladd": "103 HIGHWAY 22",
    "dropmalcty": "IDANHA",
    "dropmalst": "OR",
    "dropmalzpp": 973509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038543634,
    "dropsitcph": 5038543634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15116",
    "droptype": "D",
    "dropname": "IDLEYLD PARK",
    "dropdeladd": "23843 N UMPQUA HWY",
    "dropdelcty": "IDLEYLD PARK",
    "dropdelst": "OR",
    "dropdelzpp": 974479000,
    "dropphyadd": "23843 N UMPQUA HWY",
    "dropphycty": "IDLEYLD PARK",
    "dropphyst": "OR",
    "dropphyzpp": 974479000,
    "dropmaladd": "23843 N UMPQUA HWY",
    "dropmalcty": "IDLEYLD PARK",
    "dropmalst": "OR",
    "dropmalzpp": 974479998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414963412,
    "dropsitcph": 5414963412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15120",
    "droptype": "D",
    "dropname": "IMBLER",
    "dropdeladd": "510 RUCKMAN AVE",
    "dropdelcty": "IMBLER",
    "dropdelst": "OR",
    "dropdelzpp": 978418109,
    "dropphyadd": "510 RUCKMAN AVE",
    "dropphycty": "IMBLER",
    "dropphyst": "OR",
    "dropphyzpp": 978418109,
    "dropmaladd": "510 RUCKMAN AVE",
    "dropmalcty": "IMBLER",
    "dropmalst": "OR",
    "dropmalzpp": 978419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415344111,
    "dropsitcph": 5415344111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15121",
    "droptype": "D",
    "dropname": "IMNAHA",
    "dropdeladd": "101 HAT POINT RD",
    "dropdelcty": "IMNAHA",
    "dropdelst": "OR",
    "dropdelzpp": 978425000,
    "dropphyadd": "101 HAT POINT RD",
    "dropphycty": "IMNAHA",
    "dropphyst": "OR",
    "dropphyzpp": 978425000,
    "dropmaladd": "101 HAT POINT RD",
    "dropmalcty": "IMNAHA",
    "dropmalst": "OR",
    "dropmalzpp": 978429998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415773116,
    "dropsitcph": 5415773116,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15122",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "216 S 2ND ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "OR",
    "dropdelzpp": 973512031,
    "dropphyadd": "216 S 2ND ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "OR",
    "dropphyzpp": 973512031,
    "dropmaladd": "216 S 2ND ST",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "OR",
    "dropmalzpp": 973512031,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038385207,
    "dropsitcph": 5038385207,
    "dropfax": 5038386843
  },
  {
    "dcode": "D",
    "dropkey": "PZ15124",
    "droptype": "D",
    "dropname": "IONE",
    "dropdeladd": "180 W MAIN ST",
    "dropdelcty": "IONE",
    "dropdelst": "OR",
    "dropdelzpp": 978435000,
    "dropphyadd": "180 W MAIN ST",
    "dropphycty": "IONE",
    "dropphyst": "OR",
    "dropphyzpp": 978435000,
    "dropmaladd": "180 W MAIN ST",
    "dropmalcty": "IONE",
    "dropmalst": "OR",
    "dropmalzpp": 978439998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414227554,
    "dropsitcph": 5414227554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15126",
    "droptype": "D",
    "dropname": "IRRIGON",
    "dropdeladd": "300 NE MAIN AVE",
    "dropdelcty": "IRRIGON",
    "dropdelst": "OR",
    "dropdelzpp": 978446937,
    "dropphyadd": "300 NE MAIN AVE",
    "dropphycty": "IRRIGON",
    "dropphyst": "OR",
    "dropphyzpp": 978446937,
    "dropmaladd": "300 NE MAIN AVE",
    "dropmalcty": "IRRIGON",
    "dropmalst": "OR",
    "dropmalzpp": 978449998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419225012,
    "dropsitcph": 5419225012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15129",
    "droptype": "D",
    "dropname": "JACKSONVILLE",
    "dropdeladd": "175 N OREGON ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 975309797,
    "dropphyadd": "175 N OREGON ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 975309797,
    "dropmaladd": "175 N OREGON ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 975309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418993748,
    "dropsitcph": 5418993745,
    "dropfax": 5418993745
  },
  {
    "dcode": "D",
    "dropkey": "PZ15132",
    "droptype": "D",
    "dropname": "JAMIESON",
    "dropdeladd": "5180 JOHN DAY HWY",
    "dropdelcty": "JAMIESON",
    "dropdelst": "OR",
    "dropdelzpp": 979095000,
    "dropphyadd": "5180 JOHN DAY HWY",
    "dropphycty": "JAMIESON",
    "dropphyst": "OR",
    "dropphyzpp": 979095000,
    "dropmaladd": "5180 JOHN DAY HWY",
    "dropmalcty": "JAMIESON",
    "dropmalst": "OR",
    "dropmalzpp": 979099998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414732865,
    "dropsitcph": 5414732865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15136",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "152 S 2ND ST",
    "dropdelcty": "JEFFERSON",
    "dropdelst": "OR",
    "dropdelzpp": 973529800,
    "dropphyadd": "152 S 2ND ST",
    "dropphycty": "JEFFERSON",
    "dropphyst": "OR",
    "dropphyzpp": 973529800,
    "dropmaladd": "152 S 2ND ST",
    "dropmalcty": "JEFFERSON",
    "dropmalst": "OR",
    "dropmalzpp": 973529998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413272297,
    "dropsitcph": 5413272297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15139",
    "droptype": "D",
    "dropname": "JOHN DAY",
    "dropdeladd": "151 N CANYON BLVD",
    "dropdelcty": "JOHN DAY",
    "dropdelst": "OR",
    "dropdelzpp": 978451148,
    "dropphyadd": "151 N CANYON BLVD",
    "dropphycty": "JOHN DAY",
    "dropphyst": "OR",
    "dropphyzpp": 978451148,
    "dropmaladd": "151 N CANYON BLVD",
    "dropmalcty": "JOHN DAY",
    "dropmalst": "OR",
    "dropmalzpp": 978459998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415751294,
    "dropsitcph": 5415751294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15143",
    "droptype": "D",
    "dropname": "JORDAN VALLEY",
    "dropdeladd": "509 YTURRI BLVD",
    "dropdelcty": "JORDAN VALLEY",
    "dropdelst": "OR",
    "dropdelzpp": 979105000,
    "dropphyadd": "509 YTURRI BLVD",
    "dropphycty": "JORDAN VALLEY",
    "dropphyst": "OR",
    "dropphyzpp": 979105000,
    "dropmaladd": "509 YTURRI BLVD",
    "dropmalcty": "JORDAN VALLEY",
    "dropmalst": "OR",
    "dropmalzpp": 979109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415862811,
    "dropsitcph": 5415862811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15144",
    "droptype": "D",
    "dropname": "JOSEPH",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "JOSEPH",
    "dropdelst": "OR",
    "dropdelzpp": 978465000,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "JOSEPH",
    "dropphyst": "OR",
    "dropphyzpp": 978465000,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "JOSEPH",
    "dropmalst": "OR",
    "dropmalzpp": 978469998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414323231,
    "dropsitcph": 5414323231,
    "dropfax": 5414323007
  },
  {
    "dcode": "D",
    "dropkey": "PZ15145",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "669 GREENWOOD ST",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "OR",
    "dropdelzpp": 974481600,
    "dropphyadd": "669 GREENWOOD ST",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "OR",
    "dropphyzpp": 974481600,
    "dropmaladd": "669 GREENWOOD ST",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "OR",
    "dropmalzpp": 974489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419983173,
    "dropsitcph": 5419982869,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15148",
    "droptype": "D",
    "dropname": "JUNTURA",
    "dropdeladd": "5828 4TH ST",
    "dropdelcty": "JUNTURA",
    "dropdelst": "OR",
    "dropdelzpp": 979119702,
    "dropphyadd": "5828 4TH ST",
    "dropphycty": "JUNTURA",
    "dropphyst": "OR",
    "dropphyzpp": 979119702,
    "dropmaladd": "5828 4TH ST",
    "dropmalcty": "JUNTURA",
    "dropmalst": "OR",
    "dropmalzpp": 979119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412773305,
    "dropsitcph": 5412773305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15155",
    "droptype": "D",
    "dropname": "KENO",
    "dropdeladd": "15750 HIGHWAY 66",
    "dropdelcty": "KENO",
    "dropdelst": "OR",
    "dropdelzpp": 976279705,
    "dropphyadd": "15750 HIGHWAY 66",
    "dropphycty": "KENO",
    "dropphyst": "OR",
    "dropphyzpp": 976279705,
    "dropmaladd": "15750 HIGHWAY 66",
    "dropmalcty": "KENO",
    "dropmalst": "OR",
    "dropmalzpp": 976279998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418841855,
    "dropsitcph": 5418841855,
    "dropfax": 5418504376
  },
  {
    "dcode": "D",
    "dropkey": "PZ15156",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "95097 DOBIE POINT LN",
    "dropdelcty": "KENT",
    "dropdelst": "OR",
    "dropdelzpp": 970337033,
    "dropphyadd": "95097 DOBIE POINT LN",
    "dropphycty": "KENT",
    "dropphyst": "OR",
    "dropphyzpp": 970337033,
    "dropmaladd": "95097 DOBIE POINT LN",
    "dropmalcty": "KENT",
    "dropmalst": "OR",
    "dropmalzpp": 970339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413332581,
    "dropsitcph": 5413332581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15160",
    "droptype": "D",
    "dropname": "KIMBERLY",
    "dropdeladd": "41345 HWY 19 STE B",
    "dropdelcty": "KIMBERLY",
    "dropdelst": "OR",
    "dropdelzpp": 978486272,
    "dropphyadd": "41345 HWY 19 STE B",
    "dropphycty": "KIMBERLY",
    "dropphyst": "OR",
    "dropphyzpp": 978486272,
    "dropmaladd": "41345 HWY 19 STE B",
    "dropmalcty": "KIMBERLY",
    "dropmalst": "OR",
    "dropmalzpp": 978489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419342600,
    "dropsitcph": 5419342600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15170",
    "droptype": "D",
    "dropname": "KLAMATH FALLS",
    "dropdeladd": "317 S 7TH ST",
    "dropdelcty": "KLAMATH FALLS",
    "dropdelst": "OR",
    "dropdelzpp": 976016170,
    "dropphyadd": "317 S 7TH ST",
    "dropphycty": "KLAMATH FALLS",
    "dropphyst": "OR",
    "dropphyzpp": 976016170,
    "dropmaladd": "317 S 7TH ST",
    "dropmalcty": "KLAMATH FALLS",
    "dropmalst": "OR",
    "dropmalzpp": 976019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418849846,
    "dropsitcph": 5418849846,
    "dropfax": 5418849225
  },
  {
    "dcode": "D",
    "dropkey": "PZ15172",
    "droptype": "D",
    "dropname": "LA GRANDE",
    "dropdeladd": "1202 WASHINGTON AVE",
    "dropdelcty": "LA GRANDE",
    "dropdelst": "OR",
    "dropdelzpp": 978502525,
    "dropphyadd": "1202 WASHINGTON AVE",
    "dropphycty": "LA GRANDE",
    "dropphyst": "OR",
    "dropphyzpp": 978502525,
    "dropmaladd": "1202 WASHINGTON AVE",
    "dropmalcty": "LA GRANDE",
    "dropmalst": "OR",
    "dropmalzpp": 978509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419627519,
    "dropsitcph": 5419627539,
    "dropfax": 5419626271
  },
  {
    "dcode": "D",
    "dropkey": "PZ15173",
    "droptype": "D",
    "dropname": "LA PINE",
    "dropdeladd": "51649 HUNTINGTON RD",
    "dropdelcty": "LA PINE",
    "dropdelst": "OR",
    "dropdelzpp": 977399626,
    "dropphyadd": "51649 HUNTINGTON RD",
    "dropphycty": "LA PINE",
    "dropphyst": "OR",
    "dropphyzpp": 977399626,
    "dropmaladd": "51649 HUNTINGTON RD",
    "dropmalcty": "LA PINE",
    "dropmalst": "OR",
    "dropmalzpp": 977399998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415362208,
    "dropsitcph": 5415367452,
    "dropfax": 5415362544
  },
  {
    "dcode": "D",
    "dropkey": "PZ15176",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "491 3RD ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "OR",
    "dropdelzpp": 971279800,
    "dropphyadd": "491 3RD ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "OR",
    "dropphyzpp": 971279800,
    "dropmaladd": "491 3RD ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "OR",
    "dropmalzpp": 971279998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038643282,
    "dropsitcph": 5038642693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15180",
    "droptype": "D",
    "dropname": "LAKE OSWEGO",
    "dropdeladd": "501 4TH ST",
    "dropdelcty": "LAKE OSWEGO",
    "dropdelst": "OR",
    "dropdelzpp": 970347034,
    "dropphyadd": "501 4TH ST",
    "dropphycty": "LAKE OSWEGO",
    "dropphyst": "OR",
    "dropphyzpp": 970347034,
    "dropmaladd": "501 4TH ST",
    "dropmalcty": "LAKE OSWEGO",
    "dropmalst": "OR",
    "dropmalzpp": 970347034,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036997499,
    "dropsitcph": 5036754500,
    "dropfax": 5036366082
  },
  {
    "dcode": "D",
    "dropkey": "PZ15182",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "170 S 8TH ST",
    "dropdelcty": "LAKESIDE",
    "dropdelst": "OR",
    "dropdelzpp": 974499703,
    "dropphyadd": "170 S 8TH ST",
    "dropphycty": "LAKESIDE",
    "dropphyst": "OR",
    "dropphyzpp": 974499703,
    "dropmaladd": "170 S 8TH ST",
    "dropmalcty": "LAKESIDE",
    "dropmalst": "OR",
    "dropmalzpp": 974499998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417593504,
    "dropsitcph": 5417593504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15183",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "18 S G ST",
    "dropdelcty": "LAKEVIEW",
    "dropdelst": "OR",
    "dropdelzpp": 976301867,
    "dropphyadd": "18 S G ST",
    "dropphycty": "LAKEVIEW",
    "dropphyst": "OR",
    "dropphyzpp": 976301867,
    "dropmaladd": "18 S G ST",
    "dropmalcty": "LAKEVIEW",
    "dropmalst": "OR",
    "dropmalzpp": 976309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419475750,
    "dropsitcph": 5419475606,
    "dropfax": 5419473219
  },
  {
    "dcode": "D",
    "dropkey": "PZ15185",
    "droptype": "D",
    "dropname": "LANGLOIS",
    "dropdeladd": "94262 2ND ST",
    "dropdelcty": "LANGLOIS",
    "dropdelst": "OR",
    "dropdelzpp": 974509714,
    "dropphyadd": "94262 2ND ST",
    "dropphycty": "LANGLOIS",
    "dropphyst": "OR",
    "dropphyzpp": 974509714,
    "dropmaladd": "94262 2ND ST",
    "dropmalcty": "LANGLOIS",
    "dropmalst": "OR",
    "dropmalzpp": 974509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413482316,
    "dropsitcph": 5413482316,
    "dropfax": 5413482316
  },
  {
    "dcode": "D",
    "dropkey": "PZ15190",
    "droptype": "D",
    "dropname": "LEBANON",
    "dropdeladd": "55 WALKER RD",
    "dropdelcty": "LEBANON",
    "dropdelst": "OR",
    "dropdelzpp": 973552344,
    "dropphyadd": "55 WALKER RD",
    "dropphycty": "LEBANON",
    "dropphyst": "OR",
    "dropphyzpp": 973552344,
    "dropmaladd": "55 WALKER RD",
    "dropmalcty": "LEBANON",
    "dropmalst": "OR",
    "dropmalzpp": 973559998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414515670,
    "dropsitcph": 5414515648,
    "dropfax": 5414515671
  },
  {
    "dcode": "D",
    "dropkey": "PZ15204",
    "droptype": "D",
    "dropname": "LINCOLN CITY",
    "dropdeladd": "1501 SE EAST DEVILS LAKE RD",
    "dropdelcty": "LINCOLN CITY",
    "dropdelst": "OR",
    "dropdelzpp": 973672621,
    "dropphyadd": "1501 SE EAST DEVILS LAKE RD",
    "dropphycty": "LINCOLN CITY",
    "dropphyst": "OR",
    "dropphyzpp": 973672621,
    "dropmaladd": "1501 SE EAST DEVILS LAKE RD",
    "dropmalcty": "LINCOLN CITY",
    "dropmalst": "OR",
    "dropmalzpp": 973679998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419947910,
    "dropsitcph": 5419947910,
    "dropfax": 5419946098
  },
  {
    "dcode": "D",
    "dropkey": "PZ15209",
    "droptype": "D",
    "dropname": "LONG CREEK",
    "dropdeladd": "610 HWY 395 N",
    "dropdelcty": "LONG CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 978567039,
    "dropphyadd": "610 HWY 395 N",
    "dropphycty": "LONG CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 978567039,
    "dropmaladd": "610 HWY 395 N",
    "dropmalcty": "LONG CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 978567039,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417211062,
    "dropsitcph": 5417211062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15212",
    "droptype": "D",
    "dropname": "LORANE",
    "dropdeladd": "80255 TERRITORIAL RD",
    "dropdelcty": "LORANE",
    "dropdelst": "OR",
    "dropdelzpp": 974519719,
    "dropphyadd": "80255 TERRITORIAL RD",
    "dropphycty": "LORANE",
    "dropphyst": "OR",
    "dropphyzpp": 974519719,
    "dropmaladd": "80255 TERRITORIAL RD",
    "dropmalcty": "LORANE",
    "dropmalst": "OR",
    "dropmalzpp": 974519719,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419422212,
    "dropsitcph": 5419422212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15214",
    "droptype": "D",
    "dropname": "LOSTINE",
    "dropdeladd": "615 ELIZABETH ST",
    "dropdelcty": "LOSTINE",
    "dropdelst": "OR",
    "dropdelzpp": 978572011,
    "dropphyadd": "615 ELIZABETH ST",
    "dropphycty": "LOSTINE",
    "dropphyst": "OR",
    "dropphyzpp": 978572011,
    "dropmaladd": "615 ELIZABETH ST",
    "dropmalcty": "LOSTINE",
    "dropmalst": "OR",
    "dropmalzpp": 978572011,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415692215,
    "dropsitcph": 5415692215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15215",
    "droptype": "D",
    "dropname": "LOWELL",
    "dropdeladd": "135 N MOSS ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "OR",
    "dropdelzpp": 974529742,
    "dropphyadd": "135 N MOSS ST",
    "dropphycty": "LOWELL",
    "dropphyst": "OR",
    "dropphyzpp": 974529742,
    "dropmaladd": "135 N MOSS ST",
    "dropmalcty": "LOWELL",
    "dropmalst": "OR",
    "dropmalzpp": 974529998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419373178,
    "dropsitcph": 5419373178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15216",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "402 IRONWOOD ST",
    "dropdelcty": "LYONS",
    "dropdelst": "OR",
    "dropdelzpp": 973582129,
    "dropphyadd": "402 IRONWOOD ST",
    "dropphycty": "LYONS",
    "dropphyst": "OR",
    "dropphyzpp": 973582129,
    "dropmaladd": "402 IRONWOOD ST",
    "dropmalcty": "LYONS",
    "dropmalst": "OR",
    "dropmalzpp": 973589998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038592985,
    "dropsitcph": 5038592990,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15218",
    "droptype": "D",
    "dropname": "MADRAS",
    "dropdeladd": "73 SE 6TH ST",
    "dropdelcty": "MADRAS",
    "dropdelst": "OR",
    "dropdelzpp": 977411703,
    "dropphyadd": "73 SE 6TH ST",
    "dropphycty": "MADRAS",
    "dropphyst": "OR",
    "dropphyzpp": 977411703,
    "dropmaladd": "73 SE 6TH ST",
    "dropmalcty": "MADRAS",
    "dropmalst": "OR",
    "dropmalzpp": 977419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414757506,
    "dropsitcph": 5414756805,
    "dropfax": 5414752985
  },
  {
    "dcode": "D",
    "dropkey": "PZ15220",
    "droptype": "D",
    "dropname": "MALIN",
    "dropdeladd": "2109 BROADWAY ST",
    "dropdelcty": "MALIN",
    "dropdelst": "OR",
    "dropdelzpp": 976329771,
    "dropphyadd": "2109 BROADWAY ST",
    "dropphycty": "MALIN",
    "dropphyst": "OR",
    "dropphyzpp": 976329771,
    "dropmaladd": "2109 BROADWAY ST",
    "dropmalcty": "MALIN",
    "dropmalst": "OR",
    "dropmalzpp": 976329771,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412389520,
    "dropsitcph": 5412389522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15223",
    "droptype": "D",
    "dropname": "MANZANITA",
    "dropdeladd": "370 LANEDA AVE",
    "dropdelcty": "MANZANITA",
    "dropdelst": "OR",
    "dropdelzpp": 971309995,
    "dropphyadd": "370 LANEDA AVE",
    "dropphycty": "MANZANITA",
    "dropphyst": "OR",
    "dropphyzpp": 971309995,
    "dropmaladd": "370 LANEDA AVE",
    "dropmalcty": "MANZANITA",
    "dropmalst": "OR",
    "dropmalzpp": 971309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033686110,
    "dropsitcph": 5033686110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15224",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "10656 HIGHWAY 126",
    "dropdelcty": "MAPLETON",
    "dropdelst": "OR",
    "dropdelzpp": 974539506,
    "dropphyadd": "10656 HIGHWAY 126",
    "dropphycty": "MAPLETON",
    "dropphyst": "OR",
    "dropphyzpp": 974539506,
    "dropmaladd": "10656 HIGHWAY 126",
    "dropmalcty": "MAPLETON",
    "dropmalst": "OR",
    "dropmalzpp": 974539998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412684840,
    "dropsitcph": 5412684840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15225",
    "droptype": "D",
    "dropname": "MARCOLA",
    "dropdeladd": "92162 MARCOLA RD",
    "dropdelcty": "MARCOLA",
    "dropdelst": "OR",
    "dropdelzpp": 974549789,
    "dropphyadd": "92162 MARCOLA RD",
    "dropphycty": "MARCOLA",
    "dropphyst": "OR",
    "dropphyzpp": 974549789,
    "dropmaladd": "92162 MARCOLA RD",
    "dropmalcty": "MARCOLA",
    "dropmalst": "OR",
    "dropmalzpp": 974549998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419330014,
    "dropsitcph": 5419330014,
    "dropfax": 6516751557
  },
  {
    "dcode": "D",
    "dropkey": "PZ15230",
    "droptype": "D",
    "dropname": "MARYLHURST",
    "dropdeladd": "17600 PACIFIC HWY",
    "dropdelcty": "MARYLHURST",
    "dropdelst": "OR",
    "dropdelzpp": 970367036,
    "dropphyadd": "17600 PACIFIC HWY",
    "dropphycty": "MARYLHURST",
    "dropphyst": "OR",
    "dropphyzpp": 970367036,
    "dropmaladd": "17600 PACIFIC HWY",
    "dropmalcty": "MARYLHURST",
    "dropmalst": "OR",
    "dropmalzpp": 970369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036357265,
    "dropsitcph": 5036357265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15231",
    "droptype": "D",
    "dropname": "MAUPIN",
    "dropdeladd": "402 DESCHUTES AVE",
    "dropdelcty": "MAUPIN",
    "dropdelst": "OR",
    "dropdelzpp": 970377037,
    "dropphyadd": "402 DESCHUTES AVE",
    "dropphycty": "MAUPIN",
    "dropphyst": "OR",
    "dropphyzpp": 970377037,
    "dropmaladd": "402 DESCHUTES AVE",
    "dropmalcty": "MAUPIN",
    "dropmalst": "OR",
    "dropmalzpp": 970379998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413952440,
    "dropsitcph": 5413952440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15243",
    "droptype": "D",
    "dropname": "MCMINNVILLE",
    "dropdeladd": "650 NE 2ND ST",
    "dropdelcty": "MCMINNVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 971284700,
    "dropphyadd": "650 NE 2ND ST",
    "dropphycty": "MCMINNVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 971284700,
    "dropmaladd": "650 NE 2ND ST",
    "dropmalcty": "MCMINNVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 971284700,
    "dropsitphn": 9712013788,
    "dropsitlph": 5034720437,
    "dropsitcph": 5034721877,
    "dropfax": 5034725479
  },
  {
    "dcode": "D",
    "dropkey": "PZ15249",
    "droptype": "D",
    "dropname": "MEDFORD",
    "dropdeladd": "325 S RIVERSIDE AVE",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OR",
    "dropdelzpp": 975017238,
    "dropphyadd": "325 S RIVERSIDE AVE",
    "dropphycty": "MEDFORD",
    "dropphyst": "OR",
    "dropphyzpp": 975017238,
    "dropmaladd": "325 S RIVERSIDE AVE",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OR",
    "dropmalzpp": 975017238,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5412458540,
    "dropfax": 5412459380
  },
  {
    "dcode": "D",
    "dropkey": "PZ15257",
    "droptype": "D",
    "dropname": "MERLIN",
    "dropdeladd": "317 JOSEPHINE ST",
    "dropdelcty": "MERLIN",
    "dropdelst": "OR",
    "dropdelzpp": 975328725,
    "dropphyadd": "317 JOSEPHINE ST",
    "dropphycty": "MERLIN",
    "dropphyst": "OR",
    "dropphyzpp": 975328725,
    "dropmaladd": "317 JOSEPHINE ST",
    "dropmalcty": "MERLIN",
    "dropmalst": "OR",
    "dropmalzpp": 975329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414728152,
    "dropsitcph": 5414728141,
    "dropfax": 5414728141
  },
  {
    "dcode": "D",
    "dropkey": "PZ15258",
    "droptype": "D",
    "dropname": "MERRILL",
    "dropdeladd": "138 E FRONT ST",
    "dropdelcty": "MERRILL",
    "dropdelst": "OR",
    "dropdelzpp": 976339723,
    "dropphyadd": "138 E FRONT ST",
    "dropphycty": "MERRILL",
    "dropphyst": "OR",
    "dropphyzpp": 976339723,
    "dropmaladd": "138 E FRONT ST",
    "dropmalcty": "MERRILL",
    "dropmalst": "OR",
    "dropmalzpp": 976339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417985228,
    "dropsitcph": 5417985228,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15260",
    "droptype": "D",
    "dropname": "MIDLAND",
    "dropdeladd": "10505 HWY 97 S",
    "dropdelcty": "MIDLAND",
    "dropdelst": "OR",
    "dropdelzpp": 976349700,
    "dropphyadd": "10505 HWY 97 S",
    "dropphycty": "MIDLAND",
    "dropphyst": "OR",
    "dropphyzpp": 976349700,
    "dropmaladd": "10505 HWY 97 S",
    "dropmalcty": "MIDLAND",
    "dropmalst": "OR",
    "dropmalzpp": 976349998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418828443,
    "dropsitcph": 5418828443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15263",
    "droptype": "D",
    "dropname": "MILL CITY",
    "dropdeladd": "101 SE KINGWOOD AVE",
    "dropdelcty": "MILL CITY",
    "dropdelst": "OR",
    "dropdelzpp": 973602602,
    "dropphyadd": "101 SE KINGWOOD AVE",
    "dropphycty": "MILL CITY",
    "dropphyst": "OR",
    "dropphyzpp": 973602602,
    "dropmaladd": "101 SE KINGWOOD AVE",
    "dropmalcty": "MILL CITY",
    "dropmalst": "OR",
    "dropmalzpp": 973609998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038972096,
    "dropsitcph": 5038972096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15268",
    "droptype": "D",
    "dropname": "MILTON FREEWATER",
    "dropdeladd": "109 W BROADWAY AVE",
    "dropdelcty": "MILTON FREEWATER",
    "dropdelst": "OR",
    "dropdelzpp": 978621857,
    "dropphyadd": "109 W BROADWAY AVE",
    "dropphycty": "MILTON FREEWATER",
    "dropphyst": "OR",
    "dropphyzpp": 978621857,
    "dropmaladd": "109 W BROADWAY AVE",
    "dropmalcty": "MILTON FREEWATER",
    "dropmalst": "OR",
    "dropmalzpp": 978629998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419384393,
    "dropsitcph": 5419382744,
    "dropfax": 5419389028
  },
  {
    "dcode": "D",
    "dropkey": "PZ15276",
    "droptype": "D",
    "dropname": "MITCHELL",
    "dropdeladd": "212 W MAIN ST",
    "dropdelcty": "MITCHELL",
    "dropdelst": "OR",
    "dropdelzpp": 977509702,
    "dropphyadd": "212 W MAIN ST",
    "dropphycty": "MITCHELL",
    "dropphyst": "OR",
    "dropphyzpp": 977509702,
    "dropmaladd": "212 W MAIN ST",
    "dropmalcty": "MITCHELL",
    "dropmalst": "OR",
    "dropmalzpp": 977509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414623737,
    "dropsitcph": 5414623737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15281",
    "droptype": "D",
    "dropname": "MOLALLA",
    "dropdeladd": "215 ROBBINS ST",
    "dropdelcty": "MOLALLA",
    "dropdelst": "OR",
    "dropdelzpp": 970387038,
    "dropphyadd": "215 ROBBINS ST",
    "dropphycty": "MOLALLA",
    "dropphyst": "OR",
    "dropphyzpp": 970387038,
    "dropmaladd": "215 ROBBINS ST",
    "dropmalcty": "MOLALLA",
    "dropmalst": "OR",
    "dropmalzpp": 970389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038293297,
    "dropsitcph": 5038299179,
    "dropfax": 5038294018
  },
  {
    "dcode": "D",
    "dropkey": "PZ15283",
    "droptype": "D",
    "dropname": "MONMOUTH",
    "dropdeladd": "437 CLAY ST E",
    "dropdelcty": "MONMOUTH",
    "dropdelst": "OR",
    "dropdelzpp": 973612339,
    "dropphyadd": "437 CLAY ST E",
    "dropphycty": "MONMOUTH",
    "dropphyst": "OR",
    "dropphyzpp": 973612339,
    "dropmaladd": "437 CLAY ST E",
    "dropmalcty": "MONMOUTH",
    "dropmalst": "OR",
    "dropmalzpp": 973619998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038383034,
    "dropsitcph": 5038384719,
    "dropfax": 5038385103
  },
  {
    "dcode": "D",
    "dropkey": "PZ15284",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "590 MAIN ST",
    "dropdelcty": "MONROE",
    "dropdelst": "OR",
    "dropdelzpp": 974569606,
    "dropphyadd": "590 MAIN ST",
    "dropphycty": "MONROE",
    "dropphyst": "OR",
    "dropphyzpp": 974569606,
    "dropmaladd": "590 MAIN ST",
    "dropmalcty": "MONROE",
    "dropmalst": "OR",
    "dropmalzpp": 974569998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418476008,
    "dropsitcph": 5418475348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15285",
    "droptype": "D",
    "dropname": "MONUMENT",
    "dropdeladd": "177 NORTH ST",
    "dropdelcty": "MONUMENT",
    "dropdelst": "OR",
    "dropdelzpp": 978643318,
    "dropphyadd": "177 NORTH ST",
    "dropphycty": "MONUMENT",
    "dropphyst": "OR",
    "dropphyzpp": 978643318,
    "dropmaladd": "177 NORTH ST",
    "dropmalcty": "MONUMENT",
    "dropmalst": "OR",
    "dropmalzpp": 978649998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419342223,
    "dropsitcph": 5419342223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15286",
    "droptype": "D",
    "dropname": "MORO",
    "dropdeladd": "109 1ST ST",
    "dropdelcty": "MORO",
    "dropdelst": "OR",
    "dropdelzpp": 970397039,
    "dropphyadd": "109 1ST ST",
    "dropphycty": "MORO",
    "dropphyst": "OR",
    "dropphyzpp": 970397039,
    "dropmaladd": "109 1ST ST",
    "dropmalcty": "MORO",
    "dropmalst": "OR",
    "dropmalzpp": 970397039,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415653270,
    "dropsitcph": 5415653270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15287",
    "droptype": "D",
    "dropname": "MOSIER",
    "dropdeladd": "1001 3RD AVE",
    "dropdelcty": "MOSIER",
    "dropdelst": "OR",
    "dropdelzpp": 970407040,
    "dropphyadd": "1001 3RD AVE",
    "dropphycty": "MOSIER",
    "dropphyst": "OR",
    "dropphyzpp": 970407040,
    "dropmaladd": "1001 3RD AVE",
    "dropmalcty": "MOSIER",
    "dropmalst": "OR",
    "dropmalzpp": 970409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414783448,
    "dropsitcph": 5414783448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15288",
    "droptype": "D",
    "dropname": "MOUNT ANGEL",
    "dropdeladd": "90 N GARFIELD ST",
    "dropdelcty": "MOUNT ANGEL",
    "dropdelst": "OR",
    "dropdelzpp": 973629800,
    "dropphyadd": "90 N GARFIELD ST",
    "dropphycty": "MOUNT ANGEL",
    "dropphyst": "OR",
    "dropphyzpp": 973629800,
    "dropmaladd": "90 N GARFIELD ST",
    "dropmalcty": "MOUNT ANGEL",
    "dropmalst": "OR",
    "dropmalzpp": 973629998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038459270,
    "dropsitcph": 5038459270,
    "dropfax": 5038459271
  },
  {
    "dcode": "D",
    "dropkey": "PZ15290",
    "droptype": "D",
    "dropname": "MOUNT HOOD PARKDALE",
    "dropdeladd": "5000 BASELINE DR",
    "dropdelcty": "MOUNT HOOD PARKDALE",
    "dropdelst": "OR",
    "dropdelzpp": 970417041,
    "dropphyadd": "5000 BASELINE DR",
    "dropphycty": "MOUNT HOOD PARKDALE",
    "dropphyst": "OR",
    "dropphyzpp": 970417041,
    "dropmaladd": "5000 BASELINE DR",
    "dropmalcty": "MOUNT HOOD PARKDALE",
    "dropmalst": "OR",
    "dropmalzpp": 970419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413526606,
    "dropsitcph": 5413526606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15292",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "101 W MAIN ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "OR",
    "dropdelzpp": 978655000,
    "dropphyadd": "101 W MAIN ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "OR",
    "dropphyzpp": 978655000,
    "dropmaladd": "101 W MAIN ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "OR",
    "dropmalzpp": 978659998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419324818,
    "dropsitcph": 5419324818,
    "dropfax": 5419324818
  },
  {
    "dcode": "D",
    "dropkey": "PZ15298",
    "droptype": "D",
    "dropname": "MULINO",
    "dropdeladd": "13789 S MULINO RD",
    "dropdelcty": "MULINO",
    "dropdelst": "OR",
    "dropdelzpp": 970427042,
    "dropphyadd": "13789 S MULINO RD",
    "dropphycty": "MULINO",
    "dropphyst": "OR",
    "dropphyzpp": 970427042,
    "dropmaladd": "13789 S MULINO RD",
    "dropmalcty": "MULINO",
    "dropmalst": "OR",
    "dropmalzpp": 970427042,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038295294,
    "dropsitcph": 5038293235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15301",
    "droptype": "D",
    "dropname": "MURPHY",
    "dropdeladd": "7200 WILLIAMS HWY",
    "dropdelcty": "MURPHY",
    "dropdelst": "OR",
    "dropdelzpp": 975339700,
    "dropphyadd": "7200 WILLIAMS HWY",
    "dropphycty": "MURPHY",
    "dropphyst": "OR",
    "dropphyzpp": 975339700,
    "dropmaladd": "7200 WILLIAMS HWY",
    "dropmalcty": "MURPHY",
    "dropmalst": "OR",
    "dropmalzpp": 975339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418622800,
    "dropsitcph": 5418622800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15303",
    "droptype": "D",
    "dropname": "MYRTLE CREEK",
    "dropdeladd": "124 BROADWAY ST",
    "dropdelcty": "MYRTLE CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 974579665,
    "dropphyadd": "124 BROADWAY ST",
    "dropphycty": "MYRTLE CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 974579665,
    "dropmaladd": "124 BROADWAY ST",
    "dropmalcty": "MYRTLE CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 974579998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418636002,
    "dropsitcph": 5418636002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15305",
    "droptype": "D",
    "dropname": "MYRTLE POINT",
    "dropdeladd": "514 ASH ST",
    "dropdelcty": "MYRTLE POINT",
    "dropdelst": "OR",
    "dropdelzpp": 974581033,
    "dropphyadd": "514 ASH ST",
    "dropphycty": "MYRTLE POINT",
    "dropphyst": "OR",
    "dropphyzpp": 974581033,
    "dropmaladd": "514 ASH ST",
    "dropmalcty": "MYRTLE POINT",
    "dropmalst": "OR",
    "dropmalzpp": 974589998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415725051,
    "dropsitcph": 5415724078,
    "dropfax": 5415727849
  },
  {
    "dcode": "D",
    "dropkey": "PZ15316",
    "droptype": "D",
    "dropname": "NEHALEM",
    "dropdeladd": "12810 H ST",
    "dropdelcty": "NEHALEM",
    "dropdelst": "OR",
    "dropdelzpp": 971319518,
    "dropphyadd": "12810 H ST",
    "dropphycty": "NEHALEM",
    "dropphyst": "OR",
    "dropphyzpp": 971319518,
    "dropmaladd": "12810 H ST",
    "dropmalcty": "NEHALEM",
    "dropmalst": "OR",
    "dropmalzpp": 971319998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033686109,
    "dropsitcph": 5033686109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15318",
    "droptype": "D",
    "dropname": "NEOTSU",
    "dropdeladd": "4994 N HIGHWAY 101",
    "dropdelcty": "NEOTSU",
    "dropdelst": "OR",
    "dropdelzpp": 973649778,
    "dropphyadd": "4994 N HIGHWAY 101",
    "dropphycty": "NEOTSU",
    "dropphyst": "OR",
    "dropphyzpp": 973649778,
    "dropmaladd": "4994 N HIGHWAY 101",
    "dropmalcty": "NEOTSU",
    "dropmalst": "OR",
    "dropmalzpp": 973649998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419943141,
    "dropsitcph": 5419943141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15324",
    "droptype": "D",
    "dropname": "NEW PINE CREEK",
    "dropdeladd": "11166 HIGHWAY 395",
    "dropdelcty": "NEW PINE CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 976359702,
    "dropphyadd": "11166 HIGHWAY 395",
    "dropphycty": "NEW PINE CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 976359702,
    "dropmaladd": "11166 HIGHWAY 395",
    "dropmalcty": "NEW PINE CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 976359702,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419472686,
    "dropsitcph": 5419472686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15326",
    "droptype": "D",
    "dropname": "NEWBERG",
    "dropdeladd": "401 E 1ST ST",
    "dropdelcty": "NEWBERG",
    "dropdelst": "OR",
    "dropdelzpp": 971322928,
    "dropphyadd": "401 E 1ST ST",
    "dropphycty": "NEWBERG",
    "dropphyst": "OR",
    "dropphyzpp": 971322928,
    "dropmaladd": "401 E 1ST ST",
    "dropmalcty": "NEWBERG",
    "dropmalst": "OR",
    "dropmalzpp": 971329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035383820,
    "dropsitcph": 5035548014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15327",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "310 SW 2ND ST",
    "dropdelcty": "NEWPORT",
    "dropdelst": "OR",
    "dropdelzpp": 973653818,
    "dropphyadd": "310 SW 2ND ST",
    "dropphycty": "NEWPORT",
    "dropphyst": "OR",
    "dropphyzpp": 973653818,
    "dropmaladd": "310 SW 2ND ST",
    "dropmalcty": "NEWPORT",
    "dropmalst": "OR",
    "dropmalzpp": 973659998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412652664,
    "dropsitcph": 5415746746,
    "dropfax": 5412653795
  },
  {
    "dcode": "D",
    "dropkey": "PZ15333",
    "droptype": "D",
    "dropname": "NORTH BEND",
    "dropdeladd": "1835 MCPHERSON ST",
    "dropdelcty": "NORTH BEND",
    "dropdelst": "OR",
    "dropdelzpp": 974593409,
    "dropphyadd": "1835 MCPHERSON ST",
    "dropphycty": "NORTH BEND",
    "dropphyst": "OR",
    "dropphyzpp": 974593409,
    "dropmaladd": "1835 MCPHERSON ST",
    "dropmalcty": "NORTH BEND",
    "dropmalst": "OR",
    "dropmalzpp": 974599998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417561223,
    "dropsitcph": 5417562857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15337",
    "droptype": "D",
    "dropname": "NORTH PLAINS",
    "dropdeladd": "31700 NW COMMERCIAL ST",
    "dropdelcty": "NORTH PLAINS",
    "dropdelst": "OR",
    "dropdelzpp": 971336184,
    "dropphyadd": "31700 NW COMMERCIAL ST",
    "dropphycty": "NORTH PLAINS",
    "dropphyst": "OR",
    "dropphyzpp": 971336184,
    "dropmaladd": "31700 NW COMMERCIAL ST",
    "dropmalcty": "NORTH PLAINS",
    "dropmalst": "OR",
    "dropmalzpp": 971339998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036472612,
    "dropsitcph": 5036472612,
    "dropfax": 5036471239
  },
  {
    "dcode": "D",
    "dropkey": "PZ15338",
    "droptype": "D",
    "dropname": "NORTH POWDER",
    "dropdeladd": "205 E ST",
    "dropdelcty": "NORTH POWDER",
    "dropdelst": "OR",
    "dropdelzpp": 978675000,
    "dropphyadd": "205 E ST",
    "dropphycty": "NORTH POWDER",
    "dropphyst": "OR",
    "dropphyzpp": 978675000,
    "dropmaladd": "205 E ST",
    "dropmalcty": "NORTH POWDER",
    "dropmalst": "OR",
    "dropmalzpp": 978679998,
    "dropsitphn": 5412392180,
    "dropsitlph": 5412392180,
    "dropsitcph": 5412392180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15343",
    "droptype": "D",
    "dropname": "NOTI",
    "dropdeladd": "22528 HIGHWAY 126",
    "dropdelcty": "NOTI",
    "dropdelst": "OR",
    "dropdelzpp": 974619702,
    "dropphyadd": "22528 HIGHWAY 126",
    "dropphycty": "NOTI",
    "dropphyst": "OR",
    "dropphyzpp": 974619702,
    "dropmaladd": "22528 HIGHWAY 126",
    "dropmalcty": "NOTI",
    "dropmalst": "OR",
    "dropmalzpp": 974619702,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419357412,
    "dropsitcph": 5419357412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15345",
    "droptype": "D",
    "dropname": "NYSSA",
    "dropdeladd": "16 N 4TH ST",
    "dropdelcty": "NYSSA",
    "dropdelst": "OR",
    "dropdelzpp": 979133906,
    "dropphyadd": "16 N 4TH ST",
    "dropphycty": "NYSSA",
    "dropphyst": "OR",
    "dropphyzpp": 979133906,
    "dropmaladd": "16 N 4TH ST",
    "dropmalcty": "NYSSA",
    "dropmalst": "OR",
    "dropmalzpp": 979139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413723783,
    "dropsitcph": 5413723783,
    "dropfax": 5413723990
  },
  {
    "dcode": "D",
    "dropkey": "PZ15346",
    "droptype": "D",
    "dropname": "O BRIEN",
    "dropdeladd": "33096 REDWOOD HWY",
    "dropdelcty": "O BRIEN",
    "dropdelst": "OR",
    "dropdelzpp": 975349701,
    "dropphyadd": "33096 REDWOOD HWY",
    "dropphycty": "O BRIEN",
    "dropphyst": "OR",
    "dropphyzpp": 975349701,
    "dropmaladd": "33096 REDWOOD HWY",
    "dropmalcty": "O BRIEN",
    "dropmalst": "OR",
    "dropmalzpp": 975349701,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415962101,
    "dropsitcph": 5415962101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15353",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "223 NE 2ND ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "OR",
    "dropdelzpp": 974629754,
    "dropphyadd": "223 NE 2ND ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "OR",
    "dropphyzpp": 974629754,
    "dropmaladd": "223 NE 2ND ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "OR",
    "dropmalzpp": 974629998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414598210,
    "dropsitcph": 5414598210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15354",
    "droptype": "D",
    "dropname": "OAKRIDGE",
    "dropdeladd": "48264 E 1ST ST",
    "dropdelcty": "OAKRIDGE",
    "dropdelst": "OR",
    "dropdelzpp": 974639701,
    "dropphyadd": "48264 E 1ST ST",
    "dropphycty": "OAKRIDGE",
    "dropphyst": "OR",
    "dropphyzpp": 974639701,
    "dropmaladd": "48264 E 1ST ST",
    "dropmalcty": "OAKRIDGE",
    "dropmalst": "OR",
    "dropmalzpp": 974639998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417823651,
    "dropsitcph": 5417823845,
    "dropfax": 5417822359
  },
  {
    "dcode": "D",
    "dropkey": "PZ15358",
    "droptype": "D",
    "dropname": "OCEANSIDE",
    "dropdeladd": "1540 PACIFIC AVE",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "OR",
    "dropdelzpp": 971349100,
    "dropphyadd": "1540 PACIFIC AVE",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "OR",
    "dropphyzpp": 971349100,
    "dropmaladd": "1540 PACIFIC AVE",
    "dropmalcty": "OCEANSIDE",
    "dropmalst": "OR",
    "dropmalzpp": 971349998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038429478,
    "dropsitcph": 5038158086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15359",
    "droptype": "D",
    "dropname": "ODELL",
    "dropdeladd": "3666 ATKINSON DR",
    "dropdelcty": "ODELL",
    "dropdelst": "OR",
    "dropdelzpp": 970447044,
    "dropphyadd": "3666 ATKINSON DR",
    "dropphycty": "ODELL",
    "dropphyst": "OR",
    "dropphyzpp": 970447044,
    "dropmaladd": "3666 ATKINSON DR",
    "dropmalcty": "ODELL",
    "dropmalst": "OR",
    "dropmalzpp": 970449998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413541275,
    "dropsitcph": 5413541275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15362",
    "droptype": "D",
    "dropname": "ONTARIO",
    "dropdeladd": "88 SW 2ND AVE",
    "dropdelcty": "ONTARIO",
    "dropdelst": "OR",
    "dropdelzpp": 979142714,
    "dropphyadd": "88 SW 2ND AVE",
    "dropphycty": "ONTARIO",
    "dropphyst": "OR",
    "dropphyzpp": 979142714,
    "dropmaladd": "88 SW 2ND AVE",
    "dropmalcty": "ONTARIO",
    "dropmalst": "OR",
    "dropmalzpp": 979149998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418896692,
    "dropsitcph": 5418896692,
    "dropfax": 5418898385
  },
  {
    "dcode": "D",
    "dropkey": "PZ15363",
    "droptype": "D",
    "dropname": "OPHIR",
    "dropdeladd": "32865 NESIKA RD",
    "dropdelcty": "OPHIR",
    "dropdelst": "OR",
    "dropdelzpp": 974649700,
    "dropphyadd": "32865 NESIKA RD",
    "dropphycty": "OPHIR",
    "dropphyst": "OR",
    "dropphyzpp": 974649700,
    "dropmaladd": "32865 NESIKA RD",
    "dropmalcty": "OPHIR",
    "dropmalst": "OR",
    "dropmalzpp": 974649998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412942820,
    "dropsitcph": 5412472820,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15365",
    "droptype": "D",
    "dropname": "OREGON CITY",
    "dropdeladd": "19300 MOLALLA AVE",
    "dropdelcty": "OREGON CITY",
    "dropdelst": "OR",
    "dropdelzpp": 970450821,
    "dropphyadd": "19300 MOLALLA AVE",
    "dropphycty": "OREGON CITY",
    "dropphyst": "OR",
    "dropphyzpp": 970450821,
    "dropmaladd": "19300 MOLALLA AVE",
    "dropmalcty": "OREGON CITY",
    "dropmalst": "OR",
    "dropmalzpp": 970450821,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036508725,
    "dropsitcph": 5037222086,
    "dropfax": 5037236913
  },
  {
    "dcode": "D",
    "dropkey": "PZ15372",
    "droptype": "D",
    "dropname": "OTIS",
    "dropdeladd": "1261 SALMON RIVER HWY",
    "dropdelcty": "OTIS",
    "dropdelst": "OR",
    "dropdelzpp": 973689544,
    "dropphyadd": "1261 SALMON RIVER HWY",
    "dropphycty": "OTIS",
    "dropphyst": "OR",
    "dropphyzpp": 973689544,
    "dropmaladd": "1261 SALMON RIVER HWY",
    "dropmalcty": "OTIS",
    "dropmalst": "OR",
    "dropmalzpp": 973689998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419945575,
    "dropsitcph": 5419945575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15376",
    "droptype": "D",
    "dropname": "OXBOW",
    "dropdeladd": "49516 HOMESTEAD RD",
    "dropdelcty": "OXBOW",
    "dropdelst": "OR",
    "dropdelzpp": 978405905,
    "dropphyadd": "49516 HOMESTEAD RD",
    "dropphycty": "OXBOW",
    "dropphyst": "OR",
    "dropphyzpp": 978405905,
    "dropmaladd": "49516 HOMESTEAD RD",
    "dropmalcty": "OXBOW",
    "dropmalst": "OR",
    "dropmalzpp": 978409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417853466,
    "dropsitcph": 5417853466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15377",
    "droptype": "D",
    "dropname": "PACIFIC CITY",
    "dropdeladd": "35230 BROOTEN RD",
    "dropdelcty": "PACIFIC CITY",
    "dropdelst": "OR",
    "dropdelzpp": 971359101,
    "dropphyadd": "35230 BROOTEN RD",
    "dropphycty": "PACIFIC CITY",
    "dropphyst": "OR",
    "dropphyzpp": 971359101,
    "dropmaladd": "35230 BROOTEN RD",
    "dropmalcty": "PACIFIC CITY",
    "dropmalst": "OR",
    "dropmalzpp": 971359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5039656293,
    "dropsitcph": 5039656293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15381",
    "droptype": "D",
    "dropname": "PAISLEY",
    "dropdeladd": "511 MILL ST",
    "dropdelcty": "PAISLEY",
    "dropdelst": "OR",
    "dropdelzpp": 976369716,
    "dropphyadd": "511 MILL ST",
    "dropphycty": "PAISLEY",
    "dropphyst": "OR",
    "dropphyzpp": 976369716,
    "dropmaladd": "511 MILL ST",
    "dropmalcty": "PAISLEY",
    "dropmalst": "OR",
    "dropmalzpp": 976369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419061015,
    "dropsitcph": 5419061015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15386",
    "droptype": "D",
    "dropname": "PAULINA",
    "dropdeladd": "70344 SE PAULINA CITY RD",
    "dropdelcty": "PAULINA",
    "dropdelst": "OR",
    "dropdelzpp": 977519746,
    "dropphyadd": "70344 SE PAULINA CITY RD",
    "dropphycty": "PAULINA",
    "dropphyst": "OR",
    "dropphyzpp": 977519746,
    "dropmaladd": "70344 SE PAULINA CITY RD",
    "dropmalcty": "PAULINA",
    "dropmalst": "OR",
    "dropmalzpp": 977519998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414773261,
    "dropsitcph": 5414773261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15391",
    "droptype": "D",
    "dropname": "PENDLETON",
    "dropdeladd": "104 SW DORION AVE",
    "dropdelcty": "PENDLETON",
    "dropdelst": "OR",
    "dropdelzpp": 978012124,
    "dropphyadd": "104 SW DORION AVE",
    "dropphycty": "PENDLETON",
    "dropphyst": "OR",
    "dropphyzpp": 978012124,
    "dropmaladd": "104 SW DORION AVE",
    "dropmalcty": "PENDLETON",
    "dropmalst": "OR",
    "dropmalzpp": 978019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412784053,
    "dropsitcph": 5412784053,
    "dropfax": 5412767562
  },
  {
    "dcode": "D",
    "dropkey": "PZ15393",
    "droptype": "D",
    "dropname": "PHILOMATH",
    "dropdeladd": "1140 APPLEGATE ST",
    "dropdelcty": "PHILOMATH",
    "dropdelst": "OR",
    "dropdelzpp": 973709416,
    "dropphyadd": "1140 APPLEGATE ST",
    "dropphycty": "PHILOMATH",
    "dropphyst": "OR",
    "dropphyzpp": 973709416,
    "dropmaladd": "1140 APPLEGATE ST",
    "dropmalcty": "PHILOMATH",
    "dropmalst": "OR",
    "dropmalzpp": 973709998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419292531,
    "dropsitcph": 5419292520,
    "dropfax": 5419293585
  },
  {
    "dcode": "D",
    "dropkey": "PZ15394",
    "droptype": "D",
    "dropname": "PHOENIX",
    "dropdeladd": "105 W BOLZ RD",
    "dropdelcty": "PHOENIX",
    "dropdelst": "OR",
    "dropdelzpp": 975359803,
    "dropphyadd": "105 W BOLZ RD",
    "dropphycty": "PHOENIX",
    "dropphyst": "OR",
    "dropphyzpp": 975359803,
    "dropmaladd": "105 W BOLZ RD",
    "dropmalcty": "PHOENIX",
    "dropmalst": "OR",
    "dropmalzpp": 975359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415352757,
    "dropsitcph": 5415352755,
    "dropfax": 5415359111
  },
  {
    "dcode": "D",
    "dropkey": "PZ15396",
    "droptype": "D",
    "dropname": "PILOT ROCK",
    "dropdeladd": "103 NW ALDER PL",
    "dropdelcty": "PILOT ROCK",
    "dropdelst": "OR",
    "dropdelzpp": 978685000,
    "dropphyadd": "103 NW ALDER PL",
    "dropphycty": "PILOT ROCK",
    "dropphyst": "OR",
    "dropphyzpp": 978685000,
    "dropmaladd": "103 NW ALDER PL",
    "dropmalcty": "PILOT ROCK",
    "dropmalst": "OR",
    "dropmalzpp": 978689998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414436191,
    "dropsitcph": 5414436191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15409",
    "droptype": "D",
    "dropname": "PORT ORFORD",
    "dropdeladd": "311 7TH ST",
    "dropdelcty": "PORT ORFORD",
    "dropdelst": "OR",
    "dropdelzpp": 974659571,
    "dropphyadd": "311 7TH ST",
    "dropphycty": "PORT ORFORD",
    "dropphyst": "OR",
    "dropphyzpp": 974659571,
    "dropmaladd": "311 7TH ST",
    "dropmalcty": "PORT ORFORD",
    "dropmalst": "OR",
    "dropmalzpp": 974659998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413324251,
    "dropsitcph": 5413324251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15411",
    "droptype": "D",
    "dropname": "PORTLAND",
    "dropdeladd": "745 NW HOYT ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972088098,
    "dropphyadd": "745 NW HOYT ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972088098,
    "dropmaladd": "745 NW HOYT ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972088098,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032013641,
    "dropsitcph": 5032002400,
    "dropfax": 9712013309
  },
  {
    "dcode": "D",
    "dropkey": "PZ15414",
    "droptype": "D",
    "dropname": "POST",
    "dropdeladd": "28550 SE PAULINA HWY",
    "dropdelcty": "POST",
    "dropdelst": "OR",
    "dropdelzpp": 977529722,
    "dropphyadd": "28550 SE PAULINA HWY",
    "dropphycty": "POST",
    "dropphyst": "OR",
    "dropphyzpp": 977529722,
    "dropmaladd": "28550 SE PAULINA HWY",
    "dropmalcty": "POST",
    "dropmalst": "OR",
    "dropmalzpp": 977529998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414773265,
    "dropsitcph": 5414773265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15415",
    "droptype": "D",
    "dropname": "POWELL BUTTE",
    "dropdeladd": "16052 SW HIGHWAY 126",
    "dropdelcty": "POWELL BUTTE",
    "dropdelst": "OR",
    "dropdelzpp": 977531836,
    "dropphyadd": "16052 SW HIGHWAY 126",
    "dropphycty": "POWELL BUTTE",
    "dropphyst": "OR",
    "dropphyzpp": 977531836,
    "dropmaladd": "16052 SW HIGHWAY 126",
    "dropmalcty": "POWELL BUTTE",
    "dropmalst": "OR",
    "dropmalzpp": 977539998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415485638,
    "dropsitcph": 5415485638,
    "dropfax": 5419236583
  },
  {
    "dcode": "D",
    "dropkey": "PZ15416",
    "droptype": "D",
    "dropname": "POWERS",
    "dropdeladd": "590 2ND AVE",
    "dropdelcty": "POWERS",
    "dropdelst": "OR",
    "dropdelzpp": 974669600,
    "dropphyadd": "590 2ND AVE",
    "dropphycty": "POWERS",
    "dropphyst": "OR",
    "dropphyzpp": 974669600,
    "dropmaladd": "590 2ND AVE",
    "dropmalcty": "POWERS",
    "dropmalst": "OR",
    "dropmalzpp": 974669998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414393131,
    "dropsitcph": 5414393131,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15417",
    "droptype": "D",
    "dropname": "PRAIRIE CITY",
    "dropdeladd": "150 SW MAIN ST",
    "dropdelcty": "PRAIRIE CITY",
    "dropdelst": "OR",
    "dropdelzpp": 978694000,
    "dropphyadd": "150 SW MAIN ST",
    "dropphycty": "PRAIRIE CITY",
    "dropphyst": "OR",
    "dropphyzpp": 978694000,
    "dropmaladd": "150 SW MAIN ST",
    "dropmalcty": "PRAIRIE CITY",
    "dropmalst": "OR",
    "dropmalzpp": 978699998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418204476,
    "dropsitcph": 5418204476,
    "dropfax": 5418204394
  },
  {
    "dcode": "D",
    "dropkey": "PZ15420",
    "droptype": "D",
    "dropname": "PRINEVILLE",
    "dropdeladd": "155 NE COURT ST",
    "dropdelcty": "PRINEVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 977541933,
    "dropphyadd": "155 NE COURT ST",
    "dropphycty": "PRINEVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 977541933,
    "dropmaladd": "155 NE COURT ST",
    "dropmalcty": "PRINEVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 977549998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414160771,
    "dropsitcph": 5414160649,
    "dropfax": 5414473656
  },
  {
    "dcode": "D",
    "dropkey": "PZ15423",
    "droptype": "D",
    "dropname": "PROSPECT",
    "dropdeladd": "291 MILL CREEK DR",
    "dropdelcty": "PROSPECT",
    "dropdelst": "OR",
    "dropdelzpp": 975369722,
    "dropphyadd": "291 MILL CREEK DR",
    "dropphycty": "PROSPECT",
    "dropphyst": "OR",
    "dropphyzpp": 975369722,
    "dropmaladd": "291 MILL CREEK DR",
    "dropmalcty": "PROSPECT",
    "dropmalst": "OR",
    "dropmalzpp": 975369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415603762,
    "dropsitcph": 5415603762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15429",
    "droptype": "D",
    "dropname": "RAINIER",
    "dropdeladd": "207 W A ST",
    "dropdelcty": "RAINIER",
    "dropdelst": "OR",
    "dropdelzpp": 970482630,
    "dropphyadd": "207 W A ST",
    "dropphycty": "RAINIER",
    "dropphyst": "OR",
    "dropphyzpp": 970482630,
    "dropmaladd": "207 W A ST",
    "dropmalcty": "RAINIER",
    "dropmalst": "OR",
    "dropmalzpp": 970489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035562902,
    "dropsitcph": 5035561979,
    "dropfax": 5035561982
  },
  {
    "dcode": "D",
    "dropkey": "PZ15433",
    "droptype": "D",
    "dropname": "REDMOND",
    "dropdeladd": "618 NW HEMLOCK AVE",
    "dropdelcty": "REDMOND",
    "dropdelst": "OR",
    "dropdelzpp": 977561426,
    "dropphyadd": "618 NW HEMLOCK AVE",
    "dropphycty": "REDMOND",
    "dropphyst": "OR",
    "dropphyzpp": 977561426,
    "dropmaladd": "618 NW HEMLOCK AVE",
    "dropmalcty": "REDMOND",
    "dropmalst": "OR",
    "dropmalzpp": 977569998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415049340,
    "dropsitcph": 5419230829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15434",
    "droptype": "D",
    "dropname": "REEDSPORT",
    "dropdeladd": "301 FIR AVE",
    "dropdelcty": "REEDSPORT",
    "dropdelst": "OR",
    "dropdelzpp": 974671424,
    "dropphyadd": "301 FIR AVE",
    "dropphycty": "REEDSPORT",
    "dropphyst": "OR",
    "dropphyzpp": 974671424,
    "dropmaladd": "301 FIR AVE",
    "dropmalcty": "REEDSPORT",
    "dropmalst": "OR",
    "dropmalzpp": 974671424,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412716875,
    "dropsitcph": 5412716790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15437",
    "droptype": "D",
    "dropname": "RHODODENDRON",
    "dropdeladd": "73287 E HIGHWAY 26",
    "dropdelcty": "RHODODENDRON",
    "dropdelst": "OR",
    "dropdelzpp": 970497049,
    "dropphyadd": "73287 E HIGHWAY 26",
    "dropphycty": "RHODODENDRON",
    "dropphyst": "OR",
    "dropphyzpp": 970497049,
    "dropmaladd": "73287 E HIGHWAY 26",
    "dropmalcty": "RHODODENDRON",
    "dropmalst": "OR",
    "dropmalzpp": 970499998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036224232,
    "dropsitcph": 5036224232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15440",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "203 MAIN ST",
    "dropdelcty": "RICHLAND",
    "dropdelst": "OR",
    "dropdelzpp": 978705000,
    "dropphyadd": "203 MAIN ST",
    "dropphycty": "RICHLAND",
    "dropphyst": "OR",
    "dropphyzpp": 978705000,
    "dropmaladd": "203 MAIN ST",
    "dropmalcty": "RICHLAND",
    "dropmalst": "OR",
    "dropmalzpp": 978709998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418936194,
    "dropsitcph": 5418936194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15441",
    "droptype": "D",
    "dropname": "RICKREALL",
    "dropdeladd": "9750 CHURCH ST",
    "dropdelcty": "RICKREALL",
    "dropdelst": "OR",
    "dropdelzpp": 973719770,
    "dropphyadd": "9750 CHURCH ST",
    "dropphycty": "RICKREALL",
    "dropphyst": "OR",
    "dropphyzpp": 973719770,
    "dropmaladd": "9750 CHURCH ST",
    "dropmalcty": "RICKREALL",
    "dropmalst": "OR",
    "dropmalzpp": 973719998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036235702,
    "dropsitcph": 5036235702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15442",
    "droptype": "D",
    "dropname": "RIDDLE",
    "dropdeladd": "330 N MAIN ST",
    "dropdelcty": "RIDDLE",
    "dropdelst": "OR",
    "dropdelzpp": 974699600,
    "dropphyadd": "330 N MAIN ST",
    "dropphycty": "RIDDLE",
    "dropphyst": "OR",
    "dropphyzpp": 974699600,
    "dropmaladd": "330 N MAIN ST",
    "dropmalcty": "RIDDLE",
    "dropmalst": "OR",
    "dropmalzpp": 974699998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418742068,
    "dropsitcph": 5418742200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15443",
    "droptype": "D",
    "dropname": "RILEY",
    "dropdeladd": "17675 HIGHWAY 20 W",
    "dropdelcty": "RILEY",
    "dropdelst": "OR",
    "dropdelzpp": 977589998,
    "dropphyadd": "17675 HIGHWAY 20 W",
    "dropphycty": "RILEY",
    "dropphyst": "OR",
    "dropphyzpp": 977589998,
    "dropmaladd": "17675 HIGHWAY 20 W",
    "dropmalcty": "RILEY",
    "dropmalst": "OR",
    "dropmalzpp": 977589998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414932445,
    "dropsitcph": 5414932445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15453",
    "droptype": "D",
    "dropname": "ROCKAWAY BEACH",
    "dropdeladd": "105 N 3RD AVE",
    "dropdelcty": "ROCKAWAY BEACH",
    "dropdelst": "OR",
    "dropdelzpp": 971369411,
    "dropphyadd": "105 N 3RD AVE",
    "dropphycty": "ROCKAWAY BEACH",
    "dropphyst": "OR",
    "dropphyzpp": 971369411,
    "dropmaladd": "105 N 3RD AVE",
    "dropmalcty": "ROCKAWAY BEACH",
    "dropmalst": "OR",
    "dropmalzpp": 971369998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033552111,
    "dropsitcph": 5033552111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15461",
    "droptype": "D",
    "dropname": "ROGUE RIVER",
    "dropdeladd": "522 E MAIN ST",
    "dropdelcty": "ROGUE RIVER",
    "dropdelst": "OR",
    "dropdelzpp": 975379675,
    "dropphyadd": "522 E MAIN ST",
    "dropphycty": "ROGUE RIVER",
    "dropphyst": "OR",
    "dropphyzpp": 975379675,
    "dropmaladd": "522 E MAIN ST",
    "dropmalcty": "ROGUE RIVER",
    "dropmalst": "OR",
    "dropmalzpp": 975379998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415829744,
    "dropsitcph": 5415829744,
    "dropfax": 5415823576
  },
  {
    "dcode": "D",
    "dropkey": "PZ15465",
    "droptype": "D",
    "dropname": "ROSEBURG",
    "dropdeladd": "519 SE KANE ST",
    "dropdelcty": "ROSEBURG",
    "dropdelst": "OR",
    "dropdelzpp": 974704965,
    "dropphyadd": "519 SE KANE ST",
    "dropphycty": "ROSEBURG",
    "dropphyst": "OR",
    "dropphyzpp": 974704965,
    "dropmaladd": "519 SE KANE ST",
    "dropmalcty": "ROSEBURG",
    "dropmalst": "OR",
    "dropmalzpp": 974709998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416722113,
    "dropsitcph": 5416733620,
    "dropfax": 5416734897
  },
  {
    "dcode": "D",
    "dropkey": "PZ15470",
    "droptype": "D",
    "dropname": "RUFUS",
    "dropdeladd": "308 FOWLER ST",
    "dropdelcty": "RUFUS",
    "dropdelst": "OR",
    "dropdelzpp": 970507050,
    "dropphyadd": "308 FOWLER ST",
    "dropphycty": "RUFUS",
    "dropphyst": "OR",
    "dropphyzpp": 970507050,
    "dropmaladd": "PO BOX 150",
    "dropmalcty": "RUFUS",
    "dropmalst": "OR",
    "dropmalzpp": 970509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417392804,
    "dropsitcph": 5417392804,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15473",
    "droptype": "D",
    "dropname": "SAINT BENEDICT",
    "dropdeladd": "1 ABBEY DR",
    "dropdelcty": "SAINT BENEDICT",
    "dropdelst": "OR",
    "dropdelzpp": 973739700,
    "dropphyadd": "1 ABBEY DR",
    "dropphycty": "SAINT BENEDICT",
    "dropphyst": "OR",
    "dropphyzpp": 973739700,
    "dropmaladd": "1 ABBEY DR",
    "dropmalcty": "SAINT BENEDICT",
    "dropmalst": "OR",
    "dropmalzpp": 973739998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038459686,
    "dropsitcph": 5038459686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15474",
    "droptype": "D",
    "dropname": "SAINT HELENS",
    "dropdeladd": "1571 COLUMBIA BLVD",
    "dropdelcty": "SAINT HELENS",
    "dropdelst": "OR",
    "dropdelzpp": 970516223,
    "dropphyadd": "1571 COLUMBIA BLVD",
    "dropphycty": "SAINT HELENS",
    "dropphyst": "OR",
    "dropphyzpp": 970516223,
    "dropmaladd": "1571 COLUMBIA BLVD",
    "dropmalcty": "SAINT HELENS",
    "dropmalst": "OR",
    "dropmalzpp": 970519998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033972613,
    "dropsitcph": 5033972613,
    "dropfax": 5033660489
  },
  {
    "dcode": "D",
    "dropkey": "PZ15477",
    "droptype": "D",
    "dropname": "SAINT PAUL",
    "dropdeladd": "20180 MAIN ST NE",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "OR",
    "dropdelzpp": 971379640,
    "dropphyadd": "20180 MAIN ST NE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "OR",
    "dropphyzpp": 971379640,
    "dropmaladd": "20180 MAIN ST NE",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "OR",
    "dropmalzpp": 971379998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036332521,
    "dropsitcph": 5036332502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15479",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "1050 25TH ST SE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973015048,
    "dropphyadd": "1050 25TH ST SE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973015048,
    "dropmaladd": "PO BOX 14000",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973099998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033704710,
    "dropsitcph": 5035404502,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": "PZ15484",
    "droptype": "D",
    "dropname": "SANDY",
    "dropdeladd": "17570 WOLF DR",
    "dropdelcty": "SANDY",
    "dropdelst": "OR",
    "dropdelzpp": 970557055,
    "dropphyadd": "17570 WOLF DR",
    "dropphycty": "SANDY",
    "dropphyst": "OR",
    "dropphyzpp": 970557055,
    "dropmaladd": "17570 WOLF DR",
    "dropmalcty": "SANDY",
    "dropmalst": "OR",
    "dropmalzpp": 970559998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036684045,
    "dropsitcph": 5036684055,
    "dropfax": 5036686404
  },
  {
    "dcode": "D",
    "dropkey": "PZ15487",
    "droptype": "D",
    "dropname": "SCAPPOOSE",
    "dropdeladd": "52643 COLUMBIA RIVER HWY",
    "dropdelcty": "SCAPPOOSE",
    "dropdelst": "OR",
    "dropdelzpp": 970563106,
    "dropphyadd": "52643 COLUMBIA RIVER HWY",
    "dropphycty": "SCAPPOOSE",
    "dropphyst": "OR",
    "dropphyzpp": 970563106,
    "dropmaladd": "52643 COLUMBIA RIVER HWY",
    "dropmalcty": "SCAPPOOSE",
    "dropmalst": "OR",
    "dropmalzpp": 970569998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035434951,
    "dropsitcph": 5035434993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15489",
    "droptype": "D",
    "dropname": "SCIO",
    "dropdeladd": "38750 N MAIN ST",
    "dropdelcty": "SCIO",
    "dropdelst": "OR",
    "dropdelzpp": 973749394,
    "dropphyadd": "38750 N MAIN ST",
    "dropphycty": "SCIO",
    "dropphyst": "OR",
    "dropphyzpp": 973749394,
    "dropmaladd": "38750 N MAIN ST",
    "dropmalcty": "SCIO",
    "dropmalst": "OR",
    "dropmalzpp": 973749998,
    "dropsitphn": 9714335104,
    "dropsitlph": 9714335104,
    "dropsitcph": 9714335104,
    "dropfax": 9714335105
  },
  {
    "dcode": "D",
    "dropkey": "PZ15490",
    "droptype": "D",
    "dropname": "SCOTTS MILLS",
    "dropdeladd": "251 3RD ST",
    "dropdelcty": "SCOTTS MILLS",
    "dropdelst": "OR",
    "dropdelzpp": 973759704,
    "dropphyadd": "251 3RD ST",
    "dropphycty": "SCOTTS MILLS",
    "dropphyst": "OR",
    "dropphyzpp": 973759704,
    "dropmaladd": "251 3RD ST",
    "dropmalcty": "SCOTTS MILLS",
    "dropmalst": "OR",
    "dropmalzpp": 973759998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038733415,
    "dropsitcph": 5038733415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15492",
    "droptype": "D",
    "dropname": "SCOTTSBURG",
    "dropdeladd": "35346 STATE HIGHWAY 38",
    "dropdelcty": "SCOTTSBURG",
    "dropdelst": "OR",
    "dropdelzpp": 974739732,
    "dropphyadd": "35346 STATE HIGHWAY 38",
    "dropphycty": "SCOTTSBURG",
    "dropphyst": "OR",
    "dropphyzpp": 974739732,
    "dropmaladd": "35346 STATE HIGHWAY 38",
    "dropmalcty": "SCOTTSBURG",
    "dropmalst": "OR",
    "dropmalzpp": 974739998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415874249,
    "dropsitcph": 5415874249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15495",
    "droptype": "D",
    "dropname": "SEASIDE",
    "dropdeladd": "300 AVENUE A",
    "dropdelcty": "SEASIDE",
    "dropdelst": "OR",
    "dropdelzpp": 971385733,
    "dropphyadd": "300 AVENUE A",
    "dropphycty": "SEASIDE",
    "dropphyst": "OR",
    "dropphyzpp": 971385733,
    "dropmaladd": "300 AVENUE A",
    "dropmalcty": "SEASIDE",
    "dropmalst": "OR",
    "dropmalzpp": 971389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037385283,
    "dropsitcph": 5037385190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15497",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "18398 REDWOOD HWY",
    "dropdelcty": "SELMA",
    "dropdelst": "OR",
    "dropdelzpp": 975389729,
    "dropphyadd": "18398 REDWOOD HWY",
    "dropphycty": "SELMA",
    "dropphyst": "OR",
    "dropphyzpp": 975389729,
    "dropmaladd": "18398 REDWOOD HWY",
    "dropmalcty": "SELMA",
    "dropmalst": "OR",
    "dropmalzpp": 975389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415974851,
    "dropsitcph": 5415974851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15498",
    "droptype": "D",
    "dropname": "SENECA",
    "dropdeladd": "112 BARNES AVE",
    "dropdelcty": "SENECA",
    "dropdelst": "OR",
    "dropdelzpp": 978735000,
    "dropphyadd": "112 BARNES AVE",
    "dropphycty": "SENECA",
    "dropphyst": "OR",
    "dropphyzpp": 978735000,
    "dropmaladd": "112 BARNES AVE",
    "dropmalcty": "SENECA",
    "dropmalst": "OR",
    "dropmalzpp": 978739998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415422232,
    "dropsitcph": 5415422232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15499",
    "droptype": "D",
    "dropname": "SHADY COVE",
    "dropdeladd": "81 WILLIAMS LN",
    "dropdelcty": "SHADY COVE",
    "dropdelst": "OR",
    "dropdelzpp": 975399804,
    "dropphyadd": "81 WILLIAMS LN",
    "dropphycty": "SHADY COVE",
    "dropphyst": "OR",
    "dropphyzpp": 975399804,
    "dropmaladd": "81 WILLIAMS LN",
    "dropmalcty": "SHADY COVE",
    "dropmalst": "OR",
    "dropmalzpp": 975399998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418782888,
    "dropsitcph": 5418782888,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15502",
    "droptype": "D",
    "dropname": "SHANIKO",
    "dropdeladd": "93482 4TH ST",
    "dropdelcty": "SHANIKO",
    "dropdelst": "OR",
    "dropdelzpp": 970577057,
    "dropphyadd": "93482 4TH ST",
    "dropphycty": "SHANIKO",
    "dropphyst": "OR",
    "dropphyzpp": 970577057,
    "dropmaladd": "93482 4TH ST",
    "dropmalcty": "SHANIKO",
    "dropmalst": "OR",
    "dropmalzpp": 970579998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414893222,
    "dropsitcph": 5414893222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15505",
    "droptype": "D",
    "dropname": "SHEDD",
    "dropdeladd": "29996 1ST ST",
    "dropdelcty": "SHEDD",
    "dropdelst": "OR",
    "dropdelzpp": 973779740,
    "dropphyadd": "29996 1ST ST",
    "dropphycty": "SHEDD",
    "dropphyst": "OR",
    "dropphyzpp": 973779740,
    "dropmaladd": "29996 1ST ST",
    "dropmalcty": "SHEDD",
    "dropmalst": "OR",
    "dropmalzpp": 973779998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412092353,
    "dropsitcph": 5412092353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15507",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "137 SE SHERIDAN RD",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "OR",
    "dropdelzpp": 973781947,
    "dropphyadd": "137 SE SHERIDAN RD",
    "dropphycty": "SHERIDAN",
    "dropphyst": "OR",
    "dropphyzpp": 973781947,
    "dropmaladd": "137 SE SHERIDAN RD",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "OR",
    "dropmalzpp": 973789998,
    "dropsitphn": 9718025000,
    "dropsitlph": 9718025000,
    "dropsitcph": 5038435194,
    "dropfax": 9718025002
  },
  {
    "dcode": "D",
    "dropkey": "PZ15508",
    "droptype": "D",
    "dropname": "SHERWOOD",
    "dropdeladd": "16300 SW LANGER DR",
    "dropdelcty": "SHERWOOD",
    "dropdelst": "OR",
    "dropdelzpp": 971408766,
    "dropphyadd": "16300 SW LANGER DR",
    "dropphycty": "SHERWOOD",
    "dropphyst": "OR",
    "dropphyzpp": 971408766,
    "dropmaladd": "16300 SW LANGER DR",
    "dropmalcty": "SHERWOOD",
    "dropmalst": "OR",
    "dropmalzpp": 971409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036250675,
    "dropsitcph": 5036252512,
    "dropfax": 5039251102
  },
  {
    "dcode": "D",
    "dropkey": "PZ15510",
    "droptype": "D",
    "dropname": "SILETZ",
    "dropdeladd": "295 SE GAITHER ST",
    "dropdelcty": "SILETZ",
    "dropdelst": "OR",
    "dropdelzpp": 973809746,
    "dropphyadd": "295 SE GAITHER ST",
    "dropphycty": "SILETZ",
    "dropphyst": "OR",
    "dropphyzpp": 973809746,
    "dropmaladd": "295 SE GAITHER ST",
    "dropmalcty": "SILETZ",
    "dropmalst": "OR",
    "dropmalzpp": 973809998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414442630,
    "dropsitcph": 5414442630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15512",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "65525 HIGHWAY 31",
    "dropdelcty": "SILVER LAKE",
    "dropdelst": "OR",
    "dropdelzpp": 976389504,
    "dropphyadd": "65525 HIGHWAY 31",
    "dropphycty": "SILVER LAKE",
    "dropphyst": "OR",
    "dropphyzpp": 976389504,
    "dropmaladd": "65525 HIGHWAY 31",
    "dropmalcty": "SILVER LAKE",
    "dropmalst": "OR",
    "dropmalzpp": 976389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415762147,
    "dropsitcph": 5415762147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15514",
    "droptype": "D",
    "dropname": "SILVERTON",
    "dropdeladd": "551 N WATER ST",
    "dropdelcty": "SILVERTON",
    "dropdelst": "OR",
    "dropdelzpp": 973811440,
    "dropphyadd": "551 N WATER ST",
    "dropphycty": "SILVERTON",
    "dropphyst": "OR",
    "dropphyzpp": 973811440,
    "dropmaladd": "551 N WATER ST",
    "dropmalcty": "SILVERTON",
    "dropmalst": "OR",
    "dropmalzpp": 973819998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038735172,
    "dropsitcph": 5038735172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15515",
    "droptype": "D",
    "dropname": "SISTERS",
    "dropdeladd": "694 N LARCH ST",
    "dropdelcty": "SISTERS",
    "dropdelst": "OR",
    "dropdelzpp": 977599321,
    "dropphyadd": "694 N LARCH ST",
    "dropphycty": "SISTERS",
    "dropphyst": "OR",
    "dropphyzpp": 977599321,
    "dropmaladd": "694 N LARCH ST",
    "dropmalcty": "SISTERS",
    "dropmalst": "OR",
    "dropmalzpp": 977599998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415498109,
    "dropsitcph": 5415490412,
    "dropfax": 5415498326
  },
  {
    "dcode": "D",
    "dropkey": "PZ15533",
    "droptype": "D",
    "dropname": "SPRAY",
    "dropdeladd": "701 WILLOW ST",
    "dropdelcty": "SPRAY",
    "dropdelst": "OR",
    "dropdelzpp": 978745000,
    "dropphyadd": "701 WILLOW ST",
    "dropphycty": "SPRAY",
    "dropphyst": "OR",
    "dropphyzpp": 978745000,
    "dropmaladd": "701 WILLOW ST",
    "dropmalcty": "SPRAY",
    "dropmalst": "OR",
    "dropmalzpp": 978749998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414683121,
    "dropsitcph": 5414683121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15535",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "760 A ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 974774767,
    "dropphyadd": "760 A ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 974774767,
    "dropmaladd": "760 A ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 974779998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417473384,
    "dropsitcph": 5417478472,
    "dropfax": 5417471045
  },
  {
    "dcode": "D",
    "dropkey": "PZ15603",
    "droptype": "D",
    "dropname": "STANFIELD",
    "dropdeladd": "420 S MAIN ST",
    "dropdelcty": "STANFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 978759729,
    "dropphyadd": "420 S MAIN ST",
    "dropphycty": "STANFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 978759729,
    "dropmaladd": "420 S MAIN ST",
    "dropmalcty": "STANFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 978759729,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414493230,
    "dropsitcph": 5414493230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15607",
    "droptype": "D",
    "dropname": "STAYTON",
    "dropdeladd": "383 N 2ND AVE",
    "dropdelcty": "STAYTON",
    "dropdelst": "OR",
    "dropdelzpp": 973831711,
    "dropphyadd": "383 N 2ND AVE",
    "dropphycty": "STAYTON",
    "dropphyst": "OR",
    "dropphyzpp": 973831711,
    "dropmaladd": "383 N 2ND AVE",
    "dropmalcty": "STAYTON",
    "dropmalst": "OR",
    "dropmalzpp": 973839998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037692688,
    "dropsitcph": 5037698785,
    "dropfax": 5037698792
  },
  {
    "dcode": "D",
    "dropkey": "PZ15611",
    "droptype": "D",
    "dropname": "SUBLIMITY",
    "dropdeladd": "211 NW STARR ST",
    "dropdelcty": "SUBLIMITY",
    "dropdelst": "OR",
    "dropdelzpp": 973859113,
    "dropphyadd": "211 NW STARR ST",
    "dropphycty": "SUBLIMITY",
    "dropphyst": "OR",
    "dropphyzpp": 973859113,
    "dropmaladd": "211 NW STARR ST",
    "dropmalcty": "SUBLIMITY",
    "dropmalst": "OR",
    "dropmalzpp": 973859998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037695399,
    "dropsitcph": 5037695526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15612",
    "droptype": "D",
    "dropname": "SUMMER LAKE",
    "dropdeladd": "54128 HIGHWAY 31",
    "dropdelcty": "SUMMER LAKE",
    "dropdelst": "OR",
    "dropdelzpp": 976408715,
    "dropphyadd": "54128 HIGHWAY 31",
    "dropphycty": "SUMMER LAKE",
    "dropphyst": "OR",
    "dropphyzpp": 976408715,
    "dropmaladd": "54128 HIGHWAY 31",
    "dropmalcty": "SUMMER LAKE",
    "dropmalst": "OR",
    "dropmalzpp": 976409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419433995,
    "dropsitcph": 5419433995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15618",
    "droptype": "D",
    "dropname": "SUMPTER",
    "dropdeladd": "321 SE AUSTIN ST",
    "dropdelcty": "SUMPTER",
    "dropdelst": "OR",
    "dropdelzpp": 978775000,
    "dropphyadd": "321 SE AUSTIN ST",
    "dropphycty": "SUMPTER",
    "dropphyst": "OR",
    "dropphyzpp": 978775000,
    "dropmaladd": "321 SE AUSTIN ST",
    "dropmalcty": "SUMPTER",
    "dropmalst": "OR",
    "dropmalzpp": 978779998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418942323,
    "dropsitcph": 5418942323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15623",
    "droptype": "D",
    "dropname": "SUTHERLIN",
    "dropdeladd": "591 E CENTRAL AVE",
    "dropdelcty": "SUTHERLIN",
    "dropdelst": "OR",
    "dropdelzpp": 974799532,
    "dropphyadd": "591 E CENTRAL AVE",
    "dropphycty": "SUTHERLIN",
    "dropphyst": "OR",
    "dropphyzpp": 974799532,
    "dropmaladd": "591 E CENTRAL AVE",
    "dropmalcty": "SUTHERLIN",
    "dropmalst": "OR",
    "dropmalzpp": 974799998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414593138,
    "dropsitcph": 5414598229,
    "dropfax": 5414597692
  },
  {
    "dcode": "D",
    "dropkey": "PZ15626",
    "droptype": "D",
    "dropname": "SWEET HOME",
    "dropdeladd": "1303 LONG ST",
    "dropdelcty": "SWEET HOME",
    "dropdelst": "OR",
    "dropdelzpp": 973862122,
    "dropphyadd": "1303 LONG ST",
    "dropphycty": "SWEET HOME",
    "dropphyst": "OR",
    "dropphyzpp": 973862122,
    "dropmaladd": "1303 LONG ST",
    "dropmalcty": "SWEET HOME",
    "dropmalst": "OR",
    "dropmalzpp": 973869998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413676927,
    "dropsitcph": 5413676927,
    "dropfax": 5413671614
  },
  {
    "dcode": "D",
    "dropkey": "PZ15627",
    "droptype": "D",
    "dropname": "SWISSHOME",
    "dropdeladd": "13297 HIGHWAY 36",
    "dropdelcty": "SWISSHOME",
    "dropdelst": "OR",
    "dropdelzpp": 974809716,
    "dropphyadd": "13297 HIGHWAY 36",
    "dropphycty": "SWISSHOME",
    "dropphyst": "OR",
    "dropphyzpp": 974809716,
    "dropmaladd": "13297 HIGHWAY 36",
    "dropmalcty": "SWISSHOME",
    "dropmalst": "OR",
    "dropmalzpp": 974809998,
    "dropsitphn": 5413413619,
    "dropsitlph": 5412684735,
    "dropsitcph": 5412684735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15632",
    "droptype": "D",
    "dropname": "TALENT",
    "dropdeladd": "153 E WAGNER ST",
    "dropdelcty": "TALENT",
    "dropdelst": "OR",
    "dropdelzpp": 975409780,
    "dropphyadd": "153 E WAGNER ST",
    "dropphycty": "TALENT",
    "dropphyst": "OR",
    "dropphyzpp": 975409780,
    "dropmaladd": "153 E WAGNER ST",
    "dropmalcty": "TALENT",
    "dropmalst": "OR",
    "dropmalzpp": 975409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415353432,
    "dropsitcph": 5415353430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15633",
    "droptype": "D",
    "dropname": "TANGENT",
    "dropdeladd": "32845 HIGHWAY 99E",
    "dropdelcty": "TANGENT",
    "dropdelst": "OR",
    "dropdelzpp": 973899607,
    "dropphyadd": "32845 HIGHWAY 99E",
    "dropphycty": "TANGENT",
    "dropphyst": "OR",
    "dropphyzpp": 973899607,
    "dropmaladd": "32845 HIGHWAY 99E",
    "dropmalcty": "TANGENT",
    "dropmalst": "OR",
    "dropmalzpp": 973899998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419286248,
    "dropsitcph": 5419286248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15636",
    "droptype": "D",
    "dropname": "TENMILE",
    "dropdeladd": "114 LENA AVE",
    "dropdelcty": "TENMILE",
    "dropdelst": "OR",
    "dropdelzpp": 974819762,
    "dropphyadd": "114 LENA AVE",
    "dropphycty": "TENMILE",
    "dropphyst": "OR",
    "dropphyzpp": 974819762,
    "dropmaladd": "114 LENA AVE",
    "dropmalcty": "TENMILE",
    "dropmalst": "OR",
    "dropmalzpp": 974819998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416796160,
    "dropsitcph": 5416796160,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15637",
    "droptype": "D",
    "dropname": "TERREBONNE",
    "dropdeladd": "8080 11TH ST",
    "dropdelcty": "TERREBONNE",
    "dropdelst": "OR",
    "dropdelzpp": 977609775,
    "dropphyadd": "8080 11TH ST",
    "dropphycty": "TERREBONNE",
    "dropphyst": "OR",
    "dropphyzpp": 977609775,
    "dropmaladd": "8080 11TH ST",
    "dropmalcty": "TERREBONNE",
    "dropmalst": "OR",
    "dropmalzpp": 977609998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419236087,
    "dropsitcph": 5419236087,
    "dropfax": 5415048718
  },
  {
    "dcode": "D",
    "dropkey": "PZ15638",
    "droptype": "D",
    "dropname": "THE DALLES",
    "dropdeladd": "101 W 2ND ST",
    "dropdelcty": "THE DALLES",
    "dropdelst": "OR",
    "dropdelzpp": 970581705,
    "dropphyadd": "101 W 2ND ST",
    "dropphycty": "THE DALLES",
    "dropphyst": "OR",
    "dropphyzpp": 970581705,
    "dropmaladd": "101 W 2ND ST",
    "dropmalcty": "THE DALLES",
    "dropmalst": "OR",
    "dropmalzpp": 970589998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412961065,
    "dropsitcph": 5412961065,
    "dropfax": 5412961464
  },
  {
    "dcode": "D",
    "dropkey": "PZ15642",
    "droptype": "D",
    "dropname": "TIDEWATER",
    "dropdeladd": "14 E BRILEMAR ST",
    "dropdelcty": "TIDEWATER",
    "dropdelst": "OR",
    "dropdelzpp": 973909607,
    "dropphyadd": "14 E BRILEMAR ST",
    "dropphycty": "TIDEWATER",
    "dropphyst": "OR",
    "dropphyzpp": 973909607,
    "dropmaladd": "14 E BRILEMAR ST",
    "dropmalcty": "TIDEWATER",
    "dropmalst": "OR",
    "dropmalzpp": 973909607,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415283025,
    "dropsitcph": 5415283025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15644",
    "droptype": "D",
    "dropname": "TILLAMOOK",
    "dropdeladd": "2200 1ST ST",
    "dropdelcty": "TILLAMOOK",
    "dropdelst": "OR",
    "dropdelzpp": 971412441,
    "dropphyadd": "2200 1ST ST",
    "dropphycty": "TILLAMOOK",
    "dropphyst": "OR",
    "dropphyzpp": 971412441,
    "dropmaladd": "2200 1ST ST",
    "dropmalcty": "TILLAMOOK",
    "dropmalst": "OR",
    "dropmalzpp": 971419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038427679,
    "dropsitcph": 5038422517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15645",
    "droptype": "D",
    "dropname": "TILLER",
    "dropdeladd": "27490 TILLER TRAIL HWY",
    "dropdelcty": "TILLER",
    "dropdelst": "OR",
    "dropdelzpp": 974849702,
    "dropphyadd": "27490 TILLER TRAIL HWY",
    "dropphycty": "TILLER",
    "dropphyst": "OR",
    "dropphyzpp": 974849702,
    "dropmaladd": "27490 TILLER TRAIL HWY",
    "dropmalcty": "TILLER",
    "dropmalst": "OR",
    "dropmalzpp": 974849998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418253864,
    "dropsitcph": 5418253864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15646",
    "droptype": "D",
    "dropname": "TIMBER",
    "dropdeladd": "27650 NW TIMBER RD",
    "dropdelcty": "TIMBER",
    "dropdelst": "OR",
    "dropdelzpp": 971449000,
    "dropphyadd": "27650 NW TIMBER RD",
    "dropphycty": "TIMBER",
    "dropphyst": "OR",
    "dropphyzpp": 971449000,
    "dropmaladd": "27650 NW TIMBER RD",
    "dropmalcty": "TIMBER",
    "dropmalst": "OR",
    "dropmalzpp": 971449000,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033598858,
    "dropsitcph": 5033598858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15649",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "147 NW 1ST ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OR",
    "dropdelzpp": 973911508,
    "dropphyadd": "147 NW 1ST ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OR",
    "dropphyzpp": 973911508,
    "dropmaladd": "147 NW 1ST ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OR",
    "dropmalzpp": 973919998,
    "dropsitphn": 5412942242,
    "dropsitlph": 5672006046,
    "dropsitcph": 5413362132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15653",
    "droptype": "D",
    "dropname": "TRAIL",
    "dropdeladd": "100 OLD HIGHWAY 62",
    "dropdelcty": "TRAIL",
    "dropdelst": "OR",
    "dropdelzpp": 975419749,
    "dropphyadd": "100 OLD HIGHWAY 62",
    "dropphycty": "TRAIL",
    "dropphyst": "OR",
    "dropphyzpp": 975419749,
    "dropmaladd": "100 OLD HIGHWAY 62",
    "dropmalcty": "TRAIL",
    "dropmalst": "OR",
    "dropmalzpp": 975419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418782543,
    "dropsitcph": 5418782543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15657",
    "droptype": "D",
    "dropname": "TROUTDALE",
    "dropdeladd": "647 SW CHERRY PARK RD",
    "dropdelcty": "TROUTDALE",
    "dropdelst": "OR",
    "dropdelzpp": 970607060,
    "dropphyadd": "647 SW CHERRY PARK RD",
    "dropphycty": "TROUTDALE",
    "dropphyst": "OR",
    "dropphyzpp": 970607060,
    "dropmaladd": "647 SW CHERRY PARK RD",
    "dropmalcty": "TROUTDALE",
    "dropmalst": "OR",
    "dropmalzpp": 970609998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036652483,
    "dropsitcph": 5036615490,
    "dropfax": 5036613072
  },
  {
    "dcode": "D",
    "dropkey": "PZ15658",
    "droptype": "D",
    "dropname": "TUALATIN",
    "dropdeladd": "19190 SW 90TH AVE",
    "dropdelcty": "TUALATIN",
    "dropdelst": "OR",
    "dropdelzpp": 970629997,
    "dropphyadd": "19190 SW 90TH AVE",
    "dropphycty": "TUALATIN",
    "dropphyst": "OR",
    "dropphyzpp": 970629997,
    "dropmaladd": "19190 SW 90TH AVE",
    "dropmalcty": "TUALATIN",
    "dropmalst": "OR",
    "dropmalzpp": 970629997,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036921839,
    "dropsitcph": 5036926846,
    "dropfax": 5036916501
  },
  {
    "dcode": "D",
    "dropkey": "PZ15660",
    "droptype": "D",
    "dropname": "TURNER",
    "dropdeladd": "7230 3RD ST SE",
    "dropdelcty": "TURNER",
    "dropdelst": "OR",
    "dropdelzpp": 973929606,
    "dropphyadd": "7230 3RD ST SE",
    "dropphycty": "TURNER",
    "dropphyst": "OR",
    "dropphyzpp": 973929606,
    "dropmaladd": "7230 3RD ST SE",
    "dropmalcty": "TURNER",
    "dropmalst": "OR",
    "dropmalzpp": 973929998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037432168,
    "dropsitcph": 5037432168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15664",
    "droptype": "D",
    "dropname": "TYGH VALLEY",
    "dropdeladd": "57686 TYGH VALLEY RD",
    "dropdelcty": "TYGH VALLEY",
    "dropdelst": "OR",
    "dropdelzpp": 970637063,
    "dropphyadd": "57686 TYGH VALLEY RD",
    "dropphycty": "TYGH VALLEY",
    "dropphyst": "OR",
    "dropphyzpp": 970637063,
    "dropmaladd": "57686 TYGH VALLEY RD",
    "dropmalcty": "TYGH VALLEY",
    "dropmalst": "OR",
    "dropmalzpp": 970639998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414832323,
    "dropsitcph": 5414832323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15665",
    "droptype": "D",
    "dropname": "UKIAH",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "UKIAH",
    "dropdelst": "OR",
    "dropdelzpp": 978805000,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "UKIAH",
    "dropphyst": "OR",
    "dropphyzpp": 978805000,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "UKIAH",
    "dropmalst": "OR",
    "dropmalzpp": 978809998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414273332,
    "dropsitcph": 5414273332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15666",
    "droptype": "D",
    "dropname": "UMATILLA",
    "dropdeladd": "1900 6TH ST",
    "dropdelcty": "UMATILLA",
    "dropdelst": "OR",
    "dropdelzpp": 978825000,
    "dropphyadd": "1900 6TH ST",
    "dropphycty": "UMATILLA",
    "dropphyst": "OR",
    "dropphyzpp": 978825000,
    "dropmaladd": "1900 6TH ST",
    "dropmalcty": "UMATILLA",
    "dropmalst": "OR",
    "dropmalzpp": 978829998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419225662,
    "dropsitcph": 5419225662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15667",
    "droptype": "D",
    "dropname": "UMPQUA",
    "dropdeladd": "6451 FORT MCKAY RD",
    "dropdelcty": "UMPQUA",
    "dropdelst": "OR",
    "dropdelzpp": 974869706,
    "dropphyadd": "6451 FORT MCKAY RD",
    "dropphycty": "UMPQUA",
    "dropphyst": "OR",
    "dropphyzpp": 974869706,
    "dropmaladd": "6451 FORT MCKAY RD",
    "dropmalcty": "UMPQUA",
    "dropmalst": "OR",
    "dropmalzpp": 974869706,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414592721,
    "dropsitcph": 5414592721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15668",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "268 S MAIN ST",
    "dropdelcty": "UNION",
    "dropdelst": "OR",
    "dropdelzpp": 978839419,
    "dropphyadd": "268 S MAIN ST",
    "dropphycty": "UNION",
    "dropphyst": "OR",
    "dropphyzpp": 978839419,
    "dropmaladd": "268 S MAIN ST",
    "dropmalcty": "UNION",
    "dropmalst": "OR",
    "dropmalzpp": 978839998,
    "dropsitphn": 5415627019,
    "dropsitlph": 5415627019,
    "dropsitcph": 5415627019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15671",
    "droptype": "D",
    "dropname": "UNITY",
    "dropdeladd": "105 MAIN ST",
    "dropdelcty": "UNITY",
    "dropdelst": "OR",
    "dropdelzpp": 978845000,
    "dropphyadd": "105 MAIN ST",
    "dropphycty": "UNITY",
    "dropphyst": "OR",
    "dropphyzpp": 978845000,
    "dropmaladd": "105 MAIN ST",
    "dropmalcty": "UNITY",
    "dropmalst": "OR",
    "dropmalzpp": 978849998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414463349,
    "dropsitcph": 5414463349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15679",
    "droptype": "D",
    "dropname": "VALE",
    "dropdeladd": "177 B ST E",
    "dropdelcty": "VALE",
    "dropdelst": "OR",
    "dropdelzpp": 979181351,
    "dropphyadd": "177 B ST E",
    "dropphycty": "VALE",
    "dropphyst": "OR",
    "dropphyzpp": 979181351,
    "dropmaladd": "177 B ST E",
    "dropmalcty": "VALE",
    "dropmalst": "OR",
    "dropmalzpp": 979189998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414739304,
    "dropsitcph": 5414739303,
    "dropfax": 5414734070
  },
  {
    "dcode": "D",
    "dropkey": "PZ15684",
    "droptype": "D",
    "dropname": "VENETA",
    "dropdeladd": "25042 DUNHAM AVE",
    "dropdelcty": "VENETA",
    "dropdelst": "OR",
    "dropdelzpp": 974879791,
    "dropphyadd": "25042 DUNHAM AVE",
    "dropphycty": "VENETA",
    "dropphyst": "OR",
    "dropphyzpp": 974879791,
    "dropmaladd": "25042 DUNHAM AVE",
    "dropmalcty": "VENETA",
    "dropmalst": "OR",
    "dropmalzpp": 974879998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419352541,
    "dropsitcph": 5419359533,
    "dropfax": 5419356425
  },
  {
    "dcode": "D",
    "dropkey": "PZ15686",
    "droptype": "D",
    "dropname": "VERNONIA",
    "dropdeladd": "716 JEFFERSON AVE",
    "dropdelcty": "VERNONIA",
    "dropdelst": "OR",
    "dropdelzpp": 970647064,
    "dropphyadd": "716 JEFFERSON AVE",
    "dropphycty": "VERNONIA",
    "dropphyst": "OR",
    "dropphyzpp": 970647064,
    "dropmaladd": "716 JEFFERSON AVE",
    "dropmalcty": "VERNONIA",
    "dropmalst": "OR",
    "dropmalzpp": 970649998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5034293501,
    "dropsitcph": 5034293501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15687",
    "droptype": "D",
    "dropname": "VIDA",
    "dropdeladd": "45598 MCKENZIE HWY",
    "dropdelcty": "VIDA",
    "dropdelst": "OR",
    "dropdelzpp": 974889708,
    "dropphyadd": "45598 MCKENZIE HWY",
    "dropphycty": "VIDA",
    "dropphyst": "OR",
    "dropphyzpp": 974889708,
    "dropmaladd": "45598 MCKENZIE HWY",
    "dropmalcty": "VIDA",
    "dropmalst": "OR",
    "dropmalzpp": 974889998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418960038,
    "dropsitcph": 5418960038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15695",
    "droptype": "D",
    "dropname": "WALDPORT",
    "dropdeladd": "165 NW JOHN ST",
    "dropdelcty": "WALDPORT",
    "dropdelst": "OR",
    "dropdelzpp": 973946401,
    "dropphyadd": "165 NW JOHN ST",
    "dropphycty": "WALDPORT",
    "dropphyst": "OR",
    "dropphyzpp": 973946401,
    "dropmaladd": "165 NW JOHN ST",
    "dropmalcty": "WALDPORT",
    "dropmalst": "OR",
    "dropmalzpp": 973949998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415637437,
    "dropsitcph": 5415637396,
    "dropfax": 5415633266
  },
  {
    "dcode": "D",
    "dropkey": "PZ15697",
    "droptype": "D",
    "dropname": "WALLOWA",
    "dropdeladd": "104 N STORIE ST",
    "dropdelcty": "WALLOWA",
    "dropdelst": "OR",
    "dropdelzpp": 978855000,
    "dropphyadd": "104 N STORIE ST",
    "dropphycty": "WALLOWA",
    "dropphyst": "OR",
    "dropphyzpp": 978855000,
    "dropmaladd": "104 N STORIE ST",
    "dropmalcty": "WALLOWA",
    "dropmalst": "OR",
    "dropmalzpp": 978859998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418863422,
    "dropsitcph": 5418863422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15698",
    "droptype": "D",
    "dropname": "WALTERVILLE",
    "dropdeladd": "39333 MCKENZIE HWY",
    "dropdelcty": "WALTERVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 974899700,
    "dropphyadd": "39333 MCKENZIE HWY",
    "dropphycty": "WALTERVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 974899700,
    "dropmaladd": "39333 MCKENZIE HWY",
    "dropmalcty": "WALTERVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 974899998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417465184,
    "dropsitcph": 5417465184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15701",
    "droptype": "D",
    "dropname": "WALTON",
    "dropdeladd": "18945 HIGHWAY 126",
    "dropdelcty": "WALTON",
    "dropdelst": "OR",
    "dropdelzpp": 974909716,
    "dropphyadd": "18945 HIGHWAY 126",
    "dropphycty": "WALTON",
    "dropphyst": "OR",
    "dropphyzpp": 974909716,
    "dropmaladd": "18945 HIGHWAY 126",
    "dropmalcty": "WALTON",
    "dropmalst": "OR",
    "dropmalzpp": 974909998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419353411,
    "dropsitcph": 5419353411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15704",
    "droptype": "D",
    "dropname": "WARM SPRINGS",
    "dropdeladd": "2128 WARM SPRINGS RD",
    "dropdelcty": "WARM SPRINGS",
    "dropdelst": "OR",
    "dropdelzpp": 977619700,
    "dropphyadd": "2128 WARM SPRINGS RD",
    "dropphycty": "WARM SPRINGS",
    "dropphyst": "OR",
    "dropphyzpp": 977619700,
    "dropmaladd": "2128 WARM SPRINGS RD",
    "dropmalcty": "WARM SPRINGS",
    "dropmalst": "OR",
    "dropmalzpp": 977619998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415531377,
    "dropsitcph": 5415531377,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15707",
    "droptype": "D",
    "dropname": "WARRENTON",
    "dropdeladd": "99 N MAIN AVE",
    "dropdelcty": "WARRENTON",
    "dropdelst": "OR",
    "dropdelzpp": 971469333,
    "dropphyadd": "99 N MAIN AVE",
    "dropphycty": "WARRENTON",
    "dropphyst": "OR",
    "dropphyzpp": 971469333,
    "dropmaladd": "99 N MAIN AVE",
    "dropmalcty": "WARRENTON",
    "dropmalst": "OR",
    "dropmalzpp": 971469998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038617371,
    "dropsitcph": 5038617035,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15708",
    "droptype": "D",
    "dropname": "WASCO",
    "dropdeladd": "1024 CLARK ST",
    "dropdelcty": "WASCO",
    "dropdelst": "OR",
    "dropdelzpp": 970657065,
    "dropphyadd": "1024 CLARK ST",
    "dropphycty": "WASCO",
    "dropphyst": "OR",
    "dropphyzpp": 970657065,
    "dropmaladd": "1024 CLARK ST",
    "dropmalcty": "WASCO",
    "dropmalst": "OR",
    "dropmalzpp": 970659998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414425259,
    "dropsitcph": 5414425259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15713",
    "droptype": "D",
    "dropname": "WEDDERBURN",
    "dropdeladd": "94221 N BANK ROGUE",
    "dropdelcty": "WEDDERBURN",
    "dropdelst": "OR",
    "dropdelzpp": 974919700,
    "dropphyadd": "94221 N BANK ROGUE",
    "dropphycty": "WEDDERBURN",
    "dropphyst": "OR",
    "dropphyzpp": 974919700,
    "dropmaladd": "94221 N BANK ROGUE",
    "dropmalcty": "WEDDERBURN",
    "dropmalst": "OR",
    "dropmalzpp": 974919998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412476588,
    "dropsitcph": 5412476588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15714",
    "droptype": "D",
    "dropname": "WELCHES",
    "dropdeladd": "24407 E WELCHES RD",
    "dropdelcty": "WELCHES",
    "dropdelst": "OR",
    "dropdelzpp": 970677067,
    "dropphyadd": "24407 E WELCHES RD",
    "dropphycty": "WELCHES",
    "dropphyst": "OR",
    "dropphyzpp": 970677067,
    "dropmaladd": "24407 E WELCHES RD",
    "dropmalcty": "WELCHES",
    "dropmalst": "OR",
    "dropmalzpp": 970679998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036223232,
    "dropsitcph": 5036223232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15718",
    "droptype": "D",
    "dropname": "WEST LINN",
    "dropdeladd": "22220 SALAMO RD",
    "dropdelcty": "WEST LINN",
    "dropdelst": "OR",
    "dropdelzpp": 970687206,
    "dropphyadd": "22220 SALAMO RD",
    "dropphycty": "WEST LINN",
    "dropphyst": "OR",
    "dropphyzpp": 970687206,
    "dropmaladd": "22220 SALAMO RD",
    "dropmalcty": "WEST LINN",
    "dropmalst": "OR",
    "dropmalzpp": 970687206,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036575470,
    "dropsitcph": 5036501863,
    "dropfax": 5036563701
  },
  {
    "dcode": "D",
    "dropkey": "PZ15730",
    "droptype": "D",
    "dropname": "WESTFALL",
    "dropdeladd": "3870 N MAIN ST",
    "dropdelcty": "WESTFALL",
    "dropdelst": "OR",
    "dropdelzpp": 979205000,
    "dropphyadd": "3870 N MAIN ST",
    "dropphycty": "WESTFALL",
    "dropphyst": "OR",
    "dropphyzpp": 979205000,
    "dropmaladd": "3870 N MAIN ST",
    "dropmalcty": "WESTFALL",
    "dropmalst": "OR",
    "dropmalzpp": 979209998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413586245,
    "dropsitcph": 5413586245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15731",
    "droptype": "D",
    "dropname": "WESTFIR",
    "dropdeladd": "47395 WESTOAK RD",
    "dropdelcty": "WESTFIR",
    "dropdelst": "OR",
    "dropdelzpp": 974929740,
    "dropphyadd": "47395 WESTOAK RD",
    "dropphycty": "WESTFIR",
    "dropphyst": "OR",
    "dropphyzpp": 974929740,
    "dropmaladd": "47395 WESTOAK RD",
    "dropmalcty": "WESTFIR",
    "dropmalst": "OR",
    "dropmalzpp": 974929998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417823689,
    "dropsitcph": 5417823689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15732",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "82853 LAKE BLVD",
    "dropdelcty": "WESTLAKE",
    "dropdelst": "OR",
    "dropdelzpp": 974939725,
    "dropphyadd": "82853 LAKE BLVD",
    "dropphycty": "WESTLAKE",
    "dropphyst": "OR",
    "dropphyzpp": 974939725,
    "dropmaladd": "82853 LAKE BLVD",
    "dropmalcty": "WESTLAKE",
    "dropmalst": "OR",
    "dropmalzpp": 974939998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419978678,
    "dropsitcph": 5419978678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15733",
    "droptype": "D",
    "dropname": "WESTON",
    "dropdeladd": "204 E MAIN ST",
    "dropdelcty": "WESTON",
    "dropdelst": "OR",
    "dropdelzpp": 978864000,
    "dropphyadd": "204 E MAIN ST",
    "dropphycty": "WESTON",
    "dropphyst": "OR",
    "dropphyzpp": 978864000,
    "dropmaladd": "204 E MAIN ST",
    "dropmalcty": "WESTON",
    "dropmalst": "OR",
    "dropmalzpp": 978869998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415663632,
    "dropsitcph": 5415663632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15738",
    "droptype": "D",
    "dropname": "WHEELER",
    "dropdeladd": "500 NEHALEM BLVD",
    "dropdelcty": "WHEELER",
    "dropdelst": "OR",
    "dropdelzpp": 971479100,
    "dropphyadd": "500 NEHALEM BLVD",
    "dropphycty": "WHEELER",
    "dropphyst": "OR",
    "dropphyzpp": 971479100,
    "dropmaladd": "500 NEHALEM BLVD",
    "dropmalcty": "WHEELER",
    "dropmalst": "OR",
    "dropmalzpp": 971479998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417916903,
    "dropsitcph": 5417916903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15743",
    "droptype": "D",
    "dropname": "WILBUR",
    "dropdeladd": "8837 OLD HWY 99 N",
    "dropdelcty": "WILBUR",
    "dropdelst": "OR",
    "dropdelzpp": 974949700,
    "dropphyadd": "8837 OLD HWY 99 N",
    "dropphycty": "WILBUR",
    "dropphyst": "OR",
    "dropphyzpp": 974949700,
    "dropmaladd": "8837 OLD HWY 99 N",
    "dropmalcty": "WILBUR",
    "dropmalst": "OR",
    "dropmalzpp": 974949998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412290421,
    "dropsitcph": 5412290421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15749",
    "droptype": "D",
    "dropname": "WILLAMINA",
    "dropdeladd": "360 SW MAPLE ST",
    "dropdelcty": "WILLAMINA",
    "dropdelst": "OR",
    "dropdelzpp": 973962744,
    "dropphyadd": "360 SW MAPLE ST",
    "dropphycty": "WILLAMINA",
    "dropphyst": "OR",
    "dropphyzpp": 973962744,
    "dropmaladd": "360 SW MAPLE ST",
    "dropmalcty": "WILLAMINA",
    "dropmalst": "OR",
    "dropmalzpp": 973969998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5038764291,
    "dropsitcph": 5038764587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15750",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "20160 WILLIAMS HWY",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "OR",
    "dropdelzpp": 975449612,
    "dropphyadd": "20160 WILLIAMS HWY",
    "dropphycty": "WILLIAMS",
    "dropphyst": "OR",
    "dropphyzpp": 975449612,
    "dropmaladd": "20160 WILLIAMS HWY",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "OR",
    "dropmalzpp": 975449998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418469497,
    "dropsitcph": 5418469497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15752",
    "droptype": "D",
    "dropname": "WILSONVILLE",
    "dropdeladd": "29333 SW TOWN CENTER LOOP E",
    "dropdelcty": "WILSONVILLE",
    "dropdelst": "OR",
    "dropdelzpp": 970709465,
    "dropphyadd": "29333 SW TOWN CENTER LOOP E",
    "dropphycty": "WILSONVILLE",
    "dropphyst": "OR",
    "dropphyzpp": 970709465,
    "dropmaladd": "29333 SW TOWN CENTER LOOP E",
    "dropmalcty": "WILSONVILLE",
    "dropmalst": "OR",
    "dropmalzpp": 970709998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036829767,
    "dropsitcph": 5035707703,
    "dropfax": 5036825087
  },
  {
    "dcode": "D",
    "dropkey": "PZ15755",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "5571 NE STEPHENS ST",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "OR",
    "dropdelzpp": 974959700,
    "dropphyadd": "5571 NE STEPHENS ST",
    "dropphycty": "WINCHESTER",
    "dropphyst": "OR",
    "dropphyzpp": 974959700,
    "dropmaladd": "5571 NE STEPHENS ST",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "OR",
    "dropmalzpp": 974959998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416736276,
    "dropsitcph": 5416736220,
    "dropfax": 5419578958
  },
  {
    "dcode": "D",
    "dropkey": "PZ15759",
    "droptype": "D",
    "dropname": "WINSTON",
    "dropdeladd": "291 SW MAIN ST",
    "dropdelcty": "WINSTON",
    "dropdelst": "OR",
    "dropdelzpp": 974969769,
    "dropphyadd": "291 SW MAIN ST",
    "dropphycty": "WINSTON",
    "dropphyst": "OR",
    "dropphyzpp": 974969769,
    "dropmaladd": "291 SW MAIN ST",
    "dropmalcty": "WINSTON",
    "dropmalst": "OR",
    "dropmalzpp": 974969769,
    "dropsitphn": 9712013788,
    "dropsitlph": 5416797654,
    "dropsitcph": 5416797793,
    "dropfax": 5416793787
  },
  {
    "dcode": "D",
    "dropkey": "PZ15762",
    "droptype": "D",
    "dropname": "WOLF CREEK",
    "dropdeladd": "100 RAILROAD AVE",
    "dropdelcty": "WOLF CREEK",
    "dropdelst": "OR",
    "dropdelzpp": 974979603,
    "dropphyadd": "100 RAILROAD AVE",
    "dropphycty": "WOLF CREEK",
    "dropphyst": "OR",
    "dropphyzpp": 974979603,
    "dropmaladd": "100 RAILROAD AVE",
    "dropmalcty": "WOLF CREEK",
    "dropmalst": "OR",
    "dropmalzpp": 974979998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5418663390,
    "dropsitcph": 5418663390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15766",
    "droptype": "D",
    "dropname": "WOODBURN",
    "dropdeladd": "525 N 1ST ST",
    "dropdelcty": "WOODBURN",
    "dropdelst": "OR",
    "dropdelzpp": 970717071,
    "dropphyadd": "525 N 1ST ST",
    "dropphycty": "WOODBURN",
    "dropphyst": "OR",
    "dropphyzpp": 970717071,
    "dropmaladd": "525 N 1ST ST",
    "dropmalcty": "WOODBURN",
    "dropmalst": "OR",
    "dropmalzpp": 970719998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5039820186,
    "dropsitcph": 5039820186,
    "dropfax": 5039828446
  },
  {
    "dcode": "D",
    "dropkey": "PZ15770",
    "droptype": "D",
    "dropname": "YACHATS",
    "dropdeladd": "141 BEACH AVE",
    "dropdelcty": "YACHATS",
    "dropdelst": "OR",
    "dropdelzpp": 974989600,
    "dropphyadd": "141 BEACH AVE",
    "dropphycty": "YACHATS",
    "dropphyst": "OR",
    "dropphyzpp": 974989600,
    "dropmaladd": "141 BEACH AVE",
    "dropmalcty": "YACHATS",
    "dropmalst": "OR",
    "dropmalzpp": 974989998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5415473512,
    "dropsitcph": 5415473512,
    "dropfax": 5415474639
  },
  {
    "dcode": "D",
    "dropkey": "PZ15771",
    "droptype": "D",
    "dropname": "YAMHILL",
    "dropdeladd": "180 W 1ST ST",
    "dropdelcty": "YAMHILL",
    "dropdelst": "OR",
    "dropdelzpp": 971484700,
    "dropphyadd": "180 W 1ST ST",
    "dropphycty": "YAMHILL",
    "dropphyst": "OR",
    "dropphyzpp": 971484700,
    "dropmaladd": "180 W 1ST ST",
    "dropmalcty": "YAMHILL",
    "dropmalst": "OR",
    "dropmalzpp": 971489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036624435,
    "dropsitcph": 5036624435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15772",
    "droptype": "D",
    "dropname": "YONCALLA",
    "dropdeladd": "173 ALDER ST",
    "dropdelcty": "YONCALLA",
    "dropdelst": "OR",
    "dropdelzpp": 974999735,
    "dropphyadd": "173 ALDER ST",
    "dropphycty": "YONCALLA",
    "dropphyst": "OR",
    "dropphyzpp": 974999735,
    "dropmaladd": "173 ALDER ST",
    "dropmalcty": "YONCALLA",
    "dropmalst": "OR",
    "dropmalzpp": 974999735,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413157188,
    "dropsitcph": 5413157188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ15777",
    "droptype": "D",
    "dropname": "PALAU",
    "dropdeladd": "1 PALAU",
    "dropdelcty": "KOROR",
    "dropdelst": "PW",
    "dropdelzpp": 969409997,
    "dropphyadd": "1 PALAU",
    "dropphycty": "KOROR",
    "dropphyst": "PW",
    "dropphyzpp": 969409997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KOROR",
    "dropmalst": "PW",
    "dropmalzpp": 969409998,
    "dropsitphn": 6804885154,
    "dropsitlph": 6804885154,
    "dropsitcph": 6804885154,
    "dropfax": 6804885755
  },
  {
    "dcode": "D",
    "dropkey": "PZ15783",
    "droptype": "D",
    "dropname": "ALTAMONT",
    "dropdeladd": "15537 W 4000 N",
    "dropdelcty": "ALTAMONT",
    "dropdelst": "UT",
    "dropdelzpp": 840018000,
    "dropphyadd": "15537 W 4000 N",
    "dropphycty": "ALTAMONT",
    "dropphyst": "UT",
    "dropphyzpp": 840018000,
    "dropmaladd": "15537 W 4000 N",
    "dropmalcty": "ALTAMONT",
    "dropmalst": "UT",
    "dropmalzpp": 840018000,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354543685,
    "dropsitcph": 4354543685,
    "dropfax": 4354543539
  },
  {
    "dcode": "D",
    "dropkey": "PZ15789",
    "droptype": "D",
    "dropname": "AMERICAN FORK",
    "dropdeladd": "55 N MERCHANT ST",
    "dropdelcty": "AMERICAN FORK",
    "dropdelst": "UT",
    "dropdelzpp": 840035500,
    "dropphyadd": "55 N MERCHANT ST",
    "dropphycty": "AMERICAN FORK",
    "dropphyst": "UT",
    "dropphyzpp": 840039998,
    "dropmaladd": "55 N MERCHANT ST",
    "dropmalcty": "AMERICAN FORK",
    "dropmalst": "UT",
    "dropmalzpp": 840039998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017561691,
    "dropsitcph": 8014927731,
    "dropfax": 8017561691
  },
  {
    "dcode": "D",
    "dropkey": "PZ15793",
    "droptype": "D",
    "dropname": "ANNABELLA",
    "dropdeladd": "35 E 100 N",
    "dropdelcty": "ANNABELLA",
    "dropdelst": "UT",
    "dropdelzpp": 847118001,
    "dropphyadd": "35 E 100 N",
    "dropphycty": "ANNABELLA",
    "dropphyst": "UT",
    "dropphyzpp": 847118001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANNABELLA",
    "dropmalst": "UT",
    "dropmalzpp": 847119998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358966017,
    "dropsitcph": 4358966017,
    "dropfax": 4358966017
  },
  {
    "dcode": "D",
    "dropkey": "PZ15799",
    "droptype": "D",
    "dropname": "AURORA",
    "dropdeladd": "178 W CENTER ST",
    "dropdelcty": "AURORA",
    "dropdelst": "UT",
    "dropdelzpp": 846208001,
    "dropphyadd": "178 W CENTER ST",
    "dropphycty": "AURORA",
    "dropphyst": "UT",
    "dropphyzpp": 846208001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AURORA",
    "dropmalst": "UT",
    "dropmalzpp": 846209998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355297879,
    "dropsitcph": 4355297879,
    "dropfax": 4355293501
  },
  {
    "dcode": "D",
    "dropkey": "PZ15804",
    "droptype": "D",
    "dropname": "BEAR RIVER CITY",
    "dropdeladd": "4670 W 5900 N",
    "dropdelcty": "BEAR RIVER CITY",
    "dropdelst": "UT",
    "dropdelzpp": 843018001,
    "dropphyadd": "4670 W 5900 N",
    "dropphycty": "BEAR RIVER CITY",
    "dropphyst": "UT",
    "dropphyzpp": 843018001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAR RIVER CITY",
    "dropmalst": "UT",
    "dropmalzpp": 843019998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4352798317,
    "dropsitcph": 4352798317,
    "dropfax": 4352798317
  },
  {
    "dcode": "D",
    "dropkey": "PZ15805",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "20 S MAIN ST",
    "dropdelcty": "BEAVER",
    "dropdelst": "UT",
    "dropdelzpp": 847138001,
    "dropphyadd": "20 S MAIN ST",
    "dropphycty": "BEAVER",
    "dropphyst": "UT",
    "dropphyzpp": 847138001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "UT",
    "dropmalzpp": 847139998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354382321,
    "dropsitcph": 4354382321,
    "dropfax": 4354386164
  },
  {
    "dcode": "D",
    "dropkey": "PZ15817",
    "droptype": "D",
    "dropname": "BICKNELL",
    "dropdeladd": "70 E MAIN ST",
    "dropdelcty": "BICKNELL",
    "dropdelst": "UT",
    "dropdelzpp": 847158001,
    "dropphyadd": "70 E MAIN ST",
    "dropphycty": "BICKNELL",
    "dropphyst": "UT",
    "dropphyzpp": 847158001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BICKNELL",
    "dropmalst": "UT",
    "dropmalzpp": 847159998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354253478,
    "dropsitcph": 4354253478,
    "dropfax": 4354253478
  },
  {
    "dcode": "D",
    "dropkey": "PZ15820",
    "droptype": "D",
    "dropname": "BINGHAM CANYON",
    "dropdeladd": "8545 W STATE HWY",
    "dropdelcty": "BINGHAM CANYON",
    "dropdelst": "UT",
    "dropdelzpp": 840069998,
    "dropphyadd": "8545 W STATE HWY",
    "dropphycty": "BINGHAM CANYON",
    "dropphyst": "UT",
    "dropphyzpp": 840069998,
    "dropmaladd": "8545 W STATE HWY",
    "dropmalcty": "BINGHAM CANYON",
    "dropmalst": "UT",
    "dropmalzpp": 840069998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015690066,
    "dropsitcph": 8015690066,
    "dropfax": 8013520446
  },
  {
    "dcode": "D",
    "dropkey": "PZ15824",
    "droptype": "D",
    "dropname": "BLANDING",
    "dropdeladd": "90 N MAIN ST",
    "dropdelcty": "BLANDING",
    "dropdelst": "UT",
    "dropdelzpp": 845115100,
    "dropphyadd": "90 N MAIN ST",
    "dropphycty": "BLANDING",
    "dropphyst": "UT",
    "dropphyzpp": 845115100,
    "dropmaladd": "90 N MAIN ST",
    "dropmalcty": "BLANDING",
    "dropmalst": "UT",
    "dropmalzpp": 845115100,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356782627,
    "dropsitcph": 4356782627,
    "dropfax": 4356783723
  },
  {
    "dcode": "D",
    "dropkey": "PZ15827",
    "droptype": "D",
    "dropname": "BLUEBELL",
    "dropdeladd": "11978 W 4000 N",
    "dropdelcty": "BLUEBELL",
    "dropdelst": "UT",
    "dropdelzpp": 840078001,
    "dropphyadd": "11978 W 4000 N",
    "dropphycty": "BLUEBELL",
    "dropphyst": "UT",
    "dropphyzpp": 840078001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUEBELL",
    "dropmalst": "UT",
    "dropmalzpp": 840079998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354543520,
    "dropsitcph": 4354543520,
    "dropfax": 4354543520
  },
  {
    "dcode": "D",
    "dropkey": "PZ15828",
    "droptype": "D",
    "dropname": "BLUFF",
    "dropdeladd": "55 N 500 E",
    "dropdelcty": "BLUFF",
    "dropdelst": "UT",
    "dropdelzpp": 845128001,
    "dropphyadd": "55 N 500 E",
    "dropphycty": "BLUFF",
    "dropphyst": "UT",
    "dropphyzpp": 845128001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUFF",
    "dropmalst": "UT",
    "dropmalzpp": 845129998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356722228,
    "dropsitcph": 4356722228,
    "dropfax": 4356722228
  },
  {
    "dcode": "D",
    "dropkey": "PZ15836",
    "droptype": "D",
    "dropname": "BOUNTIFUL",
    "dropdeladd": "20 S MAIN ST",
    "dropdelcty": "BOUNTIFUL",
    "dropdelst": "UT",
    "dropdelzpp": 840109998,
    "dropphyadd": "20 S MAIN ST",
    "dropphycty": "BOUNTIFUL",
    "dropphyst": "UT",
    "dropphyzpp": 840109998,
    "dropmaladd": "20 S MAIN ST",
    "dropmalcty": "BOUNTIFUL",
    "dropmalst": "UT",
    "dropmalzpp": 840109998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8012925754,
    "dropsitcph": 8012925754,
    "dropfax": 8012998783
  },
  {
    "dcode": "D",
    "dropkey": "PZ15842",
    "droptype": "D",
    "dropname": "BRIGHAM CITY",
    "dropdeladd": "16 S 100 W",
    "dropdelcty": "BRIGHAM CITY",
    "dropdelst": "UT",
    "dropdelzpp": 843025100,
    "dropphyadd": "16 S 100 W",
    "dropphycty": "BRIGHAM CITY",
    "dropphyst": "UT",
    "dropphyzpp": 843025100,
    "dropmaladd": "16 S 100 W",
    "dropmalcty": "BRIGHAM CITY",
    "dropmalst": "UT",
    "dropmalzpp": 843025100,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357232604,
    "dropsitcph": 4357235234,
    "dropfax": 4357342604
  },
  {
    "dcode": "D",
    "dropkey": "PZ15864",
    "droptype": "D",
    "dropname": "CASTLE DALE",
    "dropdeladd": "55 S CENTER ST",
    "dropdelcty": "CASTLE DALE",
    "dropdelst": "UT",
    "dropdelzpp": 845138001,
    "dropphyadd": "55 S CENTER ST",
    "dropphycty": "CASTLE DALE",
    "dropphyst": "UT",
    "dropphyzpp": 845138001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASTLE DALE",
    "dropmalst": "UT",
    "dropmalzpp": 845139998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4353812393,
    "dropsitcph": 3853008544,
    "dropfax": 3853008642
  },
  {
    "dcode": "D",
    "dropkey": "PZ15867",
    "droptype": "D",
    "dropname": "CEDAR CITY",
    "dropdeladd": "333 N MAIN ST",
    "dropdelcty": "CEDAR CITY",
    "dropdelst": "UT",
    "dropdelzpp": 847209998,
    "dropphyadd": "333 N MAIN ST",
    "dropphycty": "CEDAR CITY",
    "dropphyst": "UT",
    "dropphyzpp": 847209998,
    "dropmaladd": "333 N MAIN ST",
    "dropmalcty": "CEDAR CITY",
    "dropmalst": "UT",
    "dropmalzpp": 847209998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355861093,
    "dropsitcph": 4355866701,
    "dropfax": 4358650110
  },
  {
    "dcode": "D",
    "dropkey": "PZ15870",
    "droptype": "D",
    "dropname": "CEDAR VALLEY",
    "dropdeladd": "103 S 200 E",
    "dropdelcty": "CEDAR VALLEY",
    "dropdelst": "UT",
    "dropdelzpp": 840139997,
    "dropphyadd": "103 S 200 E",
    "dropphycty": "CEDAR VALLEY",
    "dropphyst": "UT",
    "dropphyzpp": 840139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR VALLEY",
    "dropmalst": "UT",
    "dropmalzpp": 840139998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017688379,
    "dropsitcph": 8017688379,
    "dropfax": 8017688379
  },
  {
    "dcode": "D",
    "dropkey": "PZ15874",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "275 N MAIN ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 840141805,
    "dropphyadd": "275 N MAIN ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 840141805,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 840149998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013972536,
    "dropsitcph": 8013972535,
    "dropfax": 8012956539
  },
  {
    "dcode": "D",
    "dropkey": "PZ15880",
    "droptype": "D",
    "dropname": "CIRCLEVILLE",
    "dropdeladd": "143 W MAIN ST",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847238001,
    "dropphyadd": "143 W MAIN ST",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847238001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847239998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355772609,
    "dropsitcph": 4355772609,
    "dropfax": 4355772608
  },
  {
    "dcode": "D",
    "dropkey": "PZ15882",
    "droptype": "D",
    "dropname": "CLARKSTON",
    "dropdeladd": "155 E 100 N",
    "dropdelcty": "CLARKSTON",
    "dropdelst": "UT",
    "dropdelzpp": 843058001,
    "dropphyadd": "155 E 100 N",
    "dropphycty": "CLARKSTON",
    "dropphyst": "UT",
    "dropphyzpp": 843058001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLARKSTON",
    "dropmalst": "UT",
    "dropmalzpp": 843059998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355635962,
    "dropsitcph": 4355635962,
    "dropfax": 4355635962
  },
  {
    "dcode": "D",
    "dropkey": "PZ15883",
    "droptype": "D",
    "dropname": "CLAWSON",
    "dropdeladd": "10 S MAIN ST",
    "dropdelcty": "CLAWSON",
    "dropdelst": "UT",
    "dropdelzpp": 845168001,
    "dropphyadd": "10 S MAIN ST",
    "dropphycty": "CLAWSON",
    "dropphyst": "UT",
    "dropphyzpp": 845168001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLAWSON",
    "dropmalst": "UT",
    "dropmalzpp": 845169998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4353842698,
    "dropsitcph": 4353842698,
    "dropfax": 4353842698
  },
  {
    "dcode": "D",
    "dropkey": "PZ15884",
    "droptype": "D",
    "dropname": "CLEARFIELD",
    "dropdeladd": "98 N MAIN ST",
    "dropdelcty": "CLEARFIELD",
    "dropdelst": "UT",
    "dropdelzpp": 840159998,
    "dropphyadd": "98 N MAIN ST",
    "dropphycty": "CLEARFIELD",
    "dropphyst": "UT",
    "dropphyzpp": 840159998,
    "dropmaladd": "98 N MAIN ST",
    "dropmalcty": "CLEARFIELD",
    "dropmalst": "UT",
    "dropmalzpp": 840159998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017799298,
    "dropsitcph": 8017799110,
    "dropfax": 8018259804
  },
  {
    "dcode": "D",
    "dropkey": "PZ15885",
    "droptype": "D",
    "dropname": "CLEVELAND",
    "dropdeladd": "290 W MAIN ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "UT",
    "dropdelzpp": 845188001,
    "dropphyadd": "290 W MAIN ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "UT",
    "dropphyzpp": 845188001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "UT",
    "dropmalzpp": 845189998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356532910,
    "dropsitcph": 4356532910,
    "dropfax": 4356532910
  },
  {
    "dcode": "D",
    "dropkey": "PZ15889",
    "droptype": "D",
    "dropname": "COALVILLE",
    "dropdeladd": "33 E CENTER ST",
    "dropdelcty": "COALVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 840178001,
    "dropphyadd": "33 E CENTER ST",
    "dropphycty": "COALVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 840178001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COALVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 840179998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4353362505,
    "dropsitcph": 4353362505,
    "dropfax": 4353362505
  },
  {
    "dcode": "D",
    "dropkey": "PZ15895",
    "droptype": "D",
    "dropname": "CORINNE",
    "dropdeladd": "2425 N 4000 W",
    "dropdelcty": "CORINNE",
    "dropdelst": "UT",
    "dropdelzpp": 843078001,
    "dropphyadd": "2425 N 4000 W",
    "dropphycty": "CORINNE",
    "dropphyst": "UT",
    "dropphyzpp": 843078001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORINNE",
    "dropmalst": "UT",
    "dropmalzpp": 843079998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357445191,
    "dropsitcph": 4357445191,
    "dropfax": 4357445191
  },
  {
    "dcode": "D",
    "dropkey": "PZ15944",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "86 S 300 E",
    "dropdelcty": "DELTA",
    "dropdelst": "UT",
    "dropdelzpp": 846248001,
    "dropphyadd": "86 S 300 E",
    "dropphycty": "DELTA",
    "dropphyst": "UT",
    "dropphyzpp": 846248001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DELTA",
    "dropmalst": "UT",
    "dropmalzpp": 846249998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358642811,
    "dropsitcph": 4358645158,
    "dropfax": 4358645158
  },
  {
    "dcode": "D",
    "dropkey": "PZ15950",
    "droptype": "D",
    "dropname": "DRAPER",
    "dropdeladd": "12180 S 300 E",
    "dropdelcty": "DRAPER",
    "dropdelst": "UT",
    "dropdelzpp": 840202099,
    "dropphyadd": "12180 S 300 E",
    "dropphycty": "DRAPER",
    "dropphyst": "UT",
    "dropphyzpp": 840202099,
    "dropmaladd": "12180 S 300 E",
    "dropmalcty": "DRAPER",
    "dropmalst": "UT",
    "dropmalzpp": 840202099,
    "dropsitphn": 8019742558,
    "dropsitlph": 8018160273,
    "dropsitcph": 8015019787,
    "dropfax": 8018160470
  },
  {
    "dcode": "D",
    "dropkey": "PZ15952",
    "droptype": "D",
    "dropname": "DUCHESNE",
    "dropdeladd": "243 E MAIN ST",
    "dropdelcty": "DUCHESNE",
    "dropdelst": "UT",
    "dropdelzpp": 840218001,
    "dropphyadd": "243 E MAIN ST",
    "dropphycty": "DUCHESNE",
    "dropphyst": "UT",
    "dropphyzpp": 840218001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUCHESNE",
    "dropmalst": "UT",
    "dropmalzpp": 840219998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357383071,
    "dropsitcph": 4357382481,
    "dropfax": 4357385767
  },
  {
    "dcode": "D",
    "dropkey": "PZ15954",
    "droptype": "D",
    "dropname": "DUGWAY",
    "dropdeladd": "5326 VALDEZ CIR",
    "dropdelcty": "DUGWAY",
    "dropdelst": "UT",
    "dropdelzpp": 840229998,
    "dropphyadd": "5326 VALDEZ CIR",
    "dropphycty": "DUGWAY",
    "dropphyst": "UT",
    "dropphyzpp": 840229998,
    "dropmaladd": "5326 VALDEZ CIR",
    "dropmalcty": "DUGWAY",
    "dropmalst": "UT",
    "dropmalzpp": 840229998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358314261,
    "dropsitcph": 4358314261,
    "dropfax": 4358314261
  },
  {
    "dcode": "D",
    "dropkey": "PZ15955",
    "droptype": "D",
    "dropname": "DUTCH JOHN",
    "dropdeladd": "690 SOUTH BLVD",
    "dropdelcty": "DUTCH JOHN",
    "dropdelst": "UT",
    "dropdelzpp": 840238002,
    "dropphyadd": "690 SOUTH BLVD",
    "dropphycty": "DUTCH JOHN",
    "dropphyst": "UT",
    "dropphyzpp": 840238002,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUTCH JOHN",
    "dropmalst": "UT",
    "dropmalzpp": 840239998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358853351,
    "dropsitcph": 4358853351,
    "dropfax": 4358853351
  },
  {
    "dcode": "D",
    "dropkey": "PZ15959",
    "droptype": "D",
    "dropname": "EAST CARBON",
    "dropdeladd": "109 W WHITMORE DR",
    "dropdelcty": "EAST CARBON",
    "dropdelst": "UT",
    "dropdelzpp": 845209998,
    "dropphyadd": "109 W WHITMORE DR",
    "dropphycty": "EAST CARBON",
    "dropphyst": "UT",
    "dropphyzpp": 845209998,
    "dropmaladd": "109 W WHITMORE DR",
    "dropmalcty": "EAST CARBON",
    "dropmalst": "UT",
    "dropmalzpp": 845209998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358885533,
    "dropsitcph": 8019802586,
    "dropfax": 4358885533
  },
  {
    "dcode": "D",
    "dropkey": "PZ15963",
    "droptype": "D",
    "dropname": "EDEN",
    "dropdeladd": "2577 N HIGHWAY 162",
    "dropdelcty": "EDEN",
    "dropdelst": "UT",
    "dropdelzpp": 843109998,
    "dropphyadd": "2577 N HIGHWAY 162",
    "dropphycty": "EDEN",
    "dropphyst": "UT",
    "dropphyzpp": 843109998,
    "dropmaladd": "2577 N HIGHWAY 162",
    "dropmalcty": "EDEN",
    "dropmalst": "UT",
    "dropmalzpp": 843109998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017452568,
    "dropsitcph": 8017452568,
    "dropfax": 8017451620
  },
  {
    "dcode": "D",
    "dropkey": "PZ15964",
    "droptype": "D",
    "dropname": "ELBERTA",
    "dropdeladd": "15156 S 12800 W",
    "dropdelcty": "ELBERTA",
    "dropdelst": "UT",
    "dropdelzpp": 846268001,
    "dropphyadd": "15156 S 12800 W",
    "dropphycty": "ELBERTA",
    "dropphyst": "UT",
    "dropphyzpp": 846268001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBERTA",
    "dropmalst": "UT",
    "dropmalzpp": 846269998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8016672021,
    "dropsitcph": 8016672021,
    "dropfax": 8016672021
  },
  {
    "dcode": "D",
    "dropkey": "PZ15966",
    "droptype": "D",
    "dropname": "ELMO",
    "dropdeladd": "100 E MAIN ST",
    "dropdelcty": "ELMO",
    "dropdelst": "UT",
    "dropdelzpp": 845218001,
    "dropphyadd": "100 E MAIN ST",
    "dropphycty": "ELMO",
    "dropphyst": "UT",
    "dropphyzpp": 845218001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMO",
    "dropmalst": "UT",
    "dropmalzpp": 845219998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356532399,
    "dropsitcph": 4356532399,
    "dropfax": 4356532399
  },
  {
    "dcode": "D",
    "dropkey": "PZ15967",
    "droptype": "D",
    "dropname": "ELSINORE",
    "dropdeladd": "27 N CENTER ST",
    "dropdelcty": "ELSINORE",
    "dropdelst": "UT",
    "dropdelzpp": 847248001,
    "dropphyadd": "27 N CENTER ST",
    "dropphycty": "ELSINORE",
    "dropphyst": "UT",
    "dropphyzpp": 847248001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELSINORE",
    "dropmalst": "UT",
    "dropmalzpp": 847249998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355274760,
    "dropsitcph": 4355274760,
    "dropfax": 4355274760
  },
  {
    "dcode": "D",
    "dropkey": "PZ15969",
    "droptype": "D",
    "dropname": "EMERY",
    "dropdeladd": "31 E MAIN ST",
    "dropdelcty": "EMERY",
    "dropdelst": "UT",
    "dropdelzpp": 845228001,
    "dropphyadd": "31 E MAIN ST",
    "dropphycty": "EMERY",
    "dropphyst": "UT",
    "dropphyzpp": 845228001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EMERY",
    "dropmalst": "UT",
    "dropmalzpp": 845229998,
    "dropsitphn": 8019742558,
    "dropsitlph": 3857661334,
    "dropsitcph": 3857661334,
    "dropfax": 3854492126
  },
  {
    "dcode": "D",
    "dropkey": "PZ15973",
    "droptype": "D",
    "dropname": "ENTERPRISE",
    "dropdeladd": "14 W MAIN ST",
    "dropdelcty": "ENTERPRISE",
    "dropdelst": "UT",
    "dropdelzpp": 847258001,
    "dropphyadd": "14 W MAIN ST",
    "dropphycty": "ENTERPRISE",
    "dropphyst": "UT",
    "dropphyzpp": 847258001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENTERPRISE",
    "dropmalst": "UT",
    "dropmalzpp": 847259998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358782513,
    "dropsitcph": 4358782513,
    "dropfax": 4358782713
  },
  {
    "dcode": "D",
    "dropkey": "PZ15975",
    "droptype": "D",
    "dropname": "EPHRAIM",
    "dropdeladd": "55 E 100 N",
    "dropdelcty": "EPHRAIM",
    "dropdelst": "UT",
    "dropdelzpp": 846272760,
    "dropphyadd": "55 E 100 N",
    "dropphycty": "EPHRAIM",
    "dropphyst": "UT",
    "dropphyzpp": 846272760,
    "dropmaladd": "55 E 100 N",
    "dropmalcty": "EPHRAIM",
    "dropmalst": "UT",
    "dropmalzpp": 846272760,
    "dropsitphn": 8019742558,
    "dropsitlph": 4352834189,
    "dropsitcph": 4352834189,
    "dropfax": 4352835307
  },
  {
    "dcode": "D",
    "dropkey": "PZ15977",
    "droptype": "D",
    "dropname": "ESCALANTE",
    "dropdeladd": "230 W MAIN ST",
    "dropdelcty": "ESCALANTE",
    "dropdelst": "UT",
    "dropdelzpp": 847268001,
    "dropphyadd": "230 W MAIN ST",
    "dropphycty": "ESCALANTE",
    "dropphyst": "UT",
    "dropphyzpp": 847268001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ESCALANTE",
    "dropmalst": "UT",
    "dropmalzpp": 847269998,
    "dropsitphn": 8779073286,
    "dropsitlph": 3854466687,
    "dropsitcph": 8779073286,
    "dropfax": 4358264314
  },
  {
    "dcode": "D",
    "dropkey": "PZ15980",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "482 E MAIN ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "UT",
    "dropdelzpp": 846288001,
    "dropphyadd": "482 E MAIN ST",
    "dropphycty": "EUREKA",
    "dropphyst": "UT",
    "dropphyzpp": 846288001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EUREKA",
    "dropmalst": "UT",
    "dropmalzpp": 846289998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354336841,
    "dropsitcph": 4354336841,
    "dropfax": 4354332099
  },
  {
    "dcode": "D",
    "dropkey": "PZ15982",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "62 W CENTER ST",
    "dropdelcty": "FAIRVIEW",
    "dropdelst": "UT",
    "dropdelzpp": 846299996,
    "dropphyadd": "62 W CENTER ST",
    "dropphycty": "FAIRVIEW",
    "dropphyst": "UT",
    "dropphyzpp": 846299996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAIRVIEW",
    "dropmalst": "UT",
    "dropmalzpp": 846299998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354273804,
    "dropsitcph": 4354170023,
    "dropfax": 4354273804
  },
  {
    "dcode": "D",
    "dropkey": "PZ15983",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "145 E STATE ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "UT",
    "dropdelzpp": 840259998,
    "dropphyadd": "145 E STATE ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "UT",
    "dropphyzpp": 840259998,
    "dropmaladd": "145 E STATE ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "UT",
    "dropmalzpp": 840259998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014478389,
    "dropsitcph": 8014478382,
    "dropfax": 8014516547
  },
  {
    "dcode": "D",
    "dropkey": "PZ15987",
    "droptype": "D",
    "dropname": "FERRON",
    "dropdeladd": "60 N 100 W",
    "dropdelcty": "FERRON",
    "dropdelst": "UT",
    "dropdelzpp": 845238001,
    "dropphyadd": "60 N 100 W",
    "dropphycty": "FERRON",
    "dropphyst": "UT",
    "dropphyzpp": 845238001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERRON",
    "dropmalst": "UT",
    "dropmalzpp": 845239998,
    "dropsitphn": 8019742558,
    "dropsitlph": 3853002481,
    "dropsitcph": 3853002468,
    "dropfax": 3853002469
  },
  {
    "dcode": "D",
    "dropkey": "PZ15988",
    "droptype": "D",
    "dropname": "FIELDING",
    "dropdeladd": "25 W MAIN ST",
    "dropdelcty": "FIELDING",
    "dropdelst": "UT",
    "dropdelzpp": 843118001,
    "dropphyadd": "25 W MAIN ST",
    "dropphycty": "FIELDING",
    "dropphyst": "UT",
    "dropphyzpp": 843118001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FIELDING",
    "dropmalst": "UT",
    "dropmalzpp": 843119998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354583675,
    "dropsitcph": 4354583675,
    "dropfax": 4354583675
  },
  {
    "dcode": "D",
    "dropkey": "PZ15989",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "60 E CENTER ST",
    "dropdelcty": "FILLMORE",
    "dropdelst": "UT",
    "dropdelzpp": 846319998,
    "dropphyadd": "60 E CENTER ST",
    "dropphycty": "FILLMORE",
    "dropphyst": "UT",
    "dropphyzpp": 846319998,
    "dropmaladd": "60 E CENTER ST",
    "dropmalcty": "FILLMORE",
    "dropmalst": "UT",
    "dropmalzpp": 846319998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357435748,
    "dropsitcph": 4357435748,
    "dropfax": 4357435748
  },
  {
    "dcode": "D",
    "dropkey": "PZ15996",
    "droptype": "D",
    "dropname": "FORT DUCHESNE",
    "dropdeladd": "7299 E HIGHWAY 40",
    "dropdelcty": "FORT DUCHESNE",
    "dropdelst": "UT",
    "dropdelzpp": 840268001,
    "dropphyadd": "7299 E HIGHWAY 40",
    "dropphycty": "FORT DUCHESNE",
    "dropphyst": "UT",
    "dropphyzpp": 840268001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT DUCHESNE",
    "dropmalst": "UT",
    "dropmalzpp": 840269998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357222039,
    "dropsitcph": 4357224713,
    "dropfax": 4357222429
  },
  {
    "dcode": "D",
    "dropkey": "PZ15997",
    "droptype": "D",
    "dropname": "FOUNTAIN GREEN",
    "dropdeladd": "54 S STATE ST",
    "dropdelcty": "FOUNTAIN GREEN",
    "dropdelst": "UT",
    "dropdelzpp": 846328001,
    "dropphyadd": "54 S STATE ST",
    "dropphycty": "FOUNTAIN GREEN",
    "dropphyst": "UT",
    "dropphyzpp": 846328001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOUNTAIN GREEN",
    "dropmalst": "UT",
    "dropmalzpp": 846329998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354453551,
    "dropsitcph": 4354453551,
    "dropfax": 4354453239
  },
  {
    "dcode": "D",
    "dropkey": "PZ16008",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "95 W LOGAN RD",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "UT",
    "dropdelzpp": 840288001,
    "dropphyadd": "95 W LOGAN RD",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "UT",
    "dropphyzpp": 840288001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "UT",
    "dropmalzpp": 840289998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4359463438,
    "dropsitcph": 4359463438,
    "dropfax": 4359468424
  },
  {
    "dcode": "D",
    "dropkey": "PZ16009",
    "droptype": "D",
    "dropname": "GARLAND",
    "dropdeladd": "11 N MAIN ST",
    "dropdelcty": "GARLAND",
    "dropdelst": "UT",
    "dropdelzpp": 843128001,
    "dropphyadd": "11 N MAIN ST",
    "dropphycty": "GARLAND",
    "dropphyst": "UT",
    "dropphyzpp": 843128001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARLAND",
    "dropmalst": "UT",
    "dropmalzpp": 843129998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4352575890,
    "dropsitcph": 4352575890,
    "dropfax": 4352575890
  },
  {
    "dcode": "D",
    "dropkey": "PZ16010",
    "droptype": "D",
    "dropname": "GARRISON",
    "dropdeladd": "2 S HIGHWAY 21",
    "dropdelcty": "GARRISON",
    "dropdelst": "UT",
    "dropdelzpp": 847288001,
    "dropphyadd": "2 S HIGHWAY 21",
    "dropphycty": "GARRISON",
    "dropphyst": "UT",
    "dropphyzpp": 847288001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARRISON",
    "dropmalst": "UT",
    "dropmalzpp": 847289998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358552184,
    "dropsitcph": 4358552184,
    "dropfax": 4358552184
  },
  {
    "dcode": "D",
    "dropkey": "PZ16013",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "35 S MAIN ST",
    "dropdelcty": "GLENDALE",
    "dropdelst": "UT",
    "dropdelzpp": 847298001,
    "dropphyadd": "35 S MAIN ST",
    "dropphycty": "GLENDALE",
    "dropphyst": "UT",
    "dropphyzpp": 847298001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENDALE",
    "dropmalst": "UT",
    "dropmalzpp": 847299998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356482390,
    "dropsitcph": 4356482390,
    "dropfax": 4356482519
  },
  {
    "dcode": "D",
    "dropkey": "PZ16016",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "80 S CENTER ST",
    "dropdelcty": "GOSHEN",
    "dropdelst": "UT",
    "dropdelzpp": 846338001,
    "dropphyadd": "80 S CENTER ST",
    "dropphycty": "GOSHEN",
    "dropphyst": "UT",
    "dropphyzpp": 846338001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOSHEN",
    "dropmalst": "UT",
    "dropmalzpp": 846339998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8016679945,
    "dropsitcph": 8016679945,
    "dropfax": 8016679978
  },
  {
    "dcode": "D",
    "dropkey": "PZ16020",
    "droptype": "D",
    "dropname": "GRANTSVILLE",
    "dropdeladd": "36 W MAIN ST",
    "dropdelcty": "GRANTSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 840296001,
    "dropphyadd": "36 W MAIN ST",
    "dropphycty": "GRANTSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 840296001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANTSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 840299998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358846216,
    "dropsitcph": 4358846223,
    "dropfax": 4358846216
  },
  {
    "dcode": "D",
    "dropkey": "PZ16022",
    "droptype": "D",
    "dropname": "GREEN RIVER",
    "dropdeladd": "80 E MAIN ST",
    "dropdelcty": "GREEN RIVER",
    "dropdelst": "UT",
    "dropdelzpp": 845259996,
    "dropphyadd": "80 E MAIN ST",
    "dropphycty": "GREEN RIVER",
    "dropphyst": "UT",
    "dropphyzpp": 845259996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN RIVER",
    "dropmalst": "UT",
    "dropmalzpp": 845259998,
    "dropsitphn": 8019742558,
    "dropsitlph": 3853002358,
    "dropsitcph": 3853002358,
    "dropfax": 4355643329
  },
  {
    "dcode": "D",
    "dropkey": "PZ16030",
    "droptype": "D",
    "dropname": "GUNNISON",
    "dropdeladd": "95 W 100 S",
    "dropdelcty": "GUNNISON",
    "dropdelst": "UT",
    "dropdelzpp": 846348001,
    "dropphyadd": "95 W 100 S",
    "dropphycty": "GUNNISON",
    "dropphyst": "UT",
    "dropphyzpp": 846348001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUNNISON",
    "dropmalst": "UT",
    "dropmalzpp": 846349998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355283225,
    "dropsitcph": 4355283225,
    "dropfax": 4355283239
  },
  {
    "dcode": "D",
    "dropkey": "PZ16034",
    "droptype": "D",
    "dropname": "HANKSVILLE",
    "dropdeladd": "130 E 100 N",
    "dropdelcty": "HANKSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847348001,
    "dropphyadd": "130 E 100 N",
    "dropphycty": "HANKSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847348001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANKSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847349998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355423432,
    "dropsitcph": 4355423432,
    "dropfax": 4355423432
  },
  {
    "dcode": "D",
    "dropkey": "PZ16039",
    "droptype": "D",
    "dropname": "HATCH",
    "dropdeladd": "190 N MAIN ST",
    "dropdelcty": "HATCH",
    "dropdelst": "UT",
    "dropdelzpp": 847358001,
    "dropphyadd": "190 N MAIN ST",
    "dropphycty": "HATCH",
    "dropphyst": "UT",
    "dropphyzpp": 847358001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HATCH",
    "dropmalst": "UT",
    "dropmalzpp": 847359998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357354317,
    "dropsitcph": 4357354317,
    "dropfax": 4357354318
  },
  {
    "dcode": "D",
    "dropkey": "PZ16041",
    "droptype": "D",
    "dropname": "HEBER CITY",
    "dropdeladd": "125 E 100 N",
    "dropdelcty": "HEBER CITY",
    "dropdelst": "UT",
    "dropdelzpp": 840323200,
    "dropphyadd": "125 E 100 N",
    "dropphycty": "HEBER CITY",
    "dropphyst": "UT",
    "dropphyzpp": 840323200,
    "dropmaladd": "125 E 100 N",
    "dropmalcty": "HEBER CITY",
    "dropmalst": "UT",
    "dropmalzpp": 840323200,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356572428,
    "dropsitcph": 4356541345,
    "dropfax": 4356541712
  },
  {
    "dcode": "D",
    "dropkey": "PZ16042",
    "droptype": "D",
    "dropname": "HELPER",
    "dropdeladd": "45 S MAIN ST",
    "dropdelcty": "HELPER",
    "dropdelst": "UT",
    "dropdelzpp": 845262600,
    "dropphyadd": "45 S MAIN ST",
    "dropphycty": "HELPER",
    "dropphyst": "UT",
    "dropphyzpp": 845262600,
    "dropmaladd": "45 S MAIN ST",
    "dropmalcty": "HELPER",
    "dropmalst": "UT",
    "dropmalzpp": 845262600,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354723696,
    "dropsitcph": 4354725281,
    "dropfax": 4354725281
  },
  {
    "dcode": "D",
    "dropkey": "PZ16043",
    "droptype": "D",
    "dropname": "HENEFER",
    "dropdeladd": "95 S MAIN ST",
    "dropdelcty": "HENEFER",
    "dropdelst": "UT",
    "dropdelzpp": 840338001,
    "dropphyadd": "95 S MAIN ST",
    "dropphycty": "HENEFER",
    "dropphyst": "UT",
    "dropphyzpp": 840338001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENEFER",
    "dropmalst": "UT",
    "dropmalzpp": 840339998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4353365324,
    "dropsitcph": 4353365324,
    "dropfax": 4353365324
  },
  {
    "dcode": "D",
    "dropkey": "PZ16044",
    "droptype": "D",
    "dropname": "HENRIEVILLE",
    "dropdeladd": "25 STATE HIGHWAY 12",
    "dropdelcty": "HENRIEVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847368001,
    "dropphyadd": "25 STATE HIGHWAY 12",
    "dropphycty": "HENRIEVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847368001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HENRIEVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847369998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356798773,
    "dropsitcph": 4356798773,
    "dropfax": 4356798773
  },
  {
    "dcode": "D",
    "dropkey": "PZ16052",
    "droptype": "D",
    "dropname": "HINCKLEY",
    "dropdeladd": "5 N MAIN ST",
    "dropdelcty": "HINCKLEY",
    "dropdelst": "UT",
    "dropdelzpp": 846358001,
    "dropphyadd": "5 N MAIN ST",
    "dropphycty": "HINCKLEY",
    "dropphyst": "UT",
    "dropphyzpp": 846358001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HINCKLEY",
    "dropmalst": "UT",
    "dropmalzpp": 846359998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358643737,
    "dropsitcph": 4358643737,
    "dropfax": 4358643737
  },
  {
    "dcode": "D",
    "dropkey": "PZ16056",
    "droptype": "D",
    "dropname": "HONEYVILLE",
    "dropdeladd": "2625 W 6980 N",
    "dropdelcty": "HONEYVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 843148001,
    "dropphyadd": "2625 W 6980 N",
    "dropphycty": "HONEYVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 843148001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HONEYVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 843149998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4352798213,
    "dropsitcph": 4352798213,
    "dropfax": 4352798821
  },
  {
    "dcode": "D",
    "dropkey": "PZ16057",
    "droptype": "D",
    "dropname": "HOOPER",
    "dropdeladd": "5948 W 5500 S",
    "dropdelcty": "HOOPER",
    "dropdelst": "UT",
    "dropdelzpp": 843159998,
    "dropphyadd": "5948 W 5500 S",
    "dropphycty": "HOOPER",
    "dropphyst": "UT",
    "dropphyzpp": 843159998,
    "dropmaladd": "5948 W 5500 S",
    "dropmalcty": "HOOPER",
    "dropmalst": "UT",
    "dropmalzpp": 843159998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019853240,
    "dropsitcph": 8019850244,
    "dropfax": 8019853240
  },
  {
    "dcode": "D",
    "dropkey": "PZ16061",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "45 E 100 N",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "UT",
    "dropdelzpp": 845288001,
    "dropphyadd": "45 E 100 N",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "UT",
    "dropphyzpp": 845288001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "UT",
    "dropmalzpp": 845289998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356872514,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16062",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "7785 E 500 S",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 843179998,
    "dropphyadd": "7785 E 500 S",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 843179998,
    "dropmaladd": "7785 E 500 S",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 843179998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 8017452567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16063",
    "droptype": "D",
    "dropname": "HURRICANE",
    "dropdeladd": "1075 W 100 N",
    "dropdelcty": "HURRICANE",
    "dropdelst": "UT",
    "dropdelzpp": 847373700,
    "dropphyadd": "1075 W 100 N",
    "dropphycty": "HURRICANE",
    "dropphyst": "UT",
    "dropphyzpp": 847373700,
    "dropmaladd": "1075 W 100 N",
    "dropmalcty": "HURRICANE",
    "dropmalst": "UT",
    "dropmalzpp": 847373700,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356354781,
    "dropfax": 4356354781
  },
  {
    "dcode": "D",
    "dropkey": "PZ16064",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "25 S 200 W",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "UT",
    "dropdelzpp": 843188001,
    "dropphyadd": "25 S 200 W",
    "dropphycty": "HYDE PARK",
    "dropphyst": "UT",
    "dropphyzpp": 843188001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "UT",
    "dropmalzpp": 843189998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355639181,
    "dropsitcph": 4355639181,
    "dropfax": 4355639181
  },
  {
    "dcode": "D",
    "dropkey": "PZ16065",
    "droptype": "D",
    "dropname": "HYRUM",
    "dropdeladd": "45 E MAIN ST",
    "dropdelcty": "HYRUM",
    "dropdelst": "UT",
    "dropdelzpp": 843199998,
    "dropphyadd": "45 E MAIN ST",
    "dropphycty": "HYRUM",
    "dropphyst": "UT",
    "dropphyzpp": 843199998,
    "dropmaladd": "45 E MAIN ST",
    "dropmalcty": "HYRUM",
    "dropmalst": "UT",
    "dropmalzpp": 843199998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352456071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16071",
    "droptype": "D",
    "dropname": "JENSEN",
    "dropdeladd": "9947 E 6000 S",
    "dropdelcty": "JENSEN",
    "dropdelst": "UT",
    "dropdelzpp": 840359712,
    "dropphyadd": "9947 E 6000 S",
    "dropphycty": "JENSEN",
    "dropphyst": "UT",
    "dropphyzpp": 840359712,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JENSEN",
    "dropmalst": "UT",
    "dropmalzpp": 840359998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357892028,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16073",
    "droptype": "D",
    "dropname": "JUNCTION",
    "dropdeladd": "500 N MAIN ST",
    "dropdelcty": "JUNCTION",
    "dropdelst": "UT",
    "dropdelzpp": 847408001,
    "dropphyadd": "500 N MAIN ST",
    "dropphycty": "JUNCTION",
    "dropphyst": "UT",
    "dropphyzpp": 847408001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JUNCTION",
    "dropmalst": "UT",
    "dropmalzpp": 847409998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355772614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16074",
    "droptype": "D",
    "dropname": "KAMAS",
    "dropdeladd": "55 W 100 N",
    "dropdelcty": "KAMAS",
    "dropdelst": "UT",
    "dropdelzpp": 840368001,
    "dropphyadd": "55 W 100 N",
    "dropphycty": "KAMAS",
    "dropphyst": "UT",
    "dropphyzpp": 840368001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAMAS",
    "dropmalst": "UT",
    "dropmalzpp": 840369998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357834325,
    "dropsitcph": 4352222330,
    "dropfax": 4357834325
  },
  {
    "dcode": "D",
    "dropkey": "PZ16075",
    "droptype": "D",
    "dropname": "KANAB",
    "dropdeladd": "39 S MAIN ST",
    "dropdelcty": "KANAB",
    "dropdelst": "UT",
    "dropdelzpp": 847414300,
    "dropphyadd": "39 S MAIN ST",
    "dropphycty": "KANAB",
    "dropphyst": "UT",
    "dropphyzpp": 847414300,
    "dropmaladd": "39 S MAIN ST",
    "dropmalcty": "KANAB",
    "dropmalst": "UT",
    "dropmalzpp": 847414300,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356442760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16078",
    "droptype": "D",
    "dropname": "KANOSH",
    "dropdeladd": "50 S MAIN ST",
    "dropdelcty": "KANOSH",
    "dropdelst": "UT",
    "dropdelzpp": 846378001,
    "dropphyadd": "50 S MAIN ST",
    "dropphycty": "KANOSH",
    "dropphyst": "UT",
    "dropphyzpp": 846378001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KANOSH",
    "dropmalst": "UT",
    "dropmalzpp": 846379998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357592407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16079",
    "droptype": "D",
    "dropname": "KAYSVILLE",
    "dropdeladd": "285 N MAIN ST",
    "dropdelcty": "KAYSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 840379998,
    "dropphyadd": "285 N MAIN ST",
    "dropphycty": "KAYSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 840379998,
    "dropmaladd": "285 N MAIN ST",
    "dropmalcty": "KAYSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 840379998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015465312,
    "dropsitcph": 8015465307,
    "dropfax": 8015434380
  },
  {
    "dcode": "D",
    "dropkey": "PZ16090",
    "droptype": "D",
    "dropname": "LA SAL",
    "dropdeladd": "2 MAIN ST",
    "dropdelcty": "LA SAL",
    "dropdelst": "UT",
    "dropdelzpp": 845308001,
    "dropphyadd": "2 MAIN ST",
    "dropphycty": "LA SAL",
    "dropphyst": "UT",
    "dropphyzpp": 845308001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA SAL",
    "dropmalst": "UT",
    "dropmalzpp": 845309998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356862265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16091",
    "droptype": "D",
    "dropname": "LA VERKIN",
    "dropdeladd": "55 N STATE ST",
    "dropdelcty": "LA VERKIN",
    "dropdelst": "UT",
    "dropdelzpp": 847458001,
    "dropphyadd": "55 N STATE ST",
    "dropphycty": "LA VERKIN",
    "dropphyst": "UT",
    "dropphyzpp": 847458001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA VERKIN",
    "dropmalst": "UT",
    "dropmalzpp": 847459998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356354977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16096",
    "droptype": "D",
    "dropname": "LAKETOWN",
    "dropdeladd": "80 W CENTER ST",
    "dropdelcty": "LAKETOWN",
    "dropdelst": "UT",
    "dropdelzpp": 840388001,
    "dropphyadd": "80 W CENTER ST",
    "dropphycty": "LAKETOWN",
    "dropphyst": "UT",
    "dropphyzpp": 840388001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKETOWN",
    "dropmalst": "UT",
    "dropmalzpp": 840389998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4359468632,
    "dropfax": 4359468632
  },
  {
    "dcode": "D",
    "dropkey": "PZ16098",
    "droptype": "D",
    "dropname": "LAPOINT",
    "dropdeladd": "10815 E 7000 N",
    "dropdelcty": "LAPOINT",
    "dropdelst": "UT",
    "dropdelzpp": 840398001,
    "dropphyadd": "10815 E 7000 N",
    "dropphycty": "LAPOINT",
    "dropphyst": "UT",
    "dropphyzpp": 840398001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAPOINT",
    "dropmalst": "UT",
    "dropmalzpp": 840399998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352472361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16101",
    "droptype": "D",
    "dropname": "LAYTON",
    "dropdeladd": "1123 N FAIRFIELD RD",
    "dropdelcty": "LAYTON",
    "dropdelst": "UT",
    "dropdelzpp": 840419998,
    "dropphyadd": "1123 N FAIRFIELD RD",
    "dropphycty": "LAYTON",
    "dropphyst": "UT",
    "dropphyzpp": 840419998,
    "dropmaladd": "1123 N FAIRFIELD RD",
    "dropmalcty": "LAYTON",
    "dropmalst": "UT",
    "dropmalzpp": 840419998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015466076,
    "dropsitcph": 8015466072,
    "dropfax": 8015471578
  },
  {
    "dcode": "D",
    "dropkey": "PZ16108",
    "droptype": "D",
    "dropname": "LEHI",
    "dropdeladd": "333 E MAIN ST",
    "dropdelcty": "LEHI",
    "dropdelst": "UT",
    "dropdelzpp": 840439998,
    "dropphyadd": "333 E MAIN ST",
    "dropphycty": "LEHI",
    "dropphyst": "UT",
    "dropphyzpp": 840439998,
    "dropmaladd": "333 E MAIN ST",
    "dropmalcty": "LEHI",
    "dropmalst": "UT",
    "dropmalzpp": 840439998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017661572,
    "dropsitcph": 8017661562,
    "dropfax": 8017668280
  },
  {
    "dcode": "D",
    "dropkey": "PZ16110",
    "droptype": "D",
    "dropname": "LEVAN",
    "dropdeladd": "75 N MAIN ST",
    "dropdelcty": "LEVAN",
    "dropdelst": "UT",
    "dropdelzpp": 846398001,
    "dropphyadd": "75 N MAIN ST",
    "dropphycty": "LEVAN",
    "dropphyst": "UT",
    "dropphyzpp": 846398001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEVAN",
    "dropmalst": "UT",
    "dropmalzpp": 846399998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356230608,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16111",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "61 S MAIN ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "UT",
    "dropdelzpp": 843208001,
    "dropphyadd": "61 S MAIN ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "UT",
    "dropphyzpp": 843208001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEWISTON",
    "dropmalst": "UT",
    "dropmalzpp": 843209998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352582866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16116",
    "droptype": "D",
    "dropname": "LOA",
    "dropdeladd": "12 N MAIN ST",
    "dropdelcty": "LOA",
    "dropdelst": "UT",
    "dropdelzpp": 847478001,
    "dropphyadd": "12 N MAIN ST",
    "dropphycty": "LOA",
    "dropphyst": "UT",
    "dropphyzpp": 847478001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOA",
    "dropmalst": "UT",
    "dropmalzpp": 847479998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358362879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16117",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "75 W 200 N",
    "dropdelcty": "LOGAN",
    "dropdelst": "UT",
    "dropdelzpp": 843219998,
    "dropphyadd": "75 W 200 N",
    "dropphycty": "LOGAN",
    "dropphyst": "UT",
    "dropphyzpp": 843219998,
    "dropmaladd": "75 W 200 N",
    "dropmalcty": "LOGAN",
    "dropmalst": "UT",
    "dropmalzpp": 843219998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357536101,
    "dropsitcph": 4357520413,
    "dropfax": 4357539583
  },
  {
    "dcode": "D",
    "dropkey": "PZ16118",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "115 S MAIN ST",
    "dropdelcty": "LYMAN",
    "dropdelst": "UT",
    "dropdelzpp": 847498001,
    "dropphyadd": "115 S MAIN ST",
    "dropphycty": "LYMAN",
    "dropphyst": "UT",
    "dropphyzpp": 847498001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYMAN",
    "dropmalst": "UT",
    "dropmalzpp": 847499998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358362580,
    "dropsitcph": 4358362580,
    "dropfax": 4358362580
  },
  {
    "dcode": "D",
    "dropkey": "PZ16122",
    "droptype": "D",
    "dropname": "MAGNA",
    "dropdeladd": "8470 W MAGNA MAIN ST",
    "dropdelcty": "MAGNA",
    "dropdelst": "UT",
    "dropdelzpp": 840444450,
    "dropphyadd": "8470 W MAGNA MAIN ST",
    "dropphycty": "MAGNA",
    "dropphyst": "UT",
    "dropphyzpp": 840444450,
    "dropmaladd": "8470 W MAGNA MAIN ST",
    "dropmalcty": "MAGNA",
    "dropmalst": "UT",
    "dropmalzpp": 840444450,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015081990,
    "dropsitcph": 8015081990,
    "dropfax": 8015081203
  },
  {
    "dcode": "D",
    "dropkey": "PZ16126",
    "droptype": "D",
    "dropname": "MANILA",
    "dropdeladd": "32 E 2ND N",
    "dropdelcty": "MANILA",
    "dropdelst": "UT",
    "dropdelzpp": 840468001,
    "dropphyadd": "32 E 2ND N",
    "dropphycty": "MANILA",
    "dropphyst": "UT",
    "dropphyzpp": 840468001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANILA",
    "dropmalst": "UT",
    "dropmalzpp": 840469998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352337277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16127",
    "droptype": "D",
    "dropname": "MANTI",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "MANTI",
    "dropdelst": "UT",
    "dropdelzpp": 846429998,
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "MANTI",
    "dropphyst": "UT",
    "dropphyzpp": 846429998,
    "dropmaladd": "140 N MAIN ST",
    "dropmalcty": "MANTI",
    "dropmalst": "UT",
    "dropmalzpp": 846429998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358355081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16132",
    "droptype": "D",
    "dropname": "MARYSVALE",
    "dropdeladd": "100 W 200 N",
    "dropdelcty": "MARYSVALE",
    "dropdelst": "UT",
    "dropdelzpp": 847508001,
    "dropphyadd": "100 W 200 N",
    "dropphycty": "MARYSVALE",
    "dropphyst": "UT",
    "dropphyzpp": 847508001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARYSVALE",
    "dropmalst": "UT",
    "dropmalzpp": 847509998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4353264394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16133",
    "droptype": "D",
    "dropname": "MAYFIELD",
    "dropdeladd": "48 N MAIN ST",
    "dropdelcty": "MAYFIELD",
    "dropdelst": "UT",
    "dropdelzpp": 846438001,
    "dropphyadd": "48 N MAIN ST",
    "dropphycty": "MAYFIELD",
    "dropphyst": "UT",
    "dropphyzpp": 846438001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAYFIELD",
    "dropmalst": "UT",
    "dropmalzpp": 846439998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355283153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16134",
    "droptype": "D",
    "dropname": "MEADOW",
    "dropdeladd": "120 N MAIN ST",
    "dropdelcty": "MEADOW",
    "dropdelst": "UT",
    "dropdelzpp": 846448001,
    "dropphyadd": "120 N MAIN ST",
    "dropphycty": "MEADOW",
    "dropphyst": "UT",
    "dropphyzpp": 846448001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MEADOW",
    "dropmalst": "UT",
    "dropmalzpp": 846449998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742258,
    "dropsitcph": 4358422211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16136",
    "droptype": "D",
    "dropname": "MENDON",
    "dropdeladd": "120 N 100 W",
    "dropdelcty": "MENDON",
    "dropdelst": "UT",
    "dropdelzpp": 843258001,
    "dropphyadd": "120 N 100 W",
    "dropphycty": "MENDON",
    "dropphyst": "UT",
    "dropphyzpp": 843258001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENDON",
    "dropmalst": "UT",
    "dropmalzpp": 843259998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357531744,
    "dropsitcph": 4357531744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16139",
    "droptype": "D",
    "dropname": "MIDVALE",
    "dropdeladd": "35 W CENTER ST",
    "dropdelcty": "MIDVALE",
    "dropdelst": "UT",
    "dropdelzpp": 840479998,
    "dropphyadd": "35 W CENTER ST",
    "dropphycty": "MIDVALE",
    "dropphyst": "UT",
    "dropphyzpp": 840479998,
    "dropmaladd": "35 W CENTER ST",
    "dropmalcty": "MIDVALE",
    "dropmalst": "UT",
    "dropmalzpp": 840479998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015621629,
    "dropsitcph": 8015669668,
    "dropfax": 8012553359
  },
  {
    "dcode": "D",
    "dropkey": "PZ16140",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "125 W MAIN ST",
    "dropdelcty": "MIDWAY",
    "dropdelst": "UT",
    "dropdelzpp": 840498001,
    "dropphyadd": "125 W MAIN ST",
    "dropphycty": "MIDWAY",
    "dropphyst": "UT",
    "dropphyzpp": 840498001,
    "dropmaladd": "125 W MAIN ST",
    "dropmalcty": "MIDWAY",
    "dropmalst": "UT",
    "dropmalzpp": 840498001,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356570356,
    "dropsitcph": 4356570356,
    "dropfax": 4356570356
  },
  {
    "dcode": "D",
    "dropkey": "PZ16142",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "458 S MAIN ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "UT",
    "dropdelzpp": 847518001,
    "dropphyadd": "458 S MAIN ST",
    "dropphycty": "MILFORD",
    "dropphyst": "UT",
    "dropphyzpp": 847518001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILFORD",
    "dropmalst": "UT",
    "dropmalzpp": 847519998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4353875546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16144",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "70 W 200 N",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 843268001,
    "dropphyadd": "70 W 200 N",
    "dropphycty": "MILLVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 843268001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 843269998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357530861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16146",
    "droptype": "D",
    "dropname": "MINERSVILLE",
    "dropdeladd": "51 N CENTER ST",
    "dropdelcty": "MINERSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847528001,
    "dropphyadd": "51 N CENTER ST",
    "dropphycty": "MINERSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847528001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINERSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847529998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4353862322,
    "dropsitcph": 4353862322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16147",
    "droptype": "D",
    "dropname": "MOAB",
    "dropdeladd": "50 E 100 N",
    "dropdelcty": "MOAB",
    "dropdelst": "UT",
    "dropdelzpp": 845324500,
    "dropphyadd": "50 E 100 N",
    "dropphycty": "MOAB",
    "dropphyst": "UT",
    "dropphyzpp": 845324500,
    "dropmaladd": "50 E 100 N",
    "dropmalcty": "MOAB",
    "dropmalst": "UT",
    "dropmalzpp": 845324500,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352594823,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16149",
    "droptype": "D",
    "dropname": "MONA",
    "dropdeladd": "44 W 100 N",
    "dropdelcty": "MONA",
    "dropdelst": "UT",
    "dropdelzpp": 846458001,
    "dropphyadd": "44 W 100 N",
    "dropphycty": "MONA",
    "dropphyst": "UT",
    "dropphyzpp": 846458001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONA",
    "dropmalst": "UT",
    "dropmalzpp": 846459998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356231257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16151",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "485 N MAIN ST",
    "dropdelcty": "MONROE",
    "dropdelst": "UT",
    "dropdelzpp": 847549998,
    "dropphyadd": "485 N MAIN ST",
    "dropphycty": "MONROE",
    "dropphyst": "UT",
    "dropphyzpp": 847549998,
    "dropmaladd": "485 N MAIN ST",
    "dropmalcty": "MONROE",
    "dropmalst": "UT",
    "dropmalzpp": 847549998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355273378,
    "dropsitcph": 4355273378,
    "dropfax": 4355273378
  },
  {
    "dcode": "D",
    "dropkey": "PZ16152",
    "droptype": "D",
    "dropname": "MONTEZUMA CREEK",
    "dropdeladd": "50 CENTER ST",
    "dropdelcty": "MONTEZUMA CREEK",
    "dropdelst": "UT",
    "dropdelzpp": 845348001,
    "dropphyadd": "50 CENTER ST",
    "dropphycty": "MONTEZUMA CREEK",
    "dropphyst": "UT",
    "dropphyzpp": 845348001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTEZUMA CREEK",
    "dropmalst": "UT",
    "dropmalzpp": 845349998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356513341,
    "dropsitcph": 4356513341,
    "dropfax": 4356513341
  },
  {
    "dcode": "D",
    "dropkey": "PZ16154",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "197 S MAIN ST",
    "dropdelcty": "MONTICELLO",
    "dropdelst": "UT",
    "dropdelzpp": 845358001,
    "dropphyadd": "197 S MAIN ST",
    "dropphycty": "MONTICELLO",
    "dropphyst": "UT",
    "dropphyzpp": 845358001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTICELLO",
    "dropmalst": "UT",
    "dropmalzpp": 845359998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355872294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16157",
    "droptype": "D",
    "dropname": "MORGAN",
    "dropdeladd": "188 N STATE ST",
    "dropdelcty": "MORGAN",
    "dropdelst": "UT",
    "dropdelzpp": 840508001,
    "dropphyadd": "188 N STATE ST",
    "dropphycty": "MORGAN",
    "dropphyst": "UT",
    "dropphyzpp": 840508001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORGAN",
    "dropmalst": "UT",
    "dropmalzpp": 840509998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8018296412,
    "dropsitcph": 8018296412,
    "dropfax": 8018296412
  },
  {
    "dcode": "D",
    "dropkey": "PZ16158",
    "droptype": "D",
    "dropname": "MORONI",
    "dropdeladd": "46 N 400 E",
    "dropdelcty": "MORONI",
    "dropdelst": "UT",
    "dropdelzpp": 846468001,
    "dropphyadd": "46 N 400 E",
    "dropphycty": "MORONI",
    "dropphyst": "UT",
    "dropphyzpp": 846468001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORONI",
    "dropmalst": "UT",
    "dropmalzpp": 846469998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354170015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16160",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "55 N 100 W",
    "dropdelcty": "MOUNT PLEASANT",
    "dropdelst": "UT",
    "dropdelzpp": 846479998,
    "dropphyadd": "55 N 100 W",
    "dropphycty": "MOUNT PLEASANT",
    "dropphyst": "UT",
    "dropphyzpp": 846479998,
    "dropmaladd": "55 N 100 W",
    "dropmalcty": "MOUNT PLEASANT",
    "dropmalst": "UT",
    "dropmalzpp": 846479998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354622461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16170",
    "droptype": "D",
    "dropname": "MYTON",
    "dropdeladd": "80 E MAIN ST",
    "dropdelcty": "MYTON",
    "dropdelst": "UT",
    "dropdelzpp": 840528001,
    "dropphyadd": "80 E MAIN ST",
    "dropphycty": "MYTON",
    "dropphyst": "UT",
    "dropphyzpp": 840528001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MYTON",
    "dropmalst": "UT",
    "dropmalzpp": 840529998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357223818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16176",
    "droptype": "D",
    "dropname": "NEOLA",
    "dropdeladd": "9086 N 2000 W",
    "dropdelcty": "NEOLA",
    "dropdelst": "UT",
    "dropdelzpp": 840538000,
    "dropphyadd": "9086 N 2000 W",
    "dropphycty": "NEOLA",
    "dropphyst": "UT",
    "dropphyzpp": 840538000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEOLA",
    "dropmalst": "UT",
    "dropmalzpp": 840539998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4353534218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16177",
    "droptype": "D",
    "dropname": "NEPHI",
    "dropdeladd": "10 N MAIN ST",
    "dropdelcty": "NEPHI",
    "dropdelst": "UT",
    "dropdelzpp": 846484800,
    "dropphyadd": "10 N MAIN ST",
    "dropphycty": "NEPHI",
    "dropphyst": "UT",
    "dropphyzpp": 846484800,
    "dropmaladd": "10 N MAIN ST",
    "dropmalcty": "NEPHI",
    "dropmalst": "UT",
    "dropmalzpp": 846484800,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356231832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16178",
    "droptype": "D",
    "dropname": "NEW HARMONY",
    "dropdeladd": "3 E 100 N",
    "dropdelcty": "NEW HARMONY",
    "dropdelst": "UT",
    "dropdelzpp": 847578001,
    "dropphyadd": "3 E 100 N",
    "dropphycty": "NEW HARMONY",
    "dropphyst": "UT",
    "dropphyzpp": 847578001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW HARMONY",
    "dropmalst": "UT",
    "dropmalzpp": 847579998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355863342,
    "dropsitcph": 4355863342,
    "dropfax": 4355863342
  },
  {
    "dcode": "D",
    "dropkey": "PZ16179",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "205 N MAIN ST",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "UT",
    "dropdelzpp": 847568001,
    "dropphyadd": "205 N MAIN ST",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "UT",
    "dropphyzpp": 847568001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "UT",
    "dropmalzpp": 847569998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354395330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16180",
    "droptype": "D",
    "dropname": "NEWTON",
    "dropdeladd": "8 N CENTER ST",
    "dropdelcty": "NEWTON",
    "dropdelst": "UT",
    "dropdelzpp": 843278001,
    "dropphyadd": "8 N CENTER ST",
    "dropphycty": "NEWTON",
    "dropphyst": "UT",
    "dropphyzpp": 843278001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWTON",
    "dropmalst": "UT",
    "dropmalzpp": 843279998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355635948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16189",
    "droptype": "D",
    "dropname": "OAK CITY",
    "dropdeladd": "70 N MAIN ST",
    "dropdelcty": "OAK CITY",
    "dropdelst": "UT",
    "dropdelzpp": 846498001,
    "dropphyadd": "70 N MAIN ST",
    "dropphycty": "OAK CITY",
    "dropphyst": "UT",
    "dropphyzpp": 846498001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAK CITY",
    "dropmalst": "UT",
    "dropmalzpp": 846499998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358463181,
    "dropsitcph": 4358463181,
    "dropfax": 4358463181
  },
  {
    "dcode": "D",
    "dropkey": "PZ16191",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "4820 N STATE ROAD 32",
    "dropdelcty": "OAKLEY",
    "dropdelst": "UT",
    "dropdelzpp": 840558001,
    "dropphyadd": "4820 N STATE ROAD 32",
    "dropphycty": "OAKLEY",
    "dropphyst": "UT",
    "dropphyzpp": 840558001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKLEY",
    "dropmalst": "UT",
    "dropmalzpp": 840559998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352222326,
    "dropfax": 4352220732
  },
  {
    "dcode": "D",
    "dropkey": "PZ16193",
    "droptype": "D",
    "dropname": "OGDEN",
    "dropdeladd": "3680 PACIFIC AVE",
    "dropdelcty": "OGDEN",
    "dropdelst": "UT",
    "dropdelzpp": 844019998,
    "dropphyadd": "3680 PACIFIC AVE",
    "dropphycty": "OGDEN",
    "dropphyst": "UT",
    "dropphyzpp": 844019998,
    "dropmaladd": "3680 PACIFIC AVE",
    "dropmalcty": "OGDEN",
    "dropmalst": "UT",
    "dropmalzpp": 844019998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8016274521,
    "dropsitcph": 8016274527,
    "dropfax": 8013931856
  },
  {
    "dcode": "D",
    "dropkey": "PZ16195",
    "droptype": "D",
    "dropname": "ORANGEVILLE",
    "dropdeladd": "350 S MAIN ST",
    "dropdelcty": "ORANGEVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 845378001,
    "dropphyadd": "350 S MAIN ST",
    "dropphycty": "ORANGEVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 845378001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORANGEVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 845379998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357482548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16196",
    "droptype": "D",
    "dropname": "ORDERVILLE",
    "dropdeladd": "14 W STATE ST",
    "dropdelcty": "ORDERVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847588001,
    "dropphyadd": "14 W STATE ST",
    "dropphycty": "ORDERVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847588001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORDERVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847589998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356482461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16197",
    "droptype": "D",
    "dropname": "OREM",
    "dropdeladd": "222 W CENTER ST",
    "dropdelcty": "OREM",
    "dropdelst": "UT",
    "dropdelzpp": 840579998,
    "dropphyadd": "222 W CENTER ST",
    "dropphycty": "OREM",
    "dropphyst": "UT",
    "dropphyzpp": 840579998,
    "dropmaladd": "222 W CENTER ST",
    "dropmalcty": "OREM",
    "dropmalst": "UT",
    "dropmalzpp": 840579998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8018027137,
    "dropsitcph": 8012270662,
    "dropfax": 8012220766
  },
  {
    "dcode": "D",
    "dropkey": "PZ16200",
    "droptype": "D",
    "dropname": "PANGUITCH",
    "dropdeladd": "65 N 100 W",
    "dropdelcty": "PANGUITCH",
    "dropdelst": "UT",
    "dropdelzpp": 847598001,
    "dropphyadd": "65 N 100 W",
    "dropphycty": "PANGUITCH",
    "dropphyst": "UT",
    "dropphyzpp": 847598001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PANGUITCH",
    "dropmalst": "UT",
    "dropmalzpp": 847599998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 3854466712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16202",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "125 W 8900 S",
    "dropdelcty": "PARADISE",
    "dropdelst": "UT",
    "dropdelzpp": 843288001,
    "dropphyadd": "125 W 8900 S",
    "dropphycty": "PARADISE",
    "dropphyst": "UT",
    "dropphyzpp": 843288001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARADISE",
    "dropmalst": "UT",
    "dropmalzpp": 843289998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352456725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16204",
    "droptype": "D",
    "dropname": "PARK CITY",
    "dropdeladd": "2100 PARK AVE",
    "dropdelcty": "PARK CITY",
    "dropdelst": "UT",
    "dropdelzpp": 840608100,
    "dropphyadd": "2100 PARK AVE",
    "dropphycty": "PARK CITY",
    "dropphyst": "UT",
    "dropphyzpp": 840608100,
    "dropmaladd": "PO BOX 689998",
    "dropmalcty": "PARK CITY",
    "dropmalst": "UT",
    "dropmalzpp": 840689998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356558037,
    "dropsitcph": 4356558037,
    "dropfax": 4356558066
  },
  {
    "dcode": "D",
    "dropkey": "PZ16205",
    "droptype": "D",
    "dropname": "PARK VALLEY",
    "dropdeladd": "57560 W 17600 N",
    "dropdelcty": "PARK VALLEY",
    "dropdelst": "UT",
    "dropdelzpp": 843298001,
    "dropphyadd": "57560 W 17600 N",
    "dropphycty": "PARK VALLEY",
    "dropphyst": "UT",
    "dropphyzpp": 843298001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARK VALLEY",
    "dropmalst": "UT",
    "dropmalzpp": 843299998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358714330,
    "dropfax": 4358714330
  },
  {
    "dcode": "D",
    "dropkey": "PZ16206",
    "droptype": "D",
    "dropname": "PAROWAN",
    "dropdeladd": "58 S 100 W",
    "dropdelcty": "PAROWAN",
    "dropdelst": "UT",
    "dropdelzpp": 847618001,
    "dropphyadd": "58 S 100 W",
    "dropphycty": "PAROWAN",
    "dropphyst": "UT",
    "dropphyzpp": 847618001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PAROWAN",
    "dropmalst": "UT",
    "dropmalzpp": 847619998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4354778609,
    "dropsitcph": 4354778609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16208",
    "droptype": "D",
    "dropname": "PAYSON",
    "dropdeladd": "955 E 100 N",
    "dropdelcty": "PAYSON",
    "dropdelst": "UT",
    "dropdelzpp": 846515110,
    "dropphyadd": "955 E 100 N",
    "dropphycty": "PAYSON",
    "dropphyst": "UT",
    "dropphyzpp": 846515110,
    "dropmaladd": "955 E 100 N",
    "dropmalcty": "PAYSON",
    "dropmalst": "UT",
    "dropmalzpp": 846515110,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014651457,
    "dropsitcph": 8014650564,
    "dropfax": 8014650625
  },
  {
    "dcode": "D",
    "dropkey": "PZ16224",
    "droptype": "D",
    "dropname": "PLEASANT GROVE",
    "dropdeladd": "180 S 100 W",
    "dropdelcty": "PLEASANT GROVE",
    "dropdelst": "UT",
    "dropdelzpp": 840626200,
    "dropphyadd": "180 S 100 W",
    "dropphycty": "PLEASANT GROVE",
    "dropphyst": "UT",
    "dropphyzpp": 840626200,
    "dropmaladd": "180 S 100 W",
    "dropmalcty": "PLEASANT GROVE",
    "dropmalst": "UT",
    "dropmalzpp": 840626200,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017855415,
    "dropsitcph": 8017855589,
    "dropfax": 8017855482
  },
  {
    "dcode": "D",
    "dropkey": "PZ16226",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "5046 W 20300 N",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "UT",
    "dropdelzpp": 843308001,
    "dropphyadd": "5046 W 20300 N",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "UT",
    "dropphyzpp": 843308001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "UT",
    "dropmalzpp": 843309998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354583783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16229",
    "droptype": "D",
    "dropname": "PRICE",
    "dropdeladd": "95 S CARBON AVE",
    "dropdelcty": "PRICE",
    "dropdelst": "UT",
    "dropdelzpp": 845015000,
    "dropphyadd": "95 S CARBON AVE",
    "dropphycty": "PRICE",
    "dropphyst": "UT",
    "dropphyzpp": 845015000,
    "dropmaladd": "95 S CARBON AVE",
    "dropmalcty": "PRICE",
    "dropmalst": "UT",
    "dropmalzpp": 845015000,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356371638,
    "dropfax": 4356376746
  },
  {
    "dcode": "D",
    "dropkey": "PZ16231",
    "droptype": "D",
    "dropname": "PROVIDENCE",
    "dropdeladd": "411 W 100 N",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "UT",
    "dropdelzpp": 843323200,
    "dropphyadd": "411 W 100 N",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "UT",
    "dropphyzpp": 843323200,
    "dropmaladd": "411 W 100 N",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "UT",
    "dropmalzpp": 843323200,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357536210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16232",
    "droptype": "D",
    "dropname": "PROVO",
    "dropdeladd": "95 W 100 S",
    "dropdelcty": "PROVO",
    "dropdelst": "UT",
    "dropdelzpp": 846019998,
    "dropphyadd": "95 W 100 S",
    "dropphycty": "PROVO",
    "dropphyst": "UT",
    "dropphyzpp": 846019998,
    "dropmaladd": "95 W 100 S",
    "dropmalcty": "PROVO",
    "dropmalst": "UT",
    "dropmalzpp": 846019998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013754771,
    "dropsitcph": 8018189692,
    "dropfax": 8013756944
  },
  {
    "dcode": "D",
    "dropkey": "PZ16234",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "75 S MAIN ST",
    "dropdelcty": "RANDOLPH",
    "dropdelst": "UT",
    "dropdelzpp": 840648001,
    "dropphyadd": "75 S MAIN ST",
    "dropphycty": "RANDOLPH",
    "dropphyst": "UT",
    "dropphyzpp": 840648001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDOLPH",
    "dropmalst": "UT",
    "dropmalzpp": 840649998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357932185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16235",
    "droptype": "D",
    "dropname": "REDMOND",
    "dropdeladd": "19 S 100 W",
    "dropdelcty": "REDMOND",
    "dropdelst": "UT",
    "dropdelzpp": 846528001,
    "dropphyadd": "19 S 100 W",
    "dropphycty": "REDMOND",
    "dropphyst": "UT",
    "dropphyzpp": 846528001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "REDMOND",
    "dropmalst": "UT",
    "dropmalzpp": 846529998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355293254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16236",
    "droptype": "D",
    "dropname": "RICHFIELD",
    "dropdeladd": "93 N MAIN ST",
    "dropdelcty": "RICHFIELD",
    "dropdelst": "UT",
    "dropdelzpp": 847017100,
    "dropphyadd": "93 N MAIN ST",
    "dropphycty": "RICHFIELD",
    "dropphyst": "UT",
    "dropphyzpp": 847017100,
    "dropmaladd": "93 N MAIN ST",
    "dropmalcty": "RICHFIELD",
    "dropmalst": "UT",
    "dropmalzpp": 847017100,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358962078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16237",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "3 S STATE ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "UT",
    "dropdelzpp": 843339998,
    "dropphyadd": "3 S STATE ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "UT",
    "dropphyzpp": 843339998,
    "dropmaladd": "3 S STATE ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "UT",
    "dropmalzpp": 843339998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352582132,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16241",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "15445 N 5400 W",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "UT",
    "dropdelzpp": 843348001,
    "dropphyadd": "15445 N 5400 W",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "UT",
    "dropphyzpp": 843348001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "UT",
    "dropmalzpp": 843349998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354583329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16242",
    "droptype": "D",
    "dropname": "RIVERTON",
    "dropdeladd": "12760 S PARK AVE",
    "dropdelcty": "RIVERTON",
    "dropdelst": "UT",
    "dropdelzpp": 840656599,
    "dropphyadd": "12760 S PARK AVE",
    "dropphycty": "RIVERTON",
    "dropphyst": "UT",
    "dropphyzpp": 840656599,
    "dropmaladd": "12760 S PARK AVE",
    "dropmalcty": "RIVERTON",
    "dropmalst": "UT",
    "dropmalzpp": 840656599,
    "dropsitphn": 8019742558,
    "dropsitlph": 8012540367,
    "dropsitcph": 8012540367,
    "dropfax": 8014466450
  },
  {
    "dcode": "D",
    "dropkey": "PZ16244",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "81 S 300 E",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "UT",
    "dropdelzpp": 840666600,
    "dropphyadd": "81 S 300 E",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "UT",
    "dropphyzpp": 840666600,
    "dropmaladd": "81 S 300 E",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "UT",
    "dropmalzpp": 840666600,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357223231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16247",
    "droptype": "D",
    "dropname": "ROY",
    "dropdeladd": "4879 S 1900 W",
    "dropdelcty": "ROY",
    "dropdelst": "UT",
    "dropdelzpp": 840679998,
    "dropphyadd": "4879 S 1900 W",
    "dropphycty": "ROY",
    "dropphyst": "UT",
    "dropphyzpp": 840679998,
    "dropmaladd": "4879 S 1900 W",
    "dropmalcty": "ROY",
    "dropmalst": "UT",
    "dropmalzpp": 840679998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017733610,
    "dropsitcph": 8017739996,
    "dropfax": 8017730997
  },
  {
    "dcode": "D",
    "dropkey": "PZ16249",
    "droptype": "D",
    "dropname": "RUSH VALLEY",
    "dropdeladd": "326 W CENTER ST",
    "dropdelcty": "RUSH VALLEY",
    "dropdelst": "UT",
    "dropdelzpp": 840698001,
    "dropphyadd": "326 W CENTER ST",
    "dropphycty": "RUSH VALLEY",
    "dropphyst": "UT",
    "dropphyzpp": 840698001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUSH VALLEY",
    "dropmalst": "UT",
    "dropmalzpp": 840699998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358372271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16254",
    "droptype": "D",
    "dropname": "SALEM",
    "dropdeladd": "134 E 200 N",
    "dropdelcty": "SALEM",
    "dropdelst": "UT",
    "dropdelzpp": 846538001,
    "dropphyadd": "134 E 200 N",
    "dropphycty": "SALEM",
    "dropphyst": "UT",
    "dropphyzpp": 846538001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALEM",
    "dropmalst": "UT",
    "dropmalzpp": 846539998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014237897,
    "dropsitcph": 8014237894,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16255",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "35 N 100 E",
    "dropdelcty": "SALINA",
    "dropdelst": "UT",
    "dropdelzpp": 846549000,
    "dropphyadd": "35 N 100 E",
    "dropphycty": "SALINA",
    "dropphyst": "UT",
    "dropphyzpp": 846549000,
    "dropmaladd": "35 N 100 E",
    "dropmalcty": "SALINA",
    "dropmalst": "UT",
    "dropmalzpp": 846549000,
    "dropsitphn": 8019742558,
    "dropsitlph": 4355297221,
    "dropsitcph": 4355297221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16259",
    "droptype": "D",
    "dropname": "SALT LAKE CITY",
    "dropdeladd": "1760 W 2100 S",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841999998,
    "dropphyadd": "1760 W 2100 S",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841999998,
    "dropmaladd": "1760 W 2100 S",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841999998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742359,
    "dropsitcph": 8019742332,
    "dropfax": 8019742959
  },
  {
    "dcode": "D",
    "dropkey": "PZ16262",
    "droptype": "D",
    "dropname": "SANDY",
    "dropdeladd": "8850 S 700 E",
    "dropdelcty": "SANDY",
    "dropdelst": "UT",
    "dropdelzpp": 840709998,
    "dropphyadd": "8850 S 700 E",
    "dropphycty": "SANDY",
    "dropphyst": "UT",
    "dropphyzpp": 840709998,
    "dropmaladd": "8850 S 700 E",
    "dropmalcty": "SANDY",
    "dropmalst": "UT",
    "dropmalzpp": 840709998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015621673,
    "dropsitcph": 8015651946,
    "dropfax": 8012555872
  },
  {
    "dcode": "D",
    "dropkey": "PZ16263",
    "droptype": "D",
    "dropname": "SANTA CLARA",
    "dropdeladd": "1400 CHAPEL ST",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "UT",
    "dropdelzpp": 847658001,
    "dropphyadd": "1400 CHAPEL ST",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "UT",
    "dropphyzpp": 847658001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "UT",
    "dropmalzpp": 847659998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356282112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16264",
    "droptype": "D",
    "dropname": "SANTAQUIN",
    "dropdeladd": "20 W MAIN ST",
    "dropdelcty": "SANTAQUIN",
    "dropdelst": "UT",
    "dropdelzpp": 846557005,
    "dropphyadd": "20 W MAIN ST",
    "dropphycty": "SANTAQUIN",
    "dropphyst": "UT",
    "dropphyzpp": 846557005,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTAQUIN",
    "dropmalst": "UT",
    "dropmalzpp": 846559998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017541140,
    "dropsitcph": 8017541140,
    "dropfax": 8017545238
  },
  {
    "dcode": "D",
    "dropkey": "PZ16273",
    "droptype": "D",
    "dropname": "SMITHFIELD",
    "dropdeladd": "170 N MAIN ST",
    "dropdelcty": "SMITHFIELD",
    "dropdelst": "UT",
    "dropdelzpp": 843359998,
    "dropphyadd": "170 N MAIN ST",
    "dropphycty": "SMITHFIELD",
    "dropphyst": "UT",
    "dropphyzpp": 843359998,
    "dropmaladd": "170 N MAIN ST",
    "dropmalcty": "SMITHFIELD",
    "dropmalst": "UT",
    "dropmalzpp": 843359998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355575102,
    "dropfax": 4355635554
  },
  {
    "dcode": "D",
    "dropkey": "PZ16275",
    "droptype": "D",
    "dropname": "SNOWVILLE",
    "dropdeladd": "115 W MAIN ST",
    "dropdelcty": "SNOWVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 843368001,
    "dropphyadd": "115 W MAIN ST",
    "dropphycty": "SNOWVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 843368001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNOWVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 843369998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358728280,
    "dropsitcph": 4358728280,
    "dropfax": 4358728280
  },
  {
    "dcode": "D",
    "dropkey": "PZ16281",
    "droptype": "D",
    "dropname": "SPANISH FORK",
    "dropdeladd": "165 E 900 N",
    "dropdelcty": "SPANISH FORK",
    "dropdelst": "UT",
    "dropdelzpp": 846609998,
    "dropphyadd": "165 E 900 N",
    "dropphycty": "SPANISH FORK",
    "dropphyst": "UT",
    "dropphyzpp": 846609998,
    "dropmaladd": "165 E 900 N",
    "dropmalcty": "SPANISH FORK",
    "dropmalst": "UT",
    "dropmalzpp": 846609998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017987630,
    "dropsitcph": 8017941197,
    "dropfax": 8017989438
  },
  {
    "dcode": "D",
    "dropkey": "PZ16282",
    "droptype": "D",
    "dropname": "SPRING CITY",
    "dropdeladd": "24 N MAIN ST",
    "dropdelcty": "SPRING CITY",
    "dropdelst": "UT",
    "dropdelzpp": 846628001,
    "dropphyadd": "24 N MAIN ST",
    "dropphycty": "SPRING CITY",
    "dropphyst": "UT",
    "dropphyzpp": 846628001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRING CITY",
    "dropmalst": "UT",
    "dropmalzpp": 846629998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354622588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16285",
    "droptype": "D",
    "dropname": "SPRINGDALE",
    "dropdeladd": "625 ZION PARK BLVD",
    "dropdelcty": "SPRINGDALE",
    "dropdelst": "UT",
    "dropdelzpp": 847679400,
    "dropphyadd": "625 ZION PARK BLVD",
    "dropphycty": "SPRINGDALE",
    "dropphyst": "UT",
    "dropphyzpp": 847679400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPRINGDALE",
    "dropmalst": "UT",
    "dropmalzpp": 847679998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357723950,
    "dropsitcph": 4357723950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16286",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "75 E CENTER ST",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 846636300,
    "dropphyadd": "75 E CENTER ST",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 846636300,
    "dropmaladd": "75 E CENTER ST",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 846636300,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014897435,
    "dropsitcph": 8014913656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16289",
    "droptype": "D",
    "dropname": "SAINT GEORGE",
    "dropdeladd": "1150 E RIVERSIDE DR",
    "dropdelcty": "SAINT GEORGE",
    "dropdelst": "UT",
    "dropdelzpp": 847909998,
    "dropphyadd": "1150 E RIVERSIDE DR",
    "dropphycty": "SAINT GEORGE",
    "dropphyst": "UT",
    "dropphyzpp": 847909998,
    "dropmaladd": "1150 E RIVERSIDE DR",
    "dropmalcty": "SAINT GEORGE",
    "dropmalst": "UT",
    "dropmalzpp": 847909998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356882906,
    "dropsitcph": 4356882850,
    "dropfax": 4356881453
  },
  {
    "dcode": "D",
    "dropkey": "PZ16300",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "231 N CONNER AVE",
    "dropdelcty": "STOCKTON",
    "dropdelst": "UT",
    "dropdelzpp": 840718001,
    "dropphyadd": "231 N CONNER AVE",
    "dropphycty": "STOCKTON",
    "dropphyst": "UT",
    "dropphyzpp": 840718001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STOCKTON",
    "dropmalst": "UT",
    "dropmalzpp": 840719998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358823585,
    "dropfax": 4358823585
  },
  {
    "dcode": "D",
    "dropkey": "PZ16307",
    "droptype": "D",
    "dropname": "SUNNYSIDE",
    "dropdeladd": "1 MARKET ST",
    "dropdelcty": "SUNNYSIDE",
    "dropdelst": "UT",
    "dropdelzpp": 845398001,
    "dropphyadd": "1 MARKET ST",
    "dropphycty": "SUNNYSIDE",
    "dropphyst": "UT",
    "dropphyzpp": 845398001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNNYSIDE",
    "dropmalst": "UT",
    "dropmalzpp": 845399998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358886683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16312",
    "droptype": "D",
    "dropname": "TABIONA",
    "dropdeladd": "38060 W STATE HIGHWAY 35",
    "dropdelcty": "TABIONA",
    "dropdelst": "UT",
    "dropdelzpp": 840728001,
    "dropphyadd": "38060 W STATE HIGHWAY 35",
    "dropphycty": "TABIONA",
    "dropphyst": "UT",
    "dropphyzpp": 840728001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TABIONA",
    "dropmalst": "UT",
    "dropmalzpp": 840729998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4358485649,
    "dropfax": 4358485601
  },
  {
    "dcode": "D",
    "dropkey": "PZ16316",
    "droptype": "D",
    "dropname": "TEASDALE",
    "dropdeladd": "17 E RUSTLER ST",
    "dropdelcty": "TEASDALE",
    "dropdelst": "UT",
    "dropdelzpp": 847738001,
    "dropphyadd": "17 E RUSTLER ST",
    "dropphycty": "TEASDALE",
    "dropphyst": "UT",
    "dropphyzpp": 847738001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TEASDALE",
    "dropmalst": "UT",
    "dropmalzpp": 847739998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4354253886,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16323",
    "droptype": "D",
    "dropname": "TOOELE",
    "dropdeladd": "65 N MAIN ST",
    "dropdelcty": "TOOELE",
    "dropdelst": "UT",
    "dropdelzpp": 840742184,
    "dropphyadd": "65 N MAIN ST",
    "dropphycty": "TOOELE",
    "dropphyst": "UT",
    "dropphyzpp": 840742184,
    "dropmaladd": "65 N MAIN ST",
    "dropmalcty": "TOOELE",
    "dropmalst": "UT",
    "dropmalzpp": 840742184,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358439599,
    "dropsitcph": 4358439598,
    "dropfax": 4358431186
  },
  {
    "dcode": "D",
    "dropkey": "PZ16325",
    "droptype": "D",
    "dropname": "TOQUERVILLE",
    "dropdeladd": "39 S TOQUER BLVD",
    "dropdelcty": "TOQUERVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 847748001,
    "dropphyadd": "39 S TOQUER BLVD",
    "dropphycty": "TOQUERVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 847748001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOQUERVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 847749998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356354450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16328",
    "droptype": "D",
    "dropname": "TREMONTON",
    "dropdeladd": "111 S TREMONT ST",
    "dropdelcty": "TREMONTON",
    "dropdelst": "UT",
    "dropdelzpp": 843373700,
    "dropphyadd": "111 S TREMONT ST",
    "dropphycty": "TREMONTON",
    "dropphyst": "UT",
    "dropphyzpp": 843373700,
    "dropmaladd": "111 S TREMONT ST",
    "dropmalcty": "TREMONTON",
    "dropmalst": "UT",
    "dropmalzpp": 843379998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4352573748,
    "dropsitcph": 4352573748,
    "dropfax": 4352571573
  },
  {
    "dcode": "D",
    "dropkey": "PZ16329",
    "droptype": "D",
    "dropname": "TRENTON",
    "dropdeladd": "11 E MAIN ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "UT",
    "dropdelzpp": 843388001,
    "dropphyadd": "11 E MAIN ST",
    "dropphycty": "TRENTON",
    "dropphyst": "UT",
    "dropphyzpp": 843388001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRENTON",
    "dropmalst": "UT",
    "dropmalzpp": 843389998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4355639185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16331",
    "droptype": "D",
    "dropname": "TROPIC",
    "dropdeladd": "31 N STATE HIGHWAY 12",
    "dropdelcty": "TROPIC",
    "dropdelst": "UT",
    "dropdelzpp": 847768001,
    "dropphyadd": "31 N STATE HIGHWAY 12",
    "dropphycty": "TROPIC",
    "dropphyst": "UT",
    "dropphyzpp": 847768001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TROPIC",
    "dropmalst": "UT",
    "dropmalzpp": 847769998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356798743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16353",
    "droptype": "D",
    "dropname": "VERNAL",
    "dropdeladd": "67 N 800 W",
    "dropdelcty": "VERNAL",
    "dropdelst": "UT",
    "dropdelzpp": 840789998,
    "dropphyadd": "67 N 800 W",
    "dropphycty": "VERNAL",
    "dropphyst": "UT",
    "dropphyzpp": 840789998,
    "dropmaladd": "67 N 800 W",
    "dropmalcty": "VERNAL",
    "dropmalst": "UT",
    "dropmalzpp": 840789998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4357892393,
    "dropsitcph": 4357892393,
    "dropfax": 4357898594
  },
  {
    "dcode": "D",
    "dropkey": "PZ16354",
    "droptype": "D",
    "dropname": "VERNON",
    "dropdeladd": "20 N MAIN ST",
    "dropdelcty": "VERNON",
    "dropdelst": "UT",
    "dropdelzpp": 840808001,
    "dropphyadd": "20 N MAIN ST",
    "dropphycty": "VERNON",
    "dropphyst": "UT",
    "dropphyzpp": 840808001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VERNON",
    "dropmalst": "UT",
    "dropmalzpp": 840809998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358393552,
    "dropsitcph": 4358393552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16366",
    "droptype": "D",
    "dropname": "WALLSBURG",
    "dropdeladd": "154 W MAIN ST",
    "dropdelcty": "WALLSBURG",
    "dropdelst": "UT",
    "dropdelzpp": 840828001,
    "dropphyadd": "154 W MAIN ST",
    "dropphycty": "WALLSBURG",
    "dropphyst": "UT",
    "dropphyzpp": 840828001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALLSBURG",
    "dropmalst": "UT",
    "dropmalzpp": 840829998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356542599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16370",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "25 W TELEGRAPH ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "UT",
    "dropdelzpp": 847808010,
    "dropphyadd": "25 W TELEGRAPH ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "UT",
    "dropphyzpp": 847808010,
    "dropmaladd": "25 W TELEGRAPH ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "UT",
    "dropmalzpp": 847808010,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356739297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16374",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "610 E MAIN ST",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "UT",
    "dropdelzpp": 845429998,
    "dropphyadd": "610 E MAIN ST",
    "dropphycty": "WELLINGTON",
    "dropphyst": "UT",
    "dropphyzpp": 845429998,
    "dropmaladd": "610 E MAIN ST",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "UT",
    "dropmalzpp": 845429998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356371425,
    "dropsitcph": 4356371425,
    "dropfax": 4356371425
  },
  {
    "dcode": "D",
    "dropkey": "PZ16375",
    "droptype": "D",
    "dropname": "WELLSVILLE",
    "dropdeladd": "115 E MAIN ST",
    "dropdelcty": "WELLSVILLE",
    "dropdelst": "UT",
    "dropdelzpp": 843399998,
    "dropphyadd": "115 E MAIN ST",
    "dropphycty": "WELLSVILLE",
    "dropphyst": "UT",
    "dropphyzpp": 843399998,
    "dropmaladd": "115 E MAIN ST",
    "dropmalcty": "WELLSVILLE",
    "dropmalst": "UT",
    "dropmalzpp": 843399998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352454321,
    "dropfax": 4352453363
  },
  {
    "dcode": "D",
    "dropkey": "PZ16376",
    "droptype": "D",
    "dropname": "WENDOVER",
    "dropdeladd": "550 E WENDOVER BLVD",
    "dropdelcty": "WENDOVER",
    "dropdelst": "UT",
    "dropdelzpp": 840838001,
    "dropphyadd": "550 E WENDOVER BLVD",
    "dropphycty": "WENDOVER",
    "dropphyst": "UT",
    "dropphyzpp": 840838001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WENDOVER",
    "dropmalst": "UT",
    "dropmalzpp": 840839998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4356652369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16379",
    "droptype": "D",
    "dropname": "WEST JORDAN",
    "dropdeladd": "7901 S 3200 W",
    "dropdelcty": "WEST JORDAN",
    "dropdelst": "UT",
    "dropdelzpp": 840889998,
    "dropphyadd": "7901 S 3200 W",
    "dropphycty": "WEST JORDAN",
    "dropphyst": "UT",
    "dropphyzpp": 840889998,
    "dropmaladd": "7901 S 3200 W",
    "dropmalcty": "WEST JORDAN",
    "dropmalst": "UT",
    "dropmalzpp": 840889998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015663187,
    "dropsitcph": 8015663186,
    "dropfax": 8015663187
  },
  {
    "dcode": "D",
    "dropkey": "PZ16391",
    "droptype": "D",
    "dropname": "WHITEROCKS",
    "dropdeladd": "11444 N WHITEROCKS HWY",
    "dropdelcty": "WHITEROCKS",
    "dropdelst": "UT",
    "dropdelzpp": 840858001,
    "dropphyadd": "11444 N WHITEROCKS HWY",
    "dropphycty": "WHITEROCKS",
    "dropphyst": "UT",
    "dropphyzpp": 840858001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITEROCKS",
    "dropmalst": "UT",
    "dropmalzpp": 840859998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4353534478,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16392",
    "droptype": "D",
    "dropname": "WILLARD",
    "dropdeladd": "196 S MAIN ST",
    "dropdelcty": "WILLARD",
    "dropdelst": "UT",
    "dropdelzpp": 843408001,
    "dropphyadd": "196 S MAIN ST",
    "dropphycty": "WILLARD",
    "dropphyst": "UT",
    "dropphyzpp": 843408001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLARD",
    "dropmalst": "UT",
    "dropmalzpp": 843409998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4352397027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16398",
    "droptype": "D",
    "dropname": "WOODRUFF",
    "dropdeladd": "40 S MAIN ST",
    "dropdelcty": "WOODRUFF",
    "dropdelst": "UT",
    "dropdelzpp": 840868001,
    "dropphyadd": "40 S MAIN ST",
    "dropphycty": "WOODRUFF",
    "dropphyst": "UT",
    "dropphyzpp": 840868001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODRUFF",
    "dropmalst": "UT",
    "dropmalzpp": 840869998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742558,
    "dropsitcph": 4357934274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16405",
    "droptype": "D",
    "dropname": "ABERDEEN",
    "dropdeladd": "115 N K ST",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "WA",
    "dropdelzpp": 985209998,
    "dropphyadd": "115 N K ST",
    "dropphycty": "ABERDEEN",
    "dropphyst": "WA",
    "dropphyzpp": 985209998,
    "dropmaladd": "115 N K ST",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "WA",
    "dropmalzpp": 985209998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605327720,
    "dropsitcph": 3605377205,
    "dropfax": 6505783846
  },
  {
    "dcode": "D",
    "dropkey": "PZ16408",
    "droptype": "D",
    "dropname": "ACME",
    "dropdeladd": "2026 VALLEY HWY",
    "dropdelcty": "ACME",
    "dropdelst": "WA",
    "dropdelzpp": 982209635,
    "dropphyadd": "2026 VALLEY HWY",
    "dropphycty": "ACME",
    "dropphyst": "WA",
    "dropphyzpp": 982209635,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ACME",
    "dropmalst": "WA",
    "dropmalzpp": 982209998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605952189,
    "dropsitcph": 3605952189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16410",
    "droptype": "D",
    "dropname": "ADDY",
    "dropdeladd": "1386 MAIN ST",
    "dropdelcty": "ADDY",
    "dropdelst": "WA",
    "dropdelzpp": 991019998,
    "dropphyadd": "1386 MAIN ST",
    "dropphycty": "ADDY",
    "dropphyst": "WA",
    "dropphyzpp": 991019998,
    "dropmaladd": "1386 MAIN ST",
    "dropmalcty": "ADDY",
    "dropmalst": "WA",
    "dropmalzpp": 991019998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099356580,
    "dropsitcph": 5099356580,
    "dropfax": 5099358962
  },
  {
    "dcode": "D",
    "dropkey": "PZ16413",
    "droptype": "D",
    "dropname": "ADNA",
    "dropdeladd": "109 BUNKER CREEK HWY",
    "dropdelcty": "ADNA",
    "dropdelst": "WA",
    "dropdelzpp": 985229699,
    "dropphyadd": "109 BUNKER CREEK HWY",
    "dropphycty": "ADNA",
    "dropphyst": "WA",
    "dropphyzpp": 985229699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ADNA",
    "dropmalst": "WA",
    "dropmalzpp": 985229998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607483939,
    "dropsitcph": 3607483939,
    "dropfax": 6505775733
  },
  {
    "dcode": "D",
    "dropkey": "PZ16420",
    "droptype": "D",
    "dropname": "AIRWAY HEIGHTS",
    "dropdeladd": "1501 S MULLAN RD",
    "dropdelcty": "AIRWAY HEIGHTS",
    "dropdelst": "WA",
    "dropdelzpp": 990019998,
    "dropphyadd": "1501 S MULLAN RD",
    "dropphycty": "AIRWAY HEIGHTS",
    "dropphyst": "WA",
    "dropphyzpp": 990019998,
    "dropmaladd": "1501 S MULLAN RD",
    "dropmalcty": "AIRWAY HEIGHTS",
    "dropmalst": "WA",
    "dropmalzpp": 990019998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092443021,
    "dropsitcph": 5092440725,
    "dropfax": 5092444129
  },
  {
    "dcode": "D",
    "dropkey": "PZ16422",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "201 W FRONT ST",
    "dropdelcty": "ALBION",
    "dropdelst": "WA",
    "dropdelzpp": 991029998,
    "dropphyadd": "201 W FRONT ST",
    "dropphycty": "ALBION",
    "dropphyst": "WA",
    "dropphyzpp": 991029998,
    "dropmaladd": "201 W FRONT ST",
    "dropmalcty": "ALBION",
    "dropmalst": "WA",
    "dropmalzpp": 991029998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093327345,
    "dropsitcph": 5093327345,
    "dropfax": 5093343618
  },
  {
    "dcode": "D",
    "dropkey": "PZ16433",
    "droptype": "D",
    "dropname": "ALLYN",
    "dropdeladd": "18329 E STATE ROUTE 3",
    "dropdelcty": "ALLYN",
    "dropdelst": "WA",
    "dropdelzpp": 985249800,
    "dropphyadd": "18329 E STATE ROUTE 3",
    "dropphycty": "ALLYN",
    "dropphyst": "WA",
    "dropphyzpp": 985249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALLYN",
    "dropmalst": "WA",
    "dropmalzpp": 985249998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602756504,
    "dropsitcph": 3602756504,
    "dropfax": 3602773113
  },
  {
    "dcode": "D",
    "dropkey": "PZ16434",
    "droptype": "D",
    "dropname": "ALMIRA",
    "dropdeladd": "102 N 3RD ST",
    "dropdelcty": "ALMIRA",
    "dropdelst": "WA",
    "dropdelzpp": 991039998,
    "dropphyadd": "102 N 3RD ST",
    "dropphycty": "ALMIRA",
    "dropphyst": "WA",
    "dropphyzpp": 991039998,
    "dropmaladd": "102 N 3RD ST",
    "dropmalcty": "ALMIRA",
    "dropmalst": "WA",
    "dropmalzpp": 991039998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096392541,
    "dropsitcph": 5096392541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16438",
    "droptype": "D",
    "dropname": "AMANDA PARK",
    "dropdeladd": "6094 US HIGHWAY 101 STE C",
    "dropdelcty": "AMANDA PARK",
    "dropdelst": "WA",
    "dropdelzpp": 985269800,
    "dropphyadd": "6094 US HIGHWAY 101 STE C",
    "dropphycty": "AMANDA PARK",
    "dropphyst": "WA",
    "dropphyzpp": 985269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AMANDA PARK",
    "dropmalst": "WA",
    "dropmalzpp": 985269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602882232,
    "dropsitcph": 3602882232,
    "dropfax": 3602880089
  },
  {
    "dcode": "D",
    "dropkey": "PZ16441",
    "droptype": "D",
    "dropname": "AMBOY",
    "dropdeladd": "21501 NE 399TH ST",
    "dropdelcty": "AMBOY",
    "dropdelst": "WA",
    "dropdelzpp": 986013332,
    "dropphyadd": "21501 NE 399TH ST",
    "dropphycty": "AMBOY",
    "dropphyst": "WA",
    "dropphyzpp": 986013332,
    "dropmaladd": "21501 NE 399TH ST",
    "dropmalcty": "AMBOY",
    "dropmalst": "WA",
    "dropmalzpp": 986019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602477053,
    "dropsitcph": 3602476949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16445",
    "droptype": "D",
    "dropname": "ANACORTES",
    "dropdeladd": "519 COMMERCIAL AVE STE 100",
    "dropdelcty": "ANACORTES",
    "dropdelst": "WA",
    "dropdelzpp": 982219998,
    "dropphyadd": "519 COMMERCIAL AVE STE 100",
    "dropphycty": "ANACORTES",
    "dropphyst": "WA",
    "dropphyzpp": 982219998,
    "dropmaladd": "519 COMMERCIAL AVE STE 100",
    "dropmalcty": "ANACORTES",
    "dropmalst": "WA",
    "dropmalzpp": 982219998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602935140,
    "dropsitcph": 3602996689,
    "dropfax": 6505783847
  },
  {
    "dcode": "D",
    "dropkey": "PZ16446",
    "droptype": "D",
    "dropname": "ANATONE",
    "dropdeladd": "1128 FIR ST",
    "dropdelcty": "ANATONE",
    "dropdelst": "WA",
    "dropdelzpp": 994019998,
    "dropphyadd": "1128 FIR ST",
    "dropphycty": "ANATONE",
    "dropphyst": "WA",
    "dropphyzpp": 994019998,
    "dropmaladd": "1128 FIR ST",
    "dropmalcty": "ANATONE",
    "dropmalst": "WA",
    "dropmalzpp": 994019998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095005061,
    "dropsitcph": 5095005061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16450",
    "droptype": "D",
    "dropname": "APPLETON",
    "dropdeladd": "448 APPLETON RD",
    "dropdelcty": "APPLETON",
    "dropdelst": "WA",
    "dropdelzpp": 986029798,
    "dropphyadd": "448 APPLETON RD",
    "dropphycty": "APPLETON",
    "dropphyst": "WA",
    "dropphyzpp": 986029798,
    "dropmaladd": "448 APPLETON RD",
    "dropmalcty": "APPLETON",
    "dropmalst": "WA",
    "dropmalzpp": 986029998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5093654278,
    "dropsitcph": 5093654278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16452",
    "droptype": "D",
    "dropname": "ARDENVOIR",
    "dropdeladd": "8855 ENTIAT RIVER RD",
    "dropdelcty": "ARDENVOIR",
    "dropdelst": "WA",
    "dropdelzpp": 988119900,
    "dropphyadd": "8855 ENTIAT RIVER RD",
    "dropphycty": "ARDENVOIR",
    "dropphyst": "WA",
    "dropphyzpp": 988119900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARDENVOIR",
    "dropmalst": "WA",
    "dropmalzpp": 988119998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097842862,
    "dropsitcph": 5097842862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16454",
    "droptype": "D",
    "dropname": "ARIEL",
    "dropdeladd": "5712 LEWIS RIVER RD",
    "dropdelcty": "ARIEL",
    "dropdelst": "WA",
    "dropdelzpp": 986039754,
    "dropphyadd": "5712 LEWIS RIVER RD",
    "dropphycty": "ARIEL",
    "dropphyst": "WA",
    "dropphyzpp": 986039754,
    "dropmaladd": "5712 LEWIS RIVER RD",
    "dropmalcty": "ARIEL",
    "dropmalst": "WA",
    "dropmalzpp": 986039998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602258703,
    "dropsitcph": 3602258703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16456",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "524 N OLYMPIC AVE",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 982239998,
    "dropphyadd": "524 N OLYMPIC AVE",
    "dropphycty": "ARLINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 982239998,
    "dropmaladd": "524 N OLYMPIC AVE",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 982239998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604356273,
    "dropsitcph": 3604356273,
    "dropfax": 6514566577
  },
  {
    "dcode": "D",
    "dropkey": "PZ16459",
    "droptype": "D",
    "dropname": "ASHFORD",
    "dropdeladd": "30312 STATE ROUTE 706 E",
    "dropdelcty": "ASHFORD",
    "dropdelst": "WA",
    "dropdelzpp": 983049997,
    "dropphyadd": "30312 STATE ROUTE 706 E",
    "dropphycty": "ASHFORD",
    "dropphyst": "WA",
    "dropphyzpp": 983049997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ASHFORD",
    "dropmalst": "WA",
    "dropmalzpp": 983049998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605692346,
    "dropsitcph": 3605692346,
    "dropfax": 3605692148
  },
  {
    "dcode": "D",
    "dropkey": "PZ16460",
    "droptype": "D",
    "dropname": "ASOTIN",
    "dropdeladd": "121 2ND ST",
    "dropdelcty": "ASOTIN",
    "dropdelst": "WA",
    "dropdelzpp": 994029998,
    "dropphyadd": "121 2ND ST",
    "dropphycty": "ASOTIN",
    "dropphyst": "WA",
    "dropphyzpp": 994029998,
    "dropmaladd": "121 2ND ST",
    "dropmalcty": "ASOTIN",
    "dropmalst": "WA",
    "dropmalzpp": 994029998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092545314,
    "dropsitcph": 5092545314,
    "dropfax": 5092431146
  },
  {
    "dcode": "D",
    "dropkey": "PZ16461",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "11 3RD ST NW",
    "dropdelcty": "AUBURN",
    "dropdelst": "WA",
    "dropdelzpp": 980029998,
    "dropphyadd": "11 3RD ST NW",
    "dropphycty": "AUBURN",
    "dropphyst": "WA",
    "dropphyzpp": 980029998,
    "dropmaladd": "11 3RD ST NW",
    "dropmalcty": "AUBURN",
    "dropmalst": "WA",
    "dropmalzpp": 980029998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2533331377,
    "dropsitcph": 2533331377,
    "dropfax": 6503576602
  },
  {
    "dcode": "D",
    "dropkey": "PZ16478",
    "droptype": "D",
    "dropname": "BARING",
    "dropdeladd": "63501 NE STEVENS PASS HWY",
    "dropdelcty": "BARING",
    "dropdelst": "WA",
    "dropdelzpp": 982249800,
    "dropphyadd": "63501 NE STEVENS PASS HWY",
    "dropphycty": "BARING",
    "dropphyst": "WA",
    "dropphyzpp": 982249800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARING",
    "dropmalst": "WA",
    "dropmalzpp": 982249998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606772230,
    "dropsitcph": 3606772230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16480",
    "droptype": "D",
    "dropname": "BATTLE GROUND",
    "dropdeladd": "418 W MAIN ST",
    "dropdelcty": "BATTLE GROUND",
    "dropdelst": "WA",
    "dropdelzpp": 986044687,
    "dropphyadd": "418 W MAIN ST",
    "dropphycty": "BATTLE GROUND",
    "dropphyst": "WA",
    "dropphyzpp": 986044687,
    "dropmaladd": "418 W MAIN ST",
    "dropmalcty": "BATTLE GROUND",
    "dropmalst": "WA",
    "dropmalzpp": 986049998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606662861,
    "dropsitcph": 3606662861,
    "dropfax": 3606660705
  },
  {
    "dcode": "D",
    "dropkey": "PZ16482",
    "droptype": "D",
    "dropname": "BAY CENTER",
    "dropdeladd": "3 MAIN ST E",
    "dropdelcty": "BAY CENTER",
    "dropdelst": "WA",
    "dropdelzpp": 985279800,
    "dropphyadd": "3 MAIN ST E",
    "dropphycty": "BAY CENTER",
    "dropphyst": "WA",
    "dropphyzpp": 985279800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY CENTER",
    "dropmalst": "WA",
    "dropmalzpp": 985279998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608757143,
    "dropsitcph": 3608757143,
    "dropfax": 3608757144
  },
  {
    "dcode": "D",
    "dropkey": "PZ16488",
    "droptype": "D",
    "dropname": "BEAVER",
    "dropdeladd": "200341 HIGHWAY 101",
    "dropdelcty": "BEAVER",
    "dropdelst": "WA",
    "dropdelzpp": 983059997,
    "dropphyadd": "200341 HIGHWAY 101",
    "dropphycty": "BEAVER",
    "dropphyst": "WA",
    "dropphyzpp": 983059997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAVER",
    "dropmalst": "WA",
    "dropmalzpp": 983059998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603273504,
    "dropsitcph": 3603273504,
    "dropfax": 6505772651
  },
  {
    "dcode": "D",
    "dropkey": "PZ16492",
    "droptype": "D",
    "dropname": "BELFAIR",
    "dropdeladd": "60 NE RIDGE POINT BLVD",
    "dropdelcty": "BELFAIR",
    "dropdelst": "WA",
    "dropdelzpp": 985289800,
    "dropphyadd": "60 NE RIDGE POINT BLVD",
    "dropphycty": "BELFAIR",
    "dropphyst": "WA",
    "dropphyzpp": 985289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELFAIR",
    "dropmalst": "WA",
    "dropmalzpp": 985289998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602756266,
    "dropsitcph": 3602756266,
    "dropfax": 6514566582
  },
  {
    "dcode": "D",
    "dropkey": "PZ16493",
    "droptype": "D",
    "dropname": "BELLEVUE",
    "dropdeladd": "12224 NE BEL RED RD",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "WA",
    "dropdelzpp": 980059997,
    "dropphyadd": "12224 NE BEL RED RD",
    "dropphycty": "BELLEVUE",
    "dropphyst": "WA",
    "dropphyzpp": 980059997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "WA",
    "dropmalzpp": 980099998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254543086,
    "dropsitcph": 4254542416,
    "dropfax": 6514566584
  },
  {
    "dcode": "D",
    "dropkey": "PZ16494",
    "droptype": "D",
    "dropname": "BELLINGHAM",
    "dropdeladd": "315 PROSPECT ST",
    "dropdelcty": "BELLINGHAM",
    "dropdelst": "WA",
    "dropdelzpp": 982259998,
    "dropphyadd": "315 PROSPECT ST",
    "dropphycty": "BELLINGHAM",
    "dropphyst": "WA",
    "dropphyzpp": 982259998,
    "dropmaladd": "315 PROSPECT ST",
    "dropmalcty": "BELLINGHAM",
    "dropmalst": "WA",
    "dropmalzpp": 982259998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607529053,
    "dropsitcph": 3607529822,
    "dropfax": 6514566585
  },
  {
    "dcode": "D",
    "dropkey": "PZ16499",
    "droptype": "D",
    "dropname": "BENTON CITY",
    "dropdeladd": "909 DALE AVE",
    "dropdelcty": "BENTON CITY",
    "dropdelst": "WA",
    "dropdelzpp": 993209998,
    "dropphyadd": "909 DALE AVE",
    "dropphycty": "BENTON CITY",
    "dropphyst": "WA",
    "dropphyzpp": 993209998,
    "dropmaladd": "909 DALE AVE",
    "dropmalcty": "BENTON CITY",
    "dropmalst": "WA",
    "dropmalzpp": 993209998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095882740,
    "dropsitcph": 5095882740,
    "dropfax": 6516751468
  },
  {
    "dcode": "D",
    "dropkey": "PZ16500",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "20476 SW B ST",
    "dropdelcty": "BEVERLY",
    "dropdelst": "WA",
    "dropdelzpp": 993219998,
    "dropphyadd": "20476 SW B ST",
    "dropphycty": "BEVERLY",
    "dropphyst": "WA",
    "dropphyzpp": 993219998,
    "dropmaladd": "20476 SW B ST",
    "dropmalcty": "BEVERLY",
    "dropmalst": "WA",
    "dropmalzpp": 993219998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099324744,
    "dropsitcph": 5099324744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16501",
    "droptype": "D",
    "dropname": "BICKLETON",
    "dropdeladd": "205 E MARKET ST",
    "dropdelcty": "BICKLETON",
    "dropdelst": "WA",
    "dropdelzpp": 993229998,
    "dropphyadd": "205 E MARKET ST",
    "dropphycty": "BICKLETON",
    "dropphyst": "WA",
    "dropphyzpp": 993229998,
    "dropmaladd": "205 E MARKET ST",
    "dropmalcty": "BICKLETON",
    "dropmalst": "WA",
    "dropmalzpp": 993229998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098962934,
    "dropsitcph": 5098962934,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16503",
    "droptype": "D",
    "dropname": "BINGEN",
    "dropdeladd": "302 W STEUBEN ST",
    "dropdelcty": "BINGEN",
    "dropdelst": "WA",
    "dropdelzpp": 986059225,
    "dropphyadd": "302 W STEUBEN ST",
    "dropphycty": "BINGEN",
    "dropphyst": "WA",
    "dropphyzpp": 986059225,
    "dropmaladd": "302 W STEUBEN ST",
    "dropmalcty": "BINGEN",
    "dropmalst": "WA",
    "dropmalzpp": 986059998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094931225,
    "dropsitcph": 5094931225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16507",
    "droptype": "D",
    "dropname": "BLACK DIAMOND",
    "dropdeladd": "25228 BAKER ST",
    "dropdelcty": "BLACK DIAMOND",
    "dropdelst": "WA",
    "dropdelzpp": 980109799,
    "dropphyadd": "25228 BAKER ST",
    "dropphycty": "BLACK DIAMOND",
    "dropphyst": "WA",
    "dropphyzpp": 980109799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLACK DIAMOND",
    "dropmalst": "WA",
    "dropmalzpp": 980109998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608861123,
    "dropsitcph": 3608869429,
    "dropfax": 3608861337
  },
  {
    "dcode": "D",
    "dropkey": "PZ16508",
    "droptype": "D",
    "dropname": "BLAINE",
    "dropdeladd": "701 HARRISON AVE",
    "dropdelcty": "BLAINE",
    "dropdelst": "WA",
    "dropdelzpp": 982309998,
    "dropphyadd": "701 HARRISON AVE",
    "dropphycty": "BLAINE",
    "dropphyst": "WA",
    "dropphyzpp": 982309998,
    "dropmaladd": "701 HARRISON AVE",
    "dropmalcty": "BLAINE",
    "dropmalst": "WA",
    "dropmalzpp": 982309998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603320981,
    "dropsitcph": 3603327184,
    "dropfax": 6514566588
  },
  {
    "dcode": "D",
    "dropkey": "PZ16521",
    "droptype": "D",
    "dropname": "BOTHELL",
    "dropdeladd": "10500 BEARDSLEE BLVD",
    "dropdelcty": "BOTHELL",
    "dropdelst": "WA",
    "dropdelzpp": 980119998,
    "dropphyadd": "10500 BEARDSLEE BLVD",
    "dropphycty": "BOTHELL",
    "dropphyst": "WA",
    "dropphyzpp": 980119998,
    "dropmaladd": "10500 BEARDSLEE BLVD",
    "dropmalcty": "BOTHELL",
    "dropmalst": "WA",
    "dropmalzpp": 980119998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254861448,
    "dropsitcph": 4254829755,
    "dropfax": 6514566590
  },
  {
    "dcode": "D",
    "dropkey": "PZ16522",
    "droptype": "D",
    "dropname": "BOW",
    "dropdeladd": "5530 CHUCKANUT DR",
    "dropdelcty": "BOW",
    "dropdelst": "WA",
    "dropdelzpp": 982329990,
    "dropphyadd": "5530 CHUCKANUT DR",
    "dropphycty": "BOW",
    "dropphyst": "WA",
    "dropphyzpp": 982329990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOW",
    "dropmalst": "WA",
    "dropmalzpp": 982329998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607666319,
    "dropsitcph": 3607666642,
    "dropfax": 3607665269
  },
  {
    "dcode": "D",
    "dropkey": "PZ16527",
    "droptype": "D",
    "dropname": "BREMERTON",
    "dropdeladd": "602 PACIFIC AVE",
    "dropdelcty": "BREMERTON",
    "dropdelst": "WA",
    "dropdelzpp": 983379998,
    "dropphyadd": "602 PACIFIC AVE",
    "dropphycty": "BREMERTON",
    "dropphyst": "WA",
    "dropphyzpp": 983379998,
    "dropmaladd": "602 PACIFIC AVE",
    "dropmalcty": "BREMERTON",
    "dropmalst": "WA",
    "dropmalzpp": 983379998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603738128,
    "dropsitcph": 3603772722,
    "dropfax": 6514566591
  },
  {
    "dcode": "D",
    "dropkey": "PZ16528",
    "droptype": "D",
    "dropname": "BREWSTER",
    "dropdeladd": "109 N 7TH ST",
    "dropdelcty": "BREWSTER",
    "dropdelst": "WA",
    "dropdelzpp": 988129518,
    "dropphyadd": "109 N 7TH ST",
    "dropphycty": "BREWSTER",
    "dropphyst": "WA",
    "dropphyzpp": 988129518,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BREWSTER",
    "dropmalst": "WA",
    "dropmalzpp": 988129998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096897622,
    "dropsitcph": 5096893510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16529",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "1011 COLUMBIA AVE",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "WA",
    "dropdelzpp": 988139900,
    "dropphyadd": "1011 COLUMBIA AVE",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "WA",
    "dropphyzpp": 988139900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "WA",
    "dropmalzpp": 988139998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096864611,
    "dropsitcph": 5096864611,
    "dropfax": 5096863353
  },
  {
    "dcode": "D",
    "dropkey": "PZ16531",
    "droptype": "D",
    "dropname": "BRINNON",
    "dropdeladd": "144 BRINNON LN",
    "dropdelcty": "BRINNON",
    "dropdelst": "WA",
    "dropdelzpp": 983209997,
    "dropphyadd": "144 BRINNON LN",
    "dropphycty": "BRINNON",
    "dropphyst": "WA",
    "dropphyzpp": 983209997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRINNON",
    "dropmalst": "WA",
    "dropmalzpp": 983209998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607964465,
    "dropsitcph": 3607964465,
    "dropfax": 3607964053
  },
  {
    "dcode": "D",
    "dropkey": "PZ16535",
    "droptype": "D",
    "dropname": "BROWNSTOWN",
    "dropdeladd": "10981 BRANCH RD",
    "dropdelcty": "BROWNSTOWN",
    "dropdelst": "WA",
    "dropdelzpp": 989209800,
    "dropphyadd": "10981 BRANCH RD",
    "dropphycty": "BROWNSTOWN",
    "dropphyst": "WA",
    "dropphyzpp": 989209800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROWNSTOWN",
    "dropmalst": "WA",
    "dropmalzpp": 989209998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098482218,
    "dropsitcph": 5098482218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16537",
    "droptype": "D",
    "dropname": "BRUSH PRAIRIE",
    "dropdeladd": "12012 NE 150TH CIR",
    "dropdelcty": "BRUSH PRAIRIE",
    "dropdelst": "WA",
    "dropdelzpp": 986069597,
    "dropphyadd": "12012 NE 150TH CIR",
    "dropphycty": "BRUSH PRAIRIE",
    "dropphyst": "WA",
    "dropphyzpp": 986069597,
    "dropmaladd": "12012 NE 150TH CIR",
    "dropmalcty": "BRUSH PRAIRIE",
    "dropmalst": "WA",
    "dropmalzpp": 986069998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602607367,
    "dropsitcph": 3608820875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16540",
    "droptype": "D",
    "dropname": "BUCKLEY",
    "dropdeladd": "219 S RIVER AVE",
    "dropdelcty": "BUCKLEY",
    "dropdelst": "WA",
    "dropdelzpp": 983219990,
    "dropphyadd": "219 S RIVER AVE",
    "dropphycty": "BUCKLEY",
    "dropphyst": "WA",
    "dropphyzpp": 983219990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCKLEY",
    "dropmalst": "WA",
    "dropmalzpp": 983219998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608292245,
    "dropsitcph": 3608290781,
    "dropfax": 6514566593
  },
  {
    "dcode": "D",
    "dropkey": "PZ16541",
    "droptype": "D",
    "dropname": "BUCODA",
    "dropdeladd": "108 N MAIN ST",
    "dropdelcty": "BUCODA",
    "dropdelst": "WA",
    "dropdelzpp": 985309800,
    "dropphyadd": "108 N MAIN ST",
    "dropphycty": "BUCODA",
    "dropphyst": "WA",
    "dropphyzpp": 985309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUCODA",
    "dropmalst": "WA",
    "dropmalzpp": 985309998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602451407,
    "dropsitcph": 3602451407,
    "dropfax": 3602451407
  },
  {
    "dcode": "D",
    "dropkey": "PZ16542",
    "droptype": "D",
    "dropname": "BUENA",
    "dropdeladd": "770 BUENA RD",
    "dropdelcty": "BUENA",
    "dropdelst": "WA",
    "dropdelzpp": 989219800,
    "dropphyadd": "770 BUENA RD",
    "dropphycty": "BUENA",
    "dropphyst": "WA",
    "dropphyzpp": 989219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BUENA",
    "dropmalst": "WA",
    "dropmalzpp": 989219998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098653097,
    "dropsitcph": 5098653097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16544",
    "droptype": "D",
    "dropname": "BURBANK",
    "dropdeladd": "114 2ND AVE",
    "dropdelcty": "BURBANK",
    "dropdelst": "WA",
    "dropdelzpp": 993239998,
    "dropphyadd": "114 2ND AVE",
    "dropphycty": "BURBANK",
    "dropphyst": "WA",
    "dropphyzpp": 993239998,
    "dropmaladd": "114 2ND AVE",
    "dropmalcty": "BURBANK",
    "dropmalst": "WA",
    "dropmalzpp": 993239998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095474093,
    "dropsitcph": 5095474093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16548",
    "droptype": "D",
    "dropname": "BURLEY",
    "dropdeladd": "14831 BURLEY AVE",
    "dropdelcty": "BURLEY",
    "dropdelst": "WA",
    "dropdelzpp": 983229997,
    "dropphyadd": "14831 BURLEY AVE",
    "dropphycty": "BURLEY",
    "dropphyst": "WA",
    "dropphyzpp": 983229997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BURLEY",
    "dropmalst": "WA",
    "dropmalzpp": 983229998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538572695,
    "dropsitcph": 2538572695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16549",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "720 E FAIRHAVEN AVE",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 982339998,
    "dropphyadd": "720 E FAIRHAVEN AVE",
    "dropphycty": "BURLINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 982339998,
    "dropmaladd": "720 E FAIRHAVEN AVE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 982339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607559220,
    "dropsitcph": 3607557332,
    "dropfax": 6514566596
  },
  {
    "dcode": "D",
    "dropkey": "PZ16555",
    "droptype": "D",
    "dropname": "CAMAS",
    "dropdeladd": "440 NE 5TH AVE",
    "dropdelcty": "CAMAS",
    "dropdelst": "WA",
    "dropdelzpp": 986072031,
    "dropphyadd": "440 NE 5TH AVE",
    "dropphycty": "CAMAS",
    "dropphyst": "WA",
    "dropphyzpp": 986072031,
    "dropmaladd": "440 NE 5TH AVE",
    "dropmalcty": "CAMAS",
    "dropmalst": "WA",
    "dropmalzpp": 986079998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608340917,
    "dropsitcph": 3608338096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16562",
    "droptype": "D",
    "dropname": "CARBONADO",
    "dropdeladd": "250 COAL AVE",
    "dropdelcty": "CARBONADO",
    "dropdelst": "WA",
    "dropdelzpp": 983239996,
    "dropphyadd": "250 COAL AVE",
    "dropphycty": "CARBONADO",
    "dropphyst": "WA",
    "dropphyzpp": 983239996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARBONADO",
    "dropmalst": "WA",
    "dropmalzpp": 983239998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608299332,
    "dropsitcph": 3608299332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16565",
    "droptype": "D",
    "dropname": "CARLSBORG",
    "dropdeladd": "20 BUSINESS PARK LOOP",
    "dropdelcty": "CARLSBORG",
    "dropdelst": "WA",
    "dropdelzpp": 983249997,
    "dropphyadd": "20 BUSINESS PARK LOOP",
    "dropphycty": "CARLSBORG",
    "dropphyst": "WA",
    "dropphyzpp": 983249997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLSBORG",
    "dropmalst": "WA",
    "dropmalzpp": 983249998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606838766,
    "dropsitcph": 3606836616,
    "dropfax": 3606817931
  },
  {
    "dcode": "D",
    "dropkey": "PZ16567",
    "droptype": "D",
    "dropname": "CARLTON",
    "dropdeladd": "2274 US HIGHWAY 153",
    "dropdelcty": "CARLTON",
    "dropdelst": "WA",
    "dropdelzpp": 988149900,
    "dropphyadd": "2274 US HIGHWAY 153",
    "dropphycty": "CARLTON",
    "dropphyst": "WA",
    "dropphyzpp": 988149900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARLTON",
    "dropmalst": "WA",
    "dropmalzpp": 988149998,
    "dropsitphn": 5099976091,
    "dropsitlph": 5099976091,
    "dropsitcph": 5099976091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16568",
    "droptype": "D",
    "dropname": "CARNATION",
    "dropdeladd": "4440 MCKINLEY AVE",
    "dropdelcty": "CARNATION",
    "dropdelst": "WA",
    "dropdelzpp": 980148799,
    "dropphyadd": "4440 MCKINLEY AVE",
    "dropphycty": "CARNATION",
    "dropphyst": "WA",
    "dropphyzpp": 980148799,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARNATION",
    "dropmalst": "WA",
    "dropmalzpp": 980149998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253336501,
    "dropsitcph": 4253336451,
    "dropfax": 6503576342
  },
  {
    "dcode": "D",
    "dropkey": "PZ16570",
    "droptype": "D",
    "dropname": "CARROLLS",
    "dropdeladd": "3803 OLD PACIFIC HWY S",
    "dropdelcty": "CARROLLS",
    "dropdelst": "WA",
    "dropdelzpp": 986099598,
    "dropphyadd": "3803 OLD PACIFIC HWY S",
    "dropphycty": "CARROLLS",
    "dropphyst": "WA",
    "dropphyzpp": 986099598,
    "dropmaladd": "3803 OLD PACIFIC HWY S",
    "dropmalcty": "CARROLLS",
    "dropmalst": "WA",
    "dropmalzpp": 986099998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3605770525,
    "dropsitcph": 3605770525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16571",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "1182 WIND RIVER HWY",
    "dropdelcty": "CARSON",
    "dropdelst": "WA",
    "dropdelzpp": 986103298,
    "dropphyadd": "1182 WIND RIVER HWY",
    "dropphycty": "CARSON",
    "dropphyst": "WA",
    "dropphyzpp": 986103298,
    "dropmaladd": "1182 WIND RIVER HWY",
    "dropmalcty": "CARSON",
    "dropmalst": "WA",
    "dropmalzpp": 986109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094275051,
    "dropsitcph": 5094275051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16574",
    "droptype": "D",
    "dropname": "CASHMERE",
    "dropdeladd": "121 ELBERTA AVE",
    "dropdelcty": "CASHMERE",
    "dropdelst": "WA",
    "dropdelzpp": 988159998,
    "dropphyadd": "121 ELBERTA AVE",
    "dropphycty": "CASHMERE",
    "dropphyst": "WA",
    "dropphyzpp": 988159998,
    "dropmaladd": "121 ELBERTA AVE",
    "dropmalcty": "CASHMERE",
    "dropmalst": "WA",
    "dropmalzpp": 988159998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097822482,
    "dropsitcph": 5097821011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16575",
    "droptype": "D",
    "dropname": "CASTLE ROCK",
    "dropdeladd": "126 COWLITZ ST W",
    "dropdelcty": "CASTLE ROCK",
    "dropdelst": "WA",
    "dropdelzpp": 986118998,
    "dropphyadd": "126 COWLITZ ST W",
    "dropphycty": "CASTLE ROCK",
    "dropphyst": "WA",
    "dropphyzpp": 986118998,
    "dropmaladd": "126 COWLITZ ST W",
    "dropmalcty": "CASTLE ROCK",
    "dropmalst": "WA",
    "dropmalzpp": 986119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602745212,
    "dropsitcph": 3602745209,
    "dropfax": 3602743495
  },
  {
    "dcode": "D",
    "dropkey": "PZ16576",
    "droptype": "D",
    "dropname": "CATHLAMET",
    "dropdeladd": "30 RIVER ST",
    "dropdelcty": "CATHLAMET",
    "dropdelst": "WA",
    "dropdelzpp": 986129698,
    "dropphyadd": "30 RIVER ST",
    "dropphycty": "CATHLAMET",
    "dropphyst": "WA",
    "dropphyzpp": 986129698,
    "dropmaladd": "30 RIVER ST",
    "dropmalcty": "CATHLAMET",
    "dropmalst": "WA",
    "dropmalzpp": 986129998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3607953619,
    "dropsitcph": 3607953619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16587",
    "droptype": "D",
    "dropname": "CENTRALIA",
    "dropdeladd": "214 CENTRALIA COLLEGE BLVD",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "WA",
    "dropdelzpp": 985319998,
    "dropphyadd": "214 CENTRALIA COLLEGE BLVD",
    "dropphycty": "CENTRALIA",
    "dropphyst": "WA",
    "dropphyzpp": 985319998,
    "dropmaladd": "214 CENTRALIA COLLEGE BLVD",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "WA",
    "dropmalzpp": 985319998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607368215,
    "dropsitcph": 3608071169,
    "dropfax": 6514566599
  },
  {
    "dcode": "D",
    "dropkey": "PZ16589",
    "droptype": "D",
    "dropname": "CHATTAROY",
    "dropdeladd": "3616 E CHATTAROY RD",
    "dropdelcty": "CHATTAROY",
    "dropdelst": "WA",
    "dropdelzpp": 990039998,
    "dropphyadd": "3616 E CHATTAROY RD",
    "dropphycty": "CHATTAROY",
    "dropphyst": "WA",
    "dropphyzpp": 990039998,
    "dropmaladd": "3616 E CHATTAROY RD",
    "dropmalcty": "CHATTAROY",
    "dropmalst": "WA",
    "dropmalzpp": 990039998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092386312,
    "dropsitcph": 5092386312,
    "dropfax": 6505772409
  },
  {
    "dcode": "D",
    "dropkey": "PZ16590",
    "droptype": "D",
    "dropname": "CHEHALIS",
    "dropdeladd": "225 NW CASCADE AVE",
    "dropdelcty": "CHEHALIS",
    "dropdelst": "WA",
    "dropdelzpp": 985329998,
    "dropphyadd": "225 NW CASCADE AVE",
    "dropphycty": "CHEHALIS",
    "dropphyst": "WA",
    "dropphyzpp": 985329998,
    "dropmaladd": "225 NW CASCADE AVE",
    "dropmalcty": "CHEHALIS",
    "dropmalst": "WA",
    "dropmalzpp": 985329998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607486746,
    "dropsitcph": 3607489493,
    "dropfax": 6513066297
  },
  {
    "dcode": "D",
    "dropkey": "PZ16591",
    "droptype": "D",
    "dropname": "CHELAN",
    "dropdeladd": "144 E JOHNSON AVE",
    "dropdelcty": "CHELAN",
    "dropdelst": "WA",
    "dropdelzpp": 988169904,
    "dropphyadd": "144 E JOHNSON AVE",
    "dropphycty": "CHELAN",
    "dropphyst": "WA",
    "dropphyzpp": 988169904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHELAN",
    "dropmalst": "WA",
    "dropmalzpp": 988169998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606829407,
    "dropsitcph": 5096822625,
    "dropfax": 6505774983
  },
  {
    "dcode": "D",
    "dropkey": "PZ16592",
    "droptype": "D",
    "dropname": "CHELAN FALLS",
    "dropdeladd": "67 CHESTNUT ST",
    "dropdelcty": "CHELAN FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 988179900,
    "dropphyadd": "67 CHESTNUT ST",
    "dropphycty": "CHELAN FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 988179900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHELAN FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 988179998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096824105,
    "dropsitcph": 5096824105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16594",
    "droptype": "D",
    "dropname": "CHENEY",
    "dropdeladd": "224 2ND ST",
    "dropdelcty": "CHENEY",
    "dropdelst": "WA",
    "dropdelzpp": 990049998,
    "dropphyadd": "224 2ND ST",
    "dropphycty": "CHENEY",
    "dropphyst": "WA",
    "dropphyzpp": 990049998,
    "dropmaladd": "224 2ND ST",
    "dropmalcty": "CHENEY",
    "dropmalst": "WA",
    "dropmalzpp": 990049998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092351590,
    "dropsitcph": 5092356416,
    "dropfax": 6513066400
  },
  {
    "dcode": "D",
    "dropkey": "PZ16597",
    "droptype": "D",
    "dropname": "CHEWELAH",
    "dropdeladd": "202 E MAIN AVE",
    "dropdelcty": "CHEWELAH",
    "dropdelst": "WA",
    "dropdelzpp": 991099998,
    "dropphyadd": "202 E MAIN AVE",
    "dropphycty": "CHEWELAH",
    "dropphyst": "WA",
    "dropphyzpp": 991099998,
    "dropmaladd": "202 E MAIN AVE",
    "dropmalcty": "CHEWELAH",
    "dropmalst": "WA",
    "dropmalzpp": 991099998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099358801,
    "dropsitcph": 5099358801,
    "dropfax": 6513066658
  },
  {
    "dcode": "D",
    "dropkey": "PZ16600",
    "droptype": "D",
    "dropname": "CHIMACUM",
    "dropdeladd": "9223 RHODY DR",
    "dropdelcty": "CHIMACUM",
    "dropdelst": "WA",
    "dropdelzpp": 983259800,
    "dropphyadd": "9223 RHODY DR",
    "dropphycty": "CHIMACUM",
    "dropphyst": "WA",
    "dropphyzpp": 983259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHIMACUM",
    "dropmalst": "WA",
    "dropmalzpp": 983259998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607324611,
    "dropsitcph": 3607324611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16601",
    "droptype": "D",
    "dropname": "CHINOOK",
    "dropdeladd": "766 HWY 101",
    "dropdelcty": "CHINOOK",
    "dropdelst": "WA",
    "dropdelzpp": 986140998,
    "dropphyadd": "766 HWY 101",
    "dropphycty": "CHINOOK",
    "dropphyst": "WA",
    "dropphyzpp": 986140998,
    "dropmaladd": "766 HWY 101",
    "dropmalcty": "CHINOOK",
    "dropmalst": "WA",
    "dropmalzpp": 986149998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3607778787,
    "dropsitcph": 3607778787,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16604",
    "droptype": "D",
    "dropname": "CINEBAR",
    "dropdeladd": "110 JUSTUS RD STE B",
    "dropdelcty": "CINEBAR",
    "dropdelst": "WA",
    "dropdelzpp": 985339713,
    "dropphyadd": "110 JUSTUS RD STE B",
    "dropphycty": "CINEBAR",
    "dropphyst": "WA",
    "dropphyzpp": 985339713,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CINEBAR",
    "dropmalst": "WA",
    "dropmalzpp": 985339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609857263,
    "dropsitcph": 3609857263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16606",
    "droptype": "D",
    "dropname": "CLALLAM BAY",
    "dropdeladd": "17203 HIGHWAY 112 STE 1",
    "dropdelcty": "CLALLAM BAY",
    "dropdelst": "WA",
    "dropdelzpp": 983269800,
    "dropphyadd": "17203 HIGHWAY 112 STE 1",
    "dropphycty": "CLALLAM BAY",
    "dropphyst": "WA",
    "dropphyzpp": 983269800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLALLAM BAY",
    "dropmalst": "WA",
    "dropmalzpp": 983269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609632553,
    "dropsitcph": 3609632553,
    "dropfax": 3609632321
  },
  {
    "dcode": "D",
    "dropkey": "PZ16609",
    "droptype": "D",
    "dropname": "CLARKSTON",
    "dropdeladd": "949 6TH ST",
    "dropdelcty": "CLARKSTON",
    "dropdelst": "WA",
    "dropdelzpp": 994032668,
    "dropphyadd": "949 6TH ST",
    "dropphycty": "CLARKSTON",
    "dropphyst": "WA",
    "dropphyzpp": 994032668,
    "dropmaladd": "949 6TH ST",
    "dropmalcty": "CLARKSTON",
    "dropmalst": "WA",
    "dropmalzpp": 994032668,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092546019,
    "dropsitcph": 5097587031,
    "dropfax": 5097580572
  },
  {
    "dcode": "D",
    "dropkey": "PZ16610",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "4486 RAILROAD AVE",
    "dropdelcty": "CLAYTON",
    "dropdelst": "WA",
    "dropdelzpp": 991109998,
    "dropphyadd": "4486 RAILROAD AVE",
    "dropphycty": "CLAYTON",
    "dropphyst": "WA",
    "dropphyzpp": 991109998,
    "dropmaladd": "4486 RAILROAD AVE",
    "dropmalcty": "CLAYTON",
    "dropmalst": "WA",
    "dropmalzpp": 991109998,
    "dropsitphn": 5093636221,
    "dropsitlph": 5092762832,
    "dropsitcph": 5092762832,
    "dropfax": 5092762832
  },
  {
    "dcode": "D",
    "dropkey": "PZ16611",
    "droptype": "D",
    "dropname": "CLE ELUM",
    "dropdeladd": "305 E 1ST ST",
    "dropdelcty": "CLE ELUM",
    "dropdelst": "WA",
    "dropdelzpp": 989229998,
    "dropphyadd": "305 E 1ST ST",
    "dropphycty": "CLE ELUM",
    "dropphyst": "WA",
    "dropphyzpp": 989229998,
    "dropmaladd": "305 E 1ST ST",
    "dropmalcty": "CLE ELUM",
    "dropmalst": "WA",
    "dropmalzpp": 989229998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096742444,
    "dropsitcph": 5096742444,
    "dropfax": 6516751647
  },
  {
    "dcode": "D",
    "dropkey": "PZ16613",
    "droptype": "D",
    "dropname": "CLEARLAKE",
    "dropdeladd": "12639 STATE HIGHWAY 9",
    "dropdelcty": "CLEARLAKE",
    "dropdelst": "WA",
    "dropdelzpp": 982359800,
    "dropphyadd": "12639 STATE HIGHWAY 9",
    "dropphycty": "CLEARLAKE",
    "dropphyst": "WA",
    "dropphyzpp": 982359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLEARLAKE",
    "dropmalst": "WA",
    "dropmalzpp": 982359998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608566161,
    "dropsitcph": 3608566161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16618",
    "droptype": "D",
    "dropname": "CLINTON",
    "dropdeladd": "4801 DEER LAKE RD",
    "dropdelcty": "CLINTON",
    "dropdelst": "WA",
    "dropdelzpp": 982368446,
    "dropphyadd": "4801 DEER LAKE RD",
    "dropphycty": "CLINTON",
    "dropphyst": "WA",
    "dropphyzpp": 982368446,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLINTON",
    "dropmalst": "WA",
    "dropmalzpp": 982369998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603415043,
    "dropsitcph": 3603414848,
    "dropfax": 6513066382
  },
  {
    "dcode": "D",
    "dropkey": "PZ16622",
    "droptype": "D",
    "dropname": "COLBERT",
    "dropdeladd": "19823 N YALE RD",
    "dropdelcty": "COLBERT",
    "dropdelst": "WA",
    "dropdelzpp": 990059998,
    "dropphyadd": "19823 N YALE RD",
    "dropphycty": "COLBERT",
    "dropphyst": "WA",
    "dropphyzpp": 990059998,
    "dropmaladd": "19823 N YALE RD",
    "dropmalcty": "COLBERT",
    "dropmalst": "WA",
    "dropmalzpp": 990059998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092385134,
    "dropsitcph": 5092385134,
    "dropfax": 5092389196
  },
  {
    "dcode": "D",
    "dropkey": "PZ16625",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "211 S MAIN ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "WA",
    "dropdelzpp": 991119998,
    "dropphyadd": "211 S MAIN ST",
    "dropphycty": "COLFAX",
    "dropphyst": "WA",
    "dropphyzpp": 991119998,
    "dropmaladd": "211 S MAIN ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "WA",
    "dropmalzpp": 991119998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093972981,
    "dropsitcph": 5093972981,
    "dropfax": 6505775038
  },
  {
    "dcode": "D",
    "dropkey": "PZ16627",
    "droptype": "D",
    "dropname": "COLLEGE PLACE",
    "dropdeladd": "500 S COLLEGE AVE",
    "dropdelcty": "COLLEGE PLACE",
    "dropdelst": "WA",
    "dropdelzpp": 993249998,
    "dropphyadd": "500 S COLLEGE AVE",
    "dropphycty": "COLLEGE PLACE",
    "dropphyst": "WA",
    "dropphyzpp": 993249998,
    "dropmaladd": "500 S COLLEGE AVE",
    "dropmalcty": "COLLEGE PLACE",
    "dropmalst": "WA",
    "dropmalzpp": 993249998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095293821,
    "dropsitcph": 5095293740,
    "dropfax": 6514566158
  },
  {
    "dcode": "D",
    "dropkey": "PZ16628",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "509 STEPTOE ST",
    "dropdelcty": "COLTON",
    "dropdelst": "WA",
    "dropdelzpp": 991139998,
    "dropphyadd": "509 STEPTOE ST",
    "dropphycty": "COLTON",
    "dropphyst": "WA",
    "dropphyzpp": 991139998,
    "dropmaladd": "509 STEPTOE ST",
    "dropmalcty": "COLTON",
    "dropmalst": "WA",
    "dropmalzpp": 991139998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092293398,
    "dropsitcph": 5092293398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16634",
    "droptype": "D",
    "dropname": "COLVILLE",
    "dropdeladd": "204 S OAK ST",
    "dropdelcty": "COLVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 991149998,
    "dropphyadd": "204 S OAK ST",
    "dropphycty": "COLVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 991149998,
    "dropmaladd": "204 S OAK ST",
    "dropmalcty": "COLVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 991149998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096842241,
    "dropsitcph": 5096842241,
    "dropfax": 6514566160
  },
  {
    "dcode": "D",
    "dropkey": "PZ16635",
    "droptype": "D",
    "dropname": "CONCONULLY",
    "dropdeladd": "221 N LOTTIE AVE",
    "dropdelcty": "CONCONULLY",
    "dropdelst": "WA",
    "dropdelzpp": 988199800,
    "dropphyadd": "221 N LOTTIE AVE",
    "dropphycty": "CONCONULLY",
    "dropphyst": "WA",
    "dropphyzpp": 988199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONCONULLY",
    "dropmalst": "WA",
    "dropmalzpp": 988199998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098266305,
    "dropsitcph": 5098266305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16636",
    "droptype": "D",
    "dropname": "CONCRETE",
    "dropdeladd": "45650 MAIN ST",
    "dropdelcty": "CONCRETE",
    "dropdelst": "WA",
    "dropdelzpp": 982379689,
    "dropphyadd": "45650 MAIN ST",
    "dropphycty": "CONCRETE",
    "dropphyst": "WA",
    "dropphyzpp": 982379689,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONCRETE",
    "dropmalst": "WA",
    "dropmalzpp": 982379998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608538311,
    "dropsitcph": 3608538311,
    "dropfax": 6505774908
  },
  {
    "dcode": "D",
    "dropkey": "PZ16637",
    "droptype": "D",
    "dropname": "CONNELL",
    "dropdeladd": "115 E FRANKLIN ST",
    "dropdelcty": "CONNELL",
    "dropdelst": "WA",
    "dropdelzpp": 993269998,
    "dropphyadd": "115 E FRANKLIN ST",
    "dropphycty": "CONNELL",
    "dropphyst": "WA",
    "dropphyzpp": 993269998,
    "dropmaladd": "115 E FRANKLIN ST",
    "dropmalcty": "CONNELL",
    "dropmalst": "WA",
    "dropmalzpp": 993269998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092342111,
    "dropsitcph": 5092342111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16638",
    "droptype": "D",
    "dropname": "CONWAY",
    "dropdeladd": "18620 MAIN ST",
    "dropdelcty": "CONWAY",
    "dropdelst": "WA",
    "dropdelzpp": 982389800,
    "dropphyadd": "18620 MAIN ST",
    "dropphycty": "CONWAY",
    "dropphyst": "WA",
    "dropphyzpp": 982389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONWAY",
    "dropmalst": "WA",
    "dropmalzpp": 982389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604454755,
    "dropsitcph": 3604454755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16641",
    "droptype": "D",
    "dropname": "COPALIS BEACH",
    "dropdeladd": "731 COPALIS BEACH RD",
    "dropdelcty": "COPALIS BEACH",
    "dropdelst": "WA",
    "dropdelzpp": 985359800,
    "dropphyadd": "731 COPALIS BEACH RD",
    "dropphycty": "COPALIS BEACH",
    "dropphyst": "WA",
    "dropphyzpp": 985359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPALIS BEACH",
    "dropmalst": "WA",
    "dropmalzpp": 985359998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602892703,
    "dropsitcph": 3602892703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16642",
    "droptype": "D",
    "dropname": "COPALIS CROSSING",
    "dropdeladd": "1663 OCEAN BEACH RD",
    "dropdelcty": "COPALIS CROSSING",
    "dropdelst": "WA",
    "dropdelzpp": 985369800,
    "dropphyadd": "1663 OCEAN BEACH RD",
    "dropphycty": "COPALIS CROSSING",
    "dropphyst": "WA",
    "dropphyzpp": 985369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COPALIS CROSSING",
    "dropmalst": "WA",
    "dropmalzpp": 985369998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602890252,
    "dropsitcph": 3602890252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16643",
    "droptype": "D",
    "dropname": "COSMOPOLIS",
    "dropdeladd": "114 F ST",
    "dropdelcty": "COSMOPOLIS",
    "dropdelst": "WA",
    "dropdelzpp": 985379801,
    "dropphyadd": "114 F ST",
    "dropphycty": "COSMOPOLIS",
    "dropphyst": "WA",
    "dropphyzpp": 985379801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COSMOPOLIS",
    "dropmalst": "WA",
    "dropmalzpp": 985379998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605333305,
    "dropsitcph": 3605333305,
    "dropfax": 3605339855
  },
  {
    "dcode": "D",
    "dropkey": "PZ16646",
    "droptype": "D",
    "dropname": "COUGAR",
    "dropdeladd": "16745 LEWIS RIVER RD",
    "dropdelcty": "COUGAR",
    "dropdelst": "WA",
    "dropdelzpp": 986169707,
    "dropphyadd": "16745 LEWIS RIVER RD",
    "dropphycty": "COUGAR",
    "dropphyst": "WA",
    "dropphyzpp": 986169707,
    "dropmaladd": "16745 LEWIS RIVER RD",
    "dropmalcty": "COUGAR",
    "dropmalst": "WA",
    "dropmalzpp": 986169998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602385324,
    "dropsitcph": 3602385324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16647",
    "droptype": "D",
    "dropname": "COULEE CITY",
    "dropdeladd": "101 N 4TH ST",
    "dropdelcty": "COULEE CITY",
    "dropdelst": "WA",
    "dropdelzpp": 991159998,
    "dropphyadd": "101 N 4TH ST",
    "dropphycty": "COULEE CITY",
    "dropphyst": "WA",
    "dropphyzpp": 991159998,
    "dropmaladd": "101 N 4TH ST",
    "dropmalcty": "COULEE CITY",
    "dropmalst": "WA",
    "dropmalzpp": 991159998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096325751,
    "dropsitcph": 5096325751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16648",
    "droptype": "D",
    "dropname": "COULEE DAM",
    "dropdeladd": "402 MEAD WAY",
    "dropdelcty": "COULEE DAM",
    "dropdelst": "WA",
    "dropdelzpp": 991169998,
    "dropphyadd": "402 MEAD WAY",
    "dropphycty": "COULEE DAM",
    "dropphyst": "WA",
    "dropphyzpp": 991169998,
    "dropmaladd": "402 MEAD WAY",
    "dropmalcty": "COULEE DAM",
    "dropmalst": "WA",
    "dropmalzpp": 991169998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096330390,
    "dropsitcph": 5096330390,
    "dropfax": 5096333088
  },
  {
    "dcode": "D",
    "dropkey": "PZ16649",
    "droptype": "D",
    "dropname": "COUPEVILLE",
    "dropdeladd": "201 NW COVELAND ST",
    "dropdelcty": "COUPEVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 982399800,
    "dropphyadd": "201 NW COVELAND ST",
    "dropphycty": "COUPEVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 982399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COUPEVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 982399998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606785353,
    "dropsitcph": 3606785353,
    "dropfax": 3606785232
  },
  {
    "dcode": "D",
    "dropkey": "PZ16652",
    "droptype": "D",
    "dropname": "COWICHE",
    "dropdeladd": "161 COWICHE CITY RD",
    "dropdelcty": "COWICHE",
    "dropdelst": "WA",
    "dropdelzpp": 989233000,
    "dropphyadd": "161 COWICHE CITY RD",
    "dropphycty": "COWICHE",
    "dropphyst": "WA",
    "dropphyzpp": 989233000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COWICHE",
    "dropmalst": "WA",
    "dropmalzpp": 989239998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096784480,
    "dropsitcph": 5096784480,
    "dropfax": 6505783009
  },
  {
    "dcode": "D",
    "dropkey": "PZ16656",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "115 SW CRESTON AVE",
    "dropdelcty": "CRESTON",
    "dropdelst": "WA",
    "dropdelzpp": 991179998,
    "dropphyadd": "115 SW CRESTON AVE",
    "dropphycty": "CRESTON",
    "dropphyst": "WA",
    "dropphyzpp": 991179998,
    "dropmaladd": "115 SW CRESTON AVE",
    "dropmalcty": "CRESTON",
    "dropmalst": "WA",
    "dropmalzpp": 991179998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096363255,
    "dropsitcph": 5096363255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16668",
    "droptype": "D",
    "dropname": "CURLEW",
    "dropdeladd": "1 RIVER ST",
    "dropdelcty": "CURLEW",
    "dropdelst": "WA",
    "dropdelzpp": 991189998,
    "dropphyadd": "1 RIVER ST",
    "dropphycty": "CURLEW",
    "dropphyst": "WA",
    "dropphyzpp": 991189998,
    "dropmaladd": "1 RIVER ST",
    "dropmalcty": "CURLEW",
    "dropmalst": "WA",
    "dropmalzpp": 991189998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097794640,
    "dropsitcph": 5097794640,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16669",
    "droptype": "D",
    "dropname": "CURTIS",
    "dropdeladd": "388 BOISTFORT RD",
    "dropdelcty": "CURTIS",
    "dropdelst": "WA",
    "dropdelzpp": 985389800,
    "dropphyadd": "388 BOISTFORT RD",
    "dropphycty": "CURTIS",
    "dropphyst": "WA",
    "dropphyzpp": 985389800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CURTIS",
    "dropmalst": "WA",
    "dropmalzpp": 985389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602453224,
    "dropsitcph": 3602453224,
    "dropfax": 3602453774
  },
  {
    "dcode": "D",
    "dropkey": "PZ16671",
    "droptype": "D",
    "dropname": "CUSICK",
    "dropdeladd": "205 S 1ST ST",
    "dropdelcty": "CUSICK",
    "dropdelst": "WA",
    "dropdelzpp": 991199998,
    "dropphyadd": "205 S 1ST ST",
    "dropphycty": "CUSICK",
    "dropphyst": "WA",
    "dropphyzpp": 991199998,
    "dropmaladd": "205 S 1ST ST",
    "dropmalcty": "CUSICK",
    "dropmalst": "WA",
    "dropmalzpp": 991199998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094451553,
    "dropsitcph": 5094451553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16672",
    "droptype": "D",
    "dropname": "CUSTER",
    "dropdeladd": "7632 PORTAL WAY",
    "dropdelcty": "CUSTER",
    "dropdelst": "WA",
    "dropdelzpp": 982409998,
    "dropphyadd": "7632 PORTAL WAY",
    "dropphycty": "CUSTER",
    "dropphyst": "WA",
    "dropphyzpp": 982409998,
    "dropmaladd": "7632 PORTAL WAY",
    "dropmalcty": "CUSTER",
    "dropmalst": "WA",
    "dropmalzpp": 982409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603665666,
    "dropsitcph": 3603665666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16675",
    "droptype": "D",
    "dropname": "DALLESPORT",
    "dropdeladd": "316 6TH AVE",
    "dropdelcty": "DALLESPORT",
    "dropdelst": "WA",
    "dropdelzpp": 986170998,
    "dropphyadd": "316 6TH AVE",
    "dropphycty": "DALLESPORT",
    "dropphyst": "WA",
    "dropphyzpp": 986170998,
    "dropmaladd": "316 6TH AVE",
    "dropmalcty": "DALLESPORT",
    "dropmalst": "WA",
    "dropmalzpp": 986179998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5097671577,
    "dropsitcph": 5097671577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16676",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "2 FOURTH OF JULY CREEK RD",
    "dropdelcty": "DANVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 991219998,
    "dropphyadd": "2 FOURTH OF JULY CREEK RD",
    "dropphycty": "DANVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 991219998,
    "dropmaladd": "2 FOURTH OF JULY CREEK RD",
    "dropmalcty": "DANVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 991219998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097794485,
    "dropsitcph": 5097794485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16677",
    "droptype": "D",
    "dropname": "DARRINGTON",
    "dropdeladd": "715 GIVENS AVE",
    "dropdelcty": "DARRINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 982419900,
    "dropphyadd": "715 GIVENS AVE",
    "dropphycty": "DARRINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 982419900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DARRINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 982419998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604361100,
    "dropsitcph": 3604361100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16678",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "402 7TH ST",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "WA",
    "dropdelzpp": 991229998,
    "dropphyadd": "402 7TH ST",
    "dropphycty": "DAVENPORT",
    "dropphyst": "WA",
    "dropphyzpp": 991229998,
    "dropmaladd": "402 7TH ST",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "WA",
    "dropmalzpp": 991229998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097251131,
    "dropsitcph": 5097251131,
    "dropfax": 5097254359
  },
  {
    "dcode": "D",
    "dropkey": "PZ16679",
    "droptype": "D",
    "dropname": "DAYTON",
    "dropdeladd": "202 S 2ND ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "WA",
    "dropdelzpp": 993289998,
    "dropphyadd": "202 S 2ND ST",
    "dropphycty": "DAYTON",
    "dropphyst": "WA",
    "dropphyzpp": 993289998,
    "dropmaladd": "202 S 2ND ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "WA",
    "dropmalzpp": 993289998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093824431,
    "dropsitcph": 5093824431,
    "dropfax": 5093824959
  },
  {
    "dcode": "D",
    "dropkey": "PZ16681",
    "droptype": "D",
    "dropname": "DEER HARBOR",
    "dropdeladd": "20 JACK AND JILL PL",
    "dropdelcty": "DEER HARBOR",
    "dropdelst": "WA",
    "dropdelzpp": 982439800,
    "dropphyadd": "20 JACK AND JILL PL",
    "dropphycty": "DEER HARBOR",
    "dropphyst": "WA",
    "dropphyzpp": 982439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEER HARBOR",
    "dropmalst": "WA",
    "dropmalzpp": 982439998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603762548,
    "dropsitcph": 3603762548,
    "dropfax": 3603763863
  },
  {
    "dcode": "D",
    "dropkey": "PZ16683",
    "droptype": "D",
    "dropname": "DEER PARK",
    "dropdeladd": "19 S VERNON AVE",
    "dropdelcty": "DEER PARK",
    "dropdelst": "WA",
    "dropdelzpp": 990069998,
    "dropphyadd": "19 S VERNON AVE",
    "dropphycty": "DEER PARK",
    "dropphyst": "WA",
    "dropphyzpp": 990069998,
    "dropmaladd": "19 S VERNON AVE",
    "dropmalcty": "DEER PARK",
    "dropmalst": "WA",
    "dropmalzpp": 990069998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098216003,
    "dropsitcph": 5092761091,
    "dropfax": 6505775059
  },
  {
    "dcode": "D",
    "dropkey": "PZ16684",
    "droptype": "D",
    "dropname": "DEMING",
    "dropdeladd": "5014 DEMING RD",
    "dropdelcty": "DEMING",
    "dropdelst": "WA",
    "dropdelzpp": 982449903,
    "dropphyadd": "5014 DEMING RD",
    "dropphycty": "DEMING",
    "dropphyst": "WA",
    "dropphyzpp": 982449903,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DEMING",
    "dropmalst": "WA",
    "dropmalzpp": 982449998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605922032,
    "dropsitcph": 3605922032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16696",
    "droptype": "D",
    "dropname": "DIXIE",
    "dropdeladd": "10202 E HIGHWAY 12",
    "dropdelcty": "DIXIE",
    "dropdelst": "WA",
    "dropdelzpp": 993299998,
    "dropphyadd": "10202 E HIGHWAY 12",
    "dropphycty": "DIXIE",
    "dropphyst": "WA",
    "dropphyzpp": 993299998,
    "dropmaladd": "10202 E HIGHWAY 12",
    "dropmalcty": "DIXIE",
    "dropmalst": "WA",
    "dropmalzpp": 993299998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095291433,
    "dropsitcph": 5095291433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16702",
    "droptype": "D",
    "dropname": "DOTY",
    "dropdeladd": "212 STEVENS RD",
    "dropdelcty": "DOTY",
    "dropdelst": "WA",
    "dropdelzpp": 985399800,
    "dropphyadd": "212 STEVENS RD",
    "dropphycty": "DOTY",
    "dropphyst": "WA",
    "dropphyzpp": 985399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOTY",
    "dropmalst": "WA",
    "dropmalzpp": 985399998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602913822,
    "dropsitcph": 3602913822,
    "dropfax": 3602912821
  },
  {
    "dcode": "D",
    "dropkey": "PZ16708",
    "droptype": "D",
    "dropname": "DRYDEN",
    "dropdeladd": "6828 DRYDEN AVE",
    "dropdelcty": "DRYDEN",
    "dropdelst": "WA",
    "dropdelzpp": 988219800,
    "dropphyadd": "6828 DRYDEN AVE",
    "dropphycty": "DRYDEN",
    "dropphyst": "WA",
    "dropphyzpp": 988219800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DRYDEN",
    "dropmalst": "WA",
    "dropmalzpp": 988219998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097823324,
    "dropsitcph": 5097823324,
    "dropfax": 5097827075
  },
  {
    "dcode": "D",
    "dropkey": "PZ16709",
    "droptype": "D",
    "dropname": "DUPONT",
    "dropdeladd": "1313 THOMPSON CIR",
    "dropdelcty": "DUPONT",
    "dropdelst": "WA",
    "dropdelzpp": 983279913,
    "dropphyadd": "1313 THOMPSON CIR",
    "dropphycty": "DUPONT",
    "dropphyst": "WA",
    "dropphyzpp": 983279913,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUPONT",
    "dropmalst": "WA",
    "dropmalzpp": 983279998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539648333,
    "dropsitcph": 2539648333,
    "dropfax": 6513066303
  },
  {
    "dcode": "D",
    "dropkey": "PZ16711",
    "droptype": "D",
    "dropname": "DUVALL",
    "dropdeladd": "26400 NE VALLEY ST",
    "dropdelcty": "DUVALL",
    "dropdelst": "WA",
    "dropdelzpp": 980198499,
    "dropphyadd": "26400 NE VALLEY ST",
    "dropphycty": "DUVALL",
    "dropphyst": "WA",
    "dropphyzpp": 980198499,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUVALL",
    "dropmalst": "WA",
    "dropmalzpp": 980199998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4257883986,
    "dropsitcph": 4257885645,
    "dropfax": 6514566164
  },
  {
    "dcode": "D",
    "dropkey": "PZ16717",
    "droptype": "D",
    "dropname": "EAST OLYMPIA",
    "dropdeladd": "8315 NORMANDY ST SE",
    "dropdelcty": "EAST OLYMPIA",
    "dropdelst": "WA",
    "dropdelzpp": 985409800,
    "dropphyadd": "8315 NORMANDY ST SE",
    "dropphycty": "EAST OLYMPIA",
    "dropphyst": "WA",
    "dropphyzpp": 985409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST OLYMPIA",
    "dropmalst": "WA",
    "dropmalzpp": 985409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604916647,
    "dropsitcph": 3604916647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16727",
    "droptype": "D",
    "dropname": "EASTON",
    "dropdeladd": "2151 RAILROAD ST",
    "dropdelcty": "EASTON",
    "dropdelst": "WA",
    "dropdelzpp": 989259800,
    "dropphyadd": "2151 RAILROAD ST",
    "dropphycty": "EASTON",
    "dropphyst": "WA",
    "dropphyzpp": 989259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTON",
    "dropmalst": "WA",
    "dropmalzpp": 989259998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096562244,
    "dropsitcph": 5096562244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16728",
    "droptype": "D",
    "dropname": "EASTSOUND",
    "dropdeladd": "221 A ST STE 1",
    "dropdelcty": "EASTSOUND",
    "dropdelst": "WA",
    "dropdelzpp": 982458933,
    "dropphyadd": "221 A ST STE 1",
    "dropphycty": "EASTSOUND",
    "dropphyst": "WA",
    "dropphyzpp": 982458933,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EASTSOUND",
    "dropmalst": "WA",
    "dropmalzpp": 982459998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603764003,
    "dropsitcph": 3603764121,
    "dropfax": 6514566166
  },
  {
    "dcode": "D",
    "dropkey": "PZ16729",
    "droptype": "D",
    "dropname": "EATONVILLE",
    "dropdeladd": "103 CENTER ST W",
    "dropdelcty": "EATONVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 983286400,
    "dropphyadd": "103 CENTER ST W",
    "dropphycty": "EATONVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 983286400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EATONVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 983289998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608326614,
    "dropsitcph": 3608326613,
    "dropfax": 6514566167
  },
  {
    "dcode": "D",
    "dropkey": "PZ16735",
    "droptype": "D",
    "dropname": "EDMONDS",
    "dropdeladd": "130 2ND AVE N",
    "dropdelcty": "EDMONDS",
    "dropdelst": "WA",
    "dropdelzpp": 980209998,
    "dropphyadd": "130 2ND AVE N",
    "dropphycty": "EDMONDS",
    "dropphyst": "WA",
    "dropphyzpp": 980209998,
    "dropmaladd": "130 2ND AVE N",
    "dropmalcty": "EDMONDS",
    "dropmalst": "WA",
    "dropmalzpp": 980209998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4257740377,
    "dropsitcph": 4257719173,
    "dropfax": 6514566168
  },
  {
    "dcode": "D",
    "dropkey": "PZ16738",
    "droptype": "D",
    "dropname": "ELBE",
    "dropdeladd": "54125 MOUNTAIN HWY E",
    "dropdelcty": "ELBE",
    "dropdelst": "WA",
    "dropdelzpp": 983309800,
    "dropphyadd": "54125 MOUNTAIN HWY E",
    "dropphycty": "ELBE",
    "dropphyst": "WA",
    "dropphyzpp": 983309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELBE",
    "dropmalst": "WA",
    "dropmalzpp": 983309998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605692733,
    "dropsitcph": 3605692733,
    "dropfax": 3605692864
  },
  {
    "dcode": "D",
    "dropkey": "PZ16740",
    "droptype": "D",
    "dropname": "ELECTRIC CITY",
    "dropdeladd": "5 W COULEE BLVD",
    "dropdelcty": "ELECTRIC CITY",
    "dropdelst": "WA",
    "dropdelzpp": 991239998,
    "dropphyadd": "5 W COULEE BLVD",
    "dropphycty": "ELECTRIC CITY",
    "dropphyst": "WA",
    "dropphyzpp": 991239998,
    "dropmaladd": "5 W COULEE BLVD",
    "dropmalcty": "ELECTRIC CITY",
    "dropmalst": "WA",
    "dropmalzpp": 991239998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096330606,
    "dropsitcph": 5096330606,
    "dropfax": 5096333180
  },
  {
    "dcode": "D",
    "dropkey": "PZ16745",
    "droptype": "D",
    "dropname": "ELK",
    "dropdeladd": "9409 E BRIDGES RD",
    "dropdelcty": "ELK",
    "dropdelst": "WA",
    "dropdelzpp": 990099998,
    "dropphyadd": "9409 E BRIDGES RD",
    "dropphycty": "ELK",
    "dropphyst": "WA",
    "dropphyzpp": 990099998,
    "dropmaladd": "9409 E BRIDGES RD",
    "dropmalcty": "ELK",
    "dropmalst": "WA",
    "dropmalzpp": 990099998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092922250,
    "dropsitcph": 5092922250,
    "dropfax": 5092922250
  },
  {
    "dcode": "D",
    "dropkey": "PZ16747",
    "droptype": "D",
    "dropname": "ELLENSBURG",
    "dropdeladd": "100 E 3RD AVE",
    "dropdelcty": "ELLENSBURG",
    "dropdelst": "WA",
    "dropdelzpp": 989269998,
    "dropphyadd": "100 E 3RD AVE",
    "dropphycty": "ELLENSBURG",
    "dropphyst": "WA",
    "dropphyzpp": 989269998,
    "dropmaladd": "100 E 3RD AVE",
    "dropmalcty": "ELLENSBURG",
    "dropmalst": "WA",
    "dropmalzpp": 989269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5099624360,
    "dropsitcph": 5099624360,
    "dropfax": 6514566169
  },
  {
    "dcode": "D",
    "dropkey": "PZ16749",
    "droptype": "D",
    "dropname": "ELMA",
    "dropdeladd": "204 W YOUNG ST",
    "dropdelcty": "ELMA",
    "dropdelst": "WA",
    "dropdelzpp": 985419800,
    "dropphyadd": "204 W YOUNG ST",
    "dropphycty": "ELMA",
    "dropphyst": "WA",
    "dropphyzpp": 985419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELMA",
    "dropmalst": "WA",
    "dropmalzpp": 985419998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604823120,
    "dropsitcph": 3604822511,
    "dropfax": 6514566170
  },
  {
    "dcode": "D",
    "dropkey": "PZ16750",
    "droptype": "D",
    "dropname": "ELMER CITY",
    "dropdeladd": "16 S FRONT ST",
    "dropdelcty": "ELMER CITY",
    "dropdelst": "WA",
    "dropdelzpp": 991249998,
    "dropphyadd": "16 S FRONT ST",
    "dropphycty": "ELMER CITY",
    "dropphyst": "WA",
    "dropphyzpp": 991249998,
    "dropmaladd": "16 S FRONT ST",
    "dropmalcty": "ELMER CITY",
    "dropmalst": "WA",
    "dropmalzpp": 991249998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096331371,
    "dropsitcph": 5096331371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16751",
    "droptype": "D",
    "dropname": "ELTOPIA",
    "dropdeladd": "13101 GLADE NORTH RD",
    "dropdelcty": "ELTOPIA",
    "dropdelst": "WA",
    "dropdelzpp": 993309998,
    "dropphyadd": "13101 GLADE NORTH RD",
    "dropphycty": "ELTOPIA",
    "dropphyst": "WA",
    "dropphyzpp": 993309998,
    "dropmaladd": "13101 GLADE NORTH RD",
    "dropmalcty": "ELTOPIA",
    "dropmalst": "WA",
    "dropmalzpp": 993309998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092974277,
    "dropsitcph": 5092974277,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16752",
    "droptype": "D",
    "dropname": "ENDICOTT",
    "dropdeladd": "308 D ST",
    "dropdelcty": "ENDICOTT",
    "dropdelst": "WA",
    "dropdelzpp": 991259998,
    "dropphyadd": "308 D ST",
    "dropphycty": "ENDICOTT",
    "dropphyst": "WA",
    "dropphyzpp": 991259998,
    "dropmaladd": "308 D ST",
    "dropmalcty": "ENDICOTT",
    "dropmalst": "WA",
    "dropmalzpp": 991259998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096573567,
    "dropsitcph": 5096573567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16754",
    "droptype": "D",
    "dropname": "ENTIAT",
    "dropdeladd": "14108 KINZEL ST",
    "dropdelcty": "ENTIAT",
    "dropdelst": "WA",
    "dropdelzpp": 988229800,
    "dropphyadd": "14108 KINZEL ST",
    "dropphycty": "ENTIAT",
    "dropphyst": "WA",
    "dropphyzpp": 988229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ENTIAT",
    "dropmalst": "WA",
    "dropmalzpp": 988229998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097841414,
    "dropsitcph": 5097841414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16755",
    "droptype": "D",
    "dropname": "ENUMCLAW",
    "dropdeladd": "1742 COLE ST",
    "dropdelcty": "ENUMCLAW",
    "dropdelst": "WA",
    "dropdelzpp": 980229998,
    "dropphyadd": "1742 COLE ST",
    "dropphycty": "ENUMCLAW",
    "dropphyst": "WA",
    "dropphyzpp": 980229998,
    "dropmaladd": "1742 COLE ST",
    "dropmalcty": "ENUMCLAW",
    "dropmalst": "WA",
    "dropmalzpp": 980229998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608258325,
    "dropsitcph": 3608258325,
    "dropfax": 6514566171
  },
  {
    "dcode": "D",
    "dropkey": "PZ16756",
    "droptype": "D",
    "dropname": "EPHRATA",
    "dropdeladd": "119 1ST AVE NW",
    "dropdelcty": "EPHRATA",
    "dropdelst": "WA",
    "dropdelzpp": 988239998,
    "dropphyadd": "119 1ST AVE NW",
    "dropphycty": "EPHRATA",
    "dropphyst": "WA",
    "dropphyzpp": 988239998,
    "dropmaladd": "119 1ST AVE NW",
    "dropmalcty": "EPHRATA",
    "dropmalst": "WA",
    "dropmalzpp": 988239998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097542501,
    "dropsitcph": 5097548990,
    "dropfax": 6514566172
  },
  {
    "dcode": "D",
    "dropkey": "PZ16759",
    "droptype": "D",
    "dropname": "ETHEL",
    "dropdeladd": "1421 US HIGHWAY 12",
    "dropdelcty": "ETHEL",
    "dropdelst": "WA",
    "dropdelzpp": 985429732,
    "dropphyadd": "1421 US HIGHWAY 12",
    "dropphycty": "ETHEL",
    "dropphyst": "WA",
    "dropphyzpp": 985429732,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ETHEL",
    "dropmalst": "WA",
    "dropmalzpp": 985429998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609784662,
    "dropsitcph": 3609784662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16763",
    "droptype": "D",
    "dropname": "EVERETT",
    "dropdeladd": "3102 HOYT AVE",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982019998,
    "dropphyadd": "3102 HOYT AVE",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982019998,
    "dropmaladd": "3102 HOYT AVE",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982019998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252581739,
    "dropsitcph": 4252573208,
    "dropfax": 6514566173
  },
  {
    "dcode": "D",
    "dropkey": "PZ16770",
    "droptype": "D",
    "dropname": "EVERSON",
    "dropdeladd": "108 BLAIR DR",
    "dropdelcty": "EVERSON",
    "dropdelst": "WA",
    "dropdelzpp": 982479669,
    "dropphyadd": "108 BLAIR DR",
    "dropphycty": "EVERSON",
    "dropphyst": "WA",
    "dropphyzpp": 982479669,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EVERSON",
    "dropmalst": "WA",
    "dropmalzpp": 982479998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609664700,
    "dropsitcph": 3609664700,
    "dropfax": 6505776135
  },
  {
    "dcode": "D",
    "dropkey": "PZ16776",
    "droptype": "D",
    "dropname": "FAIRCHILD AIR FORCE BASE",
    "dropdeladd": "100 N CHENNAULT AVE STE 100",
    "dropdelcty": "FAIRCHILD AIR FORCE BASE",
    "dropdelst": "WA",
    "dropdelzpp": 990119998,
    "dropphyadd": "100 N CHENNAULT AVE STE 100",
    "dropphycty": "FAIRCHILD AIR FORCE BASE",
    "dropphyst": "WA",
    "dropphyzpp": 990119998,
    "dropmaladd": "100 N CHENNAULT AVE STE 100",
    "dropmalcty": "FAIRCHILD AIR FORCE BASE",
    "dropmalst": "WA",
    "dropmalzpp": 990119998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092446398,
    "dropsitcph": 5092446398,
    "dropfax": 6505772640
  },
  {
    "dcode": "D",
    "dropkey": "PZ16777",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "220 MAIN ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "WA",
    "dropdelzpp": 990129998,
    "dropphyadd": "220 MAIN ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "WA",
    "dropphyzpp": 990129998,
    "dropmaladd": "220 MAIN ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "WA",
    "dropmalzpp": 990129998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092832513,
    "dropsitcph": 5092832513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16783",
    "droptype": "D",
    "dropname": "FALL CITY",
    "dropdeladd": "4225 335TH PL SE",
    "dropdelcty": "FALL CITY",
    "dropdelst": "WA",
    "dropdelzpp": 980245899,
    "dropphyadd": "4225 335TH PL SE",
    "dropphycty": "FALL CITY",
    "dropphyst": "WA",
    "dropphyzpp": 980245899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FALL CITY",
    "dropmalst": "WA",
    "dropmalzpp": 980249998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252227439,
    "dropsitcph": 4252227501,
    "dropfax": 6505776079
  },
  {
    "dcode": "D",
    "dropkey": "PZ16785",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "105 E MAIN ST",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 991289998,
    "dropphyadd": "105 E MAIN ST",
    "dropphycty": "FARMINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 991289998,
    "dropmaladd": "105 E MAIN ST",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 991289998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092872631,
    "dropsitcph": 5092872631,
    "dropfax": 6505784656
  },
  {
    "dcode": "D",
    "dropkey": "PZ16790",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "5703 4TH AVE",
    "dropdelcty": "FERNDALE",
    "dropdelst": "WA",
    "dropdelzpp": 982489927,
    "dropphyadd": "5703 4TH AVE",
    "dropphycty": "FERNDALE",
    "dropphyst": "WA",
    "dropphyzpp": 982489927,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FERNDALE",
    "dropmalst": "WA",
    "dropmalzpp": 982489998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603803127,
    "dropsitcph": 3603803127,
    "dropfax": 6514566175
  },
  {
    "dcode": "D",
    "dropkey": "PZ16801",
    "droptype": "D",
    "dropname": "FORD",
    "dropdeladd": "5273C FORD WELLPINIT RD",
    "dropdelcty": "FORD",
    "dropdelst": "WA",
    "dropdelzpp": 990139998,
    "dropphyadd": "5273C FORD WELLPINIT RD",
    "dropphycty": "FORD",
    "dropphyst": "WA",
    "dropphyzpp": 990139998,
    "dropmaladd": "5273C FORD WELLPINIT RD",
    "dropmalcty": "FORD",
    "dropmalst": "WA",
    "dropmalzpp": 990139998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092587409,
    "dropsitcph": 5092587409,
    "dropfax": 5092588905
  },
  {
    "dcode": "D",
    "dropkey": "PZ16806",
    "droptype": "D",
    "dropname": "FORKS",
    "dropdeladd": "61 S SPARTAN AVE",
    "dropdelcty": "FORKS",
    "dropdelst": "WA",
    "dropdelzpp": 983319997,
    "dropphyadd": "61 S SPARTAN AVE",
    "dropphycty": "FORKS",
    "dropphyst": "WA",
    "dropphyzpp": 983319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORKS",
    "dropmalst": "WA",
    "dropmalzpp": 983319998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603746303,
    "dropsitcph": 3603746303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16813",
    "droptype": "D",
    "dropname": "FOUR LAKES",
    "dropdeladd": "10117 S ELECTRIC AVE",
    "dropdelcty": "FOUR LAKES",
    "dropdelst": "WA",
    "dropdelzpp": 990149998,
    "dropphyadd": "10117 S ELECTRIC AVE",
    "dropphycty": "FOUR LAKES",
    "dropphyst": "WA",
    "dropphyzpp": 990149998,
    "dropmaladd": "10117 S ELECTRIC AVE",
    "dropmalcty": "FOUR LAKES",
    "dropmalst": "WA",
    "dropmalzpp": 990149998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098388172,
    "dropsitcph": 5098388172,
    "dropfax": 5098380110
  },
  {
    "dcode": "D",
    "dropkey": "PZ16815",
    "droptype": "D",
    "dropname": "FOX ISLAND",
    "dropdeladd": "560 FOX DR",
    "dropdelcty": "FOX ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 983339801,
    "dropphyadd": "560 FOX DR",
    "dropphycty": "FOX ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 983339801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FOX ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 983339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535492517,
    "dropsitcph": 2535492517,
    "dropfax": 6505772770
  },
  {
    "dcode": "D",
    "dropkey": "PZ16818",
    "droptype": "D",
    "dropname": "FREELAND",
    "dropdeladd": "1619 MAIN ST",
    "dropdelcty": "FREELAND",
    "dropdelst": "WA",
    "dropdelzpp": 982499911,
    "dropphyadd": "1619 MAIN ST",
    "dropphycty": "FREELAND",
    "dropphyst": "WA",
    "dropphyzpp": 982499911,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FREELAND",
    "dropmalst": "WA",
    "dropmalzpp": 982499998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603312484,
    "dropsitcph": 3603316500,
    "dropfax": 6505783893
  },
  {
    "dcode": "D",
    "dropkey": "PZ16820",
    "droptype": "D",
    "dropname": "FRIDAY HARBOR",
    "dropdeladd": "220 BLAIR AVE",
    "dropdelcty": "FRIDAY HARBOR",
    "dropdelst": "WA",
    "dropdelzpp": 982509800,
    "dropphyadd": "220 BLAIR AVE",
    "dropphycty": "FRIDAY HARBOR",
    "dropphyst": "WA",
    "dropphyzpp": 982509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FRIDAY HARBOR",
    "dropmalst": "WA",
    "dropmalzpp": 982509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603784511,
    "dropsitcph": 3603784511,
    "dropfax": 6514566178
  },
  {
    "dcode": "D",
    "dropkey": "PZ16828",
    "droptype": "D",
    "dropname": "GALVIN",
    "dropdeladd": "4810 GALVIN RD",
    "dropdelcty": "GALVIN",
    "dropdelst": "WA",
    "dropdelzpp": 985449800,
    "dropphyadd": "4810 GALVIN RD",
    "dropphycty": "GALVIN",
    "dropphyst": "WA",
    "dropphyzpp": 985449800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GALVIN",
    "dropmalst": "WA",
    "dropmalzpp": 985449998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603302234,
    "dropsitcph": 3603302234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16831",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "302 W CALIFORNIA ST",
    "dropdelcty": "GARFIELD",
    "dropdelst": "WA",
    "dropdelzpp": 991309998,
    "dropphyadd": "302 W CALIFORNIA ST",
    "dropphycty": "GARFIELD",
    "dropphyst": "WA",
    "dropphyzpp": 991309998,
    "dropmaladd": "302 W CALIFORNIA ST",
    "dropmalcty": "GARFIELD",
    "dropmalst": "WA",
    "dropmalzpp": 991309998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096351203,
    "dropsitcph": 5096351203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16839",
    "droptype": "D",
    "dropname": "GIFFORD",
    "dropdeladd": "3379 HIGHWAY 25 S",
    "dropdelcty": "GIFFORD",
    "dropdelst": "WA",
    "dropdelzpp": 991319998,
    "dropphyadd": "3379 HIGHWAY 25 S",
    "dropphycty": "GIFFORD",
    "dropphyst": "WA",
    "dropphyzpp": 991319998,
    "dropmaladd": "3379 HIGHWAY 25 S",
    "dropmalcty": "GIFFORD",
    "dropmalst": "WA",
    "dropmalzpp": 991319998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097226257,
    "dropsitcph": 5097226257,
    "dropfax": 5092605199
  },
  {
    "dcode": "D",
    "dropkey": "PZ16840",
    "droptype": "D",
    "dropname": "GIG HARBOR",
    "dropdeladd": "3118 JUDSON ST",
    "dropdelcty": "GIG HARBOR",
    "dropdelst": "WA",
    "dropdelzpp": 983359998,
    "dropphyadd": "3118 JUDSON ST",
    "dropphycty": "GIG HARBOR",
    "dropphyst": "WA",
    "dropphyzpp": 983359998,
    "dropmaladd": "3118 JUDSON ST",
    "dropmalcty": "GIG HARBOR",
    "dropmalst": "WA",
    "dropmalzpp": 983359998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538589590,
    "dropsitcph": 2538587262,
    "dropfax": 6514566180
  },
  {
    "dcode": "D",
    "dropkey": "PZ16849",
    "droptype": "D",
    "dropname": "GLENOMA",
    "dropdeladd": "108 MARTIN RD",
    "dropdelcty": "GLENOMA",
    "dropdelst": "WA",
    "dropdelzpp": 983369800,
    "dropphyadd": "108 MARTIN RD",
    "dropphycty": "GLENOMA",
    "dropphyst": "WA",
    "dropphyzpp": 983369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GLENOMA",
    "dropmalst": "WA",
    "dropmalzpp": 983369998,
    "dropsitphn": 3604987006,
    "dropsitlph": 3604987006,
    "dropsitcph": 3604987006,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16850",
    "droptype": "D",
    "dropname": "GLENWOOD",
    "dropdeladd": "100 W MAIN ST",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 986199198,
    "dropphyadd": "100 W MAIN ST",
    "dropphycty": "GLENWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 986199198,
    "dropmaladd": "100 W MAIN ST",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 986199998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5093643500,
    "dropsitcph": 5093643500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16851",
    "droptype": "D",
    "dropname": "GOLD BAR",
    "dropdeladd": "122 10TH ST",
    "dropdelcty": "GOLD BAR",
    "dropdelst": "WA",
    "dropdelzpp": 982519800,
    "dropphyadd": "122 10TH ST",
    "dropphycty": "GOLD BAR",
    "dropphyst": "WA",
    "dropphyzpp": 982519800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GOLD BAR",
    "dropmalst": "WA",
    "dropmalzpp": 982519998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607931717,
    "dropsitcph": 3607931717,
    "dropfax": 3607934167
  },
  {
    "dcode": "D",
    "dropkey": "PZ16852",
    "droptype": "D",
    "dropname": "GOLDENDALE",
    "dropdeladd": "1020 S COLUMBUS AVE",
    "dropdelcty": "GOLDENDALE",
    "dropdelst": "WA",
    "dropdelzpp": 986209033,
    "dropphyadd": "1020 S COLUMBUS AVE",
    "dropphycty": "GOLDENDALE",
    "dropphyst": "WA",
    "dropphyzpp": 986209033,
    "dropmaladd": "1020 S COLUMBUS AVE",
    "dropmalcty": "GOLDENDALE",
    "dropmalst": "WA",
    "dropmalzpp": 986209998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5097734276,
    "dropsitcph": 5097734276,
    "dropfax": 5097737180
  },
  {
    "dcode": "D",
    "dropkey": "PZ16857",
    "droptype": "D",
    "dropname": "GRAHAM",
    "dropdeladd": "10102 224TH ST E",
    "dropdelcty": "GRAHAM",
    "dropdelst": "WA",
    "dropdelzpp": 983389997,
    "dropphyadd": "10102 224TH ST E",
    "dropphycty": "GRAHAM",
    "dropphyst": "WA",
    "dropphyzpp": 983389997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAHAM",
    "dropmalst": "WA",
    "dropmalzpp": 983389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538471114,
    "dropsitcph": 2538460345,
    "dropfax": 6514566181
  },
  {
    "dcode": "D",
    "dropkey": "PZ16858",
    "droptype": "D",
    "dropname": "GRAND COULEE",
    "dropdeladd": "407 MIDWAY AVE",
    "dropdelcty": "GRAND COULEE",
    "dropdelst": "WA",
    "dropdelzpp": 991339998,
    "dropphyadd": "407 MIDWAY AVE",
    "dropphycty": "GRAND COULEE",
    "dropphyst": "WA",
    "dropphyzpp": 991339998,
    "dropmaladd": "407 MIDWAY AVE",
    "dropmalcty": "GRAND COULEE",
    "dropmalst": "WA",
    "dropmalzpp": 991339998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096200147,
    "dropsitcph": 5096200147,
    "dropfax": 5096333223
  },
  {
    "dcode": "D",
    "dropkey": "PZ16860",
    "droptype": "D",
    "dropname": "GRANDVIEW",
    "dropdeladd": "116 GRANDRIDGE RD",
    "dropdelcty": "GRANDVIEW",
    "dropdelst": "WA",
    "dropdelzpp": 989309998,
    "dropphyadd": "116 GRANDRIDGE RD",
    "dropphycty": "GRANDVIEW",
    "dropphyst": "WA",
    "dropphyzpp": 989309998,
    "dropmaladd": "116 GRANDRIDGE RD",
    "dropmalcty": "GRANDVIEW",
    "dropmalst": "WA",
    "dropmalzpp": 989309998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098821067,
    "dropsitcph": 5098821067,
    "dropfax": 6514566182
  },
  {
    "dcode": "D",
    "dropkey": "PZ16862",
    "droptype": "D",
    "dropname": "GRANGER",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "GRANGER",
    "dropdelst": "WA",
    "dropdelzpp": 989322000,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "GRANGER",
    "dropphyst": "WA",
    "dropphyzpp": 989322000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANGER",
    "dropmalst": "WA",
    "dropmalzpp": 989329998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098541125,
    "dropsitcph": 5098541125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16863",
    "droptype": "D",
    "dropname": "GRANITE FALLS",
    "dropdeladd": "205 E STANLEY ST",
    "dropdelcty": "GRANITE FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 982529800,
    "dropphyadd": "205 E STANLEY ST",
    "dropphycty": "GRANITE FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 982529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRANITE FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 982529998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606914169,
    "dropsitcph": 3606911879,
    "dropfax": 6514566183
  },
  {
    "dcode": "D",
    "dropkey": "PZ16865",
    "droptype": "D",
    "dropname": "GRAPEVIEW",
    "dropdeladd": "4290 E GRAPEVIEW LOOP RD",
    "dropdelcty": "GRAPEVIEW",
    "dropdelst": "WA",
    "dropdelzpp": 985469800,
    "dropphyadd": "4290 E GRAPEVIEW LOOP RD",
    "dropphycty": "GRAPEVIEW",
    "dropphyst": "WA",
    "dropphyzpp": 985469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAPEVIEW",
    "dropmalst": "WA",
    "dropmalzpp": 985469998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602758553,
    "dropsitcph": 3602758553,
    "dropfax": 3602770851
  },
  {
    "dcode": "D",
    "dropkey": "PZ16867",
    "droptype": "D",
    "dropname": "GRAYLAND",
    "dropdeladd": "883 CRANBERRY RD",
    "dropdelcty": "GRAYLAND",
    "dropdelst": "WA",
    "dropdelzpp": 985479800,
    "dropphyadd": "883 CRANBERRY RD",
    "dropphycty": "GRAYLAND",
    "dropphyst": "WA",
    "dropphyzpp": 985479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAYLAND",
    "dropmalst": "WA",
    "dropmalzpp": 985479998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602673712,
    "dropsitcph": 3602673712,
    "dropfax": 3602670192
  },
  {
    "dcode": "D",
    "dropkey": "PZ16871",
    "droptype": "D",
    "dropname": "GREENACRES",
    "dropdeladd": "18727 E LABERRY DR",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 990168425,
    "dropphyadd": "18727 E LABERRY DR",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 990168425,
    "dropmaladd": "18727 E LABERRY DR",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 990168425,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092863145,
    "dropsitcph": 5098930091,
    "dropfax": 6514566184
  },
  {
    "dcode": "D",
    "dropkey": "PZ16872",
    "droptype": "D",
    "dropname": "GREENBANK",
    "dropdeladd": "25189 STATE ROUTE 525",
    "dropdelcty": "GREENBANK",
    "dropdelst": "WA",
    "dropdelzpp": 982539800,
    "dropphyadd": "25189 STATE ROUTE 525",
    "dropphycty": "GREENBANK",
    "dropphyst": "WA",
    "dropphyzpp": 982539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREENBANK",
    "dropmalst": "WA",
    "dropmalzpp": 982539998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606786808,
    "dropsitcph": 3606786808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16881",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "520B MAPLE ST",
    "dropdelcty": "HAMILTON",
    "dropdelst": "WA",
    "dropdelzpp": 982559800,
    "dropphyadd": "520B MAPLE ST",
    "dropphycty": "HAMILTON",
    "dropphyst": "WA",
    "dropphyzpp": 982559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HAMILTON",
    "dropmalst": "WA",
    "dropmalzpp": 982559998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608263373,
    "dropsitcph": 3608263373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16883",
    "droptype": "D",
    "dropname": "HANSVILLE",
    "dropdeladd": "38937 HANSVILLE RD NE",
    "dropdelcty": "HANSVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 983409997,
    "dropphyadd": "38937 HANSVILLE RD NE",
    "dropphycty": "HANSVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 983409997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HANSVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 983409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606382666,
    "dropsitcph": 3606382666,
    "dropfax": 3606382460
  },
  {
    "dcode": "D",
    "dropkey": "PZ16889",
    "droptype": "D",
    "dropname": "HARRAH",
    "dropdeladd": "3910 HARRAH RD",
    "dropdelcty": "HARRAH",
    "dropdelst": "WA",
    "dropdelzpp": 989339800,
    "dropphyadd": "3910 HARRAH RD",
    "dropphycty": "HARRAH",
    "dropphyst": "WA",
    "dropphyzpp": 989339800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HARRAH",
    "dropmalst": "WA",
    "dropmalzpp": 989339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098482505,
    "dropsitcph": 5098482505,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16890",
    "droptype": "D",
    "dropname": "HARRINGTON",
    "dropdeladd": "310 W MAIN ST",
    "dropdelcty": "HARRINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 991349998,
    "dropphyadd": "310 W MAIN ST",
    "dropphycty": "HARRINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 991349998,
    "dropmaladd": "310 W MAIN ST",
    "dropmalcty": "HARRINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 991349998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092534341,
    "dropsitcph": 5092534341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16893",
    "droptype": "D",
    "dropname": "HARTLINE",
    "dropdeladd": "867 WILLARD ST",
    "dropdelcty": "HARTLINE",
    "dropdelst": "WA",
    "dropdelzpp": 991359998,
    "dropphyadd": "867 WILLARD ST",
    "dropphycty": "HARTLINE",
    "dropphyst": "WA",
    "dropphyzpp": 991359998,
    "dropmaladd": "867 WILLARD ST",
    "dropmalcty": "HARTLINE",
    "dropmalst": "WA",
    "dropmalzpp": 991359998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096392661,
    "dropsitcph": 5096392661,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16911",
    "droptype": "D",
    "dropname": "HOBART",
    "dropdeladd": "20250 276TH AVE SE",
    "dropdelcty": "HOBART",
    "dropdelst": "WA",
    "dropdelzpp": 980259800,
    "dropphyadd": "20250 276TH AVE SE",
    "dropphycty": "HOBART",
    "dropphyst": "WA",
    "dropphyzpp": 980259800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOBART",
    "dropmalst": "WA",
    "dropmalzpp": 980259998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254131967,
    "dropsitcph": 4254131967,
    "dropfax": 6505784646
  },
  {
    "dcode": "D",
    "dropkey": "PZ16917",
    "droptype": "D",
    "dropname": "HOODSPORT",
    "dropdeladd": "76 N LAKE CUSHMAN RD",
    "dropdelcty": "HOODSPORT",
    "dropdelst": "WA",
    "dropdelzpp": 985489800,
    "dropphyadd": "76 N LAKE CUSHMAN RD",
    "dropphycty": "HOODSPORT",
    "dropphyst": "WA",
    "dropphyzpp": 985489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOODSPORT",
    "dropmalst": "WA",
    "dropmalzpp": 985489998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608775552,
    "dropsitcph": 3608775552,
    "dropfax": 3608770280
  },
  {
    "dcode": "D",
    "dropkey": "PZ16918",
    "droptype": "D",
    "dropname": "HOOPER",
    "dropdeladd": "51 HAXTON RD",
    "dropdelcty": "HOOPER",
    "dropdelst": "WA",
    "dropdelzpp": 993339998,
    "dropphyadd": "51 HAXTON RD",
    "dropphycty": "HOOPER",
    "dropphyst": "WA",
    "dropphyzpp": 993339998,
    "dropmaladd": "51 HAXTON RD",
    "dropmalcty": "HOOPER",
    "dropmalst": "WA",
    "dropmalzpp": 993339998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095493864,
    "dropsitcph": 5095493864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16919",
    "droptype": "D",
    "dropname": "HOQUIAM",
    "dropdeladd": "620 8TH ST",
    "dropdelcty": "HOQUIAM",
    "dropdelst": "WA",
    "dropdelzpp": 985509998,
    "dropphyadd": "620 8TH ST",
    "dropphycty": "HOQUIAM",
    "dropphyst": "WA",
    "dropphyzpp": 985509998,
    "dropmaladd": "620 8TH ST",
    "dropmalcty": "HOQUIAM",
    "dropmalst": "WA",
    "dropmalzpp": 985509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605387058,
    "dropsitcph": 3605377204,
    "dropfax": 6514566189
  },
  {
    "dcode": "D",
    "dropkey": "PZ16922",
    "droptype": "D",
    "dropname": "HUMPTULIPS",
    "dropdeladd": "1933 KIRKPATRICK RD",
    "dropdelcty": "HUMPTULIPS",
    "dropdelst": "WA",
    "dropdelzpp": 985529800,
    "dropphyadd": "1933 KIRKPATRICK RD",
    "dropphycty": "HUMPTULIPS",
    "dropphyst": "WA",
    "dropphyzpp": 985529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUMPTULIPS",
    "dropmalst": "WA",
    "dropmalzpp": 985529998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609872492,
    "dropsitcph": 3609872492,
    "dropfax": 3609872492
  },
  {
    "dcode": "D",
    "dropkey": "PZ16923",
    "droptype": "D",
    "dropname": "HUNTERS",
    "dropdeladd": "4990 HIGHWAY 25",
    "dropdelcty": "HUNTERS",
    "dropdelst": "WA",
    "dropdelzpp": 991379998,
    "dropphyadd": "4990 HIGHWAY 25",
    "dropphycty": "HUNTERS",
    "dropphyst": "WA",
    "dropphyzpp": 991379998,
    "dropmaladd": "4990 HIGHWAY 25",
    "dropmalcty": "HUNTERS",
    "dropmalst": "WA",
    "dropmalzpp": 991379998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097224455,
    "dropsitcph": 5097224455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16925",
    "droptype": "D",
    "dropname": "HUSUM",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "HUSUM",
    "dropdelst": "WA",
    "dropdelzpp": 986230998,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "HUSUM",
    "dropphyst": "WA",
    "dropphyzpp": 986230998,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "HUSUM",
    "dropmalst": "WA",
    "dropmalzpp": 986230998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094932630,
    "dropsitcph": 5094932630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16927",
    "droptype": "D",
    "dropname": "ILWACO",
    "dropdeladd": "128 LAKE ST SE",
    "dropdelcty": "ILWACO",
    "dropdelst": "WA",
    "dropdelzpp": 986249198,
    "dropphyadd": "128 LAKE ST SE",
    "dropphycty": "ILWACO",
    "dropphyst": "WA",
    "dropphyzpp": 986249198,
    "dropmaladd": "128 LAKE ST SE",
    "dropmalcty": "ILWACO",
    "dropmalst": "WA",
    "dropmalzpp": 986249998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606423213,
    "dropsitcph": 3606423213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16928",
    "droptype": "D",
    "dropname": "INCHELIUM",
    "dropdeladd": "2316 INCHELIUM HWY",
    "dropdelcty": "INCHELIUM",
    "dropdelst": "WA",
    "dropdelzpp": 991389998,
    "dropphyadd": "2316 INCHELIUM HWY",
    "dropphycty": "INCHELIUM",
    "dropphyst": "WA",
    "dropphyzpp": 991389998,
    "dropmaladd": "2316 INCHELIUM HWY",
    "dropmalcty": "INCHELIUM",
    "dropmalst": "WA",
    "dropmalzpp": 991389998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097224905,
    "dropsitcph": 5097224905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16929",
    "droptype": "D",
    "dropname": "INDEX",
    "dropdeladd": "503 AVENUE A",
    "dropdelcty": "INDEX",
    "dropdelst": "WA",
    "dropdelzpp": 982569800,
    "dropphyadd": "503 AVENUE A",
    "dropphycty": "INDEX",
    "dropphyst": "WA",
    "dropphyzpp": 982569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDEX",
    "dropmalst": "WA",
    "dropmalzpp": 982569998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607932344,
    "dropsitcph": 3607932344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16932",
    "droptype": "D",
    "dropname": "INDIANOLA",
    "dropdeladd": "9200 NE SHORE DR",
    "dropdelcty": "INDIANOLA",
    "dropdelst": "WA",
    "dropdelzpp": 983429800,
    "dropphyadd": "9200 NE SHORE DR",
    "dropphycty": "INDIANOLA",
    "dropphyst": "WA",
    "dropphyzpp": 983429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDIANOLA",
    "dropmalst": "WA",
    "dropmalzpp": 983429998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067684422,
    "dropsitcph": 3602820097,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16939",
    "droptype": "D",
    "dropname": "IONE",
    "dropdeladd": "419 MAIN ST",
    "dropdelcty": "IONE",
    "dropdelst": "WA",
    "dropdelzpp": 991399998,
    "dropphyadd": "419 MAIN ST",
    "dropphycty": "IONE",
    "dropphyst": "WA",
    "dropphyzpp": 991399998,
    "dropmaladd": "419 MAIN ST",
    "dropmalcty": "IONE",
    "dropmalst": "WA",
    "dropmalzpp": 991399998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094423615,
    "dropsitcph": 5094423615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16943",
    "droptype": "D",
    "dropname": "ISSAQUAH",
    "dropdeladd": "400 NW GILMAN BLVD",
    "dropdelcty": "ISSAQUAH",
    "dropdelst": "WA",
    "dropdelzpp": 980279998,
    "dropphyadd": "400 NW GILMAN BLVD",
    "dropphycty": "ISSAQUAH",
    "dropphyst": "WA",
    "dropphyzpp": 980279998,
    "dropmaladd": "400 NW GILMAN BLVD",
    "dropmalcty": "ISSAQUAH",
    "dropmalst": "WA",
    "dropmalzpp": 980279998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253925665,
    "dropsitcph": 4258378795,
    "dropfax": 6514566192
  },
  {
    "dcode": "D",
    "dropkey": "PZ16947",
    "droptype": "D",
    "dropname": "JOYCE",
    "dropdeladd": "50883 HIGHWAY 112",
    "dropdelcty": "JOYCE",
    "dropdelst": "WA",
    "dropdelzpp": 983439800,
    "dropphyadd": "50883 HIGHWAY 112",
    "dropphycty": "JOYCE",
    "dropphyst": "WA",
    "dropphyzpp": 983439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOYCE",
    "dropmalst": "WA",
    "dropmalzpp": 983439998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609283086,
    "dropsitcph": 3609283086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16951",
    "droptype": "D",
    "dropname": "KAHLOTUS",
    "dropdeladd": "125 E WESTON ST",
    "dropdelcty": "KAHLOTUS",
    "dropdelst": "WA",
    "dropdelzpp": 993359998,
    "dropphyadd": "125 E WESTON ST",
    "dropphycty": "KAHLOTUS",
    "dropphyst": "WA",
    "dropphyzpp": 993359998,
    "dropmaladd": "125 E WESTON ST",
    "dropmalcty": "KAHLOTUS",
    "dropmalst": "WA",
    "dropmalzpp": 993359998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092823304,
    "dropsitcph": 5092823304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16953",
    "droptype": "D",
    "dropname": "KALAMA",
    "dropdeladd": "454 N 1ST ST",
    "dropdelcty": "KALAMA",
    "dropdelst": "WA",
    "dropdelzpp": 986259198,
    "dropphyadd": "454 N 1ST ST",
    "dropphycty": "KALAMA",
    "dropphyst": "WA",
    "dropphyzpp": 986259198,
    "dropmaladd": "454 N 1ST ST",
    "dropmalcty": "KALAMA",
    "dropmalst": "WA",
    "dropmalzpp": 986259998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606734142,
    "dropsitcph": 3606733567,
    "dropfax": 3606734651
  },
  {
    "dcode": "D",
    "dropkey": "PZ16957",
    "droptype": "D",
    "dropname": "KAPOWSIN",
    "dropdeladd": "14814 KAPOWSIN HWY E",
    "dropdelcty": "KAPOWSIN",
    "dropdelst": "WA",
    "dropdelzpp": 983449990,
    "dropphyadd": "14814 KAPOWSIN HWY E",
    "dropphycty": "KAPOWSIN",
    "dropphyst": "WA",
    "dropphyzpp": 983449990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KAPOWSIN",
    "dropmalst": "WA",
    "dropmalzpp": 983449998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608795555,
    "dropsitcph": 3608795555,
    "dropfax": 3608795373
  },
  {
    "dcode": "D",
    "dropkey": "PZ16958",
    "droptype": "D",
    "dropname": "KELLER",
    "dropdeladd": "11673 S HIGHWAY 21",
    "dropdelcty": "KELLER",
    "dropdelst": "WA",
    "dropdelzpp": 991409998,
    "dropphyadd": "11673 S HIGHWAY 21",
    "dropphycty": "KELLER",
    "dropphyst": "WA",
    "dropphyzpp": 991409998,
    "dropmaladd": "11673 S HIGHWAY 21",
    "dropmalcty": "KELLER",
    "dropmalst": "WA",
    "dropmalzpp": 991409998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096344392,
    "dropsitcph": 5096344392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16960",
    "droptype": "D",
    "dropname": "KELSO",
    "dropdeladd": "304 ACADEMY ST",
    "dropdelcty": "KELSO",
    "dropdelst": "WA",
    "dropdelzpp": 986264101,
    "dropphyadd": "304 ACADEMY ST",
    "dropphycty": "KELSO",
    "dropphyst": "WA",
    "dropphyzpp": 986264101,
    "dropmaladd": "304 ACADEMY ST",
    "dropmalcty": "KELSO",
    "dropmalst": "WA",
    "dropmalzpp": 986269998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3604259670,
    "dropsitcph": 3605780234,
    "dropfax": 3604255589
  },
  {
    "dcode": "D",
    "dropkey": "PZ16967",
    "droptype": "D",
    "dropname": "KENNEWICK",
    "dropdeladd": "525 S AUBURN ST",
    "dropdelcty": "KENNEWICK",
    "dropdelst": "WA",
    "dropdelzpp": 993369998,
    "dropphyadd": "525 S AUBURN ST",
    "dropphycty": "KENNEWICK",
    "dropphyst": "WA",
    "dropphyzpp": 993369998,
    "dropmaladd": "525 S AUBURN ST",
    "dropmalcty": "KENNEWICK",
    "dropmalst": "WA",
    "dropmalzpp": 993369998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095867633,
    "dropsitcph": 5095858310,
    "dropfax": 6513066262
  },
  {
    "dcode": "D",
    "dropkey": "PZ16970",
    "droptype": "D",
    "dropname": "KENT",
    "dropdeladd": "10612 SE 240TH ST",
    "dropdelcty": "KENT",
    "dropdelst": "WA",
    "dropdelzpp": 980319998,
    "dropphyadd": "10612 SE 240TH ST",
    "dropphycty": "KENT",
    "dropphyst": "WA",
    "dropphyzpp": 980319998,
    "dropmaladd": "10612 SE 240TH ST",
    "dropmalcty": "KENT",
    "dropmalst": "WA",
    "dropmalzpp": 980319998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2532201459,
    "dropsitcph": 2538521080,
    "dropfax": 6514566193
  },
  {
    "dcode": "D",
    "dropkey": "PZ16974",
    "droptype": "D",
    "dropname": "KETTLE FALLS",
    "dropdeladd": "510 MEYERS ST",
    "dropdelcty": "KETTLE FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 991419998,
    "dropphyadd": "510 MEYERS ST",
    "dropphycty": "KETTLE FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 991419998,
    "dropmaladd": "510 MEYERS ST",
    "dropmalcty": "KETTLE FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 991419998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097386655,
    "dropsitcph": 5097386655,
    "dropfax": 6514566194
  },
  {
    "dcode": "D",
    "dropkey": "PZ16978",
    "droptype": "D",
    "dropname": "KEYPORT",
    "dropdeladd": "1998 STATE HIGHWAY 308 NE",
    "dropdelcty": "KEYPORT",
    "dropdelst": "WA",
    "dropdelzpp": 983459997,
    "dropphyadd": "1998 STATE HIGHWAY 308 NE",
    "dropphycty": "KEYPORT",
    "dropphyst": "WA",
    "dropphyzpp": 983459997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEYPORT",
    "dropmalst": "WA",
    "dropmalzpp": 983459998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607794123,
    "dropsitcph": 3607794123,
    "dropfax": 3607796175
  },
  {
    "dcode": "D",
    "dropkey": "PZ16981",
    "droptype": "D",
    "dropname": "KINGSTON",
    "dropdeladd": "10990 NE STATE HIGHWAY 104",
    "dropdelcty": "KINGSTON",
    "dropdelst": "WA",
    "dropdelzpp": 983469800,
    "dropphyadd": "10990 NE STATE HIGHWAY 104",
    "dropphycty": "KINGSTON",
    "dropphyst": "WA",
    "dropphyzpp": 983469800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGSTON",
    "dropmalst": "WA",
    "dropmalzpp": 983469998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602973673,
    "dropsitcph": 3602973346,
    "dropfax": 6513066848
  },
  {
    "dcode": "D",
    "dropkey": "PZ16983",
    "droptype": "D",
    "dropname": "KIRKLAND",
    "dropdeladd": "721 4TH AVE",
    "dropdelcty": "KIRKLAND",
    "dropdelst": "WA",
    "dropdelzpp": 980339998,
    "dropphyadd": "721 4TH AVE",
    "dropphycty": "KIRKLAND",
    "dropphyst": "WA",
    "dropphyzpp": 980339998,
    "dropmaladd": "721 4TH AVE",
    "dropmalcty": "KIRKLAND",
    "dropmalst": "WA",
    "dropmalzpp": 980339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4256585736,
    "dropsitcph": 4257396727,
    "dropfax": 6514566195
  },
  {
    "dcode": "D",
    "dropkey": "PZ16985",
    "droptype": "D",
    "dropname": "KITTITAS",
    "dropdeladd": "105 S MAIN ST",
    "dropdelcty": "KITTITAS",
    "dropdelst": "WA",
    "dropdelzpp": 989349997,
    "dropphyadd": "105 S MAIN ST",
    "dropphycty": "KITTITAS",
    "dropphyst": "WA",
    "dropphyzpp": 989349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KITTITAS",
    "dropmalst": "WA",
    "dropmalzpp": 989349998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096530065,
    "dropsitcph": 5096530065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16987",
    "droptype": "D",
    "dropname": "KLICKITAT",
    "dropdeladd": "103 N MAIN ST",
    "dropdelcty": "KLICKITAT",
    "dropdelst": "WA",
    "dropdelzpp": 986289198,
    "dropphyadd": "103 N MAIN ST",
    "dropphycty": "KLICKITAT",
    "dropphyst": "WA",
    "dropphyzpp": 986289198,
    "dropmaladd": "103 N MAIN ST",
    "dropmalcty": "KLICKITAT",
    "dropmalst": "WA",
    "dropmalzpp": 986289998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5093694753,
    "dropsitcph": 5093694753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16992",
    "droptype": "D",
    "dropname": "LA CENTER",
    "dropdeladd": "421 NE JOHN STORM AVE",
    "dropdelcty": "LA CENTER",
    "dropdelst": "WA",
    "dropdelzpp": 986295547,
    "dropphyadd": "421 NE JOHN STORM AVE",
    "dropphycty": "LA CENTER",
    "dropphyst": "WA",
    "dropphyzpp": 986295547,
    "dropmaladd": "421 NE JOHN STORM AVE",
    "dropmalcty": "LA CENTER",
    "dropmalst": "WA",
    "dropmalzpp": 986299998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602637269,
    "dropsitcph": 3602637269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16993",
    "droptype": "D",
    "dropname": "LA CONNER",
    "dropdeladd": "125 1ST ST",
    "dropdelcty": "LA CONNER",
    "dropdelst": "WA",
    "dropdelzpp": 982579800,
    "dropphyadd": "125 1ST ST",
    "dropphycty": "LA CONNER",
    "dropphyst": "WA",
    "dropphyzpp": 982579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA CONNER",
    "dropmalst": "WA",
    "dropmalzpp": 982579998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604661298,
    "dropsitcph": 3604665162,
    "dropfax": 6505783333
  },
  {
    "dcode": "D",
    "dropkey": "PZ16995",
    "droptype": "D",
    "dropname": "LA GRANDE",
    "dropdeladd": "46518 MOUNTAIN HWY E",
    "dropdelcty": "LA GRANDE",
    "dropdelst": "WA",
    "dropdelzpp": 983489800,
    "dropphyadd": "46518 MOUNTAIN HWY E",
    "dropphycty": "LA GRANDE",
    "dropphyst": "WA",
    "dropphyzpp": 983489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA GRANDE",
    "dropmalst": "WA",
    "dropmalzpp": 983489998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608323282,
    "dropsitcph": 3608323282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ16996",
    "droptype": "D",
    "dropname": "LA PUSH",
    "dropdeladd": "500 OCEAN DR",
    "dropdelcty": "LA PUSH",
    "dropdelst": "WA",
    "dropdelzpp": 983509800,
    "dropphyadd": "500 OCEAN DR",
    "dropphycty": "LA PUSH",
    "dropphyst": "WA",
    "dropphyzpp": 983509800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LA PUSH",
    "dropmalst": "WA",
    "dropmalzpp": 983509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603745378,
    "dropsitcph": 3603745378,
    "dropfax": 6505784621
  },
  {
    "dcode": "D",
    "dropkey": "PZ16999",
    "droptype": "D",
    "dropname": "LACROSSE",
    "dropdeladd": "219 S MAIN ST",
    "dropdelcty": "LACROSSE",
    "dropdelst": "WA",
    "dropdelzpp": 991439998,
    "dropphyadd": "219 S MAIN ST",
    "dropphycty": "LACROSSE",
    "dropphyst": "WA",
    "dropphyzpp": 991439998,
    "dropmaladd": "219 S MAIN ST",
    "dropmalcty": "LACROSSE",
    "dropmalst": "WA",
    "dropmalzpp": 991439998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095493848,
    "dropsitcph": 5095493848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17011",
    "droptype": "D",
    "dropname": "LAKE STEVENS",
    "dropdeladd": "1709 124TH AVE NE",
    "dropdelcty": "LAKE STEVENS",
    "dropdelst": "WA",
    "dropdelzpp": 982589800,
    "dropphyadd": "1709 124TH AVE NE",
    "dropphycty": "LAKE STEVENS",
    "dropphyst": "WA",
    "dropphyzpp": 982589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE STEVENS",
    "dropmalst": "WA",
    "dropmalzpp": 982589998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253344418,
    "dropsitcph": 4253979582,
    "dropfax": 4253345340
  },
  {
    "dcode": "D",
    "dropkey": "PZ17013",
    "droptype": "D",
    "dropname": "LAKEBAY",
    "dropdeladd": "1302 KEY PENINSULA HWY NW",
    "dropdelcty": "LAKEBAY",
    "dropdelst": "WA",
    "dropdelzpp": 983499997,
    "dropphyadd": "1302 KEY PENINSULA HWY NW",
    "dropphycty": "LAKEBAY",
    "dropphyst": "WA",
    "dropphyzpp": 983499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEBAY",
    "dropmalst": "WA",
    "dropmalzpp": 983499998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538842389,
    "dropsitcph": 2538842389,
    "dropfax": 6513066068
  },
  {
    "dcode": "D",
    "dropkey": "PZ17017",
    "droptype": "D",
    "dropname": "NORTH LAKEWOOD",
    "dropdeladd": "1610 172ND ST NE",
    "dropdelcty": "NORTH LAKEWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 982599800,
    "dropphyadd": "1610 172ND ST NE",
    "dropphycty": "NORTH LAKEWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 982599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LAKEWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 982599998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606527911,
    "dropsitcph": 3606527911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17021",
    "droptype": "D",
    "dropname": "LANGLEY",
    "dropdeladd": "115 2ND ST",
    "dropdelcty": "LANGLEY",
    "dropdelst": "WA",
    "dropdelzpp": 982609850,
    "dropphyadd": "115 2ND ST",
    "dropphycty": "LANGLEY",
    "dropphyst": "WA",
    "dropphyzpp": 982609850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LANGLEY",
    "dropmalst": "WA",
    "dropmalzpp": 982609998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602216434,
    "dropsitcph": 3602214113,
    "dropfax": 6505784992
  },
  {
    "dcode": "D",
    "dropkey": "PZ17024",
    "droptype": "D",
    "dropname": "LATAH",
    "dropdeladd": "123 W MARKET ST",
    "dropdelcty": "LATAH",
    "dropdelst": "WA",
    "dropdelzpp": 990189998,
    "dropphyadd": "123 W MARKET ST",
    "dropphycty": "LATAH",
    "dropphyst": "WA",
    "dropphyzpp": 990189998,
    "dropmaladd": "123 W MARKET ST",
    "dropmalcty": "LATAH",
    "dropmalst": "WA",
    "dropmalzpp": 990189998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092683145,
    "dropsitcph": 5092863145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17025",
    "droptype": "D",
    "dropname": "LAURIER",
    "dropdeladd": "27007 N HIGHWAY 395 STE 1",
    "dropdelcty": "LAURIER",
    "dropdelst": "WA",
    "dropdelzpp": 991469998,
    "dropphyadd": "27007 N HIGHWAY 395 STE 1",
    "dropphycty": "LAURIER",
    "dropphyst": "WA",
    "dropphyzpp": 991469998,
    "dropmaladd": "27007 N HIGHWAY 395 STE 1",
    "dropmalcty": "LAURIER",
    "dropmalst": "WA",
    "dropmalzpp": 991469998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096842606,
    "dropsitcph": 5096842606,
    "dropfax": 5096842606
  },
  {
    "dcode": "D",
    "dropkey": "PZ17026",
    "droptype": "D",
    "dropname": "LEAVENWORTH",
    "dropdeladd": "960 US HIGHWAY 2",
    "dropdelcty": "LEAVENWORTH",
    "dropdelst": "WA",
    "dropdelzpp": 988269998,
    "dropphyadd": "960 US HIGHWAY 2",
    "dropphycty": "LEAVENWORTH",
    "dropphyst": "WA",
    "dropphyzpp": 988269998,
    "dropmaladd": "960 US HIGHWAY 2",
    "dropmalcty": "LEAVENWORTH",
    "dropmalst": "WA",
    "dropmalzpp": 988269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5095487212,
    "dropsitcph": 5095487212,
    "dropfax": 6505784750
  },
  {
    "dcode": "D",
    "dropkey": "PZ17027",
    "droptype": "D",
    "dropname": "LEBAM",
    "dropdeladd": "142 LEBAM RD",
    "dropdelcty": "LEBAM",
    "dropdelst": "WA",
    "dropdelzpp": 985549800,
    "dropphyadd": "142 LEBAM RD",
    "dropphycty": "LEBAM",
    "dropphyst": "WA",
    "dropphyzpp": 985549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEBAM",
    "dropmalst": "WA",
    "dropmalzpp": 985549998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609345301,
    "dropsitcph": 3609345301,
    "dropfax": 3609345301
  },
  {
    "dcode": "D",
    "dropkey": "PZ17031",
    "droptype": "D",
    "dropname": "LIBERTY LAKE",
    "dropdeladd": "1423 N MOLTER RD",
    "dropdelcty": "LIBERTY LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 990199998,
    "dropphyadd": "1423 N MOLTER RD",
    "dropphycty": "LIBERTY LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 990199998,
    "dropmaladd": "1423 N MOLTER RD",
    "dropmalcty": "LIBERTY LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 990199998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098931352,
    "dropsitcph": 5098929649,
    "dropfax": 6514566200
  },
  {
    "dcode": "D",
    "dropkey": "PZ17034",
    "droptype": "D",
    "dropname": "LILLIWAUP",
    "dropdeladd": "28611 N US HIGHWAY 101",
    "dropdelcty": "LILLIWAUP",
    "dropdelst": "WA",
    "dropdelzpp": 985559800,
    "dropphyadd": "28611 N US HIGHWAY 101",
    "dropphycty": "LILLIWAUP",
    "dropphyst": "WA",
    "dropphyzpp": 985559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LILLIWAUP",
    "dropmalst": "WA",
    "dropmalzpp": 985559998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608775472,
    "dropsitcph": 3608775472,
    "dropfax": 6503576656
  },
  {
    "dcode": "D",
    "dropkey": "PZ17036",
    "droptype": "D",
    "dropname": "LIND",
    "dropdeladd": "119 W 2ND AVE",
    "dropdelcty": "LIND",
    "dropdelst": "WA",
    "dropdelzpp": 993419998,
    "dropphyadd": "119 W 2ND AVE",
    "dropphycty": "LIND",
    "dropphyst": "WA",
    "dropphyzpp": 993419998,
    "dropmaladd": "119 W 2ND AVE",
    "dropmalcty": "LIND",
    "dropmalst": "WA",
    "dropmalzpp": 993419998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096773413,
    "dropsitcph": 5096773413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17040",
    "droptype": "D",
    "dropname": "LITTLEROCK",
    "dropdeladd": "6310 128TH AVE SW",
    "dropdelcty": "LITTLEROCK",
    "dropdelst": "WA",
    "dropdelzpp": 985569800,
    "dropphyadd": "6310 128TH AVE SW",
    "dropphycty": "LITTLEROCK",
    "dropphyst": "WA",
    "dropphyzpp": 985569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLEROCK",
    "dropmalst": "WA",
    "dropmalzpp": 985569998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603525140,
    "dropsitcph": 3603525140,
    "dropfax": 3607099407
  },
  {
    "dcode": "D",
    "dropkey": "PZ17044",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "101 OREGON AVE N",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "WA",
    "dropdelzpp": 986313625,
    "dropphyadd": "101 OREGON AVE N",
    "dropphycty": "LONG BEACH",
    "dropphyst": "WA",
    "dropphyzpp": 986313625,
    "dropmaladd": "101 OREGON AVE N",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "WA",
    "dropmalzpp": 986319998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606425207,
    "dropsitcph": 3606423984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17049",
    "droptype": "D",
    "dropname": "LONGVIEW",
    "dropdeladd": "1603 LARCH ST",
    "dropdelcty": "LONGVIEW",
    "dropdelst": "WA",
    "dropdelzpp": 986322900,
    "dropphyadd": "1603 LARCH ST",
    "dropphycty": "LONGVIEW",
    "dropphyst": "WA",
    "dropphyzpp": 986322900,
    "dropmaladd": "1603 LARCH ST",
    "dropmalcty": "LONGVIEW",
    "dropmalst": "WA",
    "dropmalzpp": 986322900,
    "dropsitphn": 9712013788,
    "dropsitlph": 3604231018,
    "dropsitcph": 3606368593,
    "dropfax": 3604230721
  },
  {
    "dcode": "D",
    "dropkey": "PZ17050",
    "droptype": "D",
    "dropname": "LOOMIS",
    "dropdeladd": "12 PALMER AVE",
    "dropdelcty": "LOOMIS",
    "dropdelst": "WA",
    "dropdelzpp": 988279726,
    "dropphyadd": "12 PALMER AVE",
    "dropphycty": "LOOMIS",
    "dropphyst": "WA",
    "dropphyzpp": 988279726,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOOMIS",
    "dropmalst": "WA",
    "dropmalzpp": 988279998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092234351,
    "dropsitcph": 5092234351,
    "dropfax": 6505784645
  },
  {
    "dcode": "D",
    "dropkey": "PZ17051",
    "droptype": "D",
    "dropname": "LOON LAKE",
    "dropdeladd": "3992 COLVILLE RD",
    "dropdelcty": "LOON LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 991489998,
    "dropphyadd": "3992 COLVILLE RD",
    "dropphycty": "LOON LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 991489998,
    "dropmaladd": "3992 COLVILLE RD",
    "dropmalcty": "LOON LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 991489998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092332623,
    "dropsitcph": 5092332623,
    "dropfax": 5092339054
  },
  {
    "dcode": "D",
    "dropkey": "PZ17052",
    "droptype": "D",
    "dropname": "LOPEZ ISLAND",
    "dropdeladd": "209 WEEKS RD",
    "dropdelcty": "LOPEZ ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 982619850,
    "dropphyadd": "209 WEEKS RD",
    "dropphycty": "LOPEZ ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 982619850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOPEZ ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 982619998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604682282,
    "dropsitcph": 3604682282,
    "dropfax": 3604684102
  },
  {
    "dcode": "D",
    "dropkey": "PZ17057",
    "droptype": "D",
    "dropname": "LUMMI ISLAND",
    "dropdeladd": "2211 N NUGENT RD BLDG 2",
    "dropdelcty": "LUMMI ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 982629998,
    "dropphyadd": "2211 N NUGENT RD BLDG 2",
    "dropphycty": "LUMMI ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 982629998,
    "dropmaladd": "2211 N NUGENT RD BLDG 2",
    "dropmalcty": "LUMMI ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 982629998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607582320,
    "dropsitcph": 3607582320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17058",
    "droptype": "D",
    "dropname": "LYLE",
    "dropdeladd": "308 WASHINGTON ST",
    "dropdelcty": "LYLE",
    "dropdelst": "WA",
    "dropdelzpp": 986359630,
    "dropphyadd": "308 WASHINGTON ST",
    "dropphycty": "LYLE",
    "dropphyst": "WA",
    "dropphyzpp": 986359630,
    "dropmaladd": "308 WASHINGTON ST",
    "dropmalcty": "LYLE",
    "dropmalst": "WA",
    "dropmalzpp": 986359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5093652694,
    "dropsitcph": 5093652694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17059",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "8353 S MAIN ST",
    "dropdelcty": "LYMAN",
    "dropdelst": "WA",
    "dropdelzpp": 982639800,
    "dropphyadd": "8353 S MAIN ST",
    "dropphycty": "LYMAN",
    "dropphyst": "WA",
    "dropphyzpp": 982639800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LYMAN",
    "dropmalst": "WA",
    "dropmalzpp": 982639998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608263845,
    "dropsitcph": 3608263845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17060",
    "droptype": "D",
    "dropname": "LYNDEN",
    "dropdeladd": "600 FRONT ST",
    "dropdelcty": "LYNDEN",
    "dropdelst": "WA",
    "dropdelzpp": 982649998,
    "dropphyadd": "600 FRONT ST",
    "dropphycty": "LYNDEN",
    "dropphyst": "WA",
    "dropphyzpp": 982649998,
    "dropmaladd": "600 FRONT ST",
    "dropmalcty": "LYNDEN",
    "dropmalst": "WA",
    "dropmalzpp": 982649998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603542371,
    "dropsitcph": 3603542371,
    "dropfax": 6514566203
  },
  {
    "dcode": "D",
    "dropkey": "PZ17061",
    "droptype": "D",
    "dropname": "LYNNWOOD",
    "dropdeladd": "6817 208TH ST SW",
    "dropdelcty": "LYNNWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 980369998,
    "dropphyadd": "6817 208TH ST SW",
    "dropphycty": "LYNNWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 980369998,
    "dropmaladd": "6817 208TH ST SW",
    "dropmalcty": "LYNNWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 980369998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4257783447,
    "dropsitcph": 4257783447,
    "dropfax": 6514566204
  },
  {
    "dcode": "D",
    "dropkey": "PZ17062",
    "droptype": "D",
    "dropname": "MABTON",
    "dropdeladd": "410 B ST",
    "dropdelcty": "MABTON",
    "dropdelst": "WA",
    "dropdelzpp": 989359800,
    "dropphyadd": "410 B ST",
    "dropphycty": "MABTON",
    "dropphyst": "WA",
    "dropphyzpp": 989359800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MABTON",
    "dropmalst": "WA",
    "dropmalzpp": 989359998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098944452,
    "dropsitcph": 5098944452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17072",
    "droptype": "D",
    "dropname": "MALAGA",
    "dropdeladd": "3851 MALAGA ALCOA HWY",
    "dropdelcty": "MALAGA",
    "dropdelst": "WA",
    "dropdelzpp": 988289800,
    "dropphyadd": "3851 MALAGA ALCOA HWY",
    "dropphycty": "MALAGA",
    "dropphyst": "WA",
    "dropphyzpp": 988289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALAGA",
    "dropmalst": "WA",
    "dropmalzpp": 988289998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096631793,
    "dropsitcph": 5096631793,
    "dropfax": 5096631055
  },
  {
    "dcode": "D",
    "dropkey": "PZ17073",
    "droptype": "D",
    "dropname": "MALDEN",
    "dropdeladd": "14 W MORELAND AVE",
    "dropdelcty": "MALDEN",
    "dropdelst": "WA",
    "dropdelzpp": 991499996,
    "dropphyadd": "14 W MORELAND AVE",
    "dropphycty": "MALDEN",
    "dropphyst": "WA",
    "dropphyzpp": 991499996,
    "dropmaladd": "14 W MORELAND AVE",
    "dropmalcty": "MALDEN",
    "dropmalst": "WA",
    "dropmalzpp": 991499996,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095692161,
    "dropsitcph": 5095692161,
    "dropfax": 6505784649
  },
  {
    "dcode": "D",
    "dropkey": "PZ17074",
    "droptype": "D",
    "dropname": "MALO",
    "dropdeladd": "17500 N HIGHWAY 21",
    "dropdelcty": "MALO",
    "dropdelst": "WA",
    "dropdelzpp": 991509998,
    "dropphyadd": "17500 N HIGHWAY 21",
    "dropphycty": "MALO",
    "dropphyst": "WA",
    "dropphyzpp": 991509998,
    "dropmaladd": "17500 N HIGHWAY 21",
    "dropmalcty": "MALO",
    "dropmalst": "WA",
    "dropmalzpp": 991509998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097794355,
    "dropsitcph": 5097794355,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17076",
    "droptype": "D",
    "dropname": "MALOTT",
    "dropdeladd": "32 B AND O RD",
    "dropdelcty": "MALOTT",
    "dropdelst": "WA",
    "dropdelzpp": 988299800,
    "dropphyadd": "32 B AND O RD",
    "dropphycty": "MALOTT",
    "dropphyst": "WA",
    "dropphyzpp": 988299800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MALOTT",
    "dropmalst": "WA",
    "dropmalzpp": 988299998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094225020,
    "dropsitcph": 5094225020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17078",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "2325 COLCHESTER DR SE",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "WA",
    "dropdelzpp": 983539800,
    "dropphyadd": "2325 COLCHESTER DR SE",
    "dropphycty": "MANCHESTER",
    "dropphyst": "WA",
    "dropphyzpp": 983539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "WA",
    "dropmalzpp": 983539998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608710683,
    "dropsitcph": 3608710683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17085",
    "droptype": "D",
    "dropname": "MANSFIELD",
    "dropdeladd": "38 MAIN ST",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "WA",
    "dropdelzpp": 988309800,
    "dropphyadd": "38 MAIN ST",
    "dropphycty": "MANSFIELD",
    "dropphyst": "WA",
    "dropphyzpp": 988309800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "WA",
    "dropmalzpp": 988309998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096831255,
    "dropsitcph": 5096831255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17086",
    "droptype": "D",
    "dropname": "MANSON",
    "dropdeladd": "85 W WAPATO WAY",
    "dropdelcty": "MANSON",
    "dropdelst": "WA",
    "dropdelzpp": 988319800,
    "dropphyadd": "85 W WAPATO WAY",
    "dropphycty": "MANSON",
    "dropphyst": "WA",
    "dropphyzpp": 988319800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MANSON",
    "dropmalst": "WA",
    "dropmalzpp": 988319998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096873212,
    "dropsitcph": 5096873212,
    "dropfax": 5096878312
  },
  {
    "dcode": "D",
    "dropkey": "PZ17088",
    "droptype": "D",
    "dropname": "MAPLE FALLS",
    "dropdeladd": "7392 MOUNT BAKER HWY",
    "dropdelcty": "MAPLE FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 982669800,
    "dropphyadd": "7392 MOUNT BAKER HWY",
    "dropphycty": "MAPLE FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 982669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAPLE FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 982669998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605992917,
    "dropsitcph": 3605992917,
    "dropfax": 3605999151
  },
  {
    "dcode": "D",
    "dropkey": "PZ17091",
    "droptype": "D",
    "dropname": "MAPLE VALLEY",
    "dropdeladd": "22023 SE WAX RD",
    "dropdelcty": "MAPLE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 980389998,
    "dropphyadd": "22023 SE WAX RD",
    "dropphycty": "MAPLE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 980389998,
    "dropmaladd": "22023 SE WAX RD",
    "dropmalcty": "MAPLE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 980389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254137366,
    "dropsitcph": 4254324174,
    "dropfax": 6514566206
  },
  {
    "dcode": "D",
    "dropkey": "PZ17093",
    "droptype": "D",
    "dropname": "MARBLEMOUNT",
    "dropdeladd": "60096 STATE ROUTE 20",
    "dropdelcty": "MARBLEMOUNT",
    "dropdelst": "WA",
    "dropdelzpp": 982679990,
    "dropphyadd": "60096 STATE ROUTE 20",
    "dropphycty": "MARBLEMOUNT",
    "dropphyst": "WA",
    "dropphyzpp": 982679990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARBLEMOUNT",
    "dropmalst": "WA",
    "dropmalzpp": 982679998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608732125,
    "dropsitcph": 3608732125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17094",
    "droptype": "D",
    "dropname": "MARCUS",
    "dropdeladd": "1309 CIDER ST",
    "dropdelcty": "MARCUS",
    "dropdelst": "WA",
    "dropdelzpp": 991519998,
    "dropphyadd": "1309 CIDER ST",
    "dropphycty": "MARCUS",
    "dropphyst": "WA",
    "dropphyzpp": 991519998,
    "dropmaladd": "1309 CIDER ST",
    "dropmalcty": "MARCUS",
    "dropmalst": "WA",
    "dropmalzpp": 991519998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096848692,
    "dropsitcph": 5096848692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17098",
    "droptype": "D",
    "dropname": "MARLIN",
    "dropdeladd": "174 N URQUHART AVE",
    "dropdelcty": "MARLIN",
    "dropdelst": "WA",
    "dropdelzpp": 988329800,
    "dropphyadd": "174 N URQUHART AVE",
    "dropphycty": "MARLIN",
    "dropphyst": "WA",
    "dropphyzpp": 988329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARLIN",
    "dropmalst": "WA",
    "dropmalzpp": 988329998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5093452263,
    "dropsitcph": 5093452263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17101",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "9823 S MARSHALL AVE",
    "dropdelcty": "MARSHALL",
    "dropdelst": "WA",
    "dropdelzpp": 990209998,
    "dropphyadd": "9823 S MARSHALL AVE",
    "dropphycty": "MARSHALL",
    "dropphyst": "WA",
    "dropphyzpp": 990209998,
    "dropmaladd": "9823 S MARSHALL AVE",
    "dropmalcty": "MARSHALL",
    "dropmalst": "WA",
    "dropmalzpp": 990209998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094488332,
    "dropsitcph": 5094488332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17105",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "1010 STATE AVE",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 982709998,
    "dropphyadd": "1010 STATE AVE",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 982709998,
    "dropmaladd": "1010 STATE AVE",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 982709998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602875854,
    "dropsitcph": 3606536379,
    "dropfax": 6514566208
  },
  {
    "dcode": "D",
    "dropkey": "PZ17107",
    "droptype": "D",
    "dropname": "MATLOCK",
    "dropdeladd": "17490 W SHELTON MATLOCK RD",
    "dropdelcty": "MATLOCK",
    "dropdelst": "WA",
    "dropdelzpp": 985609900,
    "dropphyadd": "17490 W SHELTON MATLOCK RD",
    "dropphycty": "MATLOCK",
    "dropphyst": "WA",
    "dropphyzpp": 985609900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MATLOCK",
    "dropmalst": "WA",
    "dropmalzpp": 985609998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604262622,
    "dropsitcph": 3604262622,
    "dropfax": 3604273706
  },
  {
    "dcode": "D",
    "dropkey": "PZ17116",
    "droptype": "D",
    "dropname": "MCCLEARY",
    "dropdeladd": "117 S 4TH ST",
    "dropdelcty": "MCCLEARY",
    "dropdelst": "WA",
    "dropdelzpp": 985579602,
    "dropphyadd": "117 S 4TH ST",
    "dropphycty": "MCCLEARY",
    "dropphyst": "WA",
    "dropphyzpp": 985579602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCCLEARY",
    "dropmalst": "WA",
    "dropmalzpp": 985579998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604953630,
    "dropsitcph": 3604953630,
    "dropfax": 3604953848
  },
  {
    "dcode": "D",
    "dropkey": "PZ17117",
    "droptype": "D",
    "dropname": "MCKENNA",
    "dropdeladd": "9111 350TH ST S",
    "dropdelcty": "MCKENNA",
    "dropdelst": "WA",
    "dropdelzpp": 985589800,
    "dropphyadd": "9111 350TH ST S",
    "dropphycty": "MCKENNA",
    "dropphyst": "WA",
    "dropphyzpp": 985589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MCKENNA",
    "dropmalst": "WA",
    "dropmalzpp": 985589998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604587623,
    "dropsitcph": 3604587623,
    "dropfax": 3604583685
  },
  {
    "dcode": "D",
    "dropkey": "PZ17120",
    "droptype": "D",
    "dropname": "MEAD",
    "dropdeladd": "11616 N MARKET ST",
    "dropdelcty": "MEAD",
    "dropdelst": "WA",
    "dropdelzpp": 990219998,
    "dropphyadd": "11616 N MARKET ST",
    "dropphycty": "MEAD",
    "dropphyst": "WA",
    "dropphyzpp": 990219998,
    "dropmaladd": "11616 N MARKET ST",
    "dropmalcty": "MEAD",
    "dropmalst": "WA",
    "dropmalzpp": 990219998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094684880,
    "dropsitcph": 5094684681,
    "dropfax": 6514566209
  },
  {
    "dcode": "D",
    "dropkey": "PZ17122",
    "droptype": "D",
    "dropname": "MEDICAL LAKE",
    "dropdeladd": "322 E GRACE ST",
    "dropdelcty": "MEDICAL LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 990229998,
    "dropphyadd": "322 E GRACE ST",
    "dropphycty": "MEDICAL LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 990229998,
    "dropmaladd": "322 E GRACE ST",
    "dropmalcty": "MEDICAL LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 990229998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092997503,
    "dropsitcph": 5092996338,
    "dropfax": 6505772729
  },
  {
    "dcode": "D",
    "dropkey": "PZ17124",
    "droptype": "D",
    "dropname": "MEDINA",
    "dropdeladd": "816 EVERGREEN POINT RD",
    "dropdelcty": "MEDINA",
    "dropdelst": "WA",
    "dropdelzpp": 980399998,
    "dropphyadd": "816 EVERGREEN POINT RD",
    "dropphycty": "MEDINA",
    "dropphyst": "WA",
    "dropphyzpp": 980399998,
    "dropmaladd": "816 EVERGREEN POINT RD",
    "dropmalcty": "MEDINA",
    "dropmalst": "WA",
    "dropmalzpp": 980399998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254510909,
    "dropsitcph": 4256468111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17127",
    "droptype": "D",
    "dropname": "MENLO",
    "dropdeladd": "1000 HIGHWAY 6",
    "dropdelcty": "MENLO",
    "dropdelst": "WA",
    "dropdelzpp": 985619900,
    "dropphyadd": "1000 HIGHWAY 6",
    "dropphycty": "MENLO",
    "dropphyst": "WA",
    "dropphyzpp": 985619900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MENLO",
    "dropmalst": "WA",
    "dropmalzpp": 985619998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609425757,
    "dropsitcph": 3609425757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17129",
    "droptype": "D",
    "dropname": "MERCER ISLAND",
    "dropdeladd": "3040 78TH AVE SE",
    "dropdelcty": "MERCER ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 980409998,
    "dropphyadd": "3040 78TH AVE SE",
    "dropphycty": "MERCER ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 980409998,
    "dropmaladd": "3040 78TH AVE SE",
    "dropmalcty": "MERCER ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 980409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062751194,
    "dropsitcph": 2062328834,
    "dropfax": 6514566210
  },
  {
    "dcode": "D",
    "dropkey": "PZ17131",
    "droptype": "D",
    "dropname": "MESA",
    "dropdeladd": "111 FIRST AVE",
    "dropdelcty": "MESA",
    "dropdelst": "WA",
    "dropdelzpp": 993439998,
    "dropphyadd": "111 FIRST AVE",
    "dropphycty": "MESA",
    "dropphyst": "WA",
    "dropphyzpp": 993439998,
    "dropmaladd": "111 FIRST AVE",
    "dropmalcty": "MESA",
    "dropmalst": "WA",
    "dropmalzpp": 993439998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092654485,
    "dropsitcph": 5092654485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17132",
    "droptype": "D",
    "dropname": "METALINE",
    "dropdeladd": "101 N MAIN AVE",
    "dropdelcty": "METALINE",
    "dropdelst": "WA",
    "dropdelzpp": 991529998,
    "dropphyadd": "101 N MAIN AVE",
    "dropphycty": "METALINE",
    "dropphyst": "WA",
    "dropphyzpp": 991529998,
    "dropmaladd": "101 N MAIN AVE",
    "dropmalcty": "METALINE",
    "dropmalst": "WA",
    "dropmalzpp": 991529998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094464848,
    "dropsitcph": 5094464848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17133",
    "droptype": "D",
    "dropname": "METALINE FALLS",
    "dropdeladd": "224 E 5TH AVE",
    "dropdelcty": "METALINE FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 991539998,
    "dropphyadd": "224 E 5TH AVE",
    "dropphycty": "METALINE FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 991539998,
    "dropmaladd": "224 E 5TH AVE",
    "dropmalcty": "METALINE FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 991539998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094462425,
    "dropsitcph": 5094462425,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17134",
    "droptype": "D",
    "dropname": "METHOW",
    "dropdeladd": "34 MAIN ST",
    "dropdelcty": "METHOW",
    "dropdelst": "WA",
    "dropdelzpp": 988349800,
    "dropphyadd": "34 MAIN ST",
    "dropphycty": "METHOW",
    "dropphyst": "WA",
    "dropphyzpp": 988349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "METHOW",
    "dropmalst": "WA",
    "dropmalzpp": 988349998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5099232759,
    "dropsitcph": 5099232759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17144",
    "droptype": "D",
    "dropname": "MILTON",
    "dropdeladd": "2825 MILTON WAY",
    "dropdelcty": "MILTON",
    "dropdelst": "WA",
    "dropdelzpp": 983549800,
    "dropphyadd": "2825 MILTON WAY",
    "dropphycty": "MILTON",
    "dropphyst": "WA",
    "dropphyzpp": 983549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILTON",
    "dropmalst": "WA",
    "dropmalzpp": 983549998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535682664,
    "dropsitcph": 2535682866,
    "dropfax": 6514566214
  },
  {
    "dcode": "D",
    "dropkey": "PZ17145",
    "droptype": "D",
    "dropname": "MINERAL",
    "dropdeladd": "100 WASHINGTON ST",
    "dropdelcty": "MINERAL",
    "dropdelst": "WA",
    "dropdelzpp": 983559800,
    "dropphyadd": "100 WASHINGTON ST",
    "dropphycty": "MINERAL",
    "dropphyst": "WA",
    "dropphyzpp": 983559800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MINERAL",
    "dropmalst": "WA",
    "dropmalzpp": 983559998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604925383,
    "dropsitcph": 3604925383,
    "dropfax": 6505784648
  },
  {
    "dcode": "D",
    "dropkey": "PZ17147",
    "droptype": "D",
    "dropname": "MOCLIPS",
    "dropdeladd": "4758 STATE ROUTE 109",
    "dropdelcty": "MOCLIPS",
    "dropdelst": "WA",
    "dropdelzpp": 985629900,
    "dropphyadd": "4758 STATE ROUTE 109",
    "dropphycty": "MOCLIPS",
    "dropphyst": "WA",
    "dropphyzpp": 985629900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOCLIPS",
    "dropmalst": "WA",
    "dropmalzpp": 985629998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602764503,
    "dropsitcph": 3602764503,
    "dropfax": 6505784660
  },
  {
    "dcode": "D",
    "dropkey": "PZ17150",
    "droptype": "D",
    "dropname": "MONITOR",
    "dropdeladd": "3160 MAIN ST",
    "dropdelcty": "MONITOR",
    "dropdelst": "WA",
    "dropdelzpp": 988369800,
    "dropphyadd": "3160 MAIN ST",
    "dropphycty": "MONITOR",
    "dropphyst": "WA",
    "dropphyzpp": 988369800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONITOR",
    "dropmalst": "WA",
    "dropmalzpp": 988369998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097824022,
    "dropsitcph": 5097824022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17151",
    "droptype": "D",
    "dropname": "MONROE",
    "dropdeladd": "122 N BLAKELEY ST",
    "dropdelcty": "MONROE",
    "dropdelst": "WA",
    "dropdelzpp": 982729998,
    "dropphyadd": "122 N BLAKELEY ST",
    "dropphycty": "MONROE",
    "dropphyst": "WA",
    "dropphyzpp": 982729998,
    "dropmaladd": "122 N BLAKELEY ST",
    "dropmalcty": "MONROE",
    "dropmalst": "WA",
    "dropmalzpp": 982729998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607941635,
    "dropsitcph": 3608051962,
    "dropfax": 6514566215
  },
  {
    "dcode": "D",
    "dropkey": "PZ17153",
    "droptype": "D",
    "dropname": "MONTESANO",
    "dropdeladd": "211 W PIONEER AVE",
    "dropdelcty": "MONTESANO",
    "dropdelst": "WA",
    "dropdelzpp": 985639998,
    "dropphyadd": "211 W PIONEER AVE",
    "dropphycty": "MONTESANO",
    "dropphyst": "WA",
    "dropphyzpp": 985639998,
    "dropmaladd": "211 W PIONEER AVE",
    "dropmalcty": "MONTESANO",
    "dropmalst": "WA",
    "dropmalzpp": 985639998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602492834,
    "dropsitcph": 3602493322,
    "dropfax": 6514566216
  },
  {
    "dcode": "D",
    "dropkey": "PZ17156",
    "droptype": "D",
    "dropname": "MORTON",
    "dropdeladd": "170 2ND ST",
    "dropdelcty": "MORTON",
    "dropdelst": "WA",
    "dropdelzpp": 983569800,
    "dropphyadd": "170 2ND ST",
    "dropphycty": "MORTON",
    "dropphyst": "WA",
    "dropphyzpp": 983569800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORTON",
    "dropmalst": "WA",
    "dropmalzpp": 983569998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604965316,
    "dropsitcph": 3604965316,
    "dropfax": 6505776118
  },
  {
    "dcode": "D",
    "dropkey": "PZ17157",
    "droptype": "D",
    "dropname": "MOSES LAKE",
    "dropdeladd": "223 W 3RD AVE",
    "dropdelcty": "MOSES LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 988379998,
    "dropphyadd": "223 W 3RD AVE",
    "dropphycty": "MOSES LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 988379998,
    "dropmaladd": "223 W 3RD AVE",
    "dropmalcty": "MOSES LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 988379998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097651042,
    "dropsitcph": 5097646701,
    "dropfax": 6514566217
  },
  {
    "dcode": "D",
    "dropkey": "PZ17158",
    "droptype": "D",
    "dropname": "MOSSYROCK",
    "dropdeladd": "243 E MAIN ST",
    "dropdelcty": "MOSSYROCK",
    "dropdelst": "WA",
    "dropdelzpp": 985649900,
    "dropphyadd": "243 E MAIN ST",
    "dropphycty": "MOSSYROCK",
    "dropphyst": "WA",
    "dropphyzpp": 985649900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOSSYROCK",
    "dropmalst": "WA",
    "dropmalzpp": 985649998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603683060,
    "dropsitcph": 3603683060,
    "dropfax": 3609838288
  },
  {
    "dcode": "D",
    "dropkey": "PZ17160",
    "droptype": "D",
    "dropname": "MOUNT VERNON",
    "dropdeladd": "1207 CLEVELAND AVE",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "WA",
    "dropdelzpp": 982739998,
    "dropphyadd": "1207 CLEVELAND AVE",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "WA",
    "dropphyzpp": 982739998,
    "dropmaladd": "1207 CLEVELAND AVE",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "WA",
    "dropmalzpp": 982739998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603363152,
    "dropsitcph": 3603365812,
    "dropfax": 6514566219
  },
  {
    "dcode": "D",
    "dropkey": "PZ17162",
    "droptype": "D",
    "dropname": "MOUNTLAKE TERRACE",
    "dropdeladd": "23210 57TH AVE W",
    "dropdelcty": "MOUNTLAKE TERRACE",
    "dropdelst": "WA",
    "dropdelzpp": 980439998,
    "dropphyadd": "23210 57TH AVE W",
    "dropphycty": "MOUNTLAKE TERRACE",
    "dropphyst": "WA",
    "dropphyzpp": 980439998,
    "dropmaladd": "23210 57TH AVE W",
    "dropmalcty": "MOUNTLAKE TERRACE",
    "dropmalst": "WA",
    "dropmalzpp": 980439998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4257782118,
    "dropsitcph": 4257780429,
    "dropfax": 6505784715
  },
  {
    "dcode": "D",
    "dropkey": "PZ17163",
    "droptype": "D",
    "dropname": "MOXEE",
    "dropdeladd": "202 E SEATTLE AVE",
    "dropdelcty": "MOXEE",
    "dropdelst": "WA",
    "dropdelzpp": 989369035,
    "dropphyadd": "202 E SEATTLE AVE",
    "dropphycty": "MOXEE",
    "dropphyst": "WA",
    "dropphyzpp": 989369035,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOXEE",
    "dropmalst": "WA",
    "dropmalzpp": 989369998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092480955,
    "dropsitcph": 5092480955,
    "dropfax": 5092485718
  },
  {
    "dcode": "D",
    "dropkey": "PZ17165",
    "droptype": "D",
    "dropname": "MUKILTEO",
    "dropdeladd": "8050 MUKILTEO SPEEDWAY",
    "dropdelcty": "MUKILTEO",
    "dropdelst": "WA",
    "dropdelzpp": 982759998,
    "dropphyadd": "8050 MUKILTEO SPEEDWAY",
    "dropphycty": "MUKILTEO",
    "dropphyst": "WA",
    "dropphyzpp": 982759998,
    "dropmaladd": "8050 MUKILTEO SPEEDWAY",
    "dropmalcty": "MUKILTEO",
    "dropmalst": "WA",
    "dropmalzpp": 982759998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253562783,
    "dropsitcph": 4257107039,
    "dropfax": 6514566220
  },
  {
    "dcode": "D",
    "dropkey": "PZ17169",
    "droptype": "D",
    "dropname": "NACHES",
    "dropdeladd": "210 W 3RD ST",
    "dropdelcty": "NACHES",
    "dropdelst": "WA",
    "dropdelzpp": 989379996,
    "dropphyadd": "210 W 3RD ST",
    "dropphycty": "NACHES",
    "dropphyst": "WA",
    "dropphyzpp": 989379996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NACHES",
    "dropmalst": "WA",
    "dropmalzpp": 989379998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096532467,
    "dropsitcph": 5096532467,
    "dropfax": 5096531337
  },
  {
    "dcode": "D",
    "dropkey": "PZ17171",
    "droptype": "D",
    "dropname": "NAPAVINE",
    "dropdeladd": "111C 2ND AVE NE",
    "dropdelcty": "NAPAVINE",
    "dropdelst": "WA",
    "dropdelzpp": 985659900,
    "dropphyadd": "111C 2ND AVE NE",
    "dropphycty": "NAPAVINE",
    "dropphyst": "WA",
    "dropphyzpp": 985659900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NAPAVINE",
    "dropmalst": "WA",
    "dropmalzpp": 985659998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602623791,
    "dropsitcph": 3602623791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17173",
    "droptype": "D",
    "dropname": "NASELLE",
    "dropdeladd": "294 KNAPPTON RD",
    "dropdelcty": "NASELLE",
    "dropdelst": "WA",
    "dropdelzpp": 986388613,
    "dropphyadd": "294 KNAPPTON RD",
    "dropphycty": "NASELLE",
    "dropphyst": "WA",
    "dropphyzpp": 986388613,
    "dropmaladd": "294 KNAPPTON RD",
    "dropmalcty": "NASELLE",
    "dropmalst": "WA",
    "dropmalzpp": 986389998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3604843822,
    "dropsitcph": 3604843822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17178",
    "droptype": "D",
    "dropname": "NEAH BAY",
    "dropdeladd": "130 BUCHANAN ST",
    "dropdelcty": "NEAH BAY",
    "dropdelst": "WA",
    "dropdelzpp": 983579800,
    "dropphyadd": "130 BUCHANAN ST",
    "dropphycty": "NEAH BAY",
    "dropphyst": "WA",
    "dropphyzpp": 983579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEAH BAY",
    "dropmalst": "WA",
    "dropmalzpp": 983579998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606452325,
    "dropsitcph": 3606452325,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17179",
    "droptype": "D",
    "dropname": "NEILTON",
    "dropdeladd": "5513 US HIGHWAY 101",
    "dropdelcty": "NEILTON",
    "dropdelst": "WA",
    "dropdelzpp": 985669900,
    "dropphyadd": "5513 US HIGHWAY 101",
    "dropphycty": "NEILTON",
    "dropphyst": "WA",
    "dropphyzpp": 985669900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEILTON",
    "dropmalst": "WA",
    "dropmalzpp": 985669998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602882427,
    "dropsitcph": 3602882427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17181",
    "droptype": "D",
    "dropname": "NESPELEM",
    "dropdeladd": "100 9TH ST",
    "dropdelcty": "NESPELEM",
    "dropdelst": "WA",
    "dropdelzpp": 991559998,
    "dropphyadd": "100 9TH ST",
    "dropphycty": "NESPELEM",
    "dropphyst": "WA",
    "dropphyzpp": 991559998,
    "dropmaladd": "100 9TH ST",
    "dropmalcty": "NESPELEM",
    "dropmalst": "WA",
    "dropmalzpp": 991559998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096344212,
    "dropsitcph": 5096344212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17186",
    "droptype": "D",
    "dropname": "NEWMAN LAKE",
    "dropdeladd": "25125 E TRENT AVE",
    "dropdelcty": "NEWMAN LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 990259998,
    "dropphyadd": "25125 E TRENT AVE",
    "dropphycty": "NEWMAN LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 990259998,
    "dropmaladd": "25125 E TRENT AVE",
    "dropmalcty": "NEWMAN LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 990259998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092263174,
    "dropsitcph": 5092263174,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17187",
    "droptype": "D",
    "dropname": "NEWPORT",
    "dropdeladd": "100 N WASHINGTON AVE",
    "dropdelcty": "NEWPORT",
    "dropdelst": "WA",
    "dropdelzpp": 991569998,
    "dropphyadd": "100 N WASHINGTON AVE",
    "dropphycty": "NEWPORT",
    "dropphyst": "WA",
    "dropphyzpp": 991569998,
    "dropmaladd": "100 N WASHINGTON AVE",
    "dropmalcty": "NEWPORT",
    "dropmalst": "WA",
    "dropmalzpp": 991569998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094474221,
    "dropsitcph": 5094474221,
    "dropfax": 6514566221
  },
  {
    "dcode": "D",
    "dropkey": "PZ17193",
    "droptype": "D",
    "dropname": "NINE MILE FALLS",
    "dropdeladd": "12522 N NINE MILE RD",
    "dropdelcty": "NINE MILE FALLS",
    "dropdelst": "WA",
    "dropdelzpp": 990269998,
    "dropphyadd": "12522 N NINE MILE RD",
    "dropphycty": "NINE MILE FALLS",
    "dropphyst": "WA",
    "dropphyzpp": 990269998,
    "dropmaladd": "12522 N NINE MILE RD",
    "dropmalcty": "NINE MILE FALLS",
    "dropmalst": "WA",
    "dropmalzpp": 990269998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094684356,
    "dropsitcph": 5094684357,
    "dropfax": 6514566222
  },
  {
    "dcode": "D",
    "dropkey": "PZ17198",
    "droptype": "D",
    "dropname": "NORDLAND",
    "dropdeladd": "7180 FLAGLER RD",
    "dropdelcty": "NORDLAND",
    "dropdelst": "WA",
    "dropdelzpp": 983589800,
    "dropphyadd": "7180 FLAGLER RD",
    "dropphycty": "NORDLAND",
    "dropphyst": "WA",
    "dropphyzpp": 983589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORDLAND",
    "dropmalst": "WA",
    "dropmalzpp": 983589998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603852825,
    "dropsitcph": 3603852825,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17200",
    "droptype": "D",
    "dropname": "NORTH BEND",
    "dropdeladd": "451 E NORTH BEND WAY",
    "dropdelcty": "NORTH BEND",
    "dropdelst": "WA",
    "dropdelzpp": 980459990,
    "dropphyadd": "451 E NORTH BEND WAY",
    "dropphycty": "NORTH BEND",
    "dropphyst": "WA",
    "dropphyzpp": 980459990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH BEND",
    "dropmalst": "WA",
    "dropmalzpp": 980459998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4258886820,
    "dropsitcph": 4258317020,
    "dropfax": 6514566223
  },
  {
    "dcode": "D",
    "dropkey": "PZ17201",
    "droptype": "D",
    "dropname": "NORTH BONNEVILLE",
    "dropdeladd": "212 CBD MALL ST",
    "dropdelcty": "NORTH BONNEVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 986394676,
    "dropphyadd": "212 CBD MALL ST",
    "dropphycty": "NORTH BONNEVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 986394676,
    "dropmaladd": "212 CBD MALL ST",
    "dropmalcty": "NORTH BONNEVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 986399998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094278784,
    "dropsitcph": 5094278784,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17210",
    "droptype": "D",
    "dropname": "NORTHPORT",
    "dropdeladd": "409 CENTER AVE",
    "dropdelcty": "NORTHPORT",
    "dropdelst": "WA",
    "dropdelzpp": 991579998,
    "dropphyadd": "409 CENTER AVE",
    "dropphycty": "NORTHPORT",
    "dropphyst": "WA",
    "dropphyzpp": 991579998,
    "dropmaladd": "409 CENTER AVE",
    "dropmalcty": "NORTHPORT",
    "dropmalst": "WA",
    "dropmalzpp": 991579998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097326660,
    "dropsitcph": 5097326660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17213",
    "droptype": "D",
    "dropname": "OAK HARBOR",
    "dropdeladd": "1155 SE CITY BEACH ST",
    "dropdelcty": "OAK HARBOR",
    "dropdelst": "WA",
    "dropdelzpp": 982779998,
    "dropphyadd": "1155 SE CITY BEACH ST",
    "dropphycty": "OAK HARBOR",
    "dropphyst": "WA",
    "dropphyzpp": 982779998,
    "dropmaladd": "1155 SE CITY BEACH ST",
    "dropmalcty": "OAK HARBOR",
    "dropmalst": "WA",
    "dropmalzpp": 982779998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606756273,
    "dropsitcph": 3602401499,
    "dropfax": 6514566226
  },
  {
    "dcode": "D",
    "dropkey": "PZ17215",
    "droptype": "D",
    "dropname": "OAKESDALE",
    "dropdeladd": "106 W STEPTOE AVE",
    "dropdelcty": "OAKESDALE",
    "dropdelst": "WA",
    "dropdelzpp": 991589998,
    "dropphyadd": "106 W STEPTOE AVE",
    "dropphycty": "OAKESDALE",
    "dropphyst": "WA",
    "dropphyzpp": 991589998,
    "dropmaladd": "106 W STEPTOE AVE",
    "dropmalcty": "OAKESDALE",
    "dropmalst": "WA",
    "dropmalzpp": 991589998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092854675,
    "dropsitcph": 5092854675,
    "dropfax": 6505784674
  },
  {
    "dcode": "D",
    "dropkey": "PZ17216",
    "droptype": "D",
    "dropname": "OAKVILLE",
    "dropdeladd": "114 E PINE ST",
    "dropdelcty": "OAKVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 985689900,
    "dropphyadd": "114 E PINE ST",
    "dropphycty": "OAKVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 985689900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 985689998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602739321,
    "dropsitcph": 3602739321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17220",
    "droptype": "D",
    "dropname": "OCEAN PARK",
    "dropdeladd": "25502 VERNON AVE",
    "dropdelcty": "OCEAN PARK",
    "dropdelst": "WA",
    "dropdelzpp": 986409198,
    "dropphyadd": "25502 VERNON AVE",
    "dropphycty": "OCEAN PARK",
    "dropphyst": "WA",
    "dropphyzpp": 986409198,
    "dropmaladd": "25502 VERNON AVE",
    "dropmalcty": "OCEAN PARK",
    "dropmalst": "WA",
    "dropmalzpp": 986409998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606655493,
    "dropsitcph": 3606656628,
    "dropfax": 3606654265
  },
  {
    "dcode": "D",
    "dropkey": "PZ17221",
    "droptype": "D",
    "dropname": "OCEAN SHORES",
    "dropdeladd": "689 DOLPHIN AVE NE",
    "dropdelcty": "OCEAN SHORES",
    "dropdelst": "WA",
    "dropdelzpp": 985699901,
    "dropphyadd": "689 DOLPHIN AVE NE",
    "dropphycty": "OCEAN SHORES",
    "dropphyst": "WA",
    "dropphyzpp": 985699901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCEAN SHORES",
    "dropmalst": "WA",
    "dropmalzpp": 985699998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602893665,
    "dropsitcph": 3602893665,
    "dropfax": 6514566227
  },
  {
    "dcode": "D",
    "dropkey": "PZ17224",
    "droptype": "D",
    "dropname": "ODESSA",
    "dropdeladd": "203 W 1ST AVE",
    "dropdelcty": "ODESSA",
    "dropdelst": "WA",
    "dropdelzpp": 991599998,
    "dropphyadd": "203 W 1ST AVE",
    "dropphycty": "ODESSA",
    "dropphyst": "WA",
    "dropphyzpp": 991599998,
    "dropmaladd": "203 W 1ST AVE",
    "dropmalcty": "ODESSA",
    "dropmalst": "WA",
    "dropmalzpp": 991599998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099821005,
    "dropsitcph": 5099821005,
    "dropfax": 5099822770
  },
  {
    "dcode": "D",
    "dropkey": "PZ17227",
    "droptype": "D",
    "dropname": "OKANOGAN",
    "dropdeladd": "212 2ND AVE N",
    "dropdelcty": "OKANOGAN",
    "dropdelst": "WA",
    "dropdelzpp": 988409652,
    "dropphyadd": "212 2ND AVE N",
    "dropphycty": "OKANOGAN",
    "dropphyst": "WA",
    "dropphyzpp": 988409652,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OKANOGAN",
    "dropmalst": "WA",
    "dropmalzpp": 988409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094224222,
    "dropsitcph": 5094223830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17228",
    "droptype": "D",
    "dropname": "OLALLA",
    "dropdeladd": "6030 SE BURLEY OLALLA RD",
    "dropdelcty": "OLALLA",
    "dropdelst": "WA",
    "dropdelzpp": 983599800,
    "dropphyadd": "6030 SE BURLEY OLALLA RD",
    "dropphycty": "OLALLA",
    "dropphyst": "WA",
    "dropphyzpp": 983599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLALLA",
    "dropmalst": "WA",
    "dropmalzpp": 983599998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538575256,
    "dropsitcph": 2538575256,
    "dropfax": 6516751662
  },
  {
    "dcode": "D",
    "dropkey": "PZ17231",
    "droptype": "D",
    "dropname": "OLGA",
    "dropdeladd": "7034 OLGA RD",
    "dropdelcty": "OLGA",
    "dropdelst": "WA",
    "dropdelzpp": 982799996,
    "dropphyadd": "7034 OLGA RD",
    "dropphycty": "OLGA",
    "dropphyst": "WA",
    "dropphyzpp": 982799996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLGA",
    "dropmalst": "WA",
    "dropmalzpp": 982799998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603764121,
    "dropsitcph": 3603764121,
    "dropfax": 6505774906
  },
  {
    "dcode": "D",
    "dropkey": "PZ17238",
    "droptype": "D",
    "dropname": "OMAK",
    "dropdeladd": "104 S MAIN ST",
    "dropdelcty": "OMAK",
    "dropdelst": "WA",
    "dropdelzpp": 988419800,
    "dropphyadd": "104 S MAIN ST",
    "dropphycty": "OMAK",
    "dropphyst": "WA",
    "dropphyzpp": 988419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMAK",
    "dropmalst": "WA",
    "dropmalzpp": 988419998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098262060,
    "dropsitcph": 5098262060,
    "dropfax": 6514566228
  },
  {
    "dcode": "D",
    "dropkey": "PZ17239",
    "droptype": "D",
    "dropname": "ONALASKA",
    "dropdeladd": "1753 STATE HIGHWAY 508",
    "dropdelcty": "ONALASKA",
    "dropdelst": "WA",
    "dropdelzpp": 985709900,
    "dropphyadd": "1753 STATE HIGHWAY 508",
    "dropphycty": "ONALASKA",
    "dropphyst": "WA",
    "dropphyzpp": 985709900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ONALASKA",
    "dropmalst": "WA",
    "dropmalzpp": 985709998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602450228,
    "dropsitcph": 3602450228,
    "dropfax": 3609784575
  },
  {
    "dcode": "D",
    "dropkey": "PZ17241",
    "droptype": "D",
    "dropname": "ORCAS",
    "dropdeladd": "121 KILLEBREW LAKE RD",
    "dropdelcty": "ORCAS",
    "dropdelst": "WA",
    "dropdelzpp": 982809990,
    "dropphyadd": "121 KILLEBREW LAKE RD",
    "dropphycty": "ORCAS",
    "dropphyst": "WA",
    "dropphyzpp": 982809990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORCAS",
    "dropmalst": "WA",
    "dropmalzpp": 982809998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603764254,
    "dropsitcph": 3603764254,
    "dropfax": 6503576309
  },
  {
    "dcode": "D",
    "dropkey": "PZ17245",
    "droptype": "D",
    "dropname": "ORONDO",
    "dropdeladd": "14003 STATE ROUTE 2",
    "dropdelcty": "ORONDO",
    "dropdelst": "WA",
    "dropdelzpp": 988439680,
    "dropphyadd": "14003 STATE ROUTE 2",
    "dropphycty": "ORONDO",
    "dropphyst": "WA",
    "dropphyzpp": 988439680,
    "dropmaladd": "14003 STATE ROUTE 2",
    "dropmalcty": "ORONDO",
    "dropmalst": "WA",
    "dropmalzpp": 988439998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094361222,
    "dropsitcph": 5094361222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17246",
    "droptype": "D",
    "dropname": "OROVILLE",
    "dropdeladd": "1234 IRONWOOD ST",
    "dropdelcty": "OROVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 988449235,
    "dropphyadd": "1234 IRONWOOD ST",
    "dropphycty": "OROVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 988449235,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OROVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 988449998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094762393,
    "dropsitcph": 5094762393,
    "dropfax": 6505784995
  },
  {
    "dcode": "D",
    "dropkey": "PZ17247",
    "droptype": "D",
    "dropname": "ORTING",
    "dropdeladd": "117 VAN SCOYOC AVE SW",
    "dropdelcty": "ORTING",
    "dropdelst": "WA",
    "dropdelzpp": 983609800,
    "dropphyadd": "117 VAN SCOYOC AVE SW",
    "dropphycty": "ORTING",
    "dropphyst": "WA",
    "dropphyzpp": 983609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ORTING",
    "dropmalst": "WA",
    "dropmalzpp": 983609998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608936569,
    "dropsitcph": 3608935290,
    "dropfax": 6514566229
  },
  {
    "dcode": "D",
    "dropkey": "PZ17251",
    "droptype": "D",
    "dropname": "OTHELLO",
    "dropdeladd": "602 E MAIN ST",
    "dropdelcty": "OTHELLO",
    "dropdelst": "WA",
    "dropdelzpp": 993449998,
    "dropphyadd": "602 E MAIN ST",
    "dropphycty": "OTHELLO",
    "dropphyst": "WA",
    "dropphyzpp": 993449998,
    "dropmaladd": "602 E MAIN ST",
    "dropmalcty": "OTHELLO",
    "dropmalst": "WA",
    "dropmalzpp": 993449998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094889955,
    "dropsitcph": 5094889955,
    "dropfax": 6514566230
  },
  {
    "dcode": "D",
    "dropkey": "PZ17252",
    "droptype": "D",
    "dropname": "OTIS ORCHARDS",
    "dropdeladd": "21616 E WELLESLEY AVE",
    "dropdelcty": "OTIS ORCHARDS",
    "dropdelst": "WA",
    "dropdelzpp": 990279998,
    "dropphyadd": "21616 E WELLESLEY AVE",
    "dropphycty": "OTIS ORCHARDS",
    "dropphyst": "WA",
    "dropphyzpp": 990279998,
    "dropmaladd": "21616 E WELLESLEY AVE",
    "dropmalcty": "OTIS ORCHARDS",
    "dropmalst": "WA",
    "dropmalzpp": 990279998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099248124,
    "dropsitcph": 5098930291,
    "dropfax": 6505774634
  },
  {
    "dcode": "D",
    "dropkey": "PZ17253",
    "droptype": "D",
    "dropname": "OUTLOOK",
    "dropdeladd": "691 OUTLOOK RD",
    "dropdelcty": "OUTLOOK",
    "dropdelst": "WA",
    "dropdelzpp": 989389546,
    "dropphyadd": "691 OUTLOOK RD",
    "dropphycty": "OUTLOOK",
    "dropphyst": "WA",
    "dropphyzpp": 989389546,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OUTLOOK",
    "dropmalst": "WA",
    "dropmalzpp": 989389998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098374801,
    "dropsitcph": 5098374801,
    "dropfax": 5098374801
  },
  {
    "dcode": "D",
    "dropkey": "PZ17257",
    "droptype": "D",
    "dropname": "OYSTERVILLE",
    "dropdeladd": "3012 OYSTERVILLE RD",
    "dropdelcty": "OYSTERVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 986419198,
    "dropphyadd": "3012 OYSTERVILLE RD",
    "dropphycty": "OYSTERVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 986419198,
    "dropmaladd": "3012 OYSTERVILLE RD",
    "dropmalcty": "OYSTERVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 986419998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606656388,
    "dropsitcph": 3606656388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17261",
    "droptype": "D",
    "dropname": "PACIFIC BEACH",
    "dropdeladd": "12 MAIN ST",
    "dropdelcty": "PACIFIC BEACH",
    "dropdelst": "WA",
    "dropdelzpp": 985719900,
    "dropphyadd": "12 MAIN ST",
    "dropphycty": "PACIFIC BEACH",
    "dropphyst": "WA",
    "dropphyzpp": 985719900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACIFIC BEACH",
    "dropmalst": "WA",
    "dropmalzpp": 985719998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602761354,
    "dropsitcph": 3602761354,
    "dropfax": 3602761354
  },
  {
    "dcode": "D",
    "dropkey": "PZ17263",
    "droptype": "D",
    "dropname": "PACKWOOD",
    "dropdeladd": "111 SMITH RD",
    "dropdelcty": "PACKWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 983619800,
    "dropphyadd": "111 SMITH RD",
    "dropphycty": "PACKWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 983619800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PACKWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 983619998,
    "dropsitphn": 3604946311,
    "dropsitlph": 3604946311,
    "dropsitcph": 3604946311,
    "dropfax": 3604946312
  },
  {
    "dcode": "D",
    "dropkey": "PZ17264",
    "droptype": "D",
    "dropname": "PALISADES",
    "dropdeladd": "1134 PALISADES RD",
    "dropdelcty": "PALISADES",
    "dropdelst": "WA",
    "dropdelzpp": 988459609,
    "dropphyadd": "1134 PALISADES RD",
    "dropphycty": "PALISADES",
    "dropphyst": "WA",
    "dropphyzpp": 988459609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALISADES",
    "dropmalst": "WA",
    "dropmalzpp": 988459998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098847699,
    "dropsitcph": 5098847699,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17266",
    "droptype": "D",
    "dropname": "PALOUSE",
    "dropdeladd": "300 E MAIN ST",
    "dropdelcty": "PALOUSE",
    "dropdelst": "WA",
    "dropdelzpp": 991619998,
    "dropphyadd": "300 E MAIN ST",
    "dropphycty": "PALOUSE",
    "dropphyst": "WA",
    "dropphyzpp": 991619998,
    "dropmaladd": "300 E MAIN ST",
    "dropmalcty": "PALOUSE",
    "dropmalst": "WA",
    "dropmalzpp": 991619998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098781500,
    "dropsitcph": 5098781500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17268",
    "droptype": "D",
    "dropname": "PARKER",
    "dropdeladd": "301 2ND AVE",
    "dropdelcty": "PARKER",
    "dropdelst": "WA",
    "dropdelzpp": 989399800,
    "dropphyadd": "301 2ND AVE",
    "dropphycty": "PARKER",
    "dropphyst": "WA",
    "dropphyzpp": 989399800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKER",
    "dropmalst": "WA",
    "dropmalzpp": 989399998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098773150,
    "dropsitcph": 5098773150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17273",
    "droptype": "D",
    "dropname": "PASCO",
    "dropdeladd": "3500 W COURT ST",
    "dropdelcty": "PASCO",
    "dropdelst": "WA",
    "dropdelzpp": 993019998,
    "dropphyadd": "3500 W COURT ST",
    "dropphycty": "PASCO",
    "dropphyst": "WA",
    "dropphyzpp": 993019998,
    "dropmaladd": "3500 W COURT ST",
    "dropmalcty": "PASCO",
    "dropmalst": "WA",
    "dropmalzpp": 993019998,
    "dropsitphn": 5095432137,
    "dropsitlph": 5095432113,
    "dropsitcph": 5095432189,
    "dropfax": 5095432107
  },
  {
    "dcode": "D",
    "dropkey": "PZ17274",
    "droptype": "D",
    "dropname": "PATEROS",
    "dropdeladd": "170 PATEROS MALL",
    "dropdelcty": "PATEROS",
    "dropdelst": "WA",
    "dropdelzpp": 988469850,
    "dropphyadd": "170 PATEROS MALL",
    "dropphycty": "PATEROS",
    "dropphyst": "WA",
    "dropphyzpp": 988469850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATEROS",
    "dropmalst": "WA",
    "dropmalzpp": 988469998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5099233032,
    "dropsitcph": 5099233032,
    "dropfax": 5099233032
  },
  {
    "dcode": "D",
    "dropkey": "PZ17275",
    "droptype": "D",
    "dropname": "PATERSON",
    "dropdeladd": "48801 W PRIOR AVE",
    "dropdelcty": "PATERSON",
    "dropdelst": "WA",
    "dropdelzpp": 993459998,
    "dropphyadd": "48801 W PRIOR AVE",
    "dropphycty": "PATERSON",
    "dropphyst": "WA",
    "dropphyzpp": 993459998,
    "dropmaladd": "48801 W PRIOR AVE",
    "dropmalcty": "PATERSON",
    "dropmalst": "WA",
    "dropmalzpp": 993459998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098752531,
    "dropsitcph": 5098752531,
    "dropfax": 6505784673
  },
  {
    "dcode": "D",
    "dropkey": "PZ17278",
    "droptype": "D",
    "dropname": "PE ELL",
    "dropdeladd": "203 N MAIN ST",
    "dropdelcty": "PE ELL",
    "dropdelst": "WA",
    "dropdelzpp": 985729900,
    "dropphyadd": "203 N MAIN ST",
    "dropphycty": "PE ELL",
    "dropphyst": "WA",
    "dropphyzpp": 985729900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PE ELL",
    "dropmalst": "WA",
    "dropmalzpp": 985729998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602913571,
    "dropsitcph": 3602913571,
    "dropfax": 3602913571
  },
  {
    "dcode": "D",
    "dropkey": "PZ17283",
    "droptype": "D",
    "dropname": "PESHASTIN",
    "dropdeladd": "10168 MAIN ST",
    "dropdelcty": "PESHASTIN",
    "dropdelst": "WA",
    "dropdelzpp": 988479800,
    "dropphyadd": "10168 MAIN ST",
    "dropphycty": "PESHASTIN",
    "dropphyst": "WA",
    "dropphyzpp": 988479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PESHASTIN",
    "dropmalst": "WA",
    "dropmalzpp": 988479998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5095485134,
    "dropsitcph": 5095485134,
    "dropfax": 5095485304
  },
  {
    "dcode": "D",
    "dropkey": "PZ17291",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "72304 SE 3RD AVE",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "WA",
    "dropdelzpp": 993469998,
    "dropphyadd": "72304 SE 3RD AVE",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "WA",
    "dropphyzpp": 993469998,
    "dropmaladd": "72304 SE 3RD AVE",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "WA",
    "dropmalzpp": 993469998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097831671,
    "dropsitcph": 5097831671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17294",
    "droptype": "D",
    "dropname": "POINT ROBERTS",
    "dropdeladd": "1582 GULF RD",
    "dropdelcty": "POINT ROBERTS",
    "dropdelst": "WA",
    "dropdelzpp": 982819998,
    "dropphyadd": "1582 GULF RD",
    "dropphycty": "POINT ROBERTS",
    "dropphyst": "WA",
    "dropphyzpp": 982819998,
    "dropmaladd": "1582 GULF RD",
    "dropmalcty": "POINT ROBERTS",
    "dropmalst": "WA",
    "dropmalzpp": 982819998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609457770,
    "dropsitcph": 3609457770,
    "dropfax": 6514566233
  },
  {
    "dcode": "D",
    "dropkey": "PZ17295",
    "droptype": "D",
    "dropname": "POMEROY",
    "dropdeladd": "1076 MAIN ST",
    "dropdelcty": "POMEROY",
    "dropdelst": "WA",
    "dropdelzpp": 993479998,
    "dropphyadd": "1076 MAIN ST",
    "dropphycty": "POMEROY",
    "dropphyst": "WA",
    "dropphyzpp": 993479998,
    "dropmaladd": "1076 MAIN ST",
    "dropmalcty": "POMEROY",
    "dropmalst": "WA",
    "dropmalzpp": 993479998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098433841,
    "dropsitcph": 5098433841,
    "dropfax": 5098431798
  },
  {
    "dcode": "D",
    "dropkey": "PZ17298",
    "droptype": "D",
    "dropname": "PORT ANGELES",
    "dropdeladd": "424 E 1ST ST",
    "dropdelcty": "PORT ANGELES",
    "dropdelst": "WA",
    "dropdelzpp": 983629998,
    "dropphyadd": "424 E 1ST ST",
    "dropphycty": "PORT ANGELES",
    "dropphyst": "WA",
    "dropphyzpp": 983629998,
    "dropmaladd": "424 E 1ST ST",
    "dropmalcty": "PORT ANGELES",
    "dropmalst": "WA",
    "dropmalzpp": 983629998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604177569,
    "dropsitcph": 3604177528,
    "dropfax": 6514566234
  },
  {
    "dcode": "D",
    "dropkey": "PZ17300",
    "droptype": "D",
    "dropname": "PORT GAMBLE",
    "dropdeladd": "4839 NE VIEW DR STE A",
    "dropdelcty": "PORT GAMBLE",
    "dropdelst": "WA",
    "dropdelzpp": 983649800,
    "dropphyadd": "4839 NE VIEW DR STE A",
    "dropphycty": "PORT GAMBLE",
    "dropphyst": "WA",
    "dropphyzpp": 983649800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT GAMBLE",
    "dropmalst": "WA",
    "dropmalzpp": 983649998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602973300,
    "dropsitcph": 3602973300,
    "dropfax": 3602973300
  },
  {
    "dcode": "D",
    "dropkey": "PZ17304",
    "droptype": "D",
    "dropname": "PORT ORCHARD",
    "dropdeladd": "1125 BETHEL AVE",
    "dropdelcty": "PORT ORCHARD",
    "dropdelst": "WA",
    "dropdelzpp": 983669998,
    "dropphyadd": "1125 BETHEL AVE",
    "dropphycty": "PORT ORCHARD",
    "dropphyst": "WA",
    "dropphyzpp": 983669998,
    "dropmaladd": "1125 BETHEL AVE",
    "dropmalcty": "PORT ORCHARD",
    "dropmalst": "WA",
    "dropmalzpp": 983669998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608950779,
    "dropsitcph": 3608746903,
    "dropfax": 6514566235
  },
  {
    "dcode": "D",
    "dropkey": "PZ17306",
    "droptype": "D",
    "dropname": "PORT TOWNSEND",
    "dropdeladd": "1322 WASHINGTON ST",
    "dropdelcty": "PORT TOWNSEND",
    "dropdelst": "WA",
    "dropdelzpp": 983689998,
    "dropphyadd": "1322 WASHINGTON ST",
    "dropphycty": "PORT TOWNSEND",
    "dropphyst": "WA",
    "dropphyzpp": 983689998,
    "dropmaladd": "1322 WASHINGTON ST",
    "dropmalcty": "PORT TOWNSEND",
    "dropmalst": "WA",
    "dropmalzpp": 983689998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603850922,
    "dropsitcph": 3603792996,
    "dropfax": 6514566236
  },
  {
    "dcode": "D",
    "dropkey": "PZ17308",
    "droptype": "D",
    "dropname": "POULSBO",
    "dropdeladd": "19240 JENSEN WAY NE",
    "dropdelcty": "POULSBO",
    "dropdelst": "WA",
    "dropdelzpp": 983706100,
    "dropphyadd": "19240 JENSEN WAY NE",
    "dropphycty": "POULSBO",
    "dropphyst": "WA",
    "dropphyzpp": 983706100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POULSBO",
    "dropmalst": "WA",
    "dropmalzpp": 983709998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607795585,
    "dropsitcph": 3607791353,
    "dropfax": 6514566503
  },
  {
    "dcode": "D",
    "dropkey": "PZ17311",
    "droptype": "D",
    "dropname": "PRESCOTT",
    "dropdeladd": "106 S D ST",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "WA",
    "dropdelzpp": 993489998,
    "dropphyadd": "106 S D ST",
    "dropphycty": "PRESCOTT",
    "dropphyst": "WA",
    "dropphyzpp": 993489998,
    "dropmaladd": "106 S D ST",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "WA",
    "dropmalzpp": 993489998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098492257,
    "dropsitcph": 5098492257,
    "dropfax": 5098492443
  },
  {
    "dcode": "D",
    "dropkey": "PZ17312",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "30405 SE 84TH ST",
    "dropdelcty": "PRESTON",
    "dropdelst": "WA",
    "dropdelzpp": 980509801,
    "dropphyadd": "30405 SE 84TH ST",
    "dropphycty": "PRESTON",
    "dropphyst": "WA",
    "dropphyzpp": 980509801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PRESTON",
    "dropmalst": "WA",
    "dropmalzpp": 980509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252227341,
    "dropsitcph": 4252225536,
    "dropfax": 4252220578
  },
  {
    "dcode": "D",
    "dropkey": "PZ17314",
    "droptype": "D",
    "dropname": "PROSSER",
    "dropdeladd": "1103 MEADE AVE",
    "dropdelcty": "PROSSER",
    "dropdelst": "WA",
    "dropdelzpp": 993509998,
    "dropphyadd": "1103 MEADE AVE",
    "dropphycty": "PROSSER",
    "dropphyst": "WA",
    "dropphyzpp": 993509998,
    "dropmaladd": "1103 MEADE AVE",
    "dropmalcty": "PROSSER",
    "dropmalst": "WA",
    "dropmalzpp": 993509998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097862639,
    "dropsitcph": 5097860264,
    "dropfax": 6514566239
  },
  {
    "dcode": "D",
    "dropkey": "PZ17332",
    "droptype": "D",
    "dropname": "PULLMAN",
    "dropdeladd": "1135 S GRAND AVE",
    "dropdelcty": "PULLMAN",
    "dropdelst": "WA",
    "dropdelzpp": 991639998,
    "dropphyadd": "1135 S GRAND AVE",
    "dropphycty": "PULLMAN",
    "dropphyst": "WA",
    "dropphyzpp": 991639998,
    "dropmaladd": "1135 S GRAND AVE",
    "dropmalcty": "PULLMAN",
    "dropmalst": "WA",
    "dropmalzpp": 991639998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093343605,
    "dropsitcph": 5093343093,
    "dropfax": 6514566240
  },
  {
    "dcode": "D",
    "dropkey": "PZ17335",
    "droptype": "D",
    "dropname": "PUYALLUP",
    "dropdeladd": "204 2ND ST SW",
    "dropdelcty": "PUYALLUP",
    "dropdelst": "WA",
    "dropdelzpp": 983715352,
    "dropphyadd": "204 2ND ST SW",
    "dropphycty": "PUYALLUP",
    "dropphyst": "WA",
    "dropphyzpp": 983715352,
    "dropmaladd": "13516 MERIDIAN E",
    "dropmalcty": "PUYALLUP",
    "dropmalst": "WA",
    "dropmalzpp": 983739997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538418853,
    "dropsitcph": 2534355146,
    "dropfax": 6514566500
  },
  {
    "dcode": "D",
    "dropkey": "PZ17341",
    "droptype": "D",
    "dropname": "QUILCENE",
    "dropdeladd": "294843 US HIGHWAY 101 STE 3",
    "dropdelcty": "QUILCENE",
    "dropdelst": "WA",
    "dropdelzpp": 983769804,
    "dropphyadd": "294843 US HIGHWAY 101 STE 3",
    "dropphycty": "QUILCENE",
    "dropphyst": "WA",
    "dropphyzpp": 983769804,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUILCENE",
    "dropmalst": "WA",
    "dropmalzpp": 983769998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607653760,
    "dropsitcph": 3607653760,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17342",
    "droptype": "D",
    "dropname": "QUINAULT",
    "dropdeladd": "518 S SHORE RD",
    "dropdelcty": "QUINAULT",
    "dropdelst": "WA",
    "dropdelzpp": 985759901,
    "dropphyadd": "518 S SHORE RD",
    "dropphycty": "QUINAULT",
    "dropphyst": "WA",
    "dropphyzpp": 985759901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "QUINAULT",
    "dropmalst": "WA",
    "dropmalzpp": 985759998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602882557,
    "dropsitcph": 3602882557,
    "dropfax": 6505776204
  },
  {
    "dcode": "D",
    "dropkey": "PZ17343",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "20 C ST SW",
    "dropdelcty": "QUINCY",
    "dropdelst": "WA",
    "dropdelzpp": 988489998,
    "dropphyadd": "20 C ST SW",
    "dropphycty": "QUINCY",
    "dropphyst": "WA",
    "dropphyzpp": 988489998,
    "dropmaladd": "20 C ST SW",
    "dropmalcty": "QUINCY",
    "dropmalst": "WA",
    "dropmalzpp": 988489998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097872613,
    "dropsitcph": 5097872613,
    "dropfax": 6514566242
  },
  {
    "dcode": "D",
    "dropkey": "PZ17346",
    "droptype": "D",
    "dropname": "RAINIER",
    "dropdeladd": "101 ROCHESTER ST W",
    "dropdelcty": "RAINIER",
    "dropdelst": "WA",
    "dropdelzpp": 985769900,
    "dropphyadd": "101 ROCHESTER ST W",
    "dropphycty": "RAINIER",
    "dropphyst": "WA",
    "dropphyzpp": 985769900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAINIER",
    "dropmalst": "WA",
    "dropmalzpp": 985769998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604462404,
    "dropsitcph": 3604462404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17347",
    "droptype": "D",
    "dropname": "RANDLE",
    "dropdeladd": "105 CHILCOAT AVE",
    "dropdelcty": "RANDLE",
    "dropdelst": "WA",
    "dropdelzpp": 983779800,
    "dropphyadd": "105 CHILCOAT AVE",
    "dropphycty": "RANDLE",
    "dropphyst": "WA",
    "dropphyzpp": 983779800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANDLE",
    "dropmalst": "WA",
    "dropmalzpp": 983779998,
    "dropsitphn": 3604922032,
    "dropsitlph": 3604922032,
    "dropsitcph": 3604922032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17349",
    "droptype": "D",
    "dropname": "RAVENSDALE",
    "dropdeladd": "27200 272ND AVE SE",
    "dropdelcty": "RAVENSDALE",
    "dropdelst": "WA",
    "dropdelzpp": 980518101,
    "dropphyadd": "27200 272ND AVE SE",
    "dropphycty": "RAVENSDALE",
    "dropphyst": "WA",
    "dropphyzpp": 980518101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAVENSDALE",
    "dropmalst": "WA",
    "dropmalzpp": 980519998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254324712,
    "dropsitcph": 4254324712,
    "dropfax": 6514566243
  },
  {
    "dcode": "D",
    "dropkey": "PZ17350",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "406 DURYEA ST",
    "dropdelcty": "RAYMOND",
    "dropdelst": "WA",
    "dropdelzpp": 985779998,
    "dropphyadd": "406 DURYEA ST",
    "dropphycty": "RAYMOND",
    "dropphyst": "WA",
    "dropphyzpp": 985779998,
    "dropmaladd": "406 DURYEA ST",
    "dropmalcty": "RAYMOND",
    "dropmalst": "WA",
    "dropmalzpp": 985779998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609425060,
    "dropsitcph": 3609425911,
    "dropfax": 6514566244
  },
  {
    "dcode": "D",
    "dropkey": "PZ17351",
    "droptype": "D",
    "dropname": "REARDAN",
    "dropdeladd": "155 S LAKE ST",
    "dropdelcty": "REARDAN",
    "dropdelst": "WA",
    "dropdelzpp": 990299998,
    "dropphyadd": "155 S LAKE ST",
    "dropphycty": "REARDAN",
    "dropphyst": "WA",
    "dropphyzpp": 990299998,
    "dropmaladd": "155 S LAKE ST",
    "dropmalcty": "REARDAN",
    "dropmalst": "WA",
    "dropmalzpp": 990299998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097963525,
    "dropsitcph": 5097963525,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17353",
    "droptype": "D",
    "dropname": "REDMOND",
    "dropdeladd": "7241 185TH AVE NE",
    "dropdelcty": "REDMOND",
    "dropdelst": "WA",
    "dropdelzpp": 980529998,
    "dropphyadd": "7241 185TH AVE NE",
    "dropphycty": "REDMOND",
    "dropphyst": "WA",
    "dropphyzpp": 980529998,
    "dropmaladd": "7241 185TH AVE NE",
    "dropmalcty": "REDMOND",
    "dropmalst": "WA",
    "dropmalzpp": 980529998,
    "dropsitphn": 4259561232,
    "dropsitlph": 4259561232,
    "dropsitcph": 4258693690,
    "dropfax": 4259561236
  },
  {
    "dcode": "D",
    "dropkey": "PZ17357",
    "droptype": "D",
    "dropname": "RENTON",
    "dropdeladd": "17200 116TH AVE SE",
    "dropdelcty": "RENTON",
    "dropdelst": "WA",
    "dropdelzpp": 980589998,
    "dropphyadd": "17200 116TH AVE SE",
    "dropphycty": "RENTON",
    "dropphyst": "WA",
    "dropphyzpp": 980589998,
    "dropmaladd": "17200 116TH AVE SE",
    "dropmalcty": "RENTON",
    "dropmalst": "WA",
    "dropmalzpp": 980589998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4255299779,
    "dropsitcph": 4252556389,
    "dropfax": 6514566247
  },
  {
    "dcode": "D",
    "dropkey": "PZ17359",
    "droptype": "D",
    "dropname": "REPUBLIC",
    "dropdeladd": "128 N CLARK ST",
    "dropdelcty": "REPUBLIC",
    "dropdelst": "WA",
    "dropdelzpp": 991669998,
    "dropphyadd": "128 N CLARK ST",
    "dropphycty": "REPUBLIC",
    "dropphyst": "WA",
    "dropphyzpp": 991669998,
    "dropmaladd": "128 N CLARK ST",
    "dropmalcty": "REPUBLIC",
    "dropmalst": "WA",
    "dropmalzpp": 991669998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5097753332,
    "dropsitcph": 5097753332,
    "dropfax": 5097752849
  },
  {
    "dcode": "D",
    "dropkey": "PZ17363",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "639 CULLUM AVE",
    "dropdelcty": "RICHLAND",
    "dropdelst": "WA",
    "dropdelzpp": 993524203,
    "dropphyadd": "639 CULLUM AVE",
    "dropphycty": "RICHLAND",
    "dropphyst": "WA",
    "dropphyzpp": 993524203,
    "dropmaladd": "639 CULLUM AVE",
    "dropmalcty": "RICHLAND",
    "dropmalst": "WA",
    "dropmalzpp": 993524203,
    "dropsitphn": 5099437531,
    "dropsitlph": 5099437531,
    "dropsitcph": 5099437531,
    "dropfax": 5099437532
  },
  {
    "dcode": "D",
    "dropkey": "PZ17367",
    "droptype": "D",
    "dropname": "RIDGEFIELD",
    "dropdeladd": "205 N MAIN AVE",
    "dropdelcty": "RIDGEFIELD",
    "dropdelst": "WA",
    "dropdelzpp": 986429394,
    "dropphyadd": "205 N MAIN AVE",
    "dropphycty": "RIDGEFIELD",
    "dropphyst": "WA",
    "dropphyzpp": 986429394,
    "dropmaladd": "205 N MAIN AVE",
    "dropmalcty": "RIDGEFIELD",
    "dropmalst": "WA",
    "dropmalzpp": 986429998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608870558,
    "dropsitcph": 3608872043,
    "dropfax": 3608871161
  },
  {
    "dcode": "D",
    "dropkey": "PZ17369",
    "droptype": "D",
    "dropname": "RITZVILLE",
    "dropdeladd": "210 N WASHINGTON ST",
    "dropdelcty": "RITZVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 991699998,
    "dropphyadd": "210 N WASHINGTON ST",
    "dropphycty": "RITZVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 991699998,
    "dropmaladd": "210 N WASHINGTON ST",
    "dropmalcty": "RITZVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 991699998,
    "dropsitphn": 5096590550,
    "dropsitlph": 5096590550,
    "dropsitcph": 5096590550,
    "dropfax": 6505774767
  },
  {
    "dcode": "D",
    "dropkey": "PZ17370",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "407 KENDALL ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "WA",
    "dropdelzpp": 988499800,
    "dropphyadd": "407 KENDALL ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "WA",
    "dropphyzpp": 988499800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "WA",
    "dropmalzpp": 988499998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098262110,
    "dropsitcph": 5098262110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17378",
    "droptype": "D",
    "dropname": "ROCHESTER",
    "dropdeladd": "9727 HIGHWAY 12 W",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "WA",
    "dropdelzpp": 985799904,
    "dropphyadd": "9727 HIGHWAY 12 W",
    "dropphycty": "ROCHESTER",
    "dropphyst": "WA",
    "dropphyzpp": 985799904,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "WA",
    "dropmalzpp": 985799998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602738609,
    "dropsitcph": 3602739281,
    "dropfax": 6516751618
  },
  {
    "dcode": "D",
    "dropkey": "PZ17379",
    "droptype": "D",
    "dropname": "ROCK ISLAND",
    "dropdeladd": "224 ROCK ISLAND DR",
    "dropdelcty": "ROCK ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 988509597,
    "dropphyadd": "224 ROCK ISLAND DR",
    "dropphycty": "ROCK ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 988509597,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCK ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 988509998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098842629,
    "dropsitcph": 5098842629,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17380",
    "droptype": "D",
    "dropname": "ROCKFORD",
    "dropdeladd": "36 W EMMA ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "WA",
    "dropdelzpp": 990309998,
    "dropphyadd": "36 W EMMA ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "WA",
    "dropphyzpp": 990309998,
    "dropmaladd": "36 W EMMA ST",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "WA",
    "dropmalzpp": 990309998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092913178,
    "dropsitcph": 5092913178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17382",
    "droptype": "D",
    "dropname": "ROCKPORT",
    "dropdeladd": "52779 RAILROAD AVE",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "WA",
    "dropdelzpp": 982839900,
    "dropphyadd": "52779 RAILROAD AVE",
    "dropphycty": "ROCKPORT",
    "dropphyst": "WA",
    "dropphyzpp": 982839900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "WA",
    "dropmalzpp": 982839998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608538201,
    "dropsitcph": 3608538201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17385",
    "droptype": "D",
    "dropname": "ROLLINGBAY",
    "dropdeladd": "10355 NE VALLEY RD",
    "dropdelcty": "ROLLINGBAY",
    "dropdelst": "WA",
    "dropdelzpp": 980610001,
    "dropphyadd": "10355 NE VALLEY RD",
    "dropphycty": "ROLLINGBAY",
    "dropphyst": "WA",
    "dropphyzpp": 980610001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROLLINGBAY",
    "dropmalst": "WA",
    "dropmalzpp": 980619998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2068423261,
    "dropsitcph": 2068423261,
    "dropfax": 2068423261
  },
  {
    "dcode": "D",
    "dropkey": "PZ17386",
    "droptype": "D",
    "dropname": "RONALD",
    "dropdeladd": "8291 STATE ROUTE 903",
    "dropdelcty": "RONALD",
    "dropdelst": "WA",
    "dropdelzpp": 989409800,
    "dropphyadd": "8291 STATE ROUTE 903",
    "dropphycty": "RONALD",
    "dropphyst": "WA",
    "dropphyzpp": 989409800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RONALD",
    "dropmalst": "WA",
    "dropmalzpp": 989409998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092605002,
    "dropsitcph": 5092605002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17387",
    "droptype": "D",
    "dropname": "ROOSEVELT",
    "dropdeladd": "222 FRONTAGE RD",
    "dropdelcty": "ROOSEVELT",
    "dropdelst": "WA",
    "dropdelzpp": 993569998,
    "dropphyadd": "222 FRONTAGE RD",
    "dropphycty": "ROOSEVELT",
    "dropphyst": "WA",
    "dropphyzpp": 993569998,
    "dropmaladd": "222 FRONTAGE RD",
    "dropmalcty": "ROOSEVELT",
    "dropmalst": "WA",
    "dropmalzpp": 993569998,
    "dropsitphn": 5093845677,
    "dropsitlph": 5094234280,
    "dropsitcph": 5093845677,
    "dropfax": 5093849437
  },
  {
    "dcode": "D",
    "dropkey": "PZ17388",
    "droptype": "D",
    "dropname": "ROSALIA",
    "dropdeladd": "511 S WHITMAN AVE",
    "dropdelcty": "ROSALIA",
    "dropdelst": "WA",
    "dropdelzpp": 991709998,
    "dropphyadd": "511 S WHITMAN AVE",
    "dropphycty": "ROSALIA",
    "dropphyst": "WA",
    "dropphyzpp": 991709998,
    "dropmaladd": "511 S WHITMAN AVE",
    "dropmalcty": "ROSALIA",
    "dropmalst": "WA",
    "dropmalzpp": 991709998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095233504,
    "dropsitcph": 5095233504,
    "dropfax": 6505784644
  },
  {
    "dcode": "D",
    "dropkey": "PZ17390",
    "droptype": "D",
    "dropname": "ROSBURG",
    "dropdeladd": "4182 STATE ROUTE 4 W",
    "dropdelcty": "ROSBURG",
    "dropdelst": "WA",
    "dropdelzpp": 986439606,
    "dropphyadd": "4182 STATE ROUTE 4 W",
    "dropphycty": "ROSBURG",
    "dropphyst": "WA",
    "dropphyzpp": 986439606,
    "dropmaladd": "4182 STATE ROUTE 4 W",
    "dropmalcty": "ROSBURG",
    "dropmalst": "WA",
    "dropmalzpp": 986439998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3604652418,
    "dropsitcph": 3604652418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17394",
    "droptype": "D",
    "dropname": "ROSLYN",
    "dropdeladd": "122 W PENNSYLVANIA AVE",
    "dropdelcty": "ROSLYN",
    "dropdelst": "WA",
    "dropdelzpp": 989419990,
    "dropphyadd": "122 W PENNSYLVANIA AVE",
    "dropphycty": "ROSLYN",
    "dropphyst": "WA",
    "dropphyzpp": 989419990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROSLYN",
    "dropmalst": "WA",
    "dropmalzpp": 989419998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092063937,
    "dropsitcph": 5092603937,
    "dropfax": 5096493288
  },
  {
    "dcode": "D",
    "dropkey": "PZ17395",
    "droptype": "D",
    "dropname": "ROY",
    "dropdeladd": "202 N LYLE ST",
    "dropdelcty": "ROY",
    "dropdelst": "WA",
    "dropdelzpp": 985809902,
    "dropphyadd": "202 N LYLE ST",
    "dropphycty": "ROY",
    "dropphyst": "WA",
    "dropphyzpp": 985809902,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROY",
    "dropmalst": "WA",
    "dropmalzpp": 985809998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538432288,
    "dropsitcph": 2538432288,
    "dropfax": 6516751689
  },
  {
    "dcode": "D",
    "dropkey": "PZ17396",
    "droptype": "D",
    "dropname": "ROYAL CITY",
    "dropdeladd": "132 EVERGREEN AVE NW",
    "dropdelcty": "ROYAL CITY",
    "dropdelst": "WA",
    "dropdelzpp": 993579998,
    "dropphyadd": "132 EVERGREEN AVE NW",
    "dropphycty": "ROYAL CITY",
    "dropphyst": "WA",
    "dropphyzpp": 993579998,
    "dropmaladd": "132 EVERGREEN AVE NW",
    "dropmalcty": "ROYAL CITY",
    "dropmalst": "WA",
    "dropmalzpp": 993579998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093462241,
    "dropsitcph": 5093462241,
    "dropfax": 6514566251
  },
  {
    "dcode": "D",
    "dropkey": "PZ17400",
    "droptype": "D",
    "dropname": "RYDERWOOD",
    "dropdeladd": "210 MORSE ST",
    "dropdelcty": "RYDERWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 985819998,
    "dropphyadd": "210 MORSE ST",
    "dropphycty": "RYDERWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 985819998,
    "dropmaladd": "210 MORSE ST",
    "dropmalcty": "RYDERWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 985819998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602953562,
    "dropsitcph": 3602953562,
    "dropfax": 3602953082
  },
  {
    "dcode": "D",
    "dropkey": "PZ17406",
    "droptype": "D",
    "dropname": "SAINT JOHN",
    "dropdeladd": "5 N PARK ST",
    "dropdelcty": "SAINT JOHN",
    "dropdelst": "WA",
    "dropdelzpp": 991719998,
    "dropphyadd": "5 N PARK ST",
    "dropphycty": "SAINT JOHN",
    "dropphyst": "WA",
    "dropphyzpp": 991719998,
    "dropmaladd": "5 N PARK ST",
    "dropmalcty": "SAINT JOHN",
    "dropmalst": "WA",
    "dropmalzpp": 991719998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096483280,
    "dropsitcph": 5096483280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17408",
    "droptype": "D",
    "dropname": "SALKUM",
    "dropdeladd": "142 SALKUM RD",
    "dropdelcty": "SALKUM",
    "dropdelst": "WA",
    "dropdelzpp": 985829900,
    "dropphyadd": "142 SALKUM RD",
    "dropphycty": "SALKUM",
    "dropphyst": "WA",
    "dropphyzpp": 985829900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SALKUM",
    "dropmalst": "WA",
    "dropmalzpp": 985829998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609852550,
    "dropsitcph": 3609852550,
    "dropfax": 3609850848
  },
  {
    "dcode": "D",
    "dropkey": "PZ17415",
    "droptype": "D",
    "dropname": "SATSOP",
    "dropdeladd": "102 S 5TH ST",
    "dropdelcty": "SATSOP",
    "dropdelst": "WA",
    "dropdelzpp": 985839900,
    "dropphyadd": "102 S 5TH ST",
    "dropphycty": "SATSOP",
    "dropphyst": "WA",
    "dropphyzpp": 985839900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SATSOP",
    "dropmalst": "WA",
    "dropmalzpp": 985839998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604823432,
    "dropsitcph": 3604823432,
    "dropfax": 3604823432
  },
  {
    "dcode": "D",
    "dropkey": "PZ17421",
    "droptype": "D",
    "dropname": "SEABECK",
    "dropdeladd": "4691 SEABECK HOLLY RD NW",
    "dropdelcty": "SEABECK",
    "dropdelst": "WA",
    "dropdelzpp": 983809800,
    "dropphyadd": "4691 SEABECK HOLLY RD NW",
    "dropphycty": "SEABECK",
    "dropphyst": "WA",
    "dropphyzpp": 983809800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEABECK",
    "dropmalst": "WA",
    "dropmalzpp": 983809998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608304996,
    "dropsitcph": 3608305215,
    "dropfax": 6513659700
  },
  {
    "dcode": "D",
    "dropkey": "PZ17423",
    "droptype": "D",
    "dropname": "SEAHURST",
    "dropdeladd": "2116 SW 152ND ST",
    "dropdelcty": "BURIEN",
    "dropdelst": "WA",
    "dropdelzpp": 981662027,
    "dropphyadd": "2116 SW 152ND ST",
    "dropphycty": "SEAHURST",
    "dropphyst": "WA",
    "dropphyzpp": 980620001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEAHURST",
    "dropmalst": "WA",
    "dropmalzpp": 980629998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062446947,
    "dropsitcph": 2062446947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17429",
    "droptype": "D",
    "dropname": "SEATTLE",
    "dropdeladd": "2460 4TH AVE S",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981341924,
    "dropphyadd": "2460 4TH AVE S",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981341924,
    "dropmaladd": "PO BOX 3998",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981243998,
    "dropsitphn": 2067684422,
    "dropsitlph": "",
    "dropsitcph": 2063816640,
    "dropfax": 2063816649
  },
  {
    "dcode": "D",
    "dropkey": "PZ17434",
    "droptype": "D",
    "dropname": "SEAVIEW",
    "dropdeladd": "4006 PACIFIC HWY",
    "dropdelcty": "SEAVIEW",
    "dropdelst": "WA",
    "dropdelzpp": 986449898,
    "dropphyadd": "4006 PACIFIC HWY",
    "dropphycty": "SEAVIEW",
    "dropphyst": "WA",
    "dropphyzpp": 986449898,
    "dropmaladd": "4006 PACIFIC HWY",
    "dropmalcty": "SEAVIEW",
    "dropmalst": "WA",
    "dropmalzpp": 986449998,
    "dropsitphn": 3606423984,
    "dropsitlph": 3606423857,
    "dropsitcph": 3606423857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17435",
    "droptype": "D",
    "dropname": "SEDRO WOOLLEY",
    "dropdeladd": "111 WOODWORTH ST",
    "dropdelcty": "SEDRO WOOLLEY",
    "dropdelst": "WA",
    "dropdelzpp": 982849998,
    "dropphyadd": "111 WOODWORTH ST",
    "dropphycty": "SEDRO WOOLLEY",
    "dropphyst": "WA",
    "dropphyzpp": 982849998,
    "dropmaladd": "111 WOODWORTH ST",
    "dropmalcty": "SEDRO WOOLLEY",
    "dropmalst": "WA",
    "dropmalzpp": 982849998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608552392,
    "dropsitcph": 3608550545,
    "dropfax": 6514566255
  },
  {
    "dcode": "D",
    "dropkey": "PZ17436",
    "droptype": "D",
    "dropname": "SEKIU",
    "dropdeladd": "72 WASHINGTON ST",
    "dropdelcty": "SEKIU",
    "dropdelst": "WA",
    "dropdelzpp": 983819800,
    "dropphyadd": "72 WASHINGTON ST",
    "dropphycty": "SEKIU",
    "dropphyst": "WA",
    "dropphyzpp": 983819800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEKIU",
    "dropmalst": "WA",
    "dropmalzpp": 983819998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609632510,
    "dropsitcph": 3609632510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17437",
    "droptype": "D",
    "dropname": "SELAH",
    "dropdeladd": "114 E NACHES AVE",
    "dropdelcty": "SELAH",
    "dropdelst": "WA",
    "dropdelzpp": 989429998,
    "dropphyadd": "114 E NACHES AVE",
    "dropphycty": "SELAH",
    "dropphyst": "WA",
    "dropphyzpp": 989429998,
    "dropmaladd": "114 E NACHES AVE",
    "dropmalcty": "SELAH",
    "dropmalst": "WA",
    "dropmalzpp": 989429998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096983401,
    "dropsitcph": 5096983401,
    "dropfax": 6514566256
  },
  {
    "dcode": "D",
    "dropkey": "PZ17438",
    "droptype": "D",
    "dropname": "SEQUIM",
    "dropdeladd": "240 S SUNNYSIDE AVE",
    "dropdelcty": "SEQUIM",
    "dropdelst": "WA",
    "dropdelzpp": 983829998,
    "dropphyadd": "240 S SUNNYSIDE AVE",
    "dropphycty": "SEQUIM",
    "dropphyst": "WA",
    "dropphyzpp": 983829998,
    "dropmaladd": "240 S SUNNYSIDE AVE",
    "dropmalcty": "SEQUIM",
    "dropmalst": "WA",
    "dropmalzpp": 983829998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606810785,
    "dropsitcph": 3606817833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17441",
    "droptype": "D",
    "dropname": "SHAW ISLAND",
    "dropdeladd": "35 BLIND BAY RD",
    "dropdelcty": "SHAW ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 982869996,
    "dropphyadd": "35 BLIND BAY RD",
    "dropphycty": "SHAW ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 982869996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHAW ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 982869998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604682157,
    "dropsitcph": 3604682157,
    "dropfax": 3604682157
  },
  {
    "dcode": "D",
    "dropkey": "PZ17442",
    "droptype": "D",
    "dropname": "SHELTON",
    "dropdeladd": "218 MARK E REED WAY UNIT MAIN",
    "dropdelcty": "SHELTON",
    "dropdelst": "WA",
    "dropdelzpp": 985849998,
    "dropphyadd": "218 MARK E REED WAY UNIT MAIN",
    "dropphycty": "SHELTON",
    "dropphyst": "WA",
    "dropphyzpp": 985849998,
    "dropmaladd": "218 MARK E REED WAY UNIT MAIN",
    "dropmalcty": "SHELTON",
    "dropmalst": "WA",
    "dropmalzpp": 985849998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604264291,
    "dropsitcph": 3604261476,
    "dropfax": 6514566259
  },
  {
    "dcode": "D",
    "dropkey": "PZ17449",
    "droptype": "D",
    "dropname": "SILVANA",
    "dropdeladd": "1501 PIONEER HWY",
    "dropdelcty": "SILVANA",
    "dropdelst": "WA",
    "dropdelzpp": 982879800,
    "dropphyadd": "1501 PIONEER HWY",
    "dropphycty": "SILVANA",
    "dropphyst": "WA",
    "dropphyzpp": 982879800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVANA",
    "dropmalst": "WA",
    "dropmalzpp": 982879998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606527154,
    "dropsitcph": 3606527154,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17451",
    "droptype": "D",
    "dropname": "SILVER CREEK",
    "dropdeladd": "140 GERSHICK RD",
    "dropdelcty": "SILVER CREEK",
    "dropdelst": "WA",
    "dropdelzpp": 985859901,
    "dropphyadd": "140 GERSHICK RD",
    "dropphycty": "SILVER CREEK",
    "dropphyst": "WA",
    "dropphyzpp": 985859901,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVER CREEK",
    "dropmalst": "WA",
    "dropmalzpp": 985859998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609852607,
    "dropsitcph": 3609852607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17455",
    "droptype": "D",
    "dropname": "SILVERDALE",
    "dropdeladd": "10855 SILVERDALE WAY NW",
    "dropdelcty": "SILVERDALE",
    "dropdelst": "WA",
    "dropdelzpp": 983839998,
    "dropphyadd": "10855 SILVERDALE WAY NW",
    "dropphycty": "SILVERDALE",
    "dropphyst": "WA",
    "dropphyzpp": 983839998,
    "dropmaladd": "10855 SILVERDALE WAY NW",
    "dropmalcty": "SILVERDALE",
    "dropmalst": "WA",
    "dropmalzpp": 983839998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606924760,
    "dropsitcph": 3603080301,
    "dropfax": 6514566261
  },
  {
    "dcode": "D",
    "dropkey": "PZ17459",
    "droptype": "D",
    "dropname": "SKAMOKAWA",
    "dropdeladd": "1391 W STATE ROUTE 4",
    "dropdelcty": "SKAMOKAWA",
    "dropdelst": "WA",
    "dropdelzpp": 986479740,
    "dropphyadd": "1391 W STATE ROUTE 4",
    "dropphycty": "SKAMOKAWA",
    "dropphyst": "WA",
    "dropphyzpp": 986479740,
    "dropmaladd": "1391 W STATE ROUTE 4",
    "dropmalcty": "SKAMOKAWA",
    "dropmalst": "WA",
    "dropmalzpp": 986479998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3607958731,
    "dropsitcph": 3607958731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17460",
    "droptype": "D",
    "dropname": "SKYKOMISH",
    "dropdeladd": "108 THELMA ST",
    "dropdelcty": "SKYKOMISH",
    "dropdelst": "WA",
    "dropdelzpp": 982889801,
    "dropphyadd": "108 THELMA ST",
    "dropphycty": "SKYKOMISH",
    "dropphyst": "WA",
    "dropphyzpp": 982889801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKYKOMISH",
    "dropmalst": "WA",
    "dropmalzpp": 982889998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606772241,
    "dropsitcph": 3606772241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17465",
    "droptype": "D",
    "dropname": "SNOHOMISH",
    "dropdeladd": "1323 AVENUE D",
    "dropdelcty": "SNOHOMISH",
    "dropdelst": "WA",
    "dropdelzpp": 982909998,
    "dropphyadd": "1323 AVENUE D",
    "dropphycty": "SNOHOMISH",
    "dropphyst": "WA",
    "dropphyzpp": 982909998,
    "dropmaladd": "1323 AVENUE D",
    "dropmalcty": "SNOHOMISH",
    "dropmalst": "WA",
    "dropmalzpp": 982909998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605688955,
    "dropsitcph": 3605680904,
    "dropfax": 6514566265
  },
  {
    "dcode": "D",
    "dropkey": "PZ17466",
    "droptype": "D",
    "dropname": "SNOQUALMIE",
    "dropdeladd": "8264 OLMSTEAD LN SE",
    "dropdelcty": "SNOQUALMIE",
    "dropdelst": "WA",
    "dropdelzpp": 980650316,
    "dropphyadd": "8264 OLMSTEAD LN SE",
    "dropphycty": "SNOQUALMIE",
    "dropphyst": "WA",
    "dropphyzpp": 980650316,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SNOQUALMIE",
    "dropmalst": "WA",
    "dropmalzpp": 980659998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4258884317,
    "dropsitcph": 4258884317,
    "dropfax": 4258883015
  },
  {
    "dcode": "D",
    "dropkey": "PZ17472",
    "droptype": "D",
    "dropname": "SOAP LAKE",
    "dropdeladd": "511 S DIVISION ST",
    "dropdelcty": "SOAP LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 988519791,
    "dropphyadd": "511 S DIVISION ST",
    "dropphycty": "SOAP LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 988519791,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOAP LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 988519998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092461641,
    "dropsitcph": 5092461641,
    "dropfax": 6505774610
  },
  {
    "dcode": "D",
    "dropkey": "PZ17476",
    "droptype": "D",
    "dropname": "SOUTH BEND",
    "dropdeladd": "120 CENTRAL AVE",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "WA",
    "dropdelzpp": 985869906,
    "dropphyadd": "120 CENTRAL AVE",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "WA",
    "dropphyzpp": 985869906,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "WA",
    "dropmalzpp": 985869998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608755201,
    "dropsitcph": 3608755201,
    "dropfax": 3608755346
  },
  {
    "dcode": "D",
    "dropkey": "PZ17478",
    "droptype": "D",
    "dropname": "SOUTH CLE ELUM",
    "dropdeladd": "604 CLEVELAND AVE",
    "dropdelcty": "SOUTH CLE ELUM",
    "dropdelst": "WA",
    "dropdelzpp": 989439800,
    "dropphyadd": "604 CLEVELAND AVE",
    "dropphycty": "SOUTH CLE ELUM",
    "dropphyst": "WA",
    "dropphyzpp": 989439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH CLE ELUM",
    "dropmalst": "WA",
    "dropmalzpp": 989439998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096742611,
    "dropsitcph": 5096742611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17479",
    "droptype": "D",
    "dropname": "SOUTH COLBY",
    "dropdeladd": "9650 SE SOUTHWORTH DR",
    "dropdelcty": "SOUTH COLBY",
    "dropdelst": "WA",
    "dropdelzpp": 983849800,
    "dropphyadd": "9650 SE SOUTHWORTH DR",
    "dropphycty": "SOUTH COLBY",
    "dropphyst": "WA",
    "dropphyzpp": 983849800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH COLBY",
    "dropmalst": "WA",
    "dropmalzpp": 983849998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608712128,
    "dropsitcph": 3608710311,
    "dropfax": 3608712128
  },
  {
    "dcode": "D",
    "dropkey": "PZ17484",
    "droptype": "D",
    "dropname": "SOUTH PRAIRIE",
    "dropdeladd": "105 HIGHWAY 162 E",
    "dropdelcty": "SOUTH PRAIRIE",
    "dropdelst": "WA",
    "dropdelzpp": 983859800,
    "dropphyadd": "105 HIGHWAY 162 E",
    "dropphycty": "SOUTH PRAIRIE",
    "dropphyst": "WA",
    "dropphyzpp": 983859800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOUTH PRAIRIE",
    "dropmalst": "WA",
    "dropmalzpp": 983859998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608978828,
    "dropsitcph": 3608978828,
    "dropfax": 3608979980
  },
  {
    "dcode": "D",
    "dropkey": "PZ17487",
    "droptype": "D",
    "dropname": "SOUTHWORTH",
    "dropdeladd": "3985 CHERRY ST SE",
    "dropdelcty": "SOUTHWORTH",
    "dropdelst": "WA",
    "dropdelzpp": 983869998,
    "dropphyadd": "3985 CHERRY ST SE",
    "dropphycty": "SOUTHWORTH",
    "dropphyst": "WA",
    "dropphyzpp": 983869998,
    "dropmaladd": "3985 CHERRY ST SE",
    "dropmalcty": "SOUTHWORTH",
    "dropmalst": "WA",
    "dropmalzpp": 983869998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608712339,
    "dropsitcph": 3608712339,
    "dropfax": 6503576408
  },
  {
    "dcode": "D",
    "dropkey": "PZ17488",
    "droptype": "D",
    "dropname": "SPANAWAY",
    "dropdeladd": "16815 PACIFIC AVE S",
    "dropdelcty": "SPANAWAY",
    "dropdelst": "WA",
    "dropdelzpp": 983879997,
    "dropphyadd": "16815 PACIFIC AVE S",
    "dropphycty": "SPANAWAY",
    "dropphyst": "WA",
    "dropphyzpp": 983879997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SPANAWAY",
    "dropmalst": "WA",
    "dropmalzpp": 983879998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2535369731,
    "dropsitcph": 2535369687,
    "dropfax": 6514566267
  },
  {
    "dcode": "D",
    "dropkey": "PZ17489",
    "droptype": "D",
    "dropname": "SPANGLE",
    "dropdeladd": "230 N MAIN AVE",
    "dropdelcty": "SPANGLE",
    "dropdelst": "WA",
    "dropdelzpp": 990319998,
    "dropphyadd": "230 N MAIN AVE",
    "dropphycty": "SPANGLE",
    "dropphyst": "WA",
    "dropphyzpp": 990319998,
    "dropmaladd": "230 N MAIN AVE",
    "dropmalcty": "SPANGLE",
    "dropmalst": "WA",
    "dropmalzpp": 990319998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092453272,
    "dropsitcph": 5092453272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17491",
    "droptype": "D",
    "dropname": "SPOKANE",
    "dropdeladd": "904 W RIVERSIDE AVE",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992011007,
    "dropphyadd": "904 W RIVERSIDE AVE",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992011007,
    "dropmaladd": "904 W RIVERSIDE AVE",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992011007,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096266859,
    "dropsitcph": 5092522337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17494",
    "droptype": "D",
    "dropname": "SPRAGUE",
    "dropdeladd": "319 W 1ST ST",
    "dropdelcty": "SPRAGUE",
    "dropdelst": "WA",
    "dropdelzpp": 990329998,
    "dropphyadd": "319 W 1ST ST",
    "dropphycty": "SPRAGUE",
    "dropphyst": "WA",
    "dropphyzpp": 990329998,
    "dropmaladd": "319 W 1ST ST",
    "dropmalcty": "SPRAGUE",
    "dropmalst": "WA",
    "dropmalzpp": 990329998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092572269,
    "dropsitcph": 5092572269,
    "dropfax": 5092572305
  },
  {
    "dcode": "D",
    "dropkey": "PZ17496",
    "droptype": "D",
    "dropname": "SPRINGDALE",
    "dropdeladd": "113 S MAIN ST",
    "dropdelcty": "SPRINGDALE",
    "dropdelst": "WA",
    "dropdelzpp": 991739998,
    "dropphyadd": "113 S MAIN ST",
    "dropphycty": "SPRINGDALE",
    "dropphyst": "WA",
    "dropphyzpp": 991739998,
    "dropmaladd": "113 S MAIN ST",
    "dropmalcty": "SPRINGDALE",
    "dropmalst": "WA",
    "dropmalzpp": 991739998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092584507,
    "dropsitcph": 5092584507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17571",
    "droptype": "D",
    "dropname": "STANWOOD",
    "dropdeladd": "9229 271ST ST NW",
    "dropdelcty": "STANWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 982929813,
    "dropphyadd": "9229 271ST ST NW",
    "dropphycty": "STANWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 982929813,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STANWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 982929998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606293797,
    "dropsitcph": 3606293189,
    "dropfax": 6514566269
  },
  {
    "dcode": "D",
    "dropkey": "PZ17572",
    "droptype": "D",
    "dropname": "STARBUCK",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "STARBUCK",
    "dropdelst": "WA",
    "dropdelzpp": 993599998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "STARBUCK",
    "dropphyst": "WA",
    "dropphyzpp": 993599998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "STARBUCK",
    "dropmalst": "WA",
    "dropmalzpp": 993599998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093992224,
    "dropsitcph": 5093992224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17573",
    "droptype": "D",
    "dropname": "STARTUP",
    "dropdeladd": "36513 STATE ROUTE 2",
    "dropdelcty": "STARTUP",
    "dropdelst": "WA",
    "dropdelzpp": 982939800,
    "dropphyadd": "36513 STATE ROUTE 2",
    "dropphycty": "STARTUP",
    "dropphyst": "WA",
    "dropphyzpp": 982939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STARTUP",
    "dropmalst": "WA",
    "dropmalzpp": 982939998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607931606,
    "dropsitcph": 3607931606,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17575",
    "droptype": "D",
    "dropname": "STEHEKIN",
    "dropdeladd": "31 DEFACTO LN",
    "dropdelcty": "STEHEKIN",
    "dropdelst": "WA",
    "dropdelzpp": 988529801,
    "dropphyadd": "31 DEFACTO LN",
    "dropphycty": "STEHEKIN",
    "dropphyst": "WA",
    "dropphyzpp": 988529801,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STEHEKIN",
    "dropmalst": "WA",
    "dropmalzpp": 988529998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096992015,
    "dropsitcph": 5096992015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17578",
    "droptype": "D",
    "dropname": "STEVENSON",
    "dropdeladd": "90 SW RUSSELL AVE",
    "dropdelcty": "STEVENSON",
    "dropdelst": "WA",
    "dropdelzpp": 986489198,
    "dropphyadd": "90 SW RUSSELL AVE",
    "dropphycty": "STEVENSON",
    "dropphyst": "WA",
    "dropphyzpp": 986489198,
    "dropmaladd": "90 SW RUSSELL AVE",
    "dropmalcty": "STEVENSON",
    "dropmalst": "WA",
    "dropmalzpp": 986489998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094275523,
    "dropsitcph": 5094275532,
    "dropfax": 5094277949
  },
  {
    "dcode": "D",
    "dropkey": "PZ17582",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "9800 ROAD 23 NE",
    "dropdelcty": "STRATFORD",
    "dropdelst": "WA",
    "dropdelzpp": 988539800,
    "dropphyadd": "9800 ROAD 23 NE",
    "dropphycty": "STRATFORD",
    "dropphyst": "WA",
    "dropphyzpp": 988539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "STRATFORD",
    "dropmalst": "WA",
    "dropmalzpp": 988539998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5093450104,
    "dropsitcph": 5093450104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17584",
    "droptype": "D",
    "dropname": "SULTAN",
    "dropdeladd": "4 4TH ST",
    "dropdelcty": "SULTAN",
    "dropdelst": "WA",
    "dropdelzpp": 982949997,
    "dropphyadd": "4 4TH ST",
    "dropphycty": "SULTAN",
    "dropphyst": "WA",
    "dropphyzpp": 982949997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SULTAN",
    "dropmalst": "WA",
    "dropmalzpp": 982949998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607933634,
    "dropsitcph": 3607931444,
    "dropfax": 6505776140
  },
  {
    "dcode": "D",
    "dropkey": "PZ17586",
    "droptype": "D",
    "dropname": "SUMAS",
    "dropdeladd": "534 RAILROAD AVE",
    "dropdelcty": "SUMAS",
    "dropdelst": "WA",
    "dropdelzpp": 982959900,
    "dropphyadd": "534 RAILROAD AVE",
    "dropphycty": "SUMAS",
    "dropphyst": "WA",
    "dropphyzpp": 982959900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMAS",
    "dropmalst": "WA",
    "dropmalzpp": 982959998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609886212,
    "dropsitcph": 3609882613,
    "dropfax": 6513066548
  },
  {
    "dcode": "D",
    "dropkey": "PZ17588",
    "droptype": "D",
    "dropname": "SUMNER",
    "dropdeladd": "1313 FRYAR AVE",
    "dropdelcty": "SUMNER",
    "dropdelst": "WA",
    "dropdelzpp": 983909998,
    "dropphyadd": "1313 FRYAR AVE",
    "dropphycty": "SUMNER",
    "dropphyst": "WA",
    "dropphyzpp": 983909998,
    "dropmaladd": "1313 FRYAR AVE",
    "dropmalcty": "SUMNER",
    "dropmalst": "WA",
    "dropmalzpp": 983909998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538919601,
    "dropsitcph": 2538919601,
    "dropfax": 6514566271
  },
  {
    "dcode": "D",
    "dropkey": "PZ17590",
    "droptype": "D",
    "dropname": "SUNNYSIDE",
    "dropdeladd": "713 E EDISON AVE",
    "dropdelcty": "SUNNYSIDE",
    "dropdelst": "WA",
    "dropdelzpp": 989449998,
    "dropphyadd": "713 E EDISON AVE",
    "dropphycty": "SUNNYSIDE",
    "dropphyst": "WA",
    "dropphyzpp": 989449998,
    "dropmaladd": "770 CUSTER AVE",
    "dropmalcty": "SUNNYSIDE",
    "dropmalst": "WA",
    "dropmalzpp": 989449997,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098375039,
    "dropsitcph": 5098375039,
    "dropfax": 5098372557
  },
  {
    "dcode": "D",
    "dropkey": "PZ17593",
    "droptype": "D",
    "dropname": "SUQUAMISH",
    "dropdeladd": "18485 AUGUSTA AVE NE",
    "dropdelcty": "SUQUAMISH",
    "dropdelst": "WA",
    "dropdelzpp": 983929997,
    "dropphyadd": "18485 AUGUSTA AVE NE",
    "dropphycty": "SUQUAMISH",
    "dropphyst": "WA",
    "dropphyzpp": 983929997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUQUAMISH",
    "dropmalst": "WA",
    "dropmalzpp": 983929998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605984200,
    "dropsitcph": 3605984200,
    "dropfax": 6513066135
  },
  {
    "dcode": "D",
    "dropkey": "PZ17597",
    "droptype": "D",
    "dropname": "TACOMA",
    "dropdeladd": "4001 S PINE ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984139998,
    "dropphyadd": "4001 S PINE ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984139998,
    "dropmaladd": "4001 S PINE ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984139998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2534716003,
    "dropsitcph": 2534716028,
    "dropfax": 2534716008
  },
  {
    "dcode": "D",
    "dropkey": "PZ17600",
    "droptype": "D",
    "dropname": "TAHOLAH",
    "dropdeladd": "142 W QUINAULT ST",
    "dropdelcty": "TAHOLAH",
    "dropdelst": "WA",
    "dropdelzpp": 985879900,
    "dropphyadd": "142 W QUINAULT ST",
    "dropphycty": "TAHOLAH",
    "dropphyst": "WA",
    "dropphyzpp": 985879900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAHOLAH",
    "dropmalst": "WA",
    "dropmalzpp": 985879998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602761379,
    "dropsitcph": 3602761379,
    "dropfax": 3602764284
  },
  {
    "dcode": "D",
    "dropkey": "PZ17601",
    "droptype": "D",
    "dropname": "TAHUYA",
    "dropdeladd": "14850 NE NORTH SHORE RD",
    "dropdelcty": "TAHUYA",
    "dropdelst": "WA",
    "dropdelzpp": 985889998,
    "dropphyadd": "14850 NE NORTH SHORE RD",
    "dropphycty": "TAHUYA",
    "dropphyst": "WA",
    "dropphyzpp": 985889998,
    "dropmaladd": "14850 NE NORTH SHORE RD",
    "dropmalcty": "TAHUYA",
    "dropmalst": "WA",
    "dropmalzpp": 985889998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602753309,
    "dropsitcph": 3602753309,
    "dropfax": 3602756803
  },
  {
    "dcode": "D",
    "dropkey": "PZ17608",
    "droptype": "D",
    "dropname": "TEKOA",
    "dropdeladd": "101 S CROSBY ST",
    "dropdelcty": "TEKOA",
    "dropdelst": "WA",
    "dropdelzpp": 990339998,
    "dropphyadd": "101 S CROSBY ST",
    "dropphycty": "TEKOA",
    "dropphyst": "WA",
    "dropphyzpp": 990339998,
    "dropmaladd": "101 S CROSBY ST",
    "dropmalcty": "TEKOA",
    "dropmalst": "WA",
    "dropmalzpp": 990339998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092840021,
    "dropsitcph": 5092840021,
    "dropfax": 6505784675
  },
  {
    "dcode": "D",
    "dropkey": "PZ17610",
    "droptype": "D",
    "dropname": "TENINO",
    "dropdeladd": "124 SUSSEX AVE W",
    "dropdelcty": "TENINO",
    "dropdelst": "WA",
    "dropdelzpp": 985898401,
    "dropphyadd": "124 SUSSEX AVE W",
    "dropphycty": "TENINO",
    "dropphyst": "WA",
    "dropphyzpp": 985898401,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TENINO",
    "dropmalst": "WA",
    "dropmalzpp": 985899998,
    "dropsitphn": 3608072144,
    "dropsitlph": 3602621140,
    "dropsitcph": 3602621140,
    "dropfax": 3602642735
  },
  {
    "dcode": "D",
    "dropkey": "PZ17616",
    "droptype": "D",
    "dropname": "THORP",
    "dropdeladd": "50 1ST ST",
    "dropdelcty": "THORP",
    "dropdelst": "WA",
    "dropdelzpp": 989469580,
    "dropphyadd": "50 1ST ST",
    "dropphycty": "THORP",
    "dropphyst": "WA",
    "dropphyzpp": 989469580,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "THORP",
    "dropmalst": "WA",
    "dropmalzpp": 989469998,
    "dropsitphn": 5099642281,
    "dropsitlph": 5099642281,
    "dropsitcph": 5099642281,
    "dropfax": 6505784647
  },
  {
    "dcode": "D",
    "dropkey": "PZ17621",
    "droptype": "D",
    "dropname": "TIETON",
    "dropdeladd": "814 WISCONSIN ST",
    "dropdelcty": "TIETON",
    "dropdelst": "WA",
    "dropdelzpp": 989479800,
    "dropphyadd": "814 WISCONSIN ST",
    "dropphycty": "TIETON",
    "dropphyst": "WA",
    "dropphyzpp": 989479800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TIETON",
    "dropmalst": "WA",
    "dropmalzpp": 989479998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096734811,
    "dropsitcph": 5096734811,
    "dropfax": 5096732705
  },
  {
    "dcode": "D",
    "dropkey": "PZ17624",
    "droptype": "D",
    "dropname": "TOKELAND",
    "dropdeladd": "2405 TOKELAND RD",
    "dropdelcty": "TOKELAND",
    "dropdelst": "WA",
    "dropdelzpp": 985909900,
    "dropphyadd": "2405 TOKELAND RD",
    "dropphycty": "TOKELAND",
    "dropphyst": "WA",
    "dropphyzpp": 985909900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOKELAND",
    "dropmalst": "WA",
    "dropmalzpp": 985909998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602671498,
    "dropsitcph": 3602671498,
    "dropfax": 3602670186
  },
  {
    "dcode": "D",
    "dropkey": "PZ17625",
    "droptype": "D",
    "dropname": "TOLEDO",
    "dropdeladd": "202 COWLITZ ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "WA",
    "dropdelzpp": 985919900,
    "dropphyadd": "202 COWLITZ ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "WA",
    "dropphyzpp": 985919900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TOLEDO",
    "dropmalst": "WA",
    "dropmalzpp": 985919998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608642206,
    "dropsitcph": 3608642206,
    "dropfax": 3608642203
  },
  {
    "dcode": "D",
    "dropkey": "PZ17626",
    "droptype": "D",
    "dropname": "TONASKET",
    "dropdeladd": "15 W 5TH ST",
    "dropdelcty": "TONASKET",
    "dropdelst": "WA",
    "dropdelzpp": 988558826,
    "dropphyadd": "15 W 5TH ST",
    "dropphycty": "TONASKET",
    "dropphyst": "WA",
    "dropphyzpp": 988558826,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TONASKET",
    "dropmalst": "WA",
    "dropmalzpp": 988559998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094862220,
    "dropsitcph": 5094862220,
    "dropfax": 6514566275
  },
  {
    "dcode": "D",
    "dropkey": "PZ17627",
    "droptype": "D",
    "dropname": "TOPPENISH",
    "dropdeladd": "14 JEFFERSON AVE",
    "dropdelcty": "TOPPENISH",
    "dropdelst": "WA",
    "dropdelzpp": 989489998,
    "dropphyadd": "14 JEFFERSON AVE",
    "dropphycty": "TOPPENISH",
    "dropphyst": "WA",
    "dropphyzpp": 989489998,
    "dropmaladd": "14 JEFFERSON AVE",
    "dropmalcty": "TOPPENISH",
    "dropmalst": "WA",
    "dropmalzpp": 989489998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098653721,
    "dropsitcph": 5098657109,
    "dropfax": 6514566276
  },
  {
    "dcode": "D",
    "dropkey": "PZ17630",
    "droptype": "D",
    "dropname": "TOUCHET",
    "dropdeladd": "69 TOUCHET NORTH RD",
    "dropdelcty": "TOUCHET",
    "dropdelst": "WA",
    "dropdelzpp": 993609998,
    "dropphyadd": "69 TOUCHET NORTH RD",
    "dropphycty": "TOUCHET",
    "dropphyst": "WA",
    "dropphyzpp": 993609998,
    "dropmaladd": "69 TOUCHET NORTH RD",
    "dropmalcty": "TOUCHET",
    "dropmalst": "WA",
    "dropmalzpp": 993609998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093942911,
    "dropsitcph": 5093942911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17631",
    "droptype": "D",
    "dropname": "TOUTLE",
    "dropdeladd": "5208 SPIRIT LAKE HWY",
    "dropdelcty": "TOUTLE",
    "dropdelst": "WA",
    "dropdelzpp": 986499891,
    "dropphyadd": "5208 SPIRIT LAKE HWY",
    "dropphycty": "TOUTLE",
    "dropphyst": "WA",
    "dropphyzpp": 986499891,
    "dropmaladd": "5208 SPIRIT LAKE HWY",
    "dropmalcty": "TOUTLE",
    "dropmalst": "WA",
    "dropmalzpp": 986499998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602746179,
    "dropsitcph": 3602746179,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17633",
    "droptype": "D",
    "dropname": "TRACYTON",
    "dropdeladd": "5201 TRACYTON BLVD NW",
    "dropdelcty": "TRACYTON",
    "dropdelst": "WA",
    "dropdelzpp": 983939800,
    "dropphyadd": "5201 TRACYTON BLVD NW",
    "dropphycty": "TRACYTON",
    "dropphyst": "WA",
    "dropphyzpp": 983939800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRACYTON",
    "dropmalst": "WA",
    "dropmalzpp": 983939998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607922951,
    "dropsitcph": 3603777952,
    "dropfax": 3603731018
  },
  {
    "dcode": "D",
    "dropkey": "PZ17636",
    "droptype": "D",
    "dropname": "TROUT LAKE",
    "dropdeladd": "2393 HIGHWAY 141",
    "dropdelcty": "TROUT LAKE",
    "dropdelst": "WA",
    "dropdelzpp": 986509735,
    "dropphyadd": "2393 HIGHWAY 141",
    "dropphycty": "TROUT LAKE",
    "dropphyst": "WA",
    "dropphyzpp": 986509735,
    "dropmaladd": "2393 HIGHWAY 141",
    "dropmalcty": "TROUT LAKE",
    "dropmalst": "WA",
    "dropmalzpp": 986509998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5063952108,
    "dropsitcph": 5093952108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17645",
    "droptype": "D",
    "dropname": "TWISP",
    "dropdeladd": "205 GLOVER ST",
    "dropdelcty": "TWISP",
    "dropdelst": "WA",
    "dropdelzpp": 988569990,
    "dropphyadd": "205 GLOVER ST",
    "dropphycty": "TWISP",
    "dropphyst": "WA",
    "dropphyzpp": 988569990,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWISP",
    "dropmalst": "WA",
    "dropmalzpp": 988569998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5099973777,
    "dropsitcph": 5099973777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17648",
    "droptype": "D",
    "dropname": "UNDERWOOD",
    "dropdeladd": "981 SCHOOLHOUSE RD",
    "dropdelcty": "UNDERWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 986519250,
    "dropphyadd": "981 SCHOOLHOUSE RD",
    "dropphycty": "UNDERWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 986519250,
    "dropmaladd": "981 SCHOOLHOUSE RD",
    "dropmalcty": "UNDERWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 986519998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094932638,
    "dropsitcph": 5094932638,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17649",
    "droptype": "D",
    "dropname": "UNION",
    "dropdeladd": "310 E DALBY RD",
    "dropdelcty": "UNION",
    "dropdelst": "WA",
    "dropdelzpp": 985929564,
    "dropphyadd": "310 E DALBY RD",
    "dropphycty": "UNION",
    "dropphyst": "WA",
    "dropphyzpp": 985929564,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNION",
    "dropmalst": "WA",
    "dropmalzpp": 985929998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608982653,
    "dropsitcph": 3608982653,
    "dropfax": 3608982654
  },
  {
    "dcode": "D",
    "dropkey": "PZ17653",
    "droptype": "D",
    "dropname": "UNIONTOWN",
    "dropdeladd": "117 S MONTGOMERY ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "WA",
    "dropdelzpp": 991799998,
    "dropphyadd": "117 S MONTGOMERY ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "WA",
    "dropphyzpp": 991799998,
    "dropmaladd": "117 S MONTGOMERY ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "WA",
    "dropmalzpp": 991799998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092293399,
    "dropsitcph": 5092293399,
    "dropfax": 6505784729
  },
  {
    "dcode": "D",
    "dropkey": "PZ17662",
    "droptype": "D",
    "dropname": "USK",
    "dropdeladd": "102 W 5TH ST",
    "dropdelcty": "USK",
    "dropdelst": "WA",
    "dropdelzpp": 991809998,
    "dropphyadd": "102 W 5TH ST",
    "dropphycty": "USK",
    "dropphyst": "WA",
    "dropphyzpp": 991809998,
    "dropmaladd": "102 W 5TH ST",
    "dropmalcty": "USK",
    "dropmalst": "WA",
    "dropmalzpp": 991809998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094451365,
    "dropsitcph": 5094451365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17663",
    "droptype": "D",
    "dropname": "VADER",
    "dropdeladd": "621 A ST",
    "dropdelcty": "VADER",
    "dropdelst": "WA",
    "dropdelzpp": 985939900,
    "dropphyadd": "621 A ST",
    "dropphycty": "VADER",
    "dropphyst": "WA",
    "dropphyzpp": 985939900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VADER",
    "dropmalst": "WA",
    "dropmalzpp": 985939998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602953510,
    "dropsitcph": 3602953510,
    "dropfax": 3602953847
  },
  {
    "dcode": "D",
    "dropkey": "PZ17665",
    "droptype": "D",
    "dropname": "VALLEY",
    "dropdeladd": "3073 3RD AVE",
    "dropdelcty": "VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 991819998,
    "dropphyadd": "3073 3RD AVE",
    "dropphycty": "VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 991819998,
    "dropmaladd": "3073 3RD AVE",
    "dropmalcty": "VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 991819998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099372255,
    "dropsitcph": 5099372255,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17666",
    "droptype": "D",
    "dropname": "VALLEYFORD",
    "dropdeladd": "12809 S MADISON RD",
    "dropdelcty": "VALLEYFORD",
    "dropdelst": "WA",
    "dropdelzpp": 990369998,
    "dropphyadd": "12809 S MADISON RD",
    "dropphycty": "VALLEYFORD",
    "dropphyst": "WA",
    "dropphyzpp": 990369998,
    "dropmaladd": "12809 S MADISON RD",
    "dropmalcty": "VALLEYFORD",
    "dropmalst": "WA",
    "dropmalzpp": 990369998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099223881,
    "dropsitcph": 5099223881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17668",
    "droptype": "D",
    "dropname": "VANCOUVER",
    "dropdeladd": "2700 CAPLES AVE",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986616100,
    "dropphyadd": "2700 CAPLES AVE",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986616100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986689998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3609925006,
    "dropsitcph": 3609925000,
    "dropfax": 3609925088
  },
  {
    "dcode": "D",
    "dropkey": "PZ17671",
    "droptype": "D",
    "dropname": "VASHON",
    "dropdeladd": "10005 SW 178TH ST",
    "dropdelcty": "VASHON",
    "dropdelst": "WA",
    "dropdelzpp": 980705299,
    "dropphyadd": "10005 SW 178TH ST",
    "dropphycty": "VASHON",
    "dropphyst": "WA",
    "dropphyzpp": 980705299,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VASHON",
    "dropmalst": "WA",
    "dropmalzpp": 980709998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2064635134,
    "dropsitcph": 2064636842,
    "dropfax": 6514566501
  },
  {
    "dcode": "D",
    "dropkey": "PZ17673",
    "droptype": "D",
    "dropname": "VAUGHN",
    "dropdeladd": "15613 OLSON DR NW",
    "dropdelcty": "VAUGHN",
    "dropdelst": "WA",
    "dropdelzpp": 983949800,
    "dropphyadd": "15613 OLSON DR NW",
    "dropphycty": "VAUGHN",
    "dropphyst": "WA",
    "dropphyzpp": 983949800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VAUGHN",
    "dropmalst": "WA",
    "dropmalzpp": 983949998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538842564,
    "dropsitcph": 2538842564,
    "dropfax": 2538849079
  },
  {
    "dcode": "D",
    "dropkey": "PZ17674",
    "droptype": "D",
    "dropname": "VERADALE",
    "dropdeladd": "15202 E SPRAGUE AVE",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 990379998,
    "dropphyadd": "15202 E SPRAGUE AVE",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 990379998,
    "dropmaladd": "15202 E SPRAGUE AVE",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 990379998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5098930290,
    "dropsitcph": 5098930288,
    "dropfax": 6514566282
  },
  {
    "dcode": "D",
    "dropkey": "PZ17683",
    "droptype": "D",
    "dropname": "WAITSBURG",
    "dropdeladd": "224 MAIN ST",
    "dropdelcty": "WAITSBURG",
    "dropdelst": "WA",
    "dropdelzpp": 993619998,
    "dropphyadd": "224 MAIN ST",
    "dropphycty": "WAITSBURG",
    "dropphyst": "WA",
    "dropphyzpp": 993619998,
    "dropmaladd": "224 MAIN ST",
    "dropmalcty": "WAITSBURG",
    "dropmalst": "WA",
    "dropmalzpp": 993619998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093376781,
    "dropsitcph": 5093376781,
    "dropfax": 5093376935
  },
  {
    "dcode": "D",
    "dropkey": "PZ17684",
    "droptype": "D",
    "dropname": "WALDRON",
    "dropdeladd": "1 S BURN RD",
    "dropdelcty": "WALDRON",
    "dropdelst": "WA",
    "dropdelzpp": 982979800,
    "dropphyadd": "1 S BURN RD",
    "dropphycty": "WALDRON",
    "dropphyst": "WA",
    "dropphyzpp": 982979800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WALDRON",
    "dropmalst": "WA",
    "dropmalzpp": 982979998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602980217,
    "dropsitcph": 3602980217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17685",
    "droptype": "D",
    "dropname": "WALLA WALLA",
    "dropdeladd": "128 N 2ND AVE",
    "dropdelcty": "WALLA WALLA",
    "dropdelst": "WA",
    "dropdelzpp": 993629998,
    "dropphyadd": "128 N 2ND AVE",
    "dropphycty": "WALLA WALLA",
    "dropphyst": "WA",
    "dropphyzpp": 993629998,
    "dropmaladd": "128 N 2ND AVE",
    "dropmalcty": "WALLA WALLA",
    "dropmalst": "WA",
    "dropmalzpp": 993629998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095223824,
    "dropsitcph": 5095223824,
    "dropfax": 6514566281
  },
  {
    "dcode": "D",
    "dropkey": "PZ17688",
    "droptype": "D",
    "dropname": "WALLULA",
    "dropdeladd": "150 N COLUMBIA WAY",
    "dropdelcty": "WALLULA",
    "dropdelst": "WA",
    "dropdelzpp": 993639998,
    "dropphyadd": "150 N COLUMBIA WAY",
    "dropphycty": "WALLULA",
    "dropphyst": "WA",
    "dropphyzpp": 993639998,
    "dropmaladd": "150 N COLUMBIA WAY",
    "dropmalcty": "WALLULA",
    "dropmalst": "WA",
    "dropmalzpp": 993639998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095473034,
    "dropsitcph": 5095473034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17689",
    "droptype": "D",
    "dropname": "WAPATO",
    "dropdeladd": "307 S SATUS AVE",
    "dropdelcty": "WAPATO",
    "dropdelst": "WA",
    "dropdelzpp": 989519998,
    "dropphyadd": "307 S SATUS AVE",
    "dropphycty": "WAPATO",
    "dropphyst": "WA",
    "dropphyzpp": 989519998,
    "dropmaladd": "307 S SATUS AVE",
    "dropmalcty": "WAPATO",
    "dropmalst": "WA",
    "dropmalzpp": 989519998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098773700,
    "dropsitcph": 5098773700,
    "dropfax": 6513066960
  },
  {
    "dcode": "D",
    "dropkey": "PZ17690",
    "droptype": "D",
    "dropname": "WARDEN",
    "dropdeladd": "201 E 1ST ST",
    "dropdelcty": "WARDEN",
    "dropdelst": "WA",
    "dropdelzpp": 988579800,
    "dropphyadd": "201 E 1ST ST",
    "dropphycty": "WARDEN",
    "dropphyst": "WA",
    "dropphyzpp": 988579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WARDEN",
    "dropmalst": "WA",
    "dropmalzpp": 988579998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5093492364,
    "dropsitcph": 5093492364,
    "dropfax": 6505775599
  },
  {
    "dcode": "D",
    "dropkey": "PZ17695",
    "droptype": "D",
    "dropname": "WASHOUGAL",
    "dropdeladd": "129 PENDLETON WAY",
    "dropdelcty": "WASHOUGAL",
    "dropdelst": "WA",
    "dropdelzpp": 986714202,
    "dropphyadd": "129 PENDLETON WAY",
    "dropphycty": "WASHOUGAL",
    "dropphyst": "WA",
    "dropphyzpp": 986714202,
    "dropmaladd": "129 PENDLETON WAY",
    "dropmalcty": "WASHOUGAL",
    "dropmalst": "WA",
    "dropmalzpp": 986719998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608358582,
    "dropsitcph": 3608358582,
    "dropfax": 3608357856
  },
  {
    "dcode": "D",
    "dropkey": "PZ17698",
    "droptype": "D",
    "dropname": "WATERVILLE",
    "dropdeladd": "113 E LOCUST ST",
    "dropdelcty": "WATERVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 988589800,
    "dropphyadd": "113 E LOCUST ST",
    "dropphycty": "WATERVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 988589800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WATERVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 988589998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5097458432,
    "dropsitcph": 5097458432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17699",
    "droptype": "D",
    "dropname": "WAUCONDA",
    "dropdeladd": "40 TORODA CREEK RD",
    "dropdelcty": "WAUCONDA",
    "dropdelst": "WA",
    "dropdelzpp": 988599996,
    "dropphyadd": "40 TORODA CREEK RD",
    "dropphycty": "WAUCONDA",
    "dropphyst": "WA",
    "dropphyzpp": 988599996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUCONDA",
    "dropmalst": "WA",
    "dropmalzpp": 988599998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5094864566,
    "dropsitcph": 5094864566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17700",
    "droptype": "D",
    "dropname": "WAUNA",
    "dropdeladd": "14304 92ND AVE NW",
    "dropdelcty": "WAUNA",
    "dropdelst": "WA",
    "dropdelzpp": 983959800,
    "dropphyadd": "14304 92ND AVE NW",
    "dropphycty": "WAUNA",
    "dropphyst": "WA",
    "dropphyzpp": 983959800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WAUNA",
    "dropmalst": "WA",
    "dropmalzpp": 983959998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538574623,
    "dropsitcph": 2538574644,
    "dropfax": 2538572596
  },
  {
    "dcode": "D",
    "dropkey": "PZ17704",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "170 N COMMERCIAL ST",
    "dropdelcty": "WAVERLY",
    "dropdelst": "WA",
    "dropdelzpp": 990399998,
    "dropphyadd": "170 N COMMERCIAL ST",
    "dropphycty": "WAVERLY",
    "dropphyst": "WA",
    "dropphyzpp": 990399998,
    "dropmaladd": "170 N COMMERCIAL ST",
    "dropmalcty": "WAVERLY",
    "dropmalst": "WA",
    "dropmalzpp": 990399998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092832358,
    "dropsitcph": 5092832358,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17709",
    "droptype": "D",
    "dropname": "WELLPINIT",
    "dropdeladd": "6210 FORD WELLPINIT RD",
    "dropdelcty": "WELLPINIT",
    "dropdelst": "WA",
    "dropdelzpp": 990409998,
    "dropphyadd": "6210 FORD WELLPINIT RD",
    "dropphycty": "WELLPINIT",
    "dropphyst": "WA",
    "dropphyzpp": 990409998,
    "dropmaladd": "6210 FORD WELLPINIT RD",
    "dropmalcty": "WELLPINIT",
    "dropmalst": "WA",
    "dropmalzpp": 990409998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092584446,
    "dropsitcph": 5092584446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17711",
    "droptype": "D",
    "dropname": "WENATCHEE",
    "dropdeladd": "1050 MAPLE ST",
    "dropdelcty": "WENATCHEE",
    "dropdelst": "WA",
    "dropdelzpp": 988019998,
    "dropphyadd": "1050 MAPLE ST",
    "dropphycty": "WENATCHEE",
    "dropphyst": "WA",
    "dropphyzpp": 988019998,
    "dropmaladd": "1050 MAPLE ST",
    "dropmalcty": "WENATCHEE",
    "dropmalst": "WA",
    "dropmalzpp": 988019998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096622033,
    "dropsitcph": 5096622033,
    "dropfax": 6514566286
  },
  {
    "dcode": "D",
    "dropkey": "PZ17721",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "400 W OCEAN AVE",
    "dropdelcty": "WESTPORT",
    "dropdelst": "WA",
    "dropdelzpp": 985959900,
    "dropphyadd": "400 W OCEAN AVE",
    "dropphycty": "WESTPORT",
    "dropphyst": "WA",
    "dropphyzpp": 985959900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTPORT",
    "dropmalst": "WA",
    "dropmalzpp": 985959998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602681869,
    "dropsitcph": 3602689684,
    "dropfax": 3602686031
  },
  {
    "dcode": "D",
    "dropkey": "PZ17732",
    "droptype": "D",
    "dropname": "WHITE SALMON",
    "dropdeladd": "185 NE SNOHOMISH AVE",
    "dropdelcty": "WHITE SALMON",
    "dropdelst": "WA",
    "dropdelzpp": 986729198,
    "dropphyadd": "185 NE SNOHOMISH AVE",
    "dropphycty": "WHITE SALMON",
    "dropphyst": "WA",
    "dropphyzpp": 986729198,
    "dropmaladd": "185 NE SNOHOMISH AVE",
    "dropmalcty": "WHITE SALMON",
    "dropmalst": "WA",
    "dropmalzpp": 986729998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5094932835,
    "dropsitcph": 5094933904,
    "dropfax": 5094931625
  },
  {
    "dcode": "D",
    "dropkey": "PZ17733",
    "droptype": "D",
    "dropname": "WHITE SWAN",
    "dropdeladd": "210 BIRCH AVE",
    "dropdelcty": "WHITE SWAN",
    "dropdelst": "WA",
    "dropdelzpp": 989529800,
    "dropphyadd": "210 BIRCH AVE",
    "dropphycty": "WHITE SWAN",
    "dropphyst": "WA",
    "dropphyzpp": 989529800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WHITE SWAN",
    "dropmalst": "WA",
    "dropmalzpp": 989529998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098742717,
    "dropsitcph": 5098742717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17737",
    "droptype": "D",
    "dropname": "WILBUR",
    "dropdeladd": "5 SW BROADWAY ST",
    "dropdelcty": "WILBUR",
    "dropdelst": "WA",
    "dropdelzpp": 991859998,
    "dropphyadd": "5 SW BROADWAY ST",
    "dropphycty": "WILBUR",
    "dropphyst": "WA",
    "dropphyzpp": 991859998,
    "dropmaladd": "5 SW BROADWAY ST",
    "dropmalcty": "WILBUR",
    "dropmalst": "WA",
    "dropmalzpp": 991859998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5096472401,
    "dropsitcph": 5096472401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17742",
    "droptype": "D",
    "dropname": "WILKESON",
    "dropdeladd": "517 CHURCH ST",
    "dropdelcty": "WILKESON",
    "dropdelst": "WA",
    "dropdelzpp": 983969800,
    "dropphyadd": "517 CHURCH ST",
    "dropphycty": "WILKESON",
    "dropphyst": "WA",
    "dropphyzpp": 983969800,
    "dropmaladd": "517 CHURCH ST",
    "dropmalcty": "WILKESON",
    "dropmalst": "WA",
    "dropmalzpp": 983969800,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608290403,
    "dropsitcph": 3608290403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17744",
    "droptype": "D",
    "dropname": "WILSON CREEK",
    "dropdeladd": "223 RAILROAD ST",
    "dropdelcty": "WILSON CREEK",
    "dropdelst": "WA",
    "dropdelzpp": 988609800,
    "dropphyadd": "223 RAILROAD ST",
    "dropphycty": "WILSON CREEK",
    "dropphyst": "WA",
    "dropphyzpp": 988609800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILSON CREEK",
    "dropmalst": "WA",
    "dropmalzpp": 988609998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5093452561,
    "dropsitcph": 5093452561,
    "dropfax": 6505784657
  },
  {
    "dcode": "D",
    "dropkey": "PZ17746",
    "droptype": "D",
    "dropname": "WINLOCK",
    "dropdeladd": "220 NE 1ST ST",
    "dropdelcty": "WINLOCK",
    "dropdelst": "WA",
    "dropdelzpp": 985969900,
    "dropphyadd": "220 NE 1ST ST",
    "dropphycty": "WINLOCK",
    "dropphyst": "WA",
    "dropphyzpp": 985969900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINLOCK",
    "dropmalst": "WA",
    "dropmalzpp": 985969998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607854212,
    "dropsitcph": 3607853362,
    "dropfax": 6513066133
  },
  {
    "dcode": "D",
    "dropkey": "PZ17748",
    "droptype": "D",
    "dropname": "WINTHROP",
    "dropdeladd": "1110 STATE ROUTE 20",
    "dropdelcty": "WINTHROP",
    "dropdelst": "WA",
    "dropdelzpp": 988629113,
    "dropphyadd": "1110 STATE ROUTE 20",
    "dropphycty": "WINTHROP",
    "dropphyst": "WA",
    "dropphyzpp": 988629113,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WINTHROP",
    "dropmalst": "WA",
    "dropmalzpp": 988629998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5099963827,
    "dropsitcph": 5099962282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17751",
    "droptype": "D",
    "dropname": "WISHRAM",
    "dropdeladd": "521 BRIDGEWAY RD",
    "dropdelcty": "WISHRAM",
    "dropdelst": "WA",
    "dropdelzpp": 986739198,
    "dropphyadd": "521 BRIDGEWAY RD",
    "dropphycty": "WISHRAM",
    "dropphyst": "WA",
    "dropphyzpp": 986739198,
    "dropmaladd": "521 BRIDGEWAY RD",
    "dropmalcty": "WISHRAM",
    "dropmalst": "WA",
    "dropmalzpp": 986739998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5097482413,
    "dropsitcph": 5097482413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ17754",
    "droptype": "D",
    "dropname": "WOODINVILLE",
    "dropdeladd": "17610 WOODINVILLE SNOHOMISH RD NE",
    "dropdelcty": "WOODINVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 980729818,
    "dropphyadd": "17610 WOODINVILLE SNOHOMISH RD NE",
    "dropphycty": "WOODINVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 980729818,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WOODINVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 980729998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254867272,
    "dropsitcph": 4254870995,
    "dropfax": 6514566291
  },
  {
    "dcode": "D",
    "dropkey": "PZ17755",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "190 BOZARTH AVE",
    "dropdelcty": "WOODLAND",
    "dropdelst": "WA",
    "dropdelzpp": 986748416,
    "dropphyadd": "190 BOZARTH AVE",
    "dropphycty": "WOODLAND",
    "dropphyst": "WA",
    "dropphyzpp": 986748416,
    "dropmaladd": "190 BOZARTH AVE",
    "dropmalcty": "WOODLAND",
    "dropmalst": "WA",
    "dropmalzpp": 986749998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602252132,
    "dropsitcph": 3602252132,
    "dropfax": 3602255894
  },
  {
    "dcode": "D",
    "dropkey": "PZ17762",
    "droptype": "D",
    "dropname": "YACOLT",
    "dropdeladd": "555 N AMBOY AVE",
    "dropdelcty": "YACOLT",
    "dropdelst": "WA",
    "dropdelzpp": 986755403,
    "dropphyadd": "555 N AMBOY AVE",
    "dropphycty": "YACOLT",
    "dropphyst": "WA",
    "dropphyzpp": 986755403,
    "dropmaladd": "555 N AMBOY AVE",
    "dropmalcty": "YACOLT",
    "dropmalst": "WA",
    "dropmalzpp": 986759998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606868455,
    "dropsitcph": 3606863141,
    "dropfax": 3606864045
  },
  {
    "dcode": "D",
    "dropkey": "PZ17764",
    "droptype": "D",
    "dropname": "YAKIMA",
    "dropdeladd": "205 W WASHINGTON AVE",
    "dropdelcty": "YAKIMA",
    "dropdelst": "WA",
    "dropdelzpp": 989039998,
    "dropphyadd": "205 W WASHINGTON AVE",
    "dropphycty": "YAKIMA",
    "dropphyst": "WA",
    "dropphyzpp": 989039998,
    "dropmaladd": "205 W WASHINGTON AVE",
    "dropmalcty": "YAKIMA",
    "dropmalst": "WA",
    "dropmalzpp": 989039998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5092251399,
    "dropsitcph": 5092251300,
    "dropfax": 5092251318
  },
  {
    "dcode": "D",
    "dropkey": "PZ17768",
    "droptype": "D",
    "dropname": "YELM",
    "dropdeladd": "10503 CREEK ST SE",
    "dropdelcty": "YELM",
    "dropdelst": "WA",
    "dropdelzpp": 985979997,
    "dropphyadd": "10503 CREEK ST SE",
    "dropphycty": "YELM",
    "dropphyst": "WA",
    "dropphyzpp": 985979997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YELM",
    "dropmalst": "WA",
    "dropmalzpp": 985979998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3604584715,
    "dropsitcph": 3604582374,
    "dropfax": 6514566292
  },
  {
    "dcode": "D",
    "dropkey": "PZ17770",
    "droptype": "D",
    "dropname": "ZILLAH",
    "dropdeladd": "608 2ND AVE",
    "dropdelcty": "ZILLAH",
    "dropdelst": "WA",
    "dropdelzpp": 989539672,
    "dropphyadd": "608 2ND AVE",
    "dropphycty": "ZILLAH",
    "dropphyst": "WA",
    "dropphyzpp": 989539672,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZILLAH",
    "dropmalst": "WA",
    "dropmalzpp": 989539998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098295693,
    "dropsitcph": 5098295693,
    "dropfax": 5098295167
  },
  {
    "dcode": "D",
    "dropkey": "PZ20001",
    "droptype": "D",
    "dropname": "APO",
    "dropdeladd": "2501 RYDIN RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948509751,
    "dropphyadd": "2501 RYDIN RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948509751,
    "dropmaladd": "2501 RYDIN RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948509751,
    "dropsitphn": 6508081314,
    "dropsitlph": "",
    "dropsitcph": 6508081356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20021",
    "droptype": "D",
    "dropname": "ACAMPO",
    "dropdeladd": "3113 E ACAMPO RD",
    "dropdelcty": "ACAMPO",
    "dropdelst": "CA",
    "dropdelzpp": 952209998,
    "dropphyadd": "3113 E ACAMPO RD",
    "dropphycty": "ACAMPO",
    "dropphyst": "CA",
    "dropphyzpp": 952209998,
    "dropmaladd": "3113 E ACAMPO RD",
    "dropmalcty": "ACAMPO",
    "dropmalst": "CA",
    "dropmalzpp": 952209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093696417,
    "dropsitcph": 2093692049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20022",
    "droptype": "D",
    "dropname": "ACTON",
    "dropdeladd": "3632 SMITH AVE",
    "dropdelcty": "ACTON",
    "dropdelst": "CA",
    "dropdelzpp": 935109998,
    "dropphyadd": "3632 SMITH AVE",
    "dropphycty": "ACTON",
    "dropphyst": "CA",
    "dropphyzpp": 935109998,
    "dropmaladd": "3632 SMITH AVE",
    "dropmalcty": "ACTON",
    "dropmalst": "CA",
    "dropmalzpp": 935109998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612698618,
    "dropsitcph": 6612698618,
    "dropfax": 6612698629
  },
  {
    "dcode": "D",
    "dropkey": "PZ20025",
    "droptype": "D",
    "dropname": "ADELANTO",
    "dropdeladd": "11530 RANCHO RD",
    "dropdelcty": "ADELANTO",
    "dropdelst": "CA",
    "dropdelzpp": 923012729,
    "dropphyadd": "11530 RANCHO RD",
    "dropphycty": "ADELANTO",
    "dropphyst": "CA",
    "dropphyzpp": 923012729,
    "dropmaladd": "11530 RANCHO RD",
    "dropmalcty": "ADELANTO",
    "dropmalst": "CA",
    "dropmalzpp": 923012729,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602468535,
    "dropsitcph": 7602464300,
    "dropfax": 7602461281
  },
  {
    "dcode": "D",
    "dropkey": "PZ20026",
    "droptype": "D",
    "dropname": "ADIN",
    "dropdeladd": "512 S MAIN ST",
    "dropdelcty": "ADIN",
    "dropdelst": "CA",
    "dropdelzpp": 960069998,
    "dropphyadd": "512 S MAIN ST",
    "dropphycty": "ADIN",
    "dropphyst": "CA",
    "dropphyzpp": 960069998,
    "dropmaladd": "512 S MAIN ST",
    "dropmalcty": "ADIN",
    "dropmalst": "CA",
    "dropmalzpp": 960069998,
    "dropsitphn": 9163738025,
    "dropsitlph": 6464272296,
    "dropsitcph": 6464272296,
    "dropfax": 6264272289
  },
  {
    "dcode": "D",
    "dropkey": "PZ20034",
    "droptype": "D",
    "dropname": "AGOURA HILLS",
    "dropdeladd": "5158 CLARETON DR",
    "dropdelcty": "AGOURA HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 913019998,
    "dropphyadd": "5158 CLARETON DR",
    "dropphycty": "AGOURA HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 913019998,
    "dropmaladd": "5158 CLARETON DR",
    "dropmalcty": "AGOURA HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 913019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188898392,
    "dropsitcph": 8188898392,
    "dropfax": 8189918276
  },
  {
    "dcode": "D",
    "dropkey": "PZ20037",
    "droptype": "D",
    "dropname": "AGUANGA",
    "dropdeladd": "45600 HIGHWAY 79",
    "dropdelcty": "AGUANGA",
    "dropdelst": "CA",
    "dropdelzpp": 925369998,
    "dropphyadd": "45600 HIGHWAY 79",
    "dropphycty": "AGUANGA",
    "dropphyst": "CA",
    "dropphyzpp": 925369998,
    "dropmaladd": "45600 HIGHWAY 79",
    "dropmalcty": "AGUANGA",
    "dropmalst": "CA",
    "dropmalzpp": 925369998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9517671125,
    "dropsitcph": 9517671125,
    "dropfax": 9517673125
  },
  {
    "dcode": "D",
    "dropkey": "PZ20038",
    "droptype": "D",
    "dropname": "AHWAHNEE",
    "dropdeladd": "44878 NOTRE DAME LN",
    "dropdelcty": "AHWAHNEE",
    "dropdelst": "CA",
    "dropdelzpp": 936019998,
    "dropphyadd": "44878 NOTRE DAME LN",
    "dropphycty": "AHWAHNEE",
    "dropphyst": "CA",
    "dropphyzpp": 936019998,
    "dropmaladd": "44878 NOTRE DAME LN",
    "dropmalcty": "AHWAHNEE",
    "dropmalst": "CA",
    "dropmalzpp": 936019998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596834811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20043",
    "droptype": "D",
    "dropname": "ALAMEDA",
    "dropdeladd": "2201 SHORELINE DR",
    "dropdelcty": "ALAMEDA",
    "dropdelst": "CA",
    "dropdelzpp": 945016200,
    "dropphyadd": "2201 SHORELINE DR",
    "dropphycty": "ALAMEDA",
    "dropphyst": "CA",
    "dropphyzpp": 945016200,
    "dropmaladd": "2201 SHORELINE DR",
    "dropmalcty": "ALAMEDA",
    "dropmalst": "CA",
    "dropmalzpp": 945019998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107484158,
    "dropsitcph": 5107484156,
    "dropfax": 5107485371
  },
  {
    "dcode": "D",
    "dropkey": "PZ20045",
    "droptype": "D",
    "dropname": "ALAMO",
    "dropdeladd": "160 ALAMO PLZ",
    "dropdelcty": "ALAMO",
    "dropdelst": "CA",
    "dropdelzpp": 945079998,
    "dropphyadd": "160 ALAMO PLZ",
    "dropphycty": "ALAMO",
    "dropphyst": "CA",
    "dropphyzpp": 945079998,
    "dropmaladd": "160 ALAMO PLZ",
    "dropmalcty": "ALAMO",
    "dropmalst": "CA",
    "dropmalzpp": 945079998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259359654,
    "dropsitcph": 9259359953,
    "dropfax": 9258375747
  },
  {
    "dcode": "D",
    "dropkey": "PZ20047",
    "droptype": "D",
    "dropname": "ALBION",
    "dropdeladd": "34900 ALBION RIDGE RD",
    "dropdelcty": "ALBION",
    "dropdelst": "CA",
    "dropdelzpp": 954109900,
    "dropphyadd": "34900 ALBION RIDGE RD",
    "dropphycty": "ALBION",
    "dropphyst": "CA",
    "dropphyzpp": 954109900,
    "dropmaladd": "34900 ALBION RIDGE RD",
    "dropmalcty": "ALBION",
    "dropmalst": "CA",
    "dropmalzpp": 954109900,
    "dropsitphn": 7079370667,
    "dropsitlph": 7079370667,
    "dropsitcph": 7079370667,
    "dropfax": 7079370667
  },
  {
    "dcode": "D",
    "dropkey": "PZ20048",
    "droptype": "D",
    "dropname": "ALDERPOINT",
    "dropdeladd": "410 ALDER AVE",
    "dropdelcty": "ALDERPOINT",
    "dropdelst": "CA",
    "dropdelzpp": 955119402,
    "dropphyadd": "410 ALDER AVE",
    "dropphycty": "ALDERPOINT",
    "dropphyst": "CA",
    "dropphyzpp": 955119402,
    "dropmaladd": "410 ALDER AVE",
    "dropmalcty": "ALDERPOINT",
    "dropmalst": "CA",
    "dropmalzpp": 955119402,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079265270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20050",
    "droptype": "D",
    "dropname": "ALHAMBRA",
    "dropdeladd": "10 W BAY STATE ST",
    "dropdelcty": "ALHAMBRA",
    "dropdelst": "CA",
    "dropdelzpp": 918029998,
    "dropphyadd": "10 W BAY STATE ST",
    "dropphycty": "ALHAMBRA",
    "dropphyst": "CA",
    "dropphyzpp": 918029998,
    "dropmaladd": "10 W BAY STATE ST",
    "dropmalcty": "ALHAMBRA",
    "dropmalst": "CA",
    "dropmalzpp": 918029998,
    "dropsitphn": 6262891681,
    "dropsitlph": 6262894653,
    "dropsitcph": 6262891681,
    "dropfax": 6264582283
  },
  {
    "dcode": "D",
    "dropkey": "PZ20055",
    "droptype": "D",
    "dropname": "ALLEGHANY",
    "dropdeladd": "356 MAIN ST",
    "dropdelcty": "ALLEGHANY",
    "dropdelst": "CA",
    "dropdelzpp": 959109998,
    "dropphyadd": "356 MAIN ST",
    "dropphycty": "ALLEGHANY",
    "dropphyst": "CA",
    "dropphyzpp": 959109998,
    "dropmaladd": "356 MAIN ST",
    "dropmalcty": "ALLEGHANY",
    "dropmalst": "CA",
    "dropmalzpp": 959109998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302873427,
    "dropsitcph": 5302873427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20065",
    "droptype": "D",
    "dropname": "ALPAUGH",
    "dropdeladd": "3896 CENTER AVE",
    "dropdelcty": "ALPAUGH",
    "dropdelst": "CA",
    "dropdelzpp": 932011100,
    "dropphyadd": "3896 CENTER AVE",
    "dropphycty": "ALPAUGH",
    "dropphyst": "CA",
    "dropphyzpp": 932011100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ALPAUGH",
    "dropmalst": "CA",
    "dropmalzpp": 932019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599498555,
    "dropsitcph": 5599498555,
    "dropfax": 5599498553
  },
  {
    "dcode": "D",
    "dropkey": "PZ20066",
    "droptype": "D",
    "dropname": "ALPINE",
    "dropdeladd": "2127 ARNOLD WAY",
    "dropdelcty": "ALPINE",
    "dropdelst": "CA",
    "dropdelzpp": 919019998,
    "dropphyadd": "2127 ARNOLD WAY",
    "dropphycty": "ALPINE",
    "dropphyst": "CA",
    "dropphyzpp": 919019998,
    "dropmaladd": "2127 ARNOLD WAY",
    "dropmalcty": "ALPINE",
    "dropmalst": "CA",
    "dropmalzpp": 919019998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194459684,
    "dropsitcph": 6194451772,
    "dropfax": 6194457485
  },
  {
    "dcode": "D",
    "dropkey": "PZ20070",
    "droptype": "D",
    "dropname": "ALTA",
    "dropdeladd": "33735 NARY RED RD",
    "dropdelcty": "ALTA",
    "dropdelst": "CA",
    "dropdelzpp": 957019998,
    "dropphyadd": "33735 NARY RED RD",
    "dropphycty": "ALTA",
    "dropphyst": "CA",
    "dropphyzpp": 957019998,
    "dropmaladd": "33735 NARY RED RD",
    "dropmalcty": "ALTA",
    "dropmalst": "CA",
    "dropmalzpp": 957019998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303892227,
    "dropsitcph": 5303892227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20075",
    "droptype": "D",
    "dropname": "ALTADENA",
    "dropdeladd": "2271 LAKE AVE",
    "dropdelcty": "ALTADENA",
    "dropdelst": "CA",
    "dropdelzpp": 910019998,
    "dropphyadd": "2271 LAKE AVE",
    "dropphycty": "ALTADENA",
    "dropphyst": "CA",
    "dropphyzpp": 910019998,
    "dropmaladd": "2271 LAKE AVE",
    "dropmalcty": "ALTADENA",
    "dropmalst": "CA",
    "dropmalzpp": 910019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6267949306,
    "dropsitcph": 6267947618,
    "dropfax": 6267948271
  },
  {
    "dcode": "D",
    "dropkey": "PZ20077",
    "droptype": "D",
    "dropname": "ALTURAS",
    "dropdeladd": "240 N MAIN ST",
    "dropdelcty": "ALTURAS",
    "dropdelst": "CA",
    "dropdelzpp": 961014047,
    "dropphyadd": "240 N MAIN ST",
    "dropphycty": "ALTURAS",
    "dropphyst": "CA",
    "dropphyzpp": 961014047,
    "dropmaladd": "240 N MAIN ST",
    "dropmalcty": "ALTURAS",
    "dropmalst": "CA",
    "dropmalzpp": 961019998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302332410,
    "dropfax": 5302335995
  },
  {
    "dcode": "D",
    "dropkey": "PZ20081",
    "droptype": "D",
    "dropname": "ALVISO",
    "dropdeladd": "1525 GOLD ST",
    "dropdelcty": "ALVISO",
    "dropdelst": "CA",
    "dropdelzpp": 950029800,
    "dropphyadd": "1525 GOLD ST",
    "dropphycty": "ALVISO",
    "dropphyst": "CA",
    "dropphyzpp": 950029800,
    "dropmaladd": "1525 GOLD ST",
    "dropmalcty": "ALVISO",
    "dropmalst": "CA",
    "dropmalzpp": 950029800,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 4082624258,
    "dropfax": 4082622491
  },
  {
    "dcode": "D",
    "dropkey": "PZ20082",
    "droptype": "D",
    "dropname": "AMADOR CITY",
    "dropdeladd": "10781 WATER ST",
    "dropdelcty": "AMADOR CITY",
    "dropdelst": "CA",
    "dropdelzpp": 956019998,
    "dropphyadd": "10781 WATER ST",
    "dropphycty": "AMADOR CITY",
    "dropphyst": "CA",
    "dropphyzpp": 956019998,
    "dropmaladd": "10781 WATER ST",
    "dropmalcty": "AMADOR CITY",
    "dropmalst": "CA",
    "dropmalzpp": 956019998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092675476,
    "dropsitcph": 2092675476,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20093",
    "droptype": "D",
    "dropname": "ANAHEIM",
    "dropdeladd": "701 N LOARA ST",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928039998,
    "dropphyadd": "701 N LOARA ST",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928039998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7145202639,
    "dropsitlph": 7145202620,
    "dropsitcph": 7145202639,
    "dropfax": 7149565516
  },
  {
    "dcode": "D",
    "dropkey": "PZ20098",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "2141 FERRY ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "CA",
    "dropdelzpp": 960079998,
    "dropphyadd": "2141 FERRY ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "CA",
    "dropphyzpp": 960079998,
    "dropmaladd": "2141 FERRY ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "CA",
    "dropmalzpp": 960079998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303656463,
    "dropsitcph": 5303653849,
    "dropfax": 5303658715
  },
  {
    "dcode": "D",
    "dropkey": "PZ20103",
    "droptype": "D",
    "dropname": "ANGELS CAMP",
    "dropdeladd": "1216 S MAIN ST",
    "dropdelcty": "ANGELS CAMP",
    "dropdelst": "CA",
    "dropdelzpp": 952229998,
    "dropphyadd": "1216 S MAIN ST",
    "dropphycty": "ANGELS CAMP",
    "dropphyst": "CA",
    "dropphyzpp": 952229998,
    "dropmaladd": "1216 S MAIN ST",
    "dropmalcty": "ANGELS CAMP",
    "dropmalst": "CA",
    "dropmalzpp": 952229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097362220,
    "dropsitcph": 2097362220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20104",
    "droptype": "D",
    "dropname": "ANGELUS OAKS",
    "dropdeladd": "37696 STATE HIGHWAY 38",
    "dropdelcty": "ANGELUS OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 923059998,
    "dropphyadd": "37696 STATE HIGHWAY 38",
    "dropphycty": "ANGELUS OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 923059998,
    "dropmaladd": "37696 STATE HIGHWAY 38",
    "dropmalcty": "ANGELUS OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 923059998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097942909,
    "dropsitcph": 9097942909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20105",
    "droptype": "D",
    "dropname": "ANGWIN",
    "dropdeladd": "5 ANGWIN PLZ",
    "dropdelcty": "ANGWIN",
    "dropdelst": "CA",
    "dropdelzpp": 945089997,
    "dropphyadd": "5 ANGWIN PLZ",
    "dropphycty": "ANGWIN",
    "dropphyst": "CA",
    "dropphyzpp": 945089997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ANGWIN",
    "dropmalst": "CA",
    "dropmalzpp": 945089998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079652272,
    "dropfax": 7079651706
  },
  {
    "dcode": "D",
    "dropkey": "PZ20110",
    "droptype": "D",
    "dropname": "ANTIOCH",
    "dropdeladd": "2730 W TREGALLAS RD",
    "dropdelcty": "ANTIOCH",
    "dropdelst": "CA",
    "dropdelzpp": 945099998,
    "dropphyadd": "2730 W TREGALLAS RD",
    "dropphycty": "ANTIOCH",
    "dropphyst": "CA",
    "dropphyzpp": 945099998,
    "dropmaladd": "2730 W TREGALLAS RD",
    "dropmalcty": "ANTIOCH",
    "dropmalst": "CA",
    "dropmalzpp": 945099998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9257576153,
    "dropsitcph": 9257570379,
    "dropfax": 9257788149
  },
  {
    "dcode": "D",
    "dropkey": "PZ20111",
    "droptype": "D",
    "dropname": "ANZA",
    "dropdeladd": "38775 CONTRERAS RD",
    "dropdelcty": "ANZA",
    "dropdelst": "CA",
    "dropdelzpp": 925399998,
    "dropphyadd": "38775 CONTRERAS RD",
    "dropphycty": "ANZA",
    "dropphyst": "CA",
    "dropphyzpp": 925399998,
    "dropmaladd": "38775 CONTRERAS RD",
    "dropmalcty": "ANZA",
    "dropmalst": "CA",
    "dropmalzpp": 925399998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9517631359,
    "dropsitcph": 9517632074,
    "dropfax": 9517634954
  },
  {
    "dcode": "D",
    "dropkey": "PZ20112",
    "droptype": "D",
    "dropname": "APPLE VALLEY",
    "dropdeladd": "22099 US HIGHWAY 18",
    "dropdelcty": "APPLE VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 923079998,
    "dropphyadd": "22099 US HIGHWAY 18",
    "dropphycty": "APPLE VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 923079998,
    "dropmaladd": "22099 US HIGHWAY 18",
    "dropmalcty": "APPLE VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 923079998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602478511,
    "dropsitcph": 7602470640,
    "dropfax": 7602479890
  },
  {
    "dcode": "D",
    "dropkey": "PZ20113",
    "droptype": "D",
    "dropname": "APPLEGATE",
    "dropdeladd": "17880 APPLEGATE RD",
    "dropdelcty": "APPLEGATE",
    "dropdelst": "CA",
    "dropdelzpp": 957039998,
    "dropphyadd": "17880 APPLEGATE RD",
    "dropphycty": "APPLEGATE",
    "dropphyst": "CA",
    "dropphyzpp": 957039998,
    "dropmaladd": "17880 APPLEGATE RD",
    "dropmalcty": "APPLEGATE",
    "dropmalst": "CA",
    "dropmalzpp": 957039998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308781822,
    "dropsitcph": 5308781822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20114",
    "droptype": "D",
    "dropname": "APTOS",
    "dropdeladd": "500 CATHEDRAL DR",
    "dropdelcty": "APTOS",
    "dropdelst": "CA",
    "dropdelzpp": 950039998,
    "dropphyadd": "500 CATHEDRAL DR",
    "dropphycty": "APTOS",
    "dropphyst": "CA",
    "dropphyzpp": 950039998,
    "dropmaladd": "500 CATHEDRAL DR",
    "dropmalcty": "APTOS",
    "dropmalst": "CA",
    "dropmalzpp": 950039998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316883165,
    "dropsitcph": 8316883165,
    "dropfax": 8316882090
  },
  {
    "dcode": "D",
    "dropkey": "PZ20116",
    "droptype": "D",
    "dropname": "ARBUCKLE",
    "dropdeladd": "415 5TH ST",
    "dropdelcty": "ARBUCKLE",
    "dropdelst": "CA",
    "dropdelzpp": 959129508,
    "dropphyadd": "415 5TH ST",
    "dropphycty": "ARBUCKLE",
    "dropphyst": "CA",
    "dropphyzpp": 959129508,
    "dropmaladd": "415 5TH ST",
    "dropmalcty": "ARBUCKLE",
    "dropmalst": "CA",
    "dropmalzpp": 959129508,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304210555,
    "dropsitcph": 5304210555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20119",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "41 WHEELER AVE",
    "dropdelcty": "ARCADIA",
    "dropdelst": "CA",
    "dropdelzpp": 910069998,
    "dropphyadd": "41 WHEELER AVE",
    "dropphycty": "ARCADIA",
    "dropphyst": "CA",
    "dropphyzpp": 910069998,
    "dropmaladd": "41 WHEELER AVE",
    "dropmalcty": "ARCADIA",
    "dropmalst": "CA",
    "dropmalzpp": 910069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6264457517,
    "dropsitcph": 6264454421,
    "dropfax": 6264457502
  },
  {
    "dcode": "D",
    "dropkey": "PZ20120",
    "droptype": "D",
    "dropname": "ARCATA",
    "dropdeladd": "799 H ST",
    "dropdelcty": "ARCATA",
    "dropdelst": "CA",
    "dropdelzpp": 955216240,
    "dropphyadd": "799 H ST",
    "dropphycty": "ARCATA",
    "dropphyst": "CA",
    "dropphyzpp": 955216240,
    "dropmaladd": "799 H ST",
    "dropmalcty": "ARCATA",
    "dropmalst": "CA",
    "dropmalzpp": 955216240,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078223370,
    "dropfax": 7078224670
  },
  {
    "dcode": "D",
    "dropkey": "PZ20129",
    "droptype": "D",
    "dropname": "ARMONA",
    "dropdeladd": "13992 ADA ST STE 205",
    "dropdelcty": "ARMONA",
    "dropdelst": "CA",
    "dropdelzpp": 932029998,
    "dropphyadd": "13992 ADA ST STE 205",
    "dropphycty": "ARMONA",
    "dropphyst": "CA",
    "dropphyzpp": 932029998,
    "dropmaladd": "13992 ADA ST STE 205",
    "dropmalcty": "ARMONA",
    "dropmalst": "CA",
    "dropmalzpp": 932029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595824521,
    "dropsitcph": 5595824521,
    "dropfax": 5595827126
  },
  {
    "dcode": "D",
    "dropkey": "PZ20132",
    "droptype": "D",
    "dropname": "ARNOLD",
    "dropdeladd": "997 BLAGEN RD",
    "dropdelcty": "ARNOLD",
    "dropdelst": "CA",
    "dropdelzpp": 952239998,
    "dropphyadd": "997 BLAGEN RD",
    "dropphycty": "ARNOLD",
    "dropphyst": "CA",
    "dropphyzpp": 952239998,
    "dropmaladd": "997 BLAGEN RD",
    "dropmalcty": "ARNOLD",
    "dropmalst": "CA",
    "dropmalzpp": 952239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097951006,
    "dropsitcph": 2097951006,
    "dropfax": 2097956219
  },
  {
    "dcode": "D",
    "dropkey": "PZ20134",
    "droptype": "D",
    "dropname": "AROMAS",
    "dropdeladd": "368 BLOHM AVE",
    "dropdelcty": "AROMAS",
    "dropdelst": "CA",
    "dropdelzpp": 950049998,
    "dropphyadd": "368 BLOHM AVE",
    "dropphycty": "AROMAS",
    "dropphyst": "CA",
    "dropphyzpp": 950049998,
    "dropmaladd": "368 BLOHM AVE",
    "dropmalcty": "AROMAS",
    "dropmalst": "CA",
    "dropmalzpp": 950049998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8317267288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20138",
    "droptype": "D",
    "dropname": "ARROYO GRANDE",
    "dropdeladd": "160 STATION WAY",
    "dropdelcty": "ARROYO GRANDE",
    "dropdelst": "CA",
    "dropdelzpp": 934209998,
    "dropphyadd": "160 STATION WAY",
    "dropphycty": "ARROYO GRANDE",
    "dropphyst": "CA",
    "dropphyzpp": 934209998,
    "dropmaladd": "160 STATION WAY",
    "dropmalcty": "ARROYO GRANDE",
    "dropmalst": "CA",
    "dropmalzpp": 934209998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055746026,
    "dropsitcph": 8055746026,
    "dropfax": 8054748914
  },
  {
    "dcode": "D",
    "dropkey": "PZ20140",
    "droptype": "D",
    "dropname": "ARTESIA",
    "dropdeladd": "11721 183RD ST",
    "dropdelcty": "ARTESIA",
    "dropdelst": "CA",
    "dropdelzpp": 907019998,
    "dropphyadd": "11721 183RD ST",
    "dropphycty": "ARTESIA",
    "dropphyst": "CA",
    "dropphyzpp": 907019998,
    "dropmaladd": "11721 183RD ST",
    "dropmalcty": "ARTESIA",
    "dropmalst": "CA",
    "dropmalzpp": 907019998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624029975,
    "dropsitcph": 5628600394,
    "dropfax": 5624029975
  },
  {
    "dcode": "D",
    "dropkey": "PZ20141",
    "droptype": "D",
    "dropname": "ARTOIS",
    "dropdeladd": "357 FRONT ST",
    "dropdelcty": "ARTOIS",
    "dropdelst": "CA",
    "dropdelzpp": 959139998,
    "dropphyadd": "357 FRONT ST",
    "dropphycty": "ARTOIS",
    "dropphyst": "CA",
    "dropphyzpp": 959139998,
    "dropmaladd": "357 FRONT ST",
    "dropmalcty": "ARTOIS",
    "dropmalst": "CA",
    "dropmalzpp": 959139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309347891,
    "dropsitcph": 5309347891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20142",
    "droptype": "D",
    "dropname": "ARVIN",
    "dropdeladd": "140 N HILL ST",
    "dropdelcty": "ARVIN",
    "dropdelst": "CA",
    "dropdelzpp": 932031014,
    "dropphyadd": "140 N HILL ST",
    "dropphycty": "ARVIN",
    "dropphyst": "CA",
    "dropphyzpp": 932031014,
    "dropmaladd": "140 N HILL ST",
    "dropmalcty": "ARVIN",
    "dropmalst": "CA",
    "dropmalzpp": 932031014,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618546412,
    "dropsitcph": 6618546412,
    "dropfax": 6618547841
  },
  {
    "dcode": "D",
    "dropkey": "PZ20146",
    "droptype": "D",
    "dropname": "ATASCADERO",
    "dropdeladd": "9800 EL CAMINO REAL",
    "dropdelcty": "ATASCADERO",
    "dropdelst": "CA",
    "dropdelzpp": 934225583,
    "dropphyadd": "9800 EL CAMINO REAL",
    "dropphycty": "ATASCADERO",
    "dropphyst": "CA",
    "dropphyzpp": 934225583,
    "dropmaladd": "9800 EL CAMINO REAL",
    "dropmalcty": "ATASCADERO",
    "dropmalst": "CA",
    "dropmalzpp": 934225583,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054604140,
    "dropsitcph": 8054604140,
    "dropfax": 8054669549
  },
  {
    "dcode": "D",
    "dropkey": "PZ20151",
    "droptype": "D",
    "dropname": "ATWATER",
    "dropdeladd": "1599 BROADWAY AVE",
    "dropdelcty": "ATWATER",
    "dropdelst": "CA",
    "dropdelzpp": 953019998,
    "dropphyadd": "1599 BROADWAY AVE",
    "dropphycty": "ATWATER",
    "dropphyst": "CA",
    "dropphyzpp": 953019998,
    "dropmaladd": "1599 BROADWAY AVE",
    "dropmalcty": "ATWATER",
    "dropmalst": "CA",
    "dropmalzpp": 953019998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093582085,
    "dropsitcph": 2093581492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20152",
    "droptype": "D",
    "dropname": "ATWOOD",
    "dropdeladd": "1679 E ORANGETHORPE AVE",
    "dropdelcty": "ATWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 928119997,
    "dropphyadd": "1679 E ORANGETHORPE AVE",
    "dropphycty": "ATWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 928119997,
    "dropmaladd": "PO BOX ZZ",
    "dropmalcty": "ATWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 928119998,
    "dropsitphn": 7145282414,
    "dropsitlph": 7145241709,
    "dropsitcph": 7145282414,
    "dropfax": 7145288296
  },
  {
    "dcode": "D",
    "dropkey": "PZ20153",
    "droptype": "D",
    "dropname": "AUBERRY",
    "dropdeladd": "33012 AUBERRY RD",
    "dropdelcty": "AUBERRY",
    "dropdelst": "CA",
    "dropdelzpp": 936029998,
    "dropphyadd": "33012 AUBERRY RD",
    "dropphycty": "AUBERRY",
    "dropphyst": "CA",
    "dropphyzpp": 936029998,
    "dropmaladd": "33012 AUBERRY RD",
    "dropmalcty": "AUBERRY",
    "dropmalst": "CA",
    "dropmalzpp": 936029998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598552747,
    "dropfax": 5598558611
  },
  {
    "dcode": "D",
    "dropkey": "PZ20154",
    "droptype": "D",
    "dropname": "AUBURN",
    "dropdeladd": "371 NEVADA ST",
    "dropdelcty": "AUBURN",
    "dropdelst": "CA",
    "dropdelzpp": 956039998,
    "dropphyadd": "371 NEVADA ST",
    "dropphycty": "AUBURN",
    "dropphyst": "CA",
    "dropphyzpp": 956039998,
    "dropmaladd": "371 NEVADA ST",
    "dropmalcty": "AUBURN",
    "dropmalst": "CA",
    "dropmalzpp": 956039998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307456004,
    "dropsitcph": 5308857943,
    "dropfax": 5308852855
  },
  {
    "dcode": "D",
    "dropkey": "PZ20156",
    "droptype": "D",
    "dropname": "AVALON",
    "dropdeladd": "118 METROPOLE AVE",
    "dropdelcty": "AVALON",
    "dropdelst": "CA",
    "dropdelzpp": 907049997,
    "dropphyadd": "118 METROPOLE AVE",
    "dropphycty": "AVALON",
    "dropphyst": "CA",
    "dropphyzpp": 907049997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AVALON",
    "dropmalst": "CA",
    "dropmalzpp": 907049998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3105109666,
    "dropsitcph": 3105102850,
    "dropfax": 3105100829
  },
  {
    "dcode": "D",
    "dropkey": "PZ20157",
    "droptype": "D",
    "dropname": "AVENAL",
    "dropdeladd": "913 E SAN JOAQUIN ST",
    "dropdelcty": "AVENAL",
    "dropdelst": "CA",
    "dropdelzpp": 932049998,
    "dropphyadd": "913 E SAN JOAQUIN ST",
    "dropphycty": "AVENAL",
    "dropphyst": "CA",
    "dropphyzpp": 932049998,
    "dropmaladd": "913 E SAN JOAQUIN ST",
    "dropmalcty": "AVENAL",
    "dropmalst": "CA",
    "dropmalzpp": 932049998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5593861075,
    "dropsitcph": 5593861075,
    "dropfax": 5593862751
  },
  {
    "dcode": "D",
    "dropkey": "PZ20158",
    "droptype": "D",
    "dropname": "AVERY",
    "dropdeladd": "4529A HIGHWAY 4",
    "dropdelcty": "AVERY",
    "dropdelst": "CA",
    "dropdelzpp": 952249998,
    "dropphyadd": "4529A HIGHWAY 4",
    "dropphycty": "AVERY",
    "dropphyst": "CA",
    "dropphyzpp": 952249998,
    "dropmaladd": "4529A HIGHWAY 4",
    "dropmalcty": "AVERY",
    "dropmalst": "CA",
    "dropmalzpp": 952249998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097951279,
    "dropsitcph": 2097951279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20159",
    "droptype": "D",
    "dropname": "AVILA BEACH",
    "dropdeladd": "191 SAN MIGUEL",
    "dropdelcty": "AVILA BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 934249997,
    "dropphyadd": "191 SAN MIGUEL",
    "dropphycty": "AVILA BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 934249997,
    "dropmaladd": "191 SAN MIGUEL",
    "dropmalcty": "AVILA BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 934249997,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055959321,
    "dropsitcph": 8055952158,
    "dropfax": 8055952179
  },
  {
    "dcode": "D",
    "dropkey": "PZ20161",
    "droptype": "D",
    "dropname": "AZUSA",
    "dropdeladd": "110 W 6TH ST",
    "dropdelcty": "AZUSA",
    "dropdelst": "CA",
    "dropdelzpp": 917029998,
    "dropphyadd": "110 W 6TH ST",
    "dropphycty": "AZUSA",
    "dropphyst": "CA",
    "dropphyzpp": 917029998,
    "dropmaladd": "110 W 6TH ST",
    "dropmalcty": "AZUSA",
    "dropmalst": "CA",
    "dropmalzpp": 917029998,
    "dropsitphn": 6269699530,
    "dropsitlph": 6268151245,
    "dropsitcph": 6269699530,
    "dropfax": 6263343103
  },
  {
    "dcode": "D",
    "dropkey": "PZ20169",
    "droptype": "D",
    "dropname": "BAKER",
    "dropdeladd": "1 LAKEVIEW DR",
    "dropdelcty": "BAKER",
    "dropdelst": "CA",
    "dropdelzpp": 923099998,
    "dropphyadd": "1 LAKEVIEW DR",
    "dropphycty": "BAKER",
    "dropphyst": "CA",
    "dropphyzpp": 923099998,
    "dropmaladd": "1 LAKEVIEW DR",
    "dropmalcty": "BAKER",
    "dropmalst": "CA",
    "dropmalzpp": 923099998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7607334373,
    "dropsitcph": 7607334373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20172",
    "droptype": "D",
    "dropname": "BAKERSFIELD",
    "dropdeladd": "3400 PEGASUS DR",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933809998,
    "dropphyadd": "3400 PEGASUS DR",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933809998,
    "dropmaladd": "3400 PEGASUS DR",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933809998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613926102,
    "dropsitcph": 6613926175,
    "dropfax": 6613926149
  },
  {
    "dcode": "D",
    "dropkey": "PZ20178",
    "droptype": "D",
    "dropname": "BALDWIN PARK",
    "dropdeladd": "4230 MAINE AVE",
    "dropdelcty": "BALDWIN PARK",
    "dropdelst": "CA",
    "dropdelzpp": 917069998,
    "dropphyadd": "4230 MAINE AVE",
    "dropphycty": "BALDWIN PARK",
    "dropphyst": "CA",
    "dropphyzpp": 917069998,
    "dropmaladd": "4230 MAINE AVE",
    "dropmalcty": "BALDWIN PARK",
    "dropmalst": "CA",
    "dropmalzpp": 917069998,
    "dropsitphn": 6269620268,
    "dropsitlph": 6269623320,
    "dropsitcph": 6269620268,
    "dropfax": 6269603057
  },
  {
    "dcode": "D",
    "dropkey": "PZ20183",
    "droptype": "D",
    "dropname": "BALLICO",
    "dropdeladd": "11224 SANTA FE DR",
    "dropdelcty": "BALLICO",
    "dropdelst": "CA",
    "dropdelzpp": 953039998,
    "dropphyadd": "11224 SANTA FE DR",
    "dropphycty": "BALLICO",
    "dropphyst": "CA",
    "dropphyzpp": 953039998,
    "dropmaladd": "11224 SANTA FE DR",
    "dropmalcty": "BALLICO",
    "dropmalst": "CA",
    "dropmalzpp": 953039998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096320694,
    "dropsitcph": 2096320694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20185",
    "droptype": "D",
    "dropname": "BANGOR",
    "dropdeladd": "5673 LA PORTE RD",
    "dropdelcty": "BANGOR",
    "dropdelst": "CA",
    "dropdelzpp": 959149998,
    "dropphyadd": "5673 LA PORTE RD",
    "dropphycty": "BANGOR",
    "dropphyst": "CA",
    "dropphyzpp": 959149998,
    "dropmaladd": "5673 LA PORTE RD",
    "dropmalcty": "BANGOR",
    "dropmalst": "CA",
    "dropmalzpp": 959149998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306792481,
    "dropsitcph": 5306792481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20192",
    "droptype": "D",
    "dropname": "BANNING",
    "dropdeladd": "176 N ALESSANDRO ST",
    "dropdelcty": "BANNING",
    "dropdelst": "CA",
    "dropdelzpp": 922205524,
    "dropphyadd": "176 N ALESSANDRO ST",
    "dropphycty": "BANNING",
    "dropphyst": "CA",
    "dropphyzpp": 922205524,
    "dropmaladd": "176 N ALESSANDRO ST",
    "dropmalcty": "BANNING",
    "dropmalst": "CA",
    "dropmalzpp": 922209998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9518492447,
    "dropsitcph": 9518494378,
    "dropfax": 9518498607
  },
  {
    "dcode": "D",
    "dropkey": "PZ20195",
    "droptype": "D",
    "dropname": "BARD",
    "dropdeladd": "1280 BARD RD",
    "dropdelcty": "BARD",
    "dropdelst": "CA",
    "dropdelzpp": 922229800,
    "dropphyadd": "1280 BARD RD",
    "dropphycty": "BARD",
    "dropphyst": "CA",
    "dropphyzpp": 922229800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BARD",
    "dropmalst": "CA",
    "dropmalzpp": 922229998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7605720574,
    "dropsitcph": 7605720574,
    "dropfax": 7605722720
  },
  {
    "dcode": "D",
    "dropkey": "PZ20199",
    "droptype": "D",
    "dropname": "BARSTOW",
    "dropdeladd": "425 S 2ND AVE",
    "dropdelcty": "BARSTOW",
    "dropdelst": "CA",
    "dropdelzpp": 923112891,
    "dropphyadd": "425 S 2ND AVE",
    "dropphycty": "BARSTOW",
    "dropphyst": "CA",
    "dropphyzpp": 923112891,
    "dropmaladd": "425 S 2ND AVE",
    "dropmalcty": "BARSTOW",
    "dropmalst": "CA",
    "dropmalzpp": 923112891,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602561375,
    "dropsitcph": 7602569304,
    "dropfax": 7602560166
  },
  {
    "dcode": "D",
    "dropkey": "PZ20202",
    "droptype": "D",
    "dropname": "BASS LAKE",
    "dropdeladd": "54449 ROAD 432",
    "dropdelcty": "BASS LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 936049998,
    "dropphyadd": "54449 ROAD 432",
    "dropphycty": "BASS LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 936049998,
    "dropmaladd": "54449 ROAD 432",
    "dropmalcty": "BASS LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 936049998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596423710,
    "dropfax": 5596417597
  },
  {
    "dcode": "D",
    "dropkey": "PZ20210",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "1836 OLD ARCATA RD",
    "dropdelcty": "BAYSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 955249901,
    "dropphyadd": "1836 OLD ARCATA RD",
    "dropphycty": "BAYSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 955249901,
    "dropmaladd": "1836 OLD ARCATA RD",
    "dropmalcty": "BAYSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 955249901,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078221683,
    "dropfax": 7078262063
  },
  {
    "dcode": "D",
    "dropkey": "PZ20222",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "950 BEAUMONT AVE",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "CA",
    "dropdelzpp": 922239998,
    "dropphyadd": "950 BEAUMONT AVE",
    "dropphycty": "BEAUMONT",
    "dropphyst": "CA",
    "dropphyzpp": 922239998,
    "dropmaladd": "950 BEAUMONT AVE",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "CA",
    "dropmalzpp": 922239998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9518455895,
    "dropsitcph": 9518454715,
    "dropfax": 9518450915
  },
  {
    "dcode": "D",
    "dropkey": "PZ20230",
    "droptype": "D",
    "dropname": "BELL GARDENS",
    "dropdeladd": "7001 GARFIELD AVE",
    "dropdelcty": "BELL GARDENS",
    "dropdelst": "CA",
    "dropdelzpp": 902019993,
    "dropphyadd": "7001 GARFIELD AVE",
    "dropphycty": "BELL GARDENS",
    "dropphyst": "CA",
    "dropphyzpp": 902019993,
    "dropmaladd": "7001 GARFIELD AVE",
    "dropmalcty": "BELL GARDENS",
    "dropmalst": "CA",
    "dropmalzpp": 902019993,
    "dropsitphn": 5624942406,
    "dropsitlph": 5628061236,
    "dropsitcph": 5628061625,
    "dropfax": 5628069206
  },
  {
    "dcode": "D",
    "dropkey": "PZ20235",
    "droptype": "D",
    "dropname": "BELLA VISTA",
    "dropdeladd": "22515 OLD ALTURAS RD",
    "dropdelcty": "BELLA VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 960089998,
    "dropphyadd": "22515 OLD ALTURAS RD",
    "dropphycty": "BELLA VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 960089998,
    "dropmaladd": "22515 OLD ALTURAS RD",
    "dropmalcty": "BELLA VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 960089998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305493765,
    "dropsitcph": 5305493765,
    "dropfax": 5305493554
  },
  {
    "dcode": "D",
    "dropkey": "PZ20237",
    "droptype": "D",
    "dropname": "BELLFLOWER",
    "dropdeladd": "9835 FLOWER ST",
    "dropdelcty": "BELLFLOWER",
    "dropdelst": "CA",
    "dropdelzpp": 907069998,
    "dropphyadd": "9835 FLOWER ST",
    "dropphycty": "BELLFLOWER",
    "dropphyst": "CA",
    "dropphyzpp": 907069998,
    "dropmaladd": "9835 FLOWER ST",
    "dropmalcty": "BELLFLOWER",
    "dropmalst": "CA",
    "dropmalzpp": 907069998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5628041089,
    "dropsitcph": 5629201776,
    "dropfax": 5628660545
  },
  {
    "dcode": "D",
    "dropkey": "PZ20241",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "640 MASONIC WAY",
    "dropdelcty": "BELMONT",
    "dropdelst": "CA",
    "dropdelzpp": 940029998,
    "dropphyadd": "640 MASONIC WAY",
    "dropphycty": "BELMONT",
    "dropphyst": "CA",
    "dropphyzpp": 940029998,
    "dropmaladd": "640 MASONIC WAY",
    "dropmalcty": "BELMONT",
    "dropmalst": "CA",
    "dropmalzpp": 940029998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6505919588,
    "dropsitcph": 6505919588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20246",
    "droptype": "D",
    "dropname": "BELVEDERE TIBURON",
    "dropdeladd": "6 BEACH RD",
    "dropdelcty": "BELVEDERE TIBURON",
    "dropdelst": "CA",
    "dropdelzpp": 949202366,
    "dropphyadd": "6 BEACH RD",
    "dropphycty": "BELVEDERE TIBURON",
    "dropphyst": "CA",
    "dropphyzpp": 949202366,
    "dropmaladd": "6 BEACH RD",
    "dropmalcty": "BELVEDERE TIBURON",
    "dropmalst": "CA",
    "dropmalzpp": 949202366,
    "dropsitphn": 7077785312,
    "dropsitlph": 4154351378,
    "dropsitcph": 4154355004,
    "dropfax": 4154353169
  },
  {
    "dcode": "D",
    "dropkey": "PZ20248",
    "droptype": "D",
    "dropname": "BEN LOMOND",
    "dropdeladd": "250 MAIN ST",
    "dropdelcty": "BEN LOMOND",
    "dropdelst": "CA",
    "dropdelzpp": 950059998,
    "dropphyadd": "250 MAIN ST",
    "dropphycty": "BEN LOMOND",
    "dropphyst": "CA",
    "dropphyzpp": 950059998,
    "dropmaladd": "250 MAIN ST",
    "dropmalcty": "BEN LOMOND",
    "dropmalst": "CA",
    "dropmalzpp": 950059998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313363528,
    "dropsitcph": 8313363528,
    "dropfax": 8313361857
  },
  {
    "dcode": "D",
    "dropkey": "PZ20249",
    "droptype": "D",
    "dropname": "BENICIA",
    "dropdeladd": "290 E L ST",
    "dropdelcty": "BENICIA",
    "dropdelst": "CA",
    "dropdelzpp": 945109998,
    "dropphyadd": "290 E L ST",
    "dropphycty": "BENICIA",
    "dropphyst": "CA",
    "dropphyzpp": 945109998,
    "dropmaladd": "290 E L ST",
    "dropmalcty": "BENICIA",
    "dropmalst": "CA",
    "dropmalzpp": 945109998,
    "dropsitphn": 5104337569,
    "dropsitlph": 7077511935,
    "dropsitcph": 7077454019,
    "dropfax": 7077453031
  },
  {
    "dcode": "D",
    "dropkey": "PZ20251",
    "droptype": "D",
    "dropname": "BERKELEY",
    "dropdeladd": "2000 ALLSTON WAY",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947049998,
    "dropphyadd": "2000 ALLSTON WAY",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947049998,
    "dropmaladd": "2000 ALLSTON WAY",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947049998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106496775,
    "dropsitcph": 5106493114,
    "dropfax": 5106493124
  },
  {
    "dcode": "D",
    "dropkey": "PZ20255",
    "droptype": "D",
    "dropname": "BERRY CREEK",
    "dropdeladd": "5 WHISPERING CHAPEL LN",
    "dropdelcty": "BERRY CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 959169998,
    "dropphyadd": "5 WHISPERING CHAPEL LN",
    "dropphycty": "BERRY CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 959169998,
    "dropmaladd": "5 WHISPERING CHAPEL LN",
    "dropmalcty": "BERRY CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 959169998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305893162,
    "dropsitcph": 5305893162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20257",
    "droptype": "D",
    "dropname": "BETHEL ISLAND",
    "dropdeladd": "6444 BETHEL ISLAND RD",
    "dropdelcty": "BETHEL ISLAND",
    "dropdelst": "CA",
    "dropdelzpp": 945115200,
    "dropphyadd": "6444 BETHEL ISLAND RD",
    "dropphycty": "BETHEL ISLAND",
    "dropphyst": "CA",
    "dropphyzpp": 945115200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BETHEL ISLAND",
    "dropmalst": "CA",
    "dropmalzpp": 945119998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 9256842561,
    "dropfax": 6514566355
  },
  {
    "dcode": "D",
    "dropkey": "PZ20259",
    "droptype": "D",
    "dropname": "BEVERLY HILLS",
    "dropdeladd": "325 N MAPLE DR STE 150",
    "dropdelcty": "BEVERLY HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 902109998,
    "dropphyadd": "325 N MAPLE DR STE 150",
    "dropphycty": "BEVERLY HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 902109998,
    "dropmaladd": "325 N MAPLE DR STE 150",
    "dropmalcty": "BEVERLY HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 902109998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3102473455,
    "dropsitcph": 3102473455,
    "dropfax": 3102740359
  },
  {
    "dcode": "D",
    "dropkey": "PZ20263",
    "droptype": "D",
    "dropname": "BIEBER",
    "dropdeladd": "105 BRIDGE ST",
    "dropdelcty": "BIEBER",
    "dropdelst": "CA",
    "dropdelzpp": 960099998,
    "dropphyadd": "105 BRIDGE ST",
    "dropphycty": "BIEBER",
    "dropphyst": "CA",
    "dropphyzpp": 960099998,
    "dropmaladd": "105 BRIDGE ST",
    "dropmalcty": "BIEBER",
    "dropmalst": "CA",
    "dropmalzpp": 960099998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302945570,
    "dropsitcph": 5302945570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20264",
    "droptype": "D",
    "dropname": "BIG BAR",
    "dropdeladd": "27761 STATE HIGHWAY 299",
    "dropdelcty": "BIG BAR",
    "dropdelst": "CA",
    "dropdelzpp": 960109400,
    "dropphyadd": "27761 STATE HIGHWAY 299",
    "dropphycty": "BIG BAR",
    "dropphyst": "CA",
    "dropphyzpp": 960109400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG BAR",
    "dropmalst": "CA",
    "dropmalzpp": 960109998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306236697,
    "dropsitcph": 5306236697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20267",
    "droptype": "D",
    "dropname": "BIG BEAR CITY",
    "dropdeladd": "120 W COUNTRY CLUB BLVD",
    "dropdelcty": "BIG BEAR CITY",
    "dropdelst": "CA",
    "dropdelzpp": 923149998,
    "dropphyadd": "120 W COUNTRY CLUB BLVD",
    "dropphycty": "BIG BEAR CITY",
    "dropphyst": "CA",
    "dropphyzpp": 923149998,
    "dropmaladd": "120 W COUNTRY CLUB BLVD",
    "dropmalcty": "BIG BEAR CITY",
    "dropmalst": "CA",
    "dropmalzpp": 923149998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9095858762,
    "dropsitcph": 9095857132,
    "dropfax": 9095851348
  },
  {
    "dcode": "D",
    "dropkey": "PZ20268",
    "droptype": "D",
    "dropname": "BIG BEAR LAKE",
    "dropdeladd": "472 PINE KNOT BLVD",
    "dropdelcty": "BIG BEAR LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 923159996,
    "dropphyadd": "472 PINE KNOT BLVD",
    "dropphycty": "BIG BEAR LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 923159996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG BEAR LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 923159998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098663167,
    "dropsitcph": 9098661035,
    "dropfax": 9098663731
  },
  {
    "dcode": "D",
    "dropkey": "PZ20269",
    "droptype": "D",
    "dropname": "BIG BEND",
    "dropdeladd": "30487 HOT SPRINGS RD",
    "dropdelcty": "BIG BEND",
    "dropdelst": "CA",
    "dropdelzpp": 960119998,
    "dropphyadd": "30487 HOT SPRINGS RD",
    "dropphycty": "BIG BEND",
    "dropphyst": "CA",
    "dropphyzpp": 960119998,
    "dropmaladd": "30487 HOT SPRINGS RD",
    "dropmalcty": "BIG BEND",
    "dropmalst": "CA",
    "dropmalzpp": 960119998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303376556,
    "dropsitcph": 5303376556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20270",
    "droptype": "D",
    "dropname": "BIG CREEK",
    "dropdeladd": "55083 POINT RD",
    "dropdelcty": "BIG CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 936059998,
    "dropphyadd": "55083 POINT RD",
    "dropphycty": "BIG CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 936059998,
    "dropmaladd": "55083 POINT RD",
    "dropmalcty": "BIG CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 936059998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598933332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20271",
    "droptype": "D",
    "dropname": "BIG OAK FLAT",
    "dropdeladd": "17850 HIGHWAY 120",
    "dropdelcty": "BIG OAK FLAT",
    "dropdelst": "CA",
    "dropdelzpp": 953059998,
    "dropphyadd": "17850 HIGHWAY 120",
    "dropphycty": "BIG OAK FLAT",
    "dropphyst": "CA",
    "dropphyzpp": 953059998,
    "dropmaladd": "17850 HIGHWAY 120",
    "dropmalcty": "BIG OAK FLAT",
    "dropmalst": "CA",
    "dropmalzpp": 953059998,
    "dropsitphn": 9163738025,
    "dropsitlph": 3508886004,
    "dropsitcph": 3508886004,
    "dropfax": 3508886006
  },
  {
    "dcode": "D",
    "dropkey": "PZ20272",
    "droptype": "D",
    "dropname": "BIG PINE",
    "dropdeladd": "140 N MAIN ST",
    "dropdelcty": "BIG PINE",
    "dropdelst": "CA",
    "dropdelzpp": 935139997,
    "dropphyadd": "140 N MAIN ST",
    "dropphycty": "BIG PINE",
    "dropphyst": "CA",
    "dropphyzpp": 935139997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG PINE",
    "dropmalst": "CA",
    "dropmalzpp": 935139998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7609683052,
    "dropsitcph": 7609382542,
    "dropfax": 7609382960
  },
  {
    "dcode": "D",
    "dropkey": "PZ20274",
    "droptype": "D",
    "dropname": "BIG SUR",
    "dropdeladd": "47500 HIGHWAY 1",
    "dropdelcty": "BIG SUR",
    "dropdelst": "CA",
    "dropdelzpp": 939209998,
    "dropphyadd": "47500 HIGHWAY 1",
    "dropphycty": "BIG SUR",
    "dropphyst": "CA",
    "dropphyzpp": 939209998,
    "dropmaladd": "47500 HIGHWAY 1",
    "dropmalcty": "BIG SUR",
    "dropmalst": "CA",
    "dropmalzpp": 939209998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316672305,
    "dropfax": 8316672308
  },
  {
    "dcode": "D",
    "dropkey": "PZ20275",
    "droptype": "D",
    "dropname": "BIGGS",
    "dropdeladd": "2994 6TH ST",
    "dropdelcty": "BIGGS",
    "dropdelst": "CA",
    "dropdelzpp": 959179998,
    "dropphyadd": "2994 6TH ST",
    "dropphycty": "BIGGS",
    "dropphyst": "CA",
    "dropphyzpp": 959179998,
    "dropmaladd": "2994 6TH ST",
    "dropmalcty": "BIGGS",
    "dropmalst": "CA",
    "dropmalzpp": 959179998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308685938,
    "dropsitcph": 5308685938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20278",
    "droptype": "D",
    "dropname": "BIOLA",
    "dropdeladd": "4672 N BIOLA AVE",
    "dropdelcty": "BIOLA",
    "dropdelst": "CA",
    "dropdelzpp": 936069998,
    "dropphyadd": "4672 N BIOLA AVE",
    "dropphycty": "BIOLA",
    "dropphyst": "CA",
    "dropphyzpp": 936069998,
    "dropmaladd": "4672 N BIOLA AVE",
    "dropmalcty": "BIOLA",
    "dropmalst": "CA",
    "dropmalzpp": 936069998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598432338,
    "dropfax": 5598432644
  },
  {
    "dcode": "D",
    "dropkey": "PZ20281",
    "droptype": "D",
    "dropname": "BISHOP",
    "dropdeladd": "585 W LINE ST",
    "dropdelcty": "BISHOP",
    "dropdelst": "CA",
    "dropdelzpp": 935149998,
    "dropphyadd": "585 W LINE ST",
    "dropphycty": "BISHOP",
    "dropphyst": "CA",
    "dropphyzpp": 935149998,
    "dropmaladd": "585 W LINE ST",
    "dropmalcty": "BISHOP",
    "dropmalst": "CA",
    "dropmalzpp": 935149998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7608733526,
    "dropsitcph": 7608733526,
    "dropfax": 7608721139
  },
  {
    "dcode": "D",
    "dropkey": "PZ20289",
    "droptype": "D",
    "dropname": "BLAIRSDEN GRAEAGLE",
    "dropdeladd": "1228 WASCO TRL",
    "dropdelcty": "BLAIRSDEN GRAEAGLE",
    "dropdelst": "CA",
    "dropdelzpp": 961039997,
    "dropphyadd": "1228 WASCO TRL",
    "dropphycty": "BLAIRSDEN GRAEAGLE",
    "dropphyst": "CA",
    "dropphyzpp": 961039997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLAIRSDEN GRAEAGLE",
    "dropmalst": "CA",
    "dropmalzpp": 961039998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308362352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20290",
    "droptype": "D",
    "dropname": "BLOCKSBURG",
    "dropdeladd": "27984 ALDERPOINT RD",
    "dropdelcty": "BLOCKSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 955149900,
    "dropphyadd": "27984 ALDERPOINT RD",
    "dropphycty": "BLOCKSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 955149900,
    "dropmaladd": "27984 ALDERPOINT RD",
    "dropmalcty": "BLOCKSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 955149900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079265211,
    "dropfax": 7079265211
  },
  {
    "dcode": "D",
    "dropkey": "PZ20292",
    "droptype": "D",
    "dropname": "BLOOMINGTON",
    "dropdeladd": "10191 LINDEN AVE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "CA",
    "dropdelzpp": 923161891,
    "dropphyadd": "10191 LINDEN AVE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "CA",
    "dropphyzpp": 923161891,
    "dropmaladd": "10191 LINDEN AVE",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "CA",
    "dropmalzpp": 923161891,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098776306,
    "dropsitcph": 9098775042,
    "dropfax": 9098775146
  },
  {
    "dcode": "D",
    "dropkey": "PZ20300",
    "droptype": "D",
    "dropname": "BLUE JAY",
    "dropdeladd": "27177 STATE HIGHWAY 189 STE F",
    "dropdelcty": "BLUE JAY",
    "dropdelst": "CA",
    "dropdelzpp": 923170017,
    "dropphyadd": "27177 STATE HIGHWAY 189 STE F",
    "dropphycty": "BLUE JAY",
    "dropphyst": "CA",
    "dropphyzpp": 923170017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BLUE JAY",
    "dropmalst": "CA",
    "dropmalzpp": 923179998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093375258,
    "dropsitcph": 9093370394,
    "dropfax": 9093374920
  },
  {
    "dcode": "D",
    "dropkey": "PZ20301",
    "droptype": "D",
    "dropname": "BLUE LAKE",
    "dropdeladd": "411 1ST ST",
    "dropdelcty": "BLUE LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 955259747,
    "dropphyadd": "411 1ST ST",
    "dropphycty": "BLUE LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 955259747,
    "dropmaladd": "411 1ST ST",
    "dropmalcty": "BLUE LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 955259747,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076685115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20305",
    "droptype": "D",
    "dropname": "BLYTHE",
    "dropdeladd": "200 E MURPHY ST",
    "dropdelcty": "BLYTHE",
    "dropdelst": "CA",
    "dropdelzpp": 922259998,
    "dropphyadd": "200 E MURPHY ST",
    "dropphycty": "BLYTHE",
    "dropphyst": "CA",
    "dropphyzpp": 922259998,
    "dropmaladd": "200 E MURPHY ST",
    "dropmalcty": "BLYTHE",
    "dropmalst": "CA",
    "dropmalzpp": 922259998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7609226158,
    "dropsitcph": 7609221711,
    "dropfax": 7609229537
  },
  {
    "dcode": "D",
    "dropkey": "PZ20307",
    "droptype": "D",
    "dropname": "BODEGA",
    "dropdeladd": "17208 BODEGA HWY",
    "dropdelcty": "BODEGA",
    "dropdelst": "CA",
    "dropdelzpp": 949229900,
    "dropphyadd": "17208 BODEGA HWY",
    "dropphycty": "BODEGA",
    "dropphyst": "CA",
    "dropphyzpp": 949229900,
    "dropmaladd": "17208 BODEGA HWY",
    "dropmalcty": "BODEGA",
    "dropmalst": "CA",
    "dropmalzpp": 949229900,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078763186,
    "dropfax": 7078769629
  },
  {
    "dcode": "D",
    "dropkey": "PZ20308",
    "droptype": "D",
    "dropname": "BODEGA BAY",
    "dropdeladd": "537 SMITH BROTHERS RD",
    "dropdelcty": "BODEGA BAY",
    "dropdelst": "CA",
    "dropdelzpp": 949239775,
    "dropphyadd": "537 SMITH BROTHERS RD",
    "dropphycty": "BODEGA BAY",
    "dropphyst": "CA",
    "dropphyzpp": 949239775,
    "dropmaladd": "537 SMITH BROTHERS RD",
    "dropmalcty": "BODEGA BAY",
    "dropmalst": "CA",
    "dropmalzpp": 949239775,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078753529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20309",
    "droptype": "D",
    "dropname": "BODFISH",
    "dropdeladd": "1 MILLER ST",
    "dropdelcty": "BODFISH",
    "dropdelst": "CA",
    "dropdelzpp": 932059998,
    "dropphyadd": "1 MILLER ST",
    "dropphycty": "BODFISH",
    "dropphyst": "CA",
    "dropphyzpp": 932059998,
    "dropmaladd": "1 MILLER ST",
    "dropmalcty": "BODFISH",
    "dropmalst": "CA",
    "dropmalzpp": 932059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603792837,
    "dropsitcph": 7603792837,
    "dropfax": 7605494901
  },
  {
    "dcode": "D",
    "dropkey": "PZ20310",
    "droptype": "D",
    "dropname": "BOLINAS",
    "dropdeladd": "20 BRIGHTON AVE",
    "dropdelcty": "BOLINAS",
    "dropdelst": "CA",
    "dropdelzpp": 949249998,
    "dropphyadd": "20 BRIGHTON AVE",
    "dropphycty": "BOLINAS",
    "dropphyst": "CA",
    "dropphyzpp": 949249998,
    "dropmaladd": "20 BRIGHTON AVE",
    "dropmalcty": "BOLINAS",
    "dropmalst": "CA",
    "dropmalzpp": 949249998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4158681314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20315",
    "droptype": "D",
    "dropname": "BONITA",
    "dropdeladd": "5073 CENTRAL AVE",
    "dropdelcty": "BONITA",
    "dropdelst": "CA",
    "dropdelzpp": 919029998,
    "dropphyadd": "5073 CENTRAL AVE",
    "dropphycty": "BONITA",
    "dropphyst": "CA",
    "dropphyzpp": 919029998,
    "dropmaladd": "5073 CENTRAL AVE",
    "dropmalcty": "BONITA",
    "dropmalst": "CA",
    "dropmalzpp": 919029998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194750241,
    "dropsitcph": 6194750241,
    "dropfax": 6194758879
  },
  {
    "dcode": "D",
    "dropkey": "PZ20318",
    "droptype": "D",
    "dropname": "BONSALL",
    "dropdeladd": "5521 MISSION RD STE D",
    "dropdelcty": "BONSALL",
    "dropdelst": "CA",
    "dropdelzpp": 920039998,
    "dropphyadd": "5521 MISSION RD STE D",
    "dropphycty": "BONSALL",
    "dropphyst": "CA",
    "dropphyzpp": 920039998,
    "dropmaladd": "5521 MISSION RD STE D",
    "dropmalcty": "BONSALL",
    "dropmalst": "CA",
    "dropmalzpp": 920039998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607588240,
    "dropsitcph": 7607584173,
    "dropfax": 7607584965
  },
  {
    "dcode": "D",
    "dropkey": "PZ20319",
    "droptype": "D",
    "dropname": "BOONVILLE",
    "dropdeladd": "14170 HIGHWAY 128",
    "dropdelcty": "BOONVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954159900,
    "dropphyadd": "14170 HIGHWAY 128",
    "dropphycty": "BOONVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954159900,
    "dropmaladd": "14170 HIGHWAY 128",
    "dropmalcty": "BOONVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954159900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078953561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20322",
    "droptype": "D",
    "dropname": "BORON",
    "dropdeladd": "26990 ANDERSON ST",
    "dropdelcty": "BORON",
    "dropdelst": "CA",
    "dropdelzpp": 935169998,
    "dropphyadd": "26990 ANDERSON ST",
    "dropphycty": "BORON",
    "dropphyst": "CA",
    "dropphyzpp": 935169998,
    "dropmaladd": "26990 ANDERSON ST",
    "dropmalcty": "BORON",
    "dropmalst": "CA",
    "dropmalzpp": 935169998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7607625184,
    "dropsitcph": 7607625184,
    "dropfax": 7607625708
  },
  {
    "dcode": "D",
    "dropkey": "PZ20323",
    "droptype": "D",
    "dropname": "BORREGO SPRINGS",
    "dropdeladd": "2599 COUNTRY CLUB RD",
    "dropdelcty": "BORREGO SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 920049998,
    "dropphyadd": "2599 COUNTRY CLUB RD",
    "dropphycty": "BORREGO SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 920049998,
    "dropmaladd": "2599 COUNTRY CLUB RD",
    "dropmalcty": "BORREGO SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 920049998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607670741,
    "dropsitcph": 7607670741,
    "dropfax": 7607674983
  },
  {
    "dcode": "D",
    "dropkey": "PZ20327",
    "droptype": "D",
    "dropname": "BOULDER CREEK",
    "dropdeladd": "200 LORENZO ST",
    "dropdelcty": "BOULDER CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 950069998,
    "dropphyadd": "200 LORENZO ST",
    "dropphycty": "BOULDER CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 950069998,
    "dropmaladd": "200 LORENZO ST",
    "dropmalcty": "BOULDER CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 950069998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313386662,
    "dropsitcph": 8313384865,
    "dropfax": 8313386081
  },
  {
    "dcode": "D",
    "dropkey": "PZ20329",
    "droptype": "D",
    "dropname": "BOULEVARD",
    "dropdeladd": "39550 OLD HIGHWAY 80 STE A",
    "dropdelcty": "BOULEVARD",
    "dropdelst": "CA",
    "dropdelzpp": 919059666,
    "dropphyadd": "39550 OLD HIGHWAY 80 STE A",
    "dropphycty": "BOULEVARD",
    "dropphyst": "CA",
    "dropphyzpp": 919059666,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOULEVARD",
    "dropmalst": "CA",
    "dropmalzpp": 919059998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6197664287,
    "dropsitcph": 6197664287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20335",
    "droptype": "D",
    "dropname": "BOYES HOT SPRINGS",
    "dropdeladd": "18092 SONOMA HWY",
    "dropdelcty": "BOYES HOT SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 954168900,
    "dropphyadd": "18092 SONOMA HWY",
    "dropphycty": "BOYES HOT SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 954168900,
    "dropmaladd": "18092 SONOMA HWY",
    "dropmalcty": "BOYES HOT SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 954169998,
    "dropsitphn": 7079383750,
    "dropsitlph": 7079383750,
    "dropsitcph": 7079383750,
    "dropfax": 7079384276
  },
  {
    "dcode": "D",
    "dropkey": "PZ20346",
    "droptype": "D",
    "dropname": "BRADLEY",
    "dropdeladd": "73101 PLEYTO ST",
    "dropdelcty": "BRADLEY",
    "dropdelst": "CA",
    "dropdelzpp": 934269682,
    "dropphyadd": "73101 PLEYTO ST",
    "dropphycty": "BRADLEY",
    "dropphyst": "CA",
    "dropphyzpp": 934269682,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADLEY",
    "dropmalst": "CA",
    "dropmalzpp": 934269998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054722377,
    "dropsitcph": 8054722377,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ20350",
    "droptype": "D",
    "dropname": "BRAWLEY",
    "dropdeladd": "401 MAIN ST",
    "dropdelcty": "BRAWLEY",
    "dropdelst": "CA",
    "dropdelzpp": 922279998,
    "dropphyadd": "401 MAIN ST",
    "dropphycty": "BRAWLEY",
    "dropphyst": "CA",
    "dropphyzpp": 922279998,
    "dropmaladd": "401 MAIN ST",
    "dropmalcty": "BRAWLEY",
    "dropmalst": "CA",
    "dropmalzpp": 922279998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7603446870,
    "dropsitcph": 7603446870,
    "dropfax": 7603444257
  },
  {
    "dcode": "D",
    "dropkey": "PZ20351",
    "droptype": "D",
    "dropname": "BREA",
    "dropdeladd": "700 E BIRCH ST",
    "dropdelcty": "BREA",
    "dropdelst": "CA",
    "dropdelzpp": 928229998,
    "dropphyadd": "700 E BIRCH ST",
    "dropphycty": "BREA",
    "dropphyst": "CA",
    "dropphyzpp": 928229998,
    "dropmaladd": "700 E BIRCH ST",
    "dropmalcty": "BREA",
    "dropmalst": "CA",
    "dropmalzpp": 928229998,
    "dropsitphn": 7145292163,
    "dropsitlph": 7145290696,
    "dropsitcph": 7145292163,
    "dropfax": 7142558023
  },
  {
    "dcode": "D",
    "dropkey": "PZ20352",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "18 OAK ST",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 945139998,
    "dropphyadd": "18 OAK ST",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 945139998,
    "dropmaladd": "18 OAK ST",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 945139998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252402067,
    "dropsitcph": 9252402065,
    "dropfax": 9255136680
  },
  {
    "dcode": "D",
    "dropkey": "PZ20355",
    "droptype": "D",
    "dropname": "BRIDGEPORT",
    "dropdeladd": "29 KINGSLEY",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CA",
    "dropdelzpp": 935179997,
    "dropphyadd": "29 KINGSLEY",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CA",
    "dropphyzpp": 935179997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CA",
    "dropmalzpp": 935179998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7609327991,
    "dropsitcph": 7609327991,
    "dropfax": 7609327470
  },
  {
    "dcode": "D",
    "dropkey": "PZ20356",
    "droptype": "D",
    "dropname": "BRIDGEVILLE",
    "dropdeladd": "24878 STATE HIGHWAY 36",
    "dropdelcty": "BRIDGEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 955269699,
    "dropphyadd": "24878 STATE HIGHWAY 36",
    "dropphycty": "BRIDGEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 955269699,
    "dropmaladd": "24878 STATE HIGHWAY 36",
    "dropmalcty": "BRIDGEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 955269699,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7077773342,
    "dropfax": 7077773342
  },
  {
    "dcode": "D",
    "dropkey": "PZ20360",
    "droptype": "D",
    "dropname": "BRISBANE",
    "dropdeladd": "280 OLD COUNTY RD",
    "dropdelcty": "BRISBANE",
    "dropdelst": "CA",
    "dropdelzpp": 940051301,
    "dropphyadd": "280 OLD COUNTY RD",
    "dropphycty": "BRISBANE",
    "dropphyst": "CA",
    "dropphyzpp": 940051301,
    "dropmaladd": "280 OLD COUNTY RD",
    "dropmalcty": "BRISBANE",
    "dropmalst": "CA",
    "dropmalzpp": 940051301,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156570357,
    "dropsitcph": 4156573326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20370",
    "droptype": "D",
    "dropname": "BROOKDALE",
    "dropdeladd": "105 PACIFIC AVE",
    "dropdelcty": "BROOKDALE",
    "dropdelst": "CA",
    "dropdelzpp": 950079800,
    "dropphyadd": "105 PACIFIC AVE",
    "dropphycty": "BROOKDALE",
    "dropphyst": "CA",
    "dropphyzpp": 950079800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BROOKDALE",
    "dropmalst": "CA",
    "dropmalzpp": 950079998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313386017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20373",
    "droptype": "D",
    "dropname": "BROOKS",
    "dropdeladd": "14055 STATE HIGHWAY 16",
    "dropdelcty": "BROOKS",
    "dropdelst": "CA",
    "dropdelzpp": 956069998,
    "dropphyadd": "14055 STATE HIGHWAY 16",
    "dropphycty": "BROOKS",
    "dropphyst": "CA",
    "dropphyzpp": 956069998,
    "dropmaladd": "14055 STATE HIGHWAY 16",
    "dropmalcty": "BROOKS",
    "dropmalst": "CA",
    "dropmalzpp": 956069998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307963178,
    "dropsitcph": 5307963178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20374",
    "droptype": "D",
    "dropname": "BROWNS VALLEY",
    "dropdeladd": "5534 MARYSVILLE RD",
    "dropdelcty": "BROWNS VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959189998,
    "dropphyadd": "5534 MARYSVILLE RD",
    "dropphycty": "BROWNS VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959189998,
    "dropmaladd": "5534 MARYSVILLE RD",
    "dropmalcty": "BROWNS VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959189998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307430578,
    "dropsitcph": 5307430578,
    "dropfax": 5307421266
  },
  {
    "dcode": "D",
    "dropkey": "PZ20375",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "8975 FRENCHTOWN EXT",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959199998,
    "dropphyadd": "8975 FRENCHTOWN EXT",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959199998,
    "dropmaladd": "8975 FRENCHTOWN EXT",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959199998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306752496,
    "dropsitcph": 5306752496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20386",
    "droptype": "D",
    "dropname": "BUELLTON",
    "dropdeladd": "140 W HIGHWAY 246",
    "dropdelcty": "BUELLTON",
    "dropdelst": "CA",
    "dropdelzpp": 934279721,
    "dropphyadd": "140 W HIGHWAY 246",
    "dropphycty": "BUELLTON",
    "dropphyst": "CA",
    "dropphyzpp": 934279721,
    "dropmaladd": "140 W HIGHWAY 246",
    "dropmalcty": "BUELLTON",
    "dropmalst": "CA",
    "dropmalzpp": 934279721,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056881608,
    "dropsitcph": 8056881608,
    "dropfax": 8056882148
  },
  {
    "dcode": "D",
    "dropkey": "PZ20387",
    "droptype": "D",
    "dropname": "BUENA PARK",
    "dropdeladd": "7377 LA PALMA AVE",
    "dropdelcty": "BUENA PARK",
    "dropdelst": "CA",
    "dropdelzpp": 906229998,
    "dropphyadd": "7377 LA PALMA AVE",
    "dropphycty": "BUENA PARK",
    "dropphyst": "CA",
    "dropphyzpp": 906229998,
    "dropmaladd": "7377 LA PALMA AVE",
    "dropmalcty": "BUENA PARK",
    "dropmalst": "CA",
    "dropmalzpp": 906229998,
    "dropsitphn": 7145238701,
    "dropsitlph": 7145231196,
    "dropsitcph": 7145238701,
    "dropfax": 7145235411
  },
  {
    "dcode": "D",
    "dropkey": "PZ20396",
    "droptype": "D",
    "dropname": "BURBANK",
    "dropdeladd": "2140 N HOLLYWOOD WAY",
    "dropdelcty": "BURBANK",
    "dropdelst": "CA",
    "dropdelzpp": 915059998,
    "dropphyadd": "2140 N HOLLYWOOD WAY",
    "dropphycty": "BURBANK",
    "dropphyst": "CA",
    "dropphyzpp": 915059998,
    "dropmaladd": "2140 N HOLLYWOOD WAY",
    "dropmalcty": "BURBANK",
    "dropmalst": "CA",
    "dropmalzpp": 915059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188460758,
    "dropsitcph": 8188460758,
    "dropfax": 8185583983
  },
  {
    "dcode": "D",
    "dropkey": "PZ20398",
    "droptype": "D",
    "dropname": "BURLINGAME",
    "dropdeladd": "329 PRIMROSE RD",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "CA",
    "dropdelzpp": 940109998,
    "dropphyadd": "329 PRIMROSE RD",
    "dropphycty": "BURLINGAME",
    "dropphyst": "CA",
    "dropphyzpp": 940109998,
    "dropmaladd": "329 PRIMROSE RD",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "CA",
    "dropmalzpp": 940109998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6506859862,
    "dropsitcph": 6505521039,
    "dropfax": 6503437583
  },
  {
    "dcode": "D",
    "dropkey": "PZ20400",
    "droptype": "D",
    "dropname": "BURNEY",
    "dropdeladd": "20655 COMMERCE WAY",
    "dropdelcty": "BURNEY",
    "dropdelst": "CA",
    "dropdelzpp": 960139998,
    "dropphyadd": "20655 COMMERCE WAY",
    "dropphycty": "BURNEY",
    "dropphyst": "CA",
    "dropphyzpp": 960139998,
    "dropmaladd": "20655 COMMERCE WAY",
    "dropmalcty": "BURNEY",
    "dropmalst": "CA",
    "dropmalzpp": 960139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303355430,
    "dropsitcph": 5303355430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20401",
    "droptype": "D",
    "dropname": "BURNT RANCH",
    "dropdeladd": "10271C HIGHWAY 299",
    "dropdelcty": "BURNT RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 955279508,
    "dropphyadd": "10271C HIGHWAY 299",
    "dropphycty": "BURNT RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 955279508,
    "dropmaladd": "10271C HIGHWAY 299",
    "dropmalcty": "BURNT RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 955279508,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 5306292847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20404",
    "droptype": "D",
    "dropname": "BURSON",
    "dropdeladd": "3171 HWY 12",
    "dropdelcty": "BURSON",
    "dropdelst": "CA",
    "dropdelzpp": 952257442,
    "dropphyadd": "3171 HWY 12",
    "dropphycty": "BURSON",
    "dropphyst": "CA",
    "dropphyzpp": 952257442,
    "dropmaladd": "3171 HWY 12",
    "dropmalcty": "BURSON",
    "dropmalst": "CA",
    "dropmalzpp": 952257442,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097721362,
    "dropsitcph": 2097721362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20407",
    "droptype": "D",
    "dropname": "BUTTE CITY",
    "dropdeladd": "31 KILARNEY ST",
    "dropdelcty": "BUTTE CITY",
    "dropdelst": "CA",
    "dropdelzpp": 959209998,
    "dropphyadd": "31 KILARNEY ST",
    "dropphycty": "BUTTE CITY",
    "dropphyst": "CA",
    "dropphyzpp": 959209998,
    "dropmaladd": "31 KILARNEY ST",
    "dropmalcty": "BUTTE CITY",
    "dropmalst": "CA",
    "dropmalzpp": 959209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309822266,
    "dropsitcph": 5309822266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20410",
    "droptype": "D",
    "dropname": "BUTTONWILLOW",
    "dropdeladd": "121 N MAIN ST",
    "dropdelcty": "BUTTONWILLOW",
    "dropdelst": "CA",
    "dropdelzpp": 932069998,
    "dropphyadd": "121 N MAIN ST",
    "dropphycty": "BUTTONWILLOW",
    "dropphyst": "CA",
    "dropphyzpp": 932069998,
    "dropmaladd": "121 N MAIN ST",
    "dropmalcty": "BUTTONWILLOW",
    "dropmalst": "CA",
    "dropmalzpp": 932069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617645460,
    "dropsitcph": 6617645460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20411",
    "droptype": "D",
    "dropname": "BYRON",
    "dropdeladd": "3852 MAIN ST",
    "dropdelcty": "BYRON",
    "dropdelst": "CA",
    "dropdelzpp": 945145100,
    "dropphyadd": "3852 MAIN ST",
    "dropphycty": "BYRON",
    "dropphyst": "CA",
    "dropphyzpp": 945145100,
    "dropmaladd": "3852 MAIN ST",
    "dropmalcty": "BYRON",
    "dropmalst": "CA",
    "dropmalzpp": 945149997,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 9256342600,
    "dropfax": 9256342831
  },
  {
    "dcode": "D",
    "dropkey": "PZ20421",
    "droptype": "D",
    "dropname": "CABAZON",
    "dropdeladd": "50360 RAMONA RD",
    "dropdelcty": "CABAZON",
    "dropdelst": "CA",
    "dropdelzpp": 922309998,
    "dropphyadd": "50360 RAMONA RD",
    "dropphycty": "CABAZON",
    "dropphyst": "CA",
    "dropphyzpp": 922309998,
    "dropmaladd": "50360 RAMONA RD",
    "dropmalcty": "CABAZON",
    "dropmalst": "CA",
    "dropmalzpp": 922309998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9518496233,
    "dropsitcph": 9518496233,
    "dropfax": 9518499543
  },
  {
    "dcode": "D",
    "dropkey": "PZ20441",
    "droptype": "D",
    "dropname": "CALEXICO",
    "dropdeladd": "1101 OLLIE AVE",
    "dropdelcty": "CALEXICO",
    "dropdelst": "CA",
    "dropdelzpp": 922319998,
    "dropphyadd": "1101 OLLIE AVE",
    "dropphycty": "CALEXICO",
    "dropphyst": "CA",
    "dropphyzpp": 922319998,
    "dropmaladd": "1101 OLLIE AVE",
    "dropmalcty": "CALEXICO",
    "dropmalst": "CA",
    "dropmalzpp": 922319998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603572011,
    "dropsitcph": 7603570206,
    "dropfax": 7603573846
  },
  {
    "dcode": "D",
    "dropkey": "PZ20442",
    "droptype": "D",
    "dropname": "CALIENTE",
    "dropdeladd": "27750 CALIENTE BODFISH RD",
    "dropdelcty": "CALIENTE",
    "dropdelst": "CA",
    "dropdelzpp": 935189997,
    "dropphyadd": "27750 CALIENTE BODFISH RD",
    "dropphycty": "CALIENTE",
    "dropphyst": "CA",
    "dropphyzpp": 935189997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CALIENTE",
    "dropmalst": "CA",
    "dropmalzpp": 935189998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618672303,
    "dropsitcph": 6618672303,
    "dropfax": 6618673507
  },
  {
    "dcode": "D",
    "dropkey": "PZ20449",
    "droptype": "D",
    "dropname": "CALIFORNIA HOT SPRINGS",
    "dropdeladd": "42231 HOT SPRINGS DR",
    "dropdelcty": "CALIFORNIA HOT SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 932079998,
    "dropphyadd": "42231 HOT SPRINGS DR",
    "dropphycty": "CALIFORNIA HOT SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 932079998,
    "dropmaladd": "42231 HOT SPRINGS DR",
    "dropmalcty": "CALIFORNIA HOT SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 932079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615486463,
    "dropsitcph": 6615486463,
    "dropfax": 6615486202
  },
  {
    "dcode": "D",
    "dropkey": "PZ20455",
    "droptype": "D",
    "dropname": "CALIMESA",
    "dropdeladd": "600 W AVENUE L",
    "dropdelcty": "CALIMESA",
    "dropdelst": "CA",
    "dropdelzpp": 923201149,
    "dropphyadd": "600 W AVENUE L",
    "dropphycty": "CALIMESA",
    "dropphyst": "CA",
    "dropphyzpp": 923201149,
    "dropmaladd": "600 W AVENUE L",
    "dropmalcty": "CALIMESA",
    "dropmalst": "CA",
    "dropmalzpp": 923201149,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097951022,
    "dropsitcph": 9097958124,
    "dropfax": 9097954594
  },
  {
    "dcode": "D",
    "dropkey": "PZ20456",
    "droptype": "D",
    "dropname": "CALIPATRIA",
    "dropdeladd": "190 W MAIN ST",
    "dropdelcty": "CALIPATRIA",
    "dropdelst": "CA",
    "dropdelzpp": 922339998,
    "dropphyadd": "190 W MAIN ST",
    "dropphycty": "CALIPATRIA",
    "dropphyst": "CA",
    "dropphyzpp": 922339998,
    "dropmaladd": "190 W MAIN ST",
    "dropmalcty": "CALIPATRIA",
    "dropmalst": "CA",
    "dropmalzpp": 922339998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603482402,
    "dropsitcph": 7603482402,
    "dropfax": 7603487434
  },
  {
    "dcode": "D",
    "dropkey": "PZ20457",
    "droptype": "D",
    "dropname": "CALISTOGA",
    "dropdeladd": "1013 WASHINGTON ST",
    "dropdelcty": "CALISTOGA",
    "dropdelst": "CA",
    "dropdelzpp": 945159998,
    "dropphyadd": "1013 WASHINGTON ST",
    "dropphycty": "CALISTOGA",
    "dropphyst": "CA",
    "dropphyzpp": 945159998,
    "dropmaladd": "1013 WASHINGTON ST",
    "dropmalcty": "CALISTOGA",
    "dropmalst": "CA",
    "dropmalzpp": 945159998,
    "dropsitphn": 7079426661,
    "dropsitlph": 7079426661,
    "dropsitcph": 7079426661,
    "dropfax": 7079426058
  },
  {
    "dcode": "D",
    "dropkey": "PZ20458",
    "droptype": "D",
    "dropname": "CALLAHAN",
    "dropdeladd": "12436 S STATE HIGHWAY 3",
    "dropdelcty": "CALLAHAN",
    "dropdelst": "CA",
    "dropdelzpp": 960149998,
    "dropphyadd": "12436 S STATE HIGHWAY 3",
    "dropphycty": "CALLAHAN",
    "dropphyst": "CA",
    "dropphyzpp": 960149998,
    "dropmaladd": "12436 S STATE HIGHWAY 3",
    "dropmalcty": "CALLAHAN",
    "dropmalst": "CA",
    "dropmalzpp": 960149998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304675155,
    "dropsitcph": 5304675155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20464",
    "droptype": "D",
    "dropname": "CAMARILLO",
    "dropdeladd": "2150 PICKWICK DR",
    "dropdelcty": "CAMARILLO",
    "dropdelst": "CA",
    "dropdelzpp": 930109998,
    "dropphyadd": "2150 PICKWICK DR",
    "dropphycty": "CAMARILLO",
    "dropphyst": "CA",
    "dropphyzpp": 930109998,
    "dropmaladd": "2150 PICKWICK DR",
    "dropmalcty": "CAMARILLO",
    "dropmalst": "CA",
    "dropmalzpp": 930109998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8053839804,
    "dropsitcph": 8053839804,
    "dropfax": 8053898924
  },
  {
    "dcode": "D",
    "dropkey": "PZ20465",
    "droptype": "D",
    "dropname": "CAMBRIA",
    "dropdeladd": "4100 BRIDGE ST",
    "dropdelcty": "CAMBRIA",
    "dropdelst": "CA",
    "dropdelzpp": 934289998,
    "dropphyadd": "4100 BRIDGE ST",
    "dropphycty": "CAMBRIA",
    "dropphyst": "CA",
    "dropphyzpp": 934289998,
    "dropmaladd": "4100 BRIDGE ST",
    "dropmalcty": "CAMBRIA",
    "dropmalst": "CA",
    "dropmalzpp": 934289998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059246029,
    "dropsitcph": 8059246029,
    "dropfax": 8059271385
  },
  {
    "dcode": "D",
    "dropkey": "PZ20470",
    "droptype": "D",
    "dropname": "CAMINO",
    "dropdeladd": "4120 CARSON RD",
    "dropdelcty": "CAMINO",
    "dropdelst": "CA",
    "dropdelzpp": 957099998,
    "dropphyadd": "4120 CARSON RD",
    "dropphycty": "CAMINO",
    "dropphyst": "CA",
    "dropphyzpp": 957099998,
    "dropmaladd": "4120 CARSON RD",
    "dropmalcty": "CAMINO",
    "dropmalst": "CA",
    "dropmalzpp": 957099998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306444146,
    "dropsitcph": 5306446313,
    "dropfax": 5303035618
  },
  {
    "dcode": "D",
    "dropkey": "PZ20472",
    "droptype": "D",
    "dropname": "CAMP MEEKER",
    "dropdeladd": "5240 BOHEMIAN HWY",
    "dropdelcty": "CAMP MEEKER",
    "dropdelst": "CA",
    "dropdelzpp": 954199600,
    "dropphyadd": "5240 BOHEMIAN HWY",
    "dropphycty": "CAMP MEEKER",
    "dropphyst": "CA",
    "dropphyzpp": 954199600,
    "dropmaladd": "5240 BOHEMIAN HWY",
    "dropmalcty": "CAMP MEEKER",
    "dropmalst": "CA",
    "dropmalzpp": 954199998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078742231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20479",
    "droptype": "D",
    "dropname": "CAMPBELL",
    "dropdeladd": "500 W HAMILTON AVE",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "CA",
    "dropdelzpp": 950089998,
    "dropphyadd": "500 W HAMILTON AVE",
    "dropphycty": "CAMPBELL",
    "dropphyst": "CA",
    "dropphyzpp": 950089998,
    "dropmaladd": "500 W HAMILTON AVE",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "CA",
    "dropmalzpp": 950089998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4083785780,
    "dropsitcph": 4083780226,
    "dropfax": 4083748777
  },
  {
    "dcode": "D",
    "dropkey": "PZ20480",
    "droptype": "D",
    "dropname": "CAMPO",
    "dropdeladd": "951 JEB STUART RD",
    "dropdelcty": "CAMPO",
    "dropdelst": "CA",
    "dropdelzpp": 919069998,
    "dropphyadd": "951 JEB STUART RD",
    "dropphycty": "CAMPO",
    "dropphyst": "CA",
    "dropphyzpp": 919069998,
    "dropmaladd": "951 JEB STUART RD",
    "dropmalcty": "CAMPO",
    "dropmalst": "CA",
    "dropmalzpp": 919069998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194785466,
    "dropsitcph": 6194785466,
    "dropfax": 6194789537
  },
  {
    "dcode": "D",
    "dropkey": "PZ20483",
    "droptype": "D",
    "dropname": "CAMPTONVILLE",
    "dropdeladd": "15318 CLEVELAND AVE",
    "dropdelcty": "CAMPTONVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959229998,
    "dropphyadd": "15318 CLEVELAND AVE",
    "dropphycty": "CAMPTONVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959229998,
    "dropmaladd": "15318 CLEVELAND AVE",
    "dropmalcty": "CAMPTONVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302883348,
    "dropsitcph": 5302883348,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20485",
    "droptype": "D",
    "dropname": "CANBY",
    "dropdeladd": "22489 STATE HIGHWAY 299 E STE A",
    "dropdelcty": "CANBY",
    "dropdelst": "CA",
    "dropdelzpp": 960159998,
    "dropphyadd": "22489 STATE HIGHWAY 299 E STE A",
    "dropphycty": "CANBY",
    "dropphyst": "CA",
    "dropphyzpp": 960159998,
    "dropmaladd": "22489 STATE HIGHWAY 299 E STE A",
    "dropmalcty": "CANBY",
    "dropmalst": "CA",
    "dropmalzpp": 960159998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302335422,
    "dropsitcph": 5302335422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20487",
    "droptype": "D",
    "dropname": "CANOGA PARK",
    "dropdeladd": "8201 CANOGA AVE",
    "dropdelcty": "CANOGA PARK",
    "dropdelst": "CA",
    "dropdelzpp": 913049998,
    "dropphyadd": "8201 CANOGA AVE",
    "dropphycty": "CANOGA PARK",
    "dropphyst": "CA",
    "dropphyzpp": 913049998,
    "dropmaladd": "8201 CANOGA AVE",
    "dropmalcty": "CANOGA PARK",
    "dropmalst": "CA",
    "dropmalzpp": 913049998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183400679,
    "dropsitcph": 8183406741,
    "dropfax": 8184314527
  },
  {
    "dcode": "D",
    "dropkey": "PZ20489",
    "droptype": "D",
    "dropname": "CANTUA CREEK",
    "dropdeladd": "28900 W CLARKSON AVE",
    "dropdelcty": "CANTUA CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 936089998,
    "dropphyadd": "28900 W CLARKSON AVE",
    "dropphycty": "CANTUA CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 936089998,
    "dropmaladd": "28900 W CLARKSON AVE",
    "dropmalcty": "CANTUA CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 936089998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598296207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20490",
    "droptype": "D",
    "dropname": "CANYON",
    "dropdeladd": "99 PINEHURST RD",
    "dropdelcty": "CANYON",
    "dropdelst": "CA",
    "dropdelzpp": 945169800,
    "dropphyadd": "99 PINEHURST RD",
    "dropphycty": "CANYON",
    "dropphyst": "CA",
    "dropphyzpp": 945169800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CANYON",
    "dropmalst": "CA",
    "dropmalzpp": 945169998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 9253765600,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "PZ20496",
    "droptype": "D",
    "dropname": "CANYON DAM",
    "dropdeladd": "29586 STATE HIGHWAY 89",
    "dropdelcty": "CANYON DAM",
    "dropdelst": "CA",
    "dropdelzpp": 959239998,
    "dropphyadd": "29586 STATE HIGHWAY 89",
    "dropphycty": "CANYON DAM",
    "dropphyst": "CA",
    "dropphyzpp": 959239998,
    "dropmaladd": "29586 STATE HIGHWAY 89",
    "dropmalcty": "CANYON DAM",
    "dropmalst": "CA",
    "dropmalzpp": 959239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302800079,
    "dropsitcph": 5302800079,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20500",
    "droptype": "D",
    "dropname": "CAPITOLA",
    "dropdeladd": "826 BAY AVE",
    "dropdelcty": "CAPITOLA",
    "dropdelst": "CA",
    "dropdelzpp": 950109998,
    "dropphyadd": "826 BAY AVE",
    "dropphycty": "CAPITOLA",
    "dropphyst": "CA",
    "dropphyzpp": 950109998,
    "dropmaladd": "826 BAY AVE",
    "dropmalcty": "CAPITOLA",
    "dropmalst": "CA",
    "dropmalzpp": 950109998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314755529,
    "dropsitcph": 8314755948,
    "dropfax": 8314754336
  },
  {
    "dcode": "D",
    "dropkey": "PZ20508",
    "droptype": "D",
    "dropname": "CARLOTTA",
    "dropdeladd": "5429 STATE HIGHWAY 36",
    "dropdelcty": "CARLOTTA",
    "dropdelst": "CA",
    "dropdelzpp": 955289735,
    "dropphyadd": "5429 STATE HIGHWAY 36",
    "dropphycty": "CARLOTTA",
    "dropphyst": "CA",
    "dropphyzpp": 955289735,
    "dropmaladd": "5429 STATE HIGHWAY 36",
    "dropmalcty": "CARLOTTA",
    "dropmalst": "CA",
    "dropmalzpp": 955289735,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077643772,
    "dropfax": 7077683339
  },
  {
    "dcode": "D",
    "dropkey": "PZ20509",
    "droptype": "D",
    "dropname": "CARLSBAD",
    "dropdeladd": "2772 ROOSEVELT ST",
    "dropdelcty": "CARLSBAD",
    "dropdelst": "CA",
    "dropdelzpp": 920089998,
    "dropphyadd": "2772 ROOSEVELT ST",
    "dropphycty": "CARLSBAD",
    "dropphyst": "CA",
    "dropphyzpp": 920089998,
    "dropmaladd": "2772 ROOSEVELT ST",
    "dropmalcty": "CARLSBAD",
    "dropmalst": "CA",
    "dropmalzpp": 920089998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607291244,
    "dropsitcph": 7607291244,
    "dropfax": 7607295106
  },
  {
    "dcode": "D",
    "dropkey": "PZ20510",
    "droptype": "D",
    "dropname": "CARMEL",
    "dropdeladd": "3845 VIA NONA MARIE",
    "dropdelcty": "CARMEL",
    "dropdelst": "CA",
    "dropdelzpp": 939239998,
    "dropphyadd": "3845 VIA NONA MARIE",
    "dropphycty": "CARMEL",
    "dropphyst": "CA",
    "dropphyzpp": 939239998,
    "dropmaladd": "3845 VIA NONA MARIE",
    "dropmalcty": "CARMEL",
    "dropmalst": "CA",
    "dropmalzpp": 939239998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316254413,
    "dropsitcph": 8316259529,
    "dropfax": 8316251721
  },
  {
    "dcode": "D",
    "dropkey": "PZ20514",
    "droptype": "D",
    "dropname": "CARMEL VALLEY",
    "dropdeladd": "11 VIA CONTENTA",
    "dropdelcty": "CARMEL VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 939249998,
    "dropphyadd": "11 VIA CONTENTA",
    "dropphycty": "CARMEL VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 939249998,
    "dropmaladd": "11 VIA CONTENTA",
    "dropmalcty": "CARMEL VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 939249998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316592884,
    "dropsitcph": 8316598839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20517",
    "droptype": "D",
    "dropname": "CARMICHAEL",
    "dropdeladd": "6929 FAIR OAKS BLVD",
    "dropdelcty": "CARMICHAEL",
    "dropdelst": "CA",
    "dropdelzpp": 956089998,
    "dropphyadd": "6929 FAIR OAKS BLVD",
    "dropphycty": "CARMICHAEL",
    "dropphyst": "CA",
    "dropphyzpp": 956089998,
    "dropmaladd": "6929 FAIR OAKS BLVD",
    "dropmalcty": "CARMICHAEL",
    "dropmalst": "CA",
    "dropmalzpp": 956089998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9168303064,
    "dropsitcph": 9164830436,
    "dropfax": 9164837013
  },
  {
    "dcode": "D",
    "dropkey": "PZ20518",
    "droptype": "D",
    "dropname": "CARNELIAN BAY",
    "dropdeladd": "5075 N LAKE BLVD",
    "dropdelcty": "CARNELIAN BAY",
    "dropdelst": "CA",
    "dropdelzpp": 961401800,
    "dropphyadd": "5075 N LAKE BLVD",
    "dropphycty": "CARNELIAN BAY",
    "dropphyst": "CA",
    "dropphyzpp": 961401800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARNELIAN BAY",
    "dropmalst": "CA",
    "dropmalzpp": 961409998,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305462819,
    "dropsitcph": 5305464071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20519",
    "droptype": "D",
    "dropname": "CARPINTERIA",
    "dropdeladd": "5425 CARPINTERIA AVE",
    "dropdelcty": "CARPINTERIA",
    "dropdelst": "CA",
    "dropdelzpp": 930139998,
    "dropphyadd": "5425 CARPINTERIA AVE",
    "dropphycty": "CARPINTERIA",
    "dropphyst": "CA",
    "dropphyzpp": 930139998,
    "dropmaladd": "5425 CARPINTERIA AVE",
    "dropmalcty": "CARPINTERIA",
    "dropmalst": "CA",
    "dropmalzpp": 930139998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055669561,
    "dropsitcph": 8055660489,
    "dropfax": 8056843253
  },
  {
    "dcode": "D",
    "dropkey": "PZ20527",
    "droptype": "D",
    "dropname": "CARUTHERS",
    "dropdeladd": "2413 W TAHOE AVE",
    "dropdelcty": "CARUTHERS",
    "dropdelst": "CA",
    "dropdelzpp": 936099998,
    "dropphyadd": "2413 W TAHOE AVE",
    "dropphycty": "CARUTHERS",
    "dropphyst": "CA",
    "dropphyzpp": 936099998,
    "dropmaladd": "2413 W TAHOE AVE",
    "dropmalcty": "CARUTHERS",
    "dropmalst": "CA",
    "dropmalzpp": 936099998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598644928,
    "dropsitcph": 5598642438,
    "dropfax": 5598641941
  },
  {
    "dcode": "D",
    "dropkey": "PZ20533",
    "droptype": "D",
    "dropname": "CASMALIA",
    "dropdeladd": "3401 POINT SAL RD",
    "dropdelcty": "CASMALIA",
    "dropdelst": "CA",
    "dropdelzpp": 934299997,
    "dropphyadd": "3401 POINT SAL RD",
    "dropphycty": "CASMALIA",
    "dropphyst": "CA",
    "dropphyzpp": 934299997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CASMALIA",
    "dropmalst": "CA",
    "dropmalzpp": 934299998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059376824,
    "dropsitcph": 8059376824,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ20535",
    "droptype": "D",
    "dropname": "CASSEL",
    "dropdeladd": "21594 CASSEL RD",
    "dropdelcty": "CASSEL",
    "dropdelst": "CA",
    "dropdelzpp": 960169506,
    "dropphyadd": "21594 CASSEL RD",
    "dropphycty": "CASSEL",
    "dropphyst": "CA",
    "dropphyzpp": 960169506,
    "dropmaladd": "21594 CASSEL RD",
    "dropmalcty": "CASSEL",
    "dropmalst": "CA",
    "dropmalzpp": 960169506,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303283248,
    "dropsitcph": 5303283248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20538",
    "droptype": "D",
    "dropname": "CASTELLA",
    "dropdeladd": "20115 CASTLE CREEK RD",
    "dropdelcty": "CASTELLA",
    "dropdelst": "CA",
    "dropdelzpp": 960179998,
    "dropphyadd": "20115 CASTLE CREEK RD",
    "dropphycty": "CASTELLA",
    "dropphyst": "CA",
    "dropphyzpp": 960179998,
    "dropmaladd": "20115 CASTLE CREEK RD",
    "dropmalcty": "CASTELLA",
    "dropmalst": "CA",
    "dropmalzpp": 960179998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302354413,
    "dropsitcph": 5302354413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20541",
    "droptype": "D",
    "dropname": "CASTROVILLE",
    "dropdeladd": "10799 MERRITT ST",
    "dropdelcty": "CASTROVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 950129998,
    "dropphyadd": "10799 MERRITT ST",
    "dropphycty": "CASTROVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 950129998,
    "dropmaladd": "10799 MERRITT ST",
    "dropmalcty": "CASTROVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 950129998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316332636,
    "dropsitcph": 8316332636,
    "dropfax": 8316336252
  },
  {
    "dcode": "D",
    "dropkey": "PZ20545",
    "droptype": "D",
    "dropname": "CATHEDRAL CITY",
    "dropdeladd": "33490 DATE PALM DR",
    "dropdelcty": "CATHEDRAL CITY",
    "dropdelst": "CA",
    "dropdelzpp": 922349998,
    "dropphyadd": "33490 DATE PALM DR",
    "dropphycty": "CATHEDRAL CITY",
    "dropphyst": "CA",
    "dropphyzpp": 922349998,
    "dropmaladd": "33490 DATE PALM DR",
    "dropmalcty": "CATHEDRAL CITY",
    "dropmalst": "CA",
    "dropmalzpp": 922349998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602028339,
    "dropsitcph": 7602028848,
    "dropfax": 7602028559
  },
  {
    "dcode": "D",
    "dropkey": "PZ20546",
    "droptype": "D",
    "dropname": "CATHEYS VALLEY",
    "dropdeladd": "2675 STATE HIGHWAY 140",
    "dropdelcty": "CATHEYS VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 953069998,
    "dropphyadd": "2675 STATE HIGHWAY 140",
    "dropphycty": "CATHEYS VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 953069998,
    "dropmaladd": "2675 STATE HIGHWAY 140",
    "dropmalcty": "CATHEYS VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 953069998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093743481,
    "dropsitcph": 2093743481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20547",
    "droptype": "D",
    "dropname": "CAYUCOS",
    "dropdeladd": "97 ASH AVE",
    "dropdelcty": "CAYUCOS",
    "dropdelst": "CA",
    "dropdelzpp": 934301160,
    "dropphyadd": "97 ASH AVE",
    "dropphycty": "CAYUCOS",
    "dropphyst": "CA",
    "dropphyzpp": 934301160,
    "dropmaladd": "97 ASH AVE",
    "dropmalcty": "CAYUCOS",
    "dropmalst": "CA",
    "dropmalzpp": 934301160,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059953479,
    "dropsitcph": 8059953479,
    "dropfax": 8059951493
  },
  {
    "dcode": "D",
    "dropkey": "PZ20548",
    "droptype": "D",
    "dropname": "CAZADERO",
    "dropdeladd": "6145 CAZADERO HWY",
    "dropdelcty": "CAZADERO",
    "dropdelst": "CA",
    "dropdelzpp": 954219568,
    "dropphyadd": "6145 CAZADERO HWY",
    "dropphycty": "CAZADERO",
    "dropphyst": "CA",
    "dropphyzpp": 954219568,
    "dropmaladd": "6145 CAZADERO HWY",
    "dropmalcty": "CAZADERO",
    "dropmalst": "CA",
    "dropmalzpp": 954219568,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076325281,
    "dropfax": 7076326322
  },
  {
    "dcode": "D",
    "dropkey": "PZ20552",
    "droptype": "D",
    "dropname": "CEDAR GLEN",
    "dropdeladd": "28982 HOOK CREEK RD",
    "dropdelcty": "CEDAR GLEN",
    "dropdelst": "CA",
    "dropdelzpp": 923210400,
    "dropphyadd": "28982 HOOK CREEK RD",
    "dropphycty": "CEDAR GLEN",
    "dropphyst": "CA",
    "dropphyzpp": 923210400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDAR GLEN",
    "dropmalst": "CA",
    "dropmalzpp": 923219998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093374614,
    "dropsitcph": 9093374614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20557",
    "droptype": "D",
    "dropname": "CEDAR RIDGE",
    "dropdeladd": "12700 COLFAX HWY",
    "dropdelcty": "CEDAR RIDGE",
    "dropdelst": "CA",
    "dropdelzpp": 959249998,
    "dropphyadd": "12700 COLFAX HWY",
    "dropphycty": "CEDAR RIDGE",
    "dropphyst": "CA",
    "dropphyzpp": 959249998,
    "dropmaladd": "12700 COLFAX HWY",
    "dropmalcty": "CEDAR RIDGE",
    "dropmalst": "CA",
    "dropmalzpp": 959249998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302732364,
    "dropsitcph": 5302732364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20559",
    "droptype": "D",
    "dropname": "CEDARVILLE",
    "dropdeladd": "480 MAIN ST",
    "dropdelcty": "CEDARVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961049995,
    "dropphyadd": "480 MAIN ST",
    "dropphycty": "CEDARVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961049995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CEDARVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961049998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302792316,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20563",
    "droptype": "D",
    "dropname": "SHASTA LAKE",
    "dropdeladd": "4425 FRONT ST",
    "dropdelcty": "SHASTA LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 960199998,
    "dropphyadd": "4425 FRONT ST",
    "dropphycty": "SHASTA LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 960199998,
    "dropmaladd": "4425 FRONT ST",
    "dropmalcty": "SHASTA LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 960199998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302758695,
    "dropsitcph": 5302758695,
    "dropfax": 5302758330
  },
  {
    "dcode": "D",
    "dropkey": "PZ20568",
    "droptype": "D",
    "dropname": "CERES",
    "dropdeladd": "2801 MITCHELL RD",
    "dropdelcty": "CERES",
    "dropdelst": "CA",
    "dropdelzpp": 953079998,
    "dropphyadd": "2801 MITCHELL RD",
    "dropphycty": "CERES",
    "dropphyst": "CA",
    "dropphyzpp": 953079998,
    "dropmaladd": "2801 MITCHELL RD",
    "dropmalcty": "CERES",
    "dropmalst": "CA",
    "dropmalzpp": 953079998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095370740,
    "dropsitcph": 2095375669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20573",
    "droptype": "D",
    "dropname": "CHALLENGE",
    "dropdeladd": "18040 OREGON HILL RD",
    "dropdelcty": "CHALLENGE",
    "dropdelst": "CA",
    "dropdelzpp": 959259998,
    "dropphyadd": "18040 OREGON HILL RD",
    "dropphycty": "CHALLENGE",
    "dropphyst": "CA",
    "dropphyzpp": 959259998,
    "dropmaladd": "18040 OREGON HILL RD",
    "dropmalcty": "CHALLENGE",
    "dropmalst": "CA",
    "dropmalzpp": 959259998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306752353,
    "dropsitcph": 5306752353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20580",
    "droptype": "D",
    "dropname": "CHATSWORTH",
    "dropdeladd": "21606 DEVONSHIRE ST",
    "dropdelcty": "CHATSWORTH",
    "dropdelst": "CA",
    "dropdelzpp": 913119998,
    "dropphyadd": "21606 DEVONSHIRE ST",
    "dropphycty": "CHATSWORTH",
    "dropphyst": "CA",
    "dropphyzpp": 913119998,
    "dropmaladd": "21606 DEVONSHIRE ST",
    "dropmalcty": "CHATSWORTH",
    "dropmalst": "CA",
    "dropmalzpp": 913119998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187348008,
    "dropsitcph": 8187348008,
    "dropfax": 8187730408
  },
  {
    "dcode": "D",
    "dropkey": "PZ20586",
    "droptype": "D",
    "dropname": "CHESTER",
    "dropdeladd": "218 LAUREL LN",
    "dropdelcty": "CHESTER",
    "dropdelst": "CA",
    "dropdelzpp": 960209998,
    "dropphyadd": "218 LAUREL LN",
    "dropphycty": "CHESTER",
    "dropphyst": "CA",
    "dropphyzpp": 960209998,
    "dropmaladd": "218 LAUREL LN",
    "dropmalcty": "CHESTER",
    "dropmalst": "CA",
    "dropmalzpp": 960209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302584184,
    "dropsitcph": 5302584184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20588",
    "droptype": "D",
    "dropname": "CHICAGO PARK",
    "dropdeladd": "17748 LOWER COLFAX RD",
    "dropdelcty": "CHICAGO PARK",
    "dropdelst": "CA",
    "dropdelzpp": 957129998,
    "dropphyadd": "17748 LOWER COLFAX RD",
    "dropphycty": "CHICAGO PARK",
    "dropphyst": "CA",
    "dropphyzpp": 957129998,
    "dropmaladd": "17748 LOWER COLFAX RD",
    "dropmalcty": "CHICAGO PARK",
    "dropmalst": "CA",
    "dropmalzpp": 957129998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302723957,
    "dropsitcph": 5302723957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20589",
    "droptype": "D",
    "dropname": "CHICO",
    "dropdeladd": "550 VALLOMBROSA AVE",
    "dropdelcty": "CHICO",
    "dropdelst": "CA",
    "dropdelzpp": 959269998,
    "dropphyadd": "550 VALLOMBROSA AVE",
    "dropphycty": "CHICO",
    "dropphyst": "CA",
    "dropphyzpp": 959269998,
    "dropmaladd": "550 VALLOMBROSA AVE",
    "dropmalcty": "CHICO",
    "dropmalst": "CA",
    "dropmalzpp": 959269998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303432456,
    "dropsitcph": 5303432068,
    "dropfax": 5303432103
  },
  {
    "dcode": "D",
    "dropkey": "PZ20591",
    "droptype": "D",
    "dropname": "CHILCOOT",
    "dropdeladd": "94217 STATE HIGHWAY 70",
    "dropdelcty": "CHILCOOT",
    "dropdelst": "CA",
    "dropdelzpp": 961059996,
    "dropphyadd": "94217 STATE HIGHWAY 70",
    "dropphycty": "CHILCOOT",
    "dropphyst": "CA",
    "dropphyzpp": 961059996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHILCOOT",
    "dropmalst": "CA",
    "dropmalzpp": 961059998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5309934861,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20596",
    "droptype": "D",
    "dropname": "CHINESE CAMP",
    "dropdeladd": "13691 RED HL",
    "dropdelcty": "CHINESE CAMP",
    "dropdelst": "CA",
    "dropdelzpp": 953099998,
    "dropphyadd": "13691 RED HL",
    "dropphycty": "CHINESE CAMP",
    "dropphyst": "CA",
    "dropphyzpp": 953099998,
    "dropmaladd": "13691 RED HL",
    "dropmalcty": "CHINESE CAMP",
    "dropmalst": "CA",
    "dropmalzpp": 953099998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099843910,
    "dropsitcph": 2099843910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20597",
    "droptype": "D",
    "dropname": "CHINO",
    "dropdeladd": "5375 WALNUT AVE",
    "dropdelcty": "CHINO",
    "dropdelst": "CA",
    "dropdelzpp": 917089998,
    "dropphyadd": "5375 WALNUT AVE",
    "dropphycty": "CHINO",
    "dropphyst": "CA",
    "dropphyzpp": 917089998,
    "dropmaladd": "5375 WALNUT AVE",
    "dropmalcty": "CHINO",
    "dropmalst": "CA",
    "dropmalzpp": 917089998,
    "dropsitphn": 9093641361,
    "dropsitlph": 9096272961,
    "dropsitcph": 9093641361,
    "dropfax": 9095913778
  },
  {
    "dcode": "D",
    "dropkey": "PZ20602",
    "droptype": "D",
    "dropname": "CHOWCHILLA",
    "dropdeladd": "135 S 1ST ST",
    "dropdelcty": "CHOWCHILLA",
    "dropdelst": "CA",
    "dropdelzpp": 936109998,
    "dropphyadd": "135 S 1ST ST",
    "dropphycty": "CHOWCHILLA",
    "dropphyst": "CA",
    "dropphyzpp": 936109998,
    "dropmaladd": "135 S 1ST ST",
    "dropmalcty": "CHOWCHILLA",
    "dropmalst": "CA",
    "dropmalzpp": 936109998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596653279,
    "dropsitcph": 5596650380,
    "dropfax": 5596654361
  },
  {
    "dcode": "D",
    "dropkey": "PZ20604",
    "droptype": "D",
    "dropname": "CHUALAR",
    "dropdeladd": "25561 JACKSON ST",
    "dropdelcty": "CHUALAR",
    "dropdelst": "CA",
    "dropdelzpp": 939259998,
    "dropphyadd": "25561 JACKSON ST",
    "dropphycty": "CHUALAR",
    "dropphyst": "CA",
    "dropphyzpp": 939259998,
    "dropmaladd": "25561 JACKSON ST",
    "dropmalcty": "CHUALAR",
    "dropmalst": "CA",
    "dropmalzpp": 939259998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316792442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20605",
    "droptype": "D",
    "dropname": "CHULA VISTA",
    "dropdeladd": "750 3RD AVE",
    "dropdelcty": "CHULA VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 919109998,
    "dropphyadd": "750 3RD AVE",
    "dropphycty": "CHULA VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 919109998,
    "dropmaladd": "750 3RD AVE",
    "dropmalcty": "CHULA VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 919109998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194980071,
    "dropsitcph": 6194980687,
    "dropfax": 6194227256
  },
  {
    "dcode": "D",
    "dropkey": "PZ20610",
    "droptype": "D",
    "dropname": "CITRUS HEIGHTS",
    "dropdeladd": "6330 FOUNTAIN SQUARE DR",
    "dropdelcty": "CITRUS HEIGHTS",
    "dropdelst": "CA",
    "dropdelzpp": 956219998,
    "dropphyadd": "6330 FOUNTAIN SQUARE DR",
    "dropphycty": "CITRUS HEIGHTS",
    "dropphyst": "CA",
    "dropphyzpp": 956219998,
    "dropmaladd": "6330 FOUNTAIN SQUARE DR",
    "dropmalcty": "CITRUS HEIGHTS",
    "dropmalst": "CA",
    "dropmalzpp": 956219998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162427300,
    "dropsitcph": 9167251290,
    "dropfax": 9167258897
  },
  {
    "dcode": "D",
    "dropkey": "PZ20630",
    "droptype": "D",
    "dropname": "CLAREMONT",
    "dropdeladd": "140 HARVARD AVE",
    "dropdelcty": "CLAREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 917119998,
    "dropphyadd": "140 HARVARD AVE",
    "dropphycty": "CLAREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 917119998,
    "dropmaladd": "140 HARVARD AVE",
    "dropmalcty": "CLAREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 917119998,
    "dropsitphn": 9096257161,
    "dropsitlph": 9096240747,
    "dropsitcph": 9096257161,
    "dropfax": 9096247517
  },
  {
    "dcode": "D",
    "dropkey": "PZ20632",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "36385 N CENTER ST",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 956129998,
    "dropphyadd": "36385 N CENTER ST",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 956129998,
    "dropmaladd": "36385 N CENTER ST",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 956129998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167441411,
    "dropsitcph": 9167441411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20634",
    "droptype": "D",
    "dropname": "CLAYTON",
    "dropdeladd": "6150 CENTER ST",
    "dropdelcty": "CLAYTON",
    "dropdelst": "CA",
    "dropdelzpp": 945179998,
    "dropphyadd": "6150 CENTER ST",
    "dropphycty": "CLAYTON",
    "dropphyst": "CA",
    "dropphyzpp": 945179998,
    "dropmaladd": "6150 CENTER ST",
    "dropmalcty": "CLAYTON",
    "dropmalst": "CA",
    "dropmalzpp": 945179998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256724910,
    "dropsitcph": 9256724337,
    "dropfax": 9256726170
  },
  {
    "dcode": "D",
    "dropkey": "PZ20636",
    "droptype": "D",
    "dropname": "CLEARLAKE",
    "dropdeladd": "14500 OLYMPIC DR",
    "dropdelcty": "CLEARLAKE",
    "dropdelst": "CA",
    "dropdelzpp": 954229503,
    "dropphyadd": "14500 OLYMPIC DR",
    "dropphycty": "CLEARLAKE",
    "dropphyst": "CA",
    "dropphyzpp": 954229503,
    "dropmaladd": "14500 OLYMPIC DR",
    "dropmalcty": "CLEARLAKE",
    "dropmalst": "CA",
    "dropmalzpp": 954229503,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079946790,
    "dropfax": 7079949746
  },
  {
    "dcode": "D",
    "dropkey": "PZ20638",
    "droptype": "D",
    "dropname": "CLEARLAKE OAKS",
    "dropdeladd": "13280 E HIGHWAY 20",
    "dropdelcty": "CLEARLAKE OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 954239904,
    "dropphyadd": "13280 E HIGHWAY 20",
    "dropphycty": "CLEARLAKE OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 954239904,
    "dropmaladd": "13280 E HIGHWAY 20",
    "dropmalcty": "CLEARLAKE OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 954239904,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079983544,
    "dropfax": 7079983544
  },
  {
    "dcode": "D",
    "dropkey": "PZ20639",
    "droptype": "D",
    "dropname": "CLEARLAKE PARK",
    "dropdeladd": "13417 LAKESHORE DR",
    "dropdelcty": "CLEARLAKE PARK",
    "dropdelst": "CA",
    "dropdelzpp": 954247900,
    "dropphyadd": "13417 LAKESHORE DR",
    "dropphycty": "CLEARLAKE PARK",
    "dropphyst": "CA",
    "dropphyzpp": 954247900,
    "dropmaladd": "13417 LAKESHORE DR",
    "dropmalcty": "CLEARLAKE PARK",
    "dropmalst": "CA",
    "dropmalzpp": 954247900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079942382,
    "dropfax": 7079945071
  },
  {
    "dcode": "D",
    "dropkey": "PZ20643",
    "droptype": "D",
    "dropname": "CLEMENTS",
    "dropdeladd": "18860 E HIGHWAY 88",
    "dropdelcty": "CLEMENTS",
    "dropdelst": "CA",
    "dropdelzpp": 952279998,
    "dropphyadd": "18860 E HIGHWAY 88",
    "dropphycty": "CLEMENTS",
    "dropphyst": "CA",
    "dropphyzpp": 952279998,
    "dropmaladd": "18860 E HIGHWAY 88",
    "dropmalcty": "CLEMENTS",
    "dropmalst": "CA",
    "dropmalzpp": 952279998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097593352,
    "dropsitcph": 2097593352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20647",
    "droptype": "D",
    "dropname": "CLIO",
    "dropdeladd": "284 CLIO STATE 40A RD",
    "dropdelcty": "CLIO",
    "dropdelst": "CA",
    "dropdelzpp": 961061800,
    "dropphyadd": "284 CLIO STATE 40A RD",
    "dropphycty": "CLIO",
    "dropphyst": "CA",
    "dropphyzpp": 961061800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CLIO",
    "dropmalst": "CA",
    "dropmalzpp": 961069998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308360201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20649",
    "droptype": "D",
    "dropname": "CLIPPER MILLS",
    "dropdeladd": "12225 LA PORTE RD",
    "dropdelcty": "CLIPPER MILLS",
    "dropdelst": "CA",
    "dropdelzpp": 959309998,
    "dropphyadd": "12225 LA PORTE RD",
    "dropphycty": "CLIPPER MILLS",
    "dropphyst": "CA",
    "dropphyzpp": 959309998,
    "dropmaladd": "12225 LA PORTE RD",
    "dropmalcty": "CLIPPER MILLS",
    "dropmalst": "CA",
    "dropmalzpp": 959309998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306752477,
    "dropsitcph": 5306752477,
    "dropfax": 5306751437
  },
  {
    "dcode": "D",
    "dropkey": "PZ20650",
    "droptype": "D",
    "dropname": "CLOVERDALE",
    "dropdeladd": "115 BROAD ST",
    "dropdelcty": "CLOVERDALE",
    "dropdelst": "CA",
    "dropdelzpp": 954253388,
    "dropphyadd": "115 BROAD ST",
    "dropphycty": "CLOVERDALE",
    "dropphyst": "CA",
    "dropphyzpp": 954253388,
    "dropmaladd": "115 BROAD ST",
    "dropmalcty": "CLOVERDALE",
    "dropmalst": "CA",
    "dropmalzpp": 954253388,
    "dropsitphn": 7078944607,
    "dropsitlph": 7078945357,
    "dropsitcph": 7078944607,
    "dropfax": 7078945913
  },
  {
    "dcode": "D",
    "dropkey": "PZ20651",
    "droptype": "D",
    "dropname": "CLOVIS",
    "dropdeladd": "655 MINNEWAWA AVE",
    "dropdelcty": "CLOVIS",
    "dropdelst": "CA",
    "dropdelzpp": 936129998,
    "dropphyadd": "655 MINNEWAWA AVE",
    "dropphycty": "CLOVIS",
    "dropphyst": "CA",
    "dropphyzpp": 936129998,
    "dropmaladd": "655 MINNEWAWA AVE",
    "dropmalcty": "CLOVIS",
    "dropmalst": "CA",
    "dropmalzpp": 936129998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594725274,
    "dropsitcph": 5592979593,
    "dropfax": 5592979563
  },
  {
    "dcode": "D",
    "dropkey": "PZ20653",
    "droptype": "D",
    "dropname": "COACHELLA",
    "dropdeladd": "1412 6TH ST",
    "dropdelcty": "COACHELLA",
    "dropdelst": "CA",
    "dropdelzpp": 922369998,
    "dropphyadd": "1412 6TH ST",
    "dropphycty": "COACHELLA",
    "dropphyst": "CA",
    "dropphyzpp": 922369998,
    "dropmaladd": "1412 6TH ST",
    "dropmalcty": "COACHELLA",
    "dropmalst": "CA",
    "dropmalzpp": 922369998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603988091,
    "dropsitcph": 7603988112,
    "dropfax": 7603983451
  },
  {
    "dcode": "D",
    "dropkey": "PZ20654",
    "droptype": "D",
    "dropname": "COALINGA",
    "dropdeladd": "218 W DURIAN AVE",
    "dropdelcty": "COALINGA",
    "dropdelst": "CA",
    "dropdelzpp": 932109997,
    "dropphyadd": "218 W DURIAN AVE",
    "dropphycty": "COALINGA",
    "dropphyst": "CA",
    "dropphyzpp": 932109997,
    "dropmaladd": "218 W DURIAN AVE",
    "dropmalcty": "COALINGA",
    "dropmalst": "CA",
    "dropmalzpp": 932109997,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599359287,
    "dropsitcph": 5599359287,
    "dropfax": 5599350931
  },
  {
    "dcode": "D",
    "dropkey": "PZ20655",
    "droptype": "D",
    "dropname": "COARSEGOLD",
    "dropdeladd": "46944 PONY EXPRESS LN",
    "dropdelcty": "COARSEGOLD",
    "dropdelst": "CA",
    "dropdelzpp": 936149998,
    "dropphyadd": "46944 PONY EXPRESS LN",
    "dropphycty": "COARSEGOLD",
    "dropphyst": "CA",
    "dropphyzpp": 936149998,
    "dropmaladd": "46944 PONY EXPRESS LN",
    "dropmalcty": "COARSEGOLD",
    "dropmalst": "CA",
    "dropmalzpp": 936149998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596586036,
    "dropsitcph": 5596586897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20658",
    "droptype": "D",
    "dropname": "COBB",
    "dropdeladd": "16595 HIGHWAY 175",
    "dropdelcty": "COBB",
    "dropdelst": "CA",
    "dropdelzpp": 954269900,
    "dropphyadd": "16595 HIGHWAY 175",
    "dropphycty": "COBB",
    "dropphyst": "CA",
    "dropphyzpp": 954269900,
    "dropmaladd": "16595 HIGHWAY 175",
    "dropmalcty": "COBB",
    "dropmalst": "CA",
    "dropmalzpp": 954269900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079285588,
    "dropfax": 7079285588
  },
  {
    "dcode": "D",
    "dropkey": "PZ20665",
    "droptype": "D",
    "dropname": "COLEVILLE",
    "dropdeladd": "111747 US HIGHWAY 395",
    "dropdelcty": "COLEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961079995,
    "dropphyadd": "111747 US HIGHWAY 395",
    "dropphycty": "COLEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961079995,
    "dropmaladd": "111747 US HIGHWAY 395",
    "dropmalcty": "COLEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961079995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5304952133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20666",
    "droptype": "D",
    "dropname": "COLFAX",
    "dropdeladd": "40 W CHURCH ST",
    "dropdelcty": "COLFAX",
    "dropdelst": "CA",
    "dropdelzpp": 957139998,
    "dropphyadd": "40 W CHURCH ST",
    "dropphycty": "COLFAX",
    "dropphyst": "CA",
    "dropphyzpp": 957139998,
    "dropmaladd": "40 W CHURCH ST",
    "dropmalcty": "COLFAX",
    "dropmalst": "CA",
    "dropmalzpp": 957139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303460025,
    "dropsitcph": 5303460025,
    "dropfax": 5303468301
  },
  {
    "dcode": "D",
    "dropkey": "PZ20673",
    "droptype": "D",
    "dropname": "COLOMA",
    "dropdeladd": "333 STATE HIGHWAY 49",
    "dropdelcty": "COLOMA",
    "dropdelst": "CA",
    "dropdelzpp": 956139998,
    "dropphyadd": "333 STATE HIGHWAY 49",
    "dropphycty": "COLOMA",
    "dropphyst": "CA",
    "dropphyzpp": 956139998,
    "dropmaladd": "333 STATE HIGHWAY 49",
    "dropmalcty": "COLOMA",
    "dropmalst": "CA",
    "dropmalzpp": 956139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306222275,
    "dropsitcph": 5306222275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20679",
    "droptype": "D",
    "dropname": "COLTON",
    "dropdeladd": "265 N 7TH ST",
    "dropdelcty": "COLTON",
    "dropdelst": "CA",
    "dropdelzpp": 923242952,
    "dropphyadd": "265 N 7TH ST",
    "dropphycty": "COLTON",
    "dropphyst": "CA",
    "dropphyzpp": 923242952,
    "dropmaladd": "265 N 7TH ST",
    "dropmalcty": "COLTON",
    "dropmalst": "CA",
    "dropmalzpp": 923242952,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098250508,
    "dropsitcph": 9098252154,
    "dropfax": 9098256689
  },
  {
    "dcode": "D",
    "dropkey": "PZ20680",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "22628 PARROTTS FERRY RD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "CA",
    "dropdelzpp": 953109998,
    "dropphyadd": "22628 PARROTTS FERRY RD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "CA",
    "dropphyzpp": 953109998,
    "dropmaladd": "22628 PARROTTS FERRY RD",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "CA",
    "dropmalzpp": 953109998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095327557,
    "dropsitcph": 2095327557,
    "dropfax": 2095328034
  },
  {
    "dcode": "D",
    "dropkey": "PZ20683",
    "droptype": "D",
    "dropname": "COLUSA",
    "dropdeladd": "357 MARKET ST",
    "dropdelcty": "COLUSA",
    "dropdelst": "CA",
    "dropdelzpp": 959329998,
    "dropphyadd": "357 MARKET ST",
    "dropphycty": "COLUSA",
    "dropphyst": "CA",
    "dropphyzpp": 959329998,
    "dropmaladd": "357 MARKET ST",
    "dropmalcty": "COLUSA",
    "dropmalst": "CA",
    "dropmalzpp": 959329998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304583016,
    "dropsitcph": 5304583037,
    "dropfax": 5304585462
  },
  {
    "dcode": "D",
    "dropkey": "PZ20689",
    "droptype": "D",
    "dropname": "COMPTCHE",
    "dropdeladd": "31101 COMPTCHE UKIAH RD",
    "dropdelcty": "COMPTCHE",
    "dropdelst": "CA",
    "dropdelzpp": 954279900,
    "dropphyadd": "31101 COMPTCHE UKIAH RD",
    "dropphycty": "COMPTCHE",
    "dropphyst": "CA",
    "dropphyzpp": 954279900,
    "dropmaladd": "31101 COMPTCHE UKIAH RD",
    "dropmalcty": "COMPTCHE",
    "dropmalst": "CA",
    "dropmalzpp": 954279900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079374098,
    "dropfax": 7079374098
  },
  {
    "dcode": "D",
    "dropkey": "PZ20690",
    "droptype": "D",
    "dropname": "COMPTON",
    "dropdeladd": "701 S SANTA FE AVE",
    "dropdelcty": "COMPTON",
    "dropdelst": "CA",
    "dropdelzpp": 902219998,
    "dropphyadd": "701 S SANTA FE AVE",
    "dropphycty": "COMPTON",
    "dropphyst": "CA",
    "dropphyzpp": 902219998,
    "dropmaladd": "701 S SANTA FE AVE",
    "dropmalcty": "COMPTON",
    "dropmalst": "CA",
    "dropmalzpp": 902219998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3237742703,
    "dropsitcph": 3106383508,
    "dropfax": 3106383723
  },
  {
    "dcode": "D",
    "dropkey": "PZ20691",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "2121 MERIDIAN PARK BLVD",
    "dropdelcty": "CONCORD",
    "dropdelst": "CA",
    "dropdelzpp": 945209998,
    "dropphyadd": "2121 MERIDIAN PARK BLVD",
    "dropphycty": "CONCORD",
    "dropphyst": "CA",
    "dropphyzpp": 945209998,
    "dropmaladd": "2121 MERIDIAN PARK BLVD",
    "dropmalcty": "CONCORD",
    "dropmalst": "CA",
    "dropmalzpp": 945209998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256098063,
    "dropsitcph": 9256870533,
    "dropfax": 9256874193
  },
  {
    "dcode": "D",
    "dropkey": "PZ20751",
    "droptype": "D",
    "dropname": "COOL",
    "dropdeladd": "1041 NORTHSIDE DR",
    "dropdelcty": "COOL",
    "dropdelst": "CA",
    "dropdelzpp": 956149998,
    "dropphyadd": "1041 NORTHSIDE DR",
    "dropphycty": "COOL",
    "dropphyst": "CA",
    "dropphyzpp": 956149998,
    "dropmaladd": "1041 NORTHSIDE DR",
    "dropmalcty": "COOL",
    "dropmalst": "CA",
    "dropmalzpp": 956149998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308853839,
    "dropsitcph": 5308853839,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20752",
    "droptype": "D",
    "dropname": "COPPEROPOLIS",
    "dropdeladd": "101 TOWN SQUARE RD",
    "dropdelcty": "COPPEROPOLIS",
    "dropdelst": "CA",
    "dropdelzpp": 952289998,
    "dropphyadd": "101 TOWN SQUARE RD",
    "dropphycty": "COPPEROPOLIS",
    "dropphyst": "CA",
    "dropphyzpp": 952289998,
    "dropmaladd": "101 TOWN SQUARE RD",
    "dropmalcty": "COPPEROPOLIS",
    "dropmalst": "CA",
    "dropmalzpp": 952289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097852326,
    "dropsitcph": 2097852326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20754",
    "droptype": "D",
    "dropname": "CORCORAN",
    "dropdeladd": "917 CHASE AVE",
    "dropdelcty": "CORCORAN",
    "dropdelst": "CA",
    "dropdelzpp": 932129998,
    "dropphyadd": "917 CHASE AVE",
    "dropphycty": "CORCORAN",
    "dropphyst": "CA",
    "dropphyzpp": 932129998,
    "dropmaladd": "917 CHASE AVE",
    "dropmalcty": "CORCORAN",
    "dropmalst": "CA",
    "dropmalzpp": 932129998,
    "dropsitphn": 4084376726,
    "dropsitlph": 5599929165,
    "dropsitcph": 5599929165,
    "dropfax": 6617757808
  },
  {
    "dcode": "D",
    "dropkey": "PZ20758",
    "droptype": "D",
    "dropname": "CORNING",
    "dropdeladd": "1217 YOLO ST",
    "dropdelcty": "CORNING",
    "dropdelst": "CA",
    "dropdelzpp": 960219998,
    "dropphyadd": "1217 YOLO ST",
    "dropphycty": "CORNING",
    "dropphyst": "CA",
    "dropphyzpp": 960219998,
    "dropmaladd": "1217 YOLO ST",
    "dropmalcty": "CORNING",
    "dropmalst": "CA",
    "dropmalzpp": 960219998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308249486,
    "dropsitcph": 5308249436,
    "dropfax": 5308245830
  },
  {
    "dcode": "D",
    "dropkey": "PZ20759",
    "droptype": "D",
    "dropname": "CORONA",
    "dropdeladd": "414 W GRAND BLVD",
    "dropdelcty": "CORONA",
    "dropdelst": "CA",
    "dropdelzpp": 928789998,
    "dropphyadd": "414 W GRAND BLVD",
    "dropphycty": "CORONA",
    "dropphyst": "CA",
    "dropphyzpp": 928789998,
    "dropmaladd": "414 W GRAND BLVD",
    "dropmalcty": "CORONA",
    "dropmalst": "CA",
    "dropmalzpp": 928789998,
    "dropsitphn": 9517373120,
    "dropsitlph": 9517372495,
    "dropsitcph": 9517373120,
    "dropfax": 9517379540
  },
  {
    "dcode": "D",
    "dropkey": "PZ20760",
    "droptype": "D",
    "dropname": "CORONA DEL MAR",
    "dropdeladd": "406 ORCHID AVE",
    "dropdelcty": "CORONA DEL MAR",
    "dropdelst": "CA",
    "dropdelzpp": 926259998,
    "dropphyadd": "406 ORCHID AVE",
    "dropphycty": "CORONA DEL MAR",
    "dropphyst": "CA",
    "dropphyzpp": 926259998,
    "dropmaladd": "406 ORCHID AVE",
    "dropmalcty": "CORONA DEL MAR",
    "dropmalst": "CA",
    "dropmalzpp": 926259998,
    "dropsitphn": 9496732989,
    "dropsitlph": 9496734605,
    "dropsitcph": 9496732989,
    "dropfax": 9496734625
  },
  {
    "dcode": "D",
    "dropkey": "PZ20763",
    "droptype": "D",
    "dropname": "CORTE MADERA",
    "dropdeladd": "7 PIXLEY AVE",
    "dropdelcty": "CORTE MADERA",
    "dropdelst": "CA",
    "dropdelzpp": 949251457,
    "dropphyadd": "7 PIXLEY AVE",
    "dropphycty": "CORTE MADERA",
    "dropphyst": "CA",
    "dropphyzpp": 949251457,
    "dropmaladd": "7 PIXLEY AVE",
    "dropmalcty": "CORTE MADERA",
    "dropmalst": "CA",
    "dropmalzpp": 949251457,
    "dropsitphn": 4159245116,
    "dropsitlph": 4159244541,
    "dropsitcph": 4159245056,
    "dropfax": 4159243528
  },
  {
    "dcode": "D",
    "dropkey": "PZ20765",
    "droptype": "D",
    "dropname": "COSTA MESA",
    "dropdeladd": "1590 ADAMS AVE",
    "dropdelcty": "COSTA MESA",
    "dropdelst": "CA",
    "dropdelzpp": 926289998,
    "dropphyadd": "1590 ADAMS AVE",
    "dropphycty": "COSTA MESA",
    "dropphyst": "CA",
    "dropphyzpp": 926289998,
    "dropmaladd": "1590 ADAMS AVE",
    "dropmalcty": "COSTA MESA",
    "dropmalst": "CA",
    "dropmalzpp": 926289998,
    "dropsitphn": 7145465022,
    "dropsitlph": 7145461046,
    "dropsitcph": 7145465022,
    "dropfax": 7145460325
  },
  {
    "dcode": "D",
    "dropkey": "PZ20766",
    "droptype": "D",
    "dropname": "COTATI",
    "dropdeladd": "502 E COTATI AVE",
    "dropdelcty": "COTATI",
    "dropdelst": "CA",
    "dropdelzpp": 949319991,
    "dropphyadd": "502 E COTATI AVE",
    "dropphycty": "COTATI",
    "dropphyst": "CA",
    "dropphyzpp": 949319991,
    "dropmaladd": "502 E COTATI AVE",
    "dropmalcty": "COTATI",
    "dropmalst": "CA",
    "dropmalzpp": 949319991,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077927374,
    "dropsitcph": 7075865412,
    "dropfax": 7075859168
  },
  {
    "dcode": "D",
    "dropkey": "PZ20768",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "3270 WALNUT ST",
    "dropdelcty": "COTTONWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 960229998,
    "dropphyadd": "3270 WALNUT ST",
    "dropphycty": "COTTONWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 960229998,
    "dropmaladd": "3270 WALNUT ST",
    "dropmalcty": "COTTONWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 960229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303473342,
    "dropsitcph": 5303473342,
    "dropfax": 5303470491
  },
  {
    "dcode": "D",
    "dropkey": "PZ20769",
    "droptype": "D",
    "dropname": "COULTERVILLE",
    "dropdeladd": "5008A MAIN ST",
    "dropdelcty": "COULTERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 953119998,
    "dropphyadd": "5008A MAIN ST",
    "dropphycty": "COULTERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 953119998,
    "dropmaladd": "5008A MAIN ST",
    "dropmalcty": "COULTERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 953119998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098783635,
    "dropsitcph": 2098783635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20772",
    "droptype": "D",
    "dropname": "COURTLAND",
    "dropdeladd": "125 PRIMASING AVE",
    "dropdelcty": "COURTLAND",
    "dropdelst": "CA",
    "dropdelzpp": 956159998,
    "dropphyadd": "125 PRIMASING AVE",
    "dropphycty": "COURTLAND",
    "dropphyst": "CA",
    "dropphyzpp": 956159998,
    "dropmaladd": "125 PRIMASING AVE",
    "dropmalcty": "COURTLAND",
    "dropmalst": "CA",
    "dropmalzpp": 956159998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167751310,
    "dropsitcph": 9167751310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20773",
    "droptype": "D",
    "dropname": "COVELO",
    "dropdeladd": "23951 HOWARD ST",
    "dropdelcty": "COVELO",
    "dropdelst": "CA",
    "dropdelzpp": 954289903,
    "dropphyadd": "23951 HOWARD ST",
    "dropphycty": "COVELO",
    "dropphyst": "CA",
    "dropphyzpp": 954289903,
    "dropmaladd": "23951 HOWARD ST",
    "dropmalcty": "COVELO",
    "dropmalst": "CA",
    "dropmalzpp": 954289903,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079836868,
    "dropfax": 7079836868
  },
  {
    "dcode": "D",
    "dropkey": "PZ20774",
    "droptype": "D",
    "dropname": "COVINA",
    "dropdeladd": "545 N RIMSDALE AVE",
    "dropdelcty": "COVINA",
    "dropdelst": "CA",
    "dropdelzpp": 917229998,
    "dropphyadd": "545 N RIMSDALE AVE",
    "dropphycty": "COVINA",
    "dropphyst": "CA",
    "dropphyzpp": 917229998,
    "dropmaladd": "545 N RIMSDALE AVE",
    "dropmalcty": "COVINA",
    "dropmalst": "CA",
    "dropmalzpp": 917229998,
    "dropsitphn": 6269666145,
    "dropsitlph": 6263398123,
    "dropsitcph": 6269666145,
    "dropfax": 6263323941
  },
  {
    "dcode": "D",
    "dropkey": "PZ20781",
    "droptype": "D",
    "dropname": "CRESCENT CITY",
    "dropdeladd": "751 2ND ST",
    "dropdelcty": "CRESCENT CITY",
    "dropdelst": "CA",
    "dropdelzpp": 955314314,
    "dropphyadd": "751 2ND ST",
    "dropphycty": "CRESCENT CITY",
    "dropphyst": "CA",
    "dropphyzpp": 955314314,
    "dropmaladd": "751 2ND ST",
    "dropmalcty": "CRESCENT CITY",
    "dropmalst": "CA",
    "dropmalzpp": 955314314,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074642151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20784",
    "droptype": "D",
    "dropname": "CRESCENT MILLS",
    "dropdeladd": "15711 MAIN ST",
    "dropdelcty": "CRESCENT MILLS",
    "dropdelst": "CA",
    "dropdelzpp": 959349998,
    "dropphyadd": "15711 MAIN ST",
    "dropphycty": "CRESCENT MILLS",
    "dropphyst": "CA",
    "dropphyzpp": 959349998,
    "dropmaladd": "15711 MAIN ST",
    "dropmalcty": "CRESCENT MILLS",
    "dropmalst": "CA",
    "dropmalzpp": 959349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302847161,
    "dropsitcph": 5302847161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20785",
    "droptype": "D",
    "dropname": "CRESSEY",
    "dropdeladd": "9211 CRESSEY WAY",
    "dropdelcty": "CRESSEY",
    "dropdelst": "CA",
    "dropdelzpp": 953129998,
    "dropphyadd": "9211 CRESSEY WAY",
    "dropphycty": "CRESSEY",
    "dropphyst": "CA",
    "dropphyzpp": 953129998,
    "dropmaladd": "9211 CRESSEY WAY",
    "dropmalcty": "CRESSEY",
    "dropmalst": "CA",
    "dropmalzpp": 953129998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093942730,
    "dropsitcph": 2093942730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20788",
    "droptype": "D",
    "dropname": "CRESTLINE",
    "dropdeladd": "23921 LAKE DR",
    "dropdelcty": "CRESTLINE",
    "dropdelst": "CA",
    "dropdelzpp": 923250677,
    "dropphyadd": "23921 LAKE DR",
    "dropphycty": "CRESTLINE",
    "dropphyst": "CA",
    "dropphyzpp": 923250677,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESTLINE",
    "dropmalst": "CA",
    "dropmalzpp": 923259998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093384843,
    "dropsitcph": 9093385489,
    "dropfax": 9093384349
  },
  {
    "dcode": "D",
    "dropkey": "PZ20792",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "6320 WEBSTER RD",
    "dropdelcty": "CRESTON",
    "dropdelst": "CA",
    "dropdelzpp": 934329793,
    "dropphyadd": "6320 WEBSTER RD",
    "dropphycty": "CRESTON",
    "dropphyst": "CA",
    "dropphyzpp": 934329793,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CRESTON",
    "dropmalst": "CA",
    "dropmalzpp": 934329998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8052383983,
    "dropsitcph": 8052383983,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ20795",
    "droptype": "D",
    "dropname": "CROCKETT",
    "dropdeladd": "695 POMONA ST",
    "dropdelcty": "CROCKETT",
    "dropdelst": "CA",
    "dropdelzpp": 945251428,
    "dropphyadd": "695 POMONA ST",
    "dropphycty": "CROCKETT",
    "dropphyst": "CA",
    "dropphyzpp": 945251428,
    "dropmaladd": "695 POMONA ST",
    "dropmalcty": "CROCKETT",
    "dropmalst": "CA",
    "dropmalzpp": 945251428,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 5107879854,
    "dropfax": 5107879854
  },
  {
    "dcode": "D",
    "dropkey": "PZ20800",
    "droptype": "D",
    "dropname": "CROWS LANDING",
    "dropdeladd": "13 W 5TH ST",
    "dropdelcty": "CROWS LANDING",
    "dropdelst": "CA",
    "dropdelzpp": 953139998,
    "dropphyadd": "13 W 5TH ST",
    "dropphycty": "CROWS LANDING",
    "dropphyst": "CA",
    "dropphyzpp": 953139998,
    "dropmaladd": "13 W 5TH ST",
    "dropmalcty": "CROWS LANDING",
    "dropmalst": "CA",
    "dropmalzpp": 953139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098374210,
    "dropsitcph": 2098374210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20809",
    "droptype": "D",
    "dropname": "CULVER CITY",
    "dropdeladd": "6695 GREEN VALLEY CIR",
    "dropdelcty": "CULVER CITY",
    "dropdelst": "CA",
    "dropdelzpp": 902309997,
    "dropphyadd": "6695 GREEN VALLEY CIR",
    "dropphycty": "CULVER CITY",
    "dropphyst": "CA",
    "dropphyzpp": 902309997,
    "dropmaladd": "6695 GREEN VALLEY CIR",
    "dropmalcty": "CULVER CITY",
    "dropmalst": "CA",
    "dropmalzpp": 902309997,
    "dropsitphn": 5624942406,
    "dropsitlph": 4244395250,
    "dropsitcph": 4244395250,
    "dropfax": 3103908193
  },
  {
    "dcode": "D",
    "dropkey": "PZ20813",
    "droptype": "D",
    "dropname": "CUPERTINO",
    "dropdeladd": "21701 STEVENS CREEK BLVD",
    "dropdelcty": "CUPERTINO",
    "dropdelst": "CA",
    "dropdelzpp": 950149998,
    "dropphyadd": "21701 STEVENS CREEK BLVD",
    "dropphycty": "CUPERTINO",
    "dropphyst": "CA",
    "dropphyzpp": 950149998,
    "dropmaladd": "21701 STEVENS CREEK BLVD",
    "dropmalcty": "CUPERTINO",
    "dropmalst": "CA",
    "dropmalzpp": 950149998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082524185,
    "dropsitcph": 4082523086,
    "dropfax": 4082578267
  },
  {
    "dcode": "D",
    "dropkey": "PZ20815",
    "droptype": "D",
    "dropname": "CUTLER",
    "dropdeladd": "12749 1ST DR",
    "dropdelcty": "CUTLER",
    "dropdelst": "CA",
    "dropdelzpp": 936159998,
    "dropphyadd": "12749 1ST DR",
    "dropphycty": "CUTLER",
    "dropphyst": "CA",
    "dropphyzpp": 936159998,
    "dropmaladd": "12749 1ST DR",
    "dropmalcty": "CUTLER",
    "dropmalst": "CA",
    "dropmalzpp": 936159998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5595283489,
    "dropsitcph": 5595283379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20820",
    "droptype": "D",
    "dropname": "CYPRESS",
    "dropdeladd": "5762 LINCOLN AVE",
    "dropdelcty": "CYPRESS",
    "dropdelst": "CA",
    "dropdelzpp": 906309998,
    "dropphyadd": "5762 LINCOLN AVE",
    "dropphycty": "CYPRESS",
    "dropphyst": "CA",
    "dropphyzpp": 906309998,
    "dropmaladd": "5762 LINCOLN AVE",
    "dropmalcty": "CYPRESS",
    "dropmalst": "CA",
    "dropmalzpp": 906309998,
    "dropsitphn": 7148282274,
    "dropsitlph": 7148282274,
    "dropsitcph": 7148282274,
    "dropfax": 7148289758
  },
  {
    "dcode": "D",
    "dropkey": "PZ20825",
    "droptype": "D",
    "dropname": "DAGGETT",
    "dropdeladd": "33530 C ST",
    "dropdelcty": "DAGGETT",
    "dropdelst": "CA",
    "dropdelzpp": 923279998,
    "dropphyadd": "33530 C ST",
    "dropphycty": "DAGGETT",
    "dropphyst": "CA",
    "dropphyzpp": 923279998,
    "dropmaladd": "33530 C ST",
    "dropmalcty": "DAGGETT",
    "dropmalst": "CA",
    "dropmalzpp": 923279998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602542693,
    "dropsitcph": 7602542693,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20827",
    "droptype": "D",
    "dropname": "DALY CITY",
    "dropdeladd": "1100 SULLIVAN AVE",
    "dropdelcty": "DALY CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940159998,
    "dropphyadd": "1100 SULLIVAN AVE",
    "dropphycty": "DALY CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940159998,
    "dropmaladd": "1100 SULLIVAN AVE",
    "dropmalcty": "DALY CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940159998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507562277,
    "dropsitcph": 6507562304,
    "dropfax": 6507564957
  },
  {
    "dcode": "D",
    "dropkey": "PZ20830",
    "droptype": "D",
    "dropname": "DANA POINT",
    "dropdeladd": "24551 DEL PRADO",
    "dropdelcty": "DANA POINT",
    "dropdelst": "CA",
    "dropdelzpp": 926299998,
    "dropphyadd": "24551 DEL PRADO",
    "dropphycty": "DANA POINT",
    "dropphyst": "CA",
    "dropphyzpp": 926299998,
    "dropmaladd": "24551 DEL PRADO",
    "dropmalcty": "DANA POINT",
    "dropmalst": "CA",
    "dropmalzpp": 926299998,
    "dropsitphn": 9494962787,
    "dropsitlph": 9496610024,
    "dropsitcph": 9494962787,
    "dropfax": 9494932193
  },
  {
    "dcode": "D",
    "dropkey": "PZ20832",
    "droptype": "D",
    "dropname": "DANVILLE",
    "dropdeladd": "2605 CAMINO TASSAJARA",
    "dropdelcty": "DANVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 945269998,
    "dropphyadd": "2605 CAMINO TASSAJARA",
    "dropphycty": "DANVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 945269998,
    "dropmaladd": "2605 CAMINO TASSAJARA",
    "dropmalcty": "DANVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 945269998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9257365069,
    "dropsitcph": 9257360775,
    "dropfax": 9257364759
  },
  {
    "dcode": "D",
    "dropkey": "PZ20835",
    "droptype": "D",
    "dropname": "DARWIN",
    "dropdeladd": "251 REDDY ST",
    "dropdelcty": "DARWIN",
    "dropdelst": "CA",
    "dropdelzpp": 935229996,
    "dropphyadd": "251 REDDY ST",
    "dropphycty": "DARWIN",
    "dropphyst": "CA",
    "dropphyzpp": 935229996,
    "dropmaladd": "251 REDDY ST",
    "dropmalcty": "DARWIN",
    "dropmalst": "CA",
    "dropmalzpp": 935229996,
    "dropsitphn": 6617757808,
    "dropsitlph": 7608764407,
    "dropsitcph": 7608764407,
    "dropfax": 7608769107
  },
  {
    "dcode": "D",
    "dropkey": "PZ20836",
    "droptype": "D",
    "dropname": "DAVENPORT",
    "dropdeladd": "500 HIGHWAY 1",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "CA",
    "dropdelzpp": 950179998,
    "dropphyadd": "500 HIGHWAY 1",
    "dropphycty": "DAVENPORT",
    "dropphyst": "CA",
    "dropphyzpp": 950179998,
    "dropmaladd": "500 HIGHWAY 1",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "CA",
    "dropmalzpp": 950179998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8314269533,
    "dropfax": 8314263036
  },
  {
    "dcode": "D",
    "dropkey": "PZ20837",
    "droptype": "D",
    "dropname": "DAVIS",
    "dropdeladd": "2020 5TH ST",
    "dropdelcty": "DAVIS",
    "dropdelst": "CA",
    "dropdelzpp": 956169998,
    "dropphyadd": "2020 5TH ST",
    "dropphycty": "DAVIS",
    "dropphyst": "CA",
    "dropphyzpp": 956169998,
    "dropmaladd": "2020 5TH ST",
    "dropmalcty": "DAVIS",
    "dropmalst": "CA",
    "dropmalzpp": 956169998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307533546,
    "dropsitcph": 5307530428,
    "dropfax": 5307561081
  },
  {
    "dcode": "D",
    "dropkey": "PZ20838",
    "droptype": "D",
    "dropname": "DAVIS CREEK",
    "dropdeladd": "1 E US HIGHWAY 395 N",
    "dropdelcty": "DAVIS CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 961089500,
    "dropphyadd": "1 E US HIGHWAY 395 N",
    "dropphycty": "DAVIS CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 961089500,
    "dropmaladd": "1 E US HIGHWAY 395 N",
    "dropmalcty": "DAVIS CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 961089998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302333003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20842",
    "droptype": "D",
    "dropname": "DEATH VALLEY",
    "dropdeladd": "328 GREENLAND BLVD",
    "dropdelcty": "DEATH VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 923289998,
    "dropphyadd": "328 GREENLAND BLVD",
    "dropphycty": "DEATH VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 923289998,
    "dropmaladd": "328 GREENLAND BLVD",
    "dropmalcty": "DEATH VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 923289998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7607862223,
    "dropsitcph": 7607862223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20849",
    "droptype": "D",
    "dropname": "DEL MAR",
    "dropdeladd": "122 15TH ST",
    "dropdelcty": "DEL MAR",
    "dropdelst": "CA",
    "dropdelzpp": 920149998,
    "dropphyadd": "122 15TH ST",
    "dropphycty": "DEL MAR",
    "dropphyst": "CA",
    "dropphyzpp": 920149998,
    "dropmaladd": "122 15TH ST",
    "dropmalcty": "DEL MAR",
    "dropmalst": "CA",
    "dropmalzpp": 920149998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8583509607,
    "dropsitcph": 8583509513,
    "dropfax": 8587554519
  },
  {
    "dcode": "D",
    "dropkey": "PZ20853",
    "droptype": "D",
    "dropname": "DEL REY",
    "dropdeladd": "10772 MORRO AVE",
    "dropdelcty": "DEL REY",
    "dropdelst": "CA",
    "dropdelzpp": 936169998,
    "dropphyadd": "10772 MORRO AVE",
    "dropphycty": "DEL REY",
    "dropphyst": "CA",
    "dropphyzpp": 936169998,
    "dropmaladd": "10772 MORRO AVE",
    "dropmalcty": "DEL REY",
    "dropmalst": "CA",
    "dropmalzpp": 936169998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598882559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20863",
    "droptype": "D",
    "dropname": "DELANO",
    "dropdeladd": "1800 GARCES HWY",
    "dropdelcty": "DELANO",
    "dropdelst": "CA",
    "dropdelzpp": 932159998,
    "dropphyadd": "1800 GARCES HWY",
    "dropphycty": "DELANO",
    "dropphyst": "CA",
    "dropphyzpp": 932159998,
    "dropmaladd": "1800 GARCES HWY",
    "dropmalcty": "DELANO",
    "dropmalst": "CA",
    "dropmalzpp": 932159998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617253877,
    "dropsitcph": 6617253877,
    "dropfax": 6617250163
  },
  {
    "dcode": "D",
    "dropkey": "PZ20864",
    "droptype": "D",
    "dropname": "DELHI",
    "dropdeladd": "16096 LOCUST ST",
    "dropdelcty": "DELHI",
    "dropdelst": "CA",
    "dropdelzpp": 953159998,
    "dropphyadd": "16096 LOCUST ST",
    "dropphycty": "DELHI",
    "dropphyst": "CA",
    "dropphyzpp": 953159998,
    "dropmaladd": "16096 LOCUST ST",
    "dropmalcty": "DELHI",
    "dropmalst": "CA",
    "dropmalzpp": 953159998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096681473,
    "dropsitcph": 2096681309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20870",
    "droptype": "D",
    "dropname": "DENAIR",
    "dropdeladd": "4733 MAIN ST",
    "dropdelcty": "DENAIR",
    "dropdelst": "CA",
    "dropdelzpp": 953169998,
    "dropphyadd": "4733 MAIN ST",
    "dropphycty": "DENAIR",
    "dropphyst": "CA",
    "dropphyzpp": 953169998,
    "dropmaladd": "4733 MAIN ST",
    "dropmalcty": "DENAIR",
    "dropmalst": "CA",
    "dropmalzpp": 953169998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096322550,
    "dropsitcph": 2096322550,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20872",
    "droptype": "D",
    "dropname": "DESCANSO",
    "dropdeladd": "24680 VIEJAS GRADE RD STE A",
    "dropdelcty": "DESCANSO",
    "dropdelst": "CA",
    "dropdelzpp": 919169998,
    "dropphyadd": "24680 VIEJAS GRADE RD STE A",
    "dropphycty": "DESCANSO",
    "dropphyst": "CA",
    "dropphyzpp": 919169998,
    "dropmaladd": "24680 VIEJAS GRADE RD STE A",
    "dropmalcty": "DESCANSO",
    "dropmalst": "CA",
    "dropmalzpp": 919169998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194452046,
    "dropsitcph": 6194452046,
    "dropfax": 6194457813
  },
  {
    "dcode": "D",
    "dropkey": "PZ20873",
    "droptype": "D",
    "dropname": "DESERT CENTER",
    "dropdeladd": "44300 RAGSDALE RD",
    "dropdelcty": "DESERT CENTER",
    "dropdelst": "CA",
    "dropdelzpp": 922390400,
    "dropphyadd": "44300 RAGSDALE RD",
    "dropphycty": "DESERT CENTER",
    "dropphyst": "CA",
    "dropphyzpp": 922390400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DESERT CENTER",
    "dropmalst": "CA",
    "dropmalzpp": 922399998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602273112,
    "dropsitcph": 7602273112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20875",
    "droptype": "D",
    "dropname": "DESERT HOT SPRINGS",
    "dropdeladd": "66311 TWO BUNCH PALMS TRL",
    "dropdelcty": "DESERT HOT SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 922409998,
    "dropphyadd": "66311 TWO BUNCH PALMS TRL",
    "dropphycty": "DESERT HOT SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 922409998,
    "dropmaladd": "66311 TWO BUNCH PALMS TRL",
    "dropmalcty": "DESERT HOT SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 922409998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602510649,
    "dropsitcph": 7602514448,
    "dropfax": 7602516279
  },
  {
    "dcode": "D",
    "dropkey": "PZ20881",
    "droptype": "D",
    "dropname": "DIABLO",
    "dropdeladd": "1701 EL NIDO",
    "dropdelcty": "DIABLO",
    "dropdelst": "CA",
    "dropdelzpp": 945289800,
    "dropphyadd": "1701 EL NIDO",
    "dropphycty": "DIABLO",
    "dropphyst": "CA",
    "dropphyzpp": 945289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DIABLO",
    "dropmalst": "CA",
    "dropmalzpp": 945289998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 9258373800,
    "dropfax": 9258373865
  },
  {
    "dcode": "D",
    "dropkey": "PZ20887",
    "droptype": "D",
    "dropname": "DIAMOND SPRINGS",
    "dropdeladd": "4946 PLEASANT VALLEY RD",
    "dropdelcty": "DIAMOND SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 956199998,
    "dropphyadd": "4946 PLEASANT VALLEY RD",
    "dropphycty": "DIAMOND SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 956199998,
    "dropmaladd": "4946 PLEASANT VALLEY RD",
    "dropmalcty": "DIAMOND SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 956199998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306229167,
    "dropsitcph": 5306225184,
    "dropfax": 5306226954
  },
  {
    "dcode": "D",
    "dropkey": "PZ20889",
    "droptype": "D",
    "dropname": "DILLON BEACH",
    "dropdeladd": "52 CYPRESS AVE",
    "dropdelcty": "DILLON BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 949299600,
    "dropphyadd": "52 CYPRESS AVE",
    "dropphycty": "DILLON BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 949299600,
    "dropmaladd": "52 CYPRESS AVE",
    "dropmalcty": "DILLON BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 949299600,
    "dropsitphn": 7078782343,
    "dropsitlph": 7078782343,
    "dropsitcph": 7078782343,
    "dropfax": 7078782343
  },
  {
    "dcode": "D",
    "dropkey": "PZ20893",
    "droptype": "D",
    "dropname": "DINUBA",
    "dropdeladd": "222 S K ST",
    "dropdelcty": "DINUBA",
    "dropdelst": "CA",
    "dropdelzpp": 936189998,
    "dropphyadd": "222 S K ST",
    "dropphycty": "DINUBA",
    "dropphyst": "CA",
    "dropphyzpp": 936189998,
    "dropmaladd": "222 S K ST",
    "dropmalcty": "DINUBA",
    "dropmalst": "CA",
    "dropmalzpp": 936189998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5595951638,
    "dropsitcph": 5595911070,
    "dropfax": 5595959255
  },
  {
    "dcode": "D",
    "dropkey": "PZ20896",
    "droptype": "D",
    "dropname": "DIXON",
    "dropdeladd": "221 W A ST",
    "dropdelcty": "DIXON",
    "dropdelst": "CA",
    "dropdelzpp": 956209998,
    "dropphyadd": "221 W A ST",
    "dropphycty": "DIXON",
    "dropphyst": "CA",
    "dropphyzpp": 956209998,
    "dropmaladd": "221 W A ST",
    "dropmalcty": "DIXON",
    "dropmalst": "CA",
    "dropmalzpp": 956209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 7076781348,
    "dropsitcph": 7076781348,
    "dropfax": 7076784822
  },
  {
    "dcode": "D",
    "dropkey": "PZ20897",
    "droptype": "D",
    "dropname": "DOBBINS",
    "dropdeladd": "10375 OLD DOBBINS RD",
    "dropdelcty": "DOBBINS",
    "dropdelst": "CA",
    "dropdelzpp": 959359998,
    "dropphyadd": "10375 OLD DOBBINS RD",
    "dropphycty": "DOBBINS",
    "dropphyst": "CA",
    "dropphyzpp": 959359998,
    "dropmaladd": "10375 OLD DOBBINS RD",
    "dropmalcty": "DOBBINS",
    "dropmalst": "CA",
    "dropmalzpp": 959359998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306921833,
    "dropsitcph": 5306921833,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20910",
    "droptype": "D",
    "dropname": "DORRIS",
    "dropdeladd": "214 W 3RD ST",
    "dropdelcty": "DORRIS",
    "dropdelst": "CA",
    "dropdelzpp": 960239998,
    "dropphyadd": "214 W 3RD ST",
    "dropphycty": "DORRIS",
    "dropphyst": "CA",
    "dropphyzpp": 960239998,
    "dropmaladd": "214 W 3RD ST",
    "dropmalcty": "DORRIS",
    "dropmalst": "CA",
    "dropmalzpp": 960239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303975161,
    "dropsitcph": 5303975161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20911",
    "droptype": "D",
    "dropname": "DOS PALOS",
    "dropdeladd": "1555 GOLDEN GATE AVE",
    "dropdelcty": "DOS PALOS",
    "dropdelst": "CA",
    "dropdelzpp": 936209998,
    "dropphyadd": "1555 GOLDEN GATE AVE",
    "dropphycty": "DOS PALOS",
    "dropphyst": "CA",
    "dropphyzpp": 936209998,
    "dropmaladd": "1555 GOLDEN GATE AVE",
    "dropmalcty": "DOS PALOS",
    "dropmalst": "CA",
    "dropmalzpp": 936209998,
    "dropsitphn": 5594977615,
    "dropsitlph": 2093922323,
    "dropsitcph": 2093929266,
    "dropfax": 2093921004
  },
  {
    "dcode": "D",
    "dropkey": "PZ20913",
    "droptype": "D",
    "dropname": "DOUGLAS CITY",
    "dropdeladd": "140 STEINER FLAT RD",
    "dropdelcty": "DOUGLAS CITY",
    "dropdelst": "CA",
    "dropdelzpp": 960249998,
    "dropphyadd": "140 STEINER FLAT RD",
    "dropphycty": "DOUGLAS CITY",
    "dropphyst": "CA",
    "dropphyzpp": 960249998,
    "dropmaladd": "140 STEINER FLAT RD",
    "dropmalcty": "DOUGLAS CITY",
    "dropmalst": "CA",
    "dropmalzpp": 960249998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306235149,
    "dropsitcph": 5306235149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20916",
    "droptype": "D",
    "dropname": "DOWNEY",
    "dropdeladd": "8111 FIRESTONE BLVD",
    "dropdelcty": "DOWNEY",
    "dropdelst": "CA",
    "dropdelzpp": 902419998,
    "dropphyadd": "8111 FIRESTONE BLVD",
    "dropphycty": "DOWNEY",
    "dropphyst": "CA",
    "dropphyzpp": 902419998,
    "dropmaladd": "8111 FIRESTONE BLVD",
    "dropmalcty": "DOWNEY",
    "dropmalst": "CA",
    "dropmalzpp": 902419998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5629046120,
    "dropsitcph": 5626225745,
    "dropfax": 5629235897
  },
  {
    "dcode": "D",
    "dropkey": "PZ20917",
    "droptype": "D",
    "dropname": "DOWNIEVILLE",
    "dropdeladd": "301 MAIN ST",
    "dropdelcty": "DOWNIEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959369998,
    "dropphyadd": "301 MAIN ST",
    "dropphycty": "DOWNIEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959369998,
    "dropmaladd": "301 MAIN ST",
    "dropmalcty": "DOWNIEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959369998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302896528,
    "dropsitcph": 5302896528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20933",
    "droptype": "D",
    "dropname": "DOYLE",
    "dropdeladd": "745-850 RACHEL DR",
    "dropdelcty": "DOYLE",
    "dropdelst": "CA",
    "dropdelzpp": 961099995,
    "dropphyadd": "745-850 RACHEL DR",
    "dropphycty": "DOYLE",
    "dropphyst": "CA",
    "dropphyzpp": 961099995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DOYLE",
    "dropmalst": "CA",
    "dropmalzpp": 961099998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308272741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20938",
    "droptype": "D",
    "dropname": "DUARTE",
    "dropdeladd": "1220 HIGHLAND AVE",
    "dropdelcty": "DUARTE",
    "dropdelst": "CA",
    "dropdelzpp": 910109998,
    "dropphyadd": "1220 HIGHLAND AVE",
    "dropphycty": "DUARTE",
    "dropphyst": "CA",
    "dropphyzpp": 910109998,
    "dropmaladd": "1220 HIGHLAND AVE",
    "dropmalcty": "DUARTE",
    "dropmalst": "CA",
    "dropmalzpp": 910109998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6262566033,
    "dropsitcph": 6262566043,
    "dropfax": 6263571467
  },
  {
    "dcode": "D",
    "dropkey": "PZ20940",
    "droptype": "D",
    "dropname": "DUCOR",
    "dropdeladd": "23318 AVENUE 56",
    "dropdelcty": "DUCOR",
    "dropdelst": "CA",
    "dropdelzpp": 932189997,
    "dropphyadd": "23318 AVENUE 56",
    "dropphycty": "DUCOR",
    "dropphyst": "CA",
    "dropphyzpp": 932189997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUCOR",
    "dropmalst": "CA",
    "dropmalzpp": 932189998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595342440,
    "dropsitcph": 5595342440,
    "dropfax": 5595342336
  },
  {
    "dcode": "D",
    "dropkey": "PZ20941",
    "droptype": "D",
    "dropname": "DULZURA",
    "dropdeladd": "17015 HIGHWAY 94",
    "dropdelcty": "DULZURA",
    "dropdelst": "CA",
    "dropdelzpp": 919179998,
    "dropphyadd": "17015 HIGHWAY 94",
    "dropphycty": "DULZURA",
    "dropphyst": "CA",
    "dropphyzpp": 919179998,
    "dropmaladd": "17015 HIGHWAY 94",
    "dropmalcty": "DULZURA",
    "dropmalst": "CA",
    "dropmalzpp": 919179998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194683382,
    "dropsitcph": 6194683382,
    "dropfax": 6194686834
  },
  {
    "dcode": "D",
    "dropkey": "PZ20942",
    "droptype": "D",
    "dropname": "DUNCANS MILLS",
    "dropdeladd": "25375 STEELHEAD BLVD",
    "dropdelcty": "DUNCANS MILLS",
    "dropdelst": "CA",
    "dropdelzpp": 954309400,
    "dropphyadd": "25375 STEELHEAD BLVD",
    "dropphycty": "DUNCANS MILLS",
    "dropphyst": "CA",
    "dropphyzpp": 954309400,
    "dropmaladd": "25375 STEELHEAD BLVD",
    "dropmalcty": "DUNCANS MILLS",
    "dropmalst": "CA",
    "dropmalzpp": 954309998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078652767,
    "dropfax": 7078652767
  },
  {
    "dcode": "D",
    "dropkey": "PZ20944",
    "droptype": "D",
    "dropname": "DUNLAP",
    "dropdeladd": "39400 DUNLAP RD",
    "dropdelcty": "DUNLAP",
    "dropdelst": "CA",
    "dropdelzpp": 936219998,
    "dropphyadd": "39400 DUNLAP RD",
    "dropphycty": "DUNLAP",
    "dropphyst": "CA",
    "dropphyzpp": 936219998,
    "dropmaladd": "39400 DUNLAP RD",
    "dropmalcty": "DUNLAP",
    "dropmalst": "CA",
    "dropmalzpp": 936219998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5593382493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20946",
    "droptype": "D",
    "dropname": "DUNNIGAN",
    "dropdeladd": "3650 COUNTY ROAD 99W",
    "dropdelcty": "DUNNIGAN",
    "dropdelst": "CA",
    "dropdelzpp": 959379998,
    "dropphyadd": "3650 COUNTY ROAD 99W",
    "dropphycty": "DUNNIGAN",
    "dropphyst": "CA",
    "dropphyzpp": 959379998,
    "dropmaladd": "3650 COUNTY ROAD 99W",
    "dropmalcty": "DUNNIGAN",
    "dropmalst": "CA",
    "dropmalzpp": 959379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307243420,
    "dropsitcph": 5307243420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20947",
    "droptype": "D",
    "dropname": "DUNSMUIR",
    "dropdeladd": "5530 DUNSMUIR AVE",
    "dropdelcty": "DUNSMUIR",
    "dropdelst": "CA",
    "dropdelzpp": 960259998,
    "dropphyadd": "5530 DUNSMUIR AVE",
    "dropphycty": "DUNSMUIR",
    "dropphyst": "CA",
    "dropphyzpp": 960259998,
    "dropmaladd": "5530 DUNSMUIR AVE",
    "dropmalcty": "DUNSMUIR",
    "dropmalst": "CA",
    "dropmalzpp": 960259998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302350338,
    "dropsitcph": 5302350338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20948",
    "droptype": "D",
    "dropname": "DURHAM",
    "dropdeladd": "2396 DURHAM DAYTON HWY",
    "dropdelcty": "DURHAM",
    "dropdelst": "CA",
    "dropdelzpp": 959389998,
    "dropphyadd": "2396 DURHAM DAYTON HWY",
    "dropphycty": "DURHAM",
    "dropphyst": "CA",
    "dropphyzpp": 959389998,
    "dropmaladd": "2396 DURHAM DAYTON HWY",
    "dropmalcty": "DURHAM",
    "dropmalst": "CA",
    "dropmalzpp": 959389998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303431597,
    "dropsitcph": 5303431597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20949",
    "droptype": "D",
    "dropname": "DUTCH FLAT",
    "dropdeladd": "32805 MAIN ST",
    "dropdelcty": "DUTCH FLAT",
    "dropdelst": "CA",
    "dropdelzpp": 957149998,
    "dropphyadd": "32805 MAIN ST",
    "dropphycty": "DUTCH FLAT",
    "dropphyst": "CA",
    "dropphyzpp": 957149998,
    "dropmaladd": "32805 MAIN ST",
    "dropmalcty": "DUTCH FLAT",
    "dropmalst": "CA",
    "dropmalzpp": 957149998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303892644,
    "dropsitcph": 5303892644,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20960",
    "droptype": "D",
    "dropname": "EAGLEVILLE",
    "dropdeladd": "13761 MAIN ST",
    "dropdelcty": "EAGLEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961109800,
    "dropphyadd": "13761 MAIN ST",
    "dropphycty": "EAGLEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961109800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAGLEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302792440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ20961",
    "droptype": "D",
    "dropname": "EARLIMART",
    "dropdeladd": "300 N CHURCH RD",
    "dropdelcty": "EARLIMART",
    "dropdelst": "CA",
    "dropdelzpp": 932199998,
    "dropphyadd": "300 N CHURCH RD",
    "dropphycty": "EARLIMART",
    "dropphyst": "CA",
    "dropphyzpp": 932199998,
    "dropmaladd": "300 N CHURCH RD",
    "dropmalcty": "EARLIMART",
    "dropmalst": "CA",
    "dropmalzpp": 932199998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618496132,
    "dropsitcph": 6618496132,
    "dropfax": 6618496534
  },
  {
    "dcode": "D",
    "dropkey": "PZ20962",
    "droptype": "D",
    "dropname": "EARP",
    "dropdeladd": "144977 AQUEDUCT RD",
    "dropdelcty": "EARP",
    "dropdelst": "CA",
    "dropdelzpp": 922429997,
    "dropphyadd": "144977 AQUEDUCT RD",
    "dropphycty": "EARP",
    "dropphyst": "CA",
    "dropphyzpp": 922429997,
    "dropmaladd": "144977 AQUEDUCT RD",
    "dropmalcty": "EARP",
    "dropmalst": "CA",
    "dropmalzpp": 922429997,
    "dropsitphn": 9093354694,
    "dropsitlph": 7606652744,
    "dropsitcph": 7606652744,
    "dropfax": 7606651061
  },
  {
    "dcode": "D",
    "dropkey": "PZ21000",
    "droptype": "D",
    "dropname": "EDISON",
    "dropdeladd": "12299 EDISON HWY",
    "dropdelcty": "EDISON",
    "dropdelst": "CA",
    "dropdelzpp": 932209997,
    "dropphyadd": "12299 EDISON HWY",
    "dropphycty": "EDISON",
    "dropphyst": "CA",
    "dropphyzpp": 932209997,
    "dropmaladd": "12299 EDISON HWY",
    "dropmalcty": "EDISON",
    "dropmalst": "CA",
    "dropmalzpp": 932209997,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613663428,
    "dropsitcph": 6613663428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21003",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "1000 KINCHELOE AVE",
    "dropdelcty": "EDWARDS",
    "dropdelst": "CA",
    "dropdelzpp": 935239998,
    "dropphyadd": "1000 KINCHELOE AVE",
    "dropphycty": "EDWARDS",
    "dropphyst": "CA",
    "dropphyzpp": 935239998,
    "dropmaladd": "1000 KINCHELOE AVE",
    "dropmalcty": "EDWARDS",
    "dropmalst": "CA",
    "dropmalzpp": 935239998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612587145,
    "dropsitcph": 6612587145,
    "dropfax": 6612587065
  },
  {
    "dcode": "D",
    "dropkey": "PZ21009",
    "droptype": "D",
    "dropname": "EL CAJON",
    "dropdeladd": "401 W LEXINGTON AVE",
    "dropdelcty": "EL CAJON",
    "dropdelst": "CA",
    "dropdelzpp": 920209998,
    "dropphyadd": "401 W LEXINGTON AVE",
    "dropphycty": "EL CAJON",
    "dropphyst": "CA",
    "dropphyzpp": 920209998,
    "dropmaladd": "401 W LEXINGTON AVE",
    "dropmalcty": "EL CAJON",
    "dropmalst": "CA",
    "dropmalzpp": 920209998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195888591,
    "dropsitcph": 6195888665,
    "dropfax": 6194422811
  },
  {
    "dcode": "D",
    "dropkey": "PZ21012",
    "droptype": "D",
    "dropname": "EL CENTRO",
    "dropdeladd": "1598 W MAIN ST",
    "dropdelcty": "EL CENTRO",
    "dropdelst": "CA",
    "dropdelzpp": 922439998,
    "dropphyadd": "1598 W MAIN ST",
    "dropphycty": "EL CENTRO",
    "dropphyst": "CA",
    "dropphyzpp": 922439998,
    "dropmaladd": "1598 W MAIN ST",
    "dropmalcty": "EL CENTRO",
    "dropmalst": "CA",
    "dropmalzpp": 922439998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603525086,
    "dropsitcph": 7603526887,
    "dropfax": 7603523695
  },
  {
    "dcode": "D",
    "dropkey": "PZ21015",
    "droptype": "D",
    "dropname": "EL CERRITO",
    "dropdeladd": "11135 SAN PABLO AVE",
    "dropdelcty": "EL CERRITO",
    "dropdelst": "CA",
    "dropdelzpp": 945309998,
    "dropphyadd": "11135 SAN PABLO AVE",
    "dropphycty": "EL CERRITO",
    "dropphyst": "CA",
    "dropphyzpp": 945309998,
    "dropmaladd": "11135 SAN PABLO AVE",
    "dropmalcty": "EL CERRITO",
    "dropmalst": "CA",
    "dropmalzpp": 945309998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102357039,
    "dropsitcph": 5102355643,
    "dropfax": 5102355981
  },
  {
    "dcode": "D",
    "dropkey": "PZ21016",
    "droptype": "D",
    "dropname": "EL DORADO",
    "dropdeladd": "6166 PLEASANT VALLEY RD",
    "dropdelcty": "EL DORADO",
    "dropdelst": "CA",
    "dropdelzpp": 956239998,
    "dropphyadd": "6166 PLEASANT VALLEY RD",
    "dropphycty": "EL DORADO",
    "dropphyst": "CA",
    "dropphyzpp": 956239998,
    "dropmaladd": "6166 PLEASANT VALLEY RD",
    "dropmalcty": "EL DORADO",
    "dropmalst": "CA",
    "dropmalzpp": 956239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306268631,
    "dropsitcph": 5306269531,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21019",
    "droptype": "D",
    "dropname": "EL GRANADA",
    "dropdeladd": "20 AVENUE PORTOLA",
    "dropdelcty": "EL GRANADA",
    "dropdelst": "CA",
    "dropdelzpp": 940189998,
    "dropphyadd": "20 AVENUE PORTOLA",
    "dropphycty": "EL GRANADA",
    "dropphyst": "CA",
    "dropphyzpp": 940189998,
    "dropmaladd": "20 AVENUE PORTOLA",
    "dropmalcty": "EL GRANADA",
    "dropmalst": "CA",
    "dropmalzpp": 940189998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507265000,
    "dropsitcph": 6507265000,
    "dropfax": 6507263408
  },
  {
    "dcode": "D",
    "dropkey": "PZ21023",
    "droptype": "D",
    "dropname": "EL MONTE",
    "dropdeladd": "11151 VALLEY BLVD",
    "dropdelcty": "EL MONTE",
    "dropdelst": "CA",
    "dropdelzpp": 917349998,
    "dropphyadd": "11151 VALLEY BLVD",
    "dropphycty": "EL MONTE",
    "dropphyst": "CA",
    "dropphyzpp": 917349998,
    "dropmaladd": "11151 VALLEY BLVD",
    "dropmalcty": "EL MONTE",
    "dropmalst": "CA",
    "dropmalzpp": 917349998,
    "dropsitphn": 6264430704,
    "dropsitlph": 6264441966,
    "dropsitcph": 6264430704,
    "dropfax": 6264438157
  },
  {
    "dcode": "D",
    "dropkey": "PZ21024",
    "droptype": "D",
    "dropname": "EL NIDO",
    "dropdeladd": "10366 S HIGHWAY 59",
    "dropdelcty": "EL NIDO",
    "dropdelst": "CA",
    "dropdelzpp": 953179998,
    "dropphyadd": "10366 S HIGHWAY 59",
    "dropphycty": "EL NIDO",
    "dropphyst": "CA",
    "dropphyzpp": 953179998,
    "dropmaladd": "10366 S HIGHWAY 59",
    "dropmalcty": "EL NIDO",
    "dropmalst": "CA",
    "dropmalzpp": 953179998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097221023,
    "dropsitcph": 2097221023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21025",
    "droptype": "D",
    "dropname": "EL PORTAL",
    "dropdeladd": "5508 FORESTA RD",
    "dropdelcty": "EL PORTAL",
    "dropdelst": "CA",
    "dropdelzpp": 953189998,
    "dropphyadd": "5508 FORESTA RD",
    "dropphycty": "EL PORTAL",
    "dropphyst": "CA",
    "dropphyzpp": 953189998,
    "dropmaladd": "5508 FORESTA RD",
    "dropmalcty": "EL PORTAL",
    "dropmalst": "CA",
    "dropmalzpp": 953189998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093792311,
    "dropsitcph": 2093792311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21031",
    "droptype": "D",
    "dropname": "EL TORO",
    "dropdeladd": "24552 RAYMOND WAY",
    "dropdelcty": "LAKE FOREST",
    "dropdelst": "CA",
    "dropdelzpp": 926309998,
    "dropphyadd": "24552 RAYMOND WAY",
    "dropphycty": "LAKE FOREST",
    "dropphyst": "CA",
    "dropphyzpp": 926309998,
    "dropmaladd": "24552 RAYMOND WAY",
    "dropmalcty": "LAKE FOREST",
    "dropmalst": "CA",
    "dropmalzpp": 926309998,
    "dropsitphn": 9498371976,
    "dropsitlph": 9498371302,
    "dropsitcph": 9498371976,
    "dropfax": 9498372984
  },
  {
    "dcode": "D",
    "dropkey": "PZ21035",
    "droptype": "D",
    "dropname": "EL VERANO",
    "dropdeladd": "19050 BAY ST",
    "dropdelcty": "EL VERANO",
    "dropdelst": "CA",
    "dropdelzpp": 954339998,
    "dropphyadd": "19050 BAY ST",
    "dropphycty": "EL VERANO",
    "dropphyst": "CA",
    "dropphyzpp": 954339998,
    "dropmaladd": "19050 BAY ST",
    "dropmalcty": "EL VERANO",
    "dropmalst": "CA",
    "dropmalzpp": 954339998,
    "dropsitphn": 7079385249,
    "dropsitlph": 7079385249,
    "dropsitcph": 7079385249,
    "dropfax": 7079381657
  },
  {
    "dcode": "D",
    "dropkey": "PZ21037",
    "droptype": "D",
    "dropname": "ELDRIDGE",
    "dropdeladd": "15000 ARNOLD DR",
    "dropdelcty": "ELDRIDGE",
    "dropdelst": "CA",
    "dropdelzpp": 954318900,
    "dropphyadd": "15000 ARNOLD DR",
    "dropphycty": "ELDRIDGE",
    "dropphyst": "CA",
    "dropphyzpp": 954318900,
    "dropmaladd": "15000 ARNOLD DR",
    "dropmalcty": "ELDRIDGE",
    "dropmalst": "CA",
    "dropmalzpp": 954319998,
    "dropsitphn": 7079386519,
    "dropsitlph": 7079386519,
    "dropsitcph": 7079386519,
    "dropfax": 7079385764
  },
  {
    "dcode": "D",
    "dropkey": "PZ21040",
    "droptype": "D",
    "dropname": "ELK",
    "dropdeladd": "5995 S HIGHWAY 1",
    "dropdelcty": "ELK",
    "dropdelst": "CA",
    "dropdelzpp": 954329998,
    "dropphyadd": "5995 S HIGHWAY 1",
    "dropphycty": "ELK",
    "dropphyst": "CA",
    "dropphyzpp": 954329998,
    "dropmaladd": "5995 S HIGHWAY 1",
    "dropmalcty": "ELK",
    "dropmalst": "CA",
    "dropmalzpp": 954329998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078773232,
    "dropfax": 7078773232
  },
  {
    "dcode": "D",
    "dropkey": "PZ21041",
    "droptype": "D",
    "dropname": "ELK CREEK",
    "dropdeladd": "160 CHURCH ST",
    "dropdelcty": "ELK CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 959399998,
    "dropphyadd": "160 CHURCH ST",
    "dropphycty": "ELK CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 959399998,
    "dropmaladd": "160 CHURCH ST",
    "dropmalcty": "ELK CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 959399998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309685187,
    "dropsitcph": 5309685187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21042",
    "droptype": "D",
    "dropname": "ELK GROVE",
    "dropdeladd": "8850 WILLIAMSON DR",
    "dropdelcty": "ELK GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 956249998,
    "dropphyadd": "8850 WILLIAMSON DR",
    "dropphycty": "ELK GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 956249998,
    "dropmaladd": "8850 WILLIAMSON DR",
    "dropmalcty": "ELK GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 956249998,
    "dropsitphn": 9166856400,
    "dropsitlph": 9166853120,
    "dropsitcph": 9166853120,
    "dropfax": 9166852804
  },
  {
    "dcode": "D",
    "dropkey": "PZ21046",
    "droptype": "D",
    "dropname": "ELMIRA",
    "dropdeladd": "5377 VACA STATION RD",
    "dropdelcty": "ELMIRA",
    "dropdelst": "CA",
    "dropdelzpp": 956259998,
    "dropphyadd": "5377 VACA STATION RD",
    "dropphycty": "ELMIRA",
    "dropphyst": "CA",
    "dropphyzpp": 956259998,
    "dropmaladd": "5377 VACA STATION RD",
    "dropmalcty": "ELMIRA",
    "dropmalst": "CA",
    "dropmalzpp": 956259998,
    "dropsitphn": 9163738025,
    "dropsitlph": 7074483882,
    "dropsitcph": 7074483882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21049",
    "droptype": "D",
    "dropname": "ELVERTA",
    "dropdeladd": "161 W ELVERTA RD",
    "dropdelcty": "ELVERTA",
    "dropdelst": "CA",
    "dropdelzpp": 956269998,
    "dropphyadd": "161 W ELVERTA RD",
    "dropphycty": "ELVERTA",
    "dropphyst": "CA",
    "dropphyzpp": 956269998,
    "dropmaladd": "161 W ELVERTA RD",
    "dropmalcty": "ELVERTA",
    "dropmalst": "CA",
    "dropmalzpp": 956269998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169916264,
    "dropsitcph": 9169913453,
    "dropfax": 9169925469
  },
  {
    "dcode": "D",
    "dropkey": "PZ21056",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "5102 YOSEMITE BLVD",
    "dropdelcty": "EMPIRE",
    "dropdelst": "CA",
    "dropdelzpp": 953199998,
    "dropphyadd": "5102 YOSEMITE BLVD",
    "dropphycty": "EMPIRE",
    "dropphyst": "CA",
    "dropphyzpp": 953199998,
    "dropmaladd": "5102 YOSEMITE BLVD",
    "dropmalcty": "EMPIRE",
    "dropmalst": "CA",
    "dropmalzpp": 953199998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095222681,
    "dropsitcph": 2095222681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21059",
    "droptype": "D",
    "dropname": "ENCINITAS",
    "dropdeladd": "1150 GARDEN VIEW RD",
    "dropdelcty": "ENCINITAS",
    "dropdelst": "CA",
    "dropdelzpp": 920249998,
    "dropphyadd": "1150 GARDEN VIEW RD",
    "dropphycty": "ENCINITAS",
    "dropphyst": "CA",
    "dropphyzpp": 920249998,
    "dropmaladd": "1150 GARDEN VIEW RD",
    "dropmalcty": "ENCINITAS",
    "dropmalst": "CA",
    "dropmalzpp": 920249998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607530793,
    "dropsitcph": 7607531415,
    "dropfax": 7607534815
  },
  {
    "dcode": "D",
    "dropkey": "PZ21063",
    "droptype": "D",
    "dropname": "ESCALON",
    "dropdeladd": "1854 COLEY AVE",
    "dropdelcty": "ESCALON",
    "dropdelst": "CA",
    "dropdelzpp": 953209998,
    "dropphyadd": "1854 COLEY AVE",
    "dropphycty": "ESCALON",
    "dropphyst": "CA",
    "dropphyzpp": 953209998,
    "dropmaladd": "1854 COLEY AVE",
    "dropmalcty": "ESCALON",
    "dropmalst": "CA",
    "dropmalzpp": 953209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098382334,
    "dropsitcph": 2098382334,
    "dropfax": 2098383421
  },
  {
    "dcode": "D",
    "dropkey": "PZ21064",
    "droptype": "D",
    "dropname": "ESCONDIDO",
    "dropdeladd": "1157 W MISSION AVE",
    "dropdelcty": "ESCONDIDO",
    "dropdelst": "CA",
    "dropdelzpp": 920259998,
    "dropphyadd": "1157 W MISSION AVE",
    "dropphycty": "ESCONDIDO",
    "dropphyst": "CA",
    "dropphyzpp": 920259998,
    "dropmaladd": "1157 W MISSION AVE",
    "dropmalcty": "ESCONDIDO",
    "dropmalst": "CA",
    "dropmalzpp": 920259998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607359816,
    "dropsitcph": 7607359507,
    "dropfax": 7607457504
  },
  {
    "dcode": "D",
    "dropkey": "PZ21066",
    "droptype": "D",
    "dropname": "ESPARTO",
    "dropdeladd": "16884 YOLO AVE",
    "dropdelcty": "ESPARTO",
    "dropdelst": "CA",
    "dropdelzpp": 956279998,
    "dropphyadd": "16884 YOLO AVE",
    "dropphycty": "ESPARTO",
    "dropphyst": "CA",
    "dropphyzpp": 956279998,
    "dropmaladd": "16884 YOLO AVE",
    "dropmalcty": "ESPARTO",
    "dropmalst": "CA",
    "dropmalzpp": 956279998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307873801,
    "dropsitcph": 5307873801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21070",
    "droptype": "D",
    "dropname": "ETNA",
    "dropdeladd": "119 DIGGLES ST",
    "dropdelcty": "ETNA",
    "dropdelst": "CA",
    "dropdelzpp": 960279998,
    "dropphyadd": "119 DIGGLES ST",
    "dropphycty": "ETNA",
    "dropphyst": "CA",
    "dropphyzpp": 960279998,
    "dropmaladd": "119 DIGGLES ST",
    "dropmalcty": "ETNA",
    "dropmalst": "CA",
    "dropmalzpp": 960279998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304673981,
    "dropsitcph": 5304673981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21072",
    "droptype": "D",
    "dropname": "EUREKA",
    "dropdeladd": "337 W CLARK ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "CA",
    "dropdelzpp": 955019903,
    "dropphyadd": "337 W CLARK ST",
    "dropphycty": "EUREKA",
    "dropphyst": "CA",
    "dropphyzpp": 955019903,
    "dropmaladd": "337 W CLARK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "CA",
    "dropmalzpp": 955019903,
    "dropsitphn": 7077785461,
    "dropsitlph": 7074425141,
    "dropsitcph": 7074421768,
    "dropfax": 7074459076
  },
  {
    "dcode": "D",
    "dropkey": "PZ21074",
    "droptype": "D",
    "dropname": "EXETER",
    "dropdeladd": "135 S D ST",
    "dropdelcty": "EXETER",
    "dropdelst": "CA",
    "dropdelzpp": 932219998,
    "dropphyadd": "135 S D ST",
    "dropphycty": "EXETER",
    "dropphyst": "CA",
    "dropphyzpp": 932219998,
    "dropmaladd": "135 S D ST",
    "dropmalcty": "EXETER",
    "dropmalst": "CA",
    "dropmalzpp": 932219998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5598383206,
    "dropsitcph": 5598383111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21077",
    "droptype": "D",
    "dropname": "FAIR OAKS",
    "dropdeladd": "7862 WINDING WAY",
    "dropdelcty": "FAIR OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 956289998,
    "dropphyadd": "7862 WINDING WAY",
    "dropphycty": "FAIR OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 956289998,
    "dropmaladd": "7862 WINDING WAY",
    "dropmalcty": "FAIR OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 956289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169671001,
    "dropsitcph": 9169670249,
    "dropfax": 9169679997
  },
  {
    "dcode": "D",
    "dropkey": "PZ21079",
    "droptype": "D",
    "dropname": "FAIRFAX",
    "dropdeladd": "773 CENTER BLVD",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "CA",
    "dropdelzpp": 949301738,
    "dropphyadd": "773 CENTER BLVD",
    "dropphycty": "FAIRFAX",
    "dropphyst": "CA",
    "dropphyzpp": 949301738,
    "dropmaladd": "773 CENTER BLVD",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "CA",
    "dropmalzpp": 949301738,
    "dropsitphn": 4154533146,
    "dropsitlph": 4154533146,
    "dropsitcph": 4154533146,
    "dropfax": 4154537765
  },
  {
    "dcode": "D",
    "dropkey": "PZ21080",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "600 KENTUCKY ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 945339998,
    "dropphyadd": "600 KENTUCKY ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 945339998,
    "dropmaladd": "600 KENTUCKY ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 945339998,
    "dropsitphn": 5104337569,
    "dropsitlph": 7074257325,
    "dropsitcph": 7074252789,
    "dropfax": 7074258459
  },
  {
    "dcode": "D",
    "dropkey": "PZ21086",
    "droptype": "D",
    "dropname": "FALL RIVER MILLS",
    "dropdeladd": "43294 STATE HIGHWAY 299 E",
    "dropdelcty": "FALL RIVER MILLS",
    "dropdelst": "CA",
    "dropdelzpp": 960289998,
    "dropphyadd": "43294 STATE HIGHWAY 299 E",
    "dropphycty": "FALL RIVER MILLS",
    "dropphyst": "CA",
    "dropphyzpp": 960289998,
    "dropmaladd": "43294 STATE HIGHWAY 299 E",
    "dropmalcty": "FALL RIVER MILLS",
    "dropmalst": "CA",
    "dropmalzpp": 960289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303365771,
    "dropsitcph": 6265654348,
    "dropfax": 5303367202
  },
  {
    "dcode": "D",
    "dropkey": "PZ21087",
    "droptype": "D",
    "dropname": "FALLBROOK",
    "dropdeladd": "747 S MISSION RD",
    "dropdelcty": "FALLBROOK",
    "dropdelst": "CA",
    "dropdelzpp": 920289998,
    "dropphyadd": "747 S MISSION RD",
    "dropphycty": "FALLBROOK",
    "dropphyst": "CA",
    "dropphyzpp": 920289998,
    "dropmaladd": "747 S MISSION RD",
    "dropmalcty": "FALLBROOK",
    "dropmalst": "CA",
    "dropmalzpp": 920289998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607288643,
    "dropsitcph": 7607282946,
    "dropfax": 7607284726
  },
  {
    "dcode": "D",
    "dropkey": "PZ21095",
    "droptype": "D",
    "dropname": "FARMERSVILLE",
    "dropdeladd": "382 N FARMERSVILLE BLVD",
    "dropdelcty": "FARMERSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932239998,
    "dropphyadd": "382 N FARMERSVILLE BLVD",
    "dropphycty": "FARMERSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932239998,
    "dropmaladd": "382 N FARMERSVILLE BLVD",
    "dropmalcty": "FARMERSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932239998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597543958,
    "dropsitcph": 5597543957,
    "dropfax": 5597472635
  },
  {
    "dcode": "D",
    "dropkey": "PZ21096",
    "droptype": "D",
    "dropname": "FARMINGTON",
    "dropdeladd": "25320 E HIGHWAY 4",
    "dropdelcty": "FARMINGTON",
    "dropdelst": "CA",
    "dropdelzpp": 952309998,
    "dropphyadd": "25320 E HIGHWAY 4",
    "dropphycty": "FARMINGTON",
    "dropphyst": "CA",
    "dropphyzpp": 952309998,
    "dropmaladd": "25320 E HIGHWAY 4",
    "dropmalcty": "FARMINGTON",
    "dropmalst": "CA",
    "dropmalzpp": 952309998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098865416,
    "dropsitcph": 2098865416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21099",
    "droptype": "D",
    "dropname": "FAWNSKIN",
    "dropdeladd": "39132 N SHORE DR",
    "dropdelcty": "FAWNSKIN",
    "dropdelst": "CA",
    "dropdelzpp": 923330400,
    "dropphyadd": "39132 N SHORE DR",
    "dropphycty": "FAWNSKIN",
    "dropphyst": "CA",
    "dropphyzpp": 923330400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FAWNSKIN",
    "dropmalst": "CA",
    "dropmalzpp": 923339998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098663245,
    "dropsitcph": 9098663245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21113",
    "droptype": "D",
    "dropname": "FELLOWS",
    "dropdeladd": "36 MIDWAY RD",
    "dropdelcty": "FELLOWS",
    "dropdelst": "CA",
    "dropdelzpp": 932249998,
    "dropphyadd": "36 MIDWAY RD",
    "dropphycty": "FELLOWS",
    "dropphyst": "CA",
    "dropphyzpp": 932249998,
    "dropmaladd": "36 MIDWAY RD",
    "dropmalcty": "FELLOWS",
    "dropmalst": "CA",
    "dropmalzpp": 932249998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617684266,
    "dropsitcph": 6617684266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21114",
    "droptype": "D",
    "dropname": "FELTON",
    "dropdeladd": "6101 GUSHEE ST",
    "dropdelcty": "FELTON",
    "dropdelst": "CA",
    "dropdelzpp": 950189998,
    "dropphyadd": "6101 GUSHEE ST",
    "dropphycty": "FELTON",
    "dropphyst": "CA",
    "dropphyzpp": 950189998,
    "dropmaladd": "6101 GUSHEE ST",
    "dropmalcty": "FELTON",
    "dropmalst": "CA",
    "dropmalzpp": 950189998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313358015,
    "dropsitcph": 8313358015,
    "dropfax": 8313350993
  },
  {
    "dcode": "D",
    "dropkey": "PZ21117",
    "droptype": "D",
    "dropname": "FERNDALE",
    "dropdeladd": "536 MAIN ST",
    "dropdelcty": "FERNDALE",
    "dropdelst": "CA",
    "dropdelzpp": 955369460,
    "dropphyadd": "536 MAIN ST",
    "dropphycty": "FERNDALE",
    "dropphyst": "CA",
    "dropphyzpp": 955369460,
    "dropmaladd": "536 MAIN ST",
    "dropmalcty": "FERNDALE",
    "dropmalst": "CA",
    "dropmalzpp": 955369460,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077864642,
    "dropsitcph": 7077864642,
    "dropfax": 7077864642
  },
  {
    "dcode": "D",
    "dropkey": "PZ21119",
    "droptype": "D",
    "dropname": "FIDDLETOWN",
    "dropdeladd": "14283 JIBBOOM ST",
    "dropdelcty": "FIDDLETOWN",
    "dropdelst": "CA",
    "dropdelzpp": 956299998,
    "dropphyadd": "14283 JIBBOOM ST",
    "dropphycty": "FIDDLETOWN",
    "dropphyst": "CA",
    "dropphyzpp": 956299998,
    "dropmaladd": "14283 JIBBOOM ST",
    "dropmalcty": "FIDDLETOWN",
    "dropmalst": "CA",
    "dropmalzpp": 956299998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092454168,
    "dropsitcph": 2092454168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21120",
    "droptype": "D",
    "dropname": "FIELDS LANDING",
    "dropdeladd": "6710 FIELDS LANDING DR",
    "dropdelcty": "FIELDS LANDING",
    "dropdelst": "CA",
    "dropdelzpp": 955378900,
    "dropphyadd": "6710 FIELDS LANDING DR",
    "dropphycty": "FIELDS LANDING",
    "dropphyst": "CA",
    "dropphyzpp": 955378900,
    "dropmaladd": "6710 FIELDS LANDING DR",
    "dropmalcty": "FIELDS LANDING",
    "dropmalst": "CA",
    "dropmalzpp": 955379998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074452821,
    "dropfax": 7074452821
  },
  {
    "dcode": "D",
    "dropkey": "PZ21123",
    "droptype": "D",
    "dropname": "FILLMORE",
    "dropdeladd": "333 CENTRAL AVE",
    "dropdelcty": "FILLMORE",
    "dropdelst": "CA",
    "dropdelzpp": 930159998,
    "dropphyadd": "333 CENTRAL AVE",
    "dropphycty": "FILLMORE",
    "dropphyst": "CA",
    "dropphyzpp": 930159998,
    "dropmaladd": "333 CENTRAL AVE",
    "dropmalcty": "FILLMORE",
    "dropmalst": "CA",
    "dropmalzpp": 930159998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055249332,
    "dropsitcph": 8055249332,
    "dropfax": 8055243457
  },
  {
    "dcode": "D",
    "dropkey": "PZ21126",
    "droptype": "D",
    "dropname": "FINLEY",
    "dropdeladd": "1904 BIG VALLEY RD",
    "dropdelcty": "FINLEY",
    "dropdelst": "CA",
    "dropdelzpp": 954358900,
    "dropphyadd": "1904 BIG VALLEY RD",
    "dropphycty": "FINLEY",
    "dropphyst": "CA",
    "dropphyzpp": 954358900,
    "dropmaladd": "1904 BIG VALLEY RD",
    "dropmalcty": "FINLEY",
    "dropmalst": "CA",
    "dropmalzpp": 954359998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7072634544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21127",
    "droptype": "D",
    "dropname": "FIREBAUGH",
    "dropdeladd": "1580 11TH ST",
    "dropdelcty": "FIREBAUGH",
    "dropdelst": "CA",
    "dropdelzpp": 936229998,
    "dropphyadd": "1580 11TH ST",
    "dropphycty": "FIREBAUGH",
    "dropphyst": "CA",
    "dropphyzpp": 936229998,
    "dropmaladd": "1580 11TH ST",
    "dropmalcty": "FIREBAUGH",
    "dropmalst": "CA",
    "dropmalzpp": 936229998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596596504,
    "dropsitcph": 5596596504,
    "dropfax": 5596597409
  },
  {
    "dcode": "D",
    "dropkey": "PZ21138",
    "droptype": "D",
    "dropname": "FISH CAMP",
    "dropdeladd": "7733 FISH CAMP LN",
    "dropdelcty": "FISH CAMP",
    "dropdelst": "CA",
    "dropdelzpp": 936239998,
    "dropphyadd": "7733 FISH CAMP LN",
    "dropphycty": "FISH CAMP",
    "dropphyst": "CA",
    "dropphyzpp": 936239998,
    "dropmaladd": "7733 FISH CAMP LN",
    "dropmalcty": "FISH CAMP",
    "dropmalst": "CA",
    "dropmalzpp": 936239998,
    "dropsitphn": 5305510041,
    "dropsitlph": 4084376726,
    "dropsitcph": 6262314963,
    "dropfax": 5305510367
  },
  {
    "dcode": "D",
    "dropkey": "PZ21143",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "21074 S LASSEN AVE",
    "dropdelcty": "FIVE POINTS",
    "dropdelst": "CA",
    "dropdelzpp": 936249998,
    "dropphyadd": "21074 S LASSEN AVE",
    "dropphycty": "FIVE POINTS",
    "dropphyst": "CA",
    "dropphyzpp": 936249998,
    "dropmaladd": "21074 S LASSEN AVE",
    "dropmalcty": "FIVE POINTS",
    "dropmalst": "CA",
    "dropmalzpp": 936249998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598842409,
    "dropfax": 5598841016
  },
  {
    "dcode": "D",
    "dropkey": "PZ21153",
    "droptype": "D",
    "dropname": "FOLSOM",
    "dropdeladd": "1015 RILEY ST",
    "dropdelcty": "FOLSOM",
    "dropdelst": "CA",
    "dropdelzpp": 956309998,
    "dropphyadd": "1015 RILEY ST",
    "dropphycty": "FOLSOM",
    "dropphyst": "CA",
    "dropphyzpp": 956309998,
    "dropmaladd": "1015 RILEY ST",
    "dropmalcty": "FOLSOM",
    "dropmalst": "CA",
    "dropmalzpp": 956309998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169830371,
    "dropsitcph": 9169830371,
    "dropfax": 9169833127
  },
  {
    "dcode": "D",
    "dropkey": "PZ21155",
    "droptype": "D",
    "dropname": "FONTANA",
    "dropdeladd": "8282 SIERRA AVE",
    "dropdelcty": "FONTANA",
    "dropdelst": "CA",
    "dropdelzpp": 923359998,
    "dropphyadd": "8282 SIERRA AVE",
    "dropphycty": "FONTANA",
    "dropphyst": "CA",
    "dropphyzpp": 923359998,
    "dropmaladd": "8282 SIERRA AVE",
    "dropmalcty": "FONTANA",
    "dropmalst": "CA",
    "dropmalzpp": 923359998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098220737,
    "dropsitcph": 9098228030,
    "dropfax": 9098221373
  },
  {
    "dcode": "D",
    "dropkey": "PZ21158",
    "droptype": "D",
    "dropname": "FORBESTOWN",
    "dropdeladd": "19173 NEW YORK FLAT RD",
    "dropdelcty": "FORBESTOWN",
    "dropdelst": "CA",
    "dropdelzpp": 959419998,
    "dropphyadd": "19173 NEW YORK FLAT RD",
    "dropphycty": "FORBESTOWN",
    "dropphyst": "CA",
    "dropphyzpp": 959419998,
    "dropmaladd": "19173 NEW YORK FLAT RD",
    "dropmalcty": "FORBESTOWN",
    "dropmalst": "CA",
    "dropmalzpp": 959419998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306752664,
    "dropsitcph": 5306752664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21160",
    "droptype": "D",
    "dropname": "FOREST FALLS",
    "dropdeladd": "40555 VALLEY OF THE FALLS DR",
    "dropdelcty": "FOREST FALLS",
    "dropdelst": "CA",
    "dropdelzpp": 923399998,
    "dropphyadd": "40555 VALLEY OF THE FALLS DR",
    "dropphycty": "FOREST FALLS",
    "dropphyst": "CA",
    "dropphyzpp": 923399998,
    "dropmaladd": "40555 VALLEY OF THE FALLS DR",
    "dropmalcty": "FOREST FALLS",
    "dropmalst": "CA",
    "dropmalzpp": 923399998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097942329,
    "dropsitcph": 9097942329,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21162",
    "droptype": "D",
    "dropname": "FOREST KNOLLS",
    "dropdeladd": "6 CASTRO ST",
    "dropdelcty": "FOREST KNOLLS",
    "dropdelst": "CA",
    "dropdelzpp": 949339100,
    "dropphyadd": "6 CASTRO ST",
    "dropphycty": "FOREST KNOLLS",
    "dropphyst": "CA",
    "dropphyzpp": 949339100,
    "dropmaladd": "6 CASTRO ST",
    "dropmalcty": "FOREST KNOLLS",
    "dropmalst": "CA",
    "dropmalzpp": 949339100,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154880533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21163",
    "droptype": "D",
    "dropname": "FOREST RANCH",
    "dropdeladd": "15517 NOPEL AVE",
    "dropdelcty": "FOREST RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 959429998,
    "dropphyadd": "15517 NOPEL AVE",
    "dropphycty": "FOREST RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 959429998,
    "dropmaladd": "15517 NOPEL AVE",
    "dropmalcty": "FOREST RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 959429998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303425233,
    "dropsitcph": 5303425233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21164",
    "droptype": "D",
    "dropname": "FORESTHILL",
    "dropdeladd": "24035 RACETRACK ST",
    "dropdelcty": "FORESTHILL",
    "dropdelst": "CA",
    "dropdelzpp": 956319998,
    "dropphyadd": "24035 RACETRACK ST",
    "dropphycty": "FORESTHILL",
    "dropphyst": "CA",
    "dropphyzpp": 956319998,
    "dropmaladd": "24035 RACETRACK ST",
    "dropmalcty": "FORESTHILL",
    "dropmalst": "CA",
    "dropmalzpp": 956319998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303674280,
    "dropsitcph": 5303674280,
    "dropfax": 5303675175
  },
  {
    "dcode": "D",
    "dropkey": "PZ21165",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "6484 MIRABEL RD",
    "dropdelcty": "FORESTVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954369288,
    "dropphyadd": "6484 MIRABEL RD",
    "dropphycty": "FORESTVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954369288,
    "dropmaladd": "6484 MIRABEL RD",
    "dropmalcty": "FORESTVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954369288,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078872277,
    "dropfax": 7078877536
  },
  {
    "dcode": "D",
    "dropkey": "PZ21168",
    "droptype": "D",
    "dropname": "FORKS OF SALMON",
    "dropdeladd": "39039 SAWYERS BAR RD",
    "dropdelcty": "FORKS OF SALMON",
    "dropdelst": "CA",
    "dropdelzpp": 960319998,
    "dropphyadd": "39039 SAWYERS BAR RD",
    "dropphycty": "FORKS OF SALMON",
    "dropphyst": "CA",
    "dropphyzpp": 960319998,
    "dropmaladd": "39039 SAWYERS BAR RD",
    "dropmalcty": "FORKS OF SALMON",
    "dropmalst": "CA",
    "dropmalzpp": 960319998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304624765,
    "dropsitcph": 5304624765,
    "dropfax": 5304624765
  },
  {
    "dcode": "D",
    "dropkey": "PZ21171",
    "droptype": "D",
    "dropname": "FORT BIDWELL",
    "dropdeladd": "47 E BRIDGE ST",
    "dropdelcty": "FORT BIDWELL",
    "dropdelst": "CA",
    "dropdelzpp": 961129800,
    "dropphyadd": "47 E BRIDGE ST",
    "dropphycty": "FORT BIDWELL",
    "dropphyst": "CA",
    "dropphyzpp": 961129800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FORT BIDWELL",
    "dropmalst": "CA",
    "dropmalzpp": 961129998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302792196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21172",
    "droptype": "D",
    "dropname": "FORT BRAGG",
    "dropdeladd": "203 N FRANKLIN ST",
    "dropdelcty": "FORT BRAGG",
    "dropdelst": "CA",
    "dropdelzpp": 954379912,
    "dropphyadd": "203 N FRANKLIN ST",
    "dropphycty": "FORT BRAGG",
    "dropphyst": "CA",
    "dropphyzpp": 954379912,
    "dropmaladd": "203 N FRANKLIN ST",
    "dropmalcty": "FORT BRAGG",
    "dropmalst": "CA",
    "dropmalzpp": 954379912,
    "dropsitphn": 7077785312,
    "dropsitlph": 7079640917,
    "dropsitcph": 7079642302,
    "dropfax": 7079646263
  },
  {
    "dcode": "D",
    "dropkey": "PZ21177",
    "droptype": "D",
    "dropname": "FORT JONES",
    "dropdeladd": "11954 MAIN ST",
    "dropdelcty": "FORT JONES",
    "dropdelst": "CA",
    "dropdelzpp": 960329998,
    "dropphyadd": "11954 MAIN ST",
    "dropphycty": "FORT JONES",
    "dropphyst": "CA",
    "dropphyzpp": 960329998,
    "dropmaladd": "11954 MAIN ST",
    "dropmalcty": "FORT JONES",
    "dropmalst": "CA",
    "dropmalzpp": 960329998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304685111,
    "dropsitcph": 5304685111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21184",
    "droptype": "D",
    "dropname": "FORTUNA",
    "dropdeladd": "699 13TH ST",
    "dropdelcty": "FORTUNA",
    "dropdelst": "CA",
    "dropdelzpp": 955409998,
    "dropphyadd": "699 13TH ST",
    "dropphycty": "FORTUNA",
    "dropphyst": "CA",
    "dropphyzpp": 955409998,
    "dropmaladd": "699 13TH ST",
    "dropmalcty": "FORTUNA",
    "dropmalst": "CA",
    "dropmalzpp": 955409998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077259306,
    "dropfax": 7077259587
  },
  {
    "dcode": "D",
    "dropkey": "PZ21190",
    "droptype": "D",
    "dropname": "FOWLER",
    "dropdeladd": "19 E MERCED ST",
    "dropdelcty": "FOWLER",
    "dropdelst": "CA",
    "dropdelzpp": 936259998,
    "dropphyadd": "19 E MERCED ST",
    "dropphycty": "FOWLER",
    "dropphyst": "CA",
    "dropphyzpp": 936259998,
    "dropmaladd": "19 E MERCED ST",
    "dropmalcty": "FOWLER",
    "dropmalst": "CA",
    "dropmalzpp": 936259998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598349882,
    "dropsitcph": 5598345322,
    "dropfax": 5598346832
  },
  {
    "dcode": "D",
    "dropkey": "PZ21199",
    "droptype": "D",
    "dropname": "FRAZIER PARK",
    "dropdeladd": "512 MONTEREY TRL",
    "dropdelcty": "FRAZIER PARK",
    "dropdelst": "CA",
    "dropdelzpp": 932259998,
    "dropphyadd": "512 MONTEREY TRL",
    "dropphycty": "FRAZIER PARK",
    "dropphyst": "CA",
    "dropphyzpp": 932259998,
    "dropmaladd": "512 MONTEREY TRL",
    "dropmalcty": "FRAZIER PARK",
    "dropmalst": "CA",
    "dropmalzpp": 932259998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6614616000,
    "dropsitcph": 6614616000,
    "dropfax": 6612455024
  },
  {
    "dcode": "D",
    "dropkey": "PZ21201",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "2004 FREEDOM BLVD",
    "dropdelcty": "FREEDOM",
    "dropdelst": "CA",
    "dropdelzpp": 950199998,
    "dropphyadd": "2004 FREEDOM BLVD",
    "dropphycty": "FREEDOM",
    "dropphyst": "CA",
    "dropphyzpp": 950199998,
    "dropmaladd": "2004 FREEDOM BLVD",
    "dropmalcty": "FREEDOM",
    "dropmalst": "CA",
    "dropmalzpp": 950199998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8317241513,
    "dropsitcph": 8317248219,
    "dropfax": 8317610979
  },
  {
    "dcode": "D",
    "dropkey": "PZ21203",
    "droptype": "D",
    "dropname": "FREMONT",
    "dropdeladd": "37010 DUSTERBERRY WAY",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945369998,
    "dropphyadd": "37010 DUSTERBERRY WAY",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945369998,
    "dropmaladd": "37010 DUSTERBERRY WAY",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945369998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107921655,
    "dropsitcph": 5107920282,
    "dropfax": 5107925437
  },
  {
    "dcode": "D",
    "dropkey": "PZ21205",
    "droptype": "D",
    "dropname": "FRENCH CAMP",
    "dropdeladd": "315 E FRENCH CAMP RD",
    "dropdelcty": "FRENCH CAMP",
    "dropdelst": "CA",
    "dropdelzpp": 952319998,
    "dropphyadd": "315 E FRENCH CAMP RD",
    "dropphycty": "FRENCH CAMP",
    "dropphyst": "CA",
    "dropphyzpp": 952319998,
    "dropmaladd": "315 E FRENCH CAMP RD",
    "dropmalcty": "FRENCH CAMP",
    "dropmalst": "CA",
    "dropmalzpp": 952319998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099820781,
    "dropsitcph": 2099820781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21207",
    "droptype": "D",
    "dropname": "FRENCH GULCH",
    "dropdeladd": "14200 MAIN ST",
    "dropdelcty": "FRENCH GULCH",
    "dropdelst": "CA",
    "dropdelzpp": 960339998,
    "dropphyadd": "14200 MAIN ST",
    "dropphycty": "FRENCH GULCH",
    "dropphyst": "CA",
    "dropphyzpp": 960339998,
    "dropmaladd": "14200 MAIN ST",
    "dropmalcty": "FRENCH GULCH",
    "dropmalst": "CA",
    "dropmalzpp": 960339998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303592100,
    "dropsitcph": 5303592100,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21210",
    "droptype": "D",
    "dropname": "FRESNO",
    "dropdeladd": "1900 E ST",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937069998,
    "dropphyadd": "1900 E ST",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937069998,
    "dropmaladd": "1900 E ST",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937069998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594977780,
    "dropsitcph": 5594977566,
    "dropfax": 5594977511
  },
  {
    "dcode": "D",
    "dropkey": "PZ21217",
    "droptype": "D",
    "dropname": "FRIANT",
    "dropdeladd": "17275 N FRIANT RD",
    "dropdelcty": "FRIANT",
    "dropdelst": "CA",
    "dropdelzpp": 936269998,
    "dropphyadd": "17275 N FRIANT RD",
    "dropphycty": "FRIANT",
    "dropphyst": "CA",
    "dropphyzpp": 936269998,
    "dropmaladd": "17275 N FRIANT RD",
    "dropmalcty": "FRIANT",
    "dropmalst": "CA",
    "dropmalzpp": 936269998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598222234,
    "dropsitcph": 5598222234,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21235",
    "droptype": "D",
    "dropname": "FULLERTON",
    "dropdeladd": "1350 E CHAPMAN AVE",
    "dropdelcty": "FULLERTON",
    "dropdelst": "CA",
    "dropdelzpp": 928349998,
    "dropphyadd": "1350 E CHAPMAN AVE",
    "dropphycty": "FULLERTON",
    "dropphyst": "CA",
    "dropphyzpp": 928349998,
    "dropmaladd": "1350 E CHAPMAN AVE",
    "dropmalcty": "FULLERTON",
    "dropmalst": "CA",
    "dropmalzpp": 928349998,
    "dropsitphn": 7145251024,
    "dropsitlph": 7145252350,
    "dropsitcph": 7145251024,
    "dropfax": 7148797122
  },
  {
    "dcode": "D",
    "dropkey": "PZ21236",
    "droptype": "D",
    "dropname": "FULTON",
    "dropdeladd": "3340 FULTON RD",
    "dropdelcty": "FULTON",
    "dropdelst": "CA",
    "dropdelzpp": 954398861,
    "dropphyadd": "3340 FULTON RD",
    "dropphycty": "FULTON",
    "dropphyst": "CA",
    "dropphyzpp": 954398861,
    "dropmaladd": "3340 FULTON RD",
    "dropmalcty": "FULTON",
    "dropmalst": "CA",
    "dropmalzpp": 954398861,
    "dropsitphn": 7075425663,
    "dropsitlph": 7075425663,
    "dropsitcph": 7075425663,
    "dropfax": 7075421415
  },
  {
    "dcode": "D",
    "dropkey": "PZ21243",
    "droptype": "D",
    "dropname": "GALT",
    "dropdeladd": "600 N LINCOLN WAY",
    "dropdelcty": "GALT",
    "dropdelst": "CA",
    "dropdelzpp": 956329998,
    "dropphyadd": "600 N LINCOLN WAY",
    "dropphycty": "GALT",
    "dropphyst": "CA",
    "dropphyzpp": 956329998,
    "dropmaladd": "600 N LINCOLN WAY",
    "dropmalcty": "GALT",
    "dropmalst": "CA",
    "dropmalzpp": 956329998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097456127,
    "dropsitcph": 2097456127,
    "dropfax": 2097452791
  },
  {
    "dcode": "D",
    "dropkey": "PZ21245",
    "droptype": "D",
    "dropname": "GARBERVILLE",
    "dropdeladd": "368 SPROWEL CREEK RD",
    "dropdelcty": "GARBERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 955423140,
    "dropphyadd": "368 SPROWEL CREEK RD",
    "dropphycty": "GARBERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 955423140,
    "dropmaladd": "368 SPROWEL CREEK RD",
    "dropmalcty": "GARBERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 955423140,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079232652,
    "dropfax": 7079234813
  },
  {
    "dcode": "D",
    "dropkey": "PZ21246",
    "droptype": "D",
    "dropname": "GARDEN GROVE",
    "dropdeladd": "10441 STANFORD AVE",
    "dropdelcty": "GARDEN GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 928429998,
    "dropphyadd": "10441 STANFORD AVE",
    "dropphycty": "GARDEN GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 928429998,
    "dropmaladd": "10441 STANFORD AVE",
    "dropmalcty": "GARDEN GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 928429998,
    "dropsitphn": 7145371181,
    "dropsitlph": 7145372380,
    "dropsitcph": 7145371181,
    "dropfax": 7146384356
  },
  {
    "dcode": "D",
    "dropkey": "PZ21248",
    "droptype": "D",
    "dropname": "GARDEN VALLEY",
    "dropdeladd": "4850 MARSHALL RD",
    "dropdelcty": "GARDEN VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 956339998,
    "dropphyadd": "4850 MARSHALL RD",
    "dropphycty": "GARDEN VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 956339998,
    "dropmaladd": "4850 MARSHALL RD",
    "dropmalcty": "GARDEN VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 956339998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303334828,
    "dropsitcph": 5303334828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21249",
    "droptype": "D",
    "dropname": "GARDENA",
    "dropdeladd": "1455 W REDONDO BEACH BLVD",
    "dropdelcty": "GARDENA",
    "dropdelst": "CA",
    "dropdelzpp": 902479998,
    "dropphyadd": "1455 W REDONDO BEACH BLVD",
    "dropphycty": "GARDENA",
    "dropphyst": "CA",
    "dropphyzpp": 902479998,
    "dropmaladd": "1455 W REDONDO BEACH BLVD",
    "dropmalcty": "GARDENA",
    "dropmalst": "CA",
    "dropmalzpp": 902479998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103275984,
    "dropsitcph": 4244153235,
    "dropfax": 3103276061
  },
  {
    "dcode": "D",
    "dropkey": "PZ21252",
    "droptype": "D",
    "dropname": "GASQUET",
    "dropdeladd": "10360 US HIGHWAY 199",
    "dropdelcty": "GASQUET",
    "dropdelst": "CA",
    "dropdelzpp": 955439900,
    "dropphyadd": "10360 US HIGHWAY 199",
    "dropphycty": "GASQUET",
    "dropphyst": "CA",
    "dropphyzpp": 955439900,
    "dropmaladd": "10360 US HIGHWAY 199",
    "dropmalcty": "GASQUET",
    "dropmalst": "CA",
    "dropmalzpp": 955439900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074573102,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21256",
    "droptype": "D",
    "dropname": "GAZELLE",
    "dropdeladd": "18418 OLD HIGHWAY 99",
    "dropdelcty": "GAZELLE",
    "dropdelst": "CA",
    "dropdelzpp": 960349998,
    "dropphyadd": "18418 OLD HIGHWAY 99",
    "dropphycty": "GAZELLE",
    "dropphyst": "CA",
    "dropphyzpp": 960349998,
    "dropmaladd": "18418 OLD HIGHWAY 99",
    "dropmalcty": "GAZELLE",
    "dropmalst": "CA",
    "dropmalzpp": 960349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304352350,
    "dropsitcph": 5304352350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21264",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "3180 SOUTH ST",
    "dropdelcty": "GEORGETOWN",
    "dropdelst": "CA",
    "dropdelzpp": 956349998,
    "dropphyadd": "3180 SOUTH ST",
    "dropphycty": "GEORGETOWN",
    "dropphyst": "CA",
    "dropphyzpp": 956349998,
    "dropmaladd": "3180 SOUTH ST",
    "dropmalcty": "GEORGETOWN",
    "dropmalst": "CA",
    "dropmalzpp": 956349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303334303,
    "dropsitcph": 5303334303,
    "dropfax": 5303332502
  },
  {
    "dcode": "D",
    "dropkey": "PZ21265",
    "droptype": "D",
    "dropname": "GERBER",
    "dropdeladd": "408 SAN BENITO AVE",
    "dropdelcty": "GERBER",
    "dropdelst": "CA",
    "dropdelzpp": 960359998,
    "dropphyadd": "408 SAN BENITO AVE",
    "dropphycty": "GERBER",
    "dropphyst": "CA",
    "dropphyzpp": 960359998,
    "dropmaladd": "408 SAN BENITO AVE",
    "dropmalcty": "GERBER",
    "dropmalst": "CA",
    "dropmalzpp": 960359998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303851566,
    "dropsitcph": 5303851566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21267",
    "droptype": "D",
    "dropname": "GEYSERVILLE",
    "dropdeladd": "116 SCHOOL HOUSE LN",
    "dropdelcty": "GEYSERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954419998,
    "dropphyadd": "116 SCHOOL HOUSE LN",
    "dropphycty": "GEYSERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954419998,
    "dropmaladd": "116 SCHOOL HOUSE LN",
    "dropmalcty": "GEYSERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954419998,
    "dropsitphn": 7078573445,
    "dropsitlph": 7078573445,
    "dropsitcph": 7078573445,
    "dropfax": 7078573445
  },
  {
    "dcode": "D",
    "dropkey": "PZ21272",
    "droptype": "D",
    "dropname": "GILROY",
    "dropdeladd": "100 4TH ST",
    "dropdelcty": "GILROY",
    "dropdelst": "CA",
    "dropdelzpp": 950209998,
    "dropphyadd": "100 4TH ST",
    "dropphycty": "GILROY",
    "dropphyst": "CA",
    "dropphyzpp": 950209998,
    "dropmaladd": "100 4TH ST",
    "dropmalcty": "GILROY",
    "dropmalst": "CA",
    "dropmalzpp": 950209998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4088428331,
    "dropsitcph": 4088421354,
    "dropfax": 4088428336
  },
  {
    "dcode": "D",
    "dropkey": "PZ21276",
    "droptype": "D",
    "dropname": "GLEN ELLEN",
    "dropdeladd": "13720 ARNOLD DR",
    "dropdelcty": "GLEN ELLEN",
    "dropdelst": "CA",
    "dropdelzpp": 954429321,
    "dropphyadd": "13720 ARNOLD DR",
    "dropphycty": "GLEN ELLEN",
    "dropphyst": "CA",
    "dropphyzpp": 954429321,
    "dropmaladd": "13720 ARNOLD DR",
    "dropmalcty": "GLEN ELLEN",
    "dropmalst": "CA",
    "dropmalzpp": 954429321,
    "dropsitphn": 7079969233,
    "dropsitlph": 7079969233,
    "dropsitcph": 7079969233,
    "dropfax": 7079965311
  },
  {
    "dcode": "D",
    "dropkey": "PZ21278",
    "droptype": "D",
    "dropname": "GLENCOE",
    "dropdeladd": "16087 HIGHWAY 26",
    "dropdelcty": "GLENCOE",
    "dropdelst": "CA",
    "dropdelzpp": 952329998,
    "dropphyadd": "16087 HIGHWAY 26",
    "dropphycty": "GLENCOE",
    "dropphyst": "CA",
    "dropphyzpp": 952329998,
    "dropmaladd": "16087 HIGHWAY 26",
    "dropmalcty": "GLENCOE",
    "dropmalst": "CA",
    "dropmalzpp": 952329998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092937730,
    "dropsitcph": 2092937730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21279",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "313 E BROADWAY",
    "dropdelcty": "GLENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 912059998,
    "dropphyadd": "313 E BROADWAY",
    "dropphycty": "GLENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 912059998,
    "dropmaladd": "313 E BROADWAY",
    "dropmalcty": "GLENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 912059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8182659230,
    "dropsitcph": 8182659214,
    "dropfax": 8182659262
  },
  {
    "dcode": "D",
    "dropkey": "PZ21281",
    "droptype": "D",
    "dropname": "GLENDORA",
    "dropdeladd": "255 S GLENDORA AVE",
    "dropdelcty": "GLENDORA",
    "dropdelst": "CA",
    "dropdelzpp": 917409998,
    "dropphyadd": "255 S GLENDORA AVE",
    "dropphycty": "GLENDORA",
    "dropphyst": "CA",
    "dropphyzpp": 917409998,
    "dropmaladd": "255 S GLENDORA AVE",
    "dropmalcty": "GLENDORA",
    "dropmalst": "CA",
    "dropmalzpp": 917409998,
    "dropsitphn": 6268579127,
    "dropsitlph": 6263354147,
    "dropsitcph": 6268579127,
    "dropfax": 6268570367
  },
  {
    "dcode": "D",
    "dropkey": "PZ21282",
    "droptype": "D",
    "dropname": "GLENHAVEN",
    "dropdeladd": "9530 HIGHWAY 20",
    "dropdelcty": "GLENHAVEN",
    "dropdelst": "CA",
    "dropdelzpp": 954439900,
    "dropphyadd": "9530 HIGHWAY 20",
    "dropphycty": "GLENHAVEN",
    "dropphyst": "CA",
    "dropphyzpp": 954439900,
    "dropmaladd": "9530 HIGHWAY 20",
    "dropmalcty": "GLENHAVEN",
    "dropmalst": "CA",
    "dropmalzpp": 954439900,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079983878,
    "dropfax": 7079983878
  },
  {
    "dcode": "D",
    "dropkey": "PZ21283",
    "droptype": "D",
    "dropname": "GLENN",
    "dropdeladd": "1836 STATE HIGHWAY 45",
    "dropdelcty": "GLENN",
    "dropdelst": "CA",
    "dropdelzpp": 959439998,
    "dropphyadd": "1836 STATE HIGHWAY 45",
    "dropphycty": "GLENN",
    "dropphyst": "CA",
    "dropphyzpp": 959439998,
    "dropmaladd": "1836 STATE HIGHWAY 45",
    "dropmalcty": "GLENN",
    "dropmalst": "CA",
    "dropmalzpp": 959439998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309345235,
    "dropsitcph": 5309345235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21284",
    "droptype": "D",
    "dropname": "GLENNVILLE",
    "dropdeladd": "10686 HIGHWAY 155",
    "dropdelcty": "GLENNVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932269998,
    "dropphyadd": "10686 HIGHWAY 155",
    "dropphycty": "GLENNVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932269998,
    "dropmaladd": "10686 HIGHWAY 155",
    "dropmalcty": "GLENNVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932269998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615368802,
    "dropsitcph": 6615368802,
    "dropfax": 6615368916
  },
  {
    "dcode": "D",
    "dropkey": "PZ21293",
    "droptype": "D",
    "dropname": "GOLD RUN",
    "dropdeladd": "31194 GOLD RUN RD",
    "dropdelcty": "GOLD RUN",
    "dropdelst": "CA",
    "dropdelzpp": 957179998,
    "dropphyadd": "31194 GOLD RUN RD",
    "dropphycty": "GOLD RUN",
    "dropphyst": "CA",
    "dropphyzpp": 957179998,
    "dropmaladd": "31194 GOLD RUN RD",
    "dropmalcty": "GOLD RUN",
    "dropmalst": "CA",
    "dropmalzpp": 957179998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303892686,
    "dropsitcph": 5303892686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21299",
    "droptype": "D",
    "dropname": "GONZALES",
    "dropdeladd": "346 BELDEN ST",
    "dropdelcty": "GONZALES",
    "dropdelst": "CA",
    "dropdelzpp": 939269998,
    "dropphyadd": "346 BELDEN ST",
    "dropphycty": "GONZALES",
    "dropphyst": "CA",
    "dropphyzpp": 939269998,
    "dropmaladd": "346 BELDEN ST",
    "dropmalcty": "GONZALES",
    "dropmalst": "CA",
    "dropmalzpp": 939269998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316750106,
    "dropsitcph": 8316751215,
    "dropfax": 8316751220
  },
  {
    "dcode": "D",
    "dropkey": "PZ21300",
    "droptype": "D",
    "dropname": "GOODYEARS BAR",
    "dropdeladd": "22 POST OFFICE SPUR",
    "dropdelcty": "GOODYEARS BAR",
    "dropdelst": "CA",
    "dropdelzpp": 959449998,
    "dropphyadd": "22 POST OFFICE SPUR",
    "dropphycty": "GOODYEARS BAR",
    "dropphyst": "CA",
    "dropphyzpp": 959449998,
    "dropmaladd": "22 POST OFFICE SPUR",
    "dropmalcty": "GOODYEARS BAR",
    "dropmalst": "CA",
    "dropmalzpp": 959449998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302893442,
    "dropsitcph": 5302893442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21303",
    "droptype": "D",
    "dropname": "GOSHEN",
    "dropdeladd": "6901 AVENUE 305",
    "dropdelcty": "GOSHEN",
    "dropdelst": "CA",
    "dropdelzpp": 932279997,
    "dropphyadd": "6901 AVENUE 305",
    "dropphycty": "GOSHEN",
    "dropphyst": "CA",
    "dropphyzpp": 932279997,
    "dropmaladd": "6901 AVENUE 305",
    "dropmalcty": "GOSHEN",
    "dropmalst": "CA",
    "dropmalzpp": 932279997,
    "dropsitphn": 6617757808,
    "dropsitlph": 5596511420,
    "dropsitcph": 5596511420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21317",
    "droptype": "D",
    "dropname": "GRASS VALLEY",
    "dropdeladd": "185 E MAIN ST",
    "dropdelcty": "GRASS VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959459998,
    "dropphyadd": "185 E MAIN ST",
    "dropphycty": "GRASS VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959459998,
    "dropmaladd": "185 E MAIN ST",
    "dropmalcty": "GRASS VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959459998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302735419,
    "dropsitcph": 5302733429,
    "dropfax": 9162739572
  },
  {
    "dcode": "D",
    "dropkey": "PZ21319",
    "droptype": "D",
    "dropname": "GRATON",
    "dropdeladd": "3171 ROSS RD",
    "dropdelcty": "GRATON",
    "dropdelst": "CA",
    "dropdelzpp": 954449900,
    "dropphyadd": "3171 ROSS RD",
    "dropphycty": "GRATON",
    "dropphyst": "CA",
    "dropphyzpp": 954449900,
    "dropmaladd": "3171 ROSS RD",
    "dropmalcty": "GRATON",
    "dropmalst": "CA",
    "dropmalzpp": 954449900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078237731,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21328",
    "droptype": "D",
    "dropname": "GREENFIELD",
    "dropdeladd": "846 OAK AVE",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 939279998,
    "dropphyadd": "846 OAK AVE",
    "dropphycty": "GREENFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 939279998,
    "dropmaladd": "846 OAK AVE",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 939279998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316748529,
    "dropsitcph": 8316741201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21331",
    "droptype": "D",
    "dropname": "GREENVIEW",
    "dropdeladd": "6745 MAIN ST",
    "dropdelcty": "GREENVIEW",
    "dropdelst": "CA",
    "dropdelzpp": 960379998,
    "dropphyadd": "6745 MAIN ST",
    "dropphycty": "GREENVIEW",
    "dropphyst": "CA",
    "dropphyzpp": 960379998,
    "dropmaladd": "6745 MAIN ST",
    "dropmalcty": "GREENVIEW",
    "dropmalst": "CA",
    "dropmalzpp": 960379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304685168,
    "dropsitcph": 5304685168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21332",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "405 MAIN ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959479518,
    "dropphyadd": "405 MAIN ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959479518,
    "dropmaladd": "405 MAIN ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959479518,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302847615,
    "dropsitcph": 5302847615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21333",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "3811 STATE HIGHWAY 193",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 956359998,
    "dropphyadd": "3811 STATE HIGHWAY 193",
    "dropphycty": "GREENWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 956359998,
    "dropmaladd": "3811 STATE HIGHWAY 193",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 956359998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308858730,
    "dropsitcph": 5308858730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21334",
    "droptype": "D",
    "dropname": "GRENADA",
    "dropdeladd": "515 SHASTA BLVD",
    "dropdelcty": "GRENADA",
    "dropdelst": "CA",
    "dropdelzpp": 960389998,
    "dropphyadd": "515 SHASTA BLVD",
    "dropphycty": "GRENADA",
    "dropphyst": "CA",
    "dropphyzpp": 960389998,
    "dropmaladd": "515 SHASTA BLVD",
    "dropmalcty": "GRENADA",
    "dropmalst": "CA",
    "dropmalzpp": 960389998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304362210,
    "dropsitcph": 5304362210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21335",
    "droptype": "D",
    "dropname": "GRIDLEY",
    "dropdeladd": "805 SYCAMORE ST",
    "dropdelcty": "GRIDLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959489998,
    "dropphyadd": "805 SYCAMORE ST",
    "dropphycty": "GRIDLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959489998,
    "dropmaladd": "805 SYCAMORE ST",
    "dropmalcty": "GRIDLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959489998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308464347,
    "dropsitcph": 5308466399,
    "dropfax": 5308464096
  },
  {
    "dcode": "D",
    "dropkey": "PZ21338",
    "droptype": "D",
    "dropname": "GRIMES",
    "dropdeladd": "170 MAIN ST",
    "dropdelcty": "GRIMES",
    "dropdelst": "CA",
    "dropdelzpp": 959509998,
    "dropphyadd": "170 MAIN ST",
    "dropphycty": "GRIMES",
    "dropphyst": "CA",
    "dropphyzpp": 959509998,
    "dropmaladd": "170 MAIN ST",
    "dropmalcty": "GRIMES",
    "dropmalst": "CA",
    "dropmalzpp": 959509998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304372439,
    "dropsitcph": 5304372439,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21340",
    "droptype": "D",
    "dropname": "GRIZZLY FLATS",
    "dropdeladd": "4991 SCIARONI RD",
    "dropdelcty": "GRIZZLY FLATS",
    "dropdelst": "CA",
    "dropdelzpp": 956369998,
    "dropphyadd": "4991 SCIARONI RD",
    "dropphycty": "GRIZZLY FLATS",
    "dropphyst": "CA",
    "dropphyzpp": 956369998,
    "dropmaladd": "4991 SCIARONI RD",
    "dropmalcty": "GRIZZLY FLATS",
    "dropmalst": "CA",
    "dropmalzpp": 956369998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306226239,
    "dropsitcph": 5306226239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21342",
    "droptype": "D",
    "dropname": "GROVELAND",
    "dropdeladd": "18737 BACK ST",
    "dropdelcty": "GROVELAND",
    "dropdelst": "CA",
    "dropdelzpp": 953219998,
    "dropphyadd": "18737 BACK ST",
    "dropphycty": "GROVELAND",
    "dropphyst": "CA",
    "dropphyzpp": 953219998,
    "dropmaladd": "18737 BACK ST",
    "dropmalcty": "GROVELAND",
    "dropmalst": "CA",
    "dropmalzpp": 953219998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099627102,
    "dropsitcph": 2099627102,
    "dropfax": 2099621950
  },
  {
    "dcode": "D",
    "dropkey": "PZ21345",
    "droptype": "D",
    "dropname": "GROVER BEACH",
    "dropdeladd": "917 W GRAND AVE",
    "dropdelcty": "GROVER BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 934339998,
    "dropphyadd": "917 W GRAND AVE",
    "dropphycty": "GROVER BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 934339998,
    "dropmaladd": "917 W GRAND AVE",
    "dropmalcty": "GROVER BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 934339998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054811550,
    "dropsitcph": 8054895138,
    "dropfax": 8054897895
  },
  {
    "dcode": "D",
    "dropkey": "PZ21347",
    "droptype": "D",
    "dropname": "GUADALUPE",
    "dropdeladd": "1030 GUADALUPE ST",
    "dropdelcty": "GUADALUPE",
    "dropdelst": "CA",
    "dropdelzpp": 934349998,
    "dropphyadd": "1030 GUADALUPE ST",
    "dropphycty": "GUADALUPE",
    "dropphyst": "CA",
    "dropphyzpp": 934349998,
    "dropmaladd": "1030 GUADALUPE ST",
    "dropmalcty": "GUADALUPE",
    "dropmalst": "CA",
    "dropmalzpp": 934349998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8053434061,
    "dropsitcph": 8053434061,
    "dropfax": 8053434012
  },
  {
    "dcode": "D",
    "dropkey": "PZ21348",
    "droptype": "D",
    "dropname": "GUALALA",
    "dropdeladd": "39361 S HIGHWAY 1",
    "dropdelcty": "GUALALA",
    "dropdelst": "CA",
    "dropdelzpp": 954459997,
    "dropphyadd": "39361 S HIGHWAY 1",
    "dropphycty": "GUALALA",
    "dropphyst": "CA",
    "dropphyzpp": 954459997,
    "dropmaladd": "39361 S HIGHWAY 1",
    "dropmalcty": "GUALALA",
    "dropmalst": "CA",
    "dropmalzpp": 954459997,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078843759,
    "dropfax": 7078849556
  },
  {
    "dcode": "D",
    "dropkey": "PZ21349",
    "droptype": "D",
    "dropname": "GUASTI",
    "dropdeladd": "323 N TURNER AVE",
    "dropdelcty": "GUASTI",
    "dropdelst": "CA",
    "dropdelzpp": 917439001,
    "dropphyadd": "323 N TURNER AVE",
    "dropphycty": "GUASTI",
    "dropphyst": "CA",
    "dropphyzpp": 917439001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GUASTI",
    "dropmalst": "CA",
    "dropmalzpp": 917439998,
    "dropsitphn": 9099376749,
    "dropsitlph": 9096055969,
    "dropsitcph": 9099376749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21351",
    "droptype": "D",
    "dropname": "GUERNEVILLE",
    "dropdeladd": "14060 MILL ST",
    "dropdelcty": "GUERNEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954469815,
    "dropphyadd": "14060 MILL ST",
    "dropphycty": "GUERNEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954469815,
    "dropmaladd": "14060 MILL ST",
    "dropmalcty": "GUERNEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954469815,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078692167,
    "dropfax": 7078699296
  },
  {
    "dcode": "D",
    "dropkey": "PZ21357",
    "droptype": "D",
    "dropname": "GUINDA",
    "dropdeladd": "7575 STATE HIGHWAY 16",
    "dropdelcty": "GUINDA",
    "dropdelst": "CA",
    "dropdelzpp": 956379998,
    "dropphyadd": "7575 STATE HIGHWAY 16",
    "dropphycty": "GUINDA",
    "dropphyst": "CA",
    "dropphyzpp": 956379998,
    "dropmaladd": "7575 STATE HIGHWAY 16",
    "dropmalcty": "GUINDA",
    "dropmalst": "CA",
    "dropmalzpp": 956379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307963851,
    "dropsitcph": 5307963851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21358",
    "droptype": "D",
    "dropname": "GUSTINE",
    "dropdeladd": "316 5TH ST",
    "dropdelcty": "GUSTINE",
    "dropdelst": "CA",
    "dropdelzpp": 953229998,
    "dropphyadd": "316 5TH ST",
    "dropphycty": "GUSTINE",
    "dropphyst": "CA",
    "dropphyzpp": 953229998,
    "dropmaladd": "316 5TH ST",
    "dropmalcty": "GUSTINE",
    "dropmalst": "CA",
    "dropmalzpp": 953229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098546704,
    "dropsitcph": 2098546704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21367",
    "droptype": "D",
    "dropname": "HALF MOON BAY",
    "dropdeladd": "500 STONE PINE RD",
    "dropdelcty": "HALF MOON BAY",
    "dropdelst": "CA",
    "dropdelzpp": 940191753,
    "dropphyadd": "500 STONE PINE RD",
    "dropphycty": "HALF MOON BAY",
    "dropphyst": "CA",
    "dropphyzpp": 940191753,
    "dropmaladd": "500 STONE PINE RD",
    "dropmalcty": "HALF MOON BAY",
    "dropmalst": "CA",
    "dropmalzpp": 940191753,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507269181,
    "dropsitcph": 6507264015,
    "dropfax": 6507263020
  },
  {
    "dcode": "D",
    "dropkey": "PZ21373",
    "droptype": "D",
    "dropname": "HAMILTON CITY",
    "dropdeladd": "201 MAIN ST",
    "dropdelcty": "HAMILTON CITY",
    "dropdelst": "CA",
    "dropdelzpp": 959519998,
    "dropphyadd": "201 MAIN ST",
    "dropphycty": "HAMILTON CITY",
    "dropphyst": "CA",
    "dropphyzpp": 959519998,
    "dropmaladd": "201 MAIN ST",
    "dropmalcty": "HAMILTON CITY",
    "dropmalst": "CA",
    "dropmalzpp": 959519998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308263200,
    "dropsitcph": 5308263200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21379",
    "droptype": "D",
    "dropname": "HANFORD",
    "dropdeladd": "517 N IRWIN ST",
    "dropdelcty": "HANFORD",
    "dropdelst": "CA",
    "dropdelzpp": 932309998,
    "dropphyadd": "517 N IRWIN ST",
    "dropphycty": "HANFORD",
    "dropphyst": "CA",
    "dropphyzpp": 932309998,
    "dropmaladd": "517 N IRWIN ST",
    "dropmalcty": "HANFORD",
    "dropmalst": "CA",
    "dropmalzpp": 932309998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595822508,
    "dropsitcph": 5595825374,
    "dropfax": 5595825698
  },
  {
    "dcode": "D",
    "dropkey": "PZ21381",
    "droptype": "D",
    "dropname": "HAPPY CAMP",
    "dropdeladd": "33 DAVIS RD",
    "dropdelcty": "HAPPY CAMP",
    "dropdelst": "CA",
    "dropdelzpp": 960399998,
    "dropphyadd": "33 DAVIS RD",
    "dropphycty": "HAPPY CAMP",
    "dropphyst": "CA",
    "dropphyzpp": 960399998,
    "dropmaladd": "33 DAVIS RD",
    "dropmalcty": "HAPPY CAMP",
    "dropmalst": "CA",
    "dropmalzpp": 960399998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304932203,
    "dropsitcph": 5304932203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21382",
    "droptype": "D",
    "dropname": "HARBOR CITY",
    "dropdeladd": "25690 FRAMPTON AVE",
    "dropdelcty": "HARBOR CITY",
    "dropdelst": "CA",
    "dropdelzpp": 907109998,
    "dropphyadd": "25690 FRAMPTON AVE",
    "dropphycty": "HARBOR CITY",
    "dropphyst": "CA",
    "dropphyzpp": 907109998,
    "dropmaladd": "25690 FRAMPTON AVE",
    "dropmalcty": "HARBOR CITY",
    "dropmalst": "CA",
    "dropmalzpp": 907109998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103262641,
    "dropsitcph": 3103266672,
    "dropfax": 3103265014
  },
  {
    "dcode": "D",
    "dropkey": "PZ21389",
    "droptype": "D",
    "dropname": "HAT CREEK",
    "dropdeladd": "18630 STATE HIGHWAY 89",
    "dropdelcty": "HAT CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 960409998,
    "dropphyadd": "18630 STATE HIGHWAY 89",
    "dropphycty": "HAT CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 960409998,
    "dropmaladd": "18630 STATE HIGHWAY 89",
    "dropmalcty": "HAT CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 960409998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303354744,
    "dropsitcph": 5303354744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21390",
    "droptype": "D",
    "dropname": "HATHAWAY PINES",
    "dropdeladd": "5234F E HIGHWAY 4",
    "dropdelcty": "HATHAWAY PINES",
    "dropdelst": "CA",
    "dropdelzpp": 952339998,
    "dropphyadd": "5234F E HIGHWAY 4",
    "dropphycty": "HATHAWAY PINES",
    "dropphyst": "CA",
    "dropphyzpp": 952339998,
    "dropmaladd": "5234F E HIGHWAY 4",
    "dropmalcty": "HATHAWAY PINES",
    "dropmalst": "CA",
    "dropmalzpp": 952339998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097951080,
    "dropsitcph": 2097951080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21395",
    "droptype": "D",
    "dropname": "HAWTHORNE",
    "dropdeladd": "12700 INGLEWOOD AVE",
    "dropdelcty": "HAWTHORNE",
    "dropdelst": "CA",
    "dropdelzpp": 902509998,
    "dropphyadd": "12700 INGLEWOOD AVE",
    "dropphycty": "HAWTHORNE",
    "dropphyst": "CA",
    "dropphyzpp": 902509998,
    "dropmaladd": "12700 INGLEWOOD AVE",
    "dropmalcty": "HAWTHORNE",
    "dropmalst": "CA",
    "dropmalzpp": 902509998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3106769827,
    "dropsitcph": 3106760399,
    "dropfax": 3106761244
  },
  {
    "dcode": "D",
    "dropkey": "PZ21396",
    "droptype": "D",
    "dropname": "HAYFORK",
    "dropdeladd": "7180 STATE HIGHWAY 3",
    "dropdelcty": "HAYFORK",
    "dropdelst": "CA",
    "dropdelzpp": 960419997,
    "dropphyadd": "7180 STATE HIGHWAY 3",
    "dropphycty": "HAYFORK",
    "dropphyst": "CA",
    "dropphyzpp": 960419997,
    "dropmaladd": "7180 STATE HIGHWAY 3",
    "dropmalcty": "HAYFORK",
    "dropmalst": "CA",
    "dropmalzpp": 960419997,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306285515,
    "dropsitcph": 5306285515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21397",
    "droptype": "D",
    "dropname": "HAYWARD",
    "dropdeladd": "24438 SANTA CLARA ST",
    "dropdelcty": "HAYWARD",
    "dropdelst": "CA",
    "dropdelzpp": 945449998,
    "dropphyadd": "24438 SANTA CLARA ST",
    "dropphycty": "HAYWARD",
    "dropphyst": "CA",
    "dropphyzpp": 945449998,
    "dropmaladd": "24438 SANTA CLARA ST",
    "dropmalcty": "HAYWARD",
    "dropmalst": "CA",
    "dropmalzpp": 945449998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107832404,
    "dropsitcph": 5107835963,
    "dropfax": 5107830460
  },
  {
    "dcode": "D",
    "dropkey": "PZ21400",
    "droptype": "D",
    "dropname": "HEALDSBURG",
    "dropdeladd": "160 FOSS CREEK CIR",
    "dropdelcty": "HEALDSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 954489998,
    "dropphyadd": "160 FOSS CREEK CIR",
    "dropphycty": "HEALDSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 954489998,
    "dropmaladd": "160 FOSS CREEK CIR",
    "dropmalcty": "HEALDSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 954489998,
    "dropsitphn": 7074339276,
    "dropsitlph": 7074339276,
    "dropsitcph": 7074339276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21402",
    "droptype": "D",
    "dropname": "HEBER",
    "dropdeladd": "71 E MAIN ST",
    "dropdelcty": "HEBER",
    "dropdelst": "CA",
    "dropdelzpp": 922499998,
    "dropphyadd": "71 E MAIN ST",
    "dropphycty": "HEBER",
    "dropphyst": "CA",
    "dropphyzpp": 922499998,
    "dropmaladd": "71 E MAIN ST",
    "dropmalcty": "HEBER",
    "dropmalst": "CA",
    "dropmalzpp": 922499998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603520683,
    "dropsitcph": 7603524603,
    "dropfax": 7603527673
  },
  {
    "dcode": "D",
    "dropkey": "PZ21404",
    "droptype": "D",
    "dropname": "HELENDALE",
    "dropdeladd": "27072 HELENDALE RD",
    "dropdelcty": "HELENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 923429998,
    "dropphyadd": "27072 HELENDALE RD",
    "dropphycty": "HELENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 923429998,
    "dropmaladd": "27072 HELENDALE RD",
    "dropmalcty": "HELENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 923429998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602454391,
    "dropsitcph": 7602434047,
    "dropfax": 7602452347
  },
  {
    "dcode": "D",
    "dropkey": "PZ21405",
    "droptype": "D",
    "dropname": "HELM",
    "dropdeladd": "13883 S LASSEN AVE",
    "dropdelcty": "HELM",
    "dropdelst": "CA",
    "dropdelzpp": 936279998,
    "dropphyadd": "13883 S LASSEN AVE",
    "dropphycty": "HELM",
    "dropphyst": "CA",
    "dropphyzpp": 936279998,
    "dropmaladd": "13883 S LASSEN AVE",
    "dropmalcty": "HELM",
    "dropmalst": "CA",
    "dropmalzpp": 936279998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598665343,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21406",
    "droptype": "D",
    "dropname": "HEMET",
    "dropdeladd": "324 S STATE ST",
    "dropdelcty": "HEMET",
    "dropdelst": "CA",
    "dropdelzpp": 925439998,
    "dropphyadd": "324 S STATE ST",
    "dropphycty": "HEMET",
    "dropphyst": "CA",
    "dropphyzpp": 925439998,
    "dropmaladd": "324 S STATE ST",
    "dropmalcty": "HEMET",
    "dropmalst": "CA",
    "dropmalzpp": 925439998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516585865,
    "dropsitcph": 9516581323,
    "dropfax": 9516526763
  },
  {
    "dcode": "D",
    "dropkey": "PZ21410",
    "droptype": "D",
    "dropname": "HERALD",
    "dropdeladd": "12650 IVIE RD",
    "dropdelcty": "HERALD",
    "dropdelst": "CA",
    "dropdelzpp": 956389998,
    "dropphyadd": "12650 IVIE RD",
    "dropphycty": "HERALD",
    "dropphyst": "CA",
    "dropphyzpp": 956389998,
    "dropmaladd": "12650 IVIE RD",
    "dropmalcty": "HERALD",
    "dropmalst": "CA",
    "dropmalzpp": 956389998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097486006,
    "dropsitcph": 2097486007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21413",
    "droptype": "D",
    "dropname": "HERLONG",
    "dropdeladd": "2067 YUBA ST",
    "dropdelcty": "HERLONG",
    "dropdelst": "CA",
    "dropdelzpp": 961139800,
    "dropphyadd": "2067 YUBA ST",
    "dropphycty": "HERLONG",
    "dropphyst": "CA",
    "dropphyzpp": 961139800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HERLONG",
    "dropmalst": "CA",
    "dropmalzpp": 961139998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308273074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21416",
    "droptype": "D",
    "dropname": "HESPERIA",
    "dropdeladd": "17240 OLIVE ST",
    "dropdelcty": "HESPERIA",
    "dropdelst": "CA",
    "dropdelzpp": 923459998,
    "dropphyadd": "17240 OLIVE ST",
    "dropphycty": "HESPERIA",
    "dropphyst": "CA",
    "dropphyzpp": 923459998,
    "dropmaladd": "17240 OLIVE ST",
    "dropmalcty": "HESPERIA",
    "dropmalst": "CA",
    "dropmalzpp": 923459998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602444057,
    "dropsitcph": 7602443897,
    "dropfax": 7609485894
  },
  {
    "dcode": "D",
    "dropkey": "PZ21419",
    "droptype": "D",
    "dropname": "HICKMAN",
    "dropdeladd": "808 HICKMAN RD",
    "dropdelcty": "HICKMAN",
    "dropdelst": "CA",
    "dropdelzpp": 953239998,
    "dropphyadd": "808 HICKMAN RD",
    "dropphycty": "HICKMAN",
    "dropphyst": "CA",
    "dropphyzpp": 953239998,
    "dropmaladd": "808 HICKMAN RD",
    "dropmalcty": "HICKMAN",
    "dropmalst": "CA",
    "dropmalzpp": 953239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098749419,
    "dropsitcph": 2098749419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21423",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "7745 BOULDER AVE",
    "dropdelcty": "HIGHLAND",
    "dropdelst": "CA",
    "dropdelzpp": 923469998,
    "dropphyadd": "7745 BOULDER AVE",
    "dropphycty": "HIGHLAND",
    "dropphyst": "CA",
    "dropphyzpp": 923469998,
    "dropmaladd": "7745 BOULDER AVE",
    "dropmalcty": "HIGHLAND",
    "dropmalst": "CA",
    "dropmalzpp": 923469998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098642634,
    "dropsitcph": 9098642163,
    "dropfax": 9098641324
  },
  {
    "dcode": "D",
    "dropkey": "PZ21436",
    "droptype": "D",
    "dropname": "HILMAR",
    "dropdeladd": "19948 1ST ST",
    "dropdelcty": "HILMAR",
    "dropdelst": "CA",
    "dropdelzpp": 953249998,
    "dropphyadd": "19948 1ST ST",
    "dropphycty": "HILMAR",
    "dropphyst": "CA",
    "dropphyzpp": 953249998,
    "dropmaladd": "19948 1ST ST",
    "dropmalcty": "HILMAR",
    "dropmalst": "CA",
    "dropmalzpp": 953249998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096323469,
    "dropsitcph": 2096323469,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21439",
    "droptype": "D",
    "dropname": "HINKLEY",
    "dropdeladd": "35997 MOUNTAIN VIEW RD STE 1",
    "dropdelcty": "HINKLEY",
    "dropdelst": "CA",
    "dropdelzpp": 923479630,
    "dropphyadd": "35997 MOUNTAIN VIEW RD STE 1",
    "dropphycty": "HINKLEY",
    "dropphyst": "CA",
    "dropphyzpp": 923479630,
    "dropmaladd": "35997 MOUNTAIN VIEW RD STE 1",
    "dropmalcty": "HINKLEY",
    "dropmalst": "CA",
    "dropmalzpp": 923479630,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602532060,
    "dropsitcph": 7602532060,
    "dropfax": 7602532060
  },
  {
    "dcode": "D",
    "dropkey": "PZ21445",
    "droptype": "D",
    "dropname": "HOLLISTER",
    "dropdeladd": "100 MAPLE ST",
    "dropdelcty": "HOLLISTER",
    "dropdelst": "CA",
    "dropdelzpp": 950239998,
    "dropphyadd": "100 MAPLE ST",
    "dropphycty": "HOLLISTER",
    "dropphyst": "CA",
    "dropphyzpp": 950239998,
    "dropmaladd": "100 MAPLE ST",
    "dropmalcty": "HOLLISTER",
    "dropmalst": "CA",
    "dropmalzpp": 950239998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316371855,
    "dropsitcph": 8316375633,
    "dropfax": 8316378576
  },
  {
    "dcode": "D",
    "dropkey": "PZ21451",
    "droptype": "D",
    "dropname": "HOLT",
    "dropdeladd": "10340 S WHISKEY SLOUGH RD",
    "dropdelcty": "HOLT",
    "dropdelst": "CA",
    "dropdelzpp": 952349998,
    "dropphyadd": "10340 S WHISKEY SLOUGH RD",
    "dropphycty": "HOLT",
    "dropphyst": "CA",
    "dropphyzpp": 952349998,
    "dropmaladd": "10340 S WHISKEY SLOUGH RD",
    "dropmalcty": "HOLT",
    "dropmalst": "CA",
    "dropmalzpp": 952349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094666535,
    "dropsitcph": 2094666535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21452",
    "droptype": "D",
    "dropname": "HOLTVILLE",
    "dropdeladd": "520 FERN AVE",
    "dropdelcty": "HOLTVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 922509998,
    "dropphyadd": "520 FERN AVE",
    "dropphycty": "HOLTVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 922509998,
    "dropmaladd": "520 FERN AVE",
    "dropmalcty": "HOLTVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 922509998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603565559,
    "dropsitcph": 7603565200,
    "dropfax": 7603562600
  },
  {
    "dcode": "D",
    "dropkey": "PZ21455",
    "droptype": "D",
    "dropname": "HOMELAND",
    "dropdeladd": "31610 US HIGHWAY 74",
    "dropdelcty": "HOMELAND",
    "dropdelst": "CA",
    "dropdelzpp": 925489998,
    "dropphyadd": "31610 US HIGHWAY 74",
    "dropphycty": "HOMELAND",
    "dropphyst": "CA",
    "dropphyzpp": 925489998,
    "dropmaladd": "31610 US HIGHWAY 74",
    "dropmalcty": "HOMELAND",
    "dropmalst": "CA",
    "dropmalzpp": 925489998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9519269056,
    "dropsitcph": 9519261536,
    "dropfax": 9519260786
  },
  {
    "dcode": "D",
    "dropkey": "PZ21458",
    "droptype": "D",
    "dropname": "HOMEWOOD",
    "dropdeladd": "5375 WESTLAKE BLVD",
    "dropdelcty": "HOMEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 961419800,
    "dropphyadd": "5375 WESTLAKE BLVD",
    "dropphycty": "HOMEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 961419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HOMEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 961419998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5305256702,
    "dropfax": 5305251204
  },
  {
    "dcode": "D",
    "dropkey": "PZ21460",
    "droptype": "D",
    "dropname": "HONEYDEW",
    "dropdeladd": "44670 MATTOLE RD",
    "dropdelcty": "HONEYDEW",
    "dropdelst": "CA",
    "dropdelzpp": 955458900,
    "dropphyadd": "44670 MATTOLE RD",
    "dropphycty": "HONEYDEW",
    "dropphyst": "CA",
    "dropphyzpp": 955458900,
    "dropmaladd": "44670 MATTOLE RD",
    "dropmalcty": "HONEYDEW",
    "dropmalst": "CA",
    "dropmalzpp": 955459998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076293501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21461",
    "droptype": "D",
    "dropname": "HOOD",
    "dropdeladd": "10741 STATE HIGHWAY 160",
    "dropdelcty": "HOOD",
    "dropdelst": "CA",
    "dropdelzpp": 956399998,
    "dropphyadd": "10741 STATE HIGHWAY 160",
    "dropphycty": "HOOD",
    "dropphyst": "CA",
    "dropphyzpp": 956399998,
    "dropmaladd": "10741 STATE HIGHWAY 160",
    "dropmalcty": "HOOD",
    "dropmalst": "CA",
    "dropmalzpp": 956399998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167751783,
    "dropsitcph": 9167751783,
    "dropfax": 9167751783
  },
  {
    "dcode": "D",
    "dropkey": "PZ21462",
    "droptype": "D",
    "dropname": "HOOPA",
    "dropdeladd": "100 STATE HIGHWAY 96 N",
    "dropdelcty": "HOOPA",
    "dropdelst": "CA",
    "dropdelzpp": 955469603,
    "dropphyadd": "100 STATE HIGHWAY 96 N",
    "dropphycty": "HOOPA",
    "dropphyst": "CA",
    "dropphyzpp": 955469603,
    "dropmaladd": "100 STATE HIGHWAY 96 N",
    "dropmalcty": "HOOPA",
    "dropmalst": "CA",
    "dropmalzpp": 955469998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 5306254481,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21465",
    "droptype": "D",
    "dropname": "HOPLAND",
    "dropdeladd": "13400 S HIGHWAY 101",
    "dropdelcty": "HOPLAND",
    "dropdelst": "CA",
    "dropdelzpp": 954499902,
    "dropphyadd": "13400 S HIGHWAY 101",
    "dropphycty": "HOPLAND",
    "dropphyst": "CA",
    "dropphyzpp": 954499902,
    "dropmaladd": "13400 S HIGHWAY 101",
    "dropmalcty": "HOPLAND",
    "dropmalst": "CA",
    "dropmalzpp": 954499902,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077441331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21466",
    "droptype": "D",
    "dropname": "HORNBROOK",
    "dropdeladd": "15431 HORNBROOK RD",
    "dropdelcty": "HORNBROOK",
    "dropdelst": "CA",
    "dropdelzpp": 960449998,
    "dropphyadd": "15431 HORNBROOK RD",
    "dropphycty": "HORNBROOK",
    "dropphyst": "CA",
    "dropphyzpp": 960449998,
    "dropmaladd": "15431 HORNBROOK RD",
    "dropmalcty": "HORNBROOK",
    "dropmalst": "CA",
    "dropmalzpp": 960449998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304753588,
    "dropsitcph": 5304753588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21467",
    "droptype": "D",
    "dropname": "HORNITOS",
    "dropdeladd": "2885 BEAR VALLEY RD",
    "dropdelcty": "HORNITOS",
    "dropdelst": "CA",
    "dropdelzpp": 953259998,
    "dropphyadd": "2885 BEAR VALLEY RD",
    "dropphycty": "HORNITOS",
    "dropphyst": "CA",
    "dropphyzpp": 953259998,
    "dropmaladd": "2885 BEAR VALLEY RD",
    "dropmalcty": "HORNITOS",
    "dropmalst": "CA",
    "dropmalzpp": 953259998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093762373,
    "dropsitcph": 2093762373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21477",
    "droptype": "D",
    "dropname": "HUGHSON",
    "dropdeladd": "6924 ELM ST",
    "dropdelcty": "HUGHSON",
    "dropdelst": "CA",
    "dropdelzpp": 953269998,
    "dropphyadd": "6924 ELM ST",
    "dropphycty": "HUGHSON",
    "dropphyst": "CA",
    "dropphyzpp": 953269998,
    "dropmaladd": "6924 ELM ST",
    "dropmalcty": "HUGHSON",
    "dropmalst": "CA",
    "dropmalzpp": 953269998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098834530,
    "dropsitcph": 2098832716,
    "dropfax": 2098834719
  },
  {
    "dcode": "D",
    "dropkey": "PZ21482",
    "droptype": "D",
    "dropname": "HUNTINGTON BEACH",
    "dropdeladd": "6771 WARNER AVE",
    "dropdelcty": "HUNTINGTON BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926479998,
    "dropphyadd": "6771 WARNER AVE",
    "dropphycty": "HUNTINGTON BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926479998,
    "dropmaladd": "6771 WARNER AVE",
    "dropmalcty": "HUNTINGTON BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926479998,
    "dropsitphn": 7148434200,
    "dropsitlph": 7148434204,
    "dropsitcph": 7148434200,
    "dropfax": 7148478467
  },
  {
    "dcode": "D",
    "dropkey": "PZ21486",
    "droptype": "D",
    "dropname": "HUNTINGTON PARK",
    "dropdeladd": "6606 SEVILLE AVE",
    "dropdelcty": "HUNTINGTON PARK",
    "dropdelst": "CA",
    "dropdelzpp": 902559998,
    "dropphyadd": "6606 SEVILLE AVE",
    "dropphycty": "HUNTINGTON PARK",
    "dropphyst": "CA",
    "dropphyzpp": 902559998,
    "dropmaladd": "6606 SEVILLE AVE",
    "dropmalcty": "HUNTINGTON PARK",
    "dropmalst": "CA",
    "dropmalzpp": 902559998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3235870562,
    "dropsitcph": 3235875942,
    "dropfax": 3235874503
  },
  {
    "dcode": "D",
    "dropkey": "PZ21488",
    "droptype": "D",
    "dropname": "HURON",
    "dropdeladd": "36100 S LASSEN AVE",
    "dropdelcty": "HURON",
    "dropdelst": "CA",
    "dropdelzpp": 932349997,
    "dropphyadd": "36100 S LASSEN AVE",
    "dropphycty": "HURON",
    "dropphyst": "CA",
    "dropphyzpp": 932349997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HURON",
    "dropmalst": "CA",
    "dropmalzpp": 932349998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599452408,
    "dropsitcph": 5599452408,
    "dropfax": 5597637098
  },
  {
    "dcode": "D",
    "dropkey": "PZ21489",
    "droptype": "D",
    "dropname": "HYAMPOM",
    "dropdeladd": "22617 HYAMPOM RD",
    "dropdelcty": "HYAMPOM",
    "dropdelst": "CA",
    "dropdelzpp": 960469998,
    "dropphyadd": "22617 HYAMPOM RD",
    "dropphycty": "HYAMPOM",
    "dropphyst": "CA",
    "dropphyzpp": 960469998,
    "dropmaladd": "22617 HYAMPOM RD",
    "dropmalcty": "HYAMPOM",
    "dropmalst": "CA",
    "dropmalzpp": 960469998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306285955,
    "dropsitcph": 5306285955,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21490",
    "droptype": "D",
    "dropname": "HYDESVILLE",
    "dropdeladd": "3390 STATE HIGHWAY 36",
    "dropdelcty": "HYDESVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 955479900,
    "dropphyadd": "3390 STATE HIGHWAY 36",
    "dropphycty": "HYDESVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 955479900,
    "dropmaladd": "3390 STATE HIGHWAY 36",
    "dropmalcty": "HYDESVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 955479900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077643772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21497",
    "droptype": "D",
    "dropname": "IDYLLWILD",
    "dropdeladd": "54391 VILLAGE CENTER DR",
    "dropdelcty": "IDYLLWILD",
    "dropdelst": "CA",
    "dropdelzpp": 925499997,
    "dropphyadd": "54391 VILLAGE CENTER DR",
    "dropphycty": "IDYLLWILD",
    "dropphyst": "CA",
    "dropphyzpp": 925499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "IDYLLWILD",
    "dropmalst": "CA",
    "dropmalzpp": 925499998,
    "dropsitphn": 9093354457,
    "dropsitlph": 9516599719,
    "dropsitcph": 9516591969,
    "dropfax": 9516595419
  },
  {
    "dcode": "D",
    "dropkey": "PZ21499",
    "droptype": "D",
    "dropname": "IGO",
    "dropdeladd": "6484 PLACER RD",
    "dropdelcty": "IGO",
    "dropdelst": "CA",
    "dropdelzpp": 960479998,
    "dropphyadd": "6484 PLACER RD",
    "dropphycty": "IGO",
    "dropphyst": "CA",
    "dropphyzpp": 960479998,
    "dropmaladd": "6484 PLACER RD",
    "dropmalcty": "IGO",
    "dropmalst": "CA",
    "dropmalzpp": 960479998,
    "dropsitphn": 5302421925,
    "dropsitlph": 5303962882,
    "dropsitcph": 5303962882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21502",
    "droptype": "D",
    "dropname": "IMPERIAL",
    "dropdeladd": "820 N IMPERIAL AVE",
    "dropdelcty": "IMPERIAL",
    "dropdelst": "CA",
    "dropdelzpp": 922519817,
    "dropphyadd": "820 N IMPERIAL AVE",
    "dropphycty": "IMPERIAL",
    "dropphyst": "CA",
    "dropphyzpp": 922519817,
    "dropmaladd": "820 N IMPERIAL AVE",
    "dropmalcty": "IMPERIAL",
    "dropmalst": "CA",
    "dropmalzpp": 922519817,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603554301,
    "dropsitcph": 7603554966,
    "dropfax": 7603557958
  },
  {
    "dcode": "D",
    "dropkey": "PZ21503",
    "droptype": "D",
    "dropname": "IMPERIAL BEACH",
    "dropdeladd": "946 DONAX AVE",
    "dropdelcty": "IMPERIAL BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 919329998,
    "dropphyadd": "946 DONAX AVE",
    "dropphycty": "IMPERIAL BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 919329998,
    "dropmaladd": "946 DONAX AVE",
    "dropmalcty": "IMPERIAL BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 919329998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194231677,
    "dropsitcph": 6194231677,
    "dropfax": 6194233784
  },
  {
    "dcode": "D",
    "dropkey": "PZ21504",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "101 S EDWARDS ST",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "CA",
    "dropdelzpp": 935269997,
    "dropphyadd": "101 S EDWARDS ST",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "CA",
    "dropphyzpp": 935269997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "CA",
    "dropmalzpp": 935269998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7608782210,
    "dropsitcph": 7608782210,
    "dropfax": 7608782703
  },
  {
    "dcode": "D",
    "dropkey": "PZ21508",
    "droptype": "D",
    "dropname": "INDIO",
    "dropdeladd": "45805 FARGO ST",
    "dropdelcty": "INDIO",
    "dropdelst": "CA",
    "dropdelzpp": 922019998,
    "dropphyadd": "45805 FARGO ST",
    "dropphycty": "INDIO",
    "dropphyst": "CA",
    "dropphyzpp": 922019998,
    "dropmaladd": "45805 FARGO ST",
    "dropmalcty": "INDIO",
    "dropmalst": "CA",
    "dropmalzpp": 922019998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603424528,
    "dropsitcph": 7603472092,
    "dropfax": 7607751562
  },
  {
    "dcode": "D",
    "dropkey": "PZ21519",
    "droptype": "D",
    "dropname": "INGLEWOOD",
    "dropdeladd": "300 E HILLCREST BLVD",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903019998,
    "dropphyadd": "300 E HILLCREST BLVD",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903019998,
    "dropmaladd": "300 E HILLCREST BLVD",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903019998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106742321,
    "dropsitcph": 3106742321,
    "dropfax": 3106747114
  },
  {
    "dcode": "D",
    "dropkey": "PZ21521",
    "droptype": "D",
    "dropname": "INVERNESS",
    "dropdeladd": "12781 SIR FRANCIS DRAKE BLVD",
    "dropdelcty": "INVERNESS",
    "dropdelst": "CA",
    "dropdelzpp": 949379716,
    "dropphyadd": "12781 SIR FRANCIS DRAKE BLVD",
    "dropphycty": "INVERNESS",
    "dropphyst": "CA",
    "dropphyzpp": 949379716,
    "dropmaladd": "12781 SIR FRANCIS DRAKE BLVD",
    "dropmalcty": "INVERNESS",
    "dropmalst": "CA",
    "dropmalzpp": 949379716,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4156691675,
    "dropfax": 4156691675
  },
  {
    "dcode": "D",
    "dropkey": "PZ21523",
    "droptype": "D",
    "dropname": "INYOKERN",
    "dropdeladd": "6504 LOCUST AVE",
    "dropdelcty": "INYOKERN",
    "dropdelst": "CA",
    "dropdelzpp": 935279997,
    "dropphyadd": "6504 LOCUST AVE",
    "dropphycty": "INYOKERN",
    "dropphyst": "CA",
    "dropphyzpp": 935279997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "INYOKERN",
    "dropmalst": "CA",
    "dropmalzpp": 935279998,
    "dropsitphn": 6617757808,
    "dropsitlph": 4424676000,
    "dropsitcph": 4424676000,
    "dropfax": 7603775759
  },
  {
    "dcode": "D",
    "dropkey": "PZ21524",
    "droptype": "D",
    "dropname": "IONE",
    "dropdeladd": "22 MAIN ST",
    "dropdelcty": "IONE",
    "dropdelst": "CA",
    "dropdelzpp": 956409998,
    "dropphyadd": "22 MAIN ST",
    "dropphycty": "IONE",
    "dropphyst": "CA",
    "dropphyzpp": 956409998,
    "dropmaladd": "22 MAIN ST",
    "dropmalcty": "IONE",
    "dropmalst": "CA",
    "dropmalzpp": 956409998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092746492,
    "dropsitcph": 2092746478,
    "dropfax": 2092740629
  },
  {
    "dcode": "D",
    "dropkey": "PZ21529",
    "droptype": "D",
    "dropname": "IRVINE",
    "dropdeladd": "15642 SAND CANYON AVE",
    "dropdelcty": "IRVINE",
    "dropdelst": "CA",
    "dropdelzpp": 926199998,
    "dropphyadd": "15642 SAND CANYON AVE",
    "dropphycty": "IRVINE",
    "dropphyst": "CA",
    "dropphyzpp": 926199998,
    "dropmaladd": "15642 SAND CANYON AVE",
    "dropmalcty": "IRVINE",
    "dropmalst": "CA",
    "dropmalzpp": 926199998,
    "dropsitphn": 9494534910,
    "dropsitlph": 9494534953,
    "dropsitcph": 9494534910,
    "dropfax": 9497279322
  },
  {
    "dcode": "D",
    "dropkey": "PZ21534",
    "droptype": "D",
    "dropname": "ISLETON",
    "dropdeladd": "103 C ST",
    "dropdelcty": "ISLETON",
    "dropdelst": "CA",
    "dropdelzpp": 956419998,
    "dropphyadd": "103 C ST",
    "dropphycty": "ISLETON",
    "dropphyst": "CA",
    "dropphyzpp": 956419998,
    "dropmaladd": "103 C ST",
    "dropmalcty": "ISLETON",
    "dropmalst": "CA",
    "dropmalzpp": 956419998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167776814,
    "dropsitcph": 9167776814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21535",
    "droptype": "D",
    "dropname": "IVANHOE",
    "dropdeladd": "32971 ROAD 159",
    "dropdelcty": "IVANHOE",
    "dropdelst": "CA",
    "dropdelzpp": 932359998,
    "dropphyadd": "32971 ROAD 159",
    "dropphycty": "IVANHOE",
    "dropphyst": "CA",
    "dropphyzpp": 932359998,
    "dropmaladd": "32971 ROAD 159",
    "dropmalcty": "IVANHOE",
    "dropmalst": "CA",
    "dropmalzpp": 932359998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597982739,
    "dropsitcph": 5597982739,
    "dropfax": 5597543447
  },
  {
    "dcode": "D",
    "dropkey": "PZ21539",
    "droptype": "D",
    "dropname": "JACKSON",
    "dropdeladd": "424 SUTTER ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "CA",
    "dropdelzpp": 956429998,
    "dropphyadd": "424 SUTTER ST",
    "dropphycty": "JACKSON",
    "dropphyst": "CA",
    "dropphyzpp": 956429998,
    "dropmaladd": "424 SUTTER ST",
    "dropmalcty": "JACKSON",
    "dropmalst": "CA",
    "dropmalzpp": 956429998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092231290,
    "dropsitcph": 2092237720,
    "dropfax": 2092234246
  },
  {
    "dcode": "D",
    "dropkey": "PZ21540",
    "droptype": "D",
    "dropname": "JACUMBA",
    "dropdeladd": "1209 N RAILROAD ST",
    "dropdelcty": "JACUMBA",
    "dropdelst": "CA",
    "dropdelzpp": 919349800,
    "dropphyadd": "1209 N RAILROAD ST",
    "dropphycty": "JACUMBA",
    "dropphyst": "CA",
    "dropphyzpp": 919349800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACUMBA",
    "dropmalst": "CA",
    "dropmalzpp": 919349998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6193677008,
    "dropsitcph": 6193677008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21542",
    "droptype": "D",
    "dropname": "JAMESTOWN",
    "dropdeladd": "18303 MAIN ST",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "CA",
    "dropdelzpp": 953279998,
    "dropphyadd": "18303 MAIN ST",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "CA",
    "dropphyzpp": 953279998,
    "dropmaladd": "18303 MAIN ST",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "CA",
    "dropmalzpp": 953279998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099845864,
    "dropsitcph": 2099845864,
    "dropfax": 2099845864
  },
  {
    "dcode": "D",
    "dropkey": "PZ21543",
    "droptype": "D",
    "dropname": "JAMUL",
    "dropdeladd": "13961 CAMPO RD",
    "dropdelcty": "JAMUL",
    "dropdelst": "CA",
    "dropdelzpp": 919359998,
    "dropphyadd": "13961 CAMPO RD",
    "dropphycty": "JAMUL",
    "dropphyst": "CA",
    "dropphyzpp": 919359998,
    "dropmaladd": "13961 CAMPO RD",
    "dropmalcty": "JAMUL",
    "dropmalst": "CA",
    "dropmalzpp": 919359998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196690424,
    "dropsitcph": 6196690864,
    "dropfax": 6196693652
  },
  {
    "dcode": "D",
    "dropkey": "PZ21544",
    "droptype": "D",
    "dropname": "JANESVILLE",
    "dropdeladd": "463-495 MAIN ST",
    "dropdelcty": "JANESVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961148554,
    "dropphyadd": "463-495 MAIN ST",
    "dropphycty": "JANESVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961148554,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JANESVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961149998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302533666,
    "dropfax": 5302533429
  },
  {
    "dcode": "D",
    "dropkey": "PZ21546",
    "droptype": "D",
    "dropname": "JENNER",
    "dropdeladd": "10439 HIGHWAY 1",
    "dropdelcty": "JENNER",
    "dropdelst": "CA",
    "dropdelzpp": 954509605,
    "dropphyadd": "10439 HIGHWAY 1",
    "dropphycty": "JENNER",
    "dropphyst": "CA",
    "dropphyzpp": 954509605,
    "dropmaladd": "10439 HIGHWAY 1",
    "dropmalcty": "JENNER",
    "dropmalst": "CA",
    "dropmalzpp": 954509605,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078652822,
    "dropfax": 7078652822
  },
  {
    "dcode": "D",
    "dropkey": "PZ21548",
    "droptype": "D",
    "dropname": "JOHANNESBURG",
    "dropdeladd": "515 BROADWAY AVE",
    "dropdelcty": "JOHANNESBURG",
    "dropdelst": "CA",
    "dropdelzpp": 935289997,
    "dropphyadd": "515 BROADWAY AVE",
    "dropphycty": "JOHANNESBURG",
    "dropphyst": "CA",
    "dropphyzpp": 935289997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOHANNESBURG",
    "dropmalst": "CA",
    "dropmalzpp": 935289998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603742216,
    "dropsitcph": 7603742216,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ21555",
    "droptype": "D",
    "dropname": "JOLON",
    "dropdeladd": "79 INFANTRY RD",
    "dropdelcty": "JOLON",
    "dropdelst": "CA",
    "dropdelzpp": 939289800,
    "dropphyadd": "79 INFANTRY RD",
    "dropphycty": "JOLON",
    "dropphyst": "CA",
    "dropphyzpp": 939289800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JOLON",
    "dropmalst": "CA",
    "dropmalzpp": 939289998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313853812,
    "dropfax": 8313854453
  },
  {
    "dcode": "D",
    "dropkey": "PZ21556",
    "droptype": "D",
    "dropname": "JOSHUA TREE",
    "dropdeladd": "61416 29 PALMS HWY",
    "dropdelcty": "JOSHUA TREE",
    "dropdelst": "CA",
    "dropdelzpp": 922521943,
    "dropphyadd": "61416 29 PALMS HWY",
    "dropphycty": "JOSHUA TREE",
    "dropphyst": "CA",
    "dropphyzpp": 922521943,
    "dropmaladd": "61416 29 PALMS HWY",
    "dropmalcty": "JOSHUA TREE",
    "dropmalst": "CA",
    "dropmalzpp": 922529998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603663553,
    "dropsitcph": 7603668192,
    "dropfax": 7603669452
  },
  {
    "dcode": "D",
    "dropkey": "PZ21557",
    "droptype": "D",
    "dropname": "JULIAN",
    "dropdeladd": "1785 HIGHWAY 78",
    "dropdelcty": "JULIAN",
    "dropdelst": "CA",
    "dropdelzpp": 920369998,
    "dropphyadd": "1785 HIGHWAY 78",
    "dropphycty": "JULIAN",
    "dropphyst": "CA",
    "dropphyzpp": 920369998,
    "dropmaladd": "1785 HIGHWAY 78",
    "dropmalcty": "JULIAN",
    "dropmalst": "CA",
    "dropmalzpp": 920369998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607650528,
    "dropsitcph": 7607653648,
    "dropfax": 7607653124
  },
  {
    "dcode": "D",
    "dropkey": "PZ21558",
    "droptype": "D",
    "dropname": "JUNCTION CITY",
    "dropdeladd": "43380A STATE HIGHWAY 299",
    "dropdelcty": "JUNCTION CITY",
    "dropdelst": "CA",
    "dropdelzpp": 960489998,
    "dropphyadd": "43380A STATE HIGHWAY 299",
    "dropphycty": "JUNCTION CITY",
    "dropphyst": "CA",
    "dropphyzpp": 960489998,
    "dropmaladd": "43380A STATE HIGHWAY 299",
    "dropmalcty": "JUNCTION CITY",
    "dropmalst": "CA",
    "dropmalzpp": 960489998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306235254,
    "dropsitcph": 5306235254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21559",
    "droptype": "D",
    "dropname": "JUNE LAKE",
    "dropdeladd": "2747 BOULDER DR",
    "dropdelcty": "JUNE LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 935299997,
    "dropphyadd": "2747 BOULDER DR",
    "dropphycty": "JUNE LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 935299997,
    "dropmaladd": "PO BOX 2000",
    "dropmalcty": "JUNE LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 935299998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7606487483,
    "dropsitcph": 7606487483,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ21571",
    "droptype": "D",
    "dropname": "KEELER",
    "dropdeladd": "148 RAILROAD AVE",
    "dropdelcty": "KEELER",
    "dropdelst": "CA",
    "dropdelzpp": 935309997,
    "dropphyadd": "148 RAILROAD AVE",
    "dropphycty": "KEELER",
    "dropphyst": "CA",
    "dropphyzpp": 935309997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEELER",
    "dropmalst": "CA",
    "dropmalzpp": 935309998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7608765635,
    "dropsitcph": 7608765635,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ21572",
    "droptype": "D",
    "dropname": "KEENE",
    "dropdeladd": "30235 WOODFORD TEHACHAPI RD",
    "dropdelcty": "KEENE",
    "dropdelst": "CA",
    "dropdelzpp": 935319997,
    "dropphyadd": "30235 WOODFORD TEHACHAPI RD",
    "dropphycty": "KEENE",
    "dropphyst": "CA",
    "dropphyzpp": 935319997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KEENE",
    "dropmalst": "CA",
    "dropmalzpp": 935319998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618223369,
    "dropsitcph": 6618223369,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ21575",
    "droptype": "D",
    "dropname": "KELSEYVILLE",
    "dropdeladd": "5500 GADDY LN",
    "dropdelcty": "KELSEYVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954517414,
    "dropphyadd": "5500 GADDY LN",
    "dropphycty": "KELSEYVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954517414,
    "dropmaladd": "5500 GADDY LN",
    "dropmalcty": "KELSEYVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954517414,
    "dropsitphn": 7077785312,
    "dropsitlph": 7072794566,
    "dropsitcph": 7072794562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21584",
    "droptype": "D",
    "dropname": "KENWOOD",
    "dropdeladd": "8930 SONOMA HWY",
    "dropdelcty": "KENWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 954528019,
    "dropphyadd": "8930 SONOMA HWY",
    "dropphycty": "KENWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 954528019,
    "dropmaladd": "8930 SONOMA HWY",
    "dropmalcty": "KENWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 954528019,
    "dropsitphn": 7078335322,
    "dropsitlph": 7078335322,
    "dropsitcph": 7078335322,
    "dropfax": 7078334962
  },
  {
    "dcode": "D",
    "dropkey": "PZ21585",
    "droptype": "D",
    "dropname": "KERMAN",
    "dropdeladd": "14920 W D ST",
    "dropdelcty": "KERMAN",
    "dropdelst": "CA",
    "dropdelzpp": 936309998,
    "dropphyadd": "14920 W D ST",
    "dropphycty": "KERMAN",
    "dropphyst": "CA",
    "dropphyzpp": 936309998,
    "dropmaladd": "14920 W D ST",
    "dropmalcty": "KERMAN",
    "dropmalst": "CA",
    "dropmalzpp": 936309998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598463588,
    "dropsitcph": 5598468857,
    "dropfax": 5598468535
  },
  {
    "dcode": "D",
    "dropkey": "PZ21586",
    "droptype": "D",
    "dropname": "KERNVILLE",
    "dropdeladd": "45 BIG BLUE RD",
    "dropdelcty": "KERNVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932389998,
    "dropphyadd": "45 BIG BLUE RD",
    "dropphycty": "KERNVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932389998,
    "dropmaladd": "45 BIG BLUE RD",
    "dropmalcty": "KERNVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932389998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603762238,
    "dropsitcph": 7603766418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21588",
    "droptype": "D",
    "dropname": "KETTLEMAN CITY",
    "dropdeladd": "1000 MILHAM AVE",
    "dropdelcty": "KETTLEMAN CITY",
    "dropdelst": "CA",
    "dropdelzpp": 932399998,
    "dropphyadd": "1000 MILHAM AVE",
    "dropphycty": "KETTLEMAN CITY",
    "dropphyst": "CA",
    "dropphyzpp": 932399998,
    "dropmaladd": "1000 MILHAM AVE",
    "dropmalcty": "KETTLEMAN CITY",
    "dropmalst": "CA",
    "dropmalzpp": 932399998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5593869323,
    "dropsitcph": 5593869323,
    "dropfax": 5593861149
  },
  {
    "dcode": "D",
    "dropkey": "PZ21589",
    "droptype": "D",
    "dropname": "KEYES",
    "dropdeladd": "5655 7TH ST",
    "dropdelcty": "KEYES",
    "dropdelst": "CA",
    "dropdelzpp": 953289998,
    "dropphyadd": "5655 7TH ST",
    "dropphycty": "KEYES",
    "dropphyst": "CA",
    "dropphyzpp": 953289998,
    "dropmaladd": "5655 7TH ST",
    "dropmalcty": "KEYES",
    "dropmalst": "CA",
    "dropmalzpp": 953289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096341205,
    "dropsitcph": 2096341205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21592",
    "droptype": "D",
    "dropname": "KING CITY",
    "dropdeladd": "123 S 3RD ST",
    "dropdelcty": "KING CITY",
    "dropdelst": "CA",
    "dropdelzpp": 939309998,
    "dropphyadd": "123 S 3RD ST",
    "dropphycty": "KING CITY",
    "dropphyst": "CA",
    "dropphyzpp": 939309998,
    "dropmaladd": "123 S 3RD ST",
    "dropmalcty": "KING CITY",
    "dropmalst": "CA",
    "dropmalzpp": 939309998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313853361,
    "dropsitcph": 8313853676,
    "dropfax": 8313857553
  },
  {
    "dcode": "D",
    "dropkey": "PZ21593",
    "droptype": "D",
    "dropname": "KINGS BEACH",
    "dropdeladd": "8669 SALMON AVE",
    "dropdelcty": "KINGS BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 961439800,
    "dropphyadd": "8669 SALMON AVE",
    "dropphycty": "KINGS BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 961439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KINGS BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 961439998,
    "dropsitphn": 5305463671,
    "dropsitlph": 7757880663,
    "dropsitcph": 5305463671,
    "dropfax": 5302137904
  },
  {
    "dcode": "D",
    "dropkey": "PZ21595",
    "droptype": "D",
    "dropname": "KINGSBURG",
    "dropdeladd": "1401 MARION ST",
    "dropdelcty": "KINGSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 936319998,
    "dropphyadd": "1401 MARION ST",
    "dropphycty": "KINGSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 936319998,
    "dropmaladd": "1401 MARION ST",
    "dropmalcty": "KINGSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 936319998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598970915,
    "dropsitcph": 5598975207,
    "dropfax": 5598970381
  },
  {
    "dcode": "D",
    "dropkey": "PZ21599",
    "droptype": "D",
    "dropname": "KLAMATH",
    "dropdeladd": "141 KLAMATH BLVD",
    "dropdelcty": "KLAMATH",
    "dropdelst": "CA",
    "dropdelzpp": 955489387,
    "dropphyadd": "141 KLAMATH BLVD",
    "dropphycty": "KLAMATH",
    "dropphyst": "CA",
    "dropphyzpp": 955489387,
    "dropmaladd": "141 KLAMATH BLVD",
    "dropmalcty": "KLAMATH",
    "dropmalst": "CA",
    "dropmalzpp": 955489998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074822381,
    "dropfax": 7074822381
  },
  {
    "dcode": "D",
    "dropkey": "PZ21601",
    "droptype": "D",
    "dropname": "KLAMATH RIVER",
    "dropdeladd": "20523 STATE HIGHWAY 96",
    "dropdelcty": "KLAMATH RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 960509998,
    "dropphyadd": "20523 STATE HIGHWAY 96",
    "dropphycty": "KLAMATH RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 960509998,
    "dropmaladd": "20523 STATE HIGHWAY 96",
    "dropmalcty": "KLAMATH RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 960509998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304652445,
    "dropsitcph": 5304652445,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21604",
    "droptype": "D",
    "dropname": "KNIGHTS LANDING",
    "dropdeladd": "42318 2ND ST",
    "dropdelcty": "KNIGHTS LANDING",
    "dropdelst": "CA",
    "dropdelzpp": 956459998,
    "dropphyadd": "42318 2ND ST",
    "dropphycty": "KNIGHTS LANDING",
    "dropphyst": "CA",
    "dropphyzpp": 956459998,
    "dropmaladd": "42318 2ND ST",
    "dropmalcty": "KNIGHTS LANDING",
    "dropmalst": "CA",
    "dropmalzpp": 956459998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304212001,
    "dropsitcph": 5304212001,
    "dropfax": 5304212011
  },
  {
    "dcode": "D",
    "dropkey": "PZ21605",
    "droptype": "D",
    "dropname": "KNIGHTSEN",
    "dropdeladd": "3019 KNIGHTSEN AVE",
    "dropdelcty": "KNIGHTSEN",
    "dropdelst": "CA",
    "dropdelzpp": 945489800,
    "dropphyadd": "3019 KNIGHTSEN AVE",
    "dropphycty": "KNIGHTSEN",
    "dropphyst": "CA",
    "dropphyzpp": 945489800,
    "dropmaladd": "3019 KNIGHTSEN AVE",
    "dropmalcty": "KNIGHTSEN",
    "dropmalst": "CA",
    "dropmalzpp": 945489997,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 9256252724,
    "dropfax": 9256252016
  },
  {
    "dcode": "D",
    "dropkey": "PZ21607",
    "droptype": "D",
    "dropname": "KORBEL",
    "dropdeladd": "1190 MAPLE CREEK RD",
    "dropdelcty": "KORBEL",
    "dropdelst": "CA",
    "dropdelzpp": 955509613,
    "dropphyadd": "1190 MAPLE CREEK RD",
    "dropphycty": "KORBEL",
    "dropphyst": "CA",
    "dropphyzpp": 955509613,
    "dropmaladd": "1190 MAPLE CREEK RD",
    "dropmalcty": "KORBEL",
    "dropmalst": "CA",
    "dropmalzpp": 955509613,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076685115,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21609",
    "droptype": "D",
    "dropname": "KYBURZ",
    "dropdeladd": "13672 HIGHWAY 50",
    "dropdelcty": "KYBURZ",
    "dropdelst": "CA",
    "dropdelzpp": 957209998,
    "dropphyadd": "13672 HIGHWAY 50",
    "dropphycty": "KYBURZ",
    "dropphyst": "CA",
    "dropphyzpp": 957209998,
    "dropmaladd": "13672 HIGHWAY 50",
    "dropmalcty": "KYBURZ",
    "dropmalst": "CA",
    "dropmalzpp": 957209998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302933269,
    "dropsitcph": 5302933269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21613",
    "droptype": "D",
    "dropname": "LA CANADA FLINTRIDGE",
    "dropdeladd": "607 FOOTHILL BLVD",
    "dropdelcty": "LA CANADA FLINTRIDGE",
    "dropdelst": "CA",
    "dropdelzpp": 910119998,
    "dropphyadd": "607 FOOTHILL BLVD",
    "dropphycty": "LA CANADA FLINTRIDGE",
    "dropphyst": "CA",
    "dropphyzpp": 910119998,
    "dropmaladd": "607 FOOTHILL BLVD",
    "dropmalcty": "LA CANADA FLINTRIDGE",
    "dropmalst": "CA",
    "dropmalzpp": 910119998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187907944,
    "dropsitcph": 8187904178,
    "dropfax": 8187909762
  },
  {
    "dcode": "D",
    "dropkey": "PZ21617",
    "droptype": "D",
    "dropname": "LA GRANGE",
    "dropdeladd": "30204 FLOTO ST",
    "dropdelcty": "LA GRANGE",
    "dropdelst": "CA",
    "dropdelzpp": 953299998,
    "dropphyadd": "30204 FLOTO ST",
    "dropphycty": "LA GRANGE",
    "dropphyst": "CA",
    "dropphyzpp": 953299998,
    "dropmaladd": "30204 FLOTO ST",
    "dropmalcty": "LA GRANGE",
    "dropmalst": "CA",
    "dropmalzpp": 953299998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098532269,
    "dropsitcph": 2098532269,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21618",
    "droptype": "D",
    "dropname": "LA HABRA",
    "dropdeladd": "1001 W IMPERIAL HWY",
    "dropdelcty": "LA HABRA",
    "dropdelst": "CA",
    "dropdelzpp": 906319998,
    "dropphyadd": "1001 W IMPERIAL HWY",
    "dropphycty": "LA HABRA",
    "dropphyst": "CA",
    "dropphyzpp": 906319998,
    "dropmaladd": "1001 W IMPERIAL HWY",
    "dropmalcty": "LA HABRA",
    "dropmalst": "CA",
    "dropmalzpp": 906319998,
    "dropsitphn": 7149920580,
    "dropsitlph": 7149925752,
    "dropsitcph": 7149920580,
    "dropfax": 7149926546
  },
  {
    "dcode": "D",
    "dropkey": "PZ21621",
    "droptype": "D",
    "dropname": "LA HONDA",
    "dropdeladd": "8865 LA HONDA RD",
    "dropdelcty": "LA HONDA",
    "dropdelst": "CA",
    "dropdelzpp": 940209727,
    "dropphyadd": "8865 LA HONDA RD",
    "dropphycty": "LA HONDA",
    "dropphyst": "CA",
    "dropphyzpp": 940209727,
    "dropmaladd": "8865 LA HONDA RD",
    "dropmalcty": "LA HONDA",
    "dropmalst": "CA",
    "dropmalzpp": 940209727,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507470515,
    "dropsitcph": 6507470515,
    "dropfax": 6507470972
  },
  {
    "dcode": "D",
    "dropkey": "PZ21622",
    "droptype": "D",
    "dropname": "LA JOLLA",
    "dropdeladd": "1140 WALL ST",
    "dropdelcty": "LA JOLLA",
    "dropdelst": "CA",
    "dropdelzpp": 920379998,
    "dropphyadd": "1140 WALL ST",
    "dropphycty": "LA JOLLA",
    "dropphyst": "CA",
    "dropphyzpp": 920379998,
    "dropmaladd": "1140 WALL ST",
    "dropmalcty": "LA JOLLA",
    "dropmalst": "CA",
    "dropmalzpp": 920379998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8584598923,
    "dropsitcph": 8586221277,
    "dropfax": 8584549421
  },
  {
    "dcode": "D",
    "dropkey": "PZ21624",
    "droptype": "D",
    "dropname": "LA MESA",
    "dropdeladd": "10174 AUSTIN DR",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 919779996,
    "dropphyadd": "10174 AUSTIN DR",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 919779996,
    "dropmaladd": "10174 AUSTIN DR",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 919779996,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196605730,
    "dropsitcph": 6196605728,
    "dropfax": 6196706085
  },
  {
    "dcode": "D",
    "dropkey": "PZ21625",
    "droptype": "D",
    "dropname": "LA MIRADA",
    "dropdeladd": "14901 ADELFA DR",
    "dropdelcty": "LA MIRADA",
    "dropdelst": "CA",
    "dropdelzpp": 906389998,
    "dropphyadd": "14901 ADELFA DR",
    "dropphycty": "LA MIRADA",
    "dropphyst": "CA",
    "dropphyzpp": 906389998,
    "dropmaladd": "14901 ADELFA DR",
    "dropmalcty": "LA MIRADA",
    "dropmalst": "CA",
    "dropmalzpp": 906389998,
    "dropsitphn": 7145211097,
    "dropsitlph": 7145212453,
    "dropsitcph": 7145211097,
    "dropfax": 7145217239
  },
  {
    "dcode": "D",
    "dropkey": "PZ21628",
    "droptype": "D",
    "dropname": "LA PUENTE",
    "dropdeladd": "15310 ELLIOT AVE",
    "dropdelcty": "LA PUENTE",
    "dropdelst": "CA",
    "dropdelzpp": 917479998,
    "dropphyadd": "15310 ELLIOT AVE",
    "dropphycty": "LA PUENTE",
    "dropphyst": "CA",
    "dropphyzpp": 917479998,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479998,
    "dropsitphn": 6263695301,
    "dropsitlph": 6263369496,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": "PZ21629",
    "droptype": "D",
    "dropname": "LA QUINTA",
    "dropdeladd": "79125 CORPORATE CENTER DR",
    "dropdelcty": "LA QUINTA",
    "dropdelst": "CA",
    "dropdelzpp": 922539998,
    "dropphyadd": "79125 CORPORATE CENTER DR",
    "dropphycty": "LA QUINTA",
    "dropphyst": "CA",
    "dropphyzpp": 922539998,
    "dropmaladd": "79125 CORPORATE CENTER DR",
    "dropmalcty": "LA QUINTA",
    "dropmalst": "CA",
    "dropmalzpp": 922539998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7607712900,
    "dropsitcph": 7607712465,
    "dropfax": 7607712921
  },
  {
    "dcode": "D",
    "dropkey": "PZ21636",
    "droptype": "D",
    "dropname": "LA VERNE",
    "dropdeladd": "3355 N WHITE AVE",
    "dropdelcty": "LA VERNE",
    "dropdelst": "CA",
    "dropdelzpp": 917509998,
    "dropphyadd": "3355 N WHITE AVE",
    "dropphycty": "LA VERNE",
    "dropphyst": "CA",
    "dropphyzpp": 917509998,
    "dropmaladd": "3355 N WHITE AVE",
    "dropmalcty": "LA VERNE",
    "dropmalst": "CA",
    "dropmalzpp": 917509998,
    "dropsitphn": 9093924681,
    "dropsitlph": 9093922350,
    "dropsitcph": 9093924681,
    "dropfax": 9093928821
  },
  {
    "dcode": "D",
    "dropkey": "PZ21640",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "3641 MT DIABLO BLVD",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "CA",
    "dropdelzpp": 945493767,
    "dropphyadd": "3641 MT DIABLO BLVD",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "CA",
    "dropphyzpp": 945493767,
    "dropmaladd": "3641 MT DIABLO BLVD",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "CA",
    "dropmalzpp": 945499998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252838229,
    "dropsitcph": 9252838229,
    "dropfax": 9252847539
  },
  {
    "dcode": "D",
    "dropkey": "PZ21643",
    "droptype": "D",
    "dropname": "LAGUNA BEACH",
    "dropdeladd": "29911 NIGUEL RD",
    "dropdelcty": "LAGUNA NIGUEL",
    "dropdelst": "CA",
    "dropdelzpp": 926079998,
    "dropphyadd": "29911 NIGUEL RD",
    "dropphycty": "LAGUNA NIGUEL",
    "dropphyst": "CA",
    "dropphyzpp": 926079998,
    "dropmaladd": "29911 NIGUEL RD",
    "dropmalcty": "LAGUNA NIGUEL",
    "dropmalst": "CA",
    "dropmalzpp": 926079998,
    "dropsitphn": 9494951902,
    "dropsitlph": 9498312423,
    "dropsitcph": 9494951902,
    "dropfax": 9494952743
  },
  {
    "dcode": "D",
    "dropkey": "PZ21649",
    "droptype": "D",
    "dropname": "LAGUNITAS",
    "dropdeladd": "7120 SIR FRANCIS DRAKE BLVD",
    "dropdelcty": "LAGUNITAS",
    "dropdelst": "CA",
    "dropdelzpp": 949388900,
    "dropphyadd": "7120 SIR FRANCIS DRAKE BLVD",
    "dropphycty": "LAGUNITAS",
    "dropphyst": "CA",
    "dropphyzpp": 949388900,
    "dropmaladd": "7120 SIR FRANCIS DRAKE BLVD",
    "dropmalcty": "LAGUNITAS",
    "dropmalst": "CA",
    "dropmalzpp": 949388900,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154889708,
    "dropfax": 4154889708
  },
  {
    "dcode": "D",
    "dropkey": "PZ21651",
    "droptype": "D",
    "dropname": "LAKE ARROWHEAD",
    "dropdeladd": "28150 HIGHWAY 189",
    "dropdelcty": "LAKE ARROWHEAD",
    "dropdelst": "CA",
    "dropdelzpp": 923529997,
    "dropphyadd": "28150 HIGHWAY 189",
    "dropphycty": "LAKE ARROWHEAD",
    "dropphyst": "CA",
    "dropphyzpp": 923529997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE ARROWHEAD",
    "dropmalst": "CA",
    "dropmalzpp": 923529998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093370573,
    "dropsitcph": 9093372673,
    "dropfax": 9093371345
  },
  {
    "dcode": "D",
    "dropkey": "PZ21652",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "35 E NORTH ST",
    "dropdelcty": "LAKE CITY",
    "dropdelst": "CA",
    "dropdelzpp": 961159995,
    "dropphyadd": "35 E NORTH ST",
    "dropphycty": "LAKE CITY",
    "dropphyst": "CA",
    "dropphyzpp": 961159995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKE CITY",
    "dropmalst": "CA",
    "dropmalzpp": 961159998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302792309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21654",
    "droptype": "D",
    "dropname": "LAKE ELSINORE",
    "dropdeladd": "500 W GRAHAM AVE",
    "dropdelcty": "LAKE ELSINORE",
    "dropdelst": "CA",
    "dropdelzpp": 925309998,
    "dropphyadd": "500 W GRAHAM AVE",
    "dropphycty": "LAKE ELSINORE",
    "dropphyst": "CA",
    "dropphyzpp": 925309998,
    "dropmaladd": "500 W GRAHAM AVE",
    "dropmalcty": "LAKE ELSINORE",
    "dropmalst": "CA",
    "dropmalzpp": 925309998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516747402,
    "dropsitcph": 9516749726,
    "dropfax": 9516745481
  },
  {
    "dcode": "D",
    "dropkey": "PZ21657",
    "droptype": "D",
    "dropname": "LAKE HUGHES",
    "dropdeladd": "16817 ELIZABETH LAKE RD",
    "dropdelcty": "LAKE HUGHES",
    "dropdelst": "CA",
    "dropdelzpp": 935329998,
    "dropphyadd": "16817 ELIZABETH LAKE RD",
    "dropphycty": "LAKE HUGHES",
    "dropphyst": "CA",
    "dropphyzpp": 935329998,
    "dropmaladd": "16817 ELIZABETH LAKE RD",
    "dropmalcty": "LAKE HUGHES",
    "dropmalst": "CA",
    "dropmalzpp": 935329998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617241831,
    "dropsitcph": 6617249281,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ21658",
    "droptype": "D",
    "dropname": "LAKE ISABELLA",
    "dropdeladd": "6441 LAKE ISABELLA BLVD",
    "dropdelcty": "MOUNTAIN MESA",
    "dropdelst": "CA",
    "dropdelzpp": 932409478,
    "dropphyadd": "6441 LAKE ISABELLA BLVD",
    "dropphycty": "MOUNTAIN MESA",
    "dropphyst": "CA",
    "dropphyzpp": 932409478,
    "dropmaladd": "6441 LAKE ISABELLA BLVD",
    "dropmalcty": "MOUNTAIN MESA",
    "dropmalst": "CA",
    "dropmalzpp": 932409478,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603792553,
    "dropsitcph": 7603798755,
    "dropfax": 7603791326
  },
  {
    "dcode": "D",
    "dropkey": "PZ21669",
    "droptype": "D",
    "dropname": "LAKEHEAD",
    "dropdeladd": "20856 ANTLERS RD",
    "dropdelcty": "LAKEHEAD",
    "dropdelst": "CA",
    "dropdelzpp": 960519998,
    "dropphyadd": "20856 ANTLERS RD",
    "dropphycty": "LAKEHEAD",
    "dropphyst": "CA",
    "dropphyzpp": 960519998,
    "dropmaladd": "20856 ANTLERS RD",
    "dropmalcty": "LAKEHEAD",
    "dropmalst": "CA",
    "dropmalzpp": 960519998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302382681,
    "dropsitcph": 5302382681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21672",
    "droptype": "D",
    "dropname": "LAKEPORT",
    "dropdeladd": "1151 11TH ST",
    "dropdelcty": "LAKEPORT",
    "dropdelst": "CA",
    "dropdelzpp": 954539917,
    "dropphyadd": "1151 11TH ST",
    "dropphycty": "LAKEPORT",
    "dropphyst": "CA",
    "dropphyzpp": 954539917,
    "dropmaladd": "1151 11TH ST",
    "dropmalcty": "LAKEPORT",
    "dropmalst": "CA",
    "dropmalzpp": 954539917,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7072635837,
    "dropfax": 7079006012
  },
  {
    "dcode": "D",
    "dropkey": "PZ21675",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "12515 WOODSIDE AVE",
    "dropdelcty": "LAKESIDE",
    "dropdelst": "CA",
    "dropdelzpp": 920409998,
    "dropphyadd": "12515 WOODSIDE AVE",
    "dropphycty": "LAKESIDE",
    "dropphyst": "CA",
    "dropphyzpp": 920409998,
    "dropmaladd": "12515 WOODSIDE AVE",
    "dropmalcty": "LAKESIDE",
    "dropmalst": "CA",
    "dropmalzpp": 920409998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194437858,
    "dropsitcph": 6194435280,
    "dropfax": 6194433946
  },
  {
    "dcode": "D",
    "dropkey": "PZ21680",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "5200 CLARK AVE",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 907149998,
    "dropphyadd": "5200 CLARK AVE",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 907149998,
    "dropmaladd": "5200 CLARK AVE",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 907149998,
    "dropsitphn": 5628662889,
    "dropsitlph": 5628662889,
    "dropsitcph": 5628663981,
    "dropfax": 5628049771
  },
  {
    "dcode": "D",
    "dropkey": "PZ21683",
    "droptype": "D",
    "dropname": "LAMONT",
    "dropdeladd": "11940 MAIN ST",
    "dropdelcty": "LAMONT",
    "dropdelst": "CA",
    "dropdelzpp": 932419998,
    "dropphyadd": "11940 MAIN ST",
    "dropphycty": "LAMONT",
    "dropphyst": "CA",
    "dropphyzpp": 932419998,
    "dropmaladd": "11940 MAIN ST",
    "dropmalcty": "LAMONT",
    "dropmalst": "CA",
    "dropmalzpp": 932419998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618451031,
    "dropsitcph": 6618451031,
    "dropfax": 6618451010
  },
  {
    "dcode": "D",
    "dropkey": "PZ21684",
    "droptype": "D",
    "dropname": "LANCASTER",
    "dropdeladd": "43824 20TH ST W",
    "dropdelcty": "LANCASTER",
    "dropdelst": "CA",
    "dropdelzpp": 935345202,
    "dropphyadd": "43824 20TH ST W",
    "dropphycty": "LANCASTER",
    "dropphyst": "CA",
    "dropphyzpp": 935345202,
    "dropmaladd": "1008 W AVENUE J2",
    "dropmalcty": "LANCASTER",
    "dropmalst": "CA",
    "dropmalzpp": 935349998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619406101,
    "dropsitcph": 6619487251,
    "dropfax": 6614833999
  },
  {
    "dcode": "D",
    "dropkey": "PZ21691",
    "droptype": "D",
    "dropname": "LARKSPUR",
    "dropdeladd": "120 WARD ST",
    "dropdelcty": "LARKSPUR",
    "dropdelst": "CA",
    "dropdelzpp": 949391325,
    "dropphyadd": "120 WARD ST",
    "dropphycty": "LARKSPUR",
    "dropphyst": "CA",
    "dropphyzpp": 949391325,
    "dropmaladd": "120 WARD ST",
    "dropmalcty": "LARKSPUR",
    "dropmalst": "CA",
    "dropmalzpp": 949391325,
    "dropsitphn": 4159244792,
    "dropsitlph": 4159244792,
    "dropsitcph": 4159245056,
    "dropfax": 4159247613
  },
  {
    "dcode": "D",
    "dropkey": "PZ21697",
    "droptype": "D",
    "dropname": "LATHROP",
    "dropdeladd": "15529 7TH ST",
    "dropdelcty": "LATHROP",
    "dropdelst": "CA",
    "dropdelzpp": 953309998,
    "dropphyadd": "15529 7TH ST",
    "dropphycty": "LATHROP",
    "dropphyst": "CA",
    "dropphyzpp": 953309998,
    "dropmaladd": "15529 7TH ST",
    "dropmalcty": "LATHROP",
    "dropmalst": "CA",
    "dropmalzpp": 953309998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098581495,
    "dropsitcph": 2098582324,
    "dropfax": 2098589575
  },
  {
    "dcode": "D",
    "dropkey": "PZ21698",
    "droptype": "D",
    "dropname": "LATON",
    "dropdeladd": "6245 DE WOODY AVE",
    "dropdelcty": "LATON",
    "dropdelst": "CA",
    "dropdelzpp": 932429998,
    "dropphyadd": "6245 DE WOODY AVE",
    "dropphycty": "LATON",
    "dropphyst": "CA",
    "dropphyzpp": 932429998,
    "dropmaladd": "6245 DE WOODY AVE",
    "dropmalcty": "LATON",
    "dropmalst": "CA",
    "dropmalzpp": 932429998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599234844,
    "dropsitcph": 5599234844,
    "dropfax": 5599637001
  },
  {
    "dcode": "D",
    "dropkey": "PZ21707",
    "droptype": "D",
    "dropname": "LAWNDALE",
    "dropdeladd": "4320 MARINE AVE",
    "dropdelcty": "LAWNDALE",
    "dropdelst": "CA",
    "dropdelzpp": 902609998,
    "dropphyadd": "4320 MARINE AVE",
    "dropphycty": "LAWNDALE",
    "dropphyst": "CA",
    "dropphyzpp": 902609998,
    "dropmaladd": "4320 MARINE AVE",
    "dropmalcty": "LAWNDALE",
    "dropmalst": "CA",
    "dropmalzpp": 902609998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106795166,
    "dropsitcph": 3106799804,
    "dropfax": 3106444798
  },
  {
    "dcode": "D",
    "dropkey": "PZ21709",
    "droptype": "D",
    "dropname": "LAYTONVILLE",
    "dropdeladd": "50 RAMSEY RD",
    "dropdelcty": "LAYTONVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954549900,
    "dropphyadd": "50 RAMSEY RD",
    "dropphycty": "LAYTONVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954549900,
    "dropmaladd": "50 RAMSEY RD",
    "dropmalcty": "LAYTONVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954549900,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079846722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21713",
    "droptype": "D",
    "dropname": "LE GRAND",
    "dropdeladd": "13201 JEFFERSON ST",
    "dropdelcty": "LE GRAND",
    "dropdelst": "CA",
    "dropdelzpp": 953339998,
    "dropphyadd": "13201 JEFFERSON ST",
    "dropphycty": "LE GRAND",
    "dropphyst": "CA",
    "dropphyzpp": 953339998,
    "dropmaladd": "13201 JEFFERSON ST",
    "dropmalcty": "LE GRAND",
    "dropmalst": "CA",
    "dropmalzpp": 953339998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093894322,
    "dropsitcph": 2093894322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21714",
    "droptype": "D",
    "dropname": "LEBEC",
    "dropdeladd": "2132 LEBEC RD",
    "dropdelcty": "LEBEC",
    "dropdelst": "CA",
    "dropdelzpp": 932439998,
    "dropphyadd": "2132 LEBEC RD",
    "dropphycty": "LEBEC",
    "dropphyst": "CA",
    "dropphyzpp": 932439998,
    "dropmaladd": "2132 LEBEC RD",
    "dropmalcty": "LEBEC",
    "dropmalst": "CA",
    "dropmalzpp": 932439998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612486712,
    "dropsitcph": 6612486712,
    "dropfax": 6612482350
  },
  {
    "dcode": "D",
    "dropkey": "PZ21715",
    "droptype": "D",
    "dropname": "LEE VINING",
    "dropdeladd": "121 LEE VINING AVE",
    "dropdelcty": "LEE VINING",
    "dropdelst": "CA",
    "dropdelzpp": 935419997,
    "dropphyadd": "121 LEE VINING AVE",
    "dropphycty": "LEE VINING",
    "dropphyst": "CA",
    "dropphyzpp": 935419997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LEE VINING",
    "dropmalst": "CA",
    "dropmalzpp": 935419998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7606476371,
    "dropsitcph": 7606476371,
    "dropfax": 7606476165
  },
  {
    "dcode": "D",
    "dropkey": "PZ21717",
    "droptype": "D",
    "dropname": "LEGGETT",
    "dropdeladd": "67674 DRIVE THRU TREE RD",
    "dropdelcty": "LEGGETT",
    "dropdelst": "CA",
    "dropdelzpp": 955859900,
    "dropphyadd": "67674 DRIVE THRU TREE RD",
    "dropphycty": "LEGGETT",
    "dropphyst": "CA",
    "dropphyzpp": 955859900,
    "dropmaladd": "67674 DRIVE THRU TREE RD",
    "dropmalcty": "LEGGETT",
    "dropmalst": "CA",
    "dropmalzpp": 955859900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079256232,
    "dropfax": 7079256232
  },
  {
    "dcode": "D",
    "dropkey": "PZ21720",
    "droptype": "D",
    "dropname": "LEMON GROVE",
    "dropdeladd": "7938 BROADWAY",
    "dropdelcty": "LEMON GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 919459998,
    "dropphyadd": "7938 BROADWAY",
    "dropphycty": "LEMON GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 919459998,
    "dropmaladd": "7938 BROADWAY",
    "dropmalcty": "LEMON GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 919459998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194662348,
    "dropsitcph": 6194661909,
    "dropfax": 6194666371
  },
  {
    "dcode": "D",
    "dropkey": "PZ21721",
    "droptype": "D",
    "dropname": "LEMON COVE",
    "dropdeladd": "24451 DOUGLAS AVE",
    "dropdelcty": "LEMON COVE",
    "dropdelst": "CA",
    "dropdelzpp": 932449998,
    "dropphyadd": "24451 DOUGLAS AVE",
    "dropphycty": "LEMON COVE",
    "dropphyst": "CA",
    "dropphyzpp": 932449998,
    "dropmaladd": "24451 DOUGLAS AVE",
    "dropmalcty": "LEMON COVE",
    "dropmalst": "CA",
    "dropmalzpp": 932449998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595972336,
    "dropsitcph": 5595972336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21722",
    "droptype": "D",
    "dropname": "LEMOORE",
    "dropdeladd": "206 C ST",
    "dropdelcty": "LEMOORE",
    "dropdelst": "CA",
    "dropdelzpp": 932459998,
    "dropphyadd": "206 C ST",
    "dropphycty": "LEMOORE",
    "dropphyst": "CA",
    "dropphyzpp": 932459998,
    "dropmaladd": "206 C ST",
    "dropmalcty": "LEMOORE",
    "dropmalst": "CA",
    "dropmalzpp": 932459998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599243017,
    "dropsitcph": 5599243017,
    "dropfax": 5599242172
  },
  {
    "dcode": "D",
    "dropkey": "PZ21732",
    "droptype": "D",
    "dropname": "LEWISTON",
    "dropdeladd": "4391A TRINITY DAM BLVD",
    "dropdelcty": "LEWISTON",
    "dropdelst": "CA",
    "dropdelzpp": 960529998,
    "dropphyadd": "4391A TRINITY DAM BLVD",
    "dropphycty": "LEWISTON",
    "dropphyst": "CA",
    "dropphyzpp": 960529998,
    "dropmaladd": "4391A TRINITY DAM BLVD",
    "dropmalcty": "LEWISTON",
    "dropmalst": "CA",
    "dropmalzpp": 960529998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307783939,
    "dropsitcph": 5307783939,
    "dropfax": 5307783194
  },
  {
    "dcode": "D",
    "dropkey": "PZ21735",
    "droptype": "D",
    "dropname": "LIKELY",
    "dropdeladd": "3136 US HIGHWAY 395",
    "dropdelcty": "LIKELY",
    "dropdelst": "CA",
    "dropdelzpp": 961169998,
    "dropphyadd": "3136 US HIGHWAY 395",
    "dropphycty": "LIKELY",
    "dropphyst": "CA",
    "dropphyzpp": 961169998,
    "dropmaladd": "3136 US HIGHWAY 395",
    "dropmalcty": "LIKELY",
    "dropmalst": "CA",
    "dropmalzpp": 961169998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302334906,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21736",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "200 GATEWAY DR",
    "dropdelcty": "LINCOLN",
    "dropdelst": "CA",
    "dropdelzpp": 956483321,
    "dropphyadd": "200 GATEWAY DR",
    "dropphycty": "LINCOLN",
    "dropphyst": "CA",
    "dropphyzpp": 956483321,
    "dropmaladd": "200 GATEWAY DR",
    "dropmalcty": "LINCOLN",
    "dropmalst": "CA",
    "dropmalzpp": 956483321,
    "dropsitphn": 9163738025,
    "dropsitlph": 9164348168,
    "dropsitcph": 9164348144,
    "dropfax": 9164348159
  },
  {
    "dcode": "D",
    "dropkey": "PZ21743",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "4916 N MILL ST",
    "dropdelcty": "LINDEN",
    "dropdelst": "CA",
    "dropdelzpp": 952369998,
    "dropphyadd": "4916 N MILL ST",
    "dropphycty": "LINDEN",
    "dropphyst": "CA",
    "dropphyzpp": 952369998,
    "dropmaladd": "4916 N MILL ST",
    "dropmalcty": "LINDEN",
    "dropmalst": "CA",
    "dropmalzpp": 952369998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098873740,
    "dropsitcph": 2098873740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21745",
    "droptype": "D",
    "dropname": "LINDSAY",
    "dropdeladd": "262 E HONOLULU ST",
    "dropdelcty": "LINDSAY",
    "dropdelst": "CA",
    "dropdelzpp": 932479998,
    "dropphyadd": "262 E HONOLULU ST",
    "dropphycty": "LINDSAY",
    "dropphyst": "CA",
    "dropphyzpp": 932479998,
    "dropmaladd": "262 E HONOLULU ST",
    "dropmalcty": "LINDSAY",
    "dropmalst": "CA",
    "dropmalzpp": 932479998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595629295,
    "dropsitcph": 5595629295,
    "dropfax": 5595629846
  },
  {
    "dcode": "D",
    "dropkey": "PZ21746",
    "droptype": "D",
    "dropname": "LITCHFIELD",
    "dropdeladd": "721-255 CENTER RD",
    "dropdelcty": "LITCHFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 961179995,
    "dropphyadd": "721-255 CENTER RD",
    "dropphycty": "LITCHFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 961179995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITCHFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 961179998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302546747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21751",
    "droptype": "D",
    "dropname": "LITTLE RIVER",
    "dropdeladd": "7748 N HIGHWAY 1",
    "dropdelcty": "LITTLE RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 954569998,
    "dropphyadd": "7748 N HIGHWAY 1",
    "dropphycty": "LITTLE RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 954569998,
    "dropmaladd": "7748 N HIGHWAY 1",
    "dropmalcty": "LITTLE RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 954569998,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079375547,
    "dropfax": 7079375547
  },
  {
    "dcode": "D",
    "dropkey": "PZ21752",
    "droptype": "D",
    "dropname": "LITTLEROCK",
    "dropdeladd": "7765 PEARBLOSSOM HWY",
    "dropdelcty": "LITTLEROCK",
    "dropdelst": "CA",
    "dropdelzpp": 935439998,
    "dropphyadd": "7765 PEARBLOSSOM HWY",
    "dropphycty": "LITTLEROCK",
    "dropphyst": "CA",
    "dropphyzpp": 935439998,
    "dropmaladd": "7765 PEARBLOSSOM HWY",
    "dropmalcty": "LITTLEROCK",
    "dropmalst": "CA",
    "dropmalzpp": 935439998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619444002,
    "dropsitcph": 6619444002,
    "dropfax": 6619440045
  },
  {
    "dcode": "D",
    "dropkey": "PZ21753",
    "droptype": "D",
    "dropname": "LIVE OAK",
    "dropdeladd": "2622 GUM ST",
    "dropdelcty": "LIVE OAK",
    "dropdelst": "CA",
    "dropdelzpp": 959539998,
    "dropphyadd": "2622 GUM ST",
    "dropphycty": "LIVE OAK",
    "dropphyst": "CA",
    "dropphyzpp": 959539998,
    "dropmaladd": "2622 GUM ST",
    "dropmalcty": "LIVE OAK",
    "dropmalst": "CA",
    "dropmalzpp": 959539998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306952837,
    "dropsitcph": 5306952837,
    "dropfax": 5306952094
  },
  {
    "dcode": "D",
    "dropkey": "PZ21754",
    "droptype": "D",
    "dropname": "LIVERMORE",
    "dropdeladd": "220 S LIVERMORE AVE",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "CA",
    "dropdelzpp": 945509998,
    "dropphyadd": "220 S LIVERMORE AVE",
    "dropphycty": "LIVERMORE",
    "dropphyst": "CA",
    "dropphyzpp": 945509998,
    "dropmaladd": "220 S LIVERMORE AVE",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "CA",
    "dropmalzpp": 945509998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254475627,
    "dropsitcph": 9254470813,
    "dropfax": 9254432805
  },
  {
    "dcode": "D",
    "dropkey": "PZ21755",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "1444 B ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "CA",
    "dropdelzpp": 953349998,
    "dropphyadd": "1444 B ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "CA",
    "dropphyzpp": 953349998,
    "dropmaladd": "1444 B ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "CA",
    "dropmalzpp": 953349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093947216,
    "dropsitcph": 2093947216,
    "dropfax": 2093944419
  },
  {
    "dcode": "D",
    "dropkey": "PZ21760",
    "droptype": "D",
    "dropname": "LLANO",
    "dropdeladd": "17234 PEARBLOSSOM HWY",
    "dropdelcty": "LLANO",
    "dropdelst": "CA",
    "dropdelzpp": 935449998,
    "dropphyadd": "17234 PEARBLOSSOM HWY",
    "dropphycty": "LLANO",
    "dropphyst": "CA",
    "dropphyzpp": 935449998,
    "dropmaladd": "17234 PEARBLOSSOM HWY",
    "dropmalcty": "LLANO",
    "dropmalst": "CA",
    "dropmalzpp": 935449998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619442418,
    "dropsitcph": 6619442418,
    "dropfax": 6619441165
  },
  {
    "dcode": "D",
    "dropkey": "PZ21764",
    "droptype": "D",
    "dropname": "LOCKEFORD",
    "dropdeladd": "13355 E HIGHWAY 88",
    "dropdelcty": "LOCKEFORD",
    "dropdelst": "CA",
    "dropdelzpp": 952379998,
    "dropphyadd": "13355 E HIGHWAY 88",
    "dropphycty": "LOCKEFORD",
    "dropphyst": "CA",
    "dropphyzpp": 952379998,
    "dropmaladd": "13355 E HIGHWAY 88",
    "dropmalcty": "LOCKEFORD",
    "dropmalst": "CA",
    "dropmalzpp": 952379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097270718,
    "dropsitcph": 2097275129,
    "dropfax": 2097270720
  },
  {
    "dcode": "D",
    "dropkey": "PZ21769",
    "droptype": "D",
    "dropname": "LOCKWOOD",
    "dropdeladd": "68025 JOLON RD",
    "dropdelcty": "LOCKWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 939329800,
    "dropphyadd": "68025 JOLON RD",
    "dropphycty": "LOCKWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 939329800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOCKWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 939329998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313850286,
    "dropfax": 8313859590
  },
  {
    "dcode": "D",
    "dropkey": "PZ21772",
    "droptype": "D",
    "dropname": "LODI",
    "dropdeladd": "120 S SCHOOL ST",
    "dropdelcty": "LODI",
    "dropdelst": "CA",
    "dropdelzpp": 952409998,
    "dropphyadd": "120 S SCHOOL ST",
    "dropphycty": "LODI",
    "dropphyst": "CA",
    "dropphyzpp": 952409998,
    "dropmaladd": "120 S SCHOOL ST",
    "dropmalcty": "LODI",
    "dropmalst": "CA",
    "dropmalzpp": 952409998,
    "dropsitphn": 2093692351,
    "dropsitlph": 2093693580,
    "dropsitcph": 2093692351,
    "dropfax": 2093673637
  },
  {
    "dcode": "D",
    "dropkey": "PZ21774",
    "droptype": "D",
    "dropname": "LOLETA",
    "dropdeladd": "338 MAIN ST",
    "dropdelcty": "LOLETA",
    "dropdelst": "CA",
    "dropdelzpp": 955519685,
    "dropphyadd": "338 MAIN ST",
    "dropphycty": "LOLETA",
    "dropphyst": "CA",
    "dropphyzpp": 955519685,
    "dropmaladd": "338 MAIN ST",
    "dropmalcty": "LOLETA",
    "dropmalst": "CA",
    "dropmalzpp": 955519685,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077335442,
    "dropfax": 7077335442
  },
  {
    "dcode": "D",
    "dropkey": "PZ21776",
    "droptype": "D",
    "dropname": "LOMA LINDA",
    "dropdeladd": "25925 BARTON RD",
    "dropdelcty": "LOMA LINDA",
    "dropdelst": "CA",
    "dropdelzpp": 923549996,
    "dropphyadd": "25925 BARTON RD",
    "dropphycty": "LOMA LINDA",
    "dropphyst": "CA",
    "dropphyzpp": 923549996,
    "dropmaladd": "25925 BARTON RD",
    "dropmalcty": "LOMA LINDA",
    "dropmalst": "CA",
    "dropmalzpp": 923549996,
    "dropsitphn": 9093354694,
    "dropsitlph": 9094780448,
    "dropsitcph": 9094780448,
    "dropfax": 9097960179
  },
  {
    "dcode": "D",
    "dropkey": "PZ21778",
    "droptype": "D",
    "dropname": "LOMA MAR",
    "dropdeladd": "8150 PESCADERO CREEK RD",
    "dropdelcty": "LOMA MAR",
    "dropdelst": "CA",
    "dropdelzpp": 940219720,
    "dropphyadd": "8150 PESCADERO CREEK RD",
    "dropphycty": "LOMA MAR",
    "dropphyst": "CA",
    "dropphyzpp": 940219720,
    "dropmaladd": "8150 PESCADERO CREEK RD",
    "dropmalcty": "LOMA MAR",
    "dropmalst": "CA",
    "dropmalzpp": 940219720,
    "dropsitphn": 4155505045,
    "dropsitlph": 6508790373,
    "dropsitcph": 6508790373,
    "dropfax": 6508790725
  },
  {
    "dcode": "D",
    "dropkey": "PZ21781",
    "droptype": "D",
    "dropname": "LOMITA",
    "dropdeladd": "25131 NARBONNE AVE",
    "dropdelcty": "LOMITA",
    "dropdelst": "CA",
    "dropdelzpp": 907179998,
    "dropphyadd": "25131 NARBONNE AVE",
    "dropphycty": "LOMITA",
    "dropphyst": "CA",
    "dropphyzpp": 907179998,
    "dropmaladd": "25131 NARBONNE AVE",
    "dropmalcty": "LOMITA",
    "dropmalst": "CA",
    "dropmalzpp": 907179998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103268493,
    "dropsitcph": 3103268280,
    "dropfax": 3103261051
  },
  {
    "dcode": "D",
    "dropkey": "PZ21783",
    "droptype": "D",
    "dropname": "LOMPOC",
    "dropdeladd": "801 W OCEAN AVE",
    "dropdelcty": "LOMPOC",
    "dropdelst": "CA",
    "dropdelzpp": 934366526,
    "dropphyadd": "801 W OCEAN AVE",
    "dropphycty": "LOMPOC",
    "dropphyst": "CA",
    "dropphyzpp": 934366526,
    "dropmaladd": "801 W OCEAN AVE",
    "dropmalcty": "LOMPOC",
    "dropmalst": "CA",
    "dropmalzpp": 934366526,
    "dropsitphn": 6617757808,
    "dropsitlph": 8057364164,
    "dropsitcph": 8057368744,
    "dropfax": 8057368558
  },
  {
    "dcode": "D",
    "dropkey": "PZ21785",
    "droptype": "D",
    "dropname": "LONE PINE",
    "dropdeladd": "121 E BUSH ST",
    "dropdelcty": "LONE PINE",
    "dropdelst": "CA",
    "dropdelzpp": 935459997,
    "dropphyadd": "121 E BUSH ST",
    "dropphycty": "LONE PINE",
    "dropphyst": "CA",
    "dropphyzpp": 935459997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LONE PINE",
    "dropmalst": "CA",
    "dropmalzpp": 935459998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7608765681,
    "dropsitcph": 7608765681,
    "dropfax": 7608765494
  },
  {
    "dcode": "D",
    "dropkey": "PZ21787",
    "droptype": "D",
    "dropname": "LONG BARN",
    "dropdeladd": "25955 LONG BARN DR",
    "dropdelcty": "LONG BARN",
    "dropdelst": "CA",
    "dropdelzpp": 953359998,
    "dropphyadd": "25955 LONG BARN DR",
    "dropphycty": "LONG BARN",
    "dropphyst": "CA",
    "dropphyzpp": 953359998,
    "dropmaladd": "25955 LONG BARN DR",
    "dropmalcty": "LONG BARN",
    "dropmalst": "CA",
    "dropmalzpp": 953359998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095865283,
    "dropsitcph": 2095865283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21790",
    "droptype": "D",
    "dropname": "LONG BEACH",
    "dropdeladd": "300 LONG BEACH BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908029998,
    "dropphyadd": "300 LONG BEACH BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908029998,
    "dropmaladd": "300 LONG BEACH BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908029998,
    "dropsitphn": 5624369402,
    "dropsitlph": 5624369402,
    "dropsitcph": 5626281303,
    "dropfax": 5624914643
  },
  {
    "dcode": "D",
    "dropkey": "PZ21796",
    "droptype": "D",
    "dropname": "LOOKOUT",
    "dropdeladd": "409 MAIN ST",
    "dropdelcty": "LOOKOUT",
    "dropdelst": "CA",
    "dropdelzpp": 960549998,
    "dropphyadd": "409 MAIN ST",
    "dropphycty": "LOOKOUT",
    "dropphyst": "CA",
    "dropphyzpp": 960549998,
    "dropmaladd": "409 MAIN ST",
    "dropmalcty": "LOOKOUT",
    "dropmalst": "CA",
    "dropmalzpp": 960549998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302945735,
    "dropsitcph": 5302945735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21797",
    "droptype": "D",
    "dropname": "LOOMIS",
    "dropdeladd": "3669 TAYLOR RD",
    "dropdelcty": "LOOMIS",
    "dropdelst": "CA",
    "dropdelzpp": 956509998,
    "dropphyadd": "3669 TAYLOR RD",
    "dropphycty": "LOOMIS",
    "dropphyst": "CA",
    "dropphyzpp": 956509998,
    "dropmaladd": "3669 TAYLOR RD",
    "dropmalcty": "LOOMIS",
    "dropmalst": "CA",
    "dropmalzpp": 956509998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166528228,
    "dropsitcph": 9166523591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21800",
    "droptype": "D",
    "dropname": "LOS ALAMITOS",
    "dropdeladd": "10650 REAGAN ST",
    "dropdelcty": "LOS ALAMITOS",
    "dropdelst": "CA",
    "dropdelzpp": 907209998,
    "dropphyadd": "10650 REAGAN ST",
    "dropphycty": "LOS ALAMITOS",
    "dropphyst": "CA",
    "dropphyzpp": 907209998,
    "dropmaladd": "10650 REAGAN ST",
    "dropmalcty": "LOS ALAMITOS",
    "dropmalst": "CA",
    "dropmalzpp": 907209998,
    "dropsitphn": 5622845234,
    "dropsitlph": 5622845234,
    "dropsitcph": 5625940286,
    "dropfax": 5625961932
  },
  {
    "dcode": "D",
    "dropkey": "PZ21801",
    "droptype": "D",
    "dropname": "LOS ALAMOS",
    "dropdeladd": "497 BELL ST",
    "dropdelcty": "LOS ALAMOS",
    "dropdelst": "CA",
    "dropdelzpp": 934409998,
    "dropphyadd": "497 BELL ST",
    "dropphycty": "LOS ALAMOS",
    "dropphyst": "CA",
    "dropphyzpp": 934409998,
    "dropmaladd": "497 BELL ST",
    "dropmalcty": "LOS ALAMOS",
    "dropmalst": "CA",
    "dropmalzpp": 934409998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8053443602,
    "dropsitcph": 8053443602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21802",
    "droptype": "D",
    "dropname": "LOS ALTOS",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "LOS ALTOS",
    "dropdelst": "CA",
    "dropdelzpp": 940222937,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "LOS ALTOS",
    "dropphyst": "CA",
    "dropphyzpp": 940222937,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "LOS ALTOS",
    "dropmalst": "CA",
    "dropmalzpp": 940222937,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509487908,
    "dropsitcph": 6509600817,
    "dropfax": 6509484693
  },
  {
    "dcode": "D",
    "dropkey": "PZ21805",
    "droptype": "D",
    "dropname": "LOS ANGELES",
    "dropdeladd": "7001 S CENTRAL AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900529998,
    "dropphyadd": "7001 S CENTRAL AVE RM 322",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900529424,
    "dropmaladd": "7001 S CENTRAL AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900529998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3235863829,
    "dropsitcph": 3235861723,
    "dropfax": 3235861498
  },
  {
    "dcode": "D",
    "dropkey": "PZ21807",
    "droptype": "D",
    "dropname": "LOS BANOS",
    "dropdeladd": "1135 6TH ST",
    "dropdelcty": "LOS BANOS",
    "dropdelst": "CA",
    "dropdelzpp": 936359998,
    "dropphyadd": "1135 6TH ST",
    "dropphycty": "LOS BANOS",
    "dropphyst": "CA",
    "dropphyzpp": 936359998,
    "dropmaladd": "1135 6TH ST",
    "dropmalcty": "LOS BANOS",
    "dropmalst": "CA",
    "dropmalzpp": 936359998,
    "dropsitphn": 5594977615,
    "dropsitlph": 2098266948,
    "dropsitcph": 2098262591,
    "dropfax": 2098269368
  },
  {
    "dcode": "D",
    "dropkey": "PZ21810",
    "droptype": "D",
    "dropname": "LOS GATOS",
    "dropdeladd": "101 S SANTA CRUZ AVE",
    "dropdelcty": "LOS GATOS",
    "dropdelst": "CA",
    "dropdelzpp": 950309998,
    "dropphyadd": "101 S SANTA CRUZ AVE",
    "dropphycty": "LOS GATOS",
    "dropphyst": "CA",
    "dropphyzpp": 950309998,
    "dropmaladd": "101 S SANTA CRUZ AVE",
    "dropmalcty": "LOS GATOS",
    "dropmalst": "CA",
    "dropmalzpp": 950309998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4083545801,
    "dropsitcph": 4083957526,
    "dropfax": 4083950536
  },
  {
    "dcode": "D",
    "dropkey": "PZ21811",
    "droptype": "D",
    "dropname": "LOS MOLINOS",
    "dropdeladd": "7865 STATE HIGHWAY 99E",
    "dropdelcty": "LOS MOLINOS",
    "dropdelst": "CA",
    "dropdelzpp": 960559998,
    "dropphyadd": "7865 STATE HIGHWAY 99E",
    "dropphycty": "LOS MOLINOS",
    "dropphyst": "CA",
    "dropphyzpp": 960559998,
    "dropmaladd": "7865 STATE HIGHWAY 99E",
    "dropmalcty": "LOS MOLINOS",
    "dropmalst": "CA",
    "dropmalzpp": 960559998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303841933,
    "dropsitcph": 5303841933,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21813",
    "droptype": "D",
    "dropname": "LOS OLIVOS",
    "dropdeladd": "2880 GRAND AVE STE B",
    "dropdelcty": "LOS OLIVOS",
    "dropdelst": "CA",
    "dropdelzpp": 934419997,
    "dropphyadd": "2880 GRAND AVE STE B",
    "dropphycty": "LOS OLIVOS",
    "dropphyst": "CA",
    "dropphyzpp": 934419997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOS OLIVOS",
    "dropmalst": "CA",
    "dropmalzpp": 934419998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056880849,
    "dropsitcph": 8056884573,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ21817",
    "droptype": "D",
    "dropname": "LOST HILLS",
    "dropdeladd": "21155 HIGHWAY 46",
    "dropdelcty": "LOST HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 932499998,
    "dropphyadd": "21155 HIGHWAY 46",
    "dropphycty": "LOST HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 932499998,
    "dropmaladd": "21155 HIGHWAY 46",
    "dropmalcty": "LOST HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 932499998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617971202,
    "dropsitcph": 6617971202,
    "dropfax": 6617971232
  },
  {
    "dcode": "D",
    "dropkey": "PZ21819",
    "droptype": "D",
    "dropname": "LOTUS",
    "dropdeladd": "7310 STATE HIGHWAY 49",
    "dropdelcty": "LOTUS",
    "dropdelst": "CA",
    "dropdelzpp": 956519998,
    "dropphyadd": "7310 STATE HIGHWAY 49",
    "dropphycty": "LOTUS",
    "dropphyst": "CA",
    "dropphyzpp": 956519998,
    "dropmaladd": "7310 STATE HIGHWAY 49",
    "dropmalcty": "LOTUS",
    "dropmalst": "CA",
    "dropmalzpp": 956519998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306260141,
    "dropsitcph": 5306260141,
    "dropfax": 5306269539
  },
  {
    "dcode": "D",
    "dropkey": "PZ21820",
    "droptype": "D",
    "dropname": "LOWER LAKE",
    "dropdeladd": "16165 MAIN ST",
    "dropdelcty": "LOWER LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 954579906,
    "dropphyadd": "16165 MAIN ST",
    "dropphycty": "LOWER LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 954579906,
    "dropmaladd": "16165 MAIN ST",
    "dropmalcty": "LOWER LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 954579906,
    "dropsitphn": 7077785312,
    "dropsitlph": 7079946357,
    "dropsitcph": 7079946357,
    "dropfax": 7079946243
  },
  {
    "dcode": "D",
    "dropkey": "PZ21822",
    "droptype": "D",
    "dropname": "LOYALTON",
    "dropdeladd": "500 MAIN ST",
    "dropdelcty": "LOYALTON",
    "dropdelst": "CA",
    "dropdelzpp": 961189995,
    "dropphyadd": "500 MAIN ST",
    "dropphycty": "LOYALTON",
    "dropphyst": "CA",
    "dropphyzpp": 961189995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LOYALTON",
    "dropmalst": "CA",
    "dropmalzpp": 961189998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5309934471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21824",
    "droptype": "D",
    "dropname": "LUCERNE",
    "dropdeladd": "6054 E HIGHWAY 20",
    "dropdelcty": "LUCERNE",
    "dropdelst": "CA",
    "dropdelzpp": 954589904,
    "dropphyadd": "6054 E HIGHWAY 20",
    "dropphycty": "LUCERNE",
    "dropphyst": "CA",
    "dropphyzpp": 954589904,
    "dropmaladd": "6054 E HIGHWAY 20",
    "dropmalcty": "LUCERNE",
    "dropmalst": "CA",
    "dropmalzpp": 954589904,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7072741294,
    "dropfax": 7072741294
  },
  {
    "dcode": "D",
    "dropkey": "PZ21825",
    "droptype": "D",
    "dropname": "LUCERNE VALLEY",
    "dropdeladd": "10418 HIGHLAND AVE",
    "dropdelcty": "LUCERNE VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 923569998,
    "dropphyadd": "10418 HIGHLAND AVE",
    "dropphycty": "LUCERNE VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 923569998,
    "dropmaladd": "10418 HIGHLAND AVE",
    "dropmalcty": "LUCERNE VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 923569998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602487611,
    "dropsitcph": 7602482882,
    "dropfax": 7602482771
  },
  {
    "dcode": "D",
    "dropkey": "PZ21833",
    "droptype": "D",
    "dropname": "LYNWOOD",
    "dropdeladd": "11200 LONG BEACH BLVD",
    "dropdelcty": "LYNWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 902629998,
    "dropphyadd": "11200 LONG BEACH BLVD",
    "dropphycty": "LYNWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 902629998,
    "dropmaladd": "11200 LONG BEACH BLVD",
    "dropmalcty": "LYNWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 902629998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106384599,
    "dropsitcph": 3106389074,
    "dropfax": 3106389632
  },
  {
    "dcode": "D",
    "dropkey": "PZ21835",
    "droptype": "D",
    "dropname": "LYTLE CREEK",
    "dropdeladd": "375 VALLEY VISTA DR",
    "dropdelcty": "LYTLE CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 923589998,
    "dropphyadd": "375 VALLEY VISTA DR",
    "dropphycty": "LYTLE CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 923589998,
    "dropmaladd": "375 VALLEY VISTA DR",
    "dropmalcty": "LYTLE CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 923589998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098873400,
    "dropsitcph": 9098873400,
    "dropfax": 9098873400
  },
  {
    "dcode": "D",
    "dropkey": "PZ21839",
    "droptype": "D",
    "dropname": "MACDOEL",
    "dropdeladd": "41439 STATE HIGHWAY 97",
    "dropdelcty": "MACDOEL",
    "dropdelst": "CA",
    "dropdelzpp": 960589998,
    "dropphyadd": "41439 STATE HIGHWAY 97",
    "dropphycty": "MACDOEL",
    "dropphyst": "CA",
    "dropphyzpp": 960589998,
    "dropmaladd": "41439 STATE HIGHWAY 97",
    "dropmalcty": "MACDOEL",
    "dropmalst": "CA",
    "dropmalzpp": 960589998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303984383,
    "dropsitcph": 5303984383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21842",
    "droptype": "D",
    "dropname": "MAD RIVER",
    "dropdeladd": "2515B STATE HIGHWAY 36",
    "dropdelcty": "MAD RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 955529321,
    "dropphyadd": "2515B STATE HIGHWAY 36",
    "dropphycty": "MAD RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 955529321,
    "dropmaladd": "2515B STATE HIGHWAY 36",
    "dropmalcty": "MAD RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 955529321,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7075746511,
    "dropfax": 7075746511
  },
  {
    "dcode": "D",
    "dropkey": "PZ21843",
    "droptype": "D",
    "dropname": "MADELINE",
    "dropdeladd": "711-960 LASSEN ST",
    "dropdelcty": "MADELINE",
    "dropdelst": "CA",
    "dropdelzpp": 961199800,
    "dropphyadd": "711-960 LASSEN ST",
    "dropphycty": "MADELINE",
    "dropphyst": "CA",
    "dropphyzpp": 961199800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MADELINE",
    "dropmalst": "CA",
    "dropmalzpp": 961199998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302341020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21844",
    "droptype": "D",
    "dropname": "MADERA",
    "dropdeladd": "201 S D ST",
    "dropdelcty": "MADERA",
    "dropdelst": "CA",
    "dropdelzpp": 936389998,
    "dropphyadd": "201 S D ST",
    "dropphycty": "MADERA",
    "dropphyst": "CA",
    "dropphyzpp": 936389998,
    "dropmaladd": "201 S D ST",
    "dropmalcty": "MADERA",
    "dropmalst": "CA",
    "dropmalzpp": 936389998,
    "dropsitphn": 5596732732,
    "dropsitlph": 5596648578,
    "dropsitcph": 5596648578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21845",
    "droptype": "D",
    "dropname": "MADISON",
    "dropdeladd": "29053 MAIN ST",
    "dropdelcty": "MADISON",
    "dropdelst": "CA",
    "dropdelzpp": 956539998,
    "dropphyadd": "29053 MAIN ST",
    "dropphycty": "MADISON",
    "dropphyst": "CA",
    "dropphyzpp": 956539998,
    "dropmaladd": "29053 MAIN ST",
    "dropmalcty": "MADISON",
    "dropmalst": "CA",
    "dropmalzpp": 956539998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306660666,
    "dropsitcph": 5306660666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21847",
    "droptype": "D",
    "dropname": "MAGALIA",
    "dropdeladd": "14146 SKYWAY",
    "dropdelcty": "MAGALIA",
    "dropdelst": "CA",
    "dropdelzpp": 959549998,
    "dropphyadd": "14146 SKYWAY",
    "dropphycty": "MAGALIA",
    "dropphyst": "CA",
    "dropphyzpp": 959549998,
    "dropmaladd": "14146 SKYWAY",
    "dropmalcty": "MAGALIA",
    "dropmalst": "CA",
    "dropmalzpp": 959549998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308731611,
    "dropsitcph": 5308731611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21862",
    "droptype": "D",
    "dropname": "MALIBU",
    "dropdeladd": "23838 PACIFIC COAST HWY",
    "dropdelcty": "MALIBU",
    "dropdelst": "CA",
    "dropdelzpp": 902659994,
    "dropphyadd": "23838 PACIFIC COAST HWY",
    "dropphycty": "MALIBU",
    "dropphyst": "CA",
    "dropphyzpp": 902659994,
    "dropmaladd": "23838 PACIFIC COAST HWY",
    "dropmalcty": "MALIBU",
    "dropmalst": "CA",
    "dropmalzpp": 902659994,
    "dropsitphn": 5624942406,
    "dropsitlph": 3104561968,
    "dropsitcph": 3103170328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21865",
    "droptype": "D",
    "dropname": "MAMMOTH LAKES",
    "dropdeladd": "3330 MAIN ST",
    "dropdelcty": "MAMMOTH LAKES",
    "dropdelst": "CA",
    "dropdelzpp": 935469997,
    "dropphyadd": "3330 MAIN ST",
    "dropphycty": "MAMMOTH LAKES",
    "dropphyst": "CA",
    "dropphyzpp": 935469997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAMMOTH LAKES",
    "dropmalst": "CA",
    "dropmalzpp": 935469998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7609342205,
    "dropsitcph": 7609342205,
    "dropfax": 7609243453
  },
  {
    "dcode": "D",
    "dropkey": "PZ21866",
    "droptype": "D",
    "dropname": "MANCHESTER",
    "dropdeladd": "19391 US HIGHWAY 1",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "CA",
    "dropdelzpp": 954599998,
    "dropphyadd": "19391 US HIGHWAY 1",
    "dropphycty": "MANCHESTER",
    "dropphyst": "CA",
    "dropphyzpp": 954599998,
    "dropmaladd": "19391 US HIGHWAY 1",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "CA",
    "dropmalzpp": 954599998,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078822495,
    "dropfax": 7078822976
  },
  {
    "dcode": "D",
    "dropkey": "PZ21869",
    "droptype": "D",
    "dropname": "MANHATTAN BEACH",
    "dropdeladd": "1007 N SEPULVEDA BLVD",
    "dropdelcty": "MANHATTAN BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902669998,
    "dropphyadd": "1007 N SEPULVEDA BLVD",
    "dropphycty": "MANHATTAN BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902669998,
    "dropmaladd": "1007 N SEPULVEDA BLVD",
    "dropmalcty": "MANHATTAN BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902669998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3104140351,
    "dropsitcph": 3109379569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21873",
    "droptype": "D",
    "dropname": "MANTECA",
    "dropdeladd": "165 N MAPLE AVE",
    "dropdelcty": "MANTECA",
    "dropdelst": "CA",
    "dropdelzpp": 953369998,
    "dropphyadd": "165 N MAPLE AVE",
    "dropphycty": "MANTECA",
    "dropphyst": "CA",
    "dropphyzpp": 953369998,
    "dropmaladd": "165 N MAPLE AVE",
    "dropmalcty": "MANTECA",
    "dropmalst": "CA",
    "dropmalzpp": 953369998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092395320,
    "dropsitcph": 2092397027,
    "dropfax": 2098232856
  },
  {
    "dcode": "D",
    "dropkey": "PZ21874",
    "droptype": "D",
    "dropname": "MANTON",
    "dropdeladd": "31240 MANTON RD",
    "dropdelcty": "MANTON",
    "dropdelst": "CA",
    "dropdelzpp": 960599998,
    "dropphyadd": "31240 MANTON RD",
    "dropphycty": "MANTON",
    "dropphyst": "CA",
    "dropphyzpp": 960599998,
    "dropmaladd": "31240 MANTON RD",
    "dropmalcty": "MANTON",
    "dropmalst": "CA",
    "dropmalzpp": 960599998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304745410,
    "dropsitcph": 5304745410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21884",
    "droptype": "D",
    "dropname": "MARICOPA",
    "dropdeladd": "345 CALIFORNIA ST",
    "dropdelcty": "MARICOPA",
    "dropdelst": "CA",
    "dropdelzpp": 932529762,
    "dropphyadd": "345 CALIFORNIA ST",
    "dropphycty": "MARICOPA",
    "dropphyst": "CA",
    "dropphyzpp": 932529762,
    "dropmaladd": "345 CALIFORNIA ST",
    "dropmalcty": "MARICOPA",
    "dropmalst": "CA",
    "dropmalzpp": 932529998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617698415,
    "dropsitcph": 6617698415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21888",
    "droptype": "D",
    "dropname": "MARINA",
    "dropdeladd": "3100 DE FOREST RD",
    "dropdelcty": "MARINA",
    "dropdelst": "CA",
    "dropdelzpp": 939339998,
    "dropphyadd": "3100 DE FOREST RD",
    "dropphycty": "MARINA",
    "dropphyst": "CA",
    "dropphyzpp": 939339998,
    "dropmaladd": "3100 DE FOREST RD",
    "dropmalcty": "MARINA",
    "dropmalst": "CA",
    "dropmalzpp": 939339998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313844251,
    "dropsitcph": 8313848472,
    "dropfax": 8313843750
  },
  {
    "dcode": "D",
    "dropkey": "PZ21899",
    "droptype": "D",
    "dropname": "MARIPOSA",
    "dropdeladd": "5109 JESSIE ST",
    "dropdelcty": "MARIPOSA",
    "dropdelst": "CA",
    "dropdelzpp": 953389998,
    "dropphyadd": "5109 JESSIE ST",
    "dropphycty": "MARIPOSA",
    "dropphyst": "CA",
    "dropphyzpp": 953389998,
    "dropmaladd": "5109 JESSIE ST",
    "dropmalcty": "MARIPOSA",
    "dropmalst": "CA",
    "dropmalzpp": 953389998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099665798,
    "dropsitcph": 2099665798,
    "dropfax": 2099663278
  },
  {
    "dcode": "D",
    "dropkey": "PZ21904",
    "droptype": "D",
    "dropname": "MARKLEEVILLE",
    "dropdeladd": "14845 STATE ROUTE 89",
    "dropdelcty": "MARKLEEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961209995,
    "dropphyadd": "14845 STATE ROUTE 89",
    "dropphycty": "MARKLEEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961209995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MARKLEEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961209998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5306942125,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21905",
    "droptype": "D",
    "dropname": "MARSHALL",
    "dropdeladd": "19200 HIGHWAY 1",
    "dropdelcty": "MARSHALL",
    "dropdelst": "CA",
    "dropdelzpp": 949409720,
    "dropphyadd": "19200 HIGHWAY 1",
    "dropphycty": "MARSHALL",
    "dropphyst": "CA",
    "dropphyzpp": 949409720,
    "dropmaladd": "19200 HIGHWAY 1",
    "dropmalcty": "MARSHALL",
    "dropmalst": "CA",
    "dropmalzpp": 949409720,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4156638388,
    "dropfax": 4156638388
  },
  {
    "dcode": "D",
    "dropkey": "PZ21907",
    "droptype": "D",
    "dropname": "MARTINEZ",
    "dropdeladd": "4100 ALHAMBRA AVE",
    "dropdelcty": "MARTINEZ",
    "dropdelst": "CA",
    "dropdelzpp": 945539998,
    "dropphyadd": "4100 ALHAMBRA AVE",
    "dropphycty": "MARTINEZ",
    "dropphyst": "CA",
    "dropphyzpp": 945539998,
    "dropmaladd": "4100 ALHAMBRA AVE",
    "dropmalcty": "MARTINEZ",
    "dropmalst": "CA",
    "dropmalzpp": 945539998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252289875,
    "dropsitcph": 9252282722,
    "dropfax": 9252281244
  },
  {
    "dcode": "D",
    "dropkey": "PZ21909",
    "droptype": "D",
    "dropname": "MARYSVILLE",
    "dropdeladd": "407 C ST",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959015715,
    "dropphyadd": "407 C ST",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959015715,
    "dropmaladd": "407 C ST",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959015715,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306456326,
    "dropsitcph": 5307421807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21913",
    "droptype": "D",
    "dropname": "MAXWELL",
    "dropdeladd": "260 OAK ST",
    "dropdelcty": "MAXWELL",
    "dropdelst": "CA",
    "dropdelzpp": 959559998,
    "dropphyadd": "260 OAK ST",
    "dropphycty": "MAXWELL",
    "dropphyst": "CA",
    "dropphyzpp": 959559998,
    "dropmaladd": "260 OAK ST",
    "dropmalcty": "MAXWELL",
    "dropmalst": "CA",
    "dropmalzpp": 959559998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304382552,
    "dropsitcph": 5304382552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21915",
    "droptype": "D",
    "dropname": "MC FARLAND",
    "dropdeladd": "633 2ND ST",
    "dropdelcty": "MC FARLAND",
    "dropdelst": "CA",
    "dropdelzpp": 932509998,
    "dropphyadd": "633 2ND ST",
    "dropphycty": "MC FARLAND",
    "dropphyst": "CA",
    "dropphyzpp": 932509998,
    "dropmaladd": "633 2ND ST",
    "dropmalcty": "MC FARLAND",
    "dropmalst": "CA",
    "dropmalzpp": 932509998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617922335,
    "dropsitcph": 6617922335,
    "dropfax": 6617923829
  },
  {
    "dcode": "D",
    "dropkey": "PZ21917",
    "droptype": "D",
    "dropname": "MC KITTRICK",
    "dropdeladd": "23263 2ND ST",
    "dropdelcty": "MC KITTRICK",
    "dropdelst": "CA",
    "dropdelzpp": 932519998,
    "dropphyadd": "23263 2ND ST",
    "dropphycty": "MC KITTRICK",
    "dropphyst": "CA",
    "dropphyzpp": 932519998,
    "dropmaladd": "23263 2ND ST",
    "dropmalcty": "MC KITTRICK",
    "dropmalst": "CA",
    "dropmalzpp": 932519998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617627544,
    "dropsitcph": 6617627544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21920",
    "droptype": "D",
    "dropname": "MCARTHUR",
    "dropdeladd": "44160 STATE HIGHWAY 299 E STE 1",
    "dropdelcty": "MCARTHUR",
    "dropdelst": "CA",
    "dropdelzpp": 960569998,
    "dropphyadd": "44160 STATE HIGHWAY 299 E STE 1",
    "dropphycty": "MCARTHUR",
    "dropphyst": "CA",
    "dropphyzpp": 960569998,
    "dropmaladd": "44160 STATE HIGHWAY 299 E STE 1",
    "dropmalcty": "MCARTHUR",
    "dropmalst": "CA",
    "dropmalzpp": 960569998,
    "dropsitphn": 9163738025,
    "dropsitlph": 6265655808,
    "dropsitcph": 6265655808,
    "dropfax": 6265655358
  },
  {
    "dcode": "D",
    "dropkey": "PZ21923",
    "droptype": "D",
    "dropname": "MCCLOUD",
    "dropdeladd": "324 MAIN ST",
    "dropdelcty": "MCCLOUD",
    "dropdelst": "CA",
    "dropdelzpp": 960579998,
    "dropphyadd": "324 MAIN ST",
    "dropphycty": "MCCLOUD",
    "dropphyst": "CA",
    "dropphyzpp": 960579998,
    "dropmaladd": "324 MAIN ST",
    "dropmalcty": "MCCLOUD",
    "dropmalst": "CA",
    "dropmalzpp": 960579998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309642474,
    "dropsitcph": 5309642474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21927",
    "droptype": "D",
    "dropname": "MEADOW VALLEY",
    "dropdeladd": "7091 BUCKS LAKE RD",
    "dropdelcty": "MEADOW VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 959569998,
    "dropphyadd": "7091 BUCKS LAKE RD",
    "dropphycty": "MEADOW VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 959569998,
    "dropmaladd": "7091 BUCKS LAKE RD",
    "dropmalcty": "MEADOW VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 959569998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302831379,
    "dropsitcph": 5302831379,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21928",
    "droptype": "D",
    "dropname": "MEADOW VISTA",
    "dropdeladd": "16930 PLACER HILLS RD",
    "dropdelcty": "MEADOW VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 957229998,
    "dropphyadd": "16930 PLACER HILLS RD",
    "dropphycty": "MEADOW VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 957229998,
    "dropmaladd": "16930 PLACER HILLS RD",
    "dropmalcty": "MEADOW VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 957229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308787180,
    "dropsitcph": 5308787180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21931",
    "droptype": "D",
    "dropname": "MECCA",
    "dropdeladd": "91307 2ND ST",
    "dropdelcty": "MECCA",
    "dropdelst": "CA",
    "dropdelzpp": 922546515,
    "dropphyadd": "91307 2ND ST",
    "dropphycty": "MECCA",
    "dropphyst": "CA",
    "dropphyzpp": 922546515,
    "dropmaladd": "91307 2ND ST",
    "dropmalcty": "MECCA",
    "dropmalst": "CA",
    "dropmalzpp": 922549998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603961324,
    "dropsitcph": 7603963214,
    "dropfax": 7603960174
  },
  {
    "dcode": "D",
    "dropkey": "PZ21937",
    "droptype": "D",
    "dropname": "MENDOCINO",
    "dropdeladd": "10500 FORD ST",
    "dropdelcty": "MENDOCINO",
    "dropdelst": "CA",
    "dropdelzpp": 954609906,
    "dropphyadd": "10500 FORD ST",
    "dropphycty": "MENDOCINO",
    "dropphyst": "CA",
    "dropphyzpp": 954609906,
    "dropmaladd": "10500 FORD ST",
    "dropmalcty": "MENDOCINO",
    "dropmalst": "CA",
    "dropmalzpp": 954609906,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079375282,
    "dropfax": 7079371650
  },
  {
    "dcode": "D",
    "dropkey": "PZ21938",
    "droptype": "D",
    "dropname": "MENDOTA",
    "dropdeladd": "655 OLLER ST",
    "dropdelcty": "MENDOTA",
    "dropdelst": "CA",
    "dropdelzpp": 936409998,
    "dropphyadd": "655 OLLER ST",
    "dropphycty": "MENDOTA",
    "dropphyst": "CA",
    "dropphyzpp": 936409998,
    "dropmaladd": "655 OLLER ST",
    "dropmalcty": "MENDOTA",
    "dropmalst": "CA",
    "dropmalzpp": 936409998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596557128,
    "dropsitcph": 5596557121,
    "dropfax": 5596550933
  },
  {
    "dcode": "D",
    "dropkey": "PZ21942",
    "droptype": "D",
    "dropname": "MENLO PARK",
    "dropdeladd": "3875 BOHANNON DR",
    "dropdelcty": "MENLO PARK",
    "dropdelst": "CA",
    "dropdelzpp": 940251001,
    "dropphyadd": "3875 BOHANNON DR",
    "dropphycty": "MENLO PARK",
    "dropphyst": "CA",
    "dropphyzpp": 940251001,
    "dropmaladd": "3875 BOHANNON DR",
    "dropmalcty": "MENLO PARK",
    "dropmalst": "CA",
    "dropmalzpp": 940251001,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503233989,
    "dropsitcph": 6503232701,
    "dropfax": 6503234027
  },
  {
    "dcode": "D",
    "dropkey": "PZ21944",
    "droptype": "D",
    "dropname": "MENTONE",
    "dropdeladd": "1842 MENTONE BLVD",
    "dropdelcty": "MENTONE",
    "dropdelst": "CA",
    "dropdelzpp": 923591541,
    "dropphyadd": "1842 MENTONE BLVD",
    "dropphycty": "MENTONE",
    "dropphyst": "CA",
    "dropphyzpp": 923591541,
    "dropmaladd": "1842 MENTONE BLVD",
    "dropmalcty": "MENTONE",
    "dropmalst": "CA",
    "dropmalzpp": 923591541,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097943865,
    "dropsitcph": 9097940625,
    "dropfax": 9097945265
  },
  {
    "dcode": "D",
    "dropkey": "PZ21946",
    "droptype": "D",
    "dropname": "MERCED",
    "dropdeladd": "2334 M ST",
    "dropdelcty": "MERCED",
    "dropdelst": "CA",
    "dropdelzpp": 953409998,
    "dropphyadd": "2334 M ST",
    "dropphycty": "MERCED",
    "dropphyst": "CA",
    "dropphyzpp": 953409998,
    "dropmaladd": "2334 M ST",
    "dropmalcty": "MERCED",
    "dropmalst": "CA",
    "dropmalzpp": 953409998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097225474,
    "dropsitcph": 2097233741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21947",
    "droptype": "D",
    "dropname": "MERIDIAN",
    "dropdeladd": "1041 3RD ST",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "CA",
    "dropdelzpp": 959579998,
    "dropphyadd": "1041 3RD ST",
    "dropphycty": "MERIDIAN",
    "dropphyst": "CA",
    "dropphyzpp": 959579998,
    "dropmaladd": "1041 3RD ST",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "CA",
    "dropmalzpp": 959579998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306962649,
    "dropsitcph": 5306962649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21958",
    "droptype": "D",
    "dropname": "MI WUK VILLAGE",
    "dropdeladd": "24431 SIERRA PARK RD",
    "dropdelcty": "MI WUK VILLAGE",
    "dropdelst": "CA",
    "dropdelzpp": 953469998,
    "dropphyadd": "24431 SIERRA PARK RD",
    "dropphycty": "MI WUK VILLAGE",
    "dropphyst": "CA",
    "dropphyzpp": 953469998,
    "dropmaladd": "24431 SIERRA PARK RD",
    "dropmalcty": "MI WUK VILLAGE",
    "dropmalst": "CA",
    "dropmalzpp": 953469998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095864500,
    "dropsitcph": 2095864500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21961",
    "droptype": "D",
    "dropname": "MIDDLETOWN",
    "dropdeladd": "21177 CALISTOGA RD",
    "dropdelcty": "MIDDLETOWN",
    "dropdelst": "CA",
    "dropdelzpp": 954619998,
    "dropphyadd": "21177 CALISTOGA RD",
    "dropphycty": "MIDDLETOWN",
    "dropphyst": "CA",
    "dropphyzpp": 954619998,
    "dropmaladd": "21177 CALISTOGA RD",
    "dropmalcty": "MIDDLETOWN",
    "dropmalst": "CA",
    "dropmalzpp": 954619998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079873201,
    "dropfax": 7079870692
  },
  {
    "dcode": "D",
    "dropkey": "PZ21965",
    "droptype": "D",
    "dropname": "MIDPINES",
    "dropdeladd": "6629 STATE HIGHWAY 140",
    "dropdelcty": "MIDPINES",
    "dropdelst": "CA",
    "dropdelzpp": 953459998,
    "dropphyadd": "6629 STATE HIGHWAY 140",
    "dropphycty": "MIDPINES",
    "dropphyst": "CA",
    "dropphyzpp": 953459998,
    "dropmaladd": "6629 STATE HIGHWAY 140",
    "dropmalcty": "MIDPINES",
    "dropmalst": "CA",
    "dropmalzpp": 953459998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099663055,
    "dropsitcph": 2099663055,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21973",
    "droptype": "D",
    "dropname": "MILFORD",
    "dropdeladd": "450-075 MILFORD GRADE",
    "dropdelcty": "MILFORD",
    "dropdelst": "CA",
    "dropdelzpp": 961219995,
    "dropphyadd": "450-075 MILFORD GRADE",
    "dropphycty": "MILFORD",
    "dropphyst": "CA",
    "dropphyzpp": 961219995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MILFORD",
    "dropmalst": "CA",
    "dropmalzpp": 961219998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302532589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21975",
    "droptype": "D",
    "dropname": "MILL VALLEY",
    "dropdeladd": "751 E BLITHEDALE AVE",
    "dropdelcty": "MILL VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 949411515,
    "dropphyadd": "751 E BLITHEDALE AVE",
    "dropphycty": "MILL VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 949411515,
    "dropmaladd": "751 E BLITHEDALE AVE",
    "dropmalcty": "MILL VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 949411515,
    "dropsitphn": 7077785312,
    "dropsitlph": 4153880649,
    "dropsitcph": 4153880639,
    "dropfax": 4153881501
  },
  {
    "dcode": "D",
    "dropkey": "PZ21979",
    "droptype": "D",
    "dropname": "MILLBRAE",
    "dropdeladd": "501 BROADWAY",
    "dropdelcty": "MILLBRAE",
    "dropdelst": "CA",
    "dropdelzpp": 940301907,
    "dropphyadd": "501 BROADWAY",
    "dropphycty": "MILLBRAE",
    "dropphyst": "CA",
    "dropphyzpp": 940301907,
    "dropmaladd": "501 BROADWAY",
    "dropmalcty": "MILLBRAE",
    "dropmalst": "CA",
    "dropmalzpp": 940301907,
    "dropsitphn": 4155505045,
    "dropsitlph": 6506972507,
    "dropsitcph": 6506898199,
    "dropfax": 6506975875
  },
  {
    "dcode": "D",
    "dropkey": "PZ21983",
    "droptype": "D",
    "dropname": "MILLVILLE",
    "dropdeladd": "24127 OLD 44 DR",
    "dropdelcty": "MILLVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 960629998,
    "dropphyadd": "24127 OLD 44 DR",
    "dropphycty": "MILLVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 960629998,
    "dropmaladd": "24127 OLD 44 DR",
    "dropmalcty": "MILLVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 960629998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305474344,
    "dropsitcph": 5305474344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21985",
    "droptype": "D",
    "dropname": "MILPITAS",
    "dropdeladd": "450 S ABEL ST",
    "dropdelcty": "MILPITAS",
    "dropdelst": "CA",
    "dropdelzpp": 950359998,
    "dropphyadd": "450 S ABEL ST",
    "dropphycty": "MILPITAS",
    "dropphyst": "CA",
    "dropphyzpp": 950359998,
    "dropmaladd": "450 S ABEL ST",
    "dropmalcty": "MILPITAS",
    "dropmalst": "CA",
    "dropmalzpp": 950359998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082627671,
    "dropsitcph": 4082620860,
    "dropfax": 4082626429
  },
  {
    "dcode": "D",
    "dropkey": "PZ21986",
    "droptype": "D",
    "dropname": "MINERAL",
    "dropdeladd": "38450 STATE HIGHWAY 36 E",
    "dropdelcty": "MINERAL",
    "dropdelst": "CA",
    "dropdelzpp": 960639998,
    "dropphyadd": "38450 STATE HIGHWAY 36 E",
    "dropphycty": "MINERAL",
    "dropphyst": "CA",
    "dropphyzpp": 960639998,
    "dropmaladd": "38450 STATE HIGHWAY 36 E",
    "dropmalcty": "MINERAL",
    "dropmalst": "CA",
    "dropmalzpp": 960639998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305953372,
    "dropsitcph": 5305953372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ21989",
    "droptype": "D",
    "dropname": "MIRA LOMA",
    "dropdeladd": "10798 JURUPA RD",
    "dropdelcty": "JURUPA VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 917529998,
    "dropphyadd": "10798 JURUPA RD",
    "dropphycty": "JURUPA VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 917529998,
    "dropmaladd": "10798 JURUPA RD",
    "dropmalcty": "JURUPA VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 917529998,
    "dropsitphn": 9516851071,
    "dropsitlph": 9516854046,
    "dropsitcph": 9516851071,
    "dropfax": 9516859206
  },
  {
    "dcode": "D",
    "dropkey": "PZ21998",
    "droptype": "D",
    "dropname": "MIRAMONTE",
    "dropdeladd": "46039 DUNLAP RD",
    "dropdelcty": "MIRAMONTE",
    "dropdelst": "CA",
    "dropdelzpp": 936419998,
    "dropphyadd": "46039 DUNLAP RD",
    "dropphycty": "MIRAMONTE",
    "dropphyst": "CA",
    "dropphyzpp": 936419998,
    "dropmaladd": "46039 DUNLAP RD",
    "dropmalcty": "MIRAMONTE",
    "dropmalst": "CA",
    "dropmalzpp": 936419998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5593362542,
    "dropfax": 5593362352
  },
  {
    "dcode": "D",
    "dropkey": "PZ21999",
    "droptype": "D",
    "dropname": "MIRANDA",
    "dropdeladd": "6723 STATE HIGHWAY 254",
    "dropdelcty": "MIRANDA",
    "dropdelst": "CA",
    "dropdelzpp": 955538900,
    "dropphyadd": "6723 STATE HIGHWAY 254",
    "dropphycty": "MIRANDA",
    "dropphyst": "CA",
    "dropphyzpp": 955538900,
    "dropmaladd": "6723 STATE HIGHWAY 254",
    "dropmalcty": "MIRANDA",
    "dropmalst": "CA",
    "dropmalzpp": 955539998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079433571,
    "dropfax": 7079433571
  },
  {
    "dcode": "D",
    "dropkey": "PZ22014",
    "droptype": "D",
    "dropname": "MODESTO",
    "dropdeladd": "715 KEARNEY AVE",
    "dropdelcty": "MODESTO",
    "dropdelst": "CA",
    "dropdelzpp": 953509998,
    "dropphyadd": "715 KEARNEY AVE",
    "dropphycty": "MODESTO",
    "dropphyst": "CA",
    "dropphyzpp": 953509998,
    "dropmaladd": "715 KEARNEY AVE",
    "dropmalcty": "MODESTO",
    "dropmalst": "CA",
    "dropmalzpp": 953509998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095237571,
    "dropsitcph": 2095235094,
    "dropfax": 2095231984
  },
  {
    "dcode": "D",
    "dropkey": "PZ22023",
    "droptype": "D",
    "dropname": "MOJAVE",
    "dropdeladd": "2053 BELSHAW ST",
    "dropdelcty": "MOJAVE",
    "dropdelst": "CA",
    "dropdelzpp": 935019998,
    "dropphyadd": "2053 BELSHAW ST",
    "dropphycty": "MOJAVE",
    "dropphyst": "CA",
    "dropphyzpp": 935019998,
    "dropmaladd": "2053 BELSHAW ST",
    "dropmalcty": "MOJAVE",
    "dropmalst": "CA",
    "dropmalzpp": 935019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618243502,
    "dropsitcph": 6618243502,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ22024",
    "droptype": "D",
    "dropname": "MOKELUMNE HILL",
    "dropdeladd": "8331 MAIN ST",
    "dropdelcty": "MOKELUMNE HILL",
    "dropdelst": "CA",
    "dropdelzpp": 952459998,
    "dropphyadd": "8331 MAIN ST",
    "dropphycty": "MOKELUMNE HILL",
    "dropphyst": "CA",
    "dropphyzpp": 952459998,
    "dropmaladd": "8331 MAIN ST",
    "dropmalcty": "MOKELUMNE HILL",
    "dropmalst": "CA",
    "dropmalzpp": 952459998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092861628,
    "dropsitcph": 2092861628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22031",
    "droptype": "D",
    "dropname": "MONROVIA",
    "dropdeladd": "225 S IVY AVE",
    "dropdelcty": "MONROVIA",
    "dropdelst": "CA",
    "dropdelzpp": 910169998,
    "dropphyadd": "225 S IVY AVE",
    "dropphycty": "MONROVIA",
    "dropphyst": "CA",
    "dropphyzpp": 910169998,
    "dropmaladd": "225 S IVY AVE",
    "dropmalcty": "MONROVIA",
    "dropmalst": "CA",
    "dropmalzpp": 910169998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6262566019,
    "dropsitcph": 6262566019,
    "dropfax": 6263586379
  },
  {
    "dcode": "D",
    "dropkey": "PZ22032",
    "droptype": "D",
    "dropname": "MONTAGUE",
    "dropdeladd": "115 S 11TH ST",
    "dropdelcty": "MONTAGUE",
    "dropdelst": "CA",
    "dropdelzpp": 960649998,
    "dropphyadd": "115 S 11TH ST",
    "dropphycty": "MONTAGUE",
    "dropphyst": "CA",
    "dropphyzpp": 960649998,
    "dropmaladd": "115 S 11TH ST",
    "dropmalcty": "MONTAGUE",
    "dropmalst": "CA",
    "dropmalzpp": 960649998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304593621,
    "dropsitcph": 5304593621,
    "dropfax": 5304593627
  },
  {
    "dcode": "D",
    "dropkey": "PZ22035",
    "droptype": "D",
    "dropname": "MONTARA",
    "dropdeladd": "215 7TH ST",
    "dropdelcty": "MONTARA",
    "dropdelst": "CA",
    "dropdelzpp": 940379998,
    "dropphyadd": "215 7TH ST",
    "dropphycty": "MONTARA",
    "dropphyst": "CA",
    "dropphyzpp": 940379998,
    "dropmaladd": "215 7TH ST",
    "dropmalcty": "MONTARA",
    "dropmalst": "CA",
    "dropmalzpp": 940379998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507281344,
    "dropsitcph": 6507285251,
    "dropfax": 6507281627
  },
  {
    "dcode": "D",
    "dropkey": "PZ22036",
    "droptype": "D",
    "dropname": "MONTCLAIR",
    "dropdeladd": "5186 BENITO ST",
    "dropdelcty": "MONTCLAIR",
    "dropdelst": "CA",
    "dropdelzpp": 917639998,
    "dropphyadd": "5186 BENITO ST",
    "dropphycty": "MONTCLAIR",
    "dropphyst": "CA",
    "dropphyzpp": 917639998,
    "dropmaladd": "5186 BENITO ST",
    "dropmalcty": "MONTCLAIR",
    "dropmalst": "CA",
    "dropmalzpp": 917639998,
    "dropsitphn": 9096245438,
    "dropsitlph": 9096265493,
    "dropsitcph": 9096245438,
    "dropfax": 9096268096
  },
  {
    "dcode": "D",
    "dropkey": "PZ22038",
    "droptype": "D",
    "dropname": "MONTE RIO",
    "dropdeladd": "19420 HIGHWAY 116",
    "dropdelcty": "MONTE RIO",
    "dropdelst": "CA",
    "dropdelzpp": 954629716,
    "dropphyadd": "19420 HIGHWAY 116",
    "dropphycty": "MONTE RIO",
    "dropphyst": "CA",
    "dropphyzpp": 954629716,
    "dropmaladd": "19420 HIGHWAY 116",
    "dropmalcty": "MONTE RIO",
    "dropmalst": "CA",
    "dropmalzpp": 954629716,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078652328,
    "dropfax": 7078651039
  },
  {
    "dcode": "D",
    "dropkey": "PZ22041",
    "droptype": "D",
    "dropname": "MONTEBELLO",
    "dropdeladd": "145 N 5TH ST",
    "dropdelcty": "MONTEBELLO",
    "dropdelst": "CA",
    "dropdelzpp": 906409998,
    "dropphyadd": "145 N 5TH ST",
    "dropphycty": "MONTEBELLO",
    "dropphyst": "CA",
    "dropphyzpp": 906409998,
    "dropmaladd": "145 N 5TH ST",
    "dropmalcty": "MONTEBELLO",
    "dropmalst": "CA",
    "dropmalzpp": 906409998,
    "dropsitphn": 3237282249,
    "dropsitlph": 3237287104,
    "dropsitcph": 3237282249,
    "dropfax": 3237286193
  },
  {
    "dcode": "D",
    "dropkey": "PZ22046",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "565 HARTNELL ST",
    "dropdelcty": "MONTEREY",
    "dropdelst": "CA",
    "dropdelzpp": 939409998,
    "dropphyadd": "565 HARTNELL ST",
    "dropphycty": "MONTEREY",
    "dropphyst": "CA",
    "dropphyzpp": 939409998,
    "dropmaladd": "565 HARTNELL ST",
    "dropmalcty": "MONTEREY",
    "dropmalst": "CA",
    "dropmalzpp": 939409998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316429005,
    "dropsitcph": 8313724063,
    "dropfax": 8313721137
  },
  {
    "dcode": "D",
    "dropkey": "PZ22048",
    "droptype": "D",
    "dropname": "MONTEREY PARK",
    "dropdeladd": "245 W GARVEY AVE",
    "dropdelcty": "MONTEREY PARK",
    "dropdelst": "CA",
    "dropdelzpp": 917549998,
    "dropphyadd": "245 W GARVEY AVE",
    "dropphycty": "MONTEREY PARK",
    "dropphyst": "CA",
    "dropphyzpp": 917549998,
    "dropmaladd": "245 W GARVEY AVE",
    "dropmalcty": "MONTEREY PARK",
    "dropmalst": "CA",
    "dropmalzpp": 917549998,
    "dropsitphn": 6262882764,
    "dropsitlph": 6262270850,
    "dropsitcph": 6262882764,
    "dropfax": 6262888431
  },
  {
    "dcode": "D",
    "dropkey": "PZ22051",
    "droptype": "D",
    "dropname": "MONTGOMERY CREEK",
    "dropdeladd": "30346 STATE HIGHWAY 299 E",
    "dropdelcty": "MONTGOMERY CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 960659998,
    "dropphyadd": "30346 STATE HIGHWAY 299 E",
    "dropphycty": "MONTGOMERY CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 960659998,
    "dropmaladd": "30346 STATE HIGHWAY 299 E",
    "dropmalcty": "MONTGOMERY CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 960659998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303376233,
    "dropsitcph": 5303376233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22056",
    "droptype": "D",
    "dropname": "MONTROSE",
    "dropdeladd": "2100 MONTROSE AVE",
    "dropdelcty": "MONTROSE",
    "dropdelst": "CA",
    "dropdelzpp": 910209998,
    "dropphyadd": "2100 MONTROSE AVE",
    "dropphycty": "MONTROSE",
    "dropphyst": "CA",
    "dropphyzpp": 910209998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MONTROSE",
    "dropmalst": "CA",
    "dropmalzpp": 910219998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8182499635,
    "dropsitcph": 8182499463,
    "dropfax": 6617757109
  },
  {
    "dcode": "D",
    "dropkey": "PZ22058",
    "droptype": "D",
    "dropname": "MOORPARK",
    "dropdeladd": "100 W HIGH ST",
    "dropdelcty": "MOORPARK",
    "dropdelst": "CA",
    "dropdelzpp": 930211113,
    "dropphyadd": "100 W HIGH ST",
    "dropphycty": "MOORPARK",
    "dropphyst": "CA",
    "dropphyzpp": 930211113,
    "dropmaladd": "100 W HIGH ST",
    "dropmalcty": "MOORPARK",
    "dropmalst": "CA",
    "dropmalzpp": 930211113,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055529925,
    "dropsitcph": 8055520340,
    "dropfax": 8055520765
  },
  {
    "dcode": "D",
    "dropkey": "PZ22059",
    "droptype": "D",
    "dropname": "MORAGA",
    "dropdeladd": "460 CENTER ST",
    "dropdelcty": "MORAGA",
    "dropdelst": "CA",
    "dropdelzpp": 945569998,
    "dropphyadd": "460 CENTER ST",
    "dropphycty": "MORAGA",
    "dropphyst": "CA",
    "dropphyzpp": 945569998,
    "dropmaladd": "460 CENTER ST",
    "dropmalcty": "MORAGA",
    "dropmalst": "CA",
    "dropmalzpp": 945569998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9253762467,
    "dropsitcph": 9253769012,
    "dropfax": 9253768458
  },
  {
    "dcode": "D",
    "dropkey": "PZ22063",
    "droptype": "D",
    "dropname": "MORENO VALLEY",
    "dropdeladd": "23580 ALESSANDRO BLVD",
    "dropdelcty": "MORENO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 925539998,
    "dropphyadd": "23580 ALESSANDRO BLVD",
    "dropphycty": "MORENO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 925539998,
    "dropmaladd": "23580 ALESSANDRO BLVD",
    "dropmalcty": "MORENO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 925539998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516564302,
    "dropsitcph": 9516569720,
    "dropfax": 9516563461
  },
  {
    "dcode": "D",
    "dropkey": "PZ22066",
    "droptype": "D",
    "dropname": "MORGAN HILL",
    "dropdeladd": "16600 MONTEREY ST",
    "dropdelcty": "MORGAN HILL",
    "dropdelst": "CA",
    "dropdelzpp": 950379998,
    "dropphyadd": "16600 MONTEREY ST",
    "dropphycty": "MORGAN HILL",
    "dropphyst": "CA",
    "dropphyzpp": 950379998,
    "dropmaladd": "16600 MONTEREY ST",
    "dropmalcty": "MORGAN HILL",
    "dropmalst": "CA",
    "dropmalzpp": 950379998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4088255596,
    "dropsitcph": 4087794834,
    "dropfax": 4087785939
  },
  {
    "dcode": "D",
    "dropkey": "PZ22070",
    "droptype": "D",
    "dropname": "MORONGO VALLEY",
    "dropdeladd": "49649 29 PALMS HWY",
    "dropdelcty": "MORONGO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 922562000,
    "dropphyadd": "49649 29 PALMS HWY",
    "dropphycty": "MORONGO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 922562000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORONGO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 922569998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603631199,
    "dropsitcph": 7603637354,
    "dropfax": 7603636984
  },
  {
    "dcode": "D",
    "dropkey": "PZ22072",
    "droptype": "D",
    "dropname": "MORRO BAY",
    "dropdeladd": "898 NAPA AVE",
    "dropdelcty": "MORRO BAY",
    "dropdelst": "CA",
    "dropdelzpp": 934429998,
    "dropphyadd": "898 NAPA AVE",
    "dropphycty": "MORRO BAY",
    "dropphyst": "CA",
    "dropphyzpp": 934429998,
    "dropmaladd": "898 NAPA AVE",
    "dropmalcty": "MORRO BAY",
    "dropmalst": "CA",
    "dropmalzpp": 934429998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8057720862,
    "dropsitcph": 8057720839,
    "dropfax": 8057729288
  },
  {
    "dcode": "D",
    "dropkey": "PZ22074",
    "droptype": "D",
    "dropname": "MOSS BEACH",
    "dropdeladd": "2315 CARLOS ST",
    "dropdelcty": "MOSS BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 940389998,
    "dropphyadd": "2315 CARLOS ST",
    "dropphycty": "MOSS BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 940389998,
    "dropmaladd": "2315 CARLOS ST",
    "dropmalcty": "MOSS BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 940389998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507283151,
    "dropsitcph": 6507283151,
    "dropfax": 6507281627
  },
  {
    "dcode": "D",
    "dropkey": "PZ22075",
    "droptype": "D",
    "dropname": "MOSS LANDING",
    "dropdeladd": "8042 MOSS LANDING RD",
    "dropdelcty": "MOSS LANDING",
    "dropdelst": "CA",
    "dropdelzpp": 950399998,
    "dropphyadd": "8042 MOSS LANDING RD",
    "dropphycty": "MOSS LANDING",
    "dropphyst": "CA",
    "dropphyzpp": 950399998,
    "dropmaladd": "8042 MOSS LANDING RD",
    "dropmalcty": "MOSS LANDING",
    "dropmalst": "CA",
    "dropmalzpp": 950399998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316332155,
    "dropfax": 8316338342
  },
  {
    "dcode": "D",
    "dropkey": "PZ22076",
    "droptype": "D",
    "dropname": "MOUNT AUKUM",
    "dropdeladd": "8171 MOUNT AUKUM RD STE 101",
    "dropdelcty": "MOUNT AUKUM",
    "dropdelst": "CA",
    "dropdelzpp": 956569998,
    "dropphyadd": "8171 MOUNT AUKUM RD STE 101",
    "dropphycty": "MOUNT AUKUM",
    "dropphyst": "CA",
    "dropphyzpp": 956569998,
    "dropmaladd": "8171 MOUNT AUKUM RD STE 101",
    "dropmalcty": "MOUNT AUKUM",
    "dropmalst": "CA",
    "dropmalzpp": 956569998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306209000,
    "dropsitcph": 5306209000,
    "dropfax": 5306209003
  },
  {
    "dcode": "D",
    "dropkey": "PZ22079",
    "droptype": "D",
    "dropname": "MOUNT HERMON",
    "dropdeladd": "41 CONFERENCE DR",
    "dropdelcty": "MOUNT HERMON",
    "dropdelst": "CA",
    "dropdelzpp": 950419800,
    "dropphyadd": "41 CONFERENCE DR",
    "dropphycty": "MOUNT HERMON",
    "dropphyst": "CA",
    "dropphyzpp": 950419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT HERMON",
    "dropmalst": "CA",
    "dropmalzpp": 950419998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313355455,
    "dropfax": 8313354793
  },
  {
    "dcode": "D",
    "dropkey": "PZ22080",
    "droptype": "D",
    "dropname": "MOUNT LAGUNA",
    "dropdeladd": "810 SUNRISE HWY",
    "dropdelcty": "MOUNT LAGUNA",
    "dropdelst": "CA",
    "dropdelzpp": 919489800,
    "dropphyadd": "810 SUNRISE HWY",
    "dropphycty": "MOUNT LAGUNA",
    "dropphyst": "CA",
    "dropphyzpp": 919489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNT LAGUNA",
    "dropmalst": "CA",
    "dropmalzpp": 919489998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194738341,
    "dropsitcph": 6194738341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22081",
    "droptype": "D",
    "dropname": "MOUNT SHASTA",
    "dropdeladd": "301 S MOUNT SHASTA BLVD",
    "dropdelcty": "MOUNT SHASTA",
    "dropdelst": "CA",
    "dropdelzpp": 960679998,
    "dropphyadd": "301 S MOUNT SHASTA BLVD",
    "dropphycty": "MOUNT SHASTA",
    "dropphyst": "CA",
    "dropphyzpp": 960679998,
    "dropmaladd": "301 S MOUNT SHASTA BLVD",
    "dropmalcty": "MOUNT SHASTA",
    "dropmalst": "CA",
    "dropmalzpp": 960679998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309261813,
    "dropsitcph": 5309261343,
    "dropfax": 5309261924
  },
  {
    "dcode": "D",
    "dropkey": "PZ22084",
    "droptype": "D",
    "dropname": "MOUNTAIN CENTER",
    "dropdeladd": "29470 US HIGHWAY 243",
    "dropdelcty": "MOUNTAIN CENTER",
    "dropdelst": "CA",
    "dropdelzpp": 925610020,
    "dropphyadd": "29470 US HIGHWAY 243",
    "dropphycty": "MOUNTAIN CENTER",
    "dropphyst": "CA",
    "dropphyzpp": 925610020,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOUNTAIN CENTER",
    "dropmalst": "CA",
    "dropmalzpp": 925619998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516592361,
    "dropsitcph": 9516592361,
    "dropfax": 9516598503
  },
  {
    "dcode": "D",
    "dropkey": "PZ22089",
    "droptype": "D",
    "dropname": "MOUNTAIN RANCH",
    "dropdeladd": "8062 WASHINGTON ST",
    "dropdelcty": "MOUNTAIN RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 952469998,
    "dropphyadd": "8062 WASHINGTON ST",
    "dropphycty": "MOUNTAIN RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 952469998,
    "dropmaladd": "8062 WASHINGTON ST",
    "dropmalcty": "MOUNTAIN RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 952469998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097543461,
    "dropsitcph": 2097543461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22091",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "211 HOPE ST",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "CA",
    "dropdelzpp": 940419998,
    "dropphyadd": "211 HOPE ST",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "CA",
    "dropphyzpp": 940419998,
    "dropmaladd": "211 HOPE ST",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "CA",
    "dropmalzpp": 940419998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509386912,
    "dropsitcph": 6509606851,
    "dropfax": 6509386946
  },
  {
    "dcode": "D",
    "dropkey": "PZ22094",
    "droptype": "D",
    "dropname": "MT BALDY",
    "dropdeladd": "6730 MT BALDY RD",
    "dropdelcty": "MT BALDY",
    "dropdelst": "CA",
    "dropdelzpp": 917599000,
    "dropphyadd": "6730 MT BALDY RD",
    "dropphycty": "MT BALDY",
    "dropphyst": "CA",
    "dropphyzpp": 917599000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MT BALDY",
    "dropmalst": "CA",
    "dropmalzpp": 917599998,
    "dropsitphn": 9099827807,
    "dropsitlph": 9099827807,
    "dropsitcph": 9099827807,
    "dropfax": 9099825827
  },
  {
    "dcode": "D",
    "dropkey": "PZ22107",
    "droptype": "D",
    "dropname": "MURPHYS",
    "dropdeladd": "140 BIG TREES RD",
    "dropdelcty": "MURPHYS",
    "dropdelst": "CA",
    "dropdelzpp": 952479998,
    "dropphyadd": "140 BIG TREES RD",
    "dropphycty": "MURPHYS",
    "dropphyst": "CA",
    "dropphyzpp": 952479998,
    "dropmaladd": "140 BIG TREES RD",
    "dropmalcty": "MURPHYS",
    "dropmalst": "CA",
    "dropmalzpp": 952479998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097282113,
    "dropsitcph": 2097282113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22109",
    "droptype": "D",
    "dropname": "MURRIETA",
    "dropdeladd": "24930 WASHINGTON AVE",
    "dropdelcty": "MURRIETA",
    "dropdelst": "CA",
    "dropdelzpp": 925629998,
    "dropphyadd": "24930 WASHINGTON AVE",
    "dropphycty": "MURRIETA",
    "dropphyst": "CA",
    "dropphyzpp": 925629998,
    "dropmaladd": "24930 WASHINGTON AVE",
    "dropmalcty": "MURRIETA",
    "dropmalst": "CA",
    "dropmalzpp": 925629998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516984131,
    "dropsitcph": 9513042529,
    "dropfax": 9516969567
  },
  {
    "dcode": "D",
    "dropkey": "PZ22113",
    "droptype": "D",
    "dropname": "MYERS FLAT",
    "dropdeladd": "12848 STATE HIGHWAY 254",
    "dropdelcty": "MYERS FLAT",
    "dropdelst": "CA",
    "dropdelzpp": 955549538,
    "dropphyadd": "12848 STATE HIGHWAY 254",
    "dropphycty": "MYERS FLAT",
    "dropphyst": "CA",
    "dropphyzpp": 955549538,
    "dropmaladd": "12848 STATE HIGHWAY 254",
    "dropmalcty": "MYERS FLAT",
    "dropmalst": "CA",
    "dropmalzpp": 955549538,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079433335,
    "dropfax": 7079433335
  },
  {
    "dcode": "D",
    "dropkey": "PZ22120",
    "droptype": "D",
    "dropname": "NAPA",
    "dropdeladd": "1625 TRANCAS ST",
    "dropdelcty": "NAPA",
    "dropdelst": "CA",
    "dropdelzpp": 945589998,
    "dropphyadd": "1625 TRANCAS ST",
    "dropphycty": "NAPA",
    "dropphyst": "CA",
    "dropphyzpp": 945589998,
    "dropmaladd": "1625 TRANCAS ST",
    "dropmalcty": "NAPA",
    "dropmalst": "CA",
    "dropmalzpp": 945589998,
    "dropsitphn": 5104337569,
    "dropsitlph": 7072550360,
    "dropsitcph": 7072550190,
    "dropfax": 7072577041
  },
  {
    "dcode": "D",
    "dropkey": "PZ22127",
    "droptype": "D",
    "dropname": "NATIONAL CITY",
    "dropdeladd": "710 E 16TH ST",
    "dropdelcty": "NATIONAL CITY",
    "dropdelst": "CA",
    "dropdelzpp": 919509998,
    "dropphyadd": "710 E 16TH ST",
    "dropphycty": "NATIONAL CITY",
    "dropphyst": "CA",
    "dropphyzpp": 919509998,
    "dropmaladd": "710 E 16TH ST",
    "dropmalcty": "NATIONAL CITY",
    "dropmalst": "CA",
    "dropmalzpp": 919509998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194770704,
    "dropsitcph": 6194771085,
    "dropfax": 6194777873
  },
  {
    "dcode": "D",
    "dropkey": "PZ22141",
    "droptype": "D",
    "dropname": "NEEDLES",
    "dropdeladd": "628 3RD ST",
    "dropdelcty": "NEEDLES",
    "dropdelst": "CA",
    "dropdelzpp": 923639998,
    "dropphyadd": "628 3RD ST",
    "dropphycty": "NEEDLES",
    "dropphyst": "CA",
    "dropphyzpp": 923639998,
    "dropmaladd": "628 3RD ST",
    "dropmalcty": "NEEDLES",
    "dropmalst": "CA",
    "dropmalzpp": 923639998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603264156,
    "dropsitcph": 7603262696,
    "dropfax": 7603265708
  },
  {
    "dcode": "D",
    "dropkey": "PZ22145",
    "droptype": "D",
    "dropname": "NEVADA CITY",
    "dropdeladd": "200 COYOTE ST",
    "dropdelcty": "NEVADA CITY",
    "dropdelst": "CA",
    "dropdelzpp": 959599998,
    "dropphyadd": "200 COYOTE ST",
    "dropphycty": "NEVADA CITY",
    "dropphyst": "CA",
    "dropphyzpp": 959599998,
    "dropmaladd": "200 COYOTE ST",
    "dropmalcty": "NEVADA CITY",
    "dropmalst": "CA",
    "dropmalzpp": 959599998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302652455,
    "dropsitcph": 5302650263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22146",
    "droptype": "D",
    "dropname": "NEW ALMADEN",
    "dropdeladd": "21300 ALMADEN RD",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951204306,
    "dropphyadd": "21300 ALMADEN RD",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951204306,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEW ALMADEN",
    "dropmalst": "CA",
    "dropmalzpp": 950429998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 4082687730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22147",
    "droptype": "D",
    "dropname": "NEW CUYAMA",
    "dropdeladd": "4855 PRIMERO ST",
    "dropdelcty": "NEW CUYAMA",
    "dropdelst": "CA",
    "dropdelzpp": 932549998,
    "dropphyadd": "4855 PRIMERO ST",
    "dropphycty": "NEW CUYAMA",
    "dropphyst": "CA",
    "dropphyzpp": 932549998,
    "dropmaladd": "4855 PRIMERO ST",
    "dropmalcty": "NEW CUYAMA",
    "dropmalst": "CA",
    "dropmalzpp": 932549998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617662313,
    "dropsitcph": 6617662313,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22151",
    "droptype": "D",
    "dropname": "NEWARK",
    "dropdeladd": "6655 CLARK AVE",
    "dropdelcty": "NEWARK",
    "dropdelst": "CA",
    "dropdelzpp": 945609998,
    "dropphyadd": "6655 CLARK AVE",
    "dropphycty": "NEWARK",
    "dropphyst": "CA",
    "dropphyzpp": 945609998,
    "dropmaladd": "6655 CLARK AVE",
    "dropmalcty": "NEWARK",
    "dropmalst": "CA",
    "dropmalzpp": 945609998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107928139,
    "dropsitcph": 5107970903,
    "dropfax": 5107979315
  },
  {
    "dcode": "D",
    "dropkey": "PZ22153",
    "droptype": "D",
    "dropname": "NEWBERRY SPRINGS",
    "dropdeladd": "31411 NEWBERRY RD",
    "dropdelcty": "NEWBERRY SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 923659998,
    "dropphyadd": "31411 NEWBERRY RD",
    "dropphycty": "NEWBERRY SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 923659998,
    "dropmaladd": "31411 NEWBERRY RD",
    "dropmalcty": "NEWBERRY SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 923659998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602573264,
    "dropsitcph": 7602573264,
    "dropfax": 7602571054
  },
  {
    "dcode": "D",
    "dropkey": "PZ22155",
    "droptype": "D",
    "dropname": "NEWCASTLE",
    "dropdeladd": "9241 OLD STATE HWY",
    "dropdelcty": "NEWCASTLE",
    "dropdelst": "CA",
    "dropdelzpp": 956589998,
    "dropphyadd": "9241 OLD STATE HWY",
    "dropphycty": "NEWCASTLE",
    "dropphyst": "CA",
    "dropphyzpp": 956589998,
    "dropmaladd": "9241 OLD STATE HWY",
    "dropmalcty": "NEWCASTLE",
    "dropmalst": "CA",
    "dropmalzpp": 956589998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166639405,
    "dropsitcph": 9166639405,
    "dropfax": 9166639581
  },
  {
    "dcode": "D",
    "dropkey": "PZ22159",
    "droptype": "D",
    "dropname": "NEWMAN",
    "dropdeladd": "1313 MAIN ST",
    "dropdelcty": "NEWMAN",
    "dropdelst": "CA",
    "dropdelzpp": 953609998,
    "dropphyadd": "1313 MAIN ST",
    "dropphycty": "NEWMAN",
    "dropphyst": "CA",
    "dropphyzpp": 953609998,
    "dropmaladd": "1313 MAIN ST",
    "dropmalcty": "NEWMAN",
    "dropmalst": "CA",
    "dropmalzpp": 953609998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098622610,
    "dropsitcph": 2098622610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22163",
    "droptype": "D",
    "dropname": "NEWPORT BEACH",
    "dropdeladd": "1133 CAMELBACK ST",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926589998,
    "dropphyadd": "1133 CAMELBACK ST",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926589998,
    "dropmaladd": "1133 CAMELBACK ST",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926589998,
    "dropsitphn": 9496404663,
    "dropsitlph": 9496405734,
    "dropsitcph": 9496404663,
    "dropfax": 9496404703
  },
  {
    "dcode": "D",
    "dropkey": "PZ22168",
    "droptype": "D",
    "dropname": "NICASIO",
    "dropdeladd": "1 OLD RANCHERIA RD",
    "dropdelcty": "NICASIO",
    "dropdelst": "CA",
    "dropdelzpp": 949469701,
    "dropphyadd": "1 OLD RANCHERIA RD",
    "dropphycty": "NICASIO",
    "dropphyst": "CA",
    "dropphyzpp": 949469701,
    "dropmaladd": "1 OLD RANCHERIA RD",
    "dropmalcty": "NICASIO",
    "dropmalst": "CA",
    "dropmalzpp": 949469701,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4156622000,
    "dropfax": 4156622000
  },
  {
    "dcode": "D",
    "dropkey": "PZ22169",
    "droptype": "D",
    "dropname": "NICE",
    "dropdeladd": "3964 E STATE HWY 20",
    "dropdelcty": "NICE",
    "dropdelst": "CA",
    "dropdelzpp": 954649903,
    "dropphyadd": "3964 E STATE HWY 20",
    "dropphycty": "NICE",
    "dropphyst": "CA",
    "dropphyzpp": 954649903,
    "dropmaladd": "3964 E STATE HWY 20",
    "dropmalcty": "NICE",
    "dropmalst": "CA",
    "dropmalzpp": 954649903,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7072741374,
    "dropfax": 7072741374
  },
  {
    "dcode": "D",
    "dropkey": "PZ22170",
    "droptype": "D",
    "dropname": "NICOLAUS",
    "dropdeladd": "2900 GARDEN HWY",
    "dropdelcty": "NICOLAUS",
    "dropdelst": "CA",
    "dropdelzpp": 956599998,
    "dropphyadd": "2900 GARDEN HWY",
    "dropphycty": "NICOLAUS",
    "dropphyst": "CA",
    "dropphyzpp": 956599998,
    "dropmaladd": "2900 GARDEN HWY",
    "dropmalcty": "NICOLAUS",
    "dropmalst": "CA",
    "dropmalzpp": 956599998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306562251,
    "dropsitcph": 5306562251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22172",
    "droptype": "D",
    "dropname": "NILAND",
    "dropdeladd": "8108 US HIGHWAY 111",
    "dropdelcty": "NILAND",
    "dropdelst": "CA",
    "dropdelzpp": 922579800,
    "dropphyadd": "8108 US HIGHWAY 111",
    "dropphycty": "NILAND",
    "dropphyst": "CA",
    "dropphyzpp": 922579800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NILAND",
    "dropmalst": "CA",
    "dropmalzpp": 922579998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603593138,
    "dropsitcph": 7603593173,
    "dropfax": 7603590204
  },
  {
    "dcode": "D",
    "dropkey": "PZ22178",
    "droptype": "D",
    "dropname": "NIPOMO",
    "dropdeladd": "630 W TEFFT ST",
    "dropdelcty": "NIPOMO",
    "dropdelst": "CA",
    "dropdelzpp": 934449998,
    "dropphyadd": "630 W TEFFT ST",
    "dropphycty": "NIPOMO",
    "dropphyst": "CA",
    "dropphyzpp": 934449998,
    "dropmaladd": "630 W TEFFT ST",
    "dropmalcty": "NIPOMO",
    "dropmalst": "CA",
    "dropmalzpp": 934449998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059294643,
    "dropsitcph": 8059294614,
    "dropfax": 8059295366
  },
  {
    "dcode": "D",
    "dropkey": "PZ22182",
    "droptype": "D",
    "dropname": "NORCO",
    "dropdeladd": "1801 TOWN AND COUNTRY DR",
    "dropdelcty": "NORCO",
    "dropdelst": "CA",
    "dropdelzpp": 928609998,
    "dropphyadd": "1801 TOWN AND COUNTRY DR",
    "dropphycty": "NORCO",
    "dropphyst": "CA",
    "dropphyzpp": 928609998,
    "dropmaladd": "1801 TOWN AND COUNTRY DR",
    "dropmalcty": "NORCO",
    "dropmalst": "CA",
    "dropmalzpp": 928609998,
    "dropsitphn": 9518084679,
    "dropsitlph": 9518084681,
    "dropsitcph": 9518084679,
    "dropfax": 9518084687
  },
  {
    "dcode": "D",
    "dropkey": "PZ22187",
    "droptype": "D",
    "dropname": "NORTH BAY GMF",
    "dropdeladd": "1150 N MCDOWELL BLVD",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949999994,
    "dropphyadd": "1150 N MCDOWELL BLVD",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949999994,
    "dropmaladd": "1150 N MCDOWELL BLVD",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949999994,
    "dropsitphn": 7077695360,
    "dropsitlph": 7077785220,
    "dropsitcph": 7077785206,
    "dropfax": 7077785277
  },
  {
    "dcode": "D",
    "dropkey": "PZ22197",
    "droptype": "D",
    "dropname": "NORTH FORK",
    "dropdeladd": "33173 ROAD 222",
    "dropdelcty": "NORTH FORK",
    "dropdelst": "CA",
    "dropdelzpp": 936439998,
    "dropphyadd": "33173 ROAD 222",
    "dropphycty": "NORTH FORK",
    "dropphyst": "CA",
    "dropphyzpp": 936439998,
    "dropmaladd": "33173 ROAD 222",
    "dropmalcty": "NORTH FORK",
    "dropmalst": "CA",
    "dropmalzpp": 936439998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598772220,
    "dropfax": 5598772202
  },
  {
    "dcode": "D",
    "dropkey": "PZ22200",
    "droptype": "D",
    "dropname": "NORTH HIGHLANDS",
    "dropdeladd": "6483 WATT AVE",
    "dropdelcty": "NORTH HIGHLANDS",
    "dropdelst": "CA",
    "dropdelzpp": 956609998,
    "dropphyadd": "6483 WATT AVE",
    "dropphycty": "NORTH HIGHLANDS",
    "dropphyst": "CA",
    "dropphyzpp": 956609998,
    "dropmaladd": "6483 WATT AVE",
    "dropmalcty": "NORTH HIGHLANDS",
    "dropmalst": "CA",
    "dropmalzpp": 956609998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163320698,
    "dropsitcph": 9163322546,
    "dropfax": 9163384355
  },
  {
    "dcode": "D",
    "dropkey": "PZ22202",
    "droptype": "D",
    "dropname": "NORTH HOLLYWOOD",
    "dropdeladd": "7035 LAUREL CANYON BLVD",
    "dropdelcty": "NORTH HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 916059998,
    "dropphyadd": "7035 LAUREL CANYON BLVD",
    "dropphycty": "NORTH HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 916059998,
    "dropmaladd": "7035 LAUREL CANYON BLVD",
    "dropmalcty": "NORTH HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 916059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185030979,
    "dropsitcph": 8185030979,
    "dropfax": 7472055556
  },
  {
    "dcode": "D",
    "dropkey": "PZ22209",
    "droptype": "D",
    "dropname": "NORTH PALM SPRINGS",
    "dropdeladd": "64117 DILLION RD",
    "dropdelcty": "NORTH PALM SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 922580400,
    "dropphyadd": "64117 DILLION RD",
    "dropphycty": "NORTH PALM SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 922580400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH PALM SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 922589998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602510589,
    "dropsitcph": 7602517569,
    "dropfax": 7602518539
  },
  {
    "dcode": "D",
    "dropkey": "PZ22215",
    "droptype": "D",
    "dropname": "NORTH SAN JUAN",
    "dropdeladd": "20092 OAK TREE RD",
    "dropdelcty": "NORTH SAN JUAN",
    "dropdelst": "CA",
    "dropdelzpp": 959609998,
    "dropphyadd": "20092 OAK TREE RD",
    "dropphycty": "NORTH SAN JUAN",
    "dropphyst": "CA",
    "dropphyzpp": 959609998,
    "dropmaladd": "20092 OAK TREE RD",
    "dropmalcty": "NORTH SAN JUAN",
    "dropmalst": "CA",
    "dropmalzpp": 959609998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302923303,
    "dropsitcph": 5302923303,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22220",
    "droptype": "D",
    "dropname": "NORTHRIDGE",
    "dropdeladd": "9534 RESEDA BLVD",
    "dropdelcty": "NORTHRIDGE",
    "dropdelst": "CA",
    "dropdelzpp": 913249998,
    "dropphyadd": "9534 RESEDA BLVD",
    "dropphycty": "NORTHRIDGE",
    "dropphyst": "CA",
    "dropphyzpp": 913249998,
    "dropmaladd": "9534 RESEDA BLVD",
    "dropmalcty": "NORTHRIDGE",
    "dropmalst": "CA",
    "dropmalzpp": 913249998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183490331,
    "dropsitcph": 8183490331,
    "dropfax": 8184071569
  },
  {
    "dcode": "D",
    "dropkey": "PZ22228",
    "droptype": "D",
    "dropname": "NORWALK",
    "dropdeladd": "14011 CLARKDALE AVE",
    "dropdelcty": "NORWALK",
    "dropdelst": "CA",
    "dropdelzpp": 906509998,
    "dropphyadd": "14011 CLARKDALE AVE",
    "dropphycty": "NORWALK",
    "dropphyst": "CA",
    "dropphyzpp": 906509998,
    "dropmaladd": "14011 CLARKDALE AVE",
    "dropmalcty": "NORWALK",
    "dropmalst": "CA",
    "dropmalzpp": 906509998,
    "dropsitphn": 5628689408,
    "dropsitlph": 5628685337,
    "dropsitcph": 5628689408,
    "dropfax": 5629292092
  },
  {
    "dcode": "D",
    "dropkey": "PZ22229",
    "droptype": "D",
    "dropname": "NOVATO",
    "dropdeladd": "1537 S NOVATO BLVD",
    "dropdelcty": "NOVATO",
    "dropdelst": "CA",
    "dropdelzpp": 949474111,
    "dropphyadd": "1537 S NOVATO BLVD",
    "dropphycty": "NOVATO",
    "dropphyst": "CA",
    "dropphyzpp": 949474111,
    "dropmaladd": "1537 S NOVATO BLVD",
    "dropmalcty": "NOVATO",
    "dropmalst": "CA",
    "dropmalzpp": 949474111,
    "dropsitphn": 4158988207,
    "dropsitlph": 4158988207,
    "dropsitcph": 4158988799,
    "dropfax": 4158973501
  },
  {
    "dcode": "D",
    "dropkey": "PZ22275",
    "droptype": "D",
    "dropname": "NUBIEBER",
    "dropdeladd": "652-890 STATE HIGHWAY 299 E",
    "dropdelcty": "NUBIEBER",
    "dropdelst": "CA",
    "dropdelzpp": 960689998,
    "dropphyadd": "652-890 STATE HIGHWAY 299 E",
    "dropphycty": "NUBIEBER",
    "dropphyst": "CA",
    "dropphyzpp": 960689998,
    "dropmaladd": "652-890 STATE HIGHWAY 299 E",
    "dropmalcty": "NUBIEBER",
    "dropmalst": "CA",
    "dropmalzpp": 960689998,
    "dropsitphn": 9163738025,
    "dropsitlph": 6265570375,
    "dropsitcph": 6265570375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22276",
    "droptype": "D",
    "dropname": "NUEVO",
    "dropdeladd": "29245 LAKEVIEW AVE",
    "dropdelcty": "NUEVO",
    "dropdelst": "CA",
    "dropdelzpp": 925679998,
    "dropphyadd": "29245 LAKEVIEW AVE",
    "dropphycty": "NUEVO",
    "dropphyst": "CA",
    "dropphyzpp": 925679998,
    "dropmaladd": "29245 LAKEVIEW AVE",
    "dropmalcty": "NUEVO",
    "dropmalst": "CA",
    "dropmalzpp": 925679998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9519284137,
    "dropsitcph": 9519284876,
    "dropfax": 9519283276
  },
  {
    "dcode": "D",
    "dropkey": "PZ22282",
    "droptype": "D",
    "dropname": "O NEALS",
    "dropdeladd": "47065 ROAD 201",
    "dropdelcty": "O NEALS",
    "dropdelst": "CA",
    "dropdelzpp": 936459998,
    "dropphyadd": "47065 ROAD 201",
    "dropphycty": "O NEALS",
    "dropphyst": "CA",
    "dropphyzpp": 936459998,
    "dropmaladd": "47065 ROAD 201",
    "dropmalcty": "O NEALS",
    "dropmalst": "CA",
    "dropmalzpp": 936459998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598683497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22290",
    "droptype": "D",
    "dropname": "OAK RUN",
    "dropdeladd": "27600 OAK RUN TO FERN RD",
    "dropdelcty": "OAK RUN",
    "dropdelst": "CA",
    "dropdelzpp": 960699998,
    "dropphyadd": "27600 OAK RUN TO FERN RD",
    "dropphycty": "OAK RUN",
    "dropphyst": "CA",
    "dropphyzpp": 960699998,
    "dropmaladd": "27600 OAK RUN TO FERN RD",
    "dropmalcty": "OAK RUN",
    "dropmalst": "CA",
    "dropmalzpp": 960699998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304723248,
    "dropsitcph": 5304723248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22291",
    "droptype": "D",
    "dropname": "OAK VIEW",
    "dropdeladd": "360 VENTURA AVE",
    "dropdelcty": "OAK VIEW",
    "dropdelst": "CA",
    "dropdelzpp": 930229998,
    "dropphyadd": "360 VENTURA AVE",
    "dropphycty": "OAK VIEW",
    "dropphyst": "CA",
    "dropphyzpp": 930229998,
    "dropmaladd": "360 VENTURA AVE",
    "dropmalcty": "OAK VIEW",
    "dropmalst": "CA",
    "dropmalzpp": 930229998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056495324,
    "dropsitcph": 8056495395,
    "dropfax": 8059885604
  },
  {
    "dcode": "D",
    "dropkey": "PZ22292",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "170 CALIFORNIA AVE",
    "dropdelcty": "OAKDALE",
    "dropdelst": "CA",
    "dropdelzpp": 953619998,
    "dropphyadd": "170 CALIFORNIA AVE",
    "dropphycty": "OAKDALE",
    "dropphyst": "CA",
    "dropphyzpp": 953619998,
    "dropmaladd": "170 CALIFORNIA AVE",
    "dropmalcty": "OAKDALE",
    "dropmalst": "CA",
    "dropmalzpp": 953619998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098477269,
    "dropsitcph": 2098474030,
    "dropfax": 2098473270
  },
  {
    "dcode": "D",
    "dropkey": "PZ22294",
    "droptype": "D",
    "dropname": "OAKHURST",
    "dropdeladd": "40064 HIGHWAY 49",
    "dropdelcty": "OAKHURST",
    "dropdelst": "CA",
    "dropdelzpp": 936449998,
    "dropphyadd": "40064 HIGHWAY 49",
    "dropphycty": "OAKHURST",
    "dropphyst": "CA",
    "dropphyzpp": 936449998,
    "dropmaladd": "40064 HIGHWAY 49",
    "dropmalcty": "OAKHURST",
    "dropmalst": "CA",
    "dropmalzpp": 936449998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596416891,
    "dropsitcph": 5596586862,
    "dropfax": 5596585768
  },
  {
    "dcode": "D",
    "dropkey": "PZ22296",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "1675 7TH ST RM 236",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946159997,
    "dropphyadd": "1675 7TH ST RM 236",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946159997,
    "dropmaladd": "1675 7TH ST RM 236",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946159997,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108748654,
    "dropsitcph": 5102513373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22297",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "400 DEL ANTICO AVE",
    "dropdelcty": "OAKLEY",
    "dropdelst": "CA",
    "dropdelzpp": 945615710,
    "dropphyadd": "400 DEL ANTICO AVE",
    "dropphycty": "OAKLEY",
    "dropphyst": "CA",
    "dropphyzpp": 945615710,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKLEY",
    "dropmalst": "CA",
    "dropmalzpp": 945619998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256257594,
    "dropsitcph": 9256255687,
    "dropfax": 9256257523
  },
  {
    "dcode": "D",
    "dropkey": "PZ22299",
    "droptype": "D",
    "dropname": "OAKVILLE",
    "dropdeladd": "7856 ST HELENA HWY",
    "dropdelcty": "OAKVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 945629200,
    "dropphyadd": "7856 ST HELENA HWY",
    "dropphycty": "OAKVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 945629200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OAKVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 945629998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079442600,
    "dropfax": 7079448640
  },
  {
    "dcode": "D",
    "dropkey": "PZ22303",
    "droptype": "D",
    "dropname": "OCCIDENTAL",
    "dropdeladd": "3805 BOHEMIAN HWY",
    "dropdelcty": "OCCIDENTAL",
    "dropdelst": "CA",
    "dropdelzpp": 954659365,
    "dropphyadd": "3805 BOHEMIAN HWY",
    "dropphycty": "OCCIDENTAL",
    "dropphyst": "CA",
    "dropphyzpp": 954659365,
    "dropmaladd": "3805 BOHEMIAN HWY",
    "dropmalcty": "OCCIDENTAL",
    "dropmalst": "CA",
    "dropmalzpp": 954659365,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078743606,
    "dropfax": 7078742582
  },
  {
    "dcode": "D",
    "dropkey": "PZ22308",
    "droptype": "D",
    "dropname": "OCEANO",
    "dropdeladd": "1800 BEACH ST",
    "dropdelcty": "OCEANO",
    "dropdelst": "CA",
    "dropdelzpp": 934459998,
    "dropphyadd": "1800 BEACH ST",
    "dropphycty": "OCEANO",
    "dropphyst": "CA",
    "dropphyzpp": 934459998,
    "dropmaladd": "1800 BEACH ST",
    "dropmalcty": "OCEANO",
    "dropmalst": "CA",
    "dropmalzpp": 934459998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054896515,
    "dropsitcph": 8054896238,
    "dropfax": 8054897921
  },
  {
    "dcode": "D",
    "dropkey": "PZ22309",
    "droptype": "D",
    "dropname": "OCEANSIDE",
    "dropdeladd": "1895 AVENIDA DEL ORO",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 920569998,
    "dropphyadd": "1895 AVENIDA DEL ORO",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 920569998,
    "dropmaladd": "1895 AVENIDA DEL ORO",
    "dropmalcty": "OCEANSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 920569998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7608063862,
    "dropsitcph": 7608063866,
    "dropfax": 7608067810
  },
  {
    "dcode": "D",
    "dropkey": "PZ22310",
    "droptype": "D",
    "dropname": "OCOTILLO",
    "dropdeladd": "1153 N IMPERIAL HWY",
    "dropdelcty": "OCOTILLO",
    "dropdelst": "CA",
    "dropdelzpp": 922599800,
    "dropphyadd": "1153 N IMPERIAL HWY",
    "dropphycty": "OCOTILLO",
    "dropphyst": "CA",
    "dropphyzpp": 922599800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OCOTILLO",
    "dropmalst": "CA",
    "dropmalzpp": 922599998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603587751,
    "dropsitcph": 7603587751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22313",
    "droptype": "D",
    "dropname": "OJAI",
    "dropdeladd": "201 E OJAI AVE",
    "dropdelcty": "OJAI",
    "dropdelst": "CA",
    "dropdelzpp": 930239998,
    "dropphyadd": "201 E OJAI AVE",
    "dropphycty": "OJAI",
    "dropphyst": "CA",
    "dropphyzpp": 930239998,
    "dropmaladd": "201 E OJAI AVE",
    "dropmalcty": "OJAI",
    "dropmalst": "CA",
    "dropmalzpp": 930239998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056467581,
    "dropsitcph": 8056467904,
    "dropfax": 8056400853
  },
  {
    "dcode": "D",
    "dropkey": "PZ22314",
    "droptype": "D",
    "dropname": "OLANCHA",
    "dropdeladd": "100 S HIGHWAY 395",
    "dropdelcty": "OLANCHA",
    "dropdelst": "CA",
    "dropdelzpp": 935499997,
    "dropphyadd": "100 S HIGHWAY 395",
    "dropphycty": "OLANCHA",
    "dropphyst": "CA",
    "dropphyzpp": 935499997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OLANCHA",
    "dropmalst": "CA",
    "dropmalzpp": 935499998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7607642329,
    "dropsitcph": 7607642329,
    "dropfax": 6618248119
  },
  {
    "dcode": "D",
    "dropkey": "PZ22318",
    "droptype": "D",
    "dropname": "OLD STATION",
    "dropdeladd": "12529 STATE HIGHWAY 44/89",
    "dropdelcty": "OLD STATION",
    "dropdelst": "CA",
    "dropdelzpp": 960719998,
    "dropphyadd": "12529 STATE HIGHWAY 44/89",
    "dropphycty": "OLD STATION",
    "dropphyst": "CA",
    "dropphyzpp": 960719998,
    "dropmaladd": "12529 STATE HIGHWAY 44/89",
    "dropmalcty": "OLD STATION",
    "dropmalst": "CA",
    "dropmalzpp": 960719998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303357191,
    "dropsitcph": 5303357191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22323",
    "droptype": "D",
    "dropname": "OLEMA",
    "dropdeladd": "10155 HIGHWAY 1",
    "dropdelcty": "OLEMA",
    "dropdelst": "CA",
    "dropdelzpp": 949508900,
    "dropphyadd": "10155 HIGHWAY 1",
    "dropphycty": "OLEMA",
    "dropphyst": "CA",
    "dropphyzpp": 949508900,
    "dropmaladd": "10155 HIGHWAY 1",
    "dropmalcty": "OLEMA",
    "dropmalst": "CA",
    "dropmalzpp": 949509998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4156631761,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22328",
    "droptype": "D",
    "dropname": "OLIVEHURST",
    "dropdeladd": "4982 OLIVEHURST AVE",
    "dropdelcty": "OLIVEHURST",
    "dropdelst": "CA",
    "dropdelzpp": 959619998,
    "dropphyadd": "4982 OLIVEHURST AVE",
    "dropphycty": "OLIVEHURST",
    "dropphyst": "CA",
    "dropphyzpp": 959619998,
    "dropmaladd": "4982 OLIVEHURST AVE",
    "dropmalcty": "OLIVEHURST",
    "dropmalst": "CA",
    "dropmalzpp": 959619998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307437379,
    "dropsitcph": 5307435854,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22333",
    "droptype": "D",
    "dropname": "ONTARIO",
    "dropdeladd": "1555 E HOLT BLVD",
    "dropdelcty": "ONTARIO",
    "dropdelst": "CA",
    "dropdelzpp": 917619998,
    "dropphyadd": "1555 E HOLT BLVD",
    "dropphycty": "ONTARIO",
    "dropphyst": "CA",
    "dropphyzpp": 917619998,
    "dropmaladd": "1555 E HOLT BLVD",
    "dropmalcty": "ONTARIO",
    "dropmalst": "CA",
    "dropmalzpp": 917619998,
    "dropsitphn": 9099333837,
    "dropsitlph": 9099837613,
    "dropsitcph": 9099333837,
    "dropfax": 9099884023
  },
  {
    "dcode": "D",
    "dropkey": "PZ22334",
    "droptype": "D",
    "dropname": "ONYX",
    "dropdeladd": "8275 EASY ST",
    "dropdelcty": "ONYX",
    "dropdelst": "CA",
    "dropdelzpp": 932559998,
    "dropphyadd": "8275 EASY ST",
    "dropphycty": "ONYX",
    "dropphyst": "CA",
    "dropphyzpp": 932559998,
    "dropmaladd": "8275 EASY ST",
    "dropmalcty": "ONYX",
    "dropmalst": "CA",
    "dropmalzpp": 932559998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603782121,
    "dropsitcph": 7603782121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22336",
    "droptype": "D",
    "dropname": "ORANGE",
    "dropdeladd": "1075 N TUSTIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "CA",
    "dropdelzpp": 928639998,
    "dropphyadd": "1075 N TUSTIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "CA",
    "dropphyzpp": 928639998,
    "dropmaladd": "1075 N TUSTIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "CA",
    "dropmalzpp": 928639998,
    "dropsitphn": 7149971889,
    "dropsitlph": 7149228254,
    "dropsitcph": 7149971889,
    "dropfax": 7149971054
  },
  {
    "dcode": "D",
    "dropkey": "PZ22337",
    "droptype": "D",
    "dropname": "ORANGE COVE",
    "dropdeladd": "550 PARK BLVD",
    "dropdelcty": "ORANGE COVE",
    "dropdelst": "CA",
    "dropdelzpp": 936469998,
    "dropphyadd": "550 PARK BLVD",
    "dropphycty": "ORANGE COVE",
    "dropphyst": "CA",
    "dropphyzpp": 936469998,
    "dropmaladd": "550 PARK BLVD",
    "dropmalcty": "ORANGE COVE",
    "dropmalst": "CA",
    "dropmalzpp": 936469998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596261418,
    "dropsitcph": 5596261310,
    "dropfax": 5596262506
  },
  {
    "dcode": "D",
    "dropkey": "PZ22342",
    "droptype": "D",
    "dropname": "ORANGEVALE",
    "dropdeladd": "6261 HAZEL AVE",
    "dropdelcty": "ORANGEVALE",
    "dropdelst": "CA",
    "dropdelzpp": 956629998,
    "dropphyadd": "6261 HAZEL AVE",
    "dropphycty": "ORANGEVALE",
    "dropphyst": "CA",
    "dropphyzpp": 956629998,
    "dropmaladd": "6261 HAZEL AVE",
    "dropmalcty": "ORANGEVALE",
    "dropmalst": "CA",
    "dropmalzpp": 956629998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169880548,
    "dropsitcph": 9169891346,
    "dropfax": 9169881542
  },
  {
    "dcode": "D",
    "dropkey": "PZ22348",
    "droptype": "D",
    "dropname": "OREGON HOUSE",
    "dropdeladd": "8753 MARYSVILLE RD",
    "dropdelcty": "OREGON HOUSE",
    "dropdelst": "CA",
    "dropdelzpp": 959629998,
    "dropphyadd": "8753 MARYSVILLE RD",
    "dropphycty": "OREGON HOUSE",
    "dropphyst": "CA",
    "dropphyzpp": 959629998,
    "dropmaladd": "8753 MARYSVILLE RD",
    "dropmalcty": "OREGON HOUSE",
    "dropmalst": "CA",
    "dropmalzpp": 959629998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306921868,
    "dropsitcph": 5306921868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22349",
    "droptype": "D",
    "dropname": "ORICK",
    "dropdeladd": "121147 HIGHWAY 101",
    "dropdelcty": "ORICK",
    "dropdelst": "CA",
    "dropdelzpp": 955559505,
    "dropphyadd": "121147 HIGHWAY 101",
    "dropphycty": "ORICK",
    "dropphyst": "CA",
    "dropphyzpp": 955559505,
    "dropmaladd": "121147 HIGHWAY 101",
    "dropmalcty": "ORICK",
    "dropmalst": "CA",
    "dropmalzpp": 955559505,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074883611,
    "dropfax": 7074883611
  },
  {
    "dcode": "D",
    "dropkey": "PZ22350",
    "droptype": "D",
    "dropname": "ORINDA",
    "dropdeladd": "29 ORINDA WAY",
    "dropdelcty": "ORINDA",
    "dropdelst": "CA",
    "dropdelzpp": 945639998,
    "dropphyadd": "29 ORINDA WAY",
    "dropphycty": "ORINDA",
    "dropphyst": "CA",
    "dropphyzpp": 945639998,
    "dropmaladd": "29 ORINDA WAY",
    "dropmalcty": "ORINDA",
    "dropmalst": "CA",
    "dropmalzpp": 945639998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252546603,
    "dropsitcph": 9252546240,
    "dropfax": 9252546427
  },
  {
    "dcode": "D",
    "dropkey": "PZ22352",
    "droptype": "D",
    "dropname": "ORLAND",
    "dropdeladd": "831 4TH ST",
    "dropdelcty": "ORLAND",
    "dropdelst": "CA",
    "dropdelzpp": 959639998,
    "dropphyadd": "831 4TH ST",
    "dropphycty": "ORLAND",
    "dropphyst": "CA",
    "dropphyzpp": 959639998,
    "dropmaladd": "831 4TH ST",
    "dropmalcty": "ORLAND",
    "dropmalst": "CA",
    "dropmalzpp": 959639998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308659573,
    "dropsitcph": 5308654912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22353",
    "droptype": "D",
    "dropname": "ORLEANS",
    "dropdeladd": "38150 STATE HIGHWAY 96",
    "dropdelcty": "ORLEANS",
    "dropdelst": "CA",
    "dropdelzpp": 955568800,
    "dropphyadd": "38150 STATE HIGHWAY 96",
    "dropphycty": "ORLEANS",
    "dropphyst": "CA",
    "dropphyzpp": 955568800,
    "dropmaladd": "38150 STATE HIGHWAY 96",
    "dropmalcty": "ORLEANS",
    "dropmalst": "CA",
    "dropmalzpp": 955569998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 5306273466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22354",
    "droptype": "D",
    "dropname": "ORO GRANDE",
    "dropdeladd": "15155 OLIVE ST",
    "dropdelcty": "ORO GRANDE",
    "dropdelst": "CA",
    "dropdelzpp": 923689998,
    "dropphyadd": "15155 OLIVE ST",
    "dropphycty": "ORO GRANDE",
    "dropphyst": "CA",
    "dropphyzpp": 923689998,
    "dropmaladd": "15155 OLIVE ST",
    "dropmalcty": "ORO GRANDE",
    "dropmalst": "CA",
    "dropmalzpp": 923689998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602458345,
    "dropsitcph": 7602458345,
    "dropfax": 7602432795
  },
  {
    "dcode": "D",
    "dropkey": "PZ22355",
    "droptype": "D",
    "dropname": "OROSI",
    "dropdeladd": "41323 ROAD 128",
    "dropdelcty": "OROSI",
    "dropdelst": "CA",
    "dropdelzpp": 936479998,
    "dropphyadd": "41323 ROAD 128",
    "dropphycty": "OROSI",
    "dropphyst": "CA",
    "dropphyzpp": 936479998,
    "dropmaladd": "41323 ROAD 128",
    "dropmalcty": "OROSI",
    "dropmalst": "CA",
    "dropmalzpp": 936479998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5595282094,
    "dropsitcph": 5595283085,
    "dropfax": 5595283867
  },
  {
    "dcode": "D",
    "dropkey": "PZ22356",
    "droptype": "D",
    "dropname": "OROVILLE",
    "dropdeladd": "1735 ROBINSON ST",
    "dropdelcty": "OROVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959659998,
    "dropphyadd": "1735 ROBINSON ST",
    "dropphycty": "OROVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959659998,
    "dropmaladd": "1735 ROBINSON ST",
    "dropmalcty": "OROVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959659998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305334620,
    "dropsitcph": 5305338206,
    "dropfax": 5305332914
  },
  {
    "dcode": "D",
    "dropkey": "PZ22362",
    "droptype": "D",
    "dropname": "OXNARD",
    "dropdeladd": "1961 N C ST",
    "dropdelcty": "OXNARD",
    "dropdelst": "CA",
    "dropdelzpp": 930369998,
    "dropphyadd": "1961 N C ST",
    "dropphycty": "OXNARD",
    "dropphyst": "CA",
    "dropphyzpp": 930369996,
    "dropmaladd": "1961 N C ST",
    "dropmalcty": "OXNARD",
    "dropmalst": "CA",
    "dropmalzpp": 930369998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8052787650,
    "dropsitcph": 8052787615,
    "dropfax": 8052787621
  },
  {
    "dcode": "D",
    "dropkey": "PZ22373",
    "droptype": "D",
    "dropname": "PACIFIC GROVE",
    "dropdeladd": "680 LIGHTHOUSE AVE",
    "dropdelcty": "PACIFIC GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 939509998,
    "dropphyadd": "680 LIGHTHOUSE AVE",
    "dropphycty": "PACIFIC GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 939509998,
    "dropmaladd": "680 LIGHTHOUSE AVE",
    "dropmalcty": "PACIFIC GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 939509998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8312645914,
    "dropsitcph": 8313732271,
    "dropfax": 8313734327
  },
  {
    "dcode": "D",
    "dropkey": "PZ22375",
    "droptype": "D",
    "dropname": "PACIFIC PALISADES",
    "dropdeladd": "15243 LA CRUZ DR",
    "dropdelcty": "PACIFIC PALISADES",
    "dropdelst": "CA",
    "dropdelzpp": 902729997,
    "dropphyadd": "15243 LA CRUZ DR",
    "dropphycty": "PACIFIC PALISADES",
    "dropphyst": "CA",
    "dropphyzpp": 902729997,
    "dropmaladd": "15243 LA CRUZ DR",
    "dropmalcty": "PACIFIC PALISADES",
    "dropmalst": "CA",
    "dropmalzpp": 902729997,
    "dropsitphn": 3104540956,
    "dropsitlph": 3104540956,
    "dropsitcph": 3104543475,
    "dropfax": 3102301145
  },
  {
    "dcode": "D",
    "dropkey": "PZ22378",
    "droptype": "D",
    "dropname": "PACIFICA",
    "dropdeladd": "50 W MANOR DR",
    "dropdelcty": "PACIFICA",
    "dropdelst": "CA",
    "dropdelzpp": 940441845,
    "dropphyadd": "50 W MANOR DR",
    "dropphycty": "PACIFICA",
    "dropphyst": "CA",
    "dropphyzpp": 940441845,
    "dropmaladd": "50 W MANOR DR",
    "dropmalcty": "PACIFICA",
    "dropmalst": "CA",
    "dropmalzpp": 940441845,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503550927,
    "dropsitcph": 6503551280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22379",
    "droptype": "D",
    "dropname": "PACOIMA",
    "dropdeladd": "13507 VAN NUYS BLVD",
    "dropdelcty": "PACOIMA",
    "dropdelst": "CA",
    "dropdelzpp": 913319998,
    "dropphyadd": "13507 VAN NUYS BLVD",
    "dropphycty": "PACOIMA",
    "dropphyst": "CA",
    "dropphyzpp": 913319998,
    "dropmaladd": "13507 VAN NUYS BLVD",
    "dropmalcty": "PACOIMA",
    "dropmalst": "CA",
    "dropmalzpp": 913319998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188964891,
    "dropsitcph": 8188964891,
    "dropfax": 8188344251
  },
  {
    "dcode": "D",
    "dropkey": "PZ22381",
    "droptype": "D",
    "dropname": "PAICINES",
    "dropdeladd": "12261 AIRLINE HWY",
    "dropdelcty": "PAICINES",
    "dropdelst": "CA",
    "dropdelzpp": 950439998,
    "dropphyadd": "12261 AIRLINE HWY",
    "dropphycty": "PAICINES",
    "dropphyst": "CA",
    "dropphyzpp": 950439998,
    "dropmaladd": "12261 AIRLINE HWY",
    "dropmalcty": "PAICINES",
    "dropmalst": "CA",
    "dropmalzpp": 950439998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316283304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22385",
    "droptype": "D",
    "dropname": "PALERMO",
    "dropdeladd": "7390 LINCOLN BLVD",
    "dropdelcty": "PALERMO",
    "dropdelst": "CA",
    "dropdelzpp": 959689998,
    "dropphyadd": "7390 LINCOLN BLVD",
    "dropphycty": "PALERMO",
    "dropphyst": "CA",
    "dropphyzpp": 959689998,
    "dropmaladd": "7390 LINCOLN BLVD",
    "dropmalcty": "PALERMO",
    "dropmalst": "CA",
    "dropmalzpp": 959689998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305339334,
    "dropsitcph": 5305339334,
    "dropfax": 9165330621
  },
  {
    "dcode": "D",
    "dropkey": "PZ22387",
    "droptype": "D",
    "dropname": "PALM DESERT",
    "dropdeladd": "74801 HOVLEY LN E",
    "dropdelcty": "PALM DESERT",
    "dropdelst": "CA",
    "dropdelzpp": 922609998,
    "dropphyadd": "74801 HOVLEY LN E",
    "dropphycty": "PALM DESERT",
    "dropphyst": "CA",
    "dropphyzpp": 922609998,
    "dropmaladd": "74801 HOVLEY LN E",
    "dropmalcty": "PALM DESERT",
    "dropmalst": "CA",
    "dropmalzpp": 922609998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7607733040,
    "dropsitcph": 7608379525,
    "dropfax": 7605689853
  },
  {
    "dcode": "D",
    "dropkey": "PZ22391",
    "droptype": "D",
    "dropname": "PALM SPRINGS",
    "dropdeladd": "333 N SUNRISE WAY",
    "dropdelcty": "PALM SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 922629998,
    "dropphyadd": "333 N SUNRISE WAY",
    "dropphycty": "PALM SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 922629998,
    "dropmaladd": "333 N SUNRISE WAY",
    "dropmalcty": "PALM SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 922629998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603258556,
    "dropsitcph": 7603224111,
    "dropfax": 7603252391
  },
  {
    "dcode": "D",
    "dropkey": "PZ22393",
    "droptype": "D",
    "dropname": "PALMDALE",
    "dropdeladd": "2220 E PALMDALE BLVD",
    "dropdelcty": "PALMDALE",
    "dropdelst": "CA",
    "dropdelzpp": 935506502,
    "dropphyadd": "2220 E PALMDALE BLVD",
    "dropphycty": "PALMDALE",
    "dropphyst": "CA",
    "dropphyzpp": 935506502,
    "dropmaladd": "2220 E PALMDALE BLVD",
    "dropmalcty": "PALMDALE",
    "dropmalst": "CA",
    "dropmalzpp": 935506502,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612721492,
    "dropsitcph": 6612721492,
    "dropfax": 6612671128
  },
  {
    "dcode": "D",
    "dropkey": "PZ22396",
    "droptype": "D",
    "dropname": "PALO ALTO",
    "dropdeladd": "2085 E BAYSHORE RD",
    "dropdelcty": "EAST PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943039998,
    "dropphyadd": "2085 E BAYSHORE RD",
    "dropphycty": "EAST PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943039998,
    "dropmaladd": "2085 E BAYSHORE RD",
    "dropmalcty": "EAST PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943039998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6502725262,
    "dropsitcph": 6503211423,
    "dropfax": 6503212622
  },
  {
    "dcode": "D",
    "dropkey": "PZ22397",
    "droptype": "D",
    "dropname": "PALO CEDRO",
    "dropdeladd": "9434 DESCHUTES RD",
    "dropdelcty": "PALO CEDRO",
    "dropdelst": "CA",
    "dropdelzpp": 960739998,
    "dropphyadd": "9434 DESCHUTES RD",
    "dropphycty": "PALO CEDRO",
    "dropphyst": "CA",
    "dropphyzpp": 960739998,
    "dropmaladd": "9434 DESCHUTES RD",
    "dropmalcty": "PALO CEDRO",
    "dropmalst": "CA",
    "dropmalzpp": 960739998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305474927,
    "dropsitcph": 5305474927,
    "dropfax": 5305474685
  },
  {
    "dcode": "D",
    "dropkey": "PZ22398",
    "droptype": "D",
    "dropname": "PALO VERDE",
    "dropdeladd": "15 BEN HULSE HWY",
    "dropdelcty": "PALO VERDE",
    "dropdelst": "CA",
    "dropdelzpp": 922669800,
    "dropphyadd": "15 BEN HULSE HWY",
    "dropphycty": "PALO VERDE",
    "dropphyst": "CA",
    "dropphyzpp": 922669800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALO VERDE",
    "dropmalst": "CA",
    "dropmalzpp": 922669998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7608543191,
    "dropsitcph": 7608543191,
    "dropfax": 7608541062
  },
  {
    "dcode": "D",
    "dropkey": "PZ22399",
    "droptype": "D",
    "dropname": "PALOMAR MOUNTAIN",
    "dropdeladd": "33124 CANFIELD RD",
    "dropdelcty": "PALOMAR MOUNTAIN",
    "dropdelst": "CA",
    "dropdelzpp": 920600019,
    "dropphyadd": "33124 CANFIELD RD",
    "dropphycty": "PALOMAR MOUNTAIN",
    "dropphyst": "CA",
    "dropphyzpp": 920600019,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PALOMAR MOUNTAIN",
    "dropmalst": "CA",
    "dropmalzpp": 920609998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607423044,
    "dropsitcph": 7607423044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22404",
    "droptype": "D",
    "dropname": "PALOS VERDES PENINSULA",
    "dropdeladd": "955 DEEP VALLEY DR",
    "dropdelcty": "PALOS VERDES PENINSULA",
    "dropdelst": "CA",
    "dropdelzpp": 902749998,
    "dropphyadd": "955 DEEP VALLEY DR",
    "dropphycty": "PALOS VERDES PENINSULA",
    "dropphyst": "CA",
    "dropphyzpp": 902749998,
    "dropmaladd": "955 DEEP VALLEY DR",
    "dropmalcty": "PALOS VERDES PENINSULA",
    "dropmalst": "CA",
    "dropmalzpp": 902749998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3105412938,
    "dropsitcph": 3105410624,
    "dropfax": 3103772805
  },
  {
    "dcode": "D",
    "dropkey": "PZ22410",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "6469 CLARK RD",
    "dropdelcty": "PARADISE",
    "dropdelst": "CA",
    "dropdelzpp": 959699998,
    "dropphyadd": "6469 CLARK RD",
    "dropphycty": "PARADISE",
    "dropphyst": "CA",
    "dropphyzpp": 959699998,
    "dropmaladd": "6469 CLARK RD",
    "dropmalcty": "PARADISE",
    "dropmalst": "CA",
    "dropmalzpp": 959699998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308725150,
    "dropsitcph": 5308725150,
    "dropfax": 5308779045
  },
  {
    "dcode": "D",
    "dropkey": "PZ22416",
    "droptype": "D",
    "dropname": "PARAMOUNT",
    "dropdeladd": "7200 SOMERSET BLVD",
    "dropdelcty": "PARAMOUNT",
    "dropdelst": "CA",
    "dropdelzpp": 907239998,
    "dropphyadd": "7200 SOMERSET BLVD",
    "dropphycty": "PARAMOUNT",
    "dropphyst": "CA",
    "dropphyzpp": 907239998,
    "dropmaladd": "7200 SOMERSET BLVD",
    "dropmalcty": "PARAMOUNT",
    "dropmalst": "CA",
    "dropmalzpp": 907239998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5626341601,
    "dropsitcph": 5626341601,
    "dropfax": 5626349187
  },
  {
    "dcode": "D",
    "dropkey": "PZ22420",
    "droptype": "D",
    "dropname": "PARKER DAM",
    "dropdeladd": "102 CALIFORNIA ST",
    "dropdelcty": "PARKER DAM",
    "dropdelst": "CA",
    "dropdelzpp": 922679800,
    "dropphyadd": "102 CALIFORNIA ST",
    "dropphycty": "PARKER DAM",
    "dropphyst": "CA",
    "dropphyzpp": 922679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARKER DAM",
    "dropmalst": "CA",
    "dropmalzpp": 922679998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7606630165,
    "dropsitcph": 7606630165,
    "dropfax": 7606630116
  },
  {
    "dcode": "D",
    "dropkey": "PZ22425",
    "droptype": "D",
    "dropname": "PARLIER",
    "dropdeladd": "850 E PARLIER AVE",
    "dropdelcty": "PARLIER",
    "dropdelst": "CA",
    "dropdelzpp": 936489998,
    "dropphyadd": "850 E PARLIER AVE",
    "dropphycty": "PARLIER",
    "dropphyst": "CA",
    "dropphyzpp": 936489998,
    "dropmaladd": "850 E PARLIER AVE",
    "dropmalcty": "PARLIER",
    "dropmalst": "CA",
    "dropmalzpp": 936489998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5596468109,
    "dropsitcph": 5596468048,
    "dropfax": 5596467430
  },
  {
    "dcode": "D",
    "dropkey": "PZ22427",
    "droptype": "D",
    "dropname": "PASADENA",
    "dropdeladd": "600 LINCOLN AVE",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911099998,
    "dropphyadd": "600 LINCOLN AVE",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911099998,
    "dropmaladd": "600 LINCOLN AVE",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911099998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6263047112,
    "dropsitcph": 6263047164,
    "dropfax": 6263047114
  },
  {
    "dcode": "D",
    "dropkey": "PZ22428",
    "droptype": "D",
    "dropname": "PASKENTA",
    "dropdeladd": "13180 TOOMES CAMP RD",
    "dropdelcty": "PASKENTA",
    "dropdelst": "CA",
    "dropdelzpp": 960749998,
    "dropphyadd": "13180 TOOMES CAMP RD",
    "dropphycty": "PASKENTA",
    "dropphyst": "CA",
    "dropphyzpp": 960749998,
    "dropmaladd": "13180 TOOMES CAMP RD",
    "dropmalcty": "PASKENTA",
    "dropmalst": "CA",
    "dropmalzpp": 960749998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308335464,
    "dropsitcph": 5308335464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22429",
    "droptype": "D",
    "dropname": "PASO ROBLES",
    "dropdeladd": "800 6TH ST",
    "dropdelcty": "PASO ROBLES",
    "dropdelst": "CA",
    "dropdelzpp": 934462884,
    "dropphyadd": "800 6TH ST",
    "dropphycty": "PASO ROBLES",
    "dropphyst": "CA",
    "dropphyzpp": 934462884,
    "dropmaladd": "800 6TH ST",
    "dropmalcty": "PASO ROBLES",
    "dropmalst": "CA",
    "dropmalzpp": 934462884,
    "dropsitphn": 6617757808,
    "dropsitlph": 8052378342,
    "dropsitcph": 8052378342,
    "dropfax": 8052381631
  },
  {
    "dcode": "D",
    "dropkey": "PZ22430",
    "droptype": "D",
    "dropname": "PATTERSON",
    "dropdeladd": "50 N SALADO AVE",
    "dropdelcty": "PATTERSON",
    "dropdelst": "CA",
    "dropdelzpp": 953639998,
    "dropphyadd": "50 N SALADO AVE",
    "dropphycty": "PATTERSON",
    "dropphyst": "CA",
    "dropphyzpp": 953639998,
    "dropmaladd": "50 N SALADO AVE",
    "dropmalcty": "PATTERSON",
    "dropmalst": "CA",
    "dropmalzpp": 953639998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098927647,
    "dropsitcph": 2098928852,
    "dropfax": 2098926612
  },
  {
    "dcode": "D",
    "dropkey": "PZ22431",
    "droptype": "D",
    "dropname": "PATTON",
    "dropdeladd": "2592 E HIGHLAND AVE",
    "dropdelcty": "PATTON",
    "dropdelst": "CA",
    "dropdelzpp": 923690016,
    "dropphyadd": "2592 E HIGHLAND AVE",
    "dropphycty": "PATTON",
    "dropphyst": "CA",
    "dropphyzpp": 923690016,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PATTON",
    "dropmalst": "CA",
    "dropmalzpp": 923699998,
    "dropsitphn": 9093354457,
    "dropsitlph": 9098627325,
    "dropsitcph": 9098631547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22433",
    "droptype": "D",
    "dropname": "PAUMA VALLEY",
    "dropdeladd": "16160 HIGHWAY 76",
    "dropdelcty": "PAUMA VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 920619998,
    "dropphyadd": "16160 HIGHWAY 76",
    "dropphycty": "PAUMA VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 920619998,
    "dropmaladd": "16160 HIGHWAY 76",
    "dropmalcty": "PAUMA VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 920619998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607423670,
    "dropsitcph": 7607423670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22437",
    "droptype": "D",
    "dropname": "PEARBLOSSOM",
    "dropdeladd": "12302 PEARBLOSSOM HWY",
    "dropdelcty": "PEARBLOSSOM",
    "dropdelst": "CA",
    "dropdelzpp": 935539998,
    "dropphyadd": "12302 PEARBLOSSOM HWY",
    "dropphycty": "PEARBLOSSOM",
    "dropphyst": "CA",
    "dropphyzpp": 935539998,
    "dropmaladd": "12302 PEARBLOSSOM HWY",
    "dropmalcty": "PEARBLOSSOM",
    "dropmalst": "CA",
    "dropmalzpp": 935539998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619440176,
    "dropsitcph": 6619440176,
    "dropfax": 6619440206
  },
  {
    "dcode": "D",
    "dropkey": "PZ22440",
    "droptype": "D",
    "dropname": "PEBBLE BEACH",
    "dropdeladd": "1491 CYPRESS DR",
    "dropdelcty": "PEBBLE BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 939539800,
    "dropphyadd": "1491 CYPRESS DR",
    "dropphycty": "PEBBLE BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 939539800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PEBBLE BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 939539998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316229509,
    "dropsitcph": 8316243016,
    "dropfax": 8316248768
  },
  {
    "dcode": "D",
    "dropkey": "PZ22449",
    "droptype": "D",
    "dropname": "PENNGROVE",
    "dropdeladd": "11041 MAIN ST",
    "dropdelcty": "PENNGROVE",
    "dropdelst": "CA",
    "dropdelzpp": 949518756,
    "dropphyadd": "11041 MAIN ST",
    "dropphycty": "PENNGROVE",
    "dropphyst": "CA",
    "dropphyzpp": 949518756,
    "dropmaladd": "11041 MAIN ST",
    "dropmalcty": "PENNGROVE",
    "dropmalst": "CA",
    "dropmalzpp": 949518756,
    "dropsitphn": 7077955783,
    "dropsitlph": 7077955783,
    "dropsitcph": 7077955783,
    "dropfax": 7077950826
  },
  {
    "dcode": "D",
    "dropkey": "PZ22451",
    "droptype": "D",
    "dropname": "PENRYN",
    "dropdeladd": "2205 RIPPEY RD",
    "dropdelcty": "PENRYN",
    "dropdelst": "CA",
    "dropdelzpp": 956639998,
    "dropphyadd": "2205 RIPPEY RD",
    "dropphycty": "PENRYN",
    "dropphyst": "CA",
    "dropphyzpp": 956639998,
    "dropmaladd": "2205 RIPPEY RD",
    "dropmalcty": "PENRYN",
    "dropmalst": "CA",
    "dropmalzpp": 956639998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166633663,
    "dropsitcph": 9166633663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22455",
    "droptype": "D",
    "dropname": "PERRIS",
    "dropdeladd": "778 S REDLANDS AVE",
    "dropdelcty": "PERRIS",
    "dropdelst": "CA",
    "dropdelzpp": 925709991,
    "dropphyadd": "778 S REDLANDS AVE",
    "dropphycty": "PERRIS",
    "dropphyst": "CA",
    "dropphyzpp": 925709991,
    "dropmaladd": "778 S REDLANDS AVE",
    "dropmalcty": "PERRIS",
    "dropmalst": "CA",
    "dropmalzpp": 925709991,
    "dropsitphn": 9093354694,
    "dropsitlph": 9519435070,
    "dropsitcph": 9519433535,
    "dropfax": 9519432838
  },
  {
    "dcode": "D",
    "dropkey": "PZ22456",
    "droptype": "D",
    "dropname": "PESCADERO",
    "dropdeladd": "2020 PESCADERO CREEK RD",
    "dropdelcty": "PESCADERO",
    "dropdelst": "CA",
    "dropdelzpp": 940609701,
    "dropphyadd": "2020 PESCADERO CREEK RD",
    "dropphycty": "PESCADERO",
    "dropphyst": "CA",
    "dropphyzpp": 940609701,
    "dropmaladd": "2020 PESCADERO CREEK RD",
    "dropmalcty": "PESCADERO",
    "dropmalst": "CA",
    "dropmalzpp": 940609701,
    "dropsitphn": 4155505045,
    "dropsitlph": 6508790214,
    "dropsitcph": 6508790214,
    "dropfax": 6508791532
  },
  {
    "dcode": "D",
    "dropkey": "PZ22457",
    "droptype": "D",
    "dropname": "PETALUMA",
    "dropdeladd": "120 4TH ST",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949529998,
    "dropphyadd": "120 4TH ST",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949529998,
    "dropmaladd": "120 4TH ST",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949529998,
    "dropsitphn": 7077695354,
    "dropsitlph": 7077695357,
    "dropsitcph": 7077695352,
    "dropfax": 7077623303
  },
  {
    "dcode": "D",
    "dropkey": "PZ22458",
    "droptype": "D",
    "dropname": "PETROLIA",
    "dropdeladd": "89 SHERMAN ST",
    "dropdelcty": "PETROLIA",
    "dropdelst": "CA",
    "dropdelzpp": 955589535,
    "dropphyadd": "89 SHERMAN ST",
    "dropphycty": "PETROLIA",
    "dropphyst": "CA",
    "dropphyzpp": 955589535,
    "dropmaladd": "89 SHERMAN ST",
    "dropmalcty": "PETROLIA",
    "dropmalst": "CA",
    "dropmalzpp": 955589535,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076293345,
    "dropfax": 7076293345
  },
  {
    "dcode": "D",
    "dropkey": "PZ22459",
    "droptype": "D",
    "dropname": "PHELAN",
    "dropdeladd": "9782 CLOVIS RD",
    "dropdelcty": "PHELAN",
    "dropdelst": "CA",
    "dropdelzpp": 923719998,
    "dropphyadd": "9782 CLOVIS RD",
    "dropphycty": "PHELAN",
    "dropphyst": "CA",
    "dropphyzpp": 923719998,
    "dropmaladd": "9782 CLOVIS RD",
    "dropmalcty": "PHELAN",
    "dropmalst": "CA",
    "dropmalzpp": 923719998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7608682640,
    "dropsitcph": 7608680797,
    "dropfax": 7608680535
  },
  {
    "dcode": "D",
    "dropkey": "PZ22461",
    "droptype": "D",
    "dropname": "PHILLIPSVILLE",
    "dropdeladd": "2788 HIGHWAY 254",
    "dropdelcty": "PHILLIPSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 955599998,
    "dropphyadd": "2788 HIGHWAY 254",
    "dropphycty": "PHILLIPSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 955599998,
    "dropmaladd": "2788 HIGHWAY 254",
    "dropmalcty": "PHILLIPSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 955599998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079433591,
    "dropfax": 7079433591
  },
  {
    "dcode": "D",
    "dropkey": "PZ22464",
    "droptype": "D",
    "dropname": "PHILO",
    "dropdeladd": "8651 HIGHWAY 128",
    "dropdelcty": "PHILO",
    "dropdelst": "CA",
    "dropdelzpp": 954669458,
    "dropphyadd": "8651 HIGHWAY 128",
    "dropphycty": "PHILO",
    "dropphyst": "CA",
    "dropphyzpp": 954669458,
    "dropmaladd": "8651 HIGHWAY 128",
    "dropmalcty": "PHILO",
    "dropmalst": "CA",
    "dropmalzpp": 954669458,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078952881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22469",
    "droptype": "D",
    "dropname": "PICO RIVERA",
    "dropdeladd": "6320 PASSONS BLVD",
    "dropdelcty": "PICO RIVERA",
    "dropdelst": "CA",
    "dropdelzpp": 906609998,
    "dropphyadd": "6320 PASSONS BLVD",
    "dropphycty": "PICO RIVERA",
    "dropphyst": "CA",
    "dropphyzpp": 906609998,
    "dropmaladd": "6320 PASSONS BLVD",
    "dropmalcty": "PICO RIVERA",
    "dropmalst": "CA",
    "dropmalzpp": 906609998,
    "dropsitphn": 5629420168,
    "dropsitlph": 5629493022,
    "dropsitcph": 5629420168,
    "dropfax": 5629422918
  },
  {
    "dcode": "D",
    "dropkey": "PZ22472",
    "droptype": "D",
    "dropname": "PIEDRA",
    "dropdeladd": "26284 PINE FLAT RD",
    "dropdelcty": "PIEDRA",
    "dropdelst": "CA",
    "dropdelzpp": 936499998,
    "dropphyadd": "26284 PINE FLAT RD",
    "dropphycty": "PIEDRA",
    "dropphyst": "CA",
    "dropphyzpp": 936499998,
    "dropmaladd": "26284 PINE FLAT RD",
    "dropmalcty": "PIEDRA",
    "dropmalst": "CA",
    "dropmalzpp": 936499998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5597873330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22476",
    "droptype": "D",
    "dropname": "PILOT HILL",
    "dropdeladd": "4460 STATE HIGHWAY 49",
    "dropdelcty": "PILOT HILL",
    "dropdelst": "CA",
    "dropdelzpp": 956649998,
    "dropphyadd": "4460 STATE HIGHWAY 49",
    "dropphycty": "PILOT HILL",
    "dropphyst": "CA",
    "dropphyzpp": 956649998,
    "dropmaladd": "4460 STATE HIGHWAY 49",
    "dropmalcty": "PILOT HILL",
    "dropmalst": "CA",
    "dropmalzpp": 956649998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308236362,
    "dropsitcph": 5308236362,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22482",
    "droptype": "D",
    "dropname": "PINE GROVE",
    "dropdeladd": "20116 STATE HIGHWAY 88",
    "dropdelcty": "PINE GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 956659998,
    "dropphyadd": "20116 STATE HIGHWAY 88",
    "dropphycty": "PINE GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 956659998,
    "dropmaladd": "20116 STATE HIGHWAY 88",
    "dropmalcty": "PINE GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 956659998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092967244,
    "dropsitcph": 2092965831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22486",
    "droptype": "D",
    "dropname": "PINE VALLEY",
    "dropdeladd": "28858 OLD HIGHWAY 80",
    "dropdelcty": "PINE VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 919629998,
    "dropphyadd": "28858 OLD HIGHWAY 80",
    "dropphycty": "PINE VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 919629998,
    "dropmaladd": "28858 OLD HIGHWAY 80",
    "dropmalcty": "PINE VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 919629998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194738680,
    "dropsitcph": 6194738680,
    "dropfax": 6194739841
  },
  {
    "dcode": "D",
    "dropkey": "PZ22487",
    "droptype": "D",
    "dropname": "PINECREST",
    "dropdeladd": "411 PINECREST LAKE RD",
    "dropdelcty": "PINECREST",
    "dropdelst": "CA",
    "dropdelzpp": 953649998,
    "dropphyadd": "411 PINECREST LAKE RD",
    "dropphycty": "PINECREST",
    "dropphyst": "CA",
    "dropphyzpp": 953649998,
    "dropmaladd": "411 PINECREST LAKE RD",
    "dropmalcty": "PINECREST",
    "dropmalst": "CA",
    "dropmalzpp": 953649998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099653545,
    "dropsitcph": 2099653545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22492",
    "droptype": "D",
    "dropname": "PINOLE",
    "dropdeladd": "2101 PEAR ST",
    "dropdelcty": "PINOLE",
    "dropdelst": "CA",
    "dropdelzpp": 945649998,
    "dropphyadd": "2101 PEAR ST",
    "dropphycty": "PINOLE",
    "dropphyst": "CA",
    "dropphyzpp": 945649998,
    "dropmaladd": "2101 PEAR ST",
    "dropmalcty": "PINOLE",
    "dropmalst": "CA",
    "dropmalzpp": 945649998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107413056,
    "dropsitcph": 5107413056,
    "dropfax": 5107413051
  },
  {
    "dcode": "D",
    "dropkey": "PZ22493",
    "droptype": "D",
    "dropname": "PINON HILLS",
    "dropdeladd": "10353 OASIS RD",
    "dropdelcty": "PINON HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 923729998,
    "dropphyadd": "10353 OASIS RD",
    "dropphycty": "PINON HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 923729998,
    "dropmaladd": "10353 OASIS RD",
    "dropmalcty": "PINON HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 923729998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7608683185,
    "dropsitcph": 7608683493,
    "dropfax": 7608680273
  },
  {
    "dcode": "D",
    "dropkey": "PZ22495",
    "droptype": "D",
    "dropname": "PIONEER",
    "dropdeladd": "24282 STATE HIGHWAY 88",
    "dropdelcty": "PIONEER",
    "dropdelst": "CA",
    "dropdelzpp": 956669998,
    "dropphyadd": "24282 STATE HIGHWAY 88",
    "dropphycty": "PIONEER",
    "dropphyst": "CA",
    "dropphyzpp": 956669998,
    "dropmaladd": "24282 STATE HIGHWAY 88",
    "dropmalcty": "PIONEER",
    "dropmalst": "CA",
    "dropmalzpp": 956669998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092953976,
    "dropsitcph": 2092957490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22497",
    "droptype": "D",
    "dropname": "PIONEERTOWN",
    "dropdeladd": "53441 MANE ST",
    "dropdelcty": "PIONEERTOWN",
    "dropdelst": "CA",
    "dropdelzpp": 922680423,
    "dropphyadd": "53441 MANE ST",
    "dropphycty": "PIONEERTOWN",
    "dropphyst": "CA",
    "dropphyzpp": 922680423,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PIONEERTOWN",
    "dropmalst": "CA",
    "dropmalzpp": 922689998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603657543,
    "dropsitcph": 7603657543,
    "dropfax": 7603657583
  },
  {
    "dcode": "D",
    "dropkey": "PZ22498",
    "droptype": "D",
    "dropname": "PIRU",
    "dropdeladd": "652 N MAIN ST",
    "dropdelcty": "PIRU",
    "dropdelst": "CA",
    "dropdelzpp": 930409998,
    "dropphyadd": "652 N MAIN ST",
    "dropphycty": "PIRU",
    "dropphyst": "CA",
    "dropphyzpp": 930409998,
    "dropmaladd": "652 N MAIN ST",
    "dropmalcty": "PIRU",
    "dropmalst": "CA",
    "dropmalzpp": 930409998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055211172,
    "dropsitcph": 8055211172,
    "dropfax": 8059885604
  },
  {
    "dcode": "D",
    "dropkey": "PZ22499",
    "droptype": "D",
    "dropname": "PISMO BEACH",
    "dropdeladd": "100 CREST DR",
    "dropdelcty": "PISMO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 934499998,
    "dropphyadd": "100 CREST DR",
    "dropphycty": "PISMO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 934499998,
    "dropmaladd": "100 CREST DR",
    "dropmalcty": "PISMO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 934499998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054811365,
    "dropsitcph": 8054815971,
    "dropfax": 8054813473
  },
  {
    "dcode": "D",
    "dropkey": "PZ22501",
    "droptype": "D",
    "dropname": "PITTSBURG",
    "dropdeladd": "835 RAILROAD AVE",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 945659998,
    "dropphyadd": "835 RAILROAD AVE",
    "dropphycty": "PITTSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 945659998,
    "dropmaladd": "835 RAILROAD AVE",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 945659998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254324079,
    "dropsitcph": 9254322741,
    "dropfax": 9254329643
  },
  {
    "dcode": "D",
    "dropkey": "PZ22503",
    "droptype": "D",
    "dropname": "PIXLEY",
    "dropdeladd": "570 S MAIN ST",
    "dropdelcty": "PIXLEY",
    "dropdelst": "CA",
    "dropdelzpp": 932569998,
    "dropphyadd": "570 S MAIN ST",
    "dropphycty": "PIXLEY",
    "dropphyst": "CA",
    "dropphyzpp": 932569998,
    "dropmaladd": "570 S MAIN ST",
    "dropmalcty": "PIXLEY",
    "dropmalst": "CA",
    "dropmalzpp": 932569998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597573830,
    "dropsitcph": 5597573830,
    "dropfax": 5597573891
  },
  {
    "dcode": "D",
    "dropkey": "PZ22504",
    "droptype": "D",
    "dropname": "PLACENTIA",
    "dropdeladd": "1400 N KRAEMER BLVD",
    "dropdelcty": "PLACENTIA",
    "dropdelst": "CA",
    "dropdelzpp": 928719998,
    "dropphyadd": "1400 N KRAEMER BLVD",
    "dropphycty": "PLACENTIA",
    "dropphyst": "CA",
    "dropphyzpp": 928719998,
    "dropmaladd": "1400 N KRAEMER BLVD",
    "dropmalcty": "PLACENTIA",
    "dropmalst": "CA",
    "dropmalzpp": 928719998,
    "dropsitphn": 7149931163,
    "dropsitlph": 7149930350,
    "dropsitcph": 7149931163,
    "dropfax": 7149968246
  },
  {
    "dcode": "D",
    "dropkey": "PZ22505",
    "droptype": "D",
    "dropname": "PLACERVILLE",
    "dropdeladd": "3045 SACRAMENTO ST",
    "dropdelcty": "PLACERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956679998,
    "dropphyadd": "3045 SACRAMENTO ST",
    "dropphycty": "PLACERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956679998,
    "dropmaladd": "3045 SACRAMENTO ST",
    "dropmalcty": "PLACERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956679998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306225174,
    "dropsitcph": 5306225174,
    "dropfax": 5306221831
  },
  {
    "dcode": "D",
    "dropkey": "PZ22506",
    "droptype": "D",
    "dropname": "PLANADA",
    "dropdeladd": "9249 E BROADWAY ST",
    "dropdelcty": "PLANADA",
    "dropdelst": "CA",
    "dropdelzpp": 953659998,
    "dropphyadd": "9249 E BROADWAY ST",
    "dropphycty": "PLANADA",
    "dropphyst": "CA",
    "dropphyzpp": 953659998,
    "dropmaladd": "9249 E BROADWAY ST",
    "dropmalcty": "PLANADA",
    "dropmalst": "CA",
    "dropmalzpp": 953659998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093820051,
    "dropsitcph": 2093820051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22509",
    "droptype": "D",
    "dropname": "PLATINA",
    "dropdeladd": "4554 STATE HIGHWAY 36 W",
    "dropdelcty": "PLATINA",
    "dropdelst": "CA",
    "dropdelzpp": 960769998,
    "dropphyadd": "4554 STATE HIGHWAY 36 W",
    "dropphycty": "PLATINA",
    "dropphyst": "CA",
    "dropphyzpp": 960769998,
    "dropmaladd": "4554 STATE HIGHWAY 36 W",
    "dropmalcty": "PLATINA",
    "dropmalst": "CA",
    "dropmalzpp": 960769998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303524555,
    "dropsitcph": 5303524555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22519",
    "droptype": "D",
    "dropname": "PLEASANT GROVE",
    "dropdeladd": "3126 HOWSLEY RD",
    "dropdelcty": "PLEASANT GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 956689998,
    "dropphyadd": "3126 HOWSLEY RD",
    "dropphycty": "PLEASANT GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 956689998,
    "dropmaladd": "3126 HOWSLEY RD",
    "dropmalcty": "PLEASANT GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 956689998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166553903,
    "dropsitcph": 9166553903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22523",
    "droptype": "D",
    "dropname": "PLEASANTON",
    "dropdeladd": "4300 BLACK AVE",
    "dropdelcty": "PLEASANTON",
    "dropdelst": "CA",
    "dropdelzpp": 945669998,
    "dropphyadd": "4300 BLACK AVE",
    "dropphycty": "PLEASANTON",
    "dropphyst": "CA",
    "dropphyzpp": 945669998,
    "dropmaladd": "4300 BLACK AVE",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "CA",
    "dropmalzpp": 945669998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9258463204,
    "dropsitcph": 9258463204,
    "dropfax": 9254621458
  },
  {
    "dcode": "D",
    "dropkey": "PZ22524",
    "droptype": "D",
    "dropname": "PLYMOUTH",
    "dropdeladd": "9477 MAIN ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "CA",
    "dropdelzpp": 956698402,
    "dropphyadd": "9477 MAIN ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "CA",
    "dropphyzpp": 956698402,
    "dropmaladd": "9477 MAIN ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "CA",
    "dropmalzpp": 956698402,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092453472,
    "dropsitcph": 2092453472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22525",
    "droptype": "D",
    "dropname": "POINT ARENA",
    "dropdeladd": "264 MAIN ST",
    "dropdelcty": "POINT ARENA",
    "dropdelst": "CA",
    "dropdelzpp": 954689902,
    "dropphyadd": "264 MAIN ST",
    "dropphycty": "POINT ARENA",
    "dropphyst": "CA",
    "dropphyzpp": 954689902,
    "dropmaladd": "264 MAIN ST",
    "dropmalcty": "POINT ARENA",
    "dropmalst": "CA",
    "dropmalzpp": 954689902,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078822515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22532",
    "droptype": "D",
    "dropname": "POINT REYES STATION",
    "dropdeladd": "11260 HIGHWAY 1",
    "dropdelcty": "POINT REYES STATION",
    "dropdelst": "CA",
    "dropdelzpp": 949569748,
    "dropphyadd": "11260 HIGHWAY 1",
    "dropphycty": "POINT REYES STATION",
    "dropphyst": "CA",
    "dropphyzpp": 949569748,
    "dropmaladd": "11260 HIGHWAY 1",
    "dropmalcty": "POINT REYES STATION",
    "dropmalst": "CA",
    "dropmalzpp": 949569748,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4156631305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22536",
    "droptype": "D",
    "dropname": "POLLOCK PINES",
    "dropdeladd": "2669 SANDERS DR",
    "dropdelcty": "POLLOCK PINES",
    "dropdelst": "CA",
    "dropdelzpp": 957269998,
    "dropphyadd": "2669 SANDERS DR",
    "dropphycty": "POLLOCK PINES",
    "dropphyst": "CA",
    "dropphyzpp": 957269998,
    "dropmaladd": "2669 SANDERS DR",
    "dropmalcty": "POLLOCK PINES",
    "dropmalst": "CA",
    "dropmalzpp": 957269998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306447167,
    "dropsitcph": 5306446320,
    "dropfax": 5306448637
  },
  {
    "dcode": "D",
    "dropkey": "PZ22537",
    "droptype": "D",
    "dropname": "POMONA",
    "dropdeladd": "580 W MONTEREY AVE",
    "dropdelcty": "POMONA",
    "dropdelst": "CA",
    "dropdelzpp": 917699998,
    "dropphyadd": "580 W MONTEREY AVE",
    "dropphycty": "POMONA",
    "dropphyst": "CA",
    "dropphyzpp": 917699998,
    "dropmaladd": "580 W MONTEREY AVE",
    "dropmalcty": "POMONA",
    "dropmalst": "CA",
    "dropmalzpp": 917699998,
    "dropsitphn": 9098651267,
    "dropsitlph": 9096233346,
    "dropsitcph": 9098651267,
    "dropfax": 9096231952
  },
  {
    "dcode": "D",
    "dropkey": "PZ22539",
    "droptype": "D",
    "dropname": "POPE VALLEY",
    "dropdeladd": "5850 POPE VALLEY RD",
    "dropdelcty": "POPE VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 945679800,
    "dropphyadd": "5850 POPE VALLEY RD",
    "dropphycty": "POPE VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 945679800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "POPE VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 945679998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079653701,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "PZ22542",
    "droptype": "D",
    "dropname": "PORT COSTA",
    "dropdeladd": "3 CANYON LAKE DR",
    "dropdelcty": "PORT COSTA",
    "dropdelst": "CA",
    "dropdelzpp": 945699800,
    "dropphyadd": "3 CANYON LAKE DR",
    "dropphycty": "PORT COSTA",
    "dropphyst": "CA",
    "dropphyzpp": 945699800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PORT COSTA",
    "dropmalst": "CA",
    "dropmalzpp": 945699998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 5107872980,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "PZ22543",
    "droptype": "D",
    "dropname": "PORT HUENEME",
    "dropdeladd": "560 E PLEASANT VALLEY RD",
    "dropdelcty": "PORT HUENEME",
    "dropdelst": "CA",
    "dropdelzpp": 930419998,
    "dropphyadd": "560 E PLEASANT VALLEY RD",
    "dropphycty": "PORT HUENEME",
    "dropphyst": "CA",
    "dropphyzpp": 930419998,
    "dropmaladd": "560 E PLEASANT VALLEY RD",
    "dropmalcty": "PORT HUENEME",
    "dropmalst": "CA",
    "dropmalzpp": 930419998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054885851,
    "dropsitcph": 8059864661,
    "dropfax": 8054880451
  },
  {
    "dcode": "D",
    "dropkey": "PZ22547",
    "droptype": "D",
    "dropname": "PORTERVILLE",
    "dropdeladd": "65 W MILL AVE",
    "dropdelcty": "PORTERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932579998,
    "dropphyadd": "65 W MILL AVE",
    "dropphycty": "PORTERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932579998,
    "dropmaladd": "65 W MILL AVE",
    "dropmalcty": "PORTERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932579998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597844685,
    "dropsitcph": 5597844685,
    "dropfax": 5597843439
  },
  {
    "dcode": "D",
    "dropkey": "PZ22548",
    "droptype": "D",
    "dropname": "PORTOLA",
    "dropdeladd": "440 S GULLING ST",
    "dropdelcty": "PORTOLA",
    "dropdelst": "CA",
    "dropdelzpp": 961229995,
    "dropphyadd": "440 S GULLING ST",
    "dropphycty": "PORTOLA",
    "dropphyst": "CA",
    "dropphyzpp": 961229995,
    "dropmaladd": "440 S GULLING ST",
    "dropmalcty": "PORTOLA",
    "dropmalst": "CA",
    "dropmalzpp": 961229998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308324202,
    "dropfax": 5308320817
  },
  {
    "dcode": "D",
    "dropkey": "PZ22553",
    "droptype": "D",
    "dropname": "POSEY",
    "dropdeladd": "42575 OLD STAGE RD",
    "dropdelcty": "POSEY",
    "dropdelst": "CA",
    "dropdelzpp": 932609998,
    "dropphyadd": "42575 OLD STAGE RD",
    "dropphycty": "POSEY",
    "dropphyst": "CA",
    "dropphyzpp": 932609998,
    "dropmaladd": "42575 OLD STAGE RD",
    "dropmalcty": "POSEY",
    "dropmalst": "CA",
    "dropmalzpp": 932609998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615368336,
    "dropsitcph": 6615368336,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22556",
    "droptype": "D",
    "dropname": "POTRERO",
    "dropdeladd": "25050 HIGHWAY 94",
    "dropdelcty": "POTRERO",
    "dropdelst": "CA",
    "dropdelzpp": 919639998,
    "dropphyadd": "25050 HIGHWAY 94",
    "dropphycty": "POTRERO",
    "dropphyst": "CA",
    "dropphyzpp": 919639998,
    "dropmaladd": "25050 HIGHWAY 94",
    "dropmalcty": "POTRERO",
    "dropmalst": "CA",
    "dropmalzpp": 919639998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194785604,
    "dropsitcph": 6194785604,
    "dropfax": 6194785604
  },
  {
    "dcode": "D",
    "dropkey": "PZ22557",
    "droptype": "D",
    "dropname": "POTTER VALLEY",
    "dropdeladd": "10210 MAIN ST",
    "dropdelcty": "POTTER VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 954699900,
    "dropphyadd": "10210 MAIN ST",
    "dropphycty": "POTTER VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 954699900,
    "dropmaladd": "10210 MAIN ST",
    "dropmalcty": "POTTER VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 954699900,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077431002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22559",
    "droptype": "D",
    "dropname": "POWAY",
    "dropdeladd": "13308 MIDLAND RD",
    "dropdelcty": "POWAY",
    "dropdelst": "CA",
    "dropdelzpp": 920649998,
    "dropphyadd": "13308 MIDLAND RD",
    "dropphycty": "POWAY",
    "dropphyst": "CA",
    "dropphyzpp": 920649998,
    "dropmaladd": "13308 MIDLAND RD",
    "dropmalcty": "POWAY",
    "dropmalst": "CA",
    "dropmalzpp": 920649998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8587485216,
    "dropsitcph": 8587483425,
    "dropfax": 8587483798
  },
  {
    "dcode": "D",
    "dropkey": "PZ22561",
    "droptype": "D",
    "dropname": "PRATHER",
    "dropdeladd": "29460 AUBERRY RD",
    "dropdelcty": "PRATHER",
    "dropdelst": "CA",
    "dropdelzpp": 936519998,
    "dropphyadd": "29460 AUBERRY RD",
    "dropphycty": "PRATHER",
    "dropphyst": "CA",
    "dropphyzpp": 936519998,
    "dropmaladd": "29460 AUBERRY RD",
    "dropmalcty": "PRATHER",
    "dropmalst": "CA",
    "dropmalzpp": 936519998,
    "dropsitphn": 5592585131,
    "dropsitlph": 5592585128,
    "dropsitcph": 5592585149,
    "dropfax": 5598554366
  },
  {
    "dcode": "D",
    "dropkey": "PZ22572",
    "droptype": "D",
    "dropname": "PRINCETON",
    "dropdeladd": "149 COMMERCIAL ST",
    "dropdelcty": "PRINCETON",
    "dropdelst": "CA",
    "dropdelzpp": 959709998,
    "dropphyadd": "149 COMMERCIAL ST",
    "dropphycty": "PRINCETON",
    "dropphyst": "CA",
    "dropphyzpp": 959709998,
    "dropmaladd": "149 COMMERCIAL ST",
    "dropmalcty": "PRINCETON",
    "dropmalst": "CA",
    "dropmalzpp": 959709998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304392252,
    "dropsitcph": 5304392252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22574",
    "droptype": "D",
    "dropname": "PROBERTA",
    "dropdeladd": "9973 STATE HIGHWAY 99W",
    "dropdelcty": "PROBERTA",
    "dropdelst": "CA",
    "dropdelzpp": 960789998,
    "dropphyadd": "9973 STATE HIGHWAY 99W",
    "dropphycty": "PROBERTA",
    "dropphyst": "CA",
    "dropphyzpp": 960789998,
    "dropmaladd": "9973 STATE HIGHWAY 99W",
    "dropmalcty": "PROBERTA",
    "dropmalst": "CA",
    "dropmalzpp": 960789998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305276382,
    "dropsitcph": 5305276382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22588",
    "droptype": "D",
    "dropname": "QUINCY",
    "dropdeladd": "222 LAWRENCE ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "CA",
    "dropdelzpp": 959719998,
    "dropphyadd": "222 LAWRENCE ST",
    "dropphycty": "QUINCY",
    "dropphyst": "CA",
    "dropphyzpp": 959719998,
    "dropmaladd": "222 LAWRENCE ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "CA",
    "dropmalzpp": 959719998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302833912,
    "dropsitcph": 5302833912,
    "dropfax": 5302830849
  },
  {
    "dcode": "D",
    "dropkey": "PZ22590",
    "droptype": "D",
    "dropname": "RACKERBY",
    "dropdeladd": "7417 LA PORTE RD",
    "dropdelcty": "RACKERBY",
    "dropdelst": "CA",
    "dropdelzpp": 959729998,
    "dropphyadd": "7417 LA PORTE RD",
    "dropphycty": "RACKERBY",
    "dropphyst": "CA",
    "dropphyzpp": 959729998,
    "dropmaladd": "7417 LA PORTE RD",
    "dropmalcty": "RACKERBY",
    "dropmalst": "CA",
    "dropmalzpp": 959729998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306792648,
    "dropsitcph": 5306792648,
    "dropfax": 5306791819
  },
  {
    "dcode": "D",
    "dropkey": "PZ22592",
    "droptype": "D",
    "dropname": "RAIL ROAD FLAT",
    "dropdeladd": "313B RAIL ROAD FLAT RD",
    "dropdelcty": "RAIL ROAD FLAT",
    "dropdelst": "CA",
    "dropdelzpp": 952489998,
    "dropphyadd": "313B RAIL ROAD FLAT RD",
    "dropphycty": "RAIL ROAD FLAT",
    "dropphyst": "CA",
    "dropphyzpp": 952489998,
    "dropmaladd": "313B RAIL ROAD FLAT RD",
    "dropmalcty": "RAIL ROAD FLAT",
    "dropmalst": "CA",
    "dropmalzpp": 952489998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092934302,
    "dropsitcph": 2092934302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22594",
    "droptype": "D",
    "dropname": "RAISIN CITY",
    "dropdeladd": "9221 S ORMUS AVE",
    "dropdelcty": "RAISIN CITY",
    "dropdelst": "CA",
    "dropdelzpp": 936529998,
    "dropphyadd": "9221 S ORMUS AVE",
    "dropphycty": "RAISIN CITY",
    "dropphyst": "CA",
    "dropphyzpp": 936529998,
    "dropmaladd": "9221 S ORMUS AVE",
    "dropmalcty": "RAISIN CITY",
    "dropmalst": "CA",
    "dropmalzpp": 936529998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5592647743,
    "dropfax": 5594410952
  },
  {
    "dcode": "D",
    "dropkey": "PZ22597",
    "droptype": "D",
    "dropname": "RAMONA",
    "dropdeladd": "1444 MAIN ST",
    "dropdelcty": "RAMONA",
    "dropdelst": "CA",
    "dropdelzpp": 920659998,
    "dropphyadd": "1444 MAIN ST",
    "dropphycty": "RAMONA",
    "dropphyst": "CA",
    "dropphyzpp": 920659998,
    "dropmaladd": "1444 MAIN ST",
    "dropmalcty": "RAMONA",
    "dropmalst": "CA",
    "dropmalzpp": 920659998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607890208,
    "dropsitcph": 7607893118,
    "dropfax": 7607891466
  },
  {
    "dcode": "D",
    "dropkey": "PZ22603",
    "droptype": "D",
    "dropname": "RANCHO CORDOVA",
    "dropdeladd": "10923 PROGRESS CT",
    "dropdelcty": "RANCHO CORDOVA",
    "dropdelst": "CA",
    "dropdelzpp": 956705667,
    "dropphyadd": "10923 PROGRESS CT",
    "dropphycty": "RANCHO CORDOVA",
    "dropphyst": "CA",
    "dropphyzpp": 956705667,
    "dropmaladd": "10923 PROGRESS CT",
    "dropmalcty": "RANCHO CORDOVA",
    "dropmalst": "CA",
    "dropmalzpp": 956705667,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165743063,
    "dropsitcph": 9165743008,
    "dropfax": 9166355743
  },
  {
    "dcode": "D",
    "dropkey": "PZ22604",
    "droptype": "D",
    "dropname": "RANCHO CUCAMONGA",
    "dropdeladd": "10950 ARROW RTE",
    "dropdelcty": "RANCHO CUCAMONGA",
    "dropdelst": "CA",
    "dropdelzpp": 917299998,
    "dropphyadd": "10950 ARROW RTE",
    "dropphycty": "RANCHO CUCAMONGA",
    "dropphyst": "CA",
    "dropphyzpp": 917299998,
    "dropmaladd": "10950 ARROW RTE",
    "dropmalcty": "RANCHO CUCAMONGA",
    "dropmalst": "CA",
    "dropmalzpp": 917299998,
    "dropsitphn": 9094832184,
    "dropsitlph": 9099419603,
    "dropsitcph": 9094832184,
    "dropfax": 9099873653
  },
  {
    "dcode": "D",
    "dropkey": "PZ22609",
    "droptype": "D",
    "dropname": "RANCHO MIRAGE",
    "dropdeladd": "42222 RANCHO LAS PALMAS DR",
    "dropdelcty": "RANCHO MIRAGE",
    "dropdelst": "CA",
    "dropdelzpp": 922704368,
    "dropphyadd": "42222 RANCHO LAS PALMAS DR",
    "dropphycty": "RANCHO MIRAGE",
    "dropphyst": "CA",
    "dropphyzpp": 922704368,
    "dropmaladd": "42222 RANCHO LAS PALMAS DR",
    "dropmalcty": "RANCHO MIRAGE",
    "dropmalst": "CA",
    "dropmalzpp": 922704368,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603460109,
    "dropsitcph": 7603467859,
    "dropfax": 7603467069
  },
  {
    "dcode": "D",
    "dropkey": "PZ22620",
    "droptype": "D",
    "dropname": "RANCHO SANTA FE",
    "dropdeladd": "16956 VIA DE SANTA FE",
    "dropdelcty": "RANCHO SANTA FE",
    "dropdelst": "CA",
    "dropdelzpp": 920914606,
    "dropphyadd": "16956 VIA DE SANTA FE",
    "dropphycty": "RANCHO SANTA FE",
    "dropphyst": "CA",
    "dropphyzpp": 920914606,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RANCHO SANTA FE",
    "dropmalst": "CA",
    "dropmalzpp": 920679998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8587561169,
    "dropsitcph": 8587561169,
    "dropfax": 8587565396
  },
  {
    "dcode": "D",
    "dropkey": "PZ22625",
    "droptype": "D",
    "dropname": "RAVENDALE",
    "dropdeladd": "519-300 SCHOOLHOUSE RD",
    "dropdelcty": "RAVENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 961239995,
    "dropphyadd": "519-300 SCHOOLHOUSE RD",
    "dropphycty": "RAVENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 961239995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RAVENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 961239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302342025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22626",
    "droptype": "D",
    "dropname": "RAYMOND",
    "dropdeladd": "32120 ROAD 600",
    "dropdelcty": "RAYMOND",
    "dropdelst": "CA",
    "dropdelzpp": 936539998,
    "dropphyadd": "32120 ROAD 600",
    "dropphycty": "RAYMOND",
    "dropphyst": "CA",
    "dropphyzpp": 936539998,
    "dropmaladd": "32120 ROAD 600",
    "dropmalcty": "RAYMOND",
    "dropmalst": "CA",
    "dropmalzpp": 936539998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596893335,
    "dropfax": 5596893291
  },
  {
    "dcode": "D",
    "dropkey": "PZ22628",
    "droptype": "D",
    "dropname": "RED BLUFF",
    "dropdeladd": "447 WALNUT ST",
    "dropdelcty": "RED BLUFF",
    "dropdelst": "CA",
    "dropdelzpp": 960809998,
    "dropphyadd": "447 WALNUT ST",
    "dropphycty": "RED BLUFF",
    "dropphyst": "CA",
    "dropphyzpp": 960809998,
    "dropmaladd": "447 WALNUT ST",
    "dropmalcty": "RED BLUFF",
    "dropmalst": "CA",
    "dropmalzpp": 960809998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305271455,
    "dropsitcph": 5305271455,
    "dropfax": 5305279188
  },
  {
    "dcode": "D",
    "dropkey": "PZ22631",
    "droptype": "D",
    "dropname": "REDCREST",
    "dropdeladd": "26406 STATE HIGHWAY 254",
    "dropdelcty": "REDCREST",
    "dropdelst": "CA",
    "dropdelzpp": 955699631,
    "dropphyadd": "26406 STATE HIGHWAY 254",
    "dropphycty": "REDCREST",
    "dropphyst": "CA",
    "dropphyzpp": 955699631,
    "dropmaladd": "26406 STATE HIGHWAY 254",
    "dropmalcty": "REDCREST",
    "dropmalst": "CA",
    "dropmalzpp": 955699998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077643772,
    "dropfax": 7077224241
  },
  {
    "dcode": "D",
    "dropkey": "PZ22633",
    "droptype": "D",
    "dropname": "REDDING",
    "dropdeladd": "2323 CHURN CREEK RD",
    "dropdelcty": "REDDING",
    "dropdelst": "CA",
    "dropdelzpp": 960029998,
    "dropphyadd": "2323 CHURN CREEK RD",
    "dropphycty": "REDDING",
    "dropphyst": "CA",
    "dropphyzpp": 960029998,
    "dropmaladd": "2323 CHURN CREEK RD",
    "dropmalcty": "REDDING",
    "dropmalst": "CA",
    "dropmalzpp": 960029998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302237500,
    "dropsitcph": 5302237523,
    "dropfax": 5302237511
  },
  {
    "dcode": "D",
    "dropkey": "PZ22634",
    "droptype": "D",
    "dropname": "REDLANDS",
    "dropdeladd": "201 BROOKSIDE AVE",
    "dropdelcty": "REDLANDS",
    "dropdelst": "CA",
    "dropdelzpp": 923739997,
    "dropphyadd": "201 BROOKSIDE AVE",
    "dropphycty": "REDLANDS",
    "dropphyst": "CA",
    "dropphyzpp": 923739997,
    "dropmaladd": "201 BROOKSIDE AVE",
    "dropmalcty": "REDLANDS",
    "dropmalst": "CA",
    "dropmalzpp": 923739997,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097930755,
    "dropsitcph": 9097938075,
    "dropfax": 9097934981
  },
  {
    "dcode": "D",
    "dropkey": "PZ22636",
    "droptype": "D",
    "dropname": "REDONDO BEACH",
    "dropdeladd": "1201 N CATALINA AVE",
    "dropdelcty": "REDONDO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902779998,
    "dropphyadd": "1201 N CATALINA AVE",
    "dropphycty": "REDONDO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902779998,
    "dropmaladd": "1201 N CATALINA AVE",
    "dropmalcty": "REDONDO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902779998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3103760262,
    "dropsitcph": 3103763252,
    "dropfax": 3103795906
  },
  {
    "dcode": "D",
    "dropkey": "PZ22637",
    "droptype": "D",
    "dropname": "REDWAY",
    "dropdeladd": "3400 REDWOOD DR",
    "dropdelcty": "REDWAY",
    "dropdelst": "CA",
    "dropdelzpp": 955609766,
    "dropphyadd": "3400 REDWOOD DR",
    "dropphycty": "REDWAY",
    "dropphyst": "CA",
    "dropphyzpp": 955609766,
    "dropmaladd": "3400 REDWOOD DR",
    "dropmalcty": "REDWAY",
    "dropmalst": "CA",
    "dropmalzpp": 955609998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079233784,
    "dropfax": 7079233784
  },
  {
    "dcode": "D",
    "dropkey": "PZ22638",
    "droptype": "D",
    "dropname": "REDWOOD CITY",
    "dropdeladd": "1100 BROADWAY ST",
    "dropdelcty": "REDWOOD CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940633108,
    "dropphyadd": "1100 BROADWAY ST",
    "dropphycty": "REDWOOD CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940633108,
    "dropmaladd": "1100 BROADWAY ST",
    "dropmalcty": "REDWOOD CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940633108,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503681827,
    "dropsitcph": 6503681782,
    "dropfax": 6503680395
  },
  {
    "dcode": "D",
    "dropkey": "PZ22641",
    "droptype": "D",
    "dropname": "REDWOOD ESTATES",
    "dropdeladd": "21432 BROADWAY RD",
    "dropdelcty": "REDWOOD ESTATES",
    "dropdelst": "CA",
    "dropdelzpp": 950449991,
    "dropphyadd": "21432 BROADWAY RD",
    "dropphycty": "REDWOOD ESTATES",
    "dropphyst": "CA",
    "dropphyzpp": 950449991,
    "dropmaladd": "21432 BROADWAY RD",
    "dropmalcty": "REDWOOD ESTATES",
    "dropmalst": "CA",
    "dropmalzpp": 950449991,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 4083531667,
    "dropfax": 4083538448
  },
  {
    "dcode": "D",
    "dropkey": "PZ22644",
    "droptype": "D",
    "dropname": "REDWOOD VALLEY",
    "dropdeladd": "993 E SCHOOL WAY",
    "dropdelcty": "REDWOOD VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 954709900,
    "dropphyadd": "993 E SCHOOL WAY",
    "dropphycty": "REDWOOD VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 954709900,
    "dropmaladd": "993 E SCHOOL WAY",
    "dropmalcty": "REDWOOD VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 954709900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074858279,
    "dropfax": 7074858442
  },
  {
    "dcode": "D",
    "dropkey": "PZ22646",
    "droptype": "D",
    "dropname": "REEDLEY",
    "dropdeladd": "1509 11TH ST",
    "dropdelcty": "REEDLEY",
    "dropdelst": "CA",
    "dropdelzpp": 936549998,
    "dropphyadd": "1509 11TH ST",
    "dropphycty": "REEDLEY",
    "dropphyst": "CA",
    "dropphyzpp": 936549998,
    "dropmaladd": "1509 11TH ST",
    "dropmalcty": "REEDLEY",
    "dropmalst": "CA",
    "dropmalzpp": 936549998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594803903,
    "dropsitcph": 5596383781,
    "dropfax": 5596353581
  },
  {
    "dcode": "D",
    "dropkey": "PZ22649",
    "droptype": "D",
    "dropname": "RESCUE",
    "dropdeladd": "5221 DEER VALLEY RD",
    "dropdelcty": "RESCUE",
    "dropdelst": "CA",
    "dropdelzpp": 956729998,
    "dropphyadd": "5221 DEER VALLEY RD",
    "dropphycty": "RESCUE",
    "dropphyst": "CA",
    "dropphyzpp": 956729998,
    "dropmaladd": "5221 DEER VALLEY RD",
    "dropmalcty": "RESCUE",
    "dropmalst": "CA",
    "dropmalzpp": 956729998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306772354,
    "dropsitcph": 5306772354,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22651",
    "droptype": "D",
    "dropname": "RESEDA",
    "dropdeladd": "7320 RESEDA BLVD",
    "dropdelcty": "RESEDA",
    "dropdelst": "CA",
    "dropdelzpp": 913359998,
    "dropphyadd": "7320 RESEDA BLVD",
    "dropphycty": "RESEDA",
    "dropphyst": "CA",
    "dropphyzpp": 913359998,
    "dropmaladd": "7320 RESEDA BLVD",
    "dropmalcty": "RESEDA",
    "dropmalst": "CA",
    "dropmalzpp": 913359998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183426754,
    "dropsitcph": 8183425786,
    "dropfax": 8183422607
  },
  {
    "dcode": "D",
    "dropkey": "PZ22655",
    "droptype": "D",
    "dropname": "RIALTO",
    "dropdeladd": "241 W RIALTO AVE",
    "dropdelcty": "RIALTO",
    "dropdelst": "CA",
    "dropdelzpp": 923766471,
    "dropphyadd": "241 W RIALTO AVE",
    "dropphycty": "RIALTO",
    "dropphyst": "CA",
    "dropphyzpp": 923766471,
    "dropmaladd": "241 W RIALTO AVE",
    "dropmalcty": "RIALTO",
    "dropmalst": "CA",
    "dropmalzpp": 923766471,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098758436,
    "dropsitcph": 9098754064,
    "dropfax": 9098752859
  },
  {
    "dcode": "D",
    "dropkey": "PZ22657",
    "droptype": "D",
    "dropname": "RICHGROVE",
    "dropdeladd": "20920 GROVE DR",
    "dropdelcty": "RICHGROVE",
    "dropdelst": "CA",
    "dropdelzpp": 932619997,
    "dropphyadd": "20920 GROVE DR",
    "dropphycty": "RICHGROVE",
    "dropphyst": "CA",
    "dropphyzpp": 932619997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHGROVE",
    "dropmalst": "CA",
    "dropmalzpp": 932619998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613704113,
    "dropsitcph": 6613704113,
    "dropfax": 6617253606
  },
  {
    "dcode": "D",
    "dropkey": "PZ22658",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "1025 NEVIN AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948013100,
    "dropphyadd": "1025 NEVIN AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948013100,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948029998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102321264,
    "dropsitcph": 5102324314,
    "dropfax": 5102320135
  },
  {
    "dcode": "D",
    "dropkey": "PZ22659",
    "droptype": "D",
    "dropname": "RICHVALE",
    "dropdeladd": "5219 CHURCH ST",
    "dropdelcty": "RICHVALE",
    "dropdelst": "CA",
    "dropdelzpp": 959749996,
    "dropphyadd": "5219 CHURCH ST",
    "dropphycty": "RICHVALE",
    "dropphyst": "CA",
    "dropphyzpp": 959749996,
    "dropmaladd": "5219 CHURCH ST",
    "dropmalcty": "RICHVALE",
    "dropmalst": "CA",
    "dropmalzpp": 959749996,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308824422,
    "dropsitcph": 5308824422,
    "dropfax": 5308824422
  },
  {
    "dcode": "D",
    "dropkey": "PZ22660",
    "droptype": "D",
    "dropname": "RIDGECREST",
    "dropdeladd": "101 E COSO AVE",
    "dropdelcty": "RIDGECREST",
    "dropdelst": "CA",
    "dropdelzpp": 935559998,
    "dropphyadd": "101 E COSO AVE",
    "dropphycty": "RIDGECREST",
    "dropphyst": "CA",
    "dropphyzpp": 935559998,
    "dropmaladd": "101 E COSO AVE",
    "dropmalcty": "RIDGECREST",
    "dropmalst": "CA",
    "dropmalzpp": 935559998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603751939,
    "dropsitcph": 7603751939,
    "dropfax": 7603758976
  },
  {
    "dcode": "D",
    "dropkey": "PZ22663",
    "droptype": "D",
    "dropname": "RIMFOREST",
    "dropdeladd": "26517 STATE HIGHWAY 18",
    "dropdelcty": "RIMFOREST",
    "dropdelst": "CA",
    "dropdelzpp": 923780010,
    "dropphyadd": "26517 STATE HIGHWAY 18",
    "dropphycty": "RIMFOREST",
    "dropphyst": "CA",
    "dropphyzpp": 923780010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RIMFOREST",
    "dropmalst": "CA",
    "dropmalzpp": 923789998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093374414,
    "dropsitcph": 9093374414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22671",
    "droptype": "D",
    "dropname": "RIO DELL",
    "dropdeladd": "315 WILDWOOD AVE",
    "dropdelcty": "RIO DELL",
    "dropdelst": "CA",
    "dropdelzpp": 955621700,
    "dropphyadd": "315 WILDWOOD AVE",
    "dropphycty": "RIO DELL",
    "dropphyst": "CA",
    "dropphyzpp": 955621700,
    "dropmaladd": "315 WILDWOOD AVE",
    "dropmalcty": "RIO DELL",
    "dropmalst": "CA",
    "dropmalzpp": 955621700,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077643772,
    "dropfax": 7077643772
  },
  {
    "dcode": "D",
    "dropkey": "PZ22672",
    "droptype": "D",
    "dropname": "RIO LINDA",
    "dropdeladd": "801 M ST",
    "dropdelcty": "RIO LINDA",
    "dropdelst": "CA",
    "dropdelzpp": 956739998,
    "dropphyadd": "801 M ST",
    "dropphycty": "RIO LINDA",
    "dropphyst": "CA",
    "dropphyzpp": 956739998,
    "dropmaladd": "801 M ST",
    "dropmalcty": "RIO LINDA",
    "dropmalst": "CA",
    "dropmalzpp": 956739998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169917387,
    "dropsitcph": 9169915983,
    "dropfax": 9169910385
  },
  {
    "dcode": "D",
    "dropkey": "PZ22674",
    "droptype": "D",
    "dropname": "RIO OSO",
    "dropdeladd": "2156 RIO OSO RD",
    "dropdelcty": "RIO OSO",
    "dropdelst": "CA",
    "dropdelzpp": 956749998,
    "dropphyadd": "2156 RIO OSO RD",
    "dropphycty": "RIO OSO",
    "dropphyst": "CA",
    "dropphyzpp": 956749998,
    "dropmaladd": "2156 RIO OSO RD",
    "dropmalcty": "RIO OSO",
    "dropmalst": "CA",
    "dropmalzpp": 956749998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306332615,
    "dropsitcph": 5306332615,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22675",
    "droptype": "D",
    "dropname": "RIO VISTA",
    "dropdeladd": "140 SACRAMENTO ST",
    "dropdelcty": "RIO VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 945719998,
    "dropphyadd": "140 SACRAMENTO ST",
    "dropphycty": "RIO VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 945719998,
    "dropmaladd": "140 SACRAMENTO ST",
    "dropmalcty": "RIO VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 945719998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7073742057,
    "dropfax": 7073742057
  },
  {
    "dcode": "D",
    "dropkey": "PZ22676",
    "droptype": "D",
    "dropname": "RIPON",
    "dropdeladd": "1275 W MAIN ST",
    "dropdelcty": "RIPON",
    "dropdelst": "CA",
    "dropdelzpp": 953669998,
    "dropphyadd": "1275 W MAIN ST",
    "dropphycty": "RIPON",
    "dropphyst": "CA",
    "dropphyzpp": 953669998,
    "dropmaladd": "1275 W MAIN ST",
    "dropmalcty": "RIPON",
    "dropmalst": "CA",
    "dropmalzpp": 953669998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095996071,
    "dropsitcph": 2095996071,
    "dropfax": 2095995365
  },
  {
    "dcode": "D",
    "dropkey": "PZ22683",
    "droptype": "D",
    "dropname": "RIVERBANK",
    "dropdeladd": "6501 3RD ST",
    "dropdelcty": "RIVERBANK",
    "dropdelst": "CA",
    "dropdelzpp": 953679998,
    "dropphyadd": "6501 3RD ST",
    "dropphycty": "RIVERBANK",
    "dropphyst": "CA",
    "dropphyzpp": 953679998,
    "dropmaladd": "6501 3RD ST",
    "dropmalcty": "RIVERBANK",
    "dropmalst": "CA",
    "dropmalzpp": 953679998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098691274,
    "dropsitcph": 2098690181,
    "dropfax": 2098698701
  },
  {
    "dcode": "D",
    "dropkey": "PZ22684",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "3401 HENSON ST",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "CA",
    "dropdelzpp": 936569998,
    "dropphyadd": "3401 HENSON ST",
    "dropphycty": "RIVERDALE",
    "dropphyst": "CA",
    "dropphyzpp": 936569998,
    "dropmaladd": "3401 HENSON ST",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "CA",
    "dropmalzpp": 936569998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598673174,
    "dropsitcph": 5598673174,
    "dropfax": 5598678001
  },
  {
    "dcode": "D",
    "dropkey": "PZ22686",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "4150 CHICAGO AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 925079998,
    "dropphyadd": "4150 CHICAGO AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 925079998,
    "dropmaladd": "4150 CHICAGO AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 925079998,
    "dropsitphn": 9513354694,
    "dropsitlph": 9517884936,
    "dropsitcph": 9517884058,
    "dropfax": 9517886746
  },
  {
    "dcode": "D",
    "dropkey": "PZ22691",
    "droptype": "D",
    "dropname": "ROBBINS",
    "dropdeladd": "4879 DEL MONTE AVE",
    "dropdelcty": "ROBBINS",
    "dropdelst": "CA",
    "dropdelzpp": 956769998,
    "dropphyadd": "4879 DEL MONTE AVE",
    "dropphycty": "ROBBINS",
    "dropphyst": "CA",
    "dropphyzpp": 956769998,
    "dropmaladd": "4879 DEL MONTE AVE",
    "dropmalcty": "ROBBINS",
    "dropmalst": "CA",
    "dropmalzpp": 956769998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307384272,
    "dropsitcph": 5307384272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22698",
    "droptype": "D",
    "dropname": "ROCKLIN",
    "dropdeladd": "5515 PACIFIC ST",
    "dropdelcty": "ROCKLIN",
    "dropdelst": "CA",
    "dropdelzpp": 956779998,
    "dropphyadd": "5515 PACIFIC ST",
    "dropphycty": "ROCKLIN",
    "dropphyst": "CA",
    "dropphyzpp": 956779998,
    "dropmaladd": "5515 PACIFIC ST",
    "dropmalcty": "ROCKLIN",
    "dropmalst": "CA",
    "dropmalzpp": 956779998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166244118,
    "dropsitcph": 9166245875,
    "dropfax": 9166323513
  },
  {
    "dcode": "D",
    "dropkey": "PZ22701",
    "droptype": "D",
    "dropname": "RODEO",
    "dropdeladd": "499 PARKER AVE",
    "dropdelcty": "RODEO",
    "dropdelst": "CA",
    "dropdelzpp": 945721457,
    "dropphyadd": "499 PARKER AVE",
    "dropphycty": "RODEO",
    "dropphyst": "CA",
    "dropphyzpp": 945721457,
    "dropmaladd": "499 PARKER AVE",
    "dropmalcty": "RODEO",
    "dropmalst": "CA",
    "dropmalzpp": 945729998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107995015,
    "dropsitcph": 5107995019,
    "dropfax": 5107994584
  },
  {
    "dcode": "D",
    "dropkey": "PZ22714",
    "droptype": "D",
    "dropname": "ROSAMOND",
    "dropdeladd": "1950 W ROSAMOND BLVD",
    "dropdelcty": "ROSAMOND",
    "dropdelst": "CA",
    "dropdelzpp": 935609998,
    "dropphyadd": "1950 W ROSAMOND BLVD",
    "dropphycty": "ROSAMOND",
    "dropphyst": "CA",
    "dropphyzpp": 935609998,
    "dropmaladd": "1950 W ROSAMOND BLVD",
    "dropmalcty": "ROSAMOND",
    "dropmalst": "CA",
    "dropmalzpp": 935609998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615283016,
    "dropsitcph": 6615283016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22718",
    "droptype": "D",
    "dropname": "ROSEMEAD",
    "dropdeladd": "8845 VALLEY BLVD",
    "dropdelcty": "ROSEMEAD",
    "dropdelst": "CA",
    "dropdelzpp": 917709998,
    "dropphyadd": "8845 VALLEY BLVD",
    "dropphycty": "ROSEMEAD",
    "dropphyst": "CA",
    "dropphyzpp": 917709998,
    "dropmaladd": "8845 VALLEY BLVD",
    "dropmalcty": "ROSEMEAD",
    "dropmalst": "CA",
    "dropmalzpp": 917709998,
    "dropsitphn": 6262863041,
    "dropsitlph": 6262862404,
    "dropsitcph": 6262863041,
    "dropfax": 6262863714
  },
  {
    "dcode": "D",
    "dropkey": "PZ22719",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "1860 SIERRA GARDENS DR",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956619998,
    "dropphyadd": "1860 SIERRA GARDENS DR",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956619998,
    "dropmaladd": "1860 SIERRA GARDENS DR",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956619998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167894504,
    "dropsitcph": 9167894502,
    "dropfax": 9167894521
  },
  {
    "dcode": "D",
    "dropkey": "PZ22721",
    "droptype": "D",
    "dropname": "ROSS",
    "dropdeladd": "1 ROSS CMN",
    "dropdelcty": "ROSS",
    "dropdelst": "CA",
    "dropdelzpp": 949579998,
    "dropphyadd": "1 ROSS CMN",
    "dropphycty": "ROSS",
    "dropphyst": "CA",
    "dropphyzpp": 949579998,
    "dropmaladd": "1 ROSS CMN",
    "dropmalcty": "ROSS",
    "dropmalst": "CA",
    "dropmalzpp": 949579998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154544123,
    "dropfax": 4154595709
  },
  {
    "dcode": "D",
    "dropkey": "PZ22724",
    "droptype": "D",
    "dropname": "ROUGH AND READY",
    "dropdeladd": "14485 ROUGH AND READY HWY",
    "dropdelcty": "ROUGH AND READY",
    "dropdelst": "CA",
    "dropdelzpp": 959759998,
    "dropphyadd": "14485 ROUGH AND READY HWY",
    "dropphycty": "ROUGH AND READY",
    "dropphyst": "CA",
    "dropphyzpp": 959759998,
    "dropmaladd": "14485 ROUGH AND READY HWY",
    "dropmalcty": "ROUGH AND READY",
    "dropmalst": "CA",
    "dropmalzpp": 959759998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302733509,
    "dropsitcph": 5302733503,
    "dropfax": 5302720346
  },
  {
    "dcode": "D",
    "dropkey": "PZ22726",
    "droptype": "D",
    "dropname": "ROUND MOUNTAIN",
    "dropdeladd": "29620 STATE HIGHWAY 299 E",
    "dropdelcty": "ROUND MOUNTAIN",
    "dropdelst": "CA",
    "dropdelzpp": 960849998,
    "dropphyadd": "29620 STATE HIGHWAY 299 E",
    "dropphycty": "ROUND MOUNTAIN",
    "dropphyst": "CA",
    "dropphyzpp": 960849998,
    "dropmaladd": "29620 STATE HIGHWAY 299 E",
    "dropmalcty": "ROUND MOUNTAIN",
    "dropmalst": "CA",
    "dropmalzpp": 960849998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303376562,
    "dropsitcph": 5303376562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22736",
    "droptype": "D",
    "dropname": "RUNNING SPRINGS",
    "dropdeladd": "2641 PALO ALTO WAY",
    "dropdelcty": "RUNNING SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 923820481,
    "dropphyadd": "2641 PALO ALTO WAY",
    "dropphycty": "RUNNING SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 923820481,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUNNING SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 923829998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098674908,
    "dropsitcph": 9098677278,
    "dropfax": 9098674269
  },
  {
    "dcode": "D",
    "dropkey": "PZ22742",
    "droptype": "D",
    "dropname": "RUTHERFORD",
    "dropdeladd": "1190 RUTHERFORD RD",
    "dropdelcty": "RUTHERFORD",
    "dropdelst": "CA",
    "dropdelzpp": 945739800,
    "dropphyadd": "1190 RUTHERFORD RD",
    "dropphycty": "RUTHERFORD",
    "dropphyst": "CA",
    "dropphyzpp": 945739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "RUTHERFORD",
    "dropmalst": "CA",
    "dropmalzpp": 945739998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079637488,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "PZ22744",
    "droptype": "D",
    "dropname": "RYDE",
    "dropdeladd": "14286 STATE HIGHWAY 160",
    "dropdelcty": "RYDE",
    "dropdelst": "CA",
    "dropdelzpp": 956809998,
    "dropphyadd": "14286 STATE HIGHWAY 160",
    "dropphycty": "RYDE",
    "dropphyst": "CA",
    "dropphyzpp": 956809998,
    "dropmaladd": "14286 STATE HIGHWAY 160",
    "dropmalcty": "RYDE",
    "dropmalst": "CA",
    "dropmalzpp": 956809998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167761242,
    "dropsitcph": 9167761242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22761",
    "droptype": "D",
    "dropname": "SACRAMENTO",
    "dropdeladd": "2000 ROYAL OAKS DR",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958139998,
    "dropphyadd": "2000 ROYAL OAKS DR",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958139998,
    "dropmaladd": "2000 ROYAL OAKS DR",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162637218,
    "dropsitcph": 9162637077,
    "dropfax": 9162637180
  },
  {
    "dcode": "D",
    "dropkey": "PZ22766",
    "droptype": "D",
    "dropname": "SAINT HELENA",
    "dropdeladd": "1461 MAIN ST",
    "dropdelcty": "SAINT HELENA",
    "dropdelst": "CA",
    "dropdelzpp": 945749998,
    "dropphyadd": "1461 MAIN ST",
    "dropphycty": "SAINT HELENA",
    "dropphyst": "CA",
    "dropphyzpp": 945749998,
    "dropmaladd": "1461 MAIN ST",
    "dropmalcty": "SAINT HELENA",
    "dropmalst": "CA",
    "dropmalzpp": 945749998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079632668,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "PZ22771",
    "droptype": "D",
    "dropname": "SALIDA",
    "dropdeladd": "4536 BROADWAY",
    "dropdelcty": "SALIDA",
    "dropdelst": "CA",
    "dropdelzpp": 953689998,
    "dropphyadd": "4536 BROADWAY",
    "dropphycty": "SALIDA",
    "dropphyst": "CA",
    "dropphyzpp": 953689998,
    "dropmaladd": "4536 BROADWAY",
    "dropmalcty": "SALIDA",
    "dropmalst": "CA",
    "dropmalzpp": 953689998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095452024,
    "dropsitcph": 2095450620,
    "dropfax": 2095453834
  },
  {
    "dcode": "D",
    "dropkey": "PZ22773",
    "droptype": "D",
    "dropname": "SALINAS",
    "dropdeladd": "1011 POST DR",
    "dropdelcty": "SALINAS",
    "dropdelst": "CA",
    "dropdelzpp": 939071821,
    "dropphyadd": "1011 POST DR",
    "dropphycty": "SALINAS",
    "dropphyst": "CA",
    "dropphyzpp": 939071821,
    "dropmaladd": "1011 POST DR",
    "dropmalcty": "SALINAS",
    "dropmalst": "CA",
    "dropmalzpp": 939079998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8317707145,
    "dropsitcph": 8317707124,
    "dropfax": 8317707117
  },
  {
    "dcode": "D",
    "dropkey": "PZ22779",
    "droptype": "D",
    "dropname": "SALYER",
    "dropdeladd": "50 SALYER LN",
    "dropdelcty": "SALYER",
    "dropdelst": "CA",
    "dropdelzpp": 955639998,
    "dropphyadd": "50 SALYER LN",
    "dropphycty": "SALYER",
    "dropphyst": "CA",
    "dropphyzpp": 955639998,
    "dropmaladd": "50 SALYER LN",
    "dropmalcty": "SALYER",
    "dropmalst": "CA",
    "dropmalzpp": 955639998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 5306292380,
    "dropfax": 5306292380
  },
  {
    "dcode": "D",
    "dropkey": "PZ22780",
    "droptype": "D",
    "dropname": "SAMOA",
    "dropdeladd": "244 N BAYVIEW AVE",
    "dropdelcty": "SAMOA",
    "dropdelst": "CA",
    "dropdelzpp": 955649523,
    "dropphyadd": "244 N BAYVIEW AVE",
    "dropphycty": "SAMOA",
    "dropphyst": "CA",
    "dropphyzpp": 955649523,
    "dropmaladd": "244 N BAYVIEW AVE",
    "dropmalcty": "SAMOA",
    "dropmalst": "CA",
    "dropmalzpp": 955649523,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078223370,
    "dropfax": 7074425441
  },
  {
    "dcode": "D",
    "dropkey": "PZ22781",
    "droptype": "D",
    "dropname": "SAN ANDREAS",
    "dropdeladd": "315 RUSSELL RD",
    "dropdelcty": "SAN ANDREAS",
    "dropdelst": "CA",
    "dropdelzpp": 952499998,
    "dropphyadd": "315 RUSSELL RD",
    "dropphycty": "SAN ANDREAS",
    "dropphyst": "CA",
    "dropphyzpp": 952499998,
    "dropmaladd": "315 RUSSELL RD",
    "dropmalcty": "SAN ANDREAS",
    "dropmalst": "CA",
    "dropmalzpp": 952499998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097543201,
    "dropsitcph": 2097543201,
    "dropfax": 2097544093
  },
  {
    "dcode": "D",
    "dropkey": "PZ22782",
    "droptype": "D",
    "dropname": "SAN ANSELMO",
    "dropdeladd": "121 SAN ANSELMO AVE",
    "dropdelcty": "SAN ANSELMO",
    "dropdelst": "CA",
    "dropdelzpp": 949602857,
    "dropphyadd": "121 SAN ANSELMO AVE",
    "dropphycty": "SAN ANSELMO",
    "dropphyst": "CA",
    "dropphyzpp": 949602857,
    "dropmaladd": "121 SAN ANSELMO AVE",
    "dropmalcty": "SAN ANSELMO",
    "dropmalst": "CA",
    "dropmalzpp": 949602857,
    "dropsitphn": 4154530847,
    "dropsitlph": 4154530793,
    "dropsitcph": 4154530363,
    "dropfax": 4154539542
  },
  {
    "dcode": "D",
    "dropkey": "PZ22784",
    "droptype": "D",
    "dropname": "SAN ARDO",
    "dropdeladd": "1 RAILROAD ST",
    "dropdelcty": "SAN ARDO",
    "dropdelst": "CA",
    "dropdelzpp": 934509997,
    "dropphyadd": "1 RAILROAD ST",
    "dropphycty": "SAN ARDO",
    "dropphyst": "CA",
    "dropphyzpp": 934509997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN ARDO",
    "dropmalst": "CA",
    "dropmalzpp": 934509998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8316272432,
    "dropsitcph": 8316272432,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ22789",
    "droptype": "D",
    "dropname": "SAN BERNARDINO",
    "dropdeladd": "390 W 5TH ST",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924019998,
    "dropphyadd": "390 W 5TH ST",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924019998,
    "dropmaladd": "390 W 5TH ST",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924019998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098894247,
    "dropsitcph": 9098894247,
    "dropfax": 9098858226
  },
  {
    "dcode": "D",
    "dropkey": "PZ22790",
    "droptype": "D",
    "dropname": "SAN BRUNO",
    "dropdeladd": "1300 HUNTINGTON AVE",
    "dropdelcty": "SAN BRUNO",
    "dropdelst": "CA",
    "dropdelzpp": 940661599,
    "dropphyadd": "1300 HUNTINGTON AVE",
    "dropphycty": "SAN BRUNO",
    "dropphyst": "CA",
    "dropphyzpp": 940661599,
    "dropmaladd": "1300 HUNTINGTON AVE",
    "dropmalcty": "SAN BRUNO",
    "dropmalst": "CA",
    "dropmalzpp": 940661599,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509522454,
    "dropsitcph": 6509522902,
    "dropfax": 6509529856
  },
  {
    "dcode": "D",
    "dropkey": "PZ22791",
    "droptype": "D",
    "dropname": "SAN CARLOS",
    "dropdeladd": "809 LAUREL ST",
    "dropdelcty": "SAN CARLOS",
    "dropdelst": "CA",
    "dropdelzpp": 940703914,
    "dropphyadd": "809 LAUREL ST",
    "dropphycty": "SAN CARLOS",
    "dropphyst": "CA",
    "dropphyzpp": 940703914,
    "dropmaladd": "809 LAUREL ST",
    "dropmalcty": "SAN CARLOS",
    "dropmalst": "CA",
    "dropmalzpp": 940703914,
    "dropsitphn": 4155505045,
    "dropsitlph": 6505911810,
    "dropsitcph": 6505915322,
    "dropfax": 6505912938
  },
  {
    "dcode": "D",
    "dropkey": "PZ22792",
    "droptype": "D",
    "dropname": "SAN CLEMENTE",
    "dropdeladd": "520 E AVENIDA PICO",
    "dropdelcty": "SAN CLEMENTE",
    "dropdelst": "CA",
    "dropdelzpp": 926749998,
    "dropphyadd": "520 E AVENIDA PICO",
    "dropphycty": "SAN CLEMENTE",
    "dropphyst": "CA",
    "dropphyzpp": 926749998,
    "dropmaladd": "520 E AVENIDA PICO",
    "dropmalcty": "SAN CLEMENTE",
    "dropmalst": "CA",
    "dropmalzpp": 926749998,
    "dropsitphn": 9494923965,
    "dropsitlph": 9498313109,
    "dropsitcph": 9494923965,
    "dropfax": 9494928859
  },
  {
    "dcode": "D",
    "dropkey": "PZ22794",
    "droptype": "D",
    "dropname": "SAN DIEGO",
    "dropdeladd": "11251 RANCHO CARMEL DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921999988,
    "dropphyadd": "11251 RANCHO CARMEL DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921999988,
    "dropmaladd": "11251 RANCHO CARMEL DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921999988,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585302298,
    "dropsitcph": 8586740205,
    "dropfax": 8585302981
  },
  {
    "dcode": "D",
    "dropkey": "PZ22798",
    "droptype": "D",
    "dropname": "SAN DIMAS",
    "dropdeladd": "300 E BONITA AVE",
    "dropdelcty": "SAN DIMAS",
    "dropdelst": "CA",
    "dropdelzpp": 917739998,
    "dropphyadd": "300 E BONITA AVE",
    "dropphycty": "SAN DIMAS",
    "dropphyst": "CA",
    "dropphyzpp": 917739998,
    "dropmaladd": "300 E BONITA AVE",
    "dropmalcty": "SAN DIMAS",
    "dropmalst": "CA",
    "dropmalzpp": 917739998,
    "dropsitphn": 9095990651,
    "dropsitlph": 9093056961,
    "dropsitcph": 9095990651,
    "dropfax": 9095995821
  },
  {
    "dcode": "D",
    "dropkey": "PZ22799",
    "droptype": "D",
    "dropname": "SAN FERNANDO",
    "dropdeladd": "308 S MACLAY AVE",
    "dropdelcty": "SAN FERNANDO",
    "dropdelst": "CA",
    "dropdelzpp": 913409998,
    "dropphyadd": "308 S MACLAY AVE",
    "dropphycty": "SAN FERNANDO",
    "dropphyst": "CA",
    "dropphyzpp": 913409998,
    "dropmaladd": "308 S MACLAY AVE",
    "dropmalcty": "SAN FERNANDO",
    "dropmalst": "CA",
    "dropmalzpp": 913409998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188380693,
    "dropsitcph": 8188380693,
    "dropfax": 8187419607
  },
  {
    "dcode": "D",
    "dropkey": "PZ22802",
    "droptype": "D",
    "dropname": "SAN FRANCISCO",
    "dropdeladd": "1300 EVANS AVE STE 300H",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941889998,
    "dropphyadd": "1300 EVANS AVE STE 300H",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941889998,
    "dropmaladd": "1300 EVANS AVE STE 300H",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941889998,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155505057,
    "dropsitcph": 4155505001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22807",
    "droptype": "D",
    "dropname": "SAN GABRIEL",
    "dropdeladd": "120 S DEL MAR AVE",
    "dropdelcty": "SAN GABRIEL",
    "dropdelst": "CA",
    "dropdelzpp": 917789998,
    "dropphyadd": "120 S DEL MAR AVE",
    "dropphycty": "SAN GABRIEL",
    "dropphyst": "CA",
    "dropphyzpp": 917789998,
    "dropmaladd": "120 S DEL MAR AVE",
    "dropmalcty": "SAN GABRIEL",
    "dropmalst": "CA",
    "dropmalzpp": 917789998,
    "dropsitphn": 6262877014,
    "dropsitlph": 6262870480,
    "dropsitcph": 6262877014,
    "dropfax": 6262872307
  },
  {
    "dcode": "D",
    "dropkey": "PZ22808",
    "droptype": "D",
    "dropname": "SAN GERONIMO",
    "dropdeladd": "630 SAN GERONIMO VALLEY DR",
    "dropdelcty": "SAN GERONIMO",
    "dropdelst": "CA",
    "dropdelzpp": 949639998,
    "dropphyadd": "630 SAN GERONIMO VALLEY DR",
    "dropphycty": "SAN GERONIMO",
    "dropphyst": "CA",
    "dropphyzpp": 949639998,
    "dropmaladd": "630 SAN GERONIMO VALLEY DR",
    "dropmalcty": "SAN GERONIMO",
    "dropmalst": "CA",
    "dropmalzpp": 949639998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154884644,
    "dropfax": 4154884644
  },
  {
    "dcode": "D",
    "dropkey": "PZ22809",
    "droptype": "D",
    "dropname": "SAN GREGORIO",
    "dropdeladd": "7615 STAGE RD",
    "dropdelcty": "SAN GREGORIO",
    "dropdelst": "CA",
    "dropdelzpp": 940749805,
    "dropphyadd": "7615 STAGE RD",
    "dropphycty": "SAN GREGORIO",
    "dropphyst": "CA",
    "dropphyzpp": 940749805,
    "dropmaladd": "7615 STAGE RD",
    "dropmalcty": "SAN GREGORIO",
    "dropmalst": "CA",
    "dropmalzpp": 940749805,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507261045,
    "dropsitcph": 6507261045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22811",
    "droptype": "D",
    "dropname": "SAN JACINTO",
    "dropdeladd": "315 E ESPLANADE AVE",
    "dropdelcty": "SAN JACINTO",
    "dropdelst": "CA",
    "dropdelzpp": 925839998,
    "dropphyadd": "315 E ESPLANADE AVE",
    "dropphycty": "SAN JACINTO",
    "dropphyst": "CA",
    "dropphyzpp": 925839998,
    "dropmaladd": "315 E ESPLANADE AVE",
    "dropmalcty": "SAN JACINTO",
    "dropmalst": "CA",
    "dropmalzpp": 925839998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516540851,
    "dropsitcph": 9516546172,
    "dropfax": 9516542402
  },
  {
    "dcode": "D",
    "dropkey": "PZ22812",
    "droptype": "D",
    "dropname": "SAN JOAQUIN",
    "dropdeladd": "8667 9TH ST",
    "dropdelcty": "SAN JOAQUIN",
    "dropdelst": "CA",
    "dropdelzpp": 936609998,
    "dropphyadd": "8667 9TH ST",
    "dropphycty": "SAN JOAQUIN",
    "dropphyst": "CA",
    "dropphyzpp": 936609998,
    "dropmaladd": "8667 9TH ST",
    "dropmalcty": "SAN JOAQUIN",
    "dropmalst": "CA",
    "dropmalzpp": 936609998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596932229,
    "dropfax": 5596931129
  },
  {
    "dcode": "D",
    "dropkey": "PZ22814",
    "droptype": "D",
    "dropname": "SAN JOSE",
    "dropdeladd": "1750 LUNDY AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951018000,
    "dropphyadd": "1750 LUNDY AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951018000,
    "dropmaladd": "1750 LUNDY AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951018000,
    "dropsitphn": 4084376726,
    "dropsitlph": 4087236102,
    "dropsitcph": 4084376688,
    "dropfax": 4087236226
  },
  {
    "dcode": "D",
    "dropkey": "PZ22819",
    "droptype": "D",
    "dropname": "SAN JUAN BAUTISTA",
    "dropdeladd": "301 THE ALAMEDA",
    "dropdelcty": "SAN JUAN BAUTISTA",
    "dropdelst": "CA",
    "dropdelzpp": 950459998,
    "dropphyadd": "301 THE ALAMEDA",
    "dropphycty": "SAN JUAN BAUTISTA",
    "dropphyst": "CA",
    "dropphyzpp": 950459998,
    "dropmaladd": "301 THE ALAMEDA",
    "dropmalcty": "SAN JUAN BAUTISTA",
    "dropmalst": "CA",
    "dropmalzpp": 950459998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316234373,
    "dropfax": 8316234217
  },
  {
    "dcode": "D",
    "dropkey": "PZ22821",
    "droptype": "D",
    "dropname": "SAN JUAN CAPISTRANO",
    "dropdeladd": "28081 MARGUERITE PKWY",
    "dropdelcty": "MISSION VIEJO",
    "dropdelst": "CA",
    "dropdelzpp": 926909998,
    "dropphyadd": "28081 MARGUERITE PKWY",
    "dropphycty": "MISSION VIEJO",
    "dropphyst": "CA",
    "dropphyzpp": 926909998,
    "dropmaladd": "28081 MARGUERITE PKWY",
    "dropmalcty": "MISSION VIEJO",
    "dropmalst": "CA",
    "dropmalzpp": 926909998,
    "dropsitphn": 9493649606,
    "dropsitlph": 9495826299,
    "dropsitcph": 9493649606,
    "dropfax": 9493640209
  },
  {
    "dcode": "D",
    "dropkey": "PZ22824",
    "droptype": "D",
    "dropname": "SAN LEANDRO",
    "dropdeladd": "1777 ABRAM CT",
    "dropdelcty": "SAN LEANDRO",
    "dropdelst": "CA",
    "dropdelzpp": 945779998,
    "dropphyadd": "1777 ABRAM CT",
    "dropphycty": "SAN LEANDRO",
    "dropphyst": "CA",
    "dropphyzpp": 945779998,
    "dropmaladd": "1777 ABRAM CT",
    "dropmalcty": "SAN LEANDRO",
    "dropmalst": "CA",
    "dropmalzpp": 945779998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5104833062,
    "dropsitcph": 5104832785,
    "dropfax": 5106148183
  },
  {
    "dcode": "D",
    "dropkey": "PZ22825",
    "droptype": "D",
    "dropname": "SAN LORENZO",
    "dropdeladd": "15808 HESPERIAN BLVD",
    "dropdelcty": "SAN LORENZO",
    "dropdelst": "CA",
    "dropdelzpp": 945809998,
    "dropphyadd": "15808 HESPERIAN BLVD",
    "dropphycty": "SAN LORENZO",
    "dropphyst": "CA",
    "dropphyzpp": 945809998,
    "dropmaladd": "15808 HESPERIAN BLVD",
    "dropmalcty": "SAN LORENZO",
    "dropmalst": "CA",
    "dropmalzpp": 945809998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5103171106,
    "dropsitcph": 5103171104,
    "dropfax": 5103171103
  },
  {
    "dcode": "D",
    "dropkey": "PZ22826",
    "droptype": "D",
    "dropname": "SAN LUCAS",
    "dropdeladd": "53575 MAIN ST",
    "dropdelcty": "SAN LUCAS",
    "dropdelst": "CA",
    "dropdelzpp": 939549800,
    "dropphyadd": "53575 MAIN ST",
    "dropphycty": "SAN LUCAS",
    "dropphyst": "CA",
    "dropphyzpp": 939549800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN LUCAS",
    "dropmalst": "CA",
    "dropmalzpp": 939549998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313824391,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22827",
    "droptype": "D",
    "dropname": "SAN LUIS OBISPO",
    "dropdeladd": "1655 DALIDIO DR",
    "dropdelcty": "SAN LUIS OBISPO",
    "dropdelst": "CA",
    "dropdelzpp": 934011000,
    "dropphyadd": "1655 DALIDIO DR",
    "dropphycty": "SAN LUIS OBISPO",
    "dropphyst": "CA",
    "dropphyzpp": 934011000,
    "dropmaladd": "1655 DALIDIO DR",
    "dropmalcty": "SAN LUIS OBISPO",
    "dropmalst": "CA",
    "dropmalzpp": 934011000,
    "dropsitphn": 6617757808,
    "dropsitlph": 8058583478,
    "dropsitcph": 8055432605,
    "dropfax": 8055450812
  },
  {
    "dcode": "D",
    "dropkey": "PZ22830",
    "droptype": "D",
    "dropname": "SAN MARCOS",
    "dropdeladd": "420 N TWIN OAKS VALLEY RD",
    "dropdelcty": "SAN MARCOS",
    "dropdelst": "CA",
    "dropdelzpp": 920699998,
    "dropphyadd": "420 N TWIN OAKS VALLEY RD",
    "dropphycty": "SAN MARCOS",
    "dropphyst": "CA",
    "dropphyzpp": 920699998,
    "dropmaladd": "420 N TWIN OAKS VALLEY RD",
    "dropmalcty": "SAN MARCOS",
    "dropmalst": "CA",
    "dropmalzpp": 920699998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607442998,
    "dropsitcph": 7607442371,
    "dropfax": 7607444603
  },
  {
    "dcode": "D",
    "dropkey": "PZ22833",
    "droptype": "D",
    "dropname": "SAN MARTIN",
    "dropdeladd": "200 E SAN MARTIN AVE",
    "dropdelcty": "SAN MARTIN",
    "dropdelst": "CA",
    "dropdelzpp": 950469998,
    "dropphyadd": "200 E SAN MARTIN AVE",
    "dropphycty": "SAN MARTIN",
    "dropphyst": "CA",
    "dropphyzpp": 950469998,
    "dropmaladd": "200 E SAN MARTIN AVE",
    "dropmalcty": "SAN MARTIN",
    "dropmalst": "CA",
    "dropmalzpp": 950469998,
    "dropsitphn": 4084376726,
    "dropsitlph": 6692575108,
    "dropsitcph": 4086830429,
    "dropfax": 4086830122
  },
  {
    "dcode": "D",
    "dropkey": "PZ22834",
    "droptype": "D",
    "dropname": "SAN MATEO",
    "dropdeladd": "1630 S DELAWARE ST",
    "dropdelcty": "SAN MATEO",
    "dropdelst": "CA",
    "dropdelzpp": 944029998,
    "dropphyadd": "1630 S DELAWARE ST",
    "dropphycty": "SAN MATEO",
    "dropphyst": "CA",
    "dropphyzpp": 944029998,
    "dropmaladd": "1630 S DELAWARE ST",
    "dropmalcty": "SAN MATEO",
    "dropmalst": "CA",
    "dropmalzpp": 944029998,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503588482,
    "dropsitcph": 6503588490,
    "dropfax": 6503499726
  },
  {
    "dcode": "D",
    "dropkey": "PZ22835",
    "droptype": "D",
    "dropname": "SAN MIGUEL",
    "dropdeladd": "1185 MISSION ST",
    "dropdelcty": "SAN MIGUEL",
    "dropdelst": "CA",
    "dropdelzpp": 934519997,
    "dropphyadd": "1185 MISSION ST",
    "dropphycty": "SAN MIGUEL",
    "dropphyst": "CA",
    "dropphyzpp": 934519997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN MIGUEL",
    "dropmalst": "CA",
    "dropmalzpp": 934519998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054672572,
    "dropsitcph": 8054672502,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ22837",
    "droptype": "D",
    "dropname": "SAN PEDRO",
    "dropdeladd": "839 S BEACON ST",
    "dropdelcty": "SAN PEDRO",
    "dropdelst": "CA",
    "dropdelzpp": 907319998,
    "dropphyadd": "839 S BEACON ST",
    "dropphycty": "SAN PEDRO",
    "dropphyst": "CA",
    "dropphyzpp": 907319998,
    "dropmaladd": "839 S BEACON ST",
    "dropmalcty": "SAN PEDRO",
    "dropmalst": "CA",
    "dropmalzpp": 907319998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3108313222,
    "dropsitcph": 3108310264,
    "dropfax": 3108310137
  },
  {
    "dcode": "D",
    "dropkey": "PZ22838",
    "droptype": "D",
    "dropname": "SAN QUENTIN",
    "dropdeladd": "1 MAIN ST",
    "dropdelcty": "SAN QUENTIN",
    "dropdelst": "CA",
    "dropdelzpp": 949649998,
    "dropphyadd": "1 MAIN ST",
    "dropphycty": "SAN QUENTIN",
    "dropphyst": "CA",
    "dropphyzpp": 949649998,
    "dropmaladd": "1 MAIN ST",
    "dropmalcty": "SAN QUENTIN",
    "dropmalst": "CA",
    "dropmalzpp": 949649998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154564741,
    "dropfax": 4154555398
  },
  {
    "dcode": "D",
    "dropkey": "PZ22839",
    "droptype": "D",
    "dropname": "SAN RAFAEL",
    "dropdeladd": "40 BELLAM BLVD",
    "dropdelcty": "SAN RAFAEL",
    "dropdelst": "CA",
    "dropdelzpp": 949015333,
    "dropphyadd": "40 BELLAM BLVD",
    "dropphycty": "SAN RAFAEL",
    "dropphyst": "CA",
    "dropphyzpp": 949015333,
    "dropmaladd": "40 BELLAM BLVD",
    "dropmalcty": "SAN RAFAEL",
    "dropmalst": "CA",
    "dropmalzpp": 949015333,
    "dropsitphn": 7077785312,
    "dropsitlph": 4154577629,
    "dropsitcph": 4154596643,
    "dropfax": 4154565136
  },
  {
    "dcode": "D",
    "dropkey": "PZ22841",
    "droptype": "D",
    "dropname": "SAN RAMON",
    "dropdeladd": "12935 ALCOSTA BLVD",
    "dropdelcty": "SAN RAMON",
    "dropdelst": "CA",
    "dropdelzpp": 945839998,
    "dropphyadd": "12935 ALCOSTA BLVD",
    "dropphycty": "SAN RAMON",
    "dropphyst": "CA",
    "dropphyzpp": 945839998,
    "dropmaladd": "12935 ALCOSTA BLVD",
    "dropmalcty": "SAN RAMON",
    "dropmalst": "CA",
    "dropmalzpp": 945839998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252771081,
    "dropsitcph": 9252770567,
    "dropfax": 9252771729
  },
  {
    "dcode": "D",
    "dropkey": "PZ22843",
    "droptype": "D",
    "dropname": "SAN SIMEON",
    "dropdeladd": "250 SAN SIMEON AVE STE 7",
    "dropdelcty": "SAN SIMEON",
    "dropdelst": "CA",
    "dropdelzpp": 934529998,
    "dropphyadd": "250 SAN SIMEON AVE STE 7",
    "dropphycty": "SAN SIMEON",
    "dropphyst": "CA",
    "dropphyzpp": 934529998,
    "dropmaladd": "250 SAN SIMEON AVE STE 7",
    "dropmalcty": "SAN SIMEON",
    "dropmalst": "CA",
    "dropmalzpp": 934529998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059274156,
    "dropsitcph": 8059274156,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ22852",
    "droptype": "D",
    "dropname": "SANGER",
    "dropdeladd": "724 O ST",
    "dropdelcty": "SANGER",
    "dropdelst": "CA",
    "dropdelzpp": 936579998,
    "dropphyadd": "724 O ST",
    "dropphycty": "SANGER",
    "dropphyst": "CA",
    "dropphyzpp": 936579998,
    "dropmaladd": "724 O ST",
    "dropmalcty": "SANGER",
    "dropmalst": "CA",
    "dropmalzpp": 936579998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598769040,
    "dropsitcph": 5598769040,
    "dropfax": 5598754971
  },
  {
    "dcode": "D",
    "dropkey": "PZ22856",
    "droptype": "D",
    "dropname": "SANTA ANA",
    "dropdeladd": "2201 N GRAND AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927119998,
    "dropphyadd": "2201 N GRAND AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927119998,
    "dropmaladd": "2201 N GRAND AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927119998,
    "dropsitphn": 7146676734,
    "dropsitlph": 7146676761,
    "dropsitcph": 7146676734,
    "dropfax": 7148352406
  },
  {
    "dcode": "D",
    "dropkey": "PZ22860",
    "droptype": "D",
    "dropname": "SANTA BARBARA",
    "dropdeladd": "836 ANACAPA ST",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931029998,
    "dropphyadd": "836 ANACAPA ST",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931029998,
    "dropmaladd": "836 ANACAPA ST",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055642202,
    "dropsitcph": 8055642226,
    "dropfax": 8055642255
  },
  {
    "dcode": "D",
    "dropkey": "PZ22862",
    "droptype": "D",
    "dropname": "SANTA CLARA",
    "dropdeladd": "1200 FRANKLIN MALL",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "CA",
    "dropdelzpp": 950509998,
    "dropphyadd": "1200 FRANKLIN MALL",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "CA",
    "dropphyzpp": 950509998,
    "dropmaladd": "1200 FRANKLIN MALL",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "CA",
    "dropmalzpp": 950509998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082961026,
    "dropsitcph": 4082960205,
    "dropfax": 4082965372
  },
  {
    "dcode": "D",
    "dropkey": "PZ22864",
    "droptype": "D",
    "dropname": "SANTA CLARITA",
    "dropdeladd": "24355 CREEKSIDE RD",
    "dropdelcty": "SANTA CLARITA",
    "dropdelst": "CA",
    "dropdelzpp": 913559998,
    "dropphyadd": "24355 CREEKSIDE RD",
    "dropphycty": "SANTA CLARITA",
    "dropphyst": "CA",
    "dropphyzpp": 913559998,
    "dropmaladd": "24355 CREEKSIDE RD",
    "dropmalcty": "SANTA CLARITA",
    "dropmalst": "CA",
    "dropmalzpp": 913559998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612543270,
    "dropsitcph": 6612543270,
    "dropfax": 6612547318
  },
  {
    "dcode": "D",
    "dropkey": "PZ22865",
    "droptype": "D",
    "dropname": "SANTA CRUZ",
    "dropdeladd": "850 FRONT ST",
    "dropdelcty": "SANTA CRUZ",
    "dropdelst": "CA",
    "dropdelzpp": 950609998,
    "dropphyadd": "850 FRONT ST",
    "dropphycty": "SANTA CRUZ",
    "dropphyst": "CA",
    "dropphyzpp": 950609998,
    "dropmaladd": "850 FRONT ST",
    "dropmalcty": "SANTA CRUZ",
    "dropmalst": "CA",
    "dropmalzpp": 950609998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314260144,
    "dropsitcph": 8314260144,
    "dropfax": 8314269154
  },
  {
    "dcode": "D",
    "dropkey": "PZ22868",
    "droptype": "D",
    "dropname": "SANTA FE SPRINGS",
    "dropdeladd": "11760 TELEGRAPH RD",
    "dropdelcty": "SANTA FE SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 906709998,
    "dropphyadd": "11760 TELEGRAPH RD",
    "dropphycty": "SANTA FE SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 906709998,
    "dropmaladd": "11760 TELEGRAPH RD",
    "dropmalcty": "SANTA FE SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 906709998,
    "dropsitphn": 5628680951,
    "dropsitlph": 5629296759,
    "dropsitcph": 5628680951,
    "dropfax": 5628647691
  },
  {
    "dcode": "D",
    "dropkey": "PZ22870",
    "droptype": "D",
    "dropname": "SANTA MARGARITA",
    "dropdeladd": "22360 EL CAMINO REAL",
    "dropdelcty": "SANTA MARGARITA",
    "dropdelst": "CA",
    "dropdelzpp": 934538628,
    "dropphyadd": "22360 EL CAMINO REAL",
    "dropphycty": "SANTA MARGARITA",
    "dropphyst": "CA",
    "dropphyzpp": 934538628,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA MARGARITA",
    "dropmalst": "CA",
    "dropmalzpp": 934539998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054383943,
    "dropsitcph": 8054383950,
    "dropfax": 8054383080
  },
  {
    "dcode": "D",
    "dropkey": "PZ22871",
    "droptype": "D",
    "dropname": "SANTA MARIA",
    "dropdeladd": "201 E BATTLES RD",
    "dropdelcty": "SANTA MARIA",
    "dropdelst": "CA",
    "dropdelzpp": 934547299,
    "dropphyadd": "201 E BATTLES RD",
    "dropphycty": "SANTA MARIA",
    "dropphyst": "CA",
    "dropphyzpp": 934547299,
    "dropmaladd": "201 E BATTLES RD",
    "dropmalcty": "SANTA MARIA",
    "dropmalst": "CA",
    "dropmalzpp": 934547299,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059220321,
    "dropsitcph": 8059220321,
    "dropfax": 8059282451
  },
  {
    "dcode": "D",
    "dropkey": "PZ22872",
    "droptype": "D",
    "dropname": "SANTA MONICA",
    "dropdeladd": "1653 7TH ST",
    "dropdelcty": "SANTA MONICA",
    "dropdelst": "CA",
    "dropdelzpp": 904019997,
    "dropphyadd": "1653 7TH ST",
    "dropphycty": "SANTA MONICA",
    "dropphyst": "CA",
    "dropphyzpp": 904019997,
    "dropmaladd": "1653 7TH ST",
    "dropmalcty": "SANTA MONICA",
    "dropmalst": "CA",
    "dropmalzpp": 904019997,
    "dropsitphn": 5624942406,
    "dropsitlph": 3102550446,
    "dropsitcph": 3102550446,
    "dropfax": 3105760076
  },
  {
    "dcode": "D",
    "dropkey": "PZ22874",
    "droptype": "D",
    "dropname": "SANTA PAULA",
    "dropdeladd": "111 S MILL ST",
    "dropdelcty": "SANTA PAULA",
    "dropdelst": "CA",
    "dropdelzpp": 930609998,
    "dropphyadd": "111 S MILL ST",
    "dropphycty": "SANTA PAULA",
    "dropphyst": "CA",
    "dropphyzpp": 930609998,
    "dropmaladd": "111 S MILL ST",
    "dropmalcty": "SANTA PAULA",
    "dropmalst": "CA",
    "dropmalzpp": 930609998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059330832,
    "dropsitcph": 8059330832,
    "dropfax": 8055257531
  },
  {
    "dcode": "D",
    "dropkey": "PZ22875",
    "droptype": "D",
    "dropname": "SANTA RITA PARK",
    "dropdeladd": "8100 W AZUSA RD",
    "dropdelcty": "SANTA RITA PARK",
    "dropdelst": "CA",
    "dropdelzpp": 936619998,
    "dropphyadd": "8100 W AZUSA RD",
    "dropphycty": "SANTA RITA PARK",
    "dropphyst": "CA",
    "dropphyzpp": 936619998,
    "dropmaladd": "8100 W AZUSA RD",
    "dropmalcty": "SANTA RITA PARK",
    "dropmalst": "CA",
    "dropmalzpp": 936619998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 2093874501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22876",
    "droptype": "D",
    "dropname": "SANTA ROSA",
    "dropdeladd": "730 2ND ST",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "CA",
    "dropdelzpp": 954044750,
    "dropphyadd": "730 2ND ST",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "CA",
    "dropphyzpp": 954044750,
    "dropmaladd": "730 2ND ST",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "CA",
    "dropmalzpp": 954044750,
    "dropsitphn": 7075288768,
    "dropsitlph": 7075288783,
    "dropsitcph": 7075282209,
    "dropfax": 7075452122
  },
  {
    "dcode": "D",
    "dropkey": "PZ22882",
    "droptype": "D",
    "dropname": "SANTA YNEZ",
    "dropdeladd": "3564 SAGUNTO ST",
    "dropdelcty": "SANTA YNEZ",
    "dropdelst": "CA",
    "dropdelzpp": 934609110,
    "dropphyadd": "3564 SAGUNTO ST",
    "dropphycty": "SANTA YNEZ",
    "dropphyst": "CA",
    "dropphyzpp": 934609110,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA YNEZ",
    "dropmalst": "CA",
    "dropmalzpp": 934609998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056881382,
    "dropsitcph": 8056939287,
    "dropfax": 8056881539
  },
  {
    "dcode": "D",
    "dropkey": "PZ22883",
    "droptype": "D",
    "dropname": "SANTA YSABEL",
    "dropdeladd": "21977 HIGHWAY 79",
    "dropdelcty": "SANTA YSABEL",
    "dropdelst": "CA",
    "dropdelzpp": 920709998,
    "dropphyadd": "21977 HIGHWAY 79",
    "dropphycty": "SANTA YSABEL",
    "dropphyst": "CA",
    "dropphyzpp": 920709998,
    "dropmaladd": "21977 HIGHWAY 79",
    "dropmalcty": "SANTA YSABEL",
    "dropmalst": "CA",
    "dropmalzpp": 920709998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607650441,
    "dropsitcph": 7607650441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22884",
    "droptype": "D",
    "dropname": "SANTEE",
    "dropdeladd": "9518 MISSION GORGE RD",
    "dropdelcty": "SANTEE",
    "dropdelst": "CA",
    "dropdelzpp": 920719998,
    "dropphyadd": "9518 MISSION GORGE RD",
    "dropphycty": "SANTEE",
    "dropphyst": "CA",
    "dropphyzpp": 920719998,
    "dropmaladd": "9518 MISSION GORGE RD",
    "dropmalcty": "SANTEE",
    "dropmalst": "CA",
    "dropmalzpp": 920719998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194488512,
    "dropsitcph": 6194482177,
    "dropfax": 6194485497
  },
  {
    "dcode": "D",
    "dropkey": "PZ22886",
    "droptype": "D",
    "dropname": "SARATOGA",
    "dropdeladd": "19630 ALLENDALE AVE",
    "dropdelcty": "SARATOGA",
    "dropdelst": "CA",
    "dropdelzpp": 950709998,
    "dropphyadd": "19630 ALLENDALE AVE",
    "dropphycty": "SARATOGA",
    "dropphyst": "CA",
    "dropphyzpp": 950709998,
    "dropmaladd": "19630 ALLENDALE AVE",
    "dropmalcty": "SARATOGA",
    "dropmalst": "CA",
    "dropmalzpp": 950709998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4088671159,
    "dropsitcph": 4088671159,
    "dropfax": 4088670860
  },
  {
    "dcode": "D",
    "dropkey": "PZ22891",
    "droptype": "D",
    "dropname": "SATTLEY",
    "dropdeladd": "103 COUNTY RD",
    "dropdelcty": "CALPINE",
    "dropdelst": "CA",
    "dropdelzpp": 961249995,
    "dropphyadd": "103 COUNTY RD",
    "dropphycty": "CALPINE",
    "dropphyst": "CA",
    "dropphyzpp": 961249995,
    "dropmaladd": "103 COUNTY RD",
    "dropmalcty": "CALPINE",
    "dropmalst": "CA",
    "dropmalzpp": 961249995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5309943508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22893",
    "droptype": "D",
    "dropname": "SAUSALITO",
    "dropdeladd": "150 HARBOR DR",
    "dropdelcty": "SAUSALITO",
    "dropdelst": "CA",
    "dropdelzpp": 949659998,
    "dropphyadd": "150 HARBOR DR",
    "dropphycty": "SAUSALITO",
    "dropphyst": "CA",
    "dropphyzpp": 949659998,
    "dropmaladd": "150 HARBOR DR",
    "dropmalcty": "SAUSALITO",
    "dropmalst": "CA",
    "dropmalzpp": 949659998,
    "dropsitphn": 7077785312,
    "dropsitlph": 4153320285,
    "dropsitcph": 4153320227,
    "dropfax": 4153327519
  },
  {
    "dcode": "D",
    "dropkey": "PZ22897",
    "droptype": "D",
    "dropname": "SCOTIA",
    "dropdeladd": "116 MAIN ST",
    "dropdelcty": "SCOTIA",
    "dropdelst": "CA",
    "dropdelzpp": 955659998,
    "dropphyadd": "116 MAIN ST",
    "dropphycty": "SCOTIA",
    "dropphyst": "CA",
    "dropphyzpp": 955659998,
    "dropmaladd": "116 MAIN ST",
    "dropmalcty": "SCOTIA",
    "dropmalst": "CA",
    "dropmalzpp": 955659998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077643772,
    "dropfax": 7077643430
  },
  {
    "dcode": "D",
    "dropkey": "PZ22898",
    "droptype": "D",
    "dropname": "SCOTT BAR",
    "dropdeladd": "27233 SCOTT RIVER RD",
    "dropdelcty": "SCOTT BAR",
    "dropdelst": "CA",
    "dropdelzpp": 960859998,
    "dropphyadd": "27233 SCOTT RIVER RD",
    "dropphycty": "SCOTT BAR",
    "dropphyst": "CA",
    "dropphyzpp": 960859998,
    "dropmaladd": "27233 SCOTT RIVER RD",
    "dropmalcty": "SCOTT BAR",
    "dropmalst": "CA",
    "dropmalzpp": 960859998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304963248,
    "dropsitcph": 5304963248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22904",
    "droptype": "D",
    "dropname": "SEAL BEACH",
    "dropdeladd": "2929 WESTMINSTER AVE",
    "dropdelcty": "SEAL BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 907409998,
    "dropphyadd": "2929 WESTMINSTER AVE",
    "dropphycty": "SEAL BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 907409998,
    "dropmaladd": "2929 WESTMINSTER AVE",
    "dropmalcty": "SEAL BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 907409998,
    "dropsitphn": 5624313641,
    "dropsitlph": 5624313641,
    "dropsitcph": 5625986915,
    "dropfax": 5625988785
  },
  {
    "dcode": "D",
    "dropkey": "PZ22907",
    "droptype": "D",
    "dropname": "SEASIDE",
    "dropdeladd": "1093 BROADWAY AVE",
    "dropdelcty": "SEASIDE",
    "dropdelst": "CA",
    "dropdelzpp": 939559998,
    "dropphyadd": "1093 BROADWAY AVE",
    "dropphycty": "SEASIDE",
    "dropphyst": "CA",
    "dropphyzpp": 939559998,
    "dropmaladd": "1093 BROADWAY AVE",
    "dropmalcty": "SEASIDE",
    "dropmalst": "CA",
    "dropmalzpp": 939559998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313946403,
    "dropsitcph": 8313946329,
    "dropfax": 8313942997
  },
  {
    "dcode": "D",
    "dropkey": "PZ22909",
    "droptype": "D",
    "dropname": "SEBASTOPOL",
    "dropdeladd": "290 S MAIN ST",
    "dropdelcty": "SEBASTOPOL",
    "dropdelst": "CA",
    "dropdelzpp": 954729917,
    "dropphyadd": "290 S MAIN ST",
    "dropphycty": "SEBASTOPOL",
    "dropphyst": "CA",
    "dropphyzpp": 954729917,
    "dropmaladd": "290 S MAIN ST",
    "dropmalcty": "SEBASTOPOL",
    "dropmalst": "CA",
    "dropmalzpp": 954729917,
    "dropsitphn": 7078299362,
    "dropsitlph": 7078237216,
    "dropsitcph": 7078231427,
    "dropfax": 7078232641
  },
  {
    "dcode": "D",
    "dropkey": "PZ22911",
    "droptype": "D",
    "dropname": "SEELEY",
    "dropdeladd": "1801 W PARK ST",
    "dropdelcty": "SEELEY",
    "dropdelst": "CA",
    "dropdelzpp": 922739800,
    "dropphyadd": "1801 W PARK ST",
    "dropphycty": "SEELEY",
    "dropphyst": "CA",
    "dropphyzpp": 922739800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SEELEY",
    "dropmalst": "CA",
    "dropmalzpp": 922739998,
    "dropsitphn": 9093354457,
    "dropsitlph": 7603531065,
    "dropsitcph": 7603531065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22912",
    "droptype": "D",
    "dropname": "SEIAD VALLEY",
    "dropdeladd": "44717 STATE HIGHWAY 96",
    "dropdelcty": "SEIAD VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 960869998,
    "dropphyadd": "44717 STATE HIGHWAY 96",
    "dropphycty": "SEIAD VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 960869998,
    "dropmaladd": "44717 STATE HIGHWAY 96",
    "dropmalcty": "SEIAD VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 960869998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304963211,
    "dropsitcph": 5304963211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22915",
    "droptype": "D",
    "dropname": "SELMA",
    "dropdeladd": "2058 HIGH ST",
    "dropdelcty": "SELMA",
    "dropdelst": "CA",
    "dropdelzpp": 936629998,
    "dropphyadd": "2058 HIGH ST",
    "dropphycty": "SELMA",
    "dropphyst": "CA",
    "dropphyzpp": 936629998,
    "dropmaladd": "2058 HIGH ST",
    "dropmalcty": "SELMA",
    "dropmalst": "CA",
    "dropmalzpp": 936629998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598965947,
    "dropsitcph": 5598964940,
    "dropfax": 5598966323
  },
  {
    "dcode": "D",
    "dropkey": "PZ22928",
    "droptype": "D",
    "dropname": "SHAFTER",
    "dropdeladd": "322 STATE AVE",
    "dropdelcty": "SHAFTER",
    "dropdelst": "CA",
    "dropdelzpp": 932639998,
    "dropphyadd": "322 STATE AVE",
    "dropphycty": "SHAFTER",
    "dropphyst": "CA",
    "dropphyzpp": 932639998,
    "dropmaladd": "322 STATE AVE",
    "dropmalcty": "SHAFTER",
    "dropmalst": "CA",
    "dropmalzpp": 932639998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617461502,
    "dropsitcph": 6617461502,
    "dropfax": 6617461034
  },
  {
    "dcode": "D",
    "dropkey": "PZ22929",
    "droptype": "D",
    "dropname": "SHANDON",
    "dropdeladd": "200 E CENTRE ST",
    "dropdelcty": "SHANDON",
    "dropdelst": "CA",
    "dropdelzpp": 934619997,
    "dropphyadd": "200 E CENTRE ST",
    "dropphycty": "SHANDON",
    "dropphyst": "CA",
    "dropphyzpp": 934619997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SHANDON",
    "dropmalst": "CA",
    "dropmalzpp": 934619998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8052381392,
    "dropsitcph": 8052381392,
    "dropfax": 8052378479
  },
  {
    "dcode": "D",
    "dropkey": "PZ22936",
    "droptype": "D",
    "dropname": "SHASTA",
    "dropdeladd": "15430 STATE HIGHWAY 299 W",
    "dropdelcty": "SHASTA",
    "dropdelst": "CA",
    "dropdelzpp": 960879998,
    "dropphyadd": "15430 STATE HIGHWAY 299 W",
    "dropphycty": "SHASTA",
    "dropphyst": "CA",
    "dropphyzpp": 960879998,
    "dropmaladd": "15430 STATE HIGHWAY 299 W",
    "dropmalcty": "SHASTA",
    "dropmalst": "CA",
    "dropmalzpp": 960879998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302419431,
    "dropsitcph": 5302419431,
    "dropfax": 5302414856
  },
  {
    "dcode": "D",
    "dropkey": "PZ22940",
    "droptype": "D",
    "dropname": "SHAVER LAKE",
    "dropdeladd": "40677 SHAVER FOREST RD",
    "dropdelcty": "SHAVER LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 936649998,
    "dropphyadd": "40677 SHAVER FOREST RD",
    "dropphycty": "SHAVER LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 936649998,
    "dropmaladd": "40677 SHAVER FOREST RD",
    "dropmalcty": "SHAVER LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 936649998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598413678,
    "dropfax": 5598418312
  },
  {
    "dcode": "D",
    "dropkey": "PZ22945",
    "droptype": "D",
    "dropname": "SHERIDAN",
    "dropdeladd": "5730 SHERIDAN LINCOLN BLVD",
    "dropdelcty": "SHERIDAN",
    "dropdelst": "CA",
    "dropdelzpp": 956819998,
    "dropphyadd": "5730 SHERIDAN LINCOLN BLVD",
    "dropphycty": "SHERIDAN",
    "dropphyst": "CA",
    "dropphyzpp": 956819998,
    "dropmaladd": "5730 SHERIDAN LINCOLN BLVD",
    "dropmalcty": "SHERIDAN",
    "dropmalst": "CA",
    "dropmalzpp": 956819998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306332311,
    "dropsitcph": 5306332311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22953",
    "droptype": "D",
    "dropname": "SHINGLE SPRINGS",
    "dropdeladd": "4131 S SHINGLE RD STE 6",
    "dropdelcty": "SHINGLE SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 956829998,
    "dropphyadd": "4131 S SHINGLE RD STE 6",
    "dropphycty": "SHINGLE SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 956829998,
    "dropmaladd": "4131 S SHINGLE RD STE 6",
    "dropmalcty": "SHINGLE SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 956829998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303873917,
    "dropsitcph": 5306770292,
    "dropfax": 5303873925
  },
  {
    "dcode": "D",
    "dropkey": "PZ22954",
    "droptype": "D",
    "dropname": "SHINGLETOWN",
    "dropdeladd": "31268 STATE HIGHWAY 44 STE B",
    "dropdelcty": "SHINGLETOWN",
    "dropdelst": "CA",
    "dropdelzpp": 960889998,
    "dropphyadd": "31268 STATE HIGHWAY 44 STE B",
    "dropphycty": "SHINGLETOWN",
    "dropphyst": "CA",
    "dropphyzpp": 960889998,
    "dropmaladd": "31268 STATE HIGHWAY 44 STE B",
    "dropmalcty": "SHINGLETOWN",
    "dropmalst": "CA",
    "dropmalzpp": 960889998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304741942,
    "dropsitcph": 5304741942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22956",
    "droptype": "D",
    "dropname": "SHOSHONE",
    "dropdeladd": "113 N STATE HIGHWAY 127",
    "dropdelcty": "SHOSHONE",
    "dropdelst": "CA",
    "dropdelzpp": 923849998,
    "dropphyadd": "113 N STATE HIGHWAY 127",
    "dropphycty": "SHOSHONE",
    "dropphyst": "CA",
    "dropphyzpp": 923849998,
    "dropmaladd": "113 N STATE HIGHWAY 127",
    "dropmalcty": "SHOSHONE",
    "dropmalst": "CA",
    "dropmalzpp": 923849998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7608524212,
    "dropsitcph": 7608524212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22958",
    "droptype": "D",
    "dropname": "SIERRA CITY",
    "dropdeladd": "215 MAIN ST",
    "dropdelcty": "SIERRA CITY",
    "dropdelst": "CA",
    "dropdelzpp": 961259995,
    "dropphyadd": "215 MAIN ST",
    "dropphycty": "SIERRA CITY",
    "dropphyst": "CA",
    "dropphyzpp": 961259995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIERRA CITY",
    "dropmalst": "CA",
    "dropmalzpp": 961259998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5308621152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22959",
    "droptype": "D",
    "dropname": "SIERRA MADRE",
    "dropdeladd": "61 S BALDWIN AVE",
    "dropdelcty": "SIERRA MADRE",
    "dropdelst": "CA",
    "dropdelzpp": 910249998,
    "dropphyadd": "61 S BALDWIN AVE",
    "dropphycty": "SIERRA MADRE",
    "dropphyst": "CA",
    "dropphyzpp": 910249998,
    "dropmaladd": "61 S BALDWIN AVE",
    "dropmalcty": "SIERRA MADRE",
    "dropmalst": "CA",
    "dropmalzpp": 910249998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6268363646,
    "dropsitcph": 6268363596,
    "dropfax": 6263558231
  },
  {
    "dcode": "D",
    "dropkey": "PZ22960",
    "droptype": "D",
    "dropname": "SIERRAVILLE",
    "dropdeladd": "306 LINCOLN ST",
    "dropdelcty": "SIERRAVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961269995,
    "dropphyadd": "306 LINCOLN ST",
    "dropphycty": "SIERRAVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961269995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SIERRAVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961269998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5309943460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22967",
    "droptype": "D",
    "dropname": "SILVERADO",
    "dropdeladd": "28251 SILVERADO CANYON RD",
    "dropdelcty": "SILVERADO",
    "dropdelst": "CA",
    "dropdelzpp": 926769899,
    "dropphyadd": "28251 SILVERADO CANYON RD",
    "dropphycty": "SILVERADO",
    "dropphyst": "CA",
    "dropphyzpp": 926769899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SILVERADO",
    "dropmalst": "CA",
    "dropmalzpp": 926769998,
    "dropsitphn": 7146493076,
    "dropsitlph": 7146493184,
    "dropsitcph": 7146493076,
    "dropfax": 7146490522
  },
  {
    "dcode": "D",
    "dropkey": "PZ22970",
    "droptype": "D",
    "dropname": "SIMI VALLEY",
    "dropdeladd": "2551 GALENA AVE",
    "dropdelcty": "SIMI VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 930659998,
    "dropphyadd": "2551 GALENA AVE",
    "dropphycty": "SIMI VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 930659998,
    "dropmaladd": "2551 GALENA AVE",
    "dropmalcty": "SIMI VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 930659998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055269819,
    "dropsitcph": 8055269819,
    "dropfax": 8054223926
  },
  {
    "dcode": "D",
    "dropkey": "PZ22978",
    "droptype": "D",
    "dropname": "SKYFOREST",
    "dropdeladd": "951 KUFFEL CANYON RD",
    "dropdelcty": "SKYFOREST",
    "dropdelst": "CA",
    "dropdelzpp": 923850400,
    "dropphyadd": "951 KUFFEL CANYON RD",
    "dropphycty": "SKYFOREST",
    "dropphyst": "CA",
    "dropphyzpp": 923850400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SKYFOREST",
    "dropmalst": "CA",
    "dropmalzpp": 923859998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093371419,
    "dropsitcph": 9093371419,
    "dropfax": 9093372929
  },
  {
    "dcode": "D",
    "dropkey": "PZ22983",
    "droptype": "D",
    "dropname": "SLOUGHHOUSE",
    "dropdeladd": "7268 MURIETA DR",
    "dropdelcty": "SLOUGHHOUSE",
    "dropdelst": "CA",
    "dropdelzpp": 956839998,
    "dropphyadd": "7268 MURIETA DR",
    "dropphycty": "SLOUGHHOUSE",
    "dropphyst": "CA",
    "dropphyzpp": 956839998,
    "dropmaladd": "7268 MURIETA DR",
    "dropmalcty": "SLOUGHHOUSE",
    "dropmalst": "CA",
    "dropmalzpp": 956839998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163541673,
    "dropsitcph": 9163548447,
    "dropfax": 9163548447
  },
  {
    "dcode": "D",
    "dropkey": "PZ22984",
    "droptype": "D",
    "dropname": "SMARTSVILLE",
    "dropdeladd": "8482 SMARTSVILLE RD",
    "dropdelcty": "SMARTSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959779998,
    "dropphyadd": "8482 SMARTSVILLE RD",
    "dropphycty": "SMARTSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959779998,
    "dropmaladd": "8482 SMARTSVILLE RD",
    "dropmalcty": "SMARTSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959779998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306392241,
    "dropsitcph": 5306392241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ22988",
    "droptype": "D",
    "dropname": "SMITH RIVER",
    "dropdeladd": "291 N FRED D HAIGHT DR",
    "dropdelcty": "SMITH RIVER",
    "dropdelst": "CA",
    "dropdelzpp": 955679998,
    "dropphyadd": "291 N FRED D HAIGHT DR",
    "dropphycty": "SMITH RIVER",
    "dropphyst": "CA",
    "dropphyzpp": 955679998,
    "dropmaladd": "291 N FRED D HAIGHT DR",
    "dropmalcty": "SMITH RIVER",
    "dropmalst": "CA",
    "dropmalzpp": 955679998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074872895,
    "dropfax": 7074870319
  },
  {
    "dcode": "D",
    "dropkey": "PZ23013",
    "droptype": "D",
    "dropname": "SNELLING",
    "dropdeladd": "15906 LEWIS ST",
    "dropdelcty": "SNELLING",
    "dropdelst": "CA",
    "dropdelzpp": 953699998,
    "dropphyadd": "15906 LEWIS ST",
    "dropphycty": "SNELLING",
    "dropphyst": "CA",
    "dropphyzpp": 953699998,
    "dropmaladd": "15906 LEWIS ST",
    "dropmalcty": "SNELLING",
    "dropmalst": "CA",
    "dropmalzpp": 953699998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095636582,
    "dropsitcph": 2095636582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23028",
    "droptype": "D",
    "dropname": "SODA SPRINGS",
    "dropdeladd": "21719 DONNER PASS RD",
    "dropdelcty": "SODA SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 957289998,
    "dropphyadd": "21719 DONNER PASS RD",
    "dropphycty": "SODA SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 957289998,
    "dropmaladd": "21719 DONNER PASS RD",
    "dropmalcty": "SODA SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 957289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304263082,
    "dropsitcph": 5304263082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23030",
    "droptype": "D",
    "dropname": "SOLANA BEACH",
    "dropdeladd": "153 S SIERRA AVE",
    "dropdelcty": "SOLANA BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 920759998,
    "dropphyadd": "153 S SIERRA AVE",
    "dropphycty": "SOLANA BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 920759998,
    "dropmaladd": "153 S SIERRA AVE",
    "dropmalcty": "SOLANA BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 920759998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8587932414,
    "dropsitcph": 8587931667,
    "dropfax": 8587556376
  },
  {
    "dcode": "D",
    "dropkey": "PZ23031",
    "droptype": "D",
    "dropname": "SOLEDAD",
    "dropdeladd": "150 KIDDER ST",
    "dropdelcty": "SOLEDAD",
    "dropdelst": "CA",
    "dropdelzpp": 939609998,
    "dropphyadd": "150 KIDDER ST",
    "dropphycty": "SOLEDAD",
    "dropphyst": "CA",
    "dropphyzpp": 939609998,
    "dropmaladd": "150 KIDDER ST",
    "dropmalcty": "SOLEDAD",
    "dropmalst": "CA",
    "dropmalzpp": 939609998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316789122,
    "dropsitcph": 8316789072,
    "dropfax": 8316788022
  },
  {
    "dcode": "D",
    "dropkey": "PZ23033",
    "droptype": "D",
    "dropname": "SOLVANG",
    "dropdeladd": "430 ALISAL RD",
    "dropdelcty": "SOLVANG",
    "dropdelst": "CA",
    "dropdelzpp": 934639998,
    "dropphyadd": "430 ALISAL RD",
    "dropphycty": "SOLVANG",
    "dropphyst": "CA",
    "dropphyzpp": 934639998,
    "dropmaladd": "430 ALISAL RD",
    "dropmalcty": "SOLVANG",
    "dropmalst": "CA",
    "dropmalzpp": 934639998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056889309,
    "dropsitcph": 8056889309,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "PZ23034",
    "droptype": "D",
    "dropname": "SOMERSET",
    "dropdeladd": "6040 GRIZZLY FLAT RD",
    "dropdelcty": "SOMERSET",
    "dropdelst": "CA",
    "dropdelzpp": 956849900,
    "dropphyadd": "6040 GRIZZLY FLAT RD",
    "dropphycty": "SOMERSET",
    "dropphyst": "CA",
    "dropphyzpp": 956849900,
    "dropmaladd": "6040 GRIZZLY FLAT RD",
    "dropmalcty": "SOMERSET",
    "dropmalst": "CA",
    "dropmalzpp": 956849900,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306225498,
    "dropsitcph": 5306225498,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23037",
    "droptype": "D",
    "dropname": "SOMIS",
    "dropdeladd": "3349 SOMIS RD",
    "dropdelcty": "SOMIS",
    "dropdelst": "CA",
    "dropdelzpp": 930669997,
    "dropphyadd": "3349 SOMIS RD",
    "dropphycty": "SOMIS",
    "dropphyst": "CA",
    "dropphyzpp": 930669997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SOMIS",
    "dropmalst": "CA",
    "dropmalzpp": 930669998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8053864793,
    "dropsitcph": 8053864093,
    "dropfax": 8053863013
  },
  {
    "dcode": "D",
    "dropkey": "PZ23038",
    "droptype": "D",
    "dropname": "SONOMA",
    "dropdeladd": "617 BROADWAY",
    "dropdelcty": "SONOMA",
    "dropdelst": "CA",
    "dropdelzpp": 954769998,
    "dropphyadd": "617 BROADWAY",
    "dropphycty": "SONOMA",
    "dropphyst": "CA",
    "dropphyzpp": 954769998,
    "dropmaladd": "617 BROADWAY",
    "dropmalcty": "SONOMA",
    "dropmalst": "CA",
    "dropmalzpp": 954769998,
    "dropsitphn": 7079969311,
    "dropsitlph": 7079965210,
    "dropsitcph": 7079969311,
    "dropfax": 7079961752
  },
  {
    "dcode": "D",
    "dropkey": "PZ23040",
    "droptype": "D",
    "dropname": "SONORA",
    "dropdeladd": "781 S WASHINGTON ST",
    "dropdelcty": "SONORA",
    "dropdelst": "CA",
    "dropdelzpp": 953709998,
    "dropphyadd": "781 S WASHINGTON ST",
    "dropphycty": "SONORA",
    "dropphyst": "CA",
    "dropphyzpp": 953709998,
    "dropmaladd": "781 S WASHINGTON ST",
    "dropmalcty": "SONORA",
    "dropmalst": "CA",
    "dropmalzpp": 953709998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095333499,
    "dropsitcph": 2095333670,
    "dropfax": 2095326389
  },
  {
    "dcode": "D",
    "dropkey": "PZ23041",
    "droptype": "D",
    "dropname": "SOQUEL",
    "dropdeladd": "4768 SOQUEL DR",
    "dropdelcty": "SOQUEL",
    "dropdelst": "CA",
    "dropdelzpp": 950732450,
    "dropphyadd": "4768 SOQUEL DR",
    "dropphycty": "SOQUEL",
    "dropphyst": "CA",
    "dropphyzpp": 950732450,
    "dropmaladd": "4768 SOQUEL DR",
    "dropmalcty": "SOQUEL",
    "dropmalst": "CA",
    "dropmalzpp": 950739998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314628551,
    "dropsitcph": 8314628551,
    "dropfax": 8314628552
  },
  {
    "dcode": "D",
    "dropkey": "PZ23044",
    "droptype": "D",
    "dropname": "SOULSBYVILLE",
    "dropdeladd": "20489 WILLOW SPRINGS DR",
    "dropdelcty": "SOULSBYVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 953729998,
    "dropphyadd": "20489 WILLOW SPRINGS DR",
    "dropphycty": "SOULSBYVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 953729998,
    "dropmaladd": "20489 WILLOW SPRINGS DR",
    "dropmalcty": "SOULSBYVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 953729998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095326782,
    "dropsitcph": 2095326782,
    "dropfax": 2095326395
  },
  {
    "dcode": "D",
    "dropkey": "PZ23051",
    "droptype": "D",
    "dropname": "SOUTH DOS PALOS",
    "dropdeladd": "8858 W M ST",
    "dropdelcty": "SOUTH DOS PALOS",
    "dropdelst": "CA",
    "dropdelzpp": 936659998,
    "dropphyadd": "8858 W M ST",
    "dropphycty": "SOUTH DOS PALOS",
    "dropphyst": "CA",
    "dropphyzpp": 936659998,
    "dropmaladd": "8858 W M ST",
    "dropmalcty": "SOUTH DOS PALOS",
    "dropmalst": "CA",
    "dropmalzpp": 936659998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 2093926381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23055",
    "droptype": "D",
    "dropname": "SOUTH GATE",
    "dropdeladd": "10120 WRIGHT RD",
    "dropdelcty": "SOUTH GATE",
    "dropdelst": "CA",
    "dropdelzpp": 902809998,
    "dropphyadd": "10120 WRIGHT RD",
    "dropphycty": "SOUTH GATE",
    "dropphyst": "CA",
    "dropphyzpp": 902809998,
    "dropmaladd": "10120 WRIGHT RD",
    "dropmalcty": "SOUTH GATE",
    "dropmalst": "CA",
    "dropmalzpp": 902809998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3232140140,
    "dropsitcph": 3235664334,
    "dropfax": 3235663748
  },
  {
    "dcode": "D",
    "dropkey": "PZ23059",
    "droptype": "D",
    "dropname": "SOUTH LAKE TAHOE",
    "dropdeladd": "1046 AL TAHOE BLVD",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961509998,
    "dropphyadd": "1046 AL TAHOE BLVD",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961509998,
    "dropmaladd": "1046 AL TAHOE BLVD",
    "dropmalcty": "SOUTH LAKE TAHOE",
    "dropmalst": "CA",
    "dropmalzpp": 961509998,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305443367,
    "dropsitcph": 5305445867,
    "dropfax": 5305448133
  },
  {
    "dcode": "D",
    "dropkey": "PZ23064",
    "droptype": "D",
    "dropname": "SOUTH PASADENA",
    "dropdeladd": "1001 FREMONT AVE",
    "dropdelcty": "SOUTH PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 910309998,
    "dropphyadd": "1001 FREMONT AVE",
    "dropphycty": "SOUTH PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 910309998,
    "dropmaladd": "1001 FREMONT AVE",
    "dropmalcty": "SOUTH PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 910309998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6267991436,
    "dropsitcph": 6267993024,
    "dropfax": 6267990684
  },
  {
    "dcode": "D",
    "dropkey": "PZ23085",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "10174 AUSTIN DR",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 919779998,
    "dropphyadd": "10174 AUSTIN DR",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 919779998,
    "dropmaladd": "10174 AUSTIN DR",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 919779998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196605730,
    "dropsitcph": 6196605728,
    "dropfax": 6196706085
  },
  {
    "dcode": "D",
    "dropkey": "PZ23089",
    "droptype": "D",
    "dropname": "SPRINGVILLE",
    "dropdeladd": "35701 HIGHWAY 190",
    "dropdelcty": "SPRINGVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 932659998,
    "dropphyadd": "35701 HIGHWAY 190",
    "dropphycty": "SPRINGVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 932659998,
    "dropmaladd": "35701 HIGHWAY 190",
    "dropmalcty": "SPRINGVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 932659998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595396000,
    "dropsitcph": 5595396000,
    "dropfax": 5595392891
  },
  {
    "dcode": "D",
    "dropkey": "PZ23381",
    "droptype": "D",
    "dropname": "STANDISH",
    "dropdeladd": "718-650 US HIGHWAY 395 E",
    "dropdelcty": "STANDISH",
    "dropdelst": "CA",
    "dropdelzpp": 961289068,
    "dropphyadd": "718-650 US HIGHWAY 395 E",
    "dropphycty": "STANDISH",
    "dropphyst": "CA",
    "dropphyzpp": 961289068,
    "dropmaladd": "718-650 US HIGHWAY 395 E",
    "dropmalcty": "STANDISH",
    "dropmalst": "CA",
    "dropmalzpp": 961289068,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302546547,
    "dropfax": 5302546873
  },
  {
    "dcode": "D",
    "dropkey": "PZ23384",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "10440 BEACH BLVD",
    "dropdelcty": "STANTON",
    "dropdelst": "CA",
    "dropdelzpp": 906809998,
    "dropphyadd": "10440 BEACH BLVD",
    "dropphycty": "STANTON",
    "dropphyst": "CA",
    "dropphyzpp": 906809998,
    "dropmaladd": "10440 BEACH BLVD",
    "dropmalcty": "STANTON",
    "dropmalst": "CA",
    "dropmalzpp": 906809998,
    "dropsitphn": 7148268830,
    "dropsitlph": 7148266180,
    "dropsitcph": 7148268830,
    "dropfax": 7148267973
  },
  {
    "dcode": "D",
    "dropkey": "PZ23449",
    "droptype": "D",
    "dropname": "STEVINSON",
    "dropdeladd": "20085 THIRD AVE",
    "dropdelcty": "STEVINSON",
    "dropdelst": "CA",
    "dropdelzpp": 953749998,
    "dropphyadd": "20085 THIRD AVE",
    "dropphycty": "STEVINSON",
    "dropphyst": "CA",
    "dropphyzpp": 953749998,
    "dropmaladd": "20085 THIRD AVE",
    "dropmalcty": "STEVINSON",
    "dropmalst": "CA",
    "dropmalzpp": 953749998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096323694,
    "dropsitcph": 2096323694,
    "dropfax": 2092266012
  },
  {
    "dcode": "D",
    "dropkey": "PZ23450",
    "droptype": "D",
    "dropname": "STEWARTS POINT",
    "dropdeladd": "32049 HIGHWAY 1",
    "dropdelcty": "STEWARTS POINT",
    "dropdelst": "CA",
    "dropdelzpp": 954809900,
    "dropphyadd": "32049 HIGHWAY 1",
    "dropphycty": "STEWARTS POINT",
    "dropphyst": "CA",
    "dropphyzpp": 954809900,
    "dropmaladd": "32049 HIGHWAY 1",
    "dropmalcty": "STEWARTS POINT",
    "dropmalst": "CA",
    "dropmalzpp": 954809900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7077852743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23454",
    "droptype": "D",
    "dropname": "STINSON BEACH",
    "dropdeladd": "15 CALLE DEL MAR",
    "dropdelcty": "STINSON BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 949709702,
    "dropphyadd": "15 CALLE DEL MAR",
    "dropphycty": "STINSON BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 949709702,
    "dropmaladd": "15 CALLE DEL MAR",
    "dropmalcty": "STINSON BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 949709702,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 4158681504,
    "dropfax": 4158681504
  },
  {
    "dcode": "D",
    "dropkey": "PZ23455",
    "droptype": "D",
    "dropname": "STIRLING CITY",
    "dropdeladd": "16939 SKYWAY",
    "dropdelcty": "STIRLING CITY",
    "dropdelst": "CA",
    "dropdelzpp": 959789998,
    "dropphyadd": "16939 SKYWAY",
    "dropphycty": "STIRLING CITY",
    "dropphyst": "CA",
    "dropphyzpp": 959789998,
    "dropmaladd": "16939 SKYWAY",
    "dropmalcty": "STIRLING CITY",
    "dropmalst": "CA",
    "dropmalzpp": 959789998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308734775,
    "dropsitcph": 5308734775,
    "dropfax": 5308732893
  },
  {
    "dcode": "D",
    "dropkey": "PZ23459",
    "droptype": "D",
    "dropname": "STOCKTON",
    "dropdeladd": "4245 WEST LN",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952089998,
    "dropphyadd": "4245 WEST LN",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952089998,
    "dropmaladd": "4245 WEST LN",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952089998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094603667,
    "dropsitcph": 2094603667,
    "dropfax": 2094603663
  },
  {
    "dcode": "D",
    "dropkey": "PZ23461",
    "droptype": "D",
    "dropname": "STONYFORD",
    "dropdeladd": "259 MARKET ST",
    "dropdelcty": "STONYFORD",
    "dropdelst": "CA",
    "dropdelzpp": 959799998,
    "dropphyadd": "259 MARKET ST",
    "dropphycty": "STONYFORD",
    "dropphyst": "CA",
    "dropphyzpp": 959799998,
    "dropmaladd": "259 MARKET ST",
    "dropmalcty": "STONYFORD",
    "dropmalst": "CA",
    "dropmalzpp": 959799998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309633242,
    "dropsitcph": 5309633242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23464",
    "droptype": "D",
    "dropname": "STRATFORD",
    "dropdeladd": "20340 MAIN ST",
    "dropdelcty": "STRATFORD",
    "dropdelst": "CA",
    "dropdelzpp": 932669998,
    "dropphyadd": "20340 MAIN ST",
    "dropphycty": "STRATFORD",
    "dropphyst": "CA",
    "dropphyzpp": 932669998,
    "dropmaladd": "20340 MAIN ST",
    "dropmalcty": "STRATFORD",
    "dropmalst": "CA",
    "dropmalzpp": 932669998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5599473004,
    "dropsitcph": 5599473004,
    "dropfax": 5599473960
  },
  {
    "dcode": "D",
    "dropkey": "PZ23465",
    "droptype": "D",
    "dropname": "STRATHMORE",
    "dropdeladd": "19708 ORANGE BELT DR",
    "dropdelcty": "STRATHMORE",
    "dropdelst": "CA",
    "dropdelzpp": 932679998,
    "dropphyadd": "19708 ORANGE BELT DR",
    "dropphycty": "STRATHMORE",
    "dropphyst": "CA",
    "dropphyzpp": 932679998,
    "dropmaladd": "19708 ORANGE BELT DR",
    "dropmalcty": "STRATHMORE",
    "dropmalst": "CA",
    "dropmalzpp": 932679998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595680576,
    "dropsitcph": 5595680576,
    "dropfax": 5595680746
  },
  {
    "dcode": "D",
    "dropkey": "PZ23475",
    "droptype": "D",
    "dropname": "SUISUN CITY",
    "dropdeladd": "325 MERGANSER DR",
    "dropdelcty": "SUISUN CITY",
    "dropdelst": "CA",
    "dropdelzpp": 945859998,
    "dropphyadd": "325 MERGANSER DR",
    "dropphycty": "SUISUN CITY",
    "dropphyst": "CA",
    "dropphyzpp": 945859998,
    "dropmaladd": "325 MERGANSER DR",
    "dropmalcty": "SUISUN CITY",
    "dropmalst": "CA",
    "dropmalzpp": 945859998,
    "dropsitphn": 5104337569,
    "dropsitlph": 7074255449,
    "dropsitcph": 7074251334,
    "dropfax": 7074212753
  },
  {
    "dcode": "D",
    "dropkey": "PZ23477",
    "droptype": "D",
    "dropname": "SULTANA",
    "dropdeladd": "10457 AVENUE 416",
    "dropdelcty": "SULTANA",
    "dropdelst": "CA",
    "dropdelzpp": 936669998,
    "dropphyadd": "10457 AVENUE 416",
    "dropphycty": "SULTANA",
    "dropphyst": "CA",
    "dropphyzpp": 936669998,
    "dropmaladd": "10457 AVENUE 416",
    "dropmalcty": "SULTANA",
    "dropmalst": "CA",
    "dropmalzpp": 936669998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5595915110,
    "dropsitcph": 5595915110,
    "dropfax": 5595963920
  },
  {
    "dcode": "D",
    "dropkey": "PZ23479",
    "droptype": "D",
    "dropname": "SUMMERLAND",
    "dropdeladd": "2245 LILLIE AVE",
    "dropdelcty": "SUMMERLAND",
    "dropdelst": "CA",
    "dropdelzpp": 930679997,
    "dropphyadd": "2245 LILLIE AVE",
    "dropphycty": "SUMMERLAND",
    "dropphyst": "CA",
    "dropphyzpp": 930679997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUMMERLAND",
    "dropmalst": "CA",
    "dropmalzpp": 930679998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055657984,
    "dropsitcph": 8055657984,
    "dropfax": 8055655573
  },
  {
    "dcode": "D",
    "dropkey": "PZ23481",
    "droptype": "D",
    "dropname": "SUN CITY",
    "dropdeladd": "29700 HAUN RD",
    "dropdelcty": "MENIFEE",
    "dropdelst": "CA",
    "dropdelzpp": 925869997,
    "dropphyadd": "29700 HAUN RD",
    "dropphycty": "MENIFEE",
    "dropphyst": "CA",
    "dropphyzpp": 925869997,
    "dropmaladd": "29700 HAUN RD",
    "dropmalcty": "MENIFEE",
    "dropmalst": "CA",
    "dropmalzpp": 925869997,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516791544,
    "dropsitcph": 9516797886,
    "dropfax": 9513010397
  },
  {
    "dcode": "D",
    "dropkey": "PZ23482",
    "droptype": "D",
    "dropname": "SUN VALLEY",
    "dropdeladd": "10946 RATNER ST",
    "dropdelcty": "SUN VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 913529998,
    "dropphyadd": "10946 RATNER ST",
    "dropphycty": "SUN VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 913529998,
    "dropmaladd": "10946 RATNER ST",
    "dropmalcty": "SUN VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 913529998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187671939,
    "dropsitcph": 8187672073,
    "dropfax": 8187671839
  },
  {
    "dcode": "D",
    "dropkey": "PZ23486",
    "droptype": "D",
    "dropname": "SUNLAND",
    "dropdeladd": "8587 FENWICK ST",
    "dropdelcty": "SUNLAND",
    "dropdelst": "CA",
    "dropdelzpp": 910409998,
    "dropphyadd": "8587 FENWICK ST",
    "dropphycty": "SUNLAND",
    "dropphyst": "CA",
    "dropphyzpp": 910409998,
    "dropmaladd": "8587 FENWICK ST",
    "dropmalcty": "SUNLAND",
    "dropmalst": "CA",
    "dropmalzpp": 910409998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8189514516,
    "dropsitcph": 8189510376,
    "dropfax": 8183523945
  },
  {
    "dcode": "D",
    "dropkey": "PZ23492",
    "droptype": "D",
    "dropname": "SUNNYVALE",
    "dropdeladd": "209 E JAVA DR",
    "dropdelcty": "SUNNYVALE",
    "dropdelst": "CA",
    "dropdelzpp": 940899998,
    "dropphyadd": "209 E JAVA DR",
    "dropphycty": "SUNNYVALE",
    "dropphyst": "CA",
    "dropphyzpp": 940899998,
    "dropmaladd": "209 E JAVA DR",
    "dropmalcty": "SUNNYVALE",
    "dropmalst": "CA",
    "dropmalzpp": 940899998,
    "dropsitphn": 4155505045,
    "dropsitlph": 4087470692,
    "dropsitcph": 4087470340,
    "dropfax": 4087470869
  },
  {
    "dcode": "D",
    "dropkey": "PZ23493",
    "droptype": "D",
    "dropname": "SUNOL",
    "dropdeladd": "11925 MAIN ST",
    "dropdelcty": "SUNOL",
    "dropdelst": "CA",
    "dropdelzpp": 945869483,
    "dropphyadd": "11925 MAIN ST",
    "dropphycty": "SUNOL",
    "dropphyst": "CA",
    "dropphyzpp": 945869483,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNOL",
    "dropmalst": "CA",
    "dropmalzpp": 945869998,
    "dropsitphn": 5108323950,
    "dropsitlph": 5108323950,
    "dropsitcph": 9258622130,
    "dropfax": 9258620926
  },
  {
    "dcode": "D",
    "dropkey": "PZ23497",
    "droptype": "D",
    "dropname": "SUNSET BEACH",
    "dropdeladd": "16885 PACIFIC COAST HWY",
    "dropdelcty": "SUNSET BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 907429800,
    "dropphyadd": "16885 PACIFIC COAST HWY",
    "dropphycty": "SUNSET BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 907429800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SUNSET BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 907429998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5625929631,
    "dropsitcph": 5625925021,
    "dropfax": 5625925971
  },
  {
    "dcode": "D",
    "dropkey": "PZ23501",
    "droptype": "D",
    "dropname": "SURFSIDE",
    "dropdeladd": "B89 SURFSIDE AVE",
    "dropdelcty": "SURFSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 907439800,
    "dropphyadd": "B89 SURFSIDE AVE",
    "dropphycty": "SURFSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 907439800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SURFSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 907439998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5625924679,
    "dropsitcph": 5625929568,
    "dropfax": 5625924028
  },
  {
    "dcode": "D",
    "dropkey": "PZ23504",
    "droptype": "D",
    "dropname": "SUSANVILLE",
    "dropdeladd": "65 N LASSEN ST",
    "dropdelcty": "SUSANVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961309998,
    "dropphyadd": "65 N LASSEN ST",
    "dropphycty": "SUSANVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961309998,
    "dropmaladd": "65 N LASSEN ST",
    "dropmalcty": "SUSANVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961309998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302574425,
    "dropfax": 5302576825
  },
  {
    "dcode": "D",
    "dropkey": "PZ23505",
    "droptype": "D",
    "dropname": "SUTTER",
    "dropdeladd": "2209 CALIFORNIA ST",
    "dropdelcty": "SUTTER",
    "dropdelst": "CA",
    "dropdelzpp": 959829998,
    "dropphyadd": "2209 CALIFORNIA ST",
    "dropphycty": "SUTTER",
    "dropphyst": "CA",
    "dropphyzpp": 959829998,
    "dropmaladd": "2209 CALIFORNIA ST",
    "dropmalcty": "SUTTER",
    "dropmalst": "CA",
    "dropmalzpp": 959829998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307550588,
    "dropsitcph": 5307550588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23506",
    "droptype": "D",
    "dropname": "SUTTER CREEK",
    "dropdeladd": "3 GOPHER FLAT RD",
    "dropdelcty": "SUTTER CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 956859998,
    "dropphyadd": "3 GOPHER FLAT RD",
    "dropphycty": "SUTTER CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 956859998,
    "dropmaladd": "3 GOPHER FLAT RD",
    "dropmalcty": "SUTTER CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 956859998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092675544,
    "dropsitcph": 2092670128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23518",
    "droptype": "D",
    "dropname": "TAFT",
    "dropdeladd": "427 NORTH ST",
    "dropdelcty": "TAFT",
    "dropdelst": "CA",
    "dropdelzpp": 932689998,
    "dropphyadd": "427 NORTH ST",
    "dropphycty": "TAFT",
    "dropphyst": "CA",
    "dropphyzpp": 932689998,
    "dropmaladd": "427 NORTH ST",
    "dropmalcty": "TAFT",
    "dropmalst": "CA",
    "dropmalzpp": 932689998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617635773,
    "dropsitcph": 6617633342,
    "dropfax": 6617635993
  },
  {
    "dcode": "D",
    "dropkey": "PZ23519",
    "droptype": "D",
    "dropname": "TAHOE CITY",
    "dropdeladd": "950 N LAKE BLVD STE 12",
    "dropdelcty": "TAHOE CITY",
    "dropdelst": "CA",
    "dropdelzpp": 961459800,
    "dropphyadd": "950 N LAKE BLVD STE 12",
    "dropphycty": "TAHOE CITY",
    "dropphyst": "CA",
    "dropphyzpp": 961459800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAHOE CITY",
    "dropmalst": "CA",
    "dropmalzpp": 961459998,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305834900,
    "dropsitcph": 5305834900,
    "dropfax": 5305836826
  },
  {
    "dcode": "D",
    "dropkey": "PZ23526",
    "droptype": "D",
    "dropname": "TAHOE VISTA",
    "dropdeladd": "7005 N LAKE BLVD",
    "dropdelcty": "TAHOE VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 961489800,
    "dropphyadd": "7005 N LAKE BLVD",
    "dropphycty": "TAHOE VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 961489800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TAHOE VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 961489998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5305465600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23528",
    "droptype": "D",
    "dropname": "TALMAGE",
    "dropdeladd": "1986 TALMAGE RD",
    "dropdelcty": "TALMAGE",
    "dropdelst": "CA",
    "dropdelzpp": 954818800,
    "dropphyadd": "1986 TALMAGE RD",
    "dropphycty": "TALMAGE",
    "dropphyst": "CA",
    "dropphyzpp": 954818800,
    "dropmaladd": "1986 TALMAGE RD",
    "dropmalcty": "TALMAGE",
    "dropmalst": "CA",
    "dropmalzpp": 954819998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074625723,
    "dropfax": 7074625723
  },
  {
    "dcode": "D",
    "dropkey": "PZ23533",
    "droptype": "D",
    "dropname": "TARZANA",
    "dropdeladd": "5609 YOLANDA AVE",
    "dropdelcty": "TARZANA",
    "dropdelst": "CA",
    "dropdelzpp": 913569998,
    "dropphyadd": "5609 YOLANDA AVE",
    "dropphycty": "TARZANA",
    "dropphyst": "CA",
    "dropphyzpp": 913569998,
    "dropmaladd": "5609 YOLANDA AVE",
    "dropmalcty": "TARZANA",
    "dropmalst": "CA",
    "dropmalzpp": 913569998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183456850,
    "dropsitcph": 8183456850,
    "dropfax": 8189218289
  },
  {
    "dcode": "D",
    "dropkey": "PZ23536",
    "droptype": "D",
    "dropname": "TAYLORSVILLE",
    "dropdeladd": "4368 MAIN ST",
    "dropdelcty": "TAYLORSVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959839998,
    "dropphyadd": "4368 MAIN ST",
    "dropphycty": "TAYLORSVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959839998,
    "dropmaladd": "4368 MAIN ST",
    "dropmalcty": "TAYLORSVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959839998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302846224,
    "dropsitcph": 5302846224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23537",
    "droptype": "D",
    "dropname": "TECATE",
    "dropdeladd": "441 TECATE RD",
    "dropdelcty": "TECATE",
    "dropdelst": "CA",
    "dropdelzpp": 919809998,
    "dropphyadd": "441 TECATE RD",
    "dropphycty": "TECATE",
    "dropphyst": "CA",
    "dropphyzpp": 919809998,
    "dropmaladd": "441 TECATE RD",
    "dropmalcty": "TECATE",
    "dropmalst": "CA",
    "dropmalzpp": 919809998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194785819,
    "dropsitcph": 6194785819,
    "dropfax": 6194782567
  },
  {
    "dcode": "D",
    "dropkey": "PZ23538",
    "droptype": "D",
    "dropname": "TECOPA",
    "dropdeladd": "101 OLD SPANISH TRAIL HWY",
    "dropdelcty": "TECOPA",
    "dropdelst": "CA",
    "dropdelzpp": 923890010,
    "dropphyadd": "101 OLD SPANISH TRAIL HWY",
    "dropphycty": "TECOPA",
    "dropphyst": "CA",
    "dropphyzpp": 923890010,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TECOPA",
    "dropmalst": "CA",
    "dropmalzpp": 923899998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7608524314,
    "dropsitcph": 7608524314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23540",
    "droptype": "D",
    "dropname": "TEHACHAPI",
    "dropdeladd": "1085 VOYAGER DR",
    "dropdelcty": "TEHACHAPI",
    "dropdelst": "CA",
    "dropdelzpp": 935619998,
    "dropphyadd": "1085 VOYAGER DR",
    "dropphycty": "TEHACHAPI",
    "dropphyst": "CA",
    "dropphyzpp": 935619998,
    "dropmaladd": "1085 VOYAGER DR",
    "dropmalcty": "TEHACHAPI",
    "dropmalst": "CA",
    "dropmalzpp": 935619998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618220279,
    "dropsitcph": 6618220279,
    "dropfax": 6618238533
  },
  {
    "dcode": "D",
    "dropkey": "PZ23541",
    "droptype": "D",
    "dropname": "TEHAMA",
    "dropdeladd": "225 C ST",
    "dropdelcty": "TEHAMA",
    "dropdelst": "CA",
    "dropdelzpp": 960909998,
    "dropphyadd": "225 C ST",
    "dropphycty": "TEHAMA",
    "dropphyst": "CA",
    "dropphyzpp": 960909998,
    "dropmaladd": "225 C ST",
    "dropmalcty": "TEHAMA",
    "dropmalst": "CA",
    "dropmalzpp": 960909998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5303842259,
    "dropsitcph": 5303842259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23542",
    "droptype": "D",
    "dropname": "TEMECULA",
    "dropdeladd": "30777 RANCHO CALIFORNIA RD",
    "dropdelcty": "TEMECULA",
    "dropdelst": "CA",
    "dropdelzpp": 925913209,
    "dropphyadd": "30777 RANCHO CALIFORNIA RD",
    "dropphycty": "TEMECULA",
    "dropphyst": "CA",
    "dropphyzpp": 925913209,
    "dropmaladd": "30777 RANCHO CALIFORNIA RD",
    "dropmalcty": "TEMECULA",
    "dropmalst": "CA",
    "dropmalzpp": 925913209,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516951301,
    "dropsitcph": 9515065513,
    "dropfax": 9516995241
  },
  {
    "dcode": "D",
    "dropkey": "PZ23544",
    "droptype": "D",
    "dropname": "TEMPLE CITY",
    "dropdeladd": "5940 OAK AVE",
    "dropdelcty": "TEMPLE CITY",
    "dropdelst": "CA",
    "dropdelzpp": 917809998,
    "dropphyadd": "5940 OAK AVE",
    "dropphycty": "TEMPLE CITY",
    "dropphyst": "CA",
    "dropphyzpp": 917809998,
    "dropmaladd": "5940 OAK AVE",
    "dropmalcty": "TEMPLE CITY",
    "dropmalst": "CA",
    "dropmalzpp": 917809998,
    "dropsitphn": 6262874243,
    "dropsitlph": 6262878749,
    "dropsitcph": 6262874243,
    "dropfax": 6262872419
  },
  {
    "dcode": "D",
    "dropkey": "PZ23547",
    "droptype": "D",
    "dropname": "TEMPLETON",
    "dropdeladd": "101 N MAIN ST",
    "dropdelcty": "TEMPLETON",
    "dropdelst": "CA",
    "dropdelzpp": 934659998,
    "dropphyadd": "101 N MAIN ST",
    "dropphycty": "TEMPLETON",
    "dropphyst": "CA",
    "dropphyzpp": 934659998,
    "dropmaladd": "101 N MAIN ST",
    "dropmalcty": "TEMPLETON",
    "dropmalst": "CA",
    "dropmalzpp": 934659998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054343824,
    "dropsitcph": 8054349503,
    "dropfax": 8054349587
  },
  {
    "dcode": "D",
    "dropkey": "PZ23552",
    "droptype": "D",
    "dropname": "TERRA BELLA",
    "dropdeladd": "9622 ROAD 236",
    "dropdelcty": "TERRA BELLA",
    "dropdelst": "CA",
    "dropdelzpp": 932709998,
    "dropphyadd": "9622 ROAD 236",
    "dropphycty": "TERRA BELLA",
    "dropphyst": "CA",
    "dropphyzpp": 932709998,
    "dropmaladd": "9622 ROAD 236",
    "dropmalcty": "TERRA BELLA",
    "dropmalst": "CA",
    "dropmalzpp": 932709998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595357602,
    "dropsitcph": 5595357602,
    "dropfax": 5595351529
  },
  {
    "dcode": "D",
    "dropkey": "PZ23565",
    "droptype": "D",
    "dropname": "THERMAL",
    "dropdeladd": "87200 AIRPORT BLVD",
    "dropdelcty": "THERMAL",
    "dropdelst": "CA",
    "dropdelzpp": 922749998,
    "dropphyadd": "87200 AIRPORT BLVD",
    "dropphycty": "THERMAL",
    "dropphyst": "CA",
    "dropphyzpp": 922749998,
    "dropmaladd": "87200 AIRPORT BLVD",
    "dropmalcty": "THERMAL",
    "dropmalst": "CA",
    "dropmalzpp": 922749998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603993245,
    "dropsitcph": 7603991734,
    "dropfax": 7603998124
  },
  {
    "dcode": "D",
    "dropkey": "PZ23568",
    "droptype": "D",
    "dropname": "THORNTON",
    "dropdeladd": "8494 STOCKTON ST",
    "dropdelcty": "THORNTON",
    "dropdelst": "CA",
    "dropdelzpp": 956869998,
    "dropphyadd": "8494 STOCKTON ST",
    "dropphycty": "THORNTON",
    "dropphyst": "CA",
    "dropphyzpp": 956869998,
    "dropmaladd": "8494 STOCKTON ST",
    "dropmalcty": "THORNTON",
    "dropmalst": "CA",
    "dropmalzpp": 956869998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097942651,
    "dropsitcph": 2097942651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23569",
    "droptype": "D",
    "dropname": "THOUSAND OAKS",
    "dropdeladd": "3435 E THOUSAND OAKS BLVD",
    "dropdelcty": "THOUSAND OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 913629998,
    "dropphyadd": "3435 E THOUSAND OAKS BLVD",
    "dropphycty": "THOUSAND OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 913629998,
    "dropmaladd": "3435 E THOUSAND OAKS BLVD",
    "dropmalcty": "THOUSAND OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 913629998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054971641,
    "dropsitcph": 8054971641,
    "dropfax": 8054184564
  },
  {
    "dcode": "D",
    "dropkey": "PZ23570",
    "droptype": "D",
    "dropname": "THOUSAND PALMS",
    "dropdeladd": "72630 RAMON RD",
    "dropdelcty": "THOUSAND PALMS",
    "dropdelst": "CA",
    "dropdelzpp": 922763427,
    "dropphyadd": "72630 RAMON RD",
    "dropphycty": "THOUSAND PALMS",
    "dropphyst": "CA",
    "dropphyzpp": 922763427,
    "dropmaladd": "72630 RAMON RD",
    "dropmalcty": "THOUSAND PALMS",
    "dropmalst": "CA",
    "dropmalzpp": 922763427,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603437318,
    "dropsitcph": 7603433428,
    "dropfax": 7603431058
  },
  {
    "dcode": "D",
    "dropkey": "PZ23572",
    "droptype": "D",
    "dropname": "THREE RIVERS",
    "dropdeladd": "40857 SIERRA DR",
    "dropdelcty": "THREE RIVERS",
    "dropdelst": "CA",
    "dropdelzpp": 932719998,
    "dropphyadd": "40857 SIERRA DR",
    "dropphycty": "THREE RIVERS",
    "dropphyst": "CA",
    "dropphyzpp": 932719998,
    "dropmaladd": "40857 SIERRA DR",
    "dropmalcty": "THREE RIVERS",
    "dropmalst": "CA",
    "dropmalzpp": 932719998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595614261,
    "dropsitcph": 5595614261,
    "dropfax": 5595612027
  },
  {
    "dcode": "D",
    "dropkey": "PZ23578",
    "droptype": "D",
    "dropname": "TIPTON",
    "dropdeladd": "221 N GRAHAM RD",
    "dropdelcty": "TIPTON",
    "dropdelst": "CA",
    "dropdelzpp": 932729998,
    "dropphyadd": "221 N GRAHAM RD",
    "dropphycty": "TIPTON",
    "dropphyst": "CA",
    "dropphyzpp": 932729998,
    "dropmaladd": "221 N GRAHAM RD",
    "dropmalcty": "TIPTON",
    "dropmalst": "CA",
    "dropmalzpp": 932729998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597528002,
    "dropsitcph": 5597528002,
    "dropfax": 5597528001
  },
  {
    "dcode": "D",
    "dropkey": "PZ23584",
    "droptype": "D",
    "dropname": "TOLLHOUSE",
    "dropdeladd": "28425 GIBBS RANCH RD",
    "dropdelcty": "TOLLHOUSE",
    "dropdelst": "CA",
    "dropdelzpp": 936679998,
    "dropphyadd": "28425 GIBBS RANCH RD",
    "dropphycty": "TOLLHOUSE",
    "dropphyst": "CA",
    "dropphyzpp": 936679998,
    "dropmaladd": "28425 GIBBS RANCH RD",
    "dropmalcty": "TOLLHOUSE",
    "dropmalst": "CA",
    "dropmalzpp": 936679998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598552992,
    "dropfax": 5598554941
  },
  {
    "dcode": "D",
    "dropkey": "PZ23587",
    "droptype": "D",
    "dropname": "TOMALES",
    "dropdeladd": "27005 HIGHWAY 1",
    "dropdelcty": "TOMALES",
    "dropdelst": "CA",
    "dropdelzpp": 949718800,
    "dropphyadd": "27005 HIGHWAY 1",
    "dropphycty": "TOMALES",
    "dropphyst": "CA",
    "dropphyzpp": 949718800,
    "dropmaladd": "27005 HIGHWAY 1",
    "dropmalcty": "TOMALES",
    "dropmalst": "CA",
    "dropmalzpp": 949719998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078799003,
    "dropfax": 7078782364
  },
  {
    "dcode": "D",
    "dropkey": "PZ23590",
    "droptype": "D",
    "dropname": "TOPANGA",
    "dropdeladd": "101 S TOPANGA CANYON BLVD",
    "dropdelcty": "TOPANGA",
    "dropdelst": "CA",
    "dropdelzpp": 902909998,
    "dropphyadd": "101 S TOPANGA CANYON BLVD",
    "dropphycty": "TOPANGA",
    "dropphyst": "CA",
    "dropphyzpp": 902909998,
    "dropmaladd": "101 S TOPANGA CANYON BLVD",
    "dropmalcty": "TOPANGA",
    "dropmalst": "CA",
    "dropmalzpp": 902909998,
    "dropsitphn": 3104552824,
    "dropsitlph": 3104552824,
    "dropsitcph": 3104550254,
    "dropfax": 3104558624
  },
  {
    "dcode": "D",
    "dropkey": "PZ23592",
    "droptype": "D",
    "dropname": "TORRANCE",
    "dropdeladd": "2510 MONTEREY ST",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905039998,
    "dropphyadd": "2510 MONTEREY ST",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905039998,
    "dropmaladd": "2510 MONTEREY ST",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905039998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103288301,
    "dropsitcph": 3102225902,
    "dropfax": 3102125385
  },
  {
    "dcode": "D",
    "dropkey": "PZ23602",
    "droptype": "D",
    "dropname": "TRABUCO CANYON",
    "dropdeladd": "30595 TRABUCO CANYON RD",
    "dropdelcty": "TRABUCO CANYON",
    "dropdelst": "CA",
    "dropdelzpp": 926789998,
    "dropphyadd": "30595 TRABUCO CANYON RD",
    "dropphycty": "TRABUCO CANYON",
    "dropphyst": "CA",
    "dropphyzpp": 926789998,
    "dropmaladd": "29862 AVENIDA DE LAS BANDERA",
    "dropmalcty": "RANCHO SANTA MARGARITA",
    "dropmalst": "CA",
    "dropmalzpp": 926889998,
    "dropsitphn": 9498581282,
    "dropsitlph": 9496350154,
    "dropsitcph": 9498581282,
    "dropfax": 9498585371
  },
  {
    "dcode": "D",
    "dropkey": "PZ23604",
    "droptype": "D",
    "dropname": "TRACY",
    "dropdeladd": "125 W 9TH ST",
    "dropdelcty": "TRACY",
    "dropdelst": "CA",
    "dropdelzpp": 953769998,
    "dropphyadd": "125 W 9TH ST",
    "dropphycty": "TRACY",
    "dropphyst": "CA",
    "dropphyzpp": 953769998,
    "dropmaladd": "125 W 9TH ST",
    "dropmalcty": "TRACY",
    "dropmalst": "CA",
    "dropmalzpp": 953769998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098354788,
    "dropsitcph": 2098359795,
    "dropfax": 2098354391
  },
  {
    "dcode": "D",
    "dropkey": "PZ23607",
    "droptype": "D",
    "dropname": "TRANQUILLITY",
    "dropdeladd": "25660 SCAGGS AVE",
    "dropdelcty": "TRANQUILLITY",
    "dropdelst": "CA",
    "dropdelzpp": 936689998,
    "dropphyadd": "25660 SCAGGS AVE",
    "dropphycty": "TRANQUILLITY",
    "dropphyst": "CA",
    "dropphyzpp": 936689998,
    "dropmaladd": "25660 SCAGGS AVE",
    "dropmalcty": "TRANQUILLITY",
    "dropmalst": "CA",
    "dropmalzpp": 936689998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 5596985574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23610",
    "droptype": "D",
    "dropname": "TRAVER",
    "dropdeladd": "36501 BURKE DR",
    "dropdelcty": "TRAVER",
    "dropdelst": "CA",
    "dropdelzpp": 936739998,
    "dropphyadd": "36501 BURKE DR",
    "dropphycty": "TRAVER",
    "dropphyst": "CA",
    "dropphyzpp": 936739998,
    "dropmaladd": "36501 BURKE DR",
    "dropmalcty": "TRAVER",
    "dropmalst": "CA",
    "dropmalzpp": 936739998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5598973986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23615",
    "droptype": "D",
    "dropname": "TRES PINOS",
    "dropdeladd": "21 E 4TH ST",
    "dropdelcty": "TRES PINOS",
    "dropdelst": "CA",
    "dropdelzpp": 950759800,
    "dropphyadd": "21 E 4TH ST",
    "dropphycty": "TRES PINOS",
    "dropphyst": "CA",
    "dropphyzpp": 950759800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRES PINOS",
    "dropmalst": "CA",
    "dropmalzpp": 950759998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8316283527,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23616",
    "droptype": "D",
    "dropname": "TRINIDAD",
    "dropdeladd": "357 MAIN ST",
    "dropdelcty": "TRINIDAD",
    "dropdelst": "CA",
    "dropdelzpp": 955709503,
    "dropphyadd": "357 MAIN ST",
    "dropphycty": "TRINIDAD",
    "dropphyst": "CA",
    "dropphyzpp": 955709503,
    "dropmaladd": "357 MAIN ST",
    "dropmalcty": "TRINIDAD",
    "dropmalst": "CA",
    "dropmalzpp": 955709998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7076773117,
    "dropfax": 7076773117
  },
  {
    "dcode": "D",
    "dropkey": "PZ23617",
    "droptype": "D",
    "dropname": "TRINITY CENTER",
    "dropdeladd": "271 MARY AVE",
    "dropdelcty": "TRINITY CENTER",
    "dropdelst": "CA",
    "dropdelzpp": 960919998,
    "dropphyadd": "271 MARY AVE",
    "dropphycty": "TRINITY CENTER",
    "dropphyst": "CA",
    "dropphyzpp": 960919998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TRINITY CENTER",
    "dropmalst": "CA",
    "dropmalzpp": 960919900,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302663455,
    "dropsitcph": 5302663455,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23618",
    "droptype": "D",
    "dropname": "TRONA",
    "dropdeladd": "82905 SEARLES ST",
    "dropdelcty": "TRONA",
    "dropdelst": "CA",
    "dropdelzpp": 935629998,
    "dropphyadd": "82905 SEARLES ST",
    "dropphycty": "TRONA",
    "dropphyst": "CA",
    "dropphyzpp": 935629998,
    "dropmaladd": "82905 SEARLES ST",
    "dropmalcty": "TRONA",
    "dropmalst": "CA",
    "dropmalzpp": 935629998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603725099,
    "dropsitcph": 7603729129,
    "dropfax": 7603724742
  },
  {
    "dcode": "D",
    "dropkey": "PZ23622",
    "droptype": "D",
    "dropname": "TRUCKEE",
    "dropdeladd": "10050 BRIDGE ST",
    "dropdelcty": "TRUCKEE",
    "dropdelst": "CA",
    "dropdelzpp": 961610212,
    "dropphyadd": "10050 BRIDGE ST",
    "dropphycty": "TRUCKEE",
    "dropphyst": "CA",
    "dropphyzpp": 961610212,
    "dropmaladd": "10050 BRIDGE ST",
    "dropmalcty": "TRUCKEE",
    "dropmalst": "CA",
    "dropmalzpp": 961619998,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305874669,
    "dropsitcph": 5305877158,
    "dropfax": 5305877267
  },
  {
    "dcode": "D",
    "dropkey": "PZ23623",
    "droptype": "D",
    "dropname": "TUJUNGA",
    "dropdeladd": "10209 TUJUNGA CANYON BLVD",
    "dropdelcty": "TUJUNGA",
    "dropdelst": "CA",
    "dropdelzpp": 910429998,
    "dropphyadd": "10209 TUJUNGA CANYON BLVD",
    "dropphycty": "TUJUNGA",
    "dropphyst": "CA",
    "dropphyzpp": 910429998,
    "dropmaladd": "10209 TUJUNGA CANYON BLVD",
    "dropmalcty": "TUJUNGA",
    "dropmalst": "CA",
    "dropmalzpp": 910429998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8189515897,
    "dropsitcph": 8189513078,
    "dropfax": 8183532837
  },
  {
    "dcode": "D",
    "dropkey": "PZ23624",
    "droptype": "D",
    "dropname": "TULARE",
    "dropdeladd": "340 E TULARE AVE",
    "dropdelcty": "TULARE",
    "dropdelst": "CA",
    "dropdelzpp": 932749998,
    "dropphyadd": "340 E TULARE AVE",
    "dropphycty": "TULARE",
    "dropphyst": "CA",
    "dropphyzpp": 932749998,
    "dropmaladd": "834 INDUSTRIAL AVE",
    "dropmalcty": "TULARE",
    "dropmalst": "CA",
    "dropmalzpp": 932746408,
    "dropsitphn": 6617757808,
    "dropsitlph": 5596846000,
    "dropsitcph": 5596846000,
    "dropfax": 5596849349
  },
  {
    "dcode": "D",
    "dropkey": "PZ23625",
    "droptype": "D",
    "dropname": "TULELAKE",
    "dropdeladd": "541 MODOC AVE",
    "dropdelcty": "TULELAKE",
    "dropdelst": "CA",
    "dropdelzpp": 961349995,
    "dropphyadd": "541 MODOC AVE",
    "dropphycty": "TULELAKE",
    "dropphyst": "CA",
    "dropphyzpp": 961349995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TULELAKE",
    "dropmalst": "CA",
    "dropmalzpp": 961349998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5306672903,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23626",
    "droptype": "D",
    "dropname": "TUOLUMNE",
    "dropdeladd": "18758 CARTER ST",
    "dropdelcty": "TUOLUMNE",
    "dropdelst": "CA",
    "dropdelzpp": 953799998,
    "dropphyadd": "18758 CARTER ST",
    "dropphycty": "TUOLUMNE",
    "dropphyst": "CA",
    "dropphyzpp": 953799998,
    "dropmaladd": "18758 CARTER ST",
    "dropmalcty": "TUOLUMNE",
    "dropmalst": "CA",
    "dropmalzpp": 953799998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099284257,
    "dropsitcph": 2099284257,
    "dropfax": 2099284489
  },
  {
    "dcode": "D",
    "dropkey": "PZ23629",
    "droptype": "D",
    "dropname": "TUPMAN",
    "dropdeladd": "337 EMMONS BLVD",
    "dropdelcty": "TUPMAN",
    "dropdelst": "CA",
    "dropdelzpp": 932769996,
    "dropphyadd": "337 EMMONS BLVD",
    "dropphycty": "TUPMAN",
    "dropphyst": "CA",
    "dropphyzpp": 932769996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TUPMAN",
    "dropmalst": "CA",
    "dropmalzpp": 932769998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617657505,
    "dropsitcph": 6617657505,
    "dropfax": 6617634906
  },
  {
    "dcode": "D",
    "dropkey": "PZ23630",
    "droptype": "D",
    "dropname": "TURLOCK",
    "dropdeladd": "555 E MAIN ST",
    "dropdelcty": "TURLOCK",
    "dropdelst": "CA",
    "dropdelzpp": 953809998,
    "dropphyadd": "555 E MAIN ST",
    "dropphycty": "TURLOCK",
    "dropphyst": "CA",
    "dropphyzpp": 953809998,
    "dropmaladd": "555 E MAIN ST",
    "dropmalcty": "TURLOCK",
    "dropmalst": "CA",
    "dropmalzpp": 953809998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2096693022,
    "dropsitcph": 2096693021,
    "dropfax": 2096326543
  },
  {
    "dcode": "D",
    "dropkey": "PZ23631",
    "droptype": "D",
    "dropname": "TUSTIN",
    "dropdeladd": "340 E 1ST ST",
    "dropdelcty": "TUSTIN",
    "dropdelst": "CA",
    "dropdelzpp": 927819998,
    "dropphyadd": "340 E 1ST ST",
    "dropphycty": "TUSTIN",
    "dropphyst": "CA",
    "dropphyzpp": 927819998,
    "dropmaladd": "340 E 1ST ST",
    "dropmalcty": "TUSTIN",
    "dropmalst": "CA",
    "dropmalzpp": 927819998,
    "dropsitphn": 7145442258,
    "dropsitlph": 7145444129,
    "dropsitcph": 7145442258,
    "dropfax": 7145446876
  },
  {
    "dcode": "D",
    "dropkey": "PZ23635",
    "droptype": "D",
    "dropname": "TWAIN",
    "dropdeladd": "200 TWAIN RD",
    "dropdelcty": "TWAIN",
    "dropdelst": "CA",
    "dropdelzpp": 959849998,
    "dropphyadd": "200 TWAIN RD",
    "dropphycty": "TWAIN",
    "dropphyst": "CA",
    "dropphyzpp": 959849998,
    "dropmaladd": "200 TWAIN RD",
    "dropmalcty": "TWAIN",
    "dropmalst": "CA",
    "dropmalzpp": 959849998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302830570,
    "dropsitcph": 5302830570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23636",
    "droptype": "D",
    "dropname": "TWAIN HARTE",
    "dropdeladd": "23051 FULLER RD",
    "dropdelcty": "TWAIN HARTE",
    "dropdelst": "CA",
    "dropdelzpp": 953839998,
    "dropphyadd": "23051 FULLER RD",
    "dropphycty": "TWAIN HARTE",
    "dropphyst": "CA",
    "dropphyzpp": 953839998,
    "dropmaladd": "23051 FULLER RD",
    "dropmalcty": "TWAIN HARTE",
    "dropmalst": "CA",
    "dropmalzpp": 953839998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095863342,
    "dropsitcph": 2095863342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23637",
    "droptype": "D",
    "dropname": "TWENTYNINE PALMS",
    "dropdeladd": "73839 GORGONIO DR",
    "dropdelcty": "TWENTYNINE PALMS",
    "dropdelst": "CA",
    "dropdelzpp": 922772676,
    "dropphyadd": "73839 GORGONIO DR",
    "dropphycty": "TWENTYNINE PALMS",
    "dropphyst": "CA",
    "dropphyzpp": 922772676,
    "dropmaladd": "73839 GORGONIO DR",
    "dropmalcty": "TWENTYNINE PALMS",
    "dropmalst": "CA",
    "dropmalzpp": 922772676,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603672451,
    "dropsitcph": 7603671161,
    "dropfax": 7603673271
  },
  {
    "dcode": "D",
    "dropkey": "PZ23640",
    "droptype": "D",
    "dropname": "TWIN BRIDGES",
    "dropdeladd": "17481 HIGHWAY 50",
    "dropdelcty": "TWIN BRIDGES",
    "dropdelst": "CA",
    "dropdelzpp": 957359998,
    "dropphyadd": "17481 HIGHWAY 50",
    "dropphycty": "TWIN BRIDGES",
    "dropphyst": "CA",
    "dropphyzpp": 957359998,
    "dropmaladd": "17481 HIGHWAY 50",
    "dropmalcty": "TWIN BRIDGES",
    "dropmalst": "CA",
    "dropmalzpp": 957359998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306597670,
    "dropsitcph": 5306597670,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23641",
    "droptype": "D",
    "dropname": "TWIN PEAKS",
    "dropdeladd": "753 ROSE LN",
    "dropdelcty": "TWIN PEAKS",
    "dropdelst": "CA",
    "dropdelzpp": 923910400,
    "dropphyadd": "753 ROSE LN",
    "dropphycty": "TWIN PEAKS",
    "dropphyst": "CA",
    "dropphyzpp": 923910400,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "TWIN PEAKS",
    "dropmalst": "CA",
    "dropmalzpp": 923919998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093373676,
    "dropsitcph": 9093373676,
    "dropfax": 9093366516
  },
  {
    "dcode": "D",
    "dropkey": "PZ23658",
    "droptype": "D",
    "dropname": "UKIAH",
    "dropdeladd": "671 S ORCHARD AVE",
    "dropdelcty": "UKIAH",
    "dropdelst": "CA",
    "dropdelzpp": 954829998,
    "dropphyadd": "671 S ORCHARD AVE",
    "dropphycty": "UKIAH",
    "dropphyst": "CA",
    "dropphyzpp": 954829998,
    "dropmaladd": "671 S ORCHARD AVE",
    "dropmalcty": "UKIAH",
    "dropmalst": "CA",
    "dropmalzpp": 954829998,
    "dropsitphn": 7074623231,
    "dropsitlph": 7074623231,
    "dropsitcph": 7074623231,
    "dropfax": 7074623767
  },
  {
    "dcode": "D",
    "dropkey": "PZ23660",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "33170 ALVARADO NILES RD",
    "dropdelcty": "UNION CITY",
    "dropdelst": "CA",
    "dropdelzpp": 945879998,
    "dropphyadd": "33170 ALVARADO NILES RD",
    "dropphycty": "UNION CITY",
    "dropphyst": "CA",
    "dropphyzpp": 945879998,
    "dropmaladd": "33170 ALVARADO NILES RD",
    "dropmalcty": "UNION CITY",
    "dropmalst": "CA",
    "dropmalzpp": 945879998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5104711180,
    "dropsitcph": 5104711180,
    "dropfax": 5104710306
  },
  {
    "dcode": "D",
    "dropkey": "PZ23676",
    "droptype": "D",
    "dropname": "UPLAND",
    "dropdeladd": "333 E ARROW HWY",
    "dropdelcty": "UPLAND",
    "dropdelst": "CA",
    "dropdelzpp": 917859998,
    "dropphyadd": "333 E ARROW HWY",
    "dropphycty": "UPLAND",
    "dropphyst": "CA",
    "dropphyzpp": 917859998,
    "dropmaladd": "333 E ARROW HWY",
    "dropmalcty": "UPLAND",
    "dropmalst": "CA",
    "dropmalzpp": 917859998,
    "dropsitphn": 9099468134,
    "dropsitlph": 9099816324,
    "dropsitcph": 9099468134,
    "dropfax": 9099819724
  },
  {
    "dcode": "D",
    "dropkey": "PZ23677",
    "droptype": "D",
    "dropname": "UPPER LAKE",
    "dropdeladd": "9435 MAIN ST",
    "dropdelcty": "UPPER LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 954859902,
    "dropphyadd": "9435 MAIN ST",
    "dropphycty": "UPPER LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 954859902,
    "dropmaladd": "9435 MAIN ST",
    "dropmalcty": "UPPER LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 954859902,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 7072752426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23688",
    "droptype": "D",
    "dropname": "VACAVILLE",
    "dropdeladd": "200 PRAIRIE CT",
    "dropdelcty": "VACAVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956879998,
    "dropphyadd": "200 PRAIRIE CT",
    "dropphycty": "VACAVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956879998,
    "dropmaladd": "200 PRAIRIE CT",
    "dropmalcty": "VACAVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956879998,
    "dropsitphn": 9163738025,
    "dropsitlph": 7074516528,
    "dropsitcph": 7074516561,
    "dropfax": 7074516535
  },
  {
    "dcode": "D",
    "dropkey": "PZ23694",
    "droptype": "D",
    "dropname": "VALLECITO",
    "dropdeladd": "3511 MAIN ST",
    "dropdelcty": "VALLECITO",
    "dropdelst": "CA",
    "dropdelzpp": 952519998,
    "dropphyadd": "3511 MAIN ST",
    "dropphycty": "VALLECITO",
    "dropphyst": "CA",
    "dropphyzpp": 952519998,
    "dropmaladd": "3511 MAIN ST",
    "dropmalcty": "VALLECITO",
    "dropmalst": "CA",
    "dropmalzpp": 952519998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097364722,
    "dropsitcph": 2097364722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23695",
    "droptype": "D",
    "dropname": "VALLEJO",
    "dropdeladd": "2635 NAPA ST",
    "dropdelcty": "VALLEJO",
    "dropdelst": "CA",
    "dropdelzpp": 945909998,
    "dropphyadd": "2635 NAPA ST",
    "dropphycty": "VALLEJO",
    "dropphyst": "CA",
    "dropphyzpp": 945909998,
    "dropmaladd": "2635 NAPA ST",
    "dropmalcty": "VALLEJO",
    "dropmalst": "CA",
    "dropmalzpp": 945909998,
    "dropsitphn": 5104337569,
    "dropsitlph": 7076423355,
    "dropsitcph": 7076423355,
    "dropfax": 7076422957
  },
  {
    "dcode": "D",
    "dropkey": "PZ23696",
    "droptype": "D",
    "dropname": "VALLEY CENTER",
    "dropdeladd": "28588 COLE GRADE RD",
    "dropdelcty": "VALLEY CENTER",
    "dropdelst": "CA",
    "dropdelzpp": 920829998,
    "dropphyadd": "28588 COLE GRADE RD",
    "dropphycty": "VALLEY CENTER",
    "dropphyst": "CA",
    "dropphyzpp": 920829998,
    "dropmaladd": "28588 COLE GRADE RD",
    "dropmalcty": "VALLEY CENTER",
    "dropmalst": "CA",
    "dropmalzpp": 920829998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607494839,
    "dropsitcph": 7607496359,
    "dropfax": 7607490359
  },
  {
    "dcode": "D",
    "dropkey": "PZ23697",
    "droptype": "D",
    "dropname": "VALLEY FORD",
    "dropdeladd": "14449 HIGHWAY 1",
    "dropdelcty": "VALLEY FORD",
    "dropdelst": "CA",
    "dropdelzpp": 949729700,
    "dropphyadd": "14449 HIGHWAY 1",
    "dropphycty": "VALLEY FORD",
    "dropphyst": "CA",
    "dropphyzpp": 949729700,
    "dropmaladd": "14449 HIGHWAY 1",
    "dropmalcty": "VALLEY FORD",
    "dropmalst": "CA",
    "dropmalzpp": 949729700,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078763123,
    "dropfax": 7078763162
  },
  {
    "dcode": "D",
    "dropkey": "PZ23703",
    "droptype": "D",
    "dropname": "VALLEY SPRINGS",
    "dropdeladd": "200 E HIGHWAY 12 STE C5",
    "dropdelcty": "VALLEY SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 952529998,
    "dropphyadd": "200 E HIGHWAY 12 STE C5",
    "dropphycty": "VALLEY SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 952529998,
    "dropmaladd": "200 E HIGHWAY 12 STE C5",
    "dropmalcty": "VALLEY SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 952529998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097721560,
    "dropsitcph": 2097721560,
    "dropfax": 2097729612
  },
  {
    "dcode": "D",
    "dropkey": "PZ23708",
    "droptype": "D",
    "dropname": "VAN NUYS",
    "dropdeladd": "15701 SHERMAN WAY",
    "dropdelcty": "VAN NUYS",
    "dropdelst": "CA",
    "dropdelzpp": 914069998,
    "dropphyadd": "15701 SHERMAN WAY",
    "dropphycty": "VAN NUYS",
    "dropphyst": "CA",
    "dropphyzpp": 914069998,
    "dropmaladd": "15701 SHERMAN WAY",
    "dropmalcty": "VAN NUYS",
    "dropmalst": "CA",
    "dropmalzpp": 914069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183745600,
    "dropsitcph": 8183745650,
    "dropfax": 8183745603
  },
  {
    "dcode": "D",
    "dropkey": "PZ23713",
    "droptype": "D",
    "dropname": "VENICE",
    "dropdeladd": "313 GRAND BLVD",
    "dropdelcty": "VENICE",
    "dropdelst": "CA",
    "dropdelzpp": 902919993,
    "dropphyadd": "313 GRAND BLVD",
    "dropphycty": "VENICE",
    "dropphyst": "CA",
    "dropphyzpp": 902919993,
    "dropmaladd": "313 GRAND BLVD",
    "dropmalcty": "VENICE",
    "dropmalst": "CA",
    "dropmalzpp": 902919993,
    "dropsitphn": 3103144024,
    "dropsitlph": 3103969093,
    "dropsitcph": 3103144024,
    "dropfax": 3104505952
  },
  {
    "dcode": "D",
    "dropkey": "PZ23715",
    "droptype": "D",
    "dropname": "VENTURA",
    "dropdeladd": "675 E SANTA CLARA ST",
    "dropdelcty": "VENTURA",
    "dropdelst": "CA",
    "dropdelzpp": 930019998,
    "dropphyadd": "675 E SANTA CLARA ST",
    "dropphycty": "VENTURA",
    "dropphyst": "CA",
    "dropphyzpp": 930019998,
    "dropmaladd": "675 E SANTA CLARA ST",
    "dropmalcty": "VENTURA",
    "dropmalst": "CA",
    "dropmalzpp": 930019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056430576,
    "dropsitcph": 8056433057,
    "dropfax": 8056432831
  },
  {
    "dcode": "D",
    "dropkey": "PZ23716",
    "droptype": "D",
    "dropname": "VERDUGO CITY",
    "dropdeladd": "2816 HONOLULU AVE",
    "dropdelcty": "VERDUGO CITY",
    "dropdelst": "CA",
    "dropdelzpp": 910469997,
    "dropphyadd": "2816 HONOLULU AVE",
    "dropphycty": "VERDUGO CITY",
    "dropphyst": "CA",
    "dropphyzpp": 910469997,
    "dropmaladd": "2816 HONOLULU AVE",
    "dropmalcty": "VERDUGO CITY",
    "dropmalst": "CA",
    "dropmalzpp": 910461001,
    "dropsitphn": 6617757808,
    "dropsitlph": 8182496284,
    "dropsitcph": 8182491541,
    "dropfax": 6617757109
  },
  {
    "dcode": "D",
    "dropkey": "PZ23733",
    "droptype": "D",
    "dropname": "VICTOR",
    "dropdeladd": "8958 E HIGHWAY 12",
    "dropdelcty": "VICTOR",
    "dropdelst": "CA",
    "dropdelzpp": 952539998,
    "dropphyadd": "8958 E HIGHWAY 12",
    "dropphycty": "VICTOR",
    "dropphyst": "CA",
    "dropphyzpp": 952539998,
    "dropmaladd": "8958 E HIGHWAY 12",
    "dropmalcty": "VICTOR",
    "dropmalst": "CA",
    "dropmalzpp": 952539998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093685270,
    "dropsitcph": 2093685270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23735",
    "droptype": "D",
    "dropname": "VICTORVILLE",
    "dropdeladd": "16333 GREEN TREE BLVD",
    "dropdelcty": "VICTORVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 923959998,
    "dropphyadd": "16333 GREEN TREE BLVD",
    "dropphycty": "VICTORVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 923959998,
    "dropmaladd": "16333 GREEN TREE BLVD",
    "dropmalcty": "VICTORVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 923959998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602454648,
    "dropsitcph": 7602414433,
    "dropfax": 7602453024
  },
  {
    "dcode": "D",
    "dropkey": "PZ23741",
    "droptype": "D",
    "dropname": "VILLA GRANDE",
    "dropdeladd": "21893 WEST ST",
    "dropdelcty": "VILLA GRANDE",
    "dropdelst": "CA",
    "dropdelzpp": 954868900,
    "dropphyadd": "21893 WEST ST",
    "dropphycty": "VILLA GRANDE",
    "dropphyst": "CA",
    "dropphyzpp": 954868900,
    "dropmaladd": "21893 WEST ST",
    "dropmalcty": "VILLA GRANDE",
    "dropmalst": "CA",
    "dropmalzpp": 954869998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7073770016,
    "dropfax": 7073770016
  },
  {
    "dcode": "D",
    "dropkey": "PZ23747",
    "droptype": "D",
    "dropname": "VINA",
    "dropdeladd": "4750 ROWLES RD",
    "dropdelcty": "VINA",
    "dropdelst": "CA",
    "dropdelzpp": 960929998,
    "dropphyadd": "4750 ROWLES RD",
    "dropphycty": "VINA",
    "dropphyst": "CA",
    "dropphyzpp": 960929998,
    "dropmaladd": "4750 ROWLES RD",
    "dropmalcty": "VINA",
    "dropmalst": "CA",
    "dropmalzpp": 960929998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308392213,
    "dropsitcph": 5308392213,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23748",
    "droptype": "D",
    "dropname": "VINEBURG",
    "dropdeladd": "20579 8TH ST E",
    "dropdelcty": "VINEBURG",
    "dropdelst": "CA",
    "dropdelzpp": 954878800,
    "dropphyadd": "20579 8TH ST E",
    "dropphycty": "VINEBURG",
    "dropphyst": "CA",
    "dropphyzpp": 954878800,
    "dropmaladd": "20579 8TH ST E",
    "dropmalcty": "VINEBURG",
    "dropmalst": "CA",
    "dropmalzpp": 954879998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079383444,
    "dropfax": 7079381571
  },
  {
    "dcode": "D",
    "dropkey": "PZ23754",
    "droptype": "D",
    "dropname": "VISALIA",
    "dropdeladd": "2345 W BEECH AVE",
    "dropdelcty": "VISALIA",
    "dropdelst": "CA",
    "dropdelzpp": 932779998,
    "dropphyadd": "2345 W BEECH AVE",
    "dropphycty": "VISALIA",
    "dropphyst": "CA",
    "dropphyzpp": 932779998,
    "dropmaladd": "2345 W BEECH AVE",
    "dropmalcty": "VISALIA",
    "dropmalst": "CA",
    "dropmalzpp": 932779998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597322237,
    "dropsitcph": 5597322237,
    "dropfax": 5597330821
  },
  {
    "dcode": "D",
    "dropkey": "PZ23756",
    "droptype": "D",
    "dropname": "VISTA",
    "dropdeladd": "960 POSTAL WAY",
    "dropdelcty": "VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 920839998,
    "dropphyadd": "960 POSTAL WAY",
    "dropphycty": "VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 920839998,
    "dropmaladd": "960 POSTAL WAY",
    "dropmalcty": "VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 920839998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607267902,
    "dropsitcph": 7607268064,
    "dropfax": 7607264310
  },
  {
    "dcode": "D",
    "dropkey": "PZ23762",
    "droptype": "D",
    "dropname": "VOLCANO",
    "dropdeladd": "16120 MAIN ST",
    "dropdelcty": "VOLCANO",
    "dropdelst": "CA",
    "dropdelzpp": 956899998,
    "dropphyadd": "16120 MAIN ST",
    "dropphycty": "VOLCANO",
    "dropphyst": "CA",
    "dropphyzpp": 956899998,
    "dropmaladd": "16120 MAIN ST",
    "dropmalcty": "VOLCANO",
    "dropmalst": "CA",
    "dropmalzpp": 956899998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092967043,
    "dropsitcph": 2092967043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23777",
    "droptype": "D",
    "dropname": "WALLACE",
    "dropdeladd": "8271 CAMANCHE PKWY S",
    "dropdelcty": "WALLACE",
    "dropdelst": "CA",
    "dropdelzpp": 952549998,
    "dropphyadd": "8271 CAMANCHE PKWY S",
    "dropphycty": "WALLACE",
    "dropphyst": "CA",
    "dropphyzpp": 952549998,
    "dropmaladd": "8271 CAMANCHE PKWY S",
    "dropmalcty": "WALLACE",
    "dropmalst": "CA",
    "dropmalzpp": 952549998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2097635335,
    "dropsitcph": 2097635335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23778",
    "droptype": "D",
    "dropname": "WALNUT",
    "dropdeladd": "280 S LEMON AVE",
    "dropdelcty": "WALNUT",
    "dropdelst": "CA",
    "dropdelzpp": 917889998,
    "dropphyadd": "280 S LEMON AVE",
    "dropphycty": "WALNUT",
    "dropphyst": "CA",
    "dropphyzpp": 917889998,
    "dropmaladd": "280 S LEMON AVE",
    "dropmalcty": "WALNUT",
    "dropmalst": "CA",
    "dropmalzpp": 917889998,
    "dropsitphn": 9094447901,
    "dropsitlph": 9098390081,
    "dropsitcph": 9094447901,
    "dropfax": 9095980524
  },
  {
    "dcode": "D",
    "dropkey": "PZ23779",
    "droptype": "D",
    "dropname": "WALNUT CREEK",
    "dropdeladd": "2070 N BROADWAY",
    "dropdelcty": "WALNUT CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 945969998,
    "dropphyadd": "2070 N BROADWAY",
    "dropphycty": "WALNUT CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 945969998,
    "dropmaladd": "2070 N BROADWAY",
    "dropmalcty": "WALNUT CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 945969998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259300835,
    "dropsitcph": 9259350256,
    "dropfax": 9259300445
  },
  {
    "dcode": "D",
    "dropkey": "PZ23780",
    "droptype": "D",
    "dropname": "WALNUT GROVE",
    "dropdeladd": "14165 RIVER RD",
    "dropdelcty": "WALNUT GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 956909998,
    "dropphyadd": "14165 RIVER RD",
    "dropphycty": "WALNUT GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 956909998,
    "dropmaladd": "14165 RIVER RD",
    "dropmalcty": "WALNUT GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 956909998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167761315,
    "dropsitcph": 9167761315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23787",
    "droptype": "D",
    "dropname": "WARNER SPRINGS",
    "dropdeladd": "31650 HIGHWAY 79",
    "dropdelcty": "WARNER SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 920869998,
    "dropphyadd": "31650 HIGHWAY 79",
    "dropphycty": "WARNER SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 920869998,
    "dropmaladd": "31650 HIGHWAY 79",
    "dropmalcty": "WARNER SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 920869998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607823166,
    "dropsitcph": 7607823166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23788",
    "droptype": "D",
    "dropname": "WASCO",
    "dropdeladd": "800 E ST",
    "dropdelcty": "WASCO",
    "dropdelst": "CA",
    "dropdelzpp": 932809998,
    "dropphyadd": "800 E ST",
    "dropphycty": "WASCO",
    "dropphyst": "CA",
    "dropphyzpp": 932809998,
    "dropmaladd": "800 E ST",
    "dropmalcty": "WASCO",
    "dropmalst": "CA",
    "dropmalzpp": 932809998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6617585697,
    "dropsitcph": 6617585697,
    "dropfax": 6617586618
  },
  {
    "dcode": "D",
    "dropkey": "PZ23793",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "15274 WASHINGTON RD",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "CA",
    "dropdelzpp": 959869998,
    "dropphyadd": "15274 WASHINGTON RD",
    "dropphycty": "WASHINGTON",
    "dropphyst": "CA",
    "dropphyzpp": 959869998,
    "dropmaladd": "15274 WASHINGTON RD",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "CA",
    "dropmalzpp": 959869998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5302653010,
    "dropsitcph": 5302653010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23795",
    "droptype": "D",
    "dropname": "WATERFORD",
    "dropdeladd": "12525 BENTLEY ST",
    "dropdelcty": "WATERFORD",
    "dropdelst": "CA",
    "dropdelzpp": 953869998,
    "dropphyadd": "12525 BENTLEY ST",
    "dropphycty": "WATERFORD",
    "dropphyst": "CA",
    "dropphyzpp": 953869998,
    "dropmaladd": "12525 BENTLEY ST",
    "dropmalcty": "WATERFORD",
    "dropmalst": "CA",
    "dropmalzpp": 953869998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098742162,
    "dropsitcph": 2098742162,
    "dropfax": 2098745584
  },
  {
    "dcode": "D",
    "dropkey": "PZ23797",
    "droptype": "D",
    "dropname": "WATSONVILLE",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "WATSONVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 950769998,
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "WATSONVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 950769998,
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "WATSONVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 950769998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8317245273,
    "dropsitcph": 8317248243,
    "dropfax": 8317246571
  },
  {
    "dcode": "D",
    "dropkey": "PZ23802",
    "droptype": "D",
    "dropname": "WEAVERVILLE",
    "dropdeladd": "50 S MINER ST",
    "dropdelcty": "WEAVERVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 960939998,
    "dropphyadd": "50 S MINER ST",
    "dropphycty": "WEAVERVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 960939998,
    "dropmaladd": "50 S MINER ST",
    "dropmalcty": "WEAVERVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 960939998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306236144,
    "dropsitcph": 5306236144,
    "dropfax": 5306234955
  },
  {
    "dcode": "D",
    "dropkey": "PZ23804",
    "droptype": "D",
    "dropname": "WEED",
    "dropdeladd": "560 TEBBE ST",
    "dropdelcty": "WEED",
    "dropdelst": "CA",
    "dropdelzpp": 960949998,
    "dropphyadd": "560 TEBBE ST",
    "dropphycty": "WEED",
    "dropphyst": "CA",
    "dropphyzpp": 960949998,
    "dropmaladd": "560 TEBBE ST",
    "dropmalcty": "WEED",
    "dropmalst": "CA",
    "dropmalzpp": 960949998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309382517,
    "dropsitcph": 5309382517,
    "dropfax": 5309382945
  },
  {
    "dcode": "D",
    "dropkey": "PZ23805",
    "droptype": "D",
    "dropname": "WEIMAR",
    "dropdeladd": "21050 CANYON WAY",
    "dropdelcty": "WEIMAR",
    "dropdelst": "CA",
    "dropdelzpp": 957369998,
    "dropphyadd": "21050 CANYON WAY",
    "dropphycty": "WEIMAR",
    "dropphyst": "CA",
    "dropphyzpp": 957369998,
    "dropmaladd": "21050 CANYON WAY",
    "dropmalcty": "WEIMAR",
    "dropmalst": "CA",
    "dropmalzpp": 957369998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306374949,
    "dropsitcph": 5306374949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23807",
    "droptype": "D",
    "dropname": "WELDON",
    "dropdeladd": "5765 VISTA GRANDE DR",
    "dropdelcty": "WELDON",
    "dropdelst": "CA",
    "dropdelzpp": 932839998,
    "dropphyadd": "5765 VISTA GRANDE DR",
    "dropphycty": "WELDON",
    "dropphyst": "CA",
    "dropphyzpp": 932839998,
    "dropmaladd": "5765 VISTA GRANDE DR",
    "dropmalcty": "WELDON",
    "dropmalst": "CA",
    "dropmalzpp": 932839998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603782175,
    "dropsitcph": 7603782175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23812",
    "droptype": "D",
    "dropname": "WEOTT",
    "dropdeladd": "11 LUM ST",
    "dropdelcty": "WEOTT",
    "dropdelst": "CA",
    "dropdelzpp": 955718800,
    "dropphyadd": "11 LUM ST",
    "dropphycty": "WEOTT",
    "dropphyst": "CA",
    "dropphyzpp": 955718800,
    "dropmaladd": "11 LUM ST",
    "dropmalcty": "WEOTT",
    "dropmalst": "CA",
    "dropmalzpp": 955718800,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079462456,
    "dropfax": 7079462456
  },
  {
    "dcode": "D",
    "dropkey": "PZ23817",
    "droptype": "D",
    "dropname": "WEST COVINA",
    "dropdeladd": "396 S CALIFORNIA AVE",
    "dropdelcty": "WEST COVINA",
    "dropdelst": "CA",
    "dropdelzpp": 917939998,
    "dropphyadd": "396 S CALIFORNIA AVE",
    "dropphycty": "WEST COVINA",
    "dropphyst": "CA",
    "dropphyzpp": 917939998,
    "dropmaladd": "396 S CALIFORNIA AVE",
    "dropmalcty": "WEST COVINA",
    "dropmalst": "CA",
    "dropmalzpp": 917939998,
    "dropsitphn": 6269627491,
    "dropsitlph": 6269628565,
    "dropsitcph": 6269627491,
    "dropfax": 6269628572
  },
  {
    "dcode": "D",
    "dropkey": "PZ23833",
    "droptype": "D",
    "dropname": "WEST POINT",
    "dropdeladd": "397 MAIN ST",
    "dropdelcty": "WEST POINT",
    "dropdelst": "CA",
    "dropdelzpp": 952559998,
    "dropphyadd": "397 MAIN ST",
    "dropphycty": "WEST POINT",
    "dropphyst": "CA",
    "dropphyzpp": 952559998,
    "dropmaladd": "397 MAIN ST",
    "dropmalcty": "WEST POINT",
    "dropmalst": "CA",
    "dropmalzpp": 952559998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092934490,
    "dropsitcph": 2092934490,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23836",
    "droptype": "D",
    "dropname": "WEST SACRAMENTO",
    "dropdeladd": "1601 MERKLEY AVE",
    "dropdelcty": "WEST SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 956919998,
    "dropphyadd": "1601 MERKLEY AVE",
    "dropphycty": "WEST SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 956919998,
    "dropmaladd": "1601 MERKLEY AVE",
    "dropmalcty": "WEST SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 956919998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165563423,
    "dropsitcph": 9165563406,
    "dropfax": 9163711945
  },
  {
    "dcode": "D",
    "dropkey": "PZ23846",
    "droptype": "D",
    "dropname": "WESTLEY",
    "dropdeladd": "8627 STATE HIGHWAY 33",
    "dropdelcty": "WESTLEY",
    "dropdelst": "CA",
    "dropdelzpp": 953879998,
    "dropphyadd": "8627 STATE HIGHWAY 33",
    "dropphycty": "WESTLEY",
    "dropphyst": "CA",
    "dropphyzpp": 953879998,
    "dropmaladd": "8627 STATE HIGHWAY 33",
    "dropmalcty": "WESTLEY",
    "dropmalst": "CA",
    "dropmalzpp": 953879998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098946251,
    "dropsitcph": 2098946251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23848",
    "droptype": "D",
    "dropname": "WESTMINSTER",
    "dropdeladd": "15030 GOLDENWEST CIR",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CA",
    "dropdelzpp": 926859998,
    "dropphyadd": "15030 GOLDENWEST CIR",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CA",
    "dropphyzpp": 926859998,
    "dropmaladd": "15030 GOLDENWEST CIR",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CA",
    "dropmalzpp": 926859998,
    "dropsitphn": 7148923232,
    "dropsitlph": 7149036089,
    "dropsitcph": 7148923232,
    "dropfax": 7143734329
  },
  {
    "dcode": "D",
    "dropkey": "PZ23850",
    "droptype": "D",
    "dropname": "WESTMORLAND",
    "dropdeladd": "199 S CENTER ST",
    "dropdelcty": "WESTMORLAND",
    "dropdelst": "CA",
    "dropdelzpp": 922819998,
    "dropphyadd": "199 S CENTER ST",
    "dropphycty": "WESTMORLAND",
    "dropphyst": "CA",
    "dropphyzpp": 922819998,
    "dropmaladd": "199 S CENTER ST",
    "dropmalcty": "WESTMORLAND",
    "dropmalst": "CA",
    "dropmalzpp": 922819998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603443092,
    "dropsitcph": 7603443092,
    "dropfax": 7603441788
  },
  {
    "dcode": "D",
    "dropkey": "PZ23858",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "309 ASH ST",
    "dropdelcty": "WESTWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 961379995,
    "dropphyadd": "309 ASH ST",
    "dropphycty": "WESTWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 961379995,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WESTWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 961379998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302563402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23861",
    "droptype": "D",
    "dropname": "WHEATLAND",
    "dropdeladd": "404 4TH ST",
    "dropdelcty": "WHEATLAND",
    "dropdelst": "CA",
    "dropdelzpp": 956929998,
    "dropphyadd": "404 4TH ST",
    "dropphycty": "WHEATLAND",
    "dropphyst": "CA",
    "dropphyzpp": 956929998,
    "dropmaladd": "404 4TH ST",
    "dropmalcty": "WHEATLAND",
    "dropmalst": "CA",
    "dropmalzpp": 956929998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306334003,
    "dropsitcph": 5306334003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23868",
    "droptype": "D",
    "dropname": "WHITETHORN",
    "dropdeladd": "498 SHELTER COVE RD",
    "dropdelcty": "WHITETHORN",
    "dropdelst": "CA",
    "dropdelzpp": 955899998,
    "dropphyadd": "498 SHELTER COVE RD",
    "dropphycty": "WHITETHORN",
    "dropphyst": "CA",
    "dropphyzpp": 955899998,
    "dropmaladd": "498 SHELTER COVE RD",
    "dropmalcty": "WHITETHORN",
    "dropmalst": "CA",
    "dropmalzpp": 955899998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079867532,
    "dropfax": 7079867532
  },
  {
    "dcode": "D",
    "dropkey": "PZ23869",
    "droptype": "D",
    "dropname": "WHITMORE",
    "dropdeladd": "30544 WHITMORE RD",
    "dropdelcty": "WHITMORE",
    "dropdelst": "CA",
    "dropdelzpp": 960969998,
    "dropphyadd": "30544 WHITMORE RD",
    "dropphycty": "WHITMORE",
    "dropphyst": "CA",
    "dropphyzpp": 960969998,
    "dropmaladd": "30544 WHITMORE RD",
    "dropmalcty": "WHITMORE",
    "dropmalst": "CA",
    "dropmalzpp": 960969998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304723777,
    "dropsitcph": 5304723777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23870",
    "droptype": "D",
    "dropname": "WHITTIER",
    "dropdeladd": "8520 MICHIGAN AVE",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906059998,
    "dropphyadd": "8520 MICHIGAN AVE",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906059998,
    "dropmaladd": "8520 MICHIGAN AVE",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906059998,
    "dropsitphn": 5626939561,
    "dropsitlph": 5626933048,
    "dropsitcph": 5629073910,
    "dropfax": 5626980041
  },
  {
    "dcode": "D",
    "dropkey": "PZ23875",
    "droptype": "D",
    "dropname": "WILDOMAR",
    "dropdeladd": "21392 PALOMAR ST",
    "dropdelcty": "WILDOMAR",
    "dropdelst": "CA",
    "dropdelzpp": 925959998,
    "dropphyadd": "21392 PALOMAR ST",
    "dropphycty": "WILDOMAR",
    "dropphyst": "CA",
    "dropphyzpp": 925959998,
    "dropmaladd": "21392 PALOMAR ST",
    "dropmalcty": "WILDOMAR",
    "dropmalst": "CA",
    "dropmalzpp": 925959998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516789013,
    "dropsitcph": 9516789610,
    "dropfax": 9516789561
  },
  {
    "dcode": "D",
    "dropkey": "PZ23881",
    "droptype": "D",
    "dropname": "WILLIAMS",
    "dropdeladd": "801 E ST",
    "dropdelcty": "WILLIAMS",
    "dropdelst": "CA",
    "dropdelzpp": 959879998,
    "dropphyadd": "801 E ST",
    "dropphycty": "WILLIAMS",
    "dropphyst": "CA",
    "dropphyzpp": 959879998,
    "dropmaladd": "801 E ST",
    "dropmalcty": "WILLIAMS",
    "dropmalst": "CA",
    "dropmalzpp": 959879998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5304752156,
    "dropsitcph": 5304752156,
    "dropfax": 5304733418
  },
  {
    "dcode": "D",
    "dropkey": "PZ23882",
    "droptype": "D",
    "dropname": "WILLITS",
    "dropdeladd": "315 S MAIN ST",
    "dropdelcty": "WILLITS",
    "dropdelst": "CA",
    "dropdelzpp": 954909910,
    "dropphyadd": "315 S MAIN ST",
    "dropphycty": "WILLITS",
    "dropphyst": "CA",
    "dropphyzpp": 954909910,
    "dropmaladd": "315 S MAIN ST",
    "dropmalcty": "WILLITS",
    "dropmalst": "CA",
    "dropmalzpp": 954909910,
    "dropsitphn": 7077785312,
    "dropsitlph": 7074595253,
    "dropsitcph": 7074595255,
    "dropfax": 7074590904
  },
  {
    "dcode": "D",
    "dropkey": "PZ23883",
    "droptype": "D",
    "dropname": "WILLOW CREEK",
    "dropdeladd": "100 COUNTRY CLUB DR",
    "dropdelcty": "WILLOW CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 955739998,
    "dropphyadd": "100 COUNTRY CLUB DR",
    "dropphycty": "WILLOW CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 955739998,
    "dropmaladd": "100 COUNTRY CLUB DR",
    "dropmalcty": "WILLOW CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 955739998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 5306292185,
    "dropfax": 5306293105
  },
  {
    "dcode": "D",
    "dropkey": "PZ23890",
    "droptype": "D",
    "dropname": "WILLOWS",
    "dropdeladd": "315 W SYCAMORE ST",
    "dropdelcty": "WILLOWS",
    "dropdelst": "CA",
    "dropdelzpp": 959889998,
    "dropphyadd": "315 W SYCAMORE ST",
    "dropphycty": "WILLOWS",
    "dropphyst": "CA",
    "dropphyzpp": 959889998,
    "dropmaladd": "315 W SYCAMORE ST",
    "dropmalcty": "WILLOWS",
    "dropmalst": "CA",
    "dropmalzpp": 959889998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309344805,
    "dropsitcph": 5309342215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23892",
    "droptype": "D",
    "dropname": "WILMINGTON",
    "dropdeladd": "1008 N AVALON BLVD",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "CA",
    "dropdelzpp": 907449998,
    "dropphyadd": "1008 N AVALON BLVD",
    "dropphycty": "WILMINGTON",
    "dropphyst": "CA",
    "dropphyzpp": 907449998,
    "dropmaladd": "1008 N AVALON BLVD",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "CA",
    "dropmalzpp": 907449998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3108346311,
    "dropsitcph": 3108346926,
    "dropfax": 3108343802
  },
  {
    "dcode": "D",
    "dropkey": "PZ23893",
    "droptype": "D",
    "dropname": "WILSEYVILLE",
    "dropdeladd": "4054 BLIZZARD MINE RD",
    "dropdelcty": "WILSEYVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 952579998,
    "dropphyadd": "4054 BLIZZARD MINE RD",
    "dropphycty": "WILSEYVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 952579998,
    "dropmaladd": "4054 BLIZZARD MINE RD",
    "dropmalcty": "WILSEYVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 952579998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092937780,
    "dropsitcph": 2092937780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23898",
    "droptype": "D",
    "dropname": "WILTON",
    "dropdeladd": "11090 JEFF BRIAN LN",
    "dropdelcty": "WILTON",
    "dropdelst": "CA",
    "dropdelzpp": 956939998,
    "dropphyadd": "11090 JEFF BRIAN LN",
    "dropphycty": "WILTON",
    "dropphyst": "CA",
    "dropphyzpp": 956939998,
    "dropmaladd": "11090 JEFF BRIAN LN",
    "dropmalcty": "WILTON",
    "dropmalst": "CA",
    "dropmalzpp": 956939998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9166877974,
    "dropsitcph": 9166876908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23899",
    "droptype": "D",
    "dropname": "WINCHESTER",
    "dropdeladd": "28453 WINCHESTER RD",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "CA",
    "dropdelzpp": 925969998,
    "dropphyadd": "28453 WINCHESTER RD",
    "dropphycty": "WINCHESTER",
    "dropphyst": "CA",
    "dropphyzpp": 925969998,
    "dropmaladd": "28453 WINCHESTER RD",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "CA",
    "dropmalzpp": 925969998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9519262591,
    "dropsitcph": 9519265381,
    "dropfax": 9519263801
  },
  {
    "dcode": "D",
    "dropkey": "PZ23900",
    "droptype": "D",
    "dropname": "WINDSOR",
    "dropdeladd": "8800 LAKEWOOD DR",
    "dropdelcty": "WINDSOR",
    "dropdelst": "CA",
    "dropdelzpp": 954927206,
    "dropphyadd": "8800 LAKEWOOD DR",
    "dropphycty": "WINDSOR",
    "dropphyst": "CA",
    "dropphyzpp": 954927206,
    "dropmaladd": "8800 LAKEWOOD DR",
    "dropmalcty": "WINDSOR",
    "dropmalst": "CA",
    "dropmalzpp": 954927206,
    "dropsitphn": 7078386531,
    "dropsitlph": 7078367677,
    "dropsitcph": 7078386531,
    "dropfax": 7078380732
  },
  {
    "dcode": "D",
    "dropkey": "PZ23904",
    "droptype": "D",
    "dropname": "WINTERHAVEN",
    "dropdeladd": "2127 WINTERHAVEN DR",
    "dropdelcty": "WINTERHAVEN",
    "dropdelst": "CA",
    "dropdelzpp": 922839998,
    "dropphyadd": "2127 WINTERHAVEN DR",
    "dropphycty": "WINTERHAVEN",
    "dropphyst": "CA",
    "dropphyzpp": 922839998,
    "dropmaladd": "2127 WINTERHAVEN DR",
    "dropmalcty": "WINTERHAVEN",
    "dropmalst": "CA",
    "dropmalzpp": 922839998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7605720662,
    "dropsitcph": 7605720471,
    "dropfax": 7605725119
  },
  {
    "dcode": "D",
    "dropkey": "PZ23906",
    "droptype": "D",
    "dropname": "WINTERS",
    "dropdeladd": "510 RAILROAD AVE",
    "dropdelcty": "WINTERS",
    "dropdelst": "CA",
    "dropdelzpp": 956949998,
    "dropphyadd": "510 RAILROAD AVE",
    "dropphycty": "WINTERS",
    "dropphyst": "CA",
    "dropphyzpp": 956949998,
    "dropmaladd": "510 RAILROAD AVE",
    "dropmalcty": "WINTERS",
    "dropmalst": "CA",
    "dropmalzpp": 956949998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307953958,
    "dropsitcph": 5307953838,
    "dropfax": 5307954299
  },
  {
    "dcode": "D",
    "dropkey": "PZ23907",
    "droptype": "D",
    "dropname": "WINTON",
    "dropdeladd": "6514 N WINTON WAY",
    "dropdelcty": "WINTON",
    "dropdelst": "CA",
    "dropdelzpp": 953889998,
    "dropphyadd": "6514 N WINTON WAY",
    "dropphycty": "WINTON",
    "dropphyst": "CA",
    "dropphyzpp": 953889998,
    "dropmaladd": "6514 N WINTON WAY",
    "dropmalcty": "WINTON",
    "dropmalst": "CA",
    "dropmalzpp": 953889998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093586253,
    "dropsitcph": 2093586253,
    "dropfax": 2093570771
  },
  {
    "dcode": "D",
    "dropkey": "PZ23912",
    "droptype": "D",
    "dropname": "WOFFORD HEIGHTS",
    "dropdeladd": "6336 WOFFORD BLVD",
    "dropdelcty": "WOFFORD HEIGHTS",
    "dropdelst": "CA",
    "dropdelzpp": 932859998,
    "dropphyadd": "6336 WOFFORD BLVD",
    "dropphycty": "WOFFORD HEIGHTS",
    "dropphyst": "CA",
    "dropphyzpp": 932859998,
    "dropmaladd": "6336 WOFFORD BLVD",
    "dropmalcty": "WOFFORD HEIGHTS",
    "dropmalst": "CA",
    "dropmalzpp": 932859998,
    "dropsitphn": 6617757808,
    "dropsitlph": 7603766765,
    "dropsitcph": 7603766765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23913",
    "droptype": "D",
    "dropname": "WOODACRE",
    "dropdeladd": "183 SAN GERONIMO VALLEY DR",
    "dropdelcty": "WOODACRE",
    "dropdelst": "CA",
    "dropdelzpp": 949738700,
    "dropphyadd": "183 SAN GERONIMO VALLEY DR",
    "dropphycty": "WOODACRE",
    "dropphyst": "CA",
    "dropphyzpp": 949738700,
    "dropmaladd": "183 SAN GERONIMO VALLEY DR",
    "dropmalcty": "WOODACRE",
    "dropmalst": "CA",
    "dropmalzpp": 949739998,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077785254,
    "dropsitcph": 4154889337,
    "dropfax": 4154889597
  },
  {
    "dcode": "D",
    "dropkey": "PZ23914",
    "droptype": "D",
    "dropname": "WOODBRIDGE",
    "dropdeladd": "1049 E AUGUSTA ST",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "CA",
    "dropdelzpp": 952589998,
    "dropphyadd": "1049 E AUGUSTA ST",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "CA",
    "dropphyzpp": 952589998,
    "dropmaladd": "1049 E AUGUSTA ST",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "CA",
    "dropmalzpp": 952589998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093651403,
    "dropsitcph": 2093651294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23917",
    "droptype": "D",
    "dropname": "WOODLAKE",
    "dropdeladd": "310 N VALENCIA BLVD",
    "dropdelcty": "WOODLAKE",
    "dropdelst": "CA",
    "dropdelzpp": 932869998,
    "dropphyadd": "310 N VALENCIA BLVD",
    "dropphycty": "WOODLAKE",
    "dropphyst": "CA",
    "dropphyzpp": 932869998,
    "dropmaladd": "310 N VALENCIA BLVD",
    "dropmalcty": "WOODLAKE",
    "dropmalst": "CA",
    "dropmalzpp": 932869998,
    "dropsitphn": 6617757808,
    "dropsitlph": 5595645508,
    "dropsitcph": 5595645508,
    "dropfax": 5595645202
  },
  {
    "dcode": "D",
    "dropkey": "PZ23918",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "720 COURT ST",
    "dropdelcty": "WOODLAND",
    "dropdelst": "CA",
    "dropdelzpp": 956959998,
    "dropphyadd": "720 COURT ST",
    "dropphycty": "WOODLAND",
    "dropphyst": "CA",
    "dropphyzpp": 956959998,
    "dropmaladd": "720 COURT ST",
    "dropmalcty": "WOODLAND",
    "dropmalst": "CA",
    "dropmalzpp": 956959998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306621627,
    "dropsitcph": 5306620832,
    "dropfax": 5306627689
  },
  {
    "dcode": "D",
    "dropkey": "PZ23920",
    "droptype": "D",
    "dropname": "WOODLAND HILLS",
    "dropdeladd": "21200 OXNARD ST",
    "dropdelcty": "WOODLAND HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 913679998,
    "dropphyadd": "21200 OXNARD ST",
    "dropphycty": "WOODLAND HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 913679998,
    "dropmaladd": "21200 OXNARD ST",
    "dropmalcty": "WOODLAND HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 913679998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183400014,
    "dropsitcph": 8183400014,
    "dropfax": 8183400067
  },
  {
    "dcode": "D",
    "dropkey": "PZ23925",
    "droptype": "D",
    "dropname": "WOODY",
    "dropdeladd": "17987 HIGHWAY 155",
    "dropdelcty": "WOODY",
    "dropdelst": "CA",
    "dropdelzpp": 932879719,
    "dropphyadd": "17987 HIGHWAY 155",
    "dropphycty": "WOODY",
    "dropphyst": "CA",
    "dropphyzpp": 932879719,
    "dropmaladd": "17987 HIGHWAY 155",
    "dropmalcty": "WOODY",
    "dropmalst": "CA",
    "dropmalzpp": 932879719,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615368866,
    "dropsitcph": 6615368866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23931",
    "droptype": "D",
    "dropname": "WRIGHTWOOD",
    "dropdeladd": "1440 STATE HIGHWAY 2",
    "dropdelcty": "WRIGHTWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 923979998,
    "dropphyadd": "1440 STATE HIGHWAY 2",
    "dropphycty": "WRIGHTWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 923979998,
    "dropmaladd": "1440 STATE HIGHWAY 2",
    "dropmalcty": "WRIGHTWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 923979998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602495053,
    "dropsitcph": 7602498882,
    "dropfax": 7602496445
  },
  {
    "dcode": "D",
    "dropkey": "PZ23938",
    "droptype": "D",
    "dropname": "YERMO",
    "dropdeladd": "485 W YERMO RD",
    "dropdelcty": "YERMO",
    "dropdelst": "CA",
    "dropdelzpp": 923980405,
    "dropphyadd": "485 W YERMO RD",
    "dropphycty": "YERMO",
    "dropphyst": "CA",
    "dropphyzpp": 923980405,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YERMO",
    "dropmalst": "CA",
    "dropmalzpp": 923989998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7602542166,
    "dropsitcph": 7602542315,
    "dropfax": 7602549205
  },
  {
    "dcode": "D",
    "dropkey": "PZ23939",
    "droptype": "D",
    "dropname": "YETTEM",
    "dropdeladd": "14026 AVENUE 384",
    "dropdelcty": "YETTEM",
    "dropdelst": "CA",
    "dropdelzpp": 936709998,
    "dropphyadd": "14026 AVENUE 384",
    "dropphycty": "YETTEM",
    "dropphyst": "CA",
    "dropphyzpp": 936709998,
    "dropmaladd": "14026 AVENUE 384",
    "dropmalcty": "YETTEM",
    "dropmalst": "CA",
    "dropmalzpp": 936709998,
    "dropsitphn": 5594977615,
    "dropsitlph": 4084376726,
    "dropsitcph": 5595283940,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23943",
    "droptype": "D",
    "dropname": "YOLO",
    "dropdeladd": "14138 2ND ST",
    "dropdelcty": "YOLO",
    "dropdelst": "CA",
    "dropdelzpp": 956979998,
    "dropphyadd": "14138 2ND ST",
    "dropphycty": "YOLO",
    "dropphyst": "CA",
    "dropphyzpp": 956979998,
    "dropmaladd": "14138 2ND ST",
    "dropmalcty": "YOLO",
    "dropmalst": "CA",
    "dropmalzpp": 956979998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306662378,
    "dropsitcph": 5306662378,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23945",
    "droptype": "D",
    "dropname": "YORBA LINDA",
    "dropdeladd": "4770 EUREKA AVE",
    "dropdelcty": "YORBA LINDA",
    "dropdelst": "CA",
    "dropdelzpp": 928859998,
    "dropphyadd": "4770 EUREKA AVE",
    "dropphycty": "YORBA LINDA",
    "dropphyst": "CA",
    "dropphyzpp": 928859998,
    "dropmaladd": "4770 EUREKA AVE",
    "dropmalcty": "YORBA LINDA",
    "dropmalst": "CA",
    "dropmalzpp": 928859998,
    "dropsitphn": 7145287052,
    "dropsitlph": 7145283778,
    "dropsitcph": 7145287052,
    "dropfax": 7145284051
  },
  {
    "dcode": "D",
    "dropkey": "PZ23947",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "25400 HIGHWAY 128",
    "dropdelcty": "YORKVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 954949900,
    "dropphyadd": "25400 HIGHWAY 128",
    "dropphycty": "YORKVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 954949900,
    "dropmaladd": "25400 HIGHWAY 128",
    "dropmalcty": "YORKVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 954949900,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7078944376,
    "dropfax": 7078944376
  },
  {
    "dcode": "D",
    "dropkey": "PZ23951",
    "droptype": "D",
    "dropname": "YOSEMITE NATIONAL PARK",
    "dropdeladd": "9017 VILLAGE DR",
    "dropdelcty": "YOSEMITE NATIONAL PARK",
    "dropdelst": "CA",
    "dropdelzpp": 953899998,
    "dropphyadd": "9017 VILLAGE DR",
    "dropphycty": "YOSEMITE NATIONAL PARK",
    "dropphyst": "CA",
    "dropphyzpp": 953899998,
    "dropmaladd": "9017 VILLAGE DR",
    "dropmalcty": "YOSEMITE NATIONAL PARK",
    "dropmalst": "CA",
    "dropmalzpp": 953899998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093724475,
    "dropsitcph": 2093724475,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23954",
    "droptype": "D",
    "dropname": "YOUNTVILLE",
    "dropdeladd": "6514 WASHINGTON ST",
    "dropdelcty": "YOUNTVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 945995000,
    "dropphyadd": "6514 WASHINGTON ST",
    "dropphycty": "YOUNTVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 945995000,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YOUNTVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 945999998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079442123,
    "dropfax": 7079449653
  },
  {
    "dcode": "D",
    "dropkey": "PZ23955",
    "droptype": "D",
    "dropname": "YREKA",
    "dropdeladd": "401 S BROADWAY ST",
    "dropdelcty": "YREKA",
    "dropdelst": "CA",
    "dropdelzpp": 960979998,
    "dropphyadd": "401 S BROADWAY ST",
    "dropphycty": "YREKA",
    "dropphyst": "CA",
    "dropphyzpp": 960979998,
    "dropmaladd": "401 S BROADWAY ST",
    "dropmalcty": "YREKA",
    "dropmalst": "CA",
    "dropmalzpp": 960979998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308427305,
    "dropsitcph": 5308429372,
    "dropfax": 5308427333
  },
  {
    "dcode": "D",
    "dropkey": "PZ23956",
    "droptype": "D",
    "dropname": "YUBA CITY",
    "dropdeladd": "761 PLUMAS ST",
    "dropdelcty": "YUBA CITY",
    "dropdelst": "CA",
    "dropdelzpp": 959919998,
    "dropphyadd": "761 PLUMAS ST",
    "dropphycty": "YUBA CITY",
    "dropphyst": "CA",
    "dropphyzpp": 959919998,
    "dropmaladd": "761 PLUMAS ST",
    "dropmalcty": "YUBA CITY",
    "dropmalst": "CA",
    "dropmalzpp": 959919998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306739643,
    "dropsitcph": 5306731497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23957",
    "droptype": "D",
    "dropname": "YUCAIPA",
    "dropdeladd": "12460 CALIFORNIA ST",
    "dropdelcty": "YUCAIPA",
    "dropdelst": "CA",
    "dropdelzpp": 923994494,
    "dropphyadd": "12460 CALIFORNIA ST",
    "dropphycty": "YUCAIPA",
    "dropphyst": "CA",
    "dropphyzpp": 923994494,
    "dropmaladd": "12460 CALIFORNIA ST",
    "dropmalcty": "YUCAIPA",
    "dropmalst": "CA",
    "dropmalzpp": 923994494,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097908384,
    "dropsitcph": 9097974851,
    "dropfax": 9097973861
  },
  {
    "dcode": "D",
    "dropkey": "PZ23959",
    "droptype": "D",
    "dropname": "YUCCA VALLEY",
    "dropdeladd": "57280 YUCCA TRL",
    "dropdelcty": "YUCCA VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 922847915,
    "dropphyadd": "57280 YUCCA TRL",
    "dropphycty": "YUCCA VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 922847915,
    "dropmaladd": "57280 YUCCA TRL",
    "dropmalcty": "YUCCA VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 922847915,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603656096,
    "dropsitcph": 7603650725,
    "dropfax": 7603657365
  },
  {
    "dcode": "D",
    "dropkey": "PZ23961",
    "droptype": "D",
    "dropname": "ZAMORA",
    "dropdeladd": "9780 BLACKS ST",
    "dropdelcty": "ZAMORA",
    "dropdelst": "CA",
    "dropdelzpp": 956989998,
    "dropphyadd": "9780 BLACKS ST",
    "dropphycty": "ZAMORA",
    "dropphyst": "CA",
    "dropphyzpp": 956989998,
    "dropmaladd": "9780 BLACKS ST",
    "dropmalcty": "ZAMORA",
    "dropmalst": "CA",
    "dropmalzpp": 956989998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306620406,
    "dropsitcph": 5306620406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "PZ23962",
    "droptype": "D",
    "dropname": "ZENIA",
    "dropdeladd": "26531 RUTH ZENIA RD",
    "dropdelcty": "ZENIA",
    "dropdelst": "CA",
    "dropdelzpp": 955959998,
    "dropphyadd": "26531 RUTH ZENIA RD",
    "dropphycty": "ZENIA",
    "dropphyst": "CA",
    "dropphyzpp": 955959998,
    "dropmaladd": "26531 RUTH ZENIA RD",
    "dropmalcty": "ZENIA",
    "dropmalst": "CA",
    "dropmalzpp": 955959998,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7079239687,
    "dropfax": 7079239687
  },
  {
    "dcode": "D",
    "dropkey": "P000153",
    "droptype": "D",
    "dropname": "MIAMI BEACH",
    "dropdeladd": "1300 WASHINGTON AVE",
    "dropdelcty": "MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331199998,
    "dropphyadd": "1300 WASHINGTON AVE",
    "dropphycty": "MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331199998,
    "dropmaladd": "1300 WASHINGTON AVE",
    "dropmalcty": "MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331199998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055341891,
    "dropsitcph": 3056722447,
    "dropfax": 3055385187
  },
  {
    "dcode": "D",
    "dropkey": "P000155",
    "droptype": "D",
    "dropname": "EMERALD ISLE",
    "dropdeladd": "142 EASTVIEW DR",
    "dropdelcty": "EMERALD ISLE",
    "dropdelst": "NC",
    "dropdelzpp": 285941911,
    "dropphyadd": "142 EASTVIEW DR",
    "dropphycty": "EMERALD ISLE",
    "dropphyst": "NC",
    "dropphyzpp": 285941911,
    "dropmaladd": "PO BOX 28594",
    "dropmalcty": "EMERALD ISLE",
    "dropmalst": "NC",
    "dropmalzpp": 285949998,
    "dropsitphn": 7043934581,
    "dropsitlph": 2523546677,
    "dropsitcph": 2523546677,
    "dropfax": 2523542189
  },
  {
    "dcode": "D",
    "dropkey": "P000809",
    "droptype": "D",
    "dropname": "CHINO HILLS",
    "dropdeladd": "14071 PEYTON DR",
    "dropdelcty": "CHINO HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 917099998,
    "dropphyadd": "14071 PEYTON DR",
    "dropphycty": "CHINO HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 917099998,
    "dropmaladd": "14071 PEYTON DR",
    "dropmalcty": "CHINO HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 917099998,
    "dropsitphn": 9095480695,
    "dropsitlph": 9095480936,
    "dropsitcph": 9095480695,
    "dropfax": 9095909926
  },
  {
    "dcode": "D",
    "dropkey": "P001096",
    "droptype": "D",
    "dropname": "HILLVIEW",
    "dropdeladd": "175 TANYARD SPRINGS BLVD",
    "dropdelcty": "HILLVIEW",
    "dropdelst": "KY",
    "dropdelzpp": 401299998,
    "dropphyadd": "175 TANYARD SPRINGS BLVD",
    "dropphycty": "HILLVIEW",
    "dropphyst": "KY",
    "dropphyzpp": 401299998,
    "dropmaladd": "175 TANYARD SPRINGS BLVD",
    "dropmalcty": "HILLVIEW",
    "dropmalst": "KY",
    "dropmalzpp": 401299998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029668049,
    "dropfax": 5029645178
  },
  {
    "dcode": "D",
    "dropkey": "P001177",
    "droptype": "D",
    "dropname": "PHANTOM (ARDMORE TN)",
    "dropdeladd": "26050 MAIN ST",
    "dropdelcty": "ARDMORE",
    "dropdelst": "TN",
    "dropdelzpp": 384499998,
    "dropphyadd": "26050 MAIN ST",
    "dropphycty": "ARDMORE",
    "dropphyst": "TN",
    "dropphyzpp": 384499998,
    "dropmaladd": "26050 MAIN ST",
    "dropmalcty": "ARDMORE",
    "dropmalst": "TN",
    "dropmalzpp": 384499998,
    "dropsitphn": 2568594180,
    "dropsitlph": "",
    "dropsitcph": 9314273706,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001262",
    "droptype": "D",
    "dropname": "PHANTOM",
    "dropdeladd": "107 N MAIN ST",
    "dropdelcty": "CAMP CROOK",
    "dropdelst": "SD",
    "dropdelzpp": 577249000,
    "dropphyadd": "107 N MAIN ST",
    "dropphycty": "CAMP CROOK",
    "dropphyst": "SD",
    "dropphyzpp": 577249000,
    "dropmaladd": "107 N MAIN ST",
    "dropmalcty": "CAMP CROOK",
    "dropmalst": "SD",
    "dropmalzpp": 577249000,
    "dropsitphn": 4064442600,
    "dropsitlph": 9016814585,
    "dropsitcph": 9016814585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001284",
    "droptype": "D",
    "dropname": "HILLSBOROUGH",
    "dropdeladd": "437 AMWELL RD",
    "dropdelcty": "HILLSBOROUGH",
    "dropdelst": "NJ",
    "dropdelzpp": "088449998",
    "dropphyadd": "437 AMWELL RD",
    "dropphycty": "HILLSBOROUGH",
    "dropphyst": "NJ",
    "dropphyzpp": "088449998",
    "dropmaladd": "437 AMWELL RD",
    "dropmalcty": "HILLSBOROUGH",
    "dropmalst": "NJ",
    "dropmalzpp": "088449998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9082819873,
    "dropfax": 6503576749
  },
  {
    "dcode": "D",
    "dropkey": "P001733",
    "droptype": "D",
    "dropname": "EVERETT PHANTOM",
    "dropdeladd": "11 NORWOOD ST",
    "dropdelcty": "EVERETT",
    "dropdelst": "MA",
    "dropdelzpp": "021499998",
    "dropphyadd": "11 NORWOOD ST",
    "dropphycty": "EVERETT",
    "dropphyst": "MA",
    "dropphyzpp": "021499998",
    "dropmaladd": "11 NORWOOD ST",
    "dropmalcty": "EVERETT",
    "dropmalst": "MA",
    "dropmalzpp": "021499998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6173811016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001771",
    "droptype": "D",
    "dropname": "ARLINGTON PHANTOM",
    "dropdeladd": "10 COURT ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "024769998",
    "dropphyadd": "10 COURT ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "024769998",
    "dropmaladd": "10 COURT ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "024769998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7816485376,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001773",
    "droptype": "D",
    "dropname": "NEEDHAM PHANTOM",
    "dropdeladd": "1150 GREAT PLAIN AVE",
    "dropdelcty": "NEEDHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024929998",
    "dropphyadd": "1150 GREAT PLAIN AVE",
    "dropphycty": "NEEDHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024929998",
    "dropmaladd": "1150 GREAT PLAIN AVE",
    "dropmalcty": "NEEDHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024929998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7814490707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001774",
    "droptype": "D",
    "dropname": "QUINCY PHANTOM",
    "dropdeladd": "47 WASHINGTON ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MA",
    "dropdelzpp": "021699998",
    "dropphyadd": "47 WASHINGTON ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MA",
    "dropphyzpp": "021699998",
    "dropmaladd": "47 WASHINGTON ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "MA",
    "dropmalzpp": "021699998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6177736641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001813",
    "droptype": "D",
    "dropname": "SOMERVILLE PHANTOM",
    "dropdeladd": "18 BOW ST",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "021432956",
    "dropphyadd": "18 BOW ST",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "021432956",
    "dropmaladd": "18 BOW ST",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021432956",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6176662332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001814",
    "droptype": "D",
    "dropname": "MALDEN PHANTOM",
    "dropdeladd": "109 MOUNTAIN AVE",
    "dropdelcty": "MALDEN",
    "dropdelst": "MA",
    "dropdelzpp": "021489998",
    "dropphyadd": "109 MOUNTAIN AVE",
    "dropphycty": "MALDEN",
    "dropphyst": "MA",
    "dropphyzpp": "021489998",
    "dropmaladd": "109 MOUNTAIN AVE",
    "dropmalcty": "MALDEN",
    "dropmalst": "MA",
    "dropmalzpp": "021489998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7813224685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001815",
    "droptype": "D",
    "dropname": "REVERE PHANTOM OLD",
    "dropdeladd": "300 BROADWAY LBBY",
    "dropdelcty": "REVERE",
    "dropdelst": "MA",
    "dropdelzpp": "021519998",
    "dropphyadd": "300 BROADWAY LBBY",
    "dropphycty": "REVERE",
    "dropphyst": "MA",
    "dropphyzpp": "021519998",
    "dropmaladd": "300 BROADWAY LBBY",
    "dropmalcty": "REVERE",
    "dropmalst": "MA",
    "dropmalzpp": "021519998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7812892105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001816",
    "droptype": "D",
    "dropname": "CHELSEA PHANTOM",
    "dropdeladd": "320 BROADWAY STE 1",
    "dropdelcty": "CHELSEA",
    "dropdelst": "MA",
    "dropdelzpp": "021509991",
    "dropphyadd": "320 BROADWAY STE 1",
    "dropphycty": "CHELSEA",
    "dropphyst": "MA",
    "dropphyzpp": "021509991",
    "dropmaladd": "320 BROADWAY STE 1",
    "dropmalcty": "CHELSEA",
    "dropmalst": "MA",
    "dropmalzpp": "021509991",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6178843578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001817",
    "droptype": "D",
    "dropname": "WINTHROP PHANTOM",
    "dropdeladd": "5 MICHAELS MALL",
    "dropdelcty": "WINTHROP",
    "dropdelst": "MA",
    "dropdelzpp": "021529998",
    "dropphyadd": "5 MICHAELS MALL",
    "dropphycty": "WINTHROP",
    "dropphyst": "MA",
    "dropphyzpp": "021529998",
    "dropmaladd": "5 MICHAELS MALL",
    "dropmalcty": "WINTHROP",
    "dropmalst": "MA",
    "dropmalzpp": "021529998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6178460995,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001818",
    "droptype": "D",
    "dropname": "MEDFORD PHANTOM",
    "dropdeladd": "20 FOREST ST",
    "dropdelcty": "MEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "021559998",
    "dropphyadd": "20 FOREST ST",
    "dropphycty": "MEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "021559998",
    "dropmaladd": "20 FOREST ST",
    "dropmalcty": "MEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "021559998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7813962444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001820",
    "droptype": "D",
    "dropname": "STONEHAM PHANTOM",
    "dropdeladd": "345 MAIN ST",
    "dropdelcty": "STONEHAM",
    "dropdelst": "MA",
    "dropdelzpp": "021809998",
    "dropphyadd": "345 MAIN ST",
    "dropphycty": "STONEHAM",
    "dropphyst": "MA",
    "dropphyzpp": "021809998",
    "dropmaladd": "345 MAIN ST",
    "dropmalcty": "STONEHAM",
    "dropmalst": "MA",
    "dropmalzpp": "021809998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7814383124,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001821",
    "droptype": "D",
    "dropname": "BRAINTREE PHANTOM",
    "dropdeladd": "333 COMMERCE DR",
    "dropdelcty": "BRAINTREE",
    "dropdelst": "MA",
    "dropdelzpp": "021849998",
    "dropphyadd": "333 COMMERCE DR",
    "dropphycty": "BRAINTREE",
    "dropphyst": "MA",
    "dropphyzpp": "021849998",
    "dropmaladd": "333 COMMERCE DR",
    "dropmalcty": "BRAINTREE",
    "dropmalst": "MA",
    "dropmalzpp": "021849998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7813563912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001822",
    "droptype": "D",
    "dropname": "MILTON PHANTOM",
    "dropdeladd": "499 ADAMS ST",
    "dropdelcty": "MILTON",
    "dropdelst": "MA",
    "dropdelzpp": "021869998",
    "dropphyadd": "499 ADAMS ST",
    "dropphycty": "MILTON",
    "dropphyst": "MA",
    "dropphyzpp": "021869998",
    "dropmaladd": "499 ADAMS ST",
    "dropmalcty": "MILTON",
    "dropmalst": "MA",
    "dropmalzpp": "021869998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176988139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001823",
    "droptype": "D",
    "dropname": "WEYMOUTH PHANTOM",
    "dropdeladd": "103 WASHINGTON ST",
    "dropdelcty": "WEYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "021889998",
    "dropphyadd": "103 WASHINGTON ST",
    "dropphycty": "WEYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "021889998",
    "dropmaladd": "103 WASHINGTON ST",
    "dropmalcty": "WEYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "021889998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7813376867,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001824",
    "droptype": "D",
    "dropname": "LEXINGTON PHANTOM",
    "dropdeladd": "1661 MASSACHUSETTS AVE",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "024209998",
    "dropphyadd": "1661 MASSACHUSETTS AVE",
    "dropphycty": "LEXINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "024209998",
    "dropmaladd": "1661 MASSACHUSETTS AVE",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "024209998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7818624066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001825",
    "droptype": "D",
    "dropname": "BROOKLINE PHANTOM",
    "dropdeladd": "1295 BEACON ST",
    "dropdelcty": "BROOKLINE",
    "dropdelst": "MA",
    "dropdelzpp": "024469998",
    "dropphyadd": "1295 BEACON ST",
    "dropphycty": "BROOKLINE",
    "dropphyst": "MA",
    "dropphyzpp": "024469998",
    "dropmaladd": "1295 BEACON ST",
    "dropmalcty": "BROOKLINE",
    "dropmalst": "MA",
    "dropmalzpp": "024469998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177381649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001826",
    "droptype": "D",
    "dropname": "WALTHAM PHANTOM",
    "dropdeladd": "776 MAIN ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024519998",
    "dropphyadd": "776 MAIN ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024519998",
    "dropmaladd": "776 MAIN ST",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024519998",
    "dropsitphn": 7818931100,
    "dropsitlph": "",
    "dropsitcph": 7818939754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001827",
    "droptype": "D",
    "dropname": "NEWTON PHANTOM",
    "dropdeladd": "211 SUMNER ST",
    "dropdelcty": "NEWTON CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "024599998",
    "dropphyadd": "211 SUMNER ST",
    "dropphycty": "NEWTON CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "024599998",
    "dropmaladd": "211 SUMNER ST",
    "dropmalcty": "NEWTON CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "024599998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5086471864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001830",
    "droptype": "D",
    "dropname": "WELLESLEY PHANTOM",
    "dropdeladd": "1 GROVE ST",
    "dropdelcty": "WELLESLEY",
    "dropdelst": "MA",
    "dropdelzpp": "024829998",
    "dropphyadd": "1 GROVE ST",
    "dropphycty": "WELLESLEY",
    "dropphyst": "MA",
    "dropphyzpp": "024829998",
    "dropmaladd": "1 GROVE ST",
    "dropmalcty": "WELLESLEY",
    "dropmalst": "MA",
    "dropmalzpp": "024829998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7812353666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001831",
    "droptype": "D",
    "dropname": "WATERTOWN PHANTOM",
    "dropdeladd": "170 HIGH ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024535914",
    "dropphyadd": "170 HIGH ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024535914",
    "dropmaladd": "170 HIGH ST",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024535914",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6179263666,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001832",
    "droptype": "D",
    "dropname": "BELMONT PHANTOM",
    "dropdeladd": "405 CONCORD AVE",
    "dropdelcty": "BELMONT",
    "dropdelst": "MA",
    "dropdelzpp": "024789998",
    "dropphyadd": "405 CONCORD AVE",
    "dropphycty": "BELMONT",
    "dropphyst": "MA",
    "dropphyzpp": "024789998",
    "dropmaladd": "405 CONCORD AVE",
    "dropmalcty": "BELMONT",
    "dropmalst": "MA",
    "dropmalzpp": "024789998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174844201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001833",
    "droptype": "D",
    "dropname": "WESTON PHANTOM",
    "dropdeladd": "25 COLPITTS RD",
    "dropdelcty": "WESTON",
    "dropdelst": "MA",
    "dropdelzpp": "024939998",
    "dropphyadd": "25 COLPITTS RD",
    "dropphycty": "WESTON",
    "dropphyst": "MA",
    "dropphyzpp": "024939998",
    "dropmaladd": "25 COLPITTS RD",
    "dropmalcty": "WESTON",
    "dropmalst": "MA",
    "dropmalzpp": "024939998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7818937667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001844",
    "droptype": "D",
    "dropname": "MELROSE PHANTOM",
    "dropdeladd": "23 ESSEX ST",
    "dropdelcty": "MELROSE",
    "dropdelst": "MA",
    "dropdelzpp": "021769998",
    "dropphyadd": "23 ESSEX ST",
    "dropphycty": "MELROSE",
    "dropphyst": "MA",
    "dropphyzpp": "021769998",
    "dropmaladd": "23 ESSEX ST",
    "dropmalcty": "MELROSE",
    "dropmalst": "MA",
    "dropmalzpp": "021769998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7816658571,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P001933",
    "droptype": "D",
    "dropname": "UNIONDALE",
    "dropdeladd": "1000 FRONT ST",
    "dropdelcty": "UNIONDALE",
    "dropdelst": "NY",
    "dropdelzpp": 115531649,
    "dropphyadd": "1000 FRONT ST",
    "dropphycty": "UNIONDALE",
    "dropphyst": "NY",
    "dropphyzpp": 115531649,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONDALE",
    "dropmalst": "NY",
    "dropmalzpp": 115539998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5164818245,
    "dropfax": 6317552524
  },
  {
    "dcode": "D",
    "dropkey": "P001934",
    "droptype": "D",
    "dropname": "WEST HEMPSTEAD",
    "dropdeladd": "245 HEMPSTEAD AVE",
    "dropdelcty": "WEST HEMPSTEAD",
    "dropdelst": "NY",
    "dropdelzpp": 115522114,
    "dropphyadd": "245 HEMPSTEAD AVE",
    "dropphycty": "WEST HEMPSTEAD",
    "dropphyst": "NY",
    "dropphyzpp": 115522114,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST HEMPSTEAD",
    "dropmalst": "NY",
    "dropmalzpp": 115529998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5164815430,
    "dropfax": 5164866504
  },
  {
    "dcode": "D",
    "dropkey": "P001935",
    "droptype": "D",
    "dropname": "EAST MEADOW",
    "dropdeladd": "446 E MEADOW AVE",
    "dropdelcty": "EAST MEADOW",
    "dropdelst": "NY",
    "dropdelzpp": 115543946,
    "dropphyadd": "446 E MEADOW AVE",
    "dropphycty": "EAST MEADOW",
    "dropphyst": "NY",
    "dropphyzpp": 115543946,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "EAST MEADOW",
    "dropmalst": "NY",
    "dropmalzpp": 115549998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167944509,
    "dropfax": 5167945937
  },
  {
    "dcode": "D",
    "dropkey": "P001988",
    "droptype": "D",
    "dropname": "ALTA PHANTOM",
    "dropdeladd": "70 S MAIN ST",
    "dropdelcty": "DRIGGS",
    "dropdelst": "ID",
    "dropdelzpp": 834229998,
    "dropphyadd": "70 S MAIN ST",
    "dropphycty": "DRIGGS",
    "dropphyst": "ID",
    "dropphyzpp": 834229998,
    "dropmaladd": "70 S MAIN ST",
    "dropmalcty": "DRIGGS",
    "dropmalst": "ID",
    "dropmalzpp": 834229998,
    "dropsitphn": 3032976441,
    "dropsitlph": "",
    "dropsitcph": 9016814614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P002035",
    "droptype": "D",
    "dropname": "EAST PROV PHANTOM",
    "dropdeladd": "17 GROVE AVE",
    "dropdelcty": "EAST PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029144560",
    "dropphyadd": "17 GROVE AVE",
    "dropphycty": "EAST PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029144560",
    "dropmaladd": "17 GROVE AVE",
    "dropmalcty": "EAST PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029144560",
    "dropsitphn": 4017525649,
    "dropsitlph": "",
    "dropsitcph": 4014340042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P002036",
    "droptype": "D",
    "dropname": "JOHNSTON PHANTOM",
    "dropdeladd": "1530 ATWOOD AVE",
    "dropdelcty": "JOHNSTON",
    "dropdelst": "RI",
    "dropdelzpp": "029199992",
    "dropphyadd": "1530 ATWOOD AVE",
    "dropphycty": "JOHNSTON",
    "dropphyst": "RI",
    "dropphyzpp": "029199992",
    "dropmaladd": "1530 ATWOOD AVE",
    "dropmalcty": "JOHNSTON",
    "dropmalst": "RI",
    "dropmalzpp": "029199992",
    "dropsitphn": 4017525649,
    "dropsitlph": "",
    "dropsitcph": 4017525500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P002037",
    "droptype": "D",
    "dropname": "LAKEVILLE PHANTOM",
    "dropdeladd": "330 BEDFORD ST STE 1",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "023472100",
    "dropphyadd": "330 BEDFORD ST STE 1",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "023472100",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "023479998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089464519,
    "dropfax": 5089464519
  },
  {
    "dcode": "D",
    "dropkey": "P002038",
    "droptype": "D",
    "dropname": "KINGSTON PHANTOM",
    "dropdeladd": "74 SUMMER ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "MA",
    "dropdelzpp": "023649998",
    "dropphyadd": "74 SUMMER ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "MA",
    "dropphyzpp": "023649998",
    "dropmaladd": "74 SUMMER ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "MA",
    "dropmalzpp": "023649998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7815822504,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P002601",
    "droptype": "D",
    "dropname": "PORT ORANGE",
    "dropdeladd": "725 DUNLAWTON AVE",
    "dropdelcty": "PORT ORANGE",
    "dropdelst": "FL",
    "dropdelzpp": 321279226,
    "dropphyadd": "725 DUNLAWTON AVE",
    "dropphycty": "PORT ORANGE",
    "dropphyst": "FL",
    "dropphyzpp": 321279226,
    "dropmaladd": "725 DUNLAWTON AVE",
    "dropmalcty": "PORT ORANGE",
    "dropmalst": "FL",
    "dropmalzpp": 321279998,
    "dropsitphn": 9043592597,
    "dropsitlph": 3867677490,
    "dropsitcph": 3867671686,
    "dropfax": 3867670181
  },
  {
    "dcode": "D",
    "dropkey": "P011951",
    "droptype": "D",
    "dropname": "PORT SAINT LUCIE",
    "dropdeladd": "290 NW PEACOCK BLVD",
    "dropdelcty": "PORT SAINT LUCIE",
    "dropdelst": "FL",
    "dropdelzpp": 349869998,
    "dropphyadd": "290 NW PEACOCK BLVD",
    "dropphycty": "PORT SAINT LUCIE",
    "dropphyst": "FL",
    "dropphyzpp": 349869998,
    "dropmaladd": "290 NW PEACOCK BLVD",
    "dropmalcty": "PORT SAINT LUCIE",
    "dropmalst": "FL",
    "dropmalzpp": 349869998,
    "dropsitphn": 7723445054,
    "dropsitlph": 7723445054,
    "dropsitcph": 7728730674,
    "dropfax": 7724468301
  },
  {
    "dcode": "D",
    "dropkey": "P012054",
    "droptype": "D",
    "dropname": "DHS PHANTOM",
    "dropdeladd": "225 N HUMPHREYS BLVD STE 501",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381881001,
    "dropphyadd": "225 N HUMPHREYS BLVD STE 501",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381881001,
    "dropmaladd": "225 N HUMPHREYS BLVD STE 501",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381881001,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105559999,
    "dropsitcph": 4105559999,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P013054",
    "droptype": "D",
    "dropname": "WEST DES MOINES PHANTOM",
    "dropdeladd": "225 N HUMPHREYS BLVD STE 501",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381881001,
    "dropphyadd": "225 N HUMPHREYS BLVD STE 501",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381881001,
    "dropmaladd": "225 N HUMPHREYS BLVD STE 501",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381881001,
    "dropsitphn": 5152837530,
    "dropsitlph": 9016814487,
    "dropsitcph": 9016814487,
    "dropfax": 9016814487
  },
  {
    "dcode": "D",
    "dropkey": "P014050",
    "droptype": "D",
    "dropname": "LODGEPOLE PHANTOM",
    "dropdeladd": "502 ADAMS AVE",
    "dropdelcty": "HETTINGER",
    "dropdelst": "ND",
    "dropdelzpp": 586399003,
    "dropphyadd": "502 ADAMS AVE",
    "dropphycty": "HETTINGER",
    "dropphyst": "ND",
    "dropphyzpp": 586399003,
    "dropmaladd": "502 ADAMS AVE",
    "dropmalcty": "HETTINGER",
    "dropmalst": "ND",
    "dropmalzpp": 586399003,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055642000,
    "dropsitcph": 6055642000,
    "dropfax": 6053574906
  },
  {
    "dcode": "D",
    "dropkey": "P014934",
    "droptype": "D",
    "dropname": "TEXHOMA PHANTOM",
    "dropdeladd": "225 N HUMPHREYS BLVD STE 501",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381881001,
    "dropphyadd": "225 N HUMPHREYS BLVD STE 501",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381881001,
    "dropmaladd": "225 N HUMPHREYS BLVD STE 501",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381881001,
    "dropsitphn": 8173173658,
    "dropsitlph": "",
    "dropsitcph": 8173173658,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P015047",
    "droptype": "D",
    "dropname": "LITTLE AMERICA",
    "dropdeladd": "6945 STATE HIGHWAY 374",
    "dropdelcty": "LITTLE AMERICA",
    "dropdelst": "WY",
    "dropdelzpp": 829299900,
    "dropphyadd": "6945 STATE HIGHWAY 374",
    "dropphycty": "LITTLE AMERICA",
    "dropphyst": "WY",
    "dropphyzpp": 829299900,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE AMERICA",
    "dropmalst": "WY",
    "dropmalzpp": 829299998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078752400,
    "dropsitcph": 3078752400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P016502",
    "droptype": "D",
    "dropname": "CLIMAX",
    "dropdeladd": "102 W BROAD ST",
    "dropdelcty": "CLIMAX",
    "dropdelst": "GA",
    "dropdelzpp": 398342781,
    "dropphyadd": "102 W BROAD ST",
    "dropphycty": "CLIMAX",
    "dropphyst": "GA",
    "dropphyzpp": 398342781,
    "dropmaladd": "102 W BROAD ST",
    "dropmalcty": "CLIMAX",
    "dropmalst": "GA",
    "dropmalzpp": 398342781,
    "dropsitphn": 4787528466,
    "dropsitlph": 2297623267,
    "dropsitcph": 2297623267,
    "dropfax": 2297623267
  },
  {
    "dcode": "D",
    "dropkey": "P017330",
    "droptype": "D",
    "dropname": "DPO",
    "dropdeladd": "11698 NW 25TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331129997,
    "dropphyadd": "11698 NW 25TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331129997,
    "dropmaladd": "11698 NW 25TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331129997,
    "dropsitphn": 3058713327,
    "dropsitlph": "",
    "dropsitcph": 3057187501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P017332",
    "droptype": "D",
    "dropname": "DPO",
    "dropdeladd": "80 COUNTY RD",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070979997",
    "dropphyadd": "80 COUNTY RD",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070979997",
    "dropmaladd": "80 COUNTY RD",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070979997",
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215323,
    "dropsitcph": 7185537138,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P017333",
    "droptype": "D",
    "dropname": "DPO",
    "dropdeladd": "2501 RYDIN RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948509751,
    "dropphyadd": "2501 RYDIN RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948509751,
    "dropmaladd": "2501 RYDIN RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948509751,
    "dropsitphn": 6508081314,
    "dropsitlph": "",
    "dropsitcph": 6508081356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P018783",
    "droptype": "D",
    "dropname": "LEAD HILL PHANTOM",
    "dropdeladd": "165 HIGHWAY 14",
    "dropdelcty": "LEAD HILL",
    "dropdelst": "AR",
    "dropdelzpp": 726449998,
    "dropphyadd": "165 HIGHWAY 14",
    "dropphycty": "LEAD HILL",
    "dropphyst": "AR",
    "dropphyzpp": 726449998,
    "dropmaladd": "165 HIGHWAY 14",
    "dropmalcty": "LEAD HILL",
    "dropmalst": "AR",
    "dropmalzpp": 726449998,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 8704365219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P018924",
    "droptype": "D",
    "dropname": "COTTAGE GROVE",
    "dropdeladd": "7523 95TH ST S",
    "dropdelcty": "COTTAGE GROVE",
    "dropdelst": "MN",
    "dropdelzpp": 550163944,
    "dropphyadd": "7523 95TH ST S",
    "dropphycty": "COTTAGE GROVE",
    "dropphyst": "MN",
    "dropphyzpp": 550163944,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COTTAGE GROVE",
    "dropmalst": "MN",
    "dropmalzpp": 550169998,
    "dropsitphn": 6517680325,
    "dropsitlph": "",
    "dropsitcph": 6517680325,
    "dropfax": 6517698968
  },
  {
    "dcode": "D",
    "dropkey": "P019643",
    "droptype": "D",
    "dropname": "REVERE PHANTOM",
    "dropdeladd": "300 BROADWAY LBBY",
    "dropdelcty": "REVERE",
    "dropdelst": "MA",
    "dropdelzpp": "021519998",
    "dropphyadd": "300 BROADWAY LBBY",
    "dropphycty": "REVERE",
    "dropphyst": "MA",
    "dropphyzpp": "021519998",
    "dropmaladd": "300 BROADWAY LBBY",
    "dropmalcty": "REVERE",
    "dropmalst": "MA",
    "dropmalzpp": "021519998",
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7812892105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "P020963",
    "droptype": "D",
    "dropname": "BIG SKY",
    "dropdeladd": "110 MEADOW VILLAGE DR",
    "dropdelcty": "BIG SKY",
    "dropdelst": "MT",
    "dropdelzpp": 597169994,
    "dropphyadd": "110 MEADOW VILLAGE DR",
    "dropphycty": "BIG SKY",
    "dropphyst": "MT",
    "dropphyzpp": 597169994,
    "dropmaladd": "110 MEADOW VILLAGE DR",
    "dropmalcty": "BIG SKY",
    "dropmalst": "MT",
    "dropmalzpp": 597169994,
    "dropsitphn": 4069954540,
    "dropsitlph": 4063247019,
    "dropsitcph": 4063247019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A435",
    "droptype": "D",
    "dropname": "HAVENSIGHT",
    "dropdeladd": "9007 HAVENSIGHT SHOPP CTR STE D",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029994",
    "dropphyadd": "9007 HAVENSIGHT SHOPP CTR STE D",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029994",
    "dropmaladd": "9007 HAVENSIGHT SHOPP CTR STE D",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029994",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407769897,
    "dropfax": 3407769695
  },
  {
    "dcode": "D",
    "dropkey": "SV1A496",
    "droptype": "D",
    "dropname": "RYDER RETAIL",
    "dropdeladd": "2222 FLATBUSH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112349993,
    "dropphyadd": "2222 FLATBUSH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112349993,
    "dropmaladd": "2222 FLATBUSH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112349993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183381351,
    "dropfax": 7183388361
  },
  {
    "dcode": "D",
    "dropkey": "SV1A522",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "60 EVERGREEN PL STE 101",
    "dropdelcty": "EAST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070189992",
    "dropphyadd": "60 EVERGREEN PL STE 101",
    "dropphycty": "EAST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070189992",
    "dropmaladd": "60 EVERGREEN PL STE 101",
    "dropmalcty": "EAST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070189992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736726873,
    "dropsitcph": 9736726873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A554",
    "droptype": "D",
    "dropname": "KIMBERLY SQUARE",
    "dropdeladd": "475 ALBANY SHAKER RD STE 9",
    "dropdelcty": "LOUDONVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 122119900,
    "dropphyadd": "475 ALBANY SHAKER RD STE 9",
    "dropphycty": "LOUDONVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 122119900,
    "dropmaladd": "475 ALBANY SHAKER RD STE 9",
    "dropmalcty": "LOUDONVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 122119900,
    "dropsitphn": 5184589548,
    "dropsitlph": 5184591813,
    "dropsitcph": 5184591813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A606",
    "droptype": "D",
    "dropname": "UNION STATION",
    "dropdeladd": "311 EXCHANGE AVE",
    "dropdelcty": "ENDICOTT",
    "dropdelst": "NY",
    "dropdelzpp": 137609211,
    "dropphyadd": "311 EXCHANGE AVE",
    "dropphycty": "ENDICOTT",
    "dropphyst": "NY",
    "dropphyzpp": 137609211,
    "dropmaladd": "311 EXCHANGE AVE",
    "dropmalcty": "ENDICOTT",
    "dropmalst": "NY",
    "dropmalzpp": 137609211,
    "dropsitphn": 6077851181,
    "dropsitlph": 6077851181,
    "dropsitcph": 6077851181,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A616",
    "droptype": "D",
    "dropname": "FORT WASHINGTON",
    "dropdeladd": "556 W 158TH ST FRNT 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100327222,
    "dropphyadd": "556 W 158TH ST FRNT 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100327222,
    "dropmaladd": "556 W 158TH ST FRNT 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100327222,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129236654,
    "dropsitcph": 2129236654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A624",
    "droptype": "D",
    "dropname": "CYPRESS HILLS",
    "dropdeladd": "222 CRESCENT ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112089993,
    "dropphyadd": "222 CRESCENT ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112089993,
    "dropmaladd": "222 CRESCENT ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112089993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183483310,
    "dropsitcph": 7182776057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV1A638",
    "droptype": "D",
    "dropname": "MARTIN LUTHER KING JR",
    "dropdeladd": "9402 CHURCH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112129993,
    "dropphyadd": "9402 CHURCH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112129993,
    "dropmaladd": "9402 CHURCH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112129993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183423189,
    "dropfax": 7183469168
  },
  {
    "dcode": "D",
    "dropkey": "SV1A648",
    "droptype": "D",
    "dropname": "BERGEN SOUTH",
    "dropdeladd": "369 MARTIN LUTHER KING JR DR",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073059997",
    "dropphyadd": "369 MARTIN LUTHER KING JR DR",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073059997",
    "dropmaladd": "369 MARTIN LUTHER KING JR DR",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073059997",
    "dropsitphn": 2019559705,
    "dropsitlph": 5513490464,
    "dropsitcph": 5513490464,
    "dropfax": 6505774420
  },
  {
    "dcode": "D",
    "dropkey": "SV10026",
    "droptype": "D",
    "dropname": "ALLWOOD",
    "dropdeladd": "495 ALLWOOD RD",
    "dropdelcty": "CLIFTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070129998",
    "dropphyadd": "495 ALLWOOD RD",
    "dropphycty": "CLIFTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070129998",
    "dropmaladd": "495 ALLWOOD RD",
    "dropmalcty": "CLIFTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070129998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734734946,
    "dropsitcph": 9734734946,
    "dropfax": 6505774218
  },
  {
    "dcode": "D",
    "dropkey": "SV10031",
    "droptype": "D",
    "dropname": "AMPERE",
    "dropdeladd": "75 4TH AVE",
    "dropdelcty": "EAST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070179994",
    "dropphyadd": "75 4TH AVE",
    "dropphycty": "EAST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070179994",
    "dropmaladd": "75 4TH AVE",
    "dropmalcty": "EAST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070179994",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736784571,
    "dropsitcph": 9736785471,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10068",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "567 BROADWAY",
    "dropdelcty": "LONG BRANCH",
    "dropdelst": "NJ",
    "dropdelzpp": "077409995",
    "dropphyadd": "567 BROADWAY",
    "dropphycty": "LONG BRANCH",
    "dropphyst": "NJ",
    "dropphyzpp": "077409995",
    "dropmaladd": "567 BROADWAY",
    "dropmalcty": "LONG BRANCH",
    "dropmalst": "NJ",
    "dropmalzpp": "077409995",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322220203,
    "dropsitcph": 7322220203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10085",
    "droptype": "D",
    "dropname": "BAYWAY",
    "dropdeladd": "544 BAYWAY AVE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "072029991",
    "dropphyadd": "544 BAYWAY AVE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "072029991",
    "dropmaladd": "544 BAYWAY AVE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "072029991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9083510983,
    "dropsitcph": 9083510983,
    "dropfax": 9083525485
  },
  {
    "dcode": "D",
    "dropkey": "SV10108",
    "droptype": "D",
    "dropname": "BERGEN NORTH",
    "dropdeladd": "528 BERGEN AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073049998",
    "dropphyadd": "528 BERGEN AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073049998",
    "dropmaladd": "528 BERGEN AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073049998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013320919,
    "dropsitcph": 2013320919,
    "dropfax": 6505774409
  },
  {
    "dcode": "D",
    "dropkey": "SV10114",
    "droptype": "D",
    "dropname": "BERGENLINE",
    "dropdeladd": "2100 BERGENLINE AVE",
    "dropdelcty": "UNION CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070879991",
    "dropphyadd": "2100 BERGENLINE AVE",
    "dropphycty": "UNION CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070879991",
    "dropmaladd": "2100 BERGENLINE AVE",
    "dropmalcty": "UNION CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070879991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2016175288,
    "dropsitcph": 2016175288,
    "dropfax": 2018650723
  },
  {
    "dcode": "D",
    "dropkey": "SV10161",
    "droptype": "D",
    "dropname": "BRAINY BORO",
    "dropdeladd": "195 CENTRAL AVE",
    "dropdelcty": "METUCHEN",
    "dropdelst": "NJ",
    "dropdelzpp": "088409997",
    "dropphyadd": "195 CENTRAL AVE",
    "dropphycty": "METUCHEN",
    "dropphyst": "NJ",
    "dropphyzpp": "088409997",
    "dropmaladd": "195 CENTRAL AVE",
    "dropmalcty": "METUCHEN",
    "dropmalst": "NJ",
    "dropmalzpp": "088409997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325498623,
    "dropfax": 7325491824
  },
  {
    "dcode": "D",
    "dropkey": "SV10182",
    "droptype": "D",
    "dropname": "BROOKDALE",
    "dropdeladd": "1296 BROAD ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070039991",
    "dropphyadd": "1296 BROAD ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070039991",
    "dropmaladd": "1296 BROAD ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070039991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9733386921,
    "dropsitcph": 9733386921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10201",
    "droptype": "D",
    "dropname": "INDEPENDENCE",
    "dropdeladd": "2465 S BROAD ST STE C2",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086109998",
    "dropphyadd": "2465 S BROAD ST STE C2",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086109998",
    "dropmaladd": "2465 S BROAD ST STE C2",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086109998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6098880114,
    "dropfax": 6098881334
  },
  {
    "dcode": "D",
    "dropkey": "SV10221",
    "droptype": "D",
    "dropname": "CASSVILLE",
    "dropdeladd": "520 W VETERANS HWY",
    "dropdelcty": "JACKSON",
    "dropdelst": "NJ",
    "dropdelzpp": "085273705",
    "dropphyadd": "520 W VETERANS HWY",
    "dropphycty": "JACKSON",
    "dropphyst": "NJ",
    "dropphyzpp": "085273705",
    "dropmaladd": "520 W VETERANS HWY",
    "dropmalcty": "JACKSON",
    "dropmalst": "NJ",
    "dropmalzpp": "085273705",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329280110,
    "dropfax": 7329285041
  },
  {
    "dcode": "D",
    "dropkey": "SV10253",
    "droptype": "D",
    "dropname": "CHESTNUT",
    "dropdeladd": "611 CHESTNUT ST",
    "dropdelcty": "UNION",
    "dropdelst": "NJ",
    "dropdelzpp": "070839991",
    "dropphyadd": "611 CHESTNUT ST",
    "dropphycty": "UNION",
    "dropphyst": "NJ",
    "dropphyzpp": "070839991",
    "dropmaladd": "611 CHESTNUT ST",
    "dropmalcty": "UNION",
    "dropmalst": "NJ",
    "dropmalzpp": "070839991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9086862319,
    "dropsitcph": 9086862319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10265",
    "droptype": "D",
    "dropname": "CLIFF PARK",
    "dropdeladd": "589 ANDERSON AVE STE 1",
    "dropdelcty": "CLIFFSIDE PARK",
    "dropdelst": "NJ",
    "dropdelzpp": "070109991",
    "dropphyadd": "589 ANDERSON AVE STE 1",
    "dropphycty": "CLIFFSIDE PARK",
    "dropphyst": "NJ",
    "dropphyzpp": "070109991",
    "dropmaladd": "589 ANDERSON AVE STE 1",
    "dropmalcty": "CLIFFSIDE PARK",
    "dropmalst": "NJ",
    "dropmalzpp": "070109991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2019456428,
    "dropsitcph": 2019456428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10325",
    "droptype": "D",
    "dropname": "DELAWANNA",
    "dropdeladd": "266 MAIN AVE",
    "dropdelcty": "CLIFTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070149998",
    "dropphyadd": "266 MAIN AVE",
    "dropphycty": "CLIFTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070149998",
    "dropmaladd": "266 MAIN AVE",
    "dropmalcty": "CLIFTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070149998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737773096,
    "dropsitcph": 9734720426,
    "dropfax": 6505774218
  },
  {
    "dcode": "D",
    "dropkey": "SV10341",
    "droptype": "D",
    "dropname": "DODDTOWN",
    "dropdeladd": "333 DODD ST STE 1",
    "dropdelcty": "EAST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070179991",
    "dropphyadd": "333 DODD ST STE 1",
    "dropphycty": "EAST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070179991",
    "dropmaladd": "333 DODD ST STE 1",
    "dropmalcty": "EAST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070179991",
    "dropsitphn": 2019559705,
    "dropsitlph": 8736787998,
    "dropsitcph": 9736787499,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10353",
    "droptype": "D",
    "dropname": "DOWNTOWN",
    "dropdeladd": "20 S MONTGOMERY ST",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086089998",
    "dropphyadd": "20 S MONTGOMERY ST",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086089998",
    "dropmaladd": "20 S MONTGOMERY ST",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086089998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6095994050,
    "dropfax": 6095991162
  },
  {
    "dcode": "D",
    "dropkey": "SV10358",
    "droptype": "D",
    "dropname": "VILLA PARK",
    "dropdeladd": "1137 HAMILTON AVE",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086299998",
    "dropphyadd": "1137 HAMILTON AVE",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086299998",
    "dropmaladd": "1137 HAMILTON AVE",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086299998",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 6093928900,
    "dropfax": 6093924522
  },
  {
    "dcode": "D",
    "dropkey": "SV10376",
    "droptype": "D",
    "dropname": "EAST CAMDEN",
    "dropdeladd": "2816 FEDERAL ST",
    "dropdelcty": "CAMDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "081059998",
    "dropphyadd": "2816 FEDERAL ST",
    "dropphycty": "CAMDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "081059998",
    "dropmaladd": "2816 FEDERAL ST",
    "dropmalcty": "CAMDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "081059998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569638973,
    "dropsitcph": 8569636597,
    "dropfax": 8569639041
  },
  {
    "dcode": "D",
    "dropkey": "SV10383",
    "droptype": "D",
    "dropname": "EAST MILLSTONE",
    "dropdeladd": "11 MARKET ST",
    "dropdelcty": "SOMERSET",
    "dropdelst": "NJ",
    "dropdelzpp": "088739996",
    "dropphyadd": "11 MARKET ST",
    "dropphycty": "SOMERSET",
    "dropphyst": "NJ",
    "dropphyzpp": "088739996",
    "dropmaladd": "11 MARKET ST",
    "dropmalcty": "SOMERSET",
    "dropmalst": "NJ",
    "dropmalzpp": "088739996",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7328732043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10408",
    "droptype": "D",
    "dropname": "ELBERON",
    "dropdeladd": "1175 LINCOLN PL",
    "dropdelcty": "LONG BRANCH",
    "dropdelst": "NJ",
    "dropdelzpp": "077409997",
    "dropphyadd": "1175 LINCOLN PL",
    "dropphycty": "LONG BRANCH",
    "dropphyst": "NJ",
    "dropphyzpp": "077409997",
    "dropmaladd": "1175 LINCOLN PL",
    "dropmalcty": "LONG BRANCH",
    "dropmalst": "NJ",
    "dropmalzpp": "077409997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7322220110,
    "dropsitcph": 7322220110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10419",
    "droptype": "D",
    "dropname": "ELMORA",
    "dropdeladd": "175 ELMORA AVE STE 1",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "072029992",
    "dropphyadd": "175 ELMORA AVE STE 1",
    "dropphycty": "ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "072029992",
    "dropmaladd": "175 ELMORA AVE STE 1",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "072029992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935187,
    "dropsitcph": 9083545697,
    "dropfax": 9083525485
  },
  {
    "dcode": "D",
    "dropkey": "SV10425",
    "droptype": "D",
    "dropname": "ENGLEWOOD ANNEX",
    "dropdeladd": "55 SMITH ST",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "076319991",
    "dropphyadd": "55 SMITH ST",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "076319991",
    "dropmaladd": "55 SMITH ST",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "076319991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2015695834,
    "dropsitcph": 2015695834,
    "dropfax": 6505774415
  },
  {
    "dcode": "D",
    "dropkey": "SV10436",
    "droptype": "D",
    "dropname": "ERNSTON",
    "dropdeladd": "499 ERNSTON RD STE SB5",
    "dropdelcty": "PARLIN",
    "dropdelst": "NJ",
    "dropdelzpp": "088599997",
    "dropphyadd": "499 ERNSTON RD STE SB5",
    "dropphycty": "PARLIN",
    "dropphyst": "NJ",
    "dropphyzpp": "088599997",
    "dropmaladd": "499 ERNSTON RD STE SB5",
    "dropmalcty": "PARLIN",
    "dropmalst": "NJ",
    "dropmalzpp": "088599997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7327275220,
    "dropfax": 7326139616
  },
  {
    "dcode": "D",
    "dropkey": "SV10481",
    "droptype": "D",
    "dropname": "FIVE CORNERS",
    "dropdeladd": "645 NEWARK AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073069991",
    "dropphyadd": "645 NEWARK AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073069991",
    "dropmaladd": "645 NEWARK AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073069991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737982708,
    "dropsitcph": 2017982704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10498",
    "droptype": "D",
    "dropname": "FORTY FIFTH STREET",
    "dropdeladd": "4535 BERGENLINE AVE STE A",
    "dropdelcty": "UNION CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070879993",
    "dropphyadd": "4535 BERGENLINE AVE STE A",
    "dropphycty": "UNION CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070879993",
    "dropmaladd": "4535 BERGENLINE AVE STE A",
    "dropmalcty": "UNION CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070879993",
    "dropsitphn": 2019559705,
    "dropsitlph": 2016174900,
    "dropsitcph": 2016174900,
    "dropfax": 2018650723
  },
  {
    "dcode": "D",
    "dropkey": "SV10554",
    "droptype": "D",
    "dropname": "GRASSELLI",
    "dropdeladd": "938 S WOOD AVE",
    "dropdelcty": "LINDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070369992",
    "dropphyadd": "938 S WOOD AVE",
    "dropphycty": "LINDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070369992",
    "dropmaladd": "938 S WOOD AVE",
    "dropmalcty": "LINDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070369992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9089258836,
    "dropsitcph": 9088623984,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10571",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "137 OCEAN AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073059991",
    "dropphyadd": "137 OCEAN AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073059991",
    "dropmaladd": "137 OCEAN AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073059991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013326304,
    "dropsitcph": 2013326304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10581",
    "droptype": "D",
    "dropname": "GROVE",
    "dropdeladd": "145 GROVE ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070039992",
    "dropphyadd": "145 GROVE ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070039992",
    "dropmaladd": "145 GROVE ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070039992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737482036,
    "dropsitcph": 9737482036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10667",
    "droptype": "D",
    "dropname": "HUDSON CITY",
    "dropdeladd": "392 CENTRAL AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073079998",
    "dropphyadd": "392 CENTRAL AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073079998",
    "dropmaladd": "392 CENTRAL AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073079998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2017983936,
    "dropsitcph": 2017983936,
    "dropfax": 6505774219
  },
  {
    "dcode": "D",
    "dropkey": "SV10679",
    "droptype": "D",
    "dropname": "IRONBOUND",
    "dropdeladd": "279 FERRY ST STE 4",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071059998",
    "dropphyadd": "279 FERRY ST STE 4",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071059998",
    "dropmaladd": "279 FERRY ST STE 4",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071059998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736907111,
    "dropsitcph": 9736905624,
    "dropfax": 6505774200
  },
  {
    "dcode": "D",
    "dropkey": "SV10707",
    "droptype": "D",
    "dropname": "JOURNAL SQUARE",
    "dropdeladd": "899 BERGEN AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073069998",
    "dropphyadd": "899 BERGEN AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073069998",
    "dropmaladd": "899 BERGEN AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073069998",
    "dropsitphn": 2019559705,
    "dropsitlph": 2017982681,
    "dropsitcph": 2017982681,
    "dropfax": 6505774350
  },
  {
    "dcode": "D",
    "dropkey": "SV10749",
    "droptype": "D",
    "dropname": "LAKEWOOD RETAIL",
    "dropdeladd": "19 CLIFTON AVE STE 100",
    "dropdelcty": "LAKEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "087013332",
    "dropphyadd": "19 CLIFTON AVE STE 100",
    "dropphycty": "LAKEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "087013332",
    "dropmaladd": "19 CLIFTON AVE STE 100",
    "dropmalcty": "LAKEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "087013332",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7329011349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10822",
    "droptype": "D",
    "dropname": "MAIN AVENUE",
    "dropdeladd": "1114 MAIN AVE",
    "dropdelcty": "CLIFTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070119991",
    "dropphyadd": "1114 MAIN AVE",
    "dropphycty": "CLIFTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070119991",
    "dropmaladd": "1114 MAIN AVE",
    "dropmalcty": "CLIFTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070119991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9732495227,
    "dropsitcph": 9732497527,
    "dropfax": 6505774218
  },
  {
    "dcode": "D",
    "dropkey": "SV10823",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "13 LAFAYETTE PL",
    "dropdelcty": "FREEHOLD",
    "dropdelst": "NJ",
    "dropdelzpp": "077283501",
    "dropphyadd": "13 LAFAYETTE PL",
    "dropphycty": "FREEHOLD",
    "dropphyst": "NJ",
    "dropphyzpp": "077283501",
    "dropmaladd": "13 LAFAYETTE PL",
    "dropmalcty": "FREEHOLD",
    "dropmalst": "NJ",
    "dropmalzpp": "077283501",
    "dropsitphn": 8569334046,
    "dropsitlph": 7324626275,
    "dropsitcph": 7324626275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10840",
    "droptype": "D",
    "dropname": "MAPLECREST",
    "dropdeladd": "1767 SPRINGFIELD AVE STE 2",
    "dropdelcty": "MAPLEWOOD",
    "dropdelst": "NJ",
    "dropdelzpp": "070409991",
    "dropphyadd": "1767 SPRINGFIELD AVE STE 2",
    "dropphycty": "MAPLEWOOD",
    "dropphyst": "NJ",
    "dropphyzpp": "070409991",
    "dropmaladd": "1767 SPRINGFIELD AVE STE 2",
    "dropmalcty": "MAPLEWOOD",
    "dropmalst": "NJ",
    "dropmalzpp": "070409991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737616788,
    "dropsitcph": 9737616788,
    "dropfax": 9737633479
  },
  {
    "dcode": "D",
    "dropkey": "SV10869",
    "droptype": "D",
    "dropname": "MEADOWS",
    "dropdeladd": "700 PLAZA DR STE A",
    "dropdelcty": "SECAUCUS",
    "dropdelst": "NJ",
    "dropdelzpp": "070949992",
    "dropphyadd": "700 PLAZA DR STE A",
    "dropphycty": "SECAUCUS",
    "dropphyst": "NJ",
    "dropphyzpp": "070949992",
    "dropmaladd": "700 PLAZA DR STE A",
    "dropmalcty": "SECAUCUS",
    "dropmalst": "NJ",
    "dropmalzpp": "070949992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018666314,
    "dropsitcph": 2018666314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10878",
    "droptype": "D",
    "dropname": "MENLO PARK",
    "dropdeladd": "100 MENLO PARK STE 101",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088379998",
    "dropphyadd": "100 MENLO PARK STE 101",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088379998",
    "dropmaladd": "100 MENLO PARK STE 101",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088379998",
    "dropsitphn": 7328193630,
    "dropsitlph": 7325483638,
    "dropsitcph": 7325484603,
    "dropfax": 7322059613
  },
  {
    "dcode": "D",
    "dropkey": "SV10904",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "40 CLINTON ST STE L",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071029713",
    "dropphyadd": "40 CLINTON ST STE L",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071029713",
    "dropmaladd": "40 CLINTON ST STE L",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071029713",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736426381,
    "dropsitcph": 9736426381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10925",
    "droptype": "D",
    "dropname": "MONITOR",
    "dropdeladd": "6010 PARK AVE",
    "dropdelcty": "WEST NEW YORK",
    "dropdelst": "NJ",
    "dropdelzpp": "070939992",
    "dropphyadd": "6010 PARK AVE",
    "dropphycty": "WEST NEW YORK",
    "dropphyst": "NJ",
    "dropphyzpp": "070939992",
    "dropmaladd": "6010 PARK AVE",
    "dropmalcty": "WEST NEW YORK",
    "dropmalst": "NJ",
    "dropmalzpp": "070939992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018698375,
    "dropsitcph": 2018698375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10955",
    "droptype": "D",
    "dropname": "MORRIS ST",
    "dropdeladd": "1 MORRIS ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "NJ",
    "dropdelzpp": "079609997",
    "dropphyadd": "1 MORRIS ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "NJ",
    "dropphyzpp": "079609997",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "NJ",
    "dropmalzpp": "079639998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9735395617,
    "dropsitcph": 9735395617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV10981",
    "droptype": "D",
    "dropname": "MUHLENBERG",
    "dropdeladd": "1080 ARLINGTON AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070609991",
    "dropphyadd": "1080 ARLINGTON AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070609991",
    "dropmaladd": "1080 ARLINGTON AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070609991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087531480,
    "dropsitcph": 9087531480,
    "dropfax": 6505774413
  },
  {
    "dcode": "D",
    "dropkey": "SV11014",
    "droptype": "D",
    "dropname": "NETHERWOOD",
    "dropdeladd": "1120 NORTH AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070629998",
    "dropphyadd": "1120 NORTH AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070629998",
    "dropmaladd": "1120 NORTH AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070629998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087530445,
    "dropsitcph": 9087530445,
    "dropfax": 6505774426
  },
  {
    "dcode": "D",
    "dropkey": "SV11024",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "44 STELTON RD STE 100",
    "dropdelcty": "PISCATAWAY",
    "dropdelst": "NJ",
    "dropdelzpp": "088549997",
    "dropphyadd": "44 STELTON RD STE 100",
    "dropphycty": "PISCATAWAY",
    "dropphyst": "NJ",
    "dropphyzpp": "088549997",
    "dropmaladd": "44 STELTON RD STE 100",
    "dropmalcty": "PISCATAWAY",
    "dropmalst": "NJ",
    "dropmalzpp": "088549997",
    "dropsitphn": 9088193630,
    "dropsitlph": 9088193630,
    "dropsitcph": 7327525861,
    "dropfax": 6505774151
  },
  {
    "dcode": "D",
    "dropkey": "SV11038",
    "droptype": "D",
    "dropname": "NIXON",
    "dropdeladd": "2079 WOODBRIDGE AVE",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088179997",
    "dropphyadd": "2079 WOODBRIDGE AVE",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088179997",
    "dropmaladd": "2079 WOODBRIDGE AVE",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088179997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193638,
    "dropsitcph": 7329853442,
    "dropfax": 7329855468
  },
  {
    "dcode": "D",
    "dropkey": "SV11064",
    "droptype": "D",
    "dropname": "NORTH CENTER",
    "dropdeladd": "415 BROAD ST",
    "dropdelcty": "BLOOMFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070039993",
    "dropphyadd": "415 BROAD ST",
    "dropphycty": "BLOOMFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070039993",
    "dropmaladd": "415 BROAD ST",
    "dropmalcty": "BLOOMFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070039993",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737488646,
    "dropsitcph": 9737488646,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11068",
    "droptype": "D",
    "dropname": "NORTH ELIZABETH",
    "dropdeladd": "772 NEWARK AVE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "072089991",
    "dropphyadd": "772 NEWARK AVE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "072089991",
    "dropmaladd": "772 NEWARK AVE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "072089991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9083550176,
    "dropsitcph": 9083550176,
    "dropfax": 9083525485
  },
  {
    "dcode": "D",
    "dropkey": "SV11070",
    "droptype": "D",
    "dropname": "NEW BRIDGE LANDING",
    "dropdeladd": "121 KINDERKAMACK RD",
    "dropdelcty": "RIVER EDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "076619991",
    "dropphyadd": "121 KINDERKAMACK RD",
    "dropphycty": "RIVER EDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "076619991",
    "dropmaladd": "121 KINDERKAMACK RD",
    "dropmalcty": "RIVER EDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "076619991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2013420926,
    "dropsitcph": 2013420926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11127",
    "droptype": "D",
    "dropname": "OUTWATER",
    "dropdeladd": "85 OUTWATER LN STE 4B",
    "dropdelcty": "GARFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070269991",
    "dropphyadd": "85 OUTWATER LN STE 4B",
    "dropphycty": "GARFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070269991",
    "dropmaladd": "85 OUTWATER LN STE 4B",
    "dropmalcty": "GARFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070269991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737725019,
    "dropsitcph": 9737725019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11133",
    "droptype": "D",
    "dropname": "PACKANACK LAKE",
    "dropdeladd": "40 LAKE DR W",
    "dropdelcty": "WAYNE",
    "dropdelst": "NJ",
    "dropdelzpp": "074709991",
    "dropphyadd": "40 LAKE DR W",
    "dropphycty": "WAYNE",
    "dropphyst": "NJ",
    "dropphyzpp": "074709991",
    "dropmaladd": "40 LAKE DR W",
    "dropmalcty": "WAYNE",
    "dropmalst": "NJ",
    "dropmalzpp": "074709991",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736942632,
    "dropsitcph": 9736942632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11137",
    "droptype": "D",
    "dropname": "PALISADE",
    "dropdeladd": "1213 ANDERSON AVE",
    "dropdelcty": "FORT LEE",
    "dropdelst": "NJ",
    "dropdelzpp": "070249991",
    "dropphyadd": "1213 ANDERSON AVE",
    "dropphycty": "FORT LEE",
    "dropphyst": "NJ",
    "dropphyzpp": "070249991",
    "dropmaladd": "1213 ANDERSON AVE",
    "dropmalcty": "FORT LEE",
    "dropmalst": "NJ",
    "dropmalzpp": "070249991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2012248787,
    "dropsitcph": 2012248787,
    "dropfax": 2015411496
  },
  {
    "dcode": "D",
    "dropkey": "SV11145",
    "droptype": "D",
    "dropname": "PAMRAPO",
    "dropdeladd": "893 BROADWAY STE 1",
    "dropdelcty": "BAYONNE",
    "dropdelst": "NJ",
    "dropdelzpp": "070029991",
    "dropphyadd": "893 BROADWAY STE 1",
    "dropphycty": "BAYONNE",
    "dropphyst": "NJ",
    "dropphyzpp": "070029991",
    "dropmaladd": "893 BROADWAY STE 1",
    "dropmalcty": "BAYONNE",
    "dropmalst": "NJ",
    "dropmalzpp": "070029991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013326519,
    "dropsitcph": 2013326519,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11148",
    "droptype": "D",
    "dropname": "PARK",
    "dropdeladd": "497 21ST AVE",
    "dropdelcty": "PATERSON",
    "dropdelst": "NJ",
    "dropdelzpp": "075139998",
    "dropphyadd": "497 21ST AVE",
    "dropphycty": "PATERSON",
    "dropphyst": "NJ",
    "dropphyzpp": "075139998",
    "dropmaladd": "497 21ST AVE",
    "dropmalcty": "PATERSON",
    "dropmalst": "NJ",
    "dropmalzpp": "075139998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9737422460,
    "dropsitcph": 9737422460,
    "dropfax": 6505774342
  },
  {
    "dcode": "D",
    "dropkey": "SV11159",
    "droptype": "D",
    "dropname": "PASSAIC PARK",
    "dropdeladd": "158 MAIN AVE",
    "dropdelcty": "PASSAIC",
    "dropdelst": "NJ",
    "dropdelzpp": "070559992",
    "dropphyadd": "158 MAIN AVE",
    "dropphycty": "PASSAIC",
    "dropphyst": "NJ",
    "dropphyzpp": "070559992",
    "dropmaladd": "158 MAIN AVE",
    "dropmalcty": "PASSAIC",
    "dropmalst": "NJ",
    "dropmalzpp": "070559992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737776917,
    "dropsitcph": 9737776917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11211",
    "droptype": "D",
    "dropname": "PLAZA",
    "dropdeladd": "1257 PATERSON PLANK RD STE C",
    "dropdelcty": "SECAUCUS",
    "dropdelst": "NJ",
    "dropdelzpp": "070949991",
    "dropphyadd": "1257 PATERSON PLANK RD STE C",
    "dropphycty": "SECAUCUS",
    "dropphyst": "NJ",
    "dropphyzpp": "070949991",
    "dropmaladd": "1257 PATERSON PLANK RD STE C",
    "dropmalcty": "SECAUCUS",
    "dropmalst": "NJ",
    "dropmalzpp": "070949991",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018670239,
    "dropsitcph": 2018671278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11244",
    "droptype": "D",
    "dropname": "PREAKNESS",
    "dropdeladd": "42 PREAKNESS SHOPPING CTR",
    "dropdelcty": "WAYNE",
    "dropdelst": "NJ",
    "dropdelzpp": "074709992",
    "dropphyadd": "42 PREAKNESS SHOPPING CTR",
    "dropphycty": "WAYNE",
    "dropphyst": "NJ",
    "dropphyzpp": "074709992",
    "dropmaladd": "42 PREAKNESS SHOPPING CTR",
    "dropmalcty": "WAYNE",
    "dropmalst": "NJ",
    "dropmalzpp": "074709992",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736943569,
    "dropsitcph": 9736943569,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11301",
    "droptype": "D",
    "dropname": "RIVER ROAD",
    "dropdeladd": "12-44 RIVER RD",
    "dropdelcty": "FAIR LAWN",
    "dropdelst": "NJ",
    "dropdelzpp": "074109991",
    "dropphyadd": "12-44 RIVER RD",
    "dropphycty": "FAIR LAWN",
    "dropphyst": "NJ",
    "dropphyzpp": "074109991",
    "dropmaladd": "12-44 RIVER RD",
    "dropmalcty": "FAIR LAWN",
    "dropmalst": "NJ",
    "dropmalzpp": "074109991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017974267,
    "dropsitcph": 2017974267,
    "dropfax": 6505774192
  },
  {
    "dcode": "D",
    "dropkey": "SV11325",
    "droptype": "D",
    "dropname": "ROSEVILLE",
    "dropdeladd": "374 7TH AVE W",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071079998",
    "dropphyadd": "374 7TH AVE W",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071079998",
    "dropmaladd": "374 7TH AVE W",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071079998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734854545,
    "dropsitcph": 9734854545,
    "dropfax": 6505774373
  },
  {
    "dcode": "D",
    "dropkey": "SV11429",
    "droptype": "D",
    "dropname": "SOUTH",
    "dropdeladd": "514 FRELINGHUYSEN AVE",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071149998",
    "dropphyadd": "514 FRELINGHUYSEN AVE",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071149998",
    "dropmaladd": "514 FRELINGHUYSEN AVE",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071149998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9735961791,
    "dropsitcph": 9735961791,
    "dropfax": 6505774133
  },
  {
    "dcode": "D",
    "dropkey": "SV11444",
    "droptype": "D",
    "dropname": "SOUTH LIVINGSTON",
    "dropdeladd": "25 W NORTHFIELD RD STE C",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "NJ",
    "dropdelzpp": "070399991",
    "dropphyadd": "25 W NORTHFIELD RD STE C",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "NJ",
    "dropphyzpp": "070399991",
    "dropmaladd": "25 W NORTHFIELD RD STE C",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "NJ",
    "dropmalzpp": "070399991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9739920440,
    "dropsitcph": 9739920440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11447",
    "droptype": "D",
    "dropname": "SOUTH PATERSON",
    "dropdeladd": "958 MAIN ST STE 1",
    "dropdelcty": "PATERSON",
    "dropdelst": "NJ",
    "dropdelzpp": "075039998",
    "dropphyadd": "958 MAIN ST STE 1",
    "dropphycty": "PATERSON",
    "dropphyst": "NJ",
    "dropphyzpp": "075039998",
    "dropmaladd": "958 MAIN ST STE 1",
    "dropmalcty": "PATERSON",
    "dropmalst": "NJ",
    "dropmalzpp": "075039998",
    "dropsitphn": 2019559706,
    "dropsitlph": 9733571394,
    "dropsitcph": 9733571958,
    "dropfax": 6505774346
  },
  {
    "dcode": "D",
    "dropkey": "SV11454",
    "droptype": "D",
    "dropname": "SOUTH VINELAND",
    "dropdeladd": "2809 S EAST BLVD",
    "dropdelcty": "VINELAND",
    "dropdelst": "NJ",
    "dropdelzpp": "083609995",
    "dropphyadd": "2809 S EAST BLVD",
    "dropphycty": "VINELAND",
    "dropphyst": "NJ",
    "dropphyzpp": "083609995",
    "dropmaladd": "2809 S EAST BLVD",
    "dropmalcty": "VINELAND",
    "dropmalst": "NJ",
    "dropmalzpp": "083609995",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566923731,
    "dropsitcph": 8566923731,
    "dropfax": 8562050308
  },
  {
    "dcode": "D",
    "dropkey": "SV11495",
    "droptype": "D",
    "dropname": "STA A LINDEN",
    "dropdeladd": "340 W SAINT GEORGES AVE",
    "dropdelcty": "LINDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070369991",
    "dropphyadd": "340 W SAINT GEORGES AVE",
    "dropphycty": "LINDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070369991",
    "dropmaladd": "340 W SAINT GEORGES AVE",
    "dropmalcty": "LINDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070369991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9084861844,
    "dropsitcph": 9084861844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11497",
    "droptype": "D",
    "dropname": "STA A PLAINFIELD",
    "dropdeladd": "14 CLINTON AVE",
    "dropdelcty": "PLAINFIELD",
    "dropdelst": "NJ",
    "dropdelzpp": "070639998",
    "dropphyadd": "14 CLINTON AVE",
    "dropphycty": "PLAINFIELD",
    "dropphyst": "NJ",
    "dropphyzpp": "070639998",
    "dropmaladd": "14 CLINTON AVE",
    "dropmalcty": "PLAINFIELD",
    "dropmalst": "NJ",
    "dropmalzpp": "070639998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9087536618,
    "dropsitcph": 9087536618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11528",
    "droptype": "D",
    "dropname": "SUMMIT AVENUE",
    "dropdeladd": "720 8TH ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "070879994",
    "dropphyadd": "720 8TH ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "070879994",
    "dropmaladd": "720 8TH ST",
    "dropmalcty": "UNION CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "070879994",
    "dropsitphn": 2019559705,
    "dropsitlph": 2016179752,
    "dropsitcph": 2018672576,
    "dropfax": 2018650723
  },
  {
    "dcode": "D",
    "dropkey": "SV11543",
    "droptype": "D",
    "dropname": "TAURUS",
    "dropdeladd": "6406 BERGENLINE AVE STE A",
    "dropdelcty": "WEST NEW YORK",
    "dropdelst": "NJ",
    "dropdelzpp": "070939993",
    "dropphyadd": "6406 BERGENLINE AVE STE A",
    "dropphycty": "WEST NEW YORK",
    "dropphyst": "NJ",
    "dropphyzpp": "070939993",
    "dropmaladd": "6406 BERGENLINE AVE STE A",
    "dropmalcty": "WEST NEW YORK",
    "dropmalst": "NJ",
    "dropmalzpp": "070939993",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018698463,
    "dropsitcph": 2018698463,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11566",
    "droptype": "D",
    "dropname": "TOWN CENTER",
    "dropdeladd": "16 MAIN ST",
    "dropdelcty": "WEST ORANGE",
    "dropdelst": "NJ",
    "dropdelzpp": "070529994",
    "dropphyadd": "16 MAIN ST",
    "dropphycty": "WEST ORANGE",
    "dropphyst": "NJ",
    "dropphyzpp": "070529994",
    "dropmaladd": "16 MAIN ST",
    "dropmalcty": "WEST ORANGE",
    "dropmalst": "NJ",
    "dropmalzpp": "070529994",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737313581,
    "dropsitcph": 9737313581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11584",
    "droptype": "D",
    "dropname": "TYLER PARK",
    "dropdeladd": "609 KENNEDY BLVD",
    "dropdelcty": "NORTH BERGEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070479994",
    "dropphyadd": "609 KENNEDY BLVD",
    "dropphycty": "NORTH BERGEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070479994",
    "dropmaladd": "609 KENNEDY BLVD",
    "dropmalcty": "NORTH BERGEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070479994",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018635240,
    "dropsitcph": 2018635240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11591",
    "droptype": "D",
    "dropname": "UNION CENTER",
    "dropdeladd": "1965A MORRIS AVE",
    "dropdelcty": "UNION",
    "dropdelst": "NJ",
    "dropdelzpp": "070839993",
    "dropphyadd": "1965A MORRIS AVE",
    "dropphycty": "UNION",
    "dropphyst": "NJ",
    "dropphyzpp": "070839993",
    "dropmaladd": "1965A MORRIS AVE",
    "dropmalcty": "UNION",
    "dropmalst": "NJ",
    "dropmalzpp": "070839993",
    "dropsitphn": 2019559705,
    "dropsitlph": 8099648558,
    "dropsitcph": 9089645706,
    "dropfax": 9086866038
  },
  {
    "dcode": "D",
    "dropkey": "SV11594",
    "droptype": "D",
    "dropname": "UNION SQUARE",
    "dropdeladd": "946 ELIZABETH AVE",
    "dropdelcty": "ELIZABETH",
    "dropdelst": "NJ",
    "dropdelzpp": "072019992",
    "dropphyadd": "946 ELIZABETH AVE",
    "dropphycty": "ELIZABETH",
    "dropphyst": "NJ",
    "dropphyzpp": "072019992",
    "dropmaladd": "946 ELIZABETH AVE",
    "dropmalcty": "ELIZABETH",
    "dropmalst": "NJ",
    "dropmalzpp": "072019992",
    "dropsitphn": 2019559705,
    "dropsitlph": 9083522077,
    "dropsitcph": 9083522338,
    "dropfax": 9083825485
  },
  {
    "dcode": "D",
    "dropkey": "SV11603",
    "droptype": "D",
    "dropname": "UPPER MONTCLAIR",
    "dropdeladd": "572 VALLEY RD STE 2",
    "dropdelcty": "MONTCLAIR",
    "dropdelst": "NJ",
    "dropdelzpp": "070439998",
    "dropphyadd": "572 VALLEY RD STE 2",
    "dropphycty": "MONTCLAIR",
    "dropphyst": "NJ",
    "dropphyzpp": "070439998",
    "dropmaladd": "572 VALLEY RD STE 2",
    "dropmalcty": "MONTCLAIR",
    "dropmalst": "NJ",
    "dropmalzpp": "070439998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9735095059,
    "dropsitcph": 9735097865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11615",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "57 14TH ST",
    "dropdelcty": "HOBOKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070309992",
    "dropphyadd": "57 14TH ST",
    "dropphycty": "HOBOKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070309992",
    "dropmaladd": "57 14TH ST",
    "dropmalcty": "HOBOKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070309992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2014599262,
    "dropsitcph": 2014590405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11620",
    "droptype": "D",
    "dropname": "VAILSBURG",
    "dropdeladd": "210 STUYVESANT AVE",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071069998",
    "dropphyadd": "210 STUYVESANT AVE",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071069998",
    "dropmaladd": "210 STUYVESANT AVE",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071069998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734160859,
    "dropsitcph": 9734160859,
    "dropfax": 6505774119
  },
  {
    "dcode": "D",
    "dropkey": "SV11621",
    "droptype": "D",
    "dropname": "VALLEY",
    "dropdeladd": "586 VALLEY RD",
    "dropdelcty": "WAYNE",
    "dropdelst": "NJ",
    "dropdelzpp": "074709993",
    "dropphyadd": "586 VALLEY RD",
    "dropphycty": "WAYNE",
    "dropphyst": "NJ",
    "dropphyzpp": "074709993",
    "dropmaladd": "586 VALLEY RD",
    "dropmalcty": "WAYNE",
    "dropmalst": "NJ",
    "dropmalzpp": "074709993",
    "dropsitphn": 2019559706,
    "dropsitlph": 9736941032,
    "dropsitcph": 9736941032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11673",
    "droptype": "D",
    "dropname": "WARREN POINT",
    "dropdeladd": "30-10 BROADWAY",
    "dropdelcty": "FAIR LAWN",
    "dropdelst": "NJ",
    "dropdelzpp": "074109993",
    "dropphyadd": "30-10 BROADWAY",
    "dropphycty": "FAIR LAWN",
    "dropphyst": "NJ",
    "dropphyzpp": "074109993",
    "dropmaladd": "30-10 BROADWAY",
    "dropmalcty": "FAIR LAWN",
    "dropmalst": "NJ",
    "dropmalzpp": "074109993",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017965378,
    "dropsitcph": 2017965378,
    "dropfax": 6505774192
  },
  {
    "dcode": "D",
    "dropkey": "SV11679",
    "droptype": "D",
    "dropname": "WASHINGTON STREET",
    "dropdeladd": "734 WASHINGTON ST STE A",
    "dropdelcty": "HOBOKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070309993",
    "dropphyadd": "734 WASHINGTON ST STE A",
    "dropphycty": "HOBOKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070309993",
    "dropmaladd": "734 WASHINGTON ST STE A",
    "dropmalcty": "HOBOKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070309993",
    "dropsitphn": 2019559705,
    "dropsitlph": 2014590117,
    "dropsitcph": 2014590117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11697",
    "droptype": "D",
    "dropname": "WEST",
    "dropdeladd": "290 SPRINGFIELD AVE",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071039995",
    "dropphyadd": "290 SPRINGFIELD AVE",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071039995",
    "dropmaladd": "290 SPRINGFIELD AVE",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071039995",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736450120,
    "dropsitcph": 9736450120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11715",
    "droptype": "D",
    "dropname": "WEST ENGLEWOOD",
    "dropdeladd": "1393 PALISADE AVE",
    "dropdelcty": "TEANECK",
    "dropdelst": "NJ",
    "dropdelzpp": "076669991",
    "dropphyadd": "1393 PALISADE AVE",
    "dropphycty": "TEANECK",
    "dropphyst": "NJ",
    "dropphyzpp": "076669991",
    "dropmaladd": "1393 PALISADE AVE",
    "dropmalcty": "TEANECK",
    "dropmalst": "NJ",
    "dropmalzpp": "076669991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2018377020,
    "dropsitcph": 2018377020,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11737",
    "droptype": "D",
    "dropname": "WEST SIDE HOBOKEN",
    "dropdeladd": "502 GRAND ST STE A",
    "dropdelcty": "HOBOKEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070309994",
    "dropphyadd": "502 GRAND ST STE A",
    "dropphycty": "HOBOKEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070309994",
    "dropmaladd": "502 GRAND ST STE A",
    "dropmalcty": "HOBOKEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070309994",
    "dropsitphn": 2019559705,
    "dropsitlph": 2014599261,
    "dropsitcph": 2014590561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11739",
    "droptype": "D",
    "dropname": "WEST SIDE JERSEY CITY",
    "dropdeladd": "504 W SIDE AVE",
    "dropdelcty": "JERSEY CITY",
    "dropdelst": "NJ",
    "dropdelzpp": "073049992",
    "dropphyadd": "504 W SIDE AVE",
    "dropphycty": "JERSEY CITY",
    "dropphyst": "NJ",
    "dropphyzpp": "073049992",
    "dropmaladd": "504 W SIDE AVE",
    "dropmalcty": "JERSEY CITY",
    "dropmalst": "NJ",
    "dropmalzpp": "073049992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013320537,
    "dropsitcph": 2013320537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11752",
    "droptype": "D",
    "dropname": "WESTBORO",
    "dropdeladd": "104 SHREWSBURY AVE",
    "dropdelcty": "RED BANK",
    "dropdelst": "NJ",
    "dropdelzpp": "077019997",
    "dropphyadd": "104 SHREWSBURY AVE",
    "dropphycty": "RED BANK",
    "dropphyst": "NJ",
    "dropphyzpp": "077019997",
    "dropmaladd": "104 SHREWSBURY AVE",
    "dropmalcty": "RED BANK",
    "dropmalst": "NJ",
    "dropmalzpp": "077019997",
    "dropsitphn": 8569334046,
    "dropsitlph": 7327419342,
    "dropsitcph": 7327419342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11801",
    "droptype": "D",
    "dropname": "WOODCLIFF",
    "dropdeladd": "7915 BERGENLINE AVE",
    "dropdelcty": "NORTH BERGEN",
    "dropdelst": "NJ",
    "dropdelzpp": "070479996",
    "dropphyadd": "7915 BERGENLINE AVE",
    "dropphycty": "NORTH BERGEN",
    "dropphyst": "NJ",
    "dropphyzpp": "070479996",
    "dropmaladd": "7915 BERGENLINE AVE",
    "dropmalcty": "NORTH BERGEN",
    "dropmalst": "NJ",
    "dropmalzpp": "070479996",
    "dropsitphn": 2019559705,
    "dropsitlph": 2018692631,
    "dropsitcph": 2018692631,
    "dropfax": 6516751634
  },
  {
    "dcode": "D",
    "dropkey": "SV11805",
    "droptype": "D",
    "dropname": "WOODCREST",
    "dropdeladd": "1400 BERLIN RD STE 126",
    "dropdelcty": "CHERRY HILL",
    "dropdelst": "NJ",
    "dropdelzpp": "080039998",
    "dropphyadd": "1400 BERLIN RD STE 126",
    "dropphycty": "CHERRY HILL",
    "dropphyst": "NJ",
    "dropphyzpp": "080039998",
    "dropmaladd": "1400 BERLIN RD STE 126",
    "dropmalcty": "CHERRY HILL",
    "dropmalst": "NJ",
    "dropmalzpp": "080039998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564244533,
    "dropsitcph": 8564240093,
    "dropfax": 8562984952
  },
  {
    "dcode": "D",
    "dropkey": "SV11816",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "4003 164TH ST",
    "dropdelcty": "FLUSHING",
    "dropdelst": "NY",
    "dropdelzpp": 113589997,
    "dropphyadd": "4003 164TH ST",
    "dropphycty": "FLUSHING",
    "dropphyst": "NY",
    "dropphyzpp": 113589997,
    "dropmaladd": "4003 164TH ST",
    "dropmalcty": "FLUSHING",
    "dropmalst": "NY",
    "dropmalzpp": 113589997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183218078,
    "dropfax": 7185394205
  },
  {
    "dcode": "D",
    "dropkey": "SV11817",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "752 FOOTE AVE",
    "dropdelcty": "JAMESTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 147019993,
    "dropphyadd": "752 FOOTE AVE",
    "dropphycty": "JAMESTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 147019993,
    "dropmaladd": "752 FOOTE AVE",
    "dropmalcty": "JAMESTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 147019993,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7164841562,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11831",
    "droptype": "D",
    "dropname": "ADELPHI",
    "dropdeladd": "950 FULTON ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112389997,
    "dropphyadd": "950 FULTON ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112389997,
    "dropmaladd": "950 FULTON ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112389997,
    "dropsitphn": 7183215071,
    "dropsitlph": 7183215070,
    "dropsitcph": 3472721938,
    "dropfax": 7187890674
  },
  {
    "dcode": "D",
    "dropkey": "SV11871",
    "droptype": "D",
    "dropname": "ALLERTON",
    "dropdeladd": "2815 WHITE PLAINS RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104679991,
    "dropphyadd": "2815 WHITE PLAINS RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104679991,
    "dropmaladd": "711 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104679998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186550296,
    "dropsitcph": 7186550296,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV11923",
    "droptype": "D",
    "dropname": "ANSONIA",
    "dropdeladd": "178 COLUMBUS AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100239998,
    "dropphyadd": "178 COLUMBUS AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100239998,
    "dropmaladd": "178 COLUMBUS AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100239998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123621697,
    "dropsitcph": 2123621697,
    "dropfax": 2127120791
  },
  {
    "dcode": "D",
    "dropkey": "SV11959",
    "droptype": "D",
    "dropname": "ARVERNE",
    "dropdeladd": "329 BEACH 59TH ST",
    "dropdelcty": "ARVERNE",
    "dropdelst": "NY",
    "dropdelzpp": 116929997,
    "dropphyadd": "329 BEACH 59TH ST",
    "dropphycty": "ARVERNE",
    "dropphyst": "NY",
    "dropphyzpp": 116929997,
    "dropmaladd": "329 BEACH 59TH ST",
    "dropmalcty": "ARVERNE",
    "dropmalst": "NY",
    "dropmalzpp": 116929997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472305060,
    "dropfax": 7186345819
  },
  {
    "dcode": "D",
    "dropkey": "SV11990",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "511 W 165TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100329998,
    "dropphyadd": "511 W 165TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100329998,
    "dropmaladd": "511 W 165TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100329998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125682387,
    "dropsitcph": 2125682387,
    "dropfax": 2129275728
  },
  {
    "dcode": "D",
    "dropkey": "SV12002",
    "droptype": "D",
    "dropname": "STATION B",
    "dropdeladd": "10212 159TH AVE",
    "dropdelcty": "HOWARD BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 114149993,
    "dropphyadd": "10212 159TH AVE",
    "dropphycty": "HOWARD BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 114149993,
    "dropmaladd": "10212 159TH AVE",
    "dropmalcty": "HOWARD BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 114149993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183230331,
    "dropfax": 7184605537
  },
  {
    "dcode": "D",
    "dropkey": "SV12034",
    "droptype": "D",
    "dropname": "BANK PLAZA",
    "dropdeladd": "2000 FISHER AVE",
    "dropdelcty": "MERRICK",
    "dropdelst": "NY",
    "dropdelzpp": 115669991,
    "dropphyadd": "2000 FISHER AVE",
    "dropphycty": "MERRICK",
    "dropphyst": "NY",
    "dropphyzpp": 115669991,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MERRICK",
    "dropmalst": "NY",
    "dropmalzpp": 115669998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5163783295,
    "dropfax": 5163773597
  },
  {
    "dcode": "D",
    "dropkey": "SV12064",
    "droptype": "D",
    "dropname": "BATH BEACH",
    "dropdeladd": "1865 BENSON AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112149997,
    "dropphyadd": "1865 BENSON AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112149997,
    "dropmaladd": "1865 BENSON AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112149997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182367197,
    "dropfax": 7182342644
  },
  {
    "dcode": "D",
    "dropkey": "SV12072",
    "droptype": "D",
    "dropname": "BAY",
    "dropdeladd": "2628 E 18TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112359997,
    "dropphyadd": "2628 E 18TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112359997,
    "dropmaladd": "2628 E 18TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112359997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186482057,
    "dropfax": 7186486388
  },
  {
    "dcode": "D",
    "dropkey": "SV12077",
    "droptype": "D",
    "dropname": "BAY RIDGE",
    "dropdeladd": "5501 7TH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112209997,
    "dropphyadd": "5501 7TH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112209997,
    "dropmaladd": "5501 7TH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112209997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184350642,
    "dropfax": 7184365862
  },
  {
    "dcode": "D",
    "dropkey": "SV12080",
    "droptype": "D",
    "dropname": "BAY TERRACE",
    "dropdeladd": "21271 26TH AVE",
    "dropdelcty": "BAYSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 113609993,
    "dropphyadd": "21271 26TH AVE",
    "dropphycty": "BAYSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 113609993,
    "dropmaladd": "21271 26TH AVE",
    "dropmalcty": "BAYSIDE",
    "dropmalst": "NY",
    "dropmalzpp": 113609993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186313113,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "SV12085",
    "droptype": "D",
    "dropname": "BAYCHESTER",
    "dropdeladd": "1525 E GUN HILL RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104699998,
    "dropphyadd": "1525 E GUN HILL RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104699998,
    "dropmaladd": "1525 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104699998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183793016,
    "dropsitcph": 7183798518,
    "dropfax": 7186714654
  },
  {
    "dcode": "D",
    "dropkey": "SV12090",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "21235 42ND AVE STE 2",
    "dropdelcty": "BAYSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 113619997,
    "dropphyadd": "21235 42ND AVE STE 2",
    "dropphycty": "BAYSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 113619997,
    "dropmaladd": "21235 42ND AVE STE 2",
    "dropmalcty": "BAYSIDE",
    "dropmalst": "NY",
    "dropmalzpp": 113619997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182298571,
    "dropfax": 7182811669
  },
  {
    "dcode": "D",
    "dropkey": "SV12112",
    "droptype": "D",
    "dropname": "BEECHWOOD",
    "dropdeladd": "300 WARING RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146099998,
    "dropphyadd": "300 WARING RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146099998,
    "dropmaladd": "300 WARING RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146099998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133210,
    "dropsitcph": 5856133210,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12125",
    "droptype": "D",
    "dropname": "BELLEROSE",
    "dropdeladd": "23715 BRADDOCK AVE",
    "dropdelcty": "BELLEROSE",
    "dropdelst": "NY",
    "dropdelzpp": 114269997,
    "dropphyadd": "23715 BRADDOCK AVE",
    "dropphycty": "BELLEROSE",
    "dropphyst": "NY",
    "dropphyzpp": 114269997,
    "dropmaladd": "23715 BRADDOCK AVE",
    "dropmalcty": "BELLEROSE",
    "dropmalst": "NY",
    "dropmalzpp": 114269997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184605337,
    "dropfax": 7183472613
  },
  {
    "dcode": "D",
    "dropkey": "SV12201",
    "droptype": "D",
    "dropname": "BLYTHEBOURNE",
    "dropdeladd": "1200 51ST ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112199997,
    "dropphyadd": "1200 51ST ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112199997,
    "dropmaladd": "1200 51ST ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112199997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184361675,
    "dropfax": 7189726047
  },
  {
    "dcode": "D",
    "dropkey": "SV12215",
    "droptype": "D",
    "dropname": "BOROUGH HALL",
    "dropdeladd": "12055 QUEENS BLVD STE 8",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114249997,
    "dropphyadd": "12055 QUEENS BLVD STE 8",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114249997,
    "dropmaladd": "12055 QUEENS BLVD STE 8",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114249997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7182638518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12218",
    "droptype": "D",
    "dropname": "BOTANICAL",
    "dropdeladd": "2963 WEBSTER AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104589991,
    "dropphyadd": "2963 WEBSTER AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104589991,
    "dropmaladd": "2963 WEBSTER AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104589991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183652807,
    "dropsitcph": 7183652807,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12221",
    "droptype": "D",
    "dropname": "BOULEVARD",
    "dropdeladd": "1132 SOUTHERN BLVD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104599998,
    "dropphyadd": "1132 SOUTHERN BLVD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104599998,
    "dropmaladd": "1132 SOUTHERN BLVD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104599998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183287870,
    "dropsitcph": 7183287870,
    "dropfax": 7183280339
  },
  {
    "dcode": "D",
    "dropkey": "SV12262",
    "droptype": "D",
    "dropname": "BREVOORT",
    "dropdeladd": "1205 ATLANTIC AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112169997,
    "dropphyadd": "1205 ATLANTIC AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112169997,
    "dropmaladd": "1205 ATLANTIC AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112169997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186387099,
    "dropfax": 7183998578
  },
  {
    "dcode": "D",
    "dropkey": "SV12274",
    "droptype": "D",
    "dropname": "BRIDGE",
    "dropdeladd": "1001 SOUTH AVE LOWR",
    "dropdelcty": "NIAGARA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 143059998,
    "dropphyadd": "1001 SOUTH AVE LOWR",
    "dropphycty": "NIAGARA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 143059998,
    "dropmaladd": "1001 SOUTH AVE LOWR",
    "dropmalcty": "NIAGARA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 143059998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7162856094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12282",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "3157 CONEY ISLAND AVE STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112359993,
    "dropphyadd": "3157 CONEY ISLAND AVE STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112359993,
    "dropmaladd": "2628 E 18TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112359997,
    "dropsitphn": 7186480323,
    "dropsitlph": 7183483310,
    "dropsitcph": 7187438210,
    "dropfax": 7186486388
  },
  {
    "dcode": "D",
    "dropkey": "SV12285",
    "droptype": "D",
    "dropname": "BRIGHTON ROCHESTER",
    "dropdeladd": "130 N WINTON RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146109998,
    "dropphyadd": "130 N WINTON RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146109998,
    "dropmaladd": "130 N WINTON RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146109998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852882170,
    "dropsitcph": 5852882170,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12302",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "2117 BROADWAY",
    "dropdelcty": "ASTORIA",
    "dropdelst": "NY",
    "dropdelzpp": 111069997,
    "dropphyadd": "2117 BROADWAY",
    "dropphycty": "ASTORIA",
    "dropphyst": "NY",
    "dropphyzpp": 111069997,
    "dropmaladd": "2117 BROADWAY",
    "dropmalcty": "ASTORIA",
    "dropmalst": "NY",
    "dropmalzpp": 111069997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473963221,
    "dropfax": 7182042587
  },
  {
    "dcode": "D",
    "dropkey": "SV12326",
    "droptype": "D",
    "dropname": "BROWNSVILLE",
    "dropdeladd": "167 BRISTOL ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112129997,
    "dropphyadd": "167 BRISTOL ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112129997,
    "dropmaladd": "167 BRISTOL ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112129997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3477500645,
    "dropfax": 7184955108
  },
  {
    "dcode": "D",
    "dropkey": "SV12335",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "23 W 43RD ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100369991,
    "dropphyadd": "23 W 43RD ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100369991,
    "dropmaladd": "340 W 42ND ST FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100369998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122795960,
    "dropsitcph": 2122795960,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12365",
    "droptype": "D",
    "dropname": "BUSHWICK",
    "dropdeladd": "1369 BROADWAY",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112219997,
    "dropphyadd": "1369 BROADWAY",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112219997,
    "dropmaladd": "1369 BROADWAY",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112219997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186023111,
    "dropfax": 7186022401
  },
  {
    "dcode": "D",
    "dropkey": "SV12370",
    "droptype": "D",
    "dropname": "BUTTERFIELD",
    "dropdeladd": "500 SENECA ST",
    "dropdelcty": "UTICA",
    "dropdelst": "NY",
    "dropdelzpp": 135029998,
    "dropphyadd": "500 SENECA ST",
    "dropphycty": "UTICA",
    "dropphyst": "NY",
    "dropphyzpp": 135029998,
    "dropmaladd": "500 SENECA ST",
    "dropmalcty": "UTICA",
    "dropmalst": "NY",
    "dropmalzpp": 135029998,
    "dropsitphn": 3157340018,
    "dropsitlph": 3157385313,
    "dropsitcph": 3157340087,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12376",
    "droptype": "D",
    "dropname": "MID CITY",
    "dropdeladd": "1245 MAIN ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142092111,
    "dropphyadd": "1245 MAIN ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142092111,
    "dropmaladd": "1245 MAIN ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142092111,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168838708,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12377",
    "droptype": "D",
    "dropname": "KEW GARDENS HILLS",
    "dropdeladd": "7523 MAIN ST",
    "dropdelcty": "FLUSHING",
    "dropdelst": "NY",
    "dropdelzpp": 113679997,
    "dropphyadd": "7523 MAIN ST",
    "dropphycty": "FLUSHING",
    "dropphyst": "NY",
    "dropphyzpp": 113679997,
    "dropmaladd": "7523 MAIN ST",
    "dropmalcty": "FLUSHING",
    "dropmalst": "NY",
    "dropmalzpp": 113679997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185449785,
    "dropfax": 7185447691
  },
  {
    "dcode": "D",
    "dropkey": "SV12392",
    "droptype": "D",
    "dropname": "CAMBRIA HEIGHTS",
    "dropdeladd": "22901 LINDEN BLVD",
    "dropdelcty": "CAMBRIA HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 114119997,
    "dropphyadd": "22901 LINDEN BLVD",
    "dropphycty": "CAMBRIA HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 114119997,
    "dropmaladd": "22901 LINDEN BLVD",
    "dropmalcty": "CAMBRIA HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 114119997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185281484,
    "dropfax": 7189782657
  },
  {
    "dcode": "D",
    "dropkey": "SV12411",
    "droptype": "D",
    "dropname": "CANAL STREET",
    "dropdeladd": "350 CANAL ST STE 2A",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100139998,
    "dropphyadd": "350 CANAL ST STE 2A",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100139998,
    "dropmaladd": "350 CANAL ST STE 2A",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100139998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129669573,
    "dropsitcph": 2129669573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12413",
    "droptype": "D",
    "dropname": "CANARSIE",
    "dropdeladd": "10201 FLATLANDS AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112369997,
    "dropphyadd": "10201 FLATLANDS AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112369997,
    "dropmaladd": "10201 FLATLANDS AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112369997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186492073,
    "dropfax": 7182572795
  },
  {
    "dcode": "D",
    "dropkey": "SV12423",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "25 EAGLE ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122249997,
    "dropphyadd": "25 EAGLE ST",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122249997,
    "dropmaladd": "PO BOX 249998",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122249998,
    "dropsitphn": 5184624635,
    "dropsitlph": 5184624635,
    "dropsitcph": 5184624635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12450",
    "droptype": "D",
    "dropname": "CASTLE HILL",
    "dropdeladd": "1163 CASTLE HILL AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104629991,
    "dropphyadd": "1163 CASTLE HILL AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104629991,
    "dropmaladd": "1163 CASTLE HILL AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104629991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188235740,
    "dropsitcph": 7188235740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12460",
    "droptype": "D",
    "dropname": "CATHEDRAL",
    "dropdeladd": "215 W 104TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100259998,
    "dropphyadd": "215 W 104TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100259998,
    "dropmaladd": "215 W 104TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100259998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126620355,
    "dropsitcph": 2126620355,
    "dropfax": 2129323276
  },
  {
    "dcode": "D",
    "dropkey": "SV12497",
    "droptype": "D",
    "dropname": "CENTRAL PARK",
    "dropdeladd": "170 MANHATTAN AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142159998,
    "dropphyadd": "170 MANHATTAN AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142159998,
    "dropmaladd": "170 MANHATTAN AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142159998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168343215,
    "dropfax": 7168375072
  },
  {
    "dcode": "D",
    "dropkey": "SV12504",
    "droptype": "D",
    "dropname": "CENTUCK",
    "dropdeladd": "1585 CENTRAL PARK AVE",
    "dropdelcty": "YONKERS",
    "dropdelst": "NY",
    "dropdelzpp": 107106027,
    "dropphyadd": "1585 CENTRAL PARK AVE",
    "dropphycty": "YONKERS",
    "dropphyst": "NY",
    "dropphyzpp": 107106027,
    "dropmaladd": "1585 CENTRAL PARK AVE",
    "dropmalcty": "YONKERS",
    "dropmalst": "NY",
    "dropmalzpp": 107106027,
    "dropsitphn": 9146974123,
    "dropsitlph": 9147716927,
    "dropsitcph": 9147716927,
    "dropfax": 9143950445
  },
  {
    "dcode": "D",
    "dropkey": "SV12515",
    "droptype": "D",
    "dropname": "CHARLOTTE",
    "dropdeladd": "4455 LAKE AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146129997,
    "dropphyadd": "4455 LAKE AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146129997,
    "dropmaladd": "4455 LAKE AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146129997,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856631673,
    "dropsitcph": 5856631673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12558",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "1483 YORK AVE FRNT 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100759991,
    "dropphyadd": "1483 YORK AVE FRNT 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100759991,
    "dropmaladd": "217 E 70TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100219998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125178361,
    "dropsitcph": 2125178361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12578",
    "droptype": "D",
    "dropname": "CHINATOWN",
    "dropdeladd": "6 DOYERS ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100139991,
    "dropphyadd": "6 DOYERS ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100139991,
    "dropmaladd": "350 CANAL ST STE 2A",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100139998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123498264,
    "dropsitcph": 2123498264,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12586",
    "droptype": "D",
    "dropname": "CHURCH STREET",
    "dropdeladd": "90 CHURCH ST FL 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100079998,
    "dropphyadd": "90 CHURCH ST FL 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100079998,
    "dropmaladd": "90 CHURCH ST FL 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100079998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305001,
    "dropsitcph": 2123305001,
    "dropfax": 2123305034
  },
  {
    "dcode": "D",
    "dropkey": "SV12600",
    "droptype": "D",
    "dropname": "CITY ISLAND",
    "dropdeladd": "199 CITY ISLAND AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104649998,
    "dropphyadd": "199 CITY ISLAND AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104649998,
    "dropmaladd": "199 CITY ISLAND AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104649998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188853153,
    "dropsitcph": 7188853153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12617",
    "droptype": "D",
    "dropname": "CLASON POINT",
    "dropdeladd": "829 SOUNDVIEW AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104739991,
    "dropphyadd": "829 SOUNDVIEW AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104739991,
    "dropmaladd": "829 SOUNDVIEW AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104739991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185420383,
    "dropsitcph": 7185420383,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12654",
    "droptype": "D",
    "dropname": "CO OP CITY",
    "dropdeladd": "3300 CONNER ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104759998,
    "dropphyadd": "3300 CONNER ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104759998,
    "dropmaladd": "3300 CONNER ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104759998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185155698,
    "dropsitcph": 7185155698,
    "dropfax": 7189949549
  },
  {
    "dcode": "D",
    "dropkey": "SV12682",
    "droptype": "D",
    "dropname": "COLGATE",
    "dropdeladd": "13 OAK DR",
    "dropdelcty": "HAMILTON",
    "dropdelst": "NY",
    "dropdelzpp": 133461338,
    "dropphyadd": "13 OAK DR",
    "dropphycty": "HAMILTON",
    "dropphyst": "NY",
    "dropphyzpp": 133461338,
    "dropmaladd": "13 OAK DR",
    "dropmalcty": "HAMILTON",
    "dropmalst": "NY",
    "dropmalzpp": 133461338,
    "dropsitphn": 3158242350,
    "dropsitlph": 3158242350,
    "dropsitcph": 3158242350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12684",
    "droptype": "D",
    "dropname": "COLLEGE STATION",
    "dropdeladd": "217 W 140TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100309998,
    "dropphyadd": "217 W 140TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100309998,
    "dropmaladd": "217 W 140TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100309998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122837096,
    "dropsitcph": 2122837096,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12686",
    "droptype": "D",
    "dropname": "COLLEGE POINT",
    "dropdeladd": "12007 15TH AVE",
    "dropdelcty": "COLLEGE POINT",
    "dropdelst": "NY",
    "dropdelzpp": 113569997,
    "dropphyadd": "12007 15TH AVE",
    "dropphycty": "COLLEGE POINT",
    "dropphyst": "NY",
    "dropphyzpp": 113569997,
    "dropmaladd": "12007 15TH AVE",
    "dropmalcty": "COLLEGE POINT",
    "dropmalst": "NY",
    "dropmalzpp": 113569997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473794050,
    "dropfax": 7185394154
  },
  {
    "dcode": "D",
    "dropkey": "SV12698",
    "droptype": "D",
    "dropname": "COLONIAL PARK",
    "dropdeladd": "99 MACOMBS PL",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100399998,
    "dropphyadd": "99 MACOMBS PL",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100399998,
    "dropmaladd": "99 MACOMBS PL",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100399998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123689849,
    "dropsitcph": 2123689849,
    "dropfax": 2128622848
  },
  {
    "dcode": "D",
    "dropkey": "SV12707",
    "droptype": "D",
    "dropname": "COLUMBIA UNIVERSITY",
    "dropdeladd": "534 W 112TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100259991,
    "dropphyadd": "534 W 112TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100259991,
    "dropmaladd": "534 W 112TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100259991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128647813,
    "dropsitcph": 2128647813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12711",
    "droptype": "D",
    "dropname": "COLUMBUS CIRCLE",
    "dropdeladd": "27 W 60TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100239991,
    "dropphyadd": "27 W 60TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100239991,
    "dropmaladd": "178 COLUMBUS AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100239998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122657858,
    "dropsitcph": 2122657858,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12714",
    "droptype": "D",
    "dropname": "COLVIN ELMWOOD",
    "dropdeladd": "2200 S SALINA ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132059211,
    "dropphyadd": "2200 S SALINA ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132059211,
    "dropmaladd": "2200 S SALINA ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132059211,
    "dropsitphn": 3154780027,
    "dropsitlph": 3154780027,
    "dropsitcph": 3154780027,
    "dropfax": 3154780932
  },
  {
    "dcode": "D",
    "dropkey": "SV12723",
    "droptype": "D",
    "dropname": "CONEY ISLAND",
    "dropdeladd": "2727 MERMAID AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112249997,
    "dropphyadd": "2727 MERMAID AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112249997,
    "dropmaladd": "2727 MERMAID AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112249997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3477130202,
    "dropfax": 7182666905
  },
  {
    "dcode": "D",
    "dropkey": "SV12745",
    "droptype": "D",
    "dropname": "COOPER",
    "dropdeladd": "93 4TH AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100039998,
    "dropphyadd": "93 4TH AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100039998,
    "dropmaladd": "93 4TH AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100039998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122541390,
    "dropsitcph": 2122541390,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12766",
    "droptype": "D",
    "dropname": "CORNELL",
    "dropdeladd": "1950 LAFAYETTE AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104739998,
    "dropphyadd": "1950 LAFAYETTE AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104739998,
    "dropmaladd": "1950 LAFAYETTE AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104739998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188927054,
    "dropsitcph": 7188927054,
    "dropfax": 7182393373
  },
  {
    "dcode": "D",
    "dropkey": "SV12782",
    "droptype": "D",
    "dropname": "CORONA-A",
    "dropdeladd": "10328 ROOSEVELT AVE",
    "dropdelcty": "CORONA",
    "dropdelst": "NY",
    "dropdelzpp": 113689993,
    "dropphyadd": "10328 ROOSEVELT AVE",
    "dropphycty": "CORONA",
    "dropphyst": "NY",
    "dropphyzpp": 113689993,
    "dropmaladd": "10328 ROOSEVELT AVE",
    "dropmalcty": "CORONA",
    "dropmalst": "NY",
    "dropmalzpp": 113689993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473963610,
    "dropfax": 7184605537
  },
  {
    "dcode": "D",
    "dropkey": "SV12811",
    "droptype": "D",
    "dropname": "CRANFORD",
    "dropdeladd": "690 E 241ST ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104709991,
    "dropphyadd": "690 E 241ST ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104709991,
    "dropmaladd": "690 E 241ST ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104709991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183248862,
    "dropsitcph": 7183248862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12858",
    "droptype": "D",
    "dropname": "HOLLISWOOD",
    "dropdeladd": "19733 HILLSIDE AVE",
    "dropdelcty": "HOLLIS",
    "dropdelst": "NY",
    "dropdelzpp": 114239993,
    "dropphyadd": "19733 HILLSIDE AVE",
    "dropphycty": "HOLLIS",
    "dropphyst": "NY",
    "dropphyzpp": 114239993,
    "dropmaladd": "19733 HILLSIDE AVE",
    "dropmalcty": "HOLLIS",
    "dropmalst": "NY",
    "dropmalzpp": 114239993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7184654808,
    "dropfax": 7182170927
  },
  {
    "dcode": "D",
    "dropkey": "SV12927",
    "droptype": "D",
    "dropname": "DEWEY",
    "dropdeladd": "376 LEXINGTON AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146139998,
    "dropphyadd": "376 LEXINGTON AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146139998,
    "dropmaladd": "376 LEXINGTON AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854583140,
    "dropsitcph": 5854584500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12958",
    "droptype": "D",
    "dropname": "DOWNTOWN ELMIRA",
    "dropdeladd": "255 CLEMENS CENTER PKWY",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149013090,
    "dropphyadd": "255 CLEMENS CENTER PKWY",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149013090,
    "dropmaladd": "255 CLEMENS CENTER PKWY",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149013090,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077375101,
    "dropsitcph": 6077347251,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12959",
    "droptype": "D",
    "dropname": "DOWNTOWN ROCHESTER",
    "dropdeladd": "216 CUMBERLAND ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146039998,
    "dropphyadd": "216 CUMBERLAND ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146039998,
    "dropmaladd": "216 CUMBERLAND ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146039998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133027,
    "dropsitcph": 5856133027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12961",
    "droptype": "D",
    "dropname": "DOWNTOWN SYRACUSE",
    "dropdeladd": "444 S SALINA ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132019211,
    "dropphyadd": "444 S SALINA ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132019211,
    "dropmaladd": "444 S SALINA ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132019211,
    "dropsitphn": 3154720817,
    "dropsitlph": 3154720817,
    "dropsitcph": 3154720817,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV12963",
    "droptype": "D",
    "dropname": "DREISER LOOP",
    "dropdeladd": "179 DREISER LOOP",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104759992,
    "dropphyadd": "179 DREISER LOOP",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104759992,
    "dropmaladd": "179 DREISER LOOP",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104759992,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186710648,
    "dropsitcph": 7186710648,
    "dropfax": 7183255572
  },
  {
    "dcode": "D",
    "dropkey": "SV12987",
    "droptype": "D",
    "dropname": "DYKER HEIGHTS",
    "dropdeladd": "8320 13TH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112289997,
    "dropphyadd": "8320 13TH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112289997,
    "dropmaladd": "8320 13TH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112289997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188331758,
    "dropfax": 7182387549
  },
  {
    "dcode": "D",
    "dropkey": "SV13049",
    "droptype": "D",
    "dropname": "YONKERS EAST",
    "dropdeladd": "915 YONKERS AVE",
    "dropdelcty": "YONKERS",
    "dropdelst": "NY",
    "dropdelzpp": 107043046,
    "dropphyadd": "915 YONKERS AVE",
    "dropphycty": "YONKERS",
    "dropphyst": "NY",
    "dropphyzpp": 107043046,
    "dropmaladd": "915 YONKERS AVE",
    "dropmalcty": "YONKERS",
    "dropmalst": "NY",
    "dropmalzpp": 107043046,
    "dropsitphn": 9146974123,
    "dropsitlph": 9143753098,
    "dropsitcph": 9143753098,
    "dropfax": 9143752078
  },
  {
    "dcode": "D",
    "dropkey": "SV13067",
    "droptype": "D",
    "dropname": "EAST ELMHURST",
    "dropdeladd": "9107 25TH AVE",
    "dropdelcty": "EAST ELMHURST",
    "dropdelst": "NY",
    "dropdelzpp": 113699997,
    "dropphyadd": "9107 25TH AVE",
    "dropphycty": "EAST ELMHURST",
    "dropphyst": "NY",
    "dropphyzpp": 113699997,
    "dropmaladd": "9107 25TH AVE",
    "dropmalcty": "EAST ELMHURST",
    "dropmalst": "NY",
    "dropmalzpp": 113699997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184787091,
    "dropfax": 7184783340
  },
  {
    "dcode": "D",
    "dropkey": "SV13104",
    "droptype": "D",
    "dropname": "EAST NEW YORK",
    "dropdeladd": "2645 ATLANTIC AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112079997,
    "dropphyadd": "2645 ATLANTIC AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112079997,
    "dropmaladd": "2645 ATLANTIC AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112079997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185343569,
    "dropfax": 7183469540
  },
  {
    "dcode": "D",
    "dropkey": "SV13156",
    "droptype": "D",
    "dropname": "EASTWOOD",
    "dropdeladd": "2509 JAMES ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132069211,
    "dropphyadd": "2509 JAMES ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132069211,
    "dropmaladd": "2509 JAMES ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132069211,
    "dropsitphn": 3154638822,
    "dropsitlph": 3154638822,
    "dropsitcph": 3154638822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13176",
    "droptype": "D",
    "dropname": "EINSTEIN",
    "dropdeladd": "127 EINSTEIN LOOP",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104759991,
    "dropphyadd": "127 EINSTEIN LOOP",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104759991,
    "dropmaladd": "3300 CONNER ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104759998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183795891,
    "dropsitcph": 7183795891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13208",
    "droptype": "D",
    "dropname": "ELMHURST",
    "dropdeladd": "5901 JUNCTION BLVD",
    "dropdelcty": "ELMHURST",
    "dropdelst": "NY",
    "dropdelzpp": 113739997,
    "dropphyadd": "5901 JUNCTION BLVD",
    "dropphycty": "ELMHURST",
    "dropphyst": "NY",
    "dropphyzpp": 113739997,
    "dropmaladd": "5901 JUNCTION BLVD",
    "dropmalcty": "ELMHURST",
    "dropmalst": "NY",
    "dropmalzpp": 113739997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182713926,
    "dropfax": 7182714386
  },
  {
    "dcode": "D",
    "dropkey": "SV13211",
    "droptype": "D",
    "dropname": "ELMHURST A",
    "dropdeladd": "8027 BROADWAY",
    "dropdelcty": "ELMHURST",
    "dropdelst": "NY",
    "dropdelzpp": 113739993,
    "dropphyadd": "8027 BROADWAY",
    "dropphycty": "ELMHURST",
    "dropphyst": "NY",
    "dropphyzpp": 113739993,
    "dropmaladd": "8027 BROADWAY",
    "dropmalcty": "ELMHURST",
    "dropmalst": "NY",
    "dropmalzpp": 113739993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188038967,
    "dropfax": 7184605537
  },
  {
    "dcode": "D",
    "dropkey": "SV13226",
    "droptype": "D",
    "dropname": "ELTINGVILLE",
    "dropdeladd": "4455 AMBOY RD",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103129993,
    "dropphyadd": "4455 AMBOY RD",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103129993,
    "dropmaladd": "4455 AMBOY RD",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103129993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3476209432,
    "dropfax": 7189846016
  },
  {
    "dcode": "D",
    "dropkey": "SV13238",
    "droptype": "D",
    "dropname": "EMPIRE STATE PLAZA",
    "dropdeladd": "240 STATE ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122102142,
    "dropphyadd": "240 STATE ST",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122102142,
    "dropmaladd": "PO BOX 209998",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122209998,
    "dropsitphn": 5184652119,
    "dropsitlph": 5184652119,
    "dropsitcph": 5184652119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13249",
    "droptype": "D",
    "dropname": "ESPLANADE",
    "dropdeladd": "2488 WILLIAMSBRIDGE RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104699991,
    "dropphyadd": "2488 WILLIAMSBRIDGE RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104699991,
    "dropmaladd": "1525 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104699998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186548917,
    "dropsitcph": 7186548917,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13260",
    "droptype": "D",
    "dropname": "BROADWAY BUFFALO",
    "dropdeladd": "1035 BROADWAY ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142129993,
    "dropphyadd": "1035 BROADWAY ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142129993,
    "dropmaladd": "1035 BROADWAY ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142129993,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168462401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13290",
    "droptype": "D",
    "dropname": "FARRAGUT",
    "dropdeladd": "1284 UTICA AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112039993,
    "dropphyadd": "1284 UTICA AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112039993,
    "dropmaladd": "726 UTICA AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112039997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7184510108,
    "dropfax": 7184511825
  },
  {
    "dcode": "D",
    "dropkey": "SV13300",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "100 STATE ST RM 1010",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146149998,
    "dropphyadd": "100 STATE ST RM 1010",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146149998,
    "dropmaladd": "100 STATE ST RM 1010",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146149998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853255166,
    "dropsitcph": 5853255166,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13314",
    "droptype": "D",
    "dropname": "FIELDSTON",
    "dropdeladd": "444 W 238TH ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104639991,
    "dropphyadd": "444 W 238TH ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104639991,
    "dropmaladd": "444 W 238TH ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104639991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185485371,
    "dropsitcph": 7185485371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13345",
    "droptype": "D",
    "dropname": "FLATBUSH",
    "dropdeladd": "2273 CHURCH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112269997,
    "dropphyadd": "2273 CHURCH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112269997,
    "dropmaladd": "2273 CHURCH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112269997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472941069,
    "dropfax": 7186938776
  },
  {
    "dcode": "D",
    "dropkey": "SV13348",
    "droptype": "D",
    "dropname": "FLEETWOOD",
    "dropdeladd": "65 FLEETWOOD AVE",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "NY",
    "dropdelzpp": 105522800,
    "dropphyadd": "65 FLEETWOOD AVE",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "NY",
    "dropphyzpp": 105522800,
    "dropmaladd": "65 FLEETWOOD AVE",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "NY",
    "dropmalzpp": 105522800,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146689246,
    "dropsitcph": 9146689246,
    "dropfax": 9146684185
  },
  {
    "dcode": "D",
    "dropkey": "SV13372",
    "droptype": "D",
    "dropname": "FORDHAM",
    "dropdeladd": "465 E 188TH ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104589998,
    "dropphyadd": "465 E 188TH ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104589998,
    "dropmaladd": "465 E 188TH ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104589998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185843577,
    "dropsitcph": 7185843577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13377",
    "droptype": "D",
    "dropname": "FOREST HILLS",
    "dropdeladd": "10628 QUEENS BLVD",
    "dropdelcty": "FOREST HILLS",
    "dropdelst": "NY",
    "dropdelzpp": 113759997,
    "dropphyadd": "10628 QUEENS BLVD",
    "dropphycty": "FOREST HILLS",
    "dropphyst": "NY",
    "dropphyzpp": 113759997,
    "dropmaladd": "10628 QUEENS BLVD",
    "dropmalcty": "FOREST HILLS",
    "dropmalst": "NY",
    "dropmalzpp": 113759997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182633165,
    "dropfax": 7187930151
  },
  {
    "dcode": "D",
    "dropkey": "SV13396",
    "droptype": "D",
    "dropname": "FORT GEORGE",
    "dropdeladd": "4558 BROADWAY",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100409998,
    "dropphyadd": "4558 BROADWAY",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100409998,
    "dropmaladd": "4558 BROADWAY",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100409998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129425266,
    "dropsitcph": 2129425266,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13399",
    "droptype": "D",
    "dropname": "FORT HAMILTON",
    "dropdeladd": "8801 5TH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112099997,
    "dropphyadd": "8801 5TH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112099997,
    "dropmaladd": "8801 5TH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112099997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185351059,
    "dropfax": 7182387539
  },
  {
    "dcode": "D",
    "dropkey": "SV13406",
    "droptype": "D",
    "dropname": "FORT ORANGE",
    "dropdeladd": "450 CENTRAL AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122069998,
    "dropphyadd": "450 CENTRAL AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122069998,
    "dropmaladd": "450 CENTRAL AVE",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122069998,
    "dropsitphn": 5184371106,
    "dropsitlph": 5184371106,
    "dropsitcph": 5184371106,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13429",
    "droptype": "D",
    "dropname": "FDR STATION",
    "dropdeladd": "909 3RD AVE OFC",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100229998,
    "dropphyadd": "909 3RD AVE OFC",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100229998,
    "dropmaladd": "909 3RD AVE OFC",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100229998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305508,
    "dropsitcph": 2123305508,
    "dropfax": 2123305580
  },
  {
    "dcode": "D",
    "dropkey": "SV13459",
    "droptype": "D",
    "dropname": "FRESH POND",
    "dropdeladd": "6080 WOODBINE ST",
    "dropdelcty": "RIDGEWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 113859993,
    "dropphyadd": "6080 WOODBINE ST",
    "dropphycty": "RIDGEWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 113859993,
    "dropmaladd": "6080 WOODBINE ST",
    "dropmalcty": "RIDGEWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 113859993,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7188212061,
    "dropfax": 7188210093
  },
  {
    "dcode": "D",
    "dropkey": "SV13517",
    "droptype": "D",
    "dropname": "GEDNEY",
    "dropdeladd": "620 MAMARONECK AVE",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 106052081,
    "dropphyadd": "620 MAMARONECK AVE",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 106052081,
    "dropmaladd": "620 MAMARONECK AVE",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 106052081,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146841160,
    "dropsitcph": 9146841160,
    "dropfax": 9142859610
  },
  {
    "dcode": "D",
    "dropkey": "SV13556",
    "droptype": "D",
    "dropname": "GLENDALE",
    "dropdeladd": "6936 MYRTLE AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "NY",
    "dropdelzpp": 113859994,
    "dropphyadd": "6936 MYRTLE AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "NY",
    "dropphyzpp": 113859994,
    "dropmaladd": "6936 MYRTLE AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "NY",
    "dropmalzpp": 113859994,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7184181185,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13593",
    "droptype": "D",
    "dropname": "GRACIE",
    "dropdeladd": "229 E 85TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100289998,
    "dropphyadd": "229 E 85TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100289998,
    "dropmaladd": "229 E 85TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100289998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129886680,
    "dropsitcph": 2129886680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13599",
    "droptype": "D",
    "dropname": "GRAND CENTRAL",
    "dropdeladd": "450 LEXINGTON AVE FL 2",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100179998,
    "dropphyadd": "450 LEXINGTON AVE FL 2",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100179998,
    "dropmaladd": "450 LEXINGTON AVE FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100179998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305724,
    "dropsitcph": 2123305724,
    "dropfax": 2123305732
  },
  {
    "dcode": "D",
    "dropkey": "SV13604",
    "droptype": "D",
    "dropname": "GRAND",
    "dropdeladd": "4508 30TH AVE STE A",
    "dropdelcty": "ASTORIA",
    "dropdelst": "NY",
    "dropdelzpp": 111039991,
    "dropphyadd": "4508 30TH AVE STE A",
    "dropphycty": "ASTORIA",
    "dropphyst": "NY",
    "dropphyzpp": 111039991,
    "dropmaladd": "4508 30TH AVE STE A",
    "dropmalcty": "ASTORIA",
    "dropmalst": "NY",
    "dropmalzpp": 111039991,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182741428,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "SV13619",
    "droptype": "D",
    "dropname": "GRAVESEND",
    "dropdeladd": "344 AVENUE U",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112239997,
    "dropphyadd": "344 AVENUE U",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112239997,
    "dropmaladd": "344 AVENUE U",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112239997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3477130758,
    "dropfax": 7183736828
  },
  {
    "dcode": "D",
    "dropkey": "SV13627",
    "droptype": "D",
    "dropname": "GREAT KILLS",
    "dropdeladd": "1 NELSON AVE",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103089992,
    "dropphyadd": "1 NELSON AVE",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103089992,
    "dropmaladd": "1 NELSON AVE",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103089992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7189842063,
    "dropfax": 7186679725
  },
  {
    "dcode": "D",
    "dropkey": "SV13661",
    "droptype": "D",
    "dropname": "GREENPOINT",
    "dropdeladd": "66 MESEROLE AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112229997,
    "dropphyadd": "66 MESEROLE AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112229997,
    "dropmaladd": "66 MESEROLE AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112229997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183895679,
    "dropfax": 7183890499
  },
  {
    "dcode": "D",
    "dropkey": "SV13675",
    "droptype": "D",
    "dropname": "GREYSTONE",
    "dropdeladd": "7 ODELL PLZ STE 130",
    "dropdelcty": "YONKERS",
    "dropdelst": "NY",
    "dropdelzpp": 107011411,
    "dropphyadd": "7 ODELL PLZ STE 130",
    "dropphycty": "YONKERS",
    "dropphyst": "NY",
    "dropphyzpp": 107011411,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "YONKERS",
    "dropmalst": "NY",
    "dropmalzpp": 107029998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9143754173,
    "dropsitcph": 9143754173,
    "dropfax": 9143752054
  },
  {
    "dcode": "D",
    "dropkey": "SV13722",
    "droptype": "D",
    "dropname": "HALSEY",
    "dropdeladd": "805 MACDONOUGH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112339993,
    "dropphyadd": "805 MACDONOUGH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112339993,
    "dropmaladd": "1915 FULTON ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112339997,
    "dropsitphn": 7184936808,
    "dropsitlph": 7183483310,
    "dropsitcph": 7184936808,
    "dropfax": 7184674929
  },
  {
    "dcode": "D",
    "dropkey": "SV13730",
    "droptype": "D",
    "dropname": "HAMILTON GRANGE STATION",
    "dropdeladd": "521 W 146TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100319998,
    "dropphyadd": "521 W 146TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100319998,
    "dropmaladd": "521 W 146TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100319998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122811538,
    "dropsitcph": 2122811538,
    "dropfax": 2122836249
  },
  {
    "dcode": "D",
    "dropkey": "SV13819",
    "droptype": "D",
    "dropname": "HELLGATE STATION",
    "dropdeladd": "153 E 110TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100299998,
    "dropphyadd": "153 E 110TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100299998,
    "dropmaladd": "153 E 110TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100299998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128601896,
    "dropsitcph": 2128601896,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13833",
    "droptype": "D",
    "dropname": "HERITAGE",
    "dropdeladd": "1976 SCHUYLER ST",
    "dropdelcty": "SCHENECTADY",
    "dropdelst": "NY",
    "dropdelzpp": 123039998,
    "dropphyadd": "1976 SCHUYLER ST",
    "dropphycty": "SCHENECTADY",
    "dropphyst": "NY",
    "dropphyzpp": 123039998,
    "dropmaladd": "1976 SCHUYLER ST",
    "dropmalcty": "SCHENECTADY",
    "dropmalst": "NY",
    "dropmalzpp": 123039998,
    "dropsitphn": 5183701726,
    "dropsitlph": 5183701726,
    "dropsitcph": 5183701726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13862",
    "droptype": "D",
    "dropname": "HIGHBRIDGE",
    "dropdeladd": "1315 INWOOD AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104529998,
    "dropphyadd": "1315 INWOOD AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104529998,
    "dropmaladd": "1315 INWOOD AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104529998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185886889,
    "dropsitcph": 7185886889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13868",
    "droptype": "D",
    "dropname": "HIGHLAWN",
    "dropdeladd": "1714 W 6TH ST STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112239993,
    "dropphyadd": "1714 W 6TH ST STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112239993,
    "dropmaladd": "344 AVENUE U",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112239997,
    "dropsitphn": 7184493232,
    "dropsitlph": 7183483310,
    "dropsitcph": 7184493232,
    "dropfax": 7183736828
  },
  {
    "dcode": "D",
    "dropkey": "SV13882",
    "droptype": "D",
    "dropname": "HILLSIDE",
    "dropdeladd": "3482 BOSTON RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104699992,
    "dropphyadd": "3482 BOSTON RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104699992,
    "dropmaladd": "1525 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104699998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186554983,
    "dropsitcph": 7186554983,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV13909",
    "droptype": "D",
    "dropname": "HOLLIS",
    "dropdeladd": "19740 JAMAICA AVE",
    "dropdelcty": "HOLLIS",
    "dropdelst": "NY",
    "dropdelzpp": 114239997,
    "dropphyadd": "19740 JAMAICA AVE",
    "dropphycty": "HOLLIS",
    "dropphyst": "NY",
    "dropphyzpp": 114239997,
    "dropmaladd": "19740 JAMAICA AVE",
    "dropmalcty": "HOLLIS",
    "dropmalst": "NY",
    "dropmalzpp": 114239997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184658313,
    "dropfax": 7182170927
  },
  {
    "dcode": "D",
    "dropkey": "SV13920",
    "droptype": "D",
    "dropname": "HOMECREST",
    "dropdeladd": "2302 AVENUE U",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112299994,
    "dropphyadd": "2302 AVENUE U",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112299994,
    "dropmaladd": "2302 AVENUE U",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112299994,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475494955,
    "dropfax": 7188916384
  },
  {
    "dcode": "D",
    "dropkey": "SV13936",
    "droptype": "D",
    "dropname": "HORACE HARDING",
    "dropdeladd": "5601 MARATHON PKWY",
    "dropdelcty": "LITTLE NECK",
    "dropdelst": "NY",
    "dropdelzpp": 113629993,
    "dropphyadd": "5601 MARATHON PKWY",
    "dropphycty": "LITTLE NECK",
    "dropphyst": "NY",
    "dropphyzpp": 113629993,
    "dropmaladd": "5601 MARATHON PKWY",
    "dropmalcty": "LITTLE NECK",
    "dropmalst": "NY",
    "dropmalzpp": 113629993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182244492,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "SV13950",
    "droptype": "D",
    "dropname": "HOWARD BEACH",
    "dropdeladd": "16050 CROSSBAY BLVD",
    "dropdelcty": "HOWARD BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 114149997,
    "dropphyadd": "16050 CROSSBAY BLVD",
    "dropphycty": "HOWARD BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 114149997,
    "dropmaladd": "16050 CROSSBAY BLVD",
    "dropmalcty": "HOWARD BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 114149997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186419273,
    "dropfax": 7187380308
  },
  {
    "dcode": "D",
    "dropkey": "SV13956",
    "droptype": "D",
    "dropname": "HUB",
    "dropdeladd": "633 SAINT ANNS AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104559998,
    "dropphyadd": "633 SAINT ANNS AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104559998,
    "dropmaladd": "633 SAINT ANNS AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104559998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186651942,
    "dropsitcph": 7186651942,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14014",
    "droptype": "D",
    "dropname": "INWOOD",
    "dropdeladd": "90 VERMILYEA AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100349998,
    "dropphyadd": "90 VERMILYEA AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100349998,
    "dropmaladd": "90 VERMILYEA AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100349998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125677821,
    "dropsitcph": 2125677821,
    "dropfax": 2125674168
  },
  {
    "dcode": "D",
    "dropkey": "SV14019",
    "droptype": "D",
    "dropname": "IRONDEQUOIT",
    "dropdeladd": "425 E RIDGE RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146219998,
    "dropphyadd": "425 E RIDGE RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146219998,
    "dropmaladd": "425 E RIDGE RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146219998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133010,
    "dropsitcph": 5856133010,
    "dropfax": 5852660452
  },
  {
    "dcode": "D",
    "dropkey": "SV14030",
    "droptype": "D",
    "dropname": "ROOSEVELT ISLAND",
    "dropdeladd": "694 MAIN ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100449998,
    "dropphyadd": "694 MAIN ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100449998,
    "dropmaladd": "694 MAIN ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100449998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128262327,
    "dropsitcph": 2128262327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14052",
    "droptype": "D",
    "dropname": "JACKSON HEIGHTS",
    "dropdeladd": "7802 37TH AVE",
    "dropdelcty": "JACKSON HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 113729997,
    "dropphyadd": "7802 37TH AVE",
    "dropphycty": "JACKSON HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 113729997,
    "dropmaladd": "7802 37TH AVE",
    "dropmalcty": "JACKSON HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 113729997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184267359,
    "dropfax": 7184783365
  },
  {
    "dcode": "D",
    "dropkey": "SV14060",
    "droptype": "D",
    "dropname": "JAMES A FARLEY",
    "dropdeladd": "421 8TH AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100019998,
    "dropphyadd": "421 8TH AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100019998,
    "dropmaladd": "421 8TH AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100019998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123302533,
    "dropsitcph": 2123303296,
    "dropfax": 2123302006
  },
  {
    "dcode": "D",
    "dropkey": "SV14085",
    "droptype": "D",
    "dropname": "JEROME STATION",
    "dropdeladd": "2549 JEROME AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104689998,
    "dropphyadd": "2549 JEROME AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104689998,
    "dropmaladd": "2549 JEROME AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104689998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183648432,
    "dropsitcph": 7183648432,
    "dropfax": 7183653727
  },
  {
    "dcode": "D",
    "dropkey": "SV14094",
    "droptype": "D",
    "dropname": "JOHN F KENNEDY AIRPORT",
    "dropdeladd": "250 N BOUNDARY RD STE 1",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114309997,
    "dropphyadd": "250 N BOUNDARY RD STE 1",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114309997,
    "dropmaladd": "250 N BOUNDARY RD STE 1",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114309997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186566433,
    "dropfax": 7184605537
  },
  {
    "dcode": "D",
    "dropkey": "SV14110",
    "droptype": "D",
    "dropname": "JUNCTION BOULEVARD",
    "dropdeladd": "3323 JUNCTION BLVD STE 1",
    "dropdelcty": "JACKSON HEIGHTS",
    "dropdelst": "NY",
    "dropdelzpp": 113729993,
    "dropphyadd": "3323 JUNCTION BLVD STE 1",
    "dropphycty": "JACKSON HEIGHTS",
    "dropphyst": "NY",
    "dropphyzpp": 113729993,
    "dropmaladd": "3323 JUNCTION BLVD STE 1",
    "dropmalcty": "JACKSON HEIGHTS",
    "dropmalst": "NY",
    "dropmalzpp": 113729993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185651703,
    "dropfax": 7184783365
  },
  {
    "dcode": "D",
    "dropkey": "SV14133",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "419 MCDONALD AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112189997,
    "dropphyadd": "419 MCDONALD AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112189997,
    "dropmaladd": "419 MCDONALD AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112189997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184360164,
    "dropfax": 7184372676
  },
  {
    "dcode": "D",
    "dropkey": "SV14142",
    "droptype": "D",
    "dropname": "KERNAN",
    "dropdeladd": "1709 GENESEE ST STE 1",
    "dropdelcty": "UTICA",
    "dropdelst": "NY",
    "dropdelzpp": 135019998,
    "dropphyadd": "1709 GENESEE ST STE 1",
    "dropphycty": "UTICA",
    "dropphyst": "NY",
    "dropphyzpp": 135019998,
    "dropmaladd": "1709 GENESEE ST STE 1",
    "dropmalcty": "UTICA",
    "dropmalst": "NY",
    "dropmalzpp": 135019998,
    "dropsitphn": 3157385301,
    "dropsitlph": 3157385313,
    "dropsitcph": 3157336480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14147",
    "droptype": "D",
    "dropname": "KEW GARDENS",
    "dropdeladd": "8330 AUSTIN ST",
    "dropdelcty": "KEW GARDENS",
    "dropdelst": "NY",
    "dropdelzpp": 114159997,
    "dropphyadd": "8330 AUSTIN ST",
    "dropphycty": "KEW GARDENS",
    "dropphyst": "NY",
    "dropphyzpp": 114159997,
    "dropmaladd": "8330 AUSTIN ST",
    "dropmalcty": "KEW GARDENS",
    "dropmalst": "NY",
    "dropmalzpp": 114159997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188479895,
    "dropfax": 7188057978
  },
  {
    "dcode": "D",
    "dropkey": "SV14165",
    "droptype": "D",
    "dropname": "KINGSBRIDGE",
    "dropdeladd": "5517 BROADWAY",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104639998,
    "dropphyadd": "5517 BROADWAY",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104639998,
    "dropmaladd": "5517 BROADWAY",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104639998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185496962,
    "dropsitcph": 7185496962,
    "dropfax": 7186010424
  },
  {
    "dcode": "D",
    "dropkey": "SV14169",
    "droptype": "D",
    "dropname": "KINGSWAY",
    "dropdeladd": "1610 E 19TH ST STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112299993,
    "dropphyadd": "1610 E 19TH ST STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112299993,
    "dropmaladd": "1610 E 19TH ST STE 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112299993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183764448,
    "dropfax": 7187695542
  },
  {
    "dcode": "D",
    "dropkey": "SV14186",
    "droptype": "D",
    "dropname": "KNICKERBOCKER",
    "dropdeladd": "128 E BROADWAY",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100029998,
    "dropphyadd": "128 E BROADWAY",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100029998,
    "dropmaladd": "128 E BROADWAY",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100029998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122671543,
    "dropsitcph": 2122671543,
    "dropfax": 2129641832
  },
  {
    "dcode": "D",
    "dropkey": "SV14217",
    "droptype": "D",
    "dropname": "LA SALLE",
    "dropdeladd": "9860 NIAGARA FALLS BLVD",
    "dropdelcty": "NIAGARA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 143049998,
    "dropphyadd": "9860 NIAGARA FALLS BLVD",
    "dropphycty": "NIAGARA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 143049998,
    "dropmaladd": "9860 NIAGARA FALLS BLVD",
    "dropmalcty": "NIAGARA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 143049998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7165131014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14286",
    "droptype": "D",
    "dropname": "LANSINGBURGH",
    "dropdeladd": "2 116TH ST",
    "dropdelcty": "TROY",
    "dropdelst": "NY",
    "dropdelzpp": 121829998,
    "dropphyadd": "2 116TH ST",
    "dropphycty": "TROY",
    "dropphyst": "NY",
    "dropphyzpp": 121829998,
    "dropmaladd": "2 116TH ST",
    "dropmalcty": "TROY",
    "dropmalst": "NY",
    "dropmalzpp": 121829998,
    "dropsitphn": 5182727300,
    "dropsitlph": 5182352322,
    "dropsitcph": 5182352322,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14327",
    "droptype": "D",
    "dropname": "JAMES E DAVIS",
    "dropdeladd": "315 EMPIRE BLVD",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112259997,
    "dropphyadd": "315 EMPIRE BLVD",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112259997,
    "dropmaladd": "315 EMPIRE BLVD",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112259997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472276970,
    "dropfax": 7189536544
  },
  {
    "dcode": "D",
    "dropkey": "SV14333",
    "droptype": "D",
    "dropname": "LENOX HILL",
    "dropdeladd": "217 E 70TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100219998,
    "dropphyadd": "217 E 70TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100219998,
    "dropmaladd": "217 E 70TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100219998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128794401,
    "dropsitcph": 2128794401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14361",
    "droptype": "D",
    "dropname": "LINCOLNTON",
    "dropdeladd": "2266 5TH AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100379998,
    "dropphyadd": "2266 5TH AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100379998,
    "dropmaladd": "2266 5TH AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100379998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122813281,
    "dropsitcph": 2122813281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14363",
    "droptype": "D",
    "dropname": "LINDEN HILL",
    "dropdeladd": "2950 UNION ST STE A",
    "dropdelcty": "FLUSHING",
    "dropdelst": "NY",
    "dropdelzpp": 113549997,
    "dropphyadd": "2950 UNION ST STE A",
    "dropphycty": "FLUSHING",
    "dropphyst": "NY",
    "dropphyzpp": 113549997,
    "dropmaladd": "2950 UNION ST STE A",
    "dropmalcty": "FLUSHING",
    "dropmalst": "NY",
    "dropmalzpp": 113549997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473794652,
    "dropfax": 7183217631
  },
  {
    "dcode": "D",
    "dropkey": "SV14376",
    "droptype": "D",
    "dropname": "LITTLE NECK",
    "dropdeladd": "25010 NORTHERN BLVD",
    "dropdelcty": "LITTLE NECK",
    "dropdelst": "NY",
    "dropdelzpp": 113629997,
    "dropphyadd": "25010 NORTHERN BLVD",
    "dropphycty": "LITTLE NECK",
    "dropphyst": "NY",
    "dropphyzpp": 113629997,
    "dropmaladd": "25010 NORTHERN BLVD",
    "dropmalcty": "LITTLE NECK",
    "dropmalst": "NY",
    "dropmalzpp": 113629997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3478242040,
    "dropfax": 7182290259
  },
  {
    "dcode": "D",
    "dropkey": "SV14414",
    "droptype": "D",
    "dropname": "LONDON TERRACE",
    "dropdeladd": "234 10TH AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100119993,
    "dropphyadd": "234 10TH AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100119993,
    "dropmaladd": "217 W 18TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100119998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122553541,
    "dropsitcph": 2122553541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14445",
    "droptype": "D",
    "dropname": "LEXINGTON ROCHESTER",
    "dropdeladd": "1280 LEXINGTON AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146069998,
    "dropphyadd": "1280 LEXINGTON AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146069998,
    "dropmaladd": "1280 LEXINGTON AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146069998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5856133220,
    "dropsitcph": 5856133220,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14465",
    "droptype": "D",
    "dropname": "MACYS FINANCE",
    "dropdeladd": "151 W 34TH ST FL 9",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100019991,
    "dropphyadd": "151 W 34TH ST FL 9",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100019991,
    "dropmaladd": "151 W 34TH ST FL 9",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100019991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2124942688,
    "dropsitcph": 2124942688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14469",
    "droptype": "D",
    "dropname": "MADISON SQUARE",
    "dropdeladd": "149 E 23RD ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100109998,
    "dropphyadd": "149 E 23RD ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100109998,
    "dropmaladd": "149 E 23RD ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100109998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126733771,
    "dropsitcph": 2126733771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14480",
    "droptype": "D",
    "dropname": "CADMAN PLAZA",
    "dropdeladd": "271 CADMAN PLZ E STE 2",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112019997,
    "dropphyadd": "271 CADMAN PLZ E STE 2",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112019997,
    "dropmaladd": "271 CADMAN PLZ E STE 2",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112019997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188550912,
    "dropfax": 7189350149
  },
  {
    "dcode": "D",
    "dropkey": "SV14509",
    "droptype": "D",
    "dropname": "MANHATTANVILLE",
    "dropdeladd": "365 W 125TH ST STE 2A",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100279998,
    "dropphyadd": "365 W 125TH ST STE 2A",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100279998,
    "dropmaladd": "365 W 125TH ST STE 2A",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100279998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126621540,
    "dropsitcph": 2126621540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14569",
    "droptype": "D",
    "dropname": "MASPETH",
    "dropdeladd": "5502 69TH ST",
    "dropdelcty": "MASPETH",
    "dropdelst": "NY",
    "dropdelzpp": 113789997,
    "dropphyadd": "5502 69TH ST",
    "dropphycty": "MASPETH",
    "dropphyst": "NY",
    "dropphyzpp": 113789997,
    "dropmaladd": "5502 69TH ST",
    "dropmalcty": "MASPETH",
    "dropmalst": "NY",
    "dropmalzpp": 113789997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184575623,
    "dropfax": 7184605537
  },
  {
    "dcode": "D",
    "dropkey": "SV14653",
    "droptype": "D",
    "dropname": "METROPOLITAN",
    "dropdeladd": "47 DEBEVOISE ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112069997,
    "dropphyadd": "47 DEBEVOISE ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112069997,
    "dropmaladd": "47 DEBEVOISE ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112069997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472721755,
    "dropfax": 7185993427
  },
  {
    "dcode": "D",
    "dropkey": "SV14667",
    "droptype": "D",
    "dropname": "MIDDLE VILLAGE",
    "dropdeladd": "7135 METROPOLITAN AVE",
    "dropdelcty": "MIDDLE VILLAGE",
    "dropdelst": "NY",
    "dropdelzpp": 113799997,
    "dropphyadd": "7135 METROPOLITAN AVE",
    "dropphycty": "MIDDLE VILLAGE",
    "dropphyst": "NY",
    "dropphyzpp": 113799997,
    "dropmaladd": "7135 METROPOLITAN AVE",
    "dropmalcty": "MIDDLE VILLAGE",
    "dropmalst": "NY",
    "dropmalzpp": 113799997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475277143,
    "dropfax": 7188942556
  },
  {
    "dcode": "D",
    "dropkey": "SV14678",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "223 W 38TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100189998,
    "dropphyadd": "223 W 38TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100189998,
    "dropmaladd": "223 W 38TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100189998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128199604,
    "dropsitcph": 2128199604,
    "dropfax": 2127194608
  },
  {
    "dcode": "D",
    "dropkey": "SV14679",
    "droptype": "D",
    "dropname": "MIDTOWN PLAZA",
    "dropdeladd": "454 E BROAD ST STE 100",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146071724,
    "dropphyadd": "454 E BROAD ST STE 100",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146071724,
    "dropmaladd": "454 E BROAD ST STE 100",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146071724,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853252177,
    "dropsitcph": 5853252177,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14680",
    "droptype": "D",
    "dropname": "MIDWOOD",
    "dropdeladd": "1288 CONEY ISLAND AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112309997,
    "dropphyadd": "1288 CONEY ISLAND AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112309997,
    "dropmaladd": "1288 CONEY ISLAND AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112309997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475788835,
    "dropfax": 7182520746
  },
  {
    "dcode": "D",
    "dropkey": "SV14751",
    "droptype": "D",
    "dropname": "MORNINGSIDE",
    "dropdeladd": "232 W 116TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100269998,
    "dropphyadd": "232 W 116TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100269998,
    "dropmaladd": "232 W 116TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100269998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128643158,
    "dropsitcph": 2128643158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14754",
    "droptype": "D",
    "dropname": "MORRIS HEIGHTS",
    "dropdeladd": "2024 JEROME AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104539998,
    "dropphyadd": "2024 JEROME AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104539998,
    "dropmaladd": "2024 JEROME AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104539998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185830669,
    "dropsitcph": 7185830669,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14756",
    "droptype": "D",
    "dropname": "MORRIS PARK",
    "dropdeladd": "1807 WILLIAMSBRIDGE RD FRNT 1",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104619991,
    "dropphyadd": "1807 WILLIAMSBRIDGE RD FRNT 1",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104619991,
    "dropmaladd": "1807 WILLIAMSBRIDGE RD FRNT 1",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104619991,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188230968,
    "dropsitcph": 7188230968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14758",
    "droptype": "D",
    "dropname": "MORRISANIA",
    "dropdeladd": "442 E 167TH ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104569998,
    "dropphyadd": "442 E 167TH ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104569998,
    "dropmaladd": "442 E 167TH ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104569998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7189938054,
    "dropsitcph": 7189938054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14767",
    "droptype": "D",
    "dropname": "MOSHOLU",
    "dropdeladd": "3464 JEROME AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104679992,
    "dropphyadd": "3464 JEROME AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104679992,
    "dropmaladd": "711 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104679998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186550144,
    "dropsitcph": 7186550144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14771",
    "droptype": "D",
    "dropname": "MOTT HAVEN",
    "dropdeladd": "517 E 139TH ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104549998,
    "dropphyadd": "517 E 139TH ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104549998,
    "dropmaladd": "517 E 139TH ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104549998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185859611,
    "dropsitcph": 7185859611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14777",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "652 E 187TH ST FRNT 1",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104589992,
    "dropphyadd": "652 E 187TH ST FRNT 1",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104589992,
    "dropmaladd": "652 E 187TH ST FRNT 1",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104589992,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183659091,
    "dropsitcph": 7183659091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14812",
    "droptype": "D",
    "dropname": "MUNICIPAL",
    "dropdeladd": "210 JORALEMON ST FL 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112019993,
    "dropphyadd": "210 JORALEMON ST FL 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112019993,
    "dropmaladd": "210 JORALEMON ST FL 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112019993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185967263,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14935",
    "droptype": "D",
    "dropname": "NEW DORP",
    "dropdeladd": "2562 HYLAN BLVD",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103069997,
    "dropphyadd": "2562 HYLAN BLVD",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103069997,
    "dropmaladd": "2562 HYLAN BLVD",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103069997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188739267,
    "dropfax": 7186679725
  },
  {
    "dcode": "D",
    "dropkey": "SV14953",
    "droptype": "D",
    "dropname": "NEW LOTS",
    "dropdeladd": "1223 SUTTER AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112089997,
    "dropphyadd": "1223 SUTTER AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112089997,
    "dropmaladd": "1223 SUTTER AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112089997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 9172464544,
    "dropfax": 7183489659
  },
  {
    "dcode": "D",
    "dropkey": "SV14954",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "2020 PINE AVE FRNT A",
    "dropdelcty": "NIAGARA FALLS",
    "dropdelst": "NY",
    "dropdelzpp": 143019993,
    "dropphyadd": "2020 PINE AVE FRNT A",
    "dropphycty": "NIAGARA FALLS",
    "dropphyst": "NY",
    "dropphyzpp": 143019993,
    "dropmaladd": "2020 PINE AVE FRNT A",
    "dropmalcty": "NIAGARA FALLS",
    "dropmalst": "NY",
    "dropmalzpp": 143019993,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462531,
    "dropsitcph": 7162840233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV14959",
    "droptype": "D",
    "dropname": "NEW SPRINGVILLE",
    "dropdeladd": "2845 RICHMOND AVE STE 15",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103149993,
    "dropphyadd": "2845 RICHMOND AVE STE 15",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103149993,
    "dropmaladd": "2845 RICHMOND AVE STE 15",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103149993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186987958,
    "dropfax": 7188162793
  },
  {
    "dcode": "D",
    "dropkey": "SV14982",
    "droptype": "D",
    "dropname": "NEWKIRK",
    "dropdeladd": "1525 NEWKIRK AVE STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112269993,
    "dropphyadd": "1525 NEWKIRK AVE STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112269993,
    "dropmaladd": "2273 CHURCH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112269997,
    "dropsitphn": 7182844900,
    "dropsitlph": 7183483310,
    "dropsitcph": 7182844900,
    "dropfax": 7186938776
  },
  {
    "dcode": "D",
    "dropkey": "SV14998",
    "droptype": "D",
    "dropname": "NIAGARA SQUARE",
    "dropdeladd": "229 W GENESEE ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142029998,
    "dropphyadd": "229 W GENESEE ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142029998,
    "dropmaladd": "229 W GENESEE ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142029998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168564601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15030",
    "droptype": "D",
    "dropname": "NORTH BALDWIN",
    "dropdeladd": "1620 GRAND AVE",
    "dropdelcty": "NORTH BALDWIN",
    "dropdelst": "NY",
    "dropdelzpp": 115101841,
    "dropphyadd": "1620 GRAND AVE",
    "dropphycty": "NORTH BALDWIN",
    "dropphyst": "NY",
    "dropphyzpp": 115101841,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BALDWIN",
    "dropmalst": "NY",
    "dropmalzpp": 115109998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162235710,
    "dropfax": 5163773250
  },
  {
    "dcode": "D",
    "dropkey": "SV15115",
    "droptype": "D",
    "dropname": "NORTH WHITE PLAINS",
    "dropdeladd": "585 N BROADWAY",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 106039993,
    "dropphyadd": "585 N BROADWAY",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 106039993,
    "dropmaladd": "585 N BROADWAY",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 106039993,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146841548,
    "dropsitcph": 9146841548,
    "dropfax": 9143282215
  },
  {
    "dcode": "D",
    "dropkey": "SV15126",
    "droptype": "D",
    "dropname": "NORTHSIDE BUFFALO",
    "dropdeladd": "725 HERTEL AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142079998,
    "dropphyadd": "725 HERTEL AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142079998,
    "dropmaladd": "725 HERTEL AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142079998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168747007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15127",
    "droptype": "D",
    "dropname": "SOUTHSIDE CORNING",
    "dropdeladd": "129 WALNUT ST",
    "dropdelcty": "CORNING",
    "dropdelst": "NY",
    "dropdelzpp": 148309997,
    "dropphyadd": "129 WALNUT ST",
    "dropphycty": "CORNING",
    "dropphyst": "NY",
    "dropphyzpp": 148309997,
    "dropmaladd": "129 WALNUT ST",
    "dropmalcty": "CORNING",
    "dropmalst": "NY",
    "dropmalzpp": 148309997,
    "dropsitphn": 7168462415,
    "dropsitlph": 6079626223,
    "dropsitcph": 6079626223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15135",
    "droptype": "D",
    "dropname": "NOSTRAND",
    "dropdeladd": "2934 AVENUE X",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112359991,
    "dropphyadd": "2934 AVENUE X",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112359991,
    "dropmaladd": "2628 E 18TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112359997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183324921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15173",
    "droptype": "D",
    "dropname": "OAKLAND GARDENS",
    "dropdeladd": "6143 SPRINGFIELD BLVD",
    "dropdelcty": "OAKLAND GARDENS",
    "dropdelst": "NY",
    "dropdelzpp": 113649997,
    "dropphyadd": "6143 SPRINGFIELD BLVD",
    "dropphycty": "OAKLAND GARDENS",
    "dropphyst": "NY",
    "dropphyzpp": 113649997,
    "dropmaladd": "6143 SPRINGFIELD BLVD",
    "dropmalcty": "OAKLAND GARDENS",
    "dropmalst": "NY",
    "dropmalzpp": 113649997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182246491,
    "dropfax": 7182812257
  },
  {
    "dcode": "D",
    "dropkey": "SV15197",
    "droptype": "D",
    "dropname": "OLD CHELSEA",
    "dropdeladd": "217 W 18TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100119998,
    "dropphyadd": "217 W 18TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100119998,
    "dropmaladd": "217 W 18TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100119998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126750548,
    "dropsitcph": 2126752414,
    "dropfax": 2126200918
  },
  {
    "dcode": "D",
    "dropkey": "SV15268",
    "droptype": "D",
    "dropname": "OVINGTON",
    "dropdeladd": "6803 4TH AVE STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112209993,
    "dropphyadd": "6803 4TH AVE STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112209993,
    "dropmaladd": "6803 4TH AVE STE 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112209993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187480665,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15281",
    "droptype": "D",
    "dropname": "OZONE PARK",
    "dropdeladd": "9111 LIBERTY AVE",
    "dropdelcty": "OZONE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 114179993,
    "dropphyadd": "9111 LIBERTY AVE",
    "dropphycty": "OZONE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 114179993,
    "dropmaladd": "9111 LIBERTY AVE",
    "dropmalcty": "OZONE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 114179993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183740160,
    "dropfax": 7186412561
  },
  {
    "dcode": "D",
    "dropkey": "SV15312",
    "droptype": "D",
    "dropname": "PARK BLVD",
    "dropdeladd": "1007 PARK BLVD",
    "dropdelcty": "MASSAPEQUA PARK",
    "dropdelst": "NY",
    "dropdelzpp": 117629991,
    "dropphyadd": "1007 PARK BLVD",
    "dropphycty": "MASSAPEQUA PARK",
    "dropphyst": "NY",
    "dropphyzpp": 117629991,
    "dropmaladd": "1007 PARK BLVD",
    "dropmalcty": "MASSAPEQUA PARK",
    "dropmalst": "NY",
    "dropmalzpp": 117629991,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167996802,
    "dropfax": 5167990931
  },
  {
    "dcode": "D",
    "dropkey": "SV15313",
    "droptype": "D",
    "dropname": "PARK SLOPE",
    "dropdeladd": "198 7TH AVE STE A",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112159993,
    "dropphyadd": "198 7TH AVE STE A",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112159993,
    "dropmaladd": "198 7TH AVE STE A",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112159993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7188343048,
    "dropfax": 7187883037
  },
  {
    "dcode": "D",
    "dropkey": "SV15315",
    "droptype": "D",
    "dropname": "PARK WEST",
    "dropdeladd": "700 COLUMBUS AVE FRNT 4",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100259992,
    "dropphyadd": "700 COLUMBUS AVE FRNT 4",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100259992,
    "dropmaladd": "215 W 104TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100259998,
    "dropsitphn": 2128661981,
    "dropsitlph": 2123302770,
    "dropsitcph": 2128661981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15317",
    "droptype": "D",
    "dropname": "PARKCHESTER",
    "dropdeladd": "1449 WEST AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104629998,
    "dropphyadd": "1449 WEST AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104629998,
    "dropmaladd": "1449 WEST AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104629998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188920557,
    "dropsitcph": 7188920557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15319",
    "droptype": "D",
    "dropname": "PARKSIDE",
    "dropdeladd": "10119 METROPOLITAN AVE",
    "dropdelcty": "FOREST HILLS",
    "dropdelst": "NY",
    "dropdelzpp": 113759993,
    "dropphyadd": "10119 METROPOLITAN AVE",
    "dropphycty": "FOREST HILLS",
    "dropphyst": "NY",
    "dropphyzpp": 113759993,
    "dropmaladd": "10119 METROPOLITAN AVE",
    "dropmalcty": "FOREST HILLS",
    "dropmalst": "NY",
    "dropmalzpp": 113759993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182632957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15321",
    "droptype": "D",
    "dropname": "PARKVILLE",
    "dropdeladd": "6618 20TH AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112049997,
    "dropphyadd": "6618 20TH AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112049997,
    "dropmaladd": "6618 20TH AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112049997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182361789,
    "dropfax": 7182346909
  },
  {
    "dcode": "D",
    "dropkey": "SV15323",
    "droptype": "D",
    "dropname": "PARKWAY",
    "dropdeladd": "2100 WHITE PLAINS RD FRNT 3",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104629992,
    "dropphyadd": "2100 WHITE PLAINS RD FRNT 3",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104629992,
    "dropmaladd": "2100 WHITE PLAINS RD FRNT 3",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104629992,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188632489,
    "dropsitcph": 7188632489,
    "dropfax": 7188241905
  },
  {
    "dcode": "D",
    "dropkey": "SV15325",
    "droptype": "D",
    "dropname": "PATCHIN",
    "dropdeladd": "70 W 10TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100119991,
    "dropphyadd": "70 W 10TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100119991,
    "dropmaladd": "70 W 10TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100119991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2124752534,
    "dropsitcph": 2124752534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15351",
    "droptype": "D",
    "dropname": "PENATAQUIT",
    "dropdeladd": "10 BAY SHORE AVE",
    "dropdelcty": "BAY SHORE",
    "dropdelst": "NY",
    "dropdelzpp": 117067917,
    "dropphyadd": "10 BAY SHORE AVE",
    "dropphycty": "BAY SHORE",
    "dropphyst": "NY",
    "dropphyzpp": 117067917,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BAY SHORE",
    "dropmalst": "NY",
    "dropmalzpp": 117069998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6319693506,
    "dropfax": 6319686581
  },
  {
    "dcode": "D",
    "dropkey": "SV15397",
    "droptype": "D",
    "dropname": "PILGRIM",
    "dropdeladd": "1545 CROSBY AVE FRNT 1",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104619992,
    "dropphyadd": "1545 CROSBY AVE FRNT 1",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104619992,
    "dropmaladd": "1545 CROSBY AVE FRNT 1",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104619992,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188231785,
    "dropsitcph": 7188231785,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15446",
    "droptype": "D",
    "dropname": "PLANETARIUM",
    "dropdeladd": "127 W 83RD ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100249998,
    "dropphyadd": "127 W 83RD ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100249998,
    "dropmaladd": "127 W 83RD ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100249998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2128735698,
    "dropsitcph": 2128735698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15481",
    "droptype": "D",
    "dropname": "POMONOK",
    "dropdeladd": "15805 71ST AVE",
    "dropdelcty": "FRESH MEADOWS",
    "dropdelst": "NY",
    "dropdelzpp": 113659993,
    "dropphyadd": "15805 71ST AVE",
    "dropphycty": "FRESH MEADOWS",
    "dropphyst": "NY",
    "dropphyzpp": 113659993,
    "dropmaladd": "15805 71ST AVE",
    "dropmalcty": "FRESH MEADOWS",
    "dropmalst": "NY",
    "dropmalzpp": 113659993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7185919411,
    "dropfax": 7186704864
  },
  {
    "dcode": "D",
    "dropkey": "SV15510",
    "droptype": "D",
    "dropname": "PORT RICHMOND",
    "dropdeladd": "364 PORT RICHMOND AVE",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103029997,
    "dropphyadd": "364 PORT RICHMOND AVE",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103029997,
    "dropmaladd": "364 PORT RICHMOND AVE",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103029997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184425102,
    "dropfax": 7182738377
  },
  {
    "dcode": "D",
    "dropkey": "SV15551",
    "droptype": "D",
    "dropname": "PRINCE STATION",
    "dropdeladd": "124 GREENE ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100129991,
    "dropphyadd": "124 GREENE ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100123200,
    "dropmaladd": "350 CANAL ST STE 2A",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100139998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129253378,
    "dropsitcph": 2122267868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15556",
    "droptype": "D",
    "dropname": "PROSPECT PARK WEST",
    "dropdeladd": "225 PROSPECT PARK W STE A",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112159992,
    "dropphyadd": "225 PROSPECT PARK W STE A",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112159992,
    "dropmaladd": "225 PROSPECT PARK W STE A",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112159992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7188343048,
    "dropfax": 7187883087
  },
  {
    "dcode": "D",
    "dropkey": "SV15610",
    "droptype": "D",
    "dropname": "QUEENS VILLAGE",
    "dropdeladd": "20920 JAMAICA AVE",
    "dropdelcty": "QUEENS VILLAGE",
    "dropdelst": "NY",
    "dropdelzpp": 114289997,
    "dropphyadd": "20920 JAMAICA AVE",
    "dropphycty": "QUEENS VILLAGE",
    "dropphyst": "NY",
    "dropphyzpp": 114289997,
    "dropmaladd": "20920 JAMAICA AVE",
    "dropmalcty": "QUEENS VILLAGE",
    "dropmalst": "NY",
    "dropmalzpp": 114289997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184658322,
    "dropfax": 7182171135
  },
  {
    "dcode": "D",
    "dropkey": "SV15618",
    "droptype": "D",
    "dropname": "RADIO CITY",
    "dropdeladd": "322 W 52ND ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100199998,
    "dropphyadd": "322 W 52ND ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100199998,
    "dropmaladd": "322 W 52ND ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100199998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122653672,
    "dropsitcph": 2122653672,
    "dropfax": 2126647681
  },
  {
    "dcode": "D",
    "dropkey": "SV15648",
    "droptype": "D",
    "dropname": "RED HOOK",
    "dropdeladd": "615 CLINTON ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112319997,
    "dropphyadd": "615 CLINTON ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112319997,
    "dropmaladd": "615 CLINTON ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112319997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 9172464564,
    "dropfax": 7184889257
  },
  {
    "dcode": "D",
    "dropkey": "SV15660",
    "droptype": "D",
    "dropname": "REGO PARK",
    "dropdeladd": "9224 QUEENS BLVD",
    "dropdelcty": "REGO PARK",
    "dropdelst": "NY",
    "dropdelzpp": 113749997,
    "dropphyadd": "9224 QUEENS BLVD",
    "dropphycty": "REGO PARK",
    "dropphyst": "NY",
    "dropphyzpp": 113749997,
    "dropmaladd": "9224 QUEENS BLVD",
    "dropmalcty": "REGO PARK",
    "dropmalst": "NY",
    "dropmalzpp": 113749997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475277186,
    "dropfax": 7186720663
  },
  {
    "dcode": "D",
    "dropkey": "SV15670",
    "droptype": "D",
    "dropname": "RESTORATION PLAZA",
    "dropdeladd": "1360 FULTON ST STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112169993,
    "dropphyadd": "1360 FULTON ST STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112169993,
    "dropmaladd": "1360 FULTON ST STE 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112169993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187893072,
    "dropfax": 7187896813
  },
  {
    "dcode": "D",
    "dropkey": "SV15690",
    "droptype": "D",
    "dropname": "RICHMOND HILL",
    "dropdeladd": "12201 JAMAICA AVE",
    "dropdelcty": "RICHMOND HILL",
    "dropdelst": "NY",
    "dropdelzpp": 114189997,
    "dropphyadd": "12201 JAMAICA AVE",
    "dropphycty": "RICHMOND HILL",
    "dropphyst": "NY",
    "dropphyzpp": 114189997,
    "dropmaladd": "12201 JAMAICA AVE",
    "dropmalcty": "RICHMOND HILL",
    "dropmalst": "NY",
    "dropmalzpp": 114189997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188473043,
    "dropfax": 7188056413
  },
  {
    "dcode": "D",
    "dropkey": "SV15701",
    "droptype": "D",
    "dropname": "RIDGEWOOD",
    "dropdeladd": "6060 MYRTLE AVE",
    "dropdelcty": "RIDGEWOOD",
    "dropdelst": "NY",
    "dropdelzpp": 113859997,
    "dropphyadd": "6060 MYRTLE AVE",
    "dropphycty": "RIDGEWOOD",
    "dropphyst": "NY",
    "dropphyzpp": 113859997,
    "dropmaladd": "6060 MYRTLE AVE",
    "dropmalcty": "RIDGEWOOD",
    "dropmalst": "NY",
    "dropmalzpp": 113859997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472941466,
    "dropfax": 7184180671
  },
  {
    "dcode": "D",
    "dropkey": "SV15709",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "5951 RIVERDALE AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104719998,
    "dropphyadd": "5951 RIVERDALE AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104719998,
    "dropmaladd": "5951 RIVERDALE AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104719998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185495680,
    "dropsitcph": 7185495680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15729",
    "droptype": "D",
    "dropname": "ROCHDALE VILLAGE",
    "dropdeladd": "165100 BAISLEY BLVD",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114349997,
    "dropphyadd": "165100 BAISLEY BLVD",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114349997,
    "dropmaladd": "165100 BAISLEY BLVD",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114349997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185253765,
    "dropfax": 7189782765
  },
  {
    "dcode": "D",
    "dropkey": "SV15748",
    "droptype": "D",
    "dropname": "ROCKAWAY BEACH",
    "dropdeladd": "9014 ROCKAWAY BEACH BLVD",
    "dropdelcty": "ROCKAWAY BEACH",
    "dropdelst": "NY",
    "dropdelzpp": 116939997,
    "dropphyadd": "9014 ROCKAWAY BEACH BLVD",
    "dropphycty": "ROCKAWAY BEACH",
    "dropphyst": "NY",
    "dropphyzpp": 116939997,
    "dropmaladd": "9014 ROCKAWAY BEACH BLVD",
    "dropmalcty": "ROCKAWAY BEACH",
    "dropmalst": "NY",
    "dropmalzpp": 116939997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186344075,
    "dropfax": 7186345926
  },
  {
    "dcode": "D",
    "dropkey": "SV15750",
    "droptype": "D",
    "dropname": "ROCKAWAY PARK",
    "dropdeladd": "11325 BEACH CHANNEL DR",
    "dropdelcty": "ROCKAWAY PARK",
    "dropdelst": "NY",
    "dropdelzpp": 116949997,
    "dropphyadd": "11325 BEACH CHANNEL DR",
    "dropphycty": "ROCKAWAY PARK",
    "dropphyst": "NY",
    "dropphyzpp": 116949997,
    "dropmaladd": "11325 BEACH CHANNEL DR",
    "dropmalcty": "ROCKAWAY PARK",
    "dropmalst": "NY",
    "dropmalzpp": 116949997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186346057,
    "dropfax": 7186345937
  },
  {
    "dcode": "D",
    "dropkey": "SV15784",
    "droptype": "D",
    "dropname": "ROOSEVELT FIELD",
    "dropdeladd": "630 OLD COUNTRY RD UNIT 507",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "NY",
    "dropdelzpp": 115303500,
    "dropphyadd": "630 OLD COUNTRY RD UNIT 507",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "NY",
    "dropphyzpp": 115303500,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "NY",
    "dropmalzpp": 115309998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167461394,
    "dropfax": 5167460659
  },
  {
    "dcode": "D",
    "dropkey": "SV15792",
    "droptype": "D",
    "dropname": "ROSEBANK",
    "dropdeladd": "567 TOMPKINS AVE",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103059997,
    "dropphyadd": "567 TOMPKINS AVE",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103059997,
    "dropmaladd": "567 TOMPKINS AVE",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103059997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188732314,
    "dropfax": 7187278631
  },
  {
    "dcode": "D",
    "dropkey": "SV15795",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "14506 243RD ST",
    "dropdelcty": "ROSEDALE",
    "dropdelst": "NY",
    "dropdelzpp": 114229997,
    "dropphyadd": "14506 243RD ST",
    "dropphycty": "ROSEDALE",
    "dropphyst": "NY",
    "dropphyzpp": 114229997,
    "dropmaladd": "14506 243RD ST",
    "dropmalcty": "ROSEDALE",
    "dropmalst": "NY",
    "dropmalzpp": 114229997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185283078,
    "dropfax": 7189782672
  },
  {
    "dcode": "D",
    "dropkey": "SV15822",
    "droptype": "D",
    "dropname": "RUGBY",
    "dropdeladd": "726 UTICA AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112039997,
    "dropphyadd": "726 UTICA AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112039997,
    "dropmaladd": "726 UTICA AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112039997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472721735,
    "dropfax": 7187738542
  },
  {
    "dcode": "D",
    "dropkey": "SV15873",
    "droptype": "D",
    "dropname": "S U N Y",
    "dropdeladd": "1400 WASHINGTON AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122220100,
    "dropphyadd": "1400 WASHINGTON AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122220100,
    "dropmaladd": "1400 WASHINGTON AVE",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122220100,
    "dropsitphn": 5184621359,
    "dropsitlph": 5184621359,
    "dropsitcph": 5184621359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15893",
    "droptype": "D",
    "dropname": "SAINT ALBANS",
    "dropdeladd": "19504 LINDEN BLVD",
    "dropdelcty": "SAINT ALBANS",
    "dropdelst": "NY",
    "dropdelzpp": 114129997,
    "dropphyadd": "19504 LINDEN BLVD",
    "dropphycty": "SAINT ALBANS",
    "dropphyst": "NY",
    "dropphyzpp": 114129997,
    "dropmaladd": "19504 LINDEN BLVD",
    "dropmalcty": "SAINT ALBANS",
    "dropmalst": "NY",
    "dropmalzpp": 114129997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185255620,
    "dropfax": 7189782659
  },
  {
    "dcode": "D",
    "dropkey": "SV15895",
    "droptype": "D",
    "dropname": "SAINT GEORGE",
    "dropdeladd": "45 BAY ST STE 2",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103019997,
    "dropphyadd": "45 BAY ST STE 2",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103019997,
    "dropmaladd": "45 BAY ST STE 2",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103019997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7189812480,
    "dropfax": 7182738730
  },
  {
    "dcode": "D",
    "dropkey": "SV15899",
    "droptype": "D",
    "dropname": "MAJOR ROBERT OWENS",
    "dropdeladd": "1234 SAINT JOHNS PL",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112139997,
    "dropphyadd": "1234 SAINT JOHNS PL",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112139997,
    "dropmaladd": "1234 SAINT JOHNS PL",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112139997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 9172464504,
    "dropfax": 7189536534
  },
  {
    "dcode": "D",
    "dropkey": "SV15909",
    "droptype": "D",
    "dropname": "SALINA",
    "dropdeladd": "444 S SALINA ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132019900,
    "dropphyadd": "444 S SALINA ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132019900,
    "dropmaladd": "444 S SALINA ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132019900,
    "dropsitphn": 3154788849,
    "dropsitlph": 3154788849,
    "dropsitcph": 3154788849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV15953",
    "droptype": "D",
    "dropname": "SCARBOROUGH",
    "dropdeladd": "200 SCARBOROUGH STA RD",
    "dropdelcty": "BRIARCLIFF MANOR",
    "dropdelst": "NY",
    "dropdelzpp": 105102044,
    "dropphyadd": "200 SCARBOROUGH STA RD",
    "dropphycty": "BRIARCLIFF MANOR",
    "dropphyst": "NY",
    "dropphyzpp": 105102044,
    "dropmaladd": "1077 PLEASANTVILLE RD",
    "dropmalcty": "BRIARCLIFF MANOR",
    "dropmalst": "NY",
    "dropmalzpp": 105101623,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149416394,
    "dropsitcph": 9149416394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16156",
    "droptype": "D",
    "dropname": "SOUNDVIEW",
    "dropdeladd": "1687 GLEASON AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104729998,
    "dropphyadd": "1687 GLEASON AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104729998,
    "dropmaladd": "1687 GLEASON AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104729998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188939707,
    "dropsitcph": 7188939707,
    "dropfax": 7183280479
  },
  {
    "dcode": "D",
    "dropkey": "SV16158",
    "droptype": "D",
    "dropname": "YONKERS SOUTH",
    "dropdeladd": "335 S BROADWAY",
    "dropdelcty": "YONKERS",
    "dropdelst": "NY",
    "dropdelzpp": 107052023,
    "dropphyadd": "335 S BROADWAY",
    "dropphycty": "YONKERS",
    "dropphyst": "NY",
    "dropphyzpp": 107052023,
    "dropmaladd": "335 S BROADWAY",
    "dropmalcty": "YONKERS",
    "dropmalst": "NY",
    "dropmalzpp": 107052023,
    "dropsitphn": 9146974123,
    "dropsitlph": 9143753840,
    "dropsitcph": 9143753840,
    "dropfax": 9144234264
  },
  {
    "dcode": "D",
    "dropkey": "SV16211",
    "droptype": "D",
    "dropname": "SOUTH OZONE PARK",
    "dropdeladd": "12615 FOCH BLVD",
    "dropdelcty": "SOUTH OZONE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 114209997,
    "dropphyadd": "12615 FOCH BLVD",
    "dropphycty": "SOUTH OZONE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 114209997,
    "dropmaladd": "12615 FOCH BLVD",
    "dropmalcty": "SOUTH OZONE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 114209997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188359562,
    "dropfax": 7187386331
  },
  {
    "dcode": "D",
    "dropkey": "SV16217",
    "droptype": "D",
    "dropname": "SOUTH RICHMOND HILL",
    "dropdeladd": "11704 101ST AVE",
    "dropdelcty": "SOUTH RICHMOND HILL",
    "dropdelst": "NY",
    "dropdelzpp": 114199997,
    "dropphyadd": "11704 101ST AVE",
    "dropphycty": "SOUTH RICHMOND HILL",
    "dropphyst": "NY",
    "dropphyzpp": 114199997,
    "dropmaladd": "11704 101ST AVE",
    "dropmalcty": "SOUTH RICHMOND HILL",
    "dropmalst": "NY",
    "dropmalzpp": 114199997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188490694,
    "dropfax": 7188056415
  },
  {
    "dcode": "D",
    "dropkey": "SV16225",
    "droptype": "D",
    "dropname": "SOUTH SIDE BUFFALO",
    "dropdeladd": "2061 S PARK AVE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142209998,
    "dropphyadd": "2061 S PARK AVE",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142209998,
    "dropmaladd": "2061 S PARK AVE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142209998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168251700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16226",
    "droptype": "D",
    "dropname": "SOUTH SIDE ELMIRA",
    "dropdeladd": "418 S MAIN ST",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149049993,
    "dropphyadd": "418 S MAIN ST",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149049993,
    "dropmaladd": "418 S MAIN ST",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149049993,
    "dropsitphn": 7168462415,
    "dropsitlph": 6077346482,
    "dropsitcph": 6077346482,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16238",
    "droptype": "D",
    "dropname": "SOUTHVIEW",
    "dropdeladd": "1213 VESTAL AVE",
    "dropdelcty": "BINGHAMTON",
    "dropdelst": "NY",
    "dropdelzpp": 139039211,
    "dropphyadd": "1213 VESTAL AVE",
    "dropphycty": "BINGHAMTON",
    "dropphyst": "NY",
    "dropphyzpp": 139039211,
    "dropmaladd": "1213 VESTAL AVE",
    "dropmalcty": "BINGHAMTON",
    "dropmalst": "NY",
    "dropmalzpp": 139039211,
    "dropsitphn": 6077732142,
    "dropsitlph": 6077732142,
    "dropsitcph": 6077738679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16259",
    "droptype": "D",
    "dropname": "SPRING CREEK",
    "dropdeladd": "1310 PENNSYLVANIA AVE STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112399993,
    "dropphyadd": "1310 PENNSYLVANIA AVE STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112399993,
    "dropmaladd": "10201 FLATLANDS AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112369997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7188343048,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16268",
    "droptype": "D",
    "dropname": "SPRINGFIELD GARDENS",
    "dropdeladd": "21810 MERRICK BLVD",
    "dropdelcty": "SPRINGFIELD GARDENS",
    "dropdelst": "NY",
    "dropdelzpp": 114139997,
    "dropphyadd": "21810 MERRICK BLVD",
    "dropphycty": "SPRINGFIELD GARDENS",
    "dropphyst": "NY",
    "dropphyzpp": 114139997,
    "dropmaladd": "21810 MERRICK BLVD",
    "dropmalcty": "SPRINGFIELD GARDENS",
    "dropmalst": "NY",
    "dropmalzpp": 114139997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475483324,
    "dropfax": 7189782668
  },
  {
    "dcode": "D",
    "dropkey": "SV16280",
    "droptype": "D",
    "dropname": "SPUYTEN DUYVIL",
    "dropdeladd": "562 KAPPOCK ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104639993,
    "dropphyadd": "562 KAPPOCK ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104639993,
    "dropmaladd": "562 KAPPOCK ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104639993,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186017870,
    "dropsitcph": 7186017870,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16293",
    "droptype": "D",
    "dropname": "SANDFORD",
    "dropdeladd": "440 E SANDFORD BLVD",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "NY",
    "dropdelzpp": 105504752,
    "dropphyadd": "440 E SANDFORD BLVD",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "NY",
    "dropphyzpp": 105504752,
    "dropmaladd": "440 E SANDFORD BLVD",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "NY",
    "dropmalzpp": 105504752,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146994821,
    "dropsitcph": 9146994821,
    "dropfax": 9146997114
  },
  {
    "dcode": "D",
    "dropkey": "SV16343",
    "droptype": "D",
    "dropname": "STADIUM",
    "dropdeladd": "901 GERARD AVE FRNT 1",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104529992,
    "dropphyadd": "901 GERARD AVE FRNT 1",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104529992,
    "dropmaladd": "1315 INWOOD AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104529998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7182939007,
    "dropsitcph": 7182839007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16355",
    "droptype": "D",
    "dropname": "STAPLETON",
    "dropdeladd": "160 TOMPKINS AVE",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103049997,
    "dropphyadd": "160 TOMPKINS AVE",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103049997,
    "dropmaladd": "160 TOMPKINS AVE",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103049997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187277279,
    "dropfax": 7182738667
  },
  {
    "dcode": "D",
    "dropkey": "SV16373",
    "droptype": "D",
    "dropname": "STEINWAY",
    "dropdeladd": "4304 BROADWAY",
    "dropdelcty": "ASTORIA",
    "dropdelst": "NY",
    "dropdelzpp": 111039997,
    "dropphyadd": "4304 BROADWAY",
    "dropphycty": "ASTORIA",
    "dropphyst": "NY",
    "dropphyzpp": 111039997,
    "dropmaladd": "4304 BROADWAY",
    "dropmalcty": "ASTORIA",
    "dropmalst": "NY",
    "dropmalzpp": 111039997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475277123,
    "dropfax": 7182049067
  },
  {
    "dcode": "D",
    "dropkey": "SV16426",
    "droptype": "D",
    "dropname": "SHIRLEY A CHISHOLM",
    "dropdeladd": "1915 FULTON ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112339997,
    "dropphyadd": "1915 FULTON ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112339997,
    "dropmaladd": "1915 FULTON ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112339997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472941318,
    "dropfax": 7184674929
  },
  {
    "dcode": "D",
    "dropkey": "SV16443",
    "droptype": "D",
    "dropname": "SUNNYSIDE",
    "dropdeladd": "4515 44TH ST",
    "dropdelcty": "SUNNYSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 111049997,
    "dropphyadd": "4515 44TH ST",
    "dropphycty": "SUNNYSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 111049997,
    "dropmaladd": "4515 44TH ST",
    "dropmalcty": "SUNNYSIDE",
    "dropmalst": "NY",
    "dropmalzpp": 111049997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473963670,
    "dropfax": 7187868546
  },
  {
    "dcode": "D",
    "dropkey": "SV16444",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "6102 5TH AVE STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112209992,
    "dropphyadd": "6102 5TH AVE STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112209992,
    "dropmaladd": "6102 5TH AVE STE 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112209992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184390417,
    "dropfax": 7184398658
  },
  {
    "dcode": "D",
    "dropkey": "SV16487",
    "droptype": "D",
    "dropname": "TEALL",
    "dropdeladd": "226 TEALL AVE",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132179211,
    "dropphyadd": "226 TEALL AVE",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132179211,
    "dropmaladd": "226 TEALL AVE",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132179211,
    "dropsitphn": 3154722002,
    "dropsitlph": 3154722002,
    "dropsitcph": 3154722002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16516",
    "droptype": "D",
    "dropname": "THROGGS NECK",
    "dropdeladd": "3630 E TREMONT AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104659998,
    "dropphyadd": "3630 E TREMONT AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104659998,
    "dropmaladd": "3630 E TREMONT AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104659998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188223851,
    "dropsitcph": 7188223851,
    "dropfax": 7188220663
  },
  {
    "dcode": "D",
    "dropkey": "SV16519",
    "droptype": "D",
    "dropname": "THURSTON ROAD",
    "dropdeladd": "525 THURSTON RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146199998,
    "dropphyadd": "525 THURSTON RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146199998,
    "dropmaladd": "525 THURSTON RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146199998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5853287755,
    "dropsitcph": 5852475150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16531",
    "droptype": "D",
    "dropname": "TIMES SQUARE",
    "dropdeladd": "340 W 42ND ST FL 2",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100369998,
    "dropphyadd": "340 W 42ND ST FL 2",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100369998,
    "dropmaladd": "340 W 42ND ST FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100369998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125020424,
    "dropsitcph": 2125020424,
    "dropfax": 2125020458
  },
  {
    "dcode": "D",
    "dropkey": "SV16543",
    "droptype": "D",
    "dropname": "TOMPKINS SQUARE",
    "dropdeladd": "244 E 3RD ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100099991,
    "dropphyadd": "244 E 3RD ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100099991,
    "dropmaladd": "244 E 3RD ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100099991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126736415,
    "dropsitcph": 2126736415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16548",
    "droptype": "D",
    "dropname": "TOTTENVILLE",
    "dropdeladd": "228 MAIN ST",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103079997,
    "dropphyadd": "228 MAIN ST",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103079997,
    "dropmaladd": "228 MAIN ST",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103079997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7189841215,
    "dropfax": 7189845886
  },
  {
    "dcode": "D",
    "dropkey": "SV16556",
    "droptype": "D",
    "dropname": "TRAINSMEADOW",
    "dropdeladd": "7577 31ST AVE",
    "dropdelcty": "EAST ELMHURST",
    "dropdelst": "NY",
    "dropdelzpp": 113709993,
    "dropphyadd": "7577 31ST AVE",
    "dropphycty": "EAST ELMHURST",
    "dropphyst": "NY",
    "dropphyzpp": 113709993,
    "dropmaladd": "7577 31ST AVE",
    "dropmalcty": "EAST ELMHURST",
    "dropmalst": "NY",
    "dropmalzpp": 113709993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184575562,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "SV16560",
    "droptype": "D",
    "dropname": "TREMONT",
    "dropdeladd": "575 E TREMONT AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104579998,
    "dropphyadd": "575 E TREMONT AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104579998,
    "dropmaladd": "575 E TREMONT AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104579998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7182990847,
    "dropsitcph": 7182990847,
    "dropfax": 7182993545
  },
  {
    "dcode": "D",
    "dropkey": "SV16597",
    "droptype": "D",
    "dropname": "U S C C",
    "dropdeladd": "745 BREWERTON RD",
    "dropdelcty": "WEST POINT",
    "dropdelst": "NY",
    "dropdelzpp": 109961602,
    "dropphyadd": "745 BREWERTON RD",
    "dropphycty": "WEST POINT",
    "dropphyst": "NY",
    "dropphyzpp": 109961602,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WEST POINT",
    "dropmalst": "NY",
    "dropmalzpp": 109979998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454468750,
    "dropsitcph": 8454468750,
    "dropfax": 8454466792
  },
  {
    "dcode": "D",
    "dropkey": "SV16619",
    "droptype": "D",
    "dropname": "SYRACUSE UNIVERSITY",
    "dropdeladd": "720 UNIVERSITY AVE",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132359211,
    "dropphyadd": "720 UNIVERSITY AVE",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132359211,
    "dropmaladd": "720 UNIVERSITY AVE",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132359211,
    "dropsitphn": 3154720278,
    "dropsitlph": 5184720278,
    "dropsitcph": 3154720278,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16622",
    "droptype": "D",
    "dropname": "UNIVERSITY HEIGHTS",
    "dropdeladd": "1541 SHAKESPEARE AVE FRNT 1",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104529993,
    "dropphyadd": "1541 SHAKESPEARE AVE FRNT 1",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104529993,
    "dropmaladd": "1315 INWOOD AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104529998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7182949776,
    "dropsitcph": 7182949776,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16636",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "50 MAIN ST",
    "dropdelcty": "KINGSTON",
    "dropdelst": "NY",
    "dropdelzpp": 124013851,
    "dropphyadd": "50 MAIN ST",
    "dropphycty": "KINGSTON",
    "dropphyst": "NY",
    "dropphyzpp": 124013851,
    "dropmaladd": "50 MAIN ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "NY",
    "dropmalzpp": 124013851,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453312305,
    "dropsitcph": 8453312305,
    "dropfax": 8453316426
  },
  {
    "dcode": "D",
    "dropkey": "SV16645",
    "droptype": "D",
    "dropname": "UTOPIA",
    "dropdeladd": "18204 UNION TPKE",
    "dropdelcty": "FRESH MEADOWS",
    "dropdelst": "NY",
    "dropdelzpp": 113669993,
    "dropphyadd": "18204 UNION TPKE",
    "dropphycty": "FRESH MEADOWS",
    "dropphyst": "NY",
    "dropphyzpp": 113669993,
    "dropmaladd": "18204 UNION TPKE",
    "dropmalcty": "FRESH MEADOWS",
    "dropmalst": "NY",
    "dropmalzpp": 113669993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7189694986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16660",
    "droptype": "D",
    "dropname": "VAN BRUNT",
    "dropdeladd": "275 9TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112159997,
    "dropphyadd": "275 9TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112159997,
    "dropmaladd": "275 9TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112159997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187685630,
    "dropfax": 7187883087
  },
  {
    "dcode": "D",
    "dropkey": "SV16665",
    "droptype": "D",
    "dropname": "VAN COTT",
    "dropdeladd": "3102 DECATUR AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104679993,
    "dropphyadd": "3102 DECATUR AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104679993,
    "dropmaladd": "711 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104679998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186548149,
    "dropsitcph": 7186548149,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16671",
    "droptype": "D",
    "dropname": "VAN NEST",
    "dropdeladd": "715 MORRIS PARK AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104629993,
    "dropphyadd": "715 MORRIS PARK AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104629993,
    "dropmaladd": "715 MORRIS PARK AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104629993,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188295470,
    "dropsitcph": 7188295470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16672",
    "droptype": "D",
    "dropname": "VANDERVEER",
    "dropdeladd": "2319 NOSTRAND AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112109997,
    "dropphyadd": "2319 NOSTRAND AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112109997,
    "dropmaladd": "2319 NOSTRAND AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112109997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183778139,
    "dropfax": 7182523493
  },
  {
    "dcode": "D",
    "dropkey": "SV16703",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "201 VARICK ST FRNT 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100149998,
    "dropphyadd": "201 VARICK ST FRNT 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100149998,
    "dropmaladd": "201 VARICK ST FRNT 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100149998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126450327,
    "dropsitcph": 2126450327,
    "dropfax": 2122420976
  },
  {
    "dcode": "D",
    "dropkey": "SV16774",
    "droptype": "D",
    "dropname": "WAKEFIELD",
    "dropdeladd": "4165 WHITE PLAINS RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104669998,
    "dropphyadd": "4165 WHITE PLAINS RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104669998,
    "dropmaladd": "4165 WHITE PLAINS RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104669998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7186544283,
    "dropsitcph": 7186544283,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16888",
    "droptype": "D",
    "dropname": "WEST FARMS",
    "dropdeladd": "362 DEVOE AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104609998,
    "dropphyadd": "362 DEVOE AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104609998,
    "dropmaladd": "362 DEVOE AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104609998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188231245,
    "dropsitcph": 7188231245,
    "dropfax": 7185978949
  },
  {
    "dcode": "D",
    "dropkey": "SV16919",
    "droptype": "D",
    "dropname": "WEST NEW BRIGHTON",
    "dropdeladd": "1015 CASTLETON AVE",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103109997,
    "dropphyadd": "1015 CASTLETON AVE",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103109997,
    "dropmaladd": "1015 CASTLETON AVE",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103109997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188732411,
    "dropfax": 7184424051
  },
  {
    "dcode": "D",
    "dropkey": "SV16922",
    "droptype": "D",
    "dropname": "WEST NEWBURGH",
    "dropdeladd": "467 BROADWAY",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 125505345,
    "dropphyadd": "467 BROADWAY",
    "dropphycty": "NEWBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 125505345,
    "dropmaladd": "467 BROADWAY",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 125505345,
    "dropsitphn": 9146974123,
    "dropsitlph": 8455615864,
    "dropsitcph": 8455615864,
    "dropfax": 8455610622
  },
  {
    "dcode": "D",
    "dropkey": "SV16933",
    "droptype": "D",
    "dropname": "WEST RIDGE",
    "dropdeladd": "1857 DEWEY AVE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146159998,
    "dropphyadd": "1857 DEWEY AVE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146159998,
    "dropmaladd": "1857 DEWEY AVE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146159998,
    "dropsitphn": 7168462415,
    "dropsitlph": 5858659019,
    "dropsitcph": 5858659019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16945",
    "droptype": "D",
    "dropname": "WEST SIDE BUFFALO",
    "dropdeladd": "465 GRANT ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142139998,
    "dropphyadd": "465 GRANT ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142139998,
    "dropmaladd": "465 GRANT ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142139998,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168838032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV16964",
    "droptype": "D",
    "dropname": "WESTCHESTER",
    "dropdeladd": "2619 PONTON AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104619998,
    "dropphyadd": "2619 PONTON AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104619998,
    "dropmaladd": "2619 PONTON AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104619998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188239539,
    "dropsitcph": 7188239539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV17019",
    "droptype": "D",
    "dropname": "WHITESTONE",
    "dropdeladd": "1444 150TH ST",
    "dropdelcty": "WHITESTONE",
    "dropdelst": "NY",
    "dropdelzpp": 113579997,
    "dropphyadd": "1444 150TH ST",
    "dropphycty": "WHITESTONE",
    "dropphyst": "NY",
    "dropphyzpp": 113579997,
    "dropmaladd": "1444 150TH ST",
    "dropmalcty": "WHITESTONE",
    "dropmalst": "NY",
    "dropmalzpp": 113579997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187679245,
    "dropfax": 7187471088
  },
  {
    "dcode": "D",
    "dropkey": "SV17036",
    "droptype": "D",
    "dropname": "WILLIAMSBRIDGE",
    "dropdeladd": "711 E GUN HILL RD",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104679998,
    "dropphyadd": "711 E GUN HILL RD",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104679998,
    "dropmaladd": "711 E GUN HILL RD",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104679998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7188827291,
    "dropsitcph": 7188827291,
    "dropfax": 7188811318
  },
  {
    "dcode": "D",
    "dropkey": "SV17037",
    "droptype": "D",
    "dropname": "WILLIAMSBURG",
    "dropdeladd": "263 S 4TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112119997,
    "dropphyadd": "263 S 4TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112119997,
    "dropmaladd": "263 S 4TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112119997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 9172464128,
    "dropfax": 9172464147
  },
  {
    "dcode": "D",
    "dropkey": "SV17079",
    "droptype": "D",
    "dropname": "WOODHAVEN",
    "dropdeladd": "8642 FOREST PKWY",
    "dropdelcty": "WOODHAVEN",
    "dropdelst": "NY",
    "dropdelzpp": 114219997,
    "dropphyadd": "8642 FOREST PKWY",
    "dropphycty": "WOODHAVEN",
    "dropphyst": "NY",
    "dropphyzpp": 114219997,
    "dropmaladd": "8642 FOREST PKWY",
    "dropmalcty": "WOODHAVEN",
    "dropmalst": "NY",
    "dropmalzpp": 114219997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182960891,
    "dropfax": 7182968629
  },
  {
    "dcode": "D",
    "dropkey": "SV17083",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "4364 KATONAH AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104709998,
    "dropphyadd": "4364 KATONAH AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104709998,
    "dropmaladd": "4364 KATONAH AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104709998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7183243838,
    "dropsitcph": 7183243838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV17090",
    "droptype": "D",
    "dropname": "WOODSIDE",
    "dropdeladd": "3925 61ST ST",
    "dropdelcty": "WOODSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 113779997,
    "dropphyadd": "3925 61ST ST",
    "dropphycty": "WOODSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 113779997,
    "dropmaladd": "3925 61ST ST",
    "dropmalcty": "WOODSIDE",
    "dropmalst": "NY",
    "dropmalzpp": 113779997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188038529,
    "dropfax": 7184296559
  },
  {
    "dcode": "D",
    "dropkey": "SV17096",
    "droptype": "D",
    "dropname": "WOOLSEY",
    "dropdeladd": "2268 31ST ST",
    "dropdelcty": "LONG ISLAND CITY",
    "dropdelst": "NY",
    "dropdelzpp": 111059997,
    "dropphyadd": "2268 31ST ST",
    "dropphycty": "LONG ISLAND CITY",
    "dropphyst": "NY",
    "dropphyzpp": 111059997,
    "dropmaladd": "2268 31ST ST",
    "dropmalcty": "LONG ISLAND CITY",
    "dropmalst": "NY",
    "dropmalzpp": 111059997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182747396,
    "dropfax": 7183215975
  },
  {
    "dcode": "D",
    "dropkey": "SV17107",
    "droptype": "D",
    "dropname": "WYCKOFF HEIGHTS",
    "dropdeladd": "86 WYCKOFF AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112379997,
    "dropphyadd": "86 WYCKOFF AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112379997,
    "dropmaladd": "86 WYCKOFF AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112379997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183863629,
    "dropfax": 7183863010
  },
  {
    "dcode": "D",
    "dropkey": "SV17109",
    "droptype": "D",
    "dropname": "WYKAGYL",
    "dropdeladd": "3 QUAKER RIDGE RD",
    "dropdelcty": "NEW ROCHELLE",
    "dropdelst": "NY",
    "dropdelzpp": 108042807,
    "dropphyadd": "3 QUAKER RIDGE RD",
    "dropphycty": "NEW ROCHELLE",
    "dropphyst": "NY",
    "dropphyzpp": 108042807,
    "dropmaladd": "3 QUAKER RIDGE RD",
    "dropmalcty": "NEW ROCHELLE",
    "dropmalst": "NY",
    "dropmalzpp": 108042807,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146327667,
    "dropsitcph": 9146327667,
    "dropfax": 9145760523
  },
  {
    "dcode": "D",
    "dropkey": "SV17125",
    "droptype": "D",
    "dropname": "YORKVILLE",
    "dropdeladd": "1617 3RD AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 101289991,
    "dropphyadd": "1617 3RD AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 101289991,
    "dropmaladd": "229 E 85TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100289998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123692747,
    "dropsitcph": 2123692230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV17150",
    "droptype": "D",
    "dropname": "BARRIO OBRERO",
    "dropdeladd": "100 CALLE BELLA VIS",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009159997",
    "dropphyadd": "100 CALLE BELLA VIS",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009159997",
    "dropmaladd": "1959 CALLE LOIZA LBBY",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009119998",
    "dropsitphn": 7877672797,
    "dropsitlph": 7877673029,
    "dropsitcph": 7877265330,
    "dropfax": 7872686545
  },
  {
    "dcode": "D",
    "dropkey": "SV17186",
    "droptype": "D",
    "dropname": "FERNANDEZ JUNCOS",
    "dropdeladd": "1498 AVE FERNANDEZ JUNCOS",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009099998",
    "dropphyadd": "1498 AVE FERNANDEZ JUNCOS",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009099998",
    "dropmaladd": "1959 CALLE LOIZA LBBY",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009119998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877272452,
    "dropfax": 7872686545
  },
  {
    "dcode": "D",
    "dropkey": "SV17200",
    "droptype": "D",
    "dropname": "HATO REY",
    "dropdeladd": "361 CALLE JUAN CALAF",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009189998",
    "dropphyadd": "361 CALLE JUAN CALAF",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009189998",
    "dropmaladd": "361 CALLE JUAN CALAF",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009189998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877541273,
    "dropfax": 7877675072
  },
  {
    "dcode": "D",
    "dropkey": "SV17222",
    "droptype": "D",
    "dropname": "LOIZA STREET",
    "dropdeladd": "1959 CALLE LOIZA LBBY",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009119998",
    "dropphyadd": "1959 CALLE LOIZA LBBY",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009119998",
    "dropmaladd": "1959 CALLE LOIZA LBBY",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009119998",
    "dropsitphn": 7877672797,
    "dropsitlph": 7877673029,
    "dropsitcph": 7877272452,
    "dropfax": 7872686545
  },
  {
    "dcode": "D",
    "dropkey": "SV17230",
    "droptype": "D",
    "dropname": "MINILLAS CENTER",
    "dropdeladd": "100 CENTRO GUBERNAMENTAL",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009409997",
    "dropphyadd": "100 CENTRO GUBERNAMENTAL",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009409997",
    "dropmaladd": "1959 CALLE LOIZA LBBY",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009119998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877268008,
    "dropfax": 7877236366
  },
  {
    "dcode": "D",
    "dropkey": "SV17238",
    "droptype": "D",
    "dropname": "OLD SAN JUAN",
    "dropdeladd": "100 PASEO DE COLON STE 1",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009019998",
    "dropphyadd": "100 PASEO DE COLON STE 1",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009019998",
    "dropmaladd": "100 PASEO DE COLON STE 1",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009019998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877242098,
    "dropfax": 7877242185
  },
  {
    "dcode": "D",
    "dropkey": "SV17245",
    "droptype": "D",
    "dropname": "PLAZA LAS AMERICAS",
    "dropdeladd": "525 AVE FD ROOSEVELT STE 111",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009189997",
    "dropphyadd": "525 AVE FD ROOSEVELT STE 111",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009189997",
    "dropmaladd": "525 AVE FD ROOSEVELT STE 111",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009189997",
    "dropsitphn": 7877672567,
    "dropsitlph": 7877672797,
    "dropsitcph": 7872826331,
    "dropfax": 7872826362
  },
  {
    "dcode": "D",
    "dropkey": "SV17250",
    "droptype": "D",
    "dropname": "PUERTA DE TIERRA",
    "dropdeladd": "163 AVE FERNANDEZ JUNCOS STE 2",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009019997",
    "dropphyadd": "163 AVE FERNANDEZ JUNCOS STE 2",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009019997",
    "dropmaladd": "163 AVE FERNANDEZ JUNCOS STE 2",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009019997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877224134,
    "dropfax": 7877228520
  },
  {
    "dcode": "D",
    "dropkey": "SV17257",
    "droptype": "D",
    "dropname": "RAMEY",
    "dropdeladd": "100 AVE BORINQUEN",
    "dropdelcty": "AGUADILLA",
    "dropdelst": "PR",
    "dropdelzpp": "006039996",
    "dropphyadd": "100 AVE BORINQUEN",
    "dropphycty": "AGUADILLA",
    "dropphyst": "PR",
    "dropphyzpp": "006039996",
    "dropmaladd": "100 AVE BORINQUEN",
    "dropmalcty": "AGUADILLA",
    "dropmalst": "PR",
    "dropmalzpp": "006039996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878905383,
    "dropfax": 7878905383
  },
  {
    "dcode": "D",
    "dropkey": "SV17262",
    "droptype": "D",
    "dropname": "RIO PIEDRAS",
    "dropdeladd": "112 CALLE ARZUAGA STE 1",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009259998",
    "dropphyadd": "112 CALLE ARZUAGA STE 1",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009259998",
    "dropmaladd": "100 CALLE ALONDRA",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009249998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877676394,
    "dropfax": 7877542673
  },
  {
    "dcode": "D",
    "dropkey": "SV17281",
    "droptype": "D",
    "dropname": "SANTURCE",
    "dropdeladd": "800 AVE PONCE DE LEON STE A",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009079998",
    "dropphyadd": "800 AVE PONCE DE LEON STE A",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009079998",
    "dropmaladd": "1959 CALLE LOIZA LBBY",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009119998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877278304,
    "dropfax": 7877222811
  },
  {
    "dcode": "D",
    "dropkey": "SV17283",
    "droptype": "D",
    "dropname": "65TH INFANTRY",
    "dropdeladd": "100 CALLE ALONDRA",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009249998",
    "dropphyadd": "100 CALLE ALONDRA",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009249998",
    "dropmaladd": "100 CALLE ALONDRA",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009249998",
    "dropsitphn": 7877541873,
    "dropsitlph": 7877673029,
    "dropsitcph": 7877624690,
    "dropfax": 7872768040
  },
  {
    "dcode": "D",
    "dropkey": "SV17294",
    "droptype": "D",
    "dropname": "VICTORIA",
    "dropdeladd": "68 CALLE RAMON E BETANCES",
    "dropdelcty": "AGUADILLA",
    "dropdelst": "PR",
    "dropdelzpp": "006039997",
    "dropphyadd": "68 CALLE RAMON E BETANCES",
    "dropphycty": "AGUADILLA",
    "dropphyst": "PR",
    "dropphyzpp": "006039997",
    "dropmaladd": "68 CALLE RAMON E BETANCES",
    "dropmalcty": "AGUADILLA",
    "dropmalst": "PR",
    "dropmalzpp": "006039997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878824535,
    "dropfax": 7879971375
  },
  {
    "dcode": "D",
    "dropkey": "SV17312",
    "droptype": "D",
    "dropname": "VETERANS ANNEX",
    "dropdeladd": "6500 VETERANS DR",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029992",
    "dropphyadd": "6500 VETERANS DR",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029992",
    "dropmaladd": "6500 VETERANS DR",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029992",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407741950,
    "dropfax": 3407741951
  },
  {
    "dcode": "D",
    "dropkey": "SV18853",
    "droptype": "D",
    "dropname": "CUPEY",
    "dropdeladd": "369 CALLE SAN CLAUDIO FRNT",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009269998",
    "dropphyadd": "369 CALLE SAN CLAUDIO FRNT",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009269998",
    "dropmaladd": "369 CALLE SAN CLAUDIO FRNT",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009269998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877482888,
    "dropfax": 7877604645
  },
  {
    "dcode": "D",
    "dropkey": "SV18864",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "3000 AVE SALVADOR V CARO STE 3032",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009796607",
    "dropphyadd": "3000 AVE SALVADOR V CARO STE 3032",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009796607",
    "dropmaladd": "3000 AVE SALVADOR V CARO STE 3032",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009799997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221795,
    "dropsitcph": 7877322461,
    "dropfax": 7872532711
  },
  {
    "dcode": "D",
    "dropkey": "SV19072",
    "droptype": "D",
    "dropname": "RXR PLAZA",
    "dropdeladd": "100 RXR PLZ",
    "dropdelcty": "UNIONDALE",
    "dropdelst": "NY",
    "dropdelzpp": 115563848,
    "dropphyadd": "100 RXR PLZ",
    "dropphycty": "UNIONDALE",
    "dropphyst": "NY",
    "dropphyzpp": 115563848,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "UNIONDALE",
    "dropmalst": "NY",
    "dropmalzpp": 115539998,
    "dropsitphn": 5167552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5167942053,
    "dropfax": 5167942053
  },
  {
    "dcode": "D",
    "dropkey": "SV19223",
    "droptype": "D",
    "dropname": "PITT",
    "dropdeladd": "185 CLINTON ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100029991,
    "dropphyadd": "185 CLINTON ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100029991,
    "dropmaladd": "185 CLINTON ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100029991,
    "dropsitphn": 2122270089,
    "dropsitlph": 2122549270,
    "dropsitcph": 2122549270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19261",
    "droptype": "D",
    "dropname": "SYRACUSE CARRIER",
    "dropdeladd": "5640 E TAFT RD",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132209250,
    "dropphyadd": "5640 E TAFT RD",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132209250,
    "dropmaladd": "5640 E TAFT RD",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132209250,
    "dropsitphn": 3154523416,
    "dropsitlph": 5184523416,
    "dropsitcph": 3154523416,
    "dropfax": 3154523453
  },
  {
    "dcode": "D",
    "dropkey": "SV19324",
    "droptype": "D",
    "dropname": "NORTH",
    "dropdeladd": "243 BROADWAY",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071049991",
    "dropphyadd": "243 BROADWAY",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071049991",
    "dropmaladd": "243 BROADWAY",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071049991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9734852694,
    "dropsitcph": 9734852694,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19391",
    "droptype": "D",
    "dropname": "MURRAY HILL",
    "dropdeladd": "115 E 34TH ST FRNT 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100169991,
    "dropphyadd": "115 E 34TH ST FRNT 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100169991,
    "dropmaladd": "115 E 34TH ST FRNT 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100169991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126790730,
    "dropsitcph": 2126790730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19393",
    "droptype": "D",
    "dropname": "MEMORIAL",
    "dropdeladd": "128 WATCHUNG AVE STE 2",
    "dropdelcty": "MONTCLAIR",
    "dropdelst": "NJ",
    "dropdelzpp": "070439991",
    "dropphyadd": "128 WATCHUNG AVE STE 2",
    "dropphycty": "MONTCLAIR",
    "dropphyst": "NJ",
    "dropphyzpp": "070439991",
    "dropmaladd": "128 WATCHUNG AVE STE 2",
    "dropmalcty": "MONTCLAIR",
    "dropmalst": "NJ",
    "dropmalzpp": "070439991",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736550172,
    "dropsitcph": 9736550172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19582",
    "droptype": "D",
    "dropname": "MALTA",
    "dropdeladd": "12 HEMPHILL PL",
    "dropdelcty": "BALLSTON SPA",
    "dropdelst": "NY",
    "dropdelzpp": 120209997,
    "dropphyadd": "12 HEMPHILL PL",
    "dropphycty": "BALLSTON SPA",
    "dropphyst": "NY",
    "dropphyzpp": 120209997,
    "dropmaladd": "12 HEMPHILL PL",
    "dropmalcty": "BALLSTON SPA",
    "dropmalst": "NY",
    "dropmalzpp": 120209997,
    "dropsitphn": 5188996254,
    "dropsitlph": 5188996254,
    "dropsitcph": 5188996254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19727",
    "droptype": "D",
    "dropname": "BERGEN POINT",
    "dropdeladd": "195 BROADWAY STE 2",
    "dropdelcty": "BAYONNE",
    "dropdelst": "NJ",
    "dropdelzpp": "070029992",
    "dropphyadd": "195 BROADWAY STE 2",
    "dropphycty": "BAYONNE",
    "dropphyst": "NJ",
    "dropphyzpp": "070029992",
    "dropmaladd": "195 BROADWAY STE 2",
    "dropmalcty": "BAYONNE",
    "dropmalst": "NJ",
    "dropmalzpp": "070029992",
    "dropsitphn": 2019559705,
    "dropsitlph": 2013390207,
    "dropsitcph": 2013390207,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV19801",
    "droptype": "D",
    "dropname": "BRIARWOOD",
    "dropdeladd": "13869 QUEENS BLVD",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114359996,
    "dropphyadd": "13869 QUEENS BLVD",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114359996,
    "dropmaladd": "13869 QUEENS BLVD",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114359996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7185262178,
    "dropfax": 7185262875
  },
  {
    "dcode": "D",
    "dropkey": "SV19843",
    "droptype": "D",
    "dropname": "PAMPANOS",
    "dropdeladd": "2340 AVE EDUARDO RUBERTE",
    "dropdelcty": "PONCE",
    "dropdelst": "PR",
    "dropdelzpp": "007179998",
    "dropphyadd": "2340 AVE EDUARDO RUBERTE",
    "dropphycty": "PONCE",
    "dropphyst": "PR",
    "dropphyzpp": "007179997",
    "dropmaladd": "2340 AVE EDUARDO RUBERTE",
    "dropmalcty": "PONCE",
    "dropmalst": "PR",
    "dropmalzpp": "007179998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878431000,
    "dropfax": 7872598515
  },
  {
    "dcode": "D",
    "dropkey": "SV19847",
    "droptype": "D",
    "dropname": "ARECIBO PUEBLO",
    "dropdeladd": "442 AVE JUAN ROSADO STE 1",
    "dropdelcty": "ARECIBO",
    "dropdelst": "PR",
    "dropdelzpp": "006121997",
    "dropphyadd": "442 AVE JUAN ROSADO STE 1",
    "dropphycty": "ARECIBO",
    "dropphyst": "PR",
    "dropphyzpp": "006121997",
    "dropmaladd": "442 AVE JUAN ROSADO STE 1",
    "dropmalcty": "ARECIBO",
    "dropmalst": "PR",
    "dropmalzpp": "006121997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878788772,
    "dropfax": 7878781665
  },
  {
    "dcode": "D",
    "dropkey": "SV19848",
    "droptype": "D",
    "dropname": "COTTO",
    "dropdeladd": "22 CALLE CENTRO COMERCIAL",
    "dropdelcty": "ARECIBO",
    "dropdelst": "PR",
    "dropdelzpp": "006129996",
    "dropphyadd": "22 CALLE CENTRO COMERCIAL",
    "dropphycty": "ARECIBO",
    "dropphyst": "PR",
    "dropphyzpp": "006129996",
    "dropmaladd": "10 AVE SAN PATRICIO",
    "dropmalcty": "ARECIBO",
    "dropmalst": "PR",
    "dropmalzpp": "006129998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7878800094,
    "dropfax": 7878781665
  },
  {
    "dcode": "D",
    "dropkey": "SV19853",
    "droptype": "D",
    "dropname": "NORTH",
    "dropdeladd": "555 CALLE EXT MUNOZ RIVERA STE 1",
    "dropdelcty": "CAGUAS",
    "dropdelst": "PR",
    "dropdelzpp": "007254361",
    "dropphyadd": "555 CALLE EXT MUNOZ RIVERA STE 1",
    "dropphycty": "CAGUAS",
    "dropphyst": "PR",
    "dropphyzpp": "007254361",
    "dropmaladd": "555 CALLE EXT MUNOZ RIVERA STE 1",
    "dropmalcty": "CAGUAS",
    "dropmalst": "PR",
    "dropmalzpp": "007254361",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877434100,
    "dropfax": 7872581675
  },
  {
    "dcode": "D",
    "dropkey": "SV19855",
    "droptype": "D",
    "dropname": "MARINA",
    "dropdeladd": "270 CALLE DE LA CANDELARIA",
    "dropdelcty": "MAYAGUEZ",
    "dropdelst": "PR",
    "dropdelzpp": "006829996",
    "dropphyadd": "270 CALLE DE LA CANDELARIA",
    "dropphycty": "MAYAGUEZ",
    "dropphyst": "PR",
    "dropphyzpp": "006829996",
    "dropmaladd": "270 CALLE DE LA CANDELARIA",
    "dropmalcty": "MAYAGUEZ",
    "dropmalst": "PR",
    "dropmalzpp": "006829996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7878050445,
    "dropfax": 7878055625
  },
  {
    "dcode": "D",
    "dropkey": "SV19858",
    "droptype": "D",
    "dropname": "UPR RIO PIEDRAS",
    "dropdeladd": "100 CENTRO DE ESTUDIANTES",
    "dropdelcty": "SAN JUAN",
    "dropdelst": "PR",
    "dropdelzpp": "009259997",
    "dropphyadd": "100 CENTRO DE ESTUDIANTES",
    "dropphycty": "SAN JUAN",
    "dropphyst": "PR",
    "dropphyzpp": "009259997",
    "dropmaladd": "100 CENTRO DE ESTUDIANTES",
    "dropmalcty": "SAN JUAN",
    "dropmalst": "PR",
    "dropmalzpp": "009259997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877516388,
    "dropfax": 7877662217
  },
  {
    "dcode": "D",
    "dropkey": "SV19860",
    "droptype": "D",
    "dropname": "PLAZA CAROLINA",
    "dropdeladd": "200 AVE FRAGOSO STE 322",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009839997",
    "dropphyadd": "200 AVE FRAGOSO STE 322",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009839997",
    "dropmaladd": "1000 AVE SANCHEZ OSORIO",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009839998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877628842,
    "dropfax": 7872576350
  },
  {
    "dcode": "D",
    "dropkey": "SV19861",
    "droptype": "D",
    "dropname": "CAROLINA PUEBLO",
    "dropdeladd": "108 CALLE MUNOZ RIVERA S",
    "dropdelcty": "CAROLINA",
    "dropdelst": "PR",
    "dropdelzpp": "009859997",
    "dropphyadd": "108 CALLE MUNOZ RIVERA S",
    "dropphycty": "CAROLINA",
    "dropphyst": "PR",
    "dropphyzpp": "009859997",
    "dropmaladd": "1000 AVE SANCHEZ OSORIO",
    "dropmalcty": "CAROLINA",
    "dropmalst": "PR",
    "dropmalzpp": "009839998",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221644,
    "dropsitcph": 7877695423,
    "dropfax": 7877760120
  },
  {
    "dcode": "D",
    "dropkey": "SV19862",
    "droptype": "D",
    "dropname": "DOWNTOWN",
    "dropdeladd": "2119 MARKET SQ",
    "dropdelcty": "CHRISTIANSTED",
    "dropdelst": "VI",
    "dropdelzpp": "008209996",
    "dropphyadd": "2119 MARKET SQ",
    "dropphycty": "CHRISTIANSTED",
    "dropphyst": "VI",
    "dropphyzpp": "008209996",
    "dropmaladd": "2119 MARKET SQ",
    "dropmalcty": "CHRISTIANSTED",
    "dropmalst": "VI",
    "dropmalzpp": "008209996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 3407733586,
    "dropfax": 3407739426
  },
  {
    "dcode": "D",
    "dropkey": "SV19863",
    "droptype": "D",
    "dropname": "SUNNY ISLE",
    "dropdeladd": "4500 SUNNY ISLE STE 53",
    "dropdelcty": "CHRISTIANSTED",
    "dropdelst": "VI",
    "dropdelzpp": "008209997",
    "dropphyadd": "4500 SUNNY ISLE STE 53",
    "dropphycty": "CHRISTIANSTED",
    "dropphyst": "VI",
    "dropphyzpp": "008209997",
    "dropmaladd": "4500 SUNNY ISLE STE 53",
    "dropmalcty": "CHRISTIANSTED",
    "dropmalst": "VI",
    "dropmalzpp": "008209997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407786805,
    "dropfax": 3407789443
  },
  {
    "dcode": "D",
    "dropkey": "SV19864",
    "droptype": "D",
    "dropname": "GALLOWS BAY",
    "dropdeladd": "5027 ANCHOR WAY STE 1",
    "dropdelcty": "CHRISTIANSTED",
    "dropdelst": "VI",
    "dropdelzpp": "008209995",
    "dropphyadd": "5027 ANCHOR WAY STE 1",
    "dropphycty": "CHRISTIANSTED",
    "dropphyst": "VI",
    "dropphyzpp": "008209995",
    "dropmaladd": "5027 ANCHOR WAY STE 1",
    "dropmalcty": "CHRISTIANSTED",
    "dropmalst": "VI",
    "dropmalzpp": "008209995",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407734538,
    "dropfax": 3406929860
  },
  {
    "dcode": "D",
    "dropkey": "SV19865",
    "droptype": "D",
    "dropname": "EMANCIPATION GARDENS",
    "dropdeladd": "5046 NORRE GADE",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029995",
    "dropphyadd": "5046 NORRE GADE",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029995",
    "dropmaladd": "5046 NORRE GADE",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029995",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407743750,
    "dropfax": 3407749155
  },
  {
    "dcode": "D",
    "dropkey": "SV19866",
    "droptype": "D",
    "dropname": "EAST END",
    "dropdeladd": "4605 TUTU PARK MALL STE 179",
    "dropdelcty": "ST THOMAS",
    "dropdelst": "VI",
    "dropdelzpp": "008029993",
    "dropphyadd": "4605 TUTU PARK MALL STE 179",
    "dropphycty": "ST THOMAS",
    "dropphyst": "VI",
    "dropphyzpp": "008029993",
    "dropmaladd": "4605 TUTU PARK MALL STE 179",
    "dropmalcty": "ST THOMAS",
    "dropmalst": "VI",
    "dropmalzpp": "008029993",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 3407757354,
    "dropfax": 3407757305
  },
  {
    "dcode": "D",
    "dropkey": "SV19921",
    "droptype": "D",
    "dropname": "ELMSFORD ANNEX",
    "dropdeladd": "150 CLEARBROOK RD STE 124",
    "dropdelcty": "ELMSFORD",
    "dropdelst": "NY",
    "dropdelzpp": 105239998,
    "dropphyadd": "150 CLEARBROOK RD STE 124",
    "dropphycty": "ELMSFORD",
    "dropphyst": "NY",
    "dropphyzpp": 105239998,
    "dropmaladd": "150 CLEARBROOK RD STE 124",
    "dropmalcty": "ELMSFORD",
    "dropmalst": "NY",
    "dropmalzpp": 105239998,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145926703,
    "dropsitcph": 9145926703,
    "dropfax": 9143472282
  },
  {
    "dcode": "D",
    "dropkey": "SV19967",
    "droptype": "D",
    "dropname": "HOLIDAY CITY",
    "dropdeladd": "730 JAMAICA BLVD STE 23",
    "dropdelcty": "TOMS RIVER",
    "dropdelst": "NJ",
    "dropdelzpp": "087579997",
    "dropphyadd": "730 JAMAICA BLVD STE 23",
    "dropphycty": "TOMS RIVER",
    "dropphyst": "NJ",
    "dropphyzpp": "087579997",
    "dropmaladd": "730 JAMAICA BLVD STE 23",
    "dropmalcty": "TOMS RIVER",
    "dropmalst": "NJ",
    "dropmalzpp": "087579997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7323490710,
    "dropfax": 7324730865
  },
  {
    "dcode": "D",
    "dropkey": "SV19968",
    "droptype": "D",
    "dropname": "FRANKLIN SQUARE",
    "dropdeladd": "401 W DIVISION ST",
    "dropdelcty": "SYRACUSE",
    "dropdelst": "NY",
    "dropdelzpp": 132189211,
    "dropphyadd": "401 W DIVISION ST",
    "dropphycty": "SYRACUSE",
    "dropphyst": "NY",
    "dropphyzpp": 132189211,
    "dropmaladd": "401 W DIVISION ST",
    "dropmalcty": "SYRACUSE",
    "dropmalst": "NY",
    "dropmalzpp": 132189211,
    "dropsitphn": 3154788849,
    "dropsitlph": 3154788849,
    "dropsitcph": 3154788849,
    "dropfax": 3154789632
  },
  {
    "dcode": "D",
    "dropkey": "SV20001",
    "droptype": "D",
    "dropname": "WASHINGTON STREET",
    "dropdeladd": "189 WASHINGTON ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061069998",
    "dropphyadd": "189 WASHINGTON ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061069998",
    "dropmaladd": "189 WASHINGTON ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061069998",
    "dropsitphn": 8602401740,
    "dropsitlph": 8602401740,
    "dropsitcph": 8602401740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20013",
    "droptype": "D",
    "dropname": "ANN STREET",
    "dropdeladd": "185 ANN UCCELLO ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061039991",
    "dropphyadd": "185 ANN UCCELLO ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061039991",
    "dropmaladd": "185 ANN UCCELLO ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061039991",
    "dropsitphn": 8602496560,
    "dropsitlph": 8602496560,
    "dropsitcph": 8602407553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20017",
    "droptype": "D",
    "dropname": "ATLANTIC STREET",
    "dropdeladd": "421 ATLANTIC ST",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069013508",
    "dropphyadd": "421 ATLANTIC ST",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069013508",
    "dropmaladd": "421 ATLANTIC ST",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069013508",
    "dropsitphn": 8603232092,
    "dropsitlph": 8603232092,
    "dropsitcph": 2033232453,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20029",
    "droptype": "D",
    "dropname": "BARNUM",
    "dropdeladd": "2253 FAIRFIELD AVE",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066059998",
    "dropphyadd": "2253 FAIRFIELD AVE",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066059998",
    "dropmaladd": "2253 FAIRFIELD AVE",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066059998",
    "dropsitphn": 2033322693,
    "dropsitlph": 2033322693,
    "dropsitcph": 2033322693,
    "dropfax": 2033322696
  },
  {
    "dcode": "D",
    "dropkey": "SV20032",
    "droptype": "D",
    "dropname": "BARRY SQUARE",
    "dropdeladd": "645 MAPLE AVE",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061149998",
    "dropphyadd": "645 MAPLE AVE",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061149998",
    "dropmaladd": "645 MAPLE AVE",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061149998",
    "dropsitphn": 8602407552,
    "dropsitlph": 8602407552,
    "dropsitcph": 8604936325,
    "dropfax": 8602495416
  },
  {
    "dcode": "D",
    "dropkey": "SV20034",
    "droptype": "D",
    "dropname": "BAYVIEW",
    "dropdeladd": "115 BOSTON AVE",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066109998",
    "dropphyadd": "115 BOSTON AVE",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066109998",
    "dropmaladd": "115 BOSTON AVE",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066109998",
    "dropsitphn": 2033322683,
    "dropsitlph": 2033322683,
    "dropsitcph": 2033322683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20037",
    "droptype": "D",
    "dropname": "BEARDSLEY",
    "dropdeladd": "2741 MAIN ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066069998",
    "dropphyadd": "2741 MAIN ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066069998",
    "dropmaladd": "2741 MAIN ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066069998",
    "dropsitphn": 2033325302,
    "dropsitlph": 2033335948,
    "dropsitcph": 2033335948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20039",
    "droptype": "D",
    "dropname": "BELDEN",
    "dropdeladd": "2 BELDEN AVE",
    "dropdelcty": "NORWALK",
    "dropdelst": "CT",
    "dropdelzpp": "068509998",
    "dropphyadd": "2 BELDEN AVE",
    "dropphycty": "NORWALK",
    "dropphyst": "CT",
    "dropphyzpp": "068509998",
    "dropmaladd": "2 BELDEN AVE",
    "dropmalcty": "NORWALK",
    "dropmalst": "CT",
    "dropmalzpp": "068509998",
    "dropsitphn": 2038661673,
    "dropsitlph": 2038661673,
    "dropsitcph": 2038661673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20049",
    "droptype": "D",
    "dropname": "BISSELL",
    "dropdeladd": "831 MAIN ST",
    "dropdelcty": "SOUTH WINDSOR",
    "dropdelst": "CT",
    "dropdelzpp": "060749997",
    "dropphyadd": "831 MAIN ST",
    "dropphycty": "SOUTH WINDSOR",
    "dropphyst": "CT",
    "dropphyzpp": "060749997",
    "dropmaladd": "831 MAIN ST",
    "dropmalcty": "SOUTH WINDSOR",
    "dropmalst": "CT",
    "dropmalzpp": "060749997",
    "dropsitphn": 8605280832,
    "dropsitlph": 8605280832,
    "dropsitcph": 8605280832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20056",
    "droptype": "D",
    "dropname": "BLUE HILLS",
    "dropdeladd": "433 WOODLAND ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061129998",
    "dropphyadd": "433 WOODLAND ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061129998",
    "dropmaladd": "433 WOODLAND ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061129998",
    "dropsitphn": 8602494402,
    "dropsitlph": 8602494402,
    "dropsitcph": 8602401740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20059",
    "droptype": "D",
    "dropname": "BOROUGH",
    "dropdeladd": "202 THAMES ST",
    "dropdelcty": "GROTON",
    "dropdelst": "CT",
    "dropdelzpp": "063403649",
    "dropphyadd": "202 THAMES ST",
    "dropphycty": "GROTON",
    "dropphyst": "CT",
    "dropphyzpp": "063403649",
    "dropmaladd": "100 PLAZA CT",
    "dropmalcty": "GROTON",
    "dropmalst": "CT",
    "dropmalzpp": "063409991",
    "dropsitphn": 8604458154,
    "dropsitlph": 8604450180,
    "dropsitcph": 8604450180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20087",
    "droptype": "D",
    "dropname": "BUCKLAND",
    "dropdeladd": "1020 TOLLAND TPKE",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "CT",
    "dropdelzpp": "060421608",
    "dropphyadd": "1020 TOLLAND TPKE",
    "dropphycty": "MANCHESTER",
    "dropphyst": "CT",
    "dropphyzpp": "060421608",
    "dropmaladd": "1020 TOLLAND TPKE",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "CT",
    "dropmalzpp": "060421608",
    "dropsitphn": 8606439757,
    "dropsitlph": 8606432735,
    "dropsitcph": 8606432735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20160",
    "droptype": "D",
    "dropname": "DEVON",
    "dropdeladd": "548 NAUGATUCK AVE STE 1",
    "dropdelcty": "MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064609991",
    "dropphyadd": "548 NAUGATUCK AVE STE 1",
    "dropphycty": "MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064609991",
    "dropmaladd": "300 PEPES FARM RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064609994",
    "dropsitphn": 2038766180,
    "dropsitlph": 2038766180,
    "dropsitcph": 2038766180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20186",
    "droptype": "D",
    "dropname": "EAST END",
    "dropdeladd": "159 MANOR AVE STE 6",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067059998",
    "dropphyadd": "159 MANOR AVE STE 6",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067059998",
    "dropmaladd": "159 MANOR AVE STE 6",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067059998",
    "dropsitphn": 2035746512,
    "dropsitlph": 2035746512,
    "dropsitcph": 2035746512,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20213",
    "droptype": "D",
    "dropname": "ENFIELD STREET",
    "dropdeladd": "1430 ENFIELD ST",
    "dropdelcty": "ENFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "060829992",
    "dropphyadd": "1430 ENFIELD ST",
    "dropphycty": "ENFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "060829992",
    "dropmaladd": "1430 ENFIELD ST",
    "dropmalcty": "ENFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "060829992",
    "dropsitphn": 8607453882,
    "dropsitlph": 8607453882,
    "dropsitcph": 8607453882,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20220",
    "droptype": "D",
    "dropname": "FAIR HAVEN",
    "dropdeladd": "230 GRAND AVE",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065139998",
    "dropphyadd": "230 GRAND AVE",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065139998",
    "dropmaladd": "230 GRAND AVE",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065139998",
    "dropsitphn": 2037733538,
    "dropsitlph": 2037733538,
    "dropsitcph": 2037733538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20236",
    "droptype": "D",
    "dropname": "FORESTVILLE",
    "dropdeladd": "18 E MAIN ST",
    "dropdelcty": "BRISTOL",
    "dropdelst": "CT",
    "dropdelzpp": "060109991",
    "dropphyadd": "18 E MAIN ST",
    "dropphycty": "BRISTOL",
    "dropphyst": "CT",
    "dropphyzpp": "060109991",
    "dropmaladd": "151 N MAIN ST",
    "dropmalcty": "BRISTOL",
    "dropmalst": "CT",
    "dropmalzpp": "060109992",
    "dropsitphn": 8605837022,
    "dropsitlph": 8605837022,
    "dropsitcph": 8605837022,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20253",
    "droptype": "D",
    "dropname": "GLENBROOK",
    "dropdeladd": "370 HOPE ST",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069069992",
    "dropphyadd": "370 HOPE ST",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069069992",
    "dropmaladd": "370 HOPE ST",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069069992",
    "dropsitphn": 2033237469,
    "dropsitlph": 2033237469,
    "dropsitcph": 2033213910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20255",
    "droptype": "D",
    "dropname": "GLENVILLE",
    "dropdeladd": "25 GLEN RIDGE RD STE 6",
    "dropdelcty": "GREENWICH",
    "dropdelst": "CT",
    "dropdelzpp": "068319991",
    "dropphyadd": "25 GLEN RIDGE RD STE 6",
    "dropphycty": "GREENWICH",
    "dropphyst": "CT",
    "dropphyzpp": "068319991",
    "dropmaladd": "25 GLEN RIDGE RD STE 6",
    "dropmalcty": "GREENWICH",
    "dropmalst": "CT",
    "dropmalzpp": "068319991",
    "dropsitphn": 2035318744,
    "dropsitlph": 2033262204,
    "dropsitcph": 2035314146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20274",
    "droptype": "D",
    "dropname": "GROTON NAVAL BASE",
    "dropdeladd": "1 NAVAL SUBMARINE BASE",
    "dropdelcty": "GROTON",
    "dropdelst": "CT",
    "dropdelzpp": "063499992",
    "dropphyadd": "1 NAVAL SUBMARINE BASE",
    "dropphycty": "GROTON",
    "dropphyst": "CT",
    "dropphyzpp": "063499992",
    "dropmaladd": "1 NAVAL SUBMARINE BASE",
    "dropmalcty": "GROTON",
    "dropmalst": "CT",
    "dropmalzpp": "063499992",
    "dropsitphn": 8604458154,
    "dropsitlph": 8604457744,
    "dropsitcph": 8604457744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20303",
    "droptype": "D",
    "dropname": "HOTCHKISS SCHOOL",
    "dropdeladd": "11 INTERLAKEN RD",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060392130",
    "dropphyadd": "11 INTERLAKEN RD",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060392130",
    "dropmaladd": "11 INTERLAKEN RD",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060392130",
    "dropsitphn": 8604353299,
    "dropsitlph": 8604353299,
    "dropsitcph": 8604353299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20307",
    "droptype": "D",
    "dropname": "HUNTINGTON",
    "dropdeladd": "41 CHURCH ST STE 2",
    "dropdelcty": "SHELTON",
    "dropdelst": "CT",
    "dropdelzpp": "064849991",
    "dropphyadd": "41 CHURCH ST STE 2",
    "dropphycty": "SHELTON",
    "dropphyst": "CT",
    "dropphyzpp": "064849991",
    "dropmaladd": "41 CHURCH ST STE 2",
    "dropmalcty": "SHELTON",
    "dropmalst": "CT",
    "dropmalzpp": "064849991",
    "dropsitphn": 2039254297,
    "dropsitlph": 2039254297,
    "dropsitcph": 2039254297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20319",
    "droptype": "D",
    "dropname": "KILBY",
    "dropdeladd": "369 WASHINGTON AVE",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065199992",
    "dropphyadd": "369 WASHINGTON AVE",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065199992",
    "dropmaladd": "369 WASHINGTON AVE",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065199992",
    "dropsitphn": 2037823717,
    "dropsitlph": 2037823717,
    "dropsitcph": 2037823717,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20337",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "797 LAKEWOOD AVE",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067039998",
    "dropphyadd": "797 LAKEWOOD AVE",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067039998",
    "dropmaladd": "797 LAKEWOOD AVE",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067039998",
    "dropsitphn": 2035746521,
    "dropsitlph": 2035746521,
    "dropsitcph": 2037577511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20351",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "265 MAIN ST",
    "dropdelcty": "DANBURY",
    "dropdelst": "CT",
    "dropdelzpp": "068109991",
    "dropphyadd": "265 MAIN ST",
    "dropphycty": "DANBURY",
    "dropphyst": "CT",
    "dropphyzpp": "068109991",
    "dropmaladd": "265 MAIN ST",
    "dropmalcty": "DANBURY",
    "dropmalst": "CT",
    "dropmalzpp": "068109991",
    "dropsitphn": 2037961901,
    "dropsitlph": 2037925200,
    "dropsitcph": 2037925200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20450",
    "droptype": "D",
    "dropname": "NOANK",
    "dropdeladd": "19 1/2 PEARL ST",
    "dropdelcty": "GROTON",
    "dropdelst": "CT",
    "dropdelzpp": "063405723",
    "dropphyadd": "19 1/2 PEARL ST",
    "dropphycty": "GROTON",
    "dropphyst": "CT",
    "dropphyzpp": "063405723",
    "dropmaladd": "19 1/2 PEARL ST",
    "dropmalcty": "GROTON",
    "dropmalst": "CT",
    "dropmalzpp": "063405723",
    "dropsitphn": 8605361433,
    "dropsitlph": 8605361433,
    "dropsitcph": 8605361433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20451",
    "droptype": "D",
    "dropname": "NOBLE",
    "dropdeladd": "934 E MAIN ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066089998",
    "dropphyadd": "934 E MAIN ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066089998",
    "dropmaladd": "934 E MAIN ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066089998",
    "dropsitphn": 2033325301,
    "dropsitlph": 8603335688,
    "dropsitcph": 2033335688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20491",
    "droptype": "D",
    "dropname": "OAKVILLE",
    "dropdeladd": "322 MAIN ST",
    "dropdelcty": "OAKVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "067799998",
    "dropphyadd": "322 MAIN ST",
    "dropphycty": "OAKVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "067799998",
    "dropmaladd": "322 MAIN ST",
    "dropmalcty": "OAKVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "067799998",
    "dropsitphn": 8602743981,
    "dropsitlph": 8602743981,
    "dropsitcph": 8602743981,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20499",
    "droptype": "D",
    "dropname": "OLD STATE HOUSE",
    "dropdeladd": "80 STATE HOUSE SQ",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061039998",
    "dropphyadd": "80 STATE HOUSE SQ",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061039998",
    "dropmaladd": "80 STATE HOUSE SQ",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061039998",
    "dropsitphn": 8602407553,
    "dropsitlph": 8602407553,
    "dropsitcph": 8602407553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20503",
    "droptype": "D",
    "dropname": "DOWNTOWN MILFORD",
    "dropdeladd": "6 W RIVER ST",
    "dropdelcty": "MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064609992",
    "dropphyadd": "6 W RIVER ST",
    "dropphycty": "MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064609992",
    "dropmaladd": "6 W RIVER ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064609992",
    "dropsitphn": 2038766180,
    "dropsitlph": 2038766180,
    "dropsitcph": 2038766180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20504",
    "droptype": "D",
    "dropname": "PARK SQUARE",
    "dropdeladd": "79 ATLANTIC ST STE C",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069019992",
    "dropphyadd": "79 ATLANTIC ST STE C",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069019992",
    "dropmaladd": "79 ATLANTIC ST STE C",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069019992",
    "dropsitphn": 2033262038,
    "dropsitlph": 2033262038,
    "dropsitcph": 2033262038,
    "dropfax": 2033262153
  },
  {
    "dcode": "D",
    "dropkey": "SV20522",
    "droptype": "D",
    "dropname": "PLAZA",
    "dropdeladd": "41 WIGWAM AVE",
    "dropdelcty": "WATERBURY",
    "dropdelst": "CT",
    "dropdelzpp": "067049998",
    "dropphyadd": "41 WIGWAM AVE",
    "dropphycty": "WATERBURY",
    "dropphyst": "CT",
    "dropphyzpp": "067049998",
    "dropmaladd": "41 WIGWAM AVE",
    "dropmalcty": "WATERBURY",
    "dropmalst": "CT",
    "dropmalzpp": "067049998",
    "dropsitphn": 2035746553,
    "dropsitlph": 8605746158,
    "dropsitcph": 2037593642,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20569",
    "droptype": "D",
    "dropname": "ROWAYTON",
    "dropdeladd": "144 ROWAYTON AVE STE 1",
    "dropdelcty": "NORWALK",
    "dropdelst": "CT",
    "dropdelzpp": "068531412",
    "dropphyadd": "144 ROWAYTON AVE STE 1",
    "dropphycty": "NORWALK",
    "dropphyst": "CT",
    "dropphyzpp": "068531412",
    "dropmaladd": "144 ROWAYTON AVE STE 1",
    "dropmalcty": "NORWALK",
    "dropmalst": "CT",
    "dropmalzpp": "068531412",
    "dropsitphn": 2038385288,
    "dropsitlph": 2038385288,
    "dropsitcph": 2038385288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20583",
    "droptype": "D",
    "dropname": "SAMP MORTAR",
    "dropdeladd": "1262 POST RD",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068246010",
    "dropphyadd": "1262 POST RD",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068246010",
    "dropmaladd": "1262 POST RD",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068246010",
    "dropsitphn": 2033362929,
    "dropsitlph": 2033362929,
    "dropsitcph": 2033362929,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20602",
    "droptype": "D",
    "dropname": "SHORT BEACH",
    "dropdeladd": "5 COURT ST",
    "dropdelcty": "BRANFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064059991",
    "dropphyadd": "5 COURT ST",
    "dropphycty": "BRANFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064059991",
    "dropmaladd": "35 PARK PL",
    "dropmalcty": "BRANFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064059994",
    "dropsitphn": 2034880663,
    "dropsitlph": 2034888500,
    "dropsitcph": 2034888500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20640",
    "droptype": "D",
    "dropname": "CAMP AVENUE",
    "dropdeladd": "24 CAMP AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069079992",
    "dropphyadd": "24 CAMP AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069079992",
    "dropmaladd": "24 CAMP AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069079992",
    "dropsitphn": 2033213908,
    "dropsitlph": 2033213908,
    "dropsitcph": 2033213910,
    "dropfax": 2033213912
  },
  {
    "dcode": "D",
    "dropkey": "SV20643",
    "droptype": "D",
    "dropname": "GROTON LONG POINT",
    "dropdeladd": "44 BEACH RD",
    "dropdelcty": "GROTON",
    "dropdelst": "CT",
    "dropdelzpp": "063409992",
    "dropphyadd": "44 BEACH RD",
    "dropphycty": "GROTON",
    "dropphyst": "CT",
    "dropphyzpp": "063409992",
    "dropmaladd": "44 BEACH RD",
    "dropmalcty": "GROTON",
    "dropmalst": "CT",
    "dropmalzpp": "063409992",
    "dropsitphn": 8604458154,
    "dropsitlph": 8605361404,
    "dropsitcph": 8605361404,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20673",
    "droptype": "D",
    "dropname": "MERIDEN",
    "dropdeladd": "477 S BROAD ST STE 7",
    "dropdelcty": "MERIDEN",
    "dropdelst": "CT",
    "dropdelzpp": "064506660",
    "dropphyadd": "477 S BROAD ST STE 7",
    "dropphycty": "MERIDEN",
    "dropphyst": "CT",
    "dropphyzpp": "064506660",
    "dropmaladd": "190 CENTER ST",
    "dropmalcty": "MERIDEN",
    "dropmalst": "CT",
    "dropmalzpp": "064509998",
    "dropsitphn": 2032355184,
    "dropsitlph": 2032355184,
    "dropsitcph": 2032355184,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20681",
    "droptype": "D",
    "dropname": "STONY CREEK",
    "dropdeladd": "202 THIMBLE ISLAND RD",
    "dropdelcty": "BRANFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064059992",
    "dropphyadd": "202 THIMBLE ISLAND RD",
    "dropphycty": "BRANFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064059992",
    "dropmaladd": "35 PARK PL",
    "dropmalcty": "BRANFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064059994",
    "dropsitphn": 2034880663,
    "dropsitlph": 2034880663,
    "dropsitcph": 2034885111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20697",
    "droptype": "D",
    "dropname": "TALCOTTVILLE",
    "dropdeladd": "54 HARTFORD TPKE STE 1",
    "dropdelcty": "VERNON ROCKVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060669991",
    "dropphyadd": "54 HARTFORD TPKE STE 1",
    "dropphycty": "VERNON ROCKVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060669991",
    "dropmaladd": "54 HARTFORD TPKE STE 1",
    "dropmalcty": "VERNON ROCKVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060669991",
    "dropsitphn": 8606491667,
    "dropsitlph": 8606491667,
    "dropsitcph": 8606491667,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20722",
    "droptype": "D",
    "dropname": "TURNPIKE",
    "dropdeladd": "409 HARTFORD TPKE",
    "dropdelcty": "VERNON ROCKVILLE",
    "dropdelst": "CT",
    "dropdelzpp": "060664820",
    "dropphyadd": "409 HARTFORD TPKE",
    "dropphycty": "VERNON ROCKVILLE",
    "dropphyst": "CT",
    "dropphyzpp": "060664820",
    "dropmaladd": "409 HARTFORD TPKE",
    "dropmalcty": "VERNON ROCKVILLE",
    "dropmalst": "CT",
    "dropmalzpp": "060664820",
    "dropsitphn": 2038756045,
    "dropsitlph": 2038756045,
    "dropsitcph": 2038756045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20732",
    "droptype": "D",
    "dropname": "UNION CITY",
    "dropdeladd": "505 N MAIN ST",
    "dropdelcty": "NAUGATUCK",
    "dropdelst": "CT",
    "dropdelzpp": "067709994",
    "dropphyadd": "505 N MAIN ST",
    "dropphycty": "NAUGATUCK",
    "dropphyst": "CT",
    "dropphyzpp": "067709994",
    "dropmaladd": "505 N MAIN ST",
    "dropmalcty": "NAUGATUCK",
    "dropmalst": "CT",
    "dropmalzpp": "067709994",
    "dropsitphn": 2037295381,
    "dropsitlph": 2037295381,
    "dropsitcph": 2037204199,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20739",
    "droptype": "D",
    "dropname": "UNITY PLAZA",
    "dropdeladd": "271 BARBOUR ST",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061209998",
    "dropphyadd": "271 BARBOUR ST",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061209998",
    "dropmaladd": "271 BARBOUR ST",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061209998",
    "dropsitphn": 8602496765,
    "dropsitlph": 8602496765,
    "dropsitcph": 8602401740,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20781",
    "droptype": "D",
    "dropname": "WASHINGTON GREEN",
    "dropdeladd": "5 KIRBY RD",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "CT",
    "dropdelzpp": "067939991",
    "dropphyadd": "5 KIRBY RD",
    "dropphycty": "WASHINGTON",
    "dropphyst": "CT",
    "dropphyzpp": "067939991",
    "dropmaladd": "9 BRYAN HALL PLZ",
    "dropmalcty": "WASHINGTON DEPOT",
    "dropmalst": "CT",
    "dropmalzpp": "067949992",
    "dropsitphn": 8608687474,
    "dropsitlph": 8605246297,
    "dropsitcph": 8608687474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20804",
    "droptype": "D",
    "dropname": "WEST PUTNAM AVENUE",
    "dropdeladd": "480 W PUTNAM AVE",
    "dropdelcty": "GREENWICH",
    "dropdelst": "CT",
    "dropdelzpp": "06830",
    "dropphyadd": "480 W PUTNAM AVE",
    "dropphycty": "GREENWICH",
    "dropphyst": "CT",
    "dropphyzpp": "06830",
    "dropmaladd": "29 VALLEY DR",
    "dropmalcty": "GREENWICH",
    "dropmalst": "CT",
    "dropmalzpp": "068319992",
    "dropsitphn": 2038693162,
    "dropsitlph": 2038693162,
    "dropsitcph": 2038693162,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20817",
    "droptype": "D",
    "dropname": "WESTVILLE",
    "dropdeladd": "95 FOUNTAIN ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065159998",
    "dropphyadd": "95 FOUNTAIN ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065159998",
    "dropmaladd": "95 FOUNTAIN ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065159998",
    "dropsitphn": 2033898655,
    "dropsitlph": 2033898655,
    "dropsitcph": 2033898655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20824",
    "droptype": "D",
    "dropname": "WILDEMERE BEACH",
    "dropdeladd": "21 BROADWAY",
    "dropdelcty": "MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064609993",
    "dropphyadd": "21 BROADWAY",
    "dropphycty": "MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064609993",
    "dropmaladd": "300 PEPES FARM RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064609994",
    "dropsitphn": 2038766180,
    "dropsitlph": 2038778500,
    "dropsitcph": 2038778500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20845",
    "droptype": "D",
    "dropname": "WOODMONT",
    "dropdeladd": "27 VILLAGE RD",
    "dropdelcty": "MILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "06460",
    "dropphyadd": "27 VILLAGE RD",
    "dropphycty": "MILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "06460",
    "dropmaladd": "300 PEPES FARM RD",
    "dropmalcty": "MILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064609994",
    "dropsitphn": 2038766180,
    "dropsitlph": 2038778500,
    "dropsitcph": 2038778500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20854",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "206 ELM ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065119992",
    "dropphyadd": "206 ELM ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065119992",
    "dropmaladd": "206 ELM ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065119992",
    "dropsitphn": 2037827000,
    "dropsitlph": 2307733454,
    "dropsitcph": 2037733454,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20856",
    "droptype": "D",
    "dropname": "YALESVILLE",
    "dropdeladd": "314 MAIN ST STE 11",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929991",
    "dropphyadd": "314 MAIN ST STE 11",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929991",
    "dropmaladd": "4 S MAIN ST",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929994",
    "dropsitphn": 2032698712,
    "dropsitlph": 2032696222,
    "dropsitcph": 2032696222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20864",
    "droptype": "D",
    "dropname": "ANACOSTIA",
    "dropdeladd": "2341 PENNSYLVANIA AVE SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200209992,
    "dropphyadd": "2341 PENNSYLVANIA AVE SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200209992,
    "dropmaladd": "2341 PENNSYLVANIA AVE SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200209992,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025846807,
    "dropsitcph": 2025846807,
    "dropfax": 2026362935
  },
  {
    "dcode": "D",
    "dropkey": "SV20877",
    "droptype": "D",
    "dropname": "BENJAMIN FRANKLIN",
    "dropdeladd": "1200 PENNSYLVANIA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200042403,
    "dropphyadd": "1200 PENNSYLVANIA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200042403,
    "dropmaladd": "PO BOX 14400",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200444400,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232387,
    "dropsitcph": 2026361259,
    "dropfax": 2025299174
  },
  {
    "dcode": "D",
    "dropkey": "SV20878",
    "droptype": "D",
    "dropname": "BENNING",
    "dropdeladd": "3937 1/2 MINNESOTA AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200199997,
    "dropphyadd": "3937 1/2 MINNESOTA AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200199997,
    "dropmaladd": "3937 1/2 MINNESOTA AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200199997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232390,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20882",
    "droptype": "D",
    "dropname": "BOLLING AFB",
    "dropdeladd": "10 BROOKLEY AVE SW",
    "dropdelcty": "BOLLING AFB",
    "dropdelst": "DC",
    "dropdelzpp": 200327701,
    "dropphyadd": "10 BROOKLEY AVE SW",
    "dropphycty": "BOLLING AFB",
    "dropphyst": "DC",
    "dropphyzpp": 200327701,
    "dropmaladd": "10 BROOKLEY AVE SW",
    "dropmalcty": "BOLLING AFB",
    "dropmalst": "DC",
    "dropmalzpp": 200327701,
    "dropsitphn": 3014997331,
    "dropsitlph": 2027674419,
    "dropsitcph": 2027674419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20886",
    "droptype": "D",
    "dropname": "BRIGHTWOOD",
    "dropdeladd": "6323 GEORGIA AVE NW STE A",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200119996,
    "dropphyadd": "6323 GEORGIA AVE NW STE A",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200119996,
    "dropmaladd": "PO BOX 56999",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200406999,
    "dropsitphn": 3014997331,
    "dropsitlph": 2027268119,
    "dropsitcph": 2027268119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20888",
    "droptype": "D",
    "dropname": "BROOKLAND",
    "dropdeladd": "3401 12TH ST NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200179997,
    "dropphyadd": "3401 12TH ST NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200179997,
    "dropmaladd": "3401 12TH ST NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200179997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232126,
    "dropsitcph": 2025232137,
    "dropfax": 2025232135
  },
  {
    "dcode": "D",
    "dropkey": "SV20903",
    "droptype": "D",
    "dropname": "CALVERT",
    "dropdeladd": "2336 WISCONSIN AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200071843,
    "dropphyadd": "2336 WISCONSIN AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200071843,
    "dropmaladd": "2336 WISCONSIN AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200071843,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232907,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20906",
    "droptype": "D",
    "dropname": "MCPHERSON",
    "dropdeladd": "1750 PENNSYLVANIA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200069997,
    "dropphyadd": "1750 PENNSYLVANIA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200069997,
    "dropmaladd": "PO BOX 27000",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200387000,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028421229,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20909",
    "droptype": "D",
    "dropname": "LAMMOND RIGGS",
    "dropdeladd": "6200 N CAPITOL ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200111408,
    "dropphyadd": "6200 N CAPITOL ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200111408,
    "dropmaladd": "6200 N CAPITOL ST NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200111408,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232041,
    "dropsitcph": 2025232041,
    "dropfax": 2027226943
  },
  {
    "dcode": "D",
    "dropkey": "SV20911",
    "droptype": "D",
    "dropname": "CLEVELAND PARK",
    "dropdeladd": "3430 CONNECTICUT AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200089998,
    "dropphyadd": "3430 CONNECTICUT AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200089998,
    "dropmaladd": "3430 CONNECTICUT AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200089998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028421589,
    "dropsitcph": 2026361259,
    "dropfax": 2025232930
  },
  {
    "dcode": "D",
    "dropkey": "SV20919",
    "droptype": "D",
    "dropname": "CONGRESS HEIGHTS",
    "dropdeladd": "400 SOUTHERN AVE SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200329997,
    "dropphyadd": "400 SOUTHERN AVE SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200329997,
    "dropmaladd": "400 SOUTHERN AVE SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200329997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028424952,
    "dropsitcph": 2025232122,
    "dropfax": 2025741902
  },
  {
    "dcode": "D",
    "dropkey": "SV20923",
    "droptype": "D",
    "dropname": "CUSTOMS HOUSE",
    "dropdeladd": "3178 BLADENSBURG RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189998,
    "dropphyadd": "3178 BLADENSBURG RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189998,
    "dropmaladd": "3178 BLADENSBURG RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232195,
    "dropsitcph": 2025232195,
    "dropfax": 2025299174
  },
  {
    "dcode": "D",
    "dropkey": "SV20967",
    "droptype": "D",
    "dropname": "FARRAGUT",
    "dropdeladd": "1800 M ST NW FRNT 1",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200369998,
    "dropphyadd": "1800 M ST NW FRNT 1",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200369998,
    "dropmaladd": "PO BOX 33000",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200331000,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232024,
    "dropsitcph": 2026361259,
    "dropfax": 2028339615
  },
  {
    "dcode": "D",
    "dropkey": "SV20986",
    "droptype": "D",
    "dropname": "FORT DAVIS",
    "dropdeladd": "3843 PENNSYLVANIA AVE SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200209994,
    "dropphyadd": "3843 PENNSYLVANIA AVE SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200209994,
    "dropmaladd": "3843 PENNSYLVANIA AVE SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200209994,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232152,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV20990",
    "droptype": "D",
    "dropname": "FRIENDSHIP",
    "dropdeladd": "4005 WISCONSIN AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200169997,
    "dropphyadd": "4005 WISCONSIN AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200169997,
    "dropmaladd": "4005 WISCONSIN AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200169997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232130,
    "dropsitcph": 2028423332,
    "dropfax": 2025232018
  },
  {
    "dcode": "D",
    "dropkey": "SV20999",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "1215 31ST ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200079998,
    "dropphyadd": "1215 31ST ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200079998,
    "dropmaladd": "1215 31ST ST NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200079998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028422487,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21032",
    "droptype": "D",
    "dropname": "KALORAMA",
    "dropdeladd": "2300 18TH ST NW LBBY",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200099996,
    "dropphyadd": "2300 18TH ST NW LBBY",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200099996,
    "dropmaladd": "2300 18TH ST NW LBBY",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200099996,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232906,
    "dropsitcph": 2025232906,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21037",
    "droptype": "D",
    "dropname": "LE DROIT PARK",
    "dropdeladd": "416 FLORIDA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200019997,
    "dropphyadd": "416 FLORIDA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200019997,
    "dropmaladd": "416 FLORIDA AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200019997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2024830973,
    "dropsitcph": 2024830973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21038",
    "droptype": "D",
    "dropname": "LENFANT PLAZA",
    "dropdeladd": "470 LENFANT PLZ SW STE 604",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200249995,
    "dropphyadd": "470 LENFANT PLZ SW STE 604",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200249995,
    "dropmaladd": "PO BOX 44250",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200269998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232013,
    "dropsitcph": 2022684970,
    "dropfax": 2028631291
  },
  {
    "dcode": "D",
    "dropkey": "SV21045",
    "droptype": "D",
    "dropname": "MARTIN LUTHER KING JR",
    "dropdeladd": "1400 L ST NW LBBY 2",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200059997,
    "dropphyadd": "1400 L ST NW LBBY 2",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200059997,
    "dropmaladd": "1400 L ST NW LBBY 2",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200059997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028421350,
    "dropsitcph": 2025232001,
    "dropfax": 2023710658
  },
  {
    "dcode": "D",
    "dropkey": "SV21047",
    "droptype": "D",
    "dropname": "MID CITY",
    "dropdeladd": "1915 14TH ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200099994,
    "dropphyadd": "1915 14TH ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200099994,
    "dropmaladd": "1915 14TH ST NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200099994,
    "dropsitphn": 3014997331,
    "dropsitlph": 2024839580,
    "dropsitcph": 2024839580,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21051",
    "droptype": "D",
    "dropname": "NATIONAL CAPITOL",
    "dropdeladd": "2 MASSACHUSETTS AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200029997,
    "dropphyadd": "2 MASSACHUSETTS AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200029997,
    "dropmaladd": "2 MASSACHUSETTS AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200029997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232628,
    "dropsitcph": 2026361259,
    "dropfax": 2025232928
  },
  {
    "dcode": "D",
    "dropkey": "SV21080",
    "droptype": "D",
    "dropname": "NAVAL RESEARCH LABORATORY",
    "dropdeladd": "4555 OVERLOOK AVE SW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 203750001,
    "dropphyadd": "4555 OVERLOOK AVE SW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 203750001,
    "dropmaladd": "4555 OVERLOOK AVE SW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 203750001,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361200,
    "dropsitcph": 2026361200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21087",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "1563 MARYLAND AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200029998,
    "dropphyadd": "1563 MARYLAND AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200029998,
    "dropmaladd": "1563 MARYLAND AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200029998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028424421,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21088",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "5636 CONNECTICUT AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200159998,
    "dropphyadd": "5636 CONNECTICUT AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200159998,
    "dropmaladd": "5636 CONNECTICUT AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200159998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232570,
    "dropsitcph": 2025232570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21098",
    "droptype": "D",
    "dropname": "PALISADES",
    "dropdeladd": "5136 MACARTHUR BLVD NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200163316,
    "dropphyadd": "5136 MACARTHUR BLVD NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200163316,
    "dropmaladd": "5136 MACARTHUR BLVD NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200163316,
    "dropsitphn": 3014997331,
    "dropsitlph": 2023620987,
    "dropsitcph": 2025232130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21111",
    "droptype": "D",
    "dropname": "RANDLE",
    "dropdeladd": "2341 PENNSYLVANIA AVE SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200209996,
    "dropphyadd": "2341 PENNSYLVANIA AVE SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200209996,
    "dropmaladd": "2341 PENNSYLVANIA AVE SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200209996,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025846807,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21123",
    "droptype": "D",
    "dropname": "SOUTHEAST",
    "dropdeladd": "600 PENNSYLVANIA AVE SE FRNT 2",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200039998,
    "dropphyadd": "600 PENNSYLVANIA AVE SE FRNT 2",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200039998,
    "dropmaladd": "600 PENNSYLVANIA AVE SE FRNT 2",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200039998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232173,
    "dropsitcph": 2026361259,
    "dropfax": 2025232175
  },
  {
    "dcode": "D",
    "dropkey": "SV21124",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "45 L ST SW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200249997,
    "dropphyadd": "45 L ST SW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200249997,
    "dropmaladd": "45 L ST SW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200249997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232559,
    "dropsitcph": 2025232590,
    "dropfax": 2025232932
  },
  {
    "dcode": "D",
    "dropkey": "SV21125",
    "droptype": "D",
    "dropname": "RUSSELL",
    "dropdeladd": "21 SHB",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 205109996,
    "dropphyadd": "21 SHB",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 205109996,
    "dropmaladd": "21 SHB",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 205109996,
    "dropsitphn": "",
    "dropsitlph": 2022243900,
    "dropsitcph": 2025232138,
    "dropfax": 2022249003
  },
  {
    "dcode": "D",
    "dropkey": "SV21128",
    "droptype": "D",
    "dropname": "LONGWORTH",
    "dropdeladd": "15 INDEPENDENCE AVE SE RM B202",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 205159992,
    "dropphyadd": "15 INDEPENDENCE AVE SE RM B202",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 205159992,
    "dropmaladd": "15 INDEPENDENCE AVE SE RM B202",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 205159992,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2022265423,
    "dropfax": 2022263118
  },
  {
    "dcode": "D",
    "dropkey": "SV21131",
    "droptype": "D",
    "dropname": "FORD",
    "dropdeladd": "441 2ND ST SW RM H2-121",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 205159995,
    "dropphyadd": "441 2ND ST SW RM H2-121",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 205159995,
    "dropmaladd": "441 2ND ST SW RM H2-121",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 205159995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2022265414,
    "dropsitcph": 2022265414,
    "dropfax": 2022263109
  },
  {
    "dcode": "D",
    "dropkey": "SV21136",
    "droptype": "D",
    "dropname": "STATE DEPARTMENT",
    "dropdeladd": "2201 C ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 205200001,
    "dropphyadd": "2201 C ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 205200001,
    "dropmaladd": "2201 C ST NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 205200001,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232573,
    "dropsitcph": 2025232575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21137",
    "droptype": "D",
    "dropname": "T STREET",
    "dropdeladd": "1915 14TH ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200099995,
    "dropphyadd": "1915 14TH ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200099995,
    "dropmaladd": "1915 14TH ST NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200099995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2022326301,
    "dropsitcph": 2022326301,
    "dropfax": 2024623020
  },
  {
    "dcode": "D",
    "dropkey": "SV21138",
    "droptype": "D",
    "dropname": "TECHWORLD",
    "dropdeladd": "800 K ST NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200019996,
    "dropphyadd": "800 K ST NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200019996,
    "dropmaladd": "PO BOX 52499",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200919997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232019,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21143",
    "droptype": "D",
    "dropname": "TWENTIETH STREET",
    "dropdeladd": "2001 M ST NW LBBY",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200369997,
    "dropphyadd": "2001 M ST NW LBBY",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200369997,
    "dropmaladd": "2001 M ST NW LBBY",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200369997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232411,
    "dropsitcph": 2026361259,
    "dropfax": 2028339656
  },
  {
    "dcode": "D",
    "dropkey": "SV21169",
    "droptype": "D",
    "dropname": "WARD PLACE",
    "dropdeladd": "2121 WARD PL NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200379992,
    "dropphyadd": "2121 WARD PL NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200379992,
    "dropmaladd": "2121 WARD PL NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200379992,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232109,
    "dropsitcph": 2025232109,
    "dropfax": 2025232914
  },
  {
    "dcode": "D",
    "dropkey": "SV21180",
    "droptype": "D",
    "dropname": "WASHINGTON GMF",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200181004,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200181004,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200660001,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361972,
    "dropsitcph": 2026361972,
    "dropfax": 2025231212
  },
  {
    "dcode": "D",
    "dropkey": "SV21184",
    "droptype": "D",
    "dropname": "WASHINGTON SQUARE",
    "dropdeladd": "1050 CONNECTICUT AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200365303,
    "dropphyadd": "1050 CONNECTICUT AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200365303,
    "dropmaladd": "PO BOX 66660",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200359998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025233632,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21185",
    "droptype": "D",
    "dropname": "WATERGATE",
    "dropdeladd": "2512 VIRGINIA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200379997,
    "dropphyadd": "2512 VIRGINIA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200379997,
    "dropmaladd": "2512 VIRGINIA AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200379997,
    "dropsitphn": 3014997331,
    "dropsitlph": 2029656578,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21188",
    "droptype": "D",
    "dropname": "WOODRIDGE",
    "dropdeladd": "2211 RHODE ISLAND AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200182826,
    "dropphyadd": "2211 RHODE ISLAND AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200182826,
    "dropmaladd": "2211 RHODE ISLAND AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200182826,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028424340,
    "dropsitcph": 2022693384,
    "dropfax": 2025299174
  },
  {
    "dcode": "D",
    "dropkey": "SV21266",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "110 E MAIN ST",
    "dropdelcty": "NEWARK",
    "dropdelst": "DE",
    "dropdelzpp": 197119997,
    "dropphyadd": "110 E MAIN ST",
    "dropphycty": "NEWARK",
    "dropphyst": "DE",
    "dropphyzpp": 197119997,
    "dropmaladd": "110 E MAIN ST",
    "dropmalcty": "NEWARK",
    "dropmalst": "DE",
    "dropmalzpp": 197119997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023684541,
    "dropsitcph": 3023683833,
    "dropfax": 3023687849
  },
  {
    "dcode": "D",
    "dropkey": "SV21302",
    "droptype": "D",
    "dropname": "LANCASTER AVE",
    "dropdeladd": "1500 LANCASTER AVE",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198059998,
    "dropphyadd": "1500 LANCASTER AVE",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198059998,
    "dropmaladd": "1500 LANCASTER AVE",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198059998,
    "dropsitphn": 3026563353,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026540725,
    "dropfax": 3026540624
  },
  {
    "dcode": "D",
    "dropkey": "SV21407",
    "droptype": "D",
    "dropname": "ALLERTON",
    "dropdeladd": "797 NANTASKET AVE",
    "dropdelcty": "HULL",
    "dropdelst": "MA",
    "dropdelzpp": "020459991",
    "dropphyadd": "797 NANTASKET AVE",
    "dropphycty": "HULL",
    "dropphyst": "MA",
    "dropphyzpp": "020459991",
    "dropmaladd": "797 NANTASKET AVE",
    "dropmalcty": "HULL",
    "dropmalst": "MA",
    "dropmalzpp": "020459991",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 6179250096,
    "dropfax": 7819255974
  },
  {
    "dcode": "D",
    "dropkey": "SV21409",
    "droptype": "D",
    "dropname": "ALLSTON",
    "dropdeladd": "47 HARVARD AVE",
    "dropdelcty": "ALLSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021349998",
    "dropphyadd": "47 HARVARD AVE",
    "dropphycty": "ALLSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021349998",
    "dropmaladd": "47 HARVARD AVE",
    "dropmalcty": "ALLSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021349998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545011,
    "dropsitcph": 6177893769,
    "dropfax": 6177879382
  },
  {
    "dcode": "D",
    "dropkey": "SV21434",
    "droptype": "D",
    "dropname": "ASTOR",
    "dropdeladd": "207 MASSACHUSETTS AVE",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021153043",
    "dropphyadd": "207 MASSACHUSETTS AVE",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021153043",
    "dropmaladd": "PO BOX 239998",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021239998",
    "dropsitphn": 6176546113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172472429,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21439",
    "droptype": "D",
    "dropname": "ATTLEBORO FALLS",
    "dropdeladd": "215 COMMONWEALTH AVE",
    "dropdelcty": "ATTLEBORO FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "027639998",
    "dropphyadd": "215 COMMONWEALTH AVE",
    "dropphycty": "ATTLEBORO FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "027639998",
    "dropmaladd": "215 COMMONWEALTH AVE",
    "dropmalcty": "ATTLEBORO FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "027639998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086996231,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21450",
    "droptype": "D",
    "dropname": "BALLARDVALE",
    "dropdeladd": "187 ANDOVER ST STE 1",
    "dropdelcty": "ANDOVER",
    "dropdelst": "MA",
    "dropdelzpp": "018109992",
    "dropphyadd": "187 ANDOVER ST STE 1",
    "dropphycty": "ANDOVER",
    "dropphyst": "MA",
    "dropphyzpp": "018109992",
    "dropmaladd": "187 ANDOVER ST STE 1",
    "dropmalcty": "ANDOVER",
    "dropmalst": "MA",
    "dropmalzpp": "018109992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784755042,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21487",
    "droptype": "D",
    "dropname": "BEVERLY FARMS",
    "dropdeladd": "36 WEST ST STE 3",
    "dropdelcty": "BEVERLY",
    "dropdelst": "MA",
    "dropdelzpp": "019159991",
    "dropphyadd": "36 WEST ST STE 3",
    "dropphycty": "BEVERLY",
    "dropphyst": "MA",
    "dropphyzpp": "019159991",
    "dropmaladd": "36 WEST ST STE 3",
    "dropmalcty": "BEVERLY",
    "dropmalst": "MA",
    "dropmalzpp": "019159991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789273688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21516",
    "droptype": "D",
    "dropname": "BOURNE",
    "dropdeladd": "49 SANDWICH RD",
    "dropdelcty": "BUZZARDS BAY",
    "dropdelst": "MA",
    "dropdelzpp": "025329992",
    "dropphyadd": "49 SANDWICH RD",
    "dropphycty": "BUZZARDS BAY",
    "dropphyst": "MA",
    "dropphyzpp": "025329992",
    "dropmaladd": "49 SANDWICH RD",
    "dropmalcty": "BUZZARDS BAY",
    "dropmalst": "MA",
    "dropmalzpp": "025329992",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087590847,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21534",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "135 S MAIN ST",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "MA",
    "dropdelzpp": "018359991",
    "dropphyadd": "135 S MAIN ST",
    "dropphycty": "HAVERHILL",
    "dropphyst": "MA",
    "dropphyzpp": "018359991",
    "dropmaladd": "135 S MAIN ST",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "MA",
    "dropmalzpp": "018359991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785213437,
    "dropfax": 9783747373
  },
  {
    "dcode": "D",
    "dropkey": "SV21551",
    "droptype": "D",
    "dropname": "BRIGHTWOOD",
    "dropdeladd": "3065 MAIN ST STE 1",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011079998",
    "dropphyadd": "3065 MAIN ST STE 1",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011079998",
    "dropmaladd": "3065 MAIN ST STE 1",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011079998",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137333328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21573",
    "droptype": "D",
    "dropname": "QUINSIGAMOND VILLAGE",
    "dropdeladd": "347 GREENWOOD ST STE 1",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016071775",
    "dropphyadd": "347 GREENWOOD ST STE 1",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016071775",
    "dropmaladd": "347 GREENWOOD ST STE 1",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016071775",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087953725,
    "dropsitcph": 5087951904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21578",
    "droptype": "D",
    "dropname": "CAMPELLO",
    "dropdeladd": "1104 MAIN ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MA",
    "dropdelzpp": "023016829",
    "dropphyadd": "1104 MAIN ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "MA",
    "dropphyzpp": "023016829",
    "dropmaladd": "PO BOX 9712",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MA",
    "dropmalzpp": "023049712",
    "dropsitphn": 4017525649,
    "dropsitlph": 5085591824,
    "dropsitcph": 5085591816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21585",
    "droptype": "D",
    "dropname": "CATHEDRAL",
    "dropdeladd": "59 W DEDHAM ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021189998",
    "dropphyadd": "59 W DEDHAM ST",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021189998",
    "dropmaladd": "59 W DEDHAM ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021189998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172660989,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21588",
    "droptype": "D",
    "dropname": "CENTER",
    "dropdeladd": "6 MAIN STREET EXT",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "023619998",
    "dropphyadd": "6 MAIN STREET EXT",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "023619998",
    "dropmaladd": "6 MAIN STREET EXT",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "023619998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087468175,
    "dropfax": 5087468175
  },
  {
    "dcode": "D",
    "dropkey": "SV21590",
    "droptype": "D",
    "dropname": "CENTERVILLE STATION",
    "dropdeladd": "80 S MAIN ST",
    "dropdelcty": "CENTERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "026323244",
    "dropphyadd": "80 S MAIN ST",
    "dropphycty": "CENTERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "026323244",
    "dropmaladd": "80 S MAIN ST",
    "dropmalcty": "CENTERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "026323244",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087784443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21592",
    "droptype": "D",
    "dropname": "CENTRAL VILLAGE",
    "dropdeladd": "10 ADAMSVILLE RD",
    "dropdelcty": "WESTPORT",
    "dropdelst": "MA",
    "dropdelzpp": "027905000",
    "dropphyadd": "10 ADAMSVILLE RD",
    "dropphycty": "WESTPORT",
    "dropphyst": "MA",
    "dropphyzpp": "027905000",
    "dropmaladd": "10 ADAMSVILLE RD",
    "dropmalcty": "WESTPORT",
    "dropmalst": "MA",
    "dropmalzpp": "027905000",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086364062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21597",
    "droptype": "D",
    "dropname": "CHARLES STREET",
    "dropdeladd": "136 CHARLES ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021149991",
    "dropphyadd": "136 CHARLES ST",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021149991",
    "dropmaladd": "136 CHARLES ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021149991",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177237434,
    "dropfax": 6177420923
  },
  {
    "dcode": "D",
    "dropkey": "SV21619",
    "droptype": "D",
    "dropname": "CHICOPEE CENTER",
    "dropdeladd": "100 CENTER ST",
    "dropdelcty": "CHICOPEE",
    "dropdelst": "MA",
    "dropdelzpp": "010139998",
    "dropphyadd": "100 CENTER ST",
    "dropphycty": "CHICOPEE",
    "dropphyst": "MA",
    "dropphyzpp": "010139998",
    "dropmaladd": "28 MAIN ST",
    "dropmalcty": "CHICOPEE",
    "dropmalst": "MA",
    "dropmalzpp": "010209998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135922956,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21628",
    "droptype": "D",
    "dropname": "COCHITUATE",
    "dropdeladd": "148 COMMONWEALTH RD",
    "dropdelcty": "WAYLAND",
    "dropdelst": "MA",
    "dropdelzpp": "017784837",
    "dropphyadd": "148 COMMONWEALTH RD",
    "dropphycty": "WAYLAND",
    "dropphyst": "MA",
    "dropphyzpp": "017784837",
    "dropmaladd": "148 COMMONWEALTH RD",
    "dropmalcty": "WAYLAND",
    "dropmalst": "MA",
    "dropmalzpp": "017784837",
    "dropsitphn": 5086647013,
    "dropsitlph": 5086537370,
    "dropsitcph": 5086536801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21632",
    "droptype": "D",
    "dropname": "COLONIAL STATION",
    "dropdeladd": "1149 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011039998",
    "dropphyadd": "1149 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011039998",
    "dropmaladd": "1149 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011039998",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137333850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21666",
    "droptype": "D",
    "dropname": "FIELDS CORNER",
    "dropdeladd": "218 ADAMS ST",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "021229998",
    "dropphyadd": "218 ADAMS ST",
    "dropphycty": "DORCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "021229998",
    "dropmaladd": "218 ADAMS ST",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "021229998",
    "dropsitphn": 6174362134,
    "dropsitlph": 6174362134,
    "dropsitcph": 6172880834,
    "dropfax": 6172654824
  },
  {
    "dcode": "D",
    "dropkey": "SV21673",
    "droptype": "D",
    "dropname": "DOWNTOWN LOWELL",
    "dropdeladd": "20 MARKET ST",
    "dropdelcty": "LOWELL",
    "dropdelst": "MA",
    "dropdelzpp": "018529991",
    "dropphyadd": "20 MARKET ST",
    "dropphycty": "LOWELL",
    "dropphyst": "MA",
    "dropphyzpp": "018529991",
    "dropmaladd": "20 MARKET ST",
    "dropmalcty": "LOWELL",
    "dropmalst": "MA",
    "dropmalzpp": "018529991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784541222,
    "dropfax": 9786641875
  },
  {
    "dcode": "D",
    "dropkey": "SV21706",
    "droptype": "D",
    "dropname": "EAST BOSTON",
    "dropdeladd": "50 MERIDIAN ST",
    "dropdelcty": "EAST BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021289998",
    "dropphyadd": "50 MERIDIAN ST",
    "dropphycty": "EAST BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021289998",
    "dropmaladd": "50 MERIDIAN ST",
    "dropmalcty": "EAST BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021289998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174186529,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21711",
    "droptype": "D",
    "dropname": "EAST CAMBRIDGE",
    "dropdeladd": "303 CAMBRIDGE ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021419998",
    "dropphyadd": "303 CAMBRIDGE ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021419998",
    "dropmaladd": "303 CAMBRIDGE ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021419998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178768558,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21714",
    "droptype": "D",
    "dropname": "EAST DEDHAM",
    "dropdeladd": "280 BUSSEY ST",
    "dropdelcty": "DEDHAM",
    "dropdelst": "MA",
    "dropdelzpp": "020279991",
    "dropphyadd": "280 BUSSEY ST",
    "dropphycty": "DEDHAM",
    "dropphyst": "MA",
    "dropphyzpp": "020279991",
    "dropmaladd": "PO BOX 9991",
    "dropmalcty": "DEDHAM",
    "dropmalst": "MA",
    "dropmalzpp": "020279998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7813264910,
    "dropfax": 7812510285
  },
  {
    "dcode": "D",
    "dropkey": "SV21726",
    "droptype": "D",
    "dropname": "EAST LYNN",
    "dropdeladd": "245 MAPLE ST",
    "dropdelcty": "LYNN",
    "dropdelst": "MA",
    "dropdelzpp": "019049998",
    "dropphyadd": "245 MAPLE ST",
    "dropphycty": "LYNN",
    "dropphyst": "MA",
    "dropphyzpp": "019049998",
    "dropmaladd": "245 MAPLE ST",
    "dropmalcty": "LYNN",
    "dropmalst": "MA",
    "dropmalzpp": "019049998",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7815934019,
    "dropfax": 7815869068
  },
  {
    "dcode": "D",
    "dropkey": "SV21761",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "7 AVENUE DE LAFAYETTE",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021119998",
    "dropphyadd": "7 AVENUE DE LAFAYETTE",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021119998",
    "dropmaladd": "PO BOX 129998",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021129998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174237822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21785",
    "droptype": "D",
    "dropname": "FLINT",
    "dropdeladd": "1662 PLEASANT ST",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "027239998",
    "dropphyadd": "1662 PLEASANT ST",
    "dropphycty": "FALL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "027239998",
    "dropmaladd": "1662 PLEASANT ST",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "027239998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086721442,
    "dropfax": 5086726070
  },
  {
    "dcode": "D",
    "dropkey": "SV21787",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "123 MAIN ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "MA",
    "dropdelzpp": "010629998",
    "dropphyadd": "123 MAIN ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "MA",
    "dropphyzpp": "010629998",
    "dropmaladd": "191 NORTHAMPTON ST",
    "dropmalcty": "EASTHAMPTON",
    "dropmalst": "MA",
    "dropmalzpp": "010279998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135845152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21791",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "393 BELMONT AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011089998",
    "dropphyadd": "393 BELMONT AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011089998",
    "dropmaladd": "393 BELMONT AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011089998",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137333405,
    "dropfax": 4137397707
  },
  {
    "dcode": "D",
    "dropkey": "SV21794",
    "droptype": "D",
    "dropname": "FORGE VILLAGE",
    "dropdeladd": "5 W PRESCOTT ST",
    "dropdelcty": "WESTFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018869992",
    "dropphyadd": "5 W PRESCOTT ST",
    "dropphycty": "WESTFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018869992",
    "dropmaladd": "5 W PRESCOTT ST",
    "dropmalcty": "WESTFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018869992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786923865,
    "dropfax": 9786920207
  },
  {
    "dcode": "D",
    "dropkey": "SV21796",
    "droptype": "D",
    "dropname": "FORT POINT",
    "dropdeladd": "25 DORCHESTER AVE RM 1",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "022059761",
    "dropphyadd": "25 DORCHESTER AVE RM 1",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "022059761",
    "dropmaladd": "25 DORCHESTER AVE RM 1",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "022059761",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6176545302,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21802",
    "droptype": "D",
    "dropname": "FRAMINGHAM CENTER",
    "dropdeladd": "855 WORCESTER RD",
    "dropdelcty": "FRAMINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "017015258",
    "dropphyadd": "855 WORCESTER RD",
    "dropphycty": "FRAMINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "017015258",
    "dropmaladd": "PO BOX 9993",
    "dropmalcty": "FRAMINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "017039993",
    "dropsitphn": 9786647013,
    "dropsitlph": 5088757411,
    "dropsitcph": 5088791113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21844",
    "droptype": "D",
    "dropname": "GREENDALE",
    "dropdeladd": "290 W BOYLSTON ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016062378",
    "dropphyadd": "290 W BOYLSTON ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016062378",
    "dropmaladd": "290 W BOYLSTON ST",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016062378",
    "dropsitphn": 5086647013,
    "dropsitlph": 5086647013,
    "dropsitcph": 5088542976,
    "dropfax": 5088548387
  },
  {
    "dcode": "D",
    "dropkey": "SV21847",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "1179 MAIN ST STE 1",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "018809991",
    "dropphyadd": "1179 MAIN ST STE 1",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "018809991",
    "dropmaladd": "1179 MAIN ST STE 1",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "018809991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812454293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21853",
    "droptype": "D",
    "dropname": "GROVE HALL",
    "dropdeladd": "647 WARREN ST",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "021219998",
    "dropphyadd": "647 WARREN ST",
    "dropphycty": "DORCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "021219998",
    "dropmaladd": "647 WARREN ST",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "021219998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174452253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21862",
    "droptype": "D",
    "dropname": "HANOVER STREET",
    "dropdeladd": "217 HANOVER ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021139998",
    "dropphyadd": "217 HANOVER ST",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021139998",
    "dropmaladd": "217 HANOVER ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021139998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177236397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21870",
    "droptype": "D",
    "dropname": "HARVARD SQUARE",
    "dropdeladd": "125 MOUNT AUBURN ST STE 1",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021389998",
    "dropphyadd": "125 MOUNT AUBURN ST STE 1",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021389998",
    "dropmaladd": "125 MOUNT AUBURN ST STE 1",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021389998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178763883,
    "dropfax": 6178768508
  },
  {
    "dcode": "D",
    "dropkey": "SV21874",
    "droptype": "D",
    "dropname": "HARWOOD",
    "dropdeladd": "7 TAYLOR ST",
    "dropdelcty": "LITTLETON",
    "dropdelst": "MA",
    "dropdelzpp": "014601400",
    "dropphyadd": "7 TAYLOR ST",
    "dropphycty": "LITTLETON",
    "dropphyst": "MA",
    "dropphyzpp": "014601400",
    "dropmaladd": "7 TAYLOR ST",
    "dropmalcty": "LITTLETON",
    "dropmalst": "MA",
    "dropmalzpp": "014601400",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784860952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21890",
    "droptype": "D",
    "dropname": "MASON SQUARE",
    "dropdeladd": "914 STATE ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011099998",
    "dropphyadd": "914 STATE ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011099998",
    "dropmaladd": "914 STATE ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011099998",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137335331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21891",
    "droptype": "D",
    "dropname": "HIGHLANDS",
    "dropdeladd": "1677 MIDDLESEX ST STE 6",
    "dropdelcty": "LOWELL",
    "dropdelst": "MA",
    "dropdelzpp": "018519991",
    "dropphyadd": "1677 MIDDLESEX ST STE 6",
    "dropphycty": "LOWELL",
    "dropphyst": "MA",
    "dropphyzpp": "018519991",
    "dropmaladd": "1677 MIDDLESEX ST STE 6",
    "dropmalcty": "LOWELL",
    "dropmalst": "MA",
    "dropmalzpp": "018519991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784527801,
    "dropfax": 9789700492
  },
  {
    "dcode": "D",
    "dropkey": "SV21923",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "1269 HYDE PARK AVE",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "MA",
    "dropdelzpp": "021362776",
    "dropphyadd": "1269 HYDE PARK AVE",
    "dropphycty": "HYDE PARK",
    "dropphyst": "MA",
    "dropphyzpp": "021362776",
    "dropmaladd": "PO BOX 369998",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "MA",
    "dropmalzpp": "021369996",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173614759,
    "dropfax": 6173613061
  },
  {
    "dcode": "D",
    "dropkey": "SV21928",
    "droptype": "D",
    "dropname": "INMAN SQUARE",
    "dropdeladd": "1311 CAMBRIDGE ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021399991",
    "dropphyadd": "1311 CAMBRIDGE ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021399991",
    "dropmaladd": "1311 CAMBRIDGE ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021399991",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178644344,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21934",
    "droptype": "D",
    "dropname": "ISLINGTON",
    "dropdeladd": "307 WASHINGTON ST",
    "dropdelcty": "WESTWOOD",
    "dropdelst": "MA",
    "dropdelzpp": "020909991",
    "dropphyadd": "307 WASHINGTON ST",
    "dropphycty": "WESTWOOD",
    "dropphyst": "MA",
    "dropphyzpp": "020909991",
    "dropmaladd": "307 WASHINGTON ST",
    "dropmalcty": "WESTWOOD",
    "dropmalst": "MA",
    "dropmalzpp": "020909991",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7813267583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21937",
    "droptype": "D",
    "dropname": "JAMAICA PLAIN",
    "dropdeladd": "655 CENTRE ST",
    "dropdelcty": "JAMAICA PLAIN",
    "dropdelst": "MA",
    "dropdelzpp": "021309998",
    "dropphyadd": "655 CENTRE ST",
    "dropphycty": "JAMAICA PLAIN",
    "dropphyst": "MA",
    "dropphyzpp": "021309998",
    "dropmaladd": "655 CENTRE ST",
    "dropmalcty": "JAMAICA PLAIN",
    "dropmalst": "MA",
    "dropmalzpp": "021309998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175243620,
    "dropfax": 6175241816
  },
  {
    "dcode": "D",
    "dropkey": "SV21939",
    "droptype": "D",
    "dropname": "JOHN FITZGERALD KENNEDY",
    "dropdeladd": "25 NEW CHARDON ST LBBY",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021149998",
    "dropphyadd": "25 NEW CHARDON ST LBBY",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021149998",
    "dropmaladd": "25 NEW CHARDON ST LBBY",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021149998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175236566,
    "dropfax": 6177420923
  },
  {
    "dcode": "D",
    "dropkey": "SV21965",
    "droptype": "D",
    "dropname": "LANESVILLE",
    "dropdeladd": "1068 WASHINGTON ST",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "019309993",
    "dropphyadd": "1068 WASHINGTON ST",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "019309993",
    "dropmaladd": "1068 WASHINGTON ST",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "019309993",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782836998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21983",
    "droptype": "D",
    "dropname": "LINCOLN CENTER",
    "dropdeladd": "17 LINCOLN RD",
    "dropdelcty": "LINCOLN",
    "dropdelst": "MA",
    "dropdelzpp": "017732012",
    "dropphyadd": "17 LINCOLN RD",
    "dropphycty": "LINCOLN",
    "dropphyst": "MA",
    "dropphyzpp": "017732012",
    "dropmaladd": "17 LINCOLN RD",
    "dropmalcty": "LINCOLN",
    "dropmalst": "MA",
    "dropmalzpp": "017732012",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7812590724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV21984",
    "droptype": "D",
    "dropname": "LINCOLN MALL",
    "dropdeladd": "560 LINCOLN ST STE 8",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016051925",
    "dropphyadd": "560 LINCOLN ST STE 8",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016051925",
    "dropmaladd": "560 LINCOLN ST STE 8",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016051925",
    "dropsitphn": 5086647013,
    "dropsitlph": 5087953745,
    "dropsitcph": 5088523783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22002",
    "droptype": "D",
    "dropname": "M I T",
    "dropdeladd": "84 MASSACHUSETTS AVE",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021399992",
    "dropphyadd": "84 MASSACHUSETTS AVE",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021399992",
    "dropmaladd": "84 MASSACHUSETTS AVE",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021399992",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174945511,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22004",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "10 LEXINGTON AVE",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "019309991",
    "dropphyadd": "10 LEXINGTON AVE",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "019309991",
    "dropmaladd": "10 LEXINGTON AVE",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "019309991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785253488,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22007",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "484 MAIN ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016081893",
    "dropphyadd": "484 MAIN ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016081893",
    "dropmaladd": "PO BOX 9991",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016019991",
    "dropsitphn": 5086647013,
    "dropsitlph": 5087953745,
    "dropsitcph": 5087971639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22039",
    "droptype": "D",
    "dropname": "MATTAPAN",
    "dropdeladd": "1602 BLUE HILL AVE",
    "dropdelcty": "MATTAPAN",
    "dropdelst": "MA",
    "dropdelzpp": "021269998",
    "dropphyadd": "1602 BLUE HILL AVE",
    "dropphycty": "MATTAPAN",
    "dropphyst": "MA",
    "dropphyzpp": "021269998",
    "dropmaladd": "1602 BLUE HILL AVE",
    "dropmalcty": "MATTAPAN",
    "dropmalst": "MA",
    "dropmalzpp": "021269998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172961291,
    "dropfax": 6172963214
  },
  {
    "dcode": "D",
    "dropkey": "SV22046",
    "droptype": "D",
    "dropname": "MEDWAY VILLAGE",
    "dropdeladd": "137 VILLAGE ST",
    "dropdelcty": "MEDWAY",
    "dropdelst": "MA",
    "dropdelzpp": "020539991",
    "dropphyadd": "137 VILLAGE ST",
    "dropphycty": "MEDWAY",
    "dropphyst": "MA",
    "dropphyzpp": "020539991",
    "dropmaladd": "137 VILLAGE ST",
    "dropmalcty": "MEDWAY",
    "dropmalst": "MA",
    "dropmalzpp": "020539991",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085335728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22069",
    "droptype": "D",
    "dropname": "MILLERS FALLS",
    "dropdeladd": "178 AVENUE A",
    "dropdelcty": "TURNERS FALLS",
    "dropdelst": "MA",
    "dropdelzpp": "013769992",
    "dropphyadd": "178 AVENUE A",
    "dropphycty": "TURNERS FALLS",
    "dropphyst": "MA",
    "dropphyzpp": "013769992",
    "dropmaladd": "178 AVENUE A",
    "dropmalcty": "TURNERS FALLS",
    "dropmalst": "MA",
    "dropmalzpp": "013769992",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4136593317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22088",
    "droptype": "D",
    "dropname": "MONTELLO",
    "dropdeladd": "200 OAK ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MA",
    "dropdelzpp": "023011354",
    "dropphyadd": "200 OAK ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "MA",
    "dropphyzpp": "023011354",
    "dropmaladd": "PO BOX 9713",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MA",
    "dropmalzpp": "023059713",
    "dropsitphn": 4017525649,
    "dropsitlph": 5085591823,
    "dropsitcph": 5085591813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22098",
    "droptype": "D",
    "dropname": "MOUNT PLEASANT",
    "dropdeladd": "748 MOUNT PLEASANT ST",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "027459998",
    "dropphyadd": "748 MOUNT PLEASANT ST",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "027459998",
    "dropmaladd": "748 MOUNT PLEASANT ST",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "027459998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089953006,
    "dropfax": 5089985668
  },
  {
    "dcode": "D",
    "dropkey": "SV22136",
    "droptype": "D",
    "dropname": "NABNASSET",
    "dropdeladd": "62 BROOKSIDE RD",
    "dropdelcty": "WESTFORD",
    "dropdelst": "MA",
    "dropdelzpp": "018869991",
    "dropphyadd": "62 BROOKSIDE RD",
    "dropphycty": "WESTFORD",
    "dropphyst": "MA",
    "dropphyzpp": "018869991",
    "dropmaladd": "62 BROOKSIDE RD",
    "dropmalcty": "WESTFORD",
    "dropmalst": "MA",
    "dropmalzpp": "018869991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9786923881,
    "dropfax": 9786920207
  },
  {
    "dcode": "D",
    "dropkey": "SV22199",
    "droptype": "D",
    "dropname": "NOQUOCHOKE",
    "dropdeladd": "529 OLD COUNTY RD",
    "dropdelcty": "WESTPORT",
    "dropdelst": "MA",
    "dropdelzpp": "027901180",
    "dropphyadd": "529 OLD COUNTY RD",
    "dropphycty": "WESTPORT",
    "dropphyst": "MA",
    "dropphyzpp": "027901180",
    "dropmaladd": "529 OLD COUNTY RD",
    "dropmalcty": "WESTPORT",
    "dropmalst": "MA",
    "dropmalzpp": "027901180",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086364268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22202",
    "droptype": "D",
    "dropname": "NORTH",
    "dropdeladd": "282 COFFIN AVE",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "027469998",
    "dropphyadd": "282 COFFIN AVE",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "027469998",
    "dropmaladd": "282 COFFIN AVE",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "027469998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089962392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22204",
    "droptype": "D",
    "dropname": "ABINGTON CENTER",
    "dropdeladd": "24 BROCKTON AVE",
    "dropdelcty": "ABINGTON",
    "dropdelst": "MA",
    "dropdelzpp": "023519991",
    "dropphyadd": "24 BROCKTON AVE",
    "dropphycty": "ABINGTON",
    "dropphyst": "MA",
    "dropphyzpp": "023519991",
    "dropmaladd": "24 BROCKTON AVE",
    "dropmalcty": "ABINGTON",
    "dropmalst": "MA",
    "dropmalzpp": "023519991",
    "dropsitphn": 4017525649,
    "dropsitlph": 6178780977,
    "dropsitcph": 7818785979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22208",
    "droptype": "D",
    "dropname": "NORTH AMHERST",
    "dropdeladd": "15 MONTAGUE RD",
    "dropdelcty": "NORTH AMHERST",
    "dropdelst": "MA",
    "dropdelzpp": "010599998",
    "dropphyadd": "15 MONTAGUE RD",
    "dropphycty": "NORTH AMHERST",
    "dropphyst": "MA",
    "dropphyzpp": "010599998",
    "dropmaladd": "15 MONTAGUE RD",
    "dropmalcty": "NORTH AMHERST",
    "dropmalst": "MA",
    "dropmalzpp": "010599998",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135490418,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22244",
    "droptype": "D",
    "dropname": "NORTH PLYMOUTH",
    "dropdeladd": "283 COURT ST",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "023629998",
    "dropphyadd": "283 COURT ST",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "023629998",
    "dropmaladd": "283 COURT ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "023629998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087468018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22278",
    "droptype": "D",
    "dropname": "OLD TOWN HOUSE",
    "dropdeladd": "20 MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "MA",
    "dropdelzpp": "018109993",
    "dropphyadd": "20 MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "MA",
    "dropphyzpp": "018109993",
    "dropmaladd": "20 MAIN ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "MA",
    "dropmalzpp": "018109993",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784702018,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22283",
    "droptype": "D",
    "dropname": "ORCHARD STREET",
    "dropdeladd": "584 ORCHARD ST",
    "dropdelcty": "NEW BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "027449998",
    "dropphyadd": "584 ORCHARD ST",
    "dropphycty": "NEW BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "027449998",
    "dropmaladd": "584 ORCHARD ST",
    "dropmalcty": "NEW BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "027449998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089963703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22308",
    "droptype": "D",
    "dropname": "PIGEON COVE",
    "dropdeladd": "165 1/2 GRANITE ST",
    "dropdelcty": "ROCKPORT",
    "dropdelst": "MA",
    "dropdelzpp": "019669991",
    "dropphyadd": "165 1/2 GRANITE ST",
    "dropphycty": "ROCKPORT",
    "dropphyst": "MA",
    "dropphyzpp": "019669991",
    "dropmaladd": "165 1/2 GRANITE ST",
    "dropmalcty": "ROCKPORT",
    "dropmalst": "MA",
    "dropmalzpp": "019669991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785462694,
    "dropfax": 9785462101
  },
  {
    "dcode": "D",
    "dropkey": "SV22332",
    "droptype": "D",
    "dropname": "PRUDENTIAL CENTER",
    "dropdeladd": "800 BOYLSTON ST LBBY",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021999998",
    "dropphyadd": "800 BOYLSTON ST LBBY",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021999998",
    "dropmaladd": "800 BOYLSTON ST LBBY",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021999998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172674164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22342",
    "droptype": "D",
    "dropname": "READVILLE",
    "dropdeladd": "201 NEPONSET VALLEY PKWY",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "MA",
    "dropdelzpp": "021362409",
    "dropphyadd": "201 NEPONSET VALLEY PKWY",
    "dropphycty": "HYDE PARK",
    "dropphyst": "MA",
    "dropphyzpp": "021362409",
    "dropmaladd": "PO BOX 379998",
    "dropmalcty": "READVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021379998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173615605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22353",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "3 HOLLY ST",
    "dropdelcty": "GLOUCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "019309992",
    "dropphyadd": "3 HOLLY ST",
    "dropphycty": "GLOUCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "019309992",
    "dropmaladd": "3 HOLLY ST",
    "dropmalcty": "GLOUCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "019309992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9782836920,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22364",
    "droptype": "D",
    "dropname": "ROSLINDALE",
    "dropdeladd": "16 CUMMINS HWY",
    "dropdelcty": "ROSLINDALE",
    "dropdelst": "MA",
    "dropdelzpp": "021319998",
    "dropphyadd": "16 CUMMINS HWY",
    "dropphycty": "ROSLINDALE",
    "dropphyst": "MA",
    "dropphyzpp": "021319998",
    "dropmaladd": "16 CUMMINS HWY",
    "dropmalcty": "ROSLINDALE",
    "dropmalst": "MA",
    "dropmalzpp": "021319998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173230791,
    "dropfax": 6174694984
  },
  {
    "dcode": "D",
    "dropkey": "SV22368",
    "droptype": "D",
    "dropname": "ROXBURY",
    "dropdeladd": "55 ROXBURY ST",
    "dropdelcty": "ROXBURY",
    "dropdelst": "MA",
    "dropdelzpp": "021199998",
    "dropphyadd": "55 ROXBURY ST",
    "dropphycty": "ROXBURY",
    "dropphyst": "MA",
    "dropphyzpp": "021199998",
    "dropmaladd": "55 ROXBURY ST",
    "dropmalcty": "ROXBURY",
    "dropmalst": "MA",
    "dropmalzpp": "021199998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174274898,
    "dropfax": 6174271683
  },
  {
    "dcode": "D",
    "dropkey": "SV22370",
    "droptype": "D",
    "dropname": "MISSION HILL",
    "dropdeladd": "1575 TREMONT ST LBBY",
    "dropdelcty": "ROXBURY CROSSING",
    "dropdelst": "MA",
    "dropdelzpp": "021209998",
    "dropphyadd": "1575 TREMONT ST LBBY",
    "dropphycty": "ROXBURY CROSSING",
    "dropphyst": "MA",
    "dropphyzpp": "021209998",
    "dropmaladd": "1575 TREMONT ST LBBY",
    "dropmalcty": "ROXBURY CROSSING",
    "dropmalst": "MA",
    "dropmalzpp": "021209998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175662040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22421",
    "droptype": "D",
    "dropname": "SAXONVILLE",
    "dropdeladd": "31 NICHOLAS RD",
    "dropdelcty": "FRAMINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "017013465",
    "dropphyadd": "31 NICHOLAS RD",
    "dropphycty": "FRAMINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "017013465",
    "dropmaladd": "PO BOX 9995",
    "dropmalcty": "FRAMINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "017059995",
    "dropsitphn": 5086647013,
    "dropsitlph": 5088757411,
    "dropsitcph": 5088779799,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22434",
    "droptype": "D",
    "dropname": "SHAWSHEEN VILLAGE",
    "dropdeladd": "360 N MAIN ST",
    "dropdelcty": "ANDOVER",
    "dropdelst": "MA",
    "dropdelzpp": "018109991",
    "dropphyadd": "360 N MAIN ST",
    "dropphycty": "ANDOVER",
    "dropphyst": "MA",
    "dropphyzpp": "018109991",
    "dropmaladd": "360 N MAIN ST",
    "dropmalcty": "ANDOVER",
    "dropmalst": "MA",
    "dropmalzpp": "018109991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784759140,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22457",
    "droptype": "D",
    "dropname": "SNUG HARBOR",
    "dropdeladd": "455 WASHINGTON ST",
    "dropdelcty": "DUXBURY",
    "dropdelst": "MA",
    "dropdelzpp": "023319800",
    "dropphyadd": "455 WASHINGTON ST",
    "dropphycty": "DUXBURY",
    "dropphyst": "MA",
    "dropphyzpp": "023319800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "DUXBURY",
    "dropmalst": "MA",
    "dropmalzpp": "023319998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7819345192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22479",
    "droptype": "D",
    "dropname": "SOLDIERS FIELD",
    "dropdeladd": "117 WESTERN AVE STE 1",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021639998",
    "dropphyadd": "117 WESTERN AVE STE 1",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021639998",
    "dropmaladd": "117 WESTERN AVE STE 1",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021639998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175474250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22483",
    "droptype": "D",
    "dropname": "SOUTH",
    "dropdeladd": "1460 S MAIN ST",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "027249998",
    "dropphyadd": "1460 S MAIN ST",
    "dropphycty": "FALL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "027249998",
    "dropmaladd": "1460 S MAIN ST",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "027249998",
    "dropsitphn": 4012765038,
    "dropsitlph": 4012765038,
    "dropsitcph": 5086722975,
    "dropfax": 5086770463
  },
  {
    "dcode": "D",
    "dropkey": "SV22489",
    "droptype": "D",
    "dropname": "SOUTH ATTLEBORO",
    "dropdeladd": "775 NEWPORT AVE",
    "dropdelcty": "ATTLEBORO",
    "dropdelst": "MA",
    "dropdelzpp": "027035953",
    "dropphyadd": "775 NEWPORT AVE",
    "dropphycty": "ATTLEBORO",
    "dropphyst": "MA",
    "dropphyzpp": "027035953",
    "dropmaladd": "775 NEWPORT AVE",
    "dropmalcty": "ATTLEBORO",
    "dropmalst": "MA",
    "dropmalzpp": "027035953",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5087616142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22494",
    "droptype": "D",
    "dropname": "SOUTH BOSTON",
    "dropdeladd": "444 E 3RD ST",
    "dropdelcty": "SOUTH BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021279998",
    "dropphyadd": "444 E 3RD ST",
    "dropphycty": "SOUTH BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021279998",
    "dropmaladd": "444 E 3RD ST",
    "dropmalcty": "SOUTH BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021279998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172699948,
    "dropfax": 6172681098
  },
  {
    "dcode": "D",
    "dropkey": "SV22506",
    "droptype": "D",
    "dropname": "FRAMINGHAM SOUTH",
    "dropdeladd": "43 PARK ST",
    "dropdelcty": "FRAMINGHAM",
    "dropdelst": "MA",
    "dropdelzpp": "017026664",
    "dropphyadd": "43 PARK ST",
    "dropphycty": "FRAMINGHAM",
    "dropphyst": "MA",
    "dropphyzpp": "017026664",
    "dropmaladd": "PO BOX 9994",
    "dropmalcty": "FRAMINGHAM",
    "dropmalst": "MA",
    "dropmalzpp": "017049994",
    "dropsitphn": 9786647013,
    "dropsitlph": 5088757411,
    "dropsitcph": 5088791117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22518",
    "droptype": "D",
    "dropname": "SOUTH LYNNFIELD",
    "dropdeladd": "598 SALEM ST",
    "dropdelcty": "LYNNFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "019409992",
    "dropphyadd": "598 SALEM ST",
    "dropphycty": "LYNNFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "019409992",
    "dropmaladd": "598 SALEM ST",
    "dropmalcty": "LYNNFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "019409992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7815994830,
    "dropfax": 7815981501
  },
  {
    "dcode": "D",
    "dropkey": "SV22607",
    "droptype": "D",
    "dropname": "STATE HOUSE",
    "dropdeladd": "24 BEACON ST RM 2",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021339998",
    "dropphyadd": "24 BEACON ST RM 2",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021339998",
    "dropmaladd": "24 BEACON ST RM 2",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021339998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6177420012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22661",
    "droptype": "D",
    "dropname": "TURNPIKE",
    "dropdeladd": "166 BOSTON TPKE",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "MA",
    "dropdelzpp": "015459991",
    "dropphyadd": "166 BOSTON TPKE",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "MA",
    "dropphyzpp": "015459991",
    "dropmaladd": "166 BOSTON TPKE",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "MA",
    "dropmalzpp": "015459991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5087982196,
    "dropfax": 5087913461
  },
  {
    "dcode": "D",
    "dropkey": "SV22669",
    "droptype": "D",
    "dropname": "UPHAMS CORNER",
    "dropdeladd": "551 COLUMBIA RD",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "021259998",
    "dropphyadd": "551 COLUMBIA RD",
    "dropphycty": "DORCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "021259998",
    "dropmaladd": "551 COLUMBIA RD",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "021259998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172879626,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22711",
    "droptype": "D",
    "dropname": "WALLIS STREET",
    "dropdeladd": "13 WALLIS ST",
    "dropdelcty": "PEABODY",
    "dropdelst": "MA",
    "dropdelzpp": "019609992",
    "dropphyadd": "13 WALLIS ST",
    "dropphycty": "PEABODY",
    "dropphyst": "MA",
    "dropphyzpp": "019609992",
    "dropmaladd": "13 WALLIS ST",
    "dropmalcty": "PEABODY",
    "dropmalst": "MA",
    "dropmalzpp": "019609992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785327793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22719",
    "droptype": "D",
    "dropname": "WARD HILL",
    "dropdeladd": "19 CROSS RD",
    "dropdelcty": "HAVERHILL",
    "dropdelst": "MA",
    "dropdelzpp": "018359992",
    "dropphyadd": "19 CROSS RD",
    "dropphycty": "HAVERHILL",
    "dropphyst": "MA",
    "dropphyzpp": "018359992",
    "dropmaladd": "19 CROSS RD",
    "dropmalcty": "HAVERHILL",
    "dropmalst": "MA",
    "dropmalzpp": "018359992",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783726802,
    "dropfax": 9783738838
  },
  {
    "dcode": "D",
    "dropkey": "SV22735",
    "droptype": "D",
    "dropname": "WEBSTER SQUARE",
    "dropdeladd": "1049 MAIN ST STE 5",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016032487",
    "dropphyadd": "1049 MAIN ST STE 5",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016032487",
    "dropmaladd": "1049 MAIN ST STE 5",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016032487",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5083633822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22749",
    "droptype": "D",
    "dropname": "WEST ACTON",
    "dropdeladd": "241 ARLINGTON ST",
    "dropdelcty": "ACTON",
    "dropdelst": "MA",
    "dropdelzpp": "017202200",
    "dropphyadd": "241 ARLINGTON ST",
    "dropphycty": "ACTON",
    "dropphyst": "MA",
    "dropphyzpp": "017202200",
    "dropmaladd": "241 ARLINGTON ST",
    "dropmalcty": "ACTON",
    "dropmalst": "MA",
    "dropmalzpp": "017202200",
    "dropsitphn": 9786647013,
    "dropsitlph": 9782634714,
    "dropsitcph": 9782631551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22761",
    "droptype": "D",
    "dropname": "WEST CONCORD",
    "dropdeladd": "35 BEHARRELL ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "MA",
    "dropdelzpp": "017422968",
    "dropphyadd": "35 BEHARRELL ST",
    "dropphycty": "CONCORD",
    "dropphyst": "MA",
    "dropphyzpp": "017422968",
    "dropmaladd": "35 BEHARRELL ST",
    "dropmalcty": "CONCORD",
    "dropmalst": "MA",
    "dropmalzpp": "017422968",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783695924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22770",
    "droptype": "D",
    "dropname": "WEST HANOVER",
    "dropdeladd": "1405 HANOVER ST STE 2",
    "dropdelcty": "HANOVER",
    "dropdelst": "MA",
    "dropdelzpp": "023392026",
    "dropphyadd": "1405 HANOVER ST STE 2",
    "dropphycty": "HANOVER",
    "dropphyst": "MA",
    "dropphyzpp": "023392026",
    "dropmaladd": "1405 HANOVER ST STE 2",
    "dropmalcty": "HANOVER",
    "dropmalst": "MA",
    "dropmalzpp": "023392026",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7817920338,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV22787",
    "droptype": "D",
    "dropname": "WEST PEABODY",
    "dropdeladd": "637 LOWELL ST STE 4",
    "dropdelcty": "PEABODY",
    "dropdelst": "MA",
    "dropdelzpp": "019609991",
    "dropphyadd": "637 LOWELL ST STE 4",
    "dropphycty": "PEABODY",
    "dropphyst": "MA",
    "dropphyzpp": "019609991",
    "dropmaladd": "637 LOWELL ST STE 4",
    "dropmalcty": "PEABODY",
    "dropmalst": "MA",
    "dropmalzpp": "019609991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9785354609,
    "dropfax": 9785316034
  },
  {
    "dcode": "D",
    "dropkey": "SV22791",
    "droptype": "D",
    "dropname": "WEST ROXBURY",
    "dropdeladd": "1834 CENTRE ST",
    "dropdelcty": "WEST ROXBURY",
    "dropdelst": "MA",
    "dropdelzpp": "021321901",
    "dropphyadd": "1834 CENTRE ST",
    "dropphycty": "WEST ROXBURY",
    "dropphyst": "MA",
    "dropphyzpp": "021321901",
    "dropmaladd": "1834 CENTRE ST",
    "dropmalcty": "WEST ROXBURY",
    "dropmalst": "MA",
    "dropmalzpp": "021321901",
    "dropsitphn": 6173236143,
    "dropsitlph": 6173236143,
    "dropsitcph": 6173236143,
    "dropfax": 6173232383
  },
  {
    "dcode": "D",
    "dropkey": "SV22793",
    "droptype": "D",
    "dropname": "WEST SIDE",
    "dropdeladd": "381 CHANDLER ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016023399",
    "dropphyadd": "381 CHANDLER ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016023399",
    "dropmaladd": "381 CHANDLER ST",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016023399",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5087951827,
    "dropfax": 5087521558
  },
  {
    "dcode": "D",
    "dropkey": "SV22904",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "3500 DOLFIELD AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212159998,
    "dropphyadd": "3500 DOLFIELD AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212159998,
    "dropmaladd": "3500 DOLFIELD AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212159998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103675458,
    "dropsitcph": 4103675458,
    "dropfax": 4105423948
  },
  {
    "dcode": "D",
    "dropkey": "SV22985",
    "droptype": "D",
    "dropname": "ARLINGTON ROAD STATION",
    "dropdeladd": "7001 ARLINGTON RD",
    "dropdelcty": "BETHESDA",
    "dropdelst": "MD",
    "dropdelzpp": 208145230,
    "dropphyadd": "7001 ARLINGTON RD",
    "dropphycty": "BETHESDA",
    "dropphyst": "MD",
    "dropphyzpp": 208145230,
    "dropmaladd": "7001 ARLINGTON RD",
    "dropmalcty": "BETHESDA",
    "dropmalst": "MD",
    "dropmalzpp": 208145230,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019412681,
    "dropsitcph": 3019412682,
    "dropfax": 3019412687
  },
  {
    "dcode": "D",
    "dropkey": "SV23078",
    "droptype": "D",
    "dropname": "CALVERT",
    "dropdeladd": "111 N CALVERT ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212029997,
    "dropphyadd": "111 N CALVERT ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212029997,
    "dropmaladd": "111 N CALVERT ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212029997,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474202,
    "dropsitcph": 4103474202,
    "dropfax": 4108374380
  },
  {
    "dcode": "D",
    "dropkey": "SV23108",
    "droptype": "D",
    "dropname": "CARROLL",
    "dropdeladd": "340 S LOUDON AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212299998,
    "dropphyadd": "340 S LOUDON AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212299998,
    "dropmaladd": "340 S LOUDON AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212299998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106440525,
    "dropsitcph": 4106440525,
    "dropfax": 4105258329
  },
  {
    "dcode": "D",
    "dropkey": "SV23196",
    "droptype": "D",
    "dropname": "CLIFTON EAST END",
    "dropdeladd": "4200 SHANNON DR",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212139998,
    "dropphyadd": "4200 SHANNON DR",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212139998,
    "dropmaladd": "4200 SHANNON DR",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212139998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104854444,
    "dropsitcph": 4104854444,
    "dropfax": 4103257180
  },
  {
    "dcode": "D",
    "dropkey": "SV23224",
    "droptype": "D",
    "dropname": "COLLEGE ESTATES",
    "dropdeladd": "1301 W 7TH ST",
    "dropdelcty": "FREDERICK",
    "dropdelst": "MD",
    "dropdelzpp": 217029921,
    "dropphyadd": "1301 W 7TH ST",
    "dropphycty": "FREDERICK",
    "dropphyst": "MD",
    "dropphyzpp": 217029921,
    "dropmaladd": "1301 W 7TH ST",
    "dropmalcty": "FREDERICK",
    "dropmalst": "MD",
    "dropmalzpp": 217029921,
    "dropsitphn": 3016823129,
    "dropsitlph": 3016248050,
    "dropsitcph": 3016248050,
    "dropfax": 3018464674
  },
  {
    "dcode": "D",
    "dropkey": "SV23281",
    "droptype": "D",
    "dropname": "COURTHOUSE",
    "dropdeladd": "500 N WASHINGTON ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208509998,
    "dropphyadd": "500 N WASHINGTON ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208509998,
    "dropmaladd": "500 N WASHINGTON ST",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208509998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017625802,
    "dropsitcph": 3017625802,
    "dropfax": 3018382904
  },
  {
    "dcode": "D",
    "dropkey": "SV23346",
    "droptype": "D",
    "dropname": "DIAMOND FARMS",
    "dropdeladd": "23 FIRSTFIELD RD",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208789998,
    "dropphyadd": "23 FIRSTFIELD RD",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208789998,
    "dropmaladd": "23 FIRSTFIELD RD",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208789998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083735,
    "dropsitcph": 3012083735,
    "dropfax": 3012083713
  },
  {
    "dcode": "D",
    "dropkey": "SV23369",
    "droptype": "D",
    "dropname": "DRUID",
    "dropdeladd": "1826 PENNSYLVANIA AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212179998,
    "dropphyadd": "1826 PENNSYLVANIA AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212179998,
    "dropmaladd": "1826 PENNSYLVANIA AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212179998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106691477,
    "dropsitcph": 4106691477,
    "dropfax": 4105235248
  },
  {
    "dcode": "D",
    "dropkey": "SV23390",
    "droptype": "D",
    "dropname": "EASTPORT",
    "dropdeladd": "821 CHESAPEAKE AVE",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MD",
    "dropdelzpp": 214039998,
    "dropphyadd": "821 CHESAPEAKE AVE",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MD",
    "dropphyzpp": 214039998,
    "dropmaladd": "821 CHESAPEAKE AVE",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MD",
    "dropmalzpp": 214039998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4102679821,
    "dropsitcph": 4102679821,
    "dropfax": 4102689186
  },
  {
    "dcode": "D",
    "dropkey": "SV23496",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "2401 ASHTON ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212239998,
    "dropphyadd": "2401 ASHTON ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212239998,
    "dropmaladd": "2401 ASHTON ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212239998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4102332651,
    "dropsitcph": 4102332651,
    "dropfax": 4105662207
  },
  {
    "dcode": "D",
    "dropkey": "SV23508",
    "droptype": "D",
    "dropname": "FRIENDSHIP HEIGHTS",
    "dropdeladd": "5530 WISCONSIN AVE FRNT",
    "dropdelcty": "CHEVY CHASE",
    "dropdelst": "MD",
    "dropdelzpp": 208159997,
    "dropphyadd": "5530 WISCONSIN AVE FRNT",
    "dropphycty": "CHEVY CHASE",
    "dropphyst": "MD",
    "dropphyzpp": 208159997,
    "dropmaladd": "5530 WISCONSIN AVE FRNT",
    "dropmalcty": "CHEVY CHASE",
    "dropmalst": "MD",
    "dropmalzpp": 208159997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019412695,
    "dropsitcph": 3019412695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23586",
    "droptype": "D",
    "dropname": "GOVANS",
    "dropdeladd": "4904 YORK RD",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212129998,
    "dropphyadd": "4904 YORK RD",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212129998,
    "dropmaladd": "4904 YORK RD",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212129998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104350343,
    "dropsitcph": 4104350343,
    "dropfax": 4104336157
  },
  {
    "dcode": "D",
    "dropkey": "SV23626",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "4901 HARFORD RD",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212149998,
    "dropphyadd": "4901 HARFORD RD",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212149998,
    "dropmaladd": "4901 HARFORD RD",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212149998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104261662,
    "dropsitcph": 4104261662,
    "dropfax": 4104267862
  },
  {
    "dcode": "D",
    "dropkey": "SV23628",
    "droptype": "D",
    "dropname": "HAMPDEN ROLAND PARK",
    "dropdeladd": "919 W 34TH ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212119998,
    "dropphyadd": "919 W 34TH ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212119998,
    "dropmaladd": "919 W 34TH ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212119998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104675209,
    "dropsitcph": 4104675209,
    "dropfax": 4102438069
  },
  {
    "dcode": "D",
    "dropkey": "SV23635",
    "droptype": "D",
    "dropname": "HAMPTON PARK",
    "dropdeladd": "9201 EDGEWORTH DR",
    "dropdelcty": "CAPITOL HEIGHTS",
    "dropdelst": "MD",
    "dropdelzpp": 207909201,
    "dropphyadd": "9201 EDGEWORTH DR",
    "dropphycty": "CAPITOL HEIGHTS",
    "dropphyst": "MD",
    "dropphyzpp": 207909201,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAPITOL HEIGHTS",
    "dropmalst": "MD",
    "dropmalzpp": 207919998,
    "dropsitphn": 3014997304,
    "dropsitlph": 3014997304,
    "dropsitcph": 3014997304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23649",
    "droptype": "D",
    "dropname": "HARMANS",
    "dropdeladd": "1225 OLD DORSEY RD",
    "dropdelcty": "HARMANS",
    "dropdelst": "MD",
    "dropdelzpp": 210771501,
    "dropphyadd": "1225 OLD DORSEY RD",
    "dropphycty": "HARMANS",
    "dropphyst": "MD",
    "dropphyzpp": 210771501,
    "dropmaladd": "1225 OLD DORSEY RD",
    "dropmalcty": "HARMANS",
    "dropmalst": "MD",
    "dropmalzpp": 210771501,
    "dropsitphn": 4103474518,
    "dropsitlph": 4108504155,
    "dropsitcph": 4108504155,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "SV23687",
    "droptype": "D",
    "dropname": "HIGHLANDTOWN",
    "dropdeladd": "6221 EASTERN AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212249998,
    "dropphyadd": "6221 EASTERN AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212249998,
    "dropmaladd": "6221 EASTERN AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212249998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106331631,
    "dropsitcph": 4106331631,
    "dropfax": 4106315707
  },
  {
    "dcode": "D",
    "dropkey": "SV23778",
    "droptype": "D",
    "dropname": "KENILWORTH",
    "dropdeladd": "6270 KENILWORTH AVE",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "MD",
    "dropdelzpp": 207379997,
    "dropphyadd": "6270 KENILWORTH AVE",
    "dropphycty": "RIVERDALE",
    "dropphyst": "MD",
    "dropphyzpp": 207379997,
    "dropmaladd": "6270 KENILWORTH AVE",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "MD",
    "dropmalzpp": 207379997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016993215,
    "dropsitcph": 3016993215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23836",
    "droptype": "D",
    "dropname": "KETTERING",
    "dropdeladd": "68 WATKINS PARK DR",
    "dropdelcty": "UPPER MARLBORO",
    "dropdelst": "MD",
    "dropdelzpp": 207749996,
    "dropphyadd": "68 WATKINS PARK DR",
    "dropphycty": "UPPER MARLBORO",
    "dropphyst": "MD",
    "dropphyzpp": 207749996,
    "dropmaladd": "68 WATKINS PARK DR",
    "dropmalcty": "UPPER MARLBORO",
    "dropmalst": "MD",
    "dropmalzpp": 207749996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012494036,
    "dropsitcph": 3012494036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23841",
    "droptype": "D",
    "dropname": "LAUREL MALL",
    "dropdeladd": "14770 BALTIMORE AVE",
    "dropdelcty": "LAUREL",
    "dropdelst": "MD",
    "dropdelzpp": 207079996,
    "dropphyadd": "14770 BALTIMORE AVE",
    "dropphycty": "LAUREL",
    "dropphyst": "MD",
    "dropphyzpp": 207079996,
    "dropmaladd": "123 WASHINGTON BLVD S",
    "dropmalcty": "LAUREL",
    "dropmalst": "MD",
    "dropmalzpp": 207079997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014981567,
    "dropsitcph": 3014981567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23851",
    "droptype": "D",
    "dropname": "LEGION AVENUE",
    "dropdeladd": "210 LEGION AVE",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MD",
    "dropdelzpp": 214019996,
    "dropphyadd": "210 LEGION AVE",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MD",
    "dropphyzpp": 214019996,
    "dropmaladd": "210 LEGION AVE",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MD",
    "dropmalzpp": 214019996,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105736537,
    "dropsitcph": 4105736537,
    "dropfax": 4102809001
  },
  {
    "dcode": "D",
    "dropkey": "SV23855",
    "droptype": "D",
    "dropname": "LEISURE WORLD FINANCE",
    "dropdeladd": "3802 INTERNATIONAL DR",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209061548,
    "dropphyadd": "3802 INTERNATIONAL DR",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209061548,
    "dropmaladd": "3802 INTERNATIONAL DR",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209061548,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014381009,
    "dropsitcph": 3014388741,
    "dropfax": 3015980903
  },
  {
    "dcode": "D",
    "dropkey": "SV23911",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "129 E MAIN ST",
    "dropdelcty": "SALISBURY",
    "dropdelst": "MD",
    "dropdelzpp": 218039998,
    "dropphyadd": "129 E MAIN ST",
    "dropphycty": "SALISBURY",
    "dropphyst": "MD",
    "dropphyzpp": 218039998,
    "dropmaladd": "129 E MAIN ST",
    "dropmalcty": "SALISBURY",
    "dropmalst": "MD",
    "dropmalzpp": 218039998,
    "dropsitphn": 4107637740,
    "dropsitlph": 4107429261,
    "dropsitcph": 4107429261,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV23925",
    "droptype": "D",
    "dropname": "MARKET CENTER",
    "dropdeladd": "130 N GREENE ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212019997,
    "dropphyadd": "130 N GREENE ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212019997,
    "dropmaladd": "130 N GREENE ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212019997,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474202,
    "dropsitcph": 4103474202,
    "dropfax": 4108374363
  },
  {
    "dcode": "D",
    "dropkey": "SV23996",
    "droptype": "D",
    "dropname": "MONTGOMERY VILLAGE",
    "dropdeladd": "10079 STEDWICK RD",
    "dropdelcty": "MONTGOMERY VILLAGE",
    "dropdelst": "MD",
    "dropdelzpp": 208869997,
    "dropphyadd": "10079 STEDWICK RD",
    "dropphycty": "MONTGOMERY VILLAGE",
    "dropphyst": "MD",
    "dropphyzpp": 208869997,
    "dropmaladd": "10079 STEDWICK RD",
    "dropmalcty": "MONTGOMERY VILLAGE",
    "dropmalst": "MD",
    "dropmalzpp": 208869997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083718,
    "dropsitcph": 3012083718,
    "dropfax": 3012083721
  },
  {
    "dcode": "D",
    "dropkey": "SV24019",
    "droptype": "D",
    "dropname": "MOUNT WASHINGTON",
    "dropdeladd": "5730 COTTONWORTH AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212099998,
    "dropphyadd": "5730 COTTONWORTH AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212099998,
    "dropmaladd": "5730 COTTONWORTH AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212099998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103233782,
    "dropsitcph": 4103233782,
    "dropfax": 4104350678
  },
  {
    "dcode": "D",
    "dropkey": "SV24042",
    "droptype": "D",
    "dropname": "NATIONAL NAVAL MED CENTER",
    "dropdeladd": "8901 ROCKVILLE PIKE",
    "dropdelcty": "BETHESDA",
    "dropdelst": "MD",
    "dropdelzpp": 208890003,
    "dropphyadd": "8901 ROCKVILLE PIKE",
    "dropphycty": "BETHESDA",
    "dropphyst": "MD",
    "dropphyzpp": 208890003,
    "dropmaladd": "8901 ROCKVILLE PIKE",
    "dropmalcty": "BETHESDA",
    "dropmalst": "MD",
    "dropmalzpp": 208890003,
    "dropsitphn": "",
    "dropsitlph": 3019412787,
    "dropsitcph": 3019412787,
    "dropfax": 3019412789
  },
  {
    "dcode": "D",
    "dropkey": "SV24076",
    "droptype": "D",
    "dropname": "NORTH COLLEGE PARK",
    "dropdeladd": "9591 BALTIMORE AVE",
    "dropdelcty": "COLLEGE PARK",
    "dropdelst": "MD",
    "dropdelzpp": 207409996,
    "dropphyadd": "9591 BALTIMORE AVE",
    "dropphycty": "COLLEGE PARK",
    "dropphyst": "MD",
    "dropphyzpp": 207409996,
    "dropmaladd": "9591 BALTIMORE AVE",
    "dropmalcty": "COLLEGE PARK",
    "dropmalst": "MD",
    "dropmalzpp": 207409996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3013458923,
    "dropsitcph": 3013458923,
    "dropfax": 3013450036
  },
  {
    "dcode": "D",
    "dropkey": "SV24088",
    "droptype": "D",
    "dropname": "NORTHERN",
    "dropdeladd": "12912 CONAMAR DR",
    "dropdelcty": "HAGERSTOWN",
    "dropdelst": "MD",
    "dropdelzpp": 217429998,
    "dropphyadd": "12912 CONAMAR DR",
    "dropphycty": "HAGERSTOWN",
    "dropphyst": "MD",
    "dropphyzpp": 217429998,
    "dropmaladd": "12912 CONAMAR DR",
    "dropmalcty": "HAGERSTOWN",
    "dropmalst": "MD",
    "dropmalzpp": 217429998,
    "dropsitphn": 3016823129,
    "dropsitlph": 3017339195,
    "dropsitcph": 3017339195,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV24091",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "1800 E NORTHERN PKWY",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212399998,
    "dropphyadd": "1800 E NORTHERN PKWY",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212399998,
    "dropmaladd": "1800 E NORTHERN PKWY",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212399998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103238896,
    "dropsitcph": 4103238896,
    "dropfax": 4105326341
  },
  {
    "dcode": "D",
    "dropkey": "SV24147",
    "droptype": "D",
    "dropname": "FELLS POINT",
    "dropdeladd": "714 S WOLFE ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212319998,
    "dropphyadd": "714 S WOLFE ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212319998,
    "dropmaladd": "714 S WOLFE ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212319998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474293,
    "dropsitcph": 4103474293,
    "dropfax": 4107329442
  },
  {
    "dcode": "D",
    "dropkey": "SV24173",
    "droptype": "D",
    "dropname": "PIKE",
    "dropdeladd": "143 ROLLINS AVE",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208529975,
    "dropphyadd": "143 ROLLINS AVE",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208529975,
    "dropmaladd": "143 ROLLINS AVE",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208529975,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012315973,
    "dropsitcph": 3012315973,
    "dropfax": 3012315972
  },
  {
    "dcode": "D",
    "dropkey": "SV24221",
    "droptype": "D",
    "dropname": "PRINCE GEORGES PLAZA",
    "dropdeladd": "6525 BELCREST RD LBBY 180",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207829996,
    "dropphyadd": "6525 BELCREST RD LBBY 180",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207829996,
    "dropmaladd": "6525 BELCREST RD LBBY 180",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207829996,
    "dropsitphn": 2026364480,
    "dropsitlph": 3017793206,
    "dropsitcph": 3017793206,
    "dropfax": 3012091054
  },
  {
    "dcode": "D",
    "dropkey": "SV24239",
    "droptype": "D",
    "dropname": "RASPEBURG",
    "dropdeladd": "6502 BELAIR RD",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212069998,
    "dropphyadd": "6502 BELAIR RD",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212069998,
    "dropmaladd": "6502 BELAIR RD",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212069998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104260619,
    "dropsitcph": 4104260619,
    "dropfax": 4102544702
  },
  {
    "dcode": "D",
    "dropkey": "SV24246",
    "droptype": "D",
    "dropname": "REISTERSTOWN RD PLAZA",
    "dropdeladd": "6754 REISTERSTOWN RD",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212709998,
    "dropphyadd": "6754 REISTERSTOWN RD",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212709998,
    "dropmaladd": "6754 REISTERSTOWN RD",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212709998,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106534163,
    "dropsitcph": 4106534163,
    "dropfax": 4105423948
  },
  {
    "dcode": "D",
    "dropkey": "SV24301",
    "droptype": "D",
    "dropname": "ROLAND PARK",
    "dropdeladd": "732 DEEPDENE RD",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212109997,
    "dropphyadd": "732 DEEPDENE RD",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212109997,
    "dropmaladd": "732 DEEPDENE RD",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212109997,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104675209,
    "dropsitcph": 4104675209,
    "dropfax": 4102438069
  },
  {
    "dcode": "D",
    "dropkey": "SV24324",
    "droptype": "D",
    "dropname": "SAINT CHARLES CENTER",
    "dropdeladd": "11110 MALL CIR",
    "dropdelcty": "WALDORF",
    "dropdelst": "MD",
    "dropdelzpp": 206034803,
    "dropphyadd": "11110 MALL CIR",
    "dropphycty": "WALDORF",
    "dropphyst": "MD",
    "dropphyzpp": 206034803,
    "dropmaladd": "150 POST OFFICE RD",
    "dropmalcty": "WALDORF",
    "dropmalst": "MD",
    "dropmalzpp": 206029998,
    "dropsitphn": "",
    "dropsitlph": 3019324349,
    "dropsitcph": 3019324349,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV24395",
    "droptype": "D",
    "dropname": "SOUTHEAST",
    "dropdeladd": "340 S HIGHLAND AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212819998,
    "dropphyadd": "340 S HIGHLAND AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212819998,
    "dropmaladd": "340 S HIGHLAND AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212819998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4106333730,
    "dropsitcph": 4106333730,
    "dropfax": 4106338628
  },
  {
    "dcode": "D",
    "dropkey": "SV24433",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "119 VIRGINIA AVE",
    "dropdelcty": "CUMBERLAND",
    "dropdelst": "MD",
    "dropdelzpp": 215039998,
    "dropphyadd": "119 VIRGINIA AVE",
    "dropphycty": "CUMBERLAND",
    "dropphyst": "MD",
    "dropphyzpp": 215039998,
    "dropmaladd": "119 VIRGINIA AVE",
    "dropmalcty": "CUMBERLAND",
    "dropmalst": "MD",
    "dropmalzpp": 215039998,
    "dropsitphn": 3017228190,
    "dropsitlph": 4107225922,
    "dropsitcph": 3017225922,
    "dropfax": 4103474289
  },
  {
    "dcode": "D",
    "dropkey": "SV24525",
    "droptype": "D",
    "dropname": "TWINBROOK",
    "dropdeladd": "2001 VEIRS MILL RD",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208519997,
    "dropphyadd": "2001 VEIRS MILL RD",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208519997,
    "dropmaladd": "2001 VEIRS MILL RD",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208519997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017628536,
    "dropsitcph": 3017628536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV24583",
    "droptype": "D",
    "dropname": "WALBROOK",
    "dropdeladd": "1908 N ELLAMONT ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212169998,
    "dropphyadd": "1908 N ELLAMONT ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212169998,
    "dropmaladd": "1908 N ELLAMONT ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212169998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4105233198,
    "dropsitcph": 4105233198,
    "dropfax": 4105237504
  },
  {
    "dcode": "D",
    "dropkey": "SV24603",
    "droptype": "D",
    "dropname": "WAVERLY",
    "dropdeladd": "3000 HOMEWOOD AVE",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212189998,
    "dropphyadd": "3000 HOMEWOOD AVE",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212189998,
    "dropmaladd": "3000 HOMEWOOD AVE",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212189998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104672136,
    "dropsitcph": 4104672136,
    "dropfax": 4108890379
  },
  {
    "dcode": "D",
    "dropkey": "SV24610",
    "droptype": "D",
    "dropname": "WEST BOWIE",
    "dropdeladd": "13030 9TH ST",
    "dropdelcty": "BOWIE",
    "dropdelst": "MD",
    "dropdelzpp": 207203645,
    "dropphyadd": "13030 9TH ST",
    "dropphycty": "BOWIE",
    "dropphyst": "MD",
    "dropphyzpp": 207203645,
    "dropmaladd": "13030 9TH ST",
    "dropmalcty": "BOWIE",
    "dropmalst": "MD",
    "dropmalzpp": 207203645,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014641611,
    "dropsitcph": 3014641611,
    "dropfax": 3012623143
  },
  {
    "dcode": "D",
    "dropkey": "SV24642",
    "droptype": "D",
    "dropname": "WHITE FLINT MALL",
    "dropdeladd": "11301 ROCKVILLE PIKE STE 111",
    "dropdelcty": "KENSINGTON",
    "dropdelst": "MD",
    "dropdelzpp": 208959997,
    "dropphyadd": "11301 ROCKVILLE PIKE STE 111",
    "dropphycty": "KENSINGTON",
    "dropphyst": "MD",
    "dropphyzpp": 208959997,
    "dropmaladd": "11301 ROCKVILLE PIKE STE 111",
    "dropmalcty": "KENSINGTON",
    "dropmalst": "MD",
    "dropmalzpp": 208959997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012301276,
    "dropsitcph": 3012301276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV24686",
    "droptype": "D",
    "dropname": "WOODMOOR",
    "dropdeladd": "110 UNIVERSITY BLVD W",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209019998,
    "dropphyadd": "110 UNIVERSITY BLVD W",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209019998,
    "dropmaladd": "110 UNIVERSITY BLVD W",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209019998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017542714,
    "dropsitcph": 3017541705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV24839",
    "droptype": "D",
    "dropname": "DOWNTOWN STATION",
    "dropdeladd": "400 CONGRESS ST STE 9998",
    "dropdelcty": "PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041013545",
    "dropphyadd": "400 CONGRESS ST STE 9998",
    "dropphycty": "PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041013545",
    "dropmaladd": "400 CONGRESS ST STE 9998",
    "dropmalcty": "PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041013545",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077610267,
    "dropsitcph": 2077610267,
    "dropfax": 2077610667
  },
  {
    "dcode": "D",
    "dropkey": "SV24918",
    "droptype": "D",
    "dropname": "GREAT FALLS",
    "dropdeladd": "2 GREAT FALLS PLZ UNIT 9998",
    "dropdelcty": "AUBURN",
    "dropdelst": "ME",
    "dropdelzpp": "042105997",
    "dropphyadd": "2 GREAT FALLS PLZ UNIT 9998",
    "dropphycty": "AUBURN",
    "dropphyst": "ME",
    "dropphyzpp": "042105997",
    "dropmaladd": "258 RODMAN RD",
    "dropmalcty": "AUBURN",
    "dropmalst": "ME",
    "dropmalzpp": "042103855",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077863512,
    "dropsitcph": 2077844598,
    "dropfax": 2077834647
  },
  {
    "dcode": "D",
    "dropkey": "SV25204",
    "droptype": "D",
    "dropname": "SOUTH LEWISTON",
    "dropdeladd": "999 LISBON ST",
    "dropdelcty": "LEWISTON",
    "dropdelst": "ME",
    "dropdelzpp": "042405772",
    "dropphyadd": "999 LISBON ST",
    "dropphycty": "LEWISTON",
    "dropphyst": "ME",
    "dropphyzpp": "042405772",
    "dropmaladd": "49 ASH ST",
    "dropmalcty": "LEWISTON",
    "dropmalst": "ME",
    "dropmalzpp": "042407136",
    "dropsitphn": 2075102795,
    "dropsitlph": 2077838552,
    "dropsitcph": 2077838552,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV25225",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "622 CONGRESS ST STE 9998",
    "dropdelcty": "PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041013368",
    "dropphyadd": "622 CONGRESS ST STE 9998",
    "dropphycty": "PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041013368",
    "dropmaladd": "622 CONGRESS ST STE 9998",
    "dropmalcty": "PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041013368",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078718437,
    "dropsitcph": 2077610021,
    "dropfax": 2078718449
  },
  {
    "dcode": "D",
    "dropkey": "SV25274",
    "droptype": "D",
    "dropname": "WATER STREET",
    "dropdeladd": "295 WATER ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "ME",
    "dropdelzpp": "043304611",
    "dropphyadd": "295 WATER ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "ME",
    "dropphyzpp": "043304611",
    "dropmaladd": "40 WESTERN AVE",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "ME",
    "dropmalzpp": "043309998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2076238054,
    "dropsitcph": 2076238054,
    "dropfax": 2076224586
  },
  {
    "dcode": "D",
    "dropkey": "SV25493",
    "droptype": "D",
    "dropname": "GONIC",
    "dropdeladd": "49 PICKERING RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "038399996",
    "dropphyadd": "49 PICKERING RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "038399996",
    "dropmaladd": "20 ALLEN ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "038679998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033325115,
    "dropfax": 6033300824
  },
  {
    "dcode": "D",
    "dropkey": "SV25540",
    "droptype": "D",
    "dropname": "LAKEPORT",
    "dropdeladd": "34 CLINTON ST",
    "dropdelcty": "LACONIA",
    "dropdelst": "NH",
    "dropdelzpp": "032462506",
    "dropphyadd": "34 CLINTON ST",
    "dropphycty": "LACONIA",
    "dropphyst": "NH",
    "dropphyzpp": "032462506",
    "dropmaladd": "33 CHURCH ST UNIT 1",
    "dropmalcty": "LACONIA",
    "dropmalst": "NH",
    "dropmalzpp": "032469997",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6035245508,
    "dropfax": 6035244710
  },
  {
    "dcode": "D",
    "dropkey": "SV25613",
    "droptype": "D",
    "dropname": "PORTSMOUTH NAVAL SHIPYARD",
    "dropdeladd": "15 MCDONOUGH ST",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "NH",
    "dropdelzpp": "038044000",
    "dropphyadd": "15 MCDONOUGH ST",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "NH",
    "dropphyzpp": "038044000",
    "dropmaladd": "15 MCDONOUGH ST",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "NH",
    "dropmalzpp": "038044000",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 2074383941,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV25663",
    "droptype": "D",
    "dropname": "PENACOOK",
    "dropdeladd": "15 VILLAGE ST STE 4",
    "dropdelcty": "CONCORD",
    "dropdelst": "NH",
    "dropdelzpp": "033039997",
    "dropphyadd": "15 VILLAGE ST STE 4",
    "dropphycty": "CONCORD",
    "dropphyst": "NH",
    "dropphyzpp": "033039997",
    "dropmaladd": "15 VILLAGE ST STE 4",
    "dropmalcty": "CONCORD",
    "dropmalst": "NH",
    "dropmalzpp": "033039997",
    "dropsitphn": 6036444139,
    "dropsitlph": 6036444128,
    "dropsitcph": 6037534843,
    "dropfax": 6032288309
  },
  {
    "dcode": "D",
    "dropkey": "SV25726",
    "droptype": "D",
    "dropname": "NASHUA SOUTH",
    "dropdeladd": "254 DANIEL WEBSTER HWY UNIT 1",
    "dropdelcty": "NASHUA",
    "dropdelst": "NH",
    "dropdelzpp": "030609996",
    "dropphyadd": "254 DANIEL WEBSTER HWY UNIT 1",
    "dropphycty": "NASHUA",
    "dropphyst": "NH",
    "dropphyzpp": "030609996",
    "dropmaladd": "254 DANIEL WEBSTER HWY UNIT 1",
    "dropmalcty": "NASHUA",
    "dropmalst": "NH",
    "dropmalzpp": "030609996",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6038887833,
    "dropfax": 6038883157
  },
  {
    "dcode": "D",
    "dropkey": "SV25797",
    "droptype": "D",
    "dropname": "WEIRS BEACH",
    "dropdeladd": "36 ENDICOTT ST E UNIT 1",
    "dropdelcty": "LACONIA",
    "dropdelst": "NH",
    "dropdelzpp": "032469995",
    "dropphyadd": "36 ENDICOTT ST E UNIT 1",
    "dropphycty": "LACONIA",
    "dropphyst": "NH",
    "dropphyzpp": "032469995",
    "dropmaladd": "33 CHURCH ST UNIT 2",
    "dropmalcty": "LACONIA",
    "dropmalst": "NH",
    "dropmalzpp": "032469996",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6033664424,
    "dropfax": 6035244710
  },
  {
    "dcode": "D",
    "dropkey": "SV25804",
    "droptype": "D",
    "dropname": "WEST FRANKLIN",
    "dropdeladd": "73 N MAIN ST",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "NH",
    "dropdelzpp": "03235",
    "dropphyadd": "73 N MAIN ST",
    "dropphycty": "FRANKLIN",
    "dropphyst": "NH",
    "dropphyzpp": "03235",
    "dropmaladd": "65 FRANKLIN ST BLDG 2",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "NH",
    "dropmalzpp": "032359997",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6039344108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV25835",
    "droptype": "D",
    "dropname": "ANNEX FINANCE",
    "dropdeladd": "2 EXCHANGE TER",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029031701",
    "dropphyadd": "2 EXCHANGE TER",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029031701",
    "dropmaladd": "2 EXCHANGE TER",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029031701",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014217083,
    "dropfax": 4012735844
  },
  {
    "dcode": "D",
    "dropkey": "SV25845",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "169 BROADWAY",
    "dropdelcty": "NEWPORT",
    "dropdelst": "RI",
    "dropdelzpp": "028409994",
    "dropphyadd": "169 BROADWAY",
    "dropphycty": "NEWPORT",
    "dropphyst": "RI",
    "dropphyzpp": "028409994",
    "dropmaladd": "169 BROADWAY",
    "dropmalcty": "NEWPORT",
    "dropmalst": "RI",
    "dropmalzpp": "028409994",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018467865,
    "dropfax": 4018491377
  },
  {
    "dcode": "D",
    "dropkey": "SV25864",
    "droptype": "D",
    "dropname": "DARLINGTON",
    "dropdeladd": "30 MONTICELLO RD",
    "dropdelcty": "PAWTUCKET",
    "dropdelst": "RI",
    "dropdelzpp": "028613810",
    "dropphyadd": "30 MONTICELLO RD",
    "dropphycty": "PAWTUCKET",
    "dropphyst": "RI",
    "dropphyzpp": "028613810",
    "dropmaladd": "30 MONTICELLO RD",
    "dropmalcty": "PAWTUCKET",
    "dropmalst": "RI",
    "dropmalzpp": "028613810",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017249426,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV25872",
    "droptype": "D",
    "dropname": "WASHINGTON PARK",
    "dropdeladd": "1284 BROAD ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029052999",
    "dropphyadd": "1284 BROAD ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029052999",
    "dropmaladd": "1284 BROAD ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029052999",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014612676,
    "dropfax": 4014618380
  },
  {
    "dcode": "D",
    "dropkey": "SV25873",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "820 ELMWOOD AVE",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029079998",
    "dropphyadd": "820 ELMWOOD AVE",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029079998",
    "dropmaladd": "820 ELMWOOD AVE",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029079998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4019413421,
    "dropfax": 4019411787
  },
  {
    "dcode": "D",
    "dropkey": "SV25882",
    "droptype": "D",
    "dropname": "FRIAR",
    "dropdeladd": "333 EATON ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029082825",
    "dropphyadd": "333 EATON ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029082825",
    "dropmaladd": "333 EATON ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029082825",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018652447,
    "dropfax": 4017510587
  },
  {
    "dcode": "D",
    "dropkey": "SV25892",
    "droptype": "D",
    "dropname": "HIGH ST",
    "dropdeladd": "5 HIGH ST",
    "dropdelcty": "WESTERLY",
    "dropdelst": "RI",
    "dropdelzpp": "028911878",
    "dropphyadd": "5 HIGH ST",
    "dropphycty": "WESTERLY",
    "dropphyst": "RI",
    "dropphyzpp": "028911878",
    "dropmaladd": "5 HIGH ST",
    "dropmalcty": "WESTERLY",
    "dropmalst": "RI",
    "dropmalzpp": "028911878",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015969537,
    "dropfax": 4015962872
  },
  {
    "dcode": "D",
    "dropkey": "SV25927",
    "droptype": "D",
    "dropname": "OLNEYVILLE",
    "dropdeladd": "100 HARTFORD AVE",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029099998",
    "dropphyadd": "100 HARTFORD AVE",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029099998",
    "dropmaladd": "100 HARTFORD AVE",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029099998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018316294,
    "dropfax": 4014535345
  },
  {
    "dcode": "D",
    "dropkey": "SV25931",
    "droptype": "D",
    "dropname": "PILGRIM",
    "dropdeladd": "850 POST RD",
    "dropdelcty": "WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028889997",
    "dropphyadd": "850 POST RD",
    "dropphycty": "WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028889997",
    "dropmaladd": "850 POST RD",
    "dropmalcty": "WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028889997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017813856,
    "dropfax": 4014681078
  },
  {
    "dcode": "D",
    "dropkey": "SV25972",
    "droptype": "D",
    "dropname": "WATCH HILL",
    "dropdeladd": "108 BAY ST",
    "dropdelcty": "WESTERLY",
    "dropdelst": "RI",
    "dropdelzpp": "028915749",
    "dropphyadd": "108 BAY ST",
    "dropphycty": "WESTERLY",
    "dropphyst": "RI",
    "dropphyzpp": "028915749",
    "dropmaladd": "108 BAY ST",
    "dropmalcty": "WESTERLY",
    "dropmalst": "RI",
    "dropmalzpp": "028915749",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4015969537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV25979",
    "droptype": "D",
    "dropname": "WEYBOSSET HILL",
    "dropdeladd": "53 BROAD ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029034102",
    "dropphyadd": "53 BROAD ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029034102",
    "dropmaladd": "53 BROAD ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029034102",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013311453,
    "dropfax": 4013319741
  },
  {
    "dcode": "D",
    "dropkey": "SV26618",
    "droptype": "D",
    "dropname": "LYMAN",
    "dropdeladd": "27 S MAIN ST",
    "dropdelcty": "WHITE RIVER JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "050019995",
    "dropphyadd": "27 S MAIN ST",
    "dropphycty": "WHITE RIVER JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "050019995",
    "dropmaladd": "27 S MAIN ST",
    "dropmalcty": "WHITE RIVER JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "050019995",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022963246,
    "dropsitcph": 8022952703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV26770",
    "droptype": "D",
    "dropname": "NORTH BRATTLEBORO",
    "dropdeladd": "1222 PUTNEY RD",
    "dropdelcty": "BRATTLEBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053018792",
    "dropphyadd": "1222 PUTNEY RD",
    "dropphycty": "BRATTLEBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053018792",
    "dropmaladd": "204 MAIN ST STE JJ",
    "dropmalcty": "BRATTLEBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022546460,
    "dropsitcph": 8022544110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV26839",
    "droptype": "D",
    "dropname": "PEARL STREET",
    "dropdeladd": "78 PEARL ST",
    "dropdelcty": "ESSEX JUNCTION",
    "dropdelst": "VT",
    "dropdelzpp": "054539700",
    "dropphyadd": "78 PEARL ST",
    "dropphycty": "ESSEX JUNCTION",
    "dropphyst": "VT",
    "dropphyzpp": "054539700",
    "dropmaladd": "78 PEARL ST",
    "dropmalcty": "ESSEX JUNCTION",
    "dropmalst": "VT",
    "dropmalzpp": "054539700",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028783085,
    "dropsitcph": 8028797794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27211",
    "droptype": "D",
    "dropname": "WEST BRATTLEBORO",
    "dropdeladd": "1037 WESTERN AVE STE 2",
    "dropdelcty": "BRATTLEBORO",
    "dropdelst": "VT",
    "dropdelzpp": "053019904",
    "dropphyadd": "1037 WESTERN AVE STE 2",
    "dropphycty": "BRATTLEBORO",
    "dropphyst": "VT",
    "dropphyzpp": "053019904",
    "dropmaladd": "204 MAIN ST STE JJ",
    "dropmalcty": "BRATTLEBORO",
    "dropmalst": "VT",
    "dropmalzpp": "053019998",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022546460,
    "dropsitcph": 8022545922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27315",
    "droptype": "D",
    "dropname": "DOWNTOWN",
    "dropdeladd": "1000 ELM ST STE 15104",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "031019715",
    "dropphyadd": "1000 ELM ST STE 15104",
    "dropphycty": "MANCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "031019715",
    "dropmaladd": "1000 ELM ST STE 15104",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "031019715",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036233681,
    "dropfax": 6036471590
  },
  {
    "dcode": "D",
    "dropkey": "SV27325",
    "droptype": "D",
    "dropname": "WOBURN CENTER",
    "dropdeladd": "2 ABBOTT ST",
    "dropdelcty": "WOBURN",
    "dropdelst": "MA",
    "dropdelzpp": "018019991",
    "dropphyadd": "2 ABBOTT ST",
    "dropphycty": "WOBURN",
    "dropphyst": "MA",
    "dropphyzpp": "018019991",
    "dropmaladd": "2 ABBOTT ST",
    "dropmalcty": "WOBURN",
    "dropmalst": "MA",
    "dropmalzpp": "018019991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7819331114,
    "dropfax": 7819335338
  },
  {
    "dcode": "D",
    "dropkey": "SV27329",
    "droptype": "D",
    "dropname": "NANTUCKET STATION 1",
    "dropdeladd": "144 PLEASANT ST",
    "dropdelcty": "NANTUCKET",
    "dropdelst": "MA",
    "dropdelzpp": "025849800",
    "dropphyadd": "144 PLEASANT ST",
    "dropphycty": "NANTUCKET",
    "dropphyst": "MA",
    "dropphyzpp": "025849800",
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NANTUCKET",
    "dropmalst": "MA",
    "dropmalzpp": "025849998",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082284477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27333",
    "droptype": "D",
    "dropname": "MIDTOWN MALL",
    "dropdeladd": "22 FRONT ST",
    "dropdelcty": "WORCESTER",
    "dropdelst": "MA",
    "dropdelzpp": "016141401",
    "dropphyadd": "22 FRONT ST",
    "dropphycty": "WORCESTER",
    "dropphyst": "MA",
    "dropphyzpp": "016141401",
    "dropmaladd": "22 FRONT ST",
    "dropmalcty": "WORCESTER",
    "dropmalst": "MA",
    "dropmalzpp": "016141401",
    "dropsitphn": 5086647013,
    "dropsitlph": 5087953751,
    "dropsitcph": 5087569156,
    "dropfax": 5087959156
  },
  {
    "dcode": "D",
    "dropkey": "SV27385",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "357 COMMERCE DR",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "CT",
    "dropdelzpp": "068259998",
    "dropphyadd": "357 COMMERCE DR",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "CT",
    "dropphyzpp": "068259998",
    "dropmaladd": "357 COMMERCE DR",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "CT",
    "dropmalzpp": "068259998",
    "dropsitphn": 2033324546,
    "dropsitlph": 2303324546,
    "dropsitcph": 2033324546,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27396",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "1701 PRESIDENT AVE",
    "dropdelcty": "FALL RIVER",
    "dropdelst": "MA",
    "dropdelzpp": "027207114",
    "dropphyadd": "1701 PRESIDENT AVE",
    "dropphycty": "FALL RIVER",
    "dropphyst": "MA",
    "dropphyzpp": "027207114",
    "dropmaladd": "1701 PRESIDENT AVE",
    "dropmalcty": "FALL RIVER",
    "dropmalst": "MA",
    "dropmalzpp": "027207114",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086752851,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27410",
    "droptype": "D",
    "dropname": "BURLINGTON CHAMPLAIN",
    "dropdeladd": "370 SHELBURNE RD STE 4",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054019712",
    "dropphyadd": "370 SHELBURNE RD STE 4",
    "dropphycty": "BURLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054019712",
    "dropmaladd": "370 SHELBURNE RD STE 4",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054019712",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026581176,
    "dropsitcph": 8028636556,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27444",
    "droptype": "D",
    "dropname": "YORK BEACH",
    "dropdeladd": "420 RIDGE RD",
    "dropdelcty": "YORK BEACH",
    "dropdelst": "ME",
    "dropdelzpp": "039109998",
    "dropphyadd": "420 RIDGE RD",
    "dropphycty": "YORK BEACH",
    "dropphyst": "ME",
    "dropphyzpp": "039109998",
    "dropmaladd": "420 RIDGE RD",
    "dropmalcty": "YORK BEACH",
    "dropmalst": "ME",
    "dropmalzpp": "039109998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073634953,
    "dropsitcph": 2073634491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27457",
    "droptype": "D",
    "dropname": "EAST SIDE",
    "dropdeladd": "306 THAYER ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029061590",
    "dropphyadd": "306 THAYER ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029061590",
    "dropmaladd": "306 THAYER ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029061590",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017512301,
    "dropfax": 4018310595
  },
  {
    "dcode": "D",
    "dropkey": "SV27458",
    "droptype": "D",
    "dropname": "NORTH STATION",
    "dropdeladd": "351 SMITH ST",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029083700",
    "dropphyadd": "351 SMITH ST",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029083700",
    "dropmaladd": "351 SMITH ST",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029083700",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4013319253,
    "dropfax": 4017510299
  },
  {
    "dcode": "D",
    "dropkey": "SV27487",
    "droptype": "D",
    "dropname": "TAUNTON FINANCE",
    "dropdeladd": "37 TAUNTON GRN",
    "dropdelcty": "TAUNTON",
    "dropdelst": "MA",
    "dropdelzpp": "027803226",
    "dropphyadd": "37 TAUNTON GRN",
    "dropphycty": "TAUNTON",
    "dropphyst": "MA",
    "dropphyzpp": "027803226",
    "dropmaladd": "37 TAUNTON GRN",
    "dropmalcty": "TAUNTON",
    "dropmalst": "MA",
    "dropmalzpp": "027803226",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088236028,
    "dropfax": 5088226588
  },
  {
    "dcode": "D",
    "dropkey": "SV27496",
    "droptype": "D",
    "dropname": "APPONAUG",
    "dropdeladd": "3205 POST RD",
    "dropdelcty": "WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028867157",
    "dropphyadd": "3205 POST RD",
    "dropphycty": "WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028867157",
    "dropmaladd": "3205 POST RD",
    "dropmalcty": "WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028867157",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017328736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27497",
    "droptype": "D",
    "dropname": "WALNUT HILL",
    "dropdeladd": "1500 DIAMOND HILL RD UNIT M",
    "dropdelcty": "WOONSOCKET",
    "dropdelst": "RI",
    "dropdelzpp": "028951537",
    "dropphyadd": "1500 DIAMOND HILL RD UNIT M",
    "dropphycty": "WOONSOCKET",
    "dropphyst": "RI",
    "dropphyzpp": "028951537",
    "dropmaladd": "1500 DIAMOND HILL RD UNIT M",
    "dropmalcty": "WOONSOCKET",
    "dropmalst": "RI",
    "dropmalzpp": "028951537",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017668651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27517",
    "droptype": "D",
    "dropname": "LISBON FALLS",
    "dropdeladd": "13 MAIN ST STE 9998",
    "dropdelcty": "LISBON FALLS",
    "dropdelst": "ME",
    "dropdelzpp": "042529998",
    "dropphyadd": "13 MAIN ST STE 9998",
    "dropphycty": "LISBON FALLS",
    "dropphyst": "ME",
    "dropphyzpp": "042529998",
    "dropmaladd": "331 LISBON ST",
    "dropmalcty": "LISBON",
    "dropmalst": "ME",
    "dropmalzpp": "042509998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2073534395,
    "dropsitcph": 2073534395,
    "dropfax": 2073539375
  },
  {
    "dcode": "D",
    "dropkey": "SV27584",
    "droptype": "D",
    "dropname": "HUDSON MALL",
    "dropdeladd": "77 DERRY ST STE 13",
    "dropdelcty": "HUDSON",
    "dropdelst": "NH",
    "dropdelzpp": "030513798",
    "dropphyadd": "77 DERRY ST STE 13",
    "dropphycty": "HUDSON",
    "dropphyst": "NH",
    "dropphyzpp": "030513798",
    "dropmaladd": "77 DERRY ST STE 13",
    "dropmalcty": "HUDSON",
    "dropmalst": "NH",
    "dropmalzpp": "030513798",
    "dropsitphn": 6036444128,
    "dropsitlph": 6038835621,
    "dropsitcph": 6038835621,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27614",
    "droptype": "D",
    "dropname": "WEST BETHEL",
    "dropdeladd": "737 W BETHEL RD",
    "dropdelcty": "WEST BETHEL",
    "dropdelst": "ME",
    "dropdelzpp": "042869998",
    "dropphyadd": "737 W BETHEL RD",
    "dropphycty": "WEST BETHEL",
    "dropphyst": "ME",
    "dropphyzpp": "042869998",
    "dropmaladd": "737 W BETHEL RD",
    "dropmalcty": "WEST BETHEL",
    "dropmalst": "ME",
    "dropmalzpp": "042869998",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078242668,
    "dropsitcph": 2078242668,
    "dropfax": 2078242023
  },
  {
    "dcode": "D",
    "dropkey": "SV27653",
    "droptype": "D",
    "dropname": "PRICHARD PLAZA",
    "dropdeladd": "477 MAIN ST",
    "dropdelcty": "FITCHBURG",
    "dropdelst": "MA",
    "dropdelzpp": "014208037",
    "dropphyadd": "477 MAIN ST",
    "dropphycty": "FITCHBURG",
    "dropphyst": "MA",
    "dropphyzpp": "014208037",
    "dropmaladd": "477 MAIN ST",
    "dropmalcty": "FITCHBURG",
    "dropmalst": "MA",
    "dropmalzpp": "014208037",
    "dropsitphn": 5086647013,
    "dropsitlph": 5086647013,
    "dropsitcph": 9783450864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27703",
    "droptype": "D",
    "dropname": "FREDERICK DOUGLASS",
    "dropdeladd": "2833 ALABAMA AVE SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200209995,
    "dropphyadd": "2833 ALABAMA AVE SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200209995,
    "dropmaladd": "2833 ALABAMA AVE SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200209995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2028424959,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV27722",
    "droptype": "D",
    "dropname": "NATICK STATION",
    "dropdeladd": "15 COMMON ST",
    "dropdelcty": "NATICK",
    "dropdelst": "MA",
    "dropdelzpp": "017604762",
    "dropphyadd": "15 COMMON ST",
    "dropphycty": "NATICK",
    "dropphyst": "MA",
    "dropphyzpp": "017604762",
    "dropmaladd": "15 COMMON ST",
    "dropmalcty": "NATICK",
    "dropmalst": "MA",
    "dropmalzpp": "017604762",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 5086471864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV28208",
    "droptype": "D",
    "dropname": "ROBINSON STREET",
    "dropdeladd": "238 ROBINSON ST",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "RI",
    "dropdelzpp": "028793549",
    "dropphyadd": "238 ROBINSON ST",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "RI",
    "dropphyzpp": "028793549",
    "dropmaladd": "238 ROBINSON ST",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "RI",
    "dropmalzpp": "028793549",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017832691,
    "dropfax": 4017835059
  },
  {
    "dcode": "D",
    "dropkey": "SV28215",
    "droptype": "D",
    "dropname": "CUMMINGS CENTER",
    "dropdeladd": "100 CUMMINGS CTR STE 108F",
    "dropdelcty": "BEVERLY",
    "dropdelst": "MA",
    "dropdelzpp": "019159993",
    "dropphyadd": "100 CUMMINGS CTR STE 108F",
    "dropphycty": "BEVERLY",
    "dropphyst": "MA",
    "dropphyzpp": "019159993",
    "dropmaladd": "100 CUMMINGS CTR STE 108F",
    "dropmalcty": "BEVERLY",
    "dropmalst": "MA",
    "dropmalzpp": "019159993",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9789224533,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV28216",
    "droptype": "D",
    "dropname": "RIVER TERRACE",
    "dropdeladd": "3621 BENNING RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200199998,
    "dropphyadd": "3621 BENNING RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200199998,
    "dropmaladd": "3621 BENNING RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200199998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232984,
    "dropsitcph": 2025232988,
    "dropfax": 2028424929
  },
  {
    "dcode": "D",
    "dropkey": "SV28228",
    "droptype": "D",
    "dropname": "COLUMBIA HEIGHTS",
    "dropdeladd": "3321 GEORGIA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200109998,
    "dropphyadd": "3321 GEORGIA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200109998,
    "dropmaladd": "3321 GEORGIA AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200109998,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232674,
    "dropsitcph": 2025232674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV28249",
    "droptype": "D",
    "dropname": "CODMAN SQUARE",
    "dropdeladd": "554 WASHINGTON ST",
    "dropdelcty": "DORCHESTER CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "021249997",
    "dropphyadd": "554 WASHINGTON ST",
    "dropphycty": "DORCHESTER CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "021249997",
    "dropmaladd": "554 WASHINGTON ST",
    "dropmalcty": "DORCHESTER CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "021249997",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6179294144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV28255",
    "droptype": "D",
    "dropname": "DEVENS",
    "dropdeladd": "240 BARNUM RD",
    "dropdelcty": "DEVENS",
    "dropdelst": "MA",
    "dropdelzpp": "014345223",
    "dropphyadd": "240 BARNUM RD",
    "dropphycty": "DEVENS",
    "dropphyst": "MA",
    "dropphyzpp": "014345223",
    "dropmaladd": "240 BARNUM RD",
    "dropmalcty": "DEVENS",
    "dropmalst": "MA",
    "dropmalzpp": "014345223",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9787723686,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SV28270",
    "droptype": "D",
    "dropname": "NARRAGANSETT",
    "dropdeladd": "551 KINGSTOWN RD",
    "dropdelcty": "WAKEFIELD",
    "dropdelst": "RI",
    "dropdelzpp": "028799992",
    "dropphyadd": "551 KINGSTOWN RD",
    "dropphycty": "WAKEFIELD",
    "dropphyst": "RI",
    "dropphyzpp": "028799992",
    "dropmaladd": "551 KINGSTOWN RD",
    "dropmalcty": "WAKEFIELD",
    "dropmalst": "RI",
    "dropmalzpp": "028799992",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017898613,
    "dropfax": 4017824060
  },
  {
    "dcode": "D",
    "dropkey": "SV28277",
    "droptype": "D",
    "dropname": "PILGRIM CARRIERS",
    "dropdeladd": "325 STRAWBERRY FIELD RD",
    "dropdelcty": "WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028869995",
    "dropphyadd": "325 STRAWBERRY FIELD RD",
    "dropphycty": "WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028869995",
    "dropmaladd": "325 STRAWBERRY FIELD RD",
    "dropmalcty": "WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028869995",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4014681010,
    "dropfax": 4014681078
  },
  {
    "dcode": "D",
    "dropkey": "SV28279",
    "droptype": "D",
    "dropname": "CONIMICUT",
    "dropdeladd": "805 W SHORE RD",
    "dropdelcty": "WARWICK",
    "dropdelst": "RI",
    "dropdelzpp": "028899997",
    "dropphyadd": "805 W SHORE RD",
    "dropphycty": "WARWICK",
    "dropphyst": "RI",
    "dropphyzpp": "028899997",
    "dropmaladd": "805 W SHORE RD",
    "dropmalcty": "WARWICK",
    "dropmalst": "RI",
    "dropmalzpp": "028899997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017385850,
    "dropfax": 4017385850
  },
  {
    "dcode": "D",
    "dropkey": "SW1A203",
    "droptype": "D",
    "dropname": "SADDLE CREEK",
    "dropdeladd": "608 N SADDLE CREEK RD",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681329998,
    "dropphyadd": "608 N SADDLE CREEK RD",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681329998,
    "dropmaladd": "608 N SADDLE CREEK RD",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681329998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025511048,
    "dropsitcph": 4025515158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1A253",
    "droptype": "D",
    "dropname": "SOUTH OMAHA",
    "dropdeladd": "4730 S 24TH ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681079998,
    "dropphyadd": "4730 S 24TH ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681079998,
    "dropmaladd": "4730 S 24TH ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4027338929,
    "dropsitcph": 4027319382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1A301",
    "droptype": "D",
    "dropname": "STATE HOUSE",
    "dropdeladd": "301 CENTENNIAL MALL S",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685082529,
    "dropphyadd": "301 CENTENNIAL MALL S",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685082529,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685099998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024581819,
    "dropsitcph": 4024581819,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": "SW1A377",
    "droptype": "D",
    "dropname": "UNIVERSITY PLACE",
    "dropdeladd": "2427 N 48TH ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685043628,
    "dropphyadd": "2427 N 48TH ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685043603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685049998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024581814,
    "dropsitcph": 4024581886,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": "SW1A416",
    "droptype": "D",
    "dropname": "WEBB PLAZA",
    "dropdeladd": "2418 N WEBB RD STE J",
    "dropdelcty": "GRAND ISLAND",
    "dropdelst": "NE",
    "dropdelzpp": 688031748,
    "dropphyadd": "2418 N WEBB RD STE J",
    "dropphycty": "GRAND ISLAND",
    "dropphyst": "NE",
    "dropphyzpp": 688031748,
    "dropmaladd": "2418 N WEBB RD STE J",
    "dropmalcty": "GRAND ISLAND",
    "dropmalst": "NE",
    "dropmalzpp": 688031748,
    "dropsitphn": 3083856581,
    "dropsitlph": 3083856581,
    "dropsitcph": 3083856581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1A422",
    "droptype": "D",
    "dropname": "WEST OMAHA",
    "dropdeladd": "8451 W CENTER RD",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681243135,
    "dropphyadd": "8451 W CENTER RD",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681243135,
    "dropmaladd": "8451 W CENTER RD",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681243135,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023900992,
    "dropsitcph": 4023938603,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1A651",
    "droptype": "D",
    "dropname": "ABERDEEN DOWNTOWN",
    "dropdeladd": "102 4TH AVE SE",
    "dropdelcty": "ABERDEEN",
    "dropdelst": "SD",
    "dropdelzpp": 574014309,
    "dropphyadd": "102 4TH AVE SE",
    "dropphycty": "ABERDEEN",
    "dropphyst": "SD",
    "dropphyzpp": 574014309,
    "dropmaladd": "102 4TH AVE SE",
    "dropmalcty": "ABERDEEN",
    "dropmalst": "SD",
    "dropmalzpp": 574014309,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 6052262673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B294",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "124 E 8TH AVE",
    "dropdelcty": "CHEYENNE",
    "dropdelst": "WY",
    "dropdelzpp": 820019981,
    "dropphyadd": "124 E 8TH AVE",
    "dropphycty": "CHEYENNE",
    "dropphyst": "WY",
    "dropphyzpp": 820019981,
    "dropmaladd": "124 E 8TH AVE",
    "dropmalcty": "CHEYENNE",
    "dropmalst": "WY",
    "dropmalzpp": 820019981,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077726582,
    "dropsitcph": 3077787756,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B568",
    "droptype": "D",
    "dropname": "DOWNTOWN JACKSON",
    "dropdeladd": "220 W PEARL AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "WY",
    "dropdelzpp": 830019998,
    "dropphyadd": "220 W PEARL AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "WY",
    "dropphyzpp": 830019998,
    "dropmaladd": "220 W PEARL AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "WY",
    "dropmalzpp": 830019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072647215,
    "dropsitcph": 3077391740,
    "dropfax": 3077391728
  },
  {
    "dcode": "D",
    "dropkey": "SW1B597",
    "droptype": "D",
    "dropname": "MORGAN PARK",
    "dropdeladd": "1805 W MONTEREY AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606439998,
    "dropphyadd": "1805 W MONTEREY AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606439998,
    "dropmaladd": "1805 W MONTEREY AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606439998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732382791,
    "dropfax": 7732383791
  },
  {
    "dcode": "D",
    "dropkey": "SW1B615",
    "droptype": "D",
    "dropname": "LOOP CARRIER ANNEX",
    "dropdeladd": "433 W HARRISON ST FL 3E",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606999909,
    "dropphyadd": "433 W HARRISON ST FL 3E",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999909,
    "dropmaladd": "433 W HARRISON ST FL 3E",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999909,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3129838000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B666",
    "droptype": "D",
    "dropname": "DOWNTOWN CASPER",
    "dropdeladd": "150 E B ST LBBY",
    "dropdelcty": "CASPER",
    "dropdelst": "WY",
    "dropdelzpp": 826019998,
    "dropphyadd": "150 E B ST LBBY",
    "dropphycty": "CASPER",
    "dropphyst": "WY",
    "dropphyzpp": 826019998,
    "dropmaladd": "150 E B ST LBBY",
    "dropmalcty": "CASPER",
    "dropmalst": "WY",
    "dropmalzpp": 826019998,
    "dropsitphn": 3077726524,
    "dropsitlph": 3072664034,
    "dropsitcph": 3072664034,
    "dropfax": 3072662875
  },
  {
    "dcode": "D",
    "dropkey": "SW1B700",
    "droptype": "D",
    "dropname": "CAPITOL STA",
    "dropdeladd": "2120 CAPITOL AVE STE 1108",
    "dropdelcty": "CHEYENNE",
    "dropdelst": "WY",
    "dropdelzpp": 820019996,
    "dropphyadd": "2120 CAPITOL AVE STE 1108",
    "dropphycty": "CHEYENNE",
    "dropphyst": "WY",
    "dropphyzpp": 820019996,
    "dropmaladd": "2120 CAPITOL AVE STE 1108",
    "dropmalcty": "CHEYENNE",
    "dropmalst": "WY",
    "dropmalzpp": 820019996,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077726544,
    "dropsitcph": 3076388035,
    "dropfax": 3077726599
  },
  {
    "dcode": "D",
    "dropkey": "SW1B707",
    "droptype": "D",
    "dropname": "GALENA SQUARE",
    "dropdeladd": "901 GALENA SQUARE DR",
    "dropdelcty": "GALENA",
    "dropdelst": "IL",
    "dropdelzpp": 610361359,
    "dropphyadd": "901 GALENA SQUARE DR",
    "dropphycty": "GALENA",
    "dropphyst": "IL",
    "dropphyzpp": 610361359,
    "dropmaladd": "901 GALENA SQUARE DR",
    "dropmalcty": "GALENA",
    "dropmalst": "IL",
    "dropmalzpp": 610361359,
    "dropsitphn": 6302605499,
    "dropsitlph": 8157771584,
    "dropsitcph": 8157771584,
    "dropfax": 8157771647
  },
  {
    "dcode": "D",
    "dropkey": "SW1B764",
    "droptype": "D",
    "dropname": "SKOKIE POSTAL STORE",
    "dropdeladd": "9318 SKOKIE BLVD",
    "dropdelcty": "SKOKIE",
    "dropdelst": "IL",
    "dropdelzpp": 600771300,
    "dropphyadd": "9318 SKOKIE BLVD",
    "dropphycty": "SKOKIE",
    "dropphyst": "IL",
    "dropphyzpp": 600771300,
    "dropmaladd": "9318 SKOKIE BLVD",
    "dropmalcty": "SKOKIE",
    "dropmalst": "IL",
    "dropmalzpp": 600771300,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8476762232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B767",
    "droptype": "D",
    "dropname": "LOMBARD YORKTOWN",
    "dropdeladd": "226 YORKTOWN SHOPPING CTR",
    "dropdelcty": "LOMBARD",
    "dropdelst": "IL",
    "dropdelzpp": 601485534,
    "dropphyadd": "226 YORKTOWN SHOPPING CTR",
    "dropphycty": "LOMBARD",
    "dropphyst": "IL",
    "dropphyzpp": 601485534,
    "dropmaladd": "226 YORKTOWN SHOPPING CTR",
    "dropmalcty": "LOMBARD",
    "dropmalst": "IL",
    "dropmalzpp": 601485534,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306205317,
    "dropsitcph": 6306205317,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B771",
    "droptype": "D",
    "dropname": "MORGAN STREET",
    "dropdeladd": "2323 FOREST AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503113113,
    "dropphyadd": "2323 FOREST AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503113113,
    "dropmaladd": "2323 FOREST AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503113113,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152883508,
    "dropsitcph": 5152807926,
    "dropfax": 5152886256
  },
  {
    "dcode": "D",
    "dropkey": "SW1B854",
    "droptype": "D",
    "dropname": "COLUMBIA MALL STA",
    "dropdeladd": "2300 BERNADETTE DR STE 200",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652039998,
    "dropphyadd": "2300 BERNADETTE DR STE 200",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652039998,
    "dropmaladd": "2300 BERNADETTE DR STE 200",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652039998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734470101,
    "dropsitcph": 5734470101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B886",
    "droptype": "D",
    "dropname": "NEWTOWN",
    "dropdeladd": "937 W DIVERSEY PKWY",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606141439,
    "dropphyadd": "937 W DIVERSEY PKWY",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606141439,
    "dropmaladd": "937 W DIVERSEY PKWY",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606141439,
    "dropsitphn": 3127653310,
    "dropsitlph": 7735255965,
    "dropsitcph": 7735250863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B887",
    "droptype": "D",
    "dropname": "LINCOLN PARK POSTAL STORE",
    "dropdeladd": "2405 N SHEFFIELD AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606142591,
    "dropphyadd": "2405 N SHEFFIELD AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606142591,
    "dropmaladd": "2405 N SHEFFIELD AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606142591,
    "dropsitphn": 7735520863,
    "dropsitlph": 3127653225,
    "dropsitcph": 7739292680,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1B997",
    "droptype": "D",
    "dropname": "ST CHARLES EAST SIDE STATION",
    "dropdeladd": "616 E MAIN ST",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "IL",
    "dropdelzpp": 601742165,
    "dropphyadd": "616 E MAIN ST",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "IL",
    "dropphyzpp": 601742165,
    "dropmaladd": "2600 OAK ST",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "IL",
    "dropmalzpp": 601751536,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305842318,
    "dropsitcph": 6305842318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C028",
    "droptype": "D",
    "dropname": "FINANCE STATION Q",
    "dropdeladd": "4749 N BERNARD ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606259997,
    "dropphyadd": "4749 N BERNARD ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606259997,
    "dropmaladd": "4749 N BERNARD ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606259997,
    "dropsitphn": 7735393442,
    "dropsitlph": 7735393442,
    "dropsitcph": 7735399524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C055",
    "droptype": "D",
    "dropname": "FINANCE STATION H",
    "dropdeladd": "10238 S VINCENNES AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606431301,
    "dropphyadd": "10238 S VINCENNES AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606431301,
    "dropmaladd": "10238 S VINCENNES AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606431301,
    "dropsitphn": 7737790306,
    "dropsitlph": 7737790306,
    "dropsitcph": 7737790306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C056",
    "droptype": "D",
    "dropname": "FINANCE STATION K",
    "dropdeladd": "3933 W NORTH AVE STE 1",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606479997,
    "dropphyadd": "3933 W NORTH AVE STE 1",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606479997,
    "dropmaladd": "3933 W NORTH AVE STE 1",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606479997,
    "dropsitphn": 3124867218,
    "dropsitlph": 3123988765,
    "dropsitcph": 3124867218,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C057",
    "droptype": "D",
    "dropname": "FINANCE STATION L",
    "dropdeladd": "4642 S BISHOP ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606093240,
    "dropphyadd": "4642 S BISHOP ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606093240,
    "dropmaladd": "4642 S BISHOP ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606093240,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732579438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C058",
    "droptype": "D",
    "dropname": "FINANCE STATION O",
    "dropdeladd": "117 E 47TH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606533806,
    "dropphyadd": "117 E 47TH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606533806,
    "dropmaladd": "4601 S COTTAGE GROVE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606539998,
    "dropsitphn": 3126428480,
    "dropsitlph": 3126428480,
    "dropsitcph": 3126428480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C068",
    "droptype": "D",
    "dropname": "LOCKPORT",
    "dropdeladd": "1059 E 9TH ST",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 604413263,
    "dropphyadd": "1059 E 9TH ST",
    "dropphycty": "LOCKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 604413263,
    "dropmaladd": "315 W ROMEO RD",
    "dropmalcty": "ROMEOVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 604469998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8158380656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C090",
    "droptype": "D",
    "dropname": "SPFD JAMES RIVER POSTAL STOR",
    "dropdeladd": "1839H E INDEPENDENCE ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658043984,
    "dropphyadd": "1839H E INDEPENDENCE ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658043984,
    "dropmaladd": "1839H E INDEPENDENCE ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658043984,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168863758,
    "dropsitcph": 4178860048,
    "dropfax": 4178865174
  },
  {
    "dcode": "D",
    "dropkey": "SW1C113",
    "droptype": "D",
    "dropname": "WASHINGTON STREET",
    "dropdeladd": "5 S WASHINGTON ST STE 105",
    "dropdelcty": "NAPERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605409997,
    "dropphyadd": "5 S WASHINGTON ST STE 105",
    "dropphycty": "NAPERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605409997,
    "dropmaladd": "1750 W OGDEN AVE",
    "dropmalcty": "NAPERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6307172662,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C114",
    "droptype": "D",
    "dropname": "OAK LAWN",
    "dropdeladd": "9249 S CICERO AVE",
    "dropdelcty": "OAK LAWN",
    "dropdelst": "IL",
    "dropdelzpp": 604539832,
    "dropphyadd": "9249 S CICERO AVE",
    "dropphycty": "OAK LAWN",
    "dropphyst": "IL",
    "dropphyzpp": 604539832,
    "dropmaladd": "7401 W 100TH PL",
    "dropmalcty": "BRIDGEVIEW",
    "dropmalst": "IL",
    "dropmalzpp": 604559998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7082335555,
    "dropfax": 7082337374
  },
  {
    "dcode": "D",
    "dropkey": "SW1C115",
    "droptype": "D",
    "dropname": "ALGONQUIN EAST",
    "dropdeladd": "1420 E ALGONQUIN RD",
    "dropdelcty": "ALGONQUIN",
    "dropdelst": "IL",
    "dropdelzpp": 601025445,
    "dropphyadd": "1420 E ALGONQUIN RD",
    "dropphycty": "ALGONQUIN",
    "dropphyst": "IL",
    "dropphyzpp": 601025445,
    "dropmaladd": "1420 E ALGONQUIN RD",
    "dropmalcty": "ALGONQUIN",
    "dropmalst": "IL",
    "dropmalzpp": 601025445,
    "dropsitphn": 6302605496,
    "dropsitlph": 8476580012,
    "dropsitcph": 8476580012,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C141",
    "droptype": "D",
    "dropname": "KILBURN ROCKFORD",
    "dropdeladd": "2440 KILBURN AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611019700,
    "dropphyadd": "2440 KILBURN AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611019700,
    "dropmaladd": "2440 KILBURN AVE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611019700,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159628359,
    "dropsitcph": 8159628359,
    "dropfax": 8159621347
  },
  {
    "dcode": "D",
    "dropkey": "SW1C170",
    "droptype": "D",
    "dropname": "POSTAL IMPRESSIONS RETAIL",
    "dropdeladd": "5346 S 136TH ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681373001,
    "dropphyadd": "5346 S 136TH ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681370001,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681399998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028911922,
    "dropsitcph": 4028919033,
    "dropfax": 4028919143
  },
  {
    "dcode": "D",
    "dropkey": "SW1C503",
    "droptype": "D",
    "dropname": "DOWNTOWN ROCK ISLAND",
    "dropdeladd": "1956 2ND AVE",
    "dropdelcty": "ROCK ISLAND",
    "dropdelst": "IL",
    "dropdelzpp": 612019700,
    "dropphyadd": "1956 2ND AVE",
    "dropphycty": "ROCK ISLAND",
    "dropphyst": "IL",
    "dropphyzpp": 612019700,
    "dropmaladd": "1956 2ND AVE",
    "dropmalcty": "ROCK ISLAND",
    "dropmalst": "IL",
    "dropmalzpp": 612019700,
    "dropsitphn": 5152837530,
    "dropsitlph": 3097934957,
    "dropsitcph": 3097935159,
    "dropfax": 3097935161
  },
  {
    "dcode": "D",
    "dropkey": "SW1C506",
    "droptype": "D",
    "dropname": "PALATINE FIN  STA",
    "dropdeladd": "1300 E NORTHWEST HWY",
    "dropdelcty": "PALATINE",
    "dropdelst": "IL",
    "dropdelzpp": 600959997,
    "dropphyadd": "1300 E NORTHWEST HWY",
    "dropphycty": "PALATINE",
    "dropphyst": "IL",
    "dropphyzpp": 600959997,
    "dropmaladd": "1300 E NORTHWEST HWY",
    "dropmalcty": "PALATINE",
    "dropmalst": "IL",
    "dropmalzpp": 600959997,
    "dropsitphn": 6302605499,
    "dropsitlph": 8475908001,
    "dropsitcph": 8475908001,
    "dropfax": 8475906699
  },
  {
    "dcode": "D",
    "dropkey": "SW1C559",
    "droptype": "D",
    "dropname": "ASH CREEK",
    "dropdeladd": "3311 100TH ST",
    "dropdelcty": "URBANDALE",
    "dropdelst": "IA",
    "dropdelzpp": 503233855,
    "dropphyadd": "3311 100TH ST",
    "dropphycty": "URBANDALE",
    "dropphyst": "IA",
    "dropphyzpp": 503233855,
    "dropmaladd": "3311 100TH ST",
    "dropmalcty": "URBANDALE",
    "dropmalst": "IA",
    "dropmalzpp": 503233855,
    "dropsitphn": 5153345683,
    "dropsitlph": 5153348019,
    "dropsitcph": 5153345683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C564",
    "droptype": "D",
    "dropname": "HIGH RIDGE POSTAL STORE",
    "dropdeladd": "6 DILLON PLAZA DR",
    "dropdelcty": "HIGH RIDGE",
    "dropdelst": "MO",
    "dropdelzpp": 630499997,
    "dropphyadd": "6 DILLON PLAZA DR",
    "dropphycty": "HIGH RIDGE",
    "dropphyst": "MO",
    "dropphyzpp": 630499997,
    "dropmaladd": "6 DILLON PLAZA DR",
    "dropmalcty": "HIGH RIDGE",
    "dropmalst": "MO",
    "dropmalzpp": 630499997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6366771786,
    "dropsitcph": 6366771786,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C582",
    "droptype": "D",
    "dropname": "R B RICE",
    "dropdeladd": "1951 NE RICE RD",
    "dropdelcty": "LEES SUMMIT",
    "dropdelst": "MO",
    "dropdelzpp": 640649998,
    "dropphyadd": "1951 NE RICE RD",
    "dropphycty": "LEES SUMMIT",
    "dropphyst": "MO",
    "dropphyzpp": 640649998,
    "dropmaladd": "1951 NE RICE RD",
    "dropmalcty": "LEES SUMMIT",
    "dropmalst": "MO",
    "dropmalzpp": 640649998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165242612,
    "dropsitcph": 8165242612,
    "dropfax": 6505784539
  },
  {
    "dcode": "D",
    "dropkey": "SW1C583",
    "droptype": "D",
    "dropname": "BOARDWALK SQUARE STATION",
    "dropdeladd": "6304 NW BARRY RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641549998,
    "dropphyadd": "6304 NW BARRY RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641549998,
    "dropmaladd": "6304 NW BARRY RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641549998,
    "dropsitphn": 8163749109,
    "dropsitlph": 8165053796,
    "dropsitcph": 8165054594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C586",
    "droptype": "D",
    "dropname": "MEMORIAL UNION",
    "dropdeladd": "2231 LINCOLN WAY",
    "dropdelcty": "AMES",
    "dropdelst": "IA",
    "dropdelzpp": 500149997,
    "dropphyadd": "2231 LINCOLN WAY",
    "dropphycty": "AMES",
    "dropphyst": "IA",
    "dropphyzpp": 500149997,
    "dropmaladd": "2231 LINCOLN WAY",
    "dropmalcty": "AMES",
    "dropmalst": "IA",
    "dropmalzpp": 500149997,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152321113,
    "dropsitcph": 5152321113,
    "dropfax": 5152324723
  },
  {
    "dcode": "D",
    "dropkey": "SW1C612",
    "droptype": "D",
    "dropname": "ALTON SQUARE",
    "dropdeladd": "117 ALTON SQ",
    "dropdelcty": "ALTON",
    "dropdelst": "IL",
    "dropdelzpp": 620029994,
    "dropphyadd": "117 ALTON SQ",
    "dropphycty": "ALTON",
    "dropphyst": "IL",
    "dropphyzpp": 620029994,
    "dropmaladd": "117 ALTON SQ",
    "dropmalcty": "ALTON",
    "dropmalst": "IL",
    "dropmalzpp": 620029994,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184634728,
    "dropsitcph": 6184634728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C614",
    "droptype": "D",
    "dropname": "FAIRVIEW HEIGHTS",
    "dropdeladd": "10850 LINCOLN TRL UNIT 20",
    "dropdelcty": "FAIRVIEW HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 622089998,
    "dropphyadd": "10850 LINCOLN TRL UNIT 20",
    "dropphycty": "FAIRVIEW HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 622089998,
    "dropmaladd": "10850 LINCOLN TRL UNIT 20",
    "dropmalcty": "FAIRVIEW HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 622089998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183975044,
    "dropsitcph": 6183975044,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C616",
    "droptype": "D",
    "dropname": "MEADOWS POSTAL STORE",
    "dropdeladd": "2501 S LOUISE AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571064325,
    "dropphyadd": "2501 S LOUISE AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571064325,
    "dropmaladd": "PO BOX 87800",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571097800,
    "dropsitphn": "",
    "dropsitlph": 6055753565,
    "dropsitcph": 6055753565,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW1C622",
    "droptype": "D",
    "dropname": "DOWNTOWN URBANA",
    "dropdeladd": "202 S BROADWAY AVE STE 1",
    "dropdelcty": "URBANA",
    "dropdelst": "IL",
    "dropdelzpp": 618019998,
    "dropphyadd": "202 S BROADWAY AVE STE 1",
    "dropphycty": "URBANA",
    "dropphyst": "IL",
    "dropphyzpp": 618019998,
    "dropmaladd": "202 S BROADWAY AVE STE 1",
    "dropmalcty": "URBANA",
    "dropmalst": "IL",
    "dropmalzpp": 618019998,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173679629,
    "dropfax": 2173376435
  },
  {
    "dcode": "D",
    "dropkey": "SW10105",
    "droptype": "D",
    "dropname": "BEAVERDALE",
    "dropdeladd": "4023 URBANDALE AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503104000,
    "dropphyadd": "4023 URBANDALE AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503104000,
    "dropmaladd": "4023 URBANDALE AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503104000,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152555820,
    "dropsitcph": 5152558593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW10213",
    "droptype": "D",
    "dropname": "CAPITAL SQUARE",
    "dropdeladd": "400 LOCUST ST STE 185",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503092332,
    "dropphyadd": "400 LOCUST ST STE 185",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503092332,
    "dropmaladd": "400 LOCUST ST STE 185",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503092332,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152837730,
    "dropsitcph": 5152837730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW10922",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "97 MAIN AVE",
    "dropdelcty": "CLINTON",
    "dropdelst": "IA",
    "dropdelzpp": 527322318,
    "dropphyadd": "97 MAIN AVE",
    "dropphycty": "CLINTON",
    "dropphyst": "IA",
    "dropphyzpp": 527322318,
    "dropmaladd": "97 MAIN AVE",
    "dropmalcty": "CLINTON",
    "dropmalst": "IA",
    "dropmalzpp": 527322318,
    "dropsitphn": 5152837530,
    "dropsitlph": 5632431333,
    "dropsitcph": 5632431333,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW11128",
    "droptype": "D",
    "dropname": "NORTHEAST STATION",
    "dropdeladd": "1380 60TH ST NE",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 524029802,
    "dropphyadd": "1380 60TH ST NE",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 524029802,
    "dropmaladd": "1380 60TH ST NE",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 524029802,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193992946,
    "dropsitcph": 3192949005,
    "dropfax": 3193937507
  },
  {
    "dcode": "D",
    "dropkey": "SW11130",
    "droptype": "D",
    "dropname": "WEST STATION",
    "dropdeladd": "1930 WILEY BLVD SW",
    "dropdelcty": "CEDAR RAPIDS",
    "dropdelst": "IA",
    "dropdelzpp": 524049804,
    "dropphyadd": "1930 WILEY BLVD SW",
    "dropphycty": "CEDAR RAPIDS",
    "dropphyst": "IA",
    "dropphyzpp": 524049804,
    "dropmaladd": "1930 WILEY BLVD SW",
    "dropmalcty": "CEDAR RAPIDS",
    "dropmalst": "IA",
    "dropmalzpp": 524049804,
    "dropsitphn": 5152837530,
    "dropsitlph": 3193992986,
    "dropsitcph": 3193965392,
    "dropfax": 3193905715
  },
  {
    "dcode": "D",
    "dropkey": "SW11131",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "4018 MARQUETTE ST",
    "dropdelcty": "DAVENPORT",
    "dropdelst": "IA",
    "dropdelzpp": 528069715,
    "dropphyadd": "4018 MARQUETTE ST",
    "dropphycty": "DAVENPORT",
    "dropphyst": "IA",
    "dropphyzpp": 528069715,
    "dropmaladd": "4018 MARQUETTE ST",
    "dropmalcty": "DAVENPORT",
    "dropmalst": "IA",
    "dropmalzpp": 528069715,
    "dropsitphn": 5152837530,
    "dropsitlph": 5633919922,
    "dropsitcph": 5634450457,
    "dropfax": 5633914437
  },
  {
    "dcode": "D",
    "dropkey": "SW11450",
    "droptype": "D",
    "dropname": "SOUTH DES MOINES",
    "dropdeladd": "430 E MCKINLEY AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503154205,
    "dropphyadd": "430 E MCKINLEY AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503154205,
    "dropmaladd": "430 E MCKINLEY AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503154205,
    "dropsitphn": 5152837530,
    "dropsitlph": 5159534407,
    "dropsitcph": 5159748401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW11642",
    "droptype": "D",
    "dropname": "UNIVERSITY STATION",
    "dropdeladd": "2323 FOREST AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503113198,
    "dropphyadd": "2323 FOREST AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503113198,
    "dropmaladd": "2323 FOREST AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503113198,
    "dropsitphn": 5152837530,
    "dropsitlph": 5156356997,
    "dropsitcph": 5156356997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW11710",
    "droptype": "D",
    "dropname": "WELCH AVENUE",
    "dropdeladd": "119 STANTON AVE STE 101",
    "dropdelcty": "AMES",
    "dropdelst": "IA",
    "dropdelzpp": 500149996,
    "dropphyadd": "119 STANTON AVE STE 101",
    "dropphycty": "AMES",
    "dropphyst": "IA",
    "dropphyzpp": 500149996,
    "dropmaladd": "119 STANTON AVE STE 101",
    "dropmalcty": "AMES",
    "dropmalst": "IA",
    "dropmalzpp": 500149996,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152321113,
    "dropsitcph": 5152922098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW11731",
    "droptype": "D",
    "dropname": "WEST SUBURBAN",
    "dropdeladd": "2135 NW 108TH ST",
    "dropdelcty": "CLIVE",
    "dropdelst": "IA",
    "dropdelzpp": 503253704,
    "dropphyadd": "2135 NW 108TH ST",
    "dropphycty": "CLIVE",
    "dropphyst": "IA",
    "dropphyzpp": 503253704,
    "dropmaladd": "2135 NW 108TH ST",
    "dropmalcty": "CLIVE",
    "dropmalst": "IA",
    "dropmalzpp": 503253704,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152709043,
    "dropsitcph": 5152517773,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW11792",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "302 E GREEN ST",
    "dropdelcty": "CHAMPAIGN",
    "dropdelst": "IL",
    "dropdelzpp": 618209998,
    "dropphyadd": "302 E GREEN ST",
    "dropphycty": "CHAMPAIGN",
    "dropphyst": "IL",
    "dropphyzpp": 618209998,
    "dropmaladd": "302 E GREEN ST",
    "dropmalcty": "CHAMPAIGN",
    "dropmalst": "IL",
    "dropmalzpp": 618209998,
    "dropsitphn": 7085635789,
    "dropsitlph": 2173282857,
    "dropsitcph": 2173285200,
    "dropfax": 2173282410
  },
  {
    "dcode": "D",
    "dropkey": "SW11854",
    "droptype": "D",
    "dropname": "AMC OHARE",
    "dropdeladd": "11600 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606669998,
    "dropphyadd": "11600 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606669998,
    "dropmaladd": "11600 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606669998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7738941350,
    "dropfax": 7738941333
  },
  {
    "dcode": "D",
    "dropkey": "SW11855",
    "droptype": "D",
    "dropname": "AMOCO",
    "dropdeladd": "200 E RANDOLPH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606016436,
    "dropphyadd": "200 E RANDOLPH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606016436,
    "dropmaladd": "200 E RANDOLPH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606016436,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3128610473,
    "dropfax": 3128611588
  },
  {
    "dcode": "D",
    "dropkey": "SW11904",
    "droptype": "D",
    "dropname": "ASHBURN",
    "dropdeladd": "3639 W 79TH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606529998,
    "dropphyadd": "3639 W 79TH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606529998,
    "dropmaladd": "3639 W 79TH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606529998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737671590,
    "dropfax": 7737670046
  },
  {
    "dcode": "D",
    "dropkey": "SW11926",
    "droptype": "D",
    "dropname": "AUBURN PARK",
    "dropdeladd": "8345 S ASHLAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606209998,
    "dropphyadd": "8345 S ASHLAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606209998,
    "dropmaladd": "8345 S ASHLAND AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606209998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732395088,
    "dropfax": 7732391061
  },
  {
    "dcode": "D",
    "dropkey": "SW11932",
    "droptype": "D",
    "dropname": "AURORA EAST",
    "dropdeladd": "3900 GABRIELLE LN",
    "dropdelcty": "AURORA",
    "dropdelst": "IL",
    "dropdelzpp": 605988801,
    "dropphyadd": "3900 GABRIELLE LN",
    "dropphycty": "AURORA",
    "dropphyst": "IL",
    "dropphyzpp": 605988801,
    "dropmaladd": "3900 GABRIELLE LN",
    "dropmalcty": "AURORA",
    "dropmalst": "IL",
    "dropmalzpp": 605988801,
    "dropsitphn": 6309784440,
    "dropsitlph": 6309784440,
    "dropsitcph": 6305852430,
    "dropfax": 6305855022
  },
  {
    "dcode": "D",
    "dropkey": "SW11934",
    "droptype": "D",
    "dropname": "REV MILTON R BRUNSON",
    "dropdeladd": "324 S LARAMIE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606449998,
    "dropphyadd": "324 S LARAMIE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606449998,
    "dropmaladd": "324 S LARAMIE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606449998,
    "dropsitphn": 2139837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7733784122,
    "dropfax": 7733788816
  },
  {
    "dcode": "D",
    "dropkey": "SW11968",
    "droptype": "D",
    "dropname": "DOWNTOWN BARRINGTON",
    "dropdeladd": "106 BARRINGTON COMMONS CT",
    "dropdelcty": "BARRINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 600103222,
    "dropphyadd": "106 BARRINGTON COMMONS CT",
    "dropphycty": "BARRINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 600103222,
    "dropmaladd": "106 BARRINGTON COMMONS CT",
    "dropmalcty": "BARRINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 600103222,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473817206,
    "dropsitcph": 8473817206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12283",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "401 S SPRING ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627069998,
    "dropphyadd": "401 S SPRING ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627069998,
    "dropmaladd": "401 S SPRING ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627069998,
    "dropsitphn": 7085635789,
    "dropsitlph": 2177887290,
    "dropsitcph": 2177533543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12408",
    "droptype": "D",
    "dropname": "CHICAGO LAWN",
    "dropdeladd": "6037 S KEDZIE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606299997,
    "dropphyadd": "6037 S KEDZIE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606299997,
    "dropmaladd": "4301 W 69TH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606299998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7739251210,
    "dropfax": 7732846515
  },
  {
    "dcode": "D",
    "dropkey": "SW12414",
    "droptype": "D",
    "dropname": "CHINATOWN",
    "dropdeladd": "2345 S WENTWORTH AVE STE A",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606165601,
    "dropphyadd": "2345 S WENTWORTH AVE STE A",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606165601,
    "dropmaladd": "2035 S STATE ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606169998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3123266440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12445",
    "droptype": "D",
    "dropname": "CLEARING",
    "dropdeladd": "5645 S ARCHER AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606389998,
    "dropphyadd": "5645 S ARCHER AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606389998,
    "dropmaladd": "5645 S ARCHER AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606389998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737671917,
    "dropfax": 7737678468
  },
  {
    "dcode": "D",
    "dropkey": "SW12532",
    "droptype": "D",
    "dropname": "CRAGIN",
    "dropdeladd": "5100 W GRAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606399998,
    "dropphyadd": "5100 W GRAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606399998,
    "dropmaladd": "5100 W GRAND AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606399998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732370710,
    "dropfax": 7732374989
  },
  {
    "dcode": "D",
    "dropkey": "SW12635",
    "droptype": "D",
    "dropname": "DOWNTOWN DES PLAINES",
    "dropdeladd": "684 LEE ST",
    "dropdelcty": "DES PLAINES",
    "dropdelst": "IL",
    "dropdelzpp": 600164579,
    "dropphyadd": "684 LEE ST",
    "dropphycty": "DES PLAINES",
    "dropphyst": "IL",
    "dropphyzpp": 600164579,
    "dropmaladd": "1000 E OAKTON ST",
    "dropmalcty": "DES PLAINES",
    "dropmalst": "IL",
    "dropmalzpp": 600189998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478275592,
    "dropsitcph": 8476356250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12656",
    "droptype": "D",
    "dropname": "ROBERT LEFLORE JR",
    "dropdeladd": "5001 W DIVISION ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606519998,
    "dropphyadd": "5001 W DIVISION ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606519998,
    "dropmaladd": "5001 W DIVISION ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606519998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7733785850,
    "dropfax": 7733784537
  },
  {
    "dcode": "D",
    "dropkey": "SW12688",
    "droptype": "D",
    "dropname": "DOWNTOWN BLOOMINGTON",
    "dropdeladd": "400 N CENTER ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617013908,
    "dropphyadd": "400 N CENTER ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617013908,
    "dropmaladd": "1511 E EMPIRE ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617013528,
    "dropsitphn": 3096644600,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096644600,
    "dropfax": 3096680076
  },
  {
    "dcode": "D",
    "dropkey": "SW12689",
    "droptype": "D",
    "dropname": "DOWNTOWN CARBONDALE",
    "dropdeladd": "2001 W MAIN ST STE 101",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "IL",
    "dropdelzpp": 629019997,
    "dropphyadd": "2001 W MAIN ST STE 101",
    "dropphycty": "CARBONDALE",
    "dropphyst": "IL",
    "dropphyzpp": 629019997,
    "dropmaladd": "2001 W MAIN ST STE 101",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "IL",
    "dropmalzpp": 629019997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6185494904,
    "dropsitcph": 6185494904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12690",
    "droptype": "D",
    "dropname": "DOWNTOWN LA SALLE",
    "dropdeladd": "427 1ST ST",
    "dropdelcty": "LA SALLE",
    "dropdelst": "IL",
    "dropdelzpp": 613012327,
    "dropphyadd": "427 1ST ST",
    "dropphycty": "LA SALLE",
    "dropphyst": "IL",
    "dropphyzpp": 613012327,
    "dropmaladd": "427 1ST ST",
    "dropmalcty": "LA SALLE",
    "dropmalst": "IL",
    "dropmalzpp": 613012327,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8152241410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12691",
    "droptype": "D",
    "dropname": "ORVILLE H BROWNING",
    "dropdeladd": "200 N 8TH ST STE 1",
    "dropdelcty": "QUINCY",
    "dropdelst": "IL",
    "dropdelzpp": 623019996,
    "dropphyadd": "200 N 8TH ST STE 1",
    "dropphycty": "QUINCY",
    "dropphyst": "IL",
    "dropphyzpp": 623019996,
    "dropmaladd": "200 N 8TH ST STE 1",
    "dropmalcty": "QUINCY",
    "dropmalst": "IL",
    "dropmalzpp": 623019996,
    "dropsitphn": 3148959275,
    "dropsitlph": 2172248570,
    "dropsitcph": 2172248570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12692",
    "droptype": "D",
    "dropname": "DOWNTOWN SPRINGFIELD",
    "dropdeladd": "411 E MONROE ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627019998,
    "dropphyadd": "411 E MONROE ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627019998,
    "dropmaladd": "411 E MONROE ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627019998,
    "dropsitphn": 2177887407,
    "dropsitlph": 2177887480,
    "dropsitcph": 2177887480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12713",
    "droptype": "D",
    "dropname": "ROGER P MC AULIFFE",
    "dropdeladd": "6441 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606349998,
    "dropphyadd": "6441 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606349998,
    "dropmaladd": "6441 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606349998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737360714,
    "dropfax": 7737369326
  },
  {
    "dcode": "D",
    "dropkey": "SW12716",
    "droptype": "D",
    "dropname": "DUTCH HOLLOW",
    "dropdeladd": "5731 MOUNT PLEASANT LN",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 622239998,
    "dropphyadd": "5731 MOUNT PLEASANT LN",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 622239998,
    "dropmaladd": "5731 MOUNT PLEASANT LN",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 622239998,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183976616,
    "dropsitcph": 6183976616,
    "dropfax": 6183977468
  },
  {
    "dcode": "D",
    "dropkey": "SW12720",
    "droptype": "D",
    "dropname": "FINANCE STATION E",
    "dropdeladd": "100 W RANDOLPH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606013218,
    "dropphyadd": "100 W RANDOLPH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606013218,
    "dropmaladd": "100 W RANDOLPH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606013218,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3122632686,
    "dropfax": 3122637838
  },
  {
    "dcode": "D",
    "dropkey": "SW12773",
    "droptype": "D",
    "dropname": "EAST ROCKFORD",
    "dropdeladd": "111 N 6TH ST",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611079700,
    "dropphyadd": "111 N 6TH ST",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611079700,
    "dropmaladd": "111 N 6TH ST",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611079700,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159628565,
    "dropsitcph": 8159628565,
    "dropfax": 8159688891
  },
  {
    "dcode": "D",
    "dropkey": "SW12795",
    "droptype": "D",
    "dropname": "EDGEMONT",
    "dropdeladd": "8701 STATE ST",
    "dropdelcty": "EAST SAINT LOUIS",
    "dropdelst": "IL",
    "dropdelzpp": 622039997,
    "dropphyadd": "8701 STATE ST",
    "dropphycty": "EAST SAINT LOUIS",
    "dropphyst": "IL",
    "dropphyzpp": 622039997,
    "dropmaladd": "8701 STATE ST",
    "dropmalcty": "EAST SAINT LOUIS",
    "dropmalst": "IL",
    "dropmalzpp": 622039997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183983594,
    "dropsitcph": 6183983594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12801",
    "droptype": "D",
    "dropname": "EDISON SQUARE",
    "dropdeladd": "1519 N LEWIS AVE",
    "dropdelcty": "WAUKEGAN",
    "dropdelst": "IL",
    "dropdelzpp": 600851700,
    "dropphyadd": "1519 N LEWIS AVE",
    "dropphycty": "WAUKEGAN",
    "dropphyst": "IL",
    "dropphyzpp": 600851700,
    "dropmaladd": "1519 N LEWIS AVE",
    "dropmalcty": "WAUKEGAN",
    "dropmalst": "IL",
    "dropmalzpp": 600851700,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472441400,
    "dropsitcph": 8472441400,
    "dropfax": 8476627385
  },
  {
    "dcode": "D",
    "dropkey": "SW12870",
    "droptype": "D",
    "dropname": "ELSDON",
    "dropdeladd": "4922 S KEDZIE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606329998,
    "dropphyadd": "4922 S KEDZIE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606329998,
    "dropmaladd": "4301 W 69TH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606299998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7738631402,
    "dropfax": 7732846515
  },
  {
    "dcode": "D",
    "dropkey": "SW12883",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "611 W 63RD ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606219998,
    "dropphyadd": "611 W 63RD ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606219998,
    "dropmaladd": "611 W 63RD ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606219998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7738730790,
    "dropfax": 7738739345
  },
  {
    "dcode": "D",
    "dropkey": "SW12901",
    "droptype": "D",
    "dropname": "EVANSTON NORTH",
    "dropdeladd": "1929 CENTRAL ST",
    "dropdelcty": "EVANSTON",
    "dropdelst": "IL",
    "dropdelzpp": 602012287,
    "dropphyadd": "1929 CENTRAL ST",
    "dropphycty": "EVANSTON",
    "dropphyst": "IL",
    "dropphyzpp": 602012287,
    "dropmaladd": "1929 CENTRAL ST",
    "dropmalcty": "EVANSTON",
    "dropmalst": "IL",
    "dropmalzpp": 602012287,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473286288,
    "dropsitcph": 8473286288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12902",
    "droptype": "D",
    "dropname": "EVANSTON SOUTH",
    "dropdeladd": "701 MAIN ST",
    "dropdelcty": "EVANSTON",
    "dropdelst": "IL",
    "dropdelzpp": 602021700,
    "dropphyadd": "701 MAIN ST",
    "dropphycty": "EVANSTON",
    "dropphyst": "IL",
    "dropphyzpp": 602021700,
    "dropmaladd": "701 MAIN ST",
    "dropmalcty": "EVANSTON",
    "dropmalst": "IL",
    "dropmalzpp": 602021700,
    "dropsitphn": 6302605499,
    "dropsitlph": 8473286288,
    "dropsitcph": 8473286288,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW12917",
    "droptype": "D",
    "dropname": "ROGERS PARK CLARK",
    "dropdeladd": "7056 N CLARK ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606262425,
    "dropphyadd": "7056 N CLARK ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606262425,
    "dropmaladd": "7056 N CLARK ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606262425,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737648154,
    "dropfax": 7737641262
  },
  {
    "dcode": "D",
    "dropkey": "SW12998",
    "droptype": "D",
    "dropname": "FORT DEARBORN",
    "dropdeladd": "540 N DEARBORN ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606109998,
    "dropphyadd": "540 N DEARBORN ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606109998,
    "dropmaladd": "540 N DEARBORN ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606109998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838756,
    "dropsitcph": 3126443919,
    "dropfax": 3126447843
  },
  {
    "dcode": "D",
    "dropkey": "SW13021",
    "droptype": "D",
    "dropname": "FOX VALLEY CENTER",
    "dropdeladd": "191 FOX VALLEY CTR",
    "dropdelcty": "AURORA",
    "dropdelst": "IL",
    "dropdelzpp": 605044106,
    "dropphyadd": "191 FOX VALLEY CTR",
    "dropphycty": "AURORA",
    "dropphyst": "IL",
    "dropphyzpp": 605044106,
    "dropmaladd": "191 FOX VALLEY CTR",
    "dropmalcty": "AURORA",
    "dropmalst": "IL",
    "dropmalzpp": 605044106,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 7088516110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW13072",
    "droptype": "D",
    "dropname": "MARY ALICE HENRY",
    "dropdeladd": "4222 W MADISON ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606249998,
    "dropphyadd": "4222 W MADISON ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606249998,
    "dropmaladd": "4222 W MADISON ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606249998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737223740,
    "dropfax": 7737229808
  },
  {
    "dcode": "D",
    "dropkey": "SW13114",
    "droptype": "D",
    "dropname": "DOWNTOWN GLEN ELLYN",
    "dropdeladd": "528 PENNSYLVANIA AVE",
    "dropdelcty": "GLEN ELLYN",
    "dropdelst": "IL",
    "dropdelzpp": 601374160,
    "dropphyadd": "528 PENNSYLVANIA AVE",
    "dropphycty": "GLEN ELLYN",
    "dropphyst": "IL",
    "dropphyzpp": 601374160,
    "dropmaladd": "528 PENNSYLVANIA AVE",
    "dropmalcty": "GLEN ELLYN",
    "dropmalst": "IL",
    "dropmalzpp": 601374160,
    "dropsitphn": 6302605499,
    "dropsitlph": 6304690253,
    "dropsitcph": 6304690253,
    "dropfax": 6304691166
  },
  {
    "dcode": "D",
    "dropkey": "SW13155",
    "droptype": "D",
    "dropname": "GRACELAND",
    "dropdeladd": "3024 N ASHLAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606573012,
    "dropphyadd": "3024 N ASHLAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606573012,
    "dropmaladd": "3024 N ASHLAND AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606573012,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732480201,
    "dropfax": 7734046936
  },
  {
    "dcode": "D",
    "dropkey": "SW13270",
    "droptype": "D",
    "dropname": "OTIS GRANT COLLINS",
    "dropdeladd": "2302 S PULASKI RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606239998,
    "dropphyadd": "2302 S PULASKI RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606239998,
    "dropmaladd": "2302 S PULASKI RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606239998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732773070,
    "dropfax": 7735220675
  },
  {
    "dcode": "D",
    "dropkey": "SW13272",
    "droptype": "D",
    "dropname": "HAYMARKET",
    "dropdeladd": "168 N CLINTON ST STE FRONT",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606611501,
    "dropphyadd": "168 N CLINTON ST STE FRONT",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606611501,
    "dropmaladd": "168 N CLINTON ST STE FRONT",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606611501,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3129068557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW13283",
    "droptype": "D",
    "dropname": "HEGEWISCH",
    "dropdeladd": "13234 S BALTIMORE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606339998,
    "dropphyadd": "13234 S BALTIMORE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606339998,
    "dropmaladd": "13234 S BALTIMORE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606339998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7736466721,
    "dropfax": 7736460383
  },
  {
    "dcode": "D",
    "dropkey": "SW13410",
    "droptype": "D",
    "dropname": "HENRY W MCGEE",
    "dropdeladd": "4601 S COTTAGE GROVE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606539998,
    "dropphyadd": "4601 S COTTAGE GROVE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606539998,
    "dropmaladd": "4601 S COTTAGE GROVE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606539998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7739246658,
    "dropfax": 7739247948
  },
  {
    "dcode": "D",
    "dropkey": "SW13455",
    "droptype": "D",
    "dropname": "IRVING PARK",
    "dropdeladd": "3319 N CICERO AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606419998,
    "dropphyadd": "3319 N CICERO AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606419998,
    "dropmaladd": "3319 N CICERO AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606419998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737253701,
    "dropfax": 7737252958
  },
  {
    "dcode": "D",
    "dropkey": "SW13466",
    "droptype": "D",
    "dropname": "JACKSON PARK",
    "dropdeladd": "700 E 61ST ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606379998,
    "dropphyadd": "700 E 61ST ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606379998,
    "dropmaladd": "700 E 61ST ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606379998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7734933125,
    "dropfax": 7734939570
  },
  {
    "dcode": "D",
    "dropkey": "SW13524",
    "droptype": "D",
    "dropname": "DANIEL J DOFFYN",
    "dropdeladd": "3750 N KEDZIE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606189998,
    "dropphyadd": "3750 N KEDZIE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606189998,
    "dropmaladd": "3750 N KEDZIE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606189998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7735396210,
    "dropfax": 7734780928
  },
  {
    "dcode": "D",
    "dropkey": "SW13615",
    "droptype": "D",
    "dropname": "LAKE PARK",
    "dropdeladd": "1510 E 55TH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606152598,
    "dropphyadd": "1510 E 55TH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606152598,
    "dropmaladd": "4601 S COTTAGE GROVE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606539998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7733470015,
    "dropfax": 7733240896
  },
  {
    "dcode": "D",
    "dropkey": "SW13624",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "1343 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606139998,
    "dropphyadd": "1343 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606139998,
    "dropmaladd": "1343 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606139998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7733270345,
    "dropfax": 7733273903
  },
  {
    "dcode": "D",
    "dropkey": "SW13732",
    "droptype": "D",
    "dropname": "ROBERTO CLEMENTE",
    "dropdeladd": "2339 N CALIFORNIA AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606479998,
    "dropphyadd": "2339 N CALIFORNIA AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606479998,
    "dropmaladd": "2339 N CALIFORNIA AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606479998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7734892855,
    "dropfax": 7734891497
  },
  {
    "dcode": "D",
    "dropkey": "SW13752",
    "droptype": "D",
    "dropname": "LOOP CLARK STREET",
    "dropdeladd": "211 S CLARK ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606049998,
    "dropphyadd": "211 S CLARK ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606049998,
    "dropmaladd": "211 S CLARK ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606049998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3123853530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW13785",
    "droptype": "D",
    "dropname": "FINANCE STATION M",
    "dropdeladd": "7617 N PAULINA ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606269997,
    "dropphyadd": "7617 N PAULINA ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606269997,
    "dropmaladd": "7617 N PAULINA ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606269997,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7739436105,
    "dropfax": 7737430588
  },
  {
    "dcode": "D",
    "dropkey": "SW13802",
    "droptype": "D",
    "dropname": "CARDISS COLLINS",
    "dropdeladd": "433 W HARRISON ST FL LBBY",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606999208,
    "dropphyadd": "433 W HARRISON ST FL LBBY",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999208,
    "dropmaladd": "433 W HARRISON ST FL LBBY",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999208,
    "dropsitphn": 3129837601,
    "dropsitlph": 3129838765,
    "dropsitcph": 3129838130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW13909",
    "droptype": "D",
    "dropname": "MEMORIAL",
    "dropdeladd": "1601 E MOUND RD",
    "dropdelcty": "DECATUR",
    "dropdelst": "IL",
    "dropdelzpp": 625269997,
    "dropphyadd": "1601 E MOUND RD",
    "dropphycty": "DECATUR",
    "dropphyst": "IL",
    "dropphyzpp": 625269997,
    "dropmaladd": "1601 E MOUND RD",
    "dropmalcty": "DECATUR",
    "dropmalst": "IL",
    "dropmalzpp": 625269997,
    "dropsitphn": 7085637318,
    "dropsitlph": 2174284471,
    "dropsitcph": 2178774361,
    "dropfax": 2178774523
  },
  {
    "dcode": "D",
    "dropkey": "SW13918",
    "droptype": "D",
    "dropname": "MERCHANDISE MART",
    "dropdeladd": "222 MERCHANDISE MART PLZ STE 102",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606549998,
    "dropphyadd": "222 MERCHANDISE MART PLZ STE 102",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606549998,
    "dropmaladd": "222 MERCHANDISE MART PLZ STE 102",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606549998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3123210233,
    "dropfax": 3123210453
  },
  {
    "dcode": "D",
    "dropkey": "SW13947",
    "droptype": "D",
    "dropname": "NANCY B JEFFERSON",
    "dropdeladd": "116 S WESTERN AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606129998,
    "dropphyadd": "116 S WESTERN AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606129998,
    "dropmaladd": "116 S WESTERN AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606129998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3122432560,
    "dropfax": 3122434836
  },
  {
    "dcode": "D",
    "dropkey": "SW14035",
    "droptype": "D",
    "dropname": "MOUNT GREENWOOD",
    "dropdeladd": "3349 W 111TH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606559998,
    "dropphyadd": "3349 W 111TH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606559998,
    "dropmaladd": "3349 W 111TH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606559998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732382849,
    "dropfax": 7732389370
  },
  {
    "dcode": "D",
    "dropkey": "SW14090",
    "droptype": "D",
    "dropname": "NAMEOKI",
    "dropdeladd": "3236 NAMEOKI RD",
    "dropdelcty": "GRANITE CITY",
    "dropdelst": "IL",
    "dropdelzpp": 620409997,
    "dropphyadd": "3236 NAMEOKI RD",
    "dropphycty": "GRANITE CITY",
    "dropphyst": "IL",
    "dropphyzpp": 620409997,
    "dropmaladd": "3236 NAMEOKI RD",
    "dropmalcty": "GRANITE CITY",
    "dropmalst": "IL",
    "dropmalzpp": 620409997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6188770450,
    "dropsitcph": 6188770450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW14114",
    "droptype": "D",
    "dropname": "NEIL STREET",
    "dropdeladd": "600 N NEIL ST",
    "dropdelcty": "CHAMPAIGN",
    "dropdelst": "IL",
    "dropdelzpp": 618209997,
    "dropphyadd": "600 N NEIL ST",
    "dropphycty": "CHAMPAIGN",
    "dropphyst": "IL",
    "dropphyzpp": 618209997,
    "dropmaladd": "600 N NEIL ST",
    "dropmalcty": "CHAMPAIGN",
    "dropmalst": "IL",
    "dropmalzpp": 618209997,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173522167,
    "dropfax": 2173522073
  },
  {
    "dcode": "D",
    "dropkey": "SW14199",
    "droptype": "D",
    "dropname": "NORTH UNIVERSITY",
    "dropdeladd": "6310 N UNIVERSITY ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616149800,
    "dropphyadd": "6310 N UNIVERSITY ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616149800,
    "dropmaladd": "6310 N UNIVERSITY ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616149800,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096929818,
    "dropfax": 3096926568
  },
  {
    "dcode": "D",
    "dropkey": "SW14202",
    "droptype": "D",
    "dropname": "DOWNTOWN NORTHBROOK",
    "dropdeladd": "1157 CHURCH ST",
    "dropdelcty": "NORTHBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 600623684,
    "dropphyadd": "1157 CHURCH ST",
    "dropphycty": "NORTHBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 600623684,
    "dropmaladd": "1157 CHURCH ST",
    "dropmalcty": "NORTHBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 600623684,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477153093,
    "dropsitcph": 8477153093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW14212",
    "droptype": "D",
    "dropname": "NORTHTOWN",
    "dropdeladd": "3401 W DEVON AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606599998,
    "dropphyadd": "3401 W DEVON AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606599998,
    "dropmaladd": "3401 W DEVON AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606599998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7735838640,
    "dropfax": 7734632139
  },
  {
    "dcode": "D",
    "dropkey": "SW14222",
    "droptype": "D",
    "dropname": "NORWOOD PARK",
    "dropdeladd": "6300 N NORTHWEST HWY",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606319998,
    "dropphyadd": "6300 N NORTHWEST HWY",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606319998,
    "dropmaladd": "6300 N NORTHWEST HWY",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606319998,
    "dropsitphn": 3129837602,
    "dropsitlph": 7739838765,
    "dropsitcph": 7736312204,
    "dropfax": 7736319978
  },
  {
    "dcode": "D",
    "dropkey": "SW14240",
    "droptype": "D",
    "dropname": "OAK PARK SOUTH",
    "dropdeladd": "1116 GARFIELD ST",
    "dropdelcty": "OAK PARK",
    "dropdelst": "IL",
    "dropdelzpp": 603041831,
    "dropphyadd": "1116 GARFIELD ST",
    "dropphycty": "OAK PARK",
    "dropphyst": "IL",
    "dropphyzpp": 603041831,
    "dropmaladd": "1116 GARFIELD ST",
    "dropmalcty": "OAK PARK",
    "dropmalst": "IL",
    "dropmalzpp": 603041831,
    "dropsitphn": 6302605499,
    "dropsitlph": 7084060182,
    "dropsitcph": 7088486561,
    "dropfax": 7088482581
  },
  {
    "dcode": "D",
    "dropkey": "SW14263",
    "droptype": "D",
    "dropname": "OGDEN PARK",
    "dropdeladd": "6559 S ASHLAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606369998,
    "dropphyadd": "6559 S ASHLAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606369998,
    "dropmaladd": "6559 S ASHLAND AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606369998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737764458,
    "dropfax": 7737761491
  },
  {
    "dcode": "D",
    "dropkey": "SW14304",
    "droptype": "D",
    "dropname": "STREETERVILLE",
    "dropdeladd": "355 E OHIO ST STE 200",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606117223,
    "dropphyadd": "355 E OHIO ST STE 200",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606117223,
    "dropmaladd": "355 E OHIO ST STE 200",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606117223,
    "dropsitphn": 3125270670,
    "dropsitlph": 3125270673,
    "dropsitcph": 3122124678,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW14346",
    "droptype": "D",
    "dropname": "OTTO MALL",
    "dropdeladd": "1333 W END AVE",
    "dropdelcty": "CHICAGO HEIGHTS",
    "dropdelst": "IL",
    "dropdelzpp": 604119804,
    "dropphyadd": "1333 W END AVE",
    "dropphycty": "CHICAGO HEIGHTS",
    "dropphyst": "IL",
    "dropphyzpp": 604119804,
    "dropmaladd": "1333 W END AVE",
    "dropmalcty": "CHICAGO HEIGHTS",
    "dropmalst": "IL",
    "dropmalzpp": 604119804,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7087541480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW14458",
    "droptype": "D",
    "dropname": "PILSEN",
    "dropdeladd": "1859 S ASHLAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606089998,
    "dropphyadd": "1859 S ASHLAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606089998,
    "dropmaladd": "1859 S ASHLAND AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606089998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3127334750,
    "dropfax": 3127332325
  },
  {
    "dcode": "D",
    "dropkey": "SW14568",
    "droptype": "D",
    "dropname": "RAVENSWOOD",
    "dropdeladd": "2522 W LAWRENCE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606259998,
    "dropphyadd": "2522 W LAWRENCE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606259998,
    "dropmaladd": "2522 W LAWRENCE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606259998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7735618633,
    "dropfax": 7735619958
  },
  {
    "dcode": "D",
    "dropkey": "SW14659",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "1140 BROADWAY",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611049706,
    "dropphyadd": "1140 BROADWAY",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611049706,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611069998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159689522,
    "dropsitcph": 8159689522,
    "dropfax": 8159635836
  },
  {
    "dcode": "D",
    "dropkey": "SW14660",
    "droptype": "D",
    "dropname": "DOWNTOWN ROCKFORD",
    "dropdeladd": "401 S MAIN ST FL 1",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611019705,
    "dropphyadd": "401 S MAIN ST FL 1",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611019705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611059998,
    "dropsitphn": 6302605499,
    "dropsitlph": 8159625940,
    "dropsitcph": 8159625940,
    "dropfax": 8159628368
  },
  {
    "dcode": "D",
    "dropkey": "SW14668",
    "droptype": "D",
    "dropname": "ROGERS PARK",
    "dropdeladd": "1723 W DEVON AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606609998,
    "dropphyadd": "1723 W DEVON AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606609998,
    "dropmaladd": "1723 W DEVON AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606609998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737432650,
    "dropfax": 7735081208
  },
  {
    "dcode": "D",
    "dropkey": "SW14696",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "11033 S STATE ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606289998,
    "dropphyadd": "11033 S STATE ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606289998,
    "dropmaladd": "11033 S STATE ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606289998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7739286280,
    "dropfax": 7739287720
  },
  {
    "dcode": "D",
    "dropkey": "SW14920",
    "droptype": "D",
    "dropname": "JOHN BUCHANAN",
    "dropdeladd": "9308 S SOUTH CHICAGO AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606179998,
    "dropphyadd": "9308 S SOUTH CHICAGO AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606179998,
    "dropmaladd": "9308 S SOUTH CHICAGO AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606179998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732219578,
    "dropfax": 7732219735
  },
  {
    "dcode": "D",
    "dropkey": "SW14935",
    "droptype": "D",
    "dropname": "CHARLES A HAYES",
    "dropdeladd": "7436 S EXCHANGE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606499998,
    "dropphyadd": "7436 S EXCHANGE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606499998,
    "dropmaladd": "7436 S EXCHANGE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606499998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129832180,
    "dropsitcph": 7733752180,
    "dropfax": 7733748991
  },
  {
    "dcode": "D",
    "dropkey": "SW15178",
    "droptype": "D",
    "dropname": "STOCKYARD",
    "dropdeladd": "4101 S HALSTED ST STE 1",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606099998,
    "dropphyadd": "4101 S HALSTED ST STE 1",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606099998,
    "dropmaladd": "4101 S HALSTED ST STE 1",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606099998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732470731,
    "dropfax": 7732473695
  },
  {
    "dcode": "D",
    "dropkey": "SW15225",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "1760 WABASH AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627049997,
    "dropphyadd": "1760 WABASH AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627049997,
    "dropmaladd": "1760 WABASH AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627049997,
    "dropsitphn": 7085635789,
    "dropsitlph": 2177887408,
    "dropsitcph": 2175460463,
    "dropfax": 2176987962
  },
  {
    "dcode": "D",
    "dropkey": "SW15235",
    "droptype": "D",
    "dropname": "FINANCE STATION T",
    "dropdeladd": "2011 W MONTROSE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606189997,
    "dropphyadd": "2011 W MONTROSE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606189997,
    "dropmaladd": "2011 W MONTROSE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606189997,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7734721314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15323",
    "droptype": "D",
    "dropname": "TWENTY SECOND STREET",
    "dropdeladd": "2035 S STATE ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606169998,
    "dropphyadd": "2035 S STATE ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606169998,
    "dropmaladd": "2035 S STATE ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606169998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3122250218,
    "dropfax": 3122259415
  },
  {
    "dcode": "D",
    "dropkey": "SW15340",
    "droptype": "D",
    "dropname": "UPPER ALTON",
    "dropdeladd": "1624 MAIN ST",
    "dropdelcty": "ALTON",
    "dropdelst": "IL",
    "dropdelzpp": 620029996,
    "dropphyadd": "1624 MAIN ST",
    "dropphycty": "ALTON",
    "dropphyst": "IL",
    "dropphyzpp": 620029996,
    "dropmaladd": "1624 MAIN ST",
    "dropmalcty": "ALTON",
    "dropmalst": "IL",
    "dropmalzpp": 620029996,
    "dropsitphn": 3148959275,
    "dropsitlph": 6184626014,
    "dropsitcph": 6184626014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15342",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "4850 N BROADWAY ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606409998,
    "dropphyadd": "4850 N BROADWAY ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606409998,
    "dropmaladd": "4850 N BROADWAY ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606409998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7735614846,
    "dropfax": 7735611937
  },
  {
    "dcode": "D",
    "dropkey": "SW15391",
    "droptype": "D",
    "dropname": "FINANCE STATION W",
    "dropdeladd": "10422 S EWING AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606179997,
    "dropphyadd": "10422 S EWING AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606179997,
    "dropmaladd": "10422 S EWING AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606179997,
    "dropsitphn": 3122210607,
    "dropsitlph": 3122210607,
    "dropsitcph": 7732219405,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15404",
    "droptype": "D",
    "dropname": "WACKER DRIVE",
    "dropdeladd": "233 S WACKER DR STE LL1A",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606069997,
    "dropphyadd": "233 S WACKER DR STE LL1A",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606069997,
    "dropmaladd": "233 S WACKER DR STE LL1A",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606069997,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3128761024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15479",
    "droptype": "D",
    "dropname": "WENTWORTH AVENUE",
    "dropdeladd": "680 WENTWORTH AVE",
    "dropdelcty": "CALUMET CITY",
    "dropdelst": "IL",
    "dropdelzpp": 604099997,
    "dropphyadd": "680 WENTWORTH AVE",
    "dropphycty": "CALUMET CITY",
    "dropphyst": "IL",
    "dropphyzpp": 604099997,
    "dropmaladd": "680 WENTWORTH AVE",
    "dropmalcty": "CALUMET CITY",
    "dropmalst": "IL",
    "dropmalzpp": 604099997,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 7088913134,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15519",
    "droptype": "D",
    "dropname": "WHEATON SOUTH",
    "dropdeladd": "46 DANADA SQ W",
    "dropdelcty": "WHEATON",
    "dropdelst": "IL",
    "dropdelzpp": 601892017,
    "dropphyadd": "46 DANADA SQ W",
    "dropphycty": "WHEATON",
    "dropphyst": "IL",
    "dropphyzpp": 601892017,
    "dropmaladd": "46 DANADA SQ W",
    "dropmalcty": "WHEATON",
    "dropmalst": "IL",
    "dropmalzpp": 601892017,
    "dropsitphn": 6302605499,
    "dropsitlph": 6306825529,
    "dropsitcph": 6306825529,
    "dropfax": 6306829382
  },
  {
    "dcode": "D",
    "dropkey": "SW15531",
    "droptype": "D",
    "dropname": "WICKER PARK",
    "dropdeladd": "1635 W DIVISION ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606227040,
    "dropphyadd": "1635 W DIVISION ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606227040,
    "dropmaladd": "1635 W DIVISION ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606227040,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732784575,
    "dropfax": 7732781976
  },
  {
    "dcode": "D",
    "dropkey": "SW15648",
    "droptype": "D",
    "dropname": "JOPLIN STA A",
    "dropdeladd": "3115 S MAIN ST",
    "dropdelcty": "JOPLIN",
    "dropdelst": "MO",
    "dropdelzpp": 648049998,
    "dropphyadd": "3115 S MAIN ST",
    "dropphycty": "JOPLIN",
    "dropphyst": "MO",
    "dropphyzpp": 648049998,
    "dropmaladd": "3115 S MAIN ST",
    "dropmalcty": "JOPLIN",
    "dropmalst": "MO",
    "dropmalzpp": 648049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4176236176,
    "dropsitcph": 4176236176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15719",
    "droptype": "D",
    "dropname": "ANTIOCH",
    "dropdeladd": "4810 NE VIVION RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641199998,
    "dropphyadd": "4810 NE VIVION RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641199998,
    "dropmaladd": "4810 NE VIVION RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641199998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164533946,
    "dropsitcph": 8164535838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15828",
    "droptype": "D",
    "dropname": "BENTON PARK",
    "dropdeladd": "2700 S JEFFERSON AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631049998,
    "dropphyadd": "2700 S JEFFERSON AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631049998,
    "dropmaladd": "2700 S JEFFERSON AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631049998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3147739168,
    "dropsitcph": 3147739168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW15968",
    "droptype": "D",
    "dropname": "BADEN",
    "dropdeladd": "8390 N BROADWAY",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631479998,
    "dropphyadd": "8390 N BROADWAY",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631479998,
    "dropmaladd": "8390 N BROADWAY",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631479998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143831026,
    "dropsitcph": 3143830926,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16082",
    "droptype": "D",
    "dropname": "CAPITOL VIEW",
    "dropdeladd": "1750 JEFFERSON ST",
    "dropdelcty": "JEFFERSON CITY",
    "dropdelst": "MO",
    "dropdelzpp": 651099998,
    "dropphyadd": "1750 JEFFERSON ST",
    "dropphycty": "JEFFERSON CITY",
    "dropphyst": "MO",
    "dropphyzpp": 651099998,
    "dropmaladd": "1750 JEFFERSON ST",
    "dropmalcty": "JEFFERSON CITY",
    "dropmalst": "MO",
    "dropmalzpp": 651099998,
    "dropsitphn": 3148959275,
    "dropsitlph": 5736356091,
    "dropsitcph": 5736356091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16092",
    "droptype": "D",
    "dropname": "CARR",
    "dropdeladd": "1650 SHACKELFORD RD",
    "dropdelcty": "FLORISSANT",
    "dropdelst": "MO",
    "dropdelzpp": 630319998,
    "dropphyadd": "1650 SHACKELFORD RD",
    "dropphycty": "FLORISSANT",
    "dropphyst": "MO",
    "dropphyzpp": 630319998,
    "dropmaladd": "1650 SHACKELFORD RD",
    "dropmalcty": "FLORISSANT",
    "dropmalst": "MO",
    "dropmalzpp": 630319998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149219734,
    "dropsitcph": 3149217542,
    "dropfax": 3149217280
  },
  {
    "dcode": "D",
    "dropkey": "SW16093",
    "droptype": "D",
    "dropname": "MAIN OFFICE FIN POSTAL STORE",
    "dropdeladd": "1720 MARKET ST LBBY",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631559989,
    "dropphyadd": "1720 MARKET ST LBBY",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631559989,
    "dropmaladd": "1720 MARKET ST LBBY",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631559989,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144364452,
    "dropsitcph": 3144364407,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16141",
    "droptype": "D",
    "dropname": "CENTER SQUARE",
    "dropdeladd": "1100 MAIN ST STE 200",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641055118,
    "dropphyadd": "1100 MAIN ST STE 200",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641055118,
    "dropmaladd": "1100 MAIN ST STE 200",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641055118,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162833460,
    "dropsitcph": 8162833460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16147",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "400 E 9TH ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641069997,
    "dropphyadd": "400 E 9TH ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641069997,
    "dropmaladd": "400 E 9TH ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641069997,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 8162211046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16150",
    "droptype": "D",
    "dropname": "CENTROPOLIS",
    "dropdeladd": "5824 E TRUMAN RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641269998,
    "dropphyadd": "5824 E TRUMAN RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641269998,
    "dropmaladd": "5824 E TRUMAN RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641269998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164831218,
    "dropsitcph": 8162416310,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16174",
    "droptype": "D",
    "dropname": "CHOUTEAU",
    "dropdeladd": "4120 MANCHESTER AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631109998,
    "dropphyadd": "4120 MANCHESTER AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631109998,
    "dropmaladd": "4120 MANCHESTER AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631109998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145310406,
    "dropsitcph": 3145310949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16178",
    "droptype": "D",
    "dropname": "CIVIC CENTER",
    "dropdeladd": "601 E 12TH ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641069998,
    "dropphyadd": "601 E 12TH ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641069998,
    "dropmaladd": "601 E 12TH ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641069998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162213110,
    "dropsitcph": 8162213083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16230",
    "droptype": "D",
    "dropname": "COMMERCE STA",
    "dropdeladd": "3709 SANDMAN LN",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652019994,
    "dropphyadd": "3709 SANDMAN LN",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652019994,
    "dropmaladd": "3709 SANDMAN LN",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652019994,
    "dropsitphn": 3148959275,
    "dropsitlph": 5738754844,
    "dropsitcph": 5738754844,
    "dropfax": 5738767857
  },
  {
    "dcode": "D",
    "dropkey": "SW16257",
    "droptype": "D",
    "dropname": "COUNTRY CLUB",
    "dropdeladd": "108 W 63RD ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641131628,
    "dropphyadd": "108 W 63RD ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641131628,
    "dropmaladd": "108 W 63RD ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641131628,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163615467,
    "dropsitcph": 8163615675,
    "dropfax": 8163942128
  },
  {
    "dcode": "D",
    "dropkey": "SW16431",
    "droptype": "D",
    "dropname": "ENGLEWOOD",
    "dropdeladd": "1500 S NORTHERN BLVD",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "MO",
    "dropdelzpp": 640529998,
    "dropphyadd": "1500 S NORTHERN BLVD",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "MO",
    "dropphyzpp": 640529998,
    "dropmaladd": "1500 S NORTHERN BLVD",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "MO",
    "dropmalzpp": 640529998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164614820,
    "dropsitcph": 8164125619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16457",
    "droptype": "D",
    "dropname": "EXECUTIVE PARK",
    "dropdeladd": "1740 UNIVERSAL AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641209998,
    "dropphyadd": "1740 UNIVERSAL AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641209998,
    "dropmaladd": "1740 UNIVERSAL AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641209998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162413037,
    "dropsitcph": 8162413001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16466",
    "droptype": "D",
    "dropname": "FAIRLEIGH",
    "dropdeladd": "2514 FREDERICK AVE",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MO",
    "dropdelzpp": 645069998,
    "dropphyadd": "2514 FREDERICK AVE",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MO",
    "dropphyzpp": 645069998,
    "dropmaladd": "2514 FREDERICK AVE",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MO",
    "dropmalzpp": 645069998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162796908,
    "dropsitcph": 8162796908,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16530",
    "droptype": "D",
    "dropname": "FREDERICK N WEATHERS",
    "dropdeladd": "3415 N KINGSHIGHWAY BLVD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631159998,
    "dropphyadd": "3415 N KINGSHIGHWAY BLVD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631159998,
    "dropmaladd": "3415 N KINGSHIGHWAY BLVD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631159998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143895169,
    "dropsitcph": 3143897513,
    "dropfax": 3143856931
  },
  {
    "dcode": "D",
    "dropkey": "SW16593",
    "droptype": "D",
    "dropname": "GLENSTONE",
    "dropdeladd": "1442 S GLENSTONE AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658049998,
    "dropphyadd": "1442 S GLENSTONE AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658049998,
    "dropmaladd": "1442 S GLENSTONE AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658049998,
    "dropsitphn": 8163749109,
    "dropsitlph": 4178824451,
    "dropsitcph": 4178824451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16635",
    "droptype": "D",
    "dropname": "GRAVOIS",
    "dropdeladd": "4455 RIDGEWOOD AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631169997,
    "dropphyadd": "4455 RIDGEWOOD AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631169997,
    "dropmaladd": "4455 RIDGEWOOD AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631169997,
    "dropsitphn": 3148959275,
    "dropsitlph": 3144817503,
    "dropsitcph": 3144810014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16680",
    "droptype": "D",
    "dropname": "GWEN B GILES",
    "dropdeladd": "1409 HAMILTON AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631129998,
    "dropphyadd": "1409 HAMILTON AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631129998,
    "dropmaladd": "1409 HAMILTON AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631129998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143821058,
    "dropsitcph": 3143858977,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16709",
    "droptype": "D",
    "dropname": "HARRY S TRUMAN",
    "dropdeladd": "14200 E 32ND ST S",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "MO",
    "dropdelzpp": 640559998,
    "dropphyadd": "14200 E 32ND ST S",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "MO",
    "dropphyzpp": 640559998,
    "dropmaladd": "14200 E 32ND ST S",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "MO",
    "dropmalzpp": 640559998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8164611286,
    "dropsitcph": 8164611436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16741",
    "droptype": "D",
    "dropname": "HENRY W WHEELER",
    "dropdeladd": "1140 OLIVE ST",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631019998,
    "dropphyadd": "1140 OLIVE ST",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631019998,
    "dropmaladd": "1140 OLIVE ST",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631019998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3146211328,
    "dropsitcph": 3146211328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16746",
    "droptype": "D",
    "dropname": "HICKMAN MILLS",
    "dropdeladd": "6921 E 111TH ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641349998,
    "dropphyadd": "6921 E 111TH ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641349998,
    "dropmaladd": "6921 E 111TH ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641349998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167637867,
    "dropsitcph": 8167630542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16835",
    "droptype": "D",
    "dropname": "INDEP MAIN OFF",
    "dropdeladd": "301 W LEXINGTON AVE STE 110",
    "dropdelcty": "INDEPENDENCE",
    "dropdelst": "MO",
    "dropdelzpp": 640503724,
    "dropphyadd": "301 W LEXINGTON AVE STE 110",
    "dropphycty": "INDEPENDENCE",
    "dropphyst": "MO",
    "dropphyzpp": 640503724,
    "dropmaladd": "301 W LEXINGTON AVE STE 110",
    "dropmalcty": "INDEPENDENCE",
    "dropmalst": "MO",
    "dropmalzpp": 640503724,
    "dropsitphn": 8163749109,
    "dropsitlph": 8164125619,
    "dropsitcph": 8164125619,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16854",
    "droptype": "D",
    "dropname": "JAMES CREWS",
    "dropdeladd": "2201 E TRUMAN RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641279998,
    "dropphyadd": "2201 E TRUMAN RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641279998,
    "dropmaladd": "2201 E TRUMAN RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641279998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162414761,
    "dropsitcph": 8162418081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16866",
    "droptype": "D",
    "dropname": "JEFFERSON MEMORIAL",
    "dropdeladd": "111 N 6TH ST",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631019997,
    "dropphyadd": "111 N 6TH ST",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631019997,
    "dropmaladd": "111 N 6TH ST",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631019997,
    "dropsitphn": 3148959275,
    "dropsitlph": 3142410380,
    "dropsitcph": 3146211328,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16872",
    "droptype": "D",
    "dropname": "JESSE M DONALDSON",
    "dropdeladd": "156 PARIS ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641539997,
    "dropphyadd": "156 PARIS ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641539997,
    "dropmaladd": "156 PARIS ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641539997,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162435751,
    "dropsitcph": 8162435751,
    "dropfax": 8162435657
  },
  {
    "dcode": "D",
    "dropkey": "SW16876",
    "droptype": "D",
    "dropname": "JORDAN W CHAMBERS",
    "dropdeladd": "901 N GARRISON AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631069998,
    "dropphyadd": "901 N GARRISON AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631069998,
    "dropmaladd": "901 N GARRISON AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631069998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145310482,
    "dropsitcph": 3145310910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW16889",
    "droptype": "D",
    "dropname": "KANSAS CITY MAIN OFFICE",
    "dropdeladd": "300 W PERSHING RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641084318,
    "dropphyadd": "300 W PERSHING RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641084318,
    "dropmaladd": "300 W PERSHING RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641084318,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749101,
    "dropsitcph": 8163749101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17017",
    "droptype": "D",
    "dropname": "LEEDS",
    "dropdeladd": "6817 STADIUM DR",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641291860,
    "dropphyadd": "6817 STADIUM DR",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641291860,
    "dropmaladd": "6817 STADIUM DR",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641291860,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163749724,
    "dropsitcph": 8168618993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17025",
    "droptype": "D",
    "dropname": "LEON MERCER JORDAN",
    "dropdeladd": "3231 PROSPECT AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641289998,
    "dropphyadd": "3231 PROSPECT AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641289998,
    "dropmaladd": "3231 PROSPECT AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641289998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168610726,
    "dropsitcph": 8168610597,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17070",
    "droptype": "D",
    "dropname": "LONGVIEW",
    "dropdeladd": "8800 RAYTOWN RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641389998,
    "dropphyadd": "8800 RAYTOWN RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641389998,
    "dropmaladd": "8800 RAYTOWN RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641389998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8167373275,
    "dropsitcph": 8167373255,
    "dropfax": 6505784560
  },
  {
    "dcode": "D",
    "dropkey": "SW17176",
    "droptype": "D",
    "dropname": "MARTIN CITY",
    "dropdeladd": "10 E 135TH ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641459998,
    "dropphyadd": "10 E 135TH ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641459998,
    "dropmaladd": "10 E 135TH ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641459998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8169438589,
    "dropsitcph": 8169438539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17193",
    "droptype": "D",
    "dropname": "MARYVILLE GARDENS",
    "dropdeladd": "2920 MERAMEC ST",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631189998,
    "dropphyadd": "2920 MERAMEC ST",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631189998,
    "dropmaladd": "2920 MERAMEC ST",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631189998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143536536,
    "dropsitcph": 3143536536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17400",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "105 N HARDESTY AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641239998,
    "dropphyadd": "105 N HARDESTY AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641239998,
    "dropmaladd": "105 N HARDESTY AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641239998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162316641,
    "dropsitcph": 8162315863,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17493",
    "droptype": "D",
    "dropname": "PARKWAY",
    "dropdeladd": "4320 DR MARTIN LUTHER KING JR BLVD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641309998,
    "dropphyadd": "4320 DR MARTIN LUTHER KING JR BLVD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641309998,
    "dropmaladd": "4320 DR MARTIN LUTHER KING JR BLVD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641309998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8169246882,
    "dropsitcph": 8169245685,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17543",
    "droptype": "D",
    "dropname": "MARIAN OLDHAM",
    "dropdeladd": "4021 LACLEDE AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631089998,
    "dropphyadd": "4021 LACLEDE AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631089998,
    "dropmaladd": "4021 LACLEDE AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631089998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145335058,
    "dropsitcph": 3145334697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17562",
    "droptype": "D",
    "dropname": "PLAZA FINANCE",
    "dropdeladd": "5104 MAIN ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641122741,
    "dropphyadd": "5104 MAIN ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641122741,
    "dropmaladd": "5104 MAIN ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641122741,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165311781,
    "dropsitcph": 8165311770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17718",
    "droptype": "D",
    "dropname": "ROLLA STATION #1",
    "dropdeladd": "1003 S BISHOP AVE",
    "dropdelcty": "ROLLA",
    "dropdelst": "MO",
    "dropdelzpp": 654014437,
    "dropphyadd": "1003 S BISHOP AVE",
    "dropphycty": "ROLLA",
    "dropphyst": "MO",
    "dropphyzpp": 654014437,
    "dropmaladd": "1003 S BISHOP AVE",
    "dropmalcty": "ROLLA",
    "dropmalst": "MO",
    "dropmalzpp": 654014437,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733641775,
    "dropsitcph": 5733641775,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17967",
    "droptype": "D",
    "dropname": "SOUTH TROOST",
    "dropdeladd": "7420 TROOST AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641319998,
    "dropphyadd": "7420 TROOST AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641319998,
    "dropmaladd": "7420 TROOST AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641319998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163612047,
    "dropsitcph": 8164448676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW17972",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "3232 CLIFTON AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631399998,
    "dropphyadd": "3232 CLIFTON AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631399998,
    "dropmaladd": "3232 CLIFTON AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631399998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3146450843,
    "dropsitcph": 3146450902,
    "dropfax": 3146456970
  },
  {
    "dcode": "D",
    "dropkey": "SW18339",
    "droptype": "D",
    "dropname": "STOCKYARDS SAINT JOSEPH",
    "dropdeladd": "5706 LAKE AVE",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MO",
    "dropdelzpp": 645049998,
    "dropphyadd": "5706 LAKE AVE",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MO",
    "dropphyzpp": 645049998,
    "dropmaladd": "5706 LAKE AVE",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MO",
    "dropmalzpp": 645049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8162380342,
    "dropsitcph": 8162380342,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW18457",
    "droptype": "D",
    "dropname": "TOWER GROVE",
    "dropdeladd": "3198 S GRAND BLVD",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631189997,
    "dropphyadd": "3198 S GRAND BLVD",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631189997,
    "dropmaladd": "3198 S GRAND BLVD",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631189997,
    "dropsitphn": 3148959275,
    "dropsitlph": 3147717736,
    "dropsitcph": 3147717736,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW18538",
    "droptype": "D",
    "dropname": "VETERANS HOSPITAL",
    "dropdeladd": "4801 E LINWOOD BLVD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641282295,
    "dropphyadd": "4801 E LINWOOD BLVD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641282295,
    "dropmaladd": "4801 E LINWOOD BLVD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641282295,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 8162414677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW18635",
    "droptype": "D",
    "dropname": "WESTPORT",
    "dropdeladd": "200 WESTPORT RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641119998,
    "dropphyadd": "200 WESTPORT RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641119998,
    "dropmaladd": "200 WESTPORT RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641119998,
    "dropsitphn": 8165043362,
    "dropsitlph": 8165617381,
    "dropsitcph": 8165619026,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW18684",
    "droptype": "D",
    "dropname": "WORLDS OF FUN",
    "dropdeladd": "4545 NE WORLDS OF FUN DR",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641619307,
    "dropphyadd": "4545 NE WORLDS OF FUN DR",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641619307,
    "dropmaladd": "4545 NE WORLDS OF FUN DR",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641619307,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163749724,
    "dropsitcph": 8162211144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW18864",
    "droptype": "D",
    "dropname": "BISMARCK DOWNTOWN",
    "dropdeladd": "220 E ROSSER AVE RM 112",
    "dropdelcty": "BISMARCK",
    "dropdelst": "ND",
    "dropdelzpp": 585019998,
    "dropphyadd": "220 E ROSSER AVE RM 112",
    "dropphycty": "BISMARCK",
    "dropphyst": "ND",
    "dropphyzpp": 585019998,
    "dropmaladd": "220 E ROSSER AVE RM 112",
    "dropmalcty": "BISMARCK",
    "dropmalst": "ND",
    "dropmalzpp": 585019998,
    "dropsitphn": 6053574932,
    "dropsitlph": "",
    "dropsitcph": 7012238810,
    "dropfax": 7012556963
  },
  {
    "dcode": "D",
    "dropkey": "SW19229",
    "droptype": "D",
    "dropname": "PRAIRIEWOOD",
    "dropdeladd": "1455 32ND ST S",
    "dropdelcty": "FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 581033400,
    "dropphyadd": "1455 32ND ST S",
    "dropphycty": "FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 581033400,
    "dropmaladd": "1455 32ND ST S",
    "dropmalcty": "FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 581033400,
    "dropsitphn": "",
    "dropsitlph": 7012416144,
    "dropsitcph": 7013536048,
    "dropfax": 7012718533
  },
  {
    "dcode": "D",
    "dropkey": "SW19372",
    "droptype": "D",
    "dropname": "STA 9 UNIV OF ND",
    "dropdeladd": "2901 UNIVERSITY AVE STOP 8385",
    "dropdelcty": "GRAND FORKS",
    "dropdelst": "ND",
    "dropdelzpp": 582028385,
    "dropphyadd": "2901 UNIVERSITY AVE STOP 8385",
    "dropphycty": "GRAND FORKS",
    "dropphyst": "ND",
    "dropphyzpp": 582028385,
    "dropmaladd": "2901 UNIVERSITY AVE STOP 8385",
    "dropmalcty": "GRAND FORKS",
    "dropmalst": "ND",
    "dropmalzpp": 582028385,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7013352000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19436",
    "droptype": "D",
    "dropname": "AIR MAIL FACILITY",
    "dropdeladd": "6005 LOCKHEED CT",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681102600,
    "dropphyadd": "6005 LOCKHEED CT",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681102600,
    "dropmaladd": "6005 LOCKHEED CT",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681102600,
    "dropsitphn": 4023482547,
    "dropsitlph": 4023482547,
    "dropsitcph": 4023426291,
    "dropfax": 4023452931
  },
  {
    "dcode": "D",
    "dropkey": "SW19451",
    "droptype": "D",
    "dropname": "AMES AVENUE",
    "dropdeladd": "3030 MEREDITH AVE",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681119998,
    "dropphyadd": "3030 MEREDITH AVE",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681119998,
    "dropmaladd": "3030 MEREDITH AVE",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681119998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024552654,
    "dropsitcph": 4024552654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19514",
    "droptype": "D",
    "dropname": "BENSON",
    "dropdeladd": "6223 MAPLE ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681049998,
    "dropphyadd": "6223 MAPLE ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681049998,
    "dropmaladd": "6223 MAPLE ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4055510159,
    "dropsitcph": 4025536524,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19540",
    "droptype": "D",
    "dropname": "BOYSTOWN",
    "dropdeladd": "139 S 144TH ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681549998,
    "dropphyadd": "139 S 144TH ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681549998,
    "dropmaladd": "139 S 144TH ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681549998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024452496,
    "dropsitcph": 4024452496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19617",
    "droptype": "D",
    "dropname": "COLLEGE VIEW",
    "dropdeladd": "5100 VAN DORN ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685069998,
    "dropphyadd": "5100 VAN DORN ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685069998,
    "dropmaladd": "5100 VAN DORN ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685069998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024731726,
    "dropsitcph": 4024581886,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": "SW19687",
    "droptype": "D",
    "dropname": "POSTAL EMPORIUM",
    "dropdeladd": "1617 FARNAM ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681022101,
    "dropphyadd": "1617 FARNAM ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681022101,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681019998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023460269,
    "dropsitcph": 4023460274,
    "dropfax": 4023416830
  },
  {
    "dcode": "D",
    "dropkey": "SW19717",
    "droptype": "D",
    "dropname": "ELMWOOD PARK",
    "dropdeladd": "1718 S 51ST ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681062496,
    "dropphyadd": "1718 S 51ST ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681062496,
    "dropmaladd": "1718 S 51ST ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681062496,
    "dropsitphn": 4023482736,
    "dropsitlph": 4025510222,
    "dropsitcph": 4025536576,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19749",
    "droptype": "D",
    "dropname": "FLORENCE",
    "dropdeladd": "2910 STATE ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681129998,
    "dropphyadd": "2910 STATE ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681129998,
    "dropmaladd": "2910 STATE ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681129998,
    "dropsitphn": 4023482736,
    "dropsitlph": 4024511915,
    "dropsitcph": 4024512643,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW19828",
    "droptype": "D",
    "dropname": "HAVELOCK",
    "dropdeladd": "6240 PLATTE AVE",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685079850,
    "dropphyadd": "6240 PLATTE AVE",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685079850,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685299998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024581829,
    "dropsitcph": 4024581829,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": "SW19877",
    "droptype": "D",
    "dropname": "INDIAN VILLAGE",
    "dropdeladd": "1201 CALVERT ST",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685029998,
    "dropphyadd": "1201 CALVERT ST",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685029998,
    "dropmaladd": "1201 CALVERT ST",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685029998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024731742,
    "dropsitcph": 4024581830,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": "SW20054",
    "droptype": "D",
    "dropname": "ARGENTINE",
    "dropdeladd": "3400 STRONG AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661069990,
    "dropphyadd": "3400 STRONG AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661069990,
    "dropmaladd": "3400 STRONG AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661069990,
    "dropsitphn": 8165043362,
    "dropsitlph": 9134329945,
    "dropsitcph": 9137898153,
    "dropfax": 9134327216
  },
  {
    "dcode": "D",
    "dropkey": "SW20322",
    "droptype": "D",
    "dropname": "CHISHOLM",
    "dropdeladd": "2510 S ELIZABETH AVE",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672179998,
    "dropphyadd": "2510 S ELIZABETH AVE",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672179998,
    "dropmaladd": "2510 S ELIZABETH AVE",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672179998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3162640529,
    "dropsitcph": 3162640114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW20329",
    "droptype": "D",
    "dropname": "CIVIC CENTER",
    "dropdeladd": "550 NEBRASKA AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661019998,
    "dropphyadd": "550 NEBRASKA AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661019998,
    "dropmaladd": "550 NEBRASKA AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661019998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9136214116,
    "dropsitcph": 9136210013,
    "dropfax": 9136215399
  },
  {
    "dcode": "D",
    "dropkey": "SW20374",
    "droptype": "D",
    "dropname": "CORPORATE HILLS",
    "dropdeladd": "9350 E CORPORATE HILLS DR",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672079998,
    "dropphyadd": "9350 E CORPORATE HILLS DR",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672079998,
    "dropmaladd": "9350 E CORPORATE HILLS DR",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672079998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3166811507,
    "dropsitcph": 3166128013,
    "dropfax": 3166186367
  },
  {
    "dcode": "D",
    "dropkey": "SW20448",
    "droptype": "D",
    "dropname": "DOWNTOWN",
    "dropdeladd": "330 W 2ND ST N",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672029998,
    "dropphyadd": "330 W 2ND ST N",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672029998,
    "dropmaladd": "330 W 2ND ST N",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672029998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3162677798,
    "dropsitcph": 3162677710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW20580",
    "droptype": "D",
    "dropname": "GAGE CENTER",
    "dropdeladd": "1430 SW WOODHULL ST",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666049998,
    "dropphyadd": "1430 SW WOODHULL ST",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666049998,
    "dropmaladd": "1430 SW WOODHULL ST",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852724739,
    "dropsitcph": 7852720002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW20598",
    "droptype": "D",
    "dropname": "GMF RETAIL WINDOW",
    "dropdeladd": "7117 W HARRY ST",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672769804,
    "dropphyadd": "7117 W HARRY ST",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672769804,
    "dropmaladd": "7117 W HARRY ST",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672769804,
    "dropsitphn": 4023482736,
    "dropsitlph": 3169464620,
    "dropsitcph": 3162194361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW20695",
    "droptype": "D",
    "dropname": "HICREST",
    "dropdeladd": "2921 SE ADAMS ST",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666059998,
    "dropphyadd": "2921 SE ADAMS ST",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666059998,
    "dropmaladd": "2921 SE ADAMS ST",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666059998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852660347,
    "dropsitcph": 7852660347,
    "dropfax": 7852672684
  },
  {
    "dcode": "D",
    "dropkey": "SW20762",
    "droptype": "D",
    "dropname": "JAYHAWK",
    "dropdeladd": "1901 W 31ST ST",
    "dropdelcty": "LAWRENCE",
    "dropdelst": "KS",
    "dropdelzpp": 660469998,
    "dropphyadd": "1901 W 31ST ST",
    "dropphycty": "LAWRENCE",
    "dropphyst": "KS",
    "dropphyzpp": 660469998,
    "dropmaladd": "1901 W 31ST ST",
    "dropmalcty": "LAWRENCE",
    "dropmalst": "KS",
    "dropmalzpp": 660469998,
    "dropsitphn": 8163749109,
    "dropsitlph": 7858432330,
    "dropsitcph": 7858432330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW21067",
    "droptype": "D",
    "dropname": "MUNCIE",
    "dropdeladd": "6540 KAW DR",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661119997,
    "dropphyadd": "6540 KAW DR",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661119997,
    "dropmaladd": "6540 KAW DR",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661119997,
    "dropsitphn": 8165043362,
    "dropsitlph": 9132996918,
    "dropsitcph": 9132996918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW21069",
    "droptype": "D",
    "dropname": "MUNGER",
    "dropdeladd": "1314 N OLIVER AVE",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672082804,
    "dropphyadd": "1314 N OLIVER AVE",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672082804,
    "dropmaladd": "1314 N OLIVER AVE",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672082804,
    "dropsitphn": 4023482736,
    "dropsitlph": 3166854250,
    "dropsitcph": 3166180054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW21113",
    "droptype": "D",
    "dropname": "NORTH TOPEKA",
    "dropdeladd": "220 NW LYMAN RD",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666089998,
    "dropphyadd": "220 NW LYMAN RD",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666089998,
    "dropmaladd": "220 NW LYMAN RD",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666089998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7853544964,
    "dropsitcph": 7852959188,
    "dropfax": 7852323015
  },
  {
    "dcode": "D",
    "dropkey": "SW21115",
    "droptype": "D",
    "dropname": "NORTH WICHITA",
    "dropdeladd": "2325 N ARKANSAS AVE",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672049998,
    "dropphyadd": "2325 N ARKANSAS AVE",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672049998,
    "dropmaladd": "2325 N ARKANSAS AVE",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672049998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3168380407,
    "dropsitcph": 3168380309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW21143",
    "droptype": "D",
    "dropname": "OLATHE EAST",
    "dropdeladd": "15050 W 138TH ST",
    "dropdelcty": "OLATHE",
    "dropdelst": "KS",
    "dropdelzpp": 660629998,
    "dropphyadd": "15050 W 138TH ST",
    "dropphycty": "OLATHE",
    "dropphyst": "KS",
    "dropphyzpp": 660629998,
    "dropmaladd": "15050 W 138TH ST",
    "dropmalcty": "OLATHE",
    "dropmalst": "KS",
    "dropmalzpp": 660629998,
    "dropsitphn": 8163749109,
    "dropsitlph": 9137822029,
    "dropsitcph": 9137823423,
    "dropfax": 9138292085
  },
  {
    "dcode": "D",
    "dropkey": "SW21195",
    "droptype": "D",
    "dropname": "PAULINE",
    "dropdeladd": "5826 SW TOPEKA BLVD",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666191406,
    "dropphyadd": "5826 SW TOPEKA BLVD",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666191406,
    "dropmaladd": "5826 SW TOPEKA BLVD",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666191406,
    "dropsitphn": 4023482736,
    "dropsitlph": 7858620729,
    "dropsitcph": 7852660347,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW21298",
    "droptype": "D",
    "dropname": "RIVER CITY",
    "dropdeladd": "3241 S HYDRAULIC ST",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672169998,
    "dropphyadd": "3241 S HYDRAULIC ST",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672169998,
    "dropmaladd": "3241 S HYDRAULIC ST",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672169998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3165228922,
    "dropsitcph": 3165291653,
    "dropfax": 3165246495
  },
  {
    "dcode": "D",
    "dropkey": "SW21301",
    "droptype": "D",
    "dropname": "ROBERT L ROBERTS",
    "dropdeladd": "3115 N 51ST ST",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661049998,
    "dropphyadd": "3115 N 51ST ST",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661049998,
    "dropmaladd": "3115 N 51ST ST",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661049998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9132877098,
    "dropsitcph": 9132877165,
    "dropfax": 9132875453
  },
  {
    "dcode": "D",
    "dropkey": "SW21316",
    "droptype": "D",
    "dropname": "ROSEDALE",
    "dropdeladd": "2200 W 36TH AVE",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661039998,
    "dropphyadd": "2200 W 36TH AVE",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661039998,
    "dropmaladd": "2200 W 36TH AVE",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661039998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9132626463,
    "dropsitcph": 9132626463,
    "dropfax": 9134326095
  },
  {
    "dcode": "D",
    "dropkey": "SW21798",
    "droptype": "D",
    "dropname": "WYANDOTTE WEST",
    "dropdeladd": "1310 N 78TH TER",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "KS",
    "dropdelzpp": 661129998,
    "dropphyadd": "1310 N 78TH TER",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "KS",
    "dropphyzpp": 661129998,
    "dropmaladd": "1310 N 78TH TER",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "KS",
    "dropmalzpp": 661129998,
    "dropsitphn": 8165043362,
    "dropsitlph": 9133345859,
    "dropsitcph": 9133344182,
    "dropfax": 9133349576
  },
  {
    "dcode": "D",
    "dropkey": "SW21895",
    "droptype": "D",
    "dropname": "BRITTON",
    "dropdeladd": "301 W BRITTON RD",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731149998,
    "dropphyadd": "301 W BRITTON RD",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731149998,
    "dropmaladd": "301 W BRITTON RD",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731149998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058480005,
    "dropsitcph": 4058480005,
    "dropfax": 4058483660
  },
  {
    "dcode": "D",
    "dropkey": "SW21935",
    "droptype": "D",
    "dropname": "CENTENNIAL STATION",
    "dropdeladd": "801 W 33RD ST",
    "dropdelcty": "EDMOND",
    "dropdelst": "OK",
    "dropdelzpp": 730139998,
    "dropphyadd": "801 W 33RD ST",
    "dropphycty": "EDMOND",
    "dropphyst": "OK",
    "dropphyzpp": 730139998,
    "dropmaladd": "801 W 33RD ST",
    "dropmalcty": "EDMOND",
    "dropmalst": "OK",
    "dropmalzpp": 730139998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053485605,
    "dropsitcph": 4053489104,
    "dropfax": 4053489033
  },
  {
    "dcode": "D",
    "dropkey": "SW21936",
    "droptype": "D",
    "dropname": "CENTER CITY",
    "dropdeladd": "305 NW 5TH ST",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731029998,
    "dropphyadd": "305 NW 5TH ST",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731029998,
    "dropmaladd": "305 NW 5TH ST",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731029998,
    "dropsitphn": 4052322198,
    "dropsitlph": 4052322198,
    "dropsitcph": 4052322198,
    "dropfax": 4052328312
  },
  {
    "dcode": "D",
    "dropkey": "SW22011",
    "droptype": "D",
    "dropname": "DONALDSON",
    "dropdeladd": "1423 TERRACE DR",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741049998,
    "dropphyadd": "1423 TERRACE DR",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741049998,
    "dropmaladd": "1423 TERRACE DR",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741049998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187444166,
    "dropsitcph": 9187431581,
    "dropfax": 9187426484
  },
  {
    "dcode": "D",
    "dropkey": "SW22029",
    "droptype": "D",
    "dropname": "EAST SIDE BARTLESVILLE",
    "dropdeladd": "3900 SE GREEN COUNTRY RD",
    "dropdelcty": "BARTLESVILLE",
    "dropdelst": "OK",
    "dropdelzpp": 740069998,
    "dropphyadd": "3900 SE GREEN COUNTRY RD",
    "dropphycty": "BARTLESVILLE",
    "dropphyst": "OK",
    "dropphyzpp": 740069998,
    "dropmaladd": "3900 SE GREEN COUNTRY RD",
    "dropmalcty": "BARTLESVILLE",
    "dropmalst": "OK",
    "dropmalzpp": 740069998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183319574,
    "dropsitcph": 9183319574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22031",
    "droptype": "D",
    "dropname": "EASTSIDE TULSA",
    "dropdeladd": "2920 S 129TH EAST AVE",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741349998,
    "dropphyadd": "2920 S 129TH EAST AVE",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741349998,
    "dropmaladd": "2920 S 129TH EAST AVE",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741349998,
    "dropsitphn": 9186641791,
    "dropsitlph": 9186641791,
    "dropsitcph": 9186641791,
    "dropfax": 9186641569
  },
  {
    "dcode": "D",
    "dropkey": "SW22139",
    "droptype": "D",
    "dropname": "HEFNER",
    "dropdeladd": "7800 W HEFNER RD",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731629998,
    "dropphyadd": "7800 W HEFNER RD",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731629998,
    "dropmaladd": "7800 W HEFNER RD",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731629998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057227956,
    "dropsitcph": 4057227695,
    "dropfax": 4057213846
  },
  {
    "dcode": "D",
    "dropkey": "SW22322",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "5313 E INDEPENDENCE ST",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741159998,
    "dropphyadd": "5313 E INDEPENDENCE ST",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741159998,
    "dropmaladd": "5313 E INDEPENDENCE ST",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741159998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9188356244,
    "dropsitcph": 9188358089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22324",
    "droptype": "D",
    "dropname": "NORTHSIDE",
    "dropdeladd": "626 E APACHE ST",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741069998,
    "dropphyadd": "626 E APACHE ST",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741069998,
    "dropmaladd": "626 E APACHE ST",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741069998,
    "dropsitphn": 9185840745,
    "dropsitlph": 9185840745,
    "dropsitcph": 9185840765,
    "dropfax": 9185846253
  },
  {
    "dcode": "D",
    "dropkey": "SW22383",
    "droptype": "D",
    "dropname": "PENN 89",
    "dropdeladd": "9201 S PENNSYLVANIA AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731599998,
    "dropphyadd": "9201 S PENNSYLVANIA AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731599998,
    "dropmaladd": "9201 S PENNSYLVANIA AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731599998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053783734,
    "dropsitcph": 4053783726,
    "dropfax": 4056915842
  },
  {
    "dcode": "D",
    "dropkey": "SW22434",
    "droptype": "D",
    "dropname": "RENO MERIDIAN",
    "dropdeladd": "4901 W RENO AVE STE 400",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731276338,
    "dropphyadd": "4901 W RENO AVE STE 400",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731276338,
    "dropmaladd": "4901 W RENO AVE STE 400",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731276338,
    "dropsitphn": 4056856605,
    "dropsitlph": 4059494079,
    "dropsitcph": 4059499761,
    "dropfax": 4059480824
  },
  {
    "dcode": "D",
    "dropkey": "SW22473",
    "droptype": "D",
    "dropname": "SHARTEL",
    "dropdeladd": "5300 N SHARTEL AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731189998,
    "dropphyadd": "5300 N SHARTEL AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731189998,
    "dropmaladd": "5300 N SHARTEL AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731189998,
    "dropsitphn": 4058486382,
    "dropsitlph": 4058480986,
    "dropsitcph": 4058480986,
    "dropfax": 4058483682
  },
  {
    "dcode": "D",
    "dropkey": "SW22480",
    "droptype": "D",
    "dropname": "SHERIDAN LAWTON",
    "dropdeladd": "6601 W GORE BLVD",
    "dropdelcty": "LAWTON",
    "dropdelst": "OK",
    "dropdelzpp": 735059998,
    "dropphyadd": "6601 W GORE BLVD",
    "dropphycty": "LAWTON",
    "dropphyst": "OK",
    "dropphyzpp": 735059998,
    "dropmaladd": "6601 W GORE BLVD",
    "dropmalcty": "LAWTON",
    "dropmalst": "OK",
    "dropmalzpp": 735059998,
    "dropsitphn": 4058152724,
    "dropsitlph": 5805363526,
    "dropsitcph": 5805363526,
    "dropfax": 5805363523
  },
  {
    "dcode": "D",
    "dropkey": "SW22481",
    "droptype": "D",
    "dropname": "SHERIDAN TULSA",
    "dropdeladd": "6110 E 51ST PL",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741359998,
    "dropphyadd": "6110 E 51ST PL",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741359998,
    "dropmaladd": "6110 E 51ST PL",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741359998,
    "dropsitphn": 9186642083,
    "dropsitlph": 9186644699,
    "dropsitcph": 9186644699,
    "dropfax": 9186221135
  },
  {
    "dcode": "D",
    "dropkey": "SW22491",
    "droptype": "D",
    "dropname": "SOONER",
    "dropdeladd": "200 36TH AVE NW",
    "dropdelcty": "NORMAN",
    "dropdelst": "OK",
    "dropdelzpp": 730729998,
    "dropphyadd": "200 36TH AVE NW",
    "dropphycty": "NORMAN",
    "dropphyst": "OK",
    "dropphyzpp": 730729998,
    "dropmaladd": "200 36TH AVE NW",
    "dropmalcty": "NORMAN",
    "dropmalst": "OK",
    "dropmalzpp": 730729998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4053666149,
    "dropsitcph": 4053666149,
    "dropfax": 4053608957
  },
  {
    "dcode": "D",
    "dropkey": "SW22495",
    "droptype": "D",
    "dropname": "SOUTHEAST OKLAHOMA CITY",
    "dropdeladd": "4801 S I 35 SERVICE RD",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731299998,
    "dropphyadd": "4801 S I 35 SERVICE RD",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731299998,
    "dropmaladd": "4801 S I 35 SERVICE RD",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731299998,
    "dropsitphn": 4056779439,
    "dropsitlph": 4056779439,
    "dropsitcph": 4056779439,
    "dropfax": 4056770143
  },
  {
    "dcode": "D",
    "dropkey": "SW22496",
    "droptype": "D",
    "dropname": "SOUTHEAST TULSA",
    "dropdeladd": "9023 E 46TH ST",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741459998,
    "dropphyadd": "9023 E 46TH ST",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741459998,
    "dropmaladd": "9023 E 46TH ST",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741459998,
    "dropsitphn": 9186274637,
    "dropsitlph": 9186274637,
    "dropsitcph": 9186274637,
    "dropfax": 9186221179
  },
  {
    "dcode": "D",
    "dropkey": "SW22497",
    "droptype": "D",
    "dropname": "ROBERT W JENKINS",
    "dropdeladd": "6910 S YORKTOWN AVE",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741369998,
    "dropphyadd": "6910 S YORKTOWN AVE",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741369998,
    "dropmaladd": "6910 S YORKTOWN AVE",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741369998,
    "dropsitphn": 9184921630,
    "dropsitlph": 9184921630,
    "dropsitcph": 9184921630,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22517",
    "droptype": "D",
    "dropname": "STATE CAPITOL",
    "dropdeladd": "2401 N LINCOLN BLVD RM C10",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731059998,
    "dropphyadd": "2401 N LINCOLN BLVD RM C10",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731059998,
    "dropmaladd": "2401 N LINCOLN BLVD RM C10",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731059998,
    "dropsitphn": 4056856605,
    "dropsitlph": 4055256076,
    "dropsitcph": 4055256076,
    "dropfax": 4054245948
  },
  {
    "dcode": "D",
    "dropkey": "SW22523",
    "droptype": "D",
    "dropname": "STOCKYARDS",
    "dropdeladd": "1101 S AGNEW AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731089998,
    "dropphyadd": "1101 S AGNEW AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731089998,
    "dropmaladd": "1101 S AGNEW AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731089998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058152913,
    "dropsitcph": 4058152913,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22552",
    "droptype": "D",
    "dropname": "THIRTY NINTH STREET",
    "dropdeladd": "3022 W I 44 SERVICE RD",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731129998,
    "dropphyadd": "3022 W I 44 SERVICE RD",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731129998,
    "dropmaladd": "3022 W I 44 SERVICE RD",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731129998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4059467285,
    "dropsitcph": 4059468493,
    "dropfax": 4059469516
  },
  {
    "dcode": "D",
    "dropkey": "SW22561",
    "droptype": "D",
    "dropname": "TOWNWEST",
    "dropdeladd": "501 SW 5TH ST",
    "dropdelcty": "LAWTON",
    "dropdelst": "OK",
    "dropdelzpp": 735019998,
    "dropphyadd": "501 SW 5TH ST",
    "dropphycty": "LAWTON",
    "dropphyst": "OK",
    "dropphyzpp": 735019908,
    "dropmaladd": "501 SW 5TH ST",
    "dropmalcty": "LAWTON",
    "dropmalst": "OK",
    "dropmalzpp": 735019998,
    "dropsitphn": 4056856605,
    "dropsitlph": "",
    "dropsitcph": 4053531500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22583",
    "droptype": "D",
    "dropname": "UTICA SQUARE",
    "dropdeladd": "2032 UTICA SQ",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741149998,
    "dropphyadd": "2032 UTICA SQ",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741149998,
    "dropmaladd": "2032 UTICA SQ",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741149998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187428096,
    "dropsitcph": 9187421384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22626",
    "droptype": "D",
    "dropname": "WARR ACRES",
    "dropdeladd": "6001 NW 63RD ST",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731329998,
    "dropphyadd": "6001 NW 63RD ST",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731329998,
    "dropmaladd": "6001 NW 63RD ST",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731329998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4056210634,
    "dropsitcph": 4056210634,
    "dropfax": 4057211367
  },
  {
    "dcode": "D",
    "dropkey": "SW22628",
    "droptype": "D",
    "dropname": "WEST TULSA",
    "dropdeladd": "3408 W 42ND PL",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741079998,
    "dropphyadd": "3408 W 42ND PL",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741079998,
    "dropmaladd": "3408 W 42ND PL",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741079998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9184464789,
    "dropsitcph": 9184463976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22661",
    "droptype": "D",
    "dropname": "STATION A BAYTOWN",
    "dropdeladd": "3508 MARKET ST",
    "dropdelcty": "BAYTOWN",
    "dropdelst": "TX",
    "dropdelzpp": 775209998,
    "dropphyadd": "3508 MARKET ST",
    "dropphycty": "BAYTOWN",
    "dropphyst": "TX",
    "dropphyzpp": 775209998,
    "dropmaladd": "3508 MARKET ST",
    "dropmalcty": "BAYTOWN",
    "dropmalst": "TX",
    "dropmalzpp": 775209998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814270871,
    "dropsitcph": 2814275485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22662",
    "droptype": "D",
    "dropname": "STATION A DALLAS",
    "dropdeladd": "515 CENTRE ST",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752089998,
    "dropphyadd": "515 CENTRE ST",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752089998,
    "dropmaladd": "515 CENTRE ST",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752089998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2149431251,
    "dropsitcph": 2149431251,
    "dropfax": 2149410254
  },
  {
    "dcode": "D",
    "dropkey": "SW22680",
    "droptype": "D",
    "dropname": "ADDICKS BARKER",
    "dropdeladd": "16830 BARKER SPRINGS RD STE 401",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770845038,
    "dropphyadd": "16830 BARKER SPRINGS RD STE 401",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770845038,
    "dropmaladd": "16015 CAIRNWAY DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770849998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814926154,
    "dropsitcph": 2814928588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22688",
    "droptype": "D",
    "dropname": "AGGIELAND",
    "dropdeladd": "127 JOE ROUTT BLVD",
    "dropdelcty": "COLLEGE STATION",
    "dropdelst": "TX",
    "dropdelzpp": 778449800,
    "dropphyadd": "127 JOE ROUTT BLVD",
    "dropphycty": "COLLEGE STATION",
    "dropphyst": "TX",
    "dropphyzpp": 778449800,
    "dropmaladd": "127 JOE ROUTT BLVD",
    "dropmalcty": "COLLEGE STATION",
    "dropmalst": "TX",
    "dropmalzpp": 778449800,
    "dropsitphn": "",
    "dropsitlph": 9798468589,
    "dropsitcph": 9798468589,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22695",
    "droptype": "D",
    "dropname": "AMF HOUSTON",
    "dropdeladd": "19175 LEE RD STE 100",
    "dropdelcty": "HUMBLE",
    "dropdelst": "TX",
    "dropdelzpp": 773384197,
    "dropphyadd": "19175 LEE RD STE 100",
    "dropphycty": "HUMBLE",
    "dropphyst": "TX",
    "dropphyzpp": 773384197,
    "dropmaladd": "PO BOX 60998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772059998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814432960,
    "dropsitcph": 2814432582,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22706",
    "droptype": "D",
    "dropname": "ALBERT THOMAS",
    "dropdeladd": "14917 EL CAMINO REAL",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770629998,
    "dropphyadd": "14917 EL CAMINO REAL",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770629998,
    "dropmaladd": "14917 EL CAMINO REAL",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770629998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814888315,
    "dropsitcph": 2814889173,
    "dropfax": 2814610312
  },
  {
    "dcode": "D",
    "dropkey": "SW22720",
    "droptype": "D",
    "dropname": "ALMEDA",
    "dropdeladd": "3030 W FUQUA ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770459998,
    "dropphyadd": "3030 W FUQUA ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770459998,
    "dropmaladd": "3030 W FUQUA ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770459998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7134334323,
    "dropsitcph": 7134330781,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22746",
    "droptype": "D",
    "dropname": "AMON CARTER",
    "dropdeladd": "4400 AMON CARTER BLVD STE 103",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761559998,
    "dropphyadd": "4400 AMON CARTER BLVD STE 103",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761559998,
    "dropmaladd": "4400 AMON CARTER BLVD STE 103",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761559998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176841681,
    "dropsitcph": 8176840117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22760",
    "droptype": "D",
    "dropname": "ANSON JONES",
    "dropdeladd": "634 W CAVALCADE ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770099998,
    "dropphyadd": "634 W CAVALCADE ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770099998,
    "dropmaladd": "634 W CAVALCADE ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770099998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7138613583,
    "dropsitcph": 7138613577,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22783",
    "droptype": "D",
    "dropname": "ARLINGTON HEIGHTS",
    "dropdeladd": "3101 W 6TH ST",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761072778,
    "dropphyadd": "3101 W 6TH ST",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761072778,
    "dropmaladd": "PO BOX 947998",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761479998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178701530,
    "dropsitcph": 8178701442,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22789",
    "droptype": "D",
    "dropname": "ARSENAL",
    "dropdeladd": "1140 S LAREDO ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782049998,
    "dropphyadd": "1140 S LAREDO ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782049998,
    "dropmaladd": "1140 S LAREDO ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2102261151,
    "dropsitcph": 2102276900,
    "dropfax": 2108860727
  },
  {
    "dcode": "D",
    "dropkey": "SW22796",
    "droptype": "D",
    "dropname": "ASHFORD WEST",
    "dropdeladd": "12655 WHITTINGTON DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770779998,
    "dropphyadd": "12655 WHITTINGTON DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770779998,
    "dropmaladd": "12655 WHITTINGTON DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770779998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2819209334,
    "dropsitcph": 2819209337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22803",
    "droptype": "D",
    "dropname": "ASTRODOME",
    "dropdeladd": "8205 BRAESMAIN DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770259998,
    "dropphyadd": "8205 BRAESMAIN DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770259998,
    "dropmaladd": "8205 BRAESMAIN DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770259998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136617415,
    "dropsitcph": 7136617584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22824",
    "droptype": "D",
    "dropname": "AZALEA",
    "dropdeladd": "2627 S BROADWAY AVE",
    "dropdelcty": "TYLER",
    "dropdelst": "TX",
    "dropdelzpp": 757019998,
    "dropphyadd": "2627 S BROADWAY AVE",
    "dropphycty": "TYLER",
    "dropphyst": "TX",
    "dropphyzpp": 757019998,
    "dropmaladd": "2627 S BROADWAY AVE",
    "dropmalcty": "TYLER",
    "dropmalst": "TX",
    "dropmalzpp": 757019998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035974242,
    "dropsitcph": 9035974242,
    "dropfax": 9035932280
  },
  {
    "dcode": "D",
    "dropkey": "SW22835",
    "droptype": "D",
    "dropname": "BALCONES",
    "dropdeladd": "11900 JOLLYVILLE RD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787599998,
    "dropphyadd": "11900 JOLLYVILLE RD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787599998,
    "dropmaladd": "11900 JOLLYVILLE RD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123311617,
    "dropsitcph": 5123319802,
    "dropfax": 5122198294
  },
  {
    "dcode": "D",
    "dropkey": "SW22848",
    "droptype": "D",
    "dropname": "BARDIN ROAD",
    "dropdeladd": "1301 E BARDIN RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760182130,
    "dropphyadd": "1301 E BARDIN RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760182130,
    "dropmaladd": "1301 E BARDIN RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760182130,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175575561,
    "dropsitcph": 8174728201,
    "dropfax": 8174725145
  },
  {
    "dcode": "D",
    "dropkey": "SW22881",
    "droptype": "D",
    "dropname": "BEACON HILL",
    "dropdeladd": "1064 VANCE JACKSON RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782019998,
    "dropphyadd": "1064 VANCE JACKSON RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782019998,
    "dropmaladd": "1064 VANCE JACKSON RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2107350610,
    "dropsitcph": 2107350549,
    "dropfax": 2107344238
  },
  {
    "dcode": "D",
    "dropkey": "SW22882",
    "droptype": "D",
    "dropname": "BEAR CREEK",
    "dropdeladd": "16015 CAIRNWAY DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770849998,
    "dropphyadd": "16015 CAIRNWAY DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770849998,
    "dropmaladd": "16015 CAIRNWAY DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770849998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815504413,
    "dropsitcph": 2815504413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22896",
    "droptype": "D",
    "dropname": "BEECHNUT",
    "dropdeladd": "11703 BEECHNUT ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770729998,
    "dropphyadd": "11703 BEECHNUT ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770729998,
    "dropmaladd": "11703 BEECHNUT ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770729998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814984529,
    "dropsitcph": 2814984835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22922",
    "droptype": "D",
    "dropname": "BENT TREE",
    "dropdeladd": "4475 TRINITY MILLS RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752879998,
    "dropphyadd": "4475 TRINITY MILLS RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752879998,
    "dropmaladd": "4475 TRINITY MILLS RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752879998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9723804871,
    "dropsitcph": 9723804871,
    "dropfax": 9727358345
  },
  {
    "dcode": "D",
    "dropkey": "SW22930",
    "droptype": "D",
    "dropname": "EIGHTH AVENUE",
    "dropdeladd": "2600 8TH AVE",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761103051,
    "dropphyadd": "2600 8TH AVE",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761103051,
    "dropmaladd": "2600 8TH AVE",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761103051,
    "dropsitphn": 8173173658,
    "dropsitlph": 8179264518,
    "dropsitcph": 8179264518,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW22942",
    "droptype": "D",
    "dropname": "BEVERLY HILLS",
    "dropdeladd": "2202 S COCKRELL HILL RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752119998,
    "dropphyadd": "2202 S COCKRELL HILL RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752119998,
    "dropmaladd": "2202 S COCKRELL HILL RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752119998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143375370,
    "dropsitcph": 2143375370,
    "dropfax": 2143312670
  },
  {
    "dcode": "D",
    "dropkey": "SW22983",
    "droptype": "D",
    "dropname": "BLUEBONNET",
    "dropdeladd": "1822 W BRAKER LN",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787589998,
    "dropphyadd": "1822 W BRAKER LN",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787589998,
    "dropmaladd": "1822 W BRAKER LN",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787589998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128739669,
    "dropsitcph": 5128739289,
    "dropfax": 5123397028
  },
  {
    "dcode": "D",
    "dropkey": "SW22993",
    "droptype": "D",
    "dropname": "BOB LYONS",
    "dropdeladd": "5826 BROADWAY ST",
    "dropdelcty": "GALVESTON",
    "dropdelst": "TX",
    "dropdelzpp": 775519998,
    "dropphyadd": "5826 BROADWAY ST",
    "dropphycty": "GALVESTON",
    "dropphyst": "TX",
    "dropphyzpp": 775519998,
    "dropmaladd": "5826 BROADWAY ST",
    "dropmalcty": "GALVESTON",
    "dropmalst": "TX",
    "dropmalzpp": 775519998,
    "dropsitphn": 4097400137,
    "dropsitlph": 4097400071,
    "dropsitcph": 4097400037,
    "dropfax": 4097419466
  },
  {
    "dcode": "D",
    "dropkey": "SW23042",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "4020 BROADWAY ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770874800,
    "dropphyadd": "4020 BROADWAY ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770874800,
    "dropmaladd": "PO BOX 269998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772079998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136497066,
    "dropsitcph": 7136492559,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23047",
    "droptype": "D",
    "dropname": "BROOKHOLLOW",
    "dropdeladd": "5055 NORWOOD RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752479998,
    "dropphyadd": "5055 NORWOOD RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752479998,
    "dropmaladd": "5055 NORWOOD RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752479998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2146376310,
    "dropsitcph": 2146376310,
    "dropfax": 2146313400
  },
  {
    "dcode": "D",
    "dropkey": "SW23138",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "111 E 17TH ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787019997,
    "dropphyadd": "111 E 17TH ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787019997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124772035,
    "dropsitcph": 5124777082,
    "dropfax": 5127081047
  },
  {
    "dcode": "D",
    "dropkey": "SW23176",
    "droptype": "D",
    "dropname": "CEDAR ELM",
    "dropdeladd": "5837 DE ZAVALA RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782499998,
    "dropphyadd": "5837 DE ZAVALA RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782499998,
    "dropmaladd": "5837 DE ZAVALA RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106410735,
    "dropsitcph": 2106410248,
    "dropfax": 2105617850
  },
  {
    "dcode": "D",
    "dropkey": "SW23195",
    "droptype": "D",
    "dropname": "CENTRAL BEDFORD",
    "dropdeladd": "2124 L DON DODSON DR",
    "dropdelcty": "BEDFORD",
    "dropdelst": "TX",
    "dropdelzpp": 760215896,
    "dropphyadd": "2124 L DON DODSON DR",
    "dropphycty": "BEDFORD",
    "dropphyst": "TX",
    "dropphyzpp": 760215896,
    "dropmaladd": "1300 HARWOOD RD",
    "dropmalcty": "BEDFORD",
    "dropmalst": "TX",
    "dropmalzpp": 760219998,
    "dropsitphn": 8172834761,
    "dropsitlph": 8175712067,
    "dropsitcph": 8178687592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23196",
    "droptype": "D",
    "dropname": "CENTRAL FORT WORTH",
    "dropdeladd": "819 TAYLOR ST",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761026124,
    "dropphyadd": "819 TAYLOR ST",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761026124,
    "dropmaladd": "251 W LANCASTER AVE",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761029997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173326844,
    "dropsitcph": 8173326844,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23197",
    "droptype": "D",
    "dropname": "CENTRAL IRVING",
    "dropdeladd": "2300 STORY RD W",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750389998,
    "dropphyadd": "2300 STORY RD W",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750389998,
    "dropmaladd": "2300 STORY RD W",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750389998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722551637,
    "dropsitcph": 9722551637,
    "dropfax": 9722550388
  },
  {
    "dcode": "D",
    "dropkey": "SW23234",
    "droptype": "D",
    "dropname": "CHIMNEY CORNERS",
    "dropdeladd": "3575 FAR WEST BLVD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787319998,
    "dropphyadd": "3575 FAR WEST BLVD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787319998,
    "dropmaladd": "3575 FAR WEST BLVD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787319998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123452564,
    "dropsitcph": 5123459739,
    "dropfax": 5124180227
  },
  {
    "dcode": "D",
    "dropkey": "SW23258",
    "droptype": "D",
    "dropname": "CIVIC CENTER",
    "dropdeladd": "700 SMITH ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770022717,
    "dropphyadd": "700 SMITH ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770022717,
    "dropmaladd": "PO BOX 61998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772089998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132231683,
    "dropsitcph": 7132231625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23270",
    "droptype": "D",
    "dropname": "CLAYDESTA",
    "dropdeladd": "612 VETERANS AIRPARK LN",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797059998,
    "dropphyadd": "612 VETERANS AIRPARK LN",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797059998,
    "dropmaladd": "612 VETERANS AIRPARK LN",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326870437,
    "dropsitcph": 4326875961,
    "dropfax": 4326845109
  },
  {
    "dcode": "D",
    "dropkey": "SW23303",
    "droptype": "D",
    "dropname": "COLONIAL",
    "dropdeladd": "2400 COLONIAL AVE",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767079998,
    "dropphyadd": "2400 COLONIAL AVE",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767079998,
    "dropmaladd": "2400 COLONIAL AVE",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547533458,
    "dropsitcph": 2547141234,
    "dropfax": 2547537806
  },
  {
    "dcode": "D",
    "dropkey": "SW23333",
    "droptype": "D",
    "dropname": "COPPER MOUNTAIN",
    "dropdeladd": "3100 S W S YOUNG DR",
    "dropdelcty": "KILLEEN",
    "dropdelst": "TX",
    "dropdelzpp": 765429998,
    "dropphyadd": "3100 S W S YOUNG DR",
    "dropphycty": "KILLEEN",
    "dropphyst": "TX",
    "dropphyzpp": 765429998,
    "dropmaladd": "3100 S W S YOUNG DR",
    "dropmalcty": "KILLEEN",
    "dropmalst": "TX",
    "dropmalzpp": 765429998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545543033,
    "dropsitcph": 2545543033,
    "dropfax": 2546285489
  },
  {
    "dcode": "D",
    "dropkey": "SW23340",
    "droptype": "D",
    "dropname": "CORNERSTONE",
    "dropdeladd": "14403 WALTERS RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770149998,
    "dropphyadd": "14403 WALTERS RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770149998,
    "dropmaladd": "14403 WALTERS RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770149998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814441451,
    "dropsitcph": 2814443874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23342",
    "droptype": "D",
    "dropname": "CORONADO",
    "dropdeladd": "7383 REMCON CIR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799129998,
    "dropphyadd": "7383 REMCON CIR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799129998,
    "dropmaladd": "7383 REMCON CIR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155847110,
    "dropsitcph": 9155857601,
    "dropfax": 9158335622
  },
  {
    "dcode": "D",
    "dropkey": "SW23406",
    "droptype": "D",
    "dropname": "COIT",
    "dropdeladd": "3400 COIT RD",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750759998,
    "dropphyadd": "3400 COIT RD",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750759998,
    "dropmaladd": "3400 COIT RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750759998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9725999631,
    "dropsitcph": 9725999631,
    "dropfax": 9725992267
  },
  {
    "dcode": "D",
    "dropkey": "SW23451",
    "droptype": "D",
    "dropname": "DE MOSS",
    "dropdeladd": "6500 DE MOSS DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770749998,
    "dropphyadd": "6500 DE MOSS DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770749998,
    "dropmaladd": "6500 DE MOSS DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770749998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139951931,
    "dropsitcph": 7139951441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23454",
    "droptype": "D",
    "dropname": "DEBORA SUE SCHATZ",
    "dropdeladd": "2909 ROGERDALE RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770429998,
    "dropphyadd": "2909 ROGERDALE RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770429998,
    "dropmaladd": "2909 ROGERDALE RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770429998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137854978,
    "dropsitcph": 7137856478,
    "dropfax": 7137833909
  },
  {
    "dcode": "D",
    "dropkey": "SW23460",
    "droptype": "D",
    "dropname": "DELBERT L ATKINSON",
    "dropdeladd": "6100 SPENCER HWY",
    "dropdelcty": "PASADENA",
    "dropdelst": "TX",
    "dropdelzpp": 775059998,
    "dropphyadd": "6100 SPENCER HWY",
    "dropphycty": "PASADENA",
    "dropphyst": "TX",
    "dropphyzpp": 775059998,
    "dropmaladd": "6100 SPENCER HWY",
    "dropmalcty": "PASADENA",
    "dropmalst": "TX",
    "dropmalzpp": 775059998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814870159,
    "dropsitcph": 2819916984,
    "dropfax": 2814874133
  },
  {
    "dcode": "D",
    "dropkey": "SW23472",
    "droptype": "D",
    "dropname": "DENVER HARBOR",
    "dropdeladd": "5901 MARKET ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770209998,
    "dropphyadd": "5901 MARKET ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770209998,
    "dropmaladd": "5901 MARKET ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770209998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136760608,
    "dropsitcph": 7136762401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23526",
    "droptype": "D",
    "dropname": "DOWNTOWN AMARILLO",
    "dropdeladd": "505 E 9TH AVE",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791059998,
    "dropphyadd": "505 E 9TH AVE",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791059998,
    "dropmaladd": "505 E 9TH AVE",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791059998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064681605,
    "dropsitcph": 8064681605,
    "dropfax": 8063746519
  },
  {
    "dcode": "D",
    "dropkey": "SW23527",
    "droptype": "D",
    "dropname": "DOWNTOWN AUSTIN",
    "dropdeladd": "823 CONGRESS AVE STE 150",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787019998,
    "dropphyadd": "823 CONGRESS AVE STE 150",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787019998,
    "dropmaladd": "823 CONGRESS AVE STE 150",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124738323,
    "dropsitcph": 5124738334,
    "dropfax": 5127081048
  },
  {
    "dcode": "D",
    "dropkey": "SW23528",
    "droptype": "D",
    "dropname": "DOWNTOWN BEAUMONT",
    "dropdeladd": "300 WILLOW ST STE 1",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777012296,
    "dropphyadd": "300 WILLOW ST STE 1",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777012296,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777049998,
    "dropsitphn": 4098328205,
    "dropsitlph": 4098328205,
    "dropsitcph": 4098328205,
    "dropfax": 4098328607
  },
  {
    "dcode": "D",
    "dropkey": "SW23529",
    "droptype": "D",
    "dropname": "DOWNTOWN BROWNSVILLE",
    "dropdeladd": "1001 E ELIZABETH ST FL 1",
    "dropdelcty": "BROWNSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 785209995,
    "dropphyadd": "1001 E ELIZABETH ST FL 1",
    "dropphycty": "BROWNSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 785209995,
    "dropmaladd": "1001 E ELIZABETH ST FL 1",
    "dropmalcty": "BROWNSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 785209995,
    "dropsitphn": 2103688387,
    "dropsitlph": 9565426898,
    "dropsitcph": 9565426898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23530",
    "droptype": "D",
    "dropname": "DOWNTOWN BRYAN",
    "dropdeladd": "210 W WM J BRYAN PKWY",
    "dropdelcty": "BRYAN",
    "dropdelst": "TX",
    "dropdelzpp": 778039998,
    "dropphyadd": "210 W WM J BRYAN PKWY",
    "dropphycty": "BRYAN",
    "dropphyst": "TX",
    "dropphyzpp": 778039998,
    "dropmaladd": "210 W WM J BRYAN PKWY",
    "dropmalcty": "BRYAN",
    "dropmalst": "TX",
    "dropmalzpp": 778039998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9797791988,
    "dropsitcph": 9797791988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23531",
    "droptype": "D",
    "dropname": "DOWNTOWN CORPUS CHRISTI",
    "dropdeladd": "802 N TANCAHUA ST",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784019998,
    "dropphyadd": "802 N TANCAHUA ST",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784019998,
    "dropmaladd": "802 N TANCAHUA ST",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618838628,
    "dropsitcph": 3618838724,
    "dropfax": 3618878616
  },
  {
    "dcode": "D",
    "dropkey": "SW23532",
    "droptype": "D",
    "dropname": "DOWNTOWN DALLAS",
    "dropdeladd": "400 N ERVAY ST",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752019998,
    "dropphyadd": "400 N ERVAY ST",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752019998,
    "dropmaladd": "400 N ERVAY ST",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752019998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2144688270,
    "dropsitcph": 2144688270,
    "dropfax": 2144688149
  },
  {
    "dcode": "D",
    "dropkey": "SW23533",
    "droptype": "D",
    "dropname": "DOWNTOWN EL PASO",
    "dropdeladd": "219 E MILLS AVE",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799019998,
    "dropphyadd": "219 E MILLS AVE",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799019998,
    "dropmaladd": "219 E MILLS AVE",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155323147,
    "dropsitcph": 9155323147,
    "dropfax": 9155340270
  },
  {
    "dcode": "D",
    "dropkey": "SW23534",
    "droptype": "D",
    "dropname": "DOWNTOWN FORT WORTH",
    "dropdeladd": "251 W LANCASTER AVE",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761029997,
    "dropphyadd": "251 W LANCASTER AVE",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761029997,
    "dropmaladd": "251 W LANCASTER AVE",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761029997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178708104,
    "dropsitcph": 8178708128,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23535",
    "droptype": "D",
    "dropname": "DOWNTOWN FREEPORT",
    "dropdeladd": "111 E 4TH ST",
    "dropdelcty": "FREEPORT",
    "dropdelst": "TX",
    "dropdelzpp": 775415999,
    "dropphyadd": "111 E 4TH ST",
    "dropphycty": "FREEPORT",
    "dropphyst": "TX",
    "dropphyzpp": 775415999,
    "dropmaladd": "111 E 4TH ST",
    "dropmalcty": "FREEPORT",
    "dropmalst": "TX",
    "dropmalzpp": 775415999,
    "dropsitphn": 7132263055,
    "dropsitlph": 4092333215,
    "dropsitcph": 4092333215,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23537",
    "droptype": "D",
    "dropname": "DOWNTOWN HARLINGEN",
    "dropdeladd": "221 E VAN BUREN AVE STE 3",
    "dropdelcty": "HARLINGEN",
    "dropdelst": "TX",
    "dropdelzpp": 785506898,
    "dropphyadd": "221 E VAN BUREN AVE STE 3",
    "dropphycty": "HARLINGEN",
    "dropphyst": "TX",
    "dropphyzpp": 785506898,
    "dropmaladd": "1502 NEW COMBES HWY",
    "dropmalcty": "HARLINGEN",
    "dropmalst": "TX",
    "dropmalzpp": 785509998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9564231430,
    "dropsitcph": 9564231430,
    "dropfax": 9564231117
  },
  {
    "dcode": "D",
    "dropkey": "SW23539",
    "droptype": "D",
    "dropname": "DOWNTOWN LONGVIEW",
    "dropdeladd": "201 E METHVIN ST",
    "dropdelcty": "LONGVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 756019998,
    "dropphyadd": "201 E METHVIN ST",
    "dropphycty": "LONGVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 756019998,
    "dropmaladd": "201 E METHVIN ST",
    "dropmalcty": "LONGVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 756019998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9037533683,
    "dropsitcph": 9037533683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23540",
    "droptype": "D",
    "dropname": "DOWNTOWN LUBBOCK",
    "dropdeladd": "411 AVENUE L",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794081899,
    "dropphyadd": "411 AVENUE L",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794081899,
    "dropmaladd": "411 AVENUE L",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794081899,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067443806,
    "dropsitcph": 8067443806,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "SW23542",
    "droptype": "D",
    "dropname": "DOWNTOWN MCALLEN",
    "dropdeladd": "406 S 12TH ST",
    "dropdelcty": "MCALLEN",
    "dropdelst": "TX",
    "dropdelzpp": 785014977,
    "dropphyadd": "406 S 12TH ST",
    "dropphycty": "MCALLEN",
    "dropphyst": "TX",
    "dropphyzpp": 785014977,
    "dropmaladd": "406 S 12TH ST",
    "dropmalcty": "MCALLEN",
    "dropmalst": "TX",
    "dropmalzpp": 785014977,
    "dropsitphn": 2103688387,
    "dropsitlph": 9569711716,
    "dropsitcph": 9569711716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23543",
    "droptype": "D",
    "dropname": "DOWNTOWN MIDLAND",
    "dropdeladd": "100 E WALL ST",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797019998,
    "dropphyadd": "100 E WALL ST",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797019998,
    "dropmaladd": "100 E WALL ST",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797019998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326840812,
    "dropsitcph": 4326823381,
    "dropfax": 4326833844
  },
  {
    "dcode": "D",
    "dropkey": "SW23544",
    "droptype": "D",
    "dropname": "DOWNTOWN PLANO",
    "dropdeladd": "1112 18TH ST",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750749997,
    "dropphyadd": "1112 18TH ST",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750749997,
    "dropmaladd": "1200 JUPITER RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750749998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9726339434,
    "dropsitcph": 9726339434,
    "dropfax": 9728815322
  },
  {
    "dcode": "D",
    "dropkey": "SW23545",
    "droptype": "D",
    "dropname": "DOWNTOWN SAN ANTONIO",
    "dropdeladd": "615 E HOUSTON ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782059998,
    "dropphyadd": "615 E HOUSTON ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782059998,
    "dropmaladd": "615 E HOUSTON ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2102128087,
    "dropsitcph": 2102128046,
    "dropfax": 2102278600
  },
  {
    "dcode": "D",
    "dropkey": "SW23546",
    "droptype": "D",
    "dropname": "DOWNTOWN TEXARKANA",
    "dropdeladd": "500 N STATE LINE AVE STE 101",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "AR",
    "dropdelzpp": 718545999,
    "dropphyadd": "500 N STATE LINE AVE STE 101",
    "dropphycty": "TEXARKANA",
    "dropphyst": "AR",
    "dropphyzpp": 718545999,
    "dropmaladd": "500 N STATE LINE AVE STE 101",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "AR",
    "dropmalzpp": 718545999,
    "dropsitphn": 2149482879,
    "dropsitlph": 9037923794,
    "dropsitcph": 9037923794,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23548",
    "droptype": "D",
    "dropname": "DOWNTOWN WACO",
    "dropdeladd": "424 CLAY AVE",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767069998,
    "dropphyadd": "424 CLAY AVE",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767069998,
    "dropmaladd": "424 CLAY AVE",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767069998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547544182,
    "dropsitcph": 2547544189,
    "dropfax": 2547544065
  },
  {
    "dcode": "D",
    "dropkey": "SW23575",
    "droptype": "D",
    "dropname": "EAST ARLINGTON",
    "dropdeladd": "1828 E PARK ROW DR STE B",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760109997,
    "dropphyadd": "1828 E PARK ROW DR STE B",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760109997,
    "dropmaladd": "1828 E PARK ROW DR STE B",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760109997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175438412,
    "dropsitcph": 8175438413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23576",
    "droptype": "D",
    "dropname": "EAST AUSTIN",
    "dropdeladd": "1914 E 6TH ST",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787029998,
    "dropphyadd": "1914 E 6TH ST",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787029998,
    "dropmaladd": "1914 E 6TH ST",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124940506,
    "dropsitcph": 5124941721,
    "dropfax": 5127081317
  },
  {
    "dcode": "D",
    "dropkey": "SW23585",
    "droptype": "D",
    "dropname": "EAST TEXAS",
    "dropdeladd": "2600 W NEAL ST",
    "dropdelcty": "COMMERCE",
    "dropdelst": "TX",
    "dropdelzpp": 754284311,
    "dropphyadd": "2600 W NEAL ST",
    "dropphycty": "COMMERCE",
    "dropphyst": "TX",
    "dropphyzpp": 754284311,
    "dropmaladd": "1300 PARK ST",
    "dropmalcty": "COMMERCE",
    "dropmalst": "TX",
    "dropmalzpp": 754289998,
    "dropsitphn": 2149482879,
    "dropsitlph": 9038863986,
    "dropsitcph": 9038863986,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23592",
    "droptype": "D",
    "dropname": "EASTWOOD",
    "dropdeladd": "5415 LAWNDALE ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770239998,
    "dropphyadd": "5415 LAWNDALE ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770239998,
    "dropmaladd": "5415 LAWNDALE ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770239998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139214797,
    "dropsitcph": 7139214772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23616",
    "droptype": "D",
    "dropname": "EL CENTRO",
    "dropdeladd": "1300 MATAMOROS ST",
    "dropdelcty": "LAREDO",
    "dropdelst": "TX",
    "dropdelzpp": 780409998,
    "dropphyadd": "1300 MATAMOROS ST",
    "dropphycty": "LAREDO",
    "dropphyst": "TX",
    "dropphyzpp": 780409998,
    "dropmaladd": "1300 MATAMOROS ST",
    "dropmalcty": "LAREDO",
    "dropmalst": "TX",
    "dropmalzpp": 780409998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567233643,
    "dropsitcph": 9567233643,
    "dropfax": 9567915948
  },
  {
    "dcode": "D",
    "dropkey": "SW23696",
    "droptype": "D",
    "dropname": "FAIRBANKS",
    "dropdeladd": "7050 BROOKHOLLOW WEST DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770409998,
    "dropphyadd": "7050 BROOKHOLLOW WEST DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770409998,
    "dropmaladd": "7050 BROOKHOLLOW WEST DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770409998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139839682,
    "dropsitcph": 7139379108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23743",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "3011 E YANDELL DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799034133,
    "dropphyadd": "3011 E YANDELL DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799034133,
    "dropmaladd": "3011 E YANDELL DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799034133,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155323147,
    "dropsitcph": 9155323147,
    "dropfax": 9155660023
  },
  {
    "dcode": "D",
    "dropkey": "SW23756",
    "droptype": "D",
    "dropname": "FLOUR BLUFF",
    "dropdeladd": "10139 SECURITY DR",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784189998,
    "dropphyadd": "10139 SECURITY DR",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784189998,
    "dropmaladd": "10139 SECURITY DR",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784189998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619379912,
    "dropsitcph": 3619379912,
    "dropfax": 3619373605
  },
  {
    "dcode": "D",
    "dropkey": "SW23797",
    "droptype": "D",
    "dropname": "FOSTER PLACE",
    "dropdeladd": "5210 GRIGGS RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770219998,
    "dropphyadd": "5210 GRIGGS RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770219998,
    "dropmaladd": "5210 GRIGGS RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770219998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136438673,
    "dropsitcph": 7136438650,
    "dropfax": 7136438874
  },
  {
    "dcode": "D",
    "dropkey": "SW23798",
    "droptype": "D",
    "dropname": "FOUNTAIN",
    "dropdeladd": "505 FOUNTAIN PKWY",
    "dropdelcty": "GRAND PRAIRIE",
    "dropdelst": "TX",
    "dropdelzpp": 750509998,
    "dropphyadd": "505 FOUNTAIN PKWY",
    "dropphycty": "GRAND PRAIRIE",
    "dropphyst": "TX",
    "dropphyzpp": 750509998,
    "dropmaladd": "505 FOUNTAIN PKWY",
    "dropmalcty": "GRAND PRAIRIE",
    "dropmalst": "TX",
    "dropmalzpp": 750509998,
    "dropsitphn": 2144675879,
    "dropsitlph": 8176337034,
    "dropsitcph": 8176337034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23812",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "5001 AVENUE L",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794529998,
    "dropphyadd": "5001 AVENUE L",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794529998,
    "dropmaladd": "5001 AVENUE L",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794529998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067477098,
    "dropsitcph": 8067477098,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "SW23849",
    "droptype": "D",
    "dropname": "GALLERIA",
    "dropdeladd": "5015 WESTHEIMER RD STE 1200",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770569903,
    "dropphyadd": "5015 WESTHEIMER RD STE 1200",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770569903,
    "dropmaladd": "PO BOX 461998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770561909,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136279035,
    "dropsitcph": 7136270764,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23858",
    "droptype": "D",
    "dropname": "GARDEN OAKS",
    "dropdeladd": "3816 N SHEPHERD DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770189997,
    "dropphyadd": "3816 N SHEPHERD DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770189997,
    "dropmaladd": "PO BOX 92998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772069998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136949866,
    "dropsitcph": 7136949836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23876",
    "droptype": "D",
    "dropname": "GMF AUSTIN",
    "dropdeladd": "8225 CROSS PARK DR",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787109765,
    "dropphyadd": "8225 CROSS PARK DR",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787109765,
    "dropmaladd": "8225 CROSS PARK DR",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787109765,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123421286,
    "dropsitcph": 5123421259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23877",
    "droptype": "D",
    "dropname": "GMF MIDLAND",
    "dropdeladd": "10000 LOOP 40",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797119998,
    "dropphyadd": "10000 LOOP 40",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797119998,
    "dropmaladd": "10000 LOOP 40",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4325605105,
    "dropsitcph": 4325605105,
    "dropfax": 4325605096
  },
  {
    "dcode": "D",
    "dropkey": "SW23878",
    "droptype": "D",
    "dropname": "GMF SAN ANTONIO",
    "dropdeladd": "10410 PERRIN BEITEL RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782849765,
    "dropphyadd": "10410 PERRIN BEITEL RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782849765,
    "dropmaladd": "10410 PERRIN BEITEL RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782849765,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688387,
    "dropsitcph": 2103681712,
    "dropfax": 2103681698
  },
  {
    "dcode": "D",
    "dropkey": "SW23881",
    "droptype": "D",
    "dropname": "GENOA",
    "dropdeladd": "10935 ALMEDA GENOA RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770349998,
    "dropphyadd": "10935 ALMEDA GENOA RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770349998,
    "dropmaladd": "10935 ALMEDA GENOA RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770349998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139470697,
    "dropsitcph": 7139470697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23903",
    "droptype": "D",
    "dropname": "GLENCREST",
    "dropdeladd": "5125 WICHITA ST",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761199998,
    "dropphyadd": "5125 WICHITA ST",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761199998,
    "dropmaladd": "5125 WICHITA ST",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761199998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175344590,
    "dropsitcph": 8175344203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23913",
    "droptype": "D",
    "dropname": "GOLDEN TRIANGLE",
    "dropdeladd": "2101 COLORADO BLVD",
    "dropdelcty": "DENTON",
    "dropdelst": "TX",
    "dropdelzpp": 762057521,
    "dropphyadd": "2101 COLORADO BLVD",
    "dropphycty": "DENTON",
    "dropphyst": "TX",
    "dropphyzpp": 762057521,
    "dropmaladd": "2101 COLORADO BLVD",
    "dropmalcty": "DENTON",
    "dropmalst": "TX",
    "dropmalzpp": 762057521,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403878555,
    "dropsitcph": 9403878555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23950",
    "droptype": "D",
    "dropname": "GRANVILLE W ELDER",
    "dropdeladd": "550 MAXEY RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770139998,
    "dropphyadd": "550 MAXEY RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770139998,
    "dropmaladd": "550 MAXEY RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770139998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7134536573,
    "dropsitcph": 7134534158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23953",
    "droptype": "D",
    "dropname": "GRAVES",
    "dropdeladd": "3304 W WADLEY AVE",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797079998,
    "dropphyadd": "3304 W WADLEY AVE",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797079998,
    "dropmaladd": "3304 W WADLEY AVE",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326949547,
    "dropsitcph": 4325605105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23958",
    "droptype": "D",
    "dropname": "GREENBRIAR",
    "dropdeladd": "3740 GREENBRIAR DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770989998,
    "dropphyadd": "3740 GREENBRIAR DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770989998,
    "dropmaladd": "3740 GREENBRIAR DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770989998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7135281549,
    "dropsitcph": 7135285875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23960",
    "droptype": "D",
    "dropname": "GREENS NORTH",
    "dropdeladd": "1530 GREENSMARK DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770679998,
    "dropphyadd": "1530 GREENSMARK DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770679998,
    "dropmaladd": "1530 GREENSMARK DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770679998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2818756824,
    "dropsitcph": 2818756452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23963",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "5650 BELMONT AVE",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752069991,
    "dropphyadd": "5650 BELMONT AVE",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752069991,
    "dropmaladd": "5650 BELMONT AVE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752069991,
    "dropsitphn": 2147604376,
    "dropsitlph": 2148270614,
    "dropsitcph": 2147391245,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW23965",
    "droptype": "D",
    "dropname": "GREENWAY PLAZA",
    "dropdeladd": "3 GREENWAY PLZ",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770469998,
    "dropphyadd": "3 GREENWAY PLZ",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770469998,
    "dropmaladd": "2802 TIMMONS LN",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770279998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7135723675,
    "dropsitcph": 7135723936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW23991",
    "droptype": "D",
    "dropname": "GULFWAY",
    "dropdeladd": "1345 CRESCENT DR",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784129998,
    "dropphyadd": "1345 CRESCENT DR",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784129998,
    "dropmaladd": "1345 CRESCENT DR",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3619912433,
    "dropsitcph": 3619914860,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24001",
    "droptype": "D",
    "dropname": "HACKBERRY",
    "dropdeladd": "2000 S HACKBERRY ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782109998,
    "dropphyadd": "2000 S HACKBERRY ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782109998,
    "dropmaladd": "2000 S HACKBERRY ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105326324,
    "dropsitcph": 2105343861,
    "dropfax": 2105340088
  },
  {
    "dcode": "D",
    "dropkey": "SW24018",
    "droptype": "D",
    "dropname": "HANDLEY",
    "dropdeladd": "1475 HANDLEY DR",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761123371,
    "dropphyadd": "1475 HANDLEY DR",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761123371,
    "dropmaladd": "PO BOX 924998",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761249998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174468431,
    "dropsitcph": 8174468431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24031",
    "droptype": "D",
    "dropname": "HARLANDALE",
    "dropdeladd": "6302 S FLORES ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782149998,
    "dropphyadd": "6302 S FLORES ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782149998,
    "dropmaladd": "6302 S FLORES ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782149998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109322316,
    "dropsitcph": 2109322316,
    "dropfax": 2109777419
  },
  {
    "dcode": "D",
    "dropkey": "SW24036",
    "droptype": "D",
    "dropname": "HARRISBURG",
    "dropdeladd": "8330 MANCHESTER ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770122137,
    "dropphyadd": "8330 MANCHESTER ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770122137,
    "dropmaladd": "PO BOX 5998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772629998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139212463,
    "dropsitcph": 7139210747,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24062",
    "droptype": "D",
    "dropname": "HEIGHTS",
    "dropdeladd": "1050 YALE ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770089969,
    "dropphyadd": "1050 YALE ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770089969,
    "dropmaladd": "PO BOX 7320",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772489998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7138613915,
    "dropsitcph": 7138617483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24074",
    "droptype": "D",
    "dropname": "HERITAGE",
    "dropdeladd": "702 RICHLAND HILLS DR",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782459998,
    "dropphyadd": "702 RICHLAND HILLS DR",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782459998,
    "dropmaladd": "702 RICHLAND HILLS DR",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105431491,
    "dropsitcph": 2105438237,
    "dropfax": 2102567036
  },
  {
    "dcode": "D",
    "dropkey": "SW24089",
    "droptype": "D",
    "dropname": "HIGHLAND HILLS DALLAS",
    "dropdeladd": "3655 SIMPSON STUART RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752419998,
    "dropphyadd": "3655 SIMPSON STUART RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752419998,
    "dropmaladd": "3655 SIMPSON STUART RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752419998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143767549,
    "dropsitcph": 2143767549,
    "dropfax": 2143760630
  },
  {
    "dcode": "D",
    "dropkey": "SW24090",
    "droptype": "D",
    "dropname": "HIGHLAND HILLS SAN ANTONIO",
    "dropdeladd": "3918 CLARK AVE",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782239998,
    "dropphyadd": "3918 CLARK AVE",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782239998,
    "dropmaladd": "3918 CLARK AVE",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782239998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105321962,
    "dropsitcph": 2105323803,
    "dropfax": 2105332343
  },
  {
    "dcode": "D",
    "dropkey": "SW24140",
    "droptype": "D",
    "dropname": "HUFFHINES PARK",
    "dropdeladd": "1206 APOLLO RD",
    "dropdelcty": "RICHARDSON",
    "dropdelst": "TX",
    "dropdelzpp": 750819998,
    "dropphyadd": "1206 APOLLO RD",
    "dropphycty": "RICHARDSON",
    "dropphyst": "TX",
    "dropphyzpp": 750819998,
    "dropmaladd": "1206 APOLLO RD",
    "dropmalcty": "RICHARDSON",
    "dropmalst": "TX",
    "dropmalzpp": 750819998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729180692,
    "dropsitcph": 9729180692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24209",
    "droptype": "D",
    "dropname": "J FRANK DOBIE",
    "dropdeladd": "4950 E HOUSTON ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782209998,
    "dropphyadd": "4950 E HOUSTON ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782209998,
    "dropmaladd": "4950 E HOUSTON ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782209998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106620933,
    "dropsitcph": 2106627302,
    "dropfax": 2106624857
  },
  {
    "dcode": "D",
    "dropkey": "SW24211",
    "droptype": "D",
    "dropname": "JACK D WATSON WINDOW UNIT",
    "dropdeladd": "4600 MARK IV PKWY",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761619804,
    "dropphyadd": "4600 MARK IV PKWY",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761619804,
    "dropmaladd": "4600 MARK IV PKWY",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761619804,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173852,
    "dropsitcph": 8173173701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24219",
    "droptype": "D",
    "dropname": "JAMES GRIFFITH",
    "dropdeladd": "9320 EMNORA LN",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770809998,
    "dropphyadd": "9320 EMNORA LN",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770809998,
    "dropmaladd": "9320 EMNORA LN",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770809998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139731786,
    "dropsitcph": 7139730769,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24220",
    "droptype": "D",
    "dropname": "JAMES MOODY",
    "dropdeladd": "2804 SAM HOUSTON DR",
    "dropdelcty": "VICTORIA",
    "dropdelst": "TX",
    "dropdelzpp": 779049998,
    "dropphyadd": "2804 SAM HOUSTON DR",
    "dropphycty": "VICTORIA",
    "dropphyst": "TX",
    "dropphyzpp": 779049998,
    "dropmaladd": "2804 SAM HOUSTON DR",
    "dropmalcty": "VICTORIA",
    "dropmalst": "TX",
    "dropmalzpp": 779049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3615752363,
    "dropsitcph": 3615755611,
    "dropfax": 3615751010
  },
  {
    "dcode": "D",
    "dropkey": "SW24230",
    "droptype": "D",
    "dropname": "JENSEN DRIVE",
    "dropdeladd": "3520 JENSEN DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770269998,
    "dropphyadd": "3520 JENSEN DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770269998,
    "dropmaladd": "3520 JENSEN DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770269998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132245782,
    "dropsitcph": 7132245780,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24238",
    "droptype": "D",
    "dropname": "JOE POOL",
    "dropdeladd": "5521 S HAMPTON RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752329998,
    "dropphyadd": "5521 S HAMPTON RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752329998,
    "dropmaladd": "5521 S HAMPTON RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752329998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2144671004,
    "dropsitcph": 2144670847,
    "dropfax": 2144672605
  },
  {
    "dcode": "D",
    "dropkey": "SW24239",
    "droptype": "D",
    "dropname": "JOHN DUNLOP",
    "dropdeladd": "8728 BEVERLYHILL ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770639998,
    "dropphyadd": "8728 BEVERLYHILL ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770639998,
    "dropmaladd": "8728 BEVERLYHILL ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770639998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139771312,
    "dropsitcph": 7139770412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24240",
    "droptype": "D",
    "dropname": "JOHN FOSTER",
    "dropdeladd": "1520 RICHEY ST",
    "dropdelcty": "PASADENA",
    "dropdelst": "TX",
    "dropdelzpp": 775029998,
    "dropphyadd": "1520 RICHEY ST",
    "dropphycty": "PASADENA",
    "dropphyst": "TX",
    "dropphyzpp": 775029998,
    "dropmaladd": "1520 RICHEY ST",
    "dropmalcty": "PASADENA",
    "dropmalst": "TX",
    "dropmalzpp": 775021846,
    "dropsitphn": 7134739864,
    "dropsitlph": 7134755170,
    "dropsitcph": 7134750205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24253",
    "droptype": "D",
    "dropname": "JORDAN",
    "dropdeladd": "8301 W AMARILLO BLVD",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791242153,
    "dropphyadd": "8301 W AMARILLO BLVD",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791242153,
    "dropmaladd": "8301 W AMARILLO BLVD",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791242153,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063524038,
    "dropsitcph": 8063524038,
    "dropfax": 8063529017
  },
  {
    "dcode": "D",
    "dropkey": "SW24259",
    "droptype": "D",
    "dropname": "JUANITA CRAFT",
    "dropdeladd": "3055 AL LIPSCOMB WAY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752159998,
    "dropphyadd": "3055 AL LIPSCOMB WAY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752159998,
    "dropmaladd": "3055 AL LIPSCOMB WAY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752159998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2144284053,
    "dropsitcph": 2144284053,
    "dropfax": 2145651864
  },
  {
    "dcode": "D",
    "dropkey": "SW24264",
    "droptype": "D",
    "dropname": "JULIUS MELCHER",
    "dropdeladd": "2802 TIMMONS LN",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770279998,
    "dropphyadd": "2802 TIMMONS LN",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770279998,
    "dropmaladd": "2802 TIMMONS LN",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770279998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139630770,
    "dropsitcph": 7135723936,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24289",
    "droptype": "D",
    "dropname": "KELTYS",
    "dropdeladd": "1908 N RAGUET",
    "dropdelcty": "LUFKIN",
    "dropdelst": "TX",
    "dropdelzpp": 759039901,
    "dropphyadd": "1908 N RAGUET",
    "dropphycty": "LUFKIN",
    "dropphyst": "TX",
    "dropphyzpp": 759039901,
    "dropmaladd": "800 S JOHN REDDITT DR",
    "dropmalcty": "LUFKIN",
    "dropmalst": "TX",
    "dropmalzpp": 759049998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366347749,
    "dropsitcph": 9366347749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24315",
    "droptype": "D",
    "dropname": "KINGSLEY",
    "dropdeladd": "3260 SATURN RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 750419998,
    "dropphyadd": "3260 SATURN RD",
    "dropphycty": "GARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 750419998,
    "dropmaladd": "3260 SATURN RD",
    "dropmalcty": "GARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 750419998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729269461,
    "dropsitcph": 9729269461,
    "dropfax": 9722713826
  },
  {
    "dcode": "D",
    "dropkey": "SW24384",
    "droptype": "D",
    "dropname": "LAKE HIGHLANDS",
    "dropdeladd": "10502 MARKISON RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752389998,
    "dropphyadd": "10502 MARKISON RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752389998,
    "dropmaladd": "10502 MARKISON RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752389998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2145030003,
    "dropsitcph": 2145030003,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW24408",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "6120 SWISS AVE",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752149998,
    "dropphyadd": "6120 SWISS AVE",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752149998,
    "dropmaladd": "6120 SWISS AVE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752149998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2148217519,
    "dropsitcph": 2148217519,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW24413",
    "droptype": "D",
    "dropname": "LAMAR PARK",
    "dropdeladd": "4801 EVERHART RD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784119998,
    "dropphyadd": "4801 EVERHART RD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784119998,
    "dropmaladd": "4801 EVERHART RD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784119998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618527928,
    "dropsitcph": 3618527948,
    "dropfax": 3618575729
  },
  {
    "dcode": "D",
    "dropkey": "SW24431",
    "droptype": "D",
    "dropname": "LAS COLINAS",
    "dropdeladd": "3900 TELEPORT BLVD",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750399998,
    "dropphyadd": "3900 TELEPORT BLVD",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750399998,
    "dropmaladd": "2300 STORY RD W",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750389998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9728311206,
    "dropsitcph": 9728311206,
    "dropfax": 9728311206
  },
  {
    "dcode": "D",
    "dropkey": "SW24440",
    "droptype": "D",
    "dropname": "LAUREL HEIGHTS",
    "dropdeladd": "2400 MCCULLOUGH AVE",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782129998,
    "dropphyadd": "2400 MCCULLOUGH AVE",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782129998,
    "dropmaladd": "2400 MCCULLOUGH AVE",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2107322418,
    "dropsitcph": 2107352723,
    "dropfax": 2107380829
  },
  {
    "dcode": "D",
    "dropkey": "SW24510",
    "droptype": "D",
    "dropname": "LOCKHILL",
    "dropdeladd": "12951 HUEBNER RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782309998,
    "dropphyadd": "12951 HUEBNER RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782309998,
    "dropmaladd": "12951 HUEBNER RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2104939533,
    "dropsitcph": 2104939257,
    "dropfax": 2104087429
  },
  {
    "dcode": "D",
    "dropkey": "SW24528",
    "droptype": "D",
    "dropname": "LONG POINT",
    "dropdeladd": "8000 LONG POINT RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770559998,
    "dropphyadd": "8000 LONG POINT RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770559998,
    "dropmaladd": "8000 LONG POINT RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770559998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7134683460,
    "dropsitcph": 7134688067,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24547",
    "droptype": "D",
    "dropname": "LOS JARDINES",
    "dropdeladd": "5555 SAN FERNANDO ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782379998,
    "dropphyadd": "5555 SAN FERNANDO ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782379998,
    "dropmaladd": "5555 SAN FERNANDO ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782379998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2104326923,
    "dropsitcph": 2104336740,
    "dropfax": 2104332679
  },
  {
    "dcode": "D",
    "dropkey": "SW24591",
    "droptype": "D",
    "dropname": "MAIN OFFICE AMARILLO",
    "dropdeladd": "2301 ROSS ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791209804,
    "dropphyadd": "2301 ROSS ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791209804,
    "dropmaladd": "2301 ROSS ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791209804,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064682101,
    "dropsitcph": 8064682101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24617",
    "droptype": "D",
    "dropname": "MARTIN LUTHER KING",
    "dropdeladd": "9444 CULLEN BLVD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770519998,
    "dropphyadd": "9444 CULLEN BLVD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770519998,
    "dropmaladd": "9444 CULLEN BLVD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770519998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137330768,
    "dropsitcph": 7137330752,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24679",
    "droptype": "D",
    "dropname": "MEDICAL CENTER",
    "dropdeladd": "7205 ALMEDA RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770549998,
    "dropphyadd": "7205 ALMEDA RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770549998,
    "dropmaladd": "7205 ALMEDA RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770549998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7138421491,
    "dropsitcph": 7138421489,
    "dropfax": 7137486014
  },
  {
    "dcode": "D",
    "dropkey": "SW24687",
    "droptype": "D",
    "dropname": "MELEAR",
    "dropdeladd": "3903 MELEAR DR",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760159998,
    "dropphyadd": "3903 MELEAR DR",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760159998,
    "dropmaladd": "3903 MELEAR DR",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760159998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174653899,
    "dropsitcph": 8174654879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24693",
    "droptype": "D",
    "dropname": "MEMORIAL PARK",
    "dropdeladd": "10505 TOWN AND COUNTRY WAY",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770249998,
    "dropphyadd": "10505 TOWN AND COUNTRY WAY",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770249998,
    "dropmaladd": "10505 TOWN AND COUNTRY WAY",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770249998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7134657110,
    "dropsitcph": 7134567109,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24709",
    "droptype": "D",
    "dropname": "MESKILL",
    "dropdeladd": "517 6TH ST N",
    "dropdelcty": "TEXAS CITY",
    "dropdelst": "TX",
    "dropdelzpp": 775907855,
    "dropphyadd": "517 6TH ST N",
    "dropphycty": "TEXAS CITY",
    "dropphyst": "TX",
    "dropphyzpp": 775907855,
    "dropmaladd": "517 6TH ST N",
    "dropmalcty": "TEXAS CITY",
    "dropmalst": "TX",
    "dropmalzpp": 775907855,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 4099482591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24756",
    "droptype": "D",
    "dropname": "HIGHLANDER",
    "dropdeladd": "4428 N 19TH ST",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767089998,
    "dropphyadd": "4428 N 19TH ST",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767089998,
    "dropmaladd": "4428 N 19TH ST",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767089998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547141291,
    "dropsitcph": 2547141234,
    "dropfax": 2547141235
  },
  {
    "dcode": "D",
    "dropkey": "SW24759",
    "droptype": "D",
    "dropname": "MOCKINGBIRD",
    "dropdeladd": "7310 MENCHACA RD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787459998,
    "dropphyadd": "7310 MENCHACA RD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787459998,
    "dropmaladd": "7310 MENCHACA RD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124161096,
    "dropsitcph": 5124161094,
    "dropfax": 5124438147
  },
  {
    "dcode": "D",
    "dropkey": "SW24774",
    "droptype": "D",
    "dropname": "MONTEREY",
    "dropdeladd": "5014 GARY AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794139998,
    "dropphyadd": "5014 GARY AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794139998,
    "dropmaladd": "5014 GARY AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794139998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067959508,
    "dropsitcph": 8067950836,
    "dropfax": 8067922553
  },
  {
    "dcode": "D",
    "dropkey": "SW24792",
    "droptype": "D",
    "dropname": "MORNINGSIDE",
    "dropdeladd": "3107 5TH ST",
    "dropdelcty": "WICHITA FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 763019992,
    "dropphyadd": "3107 5TH ST",
    "dropphycty": "WICHITA FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 763019992,
    "dropmaladd": "3107 5TH ST",
    "dropmalcty": "WICHITA FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 763019992,
    "dropsitphn": 8173173658,
    "dropsitlph": 9407638570,
    "dropsitcph": 9407638584,
    "dropfax": 9407661147
  },
  {
    "dcode": "D",
    "dropkey": "SW24843",
    "droptype": "D",
    "dropname": "NASSAU BAY",
    "dropdeladd": "18214 UPPER BAY RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770589998,
    "dropphyadd": "18214 UPPER BAY RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770589998,
    "dropmaladd": "18214 UPPER BAY RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770589998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813332739,
    "dropsitcph": 2813359357,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24927",
    "droptype": "D",
    "dropname": "NORTH GARLAND",
    "dropdeladd": "2346 BELT LINE RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 750449998,
    "dropphyadd": "2346 BELT LINE RD",
    "dropphycty": "GARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 750449998,
    "dropmaladd": "2346 BELT LINE RD",
    "dropmalcty": "GARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 750449998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724140305,
    "dropsitcph": 9724140305,
    "dropfax": 9725302510
  },
  {
    "dcode": "D",
    "dropkey": "SW24928",
    "droptype": "D",
    "dropname": "NORTH AMARILLO",
    "dropdeladd": "841 MARTIN RD",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791179998,
    "dropphyadd": "841 MARTIN RD",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791179998,
    "dropmaladd": "841 MARTIN RD",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791179998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063746616,
    "dropsitcph": 8063746616,
    "dropfax": 8063734745
  },
  {
    "dcode": "D",
    "dropkey": "SW24929",
    "droptype": "D",
    "dropname": "NORTH AUSTIN",
    "dropdeladd": "4300 SPEEDWAY",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787059998,
    "dropphyadd": "4300 SPEEDWAY",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787059998,
    "dropmaladd": "4300 SPEEDWAY",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124526467,
    "dropsitcph": 5124532785,
    "dropfax": 5124191236
  },
  {
    "dcode": "D",
    "dropkey": "SW24931",
    "droptype": "D",
    "dropname": "NORTH BROADWAY",
    "dropdeladd": "9211 BROADWAY",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782179998,
    "dropphyadd": "9211 BROADWAY",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782179998,
    "dropmaladd": "9211 BROADWAY",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782179998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2108241258,
    "dropsitcph": 2108241237,
    "dropfax": 2108320609
  },
  {
    "dcode": "D",
    "dropkey": "SW24938",
    "droptype": "D",
    "dropname": "NORTH HURST",
    "dropdeladd": "777 CANNON DR",
    "dropdelcty": "HURST",
    "dropdelst": "TX",
    "dropdelzpp": 760543174,
    "dropphyadd": "777 CANNON DR",
    "dropphycty": "HURST",
    "dropphyst": "TX",
    "dropphyzpp": 760543174,
    "dropmaladd": "777 CANNON DR",
    "dropmalcty": "HURST",
    "dropmalst": "TX",
    "dropmalzpp": 760543174,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174285735,
    "dropsitcph": 8174851331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24939",
    "droptype": "D",
    "dropname": "NORTHLAKE FINANCE",
    "dropdeladd": "10233 E NORTHWEST HWY STE 333",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752389997,
    "dropphyadd": "10233 E NORTHWEST HWY STE 333",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752389997,
    "dropmaladd": "10233 E NORTHWEST HWY STE 333",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752389997,
    "dropsitphn": 2144675879,
    "dropsitlph": 2143418236,
    "dropsitcph": 2145030003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24943",
    "droptype": "D",
    "dropname": "NORTH PORT ARTHUR",
    "dropdeladd": "3737 13TH ST",
    "dropdelcty": "PORT ARTHUR",
    "dropdelst": "TX",
    "dropdelzpp": 776429998,
    "dropphyadd": "3737 13TH ST",
    "dropphycty": "PORT ARTHUR",
    "dropphyst": "TX",
    "dropphyzpp": 776429998,
    "dropmaladd": "3737 13TH ST",
    "dropmalcty": "PORT ARTHUR",
    "dropmalst": "TX",
    "dropmalzpp": 776429998,
    "dropsitphn": 7132263055,
    "dropsitlph": 4099835483,
    "dropsitcph": 4099833423,
    "dropfax": 4099828777
  },
  {
    "dcode": "D",
    "dropkey": "SW24946",
    "droptype": "D",
    "dropname": "NORTH SHEPHERD",
    "dropdeladd": "7511 N SHEPHERD DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770889998,
    "dropphyadd": "7511 N SHEPHERD DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770889998,
    "dropmaladd": "7511 N SHEPHERD DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770889998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814475917,
    "dropsitcph": 2814478258,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24951",
    "droptype": "D",
    "dropname": "NORTHAVEN",
    "dropdeladd": "2736 ROYAL LN",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752299998,
    "dropphyadd": "2736 ROYAL LN",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752299998,
    "dropmaladd": "2736 ROYAL LN",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752299998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9722437881,
    "dropsitcph": 9722437881,
    "dropfax": 9724842851
  },
  {
    "dcode": "D",
    "dropkey": "SW24953",
    "droptype": "D",
    "dropname": "NORTHEAST AUSTIN",
    "dropdeladd": "900 BLACKSON AVE",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787529998,
    "dropphyadd": "900 BLACKSON AVE",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787529998,
    "dropmaladd": "900 BLACKSON AVE",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787529998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124197504,
    "dropsitcph": 5124197504,
    "dropfax": 5124191238
  },
  {
    "dcode": "D",
    "dropkey": "SW24954",
    "droptype": "D",
    "dropname": "NORTHEAST ODESSA",
    "dropdeladd": "4551 E 52ND ST",
    "dropdelcty": "ODESSA",
    "dropdelst": "TX",
    "dropdelzpp": 797629998,
    "dropphyadd": "4551 E 52ND ST",
    "dropphycty": "ODESSA",
    "dropphyst": "TX",
    "dropphyzpp": 797629998,
    "dropmaladd": "4551 E 52ND ST",
    "dropmalcty": "ODESSA",
    "dropmalst": "TX",
    "dropmalzpp": 797629998,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323620945,
    "dropsitcph": 4323623598,
    "dropfax": 4323660877
  },
  {
    "dcode": "D",
    "dropkey": "SW24957",
    "droptype": "D",
    "dropname": "NORTHGATE COLLEGE STATION",
    "dropdeladd": "104 N HOUSTON ST",
    "dropdelcty": "COLLEGE STATION",
    "dropdelst": "TX",
    "dropdelzpp": 778419800,
    "dropphyadd": "104 N HOUSTON ST",
    "dropphycty": "COLLEGE STATION",
    "dropphyst": "TX",
    "dropphyzpp": 778419800,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "COLLEGE STATION",
    "dropmalst": "TX",
    "dropmalzpp": 778419998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9798465716,
    "dropsitcph": 9798465716,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24958",
    "droptype": "D",
    "dropname": "NORTHGATE EL PASO",
    "dropdeladd": "5249 SANDERS AVE",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799249998,
    "dropphyadd": "5249 SANDERS AVE",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799249998,
    "dropmaladd": "5249 SANDERS AVE",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157553123,
    "dropsitcph": 9157553123,
    "dropfax": 9157556023
  },
  {
    "dcode": "D",
    "dropkey": "SW24961",
    "droptype": "D",
    "dropname": "NORTHWEST DALLAS",
    "dropdeladd": "2341 W NORTHWEST HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752209998,
    "dropphyadd": "2341 W NORTHWEST HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752209998,
    "dropmaladd": "2341 W NORTHWEST HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752209998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143570714,
    "dropsitcph": 2143570714,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW24962",
    "droptype": "D",
    "dropname": "NORTHWEST LONGVIEW",
    "dropdeladd": "4501 MCCANN RD",
    "dropdelcty": "LONGVIEW",
    "dropdelst": "TX",
    "dropdelzpp": 756059998,
    "dropphyadd": "4501 MCCANN RD",
    "dropphycty": "LONGVIEW",
    "dropphyst": "TX",
    "dropphyzpp": 756059998,
    "dropmaladd": "4501 MCCANN RD",
    "dropmalcty": "LONGVIEW",
    "dropmalst": "TX",
    "dropmalzpp": 756059998,
    "dropsitphn": 9033243018,
    "dropsitlph": 9036632500,
    "dropsitcph": 9036632500,
    "dropfax": 9036631989
  },
  {
    "dcode": "D",
    "dropkey": "SW24973",
    "droptype": "D",
    "dropname": "OAK FOREST",
    "dropdeladd": "2499 JUDIWAY ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770189998,
    "dropphyadd": "2499 JUDIWAY ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770189998,
    "dropmaladd": "2499 JUDIWAY ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770189998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136866517,
    "dropsitcph": 7136863544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW24977",
    "droptype": "D",
    "dropname": "OAK LAWN",
    "dropdeladd": "2825 OAK LAWN AVE",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752199998,
    "dropphyadd": "2825 OAK LAWN AVE",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752199998,
    "dropmaladd": "2825 OAK LAWN AVE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752199998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2145219531,
    "dropsitcph": 2145219531,
    "dropfax": 2142190786
  },
  {
    "dcode": "D",
    "dropkey": "SW24984",
    "droptype": "D",
    "dropname": "OAK HILL",
    "dropdeladd": "6104 OLD FREDERICKSBURG RD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787499998,
    "dropphyadd": "6104 OLD FREDERICKSBURG RD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787499998,
    "dropmaladd": "6104 OLD FREDERICKSBURG RD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787499998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128924871,
    "dropsitcph": 5128922794,
    "dropfax": 5128924783
  },
  {
    "dcode": "D",
    "dropkey": "SW24992",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "1009 OAKWOOD LN",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760124475,
    "dropphyadd": "1009 OAKWOOD LN",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760124475,
    "dropmaladd": "1009 OAKWOOD LN",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760124475,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178016860,
    "dropsitcph": 8178018553,
    "dropfax": 8172747620
  },
  {
    "dcode": "D",
    "dropkey": "SW25082",
    "droptype": "D",
    "dropname": "PANTEGO",
    "dropdeladd": "1114 S BOWEN RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760132299,
    "dropphyadd": "1114 S BOWEN RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760132299,
    "dropmaladd": "1114 S BOWEN RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760132299,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178016860,
    "dropsitcph": 8178018553,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25087",
    "droptype": "D",
    "dropname": "PARK PLACE",
    "dropdeladd": "5302 GALVESTON RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770179998,
    "dropphyadd": "5302 GALVESTON RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770179998,
    "dropmaladd": "5302 GALVESTON RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770179998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139102195,
    "dropsitcph": 7139101805,
    "dropfax": 7139417420
  },
  {
    "dcode": "D",
    "dropkey": "SW25089",
    "droptype": "D",
    "dropname": "PARKDALE",
    "dropdeladd": "7720 MILITARY PKWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752279998,
    "dropphyadd": "7720 MILITARY PKWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752279998,
    "dropmaladd": "7720 MILITARY PKWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752279998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143880810,
    "dropsitcph": 2143880810,
    "dropfax": 2143884552
  },
  {
    "dcode": "D",
    "dropkey": "SW25107",
    "droptype": "D",
    "dropname": "PEBBLE HILLS",
    "dropdeladd": "3100 N YARBROUGH DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799259998,
    "dropphyadd": "3100 N YARBROUGH DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799259998,
    "dropmaladd": "3100 N YARBROUGH DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799259998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155931396,
    "dropsitcph": 9155931396,
    "dropfax": 9155987937
  },
  {
    "dcode": "D",
    "dropkey": "SW25108",
    "droptype": "D",
    "dropname": "PECAN",
    "dropdeladd": "114 E BROADWAY ST",
    "dropdelcty": "DEL RIO",
    "dropdelst": "TX",
    "dropdelzpp": 788409997,
    "dropphyadd": "114 E BROADWAY ST",
    "dropphycty": "DEL RIO",
    "dropphyst": "TX",
    "dropphyzpp": 788409997,
    "dropmaladd": "114 E BROADWAY ST",
    "dropmalcty": "DEL RIO",
    "dropmalst": "TX",
    "dropmalzpp": 788409997,
    "dropsitphn": 2103688387,
    "dropsitlph": 8307753388,
    "dropsitcph": 8307753388,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25174",
    "droptype": "D",
    "dropname": "PLEASANT GROVE",
    "dropdeladd": "350 S BUCKNER BLVD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752179998,
    "dropphyadd": "350 S BUCKNER BLVD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752179998,
    "dropmaladd": "350 S BUCKNER BLVD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752179998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143910190,
    "dropsitcph": 2143910190,
    "dropfax": 2143914155
  },
  {
    "dcode": "D",
    "dropkey": "SW25194",
    "droptype": "D",
    "dropname": "POLYTECHNIC",
    "dropdeladd": "4650 E ROSEDALE ST",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761051800,
    "dropphyadd": "4650 E ROSEDALE ST",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761051800,
    "dropmaladd": "4650 E ROSEDALE ST",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761051800,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175354017,
    "dropsitcph": 8175356247,
    "dropfax": 8175351917
  },
  {
    "dcode": "D",
    "dropkey": "SW25214",
    "droptype": "D",
    "dropname": "PORTAIRS",
    "dropdeladd": "4213 S PORT AVE",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784159998,
    "dropphyadd": "4213 S PORT AVE",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784159998,
    "dropmaladd": "4213 S PORT AVE",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784159998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618551629,
    "dropsitcph": 3618556718,
    "dropfax": 3618553638
  },
  {
    "dcode": "D",
    "dropkey": "SW25245",
    "droptype": "D",
    "dropname": "PRESTON",
    "dropdeladd": "8604 TURTLE CREEK BLVD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752259998,
    "dropphyadd": "8604 TURTLE CREEK BLVD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752259998,
    "dropmaladd": "8604 TURTLE CREEK BLVD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752259998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143617251,
    "dropsitcph": 2143617251,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW25255",
    "droptype": "D",
    "dropname": "PROMENADE",
    "dropdeladd": "400 N COIT RD STE 1975",
    "dropdelcty": "RICHARDSON",
    "dropdelst": "TX",
    "dropdelzpp": 750809997,
    "dropphyadd": "400 N COIT RD STE 1975",
    "dropphycty": "RICHARDSON",
    "dropphyst": "TX",
    "dropphyzpp": 750809997,
    "dropmaladd": "433 BELLE GROVE DR",
    "dropmalcty": "RICHARDSON",
    "dropmalst": "TX",
    "dropmalzpp": 750805200,
    "dropsitphn": 9729482879,
    "dropsitlph": 9726901174,
    "dropsitcph": 9722354695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25298",
    "droptype": "D",
    "dropname": "RANCHLAND",
    "dropdeladd": "7314 GATEWAY BLVD E",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799159998,
    "dropphyadd": "7314 GATEWAY BLVD E",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799159998,
    "dropmaladd": "7314 GATEWAY BLVD E",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799159998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155940962,
    "dropsitcph": 9155940945,
    "dropfax": 9155914989
  },
  {
    "dcode": "D",
    "dropkey": "SW25359",
    "droptype": "D",
    "dropname": "RICH HILL",
    "dropdeladd": "2950 UNITY DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770579998,
    "dropphyadd": "2950 UNITY DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770579998,
    "dropmaladd": "2950 UNITY DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770579998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137819409,
    "dropsitcph": 7137819148,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25363",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "9130 MARKVILLE DR",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752439998,
    "dropphyadd": "9130 MARKVILLE DR",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752439998,
    "dropmaladd": "9130 MARKVILLE DR",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752439998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726908991,
    "dropsitcph": 9726908991,
    "dropfax": 9726901098
  },
  {
    "dcode": "D",
    "dropkey": "SW25370",
    "droptype": "D",
    "dropname": "RIDGLEA",
    "dropdeladd": "3020 CHERRY LN",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761163944,
    "dropphyadd": "3020 CHERRY LN",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761163944,
    "dropmaladd": "3020 CHERRY LN",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761163944,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172445863,
    "dropsitcph": 8172442372,
    "dropfax": 8172443276
  },
  {
    "dcode": "D",
    "dropkey": "SW25384",
    "droptype": "D",
    "dropname": "RIVERBEND",
    "dropdeladd": "2414 GRAVEL DR",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761186989,
    "dropphyadd": "2414 GRAVEL DR",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761186989,
    "dropmaladd": "6051 DAVIS BLVD",
    "dropmalcty": "NORTH RICHLAND HILLS",
    "dropmalst": "TX",
    "dropmalzpp": 761806385,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172844157,
    "dropsitcph": 8172815846,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25386",
    "droptype": "D",
    "dropname": "RIVER OAKS",
    "dropdeladd": "1900 W GRAY ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770199998,
    "dropphyadd": "1900 W GRAY ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770199998,
    "dropmaladd": "1900 W GRAY ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770199998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7135285368,
    "dropsitcph": 7135287671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25387",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "400 N RETTA ST",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761119998,
    "dropphyadd": "400 N RETTA ST",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761119998,
    "dropmaladd": "400 N RETTA ST",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761119998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8178380141,
    "dropsitcph": 8178380080,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25434",
    "droptype": "D",
    "dropname": "ROSEMEADE",
    "dropdeladd": "3755 N JOSEY LN",
    "dropdelcty": "CARROLLTON",
    "dropdelst": "TX",
    "dropdelzpp": 750079998,
    "dropphyadd": "3755 N JOSEY LN",
    "dropphycty": "CARROLLTON",
    "dropphyst": "TX",
    "dropphyzpp": 750079998,
    "dropmaladd": "3755 N JOSEY LN",
    "dropmalcty": "CARROLLTON",
    "dropmalst": "TX",
    "dropmalzpp": 750079998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9724920560,
    "dropsitcph": 9724920560,
    "dropfax": 9723949106
  },
  {
    "dcode": "D",
    "dropkey": "SW25454",
    "droptype": "D",
    "dropname": "ROY MILLER",
    "dropdeladd": "1340 S PORT AVE",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784059998,
    "dropphyadd": "1340 S PORT AVE",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784059998,
    "dropmaladd": "1340 S PORT AVE",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618839451,
    "dropsitcph": 3618839032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25455",
    "droptype": "D",
    "dropname": "ROY ROYALL",
    "dropdeladd": "4206 LITTLE YORK RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770169998,
    "dropphyadd": "4206 LITTLE YORK RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770169998,
    "dropmaladd": "4206 LITTLE YORK RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770169998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136952630,
    "dropsitcph": 7136952690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25456",
    "droptype": "D",
    "dropname": "ROBERT E PRICE",
    "dropdeladd": "8135 FOREST LN",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752309998,
    "dropphyadd": "8135 FOREST LN",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752309998,
    "dropmaladd": "8135 FOREST LN",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752309998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2145708422,
    "dropsitcph": 2145708422,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW25500",
    "droptype": "D",
    "dropname": "SAM HOUSTON",
    "dropdeladd": "701 SAN JACINTO ST STE 149",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770023629,
    "dropphyadd": "701 SAN JACINTO ST STE 149",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770023629,
    "dropmaladd": "701 SAN JACINTO ST STE 149",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770023629,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132234409,
    "dropsitcph": 7132234402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25514",
    "droptype": "D",
    "dropname": "SAN JACINTO",
    "dropdeladd": "307 S WESTERN ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791169998,
    "dropphyadd": "307 S WESTERN ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791169998,
    "dropmaladd": "307 S WESTERN ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791169998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8063597001,
    "dropsitcph": 8063597001,
    "dropfax": 8063540589
  },
  {
    "dcode": "D",
    "dropkey": "SW25593",
    "droptype": "D",
    "dropname": "SEMINARY HILL",
    "dropdeladd": "1001 ALTAMESA BLVD",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761343411,
    "dropphyadd": "1001 ALTAMESA BLVD",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761343411,
    "dropmaladd": "1001 ALTAMESA BLVD",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761343411,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175516169,
    "dropsitcph": 8175515809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25651",
    "droptype": "D",
    "dropname": "SINGER",
    "dropdeladd": "4901 S LOOP 289",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794649998,
    "dropphyadd": "4901 S LOOP 289",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794649998,
    "dropmaladd": "4901 S LOOP 289",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794649998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8066980837,
    "dropsitcph": 8066980666,
    "dropfax": 8067627891
  },
  {
    "dcode": "D",
    "dropkey": "SW25655",
    "droptype": "D",
    "dropname": "SIX POINTS",
    "dropdeladd": "902 AYERS ST",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784049998,
    "dropphyadd": "902 AYERS ST",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784049998,
    "dropmaladd": "902 AYERS ST",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618823984,
    "dropsitcph": 3618828973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25684",
    "droptype": "D",
    "dropname": "SOUTH GARLAND",
    "dropdeladd": "501 E OATES RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 750439998,
    "dropphyadd": "501 E OATES RD",
    "dropphycty": "GARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 750439998,
    "dropmaladd": "501 E OATES RD",
    "dropmalcty": "GARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 750439998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723032428,
    "dropsitcph": 9723032428,
    "dropfax": 9722405261
  },
  {
    "dcode": "D",
    "dropkey": "SW25685",
    "droptype": "D",
    "dropname": "LONE STAR",
    "dropdeladd": "5000 S WESTERN ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791096192,
    "dropphyadd": "5000 S WESTERN ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791096192,
    "dropmaladd": "5000 S WESTERN ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791096192,
    "dropsitphn": 8173173658,
    "dropsitlph": "",
    "dropsitcph": 8064688170,
    "dropfax": 8064688347
  },
  {
    "dcode": "D",
    "dropkey": "SW25686",
    "droptype": "D",
    "dropname": "SOUTH AUSTIN",
    "dropdeladd": "3903 S CONGRESS AVE",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787049998,
    "dropphyadd": "3903 S CONGRESS AVE",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787049997,
    "dropmaladd": "3903 S CONGRESS AVE",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124447235,
    "dropsitcph": 5124446980,
    "dropfax": 5124439851
  },
  {
    "dcode": "D",
    "dropkey": "SW25689",
    "droptype": "D",
    "dropname": "SOUTH END",
    "dropdeladd": "3501 AVENUE A",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777059996,
    "dropphyadd": "3501 AVENUE A",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777059996,
    "dropmaladd": "3501 AVENUE A",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777059996,
    "dropsitphn": 4098331734,
    "dropsitlph": 4098334676,
    "dropsitcph": 4098334676,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25692",
    "droptype": "D",
    "dropname": "DR CAESAR A W CLARK SR",
    "dropdeladd": "1502 E KIEST BLVD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752169998,
    "dropphyadd": "1502 E KIEST BLVD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752169998,
    "dropmaladd": "1502 E KIEST BLVD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752169998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143756327,
    "dropsitcph": 2143756327,
    "dropfax": 2143760356
  },
  {
    "dcode": "D",
    "dropkey": "SW25703",
    "droptype": "D",
    "dropname": "SOUTH TEXAS MEDICAL CNTR",
    "dropdeladd": "4835 MEDICAL DR",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782299998,
    "dropphyadd": "4835 MEDICAL DR",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782299998,
    "dropmaladd": "4835 MEDICAL DR",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782299998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109491328,
    "dropsitcph": 2109491327,
    "dropfax": 2106920778
  },
  {
    "dcode": "D",
    "dropkey": "SW25704",
    "droptype": "D",
    "dropname": "SOUTHEAST AUSTIN",
    "dropdeladd": "4516 BURLESON RD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787449998,
    "dropphyadd": "4516 BURLESON RD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787449998,
    "dropmaladd": "4516 BURLESON RD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787449998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124440753,
    "dropsitcph": 5124441083,
    "dropfax": 5124452541
  },
  {
    "dcode": "D",
    "dropkey": "SW25705",
    "droptype": "D",
    "dropname": "SOUTHEAST CROSSING",
    "dropdeladd": "3320 TROUP HWY STE 290",
    "dropdelcty": "TYLER",
    "dropdelst": "TX",
    "dropdelzpp": 757019997,
    "dropphyadd": "3320 TROUP HWY STE 290",
    "dropphycty": "TYLER",
    "dropphyst": "TX",
    "dropphyzpp": 757019997,
    "dropmaladd": "3320 TROUP HWY STE 290",
    "dropmalcty": "TYLER",
    "dropmalst": "TX",
    "dropmalzpp": 757019997,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035815114,
    "dropsitcph": 9035815114,
    "dropfax": 9035958619
  },
  {
    "dcode": "D",
    "dropkey": "SW25706",
    "droptype": "D",
    "dropname": "SOUTHERN HILLS",
    "dropdeladd": "2501 BUFFALO GAP RD",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796056185,
    "dropphyadd": "2501 BUFFALO GAP RD",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796056185,
    "dropmaladd": "2501 BUFFALO GAP RD",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796056185,
    "dropsitphn": 8173173658,
    "dropsitlph": 3256901257,
    "dropsitcph": 3256901257,
    "dropfax": 3256906337
  },
  {
    "dcode": "D",
    "dropkey": "SW25714",
    "droptype": "D",
    "dropname": "SOUTHMORE",
    "dropdeladd": "4110 ALMEDA RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770049998,
    "dropphyadd": "4110 ALMEDA RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770049998,
    "dropmaladd": "4110 ALMEDA RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770049998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7135222624,
    "dropsitcph": 7135223720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25716",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "6742 WEBER RD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784139998,
    "dropphyadd": "6742 WEBER RD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784139998,
    "dropmaladd": "6742 WEBER RD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784139998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618528379,
    "dropsitcph": 3618526038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25718",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "3201 LOOP 306",
    "dropdelcty": "SAN ANGELO",
    "dropdelst": "TX",
    "dropdelzpp": 769049998,
    "dropphyadd": "3201 LOOP 306",
    "dropphycty": "SAN ANGELO",
    "dropphyst": "TX",
    "dropphyzpp": 769049998,
    "dropmaladd": "3201 LOOP 306",
    "dropmalcty": "SAN ANGELO",
    "dropmalst": "TX",
    "dropmalzpp": 769049998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173173658,
    "dropsitcph": 3259478727,
    "dropfax": 3259420773
  },
  {
    "dcode": "D",
    "dropkey": "SW25737",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "13770 NOEL RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752409998,
    "dropphyadd": "13770 NOEL RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752409998,
    "dropmaladd": "13770 NOEL RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752409998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9729608667,
    "dropsitcph": 9729608667,
    "dropfax": 9729913181
  },
  {
    "dcode": "D",
    "dropkey": "SW25884",
    "droptype": "D",
    "dropname": "STOCKYARDS",
    "dropdeladd": "2120 ELLIS AVE",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761649997,
    "dropphyadd": "2120 ELLIS AVE",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761649997,
    "dropmaladd": "PO BOX 964998",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761649992,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176250291,
    "dropsitcph": 8176255864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25886",
    "droptype": "D",
    "dropname": "STONEWALL STA  CC",
    "dropdeladd": "10515 STONEWALL BLVD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784109998,
    "dropphyadd": "10515 STONEWALL BLVD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784109998,
    "dropmaladd": "10515 STONEWALL BLVD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612413531,
    "dropsitcph": 3612414363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25909",
    "droptype": "D",
    "dropname": "SUMMIT HEIGHTS",
    "dropdeladd": "4116 DYER ST",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799309998,
    "dropphyadd": "4116 DYER ST",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799309998,
    "dropmaladd": "4116 DYER ST",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155628765,
    "dropsitcph": 9155651087,
    "dropfax": 9155654355
  },
  {
    "dcode": "D",
    "dropkey": "SW25917",
    "droptype": "D",
    "dropname": "SUNRISE",
    "dropdeladd": "4100 HERCULES AVE",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799049998,
    "dropphyadd": "4100 HERCULES AVE",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799049998,
    "dropmaladd": "4100 HERCULES AVE",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157553140,
    "dropsitcph": 9157553138,
    "dropfax": 9157550331
  },
  {
    "dcode": "D",
    "dropkey": "SW25920",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "2121 FRANKFORD AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794909998,
    "dropphyadd": "2121 FRANKFORD AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794909998,
    "dropmaladd": "2121 FRANKFORD AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794909998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067959981,
    "dropsitcph": 8067959981,
    "dropfax": 8067840862
  },
  {
    "dcode": "D",
    "dropkey": "SW25950",
    "droptype": "D",
    "dropname": "TANDY CENTER",
    "dropdeladd": "100 THROCKMORTON ST STE 151",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761022899,
    "dropphyadd": "100 THROCKMORTON ST STE 151",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761022899,
    "dropmaladd": "100 THROCKMORTON ST STE 151",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761022899,
    "dropsitphn": 8173173658,
    "dropsitlph": 8173355036,
    "dropsitcph": 8173355036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW25959",
    "droptype": "D",
    "dropname": "TATE SPRINGS",
    "dropdeladd": "4108 SW GREEN OAKS BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760174198,
    "dropphyadd": "4108 SW GREEN OAKS BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760174198,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760039998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174687260,
    "dropsitcph": 8174654879,
    "dropfax": 8175630418
  },
  {
    "dcode": "D",
    "dropkey": "SW26005",
    "droptype": "D",
    "dropname": "TEXAS WOMANS UNIVERSITY",
    "dropdeladd": "1 TWU STUDENT BUILDING",
    "dropdelcty": "DENTON",
    "dropdelst": "TX",
    "dropdelzpp": 762048000,
    "dropphyadd": "1 TWU STUDENT BUILDING",
    "dropphycty": "DENTON",
    "dropphyst": "TX",
    "dropphyzpp": 762048000,
    "dropmaladd": "101 E MCKINNEY ST",
    "dropmalcty": "DENTON",
    "dropmalst": "TX",
    "dropmalzpp": 762014255,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403878555,
    "dropsitcph": 9403878555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26024",
    "droptype": "D",
    "dropname": "THOUSAND OAKS",
    "dropdeladd": "15610 HENDERSON PASS",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782329998,
    "dropphyadd": "15610 HENDERSON PASS",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782329998,
    "dropmaladd": "15610 HENDERSON PASS",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782329998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2104959782,
    "dropsitcph": 2104959774,
    "dropfax": 2104945924
  },
  {
    "dcode": "D",
    "dropkey": "SW26041",
    "droptype": "D",
    "dropname": "TOBE HAHN",
    "dropdeladd": "3910 N DOWLEN RD",
    "dropdelcty": "BEAUMONT",
    "dropdelst": "TX",
    "dropdelzpp": 777069998,
    "dropphyadd": "3910 N DOWLEN RD",
    "dropphycty": "BEAUMONT",
    "dropphyst": "TX",
    "dropphyzpp": 777069998,
    "dropmaladd": "3910 N DOWLEN RD",
    "dropmalcty": "BEAUMONT",
    "dropmalst": "TX",
    "dropmalzpp": 777069998,
    "dropsitphn": 4099241077,
    "dropsitlph": 4099241077,
    "dropsitcph": 4098980168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26055",
    "droptype": "D",
    "dropname": "TOWN NORTH",
    "dropdeladd": "8557 RESEARCH BLVD STE 124",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787589997,
    "dropphyadd": "8557 RESEARCH BLVD STE 124",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787589997,
    "dropmaladd": "8557 RESEARCH BLVD STE 124",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787589997,
    "dropsitphn": 2103688387,
    "dropsitlph": 5128359745,
    "dropsitcph": 5128359745,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26069",
    "droptype": "D",
    "dropname": "TRINITY RIVER",
    "dropdeladd": "4450 OAK PARK LN",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761099998,
    "dropphyadd": "4450 OAK PARK LN",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761099998,
    "dropmaladd": "4450 OAK PARK LN",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761099998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8179261922,
    "dropsitcph": 8179263948,
    "dropfax": 8179278602
  },
  {
    "dcode": "D",
    "dropkey": "SW26109",
    "droptype": "D",
    "dropname": "UNIVERSITY OF NORTH TEXAS",
    "dropdeladd": "410 AVENUE A",
    "dropdelcty": "DENTON",
    "dropdelst": "TX",
    "dropdelzpp": 762035000,
    "dropphyadd": "410 AVENUE A",
    "dropphycty": "DENTON",
    "dropphyst": "TX",
    "dropphyzpp": 762035000,
    "dropmaladd": "101 E MCKINNEY ST",
    "dropmalcty": "DENTON",
    "dropmalst": "TX",
    "dropmalzpp": 762014255,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403878555,
    "dropsitcph": 9403878555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26114",
    "droptype": "D",
    "dropname": "UNIVERSITY AUSTIN",
    "dropdeladd": "306 INNER CAMPUS DR",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787129998,
    "dropphyadd": "306 INNER CAMPUS DR",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787129998,
    "dropmaladd": "306 INNER CAMPUS DR",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787129998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124718868,
    "dropsitcph": 5122325488,
    "dropfax": 5124719147
  },
  {
    "dcode": "D",
    "dropkey": "SW26115",
    "droptype": "D",
    "dropname": "UNIVERSITY DALLAS",
    "dropdeladd": "5606 SMU BLVD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752069998,
    "dropphyadd": "5606 SMU BLVD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752069998,
    "dropmaladd": "5606 SMU BLVD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752069998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2146910788,
    "dropsitcph": 2146910788,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW26123",
    "droptype": "D",
    "dropname": "BRIDGE CREEK",
    "dropdeladd": "4001 SOUTHWEST PKWY",
    "dropdelcty": "WICHITA FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 763083563,
    "dropphyadd": "4001 SOUTHWEST PKWY",
    "dropphycty": "WICHITA FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 763083563,
    "dropmaladd": "4001 SOUTHWEST PKWY",
    "dropmalcty": "WICHITA FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 763083563,
    "dropsitphn": 8173173658,
    "dropsitlph": 9406914956,
    "dropsitcph": 9406915051,
    "dropfax": 9406913528
  },
  {
    "dcode": "D",
    "dropkey": "SW26139",
    "droptype": "D",
    "dropname": "VALLEY HI",
    "dropdeladd": "5510 SW LOOP 410",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782279998,
    "dropphyadd": "5510 SW LOOP 410",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782279998,
    "dropmaladd": "5510 SW LOOP 410",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2106749407,
    "dropsitcph": 2106745977,
    "dropfax": 2106756382
  },
  {
    "dcode": "D",
    "dropkey": "SW26169",
    "droptype": "D",
    "dropname": "VICKERY",
    "dropdeladd": "6640 ABRAMS RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752319998,
    "dropphyadd": "6640 ABRAMS RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752319998,
    "dropmaladd": "6640 ABRAMS RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752319998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2145531842,
    "dropsitcph": 2145531842,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW26180",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "2315 W LOUISIANA AVE",
    "dropdelcty": "MIDLAND",
    "dropdelst": "TX",
    "dropdelzpp": 797019997,
    "dropphyadd": "2315 W LOUISIANA AVE",
    "dropphycty": "MIDLAND",
    "dropphyst": "TX",
    "dropphyzpp": 797019997,
    "dropmaladd": "2315 W LOUISIANA AVE",
    "dropmalcty": "MIDLAND",
    "dropmalst": "TX",
    "dropmalzpp": 797019997,
    "dropsitphn": 2103688387,
    "dropsitlph": 4326837747,
    "dropsitcph": 4325605105,
    "dropfax": 4326860167
  },
  {
    "dcode": "D",
    "dropkey": "SW26200",
    "droptype": "D",
    "dropname": "WAINWRIGHT",
    "dropdeladd": "515 PIERCE",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782089998,
    "dropphyadd": "515 PIERCE",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782089998,
    "dropmaladd": "515 PIERCE",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782089998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2102276923,
    "dropsitcph": 2102276923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26236",
    "droptype": "D",
    "dropname": "WATSON COMMUNITY",
    "dropdeladd": "1975 BALLPARK WAY",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760066635,
    "dropphyadd": "1975 BALLPARK WAY",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760066635,
    "dropmaladd": "1975 BALLPARK WAY",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760066635,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176407873,
    "dropsitcph": 8176407304,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26245",
    "droptype": "D",
    "dropname": "WEDGWOOD",
    "dropdeladd": "3701 ALTAMESA BLVD",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761335649,
    "dropphyadd": "3701 ALTAMESA BLVD",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761335649,
    "dropmaladd": "3701 ALTAMESA BLVD",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761335649,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172945964,
    "dropsitcph": 8172949273,
    "dropfax": 8172942968
  },
  {
    "dcode": "D",
    "dropkey": "SW26259",
    "droptype": "D",
    "dropname": "WESLAYAN",
    "dropdeladd": "5340 WESLAYAN ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770059922,
    "dropphyadd": "5340 WESLAYAN ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770059922,
    "dropmaladd": "PO BOX 273998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772779998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7136660890,
    "dropsitcph": 7136660830,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26261",
    "droptype": "D",
    "dropname": "WEST AUSTIN",
    "dropdeladd": "2418 SPRING LN",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787039998,
    "dropphyadd": "2418 SPRING LN",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787039998,
    "dropmaladd": "2418 SPRING LN",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787039998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124784282,
    "dropsitcph": 5124787043,
    "dropfax": 5124766897
  },
  {
    "dcode": "D",
    "dropkey": "SW26280",
    "droptype": "D",
    "dropname": "WESTBRAE",
    "dropdeladd": "10910 S GESSNER RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770719998,
    "dropphyadd": "10910 S GESSNER RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770719998,
    "dropmaladd": "10910 S GESSNER RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770719998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137770235,
    "dropsitcph": 7137770246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26282",
    "droptype": "D",
    "dropname": "WESTCHASE",
    "dropdeladd": "3836 S GESSNER RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770639944,
    "dropphyadd": "3836 S GESSNER RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770639944,
    "dropmaladd": "PO BOX 773998",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 772159998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137828322,
    "dropsitcph": 7137827561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26283",
    "droptype": "D",
    "dropname": "WESTCHESTER",
    "dropdeladd": "765 W WESTCHESTER PKWY",
    "dropdelcty": "GRAND PRAIRIE",
    "dropdelst": "TX",
    "dropdelzpp": 750529998,
    "dropphyadd": "765 W WESTCHESTER PKWY",
    "dropphycty": "GRAND PRAIRIE",
    "dropphyst": "TX",
    "dropphyzpp": 750529998,
    "dropmaladd": "765 W WESTCHESTER PKWY",
    "dropmalcty": "GRAND PRAIRIE",
    "dropmalst": "TX",
    "dropmalzpp": 750529998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9722627404,
    "dropsitcph": 9722627404,
    "dropfax": 9722623635
  },
  {
    "dcode": "D",
    "dropkey": "SW26285",
    "droptype": "D",
    "dropname": "WESTFIELD",
    "dropdeladd": "17119 RED OAK DR",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770909998,
    "dropphyadd": "17119 RED OAK DR",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770909998,
    "dropmaladd": "17119 RED OAK DR",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770909998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814448272,
    "dropsitcph": 2814409509,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26288",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "3201 BEE CAVES RD STE 120",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787469998,
    "dropphyadd": "3201 BEE CAVES RD STE 120",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787469998,
    "dropmaladd": "3201 BEE CAVES RD STE 120",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787469998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123285065,
    "dropsitcph": 5123285065,
    "dropfax": 5123061165
  },
  {
    "dcode": "D",
    "dropkey": "SW26294",
    "droptype": "D",
    "dropname": "WEST ODESSA",
    "dropdeladd": "5200 W UNIVERSITY BLVD",
    "dropdelcty": "ODESSA",
    "dropdelst": "TX",
    "dropdelzpp": 797647209,
    "dropphyadd": "5200 W UNIVERSITY BLVD",
    "dropphycty": "ODESSA",
    "dropphyst": "TX",
    "dropphyzpp": 797647209,
    "dropmaladd": "5200 W UNIVERSITY BLVD",
    "dropmalcty": "ODESSA",
    "dropmalst": "TX",
    "dropmalzpp": 797647209,
    "dropsitphn": 2103688387,
    "dropsitlph": 4323620945,
    "dropsitcph": 4323816707,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26295",
    "droptype": "D",
    "dropname": "WESTVIEW",
    "dropdeladd": "800 WOODED ACRES DR",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767109998,
    "dropphyadd": "800 WOODED ACRES DR",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767109998,
    "dropmaladd": "800 WOODED ACRES DR",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2547517479,
    "dropsitcph": 2547517479,
    "dropfax": 2547723842
  },
  {
    "dcode": "D",
    "dropkey": "SW26310",
    "droptype": "D",
    "dropname": "WHITE ROCK",
    "dropdeladd": "1351 N BUCKNER BLVD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752189998,
    "dropphyadd": "1351 N BUCKNER BLVD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752189998,
    "dropmaladd": "1351 N BUCKNER BLVD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752189998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143275086,
    "dropsitcph": 2143275086,
    "dropfax": 2143210869
  },
  {
    "dcode": "D",
    "dropkey": "SW26331",
    "droptype": "D",
    "dropname": "WILDCAT",
    "dropdeladd": "2901 W PARKER RD",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750239998,
    "dropphyadd": "2901 W PARKER RD",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750239998,
    "dropmaladd": "2901 W PARKER RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750239998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9727698804,
    "dropsitcph": 9727698804,
    "dropfax": 9727589718
  },
  {
    "dcode": "D",
    "dropkey": "SW26348",
    "droptype": "D",
    "dropname": "WILLOW PLACE",
    "dropdeladd": "12955 WILLOW PLACE DR W",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770709998,
    "dropphyadd": "12955 WILLOW PLACE DR W",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770709998,
    "dropmaladd": "12955 WILLOW PLACE DR W",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770709998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2818902494,
    "dropsitcph": 2818902392,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26359",
    "droptype": "D",
    "dropname": "WINDMILL",
    "dropdeladd": "9898 ALMEDA GENOA RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770759998,
    "dropphyadd": "9898 ALMEDA GENOA RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770759998,
    "dropmaladd": "9898 ALMEDA GENOA RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770759998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7139470697,
    "dropsitcph": 7139471056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26438",
    "droptype": "D",
    "dropname": "WASHINGTON PARK",
    "dropdeladd": "4400 E PAISANO DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799059998,
    "dropphyadd": "4400 E PAISANO DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799059998,
    "dropmaladd": "4400 E PAISANO DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799059998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155323147,
    "dropsitcph": 9155323186,
    "dropfax": 9155328653
  },
  {
    "dcode": "D",
    "dropkey": "SW26444",
    "droptype": "D",
    "dropname": "VALLEY RANCH",
    "dropdeladd": "8501 N MACARTHUR BLVD",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750639998,
    "dropphyadd": "8501 N MACARTHUR BLVD",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750639998,
    "dropmaladd": "8501 N MACARTHUR BLVD",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750639998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9725069104,
    "dropsitcph": 9725069104,
    "dropfax": 9725060265
  },
  {
    "dcode": "D",
    "dropkey": "SW26525",
    "droptype": "D",
    "dropname": "LAKE TRAVIS",
    "dropdeladd": "2110 RANCH ROAD 620 S",
    "dropdelcty": "LAKEWAY",
    "dropdelst": "TX",
    "dropdelzpp": 787349998,
    "dropphyadd": "2110 RANCH ROAD 620 S",
    "dropphycty": "LAKEWAY",
    "dropphyst": "TX",
    "dropphyzpp": 787349998,
    "dropmaladd": "2110 RANCH ROAD 620 S",
    "dropmalcty": "LAKEWAY",
    "dropmalst": "TX",
    "dropmalzpp": 787349998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122638401,
    "dropsitcph": 5122632458,
    "dropfax": 5122631928
  },
  {
    "dcode": "D",
    "dropkey": "SW26538",
    "droptype": "D",
    "dropname": "DEL CITY FINANCE",
    "dropdeladd": "4500 SE 28TH ST",
    "dropdelcty": "DEL CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731159998,
    "dropphyadd": "4500 SE 28TH ST",
    "dropphycty": "DEL CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731159998,
    "dropmaladd": "4500 SE 28TH ST",
    "dropmalcty": "DEL CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731159998,
    "dropsitphn": 4056779439,
    "dropsitlph": 4056779439,
    "dropsitcph": 4056708564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26566",
    "droptype": "D",
    "dropname": "NORTH POSTAL STATION",
    "dropdeladd": "3503 SHEPPARD ACCESS RD",
    "dropdelcty": "WICHITA FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 76304,
    "dropphyadd": "3503 SHEPPARD ACCESS RD",
    "dropphycty": "WICHITA FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 76304,
    "dropmaladd": "3107 5TH ST",
    "dropmalcty": "WICHITA FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 763011841,
    "dropsitphn": 8176928163,
    "dropsitlph": 8176928163,
    "dropsitcph": 8176928163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26633",
    "droptype": "D",
    "dropname": "FIRST COLONY",
    "dropdeladd": "3130 GRANTS LAKE BLVD",
    "dropdelcty": "SUGAR LAND",
    "dropdelst": "TX",
    "dropdelzpp": 774799998,
    "dropphyadd": "3130 GRANTS LAKE BLVD",
    "dropphycty": "SUGAR LAND",
    "dropphyst": "TX",
    "dropphyzpp": 774799998,
    "dropmaladd": "3130 GRANTS LAKE BLVD",
    "dropmalcty": "SUGAR LAND",
    "dropmalst": "TX",
    "dropmalzpp": 774799998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2816348546,
    "dropsitcph": 2814944150,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26638",
    "droptype": "D",
    "dropname": "SOCORRO",
    "dropdeladd": "10550 N LOOP DR",
    "dropdelcty": "SOCORRO",
    "dropdelst": "TX",
    "dropdelzpp": 799279998,
    "dropphyadd": "10550 N LOOP DR",
    "dropphycty": "SOCORRO",
    "dropphyst": "TX",
    "dropphyzpp": 799279998,
    "dropmaladd": "10550 N LOOP DR",
    "dropmalcty": "SOCORRO",
    "dropmalst": "TX",
    "dropmalzpp": 799279998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9158604986,
    "dropsitcph": 9158604972,
    "dropfax": 9158602303
  },
  {
    "dcode": "D",
    "dropkey": "SW26640",
    "droptype": "D",
    "dropname": "AIRPORT MAIN OFC EL PASO",
    "dropdeladd": "8401 BOEING DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799109998,
    "dropphyadd": "8401 BOEING DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799109996,
    "dropmaladd": "8401 BOEING DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799109998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157807514,
    "dropsitcph": 9157807525,
    "dropfax": 9157807503
  },
  {
    "dcode": "D",
    "dropkey": "SW26646",
    "droptype": "D",
    "dropname": "LOVERS LANE",
    "dropdeladd": "5111 GREENVILLE AVE",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752069997,
    "dropphyadd": "5111 GREENVILLE AVE",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752069997,
    "dropmaladd": "5111 GREENVILLE AVE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752069997,
    "dropsitphn": 2147604376,
    "dropsitlph": 2146910788,
    "dropsitcph": 2146910788,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "SW26652",
    "droptype": "D",
    "dropname": "TEJEDA",
    "dropdeladd": "7411 BARLITE BLVD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782249998,
    "dropphyadd": "7411 BARLITE BLVD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782249998,
    "dropmaladd": "7411 BARLITE BLVD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782249998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109227720,
    "dropsitcph": 2109230941,
    "dropfax": 2109779419
  },
  {
    "dcode": "D",
    "dropkey": "SW26820",
    "droptype": "D",
    "dropname": "ROUND ROCK WEST",
    "dropdeladd": "797 SAM BASS RD",
    "dropdelcty": "ROUND ROCK",
    "dropdelst": "TX",
    "dropdelzpp": 786819998,
    "dropphyadd": "797 SAM BASS RD",
    "dropphycty": "ROUND ROCK",
    "dropphyst": "TX",
    "dropphyzpp": 786819998,
    "dropmaladd": "797 SAM BASS RD",
    "dropmalcty": "ROUND ROCK",
    "dropmalst": "TX",
    "dropmalzpp": 786819998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123882126,
    "dropsitcph": 5122389461,
    "dropfax": 5122558764
  },
  {
    "dcode": "D",
    "dropkey": "SW26825",
    "droptype": "D",
    "dropname": "FLEETWOOD",
    "dropdeladd": "315 ADDICKS HOWELL RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770799998,
    "dropphyadd": "315 ADDICKS HOWELL RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770799998,
    "dropmaladd": "315 ADDICKS HOWELL RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770799998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2817596458,
    "dropsitcph": 2816796628,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26846",
    "droptype": "D",
    "dropname": "NORTH MESQUITE",
    "dropdeladd": "3501 GUS THOMASSON RD STE 35",
    "dropdelcty": "MESQUITE",
    "dropdelst": "TX",
    "dropdelzpp": 751509998,
    "dropphyadd": "3501 GUS THOMASSON RD STE 35",
    "dropphycty": "MESQUITE",
    "dropphyst": "TX",
    "dropphyzpp": 751509998,
    "dropmaladd": "120 E GRUBB DR",
    "dropmalcty": "MESQUITE",
    "dropmalst": "TX",
    "dropmalzpp": 751499998,
    "dropsitphn": 2147604376,
    "dropsitlph": 9726825617,
    "dropsitcph": 9726825617,
    "dropfax": 9722701032
  },
  {
    "dcode": "D",
    "dropkey": "SW26847",
    "droptype": "D",
    "dropname": "NORTHWEST PLANO",
    "dropdeladd": "3905 HEDGCOXE RD",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750259998,
    "dropphyadd": "3905 HEDGCOXE RD",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750259998,
    "dropmaladd": "3905 HEDGCOXE RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750259998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723773166,
    "dropsitcph": 9723773166,
    "dropfax": 9723776743
  },
  {
    "dcode": "D",
    "dropkey": "SW26882",
    "droptype": "D",
    "dropname": "PRIORITY MAIL ANNEX",
    "dropdeladd": "12615 SAN PEDRO AVE",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782162848,
    "dropphyadd": "12615 SAN PEDRO AVE",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782162848,
    "dropmaladd": "12615 SAN PEDRO AVE",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782162848,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105453703,
    "dropsitcph": 2104955980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26887",
    "droptype": "D",
    "dropname": "PRESTON ROYAL",
    "dropdeladd": "5959 ROYAL LN STE 539",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752309997,
    "dropphyadd": "5959 ROYAL LN STE 539",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752309997,
    "dropmaladd": "5959 ROYAL LN STE 539",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752309997,
    "dropsitphn": 2144675879,
    "dropsitlph": 2143617453,
    "dropsitcph": 2145708422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26899",
    "droptype": "D",
    "dropname": "MESA HILLS",
    "dropdeladd": "5981 N MESA ST",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799029998,
    "dropphyadd": "5981 N MESA ST",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799029998,
    "dropmaladd": "5981 N MESA ST",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799029998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9155811342,
    "dropsitcph": 9155847110,
    "dropfax": 9158454408
  },
  {
    "dcode": "D",
    "dropkey": "SW26930",
    "droptype": "D",
    "dropname": "NORTHCROSS",
    "dropdeladd": "7700 NORTHCROSS DR",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787579998,
    "dropphyadd": "7700 NORTHCROSS DR",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787579998,
    "dropmaladd": "7700 NORTHCROSS DR",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787579998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124544038,
    "dropsitcph": 5124543859,
    "dropfax": 5124191239
  },
  {
    "dcode": "D",
    "dropkey": "SW26934",
    "droptype": "D",
    "dropname": "ACCOUNTABLE PAPERS",
    "dropdeladd": "341 PINE ST",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796019901,
    "dropphyadd": "341 PINE ST",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796019901,
    "dropmaladd": "341 PINE ST",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796019901,
    "dropsitphn": 8173173658,
    "dropsitlph": 9157382101,
    "dropsitcph": 9157382101,
    "dropfax": 9157382148
  },
  {
    "dcode": "D",
    "dropkey": "SW26935",
    "droptype": "D",
    "dropname": "COORDINATOR BMEU",
    "dropdeladd": "341 PINE ST",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796019995,
    "dropphyadd": "341 PINE ST",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796019995,
    "dropmaladd": "341 PINE ST",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796019995,
    "dropsitphn": 8173173658,
    "dropsitlph": 9157382101,
    "dropsitcph": 9157382101,
    "dropfax": 9157382148
  },
  {
    "dcode": "D",
    "dropkey": "SW26940",
    "droptype": "D",
    "dropname": "SANDY CREEK",
    "dropdeladd": "2100 GEORGE DIETER DR",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799369998,
    "dropphyadd": "2100 GEORGE DIETER DR",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799369998,
    "dropmaladd": "2100 GEORGE DIETER DR",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799369998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9158561516,
    "dropsitcph": 9158561483,
    "dropfax": 9158569710
  },
  {
    "dcode": "D",
    "dropkey": "SW26960",
    "droptype": "D",
    "dropname": "MAIN OFFICE DALLAS",
    "dropdeladd": "401 TOM LANDRY HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752609996,
    "dropphyadd": "401 TOM LANDRY HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752609996,
    "dropmaladd": "401 TOM LANDRY HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752609996,
    "dropsitphn": 2147604376,
    "dropsitlph": 2147604620,
    "dropsitcph": 2147604545,
    "dropfax": 2147604387
  },
  {
    "dcode": "D",
    "dropkey": "SW26961",
    "droptype": "D",
    "dropname": "WILLOW SPRINGS",
    "dropdeladd": "2403 W STAN SCHLUETER LOOP",
    "dropdelcty": "KILLEEN",
    "dropdelst": "TX",
    "dropdelzpp": 765499998,
    "dropphyadd": "2403 W STAN SCHLUETER LOOP",
    "dropphycty": "KILLEEN",
    "dropphyst": "TX",
    "dropphyzpp": 765499998,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "KILLEEN",
    "dropmalst": "TX",
    "dropmalzpp": 765479997,
    "dropsitphn": 2103688387,
    "dropsitlph": 2545018604,
    "dropsitcph": 2545018601,
    "dropfax": 2545018631
  },
  {
    "dcode": "D",
    "dropkey": "SW26965",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "1319 RICHMOND AVE",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770069998,
    "dropphyadd": "1319 RICHMOND AVE",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770069998,
    "dropmaladd": "1319 RICHMOND AVE",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770069998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7135228901,
    "dropsitcph": 7135227389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SW26968",
    "droptype": "D",
    "dropname": "COFFEE CREEK",
    "dropdeladd": "407 W COVELL RD",
    "dropdelcty": "EDMOND",
    "dropdelst": "OK",
    "dropdelzpp": 730039998,
    "dropphyadd": "407 W COVELL RD",
    "dropphycty": "EDMOND",
    "dropphyst": "OK",
    "dropphyzpp": 730039998,
    "dropmaladd": "407 W COVELL RD",
    "dropmalcty": "EDMOND",
    "dropmalst": "OK",
    "dropmalzpp": 730039998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058440583,
    "dropsitcph": 4058440583,
    "dropfax": 4058448958
  },
  {
    "dcode": "D",
    "dropkey": "SW26971",
    "droptype": "D",
    "dropname": "ALLIANCE AIRPORT",
    "dropdeladd": "2400 WESTPORT PKWY STE 200",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761779998,
    "dropphyadd": "2400 WESTPORT PKWY STE 200",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761779998,
    "dropmaladd": "2400 WESTPORT PKWY STE 200",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761779998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8174391339,
    "dropsitcph": 8174391333,
    "dropfax": 6823504335
  },
  {
    "dcode": "D",
    "dropkey": "SX1A166",
    "droptype": "D",
    "dropname": "NEWBERRY",
    "dropdeladd": "1966 W 4TH ST",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177019994,
    "dropphyadd": "1966 W 4TH ST",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177019994,
    "dropmaladd": "1966 W 4TH ST",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177019994,
    "dropsitphn": 7172574870,
    "dropsitlph": 7173204162,
    "dropsitcph": 7173237365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1A188",
    "droptype": "D",
    "dropname": "NICETOWN FINANCE",
    "dropdeladd": "3968 GERMANTOWN AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191409998,
    "dropphyadd": "3968 GERMANTOWN AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191409998,
    "dropmaladd": "3968 GERMANTOWN AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191409998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2153247130,
    "dropsitcph": 2153247130,
    "dropfax": 2153240280
  },
  {
    "dcode": "D",
    "dropkey": "SX1A225",
    "droptype": "D",
    "dropname": "NORTH PHILADELPHIA",
    "dropdeladd": "2601 N 16TH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191329998,
    "dropphyadd": "2601 N 16TH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191329998,
    "dropmaladd": "2601 N 16TH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191329998,
    "dropsitphn": 2152233003,
    "dropsitlph": 2152233003,
    "dropsitcph": 2152233003,
    "dropfax": 2152237116
  },
  {
    "dcode": "D",
    "dropkey": "SX1A228",
    "droptype": "D",
    "dropname": "NORTH SCRANTON",
    "dropdeladd": "1812 N MAIN AVE OFC",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185081992,
    "dropphyadd": "1812 N MAIN AVE OFC",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185081992,
    "dropmaladd": "2800 STAFFORD AVE",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185059998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703471351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1A281",
    "droptype": "D",
    "dropname": "OAKLAND",
    "dropdeladd": "347 S BOUQUET ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152139998,
    "dropphyadd": "347 S BOUQUET ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152139998,
    "dropmaladd": "347 S BOUQUET ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152139998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126211134,
    "dropsitcph": 4126211134,
    "dropfax": 4126210784
  },
  {
    "dcode": "D",
    "dropkey": "SX1A327",
    "droptype": "D",
    "dropname": "OLNEY FINANCE",
    "dropdeladd": "315 W OLNEY AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191209997,
    "dropphyadd": "315 W OLNEY AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191209997,
    "dropmaladd": "315 W OLNEY AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191209997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2153247130,
    "dropsitcph": 2153247130,
    "dropfax": 2153240280
  },
  {
    "dcode": "D",
    "dropkey": "SX1A361",
    "droptype": "D",
    "dropname": "OVERBROOK",
    "dropdeladd": "658 N 63RD ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191519998,
    "dropphyadd": "658 N 63RD ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191519998,
    "dropmaladd": "658 N 63RD ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191519998,
    "dropsitphn": 2154723607,
    "dropsitlph": 2154723607,
    "dropsitcph": 2154723607,
    "dropfax": 2154768648
  },
  {
    "dcode": "D",
    "dropkey": "SX1A381",
    "droptype": "D",
    "dropname": "PARCEL POST",
    "dropdeladd": "1001 CALIFORNIA AVE RM 1119A",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152909761,
    "dropphyadd": "1001 CALIFORNIA AVE RM 1119A",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152909761,
    "dropmaladd": "1001 CALIFORNIA AVE RM 1119A",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152909761,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123597838,
    "dropsitcph": 4123597838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1A387",
    "droptype": "D",
    "dropname": "PARK",
    "dropdeladd": "335 LONGFELLOW ST STE 1",
    "dropdelcty": "VANDERGRIFT",
    "dropdelst": "PA",
    "dropdelzpp": 156901400,
    "dropphyadd": "335 LONGFELLOW ST STE 1",
    "dropphycty": "VANDERGRIFT",
    "dropphyst": "PA",
    "dropphyzpp": 156901400,
    "dropmaladd": "335 LONGFELLOW ST STE 1",
    "dropmalcty": "VANDERGRIFT",
    "dropmalst": "PA",
    "dropmalzpp": 156901400,
    "dropsitphn": 4123597568,
    "dropsitlph": 4125679113,
    "dropsitcph": 4125679113,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1A402",
    "droptype": "D",
    "dropname": "PARNASSUS",
    "dropdeladd": "360 FREEPORT ST",
    "dropdelcty": "NEW KENSINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 150686015,
    "dropphyadd": "360 FREEPORT ST",
    "dropphycty": "NEW KENSINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 150686015,
    "dropmaladd": "360 FREEPORT ST",
    "dropmalcty": "NEW KENSINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 150686015,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243354987,
    "dropsitcph": 7243354987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1A444",
    "droptype": "D",
    "dropname": "PENN CENTER",
    "dropdeladd": "1500 JOHN F KENNEDY BLVD STE C31",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191029997,
    "dropphyadd": "1500 JOHN F KENNEDY BLVD STE C31",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191029997,
    "dropmaladd": "1500 JOHN F KENNEDY BLVD STE C31",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191029997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155675186,
    "dropsitcph": 2155675186,
    "dropfax": 2158958964
  },
  {
    "dcode": "D",
    "dropkey": "SX1A600",
    "droptype": "D",
    "dropname": "POINT BREEZE",
    "dropdeladd": "2500 SNYDER AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191459998,
    "dropphyadd": "2500 SNYDER AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191459998,
    "dropmaladd": "2500 SNYDER AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191459998,
    "dropsitphn": 2153349285,
    "dropsitlph": 2153344847,
    "dropsitcph": 2153344847,
    "dropfax": 2153341215
  },
  {
    "dcode": "D",
    "dropkey": "SX1A758",
    "droptype": "D",
    "dropname": "RICHMOND",
    "dropdeladd": "2001 E WILLARD ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191349998,
    "dropphyadd": "2001 E WILLARD ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191349998,
    "dropmaladd": "2001 E WILLARD ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191349998,
    "dropsitphn": 2157398286,
    "dropsitlph": 2157397081,
    "dropsitcph": 2157398286,
    "dropfax": 2157394649
  },
  {
    "dcode": "D",
    "dropkey": "SX1A831",
    "droptype": "D",
    "dropname": "ROSEHILL",
    "dropdeladd": "109 W ONTARIO ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191409997,
    "dropphyadd": "109 W ONTARIO ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191409997,
    "dropmaladd": "109 W ONTARIO ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191409997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2153247130,
    "dropsitcph": 2153247130,
    "dropfax": 2153240280
  },
  {
    "dcode": "D",
    "dropkey": "SX1A852",
    "droptype": "D",
    "dropname": "ROXBOROUGH",
    "dropdeladd": "555 GREEN LN",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191289998,
    "dropphyadd": "555 GREEN LN",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191289998,
    "dropmaladd": "555 GREEN LN",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191289998,
    "dropsitphn": 2155080467,
    "dropsitlph": 2155080467,
    "dropsitcph": 2155080467,
    "dropfax": 2154823540
  },
  {
    "dcode": "D",
    "dropkey": "SX1A949",
    "droptype": "D",
    "dropname": "SCHUYLKILL",
    "dropdeladd": "3005 GRAYS FERRY AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191469997,
    "dropphyadd": "3005 GRAYS FERRY AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191469997,
    "dropmaladd": "3005 GRAYS FERRY AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191469997,
    "dropsitphn": 2157551510,
    "dropsitlph": 2157551510,
    "dropsitcph": 2153369258,
    "dropfax": 2157551497
  },
  {
    "dcode": "D",
    "dropkey": "SX1A985",
    "droptype": "D",
    "dropname": "SHADYSIDE",
    "dropdeladd": "6360 BROAD ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152069997,
    "dropphyadd": "6360 BROAD ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152069997,
    "dropmaladd": "6360 BROAD ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152069998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126611254,
    "dropsitcph": 4126611254,
    "dropfax": 4126612350
  },
  {
    "dcode": "D",
    "dropkey": "SX1B134",
    "droptype": "D",
    "dropname": "SOUTH ERIE",
    "dropdeladd": "3607 POPLAR ST",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165089998,
    "dropphyadd": "3607 POPLAR ST",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165089998,
    "dropmaladd": "3607 POPLAR ST",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165089998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8148660321,
    "dropsitcph": 8148660321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B158",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "131 W 4TH ST",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180151600,
    "dropphyadd": "131 W 4TH ST",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180151600,
    "dropmaladd": "535 WOOD ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "PA",
    "dropmalzpp": 180169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108673221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B161",
    "droptype": "D",
    "dropname": "SOUTHWARK",
    "dropdeladd": "925 DICKINSON ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191479998,
    "dropphyadd": "925 DICKINSON ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191479998,
    "dropmaladd": "925 DICKINSON ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191479998,
    "dropsitphn": 2153367089,
    "dropsitlph": 2154621248,
    "dropsitcph": 2153367089,
    "dropfax": 2154621197
  },
  {
    "dcode": "D",
    "dropkey": "SX1B186",
    "droptype": "D",
    "dropname": "SPRING GARDEN",
    "dropdeladd": "1299 N 7TH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191229998,
    "dropphyadd": "1299 N 7TH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191229998,
    "dropmaladd": "1299 N 7TH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191229998,
    "dropsitphn": 2152353867,
    "dropsitlph": 2157630138,
    "dropsitcph": 2152353867,
    "dropfax": 2157636408
  },
  {
    "dcode": "D",
    "dropkey": "SX1B222",
    "droptype": "D",
    "dropname": "SQUIRREL HILL",
    "dropdeladd": "1800 MURRAY AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152179998,
    "dropphyadd": "1800 MURRAY AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152179998,
    "dropmaladd": "1800 MURRAY AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152179998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126617981,
    "dropsitcph": 4124214953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B328",
    "droptype": "D",
    "dropname": "WILLIAM LEVITT",
    "dropdeladd": "52 LEVITTOWN CTR",
    "dropdelcty": "LEVITTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 190559996,
    "dropphyadd": "52 LEVITTOWN CTR",
    "dropphycty": "LEVITTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 190559996,
    "dropmaladd": "52 LEVITTOWN CTR",
    "dropmalcty": "LEVITTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 190559996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2159493131,
    "dropsitcph": 2159493131,
    "dropfax": 2159491476
  },
  {
    "dcode": "D",
    "dropkey": "SX1B329",
    "droptype": "D",
    "dropname": "STA A WILKES BARRE",
    "dropdeladd": "34 W MARKET ST",
    "dropdelcty": "WILKES BARRE",
    "dropdelst": "PA",
    "dropdelzpp": 187011300,
    "dropphyadd": "34 W MARKET ST",
    "dropphycty": "WILKES BARRE",
    "dropphyst": "PA",
    "dropphyzpp": 187011300,
    "dropmaladd": "34 W MARKET ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187011300,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5708291843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B476",
    "droptype": "D",
    "dropname": "TACONY",
    "dropdeladd": "4620 LONGSHORE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191359998,
    "dropphyadd": "4620 LONGSHORE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191359998,
    "dropmaladd": "4620 LONGSHORE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191359998,
    "dropsitphn": 2157080280,
    "dropsitlph": 2156241061,
    "dropsitcph": 2156241061,
    "dropfax": 2156240528
  },
  {
    "dcode": "D",
    "dropkey": "SX1B537",
    "droptype": "D",
    "dropname": "TORRESDALE",
    "dropdeladd": "10380 DRUMMOND RD",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191549998,
    "dropphyadd": "10380 DRUMMOND RD",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191549998,
    "dropmaladd": "10380 DRUMMOND RD",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191549998,
    "dropsitphn": 2156322946,
    "dropsitlph": 2156323774,
    "dropsitcph": 2156323774,
    "dropfax": 2156323377
  },
  {
    "dcode": "D",
    "dropkey": "SX1B633",
    "droptype": "D",
    "dropname": "UNIVERSITY CITY",
    "dropdeladd": "228 S 40TH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049971,
    "dropphyadd": "228 S 40TH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049971,
    "dropmaladd": "228 S 40TH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049971,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158959012,
    "dropsitcph": 2158959012,
    "dropfax": 2153875469
  },
  {
    "dcode": "D",
    "dropkey": "SX1B634",
    "droptype": "D",
    "dropname": "UNIVERSITY PARK",
    "dropdeladd": "54 MCALLISTER BLDG",
    "dropdelcty": "UNIVERSITY PARK",
    "dropdelst": "PA",
    "dropdelzpp": 168026405,
    "dropphyadd": "54 MCALLISTER BLDG",
    "dropphycty": "UNIVERSITY PARK",
    "dropphyst": "PA",
    "dropphyzpp": 168026405,
    "dropmaladd": "54 MCALLISTER BLDG",
    "dropmalcty": "UNIVERSITY PARK",
    "dropmalst": "PA",
    "dropmalzpp": 168026405,
    "dropsitphn": 8148367307,
    "dropsitlph": "",
    "dropsitcph": 8142382435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B661",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "2347 N 7TH ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171109998,
    "dropphyadd": "2347 N 7TH ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171109998,
    "dropmaladd": "2347 N 7TH ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171109998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172340952,
    "dropfax": 7172343271
  },
  {
    "dcode": "D",
    "dropkey": "SX1B668",
    "droptype": "D",
    "dropname": "US NAVAL BASE",
    "dropdeladd": "2500 SNYDER AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191459996,
    "dropphyadd": "2500 SNYDER AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191459996,
    "dropmaladd": "2500 SNYDER AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191459996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158974749,
    "dropsitcph": 2158974749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B697",
    "droptype": "D",
    "dropname": "VERNON PARK",
    "dropdeladd": "133 W CHELTEN AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191449997,
    "dropphyadd": "133 W CHELTEN AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191449997,
    "dropmaladd": "133 W CHELTEN AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191449997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158444353,
    "dropsitcph": 2158444353,
    "dropfax": 2158420445
  },
  {
    "dcode": "D",
    "dropkey": "SX1B761",
    "droptype": "D",
    "dropname": "WABASH",
    "dropdeladd": "13 WABASH ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152209998,
    "dropphyadd": "13 WABASH ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152209998,
    "dropmaladd": "13 WABASH ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152209998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122796955,
    "dropsitcph": 4129214178,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B764",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "1613 E WADSWORTH AVE STE 1",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191509997,
    "dropphyadd": "1613 E WADSWORTH AVE STE 1",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191509997,
    "dropmaladd": "1613 E WADSWORTH AVE STE 1",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191509997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2152429785,
    "dropsitcph": 2157538927,
    "dropfax": 2152476147
  },
  {
    "dcode": "D",
    "dropkey": "SX1B768",
    "droptype": "D",
    "dropname": "WAHNETAH",
    "dropdeladd": "432 CENTER ST",
    "dropdelcty": "JIM THORPE",
    "dropdelst": "PA",
    "dropdelzpp": 182291406,
    "dropphyadd": "432 CENTER ST",
    "dropphycty": "JIM THORPE",
    "dropphyst": "PA",
    "dropphyzpp": 182291406,
    "dropmaladd": "3 LEHIGH AVE",
    "dropmalcty": "JIM THORPE",
    "dropmalst": "PA",
    "dropmalzpp": 182299998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5703253180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B925",
    "droptype": "D",
    "dropname": "WEST MARKET",
    "dropdeladd": "5011 SANSOM ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191399998,
    "dropphyadd": "5011 SANSOM ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191399998,
    "dropmaladd": "5011 SANSOM ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191399998,
    "dropsitphn": 2157475396,
    "dropsitlph": 2157471402,
    "dropsitcph": 2157471402,
    "dropfax": 2157480729
  },
  {
    "dcode": "D",
    "dropkey": "SX1B935",
    "droptype": "D",
    "dropname": "WEST PARK",
    "dropdeladd": "5300 W JEFFERSON ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191319998,
    "dropphyadd": "5300 W JEFFERSON ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191319998,
    "dropmaladd": "5300 W JEFFERSON ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191319998,
    "dropsitphn": 2154732487,
    "dropsitlph": 2154737297,
    "dropsitcph": 2154732487,
    "dropfax": 2154732063
  },
  {
    "dcode": "D",
    "dropkey": "SX1B940",
    "droptype": "D",
    "dropname": "MAIN OFFICE PHILA DELIVERY",
    "dropdeladd": "3000 CHESTNUT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049998,
    "dropphyadd": "3000 CHESTNUT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049997,
    "dropmaladd": "3000 CHESTNUT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049997,
    "dropsitphn": 2158959012,
    "dropsitlph": 2158959012,
    "dropsitcph": 2158959012,
    "dropfax": 2158958964
  },
  {
    "dcode": "D",
    "dropkey": "SX1B950",
    "droptype": "D",
    "dropname": "WEST SCRANTON",
    "dropdeladd": "127 S MAIN AVE",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185049998,
    "dropphyadd": "127 S MAIN AVE",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185049998,
    "dropmaladd": "127 S MAIN AVE",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185049998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703424279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1B976",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "2114 W UNION BLVD",
    "dropdelcty": "BETHLEHEM",
    "dropdelst": "PA",
    "dropdelzpp": 180182030,
    "dropphyadd": "2114 W UNION BLVD",
    "dropphycty": "BETHLEHEM",
    "dropphyst": "PA",
    "dropphyzpp": 180182030,
    "dropmaladd": "535 WOOD ST",
    "dropmalcty": "BETHLEHEM",
    "dropmalst": "PA",
    "dropmalzpp": 180169998,
    "dropsitphn": 7172574870,
    "dropsitlph": 6108823244,
    "dropsitcph": 6108665982,
    "dropfax": 6108665926
  },
  {
    "dcode": "D",
    "dropkey": "SX1C014",
    "droptype": "D",
    "dropname": "WIDENER UNIVERSITY",
    "dropdeladd": "1 UNIVERSITY PL",
    "dropdelcty": "CHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 190139997,
    "dropphyadd": "1 UNIVERSITY PL",
    "dropphycty": "CHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 190139997,
    "dropmaladd": "1 UNIVERSITY PL",
    "dropmalcty": "CHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 190139997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2154994410,
    "dropsitcph": 2154994410,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C074",
    "droptype": "D",
    "dropname": "WISSINOMING",
    "dropdeladd": "5916 TORRESDALE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191359997,
    "dropphyadd": "5916 TORRESDALE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191359997,
    "dropmaladd": "5916 TORRESDALE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191359997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156241064,
    "dropsitcph": 2156241064,
    "dropfax": 2156240528
  },
  {
    "dcode": "D",
    "dropkey": "SX1C111",
    "droptype": "D",
    "dropname": "WYLIE",
    "dropdeladd": "415 DINWIDDIE ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152193384,
    "dropphyadd": "415 DINWIDDIE ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152193384,
    "dropmaladd": "415 DINWIDDIE ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152193384,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126420859,
    "dropsitcph": 4126420859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C136",
    "droptype": "D",
    "dropname": "YORK ROAD",
    "dropdeladd": "445 YORK RD",
    "dropdelcty": "WARMINSTER",
    "dropdelst": "PA",
    "dropdelzpp": 189749997,
    "dropphyadd": "445 YORK RD",
    "dropphycty": "WARMINSTER",
    "dropphyst": "PA",
    "dropphyzpp": 189749997,
    "dropmaladd": "445 YORK RD",
    "dropmalcty": "WARMINSTER",
    "dropmalst": "PA",
    "dropmalzpp": 189749997,
    "dropsitphn": 6109646414,
    "dropsitlph": 2156720254,
    "dropsitcph": 2156720254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C186",
    "droptype": "D",
    "dropname": "4TH STREET",
    "dropdeladd": "411 S 4TH ST STE 175",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402029997,
    "dropphyadd": "411 S 4TH ST STE 175",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402029997,
    "dropmaladd": "411 S 4TH ST STE 175",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402029997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025847841,
    "dropfax": 5025612856
  },
  {
    "dcode": "D",
    "dropkey": "SX1C246",
    "droptype": "D",
    "dropname": "POSTAL STORE",
    "dropdeladd": "118 W 4TH ST",
    "dropdelcty": "OWENSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423039997,
    "dropphyadd": "118 W 4TH ST",
    "dropphycty": "OWENSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423039997,
    "dropmaladd": "54 BON HARBOR HLS",
    "dropmalcty": "OWENSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706868765,
    "dropfax": 2706843231
  },
  {
    "dcode": "D",
    "dropkey": "SX1C267",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "1303 US HIGHWAY 127 S STE 100",
    "dropdelcty": "FRANKFORT",
    "dropdelst": "KY",
    "dropdelzpp": 406014412,
    "dropphyadd": "1303 US HIGHWAY 127 S STE 100",
    "dropphycty": "FRANKFORT",
    "dropphyst": "KY",
    "dropphyzpp": 406014412,
    "dropmaladd": "1303 US HIGHWAY 127 S STE 100",
    "dropmalcty": "FRANKFORT",
    "dropmalst": "KY",
    "dropmalzpp": 406014412,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022233447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C278",
    "droptype": "D",
    "dropname": "MOUNT BETHEL",
    "dropdeladd": "4455 LOWER ROSWELL RD",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300689998,
    "dropphyadd": "4455 LOWER ROSWELL RD",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300689998,
    "dropmaladd": "4455 LOWER ROSWELL RD",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300689998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784330597,
    "dropsitcph": 7705098673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C279",
    "droptype": "D",
    "dropname": "MARKET SQUARE",
    "dropdeladd": "2932 CANTON RD STE 260",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300663861,
    "dropphyadd": "2932 CANTON RD STE 260",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300663861,
    "dropmaladd": "2932 CANTON RD STE 260",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300663861,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7703219136,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C280",
    "droptype": "D",
    "dropname": "MAIN OFFICE WINDOW UNIT",
    "dropdeladd": "1420 GARDINER LN",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402319988,
    "dropphyadd": "1420 GARDINER LN",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402319988,
    "dropmaladd": "PO BOX 31997",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402319997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024541763,
    "dropfax": 5024541685
  },
  {
    "dcode": "D",
    "dropkey": "SX1C343",
    "droptype": "D",
    "dropname": "STEAMTOWN",
    "dropdeladd": "100 THE MALL AT STEAMTOWN",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185039997,
    "dropphyadd": "100 THE MALL AT STEAMTOWN",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185039997,
    "dropmaladd": "100 THE MALL AT STEAMTOWN",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185039997,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5709410502,
    "dropfax": 5709410412
  },
  {
    "dcode": "D",
    "dropkey": "SX1C362",
    "droptype": "D",
    "dropname": "DOWNTOWN HAZARD",
    "dropdeladd": "601 MAIN ST",
    "dropdelcty": "HAZARD",
    "dropdelst": "KY",
    "dropdelzpp": 417011346,
    "dropphyadd": "601 MAIN ST",
    "dropphycty": "HAZARD",
    "dropphyst": "KY",
    "dropphyzpp": 417011346,
    "dropmaladd": "601 MAIN ST",
    "dropmalcty": "HAZARD",
    "dropmalst": "KY",
    "dropmalzpp": 417011346,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064363188,
    "dropfax": 6064393499
  },
  {
    "dcode": "D",
    "dropkey": "SX1C394",
    "droptype": "D",
    "dropname": "WEBB BRIDGE",
    "dropdeladd": "4575 WEBB BRIDGE RD",
    "dropdelcty": "ALPHARETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300059998,
    "dropphyadd": "4575 WEBB BRIDGE RD",
    "dropphycty": "ALPHARETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300059998,
    "dropmaladd": "4575 WEBB BRIDGE RD",
    "dropmalcty": "ALPHARETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300059998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706648553,
    "dropsitcph": 7705699818,
    "dropfax": 7707521982
  },
  {
    "dcode": "D",
    "dropkey": "SX1C412",
    "droptype": "D",
    "dropname": "AIR MAIL FACILITY",
    "dropdeladd": "4440 CRITTENDEN DR",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402219990,
    "dropphyadd": "4440 CRITTENDEN DR",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402219990,
    "dropmaladd": "4440 CRITTENDEN DR",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402219990,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023755907,
    "dropfax": 5023755868
  },
  {
    "dcode": "D",
    "dropkey": "SX1C417",
    "droptype": "D",
    "dropname": "OLNEY CARRIER UNIT",
    "dropdeladd": "101 E OLNEY AVE FRNT",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191209998,
    "dropphyadd": "101 E OLNEY AVE FRNT",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191209998,
    "dropmaladd": "4350 N FRONT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191409996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2159242603,
    "dropsitcph": 2159242603,
    "dropfax": 2159242132
  },
  {
    "dcode": "D",
    "dropkey": "SX1C418",
    "droptype": "D",
    "dropname": "MORRELL AVENUE",
    "dropdeladd": "3854 MORRELL AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191149996,
    "dropphyadd": "3854 MORRELL AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191149996,
    "dropmaladd": "3854 MORRELL AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191149996,
    "dropsitphn": 2155329348,
    "dropsitlph": 2156329348,
    "dropsitcph": 2155329348,
    "dropfax": 2158958123
  },
  {
    "dcode": "D",
    "dropkey": "SX1C515",
    "droptype": "D",
    "dropname": "HUNTING PARK",
    "dropdeladd": "4350 N FRONT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191409995,
    "dropphyadd": "4350 N FRONT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191409995,
    "dropmaladd": "4350 N FRONT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191409995,
    "dropsitphn": 2153298147,
    "dropsitlph": 2153242275,
    "dropsitcph": 2153298147,
    "dropfax": 2153240856
  },
  {
    "dcode": "D",
    "dropkey": "SX1C517",
    "droptype": "D",
    "dropname": "LAND TITLE BLDG",
    "dropdeladd": "100 S BROAD ST STE 30",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191109997,
    "dropphyadd": "100 S BROAD ST STE 30",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191109997,
    "dropmaladd": "100 S BROAD ST STE 30",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191109997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155675186,
    "dropsitcph": 2155675186,
    "dropfax": 2158958964
  },
  {
    "dcode": "D",
    "dropkey": "SX1C583",
    "droptype": "D",
    "dropname": "LIMESTONE",
    "dropdeladd": "2490 LIMESTONE PKWY",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305019996,
    "dropphyadd": "2490 LIMESTONE PKWY",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305019996,
    "dropmaladd": "364 GREEN ST NE",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305013310,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705339508,
    "dropsitcph": 7705365647,
    "dropfax": 7705347236
  },
  {
    "dcode": "D",
    "dropkey": "SX1C584",
    "droptype": "D",
    "dropname": "POSTAL STORE",
    "dropdeladd": "800 N GREEN RIVER RD",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477152471,
    "dropphyadd": "800 N GREEN RIVER RD",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477152471,
    "dropmaladd": "800 N GREEN RIVER RD",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477152471,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124759065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C587",
    "droptype": "D",
    "dropname": "HOLMESBURG POSTAL STORE",
    "dropdeladd": "8232 FRANKFORD AVE STE A",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191369998,
    "dropphyadd": "8232 FRANKFORD AVE STE A",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191369998,
    "dropmaladd": "8232 FRANKFORD AVE STE A",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191369998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156329294,
    "dropsitcph": 2156329294,
    "dropfax": 2156329364
  },
  {
    "dcode": "D",
    "dropkey": "SX1C588",
    "droptype": "D",
    "dropname": "CASTLE",
    "dropdeladd": "1713 S BROAD ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191489996,
    "dropphyadd": "1713 S BROAD ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191489996,
    "dropmaladd": "1713 S BROAD ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191489996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2154623136,
    "dropsitcph": 2154623136,
    "dropfax": 2154621197
  },
  {
    "dcode": "D",
    "dropkey": "SX1C589",
    "droptype": "D",
    "dropname": "SOMERTON POSTAL STORE",
    "dropdeladd": "669 HENDRIX ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191169998,
    "dropphyadd": "669 HENDRIX ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191169998,
    "dropmaladd": "669 HENDRIX ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191169998,
    "dropsitphn": 2156731275,
    "dropsitlph": 2154645842,
    "dropsitcph": 2154645842,
    "dropfax": 2156764534
  },
  {
    "dcode": "D",
    "dropkey": "SX1C600",
    "droptype": "D",
    "dropname": "CAMPBELLTON STREET",
    "dropdeladd": "8486 CAMPBELLTON ST",
    "dropdelcty": "DOUGLASVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301349998,
    "dropphyadd": "8486 CAMPBELLTON ST",
    "dropphycty": "DOUGLASVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301349998,
    "dropmaladd": "8486 CAMPBELLTON ST",
    "dropmalcty": "DOUGLASVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301349998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709476985,
    "dropsitcph": 7709478132,
    "dropfax": 7709206893
  },
  {
    "dcode": "D",
    "dropkey": "SX1C621",
    "droptype": "D",
    "dropname": "P & DC PADUCAH",
    "dropdeladd": "300 S 4TH ST",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420039996,
    "dropphyadd": "300 S 4TH ST",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420039996,
    "dropmaladd": "PO BOX 1840",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420021840,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704445326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX1C643",
    "droptype": "D",
    "dropname": "CHURCH STREET",
    "dropdeladd": "6691 CHURCH ST",
    "dropdelcty": "RIVERDALE",
    "dropdelst": "GA",
    "dropdelzpp": 302749997,
    "dropphyadd": "6691 CHURCH ST",
    "dropphycty": "RIVERDALE",
    "dropphyst": "GA",
    "dropphyzpp": 302749997,
    "dropmaladd": "6691 CHURCH ST",
    "dropmalcty": "RIVERDALE",
    "dropmalst": "GA",
    "dropmalzpp": 302749997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709941866,
    "dropsitcph": 7709943536,
    "dropfax": 7709071116
  },
  {
    "dcode": "D",
    "dropkey": "SX1C645",
    "droptype": "D",
    "dropname": "GREENVILLE ST",
    "dropdeladd": "18 GREENVILLE ST",
    "dropdelcty": "NEWNAN",
    "dropdelst": "GA",
    "dropdelzpp": 302639997,
    "dropphyadd": "18 GREENVILLE ST",
    "dropphycty": "NEWNAN",
    "dropphyst": "GA",
    "dropphyzpp": 302639997,
    "dropmaladd": "18 GREENVILLE ST",
    "dropmalcty": "NEWNAN",
    "dropmalst": "GA",
    "dropmalzpp": 302639997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705027836,
    "dropsitcph": 7705027836,
    "dropfax": 7703042813
  },
  {
    "dcode": "D",
    "dropkey": "SX1C739",
    "droptype": "D",
    "dropname": "MARTECH",
    "dropdeladd": "794 MARIETTA ST NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303189997,
    "dropphyadd": "794 MARIETTA ST NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303189997,
    "dropmaladd": "794 MARIETTA ST NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303189997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045898765,
    "dropsitcph": 4048734365,
    "dropfax": 4045236765
  },
  {
    "dcode": "D",
    "dropkey": "SX1C785",
    "droptype": "D",
    "dropname": "POST RIDER",
    "dropdeladd": "210 E HIGH ST",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405079998,
    "dropphyadd": "210 E HIGH ST",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405079998,
    "dropmaladd": "210 E HIGH ST",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405079998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592786425,
    "dropfax": 8592254933
  },
  {
    "dcode": "D",
    "dropkey": "SX1D135",
    "droptype": "D",
    "dropname": "CUMBERLAND MALL",
    "dropdeladd": "1315 CUMBERLAND MALL SE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303393138,
    "dropphyadd": "1315 CUMBERLAND MALL SE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303393138,
    "dropmaladd": "1315 CUMBERLAND MALL SE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303393138,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704381076,
    "dropsitcph": 7705411395,
    "dropfax": 7704379741
  },
  {
    "dcode": "D",
    "dropkey": "SX1D139",
    "droptype": "D",
    "dropname": "PERIMETER CENTER",
    "dropdeladd": "4707 ASHFORD DUNWOODY RD",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303389997,
    "dropphyadd": "4707 ASHFORD DUNWOODY RD",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303389997,
    "dropmaladd": "4707 ASHFORD DUNWOODY RD",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303389997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705120761,
    "dropsitcph": 7703529070,
    "dropfax": 7706989532
  },
  {
    "dcode": "D",
    "dropkey": "SX1D142",
    "droptype": "D",
    "dropname": "GREENBRIAR MALL",
    "dropdeladd": "2841 GREENBRIAR PKWY SW STE N472",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303319997,
    "dropphyadd": "2841 GREENBRIAR PKWY SW STE N472",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303319997,
    "dropmaladd": "2841 GREENBRIAR PKWY SW STE N472",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303319997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043445885,
    "dropsitcph": 4046299596,
    "dropfax": 4043447366
  },
  {
    "dcode": "D",
    "dropkey": "SX1D187",
    "droptype": "D",
    "dropname": "ROXBOROUGH POSTAL STORE",
    "dropdeladd": "6184 RIDGE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191289995,
    "dropphyadd": "6184 RIDGE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191289995,
    "dropmaladd": "6184 RIDGE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191289995,
    "dropsitphn": 2155089206,
    "dropsitlph": 2155089206,
    "dropsitcph": 2154821779,
    "dropfax": 2154823540
  },
  {
    "dcode": "D",
    "dropkey": "SX1D189",
    "droptype": "D",
    "dropname": "ROOSEVELT MALL",
    "dropdeladd": "2311 COTTMAN AVE STE 10",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191499996,
    "dropphyadd": "2311 COTTMAN AVE STE 10",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191499996,
    "dropmaladd": "2311 COTTMAN AVE STE 10",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191499996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2153311346,
    "dropsitcph": 2153311346,
    "dropfax": 2153312953
  },
  {
    "dcode": "D",
    "dropkey": "SX10014",
    "droptype": "D",
    "dropname": "L&DC",
    "dropdeladd": "2310 MAYNARD H JACKSON JR BLVD",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303206005,
    "dropphyadd": "2310 MAYNARD H JACKSON JR BLVD",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303206005,
    "dropmaladd": "PO BOX 46997",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303209997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047655512,
    "dropsitcph": 4047655634,
    "dropfax": 4047659607
  },
  {
    "dcode": "D",
    "dropkey": "SX10026",
    "droptype": "D",
    "dropname": "ALPS ROAD",
    "dropdeladd": "196 ALPS RD STE 48",
    "dropdelcty": "ATHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306064094,
    "dropphyadd": "196 ALPS RD STE 48",
    "dropphycty": "ATHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306064094,
    "dropmaladd": "PO BOX 80308",
    "dropmalcty": "ATHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306080308,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063693200,
    "dropsitcph": 7063693200,
    "dropfax": 7063693238
  },
  {
    "dcode": "D",
    "dropkey": "SX10076",
    "droptype": "D",
    "dropname": "BAKER VILLAGE",
    "dropdeladd": "1435 BENNING DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319039998,
    "dropphyadd": "1435 BENNING DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319039998,
    "dropmaladd": "1435 BENNING DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7066879798,
    "dropsitcph": 7066879798,
    "dropfax": 7066828013
  },
  {
    "dcode": "D",
    "dropkey": "SX10088",
    "droptype": "D",
    "dropname": "BARRETT PARKWAY",
    "dropdeladd": "840 ERNEST W BARRETT PKWY NW STE 572",
    "dropdelcty": "KENNESAW",
    "dropdelst": "GA",
    "dropdelzpp": 301449997,
    "dropphyadd": "840 ERNEST W BARRETT PKWY NW STE 572",
    "dropphycty": "KENNESAW",
    "dropphyst": "GA",
    "dropphyzpp": 301449997,
    "dropmaladd": "2001 DUNCAN DR NW",
    "dropmalcty": "KENNESAW",
    "dropmalst": "GA",
    "dropmalzpp": 301449998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704247036,
    "dropsitcph": 7704224103,
    "dropfax": 7704221162
  },
  {
    "dcode": "D",
    "dropkey": "SX10094",
    "droptype": "D",
    "dropname": "BEALLWOOD",
    "dropdeladd": "4012 HAMILTON RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319049998,
    "dropphyadd": "4012 HAMILTON RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319049998,
    "dropmaladd": "4012 HAMILTON RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065968779,
    "dropsitcph": 7065968779,
    "dropfax": 7063247335
  },
  {
    "dcode": "D",
    "dropkey": "SX10099",
    "droptype": "D",
    "dropname": "BEN HILL",
    "dropdeladd": "2260 FAIRBURN RD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303315014,
    "dropphyadd": "2260 FAIRBURN RD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303315014,
    "dropmaladd": "2260 FAIRBURN RD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303315014,
    "dropsitphn": 4047657578,
    "dropsitlph": 4046299371,
    "dropsitcph": 4043446075,
    "dropfax": 4043444838
  },
  {
    "dcode": "D",
    "dropkey": "SX10108",
    "droptype": "D",
    "dropname": "BIBB CITY",
    "dropdeladd": "3916 MILGEN RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079998,
    "dropphyadd": "3916 MILGEN RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319071264,
    "dropmaladd": "3916 MILGEN RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319071264,
    "dropsitphn": 4787528444,
    "dropsitlph": 4787528444,
    "dropsitcph": 7063221045,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10112",
    "droptype": "D",
    "dropname": "BINGVILLE",
    "dropdeladd": "3601 MONTGOMERY ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314059998,
    "dropphyadd": "3601 MONTGOMERY ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314059998,
    "dropmaladd": "3601 MONTGOMERY ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314059998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122348935,
    "dropsitcph": 9122348935,
    "dropfax": 9122368523
  },
  {
    "dcode": "D",
    "dropkey": "SX10156",
    "droptype": "D",
    "dropname": "BRIARCLIFF",
    "dropdeladd": "3104 BRIARCLIFF RD NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303459998,
    "dropphyadd": "3104 BRIARCLIFF RD NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303459998,
    "dropmaladd": "3104 BRIARCLIFF RD NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303459998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043253423,
    "dropsitcph": 4043250497,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10161",
    "droptype": "D",
    "dropname": "BROADVIEW",
    "dropdeladd": "780 MOROSGO DR NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303249998,
    "dropphyadd": "780 MOROSGO DR NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303249998,
    "dropmaladd": "780 MOROSGO DR NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303249998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042339401,
    "dropsitcph": 4048167474,
    "dropfax": 4042400941
  },
  {
    "dcode": "D",
    "dropkey": "SX10164",
    "droptype": "D",
    "dropname": "BROOKHAVEN",
    "dropdeladd": "3851 PEACHTREE RD NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303261217,
    "dropphyadd": "3851 PEACHTREE RD NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303261217,
    "dropmaladd": "3840 ROSWELL RD NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303059998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042629794,
    "dropsitcph": 4048168058,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10207",
    "droptype": "D",
    "dropname": "CASCADE HEIGHTS",
    "dropdeladd": "2414 HERRING RD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303119998,
    "dropphyadd": "2414 HERRING RD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303119998,
    "dropmaladd": "2414 HERRING RD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303119998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047553380,
    "dropsitcph": 4047553167,
    "dropfax": 4047539624
  },
  {
    "dcode": "D",
    "dropkey": "SX10211",
    "droptype": "D",
    "dropname": "CASTLE PARK",
    "dropdeladd": "901 MILLPOND RD",
    "dropdelcty": "VALDOSTA",
    "dropdelst": "GA",
    "dropdelzpp": 316021655,
    "dropphyadd": "901 MILLPOND RD",
    "dropphycty": "VALDOSTA",
    "dropphyst": "GA",
    "dropphyzpp": 316021655,
    "dropmaladd": "401 N PATTERSON ST",
    "dropmalcty": "VALDOSTA",
    "dropmalst": "GA",
    "dropmalzpp": 316014627,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 9122428201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10224",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "183 FORSYTH ST SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303033634,
    "dropphyadd": "183 FORSYTH ST SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303033634,
    "dropmaladd": "183 FORSYTH ST SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303033634,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045210753,
    "dropsitcph": 4045210753,
    "dropfax": 4045252654
  },
  {
    "dcode": "D",
    "dropkey": "SX10239",
    "droptype": "D",
    "dropname": "CIVIC CENTER",
    "dropdeladd": "570 PIEDMONT AVE NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303089998,
    "dropphyadd": "570 PIEDMONT AVE NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303089998,
    "dropmaladd": "570 PIEDMONT AVE NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303089998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4046859335,
    "dropsitcph": 4048748718,
    "dropfax": 4048154392
  },
  {
    "dcode": "D",
    "dropkey": "SX10278",
    "droptype": "D",
    "dropname": "CONCORD SQUARE",
    "dropdeladd": "3315 S COBB DR SE STE 700",
    "dropdelcty": "SMYRNA",
    "dropdelst": "GA",
    "dropdelzpp": 300809997,
    "dropphyadd": "3315 S COBB DR SE STE 700",
    "dropphycty": "SMYRNA",
    "dropphyst": "GA",
    "dropphyzpp": 300809997,
    "dropmaladd": "3315 S COBB DR SE STE 700",
    "dropmalcty": "SMYRNA",
    "dropmalst": "GA",
    "dropmalzpp": 300809997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704358501,
    "dropsitcph": 7704358501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10287",
    "droptype": "D",
    "dropname": "COURT SQUARE",
    "dropdeladd": "100 N FRANKLIN ST RM 103",
    "dropdelcty": "DUBLIN",
    "dropdelst": "GA",
    "dropdelzpp": 310216756,
    "dropphyadd": "100 N FRANKLIN ST RM 103",
    "dropphycty": "DUBLIN",
    "dropphyst": "GA",
    "dropphyzpp": 310216756,
    "dropmaladd": "100 N FRANKLIN ST RM 103",
    "dropmalcty": "DUBLIN",
    "dropmalst": "GA",
    "dropmalzpp": 310216756,
    "dropsitphn": 4787528444,
    "dropsitlph": 4787528444,
    "dropsitcph": 4782720275,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10305",
    "droptype": "D",
    "dropname": "AKERS MILL",
    "dropdeladd": "2997 COBB PKWY SE STE 300",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303399997,
    "dropphyadd": "2997 COBB PKWY SE STE 300",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303399997,
    "dropmaladd": "2997 COBB PKWY SE STE 300",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303399997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709524746,
    "dropsitcph": 7709524746,
    "dropfax": 7709849077
  },
  {
    "dcode": "D",
    "dropkey": "SX10364",
    "droptype": "D",
    "dropname": "DOWNTOWN",
    "dropdeladd": "115 E HANCOCK AVE STE 100",
    "dropdelcty": "ATHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306019998,
    "dropphyadd": "115 E HANCOCK AVE STE 100",
    "dropphycty": "ATHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306019998,
    "dropmaladd": "PO BOX 80308",
    "dropmalcty": "ATHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306080308,
    "dropsitphn": 4047657578,
    "dropsitlph": 7063548178,
    "dropsitcph": 7063548066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10365",
    "droptype": "D",
    "dropname": "PHOENIX",
    "dropdeladd": "41 MARIETTA ST NW LBBY",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303039997,
    "dropphyadd": "41 MARIETTA ST NW LBBY",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303039997,
    "dropmaladd": "41 MARIETTA ST NW LBBY",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303039997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045242963,
    "dropsitcph": 4043059037,
    "dropfax": 4045228905
  },
  {
    "dcode": "D",
    "dropkey": "SX10366",
    "droptype": "D",
    "dropname": "DOWNTOWN COLUMBUS",
    "dropdeladd": "120 12TH ST LBBY",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319019998,
    "dropphyadd": "120 12TH ST LBBY",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319019998,
    "dropmaladd": "120 12TH ST LBBY",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7063170026,
    "dropsitcph": 7063170026,
    "dropfax": 7065968776
  },
  {
    "dcode": "D",
    "dropkey": "SX10368",
    "droptype": "D",
    "dropname": "DRUID HILLS",
    "dropdeladd": "1799 BRIARCLIFF RD NE FRNT",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303339998,
    "dropphyadd": "1799 BRIARCLIFF RD NE FRNT",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303339998,
    "dropmaladd": "1799 BRIARCLIFF RD NE FRNT",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303339998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4048980752,
    "dropsitcph": 4046344650,
    "dropfax": 4046077426
  },
  {
    "dcode": "D",
    "dropkey": "SX10384",
    "droptype": "D",
    "dropname": "EAST ATLANTA",
    "dropdeladd": "1273 METROPOLITAN AVE SE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303169998,
    "dropphyadd": "1273 METROPOLITAN AVE SE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303169998,
    "dropmaladd": "1273 METROPOLITAN AVE SE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303169998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045244752,
    "dropsitcph": 4045212064,
    "dropfax": 4045223351
  },
  {
    "dcode": "D",
    "dropkey": "SX10392",
    "droptype": "D",
    "dropname": "EAST SIDE",
    "dropdeladd": "1119 E MORRIS ST",
    "dropdelcty": "DALTON",
    "dropdelst": "GA",
    "dropdelzpp": 307219998,
    "dropphyadd": "1119 E MORRIS ST",
    "dropphycty": "DALTON",
    "dropphyst": "GA",
    "dropphyzpp": 307219998,
    "dropmaladd": "1119 E MORRIS ST",
    "dropmalcty": "DALTON",
    "dropmalst": "GA",
    "dropmalzpp": 307219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7062794195,
    "dropsitcph": 7062791329,
    "dropfax": 7062786458
  },
  {
    "dcode": "D",
    "dropkey": "SX10395",
    "droptype": "D",
    "dropname": "EASTWOOD",
    "dropdeladd": "1926 HOSEA L WILLIAMS DR NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303179998,
    "dropphyadd": "1926 HOSEA L WILLIAMS DR NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303179998,
    "dropmaladd": "1926 HOSEA L WILLIAMS DR NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303179998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043701172,
    "dropsitcph": 4043732164,
    "dropfax": 4043779889
  },
  {
    "dcode": "D",
    "dropkey": "SX10452",
    "droptype": "D",
    "dropname": "FEDERAL RESERVE",
    "dropdeladd": "1000 PEACHTREE ST NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303093904,
    "dropphyadd": "1000 PEACHTREE ST NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303093904,
    "dropmaladd": "400 PRYOR ST SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303039998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045771208,
    "dropsitcph": 4045771208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10453",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "345 W BROAD AVE FRNT",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317019990,
    "dropphyadd": "345 W BROAD AVE FRNT",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317019990,
    "dropmaladd": "345 W BROAD AVE FRNT",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317019990,
    "dropsitphn": 4787528444,
    "dropsitlph": 2294325923,
    "dropsitcph": 2294325923,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10540",
    "droptype": "D",
    "dropname": "GLENRIDGE",
    "dropdeladd": "5400 GLENRIDGE DR",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303424937,
    "dropphyadd": "5400 GLENRIDGE DR",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303424937,
    "dropmaladd": "5400 GLENRIDGE DR",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303424937,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042522651,
    "dropsitcph": 4042561977,
    "dropfax": 4042524389
  },
  {
    "dcode": "D",
    "dropkey": "SX10568",
    "droptype": "D",
    "dropname": "GRESHAM ROAD",
    "dropdeladd": "1290 GRESHAM RD",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300629997,
    "dropphyadd": "1290 GRESHAM RD",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300629997,
    "dropmaladd": "1290 GRESHAM RD",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300629997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703210461,
    "dropsitcph": 7703219016,
    "dropfax": 7709730942
  },
  {
    "dcode": "D",
    "dropkey": "SX10577",
    "droptype": "D",
    "dropname": "GWINNETT MALL CORNERS",
    "dropdeladd": "3628 SATELLITE BLVD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300969997,
    "dropphyadd": "3628 SATELLITE BLVD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300969997,
    "dropmaladd": "3628 SATELLITE BLVD",
    "dropmalcty": "DULUTH",
    "dropmalst": "GA",
    "dropmalzpp": 300969997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708138824,
    "dropsitcph": 7704979228,
    "dropfax": 7706239435
  },
  {
    "dcode": "D",
    "dropkey": "SX10639",
    "droptype": "D",
    "dropname": "HOWELL MILL",
    "dropdeladd": "1984 HOWELL MILL RD NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303279998,
    "dropphyadd": "1984 HOWELL MILL RD NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303279998,
    "dropmaladd": "1984 HOWELL MILL RD NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303279998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4046099568,
    "dropsitcph": 4043509193,
    "dropfax": 4043558845
  },
  {
    "dcode": "D",
    "dropkey": "SX10650",
    "droptype": "D",
    "dropname": "INDUSTRIAL",
    "dropdeladd": "5686 FULTON INDUSTRIAL BLVD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303369998,
    "dropphyadd": "5686 FULTON INDUSTRIAL BLVD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303369998,
    "dropmaladd": "5686 FULTON INDUSTRIAL BLVD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303369998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4046299799,
    "dropsitcph": 4043444266,
    "dropfax": 4043442202
  },
  {
    "dcode": "D",
    "dropkey": "SX10700",
    "droptype": "D",
    "dropname": "LAFAYETTE PLAZA",
    "dropdeladd": "2823 MEREDYTH DR",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317079998,
    "dropphyadd": "2823 MEREDYTH DR",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317079998,
    "dropmaladd": "2823 MEREDYTH DR",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317079998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298898721,
    "dropsitcph": 2298898721,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10710",
    "droptype": "D",
    "dropname": "LAKEWOOD",
    "dropdeladd": "1590 JONESBORO RD SE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303159998,
    "dropphyadd": "1590 JONESBORO RD SE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303159998,
    "dropmaladd": "1590 JONESBORO RD SE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303159998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045235245,
    "dropsitcph": 4045234922,
    "dropfax": 4045248349
  },
  {
    "dcode": "D",
    "dropkey": "SX10724",
    "droptype": "D",
    "dropname": "BUCKHEAD LOOP",
    "dropdeladd": "3495 BUCKHEAD LOOP NE STE 115",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303269997,
    "dropphyadd": "3495 BUCKHEAD LOOP NE STE 115",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303269997,
    "dropmaladd": "3495 BUCKHEAD LOOP NE STE 115",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303269997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4048421740,
    "dropsitcph": 4048169486,
    "dropfax": 4048697743
  },
  {
    "dcode": "D",
    "dropkey": "SX10734",
    "droptype": "D",
    "dropname": "LINDSEY CREEK",
    "dropdeladd": "3465 MACON RD STE E",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319079991,
    "dropphyadd": "3465 MACON RD STE E",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319079991,
    "dropmaladd": "3465 MACON RD STE E",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319079991,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065637269,
    "dropsitcph": 7065637269,
    "dropfax": 7065637269
  },
  {
    "dcode": "D",
    "dropkey": "SX10739",
    "droptype": "D",
    "dropname": "LITTLE FIVE POINTS",
    "dropdeladd": "455 MORELAND AVE NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303079997,
    "dropphyadd": "455 MORELAND AVE NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303079997,
    "dropmaladd": "455 MORELAND AVE NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303079997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045250656,
    "dropsitcph": 4048925880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10816",
    "droptype": "D",
    "dropname": "MEMORIAL",
    "dropdeladd": "5152 MEMORIAL DR STE 101",
    "dropdelcty": "STONE MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 300839997,
    "dropphyadd": "5152 MEMORIAL DR STE 101",
    "dropphycty": "STONE MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 300839997,
    "dropmaladd": "5152 MEMORIAL DR STE 101",
    "dropmalcty": "STONE MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 300839997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045088536,
    "dropsitcph": 4045084604,
    "dropfax": 4045088645
  },
  {
    "dcode": "D",
    "dropkey": "SX10822",
    "droptype": "D",
    "dropname": "EAST COBB",
    "dropdeladd": "1395 E COBB DR",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300689997,
    "dropphyadd": "1395 E COBB DR",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300689997,
    "dropmaladd": "1395 E COBB DR",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300689997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703210959,
    "dropsitcph": 7703210168,
    "dropfax": 7705781615
  },
  {
    "dcode": "D",
    "dropkey": "SX10840",
    "droptype": "D",
    "dropname": "MOCK ROAD",
    "dropdeladd": "328 S MOCK RD",
    "dropdelcty": "ALBANY",
    "dropdelst": "GA",
    "dropdelzpp": 317059998,
    "dropphyadd": "328 S MOCK RD",
    "dropphycty": "ALBANY",
    "dropphyst": "GA",
    "dropphyzpp": 317059998,
    "dropmaladd": "328 S MOCK RD",
    "dropmalcty": "ALBANY",
    "dropmalst": "GA",
    "dropmalzpp": 317059998,
    "dropsitphn": 4787528444,
    "dropsitlph": 2298883611,
    "dropsitcph": 2298891660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10854",
    "droptype": "D",
    "dropname": "MORRIS BROWN",
    "dropdeladd": "50 SUNSET AVE NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303144123,
    "dropphyadd": "50 SUNSET AVE NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303144123,
    "dropmaladd": "50 SUNSET AVE NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303144123,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047955381,
    "dropsitcph": 4043029470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10866",
    "droptype": "D",
    "dropname": "MOUNTAIN PARK",
    "dropdeladd": "1785 E PARK PLACE BLVD STE 201",
    "dropdelcty": "STONE MOUNTAIN",
    "dropdelst": "GA",
    "dropdelzpp": 300879998,
    "dropphyadd": "1785 E PARK PLACE BLVD STE 201",
    "dropphycty": "STONE MOUNTAIN",
    "dropphyst": "GA",
    "dropphyzpp": 300879998,
    "dropmaladd": "1785 E PARK PLACE BLVD STE 201",
    "dropmalcty": "STONE MOUNTAIN",
    "dropmalst": "GA",
    "dropmalzpp": 300879998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708797143,
    "dropsitcph": 7708796417,
    "dropfax": 7704692826
  },
  {
    "dcode": "D",
    "dropkey": "SX10875",
    "droptype": "D",
    "dropname": "MULBERRY",
    "dropdeladd": "475 MULBERRY ST LBBY",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312019998,
    "dropphyadd": "475 MULBERRY ST LBBY",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312019998,
    "dropmaladd": "475 MULBERRY ST LBBY",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312019998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787411832,
    "dropsitcph": 4787411832,
    "dropfax": 4787528601
  },
  {
    "dcode": "D",
    "dropkey": "SX10909",
    "droptype": "D",
    "dropname": "NORTH CORNERS",
    "dropdeladd": "918 JOE FRANK HARRIS PKWY SE",
    "dropdelcty": "CARTERSVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 301209997,
    "dropphyadd": "918 JOE FRANK HARRIS PKWY SE",
    "dropphycty": "CARTERSVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 301209997,
    "dropmaladd": "918 JOE FRANK HARRIS PKWY SE",
    "dropmalcty": "CARTERSVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 301209997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703825121,
    "dropsitcph": 7703829369,
    "dropfax": 7703827415
  },
  {
    "dcode": "D",
    "dropkey": "SX10911",
    "droptype": "D",
    "dropname": "NORTH DECATUR",
    "dropdeladd": "2048 LAWRENCEVILLE HWY",
    "dropdelcty": "DECATUR",
    "dropdelst": "GA",
    "dropdelzpp": 300339998,
    "dropphyadd": "2048 LAWRENCEVILLE HWY",
    "dropphycty": "DECATUR",
    "dropphyst": "GA",
    "dropphyzpp": 300339998,
    "dropmaladd": "2048 LAWRENCEVILLE HWY",
    "dropmalcty": "DECATUR",
    "dropmalst": "GA",
    "dropmalzpp": 300339998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4043151085,
    "dropsitcph": 4043151085,
    "dropfax": 4046344601
  },
  {
    "dcode": "D",
    "dropkey": "SX10913",
    "droptype": "D",
    "dropname": "NORTH HIGHLAND",
    "dropdeladd": "1190 N HIGHLAND AVE NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303069997,
    "dropphyadd": "1190 N HIGHLAND AVE NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303069997,
    "dropmaladd": "1190 N HIGHLAND AVE NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303069997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4048765052,
    "dropsitcph": 4048925880,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10918",
    "droptype": "D",
    "dropname": "NORTH SPRINGS",
    "dropdeladd": "7527 ROSWELL RD",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303509997,
    "dropphyadd": "7527 ROSWELL RD",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303509997,
    "dropmaladd": "PO BOX 566010",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 311569998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707308128,
    "dropsitcph": 7706490850,
    "dropfax": 7703960947
  },
  {
    "dcode": "D",
    "dropkey": "SX10922",
    "droptype": "D",
    "dropname": "NORTHLAKE",
    "dropdeladd": "3212 NORTHLAKE PKWY NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303459997,
    "dropphyadd": "3212 NORTHLAKE PKWY NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303459997,
    "dropmaladd": "3212 NORTHLAKE PKWY NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303459997,
    "dropsitphn": 4047923125,
    "dropsitlph": 7709344796,
    "dropsitcph": 4047289547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10924",
    "droptype": "D",
    "dropname": "NORTHRIDGE",
    "dropdeladd": "1185 HIGHTOWER TRL",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303502997,
    "dropphyadd": "1185 HIGHTOWER TRL",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303502997,
    "dropmaladd": "1185 HIGHTOWER TRL",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303502997,
    "dropsitphn": 4047657578,
    "dropsitlph": 6783174198,
    "dropsitcph": 7706490834,
    "dropfax": 7706406837
  },
  {
    "dcode": "D",
    "dropkey": "SX10926",
    "droptype": "D",
    "dropname": "NORTHSIDE WARNER ROBINS",
    "dropdeladd": "200 N DAVIS DR",
    "dropdelcty": "WARNER ROBINS",
    "dropdelst": "GA",
    "dropdelzpp": 310939998,
    "dropphyadd": "200 N DAVIS DR",
    "dropphycty": "WARNER ROBINS",
    "dropphyst": "GA",
    "dropphyzpp": 310939998,
    "dropmaladd": "200 N DAVIS DR",
    "dropmalcty": "WARNER ROBINS",
    "dropmalst": "GA",
    "dropmalzpp": 310939998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 4789221708,
    "dropfax": 4789227913
  },
  {
    "dcode": "D",
    "dropkey": "SX10928",
    "droptype": "D",
    "dropname": "PHARR ROAD",
    "dropdeladd": "575 PHARR RD NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303556000,
    "dropphyadd": "575 PHARR RD NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303556000,
    "dropmaladd": "575 PHARR RD NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303556000,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042399281,
    "dropsitcph": 4042390954,
    "dropfax": 4042399313
  },
  {
    "dcode": "D",
    "dropkey": "SX10944",
    "droptype": "D",
    "dropname": "OGLETHORPE",
    "dropdeladd": "1348 EISENHOWER DR",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314069998,
    "dropphyadd": "1348 EISENHOWER DR",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314069998,
    "dropmaladd": "1348 EISENHOWER DR",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9126627558,
    "dropsitcph": 9123510640,
    "dropfax": 9123528902
  },
  {
    "dcode": "D",
    "dropkey": "SX10948",
    "droptype": "D",
    "dropname": "OLD NATIONAL",
    "dropdeladd": "2385 GODBY RD",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303495042,
    "dropphyadd": "2385 GODBY RD",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303495042,
    "dropmaladd": "2385 GODBY RD",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303495042,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045591186,
    "dropsitcph": 4045598539,
    "dropfax": 4047659711
  },
  {
    "dcode": "D",
    "dropkey": "SX10949",
    "droptype": "D",
    "dropname": "OLDE TOWN",
    "dropdeladd": "1007 GREEN ST SE",
    "dropdelcty": "CONYERS",
    "dropdelst": "GA",
    "dropdelzpp": 300129998,
    "dropphyadd": "1007 GREEN ST SE",
    "dropphycty": "CONYERS",
    "dropphyst": "GA",
    "dropphyzpp": 300129998,
    "dropmaladd": "1007 GREEN ST SE",
    "dropmalcty": "CONYERS",
    "dropmalst": "GA",
    "dropmalzpp": 300129998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709290569,
    "dropsitcph": 7709225311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10961",
    "droptype": "D",
    "dropname": "PARK PLACE",
    "dropdeladd": "7147 JONESBORO RD STE B",
    "dropdelcty": "MORROW",
    "dropdelst": "GA",
    "dropdelzpp": 302602962,
    "dropphyadd": "7147 JONESBORO RD STE B",
    "dropphycty": "MORROW",
    "dropphyst": "GA",
    "dropphyzpp": 302602962,
    "dropmaladd": "1600 LAKE HARBIN RD",
    "dropmalcty": "MORROW",
    "dropmalst": "GA",
    "dropmalzpp": 302601742,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709689685,
    "dropsitcph": 7709611524,
    "dropfax": 7709610237
  },
  {
    "dcode": "D",
    "dropkey": "SX10965",
    "droptype": "D",
    "dropname": "CROGAN STREET",
    "dropdeladd": "121 E CROGAN ST",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300469998,
    "dropphyadd": "121 E CROGAN ST",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300469998,
    "dropmaladd": "121 E CROGAN ST",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300469998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709624106,
    "dropsitcph": 7702375392,
    "dropfax": 7709634003
  },
  {
    "dcode": "D",
    "dropkey": "SX10969",
    "droptype": "D",
    "dropname": "PEACHTREE CENTER",
    "dropdeladd": "240 PEACHTREE ST NW BSMT",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303039996,
    "dropphyadd": "240 PEACHTREE ST NW BSMT",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303039996,
    "dropmaladd": "240 PEACHTREE ST NW BSMT",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303039996,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045234855,
    "dropsitcph": 4042229255,
    "dropfax": 4045299912
  },
  {
    "dcode": "D",
    "dropkey": "SX10972",
    "droptype": "D",
    "dropname": "PEACHTREE CORNERS",
    "dropdeladd": "5600 SPALDING DR",
    "dropdelcty": "PEACHTREE CORNERS",
    "dropdelst": "GA",
    "dropdelzpp": 300929998,
    "dropphyadd": "5600 SPALDING DR",
    "dropphycty": "PEACHTREE CORNERS",
    "dropphyst": "GA",
    "dropphyzpp": 300929998,
    "dropmaladd": "5600 SPALDING DR",
    "dropmalcty": "PEACHTREE CORNERS",
    "dropmalst": "GA",
    "dropmalzpp": 300929998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704097969,
    "dropsitcph": 7704097976,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX10999",
    "droptype": "D",
    "dropname": "PIO NONO",
    "dropdeladd": "1040 PIO NONO AVE",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312049998,
    "dropphyadd": "1040 PIO NONO AVE",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312049998,
    "dropmaladd": "1040 PIO NONO AVE",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 4787452839,
    "dropfax": 4787528601
  },
  {
    "dcode": "D",
    "dropkey": "SX11058",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "2720 RIVERSIDE DR STE 124",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312049997,
    "dropphyadd": "2720 RIVERSIDE DR STE 124",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312049997,
    "dropmaladd": "2720 RIVERSIDE DR STE 124",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312049997,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787460129,
    "dropsitcph": 4787460129,
    "dropfax": 4787528601
  },
  {
    "dcode": "D",
    "dropkey": "SX11069",
    "droptype": "D",
    "dropname": "ROCKBRIDGE",
    "dropdeladd": "4771 BRITT RD STE G4",
    "dropdelcty": "NORCROSS",
    "dropdelst": "GA",
    "dropdelzpp": 300939998,
    "dropphyadd": "4771 BRITT RD STE G4",
    "dropphycty": "NORCROSS",
    "dropphyst": "GA",
    "dropphyzpp": 300939998,
    "dropmaladd": "4771 BRITT RD STE G4",
    "dropmalcty": "NORCROSS",
    "dropmalst": "GA",
    "dropmalzpp": 300939998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704919411,
    "dropsitcph": 7704919411,
    "dropfax": 7709342216
  },
  {
    "dcode": "D",
    "dropkey": "SX11146",
    "droptype": "D",
    "dropname": "EASTSIDE",
    "dropdeladd": "1900 E VICTORY DR STE 3",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314049998,
    "dropphyadd": "1900 E VICTORY DR STE 3",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314049998,
    "dropmaladd": "1900 E VICTORY DR STE 3",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122320914,
    "dropsitcph": 9122320914,
    "dropfax": 9122322108
  },
  {
    "dcode": "D",
    "dropkey": "SX11165",
    "droptype": "D",
    "dropname": "SOUTH DEKALB",
    "dropdeladd": "2853 CANDLER RD SIDE",
    "dropdelcty": "DECATUR",
    "dropdelst": "GA",
    "dropdelzpp": 300349997,
    "dropphyadd": "2853 CANDLER RD SIDE",
    "dropphycty": "DECATUR",
    "dropphyst": "GA",
    "dropphyzpp": 300349997,
    "dropmaladd": "2853 CANDLER RD SIDE",
    "dropmalcty": "DECATUR",
    "dropmalst": "GA",
    "dropmalzpp": 300349997,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042412271,
    "dropsitcph": 4042412271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11167",
    "droptype": "D",
    "dropname": "SOUTH MACON",
    "dropdeladd": "1740 ROCKY CREEK RD",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312069998,
    "dropphyadd": "1740 ROCKY CREEK RD",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312069998,
    "dropmaladd": "1740 ROCKY CREEK RD",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787843994,
    "dropsitcph": 4787843994,
    "dropfax": 4787843903
  },
  {
    "dcode": "D",
    "dropkey": "SX11171",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "10701 ABERCORN ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314199998,
    "dropphyadd": "10701 ABERCORN ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314199998,
    "dropmaladd": "10701 ABERCORN ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314199998,
    "dropsitphn": 9122354587,
    "dropsitlph": 9128986360,
    "dropsitcph": 9129259082,
    "dropfax": 9129202910
  },
  {
    "dcode": "D",
    "dropkey": "SX11176",
    "droptype": "D",
    "dropname": "SPRAYBERRY",
    "dropdeladd": "2886 SANDY PLAINS RD",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300669998,
    "dropphyadd": "2886 SANDY PLAINS RD",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300669998,
    "dropmaladd": "2886 SANDY PLAINS RD",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300669998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7703210418,
    "dropsitcph": 7703219136,
    "dropfax": 7709737477
  },
  {
    "dcode": "D",
    "dropkey": "SX11266",
    "droptype": "D",
    "dropname": "HILL STATION",
    "dropdeladd": "1434 STOVALL ST",
    "dropdelcty": "AUGUSTA",
    "dropdelst": "GA",
    "dropdelzpp": 309049998,
    "dropphyadd": "1434 STOVALL ST",
    "dropphycty": "AUGUSTA",
    "dropphyst": "GA",
    "dropphyzpp": 309049998,
    "dropmaladd": "1434 STOVALL ST",
    "dropmalcty": "AUGUSTA",
    "dropmalst": "GA",
    "dropmalzpp": 309049998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7067389822,
    "dropsitcph": 7067389822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11359",
    "droptype": "D",
    "dropname": "WESLEY CHAPEL",
    "dropdeladd": "2724 WESLEY CHAPEL RD",
    "dropdelcty": "DECATUR",
    "dropdelst": "GA",
    "dropdelzpp": 300349998,
    "dropphyadd": "2724 WESLEY CHAPEL RD",
    "dropphycty": "DECATUR",
    "dropphyst": "GA",
    "dropphyzpp": 300349998,
    "dropmaladd": "2724 WESLEY CHAPEL RD",
    "dropmalcty": "DECATUR",
    "dropmalst": "GA",
    "dropmalzpp": 300349998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042884108,
    "dropsitcph": 4042862559,
    "dropfax": 4042840712
  },
  {
    "dcode": "D",
    "dropkey": "SX11363",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "848 OGLETHORPE AVE SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303102799,
    "dropphyadd": "848 OGLETHORPE AVE SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303102799,
    "dropmaladd": "848 OGLETHORPE AVE SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303102799,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047560989,
    "dropsitcph": 4047554412,
    "dropfax": 4047538265
  },
  {
    "dcode": "D",
    "dropkey": "SX11370",
    "droptype": "D",
    "dropname": "WEST ROME",
    "dropdeladd": "2503 REDMOND CIR NW",
    "dropdelcty": "ROME",
    "dropdelst": "GA",
    "dropdelzpp": 301659997,
    "dropphyadd": "2503 REDMOND CIR NW",
    "dropphycty": "ROME",
    "dropphyst": "GA",
    "dropphyzpp": 301659997,
    "dropmaladd": "2503 REDMOND CIR NW",
    "dropmalcty": "ROME",
    "dropmalst": "GA",
    "dropmalzpp": 301659997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7062952843,
    "dropsitcph": 7062912958,
    "dropfax": 7062328005
  },
  {
    "dcode": "D",
    "dropkey": "SX11374",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "968 DAWSONVILLE HWY",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305019997,
    "dropphyadd": "968 DAWSONVILLE HWY",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305019997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305049998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705339508,
    "dropsitcph": 7707180647,
    "dropfax": 7705329397
  },
  {
    "dcode": "D",
    "dropkey": "SX11393",
    "droptype": "D",
    "dropname": "WINDY HILL",
    "dropdeladd": "3000 WINDY HILL RD SE STE T5",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300679997,
    "dropphyadd": "3000 WINDY HILL RD SE STE T5",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300679997,
    "dropmaladd": "3000 WINDY HILL RD SE STE T5",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300679997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708509256,
    "dropsitcph": 7708509054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11410",
    "droptype": "D",
    "dropname": "TELFAIR SQUARE",
    "dropdeladd": "118 BARNARD ST",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314019991,
    "dropphyadd": "118 BARNARD ST",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314019991,
    "dropmaladd": "118 BARNARD ST",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314019991,
    "dropsitphn": 4787528466,
    "dropsitlph": 9122322952,
    "dropsitcph": 9122322952,
    "dropfax": 9122385613
  },
  {
    "dcode": "D",
    "dropkey": "SX11413",
    "droptype": "D",
    "dropname": "WYNNTON",
    "dropdeladd": "1179 HENRY AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "GA",
    "dropdelzpp": 319069998,
    "dropphyadd": "1179 HENRY AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "GA",
    "dropphyzpp": 319069998,
    "dropmaladd": "1179 HENRY AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "GA",
    "dropmalzpp": 319069998,
    "dropsitphn": 4787528466,
    "dropsitlph": 7065968852,
    "dropsitcph": 7065968852,
    "dropfax": 7065765373
  },
  {
    "dcode": "D",
    "dropkey": "SX11512",
    "droptype": "D",
    "dropname": "ANDERSON",
    "dropdeladd": "1001 MAIN ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "IN",
    "dropdelzpp": 460169997,
    "dropphyadd": "1001 MAIN ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "IN",
    "dropphyzpp": 460169997,
    "dropmaladd": "1001 MAIN ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "IN",
    "dropmalzpp": 460169997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7656428036,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11514",
    "droptype": "D",
    "dropname": "BACON",
    "dropdeladd": "2727 E 55TH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462209998,
    "dropphyadd": "2727 E 55TH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462209998,
    "dropmaladd": "2727 E 55TH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462209998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646820,
    "dropfax": 3174646759
  },
  {
    "dcode": "D",
    "dropkey": "SX11663",
    "droptype": "D",
    "dropname": "BRIGHTWOOD",
    "dropdeladd": "2830 N SHERMAN DR",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462189998,
    "dropphyadd": "2830 N SHERMAN DR",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462189998,
    "dropmaladd": "2830 N SHERMAN DR",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462189998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646818,
    "dropfax": 3175410361
  },
  {
    "dcode": "D",
    "dropkey": "SX11675",
    "droptype": "D",
    "dropname": "BROAD RIPPLE",
    "dropdeladd": "6255 CARROLLTON AVE",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462209995,
    "dropphyadd": "6255 CARROLLTON AVE",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462209995,
    "dropmaladd": "6255 CARROLLTON AVE",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462209995,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11815",
    "droptype": "D",
    "dropname": "CENTENNIAL",
    "dropdeladd": "2525 INDEPENDENCE DR",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468089998,
    "dropphyadd": "2525 INDEPENDENCE DR",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468089998,
    "dropmaladd": "2525 INDEPENDENCE DR",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468089998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX11842",
    "droptype": "D",
    "dropname": "CHIPPEWA",
    "dropdeladd": "4015 S MAIN ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466149998,
    "dropphyadd": "4015 S MAIN ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466149998,
    "dropmaladd": "4015 S MAIN ST",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466149998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828500,
    "dropfax": 5742310486
  },
  {
    "dcode": "D",
    "dropkey": "SX11853",
    "droptype": "D",
    "dropname": "CIRCLE CITY",
    "dropdeladd": "456 N MERIDIAN ST STE X",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462049998,
    "dropphyadd": "456 N MERIDIAN ST STE X",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462049998,
    "dropmaladd": "456 N MERIDIAN ST STE X",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462049998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646825,
    "dropfax": 3174646600
  },
  {
    "dcode": "D",
    "dropkey": "SX12042",
    "droptype": "D",
    "dropname": "DIAMOND VALLEY",
    "dropdeladd": "600 CROSS VALLEY CIR",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477109998,
    "dropphyadd": "600 CROSS VALLEY CIR",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477109998,
    "dropmaladd": "600 CROSS VALLEY CIR",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477109998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124241830,
    "dropfax": 8124688176
  },
  {
    "dcode": "D",
    "dropkey": "SX12049",
    "droptype": "D",
    "dropname": "DIPLOMAT PLAZA",
    "dropdeladd": "4171 DIPLOMAT PLAZA CTR",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468064531,
    "dropphyadd": "4171 DIPLOMAT PLAZA CTR",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468064531,
    "dropmaladd": "4171 DIPLOMAT PLAZA CTR",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468064531,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277306,
    "dropfax": 2604479116
  },
  {
    "dcode": "D",
    "dropkey": "SX12062",
    "droptype": "D",
    "dropname": "DOWNTOWN LAFAYETTE",
    "dropdeladd": "230 N 4TH ST SIDE",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479011325,
    "dropphyadd": "230 N 4TH ST SIDE",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479011325,
    "dropmaladd": "230 N 4TH ST SIDE",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479011325,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12063",
    "droptype": "D",
    "dropname": "DOWNTOWN MUNCIE",
    "dropdeladd": "125 S FRANKLIN ST",
    "dropdelcty": "MUNCIE",
    "dropdelst": "IN",
    "dropdelzpp": 473059998,
    "dropphyadd": "125 S FRANKLIN ST",
    "dropphycty": "MUNCIE",
    "dropphyst": "IN",
    "dropphyzpp": 473059998,
    "dropmaladd": "125 S FRANKLIN ST",
    "dropmalcty": "MUNCIE",
    "dropmalst": "IN",
    "dropmalzpp": 473059998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7652869623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12064",
    "droptype": "D",
    "dropname": "DOWNTOWN VALPARAISO",
    "dropdeladd": "460 LINCOLNWAY",
    "dropdelcty": "VALPARAISO",
    "dropdelst": "IN",
    "dropdelzpp": 463859998,
    "dropphyadd": "460 LINCOLNWAY",
    "dropphycty": "VALPARAISO",
    "dropphyst": "IN",
    "dropphyzpp": 463859998,
    "dropmaladd": "460 LINCOLNWAY",
    "dropmalcty": "VALPARAISO",
    "dropmalst": "IN",
    "dropmalzpp": 463859998,
    "dropsitphn": 2194648407,
    "dropsitlph": 3174646350,
    "dropsitcph": 2194641637,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12106",
    "droptype": "D",
    "dropname": "EASTGATE",
    "dropdeladd": "740 N SHORTRIDGE RD",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462199998,
    "dropphyadd": "740 N SHORTRIDGE RD",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462199998,
    "dropmaladd": "740 N SHORTRIDGE RD",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462199998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646819,
    "dropfax": 3174646542
  },
  {
    "dcode": "D",
    "dropkey": "SX12117",
    "droptype": "D",
    "dropname": "EDISON PARK",
    "dropdeladd": "2417 EDISON RD",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466159998,
    "dropphyadd": "2417 EDISON RD",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466159998,
    "dropmaladd": "2417 EDISON RD",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466159998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828510,
    "dropfax": 5742873124
  },
  {
    "dcode": "D",
    "dropkey": "SX12195",
    "droptype": "D",
    "dropname": "15TH AVENUE",
    "dropdeladd": "1490 BROADWAY",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464079998,
    "dropphyadd": "1490 BROADWAY",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464079998,
    "dropmaladd": "1490 BROADWAY",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464079998,
    "dropsitphn": 2198826472,
    "dropsitlph": 2198868051,
    "dropsitcph": 2198826472,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12282",
    "droptype": "D",
    "dropname": "GARFIELD",
    "dropdeladd": "1636 E LEGRANDE AVE",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462039998,
    "dropphyadd": "1636 E LEGRANDE AVE",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462039998,
    "dropmaladd": "1636 E LEGRANDE AVE",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462039998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646813,
    "dropfax": 3174646543
  },
  {
    "dcode": "D",
    "dropkey": "SX12308",
    "droptype": "D",
    "dropname": "GLEN PARK",
    "dropdeladd": "320 E 40TH AVE",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464099998,
    "dropphyadd": "320 E 40TH AVE",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464099998,
    "dropmaladd": "320 E 40TH AVE",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464099998,
    "dropsitphn": 2194842043,
    "dropsitlph": 2198868051,
    "dropsitcph": 2194842043,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12405",
    "droptype": "D",
    "dropname": "HARBOR",
    "dropdeladd": "3813 MAIN ST",
    "dropdelcty": "EAST CHICAGO",
    "dropdelst": "IN",
    "dropdelzpp": 463122360,
    "dropphyadd": "3813 MAIN ST",
    "dropphycty": "EAST CHICAGO",
    "dropphyst": "IN",
    "dropphyzpp": 463122360,
    "dropmaladd": "3813 MAIN ST",
    "dropmalcty": "EAST CHICAGO",
    "dropmalst": "IN",
    "dropmalzpp": 463122360,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2193972417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12443",
    "droptype": "D",
    "dropname": "HAZELWOOD",
    "dropdeladd": "1800 HAZELWOOD AVE",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468059998,
    "dropphyadd": "1800 HAZELWOOD AVE",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468059998,
    "dropmaladd": "1800 HAZELWOOD AVE",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468059998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12462",
    "droptype": "D",
    "dropname": "HESSVILLE",
    "dropdeladd": "6530 KENNEDY AVE",
    "dropdelcty": "HAMMOND",
    "dropdelst": "IN",
    "dropdelzpp": 463239998,
    "dropphyadd": "6530 KENNEDY AVE",
    "dropphycty": "HAMMOND",
    "dropphyst": "IN",
    "dropphyzpp": 463239998,
    "dropmaladd": "6530 KENNEDY AVE",
    "dropmalcty": "HAMMOND",
    "dropmalst": "IN",
    "dropmalzpp": 463239998,
    "dropsitphn": 2198442416,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198442416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12670",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "308 E SYCAMORE ST",
    "dropdelcty": "KOKOMO",
    "dropdelst": "IN",
    "dropdelzpp": 469014826,
    "dropphyadd": "308 E SYCAMORE ST",
    "dropphycty": "KOKOMO",
    "dropphyst": "IN",
    "dropphyzpp": 469014826,
    "dropmaladd": "308 E SYCAMORE ST",
    "dropmalcty": "KOKOMO",
    "dropmalst": "IN",
    "dropmalzpp": 469014826,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654595190,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12728",
    "droptype": "D",
    "dropname": "LAWNDALE",
    "dropdeladd": "802 S GREEN RIVER RD",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477159998,
    "dropphyadd": "802 S GREEN RIVER RD",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477159998,
    "dropmaladd": "802 S GREEN RIVER RD",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477159998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124734151,
    "dropfax": 8124732488
  },
  {
    "dcode": "D",
    "dropkey": "SX12783",
    "droptype": "D",
    "dropname": "LINWOOD",
    "dropdeladd": "4401 E 10TH ST STE 18",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462019998,
    "dropphyadd": "4401 E 10TH ST STE 18",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462019998,
    "dropmaladd": "4401 E 10TH ST STE 18",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462019998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646810,
    "dropfax": 3174646545
  },
  {
    "dcode": "D",
    "dropkey": "SX12838",
    "droptype": "D",
    "dropname": "MAPLETON",
    "dropdeladd": "2650 DR MARTIN LUTHER KING JR ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462089998,
    "dropphyadd": "2650 DR MARTIN LUTHER KING JR ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462089998,
    "dropmaladd": "2650 DR MARTIN LUTHER KING JR ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462089998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646808,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12861",
    "droptype": "D",
    "dropname": "MARQUETTE MALL",
    "dropdeladd": "450 ST JOHN RD",
    "dropdelcty": "MICHIGAN CITY",
    "dropdelst": "IN",
    "dropdelzpp": 463607336,
    "dropphyadd": "450 ST JOHN RD",
    "dropphycty": "MICHIGAN CITY",
    "dropphyst": "IN",
    "dropphyzpp": 463607336,
    "dropmaladd": "450 ST JOHN RD STE 102",
    "dropmalcty": "MICHIGAN CITY",
    "dropmalst": "IN",
    "dropmalzpp": 463607373,
    "dropsitphn": 2198729163,
    "dropsitlph": 3174646350,
    "dropsitcph": 2198729163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX12951",
    "droptype": "D",
    "dropname": "MILLER",
    "dropdeladd": "518 S HANCOCK ST",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464039998,
    "dropphyadd": "518 S HANCOCK ST",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464039998,
    "dropmaladd": "518 S HANCOCK ST",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464039998,
    "dropsitphn": 2199389701,
    "dropsitlph": 2198868051,
    "dropsitcph": 2199389701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX13131",
    "droptype": "D",
    "dropname": "NORTH MADISON",
    "dropdeladd": "641 GREEN RD",
    "dropdelcty": "MADISON",
    "dropdelst": "IN",
    "dropdelzpp": 472502176,
    "dropphyadd": "641 GREEN RD",
    "dropphycty": "MADISON",
    "dropphyst": "IN",
    "dropphyzpp": 472502176,
    "dropmaladd": "641 GREEN RD",
    "dropmalcty": "MADISON",
    "dropmalst": "IN",
    "dropmalzpp": 472502176,
    "dropsitphn": 3174646305,
    "dropsitlph": 3174646350,
    "dropsitcph": 8122731188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX13145",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "6041 STELLHORN RD",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468155377,
    "dropphyadd": "6041 STELLHORN RD",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468155377,
    "dropmaladd": "6041 STELLHORN RD",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468155377,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277315,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX13197",
    "droptype": "D",
    "dropname": "OLIVE STREET",
    "dropdeladd": "150 S OLIVE ST",
    "dropdelcty": "SOUTH BEND",
    "dropdelst": "IN",
    "dropdelzpp": 466199998,
    "dropphyadd": "150 S OLIVE ST",
    "dropphycty": "SOUTH BEND",
    "dropphyst": "IN",
    "dropphyzpp": 466199998,
    "dropmaladd": "150 S OLIVE ST",
    "dropmalcty": "SOUTH BEND",
    "dropmalst": "IN",
    "dropmalzpp": 466199998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 5742828516,
    "dropfax": 5742873214
  },
  {
    "dcode": "D",
    "dropkey": "SX13396",
    "droptype": "D",
    "dropname": "RAINBOW",
    "dropdeladd": "3322 W 16TH ST",
    "dropdelcty": "INDIANAPOLIS",
    "dropdelst": "IN",
    "dropdelzpp": 462229998,
    "dropphyadd": "3322 W 16TH ST",
    "dropphycty": "INDIANAPOLIS",
    "dropphyst": "IN",
    "dropphyzpp": 462229998,
    "dropmaladd": "3322 W 16TH ST",
    "dropmalcty": "INDIANAPOLIS",
    "dropmalst": "IN",
    "dropmalzpp": 462229998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 3174646822,
    "dropfax": 3174646550
  },
  {
    "dcode": "D",
    "dropkey": "SX13436",
    "droptype": "D",
    "dropname": "RIVER CITY",
    "dropdeladd": "1915 WASHINGTON AVE",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477149998,
    "dropphyadd": "1915 WASHINGTON AVE",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477149998,
    "dropmaladd": "1915 WASHINGTON AVE",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477149998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124711966,
    "dropfax": 8124775852
  },
  {
    "dcode": "D",
    "dropkey": "SX13470",
    "droptype": "D",
    "dropname": "ROSE",
    "dropdeladd": "70 ROSE AVE",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478039998,
    "dropphyadd": "70 ROSE AVE",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478039998,
    "dropmaladd": "70 ROSE AVE",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478039998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122329133,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX13622",
    "droptype": "D",
    "dropname": "SOUTH CALUMET AVENUE",
    "dropdeladd": "7142 CALUMET AVE",
    "dropdelcty": "HAMMOND",
    "dropdelst": "IN",
    "dropdelzpp": 463242406,
    "dropphyadd": "7142 CALUMET AVE",
    "dropphycty": "HAMMOND",
    "dropphyst": "IN",
    "dropphyzpp": 463242406,
    "dropmaladd": "5530 SOHL AVE",
    "dropmalcty": "HAMMOND",
    "dropmalst": "IN",
    "dropmalzpp": 463209998,
    "dropsitphn": 2199320346,
    "dropsitlph": 3174646350,
    "dropsitcph": 2199320346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX13857",
    "droptype": "D",
    "dropname": "TOLLESTON",
    "dropdeladd": "2407 W 11TH AVE",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464049998,
    "dropphyadd": "2407 W 11TH AVE",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464049998,
    "dropmaladd": "2407 W 11TH AVE",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464049998,
    "dropsitphn": 2199447795,
    "dropsitlph": 2198868051,
    "dropsitcph": 2199447795,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX14003",
    "droptype": "D",
    "dropname": "WAYNEDALE",
    "dropdeladd": "7025 OLD TRAIL RD",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468099900,
    "dropphyadd": "7025 OLD TRAIL RD",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468099900,
    "dropmaladd": "7025 OLD TRAIL RD",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468099900,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277319,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX14029",
    "droptype": "D",
    "dropname": "WEST WABASH",
    "dropdeladd": "801 N WABASH AVE",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477129998,
    "dropphyadd": "801 N WABASH AVE",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477129998,
    "dropmaladd": "801 N WABASH AVE",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477129998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124236090,
    "dropfax": 8124254409
  },
  {
    "dcode": "D",
    "dropkey": "SX14230",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "2927 BROADWAY ST",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420019997,
    "dropphyadd": "2927 BROADWAY ST",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420019997,
    "dropmaladd": "PO BOX 7068",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420027068,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704422240,
    "dropfax": 2704445332
  },
  {
    "dcode": "D",
    "dropkey": "SX14266",
    "droptype": "D",
    "dropname": "BAXTER",
    "dropdeladd": "1527 HIGHLAND AVE",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402049997,
    "dropphyadd": "1527 HIGHLAND AVE",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402049997,
    "dropmaladd": "1527 HIGHLAND AVE",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402049997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025847018,
    "dropfax": 5025895715
  },
  {
    "dcode": "D",
    "dropkey": "SX14369",
    "droptype": "D",
    "dropname": "BLUEGRASS",
    "dropdeladd": "3525 LANSDOWNE DR",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405179998,
    "dropphyadd": "3525 LANSDOWNE DR",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405179998,
    "dropmaladd": "3525 LANSDOWNE DR",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592713281,
    "dropfax": 8592722790
  },
  {
    "dcode": "D",
    "dropkey": "SX14415",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "3160 IRVIN COBB DR",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420030300,
    "dropphyadd": "3160 IRVIN COBB DR",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420030300,
    "dropmaladd": "PO BOX 3385",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420023385,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704432331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX14582",
    "droptype": "D",
    "dropname": "CHEROKEE",
    "dropdeladd": "2240 TAYLORSVILLE RD STE 1",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402059997,
    "dropphyadd": "2240 TAYLORSVILLE RD STE 1",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402059997,
    "dropmaladd": "2240 TAYLORSVILLE RD STE 1",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402059997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024598015,
    "dropfax": 5024598034
  },
  {
    "dcode": "D",
    "dropkey": "SX14832",
    "droptype": "D",
    "dropname": "DOWNTOWN LOUISVILLE",
    "dropdeladd": "835 S 7TH ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402039998,
    "dropphyadd": "835 S 7TH ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402039998,
    "dropmaladd": "835 S 7TH ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402039998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5025878546,
    "dropfax": 5025612869
  },
  {
    "dcode": "D",
    "dropkey": "SX14834",
    "droptype": "D",
    "dropname": "DR MARTIN LUTHER KING JR",
    "dropdeladd": "2727 W BROADWAY",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402119998,
    "dropphyadd": "2727 W BROADWAY",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402119998,
    "dropmaladd": "2727 W BROADWAY",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402119998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5027787810,
    "dropfax": 5027729030
  },
  {
    "dcode": "D",
    "dropkey": "SX15091",
    "droptype": "D",
    "dropname": "GARDENSIDE",
    "dropdeladd": "1729 ALEXANDRIA DR",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405049998,
    "dropphyadd": "1729 ALEXANDRIA DR",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405049998,
    "dropmaladd": "1729 ALEXANDRIA DR",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592786425,
    "dropfax": 8592760263
  },
  {
    "dcode": "D",
    "dropkey": "SX15296",
    "droptype": "D",
    "dropname": "HENRY CLAY",
    "dropdeladd": "365 DUKE RD STE A",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405029998,
    "dropphyadd": "365 DUKE RD STE A",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405029998,
    "dropmaladd": "365 DUKE RD STE A",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405029998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592669521,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX15319",
    "droptype": "D",
    "dropname": "HIKES POINT",
    "dropdeladd": "3050 HUNSINGER LN",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402209998,
    "dropphyadd": "3050 HUNSINGER LN",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402209998,
    "dropmaladd": "3050 HUNSINGER LN",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402209998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024564557,
    "dropfax": 5024598629
  },
  {
    "dcode": "D",
    "dropkey": "SX15397",
    "droptype": "D",
    "dropname": "IROQUOIS",
    "dropdeladd": "4772 ALLMOND AVE",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402099998,
    "dropphyadd": "4772 ALLMOND AVE",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402099998,
    "dropmaladd": "4772 ALLMOND AVE",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402099998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023688911,
    "dropfax": 5023665839
  },
  {
    "dcode": "D",
    "dropkey": "SX15580",
    "droptype": "D",
    "dropname": "LIBERTY ROAD",
    "dropdeladd": "2041 CREATIVE DR STE 100",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405059998,
    "dropphyadd": "2041 CREATIVE DR STE 100",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405059998,
    "dropmaladd": "2041 CREATIVE DR STE 100",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405059998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592556995,
    "dropfax": 8592543092
  },
  {
    "dcode": "D",
    "dropkey": "SX15675",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "104 MAIN ST",
    "dropdelcty": "PIKEVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 415011175,
    "dropphyadd": "104 MAIN ST",
    "dropphycty": "PIKEVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 415011175,
    "dropmaladd": "104 MAIN ST",
    "dropmalcty": "PIKEVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 415011175,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6064322146,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX16346",
    "droptype": "D",
    "dropname": "SHELBY",
    "dropdeladd": "2312 S PRESTON ST",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402179998,
    "dropphyadd": "2312 S PRESTON ST",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402179998,
    "dropmaladd": "2312 S PRESTON ST",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402179998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5026362524,
    "dropfax": 5026348713
  },
  {
    "dcode": "D",
    "dropkey": "SX16929",
    "droptype": "D",
    "dropname": "ALLEGHENY",
    "dropdeladd": "395 FEDERAL ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152129998,
    "dropphyadd": "395 FEDERAL ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152129998,
    "dropmaladd": "395 FEDERAL ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152129998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4122314691,
    "dropsitcph": 4122314691,
    "dropfax": 4122318732
  },
  {
    "dcode": "D",
    "dropkey": "SX17006",
    "droptype": "D",
    "dropname": "ARSENAL",
    "dropdeladd": "186 42ND ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152019998,
    "dropphyadd": "186 42ND ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152019998,
    "dropmaladd": "186 42ND ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152019998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126824297,
    "dropsitcph": 4126824297,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17050",
    "droptype": "D",
    "dropname": "B FREE FRANKLIN",
    "dropdeladd": "316 MARKET ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191069996,
    "dropphyadd": "316 MARKET ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191069996,
    "dropmaladd": "316 MARKET ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191069996,
    "dropsitphn": 2158958856,
    "dropsitlph": 2155921292,
    "dropsitcph": 2155921292,
    "dropfax": 2159251967
  },
  {
    "dcode": "D",
    "dropkey": "SX17251",
    "droptype": "D",
    "dropname": "BLOOMFIELD",
    "dropdeladd": "5182 LIBERTY AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152249998,
    "dropphyadd": "5182 LIBERTY AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152249998,
    "dropmaladd": "5182 LIBERTY AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152249998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126824572,
    "dropsitcph": 4126824572,
    "dropfax": 4126825104
  },
  {
    "dcode": "D",
    "dropkey": "SX17354",
    "droptype": "D",
    "dropname": "BRIDESBURG",
    "dropdeladd": "2734 ORTHODOX ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191379998,
    "dropphyadd": "2734 ORTHODOX ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191379998,
    "dropmaladd": "2734 ORTHODOX ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191379998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155338010,
    "dropsitcph": 2155338010,
    "dropfax": 2155331480
  },
  {
    "dcode": "D",
    "dropkey": "SX17384",
    "droptype": "D",
    "dropname": "BROOKLINE",
    "dropdeladd": "612 BROOKLINE BLVD",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152269998,
    "dropphyadd": "612 BROOKLINE BLVD",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152269998,
    "dropmaladd": "612 BROOKLINE BLVD",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152269998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4125319704,
    "dropsitcph": 4125319704,
    "dropfax": 4125317504
  },
  {
    "dcode": "D",
    "dropkey": "SX17457",
    "droptype": "D",
    "dropname": "BUSTLETON",
    "dropdeladd": "9925 BUSTLETON AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191159998,
    "dropphyadd": "9925 BUSTLETON AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191159998,
    "dropmaladd": "9925 BUSTLETON AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191159998,
    "dropsitphn": 2156731275,
    "dropsitlph": 2156731275,
    "dropsitcph": 2156731275,
    "dropfax": 2156764534
  },
  {
    "dcode": "D",
    "dropkey": "SX17515",
    "droptype": "D",
    "dropname": "CARSON",
    "dropdeladd": "1731 E CARSON ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152039998,
    "dropphyadd": "1731 E CARSON ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152039998,
    "dropmaladd": "1731 E CARSON ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152039998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124311057,
    "dropsitcph": 4124311057,
    "dropfax": 4124811694
  },
  {
    "dcode": "D",
    "dropkey": "SX17533",
    "droptype": "D",
    "dropname": "CASTOR",
    "dropdeladd": "6382 CASTOR AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191499997,
    "dropphyadd": "6382 CASTOR AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191499997,
    "dropmaladd": "6382 CASTOR AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191499997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156247755,
    "dropsitcph": 2156247755,
    "dropfax": 2153312953
  },
  {
    "dcode": "D",
    "dropkey": "SX17557",
    "droptype": "D",
    "dropname": "CENTER CITY",
    "dropdeladd": "621 HEPBURN ST UNIT 2",
    "dropdelcty": "WILLIAMSPORT",
    "dropdelst": "PA",
    "dropdelzpp": 177015006,
    "dropphyadd": "621 HEPBURN ST UNIT 2",
    "dropphycty": "WILLIAMSPORT",
    "dropphyst": "PA",
    "dropphyzpp": 177015006,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "WILLIAMSPORT",
    "dropmalst": "PA",
    "dropmalzpp": 177039998,
    "dropsitphn": 7172574870,
    "dropsitlph": 5703204162,
    "dropsitcph": 5703230912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17572",
    "droptype": "D",
    "dropname": "CENTRAL WASHINGTON",
    "dropdeladd": "28 N MAIN ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "PA",
    "dropdelzpp": 153014525,
    "dropphyadd": "28 N MAIN ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "PA",
    "dropphyzpp": 153014525,
    "dropmaladd": "28 N MAIN ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "PA",
    "dropmalzpp": 153014525,
    "dropsitphn": 4123597568,
    "dropsitlph": 7242251709,
    "dropsitcph": 7242221709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17623",
    "droptype": "D",
    "dropname": "CHESTNUT HILL",
    "dropdeladd": "8225 GERMANTOWN AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191189997,
    "dropphyadd": "8225 GERMANTOWN AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191189997,
    "dropmaladd": "8225 GERMANTOWN AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191189997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2152481503,
    "dropsitcph": 2152481503,
    "dropfax": 2152476147
  },
  {
    "dcode": "D",
    "dropkey": "SX17749",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "1301 CALLOWHILL ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191239996,
    "dropphyadd": "1301 CALLOWHILL ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191239996,
    "dropmaladd": "1301 CALLOWHILL ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191239996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155921294,
    "dropsitcph": 2155921294,
    "dropfax": 2157636408
  },
  {
    "dcode": "D",
    "dropkey": "SX17770",
    "droptype": "D",
    "dropname": "CONTINENTAL",
    "dropdeladd": "615 CHESTNUT ST LBBY",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191069997,
    "dropphyadd": "615 CHESTNUT ST LBBY",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191069997,
    "dropmaladd": "615 CHESTNUT ST LBBY",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191069997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2154133516,
    "dropsitcph": 2154133516,
    "dropfax": 2155927749
  },
  {
    "dcode": "D",
    "dropkey": "SX17989",
    "droptype": "D",
    "dropname": "DOWNTOWN ERIE",
    "dropdeladd": "1401 STATE ST STE 100",
    "dropdelcty": "ERIE",
    "dropdelst": "PA",
    "dropdelzpp": 165019998,
    "dropphyadd": "1401 STATE ST STE 100",
    "dropphycty": "ERIE",
    "dropphyst": "PA",
    "dropphyzpp": 165019998,
    "dropmaladd": "1401 STATE ST STE 100",
    "dropmalcty": "ERIE",
    "dropmalst": "PA",
    "dropmalzpp": 165019998,
    "dropsitphn": 8148987318,
    "dropsitlph": 8144546486,
    "dropsitcph": 8144546486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17990",
    "droptype": "D",
    "dropname": "DOWNTOWN LANCASTER",
    "dropdeladd": "48-50 W CHESTNUT ST STE 1",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176039997,
    "dropphyadd": "48-50 W CHESTNUT ST STE 1",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176039997,
    "dropmaladd": "48-50 W CHESTNUT ST STE 1",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176039997,
    "dropsitphn": 7173968782,
    "dropsitlph": 7175097663,
    "dropsitcph": 7175097663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17992",
    "droptype": "D",
    "dropname": "DOWNTOWN NEW CASTLE",
    "dropdeladd": "151 CASCADE GALLERIA",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161019998,
    "dropphyadd": "151 CASCADE GALLERIA",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161019998,
    "dropmaladd": "151 CASCADE GALLERIA",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161019998,
    "dropsitphn": 8148367307,
    "dropsitlph": 7246567221,
    "dropsitcph": 7246524611,
    "dropfax": 7246525564
  },
  {
    "dcode": "D",
    "dropkey": "SX17995",
    "droptype": "D",
    "dropname": "DOWNTOWN SCRANTON",
    "dropdeladd": "235 N WASHINGTON AVE OFC",
    "dropdelcty": "SCRANTON",
    "dropdelst": "PA",
    "dropdelzpp": 185031540,
    "dropphyadd": "235 N WASHINGTON AVE OFC",
    "dropphycty": "SCRANTON",
    "dropphyst": "PA",
    "dropphyzpp": 185031540,
    "dropmaladd": "235 N WASHINGTON AVE OFC",
    "dropmalcty": "SCRANTON",
    "dropmalst": "PA",
    "dropmalzpp": 185031540,
    "dropsitphn": 7172574870,
    "dropsitlph": 5709695140,
    "dropsitcph": 5703481024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17996",
    "droptype": "D",
    "dropname": "DOWNTOWN UNIONTOWN",
    "dropdeladd": "34 W PETER ST",
    "dropdelcty": "UNIONTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 154013316,
    "dropphyadd": "34 W PETER ST",
    "dropphycty": "UNIONTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 154013316,
    "dropmaladd": "34 W PETER ST",
    "dropmalcty": "UNIONTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 154013316,
    "dropsitphn": 4123597568,
    "dropsitlph": 7244370474,
    "dropsitcph": 7244370474,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX17997",
    "droptype": "D",
    "dropname": "DOWNTOWN READING",
    "dropdeladd": "59 N 5TH ST",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196013435,
    "dropphyadd": "59 N 5TH ST",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196013435,
    "dropmaladd": "59 N 5TH ST",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196013435,
    "dropsitphn": 7173968782,
    "dropsitlph": 6103757492,
    "dropsitcph": 6103757492,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX18043",
    "droptype": "D",
    "dropname": "DUPONT",
    "dropdeladd": "288 MAIN ST",
    "dropdelcty": "DUPONT",
    "dropdelst": "PA",
    "dropdelzpp": 186411960,
    "dropphyadd": "288 MAIN ST",
    "dropphycty": "DUPONT",
    "dropphyst": "PA",
    "dropphyzpp": 186411960,
    "dropmaladd": "288 MAIN ST",
    "dropmalcty": "DUPONT",
    "dropmalst": "PA",
    "dropmalzpp": 186411960,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313404,
    "dropsitcph": 5704573321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX18109",
    "droptype": "D",
    "dropname": "EAST FALLS",
    "dropdeladd": "4130 RIDGE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191299998,
    "dropphyadd": "4130 RIDGE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191299998,
    "dropmaladd": "4130 RIDGE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191299998,
    "dropsitphn": 2158495429,
    "dropsitlph": 2158444837,
    "dropsitcph": 2158495429,
    "dropfax": 2158445860
  },
  {
    "dcode": "D",
    "dropkey": "SX18112",
    "droptype": "D",
    "dropname": "EAST GERMANTOWN",
    "dropdeladd": "2031 66TH AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191389998,
    "dropphyadd": "2031 66TH AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191389998,
    "dropmaladd": "2031 66TH AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191389998,
    "dropsitphn": 2159277483,
    "dropsitlph": 2155490333,
    "dropsitcph": 2159277483,
    "dropfax": 2155493073
  },
  {
    "dcode": "D",
    "dropkey": "SX18121",
    "droptype": "D",
    "dropname": "EAST LIBERTY",
    "dropdeladd": "6360 BROAD ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152069998,
    "dropphyadd": "6360 BROAD ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152069998,
    "dropmaladd": "6360 BROAD ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152069998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126615780,
    "dropsitcph": 4126615780,
    "dropfax": 4126610625
  },
  {
    "dcode": "D",
    "dropkey": "SX18313",
    "droptype": "D",
    "dropname": "FAIRHILL",
    "dropdeladd": "217 W LEHIGH AVE STE 2",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191339997,
    "dropphyadd": "217 W LEHIGH AVE STE 2",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191339997,
    "dropmaladd": "217 W LEHIGH AVE STE 2",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191339997,
    "dropsitphn": 2156346378,
    "dropsitlph": 2156346378,
    "dropsitcph": 2156346378,
    "dropfax": 2154268591
  },
  {
    "dcode": "D",
    "dropkey": "SX18322",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "900 N 19TH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191309998,
    "dropphyadd": "900 N 19TH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191309998,
    "dropmaladd": "900 N 19TH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191309998,
    "dropsitphn": 2152353091,
    "dropsitlph": 2152365176,
    "dropsitcph": 2152353091,
    "dropfax": 2152322523
  },
  {
    "dcode": "D",
    "dropkey": "SX18470",
    "droptype": "D",
    "dropname": "FOURTH AVENUE",
    "dropdeladd": "336 4TH AVE STE 1A",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152222006,
    "dropphyadd": "336 4TH AVE STE 1A",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152222006,
    "dropmaladd": "336 4TH AVE STE 1A",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152222006,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126421151,
    "dropsitcph": 4126421151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX18474",
    "droptype": "D",
    "dropname": "FOX CHASE",
    "dropdeladd": "7232 RISING SUN AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191119998,
    "dropphyadd": "7232 RISING SUN AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191119998,
    "dropmaladd": "7232 RISING SUN AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191119998,
    "dropsitphn": 2157428074,
    "dropsitlph": 2157452201,
    "dropsitcph": 2157428074,
    "dropfax": 2157459530
  },
  {
    "dcode": "D",
    "dropkey": "SX18489",
    "droptype": "D",
    "dropname": "FRANKFORD",
    "dropdeladd": "4410 PAUL ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191249998,
    "dropphyadd": "4410 PAUL ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191249998,
    "dropmaladd": "4410 PAUL ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191249998,
    "dropsitphn": 2155338174,
    "dropsitlph": 2155337386,
    "dropsitcph": 2155338174,
    "dropfax": 2155331480
  },
  {
    "dcode": "D",
    "dropkey": "SX18498",
    "droptype": "D",
    "dropname": "FRANKLIN MILLS",
    "dropdeladd": "1735 FRANKLIN MILLS CIR",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191549997,
    "dropphyadd": "1735 FRANKLIN MILLS CIR",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191549997,
    "dropmaladd": "1735 FRANKLIN MILLS CIR",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191549997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156952119,
    "dropsitcph": 2156952119,
    "dropfax": 2156329953
  },
  {
    "dcode": "D",
    "dropkey": "SX18562",
    "droptype": "D",
    "dropname": "GATEWAY CENTER",
    "dropdeladd": "625 STANWIX ST STE 104",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152221418,
    "dropphyadd": "625 STANWIX ST STE 104",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152221418,
    "dropmaladd": "625 STANWIX ST STE 104",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152221418,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126422158,
    "dropsitcph": 4126422158,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX18564",
    "droptype": "D",
    "dropname": "GAY STREET",
    "dropdeladd": "101 E GAY ST",
    "dropdelcty": "WEST CHESTER",
    "dropdelst": "PA",
    "dropdelzpp": 193809997,
    "dropphyadd": "101 E GAY ST",
    "dropphycty": "WEST CHESTER",
    "dropphyst": "PA",
    "dropphyzpp": 193809997,
    "dropmaladd": "101 E GAY ST",
    "dropmalcty": "WEST CHESTER",
    "dropmalst": "PA",
    "dropmalzpp": 193809997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6107387693,
    "dropsitcph": 6107387693,
    "dropfax": 6104317047
  },
  {
    "dcode": "D",
    "dropkey": "SX18586",
    "droptype": "D",
    "dropname": "GERMANTOWN",
    "dropdeladd": "5209 GREENE ST STE 1",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191449998,
    "dropphyadd": "5209 GREENE ST STE 1",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191449998,
    "dropmaladd": "5209 GREENE ST STE 1",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191449998,
    "dropsitphn": 2158494870,
    "dropsitlph": 2158444355,
    "dropsitcph": 2158494870,
    "dropfax": 2158420445
  },
  {
    "dcode": "D",
    "dropkey": "SX18672",
    "droptype": "D",
    "dropname": "GRANT STREET",
    "dropdeladd": "395 FEDERAL ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152129939,
    "dropphyadd": "395 FEDERAL ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152129939,
    "dropmaladd": "395 FEDERAL ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152129939,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126422964,
    "dropsitcph": 4126420769,
    "dropfax": 4126429103
  },
  {
    "dcode": "D",
    "dropkey": "SX18835",
    "droptype": "D",
    "dropname": "HAZELWOOD",
    "dropdeladd": "5020 2ND AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152079998,
    "dropphyadd": "5020 2ND AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152079998,
    "dropmaladd": "5020 2ND AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152079998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124215836,
    "dropsitcph": 4124215836,
    "dropfax": 4124221825
  },
  {
    "dcode": "D",
    "dropkey": "SX18929",
    "droptype": "D",
    "dropname": "HOLMESBURG CARRIER UNIT",
    "dropdeladd": "3854 MORRELL AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191149998,
    "dropphyadd": "3854 MORRELL AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191149998,
    "dropmaladd": "3854 MORRELL AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191149998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156122386,
    "dropsitcph": 2156122386,
    "dropfax": 2156329364
  },
  {
    "dcode": "D",
    "dropkey": "SX18983",
    "droptype": "D",
    "dropname": "NICETOWN CARRIER UNIT",
    "dropdeladd": "4350 N FRONT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191409996,
    "dropphyadd": "4350 N FRONT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191409996,
    "dropmaladd": "4350 N FRONT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191409996,
    "dropsitphn": 2153298147,
    "dropsitlph": 2153242275,
    "dropsitcph": 2153298147,
    "dropfax": 2153240280
  },
  {
    "dcode": "D",
    "dropkey": "SX19090",
    "droptype": "D",
    "dropname": "JOHN WANAMAKER",
    "dropdeladd": "1234 MARKET ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191079997,
    "dropphyadd": "1234 MARKET ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191079997,
    "dropmaladd": "1234 MARKET ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191079997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155929610,
    "dropsitcph": 2155929610,
    "dropfax": 2155927749
  },
  {
    "dcode": "D",
    "dropkey": "SX19154",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "1602 FRANKFORD AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191259998,
    "dropphyadd": "1602 FRANKFORD AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191259998,
    "dropmaladd": "1602 FRANKFORD AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191259998,
    "dropsitphn": 2157397926,
    "dropsitlph": 2157397926,
    "dropsitcph": 2157397926,
    "dropfax": 2157395420
  },
  {
    "dcode": "D",
    "dropkey": "SX19173",
    "droptype": "D",
    "dropname": "KINGSESSING",
    "dropdeladd": "5311 FLORENCE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191439998,
    "dropphyadd": "5311 FLORENCE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191439998,
    "dropmaladd": "5311 FLORENCE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191439998,
    "dropsitphn": 2157273983,
    "dropsitlph": 2157273983,
    "dropsitcph": 2157273983,
    "dropfax": 2157273667
  },
  {
    "dcode": "D",
    "dropkey": "SX19269",
    "droptype": "D",
    "dropname": "LANCASTER AVENUE",
    "dropdeladd": "4123 LANCASTER AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049966,
    "dropphyadd": "4123 LANCASTER AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049966,
    "dropmaladd": "4123 LANCASTER AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049966,
    "dropsitphn": 2158958561,
    "dropsitlph": 2158958970,
    "dropsitcph": 2158958970,
    "dropfax": 2158958964
  },
  {
    "dcode": "D",
    "dropkey": "SX19484",
    "droptype": "D",
    "dropname": "LOGAN",
    "dropdeladd": "6150 N BROAD ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191419998,
    "dropphyadd": "6150 N BROAD ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191419998,
    "dropmaladd": "6150 N BROAD ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191419998,
    "dropsitphn": 2159248858,
    "dropsitlph": 2155493711,
    "dropsitcph": 2159248858,
    "dropfax": 2155491190
  },
  {
    "dcode": "D",
    "dropkey": "SX19550",
    "droptype": "D",
    "dropname": "LYNNEWOOD",
    "dropdeladd": "2207 W CHELTENHAM AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191509996,
    "dropphyadd": "2207 W CHELTENHAM AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191509996,
    "dropmaladd": "2207 W CHELTENHAM AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191509996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2152477449,
    "dropsitcph": 2152477449,
    "dropfax": 2152476147
  },
  {
    "dcode": "D",
    "dropkey": "SX19558",
    "droptype": "D",
    "dropname": "MAC ARTHUR",
    "dropdeladd": "906 22ND ST",
    "dropdelcty": "ALIQUIPPA",
    "dropdelst": "PA",
    "dropdelzpp": 150012719,
    "dropphyadd": "906 22ND ST",
    "dropphycty": "ALIQUIPPA",
    "dropphyst": "PA",
    "dropphyzpp": 150012719,
    "dropmaladd": "906 22ND ST",
    "dropmalcty": "ALIQUIPPA",
    "dropmalst": "PA",
    "dropmalzpp": 150012719,
    "dropsitphn": 4123597568,
    "dropsitlph": 7243780692,
    "dropsitcph": 7243780692,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX19588",
    "droptype": "D",
    "dropname": "MANAYUNK",
    "dropdeladd": "4431 MAIN ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191279998,
    "dropphyadd": "4431 MAIN ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191279998,
    "dropmaladd": "4431 MAIN ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191279998,
    "dropsitphn": 2154820913,
    "dropsitlph": 2154820913,
    "dropsitcph": 2154820913,
    "dropfax": 2154823147
  },
  {
    "dcode": "D",
    "dropkey": "SX19626",
    "droptype": "D",
    "dropname": "MARKET SQUARE",
    "dropdeladd": "7782 CRITTENDEN ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191189998,
    "dropphyadd": "7782 CRITTENDEN ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191189998,
    "dropmaladd": "7782 CRITTENDEN ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191189998,
    "dropsitphn": 2157538923,
    "dropsitlph": 2152477449,
    "dropsitcph": 2157538923,
    "dropfax": 2152476147
  },
  {
    "dcode": "D",
    "dropkey": "SX19668",
    "droptype": "D",
    "dropname": "MAYFAIR",
    "dropdeladd": "7303 FRANKFORD AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191369996,
    "dropphyadd": "7303 FRANKFORD AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191369996,
    "dropmaladd": "7303 FRANKFORD AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191369996,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156329294,
    "dropsitcph": 2156329294,
    "dropfax": 2156329364
  },
  {
    "dcode": "D",
    "dropkey": "SX19785",
    "droptype": "D",
    "dropname": "MIDDLE CITY",
    "dropdeladd": "2037 CHESTNUT ST FL 1",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191039997,
    "dropphyadd": "2037 CHESTNUT ST FL 1",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191039997,
    "dropmaladd": "2037 CHESTNUT ST FL 1",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191039997,
    "dropsitphn": 2158958561,
    "dropsitlph": 2155686329,
    "dropsitcph": 2155686329,
    "dropfax": 2155611968
  },
  {
    "dcode": "D",
    "dropkey": "SX19943",
    "droptype": "D",
    "dropname": "MOUNT AIRY POSTAL STORE",
    "dropdeladd": "6711 GERMANTOWN AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191199997,
    "dropphyadd": "6711 GERMANTOWN AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191199997,
    "dropmaladd": "6711 GERMANTOWN AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191199997,
    "dropsitphn": 2154384589,
    "dropsitlph": 2154387589,
    "dropsitcph": 2154387710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX19982",
    "droptype": "D",
    "dropname": "MOUNT WASHINGTON",
    "dropdeladd": "213 SHILOH ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152119998,
    "dropphyadd": "213 SHILOH ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152119998,
    "dropmaladd": "213 SHILOH ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152119998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123814915,
    "dropsitcph": 4123814897,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A461",
    "droptype": "D",
    "dropname": "NORTHWEST FINANCE UNIT",
    "dropdeladd": "1822 HENDERSON RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432209997,
    "dropphyadd": "1822 HENDERSON RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432209997,
    "dropmaladd": "1822 HENDERSON RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432209997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144511483,
    "dropsitcph": 6144511483,
    "dropfax": 6144514073
  },
  {
    "dcode": "D",
    "dropkey": "SX2A465",
    "droptype": "D",
    "dropname": "EASTLAND FINANCE UNIT",
    "dropdeladd": "4255 MACSWAY AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432329997,
    "dropphyadd": "4255 MACSWAY AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432329997,
    "dropmaladd": "4255 MACSWAY AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432329997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142371912,
    "dropsitcph": 6142371912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A466",
    "droptype": "D",
    "dropname": "CENTRAL POINT FINANCE UNIT",
    "dropdeladd": "1499 W BROAD ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432229998,
    "dropphyadd": "1499 W BROAD ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432229998,
    "dropmaladd": "1499 W BROAD ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432229998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694268,
    "dropsitcph": 6143518386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A471",
    "droptype": "D",
    "dropname": "NORTHLAND RETAIL STORE",
    "dropdeladd": "2469 E DUBLIN GRANVILLE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432299996,
    "dropphyadd": "2469 E DUBLIN GRANVILLE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432299996,
    "dropmaladd": "2469 E DUBLIN GRANVILLE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432299996,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148901180,
    "dropsitcph": 6148189963,
    "dropfax": 6148189967
  },
  {
    "dcode": "D",
    "dropkey": "SX2A474",
    "droptype": "D",
    "dropname": "FORT HILL",
    "dropdeladd": "6020 FORT AVE",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245029998,
    "dropphyadd": "6020 FORT AVE",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245029998,
    "dropmaladd": "6020 FORT AVE",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245029998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342394875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A490",
    "droptype": "D",
    "dropname": "DOWNTOWN CHRISTIANSBURG",
    "dropdeladd": "2 E MAIN ST",
    "dropdelcty": "CHRISTIANSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 240739997,
    "dropphyadd": "2 E MAIN ST",
    "dropphycty": "CHRISTIANSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 240739997,
    "dropmaladd": "2 E MAIN ST",
    "dropmalcty": "CHRISTIANSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 240739997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403827147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A535",
    "droptype": "D",
    "dropname": "SEAPINES RETAIL",
    "dropdeladd": "320 33RD ST",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234519996,
    "dropphyadd": "320 33RD ST",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234519996,
    "dropmaladd": "320 33RD ST",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234519996,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574281368,
    "dropsitcph": 7574868655,
    "dropfax": 7574282049
  },
  {
    "dcode": "D",
    "dropkey": "SX2A536",
    "droptype": "D",
    "dropname": "JOLLIFF RETAIL",
    "dropdeladd": "4300 PORTSMOUTH BLVD STE 174",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233219997,
    "dropphyadd": "4300 PORTSMOUTH BLVD STE 174",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233219997,
    "dropmaladd": "4300 PORTSMOUTH BLVD STE 174",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233219997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574653532,
    "dropsitcph": 7574653532,
    "dropfax": 7574655908
  },
  {
    "dcode": "D",
    "dropkey": "SX2A538",
    "droptype": "D",
    "dropname": "DOWNTOWN LEXINGTON",
    "dropdeladd": "710 W MAIN",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "SC",
    "dropdelzpp": 290719997,
    "dropphyadd": "710 W MAIN",
    "dropphycty": "LEXINGTON",
    "dropphyst": "SC",
    "dropphyzpp": 290719997,
    "dropmaladd": "710 W MAIN",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "SC",
    "dropmalzpp": 290719997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8033590983,
    "dropfax": 8033597612
  },
  {
    "dcode": "D",
    "dropkey": "SX2A541",
    "droptype": "D",
    "dropname": "WOODBRIDGE",
    "dropdeladd": "3360 POST OFFICE RD",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 221939997,
    "dropphyadd": "3360 POST OFFICE RD",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 221939997,
    "dropmaladd": "3360 POST OFFICE RD",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 221939997,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037301505,
    "dropsitcph": 7037301505,
    "dropfax": 7037308748
  },
  {
    "dcode": "D",
    "dropkey": "SX2A564",
    "droptype": "D",
    "dropname": "EBENEZER",
    "dropdeladd": "2191 EBENEZER RD",
    "dropdelcty": "ROCK HILL",
    "dropdelst": "SC",
    "dropdelzpp": 297320048,
    "dropphyadd": "2191 EBENEZER RD",
    "dropphycty": "ROCK HILL",
    "dropphyst": "SC",
    "dropphyzpp": 297320048,
    "dropmaladd": "2191 EBENEZER RD",
    "dropmalcty": "ROCK HILL",
    "dropmalst": "SC",
    "dropmalzpp": 297320048,
    "dropsitphn": 7043934581,
    "dropsitlph": 8033271174,
    "dropsitcph": 8033271174,
    "dropfax": 8039804291
  },
  {
    "dcode": "D",
    "dropkey": "SX2A591",
    "droptype": "D",
    "dropname": "GENITO",
    "dropdeladd": "3530 POST OFFICE RD",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "VA",
    "dropdelzpp": 231129998,
    "dropphyadd": "3530 POST OFFICE RD",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "VA",
    "dropphyzpp": 231129998,
    "dropmaladd": "3530 POST OFFICE RD",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "VA",
    "dropmalzpp": 231129998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8046393475,
    "dropsitcph": 8046393475,
    "dropfax": 8046396123
  },
  {
    "dcode": "D",
    "dropkey": "SX2A608",
    "droptype": "D",
    "dropname": "ATLEE",
    "dropdeladd": "9540 CHAMBERLAYNE RD",
    "dropdelcty": "MECHANICSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 231169998,
    "dropphyadd": "9540 CHAMBERLAYNE RD",
    "dropphycty": "MECHANICSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 231169998,
    "dropmaladd": "9540 CHAMBERLAYNE RD",
    "dropmalcty": "MECHANICSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 231169998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045593845,
    "dropsitcph": 8045593845,
    "dropfax": 8045596851
  },
  {
    "dcode": "D",
    "dropkey": "SX2A631",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "202 MAGNOLIA AVE",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "SC",
    "dropdelzpp": 296469998,
    "dropphyadd": "202 MAGNOLIA AVE",
    "dropphycty": "GREENWOOD",
    "dropphyst": "SC",
    "dropphyzpp": 296469998,
    "dropmaladd": "202 MAGNOLIA AVE",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "SC",
    "dropmalzpp": 296469998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642290691,
    "dropfax": 8642234614
  },
  {
    "dcode": "D",
    "dropkey": "SX2A653",
    "droptype": "D",
    "dropname": "BRANDERMILL",
    "dropdeladd": "4944 MILLRIDGE PKWY E",
    "dropdelcty": "MIDLOTHIAN",
    "dropdelst": "VA",
    "dropdelzpp": 231129997,
    "dropphyadd": "4944 MILLRIDGE PKWY E",
    "dropphycty": "MIDLOTHIAN",
    "dropphyst": "VA",
    "dropphyzpp": 231129997,
    "dropmaladd": "4944 MILLRIDGE PKWY E",
    "dropmalcty": "MIDLOTHIAN",
    "dropmalst": "VA",
    "dropmalzpp": 231129997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047631587,
    "dropsitcph": 8047631587,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX2A666",
    "droptype": "D",
    "dropname": "LIVE OAK",
    "dropdeladd": "820 67TH AVE N",
    "dropdelcty": "MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295729998,
    "dropphyadd": "820 67TH AVE N",
    "dropphycty": "MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295729998,
    "dropmaladd": "820 67TH AVE N",
    "dropmalcty": "MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295729998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436929870,
    "dropsitcph": 8436929870,
    "dropfax": 8436920639
  },
  {
    "dcode": "D",
    "dropkey": "SX2A673",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "677 FAIRVIEW RD",
    "dropdelcty": "SIMPSONVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296809998,
    "dropphyadd": "677 FAIRVIEW RD",
    "dropphycty": "SIMPSONVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296809998,
    "dropmaladd": "677 FAIRVIEW RD",
    "dropmalcty": "SIMPSONVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296809998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8649625193,
    "dropfax": 8649673834
  },
  {
    "dcode": "D",
    "dropkey": "SX2A706",
    "droptype": "D",
    "dropname": "CHURCH STREET STATION",
    "dropdeladd": "825 S CHURCH ST",
    "dropdelcty": "MURFREESBORO",
    "dropdelst": "TN",
    "dropdelzpp": 371309998,
    "dropphyadd": "825 S CHURCH ST",
    "dropphycty": "MURFREESBORO",
    "dropphyst": "TN",
    "dropphyzpp": 371309998,
    "dropmaladd": "825 S CHURCH ST",
    "dropmalcty": "MURFREESBORO",
    "dropmalst": "TN",
    "dropmalzpp": 371309998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152170931,
    "dropsitcph": 6152170596,
    "dropfax": 6152171501
  },
  {
    "dcode": "D",
    "dropkey": "SX20001",
    "droptype": "D",
    "dropname": "STORY PLACE",
    "dropdeladd": "629 CENTRAL CTR",
    "dropdelcty": "CHILLICOTHE",
    "dropdelst": "OH",
    "dropdelzpp": 456012249,
    "dropphyadd": "629 CENTRAL CTR",
    "dropphycty": "CHILLICOTHE",
    "dropphyst": "OH",
    "dropphyzpp": 456012249,
    "dropmaladd": "629 CENTRAL CTR",
    "dropmalcty": "CHILLICOTHE",
    "dropmalst": "OH",
    "dropmalzpp": 456012249,
    "dropsitphn": 6144720674,
    "dropsitlph": 6147725227,
    "dropsitcph": 6147725227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20002",
    "droptype": "D",
    "dropname": "A STATION CLEVELAND",
    "dropdeladd": "6600 LORAIN AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441029998,
    "dropphyadd": "6600 LORAIN AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441029998,
    "dropmaladd": "6600 LORAIN AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441029998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162810608,
    "dropfax": 2162810411
  },
  {
    "dcode": "D",
    "dropkey": "SX20027",
    "droptype": "D",
    "dropname": "PORT COLUMBUS",
    "dropdeladd": "2323 CITY GATE DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432369998,
    "dropphyadd": "2323 CITY GATE DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432369998,
    "dropmaladd": "2323 CITY GATE DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432369998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142311054,
    "dropsitcph": 6142311054,
    "dropfax": 6142311316
  },
  {
    "dcode": "D",
    "dropkey": "SX20032",
    "droptype": "D",
    "dropname": "AIRWAY RD",
    "dropdeladd": "4924 AIRWAY RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454379998,
    "dropphyadd": "4924 AIRWAY RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454379998,
    "dropmaladd": "4924 AIRWAY RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454379998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372536074,
    "dropsitcph": 9372536074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20133",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "3493 BURNET AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452299998,
    "dropphyadd": "3493 BURNET AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452299998,
    "dropmaladd": "5115 VINE ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132812234,
    "dropsitcph": 5132812234,
    "dropfax": 5138612691
  },
  {
    "dcode": "D",
    "dropkey": "SX20136",
    "droptype": "D",
    "dropname": "B STATION CLEVELAND",
    "dropdeladd": "1650 E 55TH ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441039998,
    "dropphyadd": "1650 E 55TH ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441039998,
    "dropmaladd": "1650 E 55TH ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441039998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2168810756,
    "dropfax": 2168816748
  },
  {
    "dcode": "D",
    "dropkey": "SX20171",
    "droptype": "D",
    "dropname": "BEACHLAND",
    "dropdeladd": "891 E 185TH ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441199998,
    "dropphyadd": "891 E 185TH ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441199998,
    "dropmaladd": "891 E 185TH ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441199998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164812932,
    "dropfax": 4407306451
  },
  {
    "dcode": "D",
    "dropkey": "SX20188",
    "droptype": "D",
    "dropname": "BEECHWOLD",
    "dropdeladd": "4364 N HIGH ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432149998,
    "dropphyadd": "4364 N HIGH ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432149998,
    "dropmaladd": "4364 N HIGH ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432149998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144470146,
    "dropsitcph": 6144470146,
    "dropfax": 6144472298
  },
  {
    "dcode": "D",
    "dropkey": "SX20394",
    "droptype": "D",
    "dropname": "BURNET WOODS",
    "dropdeladd": "362 LUDLOW AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452209998,
    "dropphyadd": "362 LUDLOW AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452209998,
    "dropmaladd": "362 LUDLOW AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5138611367,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20413",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "1609 DORR ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436079998,
    "dropphyadd": "1609 DORR ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436079998,
    "dropmaladd": "1609 DORR ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436079998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192456958,
    "dropsitcph": 4192456958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20600",
    "droptype": "D",
    "dropname": "CLINTONVILLE FINANCE",
    "dropdeladd": "2804 N HIGH ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432029998,
    "dropphyadd": "2804 N HIGH ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432029998,
    "dropmaladd": "2804 N HIGH ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432029998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144470104,
    "dropsitcph": 6144470104,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20630",
    "droptype": "D",
    "dropname": "COLLINWOOD",
    "dropdeladd": "890 E 152ND ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441109998,
    "dropphyadd": "890 E 152ND ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441109998,
    "dropmaladd": "890 E 152ND ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441109998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164519414,
    "dropfax": 2164516017
  },
  {
    "dcode": "D",
    "dropkey": "SX20696",
    "droptype": "D",
    "dropname": "CORNERSBURG",
    "dropdeladd": "3375 CANFIELD RD",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445119998,
    "dropphyadd": "3375 CANFIELD RD",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445119998,
    "dropmaladd": "3375 CANFIELD RD",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445119998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307995074,
    "dropsitcph": 3307995074,
    "dropfax": 3307991186
  },
  {
    "dcode": "D",
    "dropkey": "SX20700",
    "droptype": "D",
    "dropname": "CORRYVILLE",
    "dropdeladd": "2917 SHORT VINE ST",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452199998,
    "dropphyadd": "2917 SHORT VINE ST",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452199998,
    "dropmaladd": "2917 SHORT VINE ST",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452199998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5137514384,
    "dropsitcph": 5137514384,
    "dropfax": 5132218214
  },
  {
    "dcode": "D",
    "dropkey": "SX20705",
    "droptype": "D",
    "dropname": "COUNTRY FAIR",
    "dropdeladd": "4025 TUSCARAWAS ST W",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447089998,
    "dropphyadd": "4025 TUSCARAWAS ST W",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447089998,
    "dropmaladd": "4025 TUSCARAWAS ST W",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447089998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304779494,
    "dropfax": 3302329831
  },
  {
    "dcode": "D",
    "dropkey": "SX20721",
    "droptype": "D",
    "dropname": "CRANWOOD",
    "dropdeladd": "16828 HARVARD AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441282251,
    "dropphyadd": "16828 HARVARD AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441282251,
    "dropmaladd": "16828 HARVARD AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441289998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162952351,
    "dropfax": 2167516839
  },
  {
    "dcode": "D",
    "dropkey": "SX20753",
    "droptype": "D",
    "dropname": "DABEL",
    "dropdeladd": "1490 FORRER BLVD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454209998,
    "dropphyadd": "1490 FORRER BLVD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454209998,
    "dropmaladd": "1490 FORRER BLVD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372535988,
    "dropsitcph": 9372535988,
    "dropfax": 9372545976
  },
  {
    "dcode": "D",
    "dropkey": "SX20779",
    "droptype": "D",
    "dropname": "DAYTON VIEW",
    "dropdeladd": "557 SALEM AVE",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454069998,
    "dropphyadd": "557 SALEM AVE",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454069998,
    "dropmaladd": "557 SALEM AVE",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372789260,
    "dropsitcph": 9372789260,
    "dropfax": 9372777902
  },
  {
    "dcode": "D",
    "dropkey": "SX20824",
    "droptype": "D",
    "dropname": "DONALD L MARRS",
    "dropdeladd": "3644 WERK RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452589998,
    "dropphyadd": "3644 WERK RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452589998,
    "dropmaladd": "3644 WERK RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452589998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5139224088,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX20930",
    "droptype": "D",
    "dropname": "ELLET",
    "dropdeladd": "2390 WEDGEWOOD DR",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443129998,
    "dropphyadd": "2390 WEDGEWOOD DR",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443129998,
    "dropmaladd": "2390 WEDGEWOOD DR",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443129998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307849792,
    "dropfax": 2342084411
  },
  {
    "dcode": "D",
    "dropkey": "SX20950",
    "droptype": "D",
    "dropname": "ERIEVIEW",
    "dropdeladd": "1240 E 9TH ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441999998,
    "dropphyadd": "1240 E 9TH ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441999998,
    "dropmaladd": "1240 E 9TH ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441999998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2168610708,
    "dropfax": 2168612527
  },
  {
    "dcode": "D",
    "dropkey": "SX21019",
    "droptype": "D",
    "dropname": "FIRESTONE PARK",
    "dropdeladd": "2001 BROWN ST",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443199998,
    "dropphyadd": "2001 BROWN ST",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443199998,
    "dropmaladd": "2001 BROWN ST",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443199998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307739662,
    "dropfax": 2346784369
  },
  {
    "dcode": "D",
    "dropkey": "SX21025",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "634 W EXCHANGE ST",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443029998,
    "dropphyadd": "634 W EXCHANGE ST",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443029998,
    "dropmaladd": "634 W EXCHANGE ST",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443029998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307628472,
    "dropfax": 3302533108
  },
  {
    "dcode": "D",
    "dropkey": "SX21054",
    "droptype": "D",
    "dropname": "QUEEN CITY",
    "dropdeladd": "525 VINE ST STE 1",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452029998,
    "dropphyadd": "525 VINE ST STE 1",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452029998,
    "dropmaladd": "525 VINE ST STE 1",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5136845663,
    "dropfax": 5136845082
  },
  {
    "dcode": "D",
    "dropkey": "SX21064",
    "droptype": "D",
    "dropname": "FRANKLIN PARK",
    "dropdeladd": "5151 MONROE ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436239998,
    "dropphyadd": "5151 MONROE ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436239998,
    "dropmaladd": "5151 MONROE ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436239998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4198852433,
    "dropsitcph": 4198852433,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21124",
    "droptype": "D",
    "dropname": "GERMAN VILLAGE FINANCE",
    "dropdeladd": "500 E WHITTIER ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432069998,
    "dropphyadd": "500 E WHITTIER ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432069998,
    "dropmaladd": "500 E WHITTIER ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432069998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144441024,
    "dropsitcph": 6144441024,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21150",
    "droptype": "D",
    "dropname": "GLENVILLE BRATENAHL",
    "dropdeladd": "630 E 105TH ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441089998,
    "dropphyadd": "630 E 105TH ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441089998,
    "dropmaladd": "630 E 105TH ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441089998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164516634,
    "dropfax": 4407306432
  },
  {
    "dcode": "D",
    "dropkey": "SX21246",
    "droptype": "D",
    "dropname": "HARBOR",
    "dropdeladd": "718 LAKE AVE STE 1",
    "dropdelcty": "ASHTABULA",
    "dropdelst": "OH",
    "dropdelzpp": 440043281,
    "dropphyadd": "718 LAKE AVE STE 1",
    "dropphycty": "ASHTABULA",
    "dropphyst": "OH",
    "dropphyzpp": 440043281,
    "dropmaladd": "4307 STATION AVE",
    "dropmalcty": "ASHTABULA",
    "dropmalst": "OH",
    "dropmalzpp": 440049998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4409975268,
    "dropfax": 4409920884
  },
  {
    "dcode": "D",
    "dropkey": "SX21330",
    "droptype": "D",
    "dropname": "HILLTOP FINANCE",
    "dropdeladd": "2700 W BROAD ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432043332,
    "dropphyadd": "2700 W BROAD ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432043332,
    "dropmaladd": "2700 W BROAD ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432043332,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694268,
    "dropsitcph": 6143511710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21377",
    "droptype": "D",
    "dropname": "HYDE PARK",
    "dropdeladd": "2639 ERIE AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452089998,
    "dropphyadd": "2639 ERIE AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452089998,
    "dropmaladd": "2639 ERIE AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452089998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5133216635,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21449",
    "droptype": "D",
    "dropname": "JESSE C OWENS",
    "dropdeladd": "5600 WOODLAND AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441049998,
    "dropphyadd": "5600 WOODLAND AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441049998,
    "dropmaladd": "5600 WOODLAND AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441049998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2168810407,
    "dropfax": 2168816748
  },
  {
    "dcode": "D",
    "dropkey": "SX21471",
    "droptype": "D",
    "dropname": "KENMORE",
    "dropdeladd": "2394 EAST AVE",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443149998,
    "dropphyadd": "2394 EAST AVE",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443149998,
    "dropmaladd": "2394 EAST AVE",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443149998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307458938,
    "dropfax": 3307450519
  },
  {
    "dcode": "D",
    "dropkey": "SX21481",
    "droptype": "D",
    "dropname": "KENWOOD",
    "dropdeladd": "2941 HAUGHTON DR",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436069998,
    "dropphyadd": "2941 HAUGHTON DR",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436069998,
    "dropmaladd": "2941 HAUGHTON DR",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194719093,
    "dropsitcph": 4194719093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21582",
    "droptype": "D",
    "dropname": "SHAKER FINANCE",
    "dropdeladd": "2855 E 130TH ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441202191,
    "dropphyadd": "2855 E 130TH ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441202191,
    "dropmaladd": "2855 E 130TH ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441202191,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2167528165,
    "dropfax": 2162950448
  },
  {
    "dcode": "D",
    "dropkey": "SX21631",
    "droptype": "D",
    "dropname": "LINDEN FINANCE",
    "dropdeladd": "1981 CLEVELAND AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432112577,
    "dropphyadd": "1981 CLEVELAND AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432112577,
    "dropmaladd": "1981 CLEVELAND AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432112577,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144479122,
    "dropsitcph": 6144479122,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21652",
    "droptype": "D",
    "dropname": "LIVINGSTON",
    "dropdeladd": "3850 E LIVINGSTON AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432279998,
    "dropphyadd": "3850 E LIVINGSTON AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432279998,
    "dropmaladd": "3850 E LIVINGSTON AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432279998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720674,
    "dropsitcph": 6142379570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21728",
    "droptype": "D",
    "dropname": "MAIN OFFICE CINCINNATI",
    "dropdeladd": "1623 DALTON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452348902,
    "dropphyadd": "1623 DALTON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452348902,
    "dropmaladd": "1623 DALTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452348902,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5136845009,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX21868",
    "droptype": "D",
    "dropname": "MID CITY DAYTON",
    "dropdeladd": "36 N LUDLOW ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454029998,
    "dropphyadd": "36 N LUDLOW ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454029998,
    "dropmaladd": "36 N LUDLOW ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454029998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372233877,
    "dropsitcph": 9372233877,
    "dropfax": 9372234059
  },
  {
    "dcode": "D",
    "dropkey": "SX22003",
    "droptype": "D",
    "dropname": "MOUNT VERNON FINANCE",
    "dropdeladd": "327 N 20TH ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432039998,
    "dropphyadd": "327 N 20TH ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432039998,
    "dropmaladd": "327 N 20TH ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432039998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142525139,
    "dropsitcph": 6142525139,
    "dropfax": 6142529269
  },
  {
    "dcode": "D",
    "dropkey": "SX22006",
    "droptype": "D",
    "dropname": "MOUNT WASHINGTON",
    "dropdeladd": "6117 CAMPUS LN",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452309998,
    "dropphyadd": "6117 CAMPUS LN",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452309998,
    "dropmaladd": "6117 CAMPUS LN",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452309998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132311751,
    "dropsitcph": 5132311751,
    "dropfax": 5132327525
  },
  {
    "dcode": "D",
    "dropkey": "SX22115",
    "droptype": "D",
    "dropname": "NEW MARKET",
    "dropdeladd": "220 4TH ST SW",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447029998,
    "dropphyadd": "220 4TH ST SW",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447029998,
    "dropmaladd": "220 4TH ST SW",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447029998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304386444,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22141",
    "droptype": "D",
    "dropname": "NEWBURG",
    "dropdeladd": "8745 BROADWAY AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441059998,
    "dropphyadd": "8745 BROADWAY AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441059998,
    "dropmaladd": "8745 BROADWAY AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441059998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162715490,
    "dropfax": 4407305216
  },
  {
    "dcode": "D",
    "dropkey": "SX22182",
    "droptype": "D",
    "dropname": "NORTH DAYTON",
    "dropdeladd": "1411 FARR DR",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454049998,
    "dropphyadd": "1411 FARR DR",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454049998,
    "dropmaladd": "1411 FARR DR",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454049998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9374430942,
    "dropsitcph": 9374430942,
    "dropfax": 9372287206
  },
  {
    "dcode": "D",
    "dropkey": "SX22189",
    "droptype": "D",
    "dropname": "NORTH HILL",
    "dropdeladd": "574 E CUYAHOGA FALLS AVE",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443109998,
    "dropphyadd": "574 E CUYAHOGA FALLS AVE",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443109998,
    "dropmaladd": "574 E CUYAHOGA FALLS AVE",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443109998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309456292,
    "dropfax": 2345422187
  },
  {
    "dcode": "D",
    "dropkey": "SX22220",
    "droptype": "D",
    "dropname": "NORTHRIDGE",
    "dropdeladd": "5150 PAYNE AVE",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454149998,
    "dropphyadd": "5150 PAYNE AVE",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454149998,
    "dropmaladd": "5150 PAYNE AVE",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372745695,
    "dropsitcph": 9372745695,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22258",
    "droptype": "D",
    "dropname": "OAKLEY",
    "dropdeladd": "3874 PAXTON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452099998,
    "dropphyadd": "3874 PAXTON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452099998,
    "dropmaladd": "3874 PAXTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452099998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5138715450,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22290",
    "droptype": "D",
    "dropname": "OLD WEST END",
    "dropdeladd": "2280 ASHLAND AVE",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436209998,
    "dropphyadd": "2280 ASHLAND AVE",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436209998,
    "dropmaladd": "2280 ASHLAND AVE",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436209998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192456953,
    "dropsitcph": 4192456953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22361",
    "droptype": "D",
    "dropname": "WARREN SOUTH",
    "dropdeladd": "2807 NILES RD SE",
    "dropdelcty": "WARREN",
    "dropdelst": "OH",
    "dropdelzpp": 444849998,
    "dropphyadd": "2807 NILES RD SE",
    "dropphycty": "WARREN",
    "dropphyst": "OH",
    "dropphyzpp": 444849998,
    "dropmaladd": "2807 NILES RD SE",
    "dropmalcty": "WARREN",
    "dropmalst": "OH",
    "dropmalzpp": 444849998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3303692094,
    "dropsitcph": 3303692094,
    "dropfax": 3303696984
  },
  {
    "dcode": "D",
    "dropkey": "SX22379",
    "droptype": "D",
    "dropname": "PAUL LAURENCE DUNBAR",
    "dropdeladd": "4323 W 3RD ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454179998,
    "dropphyadd": "4323 W 3RD ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454179998,
    "dropmaladd": "4323 W 3RD ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454179998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372680254,
    "dropsitcph": 9372680254,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22384",
    "droptype": "D",
    "dropname": "PEARLBROOK",
    "dropdeladd": "4160 PEARL RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441099998,
    "dropphyadd": "4160 PEARL RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441099998,
    "dropmaladd": "4160 PEARL RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441099998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2163980655,
    "dropfax": 2163980598
  },
  {
    "dcode": "D",
    "dropkey": "SX22481",
    "droptype": "D",
    "dropname": "POINT PLACE STATION",
    "dropdeladd": "4445 N SUMMIT ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436119998,
    "dropphyadd": "4445 N SUMMIT ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436119998,
    "dropmaladd": "4445 N SUMMIT ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436119998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4197263631,
    "dropsitcph": 4197263631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22513",
    "droptype": "D",
    "dropname": "PRICE HILL",
    "dropdeladd": "975 ENRIGHT AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452059998,
    "dropphyadd": "975 ENRIGHT AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452059998,
    "dropmaladd": "990 DALTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139214943,
    "dropsitcph": 5139214943,
    "dropfax": 5136845763
  },
  {
    "dcode": "D",
    "dropkey": "SX22524",
    "droptype": "D",
    "dropname": "PUBLIC SQUARE",
    "dropdeladd": "410 SUPERIOR AVE E",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441149998,
    "dropphyadd": "410 SUPERIOR AVE E",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441149998,
    "dropmaladd": "410 SUPERIOR AVE E",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441149998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2168610715,
    "dropfax": 2167060914
  },
  {
    "dcode": "D",
    "dropkey": "SX22529",
    "droptype": "D",
    "dropname": "PURITAS PARK",
    "dropdeladd": "14039 PURITAS AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441359998,
    "dropphyadd": "14039 PURITAS AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441359998,
    "dropmaladd": "14039 PURITAS AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441359998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2166710576,
    "dropfax": 4407306611
  },
  {
    "dcode": "D",
    "dropkey": "SX22588",
    "droptype": "D",
    "dropname": "REYNOLDS CORNERS",
    "dropdeladd": "6020 W BANCROFT ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436159998,
    "dropphyadd": "6020 W BANCROFT ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436159998,
    "dropmaladd": "6020 W BANCROFT ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436159998,
    "dropsitphn": 3309969797,
    "dropsitlph": 4192456870,
    "dropsitcph": 4198411375,
    "dropfax": 4198437297
  },
  {
    "dcode": "D",
    "dropkey": "SX22753",
    "droptype": "D",
    "dropname": "SCIOTOVILLE",
    "dropdeladd": "423 HARDING AVE",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "OH",
    "dropdelzpp": 456625487,
    "dropphyadd": "423 HARDING AVE",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "OH",
    "dropphyzpp": 456625487,
    "dropmaladd": "423 HARDING AVE",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "OH",
    "dropmalzpp": 456625487,
    "dropsitphn": 6144720674,
    "dropsitlph": 7407767461,
    "dropsitcph": 7407767461,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22776",
    "droptype": "D",
    "dropname": "SHAKER HEIGHTS",
    "dropdeladd": "3675 WARRENSVILLE CENTER RD",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441205200,
    "dropphyadd": "3675 WARRENSVILLE CENTER RD",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441205200,
    "dropmaladd": "3675 WARRENSVILLE CENTER RD",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441205200,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162952543,
    "dropfax": 2162950448
  },
  {
    "dcode": "D",
    "dropkey": "SX22802",
    "droptype": "D",
    "dropname": "SHERMAN",
    "dropdeladd": "1343 PARK AVE W",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 449069998,
    "dropphyadd": "1343 PARK AVE W",
    "dropphycty": "MANSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 449069998,
    "dropmaladd": "1343 PARK AVE W",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 449069998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4195293672,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22840",
    "droptype": "D",
    "dropname": "SOUTH ARLINGTON",
    "dropdeladd": "1237 S ARLINGTON ST",
    "dropdelcty": "AKRON",
    "dropdelst": "OH",
    "dropdelzpp": 443069998,
    "dropphyadd": "1237 S ARLINGTON ST",
    "dropphycty": "AKRON",
    "dropphyst": "OH",
    "dropphyzpp": 443069998,
    "dropmaladd": "1237 S ARLINGTON ST",
    "dropmalcty": "AKRON",
    "dropmalst": "OH",
    "dropmalzpp": 443069998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307240125,
    "dropfax": 2342084771
  },
  {
    "dcode": "D",
    "dropkey": "SX22845",
    "droptype": "D",
    "dropname": "SOUTH COLUMBUS",
    "dropdeladd": "445 E INNIS AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432079998,
    "dropphyadd": "445 E INNIS AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432079998,
    "dropmaladd": "445 E INNIS AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432079998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720674,
    "dropsitcph": 6144440217,
    "dropfax": 6144442517
  },
  {
    "dcode": "D",
    "dropkey": "SX22852",
    "droptype": "D",
    "dropname": "SOUTH LORAIN",
    "dropdeladd": "1680 E 28TH ST",
    "dropdelcty": "LORAIN",
    "dropdelst": "OH",
    "dropdelzpp": 440559998,
    "dropphyadd": "1680 E 28TH ST",
    "dropphycty": "LORAIN",
    "dropphyst": "OH",
    "dropphyzpp": 440559998,
    "dropmaladd": "1680 E 28TH ST",
    "dropmalcty": "LORAIN",
    "dropmalst": "OH",
    "dropmalzpp": 440559998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402778182,
    "dropfax": 4402440305
  },
  {
    "dcode": "D",
    "dropkey": "SX22867",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "672 1/2 LOGAN RD",
    "dropdelcty": "MANSFIELD",
    "dropdelst": "OH",
    "dropdelzpp": 449079998,
    "dropphyadd": "672 1/2 LOGAN RD",
    "dropphycty": "MANSFIELD",
    "dropphyst": "OH",
    "dropphyzpp": 449079998,
    "dropmaladd": "672 1/2 LOGAN RD",
    "dropmalcty": "MANSFIELD",
    "dropmalst": "OH",
    "dropmalzpp": 449079998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 4197567222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX22977",
    "droptype": "D",
    "dropname": "STATE ROAD",
    "dropdeladd": "3345 STATE RD",
    "dropdelcty": "CUYAHOGA FALLS",
    "dropdelst": "OH",
    "dropdelzpp": 442232551,
    "dropphyadd": "3345 STATE RD",
    "dropphycty": "CUYAHOGA FALLS",
    "dropphyst": "OH",
    "dropphyzpp": 442232551,
    "dropmaladd": "3345 STATE RD",
    "dropmalcty": "CUYAHOGA FALLS",
    "dropmalst": "OH",
    "dropmalzpp": 442232551,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3309289137,
    "dropfax": 2345421925
  },
  {
    "dcode": "D",
    "dropkey": "SX23041",
    "droptype": "D",
    "dropname": "SYCAMORE",
    "dropdeladd": "4914 COOPER RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452429998,
    "dropphyadd": "4914 COOPER RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452429998,
    "dropmaladd": "4914 COOPER RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452429998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 5137927708,
    "dropfax": 5138910386
  },
  {
    "dcode": "D",
    "dropkey": "SX23103",
    "droptype": "D",
    "dropname": "TRI VILLAGE FINANCE",
    "dropdeladd": "1391 GRANDVIEW AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432129998,
    "dropphyadd": "1391 GRANDVIEW AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432129998,
    "dropmaladd": "1391 GRANDVIEW AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432129998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144882590,
    "dropsitcph": 6144882590,
    "dropfax": 6144885220
  },
  {
    "dcode": "D",
    "dropkey": "SX23149",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "234 W 18TH AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432109998,
    "dropphyadd": "234 W 18TH AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432109998,
    "dropmaladd": "234 W 18TH AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432109998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694268,
    "dropsitcph": 6142947292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23150",
    "droptype": "D",
    "dropname": "UNIVERSITY CENTER",
    "dropdeladd": "1950 E 101ST ST",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441069998,
    "dropphyadd": "1950 E 101ST ST",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441069998,
    "dropmaladd": "1950 E 101ST ST",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441069998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2167918435,
    "dropfax": 2162315971
  },
  {
    "dcode": "D",
    "dropkey": "SX23235",
    "droptype": "D",
    "dropname": "WALNUT HILLS",
    "dropdeladd": "2344 KEMPER LN",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452069998,
    "dropphyadd": "2344 KEMPER LN",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452069998,
    "dropmaladd": "2344 KEMPER LN",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452069998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5139613205,
    "dropsitcph": 5139613205,
    "dropfax": 5139612705
  },
  {
    "dcode": "D",
    "dropkey": "SX23298",
    "droptype": "D",
    "dropname": "WERNERT",
    "dropdeladd": "2618 TREMAINSVILLE RD",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436139998,
    "dropphyadd": "2618 TREMAINSVILLE RD",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436139998,
    "dropmaladd": "2618 TREMAINSVILLE RD",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436139998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194719091,
    "dropsitcph": 4194719091,
    "dropfax": 4194757057
  },
  {
    "dcode": "D",
    "dropkey": "SX23329",
    "droptype": "D",
    "dropname": "WEST PARK",
    "dropdeladd": "14500 LORAIN AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441119998,
    "dropphyadd": "14500 LORAIN AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441119998,
    "dropmaladd": "14500 LORAIN AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441119998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2166710606,
    "dropfax": 2166713815
  },
  {
    "dcode": "D",
    "dropkey": "SX23336",
    "droptype": "D",
    "dropname": "WEST SIDE",
    "dropdeladd": "2030 MAHONING AVE",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445099998,
    "dropphyadd": "2030 MAHONING AVE",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445099998,
    "dropmaladd": "2030 MAHONING AVE",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445099998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307408872,
    "dropsitcph": 3307995142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23337",
    "droptype": "D",
    "dropname": "WEST TOLEDO",
    "dropdeladd": "1568 W SYLVANIA AVE",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436129998,
    "dropphyadd": "1568 W SYLVANIA AVE",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436129998,
    "dropmaladd": "1568 W SYLVANIA AVE",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436129998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4194767305,
    "dropsitcph": 4194767305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23344",
    "droptype": "D",
    "dropname": "WEST WORTHINGTON",
    "dropdeladd": "6316 NICHOLAS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432359998,
    "dropphyadd": "6316 NICHOLAS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432359998,
    "dropmaladd": "6316 NICHOLAS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432359998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6147938789,
    "dropsitcph": 6147938789,
    "dropfax": 6147982128
  },
  {
    "dcode": "D",
    "dropkey": "SX23393",
    "droptype": "D",
    "dropname": "WILLOW",
    "dropdeladd": "5725 PORTAGE AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441279998,
    "dropphyadd": "5725 PORTAGE AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441279998,
    "dropmaladd": "5725 PORTAGE AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441279998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2162715489,
    "dropfax": 2162715722
  },
  {
    "dcode": "D",
    "dropkey": "SX23432",
    "droptype": "D",
    "dropname": "WRIGHT BROTHERS",
    "dropdeladd": "1 OAKWOOD AVE",
    "dropdelcty": "OAKWOOD",
    "dropdelst": "OH",
    "dropdelzpp": 454099998,
    "dropphyadd": "1 OAKWOOD AVE",
    "dropphycty": "OAKWOOD",
    "dropphyst": "OH",
    "dropphyzpp": 454099998,
    "dropmaladd": "1 OAKWOOD AVE",
    "dropmalcty": "OAKWOOD",
    "dropmalst": "OH",
    "dropmalzpp": 454099998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372991465,
    "dropsitcph": 9372991465,
    "dropfax": 9372998217
  },
  {
    "dcode": "D",
    "dropkey": "SX23497",
    "droptype": "D",
    "dropname": "ASHLEY RIVER",
    "dropdeladd": "1964 ASHLEY RIVER RD STE B",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294074782,
    "dropphyadd": "1964 ASHLEY RIVER RD STE B",
    "dropphycty": "CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294074782,
    "dropmaladd": "1964 ASHLEY RIVER RD STE B",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294074782,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437630113,
    "dropsitcph": 8437630113,
    "dropfax": 8437630415
  },
  {
    "dcode": "D",
    "dropkey": "SX23502",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "19 CONESTEE AVE",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296049998,
    "dropphyadd": "19 CONESTEE AVE",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296049998,
    "dropmaladd": "19 CONESTEE AVE",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296049998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642716623,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23541",
    "droptype": "D",
    "dropname": "BEREA",
    "dropdeladd": "7500 WHITE HORSE RD",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296109998,
    "dropphyadd": "7500 WHITE HORSE RD",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296109998,
    "dropmaladd": "7500 WHITE HORSE RD",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296109998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642460053,
    "dropfax": 8642948453
  },
  {
    "dcode": "D",
    "dropkey": "SX23632",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "1233 MARION ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292019997,
    "dropphyadd": "1233 MARION ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292019997,
    "dropmaladd": "1233 MARION ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292019997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334730,
    "dropfax": 8037334710
  },
  {
    "dcode": "D",
    "dropkey": "SX23685",
    "droptype": "D",
    "dropname": "CHERRY ROAD",
    "dropdeladd": "725 CHERRY RD STE 169",
    "dropdelcty": "ROCK HILL",
    "dropdelst": "SC",
    "dropdelzpp": 297323152,
    "dropphyadd": "725 CHERRY RD STE 169",
    "dropphycty": "ROCK HILL",
    "dropphyst": "SC",
    "dropphyzpp": 297323152,
    "dropmaladd": "725 CHERRY RD STE 169",
    "dropmalcty": "ROCK HILL",
    "dropmalst": "SC",
    "dropmalzpp": 297323152,
    "dropsitphn": 7043934581,
    "dropsitlph": 8033271054,
    "dropsitcph": 8033271054,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23714",
    "droptype": "D",
    "dropname": "COASTAL",
    "dropdeladd": "4009 HIGHWAY 17 S",
    "dropdelcty": "NORTH MYRTLE BEACH",
    "dropdelst": "SC",
    "dropdelzpp": 295825060,
    "dropphyadd": "4009 HIGHWAY 17 S",
    "dropphycty": "NORTH MYRTLE BEACH",
    "dropphyst": "SC",
    "dropphyzpp": 295825097,
    "dropmaladd": "4009 HIGHWAY 17 S",
    "dropmalcty": "NORTH MYRTLE BEACH",
    "dropmalst": "SC",
    "dropmalzpp": 295825060,
    "dropsitphn": 8039266014,
    "dropsitlph": 8432491023,
    "dropsitcph": 8432725864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23729",
    "droptype": "D",
    "dropname": "COLUMBIA AMF",
    "dropdeladd": "1535 PLATT SPRINGS RD",
    "dropdelcty": "WEST COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 291699997,
    "dropphyadd": "1535 PLATT SPRINGS RD",
    "dropphycty": "WEST COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 291699997,
    "dropmaladd": "1535 PLATT SPRINGS RD",
    "dropmalcty": "WEST COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 291699997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037960455,
    "dropfax": 8038224161
  },
  {
    "dcode": "D",
    "dropkey": "SX23818",
    "droptype": "D",
    "dropname": "DUTCH FORK",
    "dropdeladd": "1120 BRIARGATE CIR",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292109998,
    "dropphyadd": "1120 BRIARGATE CIR",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292109998,
    "dropmaladd": "1120 BRIARGATE CIR",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292109998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037727894,
    "dropfax": 8037319390
  },
  {
    "dcode": "D",
    "dropkey": "SX23827",
    "droptype": "D",
    "dropname": "EAST BAY",
    "dropdeladd": "557 E BAY ST",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294036322,
    "dropphyadd": "557 E BAY ST",
    "dropphycty": "CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294039998,
    "dropmaladd": "PO BOX 2941398",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294139998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437271129,
    "dropsitcph": 8437271129,
    "dropfax": 8438057757
  },
  {
    "dcode": "D",
    "dropkey": "SX23834",
    "droptype": "D",
    "dropname": "EAU CLAIRE",
    "dropdeladd": "4026 LAMAR ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292039998,
    "dropphyadd": "4026 LAMAR ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292039998,
    "dropmaladd": "4026 LAMAR ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292039998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334626,
    "dropfax": 8032548151
  },
  {
    "dcode": "D",
    "dropkey": "SX23840",
    "droptype": "D",
    "dropname": "EDGEWOOD",
    "dropdeladd": "2638 TWO NOTCH RD STE 112",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292041473,
    "dropphyadd": "2638 TWO NOTCH RD STE 112",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292041473,
    "dropmaladd": "2638 TWO NOTCH RD STE 112",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292041473,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334755,
    "dropfax": 8037652790
  },
  {
    "dcode": "D",
    "dropkey": "SX23864",
    "droptype": "D",
    "dropname": "FAIRFIELD",
    "dropdeladd": "213 WILLIAM HILTON PKWY",
    "dropdelcty": "HILTON HEAD ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 299269998,
    "dropphyadd": "213 WILLIAM HILTON PKWY",
    "dropphycty": "HILTON HEAD ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 299269998,
    "dropmaladd": "213 WILLIAM HILTON PKWY",
    "dropmalcty": "HILTON HEAD ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 299269998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8436823002,
    "dropsitcph": 8436823002,
    "dropfax": 8436893548
  },
  {
    "dcode": "D",
    "dropkey": "SX23875",
    "droptype": "D",
    "dropname": "FEDERAL FLORENCE",
    "dropdeladd": "401 W EVANS ST",
    "dropdelcty": "FLORENCE",
    "dropdelst": "SC",
    "dropdelzpp": 295019997,
    "dropphyadd": "401 W EVANS ST",
    "dropphycty": "FLORENCE",
    "dropphyst": "SC",
    "dropphyzpp": 295019997,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "FLORENCE",
    "dropmalst": "SC",
    "dropmalzpp": 295039998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436655289,
    "dropsitcph": 8436655289,
    "dropfax": 8436655289
  },
  {
    "dcode": "D",
    "dropkey": "SX23876",
    "droptype": "D",
    "dropname": "FEDERAL GREENVILLE",
    "dropdeladd": "300 E WASHINGTON ST RM 105",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296039998,
    "dropphyadd": "300 E WASHINGTON ST RM 105",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296039998,
    "dropmaladd": "300 E WASHINGTON ST RM 105",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296039998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642716744,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX23883",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "2108 GREENE ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292059998,
    "dropphyadd": "2108 GREENE ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292059998,
    "dropmaladd": "2108 GREENE ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292059998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334630,
    "dropfax": 8032564963
  },
  {
    "dcode": "D",
    "dropkey": "SX23898",
    "droptype": "D",
    "dropname": "FOREST ACRES",
    "dropdeladd": "4840 FOREST DR",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292069998,
    "dropphyadd": "4840 FOREST DR",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292069998,
    "dropmaladd": "4840 FOREST DR",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292069998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037388076,
    "dropfax": 8037877915
  },
  {
    "dcode": "D",
    "dropkey": "SX23986",
    "droptype": "D",
    "dropname": "GREENVILLE AIRPORT",
    "dropdeladd": "1900 GSP DR STE 29",
    "dropdelcty": "GREER",
    "dropdelst": "SC",
    "dropdelzpp": 296519997,
    "dropphyadd": "1900 GSP DR STE 29",
    "dropphycty": "GREER",
    "dropphyst": "SC",
    "dropphyzpp": 296519997,
    "dropmaladd": "1900 GSP DR STE 29",
    "dropmalcty": "GREER",
    "dropmalst": "SC",
    "dropmalzpp": 296519997,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8648480470,
    "dropfax": 8648489887
  },
  {
    "dcode": "D",
    "dropkey": "SX24007",
    "droptype": "D",
    "dropname": "HARBOURTOWN",
    "dropdeladd": "71 LIGHTHOUSE RD STE 1",
    "dropdelcty": "HILTON HEAD ISLAND",
    "dropdelst": "SC",
    "dropdelzpp": 299287227,
    "dropphyadd": "71 LIGHTHOUSE RD STE 1",
    "dropphycty": "HILTON HEAD ISLAND",
    "dropphyst": "SC",
    "dropphyzpp": 299287227,
    "dropmaladd": "71 LIGHTHOUSE RD STE 1",
    "dropmalcty": "HILTON HEAD ISLAND",
    "dropmalst": "SC",
    "dropmalzpp": 299287227,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 8436712002,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX24071",
    "droptype": "D",
    "dropname": "JAMES ISLAND",
    "dropdeladd": "579 FOLLY RD",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294123005,
    "dropphyadd": "579 FOLLY RD",
    "dropphycty": "CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294123005,
    "dropmaladd": "PO BOX 29422",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294229998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437955006,
    "dropsitcph": 8437955006,
    "dropfax": 8437953136
  },
  {
    "dcode": "D",
    "dropkey": "SX24146",
    "droptype": "D",
    "dropname": "LEESBURG",
    "dropdeladd": "7406 GARNERS FERRY RD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292099998,
    "dropphyadd": "7406 GARNERS FERRY RD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292099998,
    "dropmaladd": "7406 GARNERS FERRY RD",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292099998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037766178,
    "dropfax": 8037835936
  },
  {
    "dcode": "D",
    "dropkey": "SX24343",
    "droptype": "D",
    "dropname": "NORTH ANDERSON",
    "dropdeladd": "3420 CLEMSON BLVD STE 4",
    "dropdelcty": "ANDERSON",
    "dropdelst": "SC",
    "dropdelzpp": 296239998,
    "dropphyadd": "3420 CLEMSON BLVD STE 4",
    "dropphycty": "ANDERSON",
    "dropphyst": "SC",
    "dropphyzpp": 296239998,
    "dropmaladd": "3420 CLEMSON BLVD STE 4",
    "dropmalcty": "ANDERSON",
    "dropmalst": "SC",
    "dropmalzpp": 296239998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642255389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX24364",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "8505 TWO NOTCH RD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292239998,
    "dropphyadd": "8505 TWO NOTCH RD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292239998,
    "dropmaladd": "8505 TWO NOTCH RD",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292239998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037362262,
    "dropfax": 8037360993
  },
  {
    "dcode": "D",
    "dropkey": "SX24388",
    "droptype": "D",
    "dropname": "KEITH D OGLESBY",
    "dropdeladd": "100 ORCHARD PARK DR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296169998,
    "dropphyadd": "100 ORCHARD PARK DR",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296169998,
    "dropmaladd": "100 ORCHARD PARK DR",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296169998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642885207,
    "dropfax": 8646750506
  },
  {
    "dcode": "D",
    "dropkey": "SX24406",
    "droptype": "D",
    "dropname": "PARK PLACE",
    "dropdeladd": "2431 N PLEASANTBURG DR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296089998,
    "dropphyadd": "2431 N PLEASANTBURG DR",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296089998,
    "dropmaladd": "2431 N PLEASANTBURG DR",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296089998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642716606,
    "dropfax": 8642719860
  },
  {
    "dcode": "D",
    "dropkey": "SX24436",
    "droptype": "D",
    "dropname": "PINEHAVEN",
    "dropdeladd": "2180 MCMILLAN AVE",
    "dropdelcty": "NORTH CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294055723,
    "dropphyadd": "2180 MCMILLAN AVE",
    "dropphycty": "NORTH CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294055723,
    "dropmaladd": "PO BOX 2941598",
    "dropmalcty": "NORTH CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294159998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437447810,
    "dropsitcph": 8437447810,
    "dropfax": 8037441607
  },
  {
    "dcode": "D",
    "dropkey": "SX24454",
    "droptype": "D",
    "dropname": "PLEASANTBURG",
    "dropdeladd": "1521 LAURENS RD",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296069998,
    "dropphyadd": "1521 LAURENS RD",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296069998,
    "dropmaladd": "1521 LAURENS RD",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296069998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642714094,
    "dropfax": 8642710596
  },
  {
    "dcode": "D",
    "dropkey": "SX24541",
    "droptype": "D",
    "dropname": "SAINT ANDREWS",
    "dropdeladd": "78 SYCAMORE AVE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "SC",
    "dropdelzpp": 294076706,
    "dropphyadd": "78 SYCAMORE AVE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "SC",
    "dropphyzpp": 294079997,
    "dropmaladd": "PO BOX 2941798",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "SC",
    "dropmalzpp": 294179998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8437664031,
    "dropsitcph": 8437664031,
    "dropfax": 8437635497
  },
  {
    "dcode": "D",
    "dropkey": "SX24624",
    "droptype": "D",
    "dropname": "SOUTH ANDERSON",
    "dropdeladd": "2815 S MAIN ST",
    "dropdelcty": "ANDERSON",
    "dropdelst": "SC",
    "dropdelzpp": 296249998,
    "dropphyadd": "2815 S MAIN ST",
    "dropphycty": "ANDERSON",
    "dropphyst": "SC",
    "dropphyzpp": 296249998,
    "dropmaladd": "2815 S MAIN ST",
    "dropmalcty": "ANDERSON",
    "dropmalst": "SC",
    "dropmalzpp": 296249998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8642265698,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX24682",
    "droptype": "D",
    "dropname": "SUMMERALL",
    "dropdeladd": "758 SILVER BLUFF RD",
    "dropdelcty": "AIKEN",
    "dropdelst": "SC",
    "dropdelzpp": 298039998,
    "dropphyadd": "758 SILVER BLUFF RD",
    "dropphycty": "AIKEN",
    "dropphyst": "SC",
    "dropphyzpp": 298039998,
    "dropmaladd": "758 SILVER BLUFF RD",
    "dropmalcty": "AIKEN",
    "dropmalst": "SC",
    "dropmalzpp": 298039998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8036499317,
    "dropsitcph": 8036499317,
    "dropfax": 8036496083
  },
  {
    "dcode": "D",
    "dropkey": "SX24847",
    "droptype": "D",
    "dropname": "ACKLEN",
    "dropdeladd": "2006 ACKLEN AVE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372129998,
    "dropphyadd": "2006 ACKLEN AVE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372129998,
    "dropmaladd": "2006 ACKLEN AVE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372129998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153866454,
    "dropsitcph": 6153835396,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX24871",
    "droptype": "D",
    "dropname": "ARCADE",
    "dropdeladd": "16 ARCADE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372199998,
    "dropphyadd": "16 ARCADE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372199998,
    "dropmaladd": "16 ARCADE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152482287,
    "dropsitcph": 6152480965,
    "dropfax": 6152547019
  },
  {
    "dcode": "D",
    "dropkey": "SX24915",
    "droptype": "D",
    "dropname": "BELLE MEADE",
    "dropdeladd": "5421 HIGHWAY 100",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372059998,
    "dropphyadd": "5421 HIGHWAY 100",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372059998,
    "dropmaladd": "5421 HIGHWAY 100",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153567465,
    "dropsitcph": 6153523442,
    "dropfax": 6153520367
  },
  {
    "dcode": "D",
    "dropkey": "SX24922",
    "droptype": "D",
    "dropname": "BEMIS",
    "dropdeladd": "207 S MISSOURI ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383017464,
    "dropphyadd": "207 S MISSOURI ST",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383017464,
    "dropmaladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7314232596,
    "dropsitcph": 7314232596,
    "dropfax": 7312651789
  },
  {
    "dcode": "D",
    "dropkey": "SX24949",
    "droptype": "D",
    "dropname": "EASTGATE",
    "dropdeladd": "711 EASTGATE LOOP",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374119998,
    "dropphyadd": "711 EASTGATE LOOP",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374119998,
    "dropmaladd": "711 EASTGATE LOOP",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238922047,
    "dropsitcph": 4238922047,
    "dropfax": 4234858953
  },
  {
    "dcode": "D",
    "dropkey": "SX24954",
    "droptype": "D",
    "dropname": "BROADWAY RETAIL",
    "dropdeladd": "901 BROADWAY",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372024105,
    "dropphyadd": "901 BROADWAY",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372024105,
    "dropmaladd": "901 BROADWAY",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372024105,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152553613,
    "dropsitcph": 6152553613,
    "dropfax": 6152559444
  },
  {
    "dcode": "D",
    "dropkey": "SX24971",
    "droptype": "D",
    "dropname": "BURLINGTON",
    "dropdeladd": "300 MACEDONIA LN",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379149998,
    "dropphyadd": "300 MACEDONIA LN",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379149998,
    "dropmaladd": "300 MACEDONIA LN",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379149998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655254045,
    "dropsitcph": 8655251901,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX24981",
    "droptype": "D",
    "dropname": "CARROLL REECE",
    "dropdeladd": "1100 N STATE OF FRANKLIN RD",
    "dropdelcty": "JOHNSON CITY",
    "dropdelst": "TN",
    "dropdelzpp": 376049998,
    "dropphyadd": "1100 N STATE OF FRANKLIN RD",
    "dropphycty": "JOHNSON CITY",
    "dropphyst": "TN",
    "dropphyzpp": 376049998,
    "dropmaladd": "1100 N STATE OF FRANKLIN RD",
    "dropmalcty": "JOHNSON CITY",
    "dropmalst": "TN",
    "dropmalzpp": 376049998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232834966,
    "dropsitcph": 4232834966,
    "dropfax": 4232835469
  },
  {
    "dcode": "D",
    "dropkey": "SX25008",
    "droptype": "D",
    "dropname": "CHICKAMAUGA",
    "dropdeladd": "7610 E BRAINERD RD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374213167,
    "dropphyadd": "7610 E BRAINERD RD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374213167,
    "dropmaladd": "7610 E BRAINERD RD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374213167,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235109377,
    "dropsitcph": 4235100759,
    "dropfax": 4234900316
  },
  {
    "dcode": "D",
    "dropkey": "SX25040",
    "droptype": "D",
    "dropname": "COLONIAL",
    "dropdeladd": "4695 SOUTHERN AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381174809,
    "dropphyadd": "4695 SOUTHERN AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381174809,
    "dropmaladd": "4695 SOUTHERN AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381174809,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017619095,
    "dropsitcph": 9017611826,
    "dropfax": 9017612823
  },
  {
    "dcode": "D",
    "dropkey": "SX25078",
    "droptype": "D",
    "dropname": "CROSSTOWN FINANCE UNIT",
    "dropdeladd": "1520 UNION AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381049997,
    "dropphyadd": "1520 UNION AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381049997,
    "dropmaladd": "1520 UNION AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381049997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9012789938,
    "dropfax": 9017269475
  },
  {
    "dcode": "D",
    "dropkey": "SX25115",
    "droptype": "D",
    "dropname": "DONELSON",
    "dropdeladd": "215 DONELSON PIKE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372149998,
    "dropphyadd": "215 DONELSON PIKE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372149998,
    "dropmaladd": "215 DONELSON PIKE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372149998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158898653,
    "dropsitcph": 6153912305,
    "dropfax": 6158853662
  },
  {
    "dcode": "D",
    "dropkey": "SX25118",
    "droptype": "D",
    "dropname": "DOWNTOWN CHATTANOOGA",
    "dropdeladd": "910 GEORGIA AVE",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374022228,
    "dropphyadd": "910 GEORGIA AVE",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374022228,
    "dropmaladd": "910 GEORGIA AVE",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374022228,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232676208,
    "dropsitcph": 4232671609,
    "dropfax": 4232666267
  },
  {
    "dcode": "D",
    "dropkey": "SX25120",
    "droptype": "D",
    "dropname": "DOWNTOWN CLEVELAND",
    "dropdeladd": "155 BROAD ST NW",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "TN",
    "dropdelzpp": 373115082,
    "dropphyadd": "155 BROAD ST NW",
    "dropphycty": "CLEVELAND",
    "dropphyst": "TN",
    "dropphyzpp": 373115082,
    "dropmaladd": "155 BROAD ST NW",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "TN",
    "dropmalzpp": 373115082,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236145280,
    "dropsitcph": 4236145280,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25121",
    "droptype": "D",
    "dropname": "DOWNTOWN KNOXVILLE",
    "dropdeladd": "501 W MAIN ST",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379029998,
    "dropphyadd": "501 W MAIN ST",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379029998,
    "dropmaladd": "501 W MAIN ST",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379029998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655258240,
    "dropsitcph": 8655255929,
    "dropfax": 8655219520
  },
  {
    "dcode": "D",
    "dropkey": "SX25139",
    "droptype": "D",
    "dropname": "EAST MEMPHIS",
    "dropdeladd": "13 S PRESCOTT ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381119997,
    "dropphyadd": "13 S PRESCOTT ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381119997,
    "dropmaladd": "13 S PRESCOTT ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381119997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9014526532,
    "dropfax": 9013231237
  },
  {
    "dcode": "D",
    "dropkey": "SX25141",
    "droptype": "D",
    "dropname": "EAST NASHVILLE",
    "dropdeladd": "1109 WOODLAND ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372069998,
    "dropphyadd": "1109 WOODLAND ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372069998,
    "dropmaladd": "1109 WOODLAND ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372069998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6156506442,
    "dropsitcph": 6156505327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25147",
    "droptype": "D",
    "dropname": "EAST CHATTANOOGA",
    "dropdeladd": "2200 AMNICOLA HWY",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374069998,
    "dropphyadd": "2200 AMNICOLA HWY",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374069998,
    "dropmaladd": "2200 AMNICOLA HWY",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374069998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236981889,
    "dropsitcph": 4236296652,
    "dropfax": 4236220190
  },
  {
    "dcode": "D",
    "dropkey": "SX25216",
    "droptype": "D",
    "dropname": "FOUNTAIN CITY",
    "dropdeladd": "131 LYNNWOOD DR",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379189998,
    "dropphyadd": "131 LYNNWOOD DR",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379189998,
    "dropmaladd": "131 LYNNWOOD DR",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8656877983,
    "dropsitcph": 8656877985,
    "dropfax": 8656879800
  },
  {
    "dcode": "D",
    "dropkey": "SX25220",
    "droptype": "D",
    "dropname": "FRAYSER",
    "dropdeladd": "3057 BASKIN ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381279998,
    "dropphyadd": "3057 BASKIN ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381279998,
    "dropmaladd": "3057 BASKIN ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381279998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9013576497,
    "dropfax": 9013572657
  },
  {
    "dcode": "D",
    "dropkey": "SX25233",
    "droptype": "D",
    "dropname": "GENERAL MAIL FACILITY",
    "dropdeladd": "1237 E WEISGARBER RD",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379508507,
    "dropphyadd": "1237 E WEISGARBER RD",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379508507,
    "dropmaladd": "1237 E WEISGARBER RD",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379508507,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655584629,
    "dropsitcph": 8655584664,
    "dropfax": 8655584521
  },
  {
    "dcode": "D",
    "dropkey": "SX25247",
    "droptype": "D",
    "dropname": "GLENVIEW",
    "dropdeladd": "301 EZELL PIKE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372179998,
    "dropphyadd": "301 EZELL PIKE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372179998,
    "dropmaladd": "301 EZELL PIKE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153997590,
    "dropsitcph": 6153673069,
    "dropfax": 6153670348
  },
  {
    "dcode": "D",
    "dropkey": "SX25267",
    "droptype": "D",
    "dropname": "GREEN HILLS",
    "dropdeladd": "1906 GLEN ECHO RD",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372159998,
    "dropphyadd": "1906 GLEN ECHO RD",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372159998,
    "dropmaladd": "1906 GLEN ECHO RD",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153861269,
    "dropsitcph": 6152924590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25282",
    "droptype": "D",
    "dropname": "HALLS STATION",
    "dropdeladd": "7450 MAYNARDVILLE PIKE",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379389998,
    "dropphyadd": "7450 MAYNARDVILLE PIKE",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379389998,
    "dropmaladd": "7450 MAYNARDVILLE PIKE",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379389998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659225127,
    "dropsitcph": 8659250155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25301",
    "droptype": "D",
    "dropname": "HENRY STREET",
    "dropdeladd": "134 N HENRY ST",
    "dropdelcty": "MORRISTOWN",
    "dropdelst": "TN",
    "dropdelzpp": 378149998,
    "dropphyadd": "134 N HENRY ST",
    "dropphycty": "MORRISTOWN",
    "dropphyst": "TN",
    "dropphyzpp": 378149998,
    "dropmaladd": "803 S CUMBERLAND ST",
    "dropmalcty": "MORRISTOWN",
    "dropmalst": "TN",
    "dropmalzpp": 378139998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4235818471,
    "dropsitcph": 4235815572,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25304",
    "droptype": "D",
    "dropname": "HICKORY HILL",
    "dropdeladd": "3735 HICKORY HILL RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381159998,
    "dropphyadd": "3735 HICKORY HILL RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381159998,
    "dropmaladd": "3735 HICKORY HILL RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381159998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013638733,
    "dropsitcph": 9013601594,
    "dropfax": 9013627622
  },
  {
    "dcode": "D",
    "dropkey": "SX25309",
    "droptype": "D",
    "dropname": "HIGHLAND HEIGHTS",
    "dropdeladd": "680 NATIONAL ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381229998,
    "dropphyadd": "680 NATIONAL ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381229998,
    "dropmaladd": "680 NATIONAL ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013230526,
    "dropsitcph": 9013230493,
    "dropfax": 9014526857
  },
  {
    "dcode": "D",
    "dropkey": "SX25311",
    "droptype": "D",
    "dropname": "HIGHLAND PARK",
    "dropdeladd": "511 S HAWTHORNE ST",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374049998,
    "dropphyadd": "511 S HAWTHORNE ST",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374049998,
    "dropmaladd": "511 S HAWTHORNE ST",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374049998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4236229597,
    "dropsitcph": 4236229365,
    "dropfax": 4236223154
  },
  {
    "dcode": "D",
    "dropkey": "SX25314",
    "droptype": "D",
    "dropname": "HILLDALE",
    "dropdeladd": "303 HOLLY CIR",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370439998,
    "dropphyadd": "303 HOLLY CIR",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370439998,
    "dropmaladd": "303 HOLLY CIR",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370439998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316472357,
    "dropsitcph": 9316472357,
    "dropfax": 9319202303
  },
  {
    "dcode": "D",
    "dropkey": "SX25321",
    "droptype": "D",
    "dropname": "HOLIDAY CITY",
    "dropdeladd": "3715 WINCHESTER RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381189998,
    "dropphyadd": "3715 WINCHESTER RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381189998,
    "dropmaladd": "3715 WINCHESTER RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381189998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013639573,
    "dropsitcph": 9013639573,
    "dropfax": 9013634247
  },
  {
    "dcode": "D",
    "dropkey": "SX25327",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "1283 TUNICA ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381089998,
    "dropphyadd": "1283 TUNICA ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381089998,
    "dropmaladd": "1283 TUNICA ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381089998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9012784215,
    "dropsitcph": 9017265274,
    "dropfax": 9017269618
  },
  {
    "dcode": "D",
    "dropkey": "SX25354",
    "droptype": "D",
    "dropname": "JACKSON SQUARE",
    "dropdeladd": "108 ADMINISTRATION RD",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "TN",
    "dropdelzpp": 378309997,
    "dropphyadd": "108 ADMINISTRATION RD",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "TN",
    "dropphyzpp": 378309997,
    "dropmaladd": "108 ADMINISTRATION RD",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "TN",
    "dropmalzpp": 378309997,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654810471,
    "dropsitcph": 8654810471,
    "dropfax": 8654829299
  },
  {
    "dcode": "D",
    "dropkey": "SX25363",
    "droptype": "D",
    "dropname": "JERE BAXTER",
    "dropdeladd": "1011 GILLOCK ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372169998,
    "dropphyadd": "1011 GILLOCK ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372169998,
    "dropmaladd": "1011 GILLOCK ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152280446,
    "dropsitcph": 6152275201,
    "dropfax": 6152263966
  },
  {
    "dcode": "D",
    "dropkey": "SX25398",
    "droptype": "D",
    "dropname": "LAMAR",
    "dropdeladd": "1458 S TREZEVANT ST",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381149997,
    "dropphyadd": "1458 S TREZEVANT ST",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381149997,
    "dropmaladd": "1458 S TREZEVANT ST",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381149997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9014526451,
    "dropsitcph": 9013245255,
    "dropfax": 9013231046
  },
  {
    "dcode": "D",
    "dropkey": "SX25458",
    "droptype": "D",
    "dropname": "MALLORY",
    "dropdeladd": "193 E MITCHELL RD",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381099998,
    "dropphyadd": "193 E MITCHELL RD",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381099998,
    "dropmaladd": "193 E MITCHELL RD",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381099998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013451737,
    "dropsitcph": 9013449840,
    "dropfax": 9013329396
  },
  {
    "dcode": "D",
    "dropkey": "SX25562",
    "droptype": "D",
    "dropname": "MURRAY LAKE HILLS",
    "dropdeladd": "4420 OAKWOOD DR",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374169998,
    "dropphyadd": "4420 OAKWOOD DR",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374169998,
    "dropmaladd": "4420 OAKWOOD DR",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234999662,
    "dropsitcph": 4234999662,
    "dropfax": 4238926007
  },
  {
    "dcode": "D",
    "dropkey": "SX25580",
    "droptype": "D",
    "dropname": "RINGGOLD MILL",
    "dropdeladd": "2011 FORT CAMPBELL BLVD",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370429998,
    "dropphyadd": "2011 FORT CAMPBELL BLVD",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370429998,
    "dropmaladd": "2011 FORT CAMPBELL BLVD",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370429998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316456085,
    "dropsitcph": 9316456085,
    "dropfax": 9316457282
  },
  {
    "dcode": "D",
    "dropkey": "SX25595",
    "droptype": "D",
    "dropname": "NORTH MEMPHIS",
    "dropdeladd": "780 FIRESTONE AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381079998,
    "dropphyadd": "780 FIRESTONE AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381079998,
    "dropmaladd": "780 FIRESTONE AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381079998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9015221257,
    "dropfax": 9015229542
  },
  {
    "dcode": "D",
    "dropkey": "SX25597",
    "droptype": "D",
    "dropname": "METRO",
    "dropdeladd": "2245 ROSA L PARKS BLVD",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372289998,
    "dropphyadd": "2245 ROSA L PARKS BLVD",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372289998,
    "dropmaladd": "2245 ROSA L PARKS BLVD",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152545505,
    "dropsitcph": 6152427581,
    "dropfax": 6152598944
  },
  {
    "dcode": "D",
    "dropkey": "SX25601",
    "droptype": "D",
    "dropname": "NORTH CHATTANOOGA",
    "dropdeladd": "134 N MARKET ST",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374059998,
    "dropphyadd": "134 N MARKET ST",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374059998,
    "dropmaladd": "134 N MARKET ST",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232654537,
    "dropsitcph": 4232654302,
    "dropfax": 4232666664
  },
  {
    "dcode": "D",
    "dropkey": "SX25602",
    "droptype": "D",
    "dropname": "NORTH KNOXVILLE",
    "dropdeladd": "2600 N BROADWAY ST",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379179998,
    "dropphyadd": "2600 N BROADWAY ST",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379179998,
    "dropmaladd": "2600 N BROADWAY ST",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655253857,
    "dropsitcph": 8655252039,
    "dropfax": 8655214928
  },
  {
    "dcode": "D",
    "dropkey": "SX25604",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "2325 DICKERSON PIKE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372079998,
    "dropphyadd": "2325 DICKERSON PIKE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372079998,
    "dropmaladd": "2325 DICKERSON PIKE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372079998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152627036,
    "dropsitcph": 6152623215,
    "dropfax": 6152277954
  },
  {
    "dcode": "D",
    "dropkey": "SX25605",
    "droptype": "D",
    "dropname": "NORWOOD",
    "dropdeladd": "5727 CLINTON HWY",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379129998,
    "dropphyadd": "5727 CLINTON HWY",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379129998,
    "dropmaladd": "5727 CLINTON HWY",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379129998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8656871879,
    "dropsitcph": 8656871879,
    "dropfax": 8656879951
  },
  {
    "dcode": "D",
    "dropkey": "SX25679",
    "droptype": "D",
    "dropname": "RALEIGH",
    "dropdeladd": "3711 AUSTIN PEAY HWY",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381289998,
    "dropphyadd": "3711 AUSTIN PEAY HWY",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381289998,
    "dropmaladd": "3711 AUSTIN PEAY HWY",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381289998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212208,
    "dropsitcph": 9013861244,
    "dropfax": 9013738385
  },
  {
    "dcode": "D",
    "dropkey": "SX25701",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "1035 HARBOR AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381139997,
    "dropphyadd": "1035 HARBOR AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381139997,
    "dropmaladd": "161 E GE PATTERSON AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381034520,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017753372,
    "dropsitcph": 9019472273,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25782",
    "droptype": "D",
    "dropname": "SOUTH CHATTANOOGA",
    "dropdeladd": "1101 W 40TH ST",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374099998,
    "dropphyadd": "1101 W 40TH ST",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374099998,
    "dropmaladd": "1101 W 40TH ST",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374099998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4238219394,
    "dropsitcph": 4238211194,
    "dropfax": 4238211261
  },
  {
    "dcode": "D",
    "dropkey": "SX25784",
    "droptype": "D",
    "dropname": "SOUTH NASHVILLE",
    "dropdeladd": "714 FESSLERS LN",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372109998,
    "dropphyadd": "714 FESSLERS LN",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372109998,
    "dropmaladd": "714 FESSLERS LN",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372109998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152564923,
    "dropsitcph": 6152514956,
    "dropfax": 6152426271
  },
  {
    "dcode": "D",
    "dropkey": "SX25789",
    "droptype": "D",
    "dropname": "SOUTH KNOXVILLE",
    "dropdeladd": "137 E YOUNG HIGH PIKE",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379209998,
    "dropphyadd": "137 E YOUNG HIGH PIKE",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379209998,
    "dropmaladd": "137 E YOUNG HIGH PIKE",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379209998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655738663,
    "dropsitcph": 8655734871,
    "dropfax": 8655779546
  },
  {
    "dcode": "D",
    "dropkey": "SX25837",
    "droptype": "D",
    "dropname": "STEPHEN HOLSTON",
    "dropdeladd": "418 BLUFF CITY HWY STE I",
    "dropdelcty": "BRISTOL",
    "dropdelst": "TN",
    "dropdelzpp": 376200800,
    "dropphyadd": "418 BLUFF CITY HWY STE I",
    "dropphycty": "BRISTOL",
    "dropphyst": "TN",
    "dropphyzpp": 376200800,
    "dropmaladd": "418 BLUFF CITY HWY STE I",
    "dropmalcty": "BRISTOL",
    "dropmalst": "TN",
    "dropmalzpp": 376200800,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4238440948,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25859",
    "droptype": "D",
    "dropname": "CEDAR BLUFF",
    "dropdeladd": "9039 CROSS PARK DR",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379239998,
    "dropphyadd": "9039 CROSS PARK DR",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379239998,
    "dropmaladd": "9039 CROSS PARK DR",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379239998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8657699207,
    "dropsitcph": 8656934751,
    "dropfax": 8656398261
  },
  {
    "dcode": "D",
    "dropkey": "SX25874",
    "droptype": "D",
    "dropname": "TOM MURRAY",
    "dropdeladd": "133 TUCKER ST",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383014034,
    "dropphyadd": "133 TUCKER ST",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383014034,
    "dropmaladd": "200 DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383019998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7314232596,
    "dropsitcph": 7314232596,
    "dropfax": 7319357201
  },
  {
    "dcode": "D",
    "dropkey": "SX25930",
    "droptype": "D",
    "dropname": "WEST",
    "dropdeladd": "4501 CHARLOTTE AVE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372099998,
    "dropphyadd": "4501 CHARLOTTE AVE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372099998,
    "dropmaladd": "4501 CHARLOTTE AVE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372099998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153854661,
    "dropsitcph": 6153832056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25932",
    "droptype": "D",
    "dropname": "WEST KNOXVILLE",
    "dropdeladd": "4434 SUTHERLAND AVE",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379199998,
    "dropphyadd": "4434 SUTHERLAND AVE",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379199998,
    "dropmaladd": "4434 SUTHERLAND AVE",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8654509965,
    "dropsitcph": 8655830206,
    "dropfax": 8655883304
  },
  {
    "dcode": "D",
    "dropkey": "SX25942",
    "droptype": "D",
    "dropname": "WHITE",
    "dropdeladd": "5821 PARK AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381199998,
    "dropphyadd": "5821 PARK AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381199998,
    "dropmaladd": "5821 PARK AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381199998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9016832613,
    "dropsitcph": 9016830675,
    "dropfax": 9016852248
  },
  {
    "dcode": "D",
    "dropkey": "SX25948",
    "droptype": "D",
    "dropname": "WHITEHAVEN",
    "dropdeladd": "1292 GATEWAY DR",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381169998,
    "dropphyadd": "1292 GATEWAY DR",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381169998,
    "dropmaladd": "1292 GATEWAY DR",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381169998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013964867,
    "dropsitcph": 9013451861,
    "dropfax": 9013329295
  },
  {
    "dcode": "D",
    "dropkey": "SX25975",
    "droptype": "D",
    "dropname": "WOODBINE",
    "dropdeladd": "4112 NOLENSVILLE PIKE",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372119998,
    "dropphyadd": "4112 NOLENSVILLE PIKE",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372119998,
    "dropmaladd": "4112 NOLENSVILLE PIKE",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372119998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158325928,
    "dropsitcph": 6153150564,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX25993",
    "droptype": "D",
    "dropname": "ACREDALE",
    "dropdeladd": "1225 KEMPSVILLE RD",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234649998,
    "dropphyadd": "1225 KEMPSVILLE RD",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234649998,
    "dropmaladd": "1225 KEMPSVILLE RD",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234649998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574247793,
    "dropsitcph": 7574248943,
    "dropfax": 7574246438
  },
  {
    "dcode": "D",
    "dropkey": "SX26071",
    "droptype": "D",
    "dropname": "BACKBAY",
    "dropdeladd": "1107 PRINCESS ANNE RD",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234579998,
    "dropphyadd": "1107 PRINCESS ANNE RD",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234579998,
    "dropmaladd": "1107 PRINCESS ANNE RD",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234579998,
    "dropsitphn": 7574260167,
    "dropsitlph": 7574260167,
    "dropsitcph": 7574260167,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26089",
    "droptype": "D",
    "dropname": "BARRACKS ROAD",
    "dropdeladd": "2150 WISE ST",
    "dropdelcty": "CHARLOTTESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229059998,
    "dropphyadd": "2150 WISE ST",
    "dropphycty": "CHARLOTTESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229059998,
    "dropmaladd": "2150 WISE ST",
    "dropmalcty": "CHARLOTTESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229059998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349773857,
    "dropsitcph": 4349632528,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26105",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "2109 THOROUGHGOOD RD",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234559998,
    "dropphyadd": "2109 THOROUGHGOOD RD",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234559998,
    "dropmaladd": "2109 THOROUGHGOOD RD",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234559998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574646242,
    "dropsitcph": 7573630358,
    "dropfax": 7574645396
  },
  {
    "dcode": "D",
    "dropkey": "SX26130",
    "droptype": "D",
    "dropname": "BERKLEY",
    "dropdeladd": "711 E LIBERTY ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235239998,
    "dropphyadd": "711 E LIBERTY ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235239998,
    "dropmaladd": "711 E LIBERTY ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235239998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575433952,
    "dropsitcph": 7575433952,
    "dropfax": 7575433952
  },
  {
    "dcode": "D",
    "dropkey": "SX26215",
    "droptype": "D",
    "dropname": "BUCKINGHAM",
    "dropdeladd": "235 N GLEBE RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222039998,
    "dropphyadd": "235 N GLEBE RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222039998,
    "dropmaladd": "235 N GLEBE RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222039998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039930072,
    "dropsitcph": 7035259441,
    "dropfax": 7035164406
  },
  {
    "dcode": "D",
    "dropkey": "SX26262",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "700 E MAIN ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232199998,
    "dropphyadd": "700 E MAIN ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232199998,
    "dropmaladd": "700 E MAIN ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232199998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047830723,
    "dropsitcph": 8047830723,
    "dropfax": 8046491933
  },
  {
    "dcode": "D",
    "dropkey": "SX26296",
    "droptype": "D",
    "dropname": "CENTRAL MARTINSVILLE",
    "dropdeladd": "1 W CHURCH ST",
    "dropdelcty": "MARTINSVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 241126229,
    "dropphyadd": "1 W CHURCH ST",
    "dropphycty": "MARTINSVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 241126229,
    "dropmaladd": "1 W CHURCH ST",
    "dropmalcty": "MARTINSVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 241126229,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 2766381607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26340",
    "droptype": "D",
    "dropname": "CHUCKATUCK",
    "dropdeladd": "109 KINGS HWY",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234329998,
    "dropphyadd": "109 KINGS HWY",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234329998,
    "dropmaladd": "109 KINGS HWY",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234329998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572550663,
    "dropsitcph": 7572550663,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26347",
    "droptype": "D",
    "dropname": "CHURCHLAND",
    "dropdeladd": "3590 TOWNE POINT RD",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "VA",
    "dropdelzpp": 237039998,
    "dropphyadd": "3590 TOWNE POINT RD",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "VA",
    "dropphyzpp": 237039998,
    "dropmaladd": "3590 TOWNE POINT RD",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "VA",
    "dropmalzpp": 237039998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574847543,
    "dropsitcph": 7574848249,
    "dropfax": 7574841043
  },
  {
    "dcode": "D",
    "dropkey": "SX26390",
    "droptype": "D",
    "dropname": "COLLEGE STATION",
    "dropdeladd": "1285 EMANCIPATION HWY",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 224019997,
    "dropphyadd": "1285 EMANCIPATION HWY",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 224019997,
    "dropmaladd": "1285 EMANCIPATION HWY",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 224019997,
    "dropsitphn": 8047756336,
    "dropsitlph": 5403614235,
    "dropsitcph": 5403614235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26414",
    "droptype": "D",
    "dropname": "COURT HOUSE ARLINGTON",
    "dropdeladd": "2043 WILSON BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222019997,
    "dropphyadd": "2043 WILSON BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222019997,
    "dropmaladd": "2043 WILSON BLVD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222019997,
    "dropsitphn": 7036986867,
    "dropsitlph": 7035254441,
    "dropsitcph": 7035254547,
    "dropfax": 7035254458
  },
  {
    "dcode": "D",
    "dropkey": "SX26439",
    "droptype": "D",
    "dropname": "CRITTENDEN",
    "dropdeladd": "1605 BRIDGE RD",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234339998,
    "dropphyadd": "1605 BRIDGE RD",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234339998,
    "dropmaladd": "1605 BRIDGE RD",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234339998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572383574,
    "dropsitcph": 7572383574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26456",
    "droptype": "D",
    "dropname": "CUSTOMHOUSE",
    "dropdeladd": "126 ATLANTIC ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235149998,
    "dropphyadd": "126 ATLANTIC ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235149998,
    "dropmaladd": "126 ATLANTIC ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235149998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576227318,
    "dropsitcph": 7576227318,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26463",
    "droptype": "D",
    "dropname": "DAM NECK",
    "dropdeladd": "1977 TERRIER AVE STE 100",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234619998,
    "dropphyadd": "1977 TERRIER AVE STE 100",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234619998,
    "dropmaladd": "1977 TERRIER AVE STE 100",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234619998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574926588,
    "dropsitcph": 7574926588,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26474",
    "droptype": "D",
    "dropname": "DEBREE",
    "dropdeladd": "417 W 20TH ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235179998,
    "dropphyadd": "417 W 20TH ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235179998,
    "dropmaladd": "417 W 20TH ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235179998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576256700,
    "dropsitcph": 7576256700,
    "dropfax": 7576253814
  },
  {
    "dcode": "D",
    "dropkey": "SX26476",
    "droptype": "D",
    "dropname": "DEEP CREEK",
    "dropdeladd": "857 GEORGE WASHINGTON HWY N",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233239998,
    "dropphyadd": "857 GEORGE WASHINGTON HWY N",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233239998,
    "dropmaladd": "857 GEORGE WASHINGTON HWY N",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233239998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574871625,
    "dropsitcph": 7574871625,
    "dropfax": 7575589907
  },
  {
    "dcode": "D",
    "dropkey": "SX26502",
    "droptype": "D",
    "dropname": "DOWNTOWN CHARLOTTESVILLE",
    "dropdeladd": "513 E MAIN ST",
    "dropdelcty": "CHARLOTTESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 229029998,
    "dropphyadd": "513 E MAIN ST",
    "dropphycty": "CHARLOTTESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 229029998,
    "dropmaladd": "513 E MAIN ST",
    "dropmalcty": "CHARLOTTESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 229029998,
    "dropsitphn": 8047756336,
    "dropsitlph": 4349775980,
    "dropsitcph": 4349775980,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26503",
    "droptype": "D",
    "dropname": "DOWNTOWN LEESBURG",
    "dropdeladd": "15 E MARKET ST",
    "dropdelcty": "LEESBURG",
    "dropdelst": "VA",
    "dropdelzpp": 201789998,
    "dropphyadd": "15 E MARKET ST",
    "dropphycty": "LEESBURG",
    "dropphyst": "VA",
    "dropphyzpp": 201789998,
    "dropmaladd": "15 E MARKET ST",
    "dropmalcty": "LEESBURG",
    "dropmalst": "VA",
    "dropmalzpp": 201789998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037774879,
    "dropsitcph": 7037774879,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26504",
    "droptype": "D",
    "dropname": "COURTHOUSE LYNCHBURG",
    "dropdeladd": "1100 CLAY ST",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245049998,
    "dropphyadd": "1100 CLAY ST",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245049998,
    "dropmaladd": "1100 CLAY ST",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245049998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5405288779,
    "dropsitcph": 4348474538,
    "dropfax": 4348464018
  },
  {
    "dcode": "D",
    "dropkey": "SX26505",
    "droptype": "D",
    "dropname": "DOWNTOWN MANASSAS",
    "dropdeladd": "9108 CHURCH ST",
    "dropdelcty": "MANASSAS",
    "dropdelst": "VA",
    "dropdelzpp": 201109997,
    "dropphyadd": "9108 CHURCH ST",
    "dropphycty": "MANASSAS",
    "dropphyst": "VA",
    "dropphyzpp": 201109997,
    "dropmaladd": "9108 CHURCH ST",
    "dropmalcty": "MANASSAS",
    "dropmalst": "VA",
    "dropmalzpp": 201109997,
    "dropsitphn": 7036986867,
    "dropsitlph": 7033923765,
    "dropsitcph": 7033923765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26514",
    "droptype": "D",
    "dropname": "DRIVER",
    "dropdeladd": "4897 BENNETTS PASTURE RD",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234359998,
    "dropphyadd": "4897 BENNETTS PASTURE RD",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234359998,
    "dropmaladd": "4897 BENNETTS PASTURE RD",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234359998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575381246,
    "dropsitcph": 7575382694,
    "dropfax": 7575381246
  },
  {
    "dcode": "D",
    "dropkey": "SX26538",
    "droptype": "D",
    "dropname": "EADS",
    "dropdeladd": "1720 S EADS ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222029998,
    "dropphyadd": "1720 S EADS ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222029998,
    "dropmaladd": "1720 S EADS ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222029998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038920840,
    "dropsitcph": 7038920840,
    "dropfax": 7039794618
  },
  {
    "dcode": "D",
    "dropkey": "SX26545",
    "droptype": "D",
    "dropname": "EAST END",
    "dropdeladd": "414 N 25TH ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232239998,
    "dropphyadd": "414 N 25TH ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232239998,
    "dropmaladd": "414 N 25TH ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232239998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 8046493790,
    "dropfax": 8047822921
  },
  {
    "dcode": "D",
    "dropkey": "SX26632",
    "droptype": "D",
    "dropname": "FOREST HILL",
    "dropdeladd": "1021 HIOAKS RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232259998,
    "dropphyadd": "1021 HIOAKS RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232259998,
    "dropmaladd": "1021 HIOAKS RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232259998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043208509,
    "dropsitcph": 8043208509,
    "dropfax": 8043209439
  },
  {
    "dcode": "D",
    "dropkey": "SX26642",
    "droptype": "D",
    "dropname": "FORT EUSTIS",
    "dropdeladd": "1321 VICTORY BLVD",
    "dropdelcty": "FORT EUSTIS",
    "dropdelst": "VA",
    "dropdelzpp": 236049998,
    "dropphyadd": "1321 VICTORY BLVD",
    "dropphycty": "FORT EUSTIS",
    "dropphyst": "VA",
    "dropphyzpp": 236049998,
    "dropmaladd": "1321 VICTORY BLVD",
    "dropmalcty": "FORT EUSTIS",
    "dropmalst": "VA",
    "dropmalzpp": 236049998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578873793,
    "dropsitcph": 7578873793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26651",
    "droptype": "D",
    "dropname": "FORT MYER",
    "dropdeladd": "217 BUFFALO SOLDIER AVE",
    "dropdelcty": "FORT MYER",
    "dropdelst": "VA",
    "dropdelzpp": 222119998,
    "dropphyadd": "217 BUFFALO SOLDIER AVE",
    "dropphycty": "FORT MYER",
    "dropphyst": "VA",
    "dropphyzpp": 222119998,
    "dropmaladd": "217 BUFFALO SOLDIER AVE",
    "dropmalcty": "FORT MYER",
    "dropmalst": "VA",
    "dropmalzpp": 222119998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7035254398,
    "dropsitcph": 7032481193,
    "dropfax": 7035253902
  },
  {
    "dcode": "D",
    "dropkey": "SX26712",
    "droptype": "D",
    "dropname": "GLEN ALLEN ANNEX",
    "dropdeladd": "3017 MOUNTAIN RD",
    "dropdelcty": "GLEN ALLEN",
    "dropdelst": "VA",
    "dropdelzpp": 230602050,
    "dropphyadd": "3017 MOUNTAIN RD",
    "dropphycty": "GLEN ALLEN",
    "dropphyst": "VA",
    "dropphyzpp": 230602050,
    "dropmaladd": "3017 MOUNTAIN RD",
    "dropmalcty": "GLEN ALLEN",
    "dropmalst": "VA",
    "dropmalzpp": 230602050,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042705573,
    "dropsitcph": 8042705573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26737",
    "droptype": "D",
    "dropname": "GRANDIN ROAD",
    "dropdeladd": "1733 GRANDIN RD SW",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240159998,
    "dropphyadd": "1733 GRANDIN RD SW",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240159998,
    "dropmaladd": "1733 GRANDIN RD SW",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240159998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403432764,
    "dropfax": 5403435018
  },
  {
    "dcode": "D",
    "dropkey": "SX26743",
    "droptype": "D",
    "dropname": "GREAT BRIDGE",
    "dropdeladd": "1100 BATTLEFIELD BLVD S",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233229998,
    "dropphyadd": "1100 BATTLEFIELD BLVD S",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233229998,
    "dropmaladd": "1100 BATTLEFIELD BLVD S",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233229998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575468856,
    "dropsitcph": 7575468856,
    "dropfax": 7575467718
  },
  {
    "dcode": "D",
    "dropkey": "SX26844",
    "droptype": "D",
    "dropname": "HILLTOP OCEANA",
    "dropdeladd": "550 FIRST COLONIAL RD STE 308",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234519997,
    "dropphyadd": "550 FIRST COLONIAL RD STE 308",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234519997,
    "dropmaladd": "550 FIRST COLONIAL RD STE 308",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234519997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574868655,
    "dropsitcph": 7574868655,
    "dropfax": 7574980684
  },
  {
    "dcode": "D",
    "dropkey": "SX26851",
    "droptype": "D",
    "dropname": "HOLLAND",
    "dropdeladd": "6723 S QUAY RD",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234379998,
    "dropphyadd": "6723 S QUAY RD",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234379998,
    "dropmaladd": "6723 S QUAY RD",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234379998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576572374,
    "dropsitcph": 7576572374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX26879",
    "droptype": "D",
    "dropname": "INDIAN RIVER",
    "dropdeladd": "3810 INDIAN RIVER RD",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233259998,
    "dropphyadd": "3810 INDIAN RIVER RD",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233259998,
    "dropmaladd": "3810 INDIAN RIVER RD",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233259998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575232303,
    "dropsitcph": 7575232303,
    "dropfax": 7574244935
  },
  {
    "dcode": "D",
    "dropkey": "SX26952",
    "droptype": "D",
    "dropname": "L C PAGE",
    "dropdeladd": "2461 E LITTLE CREEK RD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235189998,
    "dropphyadd": "2461 E LITTLE CREEK RD",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235189998,
    "dropmaladd": "2461 E LITTLE CREEK RD",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235189998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575835296,
    "dropsitcph": 7575833524,
    "dropfax": 7575836187
  },
  {
    "dcode": "D",
    "dropkey": "SX26960",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "2655 TIDEWATER DR",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235099998,
    "dropphyadd": "2655 TIDEWATER DR",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235099998,
    "dropmaladd": "2655 TIDEWATER DR",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235099998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576249454,
    "dropsitcph": 7576249479,
    "dropfax": 7576249454
  },
  {
    "dcode": "D",
    "dropkey": "SX26974",
    "droptype": "D",
    "dropname": "LANGLEY AFB",
    "dropdeladd": "62 WALNUT AVE",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236659998,
    "dropphyadd": "62 WALNUT AVE",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236659998,
    "dropmaladd": "62 WALNUT AVE",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236659998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577662195,
    "dropsitcph": 7577662195,
    "dropfax": 7577662437
  },
  {
    "dcode": "D",
    "dropkey": "SX26989",
    "droptype": "D",
    "dropname": "LEE HALL",
    "dropdeladd": "17415 WARWICK BLVD",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236039998,
    "dropphyadd": "17415 WARWICK BLVD",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236039998,
    "dropmaladd": "17415 WARWICK BLVD",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236039998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578878467,
    "dropsitcph": 7578878467,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27002",
    "droptype": "D",
    "dropname": "LINCOLNIA",
    "dropdeladd": "6137 LINCOLNIA RD",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223129998,
    "dropphyadd": "6137 LINCOLNIA RD",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223129998,
    "dropmaladd": "6137 LINCOLNIA RD",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223129998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036588762,
    "dropsitcph": 7036588762,
    "dropfax": 7039167885
  },
  {
    "dcode": "D",
    "dropkey": "SX27136",
    "droptype": "D",
    "dropname": "MELROSE",
    "dropdeladd": "3018 MELROSE AVE NW",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240179998,
    "dropphyadd": "3018 MELROSE AVE NW",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240179998,
    "dropmaladd": "3018 MELROSE AVE NW",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240179998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403428871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27203",
    "droptype": "D",
    "dropname": "MONTROSE HEIGHTS",
    "dropdeladd": "5300 KLOCKNER DR",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 232319998,
    "dropphyadd": "5300 KLOCKNER DR",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 232319998,
    "dropmaladd": "5300 KLOCKNER DR",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 232319998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042262759,
    "dropsitcph": 8042262759,
    "dropfax": 8042266416
  },
  {
    "dcode": "D",
    "dropkey": "SX27264",
    "droptype": "D",
    "dropname": "NAVY YARD",
    "dropdeladd": "1 NORFOLK NAVAL SHIPYARD",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "VA",
    "dropdelzpp": 237099998,
    "dropphyadd": "1 NORFOLK NAVAL SHIPYARD",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "VA",
    "dropphyzpp": 237099998,
    "dropmaladd": "1 NORFOLK NAVAL SHIPYARD",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "VA",
    "dropmalzpp": 237099998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573979583,
    "dropsitcph": 7573979583,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27313",
    "droptype": "D",
    "dropname": "NORTH ARLINGTON",
    "dropdeladd": "2200 N GEORGE MASON DR",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222079998,
    "dropphyadd": "2200 N GEORGE MASON DR",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222079998,
    "dropmaladd": "2200 N GEORGE MASON DR",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222079998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035367117,
    "dropsitcph": 7035367117,
    "dropfax": 7035366429
  },
  {
    "dcode": "D",
    "dropkey": "SX27316",
    "droptype": "D",
    "dropname": "NORTH POST",
    "dropdeladd": "9001 GUNSTON RD",
    "dropdelcty": "FORT BELVOIR",
    "dropdelst": "VA",
    "dropdelzpp": 220601298,
    "dropphyadd": "9001 GUNSTON RD",
    "dropphycty": "FORT BELVOIR",
    "dropphyst": "VA",
    "dropphyzpp": 220601298,
    "dropmaladd": "9001 GUNSTON RD",
    "dropmalcty": "FORT BELVOIR",
    "dropmalst": "VA",
    "dropmalzpp": 220601298,
    "dropsitphn": 7036986867,
    "dropsitlph": 7037817735,
    "dropsitcph": 7037817735,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27324",
    "droptype": "D",
    "dropname": "NORTHSIDE",
    "dropdeladd": "3004 NORTH AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232229998,
    "dropphyadd": "3004 NORTH AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232229998,
    "dropmaladd": "3004 NORTH AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232229998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043216547,
    "dropsitcph": 8043216547,
    "dropfax": 8043218410
  },
  {
    "dcode": "D",
    "dropkey": "SX27326",
    "droptype": "D",
    "dropname": "NORTHWEST RADIO",
    "dropdeladd": "1400 NORTHWEST BLVD STE 101",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233224093,
    "dropphyadd": "1400 NORTHWEST BLVD STE 101",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233224093,
    "dropmaladd": "1400 NORTHWEST BLVD STE 101",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233224093,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574218259,
    "dropsitcph": 7574218259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27329",
    "droptype": "D",
    "dropname": "NORVIEW",
    "dropdeladd": "1112 GREEN ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235139998,
    "dropphyadd": "1112 GREEN ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235139998,
    "dropmaladd": "1112 GREEN ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235139998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578558396,
    "dropsitcph": 7578554957,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27352",
    "droptype": "D",
    "dropname": "OCEAN VIEW",
    "dropdeladd": "9631 1ST VIEW ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235039998,
    "dropphyadd": "9631 1ST VIEW ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235039998,
    "dropmaladd": "9631 1ST VIEW ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235039998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575832501,
    "dropsitcph": 7575832501,
    "dropfax": 7575875027
  },
  {
    "dcode": "D",
    "dropkey": "SX27354",
    "droptype": "D",
    "dropname": "OCEANA NAS",
    "dropdeladd": "1896 LASER RD STE 100",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234609998,
    "dropphyadd": "1896 LASER RD STE 100",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234609998,
    "dropmaladd": "1896 LASER RD STE 100",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234609998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574332943,
    "dropsitcph": 7574332943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27360",
    "droptype": "D",
    "dropname": "OLD HAMPTON",
    "dropdeladd": "89 LINCOLN ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236699998,
    "dropphyadd": "89 LINCOLN ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236699998,
    "dropmaladd": "89 LINCOLN ST",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236699998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577225543,
    "dropsitcph": 7577225543,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27363",
    "droptype": "D",
    "dropname": "OLIVE",
    "dropdeladd": "201 CHOWAN DR",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "VA",
    "dropdelzpp": 237019998,
    "dropphyadd": "201 CHOWAN DR",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "VA",
    "dropphyzpp": 237019998,
    "dropmaladd": "201 CHOWAN DR",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "VA",
    "dropmalzpp": 237019998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574880174,
    "dropsitcph": 7574880174,
    "dropfax": 7573977162
  },
  {
    "dcode": "D",
    "dropkey": "SX27391",
    "droptype": "D",
    "dropname": "PARK",
    "dropdeladd": "422 N COMMERCE AVE",
    "dropdelcty": "WAYNESBORO",
    "dropdelst": "VA",
    "dropdelzpp": 229809997,
    "dropphyadd": "422 N COMMERCE AVE",
    "dropphycty": "WAYNESBORO",
    "dropphyst": "VA",
    "dropphyzpp": 229809997,
    "dropmaladd": "422 N COMMERCE AVE",
    "dropmalcty": "WAYNESBORO",
    "dropmalst": "VA",
    "dropmalzpp": 229809997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5409434451,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27393",
    "droptype": "D",
    "dropname": "PARKFAIRFAX",
    "dropdeladd": "3682 KING ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223029998,
    "dropphyadd": "3682 KING ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223029998,
    "dropmaladd": "3682 KING ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223029998,
    "dropsitphn": 7033798922,
    "dropsitlph": 7038885621,
    "dropsitcph": 7038885620,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27395",
    "droptype": "D",
    "dropname": "PARKVIEW",
    "dropdeladd": "636 79TH ST",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236059998,
    "dropphyadd": "636 79TH ST",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236059998,
    "dropmaladd": "636 79TH ST",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236059998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572473875,
    "dropsitcph": 7572473875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27414",
    "droptype": "D",
    "dropname": "PHOEBUS",
    "dropdeladd": "102 E MELLEN ST",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236639998,
    "dropphyadd": "102 E MELLEN ST",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236639998,
    "dropmaladd": "102 E MELLEN ST",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236639998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7577231074,
    "dropsitcph": 7577231074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27436",
    "droptype": "D",
    "dropname": "PORTLOCK",
    "dropdeladd": "1103 GODWIN AVE",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233241697,
    "dropphyadd": "1103 GODWIN AVE",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233241697,
    "dropmaladd": "1103 GODWIN AVE",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233241697,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575435677,
    "dropsitcph": 7575435677,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27437",
    "droptype": "D",
    "dropname": "PORTSIDE",
    "dropdeladd": "431 CRAWFORD ST FL 1",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "VA",
    "dropdelzpp": 237049997,
    "dropphyadd": "431 CRAWFORD ST FL 1",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "VA",
    "dropphyzpp": 237049997,
    "dropmaladd": "431 CRAWFORD ST FL 1",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "VA",
    "dropmalzpp": 237049997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7573975852,
    "dropsitcph": 7573975852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27446",
    "droptype": "D",
    "dropname": "PRESTON KING",
    "dropdeladd": "5877 WASHINGTON BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222059998,
    "dropphyadd": "5877 WASHINGTON BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222059998,
    "dropmaladd": "5877 WASHINGTON BLVD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222059998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035365151,
    "dropsitcph": 7035365151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27452",
    "droptype": "D",
    "dropname": "PRINCESS ANNE",
    "dropdeladd": "2509 GEORGE MASON DR",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234569998,
    "dropphyadd": "2509 GEORGE MASON DR",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234569998,
    "dropmaladd": "2509 GEORGE MASON DR",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234569998,
    "dropsitphn": 7574272705,
    "dropsitlph": 7574272705,
    "dropsitcph": 7574272705,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27541",
    "droptype": "D",
    "dropname": "RIVERDALE",
    "dropdeladd": "1062 W MERCURY BLVD",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236669998,
    "dropphyadd": "1062 W MERCURY BLVD",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236669998,
    "dropmaladd": "1062 W MERCURY BLVD",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236669998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578264357,
    "dropsitcph": 7578383476,
    "dropfax": 7578264357
  },
  {
    "dcode": "D",
    "dropkey": "SX27543",
    "droptype": "D",
    "dropname": "RIVERMONT",
    "dropdeladd": "2485 RIVERMONT AVE",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245039998,
    "dropphyadd": "2485 RIVERMONT AVE",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245039998,
    "dropmaladd": "2485 RIVERMONT AVE",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245039998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4345288968,
    "dropfax": 4345288910
  },
  {
    "dcode": "D",
    "dropkey": "SX27609",
    "droptype": "D",
    "dropname": "SCHOOLFIELD",
    "dropdeladd": "134 TUNSTALL RD",
    "dropdelcty": "DANVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 245419997,
    "dropphyadd": "134 TUNSTALL RD",
    "dropphycty": "DANVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 245419997,
    "dropmaladd": "134 TUNSTALL RD",
    "dropmalcty": "DANVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 245419997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347923242,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27645",
    "droptype": "D",
    "dropname": "SHIRLINGTON",
    "dropdeladd": "2850 S QUINCY ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222069998,
    "dropphyadd": "2850 S QUINCY ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222069998,
    "dropmaladd": "2850 S QUINCY ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222069998,
    "dropsitphn": 7039792106,
    "dropsitlph": 7039795456,
    "dropsitcph": 7039795456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27673",
    "droptype": "D",
    "dropname": "SOUTH",
    "dropdeladd": "1210 S GLEBE RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222049998,
    "dropphyadd": "1210 S GLEBE RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222049998,
    "dropmaladd": "1210 S GLEBE RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222049998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039792814,
    "dropsitcph": 7039792814,
    "dropfax": 7039792966
  },
  {
    "dcode": "D",
    "dropkey": "SX27682",
    "droptype": "D",
    "dropname": "SOUTH NORFOLK",
    "dropdeladd": "1210 POINDEXTER ST",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233249998,
    "dropphyadd": "1210 POINDEXTER ST",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233249998,
    "dropmaladd": "1210 POINDEXTER ST",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233249998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575431189,
    "dropsitcph": 7575439480,
    "dropfax": 7575430135
  },
  {
    "dcode": "D",
    "dropkey": "SX27684",
    "droptype": "D",
    "dropname": "SOUTH ROANOKE",
    "dropdeladd": "2229 CRYSTAL SPRING AVE SW",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240149998,
    "dropphyadd": "2229 CRYSTAL SPRING AVE SW",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240149998,
    "dropmaladd": "2229 CRYSTAL SPRING AVE SW",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240149998,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403427251,
    "dropfax": 5409858722
  },
  {
    "dcode": "D",
    "dropkey": "SX27686",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "2101 HOPKINS RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232249998,
    "dropphyadd": "2101 HOPKINS RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232249998,
    "dropmaladd": "2101 HOPKINS RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232249998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042310151,
    "dropsitcph": 8042310151,
    "dropfax": 8042306403
  },
  {
    "dcode": "D",
    "dropkey": "SX27771",
    "droptype": "D",
    "dropname": "STEWART",
    "dropdeladd": "3517 FLOYD AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232219998,
    "dropphyadd": "3517 FLOYD AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232219998,
    "dropmaladd": "3517 FLOYD AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232219998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8043592206,
    "dropsitcph": 8043592206,
    "dropfax": 8043551360
  },
  {
    "dcode": "D",
    "dropkey": "SX27818",
    "droptype": "D",
    "dropname": "THOMAS CORNER",
    "dropdeladd": "5900 E VIRGINIA BEACH BLVD STE 190",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235029998,
    "dropphyadd": "5900 E VIRGINIA BEACH BLVD STE 190",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235029998,
    "dropmaladd": "5900 E VIRGINIA BEACH BLVD STE 190",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235029998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574617551,
    "dropsitcph": 7574610498,
    "dropfax": 7574616478
  },
  {
    "dcode": "D",
    "dropkey": "SX27846",
    "droptype": "D",
    "dropname": "TURNPIKE",
    "dropdeladd": "3601 PICKETT RD",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "VA",
    "dropdelzpp": 220319998,
    "dropphyadd": "3601 PICKETT RD",
    "dropphycty": "FAIRFAX",
    "dropphyst": "VA",
    "dropphyzpp": 220319998,
    "dropmaladd": "3601 PICKETT RD",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "VA",
    "dropmalzpp": 220319998,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039783504,
    "dropsitcph": 7039783504,
    "dropfax": 7039780413
  },
  {
    "dcode": "D",
    "dropkey": "SX27915",
    "droptype": "D",
    "dropname": "WALNUT HILL",
    "dropdeladd": "3131 S CRATER RD",
    "dropdelcty": "PETERSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 238059998,
    "dropphyadd": "3131 S CRATER RD",
    "dropphycty": "PETERSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 238059998,
    "dropmaladd": "3131 S CRATER RD",
    "dropmalcty": "PETERSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 238059998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 8047332528,
    "dropfax": 8047321874
  },
  {
    "dcode": "D",
    "dropkey": "SX27928",
    "droptype": "D",
    "dropname": "WARWICK",
    "dropdeladd": "10830 WARWICK BLVD",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236019998,
    "dropphyadd": "10830 WARWICK BLVD",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236019998,
    "dropmaladd": "10830 WARWICK BLVD",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236019998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575993725,
    "dropsitcph": 7575993725,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX27973",
    "droptype": "D",
    "dropname": "WESTHAMPTON",
    "dropdeladd": "805 GLENBURNIE RD",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232269998,
    "dropphyadd": "805 GLENBURNIE RD",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232269998,
    "dropmaladd": "805 GLENBURNIE RD",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232269998,
    "dropsitphn": 8047373653,
    "dropsitlph": 8042851969,
    "dropsitcph": 8042851969,
    "dropfax": 8042884757
  },
  {
    "dcode": "D",
    "dropkey": "SX27978",
    "droptype": "D",
    "dropname": "WHALEYVILLE",
    "dropdeladd": "6425 WHALEYVILLE BLVD",
    "dropdelcty": "SUFFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 234389998,
    "dropphyadd": "6425 WHALEYVILLE BLVD",
    "dropphycty": "SUFFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 234389998,
    "dropmaladd": "6425 WHALEYVILLE BLVD",
    "dropmalcty": "SUFFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 234389998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7579862758,
    "dropsitcph": 7579862758,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28023",
    "droptype": "D",
    "dropname": "WITCHDUCK",
    "dropdeladd": "4831 COLUMBUS ST",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234629998,
    "dropphyadd": "4831 COLUMBUS ST",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234629998,
    "dropmaladd": "4831 COLUMBUS ST",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234629998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574979247,
    "dropsitcph": 7574971034,
    "dropfax": 7574976727
  },
  {
    "dcode": "D",
    "dropkey": "SX28037",
    "droptype": "D",
    "dropname": "WOODRUM",
    "dropdeladd": "123 W FREDERICK ST",
    "dropdelcty": "STAUNTON",
    "dropdelst": "VA",
    "dropdelzpp": 244019997,
    "dropphyadd": "123 W FREDERICK ST",
    "dropphycty": "STAUNTON",
    "dropphyst": "VA",
    "dropphyzpp": 244019997,
    "dropmaladd": "123 W FREDERICK ST",
    "dropmalcty": "STAUNTON",
    "dropmalst": "VA",
    "dropmalzpp": 244019997,
    "dropsitphn": 8047756336,
    "dropsitlph": 5408863163,
    "dropsitcph": 5408850517,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28051",
    "droptype": "D",
    "dropname": "WRIGHT",
    "dropdeladd": "7712 GRANBY ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235059998,
    "dropphyadd": "7712 GRANBY ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235059998,
    "dropmaladd": "7712 GRANBY ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235059998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574800398,
    "dropsitcph": 7574800398,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28055",
    "droptype": "D",
    "dropname": "WYTHE",
    "dropdeladd": "405 CHESTERFIELD RD",
    "dropdelcty": "HAMPTON",
    "dropdelst": "VA",
    "dropdelzpp": 236619998,
    "dropphyadd": "405 CHESTERFIELD RD",
    "dropphycty": "HAMPTON",
    "dropphyst": "VA",
    "dropphyzpp": 236619998,
    "dropmaladd": "405 CHESTERFIELD RD",
    "dropmalcty": "HAMPTON",
    "dropmalst": "VA",
    "dropmalzpp": 236619998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7572450356,
    "dropsitcph": 7572450356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28175",
    "droptype": "D",
    "dropname": "BEVERLY HILLS",
    "dropdeladd": "323 OLIVE ST",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257059998,
    "dropphyadd": "323 OLIVE ST",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257059998,
    "dropmaladd": "323 OLIVE ST",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257059998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047815432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28250",
    "droptype": "D",
    "dropname": "STATION C",
    "dropdeladd": "2328 7TH AVE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253871812,
    "dropphyadd": "2328 7TH AVE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253871812,
    "dropmaladd": "2328 7TH AVE",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253871812,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043440772,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28350",
    "droptype": "D",
    "dropname": "COVE",
    "dropdeladd": "115 MILDREN AVE",
    "dropdelcty": "WEIRTON",
    "dropdelst": "WV",
    "dropdelzpp": 260624500,
    "dropphyadd": "115 MILDREN AVE",
    "dropphycty": "WEIRTON",
    "dropphyst": "WV",
    "dropphyzpp": 260624500,
    "dropmaladd": "115 MILDREN AVE",
    "dropmalcty": "WEIRTON",
    "dropmalst": "WV",
    "dropmalzpp": 260624500,
    "dropsitphn": 4123597568,
    "dropsitlph": 3047236795,
    "dropsitcph": 3047437360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28408",
    "droptype": "D",
    "dropname": "DOWNTOWN HUNTINGTON",
    "dropdeladd": "1200 VETERANS MEMORIAL BLVD",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257019998,
    "dropphyadd": "1200 VETERANS MEMORIAL BLVD",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257019998,
    "dropmaladd": "1200 VETERANS MEMORIAL BLVD",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045292670,
    "dropfax": 3045251349
  },
  {
    "dcode": "D",
    "dropkey": "SX28409",
    "droptype": "D",
    "dropname": "DOWNTOWN WHEELING",
    "dropdeladd": "1125 CHAPLINE ST STE 1",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260032900,
    "dropphyadd": "1125 CHAPLINE ST STE 1",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260032900,
    "dropmaladd": "1125 CHAPLINE ST STE 1",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260032900,
    "dropsitphn": 3042333912,
    "dropsitlph": 3042333912,
    "dropsitcph": 3042333912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28428",
    "droptype": "D",
    "dropname": "EAST BECKLEY",
    "dropdeladd": "1821 1/2 S KANAWHA ST",
    "dropdelcty": "BECKLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258019996,
    "dropphyadd": "1821 1/2 S KANAWHA ST",
    "dropphycty": "BECKLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258019996,
    "dropmaladd": "1821 1/2 S KANAWHA ST",
    "dropmalcty": "BECKLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258019996,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042524202,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28434",
    "droptype": "D",
    "dropname": "EAST SIDE",
    "dropdeladd": "215 MERCHANT ST",
    "dropdelcty": "FAIRMONT",
    "dropdelst": "WV",
    "dropdelzpp": 265549995,
    "dropphyadd": "215 MERCHANT ST",
    "dropphycty": "FAIRMONT",
    "dropphyst": "WV",
    "dropphyzpp": 265549995,
    "dropmaladd": "215 MERCHANT ST",
    "dropmalcty": "FAIRMONT",
    "dropmalst": "WV",
    "dropmalzpp": 265549995,
    "dropsitphn": 3047465002,
    "dropsitlph": 3043664210,
    "dropsitcph": 3043662636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28455",
    "droptype": "D",
    "dropname": "ELM GROVE",
    "dropdeladd": "2209 NATIONAL RD",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260035200,
    "dropphyadd": "2209 NATIONAL RD",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260035200,
    "dropmaladd": "2209 NATIONAL RD",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260035200,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042333912,
    "dropsitcph": 3042431875,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28484",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "601 FEDERAL ST BSMT",
    "dropdelcty": "BLUEFIELD",
    "dropdelst": "WV",
    "dropdelzpp": 247019994,
    "dropphyadd": "601 FEDERAL ST BSMT",
    "dropphycty": "BLUEFIELD",
    "dropphyst": "WV",
    "dropphyzpp": 247019994,
    "dropmaladd": "3010 E CUMBERLAND RD",
    "dropmalcty": "BLUEFIELD",
    "dropmalst": "WV",
    "dropmalzpp": 247019998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043259242,
    "dropfax": 3043256165
  },
  {
    "dcode": "D",
    "dropkey": "SX28596",
    "droptype": "D",
    "dropname": "GUYANDOTTE",
    "dropdeladd": "130 BRIDGE ST",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257029998,
    "dropphyadd": "130 BRIDGE ST",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257029998,
    "dropmaladd": "130 BRIDGE ST",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257029998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045230448,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28707",
    "droptype": "D",
    "dropname": "KANAWHA CITY",
    "dropdeladd": "4600 MACCORKLE AVE SE",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253049998,
    "dropphyadd": "4600 MACCORKLE AVE SE",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253049998,
    "dropmaladd": "4600 MACCORKLE AVE SE",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253049998,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3049250763,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX28938",
    "droptype": "D",
    "dropname": "GENERAL ALFRED E BECKLEY",
    "dropdeladd": "305 PRINCE ST",
    "dropdelcty": "BECKLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258019994,
    "dropphyadd": "305 PRINCE ST",
    "dropphycty": "BECKLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258019994,
    "dropmaladd": "305 PRINCE ST",
    "dropmalcty": "BECKLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258019994,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042533779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29292",
    "droptype": "D",
    "dropname": "TOWN CENTER",
    "dropdeladd": "1057 CHARLESTON TOWN CTR",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253899997,
    "dropphyadd": "1057 CHARLESTON TOWN CTR",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253899997,
    "dropmaladd": "1057 CHARLESTON TOWN CTR",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253899997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043456848,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29342",
    "droptype": "D",
    "dropname": "WARWOOD",
    "dropdeladd": "605 WARWOOD AVE",
    "dropdelcty": "WHEELING",
    "dropdelst": "WV",
    "dropdelzpp": 260036900,
    "dropphyadd": "605 WARWOOD AVE",
    "dropphycty": "WHEELING",
    "dropphyst": "WV",
    "dropphyzpp": 260036900,
    "dropmaladd": "605 WARWOOD AVE",
    "dropmalcty": "WHEELING",
    "dropmalst": "WV",
    "dropmalzpp": 260036900,
    "dropsitphn": 4123597568,
    "dropsitlph": 3042333912,
    "dropsitcph": 3042771393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29459",
    "droptype": "D",
    "dropname": "BARBOURSVILLE MALL",
    "dropdeladd": "290 HUNTINGTON MALL",
    "dropdelcty": "BARBOURSVILLE",
    "dropdelst": "WV",
    "dropdelzpp": 255049997,
    "dropphyadd": "290 HUNTINGTON MALL",
    "dropphycty": "BARBOURSVILLE",
    "dropphyst": "WV",
    "dropphyzpp": 255049997,
    "dropmaladd": "290 HUNTINGTON MALL",
    "dropmalcty": "BARBOURSVILLE",
    "dropmalst": "WV",
    "dropmalzpp": 255049997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047365029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29491",
    "droptype": "D",
    "dropname": "MENDENHALL",
    "dropdeladd": "521 ERIN DR",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381179998,
    "dropphyadd": "521 ERIN DR",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381179998,
    "dropmaladd": "521 ERIN DR",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381179998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017634617,
    "dropsitcph": 9017634474,
    "dropfax": 9016809873
  },
  {
    "dcode": "D",
    "dropkey": "SX29562",
    "droptype": "D",
    "dropname": "COLONY SQUARE MALL",
    "dropdeladd": "3575 MAPLE AVE STE 503",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437012071,
    "dropphyadd": "3575 MAPLE AVE STE 503",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437012071,
    "dropmaladd": "3575 MAPLE AVE STE 503",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437012071,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404552802,
    "dropsitcph": 7404543998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29584",
    "droptype": "D",
    "dropname": "SOUTHRIDGE CENTRE",
    "dropdeladd": "2470 MOUNTAINEER BLVD",
    "dropdelcty": "SOUTH CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253099997,
    "dropphyadd": "2470 MOUNTAINEER BLVD",
    "dropphycty": "SOUTH CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253099997,
    "dropmaladd": "2470 MOUNTAINEER BLVD",
    "dropmalcty": "SOUTH CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253099997,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3047460124,
    "dropfax": 3043402709
  },
  {
    "dcode": "D",
    "dropkey": "SX29588",
    "droptype": "D",
    "dropname": "SHAMROCK",
    "dropdeladd": "715 SHAWAN FALLS DR",
    "dropdelcty": "DUBLIN",
    "dropdelst": "OH",
    "dropdelzpp": 430179998,
    "dropphyadd": "715 SHAWAN FALLS DR",
    "dropphycty": "DUBLIN",
    "dropphyst": "OH",
    "dropphyzpp": 430179998,
    "dropmaladd": "715 SHAWAN FALLS DR",
    "dropmalcty": "DUBLIN",
    "dropmalst": "OH",
    "dropmalzpp": 430179998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148897452,
    "dropsitcph": 6148897452,
    "dropfax": 6147660568
  },
  {
    "dcode": "D",
    "dropkey": "SX29599",
    "droptype": "D",
    "dropname": "OYSTER POINT",
    "dropdeladd": "739 THIMBLE SHOALS BLVD STE 501",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236069994,
    "dropphyadd": "739 THIMBLE SHOALS BLVD STE 501",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236069994,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236129998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575967019,
    "dropsitcph": 7575962386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29701",
    "droptype": "D",
    "dropname": "STATE STREET",
    "dropdeladd": "260 S STATE ST",
    "dropdelcty": "WESTERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430812288,
    "dropphyadd": "260 S STATE ST",
    "dropphycty": "WESTERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430812288,
    "dropmaladd": "260 S STATE ST",
    "dropmalcty": "WESTERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430812288,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148822247,
    "dropsitcph": 6148822247,
    "dropfax": 6148825957
  },
  {
    "dcode": "D",
    "dropkey": "SX29728",
    "droptype": "D",
    "dropname": "GRAND CENTRAL MALL",
    "dropdeladd": "230 GRAND CENTRAL MALL",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261019996,
    "dropphyadd": "230 GRAND CENTRAL MALL",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261019996,
    "dropmaladd": "230 GRAND CENTRAL MALL",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261019996,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044284778,
    "dropfax": 3044850724
  },
  {
    "dcode": "D",
    "dropkey": "SX29773",
    "droptype": "D",
    "dropname": "WEST ANNEX",
    "dropdeladd": "1224 D ST",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234598312,
    "dropphyadd": "1224 D ST",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234598312,
    "dropmaladd": "1224 D ST",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234599998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574647853,
    "dropsitcph": 7574647853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29777",
    "droptype": "D",
    "dropname": "OAKBROOK",
    "dropdeladd": "10070 DORCHESTER RD",
    "dropdelcty": "SUMMERVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 294859998,
    "dropphyadd": "10070 DORCHESTER RD",
    "dropphycty": "SUMMERVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 294859998,
    "dropmaladd": "10070 DORCHESTER RD",
    "dropmalcty": "SUMMERVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 294859998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8438210298,
    "dropsitcph": 8438210298,
    "dropfax": 8438218293
  },
  {
    "dcode": "D",
    "dropkey": "SX29797",
    "droptype": "D",
    "dropname": "POTOMAC",
    "dropdeladd": "1908 MOUNT VERNON AVE",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223019998,
    "dropphyadd": "1908 MOUNT VERNON AVE",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223019998,
    "dropmaladd": "1908 MOUNT VERNON AVE",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223019998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7036847168,
    "dropsitcph": 7036847168,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29800",
    "droptype": "D",
    "dropname": "DULLES P & D CENTER",
    "dropdeladd": "44715 PRENTICE DR",
    "dropdelcty": "DULLES",
    "dropdelst": "VA",
    "dropdelzpp": 201019998,
    "dropphyadd": "44715 PRENTICE DR",
    "dropphycty": "DULLES",
    "dropphyst": "VA",
    "dropphyzpp": 201019904,
    "dropmaladd": "44715 PRENTICE DR",
    "dropmalcty": "DULLES",
    "dropmalst": "VA",
    "dropmalzpp": 201019998,
    "dropsitphn": 7036986867,
    "dropsitlph": 7034066314,
    "dropsitcph": 7034066602,
    "dropfax": 7034066604
  },
  {
    "dcode": "D",
    "dropkey": "SX29830",
    "droptype": "D",
    "dropname": "TAMARACK",
    "dropdeladd": "1 TAMARACK PL",
    "dropdelcty": "BECKLEY",
    "dropdelst": "WV",
    "dropdelzpp": 258019991,
    "dropphyadd": "1 TAMARACK PL",
    "dropphycty": "BECKLEY",
    "dropphyst": "WV",
    "dropphyzpp": 258019991,
    "dropmaladd": "1 TAMARACK PL",
    "dropmalcty": "BECKLEY",
    "dropmalst": "WV",
    "dropmalzpp": 258019991,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042527155,
    "dropfax": 3042529438
  },
  {
    "dcode": "D",
    "dropkey": "SX29854",
    "droptype": "D",
    "dropname": "CLINTONVILLE CARRIER UNIT",
    "dropdeladd": "4364 N HIGH ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432149997,
    "dropphyadd": "4364 N HIGH ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432149997,
    "dropmaladd": "4364 N HIGH ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432149997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144478078,
    "dropsitcph": 6144478078,
    "dropfax": 6144472298
  },
  {
    "dcode": "D",
    "dropkey": "SX29865",
    "droptype": "D",
    "dropname": "MAIN OFFICE DAYTON",
    "dropdeladd": "1111 E 5TH ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454019705,
    "dropphyadd": "1111 E 5TH ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454019705,
    "dropmaladd": "1111 E 5TH ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454019705,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372271120,
    "dropsitcph": 9372271120,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SX29940",
    "droptype": "D",
    "dropname": "NORTH JACKSON",
    "dropdeladd": "161 W UNIVERSITY PKWY",
    "dropdelcty": "JACKSON",
    "dropdelst": "TN",
    "dropdelzpp": 383059998,
    "dropphyadd": "161 W UNIVERSITY PKWY",
    "dropphycty": "JACKSON",
    "dropphyst": "TN",
    "dropphyzpp": 383059998,
    "dropmaladd": "161 W UNIVERSITY PKWY",
    "dropmalcty": "JACKSON",
    "dropmalst": "TN",
    "dropmalzpp": 383059998,
    "dropsitphn": 6158859336,
    "dropsitlph": 7316600147,
    "dropsitcph": 7316600147,
    "dropfax": 7316687785
  },
  {
    "dcode": "D",
    "dropkey": "SX29957",
    "droptype": "D",
    "dropname": "DOWNTOWN CLARKSVILLE",
    "dropdeladd": "306 MADISON ST",
    "dropdelcty": "CLARKSVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 370409997,
    "dropphyadd": "306 MADISON ST",
    "dropphycty": "CLARKSVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 370409997,
    "dropmaladd": "2031 WILMA RUDOLPH BLVD",
    "dropmalcty": "CLARKSVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 370409998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9316479957,
    "dropsitcph": 9316479957,
    "dropfax": 9316477798
  },
  {
    "dcode": "D",
    "dropkey": "SY10009",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "8400 AIRPORT BLVD",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366089601,
    "dropphyadd": "8400 AIRPORT BLVD",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366089601,
    "dropmaladd": "8400 AIRPORT BLVD",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366089601,
    "dropsitphn": 2516351802,
    "dropsitlph": 2516351802,
    "dropsitcph": 2516351743,
    "dropfax": 2516343178
  },
  {
    "dcode": "D",
    "dropkey": "SY10017",
    "droptype": "D",
    "dropname": "ALABAMA CITY",
    "dropdeladd": "211 N 26TH ST",
    "dropdelcty": "GADSDEN",
    "dropdelst": "AL",
    "dropdelzpp": 359041930,
    "dropphyadd": "211 N 26TH ST",
    "dropphycty": "GADSDEN",
    "dropphyst": "AL",
    "dropphyzpp": 359041930,
    "dropmaladd": "211 N 26TH ST",
    "dropmalcty": "GADSDEN",
    "dropmalst": "AL",
    "dropmalzpp": 359049998,
    "dropsitphn": 2564616608,
    "dropsitlph": 2564616608,
    "dropsitcph": 2565467742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10047",
    "droptype": "D",
    "dropname": "WYNN DRIVE",
    "dropdeladd": "645 WYNN DR NW",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358169998,
    "dropphyadd": "645 WYNN DR NW",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358169998,
    "dropmaladd": "645 WYNN DR NW",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358169998,
    "dropsitphn": 2567229741,
    "dropsitlph": 2567229741,
    "dropsitcph": 2567224749,
    "dropfax": 2568378594
  },
  {
    "dcode": "D",
    "dropkey": "SY10086",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "2000 ROSEDALE RD",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366059998,
    "dropphyadd": "2000 ROSEDALE RD",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366059998,
    "dropmaladd": "2000 ROSEDALE RD",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366059998,
    "dropsitphn": 2514799569,
    "dropsitlph": 2514799569,
    "dropsitcph": 2514799569,
    "dropfax": 2514781341
  },
  {
    "dcode": "D",
    "dropkey": "SY10092",
    "droptype": "D",
    "dropname": "BEL AIR",
    "dropdeladd": "3410 BEL AIR MALL",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366063405,
    "dropphyadd": "3410 BEL AIR MALL",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366063405,
    "dropmaladd": "PO BOX 16000",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366169998,
    "dropsitphn": 2514788513,
    "dropsitlph": 2514782513,
    "dropsitcph": 2514788513,
    "dropfax": 2514780413
  },
  {
    "dcode": "D",
    "dropkey": "SY10197",
    "droptype": "D",
    "dropname": "CAROLYN",
    "dropdeladd": "1206 CARTER HILL RD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361069998,
    "dropphyadd": "1206 CARTER HILL RD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361069998,
    "dropmaladd": "1206 CARTER HILL RD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361069998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342627135,
    "dropsitcph": 3342700674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10241",
    "droptype": "D",
    "dropname": "CLOVERLAND",
    "dropdeladd": "4365 S COURT ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361059998,
    "dropphyadd": "4365 S COURT ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361059998,
    "dropmaladd": "4365 S COURT ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361059998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342847024,
    "dropsitcph": 3342863866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10270",
    "droptype": "D",
    "dropname": "COTTAGE HILL",
    "dropdeladd": "705 OAK CIRCLE DR W",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366099998,
    "dropphyadd": "705 OAK CIRCLE DR W",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366099998,
    "dropmaladd": "705 OAK CIRCLE DR W",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366099998,
    "dropsitphn": 2516608559,
    "dropsitlph": 2516608559,
    "dropsitcph": 2516608559,
    "dropfax": 2516664895
  },
  {
    "dcode": "D",
    "dropkey": "SY10284",
    "droptype": "D",
    "dropname": "CRICHTON",
    "dropdeladd": "168 BAY SHORE AVE",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366072984,
    "dropphyadd": "168 BAY SHORE AVE",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366072984,
    "dropmaladd": "168 BAY SHORE AVE",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366072984,
    "dropsitphn": 2514785873,
    "dropsitlph": 2514785873,
    "dropsitcph": 2514785639,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10343",
    "droptype": "D",
    "dropname": "DOWNTOWN HUNTSVILLE",
    "dropdeladd": "615 CLINTON AVE W",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358019998,
    "dropphyadd": "615 CLINTON AVE W",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358019998,
    "dropmaladd": "615 CLINTON AVE W",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358019998,
    "dropsitphn": 2565320391,
    "dropsitlph": 2565320391,
    "dropsitcph": 2565320391,
    "dropfax": 2565397919
  },
  {
    "dcode": "D",
    "dropkey": "SY10344",
    "droptype": "D",
    "dropname": "DOWNTOWN MONTGOMERY",
    "dropdeladd": "135 CATOMA ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361049998,
    "dropphyadd": "135 CATOMA ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361049998,
    "dropmaladd": "135 CATOMA ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361049998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342447580,
    "dropsitcph": 3342447586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10345",
    "droptype": "D",
    "dropname": "DOWNTOWN TUSCALOOSA",
    "dropdeladd": "1313 22ND AVE",
    "dropdelcty": "TUSCALOOSA",
    "dropdelst": "AL",
    "dropdelzpp": 354012937,
    "dropphyadd": "1313 22ND AVE",
    "dropphycty": "TUSCALOOSA",
    "dropphyst": "AL",
    "dropphyzpp": 354012937,
    "dropmaladd": "1313 22ND AVE",
    "dropmalcty": "TUSCALOOSA",
    "dropmalst": "AL",
    "dropmalzpp": 354019998,
    "dropsitphn": 2057589248,
    "dropsitlph": 2057589248,
    "dropsitcph": 2057585719,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10357",
    "droptype": "D",
    "dropname": "EAST GADSDEN",
    "dropdeladd": "1021 PIEDMONT CUTOFF",
    "dropdelcty": "GADSDEN",
    "dropdelst": "AL",
    "dropdelzpp": 359032761,
    "dropphyadd": "1021 PIEDMONT CUTOFF",
    "dropphycty": "GADSDEN",
    "dropphyst": "AL",
    "dropphyzpp": 359032761,
    "dropmaladd": "1021 PIEDMONT CUTOFF",
    "dropmalcty": "GADSDEN",
    "dropmalst": "AL",
    "dropmalzpp": 359039998,
    "dropsitphn": 2564928865,
    "dropsitlph": 2564928865,
    "dropsitcph": 2564928865,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10358",
    "droptype": "D",
    "dropname": "EAST LAKE ROEBUCK",
    "dropdeladd": "9150 PARKWAY E STE 200",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352061578,
    "dropphyadd": "9150 PARKWAY E STE 200",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352061578,
    "dropmaladd": "9150 PARKWAY E STE 200",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352061578,
    "dropsitphn": 2058365171,
    "dropsitlph": 2058365171,
    "dropsitcph": 2058365171,
    "dropfax": 2058339169
  },
  {
    "dcode": "D",
    "dropkey": "SY10363",
    "droptype": "D",
    "dropname": "EASTBROOK",
    "dropdeladd": "411 COLISEUM BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361099998,
    "dropphyadd": "411 COLISEUM BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361099998,
    "dropmaladd": "411 COLISEUM BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361099998,
    "dropsitphn": 3342793172,
    "dropsitlph": 3342793172,
    "dropsitcph": 3342793172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10391",
    "droptype": "D",
    "dropname": "ENSLEY",
    "dropdeladd": "700 18TH STREET ENSLEY",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352181519,
    "dropphyadd": "700 18TH STREET ENSLEY",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352181519,
    "dropmaladd": "700 18TH STREET ENSLEY",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352189998,
    "dropsitphn": 2057816417,
    "dropsitlph": 2057816417,
    "dropsitcph": 2057816417,
    "dropfax": 2057857865
  },
  {
    "dcode": "D",
    "dropkey": "SY10420",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "2801 LOMB AVE",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352084825,
    "dropphyadd": "2801 LOMB AVE",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352084825,
    "dropmaladd": "2801 LOMB AVE",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352089998,
    "dropsitphn": 2057864415,
    "dropsitlph": 2057864415,
    "dropsitcph": 2057864415,
    "dropfax": 2057858864
  },
  {
    "dcode": "D",
    "dropkey": "SY10449",
    "droptype": "D",
    "dropname": "FORESTDALE",
    "dropdeladd": "1450 FORESTDALE BLVD",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352143024,
    "dropphyadd": "1450 FORESTDALE BLVD",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352143024,
    "dropmaladd": "1450 FORESTDALE BLVD",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352149998,
    "dropsitphn": 2057982935,
    "dropsitlph": 2057982935,
    "dropsitcph": 2057982935,
    "dropfax": 2057989352
  },
  {
    "dcode": "D",
    "dropkey": "SY10534",
    "droptype": "D",
    "dropname": "GREEN LANTERN",
    "dropdeladd": "2901 MCGEHEE RD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361119998,
    "dropphyadd": "2901 MCGEHEE RD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361119998,
    "dropmaladd": "2901 MCGEHEE RD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361119998,
    "dropsitphn": 3342863866,
    "dropsitlph": 3342863866,
    "dropsitcph": 3342863866,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10536",
    "droptype": "D",
    "dropname": "GREEN SPRINGS",
    "dropdeladd": "813 GREEN SPRINGS HWY",
    "dropdelcty": "HOMEWOOD",
    "dropdelst": "AL",
    "dropdelzpp": 352094917,
    "dropphyadd": "813 GREEN SPRINGS HWY",
    "dropphycty": "HOMEWOOD",
    "dropphyst": "AL",
    "dropphyzpp": 352094917,
    "dropmaladd": "813 GREEN SPRINGS HWY",
    "dropmalcty": "HOMEWOOD",
    "dropmalst": "AL",
    "dropmalzpp": 352094917,
    "dropsitphn": 2059423151,
    "dropsitlph": 2059423151,
    "dropsitcph": 2059423151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10584",
    "droptype": "D",
    "dropname": "HAYSLAND",
    "dropdeladd": "8401 WHITESBURG DR SE",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358029998,
    "dropphyadd": "8401 WHITESBURG DR SE",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358029998,
    "dropmaladd": "8401 WHITESBURG DR SE",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358029998,
    "dropsitphn": 2568827413,
    "dropsitlph": 2568827413,
    "dropsitcph": 2568827413,
    "dropfax": 2568822143
  },
  {
    "dcode": "D",
    "dropkey": "SY10687",
    "droptype": "D",
    "dropname": "LAGOON PARK",
    "dropdeladd": "560 GEORGE TODD DR",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361219998,
    "dropphyadd": "560 GEORGE TODD DR",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361219998,
    "dropmaladd": "560 GEORGE TODD DR",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361219998,
    "dropsitphn": 3342710382,
    "dropsitlph": 3342710382,
    "dropsitcph": 3342793172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10726",
    "droptype": "D",
    "dropname": "LOOP",
    "dropdeladd": "415 DAUPHIN ISLAND PKWY",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366069998,
    "dropphyadd": "415 DAUPHIN ISLAND PKWY",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366069998,
    "dropmaladd": "415 DAUPHIN ISLAND PKWY",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366069998,
    "dropsitphn": 2514799571,
    "dropsitlph": 2514799571,
    "dropsitcph": 2514799571,
    "dropfax": 2514799571
  },
  {
    "dcode": "D",
    "dropkey": "SY10758",
    "droptype": "D",
    "dropname": "MASTIN LAKE",
    "dropdeladd": "2501 MASTIN LAKE RD NW",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358109998,
    "dropphyadd": "2501 MASTIN LAKE RD NW",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358109998,
    "dropmaladd": "2501 MASTIN LAKE RD NW",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358109998,
    "dropsitphn": 2568528984,
    "dropsitlph": 2568528984,
    "dropsitcph": 2568527094,
    "dropfax": 2568521883
  },
  {
    "dcode": "D",
    "dropkey": "SY10778",
    "droptype": "D",
    "dropname": "MEADOWBROOK",
    "dropdeladd": "1900 CORPORATE DR",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352422723,
    "dropphyadd": "1900 CORPORATE DR",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352422723,
    "dropmaladd": "1900 CORPORATE DR",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352429998,
    "dropsitphn": 2059950957,
    "dropsitlph": 2059950957,
    "dropsitcph": 2059950957,
    "dropfax": 2059808816
  },
  {
    "dcode": "D",
    "dropkey": "SY10791",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "907 SPRING HILL AVE",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366049998,
    "dropphyadd": "907 SPRING HILL AVE",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366049998,
    "dropmaladd": "907 SPRING HILL AVE",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366049998,
    "dropsitphn": 2514320270,
    "dropsitlph": 2514320270,
    "dropsitcph": 2514320270,
    "dropfax": 2514385579
  },
  {
    "dcode": "D",
    "dropkey": "SY10875",
    "droptype": "D",
    "dropname": "NORTH BIRMINGHAM",
    "dropdeladd": "2712 32ND AVE N",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352079998,
    "dropphyadd": "2712 32ND AVE N",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352079998,
    "dropmaladd": "2712 32ND AVE N",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352079998,
    "dropsitphn": 2055210367,
    "dropsitlph": 2053285850,
    "dropsitcph": 2053285850,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10877",
    "droptype": "D",
    "dropname": "NORTH FLORENCE",
    "dropdeladd": "121 EDGEWOOD DR",
    "dropdelcty": "FLORENCE",
    "dropdelst": "AL",
    "dropdelzpp": 356303075,
    "dropphyadd": "121 EDGEWOOD DR",
    "dropphycty": "FLORENCE",
    "dropphyst": "AL",
    "dropphyzpp": 356303075,
    "dropmaladd": "210 N SEMINARY ST",
    "dropmalcty": "FLORENCE",
    "dropmalst": "AL",
    "dropmalzpp": 356309998,
    "dropsitphn": 2567406350,
    "dropsitlph": 2567406350,
    "dropsitcph": 2567406350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY10880",
    "droptype": "D",
    "dropname": "NORTHSIDE",
    "dropdeladd": "3741 ROSS CLARK CIR",
    "dropdelcty": "DOTHAN",
    "dropdelst": "AL",
    "dropdelzpp": 363030002,
    "dropphyadd": "3741 ROSS CLARK CIR",
    "dropphycty": "DOTHAN",
    "dropphyst": "AL",
    "dropphyzpp": 363030002,
    "dropmaladd": "3741 ROSS CLARK CIR",
    "dropmalcty": "DOTHAN",
    "dropmalst": "AL",
    "dropmalzpp": 363032299,
    "dropsitphn": 3347939807,
    "dropsitlph": 3347939807,
    "dropsitcph": 3347939807,
    "dropfax": 3347937089
  },
  {
    "dcode": "D",
    "dropkey": "SY10960",
    "droptype": "D",
    "dropname": "PLAZA DE MALAGA",
    "dropdeladd": "6157 AIRPORT BLVD STE 310",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366083176,
    "dropphyadd": "6157 AIRPORT BLVD STE 310",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366083176,
    "dropmaladd": "PO BOX 850000",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366859998,
    "dropsitphn": 2513416186,
    "dropsitlph": 2513416186,
    "dropsitcph": 2513416186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11020",
    "droptype": "D",
    "dropname": "RIVERVIEW",
    "dropdeladd": "1425 CALIFORNIA ST",
    "dropdelcty": "VALLEY",
    "dropdelst": "AL",
    "dropdelzpp": 368545752,
    "dropphyadd": "1425 CALIFORNIA ST",
    "dropphycty": "VALLEY",
    "dropphyst": "AL",
    "dropphyzpp": 368545752,
    "dropmaladd": "30 FOB JAMES DR",
    "dropmalcty": "VALLEY",
    "dropmalst": "AL",
    "dropmalzpp": 368549998,
    "dropsitphn": 3347563268,
    "dropsitlph": 3347563268,
    "dropsitcph": 3347563268,
    "dropfax": 3347560439
  },
  {
    "dcode": "D",
    "dropkey": "SY11082",
    "droptype": "D",
    "dropname": "SHAKESPEARE",
    "dropdeladd": "2500 EASTERN BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361239998,
    "dropphyadd": "2500 EASTERN BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361239998,
    "dropmaladd": "2500 EASTERN BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361239998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342716653,
    "dropsitcph": 3342700674,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11100",
    "droptype": "D",
    "dropname": "SKYLAND",
    "dropdeladd": "3201 SKYLAND BLVD E",
    "dropdelcty": "TUSCALOOSA",
    "dropdelst": "AL",
    "dropdelzpp": 354054552,
    "dropphyadd": "3201 SKYLAND BLVD E",
    "dropphycty": "TUSCALOOSA",
    "dropphyst": "AL",
    "dropphyzpp": 354059998,
    "dropmaladd": "3201 SKYLAND BLVD E",
    "dropmalcty": "TUSCALOOSA",
    "dropmalst": "AL",
    "dropmalzpp": 354059993,
    "dropsitphn": 2055538155,
    "dropsitlph": 2055538155,
    "dropsitcph": 2055563983,
    "dropfax": 2055620028
  },
  {
    "dcode": "D",
    "dropkey": "SY11111",
    "droptype": "D",
    "dropname": "SOUTH",
    "dropdeladd": "2837 E SOUTH BLVD",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361169998,
    "dropphyadd": "2837 E SOUTH BLVD",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361169998,
    "dropmaladd": "2837 E SOUTH BLVD",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361169998,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342817441,
    "dropsitcph": 3342845309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11114",
    "droptype": "D",
    "dropname": "SOUTH HIGHLAND",
    "dropdeladd": "1821 11TH AVE S",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352059998,
    "dropphyadd": "1821 11TH AVE S",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352059998,
    "dropmaladd": "1821 11TH AVE S",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352059998,
    "dropsitphn": 2055210503,
    "dropsitlph": 2059393854,
    "dropsitcph": 2059390168,
    "dropfax": 2059331156
  },
  {
    "dcode": "D",
    "dropkey": "SY11125",
    "droptype": "D",
    "dropname": "SPRING HILL",
    "dropdeladd": "5551 OLD SHELL RD",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366089998,
    "dropphyadd": "5551 OLD SHELL RD",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366089998,
    "dropmaladd": "5551 OLD SHELL RD",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366089998,
    "dropsitphn": 2513415624,
    "dropsitlph": 2513415624,
    "dropsitcph": 2513415624,
    "dropfax": 2513422972
  },
  {
    "dcode": "D",
    "dropkey": "SY11182",
    "droptype": "D",
    "dropname": "TILLMANS CORNER",
    "dropdeladd": "5441 HIGHWAY 90 W STE 13",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366194299,
    "dropphyadd": "5441 HIGHWAY 90 W STE 13",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366194299,
    "dropmaladd": "5441 HIGHWAY 90 W STE 13",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366194299,
    "dropsitphn": 2516666580,
    "dropsitlph": 2516666580,
    "dropsitcph": 2516666580,
    "dropfax": 2516665945
  },
  {
    "dcode": "D",
    "dropkey": "SY11186",
    "droptype": "D",
    "dropname": "TOWNE WEST",
    "dropdeladd": "5701M MOFFETT RD",
    "dropdelcty": "MOBILE",
    "dropdelst": "AL",
    "dropdelzpp": 366189998,
    "dropphyadd": "5701M MOFFETT RD",
    "dropphycty": "MOBILE",
    "dropphyst": "AL",
    "dropphyzpp": 366189998,
    "dropmaladd": "5701M MOFFETT RD",
    "dropmalcty": "MOBILE",
    "dropmalst": "AL",
    "dropmalzpp": 366189998,
    "dropsitphn": 2513428665,
    "dropsitlph": 2513428665,
    "dropsitcph": 2513428665,
    "dropfax": 2513424396
  },
  {
    "dcode": "D",
    "dropkey": "SY11274",
    "droptype": "D",
    "dropname": "WEST",
    "dropdeladd": "3605 GOVERNORS DR SW",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358059998,
    "dropphyadd": "3605 GOVERNORS DR SW",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358059998,
    "dropmaladd": "3605 GOVERNORS DR SW",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358059998,
    "dropsitphn": 2565364094,
    "dropsitlph": 2565346459,
    "dropsitcph": 2565346459,
    "dropfax": 2565365712
  },
  {
    "dcode": "D",
    "dropkey": "SY11276",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "1337 TUSCALOOSA AVE SW",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352111949,
    "dropphyadd": "1337 TUSCALOOSA AVE SW",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352111949,
    "dropmaladd": "1337 TUSCALOOSA AVE SW",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352119998,
    "dropsitphn": 2057858483,
    "dropsitlph": 2057858483,
    "dropsitcph": 2057858483,
    "dropfax": 2057808732
  },
  {
    "dcode": "D",
    "dropkey": "SY11278",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "3100 TINE AVE",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "AL",
    "dropdelzpp": 361082342,
    "dropphyadd": "3100 TINE AVE",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "AL",
    "dropphyzpp": 361082342,
    "dropmaladd": "3100 TINE AVE",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "AL",
    "dropmalzpp": 361082342,
    "dropsitphn": 3342447515,
    "dropsitlph": 3342692816,
    "dropsitcph": 3342621412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11301",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "5310 1ST AVE N",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352122402,
    "dropphyadd": "5310 1ST AVE N",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352122402,
    "dropmaladd": "5310 1ST AVE N",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352129998,
    "dropsitphn": 2055922701,
    "dropsitlph": 2055922701,
    "dropsitcph": 2055922701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11306",
    "droptype": "D",
    "dropname": "WYLAM",
    "dropdeladd": "4221 7TH AVE",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352242621,
    "dropphyadd": "4221 7TH AVE",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352242621,
    "dropmaladd": "4221 7TH AVE",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352249998,
    "dropsitphn": 2057859360,
    "dropsitlph": 2057859360,
    "dropsitcph": 2057816417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11311",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "300 E JOHN ST",
    "dropdelcty": "BAY CITY",
    "dropdelst": "MI",
    "dropdelzpp": 487064672,
    "dropphyadd": "300 E JOHN ST",
    "dropphycty": "BAY CITY",
    "dropphyst": "MI",
    "dropphyzpp": 487064672,
    "dropmaladd": "300 E JOHN ST",
    "dropmalcty": "BAY CITY",
    "dropmalst": "MI",
    "dropmalzpp": 487064672,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9898955555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11357",
    "droptype": "D",
    "dropname": "ARCADIA CREEK",
    "dropdeladd": "310 E MICHIGAN AVE LOWR A",
    "dropdelcty": "KALAMAZOO",
    "dropdelst": "MI",
    "dropdelzpp": 490073885,
    "dropphyadd": "310 E MICHIGAN AVE LOWR A",
    "dropphycty": "KALAMAZOO",
    "dropphyst": "MI",
    "dropphyzpp": 490073885,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "KALAMAZOO",
    "dropmalst": "MI",
    "dropmalzpp": 490059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 2693459800,
    "dropsitcph": 2693459800,
    "dropfax": 2693459907
  },
  {
    "dcode": "D",
    "dropkey": "SY11508",
    "droptype": "D",
    "dropname": "BRIGHTMOOR",
    "dropdeladd": "20615 FENKELL ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482239998,
    "dropphyadd": "20615 FENKELL ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482239998,
    "dropmaladd": "20615 FENKELL ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482239998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3135323806,
    "dropfax": 3135320527
  },
  {
    "dcode": "D",
    "dropkey": "SY11562",
    "droptype": "D",
    "dropname": "EASTOWN",
    "dropdeladd": "1451 LAKE DR SE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495069998,
    "dropphyadd": "1451 LAKE DR SE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495069998,
    "dropmaladd": "1451 LAKE DR SE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495069998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6164514008,
    "dropsitcph": 6164514008,
    "dropfax": 6164566007
  },
  {
    "dcode": "D",
    "dropkey": "SY11662",
    "droptype": "D",
    "dropname": "CODY",
    "dropdeladd": "1601 W ATHERTON RD",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485079998,
    "dropphyadd": "1601 W ATHERTON RD",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485079998,
    "dropmaladd": "1601 W ATHERTON RD",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485079998,
    "dropsitphn": 8102348342,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102348342,
    "dropfax": 8102349110
  },
  {
    "dcode": "D",
    "dropkey": "SY11666",
    "droptype": "D",
    "dropname": "COLLEGE PARK",
    "dropdeladd": "20501 LIVERNOIS AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482219998,
    "dropphyadd": "20501 LIVERNOIS AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482219998,
    "dropmaladd": "20501 LIVERNOIS AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482219998,
    "dropsitphn": 3138631300,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138631300,
    "dropfax": 3138638890
  },
  {
    "dcode": "D",
    "dropkey": "SY11763",
    "droptype": "D",
    "dropname": "DOWNTOWN LANSING",
    "dropdeladd": "315 W ALLEGAN ST STE A",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489331523,
    "dropphyadd": "315 W ALLEGAN ST STE A",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489331523,
    "dropmaladd": "315 W ALLEGAN ST STE A",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489331523,
    "dropsitphn": 6169771064,
    "dropsitlph": 5179930969,
    "dropsitcph": 5179930969,
    "dropfax": 5174859040
  },
  {
    "dcode": "D",
    "dropkey": "SY11810",
    "droptype": "D",
    "dropname": "CUMBERLAND",
    "dropdeladd": "1300 CUMBERLAND ST",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486019998,
    "dropphyadd": "1300 CUMBERLAND ST",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486019998,
    "dropmaladd": "1300 CUMBERLAND ST",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486019998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715738,
    "dropsitcph": 9897715738,
    "dropfax": 9897522106
  },
  {
    "dcode": "D",
    "dropkey": "SY11865",
    "droptype": "D",
    "dropname": "FENKELL",
    "dropdeladd": "2720 FENKELL ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482389998,
    "dropphyadd": "2720 FENKELL ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482389998,
    "dropmaladd": "2720 FENKELL ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482389998,
    "dropsitphn": 3138615433,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138615433,
    "dropfax": 3138619649
  },
  {
    "dcode": "D",
    "dropkey": "SY11893",
    "droptype": "D",
    "dropname": "FORT DEARBORN",
    "dropdeladd": "23169 MICHIGAN AVE",
    "dropdelcty": "DEARBORN",
    "dropdelst": "MI",
    "dropdelzpp": 481240001,
    "dropphyadd": "23169 MICHIGAN AVE",
    "dropphycty": "DEARBORN",
    "dropphyst": "MI",
    "dropphyzpp": 481240001,
    "dropmaladd": "23169 MICHIGAN AVE",
    "dropmalcty": "DEARBORN",
    "dropmalst": "MI",
    "dropmalzpp": 481240001,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132771324,
    "dropsitcph": 3132771324,
    "dropfax": 3132749153
  },
  {
    "dcode": "D",
    "dropkey": "SY11905",
    "droptype": "D",
    "dropname": "FOX CREEK",
    "dropdeladd": "12711 E JEFFERSON AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482309998,
    "dropphyadd": "12711 E JEFFERSON AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482309998,
    "dropmaladd": "12711 E JEFFERSON AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482309998,
    "dropsitphn": 3133311345,
    "dropsitlph": 3132268554,
    "dropsitcph": 3133311345,
    "dropfax": 3133316537
  },
  {
    "dcode": "D",
    "dropkey": "SY11906",
    "droptype": "D",
    "dropname": "MERRILL STREET",
    "dropdeladd": "730 MERRILL ST",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489124324,
    "dropphyadd": "730 MERRILL ST",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489124324,
    "dropmaladd": "730 MERRILL ST",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489124324,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5174821962,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11934",
    "droptype": "D",
    "dropname": "GENERAL POST OFFICE",
    "dropdeladd": "1401 W FORT ST RM 1006",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482339900,
    "dropphyadd": "1401 W FORT ST RM 1006",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482339900,
    "dropmaladd": "1401 W FORT ST RM 1006",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482339900,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3132268554,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY11980",
    "droptype": "D",
    "dropname": "GRAND RIVER",
    "dropdeladd": "4744 GRAND RIVER AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482089998,
    "dropphyadd": "4744 GRAND RIVER AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482089998,
    "dropmaladd": "4744 GRAND RIVER AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482089998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138988582,
    "dropfax": 3139635758
  },
  {
    "dcode": "D",
    "dropkey": "SY11990",
    "droptype": "D",
    "dropname": "GRATIOT",
    "dropdeladd": "3434 CHENE ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482079998,
    "dropphyadd": "3434 CHENE ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482079998,
    "dropmaladd": "3434 CHENE ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482079998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132592931,
    "dropsitcph": 3138184400,
    "dropfax": 3132596310
  },
  {
    "dcode": "D",
    "dropkey": "SY11998",
    "droptype": "D",
    "dropname": "GREEN ROAD",
    "dropdeladd": "3000 GREEN RD",
    "dropdelcty": "ANN ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 481059998,
    "dropphyadd": "3000 GREEN RD",
    "dropphycty": "ANN ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 481059998,
    "dropmaladd": "3000 GREEN RD",
    "dropmalcty": "ANN ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 481059998,
    "dropsitphn": 7346622005,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346622005,
    "dropfax": 7346655304
  },
  {
    "dcode": "D",
    "dropkey": "SY12002",
    "droptype": "D",
    "dropname": "GREENMEAD",
    "dropdeladd": "37500 PEMBROKE AVE",
    "dropdelcty": "LIVONIA",
    "dropdelst": "MI",
    "dropdelzpp": 481529998,
    "dropphyadd": "37500 PEMBROKE AVE",
    "dropphycty": "LIVONIA",
    "dropphyst": "MI",
    "dropphyzpp": 481529998,
    "dropmaladd": "37500 PEMBROKE AVE",
    "dropmalcty": "LIVONIA",
    "dropmalst": "MI",
    "dropmalzpp": 481529998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7345911753,
    "dropsitcph": 7345911095,
    "dropfax": 7345915998
  },
  {
    "dcode": "D",
    "dropkey": "SY12037",
    "droptype": "D",
    "dropname": "HARPER",
    "dropdeladd": "10254 GRATIOT AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482133211,
    "dropphyadd": "10254 GRATIOT AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482133211,
    "dropmaladd": "10254 GRATIOT AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482133211,
    "dropsitphn": 3132268558,
    "dropsitlph": 3139238249,
    "dropsitcph": 3139238249,
    "dropfax": 3139230787
  },
  {
    "dcode": "D",
    "dropkey": "SY12142",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "10721 E JEFFERSON AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482149998,
    "dropphyadd": "10721 E JEFFERSON AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482149998,
    "dropmaladd": "10721 E JEFFERSON AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482149998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3133314914,
    "dropsitcph": 3133314914,
    "dropfax": 3133319581
  },
  {
    "dcode": "D",
    "dropkey": "SY12149",
    "droptype": "D",
    "dropname": "JOYFIELD",
    "dropdeladd": "16500 JOY RD",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482289998,
    "dropphyadd": "16500 JOY RD",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482289998,
    "dropmaladd": "16500 JOY RD",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482289998,
    "dropsitphn": 3132726819,
    "dropsitlph": 3132268554,
    "dropsitcph": 3132726819,
    "dropfax": 3132728590
  },
  {
    "dcode": "D",
    "dropkey": "SY12168",
    "droptype": "D",
    "dropname": "KENSINGTON",
    "dropdeladd": "17375 HARPER AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482249998,
    "dropphyadd": "17375 HARPER AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482249998,
    "dropmaladd": "17375 HARPER AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482249998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3138844342,
    "dropsitcph": 3138844342,
    "dropfax": 3138842885
  },
  {
    "dcode": "D",
    "dropkey": "SY12229",
    "droptype": "D",
    "dropname": "LEDYARD",
    "dropdeladd": "120 MONROE CENTER ST NW",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495032802,
    "dropphyadd": "120 MONROE CENTER ST NW",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495032802,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495239998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6162350139,
    "dropsitcph": 6162350139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY12243",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "200 E LIBERTY ST LBBY",
    "dropdelcty": "ANN ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 481049998,
    "dropphyadd": "200 E LIBERTY ST LBBY",
    "dropphycty": "ANN ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 481049998,
    "dropmaladd": "200 E LIBERTY ST LBBY",
    "dropmalcty": "ANN ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 481049998,
    "dropsitphn": 7346622009,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346622009,
    "dropfax": 7346636210
  },
  {
    "dcode": "D",
    "dropkey": "SY12256",
    "droptype": "D",
    "dropname": "LIVERNOIS",
    "dropdeladd": "3969 LIVERNOIS AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482109998,
    "dropphyadd": "3969 LIVERNOIS AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482109998,
    "dropmaladd": "3969 LIVERNOIS AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482109998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138988597,
    "dropfax": 3138976821
  },
  {
    "dcode": "D",
    "dropkey": "SY12362",
    "droptype": "D",
    "dropname": "DETROIT METROPOLITAN AIRPORT",
    "dropdeladd": "515 DETROIT METRO AIRPORT",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482421011,
    "dropphyadd": "515 DETROIT METRO AIRPORT",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482421011,
    "dropmaladd": "24837 GODDARD RD",
    "dropmalcty": "TAYLOR",
    "dropmalst": "MI",
    "dropmalzpp": 481809998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132348952,
    "dropsitcph": 3132348941,
    "dropfax": 3132348950
  },
  {
    "dcode": "D",
    "dropkey": "SY12412",
    "droptype": "D",
    "dropname": "MOTT PARK",
    "dropdeladd": "2712 FLUSHING RD",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485044520,
    "dropphyadd": "2712 FLUSHING RD",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485044520,
    "dropmaladd": "2712 FLUSHING RD",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485044520,
    "dropsitphn": 8102346801,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102346801,
    "dropfax": 8102346546
  },
  {
    "dcode": "D",
    "dropkey": "SY12414",
    "droptype": "D",
    "dropname": "MOUNT ELLIOTT",
    "dropdeladd": "5511 E 7 MILE RD",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482349998,
    "dropphyadd": "5511 E 7 MILE RD",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482349998,
    "dropmaladd": "5511 E 7 MILE RD",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482349998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3133661197,
    "dropsitcph": 3133661197,
    "dropfax": 3133662153
  },
  {
    "dcode": "D",
    "dropkey": "SY12468",
    "droptype": "D",
    "dropname": "NORTH END",
    "dropdeladd": "60 E MILWAUKEE ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482029998,
    "dropphyadd": "60 E MILWAUKEE ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482029998,
    "dropmaladd": "60 E MILWAUKEE ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482029998,
    "dropsitphn": 3132268587,
    "dropsitlph": 3138184397,
    "dropsitcph": 3138734110,
    "dropfax": 3138734431
  },
  {
    "dcode": "D",
    "dropkey": "SY12481",
    "droptype": "D",
    "dropname": "NORTHSIDE",
    "dropdeladd": "3311 N SAGINAW ST",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485059998,
    "dropphyadd": "3311 N SAGINAW ST",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485059998,
    "dropmaladd": "3311 N SAGINAW ST",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485059998,
    "dropsitphn": 8107871380,
    "dropsitlph": 8102571580,
    "dropsitcph": 8107871380,
    "dropfax": 8107877719
  },
  {
    "dcode": "D",
    "dropkey": "SY12485",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "1625 WALKER AVE NW",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495049998,
    "dropphyadd": "1625 WALKER AVE NW",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495049998,
    "dropmaladd": "1625 WALKER AVE NW",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495042696,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167914005,
    "dropsitcph": 6167914005,
    "dropfax": 6167914110
  },
  {
    "dcode": "D",
    "dropkey": "SY12486",
    "droptype": "D",
    "dropname": "NORTHWESTERN",
    "dropdeladd": "9650 GRAND RIVER AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482049998,
    "dropphyadd": "9650 GRAND RIVER AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482049998,
    "dropmaladd": "9650 GRAND RIVER AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482049998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3139331680,
    "dropfax": 3139331108
  },
  {
    "dcode": "D",
    "dropkey": "SY12508",
    "droptype": "D",
    "dropname": "OLD REDFORD",
    "dropdeladd": "22503 GRAND RIVER AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482199998,
    "dropphyadd": "22503 GRAND RIVER AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482199998,
    "dropmaladd": "22503 GRAND RIVER AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482199998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268854,
    "dropsitcph": 3135323579,
    "dropfax": 3135320589
  },
  {
    "dcode": "D",
    "dropkey": "SY12550",
    "droptype": "D",
    "dropname": "PARK GROVE",
    "dropdeladd": "14461 E 7 MILE RD",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482059998,
    "dropphyadd": "14461 E 7 MILE RD",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482059998,
    "dropmaladd": "14461 E 7 MILE RD",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482059998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3135262436,
    "dropsitcph": 3135262436,
    "dropfax": 3135269540
  },
  {
    "dcode": "D",
    "dropkey": "SY12651",
    "droptype": "D",
    "dropname": "RENAISSANCE CENTER",
    "dropdeladd": "100 RENAISSANCE CTR STE 2-2101",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482435000,
    "dropphyadd": "100 RENAISSANCE CTR STE 2-2101",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482435000,
    "dropmaladd": "100 RENAISSANCE CTR STE 2-2101",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482435000,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132593219,
    "dropsitcph": 3132593219,
    "dropfax": 3132596065
  },
  {
    "dcode": "D",
    "dropkey": "SY12763",
    "droptype": "D",
    "dropname": "SEVEN OAKS STA",
    "dropdeladd": "17625 W 7 MILE RD",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482359998,
    "dropphyadd": "17625 W 7 MILE RD",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482359998,
    "dropmaladd": "17625 W 7 MILE RD",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482359998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3135323392,
    "dropsitcph": 3135323392,
    "dropfax": 3135320819
  },
  {
    "dcode": "D",
    "dropkey": "SY12764",
    "droptype": "D",
    "dropname": "SEYMOUR SQUARE",
    "dropdeladd": "2017 EASTERN AVE SE STE 1",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495073200,
    "dropphyadd": "2017 EASTERN AVE SE STE 1",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495073200,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6162473713,
    "dropsitcph": 6162473713,
    "dropfax": 6162438096
  },
  {
    "dcode": "D",
    "dropkey": "SY12825",
    "droptype": "D",
    "dropname": "SPRINGWELLS",
    "dropdeladd": "1901 SPRINGWELLS ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482099998,
    "dropphyadd": "1901 SPRINGWELLS ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482099998,
    "dropmaladd": "1901 SPRINGWELLS ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482099998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3138430745,
    "dropfax": 3138412382
  },
  {
    "dcode": "D",
    "dropkey": "SY12945",
    "droptype": "D",
    "dropname": "STRATHMOOR",
    "dropdeladd": "13426 SCHAEFER HWY",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482279998,
    "dropphyadd": "13426 SCHAEFER HWY",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482279998,
    "dropmaladd": "13426 SCHAEFER HWY",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482279998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 3132724787,
    "dropfax": 3132729179
  },
  {
    "dcode": "D",
    "dropkey": "SY12980",
    "droptype": "D",
    "dropname": "TOWNSHIP BRANCH",
    "dropdeladd": "2130 WIENEKE RD",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486033651,
    "dropphyadd": "2130 WIENEKE RD",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486033651,
    "dropmaladd": "PO BOX 89998",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486089998,
    "dropsitphn": 6169771064,
    "dropsitlph": 9897715798,
    "dropsitcph": 9897715798,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY13357",
    "droptype": "D",
    "dropname": "CANDLESTICK PARK",
    "dropdeladd": "820 COOPER RD STE A",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392129998,
    "dropphyadd": "820 COOPER RD STE A",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392129998,
    "dropmaladd": "820 COOPER RD STE A",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392129998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013713769,
    "dropsitcph": 6013716335,
    "dropfax": 6013727590
  },
  {
    "dcode": "D",
    "dropkey": "SY13396",
    "droptype": "D",
    "dropname": "CHOCTAW",
    "dropdeladd": "140 LEONTYNE PRICE BLVD",
    "dropdelcty": "LAUREL",
    "dropdelst": "MS",
    "dropdelzpp": 394409996,
    "dropphyadd": "140 LEONTYNE PRICE BLVD",
    "dropphycty": "LAUREL",
    "dropphyst": "MS",
    "dropphyzpp": 394409996,
    "dropmaladd": "140 LEONTYNE PRICE BLVD",
    "dropmalcty": "LAUREL",
    "dropmalst": "MS",
    "dropmalzpp": 394409996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014262911,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY13456",
    "droptype": "D",
    "dropname": "CROSSROADS",
    "dropdeladd": "1910 HIGHWAY 82 E",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "MS",
    "dropdelzpp": 387039998,
    "dropphyadd": "1910 HIGHWAY 82 E",
    "dropphycty": "GREENVILLE",
    "dropphyst": "MS",
    "dropphyzpp": 387039998,
    "dropmaladd": "1910 HIGHWAY 82 E",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "MS",
    "dropmalzpp": 387039998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623788673,
    "dropsitcph": 6623344722,
    "dropfax": 6623327924
  },
  {
    "dcode": "D",
    "dropkey": "SY13493",
    "droptype": "D",
    "dropname": "DELTA STATION",
    "dropdeladd": "550 MELVIN BENDER DR",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392139998,
    "dropphyadd": "550 MELVIN BENDER DR",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392139998,
    "dropmaladd": "550 MELVIN BENDER DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392139998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013628349,
    "dropsitcph": 6013628574,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY13518",
    "droptype": "D",
    "dropname": "DOWNTOWN GULFPORT",
    "dropdeladd": "2421 13TH ST",
    "dropdelcty": "GULFPORT",
    "dropdelst": "MS",
    "dropdelzpp": 395019998,
    "dropphyadd": "2421 13TH ST",
    "dropphycty": "GULFPORT",
    "dropphyst": "MS",
    "dropphyzpp": 395019998,
    "dropmaladd": "2421 13TH ST",
    "dropmalcty": "GULFPORT",
    "dropmalst": "MS",
    "dropmalzpp": 395019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2288634765,
    "dropsitcph": 2288222779,
    "dropfax": 2288634765
  },
  {
    "dcode": "D",
    "dropkey": "SY13519",
    "droptype": "D",
    "dropname": "DOWNTOWN HATTIESBURG",
    "dropdeladd": "115 W PINE ST",
    "dropdelcty": "HATTIESBURG",
    "dropdelst": "MS",
    "dropdelzpp": 394019998,
    "dropphyadd": "115 W PINE ST",
    "dropphycty": "HATTIESBURG",
    "dropphyst": "MS",
    "dropphyzpp": 394019998,
    "dropmaladd": "115 W PINE ST",
    "dropmalcty": "HATTIESBURG",
    "dropmalst": "MS",
    "dropmalzpp": 394019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6015430471,
    "dropsitcph": 6015448711,
    "dropfax": 6015830204
  },
  {
    "dcode": "D",
    "dropkey": "SY13522",
    "droptype": "D",
    "dropname": "DOWNTOWN TUPELO",
    "dropdeladd": "500 W MAIN ST STE 102",
    "dropdelcty": "TUPELO",
    "dropdelst": "MS",
    "dropdelzpp": 388049998,
    "dropphyadd": "500 W MAIN ST STE 102",
    "dropphycty": "TUPELO",
    "dropphyst": "MS",
    "dropphyzpp": 388049998,
    "dropmaladd": "500 W MAIN ST STE 102",
    "dropmalcty": "TUPELO",
    "dropmalst": "MS",
    "dropmalzpp": 388049998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6628411286,
    "dropsitcph": 6628411286,
    "dropfax": 6624070558
  },
  {
    "dcode": "D",
    "dropkey": "SY13523",
    "droptype": "D",
    "dropname": "DOWNTOWN VICKSBURG",
    "dropdeladd": "820 CRAWFORD ST",
    "dropdelcty": "VICKSBURG",
    "dropdelst": "MS",
    "dropdelzpp": 391803226,
    "dropphyadd": "820 CRAWFORD ST",
    "dropphycty": "VICKSBURG",
    "dropphyst": "MS",
    "dropphyzpp": 391803226,
    "dropmaladd": "820 CRAWFORD ST",
    "dropmalcty": "VICKSBURG",
    "dropmalst": "MS",
    "dropmalzpp": 391803226,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6016387316,
    "dropfax": 6013517510
  },
  {
    "dcode": "D",
    "dropkey": "SY13546",
    "droptype": "D",
    "dropname": "EAST STATION",
    "dropdeladd": "363 COURTHOUSE RD",
    "dropdelcty": "GULFPORT",
    "dropdelst": "MS",
    "dropdelzpp": 395079998,
    "dropphyadd": "363 COURTHOUSE RD",
    "dropphycty": "GULFPORT",
    "dropphyst": "MS",
    "dropphyzpp": 395079998,
    "dropmaladd": "363 COURTHOUSE RD",
    "dropmalcty": "GULFPORT",
    "dropmalst": "MS",
    "dropmalzpp": 395079998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2288967218,
    "dropsitcph": 2288971227,
    "dropfax": 2288971508
  },
  {
    "dcode": "D",
    "dropkey": "SY13550",
    "droptype": "D",
    "dropname": "EASTLAWN",
    "dropdeladd": "2212 MARKET ST",
    "dropdelcty": "PASCAGOULA",
    "dropdelst": "MS",
    "dropdelzpp": 395679996,
    "dropphyadd": "2212 MARKET ST",
    "dropphycty": "PASCAGOULA",
    "dropphyst": "MS",
    "dropphyzpp": 395679996,
    "dropmaladd": "2212 MARKET ST",
    "dropmalcty": "PASCAGOULA",
    "dropmalst": "MS",
    "dropmalzpp": 395679996,
    "dropsitphn": 6013517144,
    "dropsitlph": 2287629721,
    "dropsitcph": 2287623441,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY13599",
    "droptype": "D",
    "dropname": "FAIRLANE",
    "dropdeladd": "235 ALABAMA ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MS",
    "dropdelzpp": 397029998,
    "dropphyadd": "235 ALABAMA ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MS",
    "dropphyzpp": 397029998,
    "dropmaladd": "235 ALABAMA ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MS",
    "dropmalzpp": 397029998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622450247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY13617",
    "droptype": "D",
    "dropname": "FONDREN",
    "dropdeladd": "629 FONDREN PL",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392169998,
    "dropphyadd": "629 FONDREN PL",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392169998,
    "dropmaladd": "629 FONDREN PL",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392169998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019812597,
    "dropsitcph": 6019816689,
    "dropfax": 6013660116
  },
  {
    "dcode": "D",
    "dropkey": "SY13802",
    "droptype": "D",
    "dropname": "SOUTHWEST",
    "dropdeladd": "4542 ROBINSON RD",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392049998,
    "dropphyadd": "4542 ROBINSON RD",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392049998,
    "dropmaladd": "4542 ROBINSON RD",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392049998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019232823,
    "dropsitcph": 6019239829,
    "dropfax": 6019239322
  },
  {
    "dcode": "D",
    "dropkey": "SY13821",
    "droptype": "D",
    "dropname": "KEESLER A F B",
    "dropdeladd": "201 MEADOWS DR",
    "dropdelcty": "BILOXI",
    "dropdelst": "MS",
    "dropdelzpp": 395342700,
    "dropphyadd": "201 MEADOWS DR",
    "dropphycty": "BILOXI",
    "dropphyst": "MS",
    "dropphyzpp": 395342700,
    "dropmaladd": "201 MEADOWS DR",
    "dropmalcty": "BILOXI",
    "dropmalst": "MS",
    "dropmalzpp": 395342700,
    "dropsitphn": 6013517144,
    "dropsitlph": 2284360739,
    "dropsitcph": 2283747276,
    "dropfax": 2284360739
  },
  {
    "dcode": "D",
    "dropkey": "SY13876",
    "droptype": "D",
    "dropname": "LEFLEUR",
    "dropdeladd": "1501 JACKSONIAN PLZ",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392119998,
    "dropphyadd": "1501 JACKSONIAN PLZ",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392119998,
    "dropmaladd": "1501 JACKSONIAN PLZ",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392119998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019817584,
    "dropsitcph": 6013667488,
    "dropfax": 6013689308
  },
  {
    "dcode": "D",
    "dropkey": "SY14118",
    "droptype": "D",
    "dropname": "NORTH JACKSON",
    "dropdeladd": "4040 NORTHVIEW DR",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392069998,
    "dropphyadd": "4040 NORTHVIEW DR",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392069998,
    "dropmaladd": "4040 NORTHVIEW DR",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392069998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013629255,
    "dropsitcph": 6013625499,
    "dropfax": 6013627430
  },
  {
    "dcode": "D",
    "dropkey": "SY14119",
    "droptype": "D",
    "dropname": "NORTH MERIDIAN",
    "dropdeladd": "5008 29TH AVE",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "MS",
    "dropdelzpp": 393059998,
    "dropphyadd": "5008 29TH AVE",
    "dropphycty": "MERIDIAN",
    "dropphyst": "MS",
    "dropphyzpp": 393059998,
    "dropmaladd": "5008 29TH AVE",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "MS",
    "dropmalzpp": 393059998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6016931634,
    "dropsitcph": 6014858212,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY14517",
    "droptype": "D",
    "dropname": "TRACETOWN",
    "dropdeladd": "55 SGT PRENTISS DR STE 10B",
    "dropdelcty": "NATCHEZ",
    "dropdelst": "MS",
    "dropdelzpp": 391209996,
    "dropphyadd": "55 SGT PRENTISS DR STE 10B",
    "dropphycty": "NATCHEZ",
    "dropphyst": "MS",
    "dropphyzpp": 391209996,
    "dropmaladd": "55 SGT PRENTISS DR STE 10B",
    "dropmalcty": "NATCHEZ",
    "dropmalst": "MS",
    "dropmalzpp": 391209996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6014420062,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY14617",
    "droptype": "D",
    "dropname": "WEST MERIDIAN",
    "dropdeladd": "708 45TH AVE",
    "dropdelcty": "MERIDIAN",
    "dropdelst": "MS",
    "dropdelzpp": 393079998,
    "dropphyadd": "708 45TH AVE",
    "dropphycty": "MERIDIAN",
    "dropphyst": "MS",
    "dropphyzpp": 393079998,
    "dropmaladd": "708 45TH AVE",
    "dropmalcty": "MERIDIAN",
    "dropmalst": "MS",
    "dropmalzpp": 393079998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6014835004,
    "dropsitcph": 6014826457,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY14620",
    "droptype": "D",
    "dropname": "WEST BILOXI",
    "dropdeladd": "2110 PASS RD",
    "dropdelcty": "BILOXI",
    "dropdelst": "MS",
    "dropdelzpp": 395319998,
    "dropphyadd": "2110 PASS RD",
    "dropphycty": "BILOXI",
    "dropphyst": "MS",
    "dropphyzpp": 395319998,
    "dropmaladd": "2110 PASS RD",
    "dropmalcty": "BILOXI",
    "dropmalst": "MS",
    "dropmalzpp": 395319998,
    "dropsitphn": 6013517144,
    "dropsitlph": 2283888660,
    "dropsitcph": 2283857275,
    "dropfax": 2283882470
  },
  {
    "dcode": "D",
    "dropkey": "SY14625",
    "droptype": "D",
    "dropname": "WESTLAND",
    "dropdeladd": "905 ELLIS AVE",
    "dropdelcty": "JACKSON",
    "dropdelst": "MS",
    "dropdelzpp": 392099998,
    "dropphyadd": "905 ELLIS AVE",
    "dropphycty": "JACKSON",
    "dropphyst": "MS",
    "dropphyzpp": 392099998,
    "dropmaladd": "905 ELLIS AVE",
    "dropmalcty": "JACKSON",
    "dropmalst": "MS",
    "dropmalzpp": 392099998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6019697269,
    "dropsitcph": 6019696591,
    "dropfax": 6013545798
  },
  {
    "dcode": "D",
    "dropkey": "SY14678",
    "droptype": "D",
    "dropname": "ACADEMY ST",
    "dropdeladd": "205 S ACADEMY ST",
    "dropdelcty": "CARY",
    "dropdelst": "NC",
    "dropdelzpp": 275199998,
    "dropphyadd": "205 S ACADEMY ST",
    "dropphycty": "CARY",
    "dropphyst": "NC",
    "dropphyzpp": 275199998,
    "dropmaladd": "205 S ACADEMY ST",
    "dropmalcty": "CARY",
    "dropmalst": "NC",
    "dropmalzpp": 275199998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 9193807712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY14722",
    "droptype": "D",
    "dropname": "ARDMORE",
    "dropdeladd": "229 MILLER ST",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271039997,
    "dropphyadd": "229 MILLER ST",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271039997,
    "dropmaladd": "229 MILLER ST",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271039997,
    "dropsitphn": 3363781463,
    "dropsitlph": 3362715587,
    "dropsitcph": 3366681375,
    "dropfax": 3367231156
  },
  {
    "dcode": "D",
    "dropkey": "SY14754",
    "droptype": "D",
    "dropname": "AZALEA",
    "dropdeladd": "3916 OLEANDER DR",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 284036758,
    "dropphyadd": "3916 OLEANDER DR",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 284036758,
    "dropmaladd": "PO BOX 28403",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 284039998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103133265,
    "dropsitcph": 9103133265,
    "dropfax": 9103133267
  },
  {
    "dcode": "D",
    "dropkey": "SY14789",
    "droptype": "D",
    "dropname": "BATTLEGROUND",
    "dropdeladd": "2941 BATTLEGROUND AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274082700,
    "dropphyadd": "2941 BATTLEGROUND AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274082700,
    "dropmaladd": "PO BOX 27438",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274389998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362827984,
    "dropfax": 3365457621
  },
  {
    "dcode": "D",
    "dropkey": "SY14814",
    "droptype": "D",
    "dropname": "BERKELEY",
    "dropdeladd": "3100 CASHWELL DR",
    "dropdelcty": "GOLDSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 275349998,
    "dropphyadd": "3100 CASHWELL DR",
    "dropphycty": "GOLDSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 275349998,
    "dropmaladd": "3100 CASHWELL DR",
    "dropmalcty": "GOLDSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 275349998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197784280,
    "dropfax": 9197783278
  },
  {
    "dcode": "D",
    "dropkey": "SY14820",
    "droptype": "D",
    "dropname": "NORTH POINT",
    "dropdeladd": "7840 N POINT BLVD STE 110",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271063290,
    "dropphyadd": "7840 N POINT BLVD STE 110",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271063290,
    "dropmaladd": "PO BOX 27116",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271029616,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367597904,
    "dropfax": 3367597904
  },
  {
    "dcode": "D",
    "dropkey": "SY14832",
    "droptype": "D",
    "dropname": "BILTMORE",
    "dropdeladd": "780 HENDERSONVILLE RD STE 7",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288032926,
    "dropphyadd": "780 HENDERSONVILLE RD STE 7",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288032926,
    "dropmaladd": "PO BOX 28813",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288139798,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716455,
    "dropsitcph": 8282716455,
    "dropfax": 8282716451
  },
  {
    "dcode": "D",
    "dropkey": "SY14881",
    "droptype": "D",
    "dropname": "BRENTWOOD",
    "dropdeladd": "2777 BRENTWOOD RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276049998,
    "dropphyadd": "2777 BRENTWOOD RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276049998,
    "dropmaladd": "2777 BRENTWOOD RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276049998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198768026,
    "dropfax": 9198783886
  },
  {
    "dcode": "D",
    "dropkey": "SY14898",
    "droptype": "D",
    "dropname": "BRYNN MARR",
    "dropdeladd": "279 HUFF DR",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285467494,
    "dropphyadd": "279 HUFF DR",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285467494,
    "dropmaladd": "PO BOX 28546",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285469998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105773074,
    "dropsitcph": 9105773074,
    "dropfax": 9105771664
  },
  {
    "dcode": "D",
    "dropkey": "SY14982",
    "droptype": "D",
    "dropname": "CENTER CITY",
    "dropdeladd": "200 TOWN RUN LN",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271019998,
    "dropphyadd": "200 TOWN RUN LN",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271019998,
    "dropmaladd": "PO BOX 27120",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271209998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367259375,
    "dropfax": 3367231289
  },
  {
    "dcode": "D",
    "dropkey": "SY14986",
    "droptype": "D",
    "dropname": "CENTURY",
    "dropdeladd": "300 FAYETTEVILLE ST",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276019995,
    "dropphyadd": "300 FAYETTEVILLE ST",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276019995,
    "dropmaladd": "300 FAYETTEVILLE ST",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276019995,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198289671,
    "dropfax": 9198283208
  },
  {
    "dcode": "D",
    "dropkey": "SY14999",
    "droptype": "D",
    "dropname": "CHERRY POINT",
    "dropdeladd": "153 E ST",
    "dropdelcty": "HAVELOCK",
    "dropdelst": "NC",
    "dropdelzpp": 285325000,
    "dropphyadd": "153 E ST",
    "dropphycty": "HAVELOCK",
    "dropphyst": "NC",
    "dropphyzpp": 285325000,
    "dropmaladd": "PO BOX 28532",
    "dropmalcty": "HAVELOCK",
    "dropmalst": "NC",
    "dropmalzpp": 285329998,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 2524662496,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15043",
    "droptype": "D",
    "dropname": "COLLEGE",
    "dropdeladd": "E DUKE CAMPUS",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 27708,
    "dropphyadd": "E DUKE CAMPUS",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 27708,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277089997,
    "dropsitphn": 9193781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196843331,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15087",
    "droptype": "D",
    "dropname": "CRABTREE VALLEY",
    "dropdeladd": "4325 GLENWOOD AVE STE 2115",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276129996,
    "dropphyadd": "4325 GLENWOOD AVE STE 2115",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276129996,
    "dropmaladd": "4325 GLENWOOD AVE STE 2115",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276129996,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205230,
    "dropfax": 9195719427
  },
  {
    "dcode": "D",
    "dropkey": "SY15132",
    "droptype": "D",
    "dropname": "DERITA",
    "dropdeladd": "2505 DERITA AVE",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282699698,
    "dropphyadd": "2505 DERITA AVE",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282699698,
    "dropmaladd": "2505 DERITA AVE",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282699698,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045977416,
    "dropsitcph": 7045977416,
    "dropfax": 7045989718
  },
  {
    "dcode": "D",
    "dropkey": "SY15151",
    "droptype": "D",
    "dropname": "DOWNTOWN ASHEVILLE",
    "dropdeladd": "33 COXE AVE",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288013305,
    "dropphyadd": "33 COXE AVE",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288013305,
    "dropmaladd": "33 COXE AVE",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288013305,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716428,
    "dropsitcph": 8282716428,
    "dropfax": 8282716423
  },
  {
    "dcode": "D",
    "dropkey": "SY15152",
    "droptype": "D",
    "dropname": "DOWNTOWN BOONE",
    "dropdeladd": "680 W KING ST",
    "dropdelcty": "BOONE",
    "dropdelst": "NC",
    "dropdelzpp": 286071017,
    "dropphyadd": "680 W KING ST",
    "dropphycty": "BOONE",
    "dropphyst": "NC",
    "dropphyzpp": 286071017,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BOONE",
    "dropmalst": "NC",
    "dropmalzpp": 286079998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 8282621171,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15153",
    "droptype": "D",
    "dropname": "DOWNTOWN CHARLOTTE",
    "dropdeladd": "201 N MCDOWELL ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282049700,
    "dropphyadd": "201 N MCDOWELL ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282049700,
    "dropmaladd": "201 N MCDOWELL ST",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282049700,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043332542,
    "dropsitcph": 7043332542,
    "dropfax": 7043348938
  },
  {
    "dcode": "D",
    "dropkey": "SY15155",
    "droptype": "D",
    "dropname": "DOWNTOWN NEW BERN",
    "dropdeladd": "233 MIDDLE ST STE 101",
    "dropdelcty": "NEW BERN",
    "dropdelst": "NC",
    "dropdelzpp": 285602101,
    "dropphyadd": "233 MIDDLE ST STE 101",
    "dropphycty": "NEW BERN",
    "dropphyst": "NC",
    "dropphyzpp": 285602101,
    "dropmaladd": "PO BOX 28563",
    "dropmalcty": "NEW BERN",
    "dropmalst": "NC",
    "dropmalzpp": 285639998,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104862341,
    "dropsitcph": 2526386921,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15176",
    "droptype": "D",
    "dropname": "DURALEIGH",
    "dropdeladd": "4325 GLENWOOD AVE STE 3025",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276124525,
    "dropphyadd": "4325 GLENWOOD AVE STE 3025",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276124525,
    "dropmaladd": "4325 GLENWOOD AVE STE 3025",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276124525,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197812840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15201",
    "droptype": "D",
    "dropname": "EAST DURHAM",
    "dropdeladd": "1100 N MIAMI BLVD",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277039998,
    "dropphyadd": "1100 N MIAMI BLVD",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277039998,
    "dropmaladd": "1100 N MIAMI BLVD",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277039998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196279003,
    "dropfax": 9196823586
  },
  {
    "dcode": "D",
    "dropkey": "SY15219",
    "droptype": "D",
    "dropname": "ECU STATION",
    "dropdeladd": "806 E 10TH ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278589997,
    "dropphyadd": "806 E 10TH ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278589997,
    "dropmaladd": "806 E 10TH ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278583502,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 2527582988,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15259",
    "droptype": "D",
    "dropname": "EMERYWOOD",
    "dropdeladd": "116 ROCKSPRING RD",
    "dropdelcty": "HIGH POINT",
    "dropdelst": "NC",
    "dropdelzpp": 272622598,
    "dropphyadd": "116 ROCKSPRING RD",
    "dropphycty": "HIGH POINT",
    "dropphyst": "NC",
    "dropphyzpp": 272622598,
    "dropmaladd": "PO BOX 27262",
    "dropmalcty": "HIGH POINT",
    "dropmalst": "NC",
    "dropmalzpp": 272609702,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368866560,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15266",
    "droptype": "D",
    "dropname": "ENO VALLEY",
    "dropdeladd": "311 MILTON RD",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277129998,
    "dropphyadd": "311 MILTON RD",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277129998,
    "dropmaladd": "311 MILTON RD",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277129998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9193218243,
    "dropfax": 9194776725
  },
  {
    "dcode": "D",
    "dropkey": "SY15282",
    "droptype": "D",
    "dropname": "EUTAW",
    "dropdeladd": "816 ELM ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283030060,
    "dropphyadd": "816 ELM ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283030060,
    "dropmaladd": "PO BOX 28303",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283039998,
    "dropsitphn": 7043934481,
    "dropsitlph": 9104869129,
    "dropsitcph": 9104232309,
    "dropfax": 9104868879
  },
  {
    "dcode": "D",
    "dropkey": "SY15315",
    "droptype": "D",
    "dropname": "FEDERAL BUILDING",
    "dropdeladd": "306 E MAIN ST",
    "dropdelcty": "ELIZABETH CITY",
    "dropdelst": "NC",
    "dropdelzpp": 279094426,
    "dropphyadd": "306 E MAIN ST",
    "dropphycty": "ELIZABETH CITY",
    "dropphyst": "NC",
    "dropphyzpp": 279094426,
    "dropmaladd": "306 E MAIN ST",
    "dropmalcty": "ELIZABETH CITY",
    "dropmalst": "NC",
    "dropmalzpp": 279099997,
    "dropsitphn": 9103781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523357770,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15325",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "2009 FAIRVIEW RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276289800,
    "dropphyadd": "2009 FAIRVIEW RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276289800,
    "dropmaladd": "2009 FAIRVIEW RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276289800,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198289798,
    "dropfax": 9198345875
  },
  {
    "dcode": "D",
    "dropkey": "SY15356",
    "droptype": "D",
    "dropname": "FOUR SEASONS",
    "dropdeladd": "301 FOUR SEASONS TOWN CTR",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274074710,
    "dropphyadd": "301 FOUR SEASONS TOWN CTR",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274074710,
    "dropmaladd": "PO BOX 27427",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274279998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362998085,
    "dropfax": 3362990139
  },
  {
    "dcode": "D",
    "dropkey": "SY15363",
    "droptype": "D",
    "dropname": "FRANKLIN STREET",
    "dropdeladd": "179 E FRANKLIN ST",
    "dropdelcty": "CHAPEL HILL",
    "dropdelst": "NC",
    "dropdelzpp": 275143647,
    "dropphyadd": "179 E FRANKLIN ST",
    "dropphycty": "CHAPEL HILL",
    "dropphyst": "NC",
    "dropphyzpp": 275143647,
    "dropmaladd": "179 E FRANKLIN ST",
    "dropmalcty": "CHAPEL HILL",
    "dropmalst": "NC",
    "dropmalzpp": 275143647,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15436",
    "droptype": "D",
    "dropname": "GRACE",
    "dropdeladd": "725 MERRIMON AVE",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288042447,
    "dropphyadd": "725 MERRIMON AVE",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288042447,
    "dropmaladd": "PO BOX 28804",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288049798,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716431,
    "dropsitcph": 8282716431,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15478",
    "droptype": "D",
    "dropname": "GUILFORD",
    "dropdeladd": "5704 W MARKET ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274092213,
    "dropphyadd": "5704 W MARKET ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274092213,
    "dropmaladd": "PO BOX 27419",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274199998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3363150286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15499",
    "droptype": "D",
    "dropname": "HANES MALL",
    "dropdeladd": "3320 SILAS CREEK PKWY STE 500",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271033025,
    "dropphyadd": "3320 SILAS CREEK PKWY STE 500",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271033025,
    "dropmaladd": "3320 SILAS CREEK PKWY STE 500",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271033025,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367600942,
    "dropfax": 3367680687
  },
  {
    "dcode": "D",
    "dropkey": "SY15530",
    "droptype": "D",
    "dropname": "HAYMOUNT",
    "dropdeladd": "106 OAKRIDGE AVE",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283054835,
    "dropphyadd": "106 OAKRIDGE AVE",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283054835,
    "dropmaladd": "PO BOX 28305",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283059998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104868981,
    "dropsitcph": 9104868981,
    "dropfax": 9108291079
  },
  {
    "dcode": "D",
    "dropkey": "SY15576",
    "droptype": "D",
    "dropname": "HILLTOP FINANCE",
    "dropdeladd": "4615 W GATE CITY BLVD",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274070100,
    "dropphyadd": "4615 W GATE CITY BLVD",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274070100,
    "dropmaladd": "PO BOX 27417",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362293056,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY15612",
    "droptype": "D",
    "dropname": "IDLEWILD",
    "dropdeladd": "6501 ALBEMARLE RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282129798,
    "dropphyadd": "6501 ALBEMARLE RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282129798,
    "dropmaladd": "6501 ALBEMARLE RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282129798,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045663135,
    "dropsitcph": 7045663135,
    "dropfax": 7045663137
  },
  {
    "dcode": "D",
    "dropkey": "SY15700",
    "droptype": "D",
    "dropname": "LAFAYETTE",
    "dropdeladd": "907 BRIGHTON RD",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283142511,
    "dropphyadd": "907 BRIGHTON RD",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283142511,
    "dropmaladd": "PO BOX 28309",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283099998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104244495,
    "dropsitcph": 9104244495,
    "dropfax": 9104232309
  },
  {
    "dcode": "D",
    "dropkey": "SY15706",
    "droptype": "D",
    "dropname": "LAKEDALE",
    "dropdeladd": "2503 SOUTHERN AVE",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283062948,
    "dropphyadd": "2503 SOUTHERN AVE",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283062948,
    "dropmaladd": "PO BOX 28306",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283069998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104867756,
    "dropsitcph": 9104867756,
    "dropfax": 9106789057
  },
  {
    "dcode": "D",
    "dropkey": "SY15827",
    "droptype": "D",
    "dropname": "MANOR",
    "dropdeladd": "3331 HEALY DR",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271039998,
    "dropphyadd": "3331 HEALY DR",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271039998,
    "dropmaladd": "3331 HEALY DR",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271039998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367600935,
    "dropfax": 3366597953
  },
  {
    "dcode": "D",
    "dropkey": "SY15893",
    "droptype": "D",
    "dropname": "METHOD",
    "dropdeladd": "3919 BERYL RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276079996,
    "dropphyadd": "3919 BERYL RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276079996,
    "dropmaladd": "3919 BERYL RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276075212,
    "dropsitphn": 9199319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198282819,
    "dropfax": 9198514512
  },
  {
    "dcode": "D",
    "dropkey": "SY15912",
    "droptype": "D",
    "dropname": "MILLBROOK",
    "dropdeladd": "4901 DEPARTURE DR",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276169997,
    "dropphyadd": "4901 DEPARTURE DR",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276169997,
    "dropmaladd": "4901 DEPARTURE DR",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276169997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198783651,
    "dropfax": 9198751987
  },
  {
    "dcode": "D",
    "dropkey": "SY15997",
    "droptype": "D",
    "dropname": "ASHEBORO",
    "dropdeladd": "340 N FAYETTEVILLE ST",
    "dropdelcty": "ASHEBORO",
    "dropdelst": "NC",
    "dropdelzpp": 272035531,
    "dropphyadd": "340 N FAYETTEVILLE ST",
    "dropphycty": "ASHEBORO",
    "dropphyst": "NC",
    "dropphyzpp": 272035531,
    "dropmaladd": "1030 S CHURCH ST",
    "dropmalcty": "ASHEBORO",
    "dropmalst": "NC",
    "dropmalzpp": 272036499,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366299119,
    "dropfax": 3366297714
  },
  {
    "dcode": "D",
    "dropkey": "SY16048",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "3490 N PATTERSON AVE",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271053627,
    "dropphyadd": "3490 N PATTERSON AVE",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271053627,
    "dropmaladd": "PO BOX 27105",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271029605,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3366681375,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16050",
    "droptype": "D",
    "dropname": "NORTH BURLINGTON",
    "dropdeladd": "2212 N CHURCH ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 272173179,
    "dropphyadd": "2212 N CHURCH ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 272173179,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 272159997,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362274292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16056",
    "droptype": "D",
    "dropname": "NORTH DURHAM",
    "dropdeladd": "3500 N ROXBORO ST STE 30",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277042765,
    "dropphyadd": "3500 N ROXBORO ST STE 30",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277042765,
    "dropmaladd": "3500 N ROXBORO ST STE 30",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277049997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9192207450,
    "dropfax": 9192208504
  },
  {
    "dcode": "D",
    "dropkey": "SY16061",
    "droptype": "D",
    "dropname": "NORTH RIDGE",
    "dropdeladd": "7800 FALLS OF NEUSE RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276159998,
    "dropphyadd": "7800 FALLS OF NEUSE RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276159998,
    "dropmaladd": "7800 FALLS OF NEUSE RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276159998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198461942,
    "dropfax": 9198468496
  },
  {
    "dcode": "D",
    "dropkey": "SY16062",
    "droptype": "D",
    "dropname": "NORTH ROXBORO",
    "dropdeladd": "1322 N MAIN ST",
    "dropdelcty": "ROXBORO",
    "dropdelst": "NC",
    "dropdelzpp": 275734342,
    "dropphyadd": "1322 N MAIN ST",
    "dropphycty": "ROXBORO",
    "dropphyst": "NC",
    "dropphyzpp": 275734342,
    "dropmaladd": "1322 N MAIN ST",
    "dropmalcty": "ROXBORO",
    "dropmalst": "NC",
    "dropmalzpp": 275734342,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 3365997430,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16063",
    "droptype": "D",
    "dropname": "NORTH TRYON",
    "dropdeladd": "6700 N TRYON ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282139798,
    "dropphyadd": "6700 N TRYON ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282139798,
    "dropmaladd": "6700 N TRYON ST",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282139798,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045980284,
    "dropsitcph": 7045980284,
    "dropfax": 7049211126
  },
  {
    "dcode": "D",
    "dropkey": "SY16070",
    "droptype": "D",
    "dropname": "NORTHWOODS",
    "dropdeladd": "2501 ONSLOW DR UNIT 100",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 285405751,
    "dropphyadd": "2501 ONSLOW DR UNIT 100",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 285405751,
    "dropmaladd": "2501 ONSLOW DR UNIT 100",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 285405751,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104863341,
    "dropsitcph": 9104553947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16117",
    "droptype": "D",
    "dropname": "OTEEN",
    "dropdeladd": "1141 TUNNEL RD STE C",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288052053,
    "dropphyadd": "1141 TUNNEL RD STE C",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288052053,
    "dropmaladd": "PO BOX 28815",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288159798,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716459,
    "dropsitcph": 8282716459,
    "dropfax": 8282716405
  },
  {
    "dcode": "D",
    "dropkey": "SY16129",
    "droptype": "D",
    "dropname": "PARK ROAD",
    "dropdeladd": "4117 PARK RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282092214,
    "dropphyadd": "4117 PARK RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282092214,
    "dropmaladd": "4117 PARK RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282092214,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045223842,
    "dropsitcph": 7045223842,
    "dropfax": 7045279373
  },
  {
    "dcode": "D",
    "dropkey": "SY16134",
    "droptype": "D",
    "dropname": "PLAZA KINSTON",
    "dropdeladd": "2433 N HERRITAGE ST",
    "dropdelcty": "KINSTON",
    "dropdelst": "NC",
    "dropdelzpp": 285011613,
    "dropphyadd": "2433 N HERRITAGE ST",
    "dropphycty": "KINSTON",
    "dropphyst": "NC",
    "dropphyzpp": 285011613,
    "dropmaladd": "PO BOX 28501",
    "dropmalcty": "KINSTON",
    "dropmalst": "NC",
    "dropmalzpp": 285019998,
    "dropsitphn": 7043934444,
    "dropsitlph": 2525264016,
    "dropsitcph": 2525264016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16135",
    "droptype": "D",
    "dropname": "PARKWOOD",
    "dropdeladd": "1470 TARBORO ST W",
    "dropdelcty": "WILSON",
    "dropdelst": "NC",
    "dropdelzpp": 278931548,
    "dropphyadd": "1470 TARBORO ST W",
    "dropphycty": "WILSON",
    "dropphyst": "NC",
    "dropphyzpp": 278931548,
    "dropmaladd": "1470 TARBORO ST W",
    "dropmalcty": "WILSON",
    "dropmalst": "NC",
    "dropmalzpp": 278931548,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522371403,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16425",
    "droptype": "D",
    "dropname": "SHANNON PLAZA",
    "dropdeladd": "3710 SHANNON RD",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277079996,
    "dropphyadd": "3710 SHANNON RD",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277079996,
    "dropmaladd": "3710 SHANNON RD",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277079996,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9193214538,
    "dropfax": 9194930587
  },
  {
    "dcode": "D",
    "dropkey": "SY16500",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "2300 SOABAR ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274063650,
    "dropphyadd": "2300 SOABAR ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274063650,
    "dropmaladd": "2300 SOABAR ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362754818,
    "dropfax": 3362738806
  },
  {
    "dcode": "D",
    "dropkey": "SY16518",
    "droptype": "D",
    "dropname": "STARMOUNT",
    "dropdeladd": "6241 SOUTH BLVD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282174157,
    "dropphyadd": "6241 SOUTH BLVD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282174157,
    "dropmaladd": "6241 SOUTH BLVD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282174157,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045223842,
    "dropsitcph": 7045223842,
    "dropfax": 7045526469
  },
  {
    "dcode": "D",
    "dropkey": "SY16529",
    "droptype": "D",
    "dropname": "STEELE CREEK",
    "dropdeladd": "10926 QUALITY DR",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282788932,
    "dropphyadd": "10926 QUALITY DR",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282788932,
    "dropmaladd": "10926 QUALITY DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282788737,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045049809,
    "dropsitcph": 7045049809,
    "dropfax": 7045049984
  },
  {
    "dcode": "D",
    "dropkey": "SY16558",
    "droptype": "D",
    "dropname": "SUMMIT",
    "dropdeladd": "1585 YANCEYVILLE ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274056940,
    "dropphyadd": "1585 YANCEYVILLE ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274056940,
    "dropmaladd": "1585 YANCEYVILLE ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274059998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362751670,
    "dropfax": 3362738452
  },
  {
    "dcode": "D",
    "dropkey": "SY16562",
    "droptype": "D",
    "dropname": "SUNNYBROOK",
    "dropdeladd": "236 SUNNYBROOK RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276109998,
    "dropphyadd": "236 SUNNYBROOK RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276109998,
    "dropmaladd": "236 SUNNYBROOK RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276109998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194205230,
    "dropfax": 9192509464
  },
  {
    "dcode": "D",
    "dropkey": "SY16616",
    "droptype": "D",
    "dropname": "TIMBERLYNE",
    "dropdeladd": "1129 WEAVER DAIRY RD STE T",
    "dropdelcty": "CHAPEL HILL",
    "dropdelst": "NC",
    "dropdelzpp": 275149993,
    "dropphyadd": "1129 WEAVER DAIRY RD STE T",
    "dropphycty": "CHAPEL HILL",
    "dropphyst": "NC",
    "dropphyzpp": 275149993,
    "dropmaladd": "1129 WEAVER DAIRY RD STE T",
    "dropmalcty": "CHAPEL HILL",
    "dropmalst": "NC",
    "dropmalzpp": 275149993,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9199295135,
    "dropfax": 9199429703
  },
  {
    "dcode": "D",
    "dropkey": "SY16668",
    "droptype": "D",
    "dropname": "JIM RICHARDSON",
    "dropdeladd": "2127 BEATTIES FORD RD STE B",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282169903,
    "dropphyadd": "2127 BEATTIES FORD RD STE B",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282169903,
    "dropmaladd": "2127 BEATTIES FORD RD STE B",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282164378,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043999401,
    "dropsitcph": 7043999401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16743",
    "droptype": "D",
    "dropname": "WAUGHTOWN",
    "dropdeladd": "1995 PLEASANT ST",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271079998,
    "dropphyadd": "1995 PLEASANT ST",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271079998,
    "dropmaladd": "PO BOX 27117",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271179998,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367843047,
    "dropfax": 3367853543
  },
  {
    "dcode": "D",
    "dropkey": "SY16765",
    "droptype": "D",
    "dropname": "WEST ASHEVILLE",
    "dropdeladd": "1302 PATTON AVE",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288062711,
    "dropphyadd": "1302 PATTON AVE",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288062711,
    "dropmaladd": "1302 PATTON AVE",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288062711,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716412,
    "dropsitcph": 8282716418,
    "dropfax": 8282716416
  },
  {
    "dcode": "D",
    "dropkey": "SY16767",
    "droptype": "D",
    "dropname": "WEST DURHAM",
    "dropdeladd": "3520 KANGAROO DR",
    "dropdelcty": "DURHAM",
    "dropdelst": "NC",
    "dropdelzpp": 277054595,
    "dropphyadd": "3520 KANGAROO DR",
    "dropphycty": "DURHAM",
    "dropphyst": "NC",
    "dropphyzpp": 277054595,
    "dropmaladd": "3520 KANGAROO DR",
    "dropmalcty": "DURHAM",
    "dropmalst": "NC",
    "dropmalzpp": 277054595,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196279003,
    "dropfax": 9193836821
  },
  {
    "dcode": "D",
    "dropkey": "SY16776",
    "droptype": "D",
    "dropname": "WEST ROCKY MOUNT",
    "dropdeladd": "1033 HAMMOND ST",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278039996,
    "dropphyadd": "1033 HAMMOND ST",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278039996,
    "dropmaladd": "1033 HAMMOND ST",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278039996,
    "dropsitphn": 9193781463,
    "dropsitlph": 9198313642,
    "dropsitcph": 2524423272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16783",
    "droptype": "D",
    "dropname": "WESTRIDGE",
    "dropdeladd": "3695 SUNSET AVE",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278049995,
    "dropphyadd": "3695 SUNSET AVE",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278049995,
    "dropmaladd": "3695 SUNSET AVE",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278049995,
    "dropsitphn": 9103781463,
    "dropsitlph": 9198313642,
    "dropsitcph": 2524437511,
    "dropfax": 2524436729
  },
  {
    "dcode": "D",
    "dropkey": "SY16842",
    "droptype": "D",
    "dropname": "WOODARD",
    "dropdeladd": "1318 NASH ST SE",
    "dropdelcty": "WILSON",
    "dropdelst": "NC",
    "dropdelzpp": 278936300,
    "dropphyadd": "1318 NASH ST SE",
    "dropphycty": "WILSON",
    "dropphyst": "NC",
    "dropphyzpp": 278936300,
    "dropmaladd": "1318 NASH ST SE",
    "dropmalcty": "WILSON",
    "dropmalst": "NC",
    "dropmalzpp": 278936300,
    "dropsitphn": 3363781463,
    "dropsitlph": 9194205175,
    "dropsitcph": 2522435982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY16883",
    "droptype": "D",
    "dropname": "AMC RETAIL CENTER",
    "dropdeladd": "5500 S HOWELL AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532076127,
    "dropphyadd": "5500 S HOWELL AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532076127,
    "dropmaladd": "PO BOX 370001",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532371001,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144810272,
    "dropsitcph": 4144810272,
    "dropfax": 4144814091
  },
  {
    "dcode": "D",
    "dropkey": "SY16964",
    "droptype": "D",
    "dropname": "BAY VIEW SAINT FRANCIS",
    "dropdeladd": "1603 E OKLAHOMA AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532079998,
    "dropphyadd": "1603 E OKLAHOMA AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532079998,
    "dropmaladd": "1603 E OKLAHOMA AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532079998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144810219,
    "dropsitcph": 4144810204,
    "dropfax": 4144812804
  },
  {
    "dcode": "D",
    "dropkey": "SY17207",
    "droptype": "D",
    "dropname": "DOWNTOWN GREEN BAY",
    "dropdeladd": "118 N MONROE AVE",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "WI",
    "dropdelzpp": 543014902,
    "dropphyadd": "118 N MONROE AVE",
    "dropphycty": "GREEN BAY",
    "dropphyst": "WI",
    "dropphyzpp": 543014902,
    "dropmaladd": "PO BOX 37",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "WI",
    "dropmalzpp": 543050037,
    "dropsitphn": 4142912520,
    "dropsitlph": 9204983892,
    "dropsitcph": 9204320229,
    "dropfax": 9204320211
  },
  {
    "dcode": "D",
    "dropkey": "SY17208",
    "droptype": "D",
    "dropname": "DOWNTOWN OSHKOSH",
    "dropdeladd": "130 STATE ST",
    "dropdelcty": "OSHKOSH",
    "dropdelst": "WI",
    "dropdelzpp": 549019998,
    "dropphyadd": "130 STATE ST",
    "dropphycty": "OSHKOSH",
    "dropphyst": "WI",
    "dropphyzpp": 549019998,
    "dropmaladd": "130 STATE ST",
    "dropmalcty": "OSHKOSH",
    "dropmalst": "WI",
    "dropmalzpp": 549019998,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202317121,
    "dropsitcph": 9202360627,
    "dropfax": 9202360211
  },
  {
    "dcode": "D",
    "dropkey": "SY17210",
    "droptype": "D",
    "dropname": "DR MARTIN LUTHER KING JR",
    "dropdeladd": "2650 N DR MARTIN LUTHER KING JR DR",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532129998,
    "dropphyadd": "2650 N DR MARTIN LUTHER KING JR DR",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532129998,
    "dropmaladd": "2650 N DR MARTIN LUTHER KING JR DR",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532129998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4145621456,
    "dropsitcph": 4145621449,
    "dropfax": 4145625423
  },
  {
    "dcode": "D",
    "dropkey": "SY17320",
    "droptype": "D",
    "dropname": "FRED JOHN",
    "dropdeladd": "5555 N 91ST ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532259998,
    "dropphyadd": "5555 N 91ST ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532259998,
    "dropmaladd": "5555 N 91ST ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532259998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144663757,
    "dropsitcph": 4144663738,
    "dropfax": 4144661587
  },
  {
    "dcode": "D",
    "dropkey": "SY17401",
    "droptype": "D",
    "dropname": "HAMPTON",
    "dropdeladd": "6501 W FOND DU LAC AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532184920,
    "dropphyadd": "6501 W FOND DU LAC AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532184920,
    "dropmaladd": "6501 W FOND DU LAC AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532184920,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144660775,
    "dropsitcph": 4144660538,
    "dropfax": 4144668780
  },
  {
    "dcode": "D",
    "dropkey": "SY17406",
    "droptype": "D",
    "dropname": "HARBOR",
    "dropdeladd": "1416 S 11TH ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532049998,
    "dropphyadd": "1416 S 11TH ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532049998,
    "dropmaladd": "4300 W LINCOLN AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532195012,
    "dropsitphn": 4142702120,
    "dropsitlph": 4146430338,
    "dropsitcph": 4146714581,
    "dropfax": 4146434449
  },
  {
    "dcode": "D",
    "dropkey": "SY17433",
    "droptype": "D",
    "dropname": "HILLDALE",
    "dropdeladd": "601 SAWYER TER",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537053237,
    "dropphyadd": "601 SAWYER TER",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537053237,
    "dropmaladd": "601 SAWYER TER",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537053237,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082312305,
    "dropsitcph": 6082312466,
    "dropfax": 6082319197
  },
  {
    "dcode": "D",
    "dropkey": "SY17437",
    "droptype": "D",
    "dropname": "HILLTOP",
    "dropdeladd": "1301 N 12TH ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532059998,
    "dropphyadd": "1301 N 12TH ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532059998,
    "dropmaladd": "1301 N 12TH ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532059998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4143423191,
    "dropsitcph": 4143423335,
    "dropfax": 4143420206
  },
  {
    "dcode": "D",
    "dropkey": "SY17491",
    "droptype": "D",
    "dropname": "JOHN P COFRIN",
    "dropdeladd": "1950 COFRIN DR",
    "dropdelcty": "GREEN BAY",
    "dropdelst": "WI",
    "dropdelzpp": 543029998,
    "dropphyadd": "1950 COFRIN DR",
    "dropphycty": "GREEN BAY",
    "dropphyst": "WI",
    "dropphyzpp": 543029998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "GREEN BAY",
    "dropmalst": "WI",
    "dropmalzpp": 543089998,
    "dropsitphn": 4142912520,
    "dropsitlph": 9204653369,
    "dropsitcph": 9204653317,
    "dropfax": 9204657257
  },
  {
    "dcode": "D",
    "dropkey": "SY17498",
    "droptype": "D",
    "dropname": "JUNEAU",
    "dropdeladd": "606 E JUNEAU AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532029998,
    "dropphyadd": "606 E JUNEAU AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532029998,
    "dropmaladd": "606 E JUNEAU AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532029998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142890809,
    "dropsitcph": 4142890809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY17666",
    "droptype": "D",
    "dropname": "MID CITY",
    "dropdeladd": "3421 W VLIET ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532089998,
    "dropphyadd": "3421 W VLIET ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532089998,
    "dropmaladd": "3421 W VLIET ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532089998,
    "dropsitphn": 4143423315,
    "dropsitlph": 4143423315,
    "dropsitcph": 4143423339,
    "dropfax": 4143423586
  },
  {
    "dcode": "D",
    "dropkey": "SY17803",
    "droptype": "D",
    "dropname": "PARKLAWN",
    "dropdeladd": "3931 N 35TH ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532169998,
    "dropphyadd": "3931 N 35TH ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532169998,
    "dropmaladd": "3931 N 35TH ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532169998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144452957,
    "dropsitcph": 4144452934,
    "dropfax": 4144452229
  },
  {
    "dcode": "D",
    "dropkey": "SY17959",
    "droptype": "D",
    "dropname": "SEQUOIA",
    "dropdeladd": "6825 W BROWN DEER RD",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532232183,
    "dropphyadd": "6825 W BROWN DEER RD",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532232183,
    "dropmaladd": "6825 W BROWN DEER RD",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532232183,
    "dropsitphn": 4142702120,
    "dropsitlph": 4143544295,
    "dropsitcph": 4143544285,
    "dropfax": 4143543235
  },
  {
    "dcode": "D",
    "dropkey": "SY18008",
    "droptype": "D",
    "dropname": "SOUTH SIDE",
    "dropdeladd": "820 W WINGRA DR",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537159998,
    "dropphyadd": "820 W WINGRA DR",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537159998,
    "dropmaladd": "820 W WINGRA DR",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537159998,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082506491,
    "dropsitcph": 6082506514,
    "dropfax": 6082556674
  },
  {
    "dcode": "D",
    "dropkey": "SY18152",
    "droptype": "D",
    "dropname": "FOUR MILE STATION",
    "dropdeladd": "2635 4 MILE RD",
    "dropdelcty": "RACINE",
    "dropdelst": "WI",
    "dropdelzpp": 534049998,
    "dropphyadd": "2635 4 MILE RD",
    "dropphycty": "RACINE",
    "dropphyst": "WI",
    "dropphyzpp": 534049998,
    "dropmaladd": "2635 4 MILE RD",
    "dropmalcty": "RACINE",
    "dropmalst": "WI",
    "dropmalzpp": 534049998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626816434,
    "dropsitcph": 2626817866,
    "dropfax": 2626819732
  },
  {
    "dcode": "D",
    "dropkey": "SY18193",
    "droptype": "D",
    "dropname": "TEUTONIA",
    "dropdeladd": "2656 N TEUTONIA AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532069998,
    "dropphyadd": "2656 N TEUTONIA AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532069998,
    "dropmaladd": "2656 N TEUTONIA AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4145623117,
    "dropsitcph": 4145623117,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18243",
    "droptype": "D",
    "dropname": "NORTH MILWAUKEE",
    "dropdeladd": "5995 N TEUTONIA AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532099998,
    "dropphyadd": "5995 N TEUTONIA AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532099998,
    "dropmaladd": "5995 N TEUTONIA AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532099998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144663735,
    "dropsitcph": 4144663702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18293",
    "droptype": "D",
    "dropname": "WEST RACINE",
    "dropdeladd": "1300 PERRY AVE",
    "dropdelcty": "RACINE",
    "dropdelst": "WI",
    "dropdelzpp": 534069998,
    "dropphyadd": "1300 PERRY AVE",
    "dropphycty": "RACINE",
    "dropphyst": "WI",
    "dropphyzpp": 534069998,
    "dropmaladd": "1300 PERRY AVE",
    "dropmalcty": "RACINE",
    "dropmalst": "WI",
    "dropmalzpp": 534069998,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626321698,
    "dropsitcph": 2626321008,
    "dropfax": 2626323014
  },
  {
    "dcode": "D",
    "dropkey": "SY18297",
    "droptype": "D",
    "dropname": "WESTERN",
    "dropdeladd": "5521 W CENTER ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532109998,
    "dropphyadd": "5521 W CENTER ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532109998,
    "dropmaladd": "5521 W CENTER ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532109998,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144453203,
    "dropsitcph": 4144453210,
    "dropfax": 4144452704
  },
  {
    "dcode": "D",
    "dropkey": "SY18301",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "733 STRUCK ST",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537116145,
    "dropphyadd": "733 STRUCK ST",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537116145,
    "dropmaladd": "733 STRUCK ST",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537116145,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082741783,
    "dropsitcph": 6082741793,
    "dropfax": 6082740194
  },
  {
    "dcode": "D",
    "dropkey": "SY18432",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "1765 3 MILE RD NE",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495059998,
    "dropphyadd": "1765 3 MILE RD NE",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495059998,
    "dropmaladd": "1765 3 MILE RD NE",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495059998,
    "dropsitphn": 6169771064,
    "dropsitlph": 6163644304,
    "dropsitcph": 6163644304,
    "dropfax": 6163645087
  },
  {
    "dcode": "D",
    "dropkey": "SY18435",
    "droptype": "D",
    "dropname": "AVENT FERRY",
    "dropdeladd": "3233 AVENT FERRY RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276069998,
    "dropphyadd": "3233 AVENT FERRY RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276069998,
    "dropmaladd": "3233 AVENT FERRY RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276069998,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197430663,
    "dropfax": 9198596691
  },
  {
    "dcode": "D",
    "dropkey": "SY18436",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "311 NEW BERN AVE",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276011417,
    "dropphyadd": "311 NEW BERN AVE",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276011417,
    "dropmaladd": "311 NEW BERN AVE",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276019997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198323478,
    "dropfax": 9198345511
  },
  {
    "dcode": "D",
    "dropkey": "SY18477",
    "droptype": "D",
    "dropname": "YPSILANTI TWP",
    "dropdeladd": "1482 ECORSE RD",
    "dropdelcty": "YPSILANTI",
    "dropdelst": "MI",
    "dropdelzpp": 481985962,
    "dropphyadd": "1482 ECORSE RD",
    "dropphycty": "YPSILANTI",
    "dropphyst": "MI",
    "dropphyzpp": 481985962,
    "dropmaladd": "1482 ECORSE RD",
    "dropmalcty": "YPSILANTI",
    "dropmalst": "MI",
    "dropmalzpp": 481985962,
    "dropsitphn": 3132268554,
    "dropsitlph": 3132268558,
    "dropsitcph": 7344826905,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18484",
    "droptype": "D",
    "dropname": "SOUTH MEMORIAL",
    "dropdeladd": "2728 S MEMORIAL DR",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 278349997,
    "dropphyadd": "2728 S MEMORIAL DR",
    "dropphycty": "GREENVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 278349997,
    "dropmaladd": "2728 S MEMORIAL DR",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 278349997,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2523212291,
    "dropfax": 2523215909
  },
  {
    "dcode": "D",
    "dropkey": "SY18554",
    "droptype": "D",
    "dropname": "YPSILANTI DDC",
    "dropdeladd": "108 S ADAMS ST",
    "dropdelcty": "YPSILANTI",
    "dropdelst": "MI",
    "dropdelzpp": 481975459,
    "dropphyadd": "108 S ADAMS ST",
    "dropphycty": "YPSILANTI",
    "dropphyst": "MI",
    "dropphyzpp": 481975459,
    "dropmaladd": "108 S ADAMS ST",
    "dropmalcty": "YPSILANTI",
    "dropmalst": "MI",
    "dropmalzpp": 481975459,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 7344823046,
    "dropfax": 7344821427
  },
  {
    "dcode": "D",
    "dropkey": "SY18558",
    "droptype": "D",
    "dropname": "WEST BROOKHAVEN",
    "dropdeladd": "407 BROOKHAVEN ST",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "MS",
    "dropdelzpp": 396019996,
    "dropphyadd": "407 BROOKHAVEN ST",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "MS",
    "dropphyzpp": 396019996,
    "dropmaladd": "407 BROOKHAVEN ST",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "MS",
    "dropmalzpp": 396019996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6018336144,
    "dropsitcph": 6018352352,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18567",
    "droptype": "D",
    "dropname": "NEW HOPE",
    "dropdeladd": "1882 S NEW HOPE RD",
    "dropdelcty": "GASTONIA",
    "dropdelst": "NC",
    "dropdelzpp": 280549998,
    "dropphyadd": "1882 S NEW HOPE RD",
    "dropphycty": "GASTONIA",
    "dropphyst": "NC",
    "dropphyzpp": 280549998,
    "dropmaladd": "1882 S NEW HOPE RD",
    "dropmalcty": "GASTONIA",
    "dropmalst": "NC",
    "dropmalzpp": 280549998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7048670339,
    "dropsitcph": 7048670339,
    "dropfax": 7048549106
  },
  {
    "dcode": "D",
    "dropkey": "SY18575",
    "droptype": "D",
    "dropname": "SOUTHWEST CARRIER ANNEX",
    "dropdeladd": "3285 EXPRESS CT",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489104397,
    "dropphyadd": "3285 EXPRESS CT",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489104397,
    "dropmaladd": "3285 EXPRESS CT",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489104397,
    "dropsitphn": 6169771064,
    "dropsitlph": 5172720684,
    "dropsitcph": 5172720684,
    "dropfax": 5172720698
  },
  {
    "dcode": "D",
    "dropkey": "SY18623",
    "droptype": "D",
    "dropname": "MYRTLE GROVE",
    "dropdeladd": "5637 CAROLINA BEACH RD",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 284122609,
    "dropphyadd": "5637 CAROLINA BEACH RD",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 284122609,
    "dropmaladd": "PO BOX 28412",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 284129998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103133282,
    "dropsitcph": 9103133282,
    "dropfax": 9103133288
  },
  {
    "dcode": "D",
    "dropkey": "SY18646",
    "droptype": "D",
    "dropname": "HAZELWOOD",
    "dropdeladd": "369 HAZELWOOD AVE",
    "dropdelcty": "WAYNESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287861945,
    "dropphyadd": "369 HAZELWOOD AVE",
    "dropphycty": "WAYNESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287861945,
    "dropmaladd": "369 HAZELWOOD AVE",
    "dropmalcty": "WAYNESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287861945,
    "dropsitphn": 7043934581,
    "dropsitlph": 8284563241,
    "dropsitcph": 8284563241,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18648",
    "droptype": "D",
    "dropname": "PURSELL",
    "dropdeladd": "885 PENNIMAN AVE",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MI",
    "dropdelzpp": 481701621,
    "dropphyadd": "885 PENNIMAN AVE",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MI",
    "dropphyzpp": 481701621,
    "dropmaladd": "47526 CLIPPER ST",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MI",
    "dropmalzpp": 481709998,
    "dropsitphn": 3132268558,
    "dropsitlph": 7344534669,
    "dropsitcph": 7344534669,
    "dropfax": 3134530208
  },
  {
    "dcode": "D",
    "dropkey": "SY18706",
    "droptype": "D",
    "dropname": "OAKDALE",
    "dropdeladd": "1101 SUNSET RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282169598,
    "dropphyadd": "1101 SUNSET RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282169598,
    "dropmaladd": "1101 SUNSET RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282169598,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043999401,
    "dropsitcph": 7043999401,
    "dropfax": 7043997914
  },
  {
    "dcode": "D",
    "dropkey": "SY18707",
    "droptype": "D",
    "dropname": "MINT HILL",
    "dropdeladd": "8920 LAWYERS RD",
    "dropdelcty": "MINT HILL",
    "dropdelst": "NC",
    "dropdelzpp": 282279498,
    "dropphyadd": "8920 LAWYERS RD",
    "dropphycty": "MINT HILL",
    "dropphyst": "NC",
    "dropphyzpp": 282279498,
    "dropmaladd": "8920 LAWYERS RD",
    "dropmalcty": "MINT HILL",
    "dropmalst": "NC",
    "dropmalzpp": 282279498,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045733846,
    "dropsitcph": 7045733846,
    "dropfax": 7045733869
  },
  {
    "dcode": "D",
    "dropkey": "SY18753",
    "droptype": "D",
    "dropname": "MINUET",
    "dropdeladd": "430 MINUET LN",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282179701,
    "dropphyadd": "430 MINUET LN",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282179701,
    "dropmaladd": "430 MINUET LN",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282179701,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045223842,
    "dropsitcph": 7045223842,
    "dropfax": 7045236739
  },
  {
    "dcode": "D",
    "dropkey": "SY18772",
    "droptype": "D",
    "dropname": "FAYETTEVILLE MAIN",
    "dropdeladd": "301 GREEN ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283015027,
    "dropphyadd": "301 GREEN ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283015027,
    "dropmaladd": "PO BOX 28302",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283029998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9104232309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY18779",
    "droptype": "D",
    "dropname": "DOGWOOD",
    "dropdeladd": "314 LENNON DR",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 284052383,
    "dropphyadd": "314 LENNON DR",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 284052383,
    "dropmaladd": "PO BOX 28405",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 284059998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9103133273,
    "dropsitcph": 9103133273,
    "dropfax": 9104521381
  },
  {
    "dcode": "D",
    "dropkey": "SY19131",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "8207 MARKET ST STE P",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "NC",
    "dropdelzpp": 284119192,
    "dropphyadd": "8207 MARKET ST STE P",
    "dropphycty": "WILMINGTON",
    "dropphyst": "NC",
    "dropphyzpp": 284119192,
    "dropmaladd": "PO BOX 28411",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "NC",
    "dropmalzpp": 284119998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106865192,
    "dropsitcph": 9106865192,
    "dropfax": 9106865893
  },
  {
    "dcode": "D",
    "dropkey": "SY19132",
    "droptype": "D",
    "dropname": "MIDWOOD",
    "dropdeladd": "1233 THE PLZ",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282059917,
    "dropphyadd": "1233 THE PLZ",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282059917,
    "dropmaladd": "1233 THE PLZ",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282999998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045663105,
    "dropsitcph": 7045663105,
    "dropfax": 7043324767
  },
  {
    "dcode": "D",
    "dropkey": "SY19165",
    "droptype": "D",
    "dropname": "WT HARRIS",
    "dropdeladd": "3515 DAVID COX RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282699598,
    "dropphyadd": "3515 DAVID COX RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282699598,
    "dropmaladd": "3515 DAVID COX RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282699598,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045977416,
    "dropsitcph": 7045977416,
    "dropfax": 7049219360
  },
  {
    "dcode": "D",
    "dropkey": "SY19166",
    "droptype": "D",
    "dropname": "BALLANTYNE",
    "dropdeladd": "8240 BALLANTYNE COMMONS PKWY",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282772466,
    "dropphyadd": "8240 BALLANTYNE COMMONS PKWY",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282772466,
    "dropmaladd": "8240 BALLANTYNE COMMONS PKWY",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282779798,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045400171,
    "dropsitcph": 7045400171,
    "dropfax": 7045408531
  },
  {
    "dcode": "D",
    "dropkey": "SY19167",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "4800 EXPRESS DR",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282086354,
    "dropphyadd": "4800 EXPRESS DR",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282086354,
    "dropmaladd": "4800 EXPRESS DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282086354,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043598638,
    "dropsitcph": 7043598638,
    "dropfax": 7043590623
  },
  {
    "dcode": "D",
    "dropkey": "SY19185",
    "droptype": "D",
    "dropname": "TOKAY ANNEX",
    "dropdeladd": "2812 RAMSEY ST",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283013110,
    "dropphyadd": "2812 RAMSEY ST",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283013110,
    "dropmaladd": "PO BOX 28301",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283019998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9106301012,
    "dropsitcph": 9106301012,
    "dropfax": 9108229465
  },
  {
    "dcode": "D",
    "dropkey": "SY19200",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "2800 RAEFORD RD STE 2",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283039716,
    "dropphyadd": "2800 RAEFORD RD STE 2",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283039716,
    "dropmaladd": "PO BOX 28304",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283049998,
    "dropsitphn": 7043934444,
    "dropsitlph": 9104244495,
    "dropsitcph": 9104244495,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY19203",
    "droptype": "D",
    "dropname": "CONCORD PKWY",
    "dropdeladd": "455 CONCORD PKWY N",
    "dropdelcty": "CONCORD",
    "dropdelst": "NC",
    "dropdelzpp": 280276705,
    "dropphyadd": "455 CONCORD PKWY N",
    "dropphycty": "CONCORD",
    "dropphyst": "NC",
    "dropphyzpp": 280276705,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CONCORD",
    "dropmalst": "NC",
    "dropmalzpp": 280279998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042623472,
    "dropsitcph": 7042623472,
    "dropfax": 7047955889
  },
  {
    "dcode": "D",
    "dropkey": "SY19230",
    "droptype": "D",
    "dropname": "NORTH LAKE",
    "dropdeladd": "172 WILLIAMSON RD",
    "dropdelcty": "MOORESVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 281176827,
    "dropphyadd": "172 WILLIAMSON RD",
    "dropphycty": "MOORESVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 281176827,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MOORESVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 281159998,
    "dropsitphn": 7043934581,
    "dropsitlph": 7047992061,
    "dropsitcph": 7047992061,
    "dropfax": 7047992062
  },
  {
    "dcode": "D",
    "dropkey": "SY19283",
    "droptype": "D",
    "dropname": "SOUTH UNIVERSITY",
    "dropdeladd": "1214 S UNIVERSITY AVE STE S104",
    "dropdelcty": "ANN ARBOR",
    "dropdelst": "MI",
    "dropdelzpp": 481042548,
    "dropphyadd": "1214 S UNIVERSITY AVE STE S104",
    "dropphycty": "ANN ARBOR",
    "dropphyst": "MI",
    "dropphyzpp": 481042548,
    "dropmaladd": "2075 W STADIUM BLVD",
    "dropmalcty": "ANN ARBOR",
    "dropmalst": "MI",
    "dropmalzpp": 481039998,
    "dropsitphn": 7346620223,
    "dropsitlph": 3132268554,
    "dropsitcph": 7346620223,
    "dropfax": 3136655304
  },
  {
    "dcode": "D",
    "dropkey": "SY19295",
    "droptype": "D",
    "dropname": "GRAND CHUTE",
    "dropdeladd": "311 N CASALOMA DR",
    "dropdelcty": "APPLETON",
    "dropdelst": "WI",
    "dropdelzpp": 549139101,
    "dropphyadd": "311 N CASALOMA DR",
    "dropphycty": "APPLETON",
    "dropphyst": "WI",
    "dropphyzpp": 549139101,
    "dropmaladd": "311 N CASALOMA DR",
    "dropmalcty": "APPLETON",
    "dropmalst": "WI",
    "dropmalzpp": 549139101,
    "dropsitphn": 4142702120,
    "dropsitlph": 9209939442,
    "dropsitcph": 9207354966,
    "dropfax": 9207341506
  },
  {
    "dcode": "D",
    "dropkey": "SY20016",
    "droptype": "D",
    "dropname": "HOT SPRINGS ALBERT PIKE STA",
    "dropdeladd": "101 HAMMOND DR",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719139997,
    "dropphyadd": "101 HAMMOND DR",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719139997,
    "dropmaladd": "101 HAMMOND DR",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719139997,
    "dropsitphn": 5016238404,
    "dropsitlph": 5016237462,
    "dropsitcph": 5016237462,
    "dropfax": 5016236542
  },
  {
    "dcode": "D",
    "dropkey": "SY20051",
    "droptype": "D",
    "dropname": "ASHER",
    "dropdeladd": "7401 COLONEL GLENN RD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722049998,
    "dropphyadd": "7401 COLONEL GLENN RD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722049998,
    "dropmaladd": "7401 COLONEL GLENN RD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722049998,
    "dropsitphn": 5014559728,
    "dropsitlph": 5015625250,
    "dropsitcph": 5015625250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY20335",
    "droptype": "D",
    "dropname": "DOWNTOWN FORT SMITH",
    "dropdeladd": "1020 GARRISON AVE",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729019998,
    "dropphyadd": "1020 GARRISON AVE",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729019998,
    "dropmaladd": "1020 GARRISON AVE",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729019998,
    "dropsitphn": 4794947950,
    "dropsitlph": 4794947950,
    "dropsitcph": 4794947950,
    "dropfax": 4797836556
  },
  {
    "dcode": "D",
    "dropkey": "SY20420",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "5420 KAVANAUGH BLVD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722079998,
    "dropphyadd": "5420 KAVANAUGH BLVD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722079998,
    "dropmaladd": "5420 KAVANAUGH BLVD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722079998,
    "dropsitphn": 5016637324,
    "dropsitlph": 5016665126,
    "dropsitcph": 5016665126,
    "dropfax": 5016633405
  },
  {
    "dcode": "D",
    "dropkey": "SY20570",
    "droptype": "D",
    "dropname": "HILLCREST",
    "dropdeladd": "2803 KAVANAUGH BLVD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722053873,
    "dropphyadd": "2803 KAVANAUGH BLVD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722053873,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722259998,
    "dropsitphn": 5012257839,
    "dropsitlph": 5016631872,
    "dropsitcph": 5016632265,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY20743",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "420 MAIN ST",
    "dropdelcty": "NORTH LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 721145450,
    "dropphyadd": "420 MAIN ST",
    "dropphycty": "NORTH LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 721145450,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "NORTH LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 721199998,
    "dropsitphn": 5019456732,
    "dropsitlph": 5013721284,
    "dropsitcph": 5013755164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY20863",
    "droptype": "D",
    "dropname": "NETTLETON",
    "dropdeladd": "4808 E NETTLETON AVE",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019740,
    "dropphyadd": "4808 E NETTLETON AVE",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019740,
    "dropmaladd": "4808 E NETTLETON AVE",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019740,
    "dropsitphn": 8709324374,
    "dropsitlph": 8709324374,
    "dropsitcph": 8709324374,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY20891",
    "droptype": "D",
    "dropname": "OAK PARK",
    "dropdeladd": "2901 S FIR ST",
    "dropdelcty": "PINE BLUFF",
    "dropdelst": "AR",
    "dropdelzpp": 716039998,
    "dropphyadd": "2901 S FIR ST",
    "dropphycty": "PINE BLUFF",
    "dropphyst": "AR",
    "dropphyzpp": 716039998,
    "dropmaladd": "2901 S FIR ST",
    "dropmalcty": "PINE BLUFF",
    "dropmalst": "AR",
    "dropmalzpp": 716039998,
    "dropsitphn": 8705353559,
    "dropsitlph": 8705367440,
    "dropsitcph": 8705367440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY20940",
    "droptype": "D",
    "dropname": "PARKHILL",
    "dropdeladd": "4601 JOHN F KENNEDY BLVD",
    "dropdelcty": "NORTH LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 721169998,
    "dropphyadd": "4601 JOHN F KENNEDY BLVD",
    "dropphycty": "NORTH LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 721169998,
    "dropmaladd": "4601 JOHN F KENNEDY BLVD",
    "dropmalcty": "NORTH LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 721169998,
    "dropsitphn": 5017536291,
    "dropsitlph": 5017536291,
    "dropsitcph": 5017536291,
    "dropfax": 5017712523
  },
  {
    "dcode": "D",
    "dropkey": "SY21063",
    "droptype": "D",
    "dropname": "ROSE CITY",
    "dropdeladd": "4903 E BROADWAY ST",
    "dropdelcty": "NORTH LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 721179998,
    "dropphyadd": "4903 E BROADWAY ST",
    "dropphycty": "NORTH LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 721179998,
    "dropmaladd": "4903 E BROADWAY ST",
    "dropmalcty": "NORTH LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 721179998,
    "dropsitphn": 5019459759,
    "dropsitlph": 5019457936,
    "dropsitcph": 5019459759,
    "dropfax": 5019552052
  },
  {
    "dcode": "D",
    "dropkey": "SY21137",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "1700 MAIN ST",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722069998,
    "dropphyadd": "1700 MAIN ST",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722069998,
    "dropmaladd": "1700 MAIN ST",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722069998,
    "dropsitphn": 5013745382,
    "dropsitlph": 5012449246,
    "dropsitcph": 5013745382,
    "dropfax": 5013740817
  },
  {
    "dcode": "D",
    "dropkey": "SY21288",
    "droptype": "D",
    "dropname": "SPRINGDALE STATION",
    "dropdeladd": "429 HOLCOMB ST",
    "dropdelcty": "SPRINGDALE",
    "dropdelst": "AR",
    "dropdelzpp": 727649997,
    "dropphyadd": "429 HOLCOMB ST",
    "dropphycty": "SPRINGDALE",
    "dropphyst": "AR",
    "dropphyzpp": 727649997,
    "dropmaladd": "429 HOLCOMB ST",
    "dropmalcty": "SPRINGDALE",
    "dropmalst": "AR",
    "dropmalzpp": 727649997,
    "dropsitphn": 4797514441,
    "dropsitlph": 4797514447,
    "dropsitcph": 4797514447,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY21290",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "11415 HURON LN",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722119998,
    "dropphyadd": "11415 HURON LN",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722119998,
    "dropmaladd": "11415 HURON LN",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722119998,
    "dropsitphn": 5012259108,
    "dropsitlph": 5012259108,
    "dropsitcph": 5012252307,
    "dropfax": 5012252196
  },
  {
    "dcode": "D",
    "dropkey": "SY21350",
    "droptype": "D",
    "dropname": "ALLAPATTAH",
    "dropdeladd": "1799 NW 28TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331429998,
    "dropphyadd": "1799 NW 28TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331429998,
    "dropmaladd": "1799 NW 28TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331429998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3056331289,
    "dropsitcph": 3056374787,
    "dropfax": 3056355518
  },
  {
    "dcode": "D",
    "dropkey": "SY21378",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "7707 MERRILL RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322779998,
    "dropphyadd": "7707 MERRILL RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322779998,
    "dropmaladd": "7707 MERRILL RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322779998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047438341,
    "dropsitcph": 9047438452,
    "dropfax": 9047433615
  },
  {
    "dcode": "D",
    "dropkey": "SY21382",
    "droptype": "D",
    "dropname": "ASTRONAUT TRAIL",
    "dropdeladd": "5 MAIN ST",
    "dropdelcty": "TITUSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 327969991,
    "dropphyadd": "5 MAIN ST",
    "dropphycty": "TITUSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 327969991,
    "dropmaladd": "5 MAIN ST",
    "dropmalcty": "TITUSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 327969991,
    "dropsitphn": 3212678144,
    "dropsitlph": 3212678144,
    "dropsitcph": 3212674826,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY21436",
    "droptype": "D",
    "dropname": "VERO BEACH FINANCE",
    "dropdeladd": "3320 CARDINAL DR",
    "dropdelcty": "VERO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329639998,
    "dropphyadd": "3320 CARDINAL DR",
    "dropphycty": "VERO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329639998,
    "dropmaladd": "3320 CARDINAL DR",
    "dropmalcty": "VERO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329639998,
    "dropsitphn": 7722314070,
    "dropsitlph": 7722314070,
    "dropsitcph": 7722314070,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY21470",
    "droptype": "D",
    "dropname": "BISCAYNE ONE",
    "dropdeladd": "2 S BISCAYNE BLVD STE 21",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331319998,
    "dropphyadd": "2 S BISCAYNE BLVD STE 21",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331319998,
    "dropmaladd": "2 S BISCAYNE BLVD STE 21",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331319998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053729480,
    "dropsitcph": 3053737562,
    "dropfax": 3053739151
  },
  {
    "dcode": "D",
    "dropkey": "SY21505",
    "droptype": "D",
    "dropname": "BRIGHT",
    "dropdeladd": "3200 E 2ND AVE",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330139998,
    "dropphyadd": "3200 E 2ND AVE",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330139998,
    "dropmaladd": "3200 E 2ND AVE",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330139998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058827035,
    "dropsitcph": 3058829071,
    "dropfax": 3058820952
  },
  {
    "dcode": "D",
    "dropkey": "SY21551",
    "droptype": "D",
    "dropname": "CARVER",
    "dropdeladd": "4160 N CANAL ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322099998,
    "dropphyadd": "4160 N CANAL ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322099998,
    "dropmaladd": "4160 N CANAL ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322099998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043538267,
    "dropsitcph": 9043538267,
    "dropfax": 9046341930
  },
  {
    "dcode": "D",
    "dropkey": "SY21568",
    "droptype": "D",
    "dropname": "CENTERVILLE",
    "dropdeladd": "2355 CENTERVILLE RD",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323089998,
    "dropphyadd": "2355 CENTERVILLE RD",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323089998,
    "dropmaladd": "2355 CENTERVILLE RD",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323089998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8508542516,
    "dropsitcph": 8503852835,
    "dropfax": 8504220818
  },
  {
    "dcode": "D",
    "dropkey": "SY21601",
    "droptype": "D",
    "dropname": "CLEVELAND STREET",
    "dropdeladd": "650 CLEVELAND ST",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "FL",
    "dropdelzpp": 337559998,
    "dropphyadd": "650 CLEVELAND ST",
    "dropphycty": "CLEARWATER",
    "dropphyst": "FL",
    "dropphyzpp": 337559998,
    "dropmaladd": "650 CLEVELAND ST",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "FL",
    "dropmalzpp": 337559998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7274412927,
    "dropsitcph": 7274475889,
    "dropfax": 7274476657
  },
  {
    "dcode": "D",
    "dropkey": "SY21610",
    "droptype": "D",
    "dropname": "COCONUT GROVE",
    "dropdeladd": "3191 GRAND AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331339998,
    "dropphyadd": "3191 GRAND AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331339998,
    "dropmaladd": "3191 GRAND AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331339998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054610125,
    "dropsitcph": 3055296700,
    "dropfax": 3054431189
  },
  {
    "dcode": "D",
    "dropkey": "SY21612",
    "droptype": "D",
    "dropname": "COLEE",
    "dropdeladd": "1404 E LAS OLAS BLVD STE B",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333019997,
    "dropphyadd": "1404 E LAS OLAS BLVD STE B",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333019997,
    "dropmaladd": "1404 E LAS OLAS BLVD STE B",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333019997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545248226,
    "dropsitcph": 9545230327,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY21614",
    "droptype": "D",
    "dropname": "COLLEGE PARK",
    "dropdeladd": "1705 EDGEWATER DR",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328049998,
    "dropphyadd": "1705 EDGEWATER DR",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328049998,
    "dropmaladd": "1705 EDGEWATER DR",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328049998,
    "dropsitphn": 4078411913,
    "dropsitlph": 3214006518,
    "dropsitcph": 4078412634,
    "dropfax": 4074221460
  },
  {
    "dcode": "D",
    "dropkey": "SY21617",
    "droptype": "D",
    "dropname": "COLONIALTOWN",
    "dropdeladd": "611 N MILLS AVE",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328034637,
    "dropphyadd": "611 N MILLS AVE",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328034637,
    "dropmaladd": "PO BOX 539998",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328539998,
    "dropsitphn": 4078944073,
    "dropsitlph": 4078944073,
    "dropsitcph": 4078977180,
    "dropfax": 4078963033
  },
  {
    "dcode": "D",
    "dropkey": "SY21632",
    "droptype": "D",
    "dropname": "CORAL RIDGE",
    "dropdeladd": "3296 N FEDERAL HWY",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333069997,
    "dropphyadd": "3296 N FEDERAL HWY",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333069997,
    "dropmaladd": "3296 N FEDERAL HWY",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333069997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545684686,
    "dropsitcph": 9545684163,
    "dropfax": 9545652613
  },
  {
    "dcode": "D",
    "dropkey": "SY21637",
    "droptype": "D",
    "dropname": "SOUTHPOINT",
    "dropdeladd": "4150 BELFORT RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322161466,
    "dropphyadd": "4150 BELFORT RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322161466,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322559998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042968005,
    "dropsitcph": 9042964540,
    "dropfax": 9042968003
  },
  {
    "dcode": "D",
    "dropkey": "SY21661",
    "droptype": "D",
    "dropname": "CROSSROADS",
    "dropdeladd": "1275 66TH ST N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337109998,
    "dropphyadd": "1275 66TH ST N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337109998,
    "dropmaladd": "1275 66TH ST N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337109998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273441537,
    "dropfax": 7273471537
  },
  {
    "dcode": "D",
    "dropkey": "SY21713",
    "droptype": "D",
    "dropname": "DIXIE VILLAGE",
    "dropdeladd": "2860 DELANEY AVE",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328069998,
    "dropphyadd": "2860 DELANEY AVE",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328069998,
    "dropmaladd": "2860 DELANEY AVE",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328069998,
    "dropsitphn": 4074237452,
    "dropsitlph": 4074237452,
    "dropsitcph": 4074252868,
    "dropfax": 4074250740
  },
  {
    "dcode": "D",
    "dropkey": "SY21715",
    "droptype": "D",
    "dropname": "DIXIELAND",
    "dropdeladd": "1057 S FLORIDA AVE",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338039998,
    "dropphyadd": "1057 S FLORIDA AVE",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338039998,
    "dropmaladd": "1057 S FLORIDA AVE",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338039998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636802997,
    "dropfax": 9416802268
  },
  {
    "dcode": "D",
    "dropkey": "SY21721",
    "droptype": "D",
    "dropname": "DOWNTOWN BOCA RATON",
    "dropdeladd": "170 NE 2ND ST",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334329998,
    "dropphyadd": "170 NE 2ND ST",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334329998,
    "dropmaladd": "170 NE 2ND ST",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334329998,
    "dropsitphn": 5613384212,
    "dropsitlph": 5613384212,
    "dropsitcph": 5614173204,
    "dropfax": 5613951293
  },
  {
    "dcode": "D",
    "dropkey": "SY21722",
    "droptype": "D",
    "dropname": "DOWNTOWN BOYNTON BEACH",
    "dropdeladd": "217 N SEACREST BLVD",
    "dropdelcty": "BOYNTON BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334359998,
    "dropphyadd": "217 N SEACREST BLVD",
    "dropphycty": "BOYNTON BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334359998,
    "dropmaladd": "217 N SEACREST BLVD",
    "dropmalcty": "BOYNTON BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334359998,
    "dropsitphn": 5613749107,
    "dropsitlph": 5613747066,
    "dropsitcph": 5617407066,
    "dropfax": 5617322147
  },
  {
    "dcode": "D",
    "dropkey": "SY21723",
    "droptype": "D",
    "dropname": "DOWNTOWN BROOKSVILLE",
    "dropdeladd": "207 E FORT DADE AVE",
    "dropdelcty": "BROOKSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 346012613,
    "dropphyadd": "207 E FORT DADE AVE",
    "dropphycty": "BROOKSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 346012613,
    "dropmaladd": "207 E FORT DADE AVE",
    "dropmalcty": "BROOKSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 346012613,
    "dropsitphn": 8138770788,
    "dropsitlph": 3527965893,
    "dropsitcph": 3527961045,
    "dropfax": 3527545011
  },
  {
    "dcode": "D",
    "dropkey": "SY21725",
    "droptype": "D",
    "dropname": "DOWNTOWN DAYTONA BEACH",
    "dropdeladd": "220 N BEACH ST",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321143302,
    "dropphyadd": "220 N BEACH ST",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321143302,
    "dropmaladd": "220 N BEACH ST",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321143302,
    "dropsitphn": 9043592957,
    "dropsitlph": 3862262618,
    "dropsitcph": 3862589352,
    "dropfax": 3862539544
  },
  {
    "dcode": "D",
    "dropkey": "SY21726",
    "droptype": "D",
    "dropname": "DOWNTOWN DELRAY BEACH",
    "dropdeladd": "382 NE 2ND AVE",
    "dropdelcty": "DELRAY BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334443802,
    "dropphyadd": "382 NE 2ND AVE",
    "dropphycty": "DELRAY BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334443802,
    "dropmaladd": "382 NE 2ND AVE",
    "dropmalcty": "DELRAY BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334443802,
    "dropsitphn": 5616384145,
    "dropsitlph": 5616384125,
    "dropsitcph": 5616389468,
    "dropfax": 5614982942
  },
  {
    "dcode": "D",
    "dropkey": "SY21727",
    "droptype": "D",
    "dropname": "DOWNTOWN FORT MYERS",
    "dropdeladd": "1350 MONROE ST",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339019998,
    "dropphyadd": "1350 MONROE ST",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339019998,
    "dropmaladd": "1350 MONROE ST",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339019998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393323696,
    "dropfax": 2393346199
  },
  {
    "dcode": "D",
    "dropkey": "SY21729",
    "droptype": "D",
    "dropname": "DOWNTOWN GAINESVILLE",
    "dropdeladd": "401 SE 1ST AVE LOWR",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326019998,
    "dropphyadd": "401 SE 1ST AVE LOWR",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326019998,
    "dropmaladd": "401 SE 1ST AVE LOWR",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326019998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341899,
    "dropsitcph": 3523774038,
    "dropfax": 3523341924
  },
  {
    "dcode": "D",
    "dropkey": "SY21731",
    "droptype": "D",
    "dropname": "DOWNTOWN LAKELAND",
    "dropdeladd": "210 N MISSOURI AVE",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338159996,
    "dropphyadd": "210 N MISSOURI AVE",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338159996,
    "dropmaladd": "210 N MISSOURI AVE",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338159996,
    "dropsitphn": 8138770788,
    "dropsitlph": 8636827459,
    "dropsitcph": 8638028190,
    "dropfax": 8636827979
  },
  {
    "dcode": "D",
    "dropkey": "SY21733",
    "droptype": "D",
    "dropname": "DOWNTOWN NAPLES",
    "dropdeladd": "860 6TH AVE S",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341026706,
    "dropphyadd": "860 6TH AVE S",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341026706,
    "dropmaladd": "1200 GOODLETTE-FRANK RD N",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341029998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392623351,
    "dropfax": 2394039150
  },
  {
    "dcode": "D",
    "dropkey": "SY21734",
    "droptype": "D",
    "dropname": "DOWNTOWN ORLANDO",
    "dropdeladd": "51 E JEFFERSON ST",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328019998,
    "dropphyadd": "51 E JEFFERSON ST",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328019998,
    "dropmaladd": "51 E JEFFERSON ST",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328019998,
    "dropsitphn": 4074233709,
    "dropsitlph": 4074233709,
    "dropsitcph": 4074256464,
    "dropfax": 4078434766
  },
  {
    "dcode": "D",
    "dropkey": "SY21735",
    "droptype": "D",
    "dropname": "DOWNTOWN PENSACOLA",
    "dropdeladd": "101 PALAFOX PL",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325025629,
    "dropphyadd": "101 PALAFOX PL",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325025629,
    "dropmaladd": "101 PALAFOX PL",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325029997,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504390169,
    "dropsitcph": 8504390169,
    "dropfax": 8504349712
  },
  {
    "dcode": "D",
    "dropkey": "SY21738",
    "droptype": "D",
    "dropname": "DOWNTOWN WEST PALM BEACH",
    "dropdeladd": "640 CLEMATIS ST",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334019998,
    "dropphyadd": "640 CLEMATIS ST",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334019998,
    "dropmaladd": "640 CLEMATIS ST",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334019998,
    "dropsitphn": 5618330836,
    "dropsitlph": 5618330836,
    "dropsitcph": 5618330929,
    "dropfax": 5618322093
  },
  {
    "dcode": "D",
    "dropkey": "SY21739",
    "droptype": "D",
    "dropname": "DOWNTOWN PANAMA CITY",
    "dropdeladd": "421 JENKS AVE",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324012647,
    "dropphyadd": "421 JENKS AVE",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324012647,
    "dropmaladd": "421 JENKS AVE",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324012647,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507636509,
    "dropsitcph": 8507636509,
    "dropfax": 8507855386
  },
  {
    "dcode": "D",
    "dropkey": "SY21741",
    "droptype": "D",
    "dropname": "DR MARTIN LUTHER KING JR",
    "dropdeladd": "6700 NW 27TH AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331479998,
    "dropphyadd": "6700 NW 27TH AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331479998,
    "dropmaladd": "6700 NW 27TH AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331479998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058369712,
    "dropsitcph": 3058365592,
    "dropfax": 3058358527
  },
  {
    "dcode": "D",
    "dropkey": "SY21763",
    "droptype": "D",
    "dropname": "EAST HILL",
    "dropdeladd": "3001 N DAVIS HWY",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325039998,
    "dropphyadd": "3001 N DAVIS HWY",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325039998,
    "dropmaladd": "3001 N DAVIS HWY",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325039998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504391773,
    "dropsitcph": 8504391773,
    "dropfax": 8504326324
  },
  {
    "dcode": "D",
    "dropkey": "SY21782",
    "droptype": "D",
    "dropname": "EAU GALLIE",
    "dropdeladd": "681 SAINT CLAIR ST",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "FL",
    "dropdelzpp": 329359998,
    "dropphyadd": "681 SAINT CLAIR ST",
    "dropphycty": "MELBOURNE",
    "dropphyst": "FL",
    "dropphyzpp": 329359998,
    "dropmaladd": "681 SAINT CLAIR ST",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "FL",
    "dropmalzpp": 329359998,
    "dropsitphn": 3212541031,
    "dropsitlph": 3212541031,
    "dropsitcph": 3212541031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY21808",
    "droptype": "D",
    "dropname": "EUCLID",
    "dropdeladd": "901 34TH AVE N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337049998,
    "dropphyadd": "901 34TH AVE N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337049998,
    "dropmaladd": "901 34TH AVE N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337049998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275251930,
    "dropfax": 7275278560
  },
  {
    "dcode": "D",
    "dropkey": "SY21840",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "1114 LAKE DR",
    "dropdelcty": "COCOA",
    "dropdelst": "FL",
    "dropdelzpp": 329229991,
    "dropphyadd": "1114 LAKE DR",
    "dropphycty": "COCOA",
    "dropphyst": "FL",
    "dropphyzpp": 329229991,
    "dropmaladd": "1114 LAKE DR",
    "dropmalcty": "COCOA",
    "dropmalst": "FL",
    "dropmalzpp": 329229991,
    "dropsitphn": 3216359069,
    "dropsitlph": 3216359069,
    "dropsitcph": 3216327190,
    "dropfax": 3216339404
  },
  {
    "dcode": "D",
    "dropkey": "SY21846",
    "droptype": "D",
    "dropname": "FLAGLER KEY WEST",
    "dropdeladd": "2764 N ROOSEVELT BLVD",
    "dropdelcty": "KEY WEST",
    "dropdelst": "FL",
    "dropdelzpp": 330403931,
    "dropphyadd": "2764 N ROOSEVELT BLVD",
    "dropphycty": "KEY WEST",
    "dropphyst": "FL",
    "dropphyzpp": 330403931,
    "dropmaladd": "400 WHITEHEAD ST",
    "dropmalcty": "KEY WEST",
    "dropmalst": "FL",
    "dropmalzpp": 330409998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3052949366,
    "dropsitcph": 3052967327,
    "dropfax": 3052946575
  },
  {
    "dcode": "D",
    "dropkey": "SY21847",
    "droptype": "D",
    "dropname": "FLAGLER MIAMI",
    "dropdeladd": "500 NW 2ND AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331019998,
    "dropphyadd": "500 NW 2ND AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331019998,
    "dropmaladd": "500 NW 2ND AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331019998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053588765,
    "dropsitcph": 3053737562,
    "dropfax": 3053743216
  },
  {
    "dcode": "D",
    "dropkey": "SY21860",
    "droptype": "D",
    "dropname": "FLORENCE VILLA",
    "dropdeladd": "1401 1ST ST N",
    "dropdelcty": "WINTER HAVEN",
    "dropdelst": "FL",
    "dropdelzpp": 338812404,
    "dropphyadd": "1401 1ST ST N",
    "dropphycty": "WINTER HAVEN",
    "dropphyst": "FL",
    "dropphyzpp": 338812404,
    "dropmaladd": "1401 1ST ST N",
    "dropmalcty": "WINTER HAVEN",
    "dropmalst": "FL",
    "dropmalzpp": 338812404,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8632935370,
    "dropfax": 8632914126
  },
  {
    "dcode": "D",
    "dropkey": "SY21875",
    "droptype": "D",
    "dropname": "FOREST HILLS",
    "dropdeladd": "11800 N FLORIDA AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336129998,
    "dropphyadd": "11800 N FLORIDA AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336129998,
    "dropmaladd": "11800 N FLORIDA AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336129998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139353375,
    "dropfax": 8139351724
  },
  {
    "dcode": "D",
    "dropkey": "SY21920",
    "droptype": "D",
    "dropname": "GATEWAY",
    "dropdeladd": "1201 N FEDERAL HWY STE 2A",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333049997,
    "dropphyadd": "1201 N FEDERAL HWY STE 2A",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333049997,
    "dropmaladd": "1201 N FEDERAL HWY STE 2A",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333049997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545651722,
    "dropsitcph": 9545651722,
    "dropfax": 9545656740
  },
  {
    "dcode": "D",
    "dropkey": "SY21923",
    "droptype": "D",
    "dropname": "GATEWAY MALL",
    "dropdeladd": "701 77TH AVE N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337029998,
    "dropphyadd": "701 77TH AVE N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337029998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337329998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275782802,
    "dropfax": 7275703709
  },
  {
    "dcode": "D",
    "dropkey": "SY21924",
    "droptype": "D",
    "dropname": "DAYTONA BEACH MO",
    "dropdeladd": "500 BILL FRANCE BLVD",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321149607,
    "dropphyadd": "500 BILL FRANCE BLVD",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321149607,
    "dropmaladd": "500 BILL FRANCE BLVD",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321149998,
    "dropsitphn": 3862746327,
    "dropsitlph": 3862746336,
    "dropsitcph": 3862746335,
    "dropfax": 3862744360
  },
  {
    "dcode": "D",
    "dropkey": "SY21925",
    "droptype": "D",
    "dropname": "GAINESVILLE GEN MAIL FACLTY",
    "dropdeladd": "4600 SW 34TH ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326089998,
    "dropphyadd": "4600 SW 34TH ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326089996,
    "dropmaladd": "4600 SW 34TH ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326089998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341899,
    "dropsitcph": 3523341899,
    "dropfax": 3523341807
  },
  {
    "dcode": "D",
    "dropkey": "SY21926",
    "droptype": "D",
    "dropname": "JACKSONVILLE MOWU MY PO",
    "dropdeladd": "1100 KINGS RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322039001,
    "dropphyadd": "1100 KINGS RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322039001,
    "dropmaladd": "1100 KINGS RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322039001,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043664892,
    "dropsitcph": 9043664820,
    "dropfax": 9043664803
  },
  {
    "dcode": "D",
    "dropkey": "SY21928",
    "droptype": "D",
    "dropname": "GENERAL MAIL FACILITY MIAMI",
    "dropdeladd": "2200 NW 72ND AVE STOP 3",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331529418,
    "dropphyadd": "2200 NW 72ND AVE STOP 3",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331529418,
    "dropmaladd": "2200 NW 72ND AVE STOP 3",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331529418,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054700322,
    "dropsitcph": 3054700691,
    "dropfax": 3054700736
  },
  {
    "dcode": "D",
    "dropkey": "SY21930",
    "droptype": "D",
    "dropname": "PENSACOLA GMF FOR MY PO",
    "dropdeladd": "1400 W JORDAN ST",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325019501,
    "dropphyadd": "1400 W JORDAN ST",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325019501,
    "dropmaladd": "PO BOX 17000",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325229998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504376700,
    "dropsitcph": 8504349126,
    "dropfax": 8504388575
  },
  {
    "dcode": "D",
    "dropkey": "SY22006",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "80 N RIVERSIDE DR",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330625028,
    "dropphyadd": "80 N RIVERSIDE DR",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330625028,
    "dropmaladd": "80 N RIVERSIDE DR",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330625028,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549411448,
    "dropsitcph": 9549412859,
    "dropfax": 9547855077
  },
  {
    "dcode": "D",
    "dropkey": "SY22021",
    "droptype": "D",
    "dropname": "HERNDON",
    "dropdeladd": "821 HERNDON AVE",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328035150,
    "dropphyadd": "821 HERNDON AVE",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328035150,
    "dropmaladd": "PO BOX 149998",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328149998,
    "dropsitphn": 4078944063,
    "dropsitlph": 4078944063,
    "dropsitcph": 4078973469,
    "dropfax": 4078940322
  },
  {
    "dcode": "D",
    "dropkey": "SY22033",
    "droptype": "D",
    "dropname": "HIGH POINT",
    "dropdeladd": "4600 140TH AVE N STE 100",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "FL",
    "dropdelzpp": 337629998,
    "dropphyadd": "4600 140TH AVE N STE 100",
    "dropphycty": "CLEARWATER",
    "dropphyst": "FL",
    "dropphyzpp": 337629998,
    "dropmaladd": "4600 140TH AVE N STE 100",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "FL",
    "dropmalzpp": 337629998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275362901,
    "dropfax": 7275326992
  },
  {
    "dcode": "D",
    "dropkey": "SY22043",
    "droptype": "D",
    "dropname": "HILLDALE",
    "dropdeladd": "3201 W HILLSBOROUGH AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336149998,
    "dropphyadd": "3201 W HILLSBOROUGH AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336149998,
    "dropmaladd": "3201 W HILLSBOROUGH AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336149998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138794309,
    "dropfax": 8138700592
  },
  {
    "dcode": "D",
    "dropkey": "SY22103",
    "droptype": "D",
    "dropname": "INTERBAY",
    "dropdeladd": "4520 W OAKELLAR AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336119998,
    "dropphyadd": "4520 W OAKELLAR AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336119998,
    "dropmaladd": "4520 W OAKELLAR AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336119998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138315541,
    "dropfax": 8138322777
  },
  {
    "dcode": "D",
    "dropkey": "SY22150",
    "droptype": "D",
    "dropname": "JOSE MARTI",
    "dropdeladd": "425 NW 27TH AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331259998,
    "dropphyadd": "425 NW 27TH AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331259998,
    "dropmaladd": "425 NW 27TH AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331259998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055412439,
    "dropsitcph": 3055412478,
    "dropfax": 3056426138
  },
  {
    "dcode": "D",
    "dropkey": "SY22195",
    "droptype": "D",
    "dropname": "LAKE FOREST",
    "dropdeladd": "1440 EDGEWOOD AVE W",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322089998,
    "dropphyadd": "1440 EDGEWOOD AVE W",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322089998,
    "dropmaladd": "1440 EDGEWOOD AVE W",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322089998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047647808,
    "dropsitcph": 9047643441,
    "dropfax": 9049242528
  },
  {
    "dcode": "D",
    "dropkey": "SY22219",
    "droptype": "D",
    "dropname": "LAKE SHORE",
    "dropdeladd": "5501 WESCONNETT BLVD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322449908,
    "dropphyadd": "5501 WESCONNETT BLVD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322449908,
    "dropmaladd": "5501 WESCONNETT BLVD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322449908,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047715918,
    "dropsitcph": 9047716826,
    "dropfax": 9045736473
  },
  {
    "dcode": "D",
    "dropkey": "SY22259",
    "droptype": "D",
    "dropname": "LEON",
    "dropdeladd": "1845 N M L KING JR BLVD",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323039998,
    "dropphyadd": "1845 N M L KING JR BLVD",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323039998,
    "dropmaladd": "1845 N M L KING JR BLVD",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323039998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8503852368,
    "dropsitcph": 8503852368,
    "dropfax": 8504223686
  },
  {
    "dcode": "D",
    "dropkey": "SY22269",
    "droptype": "D",
    "dropname": "LITTLE RIVER",
    "dropdeladd": "140 NE 84TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331389998,
    "dropphyadd": "140 NE 84TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331389998,
    "dropmaladd": "140 NE 84TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331389998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3057541906,
    "dropsitcph": 3057541329,
    "dropfax": 3057567320
  },
  {
    "dcode": "D",
    "dropkey": "SY22295",
    "droptype": "D",
    "dropname": "LUCERNE AVENUE",
    "dropdeladd": "720 LUCERNE AVE",
    "dropdelcty": "LAKE WORTH BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334609998,
    "dropphyadd": "720 LUCERNE AVE",
    "dropphycty": "LAKE WORTH BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334609998,
    "dropmaladd": "720 LUCERNE AVE",
    "dropmalcty": "LAKE WORTH BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334609998,
    "dropsitphn": 5615829391,
    "dropsitlph": 5615829391,
    "dropsitcph": 5615826137,
    "dropfax": 5615827184
  },
  {
    "dcode": "D",
    "dropkey": "SY22316",
    "droptype": "D",
    "dropname": "MAIN STREET",
    "dropdeladd": "1401 N MAIN ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326019997,
    "dropphyadd": "1401 N MAIN ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326019997,
    "dropmaladd": "PO BOX 6000",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326276000,
    "dropsitphn": 9043592957,
    "dropsitlph": 3522716392,
    "dropsitcph": 3522716392,
    "dropfax": 3523380653
  },
  {
    "dcode": "D",
    "dropkey": "SY22327",
    "droptype": "D",
    "dropname": "MANDARIN",
    "dropdeladd": "4411 SUNBEAM RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322579998,
    "dropphyadd": "4411 SUNBEAM RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322579998,
    "dropmaladd": "4411 SUNBEAM RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322579998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047377579,
    "dropsitcph": 9047374852,
    "dropfax": 9047308163
  },
  {
    "dcode": "D",
    "dropkey": "SY22442",
    "droptype": "D",
    "dropname": "MURRAY HILL",
    "dropdeladd": "5455 VERNA BLVD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322059998,
    "dropphyadd": "5455 VERNA BLVD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322059998,
    "dropmaladd": "5455 VERNA BLVD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322059998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047818567,
    "dropsitcph": 9047814701,
    "dropfax": 9047869254
  },
  {
    "dcode": "D",
    "dropkey": "SY22489",
    "droptype": "D",
    "dropname": "ALRIDGE",
    "dropdeladd": "400 NW 7TH AVE",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333119997,
    "dropphyadd": "400 NW 7TH AVE",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333119997,
    "dropmaladd": "400 NW 7TH AVE",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333119997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545238699,
    "dropsitcph": 9545230327,
    "dropfax": 9544634952
  },
  {
    "dcode": "D",
    "dropkey": "SY22512",
    "droptype": "D",
    "dropname": "NOBLES",
    "dropdeladd": "7150 TIPPIN AVE",
    "dropdelcty": "PENSACOLA",
    "dropdelst": "FL",
    "dropdelzpp": 325049998,
    "dropphyadd": "7150 TIPPIN AVE",
    "dropphycty": "PENSACOLA",
    "dropphyst": "FL",
    "dropphyzpp": 325049998,
    "dropmaladd": "7150 TIPPIN AVE",
    "dropmalcty": "PENSACOLA",
    "dropmalst": "FL",
    "dropmalzpp": 325049998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8504776871,
    "dropsitcph": 8504776871,
    "dropfax": 8504761104
  },
  {
    "dcode": "D",
    "dropkey": "SY22518",
    "droptype": "D",
    "dropname": "NORMANDY",
    "dropdeladd": "525 71ST ST",
    "dropdelcty": "MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331419998,
    "dropphyadd": "525 71ST ST",
    "dropphycty": "MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331419998,
    "dropmaladd": "525 71ST ST",
    "dropmalcty": "MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331419998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058648155,
    "dropsitcph": 3058648155,
    "dropfax": 3058664373
  },
  {
    "dcode": "D",
    "dropkey": "SY22529",
    "droptype": "D",
    "dropname": "NORTH JACKSONVILLE",
    "dropdeladd": "150 BUSCH DR",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322189998,
    "dropphyadd": "150 BUSCH DR",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322189998,
    "dropmaladd": "150 BUSCH DR",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322189998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9046966479,
    "dropsitcph": 9046962058,
    "dropfax": 9047515442
  },
  {
    "dcode": "D",
    "dropkey": "SY22543",
    "droptype": "D",
    "dropname": "NORTH SIDE",
    "dropdeladd": "1315 W 17TH ST",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324059998,
    "dropphyadd": "1315 W 17TH ST",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324059998,
    "dropmaladd": "1315 W 17TH ST",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324059998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8506914499,
    "dropsitcph": 8509142539,
    "dropfax": 8507858186
  },
  {
    "dcode": "D",
    "dropkey": "SY22561",
    "droptype": "D",
    "dropname": "OAK STREET",
    "dropdeladd": "1415 W OAK ST",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347419998,
    "dropphyadd": "1415 W OAK ST",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347419998,
    "dropmaladd": "1415 W OAK ST",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347419998,
    "dropsitphn": 4078467945,
    "dropsitlph": 4078467945,
    "dropsitcph": 4078462513,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY22574",
    "droptype": "D",
    "dropname": "OCEAN VIEW",
    "dropdeladd": "445 W 40TH ST",
    "dropdelcty": "MIAMI BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 331409998,
    "dropphyadd": "445 W 40TH ST",
    "dropphycty": "MIAMI BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 331409998,
    "dropmaladd": "445 W 40TH ST",
    "dropmalcty": "MIAMI BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 331409998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055386536,
    "dropsitcph": 3055382708,
    "dropfax": 3055315512
  },
  {
    "dcode": "D",
    "dropkey": "SY22597",
    "droptype": "D",
    "dropname": "OPEN AIR",
    "dropdeladd": "76 4TH ST N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337019998,
    "dropphyadd": "76 4TH ST N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337019998,
    "dropmaladd": "76 4TH ST N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337019998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7278964035,
    "dropfax": 7278234593
  },
  {
    "dcode": "D",
    "dropkey": "SY22599",
    "droptype": "D",
    "dropname": "ORANGE AVENUE",
    "dropdeladd": "1717 ORANGE AVE",
    "dropdelcty": "FORT PIERCE",
    "dropdelst": "FL",
    "dropdelzpp": 349509998,
    "dropphyadd": "1717 ORANGE AVE",
    "dropphycty": "FORT PIERCE",
    "dropphyst": "FL",
    "dropphyzpp": 349509998,
    "dropmaladd": "1717 ORANGE AVE",
    "dropmalcty": "FORT PIERCE",
    "dropmalst": "FL",
    "dropmalzpp": 349509998,
    "dropsitphn": 7724667351,
    "dropsitlph": 7724667351,
    "dropsitcph": 7724600835,
    "dropfax": 7727429596
  },
  {
    "dcode": "D",
    "dropkey": "SY22600",
    "droptype": "D",
    "dropname": "ORANGE BLOSSOM",
    "dropdeladd": "440 S ORANGE BLOSSOM TRL",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328059997,
    "dropphyadd": "440 S ORANGE BLOSSOM TRL",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328059997,
    "dropmaladd": "440 S ORANGE BLOSSOM TRL",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328059997,
    "dropsitphn": 4078414156,
    "dropsitlph": 4078414156,
    "dropsitcph": 4078433420,
    "dropfax": 4078431948
  },
  {
    "dcode": "D",
    "dropkey": "SY22616",
    "droptype": "D",
    "dropname": "ORMOND BEACH BEACHSIDE",
    "dropdeladd": "55 E GRANADA BLVD",
    "dropdelcty": "ORMOND BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321769998,
    "dropphyadd": "55 E GRANADA BLVD",
    "dropphycty": "ORMOND BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321769998,
    "dropmaladd": "55 E GRANADA BLVD",
    "dropmalcty": "ORMOND BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321769998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3866773839,
    "dropsitcph": 3866773839,
    "dropfax": 3866720142
  },
  {
    "dcode": "D",
    "dropkey": "SY22631",
    "droptype": "D",
    "dropname": "PAGE FIELD",
    "dropdeladd": "2655 N AIRPORT RD",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339071428,
    "dropphyadd": "2655 N AIRPORT RD",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339071428,
    "dropmaladd": "2655 N AIRPORT RD",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339071428,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392773336,
    "dropfax": 2399392721
  },
  {
    "dcode": "D",
    "dropkey": "SY22651",
    "droptype": "D",
    "dropname": "PALM VILLAGE",
    "dropdeladd": "1050 W 49TH ST",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330029998,
    "dropphyadd": "1050 W 49TH ST",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330029998,
    "dropmaladd": "1050 W 49TH ST",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330029998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058236681,
    "dropsitcph": 3058258716,
    "dropfax": 3058286271
  },
  {
    "dcode": "D",
    "dropkey": "SY22661",
    "droptype": "D",
    "dropname": "PARK AVENUE",
    "dropdeladd": "221 W PARK AVE",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323017700,
    "dropphyadd": "221 W PARK AVE",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323017700,
    "dropmaladd": "221 W PARK AVE",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323017700,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502241186,
    "dropsitcph": 8502241167,
    "dropfax": 8506819874
  },
  {
    "dcode": "D",
    "dropkey": "SY22683",
    "droptype": "D",
    "dropname": "DAYTONA BEACH PENINSULA",
    "dropdeladd": "19 N ATLANTIC AVE",
    "dropdelcty": "DAYTONA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 321184201,
    "dropphyadd": "19 N ATLANTIC AVE",
    "dropphycty": "DAYTONA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 321184201,
    "dropmaladd": "19 N ATLANTIC AVE",
    "dropmalcty": "DAYTONA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 321184201,
    "dropsitphn": 3862746327,
    "dropsitlph": 3862526476,
    "dropsitcph": 3862526476,
    "dropfax": 3862527040
  },
  {
    "dcode": "D",
    "dropkey": "SY22685",
    "droptype": "D",
    "dropname": "PENINSULA TAMPA",
    "dropdeladd": "1002B S CHURCH AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336299998,
    "dropphyadd": "1002B S CHURCH AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336299998,
    "dropmaladd": "1002B S CHURCH AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336299998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132898052,
    "dropfax": 8132881513
  },
  {
    "dcode": "D",
    "dropkey": "SY22748",
    "droptype": "D",
    "dropname": "PORT SAINT LUCIE MIDPORT",
    "dropdeladd": "2255 SE VETERANS MEMORIAL PKWY",
    "dropdelcty": "PORT SAINT LUCIE",
    "dropdelst": "FL",
    "dropdelzpp": 349529998,
    "dropphyadd": "2255 SE VETERANS MEMORIAL PKWY",
    "dropphycty": "PORT SAINT LUCIE",
    "dropphyst": "FL",
    "dropphyzpp": 349529998,
    "dropmaladd": "2255 SE VETERANS MEMORIAL PKWY",
    "dropmalcty": "PORT SAINT LUCIE",
    "dropmalst": "FL",
    "dropmalzpp": 349529998,
    "dropsitphn": 7723372591,
    "dropsitlph": 7723372591,
    "dropsitcph": 7723377504,
    "dropfax": 7724468179
  },
  {
    "dcode": "D",
    "dropkey": "SY22756",
    "droptype": "D",
    "dropname": "POTTSBURG",
    "dropdeladd": "10700 BEACH BLVD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322469998,
    "dropphyadd": "10700 BEACH BLVD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322469998,
    "dropmaladd": "10700 BEACH BLVD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322469998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9044285818,
    "dropsitcph": 9046412172,
    "dropfax": 9046455636
  },
  {
    "dcode": "D",
    "dropkey": "SY22760",
    "droptype": "D",
    "dropname": "PRODUCE",
    "dropdeladd": "2810 E HILLSBOROUGH AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336109998,
    "dropphyadd": "2810 E HILLSBOROUGH AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336109998,
    "dropmaladd": "2810 E HILLSBOROUGH AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336109998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132312621,
    "dropfax": 8132393826
  },
  {
    "dcode": "D",
    "dropkey": "SY22781",
    "droptype": "D",
    "dropname": "COUNTRYSIDE",
    "dropdeladd": "25941 US HIGHWAY 19 N",
    "dropdelcty": "CLEARWATER",
    "dropdelst": "FL",
    "dropdelzpp": 337632002,
    "dropphyadd": "25941 US HIGHWAY 19 N",
    "dropphycty": "CLEARWATER",
    "dropphyst": "FL",
    "dropphyzpp": 337632002,
    "dropmaladd": "25941 US HIGHWAY 19 N",
    "dropmalcty": "CLEARWATER",
    "dropmalst": "FL",
    "dropmalzpp": 337632002,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7277916105,
    "dropfax": 7277997307
  },
  {
    "dcode": "D",
    "dropkey": "SY22889",
    "droptype": "D",
    "dropname": "SHENANDOAH",
    "dropdeladd": "1800 CORAL WAY",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331459998,
    "dropphyadd": "1800 CORAL WAY",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331459998,
    "dropmaladd": "1800 CORAL WAY",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331459998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3058569736,
    "dropsitcph": 3058568215,
    "dropfax": 3058598061
  },
  {
    "dcode": "D",
    "dropkey": "SY22910",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "1750 16TH ST S",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337059998,
    "dropphyadd": "1750 16TH ST S",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337059998,
    "dropmaladd": "1750 16TH ST S",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337059998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7278983309,
    "dropfax": 7278221787
  },
  {
    "dcode": "D",
    "dropkey": "SY22918",
    "droptype": "D",
    "dropname": "SOUTH JACKSONVILLE",
    "dropdeladd": "3000 SPRING PARK RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322079998,
    "dropphyadd": "3000 SPRING PARK RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322079998,
    "dropmaladd": "3000 SPRING PARK RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322079998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043962190,
    "dropsitcph": 9043966748,
    "dropfax": 9043463690
  },
  {
    "dcode": "D",
    "dropkey": "SY22941",
    "droptype": "D",
    "dropname": "SOUTHGATE",
    "dropdeladd": "2055 SIESTA DR",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342399998,
    "dropphyadd": "2055 SIESTA DR",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342399998,
    "dropmaladd": "2055 SIESTA DR",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342399998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9419547198,
    "dropfax": 9419517502
  },
  {
    "dcode": "D",
    "dropkey": "SY22943",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "2801 S FEDERAL HWY",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333169998,
    "dropphyadd": "2801 S FEDERAL HWY",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333169998,
    "dropmaladd": "2801 S FEDERAL HWY",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333169998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547618936,
    "dropsitcph": 9547618936,
    "dropfax": 9547648704
  },
  {
    "dcode": "D",
    "dropkey": "SY23021",
    "droptype": "D",
    "dropname": "WORTH AVE",
    "dropdeladd": "401 S COUNTY RD",
    "dropdelcty": "PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334809991,
    "dropphyadd": "401 S COUNTY RD",
    "dropphycty": "PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334809991,
    "dropmaladd": "401 S COUNTY RD",
    "dropmalcty": "PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334809991,
    "dropsitphn": 5618059771,
    "dropsitlph": 5618059771,
    "dropsitcph": 5618320697,
    "dropfax": 5612938741
  },
  {
    "dcode": "D",
    "dropkey": "SY23022",
    "droptype": "D",
    "dropname": "SPRINGFIELD",
    "dropdeladd": "1601-1 N MAIN ST",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322069998,
    "dropphyadd": "1601-1 N MAIN ST",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322069998,
    "dropmaladd": "1601-1 N MAIN ST",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322069998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9043546163,
    "dropsitcph": 9043533578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23035",
    "droptype": "D",
    "dropname": "SULPHUR SPRINGS",
    "dropdeladd": "6706 N NEBRASKA AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336049998,
    "dropphyadd": "6706 N NEBRASKA AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336049998,
    "dropmaladd": "6706 N NEBRASKA AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336049998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132374258,
    "dropfax": 8132393326
  },
  {
    "dcode": "D",
    "dropkey": "SY23058",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "7501 SW 117TH AVE",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331839998,
    "dropphyadd": "7501 SW 117TH AVE",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331839998,
    "dropmaladd": "7501 SW 117TH AVE",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331839998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055961287,
    "dropsitcph": 3052702091,
    "dropfax": 3052742034
  },
  {
    "dcode": "D",
    "dropkey": "SY23141",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "1630 NW 1ST AVE",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326039998,
    "dropphyadd": "1630 NW 1ST AVE",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326039998,
    "dropmaladd": "1630 NW 1ST AVE",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326039998,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523811895,
    "dropsitcph": 3523797736,
    "dropfax": 3523748284
  },
  {
    "dcode": "D",
    "dropkey": "SY23172",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "100 S MILITARY TRL STE 13",
    "dropdelcty": "DEERFIELD BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334429991,
    "dropphyadd": "100 S MILITARY TRL STE 13",
    "dropphycty": "DEERFIELD BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334429991,
    "dropmaladd": "100 S MILITARY TRL STE 13",
    "dropmalcty": "DEERFIELD BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334429991,
    "dropsitphn": 9544809178,
    "dropsitlph": 9544812487,
    "dropsitcph": 9544274255,
    "dropfax": 9544809673
  },
  {
    "dcode": "D",
    "dropkey": "SY23212",
    "droptype": "D",
    "dropname": "WELLINGTON",
    "dropdeladd": "12794 FOREST HILL BLVD STE K2",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "FL",
    "dropdelzpp": 334149998,
    "dropphyadd": "12794 FOREST HILL BLVD STE K2",
    "dropphycty": "WELLINGTON",
    "dropphyst": "FL",
    "dropphyzpp": 334149998,
    "dropmaladd": "12794 FOREST HILL BLVD STE K2",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "FL",
    "dropmalzpp": 334149998,
    "dropsitphn": 5617530446,
    "dropsitlph": 5617530446,
    "dropsitcph": 5617530446,
    "dropfax": 5617538270
  },
  {
    "dcode": "D",
    "dropkey": "SY23240",
    "droptype": "D",
    "dropname": "WEST TAMPA",
    "dropdeladd": "1802 N HOWARD AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336079998,
    "dropphyadd": "1802 N HOWARD AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336079998,
    "dropmaladd": "1802 N HOWARD AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336079998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132533652,
    "dropfax": 8132541394
  },
  {
    "dcode": "D",
    "dropkey": "SY23275",
    "droptype": "D",
    "dropname": "WOODLAND",
    "dropdeladd": "604 BANYAN TRL",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334319992,
    "dropphyadd": "604 BANYAN TRL",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334319992,
    "dropmaladd": "604 BANYAN TRL",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334319992,
    "dropsitphn": 5619972559,
    "dropsitlph": 5619972559,
    "dropsitcph": 5612416186,
    "dropfax": 5619978883
  },
  {
    "dcode": "D",
    "dropkey": "SY23280",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "2020 W PENSACOLA ST STE 100",
    "dropdelcty": "TALLAHASSEE",
    "dropdelst": "FL",
    "dropdelzpp": 323049998,
    "dropphyadd": "2020 W PENSACOLA ST STE 100",
    "dropphycty": "TALLAHASSEE",
    "dropphyst": "FL",
    "dropphyzpp": 323049998,
    "dropmaladd": "2020 W PENSACOLA ST STE 100",
    "dropmalcty": "TALLAHASSEE",
    "dropmalst": "FL",
    "dropmalzpp": 323049998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8505750024,
    "dropsitcph": 8505750113,
    "dropfax": 8505759070
  },
  {
    "dcode": "D",
    "dropkey": "SY23288",
    "droptype": "D",
    "dropname": "YBOR CITY",
    "dropdeladd": "2000 E 12TH AVE",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336053955,
    "dropphyadd": "2000 E 12TH AVE",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336053955,
    "dropmaladd": "2000 E 12TH AVE",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336059998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132472416,
    "dropfax": 8132472983
  },
  {
    "dcode": "D",
    "dropkey": "SY23298",
    "droptype": "D",
    "dropname": "STATION A METAIRIE",
    "dropdeladd": "701 METAIRIE RD STE 1B102",
    "dropdelcty": "METAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 700054053,
    "dropphyadd": "701 METAIRIE RD STE 1B102",
    "dropphycty": "METAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 700054053,
    "dropmaladd": "701 METAIRIE RD STE 1B102",
    "dropmalcty": "METAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 700054053,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048336210,
    "dropfax": 5048334834
  },
  {
    "dcode": "D",
    "dropkey": "SY23299",
    "droptype": "D",
    "dropname": "STATION A ALGIERS",
    "dropdeladd": "3901 MACARTHUR BLVD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701146806,
    "dropphyadd": "3901 MACARTHUR BLVD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701146806,
    "dropmaladd": "3901 MACARTHUR BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701146806,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043629829,
    "dropfax": 5043671538
  },
  {
    "dcode": "D",
    "dropkey": "SY23346",
    "droptype": "D",
    "dropname": "AUDUBON",
    "dropdeladd": "4500 GOVERNMENT ST",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708065817,
    "dropphyadd": "4500 GOVERNMENT ST",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708065817,
    "dropmaladd": "PO BOX 66680",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708969998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253837509,
    "dropfax": 2253364691
  },
  {
    "dcode": "D",
    "dropkey": "SY23439",
    "droptype": "D",
    "dropname": "BREARD",
    "dropdeladd": "3211 BREARD ST",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712019998,
    "dropphyadd": "3211 BREARD ST",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712019998,
    "dropmaladd": "3211 BREARD ST",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712019998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3183878337,
    "dropfax": 3183241329
  },
  {
    "dcode": "D",
    "dropkey": "SY23445",
    "droptype": "D",
    "dropname": "BROADVIEW",
    "dropdeladd": "235 MARILYN DR",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708154405,
    "dropphyadd": "235 MARILYN DR",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708154405,
    "dropmaladd": "PO BOX 15000",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708959998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2259273687,
    "dropfax": 2259265346
  },
  {
    "dcode": "D",
    "dropkey": "SY23468",
    "droptype": "D",
    "dropname": "BYWATER",
    "dropdeladd": "1521 POLAND AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701174800,
    "dropphyadd": "1521 POLAND AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701174800,
    "dropmaladd": "1521 POLAND AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701174800,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5049493371,
    "dropfax": 5049493371
  },
  {
    "dcode": "D",
    "dropkey": "SY23491",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "900 N 3RD ST",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708029998,
    "dropphyadd": "900 N 3RD ST",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708029998,
    "dropmaladd": "PO BOX 44000",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708049998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253438119,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23496",
    "droptype": "D",
    "dropname": "CARROLLTON",
    "dropdeladd": "3400 S CARROLLTON AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701184582,
    "dropphyadd": "3400 S CARROLLTON AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701184582,
    "dropmaladd": "3400 S CARROLLTON AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701184582,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044850758,
    "dropfax": 5044820646
  },
  {
    "dcode": "D",
    "dropkey": "SY23510",
    "droptype": "D",
    "dropname": "CENTENARY",
    "dropdeladd": "326 KINGS HWY",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711049998,
    "dropphyadd": "326 KINGS HWY",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711049998,
    "dropmaladd": "326 KINGS HWY",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711049998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184244967,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23527",
    "droptype": "D",
    "dropname": "CHEF MENTEUR",
    "dropdeladd": "5919 CHEF MENTEUR HWY",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701265185,
    "dropphyadd": "5919 CHEF MENTEUR HWY",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701265185,
    "dropmaladd": "5919 CHEF MENTEUR HWY",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701265185,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042463740,
    "dropfax": 5042461607
  },
  {
    "dcode": "D",
    "dropkey": "SY23564",
    "droptype": "D",
    "dropname": "COMMERCE PARK",
    "dropdeladd": "10380 PERKINS RD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708109997,
    "dropphyadd": "10380 PERKINS RD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708109997,
    "dropmaladd": "10380 PERKINS RD",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708109997,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257690542,
    "dropfax": 2257672957
  },
  {
    "dcode": "D",
    "dropkey": "SY23634",
    "droptype": "D",
    "dropname": "MAIN OFFICE DOWNTOWN UNIT",
    "dropdeladd": "750 FLORIDA ST",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708011711,
    "dropphyadd": "750 FLORIDA ST",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708011711,
    "dropmaladd": "750 FLORIDA ST",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708011711,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253810325,
    "dropfax": 2253810386
  },
  {
    "dcode": "D",
    "dropkey": "SY23636",
    "droptype": "D",
    "dropname": "DOWNTOWN MORGAN CITY",
    "dropdeladd": "511 1ST ST",
    "dropdelcty": "MORGAN CITY",
    "dropdelst": "LA",
    "dropdelzpp": 703803700,
    "dropphyadd": "511 1ST ST",
    "dropphycty": "MORGAN CITY",
    "dropphyst": "LA",
    "dropphyzpp": 703803700,
    "dropmaladd": "511 1ST ST",
    "dropmalcty": "MORGAN CITY",
    "dropmalst": "LA",
    "dropmalzpp": 703803700,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043850031,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23637",
    "droptype": "D",
    "dropname": "DOWNTOWN SHREVEPORT",
    "dropdeladd": "333 MILAM ST",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711019998,
    "dropphyadd": "333 MILAM ST",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711019998,
    "dropmaladd": "333 MILAM ST",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711019998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3182273593,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23640",
    "droptype": "D",
    "dropname": "DREW",
    "dropdeladd": "5000 LAKE ST",
    "dropdelcty": "LAKE CHARLES",
    "dropdelst": "LA",
    "dropdelzpp": 706056500,
    "dropphyadd": "5000 LAKE ST",
    "dropphycty": "LAKE CHARLES",
    "dropphyst": "LA",
    "dropphyzpp": 706056500,
    "dropmaladd": "PO BOX 5000",
    "dropmalcty": "LAKE CHARLES",
    "dropmalst": "LA",
    "dropmalzpp": 706069998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374747889,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23656",
    "droptype": "D",
    "dropname": "EAST NATCHITOCHES",
    "dropdeladd": "727 KEYSER AVE",
    "dropdelcty": "NATCHITOCHES",
    "dropdelst": "LA",
    "dropdelzpp": 714579997,
    "dropphyadd": "727 KEYSER AVE",
    "dropphycty": "NATCHITOCHES",
    "dropphyst": "LA",
    "dropphyzpp": 714579997,
    "dropmaladd": "727 KEYSER AVE",
    "dropmalcty": "NATCHITOCHES",
    "dropmalst": "LA",
    "dropmalzpp": 714579997,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183521446,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23658",
    "droptype": "D",
    "dropname": "EASTSIDE",
    "dropdeladd": "950 MAIN ST",
    "dropdelcty": "LAKE CHARLES",
    "dropdelst": "LA",
    "dropdelzpp": 706155022,
    "dropphyadd": "950 MAIN ST",
    "dropphycty": "LAKE CHARLES",
    "dropphyst": "LA",
    "dropphyzpp": 706155022,
    "dropmaladd": "PO BOX 16000",
    "dropmalcty": "LAKE CHARLES",
    "dropmalst": "LA",
    "dropmalzpp": 706169998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374337689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23676",
    "droptype": "D",
    "dropname": "ENERGY CENTER",
    "dropdeladd": "455 FEU FOLLET RD",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705084223,
    "dropphyadd": "455 FEU FOLLET RD",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705084223,
    "dropmaladd": "455 FEU FOLLET RD",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705089998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372343374,
    "dropfax": 3372669731
  },
  {
    "dcode": "D",
    "dropkey": "SY23775",
    "droptype": "D",
    "dropname": "GMF PASSPORT OFFICE",
    "dropdeladd": "8101 BLUEBONNET BLVD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708102830,
    "dropphyadd": "8101 BLUEBONNET BLVD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708109996,
    "dropmaladd": "8101 BLUEBONNET BLVD",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708109996,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257633671,
    "dropfax": 2257633660
  },
  {
    "dcode": "D",
    "dropkey": "SY23777",
    "droptype": "D",
    "dropname": "GENTILLY FINANCE",
    "dropdeladd": "2051 CATON ST",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701223156,
    "dropphyadd": "2051 CATON ST",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701223156,
    "dropmaladd": "2051 CATON ST",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701223156,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042846981,
    "dropfax": 5042889154
  },
  {
    "dcode": "D",
    "dropkey": "SY23824",
    "droptype": "D",
    "dropname": "GRETNA FINANCE",
    "dropdeladd": "739 3RD ST",
    "dropdelcty": "GRETNA",
    "dropdelst": "LA",
    "dropdelzpp": 700535869,
    "dropphyadd": "739 3RD ST",
    "dropphycty": "GRETNA",
    "dropphyst": "LA",
    "dropphyzpp": 700535869,
    "dropmaladd": "739 3RD ST",
    "dropmalcty": "GRETNA",
    "dropmalst": "LA",
    "dropmalzpp": 700535869,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5043627152,
    "dropfax": 5043672962
  },
  {
    "dcode": "D",
    "dropkey": "SY23893",
    "droptype": "D",
    "dropname": "HUNTINGTON STATION",
    "dropdeladd": "6719 PINES RD",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711299998,
    "dropphyadd": "6719 PINES RD",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711299998,
    "dropmaladd": "6719 PINES RD",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711299998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186869490,
    "dropfax": 3186869439
  },
  {
    "dcode": "D",
    "dropkey": "SY23905",
    "droptype": "D",
    "dropname": "INDUSTRIAL",
    "dropdeladd": "1446 HAWN AVE",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711079998,
    "dropphyadd": "1446 HAWN AVE",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711079998,
    "dropmaladd": "1446 HAWN AVE",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711079998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186748369,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY23907",
    "droptype": "D",
    "dropname": "INTERNATIONAL TRADE MART",
    "dropdeladd": "2 CANAL ST STE 330",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701301200,
    "dropphyadd": "2 CANAL ST STE 330",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701301200,
    "dropmaladd": "2 CANAL ST STE 330",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701301200,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045243573,
    "dropsitcph": 5045236127,
    "dropfax": 5045891010
  },
  {
    "dcode": "D",
    "dropkey": "SY23915",
    "droptype": "D",
    "dropname": "ISTROUMA",
    "dropdeladd": "5200 LONGFELLOW DR",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708052711,
    "dropphyadd": "5200 LONGFELLOW DR",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708052711,
    "dropmaladd": "PO BOX 52700",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708929998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253551607,
    "dropfax": 2253566205
  },
  {
    "dcode": "D",
    "dropkey": "SY23922",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "101 JEFFERSON ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705017007,
    "dropphyadd": "101 JEFFERSON ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705017007,
    "dropmaladd": "PO BOX 2000",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705029998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372320286,
    "dropfax": 3372699794
  },
  {
    "dcode": "D",
    "dropkey": "SY23927",
    "droptype": "D",
    "dropname": "JOHNSON STREET",
    "dropdeladd": "3517 JOHNSON ST",
    "dropdelcty": "METAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 700015100,
    "dropphyadd": "3517 JOHNSON ST",
    "dropphycty": "METAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 700015100,
    "dropmaladd": "3517 JOHNSON ST",
    "dropmalcty": "METAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 700015100,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048370493,
    "dropfax": 5048314896
  },
  {
    "dcode": "D",
    "dropkey": "SY23986",
    "droptype": "D",
    "dropname": "LAFAYETTE SQUARE",
    "dropdeladd": "600 S MAESTRI PL",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701309998,
    "dropphyadd": "600 S MAESTRI PL",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701309998,
    "dropmaladd": "600 S MAESTRI PL",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701309998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045292891,
    "dropfax": 5045811039
  },
  {
    "dcode": "D",
    "dropkey": "SY23994",
    "droptype": "D",
    "dropname": "LAKE FOREST STATION",
    "dropdeladd": "9600 LAKE FOREST BLVD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701279998,
    "dropphyadd": "9600 LAKE FOREST BLVD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701279998,
    "dropmaladd": "9600 LAKE FOREST BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701279998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5042408695,
    "dropfax": 5042413639
  },
  {
    "dcode": "D",
    "dropkey": "SY24002",
    "droptype": "D",
    "dropname": "LAKEVIEW",
    "dropdeladd": "6319 MARSHAL FOCH ST",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701243900,
    "dropphyadd": "6319 MARSHAL FOCH ST",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701243900,
    "dropmaladd": "6319 MARSHAL FOCH ST",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701243900,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044830993,
    "dropfax": 5044830982
  },
  {
    "dcode": "D",
    "dropkey": "SY24079",
    "droptype": "D",
    "dropname": "LYNBROOK",
    "dropdeladd": "241 LYNBROOK BLVD",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711069998,
    "dropphyadd": "241 LYNBROOK BLVD",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711069998,
    "dropmaladd": "241 LYNBROOK BLVD",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711069998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186879575,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24152",
    "droptype": "D",
    "dropname": "AIRMAIL CENTER",
    "dropdeladd": "100 AIRPORT SERVICE RD",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701415000,
    "dropphyadd": "100 AIRPORT SERVICE RD",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701415000,
    "dropmaladd": "5720 CITRUS BLVD",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701235855,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5044655547,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24176",
    "droptype": "D",
    "dropname": "MERIWETHER",
    "dropdeladd": "8340 MANSFIELD RD",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711089998,
    "dropphyadd": "8340 MANSFIELD RD",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711089998,
    "dropmaladd": "8340 MANSFIELD RD",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711089998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186887961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24181",
    "droptype": "D",
    "dropname": "MOSS BLUFF",
    "dropdeladd": "172 E TELEPHONE RD",
    "dropdelcty": "LAKE CHARLES",
    "dropdelst": "LA",
    "dropdelzpp": 706115314,
    "dropphyadd": "172 E TELEPHONE RD",
    "dropphycty": "LAKE CHARLES",
    "dropphyst": "LA",
    "dropphyzpp": 706115314,
    "dropmaladd": "PO BOX 12000",
    "dropmalcty": "LAKE CHARLES",
    "dropmalst": "LA",
    "dropmalzpp": 706129998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3378558616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24240",
    "droptype": "D",
    "dropname": "NORTH KENNER",
    "dropdeladd": "390 W ESPLANADE AVE",
    "dropdelcty": "KENNER",
    "dropdelst": "LA",
    "dropdelzpp": 700652577,
    "dropphyadd": "390 W ESPLANADE AVE",
    "dropphycty": "KENNER",
    "dropphyst": "LA",
    "dropphyzpp": 700652577,
    "dropmaladd": "390 W ESPLANADE AVE",
    "dropmalcty": "KENNER",
    "dropmalst": "LA",
    "dropmalzpp": 700652577,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5047121898,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24242",
    "droptype": "D",
    "dropname": "NORTH 18TH STREET",
    "dropdeladd": "501 STERLINGTON RD",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712039998,
    "dropphyadd": "501 STERLINGTON RD",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712039996,
    "dropmaladd": "501 STERLINGTON RD",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712039998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3183876161,
    "dropfax": 3183241329
  },
  {
    "dcode": "D",
    "dropkey": "SY24245",
    "droptype": "D",
    "dropname": "NORTHSIDE STATION",
    "dropdeladd": "1701 SHANNON ST",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712019996,
    "dropphyadd": "1701 SHANNON ST",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712019996,
    "dropmaladd": "1701 SHANNON ST",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712019996,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183233691,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24264",
    "droptype": "D",
    "dropname": "OIL CENTER",
    "dropdeladd": "1031 COOLIDGE BLVD",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705032435,
    "dropphyadd": "1031 COOLIDGE BLVD",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705032435,
    "dropmaladd": "1031 COOLIDGE BLVD",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705032435,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372343413,
    "dropfax": 3372337189
  },
  {
    "dcode": "D",
    "dropkey": "SY24268",
    "droptype": "D",
    "dropname": "OLD HAMMOND",
    "dropdeladd": "10936 OLD HAMMOND HWY",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708169998,
    "dropphyadd": "10936 OLD HAMMOND HWY",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708169998,
    "dropmaladd": "10936 OLD HAMMOND HWY",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708169998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2252739634,
    "dropfax": 2252733201
  },
  {
    "dcode": "D",
    "dropkey": "SY24271",
    "droptype": "D",
    "dropname": "OLINKRAFT",
    "dropdeladd": "601 WOOD ST",
    "dropdelcty": "WEST MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712919998,
    "dropphyadd": "601 WOOD ST",
    "dropphycty": "WEST MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712919997,
    "dropmaladd": "601 WOOD ST",
    "dropmalcty": "WEST MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712919998,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891027,
    "dropsitcph": 3183878821,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24290",
    "droptype": "D",
    "dropname": "PARK MANOR",
    "dropdeladd": "6550 PARK MANOR DR",
    "dropdelcty": "METAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 700033900,
    "dropphyadd": "6550 PARK MANOR DR",
    "dropphycty": "METAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 700033900,
    "dropmaladd": "6550 PARK MANOR DR",
    "dropmalcty": "METAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 700033900,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5047800724,
    "dropfax": 5044561919
  },
  {
    "dcode": "D",
    "dropkey": "SY24291",
    "droptype": "D",
    "dropname": "PARK MANOR FINANCE",
    "dropdeladd": "7044 VETERANS MEMORIAL BLVD",
    "dropdelcty": "METAIRIE",
    "dropdelst": "LA",
    "dropdelzpp": 700034467,
    "dropphyadd": "7044 VETERANS MEMORIAL BLVD",
    "dropphycty": "METAIRIE",
    "dropphyst": "LA",
    "dropphyzpp": 700034467,
    "dropmaladd": "7044 VETERANS MEMORIAL BLVD",
    "dropmalcty": "METAIRIE",
    "dropmalst": "LA",
    "dropmalzpp": 700034467,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048882621,
    "dropfax": 5048886581
  },
  {
    "dcode": "D",
    "dropkey": "SY24321",
    "droptype": "D",
    "dropname": "PLANTATION STATION",
    "dropdeladd": "4310 BARKSDALE BLVD",
    "dropdelcty": "BOSSIER CITY",
    "dropdelst": "LA",
    "dropdelzpp": 711129998,
    "dropphyadd": "4310 BARKSDALE BLVD",
    "dropphycty": "BOSSIER CITY",
    "dropphyst": "LA",
    "dropphyzpp": 711129998,
    "dropmaladd": "4310 BARKSDALE BLVD",
    "dropmalcty": "BOSSIER CITY",
    "dropmalst": "LA",
    "dropmalzpp": 711129998,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3187415507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24435",
    "droptype": "D",
    "dropname": "SCOTLANDVILLE",
    "dropdeladd": "7980 PLANK RD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708119998,
    "dropphyadd": "7980 PLANK RD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708119998,
    "dropmaladd": "7980 PLANK RD",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708119998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2253550882,
    "dropfax": 2253565878
  },
  {
    "dcode": "D",
    "dropkey": "SY24478",
    "droptype": "D",
    "dropname": "SOUTH PARK STATION",
    "dropdeladd": "3401 GOVERNMENT ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "LA",
    "dropdelzpp": 713029996,
    "dropphyadd": "3401 GOVERNMENT ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "LA",
    "dropphyzpp": 713029996,
    "dropmaladd": "3401 GOVERNMENT ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "LA",
    "dropmalzpp": 713029996,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184439056,
    "dropfax": 3184439860
  },
  {
    "dcode": "D",
    "dropkey": "SY24483",
    "droptype": "D",
    "dropname": "SOUTHEAST",
    "dropdeladd": "4535 BENNINGTON AVE",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708083110,
    "dropphyadd": "4535 BENNINGTON AVE",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708083110,
    "dropmaladd": "PO BOX 14000",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708989998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2259253429,
    "dropfax": 2259259456
  },
  {
    "dcode": "D",
    "dropkey": "SY24488",
    "droptype": "D",
    "dropname": "SOUTHFIELD",
    "dropdeladd": "1925 E 70TH ST",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711050002,
    "dropphyadd": "1925 E 70TH ST",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711050002,
    "dropmaladd": "1925 E 70TH ST",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711050002,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3185241827,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24490",
    "droptype": "D",
    "dropname": "AMBASSADOR",
    "dropdeladd": "3603D AMBASSADOR CAFFERY PKWY",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705039998,
    "dropphyadd": "3603D AMBASSADOR CAFFERY PKWY",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705039998,
    "dropmaladd": "3603D AMBASSADOR CAFFERY PKWY",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705039998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3379883363,
    "dropfax": 3372337189
  },
  {
    "dcode": "D",
    "dropkey": "SY24600",
    "droptype": "D",
    "dropname": "UPTOWN STATION",
    "dropdeladd": "2000 LOUISIANA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701159998,
    "dropphyadd": "2000 LOUISIANA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701159998,
    "dropmaladd": "2000 LOUISIANA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701159998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5048910350,
    "dropfax": 5048953972
  },
  {
    "dcode": "D",
    "dropkey": "SY24616",
    "droptype": "D",
    "dropname": "VIEUX CARRE",
    "dropdeladd": "1022 IBERVILLE ST",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701123118,
    "dropphyadd": "1022 IBERVILLE ST",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701123118,
    "dropmaladd": "1022 IBERVILLE ST",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701123118,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045254896,
    "dropfax": 5045891010
  },
  {
    "dcode": "D",
    "dropkey": "SY24650",
    "droptype": "D",
    "dropname": "WEST SLIDELL",
    "dropdeladd": "1897 GAUSE BLVD W",
    "dropdelcty": "SLIDELL",
    "dropdelst": "LA",
    "dropdelzpp": 704608300,
    "dropphyadd": "1897 GAUSE BLVD W",
    "dropphycty": "SLIDELL",
    "dropphyst": "LA",
    "dropphyzpp": 704608300,
    "dropmaladd": "1897 GAUSE BLVD W",
    "dropmalcty": "SLIDELL",
    "dropmalst": "LA",
    "dropmalzpp": 704608300,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 9856491864,
    "dropfax": 9856491492
  },
  {
    "dcode": "D",
    "dropkey": "SY24655",
    "droptype": "D",
    "dropname": "WESTSIDE STATION",
    "dropdeladd": "1411 METRO DR",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "LA",
    "dropdelzpp": 713019996,
    "dropphyadd": "1411 METRO DR",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "LA",
    "dropphyzpp": 713019996,
    "dropmaladd": "1411 METRO DR",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "LA",
    "dropmalzpp": 713019996,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3184844602,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY24681",
    "droptype": "D",
    "dropname": "WOODLAWN",
    "dropdeladd": "4700 MILLWOOD DR",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708171200,
    "dropphyadd": "4700 MILLWOOD DR",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708171200,
    "dropmaladd": "PO BOX 77000",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708799998,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257527418,
    "dropfax": 2257516241
  },
  {
    "dcode": "D",
    "dropkey": "SY24799",
    "droptype": "D",
    "dropname": "BEAR CREEK",
    "dropdeladd": "1224 EASTGATE DR SE",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559049998,
    "dropphyadd": "1224 EASTGATE DR SE",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559049998,
    "dropmaladd": "1224 EASTGATE DR SE",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559049998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072810573,
    "dropfax": 5072524721
  },
  {
    "dcode": "D",
    "dropkey": "SY24942",
    "droptype": "D",
    "dropname": "BUTLER QUARTER",
    "dropdeladd": "100 N 6TH ST STE 120B",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554031500,
    "dropphyadd": "100 N 6TH ST STE 120B",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554031500,
    "dropmaladd": "100 N 6TH ST STE 120B",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554031500,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123333704,
    "dropsitcph": 6123333704,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25008",
    "droptype": "D",
    "dropname": "CITY STATION BOXING",
    "dropdeladd": "102 BROADWAY AVE S STE 100",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559049920,
    "dropphyadd": "102 BROADWAY AVE S STE 100",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559049920,
    "dropmaladd": "102 BROADWAY AVE S STE 100",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559046549,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 5072871240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25009",
    "droptype": "D",
    "dropname": "CIVIC CENTER",
    "dropdeladd": "515 W 1ST ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558021300,
    "dropphyadd": "515 W 1ST ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558021300,
    "dropmaladd": "515 W 1ST ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558021300,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232575,
    "dropsitcph": 2187221681,
    "dropfax": 2187232557
  },
  {
    "dcode": "D",
    "dropkey": "SY25054",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "307 4TH AVE S",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554151009,
    "dropphyadd": "307 4TH AVE S",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554151009,
    "dropmaladd": "307 4TH AVE S",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554159998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123330916,
    "dropsitcph": 6123333153,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25119",
    "droptype": "D",
    "dropname": "DAYTONS BLUFF",
    "dropdeladd": "1425 MINNEHAHA AVE E",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551064800,
    "dropphyadd": "1425 MINNEHAHA AVE E",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551064800,
    "dropmaladd": "1425 MINNEHAHA AVE E",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551069998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6517780872,
    "dropsitcph": 6517712011,
    "dropfax": 6517767045
  },
  {
    "dcode": "D",
    "dropkey": "SY25142",
    "droptype": "D",
    "dropname": "DIAMOND LAKE",
    "dropdeladd": "5500 NICOLLET AVE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554191930,
    "dropphyadd": "5500 NICOLLET AVE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554191930,
    "dropmaladd": "5500 NICOLLET AVE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554199998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6128232726,
    "dropsitcph": 6128232726,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25184",
    "droptype": "D",
    "dropname": "EASTSIDE",
    "dropdeladd": "1600 18TH AVE NE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554184714,
    "dropphyadd": "1600 18TH AVE NE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554184714,
    "dropmaladd": "1600 18TH AVE NE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554184714,
    "dropsitphn": 6123496399,
    "dropsitlph": 6127819086,
    "dropsitcph": 6127819086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25217",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "5100 W 36TH ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554162618,
    "dropphyadd": "5100 W 36TH ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554162618,
    "dropmaladd": "5100 W 36TH ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 9529229104,
    "dropsitcph": 9529229104,
    "dropfax": 9529260127
  },
  {
    "dcode": "D",
    "dropkey": "SY25219",
    "droptype": "D",
    "dropname": "ELWAY",
    "dropdeladd": "1715 7TH ST W",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551162346,
    "dropphyadd": "1715 7TH ST W",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551162346,
    "dropmaladd": "1715 7TH ST W",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551169998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516992984,
    "dropsitcph": 6516992762,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25522",
    "droptype": "D",
    "dropname": "INDUSTRIAL",
    "dropdeladd": "1430 CONCORDIA AVE",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551045485,
    "dropphyadd": "1430 CONCORDIA AVE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551045485,
    "dropmaladd": "1430 CONCORDIA AVE",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551049998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516448783,
    "dropsitcph": 6516457301,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25624",
    "droptype": "D",
    "dropname": "LAKESIDE",
    "dropdeladd": "4427 E SUPERIOR ST",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558042100,
    "dropphyadd": "4427 E SUPERIOR ST",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558042100,
    "dropmaladd": "4427 E SUPERIOR ST",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558042100,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232512,
    "dropsitcph": 2185251040,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25722",
    "droptype": "D",
    "dropname": "LORING",
    "dropdeladd": "18 N 12TH ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554039998,
    "dropphyadd": "18 N 12TH ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554039998,
    "dropmaladd": "18 N 12TH ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554039998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123321381,
    "dropsitcph": 6123336213,
    "dropfax": 6123417773
  },
  {
    "dcode": "D",
    "dropkey": "SY25726",
    "droptype": "D",
    "dropname": "LOWRY AVENUE",
    "dropdeladd": "2306 LOWRY AVE N",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554119998,
    "dropphyadd": "2306 LOWRY AVE N",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554119998,
    "dropmaladd": "2306 LOWRY AVE N",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554119998,
    "dropsitphn": 6123499163,
    "dropsitlph": 6125216729,
    "dropsitcph": 6125227305,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25741",
    "droptype": "D",
    "dropname": "MADISON EAST",
    "dropdeladd": "1400 MADISON AVE STE 328",
    "dropdelcty": "MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560015465,
    "dropphyadd": "1400 MADISON AVE STE 328",
    "dropphycty": "MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560015465,
    "dropmaladd": "1400 MADISON AVE STE 328",
    "dropmalcty": "MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560015465,
    "dropsitphn": 6123499163,
    "dropsitlph": 6123496348,
    "dropsitcph": 5076256831,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25855",
    "droptype": "D",
    "dropname": "MINNESOTA TRANSFER",
    "dropdeladd": "2334 UNIVERSITY AVE W",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551141802,
    "dropphyadd": "2334 UNIVERSITY AVE W",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551141802,
    "dropmaladd": "2334 UNIVERSITY AVE W",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516457745,
    "dropsitcph": 6516457703,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY25898",
    "droptype": "D",
    "dropname": "MOUNT ROYAL",
    "dropdeladd": "200 MOUNT ROYAL SHOPPING CIR",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558032633,
    "dropphyadd": "200 MOUNT ROYAL SHOPPING CIR",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558032633,
    "dropmaladd": "200 MOUNT ROYAL SHOPPING CIR",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558039998,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187243151,
    "dropsitcph": 2187243151,
    "dropfax": 2187280986
  },
  {
    "dcode": "D",
    "dropkey": "SY25967",
    "droptype": "D",
    "dropname": "NOKOMIS",
    "dropdeladd": "5139 34TH AVE S",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554179998,
    "dropphyadd": "5139 34TH AVE S",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554179998,
    "dropmaladd": "5139 34TH AVE S",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6127213105,
    "dropsitcph": 6123494743,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26122",
    "droptype": "D",
    "dropname": "POWDERHORN",
    "dropdeladd": "3045 BLOOMINGTON AVE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554079998,
    "dropphyadd": "3045 BLOOMINGTON AVE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554079998,
    "dropmaladd": "3045 BLOOMINGTON AVE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6127215428,
    "dropsitcph": 6127223973,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26169",
    "droptype": "D",
    "dropname": "RICE STREET",
    "dropdeladd": "40 ARLINGTON AVE E",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551179998,
    "dropphyadd": "40 ARLINGTON AVE E",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551179998,
    "dropmaladd": "40 ARLINGTON AVE E",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551179998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514896028,
    "dropsitcph": 6514889183,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26181",
    "droptype": "D",
    "dropname": "RIVERVIEW",
    "dropdeladd": "292 EVA ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551071605,
    "dropphyadd": "292 EVA ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551071605,
    "dropmaladd": "292 EVA ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551079998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933712,
    "dropsitcph": 6512224279,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26566",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "2811 UNIVERSITY AVE SE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554149998,
    "dropphyadd": "2811 UNIVERSITY AVE SE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554149998,
    "dropmaladd": "2811 UNIVERSITY AVE SE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554149998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123781853,
    "dropsitcph": 6123780625,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26568",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "408 SAINT PETER ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551021130,
    "dropphyadd": "408 SAINT PETER ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551021130,
    "dropmaladd": "408 SAINT PETER ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551021130,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512936035,
    "dropsitcph": 6512936032,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26655",
    "droptype": "D",
    "dropname": "WEST DULUTH",
    "dropdeladd": "215 N CENTRAL AVE BLDG 1",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558072473,
    "dropphyadd": "215 N CENTRAL AVE BLDG 1",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558072473,
    "dropmaladd": "215 N CENTRAL AVE BLDG 1",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558072473,
    "dropsitphn": 6123496399,
    "dropsitlph": 2187232536,
    "dropsitcph": 2186240253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY26854",
    "droptype": "D",
    "dropname": "PALMETTO LAKES",
    "dropdeladd": "5375 NW 159TH ST",
    "dropdelcty": "MIAMI LAKES",
    "dropdelst": "FL",
    "dropdelzpp": 330149998,
    "dropphyadd": "5375 NW 159TH ST",
    "dropphycty": "MIAMI LAKES",
    "dropphyst": "FL",
    "dropphyzpp": 330149998,
    "dropmaladd": "5375 NW 159TH ST",
    "dropmalcty": "MIAMI LAKES",
    "dropmalst": "FL",
    "dropmalzpp": 330149998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3056259533,
    "dropsitcph": 3056258851,
    "dropfax": 3056206813
  },
  {
    "dcode": "D",
    "dropkey": "SY26872",
    "droptype": "D",
    "dropname": "OVIEDO STATION",
    "dropdeladd": "83 GENEVA DR",
    "dropdelcty": "OVIEDO",
    "dropdelst": "FL",
    "dropdelzpp": 327659993,
    "dropphyadd": "83 GENEVA DR",
    "dropphycty": "OVIEDO",
    "dropphyst": "FL",
    "dropphyzpp": 327659993,
    "dropmaladd": "83 GENEVA DR",
    "dropmalcty": "OVIEDO",
    "dropmalst": "FL",
    "dropmalzpp": 327659993,
    "dropsitphn": 4073657119,
    "dropsitlph": 4073657119,
    "dropsitcph": 4073657119,
    "dropfax": 4073652905
  },
  {
    "dcode": "D",
    "dropkey": "SY26897",
    "droptype": "D",
    "dropname": "HIALEAH LAKES",
    "dropdeladd": "1500 W 84TH ST",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330189998,
    "dropphyadd": "1500 W 84TH ST",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330189998,
    "dropmaladd": "1500 W 84TH ST",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330189998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058271091,
    "dropsitcph": 3058270768,
    "dropfax": 3055571398
  },
  {
    "dcode": "D",
    "dropkey": "SY26939",
    "droptype": "D",
    "dropname": "MONUMENT",
    "dropdeladd": "10990 FORT CAROLINE RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322259998,
    "dropphyadd": "10990 FORT CAROLINE RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322259998,
    "dropmaladd": "10990 FORT CAROLINE RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322259998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9046419366,
    "dropsitcph": 9046419676,
    "dropfax": 9049987456
  },
  {
    "dcode": "D",
    "dropkey": "SY26940",
    "droptype": "D",
    "dropname": "MID CITY FINANCE",
    "dropdeladd": "501 MOSS ST",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701194928,
    "dropphyadd": "501 MOSS ST",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701194928,
    "dropmaladd": "501 MOSS ST",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701194928,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5044850545,
    "dropfax": 5044847954
  },
  {
    "dcode": "D",
    "dropkey": "SY26951",
    "droptype": "D",
    "dropname": "INDUSTRIAL",
    "dropdeladd": "6909 BASELINE RD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722099998,
    "dropphyadd": "6909 BASELINE RD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722099998,
    "dropmaladd": "6909 BASELINE RD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722099998,
    "dropsitphn": 5015651253,
    "dropsitlph": 5015651253,
    "dropsitcph": 5015651253,
    "dropfax": 5015656856
  },
  {
    "dcode": "D",
    "dropkey": "SY26954",
    "droptype": "D",
    "dropname": "CENTRAL CARRIER STATION",
    "dropdeladd": "1300 FLORIDA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701191961,
    "dropphyadd": "1300 FLORIDA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701191961,
    "dropmaladd": "1300 FLORIDA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701191961,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5049498259,
    "dropfax": 5049492719
  },
  {
    "dcode": "D",
    "dropkey": "SY26983",
    "droptype": "D",
    "dropname": "STATE CAPITOL",
    "dropdeladd": "500 WOODLANE ST STE 136",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722011008,
    "dropphyadd": "500 WOODLANE ST STE 136",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722011008,
    "dropmaladd": "500 WOODLANE ST STE 136",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722011008,
    "dropsitphn": 5013752644,
    "dropsitlph": 5012449256,
    "dropsitcph": 5013728998,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY27113",
    "droptype": "D",
    "dropname": "GALT OCEAN",
    "dropdeladd": "3324 NE 34TH ST",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333489998,
    "dropphyadd": "3324 NE 34TH ST",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333489998,
    "dropmaladd": "3324 NE 34TH ST",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333489998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545663150,
    "dropsitcph": 9545663150,
    "dropfax": 9545666053
  },
  {
    "dcode": "D",
    "dropkey": "SY27164",
    "droptype": "D",
    "dropname": "MIDLAND FORT SMITH",
    "dropdeladd": "3100 WIRSING AVE",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729049998,
    "dropphyadd": "3100 WIRSING AVE",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729049998,
    "dropmaladd": "3100 WIRSING AVE",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729049998,
    "dropsitphn": 4797821635,
    "dropsitlph": 4797821635,
    "dropsitcph": 4797821635,
    "dropfax": 4797829784
  },
  {
    "dcode": "D",
    "dropkey": "SY27166",
    "droptype": "D",
    "dropname": "FIANNA HILLS",
    "dropdeladd": "2712 MARKET TRCE",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729089998,
    "dropphyadd": "2712 MARKET TRCE",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729089998,
    "dropmaladd": "2712 MARKET TRCE",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729089998,
    "dropsitphn": 4796489345,
    "dropsitlph": 4796489345,
    "dropsitcph": 4796489345,
    "dropfax": 4796483823
  },
  {
    "dcode": "D",
    "dropkey": "SY27167",
    "droptype": "D",
    "dropname": "PROMENADE",
    "dropdeladd": "3690 W 18TH AVE",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330129998,
    "dropphyadd": "3690 W 18TH AVE",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330129998,
    "dropmaladd": "3690 W 18TH AVE",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330129998,
    "dropsitphn": 3055132368,
    "dropsitlph": 3058199945,
    "dropsitcph": 3058199860,
    "dropfax": 3058252503
  },
  {
    "dcode": "D",
    "dropkey": "SY27181",
    "droptype": "D",
    "dropname": "MAIN OFFICE TEXARKANA",
    "dropdeladd": "2211 N ROBISON RD",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "TX",
    "dropdelzpp": 755019994,
    "dropphyadd": "2211 N ROBISON RD",
    "dropphycty": "TEXARKANA",
    "dropphyst": "TX",
    "dropphyzpp": 755019994,
    "dropmaladd": "2211 N ROBISON RD",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "TX",
    "dropmalzpp": 755019994,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032233819,
    "dropsitcph": 9038389537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY27282",
    "droptype": "D",
    "dropname": "CARAWAY JONESBORO",
    "dropdeladd": "2404 RACE ST",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019997,
    "dropphyadd": "2404 RACE ST",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019997,
    "dropmaladd": "2404 RACE ST",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019997,
    "dropsitphn": 8709720275,
    "dropsitlph": 8709720275,
    "dropsitcph": 8709321261,
    "dropfax": 8709328012
  },
  {
    "dcode": "D",
    "dropkey": "SY27283",
    "droptype": "D",
    "dropname": "GEE STREET",
    "dropdeladd": "310 EAST ST STE A",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019405,
    "dropphyadd": "310 EAST ST STE A",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019405,
    "dropmaladd": "310 EAST ST STE A",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019405,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709725991,
    "dropsitcph": 8709725991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY27284",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "2400 E HIGHLAND DR",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724016233,
    "dropphyadd": "2400 E HIGHLAND DR",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724016233,
    "dropmaladd": "2400 E HIGHLAND DR",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724016233,
    "dropsitphn": 5019456732,
    "dropsitlph": 8709729389,
    "dropsitcph": 8709729389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY27286",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "3501 BESSIE COLEMAN BLVD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336305008,
    "dropphyadd": "3501 BESSIE COLEMAN BLVD",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336305008,
    "dropmaladd": "PO BOX 39841",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336309841,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138770374,
    "dropfax": 8138760893
  },
  {
    "dcode": "D",
    "dropkey": "SY27324",
    "droptype": "D",
    "dropname": "EL MERCADO",
    "dropdeladd": "2440 W 60TH ST",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330169997,
    "dropphyadd": "2440 W 60TH ST",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330169997,
    "dropmaladd": "2440 W 60TH ST",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330169997,
    "dropsitphn": 3054700642,
    "dropsitlph": 3058229954,
    "dropsitcph": 3055581701,
    "dropfax": 3058278419
  },
  {
    "dcode": "D",
    "dropkey": "SY27340",
    "droptype": "D",
    "dropname": "PALMETTO PARK",
    "dropdeladd": "1279 W PALMETTO PARK RD",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334869998,
    "dropphyadd": "1279 W PALMETTO PARK RD",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334869998,
    "dropmaladd": "1279 W PALMETTO PARK RD",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334869998,
    "dropsitphn": 5613683660,
    "dropsitlph": 5613683660,
    "dropsitcph": 5617500828,
    "dropfax": 5613681193
  },
  {
    "dcode": "D",
    "dropkey": "SY27343",
    "droptype": "D",
    "dropname": "GULFWINDS",
    "dropdeladd": "4222 22ND AVE S",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337119998,
    "dropphyadd": "4222 22ND AVE S",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337119998,
    "dropmaladd": "4222 22ND AVE S",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337119998,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273278469,
    "dropfax": 7273281890
  },
  {
    "dcode": "D",
    "dropkey": "SY27349",
    "droptype": "D",
    "dropname": "BERTRAND",
    "dropdeladd": "1830 BERTRAND DR",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "LA",
    "dropdelzpp": 705069998,
    "dropphyadd": "1830 BERTRAND DR",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "LA",
    "dropphyzpp": 705069998,
    "dropmaladd": "1830 BERTRAND DR",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "LA",
    "dropmalzpp": 705069998,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3372336890,
    "dropfax": 3372332325
  },
  {
    "dcode": "D",
    "dropkey": "SY27353",
    "droptype": "D",
    "dropname": "CAUSEWAY",
    "dropdeladd": "1515 SE 17TH ST STE 121",
    "dropdelcty": "FORT LAUDERDALE",
    "dropdelst": "FL",
    "dropdelzpp": 333161724,
    "dropphyadd": "1515 SE 17TH ST STE 121",
    "dropphycty": "FORT LAUDERDALE",
    "dropphyst": "FL",
    "dropphyzpp": 333161724,
    "dropmaladd": "1515 SE 17TH ST STE 121",
    "dropmalcty": "FORT LAUDERDALE",
    "dropmalst": "FL",
    "dropmalzpp": 333161724,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545254356,
    "dropsitcph": 9545252031,
    "dropfax": 9547618182
  },
  {
    "dcode": "D",
    "dropkey": "SY27407",
    "droptype": "D",
    "dropname": "SAWGRASS",
    "dropdeladd": "12801 W SUNRISE BLVD STE 967",
    "dropdelcty": "SUNRISE",
    "dropdelst": "FL",
    "dropdelzpp": 333239997,
    "dropphyadd": "12801 W SUNRISE BLVD STE 967",
    "dropphycty": "SUNRISE",
    "dropphyst": "FL",
    "dropphyzpp": 333239997,
    "dropmaladd": "12801 W SUNRISE BLVD STE 967",
    "dropmalcty": "SUNRISE",
    "dropmalst": "FL",
    "dropmalzpp": 333239997,
    "dropsitphn": 3055132368,
    "dropsitlph": 9548450672,
    "dropsitcph": 9548450672,
    "dropfax": 9548459793
  },
  {
    "dcode": "D",
    "dropkey": "SY27471",
    "droptype": "D",
    "dropname": "WESTLAND",
    "dropdeladd": "7055 BLANDING BLVD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322444408,
    "dropphyadd": "7055 BLANDING BLVD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322444408,
    "dropmaladd": "7055 BLANDING BLVD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322444408,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048000500,
    "dropsitcph": 9047713086,
    "dropfax": 9047789958
  },
  {
    "dcode": "D",
    "dropkey": "SY27503",
    "droptype": "D",
    "dropname": "NORTHSIDE",
    "dropdeladd": "1201 GANDY BLVD N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337022404,
    "dropphyadd": "1201 GANDY BLVD N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337022404,
    "dropmaladd": "1201 GANDY BLVD N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337022404,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7275772827,
    "dropfax": 7275778905
  },
  {
    "dcode": "D",
    "dropkey": "SY27512",
    "droptype": "D",
    "dropname": "NORTH RUSSELLVILLE",
    "dropdeladd": "414 N ELMIRA AVE",
    "dropdelcty": "RUSSELLVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 728029998,
    "dropphyadd": "414 N ELMIRA AVE",
    "dropphycty": "RUSSELLVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 728029998,
    "dropmaladd": "414 N ELMIRA AVE",
    "dropmalcty": "RUSSELLVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 728029998,
    "dropsitphn": 4798707289,
    "dropsitlph": 4798906261,
    "dropsitcph": 4798906261,
    "dropfax": 4799670402
  },
  {
    "dcode": "D",
    "dropkey": "SY27829",
    "droptype": "D",
    "dropname": "TITUSVILLE",
    "dropdeladd": "1538 HARRISON ST",
    "dropdelcty": "TITUSVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 327803453,
    "dropphyadd": "1538 HARRISON ST",
    "dropphycty": "TITUSVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 327803453,
    "dropmaladd": "1538 HARRISON ST",
    "dropmalcty": "TITUSVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 327803453,
    "dropsitphn": 3212678144,
    "dropsitlph": 3212678144,
    "dropsitcph": 3212641875,
    "dropfax": 3212641672
  },
  {
    "dcode": "D",
    "dropkey": "SY27877",
    "droptype": "D",
    "dropname": "CHENAL",
    "dropdeladd": "815 TECHNOLOGY DR",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722239998,
    "dropphyadd": "815 TECHNOLOGY DR",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722239998,
    "dropmaladd": "815 TECHNOLOGY DR",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722239998,
    "dropsitphn": 5018216257,
    "dropsitlph": 5018216257,
    "dropsitcph": 5018216299,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY27881",
    "droptype": "D",
    "dropname": "PRAIRIE LAKE",
    "dropdeladd": "1140 E ALTAMONTE DR STE 1016",
    "dropdelcty": "ALTAMONTE SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 327019991,
    "dropphyadd": "1140 E ALTAMONTE DR STE 1016",
    "dropphycty": "ALTAMONTE SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 327019991,
    "dropmaladd": "1140 E ALTAMONTE DR STE 1016",
    "dropmalcty": "ALTAMONTE SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 327019991,
    "dropsitphn": 4072629365,
    "dropsitlph": 4078655494,
    "dropsitcph": 4072629365,
    "dropfax": 4073394264
  },
  {
    "dcode": "D",
    "dropkey": "SY28013",
    "droptype": "D",
    "dropname": "DELTONA PINES",
    "dropdeladd": "2048 HOWLAND BLVD",
    "dropdelcty": "DELTONA",
    "dropdelst": "FL",
    "dropdelzpp": 327383442,
    "dropphyadd": "2048 HOWLAND BLVD",
    "dropphycty": "DELTONA",
    "dropphyst": "FL",
    "dropphyzpp": 327383442,
    "dropmaladd": "2048 HOWLAND BLVD",
    "dropmalcty": "DELTONA",
    "dropmalst": "FL",
    "dropmalzpp": 327383442,
    "dropsitphn": 3867892095,
    "dropsitlph": 3867892095,
    "dropsitcph": 3867892095,
    "dropfax": 3865322628
  },
  {
    "dcode": "D",
    "dropkey": "SY28027",
    "droptype": "D",
    "dropname": "GMF BOX SECTION",
    "dropdeladd": "4700 E MCCAIN BLVD",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722319998,
    "dropphyadd": "4700 E MCCAIN BLVD",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722319922,
    "dropmaladd": "4700 E MCCAIN BLVD",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722319998,
    "dropsitphn": 5019556335,
    "dropsitlph": 5013556335,
    "dropsitcph": 5013556335,
    "dropfax": 5019456615
  },
  {
    "dcode": "D",
    "dropkey": "SY28036",
    "droptype": "D",
    "dropname": "NEW TAMPA",
    "dropdeladd": "16350 BRUCE B DOWNS BLVD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336479998,
    "dropphyadd": "16350 BRUCE B DOWNS BLVD",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336479998,
    "dropmaladd": "16350 BRUCE B DOWNS BLVD",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336479998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139107987,
    "dropfax": 8139107995
  },
  {
    "dcode": "D",
    "dropkey": "SY28051",
    "droptype": "D",
    "dropname": "GLENGARRY",
    "dropdeladd": "935 N BENEVA RD STE 801",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342329998,
    "dropphyadd": "935 N BENEVA RD STE 801",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342329998,
    "dropmaladd": "935 N BENEVA RD STE 801",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342329998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9419170323,
    "dropfax": 9413622758
  },
  {
    "dcode": "D",
    "dropkey": "SY28055",
    "droptype": "D",
    "dropname": "BRADY",
    "dropdeladd": "8509 W MARKHAM ST",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722052400,
    "dropphyadd": "8509 W MARKHAM ST",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722052400,
    "dropmaladd": "8509 W MARKHAM ST",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722052400,
    "dropsitphn": 5012239934,
    "dropsitlph": 5012192936,
    "dropsitcph": 5012192933,
    "dropfax": 5012199951
  },
  {
    "dcode": "D",
    "dropkey": "SY28057",
    "droptype": "D",
    "dropname": "WEST SAINT PAUL",
    "dropdeladd": "1201 ROBERT ST S STE 3",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551182314,
    "dropphyadd": "1201 ROBERT ST S STE 3",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551182314,
    "dropmaladd": "1201 ROBERT ST S STE 3",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551182314,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514509304,
    "dropsitcph": 6515522216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28058",
    "droptype": "D",
    "dropname": "SEEGER SQUARE",
    "dropdeladd": "886 ARCADE ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551063864,
    "dropphyadd": "886 ARCADE ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551063864,
    "dropmaladd": "886 ARCADE ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551063864,
    "dropsitphn": 6123496399,
    "dropsitlph": 6517936169,
    "dropsitcph": 6517712011,
    "dropfax": 6517716611
  },
  {
    "dcode": "D",
    "dropkey": "SY28059",
    "droptype": "D",
    "dropname": "CLIFF LAKE",
    "dropdeladd": "1964 RAHNCLIFF CT STE 200",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551223018,
    "dropphyadd": "1964 RAHNCLIFF CT STE 200",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551223018,
    "dropmaladd": "1964 RAHNCLIFF CT STE 200",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551223018,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514058509,
    "dropsitcph": 6514059581,
    "dropfax": 6122933000
  },
  {
    "dcode": "D",
    "dropkey": "SY28140",
    "droptype": "D",
    "dropname": "HOT SPRINGS PARK",
    "dropdeladd": "620 CENTRAL AVE STE 1A",
    "dropdelcty": "HOT SPRINGS NATIONAL PARK",
    "dropdelst": "AR",
    "dropdelzpp": 719015302,
    "dropphyadd": "620 CENTRAL AVE STE 1A",
    "dropphycty": "HOT SPRINGS NATIONAL PARK",
    "dropphyst": "AR",
    "dropphyzpp": 719015302,
    "dropmaladd": "620 CENTRAL AVE STE 1A",
    "dropmalcty": "HOT SPRINGS NATIONAL PARK",
    "dropmalst": "AR",
    "dropmalzpp": 719015302,
    "dropsitphn": 5016238738,
    "dropsitlph": 5016238217,
    "dropsitcph": 5016238217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28221",
    "droptype": "D",
    "dropname": "N O MAIN OFC WINDOW SVE",
    "dropdeladd": "701 LOYOLA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701139998,
    "dropphyadd": "701 LOYOLA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701139998,
    "dropmaladd": "701 LOYOLA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701139998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5045891419,
    "dropfax": 5045891190
  },
  {
    "dcode": "D",
    "dropkey": "SY28223",
    "droptype": "D",
    "dropname": "SHREVEPORT MAIN OFFICE",
    "dropdeladd": "2400 TEXAS AVE",
    "dropdelcty": "SHREVEPORT",
    "dropdelst": "LA",
    "dropdelzpp": 711029998,
    "dropphyadd": "2400 TEXAS AVE",
    "dropphycty": "SHREVEPORT",
    "dropphyst": "LA",
    "dropphyzpp": 711029803,
    "dropmaladd": "2400 TEXAS AVE",
    "dropmalcty": "SHREVEPORT",
    "dropmalst": "LA",
    "dropmalzpp": 711029803,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3186772369,
    "dropfax": 3186772323
  },
  {
    "dcode": "D",
    "dropkey": "SY28242",
    "droptype": "D",
    "dropname": "AMC FINANCE UNIT",
    "dropdeladd": "800 AIRLINE DR",
    "dropdelcty": "KENNER",
    "dropdelst": "LA",
    "dropdelzpp": 700626921,
    "dropphyadd": "800 AIRLINE DR",
    "dropphycty": "KENNER",
    "dropphyst": "LA",
    "dropphyzpp": 700626921,
    "dropmaladd": "800 AIRLINE DR",
    "dropmalcty": "KENNER",
    "dropmalst": "LA",
    "dropmalzpp": 700626921,
    "dropsitphn": 5045891027,
    "dropsitlph": 5045891268,
    "dropsitcph": 5044666397,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28252",
    "droptype": "D",
    "dropname": "NEWPORT DETACHED BOX UNIT",
    "dropdeladd": "2525 MALCOLM AVE",
    "dropdelcty": "NEWPORT",
    "dropdelst": "AR",
    "dropdelzpp": 721123675,
    "dropphyadd": "2525 MALCOLM AVE",
    "dropphycty": "NEWPORT",
    "dropphyst": "AR",
    "dropphyzpp": 721123675,
    "dropmaladd": "2525 MALCOLM AVE",
    "dropmalcty": "NEWPORT",
    "dropmalst": "AR",
    "dropmalzpp": 721123675,
    "dropsitphn": 8705128700,
    "dropsitlph": 8705232271,
    "dropsitcph": 8705232271,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28253",
    "droptype": "D",
    "dropname": "MINNEAPOLIS RETAIL",
    "dropdeladd": "100 S 1ST ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554011055,
    "dropphyadd": "100 S 1ST ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554011055,
    "dropmaladd": "100 S 1ST ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554011055,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496346,
    "dropsitcph": 6123494713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28254",
    "droptype": "D",
    "dropname": "SAINT PAUL RETAIL",
    "dropdeladd": "180 KELLOGG BLVD E",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551011406,
    "dropphyadd": "180 KELLOGG BLVD E",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551011406,
    "dropmaladd": "PO BOX 645014",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551645014,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933257,
    "dropsitcph": 6512936346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28351",
    "droptype": "D",
    "dropname": "MINNEAPOLIS PO BOX",
    "dropdeladd": "100 S 1ST ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554011054,
    "dropphyadd": "100 S 1ST ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554011054,
    "dropmaladd": "100 S 1ST ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554011054,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496346,
    "dropsitcph": 6123494943,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28352",
    "droptype": "D",
    "dropname": "SAINT PAUL PO BOX",
    "dropdeladd": "101 5TH ST E STE 150",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551011825,
    "dropphyadd": "101 5TH ST E STE 150",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551011825,
    "dropmaladd": "PO BOX 645014",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551645014,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933277,
    "dropsitcph": 6512936346,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SY28353",
    "droptype": "D",
    "dropname": "CENTER PLACE",
    "dropdeladd": "4170 W DIVISION ST STE 160",
    "dropdelcty": "SAINT CLOUD",
    "dropdelst": "MN",
    "dropdelzpp": 563019920,
    "dropphyadd": "4170 W DIVISION ST STE 160",
    "dropphycty": "SAINT CLOUD",
    "dropphyst": "MN",
    "dropphyzpp": 563019920,
    "dropmaladd": "4170 W DIVISION ST STE 160",
    "dropmalcty": "SAINT CLOUD",
    "dropmalst": "MN",
    "dropmalzpp": 563019920,
    "dropsitphn": "",
    "dropsitlph": 3205298204,
    "dropsitcph": 3205298204,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ10083",
    "droptype": "D",
    "dropname": "FAIRBANKS DOWNTOWN STA",
    "dropdeladd": "315 BARNETTE ST",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "AK",
    "dropdelzpp": 997014532,
    "dropphyadd": "315 BARNETTE ST",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "AK",
    "dropphyzpp": 997014532,
    "dropmaladd": "PO BOX 79998",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "AK",
    "dropmalzpp": 997079998,
    "dropsitphn": 9074523237,
    "dropsitlph": 9074523237,
    "dropsitcph": 9074523223,
    "dropfax": 9074523243
  },
  {
    "dcode": "D",
    "dropkey": "SZ10090",
    "droptype": "D",
    "dropname": "EASTCHESTER",
    "dropdeladd": "800 INGRA ST",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995019998,
    "dropphyadd": "800 INGRA ST",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995019998,
    "dropmaladd": "PO BOX 209998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995209998,
    "dropsitphn": 9072779241,
    "dropsitlph": 9072779241,
    "dropsitcph": 9072728266,
    "dropfax": 9072722516
  },
  {
    "dcode": "D",
    "dropkey": "SZ10110",
    "droptype": "D",
    "dropname": "FEDERAL STATION",
    "dropdeladd": "709 W 9TH ST",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998011807,
    "dropphyadd": "709 W 9TH ST",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998011807,
    "dropmaladd": "PO BOX 29998",
    "dropmalcty": "JUNEAU",
    "dropmalst": "AK",
    "dropmalzpp": 998029998,
    "dropsitphn": 9075867987,
    "dropsitlph": 9075867987,
    "dropsitcph": 9075867987,
    "dropfax": 9075864112
  },
  {
    "dcode": "D",
    "dropkey": "SZ10141",
    "droptype": "D",
    "dropname": "HUFFMAN",
    "dropdeladd": "1221 HUFFMAN PARK DR",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995159998,
    "dropphyadd": "1221 HUFFMAN PARK DR",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995159998,
    "dropmaladd": "PO BOX 119998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995119998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072663161,
    "dropsitcph": 9073480491,
    "dropfax": 9073480482
  },
  {
    "dcode": "D",
    "dropkey": "SZ10183",
    "droptype": "D",
    "dropname": "LAKE OTIS",
    "dropdeladd": "5855 LAKE OTIS PKWY",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995071713,
    "dropphyadd": "5855 LAKE OTIS PKWY",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995071713,
    "dropmaladd": "PO BOX 239998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995239998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9075639578,
    "dropsitcph": 9075639643,
    "dropfax": 9075630114
  },
  {
    "dcode": "D",
    "dropkey": "SZ10188",
    "droptype": "D",
    "dropname": "ANCHORAGE MAIN OFFICE",
    "dropdeladd": "4141 POSTMARK DR",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995309998,
    "dropphyadd": "4141 POSTMARK DR",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995309998,
    "dropmaladd": "PO BOX 199998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995199998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072663391,
    "dropsitcph": 9072663266,
    "dropfax": 9072663253
  },
  {
    "dcode": "D",
    "dropkey": "SZ10189",
    "droptype": "D",
    "dropname": "FAIRBANKS MAIN OFFICE",
    "dropdeladd": "5400 MAIL TRAIL RD",
    "dropdelcty": "FAIRBANKS",
    "dropdelst": "AK",
    "dropdelzpp": 997099998,
    "dropphyadd": "5400 MAIL TRAIL RD",
    "dropphycty": "FAIRBANKS",
    "dropphyst": "AK",
    "dropphyzpp": 997099998,
    "dropmaladd": "PO BOX 69998",
    "dropmalcty": "FAIRBANKS",
    "dropmalst": "AK",
    "dropmalzpp": 997069998,
    "dropsitphn": 9074555452,
    "dropsitlph": 9074555452,
    "dropsitcph": 9074555444,
    "dropfax": 9074555480
  },
  {
    "dcode": "D",
    "dropkey": "SZ10198",
    "droptype": "D",
    "dropname": "MENDENHALL",
    "dropdeladd": "9491 VINTAGE BLVD",
    "dropdelcty": "JUNEAU",
    "dropdelst": "AK",
    "dropdelzpp": 998017111,
    "dropphyadd": "9491 VINTAGE BLVD",
    "dropphycty": "JUNEAU",
    "dropphyst": "AK",
    "dropphyzpp": 998017111,
    "dropmaladd": "PO BOX 39998",
    "dropmalcty": "JUNEAU",
    "dropmalst": "AK",
    "dropmalzpp": 998039998,
    "dropsitphn": 9075867982,
    "dropsitlph": 9077890934,
    "dropsitcph": 9077890934,
    "dropfax": 9077893484
  },
  {
    "dcode": "D",
    "dropkey": "SZ10202",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "3721 B ST",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995039998,
    "dropphyadd": "3721 B ST",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995039998,
    "dropmaladd": "PO BOX 249998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995249998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072735877,
    "dropsitcph": 9072735877,
    "dropfax": 9072735860
  },
  {
    "dcode": "D",
    "dropkey": "SZ10208",
    "droptype": "D",
    "dropname": "MULDOON",
    "dropdeladd": "2420 MULDOON RD",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995043673,
    "dropphyadd": "2420 MULDOON RD",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995043673,
    "dropmaladd": "PO BOX 219998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995219998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9073335446,
    "dropsitcph": 9073330053,
    "dropfax": 9073333291
  },
  {
    "dcode": "D",
    "dropkey": "SZ10264",
    "droptype": "D",
    "dropname": "RUSSIAN JACK",
    "dropdeladd": "801 NORTHWAY DR",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995089998,
    "dropphyadd": "801 NORTHWAY DR",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995089998,
    "dropmaladd": "PO BOX 149998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995149998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072777986,
    "dropsitcph": 9072721356,
    "dropfax": 9072721496
  },
  {
    "dcode": "D",
    "dropkey": "SZ10274",
    "droptype": "D",
    "dropname": "SAND LAKE",
    "dropdeladd": "2200 STRAWBERRY RD",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995029992,
    "dropphyadd": "2200 STRAWBERRY RD",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995029992,
    "dropmaladd": "PO BOX 229998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995229998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9073497576,
    "dropsitcph": 9073492551,
    "dropfax": 9073445109
  },
  {
    "dcode": "D",
    "dropkey": "SZ10296",
    "droptype": "D",
    "dropname": "SPENARD",
    "dropdeladd": "1601 W NORTHERN LIGHTS BLVD",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995173315,
    "dropphyadd": "1601 W NORTHERN LIGHTS BLVD",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995173315,
    "dropmaladd": "PO BOX 99998",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995099998,
    "dropsitphn": 9072663265,
    "dropsitlph": 9072586731,
    "dropsitcph": 9072586733,
    "dropfax": 9072586752
  },
  {
    "dcode": "D",
    "dropkey": "SZ10363",
    "droptype": "D",
    "dropname": "AHWATUKEE",
    "dropdeladd": "11010 S 51ST ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850449998,
    "dropphyadd": "11010 S 51ST ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850449998,
    "dropmaladd": "11010 S 51ST ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850449998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4804960736,
    "dropsitcph": 4808931748,
    "dropfax": 4805982834
  },
  {
    "dcode": "D",
    "dropkey": "SZ10364",
    "droptype": "D",
    "dropname": "SCOTTSDALE AIRPARK",
    "dropdeladd": "8175 E EVANS RD",
    "dropdelcty": "SCOTTSDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 852609998,
    "dropphyadd": "8175 E EVANS RD",
    "dropphycty": "SCOTTSDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 852609998,
    "dropmaladd": "8175 E EVANS RD",
    "dropmalcty": "SCOTTSDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 852609998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4805734298,
    "dropsitcph": 4804831229,
    "dropfax": 4803689047
  },
  {
    "dcode": "D",
    "dropkey": "SZ10370",
    "droptype": "D",
    "dropname": "ARCADIA",
    "dropdeladd": "3920 E THOMAS RD",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850189998,
    "dropphyadd": "3920 E THOMAS RD",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850189998,
    "dropmaladd": "3920 E THOMAS RD",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850189998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6029572830,
    "dropsitcph": 6029572693,
    "dropfax": 6029129771
  },
  {
    "dcode": "D",
    "dropkey": "SZ10382",
    "droptype": "D",
    "dropname": "ARROWHEAD",
    "dropdeladd": "19801 N 59TH AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 853089998,
    "dropphyadd": "19801 N 59TH AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 853089998,
    "dropmaladd": "19801 N 59TH AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 853089998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6235720294,
    "dropsitcph": 6232823435,
    "dropfax": 6235728601
  },
  {
    "dcode": "D",
    "dropkey": "SZ10411",
    "droptype": "D",
    "dropname": "CACTUS",
    "dropdeladd": "2901 E GREENWAY RD",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850329998,
    "dropphyadd": "2901 E GREENWAY RD",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850329998,
    "dropmaladd": "2901 E GREENWAY RD",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850329998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6024043225,
    "dropsitcph": 6028673359,
    "dropfax": 6024043989
  },
  {
    "dcode": "D",
    "dropkey": "SZ10419",
    "droptype": "D",
    "dropname": "CAPITOL",
    "dropdeladd": "2 S 35TH AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850099998,
    "dropphyadd": "2 S 35TH AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850099998,
    "dropmaladd": "2 S 35TH AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850099998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6024847068,
    "dropsitcph": 6024840719,
    "dropfax": 6024840059
  },
  {
    "dcode": "D",
    "dropkey": "SZ10437",
    "droptype": "D",
    "dropname": "ANDERSEN SPRINGS",
    "dropdeladd": "1900 W CARLA VISTA DR",
    "dropdelcty": "CHANDLER",
    "dropdelst": "AZ",
    "dropdelzpp": 852249998,
    "dropphyadd": "1900 W CARLA VISTA DR",
    "dropphycty": "CHANDLER",
    "dropphyst": "AZ",
    "dropphyzpp": 852249998,
    "dropmaladd": "1900 W CARLA VISTA DR",
    "dropmalcty": "CHANDLER",
    "dropmalst": "AZ",
    "dropmalzpp": 852249998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809170199,
    "dropsitcph": 4808993760,
    "dropfax": 4807863279
  },
  {
    "dcode": "D",
    "dropkey": "SZ10464",
    "droptype": "D",
    "dropname": "COPPER QUEEN",
    "dropdeladd": "6 MAIN ST",
    "dropdelcty": "BISBEE",
    "dropdelst": "AZ",
    "dropdelzpp": 856039901,
    "dropphyadd": "6 MAIN ST",
    "dropphycty": "BISBEE",
    "dropphyst": "AZ",
    "dropphyzpp": 856039901,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "BISBEE",
    "dropmalst": "AZ",
    "dropmalzpp": 856039997,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203885019,
    "dropsitcph": 5204322052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ10470",
    "droptype": "D",
    "dropname": "CORONADO",
    "dropdeladd": "255 N ROSEMONT BLVD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857119998,
    "dropphyadd": "255 N ROSEMONT BLVD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857119998,
    "dropmaladd": "255 N ROSEMONT BLVD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857119998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5205717245,
    "dropsitcph": 5205717160,
    "dropfax": 5207909802
  },
  {
    "dcode": "D",
    "dropkey": "SZ10478",
    "droptype": "D",
    "dropname": "DAVIS MONTHAN AFB",
    "dropdeladd": "5450 E MADERA ST",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857089897,
    "dropphyadd": "5450 E MADERA ST",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857089897,
    "dropmaladd": "5450 E MADERA ST",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857089897,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207900180,
    "dropsitcph": 5207900180,
    "dropfax": 5207900659
  },
  {
    "dcode": "D",
    "dropkey": "SZ10484",
    "droptype": "D",
    "dropname": "MESA DESERT",
    "dropdeladd": "6644 E BROADWAY RD",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852069998,
    "dropphyadd": "6644 E BROADWAY RD",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852069998,
    "dropmaladd": "6644 E BROADWAY RD",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852069998,
    "dropsitphn": 4806410427,
    "dropsitlph": 4806410427,
    "dropsitcph": 4806411166,
    "dropfax": 4806412288
  },
  {
    "dcode": "D",
    "dropkey": "SZ10485",
    "droptype": "D",
    "dropname": "DESERT FOOTHILLS",
    "dropdeladd": "1700 E RIVER RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857189998,
    "dropphyadd": "1700 E RIVER RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857189998,
    "dropmaladd": "1700 E RIVER RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857189998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206159032,
    "dropsitcph": 5205778929,
    "dropfax": 5205297099
  },
  {
    "dcode": "D",
    "dropkey": "SZ10492",
    "droptype": "D",
    "dropname": "MESA DOBSON",
    "dropdeladd": "2415 W BROADWAY RD",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852029998,
    "dropphyadd": "2415 W BROADWAY RD",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852029998,
    "dropmaladd": "2415 W BROADWAY RD",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852029998,
    "dropsitphn": 4808949389,
    "dropsitlph": 4808949389,
    "dropsitcph": 4808949468,
    "dropfax": 4808580434
  },
  {
    "dcode": "D",
    "dropkey": "SZ10497",
    "droptype": "D",
    "dropname": "DOWNTOWN FLAGSTAFF",
    "dropdeladd": "104 N WC RILES ST",
    "dropdelcty": "FLAGSTAFF",
    "dropdelst": "AZ",
    "dropdelzpp": 860019998,
    "dropphyadd": "104 N WC RILES ST",
    "dropphycty": "FLAGSTAFF",
    "dropphyst": "AZ",
    "dropphyzpp": 860019998,
    "dropmaladd": "104 N WC RILES ST",
    "dropmalcty": "FLAGSTAFF",
    "dropmalst": "AZ",
    "dropmalzpp": 860019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287792138,
    "dropsitcph": 9287792371,
    "dropfax": 9287739480
  },
  {
    "dcode": "D",
    "dropkey": "SZ10499",
    "droptype": "D",
    "dropname": "DOWNTOWN PHOENIX",
    "dropdeladd": "522 N CENTRAL AVE LBBY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850049998,
    "dropphyadd": "522 N CENTRAL AVE LBBY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850049998,
    "dropmaladd": "522 N CENTRAL AVE LBBY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850049998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022535045,
    "dropsitcph": 6022539648,
    "dropfax": 6022537920
  },
  {
    "dcode": "D",
    "dropkey": "SZ10501",
    "droptype": "D",
    "dropname": "DOWNTOWN TUCSON",
    "dropdeladd": "141 S 6TH AVE",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857019998,
    "dropphyadd": "141 S 6TH AVE",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857019998,
    "dropmaladd": "141 S 6TH AVE",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857019998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203889165,
    "dropsitcph": 5209031958,
    "dropfax": 5206249566
  },
  {
    "dcode": "D",
    "dropkey": "SZ10517",
    "droptype": "D",
    "dropname": "MESA FALCON FIELD",
    "dropdeladd": "5155 E EAGLE DR",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852159998,
    "dropphyadd": "5155 E EAGLE DR",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852159998,
    "dropmaladd": "5155 E EAGLE DR",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852159998,
    "dropsitphn": 4808543679,
    "dropsitlph": 4808543679,
    "dropsitcph": 4808324197,
    "dropfax": 4808543616
  },
  {
    "dcode": "D",
    "dropkey": "SZ10531",
    "droptype": "D",
    "dropname": "FORT LOWELL",
    "dropdeladd": "6460 E GRANT RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857159998,
    "dropphyadd": "6460 E GRANT RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857159998,
    "dropmaladd": "6460 E GRANT RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857159998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5202909723,
    "dropsitcph": 5202909718,
    "dropfax": 5207223307
  },
  {
    "dcode": "D",
    "dropkey": "SZ10557",
    "droptype": "D",
    "dropname": "PRESCOTT GOODWIN",
    "dropdeladd": "101 W GOODWIN ST STE 103",
    "dropdelcty": "PRESCOTT",
    "dropdelst": "AZ",
    "dropdelzpp": 863039998,
    "dropphyadd": "101 W GOODWIN ST STE 103",
    "dropphycty": "PRESCOTT",
    "dropphyst": "AZ",
    "dropphyzpp": 863039998,
    "dropmaladd": "101 W GOODWIN ST STE 103",
    "dropmalcty": "PRESCOTT",
    "dropmalst": "AZ",
    "dropmalzpp": 863039998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287787411,
    "dropsitcph": 9287781890,
    "dropfax": 9287781738
  },
  {
    "dcode": "D",
    "dropkey": "SZ10595",
    "droptype": "D",
    "dropname": "SCOTTSDALE HOPI",
    "dropdeladd": "8790 E VIA DE VENTURA",
    "dropdelcty": "SCOTTSDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 852589998,
    "dropphyadd": "8790 E VIA DE VENTURA",
    "dropphycty": "SCOTTSDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 852589998,
    "dropmaladd": "8790 E VIA DE VENTURA",
    "dropmalcty": "SCOTTSDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 852589998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4802128093,
    "dropsitcph": 4809989356,
    "dropfax": 4803689093
  },
  {
    "dcode": "D",
    "dropkey": "SZ10629",
    "droptype": "D",
    "dropname": "KINO RETAIL UNIT",
    "dropdeladd": "3655 N ORACLE RD STE 101",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857053210,
    "dropphyadd": "3655 N ORACLE RD STE 101",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857053210,
    "dropmaladd": "3655 N ORACLE RD STE 101",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857053210,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207920924,
    "dropsitcph": 5208870306,
    "dropfax": 5206249731
  },
  {
    "dcode": "D",
    "dropkey": "SZ10663",
    "droptype": "D",
    "dropname": "YUMA MARINE CORPS AIR STATN",
    "dropdeladd": "2637 E QUILTER ST",
    "dropdelcty": "YUMA",
    "dropdelst": "AZ",
    "dropdelzpp": 853656566,
    "dropphyadd": "2637 E QUILTER ST",
    "dropphycty": "YUMA",
    "dropphyst": "AZ",
    "dropphyzpp": 853656566,
    "dropmaladd": "2637 E QUILTER ST",
    "dropmalcty": "YUMA",
    "dropmalst": "AZ",
    "dropmalzpp": 853656566,
    "dropsitphn": 6022253214,
    "dropsitlph": 9283440437,
    "dropsitcph": 9283439416,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ10665",
    "droptype": "D",
    "dropname": "MARYVALE",
    "dropdeladd": "4415 N MARYVALE PKWY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850319998,
    "dropphyadd": "4415 N MARYVALE PKWY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850319998,
    "dropmaladd": "4415 N MARYVALE PKWY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850319998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6238482820,
    "dropsitcph": 6238482821,
    "dropfax": 6232479023
  },
  {
    "dcode": "D",
    "dropkey": "SZ10683",
    "droptype": "D",
    "dropname": "MISSION",
    "dropdeladd": "315 W VALENCIA RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857069998,
    "dropphyadd": "315 W VALENCIA RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857069998,
    "dropmaladd": "315 W VALENCIA RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857069998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208898867,
    "dropsitcph": 5208898647,
    "dropfax": 5207411135
  },
  {
    "dcode": "D",
    "dropkey": "SZ10693",
    "droptype": "D",
    "dropname": "MESA MOUNTAIN VIEW",
    "dropdeladd": "2747 E UNIVERSITY DR",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852139998,
    "dropphyadd": "2747 E UNIVERSITY DR",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852139998,
    "dropmaladd": "2747 E UNIVERSITY DR",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852139998,
    "dropsitphn": 4808441734,
    "dropsitlph": 4808441734,
    "dropsitcph": 4808441513,
    "dropfax": 4806493301
  },
  {
    "dcode": "D",
    "dropkey": "SZ10712",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "5021 N 20TH ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850169998,
    "dropphyadd": "5021 N 20TH ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850169998,
    "dropmaladd": "5021 N 20TH ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850169998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6029578180,
    "dropsitcph": 6029576412,
    "dropfax": 6029559379
  },
  {
    "dcode": "D",
    "dropkey": "SZ10713",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "4828 N 27TH AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850173679,
    "dropphyadd": "4828 N 27TH AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850173679,
    "dropmaladd": "4828 N 27TH AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850173679,
    "dropsitphn": 6022253214,
    "dropsitlph": 6028410766,
    "dropsitcph": 6022496411,
    "dropfax": 6022425197
  },
  {
    "dcode": "D",
    "dropkey": "SZ10723",
    "droptype": "D",
    "dropname": "OSBORN",
    "dropdeladd": "3905 N 7TH AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850139998,
    "dropphyadd": "3905 N 7TH AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850139998,
    "dropmaladd": "3905 N 7TH AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850139998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022359645,
    "dropsitcph": 6022359189,
    "dropfax": 6022359319
  },
  {
    "dcode": "D",
    "dropkey": "SZ10786",
    "droptype": "D",
    "dropname": "RINCON",
    "dropdeladd": "1099 S PANTANO RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857109998,
    "dropphyadd": "1099 S PANTANO RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857109998,
    "dropmaladd": "1099 S PANTANO RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857109998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5202962816,
    "dropsitcph": 5202961279,
    "dropfax": 5207229286
  },
  {
    "dcode": "D",
    "dropkey": "SZ10789",
    "droptype": "D",
    "dropname": "RIO SALADO",
    "dropdeladd": "1441 E BUCKEYE RD LBBY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850349998,
    "dropphyadd": "1441 E BUCKEYE RD LBBY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850349998,
    "dropmaladd": "1441 E BUCKEYE RD LBBY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850349998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022233242,
    "dropsitcph": 6022233232,
    "dropfax": 6022233595
  },
  {
    "dcode": "D",
    "dropkey": "SZ10826",
    "droptype": "D",
    "dropname": "SHAW BUTTE",
    "dropdeladd": "12208 N 19TH AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850299998,
    "dropphyadd": "12208 N 19TH AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850299998,
    "dropmaladd": "12208 N 19TH AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850299998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6023311656,
    "dropsitcph": 6023314284,
    "dropfax": 6029443268
  },
  {
    "dcode": "D",
    "dropkey": "SZ10827",
    "droptype": "D",
    "dropname": "MESA SHERWOOD",
    "dropdeladd": "325 S LINDSAY RD",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852049998,
    "dropphyadd": "325 S LINDSAY RD",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852049998,
    "dropmaladd": "325 S LINDSAY RD",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852049998,
    "dropsitphn": 4808441734,
    "dropsitlph": 4808441734,
    "dropsitcph": 4808441513,
    "dropfax": 4803969836
  },
  {
    "dcode": "D",
    "dropkey": "SZ10836",
    "droptype": "D",
    "dropname": "SIERRA ADOBE",
    "dropdeladd": "1902 W UNION HILLS DR",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850279998,
    "dropphyadd": "1902 W UNION HILLS DR",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850279998,
    "dropmaladd": "1902 W UNION HILLS DR",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850279998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6235161393,
    "dropsitcph": 6234343580,
    "dropfax": 6235161492
  },
  {
    "dcode": "D",
    "dropkey": "SZ10840",
    "droptype": "D",
    "dropname": "SILVERBELL",
    "dropdeladd": "975 N SILVERBELL RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857459998,
    "dropphyadd": "975 N SILVERBELL RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857459998,
    "dropmaladd": "975 N SILVERBELL RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857459998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5203886468,
    "dropsitcph": 5203889323,
    "dropfax": 5208841547
  },
  {
    "dcode": "D",
    "dropkey": "SZ10849",
    "droptype": "D",
    "dropname": "SOUTH MOUNTAIN",
    "dropdeladd": "6825 S 7TH ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850429998,
    "dropphyadd": "6825 S 7TH ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850429998,
    "dropmaladd": "6825 S 7TH ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850429998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022439131,
    "dropsitcph": 6022439131,
    "dropfax": 6023049554
  },
  {
    "dcode": "D",
    "dropkey": "SZ10901",
    "droptype": "D",
    "dropname": "SUN",
    "dropdeladd": "2100 E SPEEDWAY BLVD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857199998,
    "dropphyadd": "2100 E SPEEDWAY BLVD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857199998,
    "dropmaladd": "2100 E SPEEDWAY BLVD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857199998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208811276,
    "dropsitcph": 5208811175,
    "dropfax": 5203254918
  },
  {
    "dcode": "D",
    "dropkey": "SZ10907",
    "droptype": "D",
    "dropname": "SUNNYSLOPE",
    "dropdeladd": "9635 N 7TH ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850209998,
    "dropphyadd": "9635 N 7TH ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850209998,
    "dropmaladd": "9635 N 7TH ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850209998,
    "dropsitphn": 6029449317,
    "dropsitlph": 6029449317,
    "dropsitcph": 6023950579,
    "dropfax": 6023711469
  },
  {
    "dcode": "D",
    "dropkey": "SZ10967",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "8155 N BLACK CANYON HWY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850219998,
    "dropphyadd": "8155 N BLACK CANYON HWY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850219998,
    "dropmaladd": "8155 N BLACK CANYON HWY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850219998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6029954489,
    "dropsitcph": 6029954292,
    "dropfax": 6029955387
  },
  {
    "dcode": "D",
    "dropkey": "SZ11015",
    "droptype": "D",
    "dropname": "ALCOTT",
    "dropdeladd": "3700 TENNYSON ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802129998,
    "dropphyadd": "3700 TENNYSON ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802129998,
    "dropmaladd": "3700 TENNYSON ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802129998,
    "dropsitphn": 3034557170,
    "dropsitlph": 3034557170,
    "dropsitcph": 3034336477,
    "dropfax": 3034580233
  },
  {
    "dcode": "D",
    "dropkey": "SZ11022",
    "droptype": "D",
    "dropname": "ALTURA",
    "dropdeladd": "15355 E COLFAX AVE UNIT A",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800119998,
    "dropphyadd": "15355 E COLFAX AVE UNIT A",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800119998,
    "dropmaladd": "15355 E COLFAX AVE UNIT A",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800119998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033661058,
    "dropsitcph": 3033661058,
    "dropfax": 3033679244
  },
  {
    "dcode": "D",
    "dropkey": "SZ11026",
    "droptype": "D",
    "dropname": "ANTARES",
    "dropdeladd": "2641 E UINTAH ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809099998,
    "dropphyadd": "2641 E UINTAH ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809099998,
    "dropmaladd": "2641 E UINTAH ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809099998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196355712,
    "dropsitcph": 7196355712,
    "dropfax": 7194730388
  },
  {
    "dcode": "D",
    "dropkey": "SZ11073",
    "droptype": "D",
    "dropname": "BEAR VALLEY",
    "dropdeladd": "7555 W AMHERST AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802279998,
    "dropphyadd": "7555 W AMHERST AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802279998,
    "dropmaladd": "7555 W AMHERST AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802279998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3039804750,
    "dropsitcph": 3039804740,
    "dropfax": 3039880760
  },
  {
    "dcode": "D",
    "dropkey": "SZ11079",
    "droptype": "D",
    "dropname": "BELMONT",
    "dropdeladd": "1025 E US HIGHWAY 50 BYP",
    "dropdelcty": "PUEBLO",
    "dropdelst": "CO",
    "dropdelzpp": 810019998,
    "dropphyadd": "1025 E US HIGHWAY 50 BYP",
    "dropphycty": "PUEBLO",
    "dropphyst": "CO",
    "dropphyzpp": 810019998,
    "dropmaladd": "1025 E US HIGHWAY 50 BYP",
    "dropmalcty": "PUEBLO",
    "dropmalst": "CO",
    "dropmalzpp": 810019998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195460464,
    "dropsitcph": 7195437163,
    "dropfax": 7195431871
  },
  {
    "dcode": "D",
    "dropkey": "SZ11135",
    "droptype": "D",
    "dropname": "CADET",
    "dropdeladd": "2360 VANDENBERG DR STE 3C24",
    "dropdelcty": "USAF ACADEMY",
    "dropdelst": "CO",
    "dropdelzpp": 808408721,
    "dropphyadd": "2360 VANDENBERG DR STE 3C24",
    "dropphycty": "USAF ACADEMY",
    "dropphyst": "CO",
    "dropphyzpp": 808408721,
    "dropmaladd": "2360 VANDENBERG DR STE 3C24",
    "dropmalcty": "USAF ACADEMY",
    "dropmalst": "CO",
    "dropmalzpp": 808408721,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705409,
    "dropsitcph": 7194721198,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ11141",
    "droptype": "D",
    "dropname": "CAPITOL HILL",
    "dropdeladd": "1541 N MARION ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802189998,
    "dropphyadd": "1541 N MARION ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802189998,
    "dropmaladd": "1541 N MARION ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802189998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038370451,
    "dropsitcph": 3038370446,
    "dropfax": 3038639424
  },
  {
    "dcode": "D",
    "dropkey": "SZ11160",
    "droptype": "D",
    "dropname": "CHERRY CREEK",
    "dropdeladd": "201 COLUMBINE ST STE 150",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802064745,
    "dropphyadd": "201 COLUMBINE ST STE 150",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802064745,
    "dropmaladd": "201 COLUMBINE ST STE 150",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802064745,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033557160,
    "dropsitcph": 3033557160,
    "dropfax": 3033201468
  },
  {
    "dcode": "D",
    "dropkey": "SZ11199",
    "droptype": "D",
    "dropname": "COLUMBINE HILLS",
    "dropdeladd": "6698 S IRIS ST",
    "dropdelcty": "LITTLETON",
    "dropdelst": "CO",
    "dropdelzpp": 801239998,
    "dropphyadd": "6698 S IRIS ST",
    "dropphycty": "LITTLETON",
    "dropphyst": "CO",
    "dropphyzpp": 801233180,
    "dropmaladd": "6698 S IRIS ST",
    "dropmalcty": "LITTLETON",
    "dropmalst": "CO",
    "dropmalzpp": 801239998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033868054,
    "dropsitcph": 3039488900,
    "dropfax": 3039734114
  },
  {
    "dcode": "D",
    "dropkey": "SZ11322",
    "droptype": "D",
    "dropname": "DOWNTOWN ENGLEWOOD",
    "dropdeladd": "3330 S BROADWAY",
    "dropdelcty": "ENGLEWOOD",
    "dropdelst": "CO",
    "dropdelzpp": 801139997,
    "dropphyadd": "3330 S BROADWAY",
    "dropphycty": "ENGLEWOOD",
    "dropphyst": "CO",
    "dropphyzpp": 801139997,
    "dropmaladd": "3330 S BROADWAY",
    "dropmalcty": "ENGLEWOOD",
    "dropmalst": "CO",
    "dropmalzpp": 801139997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037610871,
    "dropsitcph": 3037610871,
    "dropfax": 3037615852
  },
  {
    "dcode": "D",
    "dropkey": "SZ11392",
    "droptype": "D",
    "dropname": "FLETCHER",
    "dropdeladd": "1550 DAYTON ST",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800109998,
    "dropphyadd": "1550 DAYTON ST",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800109998,
    "dropmaladd": "1550 DAYTON ST",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033646589,
    "dropsitcph": 3033646589,
    "dropfax": 3033679236
  },
  {
    "dcode": "D",
    "dropkey": "SZ11401",
    "droptype": "D",
    "dropname": "FORT CARSON",
    "dropdeladd": "1611 MCDONALD ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809134110,
    "dropphyadd": "1611 MCDONALD ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809134110,
    "dropmaladd": "1611 MCDONALD ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809134110,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195799617,
    "dropsitcph": 7195799617,
    "dropfax": 7195767912
  },
  {
    "dcode": "D",
    "dropkey": "SZ11433",
    "droptype": "D",
    "dropname": "GATEWAY",
    "dropdeladd": "2500 S ABILENE ST",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800149998,
    "dropphyadd": "2500 S ABILENE ST",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800149998,
    "dropmaladd": "2500 S ABILENE ST",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800149998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038737076,
    "dropsitcph": 3038737062,
    "dropfax": 3037450995
  },
  {
    "dcode": "D",
    "dropkey": "SZ11436",
    "droptype": "D",
    "dropname": "GENERAL MAIL FACILITY",
    "dropdeladd": "3655 E FOUNTAIN BLVD STE 106",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809109998,
    "dropphyadd": "3655 E FOUNTAIN BLVD STE 106",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809109998,
    "dropmaladd": "3655 E FOUNTAIN BLVD STE 106",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809109998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195705379,
    "dropsitcph": 7195705380,
    "dropfax": 7195705461
  },
  {
    "dcode": "D",
    "dropkey": "SZ11448",
    "droptype": "D",
    "dropname": "GMF FINANCE",
    "dropdeladd": "7550 E 53RD PL",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802170009,
    "dropphyadd": "7550 E 53RD PL",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802170009,
    "dropmaladd": "7550 E 53RD PL",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802170009,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038536758,
    "dropsitcph": 3038536758,
    "dropfax": 3038536689
  },
  {
    "dcode": "D",
    "dropkey": "SZ11450",
    "droptype": "D",
    "dropname": "DOWNTOWN GOLDEN",
    "dropdeladd": "619 12TH ST",
    "dropdelcty": "GOLDEN",
    "dropdelst": "CO",
    "dropdelzpp": 804019996,
    "dropphyadd": "619 12TH ST",
    "dropphycty": "GOLDEN",
    "dropphyst": "CO",
    "dropphyzpp": 804019996,
    "dropmaladd": "619 12TH ST",
    "dropmalcty": "GOLDEN",
    "dropmalst": "CO",
    "dropmalzpp": 804019996,
    "dropsitphn": 3032789235,
    "dropsitlph": 3032160326,
    "dropsitcph": 3032160320,
    "dropfax": 3032710621
  },
  {
    "dcode": "D",
    "dropkey": "SZ11496",
    "droptype": "D",
    "dropname": "HIGH MAR",
    "dropdeladd": "4985 MOORHEAD AVE",
    "dropdelcty": "BOULDER",
    "dropdelst": "CO",
    "dropdelzpp": 803059998,
    "dropphyadd": "4985 MOORHEAD AVE",
    "dropphycty": "BOULDER",
    "dropphyst": "CO",
    "dropphyzpp": 803059998,
    "dropmaladd": "4985 MOORHEAD AVE",
    "dropmalcty": "BOULDER",
    "dropmalst": "CO",
    "dropmalzpp": 803059998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034945082,
    "dropsitcph": 3034945006,
    "dropfax": 3034994790
  },
  {
    "dcode": "D",
    "dropkey": "SZ11501",
    "droptype": "D",
    "dropname": "HOFFMAN HEIGHTS",
    "dropdeladd": "738 PEORIA ST STE D",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800119995,
    "dropphyadd": "738 PEORIA ST STE D",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800119995,
    "dropmaladd": "738 PEORIA ST STE D",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800119995,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033661353,
    "dropsitcph": 3033661353,
    "dropfax": 3033679321
  },
  {
    "dcode": "D",
    "dropkey": "SZ11527",
    "droptype": "D",
    "dropname": "INDIAN TREE",
    "dropdeladd": "7765 WADSWORTH BLVD",
    "dropdelcty": "ARVADA",
    "dropdelst": "CO",
    "dropdelzpp": 800039998,
    "dropphyadd": "7765 WADSWORTH BLVD",
    "dropphycty": "ARVADA",
    "dropphyst": "CO",
    "dropphyzpp": 800039998,
    "dropmaladd": "7765 WADSWORTH BLVD",
    "dropmalcty": "ARVADA",
    "dropmalst": "CO",
    "dropmalzpp": 800039998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034214230,
    "dropsitcph": 3034239883,
    "dropfax": 3034208355
  },
  {
    "dcode": "D",
    "dropkey": "SZ11645",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "1000 W 6TH ST STE U",
    "dropdelcty": "PUEBLO",
    "dropdelst": "CO",
    "dropdelzpp": 810032389,
    "dropphyadd": "1000 W 6TH ST STE U",
    "dropphycty": "PUEBLO",
    "dropphyst": "CO",
    "dropphyzpp": 810032389,
    "dropmaladd": "1000 W 6TH ST STE U",
    "dropmalcty": "PUEBLO",
    "dropmalst": "CO",
    "dropmalzpp": 810032389,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195440365,
    "dropsitcph": 7195440365,
    "dropfax": 7195437116
  },
  {
    "dcode": "D",
    "dropkey": "SZ11655",
    "droptype": "D",
    "dropname": "MONTBELLO",
    "dropdeladd": "4710 NOME ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802399998,
    "dropphyadd": "4710 NOME ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802399998,
    "dropmaladd": "4710 NOME ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802399998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033178785,
    "dropsitcph": 3033178785,
    "dropfax": 3033750765
  },
  {
    "dcode": "D",
    "dropkey": "SZ11656",
    "droptype": "D",
    "dropname": "MONTCLAIR",
    "dropdeladd": "8275 E 11TH AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802209998,
    "dropphyadd": "8275 E 11TH AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802209998,
    "dropmaladd": "8275 E 11TH AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802209998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033332305,
    "dropsitcph": 3033332305,
    "dropfax": 3033222314
  },
  {
    "dcode": "D",
    "dropkey": "SZ11690",
    "droptype": "D",
    "dropname": "NORTH END CO SPGS",
    "dropdeladd": "2940 N PROSPECT ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809079998,
    "dropphyadd": "2940 N PROSPECT ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809079998,
    "dropmaladd": "2940 N PROSPECT ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809079998,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194735204,
    "dropsitcph": 7194735204,
    "dropfax": 7193291383
  },
  {
    "dcode": "D",
    "dropkey": "SZ11692",
    "droptype": "D",
    "dropname": "NORTH PECOS",
    "dropdeladd": "1411 CORTEZ ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802219998,
    "dropphyadd": "1411 CORTEZ ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802219998,
    "dropmaladd": "1411 CORTEZ ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802219998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036504931,
    "dropsitcph": 3036504931,
    "dropfax": 3034301813
  },
  {
    "dcode": "D",
    "dropkey": "SZ11708",
    "droptype": "D",
    "dropname": "OLD TOWN",
    "dropdeladd": "301 S HOWES ST FL 1",
    "dropdelcty": "FORT COLLINS",
    "dropdelst": "CO",
    "dropdelzpp": 805219997,
    "dropphyadd": "301 S HOWES ST FL 1",
    "dropphycty": "FORT COLLINS",
    "dropphyst": "CO",
    "dropphyzpp": 805219997,
    "dropmaladd": "301 S HOWES ST FL 1",
    "dropmalcty": "FORT COLLINS",
    "dropmalst": "CO",
    "dropmalzpp": 805219997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9704724028,
    "dropsitcph": 9704724022,
    "dropfax": 9704847202
  },
  {
    "dcode": "D",
    "dropkey": "SZ11735",
    "droptype": "D",
    "dropname": "PARK HILL",
    "dropdeladd": "3355 HUDSON ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802079998,
    "dropphyadd": "3355 HUDSON ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802079998,
    "dropmaladd": "3355 HUDSON ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802079998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033557149,
    "dropsitcph": 3033557149,
    "dropfax": 3033204709
  },
  {
    "dcode": "D",
    "dropkey": "SZ11806",
    "droptype": "D",
    "dropname": "ROCKRIMMON",
    "dropdeladd": "5001 CENTENNIAL BLVD",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809192401,
    "dropphyadd": "5001 CENTENNIAL BLVD",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809192401,
    "dropmaladd": "5001 CENTENNIAL BLVD",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809192401,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192668216,
    "dropsitcph": 7192668216,
    "dropfax": 7192600536
  },
  {
    "dcode": "D",
    "dropkey": "SZ11839",
    "droptype": "D",
    "dropname": "MILE HIGH",
    "dropdeladd": "450 W 14TH AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802049998,
    "dropphyadd": "450 W 14TH AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802049998,
    "dropmaladd": "450 W 14TH AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802049998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3035710796,
    "dropsitcph": 3035710796,
    "dropfax": 3035929125
  },
  {
    "dcode": "D",
    "dropkey": "SZ11846",
    "droptype": "D",
    "dropname": "SECURITY",
    "dropdeladd": "5755 KITTERY DR",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809113529,
    "dropphyadd": "5755 KITTERY DR",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809113529,
    "dropmaladd": "5755 KITTERY DR",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809113529,
    "dropsitphn": 7193903192,
    "dropsitlph": 7193903192,
    "dropsitcph": 7193903192,
    "dropfax": 7193926447
  },
  {
    "dcode": "D",
    "dropkey": "SZ11877",
    "droptype": "D",
    "dropname": "SOUTH DENVER",
    "dropdeladd": "225 S BROADWAY",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802099998,
    "dropphyadd": "225 S BROADWAY",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802099998,
    "dropmaladd": "225 S BROADWAY",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802099998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038710410,
    "dropsitcph": 3038710410,
    "dropfax": 3036982948
  },
  {
    "dcode": "D",
    "dropkey": "SZ11906",
    "droptype": "D",
    "dropname": "STOCKYARDS",
    "dropdeladd": "4910 BRIGHTON BLVD",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802169998,
    "dropphyadd": "4910 BRIGHTON BLVD",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802169998,
    "dropmaladd": "4910 BRIGHTON BLVD",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802169998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032956098,
    "dropsitcph": 3032956098,
    "dropfax": 3032953975
  },
  {
    "dcode": "D",
    "dropkey": "SZ11916",
    "droptype": "D",
    "dropname": "SULLIVAN",
    "dropdeladd": "8700 E JEFFERSON AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802379998,
    "dropphyadd": "8700 E JEFFERSON AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802379998,
    "dropmaladd": "8700 E JEFFERSON AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802379998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032215209,
    "dropsitcph": 3032215209,
    "dropfax": 3032906347
  },
  {
    "dcode": "D",
    "dropkey": "SZ11919",
    "droptype": "D",
    "dropname": "SUNNYSIDE",
    "dropdeladd": "1766 W 46TH AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802119998,
    "dropphyadd": "1766 W 46TH AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802119998,
    "dropmaladd": "1766 W 46TH AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802119998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034336211,
    "dropsitcph": 3034336211,
    "dropfax": 3034773805
  },
  {
    "dcode": "D",
    "dropkey": "SZ11921",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "3000 WEDGEWOOD DR",
    "dropdelcty": "PUEBLO",
    "dropdelst": "CO",
    "dropdelzpp": 810052311,
    "dropphyadd": "3000 WEDGEWOOD DR",
    "dropphycty": "PUEBLO",
    "dropphyst": "CO",
    "dropphyzpp": 810052311,
    "dropmaladd": "3000 WEDGEWOOD DR",
    "dropmalcty": "PUEBLO",
    "dropmalst": "CO",
    "dropmalzpp": 810052311,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195643147,
    "dropsitcph": 7195643147,
    "dropfax": 7195649446
  },
  {
    "dcode": "D",
    "dropkey": "SZ11934",
    "droptype": "D",
    "dropname": "TEMPLETON",
    "dropdeladd": "4356 MONTEBELLO DR",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809184330,
    "dropphyadd": "4356 MONTEBELLO DR",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809184330,
    "dropmaladd": "4356 MONTEBELLO DR",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809184330,
    "dropsitphn": 7195705409,
    "dropsitlph": 7192666033,
    "dropsitcph": 7192666033,
    "dropfax": 7195319692
  },
  {
    "dcode": "D",
    "dropkey": "SZ11972",
    "droptype": "D",
    "dropname": "UNIVERSITY PARK",
    "dropdeladd": "3800 BUCHTEL BLVD",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802109998,
    "dropphyadd": "3800 BUCHTEL BLVD",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802109998,
    "dropmaladd": "3800 BUCHTEL BLVD",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802109998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3037595794,
    "dropsitcph": 3037595794,
    "dropfax": 3037595706
  },
  {
    "dcode": "D",
    "dropkey": "SZ11984",
    "droptype": "D",
    "dropname": "VALMONT",
    "dropdeladd": "2995 55TH ST",
    "dropdelcty": "BOULDER",
    "dropdelst": "CO",
    "dropdelzpp": 803019998,
    "dropphyadd": "2995 55TH ST",
    "dropphycty": "BOULDER",
    "dropphyst": "CO",
    "dropphyzpp": 803019998,
    "dropmaladd": "2995 55TH ST",
    "dropmalcty": "BOULDER",
    "dropmalst": "CO",
    "dropmalzpp": 803019998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3032456416,
    "dropsitcph": 7205646450,
    "dropfax": 3032456486
  },
  {
    "dcode": "D",
    "dropkey": "SZ12010",
    "droptype": "D",
    "dropname": "WELLSHIRE",
    "dropdeladd": "2080 S HOLLY ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802229998,
    "dropphyadd": "2080 S HOLLY ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802229998,
    "dropmaladd": "2080 S HOLLY ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802229998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036399867,
    "dropsitcph": 3036399867,
    "dropfax": 3037595342
  },
  {
    "dcode": "D",
    "dropkey": "SZ12012",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "204 S 25TH ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809043005,
    "dropphyadd": "204 S 25TH ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809043005,
    "dropmaladd": "204 S 25TH ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809043005,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194736513,
    "dropsitcph": 7194736513,
    "dropfax": 7194771474
  },
  {
    "dcode": "D",
    "dropkey": "SZ12026",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "4259 W FLORIDA AVE",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802199998,
    "dropphyadd": "4259 W FLORIDA AVE",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802199998,
    "dropmaladd": "4259 W FLORIDA AVE",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802199998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3039348717,
    "dropsitcph": 3037279680,
    "dropfax": 3039344407
  },
  {
    "dcode": "D",
    "dropkey": "SZ12074",
    "droptype": "D",
    "dropname": "ANDERSEN AFB",
    "dropdeladd": "24018 CAROLINES AVE",
    "dropdelcty": "YIGO",
    "dropdelst": "GU",
    "dropdelzpp": 969291600,
    "dropphyadd": "24018 CAROLINES AVE",
    "dropphycty": "YIGO",
    "dropphyst": "GU",
    "dropphyzpp": 969291600,
    "dropmaladd": "24018 CAROLINES AVE",
    "dropmalcty": "YIGO",
    "dropmalst": "GU",
    "dropmalzpp": 969291600,
    "dropsitphn": 6713668777,
    "dropsitlph": 6713668777,
    "dropsitcph": 6713668777,
    "dropfax": 6716538316
  },
  {
    "dcode": "D",
    "dropkey": "SZ12092",
    "droptype": "D",
    "dropname": "MOU #3 NAV CAMS WESPAC",
    "dropdeladd": "297 NOYES ST",
    "dropdelcty": "DEDEDO",
    "dropdelst": "GU",
    "dropdelzpp": 969299996,
    "dropphyadd": "297 NOYES ST",
    "dropphycty": "DEDEDO",
    "dropphyst": "GU",
    "dropphyzpp": 969299996,
    "dropmaladd": "PO BOX 129998",
    "dropmalcty": "DEDEDO",
    "dropmalst": "GU",
    "dropmalzpp": 969129998,
    "dropsitphn": 6713555873,
    "dropsitlph": 6713555873,
    "dropsitcph": 6713555873,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12094",
    "droptype": "D",
    "dropname": "NAVAL STATION",
    "dropdeladd": "4 CHAPEL RD BLDG 4",
    "dropdelcty": "YONA",
    "dropdelst": "GU",
    "dropdelzpp": 969154799,
    "dropphyadd": "4 CHAPEL RD BLDG 4",
    "dropphycty": "YONA",
    "dropphyst": "GU",
    "dropphyzpp": 969154799,
    "dropmaladd": "4 CHAPEL RD BLDG 4",
    "dropmalcty": "YONA",
    "dropmalst": "GU",
    "dropmalzpp": 969154799,
    "dropsitphn": 6713393292,
    "dropsitlph": 6713393292,
    "dropsitcph": 6713393292,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12110",
    "droptype": "D",
    "dropname": "AINA HAINA",
    "dropdeladd": "820 W HIND DR STE 128",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968211899,
    "dropphyadd": "820 W HIND DR STE 128",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968211899,
    "dropmaladd": "820 W HIND DR STE 128",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968211899,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083731272,
    "dropsitcph": 8083966431,
    "dropfax": 8083771286
  },
  {
    "dcode": "D",
    "dropkey": "SZ12111",
    "droptype": "D",
    "dropname": "ALA MOANA",
    "dropdeladd": "1450 ALA MOANA BLVD STE 1006",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968144688,
    "dropphyadd": "1450 ALA MOANA BLVD STE 1006",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968144688,
    "dropmaladd": "330 SARATOGA RD",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968159998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089737528,
    "dropsitcph": 8085321987,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12128",
    "droptype": "D",
    "dropname": "DOWNTOWN HILO",
    "dropdeladd": "154 WAIANUENUE AVE STE 1",
    "dropdelcty": "HILO",
    "dropdelst": "HI",
    "dropdelzpp": 967202452,
    "dropphyadd": "154 WAIANUENUE AVE STE 1",
    "dropphycty": "HILO",
    "dropphyst": "HI",
    "dropphyzpp": 967202452,
    "dropmaladd": "154 WAIANUENUE AVE STE 1",
    "dropmalcty": "HILO",
    "dropmalst": "HI",
    "dropmalzpp": 967202452,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089333016,
    "dropsitcph": 8089333014,
    "dropfax": 8089349804
  },
  {
    "dcode": "D",
    "dropkey": "SZ12129",
    "droptype": "D",
    "dropname": "DOWNTOWN HONOLULU",
    "dropdeladd": "335 MERCHANT ST FL GROUND",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968139998,
    "dropphyadd": "335 MERCHANT ST FL GROUND",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968139998,
    "dropmaladd": "335 MERCHANT ST FL GROUND",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968139998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085321987,
    "dropsitcph": 8085321987,
    "dropfax": 8085321988
  },
  {
    "dcode": "D",
    "dropkey": "SZ12130",
    "droptype": "D",
    "dropname": "DOWNTOWN LAHAINA",
    "dropdeladd": "132 PAPALAUA ST",
    "dropdelcty": "LAHAINA",
    "dropdelst": "HI",
    "dropdelzpp": 967619997,
    "dropphyadd": "132 PAPALAUA ST",
    "dropphycty": "LAHAINA",
    "dropphyst": "HI",
    "dropphyzpp": 967619997,
    "dropmaladd": "132 PAPALAUA ST",
    "dropmalcty": "LAHAINA",
    "dropmalst": "HI",
    "dropmalzpp": 967619997,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086618139,
    "dropsitcph": 8086610904,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12139",
    "droptype": "D",
    "dropname": "EWA STATION",
    "dropdeladd": "91-1202 RENTON RD",
    "dropdelcty": "EWA BEACH",
    "dropdelst": "HI",
    "dropdelzpp": 967061999,
    "dropphyadd": "91-1202 RENTON RD",
    "dropphycty": "EWA BEACH",
    "dropphyst": "HI",
    "dropphyzpp": 967061999,
    "dropmaladd": "91-1202 RENTON RD",
    "dropmalcty": "EWA BEACH",
    "dropmalst": "HI",
    "dropmalzpp": 967061999,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086814250,
    "dropsitcph": 8086894250,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12145",
    "droptype": "D",
    "dropname": "FORT SHAFTER",
    "dropdeladd": "1 FORT SHAFTER ARMY BASE BLDG 434",
    "dropdelcty": "FORT SHAFTER",
    "dropdelst": "HI",
    "dropdelzpp": 968585098,
    "dropphyadd": "1 FORT SHAFTER ARMY BASE BLDG 434",
    "dropphycty": "FORT SHAFTER",
    "dropphyst": "HI",
    "dropphyzpp": 968585098,
    "dropmaladd": "1 FORT SHAFTER ARMY BASE BLDG 434",
    "dropmalcty": "FORT SHAFTER",
    "dropmalst": "HI",
    "dropmalzpp": 968585098,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088320025,
    "dropsitcph": 8088320025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12158",
    "droptype": "D",
    "dropname": "HAWAII KAI",
    "dropdeladd": "7040 HAWAII KAI DR",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968259998,
    "dropphyadd": "7040 HAWAII KAI DR",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968259998,
    "dropmaladd": "7040 HAWAII KAI DR",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968259998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8083966431,
    "dropsitcph": 8083966431,
    "dropfax": 8083955067
  },
  {
    "dcode": "D",
    "dropkey": "SZ12169",
    "droptype": "D",
    "dropname": "HICKAM AFB",
    "dropdeladd": "1300 FREEDOM AVE",
    "dropdelcty": "JBPHH",
    "dropdelst": "HI",
    "dropdelzpp": 968539998,
    "dropphyadd": "1300 FREEDOM AVE",
    "dropphycty": "JBPHH",
    "dropphyst": "HI",
    "dropphyzpp": 968539998,
    "dropmaladd": "1300 FREEDOM AVE",
    "dropmalcty": "JBPHH",
    "dropmalst": "HI",
    "dropmalzpp": 968539998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084229033,
    "dropsitcph": 8084233930,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12205",
    "droptype": "D",
    "dropname": "KAIMUKI",
    "dropdeladd": "1130 KOKO HEAD AVE",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968163795,
    "dropphyadd": "1130 KOKO HEAD AVE",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968163795,
    "dropmaladd": "1130 KOKO HEAD AVE",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968163795,
    "dropsitphn": 8084233844,
    "dropsitlph": 8087378937,
    "dropsitcph": 8087378937,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12221",
    "droptype": "D",
    "dropname": "KAPALAMA",
    "dropdeladd": "1271 N KING ST",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968179998,
    "dropphyadd": "1271 N KING ST",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968179998,
    "dropmaladd": "1271 N KING ST",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968179998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088320068,
    "dropsitcph": 8088320068,
    "dropfax": 8088320064
  },
  {
    "dcode": "D",
    "dropkey": "SZ12261",
    "droptype": "D",
    "dropname": "M O U #1",
    "dropdeladd": "1025 QUINCY AVE STE 150",
    "dropdelcty": "JBPHH",
    "dropdelst": "HI",
    "dropdelzpp": 968603528,
    "dropphyadd": "1025 QUINCY AVE STE 150",
    "dropphycty": "JBPHH",
    "dropphyst": "HI",
    "dropphyzpp": 968603528,
    "dropmaladd": "1025 QUINCY AVE STE 150",
    "dropmalcty": "JBPHH",
    "dropmalst": "HI",
    "dropmalzpp": 968603528,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084748145,
    "dropsitcph": 8084748145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12262",
    "droptype": "D",
    "dropname": "M O U #3",
    "dropdeladd": "251 MAKALAPA DR",
    "dropdelcty": "JBPHH",
    "dropdelst": "HI",
    "dropdelzpp": 968603199,
    "dropphyadd": "251 MAKALAPA DR",
    "dropphycty": "JBPHH",
    "dropphyst": "HI",
    "dropphyzpp": 968603199,
    "dropmaladd": "251 MAKALAPA DR",
    "dropmalcty": "JBPHH",
    "dropmalst": "HI",
    "dropmalzpp": 968603199,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084715440,
    "dropsitcph": 8084715440,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12264",
    "droptype": "D",
    "dropname": "MAIN OFFICE CARRIERS",
    "dropdeladd": "3600 AOLELE ST RM 400",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968209711,
    "dropphyadd": "3600 AOLELE ST RM 400",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968209711,
    "dropmaladd": "3600 AOLELE ST RM 400",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968209711,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084233917,
    "dropsitcph": 8084233917,
    "dropfax": 8084233652
  },
  {
    "dcode": "D",
    "dropkey": "SZ12271",
    "droptype": "D",
    "dropname": "MAKIKI",
    "dropdeladd": "1111 LUNALILO ST",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968229998,
    "dropphyadd": "1111 LUNALILO ST",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968229998,
    "dropmaladd": "1111 LUNALILO ST",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968229998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8085325689,
    "dropsitcph": 8085325689,
    "dropfax": 8085323733
  },
  {
    "dcode": "D",
    "dropkey": "SZ12281",
    "droptype": "D",
    "dropname": "MOILIILI",
    "dropdeladd": "2700 S KING ST STE B",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968263398,
    "dropphyadd": "2700 S KING ST STE B",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968263398,
    "dropmaladd": "2700 S KING ST STE B",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968263398,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089737208,
    "dropsitcph": 8085325689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12339",
    "droptype": "D",
    "dropname": "SCHOFIELD BARRACKS",
    "dropdeladd": "1 SCHOFIELD BARRACKS BLDG 258",
    "dropdelcty": "SCHOFIELD BARRACKS",
    "dropdelst": "HI",
    "dropdelzpp": 968575099,
    "dropphyadd": "1 SCHOFIELD BARRACKS BLDG 258",
    "dropphycty": "SCHOFIELD BARRACKS",
    "dropphyst": "HI",
    "dropphyzpp": 968575099,
    "dropmaladd": "115 LEHUA ST",
    "dropmalcty": "WAHIAWA",
    "dropmalst": "HI",
    "dropmalzpp": 967869998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086221182,
    "dropsitcph": 8086221182,
    "dropfax": 8086240273
  },
  {
    "dcode": "D",
    "dropkey": "SZ12344",
    "droptype": "D",
    "dropname": "TRIPLER ARMY MEDICAL CTR",
    "dropdeladd": "1 JARRETT WHITE RD BLDG 1",
    "dropdelcty": "TRIPLER ARMY MEDICAL CENTER",
    "dropdelst": "HI",
    "dropdelzpp": 968595098,
    "dropphyadd": "1 JARRETT WHITE RD BLDG 1",
    "dropphycty": "TRIPLER ARMY MEDICAL CENTER",
    "dropphyst": "HI",
    "dropphyzpp": 968595098,
    "dropmaladd": "1 JARRETT WHITE RD BLDG 1",
    "dropmalcty": "TRIPLER ARMY MEDICAL CENTER",
    "dropmalst": "HI",
    "dropmalzpp": 968595098,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084335272,
    "dropsitcph": 8088320068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12351",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "1170 NUUANU AVE STE 105",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968175199,
    "dropphyadd": "1170 NUUANU AVE STE 105",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968175199,
    "dropmaladd": "1170 NUUANU AVE STE 105",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968175199,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088320068,
    "dropsitcph": 8088320068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12355",
    "droptype": "D",
    "dropname": "WAIALAE KAHALA",
    "dropdeladd": "4354 PAHOA AVE",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968169998,
    "dropphyadd": "4354 PAHOA AVE",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968169998,
    "dropmaladd": "4354 PAHOA AVE",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968169998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8087378937,
    "dropsitcph": 8087378937,
    "dropfax": 8082069221
  },
  {
    "dcode": "D",
    "dropkey": "SZ12359",
    "droptype": "D",
    "dropname": "WAIKIKI",
    "dropdeladd": "330 SARATOGA RD",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968159998,
    "dropphyadd": "330 SARATOGA RD",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968159998,
    "dropmaladd": "330 SARATOGA RD",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968159998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8089737515,
    "dropsitcph": 8089737515,
    "dropfax": 8089739096
  },
  {
    "dcode": "D",
    "dropkey": "SZ12379",
    "droptype": "D",
    "dropname": "BOISE AIRPORT STATION",
    "dropdeladd": "2625 W APOLLO ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837055353,
    "dropphyadd": "2625 W APOLLO ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837055353,
    "dropmaladd": "PO BOX 15000",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837159998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083436366,
    "dropsitcph": 2084240331,
    "dropfax": 2083456278
  },
  {
    "dcode": "D",
    "dropkey": "SZ12410",
    "droptype": "D",
    "dropname": "BANNOCK",
    "dropdeladd": "102 S MAIN ST",
    "dropdelcty": "POCATELLO",
    "dropdelst": "ID",
    "dropdelzpp": 832049998,
    "dropphyadd": "102 S MAIN ST",
    "dropphycty": "POCATELLO",
    "dropphyst": "ID",
    "dropphyzpp": 832049998,
    "dropmaladd": "102 S MAIN ST",
    "dropmalcty": "POCATELLO",
    "dropmalst": "ID",
    "dropmalzpp": 832049998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082355517,
    "dropsitcph": 2082332068,
    "dropfax": 2082355550
  },
  {
    "dcode": "D",
    "dropkey": "SZ12437",
    "droptype": "D",
    "dropname": "BORAH",
    "dropdeladd": "750 W BANNOCK ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837025809,
    "dropphyadd": "750 W BANNOCK ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837025809,
    "dropmaladd": "750 W BANNOCK ST",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837025809,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083310037,
    "dropsitcph": 2083310037,
    "dropfax": 2083311680
  },
  {
    "dcode": "D",
    "dropkey": "SZ12486",
    "droptype": "D",
    "dropname": "COLE VILLAGE",
    "dropdeladd": "3485 N COLE RD",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837049998,
    "dropphyadd": "3485 N COLE RD",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837049998,
    "dropmaladd": "3485 N COLE RD",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837049998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083768651,
    "dropsitcph": 2083768651,
    "dropfax": 2083787366
  },
  {
    "dcode": "D",
    "dropkey": "SZ12488",
    "droptype": "D",
    "dropname": "COLLISTER",
    "dropdeladd": "4650 W STATE ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837034102,
    "dropphyadd": "4650 W STATE ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837034102,
    "dropmaladd": "4650 W STATE ST",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837034102,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084240378,
    "dropsitcph": 2084240378,
    "dropfax": 2083311701
  },
  {
    "dcode": "D",
    "dropkey": "SZ12526",
    "droptype": "D",
    "dropname": "EAGLE ROCK",
    "dropdeladd": "875 N CAPITAL AVE",
    "dropdelcty": "IDAHO FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 834029929,
    "dropphyadd": "875 N CAPITAL AVE",
    "dropphycty": "IDAHO FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 834029929,
    "dropmaladd": "875 N CAPITAL AVE",
    "dropmalcty": "IDAHO FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 834029929,
    "dropsitphn": 2084334080,
    "dropsitlph": 2085243635,
    "dropsitcph": 2085420837,
    "dropfax": 2085226086
  },
  {
    "dcode": "D",
    "dropkey": "SZ12561",
    "droptype": "D",
    "dropname": "FIVE MILE",
    "dropdeladd": "1350 S FIVE MILE RD",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837099998,
    "dropphyadd": "1350 S FIVE MILE RD",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837099998,
    "dropmaladd": "1350 S FIVE MILE RD",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837099998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083767819,
    "dropsitcph": 2083767819,
    "dropfax": 2083755045
  },
  {
    "dcode": "D",
    "dropkey": "SZ12570",
    "droptype": "D",
    "dropname": "GARDEN CITY",
    "dropdeladd": "8100 W MARIGOLD ST",
    "dropdelcty": "GARDEN CITY",
    "dropdelst": "ID",
    "dropdelzpp": 837149998,
    "dropphyadd": "8100 W MARIGOLD ST",
    "dropphycty": "GARDEN CITY",
    "dropphyst": "ID",
    "dropphyzpp": 837149998,
    "dropmaladd": "8100 W MARIGOLD ST",
    "dropmalcty": "GARDEN CITY",
    "dropmalst": "ID",
    "dropmalzpp": 837149998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083238245,
    "dropsitcph": 2083238271,
    "dropfax": 2083238468
  },
  {
    "dcode": "D",
    "dropkey": "SZ12956",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "704 S DEAKIN ST",
    "dropdelcty": "MOSCOW",
    "dropdelst": "ID",
    "dropdelzpp": 838432333,
    "dropphyadd": "704 S DEAKIN ST",
    "dropphycty": "MOSCOW",
    "dropphyst": "ID",
    "dropphyzpp": 838432333,
    "dropmaladd": "704 S DEAKIN ST",
    "dropmalcty": "MOSCOW",
    "dropmalst": "ID",
    "dropmalzpp": 838432333,
    "dropsitphn": 5093636210,
    "dropsitlph": 2088824900,
    "dropsitcph": 2088838464,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ12991",
    "droptype": "D",
    "dropname": "DELAP",
    "dropdeladd": "1 DELAP TOWN",
    "dropdelcty": "MAJURO",
    "dropdelst": "MH",
    "dropdelzpp": 969609996,
    "dropphyadd": "1 DELAP TOWN",
    "dropphycty": "MAJURO",
    "dropphyst": "MH",
    "dropphyzpp": 969609996,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "MAJURO",
    "dropmalst": "MH",
    "dropmalzpp": 969609998,
    "dropsitphn": 6926253221,
    "dropsitlph": 6926253221,
    "dropsitcph": 6926256221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ13081",
    "droptype": "D",
    "dropname": "CENTENNIAL",
    "dropdeladd": "2250 GRANT RD",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591029998,
    "dropphyadd": "2250 GRANT RD",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591029998,
    "dropmaladd": "2250 GRANT RD",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591029998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062006199,
    "dropsitcph": 4062006199,
    "dropfax": 4062556436
  },
  {
    "dcode": "D",
    "dropkey": "SZ13082",
    "droptype": "D",
    "dropname": "CHARLES M RUSSELL",
    "dropdeladd": "3400 9TH AVE S",
    "dropdelcty": "GREAT FALLS",
    "dropdelst": "MT",
    "dropdelzpp": 594059998,
    "dropphyadd": "3400 9TH AVE S",
    "dropphycty": "GREAT FALLS",
    "dropphyst": "MT",
    "dropphyzpp": 594059998,
    "dropmaladd": "3400 9TH AVE S",
    "dropmalcty": "GREAT FALLS",
    "dropmalst": "MT",
    "dropmalzpp": 594059998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067704200,
    "dropsitcph": 4067704200,
    "dropfax": 4067704232
  },
  {
    "dcode": "D",
    "dropkey": "SZ13128",
    "droptype": "D",
    "dropname": "DOWNTOWN BILLINGS",
    "dropdeladd": "2602 1ST AVE N FL 1",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591012366,
    "dropphyadd": "2602 1ST AVE N FL 1",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591012366,
    "dropmaladd": "2602 1ST AVE N FL 1",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591012366,
    "dropsitphn": 4066575713,
    "dropsitlph": 4066575748,
    "dropsitcph": 4066575748,
    "dropfax": 4066575676
  },
  {
    "dcode": "D",
    "dropkey": "SZ13217",
    "droptype": "D",
    "dropname": "HELLGATE",
    "dropdeladd": "200 E BROADWAY ST",
    "dropdelcty": "MISSOULA",
    "dropdelst": "MT",
    "dropdelzpp": 598029998,
    "dropphyadd": "200 E BROADWAY ST",
    "dropphycty": "MISSOULA",
    "dropphyst": "MT",
    "dropphyzpp": 598029998,
    "dropmaladd": "200 E BROADWAY ST",
    "dropmalcty": "MISSOULA",
    "dropmalst": "MT",
    "dropmalzpp": 598029998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067289805,
    "dropsitcph": 4067289805,
    "dropfax": 4067286755
  },
  {
    "dcode": "D",
    "dropkey": "SZ13258",
    "droptype": "D",
    "dropname": "LAST CHANCE",
    "dropdeladd": "500 N LAST CHANCE GULCH",
    "dropdelcty": "HELENA",
    "dropdelst": "MT",
    "dropdelzpp": 596015021,
    "dropphyadd": "500 N LAST CHANCE GULCH",
    "dropphycty": "HELENA",
    "dropphyst": "MT",
    "dropphyzpp": 596015021,
    "dropmaladd": "500 N LAST CHANCE GULCH",
    "dropmalcty": "HELENA",
    "dropmalst": "MT",
    "dropmalzpp": 596015021,
    "dropsitphn": 4066575713,
    "dropsitlph": 4064438373,
    "dropsitcph": 4064435351,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ13338",
    "droptype": "D",
    "dropname": "PIONEER",
    "dropdeladd": "724 15TH ST W",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591024170,
    "dropphyadd": "724 15TH ST W",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591024170,
    "dropmaladd": "724 15TH ST W",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591024170,
    "dropsitphn": 4062006219,
    "dropsitlph": 4062006219,
    "dropsitcph": 4062006219,
    "dropfax": 4066575788
  },
  {
    "dcode": "D",
    "dropkey": "SZ13491",
    "droptype": "D",
    "dropname": "ACADEMY",
    "dropdeladd": "6255 SAN ANTONIO DR NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871099998,
    "dropphyadd": "6255 SAN ANTONIO DR NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871099998,
    "dropmaladd": "6255 SAN ANTONIO DR NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871099998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461233,
    "dropsitcph": 5053461230,
    "dropfax": 5053461226
  },
  {
    "dcode": "D",
    "dropkey": "SZ13495",
    "droptype": "D",
    "dropname": "AIRPORT MAIL FACILITY",
    "dropdeladd": "2100 GEORGE RD SE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871065629,
    "dropphyadd": "2100 GEORGE RD SE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871065629,
    "dropmaladd": "2100 GEORGE RD SE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871065629,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460923,
    "dropsitcph": 5053460923,
    "dropfax": 5053460911
  },
  {
    "dcode": "D",
    "dropkey": "SZ13644",
    "droptype": "D",
    "dropname": "CORONADO",
    "dropdeladd": "2071 S PACHECO ST",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875059998,
    "dropphyadd": "2071 S PACHECO ST",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875059998,
    "dropmaladd": "2071 S PACHECO ST",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875059998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054381540,
    "dropsitcph": 5054381540,
    "dropfax": 5054743280
  },
  {
    "dcode": "D",
    "dropkey": "SZ13678",
    "droptype": "D",
    "dropname": "DOWNTOWN ALBUQUERQUE",
    "dropdeladd": "201 5TH ST SW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871029721,
    "dropphyadd": "201 5TH ST SW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871029721,
    "dropmaladd": "201 5TH ST SW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871029721,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461256,
    "dropsitcph": 5053461256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ13705",
    "droptype": "D",
    "dropname": "STEVE SCHIFF",
    "dropdeladd": "9719 CANDELARIA RD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871119998,
    "dropphyadd": "9719 CANDELARIA RD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871119998,
    "dropmaladd": "9719 CANDELARIA RD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460985,
    "dropsitcph": 5053460985,
    "dropfax": 5053460987
  },
  {
    "dcode": "D",
    "dropkey": "SZ13721",
    "droptype": "D",
    "dropname": "FAIRVIEW",
    "dropdeladd": "2103 N RIVERSIDE DR",
    "dropdelcty": "ESPANOLA",
    "dropdelst": "NM",
    "dropdelzpp": 875329997,
    "dropphyadd": "2103 N RIVERSIDE DR",
    "dropphycty": "ESPANOLA",
    "dropphyst": "NM",
    "dropphyzpp": 875328204,
    "dropmaladd": "2103 N RIVERSIDE DR",
    "dropmalcty": "ESPANOLA",
    "dropmalst": "NM",
    "dropmalzpp": 875329997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057532945,
    "dropsitcph": 5057532945,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ13730",
    "droptype": "D",
    "dropname": "FIVE POINTS",
    "dropdeladd": "1050 SUNSET RD SW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871059998,
    "dropphyadd": "1050 SUNSET RD SW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871059998,
    "dropmaladd": "1050 SUNSET RD SW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871059998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460876,
    "dropsitcph": 5053460876,
    "dropfax": 5053460873
  },
  {
    "dcode": "D",
    "dropkey": "SZ13797",
    "droptype": "D",
    "dropname": "HIGHLAND",
    "dropdeladd": "111 ALVARADO DR SE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871089998,
    "dropphyadd": "111 ALVARADO DR SE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871089998,
    "dropmaladd": "111 ALVARADO DR SE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871089998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460891,
    "dropsitcph": 5053460891,
    "dropfax": 5053460888
  },
  {
    "dcode": "D",
    "dropkey": "SZ13803",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "25959 US HIGHWAY 70",
    "dropdelcty": "RUIDOSO",
    "dropdelst": "NM",
    "dropdelzpp": 883456050,
    "dropphyadd": "25959 US HIGHWAY 70",
    "dropphycty": "RUIDOSO",
    "dropphyst": "NM",
    "dropphyzpp": 883456050,
    "dropmaladd": "25959 US HIGHWAY 70",
    "dropmalcty": "RUIDOSO",
    "dropmalst": "NM",
    "dropmalzpp": 883456050,
    "dropsitphn": 5053468251,
    "dropsitlph": 5752579561,
    "dropsitcph": 5752579561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ13907",
    "droptype": "D",
    "dropname": "MANZANO",
    "dropdeladd": "11600 HAINES AVE NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871129998,
    "dropphyadd": "11600 HAINES AVE NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871129998,
    "dropmaladd": "11600 HAINES AVE NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871129998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460947,
    "dropsitcph": 5053460947,
    "dropfax": 5053460945
  },
  {
    "dcode": "D",
    "dropkey": "SZ13970",
    "droptype": "D",
    "dropname": "NORTH VALLEY",
    "dropdeladd": "424 VERANDA RD NW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871079997,
    "dropphyadd": "424 VERANDA RD NW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871079997,
    "dropmaladd": "424 VERANDA RD NW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871079997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461263,
    "dropsitcph": 5053461677,
    "dropfax": 5053461261
  },
  {
    "dcode": "D",
    "dropkey": "SZ13982",
    "droptype": "D",
    "dropname": "OLD ALBUQUERQUE",
    "dropdeladd": "2016 CENTRAL AVE SW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871049998,
    "dropphyadd": "2016 CENTRAL AVE SW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871049998,
    "dropmaladd": "2016 CENTRAL AVE SW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871049998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461293,
    "dropsitcph": 5053461293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14255",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "115 CORNELL DR SE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871069998,
    "dropphyadd": "115 CORNELL DR SE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871069998,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871969997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460891,
    "dropsitcph": 5053460931,
    "dropfax": 5053460933
  },
  {
    "dcode": "D",
    "dropkey": "SZ14259",
    "droptype": "D",
    "dropname": "UNIVERSITY PARK",
    "dropdeladd": "1600 INTERNATIONAL MALL",
    "dropdelcty": "LAS CRUCES",
    "dropdelst": "NM",
    "dropdelzpp": 880031294,
    "dropphyadd": "1600 INTERNATIONAL MALL",
    "dropphycty": "LAS CRUCES",
    "dropphyst": "NM",
    "dropphyzpp": 880031294,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "LAS CRUCES",
    "dropmalst": "NM",
    "dropmalzpp": 880039998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756462019,
    "dropsitcph": 5756462019,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14262",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "2505 GRACELAND DR NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871109998,
    "dropphyadd": "2505 GRACELAND DR NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871109998,
    "dropmaladd": "2505 GRACELAND DR NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871109998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461210,
    "dropsitcph": 5053461210,
    "dropfax": 5053461205
  },
  {
    "dcode": "D",
    "dropkey": "SZ14280",
    "droptype": "D",
    "dropname": "WALKER",
    "dropdeladd": "5904 S MAIN ST",
    "dropdelcty": "ROSWELL",
    "dropdelst": "NM",
    "dropdelzpp": 882039991,
    "dropphyadd": "5904 S MAIN ST",
    "dropphycty": "ROSWELL",
    "dropphyst": "NM",
    "dropphyzpp": 882039991,
    "dropmaladd": "5904 S MAIN ST",
    "dropmalcty": "ROSWELL",
    "dropmalst": "NM",
    "dropmalzpp": 882039991,
    "dropsitphn": 5053468251,
    "dropsitlph": 5753472262,
    "dropsitcph": 5753472262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14285",
    "droptype": "D",
    "dropname": "WEST LAS VEGAS",
    "dropdeladd": "1900 HOT SPRINGS BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NM",
    "dropdelzpp": 877019997,
    "dropphyadd": "1900 HOT SPRINGS BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NM",
    "dropphyzpp": 877019997,
    "dropmaladd": "1900 HOT SPRINGS BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NM",
    "dropmalzpp": 877019997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058483903,
    "dropsitcph": 5054258341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14288",
    "droptype": "D",
    "dropname": "WHITE ROCK",
    "dropdeladd": "101 LONGVIEW DR",
    "dropdelcty": "WHITE ROCK",
    "dropdelst": "NM",
    "dropdelzpp": 875479211,
    "dropphyadd": "101 LONGVIEW DR",
    "dropphycty": "WHITE ROCK",
    "dropphyst": "NM",
    "dropphyzpp": 875479211,
    "dropmaladd": "101 LONGVIEW DR",
    "dropmalcty": "WHITE ROCK",
    "dropmalst": "NM",
    "dropmalzpp": 875479211,
    "dropsitphn": 5053468251,
    "dropsitlph": 5056720086,
    "dropsitcph": 5056720086,
    "dropfax": 5056625329
  },
  {
    "dcode": "D",
    "dropkey": "SZ14305",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "5757 WAYNE NEWTON BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891119997,
    "dropphyadd": "5757 WAYNE NEWTON BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891119997,
    "dropmaladd": "PO BOX 11998",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891119998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7023619356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14381",
    "droptype": "D",
    "dropname": "DOWNTOWN LAS VEGAS",
    "dropdeladd": "201 LAS VEGAS BLVD S STE 100",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891019997,
    "dropphyadd": "201 LAS VEGAS BLVD S STE 100",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891019997,
    "dropmaladd": "201 LAS VEGAS BLVD S STE 100",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891019997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023824488,
    "dropsitcph": 7023825779,
    "dropfax": 7023826352
  },
  {
    "dcode": "D",
    "dropkey": "SZ14395",
    "droptype": "D",
    "dropname": "EAST LAS VEGAS",
    "dropdeladd": "4948 MOUNTAIN VISTA ST",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891219995,
    "dropphyadd": "4948 MOUNTAIN VISTA ST",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891219995,
    "dropmaladd": "4948 MOUNTAIN VISTA ST",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891219995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7024587794,
    "dropsitcph": 7024587781,
    "dropfax": 7024561241
  },
  {
    "dcode": "D",
    "dropkey": "SZ14412",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "300 LAS VEGAS BLVD S STE 1370",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891015835,
    "dropphyadd": "300 LAS VEGAS BLVD S STE 1370",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891015835,
    "dropmaladd": "300 LAS VEGAS BLVD S STE 1370",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891015835,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023858944,
    "dropsitcph": 7023853837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14418",
    "droptype": "D",
    "dropname": "GALENA",
    "dropdeladd": "299 E PLUMB LN STE 110",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895023419,
    "dropphyadd": "299 E PLUMB LN STE 110",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895023419,
    "dropmaladd": "299 E PLUMB LN STE 110",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895023419,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757862723,
    "dropsitcph": 7757880683,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14421",
    "droptype": "D",
    "dropname": "GARSIDE",
    "dropdeladd": "1801 S DECATUR BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891029998,
    "dropphyadd": "1801 S DECATUR BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891029998,
    "dropmaladd": "1801 S DECATUR BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891029998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022208614,
    "dropsitcph": 7022208454,
    "dropfax": 7028710342
  },
  {
    "dcode": "D",
    "dropkey": "SZ14422",
    "droptype": "D",
    "dropname": "JAMES C BROWN JR",
    "dropdeladd": "1001 E SUNSET RD UNIT 1001",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891999712,
    "dropphyadd": "1001 E SUNSET RD UNIT 1001",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891999712,
    "dropmaladd": "1001 E SUNSET RD UNIT 1001",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891999712,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619472,
    "dropsitcph": 7023619472,
    "dropfax": 7023619378
  },
  {
    "dcode": "D",
    "dropkey": "SZ14434",
    "droptype": "D",
    "dropname": "GREEN VALLEY",
    "dropdeladd": "2722 N GREEN VALLEY PKWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890149997,
    "dropphyadd": "2722 N GREEN VALLEY PKWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890149997,
    "dropmaladd": "2722 N GREEN VALLEY PKWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890149997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7024583278,
    "dropsitcph": 7028371624,
    "dropfax": 7028371623
  },
  {
    "dcode": "D",
    "dropkey": "SZ14448",
    "droptype": "D",
    "dropname": "HUNTRIDGE",
    "dropdeladd": "3115 OLIVE ST",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891044460,
    "dropphyadd": "3115 OLIVE ST",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891044460,
    "dropmaladd": "3115 OLIVE ST",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891044460,
    "dropsitphn": 7023619453,
    "dropsitlph": 7024320822,
    "dropsitcph": 7024320482,
    "dropfax": 7024575124
  },
  {
    "dcode": "D",
    "dropkey": "SZ14548",
    "droptype": "D",
    "dropname": "PARADISE VALLEY",
    "dropdeladd": "4975 UNIVERSITY CENTER DR",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891199998,
    "dropphyadd": "4975 UNIVERSITY CENTER DR",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891199998,
    "dropmaladd": "4975 UNIVERSITY CENTER DR",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891199998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7027367910,
    "dropsitcph": 7027367649,
    "dropfax": 7027393363
  },
  {
    "dcode": "D",
    "dropkey": "SZ14574",
    "droptype": "D",
    "dropname": "RED ROCK VISTA",
    "dropdeladd": "2449 N TENAYA WAY",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891289995,
    "dropphyadd": "2449 N TENAYA WAY",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891289995,
    "dropmaladd": "2449 N TENAYA WAY",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891289995,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023603318,
    "dropsitcph": 7023603314,
    "dropfax": 7023417516
  },
  {
    "dcode": "D",
    "dropkey": "SZ14603",
    "droptype": "D",
    "dropname": "SIERRA",
    "dropdeladd": "1050 N HILLS BLVD",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895069997,
    "dropphyadd": "1050 N HILLS BLVD",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895069997,
    "dropmaladd": "1050 N HILLS BLVD",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895069997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7759729183,
    "dropsitcph": 7759727054,
    "dropfax": 7759729353
  },
  {
    "dcode": "D",
    "dropkey": "SZ14618",
    "droptype": "D",
    "dropname": "SPRING VALLEY",
    "dropdeladd": "3375 S RAINBOW BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891469998,
    "dropphyadd": "3375 S RAINBOW BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891469998,
    "dropmaladd": "3375 S RAINBOW BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891469998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7022207217,
    "dropfax": 7028710361
  },
  {
    "dcode": "D",
    "dropkey": "SZ14639",
    "droptype": "D",
    "dropname": "STEAMBOAT",
    "dropdeladd": "75 MCCABE DR",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895119998,
    "dropphyadd": "75 MCCABE DR",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895119998,
    "dropmaladd": "75 MCCABE DR",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895119998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758532635,
    "dropsitcph": 7758532615,
    "dropfax": 7758532657
  },
  {
    "dcode": "D",
    "dropkey": "SZ14671",
    "droptype": "D",
    "dropname": "UNIVERSITY LAS VEGAS",
    "dropdeladd": "4632 S MARYLAND PKWY STE 10",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891199997,
    "dropphyadd": "4632 S MARYLAND PKWY STE 10",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891199997,
    "dropmaladd": "4632 S MARYLAND PKWY STE 10",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891199997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7027367910,
    "dropsitcph": 7027367649,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14673",
    "droptype": "D",
    "dropname": "UNIVERSITY RENO",
    "dropdeladd": "1674 N VIRGINIA ST",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895039997,
    "dropphyadd": "1674 N VIRGINIA ST",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895039997,
    "dropmaladd": "1674 N VIRGINIA ST",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895039997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7753487858,
    "dropsitcph": 7753482090,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14686",
    "droptype": "D",
    "dropname": "WASHINGTON",
    "dropdeladd": "1490 STARDUST ST",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895039998,
    "dropphyadd": "1490 STARDUST ST",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895039998,
    "dropmaladd": "1490 STARDUST ST",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895039998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757463129,
    "dropsitcph": 7757474718,
    "dropfax": 7757470439
  },
  {
    "dcode": "D",
    "dropkey": "SZ14798",
    "droptype": "D",
    "dropname": "BROOKLYN",
    "dropdeladd": "1410 SE POWELL BLVD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972022398,
    "dropphyadd": "1410 SE POWELL BLVD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972022398,
    "dropmaladd": "PO BOX 42998",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972420998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032360256,
    "dropsitcph": 5032360256,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14846",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "204 SW 5TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972405000,
    "dropphyadd": "204 SW 5TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972405000,
    "dropmaladd": "204 SW 5TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972401897,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032942399,
    "dropsitcph": 5032942399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ14897",
    "droptype": "D",
    "dropname": "CRESTON",
    "dropdeladd": "5010 SE FOSTER RD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972863039,
    "dropphyadd": "5010 SE FOSTER RD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972863039,
    "dropmaladd": "5010 SE FOSTER RD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972869898,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037773305,
    "dropsitcph": 5037889037,
    "dropfax": 5037713126
  },
  {
    "dcode": "D",
    "dropkey": "SZ14949",
    "droptype": "D",
    "dropname": "DOWNTOWN BEND",
    "dropdeladd": "61 NW OREGON AVE STE 103",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977032739,
    "dropphyadd": "61 NW OREGON AVE STE 103",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977032739,
    "dropmaladd": "61 NW OREGON AVE STE 103",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977032739,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413882427,
    "dropsitcph": 5413185068,
    "dropfax": 5413858127
  },
  {
    "dcode": "D",
    "dropkey": "SZ14965",
    "droptype": "D",
    "dropname": "EAST PORTLAND",
    "dropdeladd": "1020 SE 7TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972142387,
    "dropphyadd": "1020 SE 7TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972142387,
    "dropmaladd": "1020 SE 7TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972149998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032309494,
    "dropsitcph": 5032346182,
    "dropfax": 5032318715
  },
  {
    "dcode": "D",
    "dropkey": "SZ14979",
    "droptype": "D",
    "dropname": "EMPIRE",
    "dropdeladd": "730 NEWMARK AVE",
    "dropdelcty": "COOS BAY",
    "dropdelst": "OR",
    "dropdelzpp": 974203204,
    "dropphyadd": "730 NEWMARK AVE",
    "dropphycty": "COOS BAY",
    "dropphyst": "OR",
    "dropphyzpp": 974203204,
    "dropmaladd": "730 NEWMARK AVE",
    "dropmalcty": "COOS BAY",
    "dropmalst": "OR",
    "dropmalzpp": 974209981,
    "dropsitphn": 9712013788,
    "dropsitlph": 5412675122,
    "dropsitcph": 5418884021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ15007",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "1706 NW 24TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972102508,
    "dropphyadd": "1706 NW 24TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972102508,
    "dropmaladd": "1706 NW 24TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972109998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037210921,
    "dropsitcph": 5032281003,
    "dropfax": 5032222806
  },
  {
    "dcode": "D",
    "dropkey": "SZ15103",
    "droptype": "D",
    "dropname": "HOLLADAY PARK",
    "dropdeladd": "815 NE SCHUYLER ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972124039,
    "dropphyadd": "815 NE SCHUYLER ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972124039,
    "dropmaladd": "815 NE SCHUYLER ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972129998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032800836,
    "dropsitcph": 5032820950,
    "dropfax": 5032498738
  },
  {
    "dcode": "D",
    "dropkey": "SZ15105",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "1050 SUNNYVIEW RD NE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973010643,
    "dropphyadd": "1050 SUNNYVIEW RD NE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973010643,
    "dropmaladd": "1050 SUNNYVIEW RD NE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973010643,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033704771,
    "dropsitcph": 5033712839,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": "SZ15157",
    "droptype": "D",
    "dropname": "KENTON",
    "dropdeladd": "2130 N KILPATRICK ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972176819,
    "dropphyadd": "2130 N KILPATRICK ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972176819,
    "dropmaladd": "2130 N KILPATRICK ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972179998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032899788,
    "dropsitcph": 5037359816,
    "dropfax": 5032830703
  },
  {
    "dcode": "D",
    "dropkey": "SZ15178",
    "droptype": "D",
    "dropname": "LAKE GROVE",
    "dropdeladd": "15875 BOONES FERRY RD",
    "dropdelcty": "LAKE GROVE",
    "dropdelst": "OR",
    "dropdelzpp": 970353401,
    "dropphyadd": "15875 BOONES FERRY RD",
    "dropphycty": "LAKE GROVE",
    "dropphyst": "OR",
    "dropphyzpp": 970353401,
    "dropmaladd": "15875 BOONES FERRY RD",
    "dropmalcty": "LAKE GROVE",
    "dropmalst": "OR",
    "dropmalzpp": 970359998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036353452,
    "dropsitcph": 5036992176,
    "dropfax": 5036358302
  },
  {
    "dcode": "D",
    "dropkey": "SZ15300",
    "droptype": "D",
    "dropname": "MULTNOMAH",
    "dropdeladd": "7805 SW 40TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972191643,
    "dropphyadd": "7805 SW 40TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972191643,
    "dropmaladd": "7805 SW 40TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972199998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032933118,
    "dropsitcph": 5034523112,
    "dropfax": 5032456066
  },
  {
    "dcode": "D",
    "dropkey": "SZ15385",
    "droptype": "D",
    "dropname": "PARKROSE",
    "dropdeladd": "4048 NE 122ND AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972301335,
    "dropphyadd": "4048 NE 122ND AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972301335,
    "dropmaladd": "4048 NE 122ND AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972309998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032540687,
    "dropsitcph": 5032510652,
    "dropfax": 5032557338
  },
  {
    "dcode": "D",
    "dropkey": "SZ15395",
    "droptype": "D",
    "dropname": "PIEDMONT",
    "dropdeladd": "630 NE KILLINGSWORTH ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972113857,
    "dropphyadd": "630 NE KILLINGSWORTH ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972113857,
    "dropmaladd": "630 NE KILLINGSWORTH ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972119998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032871868,
    "dropsitcph": 5032825025,
    "dropfax": 5032490145
  },
  {
    "dcode": "D",
    "dropkey": "SZ15421",
    "droptype": "D",
    "dropname": "PRINGLE PARK",
    "dropdeladd": "410 MILL ST SE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973013601,
    "dropphyadd": "410 MILL ST SE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973013601,
    "dropmaladd": "410 MILL ST SE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973013601,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033631130,
    "dropsitcph": 5033617881,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": "SZ15463",
    "droptype": "D",
    "dropname": "ROSE CITY PARK",
    "dropdeladd": "2425 NE 50TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972132515,
    "dropphyadd": "2425 NE 50TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972132515,
    "dropmaladd": "2425 NE 50TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972139998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032824761,
    "dropsitcph": 5032824761,
    "dropfax": 5032490180
  },
  {
    "dcode": "D",
    "dropkey": "SZ15475",
    "droptype": "D",
    "dropname": "SAINT JOHNS",
    "dropdeladd": "8420 N IVANHOE ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972034826,
    "dropphyadd": "8420 N IVANHOE ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972034826,
    "dropmaladd": "8420 N IVANHOE ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972039998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032861033,
    "dropsitcph": 5032837952,
    "dropfax": 5032832230
  },
  {
    "dcode": "D",
    "dropkey": "SZ15496",
    "droptype": "D",
    "dropname": "SELLWOOD",
    "dropdeladd": "6723 SE 16TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972025706,
    "dropphyadd": "6723 SE 16TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972025706,
    "dropmaladd": "6723 SE 16TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972025706,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032353659,
    "dropsitcph": 5032343246,
    "dropfax": 5032319630
  },
  {
    "dcode": "D",
    "dropkey": "SZ15526",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "30 E 33RD AVE",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974053819,
    "dropphyadd": "30 E 33RD AVE",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974053819,
    "dropmaladd": "30 E 33RD AVE",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974059998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413665,
    "dropsitcph": 5413499774,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ15689",
    "droptype": "D",
    "dropname": "VISTA",
    "dropdeladd": "3624 COMMERCIAL ST SE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973023831,
    "dropphyadd": "3624 COMMERCIAL ST SE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973023831,
    "dropmaladd": "3624 COMMERCIAL ST SE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973029998,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5033636993,
    "dropfax": 5035817021
  },
  {
    "dcode": "D",
    "dropkey": "SZ15722",
    "droptype": "D",
    "dropname": "WEST SALEM",
    "dropdeladd": "400 GLEN CREEK RD NW",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973043060,
    "dropphyadd": "400 GLEN CREEK RD NW",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973043060,
    "dropmaladd": "400 GLEN CREEK RD NW",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973043060,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033711236,
    "dropsitcph": 5033711236,
    "dropfax": 5035817906
  },
  {
    "dcode": "D",
    "dropkey": "SZ15727",
    "droptype": "D",
    "dropname": "WEST SLOPE",
    "dropdeladd": "3225 SW 87TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972253407,
    "dropphyadd": "3225 SW 87TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972253407,
    "dropmaladd": "3225 SW 87TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972259998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032923424,
    "dropsitcph": 5032038705,
    "dropfax": 5032971098
  },
  {
    "dcode": "D",
    "dropkey": "SZ15735",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "950 TYINN ST",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974022754,
    "dropphyadd": "950 TYINN ST",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974022754,
    "dropmaladd": "950 TYINN ST",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974022754,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413653,
    "dropsitcph": 5413444345,
    "dropfax": 5416834012
  },
  {
    "dcode": "D",
    "dropkey": "SZ15780",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "320 N 3700 W",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841222201,
    "dropphyadd": "320 N 3700 W",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841222201,
    "dropmaladd": "PO BOX 22062",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841220062,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013590065,
    "dropsitcph": 8013590089,
    "dropfax": 8013593542
  },
  {
    "dcode": "D",
    "dropkey": "SZ15809",
    "droptype": "D",
    "dropname": "BEN LOMOND",
    "dropdeladd": "221 N WASHINGTON BLVD",
    "dropdelcty": "OGDEN",
    "dropdelst": "UT",
    "dropdelzpp": 844049998,
    "dropphyadd": "221 N WASHINGTON BLVD",
    "dropphycty": "OGDEN",
    "dropphyst": "UT",
    "dropphyzpp": 844049998,
    "dropmaladd": "221 N WASHINGTON BLVD",
    "dropmalcty": "OGDEN",
    "dropmalst": "UT",
    "dropmalzpp": 844049998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8016121807,
    "dropsitcph": 8016121806,
    "dropfax": 8013927064
  },
  {
    "dcode": "D",
    "dropkey": "SZ15949",
    "droptype": "D",
    "dropname": "DOWNTOWN SALT LAKE CITY",
    "dropdeladd": "230 W 200 S LBBY",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841011342,
    "dropphyadd": "230 W 200 S LBBY",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841011342,
    "dropmaladd": "386 W 500 S STE 20",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841019998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013591060,
    "dropsitcph": 8015325501,
    "dropfax": 8015338348
  },
  {
    "dcode": "D",
    "dropkey": "SZ15958",
    "droptype": "D",
    "dropname": "PROVO PO",
    "dropdeladd": "936 S 250 E",
    "dropdelcty": "PROVO",
    "dropdelst": "UT",
    "dropdelzpp": 846069998,
    "dropphyadd": "936 S 250 E",
    "dropphycty": "PROVO",
    "dropphyst": "UT",
    "dropphyzpp": 846069998,
    "dropmaladd": "PO BOX 59998",
    "dropmalcty": "PROVO",
    "dropmalst": "UT",
    "dropmalzpp": 846059998,
    "dropsitphn": 8013562212,
    "dropsitlph": 8013562212,
    "dropsitcph": 8013562212,
    "dropfax": 8013772301
  },
  {
    "dcode": "D",
    "dropkey": "SZ15994",
    "droptype": "D",
    "dropname": "FOOTHILL",
    "dropdeladd": "2255 E SUNNYSIDE AVE",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841089998,
    "dropphyadd": "2255 E SUNNYSIDE AVE",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841089998,
    "dropmaladd": "2255 E SUNNYSIDE AVE",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841089998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8015833652,
    "dropsitcph": 8015833652,
    "dropfax": 8014672723
  },
  {
    "dcode": "D",
    "dropkey": "SZ16001",
    "droptype": "D",
    "dropname": "FREEPORT CENTER",
    "dropdeladd": "391 E 1700 S",
    "dropdelcty": "CLEARFIELD",
    "dropdelst": "UT",
    "dropdelzpp": 840152300,
    "dropphyadd": "391 E 1700 S",
    "dropphycty": "CLEARFIELD",
    "dropphyst": "UT",
    "dropphyzpp": 840152300,
    "dropmaladd": "PO BOX 169998",
    "dropmalcty": "CLEARFIELD",
    "dropmalst": "UT",
    "dropmalzpp": 840169998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8017799582,
    "dropsitcph": 8017792347,
    "dropfax": 8018259804
  },
  {
    "dcode": "D",
    "dropkey": "SZ16187",
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "801 N REDWOOD RD",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841169998,
    "dropphyadd": "801 N REDWOOD RD",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841169998,
    "dropmaladd": "801 N REDWOOD RD",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841169998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013596944,
    "dropsitcph": 8013596944,
    "dropfax": 8013643115
  },
  {
    "dcode": "D",
    "dropkey": "SZ16302",
    "droptype": "D",
    "dropname": "SUGARHOUSE",
    "dropdeladd": "1953 S 1100 E",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841069998,
    "dropphyadd": "1953 S 1100 E",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841069998,
    "dropmaladd": "1953 S 1100 E",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841069998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014857929,
    "dropsitcph": 8014857814,
    "dropfax": 8014857925
  },
  {
    "dcode": "D",
    "dropkey": "SZ16327",
    "droptype": "D",
    "dropname": "TOWN",
    "dropdeladd": "2730 WASHINGTON BLVD",
    "dropdelcty": "OGDEN",
    "dropdelst": "UT",
    "dropdelzpp": 844018001,
    "dropphyadd": "2730 WASHINGTON BLVD",
    "dropphycty": "OGDEN",
    "dropphyst": "UT",
    "dropphyzpp": 844018001,
    "dropmaladd": "PO BOX 29998",
    "dropmalcty": "OGDEN",
    "dropmalst": "UT",
    "dropmalzpp": 844029998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8016274521,
    "dropsitcph": 8013347382,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ16428",
    "droptype": "D",
    "dropname": "ALDERWOOD MANOR",
    "dropdeladd": "3715 196TH ST SW STE 101",
    "dropdelcty": "LYNNWOOD",
    "dropdelst": "WA",
    "dropdelzpp": 980369997,
    "dropphyadd": "3715 196TH ST SW STE 101",
    "dropphycty": "LYNNWOOD",
    "dropphyst": "WA",
    "dropphyzpp": 980369997,
    "dropmaladd": "3715 196TH ST SW STE 101",
    "dropmalcty": "LYNNWOOD",
    "dropmalst": "WA",
    "dropmalzpp": 980369997,
    "dropsitphn": 2067684422,
    "dropsitlph": 4257763137,
    "dropsitcph": 4257783447,
    "dropfax": 6514566204
  },
  {
    "dcode": "D",
    "dropkey": "SZ16462",
    "droptype": "D",
    "dropname": "TWIN LAKES AUBURN",
    "dropdeladd": "1815 SW CAMPUS DR",
    "dropdelcty": "FEDERAL WAY",
    "dropdelst": "WA",
    "dropdelzpp": 980239998,
    "dropphyadd": "1815 SW CAMPUS DR",
    "dropphycty": "FEDERAL WAY",
    "dropphyst": "WA",
    "dropphyzpp": 980239998,
    "dropmaladd": "1815 SW CAMPUS DR",
    "dropmalcty": "FEDERAL WAY",
    "dropmalst": "WA",
    "dropmalzpp": 980239998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2536613504,
    "dropsitcph": 2539524563,
    "dropfax": 6514566278
  },
  {
    "dcode": "D",
    "dropkey": "SZ16468",
    "droptype": "D",
    "dropname": "BAINBRIDGE IS",
    "dropdeladd": "271 WINSLOW WAY E",
    "dropdelcty": "BAINBRIDGE ISLAND",
    "dropdelst": "WA",
    "dropdelzpp": 981109997,
    "dropphyadd": "271 WINSLOW WAY E",
    "dropphycty": "BAINBRIDGE ISLAND",
    "dropphyst": "WA",
    "dropphyzpp": 981109997,
    "dropmaladd": "271 WINSLOW WAY E",
    "dropmalcty": "BAINBRIDGE ISLAND",
    "dropmalst": "WA",
    "dropmalzpp": 981109997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2068426133,
    "dropsitcph": 2068559571,
    "dropfax": 6514566579
  },
  {
    "dcode": "D",
    "dropkey": "SZ16472",
    "droptype": "D",
    "dropname": "BALLARD",
    "dropdeladd": "5706 17TH AVE NW",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981079998,
    "dropphyadd": "5706 17TH AVE NW",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981079998,
    "dropmaladd": "5706 17TH AVE NW",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981079998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067897695,
    "dropsitcph": 2067814656,
    "dropfax": 6514566581
  },
  {
    "dcode": "D",
    "dropkey": "SZ16475",
    "droptype": "D",
    "dropname": "BANGOR SUBMARINE BASE",
    "dropdeladd": "2650 OHIO ST",
    "dropdelcty": "SILVERDALE",
    "dropdelst": "WA",
    "dropdelzpp": 983159998,
    "dropphyadd": "2650 OHIO ST",
    "dropphycty": "SILVERDALE",
    "dropphyst": "WA",
    "dropphyzpp": 983159998,
    "dropmaladd": "2650 OHIO ST",
    "dropmalcty": "SILVERDALE",
    "dropmalst": "WA",
    "dropmalzpp": 983159998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606924760,
    "dropsitcph": 3607793152,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ16506",
    "droptype": "D",
    "dropname": "BITTER LAKE",
    "dropdeladd": "929 N 145TH ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981339998,
    "dropphyadd": "929 N 145TH ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981339998,
    "dropmaladd": "929 N 145TH ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981339998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2063624782,
    "dropsitcph": 2063640663,
    "dropfax": 6514566587
  },
  {
    "dcode": "D",
    "dropkey": "SZ16547",
    "droptype": "D",
    "dropname": "BURIEN",
    "dropdeladd": "609 SW 150TH ST",
    "dropdelcty": "BURIEN",
    "dropdelst": "WA",
    "dropdelzpp": 981669998,
    "dropphyadd": "609 SW 150TH ST",
    "dropphycty": "BURIEN",
    "dropphyst": "WA",
    "dropphyzpp": 981669998,
    "dropmaladd": "609 SW 150TH ST",
    "dropmalcty": "BURIEN",
    "dropmalst": "WA",
    "dropmalzpp": 981669998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062420496,
    "dropsitcph": 2062488647,
    "dropfax": 6514566594
  },
  {
    "dcode": "D",
    "dropkey": "SZ16584",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "112 S 3RD ST",
    "dropdelcty": "YAKIMA",
    "dropdelst": "WA",
    "dropdelzpp": 989019998,
    "dropphyadd": "112 S 3RD ST",
    "dropphycty": "YAKIMA",
    "dropphyst": "WA",
    "dropphyzpp": 989019998,
    "dropmaladd": "112 S 3RD ST",
    "dropmalcty": "YAKIMA",
    "dropmalst": "WA",
    "dropmalzpp": 989019998,
    "dropsitphn": 2067684422,
    "dropsitlph": 5095778381,
    "dropsitcph": 5092251389,
    "dropfax": 6514566597
  },
  {
    "dcode": "D",
    "dropkey": "SZ16605",
    "droptype": "D",
    "dropname": "CITY CENTER",
    "dropdeladd": "104 W MAGNOLIA ST STE 100",
    "dropdelcty": "BELLINGHAM",
    "dropdelst": "WA",
    "dropdelzpp": 982259997,
    "dropphyadd": "104 W MAGNOLIA ST STE 100",
    "dropphycty": "BELLINGHAM",
    "dropphyst": "WA",
    "dropphyzpp": 982259997,
    "dropmaladd": "104 W MAGNOLIA ST STE 100",
    "dropmalcty": "BELLINGHAM",
    "dropmalst": "WA",
    "dropmalzpp": 982259997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607346630,
    "dropsitcph": 3607529822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ16662",
    "droptype": "D",
    "dropname": "CROSSROADS",
    "dropdeladd": "15731 NE 8TH ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "WA",
    "dropdelzpp": 980089998,
    "dropphyadd": "15731 NE 8TH ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "WA",
    "dropphyzpp": 980089998,
    "dropmaladd": "15731 NE 8TH ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "WA",
    "dropmalzpp": 980089998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254494050,
    "dropsitcph": 4254010892,
    "dropfax": 6514566162
  },
  {
    "dcode": "D",
    "dropkey": "SZ16687",
    "droptype": "D",
    "dropname": "DES MOINES",
    "dropdeladd": "2003 S 216TH ST",
    "dropdelcty": "DES MOINES",
    "dropdelst": "WA",
    "dropdelzpp": 981989998,
    "dropphyadd": "2003 S 216TH ST",
    "dropphycty": "DES MOINES",
    "dropphyst": "WA",
    "dropphyzpp": 981989998,
    "dropmaladd": "2003 S 216TH ST",
    "dropmalcty": "DES MOINES",
    "dropmalst": "WA",
    "dropmalzpp": 981989998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2068781246,
    "dropsitcph": 2068243647,
    "dropfax": 6514566163
  },
  {
    "dcode": "D",
    "dropkey": "SZ16704",
    "droptype": "D",
    "dropname": "DOWNTOWN KENT",
    "dropdeladd": "216 W GOWE ST",
    "dropdelcty": "KENT",
    "dropdelst": "WA",
    "dropdelzpp": 980329997,
    "dropphyadd": "216 W GOWE ST",
    "dropphycty": "KENT",
    "dropphyst": "WA",
    "dropphyzpp": 980329997,
    "dropmaladd": "216 W GOWE ST",
    "dropmalcty": "KENT",
    "dropmalst": "WA",
    "dropmalzpp": 980329997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538521049,
    "dropsitcph": 2538521049,
    "dropfax": 2538501789
  },
  {
    "dcode": "D",
    "dropkey": "SZ16705",
    "droptype": "D",
    "dropname": "DOWNTOWN TACOMA",
    "dropdeladd": "1102 A ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984029998,
    "dropphyadd": "1102 A ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984029998,
    "dropmaladd": "1102 A ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984029998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2536278247,
    "dropsitcph": 2536274026,
    "dropfax": 6505783825
  },
  {
    "dcode": "D",
    "dropkey": "SZ16706",
    "droptype": "D",
    "dropname": "DOWNTOWN VANCOUVER",
    "dropdeladd": "1211 DANIELS ST",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986660700,
    "dropphyadd": "1211 DANIELS ST",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986660700,
    "dropmaladd": "1211 DANIELS ST",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986669998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3606960843,
    "dropsitcph": 3609925000,
    "dropfax": 3607372364
  },
  {
    "dcode": "D",
    "dropkey": "SZ16766",
    "droptype": "D",
    "dropname": "EVERGREEN",
    "dropdeladd": "4001 S PINE ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984139994,
    "dropphyadd": "4001 S PINE ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984139994,
    "dropmaladd": "PO BOX 119998",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984119998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2534716034,
    "dropsitcph": 2534715384,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ16787",
    "droptype": "D",
    "dropname": "FEDERAL WAY",
    "dropdeladd": "32829 PACIFIC HWY S",
    "dropdelcty": "FEDERAL WAY",
    "dropdelst": "WA",
    "dropdelzpp": 980039998,
    "dropphyadd": "32829 PACIFIC HWY S",
    "dropphycty": "FEDERAL WAY",
    "dropphyst": "WA",
    "dropphyzpp": 980039998,
    "dropmaladd": "32829 PACIFIC HWY S",
    "dropmalcty": "FEDERAL WAY",
    "dropmalst": "WA",
    "dropmalzpp": 980039998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2538387778,
    "dropsitcph": 2539278101,
    "dropfax": 6514566174
  },
  {
    "dcode": "D",
    "dropkey": "SZ16836",
    "droptype": "D",
    "dropname": "GEORGETOWN",
    "dropdeladd": "620 S ORCAS ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981089998,
    "dropphyadd": "620 S ORCAS ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981089998,
    "dropmaladd": "620 S ORCAS ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981089998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067639711,
    "dropsitcph": 2067649565,
    "dropfax": 6514566179
  },
  {
    "dcode": "D",
    "dropkey": "SZ16875",
    "droptype": "D",
    "dropname": "GREENWOOD",
    "dropdeladd": "8306 GREENWOOD AVE N",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981039997,
    "dropphyadd": "8306 GREENWOOD AVE N",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981039997,
    "dropmaladd": "8306 GREENWOOD AVE N",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981039997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067890651,
    "dropsitcph": 2065471406,
    "dropfax": 2065489103
  },
  {
    "dcode": "D",
    "dropkey": "SZ16898",
    "droptype": "D",
    "dropname": "HAYS PARK",
    "dropdeladd": "3910 N CRESTLINE ST",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992079998,
    "dropphyadd": "3910 N CRESTLINE ST",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992079998,
    "dropmaladd": "3910 N CRESTLINE ST",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992079998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094824835,
    "dropsitcph": 5094824835,
    "dropfax": 6514566186
  },
  {
    "dcode": "D",
    "dropkey": "SZ16907",
    "droptype": "D",
    "dropname": "HIGHLANDS",
    "dropdeladd": "4301 NE 4TH ST",
    "dropdelcty": "RENTON",
    "dropdelst": "WA",
    "dropdelzpp": 980599998,
    "dropphyadd": "4301 NE 4TH ST",
    "dropphycty": "RENTON",
    "dropphyst": "WA",
    "dropphyzpp": 980599998,
    "dropmaladd": "4301 NE 4TH ST",
    "dropmalcty": "RENTON",
    "dropmalst": "WA",
    "dropmalzpp": 980599998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252270288,
    "dropsitcph": 4252276304,
    "dropfax": 6514566187
  },
  {
    "dcode": "D",
    "dropkey": "SZ16910",
    "droptype": "D",
    "dropname": "HILLYARD",
    "dropdeladd": "4401 N FREYA ST",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992176804,
    "dropphyadd": "4401 N FREYA ST",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992176804,
    "dropmaladd": "4401 N FREYA ST",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992176804,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522327,
    "dropsitcph": 5094824581,
    "dropfax": 6514566188
  },
  {
    "dcode": "D",
    "dropkey": "SZ17003",
    "droptype": "D",
    "dropname": "LAKE CITY",
    "dropdeladd": "3019 NE 127TH ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981259998,
    "dropphyadd": "3019 NE 127TH ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981259998,
    "dropmaladd": "3019 NE 127TH ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981259998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2063624793,
    "dropsitcph": 2063640608,
    "dropfax": 6514566197
  },
  {
    "dcode": "D",
    "dropkey": "SZ17033",
    "droptype": "D",
    "dropname": "LIBERTY PARK",
    "dropdeladd": "1602 E SPRAGUE AVE",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992029998,
    "dropphyadd": "1602 E SPRAGUE AVE",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992029998,
    "dropmaladd": "1602 E SPRAGUE AVE",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992029998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522329,
    "dropsitcph": 5095329352,
    "dropfax": 6514566201
  },
  {
    "dcode": "D",
    "dropkey": "SZ17069",
    "droptype": "D",
    "dropname": "MAGNOLIA",
    "dropdeladd": "3211 W MCGRAW ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981999998,
    "dropphyadd": "3211 W MCGRAW ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981999998,
    "dropmaladd": "3211 W MCGRAW ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981999998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062828584,
    "dropsitcph": 2062845958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ17070",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "301 UNION ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981019998,
    "dropphyadd": "301 UNION ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981019998,
    "dropmaladd": "301 UNION ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981019998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067485443,
    "dropsitcph": 2067485417,
    "dropfax": 6514566191
  },
  {
    "dcode": "D",
    "dropkey": "SZ17083",
    "droptype": "D",
    "dropname": "MANITO",
    "dropdeladd": "3120 S GRAND BLVD",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992039998,
    "dropphyadd": "3120 S GRAND BLVD",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992039998,
    "dropmaladd": "3120 S GRAND BLVD",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992039998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522335,
    "dropsitcph": 5098384092,
    "dropfax": 6514566205
  },
  {
    "dcode": "D",
    "dropkey": "SZ17102",
    "droptype": "D",
    "dropname": "MARTIN LUTHER KING JR",
    "dropdeladd": "1220 MARTIN LUTHER KING JR WAY",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984059997,
    "dropphyadd": "1220 MARTIN LUTHER KING JR WAY",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984059997,
    "dropmaladd": "1220 MARTIN LUTHER KING JR WAY",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984059997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2532723082,
    "dropsitcph": 2532723082,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ17140",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "23406 PACIFIC HWY S STE 106",
    "dropdelcty": "KENT",
    "dropdelst": "WA",
    "dropdelzpp": 980329996,
    "dropphyadd": "23406 PACIFIC HWY S STE 106",
    "dropphycty": "KENT",
    "dropphyst": "WA",
    "dropphyzpp": 980329996,
    "dropmaladd": "23406 PACIFIC HWY S STE 106",
    "dropmalcty": "KENT",
    "dropmalst": "WA",
    "dropmalzpp": 980329996,
    "dropsitphn": 2067684422,
    "dropsitlph": 2068786871,
    "dropsitcph": 2068786871,
    "dropfax": 2538243512
  },
  {
    "dcode": "D",
    "dropkey": "SZ17209",
    "droptype": "D",
    "dropname": "NORTHGATE",
    "dropdeladd": "11036 8TH AVE NE",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981259997,
    "dropphyadd": "11036 8TH AVE NE",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981259997,
    "dropmaladd": "11036 8TH AVE NE",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981259997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2063637556,
    "dropsitcph": 2063640546,
    "dropfax": 2063689270
  },
  {
    "dcode": "D",
    "dropkey": "SZ17240",
    "droptype": "D",
    "dropname": "SPOKANE VALLEY",
    "dropdeladd": "11712 E SPRAGUE AVE",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 992069998,
    "dropphyadd": "11712 E SPRAGUE AVE",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 992069998,
    "dropmaladd": "11712 E SPRAGUE AVE",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 992069998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522324,
    "dropsitcph": 5098917168,
    "dropfax": 6514566268
  },
  {
    "dcode": "D",
    "dropkey": "SZ17270",
    "droptype": "D",
    "dropname": "PARKWATER",
    "dropdeladd": "2020 N DICKEY RD",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 992121277,
    "dropphyadd": "2020 N DICKEY RD",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 992121277,
    "dropmaladd": "PO BOX 11000",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992119998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5095335306,
    "dropsitcph": 5095335306,
    "dropfax": 5095369105
  },
  {
    "dcode": "D",
    "dropkey": "SZ17313",
    "droptype": "D",
    "dropname": "PROCTOR",
    "dropdeladd": "3801 N 27TH ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984079998,
    "dropphyadd": "3801 N 27TH ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984079998,
    "dropmaladd": "3801 N 27TH ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984079998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2537592851,
    "dropsitcph": 2537597701,
    "dropfax": 6514566238
  },
  {
    "dcode": "D",
    "dropkey": "SZ17337",
    "droptype": "D",
    "dropname": "QUEEN ANNE",
    "dropdeladd": "415 1ST AVE N",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981094503,
    "dropphyadd": "415 1ST AVE N",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981094503,
    "dropmaladd": "415 1ST AVE N",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981094503,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062820544,
    "dropsitcph": 2062820544,
    "dropfax": 6505783055
  },
  {
    "dcode": "D",
    "dropkey": "SZ17358",
    "droptype": "D",
    "dropname": "DOWNTOWN RENTON",
    "dropdeladd": "314 WILLIAMS AVE S",
    "dropdelcty": "RENTON",
    "dropdelst": "WA",
    "dropdelzpp": 980579798,
    "dropphyadd": "314 WILLIAMS AVE S",
    "dropphycty": "RENTON",
    "dropphyst": "WA",
    "dropphyzpp": 980579798,
    "dropmaladd": "314 WILLIAMS AVE S",
    "dropmalcty": "RENTON",
    "dropmalst": "WA",
    "dropmalzpp": 980579798,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252553090,
    "dropsitcph": 4252553090,
    "dropfax": 6514566254
  },
  {
    "dcode": "D",
    "dropkey": "SZ17372",
    "droptype": "D",
    "dropname": "RIVERSIDE",
    "dropdeladd": "904 W RIVERSIDE AVE",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992019931,
    "dropphyadd": "904 W RIVERSIDE AVE",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992019931,
    "dropmaladd": "904 W RIVERSIDE AVE",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992019931,
    "dropsitphn": 5093636210,
    "dropsitlph": 5092522346,
    "dropsitcph": 5092522337,
    "dropfax": 5098386683
  },
  {
    "dcode": "D",
    "dropkey": "SZ17375",
    "droptype": "D",
    "dropname": "RIVERTON HEIGHTS",
    "dropdeladd": "15250 32ND AVE S",
    "dropdelcty": "SEATAC",
    "dropdelst": "WA",
    "dropdelzpp": 981889998,
    "dropphyadd": "15250 32ND AVE S",
    "dropphycty": "SEATAC",
    "dropphyst": "WA",
    "dropphyzpp": 981889998,
    "dropmaladd": "15250 32ND AVE S",
    "dropmalcty": "SEATAC",
    "dropmalst": "WA",
    "dropmalzpp": 981889998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062423522,
    "dropsitcph": 2062417061,
    "dropfax": 6514566249
  },
  {
    "dcode": "D",
    "dropkey": "SZ17422",
    "droptype": "D",
    "dropname": "SEAFIRST",
    "dropdeladd": "1001 4TH AVE STE 25",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981549998,
    "dropphyadd": "1001 4TH AVE STE 25",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981549998,
    "dropmaladd": "1001 4TH AVE STE 25",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981549998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066823958,
    "dropsitcph": 2067485417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ17440",
    "droptype": "D",
    "dropname": "SHADLE GARLAND",
    "dropdeladd": "1903 W GARLAND AVE",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992059998,
    "dropphyadd": "1903 W GARLAND AVE",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992059998,
    "dropmaladd": "1903 W GARLAND AVE",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992059998,
    "dropsitphn": 5063636210,
    "dropsitlph": 5092522367,
    "dropsitcph": 5092522367,
    "dropfax": 6514566258
  },
  {
    "dcode": "D",
    "dropkey": "SZ17444",
    "droptype": "D",
    "dropname": "SHERIDAN PARK",
    "dropdeladd": "1281 SYLVAN WAY",
    "dropdelcty": "BREMERTON",
    "dropdelst": "WA",
    "dropdelzpp": 983109997,
    "dropphyadd": "1281 SYLVAN WAY",
    "dropphycty": "BREMERTON",
    "dropphyst": "WA",
    "dropphyzpp": 983109997,
    "dropmaladd": "1281 SYLVAN WAY",
    "dropmalcty": "BREMERTON",
    "dropmalst": "WA",
    "dropmalzpp": 983109997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603739665,
    "dropsitcph": 3603739665,
    "dropfax": 6514566260
  },
  {
    "dcode": "D",
    "dropkey": "SZ17462",
    "droptype": "D",
    "dropname": "SKYWAY",
    "dropdeladd": "7633 S 126TH ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981789998,
    "dropphyadd": "7633 S 126TH ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981789998,
    "dropmaladd": "7633 S 126TH ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981789998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067721860,
    "dropsitcph": 2067721860,
    "dropfax": 6514566263
  },
  {
    "dcode": "D",
    "dropkey": "SZ17464",
    "droptype": "D",
    "dropname": "SMOKEY POINT",
    "dropdeladd": "3609 168TH ST NE",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 982239997,
    "dropphyadd": "3609 168TH ST NE",
    "dropphycty": "ARLINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 982239997,
    "dropmaladd": "3609 168TH ST NE",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 982239997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3606598572,
    "dropsitcph": 3606589788,
    "dropfax": 6514566264
  },
  {
    "dcode": "D",
    "dropkey": "SZ17486",
    "droptype": "D",
    "dropname": "SOUTH TACOMA",
    "dropdeladd": "3503 S 56TH ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984099997,
    "dropphyadd": "3503 S 56TH ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984099997,
    "dropmaladd": "3503 S 56TH ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984099997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2534746685,
    "dropsitcph": 2534746885,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ17574",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "3705 S G ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984189997,
    "dropphyadd": "3705 S G ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984189997,
    "dropmaladd": "3705 S G ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984189997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2534761251,
    "dropsitcph": 2534761251,
    "dropfax": 6514566202
  },
  {
    "dcode": "D",
    "dropkey": "SZ17611",
    "droptype": "D",
    "dropname": "TERMINAL",
    "dropdeladd": "2420 4TH AVE S",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981349998,
    "dropphyadd": "2420 4TH AVE S",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981349998,
    "dropmaladd": "2420 4TH AVE S",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981349998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066525440,
    "dropsitcph": 2066522467,
    "dropfax": 6514566274
  },
  {
    "dcode": "D",
    "dropkey": "SZ17639",
    "droptype": "D",
    "dropname": "TUKWILA",
    "dropdeladd": "225 ANDOVER PARK W",
    "dropdelcty": "TUKWILA",
    "dropdelst": "WA",
    "dropdelzpp": 981889997,
    "dropphyadd": "225 ANDOVER PARK W",
    "dropphycty": "TUKWILA",
    "dropphyst": "WA",
    "dropphyzpp": 981889997,
    "dropmaladd": "225 ANDOVER PARK W",
    "dropmalcty": "TUKWILA",
    "dropmalst": "WA",
    "dropmalzpp": 981889997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062437079,
    "dropsitcph": 2062449592,
    "dropfax": 6514566277
  },
  {
    "dcode": "D",
    "dropkey": "SZ17656",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "4244 UNIVERSITY WAY NE",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981059998,
    "dropphyadd": "4244 UNIVERSITY WAY NE",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981059998,
    "dropmaladd": "4244 UNIVERSITY WAY NE",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981059998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066330736,
    "dropsitcph": 2066758114,
    "dropfax": 6514566280
  },
  {
    "dcode": "D",
    "dropkey": "SZ17687",
    "droptype": "D",
    "dropname": "WALLINGFORD",
    "dropdeladd": "1329 N 47TH ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981039998,
    "dropphyadd": "1329 N 47TH ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981039998,
    "dropmaladd": "1329 N 47TH ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981039998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066326618,
    "dropsitcph": 2065471406,
    "dropfax": 6514566284
  },
  {
    "dcode": "D",
    "dropkey": "SZ17706",
    "droptype": "D",
    "dropname": "WEDGWOOD",
    "dropdeladd": "7724 35TH AVE NE",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981159998,
    "dropphyadd": "7724 35TH AVE NE",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981159998,
    "dropmaladd": "7724 35TH AVE NE",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981159998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2065220480,
    "dropsitcph": 2065278896,
    "dropfax": 6514566285
  },
  {
    "dcode": "D",
    "dropkey": "SZ17716",
    "droptype": "D",
    "dropname": "WEST SEATTLE",
    "dropdeladd": "4412 CALIFORNIA AVE SW",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981169998,
    "dropphyadd": "4412 CALIFORNIA AVE SW",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981169998,
    "dropmaladd": "4412 CALIFORNIA AVE SW",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981169998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2069330358,
    "dropsitcph": 2069230485,
    "dropfax": 6514566289
  },
  {
    "dcode": "D",
    "dropkey": "SZ17725",
    "droptype": "D",
    "dropname": "WESTWOOD",
    "dropdeladd": "2721 SW TRENTON ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981269998,
    "dropphyadd": "2721 SW TRENTON ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981269998,
    "dropmaladd": "2721 SW TRENTON ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2069356051,
    "dropsitcph": 2069387769,
    "dropfax": 6514566290
  },
  {
    "dcode": "D",
    "dropkey": "SZ17797",
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW",
    "dropdeladd": "7959 N THORNYDALE RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857419998,
    "dropphyadd": "7959 N THORNYDALE RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857419998,
    "dropmaladd": "7959 N THORNYDALE RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857419998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207447097,
    "dropsitcph": 5207446720,
    "dropfax": 5205799561
  },
  {
    "dcode": "D",
    "dropkey": "SZ17798",
    "droptype": "D",
    "dropname": "RIVER ROAD",
    "dropdeladd": "255 RIVER AVE",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974042512,
    "dropphyadd": "255 RIVER AVE",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974042512,
    "dropmaladd": "255 RIVER AVE",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974042512,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413669,
    "dropsitcph": 5416881657,
    "dropfax": 5416886009
  },
  {
    "dcode": "D",
    "dropkey": "SZ17810",
    "droptype": "D",
    "dropname": "NANAKULI",
    "dropdeladd": "87-2070 FARRINGTON HWY STE J",
    "dropdelcty": "WAIANAE",
    "dropdelst": "HI",
    "dropdelzpp": 967923798,
    "dropphyadd": "87-2070 FARRINGTON HWY STE J",
    "dropphycty": "WAIANAE",
    "dropphyst": "HI",
    "dropphyzpp": 967923798,
    "dropmaladd": "87-2070 FARRINGTON HWY STE J",
    "dropmalcty": "WAIANAE",
    "dropmalst": "HI",
    "dropmalzpp": 967923798,
    "dropsitphn": 8084233844,
    "dropsitlph": 8086682006,
    "dropsitcph": 8086960161,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ17816",
    "droptype": "D",
    "dropname": "SCOTTSDALE FOUNTAIN HILLS",
    "dropdeladd": "16605 E AVENUE OF THE FOUNTAINS",
    "dropdelcty": "FOUNTAIN HILLS",
    "dropdelst": "AZ",
    "dropdelzpp": 852689998,
    "dropphyadd": "16605 E AVENUE OF THE FOUNTAINS",
    "dropphycty": "FOUNTAIN HILLS",
    "dropphyst": "AZ",
    "dropphyzpp": 852689998,
    "dropmaladd": "16605 E AVENUE OF THE FOUNTAINS",
    "dropmalcty": "FOUNTAIN HILLS",
    "dropmalst": "AZ",
    "dropmalzpp": 852689998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4808371432,
    "dropsitcph": 4808374812,
    "dropfax": 4808161659
  },
  {
    "dcode": "D",
    "dropkey": "SZ17827",
    "droptype": "D",
    "dropname": "MOUNT BAKER",
    "dropdeladd": "3150 ORLEANS ST",
    "dropdelcty": "BELLINGHAM",
    "dropdelst": "WA",
    "dropdelzpp": 982269998,
    "dropphyadd": "3150 ORLEANS ST",
    "dropphycty": "BELLINGHAM",
    "dropphyst": "WA",
    "dropphyzpp": 982269998,
    "dropmaladd": "3150 ORLEANS ST",
    "dropmalcty": "BELLINGHAM",
    "dropmalst": "WA",
    "dropmalzpp": 982269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607388959,
    "dropsitcph": 3607529825,
    "dropfax": 6514566218
  },
  {
    "dcode": "D",
    "dropkey": "SZ17842",
    "droptype": "D",
    "dropname": "TEMPE APACHE",
    "dropdeladd": "1962 E APACHE BLVD",
    "dropdelcty": "TEMPE",
    "dropdelst": "AZ",
    "dropdelzpp": 852819998,
    "dropphyadd": "1962 E APACHE BLVD",
    "dropphycty": "TEMPE",
    "dropphyst": "AZ",
    "dropphyzpp": 852819998,
    "dropmaladd": "1962 E APACHE BLVD",
    "dropmalcty": "TEMPE",
    "dropmalst": "AZ",
    "dropmalzpp": 852819998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809299407,
    "dropsitcph": 4809290180,
    "dropfax": 4809290204
  },
  {
    "dcode": "D",
    "dropkey": "SZ17846",
    "droptype": "D",
    "dropname": "PEAVINE",
    "dropdeladd": "1580 GRAND POINT WAY",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895239998,
    "dropphyadd": "1580 GRAND POINT WAY",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895239998,
    "dropmaladd": "1580 GRAND POINT WAY",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757464297,
    "dropsitcph": 7757468235,
    "dropfax": 7757465327
  },
  {
    "dcode": "D",
    "dropkey": "SZ17859",
    "droptype": "D",
    "dropname": "VISTA",
    "dropdeladd": "2929 VISTA BLVD",
    "dropdelcty": "SPARKS",
    "dropdelst": "NV",
    "dropdelzpp": 894348040,
    "dropphyadd": "2929 VISTA BLVD",
    "dropphycty": "SPARKS",
    "dropphyst": "NV",
    "dropphyzpp": 894348040,
    "dropmaladd": "2929 VISTA BLVD",
    "dropmalcty": "SPARKS",
    "dropmalst": "NV",
    "dropmalzpp": 894349998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7756262935,
    "dropsitcph": 7756265339,
    "dropfax": 7756265928
  },
  {
    "dcode": "D",
    "dropkey": "SZ17873",
    "droptype": "D",
    "dropname": "PEORIA DOWNTOWN",
    "dropdeladd": "10700 N 85TH AVE",
    "dropdelcty": "PEORIA",
    "dropdelst": "AZ",
    "dropdelzpp": 853459998,
    "dropphyadd": "10700 N 85TH AVE",
    "dropphycty": "PEORIA",
    "dropphyst": "AZ",
    "dropphyzpp": 853459998,
    "dropmaladd": "10700 N 85TH AVE",
    "dropmalcty": "PEORIA",
    "dropmalst": "AZ",
    "dropmalzpp": 853459998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6234864063,
    "dropsitcph": 6234864187,
    "dropfax": 6234128306
  },
  {
    "dcode": "D",
    "dropkey": "SZ17900",
    "droptype": "D",
    "dropname": "ROCKY MOUNTAIN",
    "dropdeladd": "8400 PENA BLVD",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802496325,
    "dropphyadd": "8400 PENA BLVD",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802496325,
    "dropmaladd": "8400 PENA BLVD",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802496325,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033718783,
    "dropsitcph": 3033425853,
    "dropfax": 3033427387
  },
  {
    "dcode": "D",
    "dropkey": "SZ17910",
    "droptype": "D",
    "dropname": "SUMMERLIN",
    "dropdeladd": "1611 SPRING GATE LN",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891349998,
    "dropphyadd": "1611 SPRING GATE LN",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891349998,
    "dropmaladd": "1611 SPRING GATE LN",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891349998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028698654,
    "dropsitcph": 7028698647,
    "dropfax": 7022285893
  },
  {
    "dcode": "D",
    "dropkey": "SZ17933",
    "droptype": "D",
    "dropname": "BOISE MAIN OFFICE",
    "dropdeladd": "770 S 13TH ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837089995,
    "dropphyadd": "770 S 13TH ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837089995,
    "dropmaladd": "770 S 13TH ST",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837089995,
    "dropsitphn": 2084334351,
    "dropsitlph": 2084334341,
    "dropsitcph": 2084334351,
    "dropfax": 2084334404
  },
  {
    "dcode": "D",
    "dropkey": "SZ17942",
    "droptype": "D",
    "dropname": "SILVERADO",
    "dropdeladd": "455 E PEBBLE RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891239998,
    "dropphyadd": "455 E PEBBLE RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891239998,
    "dropmaladd": "455 E PEBBLE RD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891239998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7029149672,
    "dropsitcph": 7029149670,
    "dropfax": 7029149680
  },
  {
    "dcode": "D",
    "dropkey": "SZ17989",
    "droptype": "D",
    "dropname": "COPPER HILL",
    "dropdeladd": "60 W GALENA ST",
    "dropdelcty": "BUTTE",
    "dropdelst": "MT",
    "dropdelzpp": 597011724,
    "dropphyadd": "60 W GALENA ST",
    "dropphycty": "BUTTE",
    "dropphyst": "MT",
    "dropphyzpp": 597011724,
    "dropmaladd": "60 W GALENA ST",
    "dropmalcty": "BUTTE",
    "dropmalst": "MT",
    "dropmalzpp": 597011724,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067230177,
    "dropsitcph": 4067230177,
    "dropfax": 4067230181
  },
  {
    "dcode": "D",
    "dropkey": "SZ17993",
    "droptype": "D",
    "dropname": "LENTS AT EASTPORT",
    "dropdeladd": "3850 SE 82ND AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972662999,
    "dropphyadd": "3850 SE 82ND AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972662999,
    "dropmaladd": "8100 SE CRYSTAL SPRINGS BLVD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972068599,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037741522,
    "dropsitcph": 5037741522,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18003",
    "droptype": "D",
    "dropname": "DOWNTOWN GREELEY",
    "dropdeladd": "925 11TH AVE",
    "dropdelcty": "GREELEY",
    "dropdelst": "CO",
    "dropdelzpp": 806319998,
    "dropphyadd": "925 11TH AVE",
    "dropphycty": "GREELEY",
    "dropphyst": "CO",
    "dropphyzpp": 806319998,
    "dropmaladd": "925 11TH AVE",
    "dropmalcty": "GREELEY",
    "dropmalst": "CO",
    "dropmalzpp": 806319998,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703537758,
    "dropsitcph": 9703922782,
    "dropfax": 9703537368
  },
  {
    "dcode": "D",
    "dropkey": "SZ18008",
    "droptype": "D",
    "dropname": "ALTA CANYON",
    "dropdeladd": "9265 S HIGHLAND DR",
    "dropdelcty": "SANDY",
    "dropdelst": "UT",
    "dropdelzpp": 840939998,
    "dropphyadd": "9265 S HIGHLAND DR",
    "dropphycty": "SANDY",
    "dropphyst": "UT",
    "dropphyzpp": 840939998,
    "dropmaladd": "9265 S HIGHLAND DR",
    "dropmalcty": "SANDY",
    "dropmalst": "UT",
    "dropmalzpp": 840939998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014530337,
    "dropsitcph": 8014530336,
    "dropfax": 8019421855
  },
  {
    "dcode": "D",
    "dropkey": "SZ18069",
    "droptype": "D",
    "dropname": "FLATHEAD",
    "dropdeladd": "248 1ST AVE W",
    "dropdelcty": "KALISPELL",
    "dropdelst": "MT",
    "dropdelzpp": 599014465,
    "dropphyadd": "248 1ST AVE W",
    "dropphycty": "KALISPELL",
    "dropphyst": "MT",
    "dropphyzpp": 599014465,
    "dropmaladd": "248 1ST AVE W",
    "dropmalcty": "KALISPELL",
    "dropmalst": "MT",
    "dropmalzpp": 599014465,
    "dropsitphn": 4066576450,
    "dropsitlph": 4067550187,
    "dropsitcph": 4067550187,
    "dropfax": 4067550376
  },
  {
    "dcode": "D",
    "dropkey": "SZ18089",
    "droptype": "D",
    "dropname": "CASCADE PARK",
    "dropdeladd": "304 SE HEARTHWOOD BLVD",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986847498,
    "dropphyadd": "304 SE HEARTHWOOD BLVD",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986847498,
    "dropmaladd": "401 NE 136TH AVE",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986849998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3602535053,
    "dropsitcph": 3609925000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18096",
    "droptype": "D",
    "dropname": "RICHARD J PINO",
    "dropdeladd": "4600 PARADISE BLVD NW",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871149997,
    "dropphyadd": "4600 PARADISE BLVD NW",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871149997,
    "dropmaladd": "4600 PARADISE BLVD NW",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871149997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057928739,
    "dropsitcph": 5057928741,
    "dropfax": 5058907407
  },
  {
    "dcode": "D",
    "dropkey": "SZ18098",
    "droptype": "D",
    "dropname": "THE HIGHWAY STATION",
    "dropdeladd": "990 HIGHWAY 95",
    "dropdelcty": "BULLHEAD CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 864299998,
    "dropphyadd": "990 HIGHWAY 95",
    "dropphycty": "BULLHEAD CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 864299998,
    "dropmaladd": "990 HIGHWAY 95",
    "dropmalcty": "BULLHEAD CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 864299998,
    "dropsitphn": 6022259491,
    "dropsitlph": 9287581555,
    "dropsitcph": 9287585711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18099",
    "droptype": "D",
    "dropname": "SANTA FE PLACE",
    "dropdeladd": "4250 CERRILLOS RD STE 1250",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875079211,
    "dropphyadd": "4250 CERRILLOS RD STE 1250",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875079211,
    "dropmaladd": "4250 CERRILLOS RD STE 1250",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875079211,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059882239,
    "dropsitcph": 5059882239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18100",
    "droptype": "D",
    "dropname": "DE VARGAS",
    "dropdeladd": "534 N GUADALUPE ST",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875019211,
    "dropphyadd": "534 N GUADALUPE ST",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875019211,
    "dropmaladd": "534 N GUADALUPE ST",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875019211,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059838935,
    "dropsitcph": 5059882239,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18111",
    "droptype": "D",
    "dropname": "SOUTH LAKE TAHOE",
    "dropdeladd": "1046 AL TAHOE BLVD",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961504603,
    "dropphyadd": "1046 AL TAHOE BLVD",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961504603,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ZEPHYR COVE",
    "dropmalst": "NV",
    "dropmalzpp": 894489998,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305443367,
    "dropsitcph": 7755882268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18115",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "400 SE 103RD DR",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972162756,
    "dropphyadd": "400 SE 103RD DR",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972162756,
    "dropmaladd": "400 SE 103RD DR",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972169998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032537521,
    "dropsitcph": 5032512727,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18119",
    "droptype": "D",
    "dropname": "SUNRISE",
    "dropdeladd": "4885 E CAREY AVE",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891159998,
    "dropphyadd": "4885 E CAREY AVE",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891159998,
    "dropmaladd": "4885 E CAREY AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891159998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7026448815,
    "dropsitcph": 7026448815,
    "dropfax": 7026448840
  },
  {
    "dcode": "D",
    "dropkey": "SZ18138",
    "droptype": "D",
    "dropname": "PIONEER STATION",
    "dropdeladd": "1376 FILLMORE ST",
    "dropdelcty": "TWIN FALLS",
    "dropdelst": "ID",
    "dropdelzpp": 833019996,
    "dropphyadd": "1376 FILLMORE ST",
    "dropphycty": "TWIN FALLS",
    "dropphyst": "ID",
    "dropphyzpp": 833019996,
    "dropmaladd": "1376 FILLMORE ST",
    "dropmalcty": "TWIN FALLS",
    "dropmalst": "ID",
    "dropmalzpp": 833019997,
    "dropsitphn": 2084334080,
    "dropsitlph": 2087344903,
    "dropsitcph": 2087341452,
    "dropfax": 2087345587
  },
  {
    "dcode": "D",
    "dropkey": "SZ18143",
    "droptype": "D",
    "dropname": "PULLMAN",
    "dropdeladd": "1135 S GRAND AVE",
    "dropdelcty": "PULLMAN",
    "dropdelst": "WA",
    "dropdelzpp": 991632037,
    "dropphyadd": "1135 S GRAND AVE",
    "dropphycty": "PULLMAN",
    "dropphyst": "WA",
    "dropphyzpp": 991632037,
    "dropmaladd": "1135 S GRAND AVE",
    "dropmalcty": "PULLMAN",
    "dropmalst": "WA",
    "dropmalzpp": 991632037,
    "dropsitphn": 5094590201,
    "dropsitlph": 2062828434,
    "dropsitcph": 5093343212,
    "dropfax": 2088839751
  },
  {
    "dcode": "D",
    "dropkey": "SZ18159",
    "droptype": "D",
    "dropname": "EVERGREEN DCU BVRTN",
    "dropdeladd": "3685 NE ALOCLEK DR",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972917164,
    "dropphyadd": "3685 NE ALOCLEK DR",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972917164,
    "dropmaladd": "3685 NE ALOCLEK DR",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972919808,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036149801,
    "dropsitcph": 5036435263,
    "dropfax": 5036909476
  },
  {
    "dcode": "D",
    "dropkey": "SZ18170",
    "droptype": "D",
    "dropname": "SEDONA VILLAGE OF OAK CREEK",
    "dropdeladd": "45 W CORTEZ DR",
    "dropdelcty": "SEDONA",
    "dropdelst": "AZ",
    "dropdelzpp": 863519998,
    "dropphyadd": "45 W CORTEZ DR",
    "dropphycty": "SEDONA",
    "dropphyst": "AZ",
    "dropphyzpp": 863519998,
    "dropmaladd": "45 W CORTEZ DR",
    "dropmalcty": "SEDONA",
    "dropmalst": "AZ",
    "dropmalzpp": 863519998,
    "dropsitphn": 6022253214,
    "dropsitlph": 9282393096,
    "dropsitcph": 9282843506,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18219",
    "droptype": "D",
    "dropname": "PECOS",
    "dropdeladd": "16825 S DESERT FOOTHILLS PKWY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850489998,
    "dropphyadd": "16825 S DESERT FOOTHILLS PKWY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850489998,
    "dropmaladd": "16825 S DESERT FOOTHILLS PKWY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850489998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4804600228,
    "dropsitcph": 4804600228,
    "dropfax": 4804603601
  },
  {
    "dcode": "D",
    "dropkey": "SZ18228",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "1180 COMMERCE DR",
    "dropdelcty": "LAS CRUCES",
    "dropdelst": "NM",
    "dropdelzpp": 880119998,
    "dropphyadd": "1180 COMMERCE DR",
    "dropphycty": "LAS CRUCES",
    "dropphyst": "NM",
    "dropphyzpp": 880119998,
    "dropmaladd": "1180 COMMERCE DR",
    "dropmalcty": "LAS CRUCES",
    "dropmalst": "NM",
    "dropmalzpp": 880119998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5755214953,
    "dropsitcph": 5755214953,
    "dropfax": 5755214621
  },
  {
    "dcode": "D",
    "dropkey": "SZ18229",
    "droptype": "D",
    "dropname": "NORTHWEST STATION",
    "dropdeladd": "1224 W 21ST ST",
    "dropdelcty": "CLOVIS",
    "dropdelst": "NM",
    "dropdelzpp": 881014199,
    "dropphyadd": "1224 W 21ST ST",
    "dropphycty": "CLOVIS",
    "dropphyst": "NM",
    "dropphyzpp": 881014199,
    "dropmaladd": "1224 W 21ST ST",
    "dropmalcty": "CLOVIS",
    "dropmalst": "NM",
    "dropmalzpp": 881014199,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757365556,
    "dropsitcph": 5757635556,
    "dropfax": 5757638964
  },
  {
    "dcode": "D",
    "dropkey": "SZ18237",
    "droptype": "D",
    "dropname": "COTTONWOOD",
    "dropdeladd": "10701 CORRALES RD NW STE 19A",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871149996,
    "dropphyadd": "10701 CORRALES RD NW STE 19A",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871149996,
    "dropmaladd": "10701 CORRALES RD NW STE 19A",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871149996,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058995894,
    "dropsitcph": 5057928739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18238",
    "droptype": "D",
    "dropname": "FOOTHILLS",
    "dropdeladd": "13101 LOMAS BLVD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871239998,
    "dropphyadd": "13101 LOMAS BLVD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871239998,
    "dropmaladd": "13101 LOMAS BLVD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871239998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461277,
    "dropsitcph": 5053234028,
    "dropfax": 5053460937
  },
  {
    "dcode": "D",
    "dropkey": "SZ18244",
    "droptype": "D",
    "dropname": "GATEWAY POSTAL",
    "dropdeladd": "3148 GATEWAY ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 974751100,
    "dropphyadd": "3148 GATEWAY ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 974751100,
    "dropmaladd": "PO BOX 7000",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 974750100,
    "dropsitphn": 9712013788,
    "dropsitlph": 5419885130,
    "dropsitcph": 5419885130,
    "dropfax": 5419885217
  },
  {
    "dcode": "D",
    "dropkey": "SZ18270",
    "droptype": "D",
    "dropname": "VALLE VERDE",
    "dropdeladd": "1575 W HORIZON RIDGE PKWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890129998,
    "dropphyadd": "1575 W HORIZON RIDGE PKWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890129998,
    "dropmaladd": "1575 W HORIZON RIDGE PKWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890129998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028371614,
    "dropsitcph": 7028371624,
    "dropfax": 7028371623
  },
  {
    "dcode": "D",
    "dropkey": "SZ18287",
    "droptype": "D",
    "dropname": "MOUNTAIN RUN POE",
    "dropdeladd": "5850 EUBANK BLVD NE STE B21",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871116127,
    "dropphyadd": "5850 EUBANK BLVD NE STE B21",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871116127,
    "dropmaladd": "5850 EUBANK BLVD NE STE B21",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871116127,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460985,
    "dropsitcph": 5053461270,
    "dropfax": 5053461272
  },
  {
    "dcode": "D",
    "dropkey": "SZ18288",
    "droptype": "D",
    "dropname": "LOUISIANA POE",
    "dropdeladd": "4016 LOUISIANA BLVD NE STE A",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871101447,
    "dropphyadd": "4016 LOUISIANA BLVD NE STE A",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871101447,
    "dropmaladd": "4016 LOUISIANA BLVD NE STE A",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871101447,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058818725,
    "dropsitcph": 5058818725,
    "dropfax": 5058818731
  },
  {
    "dcode": "D",
    "dropkey": "SZ18289",
    "droptype": "D",
    "dropname": "LOMAS POE",
    "dropdeladd": "13201 LOMAS BLVD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871127001,
    "dropphyadd": "13201 LOMAS BLVD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871127001,
    "dropmaladd": "13201 LOMAS BLVD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871127001,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053230979,
    "dropsitcph": 5053461822,
    "dropfax": 5053239276
  },
  {
    "dcode": "D",
    "dropkey": "SZ18291",
    "droptype": "D",
    "dropname": "SANTA FE POE",
    "dropdeladd": "2110 S PACHECO ST STE A",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875055463,
    "dropphyadd": "2110 S PACHECO ST STE A",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875055463,
    "dropmaladd": "2110 S PACHECO ST STE A",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875055463,
    "dropsitphn": 5053468251,
    "dropsitlph": 5054388452,
    "dropsitcph": 5059882239,
    "dropfax": 5054743280
  },
  {
    "dcode": "D",
    "dropkey": "SZ18292",
    "droptype": "D",
    "dropname": "TAOS POE",
    "dropdeladd": "710 PASEO DEL PUEBLO SUR STE E",
    "dropdelcty": "TAOS",
    "dropdelst": "NM",
    "dropdelzpp": 875716062,
    "dropphyadd": "710 PASEO DEL PUEBLO SUR STE E",
    "dropphycty": "TAOS",
    "dropphyst": "NM",
    "dropphyzpp": 875716062,
    "dropmaladd": "710 PASEO DEL PUEBLO SUR STE E",
    "dropmalcty": "TAOS",
    "dropmalst": "NM",
    "dropmalzpp": 875716062,
    "dropsitphn": "",
    "dropsitlph": 5757582081,
    "dropsitcph": 5757511801,
    "dropfax": 5757587429
  },
  {
    "dcode": "D",
    "dropkey": "SZ18309",
    "droptype": "D",
    "dropname": "DOWNTOWN PASCO",
    "dropdeladd": "403 W LEWIS ST",
    "dropdelcty": "PASCO",
    "dropdelst": "WA",
    "dropdelzpp": 993015663,
    "dropphyadd": "403 W LEWIS ST",
    "dropphycty": "PASCO",
    "dropphyst": "WA",
    "dropphyzpp": 993015663,
    "dropmaladd": "403 W LEWIS ST",
    "dropmalcty": "PASCO",
    "dropmalst": "WA",
    "dropmalzpp": 993015663,
    "dropsitphn": 5094590201,
    "dropsitlph": 5098825195,
    "dropsitcph": 5095432189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18335",
    "droptype": "D",
    "dropname": "COORS POE",
    "dropdeladd": "640 COORS BLVD NW STE 19",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871211401,
    "dropphyadd": "640 COORS BLVD NW STE 19",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871211401,
    "dropmaladd": "640 COORS BLVD NW STE 19",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871211401,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053525874,
    "dropsitcph": 5053460876,
    "dropfax": 5053460839
  },
  {
    "dcode": "D",
    "dropkey": "SZ18363",
    "droptype": "D",
    "dropname": "MOUNTAIN SHADOWS",
    "dropdeladd": "877 E 1200 S",
    "dropdelcty": "OREM",
    "dropdelst": "UT",
    "dropdelzpp": 840979998,
    "dropphyadd": "877 E 1200 S",
    "dropphycty": "OREM",
    "dropphyst": "UT",
    "dropphyzpp": 840979998,
    "dropmaladd": "877 E 1200 S",
    "dropmalcty": "OREM",
    "dropmalst": "UT",
    "dropmalzpp": 840979998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8018027142,
    "dropsitcph": 8018027141,
    "dropfax": 8012266071
  },
  {
    "dcode": "D",
    "dropkey": "SZ18373",
    "droptype": "D",
    "dropname": "TEMPE RETAIL STORE",
    "dropdeladd": "500 S MILL AVE",
    "dropdelcty": "TEMPE",
    "dropdelst": "AZ",
    "dropdelzpp": 852819997,
    "dropphyadd": "500 S MILL AVE",
    "dropphycty": "TEMPE",
    "dropphyst": "AZ",
    "dropphyzpp": 852819997,
    "dropmaladd": "500 S MILL AVE",
    "dropmalcty": "TEMPE",
    "dropmalst": "AZ",
    "dropmalzpp": 852819997,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809661131,
    "dropsitcph": 4808942128,
    "dropfax": 4809662944
  },
  {
    "dcode": "D",
    "dropkey": "SZ18374",
    "droptype": "D",
    "dropname": "DOWNTOWN GLENDALE",
    "dropdeladd": "6537 N 55TH AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 853019998,
    "dropphyadd": "6537 N 55TH AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 853019998,
    "dropmaladd": "6537 N 55TH AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 853019998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6238425863,
    "dropsitcph": 6238428071,
    "dropfax": 6238424152
  },
  {
    "dcode": "D",
    "dropkey": "SZ18776",
    "droptype": "D",
    "dropname": "KAPOLEI",
    "dropdeladd": "1001 KAMOKILA BLVD STE 115",
    "dropdelcty": "KAPOLEI",
    "dropdelst": "HI",
    "dropdelzpp": 967079997,
    "dropphyadd": "1001 KAMOKILA BLVD STE 115",
    "dropphycty": "KAPOLEI",
    "dropphyst": "HI",
    "dropphyzpp": 967079997,
    "dropmaladd": "1001 KAMOKILA BLVD STE 115",
    "dropmalcty": "KAPOLEI",
    "dropmalst": "HI",
    "dropmalzpp": 967079997,
    "dropsitphn": 8086742384,
    "dropsitlph": 8086742384,
    "dropsitcph": 8086710369,
    "dropfax": 8086742385
  },
  {
    "dcode": "D",
    "dropkey": "SZ18784",
    "droptype": "D",
    "dropname": "OREGON TRAIL",
    "dropdeladd": "2208 E SUMMERSWEET DR",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837169998,
    "dropphyadd": "2208 E SUMMERSWEET DR",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837169998,
    "dropmaladd": "2208 E SUMMERSWEET DR",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837169998,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083449491,
    "dropsitcph": 2083449265,
    "dropfax": 2083449565
  },
  {
    "dcode": "D",
    "dropkey": "SZ18787",
    "droptype": "D",
    "dropname": "ORMSBY",
    "dropdeladd": "2613 EMPIRE RANCH RD",
    "dropdelcty": "CARSON CITY",
    "dropdelst": "NV",
    "dropdelzpp": 897069998,
    "dropphyadd": "2613 EMPIRE RANCH RD",
    "dropphycty": "CARSON CITY",
    "dropphyst": "NV",
    "dropphyzpp": 897069998,
    "dropmaladd": "2613 EMPIRE RANCH RD",
    "dropmalcty": "CARSON CITY",
    "dropmalst": "NV",
    "dropmalzpp": 897069998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758850727,
    "dropsitcph": 7758850749,
    "dropfax": 7758850756
  },
  {
    "dcode": "D",
    "dropkey": "SZ18788",
    "droptype": "D",
    "dropname": "BABCOCK",
    "dropdeladd": "32 E BABCOCK ST",
    "dropdelcty": "BOZEMAN",
    "dropdelst": "MT",
    "dropdelzpp": 597159998,
    "dropphyadd": "32 E BABCOCK ST",
    "dropphycty": "BOZEMAN",
    "dropphyst": "MT",
    "dropphyzpp": 597159998,
    "dropmaladd": "32 E BABCOCK ST",
    "dropmalcty": "BOZEMAN",
    "dropmalst": "MT",
    "dropmalzpp": 597159998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4065861508,
    "dropsitcph": 4065861508,
    "dropfax": 4065874783
  },
  {
    "dcode": "D",
    "dropkey": "SZ18795",
    "droptype": "D",
    "dropname": "MULLAN",
    "dropdeladd": "3150 GREAT NORTHERN AVE",
    "dropdelcty": "MISSOULA",
    "dropdelst": "MT",
    "dropdelzpp": 598089998,
    "dropphyadd": "3150 GREAT NORTHERN AVE",
    "dropphycty": "MISSOULA",
    "dropphyst": "MT",
    "dropphyzpp": 598089998,
    "dropmaladd": "3150 GREAT NORTHERN AVE",
    "dropmalcty": "MISSOULA",
    "dropmalst": "MT",
    "dropmalzpp": 598089998,
    "dropsitphn": 4066575713,
    "dropsitlph": 4067285535,
    "dropsitcph": 4067285535,
    "dropfax": 4067286531
  },
  {
    "dcode": "D",
    "dropkey": "SZ18804",
    "droptype": "D",
    "dropname": "POE 587",
    "dropdeladd": "2320 E TROPICANA AVE",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891196574,
    "dropphyadd": "2320 E TROPICANA AVE",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891196574,
    "dropmaladd": "2320 E TROPICANA AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891196574,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7027365189,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18823",
    "droptype": "D",
    "dropname": "GALLUP",
    "dropdeladd": "950 W AZTEC AVE",
    "dropdelcty": "GALLUP",
    "dropdelst": "NM",
    "dropdelzpp": 873019711,
    "dropphyadd": "950 W AZTEC AVE",
    "dropphycty": "GALLUP",
    "dropphyst": "NM",
    "dropphyzpp": 873019711,
    "dropmaladd": "950 W AZTEC AVE",
    "dropmalcty": "GALLUP",
    "dropmalst": "NM",
    "dropmalzpp": 873019711,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058639635,
    "dropsitcph": 5058633491,
    "dropfax": 5058639635
  },
  {
    "dcode": "D",
    "dropkey": "SZ18827",
    "droptype": "D",
    "dropname": "POE 60",
    "dropdeladd": "6850 SPRING MOUNTAIN RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891468820,
    "dropphyadd": "6850 SPRING MOUNTAIN RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891468820,
    "dropmaladd": "6850 SPRING MOUNTAIN RD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891468820,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7022487027,
    "dropfax": 7022487097
  },
  {
    "dcode": "D",
    "dropkey": "SZ18828",
    "droptype": "D",
    "dropname": "POE 586",
    "dropdeladd": "4421 E BONANZA RD STE A",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891106343,
    "dropphyadd": "4421 E BONANZA RD STE A",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891106343,
    "dropmaladd": "4421 E BONANZA RD STE A",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891106343,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7024532219,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18830",
    "droptype": "D",
    "dropname": "POE 685",
    "dropdeladd": "4801 SPRING MOUNTAIN RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891028709,
    "dropphyadd": "4801 SPRING MOUNTAIN RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891028709,
    "dropmaladd": "1001 E SUNSET RD RM 1017",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891999996,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7023623951,
    "dropfax": 7023624388
  },
  {
    "dcode": "D",
    "dropkey": "SZ18831",
    "droptype": "D",
    "dropname": "POE 695",
    "dropdeladd": "8350 W CHEYENNE AVE",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891292147,
    "dropphyadd": "8350 W CHEYENNE AVE",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891292147,
    "dropmaladd": "8350 W CHEYENNE AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891292147,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7026554641,
    "dropfax": 7026554693
  },
  {
    "dcode": "D",
    "dropkey": "SZ18832",
    "droptype": "D",
    "dropname": "POE 788",
    "dropdeladd": "6140 W LAKE MEAD BLVD LBBY",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891086441,
    "dropphyadd": "6140 W LAKE MEAD BLVD LBBY",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891086441,
    "dropmaladd": "6140 W LAKE MEAD BLVD LBBY",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891086441,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7026314843,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18833",
    "droptype": "D",
    "dropname": "POE 683",
    "dropdeladd": "7271 S EASTERN AVE",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891194507,
    "dropphyadd": "7271 S EASTERN AVE",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891194507,
    "dropmaladd": "7271 S EASTERN AVE",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891194507,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7022637132,
    "dropfax": 7022637128
  },
  {
    "dcode": "D",
    "dropkey": "SZ18835",
    "droptype": "D",
    "dropname": "WEST RICHLAND",
    "dropdeladd": "4801 W VAN GIESEN ST",
    "dropdelcty": "WEST RICHLAND",
    "dropdelst": "WA",
    "dropdelzpp": 993539998,
    "dropphyadd": "4801 W VAN GIESEN ST",
    "dropphycty": "WEST RICHLAND",
    "dropphyst": "WA",
    "dropphyzpp": 993539998,
    "dropmaladd": "PO BOX 4000",
    "dropmalcty": "WEST RICHLAND",
    "dropmalst": "WA",
    "dropmalzpp": 993534099,
    "dropsitphn": 5093636210,
    "dropsitlph": 5099670400,
    "dropsitcph": 5099670500,
    "dropfax": 6514566288
  },
  {
    "dcode": "D",
    "dropkey": "SZ18838",
    "droptype": "D",
    "dropname": "VALENTINE",
    "dropdeladd": "601 CLEVELAND AVE",
    "dropdelcty": "LOVELAND",
    "dropdelst": "CO",
    "dropdelzpp": 805379997,
    "dropphyadd": "601 CLEVELAND AVE",
    "dropphycty": "LOVELAND",
    "dropphyst": "CO",
    "dropphyzpp": 805379997,
    "dropmaladd": "601 CLEVELAND AVE",
    "dropmalcty": "LOVELAND",
    "dropmalst": "CO",
    "dropmalzpp": 805379997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706675303,
    "dropsitcph": 9706675303,
    "dropfax": 9706130775
  },
  {
    "dcode": "D",
    "dropkey": "SZ18842",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "909 1ST AVE STE 100",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981049995,
    "dropphyadd": "909 1ST AVE STE 100",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981049995,
    "dropmaladd": "909 1ST AVE STE 100",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981049995,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067499194,
    "dropsitcph": 2067485417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18853",
    "droptype": "D",
    "dropname": "OCOTILLO",
    "dropdeladd": "123 W CHANDLER HEIGHTS RD",
    "dropdelcty": "CHANDLER",
    "dropdelst": "AZ",
    "dropdelzpp": 852489998,
    "dropphyadd": "123 W CHANDLER HEIGHTS RD",
    "dropphycty": "CHANDLER",
    "dropphyst": "AZ",
    "dropphyzpp": 852489998,
    "dropmaladd": "123 W CHANDLER HEIGHTS RD",
    "dropmalcty": "CHANDLER",
    "dropmalst": "AZ",
    "dropmalzpp": 852489998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4808024810,
    "dropsitcph": 4808024811,
    "dropfax": 4808024817
  },
  {
    "dcode": "D",
    "dropkey": "SZ18880",
    "droptype": "D",
    "dropname": "MOUNT OGDEN",
    "dropdeladd": "1145 E 4600 S",
    "dropdelcty": "OGDEN",
    "dropdelst": "UT",
    "dropdelzpp": 844039998,
    "dropphyadd": "1145 E 4600 S",
    "dropphycty": "OGDEN",
    "dropphyst": "UT",
    "dropphyzpp": 844039998,
    "dropmaladd": "1145 E 4600 S",
    "dropmalcty": "OGDEN",
    "dropmalst": "UT",
    "dropmalzpp": 844039998,
    "dropsitphn": 8019742558,
    "dropsitlph": 8014762042,
    "dropsitcph": 8014759456,
    "dropfax": 8014768721
  },
  {
    "dcode": "D",
    "dropkey": "SZ18885",
    "droptype": "D",
    "dropname": "DOWNTOWN EUGENE",
    "dropdeladd": "520 WILLAMETTE ST",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974012768,
    "dropphyadd": "520 WILLAMETTE ST",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974012768,
    "dropmaladd": "520 WILLAMETTE ST",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413697,
    "dropsitcph": 5413413697,
    "dropfax": 5413413663
  },
  {
    "dcode": "D",
    "dropkey": "SZ18888",
    "droptype": "D",
    "dropname": "MEADOW MESA",
    "dropdeladd": "4904 CAMINO AL NORTE",
    "dropdelcty": "NORTH LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 890319998,
    "dropphyadd": "4904 CAMINO AL NORTE",
    "dropphycty": "NORTH LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 890319998,
    "dropmaladd": "4904 CAMINO AL NORTE",
    "dropmalcty": "NORTH LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 890319998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7026576888,
    "dropfax": 7026570332
  },
  {
    "dcode": "D",
    "dropkey": "SZ18894",
    "droptype": "D",
    "dropname": "MESQUITE ANNEX",
    "dropdeladd": "50 N SANDHILL BLVD",
    "dropdelcty": "MESQUITE",
    "dropdelst": "NV",
    "dropdelzpp": 890274700,
    "dropphyadd": "50 N SANDHILL BLVD",
    "dropphycty": "MESQUITE",
    "dropphyst": "NV",
    "dropphyzpp": 890274700,
    "dropmaladd": "50 N SANDHILL BLVD",
    "dropmalcty": "MESQUITE",
    "dropmalst": "NV",
    "dropmalzpp": 890274700,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7023465147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18898",
    "droptype": "D",
    "dropname": "GILBERT RETAIL",
    "dropdeladd": "137 E ELLIOT RD",
    "dropdelcty": "GILBERT",
    "dropdelst": "AZ",
    "dropdelzpp": 852346700,
    "dropphyadd": "137 E ELLIOT RD",
    "dropphycty": "GILBERT",
    "dropphyst": "AZ",
    "dropphyzpp": 852346700,
    "dropmaladd": "137 E ELLIOT RD",
    "dropmalcty": "GILBERT",
    "dropmalst": "AZ",
    "dropmalzpp": 852346700,
    "dropsitphn": 6022253214,
    "dropsitlph": 4806325805,
    "dropsitcph": 4805451058,
    "dropfax": 4804973590
  },
  {
    "dcode": "D",
    "dropkey": "SZ18899",
    "droptype": "D",
    "dropname": "MESA SUPERSTITION SPRINGS",
    "dropdeladd": "7316 E SOUTHERN AVE",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852099997,
    "dropphyadd": "7316 E SOUTHERN AVE",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852099997,
    "dropmaladd": "7316 E SOUTHERN AVE",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852099997,
    "dropsitphn": 4806544759,
    "dropsitlph": 4806544759,
    "dropsitcph": 4806544275,
    "dropfax": 4806415384
  },
  {
    "dcode": "D",
    "dropkey": "SZ18921",
    "droptype": "D",
    "dropname": "GATEWAY STATION",
    "dropdeladd": "1750 FLANDRO DR",
    "dropdelcty": "POCATELLO",
    "dropdelst": "ID",
    "dropdelzpp": 832021944,
    "dropphyadd": "1750 FLANDRO DR",
    "dropphycty": "POCATELLO",
    "dropphyst": "ID",
    "dropphyzpp": 832021944,
    "dropmaladd": "1750 FLANDRO DR",
    "dropmalcty": "POCATELLO",
    "dropmalst": "ID",
    "dropmalzpp": 832021944,
    "dropsitphn": 2084334080,
    "dropsitlph": 2082355517,
    "dropsitcph": 2082355514,
    "dropfax": 2082355550
  },
  {
    "dcode": "D",
    "dropkey": "SZ18933",
    "droptype": "D",
    "dropname": "BRIARGATE",
    "dropdeladd": "8585 CRITERION DR",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809201045,
    "dropphyadd": "8585 CRITERION DR",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809201045,
    "dropmaladd": "8585 CRITERION DR",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809201045,
    "dropsitphn": 7195705409,
    "dropsitlph": 7195987516,
    "dropsitcph": 7195987516,
    "dropfax": 7195986703
  },
  {
    "dcode": "D",
    "dropkey": "SZ18947",
    "droptype": "D",
    "dropname": "ASPEN",
    "dropdeladd": "500 ASPEN WAY",
    "dropdelcty": "ELKO",
    "dropdelst": "NV",
    "dropdelzpp": 898012797,
    "dropphyadd": "500 ASPEN WAY",
    "dropphycty": "ELKO",
    "dropphyst": "NV",
    "dropphyzpp": 898012797,
    "dropmaladd": "500 ASPEN WAY",
    "dropmalcty": "ELKO",
    "dropmalst": "NV",
    "dropmalzpp": 898019997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757779801,
    "dropsitcph": 7757779801,
    "dropfax": 7757389739
  },
  {
    "dcode": "D",
    "dropkey": "SZ18950",
    "droptype": "D",
    "dropname": "PONY EXPRESS",
    "dropdeladd": "120 S ALLEN RD",
    "dropdelcty": "FALLON",
    "dropdelst": "NV",
    "dropdelzpp": 894063275,
    "dropphyadd": "120 S ALLEN RD",
    "dropphycty": "FALLON",
    "dropphyst": "NV",
    "dropphyzpp": 894063275,
    "dropmaladd": "120 S ALLEN RD",
    "dropmalcty": "FALLON",
    "dropmalst": "NV",
    "dropmalzpp": 894069996,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754281238,
    "dropsitcph": 7754281238,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18961",
    "droptype": "D",
    "dropname": "HARRIS PARK",
    "dropdeladd": "7262 MEADE ST",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CO",
    "dropdelzpp": 800309998,
    "dropphyadd": "7262 MEADE ST",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CO",
    "dropphyzpp": 800309998,
    "dropmaladd": "7262 MEADE ST",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CO",
    "dropmalzpp": 800309998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034870625,
    "dropsitcph": 3034870620,
    "dropfax": 3034307508
  },
  {
    "dcode": "D",
    "dropkey": "SZ18965",
    "droptype": "D",
    "dropname": "KING",
    "dropdeladd": "1801 N MARTIN L KING BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891069998,
    "dropphyadd": "1801 N MARTIN L KING BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891069998,
    "dropmaladd": "1801 N MARTIN L KING BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891069998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7026481350,
    "dropsitcph": 7026480238,
    "dropfax": 7026482007
  },
  {
    "dcode": "D",
    "dropkey": "SZ18979",
    "droptype": "D",
    "dropname": "GERONIMO SPRINGS",
    "dropdeladd": "300 MAIN ST",
    "dropdelcty": "TRUTH OR CONSEQUENCES",
    "dropdelst": "NM",
    "dropdelzpp": 879019997,
    "dropphyadd": "300 MAIN ST",
    "dropphycty": "TRUTH OR CONSEQUENCES",
    "dropphyst": "NM",
    "dropphyzpp": 879019997,
    "dropmaladd": "300 MAIN ST",
    "dropmalcty": "TRUTH OR CONSEQUENCES",
    "dropmalst": "NM",
    "dropmalzpp": 879019997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5758940876,
    "dropsitcph": 5758940876,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ18995",
    "droptype": "D",
    "dropname": "OVERLAND",
    "dropdeladd": "1650 W TARGEE ST",
    "dropdelcty": "BOISE",
    "dropdelst": "ID",
    "dropdelzpp": 837054239,
    "dropphyadd": "1650 W TARGEE ST",
    "dropphycty": "BOISE",
    "dropphyst": "ID",
    "dropphyzpp": 837054239,
    "dropmaladd": "1650 W TARGEE ST",
    "dropmalcty": "BOISE",
    "dropmalst": "ID",
    "dropmalzpp": 837054239,
    "dropsitphn": 2084334080,
    "dropsitlph": 2083444831,
    "dropsitcph": 2083442280,
    "dropfax": 2084290320
  },
  {
    "dcode": "D",
    "dropkey": "SZ20005",
    "droptype": "D",
    "dropname": "A STATION BERKELEY",
    "dropdeladd": "2111 SAN PABLO AVE",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947029991,
    "dropphyadd": "2111 SAN PABLO AVE",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947029991,
    "dropmaladd": "2111 SAN PABLO AVE",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947021827,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106441459,
    "dropsitcph": 5106441459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20006",
    "droptype": "D",
    "dropname": "A STATION BUENA PARK",
    "dropdeladd": "8082 COMMONWEALTH AVE STE 100",
    "dropdelcty": "BUENA PARK",
    "dropdelst": "CA",
    "dropdelzpp": 906219995,
    "dropphyadd": "8082 COMMONWEALTH AVE STE 100",
    "dropphycty": "BUENA PARK",
    "dropphyst": "CA",
    "dropphyzpp": 906219995,
    "dropmaladd": "7377 LA PALMA AVE",
    "dropmalcty": "BUENA PARK",
    "dropmalst": "CA",
    "dropmalzpp": 906229998,
    "dropsitphn": 7145238701,
    "dropsitlph": 7145238701,
    "dropsitcph": 7145238701,
    "dropfax": 7145235411
  },
  {
    "dcode": "D",
    "dropkey": "SZ20007",
    "droptype": "D",
    "dropname": "CAPUCHINO STATION",
    "dropdeladd": "1141 CAPUCHINO AVE",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "CA",
    "dropdelzpp": 940109992,
    "dropphyadd": "1141 CAPUCHINO AVE",
    "dropphycty": "BURLINGAME",
    "dropphyst": "CA",
    "dropphyzpp": 940109992,
    "dropmaladd": "1141 CAPUCHINO AVE",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "CA",
    "dropmalzpp": 940109992,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503438175,
    "dropsitcph": 6505521039,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20008",
    "droptype": "D",
    "dropname": "DOWNTOWN EUREKA",
    "dropdeladd": "514 H ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "CA",
    "dropdelzpp": 955019993,
    "dropphyadd": "514 H ST",
    "dropphycty": "EUREKA",
    "dropphyst": "CA",
    "dropphyzpp": 955019993,
    "dropmaladd": "337 W CLARK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "CA",
    "dropmalzpp": 955019903,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7074421828,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20009",
    "droptype": "D",
    "dropname": "WOODSIDE PLAZA",
    "dropdeladd": "364 WOODSIDE PLZ",
    "dropdelcty": "REDWOOD CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940619991,
    "dropphyadd": "364 WOODSIDE PLZ",
    "dropphycty": "REDWOOD CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940619991,
    "dropmaladd": "364 WOODSIDE PLZ",
    "dropmalcty": "REDWOOD CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940619991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503684394,
    "dropsitcph": 6503684163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20011",
    "droptype": "D",
    "dropname": "STEINER STREET",
    "dropdeladd": "1849 GEARY BLVD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941159991,
    "dropphyadd": "1849 GEARY BLVD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941159991,
    "dropmaladd": "1849 GEARY BLVD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941159991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4159311053,
    "dropsitcph": 4159311053,
    "dropfax": 4159311020
  },
  {
    "dcode": "D",
    "dropkey": "SZ20012",
    "droptype": "D",
    "dropname": "25TH AVENUE",
    "dropdeladd": "135 W 25TH AVE",
    "dropdelcty": "SAN MATEO",
    "dropdelst": "CA",
    "dropdelzpp": 944039991,
    "dropphyadd": "135 W 25TH AVE",
    "dropphycty": "SAN MATEO",
    "dropphyst": "CA",
    "dropphyzpp": 944039991,
    "dropmaladd": "135 W 25TH AVE",
    "dropmalcty": "SAN MATEO",
    "dropmalst": "CA",
    "dropmalzpp": 944039991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503588482,
    "dropsitcph": 6503588476,
    "dropfax": 6503499726
  },
  {
    "dcode": "D",
    "dropkey": "SZ20032",
    "droptype": "D",
    "dropname": "AGNEW",
    "dropdeladd": "4601 LAFAYETTE ST",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "CA",
    "dropdelzpp": 950549998,
    "dropphyadd": "4601 LAFAYETTE ST",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "CA",
    "dropphyzpp": 950549998,
    "dropmaladd": "4601 LAFAYETTE ST",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "CA",
    "dropmalzpp": 950549998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4089886477,
    "dropsitcph": 4089880584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20039",
    "droptype": "D",
    "dropname": "AIRPORT OAKLAND",
    "dropdeladd": "8495 PARDEE DR",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946219991,
    "dropphyadd": "8495 PARDEE DR",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946219991,
    "dropmaladd": "8495 PARDEE DR",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946219991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513105,
    "dropsitcph": 5102513104,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20052",
    "droptype": "D",
    "dropname": "ALISAL",
    "dropdeladd": "303 N SANBORN RD",
    "dropdelcty": "SALINAS",
    "dropdelst": "CA",
    "dropdelzpp": 939059998,
    "dropphyadd": "303 N SANBORN RD",
    "dropphycty": "SALINAS",
    "dropphyst": "CA",
    "dropphyzpp": 939059998,
    "dropmaladd": "303 N SANBORN RD",
    "dropmalcty": "SALINAS",
    "dropmalst": "CA",
    "dropmalzpp": 939059998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314241961,
    "dropsitcph": 8317577704,
    "dropfax": 8317531417
  },
  {
    "dcode": "D",
    "dropkey": "SZ20060",
    "droptype": "D",
    "dropname": "ALMADEN VALLEY",
    "dropdeladd": "6525 CROWN BLVD",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951209998,
    "dropphyadd": "6525 CROWN BLVD",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951209998,
    "dropmaladd": "6525 CROWN BLVD",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951209998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082680611,
    "dropsitcph": 4082682175,
    "dropfax": 4082688734
  },
  {
    "dcode": "D",
    "dropkey": "SZ20064",
    "droptype": "D",
    "dropname": "ALONDRA",
    "dropdeladd": "14028 VAN NESS AVE",
    "dropdelcty": "GARDENA",
    "dropdelst": "CA",
    "dropdelzpp": 902499998,
    "dropphyadd": "14028 VAN NESS AVE",
    "dropphycty": "GARDENA",
    "dropphyst": "CA",
    "dropphyzpp": 902499998,
    "dropmaladd": "14028 VAN NESS AVE",
    "dropmalcty": "GARDENA",
    "dropmalst": "CA",
    "dropmalzpp": 902499998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103248615,
    "dropsitcph": 3103248221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20080",
    "droptype": "D",
    "dropname": "ALVARADO",
    "dropdeladd": "3861 SMITH ST",
    "dropdelcty": "UNION CITY",
    "dropdelst": "CA",
    "dropdelzpp": 945879991,
    "dropphyadd": "3861 SMITH ST",
    "dropphycty": "UNION CITY",
    "dropphyst": "CA",
    "dropphyzpp": 945879991,
    "dropmaladd": "33170 ALVARADO NILES RD",
    "dropmalcty": "UNION CITY",
    "dropmalst": "CA",
    "dropmalzpp": 945879998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5104711466,
    "dropsitcph": 5104711180,
    "dropfax": 5104710306
  },
  {
    "dcode": "D",
    "dropkey": "SZ20095",
    "droptype": "D",
    "dropname": "ANAHEIM HILLS",
    "dropdeladd": "5505 E SANTA ANA CANYON RD",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928179998,
    "dropphyadd": "5505 E SANTA ANA CANYON RD",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928179998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7149212304,
    "dropsitlph": 7149210960,
    "dropsitcph": 7149212304,
    "dropfax": 7149214804
  },
  {
    "dcode": "D",
    "dropkey": "SZ20100",
    "droptype": "D",
    "dropname": "ANDREW JACKSON",
    "dropdeladd": "6401 EL CAJON BLVD",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921159998,
    "dropphyadd": "6401 EL CAJON BLVD",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921159998,
    "dropmaladd": "6401 EL CAJON BLVD",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921159998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195827657,
    "dropsitcph": 6195821251,
    "dropfax": 6195821159
  },
  {
    "dcode": "D",
    "dropkey": "SZ20117",
    "droptype": "D",
    "dropname": "ARCADE",
    "dropdeladd": "506 S SPRING ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900139998,
    "dropphyadd": "506 S SPRING ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900139998,
    "dropmaladd": "506 S SPRING ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900139998,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 2132441445,
    "dropfax": 2136226897
  },
  {
    "dcode": "D",
    "dropkey": "SZ20122",
    "droptype": "D",
    "dropname": "ARDEN",
    "dropdeladd": "2801 ARDEN WAY",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958259998,
    "dropphyadd": "2801 ARDEN WAY",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958259998,
    "dropmaladd": "2801 ARDEN WAY",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958259998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169932822,
    "dropsitcph": 9165743005,
    "dropfax": 9169789679
  },
  {
    "dcode": "D",
    "dropkey": "SZ20128",
    "droptype": "D",
    "dropname": "ARLINGTON",
    "dropdeladd": "10275 HOLE AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 925033457,
    "dropphyadd": "10275 HOLE AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 925033457,
    "dropmaladd": "10275 HOLE AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 925033457,
    "dropsitphn": 9513354694,
    "dropsitlph": 9516890202,
    "dropsitcph": 9516890165,
    "dropfax": 9516897038
  },
  {
    "dcode": "D",
    "dropkey": "SZ20148",
    "droptype": "D",
    "dropname": "ATLANTIC PLAZA",
    "dropdeladd": "296 ATLANTIC AVE",
    "dropdelcty": "PITTSBURG",
    "dropdelst": "CA",
    "dropdelzpp": 945659993,
    "dropphyadd": "296 ATLANTIC AVE",
    "dropphycty": "PITTSBURG",
    "dropphyst": "CA",
    "dropphyzpp": 945659993,
    "dropmaladd": "296 ATLANTIC AVE",
    "dropmalcty": "PITTSBURG",
    "dropmalst": "CA",
    "dropmalzpp": 945659993,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254324079,
    "dropsitcph": 9254322741,
    "dropfax": 9254329643
  },
  {
    "dcode": "D",
    "dropkey": "SZ20150",
    "droptype": "D",
    "dropname": "ARCO",
    "dropdeladd": "505 S FLOWER ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900719997,
    "dropphyadd": "505 S FLOWER ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900719997,
    "dropmaladd": "505 S FLOWER ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900719997,
    "dropsitphn": 2135861867,
    "dropsitlph": 2136229405,
    "dropsitcph": 2136298197,
    "dropfax": 2134894192
  },
  {
    "dcode": "D",
    "dropkey": "SZ20162",
    "droptype": "D",
    "dropname": "BELMONT SHORE",
    "dropdeladd": "5327 E 2ND ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908035335,
    "dropphyadd": "5327 E 2ND ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908035335,
    "dropmaladd": "5327 E 2ND ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908035335,
    "dropsitphn": 5624388730,
    "dropsitlph": 5624388730,
    "dropsitcph": 5624388730,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20168",
    "droptype": "D",
    "dropname": "BAILEY",
    "dropdeladd": "6709 WASHINGTON AVE",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906019998,
    "dropphyadd": "6709 WASHINGTON AVE",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906019998,
    "dropmaladd": "6709 WASHINGTON AVE",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906019998,
    "dropsitphn": 5626984810,
    "dropsitlph": 5626986619,
    "dropsitcph": 5626984810,
    "dropfax": 3106935671
  },
  {
    "dcode": "D",
    "dropkey": "SZ20175",
    "droptype": "D",
    "dropname": "BALBOA NEWPORT BEACH",
    "dropdeladd": "204 MAIN ST",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926619998,
    "dropphyadd": "204 MAIN ST",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926619998,
    "dropmaladd": "204 MAIN ST",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926619998,
    "dropsitphn": 9496752469,
    "dropsitlph": 9496751805,
    "dropsitcph": 9496752469,
    "dropfax": 9496404703
  },
  {
    "dcode": "D",
    "dropkey": "SZ20177",
    "droptype": "D",
    "dropname": "BALBOA ISLAND",
    "dropdeladd": "206 MARINE AVE",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926629998,
    "dropphyadd": "206 MARINE AVE",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926629998,
    "dropmaladd": "206 MARINE AVE",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926629998,
    "dropsitphn": 9496404663,
    "dropsitlph": 9496736508,
    "dropsitcph": 9496404663,
    "dropfax": 9496730331
  },
  {
    "dcode": "D",
    "dropkey": "SZ20198",
    "droptype": "D",
    "dropname": "BARRINGTON",
    "dropdeladd": "200 S BARRINGTON AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900499998,
    "dropphyadd": "200 S BARRINGTON AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900499998,
    "dropmaladd": "200 S BARRINGTON AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900499998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3104764057,
    "dropsitcph": 3104760486,
    "dropfax": 3104404914
  },
  {
    "dcode": "D",
    "dropkey": "SZ20211",
    "droptype": "D",
    "dropname": "BAYSIDE",
    "dropdeladd": "2731 JUNCTION AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951349998,
    "dropphyadd": "2731 JUNCTION AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951349998,
    "dropmaladd": "2731 JUNCTION AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951349998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084560741,
    "dropsitcph": 4084560563,
    "dropfax": 4084560270
  },
  {
    "dcode": "D",
    "dropkey": "SZ20212",
    "droptype": "D",
    "dropname": "BAYVIEW",
    "dropdeladd": "2111 LANE ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941249991,
    "dropphyadd": "2111 LANE ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941249991,
    "dropmaladd": "2111 LANE ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941249991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4158227157,
    "dropsitcph": 4158227157,
    "dropfax": 4158229105
  },
  {
    "dcode": "D",
    "dropkey": "SZ20216",
    "droptype": "D",
    "dropname": "BEACH CENTER",
    "dropdeladd": "316 OLIVE AVE",
    "dropdelcty": "HUNTINGTON BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926489998,
    "dropphyadd": "316 OLIVE AVE",
    "dropphycty": "HUNTINGTON BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926489998,
    "dropmaladd": "6771 WARNER AVE",
    "dropmalcty": "HUNTINGTON BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926479998,
    "dropsitphn": 7145364973,
    "dropsitlph": 7143745243,
    "dropsitcph": 7145364973,
    "dropfax": 7143749102
  },
  {
    "dcode": "D",
    "dropkey": "SZ20253",
    "droptype": "D",
    "dropname": "BERNAL HEIGHTS",
    "dropdeladd": "189 TIFFANY AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941109992,
    "dropphyadd": "189 TIFFANY AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941109992,
    "dropmaladd": "189 TIFFANY AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941109992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4156489677
  },
  {
    "dcode": "D",
    "dropkey": "SZ20256",
    "droptype": "D",
    "dropname": "BERRYESSA",
    "dropdeladd": "1315 PIEDMONT RD",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951329998,
    "dropphyadd": "1315 PIEDMONT RD",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951329998,
    "dropmaladd": "1315 PIEDMONT RD",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951329998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082593052,
    "dropsitcph": 4082592391,
    "dropfax": 4082590153
  },
  {
    "dcode": "D",
    "dropkey": "SZ20258",
    "droptype": "D",
    "dropname": "BEVERLY",
    "dropdeladd": "312 S BEVERLY DR",
    "dropdelcty": "BEVERLY HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 902129998,
    "dropphyadd": "312 S BEVERLY DR",
    "dropphycty": "BEVERLY HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 902129998,
    "dropmaladd": "312 S BEVERLY DR",
    "dropmalcty": "BEVERLY HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 902129998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3102473465,
    "dropsitcph": 3102473465,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20262",
    "droptype": "D",
    "dropname": "BICENTENNIAL",
    "dropdeladd": "7610 BEVERLY BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900489998,
    "dropphyadd": "7610 BEVERLY BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900489998,
    "dropmaladd": "7610 BEVERLY BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900489998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3239335953,
    "dropsitcph": 3239335953,
    "dropfax": 3239344961
  },
  {
    "dcode": "D",
    "dropkey": "SZ20293",
    "droptype": "D",
    "dropname": "BLOSSOM HILL",
    "dropdeladd": "5706 CAHALAN AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951239998,
    "dropphyadd": "5706 CAHALAN AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951239998,
    "dropmaladd": "5706 CAHALAN AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951239998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082268391,
    "dropsitcph": 4082258028,
    "dropfax": 4082266194
  },
  {
    "dcode": "D",
    "dropkey": "SZ20311",
    "droptype": "D",
    "dropname": "BOLSA",
    "dropdeladd": "9317 BOLSA AVE",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CA",
    "dropdelzpp": 926849997,
    "dropphyadd": "9317 BOLSA AVE",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CA",
    "dropphyzpp": 926849997,
    "dropmaladd": "15030 GOLDENWEST CIR",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CA",
    "dropmalzpp": 926859998,
    "dropsitphn": 7148923232,
    "dropsitlph": 7149033201,
    "dropsitcph": 7148923232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20326",
    "droptype": "D",
    "dropname": "BOSTONIA",
    "dropdeladd": "867 N 2ND ST",
    "dropdelcty": "EL CAJON",
    "dropdelst": "CA",
    "dropdelzpp": 920219998,
    "dropphyadd": "867 N 2ND ST",
    "dropphycty": "EL CAJON",
    "dropphyst": "CA",
    "dropphyzpp": 920219998,
    "dropmaladd": "867 N 2ND ST",
    "dropmalcty": "EL CAJON",
    "dropmalst": "CA",
    "dropmalzpp": 920219998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194429001,
    "dropsitcph": 6194420257,
    "dropfax": 6194422824
  },
  {
    "dcode": "D",
    "dropkey": "SZ20339",
    "droptype": "D",
    "dropname": "BOYLE HEIGHTS",
    "dropdeladd": "2016 E 1ST ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900339998,
    "dropphyadd": "2016 E 1ST ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900339998,
    "dropmaladd": "2016 E 1ST ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900339998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232680112,
    "dropsitcph": 3232680252,
    "dropfax": 3232619691
  },
  {
    "dcode": "D",
    "dropkey": "SZ20345",
    "droptype": "D",
    "dropname": "BRADFORD",
    "dropdeladd": "822 C ST",
    "dropdelcty": "HAYWARD",
    "dropdelst": "CA",
    "dropdelzpp": 945415121,
    "dropphyadd": "822 C ST",
    "dropphycty": "HAYWARD",
    "dropphyst": "CA",
    "dropphyzpp": 945415121,
    "dropmaladd": "24438 SANTA CLARA ST",
    "dropmalcty": "HAYWARD",
    "dropmalst": "CA",
    "dropmalzpp": 945449998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107832404,
    "dropsitcph": 5107835963,
    "dropfax": 5107830460
  },
  {
    "dcode": "D",
    "dropkey": "SZ20362",
    "droptype": "D",
    "dropname": "BRISTOL",
    "dropdeladd": "1620 W 1ST ST",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927039998,
    "dropphyadd": "1620 W 1ST ST",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927039998,
    "dropmaladd": "1620 W 1ST ST",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927039998,
    "dropsitphn": 7145411033,
    "dropsitlph": 7145416505,
    "dropsitcph": 7145411033,
    "dropfax": 7145419866
  },
  {
    "dcode": "D",
    "dropkey": "SZ20364",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "2121 BROADWAY",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958189998,
    "dropphyadd": "2121 BROADWAY",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958189998,
    "dropmaladd": "2121 BROADWAY",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958189998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162276513,
    "dropsitcph": 9162276503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20372",
    "droptype": "D",
    "dropname": "BROOKHURST CENTER",
    "dropdeladd": "2255 W BALL RD",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928149998,
    "dropphyadd": "2255 W BALL RD",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928149998,
    "dropmaladd": "2255 W BALL RD",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928149998,
    "dropsitphn": 7147740188,
    "dropsitlph": 7147743604,
    "dropsitcph": 7147740188,
    "dropfax": 7147749617
  },
  {
    "dcode": "D",
    "dropkey": "SZ20377",
    "droptype": "D",
    "dropname": "BRUNDAGE",
    "dropdeladd": "2525 E BRUNDAGE LN",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933079998,
    "dropphyadd": "2525 E BRUNDAGE LN",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933079998,
    "dropmaladd": "2525 E BRUNDAGE LN",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613227624,
    "dropsitcph": 6613227624,
    "dropfax": 6613225614
  },
  {
    "dcode": "D",
    "dropkey": "SZ20379",
    "droptype": "D",
    "dropname": "BRYANT",
    "dropdeladd": "2234 N BELLFLOWER BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908159995,
    "dropphyadd": "2234 N BELLFLOWER BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908159995,
    "dropmaladd": "2234 N BELLFLOWER BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908159995,
    "dropsitphn": 5624942406,
    "dropsitlph": 5625987638,
    "dropsitcph": 5625967153,
    "dropfax": 5624930637
  },
  {
    "dcode": "D",
    "dropkey": "SZ20395",
    "droptype": "D",
    "dropname": "BUNKER  HILL",
    "dropdeladd": "350 S GRAND AVE STE A6",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900719998,
    "dropphyadd": "350 S GRAND AVE STE A6",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900719998,
    "dropmaladd": "350 S GRAND AVE STE A6",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900719998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236200207,
    "dropsitcph": 2136173461,
    "dropfax": 3236251356
  },
  {
    "dcode": "D",
    "dropkey": "SZ20399",
    "droptype": "D",
    "dropname": "STANTON",
    "dropdeladd": "820 STANTON RD",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "CA",
    "dropdelzpp": 940109991,
    "dropphyadd": "820 STANTON RD",
    "dropphycty": "BURLINGAME",
    "dropphyst": "CA",
    "dropphyzpp": 940109991,
    "dropmaladd": "820 STANTON RD",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "CA",
    "dropmalzpp": 940109991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6506976351,
    "dropsitcph": 6505521039,
    "dropfax": 6506977465
  },
  {
    "dcode": "D",
    "dropkey": "SZ20414",
    "droptype": "D",
    "dropname": "MISSION SAN FRANCISCO",
    "dropdeladd": "1198 S VAN NESS AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941109991,
    "dropphyadd": "1198 S VAN NESS AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941109991,
    "dropmaladd": "1198 S VAN NESS AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941109991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4154313826,
    "dropsitcph": 4154313826,
    "dropfax": 4156414964
  },
  {
    "dcode": "D",
    "dropkey": "SZ20425",
    "droptype": "D",
    "dropname": "CABRILLO",
    "dropdeladd": "1690 W 23RD ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908109997,
    "dropphyadd": "1690 W 23RD ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908109997,
    "dropmaladd": "1690 W 23RD ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908109997,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624267723,
    "dropsitcph": 5629891011,
    "dropfax": 5624268322
  },
  {
    "dcode": "D",
    "dropkey": "SZ20439",
    "droptype": "D",
    "dropname": "CALAVERAS",
    "dropdeladd": "1048 W ROBINHOOD DR",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952079997,
    "dropphyadd": "1048 W ROBINHOOD DR",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952079997,
    "dropmaladd": "1048 W ROBINHOOD DR",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952079997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094770680,
    "dropsitcph": 2094770924,
    "dropfax": 2094729290
  },
  {
    "dcode": "D",
    "dropkey": "SZ20462",
    "droptype": "D",
    "dropname": "CALWA",
    "dropdeladd": "4026 E JENSEN AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937251497,
    "dropphyadd": "4026 E JENSEN AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937251497,
    "dropmaladd": "4026 E JENSEN AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937251497,
    "dropsitphn": 5594977615,
    "dropsitlph": 5598605096,
    "dropsitcph": 5592660130,
    "dropfax": 5598605097
  },
  {
    "dcode": "D",
    "dropkey": "SZ20466",
    "droptype": "D",
    "dropname": "CAMBRIAN PARK",
    "dropdeladd": "1769 HILLSDALE AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951249998,
    "dropphyadd": "1769 HILLSDALE AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951249998,
    "dropmaladd": "1769 HILLSDALE AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951249998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082670772,
    "dropsitcph": 4082676270,
    "dropfax": 4082645613
  },
  {
    "dcode": "D",
    "dropkey": "SZ20467",
    "droptype": "D",
    "dropname": "CAMBRIDGE",
    "dropdeladd": "265 CAMBRIDGE AVE",
    "dropdelcty": "PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943069991,
    "dropphyadd": "265 CAMBRIDGE AVE",
    "dropphycty": "PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943069991,
    "dropmaladd": "265 CAMBRIDGE AVE",
    "dropmalcty": "PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943069991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503271689,
    "dropsitcph": 6503211423,
    "dropfax": 6503232893
  },
  {
    "dcode": "D",
    "dropkey": "SZ20468",
    "droptype": "D",
    "dropname": "CAMELLIA",
    "dropdeladd": "4750 J ST",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958199998,
    "dropphyadd": "4750 J ST",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958199998,
    "dropmaladd": "4750 J ST",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958199998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162276507,
    "dropsitcph": 9162276503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20506",
    "droptype": "D",
    "dropname": "CARDWELL",
    "dropdeladd": "1606 E GRIFFITH WAY",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937049998,
    "dropphyadd": "1606 E GRIFFITH WAY",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937049998,
    "dropmaladd": "1606 E GRIFFITH WAY",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937049998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592221522,
    "dropsitcph": 5592222230,
    "dropfax": 5592243278
  },
  {
    "dcode": "D",
    "dropkey": "SZ20512",
    "droptype": "D",
    "dropname": "CARMEL BY THE SEA",
    "dropdeladd": "56B 5TH ST LOT 1",
    "dropdelcty": "CARMEL BY THE SEA",
    "dropdelst": "CA",
    "dropdelzpp": 939219905,
    "dropphyadd": "56B 5TH ST LOT 1",
    "dropphycty": "CARMEL BY THE SEA",
    "dropphyst": "CA",
    "dropphyzpp": 939219905,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CARMEL BY THE SEA",
    "dropmalst": "CA",
    "dropmalzpp": 939219998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8316241526,
    "dropsitcph": 8316243630,
    "dropfax": 8316251721
  },
  {
    "dcode": "D",
    "dropkey": "SZ20529",
    "droptype": "D",
    "dropname": "CASA CORREO",
    "dropdeladd": "4494 TREAT BLVD",
    "dropdelcty": "CONCORD",
    "dropdelst": "CA",
    "dropdelzpp": 945219991,
    "dropphyadd": "4494 TREAT BLVD",
    "dropphycty": "CONCORD",
    "dropphyst": "CA",
    "dropphyzpp": 945219991,
    "dropmaladd": "2121 MERIDIAN PARK BLVD",
    "dropmalcty": "CONCORD",
    "dropmalst": "CA",
    "dropmalzpp": 945209998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256098063,
    "dropsitcph": 9256870533,
    "dropfax": 9258748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20530",
    "droptype": "D",
    "dropname": "SPRING VALLEY CASA DE ORO",
    "dropdeladd": "9805 CAMPO RD STE 165",
    "dropdelcty": "SPRING VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 919779997,
    "dropphyadd": "9805 CAMPO RD STE 165",
    "dropphycty": "SPRING VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 919779997,
    "dropmaladd": "9805 CAMPO RD STE 165",
    "dropmalcty": "SPRING VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 919779997,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196605330,
    "dropsitcph": 6196605728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20543",
    "droptype": "D",
    "dropname": "CATALINA",
    "dropdeladd": "967 E COLORADO BLVD",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911069998,
    "dropphyadd": "967 E COLORADO BLVD",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911069998,
    "dropmaladd": "967 E COLORADO BLVD",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6264326871,
    "dropsitcph": 6264324835,
    "dropfax": 6267947045
  },
  {
    "dcode": "D",
    "dropkey": "SZ20550",
    "droptype": "D",
    "dropname": "CEDAR",
    "dropdeladd": "567 W LANCASTER BLVD",
    "dropdelcty": "LANCASTER",
    "dropdelst": "CA",
    "dropdelzpp": 935342514,
    "dropphyadd": "567 W LANCASTER BLVD",
    "dropphycty": "LANCASTER",
    "dropphyst": "CA",
    "dropphyzpp": 935342514,
    "dropmaladd": "567 W LANCASTER BLVD",
    "dropmalcty": "LANCASTER",
    "dropmalst": "CA",
    "dropmalzpp": 935342514,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619487251,
    "dropsitcph": 6619487251,
    "dropfax": 6619455163
  },
  {
    "dcode": "D",
    "dropkey": "SZ20564",
    "droptype": "D",
    "dropname": "CENTRE",
    "dropdeladd": "3545 EL CAMINO AVE",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958216554,
    "dropphyadd": "3545 EL CAMINO AVE",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958216554,
    "dropmaladd": "3545 EL CAMINO AVE",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958216554,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165743005,
    "dropsitcph": 9165743005,
    "dropfax": 9164879020
  },
  {
    "dcode": "D",
    "dropkey": "SZ20569",
    "droptype": "D",
    "dropname": "CERNON",
    "dropdeladd": "98 CERNON ST",
    "dropdelcty": "VACAVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956889998,
    "dropphyadd": "98 CERNON ST",
    "dropphycty": "VACAVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956889998,
    "dropmaladd": "98 CERNON ST",
    "dropmalcty": "VACAVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956889998,
    "dropsitphn": 9163738025,
    "dropsitlph": 7074516531,
    "dropsitcph": 7074516563,
    "dropfax": 7074499072
  },
  {
    "dcode": "D",
    "dropkey": "SZ20574",
    "droptype": "D",
    "dropname": "CHALLENGER",
    "dropdeladd": "21801 SHERMAN WAY",
    "dropdelcty": "CANOGA PARK",
    "dropdelst": "CA",
    "dropdelzpp": 913039998,
    "dropphyadd": "21801 SHERMAN WAY",
    "dropphycty": "CANOGA PARK",
    "dropphyst": "CA",
    "dropphyzpp": 913039998,
    "dropmaladd": "21801 SHERMAN WAY",
    "dropmalcty": "CANOGA PARK",
    "dropmalst": "CA",
    "dropmalzpp": 913039998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187100034,
    "dropsitcph": 8183406741,
    "dropfax": 8183471026
  },
  {
    "dcode": "D",
    "dropkey": "SZ20576",
    "droptype": "D",
    "dropname": "CHANDLER",
    "dropdeladd": "11304 CHANDLER BLVD",
    "dropdelcty": "NORTH HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 916019998,
    "dropphyadd": "11304 CHANDLER BLVD",
    "dropphycty": "NORTH HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 916019998,
    "dropmaladd": "11304 CHANDLER BLVD",
    "dropmalcty": "NORTH HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 916019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185063651,
    "dropsitcph": 8185063651,
    "dropfax": 7472055576
  },
  {
    "dcode": "D",
    "dropkey": "SZ20587",
    "droptype": "D",
    "dropname": "CHESTNUT",
    "dropdeladd": "36 CHESTNUT AVE",
    "dropdelcty": "SOUTH SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 940809992,
    "dropphyadd": "36 CHESTNUT AVE",
    "dropphycty": "SOUTH SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 940809992,
    "dropmaladd": "36 CHESTNUT AVE",
    "dropmalcty": "SOUTH SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 940809992,
    "dropsitphn": 4155505045,
    "dropsitlph": 6505836389,
    "dropsitcph": 6505834360,
    "dropfax": 6505833485
  },
  {
    "dcode": "D",
    "dropkey": "SZ20595",
    "droptype": "D",
    "dropname": "CHINATOWN",
    "dropdeladd": "867 STOCKTON ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941089991,
    "dropphyadd": "867 STOCKTON ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941089991,
    "dropmaladd": "867 STOCKTON ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941089991,
    "dropsitphn": 4154334919,
    "dropsitlph": 4159863494,
    "dropsitcph": 4159863494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20613",
    "droptype": "D",
    "dropname": "CITY HEIGHTS",
    "dropdeladd": "4193 UNIVERSITY AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921059998,
    "dropphyadd": "4193 UNIVERSITY AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921059998,
    "dropmaladd": "4193 UNIVERSITY AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921059998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192841373,
    "dropsitcph": 6192841092,
    "dropfax": 6192841736
  },
  {
    "dcode": "D",
    "dropkey": "SZ20624",
    "droptype": "D",
    "dropname": "CIVIC CENTER OAKLAND",
    "dropdeladd": "201 13TH ST OFC",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946129991,
    "dropphyadd": "201 13TH ST OFC",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946129991,
    "dropmaladd": "201 13TH ST OFC",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946129991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108748618,
    "dropsitcph": 5106227412,
    "dropfax": 5106227414
  },
  {
    "dcode": "D",
    "dropkey": "SZ20625",
    "droptype": "D",
    "dropname": "CIVIC CENTER SAN RAFAEL",
    "dropdeladd": "2 CIVIC CENTER DR",
    "dropdelcty": "SAN RAFAEL",
    "dropdelst": "CA",
    "dropdelzpp": 949039992,
    "dropphyadd": "2 CIVIC CENTER DR",
    "dropphycty": "SAN RAFAEL",
    "dropphyst": "CA",
    "dropphyzpp": 949039992,
    "dropmaladd": "2 CIVIC CENTER DR",
    "dropmalcty": "SAN RAFAEL",
    "dropmalst": "CA",
    "dropmalzpp": 949039992,
    "dropsitphn": 7077785461,
    "dropsitlph": 4154799563,
    "dropsitcph": 4154798261,
    "dropfax": 4154791713
  },
  {
    "dcode": "D",
    "dropkey": "SZ20645",
    "droptype": "D",
    "dropname": "CLINTER",
    "dropdeladd": "2601 E OLIVE AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937019998,
    "dropphyadd": "2601 E OLIVE AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937019998,
    "dropmaladd": "2601 E OLIVE AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937019998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594420128,
    "dropsitcph": 5594420161,
    "dropfax": 5594867859
  },
  {
    "dcode": "D",
    "dropkey": "SZ20657",
    "droptype": "D",
    "dropname": "COAST GUARD ISLAND",
    "dropdeladd": "2 EAGLE RD BLDG 22",
    "dropdelcty": "ALAMEDA",
    "dropdelst": "CA",
    "dropdelzpp": 945015100,
    "dropphyadd": "2 EAGLE RD BLDG 22",
    "dropphycty": "ALAMEDA",
    "dropphyst": "CA",
    "dropphyzpp": 945015100,
    "dropmaladd": "2201 SHORELINE DR",
    "dropmalcty": "ALAMEDA",
    "dropmalst": "CA",
    "dropmalzpp": 945019998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 5107484156,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20660",
    "droptype": "D",
    "dropname": "CODDINGTOWN",
    "dropdeladd": "1200 CODDINGTOWN CTR",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "CA",
    "dropdelzpp": 954013500,
    "dropphyadd": "1200 CODDINGTOWN CTR",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "CA",
    "dropphyzpp": 954013500,
    "dropmaladd": "1200 CODDINGTOWN CTR",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "CA",
    "dropmalzpp": 954013500,
    "dropsitphn": 7077785461,
    "dropsitlph": 7075441427,
    "dropsitcph": 7075282209,
    "dropfax": 7075451427
  },
  {
    "dcode": "D",
    "dropkey": "SZ20672",
    "droptype": "D",
    "dropname": "COLMA",
    "dropdeladd": "7373 MISSION ST",
    "dropdelcty": "DALY CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940149991,
    "dropphyadd": "7373 MISSION ST",
    "dropphycty": "DALY CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940149991,
    "dropmaladd": "7373 MISSION ST",
    "dropmalcty": "DALY CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940149991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507550281,
    "dropsitcph": 6507550281,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20674",
    "droptype": "D",
    "dropname": "COLONIAL",
    "dropdeladd": "6024 44TH ST",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958249998,
    "dropphyadd": "6024 44TH ST",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958249998,
    "dropmaladd": "6024 44TH ST",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958249998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163075530,
    "dropsitcph": 9162623128,
    "dropfax": 9164224625
  },
  {
    "dcode": "D",
    "dropkey": "SZ20675",
    "droptype": "D",
    "dropname": "COLONNADE",
    "dropdeladd": "200 S 3RD ST",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951129998,
    "dropphyadd": "200 S 3RD ST",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951129998,
    "dropmaladd": "200 S 3RD ST",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951129998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4089982385,
    "dropsitcph": 4082926285,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20677",
    "droptype": "D",
    "dropname": "COLORADO",
    "dropdeladd": "1653 7TH ST",
    "dropdelcty": "SANTA MONICA",
    "dropdelst": "CA",
    "dropdelzpp": 904019997,
    "dropphyadd": "1653 7TH ST",
    "dropphycty": "SANTA MONICA",
    "dropphyst": "CA",
    "dropphyzpp": 904019995,
    "dropmaladd": "1653 7TH ST",
    "dropmalcty": "SANTA MONICA",
    "dropmalst": "CA",
    "dropmalzpp": 904019997,
    "dropsitphn": 5625769240,
    "dropsitlph": 3105760591,
    "dropsitcph": 3105766539,
    "dropfax": 3102609868
  },
  {
    "dcode": "D",
    "dropkey": "SZ20678",
    "droptype": "D",
    "dropname": "COLORADO MAIL FACILITY",
    "dropdeladd": "1020 COLORADO AVE",
    "dropdelcty": "SANTA MONICA",
    "dropdelst": "CA",
    "dropdelzpp": 904019990,
    "dropphyadd": "1020 COLORADO AVE",
    "dropphycty": "SANTA MONICA",
    "dropphyst": "CA",
    "dropphyzpp": 904019990,
    "dropmaladd": "1020 COLORADO AVE",
    "dropmalcty": "SANTA MONICA",
    "dropmalst": "CA",
    "dropmalzpp": 904019990,
    "dropsitphn": "",
    "dropsitlph": 3105760591,
    "dropsitcph": 3105766539,
    "dropfax": 3102609868
  },
  {
    "dcode": "D",
    "dropkey": "SZ20688",
    "droptype": "D",
    "dropname": "COMMONWEALTH",
    "dropdeladd": "202 E COMMONWEALTH AVE",
    "dropdelcty": "FULLERTON",
    "dropdelst": "CA",
    "dropdelzpp": 928369998,
    "dropphyadd": "202 E COMMONWEALTH AVE",
    "dropphycty": "FULLERTON",
    "dropphyst": "CA",
    "dropphyzpp": 928369998,
    "dropmaladd": "1350 E CHAPMAN AVE",
    "dropmalcty": "FULLERTON",
    "dropmalst": "CA",
    "dropmalzpp": 928349998,
    "dropsitphn": 7148792803,
    "dropsitlph": 7148791859,
    "dropsitcph": 7148792803,
    "dropfax": 7148799354
  },
  {
    "dcode": "D",
    "dropkey": "SZ20694",
    "droptype": "D",
    "dropname": "CONEJO VALLEY",
    "dropdeladd": "235 N MOORPARK RD STE A",
    "dropdelcty": "THOUSAND OAKS",
    "dropdelst": "CA",
    "dropdelzpp": 913609998,
    "dropphyadd": "235 N MOORPARK RD STE A",
    "dropphycty": "THOUSAND OAKS",
    "dropphyst": "CA",
    "dropphyzpp": 913609998,
    "dropmaladd": "235 N MOORPARK RD STE A",
    "dropmalcty": "THOUSAND OAKS",
    "dropmalst": "CA",
    "dropmalzpp": 913609998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8057781058,
    "dropsitcph": 8057781058,
    "dropfax": 8053794301
  },
  {
    "dcode": "D",
    "dropkey": "SZ20771",
    "droptype": "D",
    "dropname": "COURT",
    "dropdeladd": "815 COURT ST",
    "dropdelcty": "MARTINEZ",
    "dropdelst": "CA",
    "dropdelzpp": 945539991,
    "dropphyadd": "815 COURT ST",
    "dropphycty": "MARTINEZ",
    "dropphyst": "CA",
    "dropphyzpp": 945539991,
    "dropmaladd": "815 COURT ST",
    "dropmalcty": "MARTINEZ",
    "dropmalst": "CA",
    "dropmalzpp": 945539991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9252289875,
    "dropsitcph": 9252294795,
    "dropfax": 9258748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20778",
    "droptype": "D",
    "dropname": "CRENSHAW",
    "dropdeladd": "3894 CRENSHAW BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900089998,
    "dropphyadd": "3894 CRENSHAW BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900089998,
    "dropmaladd": "3894 CRENSHAW BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900089998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232953503,
    "dropsitcph": 3232950099,
    "dropfax": 3235861498
  },
  {
    "dcode": "D",
    "dropkey": "SZ20779",
    "droptype": "D",
    "dropname": "CRENSHAW IMPERIAL",
    "dropdeladd": "2672 W IMPERIAL HWY",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903039998,
    "dropphyadd": "2672 W IMPERIAL HWY",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903039998,
    "dropmaladd": "2672 W IMPERIAL HWY",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903039998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3237550201,
    "dropsitcph": 3237550174,
    "dropfax": 3237550159
  },
  {
    "dcode": "D",
    "dropkey": "SZ20780",
    "droptype": "D",
    "dropname": "CRESCENT",
    "dropdeladd": "323 N CRESCENT DR",
    "dropdelcty": "BEVERLY HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 902109997,
    "dropphyadd": "323 N CRESCENT DR",
    "dropphycty": "BEVERLY HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 902109997,
    "dropmaladd": "323 N CRESCENT DR",
    "dropmalcty": "BEVERLY HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 902109997,
    "dropsitphn": 5624942406,
    "dropsitlph": 3102473464,
    "dropsitcph": 3102473470,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20798",
    "droptype": "D",
    "dropname": "CROSSROADS PLAZA",
    "dropdeladd": "9160 WHITTIER BLVD",
    "dropdelcty": "PICO RIVERA",
    "dropdelst": "CA",
    "dropdelzpp": 906609997,
    "dropphyadd": "9160 WHITTIER BLVD",
    "dropphycty": "PICO RIVERA",
    "dropphyst": "CA",
    "dropphyzpp": 906609997,
    "dropmaladd": "9160 WHITTIER BLVD",
    "dropmalcty": "PICO RIVERA",
    "dropmalst": "CA",
    "dropmalzpp": 906609997,
    "dropsitphn": 5629481217,
    "dropsitlph": 5629485058,
    "dropsitcph": 5629481217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20822",
    "droptype": "D",
    "dropname": "CYPRESS SOUTH",
    "dropdeladd": "5907 CERRITOS AVE",
    "dropdelcty": "CYPRESS",
    "dropdelst": "CA",
    "dropdelzpp": 906309997,
    "dropphyadd": "5907 CERRITOS AVE",
    "dropphycty": "CYPRESS",
    "dropphyst": "CA",
    "dropphyzpp": 906309997,
    "dropmaladd": "5762 LINCOLN AVE",
    "dropmalcty": "CYPRESS",
    "dropmalst": "CA",
    "dropmalzpp": 906309998,
    "dropsitphn": 7148287029,
    "dropsitlph": 7148278370,
    "dropsitcph": 7148287029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20823",
    "droptype": "D",
    "dropname": "BYRON RUMFORD",
    "dropdeladd": "1301 CLAY ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946125200,
    "dropphyadd": "1301 CLAY ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946125200,
    "dropmaladd": "1301 CLAY ST STE 140N",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946129996,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106374347,
    "dropsitcph": 5106374347,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20847",
    "droptype": "D",
    "dropname": "DEL AMO",
    "dropdeladd": "291 DEL AMO FASHION SQ",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905039997,
    "dropphyadd": "291 DEL AMO FASHION SQ",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905039997,
    "dropmaladd": "291 DEL AMO FASHION SQ",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905039997,
    "dropsitphn": 5624942406,
    "dropsitlph": "",
    "dropsitcph": 3102225902,
    "dropfax": 3102141746
  },
  {
    "dcode": "D",
    "dropkey": "SZ20852",
    "droptype": "D",
    "dropname": "DEL PASO HEIGHTS",
    "dropdeladd": "3817 MARYSVILLE BLVD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958389998,
    "dropphyadd": "3817 MARYSVILLE BLVD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958389998,
    "dropmaladd": "3817 MARYSVILLE BLVD",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958389998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162396427,
    "dropsitcph": 9162637044,
    "dropfax": 9169248579
  },
  {
    "dcode": "D",
    "dropkey": "SZ20857",
    "droptype": "D",
    "dropname": "DEL ROSA",
    "dropdeladd": "1663 E DATE PL",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924044496,
    "dropphyadd": "1663 E DATE PL",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924044496,
    "dropmaladd": "1663 E DATE PL",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924044496,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098862414,
    "dropsitcph": 9098825294,
    "dropfax": 9098823894
  },
  {
    "dcode": "D",
    "dropkey": "SZ20862",
    "droptype": "D",
    "dropname": "DEL VALLE",
    "dropdeladd": "819 W WASHINGTON BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900159997,
    "dropphyadd": "819 W WASHINGTON BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900159997,
    "dropmaladd": "819 W WASHINGTON BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900159997,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 2137499911,
    "dropfax": 3235861498
  },
  {
    "dcode": "D",
    "dropkey": "SZ20866",
    "droptype": "D",
    "dropname": "DELL",
    "dropdeladd": "1587 DELL AVE",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "CA",
    "dropdelzpp": 950086903,
    "dropphyadd": "1587 DELL AVE",
    "dropphycty": "CAMPBELL",
    "dropphyst": "CA",
    "dropphyzpp": 950086903,
    "dropmaladd": "101 S SANTA CRUZ AVE",
    "dropmalcty": "LOS GATOS",
    "dropmalst": "CA",
    "dropmalzpp": 950309998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4083787978,
    "dropsitcph": 4083780630,
    "dropfax": 4083785129
  },
  {
    "dcode": "D",
    "dropkey": "SZ20883",
    "droptype": "D",
    "dropname": "DIAMOND",
    "dropdeladd": "1517 S GREENVILLE ST",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927049998,
    "dropphyadd": "1517 S GREENVILLE ST",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927049998,
    "dropmaladd": "1517 S GREENVILLE ST",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927049998,
    "dropsitphn": 7145451716,
    "dropsitlph": 7145454483,
    "dropsitcph": 7145451716,
    "dropfax": 7145452958
  },
  {
    "dcode": "D",
    "dropkey": "SZ20891",
    "droptype": "D",
    "dropname": "DIMOND",
    "dropdeladd": "2226 MACARTHUR BLVD",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946029991,
    "dropphyadd": "2226 MACARTHUR BLVD",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946029991,
    "dropmaladd": "2226 MACARTHUR BLVD",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946029991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513112,
    "dropsitcph": 5102513110,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20899",
    "droptype": "D",
    "dropname": "DOCKWEILER",
    "dropdeladd": "3585 S VERMONT AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900079998,
    "dropphyadd": "3585 S VERMONT AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900079998,
    "dropmaladd": "3585 S VERMONT AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900079998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3237310278,
    "dropsitcph": 3237319458,
    "dropfax": 3235861498
  },
  {
    "dcode": "D",
    "dropkey": "SZ20906",
    "droptype": "D",
    "dropname": "DONNER",
    "dropdeladd": "11415 DEERFIELD DR",
    "dropdelcty": "TRUCKEE",
    "dropdelst": "CA",
    "dropdelzpp": 961619997,
    "dropphyadd": "11415 DEERFIELD DR",
    "dropphycty": "TRUCKEE",
    "dropphyst": "CA",
    "dropphyzpp": 961619997,
    "dropmaladd": "11415 DEERFIELD DR",
    "dropmalcty": "TRUCKEE",
    "dropmalst": "CA",
    "dropmalzpp": 961619997,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305871750,
    "dropsitcph": 5305874835,
    "dropfax": 5305877267
  },
  {
    "dcode": "D",
    "dropkey": "SZ20918",
    "droptype": "D",
    "dropname": "DOWNTOWN AUBURN",
    "dropdeladd": "100 HARRISON AVE",
    "dropdelcty": "AUBURN",
    "dropdelst": "CA",
    "dropdelzpp": 956039997,
    "dropphyadd": "100 HARRISON AVE",
    "dropphycty": "AUBURN",
    "dropphyst": "CA",
    "dropphyzpp": 956039997,
    "dropmaladd": "100 HARRISON AVE",
    "dropmalcty": "AUBURN",
    "dropmalst": "CA",
    "dropmalzpp": 956039997,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308857819,
    "dropsitcph": 5308857819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20919",
    "droptype": "D",
    "dropname": "DOWNTOWN BAKERSFIELD",
    "dropdeladd": "1730 18TH ST",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933014328,
    "dropphyadd": "1730 18TH ST",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933014328,
    "dropmaladd": "1730 18TH ST",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933014328,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618614383,
    "dropsitcph": 6618614383,
    "dropfax": 6618614108
  },
  {
    "dcode": "D",
    "dropkey": "SZ20920",
    "droptype": "D",
    "dropname": "DOWNTOWN BURBANK",
    "dropdeladd": "135 E OLIVE AVE",
    "dropdelcty": "BURBANK",
    "dropdelst": "CA",
    "dropdelzpp": 915029998,
    "dropphyadd": "135 E OLIVE AVE",
    "dropphycty": "BURBANK",
    "dropphyst": "CA",
    "dropphyzpp": 915029998,
    "dropmaladd": "135 E OLIVE AVE",
    "dropmalcty": "BURBANK",
    "dropmalst": "CA",
    "dropmalzpp": 915029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188461492,
    "dropsitcph": 8188461492,
    "dropfax": 7472343028
  },
  {
    "dcode": "D",
    "dropkey": "SZ20921",
    "droptype": "D",
    "dropname": "DOWNTOWN LONG BEACH",
    "dropdeladd": "300 LONG BEACH BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908029991,
    "dropphyadd": "300 LONG BEACH BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908029991,
    "dropmaladd": "300 LONG BEACH BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908029991,
    "dropsitphn": 5626281303,
    "dropsitlph": 5624369402,
    "dropsitcph": 5626281303,
    "dropfax": 5624357942
  },
  {
    "dcode": "D",
    "dropkey": "SZ20922",
    "droptype": "D",
    "dropname": "DOWNTOWN MANHATTAN BEACH",
    "dropdeladd": "425 15TH ST STE C",
    "dropdelcty": "MANHATTAN BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902669993,
    "dropphyadd": "425 15TH ST STE C",
    "dropphycty": "MANHATTAN BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902669993,
    "dropmaladd": "425 15TH ST STE C",
    "dropmalcty": "MANHATTAN BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902669993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3107968906,
    "dropsitcph": 3104140350,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20923",
    "droptype": "D",
    "dropname": "DOWNTOWN ONTARIO",
    "dropdeladd": "123 W HOLT BLVD",
    "dropdelcty": "ONTARIO",
    "dropdelst": "CA",
    "dropdelzpp": 917629998,
    "dropphyadd": "123 W HOLT BLVD",
    "dropphycty": "ONTARIO",
    "dropphyst": "CA",
    "dropphyzpp": 917629998,
    "dropmaladd": "123 W HOLT BLVD",
    "dropmalcty": "ONTARIO",
    "dropmalst": "CA",
    "dropmalzpp": 917629998,
    "dropsitphn": 9099333837,
    "dropsitlph": 9099842937,
    "dropsitcph": 9099333837,
    "dropfax": 9093910595
  },
  {
    "dcode": "D",
    "dropkey": "SZ20924",
    "droptype": "D",
    "dropname": "DOWNTOWN REDDING",
    "dropdeladd": "1647 YUBA ST",
    "dropdelcty": "REDDING",
    "dropdelst": "CA",
    "dropdelzpp": 960019998,
    "dropphyadd": "1647 YUBA ST",
    "dropphycty": "REDDING",
    "dropphyst": "CA",
    "dropphyzpp": 960019998,
    "dropmaladd": "1647 YUBA ST",
    "dropmalcty": "REDDING",
    "dropmalst": "CA",
    "dropmalzpp": 960019998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5309996631,
    "dropsitcph": 5302462571,
    "dropfax": 5309996697
  },
  {
    "dcode": "D",
    "dropkey": "SZ20925",
    "droptype": "D",
    "dropname": "DOWNTOWN REDWOOD CITY",
    "dropdeladd": "855 JEFFERSON AVE",
    "dropdelcty": "REDWOOD CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940639992,
    "dropphyadd": "855 JEFFERSON AVE",
    "dropphycty": "REDWOOD CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940639992,
    "dropmaladd": "855 JEFFERSON AVE",
    "dropmalcty": "REDWOOD CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940639992,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503695229,
    "dropsitcph": 6503684163,
    "dropfax": 6503690132
  },
  {
    "dcode": "D",
    "dropkey": "SZ20926",
    "droptype": "D",
    "dropname": "DOWNTOWN RIVERSIDE",
    "dropdeladd": "3890 ORANGE ST",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 925019998,
    "dropphyadd": "3890 ORANGE ST",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 925019998,
    "dropmaladd": "3890 ORANGE ST",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 925019998,
    "dropsitphn": 9513354694,
    "dropsitlph": 9516821050,
    "dropsitcph": 9512766252,
    "dropfax": 9516821943
  },
  {
    "dcode": "D",
    "dropkey": "SZ20928",
    "droptype": "D",
    "dropname": "DOWNTOWN SAN DIEGO",
    "dropdeladd": "815 E ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921019998,
    "dropphyadd": "815 E ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921019998,
    "dropmaladd": "815 E ST",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921019998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192327473,
    "dropsitcph": 6192328612,
    "dropfax": 6192326004
  },
  {
    "dcode": "D",
    "dropkey": "SZ20929",
    "droptype": "D",
    "dropname": "DOWNTOWN SONORA",
    "dropdeladd": "83 S STEWART ST FRNT",
    "dropdelcty": "SONORA",
    "dropdelst": "CA",
    "dropdelzpp": 953709997,
    "dropphyadd": "83 S STEWART ST FRNT",
    "dropphycty": "SONORA",
    "dropphyst": "CA",
    "dropphyzpp": 953709997,
    "dropmaladd": "83 S STEWART ST FRNT",
    "dropmalcty": "SONORA",
    "dropmalst": "CA",
    "dropmalzpp": 953709997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095330814,
    "dropsitcph": 2095330814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20950",
    "droptype": "D",
    "dropname": "STATION E",
    "dropdeladd": "1954 MOUNTAIN BLVD",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946112813,
    "dropphyadd": "1954 MOUNTAIN BLVD",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946112813,
    "dropmaladd": "PO BOX 99993",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946619993,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513350,
    "dropsitcph": 5102513349,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20951",
    "droptype": "D",
    "dropname": "BRANNAN STREET",
    "dropdeladd": "460 BRANNAN ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941079991,
    "dropphyadd": "460 BRANNAN ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941079991,
    "dropmaladd": "460 BRANNAN ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941079991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156262932,
    "dropsitcph": 4156262932,
    "dropfax": 4154952779
  },
  {
    "dcode": "D",
    "dropkey": "SZ20958",
    "droptype": "D",
    "dropname": "EAGLE ROCK",
    "dropdeladd": "7435 N FIGUEROA ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900411709,
    "dropphyadd": "7435 N FIGUEROA ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900419998,
    "dropmaladd": "7435 N FIGUEROA ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900419998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232543769,
    "dropsitcph": 3232546033,
    "dropfax": 3232544293
  },
  {
    "dcode": "D",
    "dropkey": "SZ20964",
    "droptype": "D",
    "dropname": "EAST BAKERSFIELD",
    "dropdeladd": "727 KENTUCKY ST",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933059998,
    "dropphyadd": "727 KENTUCKY ST",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933059998,
    "dropmaladd": "727 KENTUCKY ST",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613227624,
    "dropsitcph": 6613277813,
    "dropfax": 6613273647
  },
  {
    "dcode": "D",
    "dropkey": "SZ20967",
    "droptype": "D",
    "dropname": "EAST FRESNO",
    "dropdeladd": "5555 E TULARE ST",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937273396,
    "dropphyadd": "5555 E TULARE ST",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937273396,
    "dropmaladd": "5555 E TULARE ST",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937273396,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592551068,
    "dropsitcph": 5592551068,
    "dropfax": 5598605056
  },
  {
    "dcode": "D",
    "dropkey": "SZ20975",
    "droptype": "D",
    "dropname": "EAST LONG BEACH",
    "dropdeladd": "2727 E ANAHEIM ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908049998,
    "dropphyadd": "2727 E ANAHEIM ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908049998,
    "dropmaladd": "2727 E ANAHEIM ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908049998,
    "dropsitphn": 5624390498,
    "dropsitlph": 5624390498,
    "dropsitcph": 5624348769,
    "dropfax": 5624344589
  },
  {
    "dcode": "D",
    "dropkey": "SZ20977",
    "droptype": "D",
    "dropname": "EAST LYNWOOD",
    "dropdeladd": "11634 ATLANTIC AVE",
    "dropdelcty": "LYNWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 902629993,
    "dropphyadd": "11634 ATLANTIC AVE",
    "dropphycty": "LYNWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 902629993,
    "dropmaladd": "11634 ATLANTIC AVE",
    "dropmalcty": "LYNWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 902629993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106327560,
    "dropsitcph": 3106389074,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20985",
    "droptype": "D",
    "dropname": "EAST STOCKTON",
    "dropdeladd": "3333 E MAIN ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952059998,
    "dropphyadd": "3333 E MAIN ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952059998,
    "dropmaladd": "3333 E MAIN ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952059998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094665418,
    "dropsitcph": 2094664918,
    "dropfax": 2094663852
  },
  {
    "dcode": "D",
    "dropkey": "SZ20986",
    "droptype": "D",
    "dropname": "EAST VENTURA",
    "dropdeladd": "41 S WAKE FOREST AVE",
    "dropdelcty": "VENTURA",
    "dropdelst": "CA",
    "dropdelzpp": 930039998,
    "dropphyadd": "41 S WAKE FOREST AVE",
    "dropphycty": "VENTURA",
    "dropphyst": "CA",
    "dropphyzpp": 930039998,
    "dropmaladd": "41 S WAKE FOREST AVE",
    "dropmalcty": "VENTURA",
    "dropmalst": "CA",
    "dropmalzpp": 930039998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056420925,
    "dropsitcph": 8056421521,
    "dropfax": 8056432831
  },
  {
    "dcode": "D",
    "dropkey": "SZ20989",
    "droptype": "D",
    "dropname": "EASTMONT",
    "dropdeladd": "8033 MACARTHUR BLVD",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946059991,
    "dropphyadd": "8033 MACARTHUR BLVD",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946059991,
    "dropmaladd": "8033 MACARTHUR BLVD",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946059991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513385,
    "dropsitcph": 5102513384,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ20991",
    "droptype": "D",
    "dropname": "EASTRIDGE",
    "dropdeladd": "2200 EASTRIDGE LOOP STE 1062",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951221412,
    "dropphyadd": "2200 EASTRIDGE LOOP STE 1062",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951221412,
    "dropmaladd": "2200 EASTRIDGE LOOP STE 1062",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951221412,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082702368,
    "dropsitcph": 4082702368,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ20993",
    "droptype": "D",
    "dropname": "EASTVIEW",
    "dropdeladd": "28649 S WESTERN AVE",
    "dropdelcty": "SAN PEDRO",
    "dropdelst": "CA",
    "dropdelzpp": 907349998,
    "dropphyadd": "28649 S WESTERN AVE",
    "dropphycty": "SAN PEDRO",
    "dropphyst": "CA",
    "dropphyzpp": 907349998,
    "dropmaladd": "28649 S WESTERN AVE",
    "dropmalcty": "SAN PEDRO",
    "dropmalst": "CA",
    "dropmalzpp": 907349998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3108313222,
    "dropsitcph": 3105471582,
    "dropfax": 3108337917
  },
  {
    "dcode": "D",
    "dropkey": "SZ20998",
    "droptype": "D",
    "dropname": "EDENDALE",
    "dropdeladd": "1525 N ALVARADO ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900269998,
    "dropphyadd": "1525 N ALVARADO ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900269998,
    "dropmaladd": "1525 N ALVARADO ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900269998,
    "dropsitphn": 3235861867,
    "dropsitlph": 2134132964,
    "dropsitcph": 2134133839,
    "dropfax": 2134131654
  },
  {
    "dcode": "D",
    "dropkey": "SZ21022",
    "droptype": "D",
    "dropname": "EL MODENA",
    "dropdeladd": "3744 E CHAPMAN AVE STE F",
    "dropdelcty": "ORANGE",
    "dropdelst": "CA",
    "dropdelzpp": 928599998,
    "dropphyadd": "3744 E CHAPMAN AVE STE F",
    "dropphycty": "ORANGE",
    "dropphyst": "CA",
    "dropphyzpp": 928599998,
    "dropmaladd": "1075 N TUSTIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "CA",
    "dropmalzpp": 928639998,
    "dropsitphn": 7146390488,
    "dropsitlph": 7146393205,
    "dropsitcph": 7146390488,
    "dropfax": 7146390488
  },
  {
    "dcode": "D",
    "dropkey": "SZ21047",
    "droptype": "D",
    "dropname": "ELMWOOD",
    "dropdeladd": "2705 WEBSTER ST",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947059991,
    "dropphyadd": "2705 WEBSTER ST",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947059991,
    "dropmaladd": "2705 WEBSTER ST",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947059991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493140,
    "dropsitcph": 5106496716,
    "dropfax": 5106493168
  },
  {
    "dcode": "D",
    "dropkey": "SZ21051",
    "droptype": "D",
    "dropname": "EMBARCADERO",
    "dropdeladd": "226 HARRISON ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941052005,
    "dropphyadd": "226 HARRISON ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941052005,
    "dropmaladd": "226 HARRISON ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941052005,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155366411,
    "dropsitcph": 4155366412,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21057",
    "droptype": "D",
    "dropname": "ENCANTO",
    "dropdeladd": "5505 STEVENS WAY",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921149998,
    "dropphyadd": "5505 STEVENS WAY",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921149998,
    "dropmaladd": "5505 STEVENS WAY",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921149998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192640789,
    "dropsitcph": 6192641780,
    "dropfax": 6192646138
  },
  {
    "dcode": "D",
    "dropkey": "SZ21058",
    "droptype": "D",
    "dropname": "ENCINAL",
    "dropdeladd": "526 W FREMONT AVE",
    "dropdelcty": "SUNNYVALE",
    "dropdelst": "CA",
    "dropdelzpp": 940879991,
    "dropphyadd": "526 W FREMONT AVE",
    "dropphycty": "SUNNYVALE",
    "dropphyst": "CA",
    "dropphyzpp": 940879991,
    "dropmaladd": "526 W FREMONT AVE",
    "dropmalcty": "SUNNYVALE",
    "dropmalst": "CA",
    "dropmalzpp": 940879991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4082456228,
    "dropsitcph": 4082451783,
    "dropfax": 4082452806
  },
  {
    "dcode": "D",
    "dropkey": "SZ21065",
    "droptype": "D",
    "dropname": "ESCONDIDO POSTAL STORE",
    "dropdeladd": "403 N ESCONDIDO BLVD",
    "dropdelcty": "ESCONDIDO",
    "dropdelst": "CA",
    "dropdelzpp": 920259997,
    "dropphyadd": "403 N ESCONDIDO BLVD",
    "dropphycty": "ESCONDIDO",
    "dropphyst": "CA",
    "dropphyzpp": 920259997,
    "dropmaladd": "403 N ESCONDIDO BLVD",
    "dropmalcty": "ESCONDIDO",
    "dropmalst": "CA",
    "dropmalzpp": 920259997,
    "dropsitphn": 8586740173,
    "dropsitlph": 7604326379,
    "dropsitcph": 7607359507,
    "dropfax": 7604329492
  },
  {
    "dcode": "D",
    "dropkey": "SZ21068",
    "droptype": "D",
    "dropname": "ESTUDILLO",
    "dropdeladd": "1319 WASHINGTON AVE",
    "dropdelcty": "SAN LEANDRO",
    "dropdelst": "CA",
    "dropdelzpp": 945779991,
    "dropphyadd": "1319 WASHINGTON AVE",
    "dropphycty": "SAN LEANDRO",
    "dropphyst": "CA",
    "dropphyzpp": 945779991,
    "dropmaladd": "1319 WASHINGTON AVE",
    "dropmalcty": "SAN LEANDRO",
    "dropmalst": "CA",
    "dropmalzpp": 945779991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5104831847,
    "dropsitcph": 5104831629,
    "dropfax": 5106148183
  },
  {
    "dcode": "D",
    "dropkey": "SZ21076",
    "droptype": "D",
    "dropname": "EXCELSIOR",
    "dropdeladd": "15 ONONDAGA AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941129991,
    "dropphyadd": "15 ONONDAGA AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941129991,
    "dropmaladd": "15 ONONDAGA AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941129991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4152854662,
    "dropsitcph": 4152854662,
    "dropfax": 4153339085
  },
  {
    "dcode": "D",
    "dropkey": "SZ21084",
    "droptype": "D",
    "dropname": "FAIRMOUNT",
    "dropdeladd": "6324 FAIRMOUNT AVE",
    "dropdelcty": "EL CERRITO",
    "dropdelst": "CA",
    "dropdelzpp": 945303651,
    "dropphyadd": "6324 FAIRMOUNT AVE",
    "dropphycty": "EL CERRITO",
    "dropphyst": "CA",
    "dropphyzpp": 945303651,
    "dropmaladd": "11135 SAN PABLO AVE",
    "dropmalcty": "EL CERRITO",
    "dropmalst": "CA",
    "dropmalzpp": 945309998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5105250359,
    "dropsitcph": 5105250327,
    "dropfax": 5102355981
  },
  {
    "dcode": "D",
    "dropkey": "SZ21098",
    "droptype": "D",
    "dropname": "MISSION VALLEY",
    "dropdeladd": "1640 CAMINO DEL RIO N STE 202",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921089998,
    "dropphyadd": "1640 CAMINO DEL RIO N STE 202",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921089998,
    "dropmaladd": "1640 CAMINO DEL RIO N STE 202",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921089998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196832040,
    "dropsitcph": 6196832401,
    "dropfax": 6196832403
  },
  {
    "dcode": "D",
    "dropkey": "SZ21102",
    "droptype": "D",
    "dropname": "FEDERAL ANAHEIM",
    "dropdeladd": "333 W BROADWAY",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928159000,
    "dropphyadd": "333 W BROADWAY",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928159000,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7145202639,
    "dropsitlph": 7146359926,
    "dropsitcph": 7145202639,
    "dropfax": 7146359939
  },
  {
    "dcode": "D",
    "dropkey": "SZ21103",
    "droptype": "D",
    "dropname": "FEDERAL COVINA",
    "dropdeladd": "170 E COLLEGE ST",
    "dropdelcty": "COVINA",
    "dropdelst": "CA",
    "dropdelzpp": 917239998,
    "dropphyadd": "170 E COLLEGE ST",
    "dropphycty": "COVINA",
    "dropphyst": "CA",
    "dropphyzpp": 917239998,
    "dropmaladd": "545 N RIMSDALE AVE",
    "dropmalcty": "COVINA",
    "dropmalst": "CA",
    "dropmalzpp": 917229998,
    "dropsitphn": 6263399125,
    "dropsitlph": 6263399483,
    "dropsitcph": 6263399125,
    "dropfax": 6269663472
  },
  {
    "dcode": "D",
    "dropkey": "SZ21108",
    "droptype": "D",
    "dropname": "FEDERAL BUILDING OXNARD",
    "dropdeladd": "350 S A ST",
    "dropdelcty": "OXNARD",
    "dropdelst": "CA",
    "dropdelzpp": 930305899,
    "dropphyadd": "350 S A ST",
    "dropphycty": "OXNARD",
    "dropphyst": "CA",
    "dropphyzpp": 930305899,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "OXNARD",
    "dropmalst": "CA",
    "dropmalzpp": 930329998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8054866589,
    "dropsitcph": 8052787615,
    "dropfax": 8052787621
  },
  {
    "dcode": "D",
    "dropkey": "SZ21109",
    "droptype": "D",
    "dropname": "FEDERAL BUILDING SAN FRAN",
    "dropdeladd": "450 GOLDEN GATE AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941023661,
    "dropphyadd": "450 GOLDEN GATE AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941023661,
    "dropmaladd": "450 GOLDEN GATE AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941023661,
    "dropsitphn": 4159311053,
    "dropsitlph": 4159311053,
    "dropsitcph": 4159311053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21124",
    "droptype": "D",
    "dropname": "SAN BERNARDINO MO FINANCE",
    "dropdeladd": "455 ORANGE SHOW LN",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924082024,
    "dropphyadd": "455 ORANGE SHOW LN",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924082024,
    "dropmaladd": "455 ORANGE SHOW LN",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924082024,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098849918,
    "dropsitcph": 9098884282,
    "dropfax": 9098890374
  },
  {
    "dcode": "D",
    "dropkey": "SZ21125",
    "droptype": "D",
    "dropname": "FINANCIAL PLAZA",
    "dropdeladd": "555 S PALM CANYON DR STE A105",
    "dropdelcty": "PALM SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 922649997,
    "dropphyadd": "555 S PALM CANYON DR STE A105",
    "dropphycty": "PALM SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 922649997,
    "dropmaladd": "555 S PALM CANYON DR STE A105",
    "dropmalcty": "PALM SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 922649997,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603253101,
    "dropsitcph": 7603253101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21130",
    "droptype": "D",
    "dropname": "FIRESTONE",
    "dropdeladd": "3270 FIRESTONE BLVD",
    "dropdelcty": "SOUTH GATE",
    "dropdelst": "CA",
    "dropdelzpp": 902809993,
    "dropphyadd": "3270 FIRESTONE BLVD",
    "dropphycty": "SOUTH GATE",
    "dropphyst": "CA",
    "dropphyzpp": 902809993,
    "dropmaladd": "3270 FIRESTONE BLVD",
    "dropmalcty": "SOUTH GATE",
    "dropmalst": "CA",
    "dropmalzpp": 902809993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3235699336,
    "dropsitcph": 3235664165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21137",
    "droptype": "D",
    "dropname": "FIRST STREET",
    "dropdeladd": "517 SEAGAZE DR",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 920543004,
    "dropphyadd": "517 SEAGAZE DR",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 920543004,
    "dropmaladd": "517 SEAGAZE DR",
    "dropmalcty": "OCEANSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 920543004,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607225873,
    "dropsitcph": 7604330206,
    "dropfax": 7607221144
  },
  {
    "dcode": "D",
    "dropkey": "SZ21148",
    "droptype": "D",
    "dropname": "FLORIN",
    "dropdeladd": "7250 ELK GROVE FLORIN RD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958299998,
    "dropphyadd": "7250 ELK GROVE FLORIN RD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958299998,
    "dropmaladd": "7250 ELK GROVE FLORIN RD",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958299998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163075721,
    "dropsitcph": 9162276510,
    "dropfax": 9163815167
  },
  {
    "dcode": "D",
    "dropkey": "SZ21156",
    "droptype": "D",
    "dropname": "FOOTHILL FARMS",
    "dropdeladd": "5420 KOHLER RD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958419998,
    "dropphyadd": "5420 KOHLER RD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958419998,
    "dropmaladd": "5420 KOHLER RD",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958419998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165743072,
    "dropsitcph": 9165743002,
    "dropfax": 9163390357
  },
  {
    "dcode": "D",
    "dropkey": "SZ21178",
    "droptype": "D",
    "dropname": "FORT MAC ARTHUR",
    "dropdeladd": "2900 S PACIFIC AVE BLDG 418",
    "dropdelcty": "SAN PEDRO",
    "dropdelst": "CA",
    "dropdelzpp": 907319996,
    "dropphyadd": "2900 S PACIFIC AVE BLDG 418",
    "dropphycty": "SAN PEDRO",
    "dropphyst": "CA",
    "dropphyzpp": 907319996,
    "dropmaladd": "2900 S PACIFIC AVE BLDG 418",
    "dropmalcty": "SAN PEDRO",
    "dropmalst": "CA",
    "dropmalzpp": 907319996,
    "dropsitphn": 5624942406,
    "dropsitlph": 3108313222,
    "dropsitcph": 3108310264,
    "dropfax": 3105475284
  },
  {
    "dcode": "D",
    "dropkey": "SZ21183",
    "droptype": "D",
    "dropname": "FORT SUTTER",
    "dropdeladd": "1618 ALHAMBRA BLVD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958169998,
    "dropphyadd": "1618 ALHAMBRA BLVD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958169998,
    "dropmaladd": "1618 ALHAMBRA BLVD",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958169998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163075527,
    "dropsitcph": 9162276503,
    "dropfax": 9164562206
  },
  {
    "dcode": "D",
    "dropkey": "SZ21192",
    "droptype": "D",
    "dropname": "FOX PLAZA",
    "dropdeladd": "1390 MARKET ST LBBY",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941029995,
    "dropphyadd": "1390 MARKET ST LBBY",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941029995,
    "dropmaladd": "1390 MARKET ST LBBY",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941029995,
    "dropsitphn": 4155505045,
    "dropsitlph": 4159311053,
    "dropsitcph": 4159311053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21194",
    "droptype": "D",
    "dropname": "FOY",
    "dropdeladd": "1808 W 7TH ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900579998,
    "dropphyadd": "1808 W 7TH ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900579998,
    "dropmaladd": "1808 W 7TH ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900579998,
    "dropsitphn": 3235861867,
    "dropsitlph": 2134833745,
    "dropsitcph": 2134833573,
    "dropfax": 2134831125
  },
  {
    "dcode": "D",
    "dropkey": "SZ21223",
    "droptype": "D",
    "dropname": "FRUITVALE",
    "dropdeladd": "1445 34TH AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946013023,
    "dropphyadd": "1445 34TH AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946013023,
    "dropmaladd": "1445 34TH AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946019991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513352,
    "dropsitcph": 5102513351,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ21238",
    "droptype": "D",
    "dropname": "18TH STREET",
    "dropdeladd": "4304 18TH ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941149991,
    "dropphyadd": "4304 18TH ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941149991,
    "dropmaladd": "4304 18TH ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941149991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4154313826,
    "dropsitcph": 4154313826,
    "dropfax": 4155533908
  },
  {
    "dcode": "D",
    "dropkey": "SZ21253",
    "droptype": "D",
    "dropname": "GATEWAY CULVER CITY",
    "dropdeladd": "9942 CULVER BLVD",
    "dropdelcty": "CULVER CITY",
    "dropdelst": "CA",
    "dropdelzpp": 902329998,
    "dropphyadd": "9942 CULVER BLVD",
    "dropphycty": "CULVER CITY",
    "dropphyst": "CA",
    "dropphyzpp": 902329998,
    "dropmaladd": "9942 CULVER BLVD",
    "dropmalcty": "CULVER CITY",
    "dropmalst": "CA",
    "dropmalzpp": 902329998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3108399259,
    "dropsitcph": 3102040843,
    "dropfax": 3102043841
  },
  {
    "dcode": "D",
    "dropkey": "SZ21254",
    "droptype": "D",
    "dropname": "GATEWAY SAN FRANCISCO",
    "dropdeladd": "1 EMBARCADERO CTR STE SL12",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941119991,
    "dropphyadd": "1 EMBARCADERO CTR STE SL12",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941119991,
    "dropmaladd": "PO BOX 26000",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941266000,
    "dropsitphn": 4155505045,
    "dropsitlph": 4159863494,
    "dropsitcph": 4159863494,
    "dropfax": 4159565950
  },
  {
    "dcode": "D",
    "dropkey": "SZ21257",
    "droptype": "D",
    "dropname": "GEARY",
    "dropdeladd": "5654 GEARY BLVD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941219991,
    "dropphyadd": "5654 GEARY BLVD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941219991,
    "dropmaladd": "5654 GEARY BLVD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941219991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4152218702
  },
  {
    "dcode": "D",
    "dropkey": "SZ21258",
    "droptype": "D",
    "dropname": "GMF LOS ANGELES",
    "dropdeladd": "7001 S CENTRAL AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900529998,
    "dropphyadd": "7001 S CENTRAL AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900529989,
    "dropmaladd": "7001 S CENTRAL AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900529998,
    "dropsitphn": 2135861867,
    "dropsitlph": 2135862719,
    "dropsitcph": 2135861733,
    "dropfax": 2135861498
  },
  {
    "dcode": "D",
    "dropkey": "SZ21261",
    "droptype": "D",
    "dropname": "BALBOA VAN NUYS",
    "dropdeladd": "4930 BALBOA BLVD",
    "dropdelcty": "ENCINO",
    "dropdelst": "CA",
    "dropdelzpp": 913163432,
    "dropphyadd": "4930 BALBOA BLVD",
    "dropphycty": "ENCINO",
    "dropphyst": "CA",
    "dropphyzpp": 913163432,
    "dropmaladd": "15701 SHERMAN WAY",
    "dropmalcty": "VAN NUYS",
    "dropmalst": "CA",
    "dropmalzpp": 914069998,
    "dropsitphn": 6617757807,
    "dropsitlph": 8189863905,
    "dropsitcph": 8189863905,
    "dropfax": 8189864214
  },
  {
    "dcode": "D",
    "dropkey": "SZ21274",
    "droptype": "D",
    "dropname": "GLASSELL",
    "dropdeladd": "3950 EAGLE ROCK BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900659998,
    "dropphyadd": "3950 EAGLE ROCK BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900659998,
    "dropmaladd": "3950 EAGLE ROCK BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900659998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236843014,
    "dropsitcph": 3232540824,
    "dropfax": 3232543580
  },
  {
    "dcode": "D",
    "dropkey": "SZ21286",
    "droptype": "D",
    "dropname": "GLENOAKS",
    "dropdeladd": "1634 N SAN FERNANDO BLVD",
    "dropdelcty": "BURBANK",
    "dropdelst": "CA",
    "dropdelzpp": 915049998,
    "dropphyadd": "1634 N SAN FERNANDO BLVD",
    "dropphycty": "BURBANK",
    "dropphyst": "CA",
    "dropphyzpp": 915049998,
    "dropmaladd": "1634 N SAN FERNANDO BLVD",
    "dropmalcty": "BURBANK",
    "dropmalst": "CA",
    "dropmalzpp": 915049998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188461529,
    "dropsitcph": 8188460758,
    "dropfax": 8185583983
  },
  {
    "dcode": "D",
    "dropkey": "SZ21294",
    "droptype": "D",
    "dropname": "GOLDEN GATE",
    "dropdeladd": "3245 GEARY BLVD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941189992,
    "dropphyadd": "3245 GEARY BLVD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941189992,
    "dropmaladd": "3245 GEARY BLVD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941189992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4157513361,
    "dropsitcph": 4157513361,
    "dropfax": 4157513827
  },
  {
    "dcode": "D",
    "dropkey": "SZ21296",
    "droptype": "D",
    "dropname": "GOLDEN TRIANGLE",
    "dropdeladd": "8650 GENESEE AVE STE 214",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921229997,
    "dropphyadd": "8650 GENESEE AVE STE 214",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921229997,
    "dropmaladd": "8650 GENESEE AVE STE 214",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921229997,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585872634,
    "dropsitcph": 8585870223,
    "dropfax": 8585871329
  },
  {
    "dcode": "D",
    "dropkey": "SZ21308",
    "droptype": "D",
    "dropname": "GRAND CENTRAL",
    "dropdeladd": "6444 SAN FERNANDO RD",
    "dropdelcty": "GLENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 912015079,
    "dropphyadd": "6444 SAN FERNANDO RD",
    "dropphycty": "GLENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 912015079,
    "dropmaladd": "6444 SAN FERNANDO RD",
    "dropmalcty": "GLENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 912015079,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185461882,
    "dropsitcph": 8185461631,
    "dropfax": 8185462406
  },
  {
    "dcode": "D",
    "dropkey": "SZ21311",
    "droptype": "D",
    "dropname": "GRAND LAKE",
    "dropdeladd": "490 LAKE PARK AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946109991,
    "dropphyadd": "490 LAKE PARK AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946109991,
    "dropmaladd": "490 LAKE PARK AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946109991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513103,
    "dropsitcph": 5102513102,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ21316",
    "droptype": "D",
    "dropname": "GRANTVILLE",
    "dropdeladd": "4740 MISSION GORGE PL",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921209998,
    "dropphyadd": "4740 MISSION GORGE PL",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921209998,
    "dropmaladd": "4740 MISSION GORGE PL",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921209998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192864868,
    "dropsitcph": 6192864734,
    "dropfax": 6192860172
  },
  {
    "dcode": "D",
    "dropkey": "SZ21337",
    "droptype": "D",
    "dropname": "GRIFFITH",
    "dropdeladd": "3370 GLENDALE BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900399998,
    "dropphyadd": "3370 GLENDALE BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900399998,
    "dropmaladd": "3370 GLENDALE BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900399998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236622140,
    "dropsitcph": 3236625069,
    "dropfax": 3236614841
  },
  {
    "dcode": "D",
    "dropkey": "SZ21341",
    "droptype": "D",
    "dropname": "GROSSMONT",
    "dropdeladd": "5500 GROSSMONT CENTER DR STE 440",
    "dropdelcty": "LA MESA",
    "dropdelst": "CA",
    "dropdelzpp": 919429996,
    "dropphyadd": "5500 GROSSMONT CENTER DR STE 440",
    "dropphycty": "LA MESA",
    "dropphyst": "CA",
    "dropphyzpp": 919429996,
    "dropmaladd": "5500 GROSSMONT CENTER DR STE 440",
    "dropmalcty": "LA MESA",
    "dropmalst": "CA",
    "dropmalzpp": 919429996,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194605174,
    "dropsitcph": 6194604659,
    "dropfax": 6194602378
  },
  {
    "dcode": "D",
    "dropkey": "SZ21360",
    "droptype": "D",
    "dropname": "HACIENDA",
    "dropdeladd": "4682 CHABOT DR",
    "dropdelcty": "PLEASANTON",
    "dropdelst": "CA",
    "dropdelzpp": 945882747,
    "dropphyadd": "4682 CHABOT DR",
    "dropphycty": "PLEASANTON",
    "dropphyst": "CA",
    "dropphyzpp": 945882747,
    "dropmaladd": "4300 BLACK AVE",
    "dropmalcty": "PLEASANTON",
    "dropmalst": "CA",
    "dropmalzpp": 945669998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9258479402,
    "dropsitcph": 9258479308,
    "dropfax": 9254621458
  },
  {
    "dcode": "D",
    "dropkey": "SZ21372",
    "droptype": "D",
    "dropname": "HAMILTON",
    "dropdeladd": "380 HAMILTON AVE",
    "dropdelcty": "PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943019991,
    "dropphyadd": "380 HAMILTON AVE",
    "dropphycty": "PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943019991,
    "dropmaladd": "380 HAMILTON AVE",
    "dropmalcty": "PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943019991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503239113,
    "dropsitcph": 6503211423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21374",
    "droptype": "D",
    "dropname": "HAMMER RANCH",
    "dropdeladd": "7554 PACIFIC AVE",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952079998,
    "dropphyadd": "7554 PACIFIC AVE",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952079998,
    "dropmaladd": "7554 PACIFIC AVE",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952079998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099577976,
    "dropsitcph": 2099575436,
    "dropfax": 2099576981
  },
  {
    "dcode": "D",
    "dropkey": "SZ21378",
    "droptype": "D",
    "dropname": "HANCOCK",
    "dropdeladd": "8200 S VERMONT AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900449998,
    "dropphyadd": "8200 S VERMONT AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900449998,
    "dropmaladd": "8200 S VERMONT AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900449998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3237580261,
    "dropsitcph": 3237588126,
    "dropfax": 3237580063
  },
  {
    "dcode": "D",
    "dropkey": "SZ21386",
    "droptype": "D",
    "dropname": "HARDMAN",
    "dropdeladd": "5172 ARLINGTON AVE",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 925042686,
    "dropphyadd": "5172 ARLINGTON AVE",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 925042686,
    "dropmaladd": "5172 ARLINGTON AVE",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 925042686,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516893032,
    "dropsitcph": 9512766252,
    "dropfax": 9516895627
  },
  {
    "dcode": "D",
    "dropkey": "SZ21409",
    "droptype": "D",
    "dropname": "HENDERSON",
    "dropdeladd": "2906 F ST",
    "dropdelcty": "EUREKA",
    "dropdelst": "CA",
    "dropdelzpp": 955019992,
    "dropphyadd": "2906 F ST",
    "dropphycty": "EUREKA",
    "dropphyst": "CA",
    "dropphyzpp": 955019992,
    "dropmaladd": "337 W CLARK ST",
    "dropmalcty": "EUREKA",
    "dropmalst": "CA",
    "dropmalzpp": 955019903,
    "dropsitphn": 7077785461,
    "dropsitlph": 7077785254,
    "dropsitcph": 7074420856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21412",
    "droptype": "D",
    "dropname": "HERITAGE VILLAGE",
    "dropdeladd": "51 E CAMPBELL AVE",
    "dropdelcty": "CAMPBELL",
    "dropdelst": "CA",
    "dropdelzpp": 950082047,
    "dropphyadd": "51 E CAMPBELL AVE",
    "dropphycty": "CAMPBELL",
    "dropphyst": "CA",
    "dropphyzpp": 950082047,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CAMPBELL",
    "dropmalst": "CA",
    "dropmalzpp": 950099998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4083740402,
    "dropsitcph": 4083740402,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21425",
    "droptype": "D",
    "dropname": "HIGHLAND PARK",
    "dropdeladd": "5930 N FIGUEROA ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900429998,
    "dropphyadd": "5930 N FIGUEROA ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900429998,
    "dropmaladd": "5930 N FIGUEROA ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900429998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232562234,
    "dropsitcph": 3232562233,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21427",
    "droptype": "D",
    "dropname": "HILLCREST INGLEWOOD",
    "dropdeladd": "300 E HILLCREST BLVD",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903019998,
    "dropphyadd": "300 E HILLCREST BLVD",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903019998,
    "dropmaladd": "300 E HILLCREST BLVD",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903019998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106742321,
    "dropsitcph": 3106742605,
    "dropfax": 3106747114
  },
  {
    "dcode": "D",
    "dropkey": "SZ21428",
    "droptype": "D",
    "dropname": "HILLCREST SAN DIEGO",
    "dropdeladd": "3911 CLEVELAND AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921039998,
    "dropphyadd": "3911 CLEVELAND AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921039998,
    "dropmaladd": "3911 CLEVELAND AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921039998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192953707,
    "dropsitcph": 6192955091,
    "dropfax": 6192959335
  },
  {
    "dcode": "D",
    "dropkey": "SZ21430",
    "droptype": "D",
    "dropname": "CRESTMONT",
    "dropdeladd": "1428 CRESTMONT DR",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933069998,
    "dropphyadd": "1428 CRESTMONT DR",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933069998,
    "dropmaladd": "1428 CRESTMONT DR",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933069998,
    "dropsitphn": 4084376726,
    "dropsitlph": 6618717698,
    "dropsitcph": 6618717698,
    "dropfax": 6618714139
  },
  {
    "dcode": "D",
    "dropkey": "SZ21435",
    "droptype": "D",
    "dropname": "HILLVIEW",
    "dropdeladd": "2450 ALVIN AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951219998,
    "dropphyadd": "2450 ALVIN AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951219998,
    "dropmaladd": "2450 ALVIN AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951219998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082742748,
    "dropsitcph": 4082380213,
    "dropfax": 4085280896
  },
  {
    "dcode": "D",
    "dropkey": "SZ21444",
    "droptype": "D",
    "dropname": "HOLIDAY",
    "dropdeladd": "1180 W BALL RD",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928129998,
    "dropphyadd": "1180 W BALL RD",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928129998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7145338182,
    "dropsitlph": 7147746410,
    "dropsitcph": 7145338182,
    "dropfax": 7147720632
  },
  {
    "dcode": "D",
    "dropkey": "SZ21448",
    "droptype": "D",
    "dropname": "HOLLYDALE",
    "dropdeladd": "12129 GARFIELD AVE",
    "dropdelcty": "SOUTH GATE",
    "dropdelst": "CA",
    "dropdelzpp": 902809992,
    "dropphyadd": "12129 GARFIELD AVE",
    "dropphycty": "SOUTH GATE",
    "dropphyst": "CA",
    "dropphyzpp": 902809992,
    "dropmaladd": "12129 GARFIELD AVE",
    "dropmalcty": "SOUTH GATE",
    "dropmalst": "CA",
    "dropmalzpp": 902809992,
    "dropsitphn": 5624942406,
    "dropsitlph": 5626330345,
    "dropsitcph": 5626330308,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21450",
    "droptype": "D",
    "dropname": "HOLLYWOOD",
    "dropdeladd": "1615 WILCOX AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900289998,
    "dropphyadd": "1615 WILCOX AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900289998,
    "dropmaladd": "1615 WILCOX AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900289998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3234641714,
    "dropsitcph": 3234642355,
    "dropfax": 3234642675
  },
  {
    "dcode": "D",
    "dropkey": "SZ21456",
    "droptype": "D",
    "dropname": "HOMESTEAD",
    "dropdeladd": "1610 S EL DORADO ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952069998,
    "dropphyadd": "1610 S EL DORADO ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952069998,
    "dropmaladd": "1610 S EL DORADO ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952069998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099836460,
    "dropsitcph": 2099836422,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21470",
    "droptype": "D",
    "dropname": "HORTON PLAZA",
    "dropdeladd": "51 HORTON PLZ",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921019996,
    "dropphyadd": "51 HORTON PLZ",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921019996,
    "dropmaladd": "51 HORTON PLZ",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921019996,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192324305,
    "dropsitcph": 6192324015,
    "dropfax": 6192328814
  },
  {
    "dcode": "D",
    "dropkey": "SZ21474",
    "droptype": "D",
    "dropname": "HUB CITY",
    "dropdeladd": "101 S WILLOWBROOK AVE",
    "dropdelcty": "COMPTON",
    "dropdelst": "CA",
    "dropdelzpp": 902209998,
    "dropphyadd": "101 S WILLOWBROOK AVE",
    "dropphycty": "COMPTON",
    "dropphyst": "CA",
    "dropphyzpp": 902209998,
    "dropmaladd": "101 S WILLOWBROOK AVE",
    "dropmalcty": "COMPTON",
    "dropmalst": "CA",
    "dropmalzpp": 902209998,
    "dropsitphn": 3104942406,
    "dropsitlph": 3106386524,
    "dropsitcph": 3106383161,
    "dropfax": 3106385885
  },
  {
    "dcode": "D",
    "dropkey": "SZ21475",
    "droptype": "D",
    "dropname": "HUDSON",
    "dropdeladd": "2300 SYLVAN AVE",
    "dropdelcty": "MODESTO",
    "dropdelst": "CA",
    "dropdelzpp": 953559998,
    "dropphyadd": "2300 SYLVAN AVE",
    "dropphycty": "MODESTO",
    "dropphyst": "CA",
    "dropphyzpp": 953559998,
    "dropmaladd": "2300 SYLVAN AVE",
    "dropmalcty": "MODESTO",
    "dropmalst": "CA",
    "dropmalzpp": 953559998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095516903,
    "dropsitcph": 2095516903,
    "dropfax": 2095519589
  },
  {
    "dcode": "D",
    "dropkey": "SZ21476",
    "droptype": "D",
    "dropname": "HUGHES",
    "dropdeladd": "3727 N HUGHES AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937059998,
    "dropphyadd": "3727 N HUGHES AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937059998,
    "dropmaladd": "3727 N HUGHES AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937059998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592224524,
    "dropsitcph": 5592222138,
    "dropfax": 5592220242
  },
  {
    "dcode": "D",
    "dropkey": "SZ21495",
    "droptype": "D",
    "dropname": "IDA JEAN HAXTON",
    "dropdeladd": "9151 ATLANTA AVE",
    "dropdelcty": "HUNTINGTON BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926159998,
    "dropphyadd": "9151 ATLANTA AVE",
    "dropphycty": "HUNTINGTON BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926159998,
    "dropmaladd": "9151 ATLANTA AVE",
    "dropmalcty": "HUNTINGTON BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926159998,
    "dropsitphn": 7145930621,
    "dropsitlph": 7145933291,
    "dropsitcph": 7149630621,
    "dropfax": 7149649731
  },
  {
    "dcode": "D",
    "dropkey": "SZ21510",
    "droptype": "D",
    "dropname": "INDUSTRIAL SANTA ANA",
    "dropdeladd": "2230 S GRAND AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927359998,
    "dropphyadd": "2230 S GRAND AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927359998,
    "dropmaladd": "2230 S GRAND AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927359998,
    "dropsitphn": 7146620151,
    "dropsitlph": 7146410955,
    "dropsitcph": 7146676733,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21531",
    "droptype": "D",
    "dropname": "IRVINGTON",
    "dropdeladd": "41041 TRIMBOLI WAY",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945384832,
    "dropphyadd": "41041 TRIMBOLI WAY",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945384832,
    "dropmaladd": "41041 TRIMBOLI WAY",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945389991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106510233,
    "dropsitcph": 5106510233,
    "dropfax": 5106518279
  },
  {
    "dcode": "D",
    "dropkey": "SZ21536",
    "droptype": "D",
    "dropname": "CLAYTON STREET",
    "dropdeladd": "554 CLAYTON ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941179991,
    "dropphyadd": "554 CLAYTON ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941179991,
    "dropmaladd": "554 CLAYTON ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941179991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4159311053,
    "dropsitcph": 4159311053,
    "dropfax": 4156211528
  },
  {
    "dcode": "D",
    "dropkey": "SZ21549",
    "droptype": "D",
    "dropname": "JOHN ADAMS",
    "dropdeladd": "3288 ADAMS AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921169998,
    "dropphyadd": "3288 ADAMS AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921169998,
    "dropmaladd": "3288 ADAMS AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921169998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192847676,
    "dropsitcph": 6192840288,
    "dropfax": 6192849641
  },
  {
    "dcode": "D",
    "dropkey": "SZ21551",
    "droptype": "D",
    "dropname": "JOHN STEINBECK",
    "dropdeladd": "100 W ALISAL ST FRNT",
    "dropdelcty": "SALINAS",
    "dropdelst": "CA",
    "dropdelzpp": 939019998,
    "dropphyadd": "100 W ALISAL ST FRNT",
    "dropphycty": "SALINAS",
    "dropphyst": "CA",
    "dropphyzpp": 939019998,
    "dropmaladd": "100 W ALISAL ST FRNT",
    "dropmalcty": "SALINAS",
    "dropmalst": "CA",
    "dropmalzpp": 939019998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8317580765,
    "dropsitcph": 8317583824,
    "dropfax": 8317586032
  },
  {
    "dcode": "D",
    "dropkey": "SZ21591",
    "droptype": "D",
    "dropname": "KING",
    "dropdeladd": "1609 N KING ST",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927069998,
    "dropphyadd": "1609 N KING ST",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927069998,
    "dropmaladd": "1609 N KING ST",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927069998,
    "dropsitphn": 7148353098,
    "dropsitlph": 7148355344,
    "dropsitcph": 7148353098,
    "dropfax": 7148358549
  },
  {
    "dcode": "D",
    "dropkey": "SZ21615",
    "droptype": "D",
    "dropname": "LA COSTA MALIBU",
    "dropdeladd": "21229 PACIFIC COAST HWY",
    "dropdelcty": "MALIBU",
    "dropdelst": "CA",
    "dropdelzpp": 902659992,
    "dropphyadd": "21229 PACIFIC COAST HWY",
    "dropphycty": "MALIBU",
    "dropphyst": "CA",
    "dropphyzpp": 902659992,
    "dropmaladd": "21229 PACIFIC COAST HWY",
    "dropmalcty": "MALIBU",
    "dropmalst": "CA",
    "dropmalzpp": 902659992,
    "dropsitphn": 5624942406,
    "dropsitlph": 3104565069,
    "dropsitcph": 3104565069,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21634",
    "droptype": "D",
    "dropname": "LA TIJERA",
    "dropdeladd": "5472 CRENSHAW BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900439998,
    "dropphyadd": "5472 CRENSHAW BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900439998,
    "dropmaladd": "5472 CRENSHAW BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900439998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232917026,
    "dropsitcph": 3232910587,
    "dropfax": 3232919745
  },
  {
    "dcode": "D",
    "dropkey": "SZ21685",
    "droptype": "D",
    "dropname": "LAND PARK",
    "dropdeladd": "5930 S LAND PARK DR",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958229998,
    "dropphyadd": "5930 S LAND PARK DR",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958229998,
    "dropmaladd": "5930 S LAND PARK DR",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958229998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163075528,
    "dropsitcph": 9162623107,
    "dropfax": 9164562206
  },
  {
    "dcode": "D",
    "dropkey": "SZ21687",
    "droptype": "D",
    "dropname": "LANDSCAPE",
    "dropdeladd": "1831 SOLANO AVE",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947079991,
    "dropphyadd": "1831 SOLANO AVE",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947079991,
    "dropmaladd": "1831 SOLANO AVE",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947079991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493144,
    "dropsitcph": 5106496717,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ21701",
    "droptype": "D",
    "dropname": "LAUREL",
    "dropdeladd": "3630 HIGH ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946192158,
    "dropphyadd": "3630 HIGH ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946192158,
    "dropmaladd": "3630 HIGH ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946199991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513389,
    "dropsitcph": 5103369360,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ21731",
    "droptype": "D",
    "dropname": "LEUCADIA",
    "dropdeladd": "1160 N COAST HIGHWAY 101",
    "dropdelcty": "ENCINITAS",
    "dropdelst": "CA",
    "dropdelzpp": 920249996,
    "dropphyadd": "1160 N COAST HIGHWAY 101",
    "dropphycty": "ENCINITAS",
    "dropphyst": "CA",
    "dropphyzpp": 920249996,
    "dropmaladd": "1160 N COAST HIGHWAY 101",
    "dropmalcty": "ENCINITAS",
    "dropmalst": "CA",
    "dropmalzpp": 920249996,
    "dropsitphn": 6196740173,
    "dropsitlph": 7607535307,
    "dropsitcph": 7607531415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21741",
    "droptype": "D",
    "dropname": "LINDA MAR",
    "dropdeladd": "690 ROBERTS RD",
    "dropdelcty": "PACIFICA",
    "dropdelst": "CA",
    "dropdelzpp": 940449991,
    "dropphyadd": "690 ROBERTS RD",
    "dropphycty": "PACIFICA",
    "dropphyst": "CA",
    "dropphyzpp": 940449991,
    "dropmaladd": "690 ROBERTS RD",
    "dropmalcty": "PACIFICA",
    "dropmalst": "CA",
    "dropmalzpp": 940449991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503592741,
    "dropsitcph": 6503592935,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21742",
    "droptype": "D",
    "dropname": "LINDA VISTA",
    "dropdeladd": "2150 COMSTOCK ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921119998,
    "dropphyadd": "2150 COMSTOCK ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921119998,
    "dropmaladd": "2150 COMSTOCK ST",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921119998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8582771046,
    "dropsitcph": 8582776544,
    "dropfax": 8582779814
  },
  {
    "dcode": "D",
    "dropkey": "SZ21744",
    "droptype": "D",
    "dropname": "LINDEN",
    "dropdeladd": "322 LINDEN AVE",
    "dropdelcty": "SOUTH SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 940809991,
    "dropphyadd": "322 LINDEN AVE",
    "dropphycty": "SOUTH SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 940809991,
    "dropmaladd": "322 LINDEN AVE",
    "dropmalcty": "SOUTH SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 940809991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6505892267,
    "dropsitcph": 6505894739,
    "dropfax": 6505881651
  },
  {
    "dcode": "D",
    "dropkey": "SZ21809",
    "droptype": "D",
    "dropname": "LOS FELIZ",
    "dropdeladd": "1825 N VERMONT AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900279998,
    "dropphyadd": "1825 N VERMONT AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900279998,
    "dropmaladd": "1825 N VERMONT AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900279998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236603220,
    "dropsitcph": 3236601133,
    "dropfax": 3236601268
  },
  {
    "dcode": "D",
    "dropkey": "SZ21830",
    "droptype": "D",
    "dropname": "LUGO",
    "dropdeladd": "3641 E 8TH ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900239998,
    "dropphyadd": "3641 E 8TH ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900239998,
    "dropmaladd": "3641 E 8TH ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900239998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232688552,
    "dropsitcph": 3232680806,
    "dropfax": 3232689039
  },
  {
    "dcode": "D",
    "dropkey": "SZ21834",
    "droptype": "D",
    "dropname": "LYONS",
    "dropdeladd": "23742 LYONS AVE",
    "dropdelcty": "NEWHALL",
    "dropdelst": "CA",
    "dropdelzpp": 913212514,
    "dropphyadd": "23742 LYONS AVE",
    "dropphycty": "NEWHALL",
    "dropphyst": "CA",
    "dropphyzpp": 913212514,
    "dropmaladd": "23742 LYONS AVE",
    "dropmalcty": "NEWHALL",
    "dropmalst": "CA",
    "dropmalzpp": 913212514,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612533010,
    "dropsitcph": 6612530771,
    "dropfax": 6612533012
  },
  {
    "dcode": "D",
    "dropkey": "SZ21852",
    "droptype": "D",
    "dropname": "MAGNOLIA CENTER",
    "dropdeladd": "3681 SUNNYSIDE DR",
    "dropdelcty": "RIVERSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 925069997,
    "dropphyadd": "3681 SUNNYSIDE DR",
    "dropphycty": "RIVERSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 925069997,
    "dropmaladd": "3681 SUNNYSIDE DR",
    "dropmalcty": "RIVERSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 925069997,
    "dropsitphn": 9513354694,
    "dropsitlph": 9517884955,
    "dropsitcph": 9512766252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21858",
    "droptype": "D",
    "dropname": "MAIN OFFICE LOS ANGELES",
    "dropdeladd": "7101 S CENTRAL AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900019998,
    "dropphyadd": "7101 S CENTRAL AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900019998,
    "dropmaladd": "7101 S CENTRAL AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900019998,
    "dropsitphn": 3235861868,
    "dropsitlph": 3235864415,
    "dropsitcph": 3235864415,
    "dropfax": 3235864384
  },
  {
    "dcode": "D",
    "dropkey": "SZ21859",
    "droptype": "D",
    "dropname": "OAKLAND M O BOXES",
    "dropdeladd": "1675 7TH ST",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946159996,
    "dropphyadd": "1675 7TH ST",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946159996,
    "dropmaladd": "1675 7TH ST",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946159996,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108748710,
    "dropsitcph": 5102513373,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21877",
    "droptype": "D",
    "dropname": "MAR VISTA",
    "dropdeladd": "3826 GRAND VIEW BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900669998,
    "dropphyadd": "3826 GRAND VIEW BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900669998,
    "dropmaladd": "3826 GRAND VIEW BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900669998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3104820092,
    "dropsitcph": 3104820093,
    "dropfax": 3104823905
  },
  {
    "dcode": "D",
    "dropkey": "SZ21878",
    "droptype": "D",
    "dropname": "MARCELINA",
    "dropdeladd": "1433 MARCELINA AVE",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905019998,
    "dropphyadd": "1433 MARCELINA AVE",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905019998,
    "dropmaladd": "1433 MARCELINA AVE",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905019998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103203618,
    "dropsitcph": 3102225902,
    "dropfax": 3103203166
  },
  {
    "dcode": "D",
    "dropkey": "SZ21881",
    "droptype": "D",
    "dropname": "MARCUS FOSTER",
    "dropdeladd": "9201 INTERNATIONAL BLVD",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946031401,
    "dropphyadd": "9201 INTERNATIONAL BLVD",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946031401,
    "dropmaladd": "9201 INTERNATIONAL BLVD",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946039991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102513380,
    "dropsitcph": 5102513353,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ21889",
    "droptype": "D",
    "dropname": "MARINA",
    "dropdeladd": "2055 LOMBARD ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941239991,
    "dropphyadd": "2055 LOMBARD ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941239991,
    "dropmaladd": "2055 LOMBARD ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941239991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4153511875,
    "dropsitcph": 4153511875,
    "dropfax": 4155635367
  },
  {
    "dcode": "D",
    "dropkey": "SZ21896",
    "droptype": "D",
    "dropname": "MARINE CORPS RECRUIT DEPO",
    "dropdeladd": "3801 TIENTSEN ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921405153,
    "dropphyadd": "3801 TIENTSEN ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921405153,
    "dropmaladd": "3801 TIENTSEN ST",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921405153,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195244399,
    "dropsitcph": 6195244399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21897",
    "droptype": "D",
    "dropname": "MARINER",
    "dropdeladd": "221 MAIN ST",
    "dropdelcty": "SEAL BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 907409995,
    "dropphyadd": "221 MAIN ST",
    "dropphycty": "SEAL BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 907409995,
    "dropmaladd": "221 MAIN ST",
    "dropmalcty": "SEAL BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 907409995,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624313641,
    "dropsitcph": 5625986915,
    "dropfax": 5625988785
  },
  {
    "dcode": "D",
    "dropkey": "SZ21902",
    "droptype": "D",
    "dropname": "MARKET",
    "dropdeladd": "1122 E 7TH ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900219998,
    "dropphyadd": "1122 E 7TH ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900219998,
    "dropmaladd": "1122 E 7TH ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900219998,
    "dropsitphn": 2135861867,
    "dropsitlph": "",
    "dropsitcph": 2136221828,
    "dropfax": 2136227224
  },
  {
    "dcode": "D",
    "dropkey": "SZ21903",
    "droptype": "D",
    "dropname": "COLLEGE GROVE CENTER",
    "dropdeladd": "3426 COLLEGE AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921159997,
    "dropphyadd": "3426 COLLEGE AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921159997,
    "dropmaladd": "3426 COLLEGE AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921159997,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195830646,
    "dropsitcph": 6195832793,
    "dropfax": 6195821159
  },
  {
    "dcode": "D",
    "dropkey": "SZ21918",
    "droptype": "D",
    "dropname": "MCLAREN",
    "dropdeladd": "2755 SAN BRUNO AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941349992,
    "dropphyadd": "2755 SAN BRUNO AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941349992,
    "dropmaladd": "2755 SAN BRUNO AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941349992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4152854662,
    "dropsitcph": 4152854662,
    "dropfax": 4154672858
  },
  {
    "dcode": "D",
    "dropkey": "SZ21949",
    "droptype": "D",
    "dropname": "MESA CENTER",
    "dropdeladd": "2230 FAIRVIEW RD STE C",
    "dropdelcty": "COSTA MESA",
    "dropdelst": "CA",
    "dropdelzpp": 926279998,
    "dropphyadd": "2230 FAIRVIEW RD STE C",
    "dropphycty": "COSTA MESA",
    "dropphyst": "CA",
    "dropphyzpp": 926279998,
    "dropmaladd": "2230 FAIRVIEW RD STE C",
    "dropmalcty": "COSTA MESA",
    "dropmalst": "CA",
    "dropmalzpp": 926279998,
    "dropsitphn": 9496462805,
    "dropsitlph": 9496462912,
    "dropsitcph": 9496462805,
    "dropfax": 9496464569
  },
  {
    "dcode": "D",
    "dropkey": "SZ21960",
    "droptype": "D",
    "dropname": "MID CITY",
    "dropdeladd": "13 S SUTTER ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952023218,
    "dropphyadd": "13 S SUTTER ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952023218,
    "dropmaladd": "13 S SUTTER ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952023218,
    "dropsitphn": "",
    "dropsitlph": 2094667545,
    "dropsitcph": 2094623805,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ21967",
    "droptype": "D",
    "dropname": "MIDTOWN CHICO",
    "dropdeladd": "141 W 5TH ST",
    "dropdelcty": "CHICO",
    "dropdelst": "CA",
    "dropdelzpp": 959289998,
    "dropphyadd": "141 W 5TH ST",
    "dropphycty": "CHICO",
    "dropphyst": "CA",
    "dropphyzpp": 959289998,
    "dropmaladd": "141 W 5TH ST",
    "dropmalcty": "CHICO",
    "dropmalst": "CA",
    "dropmalzpp": 959289998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5308943710,
    "dropsitcph": 5303425048,
    "dropfax": 5303421601
  },
  {
    "dcode": "D",
    "dropkey": "SZ21990",
    "droptype": "D",
    "dropname": "MIRA MESA",
    "dropdeladd": "9051 MIRA MESA BLVD",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921269998,
    "dropphyadd": "9051 MIRA MESA BLVD",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921269998,
    "dropmaladd": "9051 MIRA MESA BLVD",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921269998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585667023,
    "dropsitcph": 8585667605,
    "dropfax": 8585666794
  },
  {
    "dcode": "D",
    "dropkey": "SZ21992",
    "droptype": "D",
    "dropname": "MIRA VISTA",
    "dropdeladd": "12651 SAN PABLO AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948059991,
    "dropphyadd": "12651 SAN PABLO AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948059991,
    "dropmaladd": "12651 SAN PABLO AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948051407,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102322594,
    "dropsitcph": 5102324554,
    "dropfax": 5102323718
  },
  {
    "dcode": "D",
    "dropkey": "SZ21996",
    "droptype": "D",
    "dropname": "MIRACLE MILE",
    "dropdeladd": "5350 WILSHIRE BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900369998,
    "dropphyadd": "5350 WILSHIRE BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900369998,
    "dropmaladd": "5350 WILSHIRE BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900369998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3239339793,
    "dropsitcph": 3239339793,
    "dropfax": 3239330104
  },
  {
    "dcode": "D",
    "dropkey": "SZ22000",
    "droptype": "D",
    "dropname": "MISSION SAN LUIS OBISPO",
    "dropdeladd": "893 MARSH ST",
    "dropdelcty": "SAN LUIS OBISPO",
    "dropdelst": "CA",
    "dropdelzpp": 934013699,
    "dropphyadd": "893 MARSH ST",
    "dropphycty": "SAN LUIS OBISPO",
    "dropphyst": "CA",
    "dropphyzpp": 934013699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SAN LUIS OBISPO",
    "dropmalst": "CA",
    "dropmalzpp": 934069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055415127,
    "dropsitcph": 8055419138,
    "dropfax": 8055420256
  },
  {
    "dcode": "D",
    "dropkey": "SZ22001",
    "droptype": "D",
    "dropname": "MISSION SANTA CLARA",
    "dropdeladd": "1050 KIELY BLVD",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "CA",
    "dropdelzpp": 950519998,
    "dropphyadd": "1050 KIELY BLVD",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "CA",
    "dropphyzpp": 950519998,
    "dropmaladd": "1050 KIELY BLVD",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "CA",
    "dropmalzpp": 950519998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082436234,
    "dropsitcph": 4082430128,
    "dropfax": 4089854168
  },
  {
    "dcode": "D",
    "dropkey": "SZ22008",
    "droptype": "D",
    "dropname": "MISSION RAFAEL",
    "dropdeladd": "910 D ST",
    "dropdelcty": "SAN RAFAEL",
    "dropdelst": "CA",
    "dropdelzpp": 949019991,
    "dropphyadd": "910 D ST",
    "dropphycty": "SAN RAFAEL",
    "dropphyst": "CA",
    "dropphyzpp": 949019991,
    "dropmaladd": "910 D ST",
    "dropmalcty": "SAN RAFAEL",
    "dropmalst": "CA",
    "dropmalzpp": 949019991,
    "dropsitphn": 4154577397,
    "dropsitlph": 4154577397,
    "dropsitcph": 4154571945,
    "dropfax": 4154565136
  },
  {
    "dcode": "D",
    "dropkey": "SZ22009",
    "droptype": "D",
    "dropname": "MISSION SAN JOSE",
    "dropdeladd": "43456 ELLSWORTH ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945395856,
    "dropphyadd": "43456 ELLSWORTH ST",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945395856,
    "dropmaladd": "43456 ELLSWORTH ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945399991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106567851,
    "dropsitcph": 5106567851,
    "dropfax": 5107925437
  },
  {
    "dcode": "D",
    "dropkey": "SZ22043",
    "droptype": "D",
    "dropname": "MONTEBELLO HILLS",
    "dropdeladd": "2547 VIA CAMPO",
    "dropdelcty": "MONTEBELLO",
    "dropdelst": "CA",
    "dropdelzpp": 906409997,
    "dropphyadd": "2547 VIA CAMPO",
    "dropphycty": "MONTEBELLO",
    "dropphyst": "CA",
    "dropphyzpp": 906409997,
    "dropmaladd": "145 N 5TH ST",
    "dropmalcty": "MONTEBELLO",
    "dropmalst": "CA",
    "dropmalzpp": 906409998,
    "dropsitphn": 3237282249,
    "dropsitlph": 3237289518,
    "dropsitcph": 3237282249,
    "dropfax": 3237283949
  },
  {
    "dcode": "D",
    "dropkey": "SZ22053",
    "droptype": "D",
    "dropname": "MONTGOMERY VILLAGE",
    "dropdeladd": "707 HAHMAN DR",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "CA",
    "dropdelzpp": 954059991,
    "dropphyadd": "707 HAHMAN DR",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "CA",
    "dropphyzpp": 954059991,
    "dropmaladd": "707 HAHMAN DR",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "CA",
    "dropmalzpp": 954059991,
    "dropsitphn": 7077785461,
    "dropsitlph": 7075460167,
    "dropsitcph": 7075282209,
    "dropfax": 7075469019
  },
  {
    "dcode": "D",
    "dropkey": "SZ22061",
    "droptype": "D",
    "dropname": "MORENO",
    "dropdeladd": "28981 ALESSANDRO BLVD",
    "dropdelcty": "MORENO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 925556907,
    "dropphyadd": "28981 ALESSANDRO BLVD",
    "dropphycty": "MORENO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 925556907,
    "dropmaladd": "28981 ALESSANDRO BLVD",
    "dropmalcty": "MORENO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 925556907,
    "dropsitphn": 9513354694,
    "dropsitlph": 9512470987,
    "dropsitcph": 9512477507,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22068",
    "droptype": "D",
    "dropname": "MORNINGSIDE PARK",
    "dropdeladd": "3212 W 85TH ST",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903059998,
    "dropphyadd": "3212 W 85TH ST",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903059998,
    "dropmaladd": "3212 W 85TH ST",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903059998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3237787746,
    "dropsitcph": 3237787724,
    "dropfax": 3237525723
  },
  {
    "dcode": "D",
    "dropkey": "SZ22124",
    "droptype": "D",
    "dropname": "MCAS MIRAMAR",
    "dropdeladd": "45482 ELROD ST STE 3",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921459998,
    "dropphyadd": "45482 ELROD ST STE 3",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921459998,
    "dropmaladd": "45482 ELROD ST STE 3",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921459998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585300102,
    "dropsitcph": 8585774578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22125",
    "droptype": "D",
    "dropname": "NAS NORTH ISLAND",
    "dropdeladd": "124 MURRAY AVE BLDG 124",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921359800,
    "dropphyadd": "124 MURRAY AVE BLDG 124",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921359800,
    "dropmaladd": "PO BOX 357028",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921357028,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195454380,
    "dropsitcph": 6194351142,
    "dropfax": 6194355192
  },
  {
    "dcode": "D",
    "dropkey": "SZ22129",
    "droptype": "D",
    "dropname": "NAVAJO",
    "dropdeladd": "6519 BISBY LAKE AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921199998,
    "dropphyadd": "6519 BISBY LAKE AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921199998,
    "dropmaladd": "6519 BISBY LAKE AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921199998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194616774,
    "dropsitcph": 6194618667,
    "dropfax": 6194615839
  },
  {
    "dcode": "D",
    "dropkey": "SZ22134",
    "droptype": "D",
    "dropname": "NAVAL HOSPITAL",
    "dropdeladd": "201 13TH ST OFC",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946129998,
    "dropphyadd": "201 13TH ST OFC",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946129998,
    "dropmaladd": "201 13TH ST OFC",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946129998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 5108323950,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ22135",
    "droptype": "D",
    "dropname": "NAVAL STATION",
    "dropdeladd": "4070 SURFACE NAVY BLVD STE 1",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921369998,
    "dropphyadd": "4070 SURFACE NAVY BLVD STE 1",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921369998,
    "dropmaladd": "4070 SURFACE NAVY BLVD STE 1",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921369998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195563530,
    "dropsitcph": 6195563530,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22174",
    "droptype": "D",
    "dropname": "NILES",
    "dropdeladd": "160 J ST",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945369991,
    "dropphyadd": "160 J ST",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945369991,
    "dropmaladd": "160 J ST",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945369991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107930291,
    "dropsitcph": 5107930291,
    "dropfax": 5107925437
  },
  {
    "dcode": "D",
    "dropkey": "SZ22181",
    "droptype": "D",
    "dropname": "NOE VALLEY",
    "dropdeladd": "4083 24TH ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941149992,
    "dropphyadd": "4083 24TH ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941149992,
    "dropmaladd": "4083 24TH ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941149992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4156489657
  },
  {
    "dcode": "D",
    "dropkey": "SZ22190",
    "droptype": "D",
    "dropname": "NORTH BEACH PRS",
    "dropdeladd": "1640 STOCKTON ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941339991,
    "dropphyadd": "1640 STOCKTON ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941339991,
    "dropmaladd": "1640 STOCKTON ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941339991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4153623494,
    "dropsitcph": 4159863494,
    "dropfax": 4153622908
  },
  {
    "dcode": "D",
    "dropkey": "SZ22192",
    "droptype": "D",
    "dropname": "NORTH BERKELEY",
    "dropdeladd": "1521 SHATTUCK AVE",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947099991,
    "dropphyadd": "1521 SHATTUCK AVE",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947099991,
    "dropmaladd": "1521 SHATTUCK AVE",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947099991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493147,
    "dropsitcph": 5106496763,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ22195",
    "droptype": "D",
    "dropname": "NORTH DOWNEY",
    "dropdeladd": "10409 LAKEWOOD BLVD",
    "dropdelcty": "DOWNEY",
    "dropdelst": "CA",
    "dropdelzpp": 902419993,
    "dropphyadd": "10409 LAKEWOOD BLVD",
    "dropphycty": "DOWNEY",
    "dropphyst": "CA",
    "dropphyzpp": 902419993,
    "dropmaladd": "10409 LAKEWOOD BLVD",
    "dropmalcty": "DOWNEY",
    "dropmalst": "CA",
    "dropmalzpp": 902419993,
    "dropsitphn": 5624942406,
    "dropsitlph": 5628613597,
    "dropsitcph": 5628612337,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22199",
    "droptype": "D",
    "dropname": "NORTH GLENDALE",
    "dropdeladd": "1009 N PACIFIC AVE",
    "dropdelcty": "GLENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 912029998,
    "dropphyadd": "1009 N PACIFIC AVE",
    "dropphycty": "GLENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 912029998,
    "dropmaladd": "1009 N PACIFIC AVE",
    "dropmalcty": "GLENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 912029998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185437086,
    "dropsitcph": 8185433229,
    "dropfax": 8185437423
  },
  {
    "dcode": "D",
    "dropkey": "SZ22206",
    "droptype": "D",
    "dropname": "NORTH LONG BEACH",
    "dropdeladd": "101 E MARKET ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908059998,
    "dropphyadd": "101 E MARKET ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908059998,
    "dropmaladd": "101 E MARKET ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908059998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624237032,
    "dropsitcph": 5624285029,
    "dropfax": 5624281719
  },
  {
    "dcode": "D",
    "dropkey": "SZ22208",
    "droptype": "D",
    "dropname": "NORTH OAKLAND",
    "dropdeladd": "4900 SHATTUCK AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946092031,
    "dropphyadd": "4900 SHATTUCK AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946092031,
    "dropmaladd": "4900 SHATTUCK AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946099991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5109853068,
    "dropsitcph": 5109853068,
    "dropfax": 5106016552
  },
  {
    "dcode": "D",
    "dropkey": "SZ22212",
    "droptype": "D",
    "dropname": "NORTH REDONDO BEACH",
    "dropdeladd": "2215 ARTESIA BLVD",
    "dropdelcty": "REDONDO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902789998,
    "dropphyadd": "2215 ARTESIA BLVD",
    "dropphycty": "REDONDO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902789998,
    "dropmaladd": "2215 ARTESIA BLVD",
    "dropmalcty": "REDONDO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902789998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103708169,
    "dropsitcph": 3103760262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22217",
    "droptype": "D",
    "dropname": "NORTH TORRANCE",
    "dropdeladd": "18080 CRENSHAW BLVD",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905049998,
    "dropphyadd": "18080 CRENSHAW BLVD",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905049998,
    "dropmaladd": "18080 CRENSHAW BLVD",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905049998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103244470,
    "dropsitcph": 3103242975,
    "dropfax": 3103240373
  },
  {
    "dcode": "D",
    "dropkey": "SZ22219",
    "droptype": "D",
    "dropname": "NORTHPARK SAN BERNARDINO",
    "dropdeladd": "4560 HALLMARK PKWY",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924071886,
    "dropphyadd": "4560 HALLMARK PKWY",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924071886,
    "dropmaladd": "4560 HALLMARK PKWY",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924071886,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098875968,
    "dropsitcph": 9098875518,
    "dropfax": 9098872668
  },
  {
    "dcode": "D",
    "dropkey": "SZ22277",
    "droptype": "D",
    "dropname": "MACYS STATION",
    "dropdeladd": "170 OFARRELL ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941029993,
    "dropphyadd": "170 OFARRELL ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941029993,
    "dropmaladd": "170 OFARRELL ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941029993,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156262932,
    "dropsitcph": 4156262932,
    "dropfax": 4154349018
  },
  {
    "dcode": "D",
    "dropkey": "SZ22284",
    "droptype": "D",
    "dropname": "OAK GROVE",
    "dropdeladd": "655 OAK GROVE AVE",
    "dropdelcty": "MENLO PARK",
    "dropdelst": "CA",
    "dropdelzpp": 940259991,
    "dropphyadd": "655 OAK GROVE AVE",
    "dropphycty": "MENLO PARK",
    "dropphyst": "CA",
    "dropphyzpp": 940259991,
    "dropmaladd": "655 OAK GROVE AVE",
    "dropmalcty": "MENLO PARK",
    "dropmalst": "CA",
    "dropmalzpp": 940259991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503217682,
    "dropsitcph": 6503232701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22289",
    "droptype": "D",
    "dropname": "OAK PARK",
    "dropdeladd": "2929 35TH ST",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958179998,
    "dropphyadd": "2929 35TH ST",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958179998,
    "dropmaladd": "2929 35TH ST",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958179998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162273864,
    "dropsitcph": 9162276509,
    "dropfax": 9164569716
  },
  {
    "dcode": "D",
    "dropkey": "SZ22301",
    "droptype": "D",
    "dropname": "OAKWOOD",
    "dropdeladd": "265 S WESTERN AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900049998,
    "dropphyadd": "265 S WESTERN AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900049998,
    "dropmaladd": "265 S WESTERN AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900049998,
    "dropsitphn": 2133833645,
    "dropsitlph": 3233833645,
    "dropsitcph": 2133834806,
    "dropfax": 2137390078
  },
  {
    "dcode": "D",
    "dropkey": "SZ22305",
    "droptype": "D",
    "dropname": "OCEAN BEACH",
    "dropdeladd": "4833 SANTA MONICA AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921079998,
    "dropphyadd": "4833 SANTA MONICA AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921079998,
    "dropmaladd": "4833 SANTA MONICA AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921079998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192248815,
    "dropsitcph": 6192243610,
    "dropfax": 6192247549
  },
  {
    "dcode": "D",
    "dropkey": "SZ22306",
    "droptype": "D",
    "dropname": "OCEAN PARK",
    "dropdeladd": "2720 NEILSON WAY FL 1",
    "dropdelcty": "SANTA MONICA",
    "dropdelst": "CA",
    "dropdelzpp": 904059998,
    "dropphyadd": "2720 NEILSON WAY FL 1",
    "dropphycty": "SANTA MONICA",
    "dropphyst": "CA",
    "dropphyzpp": 904059998,
    "dropmaladd": "2720 NEILSON WAY FL 1",
    "dropmalcty": "SANTA MONICA",
    "dropmalst": "CA",
    "dropmalzpp": 904059998,
    "dropsitphn": 3105766539,
    "dropsitlph": 3105766563,
    "dropsitcph": 3105766544,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22312",
    "droptype": "D",
    "dropname": "MINNER",
    "dropdeladd": "118 MINNER AVE",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933089998,
    "dropphyadd": "118 MINNER AVE",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933089998,
    "dropmaladd": "118 MINNER AVE",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933089998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613687668,
    "dropsitcph": 6613687668,
    "dropfax": 6613991430
  },
  {
    "dcode": "D",
    "dropkey": "SZ22321",
    "droptype": "D",
    "dropname": "OLD TOWN",
    "dropdeladd": "28360 OLD TOWN FRONT ST",
    "dropdelcty": "TEMECULA",
    "dropdelst": "CA",
    "dropdelzpp": 925909998,
    "dropphyadd": "28360 OLD TOWN FRONT ST",
    "dropphycty": "TEMECULA",
    "dropphyst": "CA",
    "dropphyzpp": 925909998,
    "dropmaladd": "28360 OLD TOWN FRONT ST",
    "dropmalcty": "TEMECULA",
    "dropmalst": "CA",
    "dropmalzpp": 925909998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516941693,
    "dropsitcph": 9515065513,
    "dropfax": 9516943413
  },
  {
    "dcode": "D",
    "dropkey": "SZ22338",
    "droptype": "D",
    "dropname": "ORANGE GLEN",
    "dropdeladd": "1770 E VALLEY PKWY",
    "dropdelcty": "ESCONDIDO",
    "dropdelst": "CA",
    "dropdelzpp": 920279998,
    "dropphyadd": "1770 E VALLEY PKWY",
    "dropphycty": "ESCONDIDO",
    "dropphyst": "CA",
    "dropphyzpp": 920279998,
    "dropmaladd": "1770 E VALLEY PKWY",
    "dropmalcty": "ESCONDIDO",
    "dropmalst": "CA",
    "dropmalzpp": 920279998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7604320486,
    "dropsitcph": 7604320713,
    "dropfax": 7607400261
  },
  {
    "dcode": "D",
    "dropkey": "SZ22341",
    "droptype": "D",
    "dropname": "ORANGEHURST",
    "dropdeladd": "1920 W COMMONWEALTH AVE",
    "dropdelcty": "FULLERTON",
    "dropdelst": "CA",
    "dropdelzpp": 928379998,
    "dropphyadd": "1920 W COMMONWEALTH AVE",
    "dropphycty": "FULLERTON",
    "dropphyst": "CA",
    "dropphyzpp": 928379998,
    "dropmaladd": "1920 W COMMONWEALTH AVE",
    "dropmalcty": "FULLERTON",
    "dropmalst": "CA",
    "dropmalzpp": 928379998,
    "dropsitphn": 7145261028,
    "dropsitlph": 7145261031,
    "dropsitcph": 7145261028,
    "dropfax": 7145263138
  },
  {
    "dcode": "D",
    "dropkey": "SZ22343",
    "droptype": "D",
    "dropname": "ORANGEWOOD",
    "dropdeladd": "99 W CALIFORNIA BLVD",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911059997,
    "dropphyadd": "99 W CALIFORNIA BLVD",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911059997,
    "dropmaladd": "99 W CALIFORNIA BLVD",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911059997,
    "dropsitphn": 6617757808,
    "dropsitlph": 6264498631,
    "dropsitcph": 6264491843,
    "dropfax": 6267952317
  },
  {
    "dcode": "D",
    "dropkey": "SZ22365",
    "droptype": "D",
    "dropname": "PACIFIC",
    "dropdeladd": "1920 PACIFIC AVE",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908069998,
    "dropphyadd": "1920 PACIFIC AVE",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908069998,
    "dropmaladd": "1920 PACIFIC AVE",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908069998,
    "dropsitphn": 5625913840,
    "dropsitlph": 5625913840,
    "dropsitcph": 5625913840,
    "dropfax": 5622183498
  },
  {
    "dcode": "D",
    "dropkey": "SZ22367",
    "droptype": "D",
    "dropname": "PACIFIC BEACH",
    "dropdeladd": "4640 CASS ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921099998,
    "dropphyadd": "4640 CASS ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921099998,
    "dropmaladd": "4640 CASS ST",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921099998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8582724865,
    "dropsitcph": 8582721948,
    "dropfax": 8582725147
  },
  {
    "dcode": "D",
    "dropkey": "SZ22380",
    "droptype": "D",
    "dropname": "PADDISON SQUARE",
    "dropdeladd": "12415 NORWALK BLVD",
    "dropdelcty": "NORWALK",
    "dropdelst": "CA",
    "dropdelzpp": 906509997,
    "dropphyadd": "12415 NORWALK BLVD",
    "dropphycty": "NORWALK",
    "dropphyst": "CA",
    "dropphyzpp": 906509997,
    "dropmaladd": "12415 NORWALK BLVD",
    "dropmalcty": "NORWALK",
    "dropmalst": "CA",
    "dropmalzpp": 906509997,
    "dropsitphn": 5628689408,
    "dropsitlph": 5628639846,
    "dropsitcph": 5628689408,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22395",
    "droptype": "D",
    "dropname": "PALMS",
    "dropdeladd": "3751 MOTOR AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900349998,
    "dropphyadd": "3751 MOTOR AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900349998,
    "dropmaladd": "3751 MOTOR AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900349998,
    "dropsitphn": 3105861867,
    "dropsitlph": 3108390180,
    "dropsitcph": 3108390286,
    "dropfax": 3108395643
  },
  {
    "dcode": "D",
    "dropkey": "SZ22409",
    "droptype": "D",
    "dropname": "PARADISE",
    "dropdeladd": "1717 PARADISE RD",
    "dropdelcty": "MODESTO",
    "dropdelst": "CA",
    "dropdelzpp": 953589998,
    "dropphyadd": "1717 PARADISE RD",
    "dropphycty": "MODESTO",
    "dropphyst": "CA",
    "dropphyzpp": 953589998,
    "dropmaladd": "1717 PARADISE RD",
    "dropmalcty": "MODESTO",
    "dropmalst": "CA",
    "dropmalzpp": 953589998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2095749416,
    "dropsitcph": 2095740160,
    "dropfax": 2095740187
  },
  {
    "dcode": "D",
    "dropkey": "SZ22413",
    "droptype": "D",
    "dropname": "PARADISE HILLS",
    "dropdeladd": "2356 REO DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921399998,
    "dropphyadd": "2356 REO DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921399998,
    "dropmaladd": "2356 REO DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921399998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194754762,
    "dropsitcph": 6194758649,
    "dropfax": 6194758709
  },
  {
    "dcode": "D",
    "dropkey": "SZ22422",
    "droptype": "D",
    "dropname": "PARKMOOR",
    "dropdeladd": "545 MERIDIAN AVE STE D",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951263425,
    "dropphyadd": "545 MERIDIAN AVE STE D",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951263425,
    "dropmaladd": "545 MERIDIAN AVE STE D",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951263425,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082940588,
    "dropsitcph": 4087236147,
    "dropfax": 4089713310
  },
  {
    "dcode": "D",
    "dropkey": "SZ22423",
    "droptype": "D",
    "dropname": "PARKSIDE",
    "dropdeladd": "1800 TARAVAL ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941169991,
    "dropphyadd": "1800 TARAVAL ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941169991,
    "dropmaladd": "1800 TARAVAL ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941169991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4157590150,
    "dropsitcph": 4157590150,
    "dropfax": 4157591013
  },
  {
    "dcode": "D",
    "dropkey": "SZ22424",
    "droptype": "D",
    "dropname": "PARKWAY",
    "dropdeladd": "4301 BROOKFIELD DR",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958239998,
    "dropphyadd": "4301 BROOKFIELD DR",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958239998,
    "dropmaladd": "4301 BROOKFIELD DR",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958239998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162623113,
    "dropsitcph": 9162623126,
    "dropfax": 9163928472
  },
  {
    "dcode": "D",
    "dropkey": "SZ22453",
    "droptype": "D",
    "dropname": "PERKINS",
    "dropdeladd": "9500 KIEFER BLVD",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958279998,
    "dropphyadd": "9500 KIEFER BLVD",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958279998,
    "dropmaladd": "9500 KIEFER BLVD",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958279998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9162555104,
    "dropsitcph": 9162555102,
    "dropfax": 9163660269
  },
  {
    "dcode": "D",
    "dropkey": "SZ22468",
    "droptype": "D",
    "dropname": "PICO HEIGHTS",
    "dropdeladd": "2390 W PICO BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900759997,
    "dropphyadd": "2390 W PICO BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900759997,
    "dropmaladd": "2390 W PICO BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900759997,
    "dropsitphn": 3235861867,
    "dropsitlph": 2133828201,
    "dropsitcph": 2133828136,
    "dropfax": 2133899848
  },
  {
    "dcode": "D",
    "dropkey": "SZ22485",
    "droptype": "D",
    "dropname": "PINE STREET",
    "dropdeladd": "1400 PINE ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941099991,
    "dropphyadd": "1400 PINE ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941099991,
    "dropmaladd": "1400 PINE ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941099991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4153512484,
    "dropsitcph": 4153512484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22511",
    "droptype": "D",
    "dropname": "PLAYA",
    "dropdeladd": "350 FOREST AVE",
    "dropdelcty": "LAGUNA BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926529000,
    "dropphyadd": "350 FOREST AVE",
    "dropphycty": "LAGUNA BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926529000,
    "dropmaladd": "29911 NIGUEL RD",
    "dropmalcty": "LAGUNA NIGUEL",
    "dropmalst": "CA",
    "dropmalzpp": 926079998,
    "dropsitphn": 9493628306,
    "dropsitlph": 9493767982,
    "dropsitcph": 9493628306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22515",
    "droptype": "D",
    "dropname": "PLAZA ORANGE",
    "dropdeladd": "308 W CHAPMAN AVE",
    "dropdelcty": "ORANGE",
    "dropdelst": "CA",
    "dropdelzpp": 928569998,
    "dropphyadd": "308 W CHAPMAN AVE",
    "dropphycty": "ORANGE",
    "dropphyst": "CA",
    "dropphyzpp": 928569998,
    "dropmaladd": "308 W CHAPMAN AVE",
    "dropmalcty": "ORANGE",
    "dropmalst": "CA",
    "dropmalzpp": 928569998,
    "dropsitphn": 7147441126,
    "dropsitlph": 7147441657,
    "dropsitcph": 7147441126,
    "dropfax": 7147714339
  },
  {
    "dcode": "D",
    "dropkey": "SZ22516",
    "droptype": "D",
    "dropname": "PLAZA PASADENA",
    "dropdeladd": "281 E COLORADO BLVD",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911019998,
    "dropphyadd": "281 E COLORADO BLVD",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911019998,
    "dropmaladd": "281 E COLORADO BLVD",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6267440422,
    "dropsitcph": 6267440212,
    "dropfax": 6267952317
  },
  {
    "dcode": "D",
    "dropkey": "SZ22518",
    "droptype": "D",
    "dropname": "PLAZA CENTER",
    "dropdeladd": "1126 N MOUNTAIN AVE",
    "dropdelcty": "ONTARIO",
    "dropdelst": "CA",
    "dropdelzpp": 917629991,
    "dropphyadd": "1126 N MOUNTAIN AVE",
    "dropphycty": "ONTARIO",
    "dropphyst": "CA",
    "dropphyzpp": 917629991,
    "dropmaladd": "1555 E HOLT BLVD",
    "dropmalcty": "ONTARIO",
    "dropmalst": "CA",
    "dropmalzpp": 917619998,
    "dropsitphn": 9099333837,
    "dropsitlph": 9099832531,
    "dropsitcph": 9099333837,
    "dropfax": 9093913243
  },
  {
    "dcode": "D",
    "dropkey": "SZ22527",
    "droptype": "D",
    "dropname": "POINT DUME",
    "dropdeladd": "29160 HEATHERCLIFF RD FL 1",
    "dropdelcty": "MALIBU",
    "dropdelst": "CA",
    "dropdelzpp": 902659993,
    "dropphyadd": "29160 HEATHERCLIFF RD FL 1",
    "dropphycty": "MALIBU",
    "dropphyst": "CA",
    "dropphyzpp": 902659993,
    "dropmaladd": "29160 HEATHERCLIFF RD FL 1",
    "dropmalcty": "MALIBU",
    "dropmalst": "CA",
    "dropmalzpp": 902659993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3104578617,
    "dropsitcph": 3104571327,
    "dropfax": 3104575274
  },
  {
    "dcode": "D",
    "dropkey": "SZ22529",
    "droptype": "D",
    "dropname": "POINT LOMA",
    "dropdeladd": "2931 CANON ST",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921069998,
    "dropphyadd": "2931 CANON ST",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921069998,
    "dropmaladd": "2931 CANON ST",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921069998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192220829,
    "dropsitcph": 6197589287,
    "dropfax": 6192220829
  },
  {
    "dcode": "D",
    "dropkey": "SZ22534",
    "droptype": "D",
    "dropname": "POINT RICHMOND",
    "dropdeladd": "104 WASHINGTON AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948019991,
    "dropphyadd": "104 WASHINGTON AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948019991,
    "dropmaladd": "104 WASHINGTON AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948019991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102328510,
    "dropsitcph": 5102324522,
    "dropfax": 5102378729
  },
  {
    "dcode": "D",
    "dropkey": "SZ22554",
    "droptype": "D",
    "dropname": "POSTAL AVE",
    "dropdeladd": "24040 POSTAL AVE",
    "dropdelcty": "MORENO VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 925539997,
    "dropphyadd": "24040 POSTAL AVE",
    "dropphycty": "MORENO VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 925539997,
    "dropmaladd": "24040 POSTAL AVE",
    "dropmalcty": "MORENO VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 925539997,
    "dropsitphn": 9513354694,
    "dropsitlph": 9512473003,
    "dropsitcph": 9516569720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22566",
    "droptype": "D",
    "dropname": "PRESIDIO OF MONTEREY",
    "dropdeladd": "1712 PRIVATE BOLIO RD RM 517A",
    "dropdelcty": "MONTEREY",
    "dropdelst": "CA",
    "dropdelzpp": 939443206,
    "dropphyadd": "1712 PRIVATE BOLIO RD RM 517A",
    "dropphycty": "MONTEREY",
    "dropphyst": "CA",
    "dropphyzpp": 939443206,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "MONTEREY",
    "dropmalst": "CA",
    "dropmalzpp": 939449998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313726224,
    "dropsitcph": 8313726224,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22571",
    "droptype": "D",
    "dropname": "PREUSS",
    "dropdeladd": "1270 S ALFRED ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900359998,
    "dropphyadd": "1270 S ALFRED ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900359998,
    "dropmaladd": "1270 S ALFRED ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900359998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236551812,
    "dropsitcph": 3236552853,
    "dropfax": 3236558257
  },
  {
    "dcode": "D",
    "dropkey": "SZ22596",
    "droptype": "D",
    "dropname": "RAMIREZ",
    "dropdeladd": "5115 S FIGUEROA ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900379998,
    "dropphyadd": "5115 S FIGUEROA ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900379998,
    "dropmaladd": "5115 S FIGUEROA ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900379998,
    "dropsitphn": 2135861867,
    "dropsitlph": "",
    "dropsitcph": 3232344092,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22598",
    "droptype": "D",
    "dropname": "RANCH",
    "dropdeladd": "19300 RINALDI ST",
    "dropdelcty": "PORTER RANCH",
    "dropdelst": "CA",
    "dropdelzpp": 913269998,
    "dropphyadd": "19300 RINALDI ST",
    "dropphycty": "PORTER RANCH",
    "dropphyst": "CA",
    "dropphyzpp": 913269998,
    "dropmaladd": "19300 RINALDI ST",
    "dropmalcty": "PORTER RANCH",
    "dropmalst": "CA",
    "dropmalzpp": 913269998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183682192,
    "dropsitcph": 8183490331,
    "dropfax": 8184071569
  },
  {
    "dcode": "D",
    "dropkey": "SZ22605",
    "droptype": "D",
    "dropname": "RANCHO DEL REY",
    "dropdeladd": "340 OXFORD ST",
    "dropdelcty": "CHULA VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 919119998,
    "dropphyadd": "340 OXFORD ST",
    "dropphycty": "CHULA VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 919119998,
    "dropmaladd": "340 OXFORD ST",
    "dropmalcty": "CHULA VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 919119998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194270251,
    "dropsitcph": 6194980687,
    "dropfax": 6194263092
  },
  {
    "dcode": "D",
    "dropkey": "SZ22615",
    "droptype": "D",
    "dropname": "RANCHO PARK",
    "dropdeladd": "11270 EXPOSITION BLVD FL 1",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900649998,
    "dropphyadd": "11270 EXPOSITION BLVD FL 1",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900649998,
    "dropmaladd": "11270 EXPOSITION BLVD FL 1",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900649998,
    "dropsitphn": 3235861868,
    "dropsitlph": 3104789847,
    "dropsitcph": 3104783936,
    "dropfax": 3104783086
  },
  {
    "dcode": "D",
    "dropkey": "SZ22617",
    "droptype": "D",
    "dropname": "RANCHO PENASQUITOS",
    "dropdeladd": "9245 TWIN TRAILS DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921299998,
    "dropphyadd": "9245 TWIN TRAILS DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921299998,
    "dropmaladd": "9245 TWIN TRAILS DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921299998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585385841,
    "dropsitcph": 8585385773,
    "dropfax": 8585383304
  },
  {
    "dcode": "D",
    "dropkey": "SZ22665",
    "droptype": "D",
    "dropname": "RIMPAU",
    "dropdeladd": "4040 W WASHINGTON BLVD FRNT",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900181067,
    "dropphyadd": "4040 W WASHINGTON BLVD FRNT",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900181067,
    "dropmaladd": "PO BOX 199998",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900199998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3237358025,
    "dropsitcph": 3237350684,
    "dropfax": 3237318178
  },
  {
    "dcode": "D",
    "dropkey": "SZ22685",
    "droptype": "D",
    "dropname": "BAY",
    "dropdeladd": "191 RIVERSIDE AVE",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926599998,
    "dropphyadd": "191 RIVERSIDE AVE",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926599998,
    "dropmaladd": "191 RIVERSIDE AVE",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926599998,
    "dropsitphn": 9496444512,
    "dropsitlph": 9496461267,
    "dropsitcph": 9496444512,
    "dropfax": 9496461199
  },
  {
    "dcode": "D",
    "dropkey": "SZ22687",
    "droptype": "D",
    "dropname": "RIVERTOWN",
    "dropdeladd": "420 W 4TH ST",
    "dropdelcty": "ANTIOCH",
    "dropdelst": "CA",
    "dropdelzpp": 945099991,
    "dropphyadd": "420 W 4TH ST",
    "dropphycty": "ANTIOCH",
    "dropphyst": "CA",
    "dropphyzpp": 945099991,
    "dropmaladd": "420 W 4TH ST",
    "dropmalcty": "ANTIOCH",
    "dropmalst": "CA",
    "dropmalzpp": 945099991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9257783697,
    "dropsitcph": 9257783578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22692",
    "droptype": "D",
    "dropname": "ROBERTSVILLE",
    "dropdeladd": "1175 BRANHAM LN",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951189998,
    "dropphyadd": "1175 BRANHAM LN",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951189998,
    "dropmaladd": "1175 BRANHAM LN",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951189998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082649317,
    "dropsitcph": 4082649523,
    "dropfax": 4082641158
  },
  {
    "dcode": "D",
    "dropkey": "SZ22717",
    "droptype": "D",
    "dropname": "ROSELAND",
    "dropdeladd": "2585 SEBASTOPOL RD",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "CA",
    "dropdelzpp": 954079991,
    "dropphyadd": "2585 SEBASTOPOL RD",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "CA",
    "dropphyzpp": 954079991,
    "dropmaladd": "2585 SEBASTOPOL RD",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "CA",
    "dropmalzpp": 954079991,
    "dropsitphn": 7077785461,
    "dropsitlph": 7075420343,
    "dropsitcph": 7075282209,
    "dropfax": 7075423248
  },
  {
    "dcode": "D",
    "dropkey": "SZ22767",
    "droptype": "D",
    "dropname": "SAINT JAMES PARK",
    "dropdeladd": "105 N 1ST ST",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951139998,
    "dropphyadd": "105 N 1ST ST",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951139998,
    "dropmaladd": "105 N 1ST ST",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951139998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082926285,
    "dropsitcph": 4082920487,
    "dropfax": 4082751268
  },
  {
    "dcode": "D",
    "dropkey": "SZ22769",
    "droptype": "D",
    "dropname": "SAINT MARYS COLLEGE",
    "dropdeladd": "1928 SAINT MARYS RD",
    "dropdelcty": "MORAGA",
    "dropdelst": "CA",
    "dropdelzpp": 945752744,
    "dropphyadd": "1928 SAINT MARYS RD",
    "dropphycty": "MORAGA",
    "dropphyst": "CA",
    "dropphyzpp": 945752744,
    "dropmaladd": "460 CENTER ST",
    "dropmalcty": "MORAGA",
    "dropmalst": "CA",
    "dropmalzpp": 945569998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9253768692,
    "dropsitcph": 9253760739,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22770",
    "droptype": "D",
    "dropname": "SAINT MATTHEW",
    "dropdeladd": "210 S ELLSWORTH AVE",
    "dropdelcty": "SAN MATEO",
    "dropdelst": "CA",
    "dropdelzpp": 944019991,
    "dropphyadd": "210 S ELLSWORTH AVE",
    "dropphycty": "SAN MATEO",
    "dropphyst": "CA",
    "dropphyzpp": 944019991,
    "dropmaladd": "210 S ELLSWORTH AVE",
    "dropmalcty": "SAN MATEO",
    "dropmalst": "CA",
    "dropmalzpp": 944019991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503588482,
    "dropsitcph": 6503588476,
    "dropfax": 6503499726
  },
  {
    "dcode": "D",
    "dropkey": "SZ22806",
    "droptype": "D",
    "dropname": "SAN FRANCISCO P&DC FINANCE",
    "dropdeladd": "1300 EVANS AVE STE 30",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941888014,
    "dropphyadd": "1300 EVANS AVE STE 30",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941888014,
    "dropmaladd": "1300 EVANS AVE STE 30",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941888014,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155505245,
    "dropsitcph": 4155505245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22823",
    "droptype": "D",
    "dropname": "SAN JUAN PLAZA",
    "dropdeladd": "32124 PASEO ADELANTO STE 1",
    "dropdelcty": "SAN JUAN CAPISTRANO",
    "dropdelst": "CA",
    "dropdelzpp": 926939998,
    "dropphyadd": "32124 PASEO ADELANTO STE 1",
    "dropphycty": "SAN JUAN CAPISTRANO",
    "dropphyst": "CA",
    "dropphyzpp": 926939998,
    "dropmaladd": "28081 MARGUERITE PKWY",
    "dropmalcty": "MISSION VIEJO",
    "dropmalst": "CA",
    "dropmalzpp": 926909998,
    "dropsitphn": 9493649606,
    "dropsitlph": 9494963275,
    "dropsitcph": 9493649606,
    "dropfax": 9493640209
  },
  {
    "dcode": "D",
    "dropkey": "SZ22842",
    "droptype": "D",
    "dropname": "SAN ROQUE",
    "dropdeladd": "3345 STATE ST",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931059998,
    "dropphyadd": "3345 STATE ST",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931059998,
    "dropmaladd": "3345 STATE ST",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931059998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055632556,
    "dropsitcph": 8056821496,
    "dropfax": 8056825431
  },
  {
    "dcode": "D",
    "dropkey": "SZ22848",
    "droptype": "D",
    "dropname": "SANDERSON",
    "dropdeladd": "3120 W FLORIDA AVE",
    "dropdelcty": "HEMET",
    "dropdelst": "CA",
    "dropdelzpp": 925453621,
    "dropphyadd": "3120 W FLORIDA AVE",
    "dropphycty": "HEMET",
    "dropphyst": "CA",
    "dropphyzpp": 925453621,
    "dropmaladd": "3120 W FLORIDA AVE",
    "dropmalcty": "HEMET",
    "dropmalst": "CA",
    "dropmalzpp": 925453621,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516529428,
    "dropsitcph": 9516581323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22866",
    "droptype": "D",
    "dropname": "SANTA FE PLAZA",
    "dropdeladd": "13445 TELEGRAPH RD",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906059991,
    "dropphyadd": "13445 TELEGRAPH RD",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906059991,
    "dropmaladd": "13445 TELEGRAPH RD",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906059991,
    "dropsitphn": 5626939561,
    "dropsitlph": 5629034515,
    "dropsitcph": 5626939561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22889",
    "droptype": "D",
    "dropname": "SATHER GATE",
    "dropdeladd": "2515 1/2 DURANT AVE",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947049991,
    "dropphyadd": "2515 1/2 DURANT AVE",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947049991,
    "dropmaladd": "2000 ALLSTON WAY",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947049998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493153,
    "dropsitcph": 5106496762,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ22890",
    "droptype": "D",
    "dropname": "SATICOY",
    "dropdeladd": "11043 CITRUS DR",
    "dropdelcty": "VENTURA",
    "dropdelst": "CA",
    "dropdelzpp": 930041300,
    "dropphyadd": "11043 CITRUS DR",
    "dropphycty": "VENTURA",
    "dropphyst": "CA",
    "dropphyzpp": 930041300,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "VENTURA",
    "dropmalst": "CA",
    "dropmalzpp": 930079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8056471653,
    "dropsitcph": 8056476058,
    "dropfax": 8056432831
  },
  {
    "dcode": "D",
    "dropkey": "SZ22920",
    "droptype": "D",
    "dropname": "SERRA MESA",
    "dropdeladd": "3223 GREYLING DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921239998,
    "dropphyadd": "3223 GREYLING DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921239998,
    "dropmaladd": "3223 GREYLING DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921239998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8582777879,
    "dropsitcph": 8582774903,
    "dropfax": 8582778746
  },
  {
    "dcode": "D",
    "dropkey": "SZ22944",
    "droptype": "D",
    "dropname": "SHELL BEACH",
    "dropdeladd": "1301 SHELL BEACH RD",
    "dropdelcty": "PISMO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 934491954,
    "dropphyadd": "1301 SHELL BEACH RD",
    "dropphycty": "PISMO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 934491954,
    "dropmaladd": "1301 SHELL BEACH RD",
    "dropmalcty": "PISMO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 934491954,
    "dropsitphn": 6617757808,
    "dropsitlph": 8057733485,
    "dropsitcph": 8054815971,
    "dropfax": 8059610838
  },
  {
    "dcode": "D",
    "dropkey": "SZ22979",
    "droptype": "D",
    "dropname": "SLAUSON",
    "dropdeladd": "9240 SLAUSON AVE",
    "dropdelcty": "PICO RIVERA",
    "dropdelst": "CA",
    "dropdelzpp": 906609996,
    "dropphyadd": "9240 SLAUSON AVE",
    "dropphycty": "PICO RIVERA",
    "dropphyst": "CA",
    "dropphyzpp": 906609996,
    "dropmaladd": "9240 SLAUSON AVE",
    "dropmalcty": "PICO RIVERA",
    "dropmalst": "CA",
    "dropmalzpp": 906609996,
    "dropsitphn": 5624940493,
    "dropsitlph": 5629490493,
    "dropsitcph": 5629490493,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ22991",
    "droptype": "D",
    "dropname": "SMOKE TREE",
    "dropdeladd": "1775 E PALM CANYON DR STE 605",
    "dropdelcty": "PALM SPRINGS",
    "dropdelst": "CA",
    "dropdelzpp": 922649996,
    "dropphyadd": "1775 E PALM CANYON DR STE 605",
    "dropphycty": "PALM SPRINGS",
    "dropphyst": "CA",
    "dropphyzpp": 922649996,
    "dropmaladd": "333 N SUNRISE WAY",
    "dropmalcty": "PALM SPRINGS",
    "dropmalst": "CA",
    "dropmalzpp": 922629998,
    "dropsitphn": 9093354694,
    "dropsitlph": 7603206971,
    "dropsitcph": 7603224111,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23042",
    "droptype": "D",
    "dropname": "SORRENTO VALLEY",
    "dropdeladd": "3974 SORRENTO VALLEY BLVD STE 100",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921219998,
    "dropphyadd": "3974 SORRENTO VALLEY BLVD STE 100",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921219998,
    "dropmaladd": "3974 SORRENTO VALLEY BLVD STE 100",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921219998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8588249113,
    "dropsitcph": 8588249094,
    "dropfax": 8585460212
  },
  {
    "dcode": "D",
    "dropkey": "SZ23043",
    "droptype": "D",
    "dropname": "SOTO",
    "dropdeladd": "5625 SOTO ST",
    "dropdelcty": "HUNTINGTON PARK",
    "dropdelst": "CA",
    "dropdelzpp": 902559993,
    "dropphyadd": "5625 SOTO ST",
    "dropphycty": "HUNTINGTON PARK",
    "dropphyst": "CA",
    "dropphyzpp": 902559993,
    "dropmaladd": "5625 SOTO ST",
    "dropmalcty": "HUNTINGTON PARK",
    "dropmalst": "CA",
    "dropmalzpp": 902559993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3235822229,
    "dropsitcph": 3235824827,
    "dropfax": 3235826040
  },
  {
    "dcode": "D",
    "dropkey": "SZ23047",
    "droptype": "D",
    "dropname": "SOUTH ALHAMBRA",
    "dropdeladd": "1603 W VALLEY BLVD",
    "dropdelcty": "ALHAMBRA",
    "dropdelst": "CA",
    "dropdelzpp": 918039998,
    "dropphyadd": "1603 W VALLEY BLVD",
    "dropphycty": "ALHAMBRA",
    "dropphyst": "CA",
    "dropphyzpp": 918039998,
    "dropmaladd": "1603 W VALLEY BLVD",
    "dropmalcty": "ALHAMBRA",
    "dropmalst": "CA",
    "dropmalzpp": 918039998,
    "dropsitphn": 6262891681,
    "dropsitlph": 6262891606,
    "dropsitcph": 6262891681,
    "dropfax": 6262899724
  },
  {
    "dcode": "D",
    "dropkey": "SZ23048",
    "droptype": "D",
    "dropname": "SOUTH BAKERSFIELD",
    "dropdeladd": "3200 LARSON LN",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933045351,
    "dropphyadd": "3200 LARSON LN",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933045351,
    "dropmaladd": "3200 LARSON LN",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933045351,
    "dropsitphn": 6617757808,
    "dropsitlph": 6615016002,
    "dropsitcph": 6615016002,
    "dropfax": 6618360285
  },
  {
    "dcode": "D",
    "dropkey": "SZ23050",
    "droptype": "D",
    "dropname": "SOUTH BERKELEY",
    "dropdeladd": "3175 ADELINE ST",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947039991,
    "dropphyadd": "3175 ADELINE ST",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947039991,
    "dropmaladd": "3175 ADELINE ST",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947032401,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106496715,
    "dropsitcph": 5106496714,
    "dropfax": 5106659281
  },
  {
    "dcode": "D",
    "dropkey": "SZ23052",
    "droptype": "D",
    "dropname": "SOUTH DOWNEY",
    "dropdeladd": "7911 IMPERIAL HWY",
    "dropdelcty": "DOWNEY",
    "dropdelst": "CA",
    "dropdelzpp": 902429998,
    "dropphyadd": "7911 IMPERIAL HWY",
    "dropphycty": "DOWNEY",
    "dropphyst": "CA",
    "dropphyzpp": 902429998,
    "dropmaladd": "7911 IMPERIAL HWY",
    "dropmalcty": "DOWNEY",
    "dropmalst": "CA",
    "dropmalzpp": 902429998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5628614096,
    "dropsitcph": 5628613035,
    "dropfax": 5626226826
  },
  {
    "dcode": "D",
    "dropkey": "SZ23054",
    "droptype": "D",
    "dropname": "SOUTH GARDENA",
    "dropdeladd": "1103 W GARDENA BLVD",
    "dropdelcty": "GARDENA",
    "dropdelst": "CA",
    "dropdelzpp": 902479993,
    "dropphyadd": "1103 W GARDENA BLVD",
    "dropphycty": "GARDENA",
    "dropphyst": "CA",
    "dropphyzpp": 902479993,
    "dropmaladd": "1103 W GARDENA BLVD",
    "dropmalcty": "GARDENA",
    "dropmalst": "CA",
    "dropmalzpp": 902479993,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103242595,
    "dropsitcph": 3103249887,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23061",
    "droptype": "D",
    "dropname": "SOUTH MAIN",
    "dropdeladd": "1415 S MAIN ST",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927079998,
    "dropphyadd": "1415 S MAIN ST",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927079998,
    "dropmaladd": "1415 S MAIN ST",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927079998,
    "dropsitphn": 7146620353,
    "dropsitlph": 7148360353,
    "dropsitcph": 7148360353,
    "dropfax": 7145416285
  },
  {
    "dcode": "D",
    "dropkey": "SZ23067",
    "droptype": "D",
    "dropname": "SOUTH SAN GABRIEL",
    "dropdeladd": "8111 NEWMARK AVE",
    "dropdelcty": "ROSEMEAD",
    "dropdelst": "CA",
    "dropdelzpp": 917709997,
    "dropphyadd": "8111 NEWMARK AVE",
    "dropphycty": "ROSEMEAD",
    "dropphyst": "CA",
    "dropphyzpp": 917709997,
    "dropmaladd": "8845 VALLEY BLVD",
    "dropmalcty": "ROSEMEAD",
    "dropmalst": "CA",
    "dropmalzpp": 917709998,
    "dropsitphn": 6262806467,
    "dropsitlph": 6262801230,
    "dropsitcph": 6262806467,
    "dropfax": 6262806072
  },
  {
    "dcode": "D",
    "dropkey": "SZ23068",
    "droptype": "D",
    "dropname": "SOUTH SAN LEANDRO",
    "dropdeladd": "14500 E 14TH ST",
    "dropdelcty": "SAN LEANDRO",
    "dropdelst": "CA",
    "dropdelzpp": 945789991,
    "dropphyadd": "14500 E 14TH ST",
    "dropphycty": "SAN LEANDRO",
    "dropphyst": "CA",
    "dropphyzpp": 945789991,
    "dropmaladd": "1777 ABRAM CT",
    "dropmalcty": "SAN LEANDRO",
    "dropmalst": "CA",
    "dropmalzpp": 945779998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106670412,
    "dropsitcph": 5106670410,
    "dropfax": 5106670327
  },
  {
    "dcode": "D",
    "dropkey": "SZ23072",
    "droptype": "D",
    "dropname": "SOUTHBAY PAVILION",
    "dropdeladd": "20700 AVALON BLVD STE 116",
    "dropdelcty": "CARSON",
    "dropdelst": "CA",
    "dropdelzpp": 907469997,
    "dropphyadd": "20700 AVALON BLVD STE 116",
    "dropphycty": "CARSON",
    "dropphyst": "CA",
    "dropphyzpp": 907469997,
    "dropmaladd": "20700 AVALON BLVD STE 116",
    "dropmalcty": "CARSON",
    "dropmalst": "CA",
    "dropmalzpp": 907469997,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103274701,
    "dropsitcph": 3103275371,
    "dropfax": 3103273580
  },
  {
    "dcode": "D",
    "dropkey": "SZ23073",
    "droptype": "D",
    "dropname": "SOUTHEASTERN",
    "dropdeladd": "2777 LOGAN AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921139998,
    "dropphyadd": "2777 LOGAN AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921139998,
    "dropmaladd": "2777 LOGAN AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921139998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192394639,
    "dropsitcph": 6192390971,
    "dropfax": 6192390715
  },
  {
    "dcode": "D",
    "dropkey": "SZ23088",
    "droptype": "D",
    "dropname": "SPRINGSTOWNE",
    "dropdeladd": "100 ADMIRAL CALLAGHAN LN",
    "dropdelcty": "VALLEJO",
    "dropdelst": "CA",
    "dropdelzpp": 945919991,
    "dropphyadd": "100 ADMIRAL CALLAGHAN LN",
    "dropphycty": "VALLEJO",
    "dropphyst": "CA",
    "dropphyzpp": 945919991,
    "dropmaladd": "100 ADMIRAL CALLAGHAN LN",
    "dropmalcty": "VALLEJO",
    "dropmalst": "CA",
    "dropmalzpp": 945919991,
    "dropsitphn": 5104337569,
    "dropsitlph": 7075581834,
    "dropsitcph": 7075581834,
    "dropfax": 7076431292
  },
  {
    "dcode": "D",
    "dropkey": "SZ23091",
    "droptype": "D",
    "dropname": "SPURGEON",
    "dropdeladd": "615 N BUSH ST",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927029998,
    "dropphyadd": "615 N BUSH ST",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927029998,
    "dropmaladd": "615 N BUSH ST",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927029998,
    "dropsitphn": 7149737721,
    "dropsitlph": 7149730248,
    "dropsitcph": 7149737721,
    "dropfax": 7149731559
  },
  {
    "dcode": "D",
    "dropkey": "SZ23377",
    "droptype": "D",
    "dropname": "STADIUM",
    "dropdeladd": "711 E BALL RD STE 100",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928259998,
    "dropphyadd": "711 E BALL RD STE 100",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928259998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7147780809,
    "dropsitlph": 7147780809,
    "dropsitcph": 7147780809,
    "dropfax": 7147780505
  },
  {
    "dcode": "D",
    "dropkey": "SZ23387",
    "droptype": "D",
    "dropname": "STATE CAPITOL",
    "dropdeladd": "801 I ST RM 149",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958149998,
    "dropphyadd": "801 I ST RM 149",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958149998,
    "dropmaladd": "801 I ST RM 149",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958149998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 9165563415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23390",
    "droptype": "D",
    "dropname": "STATE STREET",
    "dropdeladd": "7800 STATE ST",
    "dropdelcty": "HUNTINGTON PARK",
    "dropdelst": "CA",
    "dropdelzpp": 902559992,
    "dropphyadd": "7800 STATE ST",
    "dropphycty": "HUNTINGTON PARK",
    "dropphyst": "CA",
    "dropphyzpp": 902559992,
    "dropmaladd": "7800 STATE ST",
    "dropmalcty": "HUNTINGTON PARK",
    "dropmalst": "CA",
    "dropmalzpp": 902559992,
    "dropsitphn": 5624942406,
    "dropsitlph": 3235827153,
    "dropsitcph": 3235826635,
    "dropfax": 3235822309
  },
  {
    "dcode": "D",
    "dropkey": "SZ23392",
    "droptype": "D",
    "dropname": "STATELINE",
    "dropdeladd": "1046 AL TAHOE BLVD",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961504603,
    "dropphyadd": "1046 AL TAHOE BLVD",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961509938,
    "dropmaladd": "1046 AL TAHOE BLVD",
    "dropmalcty": "SOUTH LAKE TAHOE",
    "dropmalst": "CA",
    "dropmalzpp": 961504603,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305448149,
    "dropsitcph": 5305445924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23460",
    "droptype": "D",
    "dropname": "STONESTOWN",
    "dropdeladd": "585 BUCKINGHAM WAY",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941329993,
    "dropphyadd": "585 BUCKINGHAM WAY",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941329993,
    "dropmaladd": "585 BUCKINGHAM WAY",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941329993,
    "dropsitphn": 4155505045,
    "dropsitlph": 4152850872,
    "dropsitcph": 4152850872,
    "dropfax": 4152853010
  },
  {
    "dcode": "D",
    "dropkey": "SZ23485",
    "droptype": "D",
    "dropname": "SUNKIST",
    "dropdeladd": "2320 E LINCOLN AVE",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928169998,
    "dropphyadd": "2320 E LINCOLN AVE",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928169998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7146351304,
    "dropsitlph": 7147741318,
    "dropsitcph": 7146351304,
    "dropfax": 7146352055
  },
  {
    "dcode": "D",
    "dropkey": "SZ23488",
    "droptype": "D",
    "dropname": "SUNNY HILLS",
    "dropdeladd": "1820 N SUNNYCREST DR",
    "dropdelcty": "FULLERTON",
    "dropdelst": "CA",
    "dropdelzpp": 928389998,
    "dropphyadd": "1820 N SUNNYCREST DR",
    "dropphycty": "FULLERTON",
    "dropphyst": "CA",
    "dropphyzpp": 928389998,
    "dropmaladd": "1820 N SUNNYCREST DR",
    "dropmalcty": "FULLERTON",
    "dropmalst": "CA",
    "dropmalzpp": 928389998,
    "dropsitphn": 7148716618,
    "dropsitlph": 7148716542,
    "dropsitcph": 7148716618,
    "dropfax": 7148711243
  },
  {
    "dcode": "D",
    "dropkey": "SZ23494",
    "droptype": "D",
    "dropname": "SUNSET",
    "dropdeladd": "1425 N CHEROKEE AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900939993,
    "dropphyadd": "1425 N CHEROKEE AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900939993,
    "dropmaladd": "PO BOX 939998",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900939998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3234604830,
    "dropsitcph": 3234604811,
    "dropfax": 3234604201
  },
  {
    "dcode": "D",
    "dropkey": "SZ23495",
    "droptype": "D",
    "dropname": "SUNSET STATION",
    "dropdeladd": "1314 22ND AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941229991,
    "dropphyadd": "1314 22ND AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941229991,
    "dropmaladd": "1314 22ND AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941229991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4152421554
  },
  {
    "dcode": "D",
    "dropkey": "SZ23509",
    "droptype": "D",
    "dropname": "SUTTER STREET",
    "dropdeladd": "150 SUTTER ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941049991,
    "dropphyadd": "150 SUTTER ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941049991,
    "dropmaladd": "150 SUTTER ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941049991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156262932,
    "dropsitcph": 4156262932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23517",
    "droptype": "D",
    "dropname": "BELL",
    "dropdeladd": "415A W 18TH ST",
    "dropdelcty": "MERCED",
    "dropdelst": "CA",
    "dropdelzpp": 953409997,
    "dropphyadd": "415A W 18TH ST",
    "dropphycty": "MERCED",
    "dropphyst": "CA",
    "dropphyzpp": 953409997,
    "dropmaladd": "415A W 18TH ST",
    "dropmalcty": "MERCED",
    "dropmalst": "CA",
    "dropmalzpp": 953409997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093830553,
    "dropsitcph": 2093830553,
    "dropfax": 2094465174
  },
  {
    "dcode": "D",
    "dropkey": "SZ23522",
    "droptype": "D",
    "dropname": "MEYERS",
    "dropdeladd": "1285 APACHE AVE",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961505288,
    "dropphyadd": "1285 APACHE AVE",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961505288,
    "dropmaladd": "1046 AL TAHOE BLVD",
    "dropmalcty": "SOUTH LAKE TAHOE",
    "dropmalst": "CA",
    "dropmalzpp": 961504603,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305773441,
    "dropsitcph": 5305775081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23525",
    "droptype": "D",
    "dropname": "TAHOE VALLEY",
    "dropdeladd": "950 EMERALD BAY RD",
    "dropdelcty": "SOUTH LAKE TAHOE",
    "dropdelst": "CA",
    "dropdelzpp": 961506415,
    "dropphyadd": "950 EMERALD BAY RD",
    "dropphycty": "SOUTH LAKE TAHOE",
    "dropphyst": "CA",
    "dropphyzpp": 961506415,
    "dropmaladd": "1046 AL TAHOE BLVD",
    "dropmalcty": "SOUTH LAKE TAHOE",
    "dropmalst": "CA",
    "dropmalzpp": 961504603,
    "dropsitphn": 7023619453,
    "dropsitlph": 5305413448,
    "dropsitcph": 5305414365,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23543",
    "droptype": "D",
    "dropname": "TEMESCAL DPOBU",
    "dropdeladd": "4869 TELEGRAPH AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946092009,
    "dropphyadd": "4869 TELEGRAPH AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946092009,
    "dropmaladd": "4900 SHATTUCK AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946092031,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 5102513390,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ23554",
    "droptype": "D",
    "dropname": "TERRA LINDA",
    "dropdeladd": "603 DEL GANADO RD",
    "dropdelcty": "SAN RAFAEL",
    "dropdelst": "CA",
    "dropdelzpp": 949039991,
    "dropphyadd": "603 DEL GANADO RD",
    "dropphycty": "SAN RAFAEL",
    "dropphyst": "CA",
    "dropphyzpp": 949039991,
    "dropmaladd": "603 DEL GANADO RD",
    "dropmalcty": "SAN RAFAEL",
    "dropmalst": "CA",
    "dropmalzpp": 949039991,
    "dropsitphn": 7077785461,
    "dropsitlph": 4154799736,
    "dropsitcph": 4154571945,
    "dropfax": 4154565136
  },
  {
    "dcode": "D",
    "dropkey": "SZ23560",
    "droptype": "D",
    "dropname": "THE CITY",
    "dropdeladd": "1075 N TUSTIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "CA",
    "dropdelzpp": 928639951,
    "dropphyadd": "1075 N TUSTIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "CA",
    "dropphyzpp": 928639951,
    "dropmaladd": "1075 N TUSTIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "CA",
    "dropmalzpp": 928639951,
    "dropsitphn": 7146620151,
    "dropsitlph": 7146626330,
    "dropsitcph": 7146626330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23576",
    "droptype": "D",
    "dropname": "TIERRASANTA",
    "dropdeladd": "6030 SANTO RD STE I",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921249998,
    "dropphyadd": "6030 SANTO RD STE I",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921249998,
    "dropmaladd": "6030 SANTO RD STE I",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921249998,
    "dropsitphn": "",
    "dropsitlph": 8584679338,
    "dropsitcph": 6192864734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23583",
    "droptype": "D",
    "dropname": "TODOS SANTOS",
    "dropdeladd": "2043 EAST ST",
    "dropdelcty": "CONCORD",
    "dropdelst": "CA",
    "dropdelzpp": 945209991,
    "dropphyadd": "2043 EAST ST",
    "dropphycty": "CONCORD",
    "dropphyst": "CA",
    "dropphyzpp": 945209991,
    "dropmaladd": "2121 MERIDIAN PARK BLVD",
    "dropmalcty": "CONCORD",
    "dropmalst": "CA",
    "dropmalzpp": 945209998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256098063,
    "dropsitcph": 9257983849,
    "dropfax": 9258748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ23595",
    "droptype": "D",
    "dropname": "TOWER",
    "dropdeladd": "824 E FERN AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937289998,
    "dropphyadd": "824 E FERN AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937289998,
    "dropmaladd": "824 E FERN AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937289998,
    "dropsitphn": 5598605117,
    "dropsitlph": 5598605117,
    "dropsitcph": 5598605117,
    "dropfax": 5598605119
  },
  {
    "dcode": "D",
    "dropkey": "SZ23596",
    "droptype": "D",
    "dropname": "TOWN AND COUNTRY",
    "dropdeladd": "2929 FULTON AVE STE 19",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958219998,
    "dropphyadd": "2929 FULTON AVE STE 19",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958219998,
    "dropmaladd": "2929 FULTON AVE STE 19",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958219998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165743025,
    "dropsitcph": 9165743003,
    "dropfax": 9164833260
  },
  {
    "dcode": "D",
    "dropkey": "SZ23598",
    "droptype": "D",
    "dropname": "TOWN CENTER",
    "dropdeladd": "111 W ACEQUIA AVE",
    "dropdelcty": "VISALIA",
    "dropdelst": "CA",
    "dropdelzpp": 932916234,
    "dropphyadd": "111 W ACEQUIA AVE",
    "dropphycty": "VISALIA",
    "dropphyst": "CA",
    "dropphyzpp": 932916234,
    "dropmaladd": "111 W ACEQUIA AVE",
    "dropmalcty": "VISALIA",
    "dropmalst": "CA",
    "dropmalzpp": 932916234,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597322445,
    "dropsitcph": 5597322445,
    "dropfax": 5597327885
  },
  {
    "dcode": "D",
    "dropkey": "SZ23599",
    "droptype": "D",
    "dropname": "TOWN SQUARE",
    "dropdeladd": "2220 E PALMDALE BLVD",
    "dropdelcty": "PALMDALE",
    "dropdelst": "CA",
    "dropdelzpp": 935509819,
    "dropphyadd": "2220 E PALMDALE BLVD",
    "dropphycty": "PALMDALE",
    "dropphyst": "CA",
    "dropphyzpp": 935509819,
    "dropmaladd": "2220 E PALMDALE BLVD",
    "dropmalcty": "PALMDALE",
    "dropmalst": "CA",
    "dropmalzpp": 935509819,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612721273,
    "dropsitcph": 6612721492,
    "dropfax": 6612671128
  },
  {
    "dcode": "D",
    "dropkey": "SZ23605",
    "droptype": "D",
    "dropname": "TRADE CENTER",
    "dropdeladd": "1 WORLD TRADE CTR",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908310002,
    "dropphyadd": "1 WORLD TRADE CTR",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908310002,
    "dropmaladd": "PO BOX 32000",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908329998,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624328742,
    "dropsitcph": 5624954607,
    "dropfax": 5624953967
  },
  {
    "dcode": "D",
    "dropkey": "SZ23619",
    "droptype": "D",
    "dropname": "TROPICO",
    "dropdeladd": "120 E CHEVY CHASE DR",
    "dropdelcty": "GLENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 912053141,
    "dropphyadd": "120 E CHEVY CHASE DR",
    "dropphycty": "GLENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 912053141,
    "dropmaladd": "120 E CHEVY CHASE DR",
    "dropmalcty": "GLENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 912053141,
    "dropsitphn": 6617757808,
    "dropsitlph": 8182478096,
    "dropsitcph": 8182475094,
    "dropfax": 8182659262
  },
  {
    "dcode": "D",
    "dropkey": "SZ23634",
    "droptype": "D",
    "dropname": "TUXEDO PARK",
    "dropdeladd": "2616 PACIFIC AVE",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952049998,
    "dropphyadd": "2616 PACIFIC AVE",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952049998,
    "dropmaladd": "2616 PACIFIC AVE",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952049998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094669476,
    "dropsitcph": 2094669432,
    "dropfax": 2099461380
  },
  {
    "dcode": "D",
    "dropkey": "SZ23644",
    "droptype": "D",
    "dropname": "TWO ROCK COAST GUARD STATION",
    "dropdeladd": "599 TOMALES RD",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949529600,
    "dropphyadd": "599 TOMALES RD",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949529600,
    "dropmaladd": "599 TOMALES RD",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949529600,
    "dropsitphn": 7077785461,
    "dropsitlph": 4158790214,
    "dropsitcph": 7077733741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23672",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "4255 CAMPUS DR STE A100",
    "dropdelcty": "IRVINE",
    "dropdelst": "CA",
    "dropdelzpp": 926169998,
    "dropphyadd": "4255 CAMPUS DR STE A100",
    "dropphycty": "IRVINE",
    "dropphyst": "CA",
    "dropphyzpp": 926169001,
    "dropmaladd": "4255 CAMPUS DR STE A100",
    "dropmalcty": "IRVINE",
    "dropmalst": "CA",
    "dropmalzpp": 926169998,
    "dropsitphn": 9494740292,
    "dropsitlph": 9498541082,
    "dropsitcph": 9494740292,
    "dropfax": 9497279322
  },
  {
    "dcode": "D",
    "dropkey": "SZ23674",
    "droptype": "D",
    "dropname": "UNIVERSITY CITY",
    "dropdeladd": "3298 GOVERNOR DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921229996,
    "dropphyadd": "3298 GOVERNOR DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921229996,
    "dropmaladd": "3298 GOVERNOR DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921229996,
    "dropsitphn": 8586740173,
    "dropsitlph": 8584537689,
    "dropsitcph": 8584536142,
    "dropfax": 8584531832
  },
  {
    "dcode": "D",
    "dropkey": "SZ23679",
    "droptype": "D",
    "dropname": "UPTOWN",
    "dropdeladd": "2160 N ARROWHEAD AVE",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924054022,
    "dropphyadd": "2160 N ARROWHEAD AVE",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924054022,
    "dropmaladd": "2160 N ARROWHEAD AVE",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924054022,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098826113,
    "dropsitcph": 9098812523,
    "dropfax": 9098864743
  },
  {
    "dcode": "D",
    "dropkey": "SZ23684",
    "droptype": "D",
    "dropname": "USN POSTGRADUATE SCHOOL",
    "dropdeladd": "151 NORTH ST",
    "dropdelcty": "MONTEREY",
    "dropdelst": "CA",
    "dropdelzpp": 939435286,
    "dropphyadd": "151 NORTH ST",
    "dropphycty": "MONTEREY",
    "dropphyst": "CA",
    "dropphyzpp": 939435286,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "MONTEREY",
    "dropmalst": "CA",
    "dropmalzpp": 939439998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4084376726,
    "dropsitcph": 8313331734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23702",
    "droptype": "D",
    "dropname": "VALLEY PLAZA",
    "dropdeladd": "6418 BELLINGHAM AVE",
    "dropdelcty": "NORTH HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 916061492,
    "dropphyadd": "6418 BELLINGHAM AVE",
    "dropphycty": "NORTH HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 916061492,
    "dropmaladd": "6418 BELLINGHAM AVE",
    "dropmalcty": "NORTH HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 916061492,
    "dropsitphn": 6617757808,
    "dropsitlph": 8187630662,
    "dropsitcph": 8185030979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23717",
    "droptype": "D",
    "dropname": "VERDUGO VIEJO",
    "dropdeladd": "101 N VERDUGO RD",
    "dropdelcty": "GLENDALE",
    "dropdelst": "CA",
    "dropdelzpp": 912069998,
    "dropphyadd": "101 N VERDUGO RD",
    "dropphycty": "GLENDALE",
    "dropphyst": "CA",
    "dropphyzpp": 912069998,
    "dropmaladd": "101 N VERDUGO RD",
    "dropmalcty": "GLENDALE",
    "dropmalst": "CA",
    "dropmalzpp": 912069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185499510,
    "dropsitcph": 8185499062,
    "dropfax": 8185490619
  },
  {
    "dcode": "D",
    "dropkey": "SZ23727",
    "droptype": "D",
    "dropname": "VETERANS BUREAU HOSPITAL",
    "dropdeladd": "3801 MIRANDA AVE",
    "dropdelcty": "PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943041290,
    "dropphyadd": "3801 MIRANDA AVE",
    "dropphycty": "PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943041290,
    "dropmaladd": "3801 MIRANDA AVE",
    "dropmalcty": "PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943041290,
    "dropsitphn": 4155505045,
    "dropsitlph": 6504935000,
    "dropsitcph": 6504935000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23729",
    "droptype": "D",
    "dropname": "VETERANS HOME",
    "dropdeladd": "260 CALIFORNIA DR",
    "dropdelcty": "YOUNTVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 945991412,
    "dropphyadd": "260 CALIFORNIA DR",
    "dropphycty": "YOUNTVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 945991412,
    "dropmaladd": "260 CALIFORNIA DR",
    "dropmalcty": "YOUNTVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 945991412,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7079445090,
    "dropfax": 7079449653
  },
  {
    "dcode": "D",
    "dropkey": "SZ23734",
    "droptype": "D",
    "dropname": "VICTORIA COURT",
    "dropdeladd": "1221 STATE ST STE 12",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931012699,
    "dropphyadd": "1221 STATE ST STE 12",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931012699,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931909998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059659972,
    "dropsitcph": 8055642226,
    "dropfax": 8055642255
  },
  {
    "dcode": "D",
    "dropkey": "SZ23736",
    "droptype": "D",
    "dropname": "VICTORY CENTER",
    "dropdeladd": "6535 LANKERSHIM BLVD",
    "dropdelcty": "NORTH HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 916069998,
    "dropphyadd": "6535 LANKERSHIM BLVD",
    "dropphycty": "NORTH HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 916069998,
    "dropmaladd": "6535 LANKERSHIM BLVD",
    "dropmalcty": "NORTH HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 916069998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8185066821,
    "dropsitcph": 8185030979,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23740",
    "droptype": "D",
    "dropname": "VIKING",
    "dropdeladd": "5405 E VILLAGE RD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908089995,
    "dropphyadd": "5405 E VILLAGE RD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908089995,
    "dropmaladd": "5405 E VILLAGE RD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908089995,
    "dropsitphn": 5624942406,
    "dropsitlph": 5622496061,
    "dropsitcph": 5624206531,
    "dropfax": 5624207831
  },
  {
    "dcode": "D",
    "dropkey": "SZ23745",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "14376 SARATOGA AVE",
    "dropdelcty": "SARATOGA",
    "dropdelst": "CA",
    "dropdelzpp": 950709997,
    "dropphyadd": "14376 SARATOGA AVE",
    "dropphycty": "SARATOGA",
    "dropphyst": "CA",
    "dropphyzpp": 950709997,
    "dropmaladd": "14376 SARATOGA AVE",
    "dropmalcty": "SARATOGA",
    "dropmalst": "CA",
    "dropmalzpp": 950709997,
    "dropsitphn": 4084376726,
    "dropsitlph": 4088675849,
    "dropsitcph": 4088671159,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23755",
    "droptype": "D",
    "dropname": "VISITACION",
    "dropdeladd": "68 LELAND AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941349991,
    "dropphyadd": "68 LELAND AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941349991,
    "dropmaladd": "68 LELAND AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941349991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4152854662,
    "dropsitcph": 4152854662,
    "dropfax": 4153339981
  },
  {
    "dcode": "D",
    "dropkey": "SZ23758",
    "droptype": "D",
    "dropname": "VISTA DEL MAR",
    "dropdeladd": "205 AVENIDA DEL MAR",
    "dropdelcty": "SAN CLEMENTE",
    "dropdelst": "CA",
    "dropdelzpp": 926749997,
    "dropphyadd": "205 AVENIDA DEL MAR",
    "dropphycty": "SAN CLEMENTE",
    "dropphyst": "CA",
    "dropphyzpp": 926749997,
    "dropmaladd": "520 E AVENIDA PICO",
    "dropmalcty": "SAN CLEMENTE",
    "dropmalst": "CA",
    "dropmalzpp": 926749998,
    "dropsitphn": 9494923965,
    "dropsitlph": 9494922472,
    "dropsitcph": 9494923965,
    "dropfax": 9494928859
  },
  {
    "dcode": "D",
    "dropkey": "SZ23759",
    "droptype": "D",
    "dropname": "VISTA GRANDE",
    "dropdeladd": "6025 MISSION ST",
    "dropdelcty": "DALY CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940149992,
    "dropphyadd": "6025 MISSION ST",
    "dropphycty": "DALY CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940149992,
    "dropmaladd": "6025 MISSION ST",
    "dropmalcty": "DALY CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940149992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4153344647,
    "dropsitcph": 4153344647,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23774",
    "droptype": "D",
    "dropname": "WAGNER BRANCH",
    "dropdeladd": "2200 W CENTURY BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900479998,
    "dropphyadd": "2200 W CENTURY BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900479998,
    "dropmaladd": "2200 W CENTURY BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900479998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3237568639,
    "dropsitcph": 3237567853,
    "dropfax": 3237557184
  },
  {
    "dcode": "D",
    "dropkey": "SZ23784",
    "droptype": "D",
    "dropname": "WALTERIA",
    "dropdeladd": "4216 PACIFIC COAST HWY",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905059998,
    "dropphyadd": "4216 PACIFIC COAST HWY",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905059998,
    "dropmaladd": "4216 PACIFIC COAST HWY",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905059998,
    "dropsitphn": 5624942406,
    "dropsitlph": 3103751068,
    "dropsitcph": 3102225902,
    "dropfax": 3103731540
  },
  {
    "dcode": "D",
    "dropkey": "SZ23785",
    "droptype": "D",
    "dropname": "WARM SPRINGS",
    "dropdeladd": "240 FRANCISCO LN",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945397970,
    "dropphyadd": "240 FRANCISCO LN",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945397970,
    "dropmaladd": "240 FRANCISCO LN",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945399992,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106563820,
    "dropsitcph": 5106567869,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "SZ23791",
    "droptype": "D",
    "dropname": "WASHINGTON LOS ANGELES",
    "dropdeladd": "4352 S CENTRAL AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900119998,
    "dropphyadd": "4352 S CENTRAL AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900119998,
    "dropmaladd": "4352 S CENTRAL AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900119998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3235240815,
    "dropsitcph": 3235240814,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23792",
    "droptype": "D",
    "dropname": "WASHINGTON PASADENA",
    "dropdeladd": "1355 N MENTOR AVE",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911042425,
    "dropphyadd": "1355 N MENTOR AVE",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911042425,
    "dropmaladd": "1355 N MENTOR AVE",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911042425,
    "dropsitphn": 6617757808,
    "dropsitlph": 6267940206,
    "dropsitcph": 6267948053,
    "dropfax": 6267952317
  },
  {
    "dcode": "D",
    "dropkey": "SZ23794",
    "droptype": "D",
    "dropname": "WASHINGTON MANOR",
    "dropdeladd": "921 MANOR BLVD",
    "dropdelcty": "SAN LEANDRO",
    "dropdelst": "CA",
    "dropdelzpp": 945791609,
    "dropphyadd": "921 MANOR BLVD",
    "dropphycty": "SAN LEANDRO",
    "dropphyst": "CA",
    "dropphyzpp": 945791609,
    "dropmaladd": "1777 ABRAM CT",
    "dropmalcty": "SAN LEANDRO",
    "dropmalst": "CA",
    "dropmalzpp": 945779998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5103516349,
    "dropsitcph": 5103515729,
    "dropfax": 5106148183
  },
  {
    "dcode": "D",
    "dropkey": "SZ23799",
    "droptype": "D",
    "dropname": "AUGUSTUS F HAWKINS",
    "dropdeladd": "10301 COMPTON AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900029998,
    "dropphyadd": "10301 COMPTON AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900029998,
    "dropmaladd": "10301 COMPTON AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900029998,
    "dropsitphn": 2135862719,
    "dropsitlph": 2135671428,
    "dropsitcph": 3235679921,
    "dropfax": 2135861482
  },
  {
    "dcode": "D",
    "dropkey": "SZ23803",
    "droptype": "D",
    "dropname": "WEBSTER STREET",
    "dropdeladd": "1415 WEBSTER ST",
    "dropdelcty": "ALAMEDA",
    "dropdelst": "CA",
    "dropdelzpp": 945019994,
    "dropphyadd": "1415 WEBSTER ST",
    "dropphycty": "ALAMEDA",
    "dropphyst": "CA",
    "dropphyzpp": 945019994,
    "dropmaladd": "1415 WEBSTER ST",
    "dropmalcty": "ALAMEDA",
    "dropmalst": "CA",
    "dropmalzpp": 945019994,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107488141,
    "dropsitcph": 5107484156,
    "dropfax": 5107485374
  },
  {
    "dcode": "D",
    "dropkey": "SZ23814",
    "droptype": "D",
    "dropname": "WEST ADAMS",
    "dropdeladd": "4960 W WASHINGTON BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900169998,
    "dropphyadd": "4960 W WASHINGTON BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900169998,
    "dropmaladd": "4960 W WASHINGTON BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900169998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3239332173,
    "dropsitcph": 3239331471,
    "dropfax": 3239345363
  },
  {
    "dcode": "D",
    "dropkey": "SZ23815",
    "droptype": "D",
    "dropname": "WEST ARCADIA",
    "dropdeladd": "725 W DUARTE RD",
    "dropdelcty": "ARCADIA",
    "dropdelst": "CA",
    "dropdelzpp": 910079998,
    "dropphyadd": "725 W DUARTE RD",
    "dropphycty": "ARCADIA",
    "dropphyst": "CA",
    "dropphyzpp": 910079998,
    "dropmaladd": "725 W DUARTE RD",
    "dropmalcty": "ARCADIA",
    "dropmalst": "CA",
    "dropmalzpp": 910079998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6264470366,
    "dropsitcph": 6264454421,
    "dropfax": 6264457502
  },
  {
    "dcode": "D",
    "dropkey": "SZ23819",
    "droptype": "D",
    "dropname": "WEST GARDEN GROVE",
    "dropdeladd": "11947 VALLEY VIEW ST",
    "dropdelcty": "GARDEN GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 928469998,
    "dropphyadd": "11947 VALLEY VIEW ST",
    "dropphycty": "GARDEN GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 928469998,
    "dropmaladd": "11947 VALLEY VIEW ST",
    "dropmalcty": "GARDEN GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 928469998,
    "dropsitphn": 7143791291,
    "dropsitlph": 7149037018,
    "dropsitcph": 7143791291,
    "dropfax": 7149031027
  },
  {
    "dcode": "D",
    "dropkey": "SZ23827",
    "droptype": "D",
    "dropname": "WEST LOS ANGELES",
    "dropdeladd": "11270 EXPOSITION BLVD FL 2",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900643150,
    "dropphyadd": "11270 EXPOSITION BLVD FL 2",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900643150,
    "dropmaladd": "11270 EXPOSITION BLVD FL 2",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900643150,
    "dropsitphn": 3235861868,
    "dropsitlph": 3104449154,
    "dropsitcph": 3102680624,
    "dropfax": 3105750634
  },
  {
    "dcode": "D",
    "dropkey": "SZ23834",
    "droptype": "D",
    "dropname": "WEST PORTAL",
    "dropdeladd": "317 W PORTAL AVE",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941279991,
    "dropphyadd": "317 W PORTAL AVE",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941279991,
    "dropmaladd": "317 W PORTAL AVE",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941279991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4157590150,
    "dropsitcph": 4157590150,
    "dropfax": 4157591308
  },
  {
    "dcode": "D",
    "dropkey": "SZ23837",
    "droptype": "D",
    "dropname": "WEST SACRAMENTO P&DC",
    "dropdeladd": "3775 INDUSTRIAL BLVD",
    "dropdelcty": "WEST SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 957990102,
    "dropphyadd": "3775 INDUSTRIAL BLVD",
    "dropphycty": "WEST SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 957990102,
    "dropmaladd": "3775 INDUSTRIAL BLVD",
    "dropmalcty": "WEST SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 957990102,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163738025,
    "dropsitcph": 9163738157,
    "dropfax": 9163738699
  },
  {
    "dcode": "D",
    "dropkey": "SZ23840",
    "droptype": "D",
    "dropname": "WESTCHESTER",
    "dropdeladd": "7381 LA TIJERA BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900459998,
    "dropphyadd": "7381 LA TIJERA BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900459998,
    "dropmaladd": "7381 LA TIJERA BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900459998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3106457041,
    "dropsitcph": 3106454618,
    "dropfax": 3106455267
  },
  {
    "dcode": "D",
    "dropkey": "SZ23842",
    "droptype": "D",
    "dropname": "WESTGATE",
    "dropdeladd": "4285 PAYNE AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951179998,
    "dropphyadd": "4285 PAYNE AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951179998,
    "dropmaladd": "4285 PAYNE AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951179998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4085570896,
    "dropsitcph": 4082448095,
    "dropfax": 4082497232
  },
  {
    "dcode": "D",
    "dropkey": "SZ23844",
    "droptype": "D",
    "dropname": "WESTLAKE",
    "dropdeladd": "199 SOUTHGATE AVE",
    "dropdelcty": "DALY CITY",
    "dropdelst": "CA",
    "dropdelzpp": 940159993,
    "dropphyadd": "199 SOUTHGATE AVE",
    "dropphycty": "DALY CITY",
    "dropphyst": "CA",
    "dropphyzpp": 940159993,
    "dropmaladd": "199 SOUTHGATE AVE",
    "dropmalcty": "DALY CITY",
    "dropmalst": "CA",
    "dropmalzpp": 940159993,
    "dropsitphn": 4155505045,
    "dropsitlph": 6507566671,
    "dropsitcph": 6507563874,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23853",
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "1560 W BASE LINE ST",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924111775,
    "dropphyadd": "1560 W BASE LINE ST",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924111775,
    "dropmaladd": "1560 W BASE LINE ST",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924111775,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098882608,
    "dropsitcph": 9098895097,
    "dropfax": 9098893556
  },
  {
    "dcode": "D",
    "dropkey": "SZ23855",
    "droptype": "D",
    "dropname": "WESTVERN",
    "dropdeladd": "1515 W VERNON AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900629998,
    "dropphyadd": "1515 W VERNON AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900629998,
    "dropmaladd": "1515 W VERNON AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900629998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232920220,
    "dropsitcph": 3232920220,
    "dropfax": 3232921130
  },
  {
    "dcode": "D",
    "dropkey": "SZ23871",
    "droptype": "D",
    "dropname": "WHITTWOOD",
    "dropdeladd": "10053 WHITTWOOD DR STE A",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906039998,
    "dropphyadd": "10053 WHITTWOOD DR STE A",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906039998,
    "dropmaladd": "10053 WHITTWOOD DR STE A",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906039998,
    "dropsitphn": 5626939561,
    "dropsitlph": 5629474337,
    "dropsitcph": 5626939561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23878",
    "droptype": "D",
    "dropname": "WILL ROGERS",
    "dropdeladd": "1217 WILSHIRE BLVD",
    "dropdelcty": "SANTA MONICA",
    "dropdelst": "CA",
    "dropdelzpp": 904039998,
    "dropphyadd": "1217 WILSHIRE BLVD",
    "dropphycty": "SANTA MONICA",
    "dropphyst": "CA",
    "dropphyzpp": 904039998,
    "dropmaladd": "1217 WILSHIRE BLVD",
    "dropmalcty": "SANTA MONICA",
    "dropmalst": "CA",
    "dropmalzpp": 904039998,
    "dropsitphn": 3105760699,
    "dropsitlph": 3105769182,
    "dropsitcph": 3105766783,
    "dropfax": 3102609278
  },
  {
    "dcode": "D",
    "dropkey": "SZ23880",
    "droptype": "D",
    "dropname": "WILLIAM TAFT",
    "dropdeladd": "5052 CLAIREMONT DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921179998,
    "dropphyadd": "5052 CLAIREMONT DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921179998,
    "dropmaladd": "5052 CLAIREMONT DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921179998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8582735824,
    "dropsitcph": 8582730558,
    "dropfax": 8582735479
  },
  {
    "dcode": "D",
    "dropkey": "SZ23885",
    "droptype": "D",
    "dropname": "WILLOW GLEN",
    "dropdeladd": "1750 MERIDIAN AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951259998,
    "dropphyadd": "1750 MERIDIAN AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951259998,
    "dropmaladd": "1750 MERIDIAN AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951259998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4087236145,
    "dropsitcph": 4087236147,
    "dropfax": 8009978267
  },
  {
    "dcode": "D",
    "dropkey": "SZ23888",
    "droptype": "D",
    "dropname": "WILLOWBROOK",
    "dropdeladd": "2241 E EL SEGUNDO BLVD",
    "dropdelcty": "COMPTON",
    "dropdelst": "CA",
    "dropdelzpp": 902229998,
    "dropphyadd": "2241 E EL SEGUNDO BLVD",
    "dropphycty": "COMPTON",
    "dropphyst": "CA",
    "dropphyzpp": 902229998,
    "dropmaladd": "2241 E EL SEGUNDO BLVD",
    "dropmalcty": "COMPTON",
    "dropmalst": "CA",
    "dropmalzpp": 902229998,
    "dropsitphn": 3104942406,
    "dropsitlph": 3106384524,
    "dropsitcph": 3106381753,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23902",
    "droptype": "D",
    "dropname": "WINE VALLEY",
    "dropdeladd": "820 RANDOLPH ST",
    "dropdelcty": "NAPA",
    "dropdelst": "CA",
    "dropdelzpp": 945599894,
    "dropphyadd": "820 RANDOLPH ST",
    "dropphycty": "NAPA",
    "dropphyst": "CA",
    "dropphyzpp": 945599894,
    "dropmaladd": "1625 TRANCAS ST",
    "dropmalcty": "NAPA",
    "dropmalst": "CA",
    "dropmalzpp": 945589998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108323950,
    "dropsitcph": 7072550621,
    "dropfax": 7072550241
  },
  {
    "dcode": "D",
    "dropkey": "SZ23924",
    "droptype": "D",
    "dropname": "WOODWARD PARK",
    "dropdeladd": "755 E NEES AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937209998,
    "dropphyadd": "755 E NEES AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937209998,
    "dropmaladd": "755 E NEES AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937209998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594404272,
    "dropsitcph": 5594404272,
    "dropfax": 5594404289
  },
  {
    "dcode": "D",
    "dropkey": "SZ23935",
    "droptype": "D",
    "dropname": "YALE",
    "dropdeladd": "1957 E FLORIDA AVE",
    "dropdelcty": "HEMET",
    "dropdelst": "CA",
    "dropdelzpp": 925449997,
    "dropphyadd": "1957 E FLORIDA AVE",
    "dropphycty": "HEMET",
    "dropphyst": "CA",
    "dropphyzpp": 925449997,
    "dropmaladd": "1957 E FLORIDA AVE",
    "dropmalcty": "HEMET",
    "dropmalst": "CA",
    "dropmalzpp": 925449997,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516586611,
    "dropsitcph": 9516581323,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23941",
    "droptype": "D",
    "dropname": "YGNACIO VALLEY",
    "dropdeladd": "2244 OAK GROVE RD",
    "dropdelcty": "WALNUT CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 945989991,
    "dropphyadd": "2244 OAK GROVE RD",
    "dropphycty": "WALNUT CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 945989991,
    "dropmaladd": "2244 OAK GROVE RD",
    "dropmalcty": "WALNUT CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 945989991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259300830,
    "dropsitcph": 9252879267,
    "dropfax": 9259300445
  },
  {
    "dcode": "D",
    "dropkey": "SZ23946",
    "droptype": "D",
    "dropname": "YORK",
    "dropdeladd": "5132 YORK BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900429997,
    "dropphyadd": "5132 YORK BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900429997,
    "dropmaladd": "5132 YORK BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900429997,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3232570413,
    "dropfax": 3232571849
  },
  {
    "dcode": "D",
    "dropkey": "SZ23969",
    "droptype": "D",
    "dropname": "LOS CERRITOS MALL",
    "dropdeladd": "361 LOS CERRITOS MALL",
    "dropdelcty": "CERRITOS",
    "dropdelst": "CA",
    "dropdelzpp": 907039996,
    "dropphyadd": "361 LOS CERRITOS MALL",
    "dropphycty": "CERRITOS",
    "dropphyst": "CA",
    "dropphyzpp": 907039996,
    "dropmaladd": "361 LOS CERRITOS MALL",
    "dropmalcty": "CERRITOS",
    "dropmalst": "CA",
    "dropmalzpp": 907039996,
    "dropsitphn": 5624942406,
    "dropsitlph": 5628094300,
    "dropsitcph": 5628600394,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ23970",
    "droptype": "D",
    "dropname": "BANDINI",
    "dropdeladd": "5555 BANDINI BLVD",
    "dropdelcty": "BELL GARDENS",
    "dropdelst": "CA",
    "dropdelzpp": 902019996,
    "dropphyadd": "5555 BANDINI BLVD",
    "dropphycty": "BELL GARDENS",
    "dropphyst": "CA",
    "dropphyzpp": 902019996,
    "dropmaladd": "5555 BANDINI BLVD",
    "dropmalcty": "BELL GARDENS",
    "dropmalst": "CA",
    "dropmalzpp": 902019996,
    "dropsitphn": 5624942406,
    "dropsitlph": 2132647476,
    "dropsitcph": 5627765294,
    "dropfax": 5628069206
  },
  {
    "dcode": "D",
    "dropkey": "SZ24031",
    "droptype": "D",
    "dropname": "HARVEST",
    "dropdeladd": "17192 MURPHY AVE",
    "dropdelcty": "IRVINE",
    "dropdelst": "CA",
    "dropdelzpp": 926239998,
    "dropphyadd": "17192 MURPHY AVE",
    "dropphycty": "IRVINE",
    "dropphyst": "CA",
    "dropphyzpp": 926239998,
    "dropmaladd": "17192 MURPHY AVE",
    "dropmalcty": "IRVINE",
    "dropmalst": "CA",
    "dropmalzpp": 926239998,
    "dropsitphn": 9494740292,
    "dropsitlph": 9494742080,
    "dropsitcph": 9494740292,
    "dropfax": 9494740548
  },
  {
    "dcode": "D",
    "dropkey": "SZ24035",
    "droptype": "D",
    "dropname": "CARMEL MOUNTAIN POSTAL STORE",
    "dropdeladd": "11251 RANCHO CARMEL DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921999709,
    "dropphyadd": "11251 RANCHO CARMEL DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921999709,
    "dropmaladd": "11251 RANCHO CARMEL DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921999709,
    "dropsitphn": 8586740173,
    "dropsitlph": 8586740205,
    "dropsitcph": 8586740205,
    "dropfax": 8586740542
  },
  {
    "dcode": "D",
    "dropkey": "SZ24125",
    "droptype": "D",
    "dropname": "ALTA LOMA",
    "dropdeladd": "6649 AMETHYST AVE",
    "dropdelcty": "RANCHO CUCAMONGA",
    "dropdelst": "CA",
    "dropdelzpp": 917019998,
    "dropphyadd": "6649 AMETHYST AVE",
    "dropphycty": "RANCHO CUCAMONGA",
    "dropphyst": "CA",
    "dropphyzpp": 917019998,
    "dropmaladd": "10950 ARROW RTE",
    "dropmalcty": "RANCHO CUCAMONGA",
    "dropmalst": "CA",
    "dropmalzpp": 917299998,
    "dropsitphn": 9099870785,
    "dropsitlph": 9099876857,
    "dropsitcph": 9099870785,
    "dropfax": 9099873653
  },
  {
    "dcode": "D",
    "dropkey": "SZ24131",
    "droptype": "D",
    "dropname": "GMF LONG BEACH",
    "dropdeladd": "2300 REDONDO AVE",
    "dropdelcty": "SIGNAL HILL",
    "dropdelst": "CA",
    "dropdelzpp": 907551250,
    "dropphyadd": "2300 REDONDO AVE",
    "dropphycty": "SIGNAL HILL",
    "dropphyst": "CA",
    "dropphyzpp": 907551250,
    "dropmaladd": "2300 REDONDO AVE",
    "dropmalcty": "SIGNAL HILL",
    "dropmalst": "CA",
    "dropmalzpp": 907551250,
    "dropsitphn": 5624942296,
    "dropsitlph": 5624942281,
    "dropsitcph": 5624942296,
    "dropfax": 5624942280
  },
  {
    "dcode": "D",
    "dropkey": "SZ24137",
    "droptype": "D",
    "dropname": "SEASIDE ANNEX",
    "dropdeladd": "199 GIGLING RD",
    "dropdelcty": "SEASIDE",
    "dropdelst": "CA",
    "dropdelzpp": 939559997,
    "dropphyadd": "199 GIGLING RD",
    "dropphycty": "SEASIDE",
    "dropphyst": "CA",
    "dropphyzpp": 939559997,
    "dropmaladd": "199 GIGLING RD",
    "dropmalcty": "SEASIDE",
    "dropmalst": "CA",
    "dropmalzpp": 939559997,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313943062,
    "dropsitcph": 8313948200,
    "dropfax": 8313940504
  },
  {
    "dcode": "D",
    "dropkey": "SZ24153",
    "droptype": "D",
    "dropname": "ANTELOPE",
    "dropdeladd": "7828 ZENITH DR",
    "dropdelcty": "CITRUS HEIGHTS",
    "dropdelst": "CA",
    "dropdelzpp": 956211082,
    "dropphyadd": "7828 ZENITH DR",
    "dropphycty": "CITRUS HEIGHTS",
    "dropphyst": "CA",
    "dropphyzpp": 956211082,
    "dropmaladd": "7828 ZENITH DR",
    "dropmalcty": "CITRUS HEIGHTS",
    "dropmalst": "CA",
    "dropmalzpp": 956211082,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169699530,
    "dropsitcph": 9167251290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24166",
    "droptype": "D",
    "dropname": "INDUSTRIAL WEST SACRAMENTO",
    "dropdeladd": "3775 INDUSTRIAL BLVD",
    "dropdelcty": "WEST SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 957999998,
    "dropphyadd": "3775 INDUSTRIAL BLVD",
    "dropphycty": "WEST SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 957999998,
    "dropmaladd": "3775 INDUSTRIAL BLVD",
    "dropmalcty": "WEST SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 957999998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163738423,
    "dropsitcph": 9165563406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24168",
    "droptype": "D",
    "dropname": "YOSEMITE LODGE",
    "dropdeladd": "9015 LODGE DR",
    "dropdelcty": "YOSEMITE NATIONAL PARK",
    "dropdelst": "CA",
    "dropdelzpp": 953899908,
    "dropphyadd": "9015 LODGE DR",
    "dropphycty": "YOSEMITE NATIONAL PARK",
    "dropphyst": "CA",
    "dropphyzpp": 953899908,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "YOSEMITE NATIONAL PARK",
    "dropmalst": "CA",
    "dropmalzpp": 953899997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2093724853,
    "dropsitcph": 2093724853,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24172",
    "droptype": "D",
    "dropname": "RINCON FINANCE CENTER",
    "dropdeladd": "180 STEUART ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941059992,
    "dropphyadd": "180 STEUART ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941059992,
    "dropmaladd": "180 STEUART ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941059992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156262932,
    "dropsitcph": 4156262932,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24216",
    "droptype": "D",
    "dropname": "LA MESA ANNEX",
    "dropdeladd": "6055 LAKE MURRAY BLVD",
    "dropdelcty": "LA MESA",
    "dropdelst": "CA",
    "dropdelzpp": 919429997,
    "dropphyadd": "6055 LAKE MURRAY BLVD",
    "dropphycty": "LA MESA",
    "dropphyst": "CA",
    "dropphyzpp": 919429997,
    "dropmaladd": "6055 LAKE MURRAY BLVD",
    "dropmalcty": "LA MESA",
    "dropmalst": "CA",
    "dropmalzpp": 919429997,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194605176,
    "dropsitcph": 6194604659,
    "dropfax": 6194603226
  },
  {
    "dcode": "D",
    "dropkey": "SZ24220",
    "droptype": "D",
    "dropname": "PORTOLA",
    "dropdeladd": "45300 PORTOLA AVE",
    "dropdelcty": "PALM DESERT",
    "dropdelst": "CA",
    "dropdelzpp": 922609996,
    "dropphyadd": "45300 PORTOLA AVE",
    "dropphycty": "PALM DESERT",
    "dropphyst": "CA",
    "dropphyzpp": 922609996,
    "dropmaladd": "45300 PORTOLA AVE",
    "dropmalcty": "PALM DESERT",
    "dropmalst": "CA",
    "dropmalzpp": 922609996,
    "dropsitphn": 9093354694,
    "dropsitlph": 7605689213,
    "dropsitcph": 7605689213,
    "dropfax": 7607739874
  },
  {
    "dcode": "D",
    "dropkey": "SZ24222",
    "droptype": "D",
    "dropname": "GOLDENWEST",
    "dropdeladd": "13761 GOLDENWEST ST",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CA",
    "dropdelzpp": 926849992,
    "dropphyadd": "13761 GOLDENWEST ST",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CA",
    "dropphyzpp": 926849992,
    "dropmaladd": "15030 GOLDENWEST CIR",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CA",
    "dropmalzpp": 926859998,
    "dropsitphn": 7148923232,
    "dropsitlph": 7148900600,
    "dropsitcph": 7148923232,
    "dropfax": 7143734329
  },
  {
    "dcode": "D",
    "dropkey": "SZ24227",
    "droptype": "D",
    "dropname": "INDUSTRY",
    "dropdeladd": "15559 RAUSCH RD",
    "dropdelcty": "LA PUENTE",
    "dropdelst": "CA",
    "dropdelzpp": 917449998,
    "dropphyadd": "15559 RAUSCH RD",
    "dropphycty": "LA PUENTE",
    "dropphyst": "CA",
    "dropphyzpp": 917449998,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479998,
    "dropsitphn": 6269689311,
    "dropsitlph": 6263369496,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": "SZ24236",
    "droptype": "D",
    "dropname": "CITRUS",
    "dropdeladd": "1941 CALIFORNIA AVE",
    "dropdelcty": "CORONA",
    "dropdelst": "CA",
    "dropdelzpp": 928779998,
    "dropphyadd": "1941 CALIFORNIA AVE",
    "dropphycty": "CORONA",
    "dropphyst": "CA",
    "dropphyzpp": 928779998,
    "dropmaladd": "1941 CALIFORNIA AVE",
    "dropmalcty": "CORONA",
    "dropmalst": "CA",
    "dropmalzpp": 928779998,
    "dropsitphn": 9513403783,
    "dropsitlph": 9513402173,
    "dropsitcph": 9513403783,
    "dropfax": 9513401392
  },
  {
    "dcode": "D",
    "dropkey": "SZ24248",
    "droptype": "D",
    "dropname": "COLE BRANCH",
    "dropdeladd": "1125 N FAIRFAX AVE",
    "dropdelcty": "WEST HOLLYWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 900469998,
    "dropphyadd": "1125 N FAIRFAX AVE",
    "dropphycty": "WEST HOLLYWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 900469998,
    "dropmaladd": "1125 N FAIRFAX AVE",
    "dropmalcty": "WEST HOLLYWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 900469998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3236546903,
    "dropsitcph": 3236548236,
    "dropfax": 3236542748
  },
  {
    "dcode": "D",
    "dropkey": "SZ24250",
    "droptype": "D",
    "dropname": "FEDERAL LOS ANGELES",
    "dropdeladd": "300 N LOS ANGELES ST LBBY",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900129997,
    "dropphyadd": "300 N LOS ANGELES ST LBBY",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900129997,
    "dropmaladd": "300 N LOS ANGELES ST LBBY",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900129997,
    "dropsitphn": 2135861867,
    "dropsitlph": "",
    "dropsitcph": 2136174410,
    "dropfax": 2136214115
  },
  {
    "dcode": "D",
    "dropkey": "SZ24253",
    "droptype": "D",
    "dropname": "LA COSTA CARLSBAD",
    "dropdeladd": "1700 AVIARA PKWY",
    "dropdelcty": "CARLSBAD",
    "dropdelst": "CA",
    "dropdelzpp": 920119998,
    "dropphyadd": "1700 AVIARA PKWY",
    "dropphycty": "CARLSBAD",
    "dropphyst": "CA",
    "dropphyzpp": 920119998,
    "dropmaladd": "1700 AVIARA PKWY",
    "dropmalcty": "CARLSBAD",
    "dropmalst": "CA",
    "dropmalzpp": 920119998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7609180112,
    "dropsitcph": 7609180112,
    "dropfax": 7609180364
  },
  {
    "dcode": "D",
    "dropkey": "SZ24262",
    "droptype": "D",
    "dropname": "GARDEN",
    "dropdeladd": "1165 LINCOLN AVE STE 150",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951253040,
    "dropphyadd": "1165 LINCOLN AVE STE 150",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951253040,
    "dropmaladd": "1165 LINCOLN AVE STE 150",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951253040,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082921096,
    "dropsitcph": 4087236147,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24286",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "5670 E WASHINGTON BLVD",
    "dropdelcty": "COMMERCE",
    "dropdelst": "CA",
    "dropdelzpp": 900409998,
    "dropphyadd": "5670 E WASHINGTON BLVD",
    "dropphycty": "COMMERCE",
    "dropphyst": "CA",
    "dropphyzpp": 900409998,
    "dropmaladd": "5670 E WASHINGTON BLVD",
    "dropmalcty": "COMMERCE",
    "dropmalst": "CA",
    "dropmalzpp": 900409998,
    "dropsitphn": 2135862719,
    "dropsitlph": 3237223279,
    "dropsitcph": 3237220277,
    "dropfax": 3237224179
  },
  {
    "dcode": "D",
    "dropkey": "SZ24293",
    "droptype": "D",
    "dropname": "CAMINO MEDIA",
    "dropdeladd": "10001 CAMINO MEDIA",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933111309,
    "dropphyadd": "10001 CAMINO MEDIA",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933111309,
    "dropmaladd": "10001 CAMINO MEDIA",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933111309,
    "dropsitphn": 6617757808,
    "dropsitlph": 6616650243,
    "dropsitcph": 6616650243,
    "dropfax": 6616651194
  },
  {
    "dcode": "D",
    "dropkey": "SZ24314",
    "droptype": "D",
    "dropname": "GREENMEAD FINANCE",
    "dropdeladd": "12003 AVALON BLVD STE 109",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900619997,
    "dropphyadd": "12003 AVALON BLVD STE 109",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900619997,
    "dropmaladd": "12003 AVALON BLVD STE 109",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900619997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232420645,
    "dropsitcph": 3232420670,
    "dropfax": 3235861254
  },
  {
    "dcode": "D",
    "dropkey": "SZ24316",
    "droptype": "D",
    "dropname": "PENDLETON DEL MAR",
    "dropdeladd": "210636 USPS RM 186",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550004,
    "dropphyadd": "210636 USPS RM 186",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550004,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920559997,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607252196,
    "dropsitcph": 7607252196,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24318",
    "droptype": "D",
    "dropname": "PENDLETON PX",
    "dropdeladd": "1103 USPS BLDG 1103",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550006,
    "dropphyadd": "1103 USPS BLDG 1103",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550006,
    "dropmaladd": "PO BOX 9995",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920559995,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607255832,
    "dropsitcph": 7607255227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24325",
    "droptype": "D",
    "dropname": "EASTLAKE",
    "dropdeladd": "830 KUHN DR",
    "dropdelcty": "CHULA VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 919149998,
    "dropphyadd": "830 KUHN DR",
    "dropphycty": "CHULA VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 919149998,
    "dropmaladd": "830 KUHN DR",
    "dropmalcty": "CHULA VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 919149998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6196565937,
    "dropsitcph": 6196565937,
    "dropfax": 6196566305
  },
  {
    "dcode": "D",
    "dropkey": "SZ24337",
    "droptype": "D",
    "dropname": "SOUTH HILL",
    "dropdeladd": "1418 S AZUSA AVE STE D1",
    "dropdelcty": "WEST COVINA",
    "dropdelst": "CA",
    "dropdelzpp": 917919998,
    "dropphyadd": "1418 S AZUSA AVE STE D1",
    "dropphycty": "WEST COVINA",
    "dropphyst": "CA",
    "dropphyzpp": 917919998,
    "dropmaladd": "1418 S AZUSA AVE STE D1",
    "dropmalcty": "WEST COVINA",
    "dropmalst": "CA",
    "dropmalzpp": 917919998,
    "dropsitphn": 6269601339,
    "dropsitlph": 6269198909,
    "dropsitcph": 6269601339,
    "dropfax": 6269628760
  },
  {
    "dcode": "D",
    "dropkey": "SZ24344",
    "droptype": "D",
    "dropname": "OTAY MESA",
    "dropdeladd": "650 DENNERY RD STE 102",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921549997,
    "dropphyadd": "650 DENNERY RD STE 102",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921549997,
    "dropmaladd": "650 DENNERY RD STE 102",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921549997,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194282105,
    "dropsitcph": 6194282011,
    "dropfax": 6194282796
  },
  {
    "dcode": "D",
    "dropkey": "SZ24365",
    "droptype": "D",
    "dropname": "LAKESHORE PLAZA",
    "dropdeladd": "1543 SLOAT BLVD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941329992,
    "dropphyadd": "1543 SLOAT BLVD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941329992,
    "dropmaladd": "1543 SLOAT BLVD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941329992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4157590150,
    "dropsitcph": 4157590150,
    "dropfax": 4156652355
  },
  {
    "dcode": "D",
    "dropkey": "SZ24371",
    "droptype": "D",
    "dropname": "MACYS RETAIL STORE",
    "dropdeladd": "750 W 7TH ST STE 201",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900179997,
    "dropphyadd": "750 W 7TH ST STE 201",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900179997,
    "dropmaladd": "750 W 7TH ST STE 201",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900179997,
    "dropsitphn": 3235861867,
    "dropsitlph": 2136246902,
    "dropsitcph": 2136241952,
    "dropfax": 3236240355
  },
  {
    "dcode": "D",
    "dropkey": "SZ24423",
    "droptype": "D",
    "dropname": "MURRIETA CARRIER ANNEX",
    "dropdeladd": "39571 LOS ALAMOS RD",
    "dropdelcty": "MURRIETA",
    "dropdelst": "CA",
    "dropdelzpp": 925639998,
    "dropphyadd": "39571 LOS ALAMOS RD",
    "dropphycty": "MURRIETA",
    "dropphyst": "CA",
    "dropphyzpp": 925639998,
    "dropmaladd": "39571 LOS ALAMOS RD",
    "dropmalcty": "MURRIETA",
    "dropmalst": "CA",
    "dropmalzpp": 925639998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9513042529,
    "dropsitcph": 9513042448,
    "dropfax": 9516779686
  },
  {
    "dcode": "D",
    "dropkey": "SZ24446",
    "droptype": "D",
    "dropname": "ARCH AIRPORT",
    "dropdeladd": "3131 ARCH AIRPORT RD",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952139998,
    "dropphyadd": "3131 ARCH AIRPORT RD",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952139998,
    "dropmaladd": "3131 ARCH AIRPORT RD",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952139998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099836460,
    "dropsitcph": 2099836422,
    "dropfax": 2099836420
  },
  {
    "dcode": "D",
    "dropkey": "SZ24659",
    "droptype": "D",
    "dropname": "IRVING STREET",
    "dropdeladd": "821 IRVING ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941229992,
    "dropphyadd": "821 IRVING ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941229992,
    "dropmaladd": "821 IRVING ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941229992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4156659548
  },
  {
    "dcode": "D",
    "dropkey": "SZ24660",
    "droptype": "D",
    "dropname": "EAGLE",
    "dropdeladd": "4119 JOHNSTONVILLE RD",
    "dropdelcty": "SUSANVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 961309991,
    "dropphyadd": "4119 JOHNSTONVILLE RD",
    "dropphycty": "SUSANVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 961309991,
    "dropmaladd": "4119 JOHNSTONVILLE RD",
    "dropmalcty": "SUSANVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 961309991,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757880663,
    "dropsitcph": 5302572704,
    "dropfax": 5302572679
  },
  {
    "dcode": "D",
    "dropkey": "SZ24661",
    "droptype": "D",
    "dropname": "MARINA GREEN",
    "dropdeladd": "3749 BUCHANAN ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941239995,
    "dropphyadd": "3749 BUCHANAN ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941239995,
    "dropmaladd": "3749 BUCHANAN ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941239995,
    "dropsitphn": 4155505045,
    "dropsitlph": 4154401875,
    "dropsitcph": 4154401875,
    "dropfax": 4154405082
  },
  {
    "dcode": "D",
    "dropkey": "SZ24676",
    "droptype": "D",
    "dropname": "RANCHO",
    "dropdeladd": "29851 AVENTURA STE K",
    "dropdelcty": "RANCHO SANTA MARGARITA",
    "dropdelst": "CA",
    "dropdelzpp": 926889997,
    "dropphyadd": "29851 AVENTURA STE K",
    "dropphycty": "RANCHO SANTA MARGARITA",
    "dropphyst": "CA",
    "dropphyzpp": 926889997,
    "dropmaladd": "29862 AVENIDA DE LAS BANDERA",
    "dropmalcty": "RANCHO SANTA MARGARITA",
    "dropmalst": "CA",
    "dropmalzpp": 926889998,
    "dropsitphn": 9498889504,
    "dropsitlph": 9498889504,
    "dropsitcph": 9494598697,
    "dropfax": 9494598862
  },
  {
    "dcode": "D",
    "dropkey": "SZ24689",
    "droptype": "D",
    "dropname": "LOYOLA CORNERS",
    "dropdeladd": "1525 MIRAMONTE AVE",
    "dropdelcty": "LOS ALTOS",
    "dropdelst": "CA",
    "dropdelzpp": 940249991,
    "dropphyadd": "1525 MIRAMONTE AVE",
    "dropphycty": "LOS ALTOS",
    "dropphyst": "CA",
    "dropphyzpp": 940249991,
    "dropmaladd": "1525 MIRAMONTE AVE",
    "dropmalcty": "LOS ALTOS",
    "dropmalst": "CA",
    "dropmalzpp": 940249991,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509601846,
    "dropsitcph": 6509600817,
    "dropfax": 6509680481
  },
  {
    "dcode": "D",
    "dropkey": "SZ24691",
    "droptype": "D",
    "dropname": "SAN BERNARDINO MAIN OFFICE",
    "dropdeladd": "390 W 5TH ST",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924019996,
    "dropphyadd": "390 W 5TH ST",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924019996,
    "dropmaladd": "390 W 5TH ST",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924019996,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098894247,
    "dropsitcph": 9098894247,
    "dropfax": 9098858226
  },
  {
    "dcode": "D",
    "dropkey": "SZ24698",
    "droptype": "D",
    "dropname": "SAN BERNARDINO MO WINDOWS",
    "dropdeladd": "1900 W REDLANDS BLVD",
    "dropdelcty": "SAN BERNARDINO",
    "dropdelst": "CA",
    "dropdelzpp": 924039997,
    "dropphyadd": "1900 W REDLANDS BLVD",
    "dropphycty": "SAN BERNARDINO",
    "dropphyst": "CA",
    "dropphyzpp": 924039997,
    "dropmaladd": "PO BOX 19001",
    "dropmalcty": "SAN BERNARDINO",
    "dropmalst": "CA",
    "dropmalzpp": 924239001,
    "dropsitphn": 9093354694,
    "dropsitlph": 9093354379,
    "dropsitcph": 9093354462,
    "dropfax": 9093354490
  },
  {
    "dcode": "D",
    "dropkey": "SZ24708",
    "droptype": "D",
    "dropname": "BROOKS STREET",
    "dropdeladd": "211 BROOKS ST",
    "dropdelcty": "OCEANSIDE",
    "dropdelst": "CA",
    "dropdelzpp": 920549998,
    "dropphyadd": "211 BROOKS ST",
    "dropphycty": "OCEANSIDE",
    "dropphyst": "CA",
    "dropphyzpp": 920549998,
    "dropmaladd": "211 BROOKS ST",
    "dropmalcty": "OCEANSIDE",
    "dropmalst": "CA",
    "dropmalzpp": 920549998,
    "dropsitphn": 8586740173,
    "dropsitlph": 7604330553,
    "dropsitcph": 7604330206,
    "dropfax": 7604339648
  },
  {
    "dcode": "D",
    "dropkey": "SZ24730",
    "droptype": "D",
    "dropname": "PARK CENTRAL",
    "dropdeladd": "1333 PARK AVE",
    "dropdelcty": "ALAMEDA",
    "dropdelst": "CA",
    "dropdelzpp": 945019983,
    "dropphyadd": "1333 PARK AVE",
    "dropphycty": "ALAMEDA",
    "dropphyst": "CA",
    "dropphyzpp": 945019983,
    "dropmaladd": "2201 SHORELINE DR",
    "dropmalcty": "ALAMEDA",
    "dropmalst": "CA",
    "dropmalzpp": 945019998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107485366,
    "dropsitcph": 5107484156,
    "dropfax": 5107485371
  },
  {
    "dcode": "D",
    "dropkey": "SZ24734",
    "droptype": "D",
    "dropname": "ROSSMOOR",
    "dropdeladd": "1922 TICE VALLEY BLVD",
    "dropdelcty": "WALNUT CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 945959990,
    "dropphyadd": "1922 TICE VALLEY BLVD",
    "dropphycty": "WALNUT CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 945959990,
    "dropmaladd": "1922 TICE VALLEY BLVD",
    "dropmalcty": "WALNUT CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 945959990,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259300835,
    "dropsitcph": 9259470195,
    "dropfax": 9259300445
  },
  {
    "dcode": "D",
    "dropkey": "SZ24736",
    "droptype": "D",
    "dropname": "MOUNT MCCOY",
    "dropdeladd": "225 SIMI VILLAGE DR",
    "dropdelcty": "SIMI VALLEY",
    "dropdelst": "CA",
    "dropdelzpp": 930657499,
    "dropphyadd": "225 SIMI VILLAGE DR",
    "dropphycty": "SIMI VALLEY",
    "dropphyst": "CA",
    "dropphyzpp": 930657499,
    "dropmaladd": "225 SIMI VILLAGE DR",
    "dropmalcty": "SIMI VALLEY",
    "dropmalst": "CA",
    "dropmalzpp": 930657499,
    "dropsitphn": 6617757808,
    "dropsitlph": 8055840278,
    "dropsitcph": 8055840278,
    "dropfax": 8054223906
  },
  {
    "dcode": "D",
    "dropkey": "SZ24773",
    "droptype": "D",
    "dropname": "CANNERY ROW",
    "dropdeladd": "686 LIGHTHOUSE AVE",
    "dropdelcty": "MONTEREY",
    "dropdelst": "CA",
    "dropdelzpp": 939409997,
    "dropphyadd": "686 LIGHTHOUSE AVE",
    "dropphycty": "MONTEREY",
    "dropphyst": "CA",
    "dropphyzpp": 939409997,
    "dropmaladd": "686 LIGHTHOUSE AVE",
    "dropmalcty": "MONTEREY",
    "dropmalst": "CA",
    "dropmalzpp": 939409997,
    "dropsitphn": 4084376726,
    "dropsitlph": 8313758545,
    "dropsitcph": 8313758545,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "SZ24788",
    "droptype": "D",
    "dropname": "BELMONT SHORE POSTAL STORE",
    "dropdeladd": "5050 E 2ND ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908039995,
    "dropphyadd": "5050 E 2ND ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908039995,
    "dropmaladd": "5050 E 2ND ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908039995,
    "dropsitphn": 5624397474,
    "dropsitlph": 5624397474,
    "dropsitcph": 5624397474,
    "dropfax": 5624397474
  },
  {
    "dcode": "D",
    "dropkey": "SZ24792",
    "droptype": "D",
    "dropname": "BYRON CA DISCOVERY BAY",
    "dropdeladd": "3345 BIXLER RD",
    "dropdelcty": "DISCOVERY BAY",
    "dropdelst": "CA",
    "dropdelzpp": 945052231,
    "dropphyadd": "3345 BIXLER RD",
    "dropphycty": "DISCOVERY BAY",
    "dropphyst": "CA",
    "dropphyzpp": 945052231,
    "dropmaladd": "3345 BIXLER RD",
    "dropmalcty": "DISCOVERY BAY",
    "dropmalst": "CA",
    "dropmalzpp": 945052231,
    "dropsitphn": 5104337569,
    "dropsitlph": 9256341164,
    "dropsitcph": 9256341164,
    "dropfax": 9256341468
  },
  {
    "dcode": "D",
    "dropkey": "SZ24805",
    "droptype": "D",
    "dropname": "DIAMOND HEIGHTS",
    "dropdeladd": "5262 DIAMOND HEIGHTS BLVD",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941319991,
    "dropphyadd": "5262 DIAMOND HEIGHTS BLVD",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941319991,
    "dropmaladd": "5262 DIAMOND HEIGHTS BLVD",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941319991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155508356,
    "dropsitcph": 4155508356,
    "dropfax": 4155507059
  },
  {
    "dcode": "D",
    "dropkey": "SZ24840",
    "droptype": "D",
    "dropname": "DEL RAYO PLAZA",
    "dropdeladd": "16091 SAN DIEGUITO RD",
    "dropdelcty": "RANCHO SANTA FE",
    "dropdelst": "CA",
    "dropdelzpp": 920919800,
    "dropphyadd": "16091 SAN DIEGUITO RD",
    "dropphycty": "RANCHO SANTA FE",
    "dropphyst": "CA",
    "dropphyzpp": 920919800,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "RANCHO SANTA FE",
    "dropmalst": "CA",
    "dropmalzpp": 920679997,
    "dropsitphn": 8586740173,
    "dropsitlph": 8587562058,
    "dropsitcph": 8587561169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000011",
    "droptype": "D",
    "dropname": "SMITHRIDGE",
    "dropdeladd": "2000 VASSAR ST",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895109998,
    "dropphyadd": "2000 VASSAR ST",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895109995,
    "dropmaladd": "2000 VASSAR ST",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895109998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7758272188,
    "dropsitcph": 7758272188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000014",
    "droptype": "D",
    "dropname": "TALL TIMBERS VLG",
    "dropdeladd": "15 LIBERTY ST",
    "dropdelcty": "THOMASVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 317579998,
    "dropphyadd": "15 LIBERTY ST",
    "dropphycty": "THOMASVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 317579998,
    "dropmaladd": "404 N BROAD ST STE 101",
    "dropmalcty": "THOMASVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 317929998,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787528466,
    "dropsitcph": 2292276537,
    "dropfax": 2292285839
  },
  {
    "dcode": "D",
    "dropkey": "S000025",
    "droptype": "D",
    "dropname": "EMERALD",
    "dropdeladd": "4030 S JONES BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891039998,
    "dropphyadd": "4030 S JONES BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891039998,
    "dropmaladd": "4030 S JONES BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891039998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028891062,
    "dropsitcph": 7028891001,
    "dropfax": 7028891090
  },
  {
    "dcode": "D",
    "dropkey": "S000048",
    "droptype": "D",
    "dropname": "SIMMONS",
    "dropdeladd": "1050 MARKET ST",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261019994,
    "dropphyadd": "1050 MARKET ST",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261019994,
    "dropmaladd": "1050 MARKET ST",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261019994,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044858009,
    "dropfax": 3044858027
  },
  {
    "dcode": "D",
    "dropkey": "S000085",
    "droptype": "D",
    "dropname": "SANDHILLS",
    "dropdeladd": "1805 CLEMSON RD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292299998,
    "dropphyadd": "1805 CLEMSON RD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292299998,
    "dropmaladd": "1805 CLEMSON RD",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292299998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266014,
    "dropsitcph": 8038658833,
    "dropfax": 8036990561
  },
  {
    "dcode": "D",
    "dropkey": "S000101",
    "droptype": "D",
    "dropname": "DOWNTOWN WINCHESTER",
    "dropdeladd": "132 N LOUDOUN ST STE 1",
    "dropdelcty": "WINCHESTER",
    "dropdelst": "VA",
    "dropdelzpp": 226019997,
    "dropphyadd": "132 N LOUDOUN ST STE 1",
    "dropphycty": "WINCHESTER",
    "dropphyst": "VA",
    "dropphyzpp": 226019997,
    "dropmaladd": "132 N LOUDOUN ST STE 1",
    "dropmalcty": "WINCHESTER",
    "dropmalst": "VA",
    "dropmalzpp": 226019997,
    "dropsitphn": 7036986367,
    "dropsitlph": 5405458415,
    "dropsitcph": 5405458415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000109",
    "droptype": "D",
    "dropname": "DOWNTOWN VAN BUREN",
    "dropdeladd": "22 S 7TH ST",
    "dropdelcty": "VAN BUREN",
    "dropdelst": "AR",
    "dropdelzpp": 729569997,
    "dropphyadd": "22 S 7TH ST",
    "dropphycty": "VAN BUREN",
    "dropphyst": "AR",
    "dropphyzpp": 729569997,
    "dropmaladd": "22 S 7TH ST",
    "dropmalcty": "VAN BUREN",
    "dropmalst": "AR",
    "dropmalzpp": 729569997,
    "dropsitphn": 4794710281,
    "dropsitlph": 4794744980,
    "dropsitcph": 4794744980,
    "dropfax": 4794715134
  },
  {
    "dcode": "D",
    "dropkey": "S000183",
    "droptype": "D",
    "dropname": "MALL STATION",
    "dropdeladd": "3102 PLANK RD STE 420",
    "dropdelcty": "FREDERICKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 224079997,
    "dropphyadd": "3102 PLANK RD STE 420",
    "dropphycty": "FREDERICKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 224079997,
    "dropmaladd": "3102 PLANK RD STE 420",
    "dropmalcty": "FREDERICKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 224079997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5405480728,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000190",
    "droptype": "D",
    "dropname": "PALISADES CENTER STORE",
    "dropdeladd": "3302 PALISADES CENTER DR",
    "dropdelcty": "WEST NYACK",
    "dropdelst": "NY",
    "dropdelzpp": 109946654,
    "dropphyadd": "3302 PALISADES CENTER DR",
    "dropphycty": "WEST NYACK",
    "dropphyst": "NY",
    "dropphyzpp": 109946654,
    "dropmaladd": "3302 PALISADES CENTER DR",
    "dropmalcty": "WEST NYACK",
    "dropmalst": "NY",
    "dropmalzpp": 109946654,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457274081,
    "dropsitcph": 8457274081,
    "dropfax": 8457279705
  },
  {
    "dcode": "D",
    "dropkey": "S000193",
    "droptype": "D",
    "dropname": "MAIN OFFICE RETAIL",
    "dropdeladd": "1124 PACIFIC ST RM 107",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681089630,
    "dropphyadd": "1124 PACIFIC ST RM 107",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681089630,
    "dropmaladd": "1124 PACIFIC ST RM 107",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681089630,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023482696,
    "dropsitcph": 4023482696,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000195",
    "droptype": "D",
    "dropname": "DOMINION",
    "dropdeladd": "220 PLAZA XING",
    "dropdelcty": "BRISTOL",
    "dropdelst": "VA",
    "dropdelzpp": 242011704,
    "dropphyadd": "220 PLAZA XING",
    "dropphycty": "BRISTOL",
    "dropphyst": "VA",
    "dropphyzpp": 242011704,
    "dropmaladd": "220 PLAZA XING",
    "dropmalcty": "BRISTOL",
    "dropmalst": "VA",
    "dropmalzpp": 242011704,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858780,
    "dropsitcph": 2766450085,
    "dropfax": 2766450321
  },
  {
    "dcode": "D",
    "dropkey": "S000196",
    "droptype": "D",
    "dropname": "INDUSTRIAL PARK",
    "dropdeladd": "668 INDUSTRIAL PARK DR",
    "dropdelcty": "MANTECA",
    "dropdelst": "CA",
    "dropdelzpp": 953379998,
    "dropphyadd": "668 INDUSTRIAL PARK DR",
    "dropphycty": "MANTECA",
    "dropphyst": "CA",
    "dropphyzpp": 953379998,
    "dropmaladd": "668 INDUSTRIAL PARK DR",
    "dropmalcty": "MANTECA",
    "dropmalst": "CA",
    "dropmalzpp": 953379998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2092395575,
    "dropsitcph": 2092395559,
    "dropfax": 2092395596
  },
  {
    "dcode": "D",
    "dropkey": "S000225",
    "droptype": "D",
    "dropname": "OAKLAND M O FIN",
    "dropdeladd": "1675 7TH ST RM 100-10M",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946159719,
    "dropphyadd": "1675 7TH ST RM 100-10M",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946159719,
    "dropmaladd": "1675 7TH ST RM 100-10M",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946159719,
    "dropsitphn": 5104337569,
    "dropsitlph": 5108748710,
    "dropsitcph": 5108748654,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000229",
    "droptype": "D",
    "dropname": "ROLLING HILLS",
    "dropdeladd": "6305 WESLEY ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754029998,
    "dropphyadd": "6305 WESLEY ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754029998,
    "dropmaladd": "6305 WESLEY ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754029998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034547803,
    "dropsitcph": 9034547803,
    "dropfax": 9034550627
  },
  {
    "dcode": "D",
    "dropkey": "S000250",
    "droptype": "D",
    "dropname": "ORANGE PARK MALL",
    "dropdeladd": "1910 WELLS RD STE J01",
    "dropdelcty": "ORANGE PARK",
    "dropdelst": "FL",
    "dropdelzpp": 320731711,
    "dropphyadd": "1910 WELLS RD STE J01",
    "dropphycty": "ORANGE PARK",
    "dropphyst": "FL",
    "dropphyzpp": 320731711,
    "dropmaladd": "1910 WELLS RD STE J01",
    "dropmalcty": "ORANGE PARK",
    "dropmalst": "FL",
    "dropmalzpp": 320731711,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042159814,
    "dropsitcph": 9042159814,
    "dropfax": 9042644341
  },
  {
    "dcode": "D",
    "dropkey": "S000251",
    "droptype": "D",
    "dropname": "DOWNTOWN FERNANDINA BEACH",
    "dropdeladd": "401 CENTRE ST",
    "dropdelcty": "FERNANDINA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 320344288,
    "dropphyadd": "401 CENTRE ST",
    "dropphycty": "FERNANDINA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 320344288,
    "dropmaladd": "401 CENTRE ST",
    "dropmalcty": "FERNANDINA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 320344288,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042774964,
    "dropsitcph": 9042774964,
    "dropfax": 9042777947
  },
  {
    "dcode": "D",
    "dropkey": "S000256",
    "droptype": "D",
    "dropname": "HARVESTER RETAIL STORE",
    "dropdeladd": "4207 S OLD HIGHWAY 94",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "MO",
    "dropdelzpp": 633042848,
    "dropphyadd": "4207 S OLD HIGHWAY 94",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "MO",
    "dropphyzpp": 633042848,
    "dropmaladd": "4207 S OLD HIGHWAY 94",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "MO",
    "dropmalzpp": 633042848,
    "dropsitphn": 3148959275,
    "dropsitlph": 6364472381,
    "dropsitcph": 6369163417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000263",
    "droptype": "D",
    "dropname": "DOWNTOWN WINTER GARDEN",
    "dropdeladd": "207 W PLANT ST",
    "dropdelcty": "WINTER GARDEN",
    "dropdelst": "FL",
    "dropdelzpp": 347879992,
    "dropphyadd": "207 W PLANT ST",
    "dropphycty": "WINTER GARDEN",
    "dropphyst": "FL",
    "dropphyzpp": 347879992,
    "dropmaladd": "207 W PLANT ST",
    "dropmalcty": "WINTER GARDEN",
    "dropmalst": "FL",
    "dropmalzpp": 347879992,
    "dropsitphn": 4076563112,
    "dropsitlph": 4076563112,
    "dropsitcph": 4076563344,
    "dropfax": 4076560896
  },
  {
    "dcode": "D",
    "dropkey": "S000276",
    "droptype": "D",
    "dropname": "CENTRAL PARK",
    "dropdeladd": "3507 N LAMAR BLVD",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787059997,
    "dropphyadd": "3507 N LAMAR BLVD",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787059997,
    "dropmaladd": "3507 N LAMAR BLVD",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787059997,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124200794,
    "dropsitcph": 5124200310,
    "dropfax": 5124200081
  },
  {
    "dcode": "D",
    "dropkey": "S000282",
    "droptype": "D",
    "dropname": "CHURCH STREET",
    "dropdeladd": "1718 CHURCH ST",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372039998,
    "dropphyadd": "1718 CHURCH ST",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372039998,
    "dropmaladd": "1718 CHURCH ST",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372039998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153210675,
    "dropsitcph": 6153210172,
    "dropfax": 6153205206
  },
  {
    "dcode": "D",
    "dropkey": "S000291",
    "droptype": "D",
    "dropname": "CLIFFDALE",
    "dropdeladd": "6380 CLIFFDALE RD",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 283142967,
    "dropphyadd": "6380 CLIFFDALE RD",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 283142967,
    "dropmaladd": "PO BOX 28314",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 283149998,
    "dropsitphn": 7043934581,
    "dropsitlph": 9108602506,
    "dropsitcph": 9105004945,
    "dropfax": 9108602602
  },
  {
    "dcode": "D",
    "dropkey": "S000310",
    "droptype": "D",
    "dropname": "DOWNTOWN SAINT GEORGE",
    "dropdeladd": "180 N MAIN ST",
    "dropdelcty": "SAINT GEORGE",
    "dropdelst": "UT",
    "dropdelzpp": 847709998,
    "dropphyadd": "180 N MAIN ST",
    "dropphycty": "SAINT GEORGE",
    "dropphyst": "UT",
    "dropphyzpp": 847709998,
    "dropmaladd": "180 N MAIN ST",
    "dropmalcty": "SAINT GEORGE",
    "dropmalst": "UT",
    "dropmalzpp": 847709998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356739573,
    "dropsitcph": 4356739549,
    "dropfax": 4356737138
  },
  {
    "dcode": "D",
    "dropkey": "S000329",
    "droptype": "D",
    "dropname": "INGLESIDE MALL",
    "dropdeladd": "50 HOLYOKE ST",
    "dropdelcty": "HOLYOKE",
    "dropdelst": "MA",
    "dropdelzpp": "010402709",
    "dropphyadd": "50 HOLYOKE ST",
    "dropphycty": "HOLYOKE",
    "dropphyst": "MA",
    "dropphyzpp": "010402709",
    "dropmaladd": "50 HOLYOKE ST",
    "dropmalcty": "HOLYOKE",
    "dropmalst": "MA",
    "dropmalzpp": "010402709",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4135360230,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000370",
    "droptype": "D",
    "dropname": "TOWNE CENTER",
    "dropdeladd": "1121 MALL DR",
    "dropdelcty": "NORTH CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 232354735,
    "dropphyadd": "1121 MALL DR",
    "dropphycty": "NORTH CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 232354735,
    "dropmaladd": "1121 MALL DR",
    "dropmalcty": "NORTH CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 232354735,
    "dropsitphn": 8046754063,
    "dropsitlph": 8046754063,
    "dropsitcph": 8046754068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000399",
    "droptype": "D",
    "dropname": "OLD TOWN PLAZA",
    "dropdeladd": "303 ROMERO ST NW STE 108",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871049997,
    "dropphyadd": "303 ROMERO ST NW STE 108",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871049997,
    "dropmaladd": "303 ROMERO ST NW STE 108",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871049997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5052425927,
    "dropsitcph": 5052425927,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000411",
    "droptype": "D",
    "dropname": "OAKLAND PARK",
    "dropdeladd": "2200 INNIS RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432249997,
    "dropphyadd": "2200 INNIS RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432249997,
    "dropmaladd": "2200 INNIS RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432249997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144761590,
    "dropsitcph": 6144761590,
    "dropfax": 6144751670
  },
  {
    "dcode": "D",
    "dropkey": "S000427",
    "droptype": "D",
    "dropname": "IDA B WELLS",
    "dropdeladd": "365 MARTIN LUTHER KING JR DR",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "MS",
    "dropdelzpp": 386359998,
    "dropphyadd": "365 MARTIN LUTHER KING JR DR",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "MS",
    "dropphyzpp": 386359998,
    "dropmaladd": "365 MARTIN LUTHER KING JR DR",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "MS",
    "dropmalzpp": 386359998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6622523631,
    "dropfax": 6622527620
  },
  {
    "dcode": "D",
    "dropkey": "S000447",
    "droptype": "D",
    "dropname": "ROSWELL POSTAL STORE",
    "dropdeladd": "10719 ALPHARETTA HWY",
    "dropdelcty": "ROSWELL",
    "dropdelst": "GA",
    "dropdelzpp": 300762432,
    "dropphyadd": "10719 ALPHARETTA HWY",
    "dropphycty": "ROSWELL",
    "dropphyst": "GA",
    "dropphyzpp": 300762432,
    "dropmaladd": "10719 ALPHARETTA HWY",
    "dropmalcty": "ROSWELL",
    "dropmalst": "GA",
    "dropmalzpp": 300762432,
    "dropsitphn": 4047657578,
    "dropsitlph": "",
    "dropsitcph": 7709939013,
    "dropfax": 6783528565
  },
  {
    "dcode": "D",
    "dropkey": "S000492",
    "droptype": "D",
    "dropname": "DOWNTOWN HARRISONBURG",
    "dropdeladd": "281 N MASON ST",
    "dropdelcty": "HARRISONBURG",
    "dropdelst": "VA",
    "dropdelzpp": 228024145,
    "dropphyadd": "281 N MASON ST",
    "dropphycty": "HARRISONBURG",
    "dropphyst": "VA",
    "dropphyzpp": 228024145,
    "dropmaladd": "3811 S MAIN ST",
    "dropmalcty": "HARRISONBURG",
    "dropmalst": "VA",
    "dropmalzpp": 228019998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047756127,
    "dropsitcph": 5404321557,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000686",
    "droptype": "D",
    "dropname": "FORT HAMILTON MILITARY",
    "dropdeladd": "301 JOHN WARREN AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112099993,
    "dropphyadd": "301 JOHN WARREN AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112099993,
    "dropmaladd": "301 JOHN WARREN AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112099993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7189210972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000725",
    "droptype": "D",
    "dropname": "SOUTH CONGRESS",
    "dropdeladd": "3903 S CONGRESS AVE",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787049998,
    "dropphyadd": "3903 S CONGRESS AVE",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787049998,
    "dropmaladd": "3903 S CONGRESS AVE",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787049998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5124416780,
    "dropsitcph": 5124416603,
    "dropfax": 5124414853
  },
  {
    "dcode": "D",
    "dropkey": "S000756",
    "droptype": "D",
    "dropname": "VADNAIS HEIGHTS",
    "dropdeladd": "1056 HIGHWAY 96 E",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551272337,
    "dropphyadd": "1056 HIGHWAY 96 E",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551272337,
    "dropmaladd": "1056 HIGHWAY 96 E",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551272337,
    "dropsitphn": 6123496399,
    "dropsitlph": 6517628319,
    "dropsitcph": 6514079864,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S000810",
    "droptype": "D",
    "dropname": "SCOTTSDALE KACHINA",
    "dropdeladd": "7339 E WILLIAMS DR",
    "dropdelcty": "SCOTTSDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 852559998,
    "dropphyadd": "7339 E WILLIAMS DR",
    "dropphycty": "SCOTTSDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 852559998,
    "dropmaladd": "7339 E WILLIAMS DR",
    "dropmalcty": "SCOTTSDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 852559998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4802128072,
    "dropsitcph": 4805132935,
    "dropfax": 4805138886
  },
  {
    "dcode": "D",
    "dropkey": "S000829",
    "droptype": "D",
    "dropname": "TENNESSEE DISTRICT",
    "dropdeladd": "525 ROYAL PKWY",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372299998,
    "dropphyadd": "525 ROYAL PKWY",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372299998,
    "dropmaladd": "525 ROYAL PKWY",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372299998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158725749,
    "dropsitcph": 6158725749,
    "dropfax": 6158859181
  },
  {
    "dcode": "D",
    "dropkey": "S000844",
    "droptype": "D",
    "dropname": "BRIGHTON",
    "dropdeladd": "424 WASHINGTON ST",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "MA",
    "dropdelzpp": "021359998",
    "dropphyadd": "424 WASHINGTON ST",
    "dropphycty": "BRIGHTON",
    "dropphyst": "MA",
    "dropphyzpp": "021359998",
    "dropmaladd": "424 WASHINGTON ST",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "MA",
    "dropmalzpp": "021359998",
    "dropsitphn": 6172543387,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172545026,
    "dropfax": 6172549319
  },
  {
    "dcode": "D",
    "dropkey": "S000951",
    "droptype": "D",
    "dropname": "COCOA VILLAGE",
    "dropdeladd": "600 FLORIDA AVE STE 101",
    "dropdelcty": "COCOA",
    "dropdelst": "FL",
    "dropdelzpp": 329229998,
    "dropphyadd": "600 FLORIDA AVE STE 101",
    "dropphycty": "COCOA",
    "dropphyst": "FL",
    "dropphyzpp": 329229998,
    "dropmaladd": "600 FLORIDA AVE STE 101",
    "dropmalcty": "COCOA",
    "dropmalst": "FL",
    "dropmalzpp": 329229998,
    "dropsitphn": 3216316479,
    "dropsitlph": 3216316479,
    "dropsitcph": 3216326846,
    "dropfax": 3216313788
  },
  {
    "dcode": "D",
    "dropkey": "S000969",
    "droptype": "D",
    "dropname": "RANCHO BERNARDO",
    "dropdeladd": "16767 BERNARDO CENTER DR STE L1",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921289996,
    "dropphyadd": "16767 BERNARDO CENTER DR STE L1",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921289996,
    "dropmaladd": "16767 BERNARDO CENTER DR STE L1",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921289996,
    "dropsitphn": 8586740173,
    "dropsitlph": 8586744167,
    "dropsitcph": 8586744067,
    "dropfax": 8586744189
  },
  {
    "dcode": "D",
    "dropkey": "S000974",
    "droptype": "D",
    "dropname": "TEMPE SOUTH",
    "dropdeladd": "8205 S PRIEST DR",
    "dropdelcty": "TEMPE",
    "dropdelst": "AZ",
    "dropdelzpp": 852849998,
    "dropphyadd": "8205 S PRIEST DR",
    "dropphycty": "TEMPE",
    "dropphyst": "AZ",
    "dropphyzpp": 852849998,
    "dropmaladd": "8205 S PRIEST DR",
    "dropmalcty": "TEMPE",
    "dropmalst": "AZ",
    "dropmalzpp": 852849998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4807630349,
    "dropsitcph": 4807630349,
    "dropfax": 4808634150
  },
  {
    "dcode": "D",
    "dropkey": "S001024",
    "droptype": "D",
    "dropname": "LEFLORE",
    "dropdeladd": "600 YALOBUSHA ST",
    "dropdelcty": "GREENWOOD",
    "dropdelst": "MS",
    "dropdelzpp": 389309996,
    "dropphyadd": "600 YALOBUSHA ST",
    "dropphycty": "GREENWOOD",
    "dropphyst": "MS",
    "dropphyzpp": 389309996,
    "dropmaladd": "600 YALOBUSHA ST",
    "dropmalcty": "GREENWOOD",
    "dropmalst": "MS",
    "dropmalzpp": 389309996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6013517112,
    "dropsitcph": 6624533228,
    "dropfax": 6624533251
  },
  {
    "dcode": "D",
    "dropkey": "S001049",
    "droptype": "D",
    "dropname": "MARTINE",
    "dropdeladd": "170 MARTINE AVE",
    "dropdelcty": "WHITE PLAINS",
    "dropdelst": "NY",
    "dropdelzpp": 106013330,
    "dropphyadd": "170 MARTINE AVE",
    "dropphycty": "WHITE PLAINS",
    "dropphyst": "NY",
    "dropphyzpp": 106013330,
    "dropmaladd": "170 MARTINE AVE",
    "dropmalcty": "WHITE PLAINS",
    "dropmalst": "NY",
    "dropmalzpp": 106013330,
    "dropsitphn": 9146974123,
    "dropsitlph": 9149971436,
    "dropsitcph": 9149971436,
    "dropfax": 9146861471
  },
  {
    "dcode": "D",
    "dropkey": "S001136",
    "droptype": "D",
    "dropname": "NORTH PLEASANT ST",
    "dropdeladd": "141 N PLEASANT ST",
    "dropdelcty": "AMHERST",
    "dropdelst": "MA",
    "dropdelzpp": "010029997",
    "dropphyadd": "141 N PLEASANT ST",
    "dropphycty": "AMHERST",
    "dropphyst": "MA",
    "dropphyzpp": "010029997",
    "dropmaladd": "141 N PLEASANT ST",
    "dropmalcty": "AMHERST",
    "dropmalst": "MA",
    "dropmalzpp": "010029997",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856420,
    "dropsitcph": 4132560200,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001138",
    "droptype": "D",
    "dropname": "SPRINGFIELD AVE",
    "dropdeladd": "290 SPRINGFIELD AVE",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071039998",
    "dropphyadd": "290 SPRINGFIELD AVE",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071039998",
    "dropmaladd": "290 SPRINGFIELD AVE",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071039998",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736244112,
    "dropsitcph": 9736244112,
    "dropfax": 6505774136
  },
  {
    "dcode": "D",
    "dropkey": "S001153",
    "droptype": "D",
    "dropname": "POSTAL STORE",
    "dropdeladd": "320 W 5TH AVE STE 348",
    "dropdelcty": "ANCHORAGE",
    "dropdelst": "AK",
    "dropdelzpp": 995012351,
    "dropphyadd": "320 W 5TH AVE STE 348",
    "dropphycty": "ANCHORAGE",
    "dropphyst": "AK",
    "dropphyzpp": 995012351,
    "dropmaladd": "320 W 5TH AVE STE 348",
    "dropmalcty": "ANCHORAGE",
    "dropmalst": "AK",
    "dropmalzpp": 995012351,
    "dropsitphn": 9072794016,
    "dropsitlph": 9072766790,
    "dropsitcph": 9072766790,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001167",
    "droptype": "D",
    "dropname": "PORTER SQUARE",
    "dropdeladd": "1953 MASSACHUSETTS AVE",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021409998",
    "dropphyadd": "1953 MASSACHUSETTS AVE",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021409998",
    "dropmaladd": "1953 MASSACHUSETTS AVE",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021409998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178765599,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001190",
    "droptype": "D",
    "dropname": "DOWNTOWN TUSCUMBIA",
    "dropdeladd": "116 E 6TH ST",
    "dropdelcty": "TUSCUMBIA",
    "dropdelst": "AL",
    "dropdelzpp": 356742414,
    "dropphyadd": "116 E 6TH ST",
    "dropphycty": "TUSCUMBIA",
    "dropphyst": "AL",
    "dropphyzpp": 356742414,
    "dropmaladd": "116 E 6TH ST",
    "dropmalcty": "TUSCUMBIA",
    "dropmalst": "AL",
    "dropmalzpp": 356742414,
    "dropsitphn": 2563814427,
    "dropsitlph": 2563814427,
    "dropsitcph": 2563814427,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001191",
    "droptype": "D",
    "dropname": "LARGO",
    "dropdeladd": "9801 APOLLO DR",
    "dropdelcty": "UPPER MARLBORO",
    "dropdelst": "MD",
    "dropdelzpp": 207749997,
    "dropphyadd": "9801 APOLLO DR",
    "dropphycty": "UPPER MARLBORO",
    "dropphyst": "MD",
    "dropphyzpp": 207749997,
    "dropmaladd": "9801 APOLLO DR",
    "dropmalcty": "UPPER MARLBORO",
    "dropmalst": "MD",
    "dropmalzpp": 207749997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019251485,
    "dropsitcph": 3019251485,
    "dropfax": 3019259078
  },
  {
    "dcode": "D",
    "dropkey": "S001233",
    "droptype": "D",
    "dropname": "BEAUMONT",
    "dropdeladd": "1025 MAJESTIC DR",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405139998,
    "dropphyadd": "1025 MAJESTIC DR",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405139998,
    "dropmaladd": "1025 MAJESTIC DR",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405139998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592192266,
    "dropfax": 8592192387
  },
  {
    "dcode": "D",
    "dropkey": "S001234",
    "droptype": "D",
    "dropname": "HANDY STREET",
    "dropdeladd": "333 HANDY ST",
    "dropdelcty": "NEW BRUNSWICK",
    "dropdelst": "NJ",
    "dropdelzpp": "089019997",
    "dropphyadd": "333 HANDY ST",
    "dropphycty": "NEW BRUNSWICK",
    "dropphyst": "NJ",
    "dropphyzpp": "089019997",
    "dropmaladd": "333 HANDY ST",
    "dropmalcty": "NEW BRUNSWICK",
    "dropmalst": "NJ",
    "dropmalzpp": "089019997",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7325458148,
    "dropfax": 7325456321
  },
  {
    "dcode": "D",
    "dropkey": "S001235",
    "droptype": "D",
    "dropname": "TROPICAL REEF",
    "dropdeladd": "1950 NE 6TH ST",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330609998,
    "dropphyadd": "1950 NE 6TH ST",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330609998,
    "dropmaladd": "1950 NE 6TH ST",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330609998,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547818286,
    "dropsitcph": 9547810475,
    "dropfax": 9546330087
  },
  {
    "dcode": "D",
    "dropkey": "S001242",
    "droptype": "D",
    "dropname": "KING HAIGLER",
    "dropdeladd": "2629 LIBERTY HILL RD",
    "dropdelcty": "CAMDEN",
    "dropdelst": "SC",
    "dropdelzpp": 290201862,
    "dropphyadd": "2629 LIBERTY HILL RD",
    "dropphycty": "CAMDEN",
    "dropphyst": "SC",
    "dropphyzpp": 290201862,
    "dropmaladd": "2629 LIBERTY HILL RD",
    "dropmalcty": "CAMDEN",
    "dropmalst": "SC",
    "dropmalzpp": 290201862,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8034254991,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001246",
    "droptype": "D",
    "dropname": "CENTRAL RICHMOND",
    "dropdeladd": "205 N 2ND ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232419998,
    "dropphyadd": "205 N 2ND ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232419998,
    "dropmaladd": "205 N 2ND ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232419998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8047830723,
    "dropsitcph": 8046493809,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001254",
    "droptype": "D",
    "dropname": "RONALD REAGAN",
    "dropdeladd": "710 WICKS LN",
    "dropdelcty": "BILLINGS",
    "dropdelst": "MT",
    "dropdelzpp": 591059998,
    "dropphyadd": "710 WICKS LN",
    "dropphycty": "BILLINGS",
    "dropphyst": "MT",
    "dropphyzpp": 591059998,
    "dropmaladd": "710 WICKS LN",
    "dropmalcty": "BILLINGS",
    "dropmalst": "MT",
    "dropmalzpp": 591059998,
    "dropsitphn": 4066576713,
    "dropsitlph": 4062006225,
    "dropsitcph": 4062006225,
    "dropfax": 4062542315
  },
  {
    "dcode": "D",
    "dropkey": "S001265",
    "droptype": "D",
    "dropname": "OTTER CREEK",
    "dropdeladd": "13501 OTTER CREEK PKWY",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722109997,
    "dropphyadd": "13501 OTTER CREEK PKWY",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722109997,
    "dropmaladd": "13501 OTTER CREEK PKWY",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722109997,
    "dropsitphn": 5014079443,
    "dropsitlph": 5013751414,
    "dropsitcph": 5014079443,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001266",
    "droptype": "D",
    "dropname": "WEST LOS ANGELES FINANCE",
    "dropdeladd": "11420 SANTA MONICA BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900259998,
    "dropphyadd": "11420 SANTA MONICA BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900259998,
    "dropmaladd": "11420 SANTA MONICA BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900259998,
    "dropsitphn": 3235861868,
    "dropsitlph": 3104777539,
    "dropsitcph": 3104772149,
    "dropfax": 3104791087
  },
  {
    "dcode": "D",
    "dropkey": "S001277",
    "droptype": "D",
    "dropname": "RANCHO SAN CLEMENTE",
    "dropdeladd": "905 CALLE NEGOCIO",
    "dropdelcty": "SAN CLEMENTE",
    "dropdelst": "CA",
    "dropdelzpp": 926739000,
    "dropphyadd": "905 CALLE NEGOCIO",
    "dropphycty": "SAN CLEMENTE",
    "dropphyst": "CA",
    "dropphyzpp": 926739000,
    "dropmaladd": "905 CALLE NEGOCIO",
    "dropmalcty": "SAN CLEMENTE",
    "dropmalst": "CA",
    "dropmalzpp": 926739000,
    "dropsitphn": 9493699392,
    "dropsitlph": 9493698601,
    "dropsitcph": 9493699392,
    "dropfax": 9493698635
  },
  {
    "dcode": "D",
    "dropkey": "S001283",
    "droptype": "D",
    "dropname": "CB CRAFT",
    "dropdeladd": "1590 E JOYCE BLVD",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "AR",
    "dropdelzpp": 727039998,
    "dropphyadd": "1590 E JOYCE BLVD",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "AR",
    "dropphyzpp": 727039998,
    "dropmaladd": "1590 E JOYCE BLVD",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "AR",
    "dropmalzpp": 727039998,
    "dropsitphn": 4799730875,
    "dropsitlph": 4799730875,
    "dropsitcph": 4799730875,
    "dropfax": 4794422564
  },
  {
    "dcode": "D",
    "dropkey": "S001339",
    "droptype": "D",
    "dropname": "TAMARAC",
    "dropdeladd": "900 TAMARAC PKWY",
    "dropdelcty": "WOODLAND PARK",
    "dropdelst": "CO",
    "dropdelzpp": 808637707,
    "dropphyadd": "900 TAMARAC PKWY",
    "dropphycty": "WOODLAND PARK",
    "dropphyst": "CO",
    "dropphyzpp": 808637707,
    "dropmaladd": "900 TAMARAC PKWY",
    "dropmalcty": "WOODLAND PARK",
    "dropmalst": "CO",
    "dropmalzpp": 808637707,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196860240,
    "dropsitcph": 7196860240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001391",
    "droptype": "D",
    "dropname": "HOMESTEAD",
    "dropdeladd": "3001 E KELLOGG RD",
    "dropdelcty": "PAHRUMP",
    "dropdelst": "NV",
    "dropdelzpp": 890617988,
    "dropphyadd": "3001 E KELLOGG RD",
    "dropphycty": "PAHRUMP",
    "dropphyst": "NV",
    "dropphyzpp": 890617988,
    "dropmaladd": "3001 E KELLOGG RD",
    "dropmalcty": "PAHRUMP",
    "dropmalst": "NV",
    "dropmalzpp": 890617988,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757277055,
    "dropsitcph": 7757278815,
    "dropfax": 7757278062
  },
  {
    "dcode": "D",
    "dropkey": "S001392",
    "droptype": "D",
    "dropname": "SIMKINS",
    "dropdeladd": "3950 N BLAGG RD",
    "dropdelcty": "PAHRUMP",
    "dropdelst": "NV",
    "dropdelzpp": 890602659,
    "dropphyadd": "3950 N BLAGG RD",
    "dropphycty": "PAHRUMP",
    "dropphyst": "NV",
    "dropphyzpp": 890602659,
    "dropmaladd": "3950 N BLAGG RD",
    "dropmalcty": "PAHRUMP",
    "dropmalst": "NV",
    "dropmalzpp": 890602659,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757277055,
    "dropsitcph": 7757518122,
    "dropfax": 7757278062
  },
  {
    "dcode": "D",
    "dropkey": "S001410",
    "droptype": "D",
    "dropname": "EL SERENO",
    "dropdeladd": "4875 HUNTINGTON DR N",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900329997,
    "dropphyadd": "4875 HUNTINGTON DR N",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900329997,
    "dropmaladd": "4875 HUNTINGTON DR N",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900329997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232260094,
    "dropsitcph": 3232260094,
    "dropfax": 3232260309
  },
  {
    "dcode": "D",
    "dropkey": "S001435",
    "droptype": "D",
    "dropname": "OPHIR",
    "dropdeladd": "2359 MYERS ST STE D",
    "dropdelcty": "OROVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 959669998,
    "dropphyadd": "2359 MYERS ST STE D",
    "dropphycty": "OROVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 959669998,
    "dropmaladd": "2359 MYERS ST STE D",
    "dropmalcty": "OROVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 959669998,
    "dropsitphn": 9163738025,
    "dropsitlph": 5305338206,
    "dropsitcph": 5305338206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001445",
    "droptype": "D",
    "dropname": "MEDRANO",
    "dropdeladd": "8624 FERGUSON RD",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752289998,
    "dropphyadd": "8624 FERGUSON RD",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752289998,
    "dropmaladd": "8624 FERGUSON RD",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752289998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143275028,
    "dropsitcph": 2143275028,
    "dropfax": 2143240280
  },
  {
    "dcode": "D",
    "dropkey": "S001461",
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "235 N ERIE ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436049398,
    "dropphyadd": "235 N ERIE ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436049398,
    "dropmaladd": "235 N ERIE ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436049398,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192456951,
    "dropsitcph": 4192456951,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001479",
    "droptype": "D",
    "dropname": "SOUTH TOLEDO",
    "dropdeladd": "1144 S DETROIT AVE",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436149998,
    "dropphyadd": "1144 S DETROIT AVE",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436149998,
    "dropmaladd": "1144 S DETROIT AVE",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436149998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4193859536,
    "dropsitcph": 4193859537,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001486",
    "droptype": "D",
    "dropname": "JEFFERSON",
    "dropdeladd": "5716 BERKSHIRE VALLEY RD STE 5",
    "dropdelcty": "OAK RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "074389991",
    "dropphyadd": "5716 BERKSHIRE VALLEY RD STE 5",
    "dropphycty": "OAK RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "074389991",
    "dropmaladd": "5716 BERKSHIRE VALLEY RD STE 5",
    "dropmalcty": "OAK RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "074389991",
    "dropsitphn": 2019559706,
    "dropsitlph": 9732085872,
    "dropsitcph": 9732085872,
    "dropfax": 9732081726
  },
  {
    "dcode": "D",
    "dropkey": "S001520",
    "droptype": "D",
    "dropname": "NAPERVILLE STA",
    "dropdeladd": "3075 BOOK RD STE 103",
    "dropdelcty": "NAPERVILLE",
    "dropdelst": "IL",
    "dropdelzpp": 605644707,
    "dropphyadd": "3075 BOOK RD STE 103",
    "dropphycty": "NAPERVILLE",
    "dropphyst": "IL",
    "dropphyzpp": 605644707,
    "dropmaladd": "1750 W OGDEN AVE",
    "dropmalcty": "NAPERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637310,
    "dropsitcph": 6309229539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001527",
    "droptype": "D",
    "dropname": "CITYVIEW",
    "dropdeladd": "7101 BRYANT IRVIN RD",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761324135,
    "dropphyadd": "7101 BRYANT IRVIN RD",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761324135,
    "dropmaladd": "7101 BRYANT IRVIN RD",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761324135,
    "dropsitphn": 8173173658,
    "dropsitlph": 8172634823,
    "dropsitcph": 8172635063,
    "dropfax": 8172634195
  },
  {
    "dcode": "D",
    "dropkey": "S001528",
    "droptype": "D",
    "dropname": "LINCOLN",
    "dropdeladd": "3001 N BROADWAY",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900319997,
    "dropphyadd": "3001 N BROADWAY",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900319997,
    "dropmaladd": "3001 N BROADWAY",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900319997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232259892,
    "dropsitcph": 3232259892,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001559",
    "droptype": "D",
    "dropname": "NORFOLK WINDOW",
    "dropdeladd": "600 CHURCH ST LBBY",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235019990,
    "dropphyadd": "600 CHURCH ST LBBY",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235019990,
    "dropmaladd": "600 CHURCH ST LBBY",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235019990,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576292247,
    "dropsitcph": 7576292247,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001577",
    "droptype": "D",
    "dropname": "ORCHARDS",
    "dropdeladd": "11909 NE 65TH ST",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986825505,
    "dropphyadd": "11909 NE 65TH ST",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986825505,
    "dropmaladd": "11909 NE 65TH ST",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986829998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608831385,
    "dropsitcph": 3609925000,
    "dropfax": 3608910104
  },
  {
    "dcode": "D",
    "dropkey": "S001581",
    "droptype": "D",
    "dropname": "PLAZA CHARLOTTE",
    "dropdeladd": "4325 E W T HARRIS BLVD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282151985,
    "dropphyadd": "4325 E W T HARRIS BLVD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282151985,
    "dropmaladd": "4325 E W T HARRIS BLVD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282151985,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045350658,
    "dropsitcph": 7045350658,
    "dropfax": 7045356067
  },
  {
    "dcode": "D",
    "dropkey": "S001594",
    "droptype": "D",
    "dropname": "POSTAL STORE",
    "dropdeladd": "445 W MAIN ST",
    "dropdelcty": "GLASGOW",
    "dropdelst": "KY",
    "dropdelzpp": 421419990,
    "dropphyadd": "445 W MAIN ST",
    "dropphycty": "GLASGOW",
    "dropphyst": "KY",
    "dropphyzpp": 421419990,
    "dropmaladd": "445 W MAIN ST",
    "dropmalcty": "GLASGOW",
    "dropmalst": "KY",
    "dropmalzpp": 421419990,
    "dropsitphn": 5024541745,
    "dropsitlph": "",
    "dropsitcph": 2706590093,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001596",
    "droptype": "D",
    "dropname": "DOWNTOWN HUNTSVILLE",
    "dropdeladd": "1315 10TH ST",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 773209998,
    "dropphyadd": "1315 10TH ST",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 773209998,
    "dropmaladd": "1315 10TH ST",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 773209998,
    "dropsitphn": 7132263055,
    "dropsitlph": 9362954362,
    "dropsitcph": 9362953037,
    "dropfax": 9362950839
  },
  {
    "dcode": "D",
    "dropkey": "S001623",
    "droptype": "D",
    "dropname": "ROGERS PLAZA",
    "dropdeladd": "1026 28TH ST SW",
    "dropdelcty": "WYOMING",
    "dropdelst": "MI",
    "dropdelzpp": 495099997,
    "dropphyadd": "1026 28TH ST SW",
    "dropphycty": "WYOMING",
    "dropphyst": "MI",
    "dropphyzpp": 495099997,
    "dropmaladd": "1026 28TH ST SW",
    "dropmalcty": "WYOMING",
    "dropmalst": "MI",
    "dropmalzpp": 495099997,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6165349782,
    "dropfax": 6165349927
  },
  {
    "dcode": "D",
    "dropkey": "S001624",
    "droptype": "D",
    "dropname": "WESTBURY",
    "dropdeladd": "11805 CHIMNEY ROCK RD",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770359998,
    "dropphyadd": "11805 CHIMNEY ROCK RD",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770359998,
    "dropmaladd": "11805 CHIMNEY ROCK RD",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770359998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137285642,
    "dropsitcph": 7137295711,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001629",
    "droptype": "D",
    "dropname": "DOWNTOWN BLACKSBURG",
    "dropdeladd": "118 N MAIN ST",
    "dropdelcty": "BLACKSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 240609997,
    "dropphyadd": "118 N MAIN ST",
    "dropphycty": "BLACKSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 240609997,
    "dropmaladd": "118 N MAIN ST",
    "dropmalcty": "BLACKSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 240609997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5409513034,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001654",
    "droptype": "D",
    "dropname": "YSLETA",
    "dropdeladd": "880 N ZARAGOZA RD",
    "dropdelcty": "EL PASO",
    "dropdelst": "TX",
    "dropdelzpp": 799079998,
    "dropphyadd": "880 N ZARAGOZA RD",
    "dropphycty": "EL PASO",
    "dropphyst": "TX",
    "dropphyzpp": 799079998,
    "dropmaladd": "880 N ZARAGOZA RD",
    "dropmalcty": "EL PASO",
    "dropmalst": "TX",
    "dropmalzpp": 799079998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9157902834,
    "dropsitcph": 9157902834,
    "dropfax": 9157902846
  },
  {
    "dcode": "D",
    "dropkey": "S001656",
    "droptype": "D",
    "dropname": "DEL MAR",
    "dropdeladd": "2395 E DEL MAR BLVD",
    "dropdelcty": "LAREDO",
    "dropdelst": "TX",
    "dropdelzpp": 780459998,
    "dropphyadd": "2395 E DEL MAR BLVD",
    "dropphycty": "LAREDO",
    "dropphyst": "TX",
    "dropphyzpp": 780459998,
    "dropmaladd": "2395 E DEL MAR BLVD",
    "dropmalcty": "LAREDO",
    "dropmalst": "TX",
    "dropmalzpp": 780459998,
    "dropsitphn": 2103688387,
    "dropsitlph": 9567236826,
    "dropsitcph": 9567236721,
    "dropfax": 9567238237
  },
  {
    "dcode": "D",
    "dropkey": "S001663",
    "droptype": "D",
    "dropname": "DOWNTOWN COLUMBUS",
    "dropdeladd": "524 MAIN ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "MS",
    "dropdelzpp": 397019998,
    "dropphyadd": "524 MAIN ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "MS",
    "dropphyzpp": 397019998,
    "dropmaladd": "524 MAIN ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "MS",
    "dropmalzpp": 397019998,
    "dropsitphn": 6013517144,
    "dropsitlph": 6623291092,
    "dropsitcph": 6623291091,
    "dropfax": 6623293155
  },
  {
    "dcode": "D",
    "dropkey": "S001682",
    "droptype": "D",
    "dropname": "OLD TOWN",
    "dropdeladd": "450 MAIN ST",
    "dropdelcty": "PARK CITY",
    "dropdelst": "UT",
    "dropdelzpp": 840609501,
    "dropphyadd": "450 MAIN ST",
    "dropphycty": "PARK CITY",
    "dropphyst": "UT",
    "dropphyzpp": 840609501,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "PARK CITY",
    "dropmalst": "UT",
    "dropmalzpp": 840609998,
    "dropsitphn": 8019742558,
    "dropsitlph": 4356558037,
    "dropsitcph": 4356558037,
    "dropfax": 4356475605
  },
  {
    "dcode": "D",
    "dropkey": "S001725",
    "droptype": "D",
    "dropname": "PETWORTH",
    "dropdeladd": "4211 9TH ST NW STE A",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200117297,
    "dropphyadd": "4211 9TH ST NW STE A",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200117297,
    "dropmaladd": "4211 9TH ST NW STE A",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200117297,
    "dropsitphn": "",
    "dropsitlph": 2025232681,
    "dropsitcph": 2025232681,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001726",
    "droptype": "D",
    "dropname": "NORTHSIDE VALDOSTA",
    "dropdeladd": "3698 INNER PERIMETER RD",
    "dropdelcty": "VALDOSTA",
    "dropdelst": "GA",
    "dropdelzpp": 316029998,
    "dropphyadd": "3698 INNER PERIMETER RD",
    "dropphycty": "VALDOSTA",
    "dropphyst": "GA",
    "dropphyzpp": 316029998,
    "dropmaladd": "3698 INNER PERIMETER RD",
    "dropmalcty": "VALDOSTA",
    "dropmalst": "GA",
    "dropmalzpp": 316029998,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292417209,
    "dropsitcph": 2292417209,
    "dropfax": 2292418702
  },
  {
    "dcode": "D",
    "dropkey": "S001740",
    "droptype": "D",
    "dropname": "DAG HAMMARSKJOLD",
    "dropdeladd": "884 2ND AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100179993,
    "dropphyadd": "884 2ND AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100179993,
    "dropmaladd": "450 LEXINGTON AVE FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100179998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125711526,
    "dropsitcph": 2125711526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001742",
    "droptype": "D",
    "dropname": "CHEYENNE MOUNTAIN",
    "dropdeladd": "1540 S 8TH ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809051933,
    "dropphyadd": "1540 S 8TH ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809051933,
    "dropmaladd": "1540 S 8TH ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809051933,
    "dropsitphn": 7195705409,
    "dropsitlph": 7196359486,
    "dropsitcph": 7196359486,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001767",
    "droptype": "D",
    "dropname": "COURTHOUSE DANVILLE",
    "dropdeladd": "700 MAIN ST",
    "dropdelcty": "DANVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 245419993,
    "dropphyadd": "700 MAIN ST",
    "dropphycty": "DANVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 245419993,
    "dropmaladd": "700 MAIN ST",
    "dropmalcty": "DANVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 245419993,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4347992688,
    "dropfax": 4347922246
  },
  {
    "dcode": "D",
    "dropkey": "S001769",
    "droptype": "D",
    "dropname": "BROOMFIELD EAGLE VIEW",
    "dropdeladd": "8800 W 116TH CIR",
    "dropdelcty": "BROOMFIELD",
    "dropdelst": "CO",
    "dropdelzpp": 800219998,
    "dropphyadd": "8800 W 116TH CIR",
    "dropphycty": "BROOMFIELD",
    "dropphyst": "CO",
    "dropphyzpp": 800219998,
    "dropmaladd": "8800 W 116TH CIR",
    "dropmalcty": "BROOMFIELD",
    "dropmalst": "CO",
    "dropmalzpp": 800219998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034669669,
    "dropsitcph": 3034669669,
    "dropfax": 3034669821
  },
  {
    "dcode": "D",
    "dropkey": "S001779",
    "droptype": "D",
    "dropname": "WEST VILLAGE",
    "dropdeladd": "527 HUDSON ST FRNT A",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100149992,
    "dropphyadd": "527 HUDSON ST FRNT A",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100149992,
    "dropmaladd": "201 VARICK ST FRNT 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100149998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129895084,
    "dropsitcph": 2129895084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001840",
    "droptype": "D",
    "dropname": "PATRICK HENRY",
    "dropdeladd": "685 TURNBERRY BLVD",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236089998,
    "dropphyadd": "685 TURNBERRY BLVD",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236089998,
    "dropmaladd": "685 TURNBERRY BLVD",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236089998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578904768,
    "dropsitcph": 7578904544,
    "dropfax": 7578904797
  },
  {
    "dcode": "D",
    "dropkey": "S001852",
    "droptype": "D",
    "dropname": "MESA FOUR PEAKS",
    "dropdeladd": "9855 E SOUTHERN AVE",
    "dropdelcty": "MESA",
    "dropdelst": "AZ",
    "dropdelzpp": 852099998,
    "dropphyadd": "9855 E SOUTHERN AVE",
    "dropphycty": "MESA",
    "dropphyst": "AZ",
    "dropphyzpp": 852099998,
    "dropmaladd": "9855 E SOUTHERN AVE",
    "dropmalcty": "MESA",
    "dropmalst": "AZ",
    "dropmalzpp": 852099998,
    "dropsitphn": 4803573801,
    "dropsitlph": 4803573801,
    "dropsitcph": 4803573805,
    "dropfax": 4803573813
  },
  {
    "dcode": "D",
    "dropkey": "S001859",
    "droptype": "D",
    "dropname": "SEGUIN ANNEX",
    "dropdeladd": "1500 E COURT ST STE 144",
    "dropdelcty": "SEGUIN",
    "dropdelst": "TX",
    "dropdelzpp": 781559997,
    "dropphyadd": "1500 E COURT ST STE 144",
    "dropphycty": "SEGUIN",
    "dropphyst": "TX",
    "dropphyzpp": 781559997,
    "dropmaladd": "1500 E COURT ST STE 144",
    "dropmalcty": "SEGUIN",
    "dropmalst": "TX",
    "dropmalzpp": 781559997,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103688386,
    "dropsitcph": 8304014468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001884",
    "droptype": "D",
    "dropname": "BAY VILLAGE",
    "dropdeladd": "630 DOVER CENTER RD",
    "dropdelcty": "BAY VILLAGE",
    "dropdelst": "OH",
    "dropdelzpp": 441403309,
    "dropphyadd": "630 DOVER CENTER RD",
    "dropphycty": "BAY VILLAGE",
    "dropphyst": "OH",
    "dropphyzpp": 441403309,
    "dropmaladd": "630 DOVER CENTER RD",
    "dropmalcty": "BAY VILLAGE",
    "dropmalst": "OH",
    "dropmalzpp": 441403309,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402509524,
    "dropfax": 4408354404
  },
  {
    "dcode": "D",
    "dropkey": "S001886",
    "droptype": "D",
    "dropname": "STATION F",
    "dropdeladd": "900 STATE AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452041513,
    "dropphyadd": "900 STATE AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452041513,
    "dropmaladd": "900 STATE AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452041513,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 5139210175,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001888",
    "droptype": "D",
    "dropname": "CARLISLE",
    "dropdeladd": "769 CENTRAL AVE",
    "dropdelcty": "FRANKLIN",
    "dropdelst": "OH",
    "dropdelzpp": 450059997,
    "dropphyadd": "769 CENTRAL AVE",
    "dropphycty": "FRANKLIN",
    "dropphyst": "OH",
    "dropphyzpp": 450059997,
    "dropmaladd": "769 CENTRAL AVE",
    "dropmalcty": "FRANKLIN",
    "dropmalst": "OH",
    "dropmalzpp": 450059997,
    "dropsitphn": 5136845763,
    "dropsitlph": 5136845763,
    "dropsitcph": 9377460335,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001889",
    "droptype": "D",
    "dropname": "NORTHEAST",
    "dropdeladd": "1820 HARRIS HOUSTON RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282629191,
    "dropphyadd": "1820 HARRIS HOUSTON RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282629191,
    "dropmaladd": "1820 HARRIS HOUSTON RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282629191,
    "dropsitphn": 7042474425,
    "dropsitlph": 7042474425,
    "dropsitcph": 7047172713,
    "dropfax": 7045478975
  },
  {
    "dcode": "D",
    "dropkey": "S001894",
    "droptype": "D",
    "dropname": "DOWNTOWN VIMS",
    "dropdeladd": "201 N MCDOWELL ST",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282049701,
    "dropphyadd": "201 N MCDOWELL ST",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282049701,
    "dropmaladd": "201 N MCDOWELL ST",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282049701,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043335135,
    "dropsitcph": 7043335135,
    "dropfax": 7043348938
  },
  {
    "dcode": "D",
    "dropkey": "S001921",
    "droptype": "D",
    "dropname": "HUDSON VALLEY MALL",
    "dropdeladd": "1300 ULSTER AVE STE 101",
    "dropdelcty": "KINGSTON",
    "dropdelst": "NY",
    "dropdelzpp": 124011518,
    "dropphyadd": "1300 ULSTER AVE STE 101",
    "dropphycty": "KINGSTON",
    "dropphyst": "NY",
    "dropphyzpp": 124011518,
    "dropmaladd": "90 CORNELL ST",
    "dropmalcty": "KINGSTON",
    "dropmalst": "NY",
    "dropmalzpp": 124019716,
    "dropsitphn": 9146974123,
    "dropsitlph": 8453362037,
    "dropsitcph": 8453362037,
    "dropfax": 8453364420
  },
  {
    "dcode": "D",
    "dropkey": "S001937",
    "droptype": "D",
    "dropname": "SOUTH VALLEY",
    "dropdeladd": "811 S MAIN ST",
    "dropdelcty": "YERINGTON",
    "dropdelst": "NV",
    "dropdelzpp": 894472467,
    "dropphyadd": "811 S MAIN ST",
    "dropphycty": "YERINGTON",
    "dropphyst": "NV",
    "dropphyzpp": 894472467,
    "dropmaladd": "811 S MAIN ST",
    "dropmalcty": "YERINGTON",
    "dropmalst": "NV",
    "dropmalzpp": 894479997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7754631555,
    "dropsitcph": 7754631555,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001955",
    "droptype": "D",
    "dropname": "TOWER CITY",
    "dropdeladd": "50 PUBLIC SQ STE P1",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441132211,
    "dropphyadd": "50 PUBLIC SQ STE P1",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441132211,
    "dropmaladd": "50 PUBLIC SQ STE P1",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441132211,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2168617150,
    "dropfax": 2166230984
  },
  {
    "dcode": "D",
    "dropkey": "S001966",
    "droptype": "D",
    "dropname": "SNYDER PLAZA",
    "dropdeladd": "58 SNYDER AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191489998,
    "dropphyadd": "58 SNYDER AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191489998,
    "dropmaladd": "58 SNYDER AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191489998,
    "dropsitphn": 2153362860,
    "dropsitlph": 2153362860,
    "dropsitcph": 2153362860,
    "dropfax": 2154634176
  },
  {
    "dcode": "D",
    "dropkey": "S001968",
    "droptype": "D",
    "dropname": "PENNS LANDING",
    "dropdeladd": "622 S 4TH ST STE 1",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191479997,
    "dropphyadd": "622 S 4TH ST STE 1",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191479997,
    "dropmaladd": "622 S 4TH ST STE 1",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191479997,
    "dropsitphn": 2158951248,
    "dropsitlph": 2159238395,
    "dropsitcph": 2159238395,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001969",
    "droptype": "D",
    "dropname": "ROXBOROUGH FINANCE STATION",
    "dropdeladd": "6184 RIDGE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191289997,
    "dropphyadd": "6184 RIDGE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191289997,
    "dropmaladd": "6184 RIDGE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191289997,
    "dropsitphn": 2158951779,
    "dropsitlph": 2154821779,
    "dropsitcph": 2154821779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001970",
    "droptype": "D",
    "dropname": "FAIRMOUNT FINANCE",
    "dropdeladd": "1939 FAIRMOUNT AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191309997,
    "dropphyadd": "1939 FAIRMOUNT AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191309997,
    "dropmaladd": "1939 FAIRMOUNT AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191309997,
    "dropsitphn": 2152365176,
    "dropsitlph": 2152365176,
    "dropsitcph": 2152365176,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001979",
    "droptype": "D",
    "dropname": "MAIN OFFICE PHILA BOX SEC",
    "dropdeladd": "3000 CHESTNUT ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191049998,
    "dropphyadd": "3000 CHESTNUT ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191049995,
    "dropmaladd": "3000 CHESTNUT ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191049995,
    "dropsitphn": 2158958975,
    "dropsitlph": 2158958975,
    "dropsitcph": 2158958975,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001980",
    "droptype": "D",
    "dropname": "SANDY CITY CENTRE",
    "dropdeladd": "215 W SEGO LILY DR",
    "dropdelcty": "SANDY",
    "dropdelst": "UT",
    "dropdelzpp": 840709997,
    "dropphyadd": "215 W SEGO LILY DR",
    "dropphycty": "SANDY",
    "dropphyst": "UT",
    "dropphyzpp": 840709997,
    "dropmaladd": "215 W SEGO LILY DR",
    "dropmalcty": "SANDY",
    "dropmalst": "UT",
    "dropmalzpp": 840709997,
    "dropsitphn": 8019742558,
    "dropsitlph": 8013046002,
    "dropsitcph": 8013046001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001993",
    "droptype": "D",
    "dropname": "MILLENNIUM",
    "dropdeladd": "100 N AKERS ST",
    "dropdelcty": "VISALIA",
    "dropdelst": "CA",
    "dropdelzpp": 932919997,
    "dropphyadd": "100 N AKERS ST",
    "dropphycty": "VISALIA",
    "dropphyst": "CA",
    "dropphyzpp": 932919997,
    "dropmaladd": "100 N AKERS ST",
    "dropmalcty": "VISALIA",
    "dropmalst": "CA",
    "dropmalzpp": 932919997,
    "dropsitphn": 6617757808,
    "dropsitlph": 5597322237,
    "dropsitcph": 5596350179,
    "dropfax": 5596254432
  },
  {
    "dcode": "D",
    "dropkey": "S001994",
    "droptype": "D",
    "dropname": "MONTICELLO",
    "dropdeladd": "5219 MONTICELLO AVE",
    "dropdelcty": "WILLIAMSBURG",
    "dropdelst": "VA",
    "dropdelzpp": 231889998,
    "dropphyadd": "5219 MONTICELLO AVE",
    "dropphycty": "WILLIAMSBURG",
    "dropphyst": "VA",
    "dropphyzpp": 231889998,
    "dropmaladd": "5219 MONTICELLO AVE",
    "dropmalcty": "WILLIAMSBURG",
    "dropmalst": "VA",
    "dropmalzpp": 231889998,
    "dropsitphn": 8047756336,
    "dropsitlph": 8045647641,
    "dropsitcph": 7575647641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S001998",
    "droptype": "D",
    "dropname": "WINTERWOOD",
    "dropdeladd": "5070 VEGAS VALLEY DR",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891429998,
    "dropphyadd": "5070 VEGAS VALLEY DR",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891429998,
    "dropmaladd": "5070 VEGAS VALLEY DR",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891429998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7024312539,
    "dropsitcph": 7024312539,
    "dropfax": 7024316141
  },
  {
    "dcode": "D",
    "dropkey": "S002025",
    "droptype": "D",
    "dropname": "KENTLANDS",
    "dropdeladd": "618 CENTER POINT WAY",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208789997,
    "dropphyadd": "618 CENTER POINT WAY",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208789997,
    "dropmaladd": "618 CENTER POINT WAY",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208789997,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3018694866,
    "dropfax": 3018698045
  },
  {
    "dcode": "D",
    "dropkey": "S002027",
    "droptype": "D",
    "dropname": "FEDERAL COURT HOUSE",
    "dropdeladd": "101 FEDERAL PLZ",
    "dropdelcty": "CENTRAL ISLIP",
    "dropdelst": "NY",
    "dropdelzpp": 117224460,
    "dropphyadd": "101 FEDERAL PLZ",
    "dropphycty": "CENTRAL ISLIP",
    "dropphyst": "NY",
    "dropphyzpp": 117224460,
    "dropmaladd": "PO BOX 9997",
    "dropmalcty": "CENTRAL ISLIP",
    "dropmalst": "NY",
    "dropmalzpp": 117229997,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6317876000,
    "dropfax": 6317876002
  },
  {
    "dcode": "D",
    "dropkey": "S002028",
    "droptype": "D",
    "dropname": "NAVAL HOSPITAL",
    "dropdeladd": "34800 BOB WILSON DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921349998,
    "dropphyadd": "34800 BOB WILSON DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921349998,
    "dropmaladd": "34800 BOB WILSON DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921349998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6195328491,
    "dropsitcph": 6195328491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002040",
    "droptype": "D",
    "dropname": "WASHINGTON NAVY YARD",
    "dropdeladd": "1222 9TH ST SE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200039996,
    "dropphyadd": "1222 9TH ST SE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200039996,
    "dropmaladd": "1222 9TH ST SE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200039996,
    "dropsitphn": "",
    "dropsitlph": 2024332216,
    "dropsitcph": 2024332216,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002046",
    "droptype": "D",
    "dropname": "NETC STATION",
    "dropdeladd": "1900 PEARY ST STE 2",
    "dropdelcty": "NEWPORT",
    "dropdelst": "RI",
    "dropdelzpp": "028411644",
    "dropphyadd": "1900 PEARY ST STE 2",
    "dropphycty": "NEWPORT",
    "dropphyst": "RI",
    "dropphyzpp": "028411644",
    "dropmaladd": "1900 PEARY ST STE 2",
    "dropmalcty": "NEWPORT",
    "dropmalst": "RI",
    "dropmalzpp": "028411644",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4018516972,
    "dropfax": 4018485197
  },
  {
    "dcode": "D",
    "dropkey": "S002047",
    "droptype": "D",
    "dropname": "SANTAPOGUE",
    "dropdeladd": "617 W MONTAUK HWY",
    "dropdelcty": "WEST BABYLON",
    "dropdelst": "NY",
    "dropdelzpp": 117048217,
    "dropphyadd": "617 W MONTAUK HWY",
    "dropphycty": "WEST BABYLON",
    "dropphyst": "NY",
    "dropphyzpp": 117048217,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BABYLON",
    "dropmalst": "NY",
    "dropmalzpp": 117029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314222276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002072",
    "droptype": "D",
    "dropname": "HUNTS POINT",
    "dropdeladd": "800 MANIDA ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104749998,
    "dropphyadd": "800 MANIDA ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104749998,
    "dropmaladd": "800 MANIDA ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104749998,
    "dropsitphn": 2123302770,
    "dropsitlph": 7189911586,
    "dropsitcph": 7189911586,
    "dropfax": 7189918833
  },
  {
    "dcode": "D",
    "dropkey": "S002078",
    "droptype": "D",
    "dropname": "STRATFORD RETAIL STORE",
    "dropdeladd": "411 BARNUM AVENUE CUTOFF STE 14",
    "dropdelcty": "STRATFORD",
    "dropdelst": "CT",
    "dropdelzpp": "066149991",
    "dropphyadd": "411 BARNUM AVENUE CUTOFF STE 14",
    "dropphycty": "STRATFORD",
    "dropphyst": "CT",
    "dropphyzpp": "066149991",
    "dropmaladd": "411 BARNUM AVENUE CUTOFF STE 14",
    "dropmalcty": "STRATFORD",
    "dropmalst": "CT",
    "dropmalzpp": "066149991",
    "dropsitphn": 2033801880,
    "dropsitlph": 2033811373,
    "dropsitcph": 2033811373,
    "dropfax": 2033811377
  },
  {
    "dcode": "D",
    "dropkey": "S002124",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "566 ALLEN RD",
    "dropdelcty": "BASKING RIDGE",
    "dropdelst": "NJ",
    "dropdelzpp": "079203850",
    "dropphyadd": "566 ALLEN RD",
    "dropphycty": "BASKING RIDGE",
    "dropphyst": "NJ",
    "dropphyzpp": "079203850",
    "dropmaladd": "21 BROWNLEE PL",
    "dropmalcty": "BASKING RIDGE",
    "dropmalst": "NJ",
    "dropmalzpp": "079209998",
    "dropsitphn": 9735157868,
    "dropsitlph": 9084700757,
    "dropsitcph": 9084700757,
    "dropfax": 6516751423
  },
  {
    "dcode": "D",
    "dropkey": "S002159",
    "droptype": "D",
    "dropname": "ANAHEIM CANYON",
    "dropdeladd": "8161 E KAISER BLVD",
    "dropdelcty": "ANAHEIM",
    "dropdelst": "CA",
    "dropdelzpp": 928099998,
    "dropphyadd": "8161 E KAISER BLVD",
    "dropphycty": "ANAHEIM",
    "dropphyst": "CA",
    "dropphyzpp": 928099998,
    "dropmaladd": "701 N LOARA ST",
    "dropmalcty": "ANAHEIM",
    "dropmalst": "CA",
    "dropmalzpp": 928039998,
    "dropsitphn": 7146373404,
    "dropsitlph": 7149210960,
    "dropsitcph": 7146373404,
    "dropfax": 7146373442
  },
  {
    "dcode": "D",
    "dropkey": "S002160",
    "droptype": "D",
    "dropname": "FAIRPORT RETAIL",
    "dropdeladd": "6740 PITTSFORD PALMYRA RD STE 100",
    "dropdelcty": "FAIRPORT",
    "dropdelst": "NY",
    "dropdelzpp": 144509995,
    "dropphyadd": "6740 PITTSFORD PALMYRA RD STE 100",
    "dropphycty": "FAIRPORT",
    "dropphyst": "NY",
    "dropphyzpp": 144509995,
    "dropmaladd": "6740 PITTSFORD PALMYRA RD STE 100",
    "dropmalcty": "FAIRPORT",
    "dropmalst": "NY",
    "dropmalzpp": 144509995,
    "dropsitphn": 7168462415,
    "dropsitlph": 5854251460,
    "dropsitcph": 5854251460,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002186",
    "droptype": "D",
    "dropname": "PLAYA VISTA",
    "dropdeladd": "7381 LA TIJERA BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900459997,
    "dropphyadd": "7381 LA TIJERA BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900459997,
    "dropmaladd": "7381 LA TIJERA BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900459997,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3106497403,
    "dropfax": 3106455267
  },
  {
    "dcode": "D",
    "dropkey": "S002205",
    "droptype": "D",
    "dropname": "RIDGEWOOD",
    "dropdeladd": "225 COLLEGE DR",
    "dropdelcty": "ORANGE PARK",
    "dropdelst": "FL",
    "dropdelzpp": 320659998,
    "dropphyadd": "225 COLLEGE DR",
    "dropphycty": "ORANGE PARK",
    "dropphyst": "FL",
    "dropphyzpp": 320659998,
    "dropmaladd": "225 COLLEGE DR",
    "dropmalcty": "ORANGE PARK",
    "dropmalst": "FL",
    "dropmalzpp": 320659998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042722709,
    "dropsitcph": 9042722709,
    "dropfax": 9042727015
  },
  {
    "dcode": "D",
    "dropkey": "S002212",
    "droptype": "D",
    "dropname": "RANCHOS",
    "dropdeladd": "1271 KIMMERLING RD",
    "dropdelcty": "GARDNERVILLE",
    "dropdelst": "NV",
    "dropdelzpp": 894600800,
    "dropphyadd": "1271 KIMMERLING RD",
    "dropphycty": "GARDNERVILLE",
    "dropphyst": "NV",
    "dropphyzpp": 894600800,
    "dropmaladd": "1271 KIMMERLING RD",
    "dropmalcty": "GARDNERVILLE",
    "dropmalst": "NV",
    "dropmalzpp": 894609997,
    "dropsitphn": 7023619453,
    "dropsitlph": 7752656903,
    "dropsitcph": 7752657361,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002296",
    "droptype": "D",
    "dropname": "EAST ARROW",
    "dropdeladd": "2801 E KENOSHA ST",
    "dropdelcty": "BROKEN ARROW",
    "dropdelst": "OK",
    "dropdelzpp": 740149998,
    "dropphyadd": "2801 E KENOSHA ST",
    "dropphycty": "BROKEN ARROW",
    "dropphyst": "OK",
    "dropphyzpp": 740149998,
    "dropmaladd": "2801 E KENOSHA ST",
    "dropmalcty": "BROKEN ARROW",
    "dropmalst": "OK",
    "dropmalzpp": 740149998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9183559223,
    "dropsitcph": 9183559223,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002313",
    "droptype": "D",
    "dropname": "DOWNTOWN STATION",
    "dropdeladd": "333 W 4TH ST FL 1",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741039832,
    "dropphyadd": "333 W 4TH ST FL 1",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741039832,
    "dropmaladd": "333 W 4TH ST FL 1",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741039832,
    "dropsitphn": 9182707512,
    "dropsitlph": 9187326652,
    "dropsitcph": 9187326651,
    "dropfax": 9187326801
  },
  {
    "dcode": "D",
    "dropkey": "S002315",
    "droptype": "D",
    "dropname": "BONITA BEACH ROAD",
    "dropdeladd": "9071 BONITA BEACH RD SE",
    "dropdelcty": "BONITA SPRINGS",
    "dropdelst": "FL",
    "dropdelzpp": 341359974,
    "dropphyadd": "9071 BONITA BEACH RD SE",
    "dropphycty": "BONITA SPRINGS",
    "dropphyst": "FL",
    "dropphyzpp": 341359974,
    "dropmaladd": "9071 BONITA BEACH RD SE",
    "dropmalcty": "BONITA SPRINGS",
    "dropmalst": "FL",
    "dropmalzpp": 341359974,
    "dropsitphn": 8138770788,
    "dropsitlph": 2399920442,
    "dropsitcph": 2399920442,
    "dropfax": 2399480340
  },
  {
    "dcode": "D",
    "dropkey": "S002345",
    "droptype": "D",
    "dropname": "BOULDER HILLS",
    "dropdeladd": "2550 E ROSE GARDEN LN",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850509998,
    "dropphyadd": "2550 E ROSE GARDEN LN",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850509998,
    "dropmaladd": "2550 E ROSE GARDEN LN",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850509998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6024941745,
    "dropsitcph": 6024940031,
    "dropfax": 6027880800
  },
  {
    "dcode": "D",
    "dropkey": "S002367",
    "droptype": "D",
    "dropname": "DOWNTOWN ROANOKE",
    "dropdeladd": "101 CHURCH AVE SW",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240119997,
    "dropphyadd": "101 CHURCH AVE SW",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240119997,
    "dropmaladd": "101 CHURCH AVE SW",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240119997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858780,
    "dropsitcph": 5403433578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002397",
    "droptype": "D",
    "dropname": "LAGUNA POSTAL STORE",
    "dropdeladd": "9105 BRUCEVILLE RD STE 1A",
    "dropdelcty": "ELK GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 957589997,
    "dropphyadd": "9105 BRUCEVILLE RD STE 1A",
    "dropphycty": "ELK GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 957589997,
    "dropmaladd": "9105 BRUCEVILLE RD STE 1A",
    "dropmalcty": "ELK GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 957589997,
    "dropsitphn": 9166916601,
    "dropsitlph": 9166916601,
    "dropsitcph": 9166916601,
    "dropfax": 9164782489
  },
  {
    "dcode": "D",
    "dropkey": "S002451",
    "droptype": "D",
    "dropname": "EMPIRE STATE",
    "dropdeladd": "16 W 33RD ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100019992,
    "dropphyadd": "16 W 33RD ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100019992,
    "dropmaladd": "16 W 33RD ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100019992,
    "dropsitphn": 2123302770,
    "dropsitlph": 2127368282,
    "dropsitcph": 2127368282,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002452",
    "droptype": "D",
    "dropname": "HUDSON AVENUE",
    "dropdeladd": "45 HUDSON AVE",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122079998,
    "dropphyadd": "45 HUDSON AVE",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122079998,
    "dropmaladd": "45 HUDSON AVE",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122079998,
    "dropsitphn": 5184621359,
    "dropsitlph": 5184621359,
    "dropsitcph": 5184621359,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002453",
    "droptype": "D",
    "dropname": "DOWNTOWN ITHACA",
    "dropdeladd": "213 TIOGA ST",
    "dropdelcty": "ITHACA",
    "dropdelst": "NY",
    "dropdelzpp": 148519997,
    "dropphyadd": "213 TIOGA ST",
    "dropphycty": "ITHACA",
    "dropphyst": "NY",
    "dropphyzpp": 148519997,
    "dropmaladd": "213 TIOGA ST",
    "dropmalcty": "ITHACA",
    "dropmalst": "NY",
    "dropmalzpp": 148519997,
    "dropsitphn": 7168462415,
    "dropsitlph": 6072738534,
    "dropsitcph": 6072738534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002532",
    "droptype": "D",
    "dropname": "APPRAISERS STORES",
    "dropdeladd": "580 5TH AVE STE 407",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100369994,
    "dropphyadd": "580 5TH AVE STE 407",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100369994,
    "dropmaladd": "340 W 42ND ST FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100369998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2127680435,
    "dropsitcph": 2127680435,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002603",
    "droptype": "D",
    "dropname": "WALPOLE CARRIERS",
    "dropdeladd": "31 UNION ST",
    "dropdelcty": "EAST WALPOLE",
    "dropdelst": "MA",
    "dropdelzpp": "020329902",
    "dropphyadd": "31 UNION ST",
    "dropphycty": "EAST WALPOLE",
    "dropphyst": "MA",
    "dropphyzpp": "020329902",
    "dropmaladd": "31 UNION ST",
    "dropmalcty": "EAST WALPOLE",
    "dropmalst": "MA",
    "dropmalzpp": "020329902",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5086680259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002629",
    "droptype": "D",
    "dropname": "BLUE HILL PLAZA",
    "dropdeladd": "1 BLUE HILL PLZ LOWR",
    "dropdelcty": "PEARL RIVER",
    "dropdelst": "NY",
    "dropdelzpp": 109653101,
    "dropphyadd": "1 BLUE HILL PLZ LOWR",
    "dropphycty": "PEARL RIVER",
    "dropphyst": "NY",
    "dropphyzpp": 109653101,
    "dropmaladd": "35 S MAIN ST",
    "dropmalcty": "PEARL RIVER",
    "dropmalst": "NY",
    "dropmalzpp": 109659998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8457352974,
    "dropsitcph": 8457352974,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002676",
    "droptype": "D",
    "dropname": "OAKRIDGE MALL",
    "dropdeladd": "925 BLOSSOM HILL RD STE 1407",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951231232,
    "dropphyadd": "925 BLOSSOM HILL RD STE 1407",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951231232,
    "dropmaladd": "925 BLOSSOM HILL RD STE 1407",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951231232,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082268391,
    "dropsitcph": 4084376690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002706",
    "droptype": "D",
    "dropname": "WEST AVE",
    "dropdeladd": "317 WEST AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069029998",
    "dropphyadd": "317 WEST AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069029998",
    "dropmaladd": "317 WEST AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069029998",
    "dropsitphn": 2039643211,
    "dropsitlph": 2039643211,
    "dropsitcph": 2033213910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002790",
    "droptype": "D",
    "dropname": "RITA RANCH",
    "dropdeladd": "8235 S HOUGHTON RD STE 100",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857479704,
    "dropphyadd": "8235 S HOUGHTON RD STE 100",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857479704,
    "dropmaladd": "8235 S HOUGHTON RD STE 100",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857479704,
    "dropsitphn": 5203885019,
    "dropsitlph": 5206635267,
    "dropsitcph": 5206635267,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002908",
    "droptype": "D",
    "dropname": "AMITY RETAIL STORE",
    "dropdeladd": "1449 WHALLEY AVE",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065159994",
    "dropphyadd": "1449 WHALLEY AVE",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065159994",
    "dropmaladd": "1449 WHALLEY AVE",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065159994",
    "dropsitphn": 2033899881,
    "dropsitlph": 2033899881,
    "dropsitcph": 2033899881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002911",
    "droptype": "D",
    "dropname": "GENERAL DELIVERY",
    "dropdeladd": "390 9TH AVE",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100019901,
    "dropphyadd": "390 9TH AVE",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100019901,
    "dropmaladd": "390 9TH AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100019901,
    "dropsitphn": 7182922315,
    "dropsitlph": "",
    "dropsitcph": 2123302952,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002922",
    "droptype": "D",
    "dropname": "OCEAN BLUFF",
    "dropdeladd": "555 OCEAN ST",
    "dropdelcty": "OCEAN BLUFF",
    "dropdelst": "MA",
    "dropdelzpp": "020659997",
    "dropphyadd": "555 OCEAN ST",
    "dropphycty": "OCEAN BLUFF",
    "dropphyst": "MA",
    "dropphyzpp": "020659997",
    "dropmaladd": "555 OCEAN ST",
    "dropmalcty": "OCEAN BLUFF",
    "dropmalst": "MA",
    "dropmalzpp": "020659997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 7818377616,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002941",
    "droptype": "D",
    "dropname": "WASHINGTON MAIN OFFICE",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200669998,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200669998,
    "dropmaladd": "PO BOX 92200",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200902200,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025264812,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S002956",
    "droptype": "D",
    "dropname": "CROSSROADS",
    "dropdeladd": "6210 N JONES BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891309998,
    "dropphyadd": "6210 N JONES BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891309998,
    "dropmaladd": "6210 N JONES BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891309998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022208614,
    "dropsitcph": 7028394471,
    "dropfax": 7028394465
  },
  {
    "dcode": "D",
    "dropkey": "S003086",
    "droptype": "D",
    "dropname": "MOUNT AIRY CARRIER UNIT",
    "dropdeladd": "5209 GREENE ST FRNT",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191449996,
    "dropphyadd": "5209 GREENE ST FRNT",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191449996,
    "dropmaladd": "5209 GREENE ST FRNT",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191449996,
    "dropsitphn": 2158446573,
    "dropsitlph": 2158446573,
    "dropsitcph": 2158446334,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003152",
    "droptype": "D",
    "dropname": "JACKSON XING",
    "dropdeladd": "1104 JACKSON XING",
    "dropdelcty": "JACKSON",
    "dropdelst": "MI",
    "dropdelzpp": 492022061,
    "dropphyadd": "1104 JACKSON XING",
    "dropphycty": "JACKSON",
    "dropphyst": "MI",
    "dropphyzpp": 492022061,
    "dropmaladd": "1104 JACKSON XING",
    "dropmalcty": "JACKSON",
    "dropmalst": "MI",
    "dropmalzpp": 492022061,
    "dropsitphn": "",
    "dropsitlph": 5177680726,
    "dropsitcph": 5177680721,
    "dropfax": 5177680618
  },
  {
    "dcode": "D",
    "dropkey": "S003155",
    "droptype": "D",
    "dropname": "OCEAN CITY FINANCE",
    "dropdeladd": "408 PHILADELPHIA AVE",
    "dropdelcty": "OCEAN CITY",
    "dropdelst": "MD",
    "dropdelzpp": 218429996,
    "dropphyadd": "408 PHILADELPHIA AVE",
    "dropphycty": "OCEAN CITY",
    "dropphyst": "MD",
    "dropphyzpp": 218429996,
    "dropmaladd": "408 PHILADELPHIA AVE",
    "dropmalcty": "OCEAN CITY",
    "dropmalst": "MD",
    "dropmalzpp": 218429996,
    "dropsitphn": 4107637740,
    "dropsitlph": 4105247611,
    "dropsitcph": 4105247611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003188",
    "droptype": "D",
    "dropname": "GLENGARY",
    "dropdeladd": "5992 WESTERVILLE RD STE H",
    "dropdelcty": "WESTERVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 430819996,
    "dropphyadd": "5992 WESTERVILLE RD STE H",
    "dropphycty": "WESTERVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 430819996,
    "dropmaladd": "5992 WESTERVILLE RD STE H",
    "dropmalcty": "WESTERVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 430819996,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148822163,
    "dropsitcph": 6148822163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003190",
    "droptype": "D",
    "dropname": "GALLERIA",
    "dropdeladd": "40 FIRST PLAZA CTR NW STE 240",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871029711,
    "dropphyadd": "40 FIRST PLAZA CTR NW STE 240",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871029711,
    "dropmaladd": "40 FIRST PLAZA CTR NW STE 240",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871029711,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053460854,
    "dropsitcph": 5053468051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003191",
    "droptype": "D",
    "dropname": "GALLUP",
    "dropdeladd": "950 W AZTEC AVE",
    "dropdelcty": "GALLUP",
    "dropdelst": "NM",
    "dropdelzpp": 873019703,
    "dropphyadd": "950 W AZTEC AVE",
    "dropphycty": "GALLUP",
    "dropphyst": "NM",
    "dropphyzpp": 873019703,
    "dropmaladd": "950 W AZTEC AVE",
    "dropmalcty": "GALLUP",
    "dropmalst": "NM",
    "dropmalzpp": 873019703,
    "dropsitphn": 5053468251,
    "dropsitlph": 5057262686,
    "dropsitcph": 5058633491,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003309",
    "droptype": "D",
    "dropname": "BAKER CENTER",
    "dropdeladd": "1 PARK PL",
    "dropdelcty": "ATHENS",
    "dropdelst": "OH",
    "dropdelzpp": 457015005,
    "dropphyadd": "1 PARK PL",
    "dropphycty": "ATHENS",
    "dropphyst": "OH",
    "dropphyzpp": 457015005,
    "dropmaladd": "1 PARK PL",
    "dropmalcty": "ATHENS",
    "dropmalst": "OH",
    "dropmalzpp": 457015005,
    "dropsitphn": 7405935578,
    "dropsitlph": "",
    "dropsitcph": 7405924510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003356",
    "droptype": "D",
    "dropname": "WEST COLLIERVILLE FINANCE",
    "dropdeladd": "3685 S HOUSTON LEVEE RD STE 1",
    "dropdelcty": "COLLIERVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 380179997,
    "dropphyadd": "3685 S HOUSTON LEVEE RD STE 1",
    "dropphycty": "COLLIERVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 380179997,
    "dropmaladd": "3685 S HOUSTON LEVEE RD STE 1",
    "dropmalcty": "COLLIERVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 380179997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9018539380,
    "dropsitcph": 9018539380,
    "dropfax": 9018542705
  },
  {
    "dcode": "D",
    "dropkey": "S003383",
    "droptype": "D",
    "dropname": "SHORT NORTH RETAIL UNIT",
    "dropdeladd": "33 E 4TH AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432013501,
    "dropphyadd": "33 E 4TH AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432013501,
    "dropmaladd": "33 E 4TH AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432013501,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142944922,
    "dropsitcph": 6142944922,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003407",
    "droptype": "D",
    "dropname": "DOWNTOWN OTTAWA",
    "dropdeladd": "405 W MAIN ST",
    "dropdelcty": "OTTAWA",
    "dropdelst": "IL",
    "dropdelzpp": 613502837,
    "dropphyadd": "405 W MAIN ST",
    "dropphycty": "OTTAWA",
    "dropphyst": "IL",
    "dropphyzpp": 613502837,
    "dropmaladd": "405 W MAIN ST",
    "dropmalcty": "OTTAWA",
    "dropmalst": "IL",
    "dropmalzpp": 613502837,
    "dropsitphn": 8154331177,
    "dropsitlph": 7085637318,
    "dropsitcph": 8154332021,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003411",
    "droptype": "D",
    "dropname": "PEORIA P&DC",
    "dropdeladd": "95 STATE ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616019997,
    "dropphyadd": "95 STATE ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616019997,
    "dropmaladd": "95 STATE ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616019997,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096718824,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003443",
    "droptype": "D",
    "dropname": "FIVE POINTS DPOBU",
    "dropdeladd": "4101 INTERSTATE HIGHWAY 69 ACCESS RD STE L6",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784104545,
    "dropphyadd": "4101 INTERSTATE HIGHWAY 69 ACCESS RD STE L6",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784104545,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784269998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3612413531,
    "dropsitcph": 3612414363,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003479",
    "droptype": "D",
    "dropname": "BROADWAY SARATOGA SPRINGS",
    "dropdeladd": "475 BROADWAY STE 1",
    "dropdelcty": "SARATOGA SPRINGS",
    "dropdelst": "NY",
    "dropdelzpp": 128666777,
    "dropphyadd": "475 BROADWAY STE 1",
    "dropphycty": "SARATOGA SPRINGS",
    "dropphyst": "NY",
    "dropphyzpp": 128666777,
    "dropmaladd": "475 BROADWAY STE 1",
    "dropmalcty": "SARATOGA SPRINGS",
    "dropmalst": "NY",
    "dropmalzpp": 128666777,
    "dropsitphn": 5185871798,
    "dropsitlph": 5185871798,
    "dropsitcph": 5185871798,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003491",
    "droptype": "D",
    "dropname": "CHATHAM ANNEX",
    "dropdeladd": "219 MAIN ST STE B",
    "dropdelcty": "CHATHAM",
    "dropdelst": "NJ",
    "dropdelzpp": "079289991",
    "dropphyadd": "219 MAIN ST STE B",
    "dropphycty": "CHATHAM",
    "dropphyst": "NJ",
    "dropphyzpp": "079289991",
    "dropmaladd": "219 MAIN ST STE B",
    "dropmalcty": "CHATHAM",
    "dropmalst": "NJ",
    "dropmalzpp": "079289991",
    "dropsitphn": 9735157868,
    "dropsitlph": 9736358400,
    "dropsitcph": 9736358400,
    "dropfax": 6513066175
  },
  {
    "dcode": "D",
    "dropkey": "S003507",
    "droptype": "D",
    "dropname": "TOPAZ",
    "dropdeladd": "2675 N DECATUR BLVD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891082991,
    "dropphyadd": "2675 N DECATUR BLVD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891082991,
    "dropmaladd": "2675 N DECATUR BLVD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891082991,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7026476348,
    "dropfax": 7026471420
  },
  {
    "dcode": "D",
    "dropkey": "S003656",
    "droptype": "D",
    "dropname": "NEW PRESTON MARBLE DALE",
    "dropdeladd": "253 NEW MILFORD TPKE",
    "dropdelcty": "NEW PRESTON MARBLE DALE",
    "dropdelst": "CT",
    "dropdelzpp": "067779998",
    "dropphyadd": "253 NEW MILFORD TPKE",
    "dropphycty": "NEW PRESTON MARBLE DALE",
    "dropphyst": "CT",
    "dropphyzpp": "067779998",
    "dropmaladd": "253 NEW MILFORD TPKE",
    "dropmalcty": "NEW PRESTON MARBLE DALE",
    "dropmalst": "CT",
    "dropmalzpp": "067779998",
    "dropsitphn": 8608687474,
    "dropsitlph": 8608687660,
    "dropsitcph": 8608687660,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003699",
    "droptype": "D",
    "dropname": "MILK STREET",
    "dropdeladd": "31 MILK ST LBBY",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021099997",
    "dropphyadd": "31 MILK ST LBBY",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021099997",
    "dropmaladd": "PO BOX 969998",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021969998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174821956,
    "dropfax": 6174822169
  },
  {
    "dcode": "D",
    "dropkey": "S003718",
    "droptype": "D",
    "dropname": "MARINERS HARBOR FINANCE",
    "dropdeladd": "2079 FOREST AVE STE 1",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103039993,
    "dropphyadd": "2079 FOREST AVE STE 1",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103039993,
    "dropmaladd": "2079 FOREST AVE STE 1",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103039993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184422086,
    "dropfax": 7182738619
  },
  {
    "dcode": "D",
    "dropkey": "S003726",
    "droptype": "D",
    "dropname": "FRESH MEADOWS",
    "dropdeladd": "19304 HORACE HARDING EXPY STE A",
    "dropdelcty": "FRESH MEADOWS",
    "dropdelst": "NY",
    "dropdelzpp": 113659994,
    "dropphyadd": "19304 HORACE HARDING EXPY STE A",
    "dropphycty": "FRESH MEADOWS",
    "dropphyst": "NY",
    "dropphyzpp": 113659994,
    "dropmaladd": "19304 HORACE HARDING EXPY STE A",
    "dropmalcty": "FRESH MEADOWS",
    "dropmalst": "NY",
    "dropmalzpp": 113659994,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184258163,
    "dropfax": 7184541100
  },
  {
    "dcode": "D",
    "dropkey": "S003727",
    "droptype": "D",
    "dropname": "MELCOURT",
    "dropdeladd": "860 MELROSE AVE FRNT 2",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104519993,
    "dropphyadd": "860 MELROSE AVE FRNT 2",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104519993,
    "dropmaladd": "860 MELROSE AVE FRNT 2",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104519993,
    "dropsitphn": 2123302770,
    "dropsitlph": 7182924581,
    "dropsitcph": 7182924581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003793",
    "droptype": "D",
    "dropname": "DOWNTOWN DAVIS",
    "dropdeladd": "424 3RD ST",
    "dropdelcty": "DAVIS",
    "dropdelst": "CA",
    "dropdelzpp": 956164519,
    "dropphyadd": "424 3RD ST",
    "dropphycty": "DAVIS",
    "dropphyst": "CA",
    "dropphyzpp": 956164519,
    "dropmaladd": "2020 5TH ST",
    "dropmalcty": "DAVIS",
    "dropmalst": "CA",
    "dropmalzpp": 956164019,
    "dropsitphn": 9163738025,
    "dropsitlph": 5307535120,
    "dropsitcph": 5307530428,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003915",
    "droptype": "D",
    "dropname": "UNITED NATIONS",
    "dropdeladd": "405 E 42ND ST OFC 2",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100179992,
    "dropphyadd": "405 E 42ND ST OFC 2",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100179992,
    "dropmaladd": "450 LEXINGTON AVE FL 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100179998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2129637353,
    "dropsitcph": 2129637353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003923",
    "droptype": "D",
    "dropname": "JOINT FORCES STAFF COLLEGE",
    "dropdeladd": "7800 HAMPTON BLVD",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235111702,
    "dropphyadd": "7800 HAMPTON BLVD",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235111702,
    "dropmaladd": "9631 1ST VIEW ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235039998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575835820,
    "dropsitcph": 7575832501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003968",
    "droptype": "D",
    "dropname": "CNN CENTER",
    "dropdeladd": "190 MARIETTA ST NW STE 280",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303032766,
    "dropphyadd": "190 MARIETTA ST NW STE 280",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303032766,
    "dropmaladd": "190 MARIETTA ST NW STE 280",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303032766,
    "dropsitphn": 4047657578,
    "dropsitlph": 4045243692,
    "dropsitcph": 4042229255,
    "dropfax": 4045210988
  },
  {
    "dcode": "D",
    "dropkey": "S003979",
    "droptype": "D",
    "dropname": "COVE",
    "dropdeladd": "51321 AVENIDA BERMUDAS",
    "dropdelcty": "LA QUINTA",
    "dropdelst": "CA",
    "dropdelzpp": 922539997,
    "dropphyadd": "51321 AVENIDA BERMUDAS",
    "dropphycty": "LA QUINTA",
    "dropphyst": "CA",
    "dropphyzpp": 922539997,
    "dropmaladd": "51321 AVENIDA BERMUDAS",
    "dropmalcty": "LA QUINTA",
    "dropmalst": "CA",
    "dropmalzpp": 922539997,
    "dropsitphn": 9093354694,
    "dropsitlph": 7605642304,
    "dropsitcph": 7607712465,
    "dropfax": 7607711354
  },
  {
    "dcode": "D",
    "dropkey": "S003981",
    "droptype": "D",
    "dropname": "JEFFERSON PARK",
    "dropdeladd": "5401 W LAWRENCE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606303404,
    "dropphyadd": "5401 W LAWRENCE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606303404,
    "dropmaladd": "4810 N MILWAUKEE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606302139,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737361672,
    "dropfax": 7737363685
  },
  {
    "dcode": "D",
    "dropkey": "S003982",
    "droptype": "D",
    "dropname": "JOHN HANCOCK",
    "dropdeladd": "875 N MICHIGAN AVE STE GP-07",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606111895,
    "dropphyadd": "875 N MICHIGAN AVE STE GP-07",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606111895,
    "dropmaladd": "540 N DEARBORN ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606109998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3126440485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003983",
    "droptype": "D",
    "dropname": "EDGEBROOK",
    "dropdeladd": "5424 W DEVON AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606469998,
    "dropphyadd": "5424 W DEVON AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606469998,
    "dropmaladd": "5424 W DEVON AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606469998,
    "dropsitphn": 3129837602,
    "dropsitlph": "",
    "dropsitcph": 7737635370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003984",
    "droptype": "D",
    "dropname": "LOOP JEWELERS ROW",
    "dropdeladd": "5 S WABASH AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606033025,
    "dropphyadd": "5 S WABASH AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606033025,
    "dropmaladd": "211 S CLARK ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606049998,
    "dropsitphn": 3129837602,
    "dropsitlph": "",
    "dropsitcph": 3129838000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003985",
    "droptype": "D",
    "dropname": "GRAND CROSSING",
    "dropdeladd": "7715 S COTTAGE GROVE AVE STE 1",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606192998,
    "dropphyadd": "7715 S COTTAGE GROVE AVE STE 1",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606192998,
    "dropmaladd": "7748 S COTTAGE GROVE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606199998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7733470017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S003991",
    "droptype": "D",
    "dropname": "CENTERPOINTE POSTAL STORE",
    "dropdeladd": "3665 28TH ST SE STE 6F",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495121689,
    "dropphyadd": "3665 28TH ST SE STE 6F",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495121689,
    "dropmaladd": "3665 28TH ST SE STE 6F",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495121689,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6162850364,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004043",
    "droptype": "D",
    "dropname": "DOWNTOWN KINGSPORT",
    "dropdeladd": "320 W CENTER ST",
    "dropdelcty": "KINGSPORT",
    "dropdelst": "TN",
    "dropdelzpp": 376609998,
    "dropphyadd": "320 W CENTER ST",
    "dropphycty": "KINGSPORT",
    "dropphyst": "TN",
    "dropphyzpp": 376609998,
    "dropmaladd": "320 W CENTER ST",
    "dropmalcty": "KINGSPORT",
    "dropmalst": "TN",
    "dropmalzpp": 376609998,
    "dropsitphn": 6158859336,
    "dropsitlph": 4232450500,
    "dropsitcph": 4232450500,
    "dropfax": 4232450500
  },
  {
    "dcode": "D",
    "dropkey": "S004310",
    "droptype": "D",
    "dropname": "TERMINAL ANNEX FINANCE",
    "dropdeladd": "900 N ALAMEDA ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900122904,
    "dropphyadd": "900 N ALAMEDA ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900122904,
    "dropmaladd": "900 N ALAMEDA ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900122904,
    "dropsitphn": 2136174405,
    "dropsitlph": 2136174551,
    "dropsitcph": 2136174405,
    "dropfax": 2136174486
  },
  {
    "dcode": "D",
    "dropkey": "S004335",
    "droptype": "D",
    "dropname": "SUDBURY CENTER",
    "dropdeladd": "517 BOSTON POST RD",
    "dropdelcty": "SUDBURY",
    "dropdelst": "MA",
    "dropdelzpp": "017763393",
    "dropphyadd": "517 BOSTON POST RD",
    "dropphycty": "SUDBURY",
    "dropphyst": "MA",
    "dropphyzpp": "017763393",
    "dropmaladd": "517 BOSTON POST RD",
    "dropmalcty": "SUDBURY",
    "dropmalst": "MA",
    "dropmalzpp": "017763393",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784438188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004506",
    "droptype": "D",
    "dropname": "FORT MCNAIR",
    "dropdeladd": "300 A ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 203195067,
    "dropphyadd": "300 A ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 203195067,
    "dropmaladd": "300 A ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 203195067,
    "dropsitphn": "",
    "dropsitlph": 2025232590,
    "dropsitcph": 2025232590,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004521",
    "droptype": "D",
    "dropname": "WHITE HOUSE",
    "dropdeladd": "1700 PENNSYLVANIA AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200064700,
    "dropphyadd": "1700 PENNSYLVANIA AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200064700,
    "dropmaladd": "PO BOX 27003",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200387003,
    "dropsitphn": "",
    "dropsitlph": 2024562541,
    "dropsitcph": 2024562541,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004523",
    "droptype": "D",
    "dropname": "DEPT OF AGRICULTURE",
    "dropdeladd": "1400 INDEPENDENCE AVE SW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 202500004,
    "dropphyadd": "1400 INDEPENDENCE AVE SW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 202500004,
    "dropmaladd": "1400 INDEPENDENCE AVE SW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 202500004,
    "dropsitphn": "",
    "dropsitlph": 2027209592,
    "dropsitcph": 2027209592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004541",
    "droptype": "D",
    "dropname": "HEADSVILLE",
    "dropdeladd": "1200 CONSTITUTION AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 205609997,
    "dropphyadd": "1200 CONSTITUTION AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 205609997,
    "dropmaladd": "1200 CONSTITUTION AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 205609997,
    "dropsitphn": "",
    "dropsitlph": 2026333029,
    "dropsitcph": 2026333029,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004636",
    "droptype": "D",
    "dropname": "THENDARA",
    "dropdeladd": "2828 STATE ROUTE 28",
    "dropdelcty": "THENDARA",
    "dropdelst": "NY",
    "dropdelzpp": 134729998,
    "dropphyadd": "2828 STATE ROUTE 28",
    "dropphycty": "THENDARA",
    "dropphyst": "NY",
    "dropphyzpp": 134729998,
    "dropmaladd": "2828 STATE ROUTE 28",
    "dropmalcty": "THENDARA",
    "dropmalst": "NY",
    "dropmalzpp": 134729998,
    "dropsitphn": 3153693414,
    "dropsitlph": 3153693414,
    "dropsitcph": 3153693414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004717",
    "droptype": "D",
    "dropname": "KATY FINANCE",
    "dropdeladd": "5701 4TH ST",
    "dropdelcty": "KATY",
    "dropdelst": "TX",
    "dropdelzpp": 774939998,
    "dropphyadd": "5701 4TH ST",
    "dropphycty": "KATY",
    "dropphyst": "TX",
    "dropphyzpp": 774939998,
    "dropmaladd": "5701 4TH ST",
    "dropmalcty": "KATY",
    "dropmalst": "TX",
    "dropmalzpp": 774939998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2813917538,
    "dropsitcph": 2813917538,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004751",
    "droptype": "D",
    "dropname": "EAST PEORIA  BRANCH",
    "dropdeladd": "401 E WASHINGTON ST",
    "dropdelcty": "EAST PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616112666,
    "dropphyadd": "401 E WASHINGTON ST",
    "dropphycty": "EAST PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616112666,
    "dropmaladd": "401 E WASHINGTON ST",
    "dropmalcty": "EAST PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616112666,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096942366,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004774",
    "droptype": "D",
    "dropname": "DOWNTOWN JONESBORO",
    "dropdeladd": "310 EAST ST STE C",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019995,
    "dropphyadd": "310 EAST ST STE C",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019995,
    "dropmaladd": "310 EAST ST STE C",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019995,
    "dropsitphn": 8709725989,
    "dropsitlph": 8709336857,
    "dropsitcph": 8709336857,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004796",
    "droptype": "D",
    "dropname": "DR H P GARCIA",
    "dropdeladd": "809 NUECES BAY BLVD",
    "dropdelcty": "CORPUS CHRISTI",
    "dropdelst": "TX",
    "dropdelzpp": 784699998,
    "dropphyadd": "809 NUECES BAY BLVD",
    "dropphycty": "CORPUS CHRISTI",
    "dropphyst": "TX",
    "dropphyzpp": 784699995,
    "dropmaladd": "809 NUECES BAY BLVD",
    "dropmalcty": "CORPUS CHRISTI",
    "dropmalst": "TX",
    "dropmalzpp": 784699998,
    "dropsitphn": 2103688387,
    "dropsitlph": 3618862286,
    "dropsitcph": 3618862286,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S004811",
    "droptype": "D",
    "dropname": "MAIN OFFICE ABILENE",
    "dropdeladd": "341 PINE ST",
    "dropdelcty": "ABILENE",
    "dropdelst": "TX",
    "dropdelzpp": 796019998,
    "dropphyadd": "341 PINE ST",
    "dropphycty": "ABILENE",
    "dropphyst": "TX",
    "dropphyzpp": 796019998,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ABILENE",
    "dropmalst": "TX",
    "dropmalzpp": 796049998,
    "dropsitphn": 8173173658,
    "dropsitlph": 3257382111,
    "dropsitcph": 3257382135,
    "dropfax": 3257382148
  },
  {
    "dcode": "D",
    "dropkey": "S004833",
    "droptype": "D",
    "dropname": "AIRPORT STATION  SAT",
    "dropdeladd": "10250 JOHN SAUNDERS RD",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782469998,
    "dropphyadd": "10250 JOHN SAUNDERS RD",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782469998,
    "dropmaladd": "10250 JOHN SAUNDERS RD",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782469998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2108280390,
    "dropsitcph": 2108280267,
    "dropfax": 2108284447
  },
  {
    "dcode": "D",
    "dropkey": "S004914",
    "droptype": "D",
    "dropname": "MAIN OFFICE ARLINGTON",
    "dropdeladd": "300 E SOUTH ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "TX",
    "dropdelzpp": 760049998,
    "dropphyadd": "300 E SOUTH ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "TX",
    "dropphyzpp": 760049998,
    "dropmaladd": "300 E SOUTH ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "TX",
    "dropmalzpp": 760049998,
    "dropsitphn": 8173173658,
    "dropsitlph": 8175438413,
    "dropsitcph": 8175438412,
    "dropfax": 8172776430
  },
  {
    "dcode": "D",
    "dropkey": "S004915",
    "droptype": "D",
    "dropname": "MAIN OFFICE WICHITA FALLS",
    "dropdeladd": "1000 LAMAR ST",
    "dropdelcty": "WICHITA FALLS",
    "dropdelst": "TX",
    "dropdelzpp": 763019995,
    "dropphyadd": "1000 LAMAR ST",
    "dropphycty": "WICHITA FALLS",
    "dropphyst": "TX",
    "dropphyzpp": 763019995,
    "dropmaladd": "PO BOX 97998",
    "dropmalcty": "WICHITA FALLS",
    "dropmalst": "TX",
    "dropmalzpp": 763079998,
    "dropsitphn": 9403173658,
    "dropsitlph": 9403978107,
    "dropsitcph": 9403975065,
    "dropfax": 9403978137
  },
  {
    "dcode": "D",
    "dropkey": "S006128",
    "droptype": "D",
    "dropname": "LAGUNA WOODS MOBILE UNIT",
    "dropdeladd": "23822 AVENIDA SEVILLA STE A",
    "dropdelcty": "LAGUNA WOODS",
    "dropdelst": "CA",
    "dropdelzpp": 926370828,
    "dropphyadd": "23822 AVENIDA SEVILLA STE A",
    "dropphycty": "LAGUNA WOODS",
    "dropphyst": "CA",
    "dropphyzpp": 926370828,
    "dropmaladd": "24001 CALLE DE LA MAGDALENA",
    "dropmalcty": "LAGUNA HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 926549998,
    "dropsitphn": 9498371010,
    "dropsitlph": 9499514622,
    "dropsitcph": 9498371010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006139",
    "droptype": "D",
    "dropname": "PASADENA WINDOW UNIT",
    "dropdeladd": "600 LINCOLN AVE",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911099800,
    "dropphyadd": "600 LINCOLN AVE",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911099800,
    "dropmaladd": "600 LINCOLN AVE",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911099800,
    "dropsitphn": 6617757808,
    "dropsitlph": 6263047112,
    "dropsitcph": 6263047164,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006149",
    "droptype": "D",
    "dropname": "PORT AUTHORITY CONVENIENCE",
    "dropdeladd": "625 8TH AVE STE 104A",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100189993,
    "dropphyadd": "625 8TH AVE STE 104A",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100189993,
    "dropmaladd": "625 8TH AVE STE 104A",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100189993,
    "dropsitphn": 2123302770,
    "dropsitlph": 6464720501,
    "dropsitcph": 6464720501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006157",
    "droptype": "D",
    "dropname": "HAMILTON GRANGE",
    "dropdeladd": "99 MACOMBS PL",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100399997,
    "dropphyadd": "99 MACOMBS PL",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100399997,
    "dropmaladd": "99 MACOMBS PL",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100399997,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123689849,
    "dropsitcph": 2123689849,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006164",
    "droptype": "D",
    "dropname": "POST OFFICE EXPRESS",
    "dropdeladd": "565 S LOWRY ST",
    "dropdelcty": "SMYRNA",
    "dropdelst": "TN",
    "dropdelzpp": 371673803,
    "dropphyadd": "565 S LOWRY ST",
    "dropphycty": "SMYRNA",
    "dropphyst": "TN",
    "dropphyzpp": 371673803,
    "dropmaladd": "565 S LOWRY ST",
    "dropmalcty": "SMYRNA",
    "dropmalst": "TN",
    "dropmalzpp": 371673803,
    "dropsitphn": 6158859336,
    "dropsitlph": 6152202108,
    "dropsitcph": 6152202108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006181",
    "droptype": "D",
    "dropname": "GMF FORT SMITH",
    "dropdeladd": "3318 S 74TH ST",
    "dropdelcty": "FORT SMITH",
    "dropdelst": "AR",
    "dropdelzpp": 729039993,
    "dropphyadd": "3318 S 74TH ST",
    "dropphycty": "FORT SMITH",
    "dropphyst": "AR",
    "dropphyzpp": 729039993,
    "dropmaladd": "3318 S 74TH ST",
    "dropmalcty": "FORT SMITH",
    "dropmalst": "AR",
    "dropmalzpp": 729039993,
    "dropsitphn": 4794846496,
    "dropsitlph": 4794846401,
    "dropsitcph": 4794846401,
    "dropfax": 4794846397
  },
  {
    "dcode": "D",
    "dropkey": "S006182",
    "droptype": "D",
    "dropname": "MAIN OFFICE N LITTLE ROCK",
    "dropdeladd": "300 W PERSHING BLVD",
    "dropdelcty": "NORTH LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 721149998,
    "dropphyadd": "300 W PERSHING BLVD",
    "dropphycty": "NORTH LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 721149997,
    "dropmaladd": "300 W PERSHING BLVD",
    "dropmalcty": "NORTH LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 721149998,
    "dropsitphn": 5017583290,
    "dropsitlph": 5017583290,
    "dropsitcph": 5017583290,
    "dropfax": 5017589172
  },
  {
    "dcode": "D",
    "dropkey": "S006193",
    "droptype": "D",
    "dropname": "SANTA FE MAIN",
    "dropdeladd": "120 S FEDERAL PL STE 101",
    "dropdelcty": "SANTA FE",
    "dropdelst": "NM",
    "dropdelzpp": 875019998,
    "dropphyadd": "120 S FEDERAL PL STE 101",
    "dropphycty": "SANTA FE",
    "dropphyst": "NM",
    "dropphyzpp": 875019998,
    "dropmaladd": "120 S FEDERAL PL STE 101",
    "dropmalcty": "SANTA FE",
    "dropmalst": "NM",
    "dropmalzpp": 875019998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5059882239,
    "dropsitcph": 5059882239,
    "dropfax": 5059886363
  },
  {
    "dcode": "D",
    "dropkey": "S006194",
    "droptype": "D",
    "dropname": "MAIN OFFICE IRVING",
    "dropdeladd": "2701 W IRVING BLVD",
    "dropdelcty": "IRVING",
    "dropdelst": "TX",
    "dropdelzpp": 750619997,
    "dropphyadd": "2701 W IRVING BLVD",
    "dropphycty": "IRVING",
    "dropphyst": "TX",
    "dropphyzpp": 750619997,
    "dropmaladd": "2701 W IRVING BLVD",
    "dropmalcty": "IRVING",
    "dropmalst": "TX",
    "dropmalzpp": 750619997,
    "dropsitphn": 2144675879,
    "dropsitlph": 9729866560,
    "dropsitcph": 9729866560,
    "dropfax": 9729869724
  },
  {
    "dcode": "D",
    "dropkey": "S006195",
    "droptype": "D",
    "dropname": "MAIN OFFICE PLANO",
    "dropdeladd": "1200 JUPITER RD",
    "dropdelcty": "PLANO",
    "dropdelst": "TX",
    "dropdelzpp": 750749996,
    "dropphyadd": "1200 JUPITER RD",
    "dropphycty": "PLANO",
    "dropphyst": "TX",
    "dropphyzpp": 750749996,
    "dropmaladd": "1200 JUPITER RD",
    "dropmalcty": "PLANO",
    "dropmalst": "TX",
    "dropmalzpp": 750749996,
    "dropsitphn": 2144675879,
    "dropsitlph": 9726335754,
    "dropsitcph": 9726335754,
    "dropfax": 9728815322
  },
  {
    "dcode": "D",
    "dropkey": "S006237",
    "droptype": "D",
    "dropname": "WESTRIDGE",
    "dropdeladd": "7925 W RUSSELL RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891139998,
    "dropphyadd": "7925 W RUSSELL RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891139998,
    "dropmaladd": "7925 W RUSSELL RD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891139998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028711175,
    "dropsitcph": 7028711175,
    "dropfax": 7028710638
  },
  {
    "dcode": "D",
    "dropkey": "S006247",
    "droptype": "D",
    "dropname": "AMARILLO MAIN OFC",
    "dropdeladd": "2301 ROSS ST",
    "dropdelcty": "AMARILLO",
    "dropdelst": "TX",
    "dropdelzpp": 791202200,
    "dropphyadd": "2301 ROSS ST",
    "dropphycty": "AMARILLO",
    "dropphyst": "TX",
    "dropphyzpp": 791202200,
    "dropmaladd": "2301 ROSS ST",
    "dropmalcty": "AMARILLO",
    "dropmalst": "TX",
    "dropmalzpp": 791202200,
    "dropsitphn": 8173173658,
    "dropsitlph": 8064682235,
    "dropsitcph": 8064682235,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006250",
    "droptype": "D",
    "dropname": "BUCKINGHAM",
    "dropdeladd": "1074 S IRONTON ST UNIT D",
    "dropdelcty": "AURORA",
    "dropdelst": "CO",
    "dropdelzpp": 800129997,
    "dropphyadd": "1074 S IRONTON ST UNIT D",
    "dropphycty": "AURORA",
    "dropphyst": "CO",
    "dropphyzpp": 800129997,
    "dropmaladd": "1074 S IRONTON ST UNIT D",
    "dropmalcty": "AURORA",
    "dropmalst": "CO",
    "dropmalzpp": 800129997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3033661353,
    "dropsitcph": 3033661353,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006348",
    "droptype": "D",
    "dropname": "SEVEN HILLS",
    "dropdeladd": "3055 SAINT ROSE PKWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890529998,
    "dropphyadd": "3055 SAINT ROSE PKWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890529998,
    "dropmaladd": "3055 SAINT ROSE PKWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890529998,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022697325,
    "dropsitcph": 7028977398,
    "dropfax": 7028378421
  },
  {
    "dcode": "D",
    "dropkey": "S006349",
    "droptype": "D",
    "dropname": "DESERT INN",
    "dropdeladd": "2478 E DESERT INN RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891219997,
    "dropphyadd": "2478 E DESERT INN RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891219997,
    "dropmaladd": "2478 E DESERT INN RD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891219997,
    "dropsitphn": 7023619453,
    "dropsitlph": "",
    "dropsitcph": 7027960801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006351",
    "droptype": "D",
    "dropname": "BAY STATION STAMP STORE",
    "dropdeladd": "177 RIVERSIDE AVE STE A",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926639998,
    "dropphyadd": "177 RIVERSIDE AVE STE A",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926639998,
    "dropmaladd": "177 RIVERSIDE AVE STE A",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926639998,
    "dropsitphn": 9496453154,
    "dropsitlph": 9496453154,
    "dropsitcph": 9496453154,
    "dropfax": 9496501587
  },
  {
    "dcode": "D",
    "dropkey": "S006352",
    "droptype": "D",
    "dropname": "LEISURE WORLD",
    "dropdeladd": "13580 SAINT ANDREWS DR",
    "dropdelcty": "SEAL BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 907409996,
    "dropphyadd": "13580 SAINT ANDREWS DR",
    "dropphycty": "SEAL BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 907409996,
    "dropmaladd": "2929 WESTMINSTER AVE",
    "dropmalcty": "SEAL BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 907409998,
    "dropsitphn": 5624313641,
    "dropsitlph": 5624933924,
    "dropsitcph": 5624939324,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006438",
    "droptype": "D",
    "dropname": "BIRMINGHAM AMF",
    "dropdeladd": "5900 MESSER AIRPORT HWY STE 110",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352121053,
    "dropphyadd": "5900 MESSER AIRPORT HWY STE 110",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352121053,
    "dropmaladd": "5900 MESSER AIRPORT HWY STE 110",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352121053,
    "dropsitphn": 2055210367,
    "dropsitlph": 2055210367,
    "dropsitcph": 2055210217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006447",
    "droptype": "D",
    "dropname": "UNION STATION",
    "dropdeladd": "50 MASSACHUSETTS AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200029995,
    "dropphyadd": "50 MASSACHUSETTS AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200029995,
    "dropmaladd": "50 MASSACHUSETTS AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200029995,
    "dropsitphn": "",
    "dropsitlph": 2025232057,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S006927",
    "droptype": "D",
    "dropname": "TOWER SQUARE",
    "dropdeladd": "1500 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011151001",
    "dropphyadd": "1500 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011151001",
    "dropmaladd": "1500 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011151001",
    "dropsitphn": 4137856246,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137333631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S007349",
    "droptype": "D",
    "dropname": "BEDFORD RETAIL UNIT",
    "dropdeladd": "158 GREAT RD UNIT J",
    "dropdelcty": "BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "017309997",
    "dropphyadd": "158 GREAT RD UNIT J",
    "dropphycty": "BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "017309997",
    "dropmaladd": "158 GREAT RD UNIT J",
    "dropmalcty": "BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "017309997",
    "dropsitphn": 9786647013,
    "dropsitlph": 7812753068,
    "dropsitcph": 7812752083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S007603",
    "droptype": "D",
    "dropname": "WADSWORTH",
    "dropdeladd": "119 S LYMAN ST",
    "dropdelcty": "WADSWORTH",
    "dropdelst": "OH",
    "dropdelzpp": 442819997,
    "dropphyadd": "119 S LYMAN ST",
    "dropphycty": "WADSWORTH",
    "dropphyst": "OH",
    "dropphyzpp": 442819997,
    "dropmaladd": "165 BROAD ST",
    "dropmalcty": "WADSWORTH",
    "dropmalst": "OH",
    "dropmalzpp": 442819998,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3303341332,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S007647",
    "droptype": "D",
    "dropname": "USPS BUSINESS CTR RETAIL",
    "dropdeladd": "2600 ELTHAM AVE STE 109",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235132504,
    "dropphyadd": "2600 ELTHAM AVE STE 109",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235132504,
    "dropmaladd": "2600 ELTHAM AVE STE 109",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235132504,
    "dropsitphn": "",
    "dropsitlph": 7578554017,
    "dropsitcph": 7578554017,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S007826",
    "droptype": "D",
    "dropname": "AIRPORT",
    "dropdeladd": "3571 CONCORDE DR",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454909998,
    "dropphyadd": "3571 CONCORDE DR",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454909998,
    "dropmaladd": "3571 CONCORDE DR",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454909998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372271163,
    "dropsitcph": 9372271163,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008101",
    "droptype": "D",
    "dropname": "KILBUCK",
    "dropdeladd": "1001 CALIFORNIA AVE RM 1004",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152909200,
    "dropphyadd": "1001 CALIFORNIA AVE RM 1004",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152909200,
    "dropmaladd": "1001 CALIFORNIA AVE RM 1004",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152909200,
    "dropsitphn": 4123597084,
    "dropsitlph": 4123597895,
    "dropsitcph": 4123597084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008109",
    "droptype": "D",
    "dropname": "SANTA ANA WINDOW SVCS",
    "dropdeladd": "3101 W SUNFLOWER AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927990100,
    "dropphyadd": "3101 W SUNFLOWER AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927990100,
    "dropmaladd": "3101 W SUNFLOWER AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927990100,
    "dropsitphn": 7146626474,
    "dropsitlph": 7146626474,
    "dropsitcph": 7146626474,
    "dropfax": 7143276593
  },
  {
    "dcode": "D",
    "dropkey": "S008153",
    "droptype": "D",
    "dropname": "TULSA AMF RETAIL",
    "dropdeladd": "2161 N CARGO RD STE A",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741159997,
    "dropphyadd": "2161 N CARGO RD STE A",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741159997,
    "dropmaladd": "2161 N CARGO RD STE A",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741159997,
    "dropsitphn": 9182707514,
    "dropsitlph": 9188346086,
    "dropsitcph": 9188346086,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008154",
    "droptype": "D",
    "dropname": "OKC AMF RETAIL",
    "dropdeladd": "6500 AIR CARGO RD STE B",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731959900,
    "dropphyadd": "6500 AIR CARGO RD STE B",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731959900,
    "dropmaladd": "6500 AIR CARGO RD STE B",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731959900,
    "dropsitphn": 4058152632,
    "dropsitlph": 4058152632,
    "dropsitcph": 4058152632,
    "dropfax": 4056816615
  },
  {
    "dcode": "D",
    "dropkey": "S008196",
    "droptype": "D",
    "dropname": "MOUNT CARMEL",
    "dropdeladd": "2514 WHITNEY AVE",
    "dropdelcty": "HAMDEN",
    "dropdelst": "CT",
    "dropdelzpp": "065189997",
    "dropphyadd": "2514 WHITNEY AVE",
    "dropphycty": "HAMDEN",
    "dropphyst": "CT",
    "dropphyzpp": "065189997",
    "dropmaladd": "2514 WHITNEY AVE",
    "dropmalcty": "HAMDEN",
    "dropmalst": "CT",
    "dropmalzpp": "065189997",
    "dropsitphn": 2034075822,
    "dropsitlph": 2034075822,
    "dropsitcph": 2034075822,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008256",
    "droptype": "D",
    "dropname": "WESTMINSTER MALL",
    "dropdeladd": "2014 WESTMINSTER MALL",
    "dropdelcty": "WESTMINSTER",
    "dropdelst": "CA",
    "dropdelzpp": 926834950,
    "dropphyadd": "2014 WESTMINSTER MALL",
    "dropphycty": "WESTMINSTER",
    "dropphyst": "CA",
    "dropphyzpp": 926834950,
    "dropmaladd": "2014 WESTMINSTER MALL",
    "dropmalcty": "WESTMINSTER",
    "dropmalst": "CA",
    "dropmalzpp": 926834950,
    "dropsitphn": 7148970133,
    "dropsitlph": 7148970133,
    "dropsitcph": 7148970133,
    "dropfax": 7143734329
  },
  {
    "dcode": "D",
    "dropkey": "S008313",
    "droptype": "D",
    "dropname": "AMC OHARE TERMINAL 2",
    "dropdeladd": "11600 W IRVING PARK RD",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606669909,
    "dropphyadd": "11600 W IRVING PARK RD",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606669909,
    "dropmaladd": "11600 W IRVING PARK RD",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606669909,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 7736861309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008389",
    "droptype": "D",
    "dropname": "EVANSVILLE MAIN OFFICE",
    "dropdeladd": "800 SYCAMORE ST",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477089998,
    "dropphyadd": "800 SYCAMORE ST",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477089998,
    "dropmaladd": "800 SYCAMORE ST",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477089998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124293411,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008411",
    "droptype": "D",
    "dropname": "ISELIN RETAIL",
    "dropdeladd": "240 MIDDLESEX TPKE",
    "dropdelcty": "ISELIN",
    "dropdelst": "NJ",
    "dropdelzpp": "088309997",
    "dropphyadd": "240 MIDDLESEX TPKE",
    "dropphycty": "ISELIN",
    "dropphyst": "NJ",
    "dropphyzpp": "088309997",
    "dropmaladd": "250 MIDDLESEX TPKE",
    "dropmalcty": "ISELIN",
    "dropmalst": "NJ",
    "dropmalzpp": "088302032",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 7322830053,
    "dropfax": 7322838966
  },
  {
    "dcode": "D",
    "dropkey": "S008416",
    "droptype": "D",
    "dropname": "MEMPHIS AIRPORT",
    "dropdeladd": "4233 LOUIS CARRUTHERS DR",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381306604,
    "dropphyadd": "4233 LOUIS CARRUTHERS DR",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381306604,
    "dropmaladd": "4233 LOUIS CARRUTHERS DR",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381306604,
    "dropsitphn": 6158859336,
    "dropsitlph": 9013449987,
    "dropsitcph": 9013326580,
    "dropfax": 9013451525
  },
  {
    "dcode": "D",
    "dropkey": "S008421",
    "droptype": "D",
    "dropname": "DELTA BRANCH",
    "dropdeladd": "5208 W SAGINAW HWY",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489171913,
    "dropphyadd": "5208 W SAGINAW HWY",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489171913,
    "dropmaladd": "5208 W SAGINAW HWY",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489171913,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173378775,
    "dropsitcph": 5173213087,
    "dropfax": 5173219792
  },
  {
    "dcode": "D",
    "dropkey": "S008442",
    "droptype": "D",
    "dropname": "AVONDALE",
    "dropdeladd": "401 W WESTERN AVE",
    "dropdelcty": "AVONDALE",
    "dropdelst": "AZ",
    "dropdelzpp": 853232266,
    "dropphyadd": "401 W WESTERN AVE",
    "dropphycty": "AVONDALE",
    "dropphyst": "AZ",
    "dropphyzpp": 853232266,
    "dropmaladd": "401 W WESTERN AVE",
    "dropmalcty": "AVONDALE",
    "dropmalst": "AZ",
    "dropmalzpp": 853232266,
    "dropsitphn": 6238829146,
    "dropsitlph": 6239259697,
    "dropsitcph": 6238829148,
    "dropfax": 6238829239
  },
  {
    "dcode": "D",
    "dropkey": "S008453",
    "droptype": "D",
    "dropname": "SOUTHSIDE",
    "dropdeladd": "16731 SANTA ANA AVE",
    "dropdelcty": "FONTANA",
    "dropdelst": "CA",
    "dropdelzpp": 923379997,
    "dropphyadd": "16731 SANTA ANA AVE",
    "dropphycty": "FONTANA",
    "dropphyst": "CA",
    "dropphyzpp": 923379997,
    "dropmaladd": "16731 SANTA ANA AVE",
    "dropmalcty": "FONTANA",
    "dropmalst": "CA",
    "dropmalzpp": 923379997,
    "dropsitphn": 9093503425,
    "dropsitlph": 9093503425,
    "dropsitcph": 9093503466,
    "dropfax": 9093503855
  },
  {
    "dcode": "D",
    "dropkey": "S008457",
    "droptype": "D",
    "dropname": "POE HENDERSON",
    "dropdeladd": "2650 W HORIZON RIDGE PKWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890522844,
    "dropphyadd": "2650 W HORIZON RIDGE PKWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890522844,
    "dropmaladd": "2650 W HORIZON RIDGE PKWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890522844,
    "dropsitphn": 7023619453,
    "dropsitlph": 7022606954,
    "dropsitcph": 7022606389,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008482",
    "droptype": "D",
    "dropname": "KANSAS CITY MO RETAIL",
    "dropdeladd": "30 W PERSHING RD STE 112",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641089712,
    "dropphyadd": "30 W PERSHING RD STE 112",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641089712,
    "dropmaladd": "30 W PERSHING RD STE 112",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641089712,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 8163749182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008484",
    "droptype": "D",
    "dropname": "ALEXANDRIA BMEU",
    "dropdeladd": "2226 DUKE ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223149099,
    "dropphyadd": "2226 DUKE ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223149099,
    "dropmaladd": "2226 DUKE ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223149099,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035190866,
    "dropsitcph": 7035190866,
    "dropfax": 7036931530
  },
  {
    "dcode": "D",
    "dropkey": "S008493",
    "droptype": "D",
    "dropname": "CHATT MAIN OFFICE WINDOW",
    "dropdeladd": "6050 SHALLOWFORD RD",
    "dropdelcty": "CHATTANOOGA",
    "dropdelst": "TN",
    "dropdelzpp": 374219702,
    "dropphyadd": "6050 SHALLOWFORD RD",
    "dropphycty": "CHATTANOOGA",
    "dropphyst": "TN",
    "dropphyzpp": 374219702,
    "dropmaladd": "6050 SHALLOWFORD RD",
    "dropmalcty": "CHATTANOOGA",
    "dropmalst": "TN",
    "dropmalzpp": 374219702,
    "dropsitphn": 6158859336,
    "dropsitlph": 4234998294,
    "dropsitcph": 4234998294,
    "dropfax": 4234998253
  },
  {
    "dcode": "D",
    "dropkey": "S008494",
    "droptype": "D",
    "dropname": "KNOXVILLE MAIN OFFICE WINDOW",
    "dropdeladd": "1237 E WEISGARBER RD RM 9831",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379509831,
    "dropphyadd": "1237 E WEISGARBER RD RM 9831",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379509831,
    "dropmaladd": "1237 E WEISGARBER RD RM 9831",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379509831,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655584629,
    "dropsitcph": 8655584629,
    "dropfax": 8655584644
  },
  {
    "dcode": "D",
    "dropkey": "S008501",
    "droptype": "D",
    "dropname": "MEMPHIS MAIN OFFICE WINDOW",
    "dropdeladd": "555 S B B KING BLVD LBBY",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381019715,
    "dropphyadd": "555 S B B KING BLVD LBBY",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381019715,
    "dropmaladd": "555 S B B KING BLVD LBBY",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381019715,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212575,
    "dropsitcph": 9015212575,
    "dropfax": 9015212592
  },
  {
    "dcode": "D",
    "dropkey": "S008564",
    "droptype": "D",
    "dropname": "EASTSIDE",
    "dropdeladd": "3906 OAKLAND AVE",
    "dropdelcty": "SAINT JOSEPH",
    "dropdelst": "MO",
    "dropdelzpp": 645064980,
    "dropphyadd": "3906 OAKLAND AVE",
    "dropphycty": "SAINT JOSEPH",
    "dropphyst": "MO",
    "dropphyzpp": 645064980,
    "dropmaladd": "3906 OAKLAND AVE",
    "dropmalcty": "SAINT JOSEPH",
    "dropmalst": "MO",
    "dropmalzpp": 645064980,
    "dropsitphn": 8165043362,
    "dropsitlph": 8163643231,
    "dropsitcph": 8162795477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008636",
    "droptype": "D",
    "dropname": "SILVER LAKE",
    "dropdeladd": "2700 CULLEN BLVD",
    "dropdelcty": "PEARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 775840802,
    "dropphyadd": "2700 CULLEN BLVD",
    "dropphycty": "PEARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 775840802,
    "dropmaladd": "2700 CULLEN BLVD",
    "dropmalcty": "PEARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 775840802,
    "dropsitphn": 7132263055,
    "dropsitlph": 2814122876,
    "dropsitcph": 2814124548,
    "dropfax": 2814120089
  },
  {
    "dcode": "D",
    "dropkey": "S008667",
    "droptype": "D",
    "dropname": "EDWARDS",
    "dropdeladd": "20 W POPSON AVE",
    "dropdelcty": "EDWARDS",
    "dropdelst": "CA",
    "dropdelzpp": 935241201,
    "dropphyadd": "20 W POPSON AVE",
    "dropphycty": "EDWARDS",
    "dropphyst": "CA",
    "dropphyzpp": 935241201,
    "dropmaladd": "20 W POPSON AVE",
    "dropmalcty": "EDWARDS",
    "dropmalst": "CA",
    "dropmalzpp": 935241201,
    "dropsitphn": 6617757808,
    "dropsitlph": "",
    "dropsitcph": 6612587145,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008682",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "1409 W GREEN ST",
    "dropdelcty": "URBANA",
    "dropdelst": "IL",
    "dropdelzpp": 618019997,
    "dropphyadd": "1409 W GREEN ST",
    "dropphycty": "URBANA",
    "dropphyst": "IL",
    "dropphyzpp": 618019997,
    "dropmaladd": "1409 W GREEN ST",
    "dropmalcty": "URBANA",
    "dropmalst": "IL",
    "dropmalzpp": 618019997,
    "dropsitphn": 7085637318,
    "dropsitlph": "",
    "dropsitcph": 2173679890,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008687",
    "droptype": "D",
    "dropname": "VA HOSPITAL",
    "dropdeladd": "5000 W NATIONAL AVE",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532950001,
    "dropphyadd": "5000 W NATIONAL AVE",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532950001,
    "dropmaladd": "5000 W NATIONAL AVE",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532950001,
    "dropsitphn": 4142702120,
    "dropsitlph": 4143842000,
    "dropsitcph": 4143842000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008701",
    "droptype": "D",
    "dropname": "CARMEL VALLEY",
    "dropdeladd": "3880 VALLEY CENTRE DR STE 202",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921303310,
    "dropphyadd": "3880 VALLEY CENTRE DR STE 202",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921303310,
    "dropmaladd": "3880 VALLEY CENTRE DR STE 202",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921303310,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585090703,
    "dropsitcph": 8588249094,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008790",
    "droptype": "D",
    "dropname": "NASHVILLE MAIN OFFICE WINDOW",
    "dropdeladd": "525 ROYAL PKWY",
    "dropdelcty": "NASHVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 372299715,
    "dropphyadd": "525 ROYAL PKWY",
    "dropphycty": "NASHVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 372299715,
    "dropmaladd": "525 ROYAL PKWY",
    "dropmalcty": "NASHVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 372299715,
    "dropsitphn": 6158859336,
    "dropsitlph": 6158725749,
    "dropsitcph": 6158725749,
    "dropfax": 6158859136
  },
  {
    "dcode": "D",
    "dropkey": "S008835",
    "droptype": "D",
    "dropname": "WHITEHALL",
    "dropdeladd": "1 WHITEHALL ST FRNT 2",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100049992,
    "dropphyadd": "1 WHITEHALL ST FRNT 2",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100049992,
    "dropmaladd": "1 WHITEHALL ST FRNT 2",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100049992,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2123305151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008840",
    "droptype": "D",
    "dropname": "HANOVER",
    "dropdeladd": "1 HANOVER ST FL 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100059992,
    "dropphyadd": "1 HANOVER ST FL 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100059992,
    "dropmaladd": "1 HANOVER ST FL 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100059992,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2124253610,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008852",
    "droptype": "D",
    "dropname": "BATTERY PARK",
    "dropdeladd": "15 RECTOR ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100069992,
    "dropphyadd": "15 RECTOR ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100069992,
    "dropmaladd": "15 RECTOR ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100069992,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2123305151,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008886",
    "droptype": "D",
    "dropname": "MARION CENTER",
    "dropdeladd": "1301 ENTERPRISE WAY STE 32",
    "dropdelcty": "MARION",
    "dropdelst": "IL",
    "dropdelzpp": 629599997,
    "dropphyadd": "1301 ENTERPRISE WAY STE 32",
    "dropphycty": "MARION",
    "dropphyst": "IL",
    "dropphyzpp": 629599997,
    "dropmaladd": "1301 ENTERPRISE WAY STE 32",
    "dropmalcty": "MARION",
    "dropmalst": "IL",
    "dropmalzpp": 629599997,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 6189938052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008888",
    "droptype": "D",
    "dropname": "TWO HOUSTON CNTR",
    "dropdeladd": "909 FANNIN ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770101001,
    "dropphyadd": "909 FANNIN ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770101001,
    "dropmaladd": "909 FANNIN ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770101001,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137390616,
    "dropsitcph": 7136510112,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008962",
    "droptype": "D",
    "dropname": "DAISY MOUNTAIN",
    "dropdeladd": "44047 N 43RD AVE",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850879998,
    "dropphyadd": "44047 N 43RD AVE",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850879998,
    "dropmaladd": "44047 N 43RD AVE",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850879998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6235517952,
    "dropsitcph": 6235517950,
    "dropfax": 6235517955
  },
  {
    "dcode": "D",
    "dropkey": "S008965",
    "droptype": "D",
    "dropname": "26 FEDERAL PLAZA",
    "dropdeladd": "26 FEDERAL PLZ LBBY 1",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 102789991,
    "dropphyadd": "26 FEDERAL PLZ LBBY 1",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 102789991,
    "dropmaladd": "26 FEDERAL PLZ LBBY 1",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 102789991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305003,
    "dropsitcph": 2126082420,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S008969",
    "droptype": "D",
    "dropname": "PROV WINDOWS",
    "dropdeladd": "24 CORLISS ST RM 100",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029049710",
    "dropphyadd": "24 CORLISS ST RM 100",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029049710",
    "dropmaladd": "24 CORLISS ST RM 100",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029049710",
    "dropsitphn": 4017525649,
    "dropsitlph": "",
    "dropsitcph": 4012768618,
    "dropfax": 4012766868
  },
  {
    "dcode": "D",
    "dropkey": "S008986",
    "droptype": "D",
    "dropname": "NORTH BAY P&DC FINANCE",
    "dropdeladd": "1150 N MCDOWELL BLVD",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949999998,
    "dropphyadd": "1150 N MCDOWELL BLVD",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949999998,
    "dropmaladd": "1150 N MCDOWELL BLVD",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949999998,
    "dropsitphn": 7077695354,
    "dropsitlph": "",
    "dropsitcph": 7077785212,
    "dropfax": 7077785277
  },
  {
    "dcode": "D",
    "dropkey": "S008994",
    "droptype": "D",
    "dropname": "NORTHWOOD",
    "dropdeladd": "1 LEAGUE",
    "dropdelcty": "IRVINE",
    "dropdelst": "CA",
    "dropdelzpp": 926029998,
    "dropphyadd": "1 LEAGUE",
    "dropphycty": "IRVINE",
    "dropphyst": "CA",
    "dropphyzpp": 926029998,
    "dropmaladd": "1 LEAGUE",
    "dropmalcty": "IRVINE",
    "dropmalst": "CA",
    "dropmalzpp": 926029998,
    "dropsitphn": 7143683374,
    "dropsitlph": 7143684767,
    "dropsitcph": 7143683374,
    "dropfax": 7143687596
  },
  {
    "dcode": "D",
    "dropkey": "S009012",
    "droptype": "D",
    "dropname": "AMC DAYTON",
    "dropdeladd": "2275 D ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454339910,
    "dropphyadd": "2275 D ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454339910,
    "dropmaladd": "2275 D ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454339910,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372572938,
    "dropsitcph": 9372556001,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009033",
    "droptype": "D",
    "dropname": "TAMIAMI",
    "dropdeladd": "8880 SW 8TH ST",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331449998,
    "dropphyadd": "8880 SW 8TH ST",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331449998,
    "dropmaladd": "8880 SW 8TH ST",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331449998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055518783,
    "dropsitcph": 3055518783,
    "dropfax": 3055518738
  },
  {
    "dcode": "D",
    "dropkey": "S009050",
    "droptype": "D",
    "dropname": "NORTH BURLINGTON",
    "dropdeladd": "1127 NORTH AVE STE 40",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054089713",
    "dropphyadd": "1127 NORTH AVE STE 40",
    "dropphycty": "BURLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054089713",
    "dropmaladd": "1127 NORTH AVE STE 40",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054089713",
    "dropsitphn": 8022963232,
    "dropsitlph": 8028636033,
    "dropsitcph": 8026584503,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009114",
    "droptype": "D",
    "dropname": "ENCINO PARK",
    "dropdeladd": "20403 ENCINO LEDGE",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782599998,
    "dropphyadd": "20403 ENCINO LEDGE",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782599998,
    "dropmaladd": "20403 ENCINO LEDGE",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782599998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2104975068,
    "dropsitcph": 2104976391,
    "dropfax": 2104977358
  },
  {
    "dcode": "D",
    "dropkey": "S009167",
    "droptype": "D",
    "dropname": "MUNSTER",
    "dropdeladd": "917 RIDGE RD",
    "dropdelcty": "MUNSTER",
    "dropdelst": "IN",
    "dropdelzpp": 463219997,
    "dropphyadd": "917 RIDGE RD",
    "dropphycty": "MUNSTER",
    "dropphyst": "IN",
    "dropphyzpp": 463219997,
    "dropmaladd": "915 RIDGE RD BLDG 2",
    "dropmalcty": "MUNSTER",
    "dropmalst": "IN",
    "dropmalzpp": 463219998,
    "dropsitphn": 2198398005,
    "dropsitlph": "",
    "dropsitcph": 2198368005,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009177",
    "droptype": "D",
    "dropname": "FRANCES PERKINS",
    "dropdeladd": "200 CONSTITUTION AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 202100002,
    "dropphyadd": "200 CONSTITUTION AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 202100002,
    "dropmaladd": "200 CONSTITUTION AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 202100002,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2027209592,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009237",
    "droptype": "D",
    "dropname": "STOCKDALE",
    "dropdeladd": "5501 STOCKDALE HWY",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933092572,
    "dropphyadd": "5501 STOCKDALE HWY",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933092572,
    "dropmaladd": "5501 STOCKDALE HWY",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933092572,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618344158,
    "dropsitcph": 6618344158,
    "dropfax": 6615016040
  },
  {
    "dcode": "D",
    "dropkey": "S009427",
    "droptype": "D",
    "dropname": "FEDERAL",
    "dropdeladd": "754 CHAPEL ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065109992",
    "dropphyadd": "754 CHAPEL ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065109992",
    "dropmaladd": "754 CHAPEL ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065109992",
    "dropsitphn": 2037827007,
    "dropsitlph": "",
    "dropsitcph": 2037827007,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009430",
    "droptype": "D",
    "dropname": "SAINT ROBERT FINANCE",
    "dropdeladd": "194 EASTLAWN AVE STE B",
    "dropdelcty": "SAINT ROBERT",
    "dropdelst": "MO",
    "dropdelzpp": 655843758,
    "dropphyadd": "194 EASTLAWN AVE STE B",
    "dropphycty": "SAINT ROBERT",
    "dropphyst": "MO",
    "dropphyzpp": 655843758,
    "dropmaladd": "194 EASTLAWN AVE STE B",
    "dropmalcty": "SAINT ROBERT",
    "dropmalst": "MO",
    "dropmalzpp": 655843758,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733295909,
    "dropsitcph": 5733295909,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009436",
    "droptype": "D",
    "dropname": "DOWNTOWN JANESVILLE",
    "dropdeladd": "20 S MAIN ST STE 18",
    "dropdelcty": "JANESVILLE",
    "dropdelst": "WI",
    "dropdelzpp": 535453959,
    "dropphyadd": "20 S MAIN ST STE 18",
    "dropphycty": "JANESVILLE",
    "dropphyst": "WI",
    "dropphyzpp": 535453959,
    "dropmaladd": "20 S MAIN ST STE 18",
    "dropmalcty": "JANESVILLE",
    "dropmalst": "WI",
    "dropmalzpp": 535453959,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 6087544881,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S009464",
    "droptype": "D",
    "dropname": "NAVAL WEAPONS",
    "dropdeladd": "1725 RED BANK RD",
    "dropdelcty": "GOOSE CREEK",
    "dropdelst": "SC",
    "dropdelzpp": 294456583,
    "dropphyadd": "1725 RED BANK RD",
    "dropphycty": "GOOSE CREEK",
    "dropphyst": "SC",
    "dropphyzpp": 294456583,
    "dropmaladd": "1725 RED BANK RD",
    "dropmalcty": "GOOSE CREEK",
    "dropmalst": "SC",
    "dropmalzpp": 294456583,
    "dropsitphn": 8039266014,
    "dropsitlph": "",
    "dropsitcph": 8437647751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S010065",
    "droptype": "D",
    "dropname": "POE FLAMINGO",
    "dropdeladd": "10140 W FLAMINGO RD",
    "dropdelcty": "LAS VEGAS",
    "dropdelst": "NV",
    "dropdelzpp": 891478385,
    "dropphyadd": "10140 W FLAMINGO RD",
    "dropphycty": "LAS VEGAS",
    "dropphyst": "NV",
    "dropphyzpp": 891478385,
    "dropmaladd": "10140 W FLAMINGO RD",
    "dropmalcty": "LAS VEGAS",
    "dropmalst": "NV",
    "dropmalzpp": 891478385,
    "dropsitphn": 7023619453,
    "dropsitlph": 7023619457,
    "dropsitcph": 7028711175,
    "dropfax": 7022436604
  },
  {
    "dcode": "D",
    "dropkey": "S010267",
    "droptype": "D",
    "dropname": "SIOUX FLLS TMP MPO",
    "dropdeladd": "401 S 2ND AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571046903,
    "dropphyadd": "401 S 2ND AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571046903,
    "dropmaladd": "401 S 2ND AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571046903,
    "dropsitphn": 6053574932,
    "dropsitlph": 6053575021,
    "dropsitcph": 6053575021,
    "dropfax": 6053575022
  },
  {
    "dcode": "D",
    "dropkey": "S010388",
    "droptype": "D",
    "dropname": "DANVILLE SQUARE",
    "dropdeladd": "23 RAILROAD AVE",
    "dropdelcty": "DANVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 945263881,
    "dropphyadd": "23 RAILROAD AVE",
    "dropphycty": "DANVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 945263881,
    "dropmaladd": "2605 CAMINO TASSAJARA",
    "dropmalcty": "DANVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 945264400,
    "dropsitphn": 5104337569,
    "dropsitlph": 9258386919,
    "dropsitcph": 9253149650,
    "dropfax": 9253140943
  },
  {
    "dcode": "D",
    "dropkey": "S010593",
    "droptype": "D",
    "dropname": "PEABODY PLACE",
    "dropdeladd": "100 PEABODY PL STE 150",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381033687,
    "dropphyadd": "100 PEABODY PL STE 150",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381033687,
    "dropmaladd": "100 PEABODY PL STE 150",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381033687,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015750159,
    "dropsitcph": 9015750159,
    "dropfax": 9015752312
  },
  {
    "dcode": "D",
    "dropkey": "S010667",
    "droptype": "D",
    "dropname": "CITYGATE CALLER UNIT",
    "dropdeladd": "2323 CITYGATE DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432189710,
    "dropphyadd": "2323 CITYGATE DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432189710,
    "dropmaladd": "2323 CITYGATE DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432189710,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720713,
    "dropsitcph": 6144720713,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S010707",
    "droptype": "D",
    "dropname": "WEST PALM BCH WINDOW UNIT",
    "dropdeladd": "3200 SUMMIT BLVD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334163525,
    "dropphyadd": "3200 SUMMIT BLVD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334163525,
    "dropmaladd": "PO BOX 163522",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334163522,
    "dropsitphn": 5616972122,
    "dropsitlph": 5616972122,
    "dropsitcph": 5616972165,
    "dropfax": 5616971970
  },
  {
    "dcode": "D",
    "dropkey": "S010709",
    "droptype": "D",
    "dropname": "ORLANDO MOWU",
    "dropdeladd": "10401 POST OFFICE BLVD W FL 3",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328628543,
    "dropphyadd": "10401 POST OFFICE BLVD W FL 3",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328628543,
    "dropmaladd": "PO BOX 620084",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328620084,
    "dropsitphn": 4078265608,
    "dropsitlph": 4078265608,
    "dropsitcph": 4078506334,
    "dropfax": 4078505697
  },
  {
    "dcode": "D",
    "dropkey": "S010806",
    "droptype": "D",
    "dropname": "RODNEY SQ",
    "dropdeladd": "500 DELAWARE AVE STE 1",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198019998,
    "dropphyadd": "500 DELAWARE AVE STE 1",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198019998,
    "dropmaladd": "500 DELAWARE AVE STE 1",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198019998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026560228,
    "dropfax": 3027771525
  },
  {
    "dcode": "D",
    "dropkey": "S010947",
    "droptype": "D",
    "dropname": "COMMERCE",
    "dropdeladd": "401 N ASHLEY DR",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336024301,
    "dropphyadd": "401 N ASHLEY DR",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336024301,
    "dropmaladd": "401 N ASHLEY DR",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336024301,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132234225,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S010983",
    "droptype": "D",
    "dropname": "TEEL VILLAGE",
    "dropdeladd": "8811 TEEL PKWY STE 100",
    "dropdelcty": "FRISCO",
    "dropdelst": "TX",
    "dropdelzpp": 750369997,
    "dropphyadd": "8811 TEEL PKWY STE 100",
    "dropphycty": "FRISCO",
    "dropphyst": "TX",
    "dropphyzpp": 750369997,
    "dropmaladd": "8700 STONEBROOK PKWY",
    "dropmalcty": "FRISCO",
    "dropmalst": "TX",
    "dropmalzpp": 750349998,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723357453,
    "dropsitcph": 2143870779,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S010989",
    "droptype": "D",
    "dropname": "GEORGE MASON",
    "dropdeladd": "200 N WASHINGTON ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223209997,
    "dropphyadd": "200 N WASHINGTON ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223209997,
    "dropmaladd": "200 N WASHINGTON ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223209997,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035190386,
    "dropsitcph": 7035190386,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S010994",
    "droptype": "D",
    "dropname": "UNIVERSITY",
    "dropdeladd": "441 N LAKE ST",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537151029,
    "dropphyadd": "441 N LAKE ST",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537151029,
    "dropmaladd": "441 N LAKE ST",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537151029,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082506491,
    "dropsitcph": 6082501932,
    "dropfax": 6082512591
  },
  {
    "dcode": "D",
    "dropkey": "S011002",
    "droptype": "D",
    "dropname": "HILLTOP RETAIL STORE",
    "dropdeladd": "2873 W BROAD ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432049997,
    "dropphyadd": "2873 W BROAD ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432049997,
    "dropmaladd": "2873 W BROAD ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432049997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694268,
    "dropsitcph": 6143511710,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011204",
    "droptype": "D",
    "dropname": "SAN JOSE MO FINANCE",
    "dropdeladd": "1750 LUNDY AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951019713,
    "dropphyadd": "1750 LUNDY AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951019713,
    "dropmaladd": "1750 LUNDY AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951019713,
    "dropsitphn": 4084376726,
    "dropsitlph": 4087236102,
    "dropsitcph": 4084376690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011205",
    "droptype": "D",
    "dropname": "SALINAS MO FINANCE",
    "dropdeladd": "1011 POST DR",
    "dropdelcty": "SALINAS",
    "dropdelst": "CA",
    "dropdelzpp": 939078001,
    "dropphyadd": "1011 POST DR",
    "dropphycty": "SALINAS",
    "dropphyst": "CA",
    "dropphyzpp": 939078001,
    "dropmaladd": "1011 POST DR",
    "dropmalcty": "SALINAS",
    "dropmalst": "CA",
    "dropmalzpp": 939078001,
    "dropsitphn": 4084376726,
    "dropsitlph": 8317707141,
    "dropsitcph": 8317707141,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011314",
    "droptype": "D",
    "dropname": "DOWNTOWN MORGANTOWN",
    "dropdeladd": "40 HIGH ST STE 101",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265059998,
    "dropphyadd": "40 HIGH ST STE 101",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265059998,
    "dropmaladd": "40 HIGH ST STE 101",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265059998,
    "dropsitphn": 3042911036,
    "dropsitlph": 3042911036,
    "dropsitcph": 3042911036,
    "dropfax": 3042911038
  },
  {
    "dcode": "D",
    "dropkey": "S011362",
    "droptype": "D",
    "dropname": "VOLUNTEER",
    "dropdeladd": "1430 VOLUNTEER PKWY STE 32",
    "dropdelcty": "BRISTOL",
    "dropdelst": "TN",
    "dropdelzpp": 376209997,
    "dropphyadd": "1430 VOLUNTEER PKWY STE 32",
    "dropphycty": "BRISTOL",
    "dropphyst": "TN",
    "dropphyzpp": 376209997,
    "dropmaladd": "1430 VOLUNTEER PKWY STE 32",
    "dropmalcty": "BRISTOL",
    "dropmalst": "TN",
    "dropmalzpp": 376209997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858780,
    "dropsitcph": 4238440539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011466",
    "droptype": "D",
    "dropname": "NORTH WANTAGH",
    "dropdeladd": "1250 WANTAGH AVE",
    "dropdelcty": "WANTAGH",
    "dropdelst": "NY",
    "dropdelzpp": 117932217,
    "dropphyadd": "1250 WANTAGH AVE",
    "dropphycty": "WANTAGH",
    "dropphyst": "NY",
    "dropphyzpp": 117932217,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "WANTAGH",
    "dropmalst": "NY",
    "dropmalzpp": 117939996,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5162212647,
    "dropfax": 5167817822
  },
  {
    "dcode": "D",
    "dropkey": "S011638",
    "droptype": "D",
    "dropname": "FERRY TERMINAL",
    "dropdeladd": "3 FERRY TERMINAL DR",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103019992,
    "dropphyadd": "3 FERRY TERMINAL DR",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103019992,
    "dropmaladd": "3 FERRY TERMINAL DR",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103019992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183925687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011648",
    "droptype": "D",
    "dropname": "ZANE STREET",
    "dropdeladd": "1035 ZANE ST",
    "dropdelcty": "ZANESVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 437019996,
    "dropphyadd": "1035 ZANE ST",
    "dropphycty": "ZANESVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 437019996,
    "dropmaladd": "1035 ZANE ST",
    "dropmalcty": "ZANESVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 437019996,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404502356,
    "dropsitcph": 7404502356,
    "dropfax": 7404502356
  },
  {
    "dcode": "D",
    "dropkey": "S011649",
    "droptype": "D",
    "dropname": "REYNOLDSBURG",
    "dropdeladd": "7185 E MAIN ST",
    "dropdelcty": "REYNOLDSBURG",
    "dropdelst": "OH",
    "dropdelzpp": 430689997,
    "dropphyadd": "7185 E MAIN ST",
    "dropphycty": "REYNOLDSBURG",
    "dropphyst": "OH",
    "dropphyzpp": 430689997,
    "dropmaladd": "7185 E MAIN ST",
    "dropmalcty": "REYNOLDSBURG",
    "dropmalst": "OH",
    "dropmalzpp": 430689997,
    "dropsitphn": "",
    "dropsitlph": 6148666049,
    "dropsitcph": 6148666049,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011650",
    "droptype": "D",
    "dropname": "GROVE CITY RETAIL STORE",
    "dropdeladd": "2082 STRINGTOWN RD",
    "dropdelcty": "GROVE CITY",
    "dropdelst": "OH",
    "dropdelzpp": 431239997,
    "dropphyadd": "2082 STRINGTOWN RD",
    "dropphycty": "GROVE CITY",
    "dropphyst": "OH",
    "dropphyzpp": 431239997,
    "dropmaladd": "2082 STRINGTOWN RD",
    "dropmalcty": "GROVE CITY",
    "dropmalst": "OH",
    "dropmalzpp": 431239997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6145398919,
    "dropsitcph": 6145398919,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011755",
    "droptype": "D",
    "dropname": "SUBURBAN WINDOW SCV",
    "dropdeladd": "16501 SHADY GROVE RD",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208989954,
    "dropphyadd": "16501 SHADY GROVE RD",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208989954,
    "dropmaladd": "16501 SHADY GROVE RD",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208989954,
    "dropsitphn": 3014997331,
    "dropsitlph": 3016706085,
    "dropsitcph": 3016706085,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S011827",
    "droptype": "D",
    "dropname": "GREENVILLE",
    "dropdeladd": "2600 WESLEY ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "TX",
    "dropdelzpp": 754019994,
    "dropphyadd": "2600 WESLEY ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "TX",
    "dropphyzpp": 754019994,
    "dropmaladd": "2600 WESLEY ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "TX",
    "dropmalzpp": 754019994,
    "dropsitphn": 2144675879,
    "dropsitlph": 9034558487,
    "dropsitcph": 9034558487,
    "dropfax": 9034558610
  },
  {
    "dcode": "D",
    "dropkey": "S011853",
    "droptype": "D",
    "dropname": "KING OF PRUSSIA",
    "dropdeladd": "741 3RD AVE STE 1",
    "dropdelcty": "KING OF PRUSSIA",
    "dropdelst": "PA",
    "dropdelzpp": 194061409,
    "dropphyadd": "741 3RD AVE STE 1",
    "dropphycty": "KING OF PRUSSIA",
    "dropphyst": "PA",
    "dropphyzpp": 194061409,
    "dropmaladd": "741 3RD AVE STE 1",
    "dropmalcty": "KING OF PRUSSIA",
    "dropmalst": "PA",
    "dropmalzpp": 194061409,
    "dropsitphn": 6103379823,
    "dropsitlph": 6103379823,
    "dropsitcph": 6103379823,
    "dropfax": 6102652228
  },
  {
    "dcode": "D",
    "dropkey": "S012038",
    "droptype": "D",
    "dropname": "DELTA",
    "dropdeladd": "240 E CHANNEL ST",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952029998,
    "dropphyadd": "240 E CHANNEL ST",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952029998,
    "dropmaladd": "240 E CHANNEL ST",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952029998,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094622514,
    "dropsitcph": 2094622637,
    "dropfax": 2094622024
  },
  {
    "dcode": "D",
    "dropkey": "S012056",
    "droptype": "D",
    "dropname": "PANAMA CITY GMF  MY PO",
    "dropdeladd": "1336 SHERMAN AVE",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324019501,
    "dropphyadd": "1336 SHERMAN AVE",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324019501,
    "dropmaladd": "1336 SHERMAN AVE",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324019501,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507473901,
    "dropsitcph": 8507474890,
    "dropfax": 8507474814
  },
  {
    "dcode": "D",
    "dropkey": "S012075",
    "droptype": "D",
    "dropname": "TOA BAJA PUEBLO",
    "dropdeladd": "100 AVE LUIS MUNOZ RIVERA",
    "dropdelcty": "TOA BAJA",
    "dropdelst": "PR",
    "dropdelzpp": "009499997",
    "dropphyadd": "100 AVE LUIS MUNOZ RIVERA",
    "dropphycty": "TOA BAJA",
    "dropphyst": "PR",
    "dropphyzpp": "009499997",
    "dropmaladd": "100 AVE LUIS MUNOZ RIVERA",
    "dropmalcty": "TOA BAJA",
    "dropmalst": "PR",
    "dropmalzpp": "009499997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221931,
    "dropsitcph": 7877941705,
    "dropfax": 7877942825
  },
  {
    "dcode": "D",
    "dropkey": "S012101",
    "droptype": "D",
    "dropname": "LIBERTY",
    "dropdeladd": "22 HOOVER AVE STE 100",
    "dropdelcty": "DU BOIS",
    "dropdelst": "PA",
    "dropdelzpp": 158012428,
    "dropphyadd": "22 HOOVER AVE STE 100",
    "dropphycty": "DU BOIS",
    "dropphyst": "PA",
    "dropphyzpp": 158012428,
    "dropmaladd": "22 HOOVER AVE STE 100",
    "dropmalcty": "DU BOIS",
    "dropmalst": "PA",
    "dropmalzpp": 158012428,
    "dropsitphn": 8148367307,
    "dropsitlph": 8143711591,
    "dropsitcph": 8143711591,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012111",
    "droptype": "D",
    "dropname": "LA MESA FINANCE",
    "dropdeladd": "8064 ALLISON AVE",
    "dropdelcty": "LA MESA",
    "dropdelst": "CA",
    "dropdelzpp": 919429994,
    "dropphyadd": "8064 ALLISON AVE",
    "dropphycty": "LA MESA",
    "dropphyst": "CA",
    "dropphyzpp": 919429994,
    "dropmaladd": "8064 ALLISON AVE",
    "dropmalcty": "LA MESA",
    "dropmalst": "CA",
    "dropmalzpp": 919429994,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194630661,
    "dropsitcph": 6194604659,
    "dropfax": 6194631169
  },
  {
    "dcode": "D",
    "dropkey": "S012137",
    "droptype": "D",
    "dropname": "FLEMINGTON",
    "dropdeladd": "15 MAIN ST",
    "dropdelcty": "FLEMINGTON",
    "dropdelst": "NJ",
    "dropdelzpp": "088221412",
    "dropphyadd": "15 MAIN ST",
    "dropphycty": "FLEMINGTON",
    "dropphyst": "NJ",
    "dropphyzpp": "088221412",
    "dropmaladd": "15 MAIN ST",
    "dropmalcty": "FLEMINGTON",
    "dropmalst": "NJ",
    "dropmalzpp": "088221412",
    "dropsitphn": 7328193630,
    "dropsitlph": 7328193630,
    "dropsitcph": 9087822811,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012172",
    "droptype": "D",
    "dropname": "HUNTSVILLE",
    "dropdeladd": "3408 WALL TRIANA HWY",
    "dropdelcty": "HUNTSVILLE",
    "dropdelst": "AL",
    "dropdelzpp": 358139998,
    "dropphyadd": "3408 WALL TRIANA HWY",
    "dropphycty": "HUNTSVILLE",
    "dropphyst": "AL",
    "dropphyzpp": 358139998,
    "dropmaladd": "3408 WALL TRIANA HWY",
    "dropmalcty": "HUNTSVILLE",
    "dropmalst": "AL",
    "dropmalzpp": 358139998,
    "dropsitphn": 2567724691,
    "dropsitlph": 2567724691,
    "dropsitcph": 2567724691,
    "dropfax": 2564617885
  },
  {
    "dcode": "D",
    "dropkey": "S012196",
    "droptype": "D",
    "dropname": "SIOUX FALLS DOWNTOWN",
    "dropdeladd": "320 S 2ND AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571049834,
    "dropphyadd": "320 S 2ND AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571049834,
    "dropmaladd": "320 S 2ND AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571049834,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055753542,
    "dropsitcph": 6055753542,
    "dropfax": 6055753553
  },
  {
    "dcode": "D",
    "dropkey": "S012377",
    "droptype": "D",
    "dropname": "BACK BAY",
    "dropdeladd": "133 CLARENDON ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "021169998",
    "dropphyadd": "133 CLARENDON ST",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "021169998",
    "dropmaladd": "133 CLARENDON ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "021169998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6175875262,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012378",
    "droptype": "D",
    "dropname": "EAST AMHERST",
    "dropdeladd": "9630 TRANSIT RD STE 1000",
    "dropdelcty": "EAST AMHERST",
    "dropdelst": "NY",
    "dropdelzpp": 140519997,
    "dropphyadd": "9630 TRANSIT RD STE 1000",
    "dropphycty": "EAST AMHERST",
    "dropphyst": "NY",
    "dropphyzpp": 140519997,
    "dropmaladd": "9630 TRANSIT RD STE 1000",
    "dropmalcty": "EAST AMHERST",
    "dropmalst": "NY",
    "dropmalzpp": 140519997,
    "dropsitphn": 7168462415,
    "dropsitlph": 7166883071,
    "dropsitcph": 7166883071,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012403",
    "droptype": "D",
    "dropname": "EAST PASADENA",
    "dropdeladd": "3016 E COLORADO BLVD",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911073840,
    "dropphyadd": "3016 E COLORADO BLVD",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911073840,
    "dropmaladd": "3016 E COLORADO BLVD",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911073840,
    "dropsitphn": 6617757808,
    "dropsitlph": 6267955684,
    "dropsitcph": 6267955561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012535",
    "droptype": "D",
    "dropname": "MCNEIL",
    "dropdeladd": "10109 LAKE CREEK PKWY",
    "dropdelcty": "AUSTIN",
    "dropdelst": "TX",
    "dropdelzpp": 787291711,
    "dropphyadd": "10109 LAKE CREEK PKWY",
    "dropphycty": "AUSTIN",
    "dropphyst": "TX",
    "dropphyzpp": 787291711,
    "dropmaladd": "10109 LAKE CREEK PKWY",
    "dropmalcty": "AUSTIN",
    "dropmalst": "TX",
    "dropmalzpp": 787291711,
    "dropsitphn": 2103688387,
    "dropsitlph": 5122497308,
    "dropsitcph": 5122497307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012600",
    "droptype": "D",
    "dropname": "FALLS CHURCH FINANCE",
    "dropdeladd": "800 W BROAD ST STE 100",
    "dropdelcty": "FALLS CHURCH",
    "dropdelst": "VA",
    "dropdelzpp": 220463199,
    "dropphyadd": "800 W BROAD ST STE 100",
    "dropphycty": "FALLS CHURCH",
    "dropphyst": "VA",
    "dropphyzpp": 220463199,
    "dropmaladd": "800 W BROAD ST STE 100",
    "dropmalcty": "FALLS CHURCH",
    "dropmalst": "VA",
    "dropmalzpp": 220463199,
    "dropsitphn": 7036986367,
    "dropsitlph": 7032370872,
    "dropsitcph": 7032370872,
    "dropfax": 7032370875
  },
  {
    "dcode": "D",
    "dropkey": "S012759",
    "droptype": "D",
    "dropname": "DENBIGH",
    "dropdeladd": "14104 WARWICK BLVD",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236029998,
    "dropphyadd": "14104 WARWICK BLVD",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236029998,
    "dropmaladd": "14104 WARWICK BLVD",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236029998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7578771704,
    "dropsitcph": 7578771704,
    "dropfax": 7578771606
  },
  {
    "dcode": "D",
    "dropkey": "S012778",
    "droptype": "D",
    "dropname": "WICKER PARK RETAIL STORE",
    "dropdeladd": "1300 N ASHLAND AVE FRNT 100",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606222268,
    "dropphyadd": "1300 N ASHLAND AVE FRNT 100",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606222268,
    "dropmaladd": "1419 W CARROLL AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606071105,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737724734,
    "dropfax": 7737724647
  },
  {
    "dcode": "D",
    "dropkey": "S012857",
    "droptype": "D",
    "dropname": "MAIN OFFICE WINDOWS",
    "dropdeladd": "1135 BROADWAY BLVD NE STE 180",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871019700,
    "dropphyadd": "1135 BROADWAY BLVD NE STE 180",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871019700,
    "dropmaladd": "1135 BROADWAY BLVD NE STE 180",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871019700,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468053,
    "dropsitcph": 5053468053,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S012882",
    "droptype": "D",
    "dropname": "VAL VISTA",
    "dropdeladd": "225 S VAL VISTA DR",
    "dropdelcty": "GILBERT",
    "dropdelst": "AZ",
    "dropdelzpp": 852969998,
    "dropphyadd": "225 S VAL VISTA DR",
    "dropphycty": "GILBERT",
    "dropphyst": "AZ",
    "dropphyzpp": 852969998,
    "dropmaladd": "225 S VAL VISTA DR",
    "dropmalcty": "GILBERT",
    "dropmalst": "AZ",
    "dropmalzpp": 852969998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809267538,
    "dropsitcph": 4809267595,
    "dropfax": 4808923423
  },
  {
    "dcode": "D",
    "dropkey": "S013096",
    "droptype": "D",
    "dropname": "HRCOE",
    "dropdeladd": "1556 SPEARHEAD DIVISION AVE",
    "dropdelcty": "FORT KNOX",
    "dropdelst": "KY",
    "dropdelzpp": 401215741,
    "dropphyadd": "1556 SPEARHEAD DIVISION AVE",
    "dropphycty": "FORT KNOX",
    "dropphyst": "KY",
    "dropphyzpp": 401215741,
    "dropmaladd": "1556 SPEARHEAD DIVISION AVE",
    "dropmalcty": "FORT KNOX",
    "dropmalst": "KY",
    "dropmalzpp": 401215741,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5029421244,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S013151",
    "droptype": "D",
    "dropname": "METRO",
    "dropdeladd": "920 MORGAN ST STE C",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503094533,
    "dropphyadd": "920 MORGAN ST STE C",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503094533,
    "dropmaladd": "920 MORGAN ST STE C",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503094533,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152430816,
    "dropsitcph": 5152883508,
    "dropfax": 5152886256
  },
  {
    "dcode": "D",
    "dropkey": "S013160",
    "droptype": "D",
    "dropname": "MOU #1 NAVY HOSPITAL",
    "dropdeladd": "1 FARENHOLT AVE BLDG 1",
    "dropdelcty": "TAMUNING",
    "dropdelst": "GU",
    "dropdelzpp": 969133106,
    "dropphyadd": "1 FARENHOLT AVE BLDG 1",
    "dropphycty": "TAMUNING",
    "dropphyst": "GU",
    "dropphyzpp": 969133106,
    "dropmaladd": "489 ARMY DR",
    "dropmalcty": "BARRIGADA",
    "dropmalst": "GU",
    "dropmalzpp": 969139998,
    "dropsitphn": 6717343921,
    "dropsitlph": 6717343921,
    "dropsitcph": 6717346921,
    "dropfax": 7057343925
  },
  {
    "dcode": "D",
    "dropkey": "S013177",
    "droptype": "D",
    "dropname": "DOWNTOWN CONWAY",
    "dropdeladd": "1111 MAIN ST STE 107",
    "dropdelcty": "CONWAY",
    "dropdelst": "AR",
    "dropdelzpp": 720325410,
    "dropphyadd": "1111 MAIN ST STE 107",
    "dropphycty": "CONWAY",
    "dropphyst": "AR",
    "dropphyzpp": 720325410,
    "dropmaladd": "1111 MAIN ST STE 107",
    "dropmalcty": "CONWAY",
    "dropmalst": "AR",
    "dropmalzpp": 720325410,
    "dropsitphn": 5017300351,
    "dropsitlph": 5013277242,
    "dropsitcph": 5013277242,
    "dropfax": 5014507816
  },
  {
    "dcode": "D",
    "dropkey": "S013190",
    "droptype": "D",
    "dropname": "MOCKINGBIRD FINANCE",
    "dropdeladd": "4740 W MOCKINGBIRD LN STE C",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752099997,
    "dropphyadd": "4740 W MOCKINGBIRD LN STE C",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752099997,
    "dropmaladd": "2825 OAK LAWN AVE",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752199998,
    "dropsitphn": 2147604376,
    "dropsitlph": 2143532752,
    "dropsitcph": 2143532752,
    "dropfax": 2147604377
  },
  {
    "dcode": "D",
    "dropkey": "S013306",
    "droptype": "D",
    "dropname": "SOLON",
    "dropdeladd": "33333 STATION ST",
    "dropdelcty": "SOLON",
    "dropdelst": "OH",
    "dropdelzpp": 441399998,
    "dropphyadd": "33333 STATION ST",
    "dropphycty": "SOLON",
    "dropphyst": "OH",
    "dropphyzpp": 441399998,
    "dropmaladd": "33333 STATION ST",
    "dropmalcty": "SOLON",
    "dropmalst": "OH",
    "dropmalzpp": 441399998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4403492365,
    "dropfax": 4403941097
  },
  {
    "dcode": "D",
    "dropkey": "S013344",
    "droptype": "D",
    "dropname": "CENTRAL CITY",
    "dropdeladd": "400 PRYOR ST SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303039998,
    "dropphyadd": "400 PRYOR ST SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303039998,
    "dropmaladd": "400 PRYOR ST SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303039998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4042228371,
    "dropsitcph": 4042220765,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S013418",
    "droptype": "D",
    "dropname": "WALDO",
    "dropdeladd": "119 W GREGORY BLVD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641141142,
    "dropphyadd": "119 W GREGORY BLVD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641141142,
    "dropmaladd": "119 W GREGORY BLVD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641141142,
    "dropsitphn": 8163749109,
    "dropsitlph": 8163610010,
    "dropsitcph": 8163610132,
    "dropfax": 8164487052
  },
  {
    "dcode": "D",
    "dropkey": "S013427",
    "droptype": "D",
    "dropname": "MILPAS",
    "dropdeladd": "107 NOPALITOS WAY",
    "dropdelcty": "SANTA BARBARA",
    "dropdelst": "CA",
    "dropdelzpp": 931033628,
    "dropphyadd": "107 NOPALITOS WAY",
    "dropphycty": "SANTA BARBARA",
    "dropphyst": "CA",
    "dropphyzpp": 931033628,
    "dropmaladd": "107 NOPALITOS WAY",
    "dropmalcty": "SANTA BARBARA",
    "dropmalst": "CA",
    "dropmalzpp": 931033628,
    "dropsitphn": 6617757808,
    "dropsitlph": 8058994261,
    "dropsitcph": 8058991792,
    "dropfax": 8058992615
  },
  {
    "dcode": "D",
    "dropkey": "S013613",
    "droptype": "D",
    "dropname": "PAINE FIELD",
    "dropdeladd": "2201 100TH ST SW",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982049998,
    "dropphyadd": "2201 100TH ST SW",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982049998,
    "dropmaladd": "2201 100TH ST SW",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982049998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4252651339,
    "dropsitcph": 4255148063,
    "dropfax": 4255132799
  },
  {
    "dcode": "D",
    "dropkey": "S013967",
    "droptype": "D",
    "dropname": "EADS FINANCE",
    "dropdeladd": "1301 S FERN ST",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222024742,
    "dropphyadd": "1301 S FERN ST",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222024742,
    "dropmaladd": "1301 S FERN ST",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222024742,
    "dropsitphn": 7036986367,
    "dropsitlph": 7038920840,
    "dropsitcph": 7038920840,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014068",
    "droptype": "D",
    "dropname": "NORTH ATLANTA",
    "dropdeladd": "1920 DRESDEN DR NE",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "GA",
    "dropdelzpp": 303199998,
    "dropphyadd": "1920 DRESDEN DR NE",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "GA",
    "dropphyzpp": 303199998,
    "dropmaladd": "1920 DRESDEN DR NE",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "GA",
    "dropmalzpp": 303199998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4709035374,
    "dropsitcph": 4046344650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014380",
    "droptype": "D",
    "dropname": "WEST LEBANON",
    "dropdeladd": "66 BENNING ST STE 10",
    "dropdelcty": "WEST LEBANON",
    "dropdelst": "NH",
    "dropdelzpp": "037849998",
    "dropphyadd": "66 BENNING ST STE 10",
    "dropphycty": "WEST LEBANON",
    "dropphyst": "NH",
    "dropphyzpp": "037849998",
    "dropmaladd": "66 BENNING ST STE 10",
    "dropmalcty": "WEST LEBANON",
    "dropmalst": "NH",
    "dropmalzpp": "037849998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032988440,
    "dropfax": 6036503202
  },
  {
    "dcode": "D",
    "dropkey": "S014472",
    "droptype": "D",
    "dropname": "WESTSIDE OLYMPIA",
    "dropdeladd": "400 COOPER POINT RD SW STE 27",
    "dropdelcty": "OLYMPIA",
    "dropdelst": "WA",
    "dropdelzpp": 985020001,
    "dropphyadd": "400 COOPER POINT RD SW STE 27",
    "dropphycty": "OLYMPIA",
    "dropphyst": "WA",
    "dropphyzpp": 985020001,
    "dropmaladd": "400 COOPER POINT RD SW STE 27",
    "dropmalcty": "OLYMPIA",
    "dropmalst": "WA",
    "dropmalzpp": 985020001,
    "dropsitphn": 2067684422,
    "dropsitlph": 3609567088,
    "dropsitcph": 3605706300,
    "dropfax": 3605706340
  },
  {
    "dcode": "D",
    "dropkey": "S014530",
    "droptype": "D",
    "dropname": "LORAIN COLORADO AVE",
    "dropdeladd": "3190 COLORADO AVE",
    "dropdelcty": "LORAIN",
    "dropdelst": "OH",
    "dropdelzpp": 440529998,
    "dropphyadd": "3190 COLORADO AVE",
    "dropphycty": "LORAIN",
    "dropphyst": "OH",
    "dropphyzpp": 440529998,
    "dropmaladd": "3190 COLORADO AVE",
    "dropmalcty": "LORAIN",
    "dropmalst": "OH",
    "dropmalzpp": 440529998,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 4402888593,
    "dropfax": 4404346026
  },
  {
    "dcode": "D",
    "dropkey": "S014556",
    "droptype": "D",
    "dropname": "BRYANT STREET",
    "dropdeladd": "1600 BRYANT ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941419991,
    "dropphyadd": "1600 BRYANT ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941419991,
    "dropmaladd": "1600 BRYANT ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941419991,
    "dropsitphn": 4155505045,
    "dropsitlph": 4154313826,
    "dropsitcph": 4154313826,
    "dropfax": 4156210539
  },
  {
    "dcode": "D",
    "dropkey": "S014792",
    "droptype": "D",
    "dropname": "EAST SIDE",
    "dropdeladd": "1501 E FLEMING AVE",
    "dropdelcty": "DES MOINES",
    "dropdelst": "IA",
    "dropdelzpp": 503133933,
    "dropphyadd": "1501 E FLEMING AVE",
    "dropphycty": "DES MOINES",
    "dropphyst": "IA",
    "dropphyzpp": 503133933,
    "dropmaladd": "1501 E FLEMING AVE",
    "dropmalcty": "DES MOINES",
    "dropmalst": "IA",
    "dropmalzpp": 503133933,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152999130,
    "dropsitcph": 5152992399,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014812",
    "droptype": "D",
    "dropname": "OLNEY RETAIL",
    "dropdeladd": "101 E OLNEY AVE UNIT 330",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191209996,
    "dropphyadd": "101 E OLNEY AVE UNIT 330",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191209996,
    "dropmaladd": "101 E OLNEY AVE UNIT 330",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191209996,
    "dropsitphn": 2153242275,
    "dropsitlph": 2159248829,
    "dropsitcph": 2159248829,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014817",
    "droptype": "D",
    "dropname": "STATE UNIVERSITY",
    "dropdeladd": "105 N CARAWAY",
    "dropdelcty": "STATE UNIVERSITY",
    "dropdelst": "AR",
    "dropdelzpp": 724678801,
    "dropphyadd": "105 N CARAWAY",
    "dropphycty": "STATE UNIVERSITY",
    "dropphyst": "AR",
    "dropphyzpp": 724678801,
    "dropmaladd": "105 N CARAWAY",
    "dropmalcty": "STATE UNIVERSITY",
    "dropmalst": "AR",
    "dropmalzpp": 724678801,
    "dropsitphn": 8709328929,
    "dropsitlph": 8709327192,
    "dropsitcph": 8709327192,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014873",
    "droptype": "D",
    "dropname": "PECK SLIP",
    "dropdeladd": "114 JOHN ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100389991,
    "dropphyadd": "114 JOHN ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100389991,
    "dropmaladd": "114 JOHN ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100389991,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2123305013,
    "dropfax": 2129450494
  },
  {
    "dcode": "D",
    "dropkey": "S014890",
    "droptype": "D",
    "dropname": "DOWNTOWN GREENWICH",
    "dropdeladd": "44 AMOGERONE CROSSWAY",
    "dropdelcty": "GREENWICH",
    "dropdelst": "CT",
    "dropdelzpp": "068309993",
    "dropphyadd": "44 AMOGERONE CROSSWAY",
    "dropphycty": "GREENWICH",
    "dropphyst": "CT",
    "dropphyzpp": "068309993",
    "dropmaladd": "44 AMOGERONE CROSSWAY",
    "dropmalcty": "GREENWICH",
    "dropmalst": "CT",
    "dropmalzpp": "068309993",
    "dropsitphn": 2038693737,
    "dropsitlph": "",
    "dropsitcph": 2038693737,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014905",
    "droptype": "D",
    "dropname": "MARTIN LUTHER KING JR",
    "dropdeladd": "701 N KELLEY AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731179998,
    "dropphyadd": "701 N KELLEY AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731179998,
    "dropmaladd": "701 N KELLEY AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731179998,
    "dropsitphn": 4052360534,
    "dropsitlph": 4052360534,
    "dropsitcph": 4052360534,
    "dropfax": 4052321462
  },
  {
    "dcode": "D",
    "dropkey": "S014906",
    "droptype": "D",
    "dropname": "NORTHBROOK",
    "dropdeladd": "1529 W DUPONT RD",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468259998,
    "dropphyadd": "1529 W DUPONT RD",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468259998,
    "dropmaladd": "1529 W DUPONT RD",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468259998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604510139,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S014985",
    "droptype": "D",
    "dropname": "ELGIN WEST SIDE",
    "dropdeladd": "202 S RANDALL RD UNIT B",
    "dropdelcty": "ELGIN",
    "dropdelst": "IL",
    "dropdelzpp": 601235511,
    "dropphyadd": "202 S RANDALL RD UNIT B",
    "dropphycty": "ELGIN",
    "dropphyst": "IL",
    "dropphyzpp": 601235511,
    "dropmaladd": "202 S RANDALL RD UNIT B",
    "dropmalcty": "ELGIN",
    "dropmalst": "IL",
    "dropmalzpp": 601235511,
    "dropsitphn": 6302605499,
    "dropsitlph": 8477410725,
    "dropsitcph": 8477410725,
    "dropfax": 8477411959
  },
  {
    "dcode": "D",
    "dropkey": "S015025",
    "droptype": "D",
    "dropname": "WEST HOLLYWOOD HILLS",
    "dropdeladd": "5771 JOHNSON ST",
    "dropdelcty": "HOLLYWOOD",
    "dropdelst": "FL",
    "dropdelzpp": 330219996,
    "dropphyadd": "5771 JOHNSON ST",
    "dropphycty": "HOLLYWOOD",
    "dropphyst": "FL",
    "dropphyzpp": 330219996,
    "dropmaladd": "5771 JOHNSON ST",
    "dropmalcty": "HOLLYWOOD",
    "dropmalst": "FL",
    "dropmalzpp": 330219996,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549872458,
    "dropsitcph": 9549879745,
    "dropfax": 9549624541
  },
  {
    "dcode": "D",
    "dropkey": "S015075",
    "droptype": "D",
    "dropname": "14TH STREET",
    "dropdeladd": "2000 14TH ST NW STE 104",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200099993,
    "dropphyadd": "2000 14TH ST NW STE 104",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200099993,
    "dropmaladd": "2000 14TH ST NW STE 104",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200099993,
    "dropsitphn": 3014997331,
    "dropsitlph": 2022326301,
    "dropsitcph": 2026361259,
    "dropfax": 2029860485
  },
  {
    "dcode": "D",
    "dropkey": "S015103",
    "droptype": "D",
    "dropname": "CROSSTOWN",
    "dropdeladd": "1325 AUTUMN AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381049998,
    "dropphyadd": "1325 AUTUMN AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381049998,
    "dropmaladd": "1325 AUTUMN AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381049998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017254575,
    "dropsitcph": 9012789998,
    "dropfax": 9017269475
  },
  {
    "dcode": "D",
    "dropkey": "S015145",
    "droptype": "D",
    "dropname": "AVENT FERRY RALEIGH",
    "dropdeladd": "2100 LAKE DAM RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276069981,
    "dropphyadd": "2100 LAKE DAM RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276069981,
    "dropmaladd": "2100 LAKE DAM RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276069981,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197430663,
    "dropfax": 9198390655
  },
  {
    "dcode": "D",
    "dropkey": "S015146",
    "droptype": "D",
    "dropname": "NORTH NATOMAS",
    "dropdeladd": "4401 GATEWAY PARK BLVD STE 130",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958349998,
    "dropphyadd": "4401 GATEWAY PARK BLVD STE 130",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958349998,
    "dropmaladd": "4401 GATEWAY PARK BLVD STE 130",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958349998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9164198994,
    "dropsitcph": 9164198994,
    "dropfax": 9164198984
  },
  {
    "dcode": "D",
    "dropkey": "S015173",
    "droptype": "D",
    "dropname": "METRO",
    "dropdeladd": "116 W MAIN ST",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146141119,
    "dropphyadd": "116 W MAIN ST",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146141119,
    "dropmaladd": "116 W MAIN ST",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146141119,
    "dropsitphn": 5855462664,
    "dropsitlph": 5855462664,
    "dropsitcph": 5855462664,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015255",
    "droptype": "D",
    "dropname": "SUN CITY FINANCE",
    "dropdeladd": "26822 CHERRY HILLS BLVD",
    "dropdelcty": "MENIFEE",
    "dropdelst": "CA",
    "dropdelzpp": 925869998,
    "dropphyadd": "26822 CHERRY HILLS BLVD",
    "dropphycty": "MENIFEE",
    "dropphyst": "CA",
    "dropphyzpp": 925869998,
    "dropmaladd": "26822 CHERRY HILLS BLVD",
    "dropmalcty": "MENIFEE",
    "dropmalst": "CA",
    "dropmalzpp": 925869998,
    "dropsitphn": 9513354694,
    "dropsitlph": 9516723238,
    "dropsitcph": 9516797886,
    "dropfax": 9513010397
  },
  {
    "dcode": "D",
    "dropkey": "S015301",
    "droptype": "D",
    "dropname": "DOWNTOWN RENO",
    "dropdeladd": "135 N SIERRA ST STE A1",
    "dropdelcty": "RENO",
    "dropdelst": "NV",
    "dropdelzpp": 895011377,
    "dropphyadd": "135 N SIERRA ST STE A1",
    "dropphycty": "RENO",
    "dropphyst": "NV",
    "dropphyzpp": 895011377,
    "dropmaladd": "135 N SIERRA ST STE A1",
    "dropmalcty": "RENO",
    "dropmalst": "NV",
    "dropmalzpp": 895011377,
    "dropsitphn": 7023619453,
    "dropsitlph": 7757865936,
    "dropsitcph": 7753222029,
    "dropfax": 7753222037
  },
  {
    "dcode": "D",
    "dropkey": "S015306",
    "droptype": "D",
    "dropname": "WATERFRONT",
    "dropdeladd": "101 SW MADISON ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972043264,
    "dropphyadd": "101 SW MADISON ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972043264,
    "dropmaladd": "101 SW MADISON ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972049998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032275697,
    "dropsitcph": 5032275697,
    "dropfax": 5032749436
  },
  {
    "dcode": "D",
    "dropkey": "S015314",
    "droptype": "D",
    "dropname": "WASHINGTON BRIDGE",
    "dropdeladd": "518 W 181ST ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100339997,
    "dropphyadd": "518 W 181ST ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100339997,
    "dropmaladd": "518 W 181ST ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100339997,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2125432713,
    "dropfax": 2125431024
  },
  {
    "dcode": "D",
    "dropkey": "S015364",
    "droptype": "D",
    "dropname": "BULLS HEAD",
    "dropdeladd": "19 HIGH RIDGE RD",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069059991",
    "dropphyadd": "19 HIGH RIDGE RD",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069059991",
    "dropmaladd": "19 HIGH RIDGE RD",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069059991",
    "dropsitphn": 2033484066,
    "dropsitlph": 2033484066,
    "dropsitcph": 2033213910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015678",
    "droptype": "D",
    "dropname": "SAN XAVIER",
    "dropdeladd": "4700 W VALENCIA RD",
    "dropdelcty": "TUCSON",
    "dropdelst": "AZ",
    "dropdelzpp": 857579998,
    "dropphyadd": "4700 W VALENCIA RD",
    "dropphycty": "TUCSON",
    "dropphyst": "AZ",
    "dropphyzpp": 857579998,
    "dropmaladd": "4700 W VALENCIA RD",
    "dropmalcty": "TUCSON",
    "dropmalst": "AZ",
    "dropmalzpp": 857579998,
    "dropsitphn": 5203885019,
    "dropsitlph": 5208833236,
    "dropsitcph": 5208833139,
    "dropfax": 5203883614
  },
  {
    "dcode": "D",
    "dropkey": "S015712",
    "droptype": "D",
    "dropname": "CIVIC CENTER VAN NUYS",
    "dropdeladd": "6531 VAN NUYS BLVD",
    "dropdelcty": "VAN NUYS",
    "dropdelst": "CA",
    "dropdelzpp": 914019998,
    "dropphyadd": "6531 VAN NUYS BLVD",
    "dropphycty": "VAN NUYS",
    "dropphyst": "CA",
    "dropphyzpp": 914019998,
    "dropmaladd": "6531 VAN NUYS BLVD",
    "dropmalcty": "VAN NUYS",
    "dropmalst": "CA",
    "dropmalzpp": 914019998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183745680,
    "dropsitcph": 8187861232,
    "dropfax": 8183745603
  },
  {
    "dcode": "D",
    "dropkey": "S015713",
    "droptype": "D",
    "dropname": "MIDLAKES",
    "dropdeladd": "12400 SE 38TH ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "WA",
    "dropdelzpp": 980069899,
    "dropphyadd": "12400 SE 38TH ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "WA",
    "dropphyzpp": 980069899,
    "dropmaladd": "12400 SE 38TH ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "WA",
    "dropmalzpp": 980069899,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254542789,
    "dropsitcph": 4257474539,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015745",
    "droptype": "D",
    "dropname": "DOWNTOWN YORK",
    "dropdeladd": "160 W MARKET ST",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174011313,
    "dropphyadd": "160 W MARKET ST",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174011313,
    "dropmaladd": "160 W MARKET ST",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174011313,
    "dropsitphn": 7173968782,
    "dropsitlph": "",
    "dropsitcph": 7177514617,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015756",
    "droptype": "D",
    "dropname": "GREELEY SQUARE",
    "dropdeladd": "4 E 27TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100019994,
    "dropphyadd": "4 E 27TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100019994,
    "dropmaladd": "421 8TH AVE",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100019998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2126832510,
    "dropsitcph": 2126832510,
    "dropfax": 2126832475
  },
  {
    "dcode": "D",
    "dropkey": "S015782",
    "droptype": "D",
    "dropname": "CAMP GEIGER",
    "dropdeladd": "1003 A ST",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285420044,
    "dropphyadd": "1003 A ST",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285420044,
    "dropmaladd": "1003 A ST",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285420044,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105775570,
    "dropsitcph": 9105775570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015783",
    "droptype": "D",
    "dropname": "D STREET MILITARY PO",
    "dropdeladd": "222 D ST",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285420045,
    "dropphyadd": "222 D ST",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285420045,
    "dropmaladd": "222 D ST",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285420045,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 9104511715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015784",
    "droptype": "D",
    "dropname": "COURTHOUSE BAY",
    "dropdeladd": "54 POE RD",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285420046,
    "dropphyadd": "54 POE RD",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285420046,
    "dropmaladd": "54 POE RD",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285420046,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 9104511715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015786",
    "droptype": "D",
    "dropname": "FRENCH CREEK",
    "dropdeladd": "CPU-MAIL FRENCH CRK BLDG FC-312",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285420011,
    "dropphyadd": "CPU-MAIL FRENCH CRK BLDG FC-312",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285420011,
    "dropmaladd": "CPU-MAIL FRENCH CRK BLDG FC-312",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285420011,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 9104511715,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015787",
    "droptype": "D",
    "dropname": "CAMP JOHNSON",
    "dropdeladd": "129 MONTFORD LANDING RD",
    "dropdelcty": "CAMP LEJEUNE",
    "dropdelst": "NC",
    "dropdelzpp": 285420043,
    "dropphyadd": "129 MONTFORD LANDING RD",
    "dropphycty": "CAMP LEJEUNE",
    "dropphyst": "NC",
    "dropphyzpp": 285420043,
    "dropmaladd": "129 MONTFORD LANDING RD",
    "dropmalcty": "CAMP LEJEUNE",
    "dropmalst": "NC",
    "dropmalzpp": 285420043,
    "dropsitphn": 7043934581,
    "dropsitlph": 9105775570,
    "dropsitcph": 9105775570,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015788",
    "droptype": "D",
    "dropname": "FORT BRAGG MACOMB",
    "dropdeladd": "1256 MACOMB ST BLDG 2",
    "dropdelcty": "FORT BRAGG",
    "dropdelst": "NC",
    "dropdelzpp": 283108869,
    "dropphyadd": "1256 MACOMB ST BLDG 2",
    "dropphycty": "FORT BRAGG",
    "dropphyst": "NC",
    "dropphyzpp": 283108869,
    "dropmaladd": "1256 MACOMB ST BLDG 2",
    "dropmalcty": "FORT BRAGG",
    "dropmalst": "NC",
    "dropmalzpp": 283108869,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 9104232309,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S015886",
    "droptype": "D",
    "dropname": "MCBH MILITARY PO",
    "dropdeladd": "6644 MOKAPU BLVD STE 100",
    "dropdelcty": "MCBH KANEOHE BAY",
    "dropdelst": "HI",
    "dropdelzpp": 968635096,
    "dropphyadd": "6644 MOKAPU BLVD STE 100",
    "dropphycty": "MCBH KANEOHE BAY",
    "dropphyst": "HI",
    "dropphyzpp": 968635096,
    "dropmaladd": "335 HAHANI ST",
    "dropmalcty": "KAILUA",
    "dropmalst": "HI",
    "dropmalzpp": 967349998,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 8082572008,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016200",
    "droptype": "D",
    "dropname": "TRADE CENTER FINANCE UNIT",
    "dropdeladd": "368 S PICKETT ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223049996,
    "dropphyadd": "368 S PICKETT ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223049996,
    "dropmaladd": "368 S PICKETT ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223049996,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039711003,
    "dropsitcph": 7039711003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016373",
    "droptype": "D",
    "dropname": "DIVISION STREET STATION",
    "dropdeladd": "826 DIVISION ST",
    "dropdelcty": "BIG RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 493072230,
    "dropphyadd": "826 DIVISION ST",
    "dropphycty": "BIG RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 493072230,
    "dropmaladd": "826 DIVISION ST",
    "dropmalcty": "BIG RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 493072230,
    "dropsitphn": 6169771064,
    "dropsitlph": 2317966433,
    "dropsitcph": 2315921498,
    "dropfax": 2315928051
  },
  {
    "dcode": "D",
    "dropkey": "S016425",
    "droptype": "D",
    "dropname": "WICKER PK RETAIL STORE NEW",
    "dropdeladd": "1240 N ASHLAND AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606222257,
    "dropphyadd": "1240 N ASHLAND AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606222257,
    "dropmaladd": "1419 W CARROLL AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606071105,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7737724734,
    "dropfax": 7737724647
  },
  {
    "dcode": "D",
    "dropkey": "S016521",
    "droptype": "D",
    "dropname": "PETER STUYVESANT",
    "dropdeladd": "335 E 14TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100099997,
    "dropphyadd": "335 E 14TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100099997,
    "dropmaladd": "149 E 23RD ST STE 201",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100109995,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122288413,
    "dropsitcph": 2122288413,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016574",
    "droptype": "D",
    "dropname": "DOWNTOWN PLAZA",
    "dropdeladd": "660 J ST STE 170",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958149996,
    "dropphyadd": "660 J ST STE 170",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958149996,
    "dropmaladd": "660 J ST STE 170",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958149996,
    "dropsitphn": 9163738025,
    "dropsitlph": 9164986225,
    "dropsitcph": 9164989145,
    "dropfax": 9164986225
  },
  {
    "dcode": "D",
    "dropkey": "S016601",
    "droptype": "D",
    "dropname": "BADLANDS POSTAL STORE",
    "dropdeladd": "4315 9TH AVE W UNIT 411",
    "dropdelcty": "WILLISTON",
    "dropdelst": "ND",
    "dropdelzpp": 588018003,
    "dropphyadd": "4315 9TH AVE W UNIT 411",
    "dropphycty": "WILLISTON",
    "dropphyst": "ND",
    "dropphyzpp": 588018003,
    "dropmaladd": "4315 9TH AVE W UNIT 411",
    "dropmalcty": "WILLISTON",
    "dropmalst": "ND",
    "dropmalzpp": 588018003,
    "dropsitphn": 6053574932,
    "dropsitlph": 7015722408,
    "dropsitcph": 7015723657,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016639",
    "droptype": "D",
    "dropname": "WOODLAND CENTER POSTAL STORE",
    "dropdeladd": "1310 N GREEN RIVER RD",
    "dropdelcty": "EVANSVILLE",
    "dropdelst": "IN",
    "dropdelzpp": 477152427,
    "dropphyadd": "1310 N GREEN RIVER RD",
    "dropphycty": "EVANSVILLE",
    "dropphyst": "IN",
    "dropphyzpp": 477152427,
    "dropmaladd": "1310 N GREEN RIVER RD",
    "dropmalcty": "EVANSVILLE",
    "dropmalst": "IN",
    "dropmalzpp": 477152427,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8124759065,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016671",
    "droptype": "D",
    "dropname": "LIBERTY CENTER",
    "dropdeladd": "1001 LIBERTY AVE STE R20",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152229998,
    "dropphyadd": "1001 LIBERTY AVE STE R20",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152229998,
    "dropmaladd": "1001 LIBERTY AVE STE R20",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152229998,
    "dropsitphn": 4122311536,
    "dropsitlph": 4122311536,
    "dropsitcph": 4124710351,
    "dropfax": 4122320157
  },
  {
    "dcode": "D",
    "dropkey": "S016730",
    "droptype": "D",
    "dropname": "MIDWAY",
    "dropdeladd": "2701 MIDWAY DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921109996,
    "dropphyadd": "2701 MIDWAY DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921109996,
    "dropmaladd": "2701 MIDWAY DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921109996,
    "dropsitphn": 8586740173,
    "dropsitlph": 6197581802,
    "dropsitcph": 6197589287,
    "dropfax": 6197580587
  },
  {
    "dcode": "D",
    "dropkey": "S016790",
    "droptype": "D",
    "dropname": "ASTORIA",
    "dropdeladd": "3011 21ST ST STE A",
    "dropdelcty": "ASTORIA",
    "dropdelst": "NY",
    "dropdelzpp": 111029996,
    "dropphyadd": "3011 21ST ST STE A",
    "dropphycty": "ASTORIA",
    "dropphyst": "NY",
    "dropphyzpp": 111029996,
    "dropmaladd": "3011 21ST ST STE A",
    "dropmalcty": "ASTORIA",
    "dropmalst": "NY",
    "dropmalzpp": 111029996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3473963650,
    "dropfax": 7187210469
  },
  {
    "dcode": "D",
    "dropkey": "S016867",
    "droptype": "D",
    "dropname": "INTERNATIONAL",
    "dropdeladd": "409 MAYNARD AVE S STE 109",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981042959,
    "dropphyadd": "409 MAYNARD AVE S STE 109",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981042959,
    "dropmaladd": "409 MAYNARD AVE S STE 109",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981042959,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066821245,
    "dropsitcph": 2066821245,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S016914",
    "droptype": "D",
    "dropname": "22ND STREET",
    "dropdeladd": "1255 22ND ST NW LBBY",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200379995,
    "dropphyadd": "1255 22ND ST NW LBBY",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200379995,
    "dropmaladd": "1255 22ND ST NW LBBY",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200379995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2024661972,
    "dropsitcph": 2024661972,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017048",
    "droptype": "D",
    "dropname": "PASCHALL",
    "dropdeladd": "7300 LINDBERGH BLVD FRNT",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191539903,
    "dropphyadd": "7300 LINDBERGH BLVD FRNT",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191539903,
    "dropmaladd": "7300 LINDBERGH BLVD FRNT",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191539903,
    "dropsitphn": 2153657034,
    "dropsitlph": 2153657034,
    "dropsitcph": 2153657034,
    "dropfax": 2154921552
  },
  {
    "dcode": "D",
    "dropkey": "S017053",
    "droptype": "D",
    "dropname": "SAVIERS",
    "dropdeladd": "2520 SAVIERS RD",
    "dropdelcty": "OXNARD",
    "dropdelst": "CA",
    "dropdelzpp": 930339998,
    "dropphyadd": "2520 SAVIERS RD",
    "dropphycty": "OXNARD",
    "dropphyst": "CA",
    "dropphyzpp": 930339998,
    "dropmaladd": "2520 SAVIERS RD",
    "dropmalcty": "OXNARD",
    "dropmalst": "CA",
    "dropmalzpp": 930339998,
    "dropsitphn": 6617757808,
    "dropsitlph": 8058220279,
    "dropsitcph": 8058220279,
    "dropfax": 8059818440
  },
  {
    "dcode": "D",
    "dropkey": "S017063",
    "droptype": "D",
    "dropname": "PRATT",
    "dropdeladd": "609 MYRTLE AVE STE A",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112059996,
    "dropphyadd": "609 MYRTLE AVE STE A",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112059996,
    "dropmaladd": "609 MYRTLE AVE STE A",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112059996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3472721757,
    "dropfax": 7183992754
  },
  {
    "dcode": "D",
    "dropkey": "S017197",
    "droptype": "D",
    "dropname": "16 AREA",
    "dropdeladd": "16840 7TH ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550206,
    "dropphyadd": "16840 7TH ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550206,
    "dropmaladd": "16840 7TH ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550206,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607255687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017198",
    "droptype": "D",
    "dropname": "14 AREA",
    "dropdeladd": "1482 16TH ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550200,
    "dropphyadd": "1482 16TH ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550200,
    "dropmaladd": "1482 16TH ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550200,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607632294,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017199",
    "droptype": "D",
    "dropname": "CAMP MARGARITA",
    "dropdeladd": "33307 A ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550201,
    "dropphyadd": "33307 A ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550201,
    "dropmaladd": "33307 A ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550201,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607632946,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017200",
    "droptype": "D",
    "dropname": "CAMP LAS PULGAS",
    "dropdeladd": "43507 BROWN ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550202,
    "dropphyadd": "43507 BROWN ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550202,
    "dropmaladd": "43507 BROWN ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550202,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607253370,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017201",
    "droptype": "D",
    "dropname": "CAMP HORNO",
    "dropdeladd": "53507 C ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550203,
    "dropphyadd": "53507 C ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550203,
    "dropmaladd": "53507 C ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550203,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607632950,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017202",
    "droptype": "D",
    "dropname": "CAMP LAS FLORES",
    "dropdeladd": "4153 NELSON ST",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550204,
    "dropphyadd": "4153 NELSON ST",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550204,
    "dropmaladd": "4153 NELSON ST",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550204,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607635414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017203",
    "droptype": "D",
    "dropname": "CAMP SAN MATEO",
    "dropdeladd": "62307 SAN MATEO RD",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550205,
    "dropphyadd": "62307 SAN MATEO RD",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550205,
    "dropmaladd": "62307 SAN MATEO RD",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920550205,
    "dropsitphn": 8586740173,
    "dropsitlph": "",
    "dropsitcph": 7607632947,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017229",
    "droptype": "D",
    "dropname": "WHITE FLINT STATION",
    "dropdeladd": "5056 NICHOLSON LN STE B",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208529959,
    "dropphyadd": "5056 NICHOLSON LN STE B",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208529959,
    "dropmaladd": "5056 NICHOLSON LN STE B",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208529959,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012301276,
    "dropsitcph": 3012301276,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017238",
    "droptype": "D",
    "dropname": "SAINT CHARLES SOUTH",
    "dropdeladd": "1600 WOODSTONE DR",
    "dropdelcty": "SAINT CHARLES",
    "dropdelst": "MO",
    "dropdelzpp": 633039997,
    "dropphyadd": "1600 WOODSTONE DR",
    "dropphycty": "SAINT CHARLES",
    "dropphyst": "MO",
    "dropphyzpp": 633039997,
    "dropmaladd": "1600 WOODSTONE DR",
    "dropmalcty": "SAINT CHARLES",
    "dropmalst": "MO",
    "dropmalzpp": 633039997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6369222042,
    "dropsitcph": 6369222077,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017321",
    "droptype": "D",
    "dropname": "EAST SANTA CRUZ",
    "dropdeladd": "1146 SOQUEL AVE",
    "dropdelcty": "SANTA CRUZ",
    "dropdelst": "CA",
    "dropdelzpp": 950629998,
    "dropphyadd": "1146 SOQUEL AVE",
    "dropphycty": "SANTA CRUZ",
    "dropphyst": "CA",
    "dropphyzpp": 950629998,
    "dropmaladd": "1146 SOQUEL AVE",
    "dropmalcty": "SANTA CRUZ",
    "dropmalst": "CA",
    "dropmalzpp": 950629998,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314230286,
    "dropsitcph": 8314385801,
    "dropfax": 8314236329
  },
  {
    "dcode": "D",
    "dropkey": "S017434",
    "droptype": "D",
    "dropname": "PRINCES BAY",
    "dropdeladd": "645 ROSSVILLE AVE STE 3",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103099993,
    "dropphyadd": "645 ROSSVILLE AVE STE 3",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103099993,
    "dropmaladd": "645 ROSSVILLE AVE STE 3",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103099993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186050121,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017503",
    "droptype": "D",
    "dropname": "CARMEL ROAD",
    "dropdeladd": "8326 PINEVILLE MATTHEWS RD STE 407",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282264722,
    "dropphyadd": "8326 PINEVILLE MATTHEWS RD STE 407",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282264722,
    "dropmaladd": "8326 PINEVILLE MATTHEWS RD STE 407",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282264722,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045400171,
    "dropsitcph": 7045400171,
    "dropfax": 7047524313
  },
  {
    "dcode": "D",
    "dropkey": "S017504",
    "droptype": "D",
    "dropname": "FREEDOM",
    "dropdeladd": "3202 WILKINSON BLVD UNIT C3B",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282085676,
    "dropphyadd": "3202 WILKINSON BLVD UNIT C3B",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282085676,
    "dropmaladd": "3202 WILKINSON BLVD UNIT C3B",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282085676,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043598638,
    "dropsitcph": 7043598638,
    "dropfax": 7043920814
  },
  {
    "dcode": "D",
    "dropkey": "S017520",
    "droptype": "D",
    "dropname": "RANDOLPH",
    "dropdeladd": "819 N WENDOVER RD",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282111120,
    "dropphyadd": "819 N WENDOVER RD",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282111120,
    "dropmaladd": "819 N WENDOVER RD",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282111120,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043664708,
    "dropsitcph": 7043664708,
    "dropfax": 7043664707
  },
  {
    "dcode": "D",
    "dropkey": "S017521",
    "droptype": "D",
    "dropname": "30TH STREET",
    "dropdeladd": "3720 N TRYON ST STE 113",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282062073,
    "dropphyadd": "3720 N TRYON ST STE 113",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282062073,
    "dropmaladd": "3720 N TRYON ST STE 113",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282062073,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045980284,
    "dropsitcph": 7045980284,
    "dropfax": 7043774761
  },
  {
    "dcode": "D",
    "dropkey": "S017612",
    "droptype": "D",
    "dropname": "EVERETT HUB",
    "dropdeladd": "8120 HARDESON RD",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982039994,
    "dropphyadd": "8120 HARDESON RD",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982039994,
    "dropmaladd": "8120 HARDESON RD",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982039994,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253558366,
    "dropsitcph": 4252906300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017755",
    "droptype": "D",
    "dropname": "A STATION VALLEJO",
    "dropdeladd": "629 MARIN ST",
    "dropdelcty": "VALLEJO",
    "dropdelst": "CA",
    "dropdelzpp": 945905936,
    "dropphyadd": "629 MARIN ST",
    "dropphycty": "VALLEJO",
    "dropphyst": "CA",
    "dropphyzpp": 945905936,
    "dropmaladd": "629 MARIN ST",
    "dropmalcty": "VALLEJO",
    "dropmalst": "CA",
    "dropmalzpp": 945905936,
    "dropsitphn": 5104337569,
    "dropsitlph": 7076423455,
    "dropsitcph": 7076423367,
    "dropfax": 7076422957
  },
  {
    "dcode": "D",
    "dropkey": "S017756",
    "droptype": "D",
    "dropname": "FRANKLIN",
    "dropdeladd": "1436 2ND ST",
    "dropdelcty": "NAPA",
    "dropdelst": "CA",
    "dropdelzpp": 945592953,
    "dropphyadd": "1436 2ND ST",
    "dropphycty": "NAPA",
    "dropphyst": "CA",
    "dropphyzpp": 945592953,
    "dropmaladd": "1436 2ND ST",
    "dropmalcty": "NAPA",
    "dropmalst": "CA",
    "dropmalzpp": 945592953,
    "dropsitphn": 5104337569,
    "dropsitlph": 7072550695,
    "dropsitcph": 7072550621,
    "dropfax": 7072550241
  },
  {
    "dcode": "D",
    "dropkey": "S017791",
    "droptype": "D",
    "dropname": "ELLISBURG",
    "dropdeladd": "600 KINGS HWY N STE 1",
    "dropdelcty": "CHERRY HILL",
    "dropdelst": "NJ",
    "dropdelzpp": "080023372",
    "dropphyadd": "600 KINGS HWY N STE 1",
    "dropphycty": "CHERRY HILL",
    "dropphyst": "NJ",
    "dropphyzpp": "080023372",
    "dropmaladd": "600 KINGS HWY N STE 1",
    "dropmalcty": "CHERRY HILL",
    "dropmalst": "NJ",
    "dropmalzpp": "080023372",
    "dropsitphn": 8569334046,
    "dropsitlph": 8564244533,
    "dropsitcph": 8564244533,
    "dropfax": 8564296650
  },
  {
    "dcode": "D",
    "dropkey": "S017806",
    "droptype": "D",
    "dropname": "PALMER SQUARE",
    "dropdeladd": "259 NASSAU ST STE 2",
    "dropdelcty": "PRINCETON",
    "dropdelst": "NJ",
    "dropdelzpp": "085424609",
    "dropphyadd": "259 NASSAU ST STE 2",
    "dropphycty": "PRINCETON",
    "dropphyst": "NJ",
    "dropphyzpp": "085424609",
    "dropmaladd": "259 NASSAU ST STE 2",
    "dropmalcty": "PRINCETON",
    "dropmalst": "NJ",
    "dropmalzpp": "085424609",
    "dropsitphn": 8569334046,
    "dropsitlph": 6099219563,
    "dropsitcph": 6099219563,
    "dropfax": 6094301175
  },
  {
    "dcode": "D",
    "dropkey": "S017816",
    "droptype": "D",
    "dropname": "WILMINGTON ISLAND",
    "dropdeladd": "463 JOHNNY MERCER BLVD STE B2",
    "dropdelcty": "SAVANNAH",
    "dropdelst": "GA",
    "dropdelzpp": 314102235,
    "dropphyadd": "463 JOHNNY MERCER BLVD STE B2",
    "dropphycty": "SAVANNAH",
    "dropphyst": "GA",
    "dropphyzpp": 314102235,
    "dropmaladd": "463 JOHNNY MERCER BLVD STE B2",
    "dropmalcty": "SAVANNAH",
    "dropmalst": "GA",
    "dropmalzpp": 314102235,
    "dropsitphn": 4787528466,
    "dropsitlph": 9128974225,
    "dropsitcph": 9128974225,
    "dropfax": 9128977409
  },
  {
    "dcode": "D",
    "dropkey": "S017833",
    "droptype": "D",
    "dropname": "LINKSIDE PARK",
    "dropdeladd": "7210 VIRGINIA PKWY STE 100",
    "dropdelcty": "MCKINNEY",
    "dropdelst": "TX",
    "dropdelzpp": 750719996,
    "dropphyadd": "7210 VIRGINIA PKWY STE 100",
    "dropphycty": "MCKINNEY",
    "dropphyst": "TX",
    "dropphyzpp": 750719996,
    "dropmaladd": "7210 VIRGINIA PKWY STE 100",
    "dropmalcty": "MCKINNEY",
    "dropmalst": "TX",
    "dropmalzpp": 750719996,
    "dropsitphn": 2144675872,
    "dropsitlph": 9725422931,
    "dropsitcph": 9725422931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017841",
    "droptype": "D",
    "dropname": "SAUNDERS",
    "dropdeladd": "1645 W BROAD ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "VA",
    "dropdelzpp": 232202106,
    "dropphyadd": "1645 W BROAD ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "VA",
    "dropphyzpp": 232202106,
    "dropmaladd": "1645 W BROAD ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "VA",
    "dropmalzpp": 232202106,
    "dropsitphn": 8047756336,
    "dropsitlph": 8073534759,
    "dropsitcph": 8043534759,
    "dropfax": 8043535682
  },
  {
    "dcode": "D",
    "dropkey": "S017846",
    "droptype": "D",
    "dropname": "MARINE CORP RD",
    "dropdeladd": "4300 BELLEAU WOOD AVE BLDG 148",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921409998,
    "dropphyadd": "4300 BELLEAU WOOD AVE BLDG 148",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921409998,
    "dropmaladd": "4300 BELLEAU WOOD AVE BLDG 148",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921409998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192601591,
    "dropsitcph": 6195244399,
    "dropfax": 6192601591
  },
  {
    "dcode": "D",
    "dropkey": "S017850",
    "droptype": "D",
    "dropname": "JACKIE ROBINSON",
    "dropdeladd": "1355 N MENTOR AVE",
    "dropdelcty": "PASADENA",
    "dropdelst": "CA",
    "dropdelzpp": 911049998,
    "dropphyadd": "1355 N MENTOR AVE",
    "dropphycty": "PASADENA",
    "dropphyst": "CA",
    "dropphyzpp": 911049998,
    "dropmaladd": "1355 N MENTOR AVE",
    "dropmalcty": "PASADENA",
    "dropmalst": "CA",
    "dropmalzpp": 911049998,
    "dropsitphn": 6617757808,
    "dropsitlph": "",
    "dropsitcph": 6267910011,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017851",
    "droptype": "D",
    "dropname": "ENGINEERING RETAIL TEST",
    "dropdeladd": "8403 ROUTE 29",
    "dropdelcty": "MERRIFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 220829997,
    "dropphyadd": "8403 ROUTE 29",
    "dropphycty": "MERRIFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 220829997,
    "dropmaladd": "8403 ROUTE 29",
    "dropmalcty": "MERRIFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 220829997,
    "dropsitphn": 7032807417,
    "dropsitlph": "",
    "dropsitcph": 7032807417,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017859",
    "droptype": "D",
    "dropname": "PIONEER SQUARE",
    "dropdeladd": "217 1ST AVE S",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981049693,
    "dropphyadd": "217 1ST AVE S",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981049693,
    "dropmaladd": "217 1ST AVE S",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981049693,
    "dropsitphn": 2067684422,
    "dropsitlph": 2066217388,
    "dropsitcph": 2066252293,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017884",
    "droptype": "D",
    "dropname": "GATEWAY",
    "dropdeladd": "6401 Q ST STE 100",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685052495,
    "dropphyadd": "6401 Q ST STE 100",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685052495,
    "dropmaladd": "6401 Q ST STE 100",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685052495,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024661586,
    "dropsitcph": 4024661586,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S017900",
    "droptype": "D",
    "dropname": "ARCHER AVE",
    "dropdeladd": "9703 SUTPHIN BLVD",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114359995,
    "dropphyadd": "9703 SUTPHIN BLVD",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114359995,
    "dropmaladd": "9703 SUTPHIN BLVD",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114359995,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182914182,
    "dropfax": 7182914184
  },
  {
    "dcode": "D",
    "dropkey": "S017903",
    "droptype": "D",
    "dropname": "BROADWAY",
    "dropdeladd": "212 BROADWAY E",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981029997,
    "dropphyadd": "212 BROADWAY E",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981029997,
    "dropmaladd": "212 BROADWAY E",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981029997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2063237685,
    "dropsitcph": 2063245474,
    "dropfax": 6514566592
  },
  {
    "dcode": "D",
    "dropkey": "S017926",
    "droptype": "D",
    "dropname": "BEDFORD RETAIL UNIT NEW",
    "dropdeladd": "158 GREAT RD UNIT J",
    "dropdelcty": "BEDFORD",
    "dropdelst": "MA",
    "dropdelzpp": "017302735",
    "dropphyadd": "158 GREAT RD UNIT J",
    "dropphycty": "BEDFORD",
    "dropphyst": "MA",
    "dropphyzpp": "017302735",
    "dropmaladd": "158 GREAT RD UNIT J",
    "dropmalcty": "BEDFORD",
    "dropmalst": "MA",
    "dropmalzpp": "017302735",
    "dropsitphn": 9786647013,
    "dropsitlph": 7812752924,
    "dropsitcph": 7812752924,
    "dropfax": 7812756049
  },
  {
    "dcode": "D",
    "dropkey": "S017936",
    "droptype": "D",
    "dropname": "METRO",
    "dropdeladd": "150 SE 2ND AVE STE 103",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331319997,
    "dropphyadd": "150 SE 2ND AVE STE 103",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331319997,
    "dropmaladd": "150 SE 2ND AVE STE 103",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331319997,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053737562,
    "dropsitcph": 3053737562,
    "dropfax": 3053748683
  },
  {
    "dcode": "D",
    "dropkey": "S017978",
    "droptype": "D",
    "dropname": "TRIBOROUGH",
    "dropdeladd": "118 E 124TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100359997,
    "dropphyadd": "118 E 124TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100359997,
    "dropmaladd": "118 E 124TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100359997,
    "dropsitphn": 2123302770,
    "dropsitlph": 2127220751,
    "dropsitcph": 2127220751,
    "dropfax": 2127220752
  },
  {
    "dcode": "D",
    "dropkey": "S018003",
    "droptype": "D",
    "dropname": "SUMMER ATLANTIC",
    "dropdeladd": "550 SUMMER ST",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069011412",
    "dropphyadd": "550 SUMMER ST",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069011412",
    "dropmaladd": "550 SUMMER ST",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069011412",
    "dropsitphn": 2033160379,
    "dropsitlph": 2033160379,
    "dropsitcph": 2033160379,
    "dropfax": 2033160322
  },
  {
    "dcode": "D",
    "dropkey": "S018010",
    "droptype": "D",
    "dropname": "PLAZA",
    "dropdeladd": "4254 23RD ST",
    "dropdelcty": "LONG ISLAND CITY",
    "dropdelst": "NY",
    "dropdelzpp": 111019995,
    "dropphyadd": "4254 23RD ST",
    "dropphycty": "LONG ISLAND CITY",
    "dropphyst": "NY",
    "dropphyzpp": 111019995,
    "dropmaladd": "4254 23RD ST",
    "dropmalcty": "LONG ISLAND CITY",
    "dropmalst": "NY",
    "dropmalzpp": 111019995,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184333802,
    "dropfax": 7184334958
  },
  {
    "dcode": "D",
    "dropkey": "S018013",
    "droptype": "D",
    "dropname": "PENDLETON 22 AREA",
    "dropdeladd": "22103 USPS BLDG 22103",
    "dropdelcty": "CAMP PENDLETON",
    "dropdelst": "CA",
    "dropdelzpp": 920550020,
    "dropphyadd": "22103 USPS BLDG 22103",
    "dropphycty": "CAMP PENDLETON",
    "dropphyst": "CA",
    "dropphyzpp": 920550020,
    "dropmaladd": "PO BOX 9996",
    "dropmalcty": "CAMP PENDLETON",
    "dropmalst": "CA",
    "dropmalzpp": 920559996,
    "dropsitphn": 8586740173,
    "dropsitlph": 7607254691,
    "dropsitcph": 7607255227,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018020",
    "droptype": "D",
    "dropname": "TIMES PLAZA",
    "dropdeladd": "539 ATLANTIC AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112179996,
    "dropphyadd": "539 ATLANTIC AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112179996,
    "dropmaladd": "539 ATLANTIC AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112179996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187971516,
    "dropfax": 7187971674
  },
  {
    "dcode": "D",
    "dropkey": "S018024",
    "droptype": "D",
    "dropname": "WEST CITY",
    "dropdeladd": "850 TWIN RIVERS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432169532,
    "dropphyadd": "850 TWIN RIVERS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432169532,
    "dropmaladd": "850 TWIN RIVERS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432169532,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694232,
    "dropsitcph": 6144694232,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018035",
    "droptype": "D",
    "dropname": "MOONRIDGE",
    "dropdeladd": "42166 BIG BEAR BLVD",
    "dropdelcty": "BIG BEAR LAKE",
    "dropdelst": "CA",
    "dropdelzpp": 923151518,
    "dropphyadd": "42166 BIG BEAR BLVD",
    "dropphycty": "BIG BEAR LAKE",
    "dropphyst": "CA",
    "dropphyzpp": 923151518,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BIG BEAR LAKE",
    "dropmalst": "CA",
    "dropmalzpp": 923159998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098667049,
    "dropsitcph": 9098667049,
    "dropfax": 9098663731
  },
  {
    "dcode": "D",
    "dropkey": "S018053",
    "droptype": "D",
    "dropname": "T W HOUSE",
    "dropdeladd": "1300 W 19TH ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770089998,
    "dropphyadd": "1300 W 19TH ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770089998,
    "dropmaladd": "1300 W 19TH ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770089998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7138614037,
    "dropsitcph": 7138618535,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018058",
    "droptype": "D",
    "dropname": "FOOTHILL",
    "dropdeladd": "1085 MCGINNESS AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951279998,
    "dropphyadd": "1085 MCGINNESS AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951279998,
    "dropmaladd": "1085 MCGINNESS AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951279998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082590823,
    "dropsitcph": 4082595108,
    "dropfax": 4082592485
  },
  {
    "dcode": "D",
    "dropkey": "S018059",
    "droptype": "D",
    "dropname": "LA JOLLA VILLAGE",
    "dropdeladd": "8861 VILLA LA JOLLA DR STE 505",
    "dropdelcty": "LA JOLLA",
    "dropdelst": "CA",
    "dropdelzpp": 920379996,
    "dropphyadd": "8861 VILLA LA JOLLA DR STE 505",
    "dropphycty": "LA JOLLA",
    "dropphyst": "CA",
    "dropphyzpp": 920379996,
    "dropmaladd": "8861 VILLA LA JOLLA DR STE 505",
    "dropmalcty": "LA JOLLA",
    "dropmalst": "CA",
    "dropmalzpp": 920379996,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585350268,
    "dropsitcph": 8586221277,
    "dropfax": 8585351348
  },
  {
    "dcode": "D",
    "dropkey": "S018061",
    "droptype": "D",
    "dropname": "FOREST PARK",
    "dropdeladd": "4203 N MAIN ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454059998,
    "dropphyadd": "4203 N MAIN ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454059998,
    "dropmaladd": "4203 N MAIN ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454059998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372799650,
    "dropsitcph": 9372799650,
    "dropfax": 9372757336
  },
  {
    "dcode": "D",
    "dropkey": "S018088",
    "droptype": "D",
    "dropname": "PRESIDIO",
    "dropdeladd": "558 PRESIDIO BLVD STE B",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941295710,
    "dropphyadd": "558 PRESIDIO BLVD STE B",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941295710,
    "dropmaladd": "558 PRESIDIO BLVD STE B",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941295710,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155501875,
    "dropsitcph": 4154401875,
    "dropfax": 4155635367
  },
  {
    "dcode": "D",
    "dropkey": "S018124",
    "droptype": "D",
    "dropname": "DOWNTOWN FLINT",
    "dropdeladd": "400 S SAGINAW ST",
    "dropdelcty": "FLINT",
    "dropdelst": "MI",
    "dropdelzpp": 485021516,
    "dropphyadd": "400 S SAGINAW ST",
    "dropphycty": "FLINT",
    "dropphyst": "MI",
    "dropphyzpp": 485021516,
    "dropmaladd": "400 S SAGINAW ST",
    "dropmalcty": "FLINT",
    "dropmalst": "MI",
    "dropmalzpp": 485021516,
    "dropsitphn": 8102571567,
    "dropsitlph": 8102571580,
    "dropsitcph": 8102571526,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018138",
    "droptype": "D",
    "dropname": "BIXBY",
    "dropdeladd": "4470 ATLANTIC AVE",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908079997,
    "dropphyadd": "4470 ATLANTIC AVE",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908079997,
    "dropmaladd": "4470 ATLANTIC AVE",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908079997,
    "dropsitphn": 5624942406,
    "dropsitlph": 5629833074,
    "dropsitcph": 5629833073,
    "dropfax": 5624289194
  },
  {
    "dcode": "D",
    "dropkey": "S018152",
    "droptype": "D",
    "dropname": "SAN FRANCISCO COLL UNIT",
    "dropdeladd": "1300 EVANS AVE STE 121",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941888101,
    "dropphyadd": "1300 EVANS AVE STE 121",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941888101,
    "dropmaladd": "1300 EVANS AVE STE 121",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941888101,
    "dropsitphn": 4155505045,
    "dropsitlph": "",
    "dropsitcph": 4155505248,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018159",
    "droptype": "D",
    "dropname": "CITYGATE RETAIL",
    "dropdeladd": "2323 CITYGATE DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432189998,
    "dropphyadd": "2323 CITYGATE DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432189998,
    "dropmaladd": "2323 CITYGATE DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432189998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144720632,
    "dropsitcph": 6144720632,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018163",
    "droptype": "D",
    "dropname": "VERO BEACH DOWNTOWN",
    "dropdeladd": "2050 13TH AVE OFC",
    "dropdelcty": "VERO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 329609998,
    "dropphyadd": "2050 13TH AVE OFC",
    "dropphycty": "VERO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 329609998,
    "dropmaladd": "2050 13TH AVE OFC",
    "dropmalcty": "VERO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 329609998,
    "dropsitphn": 7725675206,
    "dropsitlph": 7725675502,
    "dropsitcph": 7725675206,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018166",
    "droptype": "D",
    "dropname": "BARTON",
    "dropdeladd": "2382 S CEDAR AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937259997,
    "dropphyadd": "2382 S CEDAR AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937259997,
    "dropmaladd": "2382 S CEDAR AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937259997,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592330542,
    "dropsitcph": 5592330469,
    "dropfax": 5592330684
  },
  {
    "dcode": "D",
    "dropkey": "S018176",
    "droptype": "D",
    "dropname": "WEST END",
    "dropdeladd": "81 BRIGHTON AVE",
    "dropdelcty": "LONG BRANCH",
    "dropdelst": "NJ",
    "dropdelzpp": "077405339",
    "dropphyadd": "81 BRIGHTON AVE",
    "dropphycty": "LONG BRANCH",
    "dropphyst": "NJ",
    "dropphyzpp": "077405339",
    "dropmaladd": "81 BRIGHTON AVE",
    "dropmalcty": "LONG BRANCH",
    "dropmalst": "NJ",
    "dropmalzpp": "077405339",
    "dropsitphn": 7322222383,
    "dropsitlph": 7322222383,
    "dropsitcph": 7322222383,
    "dropfax": 7322226908
  },
  {
    "dcode": "D",
    "dropkey": "S018182",
    "droptype": "D",
    "dropname": "COMO",
    "dropdeladd": "2309 COMO AVE",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551089998,
    "dropphyadd": "2309 COMO AVE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551089998,
    "dropmaladd": "2309 COMO AVE",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551089998,
    "dropsitphn": 6516450172,
    "dropsitlph": 6516450172,
    "dropsitcph": 6516450172,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018191",
    "droptype": "D",
    "dropname": "MIRACLE MILE POSTAL STORE",
    "dropdeladd": "75 MIRACLE MILE",
    "dropdelcty": "CORAL GABLES",
    "dropdelst": "FL",
    "dropdelzpp": 331349997,
    "dropphyadd": "75 MIRACLE MILE",
    "dropphycty": "CORAL GABLES",
    "dropphyst": "FL",
    "dropphyzpp": 331349997,
    "dropmaladd": "75 MIRACLE MILE",
    "dropmalcty": "CORAL GABLES",
    "dropmalst": "FL",
    "dropmalzpp": 331349997,
    "dropsitphn": 3055132368,
    "dropsitlph": 7865521241,
    "dropsitcph": 7865521241,
    "dropfax": 7865521246
  },
  {
    "dcode": "D",
    "dropkey": "S018212",
    "droptype": "D",
    "dropname": "CAPITOL STATION RETAIL",
    "dropdeladd": "2 E MIFFLIN ST STE 103",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537033334,
    "dropphyadd": "2 E MIFFLIN ST STE 103",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537033334,
    "dropmaladd": "2 E MIFFLIN ST STE 103",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537033334,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082506479,
    "dropsitcph": 6082506485,
    "dropfax": 6082554542
  },
  {
    "dcode": "D",
    "dropkey": "S018219",
    "droptype": "D",
    "dropname": "SAN FRANCISCO GEN DEL",
    "dropdeladd": "391 ELLIS ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941022709,
    "dropphyadd": "391 ELLIS ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941022709,
    "dropmaladd": "391 ELLIS ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941022709,
    "dropsitphn": 4155505045,
    "dropsitlph": 4155504045,
    "dropsitcph": 8002758777,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018221",
    "droptype": "D",
    "dropname": "LAUREL COMMONS",
    "dropdeladd": "14720 BALTIMORE AVE UNIT 111",
    "dropdelcty": "LAUREL",
    "dropdelst": "MD",
    "dropdelzpp": 207074898,
    "dropphyadd": "14720 BALTIMORE AVE UNIT 111",
    "dropphycty": "LAUREL",
    "dropphyst": "MD",
    "dropphyzpp": 207074898,
    "dropmaladd": "123 WASHINGTON BLVD S",
    "dropmalcty": "LAUREL",
    "dropmalst": "MD",
    "dropmalzpp": 207079997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014981567,
    "dropsitcph": 3014981567,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018274",
    "droptype": "D",
    "dropname": "WESTLAND",
    "dropdeladd": "770 GEORGESVILLE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432289911,
    "dropphyadd": "770 GEORGESVILLE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432289911,
    "dropmaladd": "770 GEORGESVILLE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432289911,
    "dropsitphn": 6144720674,
    "dropsitlph": 6143510138,
    "dropsitcph": 6143510138,
    "dropfax": 6143510049
  },
  {
    "dcode": "D",
    "dropkey": "S018285",
    "droptype": "D",
    "dropname": "CIVIC CENTER LA HABRA",
    "dropdeladd": "120 E LA HABRA BLVD",
    "dropdelcty": "LA HABRA",
    "dropdelst": "CA",
    "dropdelzpp": 906319996,
    "dropphyadd": "120 E LA HABRA BLVD",
    "dropphycty": "LA HABRA",
    "dropphyst": "CA",
    "dropphyzpp": 906319996,
    "dropmaladd": "1001 W IMPERIAL HWY",
    "dropmalcty": "LA HABRA",
    "dropmalst": "CA",
    "dropmalzpp": 906316986,
    "dropsitphn": 7149920580,
    "dropsitlph": 5626973890,
    "dropsitcph": 7149920580,
    "dropfax": 7149926546
  },
  {
    "dcode": "D",
    "dropkey": "S018288",
    "droptype": "D",
    "dropname": "PROMENADE",
    "dropdeladd": "3654 ATLANTA HWY STE M",
    "dropdelcty": "ATHENS",
    "dropdelst": "GA",
    "dropdelzpp": 306069997,
    "dropphyadd": "3654 ATLANTA HWY STE M",
    "dropphycty": "ATHENS",
    "dropphyst": "GA",
    "dropphyzpp": 306069997,
    "dropmaladd": "PO BOX 80308",
    "dropmalcty": "ATHENS",
    "dropmalst": "GA",
    "dropmalzpp": 306080308,
    "dropsitphn": 4047657578,
    "dropsitlph": 7065435817,
    "dropsitcph": 7065435817,
    "dropfax": 7063693238
  },
  {
    "dcode": "D",
    "dropkey": "S018289",
    "droptype": "D",
    "dropname": "CRYSTAL CITY",
    "dropdeladd": "2180 CRYSTAL DR",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222029922,
    "dropphyadd": "2180 CRYSTAL DR",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222029922,
    "dropmaladd": "2180 CRYSTAL DR",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222029922,
    "dropsitphn": 7036986367,
    "dropsitlph": 7034139268,
    "dropsitcph": 7034139268,
    "dropfax": 7034133047
  },
  {
    "dcode": "D",
    "dropkey": "S018293",
    "droptype": "D",
    "dropname": "HALLIDAY 2",
    "dropdeladd": "32 E MAIN ST",
    "dropdelcty": "HALLIDAY",
    "dropdelst": "ND",
    "dropdelzpp": 586369997,
    "dropphyadd": "32 E MAIN ST",
    "dropphycty": "HALLIDAY",
    "dropphyst": "ND",
    "dropphyzpp": 586369997,
    "dropmaladd": "32 E MAIN ST",
    "dropmalcty": "HALLIDAY",
    "dropmalst": "ND",
    "dropmalzpp": 586369997,
    "dropsitphn": 6053574932,
    "dropsitlph": 7019384659,
    "dropsitcph": 7012716205,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018298",
    "droptype": "D",
    "dropname": "CAMP H M SMITH MILITARY PO",
    "dropdeladd": "1 CAMP SMITH USMC BLDG 2C",
    "dropdelcty": "CAMP H M SMITH",
    "dropdelst": "HI",
    "dropdelzpp": 968615095,
    "dropphyadd": "1 CAMP SMITH USMC BLDG 2C",
    "dropphycty": "CAMP H M SMITH",
    "dropphyst": "HI",
    "dropphyzpp": 968615095,
    "dropmaladd": "1 CAMP SMITH USMC BLDG 2C",
    "dropmalcty": "CAMP H M SMITH",
    "dropmalst": "HI",
    "dropmalzpp": 968615095,
    "dropsitphn": 8084233844,
    "dropsitlph": 8084770203,
    "dropsitcph": 8084770203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018307",
    "droptype": "D",
    "dropname": "FARLEY RETAIL UNIT",
    "dropdeladd": "4025 W RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731479805,
    "dropphyadd": "4025 W RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731479805,
    "dropmaladd": "4025 W RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731479805,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058152917,
    "dropsitcph": 4058152917,
    "dropfax": 4058152036
  },
  {
    "dcode": "D",
    "dropkey": "S018328",
    "droptype": "D",
    "dropname": "FOREST GLEN",
    "dropdeladd": "2460 LINDEN LN UNIT 161",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209101258,
    "dropphyadd": "2460 LINDEN LN UNIT 161",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209101258,
    "dropmaladd": "2460 LINDEN LN UNIT 161",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209101258,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012957594,
    "dropsitcph": 3012957594,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018352",
    "droptype": "D",
    "dropname": "FORT JACKSON",
    "dropdeladd": "4350 CENTURY DIVISION AVE",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292079996,
    "dropphyadd": "4350 CENTURY DIVISION AVE",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292079996,
    "dropmaladd": "PO BOX 29207",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292079207,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037828709,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018392",
    "droptype": "D",
    "dropname": "LOOP",
    "dropdeladd": "811 LASALLE AVE STE 100",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554022089,
    "dropphyadd": "811 LASALLE AVE STE 100",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554022089,
    "dropmaladd": "811 LASALLE AVE STE 100",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554022089,
    "dropsitphn": 6123395549,
    "dropsitlph": "",
    "dropsitcph": 6123395105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018629",
    "droptype": "D",
    "dropname": "WILLIAM PENN RETAIL",
    "dropdeladd": "720 ARCH ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191059998,
    "dropphyadd": "720 ARCH ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191059998,
    "dropmaladd": "720 ARCH ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191059998,
    "dropsitphn": 2153657034,
    "dropsitlph": 2159252131,
    "dropsitcph": 2159252131,
    "dropfax": 2159251967
  },
  {
    "dcode": "D",
    "dropkey": "S018645",
    "droptype": "D",
    "dropname": "MANHATTAN",
    "dropdeladd": "549 E MANHATTAN BLVD",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436081270,
    "dropphyadd": "549 E MANHATTAN BLVD",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436081270,
    "dropmaladd": "549 E MANHATTAN BLVD",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436081270,
    "dropsitphn": 4192456870,
    "dropsitlph": 4197263859,
    "dropsitcph": 4197263859,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018650",
    "droptype": "D",
    "dropname": "VILLAGE",
    "dropdeladd": "1001 GAYLEY AVE STE 105",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900249997,
    "dropphyadd": "1001 GAYLEY AVE STE 105",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900249997,
    "dropmaladd": "1001 GAYLEY AVE STE 105",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900249997,
    "dropsitphn": 3235861868,
    "dropsitlph": 3102357773,
    "dropsitcph": 3108240020,
    "dropfax": 3102356161
  },
  {
    "dcode": "D",
    "dropkey": "S018658",
    "droptype": "D",
    "dropname": "CYCLONE STATION",
    "dropdeladd": "119 STANTON AVE STE 101",
    "dropdelcty": "AMES",
    "dropdelst": "IA",
    "dropdelzpp": 500142531,
    "dropphyadd": "119 STANTON AVE STE 101",
    "dropphycty": "AMES",
    "dropphyst": "IA",
    "dropphyzpp": 500142531,
    "dropmaladd": "119 STANTON AVE STE 101",
    "dropmalcty": "AMES",
    "dropmalst": "IA",
    "dropmalzpp": 500142531,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152321113,
    "dropsitcph": 5152922098,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018659",
    "droptype": "D",
    "dropname": "SIGNAL HILL",
    "dropdeladd": "2371 GRAND AVE",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908099994,
    "dropphyadd": "2371 GRAND AVE",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908099994,
    "dropmaladd": "2371 GRAND AVE",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908099994,
    "dropsitphn": 5629864901,
    "dropsitlph": 5624942281,
    "dropsitcph": 5624942297,
    "dropfax": 5624940005
  },
  {
    "dcode": "D",
    "dropkey": "S018663",
    "droptype": "D",
    "dropname": "CENTURY CITY MALL",
    "dropdeladd": "10250 SANTA MONICA BLVD LOWR 1700",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900679997,
    "dropphyadd": "10250 SANTA MONICA BLVD LOWR 1700",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900679997,
    "dropmaladd": "10250 SANTA MONICA BLVD LOWR 1700",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900679997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3107853804,
    "dropsitcph": 3107853803,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018694",
    "droptype": "D",
    "dropname": "NORTH CITY",
    "dropdeladd": "18336 AURORA AVE N STE 105",
    "dropdelcty": "SHORELINE",
    "dropdelst": "WA",
    "dropdelzpp": 981339996,
    "dropphyadd": "18336 AURORA AVE N STE 105",
    "dropphycty": "SHORELINE",
    "dropphyst": "WA",
    "dropphyzpp": 981339996,
    "dropmaladd": "18336 AURORA AVE N STE 105",
    "dropmalcty": "SHORELINE",
    "dropmalst": "WA",
    "dropmalzpp": 981339996,
    "dropsitphn": 2067684422,
    "dropsitlph": 2065428075,
    "dropsitcph": 2065428075,
    "dropfax": 2065428075
  },
  {
    "dcode": "D",
    "dropkey": "S018697",
    "droptype": "D",
    "dropname": "TAOS ENCHANTMENT",
    "dropdeladd": "110 BERTHA RD",
    "dropdelcty": "TAOS",
    "dropdelst": "NM",
    "dropdelzpp": 875719997,
    "dropphyadd": "110 BERTHA RD",
    "dropphycty": "TAOS",
    "dropphyst": "NM",
    "dropphyzpp": 875719997,
    "dropmaladd": "110 BERTHA RD",
    "dropmalcty": "TAOS",
    "dropmalst": "NM",
    "dropmalzpp": 875719997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757588670,
    "dropsitcph": 5757588670,
    "dropfax": 5757587429
  },
  {
    "dcode": "D",
    "dropkey": "S018698",
    "droptype": "D",
    "dropname": "TOWN AND COUNTRY NEW",
    "dropdeladd": "2929 FULTON AVE STE 19",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958215298,
    "dropphyadd": "2929 FULTON AVE STE 19",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958215298,
    "dropmaladd": "2929 FULTON AVE STE 19",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958215298,
    "dropsitphn": 9163738025,
    "dropsitlph": 9165743025,
    "dropsitcph": 9165743003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018713",
    "droptype": "D",
    "dropname": "STATION A",
    "dropdeladd": "225 MAIN ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436052035,
    "dropphyadd": "225 MAIN ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436052035,
    "dropmaladd": "225 MAIN ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436052035,
    "dropsitphn": 4162456870,
    "dropsitlph": 4196988066,
    "dropsitcph": 4196988066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018746",
    "droptype": "D",
    "dropname": "DOWNTOWN  FRESNO",
    "dropdeladd": "1900 E ST",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937069988,
    "dropphyadd": "1900 E ST",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937069988,
    "dropmaladd": "1900 E ST",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937069988,
    "dropsitphn": 5594977615,
    "dropsitlph": 5594977673,
    "dropsitcph": 5594977673,
    "dropfax": 5594977511
  },
  {
    "dcode": "D",
    "dropkey": "S018749",
    "droptype": "D",
    "dropname": "DINKYTOWN",
    "dropdeladd": "1316 5TH ST SE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554144123,
    "dropphyadd": "1316 5TH ST SE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554144123,
    "dropmaladd": "1316 5TH ST SE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554144123,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123780709,
    "dropsitcph": 6123780709,
    "dropfax": 6123789240
  },
  {
    "dcode": "D",
    "dropkey": "S018753",
    "droptype": "D",
    "dropname": "HAYGOOD",
    "dropdeladd": "998 INDEPENDENCE BLVD STE 102",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234559996,
    "dropphyadd": "998 INDEPENDENCE BLVD STE 102",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234559996,
    "dropmaladd": "998 INDEPENDENCE BLVD STE 102",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234559996,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7573637856,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018760",
    "droptype": "D",
    "dropname": "STONEWALL",
    "dropdeladd": "401 VIRGINIA ST W",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253025000,
    "dropphyadd": "401 VIRGINIA ST W",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253025000,
    "dropmaladd": "401 VIRGINIA ST W",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253025000,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3043461225,
    "dropfax": 3043465913
  },
  {
    "dcode": "D",
    "dropkey": "S018762",
    "droptype": "D",
    "dropname": "SOUTH FLORENCE",
    "dropdeladd": "510 2ND LOOP RD",
    "dropdelcty": "FLORENCE",
    "dropdelst": "SC",
    "dropdelzpp": 295052855,
    "dropphyadd": "510 2ND LOOP RD",
    "dropphycty": "FLORENCE",
    "dropphyst": "SC",
    "dropphyzpp": 295052855,
    "dropmaladd": "510 2ND LOOP RD",
    "dropmalcty": "FLORENCE",
    "dropmalst": "SC",
    "dropmalzpp": 295052855,
    "dropsitphn": 8039266014,
    "dropsitlph": 8436792451,
    "dropsitcph": 8437996690,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018775",
    "droptype": "D",
    "dropname": "NORTH SIDE",
    "dropdeladd": "669 GYPSY LN UNIT 22",
    "dropdelcty": "YOUNGSTOWN",
    "dropdelst": "OH",
    "dropdelzpp": 445052417,
    "dropphyadd": "669 GYPSY LN UNIT 22",
    "dropphycty": "YOUNGSTOWN",
    "dropphyst": "OH",
    "dropphyzpp": 445052417,
    "dropmaladd": "669 GYPSY LN UNIT 22",
    "dropmalcty": "YOUNGSTOWN",
    "dropmalst": "OH",
    "dropmalzpp": 445052417,
    "dropsitphn": 3309969797,
    "dropsitlph": 3307436602,
    "dropsitcph": 3307436602,
    "dropfax": 3307437348
  },
  {
    "dcode": "D",
    "dropkey": "S018818",
    "droptype": "D",
    "dropname": "MILLER HILL",
    "dropdeladd": "4901 MATTERHORN DR",
    "dropdelcty": "DULUTH",
    "dropdelst": "MN",
    "dropdelzpp": 558113878,
    "dropphyadd": "4901 MATTERHORN DR",
    "dropphycty": "DULUTH",
    "dropphyst": "MN",
    "dropphyzpp": 558113878,
    "dropmaladd": "4901 MATTERHORN DR",
    "dropmalcty": "DULUTH",
    "dropmalst": "MN",
    "dropmalzpp": 558113878,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 2187403240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018823",
    "droptype": "D",
    "dropname": "WEST LYNN",
    "dropdeladd": "55 SPENCER ST",
    "dropdelcty": "LYNN",
    "dropdelst": "MA",
    "dropdelzpp": "019059997",
    "dropphyadd": "55 SPENCER ST",
    "dropphycty": "LYNN",
    "dropphyst": "MA",
    "dropphyzpp": "019059997",
    "dropmaladd": "55 SPENCER ST",
    "dropmalcty": "LYNN",
    "dropmalst": "MA",
    "dropmalzpp": "019059997",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7815932417,
    "dropfax": 7815932463
  },
  {
    "dcode": "D",
    "dropkey": "S018828",
    "droptype": "D",
    "dropname": "HACKS CROSS",
    "dropdeladd": "7948 WINCHESTER RD STE 12",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381254349,
    "dropphyadd": "7948 WINCHESTER RD STE 12",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381254349,
    "dropmaladd": "7948 WINCHESTER RD STE 12",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381254349,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017574609,
    "dropsitcph": 9017574609,
    "dropfax": 9017574643
  },
  {
    "dcode": "D",
    "dropkey": "S018831",
    "droptype": "D",
    "dropname": "EMBRY HILLS",
    "dropdeladd": "3631 CHAMBLEE TUCKER RD STE C",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303414415,
    "dropphyadd": "3631 CHAMBLEE TUCKER RD STE C",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303414415,
    "dropmaladd": "3631 CHAMBLEE TUCKER RD STE C",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303414415,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704553203,
    "dropsitcph": 7702161968,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018833",
    "droptype": "D",
    "dropname": "OLDE TOWNE",
    "dropdeladd": "103 E MISSION AVE",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "NE",
    "dropdelzpp": 680055261,
    "dropphyadd": "103 E MISSION AVE",
    "dropphycty": "BELLEVUE",
    "dropphyst": "NE",
    "dropphyzpp": 680055261,
    "dropmaladd": "103 E MISSION AVE",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "NE",
    "dropmalzpp": 680055261,
    "dropsitphn": 4022922838,
    "dropsitlph": 4022922838,
    "dropsitcph": 4022922838,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018847",
    "droptype": "D",
    "dropname": "CIVIC CENTER FRESNO",
    "dropdeladd": "855 M ST STE 190",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937219998,
    "dropphyadd": "855 M ST STE 190",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937219998,
    "dropmaladd": "855 M ST STE 190",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937219998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592330104,
    "dropsitcph": 5592330104,
    "dropfax": 5592330105
  },
  {
    "dcode": "D",
    "dropkey": "S018861",
    "droptype": "D",
    "dropname": "BUENA VISTA",
    "dropdeladd": "3246 N MIAMI AVE STE A",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331273557,
    "dropphyadd": "3246 N MIAMI AVE STE A",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331273557,
    "dropmaladd": "3246 N MIAMI AVE STE A",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331273557,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055736011,
    "dropsitcph": 3055736056,
    "dropfax": 3053743216
  },
  {
    "dcode": "D",
    "dropkey": "S018901",
    "droptype": "D",
    "dropname": "AMERICAN CITIES",
    "dropdeladd": "10500 LITTLE PATUXENT PKWY STE 190",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MD",
    "dropdelzpp": 210449997,
    "dropphyadd": "10500 LITTLE PATUXENT PKWY STE 190",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MD",
    "dropphyzpp": 210449997,
    "dropmaladd": "10500 LITTLE PATUXENT PKWY STE 190",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MD",
    "dropmalzpp": 210449997,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103814373,
    "dropsitcph": 4103814373,
    "dropfax": 4103812469
  },
  {
    "dcode": "D",
    "dropkey": "S018944",
    "droptype": "D",
    "dropname": "WOODFIELD FIN STATION",
    "dropdeladd": "1951 MCCONNOR PKWY",
    "dropdelcty": "SCHAUMBURG",
    "dropdelst": "IL",
    "dropdelzpp": 601739987,
    "dropphyadd": "1951 MCCONNOR PKWY",
    "dropphycty": "SCHAUMBURG",
    "dropphyst": "IL",
    "dropphyzpp": 601739987,
    "dropmaladd": "1951 MCCONNOR PKWY",
    "dropmalcty": "SCHAUMBURG",
    "dropmalst": "IL",
    "dropmalzpp": 601739987,
    "dropsitphn": 6302605499,
    "dropsitlph": 8478856519,
    "dropsitcph": 8476059610,
    "dropfax": 8476059667
  },
  {
    "dcode": "D",
    "dropkey": "S018952",
    "droptype": "D",
    "dropname": "DOWNTOWN EL DORADO",
    "dropdeladd": "208 E ELM ST",
    "dropdelcty": "EL DORADO",
    "dropdelst": "AR",
    "dropdelzpp": 717309995,
    "dropphyadd": "208 E ELM ST",
    "dropphycty": "EL DORADO",
    "dropphyst": "AR",
    "dropphyzpp": 717309995,
    "dropmaladd": "208 E ELM ST",
    "dropmalcty": "EL DORADO",
    "dropmalst": "AR",
    "dropmalzpp": 717309995,
    "dropsitphn": 8708751673,
    "dropsitlph": 8708751673,
    "dropsitcph": 8708751673,
    "dropfax": 8708751673
  },
  {
    "dcode": "D",
    "dropkey": "S018953",
    "droptype": "D",
    "dropname": "DFW DALLAS",
    "dropdeladd": "2420 INNOVATION DR",
    "dropdelcty": "DFW AIRPORT",
    "dropdelst": "TX",
    "dropdelzpp": 752614601,
    "dropphyadd": "2420 INNOVATION DR",
    "dropphycty": "DFW AIRPORT",
    "dropphyst": "TX",
    "dropphyzpp": 752614601,
    "dropmaladd": "2420 INNOVATION DR",
    "dropmalcty": "DFW AIRPORT",
    "dropmalst": "TX",
    "dropmalzpp": 752614601,
    "dropsitphn": 2149482879,
    "dropsitlph": "",
    "dropsitcph": 9724533372,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018971",
    "droptype": "D",
    "dropname": "HIDENWOOD",
    "dropdeladd": "25 HIDENWOOD SHOPPING CTR",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236062228,
    "dropphyadd": "25 HIDENWOOD SHOPPING CTR",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236062228,
    "dropmaladd": "25 HIDENWOOD SHOPPING CTR",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236062228,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575967019,
    "dropsitcph": 7575950845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S018996",
    "droptype": "D",
    "dropname": "DOWNTOWN MONROE",
    "dropdeladd": "111 N 3RD ST",
    "dropdelcty": "MONROE",
    "dropdelst": "LA",
    "dropdelzpp": 712019995,
    "dropphyadd": "111 N 3RD ST",
    "dropphycty": "MONROE",
    "dropphyst": "LA",
    "dropphyzpp": 712019995,
    "dropmaladd": "111 N 3RD ST",
    "dropmalcty": "MONROE",
    "dropmalst": "LA",
    "dropmalzpp": 712019995,
    "dropsitphn": 3186772295,
    "dropsitlph": 3186772295,
    "dropsitcph": 3183223193,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019000",
    "droptype": "D",
    "dropname": "PLAZA SUNNYVALE",
    "dropdeladd": "510 E EL CAMINO REAL STE C",
    "dropdelcty": "SUNNYVALE",
    "dropdelst": "CA",
    "dropdelzpp": 940871989,
    "dropphyadd": "510 E EL CAMINO REAL STE C",
    "dropphycty": "SUNNYVALE",
    "dropphyst": "CA",
    "dropphyzpp": 940871989,
    "dropmaladd": "510 E EL CAMINO REAL STE C",
    "dropmalcty": "SUNNYVALE",
    "dropmalst": "CA",
    "dropmalzpp": 940871989,
    "dropsitphn": 4155505045,
    "dropsitlph": 4087380257,
    "dropsitcph": 4087380257,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019030",
    "droptype": "D",
    "dropname": "NOROTON HEIGHTS",
    "dropdeladd": "264 HEIGHTS RD",
    "dropdelcty": "DARIEN",
    "dropdelst": "CT",
    "dropdelzpp": "068209994",
    "dropphyadd": "264 HEIGHTS RD",
    "dropphycty": "DARIEN",
    "dropphyst": "CT",
    "dropphyzpp": "068209994",
    "dropmaladd": "264 HEIGHTS RD",
    "dropmalcty": "DARIEN",
    "dropmalst": "CT",
    "dropmalzpp": "068209994",
    "dropsitphn": 2036550631,
    "dropsitlph": 2036550631,
    "dropsitcph": 2036550631,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019036",
    "droptype": "D",
    "dropname": "BOWLING GREEN FIN STA",
    "dropdeladd": "628 STATE ST",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 421019997,
    "dropphyadd": "628 STATE ST",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 421019997,
    "dropmaladd": "628 STATE ST",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 421019997,
    "dropsitphn": 2708435760,
    "dropsitlph": "",
    "dropsitcph": 2708464485,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019050",
    "droptype": "D",
    "dropname": "POINT BREEZE POSTAL STORE",
    "dropdeladd": "2200 W OREGON AVE STE H3",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191459995,
    "dropphyadd": "2200 W OREGON AVE STE H3",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191459995,
    "dropmaladd": "2200 W OREGON AVE STE H3",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191459995,
    "dropsitphn": 2154652019,
    "dropsitlph": 2154652019,
    "dropsitcph": 2154652019,
    "dropfax": 2154651013
  },
  {
    "dcode": "D",
    "dropkey": "S019053",
    "droptype": "D",
    "dropname": "SOUTH",
    "dropdeladd": "1200 S HANOVER ST STE 100",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212303769,
    "dropphyadd": "1200 S HANOVER ST STE 100",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212303769,
    "dropmaladd": "1200 S HANOVER ST STE 100",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212303769,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103540821,
    "dropsitcph": 4103540821,
    "dropfax": 4105281280
  },
  {
    "dcode": "D",
    "dropkey": "S019061",
    "droptype": "D",
    "dropname": "OBERLIN VILLAGE",
    "dropdeladd": "806 OBERLIN RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276051131,
    "dropphyadd": "806 OBERLIN RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276051131,
    "dropmaladd": "806 OBERLIN RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276051131,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9198321186,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019067",
    "droptype": "D",
    "dropname": "ELLICOTT",
    "dropdeladd": "695 WASHINGTON ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142031412,
    "dropphyadd": "695 WASHINGTON ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142031412,
    "dropmaladd": "695 WASHINGTON ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142031412,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168564603,
    "dropfax": 7168564604
  },
  {
    "dcode": "D",
    "dropkey": "S019090",
    "droptype": "D",
    "dropname": "CHARLESTOWN",
    "dropdeladd": "3 AUSTIN ST",
    "dropdelcty": "CHARLESTOWN",
    "dropdelst": "MA",
    "dropdelzpp": "021293553",
    "dropphyadd": "3 AUSTIN ST",
    "dropphycty": "CHARLESTOWN",
    "dropphyst": "MA",
    "dropphyzpp": "021293553",
    "dropmaladd": "3 AUSTIN ST",
    "dropmalcty": "CHARLESTOWN",
    "dropmalst": "MA",
    "dropmalzpp": "021293553",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 8575880110,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019091",
    "droptype": "D",
    "dropname": "KENDALL SQUARE",
    "dropdeladd": "91 1ST ST",
    "dropdelcty": "CAMBRIDGE",
    "dropdelst": "MA",
    "dropdelzpp": "021411804",
    "dropphyadd": "91 1ST ST",
    "dropphycty": "CAMBRIDGE",
    "dropphyst": "MA",
    "dropphyzpp": "021411804",
    "dropmaladd": "91 1ST ST",
    "dropmalcty": "CAMBRIDGE",
    "dropmalst": "MA",
    "dropmalzpp": "021411804",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178765155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019094",
    "droptype": "D",
    "dropname": "PORT AUTHORITY HIGH LINE",
    "dropdeladd": "426A W 14TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100149805,
    "dropphyadd": "426A W 14TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100149805,
    "dropmaladd": "217 W 18TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100119998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123303618,
    "dropsitcph": 2123303618,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019097",
    "droptype": "D",
    "dropname": "RICHLAND",
    "dropdeladd": "235 JARI DR RM 108A",
    "dropdelcty": "JOHNSTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 159049990,
    "dropphyadd": "235 JARI DR RM 108A",
    "dropphycty": "JOHNSTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 159049990,
    "dropmaladd": "235 JARI DR RM 108A",
    "dropmalcty": "JOHNSTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 159049990,
    "dropsitphn": 8148367307,
    "dropsitlph": 8145334939,
    "dropsitcph": 8145334939,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019106",
    "droptype": "D",
    "dropname": "LUGONIA",
    "dropdeladd": "1275 W PARK AVE",
    "dropdelcty": "REDLANDS",
    "dropdelst": "CA",
    "dropdelzpp": 923738111,
    "dropphyadd": "1275 W PARK AVE",
    "dropphycty": "REDLANDS",
    "dropphyst": "CA",
    "dropphyzpp": 923738111,
    "dropmaladd": "1275 W PARK AVE",
    "dropmalcty": "REDLANDS",
    "dropmalst": "CA",
    "dropmalzpp": 923738111,
    "dropsitphn": 9093354694,
    "dropsitlph": 9097930755,
    "dropsitcph": 9097938075,
    "dropfax": 9097934981
  },
  {
    "dcode": "D",
    "dropkey": "S019123",
    "droptype": "D",
    "dropname": "ROSSLYN",
    "dropdeladd": "1550 WILSON BLVD STE 100",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222092415,
    "dropphyadd": "1550 WILSON BLVD STE 100",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222092415,
    "dropmaladd": "1550 WILSON BLVD STE 100",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222092415,
    "dropsitphn": 7036986367,
    "dropsitlph": 7032944081,
    "dropsitcph": 7032944081,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019137",
    "droptype": "D",
    "dropname": "DOWNTOWN ALEXANDRIA",
    "dropdeladd": "201 JOHNSTON ST STE 100",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "LA",
    "dropdelzpp": 713018324,
    "dropphyadd": "201 JOHNSTON ST STE 100",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "LA",
    "dropphyzpp": 713018324,
    "dropmaladd": "201 JOHNSTON ST STE 100",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "LA",
    "dropmalzpp": 713018324,
    "dropsitphn": 3184879402,
    "dropsitlph": 5045891027,
    "dropsitcph": 3184484436,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019210",
    "droptype": "D",
    "dropname": "SERNA",
    "dropdeladd": "1948 AUSTIN HWY",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782180015,
    "dropphyadd": "1948 AUSTIN HWY",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782180015,
    "dropmaladd": "1948 AUSTIN HWY",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782180015,
    "dropsitphn": 2103688387,
    "dropsitlph": 2109305780,
    "dropsitcph": 2108260230,
    "dropfax": 2108295893
  },
  {
    "dcode": "D",
    "dropkey": "S019212",
    "droptype": "D",
    "dropname": "VERNON DOWNTOWN",
    "dropdeladd": "116 S GRANT ST STE 110",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956789998,
    "dropphyadd": "116 S GRANT ST STE 110",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956789998,
    "dropmaladd": "116 S GRANT ST STE 110",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956789998,
    "dropsitphn": 9167843357,
    "dropsitlph": 9167821126,
    "dropsitcph": 9167823697,
    "dropfax": 9167843357
  },
  {
    "dcode": "D",
    "dropkey": "S019251",
    "droptype": "D",
    "dropname": "EAST UNION",
    "dropdeladd": "2207 E UNION ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981229998,
    "dropphyadd": "2207 E UNION ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981229998,
    "dropmaladd": "2207 E UNION ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981229998,
    "dropsitphn": 2063290155,
    "dropsitlph": 2063290155,
    "dropsitcph": 2063290155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019268",
    "droptype": "D",
    "dropname": "BUSH TERMINAL RETAIL",
    "dropdeladd": "775 4TH AVE STE 2",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112321415,
    "dropphyadd": "775 4TH AVE STE 2",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112321415,
    "dropmaladd": "775 4TH AVE STE 2",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112321415,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 9293973752,
    "dropfax": 7188402906
  },
  {
    "dcode": "D",
    "dropkey": "S019278",
    "droptype": "D",
    "dropname": "LA PLAZA GRANDE",
    "dropdeladd": "4 LAGRANDE BLVD",
    "dropdelcty": "LADY LAKE",
    "dropdelst": "FL",
    "dropdelzpp": 321592384,
    "dropphyadd": "4 LAGRANDE BLVD",
    "dropphycty": "LADY LAKE",
    "dropphyst": "FL",
    "dropphyzpp": 321592384,
    "dropmaladd": "4 LAGRANDE BLVD",
    "dropmalcty": "LADY LAKE",
    "dropmalst": "FL",
    "dropmalzpp": 321592384,
    "dropsitphn": 9043592957,
    "dropsitlph": 3527533888,
    "dropsitcph": 3527533888,
    "dropfax": 3527538844
  },
  {
    "dcode": "D",
    "dropkey": "S019280",
    "droptype": "D",
    "dropname": "NEPTUNE",
    "dropdeladd": "626 SHEEPSHEAD BAY RD STE 8",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112249904,
    "dropphyadd": "626 SHEEPSHEAD BAY RD STE 8",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112249904,
    "dropmaladd": "626 SHEEPSHEAD BAY RD STE 8",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112249904,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7183331320,
    "dropfax": 7182653538
  },
  {
    "dcode": "D",
    "dropkey": "S019298",
    "droptype": "D",
    "dropname": "KENMORE",
    "dropdeladd": "512 PARK DR",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "022159998",
    "dropphyadd": "512 PARK DR",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "022159998",
    "dropmaladd": "512 PARK DR",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "022159998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174211281,
    "dropfax": 6172668199
  },
  {
    "dcode": "D",
    "dropkey": "S019316",
    "droptype": "D",
    "dropname": "ATOCHA",
    "dropdeladd": "13 PASEO ATOCHA",
    "dropdelcty": "PONCE",
    "dropdelst": "PR",
    "dropdelzpp": "007309996",
    "dropphyadd": "13 PASEO ATOCHA",
    "dropphycty": "PONCE",
    "dropphyst": "PR",
    "dropphyzpp": "007309996",
    "dropmaladd": "13 PASEO ATOCHA",
    "dropmalcty": "PONCE",
    "dropmalst": "PR",
    "dropmalzpp": "007309996",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7878422997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019317",
    "droptype": "D",
    "dropname": "AIRPORT LOS ANGELES",
    "dropdeladd": "8821 AVIATION BLVD",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900099997,
    "dropphyadd": "8821 AVIATION BLVD",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900099997,
    "dropmaladd": "8821 AVIATION BLVD",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900099997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3106497403,
    "dropsitcph": 3106497401,
    "dropfax": 3106497451
  },
  {
    "dcode": "D",
    "dropkey": "S019738",
    "droptype": "D",
    "dropname": "DOWNTOWN LUFKIN",
    "dropdeladd": "601 E LUFKIN AVE",
    "dropdelcty": "LUFKIN",
    "dropdelst": "TX",
    "dropdelzpp": 759014043,
    "dropphyadd": "601 E LUFKIN AVE",
    "dropphycty": "LUFKIN",
    "dropphyst": "TX",
    "dropphyzpp": 759014043,
    "dropmaladd": "601 E LUFKIN AVE",
    "dropmalcty": "LUFKIN",
    "dropmalst": "TX",
    "dropmalzpp": 759014043,
    "dropsitphn": 2144675879,
    "dropsitlph": 9366347749,
    "dropsitcph": 9366347749,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019835",
    "droptype": "D",
    "dropname": "CLARKSBURG",
    "dropdeladd": "158 W MAIN ST",
    "dropdelcty": "CLARKSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 263015000,
    "dropphyadd": "158 W MAIN ST",
    "dropphycty": "CLARKSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 263015000,
    "dropmaladd": "158 W MAIN ST",
    "dropmalcty": "CLARKSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 263015000,
    "dropsitphn": 3046220791,
    "dropsitlph": 3046220791,
    "dropsitcph": 3046220791,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019856",
    "droptype": "D",
    "dropname": "ACADEMY",
    "dropdeladd": "363 ONTARIO ST STE 3",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122082929,
    "dropphyadd": "363 ONTARIO ST STE 3",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122082929,
    "dropmaladd": "363 ONTARIO ST STE 3",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122082929,
    "dropsitphn": 5184589548,
    "dropsitlph": 5184589548,
    "dropsitcph": 5184380188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019882",
    "droptype": "D",
    "dropname": "DOWNTOWN JOLIET",
    "dropdeladd": "51 E CLINTON ST",
    "dropdelcty": "JOLIET",
    "dropdelst": "IL",
    "dropdelzpp": 604324130,
    "dropphyadd": "51 E CLINTON ST",
    "dropphycty": "JOLIET",
    "dropphyst": "IL",
    "dropphyzpp": 604324130,
    "dropmaladd": "2000 MCDONOUGH ST",
    "dropmalcty": "JOLIET",
    "dropmalst": "IL",
    "dropmalzpp": 604369998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8157233663,
    "dropfax": 8157731079
  },
  {
    "dcode": "D",
    "dropkey": "S019919",
    "droptype": "D",
    "dropname": "MILAN",
    "dropdeladd": "2301 COLLEY AVE",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235179997,
    "dropphyadd": "2301 COLLEY AVE",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235179997,
    "dropmaladd": "2301 COLLEY AVE",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235179997,
    "dropsitphn": 7576642314,
    "dropsitlph": "",
    "dropsitcph": 7576292114,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S019960",
    "droptype": "D",
    "dropname": "LAKE ELSINORE FINANCE",
    "dropdeladd": "31724 CASINO DR",
    "dropdelcty": "LAKE ELSINORE",
    "dropdelst": "CA",
    "dropdelzpp": 925304510,
    "dropphyadd": "31724 CASINO DR",
    "dropphycty": "LAKE ELSINORE",
    "dropphyst": "CA",
    "dropphyzpp": 925304510,
    "dropmaladd": "31724 CASINO DR",
    "dropmalcty": "LAKE ELSINORE",
    "dropmalst": "CA",
    "dropmalzpp": 925304510,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516747402,
    "dropsitcph": 9516749726,
    "dropfax": 9516745481
  },
  {
    "dcode": "D",
    "dropkey": "S020018",
    "droptype": "D",
    "dropname": "ROCKEFELLER CENTER",
    "dropdeladd": "40 W 51ST ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100209993,
    "dropphyadd": "40 W 51ST ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100209993,
    "dropmaladd": "40 W 51ST ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100209993,
    "dropsitphn": 2123302770,
    "dropsitlph": 2122653855,
    "dropsitcph": 2122653855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020064",
    "droptype": "D",
    "dropname": "MIDTOWN",
    "dropdeladd": "1075 PEACHTREE ST NE STE 6",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303094883,
    "dropphyadd": "1075 PEACHTREE ST NE STE 6",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303094883,
    "dropmaladd": "1075 PEACHTREE ST NE STE 6",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303094883,
    "dropsitphn": 4047657578,
    "dropsitlph": "",
    "dropsitcph": 4048734813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020086",
    "droptype": "D",
    "dropname": "PORT AUTHORITY CONVEN. NEW",
    "dropdeladd": "625 8TH AVE SPC 110",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100189994,
    "dropphyadd": "625 8TH AVE SPC 110",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100189994,
    "dropmaladd": "625 8TH AVE SPC 110",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100189994,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 2125020432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020140",
    "droptype": "D",
    "dropname": "RIVER DISTRICT",
    "dropdeladd": "2017 NW VAUGHN ST",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972091815,
    "dropphyadd": "2017 NW VAUGHN ST",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972091815,
    "dropmaladd": "2017 NW VAUGHN ST",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972091815,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032942402,
    "dropsitcph": 5032243982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020150",
    "droptype": "D",
    "dropname": "SANFORD",
    "dropdeladd": "3500 W 6TH ST STE 103",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900209997,
    "dropphyadd": "3500 W 6TH ST STE 103",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900209997,
    "dropmaladd": "3500 W 6TH ST STE 103",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900209997,
    "dropsitphn": 3235861867,
    "dropsitlph": 2133822428,
    "dropsitcph": 2133821046,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020220",
    "droptype": "D",
    "dropname": "LAKE STREET",
    "dropdeladd": "110 E 31ST ST",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554089998,
    "dropphyadd": "110 E 31ST ST",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554089998,
    "dropmaladd": "110 E 31ST ST",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554089998,
    "dropsitphn": 6128235940,
    "dropsitlph": "",
    "dropsitcph": 6128244468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020221",
    "droptype": "D",
    "dropname": "MINNEHAHA",
    "dropdeladd": "3033 27TH AVE S",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554061914,
    "dropphyadd": "3033 27TH AVE S",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554061914,
    "dropmaladd": "3033 27TH AVE S",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554061914,
    "dropsitphn": 6127299347,
    "dropsitlph": "",
    "dropsitcph": 6128244468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020225",
    "droptype": "D",
    "dropname": "OLD POST OFFICE",
    "dropdeladd": "509 OLIVE ST",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631011844,
    "dropphyadd": "509 OLIVE ST",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631011844,
    "dropmaladd": "509 OLIVE ST",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631011844,
    "dropsitphn": 3148959275,
    "dropsitlph": "",
    "dropsitcph": 3146210137,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020483",
    "droptype": "D",
    "dropname": "MIDTOWN WOODLAND",
    "dropdeladd": "626 W LINCOLN AVE",
    "dropdelcty": "WOODLAND",
    "dropdelst": "CA",
    "dropdelzpp": 956959996,
    "dropphyadd": "626 W LINCOLN AVE",
    "dropphycty": "WOODLAND",
    "dropphyst": "CA",
    "dropphyzpp": 956959996,
    "dropmaladd": "626 W LINCOLN AVE",
    "dropmalcty": "WOODLAND",
    "dropmalst": "CA",
    "dropmalzpp": 956959996,
    "dropsitphn": 9163738025,
    "dropsitlph": 5306664196,
    "dropsitcph": 5306220832,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020490",
    "droptype": "D",
    "dropname": "FEDERAL SQUARE",
    "dropdeladd": "312 MARKET ST",
    "dropdelcty": "HARRISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 171089801,
    "dropphyadd": "312 MARKET ST",
    "dropphycty": "HARRISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 171089801,
    "dropmaladd": "312 MARKET ST",
    "dropmalcty": "HARRISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 171089801,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7172382203,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020504",
    "droptype": "D",
    "dropname": "BIG RIVER",
    "dropdeladd": "12047 NE GLENN WIDING DR",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972209050,
    "dropphyadd": "12047 NE GLENN WIDING DR",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972209050,
    "dropmaladd": "12047 NE GLENN WIDING DR",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972209050,
    "dropsitphn": 9712013698,
    "dropsitlph": 9712013697,
    "dropsitcph": 9712013697,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020518",
    "droptype": "D",
    "dropname": "COLUMBIA",
    "dropdeladd": "3795 S ALASKA ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981189924,
    "dropphyadd": "3795 S ALASKA ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981189924,
    "dropmaladd": "3795 S ALASKA ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981189924,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067215497,
    "dropsitcph": 2067215497,
    "dropfax": 6514566159
  },
  {
    "dcode": "D",
    "dropkey": "S020566",
    "droptype": "D",
    "dropname": "NORTH HILLS",
    "dropdeladd": "3016 WAKE FOREST RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276099800,
    "dropphyadd": "3016 WAKE FOREST RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276099800,
    "dropmaladd": "3016 WAKE FOREST RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276099800,
    "dropsitphn": 3369319444,
    "dropsitlph": "",
    "dropsitcph": 9198385051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020567",
    "droptype": "D",
    "dropname": "FRIENDLY",
    "dropdeladd": "3116 NORTHLINE AVE",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274089800,
    "dropphyadd": "3116 NORTHLINE AVE",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274089800,
    "dropmaladd": "3116 NORTHLINE AVE",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274089800,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3362946385,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020636",
    "droptype": "D",
    "dropname": "FORT STORY",
    "dropdeladd": "591 CEBU ISLAND RD",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234591000,
    "dropphyadd": "591 CEBU ISLAND RD",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234591000,
    "dropmaladd": "591 CEBU ISLAND RD",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234591000,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574227816,
    "dropsitcph": 7574227816,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020790",
    "droptype": "D",
    "dropname": "MEGA PASSPORT CTR",
    "dropdeladd": "415 PLASTERS AVE NE STE 100",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303249800,
    "dropphyadd": "415 PLASTERS AVE NE STE 100",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303249800,
    "dropmaladd": "415 PLASTERS AVE NE STE 100",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303249800,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047952231,
    "dropsitcph": 4048734813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020833",
    "droptype": "D",
    "dropname": "CHRISTOPHER COLUMBUS",
    "dropdeladd": "99 N HIGH ST",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432159998,
    "dropphyadd": "99 N HIGH ST",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432159998,
    "dropmaladd": "99 N HIGH ST",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432159998,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 6142282816,
    "dropfax": 6142280650
  },
  {
    "dcode": "D",
    "dropkey": "S020887",
    "droptype": "D",
    "dropname": "BAY NEW",
    "dropdeladd": "100 NEPTUNE AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112359992,
    "dropphyadd": "100 NEPTUNE AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112359992,
    "dropmaladd": "100 NEPTUNE AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112359992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186482057,
    "dropfax": 7186486388
  },
  {
    "dcode": "D",
    "dropkey": "S020918",
    "droptype": "D",
    "dropname": "DOWNTOWN SLC RETAIL EAQ",
    "dropdeladd": "386 W 500 S STE 20",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841012893,
    "dropphyadd": "386 W 500 S STE 20",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841012893,
    "dropmaladd": "386 W 500 S STE 20",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841012893,
    "dropsitphn": 8019742558,
    "dropsitlph": "",
    "dropsitcph": 8015325501,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S020919",
    "droptype": "D",
    "dropname": "SOUTH PROVIDENCE NEW",
    "dropdeladd": "6416 REA RD STE B7",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282779761,
    "dropphyadd": "6416 REA RD STE B7",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282779761,
    "dropmaladd": "6416 REA RD STE B7",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282779761,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045400171,
    "dropsitcph": 7045400171,
    "dropfax": 7048411956
  },
  {
    "dcode": "D",
    "dropkey": "S020928",
    "droptype": "D",
    "dropname": "TUKWILA NEW",
    "dropdeladd": "1233 ANDOVER PARK E STE 100",
    "dropdelcty": "TUKWILA",
    "dropdelst": "WA",
    "dropdelzpp": 981889910,
    "dropphyadd": "1233 ANDOVER PARK E STE 100",
    "dropphycty": "TUKWILA",
    "dropphyst": "WA",
    "dropphyzpp": 981889910,
    "dropmaladd": "1233 ANDOVER PARK E STE 100",
    "dropmalcty": "TUKWILA",
    "dropmalst": "WA",
    "dropmalzpp": 981889910,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062437079,
    "dropsitcph": 2062449592,
    "dropfax": 6514566277
  },
  {
    "dcode": "D",
    "dropkey": "S020931",
    "droptype": "D",
    "dropname": "ROXBOROUGH POSTAL STORE NEW",
    "dropdeladd": "6808 RIDGE AVE",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191282538,
    "dropphyadd": "6808 RIDGE AVE",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191282538,
    "dropmaladd": "6808 RIDGE AVE",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191282538,
    "dropsitphn": 2155089206,
    "dropsitlph": 2155089206,
    "dropsitcph": 2154821779,
    "dropfax": 2154823540
  },
  {
    "dcode": "D",
    "dropkey": "S021016",
    "droptype": "D",
    "dropname": "AMC RETAIL CENTER NEW",
    "dropdeladd": "552 W LAYTON AVE STE E",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532079903,
    "dropphyadd": "552 W LAYTON AVE STE E",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532079903,
    "dropmaladd": "552 W LAYTON AVE STE E",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532079903,
    "dropsitphn": 4142702120,
    "dropsitlph": 4144810272,
    "dropsitcph": 4144810272,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021019",
    "droptype": "D",
    "dropname": "LOCKPORT NEW",
    "dropdeladd": "950 E 9TH ST",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 604419900,
    "dropphyadd": "950 E 9TH ST",
    "dropphycty": "LOCKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 604419900,
    "dropmaladd": "950 E 9TH ST",
    "dropmalcty": "LOCKPORT",
    "dropmalst": "IL",
    "dropmalzpp": 604419900,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 8158380656,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021038",
    "droptype": "D",
    "dropname": "TEMPLE HEIGHTS",
    "dropdeladd": "1635 CONNECTICUT AVE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200099901,
    "dropphyadd": "1635 CONNECTICUT AVE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200099901,
    "dropmaladd": "1635 CONNECTICUT AVE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200099901,
    "dropsitphn": 3014997331,
    "dropsitlph": 2022344253,
    "dropsitcph": 2022344253,
    "dropfax": 2025232060
  },
  {
    "dcode": "D",
    "dropkey": "S021049",
    "droptype": "D",
    "dropname": "BENNING NEW",
    "dropdeladd": "3924 MINNESOTA AVE NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200199900,
    "dropphyadd": "3924 MINNESOTA AVE NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200199900,
    "dropmaladd": "3924 MINNESOTA AVE NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200199900,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232390,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021050",
    "droptype": "D",
    "dropname": "14TH ST NEW",
    "dropdeladd": "1830 14TH ST NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200199901,
    "dropphyadd": "1830 14TH ST NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200199901,
    "dropmaladd": "1830 14TH ST NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200199901,
    "dropsitphn": 3014997331,
    "dropsitlph": 2022326301,
    "dropsitcph": 2026361259,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021120",
    "droptype": "D",
    "dropname": "ACADEMY NEW",
    "dropdeladd": "563 NEW SCOTLAND AVE STE 2",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122089998,
    "dropphyadd": "563 NEW SCOTLAND AVE STE 2",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122089998,
    "dropmaladd": "563 NEW SCOTLAND AVE STE 2",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122089998,
    "dropsitphn": 5184589548,
    "dropsitlph": 5184589548,
    "dropsitcph": 5184380188,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021207",
    "droptype": "D",
    "dropname": "ARLINGTON ROAD STATION NEW",
    "dropdeladd": "5364 WESTBARD AVE",
    "dropdelcty": "BETHESDA",
    "dropdelst": "MD",
    "dropdelzpp": 208169912,
    "dropphyadd": "5364 WESTBARD AVE",
    "dropphycty": "BETHESDA",
    "dropphyst": "MD",
    "dropphyzpp": 208169912,
    "dropmaladd": "5364 WESTBARD AVE",
    "dropmalcty": "BETHESDA",
    "dropmalst": "MD",
    "dropmalzpp": 208169912,
    "dropsitphn": 3014997331,
    "dropsitlph": 3019412681,
    "dropsitcph": 3019412682,
    "dropfax": 3019412687
  },
  {
    "dcode": "D",
    "dropkey": "S021209",
    "droptype": "D",
    "dropname": "GERMAN VILLAGE NEW",
    "dropdeladd": "1612 LOCKBOURNE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432079997,
    "dropphyadd": "1612 LOCKBOURNE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432079997,
    "dropmaladd": "1612 LOCKBOURNE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432079997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144499565,
    "dropsitcph": 6144499565,
    "dropfax": 6144499553
  },
  {
    "dcode": "D",
    "dropkey": "S021232",
    "droptype": "D",
    "dropname": "CRYSTAL CITY NEW",
    "dropdeladd": "320 23RD ST S STE 75",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222029812,
    "dropphyadd": "320 23RD ST S STE 75",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222029812,
    "dropmaladd": "320 23RD ST S STE 75",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222029812,
    "dropsitphn": 7036986367,
    "dropsitlph": "",
    "dropsitcph": 7034139268,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "S021285",
    "droptype": "D",
    "dropname": "HARPER NEW",
    "dropdeladd": "10784 GRATIOT AVE",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482139998,
    "dropphyadd": "10784 GRATIOT AVE",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482139998,
    "dropmaladd": "10784 GRATIOT AVE",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482139998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3139238249,
    "dropsitcph": 3139238249,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4V1A546",
    "droptype": "D",
    "dropname": "ROCHDALE CARRIER ANNEX",
    "dropdeladd": "12045 168TH ST",
    "dropdelcty": "JAMAICA",
    "dropdelst": "NY",
    "dropdelzpp": 114349993,
    "dropphyadd": "12045 168TH ST",
    "dropphycty": "JAMAICA",
    "dropphyst": "NY",
    "dropphyzpp": 114349993,
    "dropmaladd": "12045 168TH ST",
    "dropmalcty": "JAMAICA",
    "dropmalst": "NY",
    "dropmalzpp": 114349993,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 7185285398,
    "dropfax": 7185289057
  },
  {
    "dcode": "D",
    "dropkey": "4V1A563",
    "droptype": "D",
    "dropname": "LANCASTER DEPEW CARRIER UNIT",
    "dropdeladd": "1763 COMO PARK BLVD",
    "dropdelcty": "DEPEW",
    "dropdelst": "NY",
    "dropdelzpp": 140439993,
    "dropphyadd": "1763 COMO PARK BLVD",
    "dropphycty": "DEPEW",
    "dropphyst": "NY",
    "dropphyzpp": 140439993,
    "dropmaladd": "1763 COMO PARK BLVD",
    "dropmalcty": "DEPEW",
    "dropmalst": "NY",
    "dropmalzpp": 140439993,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7166815396,
    "dropfax": 7166865753
  },
  {
    "dcode": "D",
    "dropkey": "4V10350",
    "droptype": "D",
    "dropname": "DOVER ANNEX",
    "dropdeladd": "321 RICHARD MINE RD",
    "dropdelcty": "DOVER",
    "dropdelst": "NJ",
    "dropdelzpp": "078011623",
    "dropphyadd": "321 RICHARD MINE RD",
    "dropphycty": "DOVER",
    "dropphyst": "NJ",
    "dropphyzpp": "078011623",
    "dropmaladd": "321 RICHARD MINE RD",
    "dropmalcty": "DOVER",
    "dropmalst": "NJ",
    "dropmalzpp": "078011623",
    "dropsitphn": 9735157868,
    "dropsitlph": 8623975992,
    "dropsitcph": 8623975992,
    "dropfax": 6505774011
  },
  {
    "dcode": "D",
    "dropkey": "4V11053",
    "droptype": "D",
    "dropname": "BELLEVILLE ANNEX",
    "dropdeladd": "525 MAIN ST",
    "dropdelcty": "BELLEVILLE",
    "dropdelst": "NJ",
    "dropdelzpp": "071099997",
    "dropphyadd": "525 MAIN ST",
    "dropphycty": "BELLEVILLE",
    "dropphyst": "NJ",
    "dropphyzpp": "071099997",
    "dropmaladd": "525 MAIN ST",
    "dropmalcty": "BELLEVILLE",
    "dropmalst": "NJ",
    "dropmalzpp": "071099997",
    "dropsitphn": 2019559705,
    "dropsitlph": 9737597652,
    "dropsitcph": 9737597652,
    "dropfax": 6505774412
  },
  {
    "dcode": "D",
    "dropkey": "4V12091",
    "droptype": "D",
    "dropname": "BAYSIDE ANNEX",
    "dropdeladd": "4129 216TH ST",
    "dropdelcty": "BAYSIDE",
    "dropdelst": "NY",
    "dropdelzpp": 113619992,
    "dropphyadd": "4129 216TH ST",
    "dropphycty": "BAYSIDE",
    "dropphyst": "NY",
    "dropphyzpp": 113619992,
    "dropmaladd": "4129 216TH ST",
    "dropmalcty": "BAYSIDE",
    "dropmalst": "NY",
    "dropmalzpp": 113619992,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182298578,
    "dropfax": 7182254750
  },
  {
    "dcode": "D",
    "dropkey": "4V13456",
    "droptype": "D",
    "dropname": "FRESH MEADOWS CARRIER ANNEX",
    "dropdeladd": "19220 HORACE HARDING EXPY",
    "dropdelcty": "FRESH MEADOWS",
    "dropdelst": "NY",
    "dropdelzpp": 113659997,
    "dropphyadd": "19220 HORACE HARDING EXPY",
    "dropphycty": "FRESH MEADOWS",
    "dropphyst": "NY",
    "dropphyzpp": 113659997,
    "dropmaladd": "19220 HORACE HARDING EXPY",
    "dropmalcty": "FRESH MEADOWS",
    "dropmalst": "NY",
    "dropmalzpp": 113659997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184548693,
    "dropfax": 7184541100
  },
  {
    "dcode": "D",
    "dropkey": "4V13919",
    "droptype": "D",
    "dropname": "HOMECREST",
    "dropdeladd": "2370 E 19TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112299997,
    "dropphyadd": "2370 E 19TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112299997,
    "dropmaladd": "2370 E 19TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112299997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7187438236,
    "dropfax": 7187695542
  },
  {
    "dcode": "D",
    "dropkey": "4V14818",
    "droptype": "D",
    "dropname": "MURRAY HILL ANNEX",
    "dropdeladd": "205 E 36TH ST",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100169998,
    "dropphyadd": "205 E 36TH ST",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100169998,
    "dropmaladd": "205 E 36TH ST",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100169998,
    "dropsitphn": 2123302770,
    "dropsitlph": 2125450836,
    "dropsitcph": 2125450836,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4V15834",
    "droptype": "D",
    "dropname": "RYDER",
    "dropdeladd": "1739 E 45TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112349997,
    "dropphyadd": "1739 E 45TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112349997,
    "dropmaladd": "1739 E 45TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112349997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7182580258,
    "dropfax": 7182537255
  },
  {
    "dcode": "D",
    "dropkey": "4V18852",
    "droptype": "D",
    "dropname": "ALBANY ANNEX",
    "dropdeladd": "747 BROADWAY",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122079211,
    "dropphyadd": "747 BROADWAY",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122079211,
    "dropmaladd": "747 BROADWAY",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122079211,
    "dropsitphn": 5184262287,
    "dropsitlph": 5184262287,
    "dropsitcph": 5184262287,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4V19811",
    "droptype": "D",
    "dropname": "ARLINGTON CARRIER ANNEX",
    "dropdeladd": "50 PAGE PARK DR",
    "dropdelcty": "POUGHKEEPSIE",
    "dropdelst": "NY",
    "dropdelzpp": 126032558,
    "dropphyadd": "50 PAGE PARK DR",
    "dropphycty": "POUGHKEEPSIE",
    "dropphyst": "NY",
    "dropphyzpp": 126032558,
    "dropmaladd": "50 PAGE PARK DR",
    "dropmalcty": "POUGHKEEPSIE",
    "dropmalst": "NY",
    "dropmalzpp": 126032558,
    "dropsitphn": 9146974123,
    "dropsitlph": 8454852736,
    "dropsitcph": 8454852736,
    "dropfax": 8454859394
  },
  {
    "dcode": "D",
    "dropkey": "4V19874",
    "droptype": "D",
    "dropname": "FORT LEE ANNEX",
    "dropdeladd": "360 SYLVAN AVE STE 3",
    "dropdelcty": "ENGLEWOOD CLIFFS",
    "dropdelst": "NJ",
    "dropdelzpp": "076322721",
    "dropphyadd": "360 SYLVAN AVE STE 3",
    "dropphycty": "ENGLEWOOD CLIFFS",
    "dropphyst": "NJ",
    "dropphyzpp": "076322721",
    "dropmaladd": "231 MAIN ST FL 1",
    "dropmalcty": "FORT LEE",
    "dropmalst": "NJ",
    "dropmalzpp": "070249995",
    "dropsitphn": 2019559705,
    "dropsitlph": 2015672739,
    "dropsitcph": 2015672739,
    "dropfax": 6505774368
  },
  {
    "dcode": "D",
    "dropkey": "4V20400",
    "droptype": "D",
    "dropname": "MURPHY RD CARRIER ANNEX",
    "dropdeladd": "70 MURPHY RD STE 1",
    "dropdelcty": "HARTFORD",
    "dropdelst": "CT",
    "dropdelzpp": "061142170",
    "dropphyadd": "70 MURPHY RD STE 1",
    "dropphycty": "HARTFORD",
    "dropphyst": "CT",
    "dropphyzpp": "061142170",
    "dropmaladd": "70 MURPHY RD STE 1",
    "dropmalcty": "HARTFORD",
    "dropmalst": "CT",
    "dropmalzpp": "061142170",
    "dropsitphn": 8604936325,
    "dropsitlph": 8604936325,
    "dropsitcph": 8604936325,
    "dropfax": 8604936339
  },
  {
    "dcode": "D",
    "dropkey": "4V21668",
    "droptype": "D",
    "dropname": "DORCHESTER CENTER",
    "dropdeladd": "450 TALBOT AVE",
    "dropdelcty": "DORCHESTER CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "021249998",
    "dropphyadd": "450 TALBOT AVE",
    "dropphycty": "DORCHESTER CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "021249998",
    "dropmaladd": "450 TALBOT AVE",
    "dropmalcty": "DORCHESTER CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "021249998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178257534,
    "dropfax": 6172653276
  },
  {
    "dcode": "D",
    "dropkey": "4V22169",
    "droptype": "D",
    "dropname": "NEWTON CENTER CARRIER ANNEX",
    "dropdeladd": "211 SUMNER ST",
    "dropdelcty": "NEWTON CENTER",
    "dropdelst": "MA",
    "dropdelzpp": "024599998",
    "dropphyadd": "211 SUMNER ST",
    "dropphycty": "NEWTON CENTER",
    "dropphyst": "MA",
    "dropphyzpp": "024599998",
    "dropmaladd": "211 SUMNER ST",
    "dropmalcty": "NEWTON CENTER",
    "dropmalst": "MA",
    "dropmalzpp": "024599998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6172442351,
    "dropfax": 6179642436
  },
  {
    "dcode": "D",
    "dropkey": "4V24870",
    "droptype": "D",
    "dropname": "EASTERN MAINE CARRIER ANNEX",
    "dropdeladd": "16 PENOBSCOT MEADOW DR",
    "dropdelcty": "HAMPDEN",
    "dropdelst": "ME",
    "dropdelzpp": "044447096",
    "dropphyadd": "16 PENOBSCOT MEADOW DR",
    "dropphycty": "HAMPDEN",
    "dropphyst": "ME",
    "dropphyzpp": "044447096",
    "dropmaladd": "16 PENOBSCOT MEADOW DR",
    "dropmalcty": "HAMPDEN",
    "dropmalst": "ME",
    "dropmalzpp": "044447096",
    "dropsitphn": 2075102795,
    "dropsitlph": 2079412012,
    "dropsitcph": 2079412063,
    "dropfax": 2079412023
  },
  {
    "dcode": "D",
    "dropkey": "4V25402",
    "droptype": "D",
    "dropname": "CONCORD ANNEX",
    "dropdeladd": "22 CHENELL DR",
    "dropdelcty": "CONCORD",
    "dropdelst": "NH",
    "dropdelzpp": "033019997",
    "dropphyadd": "22 CHENELL DR",
    "dropphycty": "CONCORD",
    "dropphyst": "NH",
    "dropphyzpp": "033019997",
    "dropmaladd": "18 LOUDON RD",
    "dropmalcty": "CONCORD",
    "dropmalst": "NH",
    "dropmalzpp": "033019998",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6032255536,
    "dropfax": 6032249780
  },
  {
    "dcode": "D",
    "dropkey": "4V25907",
    "droptype": "D",
    "dropname": "CORLISS PARK STATION",
    "dropdeladd": "55 CORLISS ST RM 100",
    "dropdelcty": "PROVIDENCE",
    "dropdelst": "RI",
    "dropdelzpp": "029049712",
    "dropphyadd": "55 CORLISS ST RM 100",
    "dropphycty": "PROVIDENCE",
    "dropphyst": "RI",
    "dropphyzpp": "029049712",
    "dropmaladd": "55 CORLISS ST RM 100",
    "dropmalcty": "PROVIDENCE",
    "dropmalst": "RI",
    "dropmalzpp": "029049712",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 4017525214,
    "dropfax": 4017525250
  },
  {
    "dcode": "D",
    "dropkey": "4V27316",
    "droptype": "D",
    "dropname": "MANCHESTER SOUTH",
    "dropdeladd": "7 PERIMETER RD STE 2",
    "dropdelcty": "MANCHESTER",
    "dropdelst": "NH",
    "dropdelzpp": "031033343",
    "dropphyadd": "7 PERIMETER RD STE 2",
    "dropphycty": "MANCHESTER",
    "dropphyst": "NH",
    "dropphyzpp": "031033343",
    "dropmaladd": "7 PERIMETER RD STE 2",
    "dropmalcty": "MANCHESTER",
    "dropmalst": "NH",
    "dropmalzpp": "031033343",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036260372,
    "dropfax": 6036471388
  },
  {
    "dcode": "D",
    "dropkey": "4V27317",
    "droptype": "D",
    "dropname": "MANCHESTER WEST",
    "dropdeladd": "10 LANCE LN",
    "dropdelcty": "GOFFSTOWN",
    "dropdelst": "NH",
    "dropdelzpp": "030459719",
    "dropphyadd": "10 LANCE LN",
    "dropphycty": "GOFFSTOWN",
    "dropphyst": "NH",
    "dropphyzpp": "030459719",
    "dropmaladd": "10 LANCE LN",
    "dropmalcty": "GOFFSTOWN",
    "dropmalst": "NH",
    "dropmalzpp": "030459719",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036242884,
    "dropsitcph": 6036242884,
    "dropfax": 6036471699
  },
  {
    "dcode": "D",
    "dropkey": "4V27355",
    "droptype": "D",
    "dropname": "GOVERNMENT MAILS ANNEX",
    "dropdeladd": "3300 V ST",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200181528,
    "dropphyadd": "3300 V ST",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200181528,
    "dropmaladd": "3300 V ST",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200181528,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232138,
    "dropsitcph": 2025232138,
    "dropfax": 2025232042
  },
  {
    "dcode": "D",
    "dropkey": "4V27534",
    "droptype": "D",
    "dropname": "HYDE PARK CARRIER ANNEX",
    "dropdeladd": "1575 HYDE PARK AVE",
    "dropdelcty": "HYDE PARK",
    "dropdelst": "MA",
    "dropdelzpp": "021369998",
    "dropphyadd": "1575 HYDE PARK AVE",
    "dropphycty": "HYDE PARK",
    "dropphyst": "MA",
    "dropphyzpp": "021369998",
    "dropmaladd": "1575 HYDE PARK AVE",
    "dropmalcty": "HYDE PARK",
    "dropmalst": "MA",
    "dropmalzpp": "021369998",
    "dropsitphn": 6173642760,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173648190,
    "dropfax": 6173641168
  },
  {
    "dcode": "D",
    "dropkey": "4V27562",
    "droptype": "D",
    "dropname": "SILVER SPRING CARRIER ANNEX",
    "dropdeladd": "12010 PLUM ORCHARD DR",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209047878,
    "dropphyadd": "12010 PLUM ORCHARD DR",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209047878,
    "dropmaladd": "12010 PLUM ORCHARD DR",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209047878,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015867611,
    "dropsitcph": 3015867612,
    "dropfax": 3015860093
  },
  {
    "dcode": "D",
    "dropkey": "4V27568",
    "droptype": "D",
    "dropname": "INDUSTRIAL PARK ANNEX",
    "dropdeladd": "81 INDUSTRIAL PARK RD",
    "dropdelcty": "SACO",
    "dropdelst": "ME",
    "dropdelzpp": "040721872",
    "dropphyadd": "81 INDUSTRIAL PARK RD",
    "dropphycty": "SACO",
    "dropphyst": "ME",
    "dropphyzpp": "040721872",
    "dropmaladd": "81 INDUSTRIAL PARK RD",
    "dropmalcty": "SACO",
    "dropmalst": "ME",
    "dropmalzpp": "040721872",
    "dropsitphn": 2075102795,
    "dropsitlph": 2072845971,
    "dropsitcph": 2072845971,
    "dropfax": 2072869788
  },
  {
    "dcode": "D",
    "dropkey": "4V27585",
    "droptype": "D",
    "dropname": "CENTERPOINT",
    "dropdeladd": "105 JOHNSON WAY",
    "dropdelcty": "HISTORIC NEW CASTLE",
    "dropdelst": "DE",
    "dropdelzpp": 197209997,
    "dropphyadd": "105 JOHNSON WAY",
    "dropphycty": "HISTORIC NEW CASTLE",
    "dropphyst": "DE",
    "dropphyzpp": 197209997,
    "dropmaladd": "105 JOHNSON WAY",
    "dropmalcty": "HISTORIC NEW CASTLE",
    "dropmalst": "DE",
    "dropmalzpp": 197209997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3023286472,
    "dropfax": 3023282671
  },
  {
    "dcode": "D",
    "dropkey": "4V27668",
    "droptype": "D",
    "dropname": "FENWAY CARRIER ANNEX",
    "dropdeladd": "1313 BOYLSTON ST",
    "dropdelcty": "BOSTON",
    "dropdelst": "MA",
    "dropdelzpp": "022159997",
    "dropphyadd": "1313 BOYLSTON ST",
    "dropphycty": "BOSTON",
    "dropphyst": "MA",
    "dropphyzpp": "022159997",
    "dropmaladd": "1313 BOYLSTON ST",
    "dropmalcty": "BOSTON",
    "dropmalst": "MA",
    "dropmalzpp": "022159997",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6173759666,
    "dropfax": 6173750203
  },
  {
    "dcode": "D",
    "dropkey": "4V28227",
    "droptype": "D",
    "dropname": "SHREWSBURY ANNEX",
    "dropdeladd": "194 MAIN ST",
    "dropdelcty": "SHREWSBURY",
    "dropdelst": "MA",
    "dropdelzpp": "015458194",
    "dropphyadd": "194 MAIN ST",
    "dropphycty": "SHREWSBURY",
    "dropphyst": "MA",
    "dropphyzpp": "015458194",
    "dropmaladd": "194 MAIN ST",
    "dropmalcty": "SHREWSBURY",
    "dropmalst": "MA",
    "dropmalzpp": "015458194",
    "dropsitphn": 9786647013,
    "dropsitlph": 5087935965,
    "dropsitcph": 5087935965,
    "dropfax": 5087935190
  },
  {
    "dcode": "D",
    "dropkey": "4V28245",
    "droptype": "D",
    "dropname": "LAUREL CARRIER ANNEX",
    "dropdeladd": "123 WASHINGTON BLVD S",
    "dropdelcty": "LAUREL",
    "dropdelst": "MD",
    "dropdelzpp": 207079997,
    "dropphyadd": "123 WASHINGTON BLVD S",
    "dropphycty": "LAUREL",
    "dropphyst": "MD",
    "dropphyzpp": 207079997,
    "dropmaladd": "123 WASHINGTON BLVD S",
    "dropmalcty": "LAUREL",
    "dropmalst": "MD",
    "dropmalzpp": 207079997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3014836458,
    "dropsitcph": 3014836458,
    "dropfax": 3014830929
  },
  {
    "dcode": "D",
    "dropkey": "4V28252",
    "droptype": "D",
    "dropname": "NANTUCKET CARRIER ANNEX",
    "dropdeladd": "155 OLD SOUTH RD",
    "dropdelcty": "NANTUCKET",
    "dropdelst": "MA",
    "dropdelzpp": "025549990",
    "dropphyadd": "155 OLD SOUTH RD",
    "dropphycty": "NANTUCKET",
    "dropphyst": "MA",
    "dropphyzpp": "025549990",
    "dropmaladd": "155 OLD SOUTH RD",
    "dropmalcty": "NANTUCKET",
    "dropmalst": "MA",
    "dropmalzpp": "025546089",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5083255987,
    "dropfax": 5083255887
  },
  {
    "dcode": "D",
    "dropkey": "4V28283",
    "droptype": "D",
    "dropname": "BALTIMORE CARRIER ANNEX",
    "dropdeladd": "1000 E LEXINGTON ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212029998,
    "dropphyadd": "1000 E LEXINGTON ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212029998,
    "dropmaladd": "1000 E LEXINGTON ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212029998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474463,
    "dropsitcph": 4103474463,
    "dropfax": 4102348619
  },
  {
    "dcode": "D",
    "dropkey": "4V28364",
    "droptype": "D",
    "dropname": "MILFORD ANNEX",
    "dropdeladd": "14 CAPRON RD",
    "dropdelcty": "MILFORD",
    "dropdelst": "NH",
    "dropdelzpp": "030559997",
    "dropphyadd": "14 CAPRON RD",
    "dropphycty": "MILFORD",
    "dropphyst": "NH",
    "dropphyzpp": "030559997",
    "dropmaladd": "12 MONT VERNON ST",
    "dropmalcty": "MILFORD",
    "dropmalst": "NH",
    "dropmalzpp": "030554566",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6036721983,
    "dropfax": 6036725917
  },
  {
    "dcode": "D",
    "dropkey": "4W1B773",
    "droptype": "D",
    "dropname": "WEST SIDE ANNEX",
    "dropdeladd": "4555 FUTURO CT",
    "dropdelcty": "DUBUQUE",
    "dropdelst": "IA",
    "dropdelzpp": 520029996,
    "dropphyadd": "4555 FUTURO CT",
    "dropphycty": "DUBUQUE",
    "dropphyst": "IA",
    "dropphyzpp": 520029996,
    "dropmaladd": "4555 FUTURO CT",
    "dropmalcty": "DUBUQUE",
    "dropmalst": "IA",
    "dropmalzpp": 520029996,
    "dropsitphn": 5152837530,
    "dropsitlph": 5635822997,
    "dropsitcph": 5635822997,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1B817",
    "droptype": "D",
    "dropname": "FAIRFIELD CARRIER STA",
    "dropdeladd": "203 S 23RD ST",
    "dropdelcty": "FAIRFIELD",
    "dropdelst": "IA",
    "dropdelzpp": 525564250,
    "dropphyadd": "203 S 23RD ST",
    "dropphycty": "FAIRFIELD",
    "dropphyst": "IA",
    "dropphyzpp": 525564250,
    "dropmaladd": "203 S 23RD ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "IA",
    "dropmalzpp": 525564250,
    "dropsitphn": 5152837530,
    "dropsitlph": 6414725015,
    "dropsitcph": 6414725015,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1C019",
    "droptype": "D",
    "dropname": "CHENEY RIDGE ANNEX",
    "dropdeladd": "5301 RED ROCK LN",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685169998,
    "dropphyadd": "5301 RED ROCK LN",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685169998,
    "dropmaladd": "5301 RED ROCK LN",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685169998,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024202072,
    "dropsitcph": 4024202009,
    "dropfax": 4024211289
  },
  {
    "dcode": "D",
    "dropkey": "4W1C037",
    "droptype": "D",
    "dropname": "TRI CITY CARRIER ANNEX",
    "dropdeladd": "701 W HOLBROOK RD",
    "dropdelcty": "GLENWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 604259800,
    "dropphyadd": "701 W HOLBROOK RD",
    "dropphycty": "GLENWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 604259800,
    "dropmaladd": "701 W HOLBROOK RD",
    "dropmalcty": "GLENWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 604259800,
    "dropsitphn": 7087540674,
    "dropsitlph": 7085635789,
    "dropsitcph": 7087540674,
    "dropfax": 7087546317
  },
  {
    "dcode": "D",
    "dropkey": "4W1C079",
    "droptype": "D",
    "dropname": "NORTHEAST ANNEX",
    "dropdeladd": "1927 E SANGAMON AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "IL",
    "dropdelzpp": 627029998,
    "dropphyadd": "1927 E SANGAMON AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "IL",
    "dropphyzpp": 627029998,
    "dropmaladd": "1927 E SANGAMON AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "IL",
    "dropmalzpp": 627029998,
    "dropsitphn": 2177887407,
    "dropsitlph": 2177882480,
    "dropsitcph": 2177882480,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1C083",
    "droptype": "D",
    "dropname": "WEST GLEN STATION",
    "dropdeladd": "715 W GLEN AVE",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616144875,
    "dropphyadd": "715 W GLEN AVE",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616144875,
    "dropmaladd": "715 W GLEN AVE",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616144875,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096912852,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1C084",
    "droptype": "D",
    "dropname": "PERSIMMON ANNEX",
    "dropdeladd": "90 PERSIMMON ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616029998,
    "dropphyadd": "90 PERSIMMON ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616029998,
    "dropmaladd": "90 PERSIMMON ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616029998,
    "dropsitphn": 3096718826,
    "dropsitlph": 7085637318,
    "dropsitcph": 3096718924,
    "dropfax": 3096748983
  },
  {
    "dcode": "D",
    "dropkey": "4W1C096",
    "droptype": "D",
    "dropname": "STONEYRIDGE",
    "dropdeladd": "5720 S 142ND ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681372891,
    "dropphyadd": "5720 S 142ND ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681372891,
    "dropmaladd": "5720 S 142ND ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681372891,
    "dropsitphn": 4023482736,
    "dropsitlph": 4028918978,
    "dropsitcph": 4028918961,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1C174",
    "droptype": "D",
    "dropname": "NEW TOWNE ROCKFORD CARR ANNX",
    "dropdeladd": "5225 HARRISON AVE RM 100",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611259302,
    "dropphyadd": "5225 HARRISON AVE RM 100",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611259302,
    "dropmaladd": "5225 HARRISON AVE RM 100",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611259302,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152294801,
    "dropsitcph": 8152294801,
    "dropfax": 8152270332
  },
  {
    "dcode": "D",
    "dropkey": "4W1C509",
    "droptype": "D",
    "dropname": "RIVERTON ANNEX",
    "dropdeladd": "1307 W MAIN ST",
    "dropdelcty": "RIVERTON",
    "dropdelst": "WY",
    "dropdelzpp": 825019997,
    "dropphyadd": "1307 W MAIN ST",
    "dropphycty": "RIVERTON",
    "dropphyst": "WY",
    "dropphyzpp": 825019997,
    "dropmaladd": "1307 W MAIN ST",
    "dropmalcty": "RIVERTON",
    "dropmalst": "WY",
    "dropmalzpp": 825019997,
    "dropsitphn": 3077726524,
    "dropsitlph": 3078560127,
    "dropsitcph": 3078570127,
    "dropfax": 3078560518
  },
  {
    "dcode": "D",
    "dropkey": "4W1C567",
    "droptype": "D",
    "dropname": "TIGER",
    "dropdeladd": "3212B LEMONE INDUSTRIAL BLVD",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MO",
    "dropdelzpp": 652019997,
    "dropphyadd": "3212B LEMONE INDUSTRIAL BLVD",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MO",
    "dropphyzpp": 652019997,
    "dropmaladd": "3212B LEMONE INDUSTRIAL BLVD",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MO",
    "dropmalzpp": 652019997,
    "dropsitphn": 3148959275,
    "dropsitlph": 5734411862,
    "dropsitcph": 5734411862,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W1C584",
    "droptype": "D",
    "dropname": "SPFD S W CARRIER ANNEX",
    "dropdeladd": "3951 S CAMPBELL AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658079998,
    "dropphyadd": "3951 S CAMPBELL AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658079998,
    "dropmaladd": "3951 S CAMPBELL AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658079998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178866847,
    "dropsitcph": 4178860023,
    "dropfax": 4178866744
  },
  {
    "dcode": "D",
    "dropkey": "4W1C585",
    "droptype": "D",
    "dropname": "SPFD GRIESEMER ANNEX",
    "dropdeladd": "1919 W BENNETT ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658079997,
    "dropphyadd": "1919 W BENNETT ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658079997,
    "dropmaladd": "1919 W BENNETT ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658079997,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178315412,
    "dropsitcph": 4178312678,
    "dropfax": 4178640188
  },
  {
    "dcode": "D",
    "dropkey": "4W1C598",
    "droptype": "D",
    "dropname": "TROLLWOOD",
    "dropdeladd": "3105 BROADWAY N STE 44",
    "dropdelcty": "FARGO",
    "dropdelst": "ND",
    "dropdelzpp": 581021490,
    "dropphyadd": "3105 BROADWAY N STE 44",
    "dropphycty": "FARGO",
    "dropphyst": "ND",
    "dropphyzpp": 581021490,
    "dropmaladd": "3105 BROADWAY N STE 44",
    "dropmalcty": "FARGO",
    "dropmalst": "ND",
    "dropmalzpp": 581021490,
    "dropsitphn": "",
    "dropsitlph": 7013536046,
    "dropsitcph": 7013536044,
    "dropfax": 7012356810
  },
  {
    "dcode": "D",
    "dropkey": "4W1C629",
    "droptype": "D",
    "dropname": "SOUTHWEST CARRIER ANNEX",
    "dropdeladd": "4709 S TECHNOPOLIS DR",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571064227,
    "dropphyadd": "4709 S TECHNOPOLIS DR",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571064227,
    "dropmaladd": "4709 S TECHNOPOLIS DR",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571064227,
    "dropsitphn": "",
    "dropsitlph": 6055753584,
    "dropsitcph": 6055753584,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W11644",
    "droptype": "D",
    "dropname": "URBANDALE",
    "dropdeladd": "7755 DOUGLAS AVE",
    "dropdelcty": "URBANDALE",
    "dropdelst": "IA",
    "dropdelzpp": 503223066,
    "dropphyadd": "7755 DOUGLAS AVE",
    "dropphycty": "URBANDALE",
    "dropphyst": "IA",
    "dropphyzpp": 503223066,
    "dropmaladd": "7755 DOUGLAS AVE",
    "dropmalcty": "URBANDALE",
    "dropmalst": "IA",
    "dropmalzpp": 503223066,
    "dropsitphn": 5152837530,
    "dropsitlph": 5152701055,
    "dropsitcph": 5152517330,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W12793",
    "droptype": "D",
    "dropname": "EDGEBK/LINCOLNWOOD ANNEX",
    "dropdeladd": "6500 N LINCOLN AVE STE 1",
    "dropdelcty": "LINCOLNWOOD",
    "dropdelst": "IL",
    "dropdelzpp": 607129998,
    "dropphyadd": "6500 N LINCOLN AVE STE 1",
    "dropphycty": "LINCOLNWOOD",
    "dropphyst": "IL",
    "dropphyzpp": 607129998,
    "dropmaladd": "6500 N LINCOLN AVE STE 1",
    "dropmalcty": "LINCOLNWOOD",
    "dropmalst": "IL",
    "dropmalzpp": 607129998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 8476779570,
    "dropfax": 8476779564
  },
  {
    "dcode": "D",
    "dropkey": "4W13156",
    "droptype": "D",
    "dropname": "GRACELAND CARRIER ANNEX",
    "dropdeladd": "3635 N LINCOLN AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606579998,
    "dropphyadd": "3635 N LINCOLN AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606579998,
    "dropmaladd": "3635 N LINCOLN AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606579998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7734040980,
    "dropfax": 7734044543
  },
  {
    "dcode": "D",
    "dropkey": "4W13160",
    "droptype": "D",
    "dropname": "GRAND CROSSING C ANNEX",
    "dropdeladd": "7748 S COTTAGE GROVE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606199998,
    "dropphyadd": "7748 S COTTAGE GROVE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606199998,
    "dropmaladd": "7748 S COTTAGE GROVE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606199998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7734830479,
    "dropfax": 7734830733
  },
  {
    "dcode": "D",
    "dropkey": "4W13474",
    "droptype": "D",
    "dropname": "JEFFERSON PARK CARRIER ANNEX",
    "dropdeladd": "4810 N MILWAUKEE AVE",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606309998,
    "dropphyadd": "4810 N MILWAUKEE AVE",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606309998,
    "dropmaladd": "4810 N MILWAUKEE AVE",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606309998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7736852150,
    "dropfax": 7736852731
  },
  {
    "dcode": "D",
    "dropkey": "4W13686",
    "droptype": "D",
    "dropname": "LINCOLN PARK CARRIER ANNEX",
    "dropdeladd": "2643 N CLARK ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606149998,
    "dropphyadd": "2643 N CLARK ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606149998,
    "dropmaladd": "2643 N CLARK ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606149998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7735250863,
    "dropfax": 7735250468
  },
  {
    "dcode": "D",
    "dropkey": "4W16926",
    "droptype": "D",
    "dropname": "KIRKWOOD",
    "dropdeladd": "222 S TAYLOR AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631229998,
    "dropphyadd": "222 S TAYLOR AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631229998,
    "dropmaladd": "222 S TAYLOR AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631229998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3149660638,
    "dropsitcph": 3149666953,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W20418",
    "droptype": "D",
    "dropname": "DELANO",
    "dropdeladd": "626 S TYLER RD",
    "dropdelcty": "WICHITA",
    "dropdelst": "KS",
    "dropdelzpp": 672099998,
    "dropphyadd": "626 S TYLER RD",
    "dropphycty": "WICHITA",
    "dropphyst": "KS",
    "dropphyzpp": 672099998,
    "dropmaladd": "626 S TYLER RD",
    "dropmalcty": "WICHITA",
    "dropmalst": "KS",
    "dropmalzpp": 672099998,
    "dropsitphn": 4023482736,
    "dropsitlph": 3163709610,
    "dropsitcph": 3167212065,
    "dropfax": 3163709612
  },
  {
    "dcode": "D",
    "dropkey": "4W24905",
    "droptype": "D",
    "dropname": "NIMITZ CARRIER ANNEX",
    "dropdeladd": "10330 DESERT SANDS ST",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782169998,
    "dropphyadd": "10330 DESERT SANDS ST",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782169998,
    "dropmaladd": "10330 DESERT SANDS ST",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782169998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2103411872,
    "dropsitcph": 2103412136,
    "dropfax": 2103495912
  },
  {
    "dcode": "D",
    "dropkey": "4W24955",
    "droptype": "D",
    "dropname": "NORTHEAST CARR ANNEX",
    "dropdeladd": "11119 LANDMARK 35 DR",
    "dropdelcty": "SAN ANTONIO",
    "dropdelst": "TX",
    "dropdelzpp": 782339998,
    "dropphyadd": "11119 LANDMARK 35 DR",
    "dropphycty": "SAN ANTONIO",
    "dropphyst": "TX",
    "dropphyzpp": 782339998,
    "dropmaladd": "11119 LANDMARK 35 DR",
    "dropmalcty": "SAN ANTONIO",
    "dropmalst": "TX",
    "dropmalzpp": 782339998,
    "dropsitphn": 2103688387,
    "dropsitlph": 2105900325,
    "dropsitcph": 2105900293,
    "dropfax": 2105904587
  },
  {
    "dcode": "D",
    "dropkey": "4W25698",
    "droptype": "D",
    "dropname": "SOUTH POST OAK",
    "dropdeladd": "5505 BELROSE DR BLDG A",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770352650,
    "dropphyadd": "5505 BELROSE DR BLDG A",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770352650,
    "dropmaladd": "5505 BELROSE DR BLDG A",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770352650,
    "dropsitphn": 7132263055,
    "dropsitlph": 7137234611,
    "dropsitcph": 7137235689,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W26339",
    "droptype": "D",
    "dropname": "WILLIAM RICE",
    "dropdeladd": "5201 WAKEFOREST ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770059998,
    "dropphyadd": "5201 WAKEFOREST ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770059998,
    "dropmaladd": "5201 WAKEFOREST ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770059998,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132957701,
    "dropsitcph": 7132957701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4W26476",
    "droptype": "D",
    "dropname": "CHIMNEY HILLS",
    "dropdeladd": "9230 S SHERIDAN RD",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741339998,
    "dropphyadd": "9230 S SHERIDAN RD",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741339998,
    "dropmaladd": "9230 S SHERIDAN RD",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741339998,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185231976,
    "dropsitcph": 9184961045,
    "dropfax": 9184962536
  },
  {
    "dcode": "D",
    "dropkey": "4W26560",
    "droptype": "D",
    "dropname": "SHERWOOD CARRIER ANNEX",
    "dropdeladd": "6120 SW 29TH ST",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666149998,
    "dropphyadd": "6120 SW 29TH ST",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666149998,
    "dropmaladd": "6120 SW 29TH ST",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666149998,
    "dropsitphn": 4023482736,
    "dropsitlph": 7852711880,
    "dropsitcph": 7852730885,
    "dropfax": 7852716937
  },
  {
    "dcode": "D",
    "dropkey": "4W26572",
    "droptype": "D",
    "dropname": "SOUTH TYLER ANNEX",
    "dropdeladd": "6722 S BROADWAY AVE STE 100",
    "dropdelcty": "TYLER",
    "dropdelst": "TX",
    "dropdelzpp": 757039997,
    "dropphyadd": "6722 S BROADWAY AVE STE 100",
    "dropphycty": "TYLER",
    "dropphyst": "TX",
    "dropphyzpp": 757039997,
    "dropmaladd": "6722 S BROADWAY AVE STE 100",
    "dropmalcty": "TYLER",
    "dropmalst": "TX",
    "dropmalzpp": 757039997,
    "dropsitphn": 9033243018,
    "dropsitlph": 9035810487,
    "dropsitcph": 9035810487,
    "dropfax": 9035092203
  },
  {
    "dcode": "D",
    "dropkey": "4W26585",
    "droptype": "D",
    "dropname": "FORT WORTH NORTH CARRIER ANX",
    "dropdeladd": "4909 NORTHEAST PKWY",
    "dropdelcty": "FORT WORTH",
    "dropdelst": "TX",
    "dropdelzpp": 761061834,
    "dropphyadd": "4909 NORTHEAST PKWY",
    "dropphycty": "FORT WORTH",
    "dropphyst": "TX",
    "dropphyzpp": 761061834,
    "dropmaladd": "4909 NORTHEAST PKWY",
    "dropmalcty": "FORT WORTH",
    "dropmalst": "TX",
    "dropmalzpp": 761061834,
    "dropsitphn": 8173173658,
    "dropsitlph": 8176247973,
    "dropsitcph": 8173780759,
    "dropfax": 8176242335
  },
  {
    "dcode": "D",
    "dropkey": "4W26942",
    "droptype": "D",
    "dropname": "OXFORD CARRIER ANNEX",
    "dropdeladd": "16050 MARTY CIR",
    "dropdelcty": "OVERLAND PARK",
    "dropdelst": "KS",
    "dropdelzpp": 662233202,
    "dropphyadd": "16050 MARTY CIR",
    "dropphycty": "OVERLAND PARK",
    "dropphyst": "KS",
    "dropphyzpp": 662233202,
    "dropmaladd": "16050 MARTY CIR",
    "dropmalcty": "OVERLAND PARK",
    "dropmalst": "KS",
    "dropmalzpp": 662233202,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138510532,
    "dropsitcph": 9138510426,
    "dropfax": 9138514192
  },
  {
    "dcode": "D",
    "dropkey": "4X1A220",
    "droptype": "D",
    "dropname": "NORTH HUNTINGDON",
    "dropdeladd": "1101 MAIN ST",
    "dropdelcty": "IRWIN",
    "dropdelst": "PA",
    "dropdelzpp": 156429998,
    "dropphyadd": "1101 MAIN ST",
    "dropphycty": "IRWIN",
    "dropphyst": "PA",
    "dropphyzpp": 156429998,
    "dropmaladd": "1101 MAIN ST",
    "dropmalcty": "IRWIN",
    "dropmalst": "PA",
    "dropmalzpp": 156429998,
    "dropsitphn": 4123597560,
    "dropsitlph": 7248639569,
    "dropsitcph": 7248639569,
    "dropfax": 7248639514
  },
  {
    "dcode": "D",
    "dropkey": "4X1C169",
    "droptype": "D",
    "dropname": "BRENTWOOD CARRIER ANNEX",
    "dropdeladd": "1045 BRENTWOOD CT STE 110",
    "dropdelcty": "LEXINGTON",
    "dropdelst": "KY",
    "dropdelzpp": 405119996,
    "dropphyadd": "1045 BRENTWOOD CT STE 110",
    "dropphycty": "LEXINGTON",
    "dropphyst": "KY",
    "dropphyzpp": 405119996,
    "dropmaladd": "1045 BRENTWOOD CT STE 110",
    "dropmalcty": "LEXINGTON",
    "dropmalst": "KY",
    "dropmalzpp": 405119996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8592310378,
    "dropfax": 8592310182
  },
  {
    "dcode": "D",
    "dropkey": "4X1C373",
    "droptype": "D",
    "dropname": "LANCASTER CARRIER ANNEX",
    "dropdeladd": "1301 MARSHALL AVE",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176019998,
    "dropphyadd": "1301 MARSHALL AVE",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176019998,
    "dropmaladd": "1301 MARSHALL AVE",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176019998,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173947784,
    "dropsitcph": 7173947784,
    "dropfax": 7172907625
  },
  {
    "dcode": "D",
    "dropkey": "4X1C572",
    "droptype": "D",
    "dropname": "GABRIEL CARRIER ANNEX",
    "dropdeladd": "6013 BLUFFTON RD",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468099998,
    "dropphyadd": "6013 BLUFFTON RD",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468099998,
    "dropmaladd": "6013 BLUFFTON RD",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468099998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277332,
    "dropfax": 2604785832
  },
  {
    "dcode": "D",
    "dropkey": "4X1C674",
    "droptype": "D",
    "dropname": "ACWORTH CARRIER ANNEX",
    "dropdeladd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropdelcty": "ACWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 301019996,
    "dropphyadd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropphycty": "ACWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 301019996,
    "dropmaladd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropmalcty": "ACWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 301019996,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784332942,
    "dropsitcph": 7709668169,
    "dropfax": 7709746465
  },
  {
    "dcode": "D",
    "dropkey": "4X1C784",
    "droptype": "D",
    "dropname": "RICHMOND CARRIER ANNEX",
    "dropdeladd": "120 E WATER ST",
    "dropdelcty": "RICHMOND",
    "dropdelst": "KY",
    "dropdelzpp": 404759997,
    "dropphyadd": "120 E WATER ST",
    "dropphycty": "RICHMOND",
    "dropphyst": "KY",
    "dropphyzpp": 404759997,
    "dropmaladd": "120 E WATER ST",
    "dropmalcty": "RICHMOND",
    "dropmalst": "KY",
    "dropmalzpp": 404759997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 8596232334,
    "dropfax": 8596240713
  },
  {
    "dcode": "D",
    "dropkey": "4X10306",
    "droptype": "D",
    "dropname": "CUMBERLAND CARRIER FACILITY",
    "dropdeladd": "1901 TERRELL MILL RD SE STE 500",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300678397,
    "dropphyadd": "1901 TERRELL MILL RD SE STE 500",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303399998,
    "dropmaladd": "1901 TERRELL MILL RD SE STE 500",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303399998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707016327,
    "dropsitcph": 7707016326,
    "dropfax": 7709161211
  },
  {
    "dcode": "D",
    "dropkey": "4X10628",
    "droptype": "D",
    "dropname": "CROSSTOWN CARRIER ANNEX",
    "dropdeladd": "225 E CROSSVILLE RD",
    "dropdelcty": "ROSWELL",
    "dropdelst": "GA",
    "dropdelzpp": 300759998,
    "dropphyadd": "225 E CROSSVILLE RD",
    "dropphycty": "ROSWELL",
    "dropphyst": "GA",
    "dropphyzpp": 300759998,
    "dropmaladd": "225 E CROSSVILLE RD",
    "dropmalcty": "ROSWELL",
    "dropmalst": "GA",
    "dropmalzpp": 300759998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7706402849,
    "dropsitcph": 6784617784,
    "dropfax": 7706408175
  },
  {
    "dcode": "D",
    "dropkey": "4X10787",
    "droptype": "D",
    "dropname": "MARTECH ANNEX",
    "dropdeladd": "967 BRADY AVE NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303189998,
    "dropphyadd": "967 BRADY AVE NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303189998,
    "dropmaladd": "967 BRADY AVE NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303189998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4048734428,
    "dropsitcph": 4048851037,
    "dropfax": 4048757249
  },
  {
    "dcode": "D",
    "dropkey": "4X11029",
    "droptype": "D",
    "dropname": "RALPH MCGILL CARRIER",
    "dropdeladd": "822 RALPH MCGILL BLVD NE",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303069998,
    "dropphyadd": "822 RALPH MCGILL BLVD NE",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303069998,
    "dropmaladd": "822 RALPH MCGILL BLVD NE",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303069998,
    "dropsitphn": 4047657578,
    "dropsitlph": 4048753849,
    "dropsitcph": 4048753452,
    "dropfax": 4048768735
  },
  {
    "dcode": "D",
    "dropkey": "4X14198",
    "droptype": "D",
    "dropname": "ANNSHIRE ANNEX",
    "dropdeladd": "4500 ANNSHIRE AVE",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402139997,
    "dropphyadd": "4500 ANNSHIRE AVE",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402139997,
    "dropmaladd": "4500 ANNSHIRE AVE",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402139997,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5024541882,
    "dropfax": 5024541604
  },
  {
    "dcode": "D",
    "dropkey": "4X2A616",
    "droptype": "D",
    "dropname": "CIRCLEVILLE CARRIER UNIT",
    "dropdeladd": "1191 KINGSTON PIKE",
    "dropdelcty": "CIRCLEVILLE",
    "dropdelst": "OH",
    "dropdelzpp": 431139997,
    "dropphyadd": "1191 KINGSTON PIKE",
    "dropphycty": "CIRCLEVILLE",
    "dropphyst": "OH",
    "dropphyzpp": 431139997,
    "dropmaladd": "1191 KINGSTON PIKE",
    "dropmalcty": "CIRCLEVILLE",
    "dropmalst": "OH",
    "dropmalzpp": 431139997,
    "dropsitphn": 6144720674,
    "dropsitlph": 7404743113,
    "dropsitcph": 7404743113,
    "dropfax": 7404771804
  },
  {
    "dcode": "D",
    "dropkey": "4X20458",
    "droptype": "D",
    "dropname": "CARRIER SECTIONS",
    "dropdeladd": "2201 BROADWAY AVE",
    "dropdelcty": "CLEVELAND",
    "dropdelst": "OH",
    "dropdelzpp": 441019007,
    "dropphyadd": "2201 BROADWAY AVE",
    "dropphycty": "CLEVELAND",
    "dropphyst": "OH",
    "dropphyzpp": 441019007,
    "dropmaladd": "2201 BROADWAY AVE",
    "dropmalcty": "CLEVELAND",
    "dropmalst": "OH",
    "dropmalzpp": 441019007,
    "dropsitphn": 2164434255,
    "dropsitlph": 2164434255,
    "dropsitcph": 2164434731,
    "dropfax": 2164434136
  },
  {
    "dcode": "D",
    "dropkey": "4X23346",
    "droptype": "D",
    "dropname": "WESTERN HILLS",
    "dropdeladd": "5241 CROOKSHANK RD",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452389998,
    "dropphyadd": "5241 CROOKSHANK RD",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452389998,
    "dropmaladd": "5241 CROOKSHANK RD",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452389998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5133882176,
    "dropsitcph": 5139222176,
    "dropfax": 5139228383
  },
  {
    "dcode": "D",
    "dropkey": "4X25046",
    "droptype": "D",
    "dropname": "CONCORD",
    "dropdeladd": "124 HUXLEY RD",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379229998,
    "dropphyadd": "124 HUXLEY RD",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379229998,
    "dropmaladd": "124 HUXLEY RD",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379229998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8656712407,
    "dropsitcph": 8656712307,
    "dropfax": 8656710354
  },
  {
    "dcode": "D",
    "dropkey": "4X25489",
    "droptype": "D",
    "dropname": "DESOTO",
    "dropdeladd": "161 E GE PATTERSON AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381039997,
    "dropphyadd": "161 E GE PATTERSON AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381039997,
    "dropmaladd": "161 E GE PATTERSON AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381039997,
    "dropsitphn": 6158859336,
    "dropsitlph": 9015212579,
    "dropsitcph": 9015212567,
    "dropfax": 9015212192
  },
  {
    "dcode": "D",
    "dropkey": "4X26644",
    "droptype": "D",
    "dropname": "FORT HILL CARRIER ANNEX",
    "dropdeladd": "6015 FORT AVE STE 28",
    "dropdelcty": "LYNCHBURG",
    "dropdelst": "VA",
    "dropdelzpp": 245029996,
    "dropphyadd": "6015 FORT AVE STE 28",
    "dropphycty": "LYNCHBURG",
    "dropphyst": "VA",
    "dropphyzpp": 245029996,
    "dropmaladd": "6015 FORT AVE STE 28",
    "dropmalcty": "LYNCHBURG",
    "dropmalst": "VA",
    "dropmalzpp": 245029996,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 4342378332,
    "dropfax": 4342379318
  },
  {
    "dcode": "D",
    "dropkey": "4X26917",
    "droptype": "D",
    "dropname": "JOLLIFF",
    "dropdeladd": "4417 PORTSMOUTH BLVD",
    "dropdelcty": "CHESAPEAKE",
    "dropdelst": "VA",
    "dropdelzpp": 233219998,
    "dropphyadd": "4417 PORTSMOUTH BLVD",
    "dropphycty": "CHESAPEAKE",
    "dropphyst": "VA",
    "dropphyzpp": 233219998,
    "dropmaladd": "4417 PORTSMOUTH BLVD",
    "dropmalcty": "CHESAPEAKE",
    "dropmalst": "VA",
    "dropmalzpp": 233219998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574653532,
    "dropsitcph": 7574653532,
    "dropfax": 7574653532
  },
  {
    "dcode": "D",
    "dropkey": "4X29452",
    "droptype": "D",
    "dropname": "MID CITY CINCINNATI",
    "dropdeladd": "990 DALTON AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452039998,
    "dropphyadd": "990 DALTON AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452039998,
    "dropmaladd": "990 DALTON AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452039998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132504900,
    "dropsitcph": 5132504900,
    "dropfax": 5137230544
  },
  {
    "dcode": "D",
    "dropkey": "4X29580",
    "droptype": "D",
    "dropname": "NORTHWEST ANNEX",
    "dropdeladd": "4334 MIDDLEBROOK PIKE",
    "dropdelcty": "KNOXVILLE",
    "dropdelst": "TN",
    "dropdelzpp": 379219998,
    "dropphyadd": "4334 MIDDLEBROOK PIKE",
    "dropphycty": "KNOXVILLE",
    "dropphyst": "TN",
    "dropphyzpp": 379219998,
    "dropmaladd": "4334 MIDDLEBROOK PIKE",
    "dropmalcty": "KNOXVILLE",
    "dropmalst": "TN",
    "dropmalzpp": 379219998,
    "dropsitphn": 6158859336,
    "dropsitlph": 8655586478,
    "dropsitcph": 8655585760,
    "dropfax": 4235847618
  },
  {
    "dcode": "D",
    "dropkey": "4X29610",
    "droptype": "D",
    "dropname": "MURRAY",
    "dropdeladd": "5545 MURRAY AVE",
    "dropdelcty": "CINCINNATI",
    "dropdelst": "OH",
    "dropdelzpp": 452279998,
    "dropphyadd": "5545 MURRAY AVE",
    "dropphycty": "CINCINNATI",
    "dropphyst": "OH",
    "dropphyzpp": 452279998,
    "dropmaladd": "5545 MURRAY AVE",
    "dropmalcty": "CINCINNATI",
    "dropmalst": "OH",
    "dropmalzpp": 452279998,
    "dropsitphn": 5136845763,
    "dropsitlph": 5132714230,
    "dropsitcph": 5132714230,
    "dropfax": 5132713049
  },
  {
    "dcode": "D",
    "dropkey": "4X29644",
    "droptype": "D",
    "dropname": "SHIRLINGTON ANNEX",
    "dropdeladd": "2565 S SHIRLINGTON RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222069990,
    "dropphyadd": "2565 S SHIRLINGTON RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222069990,
    "dropmaladd": "2565 S SHIRLINGTON RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222069990,
    "dropsitphn": 7036986867,
    "dropsitlph": 7039795456,
    "dropsitcph": 7039795456,
    "dropfax": 7039790288
  },
  {
    "dcode": "D",
    "dropkey": "4X29653",
    "droptype": "D",
    "dropname": "MANASSAS ANNEX",
    "dropdeladd": "9020 EUCLID AVE STE L",
    "dropdelcty": "MANASSAS",
    "dropdelst": "VA",
    "dropdelzpp": 201105347,
    "dropphyadd": "9020 EUCLID AVE STE L",
    "dropphycty": "MANASSAS",
    "dropphyst": "VA",
    "dropphyzpp": 201105347,
    "dropmaladd": "9020 EUCLID AVE STE L",
    "dropmalcty": "MANASSAS",
    "dropmalst": "VA",
    "dropmalzpp": 201105347,
    "dropsitphn": 7036986367,
    "dropsitlph": 7033690227,
    "dropsitcph": 7033690227,
    "dropfax": 7033689213
  },
  {
    "dcode": "D",
    "dropkey": "4X29738",
    "droptype": "D",
    "dropname": "EAST/LAMAR CARRIER ANNEX",
    "dropdeladd": "2801 PARK AVE",
    "dropdelcty": "MEMPHIS",
    "dropdelst": "TN",
    "dropdelzpp": 381149998,
    "dropphyadd": "2801 PARK AVE",
    "dropphycty": "MEMPHIS",
    "dropphyst": "TN",
    "dropphyzpp": 381149998,
    "dropmaladd": "2801 PARK AVE",
    "dropmalcty": "MEMPHIS",
    "dropmalst": "TN",
    "dropmalzpp": 381149998,
    "dropsitphn": 6158859336,
    "dropsitlph": 9017458547,
    "dropsitcph": 9017458547,
    "dropfax": 9017439740
  },
  {
    "dcode": "D",
    "dropkey": "4X29771",
    "droptype": "D",
    "dropname": "LONDON BRIDGE",
    "dropdeladd": "2652 PRODUCTION RD",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234549998,
    "dropphyadd": "2652 PRODUCTION RD",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234549998,
    "dropmaladd": "2652 PRODUCTION RD",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234549998,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574989516,
    "dropsitcph": 7574868655,
    "dropfax": 7574980684
  },
  {
    "dcode": "D",
    "dropkey": "4X29796",
    "droptype": "D",
    "dropname": "MEMORIAL ANNEX",
    "dropdeladd": "2226 DUKE ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223144690,
    "dropphyadd": "2226 DUKE ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223144690,
    "dropmaladd": "2226 DUKE ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223144690,
    "dropsitphn": 7036986367,
    "dropsitlph": 7036846759,
    "dropsitcph": 7036846759,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4X29867",
    "droptype": "D",
    "dropname": "ROANOKE CARRIER ANNEX",
    "dropdeladd": "1515 COURTLAND RD NE",
    "dropdelcty": "ROANOKE",
    "dropdelst": "VA",
    "dropdelzpp": 240129997,
    "dropphyadd": "1515 COURTLAND RD NE",
    "dropphycty": "ROANOKE",
    "dropphyst": "VA",
    "dropphyzpp": 240129997,
    "dropmaladd": "1515 COURTLAND RD NE",
    "dropmalcty": "ROANOKE",
    "dropmalst": "VA",
    "dropmalzpp": 240129997,
    "dropsitphn": 5409858780,
    "dropsitlph": 5409858779,
    "dropsitcph": 5403441739,
    "dropfax": 5403445521
  },
  {
    "dcode": "D",
    "dropkey": "4X29958",
    "droptype": "D",
    "dropname": "CHERAW CARRIER ANNEX",
    "dropdeladd": "91 CALVARY RD",
    "dropdelcty": "CHERAW",
    "dropdelst": "SC",
    "dropdelzpp": 295209998,
    "dropphyadd": "91 CALVARY RD",
    "dropphycty": "CHERAW",
    "dropphyst": "SC",
    "dropphyzpp": 295209998,
    "dropmaladd": "91 CALVARY RD",
    "dropmalcty": "CHERAW",
    "dropmalst": "SC",
    "dropmalzpp": 295209998,
    "dropsitphn": 8039266014,
    "dropsitlph": 8435372218,
    "dropsitcph": 8435372218,
    "dropfax": 8435374132
  },
  {
    "dcode": "D",
    "dropkey": "4Y10346",
    "droptype": "D",
    "dropname": "DOWNTOWN ANNEX",
    "dropdeladd": "612 37TH ST N",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352221320,
    "dropphyadd": "612 37TH ST N",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352221320,
    "dropmaladd": "612 37TH ST N",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352221320,
    "dropsitphn": 2055914338,
    "dropsitlph": 2055915418,
    "dropsitcph": 2055914338,
    "dropfax": 2055911630
  },
  {
    "dcode": "D",
    "dropkey": "4Y10537",
    "droptype": "D",
    "dropname": "GREEN SPRINGS ANNEX",
    "dropdeladd": "285 SNOW DR",
    "dropdelcty": "BIRMINGHAM",
    "dropdelst": "AL",
    "dropdelzpp": 352096348,
    "dropphyadd": "285 SNOW DR",
    "dropphycty": "BIRMINGHAM",
    "dropphyst": "AL",
    "dropphyzpp": 352096348,
    "dropmaladd": "285 SNOW DR",
    "dropmalcty": "BIRMINGHAM",
    "dropmalst": "AL",
    "dropmalzpp": 352099960,
    "dropsitphn": 2059423605,
    "dropsitlph": 2059423605,
    "dropsitcph": 2059423605,
    "dropfax": 2059430487
  },
  {
    "dcode": "D",
    "dropkey": "4Y11735",
    "droptype": "D",
    "dropname": "DELTA CARRIER ANNEX",
    "dropdeladd": "6101 W MICHIGAN AVE",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489172471,
    "dropphyadd": "6101 W MICHIGAN AVE",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489172471,
    "dropmaladd": "6101 W MICHIGAN AVE",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489172471,
    "dropsitphn": 6169771064,
    "dropsitlph": 5173378775,
    "dropsitcph": 5173213087,
    "dropfax": 5173219792
  },
  {
    "dcode": "D",
    "dropkey": "4Y13069",
    "droptype": "D",
    "dropname": "WATERFORD CARRIER ANNEX",
    "dropdeladd": "5340 HIGHLAND RD",
    "dropdelcty": "WATERFORD",
    "dropdelst": "MI",
    "dropdelzpp": 483279998,
    "dropphyadd": "5340 HIGHLAND RD",
    "dropphycty": "WATERFORD",
    "dropphyst": "MI",
    "dropphyzpp": 483279998,
    "dropmaladd": "5340 HIGHLAND RD",
    "dropmalcty": "WATERFORD",
    "dropmalst": "MI",
    "dropmalzpp": 483279998,
    "dropsitphn": 2486733343,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486733343,
    "dropfax": 2486735019
  },
  {
    "dcode": "D",
    "dropkey": "4Y18442",
    "droptype": "D",
    "dropname": "HILBURN ANNEX",
    "dropdeladd": "6508 HILBURN DR",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276131907,
    "dropphyadd": "6508 HILBURN DR",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276131907,
    "dropmaladd": "6508 HILBURN DR",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276131907,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197888527,
    "dropfax": 9197872247
  },
  {
    "dcode": "D",
    "dropkey": "4Y18473",
    "droptype": "D",
    "dropname": "ROCKY MOUNT ANNEX",
    "dropdeladd": "2451 POSTAL DR",
    "dropdelcty": "ROCKY MOUNT",
    "dropdelst": "NC",
    "dropdelzpp": 278049996,
    "dropphyadd": "2451 POSTAL DR",
    "dropphycty": "ROCKY MOUNT",
    "dropphyst": "NC",
    "dropphyzpp": 278049996,
    "dropmaladd": "2451 POSTAL DR",
    "dropmalcty": "ROCKY MOUNT",
    "dropmalst": "NC",
    "dropmalzpp": 278049996,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 2529374835,
    "dropfax": 2529378926
  },
  {
    "dcode": "D",
    "dropkey": "4Y18478",
    "droptype": "D",
    "dropname": "INDEPENDENCE ANNEX",
    "dropdeladd": "3717 EASTWAY DR",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282056216,
    "dropphyadd": "3717 EASTWAY DR",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282056216,
    "dropmaladd": "3717 EASTWAY DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282056216,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043934533,
    "dropsitcph": 7045663105,
    "dropfax": 7045663113
  },
  {
    "dcode": "D",
    "dropkey": "4Y18482",
    "droptype": "D",
    "dropname": "EAU CLAIRE CARRIER ANNEX",
    "dropdeladd": "1420 N HASTINGS WAY",
    "dropdelcty": "EAU CLAIRE",
    "dropdelst": "WI",
    "dropdelzpp": 547031827,
    "dropphyadd": "1420 N HASTINGS WAY",
    "dropphycty": "EAU CLAIRE",
    "dropphyst": "WI",
    "dropphyzpp": 547031827,
    "dropmaladd": "1420 N HASTINGS WAY",
    "dropmalcty": "EAU CLAIRE",
    "dropmalst": "WI",
    "dropmalzpp": 547031827,
    "dropsitphn": 6123499163,
    "dropsitlph": 6512933064,
    "dropsitcph": 7158336785,
    "dropfax": 7158390233
  },
  {
    "dcode": "D",
    "dropkey": "4Y18604",
    "droptype": "D",
    "dropname": "LONDON RD ANNEX",
    "dropdeladd": "37 LONDON RD",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288032706,
    "dropphyadd": "37 LONDON RD",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288032706,
    "dropmaladd": "37 LONDON RD",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288032706,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282716449,
    "dropsitcph": 8282716449,
    "dropfax": 8282778651
  },
  {
    "dcode": "D",
    "dropkey": "4Y18689",
    "droptype": "D",
    "dropname": "WESTSIDE ANNEX",
    "dropdeladd": "4528 W MARKET ST",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274071286,
    "dropphyadd": "4528 W MARKET ST",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274071286,
    "dropmaladd": "4528 W MARKET ST",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274071286,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368522798,
    "dropfax": 3368511377
  },
  {
    "dcode": "D",
    "dropkey": "4Y19129",
    "droptype": "D",
    "dropname": "MADISON CARRIER ANNEX",
    "dropdeladd": "205 CORPORATE DR",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537142408,
    "dropphyadd": "205 CORPORATE DR",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537142408,
    "dropmaladd": "205 CORPORATE DR",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537142408,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082456092,
    "dropsitcph": 6082456091,
    "dropfax": 6082461227
  },
  {
    "dcode": "D",
    "dropkey": "4Y19135",
    "droptype": "D",
    "dropname": "MOUNT AIRY ANNEX",
    "dropdeladd": "510 N RENFRO ST",
    "dropdelcty": "MOUNT AIRY",
    "dropdelst": "NC",
    "dropdelzpp": 270303728,
    "dropphyadd": "510 N RENFRO ST",
    "dropphycty": "MOUNT AIRY",
    "dropphyst": "NC",
    "dropphyzpp": 270303728,
    "dropmaladd": "510 N RENFRO ST",
    "dropmalcty": "MOUNT AIRY",
    "dropmalst": "NC",
    "dropmalzpp": 270303728,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367868558,
    "dropfax": 3367861205
  },
  {
    "dcode": "D",
    "dropkey": "4Y19179",
    "droptype": "D",
    "dropname": "CLARKSTON CARRIER ANNEX",
    "dropdeladd": "5886 S MAIN ST",
    "dropdelcty": "CLARKSTON",
    "dropdelst": "MI",
    "dropdelzpp": 483469998,
    "dropphyadd": "5886 S MAIN ST",
    "dropphycty": "CLARKSTON",
    "dropphyst": "MI",
    "dropphyzpp": 483469998,
    "dropmaladd": "5886 S MAIN ST",
    "dropmalcty": "CLARKSTON",
    "dropmalst": "MI",
    "dropmalzpp": 483469998,
    "dropsitphn": 2486252648,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486250648,
    "dropfax": 2486251084
  },
  {
    "dcode": "D",
    "dropkey": "4Y19222",
    "droptype": "D",
    "dropname": "FT DEARBORN ANNEX",
    "dropdeladd": "22599 VAN BORN RD",
    "dropdelcty": "DEARBORN",
    "dropdelst": "MI",
    "dropdelzpp": 481249998,
    "dropphyadd": "22599 VAN BORN RD",
    "dropphycty": "DEARBORN",
    "dropphyst": "MI",
    "dropphyzpp": 481249998,
    "dropmaladd": "22599 VAN BORN RD",
    "dropmalcty": "DEARBORN",
    "dropmalst": "MI",
    "dropmalzpp": 481249998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132746784,
    "dropsitcph": 3132746784,
    "dropfax": 3132746553
  },
  {
    "dcode": "D",
    "dropkey": "4Y19223",
    "droptype": "D",
    "dropname": "KENOSHA CARRIER ANNEX",
    "dropdeladd": "4225 101ST ST",
    "dropdelcty": "PLEASANT PRAIRIE",
    "dropdelst": "WI",
    "dropdelzpp": 531589996,
    "dropphyadd": "4225 101ST ST",
    "dropphycty": "PLEASANT PRAIRIE",
    "dropphyst": "WI",
    "dropphyzpp": 531589996,
    "dropmaladd": "4225 101ST ST",
    "dropmalcty": "PLEASANT PRAIRIE",
    "dropmalst": "WI",
    "dropmalzpp": 531589996,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626946013,
    "dropsitcph": 2626944724,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4Y19228",
    "droptype": "D",
    "dropname": "CAPITOL ANNEX DELIVERY",
    "dropdeladd": "702 E WASHINGTON AVE LOWR",
    "dropdelcty": "MADISON",
    "dropdelst": "WI",
    "dropdelzpp": 537032934,
    "dropphyadd": "702 E WASHINGTON AVE LOWR",
    "dropphycty": "MADISON",
    "dropphyst": "WI",
    "dropphyzpp": 537032934,
    "dropmaladd": "702 E WASHINGTON AVE LOWR",
    "dropmalcty": "MADISON",
    "dropmalst": "WI",
    "dropmalzpp": 537032934,
    "dropsitphn": 4142702120,
    "dropsitlph": 6082516949,
    "dropsitcph": 6082516980,
    "dropfax": 6082512303
  },
  {
    "dcode": "D",
    "dropkey": "4Y20152",
    "droptype": "D",
    "dropname": "BRADY ANNEX",
    "dropdeladd": "8313 W MARKHAM ST",
    "dropdelcty": "LITTLE ROCK",
    "dropdelst": "AR",
    "dropdelzpp": 722059998,
    "dropphyadd": "8313 W MARKHAM ST",
    "dropphycty": "LITTLE ROCK",
    "dropphyst": "AR",
    "dropphyzpp": 722059998,
    "dropmaladd": "8313 W MARKHAM ST",
    "dropmalcty": "LITTLE ROCK",
    "dropmalst": "AR",
    "dropmalzpp": 722059998,
    "dropsitphn": 5012239934,
    "dropsitlph": 5012257839,
    "dropsitcph": 5012239934,
    "dropfax": 5012219390
  },
  {
    "dcode": "D",
    "dropkey": "4Y21428",
    "droptype": "D",
    "dropname": "BAYMEADOWS DDC",
    "dropdeladd": "11250 PHILIPS INDUSTRIAL BLVD E",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322569998,
    "dropphyadd": "11250 PHILIPS INDUSTRIAL BLVD E",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322569998,
    "dropmaladd": "11250 PHILIPS INDUSTRIAL BLVD E",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322569998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042683358,
    "dropsitcph": 9042681545,
    "dropfax": 9042605198
  },
  {
    "dcode": "D",
    "dropkey": "4Y21643",
    "droptype": "D",
    "dropname": "COUNTY LINE ANNEX",
    "dropdeladd": "101 SE 1ST AVE",
    "dropdelcty": "HALLANDALE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330095508,
    "dropphyadd": "101 SE 1ST AVE",
    "dropphycty": "HALLANDALE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330095508,
    "dropmaladd": "101 SE 1ST AVE",
    "dropmalcty": "HALLANDALE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330095508,
    "dropsitphn": 3054700746,
    "dropsitlph": 9544559730,
    "dropsitcph": 9544540965,
    "dropfax": 9544582540
  },
  {
    "dcode": "D",
    "dropkey": "4Y21701",
    "droptype": "D",
    "dropname": "DEERFIELD BEACH ANNEX",
    "dropdeladd": "155 GOOLSBY BLVD",
    "dropdelcty": "DEERFIELD BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334429998,
    "dropphyadd": "155 GOOLSBY BLVD",
    "dropphycty": "DEERFIELD BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334429998,
    "dropmaladd": "155 GOOLSBY BLVD",
    "dropmalcty": "DEERFIELD BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334429998,
    "dropsitphn": 9544812487,
    "dropsitlph": 9544812487,
    "dropsitcph": 9544274255,
    "dropfax": 9546989225
  },
  {
    "dcode": "D",
    "dropkey": "4Y22028",
    "droptype": "D",
    "dropname": "HIALEAH ANNEX",
    "dropdeladd": "7000 W 19TH CT",
    "dropdelcty": "HIALEAH",
    "dropdelst": "FL",
    "dropdelzpp": 330144471,
    "dropphyadd": "7000 W 19TH CT",
    "dropphycty": "HIALEAH",
    "dropphyst": "FL",
    "dropphyzpp": 330144471,
    "dropmaladd": "7000 W 19TH CT",
    "dropmalcty": "HIALEAH",
    "dropmalst": "FL",
    "dropmalzpp": 330144471,
    "dropsitphn": 3055132368,
    "dropsitlph": 3055581701,
    "dropsitcph": 3055561933,
    "dropfax": 3058278419
  },
  {
    "dcode": "D",
    "dropkey": "4Y22224",
    "droptype": "D",
    "dropname": "1ST STREET CARRIER ANNEX",
    "dropdeladd": "140 N 1ST ST",
    "dropdelcty": "LAKE WALES",
    "dropdelst": "FL",
    "dropdelzpp": 338534103,
    "dropphyadd": "140 N 1ST ST",
    "dropphycty": "LAKE WALES",
    "dropphyst": "FL",
    "dropphyzpp": 338534103,
    "dropmaladd": "140 N 1ST ST",
    "dropmalcty": "LAKE WALES",
    "dropmalst": "FL",
    "dropmalzpp": 338534103,
    "dropsitphn": 8138770788,
    "dropsitlph": 8638022053,
    "dropsitcph": 8636783573,
    "dropfax": 8636780399
  },
  {
    "dcode": "D",
    "dropkey": "4Y22540",
    "droptype": "D",
    "dropname": "NORTH PORT",
    "dropdeladd": "13611 TAMIAMI TRL",
    "dropdelcty": "NORTH PORT",
    "dropdelst": "FL",
    "dropdelzpp": 342879998,
    "dropphyadd": "13611 TAMIAMI TRL",
    "dropphycty": "NORTH PORT",
    "dropphyst": "FL",
    "dropphyzpp": 342879998,
    "dropmaladd": "13611 TAMIAMI TRL",
    "dropmalcty": "NORTH PORT",
    "dropmalst": "FL",
    "dropmalzpp": 342879998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414260940,
    "dropfax": 9414268597
  },
  {
    "dcode": "D",
    "dropkey": "4Y22547",
    "droptype": "D",
    "dropname": "NORTHDALE CARRIER ANNEX",
    "dropdeladd": "5330 EHRLICH RD STE 122",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336246981,
    "dropphyadd": "5330 EHRLICH RD STE 122",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336246981,
    "dropmaladd": "5330 EHRLICH RD STE 122",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336246981,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8139082467,
    "dropfax": 8139637475
  },
  {
    "dcode": "D",
    "dropkey": "4Y22629",
    "droptype": "D",
    "dropname": "PACE CARRIER ANNEX",
    "dropdeladd": "4584 CHUMUCKLA HWY",
    "dropdelcty": "MILTON",
    "dropdelst": "FL",
    "dropdelzpp": 325719998,
    "dropphyadd": "4584 CHUMUCKLA HWY",
    "dropphycty": "MILTON",
    "dropphyst": "FL",
    "dropphyzpp": 325719998,
    "dropmaladd": "4584 CHUMUCKLA HWY",
    "dropmalcty": "MILTON",
    "dropmalst": "FL",
    "dropmalzpp": 325719998,
    "dropsitphn": 9043592957,
    "dropsitlph": 8509949215,
    "dropsitcph": 8509949215,
    "dropfax": 8509954563
  },
  {
    "dcode": "D",
    "dropkey": "4Y22730",
    "droptype": "D",
    "dropname": "HIBISCUS CARRIER ANNEX",
    "dropdeladd": "3500 S DIXIE HWY",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331469998,
    "dropphyadd": "3500 S DIXIE HWY",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331469998,
    "dropmaladd": "3500 S DIXIE HWY",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331469998,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055294551,
    "dropsitcph": 3055294538,
    "dropfax": 3055294522
  },
  {
    "dcode": "D",
    "dropkey": "4Y22738",
    "droptype": "D",
    "dropname": "PORT CHARLOTTE ANNEX",
    "dropdeladd": "18100 PAULSON DR",
    "dropdelcty": "PORT CHARLOTTE",
    "dropdelst": "FL",
    "dropdelzpp": 339549998,
    "dropphyadd": "18100 PAULSON DR",
    "dropphycty": "PORT CHARLOTTE",
    "dropphyst": "FL",
    "dropphyzpp": 339549998,
    "dropmaladd": "18100 PAULSON DR",
    "dropmalcty": "PORT CHARLOTTE",
    "dropmalst": "FL",
    "dropmalzpp": 339549998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 9416252397,
    "dropfax": 9416258241
  },
  {
    "dcode": "D",
    "dropkey": "4Y23080",
    "droptype": "D",
    "dropname": "TAMPA CARRIER ANNEX",
    "dropdeladd": "4009 W SPRUCE ST",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336072357,
    "dropphyadd": "4009 W SPRUCE ST",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336072357,
    "dropmaladd": "4009 W SPRUCE ST",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336072357,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8138720709,
    "dropfax": 8138754522
  },
  {
    "dcode": "D",
    "dropkey": "4Y23236",
    "droptype": "D",
    "dropname": "PALMETTO PARK ANNEX",
    "dropdeladd": "1275 W PALMETTO PARK RD",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334869991,
    "dropphyadd": "1275 W PALMETTO PARK RD",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334869991,
    "dropmaladd": "1275 W PALMETTO PARK RD",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334869991,
    "dropsitphn": 5613915474,
    "dropsitlph": 5613915474,
    "dropsitcph": 5613387164,
    "dropfax": 5613954793
  },
  {
    "dcode": "D",
    "dropkey": "4Y26810",
    "droptype": "D",
    "dropname": "ALAFAYA CARRIER ANNEX",
    "dropdeladd": "1000 N ALAFAYA TRL",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328289998,
    "dropphyadd": "1000 N ALAFAYA TRL",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328289998,
    "dropmaladd": "1000 N ALAFAYA TRL",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328289998,
    "dropsitphn": 4076582395,
    "dropsitlph": 4076582395,
    "dropsitcph": 4073846219,
    "dropfax": 4072734908
  },
  {
    "dcode": "D",
    "dropkey": "4Y26828",
    "droptype": "D",
    "dropname": "PALMS CENTRAL",
    "dropdeladd": "818 S MILITARY TRL",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334159998,
    "dropphyadd": "818 S MILITARY TRL",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334159998,
    "dropmaladd": "818 S MILITARY TRL",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334159998,
    "dropsitphn": 5616834660,
    "dropsitlph": 5616834660,
    "dropsitcph": 5616834506,
    "dropfax": 5616893879
  },
  {
    "dcode": "D",
    "dropkey": "4Y27143",
    "droptype": "D",
    "dropname": "APOLLO ANNEX",
    "dropdeladd": "680 N APOLLO BLVD FRNT",
    "dropdelcty": "MELBOURNE",
    "dropdelst": "FL",
    "dropdelzpp": 329359992,
    "dropphyadd": "680 N APOLLO BLVD FRNT",
    "dropphycty": "MELBOURNE",
    "dropphyst": "FL",
    "dropphyzpp": 329359992,
    "dropmaladd": "680 N APOLLO BLVD FRNT",
    "dropmalcty": "MELBOURNE",
    "dropmalst": "FL",
    "dropmalzpp": 329359992,
    "dropsitphn": 3212543916,
    "dropsitlph": 3212543916,
    "dropsitcph": 3212557589,
    "dropfax": 3212592049
  },
  {
    "dcode": "D",
    "dropkey": "4Y27256",
    "droptype": "D",
    "dropname": "ALOMA CARRIER ANNEX",
    "dropdeladd": "4214 METRIC DR",
    "dropdelcty": "WINTER PARK",
    "dropdelst": "FL",
    "dropdelzpp": 327929998,
    "dropphyadd": "4214 METRIC DR",
    "dropphycty": "WINTER PARK",
    "dropphyst": "FL",
    "dropphyzpp": 327929998,
    "dropmaladd": "4214 METRIC DR",
    "dropmalcty": "WINTER PARK",
    "dropmalst": "FL",
    "dropmalzpp": 327929998,
    "dropsitphn": 4076795339,
    "dropsitlph": 4076795339,
    "dropsitcph": 4076796696,
    "dropfax": 4076790166
  },
  {
    "dcode": "D",
    "dropkey": "4Y27291",
    "droptype": "D",
    "dropname": "STUART ANNEX",
    "dropdeladd": "4411 SE FEDERAL HWY",
    "dropdelcty": "STUART",
    "dropdelst": "FL",
    "dropdelzpp": 349975747,
    "dropphyadd": "4411 SE FEDERAL HWY",
    "dropphycty": "STUART",
    "dropphyst": "FL",
    "dropphyzpp": 349975747,
    "dropmaladd": "4411 SE FEDERAL HWY",
    "dropmalcty": "STUART",
    "dropmalst": "FL",
    "dropmalzpp": 349975747,
    "dropsitphn": 7722238782,
    "dropsitlph": 7722238782,
    "dropsitcph": 7727815188,
    "dropfax": 7722875014
  },
  {
    "dcode": "D",
    "dropkey": "4Y27394",
    "droptype": "D",
    "dropname": "GOLDEN GATE CARRIER ANNEX",
    "dropdeladd": "4080 15TH AVE SW",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341165235,
    "dropphyadd": "4080 15TH AVE SW",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341165235,
    "dropmaladd": "4080 15TH AVE SW",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341165235,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2393523010,
    "dropfax": 2393526398
  },
  {
    "dcode": "D",
    "dropkey": "4Y27849",
    "droptype": "D",
    "dropname": "CHANHASSEN CARRIER ANNEX",
    "dropdeladd": "1775 LAKE DR W",
    "dropdelcty": "CHANHASSEN",
    "dropdelst": "MN",
    "dropdelzpp": 553178584,
    "dropphyadd": "1775 LAKE DR W",
    "dropphycty": "CHANHASSEN",
    "dropphyst": "MN",
    "dropphyzpp": 553178584,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "CHANHASSEN",
    "dropmalst": "MN",
    "dropmalzpp": 553179998,
    "dropsitphn": 9523616892,
    "dropsitlph": 6123496346,
    "dropsitcph": 9523616892,
    "dropfax": 9522084944
  },
  {
    "dcode": "D",
    "dropkey": "4Y27864",
    "droptype": "D",
    "dropname": "BRADENTON CARRIER ANNEX",
    "dropdeladd": "815 4TH AVE W",
    "dropdelcty": "BRADENTON",
    "dropdelst": "FL",
    "dropdelzpp": 342058609,
    "dropphyadd": "815 4TH AVE W",
    "dropphycty": "BRADENTON",
    "dropphyst": "FL",
    "dropphyzpp": 342058609,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "BRADENTON",
    "dropmalst": "FL",
    "dropmalzpp": 342069998,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9417455668,
    "dropfax": 9417482345
  },
  {
    "dcode": "D",
    "dropkey": "4Y27868",
    "droptype": "D",
    "dropname": "WEST BOCA CARRIER ANNEX",
    "dropdeladd": "21850 JUDGE WINIKOFF RD",
    "dropdelcty": "BOCA RATON",
    "dropdelst": "FL",
    "dropdelzpp": 334289992,
    "dropphyadd": "21850 JUDGE WINIKOFF RD",
    "dropphycty": "BOCA RATON",
    "dropphyst": "FL",
    "dropphyzpp": 334289992,
    "dropmaladd": "21850 JUDGE WINIKOFF RD",
    "dropmalcty": "BOCA RATON",
    "dropmalst": "FL",
    "dropmalzpp": 334289992,
    "dropsitphn": 5618524180,
    "dropsitlph": 5618524180,
    "dropsitcph": 5618522028,
    "dropfax": 5612181666
  },
  {
    "dcode": "D",
    "dropkey": "4Y27874",
    "droptype": "D",
    "dropname": "CITY PLACE",
    "dropdeladd": "1040 OKEECHOBEE RD",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334019991,
    "dropphyadd": "1040 OKEECHOBEE RD",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334019991,
    "dropmaladd": "1040 OKEECHOBEE RD",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334019991,
    "dropsitphn": 5618330929,
    "dropsitlph": 5618330929,
    "dropsitcph": 5618330929,
    "dropfax": 5618329987
  },
  {
    "dcode": "D",
    "dropkey": "4Y27878",
    "droptype": "D",
    "dropname": "BUFFALO CARRIER ANNEX",
    "dropdeladd": "201 ATLAS AVE NE",
    "dropdelcty": "BUFFALO",
    "dropdelst": "MN",
    "dropdelzpp": 553132158,
    "dropphyadd": "201 ATLAS AVE NE",
    "dropphycty": "BUFFALO",
    "dropphyst": "MN",
    "dropphyzpp": 553132158,
    "dropmaladd": "201 ATLAS AVE NE",
    "dropmalcty": "BUFFALO",
    "dropmalst": "MN",
    "dropmalzpp": 553132158,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496346,
    "dropsitcph": 7636840590,
    "dropfax": 7636820105
  },
  {
    "dcode": "D",
    "dropkey": "4Y27883",
    "droptype": "D",
    "dropname": "VENICE CARRIER ANNEX",
    "dropdeladd": "314 SEABOARD AVE",
    "dropdelcty": "VENICE",
    "dropdelst": "FL",
    "dropdelzpp": 342854620,
    "dropphyadd": "314 SEABOARD AVE",
    "dropphycty": "VENICE",
    "dropphyst": "FL",
    "dropphyzpp": 342854620,
    "dropmaladd": "314 SEABOARD AVE",
    "dropmalcty": "VENICE",
    "dropmalst": "FL",
    "dropmalzpp": 342854620,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9414850995,
    "dropfax": 9414847463
  },
  {
    "dcode": "D",
    "dropkey": "4Y27924",
    "droptype": "D",
    "dropname": "DELAND CARRIER ANNEX",
    "dropdeladd": "240 W NEW YORK AVE",
    "dropdelcty": "DELAND",
    "dropdelst": "FL",
    "dropdelzpp": 327209998,
    "dropphyadd": "240 W NEW YORK AVE",
    "dropphycty": "DELAND",
    "dropphyst": "FL",
    "dropphyzpp": 327209998,
    "dropmaladd": "240 W NEW YORK AVE",
    "dropmalcty": "DELAND",
    "dropmalst": "FL",
    "dropmalzpp": 327209998,
    "dropsitphn": 3867349520,
    "dropsitlph": 3867349520,
    "dropsitcph": 3869438803,
    "dropfax": 3867362246
  },
  {
    "dcode": "D",
    "dropkey": "4Y28033",
    "droptype": "D",
    "dropname": "MALL CARRIER ANNEX",
    "dropdeladd": "800 WAREHOUSE RD",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328039998,
    "dropphyadd": "800 WAREHOUSE RD",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328039998,
    "dropmaladd": "800 WAREHOUSE RD",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328039998,
    "dropsitphn": 4072286415,
    "dropsitlph": 4072286415,
    "dropsitcph": 4078976774,
    "dropfax": 4072286427
  },
  {
    "dcode": "D",
    "dropkey": "4Y28156",
    "droptype": "D",
    "dropname": "ANDOVER CARRIER ANNEX",
    "dropdeladd": "15219 BLUEBIRD ST NW",
    "dropdelcty": "ANDOVER",
    "dropdelst": "MN",
    "dropdelzpp": 553049998,
    "dropphyadd": "15219 BLUEBIRD ST NW",
    "dropphycty": "ANDOVER",
    "dropphyst": "MN",
    "dropphyzpp": 553049998,
    "dropmaladd": "15219 BLUEBIRD ST NW",
    "dropmalcty": "ANDOVER",
    "dropmalst": "MN",
    "dropmalzpp": 553043554,
    "dropsitphn": 6123496399,
    "dropsitlph": 7634139033,
    "dropsitcph": 7634137396,
    "dropfax": 7634342130
  },
  {
    "dcode": "D",
    "dropkey": "4Z11142",
    "droptype": "D",
    "dropname": "CAPITOL HILL ANNEX",
    "dropdeladd": "1551 N DOWNING ST",
    "dropdelcty": "DENVER",
    "dropdelst": "CO",
    "dropdelzpp": 802189997,
    "dropphyadd": "1551 N DOWNING ST",
    "dropphycty": "DENVER",
    "dropphyst": "CO",
    "dropphyzpp": 802189997,
    "dropmaladd": "1551 N DOWNING ST",
    "dropmalcty": "DENVER",
    "dropmalst": "CO",
    "dropmalzpp": 802189997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038607950,
    "dropsitcph": 3038607954,
    "dropfax": 3038608330
  },
  {
    "dcode": "D",
    "dropkey": "4Z12125",
    "droptype": "D",
    "dropname": "LIHUE CARRIER ANNEX",
    "dropdeladd": "3230 KAPULE HWY",
    "dropdelcty": "LIHUE",
    "dropdelst": "HI",
    "dropdelzpp": 967661488,
    "dropphyadd": "3230 KAPULE HWY",
    "dropphycty": "LIHUE",
    "dropphyst": "HI",
    "dropphyzpp": 967661488,
    "dropmaladd": "3230 KAPULE HWY",
    "dropmalcty": "LIHUE",
    "dropmalst": "HI",
    "dropmalzpp": 967661488,
    "dropsitphn": 8084233893,
    "dropsitlph": 8082459385,
    "dropsitcph": 8082451628,
    "dropfax": 8082459405
  },
  {
    "dcode": "D",
    "dropkey": "4Z13969",
    "droptype": "D",
    "dropname": "NORTH VALLEY",
    "dropdeladd": "110 MONTANO RD NE",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871079998,
    "dropphyadd": "110 MONTANO RD NE",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871079998,
    "dropmaladd": "110 MONTANO RD NE",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871079998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053461283,
    "dropsitcph": 5053461677,
    "dropfax": 5053461281
  },
  {
    "dcode": "D",
    "dropkey": "4Z14862",
    "droptype": "D",
    "dropname": "CLACKAMAS DCU",
    "dropdeladd": "9836 SE EMPIRE CT",
    "dropdelcty": "CLACKAMAS",
    "dropdelst": "OR",
    "dropdelzpp": 970159630,
    "dropphyadd": "9836 SE EMPIRE CT",
    "dropphycty": "CLACKAMAS",
    "dropphyst": "OR",
    "dropphyzpp": 970159630,
    "dropmaladd": "9836 SE EMPIRE CT",
    "dropmalcty": "CLACKAMAS",
    "dropmalst": "OR",
    "dropmalzpp": 970158698,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036529419,
    "dropsitcph": 5036536097,
    "dropfax": 5036594766
  },
  {
    "dcode": "D",
    "dropkey": "4Z15194",
    "droptype": "D",
    "dropname": "LENTS DCU",
    "dropdeladd": "8100 SE CRYSTAL SPRINGS BLVD",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972068599,
    "dropphyadd": "8100 SE CRYSTAL SPRINGS BLVD",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972068599,
    "dropmaladd": "8100 SE CRYSTAL SPRINGS BLVD",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972068599,
    "dropsitphn": 9712013788,
    "dropsitlph": 5037743009,
    "dropsitcph": 5037744938,
    "dropfax": 5067758759
  },
  {
    "dcode": "D",
    "dropkey": "4Z16936",
    "droptype": "D",
    "dropname": "INTERBAY CARRIER ANNEX",
    "dropdeladd": "2010 15TH AVE W",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981199998,
    "dropphyadd": "2010 15TH AVE W",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981199998,
    "dropmaladd": "2010 15TH AVE W",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981199998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2062839294,
    "dropsitcph": 2062845958,
    "dropfax": 6514566190
  },
  {
    "dcode": "D",
    "dropkey": "4Z17282",
    "droptype": "D",
    "dropname": "PERRINVILLE",
    "dropdeladd": "7601 OLYMPIC VIEW DR",
    "dropdelcty": "EDMONDS",
    "dropdelst": "WA",
    "dropdelzpp": 980269998,
    "dropphyadd": "7601 OLYMPIC VIEW DR",
    "dropphycty": "EDMONDS",
    "dropphyst": "WA",
    "dropphyzpp": 980269998,
    "dropmaladd": "7601 OLYMPIC VIEW DR",
    "dropmalcty": "EDMONDS",
    "dropmalst": "WA",
    "dropmalzpp": 980269998,
    "dropsitphn": 2067684422,
    "dropsitlph": 4256724437,
    "dropsitcph": 4257719173,
    "dropfax": 6514566232
  },
  {
    "dcode": "D",
    "dropkey": "4Z18088",
    "droptype": "D",
    "dropname": "EAST VANCOUVER DCU",
    "dropdeladd": "401 NE 136TH AVE",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986846916,
    "dropphyadd": "401 NE 136TH AVE",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986846916,
    "dropmaladd": "401 NE 136TH AVE",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986849998,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608831385,
    "dropsitcph": 3608831385,
    "dropfax": 3608820301
  },
  {
    "dcode": "D",
    "dropkey": "4Z18134",
    "droptype": "D",
    "dropname": "SAND ISLAND CARRIER ANNEX",
    "dropdeladd": "91 SAND ISLAND ACCESS RD",
    "dropdelcty": "HONOLULU",
    "dropdelst": "HI",
    "dropdelzpp": 968199998,
    "dropphyadd": "91 SAND ISLAND ACCESS RD",
    "dropphycty": "HONOLULU",
    "dropphyst": "HI",
    "dropphyzpp": 968199998,
    "dropmaladd": "91 SAND ISLAND ACCESS RD",
    "dropmalcty": "HONOLULU",
    "dropmalst": "HI",
    "dropmalzpp": 968199998,
    "dropsitphn": 8084233844,
    "dropsitlph": 8088320046,
    "dropsitcph": 8088320046,
    "dropfax": 8088323917
  },
  {
    "dcode": "D",
    "dropkey": "4Z18136",
    "droptype": "D",
    "dropname": "CAVE CREEK CARRIER ANNEX",
    "dropdeladd": "6710 E CAVE CREEK RD",
    "dropdelcty": "CAVE CREEK",
    "dropdelst": "AZ",
    "dropdelzpp": 853318629,
    "dropphyadd": "6710 E CAVE CREEK RD",
    "dropphycty": "CAVE CREEK",
    "dropphyst": "AZ",
    "dropphyzpp": 853318629,
    "dropmaladd": "6710 E CAVE CREEK RD",
    "dropmalcty": "CAVE CREEK",
    "dropmalst": "AZ",
    "dropmalzpp": 853318629,
    "dropsitphn": 6022253214,
    "dropsitlph": 4805756176,
    "dropsitcph": 4805750813,
    "dropfax": 4805756181
  },
  {
    "dcode": "D",
    "dropkey": "4Z18137",
    "droptype": "D",
    "dropname": "METRO CARRIER ANNEX",
    "dropdeladd": "5511 E ALKI AVE",
    "dropdelcty": "SPOKANE VALLEY",
    "dropdelst": "WA",
    "dropdelzpp": 992129998,
    "dropphyadd": "5511 E ALKI AVE",
    "dropphycty": "SPOKANE VALLEY",
    "dropphyst": "WA",
    "dropphyzpp": 992129998,
    "dropmaladd": "5511 E ALKI AVE",
    "dropmalcty": "SPOKANE VALLEY",
    "dropmalst": "WA",
    "dropmalzpp": 992129998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5093632322,
    "dropsitcph": 5092522320,
    "dropfax": 6514566211
  },
  {
    "dcode": "D",
    "dropkey": "4Z18165",
    "droptype": "D",
    "dropname": "COEUR D ALENE CARRIER ANNEX",
    "dropdeladd": "3845 N SCHREIBER WAY",
    "dropdelcty": "COEUR D ALENE",
    "dropdelst": "ID",
    "dropdelzpp": 838158320,
    "dropphyadd": "3845 N SCHREIBER WAY",
    "dropphycty": "COEUR D ALENE",
    "dropphyst": "ID",
    "dropphyzpp": 838158320,
    "dropmaladd": "3845 N SCHREIBER WAY",
    "dropmalcty": "COEUR D ALENE",
    "dropmalst": "ID",
    "dropmalzpp": 838158320,
    "dropsitphn": 5093636210,
    "dropsitlph": 2087654890,
    "dropsitcph": 2087656349,
    "dropfax": 6513066692
  },
  {
    "dcode": "D",
    "dropkey": "4Z18218",
    "droptype": "D",
    "dropname": "SALEM HOLLYWOOD DCU",
    "dropdeladd": "2222 CLAXTER RD NE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973012397,
    "dropphyadd": "2222 CLAXTER RD NE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973012397,
    "dropmaladd": "2222 CLAXTER RD NE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973019998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5034634245,
    "dropsitcph": 5033049471,
    "dropfax": 5034631432
  },
  {
    "dcode": "D",
    "dropkey": "4Z18230",
    "droptype": "D",
    "dropname": "ROSWELL ANX",
    "dropdeladd": "497 W BRASHER RD",
    "dropdelcty": "ROSWELL",
    "dropdelst": "NM",
    "dropdelzpp": 882039998,
    "dropphyadd": "497 W BRASHER RD",
    "dropphycty": "ROSWELL",
    "dropphyst": "NM",
    "dropphyzpp": 882039998,
    "dropmaladd": "497 W BRASHER RD",
    "dropmalcty": "ROSWELL",
    "dropmalst": "NM",
    "dropmalzpp": 882039998,
    "dropsitphn": 5053468251,
    "dropsitlph": 5756238699,
    "dropsitcph": 5756238699,
    "dropfax": 5756278256
  },
  {
    "dcode": "D",
    "dropkey": "4Z18241",
    "droptype": "D",
    "dropname": "SUNNYSIDE CARRIER ANNEX",
    "dropdeladd": "770 CUSTER AVE",
    "dropdelcty": "SUNNYSIDE",
    "dropdelst": "WA",
    "dropdelzpp": 989449997,
    "dropphyadd": "770 CUSTER AVE",
    "dropphycty": "SUNNYSIDE",
    "dropphyst": "WA",
    "dropphyzpp": 989449997,
    "dropmaladd": "770 CUSTER AVE",
    "dropmalcty": "SUNNYSIDE",
    "dropmalst": "WA",
    "dropmalzpp": 989449997,
    "dropsitphn": 2067684422,
    "dropsitlph": 5098378165,
    "dropsitcph": 5098378165,
    "dropfax": 6514566272
  },
  {
    "dcode": "D",
    "dropkey": "4Z18243",
    "droptype": "D",
    "dropname": "EUGENE MAIN OFC CARRIER ANX",
    "dropdeladd": "50 W 5TH AVE",
    "dropdelcty": "EUGENE",
    "dropdelst": "OR",
    "dropdelzpp": 974012602,
    "dropphyadd": "50 W 5TH AVE",
    "dropphycty": "EUGENE",
    "dropphyst": "OR",
    "dropphyzpp": 974012602,
    "dropmaladd": "50 W 5TH AVE",
    "dropmalcty": "EUGENE",
    "dropmalst": "OR",
    "dropmalzpp": 974012602,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413639,
    "dropsitcph": 5413413639,
    "dropfax": 5413413663
  },
  {
    "dcode": "D",
    "dropkey": "4Z18248",
    "droptype": "D",
    "dropname": "MEDFORD CARRIER ANNEX",
    "dropdeladd": "173 EHRMAN WAY",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OR",
    "dropdelzpp": 975011335,
    "dropphyadd": "173 EHRMAN WAY",
    "dropphycty": "MEDFORD",
    "dropphyst": "OR",
    "dropphyzpp": 975011335,
    "dropmaladd": "173 EHRMAN WAY",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OR",
    "dropmalzpp": 975011335,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5417744088,
    "dropfax": 5416088246
  },
  {
    "dcode": "D",
    "dropkey": "4Z18276",
    "droptype": "D",
    "dropname": "NAMPA CARRIER ANNEX",
    "dropdeladd": "820 PARKCENTRE WAY",
    "dropdelcty": "NAMPA",
    "dropdelst": "ID",
    "dropdelzpp": 836511799,
    "dropphyadd": "820 PARKCENTRE WAY",
    "dropphycty": "NAMPA",
    "dropphyst": "ID",
    "dropphyzpp": 836511799,
    "dropmaladd": "820 PARKCENTRE WAY",
    "dropmalcty": "NAMPA",
    "dropmalst": "ID",
    "dropmalzpp": 836511799,
    "dropsitphn": 2084334080,
    "dropsitlph": 2084680550,
    "dropsitcph": 2084680550,
    "dropfax": 2084680568
  },
  {
    "dcode": "D",
    "dropkey": "4Z18283",
    "droptype": "D",
    "dropname": "LAFAYETTE CARRIER ANNEX",
    "dropdeladd": "109 KIMBARK ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "CO",
    "dropdelzpp": 800269997,
    "dropphyadd": "109 KIMBARK ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "CO",
    "dropphyzpp": 800269997,
    "dropmaladd": "109 KIMBARK ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "CO",
    "dropmalzpp": 800269997,
    "dropsitphn": 3038536511,
    "dropsitlph": 3036640645,
    "dropsitcph": 3036641241,
    "dropfax": 3036651325
  },
  {
    "dcode": "D",
    "dropkey": "4Z18343",
    "droptype": "D",
    "dropname": "TCCF EAST",
    "dropdeladd": "3825 S WARNER ST",
    "dropdelcty": "TACOMA",
    "dropdelst": "WA",
    "dropdelzpp": 984099998,
    "dropphyadd": "3825 S WARNER ST",
    "dropphycty": "TACOMA",
    "dropphyst": "WA",
    "dropphyzpp": 984099998,
    "dropmaladd": "3825 S WARNER ST",
    "dropmalcty": "TACOMA",
    "dropmalst": "WA",
    "dropmalzpp": 984099998,
    "dropsitphn": 2067684422,
    "dropsitlph": 2533207238,
    "dropsitcph": 2533207238,
    "dropfax": 2533207232
  },
  {
    "dcode": "D",
    "dropkey": "4Z18347",
    "droptype": "D",
    "dropname": "NORTHVIEW",
    "dropdeladd": "850 W 112TH AVE",
    "dropdelcty": "NORTHGLENN",
    "dropdelst": "CO",
    "dropdelzpp": 802349998,
    "dropphyadd": "850 W 112TH AVE",
    "dropphycty": "NORTHGLENN",
    "dropphyst": "CO",
    "dropphyzpp": 802349998,
    "dropmaladd": "850 W 112TH AVE",
    "dropmalcty": "NORTHGLENN",
    "dropmalst": "CO",
    "dropmalzpp": 802349998,
    "dropsitphn": 3038536511,
    "dropsitlph": 3034571467,
    "dropsitcph": 3034576991,
    "dropfax": 3034570678
  },
  {
    "dcode": "D",
    "dropkey": "4Z18768",
    "droptype": "D",
    "dropname": "NEWBERG DCU",
    "dropdeladd": "116 N EVEREST ST",
    "dropdelcty": "NEWBERG",
    "dropdelst": "OR",
    "dropdelzpp": 971322155,
    "dropphyadd": "116 N EVEREST ST",
    "dropphycty": "NEWBERG",
    "dropphyst": "OR",
    "dropphyzpp": 971322155,
    "dropmaladd": "401 E 1ST ST",
    "dropmalcty": "NEWBERG",
    "dropmalst": "OR",
    "dropmalzpp": 971329998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5035380299,
    "dropsitcph": 5035380561,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4Z18782",
    "droptype": "D",
    "dropname": "TUALATIN DCU",
    "dropdeladd": "18850 SW TETON AVE",
    "dropdelcty": "TUALATIN",
    "dropdelst": "OR",
    "dropdelzpp": 970628806,
    "dropphyadd": "18850 SW TETON AVE",
    "dropphycty": "TUALATIN",
    "dropphyst": "OR",
    "dropphyzpp": 970628806,
    "dropmaladd": "18850 SW TETON AVE",
    "dropmalcty": "TUALATIN",
    "dropmalst": "OR",
    "dropmalzpp": 970629995,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036929414,
    "dropsitcph": 5036920423,
    "dropfax": 5036917877
  },
  {
    "dcode": "D",
    "dropkey": "4Z18783",
    "droptype": "D",
    "dropname": "HILLSBORO DCU",
    "dropdeladd": "1330 SW WALNUT ST",
    "dropdelcty": "HILLSBORO",
    "dropdelst": "OR",
    "dropdelzpp": 971239994,
    "dropphyadd": "1330 SW WALNUT ST",
    "dropphycty": "HILLSBORO",
    "dropphyst": "OR",
    "dropphyzpp": 971239994,
    "dropmaladd": "1330 SW WALNUT ST",
    "dropmalcty": "HILLSBORO",
    "dropmalst": "OR",
    "dropmalzpp": 971239994,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036153025,
    "dropsitcph": 5036152825,
    "dropfax": 5036150806
  },
  {
    "dcode": "D",
    "dropkey": "4Z18796",
    "droptype": "D",
    "dropname": "GRANTS PASS DCU",
    "dropdeladd": "1636 NW WASHINGTON BLVD",
    "dropdelcty": "GRANTS PASS",
    "dropdelst": "OR",
    "dropdelzpp": 975266005,
    "dropphyadd": "1636 NW WASHINGTON BLVD",
    "dropphycty": "GRANTS PASS",
    "dropphyst": "OR",
    "dropphyzpp": 975266005,
    "dropmaladd": "1636 NW WASHINGTON BLVD",
    "dropmalcty": "GRANTS PASS",
    "dropmalst": "OR",
    "dropmalzpp": 975266005,
    "dropsitphn": 9712013788,
    "dropsitlph": 5414711837,
    "dropsitcph": 5419565437,
    "dropfax": 5414713446
  },
  {
    "dcode": "D",
    "dropkey": "4Z18849",
    "droptype": "D",
    "dropname": "BURLINGTON CARRIER ANNEX",
    "dropdeladd": "151 N BURLINGTON BLVD",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "WA",
    "dropdelzpp": 982339997,
    "dropphyadd": "151 N BURLINGTON BLVD",
    "dropphycty": "BURLINGTON",
    "dropphyst": "WA",
    "dropphyzpp": 982339997,
    "dropmaladd": "720 E FAIRHAVEN AVE",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "WA",
    "dropmalzpp": 982339996,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607070408,
    "dropsitcph": 3607070510,
    "dropfax": 6514566595
  },
  {
    "dcode": "D",
    "dropkey": "4Z18850",
    "droptype": "D",
    "dropname": "NORTHPOINTE",
    "dropdeladd": "9857 N NEVADA ST",
    "dropdelcty": "SPOKANE",
    "dropdelst": "WA",
    "dropdelzpp": 992189998,
    "dropphyadd": "9857 N NEVADA ST",
    "dropphycty": "SPOKANE",
    "dropphyst": "WA",
    "dropphyzpp": 992189998,
    "dropmaladd": "9857 N NEVADA ST",
    "dropmalcty": "SPOKANE",
    "dropmalst": "WA",
    "dropmalzpp": 992189998,
    "dropsitphn": 5093636210,
    "dropsitlph": 5094650319,
    "dropsitcph": 5094650313,
    "dropfax": 6514566225
  },
  {
    "dcode": "D",
    "dropkey": "4Z18912",
    "droptype": "D",
    "dropname": "MAIN OFFICE ALBUQUERQUE",
    "dropdeladd": "1135 BROADWAY BLVD NE BLDG C",
    "dropdelcty": "ALBUQUERQUE",
    "dropdelst": "NM",
    "dropdelzpp": 871019901,
    "dropphyadd": "1135 BROADWAY BLVD NE BLDG C",
    "dropphycty": "ALBUQUERQUE",
    "dropphyst": "NM",
    "dropphyzpp": 871019901,
    "dropmaladd": "1135 BROADWAY BLVD NE BLDG C",
    "dropmalcty": "ALBUQUERQUE",
    "dropmalst": "NM",
    "dropmalzpp": 871019901,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468049,
    "dropsitcph": 5053468051,
    "dropfax": 5053468059
  },
  {
    "dcode": "D",
    "dropkey": "4Z18967",
    "droptype": "D",
    "dropname": "WASILLA ANNEX",
    "dropdeladd": "626 N BOBBY DAY CIR",
    "dropdelcty": "WASILLA",
    "dropdelst": "AK",
    "dropdelzpp": 996547369,
    "dropphyadd": "626 N BOBBY DAY CIR",
    "dropphycty": "WASILLA",
    "dropphyst": "AK",
    "dropphyzpp": 996547369,
    "dropmaladd": "626 N BOBBY DAY CIR",
    "dropmalcty": "WASILLA",
    "dropmalst": "AK",
    "dropmalzpp": 996547369,
    "dropsitphn": 9073764194,
    "dropsitlph": 9073764194,
    "dropsitcph": 9073764206,
    "dropfax": 9073764202
  },
  {
    "dcode": "D",
    "dropkey": "4Z18969",
    "droptype": "D",
    "dropname": "BEND DCU",
    "dropdeladd": "836 SE BUSINESS WAY",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977021211,
    "dropphyadd": "836 SE BUSINESS WAY",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977021211,
    "dropmaladd": "836 SE BUSINESS WAY",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977021211,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413122094,
    "dropsitcph": 5413179751,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4Z18974",
    "droptype": "D",
    "dropname": "CENTRALIA CARRIER ANNEX",
    "dropdeladd": "3615 NORTHPARK DR",
    "dropdelcty": "CENTRALIA",
    "dropdelst": "WA",
    "dropdelzpp": 985319997,
    "dropphyadd": "3615 NORTHPARK DR",
    "dropphycty": "CENTRALIA",
    "dropphyst": "WA",
    "dropphyzpp": 985319997,
    "dropmaladd": "3615 NORTHPARK DR",
    "dropmalcty": "CENTRALIA",
    "dropmalst": "WA",
    "dropmalzpp": 985319997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607368215,
    "dropsitcph": 3608072144,
    "dropfax": 6514566598
  },
  {
    "dcode": "D",
    "dropkey": "4Z18975",
    "droptype": "D",
    "dropname": "LIVINGSTON ANNEX",
    "dropdeladd": "230 JEFFERSON ST",
    "dropdelcty": "LIVINGSTON",
    "dropdelst": "MT",
    "dropdelzpp": 590474202,
    "dropphyadd": "230 JEFFERSON ST",
    "dropphycty": "LIVINGSTON",
    "dropphyst": "MT",
    "dropphyzpp": 590474202,
    "dropmaladd": "230 JEFFERSON ST",
    "dropmalcty": "LIVINGSTON",
    "dropmalst": "MT",
    "dropmalzpp": 590474202,
    "dropsitphn": 4066575713,
    "dropsitlph": 4062223458,
    "dropsitcph": 4062223458,
    "dropfax": 4062222187
  },
  {
    "dcode": "D",
    "dropkey": "4Z18990",
    "droptype": "D",
    "dropname": "RIFLE ANNEX",
    "dropdeladd": "818 TAUGHENBAUGH BLVD STE 106",
    "dropdelcty": "RIFLE",
    "dropdelst": "CO",
    "dropdelzpp": 816509997,
    "dropphyadd": "818 TAUGHENBAUGH BLVD STE 106",
    "dropphycty": "RIFLE",
    "dropphyst": "CO",
    "dropphyzpp": 816509997,
    "dropmaladd": "818 TAUGHENBAUGH BLVD STE 106",
    "dropmalcty": "RIFLE",
    "dropmalst": "CO",
    "dropmalzpp": 816509997,
    "dropsitphn": 3038536511,
    "dropsitlph": 9706251078,
    "dropsitcph": 9706251078,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4Z20520",
    "droptype": "D",
    "dropname": "EL CERRITO CARRIER ANNEX",
    "dropdeladd": "11245 SAN PABLO AVE",
    "dropdelcty": "EL CERRITO",
    "dropdelst": "CA",
    "dropdelzpp": 945309992,
    "dropphyadd": "11245 SAN PABLO AVE",
    "dropphycty": "EL CERRITO",
    "dropphyst": "CA",
    "dropphyzpp": 945309992,
    "dropmaladd": "11135 SAN PABLO AVE",
    "dropmalcty": "EL CERRITO",
    "dropmalst": "CA",
    "dropmalzpp": 945309998,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102375859,
    "dropsitcph": 5102375746,
    "dropfax": 5102355981
  },
  {
    "dcode": "D",
    "dropkey": "4Z20521",
    "droptype": "D",
    "dropname": "LIVERMORE ANNEX",
    "dropdeladd": "2090 LAS POSITAS CT",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "CA",
    "dropdelzpp": 945509992,
    "dropphyadd": "2090 LAS POSITAS CT",
    "dropphycty": "LIVERMORE",
    "dropphyst": "CA",
    "dropphyzpp": 945509831,
    "dropmaladd": "220 S LIVERMORE AVE",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "CA",
    "dropmalzpp": 945509998,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254557175,
    "dropsitcph": 9254557173,
    "dropfax": 9254432805
  },
  {
    "dcode": "D",
    "dropkey": "4Z21105",
    "droptype": "D",
    "dropname": "ALAMEDA CARRIER ANNEX",
    "dropdeladd": "1055 N VIGNES ST",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900122930,
    "dropphyadd": "1055 N VIGNES ST",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900122930,
    "dropmaladd": "1055 N VIGNES ST",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900122930,
    "dropsitphn": 2136174405,
    "dropsitlph": 2136174412,
    "dropsitcph": 2136174405,
    "dropfax": 2136174486
  },
  {
    "dcode": "D",
    "dropkey": "4Z21550",
    "droptype": "D",
    "dropname": "JOHN SANCHEZ ANNEX",
    "dropdeladd": "1451 WALSH AVE",
    "dropdelcty": "SANTA CLARA",
    "dropdelst": "CA",
    "dropdelzpp": 950502641,
    "dropphyadd": "1451 WALSH AVE",
    "dropphycty": "SANTA CLARA",
    "dropphyst": "CA",
    "dropphyzpp": 950502641,
    "dropmaladd": "1451 WALSH AVE",
    "dropmalcty": "SANTA CLARA",
    "dropmalst": "CA",
    "dropmalzpp": 950502641,
    "dropsitphn": 4084376726,
    "dropsitlph": 4087483524,
    "dropsitcph": 4087489868,
    "dropfax": 4087480768
  },
  {
    "dcode": "D",
    "dropkey": "4Z21739",
    "droptype": "D",
    "dropname": "LINCOLN HGTS CARRIER ANNEX",
    "dropdeladd": "2425 ALHAMBRA AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900319998,
    "dropphyadd": "2425 ALHAMBRA AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900319998,
    "dropmaladd": "2425 ALHAMBRA AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900319998,
    "dropsitphn": 3235861867,
    "dropsitlph": 3232260578,
    "dropsitcph": 3232260016,
    "dropfax": 3232260052
  },
  {
    "dcode": "D",
    "dropkey": "4Z21775",
    "droptype": "D",
    "dropname": "LOMA",
    "dropdeladd": "3540 E 4TH ST",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908039998,
    "dropphyadd": "3540 E 4TH ST",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908039998,
    "dropmaladd": "3540 E 4TH ST",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908039998,
    "dropsitphn": 5624384654,
    "dropsitlph": 5624384654,
    "dropsitcph": 5624349919,
    "dropfax": 5624337148
  },
  {
    "dcode": "D",
    "dropkey": "4Z21919",
    "droptype": "D",
    "dropname": "MC VITTIE ANNEX",
    "dropdeladd": "2100 CHANSLOR AVE",
    "dropdelcty": "RICHMOND",
    "dropdelst": "CA",
    "dropdelzpp": 948049991,
    "dropphyadd": "2100 CHANSLOR AVE",
    "dropphycty": "RICHMOND",
    "dropphyst": "CA",
    "dropphyzpp": 948049991,
    "dropmaladd": "2100 CHANSLOR AVE",
    "dropmalcty": "RICHMOND",
    "dropmalst": "CA",
    "dropmalzpp": 948049991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102320483,
    "dropsitcph": 5102329581,
    "dropfax": 5102323718
  },
  {
    "dcode": "D",
    "dropkey": "4Z22357",
    "droptype": "D",
    "dropname": "OTAY MESA ANNEX",
    "dropdeladd": "2960 FERN AVE",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921549998,
    "dropphyadd": "2960 FERN AVE",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921549998,
    "dropmaladd": "2960 FERN AVE",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921549998,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194298424,
    "dropsitcph": 6194298414,
    "dropfax": 6194298315
  },
  {
    "dcode": "D",
    "dropkey": "4Z22601",
    "droptype": "D",
    "dropname": "RANCHO BERNARDO ANNEX",
    "dropdeladd": "16960 BERNARDO CENTER DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921289998,
    "dropphyadd": "16960 BERNARDO CENTER DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921289998,
    "dropmaladd": "16960 BERNARDO CENTER DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921289998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8584870056,
    "dropsitcph": 8584870857,
    "dropfax": 8584877524
  },
  {
    "dcode": "D",
    "dropkey": "4Z23082",
    "droptype": "D",
    "dropname": "SPRING CARRIER ANNEX",
    "dropdeladd": "3019 N BELLFLOWER BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908089998,
    "dropphyadd": "3019 N BELLFLOWER BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908089998,
    "dropmaladd": "3019 N BELLFLOWER BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908089998,
    "dropsitphn": 5624291285,
    "dropsitlph": 5624963776,
    "dropsitcph": 5624291285,
    "dropfax": 5624218645
  },
  {
    "dcode": "D",
    "dropkey": "4Z23820",
    "droptype": "D",
    "dropname": "WEST GRAND CARRIER ANNEX",
    "dropdeladd": "577 W GRAND AVE",
    "dropdelcty": "OAKLAND",
    "dropdelst": "CA",
    "dropdelzpp": 946129995,
    "dropphyadd": "577 W GRAND AVE",
    "dropphycty": "OAKLAND",
    "dropphyst": "CA",
    "dropphyzpp": 946129995,
    "dropmaladd": "577 W GRAND AVE",
    "dropmalcty": "OAKLAND",
    "dropmalst": "CA",
    "dropmalzpp": 946129995,
    "dropsitphn": 5108323950,
    "dropsitlph": 5102513394,
    "dropsitcph": 5102513113,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "4Z24215",
    "droptype": "D",
    "dropname": "RIALTO ANNEX",
    "dropdeladd": "1630 N RIVERSIDE AVE",
    "dropdelcty": "RIALTO",
    "dropdelst": "CA",
    "dropdelzpp": 923768084,
    "dropphyadd": "1630 N RIVERSIDE AVE",
    "dropphycty": "RIALTO",
    "dropphyst": "CA",
    "dropphyzpp": 923768084,
    "dropmaladd": "1630 N RIVERSIDE AVE",
    "dropmalcty": "RIALTO",
    "dropmalst": "CA",
    "dropmalzpp": 923768084,
    "dropsitphn": 9093354694,
    "dropsitlph": 9098200363,
    "dropsitcph": 9098200363,
    "dropfax": 9098203490
  },
  {
    "dcode": "D",
    "dropkey": "4Z24287",
    "droptype": "D",
    "dropname": "CEDAR ANNEX",
    "dropdeladd": "2382 S CEDAR AVE",
    "dropdelcty": "FRESNO",
    "dropdelst": "CA",
    "dropdelzpp": 937259998,
    "dropphyadd": "2382 S CEDAR AVE",
    "dropphycty": "FRESNO",
    "dropphyst": "CA",
    "dropphyzpp": 937259998,
    "dropmaladd": "2382 S CEDAR AVE",
    "dropmalcty": "FRESNO",
    "dropmalst": "CA",
    "dropmalzpp": 937259998,
    "dropsitphn": 5594977615,
    "dropsitlph": 5592330542,
    "dropsitcph": 5592330469,
    "dropfax": 5592330684
  },
  {
    "dcode": "D",
    "dropkey": "4Z24294",
    "droptype": "D",
    "dropname": "NORTH BEACH ANNEX",
    "dropdeladd": "2200 POWELL ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941339992,
    "dropphyadd": "2200 POWELL ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941339992,
    "dropmaladd": "2200 POWELL ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941339992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4159863494,
    "dropsitcph": 4159863494,
    "dropfax": 4159863596
  },
  {
    "dcode": "D",
    "dropkey": "4Z24300",
    "droptype": "D",
    "dropname": "SEVEN TREES ANNEX",
    "dropdeladd": "80 LEWIS RD",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951119998,
    "dropphyadd": "80 LEWIS RD",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951119998,
    "dropmaladd": "80 LEWIS RD",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951119998,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082818520,
    "dropsitcph": 4082810177,
    "dropfax": 4082818513
  },
  {
    "dcode": "D",
    "dropkey": "4Z24329",
    "droptype": "D",
    "dropname": "OILDALE",
    "dropdeladd": "7229 DOLE CT",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933089547,
    "dropphyadd": "7229 DOLE CT",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933089547,
    "dropmaladd": "7229 DOLE CT",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933089547,
    "dropsitphn": 6617757808,
    "dropsitlph": 6613918026,
    "dropsitcph": 6613918026,
    "dropfax": 6613910529
  },
  {
    "dcode": "D",
    "dropkey": "4Z24345",
    "droptype": "D",
    "dropname": "UNIVERSITY CITY ANNEX",
    "dropdeladd": "5045 SHOREHAM PL",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921229998,
    "dropphyadd": "5045 SHOREHAM PL",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921229998,
    "dropmaladd": "5045 SHOREHAM PL",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921229998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8584531008,
    "dropsitcph": 8584530121,
    "dropfax": 8584531452
  },
  {
    "dcode": "D",
    "dropkey": "4Z24380",
    "droptype": "D",
    "dropname": "NORTH CARRIER ANNEX",
    "dropdeladd": "5101 LONG BEACH BLVD",
    "dropdelcty": "LONG BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 908059996,
    "dropphyadd": "5101 LONG BEACH BLVD",
    "dropphycty": "LONG BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 908059996,
    "dropmaladd": "5101 LONG BEACH BLVD",
    "dropmalcty": "LONG BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 908059997,
    "dropsitphn": 5624942406,
    "dropsitlph": 5624222197,
    "dropsitcph": 5624227584,
    "dropfax": 5624288275
  },
  {
    "dcode": "D",
    "dropkey": "4Z24435",
    "droptype": "D",
    "dropname": "FREMONT DETACHED DEL UNIT",
    "dropdeladd": "4260 BUSINESS CENTER DR",
    "dropdelcty": "FREMONT",
    "dropdelst": "CA",
    "dropdelzpp": 945389989,
    "dropphyadd": "4260 BUSINESS CENTER DR",
    "dropphycty": "FREMONT",
    "dropphyst": "CA",
    "dropphyzpp": 945389989,
    "dropmaladd": "4260 BUSINESS CENTER DR",
    "dropmalcty": "FREMONT",
    "dropmalst": "CA",
    "dropmalzpp": 945389989,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102260858,
    "dropsitcph": 5102260195,
    "dropfax": 5106512061
  },
  {
    "dcode": "D",
    "dropkey": "4Z24668",
    "droptype": "D",
    "dropname": "SANTA ROSA CARRIER ANNEX",
    "dropdeladd": "2850 MCBRIDE LN",
    "dropdelcty": "SANTA ROSA",
    "dropdelst": "CA",
    "dropdelzpp": 954039991,
    "dropphyadd": "2850 MCBRIDE LN",
    "dropphycty": "SANTA ROSA",
    "dropphyst": "CA",
    "dropphyzpp": 954039991,
    "dropmaladd": "2850 MCBRIDE LN",
    "dropmalcty": "SANTA ROSA",
    "dropmalst": "CA",
    "dropmalzpp": 954039991,
    "dropsitphn": 7075260151,
    "dropsitlph": 7075260151,
    "dropsitcph": 7075260113,
    "dropfax": 7075466329
  },
  {
    "dcode": "D",
    "dropkey": "4Z24669",
    "droptype": "D",
    "dropname": "SEBASTOPOL CARRIER ANNEX",
    "dropdeladd": "275 PETALUMA AVE",
    "dropdelcty": "SEBASTOPOL",
    "dropdelst": "CA",
    "dropdelzpp": 954729992,
    "dropphyadd": "275 PETALUMA AVE",
    "dropphycty": "SEBASTOPOL",
    "dropphyst": "CA",
    "dropphyzpp": 954729992,
    "dropmaladd": "275 PETALUMA AVE",
    "dropmalcty": "SEBASTOPOL",
    "dropmalst": "CA",
    "dropmalzpp": 954729992,
    "dropsitphn": 7078299362,
    "dropsitlph": 7078231427,
    "dropsitcph": 7078231427,
    "dropfax": 7078236545
  },
  {
    "dcode": "D",
    "dropkey": "4Z24673",
    "droptype": "D",
    "dropname": "FOOTHILL ANNEX",
    "dropdeladd": "1085 MCGINNESS AVE",
    "dropdelcty": "SAN JOSE",
    "dropdelst": "CA",
    "dropdelzpp": 951279900,
    "dropphyadd": "1085 MCGINNESS AVE",
    "dropphycty": "SAN JOSE",
    "dropphyst": "CA",
    "dropphyzpp": 951279900,
    "dropmaladd": "1085 MCGINNESS AVE",
    "dropmalcty": "SAN JOSE",
    "dropmalst": "CA",
    "dropmalzpp": 951279900,
    "dropsitphn": 4084376726,
    "dropsitlph": 4082590823,
    "dropsitcph": 4082595108,
    "dropfax": 4082592485
  },
  {
    "dcode": "D",
    "dropkey": "4Z24684",
    "droptype": "D",
    "dropname": "LOVERS LANE",
    "dropdeladd": "1230 S LOVERS LN",
    "dropdelcty": "VISALIA",
    "dropdelst": "CA",
    "dropdelzpp": 932925248,
    "dropphyadd": "1230 S LOVERS LN",
    "dropphycty": "VISALIA",
    "dropphyst": "CA",
    "dropphyzpp": 932925248,
    "dropmaladd": "1230 S LOVERS LN",
    "dropmalcty": "VISALIA",
    "dropmalst": "CA",
    "dropmalzpp": 932925248,
    "dropsitphn": 6617757808,
    "dropsitlph": 5596350179,
    "dropsitcph": 5596350179,
    "dropfax": 5596350180
  },
  {
    "dcode": "D",
    "dropkey": "4Z24706",
    "droptype": "D",
    "dropname": "HILLTOP CARRIER ANNEX",
    "dropdeladd": "4180 LAKESIDE DR",
    "dropdelcty": "SAN PABLO",
    "dropdelst": "CA",
    "dropdelzpp": 948069992,
    "dropphyadd": "4180 LAKESIDE DR",
    "dropphycty": "SAN PABLO",
    "dropphyst": "CA",
    "dropphyzpp": 948069992,
    "dropmaladd": "4180 LAKESIDE DR",
    "dropmalcty": "SAN PABLO",
    "dropmalst": "CA",
    "dropmalzpp": 948069992,
    "dropsitphn": 5104337569,
    "dropsitlph": 5102626941,
    "dropsitcph": 5102234654,
    "dropfax": 5108748544
  },
  {
    "dcode": "D",
    "dropkey": "4Z24785",
    "droptype": "D",
    "dropname": "MADERA CARRIER ANNEX",
    "dropdeladd": "220 S C ST",
    "dropdelcty": "MADERA",
    "dropdelst": "CA",
    "dropdelzpp": 936389997,
    "dropphyadd": "220 S C ST",
    "dropphycty": "MADERA",
    "dropphyst": "CA",
    "dropphyzpp": 936389997,
    "dropmaladd": "220 S C ST",
    "dropmalcty": "MADERA",
    "dropmalst": "CA",
    "dropmalzpp": 936389997,
    "dropsitphn": 5596732732,
    "dropsitlph": 5596648578,
    "dropsitcph": 5596648578,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": "4Z24807",
    "droptype": "D",
    "dropname": "BERKELEY DETACHED DEL UNIT",
    "dropdeladd": "1150 8TH ST",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947101204,
    "dropphyadd": "1150 8TH ST",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947101204,
    "dropmaladd": "1150 8TH ST",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947109991,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106493146,
    "dropsitcph": 5106493143,
    "dropfax": 5106493124
  },
  {
    "dcode": "D",
    "dropkey": 4000013,
    "droptype": "D",
    "dropname": "NORTHVIEW ANNEX",
    "dropdeladd": "3120 BAIR AVE",
    "dropdelcty": "LINCOLN",
    "dropdelst": "NE",
    "dropdelzpp": 685041015,
    "dropphyadd": "3120 BAIR AVE",
    "dropphycty": "LINCOLN",
    "dropphyst": "NE",
    "dropphyzpp": 685041015,
    "dropmaladd": "3120 BAIR AVE",
    "dropmalcty": "LINCOLN",
    "dropmalst": "NE",
    "dropmalzpp": 685041015,
    "dropsitphn": 4024731617,
    "dropsitlph": 4024731780,
    "dropsitcph": 4024581848,
    "dropfax": 4024731795
  },
  {
    "dcode": "D",
    "dropkey": 4000022,
    "droptype": "D",
    "dropname": "ELGIN WEST SIDE ANNEX",
    "dropdeladd": "195 S RANDALL RD",
    "dropdelcty": "ELGIN",
    "dropdelst": "IL",
    "dropdelzpp": 601235559,
    "dropphyadd": "195 S RANDALL RD",
    "dropphycty": "ELGIN",
    "dropphyst": "IL",
    "dropphyzpp": 601235559,
    "dropmaladd": "195 S RANDALL RD",
    "dropmalcty": "ELGIN",
    "dropmalst": "IL",
    "dropmalzpp": 601235559,
    "dropsitphn": 6302605499,
    "dropsitlph": 8476951254,
    "dropsitcph": 8476951254,
    "dropfax": 8476954176
  },
  {
    "dcode": "D",
    "dropkey": 4000106,
    "droptype": "D",
    "dropname": "ORONO CARRIER ANNEX",
    "dropdeladd": "21 GODFREY DR",
    "dropdelcty": "ORONO",
    "dropdelst": "ME",
    "dropdelzpp": "044733694",
    "dropphyadd": "21 GODFREY DR",
    "dropphycty": "ORONO",
    "dropphyst": "ME",
    "dropphyzpp": "044733694",
    "dropmaladd": "21 GODFREY DR",
    "dropmalcty": "ORONO",
    "dropmalst": "ME",
    "dropmalzpp": "044733694",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078662566,
    "dropsitcph": 2078662618,
    "dropfax": 2078663903
  },
  {
    "dcode": "D",
    "dropkey": 4000168,
    "droptype": "D",
    "dropname": "HENDERSONVILLE ANNEX",
    "dropdeladd": "90 LAKEWOOD RD",
    "dropdelcty": "HENDERSONVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 287929105,
    "dropphyadd": "90 LAKEWOOD RD",
    "dropphycty": "HENDERSONVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 287929105,
    "dropmaladd": "90 LAKEWOOD RD",
    "dropmalcty": "HENDERSONVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 287929105,
    "dropsitphn": 7043934581,
    "dropsitlph": 8286925253,
    "dropsitcph": 8286925253,
    "dropfax": 8286929795
  },
  {
    "dcode": "D",
    "dropkey": 4000175,
    "droptype": "D",
    "dropname": "KISSIMMEE CARRIER ANNEX",
    "dropdeladd": "3050 POLYNESIAN ISLE BLVD",
    "dropdelcty": "KISSIMMEE",
    "dropdelst": "FL",
    "dropdelzpp": 347469998,
    "dropphyadd": "3050 POLYNESIAN ISLE BLVD",
    "dropphycty": "KISSIMMEE",
    "dropphyst": "FL",
    "dropphyzpp": 347469998,
    "dropmaladd": "3050 POLYNESIAN ISLE BLVD",
    "dropmalcty": "KISSIMMEE",
    "dropmalst": "FL",
    "dropmalzpp": 347469998,
    "dropsitphn": 4073967001,
    "dropsitlph": 4073967004,
    "dropsitcph": 4073967001,
    "dropfax": 4073967005
  },
  {
    "dcode": "D",
    "dropkey": 4000177,
    "droptype": "D",
    "dropname": "VADNAIS HGTS CARRIER ANNEX",
    "dropdeladd": "4390 MCMENEMY ST",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551276004,
    "dropphyadd": "4390 MCMENEMY ST",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551276004,
    "dropmaladd": "4390 MCMENEMY ST",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551276004,
    "dropsitphn": 6123496399,
    "dropsitlph": 6514844278,
    "dropsitcph": 6514811951,
    "dropfax": 6514849309
  },
  {
    "dcode": "D",
    "dropkey": 4000191,
    "droptype": "D",
    "dropname": "SCARSDALE CARRIER ANNEX",
    "dropdeladd": "441 CENTRAL PARK AVE",
    "dropdelcty": "SCARSDALE",
    "dropdelst": "NY",
    "dropdelzpp": 105839996,
    "dropphyadd": "441 CENTRAL PARK AVE",
    "dropphycty": "SCARSDALE",
    "dropphyst": "NY",
    "dropphyzpp": 105839996,
    "dropmaladd": "441 CENTRAL PARK AVE",
    "dropmalcty": "SCARSDALE",
    "dropmalst": "NY",
    "dropmalzpp": 105839996,
    "dropsitphn": 9146974123,
    "dropsitlph": 9144726847,
    "dropsitcph": 9144726847,
    "dropfax": 9147234250
  },
  {
    "dcode": "D",
    "dropkey": 4000194,
    "droptype": "D",
    "dropname": "LITITZ CARRIER ANNEX",
    "dropdeladd": "5 WYNFIELD DR",
    "dropdelcty": "LITITZ",
    "dropdelst": "PA",
    "dropdelzpp": 175439997,
    "dropphyadd": "5 WYNFIELD DR",
    "dropphycty": "LITITZ",
    "dropphyst": "PA",
    "dropphyzpp": 175439997,
    "dropmaladd": "5 WYNFIELD DR",
    "dropmalcty": "LITITZ",
    "dropmalst": "PA",
    "dropmalzpp": 175439997,
    "dropsitphn": 7173968782,
    "dropsitlph": 7176262329,
    "dropsitcph": 7176262329,
    "dropfax": 7176264102
  },
  {
    "dcode": "D",
    "dropkey": 4000224,
    "droptype": "D",
    "dropname": "CAMAS DCU",
    "dropdeladd": "2455 SE 8TH AVE",
    "dropdelcty": "CAMAS",
    "dropdelst": "WA",
    "dropdelzpp": 986072298,
    "dropphyadd": "2455 SE 8TH AVE",
    "dropphycty": "CAMAS",
    "dropphyst": "WA",
    "dropphyzpp": 986072298,
    "dropmaladd": "2455 SE 8TH AVE",
    "dropmalcty": "CAMAS",
    "dropmalst": "WA",
    "dropmalzpp": 986072298,
    "dropsitphn": 9712013788,
    "dropsitlph": 3608338536,
    "dropsitcph": 3608338096,
    "dropfax": 3608330575
  },
  {
    "dcode": "D",
    "dropkey": 4000261,
    "droptype": "D",
    "dropname": "CASA GRANDE ANNEX",
    "dropdeladd": "1601 CORPORATE CIR",
    "dropdelcty": "PETALUMA",
    "dropdelst": "CA",
    "dropdelzpp": 949549991,
    "dropphyadd": "1601 CORPORATE CIR",
    "dropphycty": "PETALUMA",
    "dropphyst": "CA",
    "dropphyzpp": 949549991,
    "dropmaladd": "1601 CORPORATE CIR",
    "dropmalcty": "PETALUMA",
    "dropmalst": "CA",
    "dropmalzpp": 949549991,
    "dropsitphn": 7077785312,
    "dropsitlph": 7077695357,
    "dropsitcph": 7077695360,
    "dropfax": 7077637465
  },
  {
    "dcode": "D",
    "dropkey": 4000351,
    "droptype": "D",
    "dropname": "SPRINGFIELD DCU",
    "dropdeladd": "4949 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 974786073,
    "dropphyadd": "4949 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 974786073,
    "dropmaladd": "4949 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 974786073,
    "dropsitphn": 9712013788,
    "dropsitlph": 5417265096,
    "dropsitcph": 5417265095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000359,
    "droptype": "D",
    "dropname": "SOUTH SHORE ANNEX",
    "dropdeladd": "3031 VETERANS RD W",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103099997,
    "dropphyadd": "3031 VETERANS RD W",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103099997,
    "dropmaladd": "3031 VETERANS RD W",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103099997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3476209130,
    "dropfax": 7183178403
  },
  {
    "dcode": "D",
    "dropkey": 4000369,
    "droptype": "D",
    "dropname": "ROCHESTER HLS CARRIER ANNEX",
    "dropdeladd": "1936 ROCHESTER INDUSTRIAL LN",
    "dropdelcty": "ROCHESTER HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483099998,
    "dropphyadd": "1936 ROCHESTER INDUSTRIAL LN",
    "dropphycty": "ROCHESTER HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483099998,
    "dropmaladd": "1936 ROCHESTER INDUSTRIAL LN",
    "dropmalcty": "ROCHESTER HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483099998,
    "dropsitphn": 2486010691,
    "dropsitlph": 2487585622,
    "dropsitcph": 2486010691,
    "dropfax": 2486010855
  },
  {
    "dcode": "D",
    "dropkey": 4000375,
    "droptype": "D",
    "dropname": "COVINGTON CARRIER ANNEX",
    "dropdeladd": "10721 COVINGTON BY PASS RD",
    "dropdelcty": "COVINGTON",
    "dropdelst": "GA",
    "dropdelzpp": 300149997,
    "dropphyadd": "10721 COVINGTON BY PASS RD",
    "dropphycty": "COVINGTON",
    "dropphyst": "GA",
    "dropphyzpp": 300149997,
    "dropmaladd": "10721 COVINGTON BY PASS RD",
    "dropmalcty": "COVINGTON",
    "dropmalst": "GA",
    "dropmalzpp": 300149997,
    "dropsitphn": 4047657578,
    "dropsitlph": 6783429138,
    "dropsitcph": 6783426742,
    "dropfax": 6783429349
  },
  {
    "dcode": "D",
    "dropkey": 4000418,
    "droptype": "D",
    "dropname": "ELK GROVE LAGUNA CARRIER ANX",
    "dropdeladd": "8215 LONGLEAF DR",
    "dropdelcty": "ELK GROVE",
    "dropdelst": "CA",
    "dropdelzpp": 957589998,
    "dropphyadd": "8215 LONGLEAF DR",
    "dropphycty": "ELK GROVE",
    "dropphyst": "CA",
    "dropphyzpp": 957589998,
    "dropmaladd": "8215 LONGLEAF DR",
    "dropmalcty": "ELK GROVE",
    "dropmalst": "CA",
    "dropmalzpp": 957589998,
    "dropsitphn": 9166856400,
    "dropsitlph": 9166916605,
    "dropsitcph": 9166916605,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000494,
    "droptype": "D",
    "dropname": "SELLWOOD DCU",
    "dropdeladd": "8816 SE 17TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972027333,
    "dropphyadd": "8816 SE 17TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972027333,
    "dropmaladd": "8816 SE 17TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972029998,
    "dropsitphn": 9712013788,
    "dropsitlph": 5032343104,
    "dropsitcph": 5032329566,
    "dropfax": 5032319630
  },
  {
    "dcode": "D",
    "dropkey": 4000496,
    "droptype": "D",
    "dropname": "ENUMCLAW CARRIER ANNEX",
    "dropdeladd": "1005 WASHINGTON AVE",
    "dropdelcty": "ENUMCLAW",
    "dropdelst": "WA",
    "dropdelzpp": 980229997,
    "dropphyadd": "1005 WASHINGTON AVE",
    "dropphycty": "ENUMCLAW",
    "dropphyst": "WA",
    "dropphyzpp": 980229997,
    "dropmaladd": "1005 WASHINGTON AVE",
    "dropmalcty": "ENUMCLAW",
    "dropmalst": "WA",
    "dropmalzpp": 980229997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3608029354,
    "dropsitcph": 3608029309,
    "dropfax": 6513066525
  },
  {
    "dcode": "D",
    "dropkey": 4000536,
    "droptype": "D",
    "dropname": "GORE STREET CARRIER ANNEX",
    "dropdeladd": "1325 W GORE ST",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328059998,
    "dropphyadd": "1325 W GORE ST",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328059998,
    "dropmaladd": "1325 W GORE ST",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328059998,
    "dropsitphn": 4078351592,
    "dropsitlph": 4076500686,
    "dropsitcph": 4076499591,
    "dropfax": 4078359501
  },
  {
    "dcode": "D",
    "dropkey": 4000609,
    "droptype": "D",
    "dropname": "LAFAYETTE CARRIER ANNEX",
    "dropdeladd": "3426 MT DIABLO BLVD",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "CA",
    "dropdelzpp": 945493980,
    "dropphyadd": "3426 MT DIABLO BLVD",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "CA",
    "dropphyzpp": 945493980,
    "dropmaladd": "3426 MT DIABLO BLVD",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "CA",
    "dropmalzpp": 945499993,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259621968,
    "dropsitcph": 9259626955,
    "dropfax": 9259621970
  },
  {
    "dcode": "D",
    "dropkey": 4000732,
    "droptype": "D",
    "dropname": "BARRY WOODS ANNEX",
    "dropdeladd": "8320 N PLATTE PURCHASE DR",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641181006,
    "dropphyadd": "8320 N PLATTE PURCHASE DR",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641181006,
    "dropmaladd": "8320 N PLATTE PURCHASE DR",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641181006,
    "dropsitphn": 8165043362,
    "dropsitlph": 8168918397,
    "dropsitcph": 8164688419,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000742,
    "droptype": "D",
    "dropname": "BUFORD CARRIER ANNEX",
    "dropdeladd": "2766 HAMILTON MILL RD",
    "dropdelcty": "BUFORD",
    "dropdelst": "GA",
    "dropdelzpp": 305199998,
    "dropphyadd": "2766 HAMILTON MILL RD",
    "dropphycty": "BUFORD",
    "dropphyst": "GA",
    "dropphyzpp": 305199998,
    "dropmaladd": "2766 HAMILTON MILL RD",
    "dropmalcty": "BUFORD",
    "dropmalst": "GA",
    "dropmalzpp": 305199998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708316472,
    "dropsitcph": 7708316472,
    "dropfax": 6787147078
  },
  {
    "dcode": "D",
    "dropkey": 4000874,
    "droptype": "D",
    "dropname": "WALTHAM CARRIER ANNEX",
    "dropdeladd": "200 SMITH ST STE 101",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024510006",
    "dropphyadd": "200 SMITH ST STE 101",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024510006",
    "dropmaladd": "200 SMITH ST STE 101",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024510006",
    "dropsitphn": 7817684003,
    "dropsitlph": 7817684003,
    "dropsitcph": 7817684003,
    "dropfax": 7818915658
  },
  {
    "dcode": "D",
    "dropkey": 4000880,
    "droptype": "D",
    "dropname": "CAMDEN CARRIER ANNEX",
    "dropdeladd": "2700 MOUNT EPHRAIM AVE",
    "dropdelcty": "CAMDEN",
    "dropdelst": "NJ",
    "dropdelzpp": "081049998",
    "dropphyadd": "2700 MOUNT EPHRAIM AVE",
    "dropphycty": "CAMDEN",
    "dropphyst": "NJ",
    "dropphyzpp": "081049998",
    "dropmaladd": "2700 MOUNT EPHRAIM AVE",
    "dropmalcty": "CAMDEN",
    "dropmalst": "NJ",
    "dropmalzpp": "081049998",
    "dropsitphn": 8569334046,
    "dropsitlph": 8569636597,
    "dropsitcph": 8569636597,
    "dropfax": 8569639041
  },
  {
    "dcode": "D",
    "dropkey": 4000885,
    "droptype": "D",
    "dropname": "MOORESTOWN CARRIER ANNEX",
    "dropdeladd": "200 WALT WHITMAN AVE",
    "dropdelcty": "MOUNT LAUREL",
    "dropdelst": "NJ",
    "dropdelzpp": "080549987",
    "dropphyadd": "200 WALT WHITMAN AVE",
    "dropphycty": "MOUNT LAUREL",
    "dropphyst": "NJ",
    "dropphyzpp": "080549987",
    "dropmaladd": "200 WALT WHITMAN AVE",
    "dropmalcty": "MOUNT LAUREL",
    "dropmalst": "NJ",
    "dropmalzpp": "080549987",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566380371,
    "dropsitcph": 8566380371,
    "dropfax": 8567871609
  },
  {
    "dcode": "D",
    "dropkey": 4000889,
    "droptype": "D",
    "dropname": "PLEASANTVILLE CARRIER ANNEX",
    "dropdeladd": "5 COLUMBUS AVE",
    "dropdelcty": "EGG HARBOR TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "082349997",
    "dropphyadd": "5 COLUMBUS AVE",
    "dropphycty": "EGG HARBOR TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "082349997",
    "dropmaladd": "5 COLUMBUS AVE",
    "dropmalcty": "EGG HARBOR TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "082349997",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096462191,
    "dropsitcph": 6096462191,
    "dropfax": 6096467465
  },
  {
    "dcode": "D",
    "dropkey": 4000890,
    "droptype": "D",
    "dropname": "VINELAND CARRIER ANNEX",
    "dropdeladd": "1539 ALMOND RD",
    "dropdelcty": "VINELAND",
    "dropdelst": "NJ",
    "dropdelzpp": "083609996",
    "dropphyadd": "1539 ALMOND RD",
    "dropphycty": "VINELAND",
    "dropphyst": "NJ",
    "dropphyzpp": "083609996",
    "dropmaladd": "1539 ALMOND RD",
    "dropmalcty": "VINELAND",
    "dropmalst": "NJ",
    "dropmalzpp": "083609996",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565070032,
    "dropsitcph": 8565070032,
    "dropfax": 8566911701
  },
  {
    "dcode": "D",
    "dropkey": 4000905,
    "droptype": "D",
    "dropname": "CARLSBAD",
    "dropdeladd": "3200 SAN JOSE BLVD",
    "dropdelcty": "CARLSBAD",
    "dropdelst": "NM",
    "dropdelzpp": 882209997,
    "dropphyadd": "3200 SAN JOSE BLVD",
    "dropphycty": "CARLSBAD",
    "dropphyst": "NM",
    "dropphyzpp": 882209997,
    "dropmaladd": "3200 SAN JOSE BLVD",
    "dropmalcty": "CARLSBAD",
    "dropmalst": "NM",
    "dropmalzpp": 882209997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5053468252,
    "dropsitcph": 5756280793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000920,
    "droptype": "D",
    "dropname": "WESTLAKE CARRIER ANNEX",
    "dropdeladd": "10421 MOTOR CITY DR",
    "dropdelcty": "BETHESDA",
    "dropdelst": "MD",
    "dropdelzpp": 208179998,
    "dropphyadd": "10421 MOTOR CITY DR",
    "dropphycty": "BETHESDA",
    "dropphyst": "MD",
    "dropphyzpp": 208179998,
    "dropmaladd": "10421 MOTOR CITY DR",
    "dropmalcty": "BETHESDA",
    "dropmalst": "MD",
    "dropmalzpp": 208179998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017671742,
    "dropsitcph": 3017671742,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000957,
    "droptype": "D",
    "dropname": "PRESCOTT VALLEY ANNEX",
    "dropdeladd": "6545 E 2ND ST",
    "dropdelcty": "PRESCOTT VALLEY",
    "dropdelst": "AZ",
    "dropdelzpp": 863149997,
    "dropphyadd": "6545 E 2ND ST",
    "dropphycty": "PRESCOTT VALLEY",
    "dropphyst": "AZ",
    "dropphyzpp": 863149997,
    "dropmaladd": "6545 E 2ND ST",
    "dropmalcty": "PRESCOTT VALLEY",
    "dropmalst": "AZ",
    "dropmalzpp": 863149997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287722690,
    "dropsitcph": 9287724406,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4000978,
    "droptype": "D",
    "dropname": "PEWAUKEE CARRIER ANNEX",
    "dropdeladd": "170 SIMMONS AVE",
    "dropdelcty": "PEWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 530729997,
    "dropphyadd": "170 SIMMONS AVE",
    "dropphycty": "PEWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 530729997,
    "dropmaladd": "170 SIMMONS AVE",
    "dropmalcty": "PEWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 530729997,
    "dropsitphn": 4142702120,
    "dropsitlph": 2626913289,
    "dropsitcph": 2626913253,
    "dropfax": 2626910125
  },
  {
    "dcode": "D",
    "dropkey": 4000987,
    "droptype": "D",
    "dropname": "MOUNTAIN VIEW CARRIERS ANNEX",
    "dropdeladd": "1070 LA AVENIDA ST",
    "dropdelcty": "MOUNTAIN VIEW",
    "dropdelst": "CA",
    "dropdelzpp": 940439992,
    "dropphyadd": "1070 LA AVENIDA ST",
    "dropphycty": "MOUNTAIN VIEW",
    "dropphyst": "CA",
    "dropphyzpp": 940439992,
    "dropmaladd": "1070 LA AVENIDA ST",
    "dropmalcty": "MOUNTAIN VIEW",
    "dropmalst": "CA",
    "dropmalzpp": 940439992,
    "dropsitphn": 4155505045,
    "dropsitlph": 6509601433,
    "dropsitcph": 6509606851,
    "dropfax": 6509601960
  },
  {
    "dcode": "D",
    "dropkey": 4001023,
    "droptype": "D",
    "dropname": "CONSHOHOCKEN CARRIER ANNEX",
    "dropdeladd": "101 INDUSTRIAL WAY",
    "dropdelcty": "CONSHOHOCKEN",
    "dropdelst": "PA",
    "dropdelzpp": 194281052,
    "dropphyadd": "101 INDUSTRIAL WAY",
    "dropphycty": "CONSHOHOCKEN",
    "dropphyst": "PA",
    "dropphyzpp": 194281052,
    "dropmaladd": "101 INDUSTRIAL WAY",
    "dropmalcty": "CONSHOHOCKEN",
    "dropmalst": "PA",
    "dropmalzpp": 194281052,
    "dropsitphn": 6109646414,
    "dropsitlph": 6102396424,
    "dropsitcph": 6102396424,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001042,
    "droptype": "D",
    "dropname": "FIELDS CORNER CARRIER ANNEX",
    "dropdeladd": "18 CLAYTON ST",
    "dropdelcty": "DORCHESTER",
    "dropdelst": "MA",
    "dropdelzpp": "021229997",
    "dropphyadd": "18 CLAYTON ST",
    "dropphycty": "DORCHESTER",
    "dropphyst": "MA",
    "dropphyzpp": "021229997",
    "dropmaladd": "18 CLAYTON ST",
    "dropmalcty": "DORCHESTER",
    "dropmalst": "MA",
    "dropmalzpp": "021229997",
    "dropsitphn": 6174362134,
    "dropsitlph": 6174362134,
    "dropsitcph": 6174362134,
    "dropfax": 6174361487
  },
  {
    "dcode": "D",
    "dropkey": 4001043,
    "droptype": "D",
    "dropname": "NORTH QUINCY CARRIER ANNEX",
    "dropdeladd": "617 HANCOCK ST",
    "dropdelcty": "QUINCY",
    "dropdelst": "MA",
    "dropdelzpp": "021709997",
    "dropphyadd": "617 HANCOCK ST",
    "dropphycty": "QUINCY",
    "dropphyst": "MA",
    "dropphyzpp": "021709997",
    "dropmaladd": "617 HANCOCK ST",
    "dropmalcty": "QUINCY",
    "dropmalst": "MA",
    "dropmalzpp": "021709997",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174792374,
    "dropfax": 6174727875
  },
  {
    "dcode": "D",
    "dropkey": 4001154,
    "droptype": "D",
    "dropname": "NAPER WEST",
    "dropdeladd": "3900 GABRIELLE LN",
    "dropdelcty": "FOX VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 605999706,
    "dropphyadd": "3900 GABRIELLE LN",
    "dropphycty": "FOX VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 605999706,
    "dropmaladd": "1750 W OGDEN AVE",
    "dropmalcty": "NAPERVILLE",
    "dropmalst": "IL",
    "dropmalzpp": 605409998,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 6308989270,
    "dropfax": 6308989251
  },
  {
    "dcode": "D",
    "dropkey": 4001158,
    "droptype": "D",
    "dropname": "MAHWAH CARRIER ANNEX",
    "dropdeladd": "46 INDUSTRIAL AVE STE 1",
    "dropdelcty": "MAHWAH",
    "dropdelst": "NJ",
    "dropdelzpp": "074309991",
    "dropphyadd": "46 INDUSTRIAL AVE STE 1",
    "dropphycty": "MAHWAH",
    "dropphyst": "NJ",
    "dropphyzpp": "074309991",
    "dropmaladd": "46 INDUSTRIAL AVE STE 1",
    "dropmalcty": "MAHWAH",
    "dropmalst": "NJ",
    "dropmalzpp": "074309991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2017600892,
    "dropsitcph": 2017600892,
    "dropfax": 6505774090
  },
  {
    "dcode": "D",
    "dropkey": 4001186,
    "droptype": "D",
    "dropname": "STOUGHTON CARRIER ANNEX",
    "dropdeladd": "541 BUSINESS PARK CIR",
    "dropdelcty": "STOUGHTON",
    "dropdelst": "WI",
    "dropdelzpp": 535895300,
    "dropphyadd": "541 BUSINESS PARK CIR",
    "dropphycty": "STOUGHTON",
    "dropphyst": "WI",
    "dropphyzpp": 535895300,
    "dropmaladd": "541 BUSINESS PARK CIR",
    "dropmalcty": "STOUGHTON",
    "dropmalst": "WI",
    "dropmalzpp": 535895300,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 6088778678,
    "dropfax": 6088778682
  },
  {
    "dcode": "D",
    "dropkey": 4001189,
    "droptype": "D",
    "dropname": "TOWNE LAKE STATION",
    "dropdeladd": "3101 PARKBROOKE CIR",
    "dropdelcty": "WOODSTOCK",
    "dropdelst": "GA",
    "dropdelzpp": 301899998,
    "dropphyadd": "3101 PARKBROOKE CIR",
    "dropphycty": "WOODSTOCK",
    "dropphyst": "GA",
    "dropphyzpp": 301899998,
    "dropmaladd": "3101 PARKBROOKE CIR",
    "dropmalcty": "WOODSTOCK",
    "dropmalst": "GA",
    "dropmalzpp": 301899998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6784944410,
    "dropsitcph": 6784944855,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001205,
    "droptype": "D",
    "dropname": "KENNESAW CARRIER ANNEX",
    "dropdeladd": "6950 COBB INTERNATIONAL BLVD NW",
    "dropdelcty": "KENNESAW",
    "dropdelst": "GA",
    "dropdelzpp": 301529998,
    "dropphyadd": "6950 COBB INTERNATIONAL BLVD NW",
    "dropphycty": "KENNESAW",
    "dropphyst": "GA",
    "dropphyzpp": 301529998,
    "dropmaladd": "6950 COBB INTERNATIONAL BLVD NW",
    "dropmalcty": "KENNESAW",
    "dropmalst": "GA",
    "dropmalzpp": 301529998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782901290,
    "dropsitcph": 7705286432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001210,
    "droptype": "D",
    "dropname": "PLYMOUTH ANNEX",
    "dropdeladd": "74 CAMELOT DR STE 21",
    "dropdelcty": "PLYMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "023603032",
    "dropphyadd": "74 CAMELOT DR STE 21",
    "dropphycty": "PLYMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "023603032",
    "dropmaladd": "74 CAMELOT DR STE 21",
    "dropmalcty": "PLYMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "023603032",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5088300614,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001225,
    "droptype": "D",
    "dropname": "MILLEDGEVILLE CARRIER ANNEX",
    "dropdeladd": "170 GARRETT WAY NW",
    "dropdelcty": "MILLEDGEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 310612692,
    "dropphyadd": "170 GARRETT WAY NW",
    "dropphycty": "MILLEDGEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 310612692,
    "dropmaladd": "170 GARRETT WAY NW",
    "dropmalcty": "MILLEDGEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 310612692,
    "dropsitphn": 4787528466,
    "dropsitlph": 4784524316,
    "dropsitcph": 4784524315,
    "dropfax": 4784524318
  },
  {
    "dcode": "D",
    "dropkey": 4001226,
    "droptype": "D",
    "dropname": "CORDELE CARRIER ANNEX",
    "dropdeladd": "302 N 6TH ST",
    "dropdelcty": "CORDELE",
    "dropdelst": "GA",
    "dropdelzpp": 310154376,
    "dropphyadd": "302 N 6TH ST",
    "dropphycty": "CORDELE",
    "dropphyst": "GA",
    "dropphyzpp": 310154376,
    "dropmaladd": "302 N 6TH ST",
    "dropmalcty": "CORDELE",
    "dropmalst": "GA",
    "dropmalzpp": 310154376,
    "dropsitphn": 4787528466,
    "dropsitlph": 2292732332,
    "dropsitcph": 2292732332,
    "dropfax": 2292730349
  },
  {
    "dcode": "D",
    "dropkey": 4001244,
    "droptype": "D",
    "dropname": "NEW HYDE PARK CARRIER ANNEX",
    "dropdeladd": "44 MILLERS LN",
    "dropdelcty": "NEW HYDE PARK",
    "dropdelst": "NY",
    "dropdelzpp": 110409997,
    "dropphyadd": "44 MILLERS LN",
    "dropphycty": "NEW HYDE PARK",
    "dropphyst": "NY",
    "dropphyzpp": 110409997,
    "dropmaladd": "44 MILLERS LN",
    "dropmalcty": "NEW HYDE PARK",
    "dropmalst": "NY",
    "dropmalzpp": 110409997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215070,
    "dropsitcph": 5163543536,
    "dropfax": 5163270863
  },
  {
    "dcode": "D",
    "dropkey": 4001255,
    "droptype": "D",
    "dropname": "BALLARD CARRIER ANNEX",
    "dropdeladd": "4501 9TH AVE NW",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981079997,
    "dropphyadd": "4501 9TH AVE NW",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981079997,
    "dropmaladd": "4501 9TH AVE NW",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981079997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067810148,
    "dropsitcph": 2067814656,
    "dropfax": 6514566580
  },
  {
    "dcode": "D",
    "dropkey": 4001295,
    "droptype": "D",
    "dropname": "REVERE CARRIER ANNEX",
    "dropdeladd": "140 WARD ST",
    "dropdelcty": "REVERE",
    "dropdelst": "MA",
    "dropdelzpp": "021519990",
    "dropphyadd": "140 WARD ST",
    "dropphycty": "REVERE",
    "dropphyst": "MA",
    "dropphyzpp": "021519990",
    "dropmaladd": "140 WARD ST",
    "dropmalcty": "REVERE",
    "dropmalst": "MA",
    "dropmalzpp": "021519990",
    "dropsitphn": 7812846747,
    "dropsitlph": 6176545111,
    "dropsitcph": 7812842187,
    "dropfax": 7812846764
  },
  {
    "dcode": "D",
    "dropkey": 4001310,
    "droptype": "D",
    "dropname": "NORTHFIELD CARRIER ANNEX",
    "dropdeladd": "2101 CANNON RD",
    "dropdelcty": "NORTHFIELD",
    "dropdelst": "MN",
    "dropdelzpp": 550573608,
    "dropphyadd": "2101 CANNON RD",
    "dropphycty": "NORTHFIELD",
    "dropphyst": "MN",
    "dropphyzpp": 550573608,
    "dropmaladd": "2101 CANNON RD",
    "dropmalcty": "NORTHFIELD",
    "dropmalst": "MN",
    "dropmalzpp": 550573608,
    "dropsitphn": 6123496399,
    "dropsitlph": 6512933064,
    "dropsitcph": 5076458127,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001331,
    "droptype": "D",
    "dropname": "WESTSIDE CARRIER ANNEX",
    "dropdeladd": "2024 MACLAND CROSSING CIR SW",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300089998,
    "dropphyadd": "2024 MACLAND CROSSING CIR SW",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300089998,
    "dropmaladd": "2024 MACLAND CROSSING CIR SW",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300089998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6782909159,
    "dropsitcph": 6782901990,
    "dropfax": 6782908404
  },
  {
    "dcode": "D",
    "dropkey": 4001368,
    "droptype": "D",
    "dropname": "ACREDALE ANNEX",
    "dropdeladd": "1700 CENTERVILLE TPKE",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234649997,
    "dropphyadd": "1700 CENTERVILLE TPKE",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234649997,
    "dropmaladd": "1700 CENTERVILLE TPKE",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234649997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7574792468,
    "dropsitcph": 7574798746,
    "dropfax": 7574246438
  },
  {
    "dcode": "D",
    "dropkey": 4001375,
    "droptype": "D",
    "dropname": "LARAMIE ANNEX",
    "dropdeladd": "715 PLAZA LN",
    "dropdelcty": "LARAMIE",
    "dropdelst": "WY",
    "dropdelzpp": 820709996,
    "dropphyadd": "715 PLAZA LN",
    "dropphycty": "LARAMIE",
    "dropphyst": "WY",
    "dropphyzpp": 820709996,
    "dropmaladd": "715 PLAZA LN",
    "dropmalcty": "LARAMIE",
    "dropmalst": "WY",
    "dropmalzpp": 820709996,
    "dropsitphn": 3077726524,
    "dropsitlph": 3077555350,
    "dropsitcph": 3077555350,
    "dropfax": 3077555347
  },
  {
    "dcode": "D",
    "dropkey": 4001385,
    "droptype": "D",
    "dropname": "CHICAGO CENT CARRIER ANNEX",
    "dropdeladd": "433 W HARRISON ST FL 3W",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606999901,
    "dropphyadd": "433 W HARRISON ST FL 3W",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999901,
    "dropmaladd": "433 W HARRISON ST FL 3W",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999901,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3126926120,
    "dropfax": 3126926119
  },
  {
    "dcode": "D",
    "dropkey": 4001407,
    "droptype": "D",
    "dropname": "MONTROSE ANNEX",
    "dropdeladd": "3025 WOODGATE RD",
    "dropdelcty": "MONTROSE",
    "dropdelst": "CO",
    "dropdelzpp": 814019994,
    "dropphyadd": "3025 WOODGATE RD",
    "dropphycty": "MONTROSE",
    "dropphyst": "CO",
    "dropphyzpp": 814019994,
    "dropmaladd": "3025 WOODGATE RD",
    "dropmalcty": "MONTROSE",
    "dropmalst": "CO",
    "dropmalzpp": 814019994,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702496654,
    "dropsitcph": 9702527246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001416,
    "droptype": "D",
    "dropname": "ROCKFORD CARRIER ANNEX",
    "dropdeladd": "241 ROCKFORD PARK DR NE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "MI",
    "dropdelzpp": 493418277,
    "dropphyadd": "241 ROCKFORD PARK DR NE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "MI",
    "dropphyzpp": 493418277,
    "dropmaladd": "241 ROCKFORD PARK DR NE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "MI",
    "dropmalzpp": 493418277,
    "dropsitphn": 6169771064,
    "dropsitlph": 6168660789,
    "dropsitcph": 6168660789,
    "dropfax": 6168661696
  },
  {
    "dcode": "D",
    "dropkey": 4001434,
    "droptype": "D",
    "dropname": "TRACY CARRIER ANNEX",
    "dropdeladd": "4025 COMMERCIAL DR STE B",
    "dropdelcty": "TRACY",
    "dropdelst": "CA",
    "dropdelzpp": 953049997,
    "dropphyadd": "4025 COMMERCIAL DR STE B",
    "dropphycty": "TRACY",
    "dropphyst": "CA",
    "dropphyzpp": 953049997,
    "dropmaladd": "4025 COMMERCIAL DR STE B",
    "dropmalcty": "TRACY",
    "dropmalst": "CA",
    "dropmalzpp": 953049997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2098340953,
    "dropsitcph": 2098340953,
    "dropfax": 2098340430
  },
  {
    "dcode": "D",
    "dropkey": 4001450,
    "droptype": "D",
    "dropname": "LEBANON CARRIER ANNEX",
    "dropdeladd": "701 E COPELAND ST",
    "dropdelcty": "LEBANON",
    "dropdelst": "MO",
    "dropdelzpp": 655367706,
    "dropphyadd": "701 E COPELAND ST",
    "dropphycty": "LEBANON",
    "dropphyst": "MO",
    "dropphyzpp": 655367706,
    "dropmaladd": "121 E COMMERCIAL ST",
    "dropmalcty": "LEBANON",
    "dropmalst": "MO",
    "dropmalzpp": 655369998,
    "dropsitphn": 8165043362,
    "dropsitlph": 4175322222,
    "dropsitcph": 4175322222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001469,
    "droptype": "D",
    "dropname": "LEMONT ANNEX",
    "dropdeladd": "15871 W 127TH ST",
    "dropdelcty": "LEMONT",
    "dropdelst": "IL",
    "dropdelzpp": 604399806,
    "dropphyadd": "15871 W 127TH ST",
    "dropphycty": "LEMONT",
    "dropphyst": "IL",
    "dropphyzpp": 604399806,
    "dropmaladd": "15871 W 127TH ST",
    "dropmalcty": "LEMONT",
    "dropmalst": "IL",
    "dropmalzpp": 604399806,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085637315,
    "dropsitcph": 6302431978,
    "dropfax": 6302436566
  },
  {
    "dcode": "D",
    "dropkey": 4001495,
    "droptype": "D",
    "dropname": "MOUNT LAUREL CARRIER ANNEX",
    "dropdeladd": "4000 IRWIN RD",
    "dropdelcty": "MOUNT LAUREL",
    "dropdelst": "NJ",
    "dropdelzpp": "080549985",
    "dropphyadd": "4000 IRWIN RD",
    "dropphycty": "MOUNT LAUREL",
    "dropphyst": "NJ",
    "dropphyzpp": "080549985",
    "dropmaladd": "4000 IRWIN RD",
    "dropmalcty": "MOUNT LAUREL",
    "dropmalst": "NJ",
    "dropmalzpp": "080549985",
    "dropsitphn": 8569334046,
    "dropsitlph": 8566080938,
    "dropsitcph": 8566080938,
    "dropfax": 8567871492
  },
  {
    "dcode": "D",
    "dropkey": 4001504,
    "droptype": "D",
    "dropname": "FRIDLEY CARRIER ANNEX",
    "dropdeladd": "385 NORTHCO DR",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554323304,
    "dropphyadd": "385 NORTHCO DR",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554323304,
    "dropmaladd": "385 NORTHCO DR",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554323304,
    "dropsitphn": 6123496399,
    "dropsitlph": 7635712016,
    "dropsitcph": 7635712016,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001546,
    "droptype": "D",
    "dropname": "PALM RIVER CARRIER ANNEX",
    "dropdeladd": "9860 CURRIE DAVIS DR",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336199998,
    "dropphyadd": "9860 CURRIE DAVIS DR",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336199998,
    "dropmaladd": "9860 CURRIE DAVIS DR",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336199998,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8136630056,
    "dropfax": 8136630058
  },
  {
    "dcode": "D",
    "dropkey": 4001571,
    "droptype": "D",
    "dropname": "ZEELAND CARRIER ANNEX",
    "dropdeladd": "20 N CHURCH ST",
    "dropdelcty": "ZEELAND",
    "dropdelst": "MI",
    "dropdelzpp": 494641220,
    "dropphyadd": "20 N CHURCH ST",
    "dropphycty": "ZEELAND",
    "dropphyst": "MI",
    "dropphyzpp": 494641220,
    "dropmaladd": "20 N CHURCH ST",
    "dropmalcty": "ZEELAND",
    "dropmalst": "MI",
    "dropmalzpp": 494641220,
    "dropsitphn": 6169771064,
    "dropsitlph": 6167722971,
    "dropsitcph": 6167722971,
    "dropfax": 6167763280
  },
  {
    "dcode": "D",
    "dropkey": 4001587,
    "droptype": "D",
    "dropname": "TAKOMA PARK CARRIER ANNEX",
    "dropdeladd": "110 UNIVERSITY BLVD W",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209019997,
    "dropphyadd": "110 UNIVERSITY BLVD W",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209019997,
    "dropmaladd": "110 UNIVERSITY BLVD W",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209019997,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3015936819,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001588,
    "droptype": "D",
    "dropname": "WALDORF CARRIER ANNEX",
    "dropdeladd": "110 PAUL MELLON CT",
    "dropdelcty": "WALDORF",
    "dropdelst": "MD",
    "dropdelzpp": 206029997,
    "dropphyadd": "110 PAUL MELLON CT",
    "dropphycty": "WALDORF",
    "dropphyst": "MD",
    "dropphyzpp": 206029997,
    "dropmaladd": "110 PAUL MELLON CT",
    "dropmalcty": "WALDORF",
    "dropmalst": "MD",
    "dropmalzpp": 206029997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017057003,
    "dropsitcph": 3017057003,
    "dropfax": 3017055426
  },
  {
    "dcode": "D",
    "dropkey": 4001633,
    "droptype": "D",
    "dropname": "MITCHELLVILLE CARRIER ANNEX",
    "dropdeladd": "6710 LAUREL BOWIE RD",
    "dropdelcty": "BOWIE",
    "dropdelst": "MD",
    "dropdelzpp": 207159998,
    "dropphyadd": "6710 LAUREL BOWIE RD",
    "dropphycty": "BOWIE",
    "dropphyst": "MD",
    "dropphyzpp": 207159998,
    "dropmaladd": "6710 LAUREL BOWIE RD",
    "dropmalcty": "BOWIE",
    "dropmalst": "MD",
    "dropmalzpp": 207159998,
    "dropsitphn": 3014997331,
    "dropsitlph": "",
    "dropsitcph": 3013902438,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001648,
    "droptype": "D",
    "dropname": "ELKHORN CARRIER ANNEX",
    "dropdeladd": "5410 STATIONERS WAY",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958429998,
    "dropphyadd": "5410 STATIONERS WAY",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958429998,
    "dropmaladd": "5410 STATIONERS WAY",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958429998,
    "dropsitphn": 9163738025,
    "dropsitlph": 9169931058,
    "dropsitcph": 9163320344,
    "dropfax": 9163321596
  },
  {
    "dcode": "D",
    "dropkey": 4001735,
    "droptype": "D",
    "dropname": "HILLCREST",
    "dropdeladd": "5710 AUBURN ST",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933062869,
    "dropphyadd": "5710 AUBURN ST",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933062869,
    "dropmaladd": "5710 AUBURN ST",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933062869,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618737193,
    "dropsitcph": 6618737193,
    "dropfax": 6618731813
  },
  {
    "dcode": "D",
    "dropkey": 4001736,
    "droptype": "D",
    "dropname": "RCU ANNEX",
    "dropdeladd": "340 W 42ND ST FL 3",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100369992,
    "dropphyadd": "340 W 42ND ST FL 3",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100369992,
    "dropmaladd": "340 W 42ND ST FL 3",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100369992,
    "dropsitphn": 2123302270,
    "dropsitlph": 2125020421,
    "dropsitcph": 2125020421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001737,
    "droptype": "D",
    "dropname": "PRINCE ANNEX",
    "dropdeladd": "350 CANAL ST STE 2B",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100139992,
    "dropphyadd": "350 CANAL ST STE 2B",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100139992,
    "dropmaladd": "350 CANAL ST STE 2B",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100139992,
    "dropsitphn": 2123302270,
    "dropsitlph": 2122267868,
    "dropsitcph": 2129669573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001739,
    "droptype": "D",
    "dropname": "MORNINGSIDE ANNEX",
    "dropdeladd": "365 W 125TH ST STE 2B",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100279868,
    "dropphyadd": "365 W 125TH ST STE 2B",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100279868,
    "dropmaladd": "365 W 125TH ST STE 2B",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100279868,
    "dropsitphn": 2123302270,
    "dropsitlph": 2126621540,
    "dropsitcph": 2126621540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001760,
    "droptype": "D",
    "dropname": "NORTH ST PAUL CARRIER ANNEX",
    "dropdeladd": "1686 GERVAIS AVE",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551092106,
    "dropphyadd": "1686 GERVAIS AVE",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551092106,
    "dropmaladd": "1686 GERVAIS AVE",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551099998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6517708388,
    "dropsitcph": 6517702919,
    "dropfax": 6517798756
  },
  {
    "dcode": "D",
    "dropkey": 4001782,
    "droptype": "D",
    "dropname": "NAZARETH CARRIER ANNEX",
    "dropdeladd": "859 NAZARETH PIKE UNIT A1",
    "dropdelcty": "NAZARETH",
    "dropdelst": "PA",
    "dropdelzpp": 180648000,
    "dropphyadd": "859 NAZARETH PIKE UNIT A1",
    "dropphycty": "NAZARETH",
    "dropphyst": "PA",
    "dropphyzpp": 180648000,
    "dropmaladd": "859 NAZARETH PIKE UNIT A1",
    "dropmalcty": "NAZARETH",
    "dropmalst": "PA",
    "dropmalzpp": 180648000,
    "dropsitphn": 6107593130,
    "dropsitlph": 6108823244,
    "dropsitcph": 6107593130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001799,
    "droptype": "D",
    "dropname": "ROCKVILLE CARRIER ANNEX",
    "dropdeladd": "2011 E JEFFERSON ST",
    "dropdelcty": "ROCKVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 208529997,
    "dropphyadd": "2011 E JEFFERSON ST",
    "dropphycty": "ROCKVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 208529997,
    "dropmaladd": "2011 E JEFFERSON ST",
    "dropmalcty": "ROCKVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 208529997,
    "dropsitphn": 3014997331,
    "dropsitlph": 3018818489,
    "dropsitcph": 3018818489,
    "dropfax": 3018818526
  },
  {
    "dcode": "D",
    "dropkey": 4001804,
    "droptype": "D",
    "dropname": "BRONX GPO ANNEX",
    "dropdeladd": "1313 INWOOD AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104529997,
    "dropphyadd": "1313 INWOOD AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104529997,
    "dropmaladd": "1313 INWOOD AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104529997,
    "dropsitphn": 2123302770,
    "dropsitlph": 7185883059,
    "dropsitcph": 7185883059,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001805,
    "droptype": "D",
    "dropname": "SOUTH SALEM ANNEX",
    "dropdeladd": "210 OAKRIDGE CMNS",
    "dropdelcty": "SOUTH SALEM",
    "dropdelst": "NY",
    "dropdelzpp": 105902437,
    "dropphyadd": "210 OAKRIDGE CMNS",
    "dropphycty": "SOUTH SALEM",
    "dropphyst": "NY",
    "dropphyzpp": 105902437,
    "dropmaladd": "210 OAKRIDGE CMNS",
    "dropmalcty": "SOUTH SALEM",
    "dropmalst": "NY",
    "dropmalzpp": 105902437,
    "dropsitphn": 9146974123,
    "dropsitlph": 9145336182,
    "dropsitcph": 9145336182,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001812,
    "droptype": "D",
    "dropname": "MEDINA CARRIER ANNEX",
    "dropdeladd": "1195 INDUSTRIAL PKWY",
    "dropdelcty": "MEDINA",
    "dropdelst": "OH",
    "dropdelzpp": 442569507,
    "dropphyadd": "1195 INDUSTRIAL PKWY",
    "dropphycty": "MEDINA",
    "dropphyst": "OH",
    "dropphyzpp": 442569507,
    "dropmaladd": "1195 INDUSTRIAL PKWY",
    "dropmalcty": "MEDINA",
    "dropmalst": "OH",
    "dropmalzpp": 442569507,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3307214896,
    "dropfax": 3307212937
  },
  {
    "dcode": "D",
    "dropkey": 4001838,
    "droptype": "D",
    "dropname": "PAOLA CARRIER ANNEX",
    "dropdeladd": "1680 INDUSTRIAL PARK DR",
    "dropdelcty": "PAOLA",
    "dropdelst": "KS",
    "dropdelzpp": 660719530,
    "dropphyadd": "1680 INDUSTRIAL PARK DR",
    "dropphycty": "PAOLA",
    "dropphyst": "KS",
    "dropphyzpp": 660719530,
    "dropmaladd": "1680 INDUSTRIAL PARK DR",
    "dropmalcty": "PAOLA",
    "dropmalst": "KS",
    "dropmalzpp": 660719530,
    "dropsitphn": 8165043362,
    "dropsitlph": 9135573116,
    "dropsitcph": 9135573116,
    "dropfax": 9132942206
  },
  {
    "dcode": "D",
    "dropkey": 4001841,
    "droptype": "D",
    "dropname": "CLEMENTON CARRIER ANNEX",
    "dropdeladd": "165 WHITE HORSE PIKE STE D",
    "dropdelcty": "CLEMENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "080219997",
    "dropphyadd": "165 WHITE HORSE PIKE STE D",
    "dropphycty": "CLEMENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "080219997",
    "dropmaladd": "165 WHITE HORSE PIKE STE D",
    "dropmalcty": "CLEMENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "080219997",
    "dropsitphn": 8569334046,
    "dropsitlph": 8567834868,
    "dropsitcph": 8567834868,
    "dropfax": 8567836053
  },
  {
    "dcode": "D",
    "dropkey": 4001848,
    "droptype": "D",
    "dropname": "WBD CARRIER ANNEX",
    "dropdeladd": "7140 MONROE ST",
    "dropdelcty": "WILLOWBROOK",
    "dropdelst": "IL",
    "dropdelzpp": 605279998,
    "dropphyadd": "7140 MONROE ST",
    "dropphycty": "WILLOWBROOK",
    "dropphyst": "IL",
    "dropphyzpp": 605279998,
    "dropmaladd": "7140 MONROE ST",
    "dropmalcty": "WILLOWBROOK",
    "dropmalst": "IL",
    "dropmalzpp": 605279998,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6303233950,
    "dropfax": 6303234369
  },
  {
    "dcode": "D",
    "dropkey": 4001860,
    "droptype": "D",
    "dropname": "GUILFORD/MADISON CAR ANNEX",
    "dropdeladd": "60 SHORELINE DR",
    "dropdelcty": "GUILFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064379998",
    "dropphyadd": "60 SHORELINE DR",
    "dropphycty": "GUILFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064379998",
    "dropmaladd": "60 SHORELINE DR",
    "dropmalcty": "GUILFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064379998",
    "dropsitphn": 2034584052,
    "dropsitlph": 2034584052,
    "dropsitcph": 2034584052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001872,
    "droptype": "D",
    "dropname": "LOS LUNAS",
    "dropdeladd": "351 CANAL BLVD SW",
    "dropdelcty": "LOS LUNAS",
    "dropdelst": "NM",
    "dropdelzpp": 870319997,
    "dropphyadd": "351 CANAL BLVD SW",
    "dropphycty": "LOS LUNAS",
    "dropphyst": "NM",
    "dropphyzpp": 870319997,
    "dropmaladd": "351 CANAL BLVD SW",
    "dropmalcty": "LOS LUNAS",
    "dropmalst": "NM",
    "dropmalzpp": 870319997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5058657887,
    "dropsitcph": 5055651371,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001880,
    "droptype": "D",
    "dropname": "SANTA PAULA ANNEX",
    "dropdeladd": "950 W TELEGRAPH RD",
    "dropdelcty": "SANTA PAULA",
    "dropdelst": "CA",
    "dropdelzpp": 930605499,
    "dropphyadd": "950 W TELEGRAPH RD",
    "dropphycty": "SANTA PAULA",
    "dropphyst": "CA",
    "dropphyzpp": 930605499,
    "dropmaladd": "950 W TELEGRAPH RD",
    "dropmalcty": "SANTA PAULA",
    "dropmalst": "CA",
    "dropmalzpp": 930605499,
    "dropsitphn": 6617757808,
    "dropsitlph": 8059210569,
    "dropsitcph": 8059210569,
    "dropfax": 8055254189
  },
  {
    "dcode": "D",
    "dropkey": 4001897,
    "droptype": "D",
    "dropname": "ARTESIA",
    "dropdeladd": "1401 W CENTRE AVE",
    "dropdelcty": "ARTESIA",
    "dropdelst": "NM",
    "dropdelzpp": 882109997,
    "dropphyadd": "1401 W CENTRE AVE",
    "dropphycty": "ARTESIA",
    "dropphyst": "NM",
    "dropphyzpp": 882109997,
    "dropmaladd": "1401 W CENTRE AVE",
    "dropmalcty": "ARTESIA",
    "dropmalst": "NM",
    "dropmalzpp": 882109997,
    "dropsitphn": 5053468251,
    "dropsitlph": 5757461993,
    "dropsitcph": 5757461993,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001916,
    "droptype": "D",
    "dropname": "EAGLEVILLE CARRIER ANNEX",
    "dropdeladd": "2300 POTSHOP LN",
    "dropdelcty": "NORRISTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 194039996,
    "dropphyadd": "2300 POTSHOP LN",
    "dropphycty": "NORRISTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 194039996,
    "dropmaladd": "2300 POTSHOP LN",
    "dropmalcty": "NORRISTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 194039996,
    "dropsitphn": 6109646414,
    "dropsitlph": 6106309718,
    "dropsitcph": 6106309718,
    "dropfax": 6105399248
  },
  {
    "dcode": "D",
    "dropkey": 4001948,
    "droptype": "D",
    "dropname": "OAK PARK HTS CARRIER ANNEX",
    "dropdeladd": "5520 MEMORIAL AVE N",
    "dropdelcty": "STILLWATER",
    "dropdelst": "MN",
    "dropdelzpp": 550821086,
    "dropphyadd": "5520 MEMORIAL AVE N",
    "dropphycty": "STILLWATER",
    "dropphyst": "MN",
    "dropphyzpp": 550821086,
    "dropmaladd": "5520 MEMORIAL AVE N",
    "dropmalcty": "STILLWATER",
    "dropmalst": "MN",
    "dropmalzpp": 550821086,
    "dropsitphn": 6123496399,
    "dropsitlph": 6513519378,
    "dropsitcph": 6512751393,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001956,
    "droptype": "D",
    "dropname": "GREENFIELD ANNEX",
    "dropdeladd": "100 ADAMS RD",
    "dropdelcty": "GREENFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "013011366",
    "dropphyadd": "100 ADAMS RD",
    "dropphycty": "GREENFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "013011366",
    "dropmaladd": "100 ADAMS RD",
    "dropmalcty": "GREENFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "013011366",
    "dropsitphn": 4137856420,
    "dropsitlph": "",
    "dropsitcph": 4137742793,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4001972,
    "droptype": "D",
    "dropname": "MARYSVILLE CARRIER ANNEX",
    "dropdeladd": "4000 134TH ST NE",
    "dropdelcty": "MARYSVILLE",
    "dropdelst": "WA",
    "dropdelzpp": 982719997,
    "dropphyadd": "4000 134TH ST NE",
    "dropphycty": "MARYSVILLE",
    "dropphyst": "WA",
    "dropphyzpp": 982719997,
    "dropmaladd": "4000 134TH ST NE",
    "dropmalcty": "MARYSVILLE",
    "dropmalst": "WA",
    "dropmalzpp": 982719997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3602875825,
    "dropsitcph": 3602875824,
    "dropfax": 6514566207
  },
  {
    "dcode": "D",
    "dropkey": 4001997,
    "droptype": "D",
    "dropname": "SANFORD ANNEX",
    "dropdeladd": "1475 E AIRPORT BLVD",
    "dropdelcty": "SANFORD",
    "dropdelst": "FL",
    "dropdelzpp": 327739998,
    "dropphyadd": "1475 E AIRPORT BLVD",
    "dropphycty": "SANFORD",
    "dropphyst": "FL",
    "dropphyzpp": 327739998,
    "dropmaladd": "1475 E AIRPORT BLVD",
    "dropmalcty": "SANFORD",
    "dropmalst": "FL",
    "dropmalzpp": 327739998,
    "dropsitphn": 4073249905,
    "dropsitlph": 4073249905,
    "dropsitcph": 4073249559,
    "dropfax": 4073281524
  },
  {
    "dcode": "D",
    "dropkey": 4002041,
    "droptype": "D",
    "dropname": "LAKE FOREST CARRIER ANNEX",
    "dropdeladd": "27848 N BRADLEY RD",
    "dropdelcty": "LAKE FOREST",
    "dropdelst": "IL",
    "dropdelzpp": 600451121,
    "dropphyadd": "27848 N BRADLEY RD",
    "dropphycty": "LAKE FOREST",
    "dropphyst": "IL",
    "dropphyzpp": 600451121,
    "dropmaladd": "27848 N BRADLEY RD",
    "dropmalcty": "LAKE FOREST",
    "dropmalst": "IL",
    "dropmalzpp": 600451121,
    "dropsitphn": 6302605499,
    "dropsitlph": 8472340654,
    "dropsitcph": 8476805464,
    "dropfax": 8476804984
  },
  {
    "dcode": "D",
    "dropkey": 4002052,
    "droptype": "D",
    "dropname": "STOCKDALE ANNEX",
    "dropdeladd": "5601 STOCKDALE HWY",
    "dropdelcty": "BAKERSFIELD",
    "dropdelst": "CA",
    "dropdelzpp": 933092554,
    "dropphyadd": "5601 STOCKDALE HWY",
    "dropphycty": "BAKERSFIELD",
    "dropphyst": "CA",
    "dropphyzpp": 933092554,
    "dropmaladd": "5601 STOCKDALE HWY",
    "dropmalcty": "BAKERSFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 933092554,
    "dropsitphn": 6617757808,
    "dropsitlph": 6618344158,
    "dropsitcph": 6618344158,
    "dropfax": 6615016040
  },
  {
    "dcode": "D",
    "dropkey": 4002061,
    "droptype": "D",
    "dropname": "SEARCY CARRIER ANNEX",
    "dropdeladd": "2701 E RACE AVE STE 1",
    "dropdelcty": "SEARCY",
    "dropdelst": "AR",
    "dropdelzpp": 721434737,
    "dropphyadd": "2701 E RACE AVE STE 1",
    "dropphycty": "SEARCY",
    "dropphyst": "AR",
    "dropphyzpp": 721434737,
    "dropmaladd": "2701 E RACE AVE STE 1",
    "dropmalcty": "SEARCY",
    "dropmalst": "AR",
    "dropmalzpp": 721434737,
    "dropsitphn": 5012688432,
    "dropsitlph": 5013680734,
    "dropsitcph": 5013680734,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002077,
    "droptype": "D",
    "dropname": "ROSE CITY CARRIER ANNEX",
    "dropdeladd": "292 SALEM TPKE",
    "dropdelcty": "NORWICH",
    "dropdelst": "CT",
    "dropdelzpp": "063609998",
    "dropphyadd": "292 SALEM TPKE",
    "dropphycty": "NORWICH",
    "dropphyst": "CT",
    "dropphyzpp": "063609998",
    "dropmaladd": "292 SALEM TPKE",
    "dropmalcty": "NORWICH",
    "dropmalst": "CT",
    "dropmalzpp": "063609998",
    "dropsitphn": 8608595812,
    "dropsitlph": 8608595812,
    "dropsitcph": 8608595812,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002088,
    "droptype": "D",
    "dropname": "LANIER CARRIER ANNEX",
    "dropdeladd": "2530 IVY ST E",
    "dropdelcty": "CUMMING",
    "dropdelst": "GA",
    "dropdelzpp": 300419998,
    "dropphyadd": "2530 IVY ST E",
    "dropphycty": "CUMMING",
    "dropphyst": "GA",
    "dropphyzpp": 300419998,
    "dropmaladd": "2530 IVY ST E",
    "dropmalcty": "CUMMING",
    "dropmalst": "GA",
    "dropmalzpp": 300419998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6789651210,
    "dropsitcph": 7708885357,
    "dropfax": 7708885325
  },
  {
    "dcode": "D",
    "dropkey": 4002092,
    "droptype": "D",
    "dropname": "SANTA FE CARRIER UNIT",
    "dropdeladd": "201 SW 134TH ST",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731709998,
    "dropphyadd": "201 SW 134TH ST",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731709998,
    "dropmaladd": "201 SW 134TH ST",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731709998,
    "dropsitphn": 4058152724,
    "dropsitlph": 4057990880,
    "dropsitcph": 4057990880,
    "dropfax": 4058957238
  },
  {
    "dcode": "D",
    "dropkey": 4002105,
    "droptype": "D",
    "dropname": "GLEN MILLS CARRIER ANNEX",
    "dropdeladd": "99 ALDAN AVE FRNT",
    "dropdelcty": "GLEN MILLS",
    "dropdelst": "PA",
    "dropdelzpp": 193429997,
    "dropphyadd": "99 ALDAN AVE FRNT",
    "dropphycty": "GLEN MILLS",
    "dropphyst": "PA",
    "dropphyzpp": 193429997,
    "dropmaladd": "99 ALDAN AVE FRNT",
    "dropmalcty": "GLEN MILLS",
    "dropmalst": "PA",
    "dropmalzpp": 193429997,
    "dropsitphn": 6109646414,
    "dropsitlph": 6103589500,
    "dropsitcph": 6103589500,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002131,
    "droptype": "D",
    "dropname": "RIVERFRONT CARRIER ANNEX",
    "dropdeladd": "2600 CAMINO DEL RIO N",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921089997,
    "dropphyadd": "2600 CAMINO DEL RIO N",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921089997,
    "dropmaladd": "2600 CAMINO DEL RIO N",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921089997,
    "dropsitphn": 8586740173,
    "dropsitlph": 6192969034,
    "dropsitcph": 6192962661,
    "dropfax": 6192969077
  },
  {
    "dcode": "D",
    "dropkey": 4002133,
    "droptype": "D",
    "dropname": "HAMTRAMCK ANNEX",
    "dropdeladd": "14600 DEQUINDRE ST",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482121500,
    "dropphyadd": "14600 DEQUINDRE ST",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482121500,
    "dropmaladd": "14600 DEQUINDRE ST",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482121500,
    "dropsitphn": 3132268558,
    "dropsitlph": 3138919819,
    "dropsitcph": 3138653276,
    "dropfax": 3138913154
  },
  {
    "dcode": "D",
    "dropkey": 4002161,
    "droptype": "D",
    "dropname": "BLACKSHEAR CARRIER ANX",
    "dropdeladd": "3297 US HIGHWAY 84",
    "dropdelcty": "BLACKSHEAR",
    "dropdelst": "GA",
    "dropdelzpp": 315169997,
    "dropphyadd": "3297 US HIGHWAY 84",
    "dropphycty": "BLACKSHEAR",
    "dropphyst": "GA",
    "dropphyzpp": 315169997,
    "dropmaladd": "3297 US HIGHWAY 84",
    "dropmalcty": "BLACKSHEAR",
    "dropmalst": "GA",
    "dropmalzpp": 315169997,
    "dropsitphn": 4787528466,
    "dropsitlph": 9124490783,
    "dropsitcph": 9124490783,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002167,
    "droptype": "D",
    "dropname": "SHELTON CARRIER ANNEX",
    "dropdeladd": "40 FOREST PKWY",
    "dropdelcty": "SHELTON",
    "dropdelst": "CT",
    "dropdelzpp": "064849998",
    "dropphyadd": "40 FOREST PKWY",
    "dropphycty": "SHELTON",
    "dropphyst": "CT",
    "dropphyzpp": "064849998",
    "dropmaladd": "40 FOREST PKWY",
    "dropmalcty": "SHELTON",
    "dropmalst": "CT",
    "dropmalzpp": "064849998",
    "dropsitphn": 2039227720,
    "dropsitlph": 2039227720,
    "dropsitcph": 2039227720,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002185,
    "droptype": "D",
    "dropname": "FAYETTEVILLE CARRIER ANNEX",
    "dropdeladd": "1430 HIGHWAY 54 W",
    "dropdelcty": "FAYETTEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 302144519,
    "dropphyadd": "1430 HIGHWAY 54 W",
    "dropphycty": "FAYETTEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 302144519,
    "dropmaladd": "1430 HIGHWAY 54 W",
    "dropmalcty": "FAYETTEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 302144519,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707162747,
    "dropsitcph": 7707162747,
    "dropfax": 7707163183
  },
  {
    "dcode": "D",
    "dropkey": 4002192,
    "droptype": "D",
    "dropname": "SHOREWOOD CARRIER ANNEX",
    "dropdeladd": "3600 N HOLTON ST",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532121663,
    "dropphyadd": "3600 N HOLTON ST",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532121663,
    "dropmaladd": "3600 N HOLTON ST",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532121663,
    "dropsitphn": 4142702120,
    "dropsitlph": "",
    "dropsitcph": 4149611634,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002206,
    "droptype": "D",
    "dropname": "IPSWICH CARRIER ANNEX",
    "dropdeladd": "25 HAYWARD ST STE 5",
    "dropdelcty": "IPSWICH",
    "dropdelst": "MA",
    "dropdelzpp": "019389991",
    "dropphyadd": "25 HAYWARD ST STE 5",
    "dropphycty": "IPSWICH",
    "dropphyst": "MA",
    "dropphyzpp": "019389991",
    "dropmaladd": "25 HAYWARD ST STE 5",
    "dropmalcty": "IPSWICH",
    "dropmalst": "MA",
    "dropmalzpp": "019389991",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9783567815,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002225,
    "droptype": "D",
    "dropname": "PICAYUNE CARRIER ANNEX",
    "dropdeladd": "6342 HIGHWAY 11 N",
    "dropdelcty": "PICAYUNE",
    "dropdelst": "MS",
    "dropdelzpp": 394669996,
    "dropphyadd": "6342 HIGHWAY 11 N",
    "dropphycty": "PICAYUNE",
    "dropphyst": "MS",
    "dropphyzpp": 394669996,
    "dropmaladd": "6342 HIGHWAY 11 N",
    "dropmalcty": "PICAYUNE",
    "dropmalst": "MS",
    "dropmalzpp": 394669996,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017985261,
    "dropsitcph": 6017982876,
    "dropfax": 6017987767
  },
  {
    "dcode": "D",
    "dropkey": 4002240,
    "droptype": "D",
    "dropname": "HODGE PARK CARRIER ANNEX",
    "dropdeladd": "4701 NE BARRY RD",
    "dropdelcty": "KANSAS CITY",
    "dropdelst": "MO",
    "dropdelzpp": 641561296,
    "dropphyadd": "4701 NE BARRY RD",
    "dropphycty": "KANSAS CITY",
    "dropphyst": "MO",
    "dropphyzpp": 641561296,
    "dropmaladd": "4701 NE BARRY RD",
    "dropmalcty": "KANSAS CITY",
    "dropmalst": "MO",
    "dropmalzpp": 641561296,
    "dropsitphn": 8165043362,
    "dropsitlph": "",
    "dropsitcph": 8167342459,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002272,
    "droptype": "D",
    "dropname": "INGLEWOOD CARRIER ANNEX",
    "dropdeladd": "4201 W IMPERIAL HWY",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903049997,
    "dropphyadd": "4201 W IMPERIAL HWY",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903049997,
    "dropmaladd": "4201 W IMPERIAL HWY",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903049997,
    "dropsitphn": 5624942406,
    "dropsitlph": 3106744913,
    "dropsitcph": 3106745632,
    "dropfax": 3106744891
  },
  {
    "dcode": "D",
    "dropkey": 4002276,
    "droptype": "D",
    "dropname": "HAZELWOOD BRIDGETON CA",
    "dropdeladd": "5750 PHANTOM DR",
    "dropdelcty": "HAZELWOOD",
    "dropdelst": "MO",
    "dropdelzpp": 630429997,
    "dropphyadd": "5750 PHANTOM DR",
    "dropphycty": "HAZELWOOD",
    "dropphyst": "MO",
    "dropphyzpp": 630429997,
    "dropmaladd": "5750 PHANTOM DR",
    "dropmalcty": "HAZELWOOD",
    "dropmalst": "MO",
    "dropmalzpp": 630429997,
    "dropsitphn": 3148959275,
    "dropsitlph": 3145510421,
    "dropsitcph": 3145510421,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002277,
    "droptype": "D",
    "dropname": "BULLHEAD CITY ANNEX",
    "dropdeladd": "1946 LAKESIDE DR",
    "dropdelcty": "BULLHEAD CITY",
    "dropdelst": "AZ",
    "dropdelzpp": 864429997,
    "dropphyadd": "1946 LAKESIDE DR",
    "dropphycty": "BULLHEAD CITY",
    "dropphyst": "AZ",
    "dropphyzpp": 864429997,
    "dropmaladd": "1946 LAKESIDE DR",
    "dropmalcty": "BULLHEAD CITY",
    "dropmalst": "AZ",
    "dropmalzpp": 864429997,
    "dropsitphn": 6022253214,
    "dropsitlph": 9287585730,
    "dropsitcph": 9287585711,
    "dropfax": 9287587472
  },
  {
    "dcode": "D",
    "dropkey": 4002314,
    "droptype": "D",
    "dropname": "CATONSVILLE CARRIER ANNEX",
    "dropdeladd": "700 GEIPE RD REAR",
    "dropdelcty": "CATONSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 212289997,
    "dropphyadd": "700 GEIPE RD REAR",
    "dropphycty": "CATONSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 212289997,
    "dropmaladd": "700 GEIPE RD REAR",
    "dropmalcty": "CATONSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 212289997,
    "dropsitphn": 4103474587,
    "dropsitlph": 4108699546,
    "dropsitcph": 4108699546,
    "dropfax": 4107191614
  },
  {
    "dcode": "D",
    "dropkey": 4002382,
    "droptype": "D",
    "dropname": "MARLTON CARRIER ANNEX",
    "dropdeladd": "504 CENTENNIAL BLVD",
    "dropdelcty": "VOORHEES",
    "dropdelst": "NJ",
    "dropdelzpp": "080439993",
    "dropphyadd": "504 CENTENNIAL BLVD",
    "dropphycty": "VOORHEES",
    "dropphyst": "NJ",
    "dropphyzpp": "080439993",
    "dropmaladd": "504 CENTENNIAL BLVD",
    "dropmalcty": "VOORHEES",
    "dropmalst": "NJ",
    "dropmalzpp": "080439993",
    "dropsitphn": 8569334046,
    "dropsitlph": 8563963093,
    "dropsitcph": 8563963093,
    "dropfax": 8568109015
  },
  {
    "dcode": "D",
    "dropkey": 4002414,
    "droptype": "D",
    "dropname": "NEWARK CARRIER ANNEX",
    "dropdeladd": "125 RICKEY BLVD",
    "dropdelcty": "BEAR",
    "dropdelst": "DE",
    "dropdelzpp": 197019997,
    "dropphyadd": "125 RICKEY BLVD",
    "dropphycty": "BEAR",
    "dropphyst": "DE",
    "dropphyzpp": 197019997,
    "dropmaladd": "125 RICKEY BLVD",
    "dropmalcty": "BEAR",
    "dropmalst": "DE",
    "dropmalzpp": 197019997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3028385027,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002704,
    "droptype": "D",
    "dropname": "MOUNT CARMEL CARRIER ANNEX",
    "dropdeladd": "2305 WHITNEY AVE",
    "dropdelcty": "HAMDEN",
    "dropdelst": "CT",
    "dropdelzpp": "065189992",
    "dropphyadd": "2305 WHITNEY AVE",
    "dropphycty": "HAMDEN",
    "dropphyst": "CT",
    "dropphyzpp": "065189992",
    "dropmaladd": "2305 WHITNEY AVE",
    "dropmalcty": "HAMDEN",
    "dropmalst": "CT",
    "dropmalzpp": "065189992",
    "dropsitphn": 2032488061,
    "dropsitlph": 2032488061,
    "dropsitcph": 2032488061,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4002720,
    "droptype": "D",
    "dropname": "SCRIPPS RANCH ANNEX",
    "dropdeladd": "10060 WILLOW CREEK RD",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921319997,
    "dropphyadd": "10060 WILLOW CREEK RD",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921319997,
    "dropmaladd": "10060 WILLOW CREEK RD",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921319997,
    "dropsitphn": 8586740173,
    "dropsitlph": 8585773545,
    "dropsitcph": 8585773542,
    "dropfax": 8585773551
  },
  {
    "dcode": "D",
    "dropkey": 4002910,
    "droptype": "D",
    "dropname": "CARMEL VALLEY CARRIER ANNEX",
    "dropdeladd": "10807 VISTA SORRENTO PKWY",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921219997,
    "dropphyadd": "10807 VISTA SORRENTO PKWY",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921219997,
    "dropmaladd": "10807 VISTA SORRENTO PKWY",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921219997,
    "dropsitphn": 8586740173,
    "dropsitlph": 8588249113,
    "dropsitcph": 8588249094,
    "dropfax": 8588249432
  },
  {
    "dcode": "D",
    "dropkey": 4002927,
    "droptype": "D",
    "dropname": "SOUTHSIDE ANNEX",
    "dropdeladd": "106 SOUTHSIDE PARK DR",
    "dropdelcty": "LEBANON",
    "dropdelst": "TN",
    "dropdelzpp": 370909998,
    "dropphyadd": "106 SOUTHSIDE PARK DR",
    "dropphycty": "LEBANON",
    "dropphyst": "TN",
    "dropphyzpp": 370909998,
    "dropmaladd": "106 SOUTHSIDE PARK DR",
    "dropmalcty": "LEBANON",
    "dropmalst": "TN",
    "dropmalzpp": 370909998,
    "dropsitphn": 6158859336,
    "dropsitlph": 6154430265,
    "dropsitcph": 6154433719,
    "dropfax": 6154430294
  },
  {
    "dcode": "D",
    "dropkey": 4003542,
    "droptype": "D",
    "dropname": "HOPEWELL CARRIER ANNEX",
    "dropdeladd": "1616 ROUTE 82",
    "dropdelcty": "LAGRANGEVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 125406089,
    "dropphyadd": "1616 ROUTE 82",
    "dropphycty": "LAGRANGEVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 125406089,
    "dropmaladd": "815 ROUTE 82",
    "dropmalcty": "HOPEWELL JUNCTION",
    "dropmalst": "NY",
    "dropmalzpp": 125339998,
    "dropsitphn": 9146974123,
    "dropsitlph": 8452264119,
    "dropsitcph": 8452264119,
    "dropfax": 8452268367
  },
  {
    "dcode": "D",
    "dropkey": 4003567,
    "droptype": "D",
    "dropname": "NORTHWEST ANNEX",
    "dropdeladd": "2727 W CAMELBACK RD",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850173272,
    "dropphyadd": "2727 W CAMELBACK RD",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850173272,
    "dropmaladd": "2727 W CAMELBACK RD",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850173272,
    "dropsitphn": 6022253214,
    "dropsitlph": 6028410766,
    "dropsitcph": 6022496411,
    "dropfax": 6022425197
  },
  {
    "dcode": "D",
    "dropkey": 4003703,
    "droptype": "D",
    "dropname": "SOUTHWEST CARRIER ANNEX",
    "dropdeladd": "4301 W 69TH ST",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606299998,
    "dropphyadd": "4301 W 69TH ST",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606299998,
    "dropmaladd": "4301 W 69TH ST",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606299998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7732846510,
    "dropfax": 7732846515
  },
  {
    "dcode": "D",
    "dropkey": 4003710,
    "droptype": "D",
    "dropname": "CLERMONT CARRIER ANNEX",
    "dropdeladd": "400 CITRUS TOWER BLVD",
    "dropdelcty": "CLERMONT",
    "dropdelst": "FL",
    "dropdelzpp": 347119996,
    "dropphyadd": "400 CITRUS TOWER BLVD",
    "dropphycty": "CLERMONT",
    "dropphyst": "FL",
    "dropphyzpp": 347119996,
    "dropmaladd": "400 CITRUS TOWER BLVD",
    "dropmalcty": "CLERMONT",
    "dropmalst": "FL",
    "dropmalzpp": 347119996,
    "dropsitphn": 3522417001,
    "dropsitlph": 3522417001,
    "dropsitcph": 3522417073,
    "dropfax": 3522418845
  },
  {
    "dcode": "D",
    "dropkey": 4003798,
    "droptype": "D",
    "dropname": "CROWN POINT ANNEX",
    "dropdeladd": "1280 E SUMMIT ST",
    "dropdelcty": "CROWN POINT",
    "dropdelst": "IN",
    "dropdelzpp": 463079998,
    "dropphyadd": "1280 E SUMMIT ST",
    "dropphycty": "CROWN POINT",
    "dropphyst": "IN",
    "dropphyzpp": 463079998,
    "dropmaladd": "1280 E SUMMIT ST",
    "dropmalcty": "CROWN POINT",
    "dropmalst": "IN",
    "dropmalzpp": 463079998,
    "dropsitphn": 2196630062,
    "dropsitlph": "",
    "dropsitcph": 2196630062,
    "dropfax": 2196610348
  },
  {
    "dcode": "D",
    "dropkey": 4003799,
    "droptype": "D",
    "dropname": "SAINT MARYS STATION",
    "dropdeladd": "1737 SAINT MARYS AVE",
    "dropdelcty": "FORT WAYNE",
    "dropdelst": "IN",
    "dropdelzpp": 468083272,
    "dropphyadd": "1737 SAINT MARYS AVE",
    "dropphycty": "FORT WAYNE",
    "dropphyst": "IN",
    "dropphyzpp": 468083272,
    "dropmaladd": "2525 INDEPENDENCE DR",
    "dropmalcty": "FORT WAYNE",
    "dropmalst": "IN",
    "dropmalzpp": 468089998,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 2604277314,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4003848,
    "droptype": "D",
    "dropname": "MADISON CARRIER ANNEX",
    "dropdeladd": "33 CENTRAL AVE",
    "dropdelcty": "MADISON",
    "dropdelst": "NJ",
    "dropdelzpp": "079409991",
    "dropphyadd": "33 CENTRAL AVE",
    "dropphycty": "MADISON",
    "dropphyst": "NJ",
    "dropphyzpp": "079409991",
    "dropmaladd": "33 CENTRAL AVE",
    "dropmalcty": "MADISON",
    "dropmalst": "NJ",
    "dropmalzpp": "079409991",
    "dropsitphn": 2019559706,
    "dropsitlph": 2019559706,
    "dropsitcph": 9736609636,
    "dropfax": 6516751591
  },
  {
    "dcode": "D",
    "dropkey": 4003963,
    "droptype": "D",
    "dropname": "BURLINGTON ANNEX",
    "dropdeladd": "320 PINE ST",
    "dropdelcty": "BURLINGTON",
    "dropdelst": "VT",
    "dropdelzpp": "054019844",
    "dropphyadd": "320 PINE ST",
    "dropphycty": "BURLINGTON",
    "dropphyst": "VT",
    "dropphyzpp": "054019844",
    "dropmaladd": "320 PINE ST",
    "dropmalcty": "BURLINGTON",
    "dropmalst": "VT",
    "dropmalzpp": "054019844",
    "dropsitphn": 8022963232,
    "dropsitlph": 8026581176,
    "dropsitcph": 8026580919,
    "dropfax": 8028645087
  },
  {
    "dcode": "D",
    "dropkey": 4003990,
    "droptype": "D",
    "dropname": "OSHKOSH CARRIER ANNEX",
    "dropdeladd": "1900 VENTURE DR",
    "dropdelcty": "OSHKOSH",
    "dropdelst": "WI",
    "dropdelzpp": 549026108,
    "dropphyadd": "1900 VENTURE DR",
    "dropphycty": "OSHKOSH",
    "dropphyst": "WI",
    "dropphyzpp": 549026108,
    "dropmaladd": "1900 VENTURE DR",
    "dropmalcty": "OSHKOSH",
    "dropmalst": "WI",
    "dropmalzpp": 549026108,
    "dropsitphn": 4142702120,
    "dropsitlph": 9202325760,
    "dropsitcph": 9202325760,
    "dropfax": 9202320992
  },
  {
    "dcode": "D",
    "dropkey": 4004188,
    "droptype": "D",
    "dropname": "SECTION 2 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189996,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189996,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189996,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026362273,
    "dropsitcph": 2026362274,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004266,
    "droptype": "D",
    "dropname": "PADUCAH CARRIER ANNEX",
    "dropdeladd": "3550 PARK PLAZA RD",
    "dropdelcty": "PADUCAH",
    "dropdelst": "KY",
    "dropdelzpp": 420019998,
    "dropphyadd": "3550 PARK PLAZA RD",
    "dropphycty": "PADUCAH",
    "dropphyst": "KY",
    "dropphyzpp": 420019998,
    "dropmaladd": "3550 PARK PLAZA RD",
    "dropmalcty": "PADUCAH",
    "dropmalst": "KY",
    "dropmalzpp": 420019998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2704449447,
    "dropfax": 2704420154
  },
  {
    "dcode": "D",
    "dropkey": 4004288,
    "droptype": "D",
    "dropname": "WEST OAK CARRIER ANNEX",
    "dropdeladd": "1891 W OAK PKWY",
    "dropdelcty": "MARIETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300629998,
    "dropphyadd": "1891 W OAK PKWY",
    "dropphycty": "MARIETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300629998,
    "dropmaladd": "1891 W OAK PKWY",
    "dropmalcty": "MARIETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300629998,
    "dropsitphn": "",
    "dropsitlph": 6784330017,
    "dropsitcph": 7705147782,
    "dropfax": 7704202857
  },
  {
    "dcode": "D",
    "dropkey": 4004366,
    "droptype": "D",
    "dropname": "WAYNE CARRIER ANNEX",
    "dropdeladd": "5N423 RAILROAD ST",
    "dropdelcty": "WAYNE",
    "dropdelst": "IL",
    "dropdelzpp": 601843201,
    "dropphyadd": "5N423 RAILROAD ST",
    "dropphycty": "WAYNE",
    "dropphyst": "IL",
    "dropphyzpp": 601843201,
    "dropmaladd": "5N431 RAILROAD ST",
    "dropmalcty": "WAYNE",
    "dropmalst": "IL",
    "dropmalzpp": 601843200,
    "dropsitphn": 6302605499,
    "dropsitlph": 6305843411,
    "dropsitcph": 6305843411,
    "dropfax": 6305844898
  },
  {
    "dcode": "D",
    "dropkey": 4004421,
    "droptype": "D",
    "dropname": "CANONSBURG CARRIER ANNEX",
    "dropdeladd": "14 CURRY AVE",
    "dropdelcty": "CANONSBURG",
    "dropdelst": "PA",
    "dropdelzpp": 153179998,
    "dropphyadd": "14 CURRY AVE",
    "dropphycty": "CANONSBURG",
    "dropphyst": "PA",
    "dropphyzpp": 153179998,
    "dropmaladd": "14 CURRY AVE",
    "dropmalcty": "CANONSBURG",
    "dropmalst": "PA",
    "dropmalzpp": 153179998,
    "dropsitphn": 7247455770,
    "dropsitlph": 4123597568,
    "dropsitcph": 7247455770,
    "dropfax": 7248739071
  },
  {
    "dcode": "D",
    "dropkey": 4004504,
    "droptype": "D",
    "dropname": "SIX MILE CYPRESS ANNEX",
    "dropdeladd": "14651 BEN C PRATT/6 MILE CYPRESS PKWY",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339124456,
    "dropphyadd": "14651 BEN C PRATT/6 MILE CYPRESS PKWY",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339124456,
    "dropmaladd": "14651 BEN C PRATT/6 MILE CYPRESS PKWY",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339129998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2394372973,
    "dropfax": 2394335394
  },
  {
    "dcode": "D",
    "dropkey": 4004510,
    "droptype": "D",
    "dropname": "PALM CITY ANNEX",
    "dropdeladd": "3505 SW CORPORATE PKWY",
    "dropdelcty": "PALM CITY",
    "dropdelst": "FL",
    "dropdelzpp": 349909991,
    "dropphyadd": "3505 SW CORPORATE PKWY",
    "dropphycty": "PALM CITY",
    "dropphyst": "FL",
    "dropphyzpp": 349909991,
    "dropmaladd": "3505 SW CORPORATE PKWY",
    "dropmalcty": "PALM CITY",
    "dropmalst": "FL",
    "dropmalzpp": 349909991,
    "dropsitphn": 7722234574,
    "dropsitlph": 7722234574,
    "dropsitcph": 7724030753,
    "dropfax": 7722218275
  },
  {
    "dcode": "D",
    "dropkey": 4004544,
    "droptype": "D",
    "dropname": "FAIRHAVEN CARRIER ANNEX",
    "dropdeladd": "4 PEQUOD RD",
    "dropdelcty": "FAIRHAVEN",
    "dropdelst": "MA",
    "dropdelzpp": "027194741",
    "dropphyadd": "4 PEQUOD RD",
    "dropphycty": "FAIRHAVEN",
    "dropphyst": "MA",
    "dropphyzpp": "027194741",
    "dropmaladd": "4 PEQUOD RD",
    "dropmalcty": "FAIRHAVEN",
    "dropmalst": "MA",
    "dropmalzpp": "027194741",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089975248,
    "dropfax": 5089976047
  },
  {
    "dcode": "D",
    "dropkey": 4004577,
    "droptype": "D",
    "dropname": "MISSOURI CITY ANNEX",
    "dropdeladd": "3701 GLENN LAKES LN",
    "dropdelcty": "MISSOURI CITY",
    "dropdelst": "TX",
    "dropdelzpp": 774599998,
    "dropphyadd": "3701 GLENN LAKES LN",
    "dropphycty": "MISSOURI CITY",
    "dropphyst": "TX",
    "dropphyzpp": 774599998,
    "dropmaladd": "3701 GLENN LAKES LN",
    "dropmalcty": "MISSOURI CITY",
    "dropmalst": "TX",
    "dropmalzpp": 774599998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2812081958,
    "dropsitcph": 2812081837,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004578,
    "droptype": "D",
    "dropname": "COPPERFIELD ANNEX",
    "dropdeladd": "8825 HIGHWAY 6 N",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770959998,
    "dropphyadd": "8825 HIGHWAY 6 N",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770959998,
    "dropmaladd": "8825 HIGHWAY 6 N",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770959998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2818599021,
    "dropsitcph": 2818599014,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004716,
    "droptype": "D",
    "dropname": "ROSSLYN CARRIER ANNEX",
    "dropdeladd": "3118 WASHINGTON BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222019909,
    "dropphyadd": "3118 WASHINGTON BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222019909,
    "dropmaladd": "3118 WASHINGTON BLVD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222019909,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039930072,
    "dropsitcph": 7039930072,
    "dropfax": 7032489478
  },
  {
    "dcode": "D",
    "dropkey": 4004765,
    "droptype": "D",
    "dropname": "SECTION 1 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189995,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189995,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026362290,
    "dropsitcph": 2026362290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004766,
    "droptype": "D",
    "dropname": "SECTION 4 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189993,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189993,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189993,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361972,
    "dropsitcph": 2026361010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004767,
    "droptype": "D",
    "dropname": "SECTION 5 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189994,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189994,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189994,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026361972,
    "dropsitcph": 2026362289,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004770,
    "droptype": "D",
    "dropname": "GAINESVILLE CARRIER ANNEX",
    "dropdeladd": "2530 PENTEE DR",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 305079998,
    "dropphyadd": "2530 PENTEE DR",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 305079998,
    "dropmaladd": "2530 PENTEE DR",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 305079998,
    "dropsitphn": 4047657578,
    "dropsitlph": 6789716082,
    "dropsitcph": 7702976208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4004806,
    "droptype": "D",
    "dropname": "MIFFLINTOWN CARRIER ANNEX",
    "dropdeladd": "612 WASHINGTON AVE",
    "dropdelcty": "MIFFLINTOWN",
    "dropdelst": "PA",
    "dropdelzpp": 170591409,
    "dropphyadd": "612 WASHINGTON AVE",
    "dropphycty": "MIFFLINTOWN",
    "dropphyst": "PA",
    "dropphyzpp": 170591409,
    "dropmaladd": "150 BRIDGE ST",
    "dropmalcty": "MIFFLINTOWN",
    "dropmalst": "PA",
    "dropmalzpp": 170599998,
    "dropsitphn": 7172574870,
    "dropsitlph": 7172574875,
    "dropsitcph": 7174362515,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4005647,
    "droptype": "D",
    "dropname": "ETNA CARRIER ANNEX",
    "dropdeladd": "1541 BUTLER PLANK RD",
    "dropdelcty": "GLENSHAW",
    "dropdelst": "PA",
    "dropdelzpp": 151169997,
    "dropphyadd": "1541 BUTLER PLANK RD",
    "dropphycty": "GLENSHAW",
    "dropphyst": "PA",
    "dropphyzpp": 151169997,
    "dropmaladd": "1541 BUTLER PLANK RD",
    "dropmalcty": "GLENSHAW",
    "dropmalst": "PA",
    "dropmalzpp": 151169998,
    "dropsitphn": 4123597568,
    "dropsitlph": 4124863128,
    "dropsitcph": 4124863128,
    "dropfax": 4124866122
  },
  {
    "dcode": "D",
    "dropkey": 4006122,
    "droptype": "D",
    "dropname": "COLESVILLE CARRIER ANNEX",
    "dropdeladd": "12010 PLUM ORCHARD DR",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209049996,
    "dropphyadd": "12010 PLUM ORCHARD DR",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209049996,
    "dropmaladd": "12010 PLUM ORCHARD DR",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209049996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015867613,
    "dropsitcph": 3015867613,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4006783,
    "droptype": "D",
    "dropname": "ANACOSTIA CARRIER ANNEX",
    "dropdeladd": "3719 BRANCH AVE",
    "dropdelcty": "TEMPLE HILLS",
    "dropdelst": "MD",
    "dropdelzpp": 207489993,
    "dropphyadd": "3719 BRANCH AVE",
    "dropphycty": "TEMPLE HILLS",
    "dropphyst": "MD",
    "dropphyzpp": 207489993,
    "dropmaladd": "3719 BRANCH AVE",
    "dropmalcty": "TEMPLE HILLS",
    "dropmalst": "MD",
    "dropmalzpp": 207489993,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232119,
    "dropsitcph": 3014239091,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4006845,
    "droptype": "D",
    "dropname": "HARWOOD HEIGHTS CARRIER ANX",
    "dropdeladd": "7350 W AGATITE AVE",
    "dropdelcty": "NORRIDGE",
    "dropdelst": "IL",
    "dropdelzpp": 607064752,
    "dropphyadd": "7350 W AGATITE AVE",
    "dropphycty": "NORRIDGE",
    "dropphyst": "IL",
    "dropphyzpp": 607064752,
    "dropmaladd": "7350 W AGATITE AVE",
    "dropmalcty": "NORRIDGE",
    "dropmalst": "IL",
    "dropmalzpp": 607064752,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 7084526193,
    "dropfax": 7084527639
  },
  {
    "dcode": "D",
    "dropkey": 4006931,
    "droptype": "D",
    "dropname": "BRADLEY CARRIER ANNEX",
    "dropdeladd": "6215 W BRADLEY RD",
    "dropdelcty": "MILWAUKEE",
    "dropdelst": "WI",
    "dropdelzpp": 532233441,
    "dropphyadd": "6215 W BRADLEY RD",
    "dropphycty": "MILWAUKEE",
    "dropphyst": "WI",
    "dropphyzpp": 532233441,
    "dropmaladd": "6215 W BRADLEY RD",
    "dropmalcty": "MILWAUKEE",
    "dropmalst": "WI",
    "dropmalzpp": 532233441,
    "dropsitphn": 4142702120,
    "dropsitlph": 4143544295,
    "dropsitcph": 4143544430,
    "dropfax": 4143545810
  },
  {
    "dcode": "D",
    "dropkey": 4007012,
    "droptype": "D",
    "dropname": "CALVERT CARRIER ANNEX",
    "dropdeladd": "6511 BALTIMORE AVE",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207829998,
    "dropphyadd": "6511 BALTIMORE AVE",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207829998,
    "dropmaladd": "6511 BALTIMORE AVE",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207829998,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012093430,
    "dropsitcph": 3012098905,
    "dropfax": 3012093460
  },
  {
    "dcode": "D",
    "dropkey": 4007014,
    "droptype": "D",
    "dropname": "LAYTONSVILLE CARRIER ANNEX",
    "dropdeladd": "6828 OLNEY LAYTONSVILLE RD",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208821918,
    "dropphyadd": "6828 OLNEY LAYTONSVILLE RD",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208821918,
    "dropmaladd": "6828 OLNEY LAYTONSVILLE RD",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208821918,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083736,
    "dropsitcph": 3012083736,
    "dropfax": 3102081262
  },
  {
    "dcode": "D",
    "dropkey": 4007205,
    "droptype": "D",
    "dropname": "BROOKLYN SOUTH",
    "dropdeladd": "1500 CHERRY HILL RD",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "MD",
    "dropdelzpp": 212259997,
    "dropphyadd": "1500 CHERRY HILL RD",
    "dropphycty": "BROOKLYN",
    "dropphyst": "MD",
    "dropphyzpp": 212259997,
    "dropmaladd": "1500 CHERRY HILL RD",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "MD",
    "dropmalzpp": 212259997,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103540821,
    "dropsitcph": 4103540821,
    "dropfax": 4103546273
  },
  {
    "dcode": "D",
    "dropkey": 4007270,
    "droptype": "D",
    "dropname": "CHINA TWP CARRIER ANNEX",
    "dropdeladd": "3080 KING RD",
    "dropdelcty": "CHINA",
    "dropdelst": "MI",
    "dropdelzpp": 480549998,
    "dropphyadd": "3080 KING RD",
    "dropphycty": "CHINA",
    "dropphyst": "MI",
    "dropphyzpp": 480549998,
    "dropmaladd": "3080 KING RD",
    "dropmalcty": "CHINA",
    "dropmalst": "MI",
    "dropmalzpp": 480549998,
    "dropsitphn": 8103294103,
    "dropsitlph": 2487585622,
    "dropsitcph": 8103294103,
    "dropfax": 8103293925
  },
  {
    "dcode": "D",
    "dropkey": 4007272,
    "droptype": "D",
    "dropname": "TRINITY ANNEX",
    "dropdeladd": "90 CHURCH ST STE 200",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100079996,
    "dropphyadd": "90 CHURCH ST STE 200",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100079996,
    "dropmaladd": "90 CHURCH ST STE 200",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100079996,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 2123305155,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4007295,
    "droptype": "D",
    "dropname": "CAPE CARRIER ANNEX",
    "dropdeladd": "475 KELL FARM DR",
    "dropdelcty": "CAPE GIRARDEAU",
    "dropdelst": "MO",
    "dropdelzpp": 637019727,
    "dropphyadd": "475 KELL FARM DR",
    "dropphycty": "CAPE GIRARDEAU",
    "dropphyst": "MO",
    "dropphyzpp": 637019727,
    "dropmaladd": "475 KELL FARM DR",
    "dropmalcty": "CAPE GIRARDEAU",
    "dropmalst": "MO",
    "dropmalzpp": 637019727,
    "dropsitphn": 8165043362,
    "dropsitlph": 5733310800,
    "dropsitcph": 5733310800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4007438,
    "droptype": "D",
    "dropname": "WEST END CARRIER ANNEX",
    "dropdeladd": "2410 ROBINSON ST",
    "dropdelcty": "COLORADO SPRINGS",
    "dropdelst": "CO",
    "dropdelzpp": 809043249,
    "dropphyadd": "2410 ROBINSON ST",
    "dropphycty": "COLORADO SPRINGS",
    "dropphyst": "CO",
    "dropphyzpp": 809043249,
    "dropmaladd": "2410 ROBINSON ST",
    "dropmalcty": "COLORADO SPRINGS",
    "dropmalst": "CO",
    "dropmalzpp": 809043249,
    "dropsitphn": 7195705409,
    "dropsitlph": 7194771994,
    "dropsitcph": 7194771994,
    "dropfax": 7194730415
  },
  {
    "dcode": "D",
    "dropkey": 4007463,
    "droptype": "D",
    "dropname": "EL MIRAGE ANNEX",
    "dropdeladd": "12375 W ALICE AVE STE 1",
    "dropdelcty": "EL MIRAGE",
    "dropdelst": "AZ",
    "dropdelzpp": 853354108,
    "dropphyadd": "12375 W ALICE AVE STE 1",
    "dropphycty": "EL MIRAGE",
    "dropphyst": "AZ",
    "dropphyzpp": 853354108,
    "dropmaladd": "11925 W THUNDERBIRD RD",
    "dropmalcty": "EL MIRAGE",
    "dropmalst": "AZ",
    "dropmalzpp": 853359998,
    "dropsitphn": 6022253214,
    "dropsitlph": 6235470341,
    "dropsitcph": 6235470326,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4007608,
    "droptype": "D",
    "dropname": "BAXTER CARRIER ANNEX",
    "dropdeladd": "7757 COLLEGE RD STE 100",
    "dropdelcty": "BAXTER",
    "dropdelst": "MN",
    "dropdelzpp": 564256100,
    "dropphyadd": "7757 COLLEGE RD STE 100",
    "dropphycty": "BAXTER",
    "dropphyst": "MN",
    "dropphyzpp": 564256100,
    "dropmaladd": "7757 COLLEGE RD STE 100",
    "dropmalcty": "BAXTER",
    "dropmalst": "MN",
    "dropmalzpp": 564256100,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 2188223494,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4007626,
    "droptype": "D",
    "dropname": "GLOBE ANNEX",
    "dropdeladd": "1770 HIGHWAY 60-77",
    "dropdelcty": "GLOBE",
    "dropdelst": "AZ",
    "dropdelzpp": 855011494,
    "dropphyadd": "1770 HIGHWAY 60-77",
    "dropphycty": "GLOBE",
    "dropphyst": "AZ",
    "dropphyzpp": 855011494,
    "dropmaladd": "1770 HIGHWAY 60-77",
    "dropmalcty": "GLOBE",
    "dropmalst": "AZ",
    "dropmalzpp": 855011494,
    "dropsitphn": 6022253214,
    "dropsitlph": 9284256950,
    "dropsitcph": 9284252381,
    "dropfax": 9284256953
  },
  {
    "dcode": "D",
    "dropkey": 4008085,
    "droptype": "D",
    "dropname": "LAVEEN ANNEX",
    "dropdeladd": "3721 W DOBBINS RD",
    "dropdelcty": "LAVEEN",
    "dropdelst": "AZ",
    "dropdelzpp": 853391798,
    "dropphyadd": "3721 W DOBBINS RD",
    "dropphycty": "LAVEEN",
    "dropphyst": "AZ",
    "dropphyzpp": 853391798,
    "dropmaladd": "3721 W DOBBINS RD",
    "dropmalcty": "LAVEEN",
    "dropmalst": "AZ",
    "dropmalzpp": 853391798,
    "dropsitphn": 6022253214,
    "dropsitlph": 6022370963,
    "dropsitcph": 6022379051,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008147,
    "droptype": "D",
    "dropname": "DALLAS COLLECTIONS",
    "dropdeladd": "401 TOM LANDRY HWY",
    "dropdelcty": "DALLAS",
    "dropdelst": "TX",
    "dropdelzpp": 752609796,
    "dropphyadd": "401 TOM LANDRY HWY",
    "dropphycty": "DALLAS",
    "dropphyst": "TX",
    "dropphyzpp": 752609796,
    "dropmaladd": "401 TOM LANDRY HWY",
    "dropmalcty": "DALLAS",
    "dropmalst": "TX",
    "dropmalzpp": 752609796,
    "dropsitphn": 2149482879,
    "dropsitlph": "",
    "dropsitcph": 2147604508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008193,
    "droptype": "D",
    "dropname": "WESTPORT CARRIER ANNEX",
    "dropdeladd": "234 WESTPORT AVE",
    "dropdelcty": "NORWALK",
    "dropdelst": "CT",
    "dropdelzpp": "068519993",
    "dropphyadd": "234 WESTPORT AVE",
    "dropphycty": "NORWALK",
    "dropphyst": "CT",
    "dropphyzpp": "068519993",
    "dropmaladd": "234 WESTPORT AVE",
    "dropmalcty": "NORWALK",
    "dropmalst": "CT",
    "dropmalzpp": "068519993",
    "dropsitphn": 2032290483,
    "dropsitlph": "",
    "dropsitcph": 2032290483,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008553,
    "droptype": "D",
    "dropname": "CENTRALIZED PARCEL POST",
    "dropdeladd": "341 9TH AVE BSMT BB30",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 101999793,
    "dropphyadd": "341 9TH AVE BSMT BB30",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 101999793,
    "dropmaladd": "341 9TH AVE BSMT BB30",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 101999793,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123302510,
    "dropsitcph": 2123302510,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008557,
    "droptype": "D",
    "dropname": "PARCEL POST ANNEX",
    "dropdeladd": "909 3RD AVE STE 300",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100229352,
    "dropphyadd": "909 3RD AVE STE 300",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100229352,
    "dropmaladd": "909 3RD AVE STE 300",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100229352,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305508,
    "dropsitcph": 2123305508,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008585,
    "droptype": "D",
    "dropname": "KATY ANNEX",
    "dropdeladd": "1331 PIN OAK RD",
    "dropdelcty": "KATY",
    "dropdelst": "TX",
    "dropdelzpp": 774949998,
    "dropphyadd": "1331 PIN OAK RD",
    "dropphycty": "KATY",
    "dropphyst": "TX",
    "dropphyzpp": 774949998,
    "dropmaladd": "1331 PIN OAK RD",
    "dropmalcty": "KATY",
    "dropmalst": "TX",
    "dropmalzpp": 774949998,
    "dropsitphn": 7132263055,
    "dropsitlph": 2815741401,
    "dropsitcph": 2815741401,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4008637,
    "droptype": "D",
    "dropname": "BRENTWOOD CARRIER ANNEX",
    "dropdeladd": "1734 GENERAL GEORGE PATTON DR",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 370279997,
    "dropphyadd": "1734 GENERAL GEORGE PATTON DR",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 370279997,
    "dropmaladd": "1734 GENERAL GEORGE PATTON DR",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 370279997,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153737875,
    "dropsitcph": 6153737875,
    "dropfax": 6153732462
  },
  {
    "dcode": "D",
    "dropkey": 4008937,
    "droptype": "D",
    "dropname": "ROCHESTER CARRIER ANNEX",
    "dropdeladd": "1335 JEFFERSON RD",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "NY",
    "dropdelzpp": 146929204,
    "dropphyadd": "1335 JEFFERSON RD",
    "dropphycty": "ROCHESTER",
    "dropphyst": "NY",
    "dropphyzpp": 146929204,
    "dropmaladd": "1335 JEFFERSON RD",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "NY",
    "dropmalzpp": 146929204,
    "dropsitphn": 7168462415,
    "dropsitlph": 5852725916,
    "dropsitcph": 5852725924,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4009147,
    "droptype": "D",
    "dropname": "GEORGETOWN CARRIER ANNEX",
    "dropdeladd": "4005 WISCONSIN AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200169996,
    "dropphyadd": "4005 WISCONSIN AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200169996,
    "dropmaladd": "4005 WISCONSIN AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200169996,
    "dropsitphn": 3014997331,
    "dropsitlph": 2023643665,
    "dropsitcph": 2025232130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4009148,
    "droptype": "D",
    "dropname": "CLEVELAND PARK CARRIER ANNEX",
    "dropdeladd": "4005 WISCONSIN AVE NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200169995,
    "dropphyadd": "4005 WISCONSIN AVE NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200169995,
    "dropmaladd": "4005 WISCONSIN AVE NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200169995,
    "dropsitphn": 3014997331,
    "dropsitlph": 2023643665,
    "dropsitcph": 2025232130,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4009174,
    "droptype": "D",
    "dropname": "TRINITY CARRIER ANNEX",
    "dropdeladd": "4022 LITTLE RD",
    "dropdelcty": "NEW PORT RICHEY",
    "dropdelst": "FL",
    "dropdelzpp": 346551797,
    "dropphyadd": "4022 LITTLE RD",
    "dropphycty": "NEW PORT RICHEY",
    "dropphyst": "FL",
    "dropphyzpp": 346551797,
    "dropmaladd": "4022 LITTLE RD",
    "dropmalcty": "NEW PORT RICHEY",
    "dropmalst": "FL",
    "dropmalzpp": 346551797,
    "dropsitphn": 8138770788,
    "dropsitlph": "",
    "dropsitcph": 7273761780,
    "dropfax": 7273766200
  },
  {
    "dcode": "D",
    "dropkey": 4009251,
    "droptype": "D",
    "dropname": "EAST FALMOUTH CARRIER ANNEX",
    "dropdeladd": "441 E FALMOUTH HWY",
    "dropdelcty": "EAST FALMOUTH",
    "dropdelst": "MA",
    "dropdelzpp": "025366166",
    "dropphyadd": "441 E FALMOUTH HWY",
    "dropphycty": "EAST FALMOUTH",
    "dropphyst": "MA",
    "dropphyzpp": "025366166",
    "dropmaladd": "441 E FALMOUTH HWY",
    "dropmalcty": "EAST FALMOUTH",
    "dropmalst": "MA",
    "dropmalzpp": "025366166",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085482393,
    "dropfax": 5085482774
  },
  {
    "dcode": "D",
    "dropkey": 4009303,
    "droptype": "D",
    "dropname": "WHITNEYVILLE N HAVEN SEC",
    "dropdeladd": "50 BREWERY ST",
    "dropdelcty": "NEW HAVEN",
    "dropdelst": "CT",
    "dropdelzpp": "065119749",
    "dropphyadd": "50 BREWERY ST",
    "dropphycty": "NEW HAVEN",
    "dropphyst": "CT",
    "dropphyzpp": "065119749",
    "dropmaladd": "50 BREWERY ST",
    "dropmalcty": "NEW HAVEN",
    "dropmalst": "CT",
    "dropmalzpp": "065119749",
    "dropsitphn": 2032304710,
    "dropsitlph": 2032304712,
    "dropsitcph": 2032304712,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4009321,
    "droptype": "D",
    "dropname": "TULARE CARRIER ANNEX",
    "dropdeladd": "834 INDUSTRIAL AVE",
    "dropdelcty": "TULARE",
    "dropdelst": "CA",
    "dropdelzpp": 932746408,
    "dropphyadd": "834 INDUSTRIAL AVE",
    "dropphycty": "TULARE",
    "dropphyst": "CA",
    "dropphyzpp": 932746408,
    "dropmaladd": "834 INDUSTRIAL AVE",
    "dropmalcty": "TULARE",
    "dropmalst": "CA",
    "dropmalzpp": 932746408,
    "dropsitphn": 6617757808,
    "dropsitlph": 5596846000,
    "dropsitcph": 5596846000,
    "dropfax": 5596860102
  },
  {
    "dcode": "D",
    "dropkey": 4009506,
    "droptype": "D",
    "dropname": "MIDDLEBURY ANNEX",
    "dropdeladd": "658 EXCHANGE ST STE 2",
    "dropdelcty": "MIDDLEBURY",
    "dropdelst": "VT",
    "dropdelzpp": "057539997",
    "dropphyadd": "658 EXCHANGE ST STE 2",
    "dropphycty": "MIDDLEBURY",
    "dropphyst": "VT",
    "dropphyzpp": "057539997",
    "dropmaladd": "658 EXCHANGE ST STE 2",
    "dropmalcty": "MIDDLEBURY",
    "dropmalst": "VT",
    "dropmalzpp": "057539997",
    "dropsitphn": 8022963232,
    "dropsitlph": 8023882681,
    "dropsitcph": 8023885454,
    "dropfax": 8023881475
  },
  {
    "dcode": "D",
    "dropkey": 4009807,
    "droptype": "D",
    "dropname": "LAKEVILLE CARRIERS",
    "dropdeladd": "15 RIVERSIDE DR",
    "dropdelcty": "LAKEVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "023479997",
    "dropphyadd": "15 RIVERSIDE DR",
    "dropphycty": "LAKEVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "023479997",
    "dropmaladd": "15 RIVERSIDE DR",
    "dropmalcty": "LAKEVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "023479997",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5089474767,
    "dropfax": 5089236429
  },
  {
    "dcode": "D",
    "dropkey": 4010006,
    "droptype": "D",
    "dropname": "LENOIR CITY CARRIER ANNEX",
    "dropdeladd": "501 ADESA BLVD STE 240",
    "dropdelcty": "LENOIR CITY",
    "dropdelst": "TN",
    "dropdelzpp": 377719997,
    "dropphyadd": "501 ADESA BLVD STE 240",
    "dropphycty": "LENOIR CITY",
    "dropphyst": "TN",
    "dropphyzpp": 377719997,
    "dropmaladd": "501 ADESA BLVD STE 240",
    "dropmalcty": "LENOIR CITY",
    "dropmalst": "TN",
    "dropmalzpp": 377719997,
    "dropsitphn": 6158859336,
    "dropsitlph": 8659886130,
    "dropsitcph": 8659886130,
    "dropfax": 8659886132
  },
  {
    "dcode": "D",
    "dropkey": 4010075,
    "droptype": "D",
    "dropname": "THE COLONY CARRIER ANNEX",
    "dropdeladd": "5201 S COLONY BLVD STE 600",
    "dropdelcty": "THE COLONY",
    "dropdelst": "TX",
    "dropdelzpp": 750569997,
    "dropphyadd": "5201 S COLONY BLVD STE 600",
    "dropphycty": "THE COLONY",
    "dropphyst": "TX",
    "dropphyzpp": 750569997,
    "dropmaladd": "5201 S COLONY BLVD STE 600",
    "dropmalcty": "THE COLONY",
    "dropmalst": "TX",
    "dropmalzpp": 750569997,
    "dropsitphn": 2144675879,
    "dropsitlph": 9723709721,
    "dropsitcph": 9723709721,
    "dropfax": 9723709786
  },
  {
    "dcode": "D",
    "dropkey": 4010397,
    "droptype": "D",
    "dropname": "PALMDALE CARRIER ANNEX",
    "dropdeladd": "38917 20TH ST E STE 701G",
    "dropdelcty": "PALMDALE",
    "dropdelst": "CA",
    "dropdelzpp": 935509605,
    "dropphyadd": "38917 20TH ST E STE 701G",
    "dropphycty": "PALMDALE",
    "dropphyst": "CA",
    "dropphyzpp": 935509605,
    "dropmaladd": "38917 20TH ST E STE 701G",
    "dropmalcty": "PALMDALE",
    "dropmalst": "CA",
    "dropmalzpp": 935509605,
    "dropsitphn": 6617757808,
    "dropsitlph": 6612662504,
    "dropsitcph": 6612662504,
    "dropfax": 6612671128
  },
  {
    "dcode": "D",
    "dropkey": 4010562,
    "droptype": "D",
    "dropname": "BUCKINGHAM CARRIER ANNEX",
    "dropdeladd": "3118 WASHINGTON BLVD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222019993,
    "dropphyadd": "3118 WASHINGTON BLVD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222019993,
    "dropmaladd": "3118 WASHINGTON BLVD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222019993,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039930072,
    "dropsitcph": 7039930072,
    "dropfax": 7032489478
  },
  {
    "dcode": "D",
    "dropkey": 4010781,
    "droptype": "D",
    "dropname": "LENOX HILL NORTH",
    "dropdeladd": "909 3RD AVE STE 400",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100229991,
    "dropphyadd": "909 3RD AVE STE 400",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100229991,
    "dropmaladd": "909 3RD AVE STE 400",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100229991,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305566,
    "dropsitcph": 2123305566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4010782,
    "droptype": "D",
    "dropname": "LENOX HILL SOUTH",
    "dropdeladd": "909 3RD AVE STE 401",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100229992,
    "dropphyadd": "909 3RD AVE STE 401",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100229992,
    "dropmaladd": "909 3RD AVE STE 401",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100229992,
    "dropsitphn": 2123302770,
    "dropsitlph": 2123305566,
    "dropsitcph": 2123305566,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4010858,
    "droptype": "D",
    "dropname": "MONTGOMERY ANNEX",
    "dropdeladd": "21359 EVA ST",
    "dropdelcty": "MONTGOMERY",
    "dropdelst": "TX",
    "dropdelzpp": 773569997,
    "dropphyadd": "21359 EVA ST",
    "dropphycty": "MONTGOMERY",
    "dropphyst": "TX",
    "dropphyzpp": 773569997,
    "dropmaladd": "21359 EVA ST",
    "dropmalcty": "MONTGOMERY",
    "dropmalst": "TX",
    "dropmalzpp": 773569997,
    "dropsitphn": 7132263055,
    "dropsitlph": 9365974222,
    "dropsitcph": 9365974222,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4010913,
    "droptype": "D",
    "dropname": "WATERTOWN ANNEX",
    "dropdeladd": "170 HIGH ST",
    "dropdelcty": "WALTHAM",
    "dropdelst": "MA",
    "dropdelzpp": "024535914",
    "dropphyadd": "170 HIGH ST",
    "dropphycty": "WALTHAM",
    "dropphyst": "MA",
    "dropphyzpp": "024535914",
    "dropmaladd": "170 HIGH ST",
    "dropmalcty": "WALTHAM",
    "dropmalst": "MA",
    "dropmalzpp": "024535914",
    "dropsitphn": 6176545113,
    "dropsitlph": "",
    "dropsitcph": 7818930694,
    "dropfax": 7818990626
  },
  {
    "dcode": "D",
    "dropkey": 4011054,
    "droptype": "D",
    "dropname": "GRAND SHELBY CARR ANX",
    "dropdeladd": "1401 W FORT ST RM M129",
    "dropdelcty": "DETROIT",
    "dropdelst": "MI",
    "dropdelzpp": 482331005,
    "dropphyadd": "1401 W FORT ST RM M129",
    "dropphycty": "DETROIT",
    "dropphyst": "MI",
    "dropphyzpp": 482331005,
    "dropmaladd": "1401 W FORT ST RM M129",
    "dropmalcty": "DETROIT",
    "dropmalst": "MI",
    "dropmalzpp": 482331005,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132255407,
    "dropsitcph": 3132255407,
    "dropfax": 3139635758
  },
  {
    "dcode": "D",
    "dropkey": 4011111,
    "droptype": "D",
    "dropname": "SHAKOPEE CARRIER ANNEX",
    "dropdeladd": "240 SHUMWAY ST S STE 300",
    "dropdelcty": "SHAKOPEE",
    "dropdelst": "MN",
    "dropdelzpp": 553791149,
    "dropphyadd": "240 SHUMWAY ST S STE 300",
    "dropphycty": "SHAKOPEE",
    "dropphyst": "MN",
    "dropphyzpp": 553791149,
    "dropmaladd": "240 SHUMWAY ST S STE 300",
    "dropmalcty": "SHAKOPEE",
    "dropmalst": "MN",
    "dropmalzpp": 553791149,
    "dropsitphn": 6123496399,
    "dropsitlph": "",
    "dropsitcph": 9524451047,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4011136,
    "droptype": "D",
    "dropname": "HAMPSHIRE CARRIER ANNEX",
    "dropdeladd": "225 INDUSTRIAL DR STE 1",
    "dropdelcty": "HAMPSHIRE",
    "dropdelst": "IL",
    "dropdelzpp": 601407911,
    "dropphyadd": "225 INDUSTRIAL DR STE 1",
    "dropphycty": "HAMPSHIRE",
    "dropphyst": "IL",
    "dropphyzpp": 601407911,
    "dropmaladd": "225 INDUSTRIAL DR STE 1",
    "dropmalcty": "HAMPSHIRE",
    "dropmalst": "IL",
    "dropmalzpp": 601407911,
    "dropsitphn": 6302605499,
    "dropsitlph": "",
    "dropsitcph": 8476832636,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4011137,
    "droptype": "D",
    "dropname": "HUNTLEY CARRIER ANNEX",
    "dropdeladd": "10669 WOLF DR",
    "dropdelcty": "HUNTLEY",
    "dropdelst": "IL",
    "dropdelzpp": 601427062,
    "dropphyadd": "10669 WOLF DR",
    "dropphycty": "HUNTLEY",
    "dropphyst": "IL",
    "dropphyzpp": 601427062,
    "dropmaladd": "10669 WOLF DR",
    "dropmalcty": "HUNTLEY",
    "dropmalst": "IL",
    "dropmalzpp": 601427062,
    "dropsitphn": 6302605499,
    "dropsitlph": "",
    "dropsitcph": 8476695423,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4011218,
    "droptype": "D",
    "dropname": "FAIRFIELD DETACHED DEL UNIT",
    "dropdeladd": "325 MERGANSER DR",
    "dropdelcty": "SUISUN CITY",
    "dropdelst": "CA",
    "dropdelzpp": 945853402,
    "dropphyadd": "325 MERGANSER DR",
    "dropphycty": "SUISUN CITY",
    "dropphyst": "CA",
    "dropphyzpp": 945853402,
    "dropmaladd": "600 KENTUCKY ST",
    "dropmalcty": "FAIRFIELD",
    "dropmalst": "CA",
    "dropmalzpp": 945339998,
    "dropsitphn": 5104337569,
    "dropsitlph": "",
    "dropsitcph": 7074258246,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4011292,
    "droptype": "D",
    "dropname": "LANCASTER CARRIER ANNEX",
    "dropdeladd": "1008 W AVENUE J2",
    "dropdelcty": "LANCASTER",
    "dropdelst": "CA",
    "dropdelzpp": 935349998,
    "dropphyadd": "1008 W AVENUE J2",
    "dropphycty": "LANCASTER",
    "dropphyst": "CA",
    "dropphyzpp": 935349998,
    "dropmaladd": "1008 W AVENUE J2",
    "dropmalcty": "LANCASTER",
    "dropmalst": "CA",
    "dropmalzpp": 935349998,
    "dropsitphn": 6617757808,
    "dropsitlph": 6619406101,
    "dropsitcph": 6619406101,
    "dropfax": 6614833999
  },
  {
    "dcode": "D",
    "dropkey": 4011602,
    "droptype": "D",
    "dropname": "HOOD RIVER ANNEX",
    "dropdeladd": "3020 LOWER MILL DR",
    "dropdelcty": "HOOD RIVER",
    "dropdelst": "OR",
    "dropdelzpp": 970318585,
    "dropphyadd": "3020 LOWER MILL DR",
    "dropphycty": "HOOD RIVER",
    "dropphyst": "OR",
    "dropphyzpp": 970318585,
    "dropmaladd": "3020 LOWER MILL DR",
    "dropmalcty": "HOOD RIVER",
    "dropmalst": "OR",
    "dropmalzpp": 970318585,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413549951,
    "dropsitcph": 5413549951,
    "dropfax": 5413546280
  },
  {
    "dcode": "D",
    "dropkey": 4011685,
    "droptype": "D",
    "dropname": "ALPHARETTA CARRIER ANNEX",
    "dropdeladd": "1295 BLUEGRASS LAKES PKWY STE A",
    "dropdelcty": "ALPHARETTA",
    "dropdelst": "GA",
    "dropdelzpp": 300049998,
    "dropphyadd": "1295 BLUEGRASS LAKES PKWY STE A",
    "dropphycty": "ALPHARETTA",
    "dropphyst": "GA",
    "dropphyzpp": 300049998,
    "dropmaladd": "1295 BLUEGRASS LAKES PKWY STE A",
    "dropmalcty": "ALPHARETTA",
    "dropmalst": "GA",
    "dropmalzpp": 300049998,
    "dropsitphn": 4047657578,
    "dropsitlph": 7705212242,
    "dropsitcph": 7705212057,
    "dropfax": 7705212822
  },
  {
    "dcode": "D",
    "dropkey": 4011697,
    "droptype": "D",
    "dropname": "WELLINGTON CARRIER ANNEX",
    "dropdeladd": "3161 FAIRLANE FARMS RD STE 1",
    "dropdelcty": "WELLINGTON",
    "dropdelst": "FL",
    "dropdelzpp": 334149997,
    "dropphyadd": "3161 FAIRLANE FARMS RD STE 1",
    "dropphycty": "WELLINGTON",
    "dropphyst": "FL",
    "dropphyzpp": 334149997,
    "dropmaladd": "3161 FAIRLANE FARMS RD STE 1",
    "dropmalcty": "WELLINGTON",
    "dropmalst": "FL",
    "dropmalzpp": 334149997,
    "dropsitphn": 5617912659,
    "dropsitlph": 5617912659,
    "dropsitcph": 5617912362,
    "dropfax": 5617925831
  },
  {
    "dcode": "D",
    "dropkey": 4011732,
    "droptype": "D",
    "dropname": "WILDOMAR ANNEX",
    "dropdeladd": "21420 PALOMAR ST",
    "dropdelcty": "WILDOMAR",
    "dropdelst": "CA",
    "dropdelzpp": 925959997,
    "dropphyadd": "21420 PALOMAR ST",
    "dropphycty": "WILDOMAR",
    "dropphyst": "CA",
    "dropphyzpp": 925959997,
    "dropmaladd": "21392 PALOMAR ST",
    "dropmalcty": "WILDOMAR",
    "dropmalst": "CA",
    "dropmalzpp": 925959998,
    "dropsitphn": 9093354694,
    "dropsitlph": 9516789013,
    "dropsitcph": 9516789610,
    "dropfax": 9516789561
  },
  {
    "dcode": "D",
    "dropkey": 4011764,
    "droptype": "D",
    "dropname": "LEESBURG ANNEX",
    "dropdeladd": "75 LAWSON RD SE STE 106",
    "dropdelcty": "LEESBURG",
    "dropdelst": "VA",
    "dropdelzpp": 201754425,
    "dropphyadd": "75 LAWSON RD SE STE 106",
    "dropphycty": "LEESBURG",
    "dropphyst": "VA",
    "dropphyzpp": 201754425,
    "dropmaladd": "75 LAWSON RD SE STE 106",
    "dropmalcty": "LEESBURG",
    "dropmalst": "VA",
    "dropmalzpp": 201754425,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037772518,
    "dropsitcph": 7037772518,
    "dropfax": 7037772423
  },
  {
    "dcode": "D",
    "dropkey": 4011826,
    "droptype": "D",
    "dropname": "BARDSTOWN",
    "dropdeladd": "205 W STEPHEN FOSTER AVE",
    "dropdelcty": "BARDSTOWN",
    "dropdelst": "KY",
    "dropdelzpp": 400049998,
    "dropphyadd": "205 W STEPHEN FOSTER AVE",
    "dropphycty": "BARDSTOWN",
    "dropphyst": "KY",
    "dropphyzpp": 400049998,
    "dropmaladd": "205 W STEPHEN FOSTER AVE",
    "dropmalcty": "BARDSTOWN",
    "dropmalst": "KY",
    "dropmalzpp": 400049998,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5023488504,
    "dropfax": 5023485137
  },
  {
    "dcode": "D",
    "dropkey": 4011929,
    "droptype": "D",
    "dropname": "LAKE STEVENS CARRIER ANNEX",
    "dropdeladd": "12101 36TH ST NE",
    "dropdelcty": "LAKE STEVENS",
    "dropdelst": "WA",
    "dropdelzpp": 982589997,
    "dropphyadd": "12101 36TH ST NE",
    "dropphycty": "LAKE STEVENS",
    "dropphyst": "WA",
    "dropphyzpp": 982589997,
    "dropmaladd": "12101 36TH ST NE",
    "dropmalcty": "LAKE STEVENS",
    "dropmalst": "WA",
    "dropmalzpp": 982589997,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253348974,
    "dropsitcph": 4253974904,
    "dropfax": 4253345674
  },
  {
    "dcode": "D",
    "dropkey": 4011954,
    "droptype": "D",
    "dropname": "EAST FRISCO CARRIER ANNEX",
    "dropdeladd": "12580 ROLATER RD",
    "dropdelcty": "FRISCO",
    "dropdelst": "TX",
    "dropdelzpp": 750359997,
    "dropphyadd": "12580 ROLATER RD",
    "dropphycty": "FRISCO",
    "dropphyst": "TX",
    "dropphyzpp": 750359997,
    "dropmaladd": "12580 ROLATER RD",
    "dropmalcty": "FRISCO",
    "dropmalst": "TX",
    "dropmalzpp": 750359997,
    "dropsitphn": 2144675879,
    "dropsitlph": "",
    "dropsitcph": 2144364900,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012043,
    "droptype": "D",
    "dropname": "MOUNT VERNON CARRIER ANNEX",
    "dropdeladd": "1301 BROADWAY ST",
    "dropdelcty": "MOUNT VERNON",
    "dropdelst": "IL",
    "dropdelzpp": 628649997,
    "dropphyadd": "1301 BROADWAY ST",
    "dropphycty": "MOUNT VERNON",
    "dropphyst": "IL",
    "dropphyzpp": 628649997,
    "dropmaladd": "1301 BROADWAY ST",
    "dropmalcty": "MOUNT VERNON",
    "dropmalst": "IL",
    "dropmalzpp": 628649997,
    "dropsitphn": 3148959275,
    "dropsitlph": 6182420640,
    "dropsitcph": 6182420700,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012149,
    "droptype": "D",
    "dropname": "GRAVOIS CARRIER ANNEX",
    "dropdeladd": "4039 BINGHAM AVE",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631169998,
    "dropphyadd": "4039 BINGHAM AVE",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631169998,
    "dropmaladd": "4039 BINGHAM AVE",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631169998,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143531978,
    "dropsitcph": 3143535702,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012157,
    "droptype": "D",
    "dropname": "WARRENTON CARRIER ANNEX",
    "dropdeladd": "7349 COMFORT INN DR",
    "dropdelcty": "WARRENTON",
    "dropdelst": "VA",
    "dropdelzpp": 201879997,
    "dropphyadd": "7349 COMFORT INN DR",
    "dropphycty": "WARRENTON",
    "dropphyst": "VA",
    "dropphyzpp": 201879997,
    "dropmaladd": "7349 COMFORT INN DR",
    "dropmalcty": "WARRENTON",
    "dropmalst": "VA",
    "dropmalzpp": 201879997,
    "dropsitphn": 7036986367,
    "dropsitlph": 5403510137,
    "dropsitcph": 5403510137,
    "dropfax": 5403510193
  },
  {
    "dcode": "D",
    "dropkey": 4012169,
    "droptype": "D",
    "dropname": "SUSSEX COUNTY CARRIER ANNEX",
    "dropdeladd": "35994 ZION CHURCH RD",
    "dropdelcty": "FRANKFORD",
    "dropdelst": "DE",
    "dropdelzpp": 199459997,
    "dropphyadd": "35994 ZION CHURCH RD",
    "dropphycty": "FRANKFORD",
    "dropphyst": "DE",
    "dropphyzpp": 199459997,
    "dropmaladd": "35994 ZION CHURCH RD",
    "dropmalcty": "FRANKFORD",
    "dropmalst": "DE",
    "dropmalzpp": 199459997,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024367311,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012184,
    "droptype": "D",
    "dropname": "NEW BRIGHTON CARRIER ANNEX",
    "dropdeladd": "200 5TH AVE NW",
    "dropdelcty": "SAINT PAUL",
    "dropdelst": "MN",
    "dropdelzpp": 551123388,
    "dropphyadd": "200 5TH AVE NW",
    "dropphycty": "SAINT PAUL",
    "dropphyst": "MN",
    "dropphyzpp": 551123388,
    "dropmaladd": "200 5TH AVE NW",
    "dropmalcty": "SAINT PAUL",
    "dropmalst": "MN",
    "dropmalzpp": 551123388,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516310524,
    "dropsitcph": 6516399306,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012191,
    "droptype": "D",
    "dropname": "LOUISVILLE CARRIER ANX",
    "dropdeladd": "4811 LOUISVILLE AVE",
    "dropdelcty": "LUBBOCK",
    "dropdelst": "TX",
    "dropdelzpp": 794139997,
    "dropphyadd": "4811 LOUISVILLE AVE",
    "dropphycty": "LUBBOCK",
    "dropphyst": "TX",
    "dropphyzpp": 794139997,
    "dropmaladd": "4811 LOUISVILLE AVE",
    "dropmalcty": "LUBBOCK",
    "dropmalst": "TX",
    "dropmalzpp": 794139997,
    "dropsitphn": 8173173658,
    "dropsitlph": 8067917740,
    "dropsitcph": 8067961809,
    "dropfax": 8067910865
  },
  {
    "dcode": "D",
    "dropkey": 4012205,
    "droptype": "D",
    "dropname": "WEST YORK CARRIER ANNEX",
    "dropdeladd": "1250 SMILE WAY",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174049997,
    "dropphyadd": "1250 SMILE WAY",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174049997,
    "dropmaladd": "1250 SMILE WAY",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174049997,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177514609,
    "dropsitcph": 7177514609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012255,
    "droptype": "D",
    "dropname": "WATERLOO ANNEX",
    "dropdeladd": "3314 MARNIE AVE",
    "dropdelcty": "WATERLOO",
    "dropdelst": "IA",
    "dropdelzpp": 507014303,
    "dropphyadd": "3314 MARNIE AVE",
    "dropphycty": "WATERLOO",
    "dropphyst": "IA",
    "dropphyzpp": 507014303,
    "dropmaladd": "3314 MARNIE AVE",
    "dropmalcty": "WATERLOO",
    "dropmalst": "IA",
    "dropmalzpp": 507014303,
    "dropsitphn": 5152837530,
    "dropsitlph": 3192742221,
    "dropsitcph": 3192341240,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012297,
    "droptype": "D",
    "dropname": "JACKSONVILLE BEACH ANNEX",
    "dropdeladd": "1324 BEACH BLVD",
    "dropdelcty": "JACKSONVILLE BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 322503408,
    "dropphyadd": "1324 BEACH BLVD",
    "dropphycty": "JACKSONVILLE BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 322503408,
    "dropmaladd": "1324 BEACH BLVD",
    "dropmalcty": "JACKSONVILLE BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 322503408,
    "dropsitphn": 9043592957,
    "dropsitlph": 9042493006,
    "dropsitcph": 9042495426,
    "dropfax": 9042463339
  },
  {
    "dcode": "D",
    "dropkey": 4012308,
    "droptype": "D",
    "dropname": "NEWBURYPORT CARRIER ANNEX",
    "dropdeladd": "12 MALCOLM HOYT DR",
    "dropdelcty": "NEWBURYPORT",
    "dropdelst": "MA",
    "dropdelzpp": "019509997",
    "dropphyadd": "12 MALCOLM HOYT DR",
    "dropphycty": "NEWBURYPORT",
    "dropphyst": "MA",
    "dropphyzpp": "019509997",
    "dropmaladd": "12 MALCOLM HOYT DR",
    "dropmalcty": "NEWBURYPORT",
    "dropmalst": "MA",
    "dropmalzpp": "019509997",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 9784635489,
    "dropfax": 9784633334
  },
  {
    "dcode": "D",
    "dropkey": 4012330,
    "droptype": "D",
    "dropname": "NEW CASTLE CARRIER ANNEX",
    "dropdeladd": "20 E SOUTH ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161013838,
    "dropphyadd": "20 E SOUTH ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161013838,
    "dropmaladd": "20 E SOUTH ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161013838,
    "dropsitphn": 8148987318,
    "dropsitlph": 7246567221,
    "dropsitcph": 7246523157,
    "dropfax": 7246567205
  },
  {
    "dcode": "D",
    "dropkey": 4012351,
    "droptype": "D",
    "dropname": "TALLEYVILLE CARRIER ANNEX",
    "dropdeladd": "3505 SILVERSIDE RD STE 103",
    "dropdelcty": "WILMINGTON",
    "dropdelst": "DE",
    "dropdelzpp": 198109998,
    "dropphyadd": "3505 SILVERSIDE RD STE 103",
    "dropphycty": "WILMINGTON",
    "dropphyst": "DE",
    "dropphyzpp": 198109998,
    "dropmaladd": "PO BOX 7500",
    "dropmalcty": "WILMINGTON",
    "dropmalst": "DE",
    "dropmalzpp": 198039998,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3024783201,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012451,
    "droptype": "D",
    "dropname": "GREAT NECK CARRIER ANNEX",
    "dropdeladd": "308 E SHORE RD",
    "dropdelcty": "GREAT NECK",
    "dropdelst": "NY",
    "dropdelzpp": 110239996,
    "dropphyadd": "308 E SHORE RD",
    "dropphycty": "GREAT NECK",
    "dropphyst": "NY",
    "dropphyzpp": 110239996,
    "dropmaladd": "308 E SHORE RD",
    "dropmalcty": "GREAT NECK",
    "dropmalst": "NY",
    "dropmalzpp": 110239996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 5164664208,
    "dropfax": 5164666791
  },
  {
    "dcode": "D",
    "dropkey": 4012469,
    "droptype": "D",
    "dropname": "MESQUITE CARRIER SECTION",
    "dropdeladd": "501 E OATES RD",
    "dropdelcty": "GARLAND",
    "dropdelst": "TX",
    "dropdelzpp": 750439997,
    "dropphyadd": "501 E OATES RD",
    "dropphycty": "GARLAND",
    "dropphyst": "TX",
    "dropphyzpp": 750439997,
    "dropmaladd": "501 E OATES RD",
    "dropmalcty": "GARLAND",
    "dropmalst": "TX",
    "dropmalzpp": 750439997,
    "dropsitphn": 2147604376,
    "dropsitlph": "",
    "dropsitcph": 9722884477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012470,
    "droptype": "D",
    "dropname": "BOERNE CARRIER ANNEX",
    "dropdeladd": "6 UPPER BALCONES RD",
    "dropdelcty": "BOERNE",
    "dropdelst": "TX",
    "dropdelzpp": 780069996,
    "dropphyadd": "6 UPPER BALCONES RD",
    "dropphycty": "BOERNE",
    "dropphyst": "TX",
    "dropphyzpp": 780069996,
    "dropmaladd": "6 UPPER BALCONES RD",
    "dropmalcty": "BOERNE",
    "dropmalst": "TX",
    "dropmalzpp": 780069996,
    "dropsitphn": 2103688387,
    "dropsitlph": "",
    "dropsitcph": 8302492414,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012472,
    "droptype": "D",
    "dropname": "BRASELTON HOSCHTON CAX",
    "dropdeladd": "544 JESSE CRONIC RD",
    "dropdelcty": "BRASELTON",
    "dropdelst": "GA",
    "dropdelzpp": 305179997,
    "dropphyadd": "544 JESSE CRONIC RD",
    "dropphycty": "BRASELTON",
    "dropphyst": "GA",
    "dropphyzpp": 305179997,
    "dropmaladd": "544 JESSE CRONIC RD",
    "dropmalcty": "BRASELTON",
    "dropmalst": "GA",
    "dropmalzpp": 305179997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7066549165,
    "dropsitcph": 7066540146,
    "dropfax": 7066549218
  },
  {
    "dcode": "D",
    "dropkey": 4012479,
    "droptype": "D",
    "dropname": "VILLA RICA CAX",
    "dropdeladd": "101 R F D WAY",
    "dropdelcty": "VILLA RICA",
    "dropdelst": "GA",
    "dropdelzpp": 301809997,
    "dropphyadd": "101 R F D WAY",
    "dropphycty": "VILLA RICA",
    "dropphyst": "GA",
    "dropphyzpp": 301809997,
    "dropmaladd": "101 R F D WAY",
    "dropmalcty": "VILLA RICA",
    "dropmalst": "GA",
    "dropmalzpp": 301809997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7704562813,
    "dropsitcph": 7704562811,
    "dropfax": 7704562814
  },
  {
    "dcode": "D",
    "dropkey": 4012480,
    "droptype": "D",
    "dropname": "LAWRENCEVILLE CARRIER ANNEX",
    "dropdeladd": "748 WINER INDUSTRIAL WAY",
    "dropdelcty": "LAWRENCEVILLE",
    "dropdelst": "GA",
    "dropdelzpp": 300469997,
    "dropphyadd": "748 WINER INDUSTRIAL WAY",
    "dropphycty": "LAWRENCEVILLE",
    "dropphyst": "GA",
    "dropphyzpp": 300469997,
    "dropmaladd": "748 WINER INDUSTRIAL WAY",
    "dropmalcty": "LAWRENCEVILLE",
    "dropmalst": "GA",
    "dropmalzpp": 300469997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7708222724,
    "dropsitcph": 7708224408,
    "dropfax": 7708224457
  },
  {
    "dcode": "D",
    "dropkey": 4012487,
    "droptype": "D",
    "dropname": "BLUFFTON CARRIER ANNEX",
    "dropdeladd": "208 RED OAKS WAY",
    "dropdelcty": "OKATIE",
    "dropdelst": "SC",
    "dropdelzpp": 299099998,
    "dropphyadd": "208 RED OAKS WAY",
    "dropphycty": "OKATIE",
    "dropphyst": "SC",
    "dropphyzpp": 299099998,
    "dropmaladd": "208 RED OAKS WAY",
    "dropmalcty": "OKATIE",
    "dropmalst": "SC",
    "dropmalzpp": 299099998,
    "dropsitphn": 4787528466,
    "dropsitlph": 8437575857,
    "dropsitcph": 8437575857,
    "dropfax": 8437578812
  },
  {
    "dcode": "D",
    "dropkey": 4012488,
    "droptype": "D",
    "dropname": "ELK RIVER CARRIER ANNEX",
    "dropdeladd": "560 3RD ST NW",
    "dropdelcty": "ELK RIVER",
    "dropdelst": "MN",
    "dropdelzpp": 553301409,
    "dropphyadd": "560 3RD ST NW",
    "dropphycty": "ELK RIVER",
    "dropphyst": "MN",
    "dropphyzpp": 553301409,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "ELK RIVER",
    "dropmalst": "MN",
    "dropmalzpp": 553309998,
    "dropsitphn": 6123496399,
    "dropsitlph": 6123496348,
    "dropsitcph": 7632415297,
    "dropfax": 7632419983
  },
  {
    "dcode": "D",
    "dropkey": 4012489,
    "droptype": "D",
    "dropname": "LAND O LAKES CARRIER ANNEX",
    "dropdeladd": "5875 EHREN CUTOFF",
    "dropdelcty": "LAND O LAKES",
    "dropdelst": "FL",
    "dropdelzpp": 346393423,
    "dropphyadd": "5875 EHREN CUTOFF",
    "dropphycty": "LAND O LAKES",
    "dropphyst": "FL",
    "dropphyzpp": 346393423,
    "dropmaladd": "5875 EHREN CUTOFF",
    "dropmalcty": "LAND O LAKES",
    "dropmalst": "FL",
    "dropmalzpp": 346393423,
    "dropsitphn": 8138770683,
    "dropsitlph": 8138770637,
    "dropsitcph": 8139961257,
    "dropfax": 8139959173
  },
  {
    "dcode": "D",
    "dropkey": 4012490,
    "droptype": "D",
    "dropname": "SARASOTA CARRIER ANNEX",
    "dropdeladd": "6552 PALMER PARK CIR",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342387700,
    "dropphyadd": "6552 PALMER PARK CIR",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342387700,
    "dropmaladd": "6552 PALMER PARK CIR",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342387700,
    "dropsitphn": 8138770788,
    "dropsitlph": 9413595162,
    "dropsitcph": 9419215666,
    "dropfax": 9419212413
  },
  {
    "dcode": "D",
    "dropkey": 4012498,
    "droptype": "D",
    "dropname": "MONROE CAX",
    "dropdeladd": "200 SARATOGA DR",
    "dropdelcty": "MONROE",
    "dropdelst": "GA",
    "dropdelzpp": 306569997,
    "dropphyadd": "200 SARATOGA DR",
    "dropphycty": "MONROE",
    "dropphyst": "GA",
    "dropphyzpp": 306569997,
    "dropmaladd": "200 SARATOGA DR",
    "dropmalcty": "MONROE",
    "dropmalst": "GA",
    "dropmalzpp": 306569997,
    "dropsitphn": 4047657578,
    "dropsitlph": 7702679139,
    "dropsitcph": 7702673376,
    "dropfax": 7702678799
  },
  {
    "dcode": "D",
    "dropkey": 4012544,
    "droptype": "D",
    "dropname": "OCOEE CARRIER ANNEX",
    "dropdeladd": "425 OCOEE APOPKA RD",
    "dropdelcty": "OCOEE",
    "dropdelst": "FL",
    "dropdelzpp": 347619996,
    "dropphyadd": "425 OCOEE APOPKA RD",
    "dropphycty": "OCOEE",
    "dropphyst": "FL",
    "dropphyzpp": 347619996,
    "dropmaladd": "425 OCOEE APOPKA RD",
    "dropmalcty": "OCOEE",
    "dropmalst": "FL",
    "dropmalzpp": 347619996,
    "dropsitphn": 4076569447,
    "dropsitlph": 4076569447,
    "dropsitcph": 4076549581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012556,
    "droptype": "D",
    "dropname": "MADISON HTS CARRIER ANNEX",
    "dropdeladd": "2351 BELLINGHAM DR",
    "dropdelcty": "TROY",
    "dropdelst": "MI",
    "dropdelzpp": 480839005,
    "dropphyadd": "2351 BELLINGHAM DR",
    "dropphycty": "TROY",
    "dropphyst": "MI",
    "dropphyzpp": 480839005,
    "dropmaladd": "2351 BELLINGHAM DR",
    "dropmalcty": "TROY",
    "dropmalst": "MI",
    "dropmalzpp": 480839005,
    "dropsitphn": 2485246910,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485246910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012578,
    "droptype": "D",
    "dropname": "BARNEGAT CARRIER ANNEX",
    "dropdeladd": "685 E BAY AVE",
    "dropdelcty": "BARNEGAT",
    "dropdelst": "NJ",
    "dropdelzpp": "080059997",
    "dropphyadd": "685 E BAY AVE",
    "dropphycty": "BARNEGAT",
    "dropphyst": "NJ",
    "dropphyzpp": "080059997",
    "dropmaladd": "685 E BAY AVE",
    "dropmalcty": "BARNEGAT",
    "dropmalst": "NJ",
    "dropmalzpp": "080059997",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096600158,
    "dropsitcph": 6096980101,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012599,
    "droptype": "D",
    "dropname": "CLINTON MACOMB ANNEX",
    "dropdeladd": "15285 SAMOHIN DR",
    "dropdelcty": "MACOMB",
    "dropdelst": "MI",
    "dropdelzpp": 480449991,
    "dropphyadd": "15285 SAMOHIN DR",
    "dropphycty": "MACOMB",
    "dropphyst": "MI",
    "dropphyzpp": 480449991,
    "dropmaladd": "15285 SAMOHIN DR",
    "dropmalcty": "MACOMB",
    "dropmalst": "MI",
    "dropmalzpp": 480449991,
    "dropsitphn": 5867832879,
    "dropsitlph": 2487585622,
    "dropsitcph": 5862264023,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012716,
    "droptype": "D",
    "dropname": "MONROE ANNEX",
    "dropdeladd": "1639 DICKERSON BLVD",
    "dropdelcty": "MONROE",
    "dropdelst": "NC",
    "dropdelzpp": 281102765,
    "dropphyadd": "1639 DICKERSON BLVD",
    "dropphycty": "MONROE",
    "dropphyst": "NC",
    "dropphyzpp": 281102765,
    "dropmaladd": "1639 DICKERSON BLVD",
    "dropmalcty": "MONROE",
    "dropmalst": "NC",
    "dropmalzpp": 281102765,
    "dropsitphn": 7043934581,
    "dropsitlph": 7042832565,
    "dropsitcph": 7042832565,
    "dropfax": 7042894507
  },
  {
    "dcode": "D",
    "dropkey": 4012846,
    "droptype": "D",
    "dropname": "WICKER PARK CARRIER ANNEX",
    "dropdeladd": "1419 W CARROLL AVE STE 1",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606079998,
    "dropphyadd": "1419 W CARROLL AVE STE 1",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606079998,
    "dropmaladd": "1419 W CARROLL AVE STE 1",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606079998,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3122434706,
    "dropfax": 3122434932
  },
  {
    "dcode": "D",
    "dropkey": 4012870,
    "droptype": "D",
    "dropname": "TOWNSEND CARRIER ANNEX",
    "dropdeladd": "550 TOWNSEND ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941039992,
    "dropphyadd": "550 TOWNSEND ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941039992,
    "dropmaladd": "550 TOWNSEND ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941039992,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156262932,
    "dropsitcph": 4156262932,
    "dropfax": 4156266197
  },
  {
    "dcode": "D",
    "dropkey": 4012917,
    "droptype": "D",
    "dropname": "FIESTA ANNEX",
    "dropdeladd": "2191 W OBISPO AVE",
    "dropdelcty": "GILBERT",
    "dropdelst": "AZ",
    "dropdelzpp": 852339998,
    "dropphyadd": "2191 W OBISPO AVE",
    "dropphycty": "GILBERT",
    "dropphyst": "AZ",
    "dropphyzpp": 852339998,
    "dropmaladd": "2191 W OBISPO AVE",
    "dropmalcty": "GILBERT",
    "dropmalst": "AZ",
    "dropmalzpp": 852339998,
    "dropsitphn": 6022253214,
    "dropsitlph": 4805451280,
    "dropsitcph": 4805451058,
    "dropfax": 4805451768
  },
  {
    "dcode": "D",
    "dropkey": 4012976,
    "droptype": "D",
    "dropname": "TRI CITY GAINESVILLE",
    "dropdeladd": "7645 LIMESTONE DR",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "VA",
    "dropdelzpp": 201559997,
    "dropphyadd": "7645 LIMESTONE DR",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "VA",
    "dropphyzpp": 201559997,
    "dropmaladd": "7645 LIMESTONE DR",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "VA",
    "dropmalzpp": 201559997,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037531865,
    "dropsitcph": 5712486701,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4012996,
    "droptype": "D",
    "dropname": "FTL MO CARRIER ANX",
    "dropdeladd": "1900 W OAKLAND PARK BLVD STE 105",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333109996,
    "dropphyadd": "1900 W OAKLAND PARK BLVD STE 105",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333109996,
    "dropmaladd": "1900 W OAKLAND PARK BLVD STE 105",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333109996,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545276990,
    "dropsitcph": 9545272054,
    "dropfax": 9545276994
  },
  {
    "dcode": "D",
    "dropkey": 4013003,
    "droptype": "D",
    "dropname": "BASTROP CARRIER ANNEX",
    "dropdeladd": "1114 MAIN ST",
    "dropdelcty": "BASTROP",
    "dropdelst": "TX",
    "dropdelzpp": 786023219,
    "dropphyadd": "1114 MAIN ST",
    "dropphycty": "BASTROP",
    "dropphyst": "TX",
    "dropphyzpp": 786023219,
    "dropmaladd": "1114 MAIN ST",
    "dropmalcty": "BASTROP",
    "dropmalst": "TX",
    "dropmalzpp": 786023219,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123037516,
    "dropsitcph": 5123037516,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013013,
    "droptype": "D",
    "dropname": "MARICOPA CARRIER ANNEX",
    "dropdeladd": "40435 W HONEYCUTT RD",
    "dropdelcty": "MARICOPA",
    "dropdelst": "AZ",
    "dropdelzpp": 851389997,
    "dropphyadd": "40435 W HONEYCUTT RD",
    "dropphycty": "MARICOPA",
    "dropphyst": "AZ",
    "dropphyzpp": 851389997,
    "dropmaladd": "40435 W HONEYCUTT RD",
    "dropmalcty": "MARICOPA",
    "dropmalst": "AZ",
    "dropmalzpp": 851389997,
    "dropsitphn": 6022253214,
    "dropsitlph": 5205682252,
    "dropsitcph": 5205682641,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013130,
    "droptype": "D",
    "dropname": "WAREHAM ANNEX",
    "dropdeladd": "25 TOBEY RD",
    "dropdelcty": "WAREHAM",
    "dropdelst": "MA",
    "dropdelzpp": "025711098",
    "dropphyadd": "25 TOBEY RD",
    "dropphycty": "WAREHAM",
    "dropphyst": "MA",
    "dropphyzpp": "025711098",
    "dropmaladd": "25 TOBEY RD",
    "dropmalcty": "WAREHAM",
    "dropmalst": "MA",
    "dropmalzpp": "025711098",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5082918700,
    "dropfax": 5082918700
  },
  {
    "dcode": "D",
    "dropkey": 4013142,
    "droptype": "D",
    "dropname": "VAIL ANNEX",
    "dropdeladd": "13333 E COLOSSAL CAVE RD",
    "dropdelcty": "VAIL",
    "dropdelst": "AZ",
    "dropdelzpp": 856416832,
    "dropphyadd": "13333 E COLOSSAL CAVE RD",
    "dropphycty": "VAIL",
    "dropphyst": "AZ",
    "dropphyzpp": 856416832,
    "dropmaladd": "13333 E COLOSSAL CAVE RD",
    "dropmalcty": "VAIL",
    "dropmalst": "AZ",
    "dropmalzpp": 856416832,
    "dropsitphn": 5203885019,
    "dropsitlph": 5207629088,
    "dropsitcph": 5207625052,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013149,
    "droptype": "D",
    "dropname": "BRAINTREE CARRIER ANNEX",
    "dropdeladd": "333 COMMERCE DR",
    "dropdelcty": "BRAINTREE",
    "dropdelst": "MA",
    "dropdelzpp": "021849998",
    "dropphyadd": "333 COMMERCE DR",
    "dropphycty": "BRAINTREE",
    "dropphyst": "MA",
    "dropphyzpp": "021849998",
    "dropmaladd": "333 COMMERCE DR",
    "dropmalcty": "BRAINTREE",
    "dropmalst": "MA",
    "dropmalzpp": "021849998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813563912,
    "dropfax": 7813561732
  },
  {
    "dcode": "D",
    "dropkey": 4013153,
    "droptype": "D",
    "dropname": "NEWTOWN SQ CARRIER ANNEX",
    "dropdeladd": "4607 W CHESTER PIKE",
    "dropdelcty": "NEWTOWN SQUARE",
    "dropdelst": "PA",
    "dropdelzpp": 190739998,
    "dropphyadd": "4607 W CHESTER PIKE",
    "dropphycty": "NEWTOWN SQUARE",
    "dropphyst": "PA",
    "dropphyzpp": 190739998,
    "dropmaladd": "4607 W CHESTER PIKE",
    "dropmalcty": "NEWTOWN SQUARE",
    "dropmalst": "PA",
    "dropmalzpp": 190739998,
    "dropsitphn": 6103550782,
    "dropsitlph": 6103550783,
    "dropsitcph": 6103550782,
    "dropfax": 6103550784
  },
  {
    "dcode": "D",
    "dropkey": 4013167,
    "droptype": "D",
    "dropname": "SOQUEL CARRIER ANNEX",
    "dropdeladd": "4746 SOQUEL DR",
    "dropdelcty": "SOQUEL",
    "dropdelst": "CA",
    "dropdelzpp": 950732456,
    "dropphyadd": "4746 SOQUEL DR",
    "dropphycty": "SOQUEL",
    "dropphyst": "CA",
    "dropphyzpp": 950732456,
    "dropmaladd": "4768 SOQUEL DR",
    "dropmalcty": "SOQUEL",
    "dropmalst": "CA",
    "dropmalzpp": 950732450,
    "dropsitphn": 4084376726,
    "dropsitlph": 8314628551,
    "dropsitcph": 8314628551,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013214,
    "droptype": "D",
    "dropname": "BRANSON  CARRIER ANNEX",
    "dropdeladd": "141 INDUSTRIAL PARK DR",
    "dropdelcty": "HOLLISTER",
    "dropdelst": "MO",
    "dropdelzpp": 656725392,
    "dropphyadd": "141 INDUSTRIAL PARK DR",
    "dropphycty": "HOLLISTER",
    "dropphyst": "MO",
    "dropphyzpp": 656725392,
    "dropmaladd": "141 INDUSTRIAL PARK DR",
    "dropmalcty": "HOLLISTER",
    "dropmalst": "MO",
    "dropmalzpp": 656725392,
    "dropsitphn": 8165043362,
    "dropsitlph": 4173354089,
    "dropsitcph": 4173354089,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013216,
    "droptype": "D",
    "dropname": "MENDELL CARRIER ANNEX",
    "dropdeladd": "151 MENDELL ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941249900,
    "dropphyadd": "151 MENDELL ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941249900,
    "dropmaladd": "151 MENDELL ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941249900,
    "dropsitphn": 4155505045,
    "dropsitlph": 4156433790,
    "dropsitcph": 4156433790,
    "dropfax": 4156418742
  },
  {
    "dcode": "D",
    "dropkey": 4013305,
    "droptype": "D",
    "dropname": "SEAPINES CARRIER ANNEX",
    "dropdeladd": "2652 PRODUCTION RD STE B",
    "dropdelcty": "VIRGINIA BEACH",
    "dropdelst": "VA",
    "dropdelzpp": 234549997,
    "dropphyadd": "2652 PRODUCTION RD STE B",
    "dropphycty": "VIRGINIA BEACH",
    "dropphyst": "VA",
    "dropphyzpp": 234549997,
    "dropmaladd": "2652 PRODUCTION RD STE B",
    "dropmalcty": "VIRGINIA BEACH",
    "dropmalst": "VA",
    "dropmalzpp": 234549997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575989816,
    "dropsitcph": 7574868655,
    "dropfax": 7574980684
  },
  {
    "dcode": "D",
    "dropkey": 4013329,
    "droptype": "D",
    "dropname": "NAPOLEON STREET CARRIER CPLX",
    "dropdeladd": "180 NAPOLEON ST",
    "dropdelcty": "SAN FRANCISCO",
    "dropdelst": "CA",
    "dropdelzpp": 941249711,
    "dropphyadd": "180 NAPOLEON ST",
    "dropphycty": "SAN FRANCISCO",
    "dropphyst": "CA",
    "dropphyzpp": 941249711,
    "dropmaladd": "180 NAPOLEON ST",
    "dropmalcty": "SAN FRANCISCO",
    "dropmalst": "CA",
    "dropmalzpp": 941249711,
    "dropsitphn": 4155505045,
    "dropsitlph": 4152854662,
    "dropsitcph": 4152854662,
    "dropfax": 4152853010
  },
  {
    "dcode": "D",
    "dropkey": 4013332,
    "droptype": "D",
    "dropname": "EAST NAPLES CARRIER ANNEX",
    "dropdeladd": "3573 PROGRESS AVE",
    "dropdelcty": "NAPLES",
    "dropdelst": "FL",
    "dropdelzpp": 341049998,
    "dropphyadd": "3573 PROGRESS AVE",
    "dropphycty": "NAPLES",
    "dropphyst": "FL",
    "dropphyzpp": 341049998,
    "dropmaladd": "3573 PROGRESS AVE",
    "dropmalcty": "NAPLES",
    "dropmalst": "FL",
    "dropmalzpp": 341049998,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2396431840,
    "dropfax": 2396436623
  },
  {
    "dcode": "D",
    "dropkey": 4013412,
    "droptype": "D",
    "dropname": "BALCH SPRINGS CARRIER ANNEX",
    "dropdeladd": "120 E GRUBB DR",
    "dropdelcty": "MESQUITE",
    "dropdelst": "TX",
    "dropdelzpp": 751499996,
    "dropphyadd": "120 E GRUBB DR",
    "dropphycty": "MESQUITE",
    "dropphyst": "TX",
    "dropphyzpp": 751499996,
    "dropmaladd": "120 E GRUBB DR",
    "dropmalcty": "MESQUITE",
    "dropmalst": "TX",
    "dropmalzpp": 751499996,
    "dropsitphn": 2147604376,
    "dropsitlph": "",
    "dropsitcph": 9722884477,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4013428,
    "droptype": "D",
    "dropname": "SOUTHERN MAINE CARRIER UNIT",
    "dropdeladd": "79 POSTAL SERVICE WAY RM 1058",
    "dropdelcty": "SCARBOROUGH",
    "dropdelst": "ME",
    "dropdelzpp": "040747085",
    "dropphyadd": "79 POSTAL SERVICE WAY RM 1058",
    "dropphycty": "SCARBOROUGH",
    "dropphyst": "ME",
    "dropphyzpp": "040747085",
    "dropmaladd": "79 POSTAL SERVICE WAY RM 1058",
    "dropmalcty": "SCARBOROUGH",
    "dropmalst": "ME",
    "dropmalzpp": "040747085",
    "dropsitphn": 2075102795,
    "dropsitlph": 2075102772,
    "dropsitcph": 2075102772,
    "dropfax": 2075102736
  },
  {
    "dcode": "D",
    "dropkey": 4013525,
    "droptype": "D",
    "dropname": "BLOOMINGTON ANNEX",
    "dropdeladd": "4738 W VERNAL PIKE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474049997,
    "dropphyadd": "4738 W VERNAL PIKE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474049997,
    "dropmaladd": "4738 W VERNAL PIKE",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474049997,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123314544,
    "dropfax": 8123490394
  },
  {
    "dcode": "D",
    "dropkey": 4013947,
    "droptype": "D",
    "dropname": "BURLINGAME CARRIER ANNEX",
    "dropdeladd": "1625 ROLLINS RD",
    "dropdelcty": "BURLINGAME",
    "dropdelst": "CA",
    "dropdelzpp": 940109997,
    "dropphyadd": "1625 ROLLINS RD",
    "dropphycty": "BURLINGAME",
    "dropphyst": "CA",
    "dropphyzpp": 940109997,
    "dropmaladd": "1625 ROLLINS RD",
    "dropmalcty": "BURLINGAME",
    "dropmalst": "CA",
    "dropmalzpp": 940109997,
    "dropsitphn": 6505521039,
    "dropsitlph": 6505521038,
    "dropsitcph": 6505521039,
    "dropfax": 6505521091
  },
  {
    "dcode": "D",
    "dropkey": 4014153,
    "droptype": "D",
    "dropname": "LEWISBURG CARRIER ANNEX",
    "dropdeladd": "2013 W MARKET ST",
    "dropdelcty": "LEWISBURG",
    "dropdelst": "PA",
    "dropdelzpp": 178376801,
    "dropphyadd": "2013 W MARKET ST",
    "dropphycty": "LEWISBURG",
    "dropphyst": "PA",
    "dropphyzpp": 178376801,
    "dropmaladd": "2013 W MARKET ST",
    "dropmalcty": "LEWISBURG",
    "dropmalst": "PA",
    "dropmalzpp": 178376801,
    "dropsitphn": 7172574870,
    "dropsitlph": "",
    "dropsitcph": 5705240038,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014212,
    "droptype": "D",
    "dropname": "EADS CARRIER ANNEX",
    "dropdeladd": "2565 S SHIRLINGTON RD",
    "dropdelcty": "ARLINGTON",
    "dropdelst": "VA",
    "dropdelzpp": 222069991,
    "dropphyadd": "2565 S SHIRLINGTON RD",
    "dropphycty": "ARLINGTON",
    "dropphyst": "VA",
    "dropphyzpp": 222069991,
    "dropmaladd": "2565 S SHIRLINGTON RD",
    "dropmalcty": "ARLINGTON",
    "dropmalst": "VA",
    "dropmalzpp": 222069991,
    "dropsitphn": 7036986867,
    "dropsitlph": 7039795456,
    "dropsitcph": 7039795456,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014256,
    "droptype": "D",
    "dropname": "BON AIR CARRIER ANNEX",
    "dropdeladd": "7501 LADY BLAIR LN",
    "dropdelcty": "NORTH CHESTERFIELD",
    "dropdelst": "VA",
    "dropdelzpp": 232369997,
    "dropphyadd": "7501 LADY BLAIR LN",
    "dropphycty": "NORTH CHESTERFIELD",
    "dropphyst": "VA",
    "dropphyzpp": 232369997,
    "dropmaladd": "7501 LADY BLAIR LN",
    "dropmalcty": "NORTH CHESTERFIELD",
    "dropmalst": "VA",
    "dropmalzpp": 232369997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042723845,
    "dropsitcph": 8042723845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014275,
    "droptype": "D",
    "dropname": "EAST END CARRIER ANNEX",
    "dropdeladd": "5300 KLOCKNER DR",
    "dropdelcty": "HENRICO",
    "dropdelst": "VA",
    "dropdelzpp": 232319997,
    "dropphyadd": "5300 KLOCKNER DR",
    "dropphycty": "HENRICO",
    "dropphyst": "VA",
    "dropphyzpp": 232319997,
    "dropmaladd": "5300 KLOCKNER DR",
    "dropmalcty": "HENRICO",
    "dropmalst": "VA",
    "dropmalzpp": 232319997,
    "dropsitphn": 8047756336,
    "dropsitlph": 8042262759,
    "dropsitcph": 8042262759,
    "dropfax": 8042266416
  },
  {
    "dcode": "D",
    "dropkey": 4014289,
    "droptype": "D",
    "dropname": "NORFOLK 10 CARRIER ANNEX",
    "dropdeladd": "2655 TIDEWATER DR",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235099996,
    "dropphyadd": "2655 TIDEWATER DR",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235099996,
    "dropmaladd": "2655 TIDEWATER DR",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235099996,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576249454,
    "dropsitcph": 7576249479,
    "dropfax": 7576253236
  },
  {
    "dcode": "D",
    "dropkey": 4014290,
    "droptype": "D",
    "dropname": "NORFOLK 04 CARRIER ANNEX",
    "dropdeladd": "2655 TIDEWATER DR",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235099997,
    "dropphyadd": "2655 TIDEWATER DR",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235099997,
    "dropmaladd": "2655 TIDEWATER DR",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235099997,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576249454,
    "dropsitcph": 7576249479,
    "dropfax": 7576253236
  },
  {
    "dcode": "D",
    "dropkey": 4014313,
    "droptype": "D",
    "dropname": "PARKFAIRFAX CARRIER ANNEX",
    "dropdeladd": "2226 DUKE ST",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223149098,
    "dropphyadd": "2226 DUKE ST",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223149098,
    "dropmaladd": "2226 DUKE ST",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223149098,
    "dropsitphn": 7036986367,
    "dropsitlph": 7035492452,
    "dropsitcph": 7035492452,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014408,
    "droptype": "D",
    "dropname": "PALM BCH CARRIER ANX",
    "dropdeladd": "1040 OKEECHOBEE RD STE 100",
    "dropdelcty": "WEST PALM BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 334019992,
    "dropphyadd": "1040 OKEECHOBEE RD STE 100",
    "dropphycty": "WEST PALM BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 334019992,
    "dropmaladd": "1040 OKEECHOBEE RD STE 100",
    "dropmalcty": "WEST PALM BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 334019992,
    "dropsitphn": 5618059771,
    "dropsitlph": 5618327983,
    "dropsitcph": 5618328614,
    "dropfax": 5618329063
  },
  {
    "dcode": "D",
    "dropkey": 4014409,
    "droptype": "D",
    "dropname": "FIFE CARRIER ANNEX",
    "dropdeladd": "1421 52ND AVE E",
    "dropdelcty": "FIFE",
    "dropdelst": "WA",
    "dropdelzpp": 984241221,
    "dropphyadd": "1421 52ND AVE E",
    "dropphycty": "FIFE",
    "dropphyst": "WA",
    "dropphyzpp": 984241221,
    "dropmaladd": "1421 52ND AVE E",
    "dropmalcty": "FIFE",
    "dropmalst": "WA",
    "dropmalzpp": 984241221,
    "dropsitphn": 2067684422,
    "dropsitlph": 2539225072,
    "dropsitcph": 2539225072,
    "dropfax": 6514566176
  },
  {
    "dcode": "D",
    "dropkey": 4014446,
    "droptype": "D",
    "dropname": "PIKESVILLE CARRIER ANNEX",
    "dropdeladd": "3703 OLD COURT RD",
    "dropdelcty": "PIKESVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 212089998,
    "dropphyadd": "3703 OLD COURT RD",
    "dropphycty": "PIKESVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 212089998,
    "dropmaladd": "3703 OLD COURT RD",
    "dropmalcty": "PIKESVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 212089998,
    "dropsitphn": 4103474587,
    "dropsitlph": 4104842364,
    "dropsitcph": 4104842364,
    "dropfax": 4106021199
  },
  {
    "dcode": "D",
    "dropkey": 4014525,
    "droptype": "D",
    "dropname": "WESTSIDE",
    "dropdeladd": "4025 W RENO AVE",
    "dropdelcty": "OKLAHOMA CITY",
    "dropdelst": "OK",
    "dropdelzpp": 731259402,
    "dropphyadd": "4025 W RENO AVE",
    "dropphycty": "OKLAHOMA CITY",
    "dropphyst": "OK",
    "dropphyzpp": 731259402,
    "dropmaladd": "4025 W RENO AVE",
    "dropmalcty": "OKLAHOMA CITY",
    "dropmalst": "OK",
    "dropmalzpp": 731259402,
    "dropsitphn": 4058152724,
    "dropsitlph": 4058152913,
    "dropsitcph": 4058152913,
    "dropfax": 4058152036
  },
  {
    "dcode": "D",
    "dropkey": 4014531,
    "droptype": "D",
    "dropname": "MINUET ANNEX",
    "dropdeladd": "430 MINUET LN",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282179700,
    "dropphyadd": "430 MINUET LN",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282179700,
    "dropmaladd": "430 MINUET LN",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282179700,
    "dropsitphn": 7043934581,
    "dropsitlph": 7045223842,
    "dropsitcph": 7045223842,
    "dropfax": 7045236739
  },
  {
    "dcode": "D",
    "dropkey": 4014546,
    "droptype": "D",
    "dropname": "CHELSEA CARRIER ANNEX",
    "dropdeladd": "307 BEACHAM ST",
    "dropdelcty": "CHELSEA",
    "dropdelst": "MA",
    "dropdelzpp": "021509998",
    "dropphyadd": "307 BEACHAM ST",
    "dropphycty": "CHELSEA",
    "dropphyst": "MA",
    "dropphyzpp": "021509998",
    "dropmaladd": "307 BEACHAM ST",
    "dropmalcty": "CHELSEA",
    "dropmalst": "MA",
    "dropmalzpp": "021509998",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6178849348,
    "dropfax": 6178891950
  },
  {
    "dcode": "D",
    "dropkey": 4014596,
    "droptype": "D",
    "dropname": "BELLEVUE CARRIER ANNEX",
    "dropdeladd": "13400 SE 30TH ST",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "WA",
    "dropdelzpp": 980054406,
    "dropphyadd": "13400 SE 30TH ST",
    "dropphycty": "BELLEVUE",
    "dropphyst": "WA",
    "dropphyzpp": 980054406,
    "dropmaladd": "13400 SE 30TH ST",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "WA",
    "dropmalzpp": 980054406,
    "dropsitphn": 2067684422,
    "dropsitlph": 4256438351,
    "dropsitcph": 4256438351,
    "dropfax": 6514566583
  },
  {
    "dcode": "D",
    "dropkey": 4014728,
    "droptype": "D",
    "dropname": "PENNSYLVANIA STATION",
    "dropdeladd": "900 PENNSYLVANIA AVE STE 1",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152331400,
    "dropphyadd": "900 PENNSYLVANIA AVE STE 1",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152331400,
    "dropmaladd": "900 PENNSYLVANIA AVE STE 1",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152331400,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123597859,
    "dropsitcph": 4123597859,
    "dropfax": 4123211392
  },
  {
    "dcode": "D",
    "dropkey": 4014826,
    "droptype": "D",
    "dropname": "FALLS CHURCH 43 ANNEX",
    "dropdeladd": "2920 ESKRIDGE RD",
    "dropdelcty": "FAIRFAX",
    "dropdelst": "VA",
    "dropdelzpp": 220312251,
    "dropphyadd": "2920 ESKRIDGE RD",
    "dropphycty": "FAIRFAX",
    "dropphyst": "VA",
    "dropphyzpp": 220312251,
    "dropmaladd": "2920 ESKRIDGE RD",
    "dropmalcty": "FAIRFAX",
    "dropmalst": "VA",
    "dropmalzpp": 220312251,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039986826,
    "dropsitcph": 7039986826,
    "dropfax": 7032073711
  },
  {
    "dcode": "D",
    "dropkey": 4014866,
    "droptype": "D",
    "dropname": "CENTRAL",
    "dropdeladd": "430 BROADWAY ST",
    "dropdelcty": "TOLEDO",
    "dropdelst": "OH",
    "dropdelzpp": 436049998,
    "dropphyadd": "430 BROADWAY ST",
    "dropphycty": "TOLEDO",
    "dropphyst": "OH",
    "dropphyzpp": 436049998,
    "dropmaladd": "430 BROADWAY ST",
    "dropmalcty": "TOLEDO",
    "dropmalst": "OH",
    "dropmalzpp": 436049998,
    "dropsitphn": 5136845763,
    "dropsitlph": 4192542381,
    "dropsitcph": 4192542381,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014924,
    "droptype": "D",
    "dropname": "SILVER SPRING MPO CARR ANNEX",
    "dropdeladd": "8827 MONARD DR",
    "dropdelcty": "SILVER SPRING",
    "dropdelst": "MD",
    "dropdelzpp": 209109996,
    "dropphyadd": "8827 MONARD DR",
    "dropphycty": "SILVER SPRING",
    "dropphyst": "MD",
    "dropphyzpp": 209109996,
    "dropmaladd": "8827 MONARD DR",
    "dropmalcty": "SILVER SPRING",
    "dropmalst": "MD",
    "dropmalzpp": 209109996,
    "dropsitphn": 3014997331,
    "dropsitlph": 3015854947,
    "dropsitcph": 3016083673,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4014976,
    "droptype": "D",
    "dropname": "SERRA MESA ANNEX",
    "dropdeladd": "3245 GREYLING DR",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921239997,
    "dropphyadd": "3245 GREYLING DR",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921239997,
    "dropmaladd": "3223 GREYLING DR",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921239998,
    "dropsitphn": 8586740173,
    "dropsitlph": 8582777879,
    "dropsitcph": 8582774903,
    "dropfax": 8582778746
  },
  {
    "dcode": "D",
    "dropkey": 4015083,
    "droptype": "D",
    "dropname": "MARINERS HARBOR",
    "dropdeladd": "2980 RICHMOND TER",
    "dropdelcty": "STATEN ISLAND",
    "dropdelst": "NY",
    "dropdelzpp": 103039997,
    "dropphyadd": "2980 RICHMOND TER",
    "dropphycty": "STATEN ISLAND",
    "dropphyst": "NY",
    "dropphyzpp": 103039997,
    "dropmaladd": "2980 RICHMOND TER",
    "dropmalcty": "STATEN ISLAND",
    "dropmalst": "NY",
    "dropmalzpp": 103039997,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7184420667,
    "dropfax": 7182738619
  },
  {
    "dcode": "D",
    "dropkey": 4015110,
    "droptype": "D",
    "dropname": "GERMAN VILLAGE ANNEX",
    "dropdeladd": "1612 LOCKBOURNE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432079997,
    "dropphyadd": "1612 LOCKBOURNE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432079997,
    "dropmaladd": "1612 LOCKBOURNE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432079997,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144499565,
    "dropsitcph": 6144499565,
    "dropfax": 6144499553
  },
  {
    "dcode": "D",
    "dropkey": 4015116,
    "droptype": "D",
    "dropname": "EAST CITY ANNEX",
    "dropdeladd": "850 TWIN RIVERS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432169533,
    "dropphyadd": "850 TWIN RIVERS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432169533,
    "dropmaladd": "850 TWIN RIVERS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432169533,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144694466,
    "dropsitcph": 6144694466,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015117,
    "droptype": "D",
    "dropname": "EASTLAND",
    "dropdeladd": "2601 COURTRIGHT RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432329998,
    "dropphyadd": "2601 COURTRIGHT RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432329998,
    "dropmaladd": "2601 COURTRIGHT RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432329998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142371912,
    "dropsitcph": 6142371912,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015119,
    "droptype": "D",
    "dropname": "GALLOWAY ANNEX",
    "dropdeladd": "770 GEORGESVILLE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432289995,
    "dropphyadd": "770 GEORGESVILLE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432289995,
    "dropmaladd": "770 GEORGESVILLE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432289995,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148782313,
    "dropsitcph": 6143510137,
    "dropfax": 6143510049
  },
  {
    "dcode": "D",
    "dropkey": 4015120,
    "droptype": "D",
    "dropname": "GAHANNA ANNEX",
    "dropdeladd": "2323 CITYGATE DR OFC 2",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432189996,
    "dropphyadd": "2323 CITYGATE DR OFC 2",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432189996,
    "dropmaladd": "2323 CITYGATE DR OFC 2",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432189996,
    "dropsitphn": 6144720696,
    "dropsitlph": 6144720696,
    "dropsitcph": 6144720796,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015121,
    "droptype": "D",
    "dropname": "NORTHWEST",
    "dropdeladd": "4905 GETTYSBURG RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432209998,
    "dropphyadd": "4905 GETTYSBURG RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432209998,
    "dropmaladd": "4905 GETTYSBURG RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432209998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144511502,
    "dropsitcph": 6144511502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015122,
    "droptype": "D",
    "dropname": "WHITEHALL ANNEX",
    "dropdeladd": "83 ROBINWOOD AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432139998,
    "dropphyadd": "83 ROBINWOOD AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432139998,
    "dropmaladd": "83 ROBINWOOD AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432139998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6142370601,
    "dropsitcph": 6142370601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015123,
    "droptype": "D",
    "dropname": "NORTHLAND",
    "dropdeladd": "5700 MAPLE CANYON AVE",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432299998,
    "dropphyadd": "5700 MAPLE CANYON AVE",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432299998,
    "dropmaladd": "5700 MAPLE CANYON AVE",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432299998,
    "dropsitphn": 6144720674,
    "dropsitlph": 6148901180,
    "dropsitcph": 6148901180,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015167,
    "droptype": "D",
    "dropname": "OZONE PARK CARRIER ANNEX",
    "dropdeladd": "1050 FORBELL ST RM 2098",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112569905,
    "dropphyadd": "1050 FORBELL ST RM 2098",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112569905,
    "dropmaladd": "1050 FORBELL ST RM 2098",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112569905,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7188436776,
    "dropfax": 7188438867
  },
  {
    "dcode": "D",
    "dropkey": 4015197,
    "droptype": "D",
    "dropname": "SEATTLE CARRIER ANNEX",
    "dropdeladd": "2460 4TH AVE S",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981349890,
    "dropphyadd": "2460 4TH AVE S",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981349890,
    "dropmaladd": "2460 4TH AVE S",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981349890,
    "dropsitphn": 2067684422,
    "dropsitlph": 2063816601,
    "dropsitcph": 2063816598,
    "dropfax": 6505783855
  },
  {
    "dcode": "D",
    "dropkey": 4015292,
    "droptype": "D",
    "dropname": "LOOP CARRIER ANNEX",
    "dropdeladd": "433 W HARRISON ST FL 3E",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606999905,
    "dropphyadd": "433 W HARRISON ST FL 3E",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999905,
    "dropmaladd": "433 W HARRISON ST FL 3E",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999905,
    "dropsitphn": 3129837602,
    "dropsitlph": 3129838765,
    "dropsitcph": 3129838000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015358,
    "droptype": "D",
    "dropname": "LEE VISTA",
    "dropdeladd": "6301 HAZELTINE NATIONAL DR STE 120",
    "dropdelcty": "ORLANDO",
    "dropdelst": "FL",
    "dropdelzpp": 328229998,
    "dropphyadd": "6301 HAZELTINE NATIONAL DR STE 120",
    "dropphycty": "ORLANDO",
    "dropphyst": "FL",
    "dropphyzpp": 328229998,
    "dropmaladd": "6301 HAZELTINE NATIONAL DR STE 120",
    "dropmalcty": "ORLANDO",
    "dropmalst": "FL",
    "dropmalzpp": 328229998,
    "dropsitphn": 4072409370,
    "dropsitlph": 4072409370,
    "dropsitcph": 4078517506,
    "dropfax": 4072409450
  },
  {
    "dcode": "D",
    "dropkey": 4015419,
    "droptype": "D",
    "dropname": "CARRIER SQUARE",
    "dropdeladd": "1720 MARKET ST RM G206",
    "dropdelcty": "SAINT LOUIS",
    "dropdelst": "MO",
    "dropdelzpp": 631559991,
    "dropphyadd": "1720 MARKET ST RM G206",
    "dropphycty": "SAINT LOUIS",
    "dropphyst": "MO",
    "dropphyzpp": 631559991,
    "dropmaladd": "1720 MARKET ST RM G206",
    "dropmalcty": "SAINT LOUIS",
    "dropmalst": "MO",
    "dropmalzpp": 631559991,
    "dropsitphn": 3148959275,
    "dropsitlph": 3143452819,
    "dropsitcph": 3143452818,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4015573,
    "droptype": "D",
    "dropname": "LAUDERRIDGE CARRIER ANX",
    "dropdeladd": "1900 W OAKLAND PARK BLVD STE 106",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333109990,
    "dropphyadd": "1900 W OAKLAND PARK BLVD STE 106",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333109990,
    "dropmaladd": "1900 W OAKLAND PARK BLVD STE 106",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333109990,
    "dropsitphn": 3055132368,
    "dropsitlph": 9545272917,
    "dropsitcph": 9545272926,
    "dropfax": 9545272933
  },
  {
    "dcode": "D",
    "dropkey": 4015741,
    "droptype": "D",
    "dropname": "TRADE CENTER ANNEX",
    "dropdeladd": "5221 FRANCONIA RD",
    "dropdelcty": "ALEXANDRIA",
    "dropdelst": "VA",
    "dropdelzpp": 223109997,
    "dropphyadd": "5221 FRANCONIA RD",
    "dropphycty": "ALEXANDRIA",
    "dropphyst": "VA",
    "dropphyzpp": 223109997,
    "dropmaladd": "5221 FRANCONIA RD",
    "dropmalcty": "ALEXANDRIA",
    "dropmalst": "VA",
    "dropmalzpp": 223109997,
    "dropsitphn": 7036986367,
    "dropsitlph": 7039710435,
    "dropsitcph": 7039710435,
    "dropfax": 7039718935
  },
  {
    "dcode": "D",
    "dropkey": 4016311,
    "droptype": "D",
    "dropname": "GRAND RIVER CARRIER ANNEX",
    "dropdeladd": "630 DIVISION AVE S",
    "dropdelcty": "GRAND RAPIDS",
    "dropdelst": "MI",
    "dropdelzpp": 495035109,
    "dropphyadd": "630 DIVISION AVE S",
    "dropphycty": "GRAND RAPIDS",
    "dropphyst": "MI",
    "dropphyzpp": 495035109,
    "dropmaladd": "630 DIVISION AVE S",
    "dropmalcty": "GRAND RAPIDS",
    "dropmalst": "MI",
    "dropmalzpp": 495035109,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 6165145891,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4016557,
    "droptype": "D",
    "dropname": "TERMINAL ANNEX",
    "dropdeladd": "71 TERMINAL ST",
    "dropdelcty": "ALBANY",
    "dropdelst": "NY",
    "dropdelzpp": 122069211,
    "dropphyadd": "71 TERMINAL ST",
    "dropphycty": "ALBANY",
    "dropphyst": "NY",
    "dropphyzpp": 122069211,
    "dropmaladd": "71 TERMINAL ST",
    "dropmalcty": "ALBANY",
    "dropmalst": "NY",
    "dropmalzpp": 122069211,
    "dropsitphn": 5184589548,
    "dropsitlph": 5184589548,
    "dropsitcph": 5184589548,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4016784,
    "droptype": "D",
    "dropname": "KENDALL CARRIER ANNEX",
    "dropdeladd": "10500 SW 109TH CT",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331769998,
    "dropphyadd": "10500 SW 109TH CT",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331769998,
    "dropmaladd": "10500 SW 109TH CT",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331769998,
    "dropsitphn": 3052746702,
    "dropsitlph": 3052746702,
    "dropsitcph": 3052746683,
    "dropfax": 3052746780
  },
  {
    "dcode": "D",
    "dropkey": 4016868,
    "droptype": "D",
    "dropname": "WEST EDINA CARRIER ANNEX",
    "dropdeladd": "7360 BUSH LAKE RD",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554392002,
    "dropphyadd": "7360 BUSH LAKE RD",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554392002,
    "dropmaladd": "7360 BUSH LAKE RD",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554392002,
    "dropsitphn": 6123496399,
    "dropsitlph": 9528931357,
    "dropsitcph": 9529219850,
    "dropfax": 9528931630
  },
  {
    "dcode": "D",
    "dropkey": 4016871,
    "droptype": "D",
    "dropname": "WARD PLACE CARRIER ANNEX",
    "dropdeladd": "2121 WARD PL NW",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200379996,
    "dropphyadd": "2121 WARD PL NW",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200379996,
    "dropmaladd": "2121 WARD PL NW",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200379996,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232109,
    "dropsitcph": 2025232109,
    "dropfax": 2025232914
  },
  {
    "dcode": "D",
    "dropkey": 4016924,
    "droptype": "D",
    "dropname": "GRANT STREET CARRIERS",
    "dropdeladd": "395 FEDERAL ST",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152129938,
    "dropphyadd": "395 FEDERAL ST",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152129938,
    "dropmaladd": "395 FEDERAL ST",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152129938,
    "dropsitphn": 4123597568,
    "dropsitlph": "",
    "dropsitcph": 4122311536,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4016960,
    "droptype": "D",
    "dropname": "BEVERLY HILLS CARRIER ANNEX",
    "dropdeladd": "820 N SAN VICENTE BLVD",
    "dropdelcty": "BEVERLY HILLS",
    "dropdelst": "CA",
    "dropdelzpp": 902099997,
    "dropphyadd": "820 N SAN VICENTE BLVD",
    "dropphycty": "BEVERLY HILLS",
    "dropphyst": "CA",
    "dropphyzpp": 902099997,
    "dropmaladd": "820 N SAN VICENTE BLVD",
    "dropmalcty": "BEVERLY HILLS",
    "dropmalst": "CA",
    "dropmalzpp": 902099997,
    "dropsitphn": 3235861867,
    "dropsitlph": 3106527981,
    "dropsitcph": 3106525435,
    "dropfax": 3106590897
  },
  {
    "dcode": "D",
    "dropkey": 4017046,
    "droptype": "D",
    "dropname": "GRAND JUNCTION CARRIER ANNEX",
    "dropdeladd": "734 SCARLET ST",
    "dropdelcty": "GRAND JUNCTION",
    "dropdelst": "CO",
    "dropdelzpp": 815059430,
    "dropphyadd": "734 SCARLET ST",
    "dropphycty": "GRAND JUNCTION",
    "dropphyst": "CO",
    "dropphyzpp": 815059430,
    "dropmaladd": "734 SCARLET ST",
    "dropmalcty": "GRAND JUNCTION",
    "dropmalst": "CO",
    "dropmalzpp": 815059430,
    "dropsitphn": 9702443436,
    "dropsitlph": 9702080047,
    "dropsitcph": 9702080050,
    "dropfax": 9702080048
  },
  {
    "dcode": "D",
    "dropkey": 4017196,
    "droptype": "D",
    "dropname": "METAMORA PEAK ANNEX",
    "dropdeladd": "3840 N MAIN ST STE E",
    "dropdelcty": "EAST PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616115598,
    "dropphyadd": "3840 N MAIN ST STE E",
    "dropphycty": "EAST PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616115598,
    "dropmaladd": "123 E PARTRIDGE ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "IL",
    "dropmalzpp": 615489998,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096178819,
    "dropsitcph": 3093674741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017226,
    "droptype": "D",
    "dropname": "TRENTON CARRIER ANNEX",
    "dropdeladd": "435 US HIGHWAY 130 UNIT B",
    "dropdelcty": "TRENTON",
    "dropdelst": "NJ",
    "dropdelzpp": "086209997",
    "dropphyadd": "435 US HIGHWAY 130 UNIT B",
    "dropphycty": "TRENTON",
    "dropphyst": "NJ",
    "dropphyzpp": "086209997",
    "dropmaladd": "435 US HIGHWAY 130 UNIT B",
    "dropmalcty": "TRENTON",
    "dropmalst": "NJ",
    "dropmalzpp": "086209997",
    "dropsitphn": 7328193630,
    "dropsitlph": "",
    "dropsitcph": 6095817607,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017297,
    "droptype": "D",
    "dropname": "HEBRON CARRIER ANNEX",
    "dropdeladd": "72 CLAY DR",
    "dropdelcty": "HEBRON",
    "dropdelst": "KY",
    "dropdelzpp": 410489808,
    "dropphyadd": "72 CLAY DR",
    "dropphycty": "HEBRON",
    "dropphyst": "KY",
    "dropphyzpp": 410489808,
    "dropmaladd": "72 CLAY DR",
    "dropmalcty": "HEBRON",
    "dropmalst": "KY",
    "dropmalzpp": 410489808,
    "dropsitphn": 5136845763,
    "dropsitlph": 8593715313,
    "dropsitcph": 8593714813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017512,
    "droptype": "D",
    "dropname": "PARKERSBURG CARRIER ANNEX",
    "dropdeladd": "400 RAYON DR",
    "dropdelcty": "PARKERSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 261016668,
    "dropphyadd": "400 RAYON DR",
    "dropphycty": "PARKERSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 261016668,
    "dropmaladd": "400 RAYON DR",
    "dropmalcty": "PARKERSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 261016668,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3044857771,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017751,
    "droptype": "D",
    "dropname": "WENATCHEECARRIER ANNEX",
    "dropdeladd": "3075 OHME RD",
    "dropdelcty": "WENATCHEE",
    "dropdelst": "WA",
    "dropdelzpp": 988019935,
    "dropphyadd": "3075 OHME RD",
    "dropphycty": "WENATCHEE",
    "dropphyst": "WA",
    "dropphyzpp": 988019935,
    "dropmaladd": "3075 OHME RD",
    "dropmalcty": "WENATCHEE",
    "dropmalst": "WA",
    "dropmalzpp": 988019935,
    "dropsitphn": 2067684422,
    "dropsitlph": 5096674685,
    "dropsitcph": 5096674665,
    "dropfax": 5096674668
  },
  {
    "dcode": "D",
    "dropkey": 4017760,
    "droptype": "D",
    "dropname": "LA JOLLA ANNEX UC",
    "dropdeladd": "5047 SHOREHAM PL",
    "dropdelcty": "SAN DIEGO",
    "dropdelst": "CA",
    "dropdelzpp": 921229995,
    "dropphyadd": "5047 SHOREHAM PL",
    "dropphycty": "SAN DIEGO",
    "dropphyst": "CA",
    "dropphyzpp": 921229995,
    "dropmaladd": "5047 SHOREHAM PL",
    "dropmalcty": "SAN DIEGO",
    "dropmalst": "CA",
    "dropmalzpp": 921229995,
    "dropsitphn": 8586740173,
    "dropsitlph": 8584595663,
    "dropsitcph": 8586221277,
    "dropfax": 8586221286
  },
  {
    "dcode": "D",
    "dropkey": 4017786,
    "droptype": "D",
    "dropname": "HERSHEY CARRIER ANNEX",
    "dropdeladd": "312 MILL ST",
    "dropdelcty": "HERSHEY",
    "dropdelst": "PA",
    "dropdelzpp": 170339998,
    "dropphyadd": "312 MILL ST",
    "dropphycty": "HERSHEY",
    "dropphyst": "PA",
    "dropphyzpp": 170339998,
    "dropmaladd": "312 MILL ST",
    "dropmalcty": "HERSHEY",
    "dropmalst": "PA",
    "dropmalzpp": 170339998,
    "dropsitphn": 7172574870,
    "dropsitlph": "",
    "dropsitcph": 7175333356,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017830,
    "droptype": "D",
    "dropname": "NALDO AMF  OLD",
    "dropdeladd": "14350 PECAN PARK RD",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322182441,
    "dropphyadd": "14350 PECAN PARK RD",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322182441,
    "dropmaladd": "14350 PECAN PARK RD",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322182441,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047414683,
    "dropsitcph": 9047414682,
    "dropfax": 9047418757
  },
  {
    "dcode": "D",
    "dropkey": 4017879,
    "droptype": "D",
    "dropname": "MANKATO",
    "dropdeladd": "851 SUMMIT AVE",
    "dropdelcty": "MANKATO",
    "dropdelst": "MN",
    "dropdelzpp": 560019970,
    "dropphyadd": "851 SUMMIT AVE",
    "dropphycty": "MANKATO",
    "dropphyst": "MN",
    "dropphyzpp": 560019970,
    "dropmaladd": "851 SUMMIT AVE",
    "dropmalcty": "MANKATO",
    "dropmalst": "MN",
    "dropmalzpp": 560019970,
    "dropsitphn": 6123499163,
    "dropsitlph": 5076257527,
    "dropsitcph": 5076252320,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017925,
    "droptype": "D",
    "dropname": "WRIGHT PATT CARRIER ANNEX",
    "dropdeladd": "5237 COOPER ST",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454339998,
    "dropphyadd": "5237 COOPER ST",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454339998,
    "dropmaladd": "5237 COOPER ST",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454339998,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372572938,
    "dropsitcph": 9372572938,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4017931,
    "droptype": "D",
    "dropname": "LEAVENWORTH",
    "dropdeladd": "815 S 21ST ST",
    "dropdelcty": "OMAHA",
    "dropdelst": "NE",
    "dropdelzpp": 681083007,
    "dropphyadd": "815 S 21ST ST",
    "dropphycty": "OMAHA",
    "dropphyst": "NE",
    "dropphyzpp": 681083007,
    "dropmaladd": "815 S 21ST ST",
    "dropmalcty": "OMAHA",
    "dropmalst": "NE",
    "dropmalzpp": 681083007,
    "dropsitphn": 4023482736,
    "dropsitlph": 4023482759,
    "dropsitcph": 4023451949,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018021,
    "droptype": "D",
    "dropname": "TIMES PLAZA ANNEX",
    "dropdeladd": "594 DEAN ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112389996,
    "dropphyadd": "594 DEAN ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112389996,
    "dropmaladd": "594 DEAN ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112389996,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7186220341,
    "dropfax": 7186220278
  },
  {
    "dcode": "D",
    "dropkey": 4018049,
    "droptype": "D",
    "dropname": "WEST CARRIER ANNEX",
    "dropdeladd": "2200 NW 72ND AVE STE 700",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331529995,
    "dropphyadd": "2200 NW 72ND AVE STE 700",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331529995,
    "dropmaladd": "2200 NW 72ND AVE STE 700",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331529995,
    "dropsitphn": 3054700746,
    "dropsitlph": 3053929141,
    "dropsitcph": 3053929141,
    "dropfax": 3053929138
  },
  {
    "dcode": "D",
    "dropkey": 4018050,
    "droptype": "D",
    "dropname": "MILAM ANNEX",
    "dropdeladd": "2200 NW 72ND AVE STE 702",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331529996,
    "dropphyadd": "2200 NW 72ND AVE STE 702",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331529996,
    "dropmaladd": "2200 NW 72ND AVE STE 702",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331529996,
    "dropsitphn": 3054700746,
    "dropsitlph": 3054700986,
    "dropsitcph": 3054700972,
    "dropfax": 3054700991
  },
  {
    "dcode": "D",
    "dropkey": 4018051,
    "droptype": "D",
    "dropname": "SOUTHWEST CARRIER ANNEX",
    "dropdeladd": "3285 EXPRESS CT",
    "dropdelcty": "LANSING",
    "dropdelst": "MI",
    "dropdelzpp": 489109998,
    "dropphyadd": "3285 EXPRESS CT",
    "dropphycty": "LANSING",
    "dropphyst": "MI",
    "dropphyzpp": 489109998,
    "dropmaladd": "3285 EXPRESS CT",
    "dropmalcty": "LANSING",
    "dropmalst": "MI",
    "dropmalzpp": 489109998,
    "dropsitphn": 6169771064,
    "dropsitlph": 5172720684,
    "dropsitcph": 5172720684,
    "dropfax": 5172720698
  },
  {
    "dcode": "D",
    "dropkey": 4018135,
    "droptype": "D",
    "dropname": "WEST AVE CARRIER UNIT",
    "dropdeladd": "427 WEST AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069109901",
    "dropphyadd": "427 WEST AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069109901",
    "dropmaladd": "427 WEST AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069109901",
    "dropsitphn": 2033262038,
    "dropsitlph": 2033262038,
    "dropsitcph": 2033262038,
    "dropfax": 2033262153
  },
  {
    "dcode": "D",
    "dropkey": 4018206,
    "droptype": "D",
    "dropname": "SECTION 9 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200189990,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200189990,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200189990,
    "dropsitphn": 3014997331,
    "dropsitlph": 2025232114,
    "dropsitcph": 2025232129,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018223,
    "droptype": "D",
    "dropname": "BELLEVUE WAY CARRIER ANNEX",
    "dropdeladd": "1171 BELLEVUE WAY NE",
    "dropdelcty": "BELLEVUE",
    "dropdelst": "WA",
    "dropdelzpp": 980044292,
    "dropphyadd": "1171 BELLEVUE WAY NE",
    "dropphycty": "BELLEVUE",
    "dropphyst": "WA",
    "dropphyzpp": 980044292,
    "dropmaladd": "1171 BELLEVUE WAY NE",
    "dropmalcty": "BELLEVUE",
    "dropmalst": "WA",
    "dropmalzpp": 980044292,
    "dropsitphn": 2067684422,
    "dropsitlph": 4254543086,
    "dropsitcph": 4254535655,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018245,
    "droptype": "D",
    "dropname": "BROOKLYN PARCEL ANNEX",
    "dropdeladd": "9 29TH ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112321502,
    "dropphyadd": "9 29TH ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112321502,
    "dropmaladd": "9 29TH ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112321502,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183480000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018266,
    "droptype": "D",
    "dropname": "GATEWAY CARRIER ANNEX",
    "dropdeladd": "5258 NORWOOD AVE UNIT 1",
    "dropdelcty": "JACKSONVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 322085017,
    "dropphyadd": "5258 NORWOOD AVE UNIT 1",
    "dropphycty": "JACKSONVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 322085017,
    "dropmaladd": "5258 NORWOOD AVE UNIT 1",
    "dropmalcty": "JACKSONVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 322085017,
    "dropsitphn": 9043592957,
    "dropsitlph": 9047649581,
    "dropsitcph": 9047649581,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018277,
    "droptype": "D",
    "dropname": "EASTSIDE CARRIER ANNEX",
    "dropdeladd": "1200 WILLIAM ST",
    "dropdelcty": "BUFFALO",
    "dropdelst": "NY",
    "dropdelzpp": 142409799,
    "dropphyadd": "1200 WILLIAM ST",
    "dropphycty": "BUFFALO",
    "dropphyst": "NY",
    "dropphyzpp": 142409799,
    "dropmaladd": "1200 WILLIAM ST",
    "dropmalcty": "BUFFALO",
    "dropmalst": "NY",
    "dropmalzpp": 142409799,
    "dropsitphn": 7168462415,
    "dropsitlph": 7168462415,
    "dropsitcph": 7168424754,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018279,
    "droptype": "D",
    "dropname": "PALA VISTA ANNEX",
    "dropdeladd": "1525 E VISTA WAY",
    "dropdelcty": "VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 920849997,
    "dropphyadd": "1525 E VISTA WAY",
    "dropphycty": "VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 920849997,
    "dropmaladd": "1525 E VISTA WAY",
    "dropmalcty": "VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 920849997,
    "dropsitphn": 8586740173,
    "dropsitlph": 7604141015,
    "dropsitcph": 7604149710,
    "dropfax": 7604149741
  },
  {
    "dcode": "D",
    "dropkey": 4018396,
    "droptype": "D",
    "dropname": "SAM HOUSTON",
    "dropdeladd": "1500 HADLEY ST",
    "dropdelcty": "HOUSTON",
    "dropdelst": "TX",
    "dropdelzpp": 770028943,
    "dropphyadd": "1500 HADLEY ST",
    "dropphycty": "HOUSTON",
    "dropphyst": "TX",
    "dropphyzpp": 770028943,
    "dropmaladd": "1500 HADLEY ST",
    "dropmalcty": "HOUSTON",
    "dropmalst": "TX",
    "dropmalzpp": 770028943,
    "dropsitphn": 7132263055,
    "dropsitlph": 7132263071,
    "dropsitcph": 7137390013,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018646,
    "droptype": "D",
    "dropname": "BLAINE CARRIER ANNEX",
    "dropdeladd": "9301 BALTIMORE ST NE",
    "dropdelcty": "MINNEAPOLIS",
    "dropdelst": "MN",
    "dropdelzpp": 554494335,
    "dropphyadd": "9301 BALTIMORE ST NE",
    "dropphycty": "MINNEAPOLIS",
    "dropphyst": "MN",
    "dropphyzpp": 554494335,
    "dropmaladd": "9301 BALTIMORE ST NE",
    "dropmalcty": "MINNEAPOLIS",
    "dropmalst": "MN",
    "dropmalzpp": 554494335,
    "dropsitphn": 6123496399,
    "dropsitlph": 7637841261,
    "dropsitcph": 7637841208,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018664,
    "droptype": "D",
    "dropname": "OLYMPIA CARRIER ANNEX",
    "dropdeladd": "717 76TH AVE SW",
    "dropdelcty": "TUMWATER",
    "dropdelst": "WA",
    "dropdelzpp": 985019899,
    "dropphyadd": "717 76TH AVE SW",
    "dropphycty": "TUMWATER",
    "dropphyst": "WA",
    "dropphyzpp": 985019899,
    "dropmaladd": "717 76TH AVE SW",
    "dropmalcty": "TUMWATER",
    "dropmalst": "WA",
    "dropmalzpp": 985019899,
    "dropsitphn": 2067684422,
    "dropsitlph": 3607044820,
    "dropsitcph": 3607044820,
    "dropfax": 3607044892
  },
  {
    "dcode": "D",
    "dropkey": 4018680,
    "droptype": "D",
    "dropname": "CARY ANNEX",
    "dropdeladd": "1213 BUCK JONES RD",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276069901,
    "dropphyadd": "1213 BUCK JONES RD",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276069901,
    "dropmaladd": "1213 BUCK JONES RD",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276069901,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9196741001,
    "dropfax": 9194630848
  },
  {
    "dcode": "D",
    "dropkey": 4018682,
    "droptype": "D",
    "dropname": "BROOKLYN PP ANNEX",
    "dropdeladd": "333 JOHNSON AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112062804,
    "dropphyadd": "333 JOHNSON AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112062804,
    "dropmaladd": "333 JOHNSON AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112062804,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183480000,
    "dropfax": 7188212179
  },
  {
    "dcode": "D",
    "dropkey": 4018695,
    "droptype": "D",
    "dropname": "NORTH CITY CARRIER ANNEX",
    "dropdeladd": "24360 VAN RY BLVD",
    "dropdelcty": "MOUNTLAKE TERRACE",
    "dropdelst": "WA",
    "dropdelzpp": 980439997,
    "dropphyadd": "24360 VAN RY BLVD",
    "dropphycty": "MOUNTLAKE TERRACE",
    "dropphyst": "WA",
    "dropphyzpp": 980439997,
    "dropmaladd": "24360 VAN RY BLVD",
    "dropmalcty": "MOUNTLAKE TERRACE",
    "dropmalst": "WA",
    "dropmalzpp": 980439997,
    "dropsitphn": 2067684422,
    "dropsitlph": 4256400253,
    "dropsitcph": 4256400253,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018709,
    "droptype": "D",
    "dropname": "COMMERCE PARK ANNEX",
    "dropdeladd": "8101 BLUEBONNET BLVD",
    "dropdelcty": "BATON ROUGE",
    "dropdelst": "LA",
    "dropdelzpp": 708109995,
    "dropphyadd": "8101 BLUEBONNET BLVD",
    "dropphycty": "BATON ROUGE",
    "dropphyst": "LA",
    "dropphyzpp": 708109995,
    "dropmaladd": "8101 BLUEBONNET BLVD",
    "dropmalcty": "BATON ROUGE",
    "dropmalst": "LA",
    "dropmalzpp": 708109995,
    "dropsitphn": 2257633754,
    "dropsitlph": 2257633754,
    "dropsitcph": 2257690542,
    "dropfax": 2257633768
  },
  {
    "dcode": "D",
    "dropkey": 4018737,
    "droptype": "D",
    "dropname": "COLUMBIA CARRIER ANNEX",
    "dropdeladd": "3613 S JUNEAU ST",
    "dropdelcty": "SEATTLE",
    "dropdelst": "WA",
    "dropdelzpp": 981189997,
    "dropphyadd": "3613 S JUNEAU ST",
    "dropphycty": "SEATTLE",
    "dropphyst": "WA",
    "dropphyzpp": 981189997,
    "dropmaladd": "3613 S JUNEAU ST",
    "dropmalcty": "SEATTLE",
    "dropmalst": "WA",
    "dropmalzpp": 981189997,
    "dropsitphn": 2067684422,
    "dropsitlph": 2067255117,
    "dropsitcph": 2067212534,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018769,
    "droptype": "D",
    "dropname": "METAMORA CARRIER ANNEX",
    "dropdeladd": "219 E MOUNT VERNON ST",
    "dropdelcty": "METAMORA",
    "dropdelst": "IL",
    "dropdelzpp": 615489997,
    "dropphyadd": "219 E MOUNT VERNON ST",
    "dropphycty": "METAMORA",
    "dropphyst": "IL",
    "dropphyzpp": 615489997,
    "dropmaladd": "219 E MOUNT VERNON ST",
    "dropmalcty": "METAMORA",
    "dropmalst": "IL",
    "dropmalzpp": 615489997,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3093674741,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018845,
    "droptype": "D",
    "dropname": "BUENA VISTA CARRIER ANNEX",
    "dropdeladd": "500 NW 2ND AVE STE 200",
    "dropdelcty": "MIAMI",
    "dropdelst": "FL",
    "dropdelzpp": 331019997,
    "dropphyadd": "500 NW 2ND AVE STE 200",
    "dropphycty": "MIAMI",
    "dropphyst": "FL",
    "dropphyzpp": 331019997,
    "dropmaladd": "500 NW 2ND AVE STE 200",
    "dropmalcty": "MIAMI",
    "dropmalst": "FL",
    "dropmalzpp": 331019997,
    "dropsitphn": 3054700746,
    "dropsitlph": 3055736011,
    "dropsitcph": 3055736056,
    "dropfax": 3053743216
  },
  {
    "dcode": "D",
    "dropkey": 4018873,
    "droptype": "D",
    "dropname": "PRATT ANNEX",
    "dropdeladd": "29 CUMBERLAND ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112051039,
    "dropphyadd": "29 CUMBERLAND ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112051039,
    "dropmaladd": "29 CUMBERLAND ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112051039,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 3472721757,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018874,
    "droptype": "D",
    "dropname": "NEW LOTS PARCEL ANNEX",
    "dropdeladd": "2300 LINDEN BLVD",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112084844,
    "dropphyadd": "2300 LINDEN BLVD",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112084844,
    "dropmaladd": "2300 LINDEN BLVD",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112084844,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7182770217,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018876,
    "droptype": "D",
    "dropname": "UPTOWN PARCEL ANNEX",
    "dropdeladd": "845 E 136TH ST",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104549941,
    "dropphyadd": "845 E 136TH ST",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104549941,
    "dropmaladd": "845 E 136TH ST",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104549941,
    "dropsitphn": 2123302770,
    "dropsitlph": 7182222458,
    "dropsitcph": 3322082868,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018877,
    "droptype": "D",
    "dropname": "BROOKLYN WEST ANNEX",
    "dropdeladd": "102 43RD ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112323308,
    "dropphyadd": "102 43RD ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112323308,
    "dropmaladd": "102 43RD ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112323308,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7187883542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018879,
    "droptype": "D",
    "dropname": "SPOUT SPRINGS CARRIER ANNEX",
    "dropdeladd": "196 H M CAGLE DR",
    "dropdelcty": "CAMERON",
    "dropdelst": "NC",
    "dropdelzpp": 283267655,
    "dropphyadd": "196 H M CAGLE DR",
    "dropphycty": "CAMERON",
    "dropphyst": "NC",
    "dropphyzpp": 283267655,
    "dropmaladd": "196 H M CAGLE DR",
    "dropmalcty": "CAMERON",
    "dropmalst": "NC",
    "dropmalzpp": 283267655,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 9194995801,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018886,
    "droptype": "D",
    "dropname": "MINOOKA PEAK ANNEX",
    "dropdeladd": "24053 S MUNICIPAL DR",
    "dropdelcty": "CHANNAHON",
    "dropdelst": "IL",
    "dropdelzpp": 604109997,
    "dropphyadd": "24053 S MUNICIPAL DR",
    "dropphycty": "CHANNAHON",
    "dropphyst": "IL",
    "dropphyzpp": 604109997,
    "dropmaladd": "301 W MONDAMIN ST",
    "dropmalcty": "MINOOKA",
    "dropmalst": "IL",
    "dropmalzpp": 604479998,
    "dropsitphn": 7085637318,
    "dropsitlph": 8154676360,
    "dropsitcph": 8154676360,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018889,
    "droptype": "D",
    "dropname": "BLUE OAKS",
    "dropdeladd": "1040 WINDING CREEK RD",
    "dropdelcty": "ROSEVILLE",
    "dropdelst": "CA",
    "dropdelzpp": 956789997,
    "dropphyadd": "1040 WINDING CREEK RD",
    "dropphycty": "ROSEVILLE",
    "dropphyst": "CA",
    "dropphyzpp": 956789997,
    "dropmaladd": "1040 WINDING CREEK RD",
    "dropmalcty": "ROSEVILLE",
    "dropmalst": "CA",
    "dropmalzpp": 956789997,
    "dropsitphn": 9163738025,
    "dropsitlph": 9167717026,
    "dropsitcph": 9167717021,
    "dropfax": 9167717025
  },
  {
    "dcode": "D",
    "dropkey": 4018895,
    "droptype": "D",
    "dropname": "REHOBOTH BEACH CARRIER ANNEX",
    "dropdeladd": "18908 REHOBOTH MALL BLVD STE 15",
    "dropdelcty": "REHOBOTH BEACH",
    "dropdelst": "DE",
    "dropdelzpp": 199716134,
    "dropphyadd": "18908 REHOBOTH MALL BLVD STE 15",
    "dropphycty": "REHOBOTH BEACH",
    "dropphyst": "DE",
    "dropphyzpp": 199716134,
    "dropmaladd": "18908 REHOBOTH MALL BLVD STE 15",
    "dropmalcty": "REHOBOTH BEACH",
    "dropmalst": "DE",
    "dropmalzpp": 199716134,
    "dropsitphn": 3023232279,
    "dropsitlph": 3023233734,
    "dropsitcph": 3026441409,
    "dropfax": 3022273370
  },
  {
    "dcode": "D",
    "dropkey": 4018943,
    "droptype": "D",
    "dropname": "LOCKPORT CARRIER ANNEX",
    "dropdeladd": "954 E 9TH ST",
    "dropdelcty": "LOCKPORT",
    "dropdelst": "IL",
    "dropdelzpp": 604419996,
    "dropphyadd": "954 E 9TH ST",
    "dropphycty": "LOCKPORT",
    "dropphyst": "IL",
    "dropphyzpp": 604419996,
    "dropmaladd": "954 E 9TH ST",
    "dropmalcty": "LOCKPORT",
    "dropmalst": "IL",
    "dropmalzpp": 604419996,
    "dropsitphn": 7085637318,
    "dropsitlph": 7085635789,
    "dropsitcph": 8158388679,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4018985,
    "droptype": "D",
    "dropname": "ROYAL OAK CARRIER ANNEX",
    "dropdeladd": "2351 BELLINGHAM DR",
    "dropdelcty": "TROY",
    "dropdelst": "MI",
    "dropdelzpp": 480832000,
    "dropphyadd": "2351 BELLINGHAM DR",
    "dropphycty": "TROY",
    "dropphyst": "MI",
    "dropphyzpp": 480832000,
    "dropmaladd": "2351 BELLINGHAM DR",
    "dropmalcty": "TROY",
    "dropmalst": "MI",
    "dropmalzpp": 480832000,
    "dropsitphn": 2485246910,
    "dropsitlph": 2487585622,
    "dropsitcph": 2485246910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019039,
    "droptype": "D",
    "dropname": "TIMES PLAZA PARCELS",
    "dropdeladd": "537 SACKETT ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112173018,
    "dropphyadd": "537 SACKETT ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112173018,
    "dropmaladd": "537 SACKETT ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112173018,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7186220341,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019042,
    "droptype": "D",
    "dropname": "SAINT JOHNS ANNEX",
    "dropdeladd": "1700 ATLANTIC AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112131206,
    "dropphyadd": "1700 ATLANTIC AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112131206,
    "dropmaladd": "1700 ATLANTIC AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112131206,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7187749688,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019043,
    "droptype": "D",
    "dropname": "WEST SIDE ANNEX",
    "dropdeladd": "620 12TH AVE DEPT 100",
    "dropdelcty": "NEW YORK",
    "dropdelst": "NY",
    "dropdelzpp": 100369996,
    "dropphyadd": "620 12TH AVE DEPT 100",
    "dropphycty": "NEW YORK",
    "dropphyst": "NY",
    "dropphyzpp": 100369996,
    "dropmaladd": "620 12TH AVE DEPT 100",
    "dropmalcty": "NEW YORK",
    "dropmalst": "NY",
    "dropmalzpp": 100369996,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 9177289918,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019056,
    "droptype": "D",
    "dropname": "EVERGREEN CARRIER ANNEX",
    "dropdeladd": "1222 BERGEN PKWY",
    "dropdelcty": "EVERGREEN",
    "dropdelst": "CO",
    "dropdelzpp": 804399524,
    "dropphyadd": "1222 BERGEN PKWY",
    "dropphycty": "EVERGREEN",
    "dropphyst": "CO",
    "dropphyzpp": 804399524,
    "dropmaladd": "1222 BERGEN PKWY",
    "dropmalcty": "EVERGREEN",
    "dropmalst": "CO",
    "dropmalzpp": 804399524,
    "dropsitphn": 3036753095,
    "dropsitlph": 3036753095,
    "dropsitcph": 3036753095,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019058,
    "droptype": "D",
    "dropname": "RICHMOND CARRIER ANNEX",
    "dropdeladd": "1406 SOUTHGATE DR",
    "dropdelcty": "ROSENBERG",
    "dropdelst": "TX",
    "dropdelzpp": 774715042,
    "dropphyadd": "1406 SOUTHGATE DR",
    "dropphycty": "ROSENBERG",
    "dropphyst": "TX",
    "dropphyzpp": 774715042,
    "dropmaladd": "1406 SOUTHGATE DR",
    "dropmalcty": "ROSENBERG",
    "dropmalst": "TX",
    "dropmalzpp": 774715042,
    "dropsitphn": 7132263055,
    "dropsitlph": 2817141687,
    "dropsitcph": 2817141687,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019059,
    "droptype": "D",
    "dropname": "MADISON CARRIER ANNEX",
    "dropdeladd": "213 INDUSTRIAL DR N",
    "dropdelcty": "GLUCKSTADT",
    "dropdelst": "MS",
    "dropdelzpp": 391109783,
    "dropphyadd": "213 INDUSTRIAL DR N",
    "dropphycty": "GLUCKSTADT",
    "dropphyst": "MS",
    "dropphyzpp": 391109783,
    "dropmaladd": "213 INDUSTRIAL DR N",
    "dropmalcty": "GLUCKSTADT",
    "dropmalst": "MS",
    "dropmalzpp": 391109783,
    "dropsitphn": 6013517144,
    "dropsitlph": 6017906384,
    "dropsitcph": 6018532403,
    "dropfax": 6018984774
  },
  {
    "dcode": "D",
    "dropkey": 4019066,
    "droptype": "D",
    "dropname": "APEX ANNEX",
    "dropdeladd": "112 3RD ST STE A",
    "dropdelcty": "HOLLY SPRINGS",
    "dropdelst": "NC",
    "dropdelzpp": 275402102,
    "dropphyadd": "112 3RD ST STE A",
    "dropphycty": "HOLLY SPRINGS",
    "dropphyst": "NC",
    "dropphyzpp": 275402102,
    "dropmaladd": "112 3RD ST STE A",
    "dropmalcty": "HOLLY SPRINGS",
    "dropmalst": "NC",
    "dropmalzpp": 275402102,
    "dropsitphn": 3369319444,
    "dropsitlph": 9198313642,
    "dropsitcph": 9195573508,
    "dropfax": 9195521966
  },
  {
    "dcode": "D",
    "dropkey": 4019087,
    "droptype": "D",
    "dropname": "LYNDEN CARRIER ANNEX",
    "dropdeladd": "114 S DUFFNER DR",
    "dropdelcty": "LYNDEN",
    "dropdelst": "WA",
    "dropdelzpp": 982649997,
    "dropphyadd": "114 S DUFFNER DR",
    "dropphycty": "LYNDEN",
    "dropphyst": "WA",
    "dropphyzpp": 982649997,
    "dropmaladd": "114 S DUFFNER DR",
    "dropmalcty": "LYNDEN",
    "dropmalst": "WA",
    "dropmalzpp": 982649997,
    "dropsitphn": 2067684422,
    "dropsitlph": 3603180144,
    "dropsitcph": 3603180144,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019100,
    "droptype": "D",
    "dropname": "ERIE CARRIER ANNEX",
    "dropdeladd": "621 MITCHELL WAY",
    "dropdelcty": "ERIE",
    "dropdelst": "CO",
    "dropdelzpp": 805169996,
    "dropphyadd": "621 MITCHELL WAY",
    "dropphycty": "ERIE",
    "dropphyst": "CO",
    "dropphyzpp": 805169996,
    "dropmaladd": "621 MITCHELL WAY",
    "dropmalcty": "ERIE",
    "dropmalst": "CO",
    "dropmalzpp": 805169996,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038285234,
    "dropsitcph": 3038280781,
    "dropfax": 3038285230
  },
  {
    "dcode": "D",
    "dropkey": 4019126,
    "droptype": "D",
    "dropname": "NORTHEAST JOBO CARRIER ANNEX",
    "dropdeladd": "3405 MOORE RD",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019957,
    "dropphyadd": "3405 MOORE RD",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019957,
    "dropmaladd": "3405 MOORE RD",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019957,
    "dropsitphn": 8709720275,
    "dropsitlph": 8709720275,
    "dropsitcph": 8709315763,
    "dropfax": 8709316932
  },
  {
    "dcode": "D",
    "dropkey": 4019138,
    "droptype": "D",
    "dropname": "RUSKIN CARRIER ANNEX",
    "dropdeladd": "6859 N US HIGHWAY 41",
    "dropdelcty": "APOLLO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 335721501,
    "dropphyadd": "6859 N US HIGHWAY 41",
    "dropphycty": "APOLLO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 335721501,
    "dropmaladd": "6859 N US HIGHWAY 41",
    "dropmalcty": "APOLLO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 335721501,
    "dropsitphn": 8138770788,
    "dropsitlph": 8138770683,
    "dropsitcph": 8132806502,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019140,
    "droptype": "D",
    "dropname": "MEDFORD CARRIER ANNEX NEW",
    "dropdeladd": "2195 SAGE RD",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OR",
    "dropdelzpp": 975019997,
    "dropphyadd": "2195 SAGE RD",
    "dropphycty": "MEDFORD",
    "dropphyst": "OR",
    "dropphyzpp": 975019997,
    "dropmaladd": "2195 SAGE RD",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OR",
    "dropmalzpp": 975019997,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5417744088,
    "dropfax": 5416088246
  },
  {
    "dcode": "D",
    "dropkey": 4019275,
    "droptype": "D",
    "dropname": "WYCKOFF ANNEX",
    "dropdeladd": "134 MORGAN AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112371220,
    "dropphyadd": "134 MORGAN AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112371220,
    "dropmaladd": "134 MORGAN AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112371220,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 7183863629,
    "dropfax": 7183863010
  },
  {
    "dcode": "D",
    "dropkey": 4019285,
    "droptype": "D",
    "dropname": "BRIGHTON CARRIER ANNEX",
    "dropdeladd": "729 BASELINE PL",
    "dropdelcty": "BRIGHTON",
    "dropdelst": "CO",
    "dropdelzpp": 806035751,
    "dropphyadd": "729 BASELINE PL",
    "dropphycty": "BRIGHTON",
    "dropphyst": "CO",
    "dropphyzpp": 806035751,
    "dropmaladd": "729 BASELINE PL",
    "dropmalcty": "BRIGHTON",
    "dropmalst": "CO",
    "dropmalzpp": 806035751,
    "dropsitphn": 3038536511,
    "dropsitlph": 9703477114,
    "dropsitcph": 9703245103,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019288,
    "droptype": "D",
    "dropname": "MIDWOOD ANNEX",
    "dropdeladd": "1632 MCDONALD AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112306311,
    "dropphyadd": "1632 MCDONALD AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112306311,
    "dropmaladd": "1632 MCDONALD AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112306311,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 3475788835,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019290,
    "droptype": "D",
    "dropname": "HIDENWOOD ANNEX",
    "dropdeladd": "759 J CLYDE MORRIS BLVD",
    "dropdelcty": "NEWPORT NEWS",
    "dropdelst": "VA",
    "dropdelzpp": 236011514,
    "dropphyadd": "759 J CLYDE MORRIS BLVD",
    "dropphycty": "NEWPORT NEWS",
    "dropphyst": "VA",
    "dropphyzpp": 236011514,
    "dropmaladd": "759 J CLYDE MORRIS BLVD",
    "dropmalcty": "NEWPORT NEWS",
    "dropmalst": "VA",
    "dropmalzpp": 236011514,
    "dropsitphn": 7576642314,
    "dropsitlph": 7575967019,
    "dropsitcph": 7575950845,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019291,
    "droptype": "D",
    "dropname": "SECTION 10 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200660010,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200660010,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200660010,
    "dropsitphn": 2026367331,
    "dropsitlph": 2026362290,
    "dropsitcph": 2026362290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019301,
    "droptype": "D",
    "dropname": "NEW BRAUNFELS ANNEX",
    "dropdeladd": "686 S SEGUIN AVE",
    "dropdelcty": "NEW BRAUNFELS",
    "dropdelst": "TX",
    "dropdelzpp": 781309998,
    "dropphyadd": "686 S SEGUIN AVE",
    "dropphycty": "NEW BRAUNFELS",
    "dropphyst": "TX",
    "dropphyzpp": 781309998,
    "dropmaladd": "686 S SEGUIN AVE",
    "dropmalcty": "NEW BRAUNFELS",
    "dropmalst": "TX",
    "dropmalzpp": 781309998,
    "dropsitphn": 2103688387,
    "dropsitlph": 8306257736,
    "dropsitcph": 8306257736,
    "dropfax": 2103688387
  },
  {
    "dcode": "D",
    "dropkey": 4019302,
    "droptype": "D",
    "dropname": "SAN MARCOS ANNEX",
    "dropdeladd": "210 S STAGECOACH TRL",
    "dropdelcty": "SAN MARCOS",
    "dropdelst": "TX",
    "dropdelzpp": 786669998,
    "dropphyadd": "210 S STAGECOACH TRL",
    "dropphycty": "SAN MARCOS",
    "dropphyst": "TX",
    "dropphyzpp": 786669998,
    "dropmaladd": "210 S STAGECOACH TRL",
    "dropmalcty": "SAN MARCOS",
    "dropmalst": "TX",
    "dropmalzpp": 786669998,
    "dropsitphn": 2103688387,
    "dropsitlph": 5123924835,
    "dropsitcph": 5123924831,
    "dropfax": 5123924842
  },
  {
    "dcode": "D",
    "dropkey": 4019660,
    "droptype": "D",
    "dropname": "PHENIX CITY ANNEX",
    "dropdeladd": "1411 14TH ST",
    "dropdelcty": "PHENIX CITY",
    "dropdelst": "AL",
    "dropdelzpp": 368674816,
    "dropphyadd": "1411 14TH ST",
    "dropphycty": "PHENIX CITY",
    "dropphyst": "AL",
    "dropphyzpp": 368674816,
    "dropmaladd": "1411 14TH ST",
    "dropmalcty": "PHENIX CITY",
    "dropmalst": "AL",
    "dropmalzpp": 368674816,
    "dropsitphn": 3342987871,
    "dropsitlph": 3342987871,
    "dropsitcph": 3342987871,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019674,
    "droptype": "D",
    "dropname": "BUSH TERMINAL CARRIER ANNEX",
    "dropdeladd": "147 41ST ST STE 1",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112323322,
    "dropphyadd": "147 41ST ST STE 1",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112323322,
    "dropmaladd": "147 41ST ST STE 1",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112323322,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 9294808142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019682,
    "droptype": "D",
    "dropname": "SECTION 12 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200660012,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200660012,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200660012,
    "dropsitphn": 2026367331,
    "dropsitlph": 2026362290,
    "dropsitcph": 2026362290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019683,
    "droptype": "D",
    "dropname": "SECTION 15 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200660015,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200660015,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200660015,
    "dropsitphn": 2026367331,
    "dropsitlph": 2026362290,
    "dropsitcph": 2026362290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019685,
    "droptype": "D",
    "dropname": "SUNNYSLOPE ANNEX",
    "dropdeladd": "9623 N 7TH ST",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850200003,
    "dropphyadd": "9623 N 7TH ST",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850200003,
    "dropmaladd": "9623 N 7TH ST",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850200003,
    "dropsitphn": 6029449317,
    "dropsitlph": 6029449317,
    "dropsitcph": 6023950579,
    "dropfax": 6023711469
  },
  {
    "dcode": "D",
    "dropkey": 4019710,
    "droptype": "D",
    "dropname": "WIN CARRIER ANNEX",
    "dropdeladd": "1070 DIAMOND VALLEY DR STE 500",
    "dropdelcty": "WINDSOR",
    "dropdelst": "CO",
    "dropdelzpp": 805503611,
    "dropphyadd": "1070 DIAMOND VALLEY DR STE 500",
    "dropphycty": "WINDSOR",
    "dropphyst": "CO",
    "dropphyzpp": 805503611,
    "dropmaladd": "1070 DIAMOND VALLEY DR STE 500",
    "dropmalcty": "WINDSOR",
    "dropmalst": "CO",
    "dropmalzpp": 805503611,
    "dropsitphn": 3038536511,
    "dropsitlph": 9708333010,
    "dropsitcph": 9708333010,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019741,
    "droptype": "D",
    "dropname": "SALT LAKE DOWNTOWN ANNEX",
    "dropdeladd": "1795 W 2100 S",
    "dropdelcty": "SALT LAKE CITY",
    "dropdelst": "UT",
    "dropdelzpp": 841999802,
    "dropphyadd": "1795 W 2100 S",
    "dropphycty": "SALT LAKE CITY",
    "dropphyst": "UT",
    "dropphyzpp": 841999802,
    "dropmaladd": "1795 W 2100 S",
    "dropmalcty": "SALT LAKE CITY",
    "dropmalst": "UT",
    "dropmalzpp": 841999802,
    "dropsitphn": 8019742558,
    "dropsitlph": 8019742298,
    "dropsitcph": 8019783093,
    "dropfax": 8019783034
  },
  {
    "dcode": "D",
    "dropkey": 4019855,
    "droptype": "D",
    "dropname": "SOUTH PROVIDENCE",
    "dropdeladd": "301 E JOHN ST",
    "dropdelcty": "MATTHEWS",
    "dropdelst": "NC",
    "dropdelzpp": 281050091,
    "dropphyadd": "301 E JOHN ST",
    "dropphycty": "MATTHEWS",
    "dropphyst": "NC",
    "dropphyzpp": 281050091,
    "dropmaladd": "301 E JOHN ST",
    "dropmalcty": "MATTHEWS",
    "dropmalst": "NC",
    "dropmalzpp": 281050091,
    "dropsitphn": 7043934581,
    "dropsitlph": "",
    "dropsitcph": 7048476063,
    "dropfax": 7048411956
  },
  {
    "dcode": "D",
    "dropkey": 4019903,
    "droptype": "D",
    "dropname": "FERN CREEK CARRIER ANNEX NEW",
    "dropdeladd": "9120 BEULAH CHURCH RD",
    "dropdelcty": "LOUISVILLE",
    "dropdelst": "KY",
    "dropdelzpp": 402919996,
    "dropphyadd": "9120 BEULAH CHURCH RD",
    "dropphycty": "LOUISVILLE",
    "dropphyst": "KY",
    "dropphyzpp": 402919996,
    "dropmaladd": "9120 BEULAH CHURCH RD",
    "dropmalcty": "LOUISVILLE",
    "dropmalst": "KY",
    "dropmalzpp": 402919996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 5022310110,
    "dropfax": 5022315648
  },
  {
    "dcode": "D",
    "dropkey": 4019904,
    "droptype": "D",
    "dropname": "UPPER ARLINGTON ANNEX",
    "dropdeladd": "850 TWIN RIVERS DR",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432169900,
    "dropphyadd": "850 TWIN RIVERS DR",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432169900,
    "dropmaladd": "850 TWIN RIVERS DR",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432169900,
    "dropsitphn": 6144720674,
    "dropsitlph": "",
    "dropsitcph": 6144694211,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019917,
    "droptype": "D",
    "dropname": "HILBURN STA",
    "dropdeladd": "99 NO RECORD 27612 ST",
    "dropdelcty": "RALEIGH",
    "dropdelst": "NC",
    "dropdelzpp": 276129880,
    "dropphyadd": "99 NO RECORD 27612 ST",
    "dropphycty": "RALEIGH",
    "dropphyst": "NC",
    "dropphyzpp": 276129880,
    "dropmaladd": "99 NO RECORD 27612 ST",
    "dropmalcty": "RALEIGH",
    "dropmalst": "NC",
    "dropmalzpp": 276129880,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9197888527,
    "dropfax": 9197872247
  },
  {
    "dcode": "D",
    "dropkey": 4019937,
    "droptype": "D",
    "dropname": "BRONX PARCEL POST ANNEX",
    "dropdeladd": "1110 OAKPOINT AVE",
    "dropdelcty": "BRONX",
    "dropdelst": "NY",
    "dropdelzpp": 104749902,
    "dropphyadd": "1110 OAKPOINT AVE",
    "dropphycty": "BRONX",
    "dropphyst": "NY",
    "dropphyzpp": 104749902,
    "dropmaladd": "1110 OAKPOINT AVE",
    "dropmalcty": "BRONX",
    "dropmalst": "NY",
    "dropmalzpp": 104749902,
    "dropsitphn": 2123302770,
    "dropsitlph": "",
    "dropsitcph": 9176219671,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019948,
    "droptype": "D",
    "dropname": "BROOKLYN CENTRAL ANNEX",
    "dropdeladd": "700 HICKS ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112319996,
    "dropphyadd": "700 HICKS ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112319996,
    "dropmaladd": "700 HICKS ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112319996,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 9294808142,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019949,
    "droptype": "D",
    "dropname": "BROOKLYN ALABAMA NY S&DC",
    "dropdeladd": "966 ALABAMA AVE",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112079902,
    "dropphyadd": "966 ALABAMA AVE",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112079902,
    "dropmaladd": "966 ALABAMA AVE",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112079902,
    "dropsitphn": 7183215923,
    "dropsitlph": 7183215071,
    "dropsitcph": 9292753083,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019954,
    "droptype": "D",
    "dropname": "SANTA ROSA BCH ANNEX",
    "dropdeladd": "33 CHURCHILL BAYOU RD",
    "dropdelcty": "SANTA ROSA BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 324599997,
    "dropphyadd": "33 CHURCHILL BAYOU RD",
    "dropphycty": "SANTA ROSA BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 324599997,
    "dropmaladd": "33 CHURCHILL BAYOU RD",
    "dropmalcty": "SANTA ROSA BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 324599997,
    "dropsitphn": 9043592957,
    "dropsitlph": 8502672280,
    "dropsitcph": 8502672280,
    "dropfax": 8502673520
  },
  {
    "dcode": "D",
    "dropkey": 4019959,
    "droptype": "D",
    "dropname": "WILLIAMSBURG ANNEX",
    "dropdeladd": "124 FORREST ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112069908,
    "dropphyadd": "124 FORREST ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112069908,
    "dropmaladd": "124 FORREST ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112069908,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 7183483135,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019970,
    "droptype": "D",
    "dropname": "PEAK DELIVERY ANNEX",
    "dropdeladd": "135 CALLE A",
    "dropdelcty": "BAYAMON",
    "dropdelst": "PR",
    "dropdelzpp": "009619997",
    "dropphyadd": "135 CALLE A",
    "dropphycty": "BAYAMON",
    "dropphyst": "PR",
    "dropphyzpp": "009619997",
    "dropmaladd": "135 CALLE A",
    "dropmalcty": "BAYAMON",
    "dropmalst": "PR",
    "dropmalzpp": "009619997",
    "dropsitphn": 7876221795,
    "dropsitlph": 7876221659,
    "dropsitcph": 7877850415,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4019982,
    "droptype": "D",
    "dropname": "NORTHVILLE CARRIER ANNEX",
    "dropdeladd": "23231 INDUSTRIAL PARK DR STE B",
    "dropdelcty": "FARMINGTON HILLS",
    "dropdelst": "MI",
    "dropdelzpp": 483359998,
    "dropphyadd": "23231 INDUSTRIAL PARK DR STE B",
    "dropphycty": "FARMINGTON HILLS",
    "dropphyst": "MI",
    "dropphyzpp": 483359998,
    "dropmaladd": "23231 INDUSTRIAL PARK DR STE B",
    "dropmalcty": "FARMINGTON HILLS",
    "dropmalst": "MI",
    "dropmalzpp": 483359998,
    "dropsitphn": 3132268558,
    "dropsitlph": 3132268554,
    "dropsitcph": 2483492062,
    "dropfax": 2483498134
  },
  {
    "dcode": "D",
    "dropkey": 4020025,
    "droptype": "D",
    "dropname": "GREENSBORO CARRIER ANNEX",
    "dropdeladd": "1041 WESTEND DR STE 110",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "GA",
    "dropdelzpp": 306425326,
    "dropphyadd": "1041 WESTEND DR STE 110",
    "dropphycty": "GREENSBORO",
    "dropphyst": "GA",
    "dropphyzpp": 306425326,
    "dropmaladd": "1041 WESTEND DR STE 110",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "GA",
    "dropmalzpp": 306425326,
    "dropsitphn": 4047657578,
    "dropsitlph": 7064537931,
    "dropsitcph": 7064537931,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020027,
    "droptype": "D",
    "dropname": "MIDTOWN CARRIER ANNEX",
    "dropdeladd": "415 PLASTERS AVE NE STE 100",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303243911,
    "dropphyadd": "415 PLASTERS AVE NE STE 100",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303243911,
    "dropmaladd": "415 PLASTERS AVE NE STE 100",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303243911,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047952231,
    "dropsitcph": 4048734813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020102,
    "droptype": "D",
    "dropname": "WORLD GOLF VILLAGE ANNEX",
    "dropdeladd": "455 W TOWN PL",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "FL",
    "dropdelzpp": 320929998,
    "dropphyadd": "455 W TOWN PL",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "FL",
    "dropphyzpp": 320929998,
    "dropmaladd": "455 W TOWN PL",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "FL",
    "dropmalzpp": 320929998,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048105187,
    "dropsitcph": 9048105187,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020103,
    "droptype": "D",
    "dropname": "SAINT AUGUSTINE ANNEX",
    "dropdeladd": "1740 DOBBS RD",
    "dropdelcty": "SAINT AUGUSTINE",
    "dropdelst": "FL",
    "dropdelzpp": 320846299,
    "dropphyadd": "1740 DOBBS RD",
    "dropphycty": "SAINT AUGUSTINE",
    "dropphyst": "FL",
    "dropphyzpp": 320846299,
    "dropmaladd": "1740 DOBBS RD",
    "dropmalcty": "SAINT AUGUSTINE",
    "dropmalst": "FL",
    "dropmalzpp": 320846299,
    "dropsitphn": 9043592957,
    "dropsitlph": 9048298653,
    "dropsitcph": 9048291142,
    "dropfax": 9048244462
  },
  {
    "dcode": "D",
    "dropkey": 4020139,
    "droptype": "D",
    "dropname": "SOUTHWEST PORTLAND",
    "dropdeladd": "2300 SW 6TH AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972014915,
    "dropphyadd": "2300 SW 6TH AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972014915,
    "dropmaladd": "2300 SW 6TH AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972014915,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5032281003,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020153,
    "droptype": "D",
    "dropname": "GREENMEAD ANNEX",
    "dropdeladd": "900 E GAGE AVE",
    "dropdelcty": "LOS ANGELES",
    "dropdelst": "CA",
    "dropdelzpp": 900599998,
    "dropphyadd": "900 E GAGE AVE",
    "dropphycty": "LOS ANGELES",
    "dropphyst": "CA",
    "dropphyzpp": 900599998,
    "dropmaladd": "900 E GAGE AVE",
    "dropmalcty": "LOS ANGELES",
    "dropmalst": "CA",
    "dropmalzpp": 900599998,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3235664165,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020158,
    "droptype": "D",
    "dropname": "SOUTHPORT ANNEX NEW",
    "dropdeladd": "5260 DOSHER CUTOFF SE",
    "dropdelcty": "SOUTHPORT",
    "dropdelst": "NC",
    "dropdelzpp": 284618906,
    "dropphyadd": "5260 DOSHER CUTOFF SE",
    "dropphycty": "SOUTHPORT",
    "dropphyst": "NC",
    "dropphyzpp": 284618906,
    "dropmaladd": "5260 DOSHER CUTOFF SE",
    "dropmalcty": "SOUTHPORT",
    "dropmalst": "NC",
    "dropmalzpp": 284618906,
    "dropsitphn": 7043934581,
    "dropsitlph": 9104574633,
    "dropsitcph": 9104574633,
    "dropfax": 9104574466
  },
  {
    "dcode": "D",
    "dropkey": 4020207,
    "droptype": "D",
    "dropname": "PLEASANT RIDGE ANNEX",
    "dropdeladd": "1120 PLEASANT RIDGE RD",
    "dropdelcty": "GREENSBORO",
    "dropdelst": "NC",
    "dropdelzpp": 274989708,
    "dropphyadd": "1120 PLEASANT RIDGE RD",
    "dropphycty": "GREENSBORO",
    "dropphyst": "NC",
    "dropphyzpp": 274989708,
    "dropmaladd": "1120 PLEASANT RIDGE RD",
    "dropmalcty": "GREENSBORO",
    "dropmalst": "NC",
    "dropmalzpp": 274989708,
    "dropsitphn": 3369319357,
    "dropsitlph": 3369319357,
    "dropsitcph": 3369319357,
    "dropfax": 3368511377
  },
  {
    "dcode": "D",
    "dropkey": 4020284,
    "droptype": "D",
    "dropname": "PORTER SQUARE CARRIER ANNEX",
    "dropdeladd": "30 COBBLE HILL RD",
    "dropdelcty": "SOMERVILLE",
    "dropdelst": "MA",
    "dropdelzpp": "021439997",
    "dropphyadd": "30 COBBLE HILL RD",
    "dropphycty": "SOMERVILLE",
    "dropphyst": "MA",
    "dropphyzpp": "021439997",
    "dropmaladd": "30 COBBLE HILL RD",
    "dropmalcty": "SOMERVILLE",
    "dropmalst": "MA",
    "dropmalzpp": "021439997",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 6174928778,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020461,
    "droptype": "D",
    "dropname": "BRYAN TX S&DC",
    "dropdeladd": "2121 E WM J BRYAN PKWY",
    "dropdelcty": "BRYAN",
    "dropdelst": "TX",
    "dropdelzpp": 778019903,
    "dropphyadd": "2121 E WM J BRYAN PKWY",
    "dropphycty": "BRYAN",
    "dropphyst": "TX",
    "dropphyzpp": 778019903,
    "dropmaladd": "2121 E WM J BRYAN PKWY",
    "dropmalcty": "BRYAN",
    "dropmalst": "TX",
    "dropmalzpp": 778019903,
    "dropsitphn": 9797747068,
    "dropsitlph": 9797742314,
    "dropsitcph": 9797742300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020469,
    "droptype": "D",
    "dropname": "CASTLE ROCK ANNEX",
    "dropdeladd": "300 E MILLER CT",
    "dropdelcty": "CASTLE ROCK",
    "dropdelst": "CO",
    "dropdelzpp": 801048436,
    "dropphyadd": "300 E MILLER CT",
    "dropphycty": "CASTLE ROCK",
    "dropphyst": "CO",
    "dropphyzpp": 801048436,
    "dropmaladd": "300 E MILLER CT",
    "dropmalcty": "CASTLE ROCK",
    "dropmalst": "CO",
    "dropmalzpp": 801048436,
    "dropsitphn": 3038536511,
    "dropsitlph": 3038146934,
    "dropsitcph": 3038146932,
    "dropfax": 3036883731
  },
  {
    "dcode": "D",
    "dropkey": 4020475,
    "droptype": "D",
    "dropname": "WOBURN MA S&DC",
    "dropdeladd": "462 WASHINGTON ST",
    "dropdelcty": "WOBURN",
    "dropdelst": "MA",
    "dropdelzpp": "018019899",
    "dropphyadd": "462 WASHINGTON ST",
    "dropphycty": "WOBURN",
    "dropphyst": "MA",
    "dropphyzpp": "018019899",
    "dropmaladd": "462 WASHINGTON ST",
    "dropmalcty": "WOBURN",
    "dropmalst": "MA",
    "dropmalzpp": "018019899",
    "dropsitphn": 9786647013,
    "dropsitlph": 9786647013,
    "dropsitcph": 7819378600,
    "dropfax": 7819375827
  },
  {
    "dcode": "D",
    "dropkey": 4020477,
    "droptype": "D",
    "dropname": "GAINESVILLE FL S&DC",
    "dropdeladd": "4600 SW 34TH ST",
    "dropdelcty": "GAINESVILLE",
    "dropdelst": "FL",
    "dropdelzpp": 326089901,
    "dropphyadd": "4600 SW 34TH ST",
    "dropphycty": "GAINESVILLE",
    "dropphyst": "FL",
    "dropphyzpp": 326089901,
    "dropmaladd": "4600 SW 34TH ST",
    "dropmalcty": "GAINESVILLE",
    "dropmalst": "FL",
    "dropmalzpp": 326089901,
    "dropsitphn": 9043592957,
    "dropsitlph": 3523341899,
    "dropsitcph": 3523341899,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020478,
    "droptype": "D",
    "dropname": "PANAMA CITY FL S&DC",
    "dropdeladd": "1336 SHERMAN AVE",
    "dropdelcty": "PANAMA CITY",
    "dropdelst": "FL",
    "dropdelzpp": 324019502,
    "dropphyadd": "1336 SHERMAN AVE",
    "dropphycty": "PANAMA CITY",
    "dropphyst": "FL",
    "dropphyzpp": 324019502,
    "dropmaladd": "1336 SHERMAN AVE",
    "dropmalcty": "PANAMA CITY",
    "dropmalst": "FL",
    "dropmalzpp": 324019502,
    "dropsitphn": 9043592957,
    "dropsitlph": 8507473901,
    "dropsitcph": 8507474890,
    "dropfax": 8507474814
  },
  {
    "dcode": "D",
    "dropkey": 4020479,
    "droptype": "D",
    "dropname": "BOULEVARD",
    "dropdeladd": "2801 LEVICK ST",
    "dropdelcty": "PHILADELPHIA",
    "dropdelst": "PA",
    "dropdelzpp": 191499998,
    "dropphyadd": "2801 LEVICK ST",
    "dropphycty": "PHILADELPHIA",
    "dropphyst": "PA",
    "dropphyzpp": 191499998,
    "dropmaladd": "2801 LEVICK ST",
    "dropmalcty": "PHILADELPHIA",
    "dropmalst": "PA",
    "dropmalzpp": 191499998,
    "dropsitphn": 2158958561,
    "dropsitlph": 2156247770,
    "dropsitcph": 2156247770,
    "dropfax": 2153312953
  },
  {
    "dcode": "D",
    "dropkey": 4020481,
    "droptype": "D",
    "dropname": "CENTRAL CARRIER ANNEX",
    "dropdeladd": "1300 FLORIDA AVE",
    "dropdelcty": "NEW ORLEANS",
    "dropdelst": "LA",
    "dropdelzpp": 701199998,
    "dropphyadd": "1300 FLORIDA AVE",
    "dropphycty": "NEW ORLEANS",
    "dropphyst": "LA",
    "dropphyzpp": 701199998,
    "dropmaladd": "1300 FLORIDA AVE",
    "dropmalcty": "NEW ORLEANS",
    "dropmalst": "LA",
    "dropmalzpp": 701199998,
    "dropsitphn": 5045891255,
    "dropsitlph": 5045891255,
    "dropsitcph": 5049498259,
    "dropfax": 5049492719
  },
  {
    "dcode": "D",
    "dropkey": 4020509,
    "droptype": "D",
    "dropname": "TOPEKA KS S&DC",
    "dropdeladd": "1410 NW GAGE BLVD RM 111",
    "dropdelcty": "TOPEKA",
    "dropdelst": "KS",
    "dropdelzpp": 666189801,
    "dropphyadd": "1410 NW GAGE BLVD RM 111",
    "dropphycty": "TOPEKA",
    "dropphyst": "KS",
    "dropphyzpp": 666189801,
    "dropmaladd": "1410 NW GAGE BLVD RM 111",
    "dropmalcty": "TOPEKA",
    "dropmalst": "KS",
    "dropmalzpp": 666189801,
    "dropsitphn": 7852313512,
    "dropsitlph": 7852313535,
    "dropsitcph": 7852313532,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020510,
    "droptype": "D",
    "dropname": "OWENSBORO KY S&DC",
    "dropdeladd": "54 BON HARBOR HLS",
    "dropdelcty": "OWENSBORO",
    "dropdelst": "KY",
    "dropdelzpp": 423019996,
    "dropphyadd": "54 BON HARBOR HLS",
    "dropphycty": "OWENSBORO",
    "dropphyst": "KY",
    "dropphyzpp": 423019996,
    "dropmaladd": "54 BON HARBOR HLS",
    "dropmalcty": "OWENSBORO",
    "dropmalst": "KY",
    "dropmalzpp": 423019996,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2706891838,
    "dropfax": 2706868895
  },
  {
    "dcode": "D",
    "dropkey": 4020511,
    "droptype": "D",
    "dropname": "GOLDEN CO S&DC",
    "dropdeladd": "1100 JOHNSON RD",
    "dropdelcty": "GOLDEN",
    "dropdelst": "CO",
    "dropdelzpp": 804019967,
    "dropphyadd": "1100 JOHNSON RD",
    "dropphycty": "GOLDEN",
    "dropphyst": "CO",
    "dropphyzpp": 804019967,
    "dropmaladd": "1100 JOHNSON RD",
    "dropmalcty": "GOLDEN",
    "dropmalst": "CO",
    "dropmalzpp": 804019967,
    "dropsitphn": 3034458900,
    "dropsitlph": 3038536758,
    "dropsitcph": 3038536758,
    "dropfax": 3038538954
  },
  {
    "dcode": "D",
    "dropkey": 4020512,
    "droptype": "D",
    "dropname": "KOKOMO IN S&DC",
    "dropdeladd": "2719 S WEBSTER ST",
    "dropdelcty": "KOKOMO",
    "dropdelst": "IN",
    "dropdelzpp": 469029960,
    "dropphyadd": "2719 S WEBSTER ST",
    "dropphycty": "KOKOMO",
    "dropphyst": "IN",
    "dropphyzpp": 469029960,
    "dropmaladd": "2719 S WEBSTER ST",
    "dropmalcty": "KOKOMO",
    "dropmalst": "IN",
    "dropmalzpp": 469029960,
    "dropsitphn": 3174646350,
    "dropsitlph": 7654558326,
    "dropsitcph": 7654558326,
    "dropfax": 7654558350
  },
  {
    "dcode": "D",
    "dropkey": 4020513,
    "droptype": "D",
    "dropname": "PASCO WA S&DC",
    "dropdeladd": "3500 W COURT ST",
    "dropdelcty": "PASCO",
    "dropdelst": "WA",
    "dropdelzpp": 993019985,
    "dropphyadd": "3500 W COURT ST",
    "dropphycty": "PASCO",
    "dropphyst": "WA",
    "dropphyzpp": 993019985,
    "dropmaladd": "3500 W COURT ST",
    "dropmalcty": "PASCO",
    "dropmalst": "WA",
    "dropmalzpp": 993019985,
    "dropsitphn": 5095432137,
    "dropsitlph": 5095432113,
    "dropsitcph": 5095432189,
    "dropfax": 5095432107
  },
  {
    "dcode": "D",
    "dropkey": 4020514,
    "droptype": "D",
    "dropname": "HANOVER PARK IL S&DC",
    "dropdeladd": "2670 W LAKE ST",
    "dropdelcty": "HANOVER PARK",
    "dropdelst": "IL",
    "dropdelzpp": 601339904,
    "dropphyadd": "2670 W LAKE ST",
    "dropphycty": "HANOVER PARK",
    "dropphyst": "IL",
    "dropphyzpp": 601339904,
    "dropmaladd": "2670 W LAKE ST",
    "dropmalcty": "HANOVER PARK",
    "dropmalst": "IL",
    "dropmalzpp": 601339904,
    "dropsitphn": 6302605499,
    "dropsitlph": 6308374468,
    "dropsitcph": 6308374468,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020515,
    "droptype": "D",
    "dropname": "ANNAPOLIS MD S&DC",
    "dropdeladd": "210 ADMIRAL COCHRANE DR",
    "dropdelcty": "ANNAPOLIS",
    "dropdelst": "MD",
    "dropdelzpp": 214010109,
    "dropphyadd": "210 ADMIRAL COCHRANE DR",
    "dropphycty": "ANNAPOLIS",
    "dropphyst": "MD",
    "dropphyzpp": 214010109,
    "dropmaladd": "210 ADMIRAL COCHRANE DR",
    "dropmalcty": "ANNAPOLIS",
    "dropmalst": "MD",
    "dropmalzpp": 214010109,
    "dropsitphn": 4103474518,
    "dropsitlph": 4105736537,
    "dropsitcph": 4105736537,
    "dropfax": 4106261217
  },
  {
    "dcode": "D",
    "dropkey": 4020549,
    "droptype": "D",
    "dropname": "CHULA VISTA CA S&DC",
    "dropdeladd": "750 3RD AVE",
    "dropdelcty": "CHULA VISTA",
    "dropdelst": "CA",
    "dropdelzpp": 919109900,
    "dropphyadd": "750 3RD AVE",
    "dropphycty": "CHULA VISTA",
    "dropphyst": "CA",
    "dropphyzpp": 919109900,
    "dropmaladd": "750 3RD AVE",
    "dropmalcty": "CHULA VISTA",
    "dropmalst": "CA",
    "dropmalzpp": 919109900,
    "dropsitphn": 8586740173,
    "dropsitlph": 6194980071,
    "dropsitcph": 6194980687,
    "dropfax": 6194227256
  },
  {
    "dcode": "D",
    "dropkey": 4020550,
    "droptype": "D",
    "dropname": "HUNTINGTON STATION NY S&DC",
    "dropdeladd": "888 E JERICHO TPKE",
    "dropdelcty": "HUNTINGTON STATION",
    "dropdelst": "NY",
    "dropdelzpp": 117467522,
    "dropphyadd": "888 E JERICHO TPKE",
    "dropphycty": "HUNTINGTON STATION",
    "dropphyst": "NY",
    "dropphyzpp": 117467522,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HUNTINGTON STATION",
    "dropmalst": "NY",
    "dropmalzpp": 117469998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 6314270594,
    "dropfax": 6312714437
  },
  {
    "dcode": "D",
    "dropkey": 4020551,
    "droptype": "D",
    "dropname": "STOCKTON WEST LANE CA S&DC",
    "dropdeladd": "4245 WEST LN",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952089997,
    "dropphyadd": "4245 WEST LN",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952089997,
    "dropmaladd": "4245 WEST LN",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952089997,
    "dropsitphn": 9163738025,
    "dropsitlph": 2094603667,
    "dropsitcph": 2094603667,
    "dropfax": 2094603663
  },
  {
    "dcode": "D",
    "dropkey": 4020552,
    "droptype": "D",
    "dropname": "BRIDGEPORT CT S&DC",
    "dropdeladd": "120 MIDDLE ST",
    "dropdelcty": "BRIDGEPORT",
    "dropdelst": "CT",
    "dropdelzpp": "066029996",
    "dropphyadd": "120 MIDDLE ST",
    "dropphycty": "BRIDGEPORT",
    "dropphyst": "CT",
    "dropphyzpp": "066029996",
    "dropmaladd": "120 MIDDLE ST",
    "dropmalcty": "BRIDGEPORT",
    "dropmalst": "CT",
    "dropmalzpp": "066029996",
    "dropsitphn": 2033325302,
    "dropsitlph": 2033325302,
    "dropsitcph": 2033325307,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020553,
    "droptype": "D",
    "dropname": "STEWART NY S&DC",
    "dropdeladd": "99 ENTERPRISE DR",
    "dropdelcty": "NEWBURGH",
    "dropdelst": "NY",
    "dropdelzpp": 125559996,
    "dropphyadd": "99 ENTERPRISE DR",
    "dropphycty": "NEWBURGH",
    "dropphyst": "NY",
    "dropphyzpp": 125559996,
    "dropmaladd": "99 ENTERPRISE DR",
    "dropmalcty": "NEWBURGH",
    "dropmalst": "NY",
    "dropmalzpp": 125559996,
    "dropsitphn": 9146974123,
    "dropsitlph": 9146974123,
    "dropsitcph": 8455672301,
    "dropfax": 8455672309
  },
  {
    "dcode": "D",
    "dropkey": 4020554,
    "droptype": "D",
    "dropname": "TULSA DOWNTOWN OK S&DC",
    "dropdeladd": "333 W 4TH ST FL 1",
    "dropdelcty": "TULSA",
    "dropdelst": "OK",
    "dropdelzpp": 741039900,
    "dropphyadd": "333 W 4TH ST FL 1",
    "dropphycty": "TULSA",
    "dropphyst": "OK",
    "dropphyzpp": 741039900,
    "dropmaladd": "333 W 4TH ST FL 1",
    "dropmalcty": "TULSA",
    "dropmalst": "OK",
    "dropmalzpp": 741039900,
    "dropsitphn": 9182707512,
    "dropsitlph": 9185840493,
    "dropsitcph": 9185840489,
    "dropfax": 9185991136
  },
  {
    "dcode": "D",
    "dropkey": 4020555,
    "droptype": "D",
    "dropname": "SOUTH ATLANTA GA S&DC",
    "dropdeladd": "1800 JAMES JACKSON PKWY NW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303691100,
    "dropphyadd": "1800 JAMES JACKSON PKWY NW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303691100,
    "dropmaladd": "1800 JAMES JACKSON PKWY NW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303691100,
    "dropsitphn": 4047923125,
    "dropsitlph": 4047923008,
    "dropsitcph": 4047923270,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020556,
    "droptype": "D",
    "dropname": "NORTH ATLANTA GA S&DC",
    "dropdeladd": "1920 DRESDEN DR NE",
    "dropdelcty": "BROOKHAVEN",
    "dropdelst": "GA",
    "dropdelzpp": 303193634,
    "dropphyadd": "1920 DRESDEN DR NE",
    "dropphycty": "BROOKHAVEN",
    "dropphyst": "GA",
    "dropphyzpp": 303193634,
    "dropmaladd": "1920 DRESDEN DR NE",
    "dropmalcty": "BROOKHAVEN",
    "dropmalst": "GA",
    "dropmalzpp": 303193634,
    "dropsitphn": 4047657578,
    "dropsitlph": 4709035374,
    "dropsitcph": 4046344650,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020557,
    "droptype": "D",
    "dropname": "IRVINE CA S&DC",
    "dropdeladd": "15642 SAND CANYON AVE",
    "dropdelcty": "IRVINE",
    "dropdelst": "CA",
    "dropdelzpp": 926199996,
    "dropphyadd": "15642 SAND CANYON AVE",
    "dropphycty": "IRVINE",
    "dropphyst": "CA",
    "dropphyzpp": 926199996,
    "dropmaladd": "15642 SAND CANYON AVE",
    "dropmalcty": "IRVINE",
    "dropmalst": "CA",
    "dropmalzpp": 926199996,
    "dropsitphn": 9494534910,
    "dropsitlph": 9494534953,
    "dropsitcph": 9494534910,
    "dropfax": 9497279322
  },
  {
    "dcode": "D",
    "dropkey": 4020558,
    "droptype": "D",
    "dropname": "MORGANTOWN WV S&DC",
    "dropdeladd": "300 POSTAL PLZ",
    "dropdelcty": "MORGANTOWN",
    "dropdelst": "WV",
    "dropdelzpp": 265089994,
    "dropphyadd": "300 POSTAL PLZ",
    "dropphycty": "MORGANTOWN",
    "dropphyst": "WV",
    "dropphyzpp": 265089994,
    "dropmaladd": "300 POSTAL PLZ",
    "dropmalcty": "MORGANTOWN",
    "dropmalst": "WV",
    "dropmalzpp": 265089994,
    "dropsitphn": "",
    "dropsitlph": "",
    "dropsitcph": 3042963011,
    "dropfax": 3042849819
  },
  {
    "dcode": "D",
    "dropkey": 4020559,
    "droptype": "D",
    "dropname": "WACO TX S&DC",
    "dropdeladd": "430 W STATE HIGHWAY 6",
    "dropdelcty": "WACO",
    "dropdelst": "TX",
    "dropdelzpp": 767029300,
    "dropphyadd": "430 W STATE HIGHWAY 6",
    "dropphycty": "WACO",
    "dropphyst": "TX",
    "dropphyzpp": 767029300,
    "dropmaladd": "430 W STATE HIGHWAY 6",
    "dropmalcty": "WACO",
    "dropmalst": "TX",
    "dropmalzpp": 767029300,
    "dropsitphn": 2103688387,
    "dropsitlph": 2543992296,
    "dropsitcph": 2543992201,
    "dropfax": 2543992287
  },
  {
    "dcode": "D",
    "dropkey": 4020560,
    "droptype": "D",
    "dropname": "COLUMBIA SC S&DC",
    "dropdeladd": "1601 ASSEMBLY ST",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "SC",
    "dropdelzpp": 292019958,
    "dropphyadd": "1601 ASSEMBLY ST",
    "dropphycty": "COLUMBIA",
    "dropphyst": "SC",
    "dropphyzpp": 292019958,
    "dropmaladd": "1601 ASSEMBLY ST",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "SC",
    "dropmalzpp": 292019958,
    "dropsitphn": 8039266014,
    "dropsitlph": 8039266120,
    "dropsitcph": 8037334600,
    "dropfax": 8037717717
  },
  {
    "dcode": "D",
    "dropkey": 4020561,
    "droptype": "D",
    "dropname": "TERRE HAUTE IN S&DC",
    "dropdeladd": "150 W MARGARET DR",
    "dropdelcty": "TERRE HAUTE",
    "dropdelst": "IN",
    "dropdelzpp": 478029926,
    "dropphyadd": "150 W MARGARET DR",
    "dropphycty": "TERRE HAUTE",
    "dropphyst": "IN",
    "dropphyzpp": 478029926,
    "dropmaladd": "150 W MARGARET DR",
    "dropmalcty": "TERRE HAUTE",
    "dropmalst": "IN",
    "dropmalzpp": 478029926,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8122314040,
    "dropfax": 8122314140
  },
  {
    "dcode": "D",
    "dropkey": 4020562,
    "droptype": "D",
    "dropname": "ROCKFORD IL S&DC",
    "dropdeladd": "5225 HARRISON AVE",
    "dropdelcty": "ROCKFORD",
    "dropdelst": "IL",
    "dropdelzpp": 611259700,
    "dropphyadd": "5225 HARRISON AVE",
    "dropphycty": "ROCKFORD",
    "dropphyst": "IL",
    "dropphyzpp": 611259700,
    "dropmaladd": "5225 HARRISON AVE",
    "dropmalcty": "ROCKFORD",
    "dropmalst": "IL",
    "dropmalzpp": 611259700,
    "dropsitphn": 6302605499,
    "dropsitlph": 8152294806,
    "dropsitcph": 8152294806,
    "dropfax": 8152294857
  },
  {
    "dcode": "D",
    "dropkey": 4020563,
    "droptype": "D",
    "dropname": "PALO ALTO CA S&DC",
    "dropdeladd": "2085 E BAYSHORE RD",
    "dropdelcty": "EAST PALO ALTO",
    "dropdelst": "CA",
    "dropdelzpp": 943039997,
    "dropphyadd": "2085 E BAYSHORE RD",
    "dropphycty": "EAST PALO ALTO",
    "dropphyst": "CA",
    "dropphyzpp": 943039997,
    "dropmaladd": "2085 E BAYSHORE RD",
    "dropmalcty": "EAST PALO ALTO",
    "dropmalst": "CA",
    "dropmalzpp": 943039997,
    "dropsitphn": 4155505045,
    "dropsitlph": 6502725262,
    "dropsitcph": 6503211423,
    "dropfax": 6503212622
  },
  {
    "dcode": "D",
    "dropkey": 4020570,
    "droptype": "D",
    "dropname": "LOUISBURG CARRIER ANNEX",
    "dropdeladd": "497 RETAIL WAY",
    "dropdelcty": "LOUISBURG",
    "dropdelst": "NC",
    "dropdelzpp": 275499916,
    "dropphyadd": "497 RETAIL WAY",
    "dropphycty": "LOUISBURG",
    "dropphyst": "NC",
    "dropphyzpp": 275499916,
    "dropmaladd": "497 RETAIL WAY",
    "dropmalcty": "LOUISBURG",
    "dropmalst": "NC",
    "dropmalzpp": 275499916,
    "dropsitphn": 3369319444,
    "dropsitlph": 9194205175,
    "dropsitcph": 9194961084,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020606,
    "droptype": "D",
    "dropname": "MELROSE VISTA CARRIER ANNEX",
    "dropdeladd": "1900 W OAKLAND PARK BLVD STE 104",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333109919,
    "dropphyadd": "1900 W OAKLAND PARK BLVD STE 104",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333109919,
    "dropmaladd": "1900 W OAKLAND PARK BLVD STE 104",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333109919,
    "dropsitphn": 3055132368,
    "dropsitlph": 9543168052,
    "dropsitcph": 9543168052,
    "dropfax": 9543163942
  },
  {
    "dcode": "D",
    "dropkey": 4020645,
    "droptype": "D",
    "dropname": "ASHEVILLE NC S&DC",
    "dropdeladd": "591 BREVARD RD",
    "dropdelcty": "ASHEVILLE",
    "dropdelst": "NC",
    "dropdelzpp": 288109900,
    "dropphyadd": "591 BREVARD RD",
    "dropphycty": "ASHEVILLE",
    "dropphyst": "NC",
    "dropphyzpp": 288109900,
    "dropmaladd": "591 BREVARD RD",
    "dropmalcty": "ASHEVILLE",
    "dropmalst": "NC",
    "dropmalzpp": 288109900,
    "dropsitphn": 7043934581,
    "dropsitlph": 8282574194,
    "dropsitcph": 8282574194,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020647,
    "droptype": "D",
    "dropname": "HUNTINGTON WV S&DC",
    "dropdeladd": "1000 VIRGINIA AVE W",
    "dropdelcty": "HUNTINGTON",
    "dropdelst": "WV",
    "dropdelzpp": 257049991,
    "dropphyadd": "1000 VIRGINIA AVE W",
    "dropphycty": "HUNTINGTON",
    "dropphyst": "WV",
    "dropphyzpp": 257049991,
    "dropmaladd": "1000 VIRGINIA AVE W",
    "dropmalcty": "HUNTINGTON",
    "dropmalst": "WV",
    "dropmalzpp": 257049991,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045269600,
    "dropfax": 3045269612
  },
  {
    "dcode": "D",
    "dropkey": 4020648,
    "droptype": "D",
    "dropname": "CANTON OH S&DC",
    "dropdeladd": "2650 CLEVELAND AVE NW",
    "dropdelcty": "CANTON",
    "dropdelst": "OH",
    "dropdelzpp": 447119902,
    "dropphyadd": "2650 CLEVELAND AVE NW",
    "dropphycty": "CANTON",
    "dropphyst": "OH",
    "dropphyzpp": 447119902,
    "dropmaladd": "2650 CLEVELAND AVE NW",
    "dropmalcty": "CANTON",
    "dropmalst": "OH",
    "dropmalzpp": 447119902,
    "dropsitphn": 3309969797,
    "dropsitlph": 3309969798,
    "dropsitcph": 3304386477,
    "dropfax": 3304386407
  },
  {
    "dcode": "D",
    "dropkey": 4020652,
    "droptype": "D",
    "dropname": "LAFAYETTE IN S&DC",
    "dropdeladd": "3450 SOUTH ST",
    "dropdelcty": "LAFAYETTE",
    "dropdelst": "IN",
    "dropdelzpp": 479059952,
    "dropphyadd": "3450 SOUTH ST",
    "dropphycty": "LAFAYETTE",
    "dropphyst": "IN",
    "dropphyzpp": 479059952,
    "dropmaladd": "3450 SOUTH ST",
    "dropmalcty": "LAFAYETTE",
    "dropmalst": "IN",
    "dropmalzpp": 479059952,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 7654489221,
    "dropfax": 7654489292
  },
  {
    "dcode": "D",
    "dropkey": 4020653,
    "droptype": "D",
    "dropname": "HATTIESBURG MS S&DC",
    "dropdeladd": "220 S 40TH AVE",
    "dropdelcty": "HATTIESBURG",
    "dropdelst": "MS",
    "dropdelzpp": 394029903,
    "dropphyadd": "220 S 40TH AVE",
    "dropphycty": "HATTIESBURG",
    "dropphyst": "MS",
    "dropphyzpp": 394029903,
    "dropmaladd": "220 S 40TH AVE",
    "dropmalcty": "HATTIESBURG",
    "dropmalst": "MS",
    "dropmalzpp": 394029903,
    "dropsitphn": 6013517144,
    "dropsitlph": 6012717080,
    "dropsitcph": 6012717000,
    "dropfax": 6012717060
  },
  {
    "dcode": "D",
    "dropkey": 4020654,
    "droptype": "D",
    "dropname": "SALEM OR S&DC",
    "dropdeladd": "1050 25TH ST SE",
    "dropdelcty": "SALEM",
    "dropdelst": "OR",
    "dropdelzpp": 973019913,
    "dropphyadd": "1050 25TH ST SE",
    "dropphycty": "SALEM",
    "dropphyst": "OR",
    "dropphyzpp": 973019913,
    "dropmaladd": "1050 25TH ST SE",
    "dropmalcty": "SALEM",
    "dropmalst": "OR",
    "dropmalzpp": 973019913,
    "dropsitphn": 9712013788,
    "dropsitlph": 5033704710,
    "dropsitcph": 5035404502,
    "dropfax": 5033704707
  },
  {
    "dcode": "D",
    "dropkey": 4020656,
    "droptype": "D",
    "dropname": "OXNARD CA S&DC",
    "dropdeladd": "1961 N C ST",
    "dropdelcty": "OXNARD",
    "dropdelst": "CA",
    "dropdelzpp": 930369997,
    "dropphyadd": "1961 N C ST",
    "dropphycty": "OXNARD",
    "dropphyst": "CA",
    "dropphyzpp": 930369997,
    "dropmaladd": "1961 N C ST",
    "dropmalcty": "OXNARD",
    "dropmalst": "CA",
    "dropmalzpp": 930369997,
    "dropsitphn": 6617757808,
    "dropsitlph": 8052787650,
    "dropsitcph": 8052787615,
    "dropfax": 8052787621
  },
  {
    "dcode": "D",
    "dropkey": 4020659,
    "droptype": "D",
    "dropname": "HICKSVILLE NY S&DC",
    "dropdeladd": "185 W JOHN ST",
    "dropdelcty": "HICKSVILLE",
    "dropdelst": "NY",
    "dropdelzpp": 118018703,
    "dropphyadd": "185 W JOHN ST",
    "dropphycty": "HICKSVILLE",
    "dropphyst": "NY",
    "dropphyzpp": 118018703,
    "dropmaladd": "PO BOX 9998",
    "dropmalcty": "HICKSVILLE",
    "dropmalst": "NY",
    "dropmalzpp": 118029998,
    "dropsitphn": 6317552524,
    "dropsitlph": 6317552524,
    "dropsitcph": 5169332321,
    "dropfax": 5169332309
  },
  {
    "dcode": "D",
    "dropkey": 4020660,
    "droptype": "D",
    "dropname": "PHOENIX RIO SALADO AZ S&DC",
    "dropdeladd": "1441 E BUCKEYE RD LBBY",
    "dropdelcty": "PHOENIX",
    "dropdelst": "AZ",
    "dropdelzpp": 850349111,
    "dropphyadd": "1441 E BUCKEYE RD LBBY",
    "dropphycty": "PHOENIX",
    "dropphyst": "AZ",
    "dropphyzpp": 850349111,
    "dropmaladd": "1441 E BUCKEYE RD LBBY",
    "dropmalcty": "PHOENIX",
    "dropmalst": "AZ",
    "dropmalzpp": 850349111,
    "dropsitphn": 6022253232,
    "dropsitlph": 6022233242,
    "dropsitcph": 6022233232,
    "dropfax": 6022233695
  },
  {
    "dcode": "D",
    "dropkey": 4020661,
    "droptype": "D",
    "dropname": "SOUTHERN MARYLAND MD S&DC",
    "dropdeladd": "6511 BALTIMORE AVE",
    "dropdelcty": "HYATTSVILLE",
    "dropdelst": "MD",
    "dropdelzpp": 207829907,
    "dropphyadd": "6511 BALTIMORE AVE",
    "dropphycty": "HYATTSVILLE",
    "dropphyst": "MD",
    "dropphyzpp": 207829907,
    "dropmaladd": "6511 BALTIMORE AVE",
    "dropmalcty": "HYATTSVILLE",
    "dropmalst": "MD",
    "dropmalzpp": 207829907,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012093430,
    "dropsitcph": 3012094202,
    "dropfax": 3012093460
  },
  {
    "dcode": "D",
    "dropkey": 4020666,
    "droptype": "D",
    "dropname": "BEAVERTON OR S&DC",
    "dropdeladd": "3685 NE ALOCLEK DR",
    "dropdelcty": "PORTLAND",
    "dropdelst": "OR",
    "dropdelzpp": 972919800,
    "dropphyadd": "3685 NE ALOCLEK DR",
    "dropphycty": "PORTLAND",
    "dropphyst": "OR",
    "dropphyzpp": 972919800,
    "dropmaladd": "3685 NE ALOCLEK DR",
    "dropmalcty": "PORTLAND",
    "dropmalst": "OR",
    "dropmalzpp": 972919800,
    "dropsitphn": 9712013788,
    "dropsitlph": 5036149801,
    "dropsitcph": 5036149516,
    "dropfax": 5036909476
  },
  {
    "dcode": "D",
    "dropkey": 4020668,
    "droptype": "D",
    "dropname": "FORT LAUDERDALE FL S&DC",
    "dropdeladd": "1900 W OAKLAND PARK BLVD",
    "dropdelcty": "OAKLAND PARK",
    "dropdelst": "FL",
    "dropdelzpp": 333109988,
    "dropphyadd": "1900 W OAKLAND PARK BLVD",
    "dropphycty": "OAKLAND PARK",
    "dropphyst": "FL",
    "dropphyzpp": 333109988,
    "dropmaladd": "1900 W OAKLAND PARK BLVD",
    "dropmalcty": "OAKLAND PARK",
    "dropmalst": "FL",
    "dropmalzpp": 333109988,
    "dropsitphn": 3055132368,
    "dropsitlph": 9547655740,
    "dropsitcph": 9545273245,
    "dropfax": 9545273203
  },
  {
    "dcode": "D",
    "dropkey": 4020669,
    "droptype": "D",
    "dropname": "ORANGE CA S&DC",
    "dropdeladd": "1075 N TUSTIN ST",
    "dropdelcty": "ORANGE",
    "dropdelst": "CA",
    "dropdelzpp": 928639961,
    "dropphyadd": "1075 N TUSTIN ST",
    "dropphycty": "ORANGE",
    "dropphyst": "CA",
    "dropphyzpp": 928639961,
    "dropmaladd": "1075 N TUSTIN ST",
    "dropmalcty": "ORANGE",
    "dropmalst": "CA",
    "dropmalzpp": 928639961,
    "dropsitphn": 7149971889,
    "dropsitlph": 7149228254,
    "dropsitcph": 7149971889,
    "dropfax": 7149971054
  },
  {
    "dcode": "D",
    "dropkey": 4020671,
    "droptype": "D",
    "dropname": "SAINT PETERSBURG FL S&DC",
    "dropdeladd": "3135 1ST AVE N",
    "dropdelcty": "SAINT PETERSBURG",
    "dropdelst": "FL",
    "dropdelzpp": 337309920,
    "dropphyadd": "3135 1ST AVE N",
    "dropphycty": "SAINT PETERSBURG",
    "dropphyst": "FL",
    "dropphyzpp": 337309920,
    "dropmaladd": "3135 1ST AVE N",
    "dropmalcty": "SAINT PETERSBURG",
    "dropmalst": "FL",
    "dropmalzpp": 337309920,
    "dropsitphn": 8138770788,
    "dropsitlph": 7273236568,
    "dropsitcph": 7273236585,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020672,
    "droptype": "D",
    "dropname": "LAKELAND FL S&DC",
    "dropdeladd": "2800 LAKELAND HILLS BLVD",
    "dropdelcty": "LAKELAND",
    "dropdelst": "FL",
    "dropdelzpp": 338059900,
    "dropphyadd": "2800 LAKELAND HILLS BLVD",
    "dropphycty": "LAKELAND",
    "dropphyst": "FL",
    "dropphyzpp": 338059900,
    "dropmaladd": "2800 LAKELAND HILLS BLVD",
    "dropmalcty": "LAKELAND",
    "dropmalst": "FL",
    "dropmalzpp": 338059900,
    "dropsitphn": 8138770729,
    "dropsitlph": 8638022053,
    "dropsitcph": 8638022066,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020673,
    "droptype": "D",
    "dropname": "KILMER NJ S&DC",
    "dropdeladd": "21 KILMER RD",
    "dropdelcty": "EDISON",
    "dropdelst": "NJ",
    "dropdelzpp": "088999988",
    "dropphyadd": "21 KILMER RD",
    "dropphycty": "EDISON",
    "dropphyst": "NJ",
    "dropphyzpp": "088999988",
    "dropmaladd": "21 KILMER RD",
    "dropmalcty": "EDISON",
    "dropmalst": "NJ",
    "dropmalzpp": "088999988",
    "dropsitphn": 7328194333,
    "dropsitlph": 7328194333,
    "dropsitcph": 7328194333,
    "dropfax": 7328194387
  },
  {
    "dcode": "D",
    "dropkey": 4020674,
    "droptype": "D",
    "dropname": "NEWARK NJ S&DC",
    "dropdeladd": "2 FEDERAL SQ",
    "dropdelcty": "NEWARK",
    "dropdelst": "NJ",
    "dropdelzpp": "071029955",
    "dropphyadd": "2 FEDERAL SQ",
    "dropphycty": "NEWARK",
    "dropphyst": "NJ",
    "dropphyzpp": "071029955",
    "dropmaladd": "2 FEDERAL SQ",
    "dropmalcty": "NEWARK",
    "dropmalst": "NJ",
    "dropmalzpp": "071029955",
    "dropsitphn": 2019559705,
    "dropsitlph": 9736935230,
    "dropsitcph": 9736935231,
    "dropfax": 9736935286
  },
  {
    "dcode": "D",
    "dropkey": 4020675,
    "droptype": "D",
    "dropname": "SPRINGFIELD MA S&DC",
    "dropdeladd": "1883 MAIN ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MA",
    "dropdelzpp": "011019918",
    "dropphyadd": "1883 MAIN ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MA",
    "dropphyzpp": "011019918",
    "dropmaladd": "1883 MAIN ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MA",
    "dropmalzpp": "011019918",
    "dropsitphn": 4137856420,
    "dropsitlph": 4137856246,
    "dropsitcph": 4137310573,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020676,
    "droptype": "D",
    "dropname": "BOSTON MA S&DC",
    "dropdeladd": "333 COMMERCE DR",
    "dropdelcty": "BRAINTREE",
    "dropdelst": "MA",
    "dropdelzpp": "021849918",
    "dropphyadd": "333 COMMERCE DR",
    "dropphycty": "BRAINTREE",
    "dropphyst": "MA",
    "dropphyzpp": "021849918",
    "dropmaladd": "333 COMMERCE DR",
    "dropmalcty": "BRAINTREE",
    "dropmalst": "MA",
    "dropmalzpp": "021849918",
    "dropsitphn": 6176545113,
    "dropsitlph": 6176545111,
    "dropsitcph": 7813564569,
    "dropfax": 7818439297
  },
  {
    "dcode": "D",
    "dropkey": 4020677,
    "droptype": "D",
    "dropname": "STOCKTON AIRPORT CA S&DC",
    "dropdeladd": "3131 ARCH AIRPORT RD",
    "dropdelcty": "STOCKTON",
    "dropdelst": "CA",
    "dropdelzpp": 952139901,
    "dropphyadd": "3131 ARCH AIRPORT RD",
    "dropphycty": "STOCKTON",
    "dropphyst": "CA",
    "dropphyzpp": 952139901,
    "dropmaladd": "3131 ARCH AIRPORT RD",
    "dropmalcty": "STOCKTON",
    "dropmalst": "CA",
    "dropmalzpp": 952139901,
    "dropsitphn": 9163738025,
    "dropsitlph": 2099836460,
    "dropsitcph": 2099836422,
    "dropfax": 2099836420
  },
  {
    "dcode": "D",
    "dropkey": 4020681,
    "droptype": "D",
    "dropname": "SARASOTA FL S&DC",
    "dropdeladd": "1661 RINGLING BLVD",
    "dropdelcty": "SARASOTA",
    "dropdelst": "FL",
    "dropdelzpp": 342309950,
    "dropphyadd": "1661 RINGLING BLVD",
    "dropphycty": "SARASOTA",
    "dropphyst": "FL",
    "dropphyzpp": 342309950,
    "dropmaladd": "1661 RINGLING BLVD",
    "dropmalcty": "SARASOTA",
    "dropmalst": "FL",
    "dropmalzpp": 342309950,
    "dropsitphn": 8138770729,
    "dropsitlph": 9413595162,
    "dropsitcph": 9413314221,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020682,
    "droptype": "D",
    "dropname": "ACWORTH GA S&DC",
    "dropdeladd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropdelcty": "ACWORTH",
    "dropdelst": "GA",
    "dropdelzpp": 301019903,
    "dropphyadd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropphycty": "ACWORTH",
    "dropphyst": "GA",
    "dropphyzpp": 301019903,
    "dropmaladd": "4200 MCEVER INDUSTRIAL DR NW",
    "dropmalcty": "ACWORTH",
    "dropmalst": "GA",
    "dropmalzpp": 301019903,
    "dropsitphn": 4047657578,
    "dropsitlph": 7709668169,
    "dropsitcph": 7709668169,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020684,
    "droptype": "D",
    "dropname": "MACON GA S&DC",
    "dropdeladd": "1740 ROCKY CREEK RD",
    "dropdelcty": "MACON",
    "dropdelst": "GA",
    "dropdelzpp": 312069900,
    "dropphyadd": "1740 ROCKY CREEK RD",
    "dropphycty": "MACON",
    "dropphyst": "GA",
    "dropphyzpp": 312069900,
    "dropmaladd": "1740 ROCKY CREEK RD",
    "dropmalcty": "MACON",
    "dropmalst": "GA",
    "dropmalzpp": 312069900,
    "dropsitphn": 4787528466,
    "dropsitlph": 4787843994,
    "dropsitcph": 4787843994,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020686,
    "droptype": "D",
    "dropname": "LA CROSSE WI S&DC",
    "dropdeladd": "425 STATE ST",
    "dropdelcty": "LA CROSSE",
    "dropdelst": "WI",
    "dropdelzpp": 546013333,
    "dropphyadd": "425 STATE ST",
    "dropphycty": "LA CROSSE",
    "dropphyst": "WI",
    "dropphyzpp": 546013333,
    "dropmaladd": "425 STATE ST",
    "dropmalcty": "LA CROSSE",
    "dropmalst": "WI",
    "dropmalzpp": 546013333,
    "dropsitphn": 6123499163,
    "dropsitlph": 6087918159,
    "dropsitcph": 6087918100,
    "dropfax": 6087918126
  },
  {
    "dcode": "D",
    "dropkey": 4020690,
    "droptype": "D",
    "dropname": "WALLINGFORD CT S&DC",
    "dropdeladd": "24 RESEARCH PKWY",
    "dropdelcty": "WALLINGFORD",
    "dropdelst": "CT",
    "dropdelzpp": "064929990",
    "dropphyadd": "24 RESEARCH PKWY",
    "dropphycty": "WALLINGFORD",
    "dropphyst": "CT",
    "dropphyzpp": "064929990",
    "dropmaladd": "24 RESEARCH PKWY",
    "dropmalcty": "WALLINGFORD",
    "dropmalst": "CT",
    "dropmalzpp": "064929990",
    "dropsitphn": 2039493040,
    "dropsitlph": 2039493157,
    "dropsitcph": 2039493105,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020691,
    "droptype": "D",
    "dropname": "CARBONDALE IL S&DC",
    "dropdeladd": "1301 E MAIN ST",
    "dropdelcty": "CARBONDALE",
    "dropdelst": "IL",
    "dropdelzpp": 629019926,
    "dropphyadd": "1301 E MAIN ST",
    "dropphycty": "CARBONDALE",
    "dropphyst": "IL",
    "dropphyzpp": 629019926,
    "dropmaladd": "1301 E MAIN ST",
    "dropmalcty": "CARBONDALE",
    "dropmalst": "IL",
    "dropmalzpp": 629019926,
    "dropsitphn": 3148959275,
    "dropsitlph": 6183515651,
    "dropsitcph": 6183515651,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020692,
    "droptype": "D",
    "dropname": "WILKES BARRE PA S&DC",
    "dropdeladd": "300 S MAIN ST",
    "dropdelcty": "WILKES BARRE",
    "dropdelst": "PA",
    "dropdelzpp": 187019903,
    "dropphyadd": "300 S MAIN ST",
    "dropphycty": "WILKES BARRE",
    "dropphyst": "PA",
    "dropphyzpp": 187019903,
    "dropmaladd": "300 S MAIN ST",
    "dropmalcty": "WILKES BARRE",
    "dropmalst": "PA",
    "dropmalzpp": 187019903,
    "dropsitphn": 7172574870,
    "dropsitlph": 5708313400,
    "dropsitcph": 5708313400,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020693,
    "droptype": "D",
    "dropname": "OAKLAND PARK OH S&DC",
    "dropdeladd": "2200 INNIS RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432249902,
    "dropphyadd": "2200 INNIS RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432249902,
    "dropmaladd": "2200 INNIS RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432249902,
    "dropsitphn": 6144720674,
    "dropsitlph": 6144761590,
    "dropsitcph": 6144761590,
    "dropfax": 6144751670
  },
  {
    "dcode": "D",
    "dropkey": 4020694,
    "droptype": "D",
    "dropname": "WASHINGTON TWP OH S&DC",
    "dropdeladd": "7525 PARAGON RD",
    "dropdelcty": "DAYTON",
    "dropdelst": "OH",
    "dropdelzpp": 454599935,
    "dropphyadd": "7525 PARAGON RD",
    "dropphycty": "DAYTON",
    "dropphyst": "OH",
    "dropphyzpp": 454599935,
    "dropmaladd": "7525 PARAGON RD",
    "dropmalcty": "DAYTON",
    "dropmalst": "OH",
    "dropmalzpp": 454599935,
    "dropsitphn": 5136845763,
    "dropsitlph": 9372911624,
    "dropsitcph": 9372911624,
    "dropfax": 9372914501
  },
  {
    "dcode": "D",
    "dropkey": 4020697,
    "droptype": "D",
    "dropname": "HIGH POINT NC S&DC",
    "dropdeladd": "315 E GREEN DR",
    "dropdelcty": "HIGH POINT",
    "dropdelst": "NC",
    "dropdelzpp": 272609908,
    "dropphyadd": "315 E GREEN DR",
    "dropphycty": "HIGH POINT",
    "dropphyst": "NC",
    "dropphyzpp": 272609908,
    "dropmaladd": "315 E GREEN DR",
    "dropmalcty": "HIGH POINT",
    "dropmalst": "NC",
    "dropmalzpp": 272609908,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3368846098,
    "dropfax": 3368845226
  },
  {
    "dcode": "D",
    "dropkey": 4020698,
    "droptype": "D",
    "dropname": "VINELAND NJ S&DC",
    "dropdeladd": "1539 ALMOND RD",
    "dropdelcty": "VINELAND",
    "dropdelst": "NJ",
    "dropdelzpp": "083609914",
    "dropphyadd": "1539 ALMOND RD",
    "dropphycty": "VINELAND",
    "dropphyst": "NJ",
    "dropphyzpp": "083609914",
    "dropmaladd": "1539 ALMOND RD",
    "dropmalcty": "VINELAND",
    "dropmalst": "NJ",
    "dropmalzpp": "083609914",
    "dropsitphn": 8569334046,
    "dropsitlph": 8565070032,
    "dropsitcph": 8565070032,
    "dropfax": 8566911701
  },
  {
    "dcode": "D",
    "dropkey": 4020703,
    "droptype": "D",
    "dropname": "PORTLAND ME S&DC",
    "dropdeladd": "151 FOREST AVE",
    "dropdelcty": "PORTLAND",
    "dropdelst": "ME",
    "dropdelzpp": "041019801",
    "dropphyadd": "151 FOREST AVE",
    "dropphycty": "PORTLAND",
    "dropphyst": "ME",
    "dropphyzpp": "041019801",
    "dropmaladd": "151 FOREST AVE",
    "dropmalcty": "PORTLAND",
    "dropmalst": "ME",
    "dropmalzpp": "041019801",
    "dropsitphn": 2075102795,
    "dropsitlph": 2078718519,
    "dropsitcph": 2078718519,
    "dropfax": 2078718516
  },
  {
    "dcode": "D",
    "dropkey": 4020710,
    "droptype": "D",
    "dropname": "BINGHAMTON NY S&DC",
    "dropdeladd": "115 HENRY ST",
    "dropdelcty": "BINGHAMTON",
    "dropdelst": "NY",
    "dropdelzpp": 139029900,
    "dropphyadd": "115 HENRY ST",
    "dropphycty": "BINGHAMTON",
    "dropphyst": "NY",
    "dropphyzpp": 139029900,
    "dropmaladd": "115 HENRY ST",
    "dropmalcty": "BINGHAMTON",
    "dropmalst": "NY",
    "dropmalzpp": 139029900,
    "dropsitphn": 6077732174,
    "dropsitlph": 6077732333,
    "dropsitcph": 6077732126,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020712,
    "droptype": "D",
    "dropname": "EVERETT WA S&DC",
    "dropdeladd": "8120 HARDESON RD",
    "dropdelcty": "EVERETT",
    "dropdelst": "WA",
    "dropdelzpp": 982039995,
    "dropphyadd": "8120 HARDESON RD",
    "dropphycty": "EVERETT",
    "dropphyst": "WA",
    "dropphyzpp": 982039995,
    "dropmaladd": "8120 HARDESON RD",
    "dropmalcty": "EVERETT",
    "dropmalst": "WA",
    "dropmalzpp": 982039995,
    "dropsitphn": 2067684422,
    "dropsitlph": 4253558366,
    "dropsitcph": 4252906300,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020718,
    "droptype": "D",
    "dropname": "NORFOLK VA S&DC",
    "dropdeladd": "600 CHURCH ST",
    "dropdelcty": "NORFOLK",
    "dropdelst": "VA",
    "dropdelzpp": 235019943,
    "dropphyadd": "600 CHURCH ST",
    "dropphycty": "NORFOLK",
    "dropphyst": "VA",
    "dropphyzpp": 235019943,
    "dropmaladd": "600 CHURCH ST",
    "dropmalcty": "NORFOLK",
    "dropmalst": "VA",
    "dropmalzpp": 235019943,
    "dropsitphn": 7576642314,
    "dropsitlph": 7576249472,
    "dropsitcph": 7576249472,
    "dropfax": 7576249472
  },
  {
    "dcode": "D",
    "dropkey": 4020823,
    "droptype": "D",
    "dropname": "DIAMOND FARMS RURAL",
    "dropdeladd": "7 METROPOLITAN CT",
    "dropdelcty": "GAITHERSBURG",
    "dropdelst": "MD",
    "dropdelzpp": 208789906,
    "dropphyadd": "7 METROPOLITAN CT",
    "dropphycty": "GAITHERSBURG",
    "dropphyst": "MD",
    "dropphyzpp": 208789906,
    "dropmaladd": "7 METROPOLITAN CT",
    "dropmalcty": "GAITHERSBURG",
    "dropmalst": "MD",
    "dropmalzpp": 208789906,
    "dropsitphn": 3014997331,
    "dropsitlph": 3012083735,
    "dropsitcph": 3012083735,
    "dropfax": 3012083713
  },
  {
    "dcode": "D",
    "dropkey": 4020832,
    "droptype": "D",
    "dropname": "TOOELE CARRIER ANNEX",
    "dropdeladd": "919 N MAIN ST",
    "dropdelcty": "TOOELE",
    "dropdelst": "UT",
    "dropdelzpp": 840749800,
    "dropphyadd": "919 N MAIN ST",
    "dropphycty": "TOOELE",
    "dropphyst": "UT",
    "dropphyzpp": 840749800,
    "dropmaladd": "919 N MAIN ST",
    "dropmalcty": "TOOELE",
    "dropmalst": "UT",
    "dropmalzpp": 840749800,
    "dropsitphn": 8019742558,
    "dropsitlph": 4358439599,
    "dropsitcph": 4358439598,
    "dropfax": 4358431186
  },
  {
    "dcode": "D",
    "dropkey": 4020843,
    "droptype": "D",
    "dropname": "POMPANO BEACH FL S&DC",
    "dropdeladd": "3150 NW 33RD ST",
    "dropdelcty": "POMPANO BEACH",
    "dropdelst": "FL",
    "dropdelzpp": 330699805,
    "dropphyadd": "3150 NW 33RD ST",
    "dropphycty": "POMPANO BEACH",
    "dropphyst": "FL",
    "dropphyzpp": 330699805,
    "dropmaladd": "3150 NW 33RD ST",
    "dropmalcty": "POMPANO BEACH",
    "dropmalst": "FL",
    "dropmalzpp": 330699805,
    "dropsitphn": 3055132368,
    "dropsitlph": 9549355150,
    "dropsitcph": 9549355122,
    "dropfax": 9549355128
  },
  {
    "dcode": "D",
    "dropkey": 4020844,
    "droptype": "D",
    "dropname": "ATLANTA GA SDC",
    "dropdeladd": "3900 CROWN RD SW",
    "dropdelcty": "ATLANTA",
    "dropdelst": "GA",
    "dropdelzpp": 303040001,
    "dropphyadd": "3900 CROWN RD SW",
    "dropphycty": "ATLANTA",
    "dropphyst": "GA",
    "dropphyzpp": 303040001,
    "dropmaladd": "3900 CROWN RD SW",
    "dropmalcty": "ATLANTA",
    "dropmalst": "GA",
    "dropmalzpp": 303040001,
    "dropsitphn": 4047657578,
    "dropsitlph": 4047657578,
    "dropsitcph": 4047657300,
    "dropfax": 4047657299
  },
  {
    "dcode": "D",
    "dropkey": 4020868,
    "droptype": "D",
    "dropname": "CHICAGO IL SDC",
    "dropdeladd": "433 W HARRISON ST STE 3012A",
    "dropdelcty": "CHICAGO",
    "dropdelst": "IL",
    "dropdelzpp": 606999904,
    "dropphyadd": "433 W HARRISON ST STE 3012A",
    "dropphycty": "CHICAGO",
    "dropphyst": "IL",
    "dropphyzpp": 606999904,
    "dropmaladd": "433 W HARRISON ST STE 3012A",
    "dropmalcty": "CHICAGO",
    "dropmalst": "IL",
    "dropmalzpp": 606999904,
    "dropsitphn": "",
    "dropsitlph": 3127653225,
    "dropsitcph": 3129837550,
    "dropfax": 3129838135
  },
  {
    "dcode": "D",
    "dropkey": 4020869,
    "droptype": "D",
    "dropname": "CHARLOTTE NC WESTSIDE SDC",
    "dropdeladd": "2901 SCOTT FUTRELL DR",
    "dropdelcty": "CHARLOTTE",
    "dropdelst": "NC",
    "dropdelzpp": 282289911,
    "dropphyadd": "2901 SCOTT FUTRELL DR",
    "dropphycty": "CHARLOTTE",
    "dropphyst": "NC",
    "dropphyzpp": 282289911,
    "dropmaladd": "2901 SCOTT FUTRELL DR",
    "dropmalcty": "CHARLOTTE",
    "dropmalst": "NC",
    "dropmalzpp": 282289911,
    "dropsitphn": 7043934581,
    "dropsitlph": 7043332542,
    "dropsitcph": 7043332542,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020870,
    "droptype": "D",
    "dropname": "DULUTH GA SDC",
    "dropdeladd": "1605 BOGGS RD",
    "dropdelcty": "DULUTH",
    "dropdelst": "GA",
    "dropdelzpp": 300969922,
    "dropphyadd": "1605 BOGGS RD",
    "dropphycty": "DULUTH",
    "dropphyst": "GA",
    "dropphyzpp": 300969922,
    "dropmaladd": "1605 BOGGS RD",
    "dropmalcty": "DULUTH",
    "dropmalst": "GA",
    "dropmalzpp": 300969922,
    "dropsitphn": 4047657578,
    "dropsitlph": 7707173700,
    "dropsitcph": 7707173700,
    "dropfax": 7707173452
  },
  {
    "dcode": "D",
    "dropkey": 4020871,
    "droptype": "D",
    "dropname": "GREENVILLE SC FAIRFOREST SDC",
    "dropdeladd": "204 FAIRFOREST WAY",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296079924,
    "dropphyadd": "204 FAIRFOREST WAY",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296079924,
    "dropmaladd": "204 FAIRFOREST WAY",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296079924,
    "dropsitphn": 8039266014,
    "dropsitlph": 8642828421,
    "dropsitcph": 8642828449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020872,
    "droptype": "D",
    "dropname": "GREENVILLE SC DOWNTOWN SDC",
    "dropdeladd": "600 W WASHINGTON ST",
    "dropdelcty": "GREENVILLE",
    "dropdelst": "SC",
    "dropdelzpp": 296029924,
    "dropphyadd": "600 W WASHINGTON ST",
    "dropphycty": "GREENVILLE",
    "dropphyst": "SC",
    "dropphyzpp": 296029924,
    "dropmaladd": "600 W WASHINGTON ST",
    "dropmalcty": "GREENVILLE",
    "dropmalst": "SC",
    "dropmalzpp": 296029924,
    "dropsitphn": 8039266014,
    "dropsitlph": 8642828421,
    "dropsitcph": 8642828449,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020873,
    "droptype": "D",
    "dropname": "BEND OR S&DC",
    "dropdeladd": "2300 NE 4TH ST",
    "dropdelcty": "BEND",
    "dropdelst": "OR",
    "dropdelzpp": 977019901,
    "dropphyadd": "2300 NE 4TH ST",
    "dropphycty": "BEND",
    "dropphyst": "OR",
    "dropphyzpp": 977019901,
    "dropmaladd": "2300 NE 4TH ST",
    "dropmalcty": "BEND",
    "dropmalst": "OR",
    "dropmalzpp": 977019901,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413882427,
    "dropsitcph": 5413185068,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020874,
    "droptype": "D",
    "dropname": "EUGENE OR S&DC",
    "dropdeladd": "3148 GATEWAY ST",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "OR",
    "dropdelzpp": 974759912,
    "dropphyadd": "3148 GATEWAY ST",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "OR",
    "dropphyzpp": 974759912,
    "dropmaladd": "3148 GATEWAY ST",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "OR",
    "dropmalzpp": 974759912,
    "dropsitphn": 9712013788,
    "dropsitlph": 5413413639,
    "dropsitcph": 5413413601,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020875,
    "droptype": "D",
    "dropname": "MEDFORD OR S&DC",
    "dropdeladd": "173 EHRMAN WAY",
    "dropdelcty": "MEDFORD",
    "dropdelst": "OR",
    "dropdelzpp": 975019844,
    "dropphyadd": "173 EHRMAN WAY",
    "dropphycty": "MEDFORD",
    "dropphyst": "OR",
    "dropphyzpp": 975019844,
    "dropmaladd": "173 EHRMAN WAY",
    "dropmalcty": "MEDFORD",
    "dropmalst": "OR",
    "dropmalzpp": 975019844,
    "dropsitphn": 9712013788,
    "dropsitlph": "",
    "dropsitcph": 5412458540,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020880,
    "droptype": "D",
    "dropname": "PEORIA IL SDC",
    "dropdeladd": "95 STATE ST",
    "dropdelcty": "PEORIA",
    "dropdelst": "IL",
    "dropdelzpp": 616019901,
    "dropphyadd": "95 STATE ST",
    "dropphycty": "PEORIA",
    "dropphyst": "IL",
    "dropphyzpp": 616019901,
    "dropmaladd": "95 STATE ST",
    "dropmalcty": "PEORIA",
    "dropmalst": "IL",
    "dropmalzpp": 616019901,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096718822,
    "dropfax": 3096748983
  },
  {
    "dcode": "D",
    "dropkey": 4020881,
    "droptype": "D",
    "dropname": "CHAMPAIGN IL SDC",
    "dropdeladd": "2001 N MATTIS AVE",
    "dropdelcty": "CHAMPAIGN",
    "dropdelst": "IL",
    "dropdelzpp": 618219900,
    "dropphyadd": "2001 N MATTIS AVE",
    "dropphycty": "CHAMPAIGN",
    "dropphyst": "IL",
    "dropphyzpp": 618219900,
    "dropmaladd": "2001 N MATTIS AVE",
    "dropmalcty": "CHAMPAIGN",
    "dropmalst": "IL",
    "dropmalzpp": 618219900,
    "dropsitphn": 7085637318,
    "dropsitlph": 2173736050,
    "dropsitcph": 2173522167,
    "dropfax": 2173736004
  },
  {
    "dcode": "D",
    "dropkey": 4020884,
    "droptype": "D",
    "dropname": "HAMMOND IN SDC",
    "dropdeladd": "5530 SOHL AVE",
    "dropdelcty": "HAMMOND",
    "dropdelst": "IN",
    "dropdelzpp": 463209913,
    "dropphyadd": "5530 SOHL AVE",
    "dropphycty": "HAMMOND",
    "dropphyst": "IN",
    "dropphyzpp": 463209913,
    "dropmaladd": "5530 SOHL AVE",
    "dropmalcty": "HAMMOND",
    "dropmalst": "IN",
    "dropmalzpp": 463209913,
    "dropsitphn": 2199322757,
    "dropsitlph": 3174646350,
    "dropsitcph": 2199322757,
    "dropfax": 2199379470
  },
  {
    "dcode": "D",
    "dropkey": 4020885,
    "droptype": "D",
    "dropname": "GARY IN SDC",
    "dropdeladd": "1499 MARTIN LUTHER KING DR",
    "dropdelcty": "GARY",
    "dropdelst": "IN",
    "dropdelzpp": 464019901,
    "dropphyadd": "1499 MARTIN LUTHER KING DR",
    "dropphycty": "GARY",
    "dropphyst": "IN",
    "dropphyzpp": 464019901,
    "dropmaladd": "1499 MARTIN LUTHER KING DR",
    "dropmalcty": "GARY",
    "dropmalst": "IN",
    "dropmalzpp": 464019901,
    "dropsitphn": 2198868000,
    "dropsitlph": 2198868051,
    "dropsitcph": 2198868000,
    "dropfax": 2198868211
  },
  {
    "dcode": "D",
    "dropkey": 4020930,
    "droptype": "D",
    "dropname": "MONTPELIER CARRIER ANNEX",
    "dropdeladd": "282 BERLIN MALL RD STE 11",
    "dropdelcty": "BERLIN",
    "dropdelst": "VT",
    "dropdelzpp": "056029995",
    "dropphyadd": "282 BERLIN MALL RD STE 11",
    "dropphycty": "BERLIN",
    "dropphyst": "VT",
    "dropphyzpp": "056029995",
    "dropmaladd": "282 BERLIN MALL RD STE 11",
    "dropmalcty": "BERLIN",
    "dropmalst": "VT",
    "dropmalzpp": "056029995",
    "dropsitphn": 8022963232,
    "dropsitlph": 8022232576,
    "dropsitcph": 8022232576,
    "dropfax": 8022230481
  },
  {
    "dcode": "D",
    "dropkey": 4020937,
    "droptype": "D",
    "dropname": "OLYMPIA WA S&DC",
    "dropdeladd": "717 76TH AVE SW",
    "dropdelcty": "TUMWATER",
    "dropdelst": "WA",
    "dropdelzpp": 985019975,
    "dropphyadd": "717 76TH AVE SW",
    "dropphycty": "TUMWATER",
    "dropphyst": "WA",
    "dropphyzpp": 985019975,
    "dropmaladd": "717 76TH AVE SW",
    "dropmalcty": "TUMWATER",
    "dropmalst": "WA",
    "dropmalzpp": 985019975,
    "dropsitphn": 2067684422,
    "dropsitlph": 3605706330,
    "dropsitcph": 3605706300,
    "dropfax": 3605706340
  },
  {
    "dcode": "D",
    "dropkey": 4020938,
    "droptype": "D",
    "dropname": "SHAWNEE MISSION KS S&DC",
    "dropdeladd": "6029 BROADMOOR ST",
    "dropdelcty": "MISSION",
    "dropdelst": "KS",
    "dropdelzpp": 662029810,
    "dropphyadd": "6029 BROADMOOR ST",
    "dropphycty": "MISSION",
    "dropphyst": "KS",
    "dropphyzpp": 662029810,
    "dropmaladd": "6029 BROADMOOR ST",
    "dropmalcty": "MISSION",
    "dropmalst": "KS",
    "dropmalzpp": 662029810,
    "dropsitphn": 8165043362,
    "dropsitlph": 9138315374,
    "dropsitcph": 9138315375,
    "dropfax": 9138315372
  },
  {
    "dcode": "D",
    "dropkey": 4020939,
    "droptype": "D",
    "dropname": "LAKE CHARLES LA S&DC",
    "dropdeladd": "921 MOSS ST",
    "dropdelcty": "LAKE CHARLES",
    "dropdelst": "LA",
    "dropdelzpp": 706019940,
    "dropphyadd": "921 MOSS ST",
    "dropphycty": "LAKE CHARLES",
    "dropphyst": "LA",
    "dropphyzpp": 706019940,
    "dropmaladd": "921 MOSS ST",
    "dropmalcty": "LAKE CHARLES",
    "dropmalst": "LA",
    "dropmalzpp": 706019940,
    "dropsitphn": 3372694848,
    "dropsitlph": 3372694848,
    "dropsitcph": 3374377484,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4020941,
    "droptype": "D",
    "dropname": "SEVERNA PARK MD S&DC",
    "dropdeladd": "21 MAGOTHY BRIDGE RD",
    "dropdelcty": "SEVERNA PARK",
    "dropdelst": "MD",
    "dropdelzpp": 211469900,
    "dropphyadd": "21 MAGOTHY BRIDGE RD",
    "dropphycty": "SEVERNA PARK",
    "dropphyst": "MD",
    "dropphyzpp": 211469900,
    "dropmaladd": "21 MAGOTHY BRIDGE RD",
    "dropmalcty": "SEVERNA PARK",
    "dropmalst": "MD",
    "dropmalzpp": 211469900,
    "dropsitphn": 4103474518,
    "dropsitlph": 4106472904,
    "dropsitcph": 4106472904,
    "dropfax": 4105514757
  },
  {
    "dcode": "D",
    "dropkey": 4020974,
    "droptype": "D",
    "dropname": "SALEM ANNEX",
    "dropdeladd": "7001 236TH AVE",
    "dropdelcty": "SALEM",
    "dropdelst": "WI",
    "dropdelzpp": 531689900,
    "dropphyadd": "7001 236TH AVE",
    "dropphycty": "SALEM",
    "dropphyst": "WI",
    "dropphyzpp": 531689900,
    "dropmaladd": "7001 236TH AVE",
    "dropmalcty": "SALEM",
    "dropmalst": "WI",
    "dropmalzpp": 531689900,
    "dropsitphn": 4142702120,
    "dropsitlph": 4142702021,
    "dropsitcph": 2628432330,
    "dropfax": 2628431623
  },
  {
    "dcode": "D",
    "dropkey": 4020997,
    "droptype": "D",
    "dropname": "METROPOLITAN CARRIER ANNEX",
    "dropdeladd": "124 FORREST ST",
    "dropdelcty": "BROOKLYN",
    "dropdelst": "NY",
    "dropdelzpp": 112069901,
    "dropphyadd": "124 FORREST ST",
    "dropphycty": "BROOKLYN",
    "dropphyst": "NY",
    "dropphyzpp": 112069901,
    "dropmaladd": "47 DEBEVOISE ST",
    "dropmalcty": "BROOKLYN",
    "dropmalst": "NY",
    "dropmalzpp": 112069997,
    "dropsitphn": 7183215923,
    "dropsitlph": "",
    "dropsitcph": 3472721755,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021018,
    "droptype": "D",
    "dropname": "SECTION 19 CARRIER ANNEX",
    "dropdeladd": "900 BRENTWOOD RD NE",
    "dropdelcty": "WASHINGTON",
    "dropdelst": "DC",
    "dropdelzpp": 200660019,
    "dropphyadd": "900 BRENTWOOD RD NE",
    "dropphycty": "WASHINGTON",
    "dropphyst": "DC",
    "dropphyzpp": 200660019,
    "dropmaladd": "900 BRENTWOOD RD NE",
    "dropmalcty": "WASHINGTON",
    "dropmalst": "DC",
    "dropmalzpp": 200660019,
    "dropsitphn": 3014997331,
    "dropsitlph": 2026362290,
    "dropsitcph": 2026362290,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021020,
    "droptype": "D",
    "dropname": "PORTSMOUTH NH SDC",
    "dropdeladd": "345 HERITAGE AVE UNIT 100",
    "dropdelcty": "PORTSMOUTH",
    "dropdelst": "NH",
    "dropdelzpp": "038019908",
    "dropphyadd": "345 HERITAGE AVE UNIT 100",
    "dropphycty": "PORTSMOUTH",
    "dropphyst": "NH",
    "dropphyzpp": "038019908",
    "dropmaladd": "345 HERITAGE AVE UNIT 100",
    "dropmalcty": "PORTSMOUTH",
    "dropmalst": "NH",
    "dropmalzpp": "038019908",
    "dropsitphn": 6036444128,
    "dropsitlph": 6036444128,
    "dropsitcph": 6034312871,
    "dropfax": 6034308931
  },
  {
    "dcode": "D",
    "dropkey": 4021021,
    "droptype": "D",
    "dropname": "BRENTWOOD TN SDC",
    "dropdeladd": "1734 GENERAL GEORGE PATTON DR",
    "dropdelcty": "BRENTWOOD",
    "dropdelst": "TN",
    "dropdelzpp": 370279927,
    "dropphyadd": "1734 GENERAL GEORGE PATTON DR",
    "dropphycty": "BRENTWOOD",
    "dropphyst": "TN",
    "dropphyzpp": 370279927,
    "dropmaladd": "1734 GENERAL GEORGE PATTON DR",
    "dropmalcty": "BRENTWOOD",
    "dropmalst": "TN",
    "dropmalzpp": 370279927,
    "dropsitphn": 6158859336,
    "dropsitlph": 6153737875,
    "dropsitcph": 6153737875,
    "dropfax": 6153732462
  },
  {
    "dcode": "D",
    "dropkey": 4021022,
    "droptype": "D",
    "dropname": "PATERSON NJ SDC",
    "dropdeladd": "194 WARD ST",
    "dropdelcty": "PATERSON",
    "dropdelst": "NJ",
    "dropdelzpp": "075109900",
    "dropphyadd": "194 WARD ST",
    "dropphycty": "PATERSON",
    "dropphyst": "NJ",
    "dropphyzpp": "075109900",
    "dropmaladd": "194 WARD ST",
    "dropmalcty": "PATERSON",
    "dropmalst": "NJ",
    "dropmalzpp": "075109900",
    "dropsitphn": 2019559706,
    "dropsitlph": 9739774729,
    "dropsitcph": 9739774611,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021023,
    "droptype": "D",
    "dropname": "WALDORF MD SDC",
    "dropdeladd": "110 PAUL MELLON CT",
    "dropdelcty": "WALDORF",
    "dropdelst": "MD",
    "dropdelzpp": 206029900,
    "dropphyadd": "110 PAUL MELLON CT",
    "dropphycty": "WALDORF",
    "dropphyst": "MD",
    "dropphyzpp": 206029900,
    "dropmaladd": "110 PAUL MELLON CT",
    "dropmalcty": "WALDORF",
    "dropmalst": "MD",
    "dropmalzpp": 206029900,
    "dropsitphn": 3014997331,
    "dropsitlph": 3017057003,
    "dropsitcph": 3017057003,
    "dropfax": 3017055426
  },
  {
    "dcode": "D",
    "dropkey": 4021024,
    "droptype": "D",
    "dropname": "BROCKTON MA SDC",
    "dropdeladd": "120 COMMERCIAL ST",
    "dropdelcty": "BROCKTON",
    "dropdelst": "MA",
    "dropdelzpp": "023029903",
    "dropphyadd": "120 COMMERCIAL ST",
    "dropphycty": "BROCKTON",
    "dropphyst": "MA",
    "dropphyzpp": "023029903",
    "dropmaladd": "120 COMMERCIAL ST",
    "dropmalcty": "BROCKTON",
    "dropmalst": "MA",
    "dropmalzpp": "023029903",
    "dropsitphn": 4017525649,
    "dropsitlph": 4017525649,
    "dropsitcph": 5085591958,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021025,
    "droptype": "D",
    "dropname": "WINSTON SALEM NC SDC",
    "dropdeladd": "1500 N PATTERSON AVE",
    "dropdelcty": "WINSTON SALEM",
    "dropdelst": "NC",
    "dropdelzpp": 271059900,
    "dropphyadd": "1500 N PATTERSON AVE",
    "dropphycty": "WINSTON SALEM",
    "dropphyst": "NC",
    "dropphyzpp": 271059900,
    "dropmaladd": "1500 N PATTERSON AVE",
    "dropmalcty": "WINSTON SALEM",
    "dropmalst": "NC",
    "dropmalzpp": 271059900,
    "dropsitphn": 3369319444,
    "dropsitlph": 3369319443,
    "dropsitcph": 3367216025,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021026,
    "droptype": "D",
    "dropname": "DENTON TX SDC",
    "dropdeladd": "101 E MCKINNEY ST",
    "dropdelcty": "DENTON",
    "dropdelst": "TX",
    "dropdelzpp": 762019907,
    "dropphyadd": "101 E MCKINNEY ST",
    "dropphycty": "DENTON",
    "dropphyst": "TX",
    "dropphyzpp": 762019907,
    "dropmaladd": "101 E MCKINNEY ST",
    "dropmalcty": "DENTON",
    "dropmalst": "TX",
    "dropmalzpp": 762019907,
    "dropsitphn": 8173173658,
    "dropsitlph": 9403878555,
    "dropsitcph": 9403878555,
    "dropfax": 9408910032
  },
  {
    "dcode": "D",
    "dropkey": 4021027,
    "droptype": "D",
    "dropname": "PITTSBURGH PA NORTHSIDE SDC",
    "dropdeladd": "900 PENNSYLVANIA AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152339910,
    "dropphyadd": "900 PENNSYLVANIA AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152339910,
    "dropmaladd": "900 PENNSYLVANIA AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152339910,
    "dropsitphn": 4123597568,
    "dropsitlph": 4123597859,
    "dropsitcph": 4123597859,
    "dropfax": 4123211392
  },
  {
    "dcode": "D",
    "dropkey": 4021028,
    "droptype": "D",
    "dropname": "NEW CASTLE PA SDC",
    "dropdeladd": "435 S CASCADE ST",
    "dropdelcty": "NEW CASTLE",
    "dropdelst": "PA",
    "dropdelzpp": 161089900,
    "dropphyadd": "435 S CASCADE ST",
    "dropphycty": "NEW CASTLE",
    "dropphyst": "PA",
    "dropphyzpp": 161089900,
    "dropmaladd": "435 S CASCADE ST",
    "dropmalcty": "NEW CASTLE",
    "dropmalst": "PA",
    "dropmalzpp": 161089900,
    "dropsitphn": 8148987318,
    "dropsitlph": 7246567221,
    "dropsitcph": 7246567221,
    "dropfax": 7246567205
  },
  {
    "dcode": "D",
    "dropkey": 4021029,
    "droptype": "D",
    "dropname": "EL MONTE CA SDC",
    "dropdeladd": "11151 VALLEY BLVD",
    "dropdelcty": "EL MONTE",
    "dropdelst": "CA",
    "dropdelzpp": 917349911,
    "dropphyadd": "11151 VALLEY BLVD",
    "dropphycty": "EL MONTE",
    "dropphyst": "CA",
    "dropphyzpp": 917349911,
    "dropmaladd": "11151 VALLEY BLVD",
    "dropmalcty": "EL MONTE",
    "dropmalst": "CA",
    "dropmalzpp": 917349911,
    "dropsitphn": 6264430704,
    "dropsitlph": 6264441966,
    "dropsitcph": 6264430704,
    "dropfax": 6264438157
  },
  {
    "dcode": "D",
    "dropkey": 4021030,
    "droptype": "D",
    "dropname": "ROTHSCHILD WI SDC",
    "dropdeladd": "400 CRESKE AVE",
    "dropdelcty": "ROTHSCHILD",
    "dropdelst": "WI",
    "dropdelzpp": 544749900,
    "dropphyadd": "400 CRESKE AVE",
    "dropphycty": "ROTHSCHILD",
    "dropphyst": "WI",
    "dropphyzpp": 544749900,
    "dropmaladd": "400 CRESKE AVE",
    "dropmalcty": "ROTHSCHILD",
    "dropmalst": "WI",
    "dropmalzpp": 544749900,
    "dropsitphn": 4142702120,
    "dropsitlph": 7152413800,
    "dropsitcph": 7152413800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021138,
    "droptype": "D",
    "dropname": "WOODBRIDGE VA SDC",
    "dropdeladd": "3360 POST OFFICE RD",
    "dropdelcty": "WOODBRIDGE",
    "dropdelst": "VA",
    "dropdelzpp": 221939905,
    "dropphyadd": "3360 POST OFFICE RD",
    "dropphycty": "WOODBRIDGE",
    "dropphyst": "VA",
    "dropphyzpp": 221939905,
    "dropmaladd": "3360 POST OFFICE RD",
    "dropmalcty": "WOODBRIDGE",
    "dropmalst": "VA",
    "dropmalzpp": 221939905,
    "dropsitphn": 7036986367,
    "dropsitlph": 7037301505,
    "dropsitcph": 7037301505,
    "dropfax": 7037308748
  },
  {
    "dcode": "D",
    "dropkey": 4021139,
    "droptype": "D",
    "dropname": "JONESBORO AR SDC",
    "dropdeladd": "3405 MOORE RD",
    "dropdelcty": "JONESBORO",
    "dropdelst": "AR",
    "dropdelzpp": 724019980,
    "dropphyadd": "3405 MOORE RD",
    "dropphycty": "JONESBORO",
    "dropphyst": "AR",
    "dropphyzpp": 724019980,
    "dropmaladd": "3405 MOORE RD",
    "dropmalcty": "JONESBORO",
    "dropmalst": "AR",
    "dropmalzpp": 724019980,
    "dropsitphn": 8709328929,
    "dropsitlph": 8709720275,
    "dropsitcph": 8709324057,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021140,
    "droptype": "D",
    "dropname": "FORT MYERS FL PAGE FIELD SDC",
    "dropdeladd": "2655 N AIRPORT RD",
    "dropdelcty": "FORT MYERS",
    "dropdelst": "FL",
    "dropdelzpp": 339079990,
    "dropphyadd": "2655 N AIRPORT RD",
    "dropphycty": "FORT MYERS",
    "dropphyst": "FL",
    "dropphyzpp": 339079990,
    "dropmaladd": "2655 N AIRPORT RD",
    "dropmalcty": "FORT MYERS",
    "dropmalst": "FL",
    "dropmalzpp": 339079990,
    "dropsitphn": 8138770788,
    "dropsitlph": 2397688083,
    "dropsitcph": 2392773336,
    "dropfax": 2399392721
  },
  {
    "dcode": "D",
    "dropkey": 4021146,
    "droptype": "D",
    "dropname": "ROCHESTER MN SDC",
    "dropdeladd": "1445 VALLEYHIGH DR NW",
    "dropdelcty": "ROCHESTER",
    "dropdelst": "MN",
    "dropdelzpp": 559010776,
    "dropphyadd": "1445 VALLEYHIGH DR NW",
    "dropphycty": "ROCHESTER",
    "dropphyst": "MN",
    "dropphyzpp": 559010776,
    "dropmaladd": "1445 VALLEYHIGH DR NW",
    "dropmalcty": "ROCHESTER",
    "dropmalst": "MN",
    "dropmalzpp": 559010776,
    "dropsitphn": 6123496399,
    "dropsitlph": 6516812544,
    "dropsitcph": 5072871268,
    "dropfax": 5072823068
  },
  {
    "dcode": "D",
    "dropkey": 4021147,
    "droptype": "D",
    "dropname": "BOWLING GREEN KY SDC",
    "dropdeladd": "5300 SCOTTSVILLE RD",
    "dropdelcty": "BOWLING GREEN",
    "dropdelst": "KY",
    "dropdelzpp": 421049900,
    "dropphyadd": "5300 SCOTTSVILLE RD",
    "dropphycty": "BOWLING GREEN",
    "dropphyst": "KY",
    "dropphyzpp": 421049900,
    "dropmaladd": "5300 SCOTTSVILLE RD",
    "dropmalcty": "BOWLING GREEN",
    "dropmalst": "KY",
    "dropmalzpp": 421049900,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 2707964035,
    "dropfax": 2708435773
  },
  {
    "dcode": "D",
    "dropkey": 4021148,
    "droptype": "D",
    "dropname": "EGG HARBOR TOWNSHIP NJ SDC",
    "dropdeladd": "5 COLUMBUS AVE",
    "dropdelcty": "EGG HARBOR TOWNSHIP",
    "dropdelst": "NJ",
    "dropdelzpp": "082344062",
    "dropphyadd": "5 COLUMBUS AVE",
    "dropphycty": "EGG HARBOR TOWNSHIP",
    "dropphyst": "NJ",
    "dropphyzpp": "082344062",
    "dropmaladd": "5 COLUMBUS AVE",
    "dropmalcty": "EGG HARBOR TOWNSHIP",
    "dropmalst": "NJ",
    "dropmalzpp": "082344062",
    "dropsitphn": 8569334046,
    "dropsitlph": 6096411858,
    "dropsitcph": 6096462191,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021149,
    "droptype": "D",
    "dropname": "LONDON KY SDC",
    "dropdeladd": "1760 HIGHWAY 192 W",
    "dropdelcty": "LONDON",
    "dropdelst": "KY",
    "dropdelzpp": 407419901,
    "dropphyadd": "1760 HIGHWAY 192 W",
    "dropphycty": "LONDON",
    "dropphyst": "KY",
    "dropphyzpp": 407419901,
    "dropmaladd": "1760 HIGHWAY 192 W",
    "dropmalcty": "LONDON",
    "dropmalst": "KY",
    "dropmalzpp": 407419901,
    "dropsitphn": 5024541745,
    "dropsitlph": 5024541745,
    "dropsitcph": 6066841722,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021150,
    "droptype": "D",
    "dropname": "BALTIMORE MD E LEXINGTON SDC",
    "dropdeladd": "1000 E LEXINGTON ST",
    "dropdelcty": "BALTIMORE",
    "dropdelst": "MD",
    "dropdelzpp": 212029902,
    "dropphyadd": "1000 E LEXINGTON ST",
    "dropphycty": "BALTIMORE",
    "dropphyst": "MD",
    "dropphyzpp": 212029902,
    "dropmaladd": "1000 E LEXINGTON ST",
    "dropmalcty": "BALTIMORE",
    "dropmalst": "MD",
    "dropmalzpp": 212029902,
    "dropsitphn": 4103474587,
    "dropsitlph": 4103474463,
    "dropsitcph": 4103474463,
    "dropfax": 4102348619
  },
  {
    "dcode": "D",
    "dropkey": 4021151,
    "droptype": "D",
    "dropname": "MARTINSBURG WV SDC",
    "dropdeladd": "1355 OLD COURTHOUSE SQ",
    "dropdelcty": "MARTINSBURG",
    "dropdelst": "WV",
    "dropdelzpp": 254049914,
    "dropphyadd": "1355 OLD COURTHOUSE SQ",
    "dropphycty": "MARTINSBURG",
    "dropphyst": "WV",
    "dropphyzpp": 254049914,
    "dropmaladd": "1355 OLD COURTHOUSE SQ",
    "dropmalcty": "MARTINSBURG",
    "dropmalst": "WV",
    "dropmalzpp": 254049914,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3042677787,
    "dropfax": 3042679360
  },
  {
    "dcode": "D",
    "dropkey": 4021152,
    "droptype": "D",
    "dropname": "CHARLESTON WV E LEE SDC",
    "dropdeladd": "1002 LEE ST E",
    "dropdelcty": "CHARLESTON",
    "dropdelst": "WV",
    "dropdelzpp": 253019972,
    "dropphyadd": "1002 LEE ST E",
    "dropphycty": "CHARLESTON",
    "dropphyst": "WV",
    "dropphyzpp": 253019972,
    "dropmaladd": "1002 LEE ST E",
    "dropmalcty": "CHARLESTON",
    "dropmalst": "WV",
    "dropmalzpp": 253019972,
    "dropsitphn": 3047465002,
    "dropsitlph": 3047465002,
    "dropsitcph": 3045611000,
    "dropfax": 3045611003
  },
  {
    "dcode": "D",
    "dropkey": 4021153,
    "droptype": "D",
    "dropname": "HEBRON KY SDC",
    "dropdeladd": "76 CLAY DR",
    "dropdelcty": "HEBRON",
    "dropdelst": "KY",
    "dropdelzpp": 410489903,
    "dropphyadd": "76 CLAY DR",
    "dropphycty": "HEBRON",
    "dropphyst": "KY",
    "dropphyzpp": 410489903,
    "dropmaladd": "76 CLAY DR",
    "dropmalcty": "HEBRON",
    "dropmalst": "KY",
    "dropmalzpp": 410489903,
    "dropsitphn": 5136845763,
    "dropsitlph": 8596895396,
    "dropsitcph": 8593714813,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021154,
    "droptype": "D",
    "dropname": "SPRINGFIELD MO CAMPBELL SDC",
    "dropdeladd": "3951 S CAMPBELL AVE",
    "dropdelcty": "SPRINGFIELD",
    "dropdelst": "MO",
    "dropdelzpp": 658079902,
    "dropphyadd": "3951 S CAMPBELL AVE",
    "dropphycty": "SPRINGFIELD",
    "dropphyst": "MO",
    "dropphyzpp": 658079902,
    "dropmaladd": "3951 S CAMPBELL AVE",
    "dropmalcty": "SPRINGFIELD",
    "dropmalst": "MO",
    "dropmalzpp": 658079902,
    "dropsitphn": 8165043362,
    "dropsitlph": 4178866847,
    "dropsitcph": 4178860023,
    "dropfax": 4178866744
  },
  {
    "dcode": "D",
    "dropkey": 4021155,
    "droptype": "D",
    "dropname": "TEXARKANA TX SDC",
    "dropdeladd": "2211 N ROBISON RD",
    "dropdelcty": "TEXARKANA",
    "dropdelst": "TX",
    "dropdelzpp": 755019900,
    "dropphyadd": "2211 N ROBISON RD",
    "dropphycty": "TEXARKANA",
    "dropphyst": "TX",
    "dropphyzpp": 755019900,
    "dropmaladd": "2211 N ROBISON RD",
    "dropmalcty": "TEXARKANA",
    "dropmalst": "TX",
    "dropmalzpp": 755019900,
    "dropsitphn": 2144675879,
    "dropsitlph": 9032233823,
    "dropsitcph": 9032233800,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021156,
    "droptype": "D",
    "dropname": "WATERTOWN NY SDC",
    "dropdeladd": "232 COMMERCE PARK DR",
    "dropdelcty": "WATERTOWN",
    "dropdelst": "NY",
    "dropdelzpp": 136019916,
    "dropphyadd": "232 COMMERCE PARK DR",
    "dropphycty": "WATERTOWN",
    "dropphyst": "NY",
    "dropphyzpp": 136019916,
    "dropmaladd": "232 COMMERCE PARK DR",
    "dropmalcty": "WATERTOWN",
    "dropmalst": "NY",
    "dropmalzpp": 136019916,
    "dropsitphn": 3157865982,
    "dropsitlph": 3157865982,
    "dropsitcph": 3157865982,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021157,
    "droptype": "D",
    "dropname": "ELMIRA NY SDC",
    "dropdeladd": "1580 SULLIVAN ST",
    "dropdelcty": "ELMIRA",
    "dropdelst": "NY",
    "dropdelzpp": 149019903,
    "dropphyadd": "1580 SULLIVAN ST",
    "dropphycty": "ELMIRA",
    "dropphyst": "NY",
    "dropphyzpp": 149019903,
    "dropmaladd": "1580 SULLIVAN ST",
    "dropmalcty": "ELMIRA",
    "dropmalst": "NY",
    "dropmalzpp": 149019903,
    "dropsitphn": 6078462415,
    "dropsitlph": 6077375116,
    "dropsitcph": 6077375108,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021158,
    "droptype": "D",
    "dropname": "SIOUX FALLS SD S 2ND SDC",
    "dropdeladd": "320 S 2ND AVE",
    "dropdelcty": "SIOUX FALLS",
    "dropdelst": "SD",
    "dropdelzpp": 571049707,
    "dropphyadd": "320 S 2ND AVE",
    "dropphycty": "SIOUX FALLS",
    "dropphyst": "SD",
    "dropphyzpp": 571049707,
    "dropmaladd": "320 S 2ND AVE",
    "dropmalcty": "SIOUX FALLS",
    "dropmalst": "SD",
    "dropmalzpp": 571049707,
    "dropsitphn": 6053574932,
    "dropsitlph": 6055753542,
    "dropsitcph": 6055753542,
    "dropfax": 6055753553
  },
  {
    "dcode": "D",
    "dropkey": 4021159,
    "droptype": "D",
    "dropname": "COLUMBUS OH WESTLAND SDC",
    "dropdeladd": "770 GEORGESVILLE RD",
    "dropdelcty": "COLUMBUS",
    "dropdelst": "OH",
    "dropdelzpp": 432289922,
    "dropphyadd": "770 GEORGESVILLE RD",
    "dropphycty": "COLUMBUS",
    "dropphyst": "OH",
    "dropphyzpp": 432289922,
    "dropmaladd": "770 GEORGESVILLE RD",
    "dropmalcty": "COLUMBUS",
    "dropmalst": "OH",
    "dropmalzpp": 432289922,
    "dropsitphn": 6144720674,
    "dropsitlph": 6143510138,
    "dropsitcph": 6143510138,
    "dropfax": 6143510049
  },
  {
    "dcode": "D",
    "dropkey": 4021160,
    "droptype": "D",
    "dropname": "SAGINAW MI SDC",
    "dropdeladd": "1233 S WASHINGTON AVE",
    "dropdelcty": "SAGINAW",
    "dropdelst": "MI",
    "dropdelzpp": 486019901,
    "dropphyadd": "1233 S WASHINGTON AVE",
    "dropphycty": "SAGINAW",
    "dropphyst": "MI",
    "dropphyzpp": 486019901,
    "dropmaladd": "1233 S WASHINGTON AVE",
    "dropmalcty": "SAGINAW",
    "dropmalst": "MI",
    "dropmalzpp": 486019901,
    "dropsitphn": 6169771064,
    "dropsitlph": "",
    "dropsitcph": 9897715718,
    "dropfax": 9897715715
  },
  {
    "dcode": "D",
    "dropkey": 4021161,
    "droptype": "D",
    "dropname": "FOX VALLEY IL SDC",
    "dropdeladd": "3900 GABRIELLE LN",
    "dropdelcty": "FOX VALLEY",
    "dropdelst": "IL",
    "dropdelzpp": 605999900,
    "dropphyadd": "3900 GABRIELLE LN",
    "dropphycty": "FOX VALLEY",
    "dropphyst": "IL",
    "dropphyzpp": 605999900,
    "dropmaladd": "3900 GABRIELLE LN",
    "dropmalcty": "FOX VALLEY",
    "dropmalst": "IL",
    "dropmalzpp": 605999900,
    "dropsitphn": 6309784432,
    "dropsitlph": 6309784432,
    "dropsitcph": 6309784432,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021162,
    "droptype": "D",
    "dropname": "BLOOMINGTON IN SDC",
    "dropdeladd": "4738 W VERNAL PIKE",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IN",
    "dropdelzpp": 474049916,
    "dropphyadd": "4738 W VERNAL PIKE",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IN",
    "dropphyzpp": 474049916,
    "dropmaladd": "4738 W VERNAL PIKE",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IN",
    "dropmalzpp": 474049916,
    "dropsitphn": 3174646350,
    "dropsitlph": 3174646305,
    "dropsitcph": 8123314544,
    "dropfax": 8123490394
  },
  {
    "dcode": "D",
    "dropkey": 4021163,
    "droptype": "D",
    "dropname": "PITTSBURGH PA PLSNT HLS SDC",
    "dropdeladd": "500 REGIS AVE",
    "dropdelcty": "PITTSBURGH",
    "dropdelst": "PA",
    "dropdelzpp": 152369900,
    "dropphyadd": "500 REGIS AVE",
    "dropphycty": "PITTSBURGH",
    "dropphyst": "PA",
    "dropphyzpp": 152369900,
    "dropmaladd": "500 REGIS AVE",
    "dropmalcty": "PITTSBURGH",
    "dropmalst": "PA",
    "dropmalzpp": 152369900,
    "dropsitphn": 4123597568,
    "dropsitlph": 4126553836,
    "dropsitcph": 4126553836,
    "dropfax": 4126506057
  },
  {
    "dcode": "D",
    "dropkey": 4021168,
    "droptype": "D",
    "dropname": "TOWN N CNTRY ANNEX",
    "dropdeladd": "6013 BENJAMIN RD",
    "dropdelcty": "TAMPA",
    "dropdelst": "FL",
    "dropdelzpp": 336349901,
    "dropphyadd": "6013 BENJAMIN RD",
    "dropphycty": "TAMPA",
    "dropphyst": "FL",
    "dropphyzpp": 336349901,
    "dropmaladd": "6013 BENJAMIN RD",
    "dropmalcty": "TAMPA",
    "dropmalst": "FL",
    "dropmalzpp": 336349901,
    "dropsitphn": 8138770729,
    "dropsitlph": "",
    "dropsitcph": 8138893966,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021225,
    "droptype": "D",
    "dropname": "SURPRISE AZ SDC",
    "dropdeladd": "14955 W BELL RD",
    "dropdelcty": "SURPRISE",
    "dropdelst": "AZ",
    "dropdelzpp": 853749905,
    "dropphyadd": "14955 W BELL RD",
    "dropphycty": "SURPRISE",
    "dropphyst": "AZ",
    "dropphyzpp": 853749905,
    "dropmaladd": "14955 W BELL RD",
    "dropmalcty": "SURPRISE",
    "dropmalst": "AZ",
    "dropmalzpp": 853749905,
    "dropsitphn": 6235444818,
    "dropsitlph": 6235444818,
    "dropsitcph": 6235444672,
    "dropfax": 6235444677
  },
  {
    "dcode": "D",
    "dropkey": 4021226,
    "droptype": "D",
    "dropname": "SOUTHFIELD MI SDC",
    "dropdeladd": "22200 W 11 MILE RD",
    "dropdelcty": "SOUTHFIELD",
    "dropdelst": "MI",
    "dropdelzpp": 480379913,
    "dropphyadd": "22200 W 11 MILE RD",
    "dropphycty": "SOUTHFIELD",
    "dropphyst": "MI",
    "dropphyzpp": 480379913,
    "dropmaladd": "22200 W 11 MILE RD",
    "dropmalcty": "SOUTHFIELD",
    "dropmalst": "MI",
    "dropmalzpp": 480379913,
    "dropsitphn": 2483682977,
    "dropsitlph": 2487585622,
    "dropsitcph": 2483682977,
    "dropfax": 2483682955
  },
  {
    "dcode": "D",
    "dropkey": 4021227,
    "droptype": "D",
    "dropname": "STERLING HEIGHTS MI SDC",
    "dropdeladd": "7007 METROPOLITAN PKWY",
    "dropdelcty": "STERLING HEIGHTS",
    "dropdelst": "MI",
    "dropdelzpp": 483119903,
    "dropphyadd": "7007 METROPOLITAN PKWY",
    "dropphycty": "STERLING HEIGHTS",
    "dropphyst": "MI",
    "dropphyzpp": 483119903,
    "dropmaladd": "7007 METROPOLITAN PKWY",
    "dropmalcty": "STERLING HEIGHTS",
    "dropmalst": "MI",
    "dropmalzpp": 483119903,
    "dropsitphn": 5869832359,
    "dropsitlph": 2487585622,
    "dropsitcph": 5869832359,
    "dropfax": 5862682055
  },
  {
    "dcode": "D",
    "dropkey": 4021228,
    "droptype": "D",
    "dropname": "STAMFORD CT SDC",
    "dropdeladd": "24 CAMP AVE",
    "dropdelcty": "STAMFORD",
    "dropdelst": "CT",
    "dropdelzpp": "069079990",
    "dropphyadd": "24 CAMP AVE",
    "dropphycty": "STAMFORD",
    "dropphyst": "CT",
    "dropphyzpp": "069079990",
    "dropmaladd": "24 CAMP AVE",
    "dropmalcty": "STAMFORD",
    "dropmalst": "CT",
    "dropmalzpp": "069079990",
    "dropsitphn": 2033213908,
    "dropsitlph": 2033213908,
    "dropsitcph": 2033213910,
    "dropfax": 2033213912
  },
  {
    "dcode": "D",
    "dropkey": 4021229,
    "droptype": "D",
    "dropname": "SACRAMENTO CA SDC",
    "dropdeladd": "2000 ROYAL OAKS DR",
    "dropdelcty": "SACRAMENTO",
    "dropdelst": "CA",
    "dropdelzpp": 958139903,
    "dropphyadd": "2000 ROYAL OAKS DR",
    "dropphycty": "SACRAMENTO",
    "dropphyst": "CA",
    "dropphyzpp": 958139903,
    "dropmaladd": "2000 ROYAL OAKS DR",
    "dropmalcty": "SACRAMENTO",
    "dropmalst": "CA",
    "dropmalzpp": 958139903,
    "dropsitphn": 9163738025,
    "dropsitlph": 9163738025,
    "dropsitcph": 9163738025,
    "dropfax": 9163738025
  },
  {
    "dcode": "D",
    "dropkey": 4021230,
    "droptype": "D",
    "dropname": "BERKELEY CA SDC",
    "dropdeladd": "1150 8TH ST",
    "dropdelcty": "BERKELEY",
    "dropdelst": "CA",
    "dropdelzpp": 947109934,
    "dropphyadd": "1150 8TH ST",
    "dropphycty": "BERKELEY",
    "dropphyst": "CA",
    "dropphyzpp": 947109934,
    "dropmaladd": "1150 8TH ST",
    "dropmalcty": "BERKELEY",
    "dropmalst": "CA",
    "dropmalzpp": 947109934,
    "dropsitphn": 5104337569,
    "dropsitlph": 5106496775,
    "dropsitcph": 5106493114,
    "dropfax": 5106493124
  },
  {
    "dcode": "D",
    "dropkey": 4021231,
    "droptype": "D",
    "dropname": "LIVERMORE CA SDC",
    "dropdeladd": "2090 LAS POSITAS CT",
    "dropdelcty": "LIVERMORE",
    "dropdelst": "CA",
    "dropdelzpp": 945509912,
    "dropphyadd": "2090 LAS POSITAS CT",
    "dropphycty": "LIVERMORE",
    "dropphyst": "CA",
    "dropphyzpp": 945509912,
    "dropmaladd": "2090 LAS POSITAS CT",
    "dropmalcty": "LIVERMORE",
    "dropmalst": "CA",
    "dropmalzpp": 945509912,
    "dropsitphn": 5104337569,
    "dropsitlph": 9254475627,
    "dropsitcph": 9254470813,
    "dropfax": 9254432805
  },
  {
    "dcode": "D",
    "dropkey": 4021233,
    "droptype": "D",
    "dropname": "HAYWARD CA SDC",
    "dropdeladd": "24438 SANTA CLARA ST",
    "dropdelcty": "HAYWARD",
    "dropdelst": "CA",
    "dropdelzpp": 945449910,
    "dropphyadd": "24438 SANTA CLARA ST",
    "dropphycty": "HAYWARD",
    "dropphyst": "CA",
    "dropphyzpp": 945449910,
    "dropmaladd": "24438 SANTA CLARA ST",
    "dropmalcty": "HAYWARD",
    "dropmalst": "CA",
    "dropmalzpp": 945449910,
    "dropsitphn": 5104337569,
    "dropsitlph": 5107832404,
    "dropsitcph": 5107835963,
    "dropfax": 5107830460
  },
  {
    "dcode": "D",
    "dropkey": 4021234,
    "droptype": "D",
    "dropname": "WALNUT CREEK CA SDC",
    "dropdeladd": "2070 N BROADWAY",
    "dropdelcty": "WALNUT CREEK",
    "dropdelst": "CA",
    "dropdelzpp": 945969991,
    "dropphyadd": "2070 N BROADWAY",
    "dropphycty": "WALNUT CREEK",
    "dropphyst": "CA",
    "dropphyzpp": 945969991,
    "dropmaladd": "2070 N BROADWAY",
    "dropmalcty": "WALNUT CREEK",
    "dropmalst": "CA",
    "dropmalzpp": 945969991,
    "dropsitphn": 5104337569,
    "dropsitlph": 9259300835,
    "dropsitcph": 9259350256,
    "dropfax": 9259300445
  },
  {
    "dcode": "D",
    "dropkey": 4021235,
    "droptype": "D",
    "dropname": "HENDERSON NV VALLE VERDE SDC",
    "dropdeladd": "1575 W HORIZON RIDGE PKWY",
    "dropdelcty": "HENDERSON",
    "dropdelst": "NV",
    "dropdelzpp": 890129900,
    "dropphyadd": "1575 W HORIZON RIDGE PKWY",
    "dropphycty": "HENDERSON",
    "dropphyst": "NV",
    "dropphyzpp": 890129900,
    "dropmaladd": "1575 W HORIZON RIDGE PKWY",
    "dropmalcty": "HENDERSON",
    "dropmalst": "NV",
    "dropmalzpp": 890129900,
    "dropsitphn": 7023619453,
    "dropsitlph": 7028371614,
    "dropsitcph": 7028371624,
    "dropfax": 7028371623
  },
  {
    "dcode": "D",
    "dropkey": 4021236,
    "droptype": "D",
    "dropname": "VANCOUVER WA SDC",
    "dropdeladd": "2700 CAPLES AVE",
    "dropdelcty": "VANCOUVER",
    "dropdelst": "WA",
    "dropdelzpp": 986619997,
    "dropphyadd": "2700 CAPLES AVE",
    "dropphycty": "VANCOUVER",
    "dropphyst": "WA",
    "dropphyzpp": 986619997,
    "dropmaladd": "2700 CAPLES AVE",
    "dropmalcty": "VANCOUVER",
    "dropmalst": "WA",
    "dropmalzpp": 986619997,
    "dropsitphn": 9712013788,
    "dropsitlph": 3609925006,
    "dropsitcph": 3609925000,
    "dropfax": 3609925088
  },
  {
    "dcode": "D",
    "dropkey": 4021237,
    "droptype": "D",
    "dropname": "BLOOMINGTON IL SDC",
    "dropdeladd": "1511 E EMPIRE ST",
    "dropdelcty": "BLOOMINGTON",
    "dropdelst": "IL",
    "dropdelzpp": 617019607,
    "dropphyadd": "1511 E EMPIRE ST",
    "dropphycty": "BLOOMINGTON",
    "dropphyst": "IL",
    "dropphyzpp": 617019607,
    "dropmaladd": "1511 E EMPIRE ST",
    "dropmalcty": "BLOOMINGTON",
    "dropmalst": "IL",
    "dropmalzpp": 617019607,
    "dropsitphn": 7085637318,
    "dropsitlph": 3096718819,
    "dropsitcph": 3096644600,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021238,
    "droptype": "D",
    "dropname": "AURORA IL SDC",
    "dropdeladd": "525 N BROADWAY",
    "dropdelcty": "AURORA",
    "dropdelst": "IL",
    "dropdelzpp": 605059973,
    "dropphyadd": "525 N BROADWAY",
    "dropphycty": "AURORA",
    "dropphyst": "IL",
    "dropphyzpp": 605059973,
    "dropmaladd": "525 N BROADWAY",
    "dropmalcty": "AURORA",
    "dropmalst": "IL",
    "dropmalzpp": 605059973,
    "dropsitphn": 7085637318,
    "dropsitlph": 6309784440,
    "dropsitcph": 6308448810,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021239,
    "droptype": "D",
    "dropname": "COLUMBIA MD SDC",
    "dropdeladd": "6801 OAK HALL LN",
    "dropdelcty": "COLUMBIA",
    "dropdelst": "MD",
    "dropdelzpp": 210459901,
    "dropphyadd": "6801 OAK HALL LN",
    "dropphycty": "COLUMBIA",
    "dropphyst": "MD",
    "dropphyzpp": 210459901,
    "dropmaladd": "6801 OAK HALL LN",
    "dropmalcty": "COLUMBIA",
    "dropmalst": "MD",
    "dropmalzpp": 210459901,
    "dropsitphn": 4103474518,
    "dropsitlph": 4103814373,
    "dropsitcph": 4103814373,
    "dropfax": 4103127442
  },
  {
    "dcode": "D",
    "dropkey": 4021240,
    "droptype": "D",
    "dropname": "FORT COLLINS CO SDC",
    "dropdeladd": "301 BOARDWALK DR",
    "dropdelcty": "FORT COLLINS",
    "dropdelst": "CO",
    "dropdelzpp": 805259908,
    "dropphyadd": "301 BOARDWALK DR",
    "dropphycty": "FORT COLLINS",
    "dropphyst": "CO",
    "dropphyzpp": 805259908,
    "dropmaladd": "301 BOARDWALK DR",
    "dropmalcty": "FORT COLLINS",
    "dropmalst": "CO",
    "dropmalzpp": 805259908,
    "dropsitphn": 3038536511,
    "dropsitlph": 9702254155,
    "dropsitcph": 9702254100,
    "dropfax": 9702254139
  },
  {
    "dcode": "D",
    "dropkey": 4021241,
    "droptype": "D",
    "dropname": "READING PA SDC",
    "dropdeladd": "2100 N 13TH ST",
    "dropdelcty": "READING",
    "dropdelst": "PA",
    "dropdelzpp": 196129939,
    "dropphyadd": "2100 N 13TH ST",
    "dropphycty": "READING",
    "dropphyst": "PA",
    "dropphyzpp": 196129939,
    "dropmaladd": "2100 N 13TH ST",
    "dropmalcty": "READING",
    "dropmalst": "PA",
    "dropmalzpp": 196129939,
    "dropsitphn": 7173968782,
    "dropsitlph": 6109217000,
    "dropsitcph": 6109217000,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021242,
    "droptype": "D",
    "dropname": "YORK PA WEST SDC",
    "dropdeladd": "1250 SMILE WAY",
    "dropdelcty": "YORK",
    "dropdelst": "PA",
    "dropdelzpp": 174049900,
    "dropphyadd": "1250 SMILE WAY",
    "dropphycty": "YORK",
    "dropphyst": "PA",
    "dropphyzpp": 174049900,
    "dropmaladd": "1250 SMILE WAY",
    "dropmalcty": "YORK",
    "dropmalst": "PA",
    "dropmalzpp": 174049900,
    "dropsitphn": 7173968782,
    "dropsitlph": 7177514609,
    "dropsitcph": 7177514609,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021243,
    "droptype": "D",
    "dropname": "REDONDO BEACH CA SDC",
    "dropdeladd": "1201 N CATALINA AVE",
    "dropdelcty": "REDONDO BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 902779900,
    "dropphyadd": "1201 N CATALINA AVE",
    "dropphycty": "REDONDO BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 902779900,
    "dropmaladd": "1201 N CATALINA AVE",
    "dropmalcty": "REDONDO BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 902779900,
    "dropsitphn": 3235861867,
    "dropsitlph": "",
    "dropsitcph": 3103763252,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021244,
    "droptype": "D",
    "dropname": "LANCASTER PA SDC",
    "dropdeladd": "1301 MARSHALL AVE",
    "dropdelcty": "LANCASTER",
    "dropdelst": "PA",
    "dropdelzpp": 176019800,
    "dropphyadd": "1301 MARSHALL AVE",
    "dropphycty": "LANCASTER",
    "dropphyst": "PA",
    "dropphyzpp": 176019800,
    "dropmaladd": "1301 MARSHALL AVE",
    "dropmalcty": "LANCASTER",
    "dropmalst": "PA",
    "dropmalzpp": 176019800,
    "dropsitphn": 7173968782,
    "dropsitlph": 7173947784,
    "dropsitcph": 7173947784,
    "dropfax": 7172907625
  },
  {
    "dcode": "D",
    "dropkey": 4021245,
    "droptype": "D",
    "dropname": "SAN MATEO CA SDC",
    "dropdeladd": "1630 S DELAWARE ST",
    "dropdelcty": "SAN MATEO",
    "dropdelst": "CA",
    "dropdelzpp": 944029906,
    "dropphyadd": "1630 S DELAWARE ST",
    "dropphycty": "SAN MATEO",
    "dropphyst": "CA",
    "dropphyzpp": 944029906,
    "dropmaladd": "1630 S DELAWARE ST",
    "dropmalcty": "SAN MATEO",
    "dropmalst": "CA",
    "dropmalzpp": 944029906,
    "dropsitphn": 4155505045,
    "dropsitlph": 6503588482,
    "dropsitcph": 6503588490,
    "dropfax": 6503499726
  },
  {
    "dcode": "D",
    "dropkey": 4021246,
    "droptype": "D",
    "dropname": "TORRANCE CA SDC",
    "dropdeladd": "2510 MONTEREY ST",
    "dropdelcty": "TORRANCE",
    "dropdelst": "CA",
    "dropdelzpp": 905039901,
    "dropphyadd": "2510 MONTEREY ST",
    "dropphycty": "TORRANCE",
    "dropphyst": "CA",
    "dropphyzpp": 905039901,
    "dropmaladd": "2510 MONTEREY ST",
    "dropmalcty": "TORRANCE",
    "dropmalst": "CA",
    "dropmalzpp": 905039901,
    "dropsitphn": 5624942406,
    "dropsitlph": "",
    "dropsitcph": 3102225902,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021247,
    "droptype": "D",
    "dropname": "WHITTIER CA SDC",
    "dropdeladd": "8520 MICHIGAN AVE",
    "dropdelcty": "WHITTIER",
    "dropdelst": "CA",
    "dropdelzpp": 906059910,
    "dropphyadd": "8520 MICHIGAN AVE",
    "dropphycty": "WHITTIER",
    "dropphyst": "CA",
    "dropphyzpp": 906059910,
    "dropmaladd": "8520 MICHIGAN AVE",
    "dropmalcty": "WHITTIER",
    "dropmalst": "CA",
    "dropmalzpp": 906059910,
    "dropsitphn": 5626939561,
    "dropsitlph": "",
    "dropsitcph": 5629073910,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021249,
    "droptype": "D",
    "dropname": "SUNNYVALE CA SDC",
    "dropdeladd": "209 E JAVA DR",
    "dropdelcty": "SUNNYVALE",
    "dropdelst": "CA",
    "dropdelzpp": 940899900,
    "dropphyadd": "209 E JAVA DR",
    "dropphycty": "SUNNYVALE",
    "dropphyst": "CA",
    "dropphyzpp": 940899900,
    "dropmaladd": "209 E JAVA DR",
    "dropmalcty": "SUNNYVALE",
    "dropmalst": "CA",
    "dropmalzpp": 940899900,
    "dropsitphn": 4155505045,
    "dropsitlph": 4087470692,
    "dropsitcph": 4087470340,
    "dropfax": 4087470869
  },
  {
    "dcode": "D",
    "dropkey": 4021250,
    "droptype": "D",
    "dropname": "SANTA ANA CA NORTH GRAND SDC",
    "dropdeladd": "2201 N GRAND AVE",
    "dropdelcty": "SANTA ANA",
    "dropdelst": "CA",
    "dropdelzpp": 927119930,
    "dropphyadd": "2201 N GRAND AVE",
    "dropphycty": "SANTA ANA",
    "dropphyst": "CA",
    "dropphyzpp": 927119930,
    "dropmaladd": "2201 N GRAND AVE",
    "dropmalcty": "SANTA ANA",
    "dropmalst": "CA",
    "dropmalzpp": 927119930,
    "dropsitphn": 7146676734,
    "dropsitlph": 7146676761,
    "dropsitcph": 7146676734,
    "dropfax": 7148352406
  },
  {
    "dcode": "D",
    "dropkey": 4021251,
    "droptype": "D",
    "dropname": "INGLEWOOD CA SDC",
    "dropdeladd": "4201 W IMPERIAL HWY",
    "dropdelcty": "INGLEWOOD",
    "dropdelst": "CA",
    "dropdelzpp": 903049900,
    "dropphyadd": "4201 W IMPERIAL HWY",
    "dropphycty": "INGLEWOOD",
    "dropphyst": "CA",
    "dropphyzpp": 903049900,
    "dropmaladd": "4201 W IMPERIAL HWY",
    "dropmalcty": "INGLEWOOD",
    "dropmalst": "CA",
    "dropmalzpp": 903049900,
    "dropsitphn": 5624942406,
    "dropsitlph": "",
    "dropsitcph": 3106742321,
    "dropfax": ""
  },
  {
    "dcode": "D",
    "dropkey": 4021252,
    "droptype": "D",
    "dropname": "LA PUENTE CA SDC",
    "dropdeladd": "15310 ELLIOT AVE",
    "dropdelcty": "LA PUENTE",
    "dropdelst": "CA",
    "dropdelzpp": 917479903,
    "dropphyadd": "15310 ELLIOT AVE",
    "dropphycty": "LA PUENTE",
    "dropphyst": "CA",
    "dropphyzpp": 917479903,
    "dropmaladd": "15310 ELLIOT AVE",
    "dropmalcty": "LA PUENTE",
    "dropmalst": "CA",
    "dropmalzpp": 917479903,
    "dropsitphn": 6263695301,
    "dropsitlph": 6263369496,
    "dropsitcph": 6263695301,
    "dropfax": 6269685699
  },
  {
    "dcode": "D",
    "dropkey": 4021253,
    "droptype": "D",
    "dropname": "NEWPORT BEACH CA SDC",
    "dropdeladd": "1133 CAMELBACK ST",
    "dropdelcty": "NEWPORT BEACH",
    "dropdelst": "CA",
    "dropdelzpp": 926589937,
    "dropphyadd": "1133 CAMELBACK ST",
    "dropphycty": "NEWPORT BEACH",
    "dropphyst": "CA",
    "dropphyzpp": 926589937,
    "dropmaladd": "1133 CAMELBACK ST",
    "dropmalcty": "NEWPORT BEACH",
    "dropmalst": "CA",
    "dropmalzpp": 926589937,
    "dropsitphn": 9496404663,
    "dropsitlph": 9496405734,
    "dropsitcph": 9496404663,
    "dropfax": 9496404703
  },
  {
    "dcode": "D",
    "dropkey": 4021254,
    "droptype": "D",
    "dropname": "BURBANK CA SDC",
    "dropdeladd": "2140 N HOLLYWOOD WAY",
    "dropdelcty": "BURBANK",
    "dropdelst": "CA",
    "dropdelzpp": 915059601,
    "dropphyadd": "2140 N HOLLYWOOD WAY",
    "dropphycty": "BURBANK",
    "dropphyst": "CA",
    "dropphyzpp": 915059601,
    "dropmaladd": "2140 N HOLLYWOOD WAY",
    "dropmalcty": "BURBANK",
    "dropmalst": "CA",
    "dropmalzpp": 915059601,
    "dropsitphn": 6617757808,
    "dropsitlph": 8188460758,
    "dropsitcph": 8188460758,
    "dropfax": 8185583983
  },
  {
    "dcode": "D",
    "dropkey": 4021255,
    "droptype": "D",
    "dropname": "VAN NUYS CA SDC",
    "dropdeladd": "15701 SHERMAN WAY",
    "dropdelcty": "VAN NUYS",
    "dropdelst": "CA",
    "dropdelzpp": 914069900,
    "dropphyadd": "15701 SHERMAN WAY",
    "dropphycty": "VAN NUYS",
    "dropphyst": "CA",
    "dropphyzpp": 914069900,
    "dropmaladd": "15701 SHERMAN WAY",
    "dropmalcty": "VAN NUYS",
    "dropmalst": "CA",
    "dropmalzpp": 914069900,
    "dropsitphn": 6617757808,
    "dropsitlph": 8183745600,
    "dropsitcph": 8183745650,
    "dropfax": 8183745603
  },
  {
    "dcode": "D",
    "dropkey": 4021283,
    "droptype": "D",
    "dropname": "GILBERT ROADRUNNER ANNEX",
    "dropdeladd": "2359 E OCOTILLO RD",
    "dropdelcty": "GILBERT",
    "dropdelst": "AZ",
    "dropdelzpp": 852989997,
    "dropphyadd": "2359 E OCOTILLO RD",
    "dropphycty": "GILBERT",
    "dropphyst": "AZ",
    "dropphyzpp": 852989997,
    "dropmaladd": "2359 E OCOTILLO RD",
    "dropmalcty": "GILBERT",
    "dropmalst": "AZ",
    "dropmalzpp": 852989997,
    "dropsitphn": 6022253214,
    "dropsitlph": 4809267538,
    "dropsitcph": 4809267595,
    "dropfax": 4808923423
  }
]